export const french_synonyms = {
  "avoir": [
    [
      "bien",
      0.155
    ],
    [
      "richesse",
      0.125
    ],
    [
      "argent",
      0.0925
    ],
    [
      "benefice",
      0.0925
    ],
    [
      "capital",
      0.0925
    ],
    [
      "fortune",
      0.0925
    ],
    [
      "propriete",
      0.0625
    ],
    [
      "possession",
      0.0625
    ],
    [
      "credit",
      0.0625
    ],
    [
      "actif",
      0.03
    ],
    [
      "biens",
      0.03
    ],
    [
      "compte",
      0.03
    ],
    [
      "ressource",
      0.03
    ]
  ],
  "dessine": [
    [
      "representer",
      0.1125
    ],
    [
      "montrer",
      0.1025
    ],
    [
      "tracer",
      0.085
    ],
    [
      "reveler",
      0.0775
    ],
    [
      "peindre",
      0.0425
    ],
    [
      "indiquer",
      0.0425
    ],
    [
      "former",
      0.0425
    ],
    [
      "faire",
      0.0425
    ],
    [
      "souligner",
      0.0325
    ],
    [
      "presenter",
      0.0325
    ],
    [
      "figurer",
      0.0325
    ],
    [
      "esquisser",
      0.0325
    ],
    [
      "accuser",
      0.0325
    ],
    [
      "crayonner",
      0.025
    ],
    [
      "ebaucher",
      0.015
    ],
    [
      "reproduire",
      0.015
    ],
    [
      "profiler",
      0.015
    ],
    [
      "offrir",
      0.015
    ],
    [
      "mouler",
      0.015
    ],
    [
      "griffonner",
      0.015
    ],
    [
      "devoiler",
      0.015
    ],
    [
      "dresser",
      0.015
    ],
    [
      "croquer",
      0.015
    ],
    [
      "pincer",
      0.0075
    ],
    [
      "materialiser",
      0.0075
    ],
    [
      "lever",
      0.0075
    ],
    [
      "gribouiller",
      0.0075
    ],
    [
      "graver",
      0.0075
    ],
    [
      "depeindre",
      0.0075
    ],
    [
      "delineer",
      0.0075
    ],
    [
      "delineamenter",
      0.0075
    ],
    [
      "charbonner",
      0.0075
    ],
    [
      "affirmer",
      0.0075
    ],
    [
      "accentuer",
      0.0075
    ],
    [
      "ressortir",
      0.0075
    ]
  ],
  "dessiner": [
    [
      "representer",
      0.1125
    ],
    [
      "montrer",
      0.1025
    ],
    [
      "tracer",
      0.085
    ],
    [
      "reveler",
      0.0775
    ],
    [
      "peindre",
      0.0425
    ],
    [
      "indiquer",
      0.0425
    ],
    [
      "former",
      0.0425
    ],
    [
      "faire",
      0.0425
    ],
    [
      "souligner",
      0.0325
    ],
    [
      "presenter",
      0.0325
    ],
    [
      "figurer",
      0.0325
    ],
    [
      "esquisser",
      0.0325
    ],
    [
      "accuser",
      0.0325
    ],
    [
      "crayonner",
      0.025
    ],
    [
      "ebaucher",
      0.015
    ],
    [
      "reproduire",
      0.015
    ],
    [
      "profiler",
      0.015
    ],
    [
      "offrir",
      0.015
    ],
    [
      "mouler",
      0.015
    ],
    [
      "griffonner",
      0.015
    ],
    [
      "devoiler",
      0.015
    ],
    [
      "dresser",
      0.015
    ],
    [
      "croquer",
      0.015
    ],
    [
      "pincer",
      0.0075
    ],
    [
      "materialiser",
      0.0075
    ],
    [
      "lever",
      0.0075
    ],
    [
      "gribouiller",
      0.0075
    ],
    [
      "graver",
      0.0075
    ],
    [
      "depeindre",
      0.0075
    ],
    [
      "delineer",
      0.0075
    ],
    [
      "delineamenter",
      0.0075
    ],
    [
      "charbonner",
      0.0075
    ],
    [
      "affirmer",
      0.0075
    ],
    [
      "accentuer",
      0.0075
    ],
    [
      "ressortir",
      0.0075
    ]
  ],
  "sur": [
    [
      "certain",
      0.105
    ],
    [
      "vrai",
      0.09
    ],
    [
      "bon",
      0.0475
    ],
    [
      "assure",
      0.0425
    ],
    [
      "sincere",
      0.0425
    ],
    [
      "solide",
      0.0425
    ],
    [
      "exact",
      0.04
    ],
    [
      "authentique",
      0.0375
    ],
    [
      "fidele",
      0.0375
    ],
    [
      "veritable",
      0.03
    ],
    [
      "evident",
      0.03
    ],
    [
      "incontestable",
      0.0275
    ],
    [
      "irrefragable",
      0.025
    ],
    [
      "franc",
      0.025
    ],
    [
      "avere",
      0.025
    ],
    [
      "reel",
      0.0225
    ],
    [
      "indubitable",
      0.02
    ],
    [
      "juste",
      0.02
    ],
    [
      "ferme",
      0.0175
    ],
    [
      "positif",
      0.0175
    ],
    [
      "precis",
      0.0175
    ],
    [
      "tranquille",
      0.015
    ],
    [
      "formel",
      0.015
    ],
    [
      "clair",
      0.0125
    ],
    [
      "constant",
      0.0125
    ],
    [
      "stable",
      0.0125
    ],
    [
      "etabli",
      0.01
    ],
    [
      "serieux",
      0.0075
    ],
    [
      "infaillible",
      0.0075
    ],
    [
      "habile",
      0.0075
    ],
    [
      "expert",
      0.0075
    ],
    [
      "efficace",
      0.0075
    ],
    [
      "sage",
      0.005
    ],
    [
      "loyal",
      0.005
    ],
    [
      "inevitable",
      0.005
    ],
    [
      "ineluctable",
      0.005
    ],
    [
      "immanquable",
      0.005
    ],
    [
      "bien",
      0.005
    ],
    [
      "eprouve",
      0.0025
    ],
    [
      "souverain",
      0.0025
    ],
    [
      "obligatoire",
      0.0025
    ],
    [
      "irrecusable",
      0.0025
    ],
    [
      "devoue",
      0.0025
    ],
    [
      "garanti",
      0.0
    ],
    [
      "garde",
      0.0
    ],
    [
      "imprenable",
      0.0
    ],
    [
      "indefectible",
      0.0
    ],
    [
      "paisible",
      0.0
    ],
    [
      "protege",
      0.0
    ],
    [
      "prouve",
      0.0
    ],
    [
      "fiable",
      0.0
    ],
    [
      "fatal",
      0.0
    ],
    [
      "expedient",
      0.0
    ],
    [
      "exerce",
      0.0
    ],
    [
      "couru",
      0.0
    ],
    [
      "convaincu",
      0.0
    ],
    [
      "confiant",
      0.0
    ],
    [
      "cache",
      0.0
    ],
    [
      "automatique",
      0.0
    ],
    [
      "abrite",
      0.0
    ]
  ],
  "le": [
    [
      "bande",
      0.165
    ],
    [
      "chemin",
      0.165
    ],
    [
      "halage",
      0.165
    ],
    [
      "laize",
      0.165
    ],
    [
      "largeur",
      0.165
    ],
    [
      "sentier",
      0.165
    ]
  ],
  "sable": [
    [
      "arene",
      0.2
    ],
    [
      "calcul",
      0.2
    ],
    [
      "gravier",
      0.2
    ],
    [
      "beige",
      0.1
    ],
    [
      "noir",
      0.1
    ],
    [
      "pierre",
      0.1
    ],
    [
      "sablon",
      0.1
    ]
  ],
  "sabler": [
    [
      "boire",
      0.3325
    ],
    [
      "ensabler",
      0.3325
    ],
    [
      "nettoyer",
      0.3325
    ]
  ],
  "doux": [
    [
      "bon",
      0.06
    ],
    [
      "agreable",
      0.0575
    ],
    [
      "aimable",
      0.04
    ],
    [
      "gracieux",
      0.0375
    ],
    [
      "beau",
      0.0275
    ],
    [
      "delicat",
      0.0275
    ],
    [
      "facile",
      0.0275
    ],
    [
      "calme",
      0.025
    ],
    [
      "gentil",
      0.0225
    ],
    [
      "tendre",
      0.0225
    ],
    [
      "benin",
      0.0225
    ],
    [
      "complaisant",
      0.0175
    ],
    [
      "mou",
      0.0175
    ],
    [
      "faible",
      0.0175
    ],
    [
      "bienveillant",
      0.0175
    ],
    [
      "affable",
      0.015
    ],
    [
      "debonnaire",
      0.015
    ],
    [
      "exquis",
      0.015
    ],
    [
      "moelleux",
      0.015
    ],
    [
      "suave",
      0.015
    ],
    [
      "indulgent",
      0.0125
    ],
    [
      "charmant",
      0.0125
    ],
    [
      "joli",
      0.01
    ],
    [
      "leger",
      0.01
    ],
    [
      "serein",
      0.01
    ],
    [
      "souple",
      0.01
    ],
    [
      "tranquille",
      0.01
    ],
    [
      "modere",
      0.01
    ],
    [
      "coulant",
      0.01
    ],
    [
      "amene",
      0.0075
    ],
    [
      "doucereux",
      0.0075
    ],
    [
      "paisible",
      0.0075
    ],
    [
      "sage",
      0.0075
    ],
    [
      "maniable",
      0.0075
    ],
    [
      "sociable",
      0.0075
    ],
    [
      "sucre",
      0.0075
    ],
    [
      "traitable",
      0.0075
    ],
    [
      "malleable",
      0.0075
    ],
    [
      "heureux",
      0.0075
    ],
    [
      "harmonieux",
      0.0075
    ],
    [
      "fin",
      0.0075
    ],
    [
      "conciliant",
      0.0075
    ],
    [
      "bonhomme",
      0.0075
    ],
    [
      "plaisant",
      0.005
    ],
    [
      "placide",
      0.005
    ],
    [
      "fade",
      0.005
    ],
    [
      "engageant",
      0.005
    ],
    [
      "enchanteur",
      0.005
    ],
    [
      "delicieux",
      0.005
    ],
    [
      "douillet",
      0.005
    ],
    [
      "caressant",
      0.005
    ],
    [
      "amoureux",
      0.005
    ],
    [
      "vivable",
      0.005
    ],
    [
      "veloute",
      0.005
    ],
    [
      "tolerant",
      0.005
    ],
    [
      "soyeux",
      0.005
    ],
    [
      "pose",
      0.005
    ],
    [
      "pacifique",
      0.005
    ],
    [
      "onctueux",
      0.005
    ],
    [
      "inoffensif",
      0.005
    ],
    [
      "flatteur",
      0.005
    ],
    [
      "confortable",
      0.005
    ],
    [
      "bonasse",
      0.005
    ],
    [
      "melodieux",
      0.0025
    ],
    [
      "paterne",
      0.0025
    ],
    [
      "pale",
      0.0025
    ],
    [
      "soumis",
      0.0025
    ],
    [
      "voluptueux",
      0.0025
    ],
    [
      "liant",
      0.0025
    ],
    [
      "humain",
      0.0025
    ],
    [
      "douceatre",
      0.0025
    ],
    [
      "docile",
      0.0025
    ],
    [
      "clair",
      0.0025
    ],
    [
      "cheri",
      0.0025
    ],
    [
      "benoit",
      0.0025
    ],
    [
      "anodin",
      0.0025
    ],
    [
      "patient",
      0.0025
    ],
    [
      "reposant",
      0.0025
    ],
    [
      "satine",
      0.0025
    ],
    [
      "savoureux",
      0.0025
    ],
    [
      "succulent",
      0.0025
    ],
    [
      "tiede",
      0.0025
    ],
    [
      "uni",
      0.0025
    ],
    [
      "obeissant",
      0.0025
    ],
    [
      "mielleux",
      0.0025
    ],
    [
      "affectueux",
      0.0025
    ],
    [
      "angelique",
      0.0025
    ],
    [
      "cher",
      0.0025
    ],
    [
      "clement",
      0.0025
    ],
    [
      "calin",
      0.0025
    ],
    [
      "dolce",
      0.0025
    ],
    [
      "lisse",
      0.0025
    ],
    [
      "mol",
      0.0
    ],
    [
      "mollet",
      0.0
    ],
    [
      "musical",
      0.0
    ],
    [
      "passionne",
      0.0
    ],
    [
      "pastel",
      0.0
    ],
    [
      "piano",
      0.0
    ],
    [
      "sirupeux",
      0.0
    ],
    [
      "sourd",
      0.0
    ],
    [
      "tempere",
      0.0
    ],
    [
      "liquoreux",
      0.0
    ],
    [
      "laineux",
      0.0
    ],
    [
      "aimant",
      0.0
    ],
    [
      "amabile",
      0.0
    ],
    [
      "attendrissant",
      0.0
    ],
    [
      "berceur",
      0.0
    ],
    [
      "dore",
      0.0
    ],
    [
      "doucet",
      0.0
    ],
    [
      "delectable",
      0.0
    ],
    [
      "fadasse",
      0.0
    ],
    [
      "indolent",
      0.0
    ],
    [
      "ecoeurant",
      0.0
    ]
  ],
  "visage": [
    [
      "figure",
      0.18
    ],
    [
      "air",
      0.0725
    ],
    [
      "tete",
      0.0525
    ],
    [
      "apparence",
      0.0475
    ],
    [
      "tournure",
      0.0475
    ],
    [
      "physionomie",
      0.045
    ],
    [
      "aspect",
      0.04
    ],
    [
      "face",
      0.035
    ],
    [
      "exterieur",
      0.0325
    ],
    [
      "mine",
      0.03
    ],
    [
      "trait",
      0.025
    ],
    [
      "attitude",
      0.0225
    ],
    [
      "binette",
      0.0225
    ],
    [
      "semblance",
      0.02
    ],
    [
      "expression",
      0.02
    ],
    [
      "forme",
      0.0175
    ],
    [
      "image",
      0.0175
    ],
    [
      "bouille",
      0.015
    ],
    [
      "type",
      0.0125
    ],
    [
      "portrait",
      0.0125
    ],
    [
      "masque",
      0.0125
    ],
    [
      "caractere",
      0.0125
    ],
    [
      "bille",
      0.0125
    ],
    [
      "contenance",
      0.01
    ],
    [
      "dehors",
      0.01
    ],
    [
      "facies",
      0.01
    ],
    [
      "tronche",
      0.0075
    ],
    [
      "maintien",
      0.0075
    ],
    [
      "gueule",
      0.0075
    ],
    [
      "frimousse",
      0.0075
    ],
    [
      "configuration",
      0.0075
    ],
    [
      "front",
      0.0075
    ],
    [
      "trombine",
      0.005
    ],
    [
      "museau",
      0.005
    ],
    [
      "bobine",
      0.005
    ],
    [
      "trogne",
      0.0025
    ],
    [
      "traits",
      0.0025
    ],
    [
      "profil",
      0.0025
    ],
    [
      "pomme",
      0.0025
    ],
    [
      "poire",
      0.0025
    ],
    [
      "personnalite",
      0.0025
    ],
    [
      "personnage",
      0.0025
    ],
    [
      "nez",
      0.0025
    ],
    [
      "mufle",
      0.0025
    ],
    [
      "minois",
      0.0025
    ],
    [
      "hure",
      0.0025
    ],
    [
      "fiole",
      0.0025
    ],
    [
      "disposition",
      0.0025
    ],
    [
      "mascaron",
      0.0
    ],
    [
      "margoulette",
      0.0
    ],
    [
      "gens",
      0.0
    ],
    [
      "effigie",
      0.0
    ],
    [
      "couleur",
      0.0
    ],
    [
      "conformation",
      0.0
    ],
    [
      "balle",
      0.0
    ],
    [
      "trompette",
      0.0
    ]
  ],
  "qui": [
    [
      "lequel",
      0.5
    ],
    [
      "quel",
      0.5
    ]
  ],
  "me": [
    [
      "moi",
      1.0
    ]
  ],
  "sourire": [
    [
      "rire",
      0.5
    ],
    [
      "joie",
      0.165
    ],
    [
      "ris",
      0.165
    ],
    [
      "souris",
      0.165
    ]
  ],
  "il": [],
  "a": [
    [
      "avec",
      0.1425
    ],
    [
      "de",
      0.1425
    ],
    [
      "vers",
      0.0925
    ],
    [
      "pour",
      0.0925
    ],
    [
      "par",
      0.0925
    ],
    [
      "en",
      0.0925
    ],
    [
      "dans",
      0.0925
    ],
    [
      "apres",
      0.045
    ],
    [
      "chez",
      0.045
    ],
    [
      "contre",
      0.045
    ],
    [
      "entre",
      0.045
    ],
    [
      "jusqu'a",
      0.045
    ]
  ],
  "pleuvoir": [
    [
      "pleuviner",
      0.1425
    ],
    [
      "couler",
      0.095
    ],
    [
      "pleuvasser",
      0.095
    ],
    [
      "s'abattre",
      0.095
    ],
    [
      "tomber",
      0.095
    ],
    [
      "pulluler",
      0.0475
    ],
    [
      "pluviner",
      0.0475
    ],
    [
      "pleuvoter",
      0.0475
    ],
    [
      "pleuvocher",
      0.0475
    ],
    [
      "pisser",
      0.0475
    ],
    [
      "flotter",
      0.0475
    ],
    [
      "degringoler",
      0.0475
    ],
    [
      "bruiner",
      0.0475
    ],
    [
      "abonder",
      0.0475
    ]
  ],
  "cette": [],
  "plage": [
    [
      "rivage",
      0.23
    ],
    [
      "cote",
      0.1525
    ],
    [
      "littoral",
      0.1525
    ],
    [
      "baignade",
      0.075
    ],
    [
      "greve",
      0.075
    ],
    [
      "marine",
      0.075
    ],
    [
      "pays",
      0.075
    ]
  ],
  "cet": [],
  "orage": [
    [
      "tempete",
      0.11
    ],
    [
      "trouble",
      0.0875
    ],
    [
      "tourmente",
      0.0675
    ],
    [
      "agitation",
      0.06
    ],
    [
      "secousse",
      0.04
    ],
    [
      "ouragan",
      0.0325
    ],
    [
      "commotion",
      0.0325
    ],
    [
      "bouillonnement",
      0.0325
    ],
    [
      "bourrasque",
      0.025
    ],
    [
      "explosion",
      0.025
    ],
    [
      "perturbation",
      0.025
    ],
    [
      "rupture",
      0.02
    ],
    [
      "rafale",
      0.02
    ],
    [
      "pluie",
      0.02
    ],
    [
      "nuage",
      0.02
    ],
    [
      "malheur",
      0.02
    ],
    [
      "intemperie",
      0.02
    ],
    [
      "feu",
      0.02
    ],
    [
      "temps",
      0.0125
    ],
    [
      "tension",
      0.0125
    ],
    [
      "tonnerre",
      0.0125
    ],
    [
      "tornade",
      0.0125
    ],
    [
      "tribulation",
      0.0125
    ],
    [
      "typhon",
      0.0125
    ],
    [
      "volee",
      0.0125
    ],
    [
      "renversement",
      0.0125
    ],
    [
      "mesintelligence",
      0.0125
    ],
    [
      "acces",
      0.0125
    ],
    [
      "calamite",
      0.0125
    ],
    [
      "convulsion",
      0.0125
    ],
    [
      "disgrace",
      0.0125
    ],
    [
      "dechirement",
      0.0125
    ],
    [
      "frenesie",
      0.0125
    ],
    [
      "giboulee",
      0.0125
    ],
    [
      "avalanche",
      0.005
    ],
    [
      "deluge",
      0.005
    ],
    [
      "foudre",
      0.005
    ],
    [
      "heurt",
      0.005
    ],
    [
      "revers",
      0.005
    ],
    [
      "troubles",
      0.005
    ]
  ],
  "elle": [],
  "disparu": [
    [
      "s'evanouir",
      0.06
    ],
    [
      "mourir",
      0.0525
    ],
    [
      "s'effacer",
      0.0475
    ],
    [
      "fuir",
      0.045
    ],
    [
      "partir",
      0.04
    ],
    [
      "s'enfuir",
      0.04
    ],
    [
      "s'eteindre",
      0.0325
    ],
    [
      "tomber",
      0.0325
    ],
    [
      "s'amenuiser",
      0.03
    ],
    [
      "passer",
      0.025
    ],
    [
      "s'eclipser",
      0.025
    ],
    [
      "perdre",
      0.0225
    ],
    [
      "perir",
      0.02
    ],
    [
      "finir",
      0.0175
    ],
    [
      "s'envoler",
      0.0175
    ],
    [
      "s'estomper",
      0.0175
    ],
    [
      "s'aneantir",
      0.0175
    ],
    [
      "cesser",
      0.015
    ],
    [
      "expirer",
      0.015
    ],
    [
      "sombrer",
      0.0125
    ],
    [
      "quitter",
      0.0125
    ],
    [
      "abandonner",
      0.0125
    ],
    [
      "s'enfoncer",
      0.01
    ],
    [
      "s'evaporer",
      0.0075
    ],
    [
      "s'abimer",
      0.0075
    ],
    [
      "fondre",
      0.0075
    ],
    [
      "diminuer",
      0.0075
    ],
    [
      "echapper",
      0.0075
    ],
    [
      "s'eloigner",
      0.0075
    ],
    [
      "filer",
      0.0075
    ],
    [
      "manquer",
      0.005
    ],
    [
      "tarir",
      0.005
    ],
    [
      "s'ecouler",
      0.005
    ],
    [
      "s'absenter",
      0.005
    ],
    [
      "decamper",
      0.005
    ],
    [
      "succomber",
      0.0025
    ],
    [
      "s'esquiver",
      0.0025
    ],
    [
      "s'affaiblir",
      0.0025
    ],
    [
      "reculer",
      0.0025
    ],
    [
      "s'epuiser",
      0.0025
    ],
    [
      "s'exiler",
      0.0025
    ],
    [
      "s'enterrer",
      0.0025
    ],
    [
      "s'engouffrer",
      0.0025
    ],
    [
      "decliner",
      0.0025
    ],
    [
      "trepasser",
      0.0
    ],
    [
      "s'egarer",
      0.0
    ],
    [
      "s'ensevelir",
      0.0
    ],
    [
      "s'engloutir",
      0.0
    ],
    [
      "plonger",
      0.0
    ],
    [
      "s'eliminer",
      0.0
    ],
    [
      "s'escamoter",
      0.0
    ],
    [
      "defiler",
      0.0
    ]
  ],
  "disparaitre": [
    [
      "s'evanouir",
      0.06
    ],
    [
      "mourir",
      0.0525
    ],
    [
      "s'effacer",
      0.0475
    ],
    [
      "fuir",
      0.045
    ],
    [
      "partir",
      0.04
    ],
    [
      "s'enfuir",
      0.04
    ],
    [
      "s'eteindre",
      0.0325
    ],
    [
      "tomber",
      0.0325
    ],
    [
      "s'amenuiser",
      0.03
    ],
    [
      "passer",
      0.025
    ],
    [
      "s'eclipser",
      0.025
    ],
    [
      "perdre",
      0.0225
    ],
    [
      "perir",
      0.02
    ],
    [
      "finir",
      0.0175
    ],
    [
      "s'envoler",
      0.0175
    ],
    [
      "s'estomper",
      0.0175
    ],
    [
      "s'aneantir",
      0.0175
    ],
    [
      "cesser",
      0.015
    ],
    [
      "expirer",
      0.015
    ],
    [
      "sombrer",
      0.0125
    ],
    [
      "quitter",
      0.0125
    ],
    [
      "abandonner",
      0.0125
    ],
    [
      "s'enfoncer",
      0.01
    ],
    [
      "s'evaporer",
      0.0075
    ],
    [
      "s'abimer",
      0.0075
    ],
    [
      "fondre",
      0.0075
    ],
    [
      "diminuer",
      0.0075
    ],
    [
      "echapper",
      0.0075
    ],
    [
      "s'eloigner",
      0.0075
    ],
    [
      "filer",
      0.0075
    ],
    [
      "manquer",
      0.005
    ],
    [
      "tarir",
      0.005
    ],
    [
      "s'ecouler",
      0.005
    ],
    [
      "s'absenter",
      0.005
    ],
    [
      "decamper",
      0.005
    ],
    [
      "succomber",
      0.0025
    ],
    [
      "s'esquiver",
      0.0025
    ],
    [
      "s'affaiblir",
      0.0025
    ],
    [
      "reculer",
      0.0025
    ],
    [
      "s'epuiser",
      0.0025
    ],
    [
      "s'exiler",
      0.0025
    ],
    [
      "s'enterrer",
      0.0025
    ],
    [
      "s'engouffrer",
      0.0025
    ],
    [
      "decliner",
      0.0025
    ],
    [
      "trepasser",
      0.0
    ],
    [
      "s'egarer",
      0.0
    ],
    [
      "s'ensevelir",
      0.0
    ],
    [
      "s'engloutir",
      0.0
    ],
    [
      "plonger",
      0.0
    ],
    [
      "s'eliminer",
      0.0
    ],
    [
      "s'escamoter",
      0.0
    ],
    [
      "defiler",
      0.0
    ]
  ],
  "crier": [
    [
      "protester",
      0.0475
    ],
    [
      "hurler",
      0.045
    ],
    [
      "appeler",
      0.0325
    ],
    [
      "dire",
      0.0325
    ],
    [
      "gueuler",
      0.0325
    ],
    [
      "tonner",
      0.03
    ],
    [
      "brailler",
      0.0275
    ],
    [
      "rouspeter",
      0.0275
    ],
    [
      "reclamer",
      0.0275
    ],
    [
      "tempeter",
      0.025
    ],
    [
      "gronder",
      0.025
    ],
    [
      "beugler",
      0.0225
    ],
    [
      "chanter",
      0.0225
    ],
    [
      "signaler",
      0.0225
    ],
    [
      "publier",
      0.0175
    ],
    [
      "manifester",
      0.0175
    ],
    [
      "fulminer",
      0.0175
    ],
    [
      "beler",
      0.0175
    ],
    [
      "vociferer",
      0.015
    ],
    [
      "pleurer",
      0.015
    ],
    [
      "gemir",
      0.015
    ],
    [
      "criailler",
      0.015
    ],
    [
      "bramer",
      0.015
    ],
    [
      "clamer",
      0.0125
    ],
    [
      "annoncer",
      0.0125
    ],
    [
      "affirmer",
      0.0125
    ],
    [
      "aboyer",
      0.0125
    ],
    [
      "s'egosiller",
      0.01
    ],
    [
      "proclamer",
      0.01
    ],
    [
      "piauler",
      0.01
    ],
    [
      "exprimer",
      0.01
    ],
    [
      "braire",
      0.01
    ],
    [
      "avertir",
      0.01
    ],
    [
      "eclater",
      0.0075
    ],
    [
      "tonitruer",
      0.0075
    ],
    [
      "s'ecrier",
      0.0075
    ],
    [
      "s'indigner",
      0.0075
    ],
    [
      "rugir",
      0.0075
    ],
    [
      "retentir",
      0.0075
    ],
    [
      "pousser",
      0.0075
    ],
    [
      "mugir",
      0.0075
    ],
    [
      "attraper",
      0.0075
    ],
    [
      "bruire",
      0.0075
    ],
    [
      "declamer",
      0.0075
    ],
    [
      "implorer",
      0.0075
    ],
    [
      "invectiver",
      0.0075
    ],
    [
      "prevenir",
      0.005
    ],
    [
      "pepier",
      0.005
    ],
    [
      "repandre",
      0.005
    ],
    [
      "reprimander",
      0.005
    ],
    [
      "s'exclamer",
      0.005
    ],
    [
      "sermonner",
      0.005
    ],
    [
      "supplier",
      0.005
    ],
    [
      "tancer",
      0.005
    ],
    [
      "proferer",
      0.005
    ],
    [
      "prier",
      0.005
    ],
    [
      "piper",
      0.005
    ],
    [
      "apostropher",
      0.005
    ],
    [
      "chahuter",
      0.005
    ],
    [
      "clabauder",
      0.005
    ],
    [
      "glapir",
      0.005
    ],
    [
      "grincer",
      0.005
    ],
    [
      "heler",
      0.005
    ],
    [
      "interpeller",
      0.005
    ],
    [
      "jurer",
      0.005
    ],
    [
      "piailler",
      0.005
    ],
    [
      "hucher",
      0.0
    ],
    [
      "hululer",
      0.0
    ],
    [
      "invoquer",
      0.0
    ],
    [
      "meugler",
      0.0
    ],
    [
      "s'epoumoner",
      0.0
    ],
    [
      "houper",
      0.0
    ],
    [
      "grogner",
      0.0
    ],
    [
      "feuler",
      0.0
    ],
    [
      "croasser",
      0.0
    ],
    [
      "conspuer",
      0.0
    ],
    [
      "accuser",
      0.0
    ],
    [
      "acclamer",
      0.0
    ],
    [
      "vagir",
      0.0
    ]
  ],
  "pour": [
    [
      "sur",
      0.0875
    ],
    [
      "vers",
      0.0525
    ],
    [
      "de",
      0.0525
    ],
    [
      "a",
      0.035
    ],
    [
      "pendant",
      0.035
    ],
    [
      "moyennant",
      0.035
    ],
    [
      "envers",
      0.035
    ],
    [
      "durant",
      0.035
    ],
    [
      "jusque",
      0.0175
    ],
    [
      "partisan",
      0.0175
    ],
    [
      "pret",
      0.0175
    ],
    [
      "quelque",
      0.0175
    ],
    [
      "quoique",
      0.0175
    ],
    [
      "comme",
      0.0175
    ]
  ],
  "revenir": [
    [
      "renaitre",
      0.055
    ],
    [
      "recommencer",
      0.0475
    ],
    [
      "reprendre",
      0.0475
    ],
    [
      "retourner",
      0.0475
    ],
    [
      "regagner",
      0.0325
    ],
    [
      "reapparaitre",
      0.0275
    ],
    [
      "retomber",
      0.0275
    ],
    [
      "passer",
      0.0275
    ],
    [
      "recidiver",
      0.02
    ],
    [
      "ressortir",
      0.02
    ],
    [
      "repousser",
      0.02
    ],
    [
      "reparaitre",
      0.02
    ],
    [
      "rentrer",
      0.02
    ],
    [
      "rejoindre",
      0.02
    ],
    [
      "rallier",
      0.02
    ],
    [
      "incomber",
      0.02
    ],
    [
      "guerir",
      0.02
    ],
    [
      "appartenir",
      0.02
    ],
    [
      "satisfaire",
      0.0125
    ],
    [
      "sortir",
      0.0125
    ],
    [
      "valoir",
      0.0125
    ],
    [
      "echoir",
      0.0125
    ],
    [
      "recuperer",
      0.0125
    ],
    [
      "retrouver",
      0.0125
    ],
    [
      "apparaitre",
      0.0125
    ],
    [
      "convenir",
      0.0125
    ],
    [
      "reculer",
      0.0125
    ],
    [
      "refluer",
      0.0125
    ],
    [
      "relever",
      0.0125
    ],
    [
      "retrograder",
      0.005
    ],
    [
      "s'occuper",
      0.005
    ],
    [
      "sauter",
      0.005
    ],
    [
      "equivaloir",
      0.005
    ],
    [
      "reintegrer",
      0.005
    ],
    [
      "reexaminer",
      0.005
    ],
    [
      "ressurgir",
      0.005
    ],
    [
      "afferer",
      0.005
    ],
    [
      "agreer",
      0.005
    ],
    [
      "contremander",
      0.005
    ],
    [
      "couter",
      0.005
    ],
    [
      "obtenir",
      0.005
    ],
    [
      "plaire",
      0.005
    ],
    [
      "rappliquer",
      0.005
    ],
    [
      "reconduire",
      0.005
    ],
    [
      "reconsiderer",
      0.005
    ],
    [
      "reparler",
      0.005
    ],
    [
      "repasser",
      0.005
    ]
  ],
  "pleurer": [
    [
      "crier",
      0.1
    ],
    [
      "regretter",
      0.0675
    ],
    [
      "pleurnicher",
      0.05
    ],
    [
      "plaindre",
      0.05
    ],
    [
      "gemir",
      0.05
    ],
    [
      "geindre",
      0.05
    ],
    [
      "sangloter",
      0.0325
    ],
    [
      "marchander",
      0.0325
    ],
    [
      "larmoyer",
      0.0325
    ],
    [
      "deplorer",
      0.0325
    ],
    [
      "bramer",
      0.0325
    ],
    [
      "brailler",
      0.0325
    ],
    [
      "repandre",
      0.015
    ],
    [
      "s'apitoyer",
      0.015
    ],
    [
      "soupirer",
      0.015
    ],
    [
      "suinter",
      0.015
    ],
    [
      "supplier",
      0.015
    ],
    [
      "vagir",
      0.015
    ],
    [
      "ressentir",
      0.015
    ],
    [
      "lesiner",
      0.015
    ],
    [
      "implorer",
      0.015
    ],
    [
      "hurler",
      0.015
    ],
    [
      "couler",
      0.015
    ],
    [
      "couiner",
      0.015
    ],
    [
      "chigner",
      0.015
    ],
    [
      "chialer",
      0.015
    ],
    [
      "braire",
      0.015
    ]
  ],
  "trop": [
    [
      "excessivement",
      0.11
    ],
    [
      "beaucoup",
      0.0925
    ],
    [
      "tres",
      0.0925
    ],
    [
      "exces",
      0.0725
    ],
    [
      "extremement",
      0.0725
    ],
    [
      "intrus",
      0.055
    ],
    [
      "surnombre",
      0.035
    ],
    [
      "outrance",
      0.035
    ],
    [
      "importun",
      0.035
    ],
    [
      "fort",
      0.035
    ],
    [
      "exageration",
      0.035
    ],
    [
      "indesirable",
      0.0175
    ],
    [
      "infiniment",
      0.0175
    ],
    [
      "surabondamment",
      0.0175
    ],
    [
      "surnumeraire",
      0.0175
    ],
    [
      "surplus",
      0.0175
    ],
    [
      "geneur",
      0.0175
    ],
    [
      "genant",
      0.0175
    ],
    [
      "excedent",
      0.0175
    ],
    [
      "excessif",
      0.0175
    ],
    [
      "exagerement",
      0.0175
    ],
    [
      "demesure",
      0.0175
    ],
    [
      "bien",
      0.0175
    ],
    [
      "abus",
      0.0175
    ],
    [
      "enormement",
      0.0175
    ]
  ],
  "de": [
    [
      "carrelet",
      0.25
    ],
    [
      "carre",
      0.25
    ],
    [
      "cube",
      0.25
    ],
    [
      "zanzi",
      0.25
    ]
  ],
  "peine": [
    [
      "chagrin",
      0.075
    ],
    [
      "ennui",
      0.0725
    ],
    [
      "douleur",
      0.065
    ],
    [
      "affliction",
      0.06
    ],
    [
      "mal",
      0.055
    ],
    [
      "tourment",
      0.0375
    ],
    [
      "tristesse",
      0.035
    ],
    [
      "souci",
      0.0325
    ],
    [
      "supplice",
      0.0225
    ],
    [
      "inquietude",
      0.0225
    ],
    [
      "angoisse",
      0.02
    ],
    [
      "difficulte",
      0.02
    ],
    [
      "malheur",
      0.02
    ],
    [
      "epreuve",
      0.0175
    ],
    [
      "tribulation",
      0.0175
    ],
    [
      "souffrance",
      0.0175
    ],
    [
      "melancolie",
      0.0175
    ],
    [
      "travail",
      0.015
    ],
    [
      "punition",
      0.015
    ],
    [
      "desolation",
      0.015
    ],
    [
      "chatiment",
      0.015
    ],
    [
      "amertume",
      0.015
    ],
    [
      "tracas",
      0.0125
    ],
    [
      "desagrement",
      0.01
    ],
    [
      "fatigue",
      0.01
    ],
    [
      "torture",
      0.0075
    ],
    [
      "misere",
      0.0075
    ],
    [
      "embarras",
      0.0075
    ],
    [
      "detresse",
      0.0075
    ],
    [
      "deplaisir",
      0.0075
    ],
    [
      "boulet",
      0.0075
    ],
    [
      "abattement",
      0.0075
    ],
    [
      "tintouin",
      0.0075
    ],
    [
      "regret",
      0.0075
    ],
    [
      "preoccupation",
      0.0075
    ],
    [
      "labeur",
      0.0075
    ],
    [
      "gene",
      0.0075
    ],
    [
      "depression",
      0.0075
    ],
    [
      "damnation",
      0.0075
    ],
    [
      "croix",
      0.0075
    ],
    [
      "calvaire",
      0.0075
    ],
    [
      "tirage",
      0.005
    ],
    [
      "sanction",
      0.005
    ],
    [
      "faute",
      0.005
    ],
    [
      "effort",
      0.005
    ],
    [
      "deception",
      0.005
    ],
    [
      "condamnation",
      0.005
    ],
    [
      "cafard",
      0.005
    ],
    [
      "sueur",
      0.0025
    ],
    [
      "remords",
      0.0025
    ],
    [
      "penitence",
      0.0025
    ],
    [
      "penalite",
      0.0025
    ],
    [
      "plaie",
      0.0025
    ],
    [
      "infraction",
      0.0025
    ],
    [
      "expiation",
      0.0025
    ],
    [
      "exercice",
      0.0025
    ],
    [
      "delit",
      0.0025
    ],
    [
      "crime",
      0.0025
    ],
    [
      "correction",
      0.0025
    ],
    [
      "contravention",
      0.0025
    ],
    [
      "fouet",
      0.0
    ],
    [
      "larme",
      0.0
    ],
    [
      "meurtrissure",
      0.0
    ],
    [
      "navrement",
      0.0
    ],
    [
      "purgatoire",
      0.0
    ],
    [
      "ronce",
      0.0
    ],
    [
      "enfer",
      0.0
    ],
    [
      "endolorissement",
      0.0
    ],
    [
      "deprime",
      0.0
    ],
    [
      "dechirure",
      0.0
    ],
    [
      "dam",
      0.0
    ],
    [
      "collier",
      0.0
    ],
    [
      "censure",
      0.0
    ],
    [
      "besoin",
      0.0
    ],
    [
      "anxiete",
      0.0
    ],
    [
      "agonie",
      0.0
    ],
    [
      "tache",
      0.0
    ]
  ],
  "peiner": [
    [
      "chagriner",
      0.095
    ],
    [
      "navrer",
      0.0775
    ],
    [
      "attrister",
      0.0675
    ],
    [
      "suer",
      0.06
    ],
    [
      "affliger",
      0.05
    ],
    [
      "travailler",
      0.0425
    ],
    [
      "fatiguer",
      0.0425
    ],
    [
      "deplaire",
      0.0425
    ],
    [
      "facher",
      0.0325
    ],
    [
      "tuer",
      0.025
    ],
    [
      "trimer",
      0.025
    ],
    [
      "souffrir",
      0.025
    ],
    [
      "s'epuiser",
      0.025
    ],
    [
      "meurtrir",
      0.025
    ],
    [
      "assombrir",
      0.025
    ],
    [
      "ahaner",
      0.025
    ],
    [
      "s'evertuer",
      0.015
    ],
    [
      "s'efforcer",
      0.015
    ],
    [
      "rembrunir",
      0.015
    ],
    [
      "peser",
      0.015
    ],
    [
      "endolorir",
      0.015
    ],
    [
      "desoler",
      0.015
    ],
    [
      "desobliger",
      0.015
    ],
    [
      "desesperer",
      0.015
    ],
    [
      "besogner",
      0.015
    ],
    [
      "s'ereinter",
      0.0075
    ],
    [
      "s'echiner",
      0.0075
    ],
    [
      "s'appliquer",
      0.0075
    ],
    [
      "piocher",
      0.0075
    ],
    [
      "gemir",
      0.0075
    ],
    [
      "contrister",
      0.0075
    ],
    [
      "affecter",
      0.0075
    ],
    [
      "souquer",
      0.0075
    ]
  ],
  "etre": [
    [
      "ame",
      0.1075
    ],
    [
      "esprit",
      0.09
    ],
    [
      "homme",
      0.09
    ],
    [
      "personne",
      0.075
    ],
    [
      "essence",
      0.06
    ],
    [
      "etat",
      0.045
    ],
    [
      "substance",
      0.045
    ],
    [
      "origine",
      0.045
    ],
    [
      "individu",
      0.045
    ],
    [
      "humain",
      0.045
    ],
    [
      "vie",
      0.03
    ],
    [
      "souche",
      0.03
    ],
    [
      "realite",
      0.03
    ],
    [
      "personnalite",
      0.03
    ],
    [
      "naissance",
      0.03
    ],
    [
      "existence",
      0.03
    ],
    [
      "entite",
      0.03
    ],
    [
      "creature",
      0.03
    ],
    [
      "rang",
      0.015
    ],
    [
      "mortel",
      0.015
    ],
    [
      "conscience",
      0.015
    ],
    [
      "condition",
      0.015
    ],
    [
      "abstraction",
      0.015
    ],
    [
      "type",
      0.015
    ]
  ],
  "suivre": [
    [
      "prendre",
      0.0425
    ],
    [
      "s'attacher",
      0.0425
    ],
    [
      "adopter",
      0.0275
    ],
    [
      "tenir",
      0.0275
    ],
    [
      "venir",
      0.0275
    ],
    [
      "soutenir",
      0.025
    ],
    [
      "obeir",
      0.025
    ],
    [
      "observer",
      0.025
    ],
    [
      "voir",
      0.0225
    ],
    [
      "pratiquer",
      0.0225
    ],
    [
      "embrasser",
      0.0225
    ],
    [
      "accompagner",
      0.0225
    ],
    [
      "servir",
      0.02
    ],
    [
      "regarder",
      0.02
    ],
    [
      "imiter",
      0.02
    ],
    [
      "sortir",
      0.015
    ],
    [
      "s'occuper",
      0.015
    ],
    [
      "s'adonner",
      0.015
    ],
    [
      "provenir",
      0.015
    ],
    [
      "poursuivre",
      0.015
    ],
    [
      "frequenter",
      0.015
    ],
    [
      "assister",
      0.015
    ],
    [
      "adherer",
      0.015
    ],
    [
      "ecouter",
      0.0125
    ],
    [
      "surveiller",
      0.0125
    ],
    [
      "subir",
      0.0125
    ],
    [
      "resulter",
      0.0125
    ],
    [
      "marcher",
      0.0125
    ],
    [
      "emprunter",
      0.0125
    ],
    [
      "decouler",
      0.0125
    ],
    [
      "succeder",
      0.0075
    ],
    [
      "talonner",
      0.0075
    ],
    [
      "epouser",
      0.0075
    ],
    [
      "s'interesser",
      0.0075
    ],
    [
      "s'ensuivre",
      0.0075
    ],
    [
      "comprendre",
      0.0075
    ],
    [
      "consulter",
      0.0075
    ],
    [
      "continuer",
      0.0075
    ],
    [
      "escorter",
      0.0075
    ],
    [
      "filer",
      0.0075
    ],
    [
      "pister",
      0.0075
    ],
    [
      "plagier",
      0.0075
    ],
    [
      "respecter",
      0.005
    ],
    [
      "s'abandonner",
      0.005
    ],
    [
      "s'atteler",
      0.005
    ],
    [
      "serrer",
      0.005
    ],
    [
      "remplacer",
      0.005
    ],
    [
      "remonter",
      0.005
    ],
    [
      "hanter",
      0.005
    ],
    [
      "arriver",
      0.005
    ],
    [
      "chaperonner",
      0.005
    ],
    [
      "copier",
      0.005
    ],
    [
      "cotoyer",
      0.005
    ],
    [
      "flanquer",
      0.005
    ],
    [
      "s'infeoder",
      0.0025
    ],
    [
      "sacrifier",
      0.0025
    ],
    [
      "parcourir",
      0.0025
    ],
    [
      "longer",
      0.0025
    ],
    [
      "apprendre",
      0.0025
    ],
    [
      "calquer",
      0.0025
    ],
    [
      "convoyer",
      0.0025
    ],
    [
      "corteger",
      0.0025
    ],
    [
      "courtiser",
      0.0025
    ],
    [
      "descendre",
      0.0025
    ],
    [
      "enfiler",
      0.0025
    ],
    [
      "espionner",
      0.0025
    ],
    [
      "interesser",
      0.0025
    ],
    [
      "accomplir",
      0.0025
    ]
  ],
  "assis": [
    [
      "fonder",
      0.1225
    ],
    [
      "etablir",
      0.1225
    ],
    [
      "mettre",
      0.0725
    ],
    [
      "fixer",
      0.06
    ],
    [
      "poser",
      0.06
    ],
    [
      "batir",
      0.0475
    ],
    [
      "appuyer",
      0.0475
    ],
    [
      "affermir",
      0.0475
    ],
    [
      "assurer",
      0.035
    ],
    [
      "consacrer",
      0.035
    ],
    [
      "constituer",
      0.035
    ],
    [
      "placer",
      0.035
    ],
    [
      "ebahir",
      0.0225
    ],
    [
      "stupefier",
      0.0225
    ],
    [
      "consolider",
      0.0225
    ],
    [
      "camper",
      0.0225
    ],
    [
      "baser",
      0.0225
    ],
    [
      "situer",
      0.01
    ],
    [
      "reunir",
      0.01
    ],
    [
      "renverser",
      0.01
    ],
    [
      "rasseoir",
      0.01
    ],
    [
      "motiver",
      0.01
    ],
    [
      "inviter",
      0.01
    ],
    [
      "installer",
      0.01
    ],
    [
      "estomaquer",
      0.01
    ],
    [
      "decontenancer",
      0.01
    ],
    [
      "attabler",
      0.01
    ],
    [
      "epater",
      0.01
    ]
  ],
  "asseoir": [
    [
      "fonder",
      0.1225
    ],
    [
      "etablir",
      0.1225
    ],
    [
      "mettre",
      0.0725
    ],
    [
      "fixer",
      0.06
    ],
    [
      "poser",
      0.06
    ],
    [
      "batir",
      0.0475
    ],
    [
      "appuyer",
      0.0475
    ],
    [
      "affermir",
      0.0475
    ],
    [
      "assurer",
      0.035
    ],
    [
      "consacrer",
      0.035
    ],
    [
      "constituer",
      0.035
    ],
    [
      "placer",
      0.035
    ],
    [
      "ebahir",
      0.0225
    ],
    [
      "stupefier",
      0.0225
    ],
    [
      "consolider",
      0.0225
    ],
    [
      "camper",
      0.0225
    ],
    [
      "baser",
      0.0225
    ],
    [
      "situer",
      0.01
    ],
    [
      "reunir",
      0.01
    ],
    [
      "renverser",
      0.01
    ],
    [
      "rasseoir",
      0.01
    ],
    [
      "motiver",
      0.01
    ],
    [
      "inviter",
      0.01
    ],
    [
      "installer",
      0.01
    ],
    [
      "estomaquer",
      0.01
    ],
    [
      "decontenancer",
      0.01
    ],
    [
      "attabler",
      0.01
    ],
    [
      "epater",
      0.01
    ]
  ],
  "aupres": [
    [
      "pres",
      0.235
    ],
    [
      "contre",
      0.1175
    ],
    [
      "proche",
      0.1175
    ],
    [
      "chez",
      0.0575
    ],
    [
      "avec",
      0.0575
    ],
    [
      "autour",
      0.0575
    ],
    [
      "vers",
      0.0575
    ]
  ],
  "son": [
    [
      "ton",
      0.1675
    ],
    [
      "accent",
      0.09
    ],
    [
      "bruit",
      0.09
    ],
    [
      "voix",
      0.075
    ],
    [
      "resonance",
      0.045
    ],
    [
      "timbre",
      0.03
    ],
    [
      "tonalite",
      0.03
    ],
    [
      "echo",
      0.03
    ],
    [
      "eclat",
      0.03
    ],
    [
      "sonorite",
      0.03
    ],
    [
      "retentissement",
      0.03
    ],
    [
      "modulation",
      0.03
    ],
    [
      "intonation",
      0.03
    ],
    [
      "inflexion",
      0.03
    ],
    [
      "accord",
      0.03
    ],
    [
      "onde",
      0.015
    ],
    [
      "onomatopee",
      0.015
    ],
    [
      "parole",
      0.015
    ],
    [
      "phoneme",
      0.015
    ],
    [
      "rythme",
      0.015
    ],
    [
      "note",
      0.015
    ],
    [
      "musique",
      0.015
    ],
    [
      "mouture",
      0.015
    ],
    [
      "issue",
      0.015
    ],
    [
      "coup",
      0.015
    ],
    [
      "bran",
      0.015
    ],
    [
      "ble",
      0.015
    ],
    [
      "balle",
      0.015
    ],
    [
      "vibration",
      0.015
    ]
  ],
  "ame": [
    [
      "coeur",
      0.0825
    ],
    [
      "esprit",
      0.0625
    ],
    [
      "courage",
      0.045
    ],
    [
      "generosite",
      0.04
    ],
    [
      "force",
      0.0375
    ],
    [
      "caractere",
      0.03
    ],
    [
      "ardeur",
      0.0275
    ],
    [
      "energie",
      0.0275
    ],
    [
      "etre",
      0.0225
    ],
    [
      "fond",
      0.0225
    ],
    [
      "fermete",
      0.0225
    ],
    [
      "centre",
      0.0175
    ],
    [
      "personnalite",
      0.0175
    ],
    [
      "promoteur",
      0.0175
    ],
    [
      "vie",
      0.015
    ],
    [
      "valeur",
      0.015
    ],
    [
      "personne",
      0.015
    ],
    [
      "moteur",
      0.015
    ],
    [
      "interieur",
      0.015
    ],
    [
      "vigueur",
      0.0125
    ],
    [
      "responsable",
      0.0125
    ],
    [
      "nature",
      0.0125
    ],
    [
      "conscience",
      0.0125
    ],
    [
      "cerveau",
      0.0125
    ],
    [
      "animateur",
      0.0125
    ],
    [
      "agent",
      0.0125
    ],
    [
      "intrepidite",
      0.0075
    ],
    [
      "magnanimite",
      0.0075
    ],
    [
      "moi",
      0.0075
    ],
    [
      "ombre",
      0.0075
    ],
    [
      "principe",
      0.0075
    ],
    [
      "souffle",
      0.0075
    ],
    [
      "volonte",
      0.0075
    ],
    [
      "emanation",
      0.0075
    ],
    [
      "individu",
      0.0075
    ],
    [
      "heroisme",
      0.0075
    ],
    [
      "homme",
      0.0075
    ],
    [
      "air",
      0.0075
    ],
    [
      "animation",
      0.0075
    ],
    [
      "artisan",
      0.0075
    ],
    [
      "audace",
      0.0075
    ],
    [
      "bonte",
      0.0075
    ],
    [
      "chef",
      0.0075
    ],
    [
      "essence",
      0.0075
    ],
    [
      "feu",
      0.0075
    ],
    [
      "noeud",
      0.005
    ],
    [
      "organe",
      0.005
    ],
    [
      "patron",
      0.005
    ],
    [
      "pensee",
      0.005
    ],
    [
      "secret",
      0.005
    ],
    [
      "trempe",
      0.005
    ],
    [
      "vapeur",
      0.005
    ],
    [
      "noblesse",
      0.005
    ],
    [
      "manes",
      0.005
    ],
    [
      "intime",
      0.005
    ],
    [
      "charite",
      0.005
    ],
    [
      "dedans",
      0.005
    ],
    [
      "double",
      0.005
    ],
    [
      "ectoplasme",
      0.005
    ],
    [
      "flamme",
      0.005
    ],
    [
      "instigateur",
      0.005
    ],
    [
      "intelligence",
      0.005
    ],
    [
      "noyau",
      0.0025
    ],
    [
      "organisateur",
      0.0025
    ],
    [
      "psyche",
      0.0025
    ],
    [
      "spiritualite",
      0.0025
    ],
    [
      "ether",
      0.0025
    ],
    [
      "mystere",
      0.0025
    ],
    [
      "maitre",
      0.0025
    ],
    [
      "intuition",
      0.0025
    ],
    [
      "habitant",
      0.0025
    ],
    [
      "entrailles",
      0.0025
    ],
    [
      "constance",
      0.0025
    ],
    [
      "biquet",
      0.0025
    ],
    [
      "atma",
      0.0025
    ],
    [
      "etincelle",
      0.0025
    ]
  ],
  "la": [],
  "beau": [
    [
      "bon",
      0.0575
    ],
    [
      "agreable",
      0.0275
    ],
    [
      "joli",
      0.0275
    ],
    [
      "grand",
      0.0275
    ],
    [
      "charmant",
      0.02
    ],
    [
      "parfait",
      0.02
    ],
    [
      "merveilleux",
      0.0175
    ],
    [
      "aimable",
      0.0175
    ],
    [
      "superieur",
      0.015
    ],
    [
      "etonnant",
      0.015
    ],
    [
      "distingue",
      0.015
    ],
    [
      "remarquable",
      0.015
    ],
    [
      "gracieux",
      0.0125
    ],
    [
      "bien",
      0.0125
    ],
    [
      "excellent",
      0.0125
    ],
    [
      "formidable",
      0.0125
    ],
    [
      "gros",
      0.0125
    ],
    [
      "elegant",
      0.0125
    ],
    [
      "fort",
      0.0125
    ],
    [
      "delicat",
      0.0125
    ],
    [
      "brillant",
      0.01
    ],
    [
      "exquis",
      0.01
    ],
    [
      "plaisant",
      0.01
    ],
    [
      "sensationnel",
      0.01
    ],
    [
      "important",
      0.01
    ],
    [
      "admirable",
      0.01
    ],
    [
      "fameux",
      0.01
    ],
    [
      "haut",
      0.01
    ],
    [
      "heureux",
      0.01
    ],
    [
      "honnete",
      0.01
    ],
    [
      "interessant",
      0.01
    ],
    [
      "magnifique",
      0.01
    ],
    [
      "imposant",
      0.0075
    ],
    [
      "fantastique",
      0.0075
    ],
    [
      "fabuleux",
      0.0075
    ],
    [
      "doux",
      0.0075
    ],
    [
      "convenable",
      0.0075
    ],
    [
      "superbe",
      0.0075
    ],
    [
      "noble",
      0.0075
    ],
    [
      "gentil",
      0.0075
    ],
    [
      "chic",
      0.0075
    ],
    [
      "eclatant",
      0.0075
    ],
    [
      "sublime",
      0.0075
    ],
    [
      "splendide",
      0.0075
    ],
    [
      "incomparable",
      0.0075
    ],
    [
      "fin",
      0.0075
    ],
    [
      "enorme",
      0.005
    ],
    [
      "ravissant",
      0.005
    ],
    [
      "piquant",
      0.005
    ],
    [
      "genial",
      0.005
    ],
    [
      "delicieux",
      0.005
    ],
    [
      "adorable",
      0.005
    ],
    [
      "eleve",
      0.005
    ],
    [
      "seduisant",
      0.005
    ],
    [
      "riche",
      0.005
    ],
    [
      "pur",
      0.005
    ],
    [
      "poli",
      0.005
    ],
    [
      "grandiose",
      0.005
    ],
    [
      "fier",
      0.005
    ],
    [
      "enchanteur",
      0.005
    ],
    [
      "correct",
      0.005
    ],
    [
      "genereux",
      0.005
    ],
    [
      "ideal",
      0.005
    ],
    [
      "monumental",
      0.005
    ],
    [
      "eminent",
      0.005
    ],
    [
      "epatant",
      0.005
    ],
    [
      "glorieux",
      0.005
    ],
    [
      "galant",
      0.005
    ],
    [
      "divin",
      0.005
    ],
    [
      "digne",
      0.005
    ],
    [
      "coquet",
      0.005
    ],
    [
      "avantageux",
      0.005
    ],
    [
      "attrayant",
      0.005
    ],
    [
      "propice",
      0.0025
    ],
    [
      "precieux",
      0.0025
    ],
    [
      "seyant",
      0.0025
    ],
    [
      "sortable",
      0.0025
    ],
    [
      "eblouissant",
      0.0025
    ],
    [
      "majestueux",
      0.0025
    ],
    [
      "magistral",
      0.0025
    ],
    [
      "harmonieux",
      0.0025
    ],
    [
      "gai",
      0.0025
    ],
    [
      "drole",
      0.0025
    ],
    [
      "considerable",
      0.0025
    ],
    [
      "chouette",
      0.0025
    ],
    [
      "riant",
      0.0025
    ],
    [
      "habile",
      0.0025
    ],
    [
      "favorable",
      0.0025
    ],
    [
      "brave",
      0.0025
    ],
    [
      "bizarre",
      0.0025
    ],
    [
      "bienseant",
      0.0025
    ],
    [
      "accompli",
      0.0025
    ],
    [
      "juste",
      0.0025
    ],
    [
      "mignon",
      0.0025
    ],
    [
      "proportionne",
      0.0025
    ],
    [
      "radieux",
      0.0025
    ],
    [
      "sacre",
      0.0025
    ],
    [
      "serein",
      0.0025
    ],
    [
      "simple",
      0.0025
    ],
    [
      "somptueux",
      0.0025
    ],
    [
      "unique",
      0.0025
    ],
    [
      "extra",
      0.0025
    ],
    [
      "curieux",
      0.0025
    ],
    [
      "acheve",
      0.0025
    ],
    [
      "adroit",
      0.0025
    ],
    [
      "angelique",
      0.0025
    ],
    [
      "bath",
      0.0025
    ],
    [
      "beaute",
      0.0025
    ],
    [
      "cheri",
      0.0025
    ],
    [
      "civil",
      0.0025
    ],
    [
      "clair",
      0.0025
    ],
    [
      "consomme",
      0.0025
    ],
    [
      "limpide",
      0.0
    ],
    [
      "magique",
      0.0
    ],
    [
      "passionnant",
      0.0
    ],
    [
      "perfection",
      0.0
    ],
    [
      "pittoresque",
      0.0
    ],
    [
      "profond",
      0.0
    ],
    [
      "resplendissant",
      0.0
    ],
    [
      "robuste",
      0.0
    ],
    [
      "solide",
      0.0
    ],
    [
      "stupefiant",
      0.0
    ],
    [
      "vertueux",
      0.0
    ],
    [
      "honorable",
      0.0
    ],
    [
      "gras",
      0.0
    ],
    [
      "absolu",
      0.0
    ],
    [
      "biquet",
      0.0
    ],
    [
      "calme",
      0.0
    ],
    [
      "decent",
      0.0
    ],
    [
      "esthetique",
      0.0
    ],
    [
      "fichu",
      0.0
    ],
    [
      "fieffe",
      0.0
    ],
    [
      "flatteur",
      0.0
    ],
    [
      "florissant",
      0.0
    ],
    [
      "feerique",
      0.0
    ],
    [
      "paisible",
      0.0
    ],
    [
      "mirifique",
      0.0
    ],
    [
      "menteur",
      0.0
    ],
    [
      "mensonger",
      0.0
    ],
    [
      "lucratif",
      0.0
    ],
    [
      "grace",
      0.0
    ],
    [
      "poetique",
      0.0
    ],
    [
      "prospere",
      0.0
    ],
    [
      "rupin",
      0.0
    ],
    [
      "saint",
      0.0
    ],
    [
      "super",
      0.0
    ],
    [
      "select",
      0.0
    ],
    [
      "trompeur",
      0.0
    ],
    [
      "vigoureux",
      0.0
    ],
    [
      "etrange",
      0.0
    ],
    [
      "gout",
      0.0
    ],
    [
      "flirt",
      0.0
    ],
    [
      "adequat",
      0.0
    ],
    [
      "ami",
      0.0
    ],
    [
      "approprie",
      0.0
    ],
    [
      "art",
      0.0
    ],
    [
      "astucieux",
      0.0
    ],
    [
      "choisi",
      0.0
    ],
    [
      "faux",
      0.0
    ],
    [
      "estimable",
      0.0
    ],
    [
      "ensoleille",
      0.0
    ],
    [
      "enjoue",
      0.0
    ],
    [
      "celeste",
      0.0
    ],
    [
      "comique",
      0.0
    ],
    [
      "fallacieux",
      0.0
    ],
    [
      "fastueux",
      0.0
    ],
    [
      "fructueux",
      0.0
    ],
    [
      "galantin",
      0.0
    ],
    [
      "gent",
      0.0
    ],
    [
      "girond",
      0.0
    ],
    [
      "magnanime",
      0.0
    ],
    [
      "printanier",
      0.0
    ],
    [
      "sculptural",
      0.0
    ],
    [
      "desirable",
      0.0
    ],
    [
      "dru",
      0.0
    ],
    [
      "dameret",
      0.0
    ],
    [
      "bellissime",
      0.0
    ],
    [
      "bellatre",
      0.0
    ],
    [
      "coureur",
      0.0
    ],
    [
      "cultive",
      0.0
    ],
    [
      "emouvant",
      0.0
    ]
  ],
  "damer": [
    [
      "pilonner",
      0.5
    ],
    [
      "battre",
      0.25
    ],
    [
      "tasser",
      0.25
    ]
  ],
  "dame": [
    [
      "amante",
      0.115
    ],
    [
      "maitresse",
      0.115
    ],
    [
      "femme",
      0.075
    ],
    [
      "parbleu",
      0.0375
    ],
    [
      "pardi",
      0.0375
    ],
    [
      "pilon",
      0.0375
    ],
    [
      "reine",
      0.0375
    ],
    [
      "religieuse",
      0.0375
    ],
    [
      "soeur",
      0.0375
    ],
    [
      "tolet",
      0.0375
    ],
    [
      "oui",
      0.0375
    ],
    [
      "nonne",
      0.0375
    ],
    [
      "madame",
      0.0375
    ],
    [
      "hie",
      0.0375
    ],
    [
      "dulcinee",
      0.0375
    ],
    [
      "bourgeoise",
      0.0375
    ],
    [
      "batte",
      0.0375
    ],
    [
      "atourneuse",
      0.0375
    ],
    [
      "amie",
      0.0375
    ],
    [
      "epouse",
      0.0375
    ]
  ],
  "s'": [],
  "s": [],
  "enfuir": [],
  "je": [
    [
      "ego",
      0.5
    ],
    [
      "moi",
      0.5
    ]
  ],
  "l'": [],
  "l": [],
  "chercher": [
    [
      "rechercher",
      0.0675
    ],
    [
      "examiner",
      0.0625
    ],
    [
      "sonder",
      0.06
    ],
    [
      "etudier",
      0.055
    ],
    [
      "interroger",
      0.0325
    ],
    [
      "viser",
      0.03
    ],
    [
      "solliciter",
      0.03
    ],
    [
      "s'efforcer",
      0.03
    ],
    [
      "essayer",
      0.03
    ],
    [
      "demander",
      0.03
    ],
    [
      "courir",
      0.03
    ],
    [
      "tendre",
      0.025
    ],
    [
      "s'enquerir",
      0.025
    ],
    [
      "poursuivre",
      0.025
    ],
    [
      "fouiller",
      0.025
    ],
    [
      "s'appliquer",
      0.02
    ],
    [
      "s'attacher",
      0.02
    ],
    [
      "tenter",
      0.02
    ],
    [
      "scruter",
      0.015
    ],
    [
      "s'evertuer",
      0.015
    ],
    [
      "reflechir",
      0.015
    ],
    [
      "prospecter",
      0.015
    ],
    [
      "prendre",
      0.015
    ],
    [
      "desirer",
      0.015
    ],
    [
      "consulter",
      0.015
    ],
    [
      "supposer",
      0.0125
    ],
    [
      "s'informer",
      0.0125
    ],
    [
      "faire",
      0.0125
    ],
    [
      "explorer",
      0.0125
    ],
    [
      "aspirer",
      0.0125
    ],
    [
      "analyser",
      0.0125
    ],
    [
      "tacher",
      0.0075
    ],
    [
      "s'ingenier",
      0.0075
    ],
    [
      "risquer",
      0.0075
    ],
    [
      "requerir",
      0.0075
    ],
    [
      "inventer",
      0.0075
    ],
    [
      "imaginer",
      0.0075
    ],
    [
      "fureter",
      0.0075
    ],
    [
      "enqueter",
      0.0075
    ],
    [
      "decouvrir",
      0.0075
    ],
    [
      "querir",
      0.0025
    ],
    [
      "queter",
      0.0025
    ],
    [
      "recuperer",
      0.0025
    ],
    [
      "s'exposer",
      0.0025
    ],
    [
      "tourmenter",
      0.0025
    ],
    [
      "triturer",
      0.0025
    ],
    [
      "intriguer",
      0.0025
    ],
    [
      "fourrager",
      0.0025
    ],
    [
      "atteindre",
      0.0025
    ],
    [
      "calculer",
      0.0025
    ],
    [
      "farfouiller",
      0.0025
    ]
  ],
  "sans": [
    [
      "depourvu",
      0.3325
    ],
    [
      "vide",
      0.3325
    ],
    [
      "exempt",
      0.165
    ],
    [
      "prive",
      0.165
    ]
  ],
  "plaire": [
    [
      "charmer",
      0.085
    ],
    [
      "convenir",
      0.07
    ],
    [
      "captiver",
      0.0625
    ],
    [
      "seduire",
      0.0625
    ],
    [
      "gagner",
      0.0525
    ],
    [
      "flatter",
      0.045
    ],
    [
      "ravir",
      0.0375
    ],
    [
      "enchanter",
      0.0375
    ],
    [
      "aller",
      0.0375
    ],
    [
      "agreer",
      0.0375
    ],
    [
      "amadouer",
      0.03
    ],
    [
      "attirer",
      0.03
    ],
    [
      "exciter",
      0.03
    ],
    [
      "satisfaire",
      0.03
    ],
    [
      "tenter",
      0.03
    ],
    [
      "sourire",
      0.0225
    ],
    [
      "rejouir",
      0.0225
    ],
    [
      "fasciner",
      0.0225
    ],
    [
      "dire",
      0.0225
    ],
    [
      "chanter",
      0.0225
    ],
    [
      "parler",
      0.015
    ],
    [
      "interesser",
      0.015
    ],
    [
      "emballer",
      0.015
    ],
    [
      "contenter",
      0.015
    ],
    [
      "conquerir",
      0.015
    ],
    [
      "complaire",
      0.015
    ],
    [
      "chatouiller",
      0.015
    ],
    [
      "reussir",
      0.005
    ],
    [
      "revenir",
      0.005
    ],
    [
      "cadrer",
      0.005
    ],
    [
      "botter",
      0.005
    ],
    [
      "accommoder",
      0.005
    ]
  ],
  "plus": [
    [
      "charmer",
      0.085
    ],
    [
      "convenir",
      0.07
    ],
    [
      "captiver",
      0.0625
    ],
    [
      "seduire",
      0.0625
    ],
    [
      "gagner",
      0.0525
    ],
    [
      "flatter",
      0.045
    ],
    [
      "ravir",
      0.0375
    ],
    [
      "enchanter",
      0.0375
    ],
    [
      "aller",
      0.0375
    ],
    [
      "agreer",
      0.0375
    ],
    [
      "amadouer",
      0.03
    ],
    [
      "attirer",
      0.03
    ],
    [
      "exciter",
      0.03
    ],
    [
      "satisfaire",
      0.03
    ],
    [
      "tenter",
      0.03
    ],
    [
      "sourire",
      0.0225
    ],
    [
      "rejouir",
      0.0225
    ],
    [
      "fasciner",
      0.0225
    ],
    [
      "dire",
      0.0225
    ],
    [
      "chanter",
      0.0225
    ],
    [
      "parler",
      0.015
    ],
    [
      "interesser",
      0.015
    ],
    [
      "emballer",
      0.015
    ],
    [
      "contenter",
      0.015
    ],
    [
      "conquerir",
      0.015
    ],
    [
      "complaire",
      0.015
    ],
    [
      "chatouiller",
      0.015
    ],
    [
      "reussir",
      0.005
    ],
    [
      "revenir",
      0.005
    ],
    [
      "cadrer",
      0.005
    ],
    [
      "botter",
      0.005
    ],
    [
      "accommoder",
      0.005
    ]
  ],
  "yu": [],
  "y": [],
  "croire": [
    [
      "penser",
      0.115
    ],
    [
      "imaginer",
      0.0725
    ],
    [
      "compter",
      0.0525
    ],
    [
      "estimer",
      0.0525
    ],
    [
      "presumer",
      0.0475
    ],
    [
      "considerer",
      0.0475
    ],
    [
      "juger",
      0.04
    ],
    [
      "supposer",
      0.04
    ],
    [
      "s'attendre",
      0.0325
    ],
    [
      "esperer",
      0.025
    ],
    [
      "accepter",
      0.025
    ],
    [
      "admettre",
      0.02
    ],
    [
      "reputer",
      0.02
    ],
    [
      "soupconner",
      0.02
    ],
    [
      "trouver",
      0.02
    ],
    [
      "ecouter",
      0.0125
    ],
    [
      "s'imaginer",
      0.0125
    ],
    [
      "reconnaitre",
      0.0125
    ],
    [
      "avaler",
      0.0125
    ],
    [
      "attendre",
      0.0125
    ],
    [
      "apprecier",
      0.0125
    ],
    [
      "prejuger",
      0.005
    ],
    [
      "sembler",
      0.005
    ],
    [
      "tromper",
      0.005
    ],
    [
      "marcher",
      0.005
    ],
    [
      "jurer",
      0.005
    ],
    [
      "abuser",
      0.005
    ],
    [
      "adherer",
      0.005
    ],
    [
      "cuider",
      0.005
    ],
    [
      "donner",
      0.005
    ],
    [
      "faillir",
      0.005
    ],
    [
      "gober",
      0.005
    ]
  ],
  "un": [
    [
      "unique",
      0.2375
    ],
    [
      "seul",
      0.19
    ],
    [
      "rare",
      0.0475
    ],
    [
      "quelque",
      0.0475
    ],
    [
      "premier",
      0.0475
    ],
    [
      "isole",
      0.0475
    ],
    [
      "indivis",
      0.0475
    ],
    [
      "exclusif",
      0.0475
    ],
    [
      "distinct",
      0.0475
    ],
    [
      "consubstantiel",
      0.0475
    ],
    [
      "constant",
      0.0475
    ],
    [
      "chacun",
      0.0475
    ],
    [
      "as",
      0.0475
    ],
    [
      "simple",
      0.0475
    ]
  ],
  "espoir": [
    [
      "esperance",
      0.2725
    ],
    [
      "attente",
      0.135
    ],
    [
      "desir",
      0.09
    ],
    [
      "soif",
      0.09
    ],
    [
      "pressentiment",
      0.045
    ],
    [
      "optimisme",
      0.045
    ],
    [
      "expectative",
      0.045
    ],
    [
      "expectance",
      0.045
    ],
    [
      "conviction",
      0.045
    ],
    [
      "certitude",
      0.045
    ],
    [
      "assurance",
      0.045
    ],
    [
      "aspiration",
      0.045
    ],
    [
      "projet",
      0.045
    ]
  ],
  "guider": [
    [
      "conduire",
      0.17
    ],
    [
      "diriger",
      0.14
    ],
    [
      "commander",
      0.07
    ],
    [
      "gouverner",
      0.07
    ],
    [
      "mener",
      0.07
    ],
    [
      "conseiller",
      0.05
    ],
    [
      "piloter",
      0.0375
    ],
    [
      "inspirer",
      0.0375
    ],
    [
      "entrainer",
      0.0375
    ],
    [
      "apprendre",
      0.03
    ],
    [
      "determiner",
      0.03
    ],
    [
      "eduquer",
      0.03
    ],
    [
      "orienter",
      0.0175
    ],
    [
      "manoeuvrer",
      0.0175
    ],
    [
      "indiquer",
      0.0175
    ],
    [
      "cornaquer",
      0.0175
    ],
    [
      "accompagner",
      0.0175
    ],
    [
      "teleguider",
      0.0075
    ],
    [
      "regler",
      0.0075
    ],
    [
      "radioguider",
      0.0075
    ],
    [
      "promener",
      0.0075
    ],
    [
      "manier",
      0.0075
    ],
    [
      "animer",
      0.0075
    ],
    [
      "aiguiller",
      0.0075
    ],
    [
      "aider",
      0.0075
    ],
    [
      "eclairer",
      0.0075
    ]
  ],
  "ne": [
    [
      "poindre",
      0.105
    ],
    [
      "surgir",
      0.085
    ],
    [
      "apparaitre",
      0.0725
    ],
    [
      "venir",
      0.065
    ],
    [
      "percer",
      0.0525
    ],
    [
      "eclore",
      0.045
    ],
    [
      "sortir",
      0.045
    ],
    [
      "paraitre",
      0.045
    ],
    [
      "sourdre",
      0.0325
    ],
    [
      "s'elever",
      0.0325
    ],
    [
      "commencer",
      0.0325
    ],
    [
      "decouler",
      0.025
    ],
    [
      "s'ouvrir",
      0.025
    ],
    [
      "s'eveiller",
      0.02
    ],
    [
      "s'etablir",
      0.02
    ],
    [
      "pointer",
      0.02
    ],
    [
      "partir",
      0.02
    ],
    [
      "croitre",
      0.02
    ],
    [
      "survenir",
      0.0125
    ],
    [
      "s'ebaucher",
      0.0125
    ],
    [
      "s'exciter",
      0.0125
    ],
    [
      "resulter",
      0.0125
    ],
    [
      "provenir",
      0.0125
    ],
    [
      "perler",
      0.0125
    ],
    [
      "germer",
      0.0125
    ],
    [
      "s'organiser",
      0.005
    ],
    [
      "descendre",
      0.005
    ]
  ],
  "n'": [],
  "n": [],
  "garde": [
    [
      "gardien",
      0.095
    ],
    [
      "protection",
      0.0725
    ],
    [
      "sentinelle",
      0.06
    ],
    [
      "surveillance",
      0.0475
    ],
    [
      "surveillant",
      0.0475
    ],
    [
      "veille",
      0.0475
    ],
    [
      "veilleur",
      0.0475
    ],
    [
      "tutelle",
      0.035
    ],
    [
      "soldat",
      0.035
    ],
    [
      "service",
      0.035
    ],
    [
      "guet",
      0.035
    ],
    [
      "cerbere",
      0.035
    ],
    [
      "vigie",
      0.0225
    ],
    [
      "troupe",
      0.0225
    ],
    [
      "soin",
      0.0225
    ],
    [
      "quart",
      0.0225
    ],
    [
      "preservation",
      0.0225
    ],
    [
      "patrouilleur",
      0.0225
    ],
    [
      "infirmiere",
      0.0225
    ],
    [
      "faction",
      0.0225
    ],
    [
      "defense",
      0.0225
    ],
    [
      "conservation",
      0.0225
    ],
    [
      "gardeur",
      0.01
    ],
    [
      "gardiennage",
      0.01
    ],
    [
      "milice",
      0.01
    ],
    [
      "nurse",
      0.01
    ],
    [
      "escorte",
      0.01
    ],
    [
      "depositaire",
      0.01
    ],
    [
      "conservateur",
      0.01
    ],
    [
      "chien",
      0.01
    ],
    [
      "allonge",
      0.01
    ],
    [
      "vigile",
      0.01
    ]
  ],
  "garder": [
    [
      "conserver",
      0.0975
    ],
    [
      "tenir",
      0.0825
    ],
    [
      "preserver",
      0.075
    ],
    [
      "proteger",
      0.06
    ],
    [
      "reserver",
      0.06
    ],
    [
      "maintenir",
      0.0525
    ],
    [
      "sauvegarder",
      0.0375
    ],
    [
      "retenir",
      0.0375
    ],
    [
      "garantir",
      0.0375
    ],
    [
      "defendre",
      0.0275
    ],
    [
      "detenir",
      0.0275
    ],
    [
      "epargner",
      0.0275
    ],
    [
      "economiser",
      0.02
    ],
    [
      "veiller",
      0.02
    ],
    [
      "sauver",
      0.02
    ],
    [
      "rester",
      0.02
    ],
    [
      "respecter",
      0.02
    ],
    [
      "observer",
      0.02
    ],
    [
      "menager",
      0.02
    ],
    [
      "enfermer",
      0.02
    ],
    [
      "consigner",
      0.02
    ],
    [
      "chaperonner",
      0.02
    ],
    [
      "sequestrer",
      0.0125
    ],
    [
      "surveiller",
      0.0125
    ],
    [
      "pratiquer",
      0.0125
    ],
    [
      "entretenir",
      0.0125
    ],
    [
      "demeurer",
      0.0125
    ],
    [
      "barricader",
      0.0125
    ],
    [
      "s'enfermer",
      0.005
    ],
    [
      "receler",
      0.005
    ],
    [
      "premunir",
      0.005
    ],
    [
      "mettre",
      0.005
    ],
    [
      "entreposer",
      0.005
    ],
    [
      "destiner",
      0.005
    ],
    [
      "amasser",
      0.005
    ]
  ],
  "que": [
    [
      "combien",
      0.25
    ],
    [
      "comme",
      0.25
    ],
    [
      "ne",
      0.25
    ],
    [
      "pourquoi",
      0.25
    ]
  ],
  "ce": [],
  "une": [
    [
      "unique",
      0.2375
    ],
    [
      "seul",
      0.19
    ],
    [
      "rare",
      0.0475
    ],
    [
      "quelque",
      0.0475
    ],
    [
      "premier",
      0.0475
    ],
    [
      "isole",
      0.0475
    ],
    [
      "indivis",
      0.0475
    ],
    [
      "exclusif",
      0.0475
    ],
    [
      "distinct",
      0.0475
    ],
    [
      "consubstantiel",
      0.0475
    ],
    [
      "constant",
      0.0475
    ],
    [
      "chacun",
      0.0475
    ],
    [
      "as",
      0.0475
    ],
    [
      "simple",
      0.0475
    ]
  ],
  "epave": [
    [
      "debris",
      0.3175
    ],
    [
      "ruine",
      0.21
    ],
    [
      "bribe",
      0.105
    ],
    [
      "reste",
      0.105
    ],
    [
      "decadence",
      0.05
    ],
    [
      "dechet",
      0.05
    ],
    [
      "decombres",
      0.05
    ],
    [
      "loque",
      0.05
    ],
    [
      "morceau",
      0.05
    ]
  ],
  "mouiller": [
    [
      "arroser",
      0.1275
    ],
    [
      "tremper",
      0.1175
    ],
    [
      "humecter",
      0.0975
    ],
    [
      "imbiber",
      0.0775
    ],
    [
      "asperger",
      0.0475
    ],
    [
      "laver",
      0.0375
    ],
    [
      "inonder",
      0.0375
    ],
    [
      "doucher",
      0.0375
    ],
    [
      "couper",
      0.0375
    ],
    [
      "baigner",
      0.0375
    ],
    [
      "delaver",
      0.0275
    ],
    [
      "bassiner",
      0.0275
    ],
    [
      "abreuver",
      0.0275
    ],
    [
      "arreter",
      0.0175
    ],
    [
      "baptiser",
      0.0175
    ],
    [
      "rincer",
      0.0175
    ],
    [
      "oindre",
      0.0075
    ],
    [
      "palataliser",
      0.0075
    ],
    [
      "saturer",
      0.0075
    ],
    [
      "saucer",
      0.0075
    ],
    [
      "stopper",
      0.0075
    ],
    [
      "submerger",
      0.0075
    ],
    [
      "transpercer",
      0.0075
    ],
    [
      "eclabousser",
      0.0075
    ],
    [
      "meler",
      0.0075
    ],
    [
      "madefier",
      0.0075
    ],
    [
      "humidifier",
      0.0075
    ],
    [
      "ancrer",
      0.0075
    ],
    [
      "baver",
      0.0075
    ],
    [
      "desservir",
      0.0075
    ],
    [
      "diluer",
      0.0075
    ],
    [
      "detremper",
      0.0075
    ],
    [
      "emboire",
      0.0075
    ],
    [
      "embosser",
      0.0075
    ],
    [
      "embuer",
      0.0075
    ],
    [
      "etendre",
      0.0075
    ]
  ],
  "mouille": [
    [
      "fesse",
      0.5
    ],
    [
      "trempe",
      0.5
    ]
  ],
  "et": [
    [
      "alors",
      0.1425
    ],
    [
      "avec",
      0.1425
    ],
    [
      "comme",
      0.1425
    ],
    [
      "mais",
      0.1425
    ],
    [
      "plus",
      0.1425
    ],
    [
      "pourtant",
      0.1425
    ],
    [
      "puis",
      0.1425
    ]
  ],
  "oh": [
    [
      "ho",
      0.3325
    ],
    [
      "hola",
      0.3325
    ],
    [
      "ohe",
      0.3325
    ]
  ],
  "moi": [
    [
      "personnalite",
      0.21
    ],
    [
      "ame",
      0.1575
    ],
    [
      "individu",
      0.1025
    ],
    [
      "individualite",
      0.1025
    ],
    [
      "personne",
      0.1025
    ],
    [
      "me",
      0.05
    ],
    [
      "je",
      0.05
    ],
    [
      "esprit",
      0.05
    ],
    [
      "ego",
      0.05
    ],
    [
      "bibi",
      0.05
    ],
    [
      "self",
      0.05
    ]
  ],
  "d": [],
  "d'": [],
  "ou": [
    [
      "soit",
      1.0
    ]
  ],
  "venir": [
    [
      "provenir",
      0.055
    ],
    [
      "sortir",
      0.055
    ],
    [
      "arriver",
      0.0525
    ],
    [
      "decouler",
      0.04
    ],
    [
      "proceder",
      0.04
    ],
    [
      "tomber",
      0.04
    ],
    [
      "naitre",
      0.035
    ],
    [
      "surgir",
      0.0325
    ],
    [
      "suivre",
      0.0325
    ],
    [
      "resulter",
      0.0275
    ],
    [
      "apparaitre",
      0.025
    ],
    [
      "avancer",
      0.025
    ],
    [
      "marcher",
      0.025
    ],
    [
      "emaner",
      0.02
    ],
    [
      "passer",
      0.02
    ],
    [
      "partir",
      0.02
    ],
    [
      "descendre",
      0.02
    ],
    [
      "approcher",
      0.02
    ],
    [
      "survenir",
      0.0175
    ],
    [
      "pousser",
      0.0175
    ],
    [
      "aborder",
      0.0175
    ],
    [
      "reussir",
      0.0125
    ],
    [
      "parvenir",
      0.0125
    ],
    [
      "deriver",
      0.0125
    ],
    [
      "tenir",
      0.01
    ],
    [
      "s'avancer",
      0.01
    ],
    [
      "s'approcher",
      0.01
    ],
    [
      "s'amener",
      0.01
    ],
    [
      "s'abouler",
      0.01
    ],
    [
      "remonter",
      0.01
    ],
    [
      "pointer",
      0.01
    ],
    [
      "entrer",
      0.01
    ],
    [
      "dependre",
      0.01
    ],
    [
      "s'offrir",
      0.005
    ],
    [
      "rappliquer",
      0.005
    ],
    [
      "radiner",
      0.005
    ],
    [
      "grandir",
      0.005
    ],
    [
      "debarquer",
      0.005
    ],
    [
      "croitre",
      0.005
    ],
    [
      "aboutir",
      0.005
    ],
    [
      "succeder",
      0.0025
    ],
    [
      "echoir",
      0.0025
    ],
    [
      "s'aviser",
      0.0025
    ],
    [
      "intervenir",
      0.0025
    ],
    [
      "dater",
      0.0025
    ]
  ],
  "savoir": [
    [
      "connaissance",
      0.0975
    ],
    [
      "bagage",
      0.0875
    ],
    [
      "science",
      0.0675
    ],
    [
      "instruction",
      0.0575
    ],
    [
      "capacite",
      0.0475
    ],
    [
      "culture",
      0.0475
    ],
    [
      "intelligence",
      0.0475
    ],
    [
      "genie",
      0.0375
    ],
    [
      "experience",
      0.0375
    ],
    [
      "connaissances",
      0.0375
    ],
    [
      "competence",
      0.0375
    ],
    [
      "erudition",
      0.0275
    ],
    [
      "imagination",
      0.0275
    ],
    [
      "formation",
      0.0275
    ],
    [
      "acquis",
      0.0275
    ],
    [
      "sagesse",
      0.0175
    ],
    [
      "lumiere",
      0.0175
    ],
    [
      "litterature",
      0.0175
    ],
    [
      "lettres",
      0.0175
    ],
    [
      "humanisme",
      0.0175
    ],
    [
      "conception",
      0.0175
    ],
    [
      "ballot",
      0.0175
    ],
    [
      "aptitude",
      0.0175
    ],
    [
      "pouvoir",
      0.0075
    ],
    [
      "omniscience",
      0.0075
    ],
    [
      "notions",
      0.0075
    ],
    [
      "memoire",
      0.0075
    ],
    [
      "lettre",
      0.0075
    ],
    [
      "lecture",
      0.0075
    ],
    [
      "gnose",
      0.0075
    ],
    [
      "doctrine",
      0.0075
    ],
    [
      "croyance",
      0.0075
    ],
    [
      "cognition",
      0.0075
    ],
    [
      "pratique",
      0.0075
    ]
  ],
  "aller": [
    [
      "marcher",
      0.065
    ],
    [
      "courir",
      0.0375
    ],
    [
      "passer",
      0.0375
    ],
    [
      "gagner",
      0.0325
    ],
    [
      "convenir",
      0.0275
    ],
    [
      "aboutir",
      0.025
    ],
    [
      "arriver",
      0.0225
    ],
    [
      "prendre",
      0.0225
    ],
    [
      "avancer",
      0.02
    ],
    [
      "toucher",
      0.0175
    ],
    [
      "tendre",
      0.0175
    ],
    [
      "monter",
      0.0175
    ],
    [
      "tomber",
      0.015
    ],
    [
      "tirer",
      0.015
    ],
    [
      "s'acheminer",
      0.015
    ],
    [
      "pousser",
      0.015
    ],
    [
      "piquer",
      0.015
    ],
    [
      "deambuler",
      0.015
    ],
    [
      "atteindre",
      0.015
    ],
    [
      "progresser",
      0.0125
    ],
    [
      "filer",
      0.0125
    ],
    [
      "errer",
      0.0125
    ],
    [
      "concorder",
      0.0125
    ],
    [
      "cadrer",
      0.0125
    ],
    [
      "affluer",
      0.0125
    ],
    [
      "voyager",
      0.01
    ],
    [
      "voler",
      0.01
    ],
    [
      "poursuivre",
      0.01
    ],
    [
      "plaire",
      0.01
    ],
    [
      "s'accorder",
      0.0075
    ],
    [
      "interesser",
      0.0075
    ],
    [
      "gazer",
      0.0075
    ],
    [
      "entrer",
      0.0075
    ],
    [
      "conduire",
      0.0075
    ],
    [
      "coller",
      0.0075
    ],
    [
      "cheminer",
      0.0075
    ],
    [
      "s'ajuster",
      0.005
    ],
    [
      "s'harmoniser",
      0.005
    ],
    [
      "traverser",
      0.005
    ],
    [
      "evoluer",
      0.005
    ],
    [
      "s'adresser",
      0.005
    ],
    [
      "s'adapter",
      0.005
    ],
    [
      "botter",
      0.005
    ],
    [
      "devancer",
      0.005
    ],
    [
      "distancer",
      0.005
    ],
    [
      "deriver",
      0.005
    ],
    [
      "penetrer",
      0.005
    ],
    [
      "proceder",
      0.0025
    ],
    [
      "preceder",
      0.0025
    ],
    [
      "retourner",
      0.0025
    ],
    [
      "s'approcher",
      0.0025
    ],
    [
      "s'ecouler",
      0.0025
    ],
    [
      "s'elever",
      0.0025
    ],
    [
      "seoir",
      0.0025
    ],
    [
      "solliciter",
      0.0025
    ],
    [
      "obliquer",
      0.0025
    ],
    [
      "mener",
      0.0025
    ],
    [
      "agreer",
      0.0025
    ],
    [
      "bicher",
      0.0025
    ],
    [
      "cingler",
      0.0025
    ],
    [
      "continuer",
      0.0025
    ],
    [
      "converger",
      0.0025
    ],
    [
      "correspondre",
      0.0025
    ],
    [
      "desservir",
      0.0025
    ],
    [
      "devier",
      0.0025
    ],
    [
      "habiller",
      0.0025
    ],
    [
      "peregriner",
      0.0
    ],
    [
      "refluer",
      0.0
    ],
    [
      "saquer",
      0.0
    ],
    [
      "sourire",
      0.0
    ],
    [
      "vaguer",
      0.0
    ],
    [
      "etre",
      0.0
    ],
    [
      "parcourir",
      0.0
    ],
    [
      "galoper",
      0.0
    ],
    [
      "accompagner",
      0.0
    ],
    [
      "baguenauder",
      0.0
    ],
    [
      "biaiser",
      0.0
    ],
    [
      "concerner",
      0.0
    ],
    [
      "fonctionner",
      0.0
    ],
    [
      "frequenter",
      0.0
    ]
  ],
  "dire": [
    [
      "declaration",
      0.21
    ],
    [
      "allegation",
      0.1575
    ],
    [
      "propos",
      0.1575
    ],
    [
      "affirmation",
      0.105
    ],
    [
      "parole",
      0.105
    ],
    [
      "rapport",
      0.05
    ],
    [
      "parler",
      0.05
    ],
    [
      "bruit",
      0.05
    ],
    [
      "assertion",
      0.05
    ],
    [
      "revelation",
      0.05
    ]
  ],
  "dit": [
    [
      "reveler",
      0.0625
    ],
    [
      "declarer",
      0.055
    ],
    [
      "signaler",
      0.0475
    ],
    [
      "indiquer",
      0.0425
    ],
    [
      "montrer",
      0.0425
    ],
    [
      "exprimer",
      0.035
    ],
    [
      "publier",
      0.0325
    ],
    [
      "exposer",
      0.03
    ],
    [
      "annoncer",
      0.0225
    ],
    [
      "raconter",
      0.02
    ],
    [
      "signifier",
      0.02
    ],
    [
      "temoigner",
      0.02
    ],
    [
      "affirmer",
      0.02
    ],
    [
      "donner",
      0.02
    ],
    [
      "prononcer",
      0.0175
    ],
    [
      "communiquer",
      0.0175
    ],
    [
      "manifester",
      0.0175
    ],
    [
      "expliquer",
      0.015
    ],
    [
      "decouvrir",
      0.015
    ],
    [
      "enoncer",
      0.0125
    ],
    [
      "parler",
      0.0125
    ],
    [
      "faire",
      0.0125
    ],
    [
      "debiter",
      0.0125
    ],
    [
      "apprendre",
      0.01
    ],
    [
      "rapporter",
      0.01
    ],
    [
      "crier",
      0.01
    ],
    [
      "porter",
      0.01
    ],
    [
      "assurer",
      0.01
    ],
    [
      "decider",
      0.0075
    ],
    [
      "determiner",
      0.0075
    ],
    [
      "informer",
      0.0075
    ],
    [
      "sortir",
      0.005
    ],
    [
      "repandre",
      0.005
    ],
    [
      "proferer",
      0.005
    ],
    [
      "marquer",
      0.005
    ],
    [
      "divulguer",
      0.005
    ],
    [
      "avertir",
      0.005
    ],
    [
      "trahir",
      0.005
    ],
    [
      "repondre",
      0.005
    ],
    [
      "retracer",
      0.005
    ],
    [
      "lancer",
      0.005
    ],
    [
      "chanter",
      0.005
    ],
    [
      "emettre",
      0.005
    ],
    [
      "soutenir",
      0.005
    ],
    [
      "souffler",
      0.005
    ],
    [
      "sommer",
      0.005
    ],
    [
      "pretendre",
      0.005
    ],
    [
      "ordonner",
      0.005
    ],
    [
      "nommer",
      0.005
    ],
    [
      "jurer",
      0.005
    ],
    [
      "devoiler",
      0.005
    ],
    [
      "demander",
      0.005
    ],
    [
      "certifier",
      0.005
    ],
    [
      "trancher",
      0.0025
    ],
    [
      "solliciter",
      0.0025
    ],
    [
      "revendiquer",
      0.0025
    ],
    [
      "recommander",
      0.0025
    ],
    [
      "conseiller",
      0.0025
    ],
    [
      "commander",
      0.0025
    ],
    [
      "bavarder",
      0.0025
    ],
    [
      "enumerer",
      0.0025
    ],
    [
      "specifier",
      0.0025
    ],
    [
      "requerir",
      0.0025
    ],
    [
      "protester",
      0.0025
    ],
    [
      "propager",
      0.0025
    ],
    [
      "designer",
      0.0025
    ],
    [
      "denoter",
      0.0025
    ],
    [
      "degoiser",
      0.0025
    ],
    [
      "convenir",
      0.0025
    ],
    [
      "conter",
      0.0025
    ],
    [
      "confier",
      0.0025
    ],
    [
      "colporter",
      0.0025
    ],
    [
      "plaire",
      0.0
    ],
    [
      "relater",
      0.0
    ],
    [
      "renseigner",
      0.0
    ],
    [
      "reciter",
      0.0
    ],
    [
      "souhaiter",
      0.0
    ],
    [
      "stipuler",
      0.0
    ],
    [
      "vomir",
      0.0
    ],
    [
      "observer",
      0.0
    ],
    [
      "murmurer",
      0.0
    ],
    [
      "articuler",
      0.0
    ],
    [
      "avouer",
      0.0
    ],
    [
      "balancer",
      0.0
    ],
    [
      "declamer",
      0.0
    ],
    [
      "jaser",
      0.0
    ],
    [
      "lire",
      0.0
    ],
    [
      "lacher",
      0.0
    ],
    [
      "professer",
      0.0
    ],
    [
      "preconiser",
      0.0
    ],
    [
      "prevenir",
      0.0
    ],
    [
      "prevoir",
      0.0
    ],
    [
      "repliquer",
      0.0
    ],
    [
      "tenter",
      0.0
    ],
    [
      "pressentir",
      0.0
    ],
    [
      "persuader",
      0.0
    ],
    [
      "confirmer",
      0.0
    ],
    [
      "enjoindre",
      0.0
    ],
    [
      "formuler",
      0.0
    ],
    [
      "juger",
      0.0
    ],
    [
      "medire",
      0.0
    ],
    [
      "opposer",
      0.0
    ],
    [
      "tomber",
      0.0
    ],
    [
      "s'ecrier",
      0.0
    ],
    [
      "retorquer",
      0.0
    ],
    [
      "narrer",
      0.0
    ],
    [
      "interjecter",
      0.0
    ],
    [
      "enfiler",
      0.0
    ],
    [
      "disserter",
      0.0
    ],
    [
      "chuchoter",
      0.0
    ],
    [
      "ajouter",
      0.0
    ],
    [
      "ebruiter",
      0.0
    ]
  ],
  "on": [
    [
      "personne",
      0.5
    ],
    [
      "quelqu'un",
      0.5
    ]
  ],
  "bien": [
    [
      "bon",
      0.0475
    ],
    [
      "beau",
      0.0375
    ],
    [
      "beaucoup",
      0.025
    ],
    [
      "tres",
      0.0225
    ],
    [
      "honnete",
      0.0225
    ],
    [
      "convenable",
      0.0175
    ],
    [
      "propriete",
      0.015
    ],
    [
      "avantage",
      0.015
    ],
    [
      "agreable",
      0.0125
    ],
    [
      "bienfait",
      0.0125
    ],
    [
      "extremement",
      0.0125
    ],
    [
      "benefice",
      0.0125
    ],
    [
      "parfaitement",
      0.01
    ],
    [
      "joliment",
      0.01
    ],
    [
      "faveur",
      0.01
    ],
    [
      "capital",
      0.01
    ],
    [
      "absolument",
      0.01
    ],
    [
      "bonheur",
      0.01
    ],
    [
      "ferme",
      0.01
    ],
    [
      "grace",
      0.01
    ],
    [
      "honorable",
      0.01
    ],
    [
      "sortable",
      0.0075
    ],
    [
      "service",
      0.0075
    ],
    [
      "possession",
      0.0075
    ],
    [
      "juste",
      0.0075
    ],
    [
      "correct",
      0.0075
    ],
    [
      "bonte",
      0.0075
    ],
    [
      "elegant",
      0.0075
    ],
    [
      "vraiment",
      0.0075
    ],
    [
      "vertu",
      0.0075
    ],
    [
      "profit",
      0.0075
    ],
    [
      "patrimoine",
      0.0075
    ],
    [
      "parfait",
      0.0075
    ],
    [
      "don",
      0.0075
    ],
    [
      "bougrement",
      0.0075
    ],
    [
      "richesse",
      0.005
    ],
    [
      "secours",
      0.005
    ],
    [
      "seyant",
      0.005
    ],
    [
      "serieusement",
      0.005
    ],
    [
      "totalement",
      0.005
    ],
    [
      "utilite",
      0.005
    ],
    [
      "valeur",
      0.005
    ],
    [
      "pleinement",
      0.005
    ],
    [
      "oui",
      0.005
    ],
    [
      "ideal",
      0.005
    ],
    [
      "bigrement",
      0.005
    ],
    [
      "charite",
      0.005
    ],
    [
      "digne",
      0.005
    ],
    [
      "domaine",
      0.005
    ],
    [
      "droit",
      0.005
    ],
    [
      "entierement",
      0.005
    ],
    [
      "heureux",
      0.005
    ],
    [
      "vachement",
      0.005
    ],
    [
      "perfection",
      0.005
    ],
    [
      "honnetement",
      0.005
    ],
    [
      "fortune",
      0.005
    ],
    [
      "chose",
      0.005
    ],
    [
      "avoir",
      0.005
    ],
    [
      "profondement",
      0.0025
    ],
    [
      "propice",
      0.0025
    ],
    [
      "prosperite",
      0.0025
    ],
    [
      "remarquablement",
      0.0025
    ],
    [
      "satisfaisant",
      0.0025
    ],
    [
      "sensiblement",
      0.0025
    ],
    [
      "succes",
      0.0025
    ],
    [
      "veritablement",
      0.0025
    ],
    [
      "elegamment",
      0.0025
    ],
    [
      "merveilleusement",
      0.0025
    ],
    [
      "joli",
      0.0025
    ],
    [
      "interet",
      0.0025
    ],
    [
      "aimable",
      0.0025
    ],
    [
      "aisement",
      0.0025
    ],
    [
      "assurement",
      0.0025
    ],
    [
      "chic",
      0.0025
    ],
    [
      "completement",
      0.0025
    ],
    [
      "convenablement",
      0.0025
    ],
    [
      "correctement",
      0.0025
    ],
    [
      "distingue",
      0.0025
    ],
    [
      "drolement",
      0.0025
    ],
    [
      "intensement",
      0.0025
    ],
    [
      "nettement",
      0.0025
    ],
    [
      "morale",
      0.0025
    ],
    [
      "louable",
      0.0025
    ],
    [
      "largement",
      0.0025
    ],
    [
      "justice",
      0.0025
    ],
    [
      "honneur",
      0.0025
    ],
    [
      "heureusement",
      0.0025
    ],
    [
      "produit",
      0.0025
    ],
    [
      "proprement",
      0.0025
    ],
    [
      "raisonnablement",
      0.0025
    ],
    [
      "reellement",
      0.0025
    ],
    [
      "soigneusement",
      0.0025
    ],
    [
      "serieux",
      0.0025
    ],
    [
      "sur",
      0.0025
    ],
    [
      "surement",
      0.0025
    ],
    [
      "tout",
      0.0025
    ],
    [
      "vivement",
      0.0025
    ],
    [
      "habilement",
      0.0025
    ],
    [
      "gracieusement",
      0.0025
    ],
    [
      "felicite",
      0.0025
    ],
    [
      "admirablement",
      0.0025
    ],
    [
      "agreablement",
      0.0025
    ],
    [
      "amplement",
      0.0025
    ],
    [
      "apanage",
      0.0025
    ],
    [
      "avantageusement",
      0.0025
    ],
    [
      "bellement",
      0.0025
    ],
    [
      "benediction",
      0.0025
    ],
    [
      "considerablement",
      0.0025
    ],
    [
      "fort",
      0.0025
    ],
    [
      "formidablement",
      0.0025
    ],
    [
      "fonds",
      0.0025
    ],
    [
      "fait",
      0.0025
    ],
    [
      "excellemment",
      0.0025
    ],
    [
      "estimable",
      0.0025
    ],
    [
      "dignement",
      0.0025
    ],
    [
      "rente",
      0.0
    ],
    [
      "purement",
      0.0
    ],
    [
      "noblement",
      0.0
    ],
    [
      "moral",
      0.0
    ],
    [
      "logiquement",
      0.0
    ],
    [
      "integralement",
      0.0
    ],
    [
      "impeccablement",
      0.0
    ],
    [
      "sagement",
      0.0
    ],
    [
      "soulagement",
      0.0
    ],
    [
      "select",
      0.0
    ],
    [
      "eminemment",
      0.0
    ],
    [
      "volontiers",
      0.0
    ],
    [
      "violemment",
      0.0
    ],
    [
      "terre",
      0.0
    ],
    [
      "immeuble",
      0.0
    ],
    [
      "honorablement",
      0.0
    ],
    [
      "gentiment",
      0.0
    ],
    [
      "choisi",
      0.0
    ],
    [
      "chance",
      0.0
    ],
    [
      "certes",
      0.0
    ],
    [
      "bath",
      0.0
    ],
    [
      "argent",
      0.0
    ],
    [
      "approximativement",
      0.0
    ],
    [
      "adroitement",
      0.0
    ],
    [
      "acquet",
      0.0
    ],
    [
      "commode",
      0.0
    ],
    [
      "confortablement",
      0.0
    ],
    [
      "consciencieux",
      0.0
    ],
    [
      "fruit",
      0.0
    ],
    [
      "formellement",
      0.0
    ],
    [
      "fermement",
      0.0
    ],
    [
      "excellent",
      0.0
    ],
    [
      "environ",
      0.0
    ],
    [
      "effectivement",
      0.0
    ],
    [
      "dument",
      0.0
    ],
    [
      "devoir",
      0.0
    ],
    [
      "present",
      0.0
    ],
    [
      "prudemment",
      0.0
    ],
    [
      "methodiquement",
      0.0
    ],
    [
      "magistralement",
      0.0
    ],
    [
      "judicieux",
      0.0
    ],
    [
      "judicieusement",
      0.0
    ],
    [
      "heritage",
      0.0
    ],
    [
      "rationnellement",
      0.0
    ],
    [
      "recolte",
      0.0
    ],
    [
      "salement",
      0.0
    ],
    [
      "utilement",
      0.0
    ],
    [
      "trop",
      0.0
    ],
    [
      "succession",
      0.0
    ],
    [
      "soit",
      0.0
    ],
    [
      "satisfaction",
      0.0
    ],
    [
      "favorablement",
      0.0
    ],
    [
      "fameusement",
      0.0
    ],
    [
      "expressement",
      0.0
    ],
    [
      "bravo",
      0.0
    ],
    [
      "bonnement",
      0.0
    ],
    [
      "attentivement",
      0.0
    ],
    [
      "artistement",
      0.0
    ],
    [
      "achevement",
      0.0
    ],
    [
      "cheptel",
      0.0
    ],
    [
      "commodement",
      0.0
    ],
    [
      "dotation",
      0.0
    ],
    [
      "divin",
      0.0
    ],
    [
      "couramment",
      0.0
    ],
    [
      "copieusement",
      0.0
    ],
    [
      "conquete",
      0.0
    ],
    [
      "conquet",
      0.0
    ],
    [
      "competent",
      0.0
    ],
    [
      "O.K.",
      0.0
    ]
  ],
  "finir": [
    [
      "terminer",
      0.075
    ],
    [
      "cesser",
      0.0625
    ],
    [
      "mourir",
      0.04
    ],
    [
      "achever",
      0.0375
    ],
    [
      "disparaitre",
      0.0375
    ],
    [
      "tomber",
      0.035
    ],
    [
      "s'eteindre",
      0.035
    ],
    [
      "arreter",
      0.0325
    ],
    [
      "expirer",
      0.0325
    ],
    [
      "passer",
      0.0325
    ],
    [
      "parfaire",
      0.0225
    ],
    [
      "s'evanouir",
      0.0225
    ],
    [
      "conclure",
      0.02
    ],
    [
      "interrompre",
      0.02
    ],
    [
      "parachever",
      0.02
    ],
    [
      "s'achever",
      0.0175
    ],
    [
      "abandonner",
      0.0175
    ],
    [
      "trancher",
      0.015
    ],
    [
      "regler",
      0.015
    ],
    [
      "fignoler",
      0.015
    ],
    [
      "clore",
      0.015
    ],
    [
      "arranger",
      0.015
    ],
    [
      "aboutir",
      0.015
    ],
    [
      "vider",
      0.0125
    ],
    [
      "s'arreter",
      0.0125
    ],
    [
      "rompre",
      0.0125
    ],
    [
      "perir",
      0.0125
    ],
    [
      "polir",
      0.0125
    ],
    [
      "couronner",
      0.0125
    ],
    [
      "succomber",
      0.0075
    ],
    [
      "lecher",
      0.0075
    ],
    [
      "decliner",
      0.0075
    ],
    [
      "consommer",
      0.0075
    ],
    [
      "epuiser",
      0.005
    ],
    [
      "user",
      0.005
    ],
    [
      "trepasser",
      0.005
    ],
    [
      "tourner",
      0.005
    ],
    [
      "tarir",
      0.005
    ],
    [
      "partir",
      0.005
    ],
    [
      "fermer",
      0.005
    ],
    [
      "ameliorer",
      0.005
    ],
    [
      "aneantir",
      0.005
    ],
    [
      "ciseler",
      0.005
    ],
    [
      "completer",
      0.005
    ],
    [
      "couper",
      0.005
    ],
    [
      "decider",
      0.005
    ],
    [
      "resoudre",
      0.0025
    ],
    [
      "limer",
      0.0025
    ],
    [
      "expedier",
      0.0025
    ],
    [
      "cloturer",
      0.0025
    ],
    [
      "bacler",
      0.0025
    ],
    [
      "arriver",
      0.0025
    ],
    [
      "ajuster",
      0.0025
    ],
    [
      "accomplir",
      0.0025
    ],
    [
      "s'amenuiser",
      0.0
    ],
    [
      "s'interrompre",
      0.0
    ],
    [
      "lamper",
      0.0
    ],
    [
      "entonner",
      0.0
    ],
    [
      "deceder",
      0.0
    ],
    [
      "durer",
      0.0
    ],
    [
      "discontinuer",
      0.0
    ],
    [
      "accommoder",
      0.0
    ]
  ],
  "toujours": [
    [
      "continuellement",
      0.1175
    ],
    [
      "constamment",
      0.095
    ],
    [
      "eternellement",
      0.0625
    ],
    [
      "perpetuellement",
      0.03
    ],
    [
      "indefiniment",
      0.03
    ],
    [
      "ordinairement",
      0.02
    ],
    [
      "neanmoins",
      0.02
    ],
    [
      "invariablement",
      0.02
    ],
    [
      "incessamment",
      0.02
    ],
    [
      "habituellement",
      0.02
    ],
    [
      "assidument",
      0.02
    ],
    [
      "cependant",
      0.02
    ],
    [
      "continument",
      0.02
    ],
    [
      "encore",
      0.02
    ],
    [
      "sempiternellement",
      0.01
    ],
    [
      "infiniment",
      0.01
    ],
    [
      "generalement",
      0.01
    ]
  ],
  "par": [
    [
      "avec",
      0.145
    ],
    [
      "dans",
      0.125
    ],
    [
      "en",
      0.125
    ],
    [
      "pendant",
      0.1025
    ],
    [
      "sur",
      0.0825
    ],
    [
      "de",
      0.0625
    ],
    [
      "a",
      0.04
    ],
    [
      "durant",
      0.02
    ],
    [
      "via",
      0.02
    ]
  ],
  "trouver": [
    [
      "decouvrir",
      0.0925
    ],
    [
      "saisir",
      0.0675
    ],
    [
      "deviner",
      0.0525
    ],
    [
      "voir",
      0.0525
    ],
    [
      "imaginer",
      0.0475
    ],
    [
      "juger",
      0.0475
    ],
    [
      "reperer",
      0.0425
    ],
    [
      "comprendre",
      0.04
    ],
    [
      "penser",
      0.035
    ],
    [
      "apercevoir",
      0.035
    ],
    [
      "concevoir",
      0.025
    ],
    [
      "rencontrer",
      0.025
    ],
    [
      "atteindre",
      0.02
    ],
    [
      "percer",
      0.02
    ],
    [
      "reconnaitre",
      0.02
    ],
    [
      "surprendre",
      0.015
    ],
    [
      "inventer",
      0.015
    ],
    [
      "estimer",
      0.015
    ],
    [
      "dechiffrer",
      0.015
    ],
    [
      "deceler",
      0.015
    ],
    [
      "considerer",
      0.015
    ],
    [
      "eprouver",
      0.0125
    ],
    [
      "toucher",
      0.0125
    ],
    [
      "retrouver",
      0.0125
    ],
    [
      "regarder",
      0.0125
    ],
    [
      "joindre",
      0.0125
    ],
    [
      "croire",
      0.0125
    ],
    [
      "sentir",
      0.0075
    ],
    [
      "s'aviser",
      0.0075
    ],
    [
      "resoudre",
      0.0075
    ],
    [
      "relever",
      0.0075
    ],
    [
      "rejoindre",
      0.0075
    ],
    [
      "pincer",
      0.0075
    ],
    [
      "obtenir",
      0.0075
    ],
    [
      "denicher",
      0.0075
    ],
    [
      "creer",
      0.0075
    ],
    [
      "acquerir",
      0.0075
    ],
    [
      "procurer",
      0.0025
    ],
    [
      "pecher",
      0.0025
    ],
    [
      "reussir",
      0.0025
    ],
    [
      "elucider",
      0.0025
    ],
    [
      "mettre",
      0.0025
    ],
    [
      "innover",
      0.0025
    ],
    [
      "forger",
      0.0025
    ],
    [
      "deterrer",
      0.0025
    ],
    [
      "detecter",
      0.0025
    ],
    [
      "desapprouver",
      0.0025
    ],
    [
      "degoter",
      0.0025
    ],
    [
      "cueillir",
      0.0025
    ],
    [
      "avoir",
      0.0025
    ]
  ],
  "est": [
    [
      "aurore",
      0.25
    ],
    [
      "levant",
      0.25
    ],
    [
      "orient",
      0.25
    ],
    [
      "oriental",
      0.25
    ]
  ],
  "jamais": [
    [
      "ne",
      0.25
    ],
    [
      "onques",
      0.25
    ]
  ],
  "tres": [
    [
      "extremement",
      0.125
    ],
    [
      "beaucoup",
      0.1025
    ],
    [
      "excessivement",
      0.065
    ],
    [
      "terriblement",
      0.0625
    ],
    [
      "bien",
      0.0575
    ],
    [
      "extraordinairement",
      0.055
    ],
    [
      "joliment",
      0.0375
    ],
    [
      "prodigieusement",
      0.035
    ],
    [
      "formidablement",
      0.0325
    ],
    [
      "diablement",
      0.0275
    ],
    [
      "enormement",
      0.0275
    ],
    [
      "drolement",
      0.025
    ],
    [
      "bigrement",
      0.025
    ],
    [
      "infiniment",
      0.0225
    ],
    [
      "vachement",
      0.0225
    ],
    [
      "parfaitement",
      0.015
    ],
    [
      "incroyablement",
      0.015
    ],
    [
      "fort",
      0.015
    ],
    [
      "follement",
      0.015
    ],
    [
      "trop",
      0.0125
    ],
    [
      "superieurement",
      0.0125
    ],
    [
      "rudement",
      0.0125
    ],
    [
      "merveilleusement",
      0.0125
    ],
    [
      "immensement",
      0.0125
    ],
    [
      "horriblement",
      0.0125
    ],
    [
      "furieusement",
      0.0125
    ],
    [
      "vraiment",
      0.0075
    ],
    [
      "serieusement",
      0.0075
    ],
    [
      "fortement",
      0.0075
    ],
    [
      "effroyablement",
      0.0075
    ],
    [
      "absolument",
      0.0075
    ],
    [
      "tout",
      0.005
    ],
    [
      "remarquablement",
      0.005
    ],
    [
      "pleinement",
      0.005
    ],
    [
      "genereusement",
      0.005
    ],
    [
      "assez",
      0.0025
    ],
    [
      "extra",
      0.0025
    ],
    [
      "hautement",
      0.0025
    ],
    [
      "richement",
      0.0025
    ],
    [
      "rien",
      0.0025
    ]
  ],
  "loin": [
    [
      "eloigne",
      0.2725
    ],
    [
      "apres",
      0.09
    ],
    [
      "avant",
      0.09
    ],
    [
      "dehors",
      0.09
    ],
    [
      "distant",
      0.09
    ],
    [
      "haut",
      0.09
    ],
    [
      "tard",
      0.09
    ],
    [
      "vieux",
      0.09
    ]
  ],
  "partir": [
    [
      "s'enfuir",
      0.095
    ],
    [
      "fuir",
      0.0625
    ],
    [
      "deguerpir",
      0.06
    ],
    [
      "decamper",
      0.04
    ],
    [
      "sortir",
      0.0375
    ],
    [
      "disparaitre",
      0.0375
    ],
    [
      "quitter",
      0.0325
    ],
    [
      "s'eclipser",
      0.03
    ],
    [
      "abandonner",
      0.025
    ],
    [
      "filer",
      0.025
    ],
    [
      "s'echapper",
      0.0225
    ],
    [
      "s'esquiver",
      0.0175
    ],
    [
      "deloger",
      0.0125
    ],
    [
      "s'elancer",
      0.01
    ],
    [
      "s'envoler",
      0.01
    ],
    [
      "jaillir",
      0.01
    ],
    [
      "detaler",
      0.01
    ],
    [
      "s'eloigner",
      0.0075
    ],
    [
      "echapper",
      0.0075
    ],
    [
      "venir",
      0.005
    ],
    [
      "s'effacer",
      0.005
    ],
    [
      "s'absenter",
      0.005
    ],
    [
      "mourir",
      0.005
    ],
    [
      "fuser",
      0.005
    ],
    [
      "demenager",
      0.005
    ],
    [
      "degager",
      0.005
    ],
    [
      "commencer",
      0.005
    ],
    [
      "retourner",
      0.005
    ],
    [
      "provenir",
      0.005
    ],
    [
      "proceder",
      0.005
    ],
    [
      "descendre",
      0.005
    ],
    [
      "changer",
      0.005
    ],
    [
      "eclater",
      0.0025
    ],
    [
      "tourner",
      0.0025
    ],
    [
      "tirer",
      0.0025
    ],
    [
      "sauter",
      0.0025
    ],
    [
      "marcher",
      0.0025
    ],
    [
      "demarrer",
      0.0025
    ],
    [
      "decaniller",
      0.0025
    ],
    [
      "saillir",
      0.0025
    ],
    [
      "semer",
      0.0025
    ],
    [
      "vider",
      0.0025
    ],
    [
      "ecarter",
      0.0025
    ],
    [
      "emaner",
      0.0025
    ],
    [
      "riper",
      0.0025
    ],
    [
      "bondir",
      0.0025
    ],
    [
      "caleter",
      0.0025
    ],
    [
      "circuler",
      0.0025
    ],
    [
      "finir",
      0.0025
    ],
    [
      "lancer",
      0.0025
    ],
    [
      "naitre",
      0.0025
    ],
    [
      "voyager",
      0.0
    ],
    [
      "s'oter",
      0.0
    ],
    [
      "s'emietter",
      0.0
    ],
    [
      "s'ouvrir",
      0.0
    ],
    [
      "bouger",
      0.0
    ],
    [
      "debuter",
      0.0
    ],
    [
      "decarrer",
      0.0
    ],
    [
      "denicher",
      0.0
    ],
    [
      "s'enlever",
      0.0
    ],
    [
      "s'ebranler",
      0.0
    ],
    [
      "s'embarquer",
      0.0
    ],
    [
      "s'appuyer",
      0.0
    ],
    [
      "repartir",
      0.0
    ],
    [
      "remonter",
      0.0
    ],
    [
      "emigrer",
      0.0
    ],
    [
      "diviser",
      0.0
    ],
    [
      "deserter",
      0.0
    ],
    [
      "ficher",
      0.0
    ],
    [
      "fonctionner",
      0.0
    ],
    [
      "gicler",
      0.0
    ],
    [
      "jouir",
      0.0
    ],
    [
      "partager",
      0.0
    ],
    [
      "appareiller",
      0.0
    ]
  ],
  "part": [
    [
      "morceau",
      0.1025
    ],
    [
      "portion",
      0.0925
    ],
    [
      "partie",
      0.075
    ],
    [
      "apport",
      0.06
    ],
    [
      "division",
      0.06
    ],
    [
      "fraction",
      0.06
    ],
    [
      "lot",
      0.05
    ],
    [
      "troncon",
      0.04
    ],
    [
      "quota",
      0.04
    ],
    [
      "parcelle",
      0.04
    ],
    [
      "fragment",
      0.0325
    ],
    [
      "ramification",
      0.0325
    ],
    [
      "ration",
      0.025
    ],
    [
      "partage",
      0.025
    ],
    [
      "contribution",
      0.025
    ],
    [
      "tranche",
      0.015
    ],
    [
      "sort",
      0.015
    ],
    [
      "quotite",
      0.015
    ],
    [
      "participation",
      0.015
    ],
    [
      "contingent",
      0.015
    ],
    [
      "bribe",
      0.015
    ],
    [
      "action",
      0.015
    ],
    [
      "prorata",
      0.0075
    ],
    [
      "parturition",
      0.0075
    ],
    [
      "lotissement",
      0.0075
    ],
    [
      "lieu",
      0.0075
    ],
    [
      "fait",
      0.0075
    ],
    [
      "destin",
      0.0075
    ],
    [
      "attribution",
      0.0075
    ],
    [
      "appoint",
      0.0075
    ],
    [
      "valeur",
      0.0075
    ]
  ],
  "souvent": [
    [
      "frequemment",
      0.24
    ],
    [
      "generalement",
      0.1025
    ],
    [
      "habituellement",
      0.1025
    ],
    [
      "couramment",
      0.0675
    ],
    [
      "souventefois",
      0.0325
    ],
    [
      "perpetuellement",
      0.0325
    ],
    [
      "journellement",
      0.0325
    ],
    [
      "d'ordinaire",
      0.0325
    ],
    [
      "communement",
      0.0325
    ],
    [
      "beaucoup",
      0.0325
    ],
    [
      "volontiers",
      0.0325
    ]
  ],
  "travailler": [
    [
      "faire",
      0.05
    ],
    [
      "tourmenter",
      0.045
    ],
    [
      "faconner",
      0.0325
    ],
    [
      "remuer",
      0.0275
    ],
    [
      "obseder",
      0.025
    ],
    [
      "preparer",
      0.025
    ],
    [
      "harceler",
      0.0225
    ],
    [
      "battre",
      0.0225
    ],
    [
      "agiter",
      0.0225
    ],
    [
      "polir",
      0.02
    ],
    [
      "tracasser",
      0.02
    ],
    [
      "troubler",
      0.0175
    ],
    [
      "preoccuper",
      0.015
    ],
    [
      "produire",
      0.015
    ],
    [
      "fabriquer",
      0.015
    ],
    [
      "exciter",
      0.015
    ],
    [
      "cultiver",
      0.015
    ],
    [
      "bucher",
      0.015
    ],
    [
      "agir",
      0.015
    ],
    [
      "etudier",
      0.0125
    ],
    [
      "elaborer",
      0.0125
    ],
    [
      "turlupiner",
      0.0125
    ],
    [
      "poursuivre",
      0.0125
    ],
    [
      "piocher",
      0.0125
    ],
    [
      "inquieter",
      0.0125
    ],
    [
      "hanter",
      0.0125
    ],
    [
      "fouiller",
      0.0125
    ],
    [
      "fatiguer",
      0.0125
    ],
    [
      "dresser",
      0.0125
    ],
    [
      "composer",
      0.0125
    ],
    [
      "soigner",
      0.01
    ],
    [
      "peiner",
      0.01
    ],
    [
      "gratter",
      0.01
    ],
    [
      "embarrasser",
      0.01
    ],
    [
      "ameliorer",
      0.01
    ],
    [
      "user",
      0.0075
    ],
    [
      "trifouiller",
      0.0075
    ],
    [
      "torturer",
      0.0075
    ],
    [
      "s'occuper",
      0.0075
    ],
    [
      "s'efforcer",
      0.0075
    ],
    [
      "ronger",
      0.0075
    ],
    [
      "occuper",
      0.0075
    ],
    [
      "apprendre",
      0.0075
    ],
    [
      "besogner",
      0.0075
    ],
    [
      "bricoler",
      0.0075
    ],
    [
      "fignoler",
      0.0075
    ],
    [
      "manier",
      0.0075
    ],
    [
      "ecrire",
      0.005
    ],
    [
      "trimer",
      0.005
    ],
    [
      "touiller",
      0.005
    ],
    [
      "suer",
      0.005
    ],
    [
      "s'instruire",
      0.005
    ],
    [
      "ouvrer",
      0.005
    ],
    [
      "labourer",
      0.005
    ],
    [
      "habiter",
      0.005
    ],
    [
      "fonctionner",
      0.005
    ],
    [
      "chatier",
      0.005
    ],
    [
      "bosser",
      0.005
    ],
    [
      "profiter",
      0.0025
    ],
    [
      "potasser",
      0.0025
    ],
    [
      "pilonner",
      0.0025
    ],
    [
      "operer",
      0.0025
    ],
    [
      "onduler",
      0.0025
    ],
    [
      "oeuvrer",
      0.0025
    ],
    [
      "petrir",
      0.0025
    ],
    [
      "rendre",
      0.0025
    ],
    [
      "s'employer",
      0.0025
    ],
    [
      "tendre",
      0.0025
    ],
    [
      "turbiner",
      0.0025
    ],
    [
      "epuiser",
      0.0025
    ],
    [
      "lecher",
      0.0025
    ],
    [
      "aiguiser",
      0.0025
    ],
    [
      "attiser",
      0.0025
    ],
    [
      "boulonner",
      0.0025
    ],
    [
      "chiader",
      0.0025
    ],
    [
      "ciseler",
      0.0025
    ],
    [
      "collaborer",
      0.0025
    ],
    [
      "executer",
      0.0025
    ],
    [
      "lanciner",
      0.0025
    ],
    [
      "gener",
      0.0025
    ],
    [
      "gonfler",
      0.0025
    ],
    [
      "gondoler",
      0.0025
    ],
    [
      "fructifier",
      0.0025
    ],
    [
      "fermenter",
      0.0025
    ],
    [
      "tacher",
      0.0
    ],
    [
      "travailloter",
      0.0
    ],
    [
      "retrecir",
      0.0
    ],
    [
      "retravailler",
      0.0
    ],
    [
      "ouvrager",
      0.0
    ],
    [
      "marner",
      0.0
    ],
    [
      "chiner",
      0.0
    ],
    [
      "buriner",
      0.0
    ],
    [
      "bouillir",
      0.0
    ],
    [
      "aigrir",
      0.0
    ]
  ],
  "mieux": [
    [
      "amendement",
      0.1425
    ],
    [
      "amelioration",
      0.1425
    ],
    [
      "maximum",
      0.1425
    ],
    [
      "meilleur",
      0.1425
    ],
    [
      "plus",
      0.1425
    ],
    [
      "progres",
      0.1425
    ],
    [
      "preferable",
      0.1425
    ]
  ],
  "mal": [
    [
      "peine",
      0.08
    ],
    [
      "affliction",
      0.0575
    ],
    [
      "ennui",
      0.0525
    ],
    [
      "chagrin",
      0.0475
    ],
    [
      "douleur",
      0.0475
    ],
    [
      "tristesse",
      0.035
    ],
    [
      "tourment",
      0.035
    ],
    [
      "souffrance",
      0.03
    ],
    [
      "malheur",
      0.0275
    ],
    [
      "desolation",
      0.0225
    ],
    [
      "tribulation",
      0.0225
    ],
    [
      "epreuve",
      0.0175
    ],
    [
      "malaise",
      0.0175
    ],
    [
      "amertume",
      0.0175
    ],
    [
      "calamite",
      0.015
    ],
    [
      "defaut",
      0.015
    ],
    [
      "inquietude",
      0.015
    ],
    [
      "maladie",
      0.015
    ],
    [
      "supplice",
      0.015
    ],
    [
      "vice",
      0.0125
    ],
    [
      "mechancete",
      0.0125
    ],
    [
      "faute",
      0.0125
    ],
    [
      "deplaisir",
      0.0125
    ],
    [
      "torture",
      0.01
    ],
    [
      "mauvais",
      0.01
    ],
    [
      "inconvenient",
      0.01
    ],
    [
      "imperfection",
      0.01
    ],
    [
      "effort",
      0.01
    ],
    [
      "dommage",
      0.01
    ],
    [
      "croix",
      0.01
    ],
    [
      "travail",
      0.0075
    ],
    [
      "tort",
      0.0075
    ],
    [
      "peu",
      0.0075
    ],
    [
      "perte",
      0.0075
    ],
    [
      "injustice",
      0.0075
    ],
    [
      "difficulte",
      0.0075
    ],
    [
      "cruaute",
      0.0075
    ],
    [
      "crime",
      0.0075
    ],
    [
      "melancolie",
      0.0025
    ],
    [
      "pauvrement",
      0.0025
    ],
    [
      "petitement",
      0.0025
    ],
    [
      "plaie",
      0.0025
    ],
    [
      "prejudice",
      0.0025
    ],
    [
      "peche",
      0.0025
    ],
    [
      "ravage",
      0.0025
    ],
    [
      "tare",
      0.0025
    ],
    [
      "tintouin",
      0.0025
    ],
    [
      "vilainement",
      0.0025
    ],
    [
      "violence",
      0.0025
    ],
    [
      "mediocrement",
      0.0025
    ],
    [
      "martyre",
      0.0025
    ],
    [
      "malencontreusement",
      0.0025
    ],
    [
      "acharnement",
      0.0025
    ],
    [
      "calice",
      0.0025
    ],
    [
      "damnation",
      0.0025
    ],
    [
      "defectueusement",
      0.0025
    ],
    [
      "fiel",
      0.0025
    ],
    [
      "imparfaitement",
      0.0025
    ],
    [
      "indignite",
      0.0025
    ],
    [
      "indisposition",
      0.0025
    ],
    [
      "insuffisamment",
      0.0025
    ],
    [
      "larme",
      0.0025
    ],
    [
      "maladroitement",
      0.0025
    ],
    [
      "malfacon",
      0.0
    ],
    [
      "malaisement",
      0.0
    ],
    [
      "malade",
      0.0
    ],
    [
      "laidement",
      0.0
    ],
    [
      "laid",
      0.0
    ],
    [
      "insuffisance",
      0.0
    ],
    [
      "mortification",
      0.0
    ],
    [
      "mecontentement",
      0.0
    ],
    [
      "perversion",
      0.0
    ],
    [
      "perversite",
      0.0
    ],
    [
      "pitoyable",
      0.0
    ],
    [
      "peniblement",
      0.0
    ],
    [
      "salement",
      0.0
    ],
    [
      "troubles",
      0.0
    ],
    [
      "inopportun",
      0.0
    ],
    [
      "incorrectement",
      0.0
    ],
    [
      "incompletement",
      0.0
    ],
    [
      "affection",
      0.0
    ],
    [
      "application",
      0.0
    ],
    [
      "bas",
      0.0
    ],
    [
      "bobo",
      0.0
    ],
    [
      "boiteux",
      0.0
    ],
    [
      "dangereusement",
      0.0
    ],
    [
      "defavorablement",
      0.0
    ],
    [
      "enfer",
      0.0
    ],
    [
      "ennemi",
      0.0
    ],
    [
      "faiblement",
      0.0
    ],
    [
      "facheusement",
      0.0
    ],
    [
      "gauchement",
      0.0
    ],
    [
      "abus",
      0.0
    ]
  ],
  "accompagne": [
    [
      "escorter",
      0.1475
    ],
    [
      "conduire",
      0.115
    ],
    [
      "suivre",
      0.115
    ],
    [
      "chaperonner",
      0.08
    ],
    [
      "proteger",
      0.065
    ],
    [
      "convoyer",
      0.0475
    ],
    [
      "assister",
      0.0475
    ],
    [
      "surveiller",
      0.0325
    ],
    [
      "marier",
      0.0325
    ],
    [
      "guider",
      0.0325
    ],
    [
      "flanquer",
      0.0325
    ],
    [
      "completer",
      0.0325
    ],
    [
      "assortir",
      0.0325
    ],
    [
      "reconduire",
      0.015
    ],
    [
      "joindre",
      0.015
    ],
    [
      "entourer",
      0.015
    ],
    [
      "emmener",
      0.015
    ],
    [
      "corteger",
      0.015
    ],
    [
      "cornaquer",
      0.015
    ],
    [
      "colorer",
      0.015
    ],
    [
      "aller",
      0.015
    ],
    [
      "s'ajouter",
      0.015
    ]
  ],
  "accompagner": [
    [
      "escorter",
      0.1475
    ],
    [
      "conduire",
      0.115
    ],
    [
      "suivre",
      0.115
    ],
    [
      "chaperonner",
      0.08
    ],
    [
      "proteger",
      0.065
    ],
    [
      "convoyer",
      0.0475
    ],
    [
      "assister",
      0.0475
    ],
    [
      "surveiller",
      0.0325
    ],
    [
      "marier",
      0.0325
    ],
    [
      "guider",
      0.0325
    ],
    [
      "flanquer",
      0.0325
    ],
    [
      "completer",
      0.0325
    ],
    [
      "assortir",
      0.0325
    ],
    [
      "reconduire",
      0.015
    ],
    [
      "joindre",
      0.015
    ],
    [
      "entourer",
      0.015
    ],
    [
      "emmener",
      0.015
    ],
    [
      "corteger",
      0.015
    ],
    [
      "cornaquer",
      0.015
    ],
    [
      "colorer",
      0.015
    ],
    [
      "aller",
      0.015
    ],
    [
      "s'ajouter",
      0.015
    ]
  ],
  "ton": [
    [
      "style",
      0.105
    ],
    [
      "genre",
      0.0575
    ],
    [
      "maniere",
      0.0575
    ],
    [
      "son",
      0.0575
    ],
    [
      "voix",
      0.0425
    ],
    [
      "touche",
      0.0425
    ],
    [
      "griffe",
      0.0425
    ],
    [
      "expression",
      0.0425
    ],
    [
      "accent",
      0.035
    ],
    [
      "facon",
      0.035
    ],
    [
      "forme",
      0.03
    ],
    [
      "ecriture",
      0.02
    ],
    [
      "tonalite",
      0.02
    ],
    [
      "patte",
      0.02
    ],
    [
      "parole",
      0.02
    ],
    [
      "note",
      0.02
    ],
    [
      "facture",
      0.02
    ],
    [
      "bruit",
      0.02
    ],
    [
      "tour",
      0.015
    ],
    [
      "timbre",
      0.015
    ],
    [
      "teinte",
      0.015
    ],
    [
      "main",
      0.015
    ],
    [
      "intonation",
      0.015
    ],
    [
      "inflexion",
      0.015
    ],
    [
      "air",
      0.015
    ],
    [
      "accord",
      0.015
    ],
    [
      "echo",
      0.01
    ],
    [
      "sonnerie",
      0.01
    ],
    [
      "plume",
      0.01
    ],
    [
      "pinceau",
      0.01
    ],
    [
      "phonation",
      0.01
    ],
    [
      "nuance",
      0.01
    ],
    [
      "modulation",
      0.01
    ],
    [
      "mode",
      0.01
    ],
    [
      "gout",
      0.01
    ],
    [
      "couleur",
      0.01
    ],
    [
      "corde",
      0.01
    ],
    [
      "tension",
      0.005
    ],
    [
      "tien",
      0.005
    ],
    [
      "tonicite",
      0.005
    ],
    [
      "tonus",
      0.005
    ],
    [
      "signature",
      0.005
    ],
    [
      "procede",
      0.005
    ],
    [
      "politesse",
      0.005
    ],
    [
      "musique",
      0.005
    ],
    [
      "diapason",
      0.005
    ],
    [
      "verbe",
      0.005
    ]
  ],
  "papa": [
    [
      "pere",
      1.0
    ]
  ],
  "meme": [
    [
      "identique",
      0.125
    ],
    [
      "semblable",
      0.125
    ],
    [
      "pareil",
      0.105
    ],
    [
      "analogue",
      0.0525
    ],
    [
      "aussi",
      0.0525
    ],
    [
      "similaire",
      0.0525
    ],
    [
      "egal",
      0.0525
    ],
    [
      "equivalent",
      0.035
    ],
    [
      "uniforme",
      0.035
    ],
    [
      "homogene",
      0.035
    ],
    [
      "exactement",
      0.035
    ],
    [
      "tel",
      0.0175
    ],
    [
      "precisement",
      0.0175
    ],
    [
      "propre",
      0.0175
    ],
    [
      "neanmoins",
      0.0175
    ],
    [
      "jusque",
      0.0175
    ],
    [
      "encore",
      0.0175
    ],
    [
      "constant",
      0.0175
    ],
    [
      "commun",
      0.0175
    ],
    [
      "voire",
      0.0175
    ]
  ],
  "devoir": [
    [
      "obligation",
      0.1
    ],
    [
      "charge",
      0.0775
    ],
    [
      "travail",
      0.0775
    ],
    [
      "service",
      0.0675
    ],
    [
      "tache",
      0.0675
    ],
    [
      "soin",
      0.05
    ],
    [
      "fonction",
      0.05
    ],
    [
      "corvee",
      0.05
    ],
    [
      "role",
      0.0275
    ],
    [
      "responsabilite",
      0.0275
    ],
    [
      "commandement",
      0.0275
    ],
    [
      "affaire",
      0.0275
    ],
    [
      "epreuve",
      0.0175
    ],
    [
      "vertu",
      0.0175
    ],
    [
      "pensum",
      0.0175
    ],
    [
      "office",
      0.0175
    ],
    [
      "morale",
      0.0175
    ],
    [
      "loi",
      0.0175
    ],
    [
      "imperatif",
      0.0175
    ],
    [
      "bien",
      0.0175
    ],
    [
      "composition",
      0.0175
    ],
    [
      "dette",
      0.0175
    ],
    [
      "exercice",
      0.0175
    ],
    [
      "hommage",
      0.0175
    ],
    [
      "respect",
      0.0075
    ],
    [
      "religion",
      0.0075
    ],
    [
      "probite",
      0.0075
    ],
    [
      "oeuvre",
      0.0075
    ],
    [
      "necessite",
      0.0075
    ],
    [
      "interrogation",
      0.0075
    ],
    [
      "exigence",
      0.0075
    ],
    [
      "copie",
      0.0075
    ],
    [
      "compagnonnage",
      0.0075
    ],
    [
      "civilite",
      0.0075
    ],
    [
      "scrupule",
      0.0075
    ]
  ],
  "lui": [
    [
      "cezigue",
      0.5
    ],
    [
      "soi",
      0.5
    ]
  ],
  "luire": [
    [
      "briller",
      0.125
    ],
    [
      "reluire",
      0.115
    ],
    [
      "resplendir",
      0.115
    ],
    [
      "flamboyer",
      0.1
    ],
    [
      "etinceler",
      0.1
    ],
    [
      "scintiller",
      0.085
    ],
    [
      "rayonner",
      0.0525
    ],
    [
      "miroiter",
      0.045
    ],
    [
      "chatoyer",
      0.03
    ],
    [
      "fulgurer",
      0.03
    ],
    [
      "rutiler",
      0.03
    ],
    [
      "eclater",
      0.0225
    ],
    [
      "papilloter",
      0.0225
    ],
    [
      "brasiller",
      0.015
    ],
    [
      "flamber",
      0.015
    ],
    [
      "poudroyer",
      0.015
    ],
    [
      "eblouir",
      0.0075
    ],
    [
      "vaciller",
      0.0075
    ],
    [
      "s'etoiler",
      0.0075
    ],
    [
      "reflechir",
      0.0075
    ],
    [
      "rire",
      0.0075
    ],
    [
      "apparaitre",
      0.0075
    ],
    [
      "eclairer",
      0.0075
    ]
  ],
  "parler": [
    [
      "langage",
      0.1275
    ],
    [
      "langue",
      0.1275
    ],
    [
      "parole",
      0.1275
    ],
    [
      "elocution",
      0.1075
    ],
    [
      "style",
      0.0525
    ],
    [
      "prononciation",
      0.0525
    ],
    [
      "patois",
      0.0525
    ],
    [
      "jargon",
      0.0525
    ],
    [
      "idiome",
      0.035
    ],
    [
      "debit",
      0.035
    ],
    [
      "dialecte",
      0.035
    ],
    [
      "articulation",
      0.035
    ],
    [
      "usage",
      0.0175
    ],
    [
      "phonation",
      0.0175
    ],
    [
      "dire",
      0.0175
    ],
    [
      "diction",
      0.0175
    ],
    [
      "argot",
      0.0175
    ],
    [
      "accent",
      0.0175
    ],
    [
      "usance",
      0.0175
    ]
  ],
  "va": [
    [
      "marcher",
      0.065
    ],
    [
      "courir",
      0.0375
    ],
    [
      "passer",
      0.0375
    ],
    [
      "gagner",
      0.0325
    ],
    [
      "convenir",
      0.0275
    ],
    [
      "aboutir",
      0.025
    ],
    [
      "arriver",
      0.0225
    ],
    [
      "prendre",
      0.0225
    ],
    [
      "avancer",
      0.02
    ],
    [
      "toucher",
      0.0175
    ],
    [
      "tendre",
      0.0175
    ],
    [
      "monter",
      0.0175
    ],
    [
      "tomber",
      0.015
    ],
    [
      "tirer",
      0.015
    ],
    [
      "s'acheminer",
      0.015
    ],
    [
      "pousser",
      0.015
    ],
    [
      "piquer",
      0.015
    ],
    [
      "deambuler",
      0.015
    ],
    [
      "atteindre",
      0.015
    ],
    [
      "progresser",
      0.0125
    ],
    [
      "filer",
      0.0125
    ],
    [
      "errer",
      0.0125
    ],
    [
      "concorder",
      0.0125
    ],
    [
      "cadrer",
      0.0125
    ],
    [
      "affluer",
      0.0125
    ],
    [
      "voyager",
      0.01
    ],
    [
      "voler",
      0.01
    ],
    [
      "poursuivre",
      0.01
    ],
    [
      "plaire",
      0.01
    ],
    [
      "s'accorder",
      0.0075
    ],
    [
      "interesser",
      0.0075
    ],
    [
      "gazer",
      0.0075
    ],
    [
      "entrer",
      0.0075
    ],
    [
      "conduire",
      0.0075
    ],
    [
      "coller",
      0.0075
    ],
    [
      "cheminer",
      0.0075
    ],
    [
      "s'ajuster",
      0.005
    ],
    [
      "s'harmoniser",
      0.005
    ],
    [
      "traverser",
      0.005
    ],
    [
      "evoluer",
      0.005
    ],
    [
      "s'adresser",
      0.005
    ],
    [
      "s'adapter",
      0.005
    ],
    [
      "botter",
      0.005
    ],
    [
      "devancer",
      0.005
    ],
    [
      "distancer",
      0.005
    ],
    [
      "deriver",
      0.005
    ],
    [
      "penetrer",
      0.005
    ],
    [
      "proceder",
      0.0025
    ],
    [
      "preceder",
      0.0025
    ],
    [
      "retourner",
      0.0025
    ],
    [
      "s'approcher",
      0.0025
    ],
    [
      "s'ecouler",
      0.0025
    ],
    [
      "s'elever",
      0.0025
    ],
    [
      "seoir",
      0.0025
    ],
    [
      "solliciter",
      0.0025
    ],
    [
      "obliquer",
      0.0025
    ],
    [
      "mener",
      0.0025
    ],
    [
      "agreer",
      0.0025
    ],
    [
      "bicher",
      0.0025
    ],
    [
      "cingler",
      0.0025
    ],
    [
      "continuer",
      0.0025
    ],
    [
      "converger",
      0.0025
    ],
    [
      "correspondre",
      0.0025
    ],
    [
      "desservir",
      0.0025
    ],
    [
      "devier",
      0.0025
    ],
    [
      "habiller",
      0.0025
    ],
    [
      "peregriner",
      0.0
    ],
    [
      "refluer",
      0.0
    ],
    [
      "saquer",
      0.0
    ],
    [
      "sourire",
      0.0
    ],
    [
      "vaguer",
      0.0
    ],
    [
      "etre",
      0.0
    ],
    [
      "parcourir",
      0.0
    ],
    [
      "galoper",
      0.0
    ],
    [
      "accompagner",
      0.0
    ],
    [
      "baguenauder",
      0.0
    ],
    [
      "biaiser",
      0.0
    ],
    [
      "concerner",
      0.0
    ],
    [
      "fonctionner",
      0.0
    ],
    [
      "frequenter",
      0.0
    ]
  ],
  "pas": [
    [
      "marche",
      0.075
    ],
    [
      "foulee",
      0.065
    ],
    [
      "passage",
      0.065
    ],
    [
      "seuil",
      0.05
    ],
    [
      "rien",
      0.05
    ],
    [
      "point",
      0.05
    ],
    [
      "defile",
      0.05
    ],
    [
      "trace",
      0.0375
    ],
    [
      "ne",
      0.0375
    ],
    [
      "mouvement",
      0.0375
    ],
    [
      "marque",
      0.0375
    ],
    [
      "demarche",
      0.0375
    ],
    [
      "allure",
      0.0375
    ],
    [
      "saut",
      0.025
    ],
    [
      "porte",
      0.025
    ],
    [
      "port",
      0.025
    ],
    [
      "mie",
      0.025
    ],
    [
      "goutte",
      0.025
    ],
    [
      "col",
      0.025
    ],
    [
      "jalon",
      0.01
    ],
    [
      "mot",
      0.01
    ],
    [
      "pied",
      0.01
    ],
    [
      "progres",
      0.01
    ],
    [
      "preseance",
      0.01
    ],
    [
      "signe",
      0.01
    ],
    [
      "train",
      0.01
    ],
    [
      "essai",
      0.01
    ],
    [
      "entree",
      0.01
    ],
    [
      "enjambee",
      0.01
    ],
    [
      "detroit",
      0.01
    ],
    [
      "devant",
      0.01
    ],
    [
      "bond",
      0.01
    ],
    [
      "avance",
      0.01
    ],
    [
      "aucunement",
      0.01
    ],
    [
      "appui",
      0.01
    ],
    [
      "etape",
      0.01
    ]
  ],
  "sacrer": [
    [
      "consacrer",
      0.165
    ],
    [
      "introniser",
      0.165
    ],
    [
      "jurer",
      0.0825
    ],
    [
      "instituer",
      0.0825
    ],
    [
      "inaugurer",
      0.0825
    ],
    [
      "couronner",
      0.0825
    ],
    [
      "benir",
      0.0825
    ],
    [
      "bombarder",
      0.0825
    ],
    [
      "blasphemer",
      0.0825
    ],
    [
      "oindre",
      0.0825
    ]
  ],
  "sacre": [
    [
      "consacrer",
      0.165
    ],
    [
      "introniser",
      0.165
    ],
    [
      "jurer",
      0.0825
    ],
    [
      "instituer",
      0.0825
    ],
    [
      "inaugurer",
      0.0825
    ],
    [
      "couronner",
      0.0825
    ],
    [
      "benir",
      0.0825
    ],
    [
      "bombarder",
      0.0825
    ],
    [
      "blasphemer",
      0.0825
    ],
    [
      "oindre",
      0.0825
    ]
  ],
  "tu": [
    [
      "cacher",
      0.215
    ],
    [
      "dissimuler",
      0.105
    ],
    [
      "rentrer",
      0.07
    ],
    [
      "passer",
      0.07
    ],
    [
      "omettre",
      0.07
    ],
    [
      "celer",
      0.07
    ],
    [
      "supprimer",
      0.035
    ],
    [
      "receler",
      0.035
    ],
    [
      "mentir",
      0.035
    ],
    [
      "enfouir",
      0.035
    ],
    [
      "devorer",
      0.035
    ],
    [
      "deguiser",
      0.035
    ],
    [
      "couvrir",
      0.035
    ],
    [
      "voiler",
      0.035
    ]
  ],
  "taire": [
    [
      "cacher",
      0.215
    ],
    [
      "dissimuler",
      0.105
    ],
    [
      "rentrer",
      0.07
    ],
    [
      "passer",
      0.07
    ],
    [
      "omettre",
      0.07
    ],
    [
      "celer",
      0.07
    ],
    [
      "supprimer",
      0.035
    ],
    [
      "receler",
      0.035
    ],
    [
      "mentir",
      0.035
    ],
    [
      "enfouir",
      0.035
    ],
    [
      "devorer",
      0.035
    ],
    [
      "deguiser",
      0.035
    ],
    [
      "couvrir",
      0.035
    ],
    [
      "voiler",
      0.035
    ]
  ],
  "cache": [
    [
      "abri",
      0.16
    ],
    [
      "repaire",
      0.145
    ],
    [
      "taniere",
      0.145
    ],
    [
      "cachette",
      0.095
    ],
    [
      "retraite",
      0.095
    ],
    [
      "trou",
      0.0475
    ],
    [
      "terrier",
      0.0475
    ],
    [
      "gite",
      0.0475
    ],
    [
      "refuge",
      0.03
    ],
    [
      "nid",
      0.03
    ],
    [
      "coin",
      0.03
    ],
    [
      "asile",
      0.03
    ],
    [
      "antre",
      0.03
    ],
    [
      "affut",
      0.015
    ],
    [
      "planque",
      0.015
    ],
    [
      "ecran",
      0.015
    ]
  ],
  "cacher": [
    [
      "dissimuler",
      0.09
    ],
    [
      "voiler",
      0.0775
    ],
    [
      "couvrir",
      0.055
    ],
    [
      "masquer",
      0.05
    ],
    [
      "etouffer",
      0.0325
    ],
    [
      "deguiser",
      0.0325
    ],
    [
      "camoufler",
      0.03
    ],
    [
      "murer",
      0.03
    ],
    [
      "eclipser",
      0.025
    ],
    [
      "taire",
      0.025
    ],
    [
      "occulter",
      0.025
    ],
    [
      "obscurcir",
      0.025
    ],
    [
      "escamoter",
      0.025
    ],
    [
      "envelopper",
      0.025
    ],
    [
      "derober",
      0.025
    ],
    [
      "renfermer",
      0.02
    ],
    [
      "offusquer",
      0.02
    ],
    [
      "intercepter",
      0.02
    ],
    [
      "enfermer",
      0.02
    ],
    [
      "empecher",
      0.02
    ],
    [
      "boucher",
      0.02
    ],
    [
      "recouvrir",
      0.015
    ],
    [
      "farder",
      0.015
    ],
    [
      "celer",
      0.015
    ],
    [
      "travestir",
      0.0125
    ],
    [
      "rentrer",
      0.0125
    ],
    [
      "receler",
      0.0125
    ],
    [
      "noyer",
      0.0125
    ],
    [
      "enterrer",
      0.0125
    ],
    [
      "ensevelir",
      0.0125
    ],
    [
      "enfouir",
      0.0125
    ],
    [
      "aveugler",
      0.0125
    ],
    [
      "tapisser",
      0.0075
    ],
    [
      "soustraire",
      0.0075
    ],
    [
      "serrer",
      0.0075
    ],
    [
      "renfoncer",
      0.0075
    ],
    [
      "pallier",
      0.0075
    ],
    [
      "enserrer",
      0.0075
    ],
    [
      "arreter",
      0.0075
    ],
    [
      "obstruer",
      0.0025
    ],
    [
      "ombrager",
      0.0025
    ],
    [
      "passer",
      0.0025
    ],
    [
      "planquer",
      0.0025
    ],
    [
      "sceller",
      0.0025
    ],
    [
      "musser",
      0.0025
    ],
    [
      "mucher",
      0.0025
    ],
    [
      "gazer",
      0.0025
    ],
    [
      "draper",
      0.0025
    ],
    [
      "cachotter",
      0.0025
    ],
    [
      "abriter",
      0.0025
    ]
  ],
  "doit": [
    [
      "redevoir",
      0.075
    ],
    [
      "penser",
      0.075
    ],
    [
      "falloir",
      0.075
    ],
    [
      "contracter",
      0.075
    ],
    [
      "avoir",
      0.075
    ],
    [
      "appartenir",
      0.075
    ]
  ],
  "faire": [
    [
      "former",
      0.0425
    ],
    [
      "produire",
      0.0375
    ],
    [
      "faconner",
      0.0275
    ],
    [
      "creer",
      0.025
    ],
    [
      "prendre",
      0.025
    ],
    [
      "composer",
      0.0225
    ],
    [
      "preparer",
      0.02
    ],
    [
      "fabriquer",
      0.02
    ],
    [
      "donner",
      0.02
    ],
    [
      "elaborer",
      0.0175
    ],
    [
      "executer",
      0.0175
    ],
    [
      "construire",
      0.015
    ],
    [
      "travailler",
      0.015
    ],
    [
      "agir",
      0.015
    ],
    [
      "representer",
      0.0125
    ],
    [
      "etablir",
      0.0125
    ],
    [
      "dresser",
      0.0125
    ],
    [
      "elever",
      0.01
    ],
    [
      "pratiquer",
      0.01
    ],
    [
      "pousser",
      0.01
    ],
    [
      "monter",
      0.01
    ],
    [
      "jouer",
      0.01
    ],
    [
      "attraper",
      0.01
    ],
    [
      "cultiver",
      0.01
    ],
    [
      "dire",
      0.01
    ],
    [
      "piquer",
      0.01
    ],
    [
      "sortir",
      0.0075
    ],
    [
      "rendre",
      0.0075
    ],
    [
      "batir",
      0.0075
    ],
    [
      "ecrire",
      0.0075
    ],
    [
      "tirer",
      0.0075
    ],
    [
      "tenir",
      0.0075
    ],
    [
      "soulever",
      0.0075
    ],
    [
      "realiser",
      0.0075
    ],
    [
      "polir",
      0.0075
    ],
    [
      "instruire",
      0.0075
    ],
    [
      "determiner",
      0.0075
    ],
    [
      "constituer",
      0.0075
    ],
    [
      "servir",
      0.0075
    ],
    [
      "reproduire",
      0.0075
    ],
    [
      "remplir",
      0.0075
    ],
    [
      "provoquer",
      0.0075
    ],
    [
      "exercer",
      0.0075
    ],
    [
      "accomplir",
      0.0075
    ],
    [
      "traiter",
      0.005
    ],
    [
      "prononcer",
      0.005
    ],
    [
      "gagner",
      0.005
    ],
    [
      "forger",
      0.005
    ],
    [
      "publier",
      0.005
    ],
    [
      "s'occuper",
      0.005
    ],
    [
      "susciter",
      0.005
    ],
    [
      "tracer",
      0.005
    ],
    [
      "user",
      0.005
    ],
    [
      "etudier",
      0.005
    ],
    [
      "proceder",
      0.005
    ],
    [
      "plier",
      0.005
    ],
    [
      "causer",
      0.005
    ],
    [
      "confectionner",
      0.005
    ],
    [
      "imiter",
      0.005
    ],
    [
      "obtenir",
      0.005
    ],
    [
      "operer",
      0.005
    ],
    [
      "peser",
      0.005
    ],
    [
      "ramasser",
      0.0025
    ],
    [
      "occasionner",
      0.0025
    ],
    [
      "lacher",
      0.0025
    ],
    [
      "lever",
      0.0025
    ],
    [
      "habituer",
      0.0025
    ],
    [
      "frotter",
      0.0025
    ],
    [
      "figurer",
      0.0025
    ],
    [
      "debiter",
      0.0025
    ],
    [
      "couvrir",
      0.0025
    ],
    [
      "charger",
      0.0025
    ],
    [
      "avoir",
      0.0025
    ],
    [
      "appuyer",
      0.0025
    ],
    [
      "accoucher",
      0.0025
    ],
    [
      "nommer",
      0.0025
    ],
    [
      "observer",
      0.0025
    ],
    [
      "procurer",
      0.0025
    ],
    [
      "proferer",
      0.0025
    ],
    [
      "refaire",
      0.0025
    ],
    [
      "edifier",
      0.0025
    ],
    [
      "fournir",
      0.0025
    ],
    [
      "ficher",
      0.0025
    ],
    [
      "engendrer",
      0.0025
    ],
    [
      "commettre",
      0.0025
    ],
    [
      "contenir",
      0.0025
    ],
    [
      "dessiner",
      0.0025
    ],
    [
      "derober",
      0.0025
    ],
    [
      "effectuer",
      0.0025
    ],
    [
      "enfanter",
      0.0025
    ],
    [
      "s'adonner",
      0.0
    ],
    [
      "reussir",
      0.0
    ],
    [
      "repondre",
      0.0
    ],
    [
      "recolter",
      0.0
    ],
    [
      "remporter",
      0.0
    ],
    [
      "pratique",
      0.0
    ],
    [
      "parcourir",
      0.0
    ],
    [
      "paraitre",
      0.0
    ],
    [
      "nettoyer",
      0.0
    ],
    [
      "metier",
      0.0
    ],
    [
      "modeler",
      0.0
    ],
    [
      "mesurer",
      0.0
    ],
    [
      "maniere",
      0.0
    ],
    [
      "s'employer",
      0.0
    ],
    [
      "satisfaire",
      0.0
    ],
    [
      "etre",
      0.0
    ],
    [
      "evaluer",
      0.0
    ],
    [
      "evacuer",
      0.0
    ],
    [
      "visiter",
      0.0
    ],
    [
      "vendre",
      0.0
    ],
    [
      "valoir",
      0.0
    ],
    [
      "transformer",
      0.0
    ],
    [
      "technique",
      0.0
    ],
    [
      "seduire",
      0.0
    ],
    [
      "soutirer",
      0.0
    ],
    [
      "simuler",
      0.0
    ],
    [
      "semer",
      0.0
    ],
    [
      "lustrer",
      0.0
    ],
    [
      "accoutumer",
      0.0
    ],
    [
      "couter",
      0.0
    ],
    [
      "courir",
      0.0
    ],
    [
      "couper",
      0.0
    ],
    [
      "convertir",
      0.0
    ],
    [
      "contrefaire",
      0.0
    ],
    [
      "chercher",
      0.0
    ],
    [
      "changer",
      0.0
    ],
    [
      "bruler",
      0.0
    ],
    [
      "astiquer",
      0.0
    ],
    [
      "art",
      0.0
    ],
    [
      "appreter",
      0.0
    ],
    [
      "aider",
      0.0
    ],
    [
      "adresser",
      0.0
    ],
    [
      "cueillir",
      0.0
    ],
    [
      "celebrer",
      0.0
    ],
    [
      "jauger",
      0.0
    ],
    [
      "interpreter",
      0.0
    ],
    [
      "instituer",
      0.0
    ],
    [
      "impressionner",
      0.0
    ],
    [
      "imposer",
      0.0
    ],
    [
      "fricoter",
      0.0
    ],
    [
      "foutre",
      0.0
    ],
    [
      "facon",
      0.0
    ],
    [
      "devenir",
      0.0
    ],
    [
      "duper",
      0.0
    ],
    [
      "decider",
      0.0
    ],
    [
      "devorer",
      0.0
    ],
    [
      "extorquer",
      0.0
    ],
    [
      "faucher",
      0.0
    ],
    [
      "procreer",
      0.0
    ],
    [
      "pisser",
      0.0
    ],
    [
      "piocher",
      0.0
    ],
    [
      "parfaire",
      0.0
    ],
    [
      "mijoter",
      0.0
    ],
    [
      "maquiller",
      0.0
    ],
    [
      "laver",
      0.0
    ],
    [
      "prospecter",
      0.0
    ],
    [
      "pretendre",
      0.0
    ],
    [
      "ranger",
      0.0
    ],
    [
      "recurer",
      0.0
    ],
    [
      "s'acquitter",
      0.0
    ],
    [
      "sillonner",
      0.0
    ],
    [
      "style",
      0.0
    ],
    [
      "elucubrer",
      0.0
    ],
    [
      "equivaloir",
      0.0
    ],
    [
      "instaurer",
      0.0
    ],
    [
      "importer",
      0.0
    ],
    [
      "acquitter",
      0.0
    ],
    [
      "amasser",
      0.0
    ],
    [
      "chier",
      0.0
    ],
    [
      "chiper",
      0.0
    ],
    [
      "cirer",
      0.0
    ],
    [
      "cuire",
      0.0
    ],
    [
      "defequer",
      0.0
    ],
    [
      "detailler",
      0.0
    ],
    [
      "embobiner",
      0.0
    ],
    [
      "entortiller",
      0.0
    ],
    [
      "feter",
      0.0
    ],
    [
      "farder",
      0.0
    ],
    [
      "familiariser",
      0.0
    ],
    [
      "facture",
      0.0
    ],
    [
      "entretenir",
      0.0
    ],
    [
      "entreprendre",
      0.0
    ],
    [
      "s'appuyer",
      0.0
    ],
    [
      "repliquer",
      0.0
    ],
    [
      "potasser",
      0.0
    ],
    [
      "pondre",
      0.0
    ],
    [
      "perpetrer",
      0.0
    ],
    [
      "peigner",
      0.0
    ],
    [
      "singer",
      0.0
    ],
    [
      "transmuer",
      0.0
    ],
    [
      "uriner",
      0.0
    ],
    [
      "usiner",
      0.0
    ],
    [
      "egaler",
      0.0
    ],
    [
      "epauler",
      0.0
    ],
    [
      "metamorphoser",
      0.0
    ],
    [
      "allouer",
      0.0
    ],
    [
      "bucher",
      0.0
    ],
    [
      "chiader",
      0.0
    ],
    [
      "choper",
      0.0
    ],
    [
      "coter",
      0.0
    ],
    [
      "crotter",
      0.0
    ],
    [
      "durer",
      0.0
    ],
    [
      "degrossir",
      0.0
    ],
    [
      "experience",
      0.0
    ],
    [
      "goupiller",
      0.0
    ],
    [
      "intenter",
      0.0
    ],
    [
      "manufacturer",
      0.0
    ],
    [
      "action",
      0.0
    ]
  ],
  "au": [
    [
      "avec",
      0.1425
    ],
    [
      "de",
      0.1425
    ],
    [
      "vers",
      0.0925
    ],
    [
      "pour",
      0.0925
    ],
    [
      "par",
      0.0925
    ],
    [
      "en",
      0.0925
    ],
    [
      "dans",
      0.0925
    ],
    [
      "apres",
      0.045
    ],
    [
      "chez",
      0.045
    ],
    [
      "contre",
      0.045
    ],
    [
      "entre",
      0.045
    ],
    [
      "jusqu'a",
      0.045
    ]
  ],
  "moins": [
    [
      "diminution",
      0.3325
    ],
    [
      "minimum",
      0.3325
    ],
    [
      "sauf",
      0.3325
    ]
  ],
  "mille": [
    [
      "blanc",
      0.3325
    ],
    [
      "but",
      0.3325
    ],
    [
      "mile",
      0.3325
    ]
  ],
  "fois": [
    [
      "croyance",
      0.1
    ],
    [
      "conviction",
      0.0525
    ],
    [
      "honnetete",
      0.045
    ],
    [
      "religion",
      0.045
    ],
    [
      "verite",
      0.045
    ],
    [
      "esperance",
      0.04
    ],
    [
      "dogme",
      0.04
    ],
    [
      "credo",
      0.04
    ],
    [
      "certitude",
      0.04
    ],
    [
      "loyaute",
      0.0325
    ],
    [
      "fidelite",
      0.0325
    ],
    [
      "assurance",
      0.025
    ],
    [
      "confiance",
      0.025
    ],
    [
      "conscience",
      0.025
    ],
    [
      "zele",
      0.025
    ],
    [
      "probite",
      0.0175
    ],
    [
      "promesse",
      0.0175
    ],
    [
      "sincerite",
      0.0175
    ],
    [
      "evangile",
      0.0175
    ],
    [
      "parole",
      0.0175
    ],
    [
      "franchise",
      0.0175
    ],
    [
      "exactitude",
      0.0175
    ],
    [
      "droiture",
      0.0175
    ],
    [
      "culte",
      0.0175
    ],
    [
      "confession",
      0.0175
    ],
    [
      "temoignage",
      0.0125
    ],
    [
      "opinion",
      0.0125
    ],
    [
      "honneur",
      0.0125
    ],
    [
      "hommage",
      0.0125
    ],
    [
      "fanatisme",
      0.0125
    ],
    [
      "engagement",
      0.0125
    ],
    [
      "theogonie",
      0.005
    ],
    [
      "spiritualite",
      0.005
    ],
    [
      "serment",
      0.005
    ],
    [
      "perfidie",
      0.005
    ],
    [
      "mystique",
      0.005
    ],
    [
      "mysticisme",
      0.005
    ],
    [
      "fourberie",
      0.005
    ],
    [
      "faussete",
      0.005
    ],
    [
      "creance",
      0.005
    ],
    [
      "catechisme",
      0.005
    ],
    [
      "autorite",
      0.005
    ],
    [
      "eglise",
      0.005
    ]
  ],
  "compter": [
    [
      "estimer",
      0.0825
    ],
    [
      "penser",
      0.055
    ],
    [
      "considerer",
      0.0475
    ],
    [
      "croire",
      0.0375
    ],
    [
      "esperer",
      0.0375
    ],
    [
      "regarder",
      0.0375
    ],
    [
      "evaluer",
      0.0375
    ],
    [
      "presumer",
      0.0325
    ],
    [
      "peser",
      0.0325
    ],
    [
      "denombrer",
      0.0275
    ],
    [
      "examiner",
      0.0275
    ],
    [
      "apprecier",
      0.0225
    ],
    [
      "escompter",
      0.0225
    ],
    [
      "prendre",
      0.0225
    ],
    [
      "reputer",
      0.0225
    ],
    [
      "supputer",
      0.0225
    ],
    [
      "envisager",
      0.0175
    ],
    [
      "contenir",
      0.0175
    ],
    [
      "enumerer",
      0.0125
    ],
    [
      "tabler",
      0.0125
    ],
    [
      "supposer",
      0.0125
    ],
    [
      "presenter",
      0.0125
    ],
    [
      "posseder",
      0.0125
    ],
    [
      "nombrer",
      0.0125
    ],
    [
      "mesurer",
      0.0125
    ],
    [
      "calculer",
      0.0125
    ],
    [
      "comprendre",
      0.0125
    ],
    [
      "importer",
      0.0125
    ],
    [
      "introduire",
      0.0125
    ],
    [
      "marquer",
      0.0125
    ],
    [
      "songer",
      0.0075
    ],
    [
      "s'attendre",
      0.0075
    ],
    [
      "recenser",
      0.0075
    ],
    [
      "inventorier",
      0.0075
    ],
    [
      "inclure",
      0.0075
    ],
    [
      "entendre",
      0.0075
    ],
    [
      "attendre",
      0.0075
    ],
    [
      "fonder",
      0.0025
    ],
    [
      "payer",
      0.0025
    ],
    [
      "projeter",
      0.0025
    ],
    [
      "precompter",
      0.0025
    ],
    [
      "s'appuyer",
      0.0025
    ],
    [
      "epargner",
      0.0025
    ],
    [
      "facturer",
      0.0025
    ],
    [
      "exister",
      0.0025
    ],
    [
      "chiffrer",
      0.0025
    ],
    [
      "computer",
      0.0025
    ],
    [
      "dater",
      0.0025
    ],
    [
      "decompter",
      0.0025
    ],
    [
      "englober",
      0.0025
    ]
  ],
  "mes": [],
  "doigt": [
    [
      "brin",
      0.25
    ],
    [
      "goutte",
      0.25
    ],
    [
      "peu",
      0.25
    ],
    [
      "pouce",
      0.25
    ]
  ],
  "t": [],
  "t'": [],
  "aura": [
    [
      "emanation",
      0.18
    ],
    [
      "atmosphere",
      0.135
    ],
    [
      "aureole",
      0.135
    ],
    [
      "halo",
      0.135
    ],
    [
      "semence",
      0.045
    ],
    [
      "phosphorescence",
      0.045
    ],
    [
      "nimbe",
      0.045
    ],
    [
      "milieu",
      0.045
    ],
    [
      "fluide",
      0.045
    ],
    [
      "exhalaison",
      0.045
    ],
    [
      "ambiance",
      0.045
    ],
    [
      "souffle",
      0.045
    ]
  ],
  "jour": [
    [
      "aspect",
      0.07
    ],
    [
      "lumiere",
      0.07
    ],
    [
      "ouverture",
      0.07
    ],
    [
      "perspective",
      0.07
    ],
    [
      "tournure",
      0.0575
    ],
    [
      "vue",
      0.045
    ],
    [
      "vie",
      0.045
    ],
    [
      "angle",
      0.035
    ],
    [
      "clarte",
      0.035
    ],
    [
      "epoque",
      0.0225
    ],
    [
      "eclairage",
      0.0225
    ],
    [
      "temps",
      0.0225
    ],
    [
      "semblance",
      0.0225
    ],
    [
      "optique",
      0.0225
    ],
    [
      "moment",
      0.0225
    ],
    [
      "journee",
      0.0225
    ],
    [
      "fenetre",
      0.0225
    ],
    [
      "date",
      0.0225
    ],
    [
      "apparence",
      0.0225
    ],
    [
      "moyen",
      0.01
    ],
    [
      "naissance",
      0.01
    ],
    [
      "page",
      0.01
    ],
    [
      "quantieme",
      0.01
    ],
    [
      "retribution",
      0.01
    ],
    [
      "soleil",
      0.01
    ],
    [
      "luminosite",
      0.01
    ],
    [
      "lueur",
      0.01
    ],
    [
      "judas",
      0.01
    ],
    [
      "ferie",
      0.01
    ],
    [
      "fissure",
      0.01
    ],
    [
      "fente",
      0.01
    ],
    [
      "exterieur",
      0.01
    ],
    [
      "existence",
      0.01
    ],
    [
      "ajour",
      0.01
    ],
    [
      "traitement",
      0.01
    ]
  ],
  "autre": [
    [
      "different",
      0.12
    ],
    [
      "dissemblable",
      0.09
    ],
    [
      "second",
      0.09
    ],
    [
      "separe",
      0.06
    ],
    [
      "suivant",
      0.06
    ],
    [
      "prochain",
      0.06
    ],
    [
      "oppose",
      0.06
    ],
    [
      "nouveau",
      0.06
    ],
    [
      "distinct",
      0.06
    ],
    [
      "deuxieme",
      0.06
    ],
    [
      "supplementaire",
      0.03
    ],
    [
      "reste",
      0.03
    ],
    [
      "restant",
      0.03
    ],
    [
      "incompatible",
      0.03
    ],
    [
      "change",
      0.03
    ],
    [
      "autrui",
      0.03
    ],
    [
      "etranger",
      0.03
    ]
  ],
  "tout": [
    [
      "ensemble",
      0.095
    ],
    [
      "absolument",
      0.0725
    ],
    [
      "bien",
      0.0725
    ],
    [
      "entier",
      0.0725
    ],
    [
      "tres",
      0.0475
    ],
    [
      "totalite",
      0.0475
    ],
    [
      "total",
      0.0475
    ],
    [
      "plein",
      0.0475
    ],
    [
      "extremement",
      0.0475
    ],
    [
      "bloc",
      0.0475
    ],
    [
      "long",
      0.0225
    ],
    [
      "minable",
      0.0225
    ],
    [
      "principal",
      0.0225
    ],
    [
      "quiconque",
      0.0225
    ],
    [
      "quoique",
      0.0225
    ],
    [
      "unite",
      0.0225
    ],
    [
      "integral",
      0.0225
    ],
    [
      "important",
      0.0225
    ],
    [
      "exactement",
      0.0225
    ],
    [
      "entierement",
      0.0225
    ],
    [
      "completement",
      0.0225
    ],
    [
      "complet",
      0.0225
    ],
    [
      "chaque",
      0.0225
    ],
    [
      "chacun",
      0.0225
    ],
    [
      "univers",
      0.0225
    ]
  ],
  "tous": [
    [
      "chacun",
      0.25
    ],
    [
      "ensemble",
      0.25
    ]
  ],
  "nous": [],
  "detestable": [
    [
      "mauvais",
      0.1025
    ],
    [
      "affreux",
      0.0825
    ],
    [
      "odieux",
      0.0825
    ],
    [
      "horrible",
      0.06
    ],
    [
      "repugnant",
      0.06
    ],
    [
      "desagreable",
      0.0525
    ],
    [
      "execrable",
      0.0525
    ],
    [
      "abominable",
      0.0475
    ],
    [
      "mechant",
      0.04
    ],
    [
      "degoutant",
      0.04
    ],
    [
      "haissable",
      0.035
    ],
    [
      "deplorable",
      0.03
    ],
    [
      "ignoble",
      0.03
    ],
    [
      "infect",
      0.03
    ],
    [
      "maudit",
      0.0225
    ],
    [
      "epouvantable",
      0.0175
    ],
    [
      "vilain",
      0.0175
    ],
    [
      "minable",
      0.0175
    ],
    [
      "lamentable",
      0.0175
    ],
    [
      "damne",
      0.0175
    ],
    [
      "ecoeurant",
      0.01
    ],
    [
      "regrettable",
      0.01
    ],
    [
      "piteux",
      0.01
    ],
    [
      "pendable",
      0.01
    ],
    [
      "pauvre",
      0.01
    ],
    [
      "meprisable",
      0.01
    ],
    [
      "imbuvable",
      0.01
    ],
    [
      "catastrophique",
      0.01
    ],
    [
      "antipathique",
      0.01
    ],
    [
      "disgracieux",
      0.005
    ],
    [
      "gate",
      0.005
    ],
    [
      "sacre",
      0.005
    ]
  ],
  "admirable": [
    [
      "etonnant",
      0.1225
    ],
    [
      "merveilleux",
      0.0925
    ],
    [
      "beau",
      0.08
    ],
    [
      "extraordinaire",
      0.08
    ],
    [
      "sensationnel",
      0.08
    ],
    [
      "fantastique",
      0.0475
    ],
    [
      "parfait",
      0.0425
    ],
    [
      "prodigieux",
      0.0375
    ],
    [
      "formidable",
      0.0375
    ],
    [
      "fabuleux",
      0.0375
    ],
    [
      "epatant",
      0.035
    ],
    [
      "remarquable",
      0.0275
    ],
    [
      "incomparable",
      0.025
    ],
    [
      "inoui",
      0.0225
    ],
    [
      "magnifique",
      0.0225
    ],
    [
      "sublime",
      0.0225
    ],
    [
      "exceptionnel",
      0.0175
    ],
    [
      "splendide",
      0.015
    ],
    [
      "adorable",
      0.0125
    ],
    [
      "excellent",
      0.0125
    ],
    [
      "mirifique",
      0.0125
    ],
    [
      "prestigieux",
      0.0125
    ],
    [
      "superbe",
      0.0125
    ],
    [
      "etrange",
      0.0075
    ],
    [
      "terrible",
      0.0075
    ],
    [
      "mirobolant",
      0.0075
    ],
    [
      "grandiose",
      0.0075
    ],
    [
      "divin",
      0.005
    ],
    [
      "ravissant",
      0.005
    ],
    [
      "satane",
      0.005
    ],
    [
      "boeuf",
      0.0025
    ],
    [
      "supercoquentieux",
      0.0025
    ]
  ],
  "geniteur": [
    [
      "generateur",
      0.18
    ],
    [
      "parent",
      0.18
    ],
    [
      "pere",
      0.18
    ],
    [
      "reproducteur",
      0.18
    ],
    [
      "ancetre",
      0.09
    ],
    [
      "male",
      0.09
    ],
    [
      "procreateur",
      0.09
    ]
  ],
  "des": [
    [
      "aussitot",
      0.165
    ],
    [
      "depuis",
      0.165
    ],
    [
      "immediatement",
      0.165
    ],
    [
      "incontinent",
      0.165
    ]
  ],
  "genie": [
    [
      "esprit",
      0.1
    ],
    [
      "lutin",
      0.07
    ],
    [
      "talent",
      0.065
    ],
    [
      "disposition",
      0.045
    ],
    [
      "intelligence",
      0.0425
    ],
    [
      "aptitude",
      0.0375
    ],
    [
      "capacite",
      0.0375
    ],
    [
      "don",
      0.0325
    ],
    [
      "faculte",
      0.0275
    ],
    [
      "kobold",
      0.0275
    ],
    [
      "demon",
      0.0225
    ],
    [
      "inspiration",
      0.0225
    ],
    [
      "savoir",
      0.0175
    ],
    [
      "phenix",
      0.0175
    ],
    [
      "penchant",
      0.0175
    ],
    [
      "nature",
      0.0175
    ],
    [
      "entendement",
      0.0175
    ],
    [
      "caractere",
      0.0175
    ],
    [
      "aigle",
      0.0175
    ],
    [
      "vocation",
      0.0125
    ],
    [
      "lumiere",
      0.0125
    ],
    [
      "instinct",
      0.0125
    ],
    [
      "imagination",
      0.0125
    ],
    [
      "elfe",
      0.0125
    ],
    [
      "tresor",
      0.0075
    ],
    [
      "sylphe",
      0.0075
    ],
    [
      "prodige",
      0.0075
    ],
    [
      "korrigan",
      0.0075
    ],
    [
      "gnome",
      0.0075
    ],
    [
      "fee",
      0.0075
    ],
    [
      "flamme",
      0.0075
    ],
    [
      "farfadet",
      0.0075
    ],
    [
      "enthousiasme",
      0.0075
    ],
    [
      "art",
      0.0075
    ],
    [
      "as",
      0.0075
    ],
    [
      "cerveau",
      0.0075
    ],
    [
      "classe",
      0.0075
    ],
    [
      "crack",
      0.0075
    ],
    [
      "divinite",
      0.0075
    ],
    [
      "ondine",
      0.0025
    ],
    [
      "ondin",
      0.0025
    ],
    [
      "ingenierie",
      0.0025
    ],
    [
      "geant",
      0.0025
    ],
    [
      "gout",
      0.0025
    ],
    [
      "originalite",
      0.0025
    ],
    [
      "peri",
      0.0025
    ],
    [
      "salamandre",
      0.0025
    ],
    [
      "superiorite",
      0.0025
    ],
    [
      "surdoue",
      0.0025
    ],
    [
      "sylphide",
      0.0025
    ],
    [
      "sylvain",
      0.0025
    ],
    [
      "troll",
      0.0025
    ],
    [
      "visionnaire",
      0.0025
    ],
    [
      "goule",
      0.0025
    ],
    [
      "goguelin",
      0.0025
    ],
    [
      "alf",
      0.0025
    ],
    [
      "ange",
      0.0025
    ],
    [
      "aspiole",
      0.0025
    ],
    [
      "bosse",
      0.0025
    ],
    [
      "brio",
      0.0025
    ],
    [
      "collection",
      0.0025
    ],
    [
      "djinn",
      0.0025
    ],
    [
      "dragon",
      0.0025
    ],
    [
      "drow",
      0.0025
    ],
    [
      "demiurge",
      0.0025
    ],
    [
      "efrit",
      0.0025
    ],
    [
      "engineering",
      0.0025
    ],
    [
      "expression",
      0.0025
    ],
    [
      "gobelin",
      0.0025
    ]
  ],
  "donner": [
    [
      "reveler",
      0.0325
    ],
    [
      "montrer",
      0.03
    ],
    [
      "exposer",
      0.0275
    ],
    [
      "porter",
      0.025
    ],
    [
      "produire",
      0.0225
    ],
    [
      "attribuer",
      0.0225
    ],
    [
      "faire",
      0.0225
    ],
    [
      "accorder",
      0.02
    ],
    [
      "offrir",
      0.0175
    ],
    [
      "presenter",
      0.0175
    ],
    [
      "laisser",
      0.0175
    ],
    [
      "fournir",
      0.0175
    ],
    [
      "dire",
      0.0175
    ],
    [
      "appliquer",
      0.0175
    ],
    [
      "livrer",
      0.015
    ],
    [
      "abandonner",
      0.015
    ],
    [
      "communiquer",
      0.015
    ],
    [
      "representer",
      0.0125
    ],
    [
      "preter",
      0.0125
    ],
    [
      "ceder",
      0.0125
    ],
    [
      "avancer",
      0.01
    ],
    [
      "indiquer",
      0.01
    ],
    [
      "passer",
      0.01
    ],
    [
      "rapporter",
      0.01
    ],
    [
      "remettre",
      0.01
    ],
    [
      "transmettre",
      0.01
    ],
    [
      "rendre",
      0.01
    ],
    [
      "denoncer",
      0.01
    ],
    [
      "allouer",
      0.01
    ],
    [
      "apporter",
      0.01
    ],
    [
      "distribuer",
      0.01
    ],
    [
      "determiner",
      0.01
    ],
    [
      "gratifier",
      0.01
    ],
    [
      "vendre",
      0.01
    ],
    [
      "servir",
      0.0075
    ],
    [
      "octroyer",
      0.0075
    ],
    [
      "former",
      0.0075
    ],
    [
      "exprimer",
      0.0075
    ],
    [
      "administrer",
      0.0075
    ],
    [
      "ecrire",
      0.0075
    ],
    [
      "publier",
      0.0075
    ],
    [
      "provoquer",
      0.0075
    ],
    [
      "procurer",
      0.0075
    ],
    [
      "fixer",
      0.0075
    ],
    [
      "envoyer",
      0.0075
    ],
    [
      "conceder",
      0.0075
    ],
    [
      "adresser",
      0.0075
    ],
    [
      "repandre",
      0.005
    ],
    [
      "payer",
      0.005
    ],
    [
      "frapper",
      0.005
    ],
    [
      "attacher",
      0.005
    ],
    [
      "aliener",
      0.005
    ],
    [
      "permettre",
      0.005
    ],
    [
      "prodiguer",
      0.005
    ],
    [
      "renoncer",
      0.005
    ],
    [
      "susciter",
      0.005
    ],
    [
      "trahir",
      0.005
    ],
    [
      "vouer",
      0.005
    ],
    [
      "etablir",
      0.005
    ],
    [
      "partager",
      0.005
    ],
    [
      "occasionner",
      0.005
    ],
    [
      "nommer",
      0.005
    ],
    [
      "adjuger",
      0.005
    ],
    [
      "allonger",
      0.005
    ],
    [
      "causer",
      0.005
    ],
    [
      "coller",
      0.005
    ],
    [
      "conferer",
      0.005
    ],
    [
      "decerner",
      0.005
    ],
    [
      "ficher",
      0.005
    ],
    [
      "imposer",
      0.005
    ],
    [
      "tolerer",
      0.005
    ],
    [
      "tendre",
      0.005
    ],
    [
      "repartir",
      0.005
    ],
    [
      "imputer",
      0.005
    ],
    [
      "imprimer",
      0.005
    ],
    [
      "confier",
      0.005
    ],
    [
      "affirmer",
      0.005
    ],
    [
      "verser",
      0.0025
    ],
    [
      "soumettre",
      0.0025
    ],
    [
      "sacrifier",
      0.0025
    ],
    [
      "pretendre",
      0.0025
    ],
    [
      "devouer",
      0.0025
    ],
    [
      "doter",
      0.0025
    ],
    [
      "dispenser",
      0.0025
    ],
    [
      "consentir",
      0.0025
    ],
    [
      "consacrer",
      0.0025
    ],
    [
      "assigner",
      0.0025
    ],
    [
      "aider",
      0.0025
    ],
    [
      "inspirer",
      0.0025
    ],
    [
      "jouer",
      0.0025
    ],
    [
      "leguer",
      0.0025
    ],
    [
      "pourvoir",
      0.0025
    ],
    [
      "prescrire",
      0.0025
    ],
    [
      "foutre",
      0.0025
    ],
    [
      "deposer",
      0.0025
    ],
    [
      "composer",
      0.0025
    ],
    [
      "bruler",
      0.0025
    ],
    [
      "balancer",
      0.0025
    ],
    [
      "assurer",
      0.0025
    ],
    [
      "aligner",
      0.0025
    ],
    [
      "s'ouvrir",
      0.0
    ],
    [
      "s'etendre",
      0.0
    ],
    [
      "supposer",
      0.0
    ],
    [
      "echanger",
      0.0
    ],
    [
      "retroceder",
      0.0
    ],
    [
      "infliger",
      0.0
    ],
    [
      "dedier",
      0.0
    ],
    [
      "employer",
      0.0
    ],
    [
      "exciter",
      0.0
    ],
    [
      "garantir",
      0.0
    ],
    [
      "impartir",
      0.0
    ],
    [
      "elaborer",
      0.0
    ],
    [
      "voir",
      0.0
    ],
    [
      "inoculer",
      0.0
    ],
    [
      "fructifier",
      0.0
    ],
    [
      "douer",
      0.0
    ],
    [
      "devenir",
      0.0
    ],
    [
      "assister",
      0.0
    ],
    [
      "assener",
      0.0
    ],
    [
      "affubler",
      0.0
    ],
    [
      "moucharder",
      0.0
    ],
    [
      "nantir",
      0.0
    ],
    [
      "ouvrir",
      0.0
    ],
    [
      "redonner",
      0.0
    ],
    [
      "remunerer",
      0.0
    ],
    [
      "retribuer",
      0.0
    ],
    [
      "s'etirer",
      0.0
    ],
    [
      "troquer",
      0.0
    ],
    [
      "intervenir",
      0.0
    ],
    [
      "heurter",
      0.0
    ],
    [
      "gaspiller",
      0.0
    ],
    [
      "abouler",
      0.0
    ],
    [
      "approcher",
      0.0
    ],
    [
      "bailler",
      0.0
    ],
    [
      "balanstiquer",
      0.0
    ],
    [
      "croire",
      0.0
    ],
    [
      "enfanter",
      0.0
    ],
    [
      "epandre",
      0.0
    ]
  ],
  "donne": [
    [
      "reveler",
      0.0325
    ],
    [
      "montrer",
      0.03
    ],
    [
      "exposer",
      0.0275
    ],
    [
      "porter",
      0.025
    ],
    [
      "produire",
      0.0225
    ],
    [
      "attribuer",
      0.0225
    ],
    [
      "faire",
      0.0225
    ],
    [
      "accorder",
      0.02
    ],
    [
      "offrir",
      0.0175
    ],
    [
      "presenter",
      0.0175
    ],
    [
      "laisser",
      0.0175
    ],
    [
      "fournir",
      0.0175
    ],
    [
      "dire",
      0.0175
    ],
    [
      "appliquer",
      0.0175
    ],
    [
      "livrer",
      0.015
    ],
    [
      "abandonner",
      0.015
    ],
    [
      "communiquer",
      0.015
    ],
    [
      "representer",
      0.0125
    ],
    [
      "preter",
      0.0125
    ],
    [
      "ceder",
      0.0125
    ],
    [
      "avancer",
      0.01
    ],
    [
      "indiquer",
      0.01
    ],
    [
      "passer",
      0.01
    ],
    [
      "rapporter",
      0.01
    ],
    [
      "remettre",
      0.01
    ],
    [
      "transmettre",
      0.01
    ],
    [
      "rendre",
      0.01
    ],
    [
      "denoncer",
      0.01
    ],
    [
      "allouer",
      0.01
    ],
    [
      "apporter",
      0.01
    ],
    [
      "distribuer",
      0.01
    ],
    [
      "determiner",
      0.01
    ],
    [
      "gratifier",
      0.01
    ],
    [
      "vendre",
      0.01
    ],
    [
      "servir",
      0.0075
    ],
    [
      "octroyer",
      0.0075
    ],
    [
      "former",
      0.0075
    ],
    [
      "exprimer",
      0.0075
    ],
    [
      "administrer",
      0.0075
    ],
    [
      "ecrire",
      0.0075
    ],
    [
      "publier",
      0.0075
    ],
    [
      "provoquer",
      0.0075
    ],
    [
      "procurer",
      0.0075
    ],
    [
      "fixer",
      0.0075
    ],
    [
      "envoyer",
      0.0075
    ],
    [
      "conceder",
      0.0075
    ],
    [
      "adresser",
      0.0075
    ],
    [
      "repandre",
      0.005
    ],
    [
      "payer",
      0.005
    ],
    [
      "frapper",
      0.005
    ],
    [
      "attacher",
      0.005
    ],
    [
      "aliener",
      0.005
    ],
    [
      "permettre",
      0.005
    ],
    [
      "prodiguer",
      0.005
    ],
    [
      "renoncer",
      0.005
    ],
    [
      "susciter",
      0.005
    ],
    [
      "trahir",
      0.005
    ],
    [
      "vouer",
      0.005
    ],
    [
      "etablir",
      0.005
    ],
    [
      "partager",
      0.005
    ],
    [
      "occasionner",
      0.005
    ],
    [
      "nommer",
      0.005
    ],
    [
      "adjuger",
      0.005
    ],
    [
      "allonger",
      0.005
    ],
    [
      "causer",
      0.005
    ],
    [
      "coller",
      0.005
    ],
    [
      "conferer",
      0.005
    ],
    [
      "decerner",
      0.005
    ],
    [
      "ficher",
      0.005
    ],
    [
      "imposer",
      0.005
    ],
    [
      "tolerer",
      0.005
    ],
    [
      "tendre",
      0.005
    ],
    [
      "repartir",
      0.005
    ],
    [
      "imputer",
      0.005
    ],
    [
      "imprimer",
      0.005
    ],
    [
      "confier",
      0.005
    ],
    [
      "affirmer",
      0.005
    ],
    [
      "verser",
      0.0025
    ],
    [
      "soumettre",
      0.0025
    ],
    [
      "sacrifier",
      0.0025
    ],
    [
      "pretendre",
      0.0025
    ],
    [
      "devouer",
      0.0025
    ],
    [
      "doter",
      0.0025
    ],
    [
      "dispenser",
      0.0025
    ],
    [
      "consentir",
      0.0025
    ],
    [
      "consacrer",
      0.0025
    ],
    [
      "assigner",
      0.0025
    ],
    [
      "aider",
      0.0025
    ],
    [
      "inspirer",
      0.0025
    ],
    [
      "jouer",
      0.0025
    ],
    [
      "leguer",
      0.0025
    ],
    [
      "pourvoir",
      0.0025
    ],
    [
      "prescrire",
      0.0025
    ],
    [
      "foutre",
      0.0025
    ],
    [
      "deposer",
      0.0025
    ],
    [
      "composer",
      0.0025
    ],
    [
      "bruler",
      0.0025
    ],
    [
      "balancer",
      0.0025
    ],
    [
      "assurer",
      0.0025
    ],
    [
      "aligner",
      0.0025
    ],
    [
      "s'ouvrir",
      0.0
    ],
    [
      "s'etendre",
      0.0
    ],
    [
      "supposer",
      0.0
    ],
    [
      "echanger",
      0.0
    ],
    [
      "retroceder",
      0.0
    ],
    [
      "infliger",
      0.0
    ],
    [
      "dedier",
      0.0
    ],
    [
      "employer",
      0.0
    ],
    [
      "exciter",
      0.0
    ],
    [
      "garantir",
      0.0
    ],
    [
      "impartir",
      0.0
    ],
    [
      "elaborer",
      0.0
    ],
    [
      "voir",
      0.0
    ],
    [
      "inoculer",
      0.0
    ],
    [
      "fructifier",
      0.0
    ],
    [
      "douer",
      0.0
    ],
    [
      "devenir",
      0.0
    ],
    [
      "assister",
      0.0
    ],
    [
      "assener",
      0.0
    ],
    [
      "affubler",
      0.0
    ],
    [
      "moucharder",
      0.0
    ],
    [
      "nantir",
      0.0
    ],
    [
      "ouvrir",
      0.0
    ],
    [
      "redonner",
      0.0
    ],
    [
      "remunerer",
      0.0
    ],
    [
      "retribuer",
      0.0
    ],
    [
      "s'etirer",
      0.0
    ],
    [
      "troquer",
      0.0
    ],
    [
      "intervenir",
      0.0
    ],
    [
      "heurter",
      0.0
    ],
    [
      "gaspiller",
      0.0
    ],
    [
      "abouler",
      0.0
    ],
    [
      "approcher",
      0.0
    ],
    [
      "bailler",
      0.0
    ],
    [
      "balanstiquer",
      0.0
    ],
    [
      "croire",
      0.0
    ],
    [
      "enfanter",
      0.0
    ],
    [
      "epandre",
      0.0
    ]
  ],
  "naissance": [
    [
      "origine",
      0.1325
    ],
    [
      "commencement",
      0.1225
    ],
    [
      "seuil",
      0.0775
    ],
    [
      "debut",
      0.065
    ],
    [
      "race",
      0.055
    ],
    [
      "maison",
      0.0325
    ],
    [
      "extraction",
      0.0325
    ],
    [
      "creation",
      0.0325
    ],
    [
      "aurore",
      0.0325
    ],
    [
      "apparition",
      0.0325
    ],
    [
      "etre",
      0.02
    ],
    [
      "eclosion",
      0.02
    ],
    [
      "racine",
      0.02
    ],
    [
      "generation",
      0.02
    ],
    [
      "filiation",
      0.02
    ],
    [
      "avenement",
      0.02
    ],
    [
      "ascendance",
      0.02
    ],
    [
      "jour",
      0.01
    ],
    [
      "nativite",
      0.01
    ],
    [
      "noblesse",
      0.01
    ],
    [
      "nom",
      0.01
    ],
    [
      "parage",
      0.01
    ],
    [
      "source",
      0.01
    ],
    [
      "ebauche",
      0.01
    ],
    [
      "genese",
      0.01
    ],
    [
      "accouchement",
      0.01
    ],
    [
      "agnelage",
      0.01
    ],
    [
      "attache",
      0.01
    ],
    [
      "aube",
      0.01
    ],
    [
      "berceau",
      0.01
    ],
    [
      "depart",
      0.01
    ],
    [
      "developpement",
      0.01
    ],
    [
      "extrance",
      0.01
    ],
    [
      "etat",
      0.01
    ]
  ],
  "aux": [
    [
      "avec",
      0.1425
    ],
    [
      "de",
      0.1425
    ],
    [
      "vers",
      0.0925
    ],
    [
      "pour",
      0.0925
    ],
    [
      "par",
      0.0925
    ],
    [
      "en",
      0.0925
    ],
    [
      "dans",
      0.0925
    ],
    [
      "apres",
      0.045
    ],
    [
      "chez",
      0.045
    ],
    [
      "contre",
      0.045
    ],
    [
      "entre",
      0.045
    ],
    [
      "jusqu'a",
      0.045
    ]
  ],
  "irresponsable": [
    [
      "inconscient",
      0.25
    ],
    [
      "innocent",
      0.25
    ],
    [
      "insouciant",
      0.25
    ],
    [
      "leger",
      0.25
    ]
  ],
  "tiens": [
    [
      "retenir",
      0.07
    ],
    [
      "contenir",
      0.035
    ],
    [
      "fixer",
      0.0325
    ],
    [
      "prendre",
      0.0325
    ],
    [
      "attacher",
      0.0325
    ],
    [
      "maintenir",
      0.025
    ],
    [
      "arreter",
      0.0225
    ],
    [
      "enchainer",
      0.02
    ],
    [
      "demeurer",
      0.02
    ],
    [
      "assujettir",
      0.02
    ],
    [
      "durer",
      0.0175
    ],
    [
      "observer",
      0.0175
    ],
    [
      "soutenir",
      0.0175
    ],
    [
      "occuper",
      0.015
    ],
    [
      "garder",
      0.015
    ],
    [
      "continuer",
      0.015
    ],
    [
      "avoir",
      0.0125
    ],
    [
      "embrasser",
      0.0125
    ],
    [
      "suivre",
      0.0125
    ],
    [
      "rester",
      0.0125
    ],
    [
      "mettre",
      0.0125
    ],
    [
      "immobiliser",
      0.0125
    ],
    [
      "faire",
      0.0125
    ],
    [
      "contraindre",
      0.0125
    ],
    [
      "appuyer",
      0.0125
    ],
    [
      "s'etendre",
      0.01
    ],
    [
      "posseder",
      0.01
    ],
    [
      "emprisonner",
      0.01
    ],
    [
      "coller",
      0.01
    ],
    [
      "brider",
      0.01
    ],
    [
      "trainer",
      0.0075
    ],
    [
      "pratiquer",
      0.0075
    ],
    [
      "porter",
      0.0075
    ],
    [
      "freiner",
      0.0075
    ],
    [
      "executer",
      0.0075
    ],
    [
      "engager",
      0.0075
    ],
    [
      "empecher",
      0.0075
    ],
    [
      "detenir",
      0.0075
    ],
    [
      "conserver",
      0.0075
    ],
    [
      "coincer",
      0.0075
    ],
    [
      "renfermer",
      0.0075
    ],
    [
      "perseverer",
      0.0075
    ],
    [
      "persister",
      0.0075
    ],
    [
      "endiguer",
      0.0075
    ],
    [
      "consigner",
      0.0075
    ],
    [
      "adherer",
      0.0075
    ],
    [
      "supporter",
      0.005
    ],
    [
      "subsister",
      0.005
    ],
    [
      "saisir",
      0.005
    ],
    [
      "s'attacher",
      0.005
    ],
    [
      "mener",
      0.005
    ],
    [
      "maitriser",
      0.005
    ],
    [
      "loger",
      0.005
    ],
    [
      "lier",
      0.005
    ],
    [
      "diriger",
      0.005
    ],
    [
      "recevoir",
      0.005
    ],
    [
      "remplir",
      0.005
    ],
    [
      "respecter",
      0.005
    ],
    [
      "resister",
      0.005
    ],
    [
      "moderer",
      0.005
    ],
    [
      "gouverner",
      0.005
    ],
    [
      "accomplir",
      0.005
    ],
    [
      "accrocher",
      0.005
    ],
    [
      "astreindre",
      0.005
    ],
    [
      "comprimer",
      0.005
    ],
    [
      "entrer",
      0.005
    ],
    [
      "venir",
      0.0025
    ],
    [
      "s'obstiner",
      0.0025
    ],
    [
      "resulter",
      0.0025
    ],
    [
      "ressortir",
      0.0025
    ],
    [
      "rendre",
      0.0025
    ],
    [
      "participer",
      0.0025
    ],
    [
      "manier",
      0.0025
    ],
    [
      "dependre",
      0.0025
    ],
    [
      "defendre",
      0.0025
    ],
    [
      "amarrer",
      0.0025
    ],
    [
      "absorber",
      0.0025
    ],
    [
      "resider",
      0.0025
    ],
    [
      "s'acquitter",
      0.0025
    ],
    [
      "s'etaler",
      0.0025
    ],
    [
      "satisfaire",
      0.0025
    ],
    [
      "surveiller",
      0.0025
    ],
    [
      "etreindre",
      0.0025
    ],
    [
      "ralentir",
      0.0025
    ],
    [
      "provenir",
      0.0025
    ],
    [
      "jouer",
      0.0025
    ],
    [
      "accaparer",
      0.0025
    ],
    [
      "administrer",
      0.0025
    ],
    [
      "clouer",
      0.0025
    ],
    [
      "comporter",
      0.0025
    ],
    [
      "discuter",
      0.0025
    ],
    [
      "exercer",
      0.0025
    ],
    [
      "jauger",
      0.0025
    ],
    [
      "s'etirer",
      0.0
    ],
    [
      "recouvrir",
      0.0
    ],
    [
      "naviguer",
      0.0
    ],
    [
      "gerer",
      0.0
    ],
    [
      "envisager",
      0.0
    ],
    [
      "effectuer",
      0.0
    ],
    [
      "deliberer",
      0.0
    ],
    [
      "appartenir",
      0.0
    ],
    [
      "agripper",
      0.0
    ]
  ],
  "tenir": [
    [
      "retenir",
      0.07
    ],
    [
      "contenir",
      0.035
    ],
    [
      "fixer",
      0.0325
    ],
    [
      "prendre",
      0.0325
    ],
    [
      "attacher",
      0.0325
    ],
    [
      "maintenir",
      0.025
    ],
    [
      "arreter",
      0.0225
    ],
    [
      "enchainer",
      0.02
    ],
    [
      "demeurer",
      0.02
    ],
    [
      "assujettir",
      0.02
    ],
    [
      "durer",
      0.0175
    ],
    [
      "observer",
      0.0175
    ],
    [
      "soutenir",
      0.0175
    ],
    [
      "occuper",
      0.015
    ],
    [
      "garder",
      0.015
    ],
    [
      "continuer",
      0.015
    ],
    [
      "avoir",
      0.0125
    ],
    [
      "embrasser",
      0.0125
    ],
    [
      "suivre",
      0.0125
    ],
    [
      "rester",
      0.0125
    ],
    [
      "mettre",
      0.0125
    ],
    [
      "immobiliser",
      0.0125
    ],
    [
      "faire",
      0.0125
    ],
    [
      "contraindre",
      0.0125
    ],
    [
      "appuyer",
      0.0125
    ],
    [
      "s'etendre",
      0.01
    ],
    [
      "posseder",
      0.01
    ],
    [
      "emprisonner",
      0.01
    ],
    [
      "coller",
      0.01
    ],
    [
      "brider",
      0.01
    ],
    [
      "trainer",
      0.0075
    ],
    [
      "pratiquer",
      0.0075
    ],
    [
      "porter",
      0.0075
    ],
    [
      "freiner",
      0.0075
    ],
    [
      "executer",
      0.0075
    ],
    [
      "engager",
      0.0075
    ],
    [
      "empecher",
      0.0075
    ],
    [
      "detenir",
      0.0075
    ],
    [
      "conserver",
      0.0075
    ],
    [
      "coincer",
      0.0075
    ],
    [
      "renfermer",
      0.0075
    ],
    [
      "perseverer",
      0.0075
    ],
    [
      "persister",
      0.0075
    ],
    [
      "endiguer",
      0.0075
    ],
    [
      "consigner",
      0.0075
    ],
    [
      "adherer",
      0.0075
    ],
    [
      "supporter",
      0.005
    ],
    [
      "subsister",
      0.005
    ],
    [
      "saisir",
      0.005
    ],
    [
      "s'attacher",
      0.005
    ],
    [
      "mener",
      0.005
    ],
    [
      "maitriser",
      0.005
    ],
    [
      "loger",
      0.005
    ],
    [
      "lier",
      0.005
    ],
    [
      "diriger",
      0.005
    ],
    [
      "recevoir",
      0.005
    ],
    [
      "remplir",
      0.005
    ],
    [
      "respecter",
      0.005
    ],
    [
      "resister",
      0.005
    ],
    [
      "moderer",
      0.005
    ],
    [
      "gouverner",
      0.005
    ],
    [
      "accomplir",
      0.005
    ],
    [
      "accrocher",
      0.005
    ],
    [
      "astreindre",
      0.005
    ],
    [
      "comprimer",
      0.005
    ],
    [
      "entrer",
      0.005
    ],
    [
      "venir",
      0.0025
    ],
    [
      "s'obstiner",
      0.0025
    ],
    [
      "resulter",
      0.0025
    ],
    [
      "ressortir",
      0.0025
    ],
    [
      "rendre",
      0.0025
    ],
    [
      "participer",
      0.0025
    ],
    [
      "manier",
      0.0025
    ],
    [
      "dependre",
      0.0025
    ],
    [
      "defendre",
      0.0025
    ],
    [
      "amarrer",
      0.0025
    ],
    [
      "absorber",
      0.0025
    ],
    [
      "resider",
      0.0025
    ],
    [
      "s'acquitter",
      0.0025
    ],
    [
      "s'etaler",
      0.0025
    ],
    [
      "satisfaire",
      0.0025
    ],
    [
      "surveiller",
      0.0025
    ],
    [
      "etreindre",
      0.0025
    ],
    [
      "ralentir",
      0.0025
    ],
    [
      "provenir",
      0.0025
    ],
    [
      "jouer",
      0.0025
    ],
    [
      "accaparer",
      0.0025
    ],
    [
      "administrer",
      0.0025
    ],
    [
      "clouer",
      0.0025
    ],
    [
      "comporter",
      0.0025
    ],
    [
      "discuter",
      0.0025
    ],
    [
      "exercer",
      0.0025
    ],
    [
      "jauger",
      0.0025
    ],
    [
      "s'etirer",
      0.0
    ],
    [
      "recouvrir",
      0.0
    ],
    [
      "naviguer",
      0.0
    ],
    [
      "gerer",
      0.0
    ],
    [
      "envisager",
      0.0
    ],
    [
      "effectuer",
      0.0
    ],
    [
      "deliberer",
      0.0
    ],
    [
      "appartenir",
      0.0
    ],
    [
      "agripper",
      0.0
    ]
  ],
  "tien": [
    [
      "ton",
      1.0
    ]
  ],
  "monde": [
    [
      "univers",
      0.11
    ],
    [
      "societe",
      0.0875
    ],
    [
      "gens",
      0.065
    ],
    [
      "public",
      0.0525
    ],
    [
      "terre",
      0.0425
    ],
    [
      "nature",
      0.0425
    ],
    [
      "foule",
      0.0425
    ],
    [
      "domesticite",
      0.03
    ],
    [
      "globe",
      0.03
    ],
    [
      "sphere",
      0.03
    ],
    [
      "multitude",
      0.02
    ],
    [
      "milieu",
      0.02
    ],
    [
      "maison",
      0.02
    ],
    [
      "humanite",
      0.02
    ],
    [
      "hommes",
      0.02
    ],
    [
      "gentry",
      0.02
    ],
    [
      "domaine",
      0.02
    ],
    [
      "humains",
      0.01
    ],
    [
      "macrocosme",
      0.01
    ],
    [
      "maisonnee",
      0.01
    ],
    [
      "microcosme",
      0.01
    ],
    [
      "personnel",
      0.01
    ],
    [
      "planete",
      0.01
    ],
    [
      "quantite",
      0.01
    ],
    [
      "regne",
      0.01
    ],
    [
      "realite",
      0.01
    ],
    [
      "serviteurs",
      0.01
    ],
    [
      "siecle",
      0.01
    ],
    [
      "valetaille",
      0.01
    ],
    [
      "gratin",
      0.01
    ],
    [
      "gotha",
      0.01
    ],
    [
      "aristocratie",
      0.01
    ],
    [
      "assemblage",
      0.01
    ],
    [
      "civilisation",
      0.01
    ],
    [
      "commun",
      0.01
    ],
    [
      "continent",
      0.01
    ],
    [
      "cosmos",
      0.01
    ],
    [
      "creation",
      0.01
    ],
    [
      "employes",
      0.01
    ],
    [
      "entourage",
      0.01
    ],
    [
      "galerie",
      0.01
    ],
    [
      "affluence",
      0.01
    ]
  ],
  "comment": [
    [
      "hein",
      0.22
    ],
    [
      "comme",
      0.11
    ],
    [
      "eh",
      0.11
    ],
    [
      "motif",
      0.11
    ],
    [
      "pardon",
      0.11
    ],
    [
      "quoi",
      0.11
    ]
  ],
  "fait": [
    [
      "former",
      0.0425
    ],
    [
      "produire",
      0.0375
    ],
    [
      "faconner",
      0.0275
    ],
    [
      "creer",
      0.025
    ],
    [
      "prendre",
      0.025
    ],
    [
      "composer",
      0.0225
    ],
    [
      "preparer",
      0.02
    ],
    [
      "fabriquer",
      0.02
    ],
    [
      "donner",
      0.02
    ],
    [
      "elaborer",
      0.0175
    ],
    [
      "executer",
      0.0175
    ],
    [
      "construire",
      0.015
    ],
    [
      "travailler",
      0.015
    ],
    [
      "agir",
      0.015
    ],
    [
      "representer",
      0.0125
    ],
    [
      "etablir",
      0.0125
    ],
    [
      "dresser",
      0.0125
    ],
    [
      "elever",
      0.01
    ],
    [
      "pratiquer",
      0.01
    ],
    [
      "pousser",
      0.01
    ],
    [
      "monter",
      0.01
    ],
    [
      "jouer",
      0.01
    ],
    [
      "attraper",
      0.01
    ],
    [
      "cultiver",
      0.01
    ],
    [
      "dire",
      0.01
    ],
    [
      "piquer",
      0.01
    ],
    [
      "sortir",
      0.0075
    ],
    [
      "rendre",
      0.0075
    ],
    [
      "batir",
      0.0075
    ],
    [
      "ecrire",
      0.0075
    ],
    [
      "tirer",
      0.0075
    ],
    [
      "tenir",
      0.0075
    ],
    [
      "soulever",
      0.0075
    ],
    [
      "realiser",
      0.0075
    ],
    [
      "polir",
      0.0075
    ],
    [
      "instruire",
      0.0075
    ],
    [
      "determiner",
      0.0075
    ],
    [
      "constituer",
      0.0075
    ],
    [
      "servir",
      0.0075
    ],
    [
      "reproduire",
      0.0075
    ],
    [
      "remplir",
      0.0075
    ],
    [
      "provoquer",
      0.0075
    ],
    [
      "exercer",
      0.0075
    ],
    [
      "accomplir",
      0.0075
    ],
    [
      "traiter",
      0.005
    ],
    [
      "prononcer",
      0.005
    ],
    [
      "gagner",
      0.005
    ],
    [
      "forger",
      0.005
    ],
    [
      "publier",
      0.005
    ],
    [
      "s'occuper",
      0.005
    ],
    [
      "susciter",
      0.005
    ],
    [
      "tracer",
      0.005
    ],
    [
      "user",
      0.005
    ],
    [
      "etudier",
      0.005
    ],
    [
      "proceder",
      0.005
    ],
    [
      "plier",
      0.005
    ],
    [
      "causer",
      0.005
    ],
    [
      "confectionner",
      0.005
    ],
    [
      "imiter",
      0.005
    ],
    [
      "obtenir",
      0.005
    ],
    [
      "operer",
      0.005
    ],
    [
      "peser",
      0.005
    ],
    [
      "ramasser",
      0.0025
    ],
    [
      "occasionner",
      0.0025
    ],
    [
      "lacher",
      0.0025
    ],
    [
      "lever",
      0.0025
    ],
    [
      "habituer",
      0.0025
    ],
    [
      "frotter",
      0.0025
    ],
    [
      "figurer",
      0.0025
    ],
    [
      "debiter",
      0.0025
    ],
    [
      "couvrir",
      0.0025
    ],
    [
      "charger",
      0.0025
    ],
    [
      "avoir",
      0.0025
    ],
    [
      "appuyer",
      0.0025
    ],
    [
      "accoucher",
      0.0025
    ],
    [
      "nommer",
      0.0025
    ],
    [
      "observer",
      0.0025
    ],
    [
      "procurer",
      0.0025
    ],
    [
      "proferer",
      0.0025
    ],
    [
      "refaire",
      0.0025
    ],
    [
      "edifier",
      0.0025
    ],
    [
      "fournir",
      0.0025
    ],
    [
      "ficher",
      0.0025
    ],
    [
      "engendrer",
      0.0025
    ],
    [
      "commettre",
      0.0025
    ],
    [
      "contenir",
      0.0025
    ],
    [
      "dessiner",
      0.0025
    ],
    [
      "derober",
      0.0025
    ],
    [
      "effectuer",
      0.0025
    ],
    [
      "enfanter",
      0.0025
    ],
    [
      "s'adonner",
      0.0
    ],
    [
      "reussir",
      0.0
    ],
    [
      "repondre",
      0.0
    ],
    [
      "recolter",
      0.0
    ],
    [
      "remporter",
      0.0
    ],
    [
      "pratique",
      0.0
    ],
    [
      "parcourir",
      0.0
    ],
    [
      "paraitre",
      0.0
    ],
    [
      "nettoyer",
      0.0
    ],
    [
      "metier",
      0.0
    ],
    [
      "modeler",
      0.0
    ],
    [
      "mesurer",
      0.0
    ],
    [
      "maniere",
      0.0
    ],
    [
      "s'employer",
      0.0
    ],
    [
      "satisfaire",
      0.0
    ],
    [
      "etre",
      0.0
    ],
    [
      "evaluer",
      0.0
    ],
    [
      "evacuer",
      0.0
    ],
    [
      "visiter",
      0.0
    ],
    [
      "vendre",
      0.0
    ],
    [
      "valoir",
      0.0
    ],
    [
      "transformer",
      0.0
    ],
    [
      "technique",
      0.0
    ],
    [
      "seduire",
      0.0
    ],
    [
      "soutirer",
      0.0
    ],
    [
      "simuler",
      0.0
    ],
    [
      "semer",
      0.0
    ],
    [
      "lustrer",
      0.0
    ],
    [
      "accoutumer",
      0.0
    ],
    [
      "couter",
      0.0
    ],
    [
      "courir",
      0.0
    ],
    [
      "couper",
      0.0
    ],
    [
      "convertir",
      0.0
    ],
    [
      "contrefaire",
      0.0
    ],
    [
      "chercher",
      0.0
    ],
    [
      "changer",
      0.0
    ],
    [
      "bruler",
      0.0
    ],
    [
      "astiquer",
      0.0
    ],
    [
      "art",
      0.0
    ],
    [
      "appreter",
      0.0
    ],
    [
      "aider",
      0.0
    ],
    [
      "adresser",
      0.0
    ],
    [
      "cueillir",
      0.0
    ],
    [
      "celebrer",
      0.0
    ],
    [
      "jauger",
      0.0
    ],
    [
      "interpreter",
      0.0
    ],
    [
      "instituer",
      0.0
    ],
    [
      "impressionner",
      0.0
    ],
    [
      "imposer",
      0.0
    ],
    [
      "fricoter",
      0.0
    ],
    [
      "foutre",
      0.0
    ],
    [
      "facon",
      0.0
    ],
    [
      "devenir",
      0.0
    ],
    [
      "duper",
      0.0
    ],
    [
      "decider",
      0.0
    ],
    [
      "devorer",
      0.0
    ],
    [
      "extorquer",
      0.0
    ],
    [
      "faucher",
      0.0
    ],
    [
      "procreer",
      0.0
    ],
    [
      "pisser",
      0.0
    ],
    [
      "piocher",
      0.0
    ],
    [
      "parfaire",
      0.0
    ],
    [
      "mijoter",
      0.0
    ],
    [
      "maquiller",
      0.0
    ],
    [
      "laver",
      0.0
    ],
    [
      "prospecter",
      0.0
    ],
    [
      "pretendre",
      0.0
    ],
    [
      "ranger",
      0.0
    ],
    [
      "recurer",
      0.0
    ],
    [
      "s'acquitter",
      0.0
    ],
    [
      "sillonner",
      0.0
    ],
    [
      "style",
      0.0
    ],
    [
      "elucubrer",
      0.0
    ],
    [
      "equivaloir",
      0.0
    ],
    [
      "instaurer",
      0.0
    ],
    [
      "importer",
      0.0
    ],
    [
      "acquitter",
      0.0
    ],
    [
      "amasser",
      0.0
    ],
    [
      "chier",
      0.0
    ],
    [
      "chiper",
      0.0
    ],
    [
      "cirer",
      0.0
    ],
    [
      "cuire",
      0.0
    ],
    [
      "defequer",
      0.0
    ],
    [
      "detailler",
      0.0
    ],
    [
      "embobiner",
      0.0
    ],
    [
      "entortiller",
      0.0
    ],
    [
      "feter",
      0.0
    ],
    [
      "farder",
      0.0
    ],
    [
      "familiariser",
      0.0
    ],
    [
      "facture",
      0.0
    ],
    [
      "entretenir",
      0.0
    ],
    [
      "entreprendre",
      0.0
    ],
    [
      "s'appuyer",
      0.0
    ],
    [
      "repliquer",
      0.0
    ],
    [
      "potasser",
      0.0
    ],
    [
      "pondre",
      0.0
    ],
    [
      "perpetrer",
      0.0
    ],
    [
      "peigner",
      0.0
    ],
    [
      "singer",
      0.0
    ],
    [
      "transmuer",
      0.0
    ],
    [
      "uriner",
      0.0
    ],
    [
      "usiner",
      0.0
    ],
    [
      "egaler",
      0.0
    ],
    [
      "epauler",
      0.0
    ],
    [
      "metamorphoser",
      0.0
    ],
    [
      "allouer",
      0.0
    ],
    [
      "bucher",
      0.0
    ],
    [
      "chiader",
      0.0
    ],
    [
      "choper",
      0.0
    ],
    [
      "coter",
      0.0
    ],
    [
      "crotter",
      0.0
    ],
    [
      "durer",
      0.0
    ],
    [
      "degrossir",
      0.0
    ],
    [
      "experience",
      0.0
    ],
    [
      "goupiller",
      0.0
    ],
    [
      "intenter",
      0.0
    ],
    [
      "manufacturer",
      0.0
    ],
    [
      "action",
      0.0
    ]
  ],
  "bebe": [
    [
      "enfant",
      0.2375
    ],
    [
      "gamin",
      0.0725
    ],
    [
      "mioche",
      0.0725
    ],
    [
      "gosse",
      0.055
    ],
    [
      "moutard",
      0.055
    ],
    [
      "mome",
      0.055
    ],
    [
      "poupon",
      0.055
    ],
    [
      "poupard",
      0.035
    ],
    [
      "petit",
      0.035
    ],
    [
      "nourrisson",
      0.035
    ],
    [
      "marmot",
      0.035
    ],
    [
      "bambin",
      0.035
    ],
    [
      "poupee",
      0.0175
    ],
    [
      "moutatchou",
      0.0175
    ],
    [
      "loupiot",
      0.0175
    ],
    [
      "lardon",
      0.0175
    ],
    [
      "enfancon",
      0.0175
    ],
    [
      "chiard",
      0.0175
    ],
    [
      "baigneur",
      0.0175
    ],
    [
      "baby",
      0.0175
    ],
    [
      "tetard",
      0.0175
    ]
  ],
  "personne": [
    [
      "homme",
      0.195
    ],
    [
      "individu",
      0.1575
    ],
    [
      "type",
      0.085
    ],
    [
      "personnage",
      0.0425
    ],
    [
      "ame",
      0.035
    ],
    [
      "etre",
      0.035
    ],
    [
      "citoyen",
      0.0275
    ],
    [
      "bougre",
      0.0275
    ],
    [
      "zebre",
      0.02
    ],
    [
      "zigoto",
      0.02
    ],
    [
      "quidam",
      0.02
    ],
    [
      "quelqu'un",
      0.02
    ],
    [
      "personnalite",
      0.02
    ],
    [
      "oiseau",
      0.02
    ],
    [
      "habitant",
      0.02
    ],
    [
      "creature",
      0.02
    ],
    [
      "corps",
      0.02
    ],
    [
      "zig",
      0.0125
    ],
    [
      "pierrot",
      0.0125
    ],
    [
      "mortel",
      0.0125
    ],
    [
      "moi",
      0.0125
    ],
    [
      "mec",
      0.0125
    ],
    [
      "humain",
      0.0125
    ],
    [
      "coco",
      0.0125
    ],
    [
      "sujet",
      0.005
    ],
    [
      "quiconque",
      0.005
    ],
    [
      "peau",
      0.005
    ],
    [
      "particulier",
      0.005
    ],
    [
      "paroissien",
      0.005
    ],
    [
      "on",
      0.005
    ],
    [
      "nul",
      0.005
    ],
    [
      "moineau",
      0.005
    ],
    [
      "gonze",
      0.005
    ],
    [
      "femme",
      0.005
    ],
    [
      "chacun",
      0.005
    ],
    [
      "bipede",
      0.005
    ],
    [
      "tete",
      0.005
    ]
  ],
  "papas": [
    [
      "pere",
      1.0
    ]
  ],
  "sais": [
    [
      "connaitre",
      0.26
    ],
    [
      "apprendre",
      0.11
    ],
    [
      "comprendre",
      0.11
    ],
    [
      "voir",
      0.11
    ],
    [
      "imaginer",
      0.0725
    ],
    [
      "s'attendre",
      0.035
    ],
    [
      "pouvoir",
      0.035
    ],
    [
      "posseder",
      0.035
    ]
  ],
  "en": [
    [
      "par",
      0.25
    ],
    [
      "avec",
      0.2075
    ],
    [
      "dans",
      0.125
    ],
    [
      "de",
      0.125
    ],
    [
      "pendant",
      0.0825
    ],
    [
      "sur",
      0.0825
    ],
    [
      "a",
      0.0825
    ],
    [
      "comme",
      0.04
    ]
  ],
  "heriter": [
    [
      "recevoir",
      0.23
    ],
    [
      "recueillir",
      0.1525
    ],
    [
      "tirer",
      0.1525
    ],
    [
      "acquerir",
      0.075
    ],
    [
      "emprunter",
      0.075
    ],
    [
      "recolter",
      0.075
    ],
    [
      "succeder",
      0.075
    ],
    [
      "echoir",
      0.075
    ]
  ],
  "ca": [
    [
      "cela",
      1.0
    ]
  ],
  "falloir": [
    [
      "s'agir",
      0.2
    ],
    [
      "convenir",
      0.1
    ],
    [
      "devoir",
      0.1
    ]
  ],
  "sucer": [
    [
      "absorber",
      0.1
    ],
    [
      "aspirer",
      0.1
    ],
    [
      "boire",
      0.1
    ],
    [
      "pomper",
      0.1
    ],
    [
      "manger",
      0.075
    ],
    [
      "s'abreuver",
      0.075
    ],
    [
      "tirer",
      0.075
    ],
    [
      "teter",
      0.05
    ],
    [
      "extraire",
      0.05
    ],
    [
      "attirer",
      0.05
    ],
    [
      "super",
      0.025
    ],
    [
      "siroter",
      0.025
    ],
    [
      "ruiner",
      0.025
    ],
    [
      "lecher",
      0.025
    ],
    [
      "extorquer",
      0.025
    ],
    [
      "exprimer",
      0.025
    ],
    [
      "brouter",
      0.025
    ],
    [
      "appauvrir",
      0.025
    ],
    [
      "sucoter",
      0.025
    ]
  ],
  "pouce": [
    [
      "doigt",
      0.5
    ]
  ],
  "quoi": [
    [
      "dont",
      0.1325
    ],
    [
      "tiens",
      0.065
    ],
    [
      "sujet",
      0.065
    ],
    [
      "raison",
      0.065
    ],
    [
      "quid",
      0.065
    ],
    [
      "quel",
      0.065
    ],
    [
      "lesquels",
      0.065
    ],
    [
      "lesquelles",
      0.065
    ],
    [
      "lequel",
      0.065
    ],
    [
      "laquelle",
      0.065
    ],
    [
      "hein",
      0.065
    ],
    [
      "eh",
      0.065
    ],
    [
      "comment",
      0.065
    ]
  ],
  "bouffer": [
    [
      "manger",
      0.215
    ],
    [
      "bafrer",
      0.0625
    ],
    [
      "gonfler",
      0.0625
    ],
    [
      "avaler",
      0.05
    ],
    [
      "briffer",
      0.05
    ],
    [
      "devorer",
      0.05
    ],
    [
      "s'empiffrer",
      0.0375
    ],
    [
      "escamoter",
      0.0375
    ],
    [
      "enfler",
      0.0375
    ],
    [
      "croquer",
      0.0375
    ],
    [
      "boulotter",
      0.0375
    ],
    [
      "souffler",
      0.0225
    ],
    [
      "empiffrer",
      0.0225
    ],
    [
      "boustifailler",
      0.0225
    ],
    [
      "becqueter",
      0.0225
    ],
    [
      "jaffer",
      0.01
    ],
    [
      "grailler",
      0.01
    ],
    [
      "goinfrer",
      0.01
    ],
    [
      "diner",
      0.01
    ],
    [
      "dejeuner",
      0.01
    ],
    [
      "crouter",
      0.01
    ],
    [
      "consommer",
      0.01
    ],
    [
      "cloquer",
      0.01
    ],
    [
      "bequiller",
      0.01
    ],
    [
      "bomber",
      0.01
    ],
    [
      "blouser",
      0.01
    ],
    [
      "ballonner",
      0.01
    ],
    [
      "tortorer",
      0.01
    ]
  ],
  "nos": [
    [
      "theatre",
      1.0
    ]
  ],
  "vie": [
    [
      "ardeur",
      0.105
    ],
    [
      "vivacite",
      0.08
    ],
    [
      "animation",
      0.05
    ],
    [
      "vigueur",
      0.05
    ],
    [
      "activite",
      0.0475
    ],
    [
      "vitalite",
      0.0475
    ],
    [
      "bouillonnement",
      0.04
    ],
    [
      "chaleur",
      0.035
    ],
    [
      "mouvement",
      0.03
    ],
    [
      "force",
      0.03
    ],
    [
      "entrain",
      0.03
    ],
    [
      "energie",
      0.0275
    ],
    [
      "dynamisme",
      0.025
    ],
    [
      "existence",
      0.025
    ],
    [
      "petulance",
      0.02
    ],
    [
      "ame",
      0.0175
    ],
    [
      "esprit",
      0.0175
    ],
    [
      "allant",
      0.0175
    ],
    [
      "action",
      0.0125
    ],
    [
      "couleur",
      0.0125
    ],
    [
      "destin",
      0.0125
    ],
    [
      "jour",
      0.0125
    ],
    [
      "temps",
      0.0125
    ],
    [
      "etat",
      0.0125
    ],
    [
      "naturel",
      0.01
    ],
    [
      "histoire",
      0.01
    ],
    [
      "generation",
      0.01
    ],
    [
      "fortune",
      0.01
    ],
    [
      "etre",
      0.005
    ],
    [
      "evolution",
      0.005
    ],
    [
      "age",
      0.005
    ],
    [
      "seve",
      0.005
    ],
    [
      "subsistance",
      0.005
    ],
    [
      "sort",
      0.005
    ],
    [
      "passion",
      0.005
    ],
    [
      "nourriture",
      0.005
    ],
    [
      "allegresse",
      0.005
    ],
    [
      "destinee",
      0.005
    ],
    [
      "fraicheur",
      0.005
    ],
    [
      "jours",
      0.005
    ],
    [
      "montant",
      0.005
    ],
    [
      "longevite",
      0.0025
    ],
    [
      "lumiere",
      0.0025
    ],
    [
      "moeurs",
      0.0025
    ],
    [
      "parasitisme",
      0.0025
    ],
    [
      "pittoresque",
      0.0025
    ],
    [
      "reviviscence",
      0.0025
    ],
    [
      "sante",
      0.0025
    ],
    [
      "souffle",
      0.0025
    ],
    [
      "survie",
      0.0025
    ],
    [
      "journee",
      0.0025
    ],
    [
      "fete",
      0.0025
    ],
    [
      "fecondation",
      0.0025
    ],
    [
      "autobiographie",
      0.0025
    ],
    [
      "bifteck",
      0.0025
    ],
    [
      "capital",
      0.0025
    ],
    [
      "carriere",
      0.0025
    ],
    [
      "comedie",
      0.0025
    ],
    [
      "croute",
      0.0025
    ],
    [
      "creation",
      0.0025
    ],
    [
      "discussion",
      0.0025
    ],
    [
      "expression",
      0.0025
    ],
    [
      "symbiose",
      0.0025
    ]
  ],
  "rose": [
    [
      "rosir",
      1.0
    ]
  ],
  "roser": [
    [
      "rosir",
      1.0
    ]
  ],
  "proposer": [
    [
      "presenter",
      0.1825
    ],
    [
      "offrir",
      0.1575
    ],
    [
      "avancer",
      0.13
    ],
    [
      "exposer",
      0.105
    ],
    [
      "soumettre",
      0.105
    ],
    [
      "enoncer",
      0.0525
    ],
    [
      "suggerer",
      0.0525
    ],
    [
      "agiter",
      0.025
    ],
    [
      "conseiller",
      0.025
    ],
    [
      "montrer",
      0.025
    ],
    [
      "promettre",
      0.025
    ],
    [
      "preter",
      0.025
    ]
  ],
  "les": [
    [
      "bande",
      0.165
    ],
    [
      "chemin",
      0.165
    ],
    [
      "halage",
      0.165
    ],
    [
      "laize",
      0.165
    ],
    [
      "largeur",
      0.165
    ],
    [
      "sentier",
      0.165
    ]
  ],
  "quantite": [
    [
      "multitude",
      0.12
    ],
    [
      "foule",
      0.0725
    ],
    [
      "masse",
      0.07
    ],
    [
      "affluence",
      0.055
    ],
    [
      "tas",
      0.05
    ],
    [
      "flot",
      0.03
    ],
    [
      "amas",
      0.0275
    ],
    [
      "nuee",
      0.0275
    ],
    [
      "peuple",
      0.0225
    ],
    [
      "armee",
      0.02
    ],
    [
      "abondance",
      0.02
    ],
    [
      "avalanche",
      0.015
    ],
    [
      "deluge",
      0.015
    ],
    [
      "essaim",
      0.015
    ],
    [
      "tapee",
      0.015
    ],
    [
      "ribambelle",
      0.0125
    ],
    [
      "kyrielle",
      0.0125
    ],
    [
      "collection",
      0.0125
    ],
    [
      "accumulation",
      0.0125
    ],
    [
      "pluie",
      0.01
    ],
    [
      "mer",
      0.01
    ],
    [
      "flopee",
      0.01
    ],
    [
      "charge",
      0.01
    ],
    [
      "volee",
      0.0075
    ],
    [
      "volume",
      0.0075
    ],
    [
      "tripotee",
      0.0075
    ],
    [
      "poids",
      0.0075
    ],
    [
      "mesure",
      0.0075
    ],
    [
      "grandeur",
      0.0075
    ],
    [
      "capacite",
      0.0075
    ],
    [
      "bloc",
      0.0075
    ],
    [
      "monceau",
      0.005
    ],
    [
      "nombre",
      0.005
    ],
    [
      "paquet",
      0.005
    ],
    [
      "pullulement",
      0.005
    ],
    [
      "somme",
      0.005
    ],
    [
      "serie",
      0.005
    ],
    [
      "total",
      0.005
    ],
    [
      "luxe",
      0.005
    ],
    [
      "grele",
      0.005
    ],
    [
      "concours",
      0.005
    ],
    [
      "dose",
      0.005
    ],
    [
      "encombrement",
      0.005
    ],
    [
      "ensemble",
      0.005
    ],
    [
      "entassement",
      0.005
    ],
    [
      "foison",
      0.005
    ],
    [
      "force",
      0.005
    ],
    [
      "infinite",
      0.0025
    ],
    [
      "legion",
      0.0025
    ],
    [
      "montagne",
      0.0025
    ],
    [
      "multiplicite",
      0.0025
    ],
    [
      "potee",
      0.0025
    ],
    [
      "provision",
      0.0025
    ],
    [
      "regiment",
      0.0025
    ],
    [
      "immensite",
      0.0025
    ],
    [
      "fret",
      0.0025
    ],
    [
      "apport",
      0.0025
    ],
    [
      "averse",
      0.0025
    ],
    [
      "contingent",
      0.0025
    ],
    [
      "debauche",
      0.0025
    ],
    [
      "exces",
      0.0025
    ],
    [
      "fleuve",
      0.0025
    ],
    [
      "fourmillement",
      0.0025
    ],
    [
      "moisson",
      0.0
    ],
    [
      "monde",
      0.0
    ],
    [
      "myriade",
      0.0
    ],
    [
      "nuage",
      0.0
    ],
    [
      "prise",
      0.0
    ],
    [
      "quantum",
      0.0
    ],
    [
      "jonchee",
      0.0
    ],
    [
      "foultitude",
      0.0
    ],
    [
      "foret",
      0.0
    ],
    [
      "contenance",
      0.0
    ],
    [
      "chiee",
      0.0
    ],
    [
      "categorie",
      0.0
    ],
    [
      "bout",
      0.0
    ],
    [
      "arsenal",
      0.0
    ],
    [
      "quota",
      0.0
    ]
  ],
  "choses": [
    [
      "fait",
      0.1
    ],
    [
      "bien",
      0.0825
    ],
    [
      "bidule",
      0.0675
    ],
    [
      "truc",
      0.0675
    ],
    [
      "evenement",
      0.05
    ],
    [
      "patrimoine",
      0.05
    ],
    [
      "machin",
      0.05
    ],
    [
      "affaire",
      0.05
    ],
    [
      "realite",
      0.0325
    ],
    [
      "richesse",
      0.0325
    ],
    [
      "propriete",
      0.0325
    ],
    [
      "possession",
      0.0325
    ],
    [
      "objet",
      0.0325
    ],
    [
      "circonstance",
      0.0325
    ],
    [
      "capital",
      0.0325
    ],
    [
      "bagatelle",
      0.0325
    ],
    [
      "sujet",
      0.015
    ],
    [
      "rien",
      0.015
    ],
    [
      "phenomene",
      0.015
    ],
    [
      "instrument",
      0.015
    ],
    [
      "fourbi",
      0.015
    ],
    [
      "esclave",
      0.015
    ],
    [
      "condition",
      0.015
    ],
    [
      "bricole",
      0.015
    ],
    [
      "batifolage",
      0.015
    ],
    [
      "babiole",
      0.015
    ],
    [
      "action",
      0.015
    ],
    [
      "trucmuche",
      0.015
    ]
  ],
  "chose": [
    [
      "fait",
      0.1
    ],
    [
      "bien",
      0.0825
    ],
    [
      "bidule",
      0.0675
    ],
    [
      "truc",
      0.0675
    ],
    [
      "evenement",
      0.05
    ],
    [
      "patrimoine",
      0.05
    ],
    [
      "machin",
      0.05
    ],
    [
      "affaire",
      0.05
    ],
    [
      "realite",
      0.0325
    ],
    [
      "richesse",
      0.0325
    ],
    [
      "propriete",
      0.0325
    ],
    [
      "possession",
      0.0325
    ],
    [
      "objet",
      0.0325
    ],
    [
      "circonstance",
      0.0325
    ],
    [
      "capital",
      0.0325
    ],
    [
      "bagatelle",
      0.0325
    ],
    [
      "sujet",
      0.015
    ],
    [
      "rien",
      0.015
    ],
    [
      "phenomene",
      0.015
    ],
    [
      "instrument",
      0.015
    ],
    [
      "fourbi",
      0.015
    ],
    [
      "esclave",
      0.015
    ],
    [
      "condition",
      0.015
    ],
    [
      "bricole",
      0.015
    ],
    [
      "batifolage",
      0.015
    ],
    [
      "babiole",
      0.015
    ],
    [
      "action",
      0.015
    ],
    [
      "trucmuche",
      0.015
    ]
  ],
  "envie": [
    [
      "desir",
      0.1675
    ],
    [
      "soif",
      0.095
    ],
    [
      "appetit",
      0.08
    ],
    [
      "convoitise",
      0.0625
    ],
    [
      "faim",
      0.055
    ],
    [
      "appetence",
      0.0475
    ],
    [
      "caprice",
      0.0475
    ],
    [
      "avidite",
      0.0375
    ],
    [
      "gout",
      0.03
    ],
    [
      "concupiscence",
      0.03
    ],
    [
      "besoin",
      0.03
    ],
    [
      "fantaisie",
      0.0225
    ],
    [
      "humeur",
      0.0225
    ],
    [
      "souhait",
      0.0225
    ],
    [
      "toquade",
      0.015
    ],
    [
      "tache",
      0.015
    ],
    [
      "naevus",
      0.015
    ],
    [
      "jalousie",
      0.015
    ],
    [
      "inclination",
      0.015
    ],
    [
      "fringale",
      0.015
    ],
    [
      "demangeaison",
      0.015
    ],
    [
      "cupidite",
      0.015
    ],
    [
      "peau",
      0.0075
    ],
    [
      "peche",
      0.0075
    ],
    [
      "rivalite",
      0.0075
    ],
    [
      "tentation",
      0.0075
    ],
    [
      "mechancete",
      0.0075
    ],
    [
      "marque",
      0.0075
    ],
    [
      "lubie",
      0.0075
    ],
    [
      "libido",
      0.0075
    ],
    [
      "fureur",
      0.0075
    ],
    [
      "dessein",
      0.0075
    ],
    [
      "demande",
      0.0075
    ],
    [
      "velleite",
      0.0075
    ]
  ],
  "envier": [
    [
      "convoiter",
      0.165
    ],
    [
      "desirer",
      0.165
    ],
    [
      "souhaiter",
      0.165
    ],
    [
      "vouloir",
      0.165
    ],
    [
      "refuser",
      0.055
    ],
    [
      "jalouser",
      0.055
    ],
    [
      "hair",
      0.055
    ],
    [
      "guigner",
      0.055
    ],
    [
      "soupirer",
      0.055
    ]
  ],
  "bonheur": [
    [
      "joie",
      0.0925
    ],
    [
      "felicite",
      0.07
    ],
    [
      "plaisir",
      0.05
    ],
    [
      "beatitude",
      0.045
    ],
    [
      "bien",
      0.04
    ],
    [
      "satisfaction",
      0.035
    ],
    [
      "prosperite",
      0.035
    ],
    [
      "chance",
      0.035
    ],
    [
      "succes",
      0.03
    ],
    [
      "benediction",
      0.0275
    ],
    [
      "calme",
      0.0275
    ],
    [
      "ravissement",
      0.0225
    ],
    [
      "delice",
      0.0225
    ],
    [
      "contentement",
      0.0225
    ],
    [
      "bienfait",
      0.0225
    ],
    [
      "volupte",
      0.0175
    ],
    [
      "faveur",
      0.0175
    ],
    [
      "extase",
      0.0175
    ],
    [
      "euphorie",
      0.0175
    ],
    [
      "douceur",
      0.0175
    ],
    [
      "veine",
      0.0125
    ],
    [
      "serenite",
      0.0125
    ],
    [
      "paix",
      0.0125
    ],
    [
      "nirvana",
      0.0125
    ],
    [
      "gaiete",
      0.0125
    ],
    [
      "enivrement",
      0.0125
    ],
    [
      "enchantement",
      0.0125
    ],
    [
      "delectation",
      0.0125
    ],
    [
      "avantage",
      0.0125
    ],
    [
      "allegresse",
      0.0125
    ],
    [
      "agrement",
      0.0125
    ],
    [
      "salut",
      0.0075
    ],
    [
      "reussite",
      0.0075
    ],
    [
      "fortune",
      0.0075
    ],
    [
      "ataraxie",
      0.0075
    ],
    [
      "voyage",
      0.0025
    ],
    [
      "relaxation",
      0.0025
    ],
    [
      "pot",
      0.0025
    ],
    [
      "ideal",
      0.0025
    ],
    [
      "heur",
      0.0025
    ],
    [
      "habilete",
      0.0025
    ],
    [
      "consolation",
      0.0025
    ],
    [
      "brio",
      0.0025
    ],
    [
      "aubaine",
      0.0025
    ]
  ],
  "plein": [
    [
      "rempli",
      0.07
    ],
    [
      "abondant",
      0.06
    ],
    [
      "fort",
      0.0425
    ],
    [
      "gros",
      0.0425
    ],
    [
      "riche",
      0.0325
    ],
    [
      "gras",
      0.03
    ],
    [
      "bourre",
      0.0275
    ],
    [
      "charge",
      0.025
    ],
    [
      "rebondi",
      0.025
    ],
    [
      "lourd",
      0.02
    ],
    [
      "touffu",
      0.015
    ],
    [
      "sature",
      0.015
    ],
    [
      "replet",
      0.015
    ],
    [
      "debordant",
      0.015
    ],
    [
      "bouffi",
      0.015
    ],
    [
      "soul",
      0.0125
    ],
    [
      "rond",
      0.0125
    ],
    [
      "petri",
      0.0125
    ],
    [
      "penetre",
      0.0125
    ],
    [
      "ivre",
      0.0125
    ],
    [
      "gonfle",
      0.0125
    ],
    [
      "gave",
      0.0125
    ],
    [
      "dense",
      0.0125
    ],
    [
      "complet",
      0.0125
    ],
    [
      "beaucoup",
      0.0125
    ],
    [
      "ample",
      0.0125
    ],
    [
      "repu",
      0.01
    ],
    [
      "rassasie",
      0.01
    ],
    [
      "potele",
      0.01
    ],
    [
      "plantureux",
      0.01
    ],
    [
      "nourri",
      0.01
    ],
    [
      "dodu",
      0.01
    ],
    [
      "charnu",
      0.01
    ],
    [
      "peuple",
      0.0075
    ],
    [
      "retentissant",
      0.0075
    ],
    [
      "resonnant",
      0.0075
    ],
    [
      "sonore",
      0.0075
    ],
    [
      "total",
      0.0075
    ],
    [
      "etoffe",
      0.0075
    ],
    [
      "mafflu",
      0.0075
    ],
    [
      "herisse",
      0.0075
    ],
    [
      "hante",
      0.0075
    ],
    [
      "bon",
      0.0075
    ],
    [
      "comble",
      0.0075
    ],
    [
      "entier",
      0.0075
    ],
    [
      "fertile",
      0.0075
    ],
    [
      "foisonnant",
      0.0075
    ],
    [
      "franc",
      0.0075
    ],
    [
      "habite",
      0.005
    ],
    [
      "integral",
      0.005
    ],
    [
      "maint",
      0.005
    ],
    [
      "massif",
      0.005
    ],
    [
      "poupard",
      0.005
    ],
    [
      "pourri",
      0.005
    ],
    [
      "preoccupe",
      0.005
    ],
    [
      "serre",
      0.005
    ],
    [
      "tonitruant",
      0.005
    ],
    [
      "tout",
      0.005
    ],
    [
      "eclatant",
      0.005
    ],
    [
      "grouillant",
      0.005
    ],
    [
      "fourmillant",
      0.005
    ],
    [
      "force",
      0.005
    ],
    [
      "absolu",
      0.005
    ],
    [
      "bonde",
      0.005
    ],
    [
      "coeur",
      0.005
    ],
    [
      "comble",
      0.005
    ],
    [
      "couvert",
      0.005
    ],
    [
      "encombre",
      0.005
    ],
    [
      "enfle",
      0.005
    ],
    [
      "enivre",
      0.005
    ],
    [
      "extremement",
      0.005
    ],
    [
      "farci",
      0.005
    ],
    [
      "plain",
      0.0
    ],
    [
      "plenier",
      0.0
    ],
    [
      "pete",
      0.0
    ],
    [
      "ras",
      0.0
    ],
    [
      "regorgeant",
      0.0
    ],
    [
      "vaste",
      0.0
    ],
    [
      "obsede",
      0.0
    ],
    [
      "maximum",
      0.0
    ],
    [
      "leste",
      0.0
    ],
    [
      "arrondi",
      0.0
    ],
    [
      "beurre",
      0.0
    ],
    [
      "devore",
      0.0
    ],
    [
      "empli",
      0.0
    ],
    [
      "empreint",
      0.0
    ],
    [
      "imbu",
      0.0
    ],
    [
      "impregne",
      0.0
    ],
    [
      "inonde",
      0.0
    ]
  ],
  "armoire": [
    [
      "bahut",
      0.1475
    ],
    [
      "buffet",
      0.11
    ],
    [
      "commode",
      0.11
    ],
    [
      "penderie",
      0.11
    ],
    [
      "placard",
      0.0725
    ],
    [
      "bonnetiere",
      0.0725
    ],
    [
      "tabernacle",
      0.035
    ],
    [
      "semainier",
      0.035
    ],
    [
      "panetiere",
      0.035
    ],
    [
      "habitacle",
      0.035
    ],
    [
      "coffre",
      0.035
    ],
    [
      "bureau",
      0.035
    ],
    [
      "bibliotheque",
      0.035
    ],
    [
      "vaisselier",
      0.035
    ]
  ],
  "derisoire": [
    [
      "petit",
      0.1175
    ],
    [
      "insignifiant",
      0.1075
    ],
    [
      "minime",
      0.095
    ],
    [
      "faible",
      0.085
    ],
    [
      "pietre",
      0.085
    ],
    [
      "modique",
      0.0625
    ],
    [
      "pauvre",
      0.0525
    ],
    [
      "chetif",
      0.0425
    ],
    [
      "miserable",
      0.0425
    ],
    [
      "ridicule",
      0.0425
    ],
    [
      "reduit",
      0.03
    ],
    [
      "modeste",
      0.03
    ],
    [
      "infime",
      0.03
    ],
    [
      "dedaigneux",
      0.02
    ],
    [
      "moqueur",
      0.02
    ],
    [
      "negligeable",
      0.02
    ],
    [
      "railleur",
      0.01
    ],
    [
      "piteux",
      0.01
    ],
    [
      "meprisant",
      0.01
    ],
    [
      "mineur",
      0.01
    ],
    [
      "limite",
      0.01
    ],
    [
      "lilliputien",
      0.01
    ],
    [
      "ironique",
      0.01
    ],
    [
      "comique",
      0.01
    ],
    [
      "vain",
      0.01
    ]
  ],
  "car": [
    [
      "autobus",
      0.1
    ],
    [
      "patache",
      0.1
    ],
    [
      "puisque",
      0.1
    ],
    [
      "voiture",
      0.0475
    ],
    [
      "effectivement",
      0.0475
    ],
    [
      "courrier",
      0.0475
    ],
    [
      "comme",
      0.0475
    ],
    [
      "bus",
      0.0475
    ],
    [
      "autocar",
      0.0475
    ]
  ],
  "sentimental": [
    [
      "tendre",
      0.2
    ],
    [
      "amoureux",
      0.1425
    ],
    [
      "sensible",
      0.1425
    ],
    [
      "affectueux",
      0.1125
    ],
    [
      "romanesque",
      0.055
    ],
    [
      "langoureux",
      0.055
    ],
    [
      "bon",
      0.055
    ],
    [
      "spirituel",
      0.0275
    ],
    [
      "romantique",
      0.0275
    ],
    [
      "poetique",
      0.0275
    ],
    [
      "galant",
      0.0275
    ],
    [
      "calin",
      0.0275
    ],
    [
      "affectif",
      0.0275
    ],
    [
      "transi",
      0.0275
    ]
  ],
  "soif": [
    [
      "desir",
      0.2275
    ],
    [
      "appetit",
      0.0625
    ],
    [
      "envie",
      0.05
    ],
    [
      "souhait",
      0.05
    ],
    [
      "convoitise",
      0.0425
    ],
    [
      "faim",
      0.0325
    ],
    [
      "aspiration",
      0.0325
    ],
    [
      "ambition",
      0.0325
    ],
    [
      "appetence",
      0.025
    ],
    [
      "avidite",
      0.025
    ],
    [
      "caprice",
      0.025
    ],
    [
      "volonte",
      0.02
    ],
    [
      "pretention",
      0.02
    ],
    [
      "gout",
      0.02
    ],
    [
      "demande",
      0.02
    ],
    [
      "besoin",
      0.02
    ],
    [
      "attrait",
      0.02
    ],
    [
      "impatience",
      0.015
    ],
    [
      "exigence",
      0.015
    ],
    [
      "esperance",
      0.015
    ],
    [
      "curiosite",
      0.015
    ],
    [
      "appel",
      0.015
    ],
    [
      "voeu",
      0.0125
    ],
    [
      "reve",
      0.0125
    ],
    [
      "desiderata",
      0.0125
    ],
    [
      "attente",
      0.0125
    ],
    [
      "tentation",
      0.0075
    ],
    [
      "recherche",
      0.0075
    ],
    [
      "quete",
      0.0075
    ],
    [
      "prurit",
      0.0075
    ],
    [
      "fantaisie",
      0.0075
    ],
    [
      "espoir",
      0.0075
    ],
    [
      "demangeaison",
      0.0075
    ],
    [
      "cupidite",
      0.0075
    ],
    [
      "attirance",
      0.0075
    ],
    [
      "penchant",
      0.0025
    ],
    [
      "potomanie",
      0.0025
    ],
    [
      "pepie",
      0.0025
    ],
    [
      "vanite",
      0.0025
    ],
    [
      "visee",
      0.0025
    ],
    [
      "nostalgie",
      0.0025
    ],
    [
      "interet",
      0.0025
    ],
    [
      "force",
      0.0025
    ],
    [
      "fievre",
      0.0025
    ],
    [
      "dipsomanie",
      0.0025
    ],
    [
      "anadipsie",
      0.0025
    ],
    [
      "alteration",
      0.0025
    ],
    [
      "vouloir",
      0.0025
    ]
  ],
  "ideal": [
    [
      "parfait",
      0.1
    ],
    [
      "beau",
      0.0625
    ],
    [
      "modele",
      0.0525
    ],
    [
      "absolu",
      0.04
    ],
    [
      "sublime",
      0.035
    ],
    [
      "bien",
      0.035
    ],
    [
      "imaginaire",
      0.0275
    ],
    [
      "pur",
      0.0275
    ],
    [
      "type",
      0.0275
    ],
    [
      "supreme",
      0.0225
    ],
    [
      "perfection",
      0.0225
    ],
    [
      "exemplaire",
      0.0225
    ],
    [
      "abstrait",
      0.0225
    ],
    [
      "eleve",
      0.0175
    ],
    [
      "transcendant",
      0.0175
    ],
    [
      "souverain",
      0.0175
    ],
    [
      "reve",
      0.0175
    ],
    [
      "merveilleux",
      0.0175
    ],
    [
      "impossible",
      0.0175
    ],
    [
      "immateriel",
      0.0175
    ],
    [
      "consomme",
      0.0175
    ],
    [
      "complet",
      0.0175
    ],
    [
      "chimerique",
      0.0175
    ],
    [
      "accompli",
      0.0175
    ],
    [
      "radical",
      0.01
    ],
    [
      "surnaturel",
      0.01
    ],
    [
      "theorique",
      0.01
    ],
    [
      "tresor",
      0.01
    ],
    [
      "unique",
      0.01
    ],
    [
      "utopique",
      0.01
    ],
    [
      "platonique",
      0.01
    ],
    [
      "phenix",
      0.01
    ],
    [
      "parangon",
      0.01
    ],
    [
      "archetype",
      0.01
    ],
    [
      "canon",
      0.01
    ],
    [
      "exemple",
      0.01
    ],
    [
      "heureux",
      0.01
    ],
    [
      "imagination",
      0.01
    ],
    [
      "inaccessible",
      0.01
    ],
    [
      "poetique",
      0.005
    ],
    [
      "privilegie",
      0.005
    ],
    [
      "prototype",
      0.005
    ],
    [
      "reve",
      0.005
    ],
    [
      "sensationnel",
      0.005
    ],
    [
      "sujet",
      0.005
    ],
    [
      "utopie",
      0.005
    ],
    [
      "valeur",
      0.005
    ],
    [
      "optimal",
      0.005
    ],
    [
      "illusoire",
      0.005
    ],
    [
      "ambition",
      0.005
    ],
    [
      "aspiration",
      0.005
    ],
    [
      "bible",
      0.005
    ],
    [
      "bonheur",
      0.005
    ],
    [
      "fumee",
      0.005
    ],
    [
      "felicite",
      0.005
    ],
    [
      "genre",
      0.005
    ],
    [
      "idyllique",
      0.005
    ],
    [
      "ideel",
      0.005
    ]
  ],
  "etoiler": [
    [
      "consteller",
      0.25
    ],
    [
      "feler",
      0.25
    ],
    [
      "eclairer",
      0.25
    ],
    [
      "emailler",
      0.25
    ]
  ],
  "etoile": [
    [
      "consteller",
      0.25
    ],
    [
      "feler",
      0.25
    ],
    [
      "eclairer",
      0.25
    ],
    [
      "emailler",
      0.25
    ]
  ],
  "voile": [
    [
      "manteau",
      0.1075
    ],
    [
      "voilage",
      0.0525
    ],
    [
      "rideau",
      0.0525
    ],
    [
      "pretexte",
      0.0525
    ],
    [
      "masque",
      0.0525
    ],
    [
      "mantille",
      0.0525
    ],
    [
      "coiffure",
      0.0525
    ],
    [
      "apparence",
      0.0525
    ],
    [
      "palais",
      0.025
    ],
    [
      "polacre",
      0.025
    ],
    [
      "poele",
      0.025
    ],
    [
      "tchador",
      0.025
    ],
    [
      "toile",
      0.025
    ],
    [
      "velet",
      0.025
    ],
    [
      "voilement",
      0.025
    ],
    [
      "voilette",
      0.025
    ],
    [
      "nuage",
      0.025
    ],
    [
      "mystere",
      0.025
    ],
    [
      "litham",
      0.025
    ],
    [
      "bateau",
      0.025
    ],
    [
      "couvert",
      0.025
    ],
    [
      "crepe",
      0.025
    ],
    [
      "embrouillement",
      0.025
    ],
    [
      "enveloppe",
      0.025
    ],
    [
      "gaze",
      0.025
    ],
    [
      "imbroglio",
      0.025
    ],
    [
      "linceul",
      0.025
    ],
    [
      "echarpe",
      0.025
    ]
  ],
  "voiler": [
    [
      "cacher",
      0.1325
    ],
    [
      "dissimuler",
      0.08
    ],
    [
      "masquer",
      0.08
    ],
    [
      "couvrir",
      0.065
    ],
    [
      "deguiser",
      0.0575
    ],
    [
      "obscurcir",
      0.05
    ],
    [
      "eteindre",
      0.035
    ],
    [
      "eclipser",
      0.035
    ],
    [
      "farder",
      0.035
    ],
    [
      "envelopper",
      0.035
    ],
    [
      "camoufler",
      0.0275
    ],
    [
      "estomper",
      0.0275
    ],
    [
      "murer",
      0.0275
    ],
    [
      "occulter",
      0.0275
    ],
    [
      "tamiser",
      0.0275
    ],
    [
      "travestir",
      0.02
    ],
    [
      "pallier",
      0.02
    ],
    [
      "celer",
      0.02
    ],
    [
      "attenuer",
      0.02
    ],
    [
      "ternir",
      0.0125
    ],
    [
      "ouater",
      0.0125
    ],
    [
      "intercepter",
      0.0125
    ],
    [
      "entourer",
      0.0125
    ],
    [
      "recouvrir",
      0.005
    ],
    [
      "noyer",
      0.005
    ],
    [
      "gazer",
      0.005
    ],
    [
      "gauchir",
      0.005
    ],
    [
      "filtrer",
      0.005
    ],
    [
      "envoiler",
      0.005
    ],
    [
      "enrouer",
      0.005
    ],
    [
      "effumer",
      0.005
    ],
    [
      "derober",
      0.005
    ],
    [
      "aveugler",
      0.005
    ],
    [
      "taire",
      0.005
    ]
  ],
  "commercial": [
    [
      "break",
      0.3325
    ],
    [
      "commercant",
      0.3325
    ],
    [
      "fourgonnette",
      0.3325
    ]
  ],
  "voir": [
    [
      "examiner",
      0.0425
    ],
    [
      "apercevoir",
      0.04
    ],
    [
      "comprendre",
      0.04
    ],
    [
      "decouvrir",
      0.04
    ],
    [
      "concevoir",
      0.0375
    ],
    [
      "saisir",
      0.035
    ],
    [
      "connaitre",
      0.035
    ],
    [
      "entendre",
      0.03
    ],
    [
      "regarder",
      0.03
    ],
    [
      "penser",
      0.03
    ],
    [
      "considerer",
      0.0275
    ],
    [
      "remarquer",
      0.0225
    ],
    [
      "juger",
      0.0225
    ],
    [
      "imaginer",
      0.0225
    ],
    [
      "percevoir",
      0.02
    ],
    [
      "observer",
      0.02
    ],
    [
      "penetrer",
      0.02
    ],
    [
      "trouver",
      0.0175
    ],
    [
      "verifier",
      0.0175
    ],
    [
      "discerner",
      0.015
    ],
    [
      "constater",
      0.015
    ],
    [
      "experimenter",
      0.015
    ],
    [
      "pratiquer",
      0.015
    ],
    [
      "eprouver",
      0.015
    ],
    [
      "etudier",
      0.0125
    ],
    [
      "reperer",
      0.0125
    ],
    [
      "controler",
      0.0125
    ],
    [
      "apprecier",
      0.0125
    ],
    [
      "estimer",
      0.01
    ],
    [
      "frequenter",
      0.01
    ],
    [
      "suivre",
      0.01
    ],
    [
      "s'apercevoir",
      0.0075
    ],
    [
      "percer",
      0.0075
    ],
    [
      "envisager",
      0.0075
    ],
    [
      "embrasser",
      0.0075
    ],
    [
      "distinguer",
      0.0075
    ],
    [
      "reflechir",
      0.005
    ],
    [
      "realiser",
      0.005
    ],
    [
      "peser",
      0.005
    ],
    [
      "noter",
      0.005
    ],
    [
      "entrevoir",
      0.005
    ],
    [
      "contempler",
      0.005
    ],
    [
      "aviser",
      0.005
    ],
    [
      "assister",
      0.005
    ],
    [
      "visiter",
      0.005
    ],
    [
      "viser",
      0.005
    ],
    [
      "veiller",
      0.005
    ],
    [
      "rencontrer",
      0.005
    ],
    [
      "inspecter",
      0.005
    ],
    [
      "frayer",
      0.005
    ],
    [
      "analyser",
      0.005
    ],
    [
      "subir",
      0.0025
    ],
    [
      "surprendre",
      0.0025
    ],
    [
      "zieuter",
      0.0025
    ],
    [
      "ecouter",
      0.0025
    ],
    [
      "savoir",
      0.0025
    ],
    [
      "admettre",
      0.0025
    ],
    [
      "lire",
      0.0025
    ],
    [
      "prevoir",
      0.0025
    ],
    [
      "recoler",
      0.0025
    ],
    [
      "s'assurer",
      0.0025
    ],
    [
      "s'enquerir",
      0.0025
    ],
    [
      "s'accointer",
      0.0025
    ],
    [
      "revoir",
      0.0025
    ],
    [
      "jauger",
      0.0025
    ],
    [
      "inventorier",
      0.0025
    ],
    [
      "donner",
      0.0025
    ],
    [
      "dominer",
      0.0025
    ],
    [
      "croiser",
      0.0025
    ],
    [
      "surplomber",
      0.0
    ],
    [
      "survenir",
      0.0
    ],
    [
      "visionner",
      0.0
    ],
    [
      "visualiser",
      0.0
    ],
    [
      "voisiner",
      0.0
    ],
    [
      "voyager",
      0.0
    ],
    [
      "s'informer",
      0.0
    ],
    [
      "s'imaginer",
      0.0
    ],
    [
      "planer",
      0.0
    ],
    [
      "mater",
      0.0
    ],
    [
      "loucher",
      0.0
    ],
    [
      "contacter",
      0.0
    ],
    [
      "commercer",
      0.0
    ]
  ],
  "comme": [
    [
      "ainsi",
      0.07
    ],
    [
      "avec",
      0.0525
    ],
    [
      "quand",
      0.035
    ],
    [
      "pareillement",
      0.035
    ],
    [
      "combien",
      0.035
    ],
    [
      "pour",
      0.015
    ],
    [
      "presque",
      0.015
    ],
    [
      "puisque",
      0.015
    ],
    [
      "quasi",
      0.015
    ],
    [
      "que",
      0.015
    ],
    [
      "semblable",
      0.015
    ],
    [
      "tant",
      0.015
    ],
    [
      "tel",
      0.015
    ],
    [
      "car",
      0.015
    ],
    [
      "comment",
      0.015
    ],
    [
      "en",
      0.015
    ],
    [
      "et",
      0.015
    ],
    [
      "egalement",
      0.015
    ]
  ],
  "se": [],
  "degager": [
    [
      "debarrasser",
      0.0575
    ],
    [
      "liberer",
      0.055
    ],
    [
      "enlever",
      0.04
    ],
    [
      "defaire",
      0.035
    ],
    [
      "oter",
      0.035
    ],
    [
      "decharger",
      0.0325
    ],
    [
      "detacher",
      0.03
    ],
    [
      "tirer",
      0.0275
    ],
    [
      "affranchir",
      0.025
    ],
    [
      "eclaircir",
      0.0225
    ],
    [
      "separer",
      0.0225
    ],
    [
      "sortir",
      0.0225
    ],
    [
      "reveler",
      0.0225
    ],
    [
      "exhaler",
      0.0225
    ],
    [
      "depouiller",
      0.0225
    ],
    [
      "extraire",
      0.0175
    ],
    [
      "partir",
      0.015
    ],
    [
      "montrer",
      0.015
    ],
    [
      "developper",
      0.015
    ],
    [
      "denouer",
      0.015
    ],
    [
      "delivrer",
      0.015
    ],
    [
      "delier",
      0.015
    ],
    [
      "decouvrir",
      0.015
    ],
    [
      "debrouiller",
      0.015
    ],
    [
      "emettre",
      0.0125
    ],
    [
      "purifier",
      0.0125
    ],
    [
      "produire",
      0.0125
    ],
    [
      "exonerer",
      0.0125
    ],
    [
      "dispenser",
      0.0125
    ],
    [
      "epurer",
      0.01
    ],
    [
      "soustraire",
      0.01
    ],
    [
      "repandre",
      0.01
    ],
    [
      "retirer",
      0.01
    ],
    [
      "isoler",
      0.01
    ],
    [
      "exempter",
      0.01
    ],
    [
      "desencombrer",
      0.01
    ],
    [
      "deblayer",
      0.01
    ],
    [
      "distinguer",
      0.01
    ],
    [
      "elaguer",
      0.0075
    ],
    [
      "sentir",
      0.0075
    ],
    [
      "relever",
      0.0075
    ],
    [
      "purger",
      0.0075
    ],
    [
      "manifester",
      0.0075
    ],
    [
      "desobstruer",
      0.0075
    ],
    [
      "debroussailler",
      0.0075
    ],
    [
      "deboucher",
      0.0075
    ],
    [
      "balayer",
      0.0075
    ],
    [
      "aerer",
      0.0075
    ],
    [
      "filtrer",
      0.005
    ],
    [
      "ressortir",
      0.005
    ],
    [
      "tailler",
      0.005
    ],
    [
      "evacuer",
      0.005
    ],
    [
      "denuder",
      0.005
    ],
    [
      "demunir",
      0.005
    ],
    [
      "deguerpir",
      0.005
    ],
    [
      "degrever",
      0.005
    ],
    [
      "decamper",
      0.005
    ],
    [
      "circuler",
      0.005
    ],
    [
      "avancer",
      0.005
    ],
    [
      "inferer",
      0.0
    ],
    [
      "devisser",
      0.0
    ],
    [
      "parfumer",
      0.0
    ],
    [
      "puer",
      0.0
    ],
    [
      "puiser",
      0.0
    ],
    [
      "desherber",
      0.0
    ],
    [
      "desenlacer",
      0.0
    ],
    [
      "alester",
      0.0
    ],
    [
      "debloquer",
      0.0
    ],
    [
      "deboucler",
      0.0
    ],
    [
      "debourrer",
      0.0
    ],
    [
      "deboutonner",
      0.0
    ],
    [
      "decolleter",
      0.0
    ],
    [
      "deconsigner",
      0.0
    ],
    [
      "dedouaner",
      0.0
    ],
    [
      "degainer",
      0.0
    ],
    [
      "desenchainer",
      0.0
    ],
    [
      "shooter",
      0.0
    ]
  ],
  "ces": [],
  "carton": [
    [
      "plan",
      0.1325
    ],
    [
      "dessin",
      0.105
    ],
    [
      "carte",
      0.08
    ],
    [
      "croquis",
      0.08
    ],
    [
      "modele",
      0.08
    ],
    [
      "projet",
      0.08
    ],
    [
      "etude",
      0.0525
    ],
    [
      "patron",
      0.0525
    ],
    [
      "fiche",
      0.0525
    ],
    [
      "cartable",
      0.0525
    ],
    [
      "portefeuille",
      0.025
    ],
    [
      "paille",
      0.025
    ],
    [
      "feuille",
      0.025
    ],
    [
      "cartonnier",
      0.025
    ],
    [
      "cartonnage",
      0.025
    ],
    [
      "but",
      0.025
    ],
    [
      "bristol",
      0.025
    ],
    [
      "boite",
      0.025
    ]
  ],
  "emballage": [
    [
      "contenant",
      0.13
    ],
    [
      "etui",
      0.085
    ],
    [
      "enveloppe",
      0.085
    ],
    [
      "caisse",
      0.085
    ],
    [
      "cageot",
      0.085
    ],
    [
      "boite",
      0.085
    ],
    [
      "pochette",
      0.0425
    ],
    [
      "poche",
      0.0425
    ],
    [
      "paquetage",
      0.0425
    ],
    [
      "layette",
      0.0425
    ],
    [
      "foudre",
      0.0425
    ],
    [
      "encaissement",
      0.0425
    ],
    [
      "empaquetage",
      0.0425
    ],
    [
      "conditionnement",
      0.0425
    ],
    [
      "sprint",
      0.0425
    ]
  ],
  "gens": [
    [
      "monde",
      0.1575
    ],
    [
      "domesticite",
      0.105
    ],
    [
      "maison",
      0.0775
    ],
    [
      "etres",
      0.0525
    ],
    [
      "type",
      0.0525
    ],
    [
      "serviteur",
      0.0525
    ],
    [
      "public",
      0.0525
    ],
    [
      "personnel",
      0.0525
    ],
    [
      "hommes",
      0.0525
    ],
    [
      "homme",
      0.0525
    ],
    [
      "habitant",
      0.0525
    ],
    [
      "valetaille",
      0.025
    ],
    [
      "suite",
      0.025
    ],
    [
      "personnes",
      0.025
    ],
    [
      "nation",
      0.025
    ],
    [
      "humain",
      0.025
    ],
    [
      "galerie",
      0.025
    ],
    [
      "foule",
      0.025
    ],
    [
      "employes",
      0.025
    ],
    [
      "visage",
      0.025
    ]
  ],
  "lave": [
    [
      "basalte",
      0.3325
    ],
    [
      "cendre",
      0.3325
    ],
    [
      "lause",
      0.3325
    ]
  ],
  "laver": [
    [
      "nettoyer",
      0.1325
    ],
    [
      "recurer",
      0.0775
    ],
    [
      "blanchir",
      0.045
    ],
    [
      "frotter",
      0.045
    ],
    [
      "purifier",
      0.03
    ],
    [
      "passer",
      0.03
    ],
    [
      "mouiller",
      0.03
    ],
    [
      "lessiver",
      0.03
    ],
    [
      "excuser",
      0.03
    ],
    [
      "effacer",
      0.03
    ],
    [
      "baigner",
      0.03
    ],
    [
      "rincer",
      0.0225
    ],
    [
      "enlever",
      0.0225
    ],
    [
      "detacher",
      0.0225
    ],
    [
      "degraisser",
      0.0225
    ],
    [
      "decrasser",
      0.0225
    ],
    [
      "vendre",
      0.015
    ],
    [
      "purger",
      0.015
    ],
    [
      "lotionner",
      0.015
    ],
    [
      "justifier",
      0.015
    ],
    [
      "innocenter",
      0.015
    ],
    [
      "faire",
      0.015
    ],
    [
      "deterger",
      0.015
    ],
    [
      "delaver",
      0.015
    ],
    [
      "arroser",
      0.015
    ],
    [
      "bassiner",
      0.015
    ],
    [
      "disculper",
      0.015
    ],
    [
      "doucher",
      0.015
    ],
    [
      "decharger",
      0.015
    ],
    [
      "rehabiliter",
      0.0075
    ],
    [
      "sablonner",
      0.0075
    ],
    [
      "savonner",
      0.0075
    ],
    [
      "toiletter",
      0.0075
    ],
    [
      "venger",
      0.0075
    ],
    [
      "echauder",
      0.0075
    ],
    [
      "relaver",
      0.0075
    ],
    [
      "radier",
      0.0075
    ],
    [
      "gueer",
      0.0075
    ],
    [
      "abluer",
      0.0075
    ],
    [
      "ablutionner",
      0.0075
    ],
    [
      "absterger",
      0.0075
    ],
    [
      "aiguayer",
      0.0075
    ],
    [
      "debarbouiller",
      0.0075
    ],
    [
      "decrotter",
      0.0075
    ],
    [
      "delayer",
      0.0075
    ],
    [
      "essanger",
      0.0075
    ],
    [
      "etuver",
      0.0075
    ]
  ],
  "hors": [
    [
      "excepte",
      0.15
    ],
    [
      "hormis",
      0.15
    ],
    [
      "sauf",
      0.15
    ],
    [
      "dehors",
      0.05
    ],
    [
      "fors",
      0.05
    ],
    [
      "ote",
      0.05
    ]
  ],
  "usage": [
    [
      "habitude",
      0.0625
    ],
    [
      "pratique",
      0.0625
    ],
    [
      "convenance",
      0.04
    ],
    [
      "emploi",
      0.04
    ],
    [
      "coutume",
      0.035
    ],
    [
      "education",
      0.03
    ],
    [
      "utilisation",
      0.03
    ],
    [
      "tact",
      0.03
    ],
    [
      "politesse",
      0.03
    ],
    [
      "experience",
      0.025
    ],
    [
      "fonction",
      0.025
    ],
    [
      "possession",
      0.025
    ],
    [
      "etiquette",
      0.02
    ],
    [
      "regle",
      0.02
    ],
    [
      "mode",
      0.02
    ],
    [
      "exercice",
      0.02
    ],
    [
      "disposition",
      0.02
    ],
    [
      "connaissance",
      0.02
    ],
    [
      "application",
      0.02
    ],
    [
      "propriete",
      0.015
    ],
    [
      "rite",
      0.015
    ],
    [
      "routine",
      0.015
    ],
    [
      "service",
      0.015
    ],
    [
      "tradition",
      0.015
    ],
    [
      "utilite",
      0.015
    ],
    [
      "procede",
      0.015
    ],
    [
      "frequentation",
      0.015
    ],
    [
      "accoutumance",
      0.015
    ],
    [
      "activite",
      0.015
    ],
    [
      "bienseance",
      0.015
    ],
    [
      "civilite",
      0.015
    ],
    [
      "convention",
      0.015
    ],
    [
      "ceremonial",
      0.015
    ],
    [
      "sagesse",
      0.0075
    ],
    [
      "role",
      0.0075
    ],
    [
      "puissance",
      0.0075
    ],
    [
      "moeurs",
      0.0075
    ],
    [
      "maniere",
      0.0075
    ],
    [
      "maniement",
      0.0075
    ],
    [
      "jouissance",
      0.0075
    ],
    [
      "fonctionnement",
      0.0075
    ],
    [
      "droit",
      0.0075
    ],
    [
      "destination",
      0.0075
    ],
    [
      "consommation",
      0.0075
    ],
    [
      "recours",
      0.0025
    ],
    [
      "urbanite",
      0.0025
    ],
    [
      "us",
      0.0025
    ],
    [
      "usufruit",
      0.0025
    ],
    [
      "parler",
      0.0025
    ],
    [
      "ordinaire",
      0.0025
    ],
    [
      "formes",
      0.0025
    ],
    [
      "familiarite",
      0.0025
    ],
    [
      "depense",
      0.0025
    ],
    [
      "affectation",
      0.0025
    ],
    [
      "adoption",
      0.0025
    ],
    [
      "usure",
      0.0025
    ]
  ],
  "triste": [
    [
      "penible",
      0.0525
    ],
    [
      "sombre",
      0.0425
    ],
    [
      "affligeant",
      0.0425
    ],
    [
      "mauvais",
      0.035
    ],
    [
      "chagrin",
      0.0325
    ],
    [
      "melancolique",
      0.0325
    ],
    [
      "malheureux",
      0.03
    ],
    [
      "deplorable",
      0.0275
    ],
    [
      "navrant",
      0.0275
    ],
    [
      "funeste",
      0.0275
    ],
    [
      "morne",
      0.0275
    ],
    [
      "tendu",
      0.025
    ],
    [
      "pitoyable",
      0.025
    ],
    [
      "lamentable",
      0.025
    ],
    [
      "cruel",
      0.025
    ],
    [
      "douloureux",
      0.02
    ],
    [
      "desolant",
      0.0175
    ],
    [
      "miserable",
      0.015
    ],
    [
      "sinistre",
      0.015
    ],
    [
      "piteux",
      0.015
    ],
    [
      "grave",
      0.015
    ],
    [
      "abattu",
      0.0125
    ],
    [
      "morose",
      0.0125
    ],
    [
      "afflige",
      0.0125
    ],
    [
      "peine",
      0.01
    ],
    [
      "maussade",
      0.01
    ],
    [
      "facheux",
      0.01
    ],
    [
      "ennuyeux",
      0.01
    ],
    [
      "tenebreux",
      0.01
    ],
    [
      "torturant",
      0.01
    ],
    [
      "lugubre",
      0.01
    ],
    [
      "cafardeux",
      0.01
    ],
    [
      "attristant",
      0.01
    ],
    [
      "amer",
      0.01
    ],
    [
      "pauvre",
      0.0075
    ],
    [
      "terne",
      0.0075
    ],
    [
      "severe",
      0.0075
    ],
    [
      "navre",
      0.0075
    ],
    [
      "attriste",
      0.0075
    ],
    [
      "eplore",
      0.005
    ],
    [
      "tragique",
      0.005
    ],
    [
      "rude",
      0.005
    ],
    [
      "desespere",
      0.005
    ],
    [
      "assombri",
      0.005
    ],
    [
      "affreux",
      0.005
    ],
    [
      "emouvant",
      0.005
    ],
    [
      "taciturne",
      0.005
    ],
    [
      "desole",
      0.005
    ],
    [
      "chagrine",
      0.005
    ],
    [
      "bilieux",
      0.005
    ],
    [
      "accablant",
      0.005
    ],
    [
      "sepulcral",
      0.0025
    ],
    [
      "soucieux",
      0.0025
    ],
    [
      "obscur",
      0.0025
    ],
    [
      "moche",
      0.0025
    ],
    [
      "funebre",
      0.0025
    ],
    [
      "decourage",
      0.0025
    ],
    [
      "decourageant",
      0.0025
    ],
    [
      "angoissant",
      0.0025
    ],
    [
      "calamiteux",
      0.0025
    ],
    [
      "catastrophique",
      0.0025
    ],
    [
      "consterne",
      0.0025
    ],
    [
      "dechirant",
      0.0025
    ],
    [
      "elegiaque",
      0.0025
    ],
    [
      "mediocre",
      0.0025
    ],
    [
      "monotone",
      0.0025
    ],
    [
      "infortune",
      0.0025
    ],
    [
      "desabuse",
      0.0025
    ],
    [
      "dramatique",
      0.0025
    ],
    [
      "aneanti",
      0.0025
    ],
    [
      "accable",
      0.0025
    ],
    [
      "minable",
      0.0
    ],
    [
      "nostalgique",
      0.0
    ],
    [
      "pietre",
      0.0
    ],
    [
      "regrettable",
      0.0
    ],
    [
      "rembruni",
      0.0
    ],
    [
      "sauvage",
      0.0
    ],
    [
      "eteignoir",
      0.0
    ],
    [
      "inconsolable",
      0.0
    ],
    [
      "deprime",
      0.0
    ],
    [
      "affecte",
      0.0
    ],
    [
      "atrabilaire",
      0.0
    ],
    [
      "attendrissant",
      0.0
    ],
    [
      "atterre",
      0.0
    ],
    [
      "austere",
      0.0
    ],
    [
      "bouleversant",
      0.0
    ],
    [
      "brumeux",
      0.0
    ],
    [
      "sourcilleux",
      0.0
    ],
    [
      "sempiternel",
      0.0
    ],
    [
      "romantique",
      0.0
    ],
    [
      "neurasthenique",
      0.0
    ],
    [
      "desenchante",
      0.0
    ],
    [
      "deprimant",
      0.0
    ],
    [
      "defait",
      0.0
    ],
    [
      "constipe",
      0.0
    ],
    [
      "bileux",
      0.0
    ],
    [
      "uniforme",
      0.0
    ]
  ],
  "aucun": [
    [
      "nul",
      0.25
    ],
    [
      "quelque",
      0.25
    ],
    [
      "zero",
      0.25
    ]
  ],
  "avantager": [
    [
      "favoriser",
      0.235
    ],
    [
      "embellir",
      0.1175
    ],
    [
      "flatter",
      0.1175
    ],
    [
      "privilegier",
      0.1175
    ],
    [
      "prioriser",
      0.0575
    ],
    [
      "habiller",
      0.0575
    ],
    [
      "gratifier",
      0.0575
    ],
    [
      "douer",
      0.0575
    ],
    [
      "doter",
      0.0575
    ],
    [
      "servir",
      0.0575
    ]
  ],
  "avantage": [
    [
      "gain",
      0.0725
    ],
    [
      "bien",
      0.06
    ],
    [
      "benefice",
      0.0525
    ],
    [
      "faveur",
      0.0525
    ],
    [
      "profit",
      0.05
    ],
    [
      "grace",
      0.04
    ],
    [
      "privilege",
      0.04
    ],
    [
      "don",
      0.03
    ],
    [
      "bienfait",
      0.03
    ],
    [
      "interet",
      0.025
    ],
    [
      "superiorite",
      0.025
    ],
    [
      "succes",
      0.0225
    ],
    [
      "revenu",
      0.0225
    ],
    [
      "qualite",
      0.0225
    ],
    [
      "predominance",
      0.0225
    ],
    [
      "droit",
      0.0225
    ],
    [
      "casuel",
      0.0225
    ],
    [
      "utilite",
      0.0175
    ],
    [
      "retribution",
      0.0175
    ],
    [
      "remuneration",
      0.0175
    ],
    [
      "ressource",
      0.0175
    ],
    [
      "prerogative",
      0.0175
    ],
    [
      "honneur",
      0.0175
    ],
    [
      "facilite",
      0.0175
    ],
    [
      "bonte",
      0.0175
    ],
    [
      "triomphe",
      0.0125
    ],
    [
      "preeminence",
      0.0125
    ],
    [
      "primaute",
      0.0125
    ],
    [
      "gratification",
      0.0125
    ],
    [
      "fruit",
      0.0125
    ],
    [
      "boni",
      0.0125
    ],
    [
      "bonheur",
      0.0125
    ],
    [
      "victoire",
      0.0075
    ],
    [
      "talent",
      0.0075
    ],
    [
      "prevalence",
      0.0075
    ],
    [
      "preference",
      0.0075
    ],
    [
      "priorite",
      0.0075
    ],
    [
      "liberalite",
      0.0075
    ],
    [
      "compte",
      0.0075
    ],
    [
      "commodite",
      0.0075
    ],
    [
      "capacite",
      0.0075
    ],
    [
      "cadeau",
      0.0075
    ],
    [
      "attribut",
      0.0075
    ],
    [
      "atout",
      0.0075
    ],
    [
      "suprematie",
      0.0025
    ],
    [
      "preciput",
      0.0025
    ],
    [
      "parti",
      0.0025
    ],
    [
      "joie",
      0.0025
    ],
    [
      "dessus",
      0.0025
    ],
    [
      "cote",
      0.0025
    ],
    [
      "avance",
      0.0025
    ]
  ],
  "infliger": [
    [
      "donner",
      0.2125
    ],
    [
      "administrer",
      0.1425
    ],
    [
      "prescrire",
      0.1425
    ],
    [
      "torturer",
      0.1425
    ],
    [
      "affliger",
      0.07
    ],
    [
      "appliquer",
      0.07
    ],
    [
      "imposer",
      0.07
    ],
    [
      "prononcer",
      0.07
    ],
    [
      "supplicier",
      0.07
    ]
  ],
  "desir": [
    [
      "soif",
      0.1125
    ],
    [
      "appetit",
      0.06
    ],
    [
      "envie",
      0.0425
    ],
    [
      "convoitise",
      0.0375
    ],
    [
      "appetence",
      0.0325
    ],
    [
      "avidite",
      0.0325
    ],
    [
      "souhait",
      0.0325
    ],
    [
      "gout",
      0.03
    ],
    [
      "volonte",
      0.0275
    ],
    [
      "ambition",
      0.025
    ],
    [
      "caprice",
      0.025
    ],
    [
      "passion",
      0.0225
    ],
    [
      "amour",
      0.02
    ],
    [
      "concupiscence",
      0.02
    ],
    [
      "faim",
      0.02
    ],
    [
      "attrait",
      0.0175
    ],
    [
      "pretention",
      0.015
    ],
    [
      "inclination",
      0.015
    ],
    [
      "aspiration",
      0.015
    ],
    [
      "ardeur",
      0.0125
    ],
    [
      "demande",
      0.0125
    ],
    [
      "dessein",
      0.0125
    ],
    [
      "exigence",
      0.0125
    ],
    [
      "revendication",
      0.0125
    ],
    [
      "voeu",
      0.01
    ],
    [
      "tendance",
      0.01
    ],
    [
      "penchant",
      0.01
    ],
    [
      "intention",
      0.01
    ],
    [
      "fantaisie",
      0.01
    ],
    [
      "resolution",
      0.01
    ],
    [
      "impatience",
      0.01
    ],
    [
      "humeur",
      0.01
    ],
    [
      "desiderata",
      0.01
    ],
    [
      "curiosite",
      0.01
    ],
    [
      "boulimie",
      0.01
    ],
    [
      "besoin",
      0.01
    ],
    [
      "appel",
      0.01
    ],
    [
      "visee",
      0.0075
    ],
    [
      "feu",
      0.0075
    ],
    [
      "esperance",
      0.0075
    ],
    [
      "demangeaison",
      0.0075
    ],
    [
      "cupidite",
      0.0075
    ],
    [
      "chaleur",
      0.0075
    ],
    [
      "bouillonnement",
      0.0075
    ],
    [
      "velleite",
      0.005
    ],
    [
      "tentation",
      0.005
    ],
    [
      "reve",
      0.005
    ],
    [
      "prurit",
      0.005
    ],
    [
      "libido",
      0.005
    ],
    [
      "idee",
      0.005
    ],
    [
      "force",
      0.005
    ],
    [
      "but",
      0.005
    ],
    [
      "attirance",
      0.005
    ],
    [
      "attente",
      0.005
    ],
    [
      "vouloir",
      0.0025
    ],
    [
      "sensualite",
      0.0025
    ],
    [
      "salacite",
      0.0025
    ],
    [
      "propos",
      0.0025
    ],
    [
      "interet",
      0.0025
    ],
    [
      "espoir",
      0.0025
    ],
    [
      "amativite",
      0.0
    ],
    [
      "flamme",
      0.0
    ],
    [
      "objectif",
      0.0
    ],
    [
      "rapacite",
      0.0
    ],
    [
      "vanite",
      0.0
    ],
    [
      "eros",
      0.0
    ]
  ],
  "affliger": [
    [
      "chagriner",
      0.13
    ],
    [
      "navrer",
      0.115
    ],
    [
      "desoler",
      0.0725
    ],
    [
      "attrister",
      0.0625
    ],
    [
      "facher",
      0.04
    ],
    [
      "tourmenter",
      0.035
    ],
    [
      "emouvoir",
      0.03
    ],
    [
      "peiner",
      0.03
    ],
    [
      "desesperer",
      0.03
    ],
    [
      "dechirer",
      0.03
    ],
    [
      "consterner",
      0.03
    ],
    [
      "accabler",
      0.03
    ],
    [
      "frapper",
      0.025
    ],
    [
      "affecter",
      0.025
    ],
    [
      "abattre",
      0.025
    ],
    [
      "contrarier",
      0.02
    ],
    [
      "ennuyer",
      0.02
    ],
    [
      "troubler",
      0.02
    ],
    [
      "torturer",
      0.015
    ],
    [
      "mortifier",
      0.015
    ],
    [
      "froisser",
      0.015
    ],
    [
      "contrister",
      0.015
    ],
    [
      "briser",
      0.015
    ],
    [
      "eprouver",
      0.0075
    ],
    [
      "toucher",
      0.0075
    ],
    [
      "grever",
      0.0075
    ],
    [
      "endolorir",
      0.0075
    ],
    [
      "atterrer",
      0.0075
    ],
    [
      "atteindre",
      0.0075
    ],
    [
      "assombrir",
      0.0075
    ],
    [
      "nantir",
      0.0025
    ],
    [
      "macerer",
      0.0025
    ],
    [
      "infliger",
      0.0025
    ],
    [
      "endeuiller",
      0.0025
    ],
    [
      "doter",
      0.0025
    ],
    [
      "ulcerer",
      0.0025
    ]
  ],
  "prendre": [
    [
      "gagner",
      0.035
    ],
    [
      "attraper",
      0.035
    ],
    [
      "saisir",
      0.0325
    ],
    [
      "piquer",
      0.03
    ],
    [
      "enlever",
      0.03
    ],
    [
      "voler",
      0.0225
    ],
    [
      "s'emparer",
      0.02
    ],
    [
      "faire",
      0.0175
    ],
    [
      "derober",
      0.0175
    ],
    [
      "obtenir",
      0.015
    ],
    [
      "recevoir",
      0.0125
    ],
    [
      "tenir",
      0.0125
    ],
    [
      "tirer",
      0.0125
    ],
    [
      "arreter",
      0.01
    ],
    [
      "ramasser",
      0.01
    ],
    [
      "retenir",
      0.01
    ],
    [
      "toucher",
      0.01
    ],
    [
      "s'approprier",
      0.01
    ],
    [
      "retirer",
      0.01
    ],
    [
      "fixer",
      0.01
    ],
    [
      "emporter",
      0.01
    ],
    [
      "conquerir",
      0.01
    ],
    [
      "ravir",
      0.01
    ],
    [
      "pincer",
      0.01
    ],
    [
      "chiper",
      0.01
    ],
    [
      "avoir",
      0.01
    ],
    [
      "attacher",
      0.01
    ],
    [
      "accrocher",
      0.01
    ],
    [
      "remporter",
      0.0075
    ],
    [
      "seduire",
      0.0075
    ],
    [
      "soustraire",
      0.0075
    ],
    [
      "mettre",
      0.0075
    ],
    [
      "faucher",
      0.0075
    ],
    [
      "embrasser",
      0.0075
    ],
    [
      "absorber",
      0.0075
    ],
    [
      "suivre",
      0.005
    ],
    [
      "s'attacher",
      0.005
    ],
    [
      "occuper",
      0.005
    ],
    [
      "empoigner",
      0.005
    ],
    [
      "attirer",
      0.005
    ],
    [
      "monter",
      0.005
    ],
    [
      "regarder",
      0.005
    ],
    [
      "recolter",
      0.005
    ],
    [
      "serrer",
      0.005
    ],
    [
      "soutirer",
      0.005
    ],
    [
      "traiter",
      0.005
    ],
    [
      "manger",
      0.005
    ],
    [
      "engager",
      0.005
    ],
    [
      "encaisser",
      0.005
    ],
    [
      "aller",
      0.005
    ],
    [
      "arracher",
      0.005
    ],
    [
      "atteindre",
      0.005
    ],
    [
      "choper",
      0.005
    ],
    [
      "cueillir",
      0.005
    ],
    [
      "emprunter",
      0.005
    ],
    [
      "piller",
      0.005
    ],
    [
      "rafler",
      0.005
    ],
    [
      "ratiboiser",
      0.005
    ],
    [
      "recueillir",
      0.005
    ],
    [
      "surprendre",
      0.005
    ],
    [
      "user",
      0.005
    ],
    [
      "epingler",
      0.005
    ],
    [
      "oter",
      0.005
    ],
    [
      "percevoir",
      0.005
    ],
    [
      "geler",
      0.005
    ],
    [
      "acquerir",
      0.005
    ],
    [
      "adopter",
      0.005
    ],
    [
      "attaquer",
      0.005
    ],
    [
      "capturer",
      0.005
    ],
    [
      "comprendre",
      0.005
    ],
    [
      "considerer",
      0.005
    ],
    [
      "contracter",
      0.005
    ],
    [
      "envahir",
      0.005
    ],
    [
      "figer",
      0.0025
    ],
    [
      "forcer",
      0.0025
    ],
    [
      "harponner",
      0.0025
    ],
    [
      "mordre",
      0.0025
    ],
    [
      "s'appliquer",
      0.0025
    ],
    [
      "soulever",
      0.0025
    ],
    [
      "usurper",
      0.0025
    ],
    [
      "etreindre",
      0.0025
    ],
    [
      "entrer",
      0.0025
    ],
    [
      "employer",
      0.0025
    ],
    [
      "accaparer",
      0.0025
    ],
    [
      "agrafer",
      0.0025
    ],
    [
      "apprehender",
      0.0025
    ],
    [
      "bruler",
      0.0025
    ],
    [
      "coincer",
      0.0025
    ],
    [
      "confisquer",
      0.0025
    ],
    [
      "disposer",
      0.0025
    ],
    [
      "devorer",
      0.0025
    ],
    [
      "plagier",
      0.0025
    ],
    [
      "posseder",
      0.0025
    ],
    [
      "prelever",
      0.0025
    ],
    [
      "s'assurer",
      0.0025
    ],
    [
      "souffler",
      0.0025
    ],
    [
      "estimer",
      0.0025
    ],
    [
      "embarquer",
      0.0025
    ],
    [
      "agripper",
      0.0025
    ],
    [
      "avaler",
      0.0025
    ],
    [
      "charger",
      0.0025
    ],
    [
      "choisir",
      0.0025
    ],
    [
      "coller",
      0.0025
    ],
    [
      "connaitre",
      0.0025
    ],
    [
      "retrancher",
      0.0
    ],
    [
      "ratisser",
      0.0
    ],
    [
      "piper",
      0.0
    ],
    [
      "piger",
      0.0
    ],
    [
      "nommer",
      0.0
    ],
    [
      "marcher",
      0.0
    ],
    [
      "happer",
      0.0
    ],
    [
      "reussir",
      0.0
    ],
    [
      "subir",
      0.0
    ],
    [
      "supposer",
      0.0
    ],
    [
      "selectionner",
      0.0
    ],
    [
      "tourner",
      0.0
    ],
    [
      "tuer",
      0.0
    ],
    [
      "utiliser",
      0.0
    ],
    [
      "ecoper",
      0.0
    ],
    [
      "extraire",
      0.0
    ],
    [
      "envisager",
      0.0
    ],
    [
      "acheter",
      0.0
    ],
    [
      "admettre",
      0.0
    ],
    [
      "affecter",
      0.0
    ],
    [
      "amadouer",
      0.0
    ],
    [
      "assurer",
      0.0
    ],
    [
      "barboter",
      0.0
    ],
    [
      "boire",
      0.0
    ],
    [
      "caillebotter",
      0.0
    ],
    [
      "chauffer",
      0.0
    ],
    [
      "entortiller",
      0.0
    ],
    [
      "enfiler",
      0.0
    ],
    [
      "designer",
      0.0
    ],
    [
      "consommer",
      0.0
    ],
    [
      "compter",
      0.0
    ],
    [
      "commencer",
      0.0
    ],
    [
      "chercher",
      0.0
    ],
    [
      "s'engager",
      0.0
    ],
    [
      "s'attribuer",
      0.0
    ],
    [
      "reputer",
      0.0
    ],
    [
      "reprendre",
      0.0
    ],
    [
      "recruter",
      0.0
    ],
    [
      "poisser",
      0.0
    ],
    [
      "persuader",
      0.0
    ],
    [
      "oppresser",
      0.0
    ],
    [
      "elire",
      0.0
    ],
    [
      "vendanger",
      0.0
    ],
    [
      "sortir",
      0.0
    ],
    [
      "juger",
      0.0
    ],
    [
      "interpreter",
      0.0
    ],
    [
      "intercepter",
      0.0
    ],
    [
      "couter",
      0.0
    ],
    [
      "compiler",
      0.0
    ],
    [
      "coaguler",
      0.0
    ],
    [
      "ceinturer",
      0.0
    ],
    [
      "assumer",
      0.0
    ],
    [
      "arquepincer",
      0.0
    ],
    [
      "apprivoiser",
      0.0
    ],
    [
      "apporter",
      0.0
    ],
    [
      "accueillir",
      0.0
    ],
    [
      "durcir",
      0.0
    ],
    [
      "deguster",
      0.0
    ],
    [
      "demarquer",
      0.0
    ],
    [
      "ingurgiter",
      0.0
    ],
    [
      "harper",
      0.0
    ],
    [
      "gripper",
      0.0
    ],
    [
      "ferrer",
      0.0
    ],
    [
      "exiger",
      0.0
    ],
    [
      "essuyer",
      0.0
    ],
    [
      "endosser",
      0.0
    ],
    [
      "emmener",
      0.0
    ],
    [
      "devaliser",
      0.0
    ],
    [
      "s'amorcer",
      0.0
    ],
    [
      "s'adjoindre",
      0.0
    ],
    [
      "puiser",
      0.0
    ],
    [
      "priser",
      0.0
    ],
    [
      "piocher",
      0.0
    ],
    [
      "s'associer",
      0.0
    ],
    [
      "s'implanter",
      0.0
    ],
    [
      "ecumer",
      0.0
    ],
    [
      "epaissir",
      0.0
    ],
    [
      "paumer",
      0.0
    ],
    [
      "ingerer",
      0.0
    ],
    [
      "aveindre",
      0.0
    ],
    [
      "chouraver",
      0.0
    ],
    [
      "colleter",
      0.0
    ],
    [
      "congeler",
      0.0
    ],
    [
      "coopter",
      0.0
    ],
    [
      "cramer",
      0.0
    ],
    [
      "crocher",
      0.0
    ],
    [
      "debuter",
      0.0
    ],
    [
      "decimer",
      0.0
    ],
    [
      "embaucher",
      0.0
    ],
    [
      "heberger",
      0.0
    ],
    [
      "arnaquer",
      0.0
    ]
  ],
  "deconner": [
    [
      "deraisonner",
      0.2
    ],
    [
      "bafouiller",
      0.1
    ],
    [
      "baragouiner",
      0.1
    ],
    [
      "bredouiller",
      0.1
    ],
    [
      "discourir",
      0.1
    ],
    [
      "debloquer",
      0.1
    ],
    [
      "s'abuser",
      0.1
    ],
    [
      "s'abetir",
      0.1
    ]
  ],
  "naitre": [
    [
      "poindre",
      0.105
    ],
    [
      "surgir",
      0.085
    ],
    [
      "apparaitre",
      0.0725
    ],
    [
      "venir",
      0.065
    ],
    [
      "percer",
      0.0525
    ],
    [
      "eclore",
      0.045
    ],
    [
      "sortir",
      0.045
    ],
    [
      "paraitre",
      0.045
    ],
    [
      "sourdre",
      0.0325
    ],
    [
      "s'elever",
      0.0325
    ],
    [
      "commencer",
      0.0325
    ],
    [
      "decouler",
      0.025
    ],
    [
      "s'ouvrir",
      0.025
    ],
    [
      "s'eveiller",
      0.02
    ],
    [
      "s'etablir",
      0.02
    ],
    [
      "pointer",
      0.02
    ],
    [
      "partir",
      0.02
    ],
    [
      "croitre",
      0.02
    ],
    [
      "survenir",
      0.0125
    ],
    [
      "s'ebaucher",
      0.0125
    ],
    [
      "s'exciter",
      0.0125
    ],
    [
      "resulter",
      0.0125
    ],
    [
      "provenir",
      0.0125
    ],
    [
      "perler",
      0.0125
    ],
    [
      "germer",
      0.0125
    ],
    [
      "s'organiser",
      0.005
    ],
    [
      "descendre",
      0.005
    ]
  ],
  "con": [
    [
      "idiot",
      0.1425
    ],
    [
      "imbecile",
      0.1425
    ],
    [
      "bete",
      0.1
    ],
    [
      "niais",
      0.08
    ],
    [
      "sot",
      0.08
    ],
    [
      "cul",
      0.06
    ],
    [
      "couillon",
      0.06
    ],
    [
      "ballot",
      0.06
    ],
    [
      "vulve",
      0.04
    ],
    [
      "sexe",
      0.04
    ],
    [
      "cretin",
      0.04
    ],
    [
      "beta",
      0.04
    ],
    [
      "aberrant",
      0.02
    ],
    [
      "benet",
      0.02
    ],
    [
      "chatte",
      0.02
    ],
    [
      "conard",
      0.02
    ],
    [
      "emmanche",
      0.02
    ]
  ],
  "alors": [
    [
      "donc",
      0.1175
    ],
    [
      "puis",
      0.0575
    ],
    [
      "lors",
      0.0575
    ],
    [
      "et",
      0.0575
    ],
    [
      "eh",
      0.0575
    ],
    [
      "cependant",
      0.0575
    ],
    [
      "ainsi",
      0.0575
    ],
    [
      "adonc",
      0.0575
    ]
  ],
  "pouvoir": [
    [
      "autorite",
      0.075
    ],
    [
      "puissance",
      0.075
    ],
    [
      "empire",
      0.0525
    ],
    [
      "faculte",
      0.0425
    ],
    [
      "domination",
      0.04
    ],
    [
      "capacite",
      0.0325
    ],
    [
      "habilete",
      0.0325
    ],
    [
      "influence",
      0.0325
    ],
    [
      "qualite",
      0.03
    ],
    [
      "force",
      0.0275
    ],
    [
      "vertu",
      0.02
    ],
    [
      "ascendant",
      0.0175
    ],
    [
      "competence",
      0.0175
    ],
    [
      "droit",
      0.0175
    ],
    [
      "maitrise",
      0.0175
    ],
    [
      "souverainete",
      0.0175
    ],
    [
      "etat",
      0.015
    ],
    [
      "gouvernement",
      0.015
    ],
    [
      "emprise",
      0.015
    ],
    [
      "don",
      0.015
    ],
    [
      "art",
      0.015
    ],
    [
      "dependance",
      0.0125
    ],
    [
      "possibilite",
      0.0125
    ],
    [
      "valeur",
      0.01
    ],
    [
      "regne",
      0.01
    ],
    [
      "permission",
      0.01
    ],
    [
      "loi",
      0.01
    ],
    [
      "liberte",
      0.01
    ],
    [
      "hegemonie",
      0.01
    ],
    [
      "efficacite",
      0.01
    ],
    [
      "disposition",
      0.01
    ],
    [
      "aptitude",
      0.01
    ],
    [
      "prerogative",
      0.0075
    ],
    [
      "preponderance",
      0.0075
    ],
    [
      "patte",
      0.0075
    ],
    [
      "moyen",
      0.0075
    ],
    [
      "main",
      0.0075
    ],
    [
      "grandeur",
      0.0075
    ],
    [
      "credit",
      0.0075
    ],
    [
      "propriete",
      0.005
    ],
    [
      "privilege",
      0.005
    ],
    [
      "prestige",
      0.005
    ],
    [
      "possession",
      0.005
    ],
    [
      "omnipotence",
      0.005
    ],
    [
      "mainmise",
      0.005
    ],
    [
      "delegation",
      0.005
    ],
    [
      "coupe",
      0.005
    ],
    [
      "bras",
      0.005
    ],
    [
      "attribution",
      0.005
    ],
    [
      "mandat",
      0.0025
    ],
    [
      "politique",
      0.0025
    ],
    [
      "prepotence",
      0.0025
    ],
    [
      "trone",
      0.0025
    ],
    [
      "licence",
      0.0025
    ],
    [
      "juridiction",
      0.0025
    ],
    [
      "ferule",
      0.0025
    ],
    [
      "commission",
      0.0025
    ],
    [
      "commandement",
      0.0025
    ],
    [
      "autorisation",
      0.0025
    ],
    [
      "administration",
      0.0025
    ],
    [
      "regime",
      0.0
    ],
    [
      "procuration",
      0.0
    ],
    [
      "prise",
      0.0
    ],
    [
      "mission",
      0.0
    ],
    [
      "latitude",
      0.0
    ],
    [
      "efficience",
      0.0
    ],
    [
      "charme",
      0.0
    ],
    [
      "savoir",
      0.0
    ]
  ],
  "ravager": [
    [
      "detruire",
      0.1375
    ],
    [
      "ruiner",
      0.1125
    ],
    [
      "saccager",
      0.1
    ],
    [
      "devorer",
      0.075
    ],
    [
      "devaster",
      0.0625
    ],
    [
      "ronger",
      0.05
    ],
    [
      "degrader",
      0.05
    ],
    [
      "consumer",
      0.05
    ],
    [
      "gater",
      0.035
    ],
    [
      "miner",
      0.035
    ],
    [
      "piller",
      0.035
    ],
    [
      "infester",
      0.0225
    ],
    [
      "desoler",
      0.0225
    ],
    [
      "delabrer",
      0.0225
    ],
    [
      "bruler",
      0.0225
    ],
    [
      "bouleverser",
      0.0225
    ],
    [
      "rider",
      0.01
    ],
    [
      "raviner",
      0.01
    ],
    [
      "labourer",
      0.01
    ],
    [
      "hacher",
      0.01
    ],
    [
      "fourrager",
      0.01
    ],
    [
      "endommager",
      0.01
    ],
    [
      "embraser",
      0.01
    ],
    [
      "butiner",
      0.01
    ],
    [
      "aneantir",
      0.01
    ],
    [
      "torturer",
      0.01
    ]
  ],
  "moukere": [
    [
      "prostituee",
      1.0
    ]
  ],
  "ciel": [
    [
      "Dieu",
      0.5
    ],
    [
      "Providence",
      0.5
    ]
  ],
  "devaler": [
    [
      "degringoler",
      0.2725
    ],
    [
      "debouler",
      0.18
    ],
    [
      "tomber",
      0.18
    ],
    [
      "bouler",
      0.09
    ],
    [
      "descendre",
      0.09
    ],
    [
      "rouler",
      0.09
    ]
  ],
  "emballer": [
    [
      "exciter",
      0.075
    ],
    [
      "enlever",
      0.0525
    ],
    [
      "envelopper",
      0.0525
    ],
    [
      "ravir",
      0.0525
    ],
    [
      "transporter",
      0.0525
    ],
    [
      "exalter",
      0.0425
    ],
    [
      "enthousiasmer",
      0.0425
    ],
    [
      "emprisonner",
      0.0425
    ],
    [
      "renvoyer",
      0.03
    ],
    [
      "ramasser",
      0.03
    ],
    [
      "entrainer",
      0.03
    ],
    [
      "empaqueter",
      0.03
    ],
    [
      "arreter",
      0.03
    ],
    [
      "tancer",
      0.02
    ],
    [
      "soulever",
      0.02
    ],
    [
      "reprimander",
      0.02
    ],
    [
      "plaire",
      0.02
    ],
    [
      "engueuler",
      0.02
    ],
    [
      "enfermer",
      0.02
    ],
    [
      "emmailloter",
      0.02
    ],
    [
      "embarquer",
      0.02
    ],
    [
      "cueillir",
      0.02
    ],
    [
      "attacher",
      0.02
    ],
    [
      "griser",
      0.01
    ],
    [
      "gronder",
      0.01
    ],
    [
      "manoquer",
      0.01
    ],
    [
      "paqueter",
      0.01
    ],
    [
      "remercier",
      0.01
    ],
    [
      "renfermer",
      0.01
    ],
    [
      "repousser",
      0.01
    ],
    [
      "sermonner",
      0.01
    ],
    [
      "ensacher",
      0.01
    ],
    [
      "enfourner",
      0.01
    ],
    [
      "enchanter",
      0.01
    ],
    [
      "attiser",
      0.01
    ],
    [
      "conditionner",
      0.01
    ],
    [
      "congedier",
      0.01
    ],
    [
      "embaluchonner",
      0.01
    ],
    [
      "emboiter",
      0.01
    ],
    [
      "emmitoufler",
      0.01
    ],
    [
      "encaisser",
      0.01
    ],
    [
      "encaquer",
      0.01
    ],
    [
      "ecrouer",
      0.01
    ]
  ],
  "demain": [
    [
      "bientot",
      0.2
    ],
    [
      "futur",
      0.2
    ],
    [
      "temps",
      0.2
    ]
  ],
  "enfant": [
    [
      "gamin",
      0.1025
    ],
    [
      "bebe",
      0.065
    ],
    [
      "fils",
      0.04
    ],
    [
      "gosse",
      0.04
    ],
    [
      "moutard",
      0.0325
    ],
    [
      "mioche",
      0.0325
    ],
    [
      "mome",
      0.03
    ],
    [
      "petit",
      0.03
    ],
    [
      "rejeton",
      0.025
    ],
    [
      "marmot",
      0.0175
    ],
    [
      "fruit",
      0.0175
    ],
    [
      "fille",
      0.0175
    ],
    [
      "drole",
      0.0175
    ],
    [
      "ange",
      0.0175
    ],
    [
      "polisson",
      0.015
    ],
    [
      "momichon",
      0.015
    ],
    [
      "mouflet",
      0.015
    ],
    [
      "infantile",
      0.015
    ],
    [
      "heritier",
      0.015
    ],
    [
      "gnard",
      0.015
    ],
    [
      "garcon",
      0.015
    ],
    [
      "bambin",
      0.015
    ],
    [
      "marmouset",
      0.0075
    ],
    [
      "minouche",
      0.0075
    ],
    [
      "morveux",
      0.0075
    ],
    [
      "moujingue",
      0.0075
    ],
    [
      "portee",
      0.0075
    ],
    [
      "poupon",
      0.0075
    ],
    [
      "produit",
      0.0075
    ],
    [
      "putto",
      0.0075
    ],
    [
      "pueril",
      0.0075
    ],
    [
      "gars",
      0.0075
    ],
    [
      "galopin",
      0.0075
    ],
    [
      "fillette",
      0.0075
    ],
    [
      "amour",
      0.0075
    ],
    [
      "angelot",
      0.0075
    ],
    [
      "biquet",
      0.0075
    ],
    [
      "cherubin",
      0.0075
    ],
    [
      "couvee",
      0.0075
    ],
    [
      "descendant",
      0.0075
    ],
    [
      "diable",
      0.0075
    ],
    [
      "enfantin",
      0.0075
    ],
    [
      "enfancon",
      0.0075
    ],
    [
      "natif",
      0.0025
    ],
    [
      "moucheron",
      0.0025
    ],
    [
      "morpion",
      0.0025
    ],
    [
      "momillon",
      0.0025
    ],
    [
      "momignard",
      0.0025
    ],
    [
      "minouchet",
      0.0025
    ],
    [
      "minot",
      0.0025
    ],
    [
      "mineur",
      0.0025
    ],
    [
      "nichee",
      0.0025
    ],
    [
      "niston",
      0.0025
    ],
    [
      "nourrisson",
      0.0025
    ],
    [
      "successeur",
      0.0025
    ],
    [
      "sauteriau",
      0.0025
    ],
    [
      "pupille",
      0.0025
    ],
    [
      "poupard",
      0.0025
    ],
    [
      "pitchoun",
      0.0025
    ],
    [
      "mignard",
      0.0025
    ],
    [
      "merdeux",
      0.0025
    ],
    [
      "enfantelet",
      0.0025
    ],
    [
      "diablotin",
      0.0025
    ],
    [
      "crapaud",
      0.0025
    ],
    [
      "citoyen",
      0.0025
    ],
    [
      "chiffon",
      0.0025
    ],
    [
      "chiard",
      0.0025
    ],
    [
      "bebete",
      0.0025
    ],
    [
      "garconnet",
      0.0025
    ],
    [
      "gnasse",
      0.0025
    ],
    [
      "merdaillon",
      0.0025
    ],
    [
      "marmaille",
      0.0025
    ],
    [
      "loupiot",
      0.0025
    ],
    [
      "lardon",
      0.0025
    ],
    [
      "innocent",
      0.0025
    ],
    [
      "infant",
      0.0025
    ],
    [
      "geniture",
      0.0025
    ],
    [
      "gone",
      0.0025
    ],
    [
      "babouin",
      0.0025
    ]
  ],
  "pale": [
    [
      "aile",
      0.5
    ],
    [
      "palette",
      0.5
    ]
  ],
  "reve": [
    [
      "desirer",
      0.1
    ],
    [
      "souhaiter",
      0.1
    ],
    [
      "vouloir",
      0.0925
    ],
    [
      "ambitionner",
      0.055
    ],
    [
      "viser",
      0.045
    ],
    [
      "soupirer",
      0.045
    ],
    [
      "pretendre",
      0.045
    ],
    [
      "penser",
      0.045
    ],
    [
      "convoiter",
      0.045
    ],
    [
      "aspirer",
      0.035
    ],
    [
      "lorgner",
      0.035
    ],
    [
      "songer",
      0.035
    ],
    [
      "imaginer",
      0.0275
    ],
    [
      "revasser",
      0.0175
    ],
    [
      "projeter",
      0.0175
    ],
    [
      "mediter",
      0.0175
    ],
    [
      "divaguer",
      0.0175
    ],
    [
      "beer",
      0.0175
    ],
    [
      "bayer",
      0.0175
    ],
    [
      "rechercher",
      0.0075
    ],
    [
      "reflechir",
      0.0075
    ],
    [
      "s'egarer",
      0.0075
    ],
    [
      "evoquer",
      0.0075
    ],
    [
      "planer",
      0.0075
    ],
    [
      "inventer",
      0.0075
    ],
    [
      "forger",
      0.0075
    ],
    [
      "extravaguer",
      0.0075
    ],
    [
      "deraisonner",
      0.0075
    ],
    [
      "dormir",
      0.0075
    ]
  ],
  "rever": [
    [
      "desirer",
      0.1
    ],
    [
      "souhaiter",
      0.1
    ],
    [
      "vouloir",
      0.0925
    ],
    [
      "ambitionner",
      0.055
    ],
    [
      "viser",
      0.045
    ],
    [
      "soupirer",
      0.045
    ],
    [
      "pretendre",
      0.045
    ],
    [
      "penser",
      0.045
    ],
    [
      "convoiter",
      0.045
    ],
    [
      "aspirer",
      0.035
    ],
    [
      "lorgner",
      0.035
    ],
    [
      "songer",
      0.035
    ],
    [
      "imaginer",
      0.0275
    ],
    [
      "revasser",
      0.0175
    ],
    [
      "projeter",
      0.0175
    ],
    [
      "mediter",
      0.0175
    ],
    [
      "divaguer",
      0.0175
    ],
    [
      "beer",
      0.0175
    ],
    [
      "bayer",
      0.0175
    ],
    [
      "rechercher",
      0.0075
    ],
    [
      "reflechir",
      0.0075
    ],
    [
      "s'egarer",
      0.0075
    ],
    [
      "evoquer",
      0.0075
    ],
    [
      "planer",
      0.0075
    ],
    [
      "inventer",
      0.0075
    ],
    [
      "forger",
      0.0075
    ],
    [
      "extravaguer",
      0.0075
    ],
    [
      "deraisonner",
      0.0075
    ],
    [
      "dormir",
      0.0075
    ]
  ],
  "cheval": [
    [
      "coureur",
      0.07
    ],
    [
      "rosse",
      0.07
    ],
    [
      "bourrin",
      0.045
    ],
    [
      "canasson",
      0.045
    ],
    [
      "carne",
      0.045
    ],
    [
      "haridelle",
      0.045
    ],
    [
      "jument",
      0.045
    ],
    [
      "bourrique",
      0.035
    ],
    [
      "yearling",
      0.0225
    ],
    [
      "pouliche",
      0.0225
    ],
    [
      "poulain",
      0.0225
    ],
    [
      "palefroi",
      0.0225
    ],
    [
      "favori",
      0.0225
    ],
    [
      "destrier",
      0.0225
    ],
    [
      "criquet",
      0.0225
    ],
    [
      "bique",
      0.0225
    ],
    [
      "carcan",
      0.0225
    ],
    [
      "cavale",
      0.0225
    ],
    [
      "coursier",
      0.0225
    ],
    [
      "outsider",
      0.01
    ],
    [
      "rossard",
      0.01
    ],
    [
      "rossinante",
      0.01
    ],
    [
      "roussin",
      0.01
    ],
    [
      "sauteur",
      0.01
    ],
    [
      "solipede",
      0.01
    ],
    [
      "tarpan",
      0.01
    ],
    [
      "trotteur",
      0.01
    ],
    [
      "equide",
      0.01
    ],
    [
      "etalon",
      0.01
    ],
    [
      "mustang",
      0.01
    ],
    [
      "monture",
      0.01
    ],
    [
      "crack",
      0.01
    ],
    [
      "dada",
      0.01
    ],
    [
      "gaye",
      0.01
    ],
    [
      "genet",
      0.01
    ],
    [
      "haquenee",
      0.01
    ],
    [
      "hongre",
      0.01
    ],
    [
      "mazette",
      0.01
    ],
    [
      "mileur",
      0.01
    ],
    [
      "bidet",
      0.01
    ]
  ],
  "liste": [
    [
      "catalogue",
      0.1475
    ],
    [
      "repertoire",
      0.13
    ],
    [
      "tableau",
      0.0925
    ],
    [
      "etat",
      0.0725
    ],
    [
      "inventaire",
      0.065
    ],
    [
      "denombrement",
      0.055
    ],
    [
      "enumeration",
      0.045
    ],
    [
      "role",
      0.035
    ],
    [
      "rang",
      0.0275
    ],
    [
      "releve",
      0.0275
    ],
    [
      "suite",
      0.0275
    ],
    [
      "serie",
      0.0275
    ],
    [
      "table",
      0.0275
    ],
    [
      "revue",
      0.0175
    ],
    [
      "nomenclature",
      0.0175
    ],
    [
      "bordereau",
      0.0175
    ],
    [
      "bibliographie",
      0.0175
    ],
    [
      "nombre",
      0.0075
    ],
    [
      "menologe",
      0.0075
    ],
    [
      "memoire",
      0.0075
    ],
    [
      "matricule",
      0.0075
    ],
    [
      "martyrologe",
      0.0075
    ],
    [
      "listing",
      0.0075
    ],
    [
      "listage",
      0.0075
    ],
    [
      "kyrielle",
      0.0075
    ],
    [
      "index",
      0.0075
    ],
    [
      "cedule",
      0.0075
    ],
    [
      "canon",
      0.0075
    ],
    [
      "cadre",
      0.0075
    ],
    [
      "arsenal",
      0.0075
    ],
    [
      "palmares",
      0.0075
    ]
  ],
  "dont": [
    [
      "quoi",
      0.2
    ],
    [
      "duquel",
      0.0975
    ],
    [
      "laquelle",
      0.0975
    ],
    [
      "lequel",
      0.0975
    ],
    [
      "parmi",
      0.0975
    ]
  ],
  "questionner": [
    [
      "interroger",
      0.225
    ],
    [
      "demander",
      0.1125
    ],
    [
      "sonder",
      0.0875
    ],
    [
      "interpeller",
      0.065
    ],
    [
      "interviewer",
      0.065
    ],
    [
      "s'enquerir",
      0.065
    ],
    [
      "tater",
      0.0425
    ],
    [
      "torturer",
      0.0425
    ],
    [
      "enqueter",
      0.0425
    ],
    [
      "tourmenter",
      0.02
    ],
    [
      "tester",
      0.02
    ],
    [
      "scruter",
      0.02
    ],
    [
      "revendiquer",
      0.02
    ],
    [
      "gehenner",
      0.02
    ],
    [
      "cuisiner",
      0.02
    ],
    [
      "consulter",
      0.02
    ],
    [
      "adresser",
      0.02
    ],
    [
      "eprouver",
      0.02
    ]
  ],
  "utilite": [
    [
      "bien",
      0.1025
    ],
    [
      "avantage",
      0.0675
    ],
    [
      "bonte",
      0.0675
    ],
    [
      "usage",
      0.05
    ],
    [
      "service",
      0.05
    ],
    [
      "interet",
      0.05
    ],
    [
      "convenance",
      0.05
    ],
    [
      "commodite",
      0.05
    ],
    [
      "benefice",
      0.05
    ],
    [
      "bienfait",
      0.05
    ],
    [
      "bienfaisance",
      0.05
    ],
    [
      "valeur",
      0.0325
    ],
    [
      "secours",
      0.0325
    ],
    [
      "profit",
      0.0325
    ],
    [
      "fonction",
      0.0325
    ],
    [
      "figurant",
      0.0325
    ],
    [
      "role",
      0.015
    ],
    [
      "praticite",
      0.015
    ],
    [
      "necessite",
      0.015
    ],
    [
      "merite",
      0.015
    ],
    [
      "expedience",
      0.015
    ],
    [
      "comparse",
      0.015
    ],
    [
      "besoin",
      0.015
    ],
    [
      "accessoire",
      0.015
    ],
    [
      "utilitarisme",
      0.015
    ]
  ],
  "vous": [],
  "go": [],
  "baril": [
    [
      "tonneau",
      0.2675
    ],
    [
      "barrique",
      0.17
    ],
    [
      "futaille",
      0.145
    ],
    [
      "fut",
      0.0725
    ],
    [
      "quartaut",
      0.0475
    ],
    [
      "piece",
      0.0225
    ],
    [
      "tine",
      0.0225
    ],
    [
      "tinette",
      0.0225
    ],
    [
      "tonne",
      0.0225
    ],
    [
      "muid",
      0.0225
    ],
    [
      "gonne",
      0.0225
    ],
    [
      "foudre",
      0.0225
    ],
    [
      "feuillette",
      0.0225
    ],
    [
      "caque",
      0.0225
    ],
    [
      "barrot",
      0.0225
    ],
    [
      "tonnelet",
      0.0225
    ]
  ],
  "partie": [
    [
      "association",
      0.07
    ],
    [
      "clan",
      0.065
    ],
    [
      "faction",
      0.06
    ],
    [
      "groupe",
      0.06
    ],
    [
      "secte",
      0.06
    ],
    [
      "ligue",
      0.055
    ],
    [
      "societe",
      0.055
    ],
    [
      "coalition",
      0.045
    ],
    [
      "coterie",
      0.035
    ],
    [
      "cabale",
      0.035
    ],
    [
      "bande",
      0.035
    ],
    [
      "phalange",
      0.0275
    ],
    [
      "troupe",
      0.0275
    ],
    [
      "rassemblement",
      0.025
    ],
    [
      "resolution",
      0.025
    ],
    [
      "organisation",
      0.0175
    ],
    [
      "complot",
      0.0175
    ],
    [
      "alliance",
      0.0175
    ],
    [
      "union",
      0.0125
    ],
    [
      "tribu",
      0.0125
    ],
    [
      "position",
      0.0125
    ],
    [
      "determination",
      0.0125
    ],
    [
      "decision",
      0.0125
    ],
    [
      "dessein",
      0.0125
    ],
    [
      "camp",
      0.0125
    ],
    [
      "volonte",
      0.0075
    ],
    [
      "tendance",
      0.0075
    ],
    [
      "situation",
      0.0075
    ],
    [
      "intrigue",
      0.0075
    ],
    [
      "formation",
      0.0075
    ],
    [
      "faisceau",
      0.0075
    ],
    [
      "chapelle",
      0.0075
    ],
    [
      "brigue",
      0.0075
    ],
    [
      "ivre",
      0.0025
    ],
    [
      "mouvement",
      0.0025
    ],
    [
      "partialite",
      0.0025
    ],
    [
      "profession",
      0.0025
    ],
    [
      "profit",
      0.0025
    ],
    [
      "propos",
      0.0025
    ],
    [
      "gai",
      0.0025
    ],
    [
      "conseil",
      0.0025
    ],
    [
      "choix",
      0.0025
    ],
    [
      "cause",
      0.0025
    ],
    [
      "benefice",
      0.0025
    ],
    [
      "avantage",
      0.0025
    ],
    [
      "absent",
      0.0025
    ],
    [
      "solution",
      0.0025
    ]
  ],
  "inferieur": [
    [
      "subalterne",
      0.1175
    ],
    [
      "subordonne",
      0.1175
    ],
    [
      "bas",
      0.0875
    ],
    [
      "mediocre",
      0.0725
    ],
    [
      "petit",
      0.0725
    ],
    [
      "moindre",
      0.0575
    ],
    [
      "second",
      0.0425
    ],
    [
      "sujet",
      0.0275
    ],
    [
      "mineur",
      0.0275
    ],
    [
      "mauvais",
      0.0275
    ],
    [
      "infime",
      0.0275
    ],
    [
      "humble",
      0.0275
    ],
    [
      "esclave",
      0.0275
    ],
    [
      "dependant",
      0.0275
    ],
    [
      "secondaire",
      0.0125
    ],
    [
      "suivant",
      0.0125
    ],
    [
      "profond",
      0.0125
    ],
    [
      "lilliputien",
      0.0125
    ],
    [
      "insuffisant",
      0.0125
    ],
    [
      "domestique",
      0.0125
    ],
    [
      "dernier",
      0.0125
    ],
    [
      "commun",
      0.0125
    ],
    [
      "vassal",
      0.0125
    ]
  ],
  "du": [
    [
      "redevoir",
      0.075
    ],
    [
      "penser",
      0.075
    ],
    [
      "falloir",
      0.075
    ],
    [
      "contracter",
      0.075
    ],
    [
      "avoir",
      0.075
    ],
    [
      "appartenir",
      0.075
    ]
  ],
  "couper": [
    [
      "tailler",
      0.035
    ],
    [
      "supprimer",
      0.03
    ],
    [
      "retrancher",
      0.03
    ],
    [
      "dechirer",
      0.025
    ],
    [
      "trancher",
      0.025
    ],
    [
      "diminuer",
      0.0225
    ],
    [
      "arreter",
      0.0225
    ],
    [
      "diviser",
      0.0225
    ],
    [
      "enlever",
      0.0225
    ],
    [
      "taillader",
      0.02
    ],
    [
      "rompre",
      0.02
    ],
    [
      "blesser",
      0.0175
    ],
    [
      "barrer",
      0.0175
    ],
    [
      "casser",
      0.0175
    ],
    [
      "morceler",
      0.0175
    ],
    [
      "oter",
      0.0175
    ],
    [
      "interrompre",
      0.0175
    ],
    [
      "mutiler",
      0.015
    ],
    [
      "fendre",
      0.015
    ],
    [
      "decouper",
      0.015
    ],
    [
      "separer",
      0.0125
    ],
    [
      "abattre",
      0.0125
    ],
    [
      "amputer",
      0.0125
    ],
    [
      "raccourcir",
      0.0125
    ],
    [
      "elaguer",
      0.0125
    ],
    [
      "rogner",
      0.0125
    ],
    [
      "entamer",
      0.0125
    ],
    [
      "entailler",
      0.0125
    ],
    [
      "briser",
      0.01
    ],
    [
      "dechiqueter",
      0.01
    ],
    [
      "depecer",
      0.01
    ],
    [
      "hacher",
      0.01
    ],
    [
      "tronquer",
      0.01
    ],
    [
      "sectionner",
      0.01
    ],
    [
      "faucher",
      0.01
    ],
    [
      "arracher",
      0.01
    ],
    [
      "balafrer",
      0.0075
    ],
    [
      "decapiter",
      0.0075
    ],
    [
      "suspendre",
      0.005
    ],
    [
      "retirer",
      0.005
    ],
    [
      "ouvrir",
      0.005
    ],
    [
      "fermer",
      0.005
    ],
    [
      "censurer",
      0.005
    ],
    [
      "etendre",
      0.005
    ],
    [
      "echarper",
      0.005
    ],
    [
      "terminer",
      0.005
    ],
    [
      "lever",
      0.005
    ],
    [
      "labourer",
      0.005
    ],
    [
      "finir",
      0.005
    ],
    [
      "effacer",
      0.005
    ],
    [
      "detacher",
      0.005
    ],
    [
      "ecimer",
      0.005
    ],
    [
      "tondre",
      0.005
    ],
    [
      "partager",
      0.005
    ],
    [
      "inciser",
      0.005
    ],
    [
      "fractionner",
      0.005
    ],
    [
      "executer",
      0.005
    ],
    [
      "empecher",
      0.005
    ],
    [
      "melanger",
      0.0025
    ],
    [
      "meler",
      0.0025
    ],
    [
      "piquer",
      0.0025
    ],
    [
      "scier",
      0.0025
    ],
    [
      "temperer",
      0.0025
    ],
    [
      "traverser",
      0.0025
    ],
    [
      "emonder",
      0.0025
    ],
    [
      "mouiller",
      0.0025
    ],
    [
      "guillotiner",
      0.0025
    ],
    [
      "cesser",
      0.0025
    ],
    [
      "charcuter",
      0.0025
    ],
    [
      "chatrer",
      0.0025
    ],
    [
      "cisailler",
      0.0025
    ],
    [
      "croiser",
      0.0025
    ],
    [
      "debiter",
      0.0025
    ],
    [
      "faire",
      0.0025
    ],
    [
      "rayer",
      0.0025
    ],
    [
      "resequer",
      0.0025
    ],
    [
      "scinder",
      0.0025
    ],
    [
      "segmenter",
      0.0025
    ],
    [
      "ebarber",
      0.0025
    ],
    [
      "echancrer",
      0.0025
    ],
    [
      "ecorcher",
      0.0025
    ],
    [
      "egorger",
      0.0025
    ],
    [
      "emasculer",
      0.0025
    ],
    [
      "rafraichir",
      0.0025
    ],
    [
      "prelever",
      0.0025
    ],
    [
      "passer",
      0.0025
    ],
    [
      "abreger",
      0.0025
    ],
    [
      "amenuiser",
      0.0025
    ],
    [
      "bloquer",
      0.0025
    ],
    [
      "cingler",
      0.0025
    ],
    [
      "ciseler",
      0.0025
    ],
    [
      "diluer",
      0.0025
    ],
    [
      "emporter",
      0.0025
    ],
    [
      "expurger",
      0.0025
    ],
    [
      "fouetter",
      0.0025
    ],
    [
      "raser",
      0.0
    ],
    [
      "saper",
      0.0
    ],
    [
      "steriliser",
      0.0
    ],
    [
      "tremper",
      0.0
    ],
    [
      "tronconner",
      0.0
    ],
    [
      "ecourter",
      0.0
    ],
    [
      "egrapper",
      0.0
    ],
    [
      "emincer",
      0.0
    ],
    [
      "eteter",
      0.0
    ],
    [
      "eviter",
      0.0
    ],
    [
      "operer",
      0.0
    ],
    [
      "obstruer",
      0.0
    ],
    [
      "moissonner",
      0.0
    ],
    [
      "additionner",
      0.0
    ],
    [
      "baptiser",
      0.0
    ],
    [
      "boucher",
      0.0
    ],
    [
      "chantourner",
      0.0
    ],
    [
      "chapeler",
      0.0
    ],
    [
      "debrider",
      0.0
    ],
    [
      "decoller",
      0.0
    ],
    [
      "decoudre",
      0.0
    ],
    [
      "extirper",
      0.0
    ],
    [
      "intercepter",
      0.0
    ],
    [
      "mincer",
      0.0
    ],
    [
      "hongrer",
      0.0
    ],
    [
      "guerir",
      0.0
    ],
    [
      "gercer",
      0.0
    ],
    [
      "mitiger",
      0.0
    ],
    [
      "moucher",
      0.0
    ],
    [
      "s'entrecouper",
      0.0
    ],
    [
      "surcouper",
      0.0
    ],
    [
      "ebouter",
      0.0
    ],
    [
      "ebrancher",
      0.0
    ],
    [
      "emarger",
      0.0
    ],
    [
      "faucarder",
      0.0
    ],
    [
      "exciser",
      0.0
    ],
    [
      "essoriller",
      0.0
    ],
    [
      "ajouter",
      0.0
    ],
    [
      "amenager",
      0.0
    ],
    [
      "aviver",
      0.0
    ],
    [
      "castrer",
      0.0
    ],
    [
      "chaumer",
      0.0
    ],
    [
      "dissequer",
      0.0
    ],
    [
      "debrancher",
      0.0
    ],
    [
      "decolleter",
      0.0
    ],
    [
      "deranger",
      0.0
    ],
    [
      "entrecouper",
      0.0
    ],
    [
      "escarper",
      0.0
    ],
    [
      "etraper",
      0.0
    ]
  ],
  "coupe": [
    [
      "tailler",
      0.035
    ],
    [
      "supprimer",
      0.03
    ],
    [
      "retrancher",
      0.03
    ],
    [
      "dechirer",
      0.025
    ],
    [
      "trancher",
      0.025
    ],
    [
      "diminuer",
      0.0225
    ],
    [
      "arreter",
      0.0225
    ],
    [
      "diviser",
      0.0225
    ],
    [
      "enlever",
      0.0225
    ],
    [
      "taillader",
      0.02
    ],
    [
      "rompre",
      0.02
    ],
    [
      "blesser",
      0.0175
    ],
    [
      "barrer",
      0.0175
    ],
    [
      "casser",
      0.0175
    ],
    [
      "morceler",
      0.0175
    ],
    [
      "oter",
      0.0175
    ],
    [
      "interrompre",
      0.0175
    ],
    [
      "mutiler",
      0.015
    ],
    [
      "fendre",
      0.015
    ],
    [
      "decouper",
      0.015
    ],
    [
      "separer",
      0.0125
    ],
    [
      "abattre",
      0.0125
    ],
    [
      "amputer",
      0.0125
    ],
    [
      "raccourcir",
      0.0125
    ],
    [
      "elaguer",
      0.0125
    ],
    [
      "rogner",
      0.0125
    ],
    [
      "entamer",
      0.0125
    ],
    [
      "entailler",
      0.0125
    ],
    [
      "briser",
      0.01
    ],
    [
      "dechiqueter",
      0.01
    ],
    [
      "depecer",
      0.01
    ],
    [
      "hacher",
      0.01
    ],
    [
      "tronquer",
      0.01
    ],
    [
      "sectionner",
      0.01
    ],
    [
      "faucher",
      0.01
    ],
    [
      "arracher",
      0.01
    ],
    [
      "balafrer",
      0.0075
    ],
    [
      "decapiter",
      0.0075
    ],
    [
      "suspendre",
      0.005
    ],
    [
      "retirer",
      0.005
    ],
    [
      "ouvrir",
      0.005
    ],
    [
      "fermer",
      0.005
    ],
    [
      "censurer",
      0.005
    ],
    [
      "etendre",
      0.005
    ],
    [
      "echarper",
      0.005
    ],
    [
      "terminer",
      0.005
    ],
    [
      "lever",
      0.005
    ],
    [
      "labourer",
      0.005
    ],
    [
      "finir",
      0.005
    ],
    [
      "effacer",
      0.005
    ],
    [
      "detacher",
      0.005
    ],
    [
      "ecimer",
      0.005
    ],
    [
      "tondre",
      0.005
    ],
    [
      "partager",
      0.005
    ],
    [
      "inciser",
      0.005
    ],
    [
      "fractionner",
      0.005
    ],
    [
      "executer",
      0.005
    ],
    [
      "empecher",
      0.005
    ],
    [
      "melanger",
      0.0025
    ],
    [
      "meler",
      0.0025
    ],
    [
      "piquer",
      0.0025
    ],
    [
      "scier",
      0.0025
    ],
    [
      "temperer",
      0.0025
    ],
    [
      "traverser",
      0.0025
    ],
    [
      "emonder",
      0.0025
    ],
    [
      "mouiller",
      0.0025
    ],
    [
      "guillotiner",
      0.0025
    ],
    [
      "cesser",
      0.0025
    ],
    [
      "charcuter",
      0.0025
    ],
    [
      "chatrer",
      0.0025
    ],
    [
      "cisailler",
      0.0025
    ],
    [
      "croiser",
      0.0025
    ],
    [
      "debiter",
      0.0025
    ],
    [
      "faire",
      0.0025
    ],
    [
      "rayer",
      0.0025
    ],
    [
      "resequer",
      0.0025
    ],
    [
      "scinder",
      0.0025
    ],
    [
      "segmenter",
      0.0025
    ],
    [
      "ebarber",
      0.0025
    ],
    [
      "echancrer",
      0.0025
    ],
    [
      "ecorcher",
      0.0025
    ],
    [
      "egorger",
      0.0025
    ],
    [
      "emasculer",
      0.0025
    ],
    [
      "rafraichir",
      0.0025
    ],
    [
      "prelever",
      0.0025
    ],
    [
      "passer",
      0.0025
    ],
    [
      "abreger",
      0.0025
    ],
    [
      "amenuiser",
      0.0025
    ],
    [
      "bloquer",
      0.0025
    ],
    [
      "cingler",
      0.0025
    ],
    [
      "ciseler",
      0.0025
    ],
    [
      "diluer",
      0.0025
    ],
    [
      "emporter",
      0.0025
    ],
    [
      "expurger",
      0.0025
    ],
    [
      "fouetter",
      0.0025
    ],
    [
      "raser",
      0.0
    ],
    [
      "saper",
      0.0
    ],
    [
      "steriliser",
      0.0
    ],
    [
      "tremper",
      0.0
    ],
    [
      "tronconner",
      0.0
    ],
    [
      "ecourter",
      0.0
    ],
    [
      "egrapper",
      0.0
    ],
    [
      "emincer",
      0.0
    ],
    [
      "eteter",
      0.0
    ],
    [
      "eviter",
      0.0
    ],
    [
      "operer",
      0.0
    ],
    [
      "obstruer",
      0.0
    ],
    [
      "moissonner",
      0.0
    ],
    [
      "additionner",
      0.0
    ],
    [
      "baptiser",
      0.0
    ],
    [
      "boucher",
      0.0
    ],
    [
      "chantourner",
      0.0
    ],
    [
      "chapeler",
      0.0
    ],
    [
      "debrider",
      0.0
    ],
    [
      "decoller",
      0.0
    ],
    [
      "decoudre",
      0.0
    ],
    [
      "extirper",
      0.0
    ],
    [
      "intercepter",
      0.0
    ],
    [
      "mincer",
      0.0
    ],
    [
      "hongrer",
      0.0
    ],
    [
      "guerir",
      0.0
    ],
    [
      "gercer",
      0.0
    ],
    [
      "mitiger",
      0.0
    ],
    [
      "moucher",
      0.0
    ],
    [
      "s'entrecouper",
      0.0
    ],
    [
      "surcouper",
      0.0
    ],
    [
      "ebouter",
      0.0
    ],
    [
      "ebrancher",
      0.0
    ],
    [
      "emarger",
      0.0
    ],
    [
      "faucarder",
      0.0
    ],
    [
      "exciser",
      0.0
    ],
    [
      "essoriller",
      0.0
    ],
    [
      "ajouter",
      0.0
    ],
    [
      "amenager",
      0.0
    ],
    [
      "aviver",
      0.0
    ],
    [
      "castrer",
      0.0
    ],
    [
      "chaumer",
      0.0
    ],
    [
      "dissequer",
      0.0
    ],
    [
      "debrancher",
      0.0
    ],
    [
      "decolleter",
      0.0
    ],
    [
      "deranger",
      0.0
    ],
    [
      "entrecouper",
      0.0
    ],
    [
      "escarper",
      0.0
    ],
    [
      "etraper",
      0.0
    ]
  ],
  "ongle": [
    [
      "serre",
      0.5
    ],
    [
      "ergot",
      0.25
    ],
    [
      "griffe",
      0.25
    ]
  ],
  "point": [
    [
      "paraitre",
      0.1175
    ],
    [
      "percer",
      0.085
    ],
    [
      "naitre",
      0.08
    ],
    [
      "surgir",
      0.08
    ],
    [
      "apparaitre",
      0.07
    ],
    [
      "sortir",
      0.06
    ],
    [
      "sourdre",
      0.05
    ],
    [
      "emerger",
      0.045
    ],
    [
      "pointer",
      0.04
    ],
    [
      "eclore",
      0.03
    ],
    [
      "piquer",
      0.025
    ],
    [
      "pousser",
      0.025
    ],
    [
      "commencer",
      0.02
    ],
    [
      "s'ebaucher",
      0.0125
    ],
    [
      "froisser",
      0.0125
    ],
    [
      "eperonner",
      0.0075
    ],
    [
      "transparaitre",
      0.0075
    ],
    [
      "s'elever",
      0.0075
    ],
    [
      "perler",
      0.0075
    ],
    [
      "affleurer",
      0.0075
    ],
    [
      "ulcerer",
      0.0025
    ],
    [
      "transpercer",
      0.0025
    ],
    [
      "s'eveiller",
      0.0025
    ],
    [
      "pointiller",
      0.0025
    ],
    [
      "passer",
      0.0025
    ],
    [
      "navrer",
      0.0025
    ],
    [
      "meurtrir",
      0.0025
    ],
    [
      "fouetter",
      0.0025
    ],
    [
      "etreindre",
      0.0025
    ]
  ],
  "poindre": [
    [
      "paraitre",
      0.1175
    ],
    [
      "percer",
      0.085
    ],
    [
      "naitre",
      0.08
    ],
    [
      "surgir",
      0.08
    ],
    [
      "apparaitre",
      0.07
    ],
    [
      "sortir",
      0.06
    ],
    [
      "sourdre",
      0.05
    ],
    [
      "emerger",
      0.045
    ],
    [
      "pointer",
      0.04
    ],
    [
      "eclore",
      0.03
    ],
    [
      "piquer",
      0.025
    ],
    [
      "pousser",
      0.025
    ],
    [
      "commencer",
      0.02
    ],
    [
      "s'ebaucher",
      0.0125
    ],
    [
      "froisser",
      0.0125
    ],
    [
      "eperonner",
      0.0075
    ],
    [
      "transparaitre",
      0.0075
    ],
    [
      "s'elever",
      0.0075
    ],
    [
      "perler",
      0.0075
    ],
    [
      "affleurer",
      0.0075
    ],
    [
      "ulcerer",
      0.0025
    ],
    [
      "transpercer",
      0.0025
    ],
    [
      "s'eveiller",
      0.0025
    ],
    [
      "pointiller",
      0.0025
    ],
    [
      "passer",
      0.0025
    ],
    [
      "navrer",
      0.0025
    ],
    [
      "meurtrir",
      0.0025
    ],
    [
      "fouetter",
      0.0025
    ],
    [
      "etreindre",
      0.0025
    ]
  ],
  "virgule": [
    [
      "microbe",
      0.5
    ],
    [
      "ponctuation",
      0.5
    ]
  ],
  "notice": [
    [
      "note",
      0.0975
    ],
    [
      "avertissement",
      0.0725
    ],
    [
      "avis",
      0.0725
    ],
    [
      "guide",
      0.0725
    ],
    [
      "memento",
      0.0725
    ],
    [
      "preface",
      0.0725
    ],
    [
      "sommaire",
      0.0475
    ],
    [
      "resume",
      0.0475
    ],
    [
      "prospectus",
      0.0475
    ],
    [
      "introduction",
      0.0475
    ],
    [
      "depliant",
      0.0475
    ],
    [
      "analyse",
      0.0475
    ],
    [
      "notule",
      0.0225
    ],
    [
      "extrait",
      0.0225
    ],
    [
      "documentation",
      0.0225
    ],
    [
      "biographie",
      0.0225
    ],
    [
      "article",
      0.0225
    ],
    [
      "abrege",
      0.0225
    ],
    [
      "preambule",
      0.0225
    ]
  ],
  "dans": [
    [
      "par",
      0.1475
    ],
    [
      "avec",
      0.0725
    ],
    [
      "en",
      0.0725
    ],
    [
      "parmi",
      0.0725
    ],
    [
      "pendant",
      0.0725
    ],
    [
      "sur",
      0.0725
    ],
    [
      "a",
      0.0475
    ],
    [
      "selon",
      0.0475
    ],
    [
      "d'apres",
      0.0475
    ],
    [
      "chez",
      0.0475
    ],
    [
      "suivant",
      0.0225
    ],
    [
      "lors",
      0.0225
    ],
    [
      "dedans",
      0.0225
    ],
    [
      "d'ici",
      0.0225
    ]
  ],
  "boite": [
    [
      "affaire",
      0.055
    ],
    [
      "caisse",
      0.055
    ],
    [
      "coffret",
      0.0375
    ],
    [
      "coffre",
      0.0325
    ],
    [
      "prison",
      0.0275
    ],
    [
      "bureau",
      0.0275
    ],
    [
      "boutique",
      0.0275
    ],
    [
      "etui",
      0.02
    ],
    [
      "etablissement",
      0.02
    ],
    [
      "ecole",
      0.02
    ],
    [
      "maison",
      0.02
    ],
    [
      "entreprise",
      0.02
    ],
    [
      "college",
      0.02
    ],
    [
      "casier",
      0.02
    ],
    [
      "cagnotte",
      0.02
    ],
    [
      "cage",
      0.02
    ],
    [
      "bazar",
      0.02
    ],
    [
      "bahut",
      0.02
    ],
    [
      "lycee",
      0.015
    ],
    [
      "malle",
      0.015
    ],
    [
      "tirelire",
      0.015
    ],
    [
      "ecrin",
      0.015
    ],
    [
      "contenant",
      0.015
    ],
    [
      "commerce",
      0.015
    ],
    [
      "cassette",
      0.015
    ],
    [
      "case",
      0.015
    ],
    [
      "boitier",
      0.015
    ],
    [
      "bonbonniere",
      0.015
    ],
    [
      "atelier",
      0.015
    ],
    [
      "necessaire",
      0.01
    ],
    [
      "reliquaire",
      0.01
    ],
    [
      "recipient",
      0.01
    ],
    [
      "societe",
      0.01
    ],
    [
      "taule",
      0.01
    ],
    [
      "trousse",
      0.01
    ],
    [
      "usine",
      0.01
    ],
    [
      "firme",
      0.01
    ],
    [
      "fichier",
      0.01
    ],
    [
      "baraque",
      0.01
    ],
    [
      "casse",
      0.01
    ],
    [
      "chantier",
      0.01
    ],
    [
      "chasse",
      0.01
    ],
    [
      "classeur",
      0.01
    ],
    [
      "dancing",
      0.01
    ],
    [
      "emballage",
      0.01
    ],
    [
      "custode",
      0.0025
    ],
    [
      "drageoir",
      0.0025
    ],
    [
      "gueule",
      0.0025
    ],
    [
      "marmotte",
      0.0025
    ],
    [
      "pension",
      0.0025
    ],
    [
      "plumier",
      0.0025
    ],
    [
      "poubelle",
      0.0025
    ],
    [
      "poudrier",
      0.0025
    ],
    [
      "tabatiere",
      0.0025
    ],
    [
      "tiroir",
      0.0025
    ],
    [
      "tronc",
      0.0025
    ],
    [
      "valise",
      0.0025
    ],
    [
      "chocolatiere",
      0.0025
    ],
    [
      "chanceliere",
      0.0025
    ],
    [
      "cercueil",
      0.0025
    ],
    [
      "administration",
      0.0025
    ],
    [
      "baguier",
      0.0025
    ],
    [
      "bal",
      0.0025
    ],
    [
      "biere",
      0.0025
    ],
    [
      "cabaret",
      0.0025
    ],
    [
      "cachot",
      0.0025
    ],
    [
      "caissette",
      0.0025
    ],
    [
      "capsa",
      0.0025
    ],
    [
      "caque",
      0.0025
    ],
    [
      "carter",
      0.0025
    ],
    [
      "carton",
      0.0025
    ],
    [
      "cartouche",
      0.0025
    ],
    [
      "cavite",
      0.0025
    ]
  ],
  "medicament": [
    [
      "remede",
      0.37
    ],
    [
      "medication",
      0.1025
    ],
    [
      "potion",
      0.1025
    ],
    [
      "succedane",
      0.05
    ],
    [
      "specifique",
      0.05
    ],
    [
      "specialite",
      0.05
    ],
    [
      "placebo",
      0.05
    ],
    [
      "panacee",
      0.05
    ],
    [
      "drogue",
      0.05
    ],
    [
      "breuvage",
      0.05
    ],
    [
      "therapeutique",
      0.05
    ]
  ],
  "application": [
    [
      "attention",
      0.0775
    ],
    [
      "soin",
      0.0775
    ],
    [
      "zele",
      0.055
    ],
    [
      "travail",
      0.0475
    ],
    [
      "concentration",
      0.04
    ],
    [
      "etude",
      0.0325
    ],
    [
      "emploi",
      0.0325
    ],
    [
      "effort",
      0.0325
    ],
    [
      "affectation",
      0.0325
    ],
    [
      "exercice",
      0.025
    ],
    [
      "meditation",
      0.025
    ],
    [
      "usage",
      0.025
    ],
    [
      "realisation",
      0.02
    ],
    [
      "pratique",
      0.02
    ],
    [
      "impression",
      0.02
    ],
    [
      "execution",
      0.02
    ],
    [
      "diligence",
      0.02
    ],
    [
      "conscience",
      0.02
    ],
    [
      "assiduite",
      0.02
    ],
    [
      "assemblage",
      0.02
    ],
    [
      "art",
      0.02
    ],
    [
      "utilisation",
      0.0125
    ],
    [
      "serieux",
      0.0125
    ],
    [
      "regularite",
      0.0125
    ],
    [
      "reflexion",
      0.0125
    ],
    [
      "relation",
      0.0125
    ],
    [
      "experimentation",
      0.0125
    ],
    [
      "exactitude",
      0.0125
    ],
    [
      "effet",
      0.0125
    ],
    [
      "destination",
      0.0125
    ],
    [
      "contention",
      0.0125
    ],
    [
      "attachement",
      0.0125
    ],
    [
      "placage",
      0.005
    ],
    [
      "mal",
      0.005
    ],
    [
      "injection",
      0.005
    ],
    [
      "pose",
      0.005
    ],
    [
      "recueillement",
      0.005
    ],
    [
      "superposition",
      0.005
    ],
    [
      "surjection",
      0.005
    ],
    [
      "tension",
      0.005
    ],
    [
      "vigilance",
      0.005
    ],
    [
      "imputation",
      0.005
    ],
    [
      "image",
      0.005
    ],
    [
      "adaptation",
      0.005
    ],
    [
      "antecedent",
      0.005
    ],
    [
      "applique",
      0.005
    ],
    [
      "attribution",
      0.005
    ],
    [
      "bijection",
      0.005
    ],
    [
      "correspondance",
      0.005
    ],
    [
      "curiosite",
      0.005
    ],
    [
      "empreinte",
      0.005
    ],
    [
      "fomentation",
      0.005
    ],
    [
      "homomorphisme",
      0.005
    ],
    [
      "vigueur",
      0.005
    ]
  ],
  "boussole": [
    [
      "aimant",
      0.1
    ],
    [
      "mentor",
      0.1
    ],
    [
      "inspirateur",
      0.1
    ],
    [
      "guide",
      0.1
    ],
    [
      "galvanometre",
      0.1
    ],
    [
      "direction",
      0.1
    ],
    [
      "conseiller",
      0.1
    ],
    [
      "compas",
      0.1
    ],
    [
      "tete",
      0.1
    ]
  ],
  "petit": [
    [
      "insignifiant",
      0.07
    ],
    [
      "faible",
      0.065
    ],
    [
      "mediocre",
      0.05
    ],
    [
      "maigre",
      0.04
    ],
    [
      "pauvre",
      0.035
    ],
    [
      "mesquin",
      0.035
    ],
    [
      "mince",
      0.0275
    ],
    [
      "modeste",
      0.0275
    ],
    [
      "bas",
      0.025
    ],
    [
      "reduit",
      0.025
    ],
    [
      "modique",
      0.025
    ],
    [
      "leger",
      0.025
    ],
    [
      "court",
      0.025
    ],
    [
      "infime",
      0.02
    ],
    [
      "minuscule",
      0.02
    ],
    [
      "negligeable",
      0.02
    ],
    [
      "minime",
      0.0175
    ],
    [
      "etroit",
      0.0175
    ],
    [
      "pietre",
      0.0175
    ],
    [
      "derisoire",
      0.015
    ],
    [
      "etrique",
      0.015
    ],
    [
      "chetif",
      0.0125
    ],
    [
      "ordinaire",
      0.01
    ],
    [
      "mechant",
      0.01
    ],
    [
      "limite",
      0.01
    ],
    [
      "humble",
      0.01
    ],
    [
      "exigu",
      0.01
    ],
    [
      "delicat",
      0.01
    ],
    [
      "succinct",
      0.01
    ],
    [
      "subalterne",
      0.01
    ],
    [
      "simple",
      0.01
    ],
    [
      "nain",
      0.01
    ],
    [
      "malheureux",
      0.01
    ],
    [
      "imperceptible",
      0.01
    ],
    [
      "sommaire",
      0.0075
    ],
    [
      "menu",
      0.0075
    ],
    [
      "enfant",
      0.0075
    ],
    [
      "avorton",
      0.0075
    ],
    [
      "vil",
      0.005
    ],
    [
      "lilliputien",
      0.005
    ],
    [
      "jeune",
      0.005
    ],
    [
      "inferieur",
      0.005
    ],
    [
      "grele",
      0.005
    ],
    [
      "gringalet",
      0.005
    ],
    [
      "gamin",
      0.005
    ],
    [
      "fin",
      0.005
    ],
    [
      "borne",
      0.005
    ],
    [
      "quelconque",
      0.005
    ],
    [
      "mineur",
      0.005
    ],
    [
      "microscopique",
      0.005
    ],
    [
      "gosse",
      0.005
    ],
    [
      "banal",
      0.005
    ],
    [
      "svelte",
      0.0025
    ],
    [
      "riquiqui",
      0.0025
    ],
    [
      "moindre",
      0.0025
    ],
    [
      "mioche",
      0.0025
    ],
    [
      "mignon",
      0.0025
    ],
    [
      "microbe",
      0.0025
    ],
    [
      "juste",
      0.0025
    ],
    [
      "joli",
      0.0025
    ],
    [
      "delie",
      0.0025
    ],
    [
      "anodin",
      0.0025
    ],
    [
      "minus",
      0.0025
    ],
    [
      "petiot",
      0.0025
    ],
    [
      "retreci",
      0.0025
    ],
    [
      "subtil",
      0.0025
    ],
    [
      "tenu",
      0.0025
    ],
    [
      "infinitesimal",
      0.0025
    ],
    [
      "gentil",
      0.0025
    ],
    [
      "fils",
      0.0025
    ],
    [
      "bambin",
      0.0025
    ],
    [
      "biquet",
      0.0025
    ],
    [
      "bebe",
      0.0025
    ],
    [
      "benin",
      0.0025
    ],
    [
      "crapoussin",
      0.0025
    ],
    [
      "mini",
      0.0
    ],
    [
      "miniature",
      0.0
    ],
    [
      "moutard",
      0.0
    ],
    [
      "myrmidon",
      0.0
    ],
    [
      "mome",
      0.0
    ],
    [
      "nabot",
      0.0
    ],
    [
      "obscur",
      0.0
    ],
    [
      "portatif",
      0.0
    ],
    [
      "puce",
      0.0
    ],
    [
      "pygmee",
      0.0
    ],
    [
      "marmouset",
      0.0
    ],
    [
      "invisible",
      0.0
    ],
    [
      "gnome",
      0.0
    ],
    [
      "animalcule",
      0.0
    ],
    [
      "bref",
      0.0
    ],
    [
      "coquet",
      0.0
    ],
    [
      "courtaud",
      0.0
    ],
    [
      "criquet",
      0.0
    ],
    [
      "douillet",
      0.0
    ],
    [
      "extrait",
      0.0
    ],
    [
      "ecrase",
      0.0
    ]
  ],
  "oindre": [
    [
      "enduire",
      0.1425
    ],
    [
      "frotter",
      0.1425
    ],
    [
      "baptiser",
      0.0925
    ],
    [
      "benir",
      0.0925
    ],
    [
      "consacrer",
      0.0925
    ],
    [
      "graisser",
      0.0925
    ],
    [
      "sacrer",
      0.045
    ],
    [
      "parfumer",
      0.045
    ],
    [
      "mouiller",
      0.045
    ],
    [
      "lubrifier",
      0.045
    ],
    [
      "frictionner",
      0.045
    ],
    [
      "badigeonner",
      0.045
    ],
    [
      "tamponner",
      0.045
    ]
  ],
  "oignon": [
    [
      "cor",
      0.215
    ],
    [
      "racine",
      0.07
    ],
    [
      "montre",
      0.07
    ],
    [
      "induration",
      0.07
    ],
    [
      "durillon",
      0.07
    ],
    [
      "cul",
      0.07
    ],
    [
      "callosite",
      0.07
    ],
    [
      "cal",
      0.07
    ],
    [
      "bulbe",
      0.07
    ],
    [
      "anus",
      0.07
    ],
    [
      "echalote",
      0.07
    ]
  ],
  "bocal": [
    [
      "bidon",
      0.1425
    ],
    [
      "embouchure",
      0.1425
    ],
    [
      "panse",
      0.1425
    ],
    [
      "pot",
      0.1425
    ],
    [
      "recipient",
      0.1425
    ],
    [
      "vase",
      0.1425
    ],
    [
      "ventre",
      0.1425
    ]
  ],
  "cornichon": [
    [
      "ballot",
      0.165
    ],
    [
      "bete",
      0.165
    ],
    [
      "sot",
      0.1425
    ],
    [
      "gourde",
      0.0825
    ],
    [
      "beta",
      0.07
    ],
    [
      "imbecile",
      0.07
    ],
    [
      "cruche",
      0.0575
    ],
    [
      "niais",
      0.0475
    ],
    [
      "idiot",
      0.0475
    ],
    [
      "corniaud",
      0.0475
    ],
    [
      "buse",
      0.0475
    ],
    [
      "buche",
      0.0225
    ],
    [
      "concombre",
      0.01
    ],
    [
      "pastisson",
      0.01
    ]
  ],
  "smart": [
    [
      "chic",
      0.3325
    ],
    [
      "select",
      0.3325
    ],
    [
      "elegant",
      0.3325
    ]
  ],
  "box": [
    [
      "abri",
      0.1675
    ],
    [
      "cellule",
      0.1125
    ],
    [
      "loge",
      0.1125
    ],
    [
      "reduit",
      0.1125
    ],
    [
      "compartiment",
      0.0825
    ],
    [
      "case",
      0.055
    ],
    [
      "alcove",
      0.055
    ],
    [
      "stalle",
      0.025
    ],
    [
      "remise",
      0.025
    ],
    [
      "logette",
      0.025
    ],
    [
      "logement",
      0.025
    ],
    [
      "garage",
      0.025
    ],
    [
      "detective",
      0.025
    ],
    [
      "coin",
      0.025
    ],
    [
      "chambrette",
      0.025
    ],
    [
      "banc",
      0.025
    ],
    [
      "appareil",
      0.025
    ],
    [
      "ecurie",
      0.025
    ]
  ],
  "vesicule": [
    [
      "ampoule",
      0.18
    ],
    [
      "bouton",
      0.18
    ],
    [
      "aerocyste",
      0.09
    ],
    [
      "boursouflure",
      0.09
    ],
    [
      "bulle",
      0.09
    ],
    [
      "cavite",
      0.09
    ],
    [
      "cloque",
      0.09
    ],
    [
      "pustule",
      0.09
    ],
    [
      "utricule",
      0.09
    ]
  ],
  "biliaire": [
    [
      "bilieux",
      1.0
    ]
  ],
  "servir": [
    [
      "aider",
      0.185
    ],
    [
      "soutenir",
      0.045
    ],
    [
      "assister",
      0.0425
    ],
    [
      "donner",
      0.0375
    ],
    [
      "appuyer",
      0.035
    ],
    [
      "faire",
      0.03
    ],
    [
      "favoriser",
      0.03
    ],
    [
      "epauler",
      0.0225
    ],
    [
      "pousser",
      0.0225
    ],
    [
      "agir",
      0.02
    ],
    [
      "representer",
      0.02
    ],
    [
      "seconder",
      0.02
    ],
    [
      "secourir",
      0.02
    ],
    [
      "suivre",
      0.02
    ],
    [
      "s'occuper",
      0.0175
    ],
    [
      "remplacer",
      0.0175
    ],
    [
      "proteger",
      0.0175
    ],
    [
      "partager",
      0.0175
    ],
    [
      "concourir",
      0.0175
    ],
    [
      "collaborer",
      0.0175
    ],
    [
      "participer",
      0.0125
    ],
    [
      "lancer",
      0.0125
    ],
    [
      "couvrir",
      0.0125
    ],
    [
      "contribuer",
      0.0125
    ],
    [
      "tirer",
      0.01
    ],
    [
      "suppleer",
      0.01
    ],
    [
      "reconforter",
      0.01
    ],
    [
      "profiter",
      0.01
    ],
    [
      "payer",
      0.01
    ],
    [
      "offrir",
      0.01
    ],
    [
      "obeir",
      0.01
    ],
    [
      "equivaloir",
      0.005
    ],
    [
      "soulager",
      0.005
    ],
    [
      "s'atteler",
      0.005
    ],
    [
      "s'attacher",
      0.005
    ],
    [
      "presenter",
      0.005
    ],
    [
      "patronner",
      0.005
    ],
    [
      "obliger",
      0.005
    ],
    [
      "monter",
      0.005
    ],
    [
      "debiter",
      0.005
    ],
    [
      "abattre",
      0.005
    ],
    [
      "saillir",
      0.0025
    ],
    [
      "s'infeoder",
      0.0025
    ],
    [
      "s'entraider",
      0.0025
    ],
    [
      "s'accoupler",
      0.0025
    ],
    [
      "sourire",
      0.0025
    ],
    [
      "subventionner",
      0.0025
    ],
    [
      "tuer",
      0.0025
    ],
    [
      "verser",
      0.0025
    ],
    [
      "relayer",
      0.0025
    ],
    [
      "avantager",
      0.0025
    ],
    [
      "chasser",
      0.0025
    ],
    [
      "conforter",
      0.0025
    ],
    [
      "distribuer",
      0.0025
    ],
    [
      "depanner",
      0.0025
    ],
    [
      "faciliter",
      0.0025
    ],
    [
      "marcher",
      0.0025
    ],
    [
      "permettre",
      0.0025
    ],
    [
      "adorer",
      0.0025
    ]
  ],
  "sert": [
    [
      "aider",
      0.185
    ],
    [
      "soutenir",
      0.045
    ],
    [
      "assister",
      0.0425
    ],
    [
      "donner",
      0.0375
    ],
    [
      "appuyer",
      0.035
    ],
    [
      "faire",
      0.03
    ],
    [
      "favoriser",
      0.03
    ],
    [
      "epauler",
      0.0225
    ],
    [
      "pousser",
      0.0225
    ],
    [
      "agir",
      0.02
    ],
    [
      "representer",
      0.02
    ],
    [
      "seconder",
      0.02
    ],
    [
      "secourir",
      0.02
    ],
    [
      "suivre",
      0.02
    ],
    [
      "s'occuper",
      0.0175
    ],
    [
      "remplacer",
      0.0175
    ],
    [
      "proteger",
      0.0175
    ],
    [
      "partager",
      0.0175
    ],
    [
      "concourir",
      0.0175
    ],
    [
      "collaborer",
      0.0175
    ],
    [
      "participer",
      0.0125
    ],
    [
      "lancer",
      0.0125
    ],
    [
      "couvrir",
      0.0125
    ],
    [
      "contribuer",
      0.0125
    ],
    [
      "tirer",
      0.01
    ],
    [
      "suppleer",
      0.01
    ],
    [
      "reconforter",
      0.01
    ],
    [
      "profiter",
      0.01
    ],
    [
      "payer",
      0.01
    ],
    [
      "offrir",
      0.01
    ],
    [
      "obeir",
      0.01
    ],
    [
      "equivaloir",
      0.005
    ],
    [
      "soulager",
      0.005
    ],
    [
      "s'atteler",
      0.005
    ],
    [
      "s'attacher",
      0.005
    ],
    [
      "presenter",
      0.005
    ],
    [
      "patronner",
      0.005
    ],
    [
      "obliger",
      0.005
    ],
    [
      "monter",
      0.005
    ],
    [
      "debiter",
      0.005
    ],
    [
      "abattre",
      0.005
    ],
    [
      "saillir",
      0.0025
    ],
    [
      "s'infeoder",
      0.0025
    ],
    [
      "s'entraider",
      0.0025
    ],
    [
      "s'accoupler",
      0.0025
    ],
    [
      "sourire",
      0.0025
    ],
    [
      "subventionner",
      0.0025
    ],
    [
      "tuer",
      0.0025
    ],
    [
      "verser",
      0.0025
    ],
    [
      "relayer",
      0.0025
    ],
    [
      "avantager",
      0.0025
    ],
    [
      "chasser",
      0.0025
    ],
    [
      "conforter",
      0.0025
    ],
    [
      "distribuer",
      0.0025
    ],
    [
      "depanner",
      0.0025
    ],
    [
      "faciliter",
      0.0025
    ],
    [
      "marcher",
      0.0025
    ],
    [
      "permettre",
      0.0025
    ],
    [
      "adorer",
      0.0025
    ]
  ],
  "elles": [],
  "necessaire": [
    [
      "essentiel",
      0.075
    ],
    [
      "indispensable",
      0.075
    ],
    [
      "inevitable",
      0.0625
    ],
    [
      "obligatoire",
      0.0625
    ],
    [
      "primordial",
      0.05
    ],
    [
      "oblige",
      0.0375
    ],
    [
      "important",
      0.0375
    ],
    [
      "immanquable",
      0.0375
    ],
    [
      "force",
      0.0375
    ],
    [
      "fatal",
      0.0375
    ],
    [
      "absolu",
      0.0375
    ],
    [
      "etui",
      0.025
    ],
    [
      "utile",
      0.025
    ],
    [
      "trousse",
      0.025
    ],
    [
      "pressant",
      0.025
    ],
    [
      "premier",
      0.025
    ],
    [
      "logique",
      0.025
    ],
    [
      "ineluctable",
      0.025
    ],
    [
      "imperatif",
      0.025
    ],
    [
      "fondamental",
      0.025
    ],
    [
      "boite",
      0.025
    ],
    [
      "precieux",
      0.0125
    ],
    [
      "rationnel",
      0.0125
    ],
    [
      "requis",
      0.0125
    ],
    [
      "rigoureux",
      0.0125
    ],
    [
      "substance",
      0.0125
    ],
    [
      "irremediable",
      0.0125
    ],
    [
      "infaillible",
      0.0125
    ],
    [
      "inconditionne",
      0.0125
    ],
    [
      "boitier",
      0.0125
    ],
    [
      "besoin",
      0.0125
    ],
    [
      "besogne",
      0.0125
    ],
    [
      "apodictique",
      0.0125
    ],
    [
      "accessoire",
      0.0125
    ],
    [
      "trousseau",
      0.0125
    ]
  ],
  "utiliser": [
    [
      "employer",
      0.1475
    ],
    [
      "user",
      0.135
    ],
    [
      "pratiquer",
      0.0675
    ],
    [
      "prendre",
      0.0675
    ],
    [
      "profiter",
      0.0675
    ],
    [
      "adopter",
      0.0525
    ],
    [
      "manier",
      0.04
    ],
    [
      "exploiter",
      0.04
    ],
    [
      "emprunter",
      0.04
    ],
    [
      "disposer",
      0.04
    ],
    [
      "recourir",
      0.025
    ],
    [
      "manipuler",
      0.025
    ],
    [
      "consommer",
      0.025
    ],
    [
      "appliquer",
      0.025
    ],
    [
      "amortir",
      0.0125
    ],
    [
      "assimiler",
      0.0125
    ],
    [
      "beneficier",
      0.0125
    ],
    [
      "consacrer",
      0.0125
    ]
  ],
  "vraiment": [
    [
      "reellement",
      0.1125
    ],
    [
      "veritablement",
      0.1125
    ],
    [
      "certainement",
      0.08
    ],
    [
      "bien",
      0.07
    ],
    [
      "assurement",
      0.06
    ],
    [
      "franchement",
      0.06
    ],
    [
      "effectivement",
      0.05
    ],
    [
      "sincerement",
      0.04
    ],
    [
      "indubitablement",
      0.04
    ],
    [
      "absolument",
      0.04
    ],
    [
      "bonnement",
      0.03
    ],
    [
      "exactement",
      0.03
    ],
    [
      "positivement",
      0.03
    ],
    [
      "tres",
      0.03
    ],
    [
      "vrai",
      0.0175
    ],
    [
      "serieusement",
      0.0175
    ],
    [
      "precisement",
      0.0175
    ],
    [
      "proprement",
      0.0175
    ],
    [
      "bellement",
      0.0175
    ],
    [
      "voire",
      0.0075
    ],
    [
      "loyalement",
      0.0075
    ],
    [
      "fortement",
      0.0075
    ]
  ],
  "begaiement": [
    [
      "balbutiement",
      0.2625
    ],
    [
      "bredouillement",
      0.105
    ],
    [
      "commencement",
      0.105
    ],
    [
      "debut",
      0.105
    ],
    [
      "tatonnement",
      0.05
    ],
    [
      "prononciation",
      0.05
    ],
    [
      "begayage",
      0.05
    ],
    [
      "berceau",
      0.05
    ],
    [
      "balbutie",
      0.05
    ],
    [
      "balbisme",
      0.05
    ],
    [
      "bafouillage",
      0.05
    ],
    [
      "elements",
      0.05
    ]
  ],
  "o": [],
  "circonflexe": [
    [
      "tordu",
      0.5
    ],
    [
      "tortu",
      0.5
    ]
  ],
  "signature": [
    [
      "marque",
      0.1825
    ],
    [
      "griffe",
      0.1125
    ],
    [
      "visa",
      0.09
    ],
    [
      "empreinte",
      0.0675
    ],
    [
      "paraphe",
      0.0675
    ],
    [
      "sceau",
      0.0675
    ],
    [
      "emargement",
      0.045
    ],
    [
      "style",
      0.045
    ],
    [
      "seing",
      0.045
    ],
    [
      "engagement",
      0.045
    ],
    [
      "ton",
      0.02
    ],
    [
      "souscription",
      0.02
    ],
    [
      "nom",
      0.02
    ],
    [
      "monogramme",
      0.02
    ],
    [
      "garantie",
      0.02
    ],
    [
      "endossement",
      0.02
    ],
    [
      "endos",
      0.02
    ],
    [
      "contreseing",
      0.02
    ],
    [
      "approbation",
      0.02
    ],
    [
      "trace",
      0.02
    ]
  ],
  "dos": [
    [
      "derriere",
      0.2
    ],
    [
      "reins",
      0.1325
    ],
    [
      "echine",
      0.065
    ],
    [
      "verso",
      0.065
    ],
    [
      "surface",
      0.065
    ],
    [
      "rable",
      0.065
    ],
    [
      "revers",
      0.065
    ],
    [
      "rachis",
      0.065
    ],
    [
      "envers",
      0.065
    ],
    [
      "arriere",
      0.065
    ]
  ],
  "carte": [
    [
      "billet",
      0.0925
    ],
    [
      "cartographie",
      0.045
    ],
    [
      "carton",
      0.045
    ],
    [
      "plan",
      0.045
    ],
    [
      "planisphere",
      0.045
    ],
    [
      "prix",
      0.03
    ],
    [
      "representation",
      0.03
    ],
    [
      "tarif",
      0.03
    ],
    [
      "vue",
      0.03
    ],
    [
      "georama",
      0.03
    ],
    [
      "cartel",
      0.03
    ],
    [
      "altimetrie",
      0.03
    ],
    [
      "as",
      0.03
    ],
    [
      "atout",
      0.03
    ],
    [
      "brisque",
      0.03
    ],
    [
      "bristol",
      0.03
    ],
    [
      "menu",
      0.0125
    ],
    [
      "paysage",
      0.0125
    ],
    [
      "photo",
      0.0125
    ],
    [
      "pneu",
      0.0125
    ],
    [
      "pneumatique",
      0.0125
    ],
    [
      "projection",
      0.0125
    ],
    [
      "tarot",
      0.0125
    ],
    [
      "ticket",
      0.0125
    ],
    [
      "titre",
      0.0125
    ],
    [
      "visa",
      0.0125
    ],
    [
      "mappemonde",
      0.0125
    ],
    [
      "manillon",
      0.0125
    ],
    [
      "autorisation",
      0.0125
    ],
    [
      "breme",
      0.0125
    ],
    [
      "choix",
      0.0125
    ],
    [
      "croquis",
      0.0125
    ],
    [
      "entree",
      0.0125
    ],
    [
      "fiche",
      0.0125
    ],
    [
      "figuration",
      0.0125
    ],
    [
      "lettre",
      0.0125
    ],
    [
      "atlas",
      0.0125
    ]
  ],
  "bleu": [
    [
      "azure",
      0.065
    ],
    [
      "blessure",
      0.045
    ],
    [
      "coup",
      0.0375
    ],
    [
      "azur",
      0.0325
    ],
    [
      "ecchymose",
      0.0325
    ],
    [
      "novice",
      0.0325
    ],
    [
      "vert",
      0.025
    ],
    [
      "torgnole",
      0.025
    ],
    [
      "bleuatre",
      0.025
    ],
    [
      "beigne",
      0.025
    ],
    [
      "soldat",
      0.0175
    ],
    [
      "meurtrissure",
      0.0175
    ],
    [
      "debutant",
      0.0175
    ],
    [
      "cotte",
      0.0175
    ],
    [
      "coquard",
      0.0175
    ],
    [
      "contusion",
      0.0175
    ],
    [
      "bleme",
      0.0175
    ],
    [
      "bleusaille",
      0.0175
    ],
    [
      "pale",
      0.01
    ],
    [
      "souquenille",
      0.01
    ],
    [
      "surtout",
      0.01
    ],
    [
      "tumefaction",
      0.01
    ],
    [
      "telegramme",
      0.01
    ],
    [
      "pneu",
      0.01
    ],
    [
      "nouveau",
      0.01
    ],
    [
      "azurin",
      0.01
    ],
    [
      "bleute",
      0.01
    ],
    [
      "conscrit",
      0.01
    ],
    [
      "livide",
      0.01
    ],
    [
      "pneumatique",
      0.005
    ],
    [
      "pierrot",
      0.005
    ],
    [
      "pervenche",
      0.005
    ],
    [
      "pers",
      0.005
    ],
    [
      "pastel",
      0.005
    ],
    [
      "pantalon",
      0.005
    ],
    [
      "myosotis",
      0.005
    ],
    [
      "lilas",
      0.005
    ],
    [
      "interdit",
      0.005
    ],
    [
      "induline",
      0.005
    ],
    [
      "recrue",
      0.005
    ],
    [
      "roquefort",
      0.005
    ],
    [
      "roussette",
      0.005
    ],
    [
      "emeraldine",
      0.005
    ],
    [
      "ecolier",
      0.005
    ],
    [
      "violet",
      0.005
    ],
    [
      "tournesol",
      0.005
    ],
    [
      "tache",
      0.005
    ],
    [
      "stupefait",
      0.005
    ],
    [
      "smalt",
      0.005
    ],
    [
      "saphir",
      0.005
    ],
    [
      "salopette",
      0.005
    ],
    [
      "resorcine",
      0.005
    ],
    [
      "indophenol",
      0.005
    ],
    [
      "indigo",
      0.005
    ],
    [
      "ciel",
      0.005
    ],
    [
      "chataigne",
      0.005
    ],
    [
      "cerne",
      0.005
    ],
    [
      "bleuissure",
      0.005
    ],
    [
      "bleuet",
      0.005
    ],
    [
      "bizut",
      0.005
    ],
    [
      "azureen",
      0.005
    ],
    [
      "azurite",
      0.005
    ],
    [
      "ardoise",
      0.005
    ],
    [
      "cobalt",
      0.005
    ],
    [
      "combinaison",
      0.005
    ],
    [
      "hematome",
      0.005
    ],
    [
      "guede",
      0.005
    ],
    [
      "gendarme",
      0.005
    ],
    [
      "ceruleen",
      0.005
    ],
    [
      "cerule",
      0.005
    ],
    [
      "cerulescent",
      0.005
    ],
    [
      "celeste",
      0.005
    ],
    [
      "cable",
      0.005
    ],
    [
      "cyanose",
      0.005
    ],
    [
      "cru",
      0.005
    ],
    [
      "commencant",
      0.005
    ],
    [
      "Dieu",
      0.005
    ]
  ],
  "cookie": [],
  "discutable": [
    [
      "contestable",
      0.175
    ],
    [
      "douteux",
      0.175
    ],
    [
      "critiquable",
      0.1175
    ],
    [
      "incertain",
      0.1175
    ],
    [
      "imparfait",
      0.0575
    ],
    [
      "hypothetique",
      0.0575
    ],
    [
      "disputable",
      0.0575
    ],
    [
      "discute",
      0.0575
    ],
    [
      "controversable",
      0.0575
    ],
    [
      "attaquable",
      0.0575
    ],
    [
      "niable",
      0.0575
    ]
  ],
  "coriandre": [],
  "boule": [
    [
      "balle",
      0.125
    ],
    [
      "pelote",
      0.0625
    ],
    [
      "sphere",
      0.0625
    ],
    [
      "tete",
      0.0625
    ],
    [
      "rond",
      0.04
    ],
    [
      "pomme",
      0.04
    ],
    [
      "globe",
      0.04
    ],
    [
      "boulette",
      0.04
    ],
    [
      "bouille",
      0.04
    ],
    [
      "ballon",
      0.04
    ],
    [
      "pain",
      0.02
    ],
    [
      "pastille",
      0.02
    ],
    [
      "peloton",
      0.02
    ],
    [
      "perle",
      0.02
    ],
    [
      "pilule",
      0.02
    ],
    [
      "pommeau",
      0.02
    ],
    [
      "petanque",
      0.02
    ],
    [
      "terre",
      0.02
    ],
    [
      "grosseur",
      0.02
    ],
    [
      "cochonnet",
      0.02
    ],
    [
      "bulteau",
      0.02
    ],
    [
      "baie",
      0.02
    ],
    [
      "bilboquet",
      0.02
    ],
    [
      "bille",
      0.02
    ],
    [
      "bombe",
      0.02
    ],
    [
      "bouillotte",
      0.02
    ],
    [
      "boulet",
      0.02
    ],
    [
      "boulier",
      0.02
    ],
    [
      "bowling",
      0.02
    ],
    [
      "bulle",
      0.02
    ],
    [
      "eteuf",
      0.02
    ]
  ],
  "bouler": [
    [
      "battre",
      0.1275
    ],
    [
      "remuer",
      0.1275
    ],
    [
      "touiller",
      0.095
    ],
    [
      "troubler",
      0.0625
    ],
    [
      "tomber",
      0.0625
    ],
    [
      "rouler",
      0.0625
    ],
    [
      "degringoler",
      0.0625
    ],
    [
      "bouiller",
      0.0625
    ],
    [
      "agiter",
      0.0625
    ],
    [
      "s'ecrouler",
      0.03
    ],
    [
      "s'effondrer",
      0.03
    ],
    [
      "repousser",
      0.03
    ],
    [
      "fatiguer",
      0.03
    ],
    [
      "devaler",
      0.03
    ],
    [
      "debouler",
      0.03
    ],
    [
      "bouillir",
      0.03
    ],
    [
      "econduire",
      0.03
    ]
  ],
  "interieur": [
    [
      "coeur",
      0.0875
    ],
    [
      "intime",
      0.0625
    ],
    [
      "ame",
      0.0625
    ],
    [
      "sein",
      0.05
    ],
    [
      "secret",
      0.05
    ],
    [
      "home",
      0.05
    ],
    [
      "foyer",
      0.05
    ],
    [
      "fond",
      0.05
    ],
    [
      "domestique",
      0.05
    ],
    [
      "profond",
      0.0375
    ],
    [
      "personnel",
      0.0375
    ],
    [
      "maison",
      0.0375
    ],
    [
      "intrinseque",
      0.0375
    ],
    [
      "entrailles",
      0.0375
    ],
    [
      "dedans",
      0.0375
    ],
    [
      "spirituel",
      0.0225
    ],
    [
      "profondeur",
      0.0225
    ],
    [
      "psychique",
      0.01
    ],
    [
      "prive",
      0.01
    ],
    [
      "intimite",
      0.01
    ],
    [
      "intestin",
      0.01
    ],
    [
      "interne",
      0.01
    ],
    [
      "inherent",
      0.01
    ],
    [
      "inclus",
      0.01
    ],
    [
      "hinterland",
      0.01
    ],
    [
      "giron",
      0.01
    ],
    [
      "familial",
      0.01
    ],
    [
      "central",
      0.01
    ],
    [
      "tuf",
      0.01
    ]
  ],
  "pot": [
    [
      "bol",
      0.1025
    ],
    [
      "recipient",
      0.1025
    ],
    [
      "vase",
      0.1025
    ],
    [
      "verre",
      0.05
    ],
    [
      "pichet",
      0.05
    ],
    [
      "fessier",
      0.05
    ],
    [
      "bock",
      0.05
    ],
    [
      "veine",
      0.0325
    ],
    [
      "hanap",
      0.0325
    ],
    [
      "faience",
      0.0325
    ],
    [
      "derriere",
      0.0325
    ],
    [
      "cruche",
      0.0325
    ],
    [
      "anus",
      0.0325
    ],
    [
      "marmite",
      0.015
    ],
    [
      "popotin",
      0.015
    ],
    [
      "potage",
      0.015
    ],
    [
      "potiche",
      0.015
    ],
    [
      "ustensile",
      0.015
    ],
    [
      "excrement",
      0.015
    ],
    [
      "drink",
      0.015
    ],
    [
      "chope",
      0.015
    ],
    [
      "broc",
      0.015
    ],
    [
      "bouteille",
      0.015
    ],
    [
      "bouille",
      0.015
    ],
    [
      "bonheur",
      0.015
    ],
    [
      "bocal",
      0.015
    ],
    [
      "arrosage",
      0.015
    ]
  ],
  "plante": [
    [
      "mettre",
      0.0775
    ],
    [
      "ficher",
      0.07
    ],
    [
      "placer",
      0.06
    ],
    [
      "fixer",
      0.0525
    ],
    [
      "arrimer",
      0.0425
    ],
    [
      "introduire",
      0.0425
    ],
    [
      "elever",
      0.0325
    ],
    [
      "semer",
      0.0325
    ],
    [
      "poser",
      0.0325
    ],
    [
      "laisser",
      0.0325
    ],
    [
      "dresser",
      0.0325
    ],
    [
      "camper",
      0.0325
    ],
    [
      "situer",
      0.025
    ],
    [
      "quitter",
      0.025
    ],
    [
      "implanter",
      0.025
    ],
    [
      "ensemencer",
      0.025
    ],
    [
      "enfoncer",
      0.025
    ],
    [
      "cultiver",
      0.025
    ],
    [
      "boiser",
      0.025
    ],
    [
      "abandonner",
      0.025
    ],
    [
      "transplanter",
      0.015
    ],
    [
      "replanter",
      0.015
    ],
    [
      "repeupler",
      0.015
    ],
    [
      "poster",
      0.015
    ],
    [
      "plaquer",
      0.015
    ],
    [
      "piquer",
      0.015
    ],
    [
      "monter",
      0.015
    ],
    [
      "entrer",
      0.015
    ],
    [
      "ameliorer",
      0.015
    ],
    [
      "reboiser",
      0.0075
    ],
    [
      "peupler",
      0.0075
    ],
    [
      "immobiliser",
      0.0075
    ],
    [
      "complanter",
      0.0075
    ],
    [
      "arborer",
      0.0075
    ],
    [
      "aposter",
      0.0075
    ],
    [
      "repiquer",
      0.0075
    ]
  ],
  "planter": [
    [
      "mettre",
      0.0775
    ],
    [
      "ficher",
      0.07
    ],
    [
      "placer",
      0.06
    ],
    [
      "fixer",
      0.0525
    ],
    [
      "arrimer",
      0.0425
    ],
    [
      "introduire",
      0.0425
    ],
    [
      "elever",
      0.0325
    ],
    [
      "semer",
      0.0325
    ],
    [
      "poser",
      0.0325
    ],
    [
      "laisser",
      0.0325
    ],
    [
      "dresser",
      0.0325
    ],
    [
      "camper",
      0.0325
    ],
    [
      "situer",
      0.025
    ],
    [
      "quitter",
      0.025
    ],
    [
      "implanter",
      0.025
    ],
    [
      "ensemencer",
      0.025
    ],
    [
      "enfoncer",
      0.025
    ],
    [
      "cultiver",
      0.025
    ],
    [
      "boiser",
      0.025
    ],
    [
      "abandonner",
      0.025
    ],
    [
      "transplanter",
      0.015
    ],
    [
      "replanter",
      0.015
    ],
    [
      "repeupler",
      0.015
    ],
    [
      "poster",
      0.015
    ],
    [
      "plaquer",
      0.015
    ],
    [
      "piquer",
      0.015
    ],
    [
      "monter",
      0.015
    ],
    [
      "entrer",
      0.015
    ],
    [
      "ameliorer",
      0.015
    ],
    [
      "reboiser",
      0.0075
    ],
    [
      "peupler",
      0.0075
    ],
    [
      "immobiliser",
      0.0075
    ],
    [
      "complanter",
      0.0075
    ],
    [
      "arborer",
      0.0075
    ],
    [
      "aposter",
      0.0075
    ],
    [
      "repiquer",
      0.0075
    ]
  ],
  "comprendre": [
    [
      "saisir",
      0.075
    ],
    [
      "voir",
      0.0675
    ],
    [
      "decouvrir",
      0.065
    ],
    [
      "penetrer",
      0.06
    ],
    [
      "apercevoir",
      0.0525
    ],
    [
      "entendre",
      0.0425
    ],
    [
      "connaitre",
      0.0425
    ],
    [
      "embrasser",
      0.0325
    ],
    [
      "reperer",
      0.0325
    ],
    [
      "deviner",
      0.03
    ],
    [
      "concevoir",
      0.03
    ],
    [
      "prendre",
      0.025
    ],
    [
      "trouver",
      0.0225
    ],
    [
      "apprehender",
      0.02
    ],
    [
      "dechiffrer",
      0.02
    ],
    [
      "inclure",
      0.02
    ],
    [
      "sentir",
      0.02
    ],
    [
      "contenir",
      0.0175
    ],
    [
      "remarquer",
      0.015
    ],
    [
      "comporter",
      0.015
    ],
    [
      "admettre",
      0.0125
    ],
    [
      "apprendre",
      0.0125
    ],
    [
      "apprecier",
      0.0125
    ],
    [
      "englober",
      0.0125
    ],
    [
      "imaginer",
      0.0125
    ],
    [
      "percer",
      0.0125
    ],
    [
      "reveler",
      0.0125
    ],
    [
      "renfermer",
      0.01
    ],
    [
      "interpreter",
      0.01
    ],
    [
      "assimiler",
      0.01
    ],
    [
      "suivre",
      0.005
    ],
    [
      "savoir",
      0.005
    ],
    [
      "s'apercevoir",
      0.005
    ],
    [
      "mordre",
      0.005
    ],
    [
      "integrer",
      0.005
    ],
    [
      "incorporer",
      0.005
    ],
    [
      "compter",
      0.005
    ],
    [
      "enfermer",
      0.005
    ],
    [
      "entrer",
      0.005
    ],
    [
      "entrevoir",
      0.005
    ],
    [
      "impliquer",
      0.005
    ],
    [
      "traduire",
      0.0025
    ],
    [
      "realiser",
      0.0025
    ],
    [
      "piger",
      0.0025
    ],
    [
      "meler",
      0.0025
    ],
    [
      "envelopper",
      0.0025
    ],
    [
      "enclore",
      0.0025
    ],
    [
      "approuver",
      0.0025
    ],
    [
      "s'expliquer",
      0.0
    ],
    [
      "melanger",
      0.0
    ],
    [
      "grouper",
      0.0
    ],
    [
      "demeler",
      0.0
    ],
    [
      "decoder",
      0.0
    ],
    [
      "consister",
      0.0
    ]
  ],
  "bidet": [
    [
      "bourrin",
      0.125
    ],
    [
      "canasson",
      0.125
    ],
    [
      "cheval",
      0.125
    ],
    [
      "cob",
      0.125
    ],
    [
      "cuvette",
      0.125
    ],
    [
      "mule",
      0.125
    ],
    [
      "mulet",
      0.125
    ],
    [
      "postier",
      0.125
    ]
  ],
  "aucune": [
    [
      "nul",
      0.25
    ],
    [
      "quelque",
      0.25
    ],
    [
      "zero",
      0.25
    ]
  ],
  "idee": [
    [
      "pensee",
      0.07
    ],
    [
      "conception",
      0.0375
    ],
    [
      "vue",
      0.0375
    ],
    [
      "imagination",
      0.035
    ],
    [
      "sentiment",
      0.035
    ],
    [
      "image",
      0.0275
    ],
    [
      "vision",
      0.0275
    ],
    [
      "reve",
      0.0225
    ],
    [
      "opinion",
      0.0225
    ],
    [
      "notion",
      0.02
    ],
    [
      "plan",
      0.02
    ],
    [
      "connaissance",
      0.0175
    ],
    [
      "theorie",
      0.0175
    ],
    [
      "principe",
      0.015
    ],
    [
      "position",
      0.015
    ],
    [
      "intelligence",
      0.015
    ],
    [
      "illusion",
      0.015
    ],
    [
      "ombre",
      0.0125
    ],
    [
      "invention",
      0.0125
    ],
    [
      "esquisse",
      0.0125
    ],
    [
      "dessein",
      0.0125
    ],
    [
      "conscience",
      0.0125
    ],
    [
      "chimere",
      0.0125
    ],
    [
      "abstraction",
      0.0125
    ],
    [
      "volonte",
      0.01
    ],
    [
      "reverie",
      0.01
    ],
    [
      "representation",
      0.01
    ],
    [
      "projet",
      0.01
    ],
    [
      "perspective",
      0.01
    ],
    [
      "perception",
      0.01
    ],
    [
      "modele",
      0.01
    ],
    [
      "jugement",
      0.01
    ],
    [
      "fantaisie",
      0.01
    ],
    [
      "apparence",
      0.01
    ],
    [
      "apercu",
      0.01
    ],
    [
      "ebauche",
      0.0075
    ],
    [
      "supposition",
      0.0075
    ],
    [
      "soupcon",
      0.0075
    ],
    [
      "pointe",
      0.0075
    ],
    [
      "manie",
      0.0075
    ],
    [
      "intention",
      0.0075
    ],
    [
      "humeur",
      0.0075
    ],
    [
      "croyance",
      0.0075
    ],
    [
      "pressentiment",
      0.005
    ],
    [
      "reflexion",
      0.005
    ],
    [
      "schema",
      0.005
    ],
    [
      "sujet",
      0.005
    ],
    [
      "tete",
      0.005
    ],
    [
      "echantillon",
      0.005
    ],
    [
      "philosophie",
      0.005
    ],
    [
      "obsession",
      0.005
    ],
    [
      "inspiration",
      0.005
    ],
    [
      "aspect",
      0.005
    ],
    [
      "concept",
      0.005
    ],
    [
      "desir",
      0.005
    ],
    [
      "essai",
      0.005
    ],
    [
      "exemple",
      0.005
    ],
    [
      "gre",
      0.005
    ],
    [
      "hypothese",
      0.005
    ],
    [
      "marotte",
      0.0025
    ],
    [
      "mythe",
      0.0025
    ],
    [
      "once",
      0.0025
    ],
    [
      "situation",
      0.0025
    ],
    [
      "theme",
      0.0025
    ],
    [
      "trouvaille",
      0.0025
    ],
    [
      "larme",
      0.0025
    ],
    [
      "hantise",
      0.0025
    ],
    [
      "archetype",
      0.0025
    ],
    [
      "avis",
      0.0025
    ],
    [
      "categorie",
      0.0025
    ],
    [
      "fantome",
      0.0025
    ],
    [
      "fond",
      0.0025
    ],
    [
      "goutte",
      0.0025
    ],
    [
      "source",
      0.0
    ],
    [
      "psychose",
      0.0
    ],
    [
      "prejuge",
      0.0
    ],
    [
      "possibilite",
      0.0
    ],
    [
      "penser",
      0.0
    ],
    [
      "lineament",
      0.0
    ],
    [
      "illumination",
      0.0
    ],
    [
      "entite",
      0.0
    ],
    [
      "determination",
      0.0
    ],
    [
      "donnee",
      0.0
    ],
    [
      "dada",
      0.0
    ],
    [
      "clarte",
      0.0
    ],
    [
      "elucubration",
      0.0
    ]
  ],
  "cote": [
    [
      "juger",
      0.1525
    ],
    [
      "jauger",
      0.115
    ],
    [
      "noter",
      0.115
    ],
    [
      "evaluer",
      0.075
    ],
    [
      "numeroter",
      0.075
    ],
    [
      "marquer",
      0.075
    ],
    [
      "classer",
      0.075
    ],
    [
      "apprecier",
      0.075
    ],
    [
      "cataloguer",
      0.0375
    ],
    [
      "estimer",
      0.0375
    ],
    [
      "faire",
      0.0375
    ],
    [
      "folioter",
      0.0375
    ],
    [
      "paginer",
      0.0375
    ],
    [
      "tarifer",
      0.0375
    ]
  ],
  "gommer": [
    [
      "supprimer",
      0.19
    ],
    [
      "oter",
      0.19
    ],
    [
      "retrancher",
      0.095
    ],
    [
      "radier",
      0.095
    ],
    [
      "enlever",
      0.095
    ],
    [
      "effacer",
      0.095
    ],
    [
      "coller",
      0.045
    ],
    [
      "enduire",
      0.045
    ],
    [
      "gominer",
      0.045
    ],
    [
      "sacrifier",
      0.045
    ]
  ],
  "gomme": [
    [
      "supprimer",
      0.19
    ],
    [
      "oter",
      0.19
    ],
    [
      "retrancher",
      0.095
    ],
    [
      "radier",
      0.095
    ],
    [
      "enlever",
      0.095
    ],
    [
      "effacer",
      0.095
    ],
    [
      "coller",
      0.045
    ],
    [
      "enduire",
      0.045
    ],
    [
      "gominer",
      0.045
    ],
    [
      "sacrifier",
      0.045
    ]
  ],
  "ah": [],
  "sonnette": [
    [
      "cloche",
      0.265
    ],
    [
      "clochette",
      0.1575
    ],
    [
      "grelot",
      0.105
    ],
    [
      "sonnaille",
      0.105
    ],
    [
      "drelin",
      0.05
    ],
    [
      "clarine",
      0.05
    ],
    [
      "carillon",
      0.05
    ],
    [
      "campane",
      0.05
    ],
    [
      "avertisseur",
      0.05
    ],
    [
      "appel",
      0.05
    ],
    [
      "timbre",
      0.05
    ]
  ],
  "accueil": [
    [
      "reception",
      0.16
    ],
    [
      "abord",
      0.12
    ],
    [
      "entree",
      0.12
    ],
    [
      "amabilite",
      0.08
    ],
    [
      "hospitalite",
      0.08
    ],
    [
      "hebergement",
      0.04
    ],
    [
      "mine",
      0.04
    ],
    [
      "refuge",
      0.04
    ],
    [
      "reaction",
      0.04
    ],
    [
      "hall",
      0.04
    ],
    [
      "chere",
      0.04
    ],
    [
      "bonte",
      0.04
    ],
    [
      "bienvenue",
      0.04
    ],
    [
      "asile",
      0.04
    ],
    [
      "acces",
      0.04
    ],
    [
      "traitement",
      0.04
    ]
  ],
  "hotel": [
    [
      "maison",
      0.1175
    ],
    [
      "auberge",
      0.0925
    ],
    [
      "cabaret",
      0.07
    ],
    [
      "immeuble",
      0.07
    ],
    [
      "palais",
      0.07
    ],
    [
      "etape",
      0.07
    ],
    [
      "hotellerie",
      0.045
    ],
    [
      "gite",
      0.045
    ],
    [
      "cambuse",
      0.045
    ],
    [
      "riokan",
      0.0225
    ],
    [
      "relais",
      0.0225
    ],
    [
      "pension",
      0.0225
    ],
    [
      "parador",
      0.0225
    ],
    [
      "palace",
      0.0225
    ],
    [
      "motel",
      0.0225
    ],
    [
      "meuble",
      0.0225
    ],
    [
      "logis",
      0.0225
    ],
    [
      "estaminet",
      0.0225
    ],
    [
      "creche",
      0.0225
    ],
    [
      "chateau",
      0.0225
    ],
    [
      "caravanserail",
      0.0225
    ],
    [
      "batiment",
      0.0225
    ],
    [
      "taule",
      0.0225
    ]
  ],
  "sac": [
    [
      "sacoche",
      0.09
    ],
    [
      "poche",
      0.075
    ],
    [
      "bourse",
      0.06
    ],
    [
      "enveloppe",
      0.06
    ],
    [
      "gibeciere",
      0.06
    ],
    [
      "saccage",
      0.045
    ],
    [
      "trousse",
      0.0275
    ],
    [
      "sachet",
      0.0275
    ],
    [
      "reticule",
      0.0275
    ],
    [
      "pillage",
      0.0275
    ],
    [
      "devastation",
      0.0275
    ],
    [
      "contenant",
      0.0275
    ],
    [
      "carnassiere",
      0.0275
    ],
    [
      "cabas",
      0.0275
    ],
    [
      "balle",
      0.0275
    ],
    [
      "aumoniere",
      0.0275
    ],
    [
      "havresac",
      0.0125
    ],
    [
      "hotte",
      0.0125
    ],
    [
      "massacre",
      0.0125
    ],
    [
      "panetiere",
      0.0125
    ],
    [
      "raide",
      0.0125
    ],
    [
      "ravage",
      0.0125
    ],
    [
      "razzia",
      0.0125
    ],
    [
      "ridicule",
      0.0125
    ],
    [
      "recipient",
      0.0125
    ],
    [
      "depredation",
      0.0125
    ],
    [
      "colis",
      0.0125
    ],
    [
      "bagage",
      0.0125
    ],
    [
      "ballot",
      0.0125
    ],
    [
      "barda",
      0.0125
    ],
    [
      "besace",
      0.0125
    ],
    [
      "bissac",
      0.0125
    ],
    [
      "briquage",
      0.0125
    ],
    [
      "cartable",
      0.0125
    ],
    [
      "cartouchiere",
      0.0125
    ],
    [
      "cavite",
      0.0125
    ],
    [
      "sacotin",
      0.0125
    ]
  ],
  "toute": [],
  "pocher": [
    [
      "croquer",
      0.1675
    ],
    [
      "esquisser",
      0.11
    ],
    [
      "goder",
      0.11
    ],
    [
      "grigner",
      0.11
    ],
    [
      "saisir",
      0.055
    ],
    [
      "pocheter",
      0.055
    ],
    [
      "plonger",
      0.055
    ],
    [
      "peindre",
      0.055
    ],
    [
      "meurtrir",
      0.055
    ],
    [
      "grimacer",
      0.055
    ],
    [
      "godailler",
      0.055
    ],
    [
      "ebaucher",
      0.055
    ]
  ],
  "poche": [
    [
      "sac",
      0.1
    ],
    [
      "gonflement",
      0.06
    ],
    [
      "pochette",
      0.06
    ],
    [
      "valise",
      0.04
    ],
    [
      "sacoche",
      0.04
    ],
    [
      "filet",
      0.04
    ],
    [
      "enflure",
      0.04
    ],
    [
      "cavite",
      0.04
    ],
    [
      "bourse",
      0.04
    ],
    [
      "pochon",
      0.02
    ],
    [
      "pochee",
      0.02
    ],
    [
      "pocket",
      0.02
    ],
    [
      "profonde",
      0.02
    ],
    [
      "renflement",
      0.02
    ],
    [
      "renfoncement",
      0.02
    ],
    [
      "repli",
      0.02
    ],
    [
      "sachet",
      0.02
    ],
    [
      "saillie",
      0.02
    ],
    [
      "trousse",
      0.02
    ],
    [
      "valoche",
      0.02
    ],
    [
      "pochetee",
      0.02
    ],
    [
      "pli",
      0.02
    ],
    [
      "manche",
      0.02
    ],
    [
      "apostume",
      0.02
    ],
    [
      "aumoniere",
      0.02
    ],
    [
      "balance",
      0.02
    ],
    [
      "blague",
      0.02
    ],
    [
      "bouffissure",
      0.02
    ],
    [
      "cerne",
      0.02
    ],
    [
      "cuiller",
      0.02
    ],
    [
      "emballage",
      0.02
    ],
    [
      "fouille",
      0.02
    ],
    [
      "gousset",
      0.02
    ],
    [
      "jabot",
      0.02
    ],
    [
      "epuisette",
      0.02
    ]
  ],
  "jean": [
    [
      "denim",
      0.25
    ],
    [
      "pantalon",
      0.25
    ]
  ],
  "mettre": [
    [
      "placer",
      0.0875
    ],
    [
      "poser",
      0.0475
    ],
    [
      "appliquer",
      0.0375
    ],
    [
      "ficher",
      0.0325
    ],
    [
      "coller",
      0.0275
    ],
    [
      "situer",
      0.0275
    ],
    [
      "fixer",
      0.0275
    ],
    [
      "etablir",
      0.025
    ],
    [
      "introduire",
      0.0225
    ],
    [
      "porter",
      0.0225
    ],
    [
      "prendre",
      0.02
    ],
    [
      "fourrer",
      0.02
    ],
    [
      "disposer",
      0.0175
    ],
    [
      "attacher",
      0.0175
    ],
    [
      "installer",
      0.015
    ],
    [
      "camper",
      0.015
    ],
    [
      "tenir",
      0.0125
    ],
    [
      "planter",
      0.0125
    ],
    [
      "passer",
      0.0125
    ],
    [
      "loger",
      0.0125
    ],
    [
      "engager",
      0.0125
    ],
    [
      "caser",
      0.0125
    ],
    [
      "affecter",
      0.0125
    ],
    [
      "etendre",
      0.01
    ],
    [
      "remettre",
      0.01
    ],
    [
      "flanquer",
      0.01
    ],
    [
      "dresser",
      0.01
    ],
    [
      "coucher",
      0.01
    ],
    [
      "consigner",
      0.01
    ],
    [
      "appuyer",
      0.01
    ],
    [
      "marquer",
      0.01
    ],
    [
      "jeter",
      0.01
    ],
    [
      "inscrire",
      0.01
    ],
    [
      "charger",
      0.01
    ],
    [
      "ranger",
      0.0075
    ],
    [
      "employer",
      0.0075
    ],
    [
      "conduire",
      0.0075
    ],
    [
      "asseoir",
      0.0075
    ],
    [
      "arrimer",
      0.0075
    ],
    [
      "arranger",
      0.0075
    ],
    [
      "etaler",
      0.0075
    ],
    [
      "laisser",
      0.0075
    ],
    [
      "foutre",
      0.0075
    ],
    [
      "amener",
      0.0075
    ],
    [
      "mener",
      0.005
    ],
    [
      "noter",
      0.005
    ],
    [
      "plaquer",
      0.005
    ],
    [
      "poster",
      0.005
    ],
    [
      "preparer",
      0.005
    ],
    [
      "serrer",
      0.005
    ],
    [
      "ecrire",
      0.005
    ],
    [
      "imputer",
      0.005
    ],
    [
      "glisser",
      0.005
    ],
    [
      "afficher",
      0.005
    ],
    [
      "apporter",
      0.005
    ],
    [
      "attribuer",
      0.005
    ],
    [
      "classer",
      0.005
    ],
    [
      "deposer",
      0.005
    ],
    [
      "enfiler",
      0.005
    ],
    [
      "enfoncer",
      0.005
    ],
    [
      "verser",
      0.0025
    ],
    [
      "revetir",
      0.0025
    ],
    [
      "manger",
      0.0025
    ],
    [
      "interposer",
      0.0025
    ],
    [
      "inserer",
      0.0025
    ],
    [
      "fricoter",
      0.0025
    ],
    [
      "fonder",
      0.0025
    ],
    [
      "constituer",
      0.0025
    ],
    [
      "consacrer",
      0.0025
    ],
    [
      "adosser",
      0.0025
    ],
    [
      "melanger",
      0.0025
    ],
    [
      "opposer",
      0.0025
    ],
    [
      "plonger",
      0.0025
    ],
    [
      "reduire",
      0.0025
    ],
    [
      "s'habiller",
      0.0025
    ],
    [
      "traduire",
      0.0025
    ],
    [
      "imposer",
      0.0025
    ],
    [
      "immatriculer",
      0.0025
    ],
    [
      "admettre",
      0.0025
    ],
    [
      "attendre",
      0.0025
    ],
    [
      "considerer",
      0.0025
    ],
    [
      "croquer",
      0.0025
    ],
    [
      "emmener",
      0.0025
    ],
    [
      "endosser",
      0.0025
    ],
    [
      "fricasser",
      0.0025
    ],
    [
      "trouver",
      0.0
    ],
    [
      "rajouter",
      0.0
    ],
    [
      "miser",
      0.0
    ],
    [
      "mentionner",
      0.0
    ],
    [
      "garder",
      0.0
    ],
    [
      "empiler",
      0.0
    ],
    [
      "claquer",
      0.0
    ],
    [
      "chausser",
      0.0
    ],
    [
      "bouter",
      0.0
    ],
    [
      "apposer",
      0.0
    ],
    [
      "agrafer",
      0.0
    ],
    [
      "vetir",
      0.0
    ]
  ],
  "dedans": [
    [
      "interieur",
      0.2725
    ],
    [
      "ame",
      0.18
    ],
    [
      "coeur",
      0.09
    ],
    [
      "ceans",
      0.09
    ],
    [
      "dans",
      0.09
    ],
    [
      "intime",
      0.09
    ],
    [
      "intrinseque",
      0.09
    ],
    [
      "interieurement",
      0.09
    ]
  ],
  "utile": [
    [
      "bon",
      0.16
    ],
    [
      "precieux",
      0.1
    ],
    [
      "avantageux",
      0.08
    ],
    [
      "profitable",
      0.08
    ],
    [
      "seyant",
      0.06
    ],
    [
      "propice",
      0.06
    ],
    [
      "opportun",
      0.06
    ],
    [
      "convenable",
      0.06
    ],
    [
      "utilisable",
      0.0375
    ],
    [
      "salutaire",
      0.0375
    ],
    [
      "pratique",
      0.0375
    ],
    [
      "necessaire",
      0.0375
    ],
    [
      "important",
      0.0375
    ],
    [
      "efficace",
      0.0375
    ],
    [
      "expedient",
      0.0175
    ],
    [
      "fructueux",
      0.0175
    ],
    [
      "indispensable",
      0.0175
    ],
    [
      "tutelaire",
      0.0175
    ],
    [
      "usager",
      0.0175
    ]
  ],
  "inutile": [
    [
      "vain",
      0.1225
    ],
    [
      "sterile",
      0.1125
    ],
    [
      "vide",
      0.0975
    ],
    [
      "futile",
      0.06
    ],
    [
      "nul",
      0.06
    ],
    [
      "superflu",
      0.0475
    ],
    [
      "insignifiant",
      0.0475
    ],
    [
      "inefficace",
      0.0475
    ],
    [
      "improductif",
      0.0475
    ],
    [
      "bete",
      0.0375
    ],
    [
      "oiseux",
      0.0375
    ],
    [
      "superfetatoire",
      0.0225
    ],
    [
      "negligeable",
      0.0225
    ],
    [
      "mauvais",
      0.0225
    ],
    [
      "infecond",
      0.0225
    ],
    [
      "accessoire",
      0.0225
    ],
    [
      "absurde",
      0.0225
    ],
    [
      "perdu",
      0.01
    ],
    [
      "parasite",
      0.01
    ],
    [
      "infructueux",
      0.01
    ],
    [
      "inemployable",
      0.01
    ],
    [
      "frivole",
      0.01
    ],
    [
      "croupissant",
      0.01
    ],
    [
      "creux",
      0.01
    ]
  ],
  "habile": [
    [
      "adroit",
      0.065
    ],
    [
      "capable",
      0.05
    ],
    [
      "fin",
      0.0425
    ],
    [
      "astucieux",
      0.04
    ],
    [
      "expert",
      0.04
    ],
    [
      "experimente",
      0.035
    ],
    [
      "malin",
      0.03
    ],
    [
      "ruse",
      0.03
    ],
    [
      "bon",
      0.0275
    ],
    [
      "intelligent",
      0.025
    ],
    [
      "ingenieux",
      0.025
    ],
    [
      "subtil",
      0.0225
    ],
    [
      "competent",
      0.02
    ],
    [
      "fute",
      0.02
    ],
    [
      "retors",
      0.02
    ],
    [
      "savant",
      0.02
    ],
    [
      "fort",
      0.0175
    ],
    [
      "roublard",
      0.0175
    ],
    [
      "propre",
      0.015
    ],
    [
      "exerce",
      0.015
    ],
    [
      "delicat",
      0.015
    ],
    [
      "averti",
      0.0125
    ],
    [
      "avise",
      0.0125
    ],
    [
      "beau",
      0.0125
    ],
    [
      "delie",
      0.0125
    ],
    [
      "roue",
      0.01
    ],
    [
      "prompt",
      0.01
    ],
    [
      "verse",
      0.0075
    ],
    [
      "tortueux",
      0.0075
    ],
    [
      "souple",
      0.0075
    ],
    [
      "qualifie",
      0.0075
    ],
    [
      "penetrant",
      0.0075
    ],
    [
      "entendu",
      0.0075
    ],
    [
      "debrouillard",
      0.0075
    ],
    [
      "diplomate",
      0.0075
    ],
    [
      "combinard",
      0.0075
    ],
    [
      "agile",
      0.0075
    ],
    [
      "eclaire",
      0.0075
    ],
    [
      "vif",
      0.0075
    ],
    [
      "prudent",
      0.0075
    ],
    [
      "matois",
      0.0075
    ],
    [
      "doue",
      0.0075
    ],
    [
      "brillant",
      0.0075
    ],
    [
      "emerite",
      0.005
    ],
    [
      "sur",
      0.005
    ],
    [
      "rompu",
      0.005
    ],
    [
      "politique",
      0.005
    ],
    [
      "industrieux",
      0.005
    ],
    [
      "chevronne",
      0.005
    ],
    [
      "artificieux",
      0.005
    ],
    [
      "apte",
      0.005
    ],
    [
      "inventif",
      0.0025
    ],
    [
      "leste",
      0.0025
    ],
    [
      "madre",
      0.0025
    ],
    [
      "preste",
      0.0025
    ],
    [
      "eprouve",
      0.0025
    ],
    [
      "insinuant",
      0.0025
    ],
    [
      "finaud",
      0.0025
    ],
    [
      "ferre",
      0.0025
    ],
    [
      "exquis",
      0.0025
    ],
    [
      "entraine",
      0.0025
    ],
    [
      "cauteleux",
      0.0025
    ],
    [
      "captieux",
      0.0025
    ],
    [
      "erudit",
      0.0025
    ],
    [
      "virtuose",
      0.0025
    ],
    [
      "raffine",
      0.0025
    ],
    [
      "intrigant",
      0.0025
    ],
    [
      "heureux",
      0.0025
    ],
    [
      "docte",
      0.0025
    ],
    [
      "cale",
      0.0025
    ],
    [
      "magicien",
      0.0
    ],
    [
      "facile",
      0.0
    ],
    [
      "demerdard",
      0.0
    ],
    [
      "diplomatique",
      0.0
    ],
    [
      "diligent",
      0.0
    ],
    [
      "bricoleur",
      0.0
    ],
    [
      "assure",
      0.0
    ],
    [
      "adextre",
      0.0
    ]
  ],
  "futile": [
    [
      "frivole",
      0.1325
    ],
    [
      "leger",
      0.1325
    ],
    [
      "vain",
      0.1175
    ],
    [
      "insignifiant",
      0.1025
    ],
    [
      "vide",
      0.1025
    ],
    [
      "inutile",
      0.0725
    ],
    [
      "negligeable",
      0.0425
    ],
    [
      "superficiel",
      0.0275
    ],
    [
      "sterile",
      0.0275
    ],
    [
      "oiseux",
      0.0275
    ],
    [
      "creux",
      0.0275
    ],
    [
      "pueril",
      0.0125
    ],
    [
      "meprisable",
      0.0125
    ],
    [
      "mondain",
      0.0125
    ],
    [
      "menu",
      0.0125
    ],
    [
      "insouciant",
      0.0125
    ],
    [
      "inepte",
      0.0125
    ],
    [
      "inconsistant",
      0.0125
    ],
    [
      "desinvolte",
      0.0125
    ],
    [
      "byzantin",
      0.0125
    ],
    [
      "badin",
      0.0125
    ],
    [
      "anodin",
      0.0125
    ],
    [
      "evapore",
      0.0125
    ]
  ],
  "leur": [
    [
      "sien",
      1.0
    ]
  ],
  "interet": [
    [
      "gain",
      0.07
    ],
    [
      "rapport",
      0.055
    ],
    [
      "revenu",
      0.0475
    ],
    [
      "avantage",
      0.04
    ],
    [
      "valeur",
      0.035
    ],
    [
      "profit",
      0.035
    ],
    [
      "affection",
      0.035
    ],
    [
      "rente",
      0.0275
    ],
    [
      "passion",
      0.0275
    ],
    [
      "loyer",
      0.0275
    ],
    [
      "coeur",
      0.0275
    ],
    [
      "bonte",
      0.0275
    ],
    [
      "bien",
      0.0275
    ],
    [
      "attachement",
      0.0275
    ],
    [
      "amour",
      0.0275
    ],
    [
      "utilite",
      0.02
    ],
    [
      "remuneration",
      0.02
    ],
    [
      "ressource",
      0.02
    ],
    [
      "prix",
      0.02
    ],
    [
      "commission",
      0.02
    ],
    [
      "bienveillance",
      0.02
    ],
    [
      "agio",
      0.02
    ],
    [
      "pourcentage",
      0.0125
    ],
    [
      "sollicitude",
      0.0125
    ],
    [
      "sympathie",
      0.0125
    ],
    [
      "tantieme",
      0.0125
    ],
    [
      "taux",
      0.0125
    ],
    [
      "usure",
      0.0125
    ],
    [
      "portee",
      0.0125
    ],
    [
      "poids",
      0.0125
    ],
    [
      "piquant",
      0.0125
    ],
    [
      "ardeur",
      0.0125
    ],
    [
      "attache",
      0.0125
    ],
    [
      "attention",
      0.0125
    ],
    [
      "charge",
      0.0125
    ],
    [
      "curiosite",
      0.0125
    ],
    [
      "desir",
      0.0125
    ],
    [
      "escompte",
      0.005
    ],
    [
      "importance",
      0.005
    ],
    [
      "intrigue",
      0.005
    ],
    [
      "originalite",
      0.005
    ],
    [
      "piment",
      0.005
    ],
    [
      "rentabilite",
      0.005
    ],
    [
      "dommage",
      0.005
    ],
    [
      "dividende",
      0.005
    ],
    [
      "denier",
      0.005
    ],
    [
      "compte",
      0.005
    ],
    [
      "charme",
      0.005
    ],
    [
      "cause",
      0.005
    ],
    [
      "arrerages",
      0.005
    ],
    [
      "annuite",
      0.005
    ],
    [
      "anatocisme",
      0.005
    ],
    [
      "soif",
      0.005
    ]
  ],
  "repondre": [
    [
      "affirmer",
      0.0675
    ],
    [
      "assurer",
      0.0675
    ],
    [
      "dire",
      0.0525
    ],
    [
      "declarer",
      0.0525
    ],
    [
      "temoigner",
      0.045
    ],
    [
      "certifier",
      0.045
    ],
    [
      "protester",
      0.0375
    ],
    [
      "soutenir",
      0.0275
    ],
    [
      "satisfaire",
      0.0275
    ],
    [
      "resister",
      0.0275
    ],
    [
      "repliquer",
      0.0275
    ],
    [
      "riposter",
      0.0275
    ],
    [
      "promettre",
      0.0275
    ],
    [
      "faire",
      0.0275
    ],
    [
      "refuter",
      0.0225
    ],
    [
      "opposer",
      0.0225
    ],
    [
      "objecter",
      0.0225
    ],
    [
      "garantir",
      0.0225
    ],
    [
      "couvrir",
      0.0225
    ],
    [
      "convenir",
      0.0225
    ],
    [
      "retorquer",
      0.0125
    ],
    [
      "reagir",
      0.0125
    ],
    [
      "remplir",
      0.0125
    ],
    [
      "produire",
      0.0125
    ],
    [
      "correspondre",
      0.0125
    ],
    [
      "attester",
      0.0125
    ],
    [
      "repartir",
      0.005
    ],
    [
      "recriminer",
      0.005
    ],
    [
      "s'accorder",
      0.005
    ],
    [
      "s'engager",
      0.005
    ],
    [
      "rendre",
      0.005
    ],
    [
      "rembarrer",
      0.005
    ],
    [
      "concorder",
      0.005
    ],
    [
      "contredire",
      0.005
    ],
    [
      "obeir",
      0.005
    ],
    [
      "raisonner",
      0.005
    ]
  ],
  "begayer": [
    [
      "balbutier",
      0.25
    ],
    [
      "bafouiller",
      0.1875
    ],
    [
      "bredouiller",
      0.1875
    ],
    [
      "parler",
      0.125
    ],
    [
      "baragouiner",
      0.0625
    ],
    [
      "hesiter",
      0.0625
    ],
    [
      "prononcer",
      0.0625
    ]
  ],
  "auto": [
    [
      "automobile",
      0.285
    ],
    [
      "voiture",
      0.285
    ],
    [
      "bagnole",
      0.1425
    ],
    [
      "berline",
      0.1425
    ]
  ],
  "collant": [
    [
      "adherent",
      0.055
    ],
    [
      "visqueux",
      0.055
    ],
    [
      "tenace",
      0.055
    ],
    [
      "serre",
      0.055
    ],
    [
      "raseur",
      0.055
    ],
    [
      "importun",
      0.055
    ],
    [
      "gluant",
      0.055
    ],
    [
      "adhesif",
      0.055
    ],
    [
      "juste",
      0.0375
    ],
    [
      "crampon",
      0.0375
    ],
    [
      "chausse",
      0.0375
    ],
    [
      "accrocheur",
      0.0375
    ],
    [
      "maillot",
      0.0175
    ],
    [
      "moulant",
      0.0175
    ],
    [
      "poisseux",
      0.0175
    ],
    [
      "pateux",
      0.0175
    ],
    [
      "sangsue",
      0.0175
    ],
    [
      "scotch",
      0.0175
    ],
    [
      "sirupeux",
      0.0175
    ],
    [
      "justaucorps",
      0.0175
    ],
    [
      "indiscret",
      0.0175
    ],
    [
      "ennuyeux",
      0.0175
    ],
    [
      "culotte",
      0.0175
    ],
    [
      "cuit",
      0.0175
    ],
    [
      "conglutinant",
      0.0175
    ],
    [
      "colleur",
      0.0175
    ],
    [
      "bas",
      0.0175
    ],
    [
      "autocollant",
      0.0175
    ],
    [
      "ajuste",
      0.0175
    ],
    [
      "etroit",
      0.0175
    ]
  ],
  "fruit": [
    [
      "produit",
      0.1
    ],
    [
      "resultat",
      0.09
    ],
    [
      "benefice",
      0.07
    ],
    [
      "consequence",
      0.06
    ],
    [
      "gain",
      0.06
    ],
    [
      "effet",
      0.05
    ],
    [
      "suite",
      0.04
    ],
    [
      "revenu",
      0.04
    ],
    [
      "ressource",
      0.04
    ],
    [
      "profit",
      0.04
    ],
    [
      "enfant",
      0.04
    ],
    [
      "avantage",
      0.03
    ],
    [
      "rapport",
      0.03
    ],
    [
      "usufruit",
      0.0175
    ],
    [
      "rejeton",
      0.0175
    ],
    [
      "recette",
      0.0175
    ],
    [
      "portee",
      0.0175
    ],
    [
      "graine",
      0.0175
    ],
    [
      "fils",
      0.0175
    ],
    [
      "fille",
      0.0175
    ],
    [
      "bien",
      0.0175
    ],
    [
      "baie",
      0.0175
    ],
    [
      "aboutissement",
      0.0175
    ],
    [
      "pomme",
      0.0075
    ],
    [
      "production",
      0.0075
    ],
    [
      "premices",
      0.0075
    ],
    [
      "rancon",
      0.0075
    ],
    [
      "grain",
      0.0075
    ],
    [
      "faine",
      0.0075
    ],
    [
      "denouement",
      0.0075
    ],
    [
      "couronnement",
      0.0075
    ],
    [
      "akene",
      0.0075
    ],
    [
      "agrume",
      0.0075
    ],
    [
      "recompense",
      0.0075
    ]
  ],
  "mais": [
    [
      "cependant",
      0.175
    ],
    [
      "pourtant",
      0.1175
    ],
    [
      "seulement",
      0.0575
    ],
    [
      "or",
      0.0575
    ],
    [
      "neanmoins",
      0.0575
    ],
    [
      "ne",
      0.0575
    ],
    [
      "et",
      0.0575
    ],
    [
      "encore",
      0.0575
    ],
    [
      "toutefois",
      0.0575
    ]
  ],
  "voila": [
    [
      "voici",
      1.0
    ]
  ],
  "vedette": [
    [
      "artiste",
      0.11
    ],
    [
      "acteur",
      0.0725
    ],
    [
      "personnalite",
      0.0725
    ],
    [
      "sommite",
      0.0725
    ],
    [
      "star",
      0.0725
    ],
    [
      "etoile",
      0.0725
    ],
    [
      "factionnaire",
      0.035
    ],
    [
      "manchette",
      0.035
    ],
    [
      "notabilite",
      0.035
    ],
    [
      "sentinelle",
      0.035
    ],
    [
      "embarcation",
      0.035
    ],
    [
      "celebrite",
      0.035
    ],
    [
      "chanteuse",
      0.035
    ],
    [
      "chanteur",
      0.035
    ],
    [
      "champion",
      0.035
    ],
    [
      "canot",
      0.035
    ],
    [
      "bateau",
      0.035
    ],
    [
      "astre",
      0.035
    ]
  ],
  "cadre": [
    [
      "carcasse",
      0.0675
    ],
    [
      "encadrement",
      0.0675
    ],
    [
      "charpente",
      0.055
    ],
    [
      "cercle",
      0.045
    ],
    [
      "sphere",
      0.0325
    ],
    [
      "plan",
      0.0325
    ],
    [
      "milieu",
      0.0325
    ],
    [
      "limite",
      0.0325
    ],
    [
      "entourage",
      0.0325
    ],
    [
      "contenant",
      0.0325
    ],
    [
      "canevas",
      0.0325
    ],
    [
      "bordure",
      0.0325
    ],
    [
      "appareil",
      0.0325
    ],
    [
      "tableau",
      0.02
    ],
    [
      "ossature",
      0.02
    ],
    [
      "decor",
      0.02
    ],
    [
      "domaine",
      0.02
    ],
    [
      "disposition",
      0.02
    ],
    [
      "chassis",
      0.02
    ],
    [
      "chef",
      0.02
    ],
    [
      "caisse",
      0.02
    ],
    [
      "bord",
      0.02
    ],
    [
      "liste",
      0.01
    ],
    [
      "huisserie",
      0.01
    ],
    [
      "hierarchie",
      0.01
    ],
    [
      "environnement",
      0.01
    ],
    [
      "enveloppe",
      0.01
    ],
    [
      "manager",
      0.01
    ],
    [
      "orbite",
      0.01
    ],
    [
      "responsable",
      0.01
    ],
    [
      "schema",
      0.01
    ],
    [
      "superieur",
      0.01
    ],
    [
      "entour",
      0.01
    ],
    [
      "ensemble",
      0.01
    ],
    [
      "borne",
      0.01
    ],
    [
      "bourgeois",
      0.01
    ],
    [
      "bati",
      0.01
    ],
    [
      "carcan",
      0.01
    ],
    [
      "cartouche",
      0.01
    ],
    [
      "chambranle",
      0.01
    ],
    [
      "coffrage",
      0.01
    ],
    [
      "compagnie",
      0.01
    ],
    [
      "conteneur",
      0.01
    ],
    [
      "contrainte",
      0.01
    ],
    [
      "corset",
      0.01
    ],
    [
      "boisage",
      0.01
    ]
  ],
  "cadrer": [
    [
      "aller",
      0.14
    ],
    [
      "convenir",
      0.14
    ],
    [
      "concorder",
      0.115
    ],
    [
      "s'accorder",
      0.0925
    ],
    [
      "correspondre",
      0.07
    ],
    [
      "s'ajuster",
      0.07
    ],
    [
      "s'adapter",
      0.045
    ],
    [
      "coincider",
      0.045
    ],
    [
      "border",
      0.0225
    ],
    [
      "centrer",
      0.0225
    ],
    [
      "concilier",
      0.0225
    ],
    [
      "corder",
      0.0225
    ],
    [
      "plaire",
      0.0225
    ],
    [
      "s'assortir",
      0.0225
    ]
  ],
  "numerique": [
    [
      "discret",
      0.5
    ],
    [
      "numeral",
      0.5
    ]
  ],
  "deuxieme": [
    [
      "autre",
      0.2
    ],
    [
      "second",
      0.2
    ],
    [
      "suivant",
      0.2
    ],
    [
      "deux",
      0.1
    ],
    [
      "duodi",
      0.1
    ],
    [
      "posterieur",
      0.1
    ]
  ],
  "prenom": [
    [
      "nom",
      0.25
    ]
  ],
  "placement": [
    [
      "investissement",
      0.1425
    ],
    [
      "ecoulement",
      0.07
    ],
    [
      "vente",
      0.07
    ],
    [
      "usure",
      0.07
    ],
    [
      "rangement",
      0.07
    ],
    [
      "positionnement",
      0.07
    ],
    [
      "installation",
      0.07
    ],
    [
      "financement",
      0.07
    ],
    [
      "defaite",
      0.07
    ],
    [
      "classement",
      0.07
    ],
    [
      "etablissement",
      0.07
    ]
  ],
  "produire": [
    [
      "faire",
      0.06
    ],
    [
      "former",
      0.0475
    ],
    [
      "montrer",
      0.04
    ],
    [
      "creer",
      0.0375
    ],
    [
      "composer",
      0.0325
    ],
    [
      "donner",
      0.03
    ],
    [
      "presenter",
      0.0275
    ],
    [
      "reveler",
      0.0275
    ],
    [
      "ecrire",
      0.025
    ],
    [
      "elaborer",
      0.0225
    ],
    [
      "rendre",
      0.0225
    ],
    [
      "preparer",
      0.0225
    ],
    [
      "exposer",
      0.0225
    ],
    [
      "entrainer",
      0.0225
    ],
    [
      "porter",
      0.0225
    ],
    [
      "provoquer",
      0.0225
    ],
    [
      "apporter",
      0.02
    ],
    [
      "determiner",
      0.0175
    ],
    [
      "causer",
      0.015
    ],
    [
      "engendrer",
      0.015
    ],
    [
      "rapporter",
      0.015
    ],
    [
      "travailler",
      0.015
    ],
    [
      "temoigner",
      0.015
    ],
    [
      "pousser",
      0.015
    ],
    [
      "lancer",
      0.015
    ],
    [
      "cultiver",
      0.0125
    ],
    [
      "fournir",
      0.0125
    ],
    [
      "susciter",
      0.0125
    ],
    [
      "sortir",
      0.0125
    ],
    [
      "occasionner",
      0.0125
    ],
    [
      "marquer",
      0.0125
    ],
    [
      "fabriquer",
      0.0125
    ],
    [
      "amener",
      0.0125
    ],
    [
      "emettre",
      0.01
    ],
    [
      "afficher",
      0.01
    ],
    [
      "tirer",
      0.0075
    ],
    [
      "fructifier",
      0.0075
    ],
    [
      "enfanter",
      0.0075
    ],
    [
      "alleguer",
      0.0075
    ],
    [
      "accoucher",
      0.0075
    ],
    [
      "soulever",
      0.005
    ],
    [
      "reproduire",
      0.005
    ],
    [
      "procreer",
      0.005
    ],
    [
      "introduire",
      0.005
    ],
    [
      "developper",
      0.005
    ],
    [
      "degager",
      0.005
    ],
    [
      "agir",
      0.005
    ],
    [
      "procurer",
      0.005
    ],
    [
      "obtenir",
      0.005
    ],
    [
      "frapper",
      0.005
    ],
    [
      "exhaler",
      0.005
    ],
    [
      "affirmer",
      0.005
    ],
    [
      "repondre",
      0.0025
    ],
    [
      "forger",
      0.0025
    ],
    [
      "exhiber",
      0.0025
    ],
    [
      "exercer",
      0.0025
    ],
    [
      "deposer",
      0.0025
    ],
    [
      "concevoir",
      0.0025
    ],
    [
      "elucubrer",
      0.0025
    ],
    [
      "proliferer",
      0.0025
    ],
    [
      "pisser",
      0.0025
    ],
    [
      "parrainer",
      0.0025
    ],
    [
      "invoquer",
      0.0025
    ],
    [
      "declencher",
      0.0025
    ],
    [
      "abonder",
      0.0025
    ],
    [
      "administrer",
      0.0025
    ],
    [
      "citer",
      0.0025
    ],
    [
      "confectionner",
      0.0025
    ],
    [
      "patronner",
      0.0
    ],
    [
      "manufacturer",
      0.0
    ],
    [
      "exhumer",
      0.0
    ],
    [
      "essaimer",
      0.0
    ],
    [
      "pondre",
      0.0
    ]
  ],
  "produit": [
    [
      "faire",
      0.06
    ],
    [
      "former",
      0.0475
    ],
    [
      "montrer",
      0.04
    ],
    [
      "creer",
      0.0375
    ],
    [
      "composer",
      0.0325
    ],
    [
      "donner",
      0.03
    ],
    [
      "presenter",
      0.0275
    ],
    [
      "reveler",
      0.0275
    ],
    [
      "ecrire",
      0.025
    ],
    [
      "elaborer",
      0.0225
    ],
    [
      "rendre",
      0.0225
    ],
    [
      "preparer",
      0.0225
    ],
    [
      "exposer",
      0.0225
    ],
    [
      "entrainer",
      0.0225
    ],
    [
      "porter",
      0.0225
    ],
    [
      "provoquer",
      0.0225
    ],
    [
      "apporter",
      0.02
    ],
    [
      "determiner",
      0.0175
    ],
    [
      "causer",
      0.015
    ],
    [
      "engendrer",
      0.015
    ],
    [
      "rapporter",
      0.015
    ],
    [
      "travailler",
      0.015
    ],
    [
      "temoigner",
      0.015
    ],
    [
      "pousser",
      0.015
    ],
    [
      "lancer",
      0.015
    ],
    [
      "cultiver",
      0.0125
    ],
    [
      "fournir",
      0.0125
    ],
    [
      "susciter",
      0.0125
    ],
    [
      "sortir",
      0.0125
    ],
    [
      "occasionner",
      0.0125
    ],
    [
      "marquer",
      0.0125
    ],
    [
      "fabriquer",
      0.0125
    ],
    [
      "amener",
      0.0125
    ],
    [
      "emettre",
      0.01
    ],
    [
      "afficher",
      0.01
    ],
    [
      "tirer",
      0.0075
    ],
    [
      "fructifier",
      0.0075
    ],
    [
      "enfanter",
      0.0075
    ],
    [
      "alleguer",
      0.0075
    ],
    [
      "accoucher",
      0.0075
    ],
    [
      "soulever",
      0.005
    ],
    [
      "reproduire",
      0.005
    ],
    [
      "procreer",
      0.005
    ],
    [
      "introduire",
      0.005
    ],
    [
      "developper",
      0.005
    ],
    [
      "degager",
      0.005
    ],
    [
      "agir",
      0.005
    ],
    [
      "procurer",
      0.005
    ],
    [
      "obtenir",
      0.005
    ],
    [
      "frapper",
      0.005
    ],
    [
      "exhaler",
      0.005
    ],
    [
      "affirmer",
      0.005
    ],
    [
      "repondre",
      0.0025
    ],
    [
      "forger",
      0.0025
    ],
    [
      "exhiber",
      0.0025
    ],
    [
      "exercer",
      0.0025
    ],
    [
      "deposer",
      0.0025
    ],
    [
      "concevoir",
      0.0025
    ],
    [
      "elucubrer",
      0.0025
    ],
    [
      "proliferer",
      0.0025
    ],
    [
      "pisser",
      0.0025
    ],
    [
      "parrainer",
      0.0025
    ],
    [
      "invoquer",
      0.0025
    ],
    [
      "declencher",
      0.0025
    ],
    [
      "abonder",
      0.0025
    ],
    [
      "administrer",
      0.0025
    ],
    [
      "citer",
      0.0025
    ],
    [
      "confectionner",
      0.0025
    ],
    [
      "patronner",
      0.0
    ],
    [
      "manufacturer",
      0.0
    ],
    [
      "exhumer",
      0.0
    ],
    [
      "essaimer",
      0.0
    ],
    [
      "pondre",
      0.0
    ]
  ],
  "quand": [
    [
      "si",
      0.0925
    ],
    [
      "comme",
      0.0925
    ],
    [
      "lorsque",
      0.045
    ],
    [
      "ou",
      0.045
    ]
  ],
  "acheter": [
    [
      "soudoyer",
      0.095
    ],
    [
      "corrompre",
      0.0775
    ],
    [
      "prendre",
      0.0775
    ],
    [
      "avoir",
      0.055
    ],
    [
      "offrir",
      0.055
    ],
    [
      "payer",
      0.055
    ],
    [
      "traiter",
      0.0375
    ],
    [
      "seduire",
      0.0375
    ],
    [
      "brocanter",
      0.0375
    ],
    [
      "arroser",
      0.0375
    ],
    [
      "procurer",
      0.0175
    ],
    [
      "s'offrir",
      0.0175
    ],
    [
      "stipendier",
      0.0175
    ],
    [
      "obtenir",
      0.0175
    ],
    [
      "negocier",
      0.0175
    ],
    [
      "marchander",
      0.0175
    ],
    [
      "importer",
      0.0175
    ],
    [
      "depraver",
      0.0175
    ],
    [
      "commercer",
      0.0175
    ],
    [
      "commander",
      0.0175
    ],
    [
      "chiner",
      0.0175
    ],
    [
      "acquerir",
      0.0175
    ],
    [
      "suborner",
      0.0175
    ]
  ],
  "sa": [],
  "majorite": [
    [
      "multitude",
      0.165
    ],
    [
      "generalite",
      0.11
    ],
    [
      "pluralite",
      0.11
    ],
    [
      "quorum",
      0.055
    ],
    [
      "maturite",
      0.055
    ],
    [
      "masse",
      0.055
    ],
    [
      "foule",
      0.055
    ],
    [
      "emancipation",
      0.055
    ]
  ],
  "site": [
    [
      "lieu",
      0.1175
    ],
    [
      "vue",
      0.1
    ],
    [
      "paysage",
      0.0825
    ],
    [
      "coin",
      0.0675
    ],
    [
      "emplacement",
      0.0675
    ],
    [
      "endroit",
      0.0675
    ],
    [
      "situation",
      0.05
    ],
    [
      "place",
      0.05
    ],
    [
      "panorama",
      0.05
    ],
    [
      "horizon",
      0.05
    ],
    [
      "perspective",
      0.0325
    ],
    [
      "position",
      0.0325
    ],
    [
      "tableau",
      0.0325
    ],
    [
      "theatre",
      0.015
    ],
    [
      "spectacle",
      0.015
    ],
    [
      "parages",
      0.015
    ],
    [
      "localite",
      0.015
    ],
    [
      "canton",
      0.015
    ],
    [
      "etendue",
      0.015
    ]
  ],
  "porno": [
    [
      "pornographique",
      0.285
    ],
    [
      "bas",
      0.1425
    ],
    [
      "cochon",
      0.1425
    ],
    [
      "pornographie",
      0.1425
    ],
    [
      "repugnant",
      0.1425
    ]
  ],
  "potage": [
    [
      "bouillon",
      0.235
    ],
    [
      "lavure",
      0.115
    ],
    [
      "soupe",
      0.0575
    ],
    [
      "pot",
      0.0575
    ],
    [
      "oille",
      0.0575
    ],
    [
      "minestrone",
      0.0575
    ],
    [
      "lavasse",
      0.0575
    ],
    [
      "julienne",
      0.0575
    ],
    [
      "consomme",
      0.0575
    ],
    [
      "brouet",
      0.0575
    ],
    [
      "bisque",
      0.0575
    ],
    [
      "veloute",
      0.0575
    ]
  ],
  "machine": [
    [
      "engin",
      0.1125
    ],
    [
      "appareil",
      0.095
    ],
    [
      "truc",
      0.08
    ],
    [
      "instrument",
      0.0625
    ],
    [
      "outil",
      0.0475
    ],
    [
      "mecanique",
      0.0475
    ],
    [
      "moyen",
      0.0475
    ],
    [
      "dispositif",
      0.0475
    ],
    [
      "becane",
      0.0475
    ],
    [
      "ruse",
      0.03
    ],
    [
      "robot",
      0.03
    ],
    [
      "moto",
      0.03
    ],
    [
      "moteur",
      0.03
    ],
    [
      "coucou",
      0.03
    ],
    [
      "astuce",
      0.03
    ],
    [
      "artifice",
      0.03
    ],
    [
      "piege",
      0.015
    ],
    [
      "ordinateur",
      0.015
    ],
    [
      "mecanisme",
      0.015
    ],
    [
      "machination",
      0.015
    ],
    [
      "machin",
      0.015
    ],
    [
      "locomotive",
      0.015
    ],
    [
      "catapulte",
      0.015
    ],
    [
      "bombe",
      0.015
    ],
    [
      "automobile",
      0.015
    ],
    [
      "automate",
      0.015
    ],
    [
      "treuil",
      0.015
    ]
  ],
  "cafe": [
    [
      "cabaret",
      0.2225
    ],
    [
      "buvette",
      0.0875
    ],
    [
      "bistrot",
      0.08
    ],
    [
      "bar",
      0.06
    ],
    [
      "buffet",
      0.045
    ],
    [
      "restaurant",
      0.045
    ],
    [
      "taverne",
      0.04
    ],
    [
      "brasserie",
      0.04
    ],
    [
      "estaminet",
      0.0325
    ],
    [
      "troquet",
      0.0325
    ],
    [
      "bibine",
      0.025
    ],
    [
      "caboulot",
      0.025
    ],
    [
      "gargote",
      0.025
    ],
    [
      "bousin",
      0.0175
    ],
    [
      "bouchon",
      0.0175
    ],
    [
      "cambuse",
      0.0125
    ],
    [
      "mastroquet",
      0.0125
    ],
    [
      "express",
      0.005
    ],
    [
      "filtre",
      0.005
    ],
    [
      "gloria",
      0.005
    ],
    [
      "jus",
      0.005
    ],
    [
      "lavasse",
      0.005
    ],
    [
      "noir",
      0.005
    ],
    [
      "popine",
      0.005
    ],
    [
      "pub",
      0.005
    ],
    [
      "debit",
      0.005
    ],
    [
      "creme",
      0.005
    ],
    [
      "cappuccino",
      0.005
    ],
    [
      "assommoir",
      0.005
    ],
    [
      "bistouille",
      0.005
    ],
    [
      "boisson",
      0.005
    ],
    [
      "bougnat",
      0.005
    ],
    [
      "cafeton",
      0.005
    ],
    [
      "cafeteria",
      0.005
    ],
    [
      "caoua",
      0.005
    ],
    [
      "zinc",
      0.005
    ]
  ],
  "surtout": [
    [
      "souquenille",
      0.1625
    ],
    [
      "blouse",
      0.0925
    ],
    [
      "particulierement",
      0.0925
    ],
    [
      "principalement",
      0.07
    ],
    [
      "specialement",
      0.045
    ],
    [
      "notamment",
      0.045
    ],
    [
      "cotte",
      0.045
    ],
    [
      "casaque",
      0.045
    ],
    [
      "bleu",
      0.045
    ],
    [
      "tablier",
      0.0225
    ],
    [
      "sur",
      0.0225
    ],
    [
      "singulierement",
      0.0225
    ],
    [
      "sarrau",
      0.0225
    ],
    [
      "plus",
      0.0225
    ],
    [
      "charrette",
      0.0225
    ],
    [
      "caban",
      0.0225
    ],
    [
      "eminemment",
      0.0225
    ]
  ],
  "chanteur": [
    [
      "musicien",
      0.1125
    ],
    [
      "poete",
      0.1125
    ],
    [
      "artiste",
      0.0625
    ],
    [
      "barde",
      0.0625
    ],
    [
      "troubadour",
      0.0625
    ],
    [
      "choriste",
      0.0475
    ],
    [
      "trouvere",
      0.0475
    ],
    [
      "virtuose",
      0.03
    ],
    [
      "interprete",
      0.03
    ],
    [
      "executant",
      0.03
    ],
    [
      "chantre",
      0.03
    ],
    [
      "acteur",
      0.03
    ],
    [
      "minnesinger",
      0.015
    ],
    [
      "menestrel",
      0.015
    ],
    [
      "rhapsode",
      0.015
    ],
    [
      "scalde",
      0.015
    ],
    [
      "soliste",
      0.015
    ],
    [
      "tenor",
      0.015
    ],
    [
      "vedette",
      0.015
    ],
    [
      "vocaliste",
      0.015
    ],
    [
      "duettiste",
      0.015
    ],
    [
      "diva",
      0.015
    ],
    [
      "aede",
      0.015
    ],
    [
      "cantatrice",
      0.015
    ],
    [
      "castrat",
      0.015
    ],
    [
      "chansonnier",
      0.015
    ],
    [
      "choreute",
      0.015
    ],
    [
      "citharede",
      0.015
    ],
    [
      "coryphee",
      0.015
    ],
    [
      "crooner",
      0.015
    ],
    [
      "voix",
      0.015
    ]
  ],
  "voix": [
    [
      "ton",
      0.09
    ],
    [
      "cri",
      0.055
    ],
    [
      "parole",
      0.055
    ],
    [
      "son",
      0.055
    ],
    [
      "suffrage",
      0.0425
    ],
    [
      "hurlement",
      0.0425
    ],
    [
      "bruit",
      0.0425
    ],
    [
      "avis",
      0.0425
    ],
    [
      "approbation",
      0.0425
    ],
    [
      "phonation",
      0.0325
    ],
    [
      "bramement",
      0.0325
    ],
    [
      "appel",
      0.0325
    ],
    [
      "vote",
      0.02
    ],
    [
      "suggestion",
      0.02
    ],
    [
      "pensee",
      0.02
    ],
    [
      "intonation",
      0.02
    ],
    [
      "inflexion",
      0.02
    ],
    [
      "impulsion",
      0.02
    ],
    [
      "grondement",
      0.02
    ],
    [
      "conseil",
      0.02
    ],
    [
      "chant",
      0.02
    ],
    [
      "avertissement",
      0.02
    ],
    [
      "assentiment",
      0.02
    ],
    [
      "accord",
      0.02
    ],
    [
      "accent",
      0.02
    ],
    [
      "inspiration",
      0.01
    ],
    [
      "jugement",
      0.01
    ],
    [
      "opinion",
      0.01
    ],
    [
      "plainte",
      0.01
    ],
    [
      "referendum",
      0.01
    ],
    [
      "hallucination",
      0.01
    ],
    [
      "gosier",
      0.01
    ],
    [
      "expression",
      0.01
    ],
    [
      "chanteuse",
      0.01
    ],
    [
      "chanteur",
      0.01
    ],
    [
      "articulation",
      0.01
    ],
    [
      "aboiement",
      0.01
    ],
    [
      "timbre",
      0.01
    ]
  ],
  "posseder": [
    [
      "avoir",
      0.115
    ],
    [
      "rouler",
      0.09
    ],
    [
      "tromper",
      0.075
    ],
    [
      "tenir",
      0.065
    ],
    [
      "prendre",
      0.0475
    ],
    [
      "contenir",
      0.04
    ],
    [
      "abuser",
      0.0325
    ],
    [
      "disposer",
      0.0325
    ],
    [
      "penetrer",
      0.0225
    ],
    [
      "detenir",
      0.0225
    ],
    [
      "connaitre",
      0.0225
    ],
    [
      "compter",
      0.0225
    ],
    [
      "baiser",
      0.0225
    ],
    [
      "jouir",
      0.015
    ],
    [
      "maitriser",
      0.015
    ],
    [
      "pigeonner",
      0.015
    ],
    [
      "porter",
      0.015
    ],
    [
      "ramoner",
      0.015
    ],
    [
      "renfermer",
      0.015
    ],
    [
      "rester",
      0.015
    ],
    [
      "habiter",
      0.015
    ],
    [
      "flouer",
      0.015
    ],
    [
      "absorber",
      0.015
    ],
    [
      "dominer",
      0.015
    ],
    [
      "empaumer",
      0.015
    ],
    [
      "empiler",
      0.015
    ],
    [
      "enfiler",
      0.015
    ],
    [
      "entendre",
      0.015
    ],
    [
      "entuber",
      0.015
    ],
    [
      "tringler",
      0.0075
    ],
    [
      "savoir",
      0.0075
    ],
    [
      "piner",
      0.0075
    ],
    [
      "obseder",
      0.0075
    ],
    [
      "niquer",
      0.0075
    ],
    [
      "hanter",
      0.0075
    ],
    [
      "gruger",
      0.0075
    ],
    [
      "feinter",
      0.0075
    ],
    [
      "carotter",
      0.0075
    ],
    [
      "beneficier",
      0.0075
    ],
    [
      "bourrer",
      0.0075
    ],
    [
      "accaparer",
      0.0075
    ]
  ],
  "possede": [
    [
      "avoir",
      0.115
    ],
    [
      "rouler",
      0.09
    ],
    [
      "tromper",
      0.075
    ],
    [
      "tenir",
      0.065
    ],
    [
      "prendre",
      0.0475
    ],
    [
      "contenir",
      0.04
    ],
    [
      "abuser",
      0.0325
    ],
    [
      "disposer",
      0.0325
    ],
    [
      "penetrer",
      0.0225
    ],
    [
      "detenir",
      0.0225
    ],
    [
      "connaitre",
      0.0225
    ],
    [
      "compter",
      0.0225
    ],
    [
      "baiser",
      0.0225
    ],
    [
      "jouir",
      0.015
    ],
    [
      "maitriser",
      0.015
    ],
    [
      "pigeonner",
      0.015
    ],
    [
      "porter",
      0.015
    ],
    [
      "ramoner",
      0.015
    ],
    [
      "renfermer",
      0.015
    ],
    [
      "rester",
      0.015
    ],
    [
      "habiter",
      0.015
    ],
    [
      "flouer",
      0.015
    ],
    [
      "absorber",
      0.015
    ],
    [
      "dominer",
      0.015
    ],
    [
      "empaumer",
      0.015
    ],
    [
      "empiler",
      0.015
    ],
    [
      "enfiler",
      0.015
    ],
    [
      "entendre",
      0.015
    ],
    [
      "entuber",
      0.015
    ],
    [
      "tringler",
      0.0075
    ],
    [
      "savoir",
      0.0075
    ],
    [
      "piner",
      0.0075
    ],
    [
      "obseder",
      0.0075
    ],
    [
      "niquer",
      0.0075
    ],
    [
      "hanter",
      0.0075
    ],
    [
      "gruger",
      0.0075
    ],
    [
      "feinter",
      0.0075
    ],
    [
      "carotter",
      0.0075
    ],
    [
      "beneficier",
      0.0075
    ],
    [
      "bourrer",
      0.0075
    ],
    [
      "accaparer",
      0.0075
    ]
  ],
  "chanson": [
    [
      "baliverne",
      0.075
    ],
    [
      "chant",
      0.065
    ],
    [
      "sornette",
      0.0525
    ],
    [
      "fadaise",
      0.0475
    ],
    [
      "calembredaine",
      0.0425
    ],
    [
      "conte",
      0.0375
    ],
    [
      "musique",
      0.035
    ],
    [
      "refrain",
      0.035
    ],
    [
      "poeme",
      0.03
    ],
    [
      "histoire",
      0.03
    ],
    [
      "bruit",
      0.025
    ],
    [
      "faribole",
      0.025
    ],
    [
      "propos",
      0.025
    ],
    [
      "sottise",
      0.02
    ],
    [
      "romance",
      0.02
    ],
    [
      "rengaine",
      0.02
    ],
    [
      "melodie",
      0.02
    ],
    [
      "betise",
      0.02
    ],
    [
      "bagatelle",
      0.02
    ],
    [
      "bateau",
      0.0175
    ],
    [
      "bourde",
      0.0175
    ],
    [
      "gazouillis",
      0.0175
    ],
    [
      "murmure",
      0.0175
    ],
    [
      "roman",
      0.0125
    ],
    [
      "comedie",
      0.0125
    ],
    [
      "billevesee",
      0.0125
    ],
    [
      "babil",
      0.0125
    ],
    [
      "antienne",
      0.0125
    ],
    [
      "epopee",
      0.0075
    ],
    [
      "scie",
      0.0075
    ],
    [
      "ritournelle",
      0.0075
    ],
    [
      "ramage",
      0.0075
    ],
    [
      "lied",
      0.0075
    ],
    [
      "lanterne",
      0.0075
    ],
    [
      "couplet",
      0.0075
    ],
    [
      "coquecigrue",
      0.0075
    ],
    [
      "air",
      0.0075
    ],
    [
      "babiole",
      0.0075
    ],
    [
      "ballade",
      0.0075
    ],
    [
      "barcarolle",
      0.0075
    ],
    [
      "bricole",
      0.0075
    ],
    [
      "frivolite",
      0.0025
    ],
    [
      "fumisterie",
      0.0025
    ],
    [
      "futilite",
      0.0025
    ],
    [
      "guitare",
      0.0025
    ],
    [
      "radotage",
      0.0025
    ],
    [
      "ronde",
      0.0025
    ],
    [
      "roucoulement",
      0.0025
    ],
    [
      "vaudeville",
      0.0025
    ],
    [
      "flonflon",
      0.0025
    ],
    [
      "comptine",
      0.0025
    ],
    [
      "berceuse",
      0.0025
    ],
    [
      "bergerette",
      0.0025
    ],
    [
      "beuglante",
      0.0025
    ],
    [
      "brunette",
      0.0025
    ],
    [
      "cantilene",
      0.0025
    ],
    [
      "canzone",
      0.0025
    ],
    [
      "canzonette",
      0.0025
    ],
    [
      "cavatine",
      0.0025
    ],
    [
      "complainte",
      0.0025
    ],
    [
      "villanelle",
      0.0025
    ]
  ],
  "crustace": [],
  "as": [
    [
      "aigle",
      0.0875
    ],
    [
      "champion",
      0.0875
    ],
    [
      "chef",
      0.0875
    ],
    [
      "virtuose",
      0.0575
    ],
    [
      "phenix",
      0.0575
    ],
    [
      "maitre",
      0.0575
    ],
    [
      "genie",
      0.0575
    ],
    [
      "crack",
      0.0575
    ],
    [
      "carte",
      0.0575
    ],
    [
      "un",
      0.0275
    ],
    [
      "tresor",
      0.0275
    ],
    [
      "spadille",
      0.0275
    ],
    [
      "poids",
      0.0275
    ],
    [
      "manillon",
      0.0275
    ],
    [
      "caid",
      0.0275
    ],
    [
      "cacique",
      0.0275
    ],
    [
      "brisque",
      0.0275
    ],
    [
      "bezet",
      0.0275
    ],
    [
      "besas",
      0.0275
    ],
    [
      "baste",
      0.0275
    ],
    [
      "ambesas",
      0.0275
    ],
    [
      "etoile",
      0.0275
    ]
  ],
  "compris": [
    [
      "saisir",
      0.075
    ],
    [
      "voir",
      0.0675
    ],
    [
      "decouvrir",
      0.065
    ],
    [
      "penetrer",
      0.06
    ],
    [
      "apercevoir",
      0.0525
    ],
    [
      "entendre",
      0.0425
    ],
    [
      "connaitre",
      0.0425
    ],
    [
      "embrasser",
      0.0325
    ],
    [
      "reperer",
      0.0325
    ],
    [
      "deviner",
      0.03
    ],
    [
      "concevoir",
      0.03
    ],
    [
      "prendre",
      0.025
    ],
    [
      "trouver",
      0.0225
    ],
    [
      "apprehender",
      0.02
    ],
    [
      "dechiffrer",
      0.02
    ],
    [
      "inclure",
      0.02
    ],
    [
      "sentir",
      0.02
    ],
    [
      "contenir",
      0.0175
    ],
    [
      "remarquer",
      0.015
    ],
    [
      "comporter",
      0.015
    ],
    [
      "admettre",
      0.0125
    ],
    [
      "apprendre",
      0.0125
    ],
    [
      "apprecier",
      0.0125
    ],
    [
      "englober",
      0.0125
    ],
    [
      "imaginer",
      0.0125
    ],
    [
      "percer",
      0.0125
    ],
    [
      "reveler",
      0.0125
    ],
    [
      "renfermer",
      0.01
    ],
    [
      "interpreter",
      0.01
    ],
    [
      "assimiler",
      0.01
    ],
    [
      "suivre",
      0.005
    ],
    [
      "savoir",
      0.005
    ],
    [
      "s'apercevoir",
      0.005
    ],
    [
      "mordre",
      0.005
    ],
    [
      "integrer",
      0.005
    ],
    [
      "incorporer",
      0.005
    ],
    [
      "compter",
      0.005
    ],
    [
      "enfermer",
      0.005
    ],
    [
      "entrer",
      0.005
    ],
    [
      "entrevoir",
      0.005
    ],
    [
      "impliquer",
      0.005
    ],
    [
      "traduire",
      0.0025
    ],
    [
      "realiser",
      0.0025
    ],
    [
      "piger",
      0.0025
    ],
    [
      "meler",
      0.0025
    ],
    [
      "envelopper",
      0.0025
    ],
    [
      "enclore",
      0.0025
    ],
    [
      "approuver",
      0.0025
    ],
    [
      "s'expliquer",
      0.0
    ],
    [
      "melanger",
      0.0
    ],
    [
      "grouper",
      0.0
    ],
    [
      "demeler",
      0.0
    ],
    [
      "decoder",
      0.0
    ],
    [
      "consister",
      0.0
    ]
  ],
  "concept": [
    [
      "idee",
      0.23
    ],
    [
      "abstraction",
      0.1525
    ],
    [
      "categorie",
      0.1525
    ],
    [
      "notion",
      0.1525
    ],
    [
      "conception",
      0.075
    ],
    [
      "genre",
      0.075
    ],
    [
      "objet",
      0.075
    ],
    [
      "pensee",
      0.075
    ]
  ],
  "avec": [
    [
      "par",
      0.115
    ],
    [
      "de",
      0.0825
    ],
    [
      "en",
      0.0825
    ],
    [
      "sur",
      0.0825
    ],
    [
      "a",
      0.0475
    ],
    [
      "parmi",
      0.0475
    ],
    [
      "dans",
      0.0475
    ],
    [
      "comme",
      0.0475
    ],
    [
      "envers",
      0.0325
    ],
    [
      "entre",
      0.0325
    ],
    [
      "simultanement",
      0.015
    ],
    [
      "moyennant",
      0.015
    ],
    [
      "malgre",
      0.015
    ],
    [
      "et",
      0.015
    ],
    [
      "aupres",
      0.015
    ],
    [
      "apparente",
      0.015
    ]
  ],
  "li": [],
  "lu": [
    [
      "dechiffrer",
      0.1175
    ],
    [
      "decouvrir",
      0.1
    ],
    [
      "reperer",
      0.0825
    ],
    [
      "penetrer",
      0.0675
    ],
    [
      "voir",
      0.05
    ],
    [
      "expliquer",
      0.05
    ],
    [
      "dire",
      0.05
    ],
    [
      "deviner",
      0.05
    ],
    [
      "epeler",
      0.0325
    ],
    [
      "percer",
      0.0325
    ],
    [
      "interpreter",
      0.0325
    ],
    [
      "feuilleter",
      0.0325
    ],
    [
      "discerner",
      0.0325
    ],
    [
      "consulter",
      0.0325
    ],
    [
      "survoler",
      0.015
    ],
    [
      "reciter",
      0.015
    ],
    [
      "prononcer",
      0.015
    ],
    [
      "parcourir",
      0.015
    ],
    [
      "frequenter",
      0.015
    ],
    [
      "devorer",
      0.015
    ],
    [
      "depouiller",
      0.015
    ],
    [
      "decrypter",
      0.015
    ],
    [
      "decoder",
      0.015
    ],
    [
      "debrouiller",
      0.015
    ],
    [
      "compulser",
      0.015
    ],
    [
      "bouquiner",
      0.015
    ],
    [
      "anonner",
      0.015
    ]
  ],
  "lire": [
    [
      "dechiffrer",
      0.1175
    ],
    [
      "decouvrir",
      0.1
    ],
    [
      "reperer",
      0.0825
    ],
    [
      "penetrer",
      0.0675
    ],
    [
      "voir",
      0.05
    ],
    [
      "expliquer",
      0.05
    ],
    [
      "dire",
      0.05
    ],
    [
      "deviner",
      0.05
    ],
    [
      "epeler",
      0.0325
    ],
    [
      "percer",
      0.0325
    ],
    [
      "interpreter",
      0.0325
    ],
    [
      "feuilleter",
      0.0325
    ],
    [
      "discerner",
      0.0325
    ],
    [
      "consulter",
      0.0325
    ],
    [
      "survoler",
      0.015
    ],
    [
      "reciter",
      0.015
    ],
    [
      "prononcer",
      0.015
    ],
    [
      "parcourir",
      0.015
    ],
    [
      "frequenter",
      0.015
    ],
    [
      "devorer",
      0.015
    ],
    [
      "depouiller",
      0.015
    ],
    [
      "decrypter",
      0.015
    ],
    [
      "decoder",
      0.015
    ],
    [
      "debrouiller",
      0.015
    ],
    [
      "compulser",
      0.015
    ],
    [
      "bouquiner",
      0.015
    ],
    [
      "anonner",
      0.015
    ]
  ],
  "ils": [],
  "capter": [
    [
      "attraper",
      0.08
    ],
    [
      "gagner",
      0.075
    ],
    [
      "seduire",
      0.0625
    ],
    [
      "conquerir",
      0.0575
    ],
    [
      "enjoler",
      0.0575
    ],
    [
      "tromper",
      0.0575
    ],
    [
      "abuser",
      0.0475
    ],
    [
      "attirer",
      0.035
    ],
    [
      "obtenir",
      0.035
    ],
    [
      "s'emparer",
      0.03
    ],
    [
      "remporter",
      0.025
    ],
    [
      "embobiner",
      0.025
    ],
    [
      "embabouiner",
      0.025
    ],
    [
      "capturer",
      0.025
    ],
    [
      "captiver",
      0.025
    ],
    [
      "accrocher",
      0.02
    ],
    [
      "circonvenir",
      0.02
    ],
    [
      "leurrer",
      0.02
    ],
    [
      "ramasser",
      0.02
    ],
    [
      "surprendre",
      0.02
    ],
    [
      "soutirer",
      0.015
    ],
    [
      "retenir",
      0.015
    ],
    [
      "recueillir",
      0.015
    ],
    [
      "duper",
      0.015
    ],
    [
      "acquerir",
      0.015
    ],
    [
      "vaincre",
      0.01
    ],
    [
      "s'approprier",
      0.01
    ],
    [
      "reunir",
      0.01
    ],
    [
      "rassembler",
      0.01
    ],
    [
      "intercepter",
      0.01
    ],
    [
      "extorquer",
      0.01
    ],
    [
      "embobeliner",
      0.01
    ],
    [
      "conduire",
      0.01
    ],
    [
      "charmer",
      0.01
    ],
    [
      "canaliser",
      0.01
    ],
    [
      "prelever",
      0.005
    ],
    [
      "pomper",
      0.005
    ],
    [
      "fourvoyer",
      0.005
    ],
    [
      "accaparer",
      0.005
    ]
  ],
  "entendre": [
    [
      "voir",
      0.105
    ],
    [
      "connaitre",
      0.1
    ],
    [
      "comprendre",
      0.0825
    ],
    [
      "percevoir",
      0.0775
    ],
    [
      "penetrer",
      0.0675
    ],
    [
      "saisir",
      0.0675
    ],
    [
      "concevoir",
      0.0575
    ],
    [
      "discerner",
      0.0475
    ],
    [
      "sentir",
      0.04
    ],
    [
      "apprehender",
      0.04
    ],
    [
      "apprecier",
      0.04
    ],
    [
      "juger",
      0.025
    ],
    [
      "distinguer",
      0.02
    ],
    [
      "ecouter",
      0.015
    ],
    [
      "realiser",
      0.015
    ],
    [
      "reconnaitre",
      0.015
    ],
    [
      "pratiquer",
      0.015
    ],
    [
      "admettre",
      0.015
    ],
    [
      "posseder",
      0.01
    ],
    [
      "embrasser",
      0.01
    ],
    [
      "compter",
      0.01
    ],
    [
      "exiger",
      0.0025
    ],
    [
      "gouter",
      0.0025
    ],
    [
      "interpreter",
      0.0025
    ],
    [
      "ouir",
      0.0025
    ],
    [
      "preferer",
      0.0025
    ],
    [
      "pretendre",
      0.0025
    ],
    [
      "satisfaire",
      0.0025
    ],
    [
      "souhaiter",
      0.0025
    ],
    [
      "exaucer",
      0.0025
    ],
    [
      "desirer",
      0.0025
    ],
    [
      "assister",
      0.0025
    ],
    [
      "attraper",
      0.0025
    ],
    [
      "auditionner",
      0.0025
    ],
    [
      "confesser",
      0.0025
    ],
    [
      "consentir",
      0.0025
    ],
    [
      "cultiver",
      0.0025
    ],
    [
      "vouloir",
      0.0025
    ]
  ],
  "preluder": [
    [
      "annoncer",
      0.23
    ],
    [
      "presager",
      0.155
    ],
    [
      "s'exercer",
      0.075
    ],
    [
      "preparer",
      0.075
    ],
    [
      "prefigurer",
      0.075
    ],
    [
      "preceder",
      0.075
    ],
    [
      "improviser",
      0.075
    ],
    [
      "essayer",
      0.075
    ],
    [
      "commencer",
      0.075
    ]
  ],
  "prelude": [
    [
      "introduction",
      0.1125
    ],
    [
      "preambule",
      0.1125
    ],
    [
      "preface",
      0.1125
    ],
    [
      "presage",
      0.0675
    ],
    [
      "preliminaires",
      0.0675
    ],
    [
      "prefiguration",
      0.0675
    ],
    [
      "prodrome",
      0.0675
    ],
    [
      "preparation",
      0.045
    ],
    [
      "prologue",
      0.045
    ],
    [
      "exorde",
      0.045
    ],
    [
      "commencement",
      0.045
    ],
    [
      "annonce",
      0.0225
    ],
    [
      "appret",
      0.0225
    ],
    [
      "exposition",
      0.0225
    ],
    [
      "lever",
      0.0225
    ],
    [
      "ouverture",
      0.0225
    ]
  ],
  "ma": [],
  "raison": [
    [
      "esprit",
      0.075
    ],
    [
      "intelligence",
      0.055
    ],
    [
      "sens",
      0.05
    ],
    [
      "entendement",
      0.0425
    ],
    [
      "motif",
      0.0425
    ],
    [
      "jugement",
      0.04
    ],
    [
      "cause",
      0.04
    ],
    [
      "lucidite",
      0.025
    ],
    [
      "sagesse",
      0.025
    ],
    [
      "tact",
      0.025
    ],
    [
      "tete",
      0.02
    ],
    [
      "pretexte",
      0.02
    ],
    [
      "pensee",
      0.02
    ],
    [
      "logique",
      0.02
    ],
    [
      "connaissance",
      0.02
    ],
    [
      "comprehension",
      0.02
    ],
    [
      "discernement",
      0.0175
    ],
    [
      "fondement",
      0.0175
    ],
    [
      "principe",
      0.0175
    ],
    [
      "sujet",
      0.0175
    ],
    [
      "raisonnement",
      0.0125
    ],
    [
      "philosophie",
      0.0125
    ],
    [
      "excuse",
      0.0125
    ],
    [
      "argument",
      0.0125
    ],
    [
      "reparation",
      0.01
    ],
    [
      "origine",
      0.01
    ],
    [
      "moderation",
      0.01
    ],
    [
      "mobile",
      0.01
    ],
    [
      "justification",
      0.01
    ],
    [
      "jugeote",
      0.01
    ],
    [
      "intellect",
      0.01
    ],
    [
      "explication",
      0.01
    ],
    [
      "demonstration",
      0.01
    ],
    [
      "cerveau",
      0.01
    ],
    [
      "rapport",
      0.005
    ],
    [
      "ponderation",
      0.005
    ],
    [
      "occasion",
      0.005
    ],
    [
      "lumiere",
      0.005
    ],
    [
      "lieu",
      0.005
    ],
    [
      "justesse",
      0.005
    ],
    [
      "consideration",
      0.005
    ],
    [
      "but",
      0.005
    ],
    [
      "methode",
      0.0025
    ],
    [
      "pourquoi",
      0.0025
    ],
    [
      "probabilite",
      0.0025
    ],
    [
      "quoi",
      0.0025
    ],
    [
      "rationnel",
      0.0025
    ],
    [
      "rectitude",
      0.0025
    ],
    [
      "refutation",
      0.0025
    ],
    [
      "satisfaction",
      0.0025
    ],
    [
      "judiciaire",
      0.0025
    ],
    [
      "indice",
      0.0025
    ],
    [
      "allegation",
      0.0025
    ],
    [
      "base",
      0.0025
    ],
    [
      "considerant",
      0.0025
    ],
    [
      "couleur",
      0.0025
    ],
    [
      "dedommagement",
      0.0025
    ],
    [
      "facultes",
      0.0025
    ],
    [
      "gout",
      0.0025
    ],
    [
      "titre",
      0.0025
    ]
  ],
  "envoler": [],
  "port": [
    [
      "allure",
      0.085
    ],
    [
      "air",
      0.065
    ],
    [
      "demarche",
      0.06
    ],
    [
      "maintien",
      0.06
    ],
    [
      "tournure",
      0.045
    ],
    [
      "abri",
      0.04
    ],
    [
      "touche",
      0.025
    ],
    [
      "silhouette",
      0.025
    ],
    [
      "quai",
      0.025
    ],
    [
      "passage",
      0.025
    ],
    [
      "defile",
      0.025
    ],
    [
      "bassin",
      0.025
    ],
    [
      "aspect",
      0.025
    ],
    [
      "transport",
      0.02
    ],
    [
      "tenue",
      0.02
    ],
    [
      "taille",
      0.02
    ],
    [
      "retraite",
      0.02
    ],
    [
      "prestance",
      0.02
    ],
    [
      "havre",
      0.02
    ],
    [
      "degaine",
      0.02
    ],
    [
      "contenance",
      0.02
    ],
    [
      "attitude",
      0.02
    ],
    [
      "ligne",
      0.0125
    ],
    [
      "maniere",
      0.0125
    ],
    [
      "pas",
      0.0125
    ],
    [
      "portage",
      0.0125
    ],
    [
      "relache",
      0.0125
    ],
    [
      "taxe",
      0.0125
    ],
    [
      "golfe",
      0.0125
    ],
    [
      "embarcadere",
      0.0125
    ],
    [
      "asile",
      0.0125
    ],
    [
      "breche",
      0.0125
    ],
    [
      "cale",
      0.0125
    ],
    [
      "cluse",
      0.0125
    ],
    [
      "col",
      0.0125
    ],
    [
      "dock",
      0.0125
    ],
    [
      "passe",
      0.005
    ],
    [
      "portement",
      0.005
    ],
    [
      "rade",
      0.005
    ],
    [
      "refuge",
      0.005
    ],
    [
      "representation",
      0.005
    ],
    [
      "stature",
      0.005
    ],
    [
      "oasis",
      0.005
    ],
    [
      "hivernage",
      0.005
    ],
    [
      "escale",
      0.005
    ],
    [
      "debarcadere",
      0.005
    ],
    [
      "darse",
      0.005
    ],
    [
      "but",
      0.005
    ],
    [
      "anse",
      0.005
    ],
    [
      "affranchissement",
      0.005
    ],
    [
      "wharf",
      0.005
    ]
  ],
  "baraque": [
    [
      "cabane",
      0.1675
    ],
    [
      "bicoque",
      0.1225
    ],
    [
      "maison",
      0.1
    ],
    [
      "abri",
      0.0775
    ],
    [
      "habitation",
      0.0775
    ],
    [
      "hutte",
      0.055
    ],
    [
      "gourbi",
      0.055
    ],
    [
      "cahute",
      0.055
    ],
    [
      "loge",
      0.045
    ],
    [
      "case",
      0.0325
    ],
    [
      "boutique",
      0.0325
    ],
    [
      "poulailler",
      0.0225
    ],
    [
      "masure",
      0.0225
    ],
    [
      "hangar",
      0.0225
    ],
    [
      "cambuse",
      0.0225
    ],
    [
      "boite",
      0.0225
    ],
    [
      "appentis",
      0.0225
    ],
    [
      "baraquement",
      0.01
    ],
    [
      "cassine",
      0.01
    ],
    [
      "echoppe",
      0.01
    ]
  ],
  "cargo": [
    [
      "bateau",
      0.3325
    ],
    [
      "caboteur",
      0.3325
    ],
    [
      "tramp",
      0.3325
    ]
  ],
  "lourd": [
    [
      "pesant",
      0.065
    ],
    [
      "epais",
      0.0575
    ],
    [
      "balourd",
      0.045
    ],
    [
      "grossier",
      0.0425
    ],
    [
      "lourdaud",
      0.0375
    ],
    [
      "gros",
      0.0325
    ],
    [
      "bete",
      0.0325
    ],
    [
      "penible",
      0.03
    ],
    [
      "fort",
      0.0275
    ],
    [
      "massif",
      0.025
    ],
    [
      "stupide",
      0.0225
    ],
    [
      "beotien",
      0.02
    ],
    [
      "dur",
      0.02
    ],
    [
      "fruste",
      0.0175
    ],
    [
      "obtus",
      0.0175
    ],
    [
      "tendu",
      0.015
    ],
    [
      "lent",
      0.015
    ],
    [
      "gauche",
      0.015
    ],
    [
      "dense",
      0.015
    ],
    [
      "rude",
      0.0125
    ],
    [
      "plein",
      0.0125
    ],
    [
      "difficile",
      0.0125
    ],
    [
      "brut",
      0.0125
    ],
    [
      "accablant",
      0.0125
    ],
    [
      "trapu",
      0.01
    ],
    [
      "maladroit",
      0.01
    ],
    [
      "important",
      0.01
    ],
    [
      "grave",
      0.01
    ],
    [
      "violent",
      0.0075
    ],
    [
      "rustique",
      0.0075
    ],
    [
      "niais",
      0.0075
    ],
    [
      "mastoc",
      0.0075
    ],
    [
      "inintelligent",
      0.0075
    ],
    [
      "engourdi",
      0.0075
    ],
    [
      "empote",
      0.0075
    ],
    [
      "douloureux",
      0.0075
    ],
    [
      "ecrasant",
      0.0075
    ],
    [
      "sot",
      0.0075
    ],
    [
      "ramasse",
      0.0075
    ],
    [
      "penetre",
      0.0075
    ],
    [
      "laborieux",
      0.0075
    ],
    [
      "indigeste",
      0.0075
    ],
    [
      "gourd",
      0.0075
    ],
    [
      "embarrasse",
      0.0075
    ],
    [
      "confus",
      0.0075
    ],
    [
      "charge",
      0.0075
    ],
    [
      "bouche",
      0.0075
    ],
    [
      "rustaud",
      0.005
    ],
    [
      "rustre",
      0.005
    ],
    [
      "sature",
      0.005
    ],
    [
      "surcharge",
      0.005
    ],
    [
      "etouffant",
      0.005
    ],
    [
      "rempli",
      0.005
    ],
    [
      "poignant",
      0.005
    ],
    [
      "pataud",
      0.005
    ],
    [
      "oppressant",
      0.005
    ],
    [
      "endormi",
      0.005
    ],
    [
      "court",
      0.005
    ],
    [
      "alourdissant",
      0.005
    ],
    [
      "onereux",
      0.0025
    ],
    [
      "opaque",
      0.0025
    ],
    [
      "ordinaire",
      0.0025
    ],
    [
      "somnolent",
      0.0025
    ],
    [
      "tarabiscote",
      0.0025
    ],
    [
      "tasse",
      0.0025
    ],
    [
      "apre",
      0.0025
    ],
    [
      "materiel",
      0.0025
    ],
    [
      "marque",
      0.0025
    ],
    [
      "appesanti",
      0.0025
    ],
    [
      "compact",
      0.0025
    ],
    [
      "corpulent",
      0.0025
    ],
    [
      "embarrassant",
      0.0025
    ],
    [
      "impregne",
      0.0025
    ],
    [
      "informe",
      0.0025
    ],
    [
      "malhabile",
      0.0025
    ],
    [
      "rococo",
      0.0
    ],
    [
      "pondereux",
      0.0
    ],
    [
      "perclus",
      0.0
    ],
    [
      "irrespirable",
      0.0
    ],
    [
      "inelegant",
      0.0
    ],
    [
      "gaffeur",
      0.0
    ],
    [
      "exorbitant",
      0.0
    ],
    [
      "crasse",
      0.0
    ],
    [
      "considerable",
      0.0
    ],
    [
      "bovin",
      0.0
    ],
    [
      "bourgeois",
      0.0
    ],
    [
      "beaucoup",
      0.0
    ],
    [
      "ruineux",
      0.0
    ]
  ],
  "rafistoler": [
    [
      "retaper",
      0.15
    ],
    [
      "reparer",
      0.15
    ],
    [
      "raccommoder",
      0.12
    ],
    [
      "rapetasser",
      0.12
    ],
    [
      "rapiecer",
      0.12
    ],
    [
      "ravauder",
      0.09
    ],
    [
      "repriser",
      0.06
    ],
    [
      "rabibocher",
      0.06
    ],
    [
      "colmater",
      0.03
    ],
    [
      "radouber",
      0.03
    ],
    [
      "rapieceter",
      0.03
    ],
    [
      "replatrer",
      0.03
    ]
  ],
  "torchere": [
    [
      "chandelier",
      0.28
    ],
    [
      "flambeau",
      0.16
    ],
    [
      "torche",
      0.1175
    ],
    [
      "candelabre",
      0.0775
    ],
    [
      "oupille",
      0.0375
    ],
    [
      "martinet",
      0.0375
    ],
    [
      "luminaire",
      0.0375
    ],
    [
      "lampadaire",
      0.0375
    ],
    [
      "girandole",
      0.0375
    ],
    [
      "bras",
      0.0375
    ],
    [
      "bougeoir",
      0.0375
    ],
    [
      "applique",
      0.0375
    ],
    [
      "torchage",
      0.0375
    ]
  ],
  "grue": [
    [
      "caille",
      0.11
    ],
    [
      "chevre",
      0.11
    ],
    [
      "crone",
      0.11
    ],
    [
      "demoiselle",
      0.11
    ],
    [
      "derrick",
      0.11
    ],
    [
      "prostituee",
      0.11
    ],
    [
      "putain",
      0.11
    ],
    [
      "sapine",
      0.11
    ],
    [
      "trompette",
      0.11
    ]
  ],
  "citerne": [
    [
      "camion",
      0.1425
    ],
    [
      "cavite",
      0.1425
    ],
    [
      "cuve",
      0.1425
    ],
    [
      "puits",
      0.1425
    ],
    [
      "reservoir",
      0.1425
    ],
    [
      "tank",
      0.1425
    ],
    [
      "wagon",
      0.1425
    ]
  ],
  "gasoil": [],
  "courir": [
    [
      "filer",
      0.0525
    ],
    [
      "aller",
      0.05
    ],
    [
      "poursuivre",
      0.045
    ],
    [
      "voler",
      0.035
    ],
    [
      "passer",
      0.035
    ],
    [
      "fuir",
      0.035
    ],
    [
      "couler",
      0.0325
    ],
    [
      "foncer",
      0.0325
    ],
    [
      "s'enfuir",
      0.0325
    ],
    [
      "detaler",
      0.0225
    ],
    [
      "circuler",
      0.0225
    ],
    [
      "chercher",
      0.0175
    ],
    [
      "s'envoler",
      0.0125
    ],
    [
      "s'empresser",
      0.0125
    ],
    [
      "s'agiter",
      0.0125
    ],
    [
      "chasser",
      0.0125
    ],
    [
      "affluer",
      0.0125
    ],
    [
      "traverser",
      0.01
    ],
    [
      "tendre",
      0.01
    ],
    [
      "s'elancer",
      0.01
    ],
    [
      "s'ecouler",
      0.01
    ],
    [
      "presser",
      0.01
    ],
    [
      "pourchasser",
      0.01
    ],
    [
      "hanter",
      0.01
    ],
    [
      "galoper",
      0.01
    ],
    [
      "errer",
      0.01
    ],
    [
      "bondir",
      0.01
    ],
    [
      "sillonner",
      0.0075
    ],
    [
      "talonner",
      0.0075
    ],
    [
      "tracer",
      0.0075
    ],
    [
      "visiter",
      0.0075
    ],
    [
      "voyager",
      0.0075
    ],
    [
      "parcourir",
      0.0075
    ],
    [
      "glisser",
      0.0075
    ],
    [
      "cavaler",
      0.0075
    ],
    [
      "decaniller",
      0.0075
    ],
    [
      "essayer",
      0.0075
    ],
    [
      "faire",
      0.0075
    ],
    [
      "fondre",
      0.0075
    ],
    [
      "frequenter",
      0.0075
    ],
    [
      "sprinter",
      0.0025
    ],
    [
      "toucher",
      0.0025
    ],
    [
      "troler",
      0.0025
    ],
    [
      "voltiger",
      0.0025
    ],
    [
      "s'etendre",
      0.0025
    ],
    [
      "roder",
      0.0025
    ],
    [
      "relancer",
      0.0025
    ],
    [
      "accourir",
      0.0025
    ],
    [
      "accelerer",
      0.0025
    ],
    [
      "aspirer",
      0.0025
    ],
    [
      "continuer",
      0.0025
    ],
    [
      "gazer",
      0.0025
    ],
    [
      "importuner",
      0.0025
    ],
    [
      "rechercher",
      0.0025
    ],
    [
      "gambader",
      0.0
    ],
    [
      "pouloper",
      0.0
    ],
    [
      "pedaler",
      0.0
    ],
    [
      "tenter",
      0.0
    ],
    [
      "trisser",
      0.0
    ],
    [
      "droper",
      0.0
    ],
    [
      "draguer",
      0.0
    ],
    [
      "caleter",
      0.0
    ],
    [
      "claquer",
      0.0
    ],
    [
      "courailler",
      0.0
    ],
    [
      "courre",
      0.0
    ],
    [
      "courser",
      0.0
    ],
    [
      "distancer",
      0.0
    ],
    [
      "trotter",
      0.0
    ]
  ],
  "flaque": [
    [
      "flache",
      0.3325
    ],
    [
      "mare",
      0.3325
    ],
    [
      "nappe",
      0.3325
    ]
  ],
  "tete": [
    [
      "visage",
      0.09
    ],
    [
      "figure",
      0.0775
    ],
    [
      "binette",
      0.03
    ],
    [
      "face",
      0.03
    ],
    [
      "esprit",
      0.025
    ],
    [
      "bouille",
      0.025
    ],
    [
      "cerveau",
      0.02
    ],
    [
      "raison",
      0.02
    ],
    [
      "tronche",
      0.02
    ],
    [
      "pointe",
      0.015
    ],
    [
      "intelligence",
      0.015
    ],
    [
      "ciboulot",
      0.015
    ],
    [
      "bille",
      0.015
    ],
    [
      "physionomie",
      0.0125
    ],
    [
      "lucidite",
      0.0125
    ],
    [
      "image",
      0.0125
    ],
    [
      "gueule",
      0.0125
    ],
    [
      "front",
      0.0125
    ],
    [
      "fiole",
      0.0125
    ],
    [
      "entendement",
      0.0125
    ],
    [
      "direction",
      0.0125
    ],
    [
      "crane",
      0.0125
    ],
    [
      "chef",
      0.0125
    ],
    [
      "bourrichon",
      0.0125
    ],
    [
      "meneur",
      0.01
    ],
    [
      "poire",
      0.01
    ],
    [
      "pomme",
      0.01
    ],
    [
      "trombine",
      0.01
    ],
    [
      "idee",
      0.01
    ],
    [
      "haut",
      0.01
    ],
    [
      "devant",
      0.01
    ],
    [
      "cervelle",
      0.01
    ],
    [
      "cap",
      0.01
    ],
    [
      "boule",
      0.01
    ],
    [
      "bobine",
      0.01
    ],
    [
      "portrait",
      0.005
    ],
    [
      "mufle",
      0.005
    ],
    [
      "mine",
      0.005
    ],
    [
      "leader",
      0.005
    ],
    [
      "individu",
      0.005
    ],
    [
      "hure",
      0.005
    ],
    [
      "reflexion",
      0.005
    ],
    [
      "seuil",
      0.005
    ],
    [
      "sommet",
      0.005
    ],
    [
      "tirelire",
      0.005
    ],
    [
      "trogne",
      0.005
    ],
    [
      "unite",
      0.005
    ],
    [
      "homme",
      0.005
    ],
    [
      "faite",
      0.005
    ],
    [
      "facultes",
      0.005
    ],
    [
      "balle",
      0.005
    ],
    [
      "bouillotte",
      0.005
    ],
    [
      "caboche",
      0.005
    ],
    [
      "cabeche",
      0.005
    ],
    [
      "cafetiere",
      0.005
    ],
    [
      "caillou",
      0.005
    ],
    [
      "caisson",
      0.005
    ],
    [
      "coloquinte",
      0.005
    ],
    [
      "citrouille",
      0.005
    ],
    [
      "citron",
      0.005
    ],
    [
      "cassis",
      0.005
    ],
    [
      "carafon",
      0.005
    ],
    [
      "calme",
      0.005
    ],
    [
      "ogive",
      0.0025
    ],
    [
      "memoire",
      0.0025
    ],
    [
      "museau",
      0.0025
    ],
    [
      "margoulette",
      0.0025
    ],
    [
      "intellect",
      0.0025
    ],
    [
      "gousse",
      0.0025
    ],
    [
      "facies",
      0.0025
    ],
    [
      "personne",
      0.0025
    ],
    [
      "piece",
      0.0025
    ],
    [
      "plafond",
      0.0025
    ],
    [
      "sculpture",
      0.0025
    ],
    [
      "terrine",
      0.0025
    ],
    [
      "toiture",
      0.0025
    ],
    [
      "trompette",
      0.0025
    ],
    [
      "encephale",
      0.0025
    ],
    [
      "debut",
      0.0025
    ],
    [
      "autorite",
      0.0025
    ],
    [
      "avant",
      0.0025
    ],
    [
      "bobeche",
      0.0025
    ],
    [
      "bougie",
      0.0025
    ],
    [
      "boussole",
      0.0025
    ],
    [
      "brioche",
      0.0025
    ],
    [
      "burette",
      0.0025
    ],
    [
      "calebasse",
      0.0025
    ],
    [
      "carafe",
      0.0025
    ],
    [
      "chevet",
      0.0025
    ],
    [
      "cime",
      0.0025
    ],
    [
      "coco",
      0.0025
    ],
    [
      "commencement",
      0.0025
    ],
    [
      "directeur",
      0.0025
    ],
    [
      "assurance",
      0.0025
    ]
  ],
  "claque": [
    [
      "coup",
      0.0925
    ],
    [
      "gifle",
      0.0925
    ],
    [
      "soufflet",
      0.0925
    ],
    [
      "talmouse",
      0.0925
    ],
    [
      "torgnole",
      0.0925
    ],
    [
      "calotte",
      0.0675
    ],
    [
      "tape",
      0.045
    ],
    [
      "taloche",
      0.045
    ],
    [
      "mornifle",
      0.045
    ],
    [
      "tripot",
      0.0225
    ],
    [
      "tarte",
      0.0225
    ],
    [
      "souteneur",
      0.0225
    ],
    [
      "gibus",
      0.0225
    ],
    [
      "fessee",
      0.0225
    ],
    [
      "emplatre",
      0.0225
    ],
    [
      "empeigne",
      0.0225
    ],
    [
      "claqueur",
      0.0225
    ],
    [
      "claquement",
      0.0225
    ],
    [
      "bordel",
      0.0225
    ],
    [
      "baffe",
      0.0225
    ],
    [
      "tube",
      0.0225
    ]
  ],
  "claquer": [
    [
      "ereinter",
      0.0875
    ],
    [
      "crever",
      0.07
    ],
    [
      "fatiguer",
      0.0625
    ],
    [
      "epuiser",
      0.0625
    ],
    [
      "rompre",
      0.0475
    ],
    [
      "vanner",
      0.0475
    ],
    [
      "harasser",
      0.0375
    ],
    [
      "croquer",
      0.0375
    ],
    [
      "craquer",
      0.0375
    ],
    [
      "vider",
      0.03
    ],
    [
      "extenuer",
      0.03
    ],
    [
      "engloutir",
      0.03
    ],
    [
      "dissiper",
      0.03
    ],
    [
      "dilapider",
      0.03
    ],
    [
      "battre",
      0.03
    ],
    [
      "manger",
      0.0225
    ],
    [
      "depenser",
      0.0225
    ],
    [
      "casser",
      0.0225
    ],
    [
      "taper",
      0.015
    ],
    [
      "pomper",
      0.015
    ],
    [
      "mourir",
      0.015
    ],
    [
      "gaspiller",
      0.015
    ],
    [
      "frapper",
      0.015
    ],
    [
      "exceder",
      0.015
    ],
    [
      "esquinter",
      0.015
    ],
    [
      "crepiter",
      0.015
    ],
    [
      "mettre",
      0.005
    ],
    [
      "s'agiter",
      0.005
    ],
    [
      "souffleter",
      0.005
    ],
    [
      "succomber",
      0.005
    ],
    [
      "talocher",
      0.005
    ],
    [
      "gifler",
      0.005
    ],
    [
      "froisser",
      0.005
    ],
    [
      "forcer",
      0.005
    ],
    [
      "fermer",
      0.005
    ],
    [
      "engouffrer",
      0.005
    ],
    [
      "courir",
      0.005
    ],
    [
      "clapper",
      0.005
    ],
    [
      "calotter",
      0.005
    ],
    [
      "echouer",
      0.005
    ]
  ],
  "te": [
    [
      "regle",
      0.3325
    ],
    [
      "tiens",
      0.3325
    ],
    [
      "equerre",
      0.3325
    ]
  ],
  "bestiole": [
    [
      "animal",
      0.25
    ],
    [
      "bestion",
      0.25
    ],
    [
      "bete",
      0.25
    ],
    [
      "insecte",
      0.25
    ]
  ],
  "etai": [
    [
      "soutien",
      0.1525
    ],
    [
      "appui",
      0.14
    ],
    [
      "etancon",
      0.11
    ],
    [
      "accotoir",
      0.04
    ],
    [
      "fondement",
      0.04
    ],
    [
      "support",
      0.04
    ],
    [
      "soutenement",
      0.025
    ],
    [
      "cale",
      0.025
    ],
    [
      "bequille",
      0.025
    ],
    [
      "boisage",
      0.025
    ],
    [
      "aide",
      0.025
    ],
    [
      "hauban",
      0.0125
    ],
    [
      "pilier",
      0.0125
    ],
    [
      "pointal",
      0.0125
    ],
    [
      "renfort",
      0.0125
    ],
    [
      "semelle",
      0.0125
    ],
    [
      "tuteur",
      0.0125
    ],
    [
      "epointille",
      0.0125
    ],
    [
      "etance",
      0.0125
    ],
    [
      "etrier",
      0.0125
    ],
    [
      "guinderesse",
      0.0125
    ],
    [
      "fiche",
      0.0125
    ],
    [
      "accore",
      0.0125
    ],
    [
      "bois",
      0.0125
    ],
    [
      "chandelier",
      0.0125
    ],
    [
      "chevalement",
      0.0125
    ],
    [
      "chevalet",
      0.0125
    ],
    [
      "contreboutant",
      0.0125
    ],
    [
      "cordage",
      0.0125
    ],
    [
      "couchis",
      0.0125
    ],
    [
      "etresillon",
      0.0125
    ]
  ],
  "colle": [
    [
      "question",
      0.115
    ],
    [
      "punition",
      0.0775
    ],
    [
      "gelose",
      0.0375
    ],
    [
      "ichtyocolle",
      0.0375
    ],
    [
      "interrogation",
      0.0375
    ],
    [
      "oreillons",
      0.0375
    ],
    [
      "poisse",
      0.0375
    ],
    [
      "poix",
      0.0375
    ],
    [
      "probleme",
      0.0375
    ],
    [
      "pate",
      0.0375
    ],
    [
      "retenue",
      0.0375
    ],
    [
      "glu",
      0.0375
    ],
    [
      "futee",
      0.0375
    ],
    [
      "amidon",
      0.0375
    ],
    [
      "attrape",
      0.0375
    ],
    [
      "colloide",
      0.0375
    ],
    [
      "composition",
      0.0375
    ],
    [
      "consigne",
      0.0375
    ],
    [
      "conte",
      0.0375
    ],
    [
      "emplatre",
      0.0375
    ],
    [
      "empois",
      0.0375
    ],
    [
      "roman",
      0.0375
    ]
  ],
  "coller": [
    [
      "mettre",
      0.0675
    ],
    [
      "attacher",
      0.06
    ],
    [
      "fixer",
      0.0575
    ],
    [
      "ficher",
      0.0525
    ],
    [
      "appliquer",
      0.0475
    ],
    [
      "placer",
      0.04
    ],
    [
      "tenir",
      0.03
    ],
    [
      "donner",
      0.025
    ],
    [
      "s'attacher",
      0.0225
    ],
    [
      "prendre",
      0.0225
    ],
    [
      "flanquer",
      0.0225
    ],
    [
      "envoyer",
      0.0225
    ],
    [
      "refuser",
      0.0175
    ],
    [
      "consigner",
      0.0175
    ],
    [
      "assembler",
      0.0175
    ],
    [
      "arrimer",
      0.0175
    ],
    [
      "adherer",
      0.0175
    ],
    [
      "etendre",
      0.015
    ],
    [
      "s'appliquer",
      0.015
    ],
    [
      "recaler",
      0.015
    ],
    [
      "loger",
      0.015
    ],
    [
      "fourrer",
      0.015
    ],
    [
      "enduire",
      0.015
    ],
    [
      "bloquer",
      0.015
    ],
    [
      "allonger",
      0.015
    ],
    [
      "aller",
      0.015
    ],
    [
      "river",
      0.01
    ],
    [
      "plaquer",
      0.01
    ],
    [
      "joindre",
      0.01
    ],
    [
      "fermer",
      0.01
    ],
    [
      "conglomerer",
      0.01
    ],
    [
      "ajuster",
      0.01
    ],
    [
      "lancer",
      0.0075
    ],
    [
      "s'ajuster",
      0.0075
    ],
    [
      "s'aplatir",
      0.0075
    ],
    [
      "vendre",
      0.0075
    ],
    [
      "echouer",
      0.0075
    ],
    [
      "eliminer",
      0.0075
    ],
    [
      "gazer",
      0.0075
    ],
    [
      "encoller",
      0.0075
    ],
    [
      "corder",
      0.0075
    ],
    [
      "adresser",
      0.0075
    ],
    [
      "agglomerer",
      0.0075
    ],
    [
      "agglutiner",
      0.0075
    ],
    [
      "appuyer",
      0.0075
    ],
    [
      "assieger",
      0.0075
    ],
    [
      "caser",
      0.0075
    ],
    [
      "concorder",
      0.0075
    ],
    [
      "punir",
      0.0025
    ],
    [
      "regarder",
      0.0025
    ],
    [
      "retaper",
      0.0025
    ],
    [
      "retoquer",
      0.0025
    ],
    [
      "s'accrocher",
      0.0025
    ],
    [
      "secher",
      0.0025
    ],
    [
      "sevir",
      0.0025
    ],
    [
      "tapisser",
      0.0025
    ],
    [
      "tordre",
      0.0025
    ],
    [
      "gommer",
      0.0025
    ],
    [
      "envahir",
      0.0025
    ],
    [
      "embarrasser",
      0.0025
    ],
    [
      "affubler",
      0.0025
    ],
    [
      "ajourner",
      0.0025
    ],
    [
      "bicher",
      0.0025
    ],
    [
      "blackbouler",
      0.0025
    ],
    [
      "boumer",
      0.0025
    ],
    [
      "cacheter",
      0.0025
    ],
    [
      "cintrer",
      0.0025
    ],
    [
      "conglutiner",
      0.0025
    ],
    [
      "cramponner",
      0.0025
    ],
    [
      "demeurer",
      0.0025
    ]
  ],
  "toutes": [],
  "amour": [
    [
      "passion",
      0.075
    ],
    [
      "attachement",
      0.0375
    ],
    [
      "affection",
      0.035
    ],
    [
      "flirt",
      0.0275
    ],
    [
      "amourette",
      0.025
    ],
    [
      "caprice",
      0.025
    ],
    [
      "tendresse",
      0.0225
    ],
    [
      "coeur",
      0.0225
    ],
    [
      "adoration",
      0.02
    ],
    [
      "fanatisme",
      0.02
    ],
    [
      "galanterie",
      0.02
    ],
    [
      "liaison",
      0.0175
    ],
    [
      "inclination",
      0.0175
    ],
    [
      "devotion",
      0.0175
    ],
    [
      "desir",
      0.0175
    ],
    [
      "bagatelle",
      0.0175
    ],
    [
      "badinage",
      0.0175
    ],
    [
      "ardeur",
      0.015
    ],
    [
      "chaleur",
      0.015
    ],
    [
      "gout",
      0.015
    ],
    [
      "toquade",
      0.015
    ],
    [
      "passade",
      0.015
    ],
    [
      "fantaisie",
      0.015
    ],
    [
      "enthousiasme",
      0.015
    ],
    [
      "beguin",
      0.015
    ],
    [
      "veneration",
      0.0125
    ],
    [
      "sentiment",
      0.0125
    ],
    [
      "intrigue",
      0.0125
    ],
    [
      "engouement",
      0.0125
    ],
    [
      "devouement",
      0.0125
    ],
    [
      "tendance",
      0.01
    ],
    [
      "sens",
      0.01
    ],
    [
      "relation",
      0.01
    ],
    [
      "penchant",
      0.01
    ],
    [
      "flamme",
      0.01
    ],
    [
      "culte",
      0.01
    ],
    [
      "bluette",
      0.01
    ],
    [
      "plaisir",
      0.0075
    ],
    [
      "grace",
      0.0075
    ],
    [
      "feu",
      0.0075
    ],
    [
      "delicatesse",
      0.0075
    ],
    [
      "bouillonnement",
      0.0075
    ],
    [
      "aventure",
      0.0075
    ],
    [
      "amitie",
      0.0075
    ],
    [
      "mouvement",
      0.005
    ],
    [
      "interet",
      0.005
    ],
    [
      "idolatrie",
      0.005
    ],
    [
      "ferveur",
      0.005
    ],
    [
      "entente",
      0.005
    ],
    [
      "concupiscence",
      0.005
    ],
    [
      "bricole",
      0.005
    ],
    [
      "batifolage",
      0.005
    ],
    [
      "babiole",
      0.005
    ],
    [
      "piete",
      0.005
    ],
    [
      "marivaudage",
      0.005
    ],
    [
      "folie",
      0.005
    ],
    [
      "charite",
      0.005
    ],
    [
      "association",
      0.005
    ],
    [
      "amusement",
      0.005
    ],
    [
      "altruisme",
      0.005
    ],
    [
      "admiration",
      0.005
    ],
    [
      "mariage",
      0.0025
    ],
    [
      "mysticisme",
      0.0025
    ],
    [
      "pulsion",
      0.0025
    ],
    [
      "sensibilite",
      0.0025
    ],
    [
      "eros",
      0.0025
    ],
    [
      "frequentation",
      0.0025
    ],
    [
      "fraternite",
      0.0025
    ],
    [
      "ange",
      0.0025
    ],
    [
      "biquet",
      0.0025
    ],
    [
      "enfant",
      0.0025
    ],
    [
      "estime",
      0.0025
    ],
    [
      "fievre",
      0.0025
    ],
    [
      "dilection",
      0.0
    ],
    [
      "faible",
      0.0
    ],
    [
      "fleurette",
      0.0
    ],
    [
      "hymen",
      0.0
    ],
    [
      "hymenee",
      0.0
    ],
    [
      "ivresse",
      0.0
    ],
    [
      "maladie",
      0.0
    ],
    [
      "passionnette",
      0.0
    ],
    [
      "philanthropie",
      0.0
    ],
    [
      "putto",
      0.0
    ],
    [
      "touche",
      0.0
    ],
    [
      "coquetterie",
      0.0
    ],
    [
      "Cupidon",
      0.0
    ],
    [
      "Venus",
      0.0
    ],
    [
      "affect",
      0.0
    ],
    [
      "amativite",
      0.0
    ],
    [
      "archer",
      0.0
    ],
    [
      "archerot",
      0.0
    ],
    [
      "baise",
      0.0
    ],
    [
      "concubinage",
      0.0
    ],
    [
      "conquete",
      0.0
    ],
    [
      "contemplation",
      0.0
    ],
    [
      "Aphrodite",
      0.0
    ]
  ],
  "detraquer": [
    [
      "demolir",
      0.1225
    ],
    [
      "abimer",
      0.0725
    ],
    [
      "deteriorer",
      0.0725
    ],
    [
      "degrader",
      0.065
    ],
    [
      "deglinguer",
      0.0575
    ],
    [
      "deranger",
      0.0575
    ],
    [
      "troubler",
      0.0475
    ],
    [
      "demanteler",
      0.0475
    ],
    [
      "disloquer",
      0.0475
    ],
    [
      "alterer",
      0.0475
    ],
    [
      "casser",
      0.04
    ],
    [
      "deregler",
      0.04
    ],
    [
      "pervertir",
      0.0325
    ],
    [
      "fausser",
      0.0325
    ],
    [
      "esquinter",
      0.0225
    ],
    [
      "demonter",
      0.0225
    ],
    [
      "demantibuler",
      0.0225
    ],
    [
      "demancher",
      0.0225
    ],
    [
      "brouiller",
      0.0225
    ],
    [
      "accidenter",
      0.0225
    ],
    [
      "perturber",
      0.015
    ],
    [
      "embarbouiller",
      0.0075
    ],
    [
      "forcer",
      0.0075
    ],
    [
      "frelater",
      0.0075
    ],
    [
      "tournebouler",
      0.0075
    ]
  ],
  "chagrin": [
    [
      "affliction",
      0.05
    ],
    [
      "peine",
      0.05
    ],
    [
      "ennui",
      0.05
    ],
    [
      "tristesse",
      0.05
    ],
    [
      "douleur",
      0.045
    ],
    [
      "triste",
      0.0375
    ],
    [
      "desolation",
      0.0275
    ],
    [
      "melancolie",
      0.025
    ],
    [
      "amertume",
      0.025
    ],
    [
      "tourment",
      0.0225
    ],
    [
      "mal",
      0.0225
    ],
    [
      "malheur",
      0.02
    ],
    [
      "desespoir",
      0.0175
    ],
    [
      "calamite",
      0.0175
    ],
    [
      "tribulation",
      0.015
    ],
    [
      "souci",
      0.015
    ],
    [
      "morose",
      0.015
    ],
    [
      "maussade",
      0.015
    ],
    [
      "bilieux",
      0.015
    ],
    [
      "deception",
      0.0125
    ],
    [
      "sombre",
      0.0125
    ],
    [
      "souffrance",
      0.0125
    ],
    [
      "deplaisir",
      0.0125
    ],
    [
      "angoisse",
      0.0125
    ],
    [
      "detresse",
      0.01
    ],
    [
      "melancolique",
      0.01
    ],
    [
      "renfrogne",
      0.01
    ],
    [
      "hargneux",
      0.01
    ],
    [
      "desagrement",
      0.01
    ],
    [
      "degout",
      0.01
    ],
    [
      "deboire",
      0.01
    ],
    [
      "contrariete",
      0.01
    ],
    [
      "bile",
      0.01
    ],
    [
      "afflige",
      0.01
    ],
    [
      "morne",
      0.0075
    ],
    [
      "deuil",
      0.0075
    ],
    [
      "atrabilaire",
      0.0075
    ],
    [
      "eplore",
      0.0075
    ],
    [
      "soucieux",
      0.0075
    ],
    [
      "navre",
      0.0075
    ],
    [
      "mecontentement",
      0.0075
    ],
    [
      "inquietude",
      0.0075
    ],
    [
      "desole",
      0.0075
    ],
    [
      "attriste",
      0.0075
    ],
    [
      "reveche",
      0.005
    ],
    [
      "pleurard",
      0.005
    ],
    [
      "peine",
      0.005
    ],
    [
      "colere",
      0.005
    ],
    [
      "boulet",
      0.005
    ],
    [
      "elegiaque",
      0.0025
    ],
    [
      "regret",
      0.0025
    ],
    [
      "ennuye",
      0.0025
    ],
    [
      "depit",
      0.0025
    ],
    [
      "consternation",
      0.0025
    ],
    [
      "cafardeux",
      0.0025
    ],
    [
      "cafard",
      0.0025
    ],
    [
      "bourru",
      0.0025
    ],
    [
      "accablement",
      0.0025
    ],
    [
      "abattu",
      0.0025
    ],
    [
      "maussaderie",
      0.0025
    ],
    [
      "misere",
      0.0025
    ],
    [
      "morosite",
      0.0025
    ],
    [
      "plaintif",
      0.0025
    ],
    [
      "spleen",
      0.0025
    ],
    [
      "larmoyant",
      0.0025
    ],
    [
      "grincheux",
      0.0025
    ],
    [
      "dechirement",
      0.0025
    ],
    [
      "aigre",
      0.0025
    ],
    [
      "atrabile",
      0.0025
    ],
    [
      "bougon",
      0.0025
    ],
    [
      "chagrine",
      0.0025
    ],
    [
      "contrarie",
      0.0025
    ],
    [
      "inquiet",
      0.0
    ],
    [
      "misanthrope",
      0.0
    ],
    [
      "mortifie",
      0.0
    ],
    [
      "navrement",
      0.0
    ],
    [
      "pleureur",
      0.0
    ],
    [
      "rechigne",
      0.0
    ],
    [
      "remords",
      0.0
    ],
    [
      "terne",
      0.0
    ],
    [
      "hypocondrie",
      0.0
    ],
    [
      "gemissant",
      0.0
    ],
    [
      "accident",
      0.0
    ],
    [
      "affecte",
      0.0
    ],
    [
      "assombri",
      0.0
    ],
    [
      "colereux",
      0.0
    ],
    [
      "consterne",
      0.0
    ],
    [
      "dolent",
      0.0
    ],
    [
      "douloureux",
      0.0
    ],
    [
      "desappointement",
      0.0
    ],
    [
      "lugubre",
      0.0
    ],
    [
      "lypemanie",
      0.0
    ],
    [
      "peau",
      0.0
    ],
    [
      "sinistre",
      0.0
    ],
    [
      "larme",
      0.0
    ],
    [
      "inconsolable",
      0.0
    ],
    [
      "hypocondriaque",
      0.0
    ],
    [
      "grognon",
      0.0
    ],
    [
      "grimaud",
      0.0
    ],
    [
      "depite",
      0.0
    ],
    [
      "cuir",
      0.0
    ],
    [
      "contrit",
      0.0
    ],
    [
      "tracasserie",
      0.0
    ]
  ],
  "bricoler": [
    [
      "travailler",
      0.1175
    ],
    [
      "gratter",
      0.0875
    ],
    [
      "trafiquer",
      0.0875
    ],
    [
      "entretenir",
      0.0575
    ],
    [
      "restaurer",
      0.0575
    ],
    [
      "orner",
      0.0275
    ],
    [
      "peindre",
      0.0275
    ],
    [
      "pignocher",
      0.0275
    ],
    [
      "ravaler",
      0.0275
    ],
    [
      "refaire",
      0.0275
    ],
    [
      "reparer",
      0.0275
    ],
    [
      "s'amuser",
      0.0275
    ],
    [
      "s'occuper",
      0.0275
    ],
    [
      "travailloter",
      0.0275
    ],
    [
      "nettoyer",
      0.0275
    ],
    [
      "menuiser",
      0.0275
    ],
    [
      "bibeloter",
      0.0275
    ],
    [
      "bidouiller",
      0.0275
    ],
    [
      "boursicoter",
      0.0275
    ],
    [
      "brocher",
      0.0275
    ],
    [
      "decorer",
      0.0275
    ],
    [
      "fabriquer",
      0.0275
    ],
    [
      "frelater",
      0.0275
    ],
    [
      "jardiner",
      0.0275
    ],
    [
      "magouiller",
      0.0275
    ],
    [
      "tripoter",
      0.0275
    ]
  ],
  "bricole": [
    [
      "babiole",
      0.1425
    ],
    [
      "bagatelle",
      0.14
    ],
    [
      "futilite",
      0.09
    ],
    [
      "frivolite",
      0.085
    ],
    [
      "betise",
      0.04
    ],
    [
      "rien",
      0.035
    ],
    [
      "bibelot",
      0.0325
    ],
    [
      "broutille",
      0.0275
    ],
    [
      "amusette",
      0.025
    ],
    [
      "niaiserie",
      0.025
    ],
    [
      "badinage",
      0.0225
    ],
    [
      "baliverne",
      0.0225
    ],
    [
      "breloque",
      0.0225
    ],
    [
      "plaisanterie",
      0.0225
    ],
    [
      "fadaise",
      0.02
    ],
    [
      "amusement",
      0.02
    ],
    [
      "amour",
      0.0125
    ],
    [
      "fantaisie",
      0.0125
    ],
    [
      "jeu",
      0.0125
    ],
    [
      "vetille",
      0.0075
    ],
    [
      "sottise",
      0.0075
    ],
    [
      "flirt",
      0.0075
    ],
    [
      "colifichet",
      0.0075
    ],
    [
      "brimborion",
      0.0075
    ],
    [
      "travail",
      0.005
    ],
    [
      "sornette",
      0.005
    ],
    [
      "misere",
      0.005
    ],
    [
      "machinette",
      0.005
    ],
    [
      "harnais",
      0.005
    ],
    [
      "galanterie",
      0.005
    ],
    [
      "chanson",
      0.005
    ],
    [
      "caprice",
      0.005
    ],
    [
      "bretelle",
      0.005
    ],
    [
      "badinerie",
      0.005
    ],
    [
      "amusoire",
      0.005
    ],
    [
      "amourette",
      0.005
    ],
    [
      "connerie",
      0.0025
    ],
    [
      "fanfreluche",
      0.0025
    ],
    [
      "faribole",
      0.0025
    ],
    [
      "harnachement",
      0.0025
    ],
    [
      "laniere",
      0.0025
    ],
    [
      "poitrail",
      0.0025
    ],
    [
      "chose",
      0.0025
    ],
    [
      "catapulte",
      0.0025
    ],
    [
      "broquille",
      0.0025
    ],
    [
      "brocante",
      0.0025
    ],
    [
      "bricolage",
      0.0025
    ],
    [
      "brassiere",
      0.0025
    ],
    [
      "bimbelot",
      0.0025
    ],
    [
      "balancement",
      0.0025
    ],
    [
      "affiquet",
      0.0025
    ],
    [
      "rogaton",
      0.0025
    ]
  ],
  "erreur": [
    [
      "faute",
      0.1125
    ],
    [
      "aberration",
      0.06
    ],
    [
      "bevue",
      0.055
    ],
    [
      "ecart",
      0.0525
    ],
    [
      "betise",
      0.045
    ],
    [
      "egarement",
      0.0325
    ],
    [
      "maladresse",
      0.025
    ],
    [
      "illusion",
      0.025
    ],
    [
      "meprise",
      0.02
    ],
    [
      "sophisme",
      0.0175
    ],
    [
      "mensonge",
      0.0175
    ],
    [
      "manquement",
      0.0175
    ],
    [
      "inexactitude",
      0.0175
    ],
    [
      "fredaine",
      0.0175
    ],
    [
      "folie",
      0.0175
    ],
    [
      "errements",
      0.0175
    ],
    [
      "etourderie",
      0.0125
    ],
    [
      "irregularite",
      0.0125
    ],
    [
      "inadvertance",
      0.0125
    ],
    [
      "gaffe",
      0.0125
    ],
    [
      "faussete",
      0.0125
    ],
    [
      "extravagance",
      0.0125
    ],
    [
      "deviation",
      0.0125
    ],
    [
      "defaut",
      0.0125
    ],
    [
      "contresens",
      0.0125
    ],
    [
      "bourde",
      0.0125
    ],
    [
      "quiproquo",
      0.01
    ],
    [
      "lapsus",
      0.01
    ],
    [
      "incartade",
      0.01
    ],
    [
      "faiblesse",
      0.01
    ],
    [
      "dereglement",
      0.01
    ],
    [
      "distraction",
      0.01
    ],
    [
      "confusion",
      0.01
    ],
    [
      "aveuglement",
      0.01
    ],
    [
      "malentendu",
      0.005
    ],
    [
      "neant",
      0.005
    ],
    [
      "paralogisme",
      0.005
    ],
    [
      "peccadille",
      0.005
    ],
    [
      "vanite",
      0.005
    ],
    [
      "infidelite",
      0.005
    ],
    [
      "heresie",
      0.005
    ],
    [
      "fourvoiement",
      0.005
    ],
    [
      "blague",
      0.005
    ],
    [
      "coquille",
      0.005
    ],
    [
      "cuir",
      0.005
    ],
    [
      "errance",
      0.005
    ],
    [
      "faux",
      0.005
    ],
    [
      "maldonne",
      0.0025
    ],
    [
      "mastic",
      0.0025
    ],
    [
      "mecompte",
      0.0025
    ],
    [
      "megarde",
      0.0025
    ],
    [
      "mesinterpretation",
      0.0025
    ],
    [
      "prejuge",
      0.0025
    ],
    [
      "peregrination",
      0.0025
    ],
    [
      "songe",
      0.0025
    ],
    [
      "tenebres",
      0.0025
    ],
    [
      "injustice",
      0.0025
    ],
    [
      "impair",
      0.0025
    ],
    [
      "fumee",
      0.0025
    ],
    [
      "baudruche",
      0.0025
    ],
    [
      "bavure",
      0.0025
    ],
    [
      "boulette",
      0.0025
    ],
    [
      "bourdon",
      0.0025
    ],
    [
      "brioche",
      0.0025
    ],
    [
      "doublon",
      0.0025
    ],
    [
      "duperie",
      0.0025
    ],
    [
      "entorse",
      0.0025
    ],
    [
      "erratum",
      0.0025
    ],
    [
      "anerie",
      0.0025
    ]
  ],
  "zodiaque": [],
  "sauter": [
    [
      "fuser",
      0.0625
    ],
    [
      "bondir",
      0.055
    ],
    [
      "s'elancer",
      0.055
    ],
    [
      "passer",
      0.0425
    ],
    [
      "piquer",
      0.035
    ],
    [
      "foncer",
      0.035
    ],
    [
      "descendre",
      0.035
    ],
    [
      "attaquer",
      0.035
    ],
    [
      "eclater",
      0.0275
    ],
    [
      "tomber",
      0.0275
    ],
    [
      "partir",
      0.0275
    ],
    [
      "gambader",
      0.0275
    ],
    [
      "tressauter",
      0.02
    ],
    [
      "sursauter",
      0.02
    ],
    [
      "sautiller",
      0.02
    ],
    [
      "s'elever",
      0.02
    ],
    [
      "plonger",
      0.02
    ],
    [
      "manger",
      0.02
    ],
    [
      "avaler",
      0.02
    ],
    [
      "tressaillir",
      0.0125
    ],
    [
      "oublier",
      0.0125
    ],
    [
      "exploser",
      0.0125
    ],
    [
      "escamoter",
      0.0125
    ],
    [
      "enjamber",
      0.0125
    ],
    [
      "danser",
      0.0125
    ],
    [
      "cahoter",
      0.0125
    ],
    [
      "omettre",
      0.005
    ],
    [
      "peter",
      0.005
    ],
    [
      "rebondir",
      0.005
    ],
    [
      "remuer",
      0.005
    ],
    [
      "revenir",
      0.005
    ],
    [
      "ricocher",
      0.005
    ],
    [
      "saillir",
      0.005
    ],
    [
      "saquer",
      0.005
    ],
    [
      "trepigner",
      0.005
    ],
    [
      "grimper",
      0.005
    ],
    [
      "giguer",
      0.005
    ],
    [
      "apprehender",
      0.005
    ],
    [
      "assaillir",
      0.005
    ],
    [
      "attraper",
      0.005
    ],
    [
      "bringuebaler",
      0.005
    ],
    [
      "cabrioler",
      0.005
    ],
    [
      "chevaucher",
      0.005
    ],
    [
      "ceder",
      0.005
    ],
    [
      "franchir",
      0.005
    ],
    [
      "fringuer",
      0.005
    ]
  ],
  "saute": [
    [
      "fuser",
      0.0625
    ],
    [
      "bondir",
      0.055
    ],
    [
      "s'elancer",
      0.055
    ],
    [
      "passer",
      0.0425
    ],
    [
      "piquer",
      0.035
    ],
    [
      "foncer",
      0.035
    ],
    [
      "descendre",
      0.035
    ],
    [
      "attaquer",
      0.035
    ],
    [
      "eclater",
      0.0275
    ],
    [
      "tomber",
      0.0275
    ],
    [
      "partir",
      0.0275
    ],
    [
      "gambader",
      0.0275
    ],
    [
      "tressauter",
      0.02
    ],
    [
      "sursauter",
      0.02
    ],
    [
      "sautiller",
      0.02
    ],
    [
      "s'elever",
      0.02
    ],
    [
      "plonger",
      0.02
    ],
    [
      "manger",
      0.02
    ],
    [
      "avaler",
      0.02
    ],
    [
      "tressaillir",
      0.0125
    ],
    [
      "oublier",
      0.0125
    ],
    [
      "exploser",
      0.0125
    ],
    [
      "escamoter",
      0.0125
    ],
    [
      "enjamber",
      0.0125
    ],
    [
      "danser",
      0.0125
    ],
    [
      "cahoter",
      0.0125
    ],
    [
      "omettre",
      0.005
    ],
    [
      "peter",
      0.005
    ],
    [
      "rebondir",
      0.005
    ],
    [
      "remuer",
      0.005
    ],
    [
      "revenir",
      0.005
    ],
    [
      "ricocher",
      0.005
    ],
    [
      "saillir",
      0.005
    ],
    [
      "saquer",
      0.005
    ],
    [
      "trepigner",
      0.005
    ],
    [
      "grimper",
      0.005
    ],
    [
      "giguer",
      0.005
    ],
    [
      "apprehender",
      0.005
    ],
    [
      "assaillir",
      0.005
    ],
    [
      "attraper",
      0.005
    ],
    [
      "bringuebaler",
      0.005
    ],
    [
      "cabrioler",
      0.005
    ],
    [
      "chevaucher",
      0.005
    ],
    [
      "ceder",
      0.005
    ],
    [
      "franchir",
      0.005
    ],
    [
      "fringuer",
      0.005
    ]
  ],
  "pied": [
    [
      "patte",
      0.075
    ],
    [
      "jambe",
      0.055
    ],
    [
      "racine",
      0.055
    ],
    [
      "trace",
      0.0375
    ],
    [
      "souche",
      0.0375
    ],
    [
      "ripaton",
      0.0375
    ],
    [
      "fondement",
      0.0375
    ],
    [
      "base",
      0.0375
    ],
    [
      "pas",
      0.0175
    ],
    [
      "passee",
      0.0175
    ],
    [
      "paturon",
      0.0175
    ],
    [
      "peton",
      0.0175
    ],
    [
      "pince",
      0.0175
    ],
    [
      "pinceau",
      0.0175
    ],
    [
      "plante",
      0.0175
    ],
    [
      "pedicule",
      0.0175
    ],
    [
      "savate",
      0.0175
    ],
    [
      "spondee",
      0.0175
    ],
    [
      "stipe",
      0.0175
    ],
    [
      "syllabe",
      0.0175
    ],
    [
      "tribraque",
      0.0175
    ],
    [
      "trochee",
      0.0175
    ],
    [
      "panard",
      0.0175
    ],
    [
      "nougat",
      0.0175
    ],
    [
      "metre",
      0.0175
    ],
    [
      "arpion",
      0.0175
    ],
    [
      "assise",
      0.0175
    ],
    [
      "bas",
      0.0175
    ],
    [
      "butin",
      0.0175
    ],
    [
      "cep",
      0.0175
    ],
    [
      "choriambe",
      0.0175
    ],
    [
      "collet",
      0.0175
    ],
    [
      "dactyle",
      0.0175
    ],
    [
      "extremite",
      0.0175
    ],
    [
      "fade",
      0.0175
    ],
    [
      "fumeron",
      0.0175
    ],
    [
      "iambe",
      0.0175
    ],
    [
      "latte",
      0.0175
    ],
    [
      "main",
      0.0175
    ],
    [
      "anapeste",
      0.0175
    ]
  ],
  "pris": [
    [
      "gagner",
      0.035
    ],
    [
      "attraper",
      0.035
    ],
    [
      "saisir",
      0.0325
    ],
    [
      "piquer",
      0.03
    ],
    [
      "enlever",
      0.03
    ],
    [
      "voler",
      0.0225
    ],
    [
      "s'emparer",
      0.02
    ],
    [
      "faire",
      0.0175
    ],
    [
      "derober",
      0.0175
    ],
    [
      "obtenir",
      0.015
    ],
    [
      "recevoir",
      0.0125
    ],
    [
      "tenir",
      0.0125
    ],
    [
      "tirer",
      0.0125
    ],
    [
      "arreter",
      0.01
    ],
    [
      "ramasser",
      0.01
    ],
    [
      "retenir",
      0.01
    ],
    [
      "toucher",
      0.01
    ],
    [
      "s'approprier",
      0.01
    ],
    [
      "retirer",
      0.01
    ],
    [
      "fixer",
      0.01
    ],
    [
      "emporter",
      0.01
    ],
    [
      "conquerir",
      0.01
    ],
    [
      "ravir",
      0.01
    ],
    [
      "pincer",
      0.01
    ],
    [
      "chiper",
      0.01
    ],
    [
      "avoir",
      0.01
    ],
    [
      "attacher",
      0.01
    ],
    [
      "accrocher",
      0.01
    ],
    [
      "remporter",
      0.0075
    ],
    [
      "seduire",
      0.0075
    ],
    [
      "soustraire",
      0.0075
    ],
    [
      "mettre",
      0.0075
    ],
    [
      "faucher",
      0.0075
    ],
    [
      "embrasser",
      0.0075
    ],
    [
      "absorber",
      0.0075
    ],
    [
      "suivre",
      0.005
    ],
    [
      "s'attacher",
      0.005
    ],
    [
      "occuper",
      0.005
    ],
    [
      "empoigner",
      0.005
    ],
    [
      "attirer",
      0.005
    ],
    [
      "monter",
      0.005
    ],
    [
      "regarder",
      0.005
    ],
    [
      "recolter",
      0.005
    ],
    [
      "serrer",
      0.005
    ],
    [
      "soutirer",
      0.005
    ],
    [
      "traiter",
      0.005
    ],
    [
      "manger",
      0.005
    ],
    [
      "engager",
      0.005
    ],
    [
      "encaisser",
      0.005
    ],
    [
      "aller",
      0.005
    ],
    [
      "arracher",
      0.005
    ],
    [
      "atteindre",
      0.005
    ],
    [
      "choper",
      0.005
    ],
    [
      "cueillir",
      0.005
    ],
    [
      "emprunter",
      0.005
    ],
    [
      "piller",
      0.005
    ],
    [
      "rafler",
      0.005
    ],
    [
      "ratiboiser",
      0.005
    ],
    [
      "recueillir",
      0.005
    ],
    [
      "surprendre",
      0.005
    ],
    [
      "user",
      0.005
    ],
    [
      "epingler",
      0.005
    ],
    [
      "oter",
      0.005
    ],
    [
      "percevoir",
      0.005
    ],
    [
      "geler",
      0.005
    ],
    [
      "acquerir",
      0.005
    ],
    [
      "adopter",
      0.005
    ],
    [
      "attaquer",
      0.005
    ],
    [
      "capturer",
      0.005
    ],
    [
      "comprendre",
      0.005
    ],
    [
      "considerer",
      0.005
    ],
    [
      "contracter",
      0.005
    ],
    [
      "envahir",
      0.005
    ],
    [
      "figer",
      0.0025
    ],
    [
      "forcer",
      0.0025
    ],
    [
      "harponner",
      0.0025
    ],
    [
      "mordre",
      0.0025
    ],
    [
      "s'appliquer",
      0.0025
    ],
    [
      "soulever",
      0.0025
    ],
    [
      "usurper",
      0.0025
    ],
    [
      "etreindre",
      0.0025
    ],
    [
      "entrer",
      0.0025
    ],
    [
      "employer",
      0.0025
    ],
    [
      "accaparer",
      0.0025
    ],
    [
      "agrafer",
      0.0025
    ],
    [
      "apprehender",
      0.0025
    ],
    [
      "bruler",
      0.0025
    ],
    [
      "coincer",
      0.0025
    ],
    [
      "confisquer",
      0.0025
    ],
    [
      "disposer",
      0.0025
    ],
    [
      "devorer",
      0.0025
    ],
    [
      "plagier",
      0.0025
    ],
    [
      "posseder",
      0.0025
    ],
    [
      "prelever",
      0.0025
    ],
    [
      "s'assurer",
      0.0025
    ],
    [
      "souffler",
      0.0025
    ],
    [
      "estimer",
      0.0025
    ],
    [
      "embarquer",
      0.0025
    ],
    [
      "agripper",
      0.0025
    ],
    [
      "avaler",
      0.0025
    ],
    [
      "charger",
      0.0025
    ],
    [
      "choisir",
      0.0025
    ],
    [
      "coller",
      0.0025
    ],
    [
      "connaitre",
      0.0025
    ],
    [
      "retrancher",
      0.0
    ],
    [
      "ratisser",
      0.0
    ],
    [
      "piper",
      0.0
    ],
    [
      "piger",
      0.0
    ],
    [
      "nommer",
      0.0
    ],
    [
      "marcher",
      0.0
    ],
    [
      "happer",
      0.0
    ],
    [
      "reussir",
      0.0
    ],
    [
      "subir",
      0.0
    ],
    [
      "supposer",
      0.0
    ],
    [
      "selectionner",
      0.0
    ],
    [
      "tourner",
      0.0
    ],
    [
      "tuer",
      0.0
    ],
    [
      "utiliser",
      0.0
    ],
    [
      "ecoper",
      0.0
    ],
    [
      "extraire",
      0.0
    ],
    [
      "envisager",
      0.0
    ],
    [
      "acheter",
      0.0
    ],
    [
      "admettre",
      0.0
    ],
    [
      "affecter",
      0.0
    ],
    [
      "amadouer",
      0.0
    ],
    [
      "assurer",
      0.0
    ],
    [
      "barboter",
      0.0
    ],
    [
      "boire",
      0.0
    ],
    [
      "caillebotter",
      0.0
    ],
    [
      "chauffer",
      0.0
    ],
    [
      "entortiller",
      0.0
    ],
    [
      "enfiler",
      0.0
    ],
    [
      "designer",
      0.0
    ],
    [
      "consommer",
      0.0
    ],
    [
      "compter",
      0.0
    ],
    [
      "commencer",
      0.0
    ],
    [
      "chercher",
      0.0
    ],
    [
      "s'engager",
      0.0
    ],
    [
      "s'attribuer",
      0.0
    ],
    [
      "reputer",
      0.0
    ],
    [
      "reprendre",
      0.0
    ],
    [
      "recruter",
      0.0
    ],
    [
      "poisser",
      0.0
    ],
    [
      "persuader",
      0.0
    ],
    [
      "oppresser",
      0.0
    ],
    [
      "elire",
      0.0
    ],
    [
      "vendanger",
      0.0
    ],
    [
      "sortir",
      0.0
    ],
    [
      "juger",
      0.0
    ],
    [
      "interpreter",
      0.0
    ],
    [
      "intercepter",
      0.0
    ],
    [
      "couter",
      0.0
    ],
    [
      "compiler",
      0.0
    ],
    [
      "coaguler",
      0.0
    ],
    [
      "ceinturer",
      0.0
    ],
    [
      "assumer",
      0.0
    ],
    [
      "arquepincer",
      0.0
    ],
    [
      "apprivoiser",
      0.0
    ],
    [
      "apporter",
      0.0
    ],
    [
      "accueillir",
      0.0
    ],
    [
      "durcir",
      0.0
    ],
    [
      "deguster",
      0.0
    ],
    [
      "demarquer",
      0.0
    ],
    [
      "ingurgiter",
      0.0
    ],
    [
      "harper",
      0.0
    ],
    [
      "gripper",
      0.0
    ],
    [
      "ferrer",
      0.0
    ],
    [
      "exiger",
      0.0
    ],
    [
      "essuyer",
      0.0
    ],
    [
      "endosser",
      0.0
    ],
    [
      "emmener",
      0.0
    ],
    [
      "devaliser",
      0.0
    ],
    [
      "s'amorcer",
      0.0
    ],
    [
      "s'adjoindre",
      0.0
    ],
    [
      "puiser",
      0.0
    ],
    [
      "priser",
      0.0
    ],
    [
      "piocher",
      0.0
    ],
    [
      "s'associer",
      0.0
    ],
    [
      "s'implanter",
      0.0
    ],
    [
      "ecumer",
      0.0
    ],
    [
      "epaissir",
      0.0
    ],
    [
      "paumer",
      0.0
    ],
    [
      "ingerer",
      0.0
    ],
    [
      "aveindre",
      0.0
    ],
    [
      "chouraver",
      0.0
    ],
    [
      "colleter",
      0.0
    ],
    [
      "congeler",
      0.0
    ],
    [
      "coopter",
      0.0
    ],
    [
      "cramer",
      0.0
    ],
    [
      "crocher",
      0.0
    ],
    [
      "debuter",
      0.0
    ],
    [
      "decimer",
      0.0
    ],
    [
      "embaucher",
      0.0
    ],
    [
      "heberger",
      0.0
    ],
    [
      "arnaquer",
      0.0
    ]
  ],
  "remorqueur": [
    [
      "tireur",
      0.5
    ],
    [
      "toueur",
      0.5
    ]
  ],
  "gondole": [
    [
      "barque",
      0.5
    ],
    [
      "bateau",
      0.5
    ]
  ],
  "trainer": [
    [
      "flaner",
      0.08
    ],
    [
      "durer",
      0.04
    ],
    [
      "rester",
      0.0375
    ],
    [
      "errer",
      0.035
    ],
    [
      "musarder",
      0.035
    ],
    [
      "demeurer",
      0.0325
    ],
    [
      "subsister",
      0.03
    ],
    [
      "trainasser",
      0.03
    ],
    [
      "lambiner",
      0.025
    ],
    [
      "entrainer",
      0.025
    ],
    [
      "continuer",
      0.025
    ],
    [
      "lanterner",
      0.0225
    ],
    [
      "muser",
      0.0225
    ],
    [
      "s'eterniser",
      0.0225
    ],
    [
      "mener",
      0.02
    ],
    [
      "roder",
      0.02
    ],
    [
      "tenir",
      0.02
    ],
    [
      "transporter",
      0.02
    ],
    [
      "vagabonder",
      0.0175
    ],
    [
      "s'attarder",
      0.0175
    ],
    [
      "baguenauder",
      0.0125
    ],
    [
      "conduire",
      0.0125
    ],
    [
      "tarder",
      0.01
    ],
    [
      "s'amuser",
      0.01
    ],
    [
      "retarder",
      0.01
    ],
    [
      "marcher",
      0.01
    ],
    [
      "emporter",
      0.01
    ],
    [
      "attirer",
      0.01
    ],
    [
      "amener",
      0.01
    ],
    [
      "vadrouiller",
      0.0075
    ],
    [
      "tirer",
      0.0075
    ],
    [
      "survivre",
      0.0075
    ],
    [
      "s'etendre",
      0.0075
    ],
    [
      "promener",
      0.0075
    ],
    [
      "perseverer",
      0.0075
    ],
    [
      "emmener",
      0.0075
    ],
    [
      "charrier",
      0.0075
    ],
    [
      "badauder",
      0.0075
    ],
    [
      "temporiser",
      0.005
    ],
    [
      "tomber",
      0.005
    ],
    [
      "touer",
      0.005
    ],
    [
      "vaguer",
      0.005
    ],
    [
      "resister",
      0.005
    ],
    [
      "pendiller",
      0.005
    ],
    [
      "differer",
      0.005
    ],
    [
      "faineanter",
      0.005
    ],
    [
      "flanocher",
      0.005
    ],
    [
      "galvauder",
      0.005
    ],
    [
      "moisir",
      0.005
    ],
    [
      "paresser",
      0.005
    ],
    [
      "s'enliser",
      0.0025
    ],
    [
      "s'egarer",
      0.0025
    ],
    [
      "traduire",
      0.0025
    ],
    [
      "trainailler",
      0.0025
    ],
    [
      "trimballer",
      0.0025
    ],
    [
      "troler",
      0.0025
    ],
    [
      "vivre",
      0.0025
    ],
    [
      "zoner",
      0.0025
    ],
    [
      "rodailler",
      0.0025
    ],
    [
      "retomber",
      0.0025
    ],
    [
      "remorquer",
      0.0025
    ],
    [
      "bader",
      0.0025
    ],
    [
      "balayer",
      0.0025
    ],
    [
      "balocher",
      0.0025
    ],
    [
      "clampiner",
      0.0025
    ],
    [
      "dormir",
      0.0025
    ],
    [
      "folatrer",
      0.0025
    ],
    [
      "languir",
      0.0025
    ],
    [
      "occasionner",
      0.0025
    ],
    [
      "atteler",
      0.0025
    ]
  ],
  "traine": [
    [
      "filet",
      0.2
    ],
    [
      "queue",
      0.2
    ],
    [
      "remorque",
      0.2
    ],
    [
      "seine",
      0.2
    ],
    [
      "senne",
      0.2
    ]
  ],
  "casserole": [
    [
      "batterie",
      0.085
    ],
    [
      "casse",
      0.085
    ],
    [
      "cocotte",
      0.085
    ],
    [
      "marmite",
      0.085
    ],
    [
      "poele",
      0.085
    ],
    [
      "lechefrite",
      0.0425
    ],
    [
      "mouchard",
      0.0425
    ],
    [
      "poelon",
      0.0425
    ],
    [
      "rapporteur",
      0.0425
    ],
    [
      "sauteuse",
      0.0425
    ],
    [
      "gamelle",
      0.0425
    ],
    [
      "faitout",
      0.0425
    ],
    [
      "espion",
      0.0425
    ],
    [
      "denonciateur",
      0.0425
    ],
    [
      "chaudron",
      0.0425
    ],
    [
      "casserolee",
      0.0425
    ],
    [
      "braisiere",
      0.0425
    ],
    [
      "sautoir",
      0.0425
    ]
  ],
  "decharge": [
    [
      "diminution",
      0.0575
    ],
    [
      "degrevement",
      0.0575
    ],
    [
      "exoneration",
      0.0475
    ],
    [
      "allegement",
      0.0375
    ],
    [
      "deblai",
      0.0375
    ],
    [
      "rafale",
      0.0375
    ],
    [
      "salve",
      0.0375
    ],
    [
      "liberation",
      0.0275
    ],
    [
      "feu",
      0.0275
    ],
    [
      "exemption",
      0.0275
    ],
    [
      "depotoir",
      0.0275
    ],
    [
      "volee",
      0.0175
    ],
    [
      "voirie",
      0.0175
    ],
    [
      "tir",
      0.0175
    ],
    [
      "soulagement",
      0.0175
    ],
    [
      "reduction",
      0.0175
    ],
    [
      "recepisse",
      0.0175
    ],
    [
      "quittance",
      0.0175
    ],
    [
      "immunite",
      0.0175
    ],
    [
      "debris",
      0.0175
    ],
    [
      "debarras",
      0.0175
    ],
    [
      "affranchissement",
      0.0175
    ],
    [
      "abattement",
      0.0175
    ],
    [
      "justification",
      0.0075
    ],
    [
      "fusillade",
      0.0075
    ],
    [
      "flux",
      0.0075
    ],
    [
      "extinction",
      0.0075
    ],
    [
      "excuse",
      0.0075
    ],
    [
      "detonation",
      0.0075
    ],
    [
      "mousquetade",
      0.0075
    ],
    [
      "platras",
      0.0075
    ],
    [
      "poutre",
      0.0075
    ],
    [
      "quitus",
      0.0075
    ],
    [
      "reste",
      0.0075
    ],
    [
      "recu",
      0.0075
    ],
    [
      "sentine",
      0.0075
    ],
    [
      "torgnole",
      0.0075
    ],
    [
      "ecoulement",
      0.0075
    ],
    [
      "emargement",
      0.0075
    ],
    [
      "depot",
      0.0075
    ],
    [
      "demolition",
      0.0075
    ],
    [
      "acquit",
      0.0075
    ],
    [
      "apaisement",
      0.0075
    ],
    [
      "arrosage",
      0.0075
    ],
    [
      "bastonnade",
      0.0075
    ],
    [
      "bordee",
      0.0075
    ],
    [
      "caillasse",
      0.0075
    ],
    [
      "cloaque",
      0.0075
    ],
    [
      "dechargement",
      0.0075
    ],
    [
      "dechargeoir",
      0.0075
    ],
    [
      "dechetterie",
      0.0075
    ],
    [
      "decombres",
      0.0075
    ],
    [
      "defense",
      0.0075
    ],
    [
      "defoulement",
      0.0075
    ],
    [
      "defecation",
      0.0075
    ],
    [
      "abreaction",
      0.0075
    ]
  ],
  "decharger": [
    [
      "degager",
      0.09
    ],
    [
      "liberer",
      0.09
    ],
    [
      "soulager",
      0.06
    ],
    [
      "debarrasser",
      0.0525
    ],
    [
      "exonerer",
      0.0525
    ],
    [
      "oter",
      0.0525
    ],
    [
      "exempter",
      0.0425
    ],
    [
      "delivrer",
      0.0425
    ],
    [
      "affranchir",
      0.0375
    ],
    [
      "dispenser",
      0.0375
    ],
    [
      "enlever",
      0.0375
    ],
    [
      "degrever",
      0.03
    ],
    [
      "alleger",
      0.03
    ],
    [
      "epancher",
      0.02
    ],
    [
      "tirer",
      0.02
    ],
    [
      "justifier",
      0.02
    ],
    [
      "excuser",
      0.02
    ],
    [
      "debarquer",
      0.02
    ],
    [
      "diminuer",
      0.02
    ],
    [
      "eviter",
      0.0125
    ],
    [
      "renvoyer",
      0.0125
    ],
    [
      "laver",
      0.0125
    ],
    [
      "innocenter",
      0.0125
    ],
    [
      "exprimer",
      0.0125
    ],
    [
      "deverser",
      0.0125
    ],
    [
      "disculper",
      0.0125
    ],
    [
      "blanchir",
      0.0125
    ],
    [
      "acquitter",
      0.0125
    ],
    [
      "deposer",
      0.005
    ],
    [
      "delier",
      0.005
    ],
    [
      "delester",
      0.005
    ],
    [
      "decocher",
      0.005
    ],
    [
      "debourrer",
      0.005
    ],
    [
      "debarder",
      0.005
    ],
    [
      "deballer",
      0.005
    ],
    [
      "bavocher",
      0.005
    ],
    [
      "assener",
      0.005
    ],
    [
      "deteindre",
      0.005
    ]
  ],
  "pack": [
    [
      "glace",
      0.5
    ],
    [
      "paquet",
      0.5
    ]
  ],
  "bazarder": [
    [
      "liquider",
      0.1375
    ],
    [
      "balancer",
      0.11
    ],
    [
      "vendre",
      0.0825
    ],
    [
      "solder",
      0.0825
    ],
    [
      "jeter",
      0.0825
    ],
    [
      "abandonner",
      0.055
    ],
    [
      "balayer",
      0.055
    ],
    [
      "brader",
      0.0275
    ],
    [
      "brocanter",
      0.0275
    ],
    [
      "flanquer",
      0.0275
    ],
    [
      "fourguer",
      0.0275
    ]
  ],
  "prix": [
    [
      "recompense",
      0.085
    ],
    [
      "loyer",
      0.0525
    ],
    [
      "taux",
      0.0525
    ],
    [
      "valeur",
      0.04
    ],
    [
      "tarif",
      0.04
    ],
    [
      "salaire",
      0.04
    ],
    [
      "montant",
      0.04
    ],
    [
      "trophee",
      0.03
    ],
    [
      "tribut",
      0.03
    ],
    [
      "taxe",
      0.03
    ],
    [
      "interet",
      0.03
    ],
    [
      "cout",
      0.03
    ],
    [
      "cours",
      0.03
    ],
    [
      "cote",
      0.03
    ],
    [
      "evaluation",
      0.02
    ],
    [
      "somme",
      0.02
    ],
    [
      "paiement",
      0.02
    ],
    [
      "medaille",
      0.02
    ],
    [
      "facture",
      0.02
    ],
    [
      "estimation",
      0.02
    ],
    [
      "carte",
      0.02
    ],
    [
      "addition",
      0.02
    ],
    [
      "depens",
      0.01
    ],
    [
      "encouragement",
      0.01
    ],
    [
      "louage",
      0.01
    ],
    [
      "mercuriale",
      0.01
    ],
    [
      "merite",
      0.01
    ],
    [
      "oscar",
      0.01
    ],
    [
      "rancon",
      0.01
    ],
    [
      "rapport",
      0.01
    ],
    [
      "etiquette",
      0.01
    ],
    [
      "diplome",
      0.01
    ],
    [
      "devis",
      0.01
    ],
    [
      "couronne",
      0.01
    ],
    [
      "bordereau",
      0.01
    ],
    [
      "cachet",
      0.01
    ],
    [
      "cadeau",
      0.01
    ],
    [
      "cherte",
      0.01
    ],
    [
      "choix",
      0.01
    ],
    [
      "chatiment",
      0.01
    ],
    [
      "condition",
      0.01
    ],
    [
      "cotation",
      0.01
    ],
    [
      "coupe",
      0.01
    ],
    [
      "accessit",
      0.01
    ]
  ],
  "petrole": [
    [
      "combustible",
      0.2675
    ],
    [
      "carburant",
      0.2
    ],
    [
      "naphte",
      0.065
    ],
    [
      "kerosene",
      0.065
    ],
    [
      "hydrocarbure",
      0.065
    ],
    [
      "huile",
      0.065
    ],
    [
      "alcool",
      0.065
    ]
  ],
  "col": [
    [
      "defile",
      0.11
    ],
    [
      "passage",
      0.11
    ],
    [
      "collet",
      0.0825
    ],
    [
      "cou",
      0.0825
    ],
    [
      "detroit",
      0.0825
    ],
    [
      "gorge",
      0.0825
    ],
    [
      "rabat",
      0.055
    ],
    [
      "port",
      0.055
    ],
    [
      "pas",
      0.055
    ],
    [
      "guimpe",
      0.0275
    ],
    [
      "goulot",
      0.0275
    ],
    [
      "gorgette",
      0.0275
    ],
    [
      "fraise",
      0.0275
    ],
    [
      "encolure",
      0.0275
    ],
    [
      "cravate",
      0.0275
    ],
    [
      "collerette",
      0.0275
    ],
    [
      "canyon",
      0.0275
    ],
    [
      "breche",
      0.0275
    ],
    [
      "pertuis",
      0.0275
    ]
  ],
  "blanc": [
    [
      "pur",
      0.1075
    ],
    [
      "blanchatre",
      0.0525
    ],
    [
      "net",
      0.0525
    ],
    [
      "pale",
      0.0425
    ],
    [
      "vierge",
      0.0425
    ],
    [
      "propre",
      0.03
    ],
    [
      "opalin",
      0.03
    ],
    [
      "immacule",
      0.03
    ],
    [
      "clair",
      0.03
    ],
    [
      "candide",
      0.03
    ],
    [
      "virginal",
      0.02
    ],
    [
      "vide",
      0.02
    ],
    [
      "nu",
      0.02
    ],
    [
      "limpide",
      0.02
    ],
    [
      "laiteux",
      0.02
    ],
    [
      "ivoirin",
      0.02
    ],
    [
      "innocent",
      0.02
    ],
    [
      "espace",
      0.02
    ],
    [
      "bleme",
      0.02
    ],
    [
      "lacte",
      0.01
    ],
    [
      "lactescent",
      0.01
    ],
    [
      "ivoire",
      0.01
    ],
    [
      "intervalle",
      0.01
    ],
    [
      "interligne",
      0.01
    ],
    [
      "ingenu",
      0.01
    ],
    [
      "lave",
      0.01
    ],
    [
      "lilial",
      0.01
    ],
    [
      "livide",
      0.01
    ],
    [
      "mille",
      0.01
    ],
    [
      "niveen",
      0.01
    ],
    [
      "platine",
      0.01
    ],
    [
      "platine",
      0.01
    ],
    [
      "supreme",
      0.01
    ],
    [
      "vin",
      0.01
    ],
    [
      "incolore",
      0.01
    ],
    [
      "impersonnel",
      0.01
    ],
    [
      "albugine",
      0.01
    ],
    [
      "alpestre",
      0.01
    ],
    [
      "argente",
      0.01
    ],
    [
      "azurant",
      0.01
    ],
    [
      "blafard",
      0.01
    ],
    [
      "blancheur",
      0.01
    ],
    [
      "blanchi",
      0.01
    ],
    [
      "chenu",
      0.01
    ],
    [
      "creme",
      0.01
    ],
    [
      "enfarine",
      0.01
    ],
    [
      "fenetre",
      0.01
    ],
    [
      "filet",
      0.01
    ],
    [
      "albe",
      0.01
    ]
  ],
  "foutre": [
    [
      "ficher",
      0.23
    ],
    [
      "flanquer",
      0.115
    ],
    [
      "appliquer",
      0.0675
    ],
    [
      "mettre",
      0.055
    ],
    [
      "lancer",
      0.045
    ],
    [
      "jeter",
      0.045
    ],
    [
      "donner",
      0.045
    ],
    [
      "adresser",
      0.045
    ],
    [
      "allonger",
      0.0325
    ],
    [
      "fabriquer",
      0.0325
    ],
    [
      "faire",
      0.0325
    ],
    [
      "placer",
      0.0225
    ],
    [
      "fricoter",
      0.0225
    ],
    [
      "fourrer",
      0.0225
    ],
    [
      "branler",
      0.0225
    ],
    [
      "bougre",
      0.0225
    ],
    [
      "administrer",
      0.0225
    ],
    [
      "releguer",
      0.01
    ],
    [
      "maquiller",
      0.01
    ],
    [
      "fichtre",
      0.01
    ],
    [
      "enfiler",
      0.01
    ],
    [
      "diable",
      0.01
    ],
    [
      "cyprine",
      0.01
    ],
    [
      "baiser",
      0.01
    ],
    [
      "tringler",
      0.01
    ]
  ],
  "vrac": [],
  "roll": [],
  "bemol": [
    [
      "nuance",
      1.0
    ]
  ],
  "couac": [
    [
      "canard",
      0.5
    ]
  ],
  "nom": [
    [
      "appellation",
      0.095
    ],
    [
      "marque",
      0.075
    ],
    [
      "mot",
      0.075
    ],
    [
      "denomination",
      0.055
    ],
    [
      "qualification",
      0.055
    ],
    [
      "titre",
      0.055
    ],
    [
      "vocable",
      0.0375
    ],
    [
      "terme",
      0.0375
    ],
    [
      "surnom",
      0.0375
    ],
    [
      "qualite",
      0.0375
    ],
    [
      "designation",
      0.0375
    ],
    [
      "celebrite",
      0.0375
    ],
    [
      "prenom",
      0.0175
    ],
    [
      "pseudonyme",
      0.0175
    ],
    [
      "renommee",
      0.0175
    ],
    [
      "reputation",
      0.0175
    ],
    [
      "signature",
      0.0175
    ],
    [
      "signifiant",
      0.0175
    ],
    [
      "sobriquet",
      0.0175
    ],
    [
      "patronyme",
      0.0175
    ],
    [
      "notoriete",
      0.0175
    ],
    [
      "blase",
      0.0175
    ],
    [
      "blason",
      0.0175
    ],
    [
      "gloire",
      0.0175
    ],
    [
      "homonyme",
      0.0175
    ],
    [
      "label",
      0.0175
    ],
    [
      "lignage",
      0.0175
    ],
    [
      "maison",
      0.0175
    ],
    [
      "naissance",
      0.0175
    ],
    [
      "substantif",
      0.0175
    ]
  ],
  "coin": [
    [
      "lieu",
      0.0575
    ],
    [
      "endroit",
      0.05
    ],
    [
      "pays",
      0.0425
    ],
    [
      "angle",
      0.0375
    ],
    [
      "repli",
      0.0375
    ],
    [
      "region",
      0.0375
    ],
    [
      "trou",
      0.0375
    ],
    [
      "point",
      0.0325
    ],
    [
      "patelin",
      0.0325
    ],
    [
      "partie",
      0.0325
    ],
    [
      "marque",
      0.025
    ],
    [
      "morceau",
      0.025
    ],
    [
      "quartier",
      0.025
    ],
    [
      "secteur",
      0.025
    ],
    [
      "site",
      0.025
    ],
    [
      "renfoncement",
      0.0175
    ],
    [
      "place",
      0.0175
    ],
    [
      "parages",
      0.0175
    ],
    [
      "emplacement",
      0.0175
    ],
    [
      "detour",
      0.0175
    ],
    [
      "bout",
      0.0175
    ],
    [
      "bled",
      0.0175
    ],
    [
      "estampille",
      0.01
    ],
    [
      "face",
      0.01
    ],
    [
      "localite",
      0.01
    ],
    [
      "racoin",
      0.01
    ],
    [
      "recoin",
      0.01
    ],
    [
      "retrait",
      0.01
    ],
    [
      "solitude",
      0.01
    ],
    [
      "tournant",
      0.01
    ],
    [
      "encoignure",
      0.01
    ],
    [
      "corne",
      0.01
    ],
    [
      "bande",
      0.01
    ],
    [
      "cache",
      0.01
    ],
    [
      "cachet",
      0.01
    ],
    [
      "cachette",
      0.01
    ],
    [
      "canton",
      0.01
    ],
    [
      "carre",
      0.01
    ],
    [
      "chronique",
      0.01
    ],
    [
      "commissure",
      0.01
    ],
    [
      "extremite",
      0.005
    ],
    [
      "patarasse",
      0.005
    ],
    [
      "piquet",
      0.005
    ],
    [
      "poincon",
      0.005
    ],
    [
      "punition",
      0.005
    ],
    [
      "rabicoin",
      0.005
    ],
    [
      "rubrique",
      0.005
    ],
    [
      "sceau",
      0.005
    ],
    [
      "empreinte",
      0.005
    ],
    [
      "croisement",
      0.005
    ],
    [
      "courrier",
      0.005
    ],
    [
      "alignoir",
      0.005
    ],
    [
      "bois",
      0.005
    ],
    [
      "box",
      0.005
    ],
    [
      "cachot",
      0.005
    ],
    [
      "cale",
      0.005
    ],
    [
      "carne",
      0.005
    ],
    [
      "coinstot",
      0.005
    ],
    [
      "coulisse",
      0.005
    ],
    [
      "thebaide",
      0.005
    ]
  ],
  "vouloir": [
    [
      "volonte",
      0.2725
    ],
    [
      "desir",
      0.18
    ],
    [
      "intention",
      0.18
    ],
    [
      "resolution",
      0.18
    ],
    [
      "disposition",
      0.09
    ],
    [
      "soif",
      0.09
    ]
  ],
  "cher": [
    [
      "bon",
      0.14
    ],
    [
      "cheri",
      0.0775
    ],
    [
      "onereux",
      0.0775
    ],
    [
      "dispendieux",
      0.0625
    ],
    [
      "precieux",
      0.0625
    ],
    [
      "ruineux",
      0.045
    ],
    [
      "inabordable",
      0.045
    ],
    [
      "exorbitant",
      0.045
    ],
    [
      "couteux",
      0.045
    ],
    [
      "adore",
      0.045
    ],
    [
      "estimable",
      0.03
    ],
    [
      "doux",
      0.03
    ],
    [
      "aimable",
      0.03
    ],
    [
      "rare",
      0.015
    ],
    [
      "inestimable",
      0.015
    ],
    [
      "gros",
      0.015
    ],
    [
      "excellent",
      0.015
    ],
    [
      "cherot",
      0.015
    ],
    [
      "cherement",
      0.015
    ],
    [
      "chaud",
      0.015
    ],
    [
      "carissime",
      0.015
    ],
    [
      "aime",
      0.015
    ],
    [
      "agreable",
      0.015
    ],
    [
      "affectionne",
      0.015
    ],
    [
      "adule",
      0.015
    ],
    [
      "sale",
      0.015
    ]
  ],
  "trembler": [
    [
      "frissonner",
      0.1075
    ],
    [
      "vaciller",
      0.095
    ],
    [
      "fremir",
      0.0575
    ],
    [
      "remuer",
      0.0575
    ],
    [
      "s'agiter",
      0.0575
    ],
    [
      "vibrer",
      0.0475
    ],
    [
      "tremuler",
      0.0475
    ],
    [
      "trembloter",
      0.0475
    ],
    [
      "palpiter",
      0.0475
    ],
    [
      "osciller",
      0.0475
    ],
    [
      "chanceler",
      0.0375
    ],
    [
      "tressaillir",
      0.0375
    ],
    [
      "grelotter",
      0.0275
    ],
    [
      "trepider",
      0.0275
    ],
    [
      "tressauter",
      0.0175
    ],
    [
      "tituber",
      0.0175
    ],
    [
      "scintiller",
      0.0175
    ],
    [
      "s'affoler",
      0.0175
    ],
    [
      "panteler",
      0.0175
    ],
    [
      "clignoter",
      0.0175
    ],
    [
      "tremousser",
      0.0075
    ],
    [
      "s'etonner",
      0.0075
    ],
    [
      "s'epouvanter",
      0.0075
    ],
    [
      "redouter",
      0.0075
    ],
    [
      "petocher",
      0.0075
    ],
    [
      "flageoler",
      0.0075
    ],
    [
      "danser",
      0.0075
    ],
    [
      "craindre",
      0.0075
    ],
    [
      "chevroter",
      0.0075
    ],
    [
      "apprehender",
      0.0075
    ],
    [
      "ebranler",
      0.0075
    ]
  ],
  "village": [
    [
      "agglomeration",
      0.17
    ],
    [
      "bourg",
      0.12
    ],
    [
      "localite",
      0.0975
    ],
    [
      "commune",
      0.0725
    ],
    [
      "hameau",
      0.0725
    ],
    [
      "paroisse",
      0.0725
    ],
    [
      "patelin",
      0.0725
    ],
    [
      "trou",
      0.0725
    ],
    [
      "ville",
      0.0475
    ],
    [
      "bourgade",
      0.0475
    ],
    [
      "bled",
      0.0225
    ],
    [
      "cite",
      0.0225
    ],
    [
      "endroit",
      0.0225
    ],
    [
      "feux",
      0.0225
    ],
    [
      "menil",
      0.0225
    ]
  ],
  "toi": [],
  "fille": [
    [
      "tendron",
      0.18
    ],
    [
      "enfant",
      0.045
    ],
    [
      "demoiselle",
      0.0325
    ],
    [
      "celibataire",
      0.0325
    ],
    [
      "adolescente",
      0.0325
    ],
    [
      "vierge",
      0.02
    ],
    [
      "trottin",
      0.02
    ],
    [
      "pucelle",
      0.02
    ],
    [
      "poulette",
      0.02
    ],
    [
      "nana",
      0.02
    ],
    [
      "jouvencelle",
      0.02
    ],
    [
      "gosse",
      0.02
    ],
    [
      "fruit",
      0.02
    ],
    [
      "fillette",
      0.02
    ],
    [
      "biquette",
      0.02
    ],
    [
      "nymphe",
      0.01
    ],
    [
      "nonne",
      0.01
    ],
    [
      "muse",
      0.01
    ],
    [
      "mignonne",
      0.01
    ],
    [
      "midinette",
      0.01
    ],
    [
      "mademoiselle",
      0.01
    ],
    [
      "jeunesse",
      0.01
    ],
    [
      "heritiere",
      0.01
    ],
    [
      "nymphette",
      0.01
    ],
    [
      "nenette",
      0.01
    ],
    [
      "suivante",
      0.01
    ],
    [
      "souris",
      0.01
    ],
    [
      "soeur",
      0.01
    ],
    [
      "resultat",
      0.01
    ],
    [
      "rosiere",
      0.01
    ],
    [
      "religieuse",
      0.01
    ],
    [
      "quille",
      0.01
    ],
    [
      "petite",
      0.01
    ],
    [
      "gonzesse",
      0.01
    ],
    [
      "gazille",
      0.01
    ],
    [
      "garconne",
      0.01
    ],
    [
      "bambine",
      0.01
    ],
    [
      "blondinette",
      0.01
    ],
    [
      "bouchon",
      0.01
    ],
    [
      "brebis",
      0.01
    ],
    [
      "brunette",
      0.01
    ],
    [
      "catherinette",
      0.01
    ],
    [
      "colombe",
      0.01
    ],
    [
      "consequence",
      0.01
    ],
    [
      "coureuse",
      0.01
    ],
    [
      "courtisane",
      0.01
    ],
    [
      "descendant",
      0.01
    ],
    [
      "donzelle",
      0.01
    ],
    [
      "effet",
      0.01
    ],
    [
      "fillasse",
      0.01
    ],
    [
      "gamine",
      0.01
    ],
    [
      "bachelette",
      0.01
    ]
  ],
  "phenomene": [
    [
      "original",
      0.0775
    ],
    [
      "type",
      0.0775
    ],
    [
      "energumene",
      0.0575
    ],
    [
      "prodige",
      0.0575
    ],
    [
      "individu",
      0.0575
    ],
    [
      "bizarre",
      0.0575
    ],
    [
      "singularite",
      0.0375
    ],
    [
      "phenix",
      0.0375
    ],
    [
      "olibrius",
      0.0375
    ],
    [
      "merveille",
      0.0375
    ],
    [
      "lascar",
      0.0375
    ],
    [
      "fait",
      0.0375
    ],
    [
      "apparence",
      0.0375
    ],
    [
      "anomalie",
      0.0375
    ],
    [
      "mirage",
      0.0175
    ],
    [
      "monstre",
      0.0175
    ],
    [
      "monstruosite",
      0.0175
    ],
    [
      "ostrogoth",
      0.0175
    ],
    [
      "outil",
      0.0175
    ],
    [
      "rarete",
      0.0175
    ],
    [
      "miracle",
      0.0175
    ],
    [
      "manifestation",
      0.0175
    ],
    [
      "loustic",
      0.0175
    ],
    [
      "fable",
      0.0175
    ],
    [
      "excentrique",
      0.0175
    ],
    [
      "chose",
      0.0175
    ],
    [
      "aigle",
      0.0175
    ],
    [
      "accident",
      0.0175
    ],
    [
      "epiphenomene",
      0.0175
    ]
  ],
  "humain": [
    [
      "bon",
      0.1475
    ],
    [
      "charitable",
      0.065
    ],
    [
      "indulgent",
      0.065
    ],
    [
      "genereux",
      0.0575
    ],
    [
      "sensible",
      0.0475
    ],
    [
      "misericordieux",
      0.0475
    ],
    [
      "homme",
      0.0475
    ],
    [
      "compatissant",
      0.0475
    ],
    [
      "bienveillant",
      0.04
    ],
    [
      "etre",
      0.0225
    ],
    [
      "tendre",
      0.0225
    ],
    [
      "philanthrope",
      0.0225
    ],
    [
      "doux",
      0.0225
    ],
    [
      "comprehensif",
      0.0225
    ],
    [
      "benin",
      0.0225
    ],
    [
      "altruiste",
      0.0225
    ],
    [
      "tolerant",
      0.015
    ],
    [
      "pitoyable",
      0.015
    ],
    [
      "personne",
      0.015
    ],
    [
      "mortel",
      0.015
    ],
    [
      "delicat",
      0.015
    ],
    [
      "creature",
      0.015
    ],
    [
      "clement",
      0.015
    ],
    [
      "accessible",
      0.015
    ],
    [
      "individu",
      0.0075
    ],
    [
      "secourable",
      0.0075
    ],
    [
      "social",
      0.0075
    ],
    [
      "surhumain",
      0.0075
    ],
    [
      "terrestre",
      0.0075
    ],
    [
      "humanite",
      0.0075
    ],
    [
      "humanitaire",
      0.0075
    ],
    [
      "gens",
      0.0075
    ],
    [
      "esprit",
      0.0075
    ],
    [
      "empathique",
      0.0075
    ],
    [
      "comprehensible",
      0.0075
    ],
    [
      "bienfaisant",
      0.0075
    ],
    [
      "anthropien",
      0.0075
    ]
  ],
  "genre": [
    [
      "type",
      0.0875
    ],
    [
      "style",
      0.0625
    ],
    [
      "maniere",
      0.06
    ],
    [
      "air",
      0.055
    ],
    [
      "allure",
      0.0525
    ],
    [
      "tournure",
      0.0475
    ],
    [
      "forme",
      0.04
    ],
    [
      "comportement",
      0.035
    ],
    [
      "facon",
      0.0325
    ],
    [
      "caractere",
      0.03
    ],
    [
      "touche",
      0.03
    ],
    [
      "sorte",
      0.0275
    ],
    [
      "expression",
      0.0275
    ],
    [
      "espece",
      0.0275
    ],
    [
      "attitude",
      0.0275
    ],
    [
      "tenue",
      0.025
    ],
    [
      "ton",
      0.025
    ],
    [
      "exterieur",
      0.0175
    ],
    [
      "classe",
      0.0175
    ],
    [
      "aspect",
      0.0175
    ],
    [
      "nature",
      0.015
    ],
    [
      "marque",
      0.015
    ],
    [
      "griffe",
      0.015
    ],
    [
      "degaine",
      0.015
    ],
    [
      "conduite",
      0.015
    ],
    [
      "apparence",
      0.015
    ],
    [
      "categorie",
      0.0125
    ],
    [
      "ordre",
      0.0125
    ],
    [
      "gabarit",
      0.01
    ],
    [
      "acabit",
      0.0075
    ],
    [
      "variete",
      0.005
    ],
    [
      "ligne",
      0.005
    ],
    [
      "division",
      0.005
    ],
    [
      "affectation",
      0.005
    ],
    [
      "ecriture",
      0.0025
    ],
    [
      "race",
      0.0025
    ],
    [
      "plume",
      0.0025
    ],
    [
      "mode",
      0.0025
    ],
    [
      "manieres",
      0.0025
    ],
    [
      "famille",
      0.0025
    ],
    [
      "calibre",
      0.0025
    ],
    [
      "echantillon",
      0.0
    ],
    [
      "ideal",
      0.0
    ],
    [
      "gout",
      0.0
    ],
    [
      "farine",
      0.0
    ],
    [
      "embranchement",
      0.0
    ],
    [
      "domaine",
      0.0
    ],
    [
      "congenere",
      0.0
    ],
    [
      "concept",
      0.0
    ],
    [
      "etage",
      0.0
    ]
  ],
  "femme": [
    [
      "amante",
      0.11
    ],
    [
      "epouse",
      0.11
    ],
    [
      "nenette",
      0.0425
    ],
    [
      "maitresse",
      0.0425
    ],
    [
      "legitime",
      0.0425
    ],
    [
      "dame",
      0.0425
    ],
    [
      "bourgeoise",
      0.0425
    ],
    [
      "frangine",
      0.02
    ],
    [
      "matrone",
      0.02
    ],
    [
      "moitie",
      0.02
    ],
    [
      "mousme",
      0.02
    ],
    [
      "muse",
      0.02
    ],
    [
      "menesse",
      0.02
    ],
    [
      "nana",
      0.02
    ],
    [
      "personne",
      0.02
    ],
    [
      "rombiere",
      0.02
    ],
    [
      "reguliere",
      0.02
    ],
    [
      "femmelette",
      0.02
    ],
    [
      "femelle",
      0.02
    ],
    [
      "bobonne",
      0.02
    ],
    [
      "commere",
      0.02
    ],
    [
      "compagne",
      0.02
    ],
    [
      "concubine",
      0.02
    ],
    [
      "conjointe",
      0.02
    ],
    [
      "cotillon",
      0.02
    ],
    [
      "creature",
      0.02
    ],
    [
      "demoiselle",
      0.02
    ],
    [
      "donzelle",
      0.02
    ],
    [
      "egerie",
      0.02
    ]
  ],
  "change": [
    [
      "transformer",
      0.09
    ],
    [
      "alterer",
      0.055
    ],
    [
      "modifier",
      0.0375
    ],
    [
      "renouveler",
      0.0375
    ],
    [
      "tourner",
      0.03
    ],
    [
      "deplacer",
      0.025
    ],
    [
      "metamorphoser",
      0.025
    ],
    [
      "reformer",
      0.02
    ],
    [
      "deranger",
      0.02
    ],
    [
      "deguiser",
      0.02
    ],
    [
      "bouleverser",
      0.02
    ],
    [
      "evoluer",
      0.0175
    ],
    [
      "quitter",
      0.015
    ],
    [
      "passer",
      0.015
    ],
    [
      "frelater",
      0.015
    ],
    [
      "deformer",
      0.015
    ],
    [
      "corriger",
      0.015
    ],
    [
      "transposer",
      0.0125
    ],
    [
      "partir",
      0.0125
    ],
    [
      "fausser",
      0.0125
    ],
    [
      "denaturer",
      0.0125
    ],
    [
      "defigurer",
      0.0125
    ],
    [
      "convertir",
      0.0125
    ],
    [
      "contrefaire",
      0.0125
    ],
    [
      "varier",
      0.01
    ],
    [
      "truquer",
      0.01
    ],
    [
      "transmuer",
      0.01
    ],
    [
      "revolutionner",
      0.01
    ],
    [
      "remuer",
      0.01
    ],
    [
      "devier",
      0.01
    ],
    [
      "defaire",
      0.01
    ],
    [
      "devenir",
      0.01
    ],
    [
      "remanier",
      0.0075
    ],
    [
      "remplacer",
      0.0075
    ],
    [
      "travestir",
      0.0075
    ],
    [
      "ecarter",
      0.0075
    ],
    [
      "echanger",
      0.0075
    ],
    [
      "pervertir",
      0.0075
    ],
    [
      "intervertir",
      0.0075
    ],
    [
      "ameliorer",
      0.0075
    ],
    [
      "bouger",
      0.0075
    ],
    [
      "diminuer",
      0.0075
    ],
    [
      "degenerer",
      0.0075
    ],
    [
      "demenager",
      0.0075
    ],
    [
      "faire",
      0.0075
    ],
    [
      "glisser",
      0.0075
    ],
    [
      "rectifier",
      0.005
    ],
    [
      "renover",
      0.005
    ],
    [
      "substituer",
      0.005
    ],
    [
      "toucher",
      0.005
    ],
    [
      "transferer",
      0.005
    ],
    [
      "transplanter",
      0.005
    ],
    [
      "virer",
      0.005
    ],
    [
      "emigrer",
      0.005
    ],
    [
      "permuter",
      0.005
    ],
    [
      "papillonner",
      0.005
    ],
    [
      "alterner",
      0.005
    ],
    [
      "amender",
      0.005
    ],
    [
      "chambarder",
      0.005
    ],
    [
      "chambouler",
      0.005
    ],
    [
      "commuer",
      0.005
    ],
    [
      "distraire",
      0.005
    ],
    [
      "deloger",
      0.005
    ],
    [
      "innover",
      0.005
    ],
    [
      "inverser",
      0.005
    ],
    [
      "monnayer",
      0.005
    ],
    [
      "s'expatrier",
      0.0
    ],
    [
      "reduire",
      0.0
    ],
    [
      "reprendre",
      0.0
    ],
    [
      "transfigurer",
      0.0
    ],
    [
      "troquer",
      0.0
    ],
    [
      "voltiger",
      0.0
    ],
    [
      "renoncer",
      0.0
    ],
    [
      "remodeler",
      0.0
    ],
    [
      "aggraver",
      0.0
    ],
    [
      "bifurquer",
      0.0
    ],
    [
      "copermuter",
      0.0
    ],
    [
      "diversifier",
      0.0
    ],
    [
      "decaler",
      0.0
    ],
    [
      "delasser",
      0.0
    ],
    [
      "desacclimater",
      0.0
    ],
    [
      "desennuyer",
      0.0
    ],
    [
      "fluctuer",
      0.0
    ],
    [
      "muer",
      0.0
    ],
    [
      "muter",
      0.0
    ],
    [
      "murir",
      0.0
    ],
    [
      "refondre",
      0.0
    ],
    [
      "eriger",
      0.0
    ]
  ],
  "changer": [
    [
      "transformer",
      0.09
    ],
    [
      "alterer",
      0.055
    ],
    [
      "modifier",
      0.0375
    ],
    [
      "renouveler",
      0.0375
    ],
    [
      "tourner",
      0.03
    ],
    [
      "deplacer",
      0.025
    ],
    [
      "metamorphoser",
      0.025
    ],
    [
      "reformer",
      0.02
    ],
    [
      "deranger",
      0.02
    ],
    [
      "deguiser",
      0.02
    ],
    [
      "bouleverser",
      0.02
    ],
    [
      "evoluer",
      0.0175
    ],
    [
      "quitter",
      0.015
    ],
    [
      "passer",
      0.015
    ],
    [
      "frelater",
      0.015
    ],
    [
      "deformer",
      0.015
    ],
    [
      "corriger",
      0.015
    ],
    [
      "transposer",
      0.0125
    ],
    [
      "partir",
      0.0125
    ],
    [
      "fausser",
      0.0125
    ],
    [
      "denaturer",
      0.0125
    ],
    [
      "defigurer",
      0.0125
    ],
    [
      "convertir",
      0.0125
    ],
    [
      "contrefaire",
      0.0125
    ],
    [
      "varier",
      0.01
    ],
    [
      "truquer",
      0.01
    ],
    [
      "transmuer",
      0.01
    ],
    [
      "revolutionner",
      0.01
    ],
    [
      "remuer",
      0.01
    ],
    [
      "devier",
      0.01
    ],
    [
      "defaire",
      0.01
    ],
    [
      "devenir",
      0.01
    ],
    [
      "remanier",
      0.0075
    ],
    [
      "remplacer",
      0.0075
    ],
    [
      "travestir",
      0.0075
    ],
    [
      "ecarter",
      0.0075
    ],
    [
      "echanger",
      0.0075
    ],
    [
      "pervertir",
      0.0075
    ],
    [
      "intervertir",
      0.0075
    ],
    [
      "ameliorer",
      0.0075
    ],
    [
      "bouger",
      0.0075
    ],
    [
      "diminuer",
      0.0075
    ],
    [
      "degenerer",
      0.0075
    ],
    [
      "demenager",
      0.0075
    ],
    [
      "faire",
      0.0075
    ],
    [
      "glisser",
      0.0075
    ],
    [
      "rectifier",
      0.005
    ],
    [
      "renover",
      0.005
    ],
    [
      "substituer",
      0.005
    ],
    [
      "toucher",
      0.005
    ],
    [
      "transferer",
      0.005
    ],
    [
      "transplanter",
      0.005
    ],
    [
      "virer",
      0.005
    ],
    [
      "emigrer",
      0.005
    ],
    [
      "permuter",
      0.005
    ],
    [
      "papillonner",
      0.005
    ],
    [
      "alterner",
      0.005
    ],
    [
      "amender",
      0.005
    ],
    [
      "chambarder",
      0.005
    ],
    [
      "chambouler",
      0.005
    ],
    [
      "commuer",
      0.005
    ],
    [
      "distraire",
      0.005
    ],
    [
      "deloger",
      0.005
    ],
    [
      "innover",
      0.005
    ],
    [
      "inverser",
      0.005
    ],
    [
      "monnayer",
      0.005
    ],
    [
      "s'expatrier",
      0.0
    ],
    [
      "reduire",
      0.0
    ],
    [
      "reprendre",
      0.0
    ],
    [
      "transfigurer",
      0.0
    ],
    [
      "troquer",
      0.0
    ],
    [
      "voltiger",
      0.0
    ],
    [
      "renoncer",
      0.0
    ],
    [
      "remodeler",
      0.0
    ],
    [
      "aggraver",
      0.0
    ],
    [
      "bifurquer",
      0.0
    ],
    [
      "copermuter",
      0.0
    ],
    [
      "diversifier",
      0.0
    ],
    [
      "decaler",
      0.0
    ],
    [
      "delasser",
      0.0
    ],
    [
      "desacclimater",
      0.0
    ],
    [
      "desennuyer",
      0.0
    ],
    [
      "fluctuer",
      0.0
    ],
    [
      "muer",
      0.0
    ],
    [
      "muter",
      0.0
    ],
    [
      "murir",
      0.0
    ],
    [
      "refondre",
      0.0
    ],
    [
      "eriger",
      0.0
    ]
  ],
  "grand": [
    [
      "gros",
      0.0525
    ],
    [
      "beau",
      0.0425
    ],
    [
      "extraordinaire",
      0.0375
    ],
    [
      "enorme",
      0.0375
    ],
    [
      "important",
      0.035
    ],
    [
      "fort",
      0.0325
    ],
    [
      "immense",
      0.0275
    ],
    [
      "haut",
      0.0225
    ],
    [
      "considerable",
      0.0225
    ],
    [
      "excessif",
      0.0225
    ],
    [
      "superieur",
      0.02
    ],
    [
      "eminent",
      0.02
    ],
    [
      "vaste",
      0.02
    ],
    [
      "demesure",
      0.0175
    ],
    [
      "imposant",
      0.0175
    ],
    [
      "remarquable",
      0.0175
    ],
    [
      "terrible",
      0.015
    ],
    [
      "gigantesque",
      0.015
    ],
    [
      "fabuleux",
      0.015
    ],
    [
      "colossal",
      0.015
    ],
    [
      "extreme",
      0.015
    ],
    [
      "eleve",
      0.015
    ],
    [
      "bon",
      0.015
    ],
    [
      "fameux",
      0.015
    ],
    [
      "noble",
      0.015
    ],
    [
      "puissant",
      0.0125
    ],
    [
      "violent",
      0.01
    ],
    [
      "profond",
      0.01
    ],
    [
      "large",
      0.01
    ],
    [
      "intense",
      0.01
    ],
    [
      "magnifique",
      0.01
    ],
    [
      "monstrueux",
      0.01
    ],
    [
      "sensationnel",
      0.01
    ],
    [
      "monumental",
      0.0075
    ],
    [
      "abondant",
      0.0075
    ],
    [
      "grandiose",
      0.0075
    ],
    [
      "genereux",
      0.0075
    ],
    [
      "illustre",
      0.0075
    ],
    [
      "marquant",
      0.0075
    ],
    [
      "sublime",
      0.0075
    ],
    [
      "infini",
      0.0075
    ],
    [
      "genial",
      0.0075
    ],
    [
      "glorieux",
      0.0075
    ],
    [
      "fier",
      0.0075
    ],
    [
      "exagere",
      0.0075
    ],
    [
      "distingue",
      0.0075
    ],
    [
      "retentissant",
      0.005
    ],
    [
      "furieux",
      0.005
    ],
    [
      "ample",
      0.005
    ],
    [
      "titanesque",
      0.005
    ],
    [
      "supreme",
      0.005
    ],
    [
      "prestigieux",
      0.005
    ],
    [
      "memorable",
      0.005
    ],
    [
      "magistral",
      0.005
    ],
    [
      "incommensurable",
      0.005
    ],
    [
      "effrayant",
      0.005
    ],
    [
      "architectural",
      0.005
    ],
    [
      "epouvantable",
      0.005
    ],
    [
      "etendu",
      0.0025
    ],
    [
      "principal",
      0.0025
    ],
    [
      "notabilite",
      0.0025
    ],
    [
      "long",
      0.0025
    ],
    [
      "interminable",
      0.0025
    ],
    [
      "geant",
      0.0025
    ],
    [
      "transcendant",
      0.0025
    ],
    [
      "sacre",
      0.0025
    ],
    [
      "repute",
      0.0025
    ],
    [
      "rude",
      0.0025
    ],
    [
      "personnalite",
      0.0025
    ],
    [
      "majeur",
      0.0025
    ],
    [
      "incomparable",
      0.0025
    ],
    [
      "essentiel",
      0.0025
    ],
    [
      "courageux",
      0.0025
    ],
    [
      "spacieux",
      0.0025
    ],
    [
      "sommite",
      0.0025
    ],
    [
      "puissance",
      0.0025
    ],
    [
      "nombreux",
      0.0025
    ],
    [
      "forcene",
      0.0025
    ],
    [
      "excellent",
      0.0025
    ],
    [
      "effroyable",
      0.0025
    ],
    [
      "astronomique",
      0.0025
    ],
    [
      "rondelet",
      0.0
    ],
    [
      "seigneur",
      0.0
    ],
    [
      "vif",
      0.0
    ],
    [
      "age",
      0.0
    ],
    [
      "echalas",
      0.0
    ],
    [
      "personnage",
      0.0
    ],
    [
      "magnat",
      0.0
    ],
    [
      "illimite",
      0.0
    ],
    [
      "coquet",
      0.0
    ],
    [
      "cyclopeen",
      0.0
    ],
    [
      "emphatique",
      0.0
    ],
    [
      "glacial",
      0.0
    ],
    [
      "heros",
      0.0
    ],
    [
      "escogriffe",
      0.0
    ],
    [
      "grandeur",
      0.0
    ],
    [
      "grandiloquent",
      0.0
    ],
    [
      "legendaire",
      0.0
    ],
    [
      "mur",
      0.0
    ],
    [
      "perche",
      0.0
    ],
    [
      "robuste",
      0.0
    ],
    [
      "surprenant",
      0.0
    ],
    [
      "elance",
      0.0
    ],
    [
      "developpe",
      0.0
    ],
    [
      "dechaine",
      0.0
    ],
    [
      "confortable",
      0.0
    ],
    [
      "acharne",
      0.0
    ],
    [
      "adulte",
      0.0
    ],
    [
      "appreciable",
      0.0
    ],
    [
      "aristocrate",
      0.0
    ],
    [
      "aristocratique",
      0.0
    ],
    [
      "auguste",
      0.0
    ],
    [
      "aine",
      0.0
    ],
    [
      "baleze",
      0.0
    ],
    [
      "baraque",
      0.0
    ],
    [
      "industriel",
      0.0
    ],
    [
      "influent",
      0.0
    ],
    [
      "invetere",
      0.0
    ],
    [
      "longiligne",
      0.0
    ],
    [
      "magnanime",
      0.0
    ],
    [
      "meilleur",
      0.0
    ],
    [
      "prolonge",
      0.0
    ],
    [
      "talentueux",
      0.0
    ],
    [
      "trapu",
      0.0
    ],
    [
      "triple",
      0.0
    ],
    [
      "immensurable",
      0.0
    ],
    [
      "grandement",
      0.0
    ],
    [
      "gouvernant",
      0.0
    ],
    [
      "alarmant",
      0.0
    ],
    [
      "asperge",
      0.0
    ],
    [
      "assourdissant",
      0.0
    ],
    [
      "atroce",
      0.0
    ],
    [
      "avance",
      0.0
    ],
    [
      "beant",
      0.0
    ],
    [
      "caniculaire",
      0.0
    ],
    [
      "consequent",
      0.0
    ],
    [
      "demiurge",
      0.0
    ],
    [
      "fieffe",
      0.0
    ],
    [
      "fils",
      0.0
    ],
    [
      "etouffant",
      0.0
    ]
  ],
  "delinquant": [
    [
      "antisocial",
      0.165
    ],
    [
      "coupable",
      0.165
    ],
    [
      "devoye",
      0.165
    ],
    [
      "fautif",
      0.165
    ],
    [
      "inadapte",
      0.165
    ],
    [
      "mino",
      0.165
    ]
  ],
  "gentleman": [
    [
      "gentilhomme",
      0.165
    ]
  ],
  "beaute": [
    [
      "charme",
      0.055
    ],
    [
      "grace",
      0.055
    ],
    [
      "eclat",
      0.055
    ],
    [
      "splendeur",
      0.04
    ],
    [
      "grandeur",
      0.035
    ],
    [
      "elegance",
      0.035
    ],
    [
      "magnificence",
      0.03
    ],
    [
      "perfection",
      0.0275
    ],
    [
      "delicatesse",
      0.0275
    ],
    [
      "bonte",
      0.0275
    ],
    [
      "beau",
      0.0275
    ],
    [
      "agrement",
      0.0275
    ],
    [
      "appas",
      0.0225
    ],
    [
      "brillant",
      0.0225
    ],
    [
      "richesse",
      0.0175
    ],
    [
      "purete",
      0.0175
    ],
    [
      "piquant",
      0.0175
    ],
    [
      "noblesse",
      0.0175
    ],
    [
      "majeste",
      0.0175
    ],
    [
      "lustre",
      0.0175
    ],
    [
      "generosite",
      0.0175
    ],
    [
      "gloire",
      0.0175
    ],
    [
      "force",
      0.0175
    ],
    [
      "fleur",
      0.0175
    ],
    [
      "distinction",
      0.0175
    ],
    [
      "elevation",
      0.0125
    ],
    [
      "seduction",
      0.0125
    ],
    [
      "simplicite",
      0.0125
    ],
    [
      "profondeur",
      0.0125
    ],
    [
      "joliesse",
      0.0125
    ],
    [
      "harmonie",
      0.0125
    ],
    [
      "finesse",
      0.0125
    ],
    [
      "bijou",
      0.0125
    ],
    [
      "magnanimite",
      0.0075
    ],
    [
      "poesie",
      0.0075
    ],
    [
      "somptuosite",
      0.0075
    ],
    [
      "sublimite",
      0.0075
    ],
    [
      "magie",
      0.0075
    ],
    [
      "lumiere",
      0.0075
    ],
    [
      "feerie",
      0.0075
    ],
    [
      "fraicheur",
      0.0075
    ],
    [
      "faste",
      0.0075
    ],
    [
      "charmes",
      0.0075
    ],
    [
      "attrait",
      0.0075
    ],
    [
      "art",
      0.0075
    ],
    [
      "proportion",
      0.0025
    ],
    [
      "star",
      0.0025
    ],
    [
      "symetrie",
      0.0025
    ],
    [
      "tresors",
      0.0025
    ],
    [
      "venus",
      0.0025
    ],
    [
      "parfum",
      0.0025
    ],
    [
      "nu",
      0.0025
    ],
    [
      "joyau",
      0.0025
    ],
    [
      "forme",
      0.0025
    ],
    [
      "esthetique",
      0.0025
    ],
    [
      "deesse",
      0.0025
    ],
    [
      "belle",
      0.0025
    ],
    [
      "aphrodite",
      0.0025
    ],
    [
      "venuste",
      0.0025
    ]
  ],
  "pareil": [
    [
      "semblable",
      0.1775
    ],
    [
      "identique",
      0.1075
    ],
    [
      "similaire",
      0.0975
    ],
    [
      "analogue",
      0.0875
    ],
    [
      "meme",
      0.0575
    ],
    [
      "egal",
      0.0575
    ],
    [
      "equivalent",
      0.0575
    ],
    [
      "comparable",
      0.0475
    ],
    [
      "assimile",
      0.0275
    ],
    [
      "homogene",
      0.0275
    ],
    [
      "homologue",
      0.0275
    ],
    [
      "jumeau",
      0.0275
    ],
    [
      "uniforme",
      0.0175
    ],
    [
      "tel",
      0.0175
    ],
    [
      "parallele",
      0.0175
    ],
    [
      "conforme",
      0.0175
    ],
    [
      "synonyme",
      0.0075
    ],
    [
      "replique",
      0.0075
    ],
    [
      "reciproque",
      0.0075
    ],
    [
      "ressemblant",
      0.0075
    ],
    [
      "pareillement",
      0.0075
    ],
    [
      "pair",
      0.0075
    ],
    [
      "gemeau",
      0.0075
    ],
    [
      "congenere",
      0.0075
    ]
  ],
  "emparer": [],
  "mener": [
    [
      "conduire",
      0.14
    ],
    [
      "diriger",
      0.075
    ],
    [
      "gouverner",
      0.055
    ],
    [
      "entrainer",
      0.045
    ],
    [
      "pousser",
      0.0375
    ],
    [
      "transporter",
      0.0325
    ],
    [
      "regenter",
      0.0325
    ],
    [
      "manier",
      0.0325
    ],
    [
      "animer",
      0.0275
    ],
    [
      "guider",
      0.0275
    ],
    [
      "manoeuvrer",
      0.0275
    ],
    [
      "trainer",
      0.0275
    ],
    [
      "agir",
      0.025
    ],
    [
      "tenir",
      0.02
    ],
    [
      "inspirer",
      0.02
    ],
    [
      "emmener",
      0.02
    ],
    [
      "commander",
      0.02
    ],
    [
      "amener",
      0.02
    ],
    [
      "regir",
      0.015
    ],
    [
      "mettre",
      0.015
    ],
    [
      "influencer",
      0.015
    ],
    [
      "administrer",
      0.015
    ],
    [
      "traiter",
      0.0125
    ],
    [
      "presenter",
      0.0125
    ],
    [
      "promener",
      0.0125
    ],
    [
      "piloter",
      0.0125
    ],
    [
      "manipuler",
      0.0125
    ],
    [
      "dominer",
      0.0125
    ],
    [
      "avoir",
      0.0125
    ],
    [
      "tyranniser",
      0.0075
    ],
    [
      "traduire",
      0.0075
    ],
    [
      "suggestionner",
      0.0075
    ],
    [
      "remmener",
      0.0075
    ],
    [
      "remener",
      0.0075
    ],
    [
      "ramener",
      0.0075
    ],
    [
      "embarquer",
      0.0075
    ],
    [
      "conclure",
      0.0075
    ],
    [
      "charrier",
      0.0075
    ],
    [
      "aller",
      0.0075
    ],
    [
      "aboutir",
      0.0075
    ],
    [
      "trimballer",
      0.0025
    ],
    [
      "supporter",
      0.0025
    ],
    [
      "superviser",
      0.0025
    ],
    [
      "soutenir",
      0.0025
    ],
    [
      "manigancer",
      0.0025
    ],
    [
      "deboucher",
      0.0025
    ],
    [
      "commencer",
      0.0025
    ],
    [
      "vehiculer",
      0.0025
    ]
  ],
  "bateau": [
    [
      "mensonge",
      0.06
    ],
    [
      "barque",
      0.055
    ],
    [
      "embarcation",
      0.055
    ],
    [
      "conte",
      0.0475
    ],
    [
      "blague",
      0.04
    ],
    [
      "canot",
      0.035
    ],
    [
      "bourde",
      0.03
    ],
    [
      "tromperie",
      0.03
    ],
    [
      "roman",
      0.025
    ],
    [
      "histoire",
      0.025
    ],
    [
      "canular",
      0.025
    ],
    [
      "bobard",
      0.02
    ],
    [
      "chaloupe",
      0.02
    ],
    [
      "farce",
      0.02
    ],
    [
      "mystification",
      0.02
    ],
    [
      "peniche",
      0.015
    ],
    [
      "plaisanterie",
      0.015
    ],
    [
      "navire",
      0.015
    ],
    [
      "invention",
      0.015
    ],
    [
      "coche",
      0.015
    ],
    [
      "chanson",
      0.015
    ],
    [
      "chaland",
      0.015
    ],
    [
      "batiment",
      0.015
    ],
    [
      "vaisseau",
      0.0125
    ],
    [
      "steamer",
      0.0125
    ],
    [
      "ruse",
      0.0125
    ],
    [
      "imposture",
      0.0125
    ],
    [
      "boniment",
      0.0125
    ],
    [
      "barge",
      0.0125
    ],
    [
      "bac",
      0.0125
    ],
    [
      "attrape",
      0.0125
    ],
    [
      "nacelle",
      0.0075
    ],
    [
      "nef",
      0.0075
    ],
    [
      "pirogue",
      0.0075
    ],
    [
      "radotage",
      0.0075
    ],
    [
      "transatlantique",
      0.0075
    ],
    [
      "intrigue",
      0.0075
    ],
    [
      "fourberie",
      0.0075
    ],
    [
      "belandre",
      0.0075
    ],
    [
      "calembredaine",
      0.0075
    ],
    [
      "canoe",
      0.0075
    ],
    [
      "craque",
      0.0075
    ],
    [
      "dada",
      0.0075
    ],
    [
      "topique",
      0.0025
    ],
    [
      "steamboat",
      0.0025
    ],
    [
      "soulier",
      0.0025
    ],
    [
      "rafiot",
      0.0025
    ],
    [
      "perissoire",
      0.0025
    ],
    [
      "paquebot",
      0.0025
    ],
    [
      "marotte",
      0.0025
    ],
    [
      "toue",
      0.0025
    ],
    [
      "transport",
      0.0025
    ],
    [
      "youyou",
      0.0025
    ],
    [
      "yole",
      0.0025
    ],
    [
      "yachting",
      0.0025
    ],
    [
      "yacht",
      0.0025
    ],
    [
      "voile",
      0.0025
    ],
    [
      "vedette",
      0.0025
    ],
    [
      "vapeur",
      0.0025
    ],
    [
      "unite",
      0.0025
    ],
    [
      "manie",
      0.0025
    ],
    [
      "lubie",
      0.0025
    ],
    [
      "baleiniere",
      0.0025
    ],
    [
      "banal",
      0.0025
    ],
    [
      "banalite",
      0.0025
    ],
    [
      "cabane",
      0.0025
    ],
    [
      "caboteur",
      0.0025
    ],
    [
      "cabotiere",
      0.0025
    ],
    [
      "caravelle",
      0.0025
    ],
    [
      "cargo",
      0.0025
    ],
    [
      "chalutier",
      0.0025
    ],
    [
      "chaussure",
      0.0025
    ],
    [
      "cliche",
      0.0025
    ],
    [
      "courrier",
      0.0025
    ],
    [
      "esquif",
      0.0025
    ],
    [
      "gabare",
      0.0025
    ],
    [
      "gondole",
      0.0025
    ],
    [
      "arche",
      0.0025
    ]
  ],
  "demander": [
    [
      "revendiquer",
      0.0825
    ],
    [
      "solliciter",
      0.0775
    ],
    [
      "requerir",
      0.0725
    ],
    [
      "reclamer",
      0.0525
    ],
    [
      "exiger",
      0.0475
    ],
    [
      "sommer",
      0.04
    ],
    [
      "prier",
      0.0375
    ],
    [
      "vouloir",
      0.035
    ],
    [
      "appeler",
      0.0325
    ],
    [
      "commander",
      0.0325
    ],
    [
      "souhaiter",
      0.03
    ],
    [
      "ordonner",
      0.0275
    ],
    [
      "prescrire",
      0.025
    ],
    [
      "interroger",
      0.025
    ],
    [
      "desirer",
      0.025
    ],
    [
      "enjoindre",
      0.0225
    ],
    [
      "supplier",
      0.0225
    ],
    [
      "recommander",
      0.02
    ],
    [
      "chercher",
      0.0175
    ],
    [
      "interpeller",
      0.0175
    ],
    [
      "rechercher",
      0.015
    ],
    [
      "inviter",
      0.015
    ],
    [
      "implorer",
      0.015
    ],
    [
      "dire",
      0.015
    ],
    [
      "questionner",
      0.0125
    ],
    [
      "s'enquerir",
      0.0125
    ],
    [
      "sonder",
      0.0125
    ],
    [
      "queter",
      0.01
    ],
    [
      "pretendre",
      0.01
    ],
    [
      "quemander",
      0.0075
    ],
    [
      "necessiter",
      0.0075
    ],
    [
      "mander",
      0.0075
    ],
    [
      "imposer",
      0.0075
    ],
    [
      "briguer",
      0.0075
    ],
    [
      "adjurer",
      0.0075
    ],
    [
      "s'adresser",
      0.005
    ],
    [
      "meriter",
      0.005
    ],
    [
      "insister",
      0.005
    ],
    [
      "convier",
      0.005
    ],
    [
      "consulter",
      0.005
    ],
    [
      "aimer",
      0.005
    ],
    [
      "redemander",
      0.0
    ],
    [
      "petitionner",
      0.0
    ],
    [
      "presenter",
      0.0
    ],
    [
      "postuler",
      0.0
    ],
    [
      "mendier",
      0.0
    ],
    [
      "cuisiner",
      0.0
    ],
    [
      "conjurer",
      0.0
    ]
  ],
  "puis": [
    [
      "alors",
      0.2
    ],
    [
      "apres",
      0.2
    ],
    [
      "ensuite",
      0.2
    ],
    [
      "et",
      0.2
    ],
    [
      "subsequemment",
      0.2
    ]
  ],
  "aussitot": [
    [
      "immediatement",
      0.145
    ],
    [
      "soudain",
      0.11
    ],
    [
      "incontinent",
      0.065
    ],
    [
      "d'emblee",
      0.055
    ],
    [
      "instantanement",
      0.0425
    ],
    [
      "illico",
      0.0325
    ],
    [
      "tot",
      0.01
    ],
    [
      "sitot",
      0.01
    ],
    [
      "incessamment",
      0.01
    ],
    [
      "des",
      0.01
    ],
    [
      "d'abord",
      0.01
    ]
  ],
  "demarrer": [
    [
      "commencer",
      0.24
    ],
    [
      "partir",
      0.1375
    ],
    [
      "debuter",
      0.1025
    ],
    [
      "entreprendre",
      0.0675
    ],
    [
      "s'engager",
      0.0675
    ],
    [
      "quitter",
      0.0325
    ],
    [
      "s'amorcer",
      0.0325
    ],
    [
      "s'emmancher",
      0.0325
    ],
    [
      "desamarrer",
      0.0325
    ],
    [
      "demordre",
      0.0325
    ],
    [
      "decamper",
      0.0325
    ],
    [
      "appareiller",
      0.0325
    ],
    [
      "amorcer",
      0.0325
    ]
  ],
  "impressionner": [
    [
      "emouvoir",
      0.11
    ],
    [
      "bouleverser",
      0.0975
    ],
    [
      "troubler",
      0.075
    ],
    [
      "frapper",
      0.0675
    ],
    [
      "secouer",
      0.0575
    ],
    [
      "remuer",
      0.05
    ],
    [
      "eblouir",
      0.05
    ],
    [
      "saisir",
      0.045
    ],
    [
      "ebranler",
      0.045
    ],
    [
      "toucher",
      0.04
    ],
    [
      "imposer",
      0.0325
    ],
    [
      "empoigner",
      0.0275
    ],
    [
      "retourner",
      0.0275
    ],
    [
      "epater",
      0.0275
    ],
    [
      "fasciner",
      0.0225
    ],
    [
      "etonner",
      0.0225
    ],
    [
      "emotionner",
      0.015
    ],
    [
      "intimider",
      0.015
    ],
    [
      "faire",
      0.015
    ],
    [
      "briller",
      0.015
    ],
    [
      "subjuguer",
      0.01
    ],
    [
      "revolutionner",
      0.01
    ],
    [
      "piquer",
      0.01
    ],
    [
      "parler",
      0.01
    ],
    [
      "esbroufer",
      0.01
    ],
    [
      "agir",
      0.01
    ],
    [
      "influencer",
      0.005
    ],
    [
      "exposer",
      0.005
    ],
    [
      "effrayer",
      0.005
    ],
    [
      "affecter",
      0.005
    ],
    [
      "eclabousser",
      0.005
    ]
  ],
  "devenir": [
    [
      "changement",
      0.2125
    ],
    [
      "mouvement",
      0.2125
    ],
    [
      "transformation",
      0.1425
    ],
    [
      "evolution",
      0.1425
    ],
    [
      "dynamisme",
      0.07
    ],
    [
      "futur",
      0.07
    ],
    [
      "mouvant",
      0.07
    ],
    [
      "mutation",
      0.07
    ]
  ],
  "preferer": [
    [
      "aimer",
      0.1
    ],
    [
      "choisir",
      0.1
    ],
    [
      "distinguer",
      0.1
    ],
    [
      "opter",
      0.1
    ],
    [
      "pencher",
      0.1
    ],
    [
      "selectionner",
      0.1
    ],
    [
      "predilectionner",
      0.0475
    ],
    [
      "incliner",
      0.0475
    ],
    [
      "estimer",
      0.0475
    ],
    [
      "entendre",
      0.0475
    ],
    [
      "cherir",
      0.0475
    ],
    [
      "adopter",
      0.0475
    ],
    [
      "elire",
      0.0475
    ]
  ],
  "prefere": [
    [
      "aimer",
      0.1
    ],
    [
      "choisir",
      0.1
    ],
    [
      "distinguer",
      0.1
    ],
    [
      "opter",
      0.1
    ],
    [
      "pencher",
      0.1
    ],
    [
      "selectionner",
      0.1
    ],
    [
      "predilectionner",
      0.0475
    ],
    [
      "incliner",
      0.0475
    ],
    [
      "estimer",
      0.0475
    ],
    [
      "entendre",
      0.0475
    ],
    [
      "cherir",
      0.0475
    ],
    [
      "adopter",
      0.0475
    ],
    [
      "elire",
      0.0475
    ]
  ],
  "danser": [
    [
      "balancer",
      0.0925
    ],
    [
      "tanguer",
      0.0625
    ],
    [
      "sautiller",
      0.0625
    ],
    [
      "sauter",
      0.0625
    ],
    [
      "s'agiter",
      0.0625
    ],
    [
      "giguer",
      0.0625
    ],
    [
      "gigoter",
      0.0625
    ],
    [
      "gambiller",
      0.0625
    ],
    [
      "gambader",
      0.0625
    ],
    [
      "baller",
      0.0625
    ],
    [
      "twister",
      0.03
    ],
    [
      "trembler",
      0.03
    ],
    [
      "jerker",
      0.03
    ],
    [
      "guincher",
      0.03
    ],
    [
      "dansotter",
      0.03
    ],
    [
      "chalouper",
      0.03
    ],
    [
      "branler",
      0.03
    ],
    [
      "valser",
      0.03
    ]
  ],
  "soir": [
    [
      "crepuscule",
      0.2175
    ],
    [
      "soiree",
      0.13
    ],
    [
      "brune",
      0.085
    ],
    [
      "couchant",
      0.085
    ],
    [
      "coucher",
      0.085
    ],
    [
      "declin",
      0.085
    ],
    [
      "vepres",
      0.0425
    ],
    [
      "veillee",
      0.0425
    ],
    [
      "fin",
      0.0425
    ],
    [
      "vepree",
      0.0425
    ]
  ],
  "aimer": [
    [
      "gouter",
      0.0575
    ],
    [
      "s'eprendre",
      0.0575
    ],
    [
      "cherir",
      0.05
    ],
    [
      "adorer",
      0.045
    ],
    [
      "apprecier",
      0.045
    ],
    [
      "affectionner",
      0.0375
    ],
    [
      "admirer",
      0.03
    ],
    [
      "estimer",
      0.03
    ],
    [
      "raffoler",
      0.03
    ],
    [
      "venerer",
      0.03
    ],
    [
      "vouloir",
      0.025
    ],
    [
      "s'enticher",
      0.025
    ],
    [
      "s'interesser",
      0.0175
    ],
    [
      "s'amouracher",
      0.0175
    ],
    [
      "desirer",
      0.0175
    ],
    [
      "s'emouvoir",
      0.0125
    ],
    [
      "s'attacher",
      0.0125
    ],
    [
      "preferer",
      0.0125
    ],
    [
      "mordre",
      0.0125
    ],
    [
      "demander",
      0.0125
    ],
    [
      "s'embeguiner",
      0.005
    ],
    [
      "s'embraser",
      0.005
    ],
    [
      "reclamer",
      0.005
    ],
    [
      "roucouler",
      0.005
    ],
    [
      "s'enamourer",
      0.005
    ],
    [
      "s'enflammer",
      0.005
    ],
    [
      "pincer",
      0.005
    ],
    [
      "gober",
      0.005
    ],
    [
      "idolatrer",
      0.005
    ]
  ],
  "chaise": [
    [
      "brancard",
      0.1675
    ],
    [
      "siege",
      0.0825
    ],
    [
      "selle",
      0.0825
    ],
    [
      "palanquin",
      0.0825
    ],
    [
      "filanzane",
      0.0825
    ],
    [
      "dormeuse",
      0.0825
    ],
    [
      "coche",
      0.0825
    ],
    [
      "chauffeuse",
      0.0825
    ],
    [
      "caquetoire",
      0.0825
    ],
    [
      "brouette",
      0.0825
    ],
    [
      "vinaigrette",
      0.0825
    ]
  ],
  "laquelle": [
    [
      "dont",
      0.5
    ],
    [
      "quoi",
      0.5
    ]
  ],
  "rien": [
    [
      "bagatelle",
      0.135
    ],
    [
      "futilite",
      0.08
    ],
    [
      "babiole",
      0.0675
    ],
    [
      "bricole",
      0.0575
    ],
    [
      "frivolite",
      0.0575
    ],
    [
      "vetille",
      0.0475
    ],
    [
      "broutille",
      0.04
    ],
    [
      "misere",
      0.035
    ],
    [
      "niaiserie",
      0.035
    ],
    [
      "neant",
      0.03
    ],
    [
      "baliverne",
      0.03
    ],
    [
      "fumee",
      0.025
    ],
    [
      "betise",
      0.02
    ],
    [
      "pas",
      0.02
    ],
    [
      "vide",
      0.02
    ],
    [
      "insignifiance",
      0.015
    ],
    [
      "foutaise",
      0.015
    ],
    [
      "brimborion",
      0.015
    ],
    [
      "poussiere",
      0.01
    ],
    [
      "point",
      0.01
    ],
    [
      "minutie",
      0.01
    ],
    [
      "inanite",
      0.01
    ],
    [
      "fetu",
      0.01
    ],
    [
      "fichaise",
      0.01
    ],
    [
      "bibelot",
      0.01
    ],
    [
      "macache",
      0.005
    ],
    [
      "mie",
      0.005
    ],
    [
      "non",
      0.005
    ],
    [
      "nul",
      0.005
    ],
    [
      "oualou",
      0.005
    ],
    [
      "rudement",
      0.005
    ],
    [
      "tres",
      0.005
    ],
    [
      "vachement",
      0.005
    ],
    [
      "zero",
      0.005
    ],
    [
      "goutte",
      0.005
    ],
    [
      "gnognotte",
      0.005
    ],
    [
      "fifrelin",
      0.005
    ],
    [
      "aucunement",
      0.005
    ],
    [
      "bernique",
      0.005
    ],
    [
      "bibus",
      0.005
    ],
    [
      "breloque",
      0.005
    ],
    [
      "broquille",
      0.005
    ],
    [
      "chose",
      0.005
    ],
    [
      "colifichet",
      0.005
    ],
    [
      "drolement",
      0.005
    ],
    [
      "desert",
      0.005
    ],
    [
      "absence",
      0.005
    ]
  ],
  "pierre": [
    [
      "roche",
      0.065
    ],
    [
      "calcaire",
      0.045
    ],
    [
      "gemme",
      0.045
    ],
    [
      "caillou",
      0.04
    ],
    [
      "calcul",
      0.03
    ],
    [
      "calcedoine",
      0.025
    ],
    [
      "quartz",
      0.0175
    ],
    [
      "moellon",
      0.0175
    ],
    [
      "minerai",
      0.0175
    ],
    [
      "grenat",
      0.0175
    ],
    [
      "gravier",
      0.0175
    ],
    [
      "diamant",
      0.0175
    ],
    [
      "chrysolithe",
      0.0175
    ],
    [
      "marbre",
      0.0125
    ],
    [
      "pave",
      0.0125
    ],
    [
      "roc",
      0.0125
    ],
    [
      "rubis",
      0.0125
    ],
    [
      "stele",
      0.0125
    ],
    [
      "tombe",
      0.0125
    ],
    [
      "tuf",
      0.0125
    ],
    [
      "zircon",
      0.0125
    ],
    [
      "emeraude",
      0.0125
    ],
    [
      "jaspe",
      0.0125
    ],
    [
      "hyacinthe",
      0.0125
    ],
    [
      "happelourde",
      0.0125
    ],
    [
      "agate",
      0.0125
    ],
    [
      "alabandine",
      0.0125
    ],
    [
      "amethyste",
      0.0125
    ],
    [
      "caillasse",
      0.0125
    ],
    [
      "corindon",
      0.0125
    ],
    [
      "escarboucle",
      0.0125
    ],
    [
      "galet",
      0.0125
    ],
    [
      "granit",
      0.0125
    ],
    [
      "gravelle",
      0.0125
    ],
    [
      "pechblende",
      0.005
    ],
    [
      "parpaing",
      0.005
    ],
    [
      "palet",
      0.005
    ],
    [
      "onyx",
      0.005
    ],
    [
      "meteorite",
      0.005
    ],
    [
      "mineral",
      0.005
    ],
    [
      "meuliere",
      0.005
    ],
    [
      "malachite",
      0.005
    ],
    [
      "lithiase",
      0.005
    ],
    [
      "libage",
      0.005
    ],
    [
      "liais",
      0.005
    ],
    [
      "pierraille",
      0.005
    ],
    [
      "ponce",
      0.005
    ],
    [
      "peridot",
      0.005
    ],
    [
      "tuffeau",
      0.005
    ],
    [
      "travertin",
      0.005
    ],
    [
      "topaze",
      0.005
    ],
    [
      "sepulture",
      0.005
    ],
    [
      "strass",
      0.005
    ],
    [
      "spinelle",
      0.005
    ],
    [
      "solitaire",
      0.005
    ],
    [
      "silex",
      0.005
    ],
    [
      "saphir",
      0.005
    ],
    [
      "sable",
      0.005
    ],
    [
      "rocher",
      0.005
    ],
    [
      "lazulite",
      0.005
    ],
    [
      "cliquart",
      0.005
    ],
    [
      "chrysoprase",
      0.005
    ],
    [
      "bezoard",
      0.005
    ],
    [
      "beryl",
      0.005
    ],
    [
      "brillant",
      0.005
    ],
    [
      "boutisse",
      0.005
    ],
    [
      "borne",
      0.005
    ],
    [
      "bolide",
      0.005
    ],
    [
      "bauxite",
      0.005
    ],
    [
      "aerolithe",
      0.005
    ],
    [
      "aventurine",
      0.005
    ],
    [
      "concretion",
      0.005
    ],
    [
      "coquillart",
      0.005
    ],
    [
      "lapilli",
      0.005
    ],
    [
      "lambourde",
      0.005
    ],
    [
      "jargon",
      0.005
    ],
    [
      "jade",
      0.005
    ],
    [
      "jacinthe",
      0.005
    ],
    [
      "hippolithe",
      0.005
    ],
    [
      "gypse",
      0.005
    ],
    [
      "gres",
      0.005
    ],
    [
      "doublet",
      0.005
    ],
    [
      "dalle",
      0.005
    ],
    [
      "cornaline",
      0.005
    ]
  ],
  "chemin": [
    [
      "voie",
      0.12
    ],
    [
      "route",
      0.0725
    ],
    [
      "sentier",
      0.0675
    ],
    [
      "passage",
      0.0625
    ],
    [
      "trajet",
      0.0625
    ],
    [
      "avenue",
      0.045
    ],
    [
      "parcours",
      0.04
    ],
    [
      "allee",
      0.04
    ],
    [
      "rue",
      0.0275
    ],
    [
      "chaussee",
      0.02
    ],
    [
      "etape",
      0.015
    ],
    [
      "methode",
      0.015
    ],
    [
      "moyen",
      0.015
    ],
    [
      "laie",
      0.015
    ],
    [
      "itineraire",
      0.015
    ],
    [
      "direction",
      0.015
    ],
    [
      "course",
      0.015
    ],
    [
      "couloir",
      0.015
    ],
    [
      "conduit",
      0.015
    ],
    [
      "artere",
      0.015
    ],
    [
      "raidillon",
      0.01
    ],
    [
      "rampe",
      0.01
    ],
    [
      "sente",
      0.01
    ],
    [
      "traite",
      0.01
    ],
    [
      "trotte",
      0.01
    ],
    [
      "piste",
      0.01
    ],
    [
      "montee",
      0.01
    ],
    [
      "boulevard",
      0.01
    ],
    [
      "cote",
      0.01
    ],
    [
      "distance",
      0.01
    ],
    [
      "ligne",
      0.01
    ],
    [
      "maniere",
      0.01
    ],
    [
      "percee",
      0.005
    ],
    [
      "ravin",
      0.005
    ],
    [
      "rocade",
      0.005
    ],
    [
      "routine",
      0.005
    ],
    [
      "ruban",
      0.005
    ],
    [
      "sens",
      0.005
    ],
    [
      "tapis",
      0.005
    ],
    [
      "tirage",
      0.005
    ],
    [
      "tortille",
      0.005
    ],
    [
      "trajectoire",
      0.005
    ],
    [
      "pavement",
      0.005
    ],
    [
      "marchepied",
      0.005
    ],
    [
      "macadam",
      0.005
    ],
    [
      "acces",
      0.005
    ],
    [
      "berme",
      0.005
    ],
    [
      "boyau",
      0.005
    ],
    [
      "cavee",
      0.005
    ],
    [
      "charmille",
      0.005
    ],
    [
      "descente",
      0.005
    ],
    [
      "facon",
      0.005
    ],
    [
      "grimpette",
      0.005
    ],
    [
      "layon",
      0.005
    ],
    [
      "le",
      0.005
    ],
    [
      "venelle",
      0.005
    ]
  ],
  "hanter": [
    [
      "poursuivre",
      0.12
    ],
    [
      "obseder",
      0.1125
    ],
    [
      "tourmenter",
      0.1025
    ],
    [
      "harceler",
      0.0825
    ],
    [
      "frequenter",
      0.065
    ],
    [
      "travailler",
      0.055
    ],
    [
      "habiter",
      0.045
    ],
    [
      "ronger",
      0.035
    ],
    [
      "courir",
      0.035
    ],
    [
      "devorer",
      0.0275
    ],
    [
      "pratiquer",
      0.0275
    ],
    [
      "tenailler",
      0.0275
    ],
    [
      "visiter",
      0.0175
    ],
    [
      "suivre",
      0.0175
    ],
    [
      "submerger",
      0.0175
    ],
    [
      "preoccuper",
      0.0175
    ],
    [
      "presser",
      0.0175
    ],
    [
      "pourchasser",
      0.0175
    ],
    [
      "lanciner",
      0.0175
    ],
    [
      "assaillir",
      0.0175
    ],
    [
      "s'afficher",
      0.0075
    ],
    [
      "posseder",
      0.0075
    ],
    [
      "peupler",
      0.0075
    ],
    [
      "nicher",
      0.0075
    ],
    [
      "infester",
      0.0075
    ],
    [
      "halluciner",
      0.0075
    ],
    [
      "frayer",
      0.0075
    ],
    [
      "tyranniser",
      0.0075
    ]
  ],
  "nommer": [
    [
      "designer",
      0.0975
    ],
    [
      "indiquer",
      0.0725
    ],
    [
      "reveler",
      0.0725
    ],
    [
      "signaler",
      0.05
    ],
    [
      "donner",
      0.045
    ],
    [
      "appeler",
      0.045
    ],
    [
      "affecter",
      0.0325
    ],
    [
      "dire",
      0.0325
    ],
    [
      "qualifier",
      0.0325
    ],
    [
      "etablir",
      0.0325
    ],
    [
      "faire",
      0.0275
    ],
    [
      "denommer",
      0.0275
    ],
    [
      "citer",
      0.0275
    ],
    [
      "declarer",
      0.0225
    ],
    [
      "denoncer",
      0.0225
    ],
    [
      "introniser",
      0.0225
    ],
    [
      "prendre",
      0.0225
    ],
    [
      "evoquer",
      0.015
    ],
    [
      "enumerer",
      0.015
    ],
    [
      "elire",
      0.015
    ],
    [
      "traiter",
      0.015
    ],
    [
      "instituer",
      0.015
    ],
    [
      "envoyer",
      0.015
    ],
    [
      "choisir",
      0.015
    ],
    [
      "baptiser",
      0.015
    ],
    [
      "etiqueter",
      0.01
    ],
    [
      "titulariser",
      0.01
    ],
    [
      "reconnaitre",
      0.01
    ],
    [
      "promouvoir",
      0.01
    ],
    [
      "mentionner",
      0.01
    ],
    [
      "installer",
      0.01
    ],
    [
      "deplacer",
      0.01
    ],
    [
      "conferer",
      0.01
    ],
    [
      "commettre",
      0.01
    ],
    [
      "bombarder",
      0.01
    ],
    [
      "selectionner",
      0.005
    ],
    [
      "surnommer",
      0.005
    ],
    [
      "prenommer",
      0.005
    ],
    [
      "parachuter",
      0.005
    ],
    [
      "intituler",
      0.005
    ],
    [
      "commissionner",
      0.005
    ],
    [
      "acclamer",
      0.005
    ],
    [
      "verser",
      0.005
    ]
  ],
  "nomme": [
    [
      "designer",
      0.0975
    ],
    [
      "indiquer",
      0.0725
    ],
    [
      "reveler",
      0.0725
    ],
    [
      "signaler",
      0.05
    ],
    [
      "donner",
      0.045
    ],
    [
      "appeler",
      0.045
    ],
    [
      "affecter",
      0.0325
    ],
    [
      "dire",
      0.0325
    ],
    [
      "qualifier",
      0.0325
    ],
    [
      "etablir",
      0.0325
    ],
    [
      "faire",
      0.0275
    ],
    [
      "denommer",
      0.0275
    ],
    [
      "citer",
      0.0275
    ],
    [
      "declarer",
      0.0225
    ],
    [
      "denoncer",
      0.0225
    ],
    [
      "introniser",
      0.0225
    ],
    [
      "prendre",
      0.0225
    ],
    [
      "evoquer",
      0.015
    ],
    [
      "enumerer",
      0.015
    ],
    [
      "elire",
      0.015
    ],
    [
      "traiter",
      0.015
    ],
    [
      "instituer",
      0.015
    ],
    [
      "envoyer",
      0.015
    ],
    [
      "choisir",
      0.015
    ],
    [
      "baptiser",
      0.015
    ],
    [
      "etiqueter",
      0.01
    ],
    [
      "titulariser",
      0.01
    ],
    [
      "reconnaitre",
      0.01
    ],
    [
      "promouvoir",
      0.01
    ],
    [
      "mentionner",
      0.01
    ],
    [
      "installer",
      0.01
    ],
    [
      "deplacer",
      0.01
    ],
    [
      "conferer",
      0.01
    ],
    [
      "commettre",
      0.01
    ],
    [
      "bombarder",
      0.01
    ],
    [
      "selectionner",
      0.005
    ],
    [
      "surnommer",
      0.005
    ],
    [
      "prenommer",
      0.005
    ],
    [
      "parachuter",
      0.005
    ],
    [
      "intituler",
      0.005
    ],
    [
      "commissionner",
      0.005
    ],
    [
      "acclamer",
      0.005
    ],
    [
      "verser",
      0.005
    ]
  ],
  "peau": [
    [
      "cuir",
      0.105
    ],
    [
      "enveloppe",
      0.09
    ],
    [
      "corps",
      0.06
    ],
    [
      "chair",
      0.045
    ],
    [
      "robe",
      0.045
    ],
    [
      "ecorce",
      0.03
    ],
    [
      "velin",
      0.03
    ],
    [
      "pelure",
      0.03
    ],
    [
      "pellicule",
      0.015
    ],
    [
      "pelleterie",
      0.015
    ],
    [
      "pelage",
      0.015
    ],
    [
      "peausserie",
      0.015
    ],
    [
      "parchemin",
      0.015
    ],
    [
      "mue",
      0.015
    ],
    [
      "membrane",
      0.015
    ],
    [
      "personne",
      0.015
    ],
    [
      "place",
      0.015
    ],
    [
      "porc",
      0.015
    ],
    [
      "prostituee",
      0.015
    ],
    [
      "pecari",
      0.015
    ],
    [
      "serpent",
      0.015
    ],
    [
      "tegument",
      0.015
    ],
    [
      "epicarpe",
      0.015
    ],
    [
      "epiderme",
      0.015
    ],
    [
      "epluchure",
      0.015
    ],
    [
      "maroquin",
      0.015
    ],
    [
      "lezard",
      0.015
    ],
    [
      "guenille",
      0.015
    ],
    [
      "basane",
      0.015
    ],
    [
      "bisquain",
      0.015
    ],
    [
      "carcasse",
      0.015
    ],
    [
      "carnation",
      0.015
    ],
    [
      "chagrin",
      0.015
    ],
    [
      "chamois",
      0.015
    ],
    [
      "chevreau",
      0.015
    ],
    [
      "chevrotin",
      0.015
    ],
    [
      "cosse",
      0.015
    ],
    [
      "couenne",
      0.015
    ],
    [
      "crocodile",
      0.015
    ],
    [
      "croupon",
      0.015
    ],
    [
      "derme",
      0.015
    ],
    [
      "envie",
      0.015
    ],
    [
      "fourrure",
      0.015
    ],
    [
      "galuchat",
      0.015
    ],
    [
      "agnelin",
      0.015
    ]
  ],
  "dore": [
    [
      "chamarrer",
      0.11
    ],
    [
      "galvaniser",
      0.11
    ],
    [
      "haler",
      0.11
    ],
    [
      "jaunir",
      0.11
    ],
    [
      "murir",
      0.11
    ],
    [
      "orner",
      0.11
    ],
    [
      "rissoler",
      0.11
    ],
    [
      "rougir",
      0.11
    ],
    [
      "eclairer",
      0.11
    ]
  ],
  "doree": [
    [
      "chamarrer",
      0.11
    ],
    [
      "galvaniser",
      0.11
    ],
    [
      "haler",
      0.11
    ],
    [
      "jaunir",
      0.11
    ],
    [
      "murir",
      0.11
    ],
    [
      "orner",
      0.11
    ],
    [
      "rissoler",
      0.11
    ],
    [
      "rougir",
      0.11
    ],
    [
      "eclairer",
      0.11
    ]
  ],
  "dorer": [
    [
      "chamarrer",
      0.11
    ],
    [
      "galvaniser",
      0.11
    ],
    [
      "haler",
      0.11
    ],
    [
      "jaunir",
      0.11
    ],
    [
      "murir",
      0.11
    ],
    [
      "orner",
      0.11
    ],
    [
      "rissoler",
      0.11
    ],
    [
      "rougir",
      0.11
    ],
    [
      "eclairer",
      0.11
    ]
  ],
  "hair": [
    [
      "abhorrer",
      0.1875
    ],
    [
      "detester",
      0.155
    ],
    [
      "abominer",
      0.125
    ],
    [
      "execrer",
      0.0925
    ],
    [
      "honnir",
      0.03
    ],
    [
      "maudire",
      0.03
    ],
    [
      "repugner",
      0.03
    ],
    [
      "sentir",
      0.03
    ],
    [
      "fuir",
      0.03
    ],
    [
      "envier",
      0.03
    ],
    [
      "souffrir",
      0.03
    ]
  ],
  "jalouser": [
    [
      "envier",
      1.0
    ]
  ],
  "homme": [
    [
      "individu",
      0.12
    ],
    [
      "type",
      0.115
    ],
    [
      "personne",
      0.0875
    ],
    [
      "bougre",
      0.0425
    ],
    [
      "gaillard",
      0.035
    ],
    [
      "mec",
      0.0325
    ],
    [
      "citoyen",
      0.0225
    ],
    [
      "zebre",
      0.0225
    ],
    [
      "etre",
      0.0175
    ],
    [
      "zigoto",
      0.0175
    ],
    [
      "pistolet",
      0.0175
    ],
    [
      "pierrot",
      0.0175
    ],
    [
      "personnage",
      0.0175
    ],
    [
      "humain",
      0.0175
    ],
    [
      "bonhomme",
      0.0175
    ],
    [
      "zig",
      0.015
    ],
    [
      "oiseau",
      0.015
    ],
    [
      "habitant",
      0.015
    ],
    [
      "gars",
      0.015
    ],
    [
      "esprit",
      0.015
    ],
    [
      "drole",
      0.0125
    ],
    [
      "quidam",
      0.0125
    ],
    [
      "soldat",
      0.0125
    ],
    [
      "ame",
      0.0075
    ],
    [
      "moineau",
      0.0075
    ],
    [
      "guignol",
      0.0075
    ],
    [
      "gazier",
      0.0075
    ],
    [
      "corps",
      0.0075
    ],
    [
      "coco",
      0.0075
    ],
    [
      "amant",
      0.0075
    ],
    [
      "naturel",
      0.005
    ],
    [
      "piaf",
      0.005
    ],
    [
      "societe",
      0.005
    ],
    [
      "sujet",
      0.005
    ],
    [
      "tete",
      0.005
    ],
    [
      "mortel",
      0.005
    ],
    [
      "luron",
      0.005
    ],
    [
      "lascar",
      0.005
    ],
    [
      "humanite",
      0.005
    ],
    [
      "gonze",
      0.005
    ],
    [
      "gens",
      0.005
    ],
    [
      "garcon",
      0.005
    ],
    [
      "creature",
      0.005
    ],
    [
      "ouvrier",
      0.0025
    ],
    [
      "male",
      0.0025
    ],
    [
      "monsieur",
      0.0025
    ],
    [
      "mecton",
      0.0025
    ],
    [
      "masculin",
      0.0025
    ],
    [
      "mari",
      0.0025
    ],
    [
      "pante",
      0.0025
    ],
    [
      "paroissien",
      0.0025
    ],
    [
      "particulier",
      0.0025
    ],
    [
      "prochain",
      0.0025
    ],
    [
      "pelerin",
      0.0025
    ],
    [
      "quelqu'un",
      0.0025
    ],
    [
      "regulier",
      0.0025
    ],
    [
      "semblable",
      0.0025
    ],
    [
      "zouave",
      0.0025
    ],
    [
      "lapin",
      0.0025
    ],
    [
      "jules",
      0.0025
    ],
    [
      "adulte",
      0.0025
    ],
    [
      "anthropoide",
      0.0025
    ],
    [
      "bimane",
      0.0025
    ],
    [
      "bipede",
      0.0025
    ],
    [
      "bras",
      0.0025
    ],
    [
      "combattant",
      0.0025
    ],
    [
      "croquant",
      0.0025
    ],
    [
      "celebrite",
      0.0025
    ],
    [
      "diable",
      0.0025
    ],
    [
      "espece",
      0.0025
    ],
    [
      "gus",
      0.0025
    ],
    [
      "hominien",
      0.0025
    ],
    [
      "here",
      0.0025
    ],
    [
      "epoux",
      0.0025
    ]
  ],
  "ici": [
    [
      "ci",
      0.2
    ],
    [
      "contre",
      0.2
    ],
    [
      "ceans",
      0.2
    ],
    [
      "maintenant",
      0.2
    ]
  ],
  "ni": [],
  "facile": [
    [
      "doux",
      0.0625
    ],
    [
      "accommodant",
      0.055
    ],
    [
      "commode",
      0.045
    ],
    [
      "simple",
      0.045
    ],
    [
      "coulant",
      0.0425
    ],
    [
      "traitable",
      0.0375
    ],
    [
      "complaisant",
      0.0375
    ],
    [
      "aise",
      0.0375
    ],
    [
      "faible",
      0.0275
    ],
    [
      "maniable",
      0.0275
    ],
    [
      "accessible",
      0.0225
    ],
    [
      "mou",
      0.0225
    ],
    [
      "malleable",
      0.02
    ],
    [
      "indulgent",
      0.02
    ],
    [
      "familier",
      0.02
    ],
    [
      "conciliant",
      0.02
    ],
    [
      "agreable",
      0.02
    ],
    [
      "transparent",
      0.0175
    ],
    [
      "sociable",
      0.0175
    ],
    [
      "leger",
      0.0175
    ],
    [
      "debonnaire",
      0.0175
    ],
    [
      "clair",
      0.0175
    ],
    [
      "vivable",
      0.0125
    ],
    [
      "pratique",
      0.0125
    ],
    [
      "pliant",
      0.0125
    ],
    [
      "ordinaire",
      0.0125
    ],
    [
      "naturel",
      0.0125
    ],
    [
      "libre",
      0.0125
    ],
    [
      "intelligible",
      0.0125
    ],
    [
      "comprehensible",
      0.0125
    ],
    [
      "bonhomme",
      0.0125
    ],
    [
      "elastique",
      0.01
    ],
    [
      "possible",
      0.01
    ],
    [
      "degage",
      0.01
    ],
    [
      "tolerant",
      0.0075
    ],
    [
      "relache",
      0.0075
    ],
    [
      "quelconque",
      0.0075
    ],
    [
      "penetrable",
      0.0075
    ],
    [
      "gracieux",
      0.0075
    ],
    [
      "courant",
      0.0075
    ],
    [
      "abordable",
      0.0075
    ],
    [
      "vulgaire",
      0.005
    ],
    [
      "tendre",
      0.005
    ],
    [
      "realisable",
      0.005
    ],
    [
      "praticable",
      0.005
    ],
    [
      "enfantin",
      0.005
    ],
    [
      "docile",
      0.005
    ],
    [
      "brave",
      0.005
    ],
    [
      "banal",
      0.005
    ],
    [
      "arrangeant",
      0.005
    ],
    [
      "visible",
      0.0025
    ],
    [
      "veule",
      0.0025
    ],
    [
      "plat",
      0.0025
    ],
    [
      "limpide",
      0.0025
    ],
    [
      "habile",
      0.0025
    ],
    [
      "faisable",
      0.0025
    ],
    [
      "facilement",
      0.0025
    ],
    [
      "executable",
      0.0025
    ],
    [
      "elementaire",
      0.0025
    ]
  ],
  "difficile": [
    [
      "dur",
      0.07
    ],
    [
      "penible",
      0.045
    ],
    [
      "obscur",
      0.035
    ],
    [
      "rude",
      0.035
    ],
    [
      "delicat",
      0.03
    ],
    [
      "reveche",
      0.025
    ],
    [
      "sibyllin",
      0.0225
    ],
    [
      "impossible",
      0.0225
    ],
    [
      "tendu",
      0.0225
    ],
    [
      "impenetrable",
      0.02
    ],
    [
      "mauvais",
      0.02
    ],
    [
      "tenebreux",
      0.02
    ],
    [
      "epineux",
      0.0175
    ],
    [
      "nebuleux",
      0.0175
    ],
    [
      "intraitable",
      0.0175
    ],
    [
      "ardu",
      0.0175
    ],
    [
      "embarrassant",
      0.015
    ],
    [
      "terrible",
      0.0125
    ],
    [
      "severe",
      0.0125
    ],
    [
      "pointilleux",
      0.0125
    ],
    [
      "mysterieux",
      0.0125
    ],
    [
      "inabordable",
      0.0125
    ],
    [
      "dangereux",
      0.0125
    ],
    [
      "enigmatique",
      0.01
    ],
    [
      "rogue",
      0.01
    ],
    [
      "malaise",
      0.01
    ],
    [
      "lourd",
      0.01
    ],
    [
      "insupportable",
      0.01
    ],
    [
      "inintelligible",
      0.01
    ],
    [
      "exigeant",
      0.01
    ],
    [
      "complique",
      0.01
    ],
    [
      "cale",
      0.01
    ],
    [
      "apre",
      0.01
    ],
    [
      "impraticable",
      0.01
    ],
    [
      "facheux",
      0.01
    ],
    [
      "acariatre",
      0.01
    ],
    [
      "abscons",
      0.01
    ],
    [
      "esoterique",
      0.0075
    ],
    [
      "scabreux",
      0.0075
    ],
    [
      "raboteux",
      0.0075
    ],
    [
      "profond",
      0.0075
    ],
    [
      "inextricable",
      0.0075
    ],
    [
      "inaccessible",
      0.0075
    ],
    [
      "hermetique",
      0.0075
    ],
    [
      "ennuyeux",
      0.0075
    ],
    [
      "difficultueux",
      0.0075
    ],
    [
      "abstrus",
      0.0075
    ],
    [
      "malheureux",
      0.005
    ],
    [
      "raide",
      0.005
    ],
    [
      "risque",
      0.005
    ],
    [
      "retif",
      0.005
    ],
    [
      "sourcilleux",
      0.005
    ],
    [
      "invivable",
      0.005
    ],
    [
      "indechiffrable",
      0.005
    ],
    [
      "indocile",
      0.005
    ],
    [
      "escarpe",
      0.005
    ],
    [
      "embrouille",
      0.005
    ],
    [
      "confus",
      0.005
    ],
    [
      "abstrait",
      0.005
    ],
    [
      "perilleux",
      0.0025
    ],
    [
      "quinteux",
      0.0025
    ],
    [
      "savant",
      0.0025
    ],
    [
      "subtil",
      0.0025
    ],
    [
      "tragique",
      0.0025
    ],
    [
      "irascible",
      0.0025
    ],
    [
      "introuvable",
      0.0025
    ],
    [
      "inquietant",
      0.0025
    ],
    [
      "desobeissant",
      0.0025
    ],
    [
      "dramatique",
      0.0025
    ],
    [
      "critique",
      0.0025
    ],
    [
      "complexe",
      0.0025
    ],
    [
      "raffine",
      0.0025
    ],
    [
      "rare",
      0.0025
    ],
    [
      "tordu",
      0.0025
    ],
    [
      "trapu",
      0.0025
    ],
    [
      "etonnant",
      0.0025
    ],
    [
      "querelleur",
      0.0025
    ],
    [
      "preoccupant",
      0.0025
    ],
    [
      "precieux",
      0.0025
    ],
    [
      "douloureux",
      0.0025
    ],
    [
      "ingrat",
      0.0025
    ],
    [
      "laborieux",
      0.0025
    ],
    [
      "ombrageux",
      0.0025
    ],
    [
      "heurte",
      0.0
    ],
    [
      "illisible",
      0.0
    ],
    [
      "infaisable",
      0.0
    ],
    [
      "insurmontable",
      0.0
    ],
    [
      "lent",
      0.0
    ],
    [
      "minutieux",
      0.0
    ],
    [
      "problematique",
      0.0
    ],
    [
      "sorcier",
      0.0
    ],
    [
      "tatillon",
      0.0
    ],
    [
      "torturant",
      0.0
    ],
    [
      "vache",
      0.0
    ],
    [
      "emporte",
      0.0
    ],
    [
      "acrobatique",
      0.0
    ],
    [
      "blase",
      0.0
    ],
    [
      "capricieux",
      0.0
    ],
    [
      "chinois",
      0.0
    ],
    [
      "contrariant",
      0.0
    ],
    [
      "coriace",
      0.0
    ],
    [
      "coton",
      0.0
    ],
    [
      "diabolique",
      0.0
    ],
    [
      "duraille",
      0.0
    ],
    [
      "degoute",
      0.0
    ],
    [
      "etroit",
      0.0
    ]
  ],
  "magnifique": [
    [
      "beau",
      0.105
    ],
    [
      "grand",
      0.0625
    ],
    [
      "imposant",
      0.0625
    ],
    [
      "splendide",
      0.0525
    ],
    [
      "superbe",
      0.05
    ],
    [
      "sublime",
      0.045
    ],
    [
      "architectural",
      0.04
    ],
    [
      "noble",
      0.04
    ],
    [
      "eleve",
      0.04
    ],
    [
      "etonnant",
      0.035
    ],
    [
      "somptueux",
      0.035
    ],
    [
      "admirable",
      0.03
    ],
    [
      "grandiose",
      0.03
    ],
    [
      "sensationnel",
      0.03
    ],
    [
      "brillant",
      0.025
    ],
    [
      "merveilleux",
      0.025
    ],
    [
      "pompeux",
      0.025
    ],
    [
      "eclatant",
      0.025
    ],
    [
      "riche",
      0.0225
    ],
    [
      "fastueux",
      0.0225
    ],
    [
      "extraordinaire",
      0.0175
    ],
    [
      "formidable",
      0.0175
    ],
    [
      "glorieux",
      0.0175
    ],
    [
      "releve",
      0.0175
    ],
    [
      "magistral",
      0.0125
    ],
    [
      "luxueux",
      0.0125
    ],
    [
      "genereux",
      0.0125
    ],
    [
      "triomphal",
      0.0075
    ],
    [
      "royal",
      0.0075
    ],
    [
      "ravissant",
      0.0075
    ],
    [
      "emphatique",
      0.0075
    ],
    [
      "bellissime",
      0.0025
    ],
    [
      "joli",
      0.0025
    ],
    [
      "munificent",
      0.0025
    ],
    [
      "seigneurial",
      0.0025
    ],
    [
      "supercoquentieux",
      0.0025
    ]
  ],
  "ses": [],
  "disciple": [
    [
      "epigone",
      0.0975
    ],
    [
      "eleve",
      0.0725
    ],
    [
      "suiveur",
      0.0725
    ],
    [
      "proselyte",
      0.0725
    ],
    [
      "partisan",
      0.0725
    ],
    [
      "heritier",
      0.0725
    ],
    [
      "adepte",
      0.0725
    ],
    [
      "zelateur",
      0.0475
    ],
    [
      "tenant",
      0.0475
    ],
    [
      "suivant",
      0.0475
    ],
    [
      "sectateur",
      0.0475
    ],
    [
      "fils",
      0.0475
    ],
    [
      "continuateur",
      0.0475
    ],
    [
      "apotre",
      0.0475
    ],
    [
      "apprenti",
      0.0225
    ],
    [
      "fidele",
      0.0225
    ],
    [
      "imitateur",
      0.0225
    ],
    [
      "ecolier",
      0.0225
    ],
    [
      "emanation",
      0.0225
    ]
  ],
  "vite": [
    [
      "rapidement",
      0.0975
    ],
    [
      "promptement",
      0.08
    ],
    [
      "hativement",
      0.0725
    ],
    [
      "precipitamment",
      0.055
    ],
    [
      "rapide",
      0.0475
    ],
    [
      "vif",
      0.04
    ],
    [
      "prestement",
      0.04
    ],
    [
      "prompt",
      0.03
    ],
    [
      "presto",
      0.03
    ],
    [
      "agile",
      0.0225
    ],
    [
      "preste",
      0.0225
    ],
    [
      "tot",
      0.0225
    ],
    [
      "vivement",
      0.0225
    ],
    [
      "subito",
      0.015
    ],
    [
      "rondement",
      0.015
    ],
    [
      "presse",
      0.015
    ],
    [
      "brusquement",
      0.015
    ],
    [
      "bientot",
      0.015
    ],
    [
      "veloce",
      0.005
    ],
    [
      "vitement",
      0.005
    ],
    [
      "raide",
      0.005
    ],
    [
      "prestissimo",
      0.005
    ],
    [
      "impetueux",
      0.005
    ],
    [
      "hatif",
      0.005
    ],
    [
      "dispos",
      0.005
    ]
  ],
  "indecis": [
    [
      "incertain",
      0.125
    ],
    [
      "vague",
      0.09
    ],
    [
      "flottant",
      0.0775
    ],
    [
      "confus",
      0.05
    ],
    [
      "hesitant",
      0.05
    ],
    [
      "timide",
      0.0425
    ],
    [
      "indetermine",
      0.0425
    ],
    [
      "flou",
      0.035
    ],
    [
      "irresolu",
      0.035
    ],
    [
      "nebuleux",
      0.0325
    ],
    [
      "equivoque",
      0.025
    ],
    [
      "versatile",
      0.025
    ],
    [
      "indistinct",
      0.025
    ],
    [
      "imprecis",
      0.025
    ],
    [
      "douteux",
      0.025
    ],
    [
      "ambigu",
      0.025
    ],
    [
      "embarrasse",
      0.02
    ],
    [
      "velleitaire",
      0.02
    ],
    [
      "faible",
      0.0175
    ],
    [
      "vacillant",
      0.0125
    ],
    [
      "ondoyant",
      0.0125
    ],
    [
      "mou",
      0.0125
    ],
    [
      "inconsistant",
      0.0125
    ],
    [
      "fluctuant",
      0.0125
    ],
    [
      "changeant",
      0.0125
    ],
    [
      "trouble",
      0.01
    ],
    [
      "perplexe",
      0.01
    ],
    [
      "indeterminable",
      0.01
    ],
    [
      "indefini",
      0.01
    ],
    [
      "fluide",
      0.01
    ],
    [
      "faux",
      0.01
    ],
    [
      "suspendu",
      0.005
    ],
    [
      "lent",
      0.005
    ],
    [
      "indiscernable",
      0.005
    ],
    [
      "balance",
      0.0025
    ],
    [
      "desoriente",
      0.0025
    ],
    [
      "general",
      0.0025
    ],
    [
      "timore",
      0.0025
    ],
    [
      "ebranle",
      0.0025
    ]
  ],
  "tremblant": [
    [
      "affole",
      0.0775
    ],
    [
      "apeure",
      0.0775
    ],
    [
      "craintif",
      0.0775
    ],
    [
      "epouvante",
      0.0575
    ],
    [
      "vacillant",
      0.0575
    ],
    [
      "transi",
      0.0575
    ],
    [
      "terrifie",
      0.0575
    ],
    [
      "fremissant",
      0.0575
    ],
    [
      "effraye",
      0.0575
    ],
    [
      "alarme",
      0.0575
    ],
    [
      "emu",
      0.0375
    ],
    [
      "tremblotant",
      0.0375
    ],
    [
      "peureux",
      0.0375
    ],
    [
      "frissonnant",
      0.0375
    ],
    [
      "chancelant",
      0.0375
    ],
    [
      "tremble",
      0.0175
    ],
    [
      "palpitant",
      0.0175
    ],
    [
      "lache",
      0.0175
    ],
    [
      "flageolant",
      0.0175
    ],
    [
      "defaillant",
      0.0175
    ],
    [
      "chevrotant",
      0.0175
    ],
    [
      "casse",
      0.0175
    ],
    [
      "bredouillant",
      0.0175
    ],
    [
      "tremulant",
      0.0175
    ]
  ],
  "feuille": [
    [
      "journal",
      0.105
    ],
    [
      "feuillet",
      0.0625
    ],
    [
      "fiche",
      0.0625
    ],
    [
      "papier",
      0.0625
    ],
    [
      "tract",
      0.0425
    ],
    [
      "plaque",
      0.0425
    ],
    [
      "lame",
      0.0425
    ],
    [
      "frondaison",
      0.0425
    ],
    [
      "feuillage",
      0.0425
    ],
    [
      "bulletin",
      0.0425
    ],
    [
      "oreille",
      0.02
    ],
    [
      "organe",
      0.02
    ],
    [
      "page",
      0.02
    ],
    [
      "placard",
      0.02
    ],
    [
      "prospectus",
      0.02
    ],
    [
      "petale",
      0.02
    ],
    [
      "recto",
      0.02
    ],
    [
      "seillee",
      0.02
    ],
    [
      "verdure",
      0.02
    ],
    [
      "lamelle",
      0.02
    ],
    [
      "gazette",
      0.02
    ],
    [
      "foliole",
      0.02
    ],
    [
      "canard",
      0.02
    ],
    [
      "carton",
      0.02
    ],
    [
      "copie",
      0.02
    ],
    [
      "document",
      0.02
    ],
    [
      "fane",
      0.02
    ],
    [
      "feuillee",
      0.02
    ],
    [
      "fibre",
      0.02
    ],
    [
      "folio",
      0.02
    ],
    [
      "verso",
      0.02
    ]
  ],
  "caresser": [
    [
      "flatter",
      0.0925
    ],
    [
      "cajoler",
      0.0625
    ],
    [
      "effleurer",
      0.0625
    ],
    [
      "aduler",
      0.04
    ],
    [
      "peloter",
      0.04
    ],
    [
      "tripoter",
      0.0325
    ],
    [
      "toucher",
      0.0325
    ],
    [
      "froler",
      0.0325
    ],
    [
      "chatouiller",
      0.0325
    ],
    [
      "choyer",
      0.0275
    ],
    [
      "embrasser",
      0.0275
    ],
    [
      "flagorner",
      0.0275
    ],
    [
      "frotter",
      0.0275
    ],
    [
      "manier",
      0.0225
    ],
    [
      "caliner",
      0.0225
    ],
    [
      "courtiser",
      0.0225
    ],
    [
      "bouchonner",
      0.0225
    ],
    [
      "amadouer",
      0.0225
    ],
    [
      "serrer",
      0.015
    ],
    [
      "presser",
      0.015
    ],
    [
      "exciter",
      0.015
    ],
    [
      "dorloter",
      0.015
    ],
    [
      "baiser",
      0.015
    ],
    [
      "etreindre",
      0.01
    ],
    [
      "patiner",
      0.01
    ],
    [
      "nourrir",
      0.01
    ],
    [
      "mignoter",
      0.01
    ],
    [
      "lecher",
      0.01
    ],
    [
      "glisser",
      0.01
    ],
    [
      "entretenir",
      0.01
    ],
    [
      "accoler",
      0.01
    ],
    [
      "bercer",
      0.01
    ],
    [
      "bichonner",
      0.01
    ],
    [
      "chiffonner",
      0.01
    ],
    [
      "enjoler",
      0.01
    ],
    [
      "patouiller",
      0.0025
    ],
    [
      "projeter",
      0.0025
    ],
    [
      "raser",
      0.0025
    ],
    [
      "rebaudir",
      0.0025
    ],
    [
      "ressasser",
      0.0025
    ],
    [
      "tapoter",
      0.0025
    ],
    [
      "titiller",
      0.0025
    ],
    [
      "tripotailler",
      0.0025
    ],
    [
      "mignarder",
      0.0025
    ],
    [
      "ambitionner",
      0.0025
    ],
    [
      "attoucher",
      0.0025
    ],
    [
      "baigner",
      0.0025
    ],
    [
      "becqueter",
      0.0025
    ],
    [
      "becoter",
      0.0025
    ],
    [
      "enlacer",
      0.0025
    ],
    [
      "louer",
      0.0025
    ],
    [
      "egratigner",
      0.0025
    ]
  ],
  "toucher": [
    [
      "attouchement",
      0.22
    ],
    [
      "palpation",
      0.22
    ],
    [
      "tact",
      0.22
    ],
    [
      "contact",
      0.11
    ],
    [
      "investigation",
      0.11
    ],
    [
      "sens",
      0.11
    ]
  ],
  "tourner": [
    [
      "passer",
      0.045
    ],
    [
      "changer",
      0.04
    ],
    [
      "remuer",
      0.0325
    ],
    [
      "jouer",
      0.03
    ],
    [
      "marcher",
      0.03
    ],
    [
      "tournoyer",
      0.025
    ],
    [
      "obliquer",
      0.025
    ],
    [
      "virevolter",
      0.0225
    ],
    [
      "virer",
      0.0225
    ],
    [
      "rouler",
      0.0225
    ],
    [
      "retourner",
      0.0225
    ],
    [
      "detourner",
      0.0225
    ],
    [
      "arranger",
      0.0225
    ],
    [
      "tordre",
      0.0175
    ],
    [
      "tendre",
      0.0175
    ],
    [
      "orienter",
      0.0175
    ],
    [
      "incliner",
      0.0175
    ],
    [
      "battre",
      0.0175
    ],
    [
      "eluder",
      0.0125
    ],
    [
      "transformer",
      0.0125
    ],
    [
      "rabattre",
      0.0125
    ],
    [
      "prendre",
      0.0125
    ],
    [
      "pivoter",
      0.0125
    ],
    [
      "partir",
      0.0125
    ],
    [
      "influer",
      0.0125
    ],
    [
      "diriger",
      0.0125
    ],
    [
      "disposer",
      0.0125
    ],
    [
      "devier",
      0.0125
    ],
    [
      "exposer",
      0.0125
    ],
    [
      "fonctionner",
      0.0125
    ],
    [
      "evoluer",
      0.01
    ],
    [
      "tournailler",
      0.01
    ],
    [
      "tortiller",
      0.01
    ],
    [
      "presenter",
      0.01
    ],
    [
      "influencer",
      0.01
    ],
    [
      "finir",
      0.01
    ],
    [
      "metamorphoser",
      0.005
    ],
    [
      "pourrir",
      0.005
    ],
    [
      "prevenir",
      0.005
    ],
    [
      "ruminer",
      0.005
    ],
    [
      "roder",
      0.005
    ],
    [
      "serpenter",
      0.005
    ],
    [
      "tourniller",
      0.005
    ],
    [
      "tourniquer",
      0.005
    ],
    [
      "violer",
      0.005
    ],
    [
      "modifier",
      0.005
    ],
    [
      "manipuler",
      0.005
    ],
    [
      "interpreter",
      0.005
    ],
    [
      "appliquer",
      0.005
    ],
    [
      "braquer",
      0.005
    ],
    [
      "brasser",
      0.005
    ],
    [
      "cinematographier",
      0.005
    ],
    [
      "considerer",
      0.005
    ],
    [
      "contourner",
      0.005
    ],
    [
      "degenerer",
      0.005
    ],
    [
      "deriver",
      0.005
    ],
    [
      "encercler",
      0.005
    ],
    [
      "esquiver",
      0.005
    ],
    [
      "graviter",
      0.005
    ],
    [
      "tortillonner",
      0.0025
    ],
    [
      "s'aigrir",
      0.0025
    ],
    [
      "pirouetter",
      0.0025
    ],
    [
      "murir",
      0.0025
    ],
    [
      "touiller",
      0.0025
    ],
    [
      "toupiller",
      0.0025
    ],
    [
      "toupiner",
      0.0025
    ],
    [
      "tourbillonner",
      0.0025
    ],
    [
      "tournicoter",
      0.0025
    ],
    [
      "transgresser",
      0.0025
    ],
    [
      "trousser",
      0.0025
    ],
    [
      "virevousser",
      0.0025
    ],
    [
      "zigzaguer",
      0.0025
    ],
    [
      "girer",
      0.0025
    ],
    [
      "finasser",
      0.0025
    ],
    [
      "alterner",
      0.0025
    ],
    [
      "aleser",
      0.0025
    ],
    [
      "bistourner",
      0.0025
    ],
    [
      "cinegraphier",
      0.0025
    ],
    [
      "convertir",
      0.0025
    ],
    [
      "devenir",
      0.0025
    ],
    [
      "doubler",
      0.0025
    ],
    [
      "deborder",
      0.0025
    ],
    [
      "enfermer",
      0.0025
    ],
    [
      "enrouler",
      0.0025
    ],
    [
      "escamoter",
      0.0025
    ],
    [
      "examiner",
      0.0025
    ],
    [
      "exprimer",
      0.0025
    ],
    [
      "filmer",
      0.0025
    ],
    [
      "aigrir",
      0.0025
    ]
  ],
  "he": [
    [
      "ho",
      0.3325
    ],
    [
      "hola",
      0.3325
    ],
    [
      "eh",
      0.165
    ],
    [
      "hem",
      0.165
    ]
  ],
  "bete": [
    [
      "sot",
      0.1025
    ],
    [
      "stupide",
      0.07
    ],
    [
      "ballot",
      0.0675
    ],
    [
      "niais",
      0.0625
    ],
    [
      "beta",
      0.055
    ],
    [
      "idiot",
      0.045
    ],
    [
      "imbecile",
      0.0325
    ],
    [
      "balourd",
      0.0275
    ],
    [
      "cruche",
      0.02
    ],
    [
      "ane",
      0.02
    ],
    [
      "nigaud",
      0.0175
    ],
    [
      "gourde",
      0.015
    ],
    [
      "lourd",
      0.015
    ],
    [
      "inintelligent",
      0.015
    ],
    [
      "cretin",
      0.0125
    ],
    [
      "lourdaud",
      0.0125
    ],
    [
      "benet",
      0.0125
    ],
    [
      "cornichon",
      0.0125
    ],
    [
      "absurde",
      0.01
    ],
    [
      "abruti",
      0.01
    ],
    [
      "ignorant",
      0.01
    ],
    [
      "obtus",
      0.01
    ],
    [
      "simple",
      0.0075
    ],
    [
      "inepte",
      0.0075
    ],
    [
      "gauche",
      0.0075
    ],
    [
      "buse",
      0.0075
    ],
    [
      "borne",
      0.0075
    ],
    [
      "bouche",
      0.0075
    ],
    [
      "innocent",
      0.0075
    ],
    [
      "godiche",
      0.0075
    ],
    [
      "dadais",
      0.0075
    ],
    [
      "beotien",
      0.0075
    ],
    [
      "becasse",
      0.0075
    ],
    [
      "butor",
      0.0075
    ],
    [
      "pesant",
      0.005
    ],
    [
      "dur",
      0.005
    ],
    [
      "brute",
      0.005
    ],
    [
      "vide",
      0.0025
    ],
    [
      "vain",
      0.0025
    ],
    [
      "rustre",
      0.0025
    ],
    [
      "pretentieux",
      0.0025
    ],
    [
      "nul",
      0.0025
    ],
    [
      "naif",
      0.0025
    ],
    [
      "insense",
      0.0025
    ],
    [
      "ganache",
      0.0025
    ],
    [
      "aberrant",
      0.0025
    ],
    [
      "animal",
      0.0025
    ],
    [
      "baudet",
      0.0025
    ],
    [
      "con",
      0.0025
    ],
    [
      "corniaud",
      0.0025
    ],
    [
      "empote",
      0.0025
    ],
    [
      "epais",
      0.0025
    ],
    [
      "type",
      0.0025
    ],
    [
      "salaud",
      0.0025
    ],
    [
      "ridicule",
      0.0025
    ],
    [
      "nouille",
      0.0025
    ],
    [
      "facheux",
      0.0025
    ],
    [
      "buche",
      0.0025
    ],
    [
      "bourrique",
      0.0025
    ],
    [
      "andouille",
      0.0025
    ],
    [
      "moule",
      0.0025
    ],
    [
      "mufle",
      0.0025
    ],
    [
      "oie",
      0.0025
    ],
    [
      "pecore",
      0.0025
    ],
    [
      "sagouin",
      0.0025
    ],
    [
      "etourdi",
      0.0025
    ],
    [
      "monstre",
      0.0025
    ],
    [
      "mec",
      0.0025
    ],
    [
      "couillon",
      0.0025
    ],
    [
      "demeure",
      0.0025
    ],
    [
      "gibier",
      0.0025
    ],
    [
      "inutile",
      0.0025
    ],
    [
      "lourdingue",
      0.0025
    ],
    [
      "malavise",
      0.0025
    ],
    [
      "gourdiflot",
      0.0
    ],
    [
      "jocrisse",
      0.0
    ],
    [
      "nullite",
      0.0
    ],
    [
      "oiseau",
      0.0
    ],
    [
      "panouille",
      0.0
    ],
    [
      "poire",
      0.0
    ],
    [
      "pedant",
      0.0
    ],
    [
      "regrettable",
      0.0
    ],
    [
      "retreci",
      0.0
    ],
    [
      "solitaire",
      0.0
    ],
    [
      "souche",
      0.0
    ],
    [
      "vache",
      0.0
    ],
    [
      "fat",
      0.0
    ],
    [
      "ennuyeux",
      0.0
    ],
    [
      "enfantin",
      0.0
    ],
    [
      "aliboron",
      0.0
    ],
    [
      "bougre",
      0.0
    ],
    [
      "bourricot",
      0.0
    ],
    [
      "bovin",
      0.0
    ],
    [
      "bate",
      0.0
    ],
    [
      "bebete",
      0.0
    ],
    [
      "bejaune",
      0.0
    ],
    [
      "betasse",
      0.0
    ],
    [
      "deraisonnable",
      0.0
    ],
    [
      "cruchon",
      0.0
    ],
    [
      "connard",
      0.0
    ],
    [
      "cochon",
      0.0
    ],
    [
      "cloche",
      0.0
    ],
    [
      "porc",
      0.0
    ],
    [
      "patate",
      0.0
    ],
    [
      "paon",
      0.0
    ],
    [
      "niquedouille",
      0.0
    ],
    [
      "machoire",
      0.0
    ],
    [
      "loup",
      0.0
    ],
    [
      "inattentif",
      0.0
    ],
    [
      "impardonnable",
      0.0
    ],
    [
      "ilote",
      0.0
    ],
    [
      "huitre",
      0.0
    ],
    [
      "guignol",
      0.0
    ],
    [
      "pate",
      0.0
    ],
    [
      "quinaud",
      0.0
    ],
    [
      "etroit",
      0.0
    ],
    [
      "zigoto",
      0.0
    ],
    [
      "zig",
      0.0
    ],
    [
      "veau",
      0.0
    ],
    [
      "tourte",
      0.0
    ],
    [
      "tarte",
      0.0
    ],
    [
      "sosot",
      0.0
    ],
    [
      "serin",
      0.0
    ],
    [
      "saligaud",
      0.0
    ],
    [
      "grotesque",
      0.0
    ],
    [
      "gars",
      0.0
    ],
    [
      "becassot",
      0.0
    ],
    [
      "buffle",
      0.0
    ],
    [
      "bourrin",
      0.0
    ],
    [
      "bon",
      0.0
    ],
    [
      "bestiole",
      0.0
    ],
    [
      "bestiasse",
      0.0
    ],
    [
      "bestial",
      0.0
    ],
    [
      "balluchon",
      0.0
    ],
    [
      "balluche",
      0.0
    ],
    [
      "badaud",
      0.0
    ],
    [
      "becheur",
      0.0
    ],
    [
      "belant",
      0.0
    ],
    [
      "fumier",
      0.0
    ],
    [
      "fourneau",
      0.0
    ],
    [
      "faune",
      0.0
    ],
    [
      "fada",
      0.0
    ],
    [
      "enfoire",
      0.0
    ],
    [
      "dommage",
      0.0
    ],
    [
      "dindon",
      0.0
    ],
    [
      "dinde",
      0.0
    ],
    [
      "cucul",
      0.0
    ],
    [
      "ahuri",
      0.0
    ]
  ],
  "ombrer": [
    [
      "obscurcir",
      0.285
    ],
    [
      "brunir",
      0.1425
    ],
    [
      "obombrer",
      0.1425
    ],
    [
      "estomper",
      0.07
    ],
    [
      "farder",
      0.07
    ],
    [
      "foncer",
      0.07
    ],
    [
      "maquiller",
      0.07
    ],
    [
      "noircir",
      0.07
    ],
    [
      "ombrager",
      0.07
    ]
  ],
  "ombre": [
    [
      "apparence",
      0.0575
    ],
    [
      "fantome",
      0.0475
    ],
    [
      "image",
      0.0475
    ],
    [
      "soupcon",
      0.0425
    ],
    [
      "vision",
      0.0425
    ],
    [
      "obscurite",
      0.0375
    ],
    [
      "semblant",
      0.0375
    ],
    [
      "simulacre",
      0.0325
    ],
    [
      "ombrage",
      0.0325
    ],
    [
      "illusion",
      0.0325
    ],
    [
      "idee",
      0.0325
    ],
    [
      "sombreur",
      0.02
    ],
    [
      "spectre",
      0.02
    ],
    [
      "tenebres",
      0.02
    ],
    [
      "pointe",
      0.015
    ],
    [
      "penombre",
      0.015
    ],
    [
      "teinte",
      0.015
    ],
    [
      "trace",
      0.015
    ],
    [
      "ame",
      0.015
    ],
    [
      "obscurcissement",
      0.015
    ],
    [
      "mystere",
      0.015
    ],
    [
      "brume",
      0.015
    ],
    [
      "doute",
      0.015
    ],
    [
      "effacement",
      0.015
    ],
    [
      "forme",
      0.015
    ],
    [
      "inquietude",
      0.015
    ],
    [
      "melancolie",
      0.01
    ],
    [
      "opacite",
      0.01
    ],
    [
      "peu",
      0.01
    ],
    [
      "pretexte",
      0.01
    ],
    [
      "revenant",
      0.01
    ],
    [
      "secret",
      0.01
    ],
    [
      "souvenir",
      0.01
    ],
    [
      "vernis",
      0.01
    ],
    [
      "manes",
      0.01
    ],
    [
      "mort",
      0.01
    ],
    [
      "brouillard",
      0.01
    ],
    [
      "brumaille",
      0.01
    ],
    [
      "chimere",
      0.01
    ],
    [
      "couvert",
      0.01
    ],
    [
      "double",
      0.01
    ],
    [
      "fantasme",
      0.01
    ],
    [
      "humilite",
      0.01
    ],
    [
      "modestie",
      0.005
    ],
    [
      "nuit",
      0.005
    ],
    [
      "ombrine",
      0.005
    ],
    [
      "oubli",
      0.005
    ],
    [
      "parcelle",
      0.005
    ],
    [
      "protection",
      0.005
    ],
    [
      "preoccupation",
      0.005
    ],
    [
      "reflet",
      0.005
    ],
    [
      "silhouette",
      0.005
    ],
    [
      "malaise",
      0.005
    ],
    [
      "inconvenient",
      0.005
    ],
    [
      "approche",
      0.005
    ],
    [
      "contour",
      0.005
    ],
    [
      "contrariete",
      0.005
    ],
    [
      "defaut",
      0.005
    ],
    [
      "embrouillement",
      0.005
    ],
    [
      "frondaison",
      0.005
    ],
    [
      "imbroglio",
      0.005
    ],
    [
      "solitude",
      0.005
    ]
  ],
  "saper": [
    [
      "detruire",
      0.1675
    ],
    [
      "miner",
      0.125
    ],
    [
      "ruiner",
      0.09
    ],
    [
      "ronger",
      0.075
    ],
    [
      "abattre",
      0.0625
    ],
    [
      "affaiblir",
      0.0475
    ],
    [
      "demolir",
      0.0475
    ],
    [
      "consumer",
      0.04
    ],
    [
      "degrader",
      0.0325
    ],
    [
      "corroder",
      0.0275
    ],
    [
      "diminuer",
      0.0275
    ],
    [
      "eroder",
      0.0275
    ],
    [
      "devaster",
      0.02
    ],
    [
      "desintegrer",
      0.02
    ],
    [
      "desagreger",
      0.02
    ],
    [
      "aneantir",
      0.02
    ],
    [
      "ebranler",
      0.0125
    ],
    [
      "renverser",
      0.0125
    ],
    [
      "mordre",
      0.0125
    ],
    [
      "moissonner",
      0.0125
    ],
    [
      "defaire",
      0.0125
    ],
    [
      "couper",
      0.0125
    ],
    [
      "affouiller",
      0.0125
    ],
    [
      "degravoyer",
      0.005
    ],
    [
      "fissurer",
      0.005
    ],
    [
      "fragiliser",
      0.005
    ],
    [
      "fringuer",
      0.005
    ],
    [
      "torpiller",
      0.005
    ]
  ],
  "casse": [
    [
      "rompre",
      0.07
    ],
    [
      "detruire",
      0.06
    ],
    [
      "briser",
      0.0575
    ],
    [
      "demolir",
      0.0525
    ],
    [
      "couper",
      0.03
    ],
    [
      "diviser",
      0.0275
    ],
    [
      "dechirer",
      0.025
    ],
    [
      "annuler",
      0.0225
    ],
    [
      "ereinter",
      0.02
    ],
    [
      "morceler",
      0.02
    ],
    [
      "disloquer",
      0.02
    ],
    [
      "broyer",
      0.02
    ],
    [
      "battre",
      0.02
    ],
    [
      "abimer",
      0.02
    ],
    [
      "revoquer",
      0.0175
    ],
    [
      "ecraser",
      0.0175
    ],
    [
      "supprimer",
      0.0175
    ],
    [
      "destituer",
      0.0175
    ],
    [
      "blesser",
      0.0175
    ],
    [
      "degrader",
      0.015
    ],
    [
      "separer",
      0.0125
    ],
    [
      "resilier",
      0.0125
    ],
    [
      "demanteler",
      0.0125
    ],
    [
      "defaire",
      0.0125
    ],
    [
      "dissoudre",
      0.0125
    ],
    [
      "abolir",
      0.01
    ],
    [
      "affaiblir",
      0.01
    ],
    [
      "desagreger",
      0.01
    ],
    [
      "deteriorer",
      0.01
    ],
    [
      "suspendre",
      0.01
    ],
    [
      "invalider",
      0.0075
    ],
    [
      "fendre",
      0.0075
    ],
    [
      "detraquer",
      0.0075
    ],
    [
      "ebrecher",
      0.0075
    ],
    [
      "renvoyer",
      0.0075
    ],
    [
      "interdire",
      0.0075
    ],
    [
      "infirmer",
      0.0075
    ],
    [
      "fragmenter",
      0.0075
    ],
    [
      "entamer",
      0.0075
    ],
    [
      "detroner",
      0.0075
    ],
    [
      "deposer",
      0.0075
    ],
    [
      "abroger",
      0.0075
    ],
    [
      "concasser",
      0.0075
    ],
    [
      "ceder",
      0.0075
    ],
    [
      "demancher",
      0.0075
    ],
    [
      "demantibuler",
      0.0075
    ],
    [
      "demettre",
      0.0075
    ],
    [
      "tuer",
      0.005
    ],
    [
      "tomber",
      0.005
    ],
    [
      "piler",
      0.005
    ],
    [
      "mutiler",
      0.005
    ],
    [
      "limoger",
      0.005
    ],
    [
      "fractionner",
      0.005
    ],
    [
      "depecer",
      0.005
    ],
    [
      "delabrer",
      0.005
    ],
    [
      "craquer",
      0.005
    ],
    [
      "claquer",
      0.005
    ],
    [
      "bigorner",
      0.005
    ],
    [
      "fracasser",
      0.0025
    ],
    [
      "peter",
      0.0025
    ],
    [
      "rejeter",
      0.0025
    ],
    [
      "rosser",
      0.0025
    ],
    [
      "emietter",
      0.0025
    ],
    [
      "flancher",
      0.0025
    ],
    [
      "entailler",
      0.0025
    ],
    [
      "effondrer",
      0.0025
    ],
    [
      "accidenter",
      0.0025
    ],
    [
      "bouleverser",
      0.0025
    ],
    [
      "debarquer",
      0.0025
    ],
    [
      "delier",
      0.0025
    ],
    [
      "denoncer",
      0.0025
    ],
    [
      "rescinder",
      0.0
    ],
    [
      "eclater",
      0.0
    ],
    [
      "ecorner",
      0.0
    ],
    [
      "edenter",
      0.0
    ],
    [
      "egueuler",
      0.0
    ],
    [
      "epater",
      0.0
    ],
    [
      "ployer",
      0.0
    ],
    [
      "lacher",
      0.0
    ],
    [
      "bresiller",
      0.0
    ],
    [
      "comminuer",
      0.0
    ],
    [
      "craqueler",
      0.0
    ],
    [
      "debiliter",
      0.0
    ],
    [
      "decourager",
      0.0
    ],
    [
      "fendiller",
      0.0
    ],
    [
      "fracturer",
      0.0
    ],
    [
      "feler",
      0.0
    ],
    [
      "eventrer",
      0.0
    ]
  ],
  "casser": [
    [
      "rompre",
      0.07
    ],
    [
      "detruire",
      0.06
    ],
    [
      "briser",
      0.0575
    ],
    [
      "demolir",
      0.0525
    ],
    [
      "couper",
      0.03
    ],
    [
      "diviser",
      0.0275
    ],
    [
      "dechirer",
      0.025
    ],
    [
      "annuler",
      0.0225
    ],
    [
      "ereinter",
      0.02
    ],
    [
      "morceler",
      0.02
    ],
    [
      "disloquer",
      0.02
    ],
    [
      "broyer",
      0.02
    ],
    [
      "battre",
      0.02
    ],
    [
      "abimer",
      0.02
    ],
    [
      "revoquer",
      0.0175
    ],
    [
      "ecraser",
      0.0175
    ],
    [
      "supprimer",
      0.0175
    ],
    [
      "destituer",
      0.0175
    ],
    [
      "blesser",
      0.0175
    ],
    [
      "degrader",
      0.015
    ],
    [
      "separer",
      0.0125
    ],
    [
      "resilier",
      0.0125
    ],
    [
      "demanteler",
      0.0125
    ],
    [
      "defaire",
      0.0125
    ],
    [
      "dissoudre",
      0.0125
    ],
    [
      "abolir",
      0.01
    ],
    [
      "affaiblir",
      0.01
    ],
    [
      "desagreger",
      0.01
    ],
    [
      "deteriorer",
      0.01
    ],
    [
      "suspendre",
      0.01
    ],
    [
      "invalider",
      0.0075
    ],
    [
      "fendre",
      0.0075
    ],
    [
      "detraquer",
      0.0075
    ],
    [
      "ebrecher",
      0.0075
    ],
    [
      "renvoyer",
      0.0075
    ],
    [
      "interdire",
      0.0075
    ],
    [
      "infirmer",
      0.0075
    ],
    [
      "fragmenter",
      0.0075
    ],
    [
      "entamer",
      0.0075
    ],
    [
      "detroner",
      0.0075
    ],
    [
      "deposer",
      0.0075
    ],
    [
      "abroger",
      0.0075
    ],
    [
      "concasser",
      0.0075
    ],
    [
      "ceder",
      0.0075
    ],
    [
      "demancher",
      0.0075
    ],
    [
      "demantibuler",
      0.0075
    ],
    [
      "demettre",
      0.0075
    ],
    [
      "tuer",
      0.005
    ],
    [
      "tomber",
      0.005
    ],
    [
      "piler",
      0.005
    ],
    [
      "mutiler",
      0.005
    ],
    [
      "limoger",
      0.005
    ],
    [
      "fractionner",
      0.005
    ],
    [
      "depecer",
      0.005
    ],
    [
      "delabrer",
      0.005
    ],
    [
      "craquer",
      0.005
    ],
    [
      "claquer",
      0.005
    ],
    [
      "bigorner",
      0.005
    ],
    [
      "fracasser",
      0.0025
    ],
    [
      "peter",
      0.0025
    ],
    [
      "rejeter",
      0.0025
    ],
    [
      "rosser",
      0.0025
    ],
    [
      "emietter",
      0.0025
    ],
    [
      "flancher",
      0.0025
    ],
    [
      "entailler",
      0.0025
    ],
    [
      "effondrer",
      0.0025
    ],
    [
      "accidenter",
      0.0025
    ],
    [
      "bouleverser",
      0.0025
    ],
    [
      "debarquer",
      0.0025
    ],
    [
      "delier",
      0.0025
    ],
    [
      "denoncer",
      0.0025
    ],
    [
      "rescinder",
      0.0
    ],
    [
      "eclater",
      0.0
    ],
    [
      "ecorner",
      0.0
    ],
    [
      "edenter",
      0.0
    ],
    [
      "egueuler",
      0.0
    ],
    [
      "epater",
      0.0
    ],
    [
      "ployer",
      0.0
    ],
    [
      "lacher",
      0.0
    ],
    [
      "bresiller",
      0.0
    ],
    [
      "comminuer",
      0.0
    ],
    [
      "craqueler",
      0.0
    ],
    [
      "debiliter",
      0.0
    ],
    [
      "decourager",
      0.0
    ],
    [
      "fendiller",
      0.0
    ],
    [
      "fracturer",
      0.0
    ],
    [
      "feler",
      0.0
    ],
    [
      "eventrer",
      0.0
    ]
  ],
  "ta": [],
  "porte": [
    [
      "ouverture",
      0.095
    ],
    [
      "issue",
      0.075
    ],
    [
      "entree",
      0.055
    ],
    [
      "fermeture",
      0.055
    ],
    [
      "moyen",
      0.055
    ],
    [
      "porche",
      0.055
    ],
    [
      "echappatoire",
      0.0375
    ],
    [
      "sortie",
      0.0375
    ],
    [
      "portail",
      0.0375
    ],
    [
      "pas",
      0.0375
    ],
    [
      "gorge",
      0.0375
    ],
    [
      "defile",
      0.0375
    ],
    [
      "portique",
      0.0175
    ],
    [
      "portiere",
      0.0175
    ],
    [
      "poterne",
      0.0175
    ],
    [
      "propylee",
      0.0175
    ],
    [
      "seuil",
      0.0175
    ],
    [
      "trappe",
      0.0175
    ],
    [
      "tremplin",
      0.0175
    ],
    [
      "vallee",
      0.0175
    ],
    [
      "portillon",
      0.0175
    ],
    [
      "lourde",
      0.0175
    ],
    [
      "introduction",
      0.0175
    ],
    [
      "acces",
      0.0175
    ],
    [
      "arc",
      0.0175
    ],
    [
      "barriere",
      0.0175
    ],
    [
      "battant",
      0.0175
    ],
    [
      "degagement",
      0.0175
    ],
    [
      "guichet",
      0.0175
    ],
    [
      "herse",
      0.0175
    ],
    [
      "huis",
      0.0175
    ],
    [
      "vantail",
      0.0175
    ]
  ],
  "porter": [
    [
      "ale",
      0.5
    ],
    [
      "biere",
      0.5
    ]
  ],
  "retrouver": [
    [
      "rejoindre",
      0.095
    ],
    [
      "regagner",
      0.0825
    ],
    [
      "reprendre",
      0.0825
    ],
    [
      "rattraper",
      0.0675
    ],
    [
      "recuperer",
      0.055
    ],
    [
      "atteindre",
      0.055
    ],
    [
      "trouver",
      0.04
    ],
    [
      "rentrer",
      0.04
    ],
    [
      "remettre",
      0.04
    ],
    [
      "refaire",
      0.04
    ],
    [
      "recouvrer",
      0.04
    ],
    [
      "reconnaitre",
      0.04
    ],
    [
      "joindre",
      0.04
    ],
    [
      "gagner",
      0.04
    ],
    [
      "attraper",
      0.04
    ],
    [
      "revenir",
      0.0275
    ],
    [
      "reconquerir",
      0.0275
    ],
    [
      "rallier",
      0.0275
    ],
    [
      "revoir",
      0.0125
    ],
    [
      "retracer",
      0.0125
    ],
    [
      "ressaisir",
      0.0125
    ],
    [
      "identifier",
      0.0125
    ],
    [
      "depister",
      0.0125
    ],
    [
      "distinguer",
      0.0125
    ]
  ],
  "vendre": [
    [
      "donner",
      0.11
    ],
    [
      "solder",
      0.0625
    ],
    [
      "laisser",
      0.055
    ],
    [
      "liquider",
      0.055
    ],
    [
      "trafiquer",
      0.045
    ],
    [
      "livrer",
      0.035
    ],
    [
      "faire",
      0.035
    ],
    [
      "brader",
      0.035
    ],
    [
      "ecouler",
      0.025
    ],
    [
      "echanger",
      0.025
    ],
    [
      "prostituer",
      0.025
    ],
    [
      "offrir",
      0.025
    ],
    [
      "fournir",
      0.025
    ],
    [
      "debiter",
      0.025
    ],
    [
      "ceder",
      0.025
    ],
    [
      "brocanter",
      0.025
    ],
    [
      "bazarder",
      0.025
    ],
    [
      "aliener",
      0.025
    ],
    [
      "violer",
      0.0175
    ],
    [
      "trahir",
      0.0175
    ],
    [
      "sacrifier",
      0.0175
    ],
    [
      "realiser",
      0.0175
    ],
    [
      "placer",
      0.0175
    ],
    [
      "laver",
      0.0175
    ],
    [
      "coller",
      0.0175
    ],
    [
      "negocier",
      0.0075
    ],
    [
      "mevendre",
      0.0075
    ],
    [
      "monnayer",
      0.0075
    ],
    [
      "lessiver",
      0.0075
    ],
    [
      "exporter",
      0.0075
    ],
    [
      "detailler",
      0.0075
    ],
    [
      "denoncer",
      0.0075
    ],
    [
      "cameloter",
      0.0075
    ],
    [
      "adjuger",
      0.0075
    ]
  ],
  "tonne": [
    [
      "baril",
      0.25
    ],
    [
      "barrique",
      0.25
    ],
    [
      "poids",
      0.25
    ],
    [
      "tonneau",
      0.25
    ]
  ],
  "tonner": [
    [
      "fulminer",
      0.165
    ],
    [
      "crier",
      0.1525
    ],
    [
      "tempeter",
      0.125
    ],
    [
      "protester",
      0.0675
    ],
    [
      "s'indigner",
      0.0675
    ],
    [
      "vituperer",
      0.055
    ],
    [
      "gronder",
      0.055
    ],
    [
      "gueuler",
      0.04
    ],
    [
      "eclater",
      0.04
    ],
    [
      "tonitruer",
      0.0275
    ],
    [
      "retentir",
      0.0275
    ],
    [
      "menacer",
      0.0275
    ],
    [
      "maudire",
      0.0275
    ],
    [
      "invectiver",
      0.0275
    ],
    [
      "exploser",
      0.0275
    ],
    [
      "clamer",
      0.0125
    ],
    [
      "fumer",
      0.0125
    ],
    [
      "rouler",
      0.0125
    ]
  ],
  "sucre": [
    [
      "adoucir",
      0.3325
    ],
    [
      "dulcifier",
      0.3325
    ],
    [
      "edulcorer",
      0.3325
    ]
  ],
  "sucrer": [
    [
      "adoucir",
      0.3325
    ],
    [
      "dulcifier",
      0.3325
    ],
    [
      "edulcorer",
      0.3325
    ]
  ],
  "ouais": [],
  "puce": [
    [
      "aphaniptere",
      0.125
    ],
    [
      "brun",
      0.125
    ],
    [
      "chique",
      0.125
    ],
    [
      "microbe",
      0.125
    ],
    [
      "nain",
      0.125
    ],
    [
      "petit",
      0.125
    ],
    [
      "puceron",
      0.125
    ],
    [
      "vermine",
      0.125
    ]
  ],
  "thune": [
    [
      "ble",
      0.25
    ],
    [
      "piece",
      0.25
    ],
    [
      "peze",
      0.25
    ],
    [
      "sou",
      0.25
    ]
  ],
  "rendre": [
    [
      "donner",
      0.0725
    ],
    [
      "exprimer",
      0.0725
    ],
    [
      "faire",
      0.0725
    ],
    [
      "produire",
      0.0625
    ],
    [
      "remettre",
      0.05
    ],
    [
      "porter",
      0.045
    ],
    [
      "restituer",
      0.0375
    ],
    [
      "rapporter",
      0.0375
    ],
    [
      "reproduire",
      0.0325
    ],
    [
      "representer",
      0.0275
    ],
    [
      "signifier",
      0.02
    ],
    [
      "repeter",
      0.02
    ],
    [
      "refaire",
      0.02
    ],
    [
      "redonner",
      0.02
    ],
    [
      "prononcer",
      0.02
    ],
    [
      "marquer",
      0.02
    ],
    [
      "livrer",
      0.02
    ],
    [
      "enoncer",
      0.015
    ],
    [
      "emettre",
      0.015
    ],
    [
      "traduire",
      0.015
    ],
    [
      "retroceder",
      0.015
    ],
    [
      "renvoyer",
      0.015
    ],
    [
      "rejeter",
      0.015
    ],
    [
      "obtenir",
      0.015
    ],
    [
      "fructifier",
      0.015
    ],
    [
      "fournir",
      0.015
    ],
    [
      "attraper",
      0.015
    ],
    [
      "rembourser",
      0.01
    ],
    [
      "retourner",
      0.01
    ],
    [
      "tenir",
      0.01
    ],
    [
      "travailler",
      0.01
    ],
    [
      "vomir",
      0.01
    ],
    [
      "ramener",
      0.01
    ],
    [
      "poser",
      0.01
    ],
    [
      "payer",
      0.01
    ],
    [
      "observer",
      0.01
    ],
    [
      "lacher",
      0.01
    ],
    [
      "formuler",
      0.01
    ],
    [
      "exhaler",
      0.01
    ],
    [
      "repondre",
      0.0025
    ],
    [
      "repercuter",
      0.0025
    ],
    [
      "revetir",
      0.0025
    ],
    [
      "degueuler",
      0.0025
    ],
    [
      "devenir",
      0.0025
    ],
    [
      "compenser",
      0.0025
    ],
    [
      "reverberer",
      0.0025
    ]
  ],
  "an": [
    [
      "periode",
      0.175
    ],
    [
      "temps",
      0.175
    ],
    [
      "annee",
      0.1175
    ],
    [
      "berge",
      0.1175
    ],
    [
      "date",
      0.1175
    ],
    [
      "printemps",
      0.0575
    ],
    [
      "pige",
      0.0575
    ],
    [
      "hiver",
      0.0575
    ],
    [
      "cycle",
      0.0575
    ],
    [
      "age",
      0.0575
    ]
  ],
  "manier": [
    [
      "tripoter",
      0.095
    ],
    [
      "gouverner",
      0.05
    ],
    [
      "mener",
      0.05
    ],
    [
      "diriger",
      0.0425
    ],
    [
      "manipuler",
      0.0425
    ],
    [
      "user",
      0.0375
    ],
    [
      "manoeuvrer",
      0.03
    ],
    [
      "conduire",
      0.03
    ],
    [
      "travailler",
      0.025
    ],
    [
      "traiter",
      0.025
    ],
    [
      "toucher",
      0.025
    ],
    [
      "regir",
      0.025
    ],
    [
      "regenter",
      0.025
    ],
    [
      "petrir",
      0.025
    ],
    [
      "pratiquer",
      0.025
    ],
    [
      "mouvoir",
      0.025
    ],
    [
      "jouer",
      0.025
    ],
    [
      "faconner",
      0.025
    ],
    [
      "caresser",
      0.025
    ],
    [
      "agiter",
      0.025
    ],
    [
      "administrer",
      0.025
    ],
    [
      "utiliser",
      0.0175
    ],
    [
      "trifouiller",
      0.0175
    ],
    [
      "tenir",
      0.0175
    ],
    [
      "peloter",
      0.0175
    ],
    [
      "disposer",
      0.0175
    ],
    [
      "triturer",
      0.01
    ],
    [
      "tripatouiller",
      0.01
    ],
    [
      "patouiller",
      0.01
    ],
    [
      "patiner",
      0.01
    ],
    [
      "palper",
      0.01
    ],
    [
      "gerer",
      0.01
    ],
    [
      "dominer",
      0.01
    ],
    [
      "brasser",
      0.01
    ],
    [
      "actionner",
      0.01
    ],
    [
      "patrouiller",
      0.005
    ],
    [
      "modeler",
      0.005
    ],
    [
      "malaxer",
      0.005
    ],
    [
      "influencer",
      0.005
    ],
    [
      "guider",
      0.005
    ],
    [
      "chiffonner",
      0.005
    ],
    [
      "tater",
      0.005
    ]
  ],
  "manie": [
    [
      "toquade",
      0.0725
    ],
    [
      "travers",
      0.0725
    ],
    [
      "marotte",
      0.065
    ],
    [
      "passion",
      0.06
    ],
    [
      "tic",
      0.06
    ],
    [
      "folie",
      0.05
    ],
    [
      "obsession",
      0.045
    ],
    [
      "caprice",
      0.0375
    ],
    [
      "frenesie",
      0.0375
    ],
    [
      "fureur",
      0.0325
    ],
    [
      "rage",
      0.03
    ],
    [
      "delire",
      0.03
    ],
    [
      "maladie",
      0.0225
    ],
    [
      "hantise",
      0.0225
    ],
    [
      "habitude",
      0.0225
    ],
    [
      "gout",
      0.0225
    ],
    [
      "dada",
      0.0225
    ],
    [
      "alienation",
      0.0225
    ],
    [
      "monomanie",
      0.0175
    ],
    [
      "egarement",
      0.015
    ],
    [
      "vice",
      0.015
    ],
    [
      "spectre",
      0.015
    ],
    [
      "idee",
      0.015
    ],
    [
      "fantaisie",
      0.015
    ],
    [
      "faible",
      0.015
    ],
    [
      "bizarrerie",
      0.015
    ],
    [
      "demence",
      0.01
    ],
    [
      "humeur",
      0.01
    ],
    [
      "psychose",
      0.01
    ],
    [
      "maniere",
      0.0075
    ],
    [
      "furie",
      0.0075
    ],
    [
      "fievre",
      0.0075
    ],
    [
      "demangeaison",
      0.0075
    ],
    [
      "turlutaine",
      0.0025
    ],
    [
      "routine",
      0.0025
    ],
    [
      "originalite",
      0.0025
    ],
    [
      "lune",
      0.0025
    ],
    [
      "califourchon",
      0.0025
    ],
    [
      "bougeotte",
      0.0025
    ],
    [
      "bateau",
      0.0025
    ],
    [
      "accoutumance",
      0.0025
    ],
    [
      "epidemie",
      0.0025
    ]
  ],
  "melo": [],
  "demande": [
    [
      "requete",
      0.1075
    ],
    [
      "revendication",
      0.1075
    ],
    [
      "sollicitation",
      0.065
    ],
    [
      "priere",
      0.055
    ],
    [
      "supplication",
      0.05
    ],
    [
      "appel",
      0.05
    ],
    [
      "desir",
      0.035
    ],
    [
      "sommation",
      0.025
    ],
    [
      "soif",
      0.025
    ],
    [
      "petition",
      0.025
    ],
    [
      "instance",
      0.025
    ],
    [
      "demarche",
      0.025
    ],
    [
      "action",
      0.025
    ],
    [
      "reclamation",
      0.02
    ],
    [
      "quete",
      0.02
    ],
    [
      "pretention",
      0.02
    ],
    [
      "poursuite",
      0.02
    ],
    [
      "ordre",
      0.02
    ],
    [
      "imploration",
      0.02
    ],
    [
      "exigence",
      0.02
    ],
    [
      "adjuration",
      0.02
    ],
    [
      "souhait",
      0.015
    ],
    [
      "recours",
      0.015
    ],
    [
      "assignation",
      0.015
    ],
    [
      "voeu",
      0.0075
    ],
    [
      "supplique",
      0.0075
    ],
    [
      "placet",
      0.0075
    ],
    [
      "mandement",
      0.0075
    ],
    [
      "invocation",
      0.0075
    ],
    [
      "invitation",
      0.0075
    ],
    [
      "interrogation",
      0.0075
    ],
    [
      "interpellation",
      0.0075
    ],
    [
      "conjuration",
      0.0075
    ],
    [
      "commande",
      0.0075
    ],
    [
      "envie",
      0.0025
    ],
    [
      "question",
      0.0025
    ],
    [
      "quemandage",
      0.0025
    ],
    [
      "requisition",
      0.0025
    ],
    [
      "transaction",
      0.0025
    ],
    [
      "degaine",
      0.0025
    ],
    [
      "doleance",
      0.0025
    ],
    [
      "convoitise",
      0.0025
    ],
    [
      "consommation",
      0.0025
    ],
    [
      "commandement",
      0.0025
    ],
    [
      "candidature",
      0.0025
    ],
    [
      "ajournement",
      0.0025
    ],
    [
      "ecrit",
      0.0025
    ]
  ],
  "si": [
    [
      "aussi",
      0.085
    ],
    [
      "quand",
      0.085
    ],
    [
      "quelque",
      0.0425
    ],
    [
      "sauf",
      0.0425
    ],
    [
      "tant",
      0.0425
    ],
    [
      "tellement",
      0.0425
    ],
    [
      "puisque",
      0.0425
    ],
    [
      "oui",
      0.0425
    ],
    [
      "excepte",
      0.0425
    ],
    [
      "de",
      0.0425
    ],
    [
      "combien",
      0.0425
    ]
  ],
  "complot": [
    [
      "intrigue",
      0.12
    ],
    [
      "cabale",
      0.085
    ],
    [
      "alliance",
      0.06
    ],
    [
      "brigue",
      0.06
    ],
    [
      "machination",
      0.06
    ],
    [
      "tripotage",
      0.05
    ],
    [
      "menees",
      0.05
    ],
    [
      "manege",
      0.05
    ],
    [
      "ligue",
      0.05
    ],
    [
      "faction",
      0.05
    ],
    [
      "conspiration",
      0.05
    ],
    [
      "coalition",
      0.0325
    ],
    [
      "parti",
      0.0325
    ],
    [
      "trame",
      0.025
    ],
    [
      "manigance",
      0.025
    ],
    [
      "dessein",
      0.025
    ],
    [
      "conjuration",
      0.025
    ],
    [
      "association",
      0.025
    ],
    [
      "projet",
      0.015
    ],
    [
      "ruse",
      0.015
    ],
    [
      "reunion",
      0.015
    ],
    [
      "crime",
      0.0075
    ],
    [
      "conciliabule",
      0.0075
    ],
    [
      "concert",
      0.0075
    ],
    [
      "attentat",
      0.0075
    ],
    [
      "sedition",
      0.0075
    ]
  ],
  "main": [
    [
      "patte",
      0.15
    ],
    [
      "griffe",
      0.095
    ],
    [
      "autorite",
      0.0525
    ],
    [
      "pouvoir",
      0.0525
    ],
    [
      "style",
      0.0525
    ],
    [
      "ton",
      0.04
    ],
    [
      "poigne",
      0.04
    ],
    [
      "pince",
      0.04
    ],
    [
      "dependance",
      0.04
    ],
    [
      "ecriture",
      0.025
    ],
    [
      "touche",
      0.025
    ],
    [
      "patoche",
      0.025
    ],
    [
      "loi",
      0.025
    ],
    [
      "habilete",
      0.025
    ],
    [
      "effet",
      0.025
    ],
    [
      "action",
      0.025
    ],
    [
      "oeuvre",
      0.0125
    ],
    [
      "paluche",
      0.0125
    ],
    [
      "pied",
      0.0125
    ],
    [
      "plume",
      0.0125
    ],
    [
      "pogne",
      0.0125
    ],
    [
      "poing",
      0.0125
    ],
    [
      "senestre",
      0.0125
    ],
    [
      "menotte",
      0.0125
    ],
    [
      "louche",
      0.0125
    ],
    [
      "empan",
      0.0125
    ],
    [
      "dextre",
      0.0125
    ],
    [
      "cuiller",
      0.0125
    ],
    [
      "cachet",
      0.0125
    ],
    [
      "battoir",
      0.0125
    ],
    [
      "appui",
      0.0125
    ],
    [
      "aide",
      0.0125
    ],
    [
      "serre",
      0.0125
    ]
  ],
  "haut": [
    [
      "grand",
      0.0775
    ],
    [
      "beau",
      0.055
    ],
    [
      "superieur",
      0.05
    ],
    [
      "eleve",
      0.05
    ],
    [
      "important",
      0.045
    ],
    [
      "fort",
      0.0425
    ],
    [
      "gros",
      0.0375
    ],
    [
      "eminent",
      0.0275
    ],
    [
      "sommet",
      0.0275
    ],
    [
      "noble",
      0.0275
    ],
    [
      "profond",
      0.0225
    ],
    [
      "sublime",
      0.0225
    ],
    [
      "bon",
      0.02
    ],
    [
      "superbe",
      0.02
    ],
    [
      "releve",
      0.0175
    ],
    [
      "extreme",
      0.015
    ],
    [
      "fier",
      0.015
    ],
    [
      "eclatant",
      0.015
    ],
    [
      "retentissant",
      0.0125
    ],
    [
      "remarquable",
      0.0125
    ],
    [
      "puissant",
      0.0125
    ],
    [
      "faite",
      0.0125
    ],
    [
      "comble",
      0.0125
    ],
    [
      "arrogant",
      0.01
    ],
    [
      "considerable",
      0.01
    ],
    [
      "hauteur",
      0.01
    ],
    [
      "vif",
      0.01
    ],
    [
      "eloigne",
      0.0075
    ],
    [
      "sonore",
      0.0075
    ],
    [
      "cime",
      0.0075
    ],
    [
      "vieux",
      0.005
    ],
    [
      "tete",
      0.005
    ],
    [
      "transcendant",
      0.005
    ],
    [
      "tonitruant",
      0.005
    ],
    [
      "supreme",
      0.005
    ],
    [
      "resonnant",
      0.005
    ],
    [
      "pointe",
      0.005
    ],
    [
      "orgueilleux",
      0.005
    ],
    [
      "intense",
      0.005
    ],
    [
      "aigu",
      0.005
    ],
    [
      "altier",
      0.005
    ],
    [
      "ancien",
      0.005
    ],
    [
      "exagere",
      0.005
    ],
    [
      "hautain",
      0.005
    ],
    [
      "heroique",
      0.005
    ],
    [
      "percant",
      0.0025
    ],
    [
      "pinacle",
      0.0025
    ],
    [
      "recule",
      0.0025
    ],
    [
      "rencheri",
      0.0025
    ],
    [
      "sommite",
      0.0025
    ],
    [
      "sourcilleux",
      0.0025
    ],
    [
      "soutenu",
      0.0025
    ],
    [
      "elevation",
      0.0025
    ],
    [
      "eminence",
      0.0025
    ],
    [
      "ethere",
      0.0025
    ],
    [
      "ouvertement",
      0.0025
    ],
    [
      "nettement",
      0.0025
    ],
    [
      "crete",
      0.0025
    ],
    [
      "digne",
      0.0025
    ],
    [
      "dominant",
      0.0025
    ],
    [
      "dedaigneux",
      0.0025
    ],
    [
      "exemplaire",
      0.0025
    ],
    [
      "fleche",
      0.0025
    ],
    [
      "fortement",
      0.0025
    ],
    [
      "franchement",
      0.0025
    ],
    [
      "hautement",
      0.0025
    ],
    [
      "long",
      0.0025
    ],
    [
      "proeminent",
      0.0
    ],
    [
      "perche",
      0.0
    ],
    [
      "noeud",
      0.0
    ],
    [
      "loin",
      0.0
    ],
    [
      "publiquement",
      0.0
    ],
    [
      "ronflant",
      0.0
    ],
    [
      "sureleve",
      0.0
    ],
    [
      "toiture",
      0.0
    ],
    [
      "vibrant",
      0.0
    ],
    [
      "edifiant",
      0.0
    ],
    [
      "elance",
      0.0
    ],
    [
      "leve",
      0.0
    ],
    [
      "intensement",
      0.0
    ],
    [
      "front",
      0.0
    ],
    [
      "altitude",
      0.0
    ],
    [
      "apogee",
      0.0
    ],
    [
      "colline",
      0.0
    ],
    [
      "corsage",
      0.0
    ],
    [
      "couronnement",
      0.0
    ],
    [
      "culminant",
      0.0
    ],
    [
      "celeste",
      0.0
    ],
    [
      "dessus",
      0.0
    ],
    [
      "dresse",
      0.0
    ],
    [
      "demesure",
      0.0
    ],
    [
      "fortune",
      0.0
    ],
    [
      "epice",
      0.0
    ]
  ],
  "mec": [
    [
      "type",
      0.18
    ],
    [
      "homme",
      0.1625
    ],
    [
      "gars",
      0.065
    ],
    [
      "gonze",
      0.065
    ],
    [
      "individu",
      0.0475
    ],
    [
      "bete",
      0.0475
    ],
    [
      "bougre",
      0.0475
    ],
    [
      "amant",
      0.0475
    ],
    [
      "personne",
      0.0325
    ],
    [
      "maquereau",
      0.0325
    ],
    [
      "jules",
      0.0325
    ],
    [
      "gnard",
      0.0325
    ],
    [
      "gazier",
      0.0325
    ],
    [
      "dur",
      0.0325
    ],
    [
      "bonhomme",
      0.0325
    ],
    [
      "caid",
      0.015
    ],
    [
      "fiasse",
      0.015
    ],
    [
      "julot",
      0.015
    ],
    [
      "mecton",
      0.015
    ],
    [
      "pante",
      0.015
    ],
    [
      "souteneur",
      0.015
    ]
  ],
  "facon": [
    [
      "maniere",
      0.0875
    ],
    [
      "allure",
      0.0575
    ],
    [
      "style",
      0.0525
    ],
    [
      "genre",
      0.05
    ],
    [
      "forme",
      0.04
    ],
    [
      "procede",
      0.035
    ],
    [
      "air",
      0.035
    ],
    [
      "comportement",
      0.03
    ],
    [
      "tenue",
      0.025
    ],
    [
      "methode",
      0.025
    ],
    [
      "facture",
      0.025
    ],
    [
      "fabrication",
      0.025
    ],
    [
      "art",
      0.025
    ],
    [
      "moyen",
      0.0225
    ],
    [
      "ton",
      0.0225
    ],
    [
      "tour",
      0.02
    ],
    [
      "mode",
      0.02
    ],
    [
      "exterieur",
      0.02
    ],
    [
      "maintien",
      0.015
    ],
    [
      "travail",
      0.015
    ],
    [
      "type",
      0.015
    ],
    [
      "sorte",
      0.0125
    ],
    [
      "simagree",
      0.0125
    ],
    [
      "marche",
      0.0125
    ],
    [
      "griffe",
      0.0125
    ],
    [
      "faire",
      0.0125
    ],
    [
      "ameublissement",
      0.0125
    ],
    [
      "technique",
      0.0075
    ],
    [
      "ressource",
      0.0075
    ],
    [
      "preparation",
      0.0075
    ],
    [
      "ouvrage",
      0.0075
    ],
    [
      "mine",
      0.0075
    ],
    [
      "minauderie",
      0.0075
    ],
    [
      "invention",
      0.0075
    ],
    [
      "creation",
      0.0075
    ],
    [
      "dehors",
      0.0075
    ],
    [
      "degaine",
      0.0075
    ],
    [
      "execution",
      0.0075
    ],
    [
      "formation",
      0.0075
    ],
    [
      "tactique",
      0.005
    ],
    [
      "pose",
      0.005
    ],
    [
      "politesse",
      0.005
    ],
    [
      "modalite",
      0.005
    ],
    [
      "marque",
      0.005
    ],
    [
      "histoire",
      0.005
    ],
    [
      "guise",
      0.005
    ],
    [
      "grace",
      0.005
    ],
    [
      "fabrique",
      0.005
    ],
    [
      "confection",
      0.005
    ],
    [
      "appret",
      0.005
    ],
    [
      "hersage",
      0.0025
    ],
    [
      "hesitation",
      0.0025
    ],
    [
      "labour",
      0.0025
    ],
    [
      "roulage",
      0.0025
    ],
    [
      "habitude",
      0.0025
    ],
    [
      "grimace",
      0.0025
    ],
    [
      "espece",
      0.0025
    ],
    [
      "coupe",
      0.0025
    ],
    [
      "configuration",
      0.0025
    ],
    [
      "chemin",
      0.0025
    ],
    [
      "binage",
      0.0025
    ],
    [
      "agio",
      0.0025
    ],
    [
      "sarclage",
      0.0025
    ]
  ],
  "avant": [
    [
      "auparavant",
      0.16
    ],
    [
      "devant",
      0.0875
    ],
    [
      "front",
      0.0525
    ],
    [
      "proue",
      0.0525
    ],
    [
      "supra",
      0.035
    ],
    [
      "precedemment",
      0.035
    ],
    [
      "d'abord",
      0.035
    ],
    [
      "anciennement",
      0.035
    ],
    [
      "facade",
      0.015
    ],
    [
      "jadis",
      0.015
    ],
    [
      "loin",
      0.015
    ],
    [
      "naguere",
      0.015
    ],
    [
      "nez",
      0.015
    ],
    [
      "premierement",
      0.015
    ],
    [
      "profondement",
      0.015
    ],
    [
      "prealablement",
      0.015
    ],
    [
      "tard",
      0.015
    ],
    [
      "tete",
      0.015
    ],
    [
      "anterieur",
      0.015
    ],
    [
      "anterieurement",
      0.015
    ],
    [
      "autrefois",
      0.015
    ],
    [
      "avance",
      0.015
    ],
    [
      "deja",
      0.015
    ],
    [
      "etrave",
      0.015
    ]
  ],
  "minuit": [
    [
      "medianoche",
      1.0
    ]
  ],
  "vivre": [
    [
      "nourriture",
      1.0
    ]
  ],
  "piste": [
    [
      "voie",
      0.1775
    ],
    [
      "chemin",
      0.1175
    ],
    [
      "passage",
      0.1175
    ],
    [
      "trace",
      0.0575
    ],
    [
      "stade",
      0.0575
    ],
    [
      "signe",
      0.0575
    ],
    [
      "sentier",
      0.0575
    ],
    [
      "rink",
      0.0575
    ],
    [
      "indication",
      0.0575
    ],
    [
      "foulee",
      0.0575
    ],
    [
      "cirque",
      0.0575
    ],
    [
      "chaussee",
      0.0575
    ],
    [
      "xyste",
      0.0575
    ]
  ],
  "pister": [
    [
      "suivre",
      0.23
    ],
    [
      "filer",
      0.1525
    ],
    [
      "surveiller",
      0.1525
    ],
    [
      "epier",
      0.1525
    ],
    [
      "depister",
      0.075
    ],
    [
      "guetter",
      0.075
    ],
    [
      "rechercher",
      0.075
    ]
  ],
  "oeil": [
    [
      "regard",
      0.1275
    ],
    [
      "vue",
      0.095
    ],
    [
      "bourgeon",
      0.0625
    ],
    [
      "prunelle",
      0.0625
    ],
    [
      "noeud",
      0.03
    ],
    [
      "oeillard",
      0.03
    ],
    [
      "oeillet",
      0.03
    ],
    [
      "oeilleton",
      0.03
    ],
    [
      "ouverture",
      0.03
    ],
    [
      "pousse",
      0.03
    ],
    [
      "pupille",
      0.03
    ],
    [
      "quinquet",
      0.03
    ],
    [
      "microviseur",
      0.03
    ],
    [
      "marcotte",
      0.03
    ],
    [
      "anus",
      0.03
    ],
    [
      "bille",
      0.03
    ],
    [
      "boucle",
      0.03
    ],
    [
      "bouton",
      0.03
    ],
    [
      "chas",
      0.03
    ],
    [
      "chasse",
      0.03
    ],
    [
      "excroissance",
      0.03
    ],
    [
      "vision",
      0.03
    ]
  ],
  "river": [
    [
      "attacher",
      0.165
    ],
    [
      "fixer",
      0.1375
    ],
    [
      "arrimer",
      0.0975
    ],
    [
      "assembler",
      0.0775
    ],
    [
      "lier",
      0.0675
    ],
    [
      "assujettir",
      0.0675
    ],
    [
      "clouer",
      0.0475
    ],
    [
      "enchainer",
      0.0475
    ],
    [
      "immobiliser",
      0.0475
    ],
    [
      "visser",
      0.0375
    ],
    [
      "joindre",
      0.0375
    ],
    [
      "boulonner",
      0.0375
    ],
    [
      "coller",
      0.0275
    ],
    [
      "ficher",
      0.0175
    ],
    [
      "petrifier",
      0.0175
    ],
    [
      "ancrer",
      0.0075
    ],
    [
      "atteler",
      0.0075
    ],
    [
      "riveter",
      0.0075
    ],
    [
      "s'atteler",
      0.0075
    ],
    [
      "transir",
      0.0075
    ]
  ],
  "habit": [
    [
      "vetement",
      0.145
    ],
    [
      "costume",
      0.0825
    ],
    [
      "manteau",
      0.06
    ],
    [
      "mise",
      0.06
    ],
    [
      "veste",
      0.04
    ],
    [
      "tenue",
      0.04
    ],
    [
      "harnais",
      0.04
    ],
    [
      "habillement",
      0.04
    ],
    [
      "fringue",
      0.04
    ],
    [
      "exterieur",
      0.04
    ],
    [
      "effet",
      0.04
    ],
    [
      "parure",
      0.0175
    ],
    [
      "redingote",
      0.0175
    ],
    [
      "smoking",
      0.0175
    ],
    [
      "spencer",
      0.0175
    ],
    [
      "jaquette",
      0.0175
    ],
    [
      "harde",
      0.0175
    ],
    [
      "fripe",
      0.0175
    ],
    [
      "frac",
      0.0175
    ],
    [
      "defroque",
      0.0175
    ],
    [
      "dehors",
      0.0175
    ],
    [
      "cape",
      0.0175
    ],
    [
      "aspect",
      0.0175
    ],
    [
      "apparence",
      0.0175
    ],
    [
      "uniforme",
      0.0175
    ]
  ],
  "briller": [
    [
      "resplendir",
      0.0875
    ],
    [
      "luire",
      0.0775
    ],
    [
      "etinceler",
      0.0725
    ],
    [
      "flamboyer",
      0.0675
    ],
    [
      "reluire",
      0.0625
    ],
    [
      "rayonner",
      0.0475
    ],
    [
      "scintiller",
      0.0425
    ],
    [
      "fulgurer",
      0.0375
    ],
    [
      "chatoyer",
      0.0225
    ],
    [
      "marquer",
      0.0225
    ],
    [
      "eblouir",
      0.0225
    ],
    [
      "eclater",
      0.0175
    ],
    [
      "triompher",
      0.0175
    ],
    [
      "seduire",
      0.0175
    ],
    [
      "rutiler",
      0.0175
    ],
    [
      "petiller",
      0.0175
    ],
    [
      "paraitre",
      0.0175
    ],
    [
      "miroiter",
      0.0175
    ],
    [
      "fasciner",
      0.0175
    ],
    [
      "eclairer",
      0.0125
    ],
    [
      "irradier",
      0.0125
    ],
    [
      "impressionner",
      0.0125
    ],
    [
      "charmer",
      0.0125
    ],
    [
      "brillanter",
      0.0125
    ],
    [
      "reussir",
      0.0075
    ],
    [
      "reflechir",
      0.0075
    ],
    [
      "refleter",
      0.0075
    ],
    [
      "frapper",
      0.0075
    ],
    [
      "flamber",
      0.0075
    ],
    [
      "exceller",
      0.0075
    ],
    [
      "radier",
      0.0025
    ],
    [
      "ravir",
      0.0025
    ],
    [
      "ressortir",
      0.0025
    ],
    [
      "s'animer",
      0.0025
    ],
    [
      "s'illuminer",
      0.0025
    ],
    [
      "s'iriser",
      0.0025
    ],
    [
      "s'irradier",
      0.0025
    ],
    [
      "eclabousser",
      0.0025
    ],
    [
      "etaler",
      0.0025
    ],
    [
      "queter",
      0.0025
    ],
    [
      "performer",
      0.0025
    ],
    [
      "aveugler",
      0.0025
    ],
    [
      "brasiller",
      0.0025
    ],
    [
      "briquer",
      0.0025
    ],
    [
      "ensorceler",
      0.0025
    ],
    [
      "fleurir",
      0.0025
    ],
    [
      "illuminer",
      0.0025
    ],
    [
      "iriser",
      0.0025
    ],
    [
      "l'emporter",
      0.0025
    ]
  ],
  "tels": [
    [
      "semblable",
      0.2725
    ],
    [
      "pareil",
      0.18
    ],
    [
      "assimile",
      0.09
    ],
    [
      "celui",
      0.09
    ],
    [
      "certain",
      0.09
    ],
    [
      "comme",
      0.09
    ],
    [
      "meme",
      0.09
    ],
    [
      "quelqu'un",
      0.09
    ]
  ],
  "magique": [
    [
      "merveilleux",
      0.1225
    ],
    [
      "fascinant",
      0.085
    ],
    [
      "etonnant",
      0.0725
    ],
    [
      "extraordinaire",
      0.06
    ],
    [
      "fantastique",
      0.06
    ],
    [
      "prodigieux",
      0.06
    ],
    [
      "sensationnel",
      0.06
    ],
    [
      "envoutant",
      0.0475
    ],
    [
      "enchanteur",
      0.0475
    ],
    [
      "beau",
      0.0475
    ],
    [
      "feerique",
      0.035
    ],
    [
      "sublime",
      0.035
    ],
    [
      "prestigieux",
      0.0225
    ],
    [
      "mysterieux",
      0.0225
    ],
    [
      "fascinateur",
      0.0225
    ],
    [
      "fantasmagorique",
      0.0225
    ],
    [
      "thaumaturgique",
      0.01
    ],
    [
      "surprenant",
      0.01
    ],
    [
      "surnaturel",
      0.01
    ],
    [
      "subjuguant",
      0.01
    ],
    [
      "occulte",
      0.01
    ],
    [
      "magnetique",
      0.01
    ],
    [
      "enivrant",
      0.01
    ],
    [
      "enchante",
      0.01
    ],
    [
      "divinatoire",
      0.01
    ],
    [
      "captivant",
      0.01
    ],
    [
      "cabalistique",
      0.01
    ],
    [
      "esoterique",
      0.01
    ]
  ],
  "na": [],
  "controler": [
    [
      "verifier",
      0.125
    ],
    [
      "examiner",
      0.1125
    ],
    [
      "voir",
      0.1
    ],
    [
      "dominer",
      0.0625
    ],
    [
      "dompter",
      0.05
    ],
    [
      "maitriser",
      0.05
    ],
    [
      "eplucher",
      0.0375
    ],
    [
      "tamiser",
      0.0375
    ],
    [
      "juger",
      0.0375
    ],
    [
      "inspecter",
      0.0375
    ],
    [
      "experimenter",
      0.0375
    ],
    [
      "critiquer",
      0.0375
    ],
    [
      "constater",
      0.025
    ],
    [
      "peser",
      0.025
    ],
    [
      "s'assurer",
      0.025
    ],
    [
      "regner",
      0.0125
    ],
    [
      "reguler",
      0.0125
    ],
    [
      "soumettre",
      0.0125
    ],
    [
      "superviser",
      0.0125
    ],
    [
      "surmonter",
      0.0125
    ],
    [
      "surveiller",
      0.0125
    ],
    [
      "recoler",
      0.0125
    ],
    [
      "quadriller",
      0.0125
    ],
    [
      "pointer",
      0.0125
    ],
    [
      "occuper",
      0.0125
    ],
    [
      "essayer",
      0.0125
    ],
    [
      "contenir",
      0.0125
    ],
    [
      "censurer",
      0.0125
    ],
    [
      "administrer",
      0.0125
    ],
    [
      "vaincre",
      0.0125
    ]
  ],
  "controle": [
    [
      "verification",
      0.11
    ],
    [
      "examen",
      0.09
    ],
    [
      "maitrise",
      0.09
    ],
    [
      "inspection",
      0.065
    ],
    [
      "experience",
      0.0425
    ],
    [
      "empire",
      0.0425
    ],
    [
      "domination",
      0.0425
    ],
    [
      "monitoring",
      0.02
    ],
    [
      "orthogenie",
      0.02
    ],
    [
      "pointage",
      0.02
    ],
    [
      "poincon",
      0.02
    ],
    [
      "possession",
      0.02
    ],
    [
      "quadrillage",
      0.02
    ],
    [
      "regulation",
      0.02
    ],
    [
      "sondage",
      0.02
    ],
    [
      "supervision",
      0.02
    ],
    [
      "surveillance",
      0.02
    ],
    [
      "marque",
      0.02
    ],
    [
      "limitation",
      0.02
    ],
    [
      "arret",
      0.02
    ],
    [
      "blocage",
      0.02
    ],
    [
      "calme",
      0.02
    ],
    [
      "censure",
      0.02
    ],
    [
      "critique",
      0.02
    ],
    [
      "domestication",
      0.02
    ],
    [
      "encadrement",
      0.02
    ],
    [
      "experimentation",
      0.02
    ],
    [
      "gouvernement",
      0.02
    ],
    [
      "visite",
      0.02
    ]
  ],
  "apprecier": [
    [
      "estimer",
      0.1275
    ],
    [
      "juger",
      0.075
    ],
    [
      "evaluer",
      0.075
    ],
    [
      "peser",
      0.0575
    ],
    [
      "considerer",
      0.0475
    ],
    [
      "entendre",
      0.0425
    ],
    [
      "gouter",
      0.0425
    ],
    [
      "voir",
      0.0425
    ],
    [
      "examiner",
      0.035
    ],
    [
      "aimer",
      0.035
    ],
    [
      "mesurer",
      0.03
    ],
    [
      "jauger",
      0.025
    ],
    [
      "connaitre",
      0.025
    ],
    [
      "compter",
      0.025
    ],
    [
      "comprendre",
      0.025
    ],
    [
      "sentir",
      0.02
    ],
    [
      "venerer",
      0.02
    ],
    [
      "sonder",
      0.015
    ],
    [
      "priser",
      0.015
    ],
    [
      "discerner",
      0.015
    ],
    [
      "admirer",
      0.015
    ],
    [
      "savourer",
      0.01
    ],
    [
      "saisir",
      0.01
    ],
    [
      "noter",
      0.01
    ],
    [
      "determiner",
      0.01
    ],
    [
      "croire",
      0.01
    ],
    [
      "coter",
      0.01
    ],
    [
      "concevoir",
      0.01
    ],
    [
      "comparer",
      0.01
    ],
    [
      "calculer",
      0.01
    ],
    [
      "approuver",
      0.01
    ],
    [
      "jouir",
      0.005
    ],
    [
      "expertiser",
      0.005
    ],
    [
      "deguster",
      0.005
    ],
    [
      "affectionner",
      0.005
    ],
    [
      "surestimer",
      0.005
    ]
  ],
  "mon": [],
  "parcourir": [
    [
      "examiner",
      0.085
    ],
    [
      "visiter",
      0.085
    ],
    [
      "traverser",
      0.065
    ],
    [
      "sillonner",
      0.065
    ],
    [
      "faire",
      0.065
    ],
    [
      "explorer",
      0.065
    ],
    [
      "courir",
      0.065
    ],
    [
      "survoler",
      0.0425
    ],
    [
      "regarder",
      0.0425
    ],
    [
      "prospecter",
      0.0425
    ],
    [
      "inspecter",
      0.0425
    ],
    [
      "franchir",
      0.0425
    ],
    [
      "feuilleter",
      0.0425
    ],
    [
      "couvrir",
      0.0425
    ],
    [
      "battre",
      0.0425
    ],
    [
      "rebattre",
      0.02
    ],
    [
      "patrouiller",
      0.02
    ],
    [
      "lire",
      0.02
    ],
    [
      "arpenter",
      0.02
    ],
    [
      "aller",
      0.02
    ],
    [
      "suivre",
      0.02
    ]
  ],
  "parcours": [
    [
      "examiner",
      0.085
    ],
    [
      "visiter",
      0.085
    ],
    [
      "traverser",
      0.065
    ],
    [
      "sillonner",
      0.065
    ],
    [
      "faire",
      0.065
    ],
    [
      "explorer",
      0.065
    ],
    [
      "courir",
      0.065
    ],
    [
      "survoler",
      0.0425
    ],
    [
      "regarder",
      0.0425
    ],
    [
      "prospecter",
      0.0425
    ],
    [
      "inspecter",
      0.0425
    ],
    [
      "franchir",
      0.0425
    ],
    [
      "feuilleter",
      0.0425
    ],
    [
      "couvrir",
      0.0425
    ],
    [
      "battre",
      0.0425
    ],
    [
      "rebattre",
      0.02
    ],
    [
      "patrouiller",
      0.02
    ],
    [
      "lire",
      0.02
    ],
    [
      "arpenter",
      0.02
    ],
    [
      "aller",
      0.02
    ],
    [
      "suivre",
      0.02
    ]
  ],
  "saler": [
    [
      "assaisonner",
      0.2
    ],
    [
      "depouiller",
      0.2
    ],
    [
      "punir",
      0.2
    ],
    [
      "sabrer",
      0.2
    ],
    [
      "saupoudrer",
      0.2
    ]
  ],
  "sale": [
    [
      "assaisonner",
      0.2
    ],
    [
      "depouiller",
      0.2
    ],
    [
      "punir",
      0.2
    ],
    [
      "sabrer",
      0.2
    ],
    [
      "saupoudrer",
      0.2
    ]
  ],
  "coquin": [
    [
      "fripon",
      0.085
    ],
    [
      "vaurien",
      0.0825
    ],
    [
      "fripouille",
      0.0775
    ],
    [
      "polisson",
      0.055
    ],
    [
      "bandit",
      0.045
    ],
    [
      "truand",
      0.045
    ],
    [
      "gredin",
      0.0375
    ],
    [
      "voleur",
      0.03
    ],
    [
      "maraud",
      0.03
    ],
    [
      "garnement",
      0.03
    ],
    [
      "chenapan",
      0.03
    ],
    [
      "canaille",
      0.025
    ],
    [
      "sacripant",
      0.025
    ],
    [
      "scelerat",
      0.0225
    ],
    [
      "miserable",
      0.0175
    ],
    [
      "filou",
      0.0175
    ],
    [
      "espiegle",
      0.0175
    ],
    [
      "escroc",
      0.0175
    ],
    [
      "diable",
      0.0175
    ],
    [
      "brigand",
      0.0175
    ],
    [
      "egrillard",
      0.015
    ],
    [
      "mechant",
      0.015
    ],
    [
      "drole",
      0.015
    ],
    [
      "vil",
      0.01
    ],
    [
      "rosse",
      0.01
    ],
    [
      "rossard",
      0.01
    ],
    [
      "libertin",
      0.01
    ],
    [
      "leste",
      0.01
    ],
    [
      "gueux",
      0.01
    ],
    [
      "grivois",
      0.01
    ],
    [
      "gaulois",
      0.01
    ],
    [
      "galopin",
      0.01
    ],
    [
      "brigandeau",
      0.01
    ],
    [
      "malicieux",
      0.0075
    ],
    [
      "maroufle",
      0.0075
    ],
    [
      "matin",
      0.0075
    ],
    [
      "pendard",
      0.0075
    ],
    [
      "libre",
      0.0075
    ],
    [
      "graveleux",
      0.0075
    ],
    [
      "galapiat",
      0.0075
    ],
    [
      "gaillard",
      0.0075
    ],
    [
      "faquin",
      0.0075
    ],
    [
      "belitre",
      0.0075
    ],
    [
      "aigrefin",
      0.0075
    ],
    [
      "lache",
      0.0025
    ],
    [
      "lutin",
      0.0025
    ],
    [
      "croustillant",
      0.0025
    ]
  ],
  "cocu": [
    [
      "trompe",
      0.22
    ],
    [
      "bafoue",
      0.11
    ],
    [
      "berne",
      0.11
    ],
    [
      "blouse",
      0.11
    ],
    [
      "chanceux",
      0.11
    ],
    [
      "coiffe",
      0.11
    ],
    [
      "cornard",
      0.11
    ],
    [
      "deshonore",
      0.11
    ]
  ],
  "vu": [
    [
      "examiner",
      0.0425
    ],
    [
      "apercevoir",
      0.04
    ],
    [
      "comprendre",
      0.04
    ],
    [
      "decouvrir",
      0.04
    ],
    [
      "concevoir",
      0.0375
    ],
    [
      "saisir",
      0.035
    ],
    [
      "connaitre",
      0.035
    ],
    [
      "entendre",
      0.03
    ],
    [
      "regarder",
      0.03
    ],
    [
      "penser",
      0.03
    ],
    [
      "considerer",
      0.0275
    ],
    [
      "remarquer",
      0.0225
    ],
    [
      "juger",
      0.0225
    ],
    [
      "imaginer",
      0.0225
    ],
    [
      "percevoir",
      0.02
    ],
    [
      "observer",
      0.02
    ],
    [
      "penetrer",
      0.02
    ],
    [
      "trouver",
      0.0175
    ],
    [
      "verifier",
      0.0175
    ],
    [
      "discerner",
      0.015
    ],
    [
      "constater",
      0.015
    ],
    [
      "experimenter",
      0.015
    ],
    [
      "pratiquer",
      0.015
    ],
    [
      "eprouver",
      0.015
    ],
    [
      "etudier",
      0.0125
    ],
    [
      "reperer",
      0.0125
    ],
    [
      "controler",
      0.0125
    ],
    [
      "apprecier",
      0.0125
    ],
    [
      "estimer",
      0.01
    ],
    [
      "frequenter",
      0.01
    ],
    [
      "suivre",
      0.01
    ],
    [
      "s'apercevoir",
      0.0075
    ],
    [
      "percer",
      0.0075
    ],
    [
      "envisager",
      0.0075
    ],
    [
      "embrasser",
      0.0075
    ],
    [
      "distinguer",
      0.0075
    ],
    [
      "reflechir",
      0.005
    ],
    [
      "realiser",
      0.005
    ],
    [
      "peser",
      0.005
    ],
    [
      "noter",
      0.005
    ],
    [
      "entrevoir",
      0.005
    ],
    [
      "contempler",
      0.005
    ],
    [
      "aviser",
      0.005
    ],
    [
      "assister",
      0.005
    ],
    [
      "visiter",
      0.005
    ],
    [
      "viser",
      0.005
    ],
    [
      "veiller",
      0.005
    ],
    [
      "rencontrer",
      0.005
    ],
    [
      "inspecter",
      0.005
    ],
    [
      "frayer",
      0.005
    ],
    [
      "analyser",
      0.005
    ],
    [
      "subir",
      0.0025
    ],
    [
      "surprendre",
      0.0025
    ],
    [
      "zieuter",
      0.0025
    ],
    [
      "ecouter",
      0.0025
    ],
    [
      "savoir",
      0.0025
    ],
    [
      "admettre",
      0.0025
    ],
    [
      "lire",
      0.0025
    ],
    [
      "prevoir",
      0.0025
    ],
    [
      "recoler",
      0.0025
    ],
    [
      "s'assurer",
      0.0025
    ],
    [
      "s'enquerir",
      0.0025
    ],
    [
      "s'accointer",
      0.0025
    ],
    [
      "revoir",
      0.0025
    ],
    [
      "jauger",
      0.0025
    ],
    [
      "inventorier",
      0.0025
    ],
    [
      "donner",
      0.0025
    ],
    [
      "dominer",
      0.0025
    ],
    [
      "croiser",
      0.0025
    ],
    [
      "surplomber",
      0.0
    ],
    [
      "survenir",
      0.0
    ],
    [
      "visionner",
      0.0
    ],
    [
      "visualiser",
      0.0
    ],
    [
      "voisiner",
      0.0
    ],
    [
      "voyager",
      0.0
    ],
    [
      "s'informer",
      0.0
    ],
    [
      "s'imaginer",
      0.0
    ],
    [
      "planer",
      0.0
    ],
    [
      "mater",
      0.0
    ],
    [
      "loucher",
      0.0
    ],
    [
      "contacter",
      0.0
    ],
    [
      "commercer",
      0.0
    ]
  ],
  "plaque": [
    [
      "decoration",
      0.0825
    ],
    [
      "tablette",
      0.0825
    ],
    [
      "table",
      0.0825
    ],
    [
      "lamelle",
      0.0825
    ],
    [
      "lame",
      0.0825
    ],
    [
      "insigne",
      0.0825
    ],
    [
      "feuille",
      0.0825
    ],
    [
      "ecaille",
      0.04
    ],
    [
      "souvenir",
      0.04
    ],
    [
      "poele",
      0.04
    ],
    [
      "panonceau",
      0.04
    ],
    [
      "medaille",
      0.04
    ],
    [
      "inscription",
      0.04
    ],
    [
      "fiche",
      0.04
    ],
    [
      "crachat",
      0.04
    ],
    [
      "chocolat",
      0.04
    ],
    [
      "ecriteau",
      0.04
    ]
  ],
  "plaquer": [
    [
      "abandonner",
      0.1675
    ],
    [
      "appliquer",
      0.0825
    ],
    [
      "lacher",
      0.0825
    ],
    [
      "quitter",
      0.0825
    ],
    [
      "mettre",
      0.0675
    ],
    [
      "laisser",
      0.05
    ],
    [
      "coller",
      0.05
    ],
    [
      "etaler",
      0.0325
    ],
    [
      "rompre",
      0.0325
    ],
    [
      "raccrocher",
      0.0325
    ],
    [
      "planter",
      0.0325
    ],
    [
      "larguer",
      0.0325
    ],
    [
      "enduire",
      0.0325
    ],
    [
      "delaisser",
      0.0325
    ],
    [
      "placarder",
      0.015
    ],
    [
      "liquider",
      0.015
    ],
    [
      "contreplaquer",
      0.015
    ],
    [
      "balancer",
      0.015
    ],
    [
      "aplatir",
      0.015
    ],
    [
      "adosser",
      0.015
    ],
    [
      "s'aplatir",
      0.015
    ]
  ],
  "croco": [
    [
      "crocodile",
      1.0
    ]
  ],
  "chaussure": [
    [
      "soulier",
      0.245
    ],
    [
      "botte",
      0.05
    ],
    [
      "bottine",
      0.05
    ],
    [
      "brodequin",
      0.05
    ],
    [
      "godillot",
      0.05
    ],
    [
      "bottillon",
      0.04
    ],
    [
      "pantoufle",
      0.0275
    ],
    [
      "chausson",
      0.0275
    ],
    [
      "socque",
      0.02
    ],
    [
      "sabot",
      0.02
    ],
    [
      "peniche",
      0.02
    ],
    [
      "patin",
      0.02
    ],
    [
      "godasse",
      0.02
    ],
    [
      "galoche",
      0.02
    ],
    [
      "croquenot",
      0.02
    ],
    [
      "babouche",
      0.02
    ],
    [
      "richelieu",
      0.0075
    ],
    [
      "ribouis",
      0.0075
    ],
    [
      "pompe",
      0.0075
    ],
    [
      "pataugas",
      0.0075
    ],
    [
      "sandale",
      0.0075
    ],
    [
      "savate",
      0.0075
    ],
    [
      "sorlot",
      0.0075
    ],
    [
      "spartiate",
      0.0075
    ],
    [
      "tatane",
      0.0075
    ],
    [
      "tennis",
      0.0075
    ],
    [
      "mule",
      0.0075
    ],
    [
      "mocassin",
      0.0075
    ],
    [
      "grolle",
      0.0075
    ],
    [
      "ballerine",
      0.0075
    ],
    [
      "bas",
      0.0075
    ],
    [
      "basket",
      0.0075
    ],
    [
      "bateau",
      0.0075
    ],
    [
      "boots",
      0.0075
    ],
    [
      "caoutchouc",
      0.0075
    ],
    [
      "charentaise",
      0.0075
    ],
    [
      "chaussette",
      0.0075
    ],
    [
      "cothurne",
      0.0075
    ],
    [
      "escarpin",
      0.0075
    ],
    [
      "espadrille",
      0.0075
    ]
  ],
  "hein": [
    [
      "comment",
      0.22
    ],
    [
      "eh",
      0.22
    ],
    [
      "hem",
      0.11
    ],
    [
      "pardon",
      0.11
    ],
    [
      "quoi",
      0.11
    ]
  ],
  "localise": [
    [
      "determiner",
      0.1525
    ],
    [
      "limiter",
      0.1525
    ],
    [
      "positionner",
      0.1525
    ],
    [
      "restreindre",
      0.075
    ],
    [
      "renfermer",
      0.075
    ],
    [
      "placer",
      0.075
    ],
    [
      "detecter",
      0.075
    ],
    [
      "circonscrire",
      0.075
    ],
    [
      "borner",
      0.075
    ],
    [
      "situer",
      0.075
    ]
  ],
  "localiser": [
    [
      "determiner",
      0.1525
    ],
    [
      "limiter",
      0.1525
    ],
    [
      "positionner",
      0.1525
    ],
    [
      "restreindre",
      0.075
    ],
    [
      "renfermer",
      0.075
    ],
    [
      "placer",
      0.075
    ],
    [
      "detecter",
      0.075
    ],
    [
      "circonscrire",
      0.075
    ],
    [
      "borner",
      0.075
    ],
    [
      "situer",
      0.075
    ]
  ],
  "focaliser": [
    [
      "concentrer",
      0.5
    ],
    [
      "diriger",
      0.25
    ],
    [
      "polariser",
      0.25
    ]
  ],
  "jaja": [],
  "jaloux": [
    [
      "ombrageux",
      0.1575
    ],
    [
      "craintif",
      0.105
    ],
    [
      "desireux",
      0.105
    ],
    [
      "envieux",
      0.105
    ],
    [
      "soupconneux",
      0.105
    ],
    [
      "soucieux",
      0.0525
    ],
    [
      "possessif",
      0.0525
    ],
    [
      "pointilleux",
      0.0525
    ],
    [
      "exclusif",
      0.0525
    ],
    [
      "defiant",
      0.0525
    ],
    [
      "becheur",
      0.0525
    ],
    [
      "attache",
      0.0525
    ],
    [
      "zoile",
      0.0525
    ]
  ],
  "avouer": [
    [
      "reconnaitre",
      0.095
    ],
    [
      "confesser",
      0.0725
    ],
    [
      "convenir",
      0.0725
    ],
    [
      "reveler",
      0.0725
    ],
    [
      "admettre",
      0.06
    ],
    [
      "declarer",
      0.06
    ],
    [
      "parler",
      0.0475
    ],
    [
      "decouvrir",
      0.0475
    ],
    [
      "accorder",
      0.0475
    ],
    [
      "dire",
      0.035
    ],
    [
      "s'allonger",
      0.0225
    ],
    [
      "s'accuser",
      0.0225
    ],
    [
      "deballer",
      0.0225
    ],
    [
      "constater",
      0.0225
    ],
    [
      "consentir",
      0.0225
    ],
    [
      "confier",
      0.0225
    ],
    [
      "approuver",
      0.0225
    ],
    [
      "ratifier",
      0.01
    ],
    [
      "s'affaler",
      0.01
    ],
    [
      "sanctionner",
      0.01
    ],
    [
      "enteriner",
      0.01
    ],
    [
      "conceder",
      0.01
    ],
    [
      "appuyer",
      0.01
    ],
    [
      "accoucher",
      0.01
    ]
  ],
  "vis": [
    [
      "boulon",
      0.2
    ],
    [
      "piton",
      0.2
    ],
    [
      "presse",
      0.2
    ],
    [
      "spirale",
      0.2
    ]
  ],
  "victoire": [
    [
      "succes",
      0.235
    ],
    [
      "gain",
      0.175
    ],
    [
      "triomphe",
      0.175
    ],
    [
      "avantage",
      0.1175
    ],
    [
      "reussite",
      0.1175
    ],
    [
      "bataille",
      0.0575
    ],
    [
      "conquete",
      0.0575
    ],
    [
      "consecration",
      0.0575
    ]
  ],
  "imbecile": [
    [
      "bete",
      0.12
    ],
    [
      "idiot",
      0.1175
    ],
    [
      "sot",
      0.115
    ],
    [
      "ballot",
      0.08
    ],
    [
      "stupide",
      0.075
    ],
    [
      "cretin",
      0.04
    ],
    [
      "niais",
      0.04
    ],
    [
      "ignorant",
      0.0225
    ],
    [
      "con",
      0.0225
    ],
    [
      "abruti",
      0.02
    ],
    [
      "cornichon",
      0.02
    ],
    [
      "gourde",
      0.02
    ],
    [
      "ane",
      0.015
    ],
    [
      "inintelligent",
      0.015
    ],
    [
      "buse",
      0.015
    ],
    [
      "borne",
      0.015
    ],
    [
      "arriere",
      0.0125
    ],
    [
      "cruche",
      0.0125
    ],
    [
      "debile",
      0.0125
    ],
    [
      "incapable",
      0.01
    ],
    [
      "ganache",
      0.01
    ],
    [
      "fou",
      0.01
    ],
    [
      "faible",
      0.01
    ],
    [
      "andouille",
      0.01
    ],
    [
      "aberrant",
      0.01
    ],
    [
      "ramolli",
      0.005
    ],
    [
      "minus",
      0.005
    ],
    [
      "impuissant",
      0.005
    ],
    [
      "degenere",
      0.005
    ],
    [
      "demeure",
      0.005
    ],
    [
      "cul",
      0.005
    ],
    [
      "couillon",
      0.005
    ],
    [
      "corniaud",
      0.005
    ],
    [
      "bouche",
      0.005
    ],
    [
      "manche",
      0.0025
    ],
    [
      "melon",
      0.0025
    ],
    [
      "moule",
      0.0025
    ],
    [
      "noix",
      0.0025
    ],
    [
      "panouille",
      0.0025
    ],
    [
      "poire",
      0.0025
    ],
    [
      "saucisse",
      0.0025
    ],
    [
      "sinoque",
      0.0025
    ],
    [
      "fourneau",
      0.0025
    ],
    [
      "enfle",
      0.0025
    ],
    [
      "abeti",
      0.0025
    ],
    [
      "anchois",
      0.0025
    ],
    [
      "bedole",
      0.0025
    ],
    [
      "brele",
      0.0025
    ],
    [
      "conard",
      0.0025
    ],
    [
      "couenne",
      0.0025
    ],
    [
      "croute",
      0.0025
    ],
    [
      "emmanche",
      0.0025
    ],
    [
      "tourte",
      0.0025
    ]
  ],
  "concurrencer": [
    [
      "rivaliser",
      1.0
    ]
  ],
  "concurrence": [
    [
      "competition",
      0.1875
    ],
    [
      "lutte",
      0.1875
    ],
    [
      "rivalite",
      0.1875
    ],
    [
      "bataille",
      0.125
    ],
    [
      "emulation",
      0.125
    ],
    [
      "affrontement",
      0.0625
    ],
    [
      "antagonisme",
      0.0625
    ],
    [
      "concours",
      0.0625
    ]
  ],
  "vessie": [],
  "recette": [
    [
      "revenu",
      0.0875
    ],
    [
      "gain",
      0.0725
    ],
    [
      "procede",
      0.0725
    ],
    [
      "truc",
      0.0725
    ],
    [
      "moyen",
      0.0575
    ],
    [
      "methode",
      0.0575
    ],
    [
      "ressource",
      0.0575
    ],
    [
      "systeme",
      0.0425
    ],
    [
      "rentree",
      0.0425
    ],
    [
      "profit",
      0.0425
    ],
    [
      "benefice",
      0.0425
    ],
    [
      "budget",
      0.0425
    ],
    [
      "secret",
      0.0275
    ],
    [
      "produit",
      0.0275
    ],
    [
      "fruit",
      0.0275
    ],
    [
      "finance",
      0.0275
    ],
    [
      "tactique",
      0.0125
    ],
    [
      "reception",
      0.0125
    ],
    [
      "rendement",
      0.0125
    ],
    [
      "recouvrement",
      0.0125
    ],
    [
      "precepte",
      0.0125
    ],
    [
      "perception",
      0.0125
    ],
    [
      "guide",
      0.0125
    ],
    [
      "ficelle",
      0.0125
    ],
    [
      "boni",
      0.0125
    ],
    [
      "argent",
      0.0125
    ],
    [
      "admission",
      0.0125
    ],
    [
      "technique",
      0.0125
    ]
  ],
  "down": [],
  "girl": [
    [
      "danseuse",
      0.5
    ],
    [
      "figurant",
      0.5
    ]
  ],
  "yeah": [],
  "in": [
    [
      "moderne",
      0.285
    ],
    [
      "nouveau",
      0.285
    ],
    [
      "chic",
      0.1425
    ],
    [
      "moderniste",
      0.1425
    ]
  ],
  "tell": [],
  "out": [],
  "lover": [
    [
      "enrouler",
      0.5
    ],
    [
      "rouler",
      0.5
    ]
  ],
  "to": [],
  "m": [],
  "for": [
    [
      "juridiction",
      1.0
    ]
  ],
  "baby": [
    [
      "bebe",
      1.0
    ]
  ],
  "more": [],
  "are": [],
  "haver": [],
  "let": [],
  "if": [
    [
      "egouttoir",
      1.0
    ]
  ],
  "r": [],
  "not": [],
  "set": [
    [
      "manche",
      1.0
    ]
  ],
  "harmonie": [
    [
      "accord",
      0.1475
    ],
    [
      "union",
      0.0575
    ],
    [
      "entente",
      0.0275
    ],
    [
      "fraternite",
      0.0275
    ],
    [
      "equilibre",
      0.025
    ],
    [
      "unite",
      0.025
    ],
    [
      "alliance",
      0.025
    ],
    [
      "affinite",
      0.0225
    ],
    [
      "concordance",
      0.0225
    ],
    [
      "conformite",
      0.0225
    ],
    [
      "convenance",
      0.0225
    ],
    [
      "ordre",
      0.0175
    ],
    [
      "ensemble",
      0.0175
    ],
    [
      "correspondance",
      0.0175
    ],
    [
      "communion",
      0.0175
    ],
    [
      "arrangement",
      0.0175
    ],
    [
      "concert",
      0.0175
    ],
    [
      "rapport",
      0.0175
    ],
    [
      "symetrie",
      0.0175
    ],
    [
      "regularite",
      0.0125
    ],
    [
      "rythme",
      0.0125
    ],
    [
      "proportion",
      0.0125
    ],
    [
      "paix",
      0.0125
    ],
    [
      "orchestre",
      0.0125
    ],
    [
      "communaute",
      0.0125
    ],
    [
      "combinaison",
      0.0125
    ],
    [
      "cadence",
      0.0125
    ],
    [
      "sympathie",
      0.0125
    ],
    [
      "conciliation",
      0.0125
    ],
    [
      "amitie",
      0.0125
    ],
    [
      "ajustement",
      0.0125
    ],
    [
      "symphonie",
      0.0075
    ],
    [
      "musique",
      0.0075
    ],
    [
      "concorde",
      0.0075
    ],
    [
      "assortiment",
      0.0075
    ],
    [
      "grace",
      0.005
    ],
    [
      "melodie",
      0.005
    ],
    [
      "organisation",
      0.005
    ],
    [
      "ressemblance",
      0.005
    ],
    [
      "simplicite",
      0.005
    ],
    [
      "unisson",
      0.005
    ],
    [
      "elegance",
      0.005
    ],
    [
      "eurythmie",
      0.005
    ],
    [
      "consonance",
      0.005
    ],
    [
      "adaptation",
      0.005
    ],
    [
      "agencement",
      0.005
    ],
    [
      "balancement",
      0.005
    ],
    [
      "beaute",
      0.005
    ],
    [
      "choeur",
      0.005
    ],
    [
      "coherence",
      0.005
    ],
    [
      "cohesion",
      0.005
    ],
    [
      "economie",
      0.0025
    ],
    [
      "unanimite",
      0.0025
    ],
    [
      "tranquillite",
      0.0025
    ],
    [
      "similitude",
      0.0025
    ],
    [
      "orpheon",
      0.0025
    ],
    [
      "ordonnance",
      0.0025
    ],
    [
      "nombre",
      0.0025
    ],
    [
      "delicatesse",
      0.0025
    ],
    [
      "fanfare",
      0.0025
    ],
    [
      "homogeneite",
      0.0025
    ],
    [
      "hymne",
      0.0025
    ],
    [
      "joliesse",
      0.0025
    ],
    [
      "justesse",
      0.0
    ],
    [
      "mouvement",
      0.0
    ],
    [
      "metaphonie",
      0.0
    ],
    [
      "philharmonie",
      0.0
    ],
    [
      "ponderation",
      0.0
    ],
    [
      "rondeur",
      0.0
    ],
    [
      "reconciliation",
      0.0
    ],
    [
      "sonorite",
      0.0
    ],
    [
      "suavite",
      0.0
    ],
    [
      "incantation",
      0.0
    ],
    [
      "harmonique",
      0.0
    ],
    [
      "fluidite",
      0.0
    ],
    [
      "accordance",
      0.0
    ],
    [
      "alliteration",
      0.0
    ],
    [
      "appariement",
      0.0
    ],
    [
      "compatibilite",
      0.0
    ],
    [
      "contrepoint",
      0.0
    ],
    [
      "euphonie",
      0.0
    ],
    [
      "finalite",
      0.0
    ],
    [
      "accompagnement",
      0.0
    ]
  ],
  "pendre": [
    [
      "pendiller",
      0.16
    ],
    [
      "accrocher",
      0.0675
    ],
    [
      "attacher",
      0.0675
    ],
    [
      "suspendre",
      0.0675
    ],
    [
      "etrangler",
      0.045
    ],
    [
      "tuer",
      0.045
    ],
    [
      "tomber",
      0.045
    ],
    [
      "s'affaisser",
      0.045
    ],
    [
      "fixer",
      0.045
    ],
    [
      "descendre",
      0.045
    ],
    [
      "pendouiller",
      0.02
    ],
    [
      "rappeler",
      0.02
    ],
    [
      "retomber",
      0.02
    ],
    [
      "s'attacher",
      0.02
    ],
    [
      "s'avachir",
      0.02
    ],
    [
      "stranguler",
      0.02
    ],
    [
      "lanterner",
      0.02
    ],
    [
      "flotter",
      0.02
    ],
    [
      "executer",
      0.02
    ],
    [
      "bequiller",
      0.02
    ],
    [
      "brandiller",
      0.02
    ],
    [
      "brancher",
      0.02
    ],
    [
      "baller",
      0.02
    ],
    [
      "arrimer",
      0.02
    ],
    [
      "appendre",
      0.02
    ]
  ],
  "pendu": [
    [
      "pendiller",
      0.16
    ],
    [
      "accrocher",
      0.0675
    ],
    [
      "attacher",
      0.0675
    ],
    [
      "suspendre",
      0.0675
    ],
    [
      "etrangler",
      0.045
    ],
    [
      "tuer",
      0.045
    ],
    [
      "tomber",
      0.045
    ],
    [
      "s'affaisser",
      0.045
    ],
    [
      "fixer",
      0.045
    ],
    [
      "descendre",
      0.045
    ],
    [
      "pendouiller",
      0.02
    ],
    [
      "rappeler",
      0.02
    ],
    [
      "retomber",
      0.02
    ],
    [
      "s'attacher",
      0.02
    ],
    [
      "s'avachir",
      0.02
    ],
    [
      "stranguler",
      0.02
    ],
    [
      "lanterner",
      0.02
    ],
    [
      "flotter",
      0.02
    ],
    [
      "executer",
      0.02
    ],
    [
      "bequiller",
      0.02
    ],
    [
      "brandiller",
      0.02
    ],
    [
      "brancher",
      0.02
    ],
    [
      "baller",
      0.02
    ],
    [
      "arrimer",
      0.02
    ],
    [
      "appendre",
      0.02
    ]
  ],
  "matin": [
    [
      "aube",
      0.2325
    ],
    [
      "aurore",
      0.1525
    ],
    [
      "seuil",
      0.075
    ],
    [
      "matinee",
      0.075
    ],
    [
      "mat'",
      0.075
    ],
    [
      "commencement",
      0.075
    ],
    [
      "tot",
      0.075
    ]
  ],
  "chateau": [
    [
      "habitation",
      0.1225
    ],
    [
      "maison",
      0.0925
    ],
    [
      "abri",
      0.065
    ],
    [
      "castel",
      0.065
    ],
    [
      "pavillon",
      0.065
    ],
    [
      "forteresse",
      0.0525
    ],
    [
      "manoir",
      0.0525
    ],
    [
      "palais",
      0.04
    ],
    [
      "krak",
      0.04
    ],
    [
      "gentilhommiere",
      0.04
    ],
    [
      "demeure",
      0.04
    ],
    [
      "chartreuse",
      0.04
    ],
    [
      "fort",
      0.025
    ],
    [
      "folie",
      0.025
    ],
    [
      "citadelle",
      0.025
    ],
    [
      "campagne",
      0.025
    ],
    [
      "bastille",
      0.025
    ],
    [
      "bastide",
      0.025
    ],
    [
      "acrostole",
      0.0125
    ],
    [
      "chatelet",
      0.0125
    ],
    [
      "donjon",
      0.0125
    ],
    [
      "hotel",
      0.0125
    ],
    [
      "residence",
      0.0125
    ],
    [
      "timonerie",
      0.0125
    ]
  ],
  "arriver": [
    [
      "parvenir",
      0.06
    ],
    [
      "tomber",
      0.0525
    ],
    [
      "venir",
      0.0525
    ],
    [
      "atteindre",
      0.0475
    ],
    [
      "surgir",
      0.045
    ],
    [
      "survenir",
      0.045
    ],
    [
      "aller",
      0.04
    ],
    [
      "gagner",
      0.0325
    ],
    [
      "aborder",
      0.03
    ],
    [
      "aboutir",
      0.03
    ],
    [
      "accoster",
      0.03
    ],
    [
      "toucher",
      0.03
    ],
    [
      "reussir",
      0.025
    ],
    [
      "percer",
      0.025
    ],
    [
      "advenir",
      0.02
    ],
    [
      "apparaitre",
      0.02
    ],
    [
      "monter",
      0.02
    ],
    [
      "s'elever",
      0.0175
    ],
    [
      "approcher",
      0.0175
    ],
    [
      "acceder",
      0.0175
    ],
    [
      "entrer",
      0.0125
    ],
    [
      "emerger",
      0.01
    ],
    [
      "s'approcher",
      0.01
    ],
    [
      "s'accomplir",
      0.01
    ],
    [
      "pointer",
      0.01
    ],
    [
      "joindre",
      0.01
    ],
    [
      "affluer",
      0.01
    ],
    [
      "echoir",
      0.005
    ],
    [
      "suivre",
      0.005
    ],
    [
      "finir",
      0.005
    ],
    [
      "accourir",
      0.005
    ],
    [
      "surprendre",
      0.0025
    ],
    [
      "sonner",
      0.0025
    ],
    [
      "s'ensuivre",
      0.0025
    ],
    [
      "s'abouler",
      0.0025
    ],
    [
      "preceder",
      0.0025
    ],
    [
      "debarquer",
      0.0025
    ],
    [
      "devancer",
      0.0025
    ],
    [
      "atterrir",
      0.0025
    ],
    [
      "amerrir",
      0.0025
    ],
    [
      "abattre",
      0.0025
    ]
  ],
  "arrive": [
    [
      "parvenir",
      0.06
    ],
    [
      "tomber",
      0.0525
    ],
    [
      "venir",
      0.0525
    ],
    [
      "atteindre",
      0.0475
    ],
    [
      "surgir",
      0.045
    ],
    [
      "survenir",
      0.045
    ],
    [
      "aller",
      0.04
    ],
    [
      "gagner",
      0.0325
    ],
    [
      "aborder",
      0.03
    ],
    [
      "aboutir",
      0.03
    ],
    [
      "accoster",
      0.03
    ],
    [
      "toucher",
      0.03
    ],
    [
      "reussir",
      0.025
    ],
    [
      "percer",
      0.025
    ],
    [
      "advenir",
      0.02
    ],
    [
      "apparaitre",
      0.02
    ],
    [
      "monter",
      0.02
    ],
    [
      "s'elever",
      0.0175
    ],
    [
      "approcher",
      0.0175
    ],
    [
      "acceder",
      0.0175
    ],
    [
      "entrer",
      0.0125
    ],
    [
      "emerger",
      0.01
    ],
    [
      "s'approcher",
      0.01
    ],
    [
      "s'accomplir",
      0.01
    ],
    [
      "pointer",
      0.01
    ],
    [
      "joindre",
      0.01
    ],
    [
      "affluer",
      0.01
    ],
    [
      "echoir",
      0.005
    ],
    [
      "suivre",
      0.005
    ],
    [
      "finir",
      0.005
    ],
    [
      "accourir",
      0.005
    ],
    [
      "surprendre",
      0.0025
    ],
    [
      "sonner",
      0.0025
    ],
    [
      "s'ensuivre",
      0.0025
    ],
    [
      "s'abouler",
      0.0025
    ],
    [
      "preceder",
      0.0025
    ],
    [
      "debarquer",
      0.0025
    ],
    [
      "devancer",
      0.0025
    ],
    [
      "atterrir",
      0.0025
    ],
    [
      "amerrir",
      0.0025
    ],
    [
      "abattre",
      0.0025
    ]
  ],
  "juin": [
    [
      "messidor",
      0.5
    ],
    [
      "prairial",
      0.5
    ]
  ],
  "feter": [
    [
      "celebrer",
      0.2525
    ],
    [
      "traiter",
      0.125
    ],
    [
      "sanctifier",
      0.0625
    ],
    [
      "regaler",
      0.0625
    ],
    [
      "marquer",
      0.0625
    ],
    [
      "honorer",
      0.0625
    ],
    [
      "faire",
      0.0625
    ],
    [
      "manifester",
      0.03
    ],
    [
      "festoyer",
      0.03
    ],
    [
      "consacrer",
      0.03
    ],
    [
      "commemorer",
      0.03
    ],
    [
      "chomer",
      0.03
    ],
    [
      "arroser",
      0.03
    ],
    [
      "aduler",
      0.03
    ],
    [
      "accueillir",
      0.03
    ],
    [
      "solenniser",
      0.03
    ]
  ],
  "fete": [
    [
      "bringue",
      0.0675
    ],
    [
      "rejouissance",
      0.0575
    ],
    [
      "festivite",
      0.0525
    ],
    [
      "festin",
      0.0475
    ],
    [
      "bombance",
      0.0425
    ],
    [
      "kermesse",
      0.04
    ],
    [
      "ceremonie",
      0.04
    ],
    [
      "noce",
      0.035
    ],
    [
      "frairie",
      0.03
    ],
    [
      "reception",
      0.025
    ],
    [
      "nouba",
      0.025
    ],
    [
      "foire",
      0.025
    ],
    [
      "festival",
      0.025
    ],
    [
      "debauche",
      0.025
    ],
    [
      "bombe",
      0.025
    ],
    [
      "bamboche",
      0.025
    ],
    [
      "bal",
      0.025
    ],
    [
      "banquet",
      0.02
    ],
    [
      "gala",
      0.02
    ],
    [
      "reunion",
      0.0175
    ],
    [
      "regal",
      0.0175
    ],
    [
      "celebration",
      0.0175
    ],
    [
      "amusement",
      0.0175
    ],
    [
      "partie",
      0.0125
    ],
    [
      "delice",
      0.0125
    ],
    [
      "divertissement",
      0.0125
    ],
    [
      "solennite",
      0.0075
    ],
    [
      "soiree",
      0.0075
    ],
    [
      "sauterie",
      0.0075
    ],
    [
      "recreation",
      0.0075
    ],
    [
      "raout",
      0.0075
    ],
    [
      "inauguration",
      0.0075
    ],
    [
      "bamboula",
      0.0075
    ],
    [
      "baloche",
      0.0075
    ],
    [
      "agapes",
      0.0075
    ],
    [
      "preveil",
      0.0025
    ],
    [
      "pardon",
      0.0025
    ],
    [
      "matinee",
      0.0025
    ],
    [
      "liturgie",
      0.0025
    ],
    [
      "java",
      0.0025
    ],
    [
      "redoute",
      0.0025
    ],
    [
      "ribouldingue",
      0.0025
    ],
    [
      "reveillon",
      0.0025
    ],
    [
      "station",
      0.0025
    ],
    [
      "surboum",
      0.0025
    ],
    [
      "veglione",
      0.0025
    ],
    [
      "vie",
      0.0025
    ],
    [
      "vogue",
      0.0025
    ],
    [
      "ferie",
      0.0025
    ],
    [
      "fiesta",
      0.0025
    ],
    [
      "ferrade",
      0.0025
    ],
    [
      "anniversaire",
      0.0025
    ],
    [
      "apparat",
      0.0025
    ],
    [
      "apport",
      0.0025
    ],
    [
      "assemblee",
      0.0025
    ],
    [
      "bacchanale",
      0.0025
    ],
    [
      "ballade",
      0.0025
    ],
    [
      "balocho",
      0.0025
    ],
    [
      "boum",
      0.0025
    ],
    [
      "cocagne",
      0.0025
    ],
    [
      "commemoration",
      0.0025
    ],
    [
      "ducasse",
      0.0025
    ],
    [
      "dedicace",
      0.0025
    ],
    [
      "degagement",
      0.0025
    ],
    [
      "enchantement",
      0.0025
    ],
    [
      "evenement",
      0.0025
    ]
  ],
  "bal": [
    [
      "fete",
      0.135
    ],
    [
      "bastringue",
      0.09
    ],
    [
      "danse",
      0.0675
    ],
    [
      "reception",
      0.0675
    ],
    [
      "surboum",
      0.0425
    ],
    [
      "sauterie",
      0.0425
    ],
    [
      "guinche",
      0.0425
    ],
    [
      "dancing",
      0.0425
    ],
    [
      "boum",
      0.0425
    ],
    [
      "surpatte",
      0.02
    ],
    [
      "soiree",
      0.02
    ],
    [
      "salon",
      0.02
    ],
    [
      "redoute",
      0.02
    ],
    [
      "musette",
      0.02
    ],
    [
      "guinguette",
      0.02
    ],
    [
      "frairie",
      0.02
    ],
    [
      "boite",
      0.02
    ],
    [
      "valse",
      0.02
    ]
  ],
  "rubis": [
    [
      "grenat",
      0.3325
    ],
    [
      "pierre",
      0.3325
    ],
    [
      "gemme",
      0.165
    ],
    [
      "rouge",
      0.165
    ]
  ],
  "topaze": [
    [
      "chrysolithe",
      0.3325
    ],
    [
      "jaune",
      0.3325
    ],
    [
      "pierre",
      0.3325
    ]
  ],
  "blanche": [
    [
      "pur",
      0.1075
    ],
    [
      "blanchatre",
      0.0525
    ],
    [
      "net",
      0.0525
    ],
    [
      "pale",
      0.0425
    ],
    [
      "vierge",
      0.0425
    ],
    [
      "propre",
      0.03
    ],
    [
      "opalin",
      0.03
    ],
    [
      "immacule",
      0.03
    ],
    [
      "clair",
      0.03
    ],
    [
      "candide",
      0.03
    ],
    [
      "virginal",
      0.02
    ],
    [
      "vide",
      0.02
    ],
    [
      "nu",
      0.02
    ],
    [
      "limpide",
      0.02
    ],
    [
      "laiteux",
      0.02
    ],
    [
      "ivoirin",
      0.02
    ],
    [
      "innocent",
      0.02
    ],
    [
      "espace",
      0.02
    ],
    [
      "bleme",
      0.02
    ],
    [
      "lacte",
      0.01
    ],
    [
      "lactescent",
      0.01
    ],
    [
      "ivoire",
      0.01
    ],
    [
      "intervalle",
      0.01
    ],
    [
      "interligne",
      0.01
    ],
    [
      "ingenu",
      0.01
    ],
    [
      "lave",
      0.01
    ],
    [
      "lilial",
      0.01
    ],
    [
      "livide",
      0.01
    ],
    [
      "mille",
      0.01
    ],
    [
      "niveen",
      0.01
    ],
    [
      "platine",
      0.01
    ],
    [
      "platine",
      0.01
    ],
    [
      "supreme",
      0.01
    ],
    [
      "vin",
      0.01
    ],
    [
      "incolore",
      0.01
    ],
    [
      "impersonnel",
      0.01
    ],
    [
      "albugine",
      0.01
    ],
    [
      "alpestre",
      0.01
    ],
    [
      "argente",
      0.01
    ],
    [
      "azurant",
      0.01
    ],
    [
      "blafard",
      0.01
    ],
    [
      "blancheur",
      0.01
    ],
    [
      "blanchi",
      0.01
    ],
    [
      "chenu",
      0.01
    ],
    [
      "creme",
      0.01
    ],
    [
      "enfarine",
      0.01
    ],
    [
      "fenetre",
      0.01
    ],
    [
      "filet",
      0.01
    ],
    [
      "albe",
      0.01
    ]
  ],
  "robe": [
    [
      "enveloppe",
      0.085
    ],
    [
      "peau",
      0.0625
    ],
    [
      "rochet",
      0.0625
    ],
    [
      "ecorce",
      0.0425
    ],
    [
      "vetement",
      0.0425
    ],
    [
      "tunique",
      0.0425
    ],
    [
      "poil",
      0.0425
    ],
    [
      "pelure",
      0.0425
    ],
    [
      "pelage",
      0.0425
    ],
    [
      "fourrure",
      0.0425
    ],
    [
      "neglige",
      0.02
    ],
    [
      "peignoir",
      0.02
    ],
    [
      "peplum",
      0.02
    ],
    [
      "sari",
      0.02
    ],
    [
      "soutane",
      0.02
    ],
    [
      "surplis",
      0.02
    ],
    [
      "toge",
      0.02
    ],
    [
      "toilette",
      0.02
    ],
    [
      "toison",
      0.02
    ],
    [
      "tonte",
      0.02
    ],
    [
      "haik",
      0.02
    ],
    [
      "gandoura",
      0.02
    ],
    [
      "aube",
      0.02
    ],
    [
      "cafetan",
      0.02
    ],
    [
      "cape",
      0.02
    ],
    [
      "chiton",
      0.02
    ],
    [
      "djellaba",
      0.02
    ],
    [
      "domino",
      0.02
    ],
    [
      "douillette",
      0.02
    ],
    [
      "deshabille",
      0.02
    ],
    [
      "fourreau",
      0.02
    ],
    [
      "froc",
      0.02
    ],
    [
      "epitoge",
      0.02
    ]
  ],
  "longue": [
    [
      "grand",
      0.07
    ],
    [
      "prolixe",
      0.07
    ],
    [
      "verbeux",
      0.06
    ],
    [
      "abondant",
      0.0475
    ],
    [
      "allonge",
      0.0475
    ],
    [
      "diffus",
      0.0475
    ],
    [
      "vaste",
      0.0475
    ],
    [
      "interminable",
      0.035
    ],
    [
      "infini",
      0.035
    ],
    [
      "immense",
      0.035
    ],
    [
      "copieux",
      0.035
    ],
    [
      "eternel",
      0.0225
    ],
    [
      "etendu",
      0.0225
    ],
    [
      "elance",
      0.0225
    ],
    [
      "vieux",
      0.0225
    ],
    [
      "illimite",
      0.0225
    ],
    [
      "haut",
      0.0225
    ],
    [
      "filandreux",
      0.0225
    ],
    [
      "entier",
      0.0225
    ],
    [
      "ennuyeux",
      0.0225
    ],
    [
      "effile",
      0.0225
    ],
    [
      "bavard",
      0.0225
    ],
    [
      "ancien",
      0.0225
    ],
    [
      "longueur",
      0.01
    ],
    [
      "mortel",
      0.01
    ],
    [
      "oblong",
      0.01
    ],
    [
      "tardif",
      0.01
    ],
    [
      "tombant",
      0.01
    ],
    [
      "longuet",
      0.01
    ],
    [
      "lointain",
      0.01
    ],
    [
      "lent",
      0.01
    ],
    [
      "imposant",
      0.01
    ],
    [
      "grele",
      0.01
    ],
    [
      "excessif",
      0.01
    ],
    [
      "barlong",
      0.01
    ],
    [
      "antique",
      0.01
    ],
    [
      "tout",
      0.01
    ]
  ],
  "long": [
    [
      "grand",
      0.07
    ],
    [
      "prolixe",
      0.07
    ],
    [
      "verbeux",
      0.06
    ],
    [
      "abondant",
      0.0475
    ],
    [
      "allonge",
      0.0475
    ],
    [
      "diffus",
      0.0475
    ],
    [
      "vaste",
      0.0475
    ],
    [
      "interminable",
      0.035
    ],
    [
      "infini",
      0.035
    ],
    [
      "immense",
      0.035
    ],
    [
      "copieux",
      0.035
    ],
    [
      "eternel",
      0.0225
    ],
    [
      "etendu",
      0.0225
    ],
    [
      "elance",
      0.0225
    ],
    [
      "vieux",
      0.0225
    ],
    [
      "illimite",
      0.0225
    ],
    [
      "haut",
      0.0225
    ],
    [
      "filandreux",
      0.0225
    ],
    [
      "entier",
      0.0225
    ],
    [
      "ennuyeux",
      0.0225
    ],
    [
      "effile",
      0.0225
    ],
    [
      "bavard",
      0.0225
    ],
    [
      "ancien",
      0.0225
    ],
    [
      "longueur",
      0.01
    ],
    [
      "mortel",
      0.01
    ],
    [
      "oblong",
      0.01
    ],
    [
      "tardif",
      0.01
    ],
    [
      "tombant",
      0.01
    ],
    [
      "longuet",
      0.01
    ],
    [
      "lointain",
      0.01
    ],
    [
      "lent",
      0.01
    ],
    [
      "imposant",
      0.01
    ],
    [
      "grele",
      0.01
    ],
    [
      "excessif",
      0.01
    ],
    [
      "barlong",
      0.01
    ],
    [
      "antique",
      0.01
    ],
    [
      "tout",
      0.01
    ]
  ],
  "jardin": [
    [
      "verger",
      0.1025
    ],
    [
      "clos",
      0.07
    ],
    [
      "enclos",
      0.07
    ],
    [
      "parc",
      0.07
    ],
    [
      "plantation",
      0.07
    ],
    [
      "paradis",
      0.0325
    ],
    [
      "potager",
      0.0325
    ],
    [
      "promenade",
      0.0325
    ],
    [
      "pepiniere",
      0.0325
    ],
    [
      "square",
      0.0325
    ],
    [
      "terre",
      0.0325
    ],
    [
      "zoo",
      0.0325
    ],
    [
      "ouche",
      0.0325
    ],
    [
      "menagerie",
      0.0325
    ],
    [
      "marais",
      0.0325
    ],
    [
      "jardinet",
      0.0325
    ],
    [
      "hortillonnage",
      0.0325
    ],
    [
      "fruitier",
      0.0325
    ],
    [
      "eldorado",
      0.0325
    ],
    [
      "courtil",
      0.0325
    ],
    [
      "closerie",
      0.0325
    ],
    [
      "eden",
      0.0325
    ]
  ],
  "serrer": [
    [
      "attacher",
      0.0525
    ],
    [
      "presser",
      0.0525
    ],
    [
      "entourer",
      0.0475
    ],
    [
      "comprimer",
      0.0325
    ],
    [
      "prendre",
      0.0325
    ],
    [
      "etreindre",
      0.03
    ],
    [
      "enserrer",
      0.025
    ],
    [
      "resserrer",
      0.0225
    ],
    [
      "oppresser",
      0.0225
    ],
    [
      "lier",
      0.0225
    ],
    [
      "gener",
      0.0225
    ],
    [
      "enlacer",
      0.0225
    ],
    [
      "encercler",
      0.0225
    ],
    [
      "embrasser",
      0.0225
    ],
    [
      "ceindre",
      0.02
    ],
    [
      "enfermer",
      0.02
    ],
    [
      "sangler",
      0.0175
    ],
    [
      "renfermer",
      0.0175
    ],
    [
      "pincer",
      0.0175
    ],
    [
      "etouffer",
      0.015
    ],
    [
      "ecraser",
      0.015
    ],
    [
      "tasser",
      0.015
    ],
    [
      "contraindre",
      0.015
    ],
    [
      "brider",
      0.015
    ],
    [
      "bloquer",
      0.015
    ],
    [
      "ranger",
      0.01
    ],
    [
      "poursuivre",
      0.01
    ],
    [
      "placer",
      0.01
    ],
    [
      "mettre",
      0.01
    ],
    [
      "joindre",
      0.01
    ],
    [
      "freiner",
      0.01
    ],
    [
      "entasser",
      0.01
    ],
    [
      "accoler",
      0.01
    ],
    [
      "assembler",
      0.01
    ],
    [
      "coincer",
      0.01
    ],
    [
      "contracter",
      0.01
    ],
    [
      "emprisonner",
      0.01
    ],
    [
      "etrangler",
      0.0075
    ],
    [
      "saisir",
      0.0075
    ],
    [
      "raser",
      0.0075
    ],
    [
      "mouler",
      0.0075
    ],
    [
      "froler",
      0.0075
    ],
    [
      "empoigner",
      0.0075
    ],
    [
      "caresser",
      0.0075
    ],
    [
      "boucler",
      0.0075
    ],
    [
      "bander",
      0.0075
    ],
    [
      "atteler",
      0.0075
    ],
    [
      "appuyer",
      0.0075
    ],
    [
      "rapprocher",
      0.005
    ],
    [
      "rencogner",
      0.005
    ],
    [
      "souquer",
      0.005
    ],
    [
      "suivre",
      0.005
    ],
    [
      "talonner",
      0.005
    ],
    [
      "visser",
      0.005
    ],
    [
      "mordre",
      0.005
    ],
    [
      "gripper",
      0.005
    ],
    [
      "cacher",
      0.005
    ],
    [
      "caler",
      0.005
    ],
    [
      "caser",
      0.005
    ],
    [
      "corder",
      0.005
    ],
    [
      "effleurer",
      0.005
    ],
    [
      "entrelacer",
      0.005
    ],
    [
      "lacer",
      0.0
    ],
    [
      "remiser",
      0.0
    ],
    [
      "s'approcher",
      0.0
    ],
    [
      "economiser",
      0.0
    ],
    [
      "epreindre",
      0.0
    ],
    [
      "harper",
      0.0
    ],
    [
      "gainer",
      0.0
    ],
    [
      "froisser",
      0.0
    ],
    [
      "emmailloter",
      0.0
    ],
    [
      "crisper",
      0.0
    ],
    [
      "corseter",
      0.0
    ],
    [
      "compresser",
      0.0
    ],
    [
      "carguer",
      0.0
    ],
    [
      "boudiner",
      0.0
    ]
  ],
  "poing": [
    [
      "allonge",
      0.3325
    ],
    [
      "main",
      0.3325
    ],
    [
      "poigne",
      0.3325
    ]
  ],
  "regarder": [
    [
      "examiner",
      0.1
    ],
    [
      "considerer",
      0.0675
    ],
    [
      "voir",
      0.055
    ],
    [
      "estimer",
      0.04
    ],
    [
      "observer",
      0.0325
    ],
    [
      "viser",
      0.03
    ],
    [
      "scruter",
      0.03
    ],
    [
      "prendre",
      0.03
    ],
    [
      "devisager",
      0.03
    ],
    [
      "etudier",
      0.0275
    ],
    [
      "penser",
      0.0275
    ],
    [
      "contempler",
      0.0275
    ],
    [
      "fixer",
      0.0225
    ],
    [
      "toucher",
      0.0225
    ],
    [
      "zieuter",
      0.0225
    ],
    [
      "compter",
      0.02
    ],
    [
      "traiter",
      0.02
    ],
    [
      "juger",
      0.0175
    ],
    [
      "envisager",
      0.0175
    ],
    [
      "suivre",
      0.015
    ],
    [
      "reluquer",
      0.015
    ],
    [
      "mater",
      0.015
    ],
    [
      "lorgner",
      0.015
    ],
    [
      "inspecter",
      0.015
    ],
    [
      "concerner",
      0.015
    ],
    [
      "bigler",
      0.015
    ],
    [
      "analyser",
      0.015
    ],
    [
      "inventorier",
      0.0125
    ],
    [
      "reputer",
      0.0125
    ],
    [
      "interesser",
      0.01
    ],
    [
      "trouver",
      0.0075
    ],
    [
      "peser",
      0.0075
    ],
    [
      "admirer",
      0.0075
    ],
    [
      "eplucher",
      0.0025
    ],
    [
      "economiser",
      0.0025
    ],
    [
      "toiser",
      0.0025
    ],
    [
      "s'adresser",
      0.0025
    ],
    [
      "remarquer",
      0.0025
    ],
    [
      "rechercher",
      0.0025
    ],
    [
      "presumer",
      0.0025
    ],
    [
      "parcourir",
      0.0025
    ],
    [
      "aviser",
      0.0025
    ],
    [
      "consulter",
      0.0025
    ],
    [
      "guigner",
      0.0025
    ],
    [
      "liarder",
      0.0025
    ],
    [
      "lesiner",
      0.0025
    ],
    [
      "mirer",
      0.0025
    ],
    [
      "plaindre",
      0.0
    ],
    [
      "rechasser",
      0.0
    ],
    [
      "s'inquieter",
      0.0
    ],
    [
      "s'opposer",
      0.0
    ],
    [
      "visionner",
      0.0
    ],
    [
      "epier",
      0.0
    ],
    [
      "piger",
      0.0
    ],
    [
      "megoter",
      0.0
    ],
    [
      "approcher",
      0.0
    ],
    [
      "aspecter",
      0.0
    ],
    [
      "azimuter",
      0.0
    ],
    [
      "beer",
      0.0
    ],
    [
      "coller",
      0.0
    ]
  ],
  "fiancer": [
    [
      "allier",
      0.25
    ],
    [
      "engager",
      0.25
    ],
    [
      "promettre",
      0.25
    ],
    [
      "unir",
      0.25
    ]
  ],
  "fiance": [
    [
      "allier",
      0.25
    ],
    [
      "engager",
      0.25
    ],
    [
      "promettre",
      0.25
    ],
    [
      "unir",
      0.25
    ]
  ],
  "tranquille": [
    [
      "calme",
      0.155
    ],
    [
      "paisible",
      0.0725
    ],
    [
      "serein",
      0.0675
    ],
    [
      "doux",
      0.05
    ],
    [
      "placide",
      0.0375
    ],
    [
      "pose",
      0.0375
    ],
    [
      "sur",
      0.0375
    ],
    [
      "sage",
      0.0325
    ],
    [
      "impassible",
      0.0325
    ],
    [
      "flegmatique",
      0.0325
    ],
    [
      "imperturbable",
      0.0275
    ],
    [
      "silencieux",
      0.0275
    ],
    [
      "quiet",
      0.0225
    ],
    [
      "egal",
      0.015
    ],
    [
      "philosophe",
      0.015
    ],
    [
      "pacifique",
      0.015
    ],
    [
      "immobile",
      0.015
    ],
    [
      "certain",
      0.015
    ],
    [
      "assure",
      0.015
    ],
    [
      "olympien",
      0.01
    ],
    [
      "reposant",
      0.01
    ],
    [
      "regulier",
      0.01
    ],
    [
      "stoique",
      0.01
    ],
    [
      "uni",
      0.01
    ],
    [
      "evident",
      0.01
    ],
    [
      "mort",
      0.01
    ],
    [
      "limpide",
      0.01
    ],
    [
      "beat",
      0.01
    ],
    [
      "coi",
      0.01
    ],
    [
      "dormant",
      0.01
    ],
    [
      "exact",
      0.01
    ],
    [
      "heureux",
      0.01
    ],
    [
      "impavide",
      0.01
    ],
    [
      "lent",
      0.005
    ],
    [
      "peinard",
      0.005
    ],
    [
      "rassis",
      0.005
    ],
    [
      "rassure",
      0.005
    ],
    [
      "remis",
      0.005
    ],
    [
      "tranquillement",
      0.005
    ],
    [
      "inoffensif",
      0.005
    ],
    [
      "indubitable",
      0.005
    ],
    [
      "gentil",
      0.005
    ],
    [
      "garanti",
      0.005
    ],
    [
      "cousu",
      0.005
    ],
    [
      "cool",
      0.005
    ],
    [
      "confiant",
      0.005
    ],
    [
      "etabli",
      0.005
    ]
  ],
  "vingt": [],
  "recevoir": [
    [
      "prendre",
      0.1125
    ],
    [
      "encaisser",
      0.07
    ],
    [
      "gagner",
      0.05
    ],
    [
      "subir",
      0.04
    ],
    [
      "recueillir",
      0.035
    ],
    [
      "souffrir",
      0.035
    ],
    [
      "toucher",
      0.0325
    ],
    [
      "percevoir",
      0.0275
    ],
    [
      "boire",
      0.0275
    ],
    [
      "accueillir",
      0.0275
    ],
    [
      "ecoper",
      0.0225
    ],
    [
      "traiter",
      0.0225
    ],
    [
      "tirer",
      0.0225
    ],
    [
      "recolter",
      0.0225
    ],
    [
      "obtenir",
      0.0225
    ],
    [
      "essuyer",
      0.0225
    ],
    [
      "attraper",
      0.0225
    ],
    [
      "admettre",
      0.0225
    ],
    [
      "eprouver",
      0.0175
    ],
    [
      "tenir",
      0.0175
    ],
    [
      "sentir",
      0.0175
    ],
    [
      "retirer",
      0.0175
    ],
    [
      "remporter",
      0.0175
    ],
    [
      "empocher",
      0.0175
    ],
    [
      "avoir",
      0.0175
    ],
    [
      "avaler",
      0.0175
    ],
    [
      "acquerir",
      0.0175
    ],
    [
      "accepter",
      0.0175
    ],
    [
      "heriter",
      0.0125
    ],
    [
      "heberger",
      0.0125
    ],
    [
      "trinquer",
      0.0075
    ],
    [
      "soutenir",
      0.0075
    ],
    [
      "reconnaitre",
      0.0075
    ],
    [
      "passer",
      0.0075
    ],
    [
      "loger",
      0.0075
    ],
    [
      "emprunter",
      0.0075
    ],
    [
      "deguster",
      0.0075
    ],
    [
      "affilier",
      0.0075
    ],
    [
      "recouvrer",
      0.0025
    ],
    [
      "inviter",
      0.0025
    ],
    [
      "initier",
      0.0025
    ],
    [
      "festoyer",
      0.0025
    ],
    [
      "enregistrer",
      0.0025
    ],
    [
      "embourser",
      0.0025
    ],
    [
      "contenir",
      0.0025
    ],
    [
      "assimiler",
      0.0025
    ],
    [
      "agreer",
      0.0025
    ],
    [
      "receptionner",
      0.0025
    ]
  ],
  "recu": [
    [
      "prendre",
      0.1125
    ],
    [
      "encaisser",
      0.07
    ],
    [
      "gagner",
      0.05
    ],
    [
      "subir",
      0.04
    ],
    [
      "recueillir",
      0.035
    ],
    [
      "souffrir",
      0.035
    ],
    [
      "toucher",
      0.0325
    ],
    [
      "percevoir",
      0.0275
    ],
    [
      "boire",
      0.0275
    ],
    [
      "accueillir",
      0.0275
    ],
    [
      "ecoper",
      0.0225
    ],
    [
      "traiter",
      0.0225
    ],
    [
      "tirer",
      0.0225
    ],
    [
      "recolter",
      0.0225
    ],
    [
      "obtenir",
      0.0225
    ],
    [
      "essuyer",
      0.0225
    ],
    [
      "attraper",
      0.0225
    ],
    [
      "admettre",
      0.0225
    ],
    [
      "eprouver",
      0.0175
    ],
    [
      "tenir",
      0.0175
    ],
    [
      "sentir",
      0.0175
    ],
    [
      "retirer",
      0.0175
    ],
    [
      "remporter",
      0.0175
    ],
    [
      "empocher",
      0.0175
    ],
    [
      "avoir",
      0.0175
    ],
    [
      "avaler",
      0.0175
    ],
    [
      "acquerir",
      0.0175
    ],
    [
      "accepter",
      0.0175
    ],
    [
      "heriter",
      0.0125
    ],
    [
      "heberger",
      0.0125
    ],
    [
      "trinquer",
      0.0075
    ],
    [
      "soutenir",
      0.0075
    ],
    [
      "reconnaitre",
      0.0075
    ],
    [
      "passer",
      0.0075
    ],
    [
      "loger",
      0.0075
    ],
    [
      "emprunter",
      0.0075
    ],
    [
      "deguster",
      0.0075
    ],
    [
      "affilier",
      0.0075
    ],
    [
      "recouvrer",
      0.0025
    ],
    [
      "inviter",
      0.0025
    ],
    [
      "initier",
      0.0025
    ],
    [
      "festoyer",
      0.0025
    ],
    [
      "enregistrer",
      0.0025
    ],
    [
      "embourser",
      0.0025
    ],
    [
      "contenir",
      0.0025
    ],
    [
      "assimiler",
      0.0025
    ],
    [
      "agreer",
      0.0025
    ],
    [
      "receptionner",
      0.0025
    ]
  ],
  "fou": [
    [
      "insense",
      0.0575
    ],
    [
      "toque",
      0.04
    ],
    [
      "extravagant",
      0.0375
    ],
    [
      "aliene",
      0.03
    ],
    [
      "pique",
      0.0275
    ],
    [
      "cingle",
      0.0275
    ],
    [
      "timbre",
      0.025
    ],
    [
      "bizarre",
      0.025
    ],
    [
      "deraisonnable",
      0.0225
    ],
    [
      "passionne",
      0.02
    ],
    [
      "frenetique",
      0.02
    ],
    [
      "excessif",
      0.02
    ],
    [
      "enrage",
      0.0175
    ],
    [
      "furieux",
      0.0175
    ],
    [
      "violent",
      0.0175
    ],
    [
      "extraordinaire",
      0.015
    ],
    [
      "fabuleux",
      0.015
    ],
    [
      "effrene",
      0.015
    ],
    [
      "absurde",
      0.015
    ],
    [
      "farfelu",
      0.015
    ],
    [
      "fantastique",
      0.0125
    ],
    [
      "desequilibre",
      0.0125
    ],
    [
      "dement",
      0.01
    ],
    [
      "detraque",
      0.01
    ],
    [
      "fanatique",
      0.01
    ],
    [
      "saugrenu",
      0.01
    ],
    [
      "eperdu",
      0.01
    ],
    [
      "exalte",
      0.01
    ],
    [
      "delirant",
      0.01
    ],
    [
      "dingue",
      0.01
    ],
    [
      "tape",
      0.0075
    ],
    [
      "sot",
      0.0075
    ],
    [
      "prodigieux",
      0.0075
    ],
    [
      "malade",
      0.0075
    ],
    [
      "loufoque",
      0.0075
    ],
    [
      "forcene",
      0.0075
    ],
    [
      "braque",
      0.0075
    ],
    [
      "exagere",
      0.0075
    ],
    [
      "extreme",
      0.0075
    ],
    [
      "fantasque",
      0.0075
    ],
    [
      "terrible",
      0.0075
    ],
    [
      "maniaque",
      0.005
    ],
    [
      "deregle",
      0.005
    ],
    [
      "derange",
      0.005
    ],
    [
      "enorme",
      0.005
    ],
    [
      "stupide",
      0.005
    ],
    [
      "ivre",
      0.005
    ],
    [
      "debride",
      0.005
    ],
    [
      "biscornu",
      0.005
    ],
    [
      "amoureux",
      0.005
    ],
    [
      "abracadabrant",
      0.005
    ],
    [
      "etourdi",
      0.005
    ],
    [
      "energumene",
      0.005
    ],
    [
      "vif",
      0.005
    ],
    [
      "incroyable",
      0.005
    ],
    [
      "inconsequent",
      0.005
    ],
    [
      "fele",
      0.005
    ],
    [
      "folatre",
      0.005
    ],
    [
      "dingo",
      0.005
    ],
    [
      "capricieux",
      0.005
    ],
    [
      "aberrant",
      0.005
    ],
    [
      "evapore",
      0.0025
    ],
    [
      "ecervele",
      0.0025
    ],
    [
      "idiot",
      0.0025
    ],
    [
      "excentrique",
      0.0025
    ],
    [
      "desordonne",
      0.0025
    ],
    [
      "branquignol",
      0.0025
    ],
    [
      "affole",
      0.0025
    ],
    [
      "transporte",
      0.0025
    ],
    [
      "tordu",
      0.0025
    ],
    [
      "sonne",
      0.0025
    ],
    [
      "irrationnel",
      0.0025
    ],
    [
      "impossible",
      0.0025
    ],
    [
      "hallucine",
      0.0025
    ],
    [
      "gai",
      0.0025
    ],
    [
      "anormal",
      0.0025
    ],
    [
      "barjo",
      0.0025
    ],
    [
      "foufou",
      0.0025
    ],
    [
      "frappe",
      0.0025
    ],
    [
      "feroce",
      0.0025
    ],
    [
      "sinoque",
      0.0025
    ],
    [
      "petulant",
      0.0025
    ],
    [
      "nevrose",
      0.0025
    ],
    [
      "mordu",
      0.0025
    ],
    [
      "maboul",
      0.0025
    ],
    [
      "immense",
      0.0025
    ],
    [
      "gigantesque",
      0.0025
    ],
    [
      "feru",
      0.0025
    ],
    [
      "explosif",
      0.0025
    ],
    [
      "exorbitant",
      0.0025
    ],
    [
      "espiegle",
      0.0025
    ],
    [
      "givre",
      0.0
    ],
    [
      "hagard",
      0.0
    ],
    [
      "imbecile",
      0.0
    ],
    [
      "inconscient",
      0.0
    ],
    [
      "jete",
      0.0
    ],
    [
      "siphonne",
      0.0
    ],
    [
      "turbulent",
      0.0
    ],
    [
      "egare",
      0.0
    ],
    [
      "fondu",
      0.0
    ],
    [
      "faux",
      0.0
    ],
    [
      "astronomique",
      0.0
    ],
    [
      "badin",
      0.0
    ],
    [
      "bouffon",
      0.0
    ],
    [
      "chimerique",
      0.0
    ],
    [
      "diable",
      0.0
    ],
    [
      "desaxe",
      0.0
    ],
    [
      "faramineux",
      0.0
    ],
    [
      "fatigue",
      0.0
    ],
    [
      "paranoiaque",
      0.0
    ],
    [
      "originalite",
      0.0
    ],
    [
      "obsede",
      0.0
    ],
    [
      "lunatique",
      0.0
    ],
    [
      "irresistible",
      0.0
    ],
    [
      "insane",
      0.0
    ],
    [
      "psychopathe",
      0.0
    ],
    [
      "psychose",
      0.0
    ],
    [
      "risible",
      0.0
    ],
    [
      "risque",
      0.0
    ],
    [
      "schizophrene",
      0.0
    ],
    [
      "vertigineux",
      0.0
    ],
    [
      "epris",
      0.0
    ],
    [
      "etourneau",
      0.0
    ],
    [
      "infatue",
      0.0
    ],
    [
      "inextinguible",
      0.0
    ],
    [
      "bouleverse",
      0.0
    ],
    [
      "brindezingue",
      0.0
    ],
    [
      "cintre",
      0.0
    ],
    [
      "cretin",
      0.0
    ],
    [
      "dangereux",
      0.0
    ],
    [
      "desespere",
      0.0
    ],
    [
      "devergonde",
      0.0
    ],
    [
      "enjoue",
      0.0
    ],
    [
      "homerique",
      0.0
    ],
    [
      "hasardeux",
      0.0
    ],
    [
      "friand",
      0.0
    ],
    [
      "follet",
      0.0
    ],
    [
      "fada",
      0.0
    ],
    [
      "entiche",
      0.0
    ],
    [
      "melancolique",
      0.0
    ],
    [
      "marteau",
      0.0
    ],
    [
      "louftingue",
      0.0
    ],
    [
      "louf",
      0.0
    ],
    [
      "joyeux",
      0.0
    ],
    [
      "obsessionnel",
      0.0
    ],
    [
      "paraphrenique",
      0.0
    ],
    [
      "pervers",
      0.0
    ],
    [
      "phobique",
      0.0
    ],
    [
      "pete",
      0.0
    ],
    [
      "tordant",
      0.0
    ],
    [
      "zinzin",
      0.0
    ],
    [
      "jobard",
      0.0
    ],
    [
      "irrepressible",
      0.0
    ],
    [
      "irraisonnable",
      0.0
    ],
    [
      "azimute",
      0.0
    ],
    [
      "branque",
      0.0
    ],
    [
      "diablotin",
      0.0
    ],
    [
      "desembraye",
      0.0
    ],
    [
      "engoue",
      0.0
    ],
    [
      "enivre",
      0.0
    ],
    [
      "fayard",
      0.0
    ],
    [
      "folingue",
      0.0
    ],
    [
      "hasarde",
      0.0
    ],
    [
      "hysterique",
      0.0
    ],
    [
      "hetre",
      0.0
    ],
    [
      "idolatre",
      0.0
    ],
    [
      "incoercible",
      0.0
    ],
    [
      "interne",
      0.0
    ],
    [
      "atteint",
      0.0
    ]
  ],
  "toiser": [
    [
      "examiner",
      0.22
    ],
    [
      "observer",
      0.22
    ],
    [
      "regarder",
      0.22
    ],
    [
      "considerer",
      0.11
    ],
    [
      "devisager",
      0.11
    ],
    [
      "mesurer",
      0.11
    ]
  ],
  "toise": [
    [
      "somatometre",
      1.0
    ]
  ],
  "crever": [
    [
      "rompre",
      0.105
    ],
    [
      "claquer",
      0.095
    ],
    [
      "percer",
      0.0725
    ],
    [
      "ereinter",
      0.0725
    ],
    [
      "fatiguer",
      0.0525
    ],
    [
      "epuiser",
      0.0425
    ],
    [
      "mourir",
      0.0425
    ],
    [
      "dechirer",
      0.0425
    ],
    [
      "craquer",
      0.0425
    ],
    [
      "vanner",
      0.03
    ],
    [
      "transpercer",
      0.03
    ],
    [
      "peter",
      0.03
    ],
    [
      "harasser",
      0.03
    ],
    [
      "enfoncer",
      0.03
    ],
    [
      "eclater",
      0.02
    ],
    [
      "echouer",
      0.02
    ],
    [
      "vider",
      0.02
    ],
    [
      "tuer",
      0.02
    ],
    [
      "succomber",
      0.02
    ],
    [
      "s'ouvrir",
      0.02
    ],
    [
      "forcer",
      0.02
    ],
    [
      "esquinter",
      0.02
    ],
    [
      "clamser",
      0.02
    ],
    [
      "claboter",
      0.01
    ],
    [
      "fendre",
      0.01
    ],
    [
      "pomper",
      0.01
    ],
    [
      "eventrer",
      0.01
    ]
  ],
  "haine": [
    [
      "ressentiment",
      0.09
    ],
    [
      "animosite",
      0.0625
    ],
    [
      "aversion",
      0.055
    ],
    [
      "antipathie",
      0.0475
    ],
    [
      "hostilite",
      0.0475
    ],
    [
      "malveillance",
      0.04
    ],
    [
      "repulsion",
      0.0325
    ],
    [
      "rancune",
      0.0325
    ],
    [
      "horreur",
      0.0325
    ],
    [
      "fureur",
      0.0325
    ],
    [
      "aigreur",
      0.0325
    ],
    [
      "inimitie",
      0.025
    ],
    [
      "fiel",
      0.025
    ],
    [
      "execration",
      0.025
    ],
    [
      "degout",
      0.025
    ],
    [
      "acharnement",
      0.025
    ],
    [
      "eloignement",
      0.02
    ],
    [
      "repugnance",
      0.02
    ],
    [
      "ferocite",
      0.02
    ],
    [
      "fanatisme",
      0.02
    ],
    [
      "dent",
      0.02
    ],
    [
      "cruaute",
      0.02
    ],
    [
      "colere",
      0.02
    ],
    [
      "venin",
      0.0125
    ],
    [
      "rivalite",
      0.0125
    ],
    [
      "rancoeur",
      0.0125
    ],
    [
      "malignite",
      0.0125
    ],
    [
      "jalousie",
      0.0125
    ],
    [
      "antagonisme",
      0.0125
    ],
    [
      "intolerance",
      0.005
    ],
    [
      "misanthropie",
      0.005
    ],
    [
      "persecution",
      0.005
    ],
    [
      "phobie",
      0.005
    ],
    [
      "querelle",
      0.005
    ],
    [
      "racisme",
      0.005
    ],
    [
      "vengeance",
      0.005
    ],
    [
      "grippe",
      0.005
    ],
    [
      "folie",
      0.005
    ],
    [
      "exasperation",
      0.005
    ],
    [
      "detestation",
      0.005
    ],
    [
      "dissension",
      0.005
    ],
    [
      "cilice",
      0.005
    ],
    [
      "animadversion",
      0.005
    ],
    [
      "acrimonie",
      0.005
    ],
    [
      "abomination",
      0.005
    ],
    [
      "xenophobie",
      0.005
    ]
  ],
  "quatre": [],
  "ligne": [
    [
      "trait",
      0.04
    ],
    [
      "direction",
      0.03
    ],
    [
      "ordre",
      0.03
    ],
    [
      "sens",
      0.0275
    ],
    [
      "forme",
      0.0275
    ],
    [
      "filiation",
      0.0275
    ],
    [
      "famille",
      0.0275
    ],
    [
      "contour",
      0.0275
    ],
    [
      "rangee",
      0.0225
    ],
    [
      "voie",
      0.0175
    ],
    [
      "silhouette",
      0.0175
    ],
    [
      "regle",
      0.0175
    ],
    [
      "portee",
      0.0175
    ],
    [
      "plan",
      0.0175
    ],
    [
      "galbe",
      0.0175
    ],
    [
      "file",
      0.0175
    ],
    [
      "dessin",
      0.0175
    ],
    [
      "bordure",
      0.0175
    ],
    [
      "allure",
      0.0175
    ],
    [
      "lisere",
      0.0125
    ],
    [
      "niveau",
      0.0125
    ],
    [
      "orientation",
      0.0125
    ],
    [
      "race",
      0.0125
    ],
    [
      "raie",
      0.0125
    ],
    [
      "limite",
      0.0125
    ],
    [
      "genre",
      0.0125
    ],
    [
      "cote",
      0.0125
    ],
    [
      "cordeau",
      0.0125
    ],
    [
      "biais",
      0.0125
    ],
    [
      "barre",
      0.0125
    ],
    [
      "axe",
      0.0125
    ],
    [
      "ascendance",
      0.0125
    ],
    [
      "parente",
      0.0075
    ],
    [
      "orthodoxie",
      0.0075
    ],
    [
      "maintien",
      0.0075
    ],
    [
      "lineament",
      0.0075
    ],
    [
      "lignee",
      0.0075
    ],
    [
      "point",
      0.0075
    ],
    [
      "port",
      0.0075
    ],
    [
      "profil",
      0.0075
    ],
    [
      "rang",
      0.0075
    ],
    [
      "rayure",
      0.0075
    ],
    [
      "ride",
      0.0075
    ],
    [
      "route",
      0.0075
    ],
    [
      "tringle",
      0.0075
    ],
    [
      "liaison",
      0.0075
    ],
    [
      "haie",
      0.0075
    ],
    [
      "frontiere",
      0.0075
    ],
    [
      "alignement",
      0.0075
    ],
    [
      "allongement",
      0.0075
    ],
    [
      "arabesque",
      0.0075
    ],
    [
      "architecture",
      0.0075
    ],
    [
      "base",
      0.0075
    ],
    [
      "brochette",
      0.0075
    ],
    [
      "chapelet",
      0.0075
    ],
    [
      "chemin",
      0.0075
    ],
    [
      "cordage",
      0.0075
    ],
    [
      "cordon",
      0.0075
    ],
    [
      "courbe",
      0.0075
    ],
    [
      "descendance",
      0.0075
    ],
    [
      "enfilade",
      0.0075
    ],
    [
      "rayon",
      0.0025
    ],
    [
      "poids",
      0.0025
    ],
    [
      "norme",
      0.0025
    ],
    [
      "melodie",
      0.0025
    ],
    [
      "mitraillette",
      0.0025
    ],
    [
      "retranchement",
      0.0025
    ],
    [
      "rideau",
      0.0025
    ],
    [
      "segment",
      0.0025
    ],
    [
      "simbleau",
      0.0025
    ],
    [
      "strie",
      0.0025
    ],
    [
      "tiret",
      0.0025
    ],
    [
      "trainee",
      0.0025
    ],
    [
      "libouret",
      0.0025
    ],
    [
      "intersection",
      0.0025
    ],
    [
      "arete",
      0.0025
    ],
    [
      "ascendant",
      0.0025
    ],
    [
      "bretelle",
      0.0025
    ],
    [
      "conformisme",
      0.0025
    ],
    [
      "cordee",
      0.0025
    ],
    [
      "droite",
      0.0025
    ],
    [
      "delineament",
      0.0025
    ],
    [
      "demarcation",
      0.0025
    ],
    [
      "front",
      0.0025
    ],
    [
      "hachure",
      0.0025
    ],
    [
      "horizon",
      0.0025
    ],
    [
      "amarre",
      0.0025
    ]
  ],
  "journal": [
    [
      "revue",
      0.115
    ],
    [
      "magazine",
      0.07
    ],
    [
      "recit",
      0.07
    ],
    [
      "bulletin",
      0.055
    ],
    [
      "feuille",
      0.055
    ],
    [
      "gazette",
      0.0425
    ],
    [
      "nouvelles",
      0.0275
    ],
    [
      "organe",
      0.0275
    ],
    [
      "periodique",
      0.0275
    ],
    [
      "quotidien",
      0.0275
    ],
    [
      "relation",
      0.0275
    ],
    [
      "note",
      0.0275
    ],
    [
      "narration",
      0.0275
    ],
    [
      "memoires",
      0.0275
    ],
    [
      "information",
      0.0275
    ],
    [
      "hebdomadaire",
      0.0275
    ],
    [
      "carnet",
      0.0275
    ],
    [
      "cahier",
      0.0275
    ],
    [
      "journee",
      0.0125
    ],
    [
      "livre",
      0.0125
    ],
    [
      "presse",
      0.0125
    ],
    [
      "registre",
      0.0125
    ],
    [
      "roman",
      0.0125
    ],
    [
      "souvenir",
      0.0125
    ],
    [
      "journaux",
      0.0125
    ],
    [
      "journalier",
      0.0125
    ],
    [
      "informations",
      0.0125
    ],
    [
      "imprime",
      0.0125
    ],
    [
      "illustre",
      0.0125
    ],
    [
      "canard",
      0.0125
    ],
    [
      "biographie",
      0.0125
    ],
    [
      "actualite",
      0.0125
    ],
    [
      "tabloid",
      0.0125
    ]
  ],
  "vulgaire": [
    [
      "trivial",
      0.11
    ],
    [
      "commun",
      0.0925
    ],
    [
      "grossier",
      0.0825
    ],
    [
      "ordinaire",
      0.08
    ],
    [
      "bas",
      0.05
    ],
    [
      "banal",
      0.0325
    ],
    [
      "simple",
      0.0275
    ],
    [
      "prosaique",
      0.0275
    ],
    [
      "peuple",
      0.0275
    ],
    [
      "canaille",
      0.025
    ],
    [
      "populaire",
      0.025
    ],
    [
      "vil",
      0.025
    ],
    [
      "quelconque",
      0.0225
    ],
    [
      "populacier",
      0.0225
    ],
    [
      "courant",
      0.0175
    ],
    [
      "mediocre",
      0.0175
    ],
    [
      "roturier",
      0.015
    ],
    [
      "populace",
      0.015
    ],
    [
      "insignifiant",
      0.015
    ],
    [
      "foule",
      0.015
    ],
    [
      "beotien",
      0.015
    ],
    [
      "bourgeois",
      0.015
    ],
    [
      "fruste",
      0.0125
    ],
    [
      "gros",
      0.0125
    ],
    [
      "poissard",
      0.0125
    ],
    [
      "epais",
      0.0075
    ],
    [
      "tourbe",
      0.0075
    ],
    [
      "rustre",
      0.0075
    ],
    [
      "inculte",
      0.0075
    ],
    [
      "brut",
      0.0075
    ],
    [
      "voyou",
      0.005
    ],
    [
      "rustique",
      0.005
    ],
    [
      "obscene",
      0.005
    ],
    [
      "multitude",
      0.005
    ],
    [
      "modeste",
      0.005
    ],
    [
      "materiel",
      0.005
    ],
    [
      "ignoble",
      0.005
    ],
    [
      "faubourien",
      0.005
    ],
    [
      "facile",
      0.005
    ],
    [
      "tapageur",
      0.0025
    ],
    [
      "scurrile",
      0.0025
    ],
    [
      "rebattu",
      0.0025
    ],
    [
      "pinchard",
      0.0025
    ],
    [
      "philistin",
      0.0025
    ],
    [
      "irreverencieux",
      0.0025
    ],
    [
      "inelegant",
      0.0025
    ],
    [
      "gouailleur",
      0.0025
    ],
    [
      "effronte",
      0.0025
    ],
    [
      "vernaculaire",
      0.0025
    ]
  ],
  "assassin": [
    [
      "criminel",
      0.1325
    ],
    [
      "meurtrier",
      0.1325
    ],
    [
      "tueur",
      0.11
    ],
    [
      "massacreur",
      0.065
    ],
    [
      "egorgeur",
      0.0425
    ],
    [
      "homicide",
      0.0425
    ],
    [
      "bandit",
      0.0425
    ],
    [
      "malfaiteur",
      0.02
    ],
    [
      "mouche",
      0.02
    ],
    [
      "parricide",
      0.02
    ],
    [
      "regicide",
      0.02
    ],
    [
      "sbire",
      0.02
    ],
    [
      "spadassin",
      0.02
    ],
    [
      "terreur",
      0.02
    ],
    [
      "tyrannicide",
      0.02
    ],
    [
      "infanticide",
      0.02
    ],
    [
      "haschischin",
      0.02
    ],
    [
      "assassineur",
      0.02
    ],
    [
      "boucher",
      0.02
    ],
    [
      "bravo",
      0.02
    ],
    [
      "brigand",
      0.02
    ],
    [
      "coquet",
      0.02
    ],
    [
      "empoisonneur",
      0.02
    ],
    [
      "fratricide",
      0.02
    ],
    [
      "genocide",
      0.02
    ],
    [
      "etrangleur",
      0.02
    ]
  ],
  "vagabond": [
    [
      "truand",
      0.09
    ],
    [
      "clochard",
      0.0825
    ],
    [
      "gueux",
      0.0625
    ],
    [
      "chemineau",
      0.045
    ],
    [
      "errant",
      0.045
    ],
    [
      "mendiant",
      0.045
    ],
    [
      "rodeur",
      0.035
    ],
    [
      "miserable",
      0.035
    ],
    [
      "instable",
      0.035
    ],
    [
      "bohemien",
      0.035
    ],
    [
      "trimardeur",
      0.025
    ],
    [
      "pauvre",
      0.025
    ],
    [
      "nomade",
      0.025
    ],
    [
      "malandrin",
      0.025
    ],
    [
      "cloche",
      0.025
    ],
    [
      "boheme",
      0.025
    ],
    [
      "bandit",
      0.025
    ],
    [
      "aventurier",
      0.025
    ],
    [
      "voyageur",
      0.0175
    ],
    [
      "ribleur",
      0.0175
    ],
    [
      "libertin",
      0.0175
    ],
    [
      "desordonne",
      0.0175
    ],
    [
      "deregle",
      0.0175
    ],
    [
      "coureur",
      0.0175
    ],
    [
      "clodo",
      0.0175
    ],
    [
      "ambulant",
      0.0175
    ],
    [
      "fugitif",
      0.0075
    ],
    [
      "galvaudeux",
      0.0075
    ],
    [
      "retif",
      0.0075
    ],
    [
      "trainier",
      0.0075
    ],
    [
      "flaneur",
      0.0075
    ],
    [
      "flottant",
      0.0075
    ],
    [
      "comete",
      0.0075
    ],
    [
      "chiffonnier",
      0.0075
    ],
    [
      "buissonnier",
      0.0075
    ]
  ],
  "indigner": [
    [
      "revolter",
      0.19
    ],
    [
      "irriter",
      0.1425
    ],
    [
      "scandaliser",
      0.095
    ],
    [
      "revulser",
      0.095
    ],
    [
      "outrer",
      0.095
    ],
    [
      "facher",
      0.095
    ],
    [
      "exasperer",
      0.095
    ],
    [
      "choquer",
      0.045
    ],
    [
      "encolerer",
      0.045
    ],
    [
      "ecoeurer",
      0.045
    ]
  ],
  "indigne": [
    [
      "honteux",
      0.1025
    ],
    [
      "bas",
      0.0875
    ],
    [
      "abject",
      0.065
    ],
    [
      "infame",
      0.065
    ],
    [
      "mauvais",
      0.06
    ],
    [
      "avilissant",
      0.0475
    ],
    [
      "ignoble",
      0.0475
    ],
    [
      "immoral",
      0.0425
    ],
    [
      "laid",
      0.0425
    ],
    [
      "odieux",
      0.0375
    ],
    [
      "degradant",
      0.03
    ],
    [
      "impur",
      0.03
    ],
    [
      "abominable",
      0.0275
    ],
    [
      "inqualifiable",
      0.0275
    ],
    [
      "vil",
      0.0275
    ],
    [
      "mechant",
      0.02
    ],
    [
      "monstrueux",
      0.02
    ],
    [
      "malhonnete",
      0.02
    ],
    [
      "injuste",
      0.02
    ],
    [
      "inavouable",
      0.02
    ],
    [
      "deshonorant",
      0.02
    ],
    [
      "coupable",
      0.015
    ],
    [
      "cruel",
      0.015
    ],
    [
      "revoltant",
      0.015
    ],
    [
      "trivial",
      0.01
    ],
    [
      "scandaleux",
      0.01
    ],
    [
      "infamant",
      0.01
    ],
    [
      "denature",
      0.01
    ],
    [
      "condamnable",
      0.0025
    ],
    [
      "execrable",
      0.0025
    ],
    [
      "meprisable",
      0.0025
    ],
    [
      "outre",
      0.0025
    ]
  ],
  "heure": [
    [
      "temps",
      0.2375
    ],
    [
      "moment",
      0.1425
    ],
    [
      "epoque",
      0.1425
    ],
    [
      "tantot",
      0.045
    ],
    [
      "periode",
      0.045
    ],
    [
      "plombe",
      0.045
    ],
    [
      "occasion",
      0.045
    ],
    [
      "liturgie",
      0.045
    ],
    [
      "jours",
      0.045
    ],
    [
      "instant",
      0.045
    ],
    [
      "fuseau",
      0.045
    ],
    [
      "circonstance",
      0.045
    ],
    [
      "age",
      0.045
    ]
  ],
  "ecraser": [
    [
      "broyer",
      0.0625
    ],
    [
      "aneantir",
      0.05
    ],
    [
      "briser",
      0.05
    ],
    [
      "abattre",
      0.0425
    ],
    [
      "accabler",
      0.0425
    ],
    [
      "vaincre",
      0.035
    ],
    [
      "battre",
      0.035
    ],
    [
      "pulveriser",
      0.03
    ],
    [
      "detruire",
      0.0275
    ],
    [
      "aplatir",
      0.0275
    ],
    [
      "enfoncer",
      0.0275
    ],
    [
      "triompher",
      0.0225
    ],
    [
      "renverser",
      0.02
    ],
    [
      "triturer",
      0.02
    ],
    [
      "presser",
      0.0175
    ],
    [
      "casser",
      0.0175
    ],
    [
      "opprimer",
      0.015
    ],
    [
      "foudroyer",
      0.015
    ],
    [
      "fouler",
      0.0125
    ],
    [
      "froisser",
      0.0125
    ],
    [
      "etouffer",
      0.0125
    ],
    [
      "terrasser",
      0.0125
    ],
    [
      "piler",
      0.0125
    ],
    [
      "moudre",
      0.0125
    ],
    [
      "fatiguer",
      0.0125
    ],
    [
      "culbuter",
      0.0125
    ],
    [
      "tuer",
      0.01
    ],
    [
      "surpasser",
      0.01
    ],
    [
      "peser",
      0.01
    ],
    [
      "oppresser",
      0.01
    ],
    [
      "ecrabouiller",
      0.0075
    ],
    [
      "tomber",
      0.0075
    ],
    [
      "serrer",
      0.0075
    ],
    [
      "ruiner",
      0.0075
    ],
    [
      "rabaisser",
      0.0075
    ],
    [
      "humilier",
      0.0075
    ],
    [
      "enchainer",
      0.0075
    ],
    [
      "comprimer",
      0.0075
    ],
    [
      "abaisser",
      0.0075
    ],
    [
      "pressurer",
      0.005
    ],
    [
      "surclasser",
      0.005
    ],
    [
      "surmonter",
      0.005
    ],
    [
      "tasser",
      0.005
    ],
    [
      "meurtrir",
      0.005
    ],
    [
      "l'emporter",
      0.005
    ],
    [
      "dominer",
      0.005
    ],
    [
      "concasser",
      0.005
    ],
    [
      "charger",
      0.005
    ],
    [
      "bombarder",
      0.005
    ],
    [
      "blesser",
      0.005
    ],
    [
      "etonner",
      0.005
    ],
    [
      "epater",
      0.005
    ],
    [
      "tyranniser",
      0.005
    ],
    [
      "grever",
      0.005
    ],
    [
      "bigorner",
      0.005
    ],
    [
      "abrutir",
      0.005
    ],
    [
      "abasourdir",
      0.005
    ],
    [
      "eclipser",
      0.0025
    ],
    [
      "surmener",
      0.0025
    ],
    [
      "surcharger",
      0.0025
    ],
    [
      "rouler",
      0.0025
    ],
    [
      "petrir",
      0.0025
    ],
    [
      "pilonner",
      0.0025
    ],
    [
      "inonder",
      0.0025
    ],
    [
      "balayer",
      0.0025
    ],
    [
      "bousiller",
      0.0025
    ],
    [
      "consterner",
      0.0025
    ],
    [
      "deborder",
      0.0025
    ],
    [
      "gorger",
      0.0025
    ],
    [
      "egruger",
      0.0
    ],
    [
      "eclabousser",
      0.0
    ],
    [
      "ecacher",
      0.0
    ],
    [
      "rapetisser",
      0.0
    ],
    [
      "machurer",
      0.0
    ],
    [
      "macher",
      0.0
    ],
    [
      "mouliner",
      0.0
    ],
    [
      "laminer",
      0.0
    ],
    [
      "croquer",
      0.0
    ],
    [
      "compresser",
      0.0
    ],
    [
      "etriller",
      0.0
    ]
  ],
  "peu": [
    [
      "goutte",
      0.0775
    ],
    [
      "faiblement",
      0.0675
    ],
    [
      "grain",
      0.0675
    ],
    [
      "mediocrement",
      0.0675
    ],
    [
      "brin",
      0.055
    ],
    [
      "pointe",
      0.055
    ],
    [
      "soupcon",
      0.055
    ],
    [
      "guere",
      0.045
    ],
    [
      "legerement",
      0.0325
    ],
    [
      "mal",
      0.0325
    ],
    [
      "miette",
      0.0325
    ],
    [
      "once",
      0.0325
    ],
    [
      "vaguement",
      0.0225
    ],
    [
      "trace",
      0.0225
    ],
    [
      "ombre",
      0.0225
    ],
    [
      "larme",
      0.0225
    ],
    [
      "imperceptiblement",
      0.0225
    ],
    [
      "gramme",
      0.0225
    ],
    [
      "nuage",
      0.01
    ],
    [
      "rarement",
      0.01
    ],
    [
      "moderement",
      0.01
    ],
    [
      "modestement",
      0.01
    ],
    [
      "maigrement",
      0.01
    ],
    [
      "lueur",
      0.01
    ],
    [
      "insuffisamment",
      0.01
    ],
    [
      "fetu",
      0.01
    ],
    [
      "filet",
      0.01
    ],
    [
      "doigt",
      0.01
    ],
    [
      "tantinet",
      0.01
    ]
  ],
  "dernier": [
    [
      "extreme",
      0.095
    ],
    [
      "definitif",
      0.07
    ],
    [
      "final",
      0.07
    ],
    [
      "ultime",
      0.0475
    ],
    [
      "trainard",
      0.0475
    ],
    [
      "bout",
      0.0475
    ],
    [
      "benjamin",
      0.0475
    ],
    [
      "moderne",
      0.0225
    ],
    [
      "moindre",
      0.0225
    ],
    [
      "nouveau",
      0.0225
    ],
    [
      "passe",
      0.0225
    ],
    [
      "precedent",
      0.0225
    ],
    [
      "queue",
      0.0225
    ],
    [
      "recent",
      0.0225
    ],
    [
      "seul",
      0.0225
    ],
    [
      "supreme",
      0.0225
    ],
    [
      "terminal",
      0.0225
    ],
    [
      "vil",
      0.0225
    ],
    [
      "lanterne",
      0.0225
    ],
    [
      "cancre",
      0.0225
    ],
    [
      "culot",
      0.0225
    ],
    [
      "derriere",
      0.0225
    ],
    [
      "decisif",
      0.0225
    ],
    [
      "deplorable",
      0.0225
    ],
    [
      "infime",
      0.0225
    ],
    [
      "inferieur",
      0.0225
    ],
    [
      "irrevocable",
      0.0225
    ],
    [
      "lambin",
      0.0225
    ]
  ],
  "phraser": [],
  "phrase": [
    [
      "expression",
      0.1425
    ],
    [
      "discours",
      0.12
    ],
    [
      "parole",
      0.12
    ],
    [
      "formule",
      0.095
    ],
    [
      "propos",
      0.07
    ],
    [
      "sentence",
      0.07
    ],
    [
      "enonce",
      0.0475
    ],
    [
      "circonlocution",
      0.0475
    ],
    [
      "syntagme",
      0.0225
    ],
    [
      "periode",
      0.0225
    ],
    [
      "proposition",
      0.0225
    ],
    [
      "locution",
      0.0225
    ],
    [
      "lexie",
      0.0225
    ],
    [
      "enflure",
      0.0225
    ],
    [
      "detour",
      0.0225
    ],
    [
      "compliment",
      0.0225
    ],
    [
      "cliche",
      0.0225
    ],
    [
      "circonvolution",
      0.0225
    ],
    [
      "bavardage",
      0.0225
    ],
    [
      "tirade",
      0.0225
    ]
  ],
  "plaindre": [
    [
      "marchander",
      0.1825
    ],
    [
      "lesiner",
      0.135
    ],
    [
      "pleurer",
      0.135
    ],
    [
      "regretter",
      0.135
    ],
    [
      "economiser",
      0.135
    ],
    [
      "s'apitoyer",
      0.09
    ],
    [
      "compatir",
      0.045
    ],
    [
      "craindre",
      0.045
    ],
    [
      "regarder",
      0.045
    ],
    [
      "s'attendrir",
      0.045
    ]
  ],
  "celui": [
    [
      "tel",
      1.0
    ]
  ],
  "etude": [
    [
      "examen",
      0.0725
    ],
    [
      "recherche",
      0.0725
    ],
    [
      "esquisse",
      0.0425
    ],
    [
      "essai",
      0.0425
    ],
    [
      "travail",
      0.035
    ],
    [
      "projet",
      0.035
    ],
    [
      "observation",
      0.035
    ],
    [
      "art",
      0.035
    ],
    [
      "application",
      0.035
    ],
    [
      "preparation",
      0.0275
    ],
    [
      "speculation",
      0.0275
    ],
    [
      "traite",
      0.02
    ],
    [
      "meditation",
      0.02
    ],
    [
      "maquette",
      0.02
    ],
    [
      "experimentation",
      0.02
    ],
    [
      "exploration",
      0.02
    ],
    [
      "dissertation",
      0.02
    ],
    [
      "discussion",
      0.02
    ],
    [
      "attention",
      0.02
    ],
    [
      "approfondissement",
      0.02
    ],
    [
      "analyse",
      0.02
    ],
    [
      "modele",
      0.0125
    ],
    [
      "ouvrage",
      0.0125
    ],
    [
      "peinture",
      0.0125
    ],
    [
      "soin",
      0.0125
    ],
    [
      "theorie",
      0.0125
    ],
    [
      "elaboration",
      0.0125
    ],
    [
      "exercice",
      0.0125
    ],
    [
      "enquete",
      0.0125
    ],
    [
      "appret",
      0.0125
    ],
    [
      "bureau",
      0.0125
    ],
    [
      "carton",
      0.0125
    ],
    [
      "consideration",
      0.0125
    ],
    [
      "dessin",
      0.0125
    ],
    [
      "discipline",
      0.0125
    ],
    [
      "information",
      0.005
    ],
    [
      "inspection",
      0.005
    ],
    [
      "morceau",
      0.005
    ],
    [
      "memoire",
      0.005
    ],
    [
      "officine",
      0.005
    ],
    [
      "repetition",
      0.005
    ],
    [
      "histoire",
      0.005
    ],
    [
      "explication",
      0.005
    ],
    [
      "expertise",
      0.005
    ],
    [
      "enseignement",
      0.005
    ],
    [
      "dissimulation",
      0.005
    ],
    [
      "cabinet",
      0.005
    ],
    [
      "attitude",
      0.005
    ],
    [
      "article",
      0.005
    ],
    [
      "science",
      0.005
    ]
  ],
  "travail": [
    [
      "besogne",
      0.05
    ],
    [
      "tache",
      0.045
    ],
    [
      "affaire",
      0.04
    ],
    [
      "occupation",
      0.04
    ],
    [
      "fonction",
      0.035
    ],
    [
      "activite",
      0.035
    ],
    [
      "metier",
      0.0325
    ],
    [
      "oeuvre",
      0.0275
    ],
    [
      "ouvrage",
      0.0275
    ],
    [
      "emploi",
      0.025
    ],
    [
      "effort",
      0.025
    ],
    [
      "action",
      0.025
    ],
    [
      "devoir",
      0.0225
    ],
    [
      "labeur",
      0.0225
    ],
    [
      "peine",
      0.0225
    ],
    [
      "application",
      0.0175
    ],
    [
      "mission",
      0.0175
    ],
    [
      "situation",
      0.0175
    ],
    [
      "soin",
      0.0175
    ],
    [
      "profession",
      0.015
    ],
    [
      "exercice",
      0.015
    ],
    [
      "art",
      0.015
    ],
    [
      "etude",
      0.0125
    ],
    [
      "etat",
      0.0125
    ],
    [
      "service",
      0.0125
    ],
    [
      "production",
      0.0125
    ],
    [
      "job",
      0.0125
    ],
    [
      "facon",
      0.0125
    ],
    [
      "entreprise",
      0.0125
    ],
    [
      "role",
      0.01
    ],
    [
      "place",
      0.01
    ],
    [
      "execution",
      0.01
    ],
    [
      "corvee",
      0.01
    ],
    [
      "boulot",
      0.01
    ],
    [
      "elaboration",
      0.0075
    ],
    [
      "sueur",
      0.0075
    ],
    [
      "plan",
      0.0075
    ],
    [
      "operation",
      0.0075
    ],
    [
      "marche",
      0.0075
    ],
    [
      "mal",
      0.0075
    ],
    [
      "industrie",
      0.0075
    ],
    [
      "bras",
      0.0075
    ],
    [
      "difficulte",
      0.0075
    ],
    [
      "enfantement",
      0.0075
    ],
    [
      "facture",
      0.0075
    ],
    [
      "fatigue",
      0.0075
    ],
    [
      "force",
      0.0075
    ],
    [
      "ecrit",
      0.005
    ],
    [
      "zele",
      0.005
    ],
    [
      "veille",
      0.005
    ],
    [
      "poste",
      0.005
    ],
    [
      "forme",
      0.005
    ],
    [
      "fonctionnement",
      0.005
    ],
    [
      "cassement",
      0.005
    ],
    [
      "bricole",
      0.005
    ],
    [
      "programme",
      0.0
    ],
    [
      "pensum",
      0.0
    ],
    [
      "livre",
      0.0
    ],
    [
      "interim",
      0.0
    ],
    [
      "recherche",
      0.0
    ],
    [
      "reparation",
      0.0
    ],
    [
      "sape",
      0.0
    ],
    [
      "specialite",
      0.0
    ],
    [
      "tintouin",
      0.0
    ],
    [
      "turbin",
      0.0
    ],
    [
      "etudes",
      0.0
    ],
    [
      "gesine",
      0.0
    ],
    [
      "gymnastique",
      0.0
    ],
    [
      "gauchissement",
      0.0
    ],
    [
      "amortissement",
      0.0
    ],
    [
      "bricolage",
      0.0
    ],
    [
      "brocante",
      0.0
    ],
    [
      "business",
      0.0
    ],
    [
      "canevas",
      0.0
    ],
    [
      "cheminement",
      0.0
    ],
    [
      "entrainement",
      0.0
    ],
    [
      "fait",
      0.0
    ],
    [
      "fermentation",
      0.0
    ],
    [
      "accouchement",
      0.0
    ]
  ],
  "taf": [
    [
      "touche",
      1.0
    ]
  ],
  "argent": [
    [
      "monnaie",
      0.0825
    ],
    [
      "finance",
      0.06
    ],
    [
      "capital",
      0.045
    ],
    [
      "fonds",
      0.045
    ],
    [
      "fortune",
      0.045
    ],
    [
      "richesse",
      0.0375
    ],
    [
      "ressource",
      0.0375
    ],
    [
      "fric",
      0.0375
    ],
    [
      "peze",
      0.0275
    ],
    [
      "pognon",
      0.0275
    ],
    [
      "ble",
      0.0275
    ],
    [
      "billet",
      0.0275
    ],
    [
      "biens",
      0.0275
    ],
    [
      "tresorerie",
      0.02
    ],
    [
      "tresor",
      0.02
    ],
    [
      "sou",
      0.02
    ],
    [
      "numeraire",
      0.02
    ],
    [
      "galette",
      0.02
    ],
    [
      "especes",
      0.02
    ],
    [
      "avoir",
      0.02
    ],
    [
      "quibus",
      0.0125
    ],
    [
      "oseille",
      0.0125
    ],
    [
      "grisbi",
      0.0125
    ],
    [
      "flouze",
      0.0125
    ],
    [
      "finances",
      0.0125
    ],
    [
      "ferraille",
      0.0125
    ],
    [
      "denier",
      0.0125
    ],
    [
      "bourse",
      0.0125
    ],
    [
      "bien",
      0.0125
    ],
    [
      "pepetes",
      0.005
    ],
    [
      "pecune",
      0.005
    ],
    [
      "pecule",
      0.005
    ],
    [
      "picaillons",
      0.005
    ],
    [
      "picaille",
      0.005
    ],
    [
      "radis",
      0.005
    ],
    [
      "recette",
      0.005
    ],
    [
      "ronds",
      0.005
    ],
    [
      "sig",
      0.005
    ],
    [
      "somme",
      0.005
    ],
    [
      "sous",
      0.005
    ],
    [
      "viatique",
      0.005
    ],
    [
      "osier",
      0.005
    ],
    [
      "or",
      0.005
    ],
    [
      "argenterie",
      0.005
    ],
    [
      "aubert",
      0.005
    ],
    [
      "bijouterie",
      0.005
    ],
    [
      "braise",
      0.005
    ],
    [
      "cig",
      0.005
    ],
    [
      "deniers",
      0.005
    ],
    [
      "douille",
      0.005
    ],
    [
      "espece",
      0.005
    ],
    [
      "fraiche",
      0.005
    ],
    [
      "frusquin",
      0.005
    ],
    [
      "mitraille",
      0.005
    ],
    [
      "ecus",
      0.005
    ]
  ],
  "depenser": [
    [
      "dilapider",
      0.0975
    ],
    [
      "dissiper",
      0.0975
    ],
    [
      "manger",
      0.08
    ],
    [
      "consumer",
      0.065
    ],
    [
      "engloutir",
      0.065
    ],
    [
      "devorer",
      0.055
    ],
    [
      "epuiser",
      0.0475
    ],
    [
      "user",
      0.0475
    ],
    [
      "gaspiller",
      0.0475
    ],
    [
      "prodiguer",
      0.04
    ],
    [
      "consommer",
      0.0325
    ],
    [
      "croquer",
      0.0325
    ],
    [
      "payer",
      0.0225
    ],
    [
      "fricoter",
      0.0225
    ],
    [
      "claquer",
      0.0225
    ],
    [
      "deployer",
      0.015
    ],
    [
      "employer",
      0.015
    ],
    [
      "verser",
      0.015
    ],
    [
      "saigner",
      0.0075
    ],
    [
      "rembourser",
      0.0075
    ],
    [
      "boire",
      0.0075
    ],
    [
      "debourser",
      0.0075
    ],
    [
      "escompter",
      0.0075
    ],
    [
      "flamber",
      0.0075
    ],
    [
      "fricasser",
      0.0075
    ],
    [
      "friper",
      0.0075
    ],
    [
      "fusiller",
      0.0075
    ],
    [
      "hypothequer",
      0.0075
    ],
    [
      "ecorner",
      0.0075
    ]
  ],
  "depense": [
    [
      "contribution",
      0.055
    ],
    [
      "depens",
      0.055
    ],
    [
      "frais",
      0.055
    ],
    [
      "etalage",
      0.035
    ],
    [
      "prodigalite",
      0.035
    ],
    [
      "luxe",
      0.035
    ],
    [
      "gaspillage",
      0.035
    ],
    [
      "finance",
      0.035
    ],
    [
      "debours",
      0.035
    ],
    [
      "dissipation",
      0.035
    ],
    [
      "cotisation",
      0.035
    ],
    [
      "charge",
      0.035
    ],
    [
      "participation",
      0.0175
    ],
    [
      "paiement",
      0.0175
    ],
    [
      "office",
      0.0175
    ],
    [
      "montre",
      0.0175
    ],
    [
      "impense",
      0.0175
    ],
    [
      "questure",
      0.0175
    ],
    [
      "resserre",
      0.0175
    ],
    [
      "reserve",
      0.0175
    ],
    [
      "sacrifice",
      0.0175
    ],
    [
      "sortie",
      0.0175
    ],
    [
      "usage",
      0.0175
    ],
    [
      "folie",
      0.0175
    ],
    [
      "budget",
      0.0175
    ],
    [
      "cambuse",
      0.0175
    ],
    [
      "cellier",
      0.0175
    ],
    [
      "consommation",
      0.0175
    ],
    [
      "cout",
      0.0175
    ],
    [
      "dilapidation",
      0.0175
    ],
    [
      "debourse",
      0.0175
    ],
    [
      "decaissement",
      0.0175
    ],
    [
      "deploiement",
      0.0175
    ],
    [
      "exhibition",
      0.0175
    ],
    [
      "extra",
      0.0175
    ],
    [
      "fastuosite",
      0.0175
    ],
    [
      "ecot",
      0.0175
    ]
  ],
  "credit": [
    [
      "influence",
      0.075
    ],
    [
      "autorite",
      0.0625
    ],
    [
      "consideration",
      0.0625
    ],
    [
      "reputation",
      0.0625
    ],
    [
      "ascendant",
      0.0525
    ],
    [
      "vogue",
      0.0425
    ],
    [
      "puissance",
      0.0425
    ],
    [
      "prestige",
      0.0425
    ],
    [
      "pouvoir",
      0.0425
    ],
    [
      "faveur",
      0.0425
    ],
    [
      "celebrite",
      0.0425
    ],
    [
      "creance",
      0.03
    ],
    [
      "empire",
      0.03
    ],
    [
      "importance",
      0.03
    ],
    [
      "renommee",
      0.02
    ],
    [
      "renom",
      0.02
    ],
    [
      "pret",
      0.02
    ],
    [
      "estime",
      0.02
    ],
    [
      "benefice",
      0.02
    ],
    [
      "avoir",
      0.02
    ],
    [
      "emprise",
      0.0075
    ],
    [
      "finance",
      0.0075
    ],
    [
      "mode",
      0.0075
    ],
    [
      "solde",
      0.0075
    ],
    [
      "sortie",
      0.0075
    ],
    [
      "surface",
      0.0075
    ],
    [
      "terme",
      0.0075
    ],
    [
      "delai",
      0.0075
    ],
    [
      "credibilite",
      0.0075
    ],
    [
      "cours",
      0.0075
    ],
    [
      "accreditif",
      0.0075
    ],
    [
      "actif",
      0.0075
    ],
    [
      "agio",
      0.0075
    ],
    [
      "avance",
      0.0075
    ],
    [
      "bras",
      0.0075
    ],
    [
      "budget",
      0.0075
    ],
    [
      "confiance",
      0.0075
    ],
    [
      "consistance",
      0.0075
    ],
    [
      "etoile",
      0.0075
    ]
  ],
  "creance": [
    [
      "credit",
      0.3325
    ],
    [
      "confiance",
      0.22
    ],
    [
      "croyance",
      0.11
    ],
    [
      "credibilite",
      0.11
    ],
    [
      "foi",
      0.11
    ],
    [
      "influence",
      0.11
    ]
  ],
  "dette": [
    [
      "obligation",
      0.06
    ],
    [
      "redevance",
      0.06
    ],
    [
      "nantissement",
      0.04
    ],
    [
      "finance",
      0.04
    ],
    [
      "engagement",
      0.04
    ],
    [
      "droit",
      0.04
    ],
    [
      "devoir",
      0.04
    ],
    [
      "commandement",
      0.04
    ],
    [
      "charge",
      0.04
    ],
    [
      "caution",
      0.04
    ],
    [
      "amortissement",
      0.04
    ],
    [
      "gage",
      0.0175
    ],
    [
      "faillite",
      0.0175
    ],
    [
      "extinction",
      0.0175
    ],
    [
      "endettement",
      0.0175
    ],
    [
      "emprunt",
      0.0175
    ],
    [
      "insolvabilite",
      0.0175
    ],
    [
      "passif",
      0.0175
    ],
    [
      "pouf",
      0.0175
    ],
    [
      "rente",
      0.0175
    ],
    [
      "sommation",
      0.0175
    ],
    [
      "terme",
      0.0175
    ],
    [
      "du",
      0.0175
    ],
    [
      "deficit",
      0.0175
    ],
    [
      "antichrese",
      0.0175
    ],
    [
      "arriere",
      0.0175
    ],
    [
      "atermoiement",
      0.0175
    ],
    [
      "banqueroute",
      0.0175
    ],
    [
      "calendes",
      0.0175
    ],
    [
      "carence",
      0.0175
    ],
    [
      "compensation",
      0.0175
    ],
    [
      "concordat",
      0.0175
    ],
    [
      "debet",
      0.0175
    ],
    [
      "debit",
      0.0175
    ],
    [
      "deconfiture",
      0.0175
    ],
    [
      "decouvert",
      0.0175
    ],
    [
      "echeance",
      0.0175
    ]
  ],
  "huissier": [
    [
      "appariteur",
      0.2
    ],
    [
      "gardien",
      0.0975
    ],
    [
      "surveillant",
      0.0975
    ],
    [
      "sergent",
      0.0475
    ],
    [
      "portier",
      0.0475
    ],
    [
      "ouvreur",
      0.0475
    ],
    [
      "massier",
      0.0475
    ],
    [
      "introducteur",
      0.0475
    ],
    [
      "garcon",
      0.0475
    ],
    [
      "chaouch",
      0.0475
    ],
    [
      "adjudicateur",
      0.0475
    ],
    [
      "tangente",
      0.0475
    ]
  ],
  "merde": [
    [
      "excrement",
      0.1425
    ],
    [
      "boue",
      0.095
    ],
    [
      "gadoue",
      0.095
    ],
    [
      "crotte",
      0.07
    ],
    [
      "ordure",
      0.07
    ],
    [
      "salete",
      0.0475
    ],
    [
      "emmerdement",
      0.0475
    ],
    [
      "mercredi",
      0.0225
    ],
    [
      "merdouille",
      0.0225
    ],
    [
      "mince",
      0.0225
    ],
    [
      "mouscaille",
      0.0225
    ],
    [
      "pagaille",
      0.0225
    ],
    [
      "tasse",
      0.0225
    ],
    [
      "vache",
      0.0225
    ],
    [
      "heroine",
      0.0225
    ],
    [
      "emmerde",
      0.0225
    ],
    [
      "embarras",
      0.0225
    ],
    [
      "drogue",
      0.0225
    ],
    [
      "chierie",
      0.0225
    ],
    [
      "came",
      0.0225
    ],
    [
      "caca",
      0.0225
    ],
    [
      "bran",
      0.0225
    ],
    [
      "bouse",
      0.0225
    ],
    [
      "bordel",
      0.0225
    ],
    [
      "zut",
      0.0225
    ]
  ],
  "merder": [
    [
      "echouer",
      0.4
    ],
    [
      "foirer",
      0.2
    ],
    [
      "merdoyer",
      0.2
    ],
    [
      "vasouiller",
      0.2
    ]
  ],
  "gosse": [
    [
      "enfant",
      0.18
    ],
    [
      "gamin",
      0.1575
    ],
    [
      "petit",
      0.09
    ],
    [
      "bebe",
      0.0675
    ],
    [
      "mioche",
      0.0675
    ],
    [
      "mome",
      0.0675
    ],
    [
      "petiot",
      0.045
    ],
    [
      "moutard",
      0.045
    ],
    [
      "fille",
      0.045
    ],
    [
      "bambin",
      0.045
    ],
    [
      "lardon",
      0.0225
    ],
    [
      "infantile",
      0.0225
    ],
    [
      "gone",
      0.0225
    ],
    [
      "gnard",
      0.0225
    ],
    [
      "enfantin",
      0.0225
    ],
    [
      "drole",
      0.0225
    ],
    [
      "amante",
      0.0225
    ],
    [
      "tendron",
      0.0225
    ]
  ],
  "divorcer": [
    [
      "rompre",
      0.21
    ],
    [
      "demarier",
      0.105
    ],
    [
      "renoncer",
      0.105
    ],
    [
      "separer",
      0.105
    ],
    [
      "repudier",
      0.0525
    ]
  ],
  "divorce": [
    [
      "division",
      0.12
    ],
    [
      "desaccord",
      0.12
    ],
    [
      "opposition",
      0.12
    ],
    [
      "divergence",
      0.1
    ],
    [
      "desunion",
      0.08
    ],
    [
      "rupture",
      0.08
    ],
    [
      "conflit",
      0.06
    ],
    [
      "separation",
      0.06
    ],
    [
      "heurt",
      0.0375
    ],
    [
      "dissension",
      0.0375
    ],
    [
      "contradiction",
      0.0375
    ],
    [
      "abime",
      0.0175
    ],
    [
      "discordance",
      0.0175
    ],
    [
      "disjonction",
      0.0175
    ],
    [
      "dissolution",
      0.0175
    ],
    [
      "demariage",
      0.0175
    ],
    [
      "repudiation",
      0.0175
    ]
  ],
  "proche": [
    [
      "voisin",
      0.11
    ],
    [
      "prochain",
      0.1
    ],
    [
      "semblable",
      0.065
    ],
    [
      "contigu",
      0.055
    ],
    [
      "pres",
      0.055
    ],
    [
      "riverain",
      0.055
    ],
    [
      "avoisinant",
      0.0425
    ],
    [
      "analogue",
      0.0425
    ],
    [
      "approchant",
      0.0325
    ],
    [
      "attenant",
      0.0325
    ],
    [
      "limitrophe",
      0.0325
    ],
    [
      "similaire",
      0.02
    ],
    [
      "joignant",
      0.02
    ],
    [
      "imminent",
      0.02
    ],
    [
      "environnant",
      0.02
    ],
    [
      "comparable",
      0.02
    ],
    [
      "aupres",
      0.02
    ],
    [
      "approximatif",
      0.02
    ],
    [
      "adjacent",
      0.02
    ],
    [
      "accessible",
      0.02
    ],
    [
      "parallele",
      0.01
    ],
    [
      "parent",
      0.01
    ],
    [
      "rapproche",
      0.01
    ],
    [
      "recent",
      0.01
    ],
    [
      "receptif",
      0.01
    ],
    [
      "jouxte",
      0.01
    ],
    [
      "intime",
      0.01
    ],
    [
      "futur",
      0.01
    ],
    [
      "confiant",
      0.01
    ],
    [
      "communicatif",
      0.01
    ],
    [
      "circonvoisin",
      0.01
    ],
    [
      "approche",
      0.01
    ],
    [
      "abordable",
      0.01
    ]
  ],
  "deuil": [
    [
      "affliction",
      0.1775
    ],
    [
      "malheur",
      0.1225
    ],
    [
      "douleur",
      0.11
    ],
    [
      "chagrin",
      0.095
    ],
    [
      "tristesse",
      0.095
    ],
    [
      "epreuve",
      0.08
    ],
    [
      "calamite",
      0.0675
    ],
    [
      "tribulation",
      0.0675
    ],
    [
      "souffrance",
      0.055
    ],
    [
      "dechirement",
      0.025
    ],
    [
      "desolation",
      0.025
    ],
    [
      "convoi",
      0.0125
    ],
    [
      "enterrement",
      0.0125
    ],
    [
      "funerailles",
      0.0125
    ],
    [
      "perte",
      0.0125
    ]
  ],
  "probleme": [
    [
      "difficulte",
      0.1775
    ],
    [
      "ennui",
      0.1425
    ],
    [
      "question",
      0.1425
    ],
    [
      "affaire",
      0.1075
    ],
    [
      "histoire",
      0.1075
    ],
    [
      "tirage",
      0.07
    ],
    [
      "sujet",
      0.07
    ],
    [
      "souci",
      0.07
    ],
    [
      "colle",
      0.035
    ],
    [
      "complication",
      0.035
    ],
    [
      "enigme",
      0.035
    ]
  ],
  "seul": [
    [
      "isole",
      0.11
    ],
    [
      "solitaire",
      0.095
    ],
    [
      "unique",
      0.0775
    ],
    [
      "un",
      0.0625
    ],
    [
      "simple",
      0.0625
    ],
    [
      "abandonne",
      0.0625
    ],
    [
      "distinct",
      0.0475
    ],
    [
      "individuel",
      0.0475
    ],
    [
      "singulier",
      0.03
    ],
    [
      "sauvage",
      0.03
    ],
    [
      "retire",
      0.03
    ],
    [
      "esseule",
      0.03
    ],
    [
      "desert",
      0.03
    ],
    [
      "delaisse",
      0.03
    ],
    [
      "celibataire",
      0.03
    ],
    [
      "veuf",
      0.015
    ],
    [
      "uniquement",
      0.015
    ],
    [
      "solitairement",
      0.015
    ],
    [
      "soliste",
      0.015
    ],
    [
      "seulet",
      0.015
    ],
    [
      "sec",
      0.015
    ],
    [
      "pur",
      0.015
    ],
    [
      "orphelin",
      0.015
    ],
    [
      "independant",
      0.015
    ],
    [
      "exclusif",
      0.015
    ],
    [
      "depareille",
      0.015
    ],
    [
      "dernier",
      0.015
    ]
  ],
  "crise": [
    [
      "trouble",
      0.0675
    ],
    [
      "acces",
      0.0575
    ],
    [
      "malaise",
      0.0475
    ],
    [
      "marasme",
      0.0475
    ],
    [
      "poussee",
      0.0475
    ],
    [
      "detresse",
      0.0375
    ],
    [
      "transport",
      0.0275
    ],
    [
      "penurie",
      0.0275
    ],
    [
      "maladie",
      0.0275
    ],
    [
      "depression",
      0.0275
    ],
    [
      "danger",
      0.0275
    ],
    [
      "convulsion",
      0.0275
    ],
    [
      "atteinte",
      0.0275
    ],
    [
      "angoisse",
      0.0275
    ],
    [
      "peril",
      0.0175
    ],
    [
      "recession",
      0.0175
    ],
    [
      "stagnation",
      0.0175
    ],
    [
      "tension",
      0.0175
    ],
    [
      "transe",
      0.0175
    ],
    [
      "elan",
      0.0175
    ],
    [
      "paroxysme",
      0.0175
    ],
    [
      "misere",
      0.0175
    ],
    [
      "alarme",
      0.0175
    ],
    [
      "anemie",
      0.0175
    ],
    [
      "attaque",
      0.0175
    ],
    [
      "bouffee",
      0.0175
    ],
    [
      "faillite",
      0.0175
    ],
    [
      "krach",
      0.0175
    ],
    [
      "manque",
      0.0075
    ],
    [
      "perturbation",
      0.0075
    ],
    [
      "peripetie",
      0.0075
    ],
    [
      "quinte",
      0.0075
    ],
    [
      "redoublement",
      0.0075
    ],
    [
      "rupture",
      0.0075
    ],
    [
      "soubresaut",
      0.0075
    ],
    [
      "incertitude",
      0.0075
    ],
    [
      "flambee",
      0.0075
    ],
    [
      "debacle",
      0.0075
    ],
    [
      "difficulte",
      0.0075
    ],
    [
      "colere",
      0.0075
    ],
    [
      "chomage",
      0.0075
    ],
    [
      "chute",
      0.0075
    ],
    [
      "cataclysme",
      0.0075
    ],
    [
      "bouillon",
      0.0075
    ],
    [
      "acuite",
      0.0075
    ],
    [
      "ebranlement",
      0.0075
    ]
  ],
  "famine": [
    [
      "disette",
      0.25
    ],
    [
      "denuement",
      0.25
    ],
    [
      "faim",
      0.25
    ],
    [
      "detresse",
      0.125
    ],
    [
      "fringale",
      0.125
    ]
  ],
  "tiers": [
    [
      "intermediaire",
      0.1325
    ],
    [
      "mediateur",
      0.1325
    ],
    [
      "negociateur",
      0.1325
    ],
    [
      "temoin",
      0.065
    ],
    [
      "troisieme",
      0.065
    ],
    [
      "tierce",
      0.065
    ],
    [
      "milieu",
      0.065
    ],
    [
      "intrus",
      0.065
    ],
    [
      "inconnu",
      0.065
    ],
    [
      "arbitre",
      0.065
    ],
    [
      "etranger",
      0.065
    ]
  ],
  "fatigue": [
    [
      "ennuyer",
      0.0575
    ],
    [
      "epuiser",
      0.0525
    ],
    [
      "assommer",
      0.0475
    ],
    [
      "ereinter",
      0.04
    ],
    [
      "briser",
      0.04
    ],
    [
      "aneantir",
      0.04
    ],
    [
      "abattre",
      0.04
    ],
    [
      "accabler",
      0.03
    ],
    [
      "exceder",
      0.03
    ],
    [
      "extenuer",
      0.03
    ],
    [
      "raser",
      0.025
    ],
    [
      "lasser",
      0.0225
    ],
    [
      "harasser",
      0.02
    ],
    [
      "affaiblir",
      0.02
    ],
    [
      "barber",
      0.02
    ],
    [
      "importuner",
      0.02
    ],
    [
      "empoisonner",
      0.015
    ],
    [
      "tanner",
      0.015
    ],
    [
      "tuer",
      0.015
    ],
    [
      "diminuer",
      0.015
    ],
    [
      "battre",
      0.015
    ],
    [
      "bassiner",
      0.015
    ],
    [
      "deprimer",
      0.0125
    ],
    [
      "etourdir",
      0.0125
    ],
    [
      "enerver",
      0.01
    ],
    [
      "harceler",
      0.01
    ],
    [
      "degouter",
      0.01
    ],
    [
      "claquer",
      0.01
    ],
    [
      "assourdir",
      0.01
    ],
    [
      "ecraser",
      0.01
    ],
    [
      "vanner",
      0.01
    ],
    [
      "enquiquiner",
      0.01
    ],
    [
      "endormir",
      0.01
    ],
    [
      "embeter",
      0.01
    ],
    [
      "travailler",
      0.0075
    ],
    [
      "surmener",
      0.0075
    ],
    [
      "obseder",
      0.0075
    ],
    [
      "decourager",
      0.0075
    ],
    [
      "vider",
      0.005
    ],
    [
      "tracasser",
      0.005
    ],
    [
      "rompre",
      0.005
    ],
    [
      "peser",
      0.005
    ],
    [
      "peiner",
      0.005
    ],
    [
      "esquinter",
      0.005
    ],
    [
      "crever",
      0.005
    ],
    [
      "broyer",
      0.005
    ],
    [
      "ecoeurer",
      0.005
    ],
    [
      "assassiner",
      0.005
    ],
    [
      "touiller",
      0.0025
    ],
    [
      "suer",
      0.0025
    ],
    [
      "remuer",
      0.0025
    ],
    [
      "rebuter",
      0.0025
    ],
    [
      "incommoder",
      0.0025
    ],
    [
      "forcer",
      0.0025
    ],
    [
      "canuler",
      0.0025
    ],
    [
      "blaser",
      0.0025
    ],
    [
      "assieger",
      0.0025
    ],
    [
      "affadir",
      0.0025
    ],
    [
      "echiner",
      0.0
    ],
    [
      "tarabuster",
      0.0
    ],
    [
      "talonner",
      0.0
    ],
    [
      "indisposer",
      0.0
    ],
    [
      "exasperer",
      0.0
    ],
    [
      "escagasser",
      0.0
    ],
    [
      "consumer",
      0.0
    ],
    [
      "alanguir",
      0.0
    ],
    [
      "revoir",
      0.0
    ],
    [
      "s'epuiser",
      0.0
    ],
    [
      "saturer",
      0.0
    ],
    [
      "surentrainer",
      0.0
    ],
    [
      "plier",
      0.0
    ],
    [
      "meler",
      0.0
    ],
    [
      "melanger",
      0.0
    ],
    [
      "moudre",
      0.0
    ],
    [
      "flapir",
      0.0
    ],
    [
      "bouler",
      0.0
    ],
    [
      "avachir",
      0.0
    ],
    [
      "ahaner",
      0.0
    ],
    [
      "trimer",
      0.0
    ]
  ],
  "fatiguer": [
    [
      "ennuyer",
      0.0575
    ],
    [
      "epuiser",
      0.0525
    ],
    [
      "assommer",
      0.0475
    ],
    [
      "ereinter",
      0.04
    ],
    [
      "briser",
      0.04
    ],
    [
      "aneantir",
      0.04
    ],
    [
      "abattre",
      0.04
    ],
    [
      "accabler",
      0.03
    ],
    [
      "exceder",
      0.03
    ],
    [
      "extenuer",
      0.03
    ],
    [
      "raser",
      0.025
    ],
    [
      "lasser",
      0.0225
    ],
    [
      "harasser",
      0.02
    ],
    [
      "affaiblir",
      0.02
    ],
    [
      "barber",
      0.02
    ],
    [
      "importuner",
      0.02
    ],
    [
      "empoisonner",
      0.015
    ],
    [
      "tanner",
      0.015
    ],
    [
      "tuer",
      0.015
    ],
    [
      "diminuer",
      0.015
    ],
    [
      "battre",
      0.015
    ],
    [
      "bassiner",
      0.015
    ],
    [
      "deprimer",
      0.0125
    ],
    [
      "etourdir",
      0.0125
    ],
    [
      "enerver",
      0.01
    ],
    [
      "harceler",
      0.01
    ],
    [
      "degouter",
      0.01
    ],
    [
      "claquer",
      0.01
    ],
    [
      "assourdir",
      0.01
    ],
    [
      "ecraser",
      0.01
    ],
    [
      "vanner",
      0.01
    ],
    [
      "enquiquiner",
      0.01
    ],
    [
      "endormir",
      0.01
    ],
    [
      "embeter",
      0.01
    ],
    [
      "travailler",
      0.0075
    ],
    [
      "surmener",
      0.0075
    ],
    [
      "obseder",
      0.0075
    ],
    [
      "decourager",
      0.0075
    ],
    [
      "vider",
      0.005
    ],
    [
      "tracasser",
      0.005
    ],
    [
      "rompre",
      0.005
    ],
    [
      "peser",
      0.005
    ],
    [
      "peiner",
      0.005
    ],
    [
      "esquinter",
      0.005
    ],
    [
      "crever",
      0.005
    ],
    [
      "broyer",
      0.005
    ],
    [
      "ecoeurer",
      0.005
    ],
    [
      "assassiner",
      0.005
    ],
    [
      "touiller",
      0.0025
    ],
    [
      "suer",
      0.0025
    ],
    [
      "remuer",
      0.0025
    ],
    [
      "rebuter",
      0.0025
    ],
    [
      "incommoder",
      0.0025
    ],
    [
      "forcer",
      0.0025
    ],
    [
      "canuler",
      0.0025
    ],
    [
      "blaser",
      0.0025
    ],
    [
      "assieger",
      0.0025
    ],
    [
      "affadir",
      0.0025
    ],
    [
      "echiner",
      0.0
    ],
    [
      "tarabuster",
      0.0
    ],
    [
      "talonner",
      0.0
    ],
    [
      "indisposer",
      0.0
    ],
    [
      "exasperer",
      0.0
    ],
    [
      "escagasser",
      0.0
    ],
    [
      "consumer",
      0.0
    ],
    [
      "alanguir",
      0.0
    ],
    [
      "revoir",
      0.0
    ],
    [
      "s'epuiser",
      0.0
    ],
    [
      "saturer",
      0.0
    ],
    [
      "surentrainer",
      0.0
    ],
    [
      "plier",
      0.0
    ],
    [
      "meler",
      0.0
    ],
    [
      "melanger",
      0.0
    ],
    [
      "moudre",
      0.0
    ],
    [
      "flapir",
      0.0
    ],
    [
      "bouler",
      0.0
    ],
    [
      "avachir",
      0.0
    ],
    [
      "ahaner",
      0.0
    ],
    [
      "trimer",
      0.0
    ]
  ],
  "reveil": [
    [
      "renouveau",
      0.16
    ],
    [
      "resurrection",
      0.12
    ],
    [
      "reviviscence",
      0.08
    ],
    [
      "revif",
      0.08
    ],
    [
      "retour",
      0.08
    ],
    [
      "renaissance",
      0.08
    ],
    [
      "diane",
      0.08
    ],
    [
      "survivance",
      0.04
    ],
    [
      "sonnerie",
      0.04
    ],
    [
      "revivification",
      0.04
    ],
    [
      "regain",
      0.04
    ],
    [
      "horloge",
      0.04
    ],
    [
      "batterie",
      0.04
    ],
    [
      "eveil",
      0.04
    ]
  ],
  "sourd": [
    [
      "secret",
      0.0875
    ],
    [
      "cache",
      0.06
    ],
    [
      "voile",
      0.06
    ],
    [
      "impenetrable",
      0.0525
    ],
    [
      "tenebreux",
      0.0525
    ],
    [
      "insensible",
      0.04
    ],
    [
      "etouffe",
      0.0325
    ],
    [
      "sepulcral",
      0.0325
    ],
    [
      "souterrain",
      0.0325
    ],
    [
      "sournois",
      0.0325
    ],
    [
      "sombre",
      0.0325
    ],
    [
      "occulte",
      0.0325
    ],
    [
      "vague",
      0.025
    ],
    [
      "refractaire",
      0.025
    ],
    [
      "mysterieux",
      0.025
    ],
    [
      "caverneux",
      0.0175
    ],
    [
      "impermeable",
      0.0175
    ],
    [
      "inaccessible",
      0.0175
    ],
    [
      "insaisissable",
      0.0175
    ],
    [
      "mou",
      0.0175
    ],
    [
      "inflexible",
      0.0125
    ],
    [
      "latent",
      0.0125
    ],
    [
      "mat",
      0.0125
    ],
    [
      "rebelle",
      0.0125
    ],
    [
      "eteint",
      0.0125
    ],
    [
      "indistinct",
      0.0125
    ],
    [
      "incertain",
      0.0125
    ],
    [
      "grave",
      0.0125
    ],
    [
      "fuyant",
      0.0125
    ],
    [
      "ferme",
      0.0125
    ],
    [
      "assourdi",
      0.0125
    ],
    [
      "amorti",
      0.0125
    ],
    [
      "indifferent",
      0.005
    ],
    [
      "inexorable",
      0.005
    ],
    [
      "salamandre",
      0.005
    ],
    [
      "sourdingue",
      0.005
    ],
    [
      "impitoyable",
      0.005
    ],
    [
      "hypocrite",
      0.005
    ],
    [
      "enroue",
      0.005
    ],
    [
      "embu",
      0.005
    ],
    [
      "doux",
      0.005
    ],
    [
      "creux",
      0.005
    ],
    [
      "cotonneux",
      0.005
    ],
    [
      "clandestin",
      0.005
    ],
    [
      "attenue",
      0.005
    ],
    [
      "tamise",
      0.005
    ]
  ],
  "sourdre": [
    [
      "sortir",
      0.115
    ],
    [
      "paraitre",
      0.1
    ],
    [
      "poindre",
      0.0725
    ],
    [
      "surgir",
      0.0725
    ],
    [
      "apparaitre",
      0.065
    ],
    [
      "jaillir",
      0.05
    ],
    [
      "percer",
      0.05
    ],
    [
      "emerger",
      0.05
    ],
    [
      "couler",
      0.0425
    ],
    [
      "pointer",
      0.0425
    ],
    [
      "naitre",
      0.035
    ],
    [
      "transpirer",
      0.0275
    ],
    [
      "emaner",
      0.0275
    ],
    [
      "ressortir",
      0.02
    ],
    [
      "filtrer",
      0.02
    ],
    [
      "decouler",
      0.02
    ],
    [
      "fuir",
      0.0125
    ],
    [
      "pousser",
      0.0125
    ],
    [
      "suinter",
      0.0125
    ],
    [
      "eclore",
      0.0125
    ],
    [
      "fuser",
      0.005
    ]
  ],
  "veiller": [
    [
      "proteger",
      0.09
    ],
    [
      "assister",
      0.0725
    ],
    [
      "preserver",
      0.0725
    ],
    [
      "s'occuper",
      0.0725
    ],
    [
      "voir",
      0.0725
    ],
    [
      "garder",
      0.0525
    ],
    [
      "surveiller",
      0.035
    ],
    [
      "s'assurer",
      0.035
    ],
    [
      "pourvoir",
      0.035
    ],
    [
      "parer",
      0.035
    ],
    [
      "maintenir",
      0.035
    ],
    [
      "chaperonner",
      0.035
    ],
    [
      "aviser",
      0.035
    ],
    [
      "assurer",
      0.035
    ],
    [
      "soigner",
      0.0175
    ],
    [
      "secourir",
      0.0175
    ],
    [
      "s'appliquer",
      0.0175
    ],
    [
      "presider",
      0.0175
    ],
    [
      "songer",
      0.0175
    ]
  ],
  "veille": [
    [
      "proteger",
      0.09
    ],
    [
      "assister",
      0.0725
    ],
    [
      "preserver",
      0.0725
    ],
    [
      "s'occuper",
      0.0725
    ],
    [
      "voir",
      0.0725
    ],
    [
      "garder",
      0.0525
    ],
    [
      "surveiller",
      0.035
    ],
    [
      "s'assurer",
      0.035
    ],
    [
      "pourvoir",
      0.035
    ],
    [
      "parer",
      0.035
    ],
    [
      "maintenir",
      0.035
    ],
    [
      "chaperonner",
      0.035
    ],
    [
      "aviser",
      0.035
    ],
    [
      "assurer",
      0.035
    ],
    [
      "soigner",
      0.0175
    ],
    [
      "secourir",
      0.0175
    ],
    [
      "s'appliquer",
      0.0175
    ],
    [
      "presider",
      0.0175
    ],
    [
      "songer",
      0.0175
    ]
  ],
  "sortir": [
    [
      "debucher",
      1.0
    ]
  ],
  "sort": [
    [
      "destin",
      0.1525
    ],
    [
      "destinee",
      0.105
    ],
    [
      "fortune",
      0.0825
    ],
    [
      "fatalite",
      0.0575
    ],
    [
      "lot",
      0.0575
    ],
    [
      "etat",
      0.0475
    ],
    [
      "hasard",
      0.0475
    ],
    [
      "condition",
      0.035
    ],
    [
      "malheur",
      0.035
    ],
    [
      "vie",
      0.0225
    ],
    [
      "situation",
      0.0225
    ],
    [
      "partage",
      0.0225
    ],
    [
      "part",
      0.0225
    ],
    [
      "malefice",
      0.0225
    ],
    [
      "malchance",
      0.0225
    ],
    [
      "aventure",
      0.0225
    ],
    [
      "adversite",
      0.0225
    ],
    [
      "fin",
      0.01
    ],
    [
      "magie",
      0.01
    ],
    [
      "position",
      0.01
    ],
    [
      "providence",
      0.01
    ],
    [
      "sorcellerie",
      0.01
    ],
    [
      "sortilege",
      0.01
    ],
    [
      "fatum",
      0.01
    ],
    [
      "ensorcellement",
      0.01
    ],
    [
      "enchantement",
      0.01
    ],
    [
      "denouement",
      0.01
    ],
    [
      "charme",
      0.01
    ],
    [
      "chance",
      0.01
    ],
    [
      "avenir",
      0.01
    ],
    [
      "apanage",
      0.01
    ],
    [
      "etoile",
      0.01
    ]
  ],
  "oublier": [
    [
      "negliger",
      0.13
    ],
    [
      "abandonner",
      0.1175
    ],
    [
      "delaisser",
      0.08
    ],
    [
      "laisser",
      0.08
    ],
    [
      "passer",
      0.045
    ],
    [
      "pardonner",
      0.045
    ],
    [
      "omettre",
      0.045
    ],
    [
      "lacher",
      0.045
    ],
    [
      "manquer",
      0.035
    ],
    [
      "transgresser",
      0.0225
    ],
    [
      "sauter",
      0.0225
    ],
    [
      "pecher",
      0.0225
    ],
    [
      "perdre",
      0.0225
    ],
    [
      "manger",
      0.0225
    ],
    [
      "excepter",
      0.0225
    ],
    [
      "meconnaitre",
      0.01
    ],
    [
      "noyer",
      0.01
    ],
    [
      "faillir",
      0.01
    ],
    [
      "enterrer",
      0.01
    ],
    [
      "effacer",
      0.01
    ],
    [
      "deserter",
      0.01
    ],
    [
      "desapprendre",
      0.01
    ],
    [
      "dormir",
      0.01
    ],
    [
      "amnistier",
      0.01
    ],
    [
      "epargner",
      0.01
    ]
  ],
  "danse": [
    [
      "raclee",
      0.0525
    ],
    [
      "valse",
      0.0525
    ],
    [
      "volee",
      0.0525
    ],
    [
      "torgnole",
      0.0375
    ],
    [
      "sarabande",
      0.0375
    ],
    [
      "ronde",
      0.0375
    ],
    [
      "farandole",
      0.0375
    ],
    [
      "choregraphie",
      0.0375
    ],
    [
      "ballet",
      0.0375
    ],
    [
      "bal",
      0.0375
    ],
    [
      "roulee",
      0.025
    ],
    [
      "reproche",
      0.025
    ],
    [
      "quadrille",
      0.025
    ],
    [
      "guinche",
      0.025
    ],
    [
      "coup",
      0.025
    ],
    [
      "contredanse",
      0.025
    ],
    [
      "attrapade",
      0.025
    ],
    [
      "orchesographie",
      0.01
    ],
    [
      "menuet",
      0.01
    ],
    [
      "mazurka",
      0.01
    ],
    [
      "matchiche",
      0.01
    ],
    [
      "mascarade",
      0.01
    ],
    [
      "lessivage",
      0.01
    ],
    [
      "pavane",
      0.01
    ],
    [
      "polka",
      0.01
    ],
    [
      "rigaudon",
      0.01
    ],
    [
      "rythmique",
      0.01
    ],
    [
      "saltation",
      0.01
    ],
    [
      "sauterie",
      0.01
    ],
    [
      "spectacle",
      0.01
    ],
    [
      "tango",
      0.01
    ],
    [
      "tarentelle",
      0.01
    ],
    [
      "jota",
      0.01
    ],
    [
      "java",
      0.01
    ],
    [
      "gigue",
      0.01
    ],
    [
      "blues",
      0.01
    ],
    [
      "bolero",
      0.01
    ],
    [
      "boston",
      0.01
    ],
    [
      "bourree",
      0.01
    ],
    [
      "carmagnole",
      0.01
    ],
    [
      "chaine",
      0.01
    ],
    [
      "cotillon",
      0.01
    ],
    [
      "czardas",
      0.01
    ],
    [
      "derobee",
      0.01
    ],
    [
      "entrechat",
      0.01
    ],
    [
      "gambille",
      0.01
    ],
    [
      "gavotte",
      0.01
    ],
    [
      "aubade",
      0.01
    ]
  ],
  "fini": [
    [
      "fatigue",
      0.075
    ],
    [
      "perdu",
      0.075
    ],
    [
      "foutu",
      0.0525
    ],
    [
      "mort",
      0.0525
    ],
    [
      "acheve",
      0.0425
    ],
    [
      "fichu",
      0.0425
    ],
    [
      "eteint",
      0.0325
    ],
    [
      "epuise",
      0.0325
    ],
    [
      "use",
      0.0325
    ],
    [
      "usage",
      0.0325
    ],
    [
      "travaille",
      0.0325
    ],
    [
      "poli",
      0.0325
    ],
    [
      "accompli",
      0.0325
    ],
    [
      "vide",
      0.02
    ],
    [
      "ruine",
      0.02
    ],
    [
      "parfait",
      0.02
    ],
    [
      "leche",
      0.02
    ],
    [
      "inextensible",
      0.02
    ],
    [
      "flambe",
      0.02
    ],
    [
      "fignole",
      0.02
    ],
    [
      "fait",
      0.02
    ],
    [
      "disparu",
      0.02
    ],
    [
      "condamne",
      0.02
    ],
    [
      "borne",
      0.02
    ],
    [
      "lime",
      0.01
    ],
    [
      "perfection",
      0.01
    ],
    [
      "pomme",
      0.01
    ],
    [
      "revolu",
      0.01
    ],
    [
      "soigne",
      0.01
    ],
    [
      "suranne",
      0.01
    ],
    [
      "temporel",
      0.01
    ],
    [
      "termine",
      0.01
    ],
    [
      "limite",
      0.01
    ],
    [
      "incurable",
      0.01
    ],
    [
      "cisele",
      0.01
    ],
    [
      "consomme",
      0.01
    ],
    [
      "diminue",
      0.01
    ],
    [
      "defini",
      0.01
    ],
    [
      "fieffe",
      0.01
    ],
    [
      "fignolage",
      0.01
    ],
    [
      "frit",
      0.01
    ],
    [
      "evanoui",
      0.01
    ]
  ],
  "pire": [
    [
      "pis",
      0.3325
    ]
  ],
  "mourir": [
    [
      "disparaitre",
      0.1175
    ],
    [
      "succomber",
      0.07
    ],
    [
      "s'eteindre",
      0.055
    ],
    [
      "tomber",
      0.055
    ],
    [
      "finir",
      0.0425
    ],
    [
      "s'effacer",
      0.04
    ],
    [
      "s'evanouir",
      0.04
    ],
    [
      "expirer",
      0.035
    ],
    [
      "perir",
      0.0325
    ],
    [
      "abandonner",
      0.0325
    ],
    [
      "s'estomper",
      0.03
    ],
    [
      "s'amenuiser",
      0.025
    ],
    [
      "diminuer",
      0.0225
    ],
    [
      "decliner",
      0.0225
    ],
    [
      "partir",
      0.0175
    ],
    [
      "s'affaiblir",
      0.0125
    ],
    [
      "quitter",
      0.0125
    ],
    [
      "crever",
      0.01
    ],
    [
      "rompre",
      0.01
    ],
    [
      "s'aneantir",
      0.01
    ],
    [
      "trepasser",
      0.01
    ],
    [
      "renoncer",
      0.0075
    ],
    [
      "clamser",
      0.0075
    ],
    [
      "echapper",
      0.005
    ],
    [
      "s'achever",
      0.005
    ],
    [
      "pericliter",
      0.005
    ],
    [
      "agoniser",
      0.005
    ],
    [
      "cesser",
      0.005
    ],
    [
      "claquer",
      0.005
    ],
    [
      "deceder",
      0.005
    ],
    [
      "deperir",
      0.005
    ],
    [
      "s'obscurcir",
      0.0025
    ],
    [
      "s'endormir",
      0.0025
    ],
    [
      "s'abatardir",
      0.0025
    ],
    [
      "s'etouffer",
      0.0025
    ],
    [
      "souffrir",
      0.0025
    ],
    [
      "calancher",
      0.0025
    ],
    [
      "caner",
      0.0025
    ],
    [
      "claboter",
      0.0025
    ],
    [
      "cronir",
      0.0025
    ],
    [
      "degeler",
      0.0025
    ],
    [
      "degenerer",
      0.0025
    ]
  ],
  "mort": [
    [
      "aneantissement",
      0.0425
    ],
    [
      "eteint",
      0.04
    ],
    [
      "disparition",
      0.0275
    ],
    [
      "inerte",
      0.0275
    ],
    [
      "passe",
      0.0275
    ],
    [
      "perdu",
      0.0275
    ],
    [
      "fin",
      0.025
    ],
    [
      "fatigue",
      0.025
    ],
    [
      "decede",
      0.02
    ],
    [
      "effondrement",
      0.02
    ],
    [
      "ruine",
      0.02
    ],
    [
      "terne",
      0.02
    ],
    [
      "vide",
      0.0175
    ],
    [
      "perte",
      0.0175
    ],
    [
      "fini",
      0.0175
    ],
    [
      "defunt",
      0.0175
    ],
    [
      "chute",
      0.0175
    ],
    [
      "apathique",
      0.0175
    ],
    [
      "tue",
      0.0125
    ],
    [
      "stagnant",
      0.0125
    ],
    [
      "rompu",
      0.0125
    ],
    [
      "mourant",
      0.0125
    ],
    [
      "morne",
      0.0125
    ],
    [
      "desert",
      0.0125
    ],
    [
      "destruction",
      0.0125
    ],
    [
      "agonie",
      0.0125
    ],
    [
      "fige",
      0.01
    ],
    [
      "foutu",
      0.01
    ],
    [
      "harasse",
      0.01
    ],
    [
      "inactif",
      0.01
    ],
    [
      "somnolent",
      0.01
    ],
    [
      "use",
      0.01
    ],
    [
      "ecroulement",
      0.01
    ],
    [
      "fichu",
      0.01
    ],
    [
      "fade",
      0.01
    ],
    [
      "cadavre",
      0.01
    ],
    [
      "disparu",
      0.01
    ],
    [
      "dormant",
      0.01
    ],
    [
      "deces",
      0.01
    ],
    [
      "delave",
      0.01
    ],
    [
      "detruit",
      0.01
    ],
    [
      "enterrement",
      0.01
    ],
    [
      "extinction",
      0.01
    ],
    [
      "silencieux",
      0.005
    ],
    [
      "retame",
      0.005
    ],
    [
      "rendu",
      0.005
    ],
    [
      "recru",
      0.005
    ],
    [
      "plongeon",
      0.005
    ],
    [
      "spectre",
      0.005
    ],
    [
      "tombeau",
      0.005
    ],
    [
      "tranquille",
      0.005
    ],
    [
      "transi",
      0.005
    ],
    [
      "trepas",
      0.005
    ],
    [
      "trepasse",
      0.005
    ],
    [
      "victime",
      0.005
    ],
    [
      "evanoui",
      0.005
    ],
    [
      "plat",
      0.005
    ],
    [
      "ombre",
      0.005
    ],
    [
      "necrose",
      0.005
    ],
    [
      "camarde",
      0.005
    ],
    [
      "decomposition",
      0.005
    ],
    [
      "esprit",
      0.005
    ],
    [
      "esquinte",
      0.005
    ],
    [
      "fantome",
      0.005
    ],
    [
      "faucheuse",
      0.005
    ],
    [
      "inanime",
      0.005
    ],
    [
      "neant",
      0.005
    ],
    [
      "manes",
      0.005
    ],
    [
      "macchabee",
      0.005
    ],
    [
      "lessive",
      0.005
    ],
    [
      "languide",
      0.005
    ],
    [
      "insensible",
      0.005
    ],
    [
      "irrecuperable",
      0.0025
    ],
    [
      "ivre",
      0.0025
    ],
    [
      "macchab",
      0.0025
    ],
    [
      "malemort",
      0.0025
    ],
    [
      "mortifie",
      0.0025
    ],
    [
      "restes",
      0.0025
    ],
    [
      "supplice",
      0.0025
    ],
    [
      "tombe",
      0.0025
    ],
    [
      "inhabite",
      0.0025
    ],
    [
      "ankylose",
      0.0025
    ],
    [
      "charogne",
      0.0025
    ],
    [
      "corps",
      0.0025
    ],
    [
      "depouille",
      0.0025
    ],
    [
      "execution",
      0.0025
    ],
    [
      "feu",
      0.0025
    ],
    [
      "fossoyeuse",
      0.0025
    ],
    [
      "torture",
      0.0025
    ]
  ],
  "enfin": [
    [
      "finalement",
      0.25
    ],
    [
      "bref",
      0.125
    ],
    [
      "ultimo",
      0.0625
    ],
    [
      "dernierement",
      0.0625
    ]
  ],
  "ben": [],
  "encore": [
    [
      "cependant",
      0.1
    ],
    [
      "toujours",
      0.1
    ],
    [
      "plus",
      0.05
    ],
    [
      "meme",
      0.05
    ],
    [
      "mais",
      0.05
    ],
    [
      "davantage",
      0.05
    ],
    [
      "bravo",
      0.05
    ],
    [
      "bis",
      0.05
    ],
    [
      "aussi",
      0.05
    ]
  ],
  "musiquer": [],
  "musique": [
    [
      "chanson",
      0.1175
    ],
    [
      "bruit",
      0.1025
    ],
    [
      "chant",
      0.1025
    ],
    [
      "orchestre",
      0.0875
    ],
    [
      "harmonie",
      0.0575
    ],
    [
      "fanfare",
      0.0575
    ],
    [
      "murmure",
      0.0425
    ],
    [
      "refrain",
      0.0275
    ],
    [
      "melodie",
      0.0275
    ],
    [
      "hymne",
      0.0275
    ],
    [
      "gazouillis",
      0.0275
    ],
    [
      "concert",
      0.0275
    ],
    [
      "clique",
      0.0275
    ],
    [
      "nouba",
      0.0125
    ],
    [
      "partition",
      0.0125
    ],
    [
      "poesie",
      0.0125
    ],
    [
      "ramage",
      0.0125
    ],
    [
      "son",
      0.0125
    ],
    [
      "symphonie",
      0.0125
    ],
    [
      "ton",
      0.0125
    ],
    [
      "musiquette",
      0.0125
    ],
    [
      "musicalite",
      0.0125
    ],
    [
      "messe",
      0.0125
    ],
    [
      "histoire",
      0.0125
    ],
    [
      "groupe",
      0.0125
    ],
    [
      "flonflon",
      0.0125
    ],
    [
      "disque",
      0.0125
    ],
    [
      "bourdonnement",
      0.0125
    ],
    [
      "bastringue",
      0.0125
    ],
    [
      "zizique",
      0.0125
    ]
  ],
  "tripe": [],
  "prier": [
    [
      "demander",
      0.15
    ],
    [
      "supplier",
      0.12
    ],
    [
      "implorer",
      0.08
    ],
    [
      "appeler",
      0.0675
    ],
    [
      "inviter",
      0.0675
    ],
    [
      "solliciter",
      0.06
    ],
    [
      "reclamer",
      0.06
    ],
    [
      "sommer",
      0.0475
    ],
    [
      "recommander",
      0.04
    ],
    [
      "requerir",
      0.04
    ],
    [
      "revendiquer",
      0.04
    ],
    [
      "insister",
      0.0275
    ],
    [
      "adjurer",
      0.0275
    ],
    [
      "crier",
      0.02
    ],
    [
      "enjoindre",
      0.02
    ],
    [
      "invoquer",
      0.02
    ],
    [
      "presser",
      0.02
    ],
    [
      "s'agenouiller",
      0.0075
    ],
    [
      "s'adresser",
      0.0075
    ],
    [
      "retenir",
      0.0075
    ],
    [
      "interceder",
      0.0075
    ],
    [
      "convier",
      0.0075
    ],
    [
      "conjurer",
      0.0075
    ],
    [
      "adorer",
      0.0075
    ]
  ],
  "arreter": [
    [
      "retenir",
      0.0525
    ],
    [
      "fixer",
      0.0425
    ],
    [
      "endiguer",
      0.0325
    ],
    [
      "bloquer",
      0.03
    ],
    [
      "etouffer",
      0.0275
    ],
    [
      "attacher",
      0.0275
    ],
    [
      "freiner",
      0.025
    ],
    [
      "prendre",
      0.025
    ],
    [
      "immobiliser",
      0.025
    ],
    [
      "couper",
      0.025
    ],
    [
      "contenir",
      0.0225
    ],
    [
      "interrompre",
      0.0225
    ],
    [
      "enrayer",
      0.02
    ],
    [
      "paralyser",
      0.02
    ],
    [
      "tenir",
      0.0175
    ],
    [
      "moderer",
      0.0175
    ],
    [
      "empecher",
      0.015
    ],
    [
      "finir",
      0.015
    ],
    [
      "stopper",
      0.015
    ],
    [
      "suspendre",
      0.015
    ],
    [
      "trancher",
      0.0125
    ],
    [
      "terminer",
      0.0125
    ],
    [
      "saisir",
      0.0125
    ],
    [
      "barrer",
      0.0125
    ],
    [
      "supprimer",
      0.0125
    ],
    [
      "reprimer",
      0.0125
    ],
    [
      "regler",
      0.0125
    ],
    [
      "maintenir",
      0.0125
    ],
    [
      "fermer",
      0.0125
    ],
    [
      "decider",
      0.0125
    ],
    [
      "accrocher",
      0.01
    ],
    [
      "arrimer",
      0.01
    ],
    [
      "assujettir",
      0.01
    ],
    [
      "briser",
      0.01
    ],
    [
      "rompre",
      0.0075
    ],
    [
      "refrener",
      0.0075
    ],
    [
      "conclure",
      0.0075
    ],
    [
      "calmer",
      0.0075
    ],
    [
      "assurer",
      0.0075
    ],
    [
      "temperer",
      0.0075
    ],
    [
      "ralentir",
      0.0075
    ],
    [
      "juguler",
      0.0075
    ],
    [
      "entraver",
      0.0075
    ],
    [
      "borner",
      0.0075
    ],
    [
      "traiter",
      0.005
    ],
    [
      "resoudre",
      0.005
    ],
    [
      "limiter",
      0.005
    ],
    [
      "cesser",
      0.005
    ],
    [
      "captiver",
      0.005
    ],
    [
      "s'emparer",
      0.005
    ],
    [
      "emprisonner",
      0.005
    ],
    [
      "determiner",
      0.005
    ],
    [
      "dissoudre",
      0.005
    ],
    [
      "clore",
      0.005
    ],
    [
      "caler",
      0.005
    ],
    [
      "statuer",
      0.0025
    ],
    [
      "soumettre",
      0.0025
    ],
    [
      "s'arreter",
      0.0025
    ],
    [
      "piquer",
      0.0025
    ],
    [
      "intercepter",
      0.0025
    ],
    [
      "engager",
      0.0025
    ],
    [
      "circonscrire",
      0.0025
    ],
    [
      "capturer",
      0.0025
    ],
    [
      "ramasser",
      0.0025
    ],
    [
      "retarder",
      0.0025
    ],
    [
      "reserver",
      0.0025
    ],
    [
      "s'assurer",
      0.0025
    ],
    [
      "mater",
      0.0025
    ],
    [
      "geler",
      0.0025
    ],
    [
      "attirer",
      0.0025
    ],
    [
      "barricader",
      0.0025
    ],
    [
      "consolider",
      0.0025
    ],
    [
      "decourager",
      0.0025
    ],
    [
      "emballer",
      0.0025
    ],
    [
      "empoigner",
      0.0
    ],
    [
      "mouiller",
      0.0
    ],
    [
      "prescrire",
      0.0
    ],
    [
      "quitter",
      0.0
    ],
    [
      "vouloir",
      0.0
    ],
    [
      "ecluser",
      0.0
    ],
    [
      "etablir",
      0.0
    ],
    [
      "etancher",
      0.0
    ],
    [
      "embarrasser",
      0.0
    ],
    [
      "embarquer",
      0.0
    ],
    [
      "aborder",
      0.0
    ],
    [
      "ancrer",
      0.0
    ],
    [
      "cacher",
      0.0
    ],
    [
      "cloturer",
      0.0
    ],
    [
      "coffrer",
      0.0
    ],
    [
      "convenir",
      0.0
    ],
    [
      "cueillir",
      0.0
    ],
    [
      "deposer",
      0.0
    ],
    [
      "poisser",
      0.0
    ],
    [
      "prononcer",
      0.0
    ],
    [
      "rebuter",
      0.0
    ],
    [
      "souhaiter",
      0.0
    ],
    [
      "tarir",
      0.0
    ],
    [
      "temporiser",
      0.0
    ],
    [
      "louer",
      0.0
    ],
    [
      "incarcerer",
      0.0
    ],
    [
      "accoster",
      0.0
    ],
    [
      "achopper",
      0.0
    ],
    [
      "ankyloser",
      0.0
    ],
    [
      "apprehender",
      0.0
    ],
    [
      "assoupir",
      0.0
    ],
    [
      "buter",
      0.0
    ],
    [
      "debrancher",
      0.0
    ],
    [
      "torpiller",
      0.0
    ]
  ],
  "corps": [
    [
      "association",
      0.065
    ],
    [
      "compagnie",
      0.065
    ],
    [
      "societe",
      0.065
    ],
    [
      "unite",
      0.0525
    ],
    [
      "peau",
      0.0425
    ],
    [
      "corporation",
      0.0425
    ],
    [
      "communaute",
      0.0425
    ],
    [
      "carcasse",
      0.0425
    ],
    [
      "troupe",
      0.0325
    ],
    [
      "personne",
      0.0325
    ],
    [
      "homme",
      0.0325
    ],
    [
      "defroque",
      0.0325
    ],
    [
      "congregation",
      0.0325
    ],
    [
      "assemblee",
      0.0325
    ],
    [
      "substance",
      0.02
    ],
    [
      "objet",
      0.02
    ],
    [
      "matiere",
      0.02
    ],
    [
      "individu",
      0.02
    ],
    [
      "guenille",
      0.02
    ],
    [
      "college",
      0.02
    ],
    [
      "chair",
      0.02
    ],
    [
      "armee",
      0.02
    ],
    [
      "mort",
      0.01
    ],
    [
      "mortel",
      0.01
    ],
    [
      "ordre",
      0.01
    ],
    [
      "organe",
      0.01
    ],
    [
      "organisme",
      0.01
    ],
    [
      "principal",
      0.01
    ],
    [
      "restes",
      0.01
    ],
    [
      "regiment",
      0.01
    ],
    [
      "solide",
      0.01
    ],
    [
      "morphologie",
      0.01
    ],
    [
      "depouille",
      0.01
    ],
    [
      "anatomie",
      0.01
    ],
    [
      "atome",
      0.01
    ],
    [
      "cadavre",
      0.01
    ],
    [
      "chambre",
      0.01
    ],
    [
      "collection",
      0.01
    ],
    [
      "composant",
      0.01
    ],
    [
      "confrerie",
      0.01
    ],
    [
      "coquatre",
      0.01
    ],
    [
      "corpus",
      0.01
    ],
    [
      "tronc",
      0.01
    ]
  ],
  "boucher": [
    [
      "tueur",
      0.19
    ],
    [
      "bourreau",
      0.095
    ],
    [
      "criminel",
      0.095
    ],
    [
      "militaire",
      0.0475
    ],
    [
      "massacreur",
      0.0475
    ],
    [
      "louchebem",
      0.0475
    ],
    [
      "detaillant",
      0.0475
    ],
    [
      "chirurgien",
      0.0475
    ],
    [
      "chevillard",
      0.0475
    ],
    [
      "chasseur",
      0.0475
    ],
    [
      "charcutier",
      0.0475
    ],
    [
      "bouchere",
      0.0475
    ],
    [
      "assommeur",
      0.0475
    ],
    [
      "assassin",
      0.0475
    ],
    [
      "abatteur",
      0.0475
    ],
    [
      "etalier",
      0.0475
    ]
  ],
  "bouche": [
    [
      "bec",
      0.1125
    ],
    [
      "ouverture",
      0.1125
    ],
    [
      "gueule",
      0.09
    ],
    [
      "embouchure",
      0.0675
    ],
    [
      "gosier",
      0.0675
    ],
    [
      "goulot",
      0.0675
    ],
    [
      "orifice",
      0.045
    ],
    [
      "machoire",
      0.045
    ],
    [
      "margoulette",
      0.045
    ],
    [
      "entree",
      0.045
    ],
    [
      "sucoir",
      0.0225
    ],
    [
      "museau",
      0.0225
    ],
    [
      "mandibule",
      0.0225
    ],
    [
      "levre",
      0.0225
    ],
    [
      "langue",
      0.0225
    ],
    [
      "gueulard",
      0.0225
    ],
    [
      "goule",
      0.0225
    ],
    [
      "delta",
      0.0225
    ],
    [
      "cystotome",
      0.0225
    ],
    [
      "cavite",
      0.0225
    ],
    [
      "bouchette",
      0.0225
    ],
    [
      "avaloir",
      0.0225
    ],
    [
      "trompe",
      0.0225
    ]
  ],
  "oreille": [
    [
      "anse",
      0.065
    ],
    [
      "portugaise",
      0.065
    ],
    [
      "poignee",
      0.065
    ],
    [
      "pli",
      0.065
    ],
    [
      "pavillon",
      0.065
    ],
    [
      "ouie",
      0.065
    ],
    [
      "orillon",
      0.065
    ],
    [
      "oreillette",
      0.065
    ],
    [
      "feuille",
      0.065
    ],
    [
      "faveur",
      0.065
    ],
    [
      "esgourde",
      0.065
    ],
    [
      "corne",
      0.065
    ],
    [
      "confiance",
      0.065
    ],
    [
      "audition",
      0.065
    ],
    [
      "versoir",
      0.065
    ]
  ],
  "fort": [
    [
      "gros",
      0.0525
    ],
    [
      "grand",
      0.035
    ],
    [
      "bon",
      0.025
    ],
    [
      "ferme",
      0.025
    ],
    [
      "robuste",
      0.025
    ],
    [
      "beau",
      0.0225
    ],
    [
      "solide",
      0.0225
    ],
    [
      "energique",
      0.02
    ],
    [
      "puissant",
      0.02
    ],
    [
      "dur",
      0.0175
    ],
    [
      "vif",
      0.0175
    ],
    [
      "abondant",
      0.0175
    ],
    [
      "violent",
      0.0175
    ],
    [
      "trapu",
      0.015
    ],
    [
      "important",
      0.015
    ],
    [
      "vigoureux",
      0.015
    ],
    [
      "epais",
      0.0125
    ],
    [
      "haut",
      0.0125
    ],
    [
      "resistant",
      0.0125
    ],
    [
      "profond",
      0.0125
    ],
    [
      "excessif",
      0.0125
    ],
    [
      "plein",
      0.01
    ],
    [
      "lourd",
      0.01
    ],
    [
      "vaste",
      0.01
    ],
    [
      "eclatant",
      0.0075
    ],
    [
      "intense",
      0.0075
    ],
    [
      "genereux",
      0.0075
    ],
    [
      "extraordinaire",
      0.0075
    ],
    [
      "retentissant",
      0.0075
    ],
    [
      "percant",
      0.0075
    ],
    [
      "muscle",
      0.0075
    ],
    [
      "massif",
      0.0075
    ],
    [
      "large",
      0.0075
    ],
    [
      "habile",
      0.0075
    ],
    [
      "gras",
      0.0075
    ],
    [
      "courageux",
      0.0075
    ],
    [
      "costaud",
      0.0075
    ],
    [
      "capable",
      0.0075
    ],
    [
      "aigu",
      0.0075
    ],
    [
      "dense",
      0.0075
    ],
    [
      "etonnant",
      0.005
    ],
    [
      "enorme",
      0.005
    ],
    [
      "tenace",
      0.005
    ],
    [
      "intelligent",
      0.005
    ],
    [
      "formidable",
      0.005
    ],
    [
      "extreme",
      0.005
    ],
    [
      "cale",
      0.005
    ],
    [
      "vivant",
      0.005
    ],
    [
      "savant",
      0.005
    ],
    [
      "rude",
      0.005
    ],
    [
      "raide",
      0.005
    ],
    [
      "inebranlable",
      0.005
    ],
    [
      "infatigable",
      0.005
    ],
    [
      "efficace",
      0.005
    ],
    [
      "autoritaire",
      0.005
    ],
    [
      "ample",
      0.005
    ],
    [
      "touffu",
      0.0025
    ],
    [
      "sonore",
      0.0025
    ],
    [
      "resolu",
      0.0025
    ],
    [
      "precis",
      0.0025
    ],
    [
      "irresistible",
      0.0025
    ],
    [
      "baraque",
      0.0025
    ],
    [
      "agissant",
      0.0025
    ],
    [
      "genial",
      0.0025
    ],
    [
      "incroyable",
      0.0025
    ],
    [
      "insupportable",
      0.0025
    ],
    [
      "piquant",
      0.0025
    ],
    [
      "penetrant",
      0.0025
    ],
    [
      "resonnant",
      0.0025
    ],
    [
      "sale",
      0.0025
    ],
    [
      "tonitruant",
      0.0025
    ],
    [
      "volontaire",
      0.0025
    ],
    [
      "volumineux",
      0.0025
    ],
    [
      "grave",
      0.0025
    ],
    [
      "forteresse",
      0.0025
    ],
    [
      "absolu",
      0.0025
    ],
    [
      "actif",
      0.0025
    ],
    [
      "adroit",
      0.0025
    ],
    [
      "brutal",
      0.0025
    ],
    [
      "carabine",
      0.0025
    ],
    [
      "charge",
      0.0025
    ],
    [
      "copieux",
      0.0025
    ],
    [
      "dru",
      0.0025
    ],
    [
      "exagere",
      0.0025
    ],
    [
      "fier",
      0.0025
    ],
    [
      "instruit",
      0.0025
    ],
    [
      "invulnerable",
      0.0025
    ],
    [
      "marque",
      0.0025
    ],
    [
      "opulent",
      0.0025
    ],
    [
      "rable",
      0.0025
    ],
    [
      "strict",
      0.0025
    ],
    [
      "stupefiant",
      0.0025
    ],
    [
      "valide",
      0.0025
    ],
    [
      "eblouissant",
      0.0025
    ],
    [
      "inoui",
      0.0025
    ],
    [
      "influent",
      0.0025
    ],
    [
      "abri",
      0.0025
    ],
    [
      "baleze",
      0.0025
    ],
    [
      "colore",
      0.0025
    ],
    [
      "comble",
      0.0025
    ],
    [
      "convaincant",
      0.0025
    ],
    [
      "corpulent",
      0.0025
    ],
    [
      "corse",
      0.0025
    ],
    [
      "impetueux",
      0.0025
    ],
    [
      "prononce",
      0.0
    ],
    [
      "propre",
      0.0
    ],
    [
      "rebondi",
      0.0
    ],
    [
      "releve",
      0.0
    ],
    [
      "replet",
      0.0
    ],
    [
      "rigide",
      0.0
    ],
    [
      "serieux",
      0.0
    ],
    [
      "trempe",
      0.0
    ],
    [
      "eloquent",
      0.0
    ],
    [
      "epice",
      0.0
    ],
    [
      "etourdissant",
      0.0
    ],
    [
      "nombreux",
      0.0
    ],
    [
      "male",
      0.0
    ],
    [
      "invraisemblable",
      0.0
    ],
    [
      "amer",
      0.0
    ],
    [
      "coeur",
      0.0
    ],
    [
      "cuisant",
      0.0
    ],
    [
      "doue",
      0.0
    ],
    [
      "decisif",
      0.0
    ],
    [
      "expressif",
      0.0
    ],
    [
      "ferre",
      0.0
    ],
    [
      "fortification",
      0.0
    ],
    [
      "insoutenable",
      0.0
    ],
    [
      "intolerable",
      0.0
    ],
    [
      "invincible",
      0.0
    ],
    [
      "krak",
      0.0
    ],
    [
      "hercule",
      0.0
    ],
    [
      "fortin",
      0.0
    ],
    [
      "fortifie",
      0.0
    ],
    [
      "fortiche",
      0.0
    ],
    [
      "maitre",
      0.0
    ],
    [
      "outre",
      0.0
    ],
    [
      "ouvrage",
      0.0
    ],
    [
      "repaire",
      0.0
    ],
    [
      "rustique",
      0.0
    ],
    [
      "strident",
      0.0
    ],
    [
      "summum",
      0.0
    ],
    [
      "experimente",
      0.0
    ],
    [
      "enivrant",
      0.0
    ],
    [
      "accuse",
      0.0
    ],
    [
      "aguerri",
      0.0
    ],
    [
      "appuye",
      0.0
    ],
    [
      "bruyant",
      0.0
    ],
    [
      "choquant",
      0.0
    ],
    [
      "chateau",
      0.0
    ],
    [
      "concis",
      0.0
    ],
    [
      "constant",
      0.0
    ],
    [
      "docte",
      0.0
    ],
    [
      "developpe",
      0.0
    ],
    [
      "marquant",
      0.0
    ],
    [
      "maous",
      0.0
    ],
    [
      "malin",
      0.0
    ],
    [
      "malabar",
      0.0
    ],
    [
      "inusable",
      0.0
    ],
    [
      "poivre",
      0.0
    ],
    [
      "porteur",
      0.0
    ],
    [
      "pousse",
      0.0
    ],
    [
      "pepere",
      0.0
    ],
    [
      "sein",
      0.0
    ],
    [
      "soigne",
      0.0
    ],
    [
      "taille",
      0.0
    ],
    [
      "taniere",
      0.0
    ],
    [
      "imbattable",
      0.0
    ],
    [
      "herculeen",
      0.0
    ],
    [
      "fetide",
      0.0
    ],
    [
      "alcoolise",
      0.0
    ],
    [
      "arme",
      0.0
    ],
    [
      "athletique",
      0.0
    ],
    [
      "aveuglant",
      0.0
    ],
    [
      "centre",
      0.0
    ],
    [
      "claironnant",
      0.0
    ],
    [
      "despotique",
      0.0
    ],
    [
      "dictatorial",
      0.0
    ],
    [
      "entetant",
      0.0
    ],
    [
      "excellent",
      0.0
    ],
    [
      "alcide",
      0.0
    ]
  ],
  "persister": [
    [
      "continuer",
      0.1475
    ],
    [
      "demeurer",
      0.11
    ],
    [
      "perseverer",
      0.11
    ],
    [
      "durer",
      0.0975
    ],
    [
      "subsister",
      0.0975
    ],
    [
      "tenir",
      0.0725
    ],
    [
      "rester",
      0.06
    ],
    [
      "s'obstiner",
      0.0475
    ],
    [
      "soutenir",
      0.035
    ],
    [
      "s'eterniser",
      0.035
    ],
    [
      "poursuivre",
      0.0225
    ],
    [
      "s'opiniatrer",
      0.0225
    ],
    [
      "exister",
      0.01
    ],
    [
      "insister",
      0.01
    ],
    [
      "perdurer",
      0.01
    ],
    [
      "survivre",
      0.01
    ]
  ],
  "chanter": [
    [
      "crier",
      0.065
    ],
    [
      "dire",
      0.055
    ],
    [
      "murmurer",
      0.03
    ],
    [
      "publier",
      0.03
    ],
    [
      "repeter",
      0.03
    ],
    [
      "seriner",
      0.03
    ],
    [
      "hurler",
      0.0225
    ],
    [
      "louer",
      0.0225
    ],
    [
      "plaire",
      0.0225
    ],
    [
      "pepier",
      0.0225
    ],
    [
      "rabacher",
      0.0225
    ],
    [
      "raconter",
      0.0225
    ],
    [
      "siffler",
      0.0225
    ],
    [
      "gueuler",
      0.0225
    ],
    [
      "gringotter",
      0.0225
    ],
    [
      "bourdonner",
      0.0225
    ],
    [
      "brailler",
      0.0225
    ],
    [
      "convenir",
      0.0225
    ],
    [
      "celebrer",
      0.0225
    ],
    [
      "debiter",
      0.0225
    ],
    [
      "fredonner",
      0.0225
    ],
    [
      "gazouiller",
      0.0225
    ],
    [
      "redire",
      0.015
    ],
    [
      "jaser",
      0.015
    ],
    [
      "exalter",
      0.015
    ],
    [
      "degoiser",
      0.015
    ],
    [
      "braire",
      0.015
    ],
    [
      "beugler",
      0.015
    ],
    [
      "aboyer",
      0.015
    ],
    [
      "ramager",
      0.005
    ],
    [
      "railler",
      0.005
    ],
    [
      "radoter",
      0.005
    ],
    [
      "psalmodier",
      0.005
    ],
    [
      "proclamer",
      0.005
    ],
    [
      "nuancer",
      0.005
    ],
    [
      "moduler",
      0.005
    ],
    [
      "roucouler",
      0.005
    ],
    [
      "s'egosiller",
      0.005
    ],
    [
      "solfier",
      0.005
    ],
    [
      "sourire",
      0.005
    ],
    [
      "striduler",
      0.005
    ],
    [
      "tenoriser",
      0.005
    ],
    [
      "vocaliser",
      0.005
    ],
    [
      "miauler",
      0.005
    ],
    [
      "machicoter",
      0.005
    ],
    [
      "jodler",
      0.005
    ],
    [
      "barytonner",
      0.005
    ],
    [
      "bouillir",
      0.005
    ],
    [
      "bramer",
      0.005
    ],
    [
      "chansonner",
      0.005
    ],
    [
      "chantonner",
      0.005
    ],
    [
      "chevroter",
      0.005
    ],
    [
      "conter",
      0.005
    ],
    [
      "coqueriquer",
      0.005
    ],
    [
      "dechiffrer",
      0.005
    ],
    [
      "detonner",
      0.005
    ],
    [
      "entonner",
      0.005
    ],
    [
      "executer",
      0.005
    ],
    [
      "glorifier",
      0.005
    ],
    [
      "goualer",
      0.005
    ],
    [
      "gresiller",
      0.005
    ],
    [
      "agreer",
      0.005
    ]
  ],
  "seulement": [
    [
      "simplement",
      0.135
    ],
    [
      "uniquement",
      0.135
    ],
    [
      "neanmoins",
      0.09
    ],
    [
      "pourtant",
      0.09
    ],
    [
      "purement",
      0.09
    ],
    [
      "malheureusement",
      0.045
    ],
    [
      "mais",
      0.045
    ],
    [
      "juste",
      0.045
    ],
    [
      "exclusivement",
      0.045
    ],
    [
      "cependant",
      0.045
    ],
    [
      "toutefois",
      0.045
    ]
  ],
  "hiver": [
    [
      "an",
      0.2
    ],
    [
      "frimas",
      0.2
    ],
    [
      "froid",
      0.2
    ],
    [
      "froidure",
      0.2
    ],
    [
      "vieillesse",
      0.2
    ]
  ],
  "installer": [
    [
      "etablir",
      0.1125
    ],
    [
      "placer",
      0.0975
    ],
    [
      "disposer",
      0.09
    ],
    [
      "mettre",
      0.0675
    ],
    [
      "situer",
      0.06
    ],
    [
      "poser",
      0.0525
    ],
    [
      "agencer",
      0.035
    ],
    [
      "organiser",
      0.03
    ],
    [
      "fixer",
      0.03
    ],
    [
      "dresser",
      0.03
    ],
    [
      "camper",
      0.03
    ],
    [
      "arranger",
      0.03
    ],
    [
      "poster",
      0.02
    ],
    [
      "monter",
      0.02
    ],
    [
      "introniser",
      0.02
    ],
    [
      "implanter",
      0.02
    ],
    [
      "caser",
      0.02
    ],
    [
      "amenager",
      0.02
    ],
    [
      "affecter",
      0.02
    ],
    [
      "investir",
      0.015
    ],
    [
      "loger",
      0.015
    ],
    [
      "nommer",
      0.015
    ],
    [
      "preposer",
      0.005
    ],
    [
      "repartir",
      0.005
    ],
    [
      "sedentariser",
      0.005
    ],
    [
      "titulariser",
      0.005
    ],
    [
      "implementer",
      0.005
    ],
    [
      "emmenager",
      0.005
    ],
    [
      "asseoir",
      0.005
    ],
    [
      "adapter",
      0.005
    ],
    [
      "accrediter",
      0.005
    ],
    [
      "accorder",
      0.005
    ],
    [
      "accommoder",
      0.005
    ],
    [
      "equiper",
      0.005
    ]
  ],
  "doucement": [
    [
      "lentement",
      0.135
    ],
    [
      "insensiblement",
      0.0675
    ],
    [
      "mollement",
      0.0675
    ],
    [
      "progressivement",
      0.05
    ],
    [
      "legerement",
      0.05
    ],
    [
      "graduellement",
      0.05
    ],
    [
      "posement",
      0.0325
    ],
    [
      "piano",
      0.0325
    ],
    [
      "paisiblement",
      0.0325
    ],
    [
      "imperceptiblement",
      0.0325
    ],
    [
      "faiblement",
      0.0325
    ],
    [
      "delicatement",
      0.0325
    ],
    [
      "calmement",
      0.0325
    ],
    [
      "silencieusement",
      0.015
    ],
    [
      "secretement",
      0.015
    ],
    [
      "pianissimo",
      0.015
    ],
    [
      "mou",
      0.015
    ],
    [
      "mollo",
      0.015
    ],
    [
      "furtivement",
      0.015
    ],
    [
      "doucettement",
      0.015
    ],
    [
      "bellement",
      0.015
    ],
    [
      "agreablement",
      0.015
    ]
  ],
  "nuit": [
    [
      "blesser",
      0.08
    ],
    [
      "contrarier",
      0.055
    ],
    [
      "discrediter",
      0.055
    ],
    [
      "desservir",
      0.0475
    ],
    [
      "gener",
      0.0475
    ],
    [
      "prejudicier",
      0.04
    ],
    [
      "perdre",
      0.04
    ],
    [
      "leser",
      0.04
    ],
    [
      "entraver",
      0.04
    ],
    [
      "detruire",
      0.03
    ],
    [
      "deshonorer",
      0.03
    ],
    [
      "attaquer",
      0.03
    ],
    [
      "s'opposer",
      0.0225
    ],
    [
      "freiner",
      0.0225
    ],
    [
      "calomnier",
      0.0225
    ],
    [
      "violer",
      0.015
    ],
    [
      "ruiner",
      0.015
    ],
    [
      "paralyser",
      0.015
    ],
    [
      "medire",
      0.015
    ],
    [
      "endommager",
      0.015
    ],
    [
      "desobliger",
      0.015
    ],
    [
      "desavantager",
      0.015
    ],
    [
      "contrecarrer",
      0.015
    ],
    [
      "compromettre",
      0.015
    ],
    [
      "jurer",
      0.005
    ],
    [
      "ralentir",
      0.005
    ],
    [
      "deparer",
      0.005
    ],
    [
      "defavoriser",
      0.005
    ],
    [
      "deconsiderer",
      0.005
    ],
    [
      "baver",
      0.005
    ],
    [
      "affaiblir",
      0.005
    ]
  ],
  "nuire": [
    [
      "blesser",
      0.08
    ],
    [
      "contrarier",
      0.055
    ],
    [
      "discrediter",
      0.055
    ],
    [
      "desservir",
      0.0475
    ],
    [
      "gener",
      0.0475
    ],
    [
      "prejudicier",
      0.04
    ],
    [
      "perdre",
      0.04
    ],
    [
      "leser",
      0.04
    ],
    [
      "entraver",
      0.04
    ],
    [
      "detruire",
      0.03
    ],
    [
      "deshonorer",
      0.03
    ],
    [
      "attaquer",
      0.03
    ],
    [
      "s'opposer",
      0.0225
    ],
    [
      "freiner",
      0.0225
    ],
    [
      "calomnier",
      0.0225
    ],
    [
      "violer",
      0.015
    ],
    [
      "ruiner",
      0.015
    ],
    [
      "paralyser",
      0.015
    ],
    [
      "medire",
      0.015
    ],
    [
      "endommager",
      0.015
    ],
    [
      "desobliger",
      0.015
    ],
    [
      "desavantager",
      0.015
    ],
    [
      "contrecarrer",
      0.015
    ],
    [
      "compromettre",
      0.015
    ],
    [
      "jurer",
      0.005
    ],
    [
      "ralentir",
      0.005
    ],
    [
      "deparer",
      0.005
    ],
    [
      "defavoriser",
      0.005
    ],
    [
      "deconsiderer",
      0.005
    ],
    [
      "baver",
      0.005
    ],
    [
      "affaiblir",
      0.005
    ]
  ],
  "neiger": [],
  "neige": [
    [
      "blanche",
      0.25
    ],
    [
      "glace",
      0.25
    ],
    [
      "hydrometeore",
      0.25
    ],
    [
      "mousse",
      0.25
    ]
  ],
  "reine": [
    [
      "biquette",
      0.165
    ],
    [
      "dame",
      0.165
    ],
    [
      "deesse",
      0.165
    ],
    [
      "phenix",
      0.165
    ],
    [
      "souveraine",
      0.165
    ],
    [
      "tresor",
      0.165
    ]
  ],
  "tour": [
    [
      "circuit",
      0.0375
    ],
    [
      "promenade",
      0.0375
    ],
    [
      "tournure",
      0.03
    ],
    [
      "allure",
      0.025
    ],
    [
      "truc",
      0.025
    ],
    [
      "voyage",
      0.025
    ],
    [
      "forme",
      0.0225
    ],
    [
      "plaisanterie",
      0.02
    ],
    [
      "marche",
      0.02
    ],
    [
      "cercle",
      0.02
    ],
    [
      "contour",
      0.0175
    ],
    [
      "course",
      0.015
    ],
    [
      "farce",
      0.015
    ],
    [
      "randonnee",
      0.015
    ],
    [
      "revolution",
      0.015
    ],
    [
      "tournee",
      0.015
    ],
    [
      "style",
      0.0125
    ],
    [
      "ruse",
      0.0125
    ],
    [
      "mechancete",
      0.0125
    ],
    [
      "malice",
      0.0125
    ],
    [
      "facon",
      0.0125
    ],
    [
      "rotation",
      0.01
    ],
    [
      "retour",
      0.01
    ],
    [
      "periple",
      0.01
    ],
    [
      "pirouette",
      0.01
    ],
    [
      "expression",
      0.01
    ],
    [
      "excursion",
      0.01
    ],
    [
      "enceinte",
      0.01
    ],
    [
      "detour",
      0.01
    ],
    [
      "artifice",
      0.01
    ],
    [
      "evolution",
      0.0075
    ],
    [
      "trajet",
      0.0075
    ],
    [
      "sortie",
      0.0075
    ],
    [
      "rosserie",
      0.0075
    ],
    [
      "pourtour",
      0.0075
    ],
    [
      "giration",
      0.0075
    ],
    [
      "facetie",
      0.0075
    ],
    [
      "coup",
      0.0075
    ],
    [
      "aspect",
      0.0075
    ],
    [
      "abri",
      0.0075
    ],
    [
      "physionomie",
      0.005
    ],
    [
      "habitation",
      0.005
    ],
    [
      "fortification",
      0.005
    ],
    [
      "flanerie",
      0.005
    ],
    [
      "pitrerie",
      0.005
    ],
    [
      "prestidigitation",
      0.005
    ],
    [
      "taquinerie",
      0.005
    ],
    [
      "tenue",
      0.005
    ],
    [
      "ton",
      0.005
    ],
    [
      "volte",
      0.005
    ],
    [
      "errance",
      0.005
    ],
    [
      "direction",
      0.005
    ],
    [
      "courbe",
      0.005
    ],
    [
      "acrobatie",
      0.005
    ],
    [
      "attrape",
      0.005
    ],
    [
      "balade",
      0.005
    ],
    [
      "blague",
      0.005
    ],
    [
      "batiment",
      0.005
    ],
    [
      "circonference",
      0.005
    ],
    [
      "circonvolution",
      0.005
    ],
    [
      "clownerie",
      0.005
    ],
    [
      "combine",
      0.005
    ],
    [
      "couleur",
      0.005
    ],
    [
      "soleil",
      0.0025
    ],
    [
      "sinuosite",
      0.0025
    ],
    [
      "semblance",
      0.0025
    ],
    [
      "rang",
      0.0025
    ],
    [
      "peripherie",
      0.0025
    ],
    [
      "perimetre",
      0.0025
    ],
    [
      "stratageme",
      0.0025
    ],
    [
      "succes",
      0.0025
    ],
    [
      "teinte",
      0.0025
    ],
    [
      "tourelle",
      0.0025
    ],
    [
      "tournant",
      0.0025
    ],
    [
      "tournoiement",
      0.0025
    ],
    [
      "vacherie",
      0.0025
    ],
    [
      "viree",
      0.0025
    ],
    [
      "visite",
      0.0025
    ],
    [
      "numero",
      0.0025
    ],
    [
      "niche",
      0.0025
    ],
    [
      "meandre",
      0.0025
    ],
    [
      "alternance",
      0.0025
    ],
    [
      "art",
      0.0025
    ],
    [
      "beffroi",
      0.0025
    ],
    [
      "ceinture",
      0.0025
    ],
    [
      "charge",
      0.0025
    ],
    [
      "clocher",
      0.0025
    ],
    [
      "configuration",
      0.0025
    ],
    [
      "construction",
      0.0025
    ],
    [
      "coude",
      0.0025
    ],
    [
      "locution",
      0.0025
    ],
    [
      "immeuble",
      0.0025
    ],
    [
      "fleche",
      0.0025
    ],
    [
      "expedient",
      0.0025
    ],
    [
      "croisiere",
      0.0025
    ],
    [
      "saut",
      0.0
    ],
    [
      "roue",
      0.0
    ],
    [
      "ronde",
      0.0
    ],
    [
      "qualification",
      0.0
    ],
    [
      "periphrase",
      0.0
    ],
    [
      "piece",
      0.0
    ],
    [
      "parcours",
      0.0
    ],
    [
      "spire",
      0.0
    ],
    [
      "supercherie",
      0.0
    ],
    [
      "tambour",
      0.0
    ],
    [
      "tourbillonnement",
      0.0
    ],
    [
      "tournelle",
      0.0
    ],
    [
      "tourniquet",
      0.0
    ],
    [
      "tracasserie",
      0.0
    ],
    [
      "vadrouille",
      0.0
    ],
    [
      "virevolte",
      0.0
    ],
    [
      "echappee",
      0.0
    ],
    [
      "navigation",
      0.0
    ],
    [
      "mefait",
      0.0
    ],
    [
      "minaret",
      0.0
    ],
    [
      "bordure",
      0.0
    ],
    [
      "building",
      0.0
    ],
    [
      "cabriole",
      0.0
    ],
    [
      "campanile",
      0.0
    ],
    [
      "circumnavigation",
      0.0
    ],
    [
      "conversion",
      0.0
    ],
    [
      "crasse",
      0.0
    ],
    [
      "donjon",
      0.0
    ],
    [
      "deambulation",
      0.0
    ],
    [
      "entourloupette",
      0.0
    ],
    [
      "escamotage",
      0.0
    ],
    [
      "exploit",
      0.0
    ],
    [
      "fumisterie",
      0.0
    ],
    [
      "gentillesse",
      0.0
    ],
    [
      "helepole",
      0.0
    ],
    [
      "jonglerie",
      0.0
    ],
    [
      "aleseuse",
      0.0
    ]
  ],
  "royaume": [
    [
      "domaine",
      0.125
    ],
    [
      "empire",
      0.125
    ],
    [
      "pays",
      0.125
    ],
    [
      "regne",
      0.125
    ],
    [
      "etat",
      0.0825
    ],
    [
      "univers",
      0.0825
    ],
    [
      "sphere",
      0.0825
    ],
    [
      "monarchie",
      0.0825
    ],
    [
      "couronne",
      0.0825
    ],
    [
      "fief",
      0.04
    ],
    [
      "region",
      0.04
    ]
  ],
  "solitude": [
    [
      "isolement",
      0.135
    ],
    [
      "retraite",
      0.135
    ],
    [
      "abandon",
      0.0575
    ],
    [
      "separation",
      0.0575
    ],
    [
      "thebaide",
      0.0575
    ],
    [
      "eloignement",
      0.0375
    ],
    [
      "recueillement",
      0.0375
    ],
    [
      "exil",
      0.0375
    ],
    [
      "desert",
      0.0375
    ],
    [
      "coin",
      0.0375
    ],
    [
      "cloitre",
      0.0375
    ],
    [
      "bled",
      0.0375
    ],
    [
      "veuvage",
      0.0175
    ],
    [
      "taniere",
      0.0175
    ],
    [
      "retranchement",
      0.0175
    ],
    [
      "quarantaine",
      0.0175
    ],
    [
      "ombre",
      0.0175
    ],
    [
      "meditation",
      0.0175
    ],
    [
      "isolation",
      0.0175
    ],
    [
      "dereliction",
      0.0175
    ],
    [
      "delaissement",
      0.0175
    ],
    [
      "coque",
      0.0175
    ],
    [
      "cocon",
      0.0175
    ],
    [
      "claustration",
      0.0175
    ],
    [
      "viduite",
      0.0175
    ]
  ],
  "place": [
    [
      "situation",
      0.1
    ],
    [
      "lieu",
      0.0725
    ],
    [
      "position",
      0.0725
    ],
    [
      "fonction",
      0.06
    ],
    [
      "emplacement",
      0.05
    ],
    [
      "emploi",
      0.05
    ],
    [
      "metier",
      0.035
    ],
    [
      "charge",
      0.03
    ],
    [
      "endroit",
      0.03
    ],
    [
      "poste",
      0.03
    ],
    [
      "rang",
      0.03
    ],
    [
      "travail",
      0.0225
    ],
    [
      "point",
      0.0225
    ],
    [
      "disposition",
      0.0225
    ],
    [
      "square",
      0.0175
    ],
    [
      "site",
      0.0175
    ],
    [
      "ordre",
      0.0175
    ],
    [
      "condition",
      0.0175
    ],
    [
      "coin",
      0.0175
    ],
    [
      "terrain",
      0.01
    ],
    [
      "siege",
      0.01
    ],
    [
      "quinconce",
      0.01
    ],
    [
      "office",
      0.01
    ],
    [
      "espace",
      0.01
    ],
    [
      "dignite",
      0.01
    ],
    [
      "carre",
      0.01
    ],
    [
      "arrangement",
      0.01
    ],
    [
      "aire",
      0.01
    ],
    [
      "agora",
      0.01
    ],
    [
      "agencement",
      0.01
    ],
    [
      "poids",
      0.005
    ],
    [
      "placette",
      0.005
    ],
    [
      "peau",
      0.005
    ],
    [
      "parvis",
      0.005
    ],
    [
      "portee",
      0.005
    ],
    [
      "protocole",
      0.005
    ],
    [
      "redoute",
      0.005
    ],
    [
      "stalle",
      0.005
    ],
    [
      "volume",
      0.005
    ],
    [
      "maison",
      0.005
    ],
    [
      "job",
      0.005
    ],
    [
      "berceau",
      0.005
    ],
    [
      "caserne",
      0.005
    ],
    [
      "citadelle",
      0.005
    ],
    [
      "entree",
      0.005
    ],
    [
      "esplanade",
      0.005
    ],
    [
      "fauteuil",
      0.005
    ],
    [
      "filon",
      0.005
    ],
    [
      "forum",
      0.005
    ],
    [
      "installation",
      0.005
    ],
    [
      "etiquette",
      0.005
    ]
  ],
  "placer": [
    [
      "mettre",
      0.15
    ],
    [
      "situer",
      0.055
    ],
    [
      "etablir",
      0.05
    ],
    [
      "disposer",
      0.045
    ],
    [
      "poser",
      0.045
    ],
    [
      "caser",
      0.035
    ],
    [
      "installer",
      0.0325
    ],
    [
      "ranger",
      0.03
    ],
    [
      "ficher",
      0.03
    ],
    [
      "coller",
      0.03
    ],
    [
      "appliquer",
      0.025
    ],
    [
      "arranger",
      0.025
    ],
    [
      "loger",
      0.025
    ],
    [
      "fourrer",
      0.02
    ],
    [
      "fixer",
      0.02
    ],
    [
      "camper",
      0.02
    ],
    [
      "dresser",
      0.0175
    ],
    [
      "planter",
      0.0175
    ],
    [
      "attacher",
      0.015
    ],
    [
      "flanquer",
      0.015
    ],
    [
      "ordonner",
      0.0125
    ],
    [
      "introduire",
      0.0125
    ],
    [
      "fonder",
      0.0125
    ],
    [
      "constituer",
      0.0125
    ],
    [
      "classer",
      0.0125
    ],
    [
      "poster",
      0.01
    ],
    [
      "serrer",
      0.01
    ],
    [
      "etendre",
      0.0075
    ],
    [
      "eriger",
      0.0075
    ],
    [
      "elever",
      0.0075
    ],
    [
      "pourvoir",
      0.0075
    ],
    [
      "exposer",
      0.0075
    ],
    [
      "coucher",
      0.0075
    ],
    [
      "assigner",
      0.0075
    ],
    [
      "asseoir",
      0.0075
    ],
    [
      "miser",
      0.005
    ],
    [
      "nicher",
      0.005
    ],
    [
      "percher",
      0.005
    ],
    [
      "preter",
      0.005
    ],
    [
      "risquer",
      0.005
    ],
    [
      "vendre",
      0.005
    ],
    [
      "investir",
      0.005
    ],
    [
      "interposer",
      0.005
    ],
    [
      "instituer",
      0.005
    ],
    [
      "agencer",
      0.005
    ],
    [
      "ajuster",
      0.005
    ],
    [
      "aposter",
      0.005
    ],
    [
      "ceindre",
      0.005
    ],
    [
      "charger",
      0.005
    ],
    [
      "foutre",
      0.005
    ],
    [
      "echelonner",
      0.0025
    ],
    [
      "thesauriser",
      0.0025
    ],
    [
      "replacer",
      0.0025
    ],
    [
      "remiser",
      0.0025
    ],
    [
      "positionner",
      0.0025
    ],
    [
      "ponter",
      0.0025
    ],
    [
      "localiser",
      0.0025
    ],
    [
      "liquider",
      0.0025
    ],
    [
      "glisser",
      0.0025
    ],
    [
      "deposer",
      0.0025
    ],
    [
      "colloquer",
      0.0025
    ],
    [
      "bouter",
      0.0025
    ],
    [
      "abouter",
      0.0025
    ],
    [
      "ecouler",
      0.0025
    ]
  ],
  "vent": [
    [
      "souffle",
      0.0725
    ],
    [
      "bruit",
      0.0475
    ],
    [
      "bourrasque",
      0.04
    ],
    [
      "tempete",
      0.04
    ],
    [
      "emanation",
      0.03
    ],
    [
      "haleine",
      0.03
    ],
    [
      "air",
      0.03
    ],
    [
      "rafale",
      0.0225
    ],
    [
      "gaz",
      0.0225
    ],
    [
      "fumee",
      0.0225
    ],
    [
      "flatuosite",
      0.0225
    ],
    [
      "brise",
      0.0225
    ],
    [
      "bise",
      0.0225
    ],
    [
      "pet",
      0.015
    ],
    [
      "simoun",
      0.015
    ],
    [
      "temps",
      0.015
    ],
    [
      "tornade",
      0.015
    ],
    [
      "tourbillon",
      0.015
    ],
    [
      "typhon",
      0.015
    ],
    [
      "ouragan",
      0.015
    ],
    [
      "odeur",
      0.015
    ],
    [
      "agitation",
      0.015
    ],
    [
      "courant",
      0.015
    ],
    [
      "flatulence",
      0.015
    ],
    [
      "flot",
      0.015
    ],
    [
      "flux",
      0.015
    ],
    [
      "intemperie",
      0.015
    ],
    [
      "risee",
      0.0075
    ],
    [
      "petarade",
      0.0075
    ],
    [
      "promesse",
      0.0075
    ],
    [
      "perlouse",
      0.0075
    ],
    [
      "pampero",
      0.0075
    ],
    [
      "neant",
      0.0075
    ],
    [
      "nouvelle",
      0.0075
    ],
    [
      "notus",
      0.0075
    ],
    [
      "senteur",
      0.0075
    ],
    [
      "sirocco",
      0.0075
    ],
    [
      "suroit",
      0.0075
    ],
    [
      "zephyr",
      0.0075
    ],
    [
      "zef",
      0.0075
    ],
    [
      "vogue",
      0.0075
    ],
    [
      "vesse",
      0.0075
    ],
    [
      "ventosite",
      0.0075
    ],
    [
      "vanne",
      0.0075
    ],
    [
      "vanite",
      0.0075
    ],
    [
      "tramontane",
      0.0075
    ],
    [
      "noroit",
      0.0075
    ],
    [
      "mousson",
      0.0075
    ],
    [
      "mode",
      0.0075
    ],
    [
      "chergui",
      0.0075
    ],
    [
      "boree",
      0.0075
    ],
    [
      "blizzard",
      0.0075
    ],
    [
      "battage",
      0.0075
    ],
    [
      "autan",
      0.0075
    ],
    [
      "auster",
      0.0075
    ],
    [
      "aquilon",
      0.0075
    ],
    [
      "cyclone",
      0.0075
    ],
    [
      "debourree",
      0.0075
    ],
    [
      "mistral",
      0.0075
    ],
    [
      "maree",
      0.0075
    ],
    [
      "louise",
      0.0075
    ],
    [
      "louffe",
      0.0075
    ],
    [
      "incongruite",
      0.0075
    ],
    [
      "harmattan",
      0.0075
    ],
    [
      "galerne",
      0.0075
    ],
    [
      "foehn",
      0.0075
    ],
    [
      "alize",
      0.0075
    ]
  ],
  "hurler": [
    [
      "crier",
      0.1975
    ],
    [
      "gueuler",
      0.085
    ],
    [
      "bramer",
      0.0725
    ],
    [
      "vociferer",
      0.0725
    ],
    [
      "beugler",
      0.06
    ],
    [
      "brailler",
      0.06
    ],
    [
      "tempeter",
      0.0475
    ],
    [
      "s'egosiller",
      0.0475
    ],
    [
      "aboyer",
      0.035
    ],
    [
      "chanter",
      0.035
    ],
    [
      "mugir",
      0.035
    ],
    [
      "rugir",
      0.035
    ],
    [
      "jurer",
      0.0225
    ],
    [
      "injurier",
      0.0225
    ],
    [
      "gronder",
      0.0225
    ],
    [
      "fulminer",
      0.0225
    ],
    [
      "tonitruer",
      0.01
    ],
    [
      "s'epoumoner",
      0.01
    ],
    [
      "pleurer",
      0.01
    ],
    [
      "hennir",
      0.01
    ],
    [
      "glapir",
      0.01
    ],
    [
      "clamer",
      0.01
    ],
    [
      "trancher",
      0.01
    ]
  ],
  "penser": [
    [
      "idee",
      0.5
    ],
    [
      "pensee",
      0.5
    ]
  ],
  "lutter": [
    [
      "batailler",
      0.1175
    ],
    [
      "combattre",
      0.08
    ],
    [
      "resister",
      0.0425
    ],
    [
      "s'opposer",
      0.035
    ],
    [
      "s'escrimer",
      0.035
    ],
    [
      "disputer",
      0.035
    ],
    [
      "discuter",
      0.035
    ],
    [
      "jouter",
      0.03
    ],
    [
      "ferrailler",
      0.03
    ],
    [
      "battre",
      0.03
    ],
    [
      "affronter",
      0.03
    ],
    [
      "s'evertuer",
      0.0225
    ],
    [
      "s'affronter",
      0.0225
    ],
    [
      "rivaliser",
      0.0175
    ],
    [
      "barouder",
      0.0175
    ],
    [
      "bagarrer",
      0.0175
    ],
    [
      "etouffer",
      0.01
    ],
    [
      "s'acharner",
      0.01
    ],
    [
      "escrimer",
      0.01
    ],
    [
      "couvrir",
      0.01
    ],
    [
      "contenir",
      0.01
    ],
    [
      "attaquer",
      0.01
    ],
    [
      "agir",
      0.01
    ],
    [
      "s'efforcer",
      0.005
    ],
    [
      "s'accoupler",
      0.005
    ],
    [
      "refrener",
      0.005
    ],
    [
      "militer",
      0.005
    ],
    [
      "guerroyer",
      0.005
    ],
    [
      "demeurer",
      0.005
    ]
  ],
  "vain": [
    [
      "inutile",
      0.0575
    ],
    [
      "sterile",
      0.0575
    ],
    [
      "vide",
      0.05
    ],
    [
      "futile",
      0.045
    ],
    [
      "suffisant",
      0.04
    ],
    [
      "imaginaire",
      0.04
    ],
    [
      "fat",
      0.0325
    ],
    [
      "pretentieux",
      0.0325
    ],
    [
      "vaniteux",
      0.0275
    ],
    [
      "orgueilleux",
      0.0275
    ],
    [
      "insignifiant",
      0.0275
    ],
    [
      "illusoire",
      0.0275
    ],
    [
      "bete",
      0.0275
    ],
    [
      "superficiel",
      0.0225
    ],
    [
      "superbe",
      0.0225
    ],
    [
      "sot",
      0.0225
    ],
    [
      "leger",
      0.0225
    ],
    [
      "frivole",
      0.0225
    ],
    [
      "chimerique",
      0.0225
    ],
    [
      "absurde",
      0.0225
    ],
    [
      "infructueux",
      0.015
    ],
    [
      "infatue",
      0.015
    ],
    [
      "inefficace",
      0.015
    ],
    [
      "fier",
      0.015
    ],
    [
      "creux",
      0.015
    ],
    [
      "satisfait",
      0.01
    ],
    [
      "presomptueux",
      0.01
    ],
    [
      "oiseux",
      0.01
    ],
    [
      "negatif",
      0.01
    ],
    [
      "inoperant",
      0.01
    ],
    [
      "infecond",
      0.01
    ],
    [
      "infertile",
      0.01
    ],
    [
      "inculte",
      0.01
    ],
    [
      "impossible",
      0.01
    ],
    [
      "important",
      0.01
    ],
    [
      "glorieux",
      0.01
    ],
    [
      "faux",
      0.01
    ],
    [
      "pueril",
      0.005
    ],
    [
      "superflu",
      0.005
    ],
    [
      "irreel",
      0.005
    ],
    [
      "insaisissable",
      0.005
    ],
    [
      "incapable",
      0.005
    ],
    [
      "hypothetique",
      0.005
    ],
    [
      "fugace",
      0.005
    ],
    [
      "fastueux",
      0.005
    ],
    [
      "fantaisiste",
      0.005
    ],
    [
      "derisoire",
      0.005
    ],
    [
      "avorte",
      0.005
    ]
  ],
  "tes": [
    [
      "regle",
      0.3325
    ],
    [
      "tiens",
      0.3325
    ],
    [
      "equerre",
      0.3325
    ]
  ],
  "attention": [
    [
      "soin",
      0.1275
    ],
    [
      "application",
      0.07
    ],
    [
      "circonspection",
      0.05
    ],
    [
      "prevenance",
      0.05
    ],
    [
      "gentillesse",
      0.0425
    ],
    [
      "delicatesse",
      0.0375
    ],
    [
      "zele",
      0.03
    ],
    [
      "reflexion",
      0.03
    ],
    [
      "empressement",
      0.03
    ],
    [
      "amabilite",
      0.03
    ],
    [
      "vigilance",
      0.025
    ],
    [
      "sollicitude",
      0.025
    ],
    [
      "precaution",
      0.025
    ],
    [
      "prudence",
      0.025
    ],
    [
      "obligeance",
      0.025
    ],
    [
      "meditation",
      0.025
    ],
    [
      "diligence",
      0.025
    ],
    [
      "concentration",
      0.025
    ],
    [
      "complaisance",
      0.025
    ],
    [
      "etude",
      0.0175
    ],
    [
      "menagement",
      0.0175
    ],
    [
      "curiosite",
      0.0175
    ],
    [
      "consideration",
      0.0175
    ],
    [
      "conscience",
      0.0175
    ],
    [
      "egard",
      0.01
    ],
    [
      "sensibilite",
      0.01
    ],
    [
      "prevoyance",
      0.01
    ],
    [
      "interet",
      0.01
    ],
    [
      "gracieusete",
      0.01
    ],
    [
      "effort",
      0.01
    ],
    [
      "contention",
      0.01
    ],
    [
      "tension",
      0.005
    ],
    [
      "surveillance",
      0.005
    ],
    [
      "regularite",
      0.005
    ],
    [
      "preference",
      0.005
    ],
    [
      "introspection",
      0.005
    ],
    [
      "gare",
      0.005
    ],
    [
      "gaffe",
      0.005
    ],
    [
      "exactitude",
      0.005
    ],
    [
      "contemplation",
      0.005
    ],
    [
      "caresse",
      0.005
    ],
    [
      "audience",
      0.005
    ]
  ],
  "secret": [
    [
      "cache",
      0.0875
    ],
    [
      "mysterieux",
      0.0475
    ],
    [
      "obscur",
      0.0475
    ],
    [
      "impenetrable",
      0.045
    ],
    [
      "tenebreux",
      0.0325
    ],
    [
      "mystere",
      0.03
    ],
    [
      "occulte",
      0.0275
    ],
    [
      "sourd",
      0.0275
    ],
    [
      "insaisissable",
      0.0275
    ],
    [
      "inconnu",
      0.0275
    ],
    [
      "dissimule",
      0.0225
    ],
    [
      "enigmatique",
      0.0225
    ],
    [
      "sournois",
      0.02
    ],
    [
      "renferme",
      0.0175
    ],
    [
      "voile",
      0.0175
    ],
    [
      "souterrain",
      0.0125
    ],
    [
      "sibyllin",
      0.0125
    ],
    [
      "reserve",
      0.0125
    ],
    [
      "nebuleux",
      0.0125
    ],
    [
      "latent",
      0.0125
    ],
    [
      "fuyant",
      0.0125
    ],
    [
      "clandestin",
      0.0125
    ],
    [
      "esoterique",
      0.01
    ],
    [
      "truc",
      0.01
    ],
    [
      "hermetique",
      0.01
    ],
    [
      "furtif",
      0.01
    ],
    [
      "discret",
      0.01
    ],
    [
      "intime",
      0.01
    ],
    [
      "profond",
      0.01
    ],
    [
      "profondeur",
      0.01
    ],
    [
      "silencieux",
      0.0075
    ],
    [
      "repli",
      0.0075
    ],
    [
      "moyen",
      0.0075
    ],
    [
      "interieur",
      0.0075
    ],
    [
      "inexplicable",
      0.0075
    ],
    [
      "fond",
      0.0075
    ],
    [
      "astuce",
      0.0075
    ],
    [
      "invisible",
      0.005
    ],
    [
      "masque",
      0.005
    ],
    [
      "procede",
      0.005
    ],
    [
      "subreptice",
      0.005
    ],
    [
      "taciturne",
      0.005
    ],
    [
      "trefonds",
      0.005
    ],
    [
      "introuvable",
      0.005
    ],
    [
      "hypocrite",
      0.005
    ],
    [
      "anonyme",
      0.005
    ],
    [
      "art",
      0.005
    ],
    [
      "cabalistique",
      0.005
    ],
    [
      "cachottier",
      0.005
    ],
    [
      "detour",
      0.005
    ],
    [
      "glissant",
      0.005
    ],
    [
      "pudique",
      0.0025
    ],
    [
      "recette",
      0.0025
    ],
    [
      "recoin",
      0.0025
    ],
    [
      "retenu",
      0.0025
    ],
    [
      "retire",
      0.0025
    ],
    [
      "reserve",
      0.0025
    ],
    [
      "reticent",
      0.0025
    ],
    [
      "science",
      0.0025
    ],
    [
      "tenebres",
      0.0025
    ],
    [
      "ame",
      0.0025
    ],
    [
      "enigme",
      0.0025
    ],
    [
      "ombre",
      0.0025
    ],
    [
      "methode",
      0.0025
    ],
    [
      "larve",
      0.0025
    ],
    [
      "abscons",
      0.0025
    ],
    [
      "cachette",
      0.0025
    ],
    [
      "coulisse",
      0.0025
    ],
    [
      "discretion",
      0.0025
    ],
    [
      "ficelle",
      0.0025
    ],
    [
      "ignore",
      0.0025
    ],
    [
      "incognito",
      0.0025
    ],
    [
      "indefinissable",
      0.0025
    ],
    [
      "insinuant",
      0.0025
    ],
    [
      "insondable",
      0.0025
    ],
    [
      "intimite",
      0.0025
    ],
    [
      "irrevele",
      0.0025
    ],
    [
      "inconnaissable",
      0.0
    ],
    [
      "inavoue",
      0.0
    ],
    [
      "illicite",
      0.0
    ],
    [
      "derobe",
      0.0
    ],
    [
      "mystique",
      0.0
    ],
    [
      "pli",
      0.0
    ],
    [
      "retenue",
      0.0
    ],
    [
      "rebus",
      0.0
    ],
    [
      "silence",
      0.0
    ],
    [
      "somnolent",
      0.0
    ],
    [
      "dedale",
      0.0
    ],
    [
      "arcane",
      0.0
    ],
    [
      "botte",
      0.0
    ],
    [
      "boutonne",
      0.0
    ],
    [
      "cabale",
      0.0
    ],
    [
      "cachotterie",
      0.0
    ],
    [
      "chafouin",
      0.0
    ],
    [
      "clandestinite",
      0.0
    ],
    [
      "concentre",
      0.0
    ],
    [
      "confidence",
      0.0
    ],
    [
      "confidentiel",
      0.0
    ],
    [
      "dessous",
      0.0
    ],
    [
      "equivoque",
      0.0
    ]
  ],
  "survivre": [
    [
      "subsister",
      0.2075
    ],
    [
      "rester",
      0.1725
    ],
    [
      "continuer",
      0.1025
    ],
    [
      "s'eterniser",
      0.1025
    ],
    [
      "trainer",
      0.1025
    ],
    [
      "demeurer",
      0.0675
    ],
    [
      "surnager",
      0.0325
    ],
    [
      "resister",
      0.0325
    ],
    [
      "persister",
      0.0325
    ],
    [
      "enterrer",
      0.0325
    ],
    [
      "vegeter",
      0.0325
    ]
  ],
  "etat": [
    [
      "situation",
      0.0575
    ],
    [
      "condition",
      0.0475
    ],
    [
      "position",
      0.0375
    ],
    [
      "qualite",
      0.03
    ],
    [
      "fonction",
      0.0275
    ],
    [
      "rang",
      0.0275
    ],
    [
      "profession",
      0.0225
    ],
    [
      "liste",
      0.0225
    ],
    [
      "disposition",
      0.0225
    ],
    [
      "metier",
      0.02
    ],
    [
      "pouvoir",
      0.02
    ],
    [
      "tableau",
      0.0175
    ],
    [
      "repertoire",
      0.0175
    ],
    [
      "releve",
      0.0175
    ],
    [
      "puissance",
      0.0175
    ],
    [
      "pays",
      0.0175
    ],
    [
      "note",
      0.0175
    ],
    [
      "nation",
      0.0175
    ],
    [
      "inventaire",
      0.0175
    ],
    [
      "empire",
      0.0175
    ],
    [
      "travail",
      0.015
    ],
    [
      "role",
      0.015
    ],
    [
      "revue",
      0.015
    ],
    [
      "nature",
      0.015
    ],
    [
      "gouvernement",
      0.015
    ],
    [
      "forme",
      0.015
    ],
    [
      "denombrement",
      0.015
    ],
    [
      "classe",
      0.015
    ],
    [
      "catalogue",
      0.015
    ],
    [
      "vie",
      0.01
    ],
    [
      "sorte",
      0.01
    ],
    [
      "sort",
      0.01
    ],
    [
      "emploi",
      0.01
    ],
    [
      "bordereau",
      0.01
    ],
    [
      "bilan",
      0.01
    ],
    [
      "expose",
      0.0075
    ],
    [
      "facture",
      0.0075
    ],
    [
      "memoire",
      0.0075
    ],
    [
      "point",
      0.0075
    ],
    [
      "republique",
      0.0075
    ],
    [
      "statut",
      0.0075
    ],
    [
      "etre",
      0.0075
    ],
    [
      "existence",
      0.0075
    ],
    [
      "espece",
      0.0075
    ],
    [
      "declaration",
      0.0075
    ],
    [
      "art",
      0.0075
    ],
    [
      "bulletin",
      0.0075
    ],
    [
      "carriere",
      0.0075
    ],
    [
      "cas",
      0.0075
    ],
    [
      "conjoncture",
      0.0075
    ],
    [
      "description",
      0.0075
    ],
    [
      "destin",
      0.0075
    ],
    [
      "posture",
      0.005
    ],
    [
      "province",
      0.005
    ],
    [
      "royaume",
      0.005
    ],
    [
      "regime",
      0.005
    ],
    [
      "societe",
      0.005
    ],
    [
      "souverainete",
      0.005
    ],
    [
      "statistique",
      0.005
    ],
    [
      "volee",
      0.005
    ],
    [
      "patrie",
      0.005
    ],
    [
      "modalite",
      0.005
    ],
    [
      "administration",
      0.005
    ],
    [
      "attitude",
      0.005
    ],
    [
      "champ",
      0.005
    ],
    [
      "cite",
      0.005
    ],
    [
      "communaute",
      0.005
    ],
    [
      "couronne",
      0.005
    ],
    [
      "fortune",
      0.005
    ],
    [
      "recensement",
      0.0
    ],
    [
      "recu",
      0.0
    ],
    [
      "temperament",
      0.0
    ],
    [
      "territoire",
      0.0
    ],
    [
      "questionnaire",
      0.0
    ],
    [
      "politique",
      0.0
    ],
    [
      "nomenclature",
      0.0
    ],
    [
      "naissance",
      0.0
    ],
    [
      "division",
      0.0
    ],
    [
      "equipage",
      0.0
    ]
  ],
  "tourment": [
    [
      "souci",
      0.1025
    ],
    [
      "inquietude",
      0.0925
    ],
    [
      "peine",
      0.0525
    ],
    [
      "chagrin",
      0.05
    ],
    [
      "douleur",
      0.045
    ],
    [
      "affliction",
      0.04
    ],
    [
      "angoisse",
      0.04
    ],
    [
      "ennui",
      0.04
    ],
    [
      "supplice",
      0.035
    ],
    [
      "mal",
      0.035
    ],
    [
      "tracas",
      0.03
    ],
    [
      "preoccupation",
      0.0275
    ],
    [
      "souffrance",
      0.025
    ],
    [
      "emoi",
      0.0175
    ],
    [
      "crainte",
      0.015
    ],
    [
      "boulet",
      0.015
    ],
    [
      "anxiete",
      0.015
    ],
    [
      "agitation",
      0.015
    ],
    [
      "affres",
      0.015
    ],
    [
      "transe",
      0.0125
    ],
    [
      "scrupule",
      0.0125
    ],
    [
      "obsession",
      0.0125
    ],
    [
      "desolation",
      0.0125
    ],
    [
      "alarme",
      0.0125
    ],
    [
      "tracasserie",
      0.01
    ],
    [
      "torture",
      0.01
    ],
    [
      "tintouin",
      0.01
    ],
    [
      "mechancete",
      0.01
    ],
    [
      "desespoir",
      0.01
    ],
    [
      "croix",
      0.01
    ],
    [
      "contrariete",
      0.01
    ],
    [
      "amertume",
      0.01
    ],
    [
      "soin",
      0.0075
    ],
    [
      "malaise",
      0.0075
    ],
    [
      "incertitude",
      0.0075
    ],
    [
      "fardeau",
      0.0075
    ],
    [
      "dechirement",
      0.0075
    ],
    [
      "bile",
      0.0075
    ],
    [
      "poids",
      0.005
    ],
    [
      "plaie",
      0.005
    ],
    [
      "martyre",
      0.005
    ],
    [
      "cauchemar",
      0.005
    ],
    [
      "cassement",
      0.005
    ],
    [
      "sollicitude",
      0.0
    ],
    [
      "rosserie",
      0.0
    ],
    [
      "perplexite",
      0.0
    ],
    [
      "martel",
      0.0
    ],
    [
      "irritation",
      0.0
    ],
    [
      "exigence",
      0.0
    ],
    [
      "exercice",
      0.0
    ],
    [
      "brimade",
      0.0
    ],
    [
      "bourrelement",
      0.0
    ],
    [
      "tracassin",
      0.0
    ]
  ],
  "sentiment": [
    [
      "opinion",
      0.065
    ],
    [
      "idee",
      0.055
    ],
    [
      "pensee",
      0.0525
    ],
    [
      "sens",
      0.045
    ],
    [
      "conscience",
      0.04
    ],
    [
      "intuition",
      0.04
    ],
    [
      "tendance",
      0.04
    ],
    [
      "vue",
      0.0375
    ],
    [
      "coeur",
      0.0375
    ],
    [
      "impression",
      0.03
    ],
    [
      "mouvement",
      0.03
    ],
    [
      "sensation",
      0.025
    ],
    [
      "pressentiment",
      0.025
    ],
    [
      "perception",
      0.025
    ],
    [
      "passion",
      0.025
    ],
    [
      "jugement",
      0.025
    ],
    [
      "amour",
      0.025
    ],
    [
      "avis",
      0.0225
    ],
    [
      "instinct",
      0.0225
    ],
    [
      "position",
      0.0225
    ],
    [
      "sensibilite",
      0.0225
    ],
    [
      "emotion",
      0.0175
    ],
    [
      "notion",
      0.0175
    ],
    [
      "inclination",
      0.0175
    ],
    [
      "esprit",
      0.0175
    ],
    [
      "affection",
      0.0175
    ],
    [
      "disposition",
      0.0125
    ],
    [
      "vision",
      0.01
    ],
    [
      "tendresse",
      0.01
    ],
    [
      "talent",
      0.01
    ],
    [
      "croyance",
      0.01
    ],
    [
      "connaissance",
      0.01
    ],
    [
      "appreciation",
      0.01
    ],
    [
      "emoi",
      0.005
    ],
    [
      "elan",
      0.005
    ],
    [
      "gre",
      0.005
    ],
    [
      "fibre",
      0.005
    ],
    [
      "courage",
      0.005
    ],
    [
      "compassion",
      0.005
    ],
    [
      "attachement",
      0.005
    ],
    [
      "flair",
      0.0025
    ],
    [
      "effet",
      0.0025
    ],
    [
      "consideration",
      0.0025
    ],
    [
      "aperception",
      0.0025
    ],
    [
      "amitie",
      0.0025
    ],
    [
      "affectivite",
      0.0025
    ]
  ],
  "delivrer": [
    [
      "liberer",
      0.17
    ],
    [
      "affranchir",
      0.1075
    ],
    [
      "decharger",
      0.0925
    ],
    [
      "degager",
      0.0925
    ],
    [
      "debarrasser",
      0.0775
    ],
    [
      "soulager",
      0.045
    ],
    [
      "guerir",
      0.045
    ],
    [
      "delier",
      0.045
    ],
    [
      "defaire",
      0.045
    ],
    [
      "tirer",
      0.03
    ],
    [
      "remettre",
      0.03
    ],
    [
      "depetrer",
      0.03
    ],
    [
      "dispenser",
      0.03
    ],
    [
      "emanciper",
      0.015
    ],
    [
      "racheter",
      0.015
    ],
    [
      "livrer",
      0.015
    ],
    [
      "exterioriser",
      0.015
    ],
    [
      "appliquer",
      0.015
    ],
    [
      "apaiser",
      0.015
    ],
    [
      "accoucher",
      0.015
    ],
    [
      "eviter",
      0.015
    ]
  ],
  "mentir": [
    [
      "abuser",
      0.15
    ],
    [
      "tromper",
      0.15
    ],
    [
      "blaguer",
      0.0625
    ],
    [
      "inventer",
      0.0625
    ],
    [
      "jouer",
      0.0625
    ],
    [
      "trahir",
      0.0425
    ],
    [
      "romancer",
      0.0425
    ],
    [
      "plaisanter",
      0.0425
    ],
    [
      "mystifier",
      0.0425
    ],
    [
      "galejer",
      0.0425
    ],
    [
      "feindre",
      0.0425
    ],
    [
      "renier",
      0.02
    ],
    [
      "habler",
      0.02
    ],
    [
      "flatter",
      0.02
    ],
    [
      "fabuler",
      0.02
    ],
    [
      "calomnier",
      0.02
    ],
    [
      "broder",
      0.02
    ],
    [
      "bourrer",
      0.02
    ],
    [
      "taire",
      0.02
    ]
  ],
  "decider": [
    [
      "trancher",
      0.145
    ],
    [
      "determiner",
      0.065
    ],
    [
      "regler",
      0.055
    ],
    [
      "resoudre",
      0.05
    ],
    [
      "ordonner",
      0.05
    ],
    [
      "arreter",
      0.05
    ],
    [
      "dire",
      0.045
    ],
    [
      "prononcer",
      0.04
    ],
    [
      "statuer",
      0.03
    ],
    [
      "juger",
      0.03
    ],
    [
      "disposer",
      0.03
    ],
    [
      "commander",
      0.03
    ],
    [
      "decreter",
      0.0275
    ],
    [
      "conclure",
      0.0225
    ],
    [
      "fixer",
      0.0225
    ],
    [
      "prescrire",
      0.0225
    ],
    [
      "pousser",
      0.0175
    ],
    [
      "faire",
      0.0175
    ],
    [
      "entrainer",
      0.0175
    ],
    [
      "vouloir",
      0.0125
    ],
    [
      "persuader",
      0.0125
    ],
    [
      "jurer",
      0.0125
    ],
    [
      "finir",
      0.0125
    ],
    [
      "convenir",
      0.0125
    ],
    [
      "predestiner",
      0.0075
    ],
    [
      "inciter",
      0.0075
    ],
    [
      "dicter",
      0.0075
    ],
    [
      "choisir",
      0.0075
    ],
    [
      "solutionner",
      0.0025
    ],
    [
      "prevoir",
      0.0025
    ],
    [
      "homologuer",
      0.0025
    ],
    [
      "definir",
      0.0025
    ],
    [
      "destiner",
      0.0025
    ],
    [
      "convaincre",
      0.0025
    ],
    [
      "conjurer",
      0.0025
    ],
    [
      "arbitrer",
      0.0025
    ],
    [
      "vider",
      0.0025
    ]
  ],
  "decide": [
    [
      "trancher",
      0.145
    ],
    [
      "determiner",
      0.065
    ],
    [
      "regler",
      0.055
    ],
    [
      "resoudre",
      0.05
    ],
    [
      "ordonner",
      0.05
    ],
    [
      "arreter",
      0.05
    ],
    [
      "dire",
      0.045
    ],
    [
      "prononcer",
      0.04
    ],
    [
      "statuer",
      0.03
    ],
    [
      "juger",
      0.03
    ],
    [
      "disposer",
      0.03
    ],
    [
      "commander",
      0.03
    ],
    [
      "decreter",
      0.0275
    ],
    [
      "conclure",
      0.0225
    ],
    [
      "fixer",
      0.0225
    ],
    [
      "prescrire",
      0.0225
    ],
    [
      "pousser",
      0.0175
    ],
    [
      "faire",
      0.0175
    ],
    [
      "entrainer",
      0.0175
    ],
    [
      "vouloir",
      0.0125
    ],
    [
      "persuader",
      0.0125
    ],
    [
      "jurer",
      0.0125
    ],
    [
      "finir",
      0.0125
    ],
    [
      "convenir",
      0.0125
    ],
    [
      "predestiner",
      0.0075
    ],
    [
      "inciter",
      0.0075
    ],
    [
      "dicter",
      0.0075
    ],
    [
      "choisir",
      0.0075
    ],
    [
      "solutionner",
      0.0025
    ],
    [
      "prevoir",
      0.0025
    ],
    [
      "homologuer",
      0.0025
    ],
    [
      "definir",
      0.0025
    ],
    [
      "destiner",
      0.0025
    ],
    [
      "convaincre",
      0.0025
    ],
    [
      "conjurer",
      0.0025
    ],
    [
      "arbitrer",
      0.0025
    ],
    [
      "vider",
      0.0025
    ]
  ],
  "froid": [
    [
      "insensible",
      0.07
    ],
    [
      "glacial",
      0.0525
    ],
    [
      "dur",
      0.045
    ],
    [
      "glace",
      0.0375
    ],
    [
      "sec",
      0.0325
    ],
    [
      "indifferent",
      0.0325
    ],
    [
      "impassible",
      0.0325
    ],
    [
      "calme",
      0.0225
    ],
    [
      "froideur",
      0.0225
    ],
    [
      "reserve",
      0.0225
    ],
    [
      "severe",
      0.0175
    ],
    [
      "terne",
      0.0175
    ],
    [
      "rude",
      0.015
    ],
    [
      "imperturbable",
      0.015
    ],
    [
      "flegmatique",
      0.015
    ],
    [
      "brouille",
      0.0125
    ],
    [
      "distant",
      0.0125
    ],
    [
      "mesintelligence",
      0.0125
    ],
    [
      "serieux",
      0.0125
    ],
    [
      "insipide",
      0.01
    ],
    [
      "refroidissement",
      0.01
    ],
    [
      "rigoureux",
      0.01
    ],
    [
      "refrigerant",
      0.01
    ],
    [
      "inanime",
      0.01
    ],
    [
      "implacable",
      0.01
    ],
    [
      "grave",
      0.01
    ],
    [
      "gele",
      0.01
    ],
    [
      "frais",
      0.01
    ],
    [
      "fade",
      0.01
    ],
    [
      "aride",
      0.01
    ],
    [
      "placide",
      0.0075
    ],
    [
      "malaise",
      0.0075
    ],
    [
      "languissant",
      0.0075
    ],
    [
      "inhospitalier",
      0.0075
    ],
    [
      "polaire",
      0.0075
    ],
    [
      "pose",
      0.0075
    ],
    [
      "retenu",
      0.0075
    ],
    [
      "rigueur",
      0.0075
    ],
    [
      "tension",
      0.0075
    ],
    [
      "transi",
      0.0075
    ],
    [
      "inerte",
      0.0075
    ],
    [
      "indifference",
      0.0075
    ],
    [
      "inaccessible",
      0.0075
    ],
    [
      "aigre",
      0.0075
    ],
    [
      "austere",
      0.0075
    ],
    [
      "bouderie",
      0.0075
    ],
    [
      "brouillerie",
      0.0075
    ],
    [
      "ennuyeux",
      0.0075
    ],
    [
      "fier",
      0.0075
    ],
    [
      "frappe",
      0.0075
    ],
    [
      "frimas",
      0.0075
    ],
    [
      "froidure",
      0.0075
    ],
    [
      "hostile",
      0.0075
    ],
    [
      "hautain",
      0.005
    ],
    [
      "impassibilite",
      0.005
    ],
    [
      "impitoyable",
      0.005
    ],
    [
      "inexpressif",
      0.005
    ],
    [
      "monotone",
      0.005
    ],
    [
      "mesentente",
      0.005
    ],
    [
      "plat",
      0.005
    ],
    [
      "rupture",
      0.005
    ],
    [
      "glacant",
      0.005
    ],
    [
      "facherie",
      0.005
    ],
    [
      "frisquet",
      0.005
    ],
    [
      "academique",
      0.005
    ],
    [
      "desseche",
      0.005
    ],
    [
      "dedaigneux",
      0.005
    ],
    [
      "engourdi",
      0.005
    ],
    [
      "fadasse",
      0.005
    ],
    [
      "flegme",
      0.005
    ],
    [
      "fraicheur",
      0.005
    ],
    [
      "frigidite",
      0.005
    ],
    [
      "hivernal",
      0.0
    ],
    [
      "inamical",
      0.0
    ],
    [
      "intemperie",
      0.0
    ],
    [
      "marmoreen",
      0.0
    ],
    [
      "mecontentement",
      0.0
    ],
    [
      "rafraichissant",
      0.0
    ],
    [
      "refroidi",
      0.0
    ],
    [
      "renferme",
      0.0
    ],
    [
      "rhume",
      0.0
    ],
    [
      "refrigeration",
      0.0
    ],
    [
      "refrigere",
      0.0
    ],
    [
      "hiver",
      0.0
    ],
    [
      "gene",
      0.0
    ],
    [
      "gelee",
      0.0
    ],
    [
      "algide",
      0.0
    ],
    [
      "antipathie",
      0.0
    ],
    [
      "attiedissement",
      0.0
    ],
    [
      "blase",
      0.0
    ],
    [
      "climatisation",
      0.0
    ],
    [
      "congele",
      0.0
    ],
    [
      "congelation",
      0.0
    ],
    [
      "constipe",
      0.0
    ],
    [
      "frigide",
      0.0
    ],
    [
      "frigo",
      0.0
    ],
    [
      "frigorifique",
      0.0
    ],
    [
      "siberien",
      0.0
    ]
  ],
  "liberte": [
    [
      "desinvolture",
      0.0675
    ],
    [
      "licence",
      0.0575
    ],
    [
      "faculte",
      0.05
    ],
    [
      "franchise",
      0.05
    ],
    [
      "permission",
      0.05
    ],
    [
      "pouvoir",
      0.0425
    ],
    [
      "possibilite",
      0.0425
    ],
    [
      "abandon",
      0.0325
    ],
    [
      "facilite",
      0.0325
    ],
    [
      "liberation",
      0.025
    ],
    [
      "latitude",
      0.025
    ],
    [
      "hardiesse",
      0.025
    ],
    [
      "familiarite",
      0.025
    ],
    [
      "affranchissement",
      0.025
    ],
    [
      "indifference",
      0.015
    ],
    [
      "independance",
      0.015
    ],
    [
      "irreverence",
      0.015
    ],
    [
      "loisir",
      0.015
    ],
    [
      "moyen",
      0.015
    ],
    [
      "relaxation",
      0.015
    ],
    [
      "volonte",
      0.015
    ],
    [
      "incongruite",
      0.015
    ],
    [
      "impudicite",
      0.015
    ],
    [
      "aisance",
      0.015
    ],
    [
      "aise",
      0.015
    ],
    [
      "choix",
      0.015
    ],
    [
      "dispense",
      0.015
    ],
    [
      "exemption",
      0.015
    ],
    [
      "immunite",
      0.015
    ],
    [
      "impertinence",
      0.015
    ],
    [
      "impudence",
      0.015
    ],
    [
      "marge",
      0.0075
    ],
    [
      "polissonnerie",
      0.0075
    ],
    [
      "privaute",
      0.0075
    ],
    [
      "rondeur",
      0.0075
    ],
    [
      "temerite",
      0.0075
    ],
    [
      "elargissement",
      0.0075
    ],
    [
      "intimite",
      0.0075
    ],
    [
      "indeterminisme",
      0.0075
    ],
    [
      "dereglement",
      0.0075
    ],
    [
      "debraille",
      0.0075
    ],
    [
      "droit",
      0.0075
    ],
    [
      "disponibilite",
      0.0075
    ],
    [
      "autonomie",
      0.0075
    ],
    [
      "election",
      0.0075
    ]
  ],
  "hauteur": [
    [
      "eminence",
      0.075
    ],
    [
      "elevation",
      0.065
    ],
    [
      "arrogance",
      0.045
    ],
    [
      "butte",
      0.045
    ],
    [
      "fierte",
      0.045
    ],
    [
      "mont",
      0.045
    ],
    [
      "superbe",
      0.04
    ],
    [
      "morgue",
      0.04
    ],
    [
      "monticule",
      0.04
    ],
    [
      "dedain",
      0.035
    ],
    [
      "orgueil",
      0.035
    ],
    [
      "sommet",
      0.035
    ],
    [
      "colline",
      0.03
    ],
    [
      "grandeur",
      0.03
    ],
    [
      "superiorite",
      0.0225
    ],
    [
      "haut",
      0.0225
    ],
    [
      "outrecuidance",
      0.02
    ],
    [
      "sublimite",
      0.02
    ],
    [
      "noblesse",
      0.015
    ],
    [
      "niveau",
      0.015
    ],
    [
      "mamelon",
      0.015
    ],
    [
      "coteau",
      0.015
    ],
    [
      "piton",
      0.0075
    ],
    [
      "profondeur",
      0.0075
    ],
    [
      "promontoire",
      0.0075
    ],
    [
      "roguerie",
      0.0075
    ],
    [
      "stature",
      0.0075
    ],
    [
      "taille",
      0.0075
    ],
    [
      "tertre",
      0.0075
    ],
    [
      "motte",
      0.0075
    ],
    [
      "montagne",
      0.0075
    ],
    [
      "belvedere",
      0.0075
    ],
    [
      "condescendance",
      0.0075
    ],
    [
      "crete",
      0.0075
    ],
    [
      "cote",
      0.0075
    ],
    [
      "dimension",
      0.0075
    ],
    [
      "falaise",
      0.0075
    ],
    [
      "insolence",
      0.0075
    ],
    [
      "pic",
      0.0025
    ],
    [
      "plan",
      0.0025
    ],
    [
      "plateau",
      0.0025
    ],
    [
      "surplomb",
      0.0025
    ],
    [
      "talus",
      0.0025
    ],
    [
      "taupiniere",
      0.0025
    ],
    [
      "perpendiculaire",
      0.0025
    ],
    [
      "mepris",
      0.0025
    ],
    [
      "morne",
      0.0025
    ],
    [
      "hypsometrie",
      0.0025
    ],
    [
      "dune",
      0.0025
    ],
    [
      "cotiere",
      0.0025
    ],
    [
      "chaine",
      0.0025
    ],
    [
      "bosse",
      0.0025
    ],
    [
      "ballon",
      0.0025
    ],
    [
      "altitude",
      0.0025
    ],
    [
      "etage",
      0.0025
    ]
  ],
  "sembler": [
    [
      "paraitre",
      0.23
    ],
    [
      "apparaitre",
      0.115
    ],
    [
      "imiter",
      0.075
    ],
    [
      "simuler",
      0.075
    ],
    [
      "s'offrir",
      0.0375
    ],
    [
      "s'averer",
      0.0375
    ],
    [
      "ressembler",
      0.0375
    ],
    [
      "croire",
      0.0375
    ]
  ],
  "insignifiant": [
    [
      "petit",
      0.08
    ],
    [
      "faible",
      0.0475
    ],
    [
      "mediocre",
      0.045
    ],
    [
      "negligeable",
      0.04
    ],
    [
      "quelconque",
      0.04
    ],
    [
      "fade",
      0.0325
    ],
    [
      "terne",
      0.0325
    ],
    [
      "banal",
      0.03
    ],
    [
      "leger",
      0.0275
    ],
    [
      "infime",
      0.0275
    ],
    [
      "anodin",
      0.025
    ],
    [
      "bas",
      0.025
    ],
    [
      "mince",
      0.025
    ],
    [
      "plat",
      0.025
    ],
    [
      "miserable",
      0.0225
    ],
    [
      "pietre",
      0.02
    ],
    [
      "mechant",
      0.02
    ],
    [
      "minime",
      0.02
    ],
    [
      "falot",
      0.02
    ],
    [
      "insipide",
      0.0175
    ],
    [
      "mesquin",
      0.0175
    ],
    [
      "vil",
      0.0175
    ],
    [
      "ordinaire",
      0.015
    ],
    [
      "modique",
      0.015
    ],
    [
      "derisoire",
      0.015
    ],
    [
      "inconsistant",
      0.0125
    ],
    [
      "indifferent",
      0.0125
    ],
    [
      "ininteressant",
      0.0125
    ],
    [
      "malheureux",
      0.0125
    ],
    [
      "neutre",
      0.0125
    ],
    [
      "vide",
      0.0125
    ],
    [
      "nul",
      0.01
    ],
    [
      "futile",
      0.01
    ],
    [
      "imperceptible",
      0.0075
    ],
    [
      "modeste",
      0.0075
    ],
    [
      "meprisable",
      0.0075
    ],
    [
      "vulgaire",
      0.0075
    ],
    [
      "vain",
      0.0075
    ],
    [
      "efface",
      0.0075
    ],
    [
      "chetif",
      0.0075
    ],
    [
      "minuscule",
      0.005
    ],
    [
      "menu",
      0.005
    ],
    [
      "inutile",
      0.005
    ],
    [
      "insuffisant",
      0.005
    ],
    [
      "inodore",
      0.005
    ],
    [
      "exigu",
      0.005
    ],
    [
      "veniel",
      0.0025
    ],
    [
      "vague",
      0.0025
    ],
    [
      "insensible",
      0.0025
    ],
    [
      "inoffensif",
      0.0025
    ],
    [
      "inexistant",
      0.0025
    ],
    [
      "frivole",
      0.0025
    ],
    [
      "accessoire",
      0.0025
    ],
    [
      "trivial",
      0.0025
    ],
    [
      "secondaire",
      0.0025
    ],
    [
      "negatif",
      0.0025
    ],
    [
      "mineur",
      0.0025
    ],
    [
      "interchangeable",
      0.0
    ],
    [
      "excusable",
      0.0
    ],
    [
      "anonyme",
      0.0
    ]
  ],
  "tristesse": [
    [
      "melancolie",
      0.0925
    ],
    [
      "chagrin",
      0.085
    ],
    [
      "ennui",
      0.075
    ],
    [
      "affliction",
      0.06
    ],
    [
      "abattement",
      0.0475
    ],
    [
      "peine",
      0.04
    ],
    [
      "douleur",
      0.0325
    ],
    [
      "accablement",
      0.03
    ],
    [
      "mal",
      0.0275
    ],
    [
      "desespoir",
      0.0275
    ],
    [
      "cafard",
      0.0275
    ],
    [
      "desolation",
      0.025
    ],
    [
      "amertume",
      0.0225
    ],
    [
      "degout",
      0.0225
    ],
    [
      "spleen",
      0.0225
    ],
    [
      "desesperance",
      0.0225
    ],
    [
      "decouragement",
      0.0225
    ],
    [
      "malheur",
      0.02
    ],
    [
      "consternation",
      0.015
    ],
    [
      "deuil",
      0.015
    ],
    [
      "depression",
      0.015
    ],
    [
      "epreuve",
      0.0125
    ],
    [
      "souffrance",
      0.0125
    ],
    [
      "morosite",
      0.0125
    ],
    [
      "calamite",
      0.0125
    ],
    [
      "angoisse",
      0.01
    ],
    [
      "inquietude",
      0.01
    ],
    [
      "lassitude",
      0.01
    ],
    [
      "neurasthenie",
      0.01
    ],
    [
      "maussaderie",
      0.0075
    ],
    [
      "bourdon",
      0.0075
    ],
    [
      "bile",
      0.0075
    ],
    [
      "souci",
      0.005
    ],
    [
      "nostalgie",
      0.005
    ],
    [
      "navrement",
      0.005
    ],
    [
      "monotonie",
      0.005
    ],
    [
      "malaise",
      0.005
    ],
    [
      "lypemanie",
      0.005
    ],
    [
      "grisaille",
      0.005
    ],
    [
      "desenchantement",
      0.005
    ],
    [
      "platitude",
      0.0025
    ],
    [
      "pauvrete",
      0.0025
    ],
    [
      "brumaille",
      0.0025
    ],
    [
      "uniformite",
      0.0
    ],
    [
      "severite",
      0.0
    ],
    [
      "sombreur",
      0.0
    ],
    [
      "nuage",
      0.0
    ],
    [
      "noirceur",
      0.0
    ],
    [
      "mochete",
      0.0
    ],
    [
      "laideur",
      0.0
    ],
    [
      "desabusement",
      0.0
    ],
    [
      "austerite",
      0.0
    ],
    [
      "atrabile",
      0.0
    ],
    [
      "assombrissement",
      0.0
    ],
    [
      "aigreur",
      0.0
    ],
    [
      "eplorement",
      0.0
    ]
  ],
  "angoisser": [
    [
      "alarmer",
      0.125
    ],
    [
      "inquieter",
      0.125
    ],
    [
      "affoler",
      0.0925
    ],
    [
      "agiter",
      0.0925
    ],
    [
      "effrayer",
      0.0925
    ],
    [
      "tourmenter",
      0.0925
    ],
    [
      "epouvanter",
      0.0625
    ],
    [
      "navrer",
      0.0625
    ],
    [
      "chagriner",
      0.0625
    ],
    [
      "gener",
      0.03
    ],
    [
      "oppresser",
      0.03
    ],
    [
      "paniquer",
      0.03
    ],
    [
      "terroriser",
      0.03
    ]
  ],
  "angoisse": [
    [
      "alarmer",
      0.125
    ],
    [
      "inquieter",
      0.125
    ],
    [
      "affoler",
      0.0925
    ],
    [
      "agiter",
      0.0925
    ],
    [
      "effrayer",
      0.0925
    ],
    [
      "tourmenter",
      0.0925
    ],
    [
      "epouvanter",
      0.0625
    ],
    [
      "navrer",
      0.0625
    ],
    [
      "chagriner",
      0.0625
    ],
    [
      "gener",
      0.03
    ],
    [
      "oppresser",
      0.03
    ],
    [
      "paniquer",
      0.03
    ],
    [
      "terroriser",
      0.03
    ]
  ],
  "peur": [
    [
      "frousse",
      0.1125
    ],
    [
      "crainte",
      0.0875
    ],
    [
      "frayeur",
      0.085
    ],
    [
      "effroi",
      0.07
    ],
    [
      "inquietude",
      0.05
    ],
    [
      "alarme",
      0.0475
    ],
    [
      "terreur",
      0.04
    ],
    [
      "epouvante",
      0.04
    ],
    [
      "horreur",
      0.0375
    ],
    [
      "lachete",
      0.0325
    ],
    [
      "angoisse",
      0.0275
    ],
    [
      "apprehension",
      0.0225
    ],
    [
      "trouille",
      0.0225
    ],
    [
      "affres",
      0.0175
    ],
    [
      "phobie",
      0.0175
    ],
    [
      "pusillanimite",
      0.0175
    ],
    [
      "transe",
      0.0175
    ],
    [
      "trac",
      0.0125
    ],
    [
      "spectre",
      0.0125
    ],
    [
      "cauchemar",
      0.0125
    ],
    [
      "anxiete",
      0.0125
    ],
    [
      "affolement",
      0.0125
    ],
    [
      "vertige",
      0.0075
    ],
    [
      "trouble",
      0.0075
    ],
    [
      "timidite",
      0.0075
    ],
    [
      "stupefaction",
      0.0075
    ],
    [
      "saisissement",
      0.0075
    ],
    [
      "repulsion",
      0.0075
    ],
    [
      "poltronnerie",
      0.0075
    ],
    [
      "pleutrerie",
      0.0075
    ],
    [
      "alerte",
      0.0075
    ],
    [
      "aversion",
      0.0075
    ],
    [
      "couardise",
      0.0075
    ],
    [
      "frisson",
      0.0075
    ],
    [
      "hantise",
      0.0075
    ],
    [
      "panique",
      0.0075
    ],
    [
      "venette",
      0.0025
    ],
    [
      "souleur",
      0.0025
    ],
    [
      "repugnance",
      0.0025
    ],
    [
      "petoche",
      0.0025
    ],
    [
      "malepeur",
      0.0025
    ],
    [
      "foire",
      0.0025
    ],
    [
      "vesse",
      0.0025
    ]
  ],
  "quitter": [
    [
      "abandonner",
      0.145
    ],
    [
      "partir",
      0.06
    ],
    [
      "renoncer",
      0.05
    ],
    [
      "s'enfuir",
      0.045
    ],
    [
      "sortir",
      0.0425
    ],
    [
      "lacher",
      0.025
    ],
    [
      "fuir",
      0.025
    ],
    [
      "ceder",
      0.025
    ],
    [
      "rompre",
      0.0225
    ],
    [
      "s'eloigner",
      0.0225
    ],
    [
      "passer",
      0.02
    ],
    [
      "delaisser",
      0.02
    ],
    [
      "disparaitre",
      0.02
    ],
    [
      "deguerpir",
      0.015
    ],
    [
      "laisser",
      0.015
    ],
    [
      "enlever",
      0.015
    ],
    [
      "changer",
      0.0125
    ],
    [
      "deposer",
      0.0125
    ],
    [
      "s'evader",
      0.0125
    ],
    [
      "tomber",
      0.0125
    ],
    [
      "semer",
      0.01
    ],
    [
      "s'echapper",
      0.01
    ],
    [
      "planter",
      0.01
    ],
    [
      "perdre",
      0.01
    ],
    [
      "mourir",
      0.01
    ],
    [
      "debarrasser",
      0.01
    ],
    [
      "oter",
      0.0075
    ],
    [
      "s'absenter",
      0.0075
    ],
    [
      "plaquer",
      0.0075
    ],
    [
      "liberer",
      0.0075
    ],
    [
      "depouiller",
      0.0075
    ],
    [
      "demenager",
      0.0075
    ],
    [
      "deloger",
      0.0075
    ],
    [
      "defaire",
      0.0075
    ],
    [
      "evacuer",
      0.005
    ],
    [
      "tirer",
      0.005
    ],
    [
      "deserter",
      0.005
    ],
    [
      "abdiquer",
      0.005
    ],
    [
      "emigrer",
      0.0025
    ],
    [
      "resigner",
      0.0025
    ],
    [
      "retirer",
      0.0025
    ],
    [
      "renier",
      0.0025
    ],
    [
      "poser",
      0.0025
    ],
    [
      "interrompre",
      0.0025
    ],
    [
      "immoler",
      0.0025
    ],
    [
      "deteler",
      0.0025
    ],
    [
      "arreter",
      0.0025
    ],
    [
      "abjurer",
      0.0025
    ],
    [
      "sacrifier",
      0.0
    ],
    [
      "s'expatrier",
      0.0
    ],
    [
      "demarrer",
      0.0
    ],
    [
      "appareiller",
      0.0
    ],
    [
      "apostasier",
      0.0
    ]
  ],
  "depuis": [
    [
      "de",
      0.25
    ],
    [
      "des",
      0.25
    ]
  ],
  "longtemps": [
    [
      "longuement",
      0.2675
    ],
    [
      "minutieusement",
      0.065
    ],
    [
      "lentement",
      0.065
    ],
    [
      "jadis",
      0.065
    ],
    [
      "beaucoup",
      0.065
    ],
    [
      "autrefois",
      0.065
    ],
    [
      "anciennement",
      0.065
    ]
  ],
  "respirer": [
    [
      "aspirer",
      0.065
    ],
    [
      "reveler",
      0.065
    ],
    [
      "souffler",
      0.065
    ],
    [
      "sentir",
      0.0525
    ],
    [
      "renifler",
      0.0525
    ],
    [
      "montrer",
      0.0525
    ],
    [
      "humer",
      0.0525
    ],
    [
      "exhaler",
      0.0525
    ],
    [
      "afficher",
      0.0375
    ],
    [
      "haleter",
      0.0375
    ],
    [
      "s'ebrouer",
      0.025
    ],
    [
      "presenter",
      0.025
    ],
    [
      "pousser",
      0.025
    ],
    [
      "marquer",
      0.025
    ],
    [
      "manifester",
      0.025
    ],
    [
      "inspirer",
      0.025
    ],
    [
      "inhaler",
      0.025
    ],
    [
      "flairer",
      0.025
    ],
    [
      "exprimer",
      0.025
    ],
    [
      "boire",
      0.025
    ],
    [
      "absorber",
      0.025
    ],
    [
      "s'oxygener",
      0.0125
    ],
    [
      "soupirer",
      0.0125
    ],
    [
      "subodorer",
      0.0125
    ],
    [
      "suer",
      0.0125
    ],
    [
      "suinter",
      0.0125
    ],
    [
      "revivre",
      0.0125
    ],
    [
      "panteler",
      0.0125
    ],
    [
      "offrir",
      0.0125
    ],
    [
      "expirer",
      0.0125
    ],
    [
      "anheler",
      0.0125
    ],
    [
      "vivre",
      0.0125
    ]
  ],
  "desert": [
    [
      "vide",
      0.1275
    ],
    [
      "abandonne",
      0.0775
    ],
    [
      "solitaire",
      0.0675
    ],
    [
      "inhabite",
      0.0575
    ],
    [
      "sauvage",
      0.0575
    ],
    [
      "infrequente",
      0.0475
    ],
    [
      "sterile",
      0.0375
    ],
    [
      "retire",
      0.0375
    ],
    [
      "mort",
      0.0375
    ],
    [
      "inculte",
      0.0375
    ],
    [
      "perdu",
      0.0275
    ],
    [
      "nu",
      0.0275
    ],
    [
      "inoccupe",
      0.0275
    ],
    [
      "aride",
      0.0275
    ],
    [
      "trou",
      0.0175
    ],
    [
      "solitude",
      0.0175
    ],
    [
      "seul",
      0.0175
    ],
    [
      "neant",
      0.0175
    ],
    [
      "desole",
      0.0175
    ],
    [
      "desertique",
      0.0175
    ],
    [
      "depeuple",
      0.0175
    ],
    [
      "bled",
      0.0175
    ],
    [
      "rien",
      0.0075
    ],
    [
      "sahara",
      0.0075
    ],
    [
      "steppe",
      0.0075
    ],
    [
      "thebaide",
      0.0075
    ],
    [
      "toundra",
      0.0075
    ],
    [
      "pampa",
      0.0075
    ],
    [
      "libre",
      0.0075
    ],
    [
      "inanime",
      0.0075
    ],
    [
      "impeuple",
      0.0075
    ],
    [
      "hamada",
      0.0075
    ],
    [
      "erg",
      0.0075
    ],
    [
      "devaste",
      0.0075
    ],
    [
      "deserte",
      0.0075
    ],
    [
      "eloigne",
      0.0075
    ]
  ],
  "printemps": [
    [
      "an",
      0.165
    ],
    [
      "avril",
      0.165
    ],
    [
      "jeunesse",
      0.165
    ],
    [
      "renaissance",
      0.165
    ],
    [
      "renouveau",
      0.165
    ]
  ],
  "ete": [
    [
      "canicule",
      0.125
    ],
    [
      "chaleur",
      0.125
    ]
  ],
  "sortilege": [
    [
      "magie",
      0.15
    ],
    [
      "sorcellerie",
      0.15
    ],
    [
      "charme",
      0.12
    ],
    [
      "enchantement",
      0.09
    ],
    [
      "malefice",
      0.09
    ],
    [
      "incantation",
      0.06
    ],
    [
      "envoutement",
      0.06
    ],
    [
      "ensorcellement",
      0.06
    ],
    [
      "diablerie",
      0.03
    ],
    [
      "fascination",
      0.03
    ],
    [
      "jettatura",
      0.03
    ],
    [
      "sort",
      0.03
    ],
    [
      "talisman",
      0.03
    ],
    [
      "evocation",
      0.03
    ]
  ],
  "choisi": [
    [
      "distingue",
      0.1
    ],
    [
      "precieux",
      0.1
    ],
    [
      "beau",
      0.075
    ],
    [
      "raffine",
      0.075
    ],
    [
      "elegant",
      0.075
    ],
    [
      "elu",
      0.05
    ],
    [
      "privilegie",
      0.05
    ],
    [
      "favori",
      0.05
    ],
    [
      "correct",
      0.05
    ],
    [
      "bien",
      0.05
    ],
    [
      "tarabiscote",
      0.025
    ],
    [
      "selectionne",
      0.025
    ],
    [
      "select",
      0.025
    ],
    [
      "sophistique",
      0.025
    ],
    [
      "resolu",
      0.025
    ],
    [
      "prefere",
      0.025
    ],
    [
      "predestine",
      0.025
    ],
    [
      "oint",
      0.025
    ],
    [
      "decide",
      0.025
    ],
    [
      "chatie",
      0.025
    ],
    [
      "chic",
      0.025
    ],
    [
      "appele",
      0.025
    ],
    [
      "trie",
      0.025
    ]
  ],
  "choisir": [
    [
      "selectionner",
      0.145
    ],
    [
      "elire",
      0.08
    ],
    [
      "adopter",
      0.0525
    ],
    [
      "designer",
      0.0525
    ],
    [
      "prendre",
      0.0525
    ],
    [
      "trancher",
      0.0375
    ],
    [
      "opter",
      0.0375
    ],
    [
      "nommer",
      0.0375
    ],
    [
      "coopter",
      0.0375
    ],
    [
      "appeler",
      0.0375
    ],
    [
      "trier",
      0.025
    ],
    [
      "s'arreter",
      0.025
    ],
    [
      "preferer",
      0.025
    ],
    [
      "embrasser",
      0.025
    ],
    [
      "determiner",
      0.025
    ],
    [
      "decider",
      0.025
    ],
    [
      "distinguer",
      0.025
    ],
    [
      "ecremer",
      0.0125
    ],
    [
      "s'orienter",
      0.0125
    ],
    [
      "s'engager",
      0.0125
    ],
    [
      "retenir",
      0.0125
    ],
    [
      "agreger",
      0.0125
    ],
    [
      "affecter",
      0.0125
    ],
    [
      "epouser",
      0.0125
    ]
  ],
  "reconstruire": [
    [
      "reedifier",
      0.22
    ],
    [
      "refaire",
      0.165
    ],
    [
      "retablir",
      0.165
    ],
    [
      "rebatir",
      0.11
    ],
    [
      "reconstituer",
      0.11
    ],
    [
      "relever",
      0.11
    ],
    [
      "construire",
      0.055
    ],
    [
      "recomposer",
      0.055
    ]
  ],
  "ainsi": [
    [
      "donc",
      0.1525
    ],
    [
      "comme",
      0.075
    ],
    [
      "pareillement",
      0.075
    ],
    [
      "aussi",
      0.05
    ],
    [
      "partant",
      0.025
    ],
    [
      "alors",
      0.025
    ],
    [
      "sic",
      0.025
    ]
  ],
  "memes": [
    [
      "identique",
      0.125
    ],
    [
      "semblable",
      0.125
    ],
    [
      "pareil",
      0.105
    ],
    [
      "analogue",
      0.0525
    ],
    [
      "aussi",
      0.0525
    ],
    [
      "similaire",
      0.0525
    ],
    [
      "egal",
      0.0525
    ],
    [
      "equivalent",
      0.035
    ],
    [
      "uniforme",
      0.035
    ],
    [
      "homogene",
      0.035
    ],
    [
      "exactement",
      0.035
    ],
    [
      "tel",
      0.0175
    ],
    [
      "precisement",
      0.0175
    ],
    [
      "propre",
      0.0175
    ],
    [
      "neanmoins",
      0.0175
    ],
    [
      "jusque",
      0.0175
    ],
    [
      "encore",
      0.0175
    ],
    [
      "constant",
      0.0175
    ],
    [
      "commun",
      0.0175
    ],
    [
      "voire",
      0.0175
    ]
  ],
  "cheap": [],
  "bander": [
    [
      "entourer",
      0.0925
    ],
    [
      "envelopper",
      0.0925
    ],
    [
      "fermer",
      0.0925
    ],
    [
      "raidir",
      0.0925
    ],
    [
      "serrer",
      0.0925
    ],
    [
      "tendre",
      0.0925
    ],
    [
      "tirer",
      0.0625
    ],
    [
      "contracter",
      0.0625
    ],
    [
      "attacher",
      0.0625
    ],
    [
      "concentrer",
      0.03
    ],
    [
      "couvrir",
      0.03
    ],
    [
      "obturer",
      0.03
    ],
    [
      "panser",
      0.03
    ],
    [
      "roidir",
      0.03
    ],
    [
      "soigner",
      0.03
    ],
    [
      "triquer",
      0.03
    ]
  ],
  "bande": [
    [
      "troupe",
      0.07
    ],
    [
      "groupe",
      0.0575
    ],
    [
      "societe",
      0.0425
    ],
    [
      "association",
      0.0375
    ],
    [
      "multitude",
      0.03
    ],
    [
      "horde",
      0.03
    ],
    [
      "compagnie",
      0.03
    ],
    [
      "colonie",
      0.03
    ],
    [
      "clan",
      0.03
    ],
    [
      "agglomeration",
      0.03
    ],
    [
      "rassemblement",
      0.025
    ],
    [
      "masse",
      0.025
    ],
    [
      "bretelle",
      0.0225
    ],
    [
      "parti",
      0.0225
    ],
    [
      "ceinture",
      0.02
    ],
    [
      "cordon",
      0.02
    ],
    [
      "harde",
      0.02
    ],
    [
      "troupeau",
      0.015
    ],
    [
      "ruban",
      0.015
    ],
    [
      "peuple",
      0.015
    ],
    [
      "courroie",
      0.015
    ],
    [
      "coterie",
      0.015
    ],
    [
      "cohorte",
      0.015
    ],
    [
      "armee",
      0.015
    ],
    [
      "bandeau",
      0.0125
    ],
    [
      "barre",
      0.0125
    ],
    [
      "meute",
      0.0125
    ],
    [
      "sangle",
      0.01
    ],
    [
      "lien",
      0.01
    ],
    [
      "gang",
      0.01
    ],
    [
      "bandage",
      0.01
    ],
    [
      "lisiere",
      0.005
    ],
    [
      "legion",
      0.005
    ],
    [
      "morceau",
      0.005
    ],
    [
      "raie",
      0.005
    ],
    [
      "ramassis",
      0.005
    ],
    [
      "secte",
      0.005
    ],
    [
      "echarpe",
      0.005
    ],
    [
      "ligature",
      0.005
    ],
    [
      "coin",
      0.005
    ],
    [
      "banc",
      0.005
    ],
    [
      "bandelette",
      0.005
    ],
    [
      "bandouliere",
      0.005
    ],
    [
      "baudrier",
      0.005
    ],
    [
      "brassard",
      0.005
    ],
    [
      "caravane",
      0.005
    ],
    [
      "clique",
      0.005
    ],
    [
      "penture",
      0.0025
    ],
    [
      "pellicule",
      0.0025
    ],
    [
      "patte",
      0.0025
    ],
    [
      "le",
      0.0025
    ],
    [
      "ligue",
      0.0025
    ],
    [
      "rayure",
      0.0025
    ],
    [
      "rouleau",
      0.0025
    ],
    [
      "ruche",
      0.0025
    ],
    [
      "trepointe",
      0.0025
    ],
    [
      "volant",
      0.0025
    ],
    [
      "zone",
      0.0025
    ],
    [
      "zebrure",
      0.0025
    ],
    [
      "epaulette",
      0.0025
    ],
    [
      "equipe",
      0.0025
    ],
    [
      "etole",
      0.0025
    ],
    [
      "laniere",
      0.0025
    ],
    [
      "jarretiere",
      0.0025
    ],
    [
      "jarretelle",
      0.0025
    ],
    [
      "bourdalou",
      0.0025
    ],
    [
      "boutique",
      0.0025
    ],
    [
      "bras",
      0.0025
    ],
    [
      "brayer",
      0.0025
    ],
    [
      "ceinturon",
      0.0025
    ],
    [
      "cote",
      0.0025
    ],
    [
      "dragonne",
      0.0025
    ],
    [
      "detour",
      0.0025
    ],
    [
      "embattage",
      0.0025
    ],
    [
      "film",
      0.0025
    ],
    [
      "frange",
      0.0025
    ],
    [
      "galon",
      0.0025
    ],
    [
      "guiche",
      0.0025
    ],
    [
      "gite",
      0.0025
    ],
    [
      "inclinaison",
      0.0025
    ],
    [
      "banderole",
      0.0025
    ]
  ],
  "mauviette": [
    [
      "avorton",
      0.25
    ],
    [
      "gringalet",
      0.25
    ],
    [
      "faible",
      0.165
    ],
    [
      "alouette",
      0.0825
    ],
    [
      "chetif",
      0.0825
    ],
    [
      "foetus",
      0.0825
    ],
    [
      "freluquet",
      0.0825
    ]
  ],
  "infidele": [
    [
      "deloyal",
      0.11
    ],
    [
      "renegat",
      0.0775
    ],
    [
      "impie",
      0.065
    ],
    [
      "faux",
      0.055
    ],
    [
      "heretique",
      0.055
    ],
    [
      "traitre",
      0.0425
    ],
    [
      "perfide",
      0.0425
    ],
    [
      "paien",
      0.0425
    ],
    [
      "trompeur",
      0.0325
    ],
    [
      "mecreant",
      0.0325
    ],
    [
      "incroyant",
      0.0325
    ],
    [
      "incorrect",
      0.0325
    ],
    [
      "felon",
      0.0325
    ],
    [
      "apostat",
      0.0325
    ],
    [
      "revolte",
      0.02
    ],
    [
      "parjure",
      0.02
    ],
    [
      "mensonger",
      0.02
    ],
    [
      "malhonnete",
      0.02
    ],
    [
      "inexact",
      0.02
    ],
    [
      "errone",
      0.02
    ],
    [
      "adultere",
      0.02
    ],
    [
      "scelerat",
      0.01
    ],
    [
      "schismatique",
      0.01
    ],
    [
      "retif",
      0.01
    ],
    [
      "roumi",
      0.01
    ],
    [
      "prevaricateur",
      0.01
    ],
    [
      "parpaillot",
      0.01
    ],
    [
      "leger",
      0.01
    ],
    [
      "judas",
      0.01
    ],
    [
      "inconstant",
      0.01
    ],
    [
      "giaour",
      0.01
    ],
    [
      "gentil",
      0.01
    ],
    [
      "deforme",
      0.01
    ],
    [
      "changeant",
      0.01
    ],
    [
      "volage",
      0.01
    ]
  ],
  "previsible": [
    [
      "envisageable",
      0.1525
    ],
    [
      "possible",
      0.1525
    ],
    [
      "probable",
      0.1525
    ],
    [
      "presumable",
      0.075
    ],
    [
      "normal",
      0.075
    ],
    [
      "devinable",
      0.075
    ],
    [
      "conjecturable",
      0.075
    ],
    [
      "concevable",
      0.075
    ],
    [
      "attendu",
      0.075
    ],
    [
      "realisable",
      0.075
    ]
  ],
  "non": [
    [
      "nenni",
      0.3325
    ],
    [
      "point",
      0.3325
    ],
    [
      "rien",
      0.3325
    ]
  ],
  "certaine": [
    [
      "evident",
      0.0825
    ],
    [
      "vrai",
      0.06
    ],
    [
      "sur",
      0.055
    ],
    [
      "incontestable",
      0.045
    ],
    [
      "reel",
      0.0375
    ],
    [
      "authentique",
      0.0375
    ],
    [
      "positif",
      0.035
    ],
    [
      "avere",
      0.0275
    ],
    [
      "indubitable",
      0.0275
    ],
    [
      "manifeste",
      0.0275
    ],
    [
      "exact",
      0.025
    ],
    [
      "irrefragable",
      0.025
    ],
    [
      "formel",
      0.025
    ],
    [
      "sincere",
      0.025
    ],
    [
      "tangible",
      0.0225
    ],
    [
      "assure",
      0.02
    ],
    [
      "clair",
      0.02
    ],
    [
      "solide",
      0.0175
    ],
    [
      "indiscutable",
      0.0175
    ],
    [
      "indeniable",
      0.0175
    ],
    [
      "notoire",
      0.015
    ],
    [
      "precis",
      0.015
    ],
    [
      "net",
      0.015
    ],
    [
      "officiel",
      0.015
    ],
    [
      "etabli",
      0.0125
    ],
    [
      "patent",
      0.01
    ],
    [
      "veridique",
      0.01
    ],
    [
      "franc",
      0.01
    ],
    [
      "flagrant",
      0.01
    ],
    [
      "decide",
      0.01
    ],
    [
      "bon",
      0.0075
    ],
    [
      "decisif",
      0.0075
    ],
    [
      "determine",
      0.0075
    ],
    [
      "stable",
      0.0075
    ],
    [
      "probant",
      0.0075
    ],
    [
      "irrefutable",
      0.0075
    ],
    [
      "irrecusable",
      0.0075
    ],
    [
      "constant",
      0.005
    ],
    [
      "fixe",
      0.005
    ],
    [
      "peremptoire",
      0.005
    ],
    [
      "visible",
      0.0025
    ],
    [
      "reconnu",
      0.0025
    ],
    [
      "infaillible",
      0.0025
    ],
    [
      "dogmatique",
      0.0025
    ],
    [
      "convaincu",
      0.0025
    ],
    [
      "confirme",
      0.0025
    ],
    [
      "certifie",
      0.0025
    ],
    [
      "absolu",
      0.0025
    ],
    [
      "inattaquable",
      0.0025
    ],
    [
      "palpable",
      0.0025
    ],
    [
      "prouve",
      0.0025
    ],
    [
      "rigoureux",
      0.0025
    ],
    [
      "tranquille",
      0.0025
    ],
    [
      "fonde",
      0.0025
    ],
    [
      "efficace",
      0.0025
    ],
    [
      "effectif",
      0.0025
    ],
    [
      "declare",
      0.0025
    ],
    [
      "constate",
      0.0025
    ],
    [
      "connu",
      0.0025
    ],
    [
      "atteste",
      0.0025
    ],
    [
      "inconteste",
      0.0
    ],
    [
      "invariable",
      0.0
    ],
    [
      "ineluctable",
      0.0
    ],
    [
      "inevitable",
      0.0
    ],
    [
      "mathematique",
      0.0
    ],
    [
      "immanquable",
      0.0
    ],
    [
      "historique",
      0.0
    ],
    [
      "fixe",
      0.0
    ],
    [
      "demontre",
      0.0
    ],
    [
      "controle",
      0.0
    ],
    [
      "affirmatif",
      0.0
    ],
    [
      "admis",
      0.0
    ],
    [
      "relatif",
      0.0
    ],
    [
      "quelque",
      0.0
    ],
    [
      "persuade",
      0.0
    ],
    [
      "obligatoire",
      0.0
    ],
    [
      "donne",
      0.0
    ],
    [
      "couru",
      0.0
    ],
    [
      "tel",
      0.0
    ]
  ],
  "certain": [
    [
      "evident",
      0.0825
    ],
    [
      "vrai",
      0.06
    ],
    [
      "sur",
      0.055
    ],
    [
      "incontestable",
      0.045
    ],
    [
      "reel",
      0.0375
    ],
    [
      "authentique",
      0.0375
    ],
    [
      "positif",
      0.035
    ],
    [
      "avere",
      0.0275
    ],
    [
      "indubitable",
      0.0275
    ],
    [
      "manifeste",
      0.0275
    ],
    [
      "exact",
      0.025
    ],
    [
      "irrefragable",
      0.025
    ],
    [
      "formel",
      0.025
    ],
    [
      "sincere",
      0.025
    ],
    [
      "tangible",
      0.0225
    ],
    [
      "assure",
      0.02
    ],
    [
      "clair",
      0.02
    ],
    [
      "solide",
      0.0175
    ],
    [
      "indiscutable",
      0.0175
    ],
    [
      "indeniable",
      0.0175
    ],
    [
      "notoire",
      0.015
    ],
    [
      "precis",
      0.015
    ],
    [
      "net",
      0.015
    ],
    [
      "officiel",
      0.015
    ],
    [
      "etabli",
      0.0125
    ],
    [
      "patent",
      0.01
    ],
    [
      "veridique",
      0.01
    ],
    [
      "franc",
      0.01
    ],
    [
      "flagrant",
      0.01
    ],
    [
      "decide",
      0.01
    ],
    [
      "bon",
      0.0075
    ],
    [
      "decisif",
      0.0075
    ],
    [
      "determine",
      0.0075
    ],
    [
      "stable",
      0.0075
    ],
    [
      "probant",
      0.0075
    ],
    [
      "irrefutable",
      0.0075
    ],
    [
      "irrecusable",
      0.0075
    ],
    [
      "constant",
      0.005
    ],
    [
      "fixe",
      0.005
    ],
    [
      "peremptoire",
      0.005
    ],
    [
      "visible",
      0.0025
    ],
    [
      "reconnu",
      0.0025
    ],
    [
      "infaillible",
      0.0025
    ],
    [
      "dogmatique",
      0.0025
    ],
    [
      "convaincu",
      0.0025
    ],
    [
      "confirme",
      0.0025
    ],
    [
      "certifie",
      0.0025
    ],
    [
      "absolu",
      0.0025
    ],
    [
      "inattaquable",
      0.0025
    ],
    [
      "palpable",
      0.0025
    ],
    [
      "prouve",
      0.0025
    ],
    [
      "rigoureux",
      0.0025
    ],
    [
      "tranquille",
      0.0025
    ],
    [
      "fonde",
      0.0025
    ],
    [
      "efficace",
      0.0025
    ],
    [
      "effectif",
      0.0025
    ],
    [
      "declare",
      0.0025
    ],
    [
      "constate",
      0.0025
    ],
    [
      "connu",
      0.0025
    ],
    [
      "atteste",
      0.0025
    ],
    [
      "inconteste",
      0.0
    ],
    [
      "invariable",
      0.0
    ],
    [
      "ineluctable",
      0.0
    ],
    [
      "inevitable",
      0.0
    ],
    [
      "mathematique",
      0.0
    ],
    [
      "immanquable",
      0.0
    ],
    [
      "historique",
      0.0
    ],
    [
      "fixe",
      0.0
    ],
    [
      "demontre",
      0.0
    ],
    [
      "controle",
      0.0
    ],
    [
      "affirmatif",
      0.0
    ],
    [
      "admis",
      0.0
    ],
    [
      "relatif",
      0.0
    ],
    [
      "quelque",
      0.0
    ],
    [
      "persuade",
      0.0
    ],
    [
      "obligatoire",
      0.0
    ],
    [
      "donne",
      0.0
    ],
    [
      "couru",
      0.0
    ],
    [
      "tel",
      0.0
    ]
  ],
  "merite": [
    [
      "valeur",
      0.1225
    ],
    [
      "vertu",
      0.1225
    ],
    [
      "qualite",
      0.11
    ],
    [
      "distinction",
      0.085
    ],
    [
      "grandeur",
      0.085
    ],
    [
      "honneur",
      0.0725
    ],
    [
      "capacite",
      0.0475
    ],
    [
      "classe",
      0.0475
    ],
    [
      "honnetete",
      0.0475
    ],
    [
      "talent",
      0.0475
    ],
    [
      "gloire",
      0.035
    ],
    [
      "force",
      0.035
    ],
    [
      "lustre",
      0.0225
    ],
    [
      "moralite",
      0.0225
    ],
    [
      "superiorite",
      0.0225
    ],
    [
      "agrement",
      0.01
    ],
    [
      "perfection",
      0.01
    ],
    [
      "prix",
      0.01
    ],
    [
      "utilite",
      0.01
    ],
    [
      "eloge",
      0.01
    ]
  ],
  "meriter": [
    [
      "commander",
      0.1
    ],
    [
      "demander",
      0.1
    ],
    [
      "requerir",
      0.1
    ],
    [
      "reclamer",
      0.1
    ],
    [
      "valoir",
      0.1
    ],
    [
      "procurer",
      0.0475
    ],
    [
      "obtenir",
      0.0475
    ],
    [
      "necessiter",
      0.0475
    ],
    [
      "imposer",
      0.0475
    ],
    [
      "gagner",
      0.0475
    ],
    [
      "encourir",
      0.0475
    ],
    [
      "appeler",
      0.0475
    ]
  ],
  "chance": [
    [
      "hasard",
      0.1325
    ],
    [
      "bonheur",
      0.0875
    ],
    [
      "occasion",
      0.065
    ],
    [
      "fortune",
      0.055
    ],
    [
      "veine",
      0.0425
    ],
    [
      "succes",
      0.0425
    ],
    [
      "possibilite",
      0.0425
    ],
    [
      "eventualite",
      0.0325
    ],
    [
      "prosperite",
      0.0325
    ],
    [
      "incertitude",
      0.0325
    ],
    [
      "filon",
      0.0325
    ],
    [
      "circonstance",
      0.0325
    ],
    [
      "aubaine",
      0.0325
    ],
    [
      "alea",
      0.0325
    ],
    [
      "temps",
      0.02
    ],
    [
      "reussite",
      0.02
    ],
    [
      "risque",
      0.02
    ],
    [
      "moyen",
      0.02
    ],
    [
      "facilite",
      0.02
    ],
    [
      "destin",
      0.02
    ],
    [
      "bien",
      0.02
    ],
    [
      "etoile",
      0.01
    ],
    [
      "sort",
      0.01
    ],
    [
      "probabilite",
      0.01
    ],
    [
      "loterie",
      0.01
    ],
    [
      "heur",
      0.01
    ],
    [
      "faveur",
      0.01
    ],
    [
      "destinee",
      0.01
    ],
    [
      "baraka",
      0.01
    ],
    [
      "auspice",
      0.01
    ],
    [
      "atout",
      0.01
    ]
  ],
  "merci": [
    [
      "grace",
      0.3325
    ],
    [
      "misericorde",
      0.165
    ],
    [
      "dependance",
      0.0825
    ],
    [
      "pitie",
      0.0825
    ],
    [
      "quartier",
      0.0825
    ],
    [
      "remerciement",
      0.0825
    ],
    [
      "remise",
      0.0825
    ],
    [
      "soumission",
      0.0825
    ]
  ],
  "prochain": [
    [
      "proche",
      0.1425
    ],
    [
      "riverain",
      0.0925
    ],
    [
      "contigu",
      0.0775
    ],
    [
      "voisin",
      0.0775
    ],
    [
      "immediat",
      0.0625
    ],
    [
      "semblable",
      0.0625
    ],
    [
      "limitrophe",
      0.045
    ],
    [
      "avoisinant",
      0.045
    ],
    [
      "attenant",
      0.045
    ],
    [
      "suivant",
      0.03
    ],
    [
      "imminent",
      0.03
    ],
    [
      "futur",
      0.03
    ],
    [
      "environnant",
      0.03
    ],
    [
      "autrui",
      0.03
    ],
    [
      "autre",
      0.03
    ],
    [
      "adjacent",
      0.03
    ],
    [
      "prompt",
      0.015
    ],
    [
      "joignant",
      0.015
    ],
    [
      "intime",
      0.015
    ],
    [
      "homme",
      0.015
    ],
    [
      "frere",
      0.015
    ],
    [
      "direct",
      0.015
    ],
    [
      "circonvoisin",
      0.015
    ],
    [
      "rapproche",
      0.015
    ]
  ],
  "reglement": [
    [
      "statut",
      0.1175
    ],
    [
      "loi",
      0.0825
    ],
    [
      "regle",
      0.0675
    ],
    [
      "ordonnance",
      0.055
    ],
    [
      "prescription",
      0.05
    ],
    [
      "ordre",
      0.0425
    ],
    [
      "norme",
      0.0425
    ],
    [
      "convention",
      0.0425
    ],
    [
      "decret",
      0.0375
    ],
    [
      "decision",
      0.0325
    ],
    [
      "arrete",
      0.0325
    ],
    [
      "arrangement",
      0.0275
    ],
    [
      "code",
      0.0275
    ],
    [
      "constitution",
      0.0275
    ],
    [
      "organisation",
      0.02
    ],
    [
      "protocole",
      0.02
    ],
    [
      "edit",
      0.015
    ],
    [
      "solution",
      0.015
    ],
    [
      "paiement",
      0.015
    ],
    [
      "discipline",
      0.015
    ],
    [
      "conclusion",
      0.015
    ],
    [
      "canon",
      0.015
    ],
    [
      "solde",
      0.01
    ],
    [
      "observance",
      0.01
    ],
    [
      "mandement",
      0.01
    ],
    [
      "gouvernement",
      0.01
    ],
    [
      "direction",
      0.01
    ],
    [
      "consigne",
      0.01
    ],
    [
      "compte",
      0.01
    ],
    [
      "charte",
      0.01
    ],
    [
      "arret",
      0.01
    ],
    [
      "arbitrage",
      0.01
    ],
    [
      "accord",
      0.01
    ],
    [
      "statuts",
      0.005
    ],
    [
      "reglementation",
      0.005
    ],
    [
      "liquidation",
      0.005
    ],
    [
      "institutions",
      0.005
    ],
    [
      "droit",
      0.005
    ],
    [
      "acquittement",
      0.005
    ],
    [
      "terminaison",
      0.005
    ]
  ],
  "surement": [
    [
      "certainement",
      0.1275
    ],
    [
      "immanquablement",
      0.1
    ],
    [
      "infailliblement",
      0.1
    ],
    [
      "assurement",
      0.085
    ],
    [
      "necessairement",
      0.085
    ],
    [
      "evidemment",
      0.085
    ],
    [
      "inevitablement",
      0.055
    ],
    [
      "bien",
      0.0425
    ],
    [
      "forcement",
      0.0425
    ],
    [
      "obligatoirement",
      0.0275
    ],
    [
      "ineluctablement",
      0.0275
    ],
    [
      "indubitablement",
      0.0275
    ],
    [
      "fatalement",
      0.0275
    ],
    [
      "effectivement",
      0.0275
    ],
    [
      "certes",
      0.0275
    ],
    [
      "efficacement",
      0.0125
    ],
    [
      "ferme",
      0.0125
    ],
    [
      "paisiblement",
      0.0125
    ],
    [
      "tranquillement",
      0.0125
    ]
  ],
  "regle": [
    [
      "conclure",
      0.05
    ],
    [
      "arranger",
      0.045
    ],
    [
      "decider",
      0.0425
    ],
    [
      "trancher",
      0.0425
    ],
    [
      "arreter",
      0.04
    ],
    [
      "disposer",
      0.04
    ],
    [
      "ordonner",
      0.03
    ],
    [
      "diriger",
      0.03
    ],
    [
      "commander",
      0.03
    ],
    [
      "ajuster",
      0.0275
    ],
    [
      "resoudre",
      0.0275
    ],
    [
      "mesurer",
      0.025
    ],
    [
      "terminer",
      0.025
    ],
    [
      "traiter",
      0.02
    ],
    [
      "organiser",
      0.02
    ],
    [
      "normaliser",
      0.02
    ],
    [
      "finir",
      0.02
    ],
    [
      "dominer",
      0.02
    ],
    [
      "accorder",
      0.02
    ],
    [
      "statuer",
      0.0175
    ],
    [
      "payer",
      0.0175
    ],
    [
      "harmoniser",
      0.0175
    ],
    [
      "gouverner",
      0.0175
    ],
    [
      "fixer",
      0.0175
    ],
    [
      "convenir",
      0.0175
    ],
    [
      "vider",
      0.0125
    ],
    [
      "conduire",
      0.0125
    ],
    [
      "calculer",
      0.0125
    ],
    [
      "adapter",
      0.0125
    ],
    [
      "etablir",
      0.01
    ],
    [
      "tirer",
      0.01
    ],
    [
      "temperer",
      0.01
    ],
    [
      "reglementer",
      0.01
    ],
    [
      "regir",
      0.01
    ],
    [
      "maitriser",
      0.01
    ],
    [
      "juger",
      0.01
    ],
    [
      "amenager",
      0.01
    ],
    [
      "aligner",
      0.01
    ],
    [
      "moderer",
      0.005
    ],
    [
      "menager",
      0.005
    ],
    [
      "rythmer",
      0.005
    ],
    [
      "tracer",
      0.005
    ],
    [
      "verser",
      0.005
    ],
    [
      "liquider",
      0.005
    ],
    [
      "decreter",
      0.005
    ],
    [
      "decaisser",
      0.005
    ],
    [
      "dompter",
      0.005
    ],
    [
      "discipliner",
      0.005
    ],
    [
      "couvrir",
      0.005
    ],
    [
      "conformer",
      0.005
    ],
    [
      "centrer",
      0.005
    ],
    [
      "pointer",
      0.0025
    ],
    [
      "positionner",
      0.0025
    ],
    [
      "presider",
      0.0025
    ],
    [
      "rajuster",
      0.0025
    ],
    [
      "regulariser",
      0.0025
    ],
    [
      "remunerer",
      0.0025
    ],
    [
      "retribuer",
      0.0025
    ],
    [
      "parametrer",
      0.0025
    ],
    [
      "modeler",
      0.0025
    ],
    [
      "guider",
      0.0025
    ],
    [
      "financer",
      0.0025
    ],
    [
      "doser",
      0.0025
    ],
    [
      "dicter",
      0.0025
    ],
    [
      "codifier",
      0.0025
    ],
    [
      "acquitter",
      0.0025
    ],
    [
      "solder",
      0.0025
    ]
  ],
  "regler": [
    [
      "conclure",
      0.05
    ],
    [
      "arranger",
      0.045
    ],
    [
      "decider",
      0.0425
    ],
    [
      "trancher",
      0.0425
    ],
    [
      "arreter",
      0.04
    ],
    [
      "disposer",
      0.04
    ],
    [
      "ordonner",
      0.03
    ],
    [
      "diriger",
      0.03
    ],
    [
      "commander",
      0.03
    ],
    [
      "ajuster",
      0.0275
    ],
    [
      "resoudre",
      0.0275
    ],
    [
      "mesurer",
      0.025
    ],
    [
      "terminer",
      0.025
    ],
    [
      "traiter",
      0.02
    ],
    [
      "organiser",
      0.02
    ],
    [
      "normaliser",
      0.02
    ],
    [
      "finir",
      0.02
    ],
    [
      "dominer",
      0.02
    ],
    [
      "accorder",
      0.02
    ],
    [
      "statuer",
      0.0175
    ],
    [
      "payer",
      0.0175
    ],
    [
      "harmoniser",
      0.0175
    ],
    [
      "gouverner",
      0.0175
    ],
    [
      "fixer",
      0.0175
    ],
    [
      "convenir",
      0.0175
    ],
    [
      "vider",
      0.0125
    ],
    [
      "conduire",
      0.0125
    ],
    [
      "calculer",
      0.0125
    ],
    [
      "adapter",
      0.0125
    ],
    [
      "etablir",
      0.01
    ],
    [
      "tirer",
      0.01
    ],
    [
      "temperer",
      0.01
    ],
    [
      "reglementer",
      0.01
    ],
    [
      "regir",
      0.01
    ],
    [
      "maitriser",
      0.01
    ],
    [
      "juger",
      0.01
    ],
    [
      "amenager",
      0.01
    ],
    [
      "aligner",
      0.01
    ],
    [
      "moderer",
      0.005
    ],
    [
      "menager",
      0.005
    ],
    [
      "rythmer",
      0.005
    ],
    [
      "tracer",
      0.005
    ],
    [
      "verser",
      0.005
    ],
    [
      "liquider",
      0.005
    ],
    [
      "decreter",
      0.005
    ],
    [
      "decaisser",
      0.005
    ],
    [
      "dompter",
      0.005
    ],
    [
      "discipliner",
      0.005
    ],
    [
      "couvrir",
      0.005
    ],
    [
      "conformer",
      0.005
    ],
    [
      "centrer",
      0.005
    ],
    [
      "pointer",
      0.0025
    ],
    [
      "positionner",
      0.0025
    ],
    [
      "presider",
      0.0025
    ],
    [
      "rajuster",
      0.0025
    ],
    [
      "regulariser",
      0.0025
    ],
    [
      "remunerer",
      0.0025
    ],
    [
      "retribuer",
      0.0025
    ],
    [
      "parametrer",
      0.0025
    ],
    [
      "modeler",
      0.0025
    ],
    [
      "guider",
      0.0025
    ],
    [
      "financer",
      0.0025
    ],
    [
      "doser",
      0.0025
    ],
    [
      "dicter",
      0.0025
    ],
    [
      "codifier",
      0.0025
    ],
    [
      "acquitter",
      0.0025
    ],
    [
      "solder",
      0.0025
    ]
  ],
  "derriere": [
    [
      "fessier",
      0.14
    ],
    [
      "cul",
      0.1225
    ],
    [
      "fesse",
      0.1225
    ],
    [
      "posterieur",
      0.0675
    ],
    [
      "croupe",
      0.0425
    ],
    [
      "fondement",
      0.0325
    ],
    [
      "reins",
      0.025
    ],
    [
      "popotin",
      0.025
    ],
    [
      "fesses",
      0.025
    ],
    [
      "dos",
      0.025
    ],
    [
      "derche",
      0.025
    ],
    [
      "croupion",
      0.025
    ],
    [
      "anus",
      0.025
    ],
    [
      "seant",
      0.015
    ],
    [
      "siege",
      0.015
    ],
    [
      "petard",
      0.015
    ],
    [
      "pot",
      0.015
    ],
    [
      "arriere",
      0.015
    ],
    [
      "apres",
      0.015
    ],
    [
      "postere",
      0.0075
    ],
    [
      "prose",
      0.0075
    ],
    [
      "revers",
      0.0075
    ],
    [
      "sous",
      0.0075
    ],
    [
      "verso",
      0.0075
    ],
    [
      "panier",
      0.0075
    ],
    [
      "lune",
      0.0075
    ],
    [
      "fond",
      0.0075
    ],
    [
      "envers",
      0.0075
    ],
    [
      "dernier",
      0.0075
    ],
    [
      "derjeau",
      0.0075
    ],
    [
      "ballon",
      0.0075
    ]
  ],
  "valise": [
    [
      "malle",
      0.1575
    ],
    [
      "bagage",
      0.105
    ],
    [
      "ballot",
      0.105
    ],
    [
      "poche",
      0.105
    ],
    [
      "valoche",
      0.105
    ],
    [
      "portemanteau",
      0.0525
    ],
    [
      "mallette",
      0.0525
    ],
    [
      "correspondance",
      0.0525
    ],
    [
      "cerne",
      0.0525
    ],
    [
      "boite",
      0.0525
    ],
    [
      "barda",
      0.0525
    ],
    [
      "balluchon",
      0.0525
    ],
    [
      "valtouze",
      0.0525
    ]
  ],
  "revoir": [
    [
      "retrouvailles",
      1.0
    ]
  ],
  "mere": [
    [
      "origine",
      0.1
    ],
    [
      "source",
      0.1
    ],
    [
      "pays",
      0.065
    ],
    [
      "matrone",
      0.03
    ],
    [
      "moule",
      0.03
    ],
    [
      "nonne",
      0.03
    ],
    [
      "parent",
      0.03
    ],
    [
      "patrie",
      0.03
    ],
    [
      "preliminaires",
      0.03
    ],
    [
      "religieuse",
      0.03
    ],
    [
      "soeur",
      0.03
    ],
    [
      "matrice",
      0.03
    ],
    [
      "maratre",
      0.03
    ],
    [
      "accouchee",
      0.03
    ],
    [
      "cause",
      0.03
    ],
    [
      "daronne",
      0.03
    ],
    [
      "femelle",
      0.03
    ],
    [
      "ferment",
      0.03
    ],
    [
      "germe",
      0.03
    ],
    [
      "genitrice",
      0.03
    ],
    [
      "generateur",
      0.03
    ],
    [
      "inventeur",
      0.03
    ],
    [
      "maman",
      0.03
    ],
    [
      "surmoulage",
      0.03
    ]
  ],
  "idealiser": [
    [
      "rehausser",
      0.1425
    ],
    [
      "sublimer",
      0.1425
    ],
    [
      "magnifier",
      0.0925
    ],
    [
      "glorifier",
      0.0925
    ],
    [
      "exalter",
      0.0925
    ],
    [
      "ennoblir",
      0.0925
    ],
    [
      "embellir",
      0.0925
    ],
    [
      "diviniser",
      0.045
    ],
    [
      "flatter",
      0.045
    ],
    [
      "purifier",
      0.045
    ],
    [
      "spiritualiser",
      0.045
    ],
    [
      "styliser",
      0.045
    ]
  ],
  "perdre": [
    [
      "disparaitre",
      0.045
    ],
    [
      "diminuer",
      0.0425
    ],
    [
      "degrader",
      0.035
    ],
    [
      "ruiner",
      0.03
    ],
    [
      "detruire",
      0.0275
    ],
    [
      "gater",
      0.0275
    ],
    [
      "egarer",
      0.025
    ],
    [
      "s'enfoncer",
      0.02
    ],
    [
      "discrediter",
      0.02
    ],
    [
      "deshonorer",
      0.0175
    ],
    [
      "gacher",
      0.0175
    ],
    [
      "pervertir",
      0.0175
    ],
    [
      "s'eteindre",
      0.015
    ],
    [
      "s'abimer",
      0.015
    ],
    [
      "deprecier",
      0.015
    ],
    [
      "couler",
      0.015
    ],
    [
      "corrompre",
      0.015
    ],
    [
      "s'estomper",
      0.0125
    ],
    [
      "quitter",
      0.0125
    ],
    [
      "detourner",
      0.0125
    ],
    [
      "dissiper",
      0.0125
    ],
    [
      "baisser",
      0.0125
    ],
    [
      "seduire",
      0.01
    ],
    [
      "s'ecrouler",
      0.01
    ],
    [
      "s'aneantir",
      0.01
    ],
    [
      "s'amenuiser",
      0.01
    ],
    [
      "perir",
      0.01
    ],
    [
      "pourrir",
      0.01
    ],
    [
      "nuire",
      0.01
    ],
    [
      "manquer",
      0.01
    ],
    [
      "fuir",
      0.01
    ],
    [
      "fletrir",
      0.01
    ],
    [
      "decroitre",
      0.01
    ],
    [
      "s'affaiblir",
      0.0075
    ],
    [
      "s'effondrer",
      0.0075
    ],
    [
      "torcher",
      0.0075
    ],
    [
      "laisser",
      0.0075
    ],
    [
      "devoyer",
      0.0075
    ],
    [
      "derouter",
      0.0075
    ],
    [
      "depraver",
      0.0075
    ],
    [
      "degenerer",
      0.0075
    ],
    [
      "debaucher",
      0.0075
    ],
    [
      "dilapider",
      0.0075
    ],
    [
      "renoncer",
      0.005
    ],
    [
      "s'appauvrir",
      0.005
    ],
    [
      "s'effacer",
      0.005
    ],
    [
      "maigrir",
      0.005
    ],
    [
      "gaspiller",
      0.005
    ],
    [
      "deconsiderer",
      0.005
    ],
    [
      "demolir",
      0.005
    ],
    [
      "desorienter",
      0.005
    ],
    [
      "devaloriser",
      0.005
    ],
    [
      "expedier",
      0.005
    ],
    [
      "paumer",
      0.0025
    ],
    [
      "rater",
      0.0025
    ],
    [
      "s'atrophier",
      0.0025
    ],
    [
      "s'engloutir",
      0.0025
    ],
    [
      "s'engouffrer",
      0.0025
    ],
    [
      "s'egarer",
      0.0025
    ],
    [
      "echouer",
      0.0025
    ],
    [
      "oublier",
      0.0025
    ],
    [
      "galvauder",
      0.0025
    ],
    [
      "fourvoyer",
      0.0025
    ],
    [
      "aliener",
      0.0025
    ],
    [
      "avarier",
      0.0025
    ],
    [
      "condamner",
      0.0025
    ],
    [
      "demonetiser",
      0.0025
    ],
    [
      "depouiller",
      0.0025
    ],
    [
      "desaxer",
      0.0025
    ],
    [
      "fausser",
      0.0025
    ],
    [
      "flamber",
      0.0025
    ],
    [
      "s'alterer",
      0.0
    ],
    [
      "s'amortir",
      0.0
    ],
    [
      "s'effeuiller",
      0.0
    ],
    [
      "s'etouffer",
      0.0
    ],
    [
      "suinter",
      0.0
    ],
    [
      "echapper",
      0.0
    ],
    [
      "s'aliener",
      0.0
    ],
    [
      "pisser",
      0.0
    ],
    [
      "adirer",
      0.0
    ],
    [
      "damner",
      0.0
    ],
    [
      "disqualifier",
      0.0
    ],
    [
      "decrier",
      0.0
    ],
    [
      "deposer",
      0.0
    ],
    [
      "leser",
      0.0
    ],
    [
      "patauger",
      0.0
    ],
    [
      "etouffer",
      0.0
    ]
  ],
  "aussi": [
    [
      "pareillement",
      0.105
    ],
    [
      "egalement",
      0.085
    ],
    [
      "meme",
      0.0625
    ],
    [
      "tant",
      0.0425
    ],
    [
      "si",
      0.0425
    ],
    [
      "memement",
      0.0425
    ],
    [
      "autant",
      0.0425
    ],
    [
      "ainsi",
      0.0425
    ],
    [
      "tellement",
      0.02
    ],
    [
      "quelque",
      0.02
    ],
    [
      "pourquoi",
      0.02
    ],
    [
      "itou",
      0.02
    ],
    [
      "encore",
      0.02
    ],
    [
      "voire",
      0.02
    ]
  ],
  "maintenant": [
    [
      "aujourd'hui",
      0.165
    ],
    [
      "actuellement",
      0.11
    ],
    [
      "presentement",
      0.11
    ],
    [
      "ores",
      0.055
    ],
    [
      "ici",
      0.055
    ],
    [
      "desormais",
      0.055
    ]
  ],
  "maintenir": [
    [
      "fixer",
      0.0925
    ],
    [
      "soutenir",
      0.0675
    ],
    [
      "tenir",
      0.0675
    ],
    [
      "assurer",
      0.0625
    ],
    [
      "retenir",
      0.06
    ],
    [
      "attacher",
      0.0475
    ],
    [
      "arreter",
      0.0425
    ],
    [
      "assujettir",
      0.0425
    ],
    [
      "caler",
      0.04
    ],
    [
      "appuyer",
      0.035
    ],
    [
      "conserver",
      0.03
    ],
    [
      "arrimer",
      0.03
    ],
    [
      "coincer",
      0.0275
    ],
    [
      "garder",
      0.0275
    ],
    [
      "proteger",
      0.0275
    ],
    [
      "preserver",
      0.0225
    ],
    [
      "defendre",
      0.0225
    ],
    [
      "bloquer",
      0.0175
    ],
    [
      "contenir",
      0.0175
    ],
    [
      "etayer",
      0.015
    ],
    [
      "reserver",
      0.015
    ],
    [
      "enchainer",
      0.015
    ],
    [
      "agrafer",
      0.015
    ],
    [
      "sauvegarder",
      0.01
    ],
    [
      "raffermir",
      0.01
    ],
    [
      "entretenir",
      0.01
    ],
    [
      "continuer",
      0.01
    ],
    [
      "confirmer",
      0.01
    ],
    [
      "veiller",
      0.005
    ],
    [
      "temoigner",
      0.005
    ],
    [
      "supporter",
      0.005
    ],
    [
      "perpetuer",
      0.005
    ],
    [
      "boulonner",
      0.005
    ],
    [
      "assembler",
      0.005
    ],
    [
      "affirmer",
      0.005
    ],
    [
      "tuteurer",
      0.0025
    ],
    [
      "repeter",
      0.0025
    ],
    [
      "rattacher",
      0.0025
    ],
    [
      "protester",
      0.0025
    ],
    [
      "fideliser",
      0.0025
    ],
    [
      "certifier",
      0.0025
    ],
    [
      "etanconner",
      0.0025
    ]
  ],
  "envers": [
    [
      "avec",
      0.085
    ],
    [
      "pour",
      0.085
    ],
    [
      "revers",
      0.085
    ],
    [
      "rancon",
      0.0425
    ],
    [
      "ubac",
      0.0425
    ],
    [
      "vers",
      0.0425
    ],
    [
      "verso",
      0.0425
    ],
    [
      "pile",
      0.0425
    ],
    [
      "inverse",
      0.0425
    ],
    [
      "dos",
      0.0425
    ],
    [
      "dessous",
      0.0425
    ],
    [
      "derriere",
      0.0425
    ],
    [
      "contrepartie",
      0.0425
    ],
    [
      "contraire",
      0.0425
    ]
  ],
  "reagir": [
    [
      "resister",
      0.1075
    ],
    [
      "s'opposer",
      0.065
    ],
    [
      "s'insurger",
      0.065
    ],
    [
      "influencer",
      0.065
    ],
    [
      "agir",
      0.065
    ],
    [
      "repondre",
      0.0425
    ],
    [
      "influer",
      0.0425
    ],
    [
      "s'emouvoir",
      0.02
    ],
    [
      "riposter",
      0.02
    ],
    [
      "regimber",
      0.02
    ],
    [
      "peser",
      0.02
    ],
    [
      "marquer",
      0.02
    ],
    [
      "interagir",
      0.02
    ]
  ],
  "gnangnan": [
    [
      "mou",
      0.2
    ],
    [
      "lent",
      0.15
    ],
    [
      "indolent",
      0.1
    ],
    [
      "lambin",
      0.1
    ],
    [
      "nonchalant",
      0.1
    ],
    [
      "sucre",
      0.0475
    ],
    [
      "mollasse",
      0.0475
    ],
    [
      "minaudier",
      0.0475
    ],
    [
      "emplatre",
      0.0475
    ],
    [
      "chiffe",
      0.0475
    ],
    [
      "becasse",
      0.0475
    ],
    [
      "trainard",
      0.0475
    ]
  ],
  "important": [
    [
      "gros",
      0.0725
    ],
    [
      "grand",
      0.0675
    ],
    [
      "considerable",
      0.0375
    ],
    [
      "beau",
      0.0325
    ],
    [
      "notable",
      0.03
    ],
    [
      "eminent",
      0.0275
    ],
    [
      "fort",
      0.0275
    ],
    [
      "bon",
      0.025
    ],
    [
      "haut",
      0.025
    ],
    [
      "remarquable",
      0.025
    ],
    [
      "superbe",
      0.025
    ],
    [
      "suffisant",
      0.0225
    ],
    [
      "orgueilleux",
      0.02
    ],
    [
      "puissant",
      0.02
    ],
    [
      "pretentieux",
      0.02
    ],
    [
      "principal",
      0.0175
    ],
    [
      "superieur",
      0.0175
    ],
    [
      "avantageux",
      0.0175
    ],
    [
      "fat",
      0.015
    ],
    [
      "vaniteux",
      0.015
    ],
    [
      "essentiel",
      0.015
    ],
    [
      "imposant",
      0.015
    ],
    [
      "marquant",
      0.0125
    ],
    [
      "grave",
      0.0125
    ],
    [
      "glorieux",
      0.0125
    ],
    [
      "illustre",
      0.01
    ],
    [
      "memorable",
      0.01
    ],
    [
      "profond",
      0.01
    ],
    [
      "vaste",
      0.01
    ],
    [
      "serieux",
      0.01
    ],
    [
      "eleve",
      0.01
    ],
    [
      "precieux",
      0.0075
    ],
    [
      "massif",
      0.0075
    ],
    [
      "large",
      0.0075
    ],
    [
      "substantiel",
      0.0075
    ],
    [
      "primordial",
      0.0075
    ],
    [
      "poseur",
      0.0075
    ],
    [
      "notabilite",
      0.0075
    ],
    [
      "majeur",
      0.0075
    ],
    [
      "lourd",
      0.0075
    ],
    [
      "fondamental",
      0.0075
    ],
    [
      "celebre",
      0.0075
    ],
    [
      "capital",
      0.0075
    ],
    [
      "solide",
      0.005
    ],
    [
      "signale",
      0.005
    ],
    [
      "rondelet",
      0.005
    ],
    [
      "pesant",
      0.005
    ],
    [
      "outrecuidant",
      0.005
    ],
    [
      "joli",
      0.005
    ],
    [
      "arrogant",
      0.005
    ],
    [
      "appreciable",
      0.005
    ],
    [
      "vital",
      0.0025
    ],
    [
      "valable",
      0.0025
    ],
    [
      "personnalite",
      0.0025
    ],
    [
      "interessant",
      0.0025
    ],
    [
      "craneur",
      0.0025
    ],
    [
      "coquet",
      0.0025
    ],
    [
      "affecte",
      0.0025
    ],
    [
      "etendu",
      0.0025
    ],
    [
      "volumineux",
      0.0025
    ],
    [
      "sommite",
      0.0025
    ],
    [
      "sensible",
      0.0025
    ],
    [
      "renomme",
      0.0025
    ],
    [
      "pressant",
      0.0025
    ],
    [
      "necessaire",
      0.0025
    ],
    [
      "infatue",
      0.0025
    ],
    [
      "decisif",
      0.0025
    ],
    [
      "dominant",
      0.0025
    ],
    [
      "copieux",
      0.0025
    ],
    [
      "insigne",
      0.0
    ],
    [
      "nombreux",
      0.0
    ],
    [
      "puant",
      0.0
    ],
    [
      "utile",
      0.0
    ],
    [
      "vain",
      0.0
    ],
    [
      "ecrasant",
      0.0
    ],
    [
      "influent",
      0.0
    ],
    [
      "inestimable",
      0.0
    ],
    [
      "incalculable",
      0.0
    ],
    [
      "becheur",
      0.0
    ],
    [
      "conquerant",
      0.0
    ],
    [
      "crucial",
      0.0
    ],
    [
      "gourme",
      0.0
    ],
    [
      "impressionnant",
      0.0
    ],
    [
      "urgent",
      0.0
    ],
    [
      "tout",
      0.0
    ],
    [
      "presse",
      0.0
    ],
    [
      "plastronneur",
      0.0
    ],
    [
      "corse",
      0.0
    ],
    [
      "consequent",
      0.0
    ],
    [
      "connu",
      0.0
    ]
  ],
  "importer": [
    [
      "introduire",
      0.135
    ],
    [
      "apporter",
      0.0975
    ],
    [
      "transporter",
      0.0775
    ],
    [
      "etablir",
      0.0575
    ],
    [
      "porter",
      0.0575
    ],
    [
      "peser",
      0.0575
    ],
    [
      "compter",
      0.0575
    ],
    [
      "amener",
      0.0575
    ],
    [
      "introniser",
      0.0375
    ],
    [
      "instaurer",
      0.0375
    ],
    [
      "implanter",
      0.0375
    ],
    [
      "faire",
      0.0375
    ],
    [
      "s'agir",
      0.0175
    ],
    [
      "rapporter",
      0.0175
    ],
    [
      "interesser",
      0.0175
    ],
    [
      "impatroniser",
      0.0175
    ],
    [
      "commercer",
      0.0175
    ],
    [
      "chaloir",
      0.0175
    ],
    [
      "acheter",
      0.0175
    ],
    [
      "acclimater",
      0.0175
    ]
  ],
  "appeler": [
    [
      "provoquer",
      0.055
    ],
    [
      "entrainer",
      0.045
    ],
    [
      "pousser",
      0.04
    ],
    [
      "determiner",
      0.0375
    ],
    [
      "exciter",
      0.0375
    ],
    [
      "demander",
      0.0325
    ],
    [
      "attirer",
      0.03
    ],
    [
      "crier",
      0.03
    ],
    [
      "engager",
      0.03
    ],
    [
      "reclamer",
      0.0275
    ],
    [
      "inviter",
      0.0275
    ],
    [
      "amener",
      0.025
    ],
    [
      "citer",
      0.025
    ],
    [
      "soulever",
      0.025
    ],
    [
      "solliciter",
      0.0225
    ],
    [
      "inciter",
      0.0225
    ],
    [
      "designer",
      0.02
    ],
    [
      "nommer",
      0.02
    ],
    [
      "susciter",
      0.02
    ],
    [
      "requerir",
      0.0175
    ],
    [
      "prier",
      0.0175
    ],
    [
      "occasionner",
      0.0175
    ],
    [
      "convier",
      0.0175
    ],
    [
      "commander",
      0.015
    ],
    [
      "convoquer",
      0.015
    ],
    [
      "implorer",
      0.015
    ],
    [
      "necessiter",
      0.015
    ],
    [
      "evoquer",
      0.015
    ],
    [
      "souhaiter",
      0.01
    ],
    [
      "qualifier",
      0.01
    ],
    [
      "assigner",
      0.01
    ],
    [
      "supplier",
      0.0075
    ],
    [
      "motiver",
      0.0075
    ],
    [
      "mander",
      0.0075
    ],
    [
      "invoquer",
      0.0075
    ],
    [
      "interpeller",
      0.0075
    ],
    [
      "exiger",
      0.0075
    ],
    [
      "elire",
      0.005
    ],
    [
      "predestiner",
      0.005
    ],
    [
      "heler",
      0.005
    ],
    [
      "exhorter",
      0.005
    ],
    [
      "desirer",
      0.005
    ],
    [
      "choisir",
      0.005
    ],
    [
      "apporter",
      0.005
    ],
    [
      "hucher",
      0.0025
    ],
    [
      "mobiliser",
      0.0025
    ],
    [
      "predisposer",
      0.0025
    ],
    [
      "rappeler",
      0.0025
    ],
    [
      "signaler",
      0.0025
    ],
    [
      "traduire",
      0.0025
    ],
    [
      "traiter",
      0.0025
    ],
    [
      "gemir",
      0.0025
    ],
    [
      "denommer",
      0.0025
    ],
    [
      "adjurer",
      0.0025
    ],
    [
      "ameuter",
      0.0025
    ],
    [
      "aspirer",
      0.0025
    ],
    [
      "avertir",
      0.0025
    ],
    [
      "baptiser",
      0.0025
    ],
    [
      "destiner",
      0.0025
    ],
    [
      "protester",
      0.0
    ],
    [
      "preceder",
      0.0
    ],
    [
      "prenommer",
      0.0
    ],
    [
      "preter",
      0.0
    ],
    [
      "siffler",
      0.0
    ],
    [
      "sonner",
      0.0
    ],
    [
      "surnommer",
      0.0
    ],
    [
      "telephoner",
      0.0
    ],
    [
      "meriter",
      0.0
    ],
    [
      "apostropher",
      0.0
    ],
    [
      "beugler",
      0.0
    ],
    [
      "beler",
      0.0
    ],
    [
      "coopter",
      0.0
    ],
    [
      "defier",
      0.0
    ],
    [
      "fasciner",
      0.0
    ],
    [
      "houper",
      0.0
    ],
    [
      "incorporer",
      0.0
    ],
    [
      "intituler",
      0.0
    ],
    [
      "vouer",
      0.0
    ]
  ],
  "ragnagnas": [],
  "bon": [
    [
      "beau",
      0.0575
    ],
    [
      "honnete",
      0.0325
    ],
    [
      "convenable",
      0.0225
    ],
    [
      "aimable",
      0.02
    ],
    [
      "doux",
      0.02
    ],
    [
      "agreable",
      0.015
    ],
    [
      "bien",
      0.015
    ],
    [
      "genereux",
      0.015
    ],
    [
      "fort",
      0.015
    ],
    [
      "bienveillant",
      0.015
    ],
    [
      "juste",
      0.0125
    ],
    [
      "favorable",
      0.0125
    ],
    [
      "correct",
      0.01
    ],
    [
      "delicat",
      0.01
    ],
    [
      "exquis",
      0.01
    ],
    [
      "vrai",
      0.01
    ],
    [
      "pur",
      0.01
    ],
    [
      "honorable",
      0.01
    ],
    [
      "gentil",
      0.01
    ],
    [
      "brave",
      0.01
    ],
    [
      "benin",
      0.01
    ],
    [
      "grand",
      0.01
    ],
    [
      "parfait",
      0.01
    ],
    [
      "sur",
      0.01
    ],
    [
      "important",
      0.0075
    ],
    [
      "gros",
      0.0075
    ],
    [
      "gracieux",
      0.0075
    ],
    [
      "avantageux",
      0.0075
    ],
    [
      "acceptable",
      0.0075
    ],
    [
      "serieux",
      0.0075
    ],
    [
      "superieur",
      0.0075
    ],
    [
      "sage",
      0.0075
    ],
    [
      "humain",
      0.0075
    ],
    [
      "habile",
      0.0075
    ],
    [
      "franc",
      0.0075
    ],
    [
      "excellent",
      0.0075
    ],
    [
      "exact",
      0.0075
    ],
    [
      "solide",
      0.005
    ],
    [
      "simple",
      0.005
    ],
    [
      "raisonnable",
      0.005
    ],
    [
      "propre",
      0.005
    ],
    [
      "plaisant",
      0.005
    ],
    [
      "joli",
      0.005
    ],
    [
      "indulgent",
      0.005
    ],
    [
      "heureux",
      0.005
    ],
    [
      "droit",
      0.005
    ],
    [
      "complaisant",
      0.005
    ],
    [
      "charitable",
      0.005
    ],
    [
      "precieux",
      0.005
    ],
    [
      "propice",
      0.005
    ],
    [
      "fameux",
      0.005
    ],
    [
      "distingue",
      0.005
    ],
    [
      "digne",
      0.005
    ],
    [
      "bienfaisant",
      0.005
    ],
    [
      "valable",
      0.005
    ],
    [
      "sortable",
      0.005
    ],
    [
      "satisfaisant",
      0.005
    ],
    [
      "potable",
      0.005
    ],
    [
      "ferme",
      0.005
    ],
    [
      "estimable",
      0.005
    ],
    [
      "efficace",
      0.005
    ],
    [
      "debonnaire",
      0.005
    ],
    [
      "charmant",
      0.005
    ],
    [
      "capable",
      0.005
    ],
    [
      "bonhomme",
      0.005
    ],
    [
      "sensible",
      0.0025
    ],
    [
      "sain",
      0.0025
    ],
    [
      "noble",
      0.0025
    ],
    [
      "delicieux",
      0.0025
    ],
    [
      "affable",
      0.0025
    ],
    [
      "abondant",
      0.0025
    ],
    [
      "profitable",
      0.0025
    ],
    [
      "remarquable",
      0.0025
    ],
    [
      "riche",
      0.0025
    ],
    [
      "salutaire",
      0.0025
    ],
    [
      "serviable",
      0.0025
    ],
    [
      "strict",
      0.0025
    ],
    [
      "succulent",
      0.0025
    ],
    [
      "tendre",
      0.0025
    ],
    [
      "utile",
      0.0025
    ],
    [
      "vertueux",
      0.0025
    ],
    [
      "passable",
      0.0025
    ],
    [
      "obligeant",
      0.0025
    ],
    [
      "merveilleux",
      0.0025
    ],
    [
      "bonasse",
      0.0025
    ],
    [
      "cher",
      0.0025
    ],
    [
      "commode",
      0.0025
    ],
    [
      "fidele",
      0.0025
    ],
    [
      "formidable",
      0.0025
    ],
    [
      "genial",
      0.0025
    ],
    [
      "haut",
      0.0025
    ],
    [
      "interessant",
      0.0025
    ],
    [
      "judicieux",
      0.0025
    ],
    [
      "louable",
      0.0025
    ],
    [
      "moyen",
      0.0025
    ],
    [
      "moral",
      0.0025
    ],
    [
      "misericordieux",
      0.0025
    ],
    [
      "innocent",
      0.0025
    ],
    [
      "heroique",
      0.0025
    ],
    [
      "gai",
      0.0025
    ],
    [
      "fructueux",
      0.0025
    ],
    [
      "meritant",
      0.0025
    ],
    [
      "ouvert",
      0.0025
    ],
    [
      "piquant",
      0.0025
    ],
    [
      "robuste",
      0.0025
    ],
    [
      "spirituel",
      0.0025
    ],
    [
      "suffisant",
      0.0025
    ],
    [
      "tutelaire",
      0.0025
    ],
    [
      "eleve",
      0.0025
    ],
    [
      "energique",
      0.0025
    ],
    [
      "fertile",
      0.0025
    ],
    [
      "faible",
      0.0025
    ],
    [
      "adroit",
      0.0025
    ],
    [
      "altruiste",
      0.0025
    ],
    [
      "amusant",
      0.0025
    ],
    [
      "angelique",
      0.0025
    ],
    [
      "approprie",
      0.0025
    ],
    [
      "benefique",
      0.0025
    ],
    [
      "certain",
      0.0025
    ],
    [
      "chic",
      0.0025
    ],
    [
      "cheri",
      0.0025
    ],
    [
      "decent",
      0.0025
    ],
    [
      "divin",
      0.0025
    ],
    [
      "courageux",
      0.0025
    ],
    [
      "cordial",
      0.0025
    ],
    [
      "considerable",
      0.0025
    ],
    [
      "consciencieux",
      0.0025
    ],
    [
      "clement",
      0.0025
    ],
    [
      "lucratif",
      0.0
    ],
    [
      "meritoire",
      0.0
    ],
    [
      "naif",
      0.0
    ],
    [
      "opportun",
      0.0
    ],
    [
      "philanthrope",
      0.0
    ],
    [
      "providentiel",
      0.0
    ],
    [
      "prudent",
      0.0
    ],
    [
      "recevable",
      0.0
    ],
    [
      "savoureux",
      0.0
    ],
    [
      "secourable",
      0.0
    ],
    [
      "tolerant",
      0.0
    ],
    [
      "valide",
      0.0
    ],
    [
      "veritable",
      0.0
    ],
    [
      "ingenieux",
      0.0
    ],
    [
      "extra",
      0.0
    ],
    [
      "accessible",
      0.0
    ],
    [
      "admissible",
      0.0
    ],
    [
      "adequat",
      0.0
    ],
    [
      "apte",
      0.0
    ],
    [
      "avise",
      0.0
    ],
    [
      "billet",
      0.0
    ],
    [
      "benevole",
      0.0
    ],
    [
      "candide",
      0.0
    ],
    [
      "devoue",
      0.0
    ],
    [
      "desinteresse",
      0.0
    ],
    [
      "delectable",
      0.0
    ],
    [
      "complet",
      0.0
    ],
    [
      "compatissant",
      0.0
    ],
    [
      "reconfortant",
      0.0
    ],
    [
      "rigoureux",
      0.0
    ],
    [
      "rentable",
      0.0
    ],
    [
      "productif",
      0.0
    ],
    [
      "prodigue",
      0.0
    ],
    [
      "plein",
      0.0
    ],
    [
      "plausible",
      0.0
    ],
    [
      "pitoyable",
      0.0
    ],
    [
      "paterne",
      0.0
    ],
    [
      "mangeable",
      0.0
    ],
    [
      "magnanime",
      0.0
    ],
    [
      "remunerateur",
      0.0
    ],
    [
      "sauf",
      0.0
    ],
    [
      "eclaire",
      0.0
    ],
    [
      "venerable",
      0.0
    ],
    [
      "valeur",
      0.0
    ],
    [
      "titre",
      0.0
    ],
    [
      "susceptible",
      0.0
    ],
    [
      "suave",
      0.0
    ],
    [
      "stable",
      0.0
    ],
    [
      "souverain",
      0.0
    ],
    [
      "soit",
      0.0
    ],
    [
      "sentimental",
      0.0
    ],
    [
      "joyeux",
      0.0
    ],
    [
      "inoffensif",
      0.0
    ],
    [
      "affectueux",
      0.0
    ],
    [
      "certifie",
      0.0
    ],
    [
      "certificat",
      0.0
    ],
    [
      "bonte",
      0.0
    ],
    [
      "boniface",
      0.0
    ],
    [
      "biquet",
      0.0
    ],
    [
      "bienfaiteur",
      0.0
    ],
    [
      "benoit",
      0.0
    ],
    [
      "authentique",
      0.0
    ],
    [
      "agreablement",
      0.0
    ],
    [
      "chaud",
      0.0
    ],
    [
      "copieux",
      0.0
    ],
    [
      "ingenu",
      0.0
    ],
    [
      "friand",
      0.0
    ],
    [
      "fermement",
      0.0
    ],
    [
      "fait",
      0.0
    ],
    [
      "expert",
      0.0
    ],
    [
      "exemplaire",
      0.0
    ],
    [
      "drole",
      0.0
    ],
    [
      "doue",
      0.0
    ],
    [
      "cuit",
      0.0
    ],
    [
      "credule",
      0.0
    ],
    [
      "costaud",
      0.0
    ],
    [
      "performant",
      0.0
    ],
    [
      "paternel",
      0.0
    ],
    [
      "operant",
      0.0
    ],
    [
      "modele",
      0.0
    ],
    [
      "meilleur",
      0.0
    ],
    [
      "instructif",
      0.0
    ],
    [
      "pondere",
      0.0
    ],
    [
      "pret",
      0.0
    ],
    [
      "reposant",
      0.0
    ],
    [
      "sauve",
      0.0
    ],
    [
      "sociable",
      0.0
    ],
    [
      "solidement",
      0.0
    ],
    [
      "ticket",
      0.0
    ],
    [
      "utilisable",
      0.0
    ],
    [
      "equitable",
      0.0
    ],
    [
      "humanitaire",
      0.0
    ],
    [
      "faste",
      0.0
    ],
    [
      "appetissant",
      0.0
    ],
    [
      "aromatique",
      0.0
    ],
    [
      "attestation",
      0.0
    ],
    [
      "autorisation",
      0.0
    ],
    [
      "bonard",
      0.0
    ],
    [
      "bete",
      0.0
    ],
    [
      "carabine",
      0.0
    ],
    [
      "convaincant",
      0.0
    ],
    [
      "coupon",
      0.0
    ],
    [
      "coupure",
      0.0
    ],
    [
      "delicieusement",
      0.0
    ],
    [
      "emballe",
      0.0
    ],
    [
      "enviable",
      0.0
    ],
    [
      "adore",
      0.0
    ]
  ],
  "moment": [
    [
      "temps",
      0.1475
    ],
    [
      "epoque",
      0.0925
    ],
    [
      "circonstance",
      0.0725
    ],
    [
      "instant",
      0.0725
    ],
    [
      "passage",
      0.0725
    ],
    [
      "heure",
      0.055
    ],
    [
      "episode",
      0.035
    ],
    [
      "siecle",
      0.035
    ],
    [
      "point",
      0.035
    ],
    [
      "page",
      0.035
    ],
    [
      "occasion",
      0.035
    ],
    [
      "minute",
      0.035
    ],
    [
      "jour",
      0.035
    ],
    [
      "endroit",
      0.035
    ],
    [
      "conjoncture",
      0.035
    ],
    [
      "stage",
      0.0175
    ],
    [
      "seconde",
      0.0175
    ],
    [
      "saison",
      0.0175
    ],
    [
      "morceau",
      0.0175
    ],
    [
      "intervalle",
      0.0175
    ],
    [
      "duree",
      0.0175
    ],
    [
      "date",
      0.0175
    ],
    [
      "tournant",
      0.0175
    ]
  ],
  "oui": [
    [
      "assurement",
      0.15
    ],
    [
      "certainement",
      0.15
    ],
    [
      "absolument",
      0.09
    ],
    [
      "bien",
      0.09
    ],
    [
      "d'accord",
      0.06
    ],
    [
      "certes",
      0.06
    ],
    [
      "O.K.",
      0.06
    ],
    [
      "si",
      0.03
    ],
    [
      "parfaitement",
      0.03
    ],
    [
      "parfait",
      0.03
    ],
    [
      "optime",
      0.03
    ],
    [
      "dame",
      0.03
    ],
    [
      "evidemment",
      0.03
    ]
  ],
  "present": [
    [
      "don",
      0.1375
    ],
    [
      "cadeau",
      0.1075
    ],
    [
      "actuel",
      0.08
    ],
    [
      "vivant",
      0.0525
    ],
    [
      "largesse",
      0.0525
    ],
    [
      "gratification",
      0.0525
    ],
    [
      "existant",
      0.0525
    ],
    [
      "bienfait",
      0.0525
    ],
    [
      "vivace",
      0.025
    ],
    [
      "temoin",
      0.025
    ],
    [
      "temps",
      0.025
    ],
    [
      "realite",
      0.025
    ],
    [
      "omnipresent",
      0.025
    ],
    [
      "offrande",
      0.025
    ],
    [
      "moderne",
      0.025
    ],
    [
      "manifeste",
      0.025
    ],
    [
      "immediat",
      0.025
    ],
    [
      "courant",
      0.025
    ],
    [
      "contemporain",
      0.025
    ],
    [
      "bien",
      0.025
    ],
    [
      "assistant",
      0.025
    ],
    [
      "actualite",
      0.025
    ],
    [
      "etrenne",
      0.025
    ]
  ],
  "elever": [
    [
      "hausser",
      0.0675
    ],
    [
      "augmenter",
      0.055
    ],
    [
      "monter",
      0.0525
    ],
    [
      "exalter",
      0.0425
    ],
    [
      "relever",
      0.0425
    ],
    [
      "soulever",
      0.0325
    ],
    [
      "rehausser",
      0.0275
    ],
    [
      "dresser",
      0.025
    ],
    [
      "porter",
      0.025
    ],
    [
      "pousser",
      0.025
    ],
    [
      "faire",
      0.025
    ],
    [
      "former",
      0.0225
    ],
    [
      "lever",
      0.0225
    ],
    [
      "etablir",
      0.0175
    ],
    [
      "exhausser",
      0.0175
    ],
    [
      "creer",
      0.0175
    ],
    [
      "construire",
      0.0175
    ],
    [
      "agrandir",
      0.0175
    ],
    [
      "eduquer",
      0.015
    ],
    [
      "surelever",
      0.015
    ],
    [
      "instruire",
      0.015
    ],
    [
      "grandir",
      0.015
    ],
    [
      "faconner",
      0.015
    ],
    [
      "accroitre",
      0.015
    ],
    [
      "batir",
      0.0125
    ],
    [
      "conduire",
      0.0125
    ],
    [
      "ennoblir",
      0.0125
    ],
    [
      "eriger",
      0.0125
    ],
    [
      "edifier",
      0.0125
    ],
    [
      "remonter",
      0.0125
    ],
    [
      "louer",
      0.0125
    ],
    [
      "cultiver",
      0.0125
    ],
    [
      "fortifier",
      0.01
    ],
    [
      "hisser",
      0.01
    ],
    [
      "jeter",
      0.01
    ],
    [
      "surhausser",
      0.01
    ],
    [
      "transporter",
      0.01
    ],
    [
      "revaloriser",
      0.0075
    ],
    [
      "promouvoir",
      0.0075
    ],
    [
      "planter",
      0.0075
    ],
    [
      "nourrir",
      0.0075
    ],
    [
      "glorifier",
      0.0075
    ],
    [
      "vanter",
      0.005
    ],
    [
      "soigner",
      0.005
    ],
    [
      "placer",
      0.005
    ],
    [
      "fonder",
      0.005
    ],
    [
      "catapulter",
      0.005
    ],
    [
      "intensifier",
      0.0025
    ],
    [
      "magnifier",
      0.0025
    ],
    [
      "orner",
      0.0025
    ],
    [
      "proner",
      0.0025
    ],
    [
      "styler",
      0.0025
    ],
    [
      "susciter",
      0.0025
    ],
    [
      "gouverner",
      0.0025
    ],
    [
      "entretenir",
      0.0025
    ],
    [
      "accentuer",
      0.0025
    ],
    [
      "affiner",
      0.0025
    ],
    [
      "arborer",
      0.0025
    ],
    [
      "bombarder",
      0.0025
    ],
    [
      "braquer",
      0.0025
    ],
    [
      "diviniser",
      0.0025
    ],
    [
      "enlever",
      0.0025
    ],
    [
      "majorer",
      0.0
    ],
    [
      "maconner",
      0.0
    ],
    [
      "modeler",
      0.0
    ],
    [
      "opposer",
      0.0
    ],
    [
      "poetiser",
      0.0
    ],
    [
      "guinder",
      0.0
    ],
    [
      "deifier",
      0.0
    ],
    [
      "discipliner",
      0.0
    ],
    [
      "civiliser",
      0.0
    ],
    [
      "brandir",
      0.0
    ],
    [
      "anoblir",
      0.0
    ],
    [
      "amasser",
      0.0
    ],
    [
      "allaiter",
      0.0
    ],
    [
      "sublimer",
      0.0
    ]
  ],
  "absent": [
    [
      "distrait",
      0.12
    ],
    [
      "absorbe",
      0.0725
    ],
    [
      "lointain",
      0.0725
    ],
    [
      "reveur",
      0.0725
    ],
    [
      "etourdi",
      0.0475
    ],
    [
      "songeur",
      0.0475
    ],
    [
      "preoccupe",
      0.0475
    ],
    [
      "perdu",
      0.0475
    ],
    [
      "negligent",
      0.0475
    ],
    [
      "inexistant",
      0.0475
    ],
    [
      "abstrait",
      0.0475
    ],
    [
      "pensif",
      0.0225
    ],
    [
      "parti",
      0.0225
    ],
    [
      "manquant",
      0.0225
    ],
    [
      "inconnu",
      0.0225
    ],
    [
      "inattentif",
      0.0225
    ],
    [
      "hagard",
      0.0225
    ],
    [
      "fictif",
      0.0225
    ],
    [
      "defaillant",
      0.0225
    ],
    [
      "contumace",
      0.0225
    ],
    [
      "apathique",
      0.0225
    ],
    [
      "amnesique",
      0.0225
    ],
    [
      "eloigne",
      0.0225
    ]
  ],
  "naturel": [
    [
      "simple",
      0.045
    ],
    [
      "nature",
      0.0375
    ],
    [
      "spontane",
      0.035
    ],
    [
      "inne",
      0.03
    ],
    [
      "vrai",
      0.03
    ],
    [
      "temperament",
      0.0275
    ],
    [
      "pur",
      0.025
    ],
    [
      "essentiel",
      0.025
    ],
    [
      "aise",
      0.0225
    ],
    [
      "natif",
      0.0225
    ],
    [
      "primitif",
      0.0225
    ],
    [
      "simplicite",
      0.0175
    ],
    [
      "originaire",
      0.0175
    ],
    [
      "normal",
      0.0175
    ],
    [
      "franc",
      0.0175
    ],
    [
      "esprit",
      0.0175
    ],
    [
      "caractere",
      0.0175
    ],
    [
      "brut",
      0.0175
    ],
    [
      "facile",
      0.015
    ],
    [
      "naif",
      0.015
    ],
    [
      "verite",
      0.0125
    ],
    [
      "sincere",
      0.0125
    ],
    [
      "naivete",
      0.0125
    ],
    [
      "fondamental",
      0.0125
    ],
    [
      "facilite",
      0.0125
    ],
    [
      "instinctif",
      0.0075
    ],
    [
      "irreflechi",
      0.0075
    ],
    [
      "ordinaire",
      0.0075
    ],
    [
      "physique",
      0.0075
    ],
    [
      "propre",
      0.0075
    ],
    [
      "raisonnable",
      0.0075
    ],
    [
      "spontaneite",
      0.0075
    ],
    [
      "vie",
      0.0075
    ],
    [
      "veritable",
      0.0075
    ],
    [
      "initial",
      0.0075
    ],
    [
      "indigene",
      0.0075
    ],
    [
      "aborigene",
      0.0075
    ],
    [
      "aisance",
      0.0075
    ],
    [
      "coeur",
      0.0075
    ],
    [
      "complexion",
      0.0075
    ],
    [
      "cru",
      0.0075
    ],
    [
      "fond",
      0.0075
    ],
    [
      "fraicheur",
      0.0075
    ],
    [
      "honnete",
      0.0075
    ],
    [
      "illegitime",
      0.0075
    ],
    [
      "habituel",
      0.005
    ],
    [
      "homme",
      0.005
    ],
    [
      "humeur",
      0.005
    ],
    [
      "ingenuite",
      0.005
    ],
    [
      "inherent",
      0.005
    ],
    [
      "intrinseque",
      0.005
    ],
    [
      "logique",
      0.005
    ],
    [
      "moeurs",
      0.005
    ],
    [
      "propension",
      0.005
    ],
    [
      "rationnel",
      0.005
    ],
    [
      "sain",
      0.005
    ],
    [
      "habitant",
      0.005
    ],
    [
      "fruste",
      0.005
    ],
    [
      "foncier",
      0.005
    ],
    [
      "abandon",
      0.005
    ],
    [
      "autochtone",
      0.005
    ],
    [
      "candide",
      0.005
    ],
    [
      "caracteristique",
      0.005
    ],
    [
      "comprehensible",
      0.005
    ],
    [
      "congenital",
      0.005
    ],
    [
      "constitutif",
      0.005
    ],
    [
      "constitution",
      0.005
    ],
    [
      "corporel",
      0.005
    ],
    [
      "correct",
      0.005
    ],
    [
      "coulant",
      0.005
    ],
    [
      "legerete",
      0.0025
    ],
    [
      "irregulier",
      0.0025
    ],
    [
      "involontaire",
      0.0025
    ],
    [
      "intimite",
      0.0025
    ],
    [
      "physiologique",
      0.0025
    ],
    [
      "primesautier",
      0.0025
    ],
    [
      "pate",
      0.0025
    ],
    [
      "ressortissant",
      0.0025
    ],
    [
      "rondeur",
      0.0025
    ],
    [
      "trempe",
      0.0025
    ],
    [
      "infus",
      0.0025
    ],
    [
      "hereditaire",
      0.0025
    ],
    [
      "adulterin",
      0.0025
    ],
    [
      "ancestral",
      0.0025
    ],
    [
      "authenticite",
      0.0025
    ],
    [
      "authentique",
      0.0025
    ],
    [
      "batard",
      0.0025
    ],
    [
      "charnel",
      0.0025
    ],
    [
      "commun",
      0.0025
    ],
    [
      "direct",
      0.0025
    ],
    [
      "degage",
      0.0025
    ],
    [
      "familiarite",
      0.0025
    ],
    [
      "ecru",
      0.0025
    ]
  ],
  "mens": [
    [
      "abuser",
      0.15
    ],
    [
      "tromper",
      0.15
    ],
    [
      "blaguer",
      0.0625
    ],
    [
      "inventer",
      0.0625
    ],
    [
      "jouer",
      0.0625
    ],
    [
      "trahir",
      0.0425
    ],
    [
      "romancer",
      0.0425
    ],
    [
      "plaisanter",
      0.0425
    ],
    [
      "mystifier",
      0.0425
    ],
    [
      "galejer",
      0.0425
    ],
    [
      "feindre",
      0.0425
    ],
    [
      "renier",
      0.02
    ],
    [
      "habler",
      0.02
    ],
    [
      "flatter",
      0.02
    ],
    [
      "fabuler",
      0.02
    ],
    [
      "calomnier",
      0.02
    ],
    [
      "broder",
      0.02
    ],
    [
      "bourrer",
      0.02
    ],
    [
      "taire",
      0.02
    ]
  ],
  "eternel": [
    [
      "Dieu",
      1.0
    ]
  ],
  "marrer": [
    [
      "rire",
      0.25
    ],
    [
      "rigoler",
      0.125
    ]
  ],
  "marre": [
    [
      "assez",
      0.25
    ],
    [
      "branche",
      0.25
    ],
    [
      "houe",
      0.25
    ]
  ],
  "heureux": [
    [
      "beau",
      0.075
    ],
    [
      "bon",
      0.0525
    ],
    [
      "content",
      0.0525
    ],
    [
      "ravi",
      0.05
    ],
    [
      "agreable",
      0.0375
    ],
    [
      "bienheureux",
      0.0325
    ],
    [
      "satisfait",
      0.0325
    ],
    [
      "radieux",
      0.0275
    ],
    [
      "favorable",
      0.025
    ],
    [
      "fortune",
      0.025
    ],
    [
      "prospere",
      0.025
    ],
    [
      "riche",
      0.02
    ],
    [
      "plaisant",
      0.02
    ],
    [
      "nanti",
      0.02
    ],
    [
      "joyeux",
      0.02
    ],
    [
      "gai",
      0.02
    ],
    [
      "doux",
      0.02
    ],
    [
      "rejoui",
      0.015
    ],
    [
      "propice",
      0.015
    ],
    [
      "privilegie",
      0.015
    ],
    [
      "serein",
      0.0125
    ],
    [
      "harmonieux",
      0.0125
    ],
    [
      "fier",
      0.0125
    ],
    [
      "favorise",
      0.0125
    ],
    [
      "faste",
      0.0125
    ],
    [
      "enchante",
      0.0125
    ],
    [
      "enchanteur",
      0.0125
    ],
    [
      "calme",
      0.0125
    ],
    [
      "beat",
      0.0125
    ],
    [
      "avantageux",
      0.0125
    ],
    [
      "elegant",
      0.01
    ],
    [
      "florissant",
      0.01
    ],
    [
      "comble",
      0.01
    ],
    [
      "chanceux",
      0.01
    ],
    [
      "aise",
      0.01
    ],
    [
      "original",
      0.005
    ],
    [
      "paradisiaque",
      0.005
    ],
    [
      "rayonnant",
      0.005
    ],
    [
      "repu",
      0.005
    ],
    [
      "rieur",
      0.005
    ],
    [
      "tranquille",
      0.005
    ],
    [
      "triomphant",
      0.005
    ],
    [
      "veinard",
      0.005
    ],
    [
      "juste",
      0.005
    ],
    [
      "ideal",
      0.005
    ],
    [
      "habile",
      0.005
    ],
    [
      "aise",
      0.005
    ],
    [
      "benoit",
      0.005
    ],
    [
      "bien",
      0.005
    ],
    [
      "benefique",
      0.005
    ],
    [
      "charme",
      0.005
    ],
    [
      "doue",
      0.005
    ],
    [
      "exceptionnel",
      0.005
    ],
    [
      "rare",
      0.0025
    ],
    [
      "reussi",
      0.0025
    ],
    [
      "transporte",
      0.0025
    ],
    [
      "trouve",
      0.0025
    ],
    [
      "providentiel",
      0.0025
    ],
    [
      "optimiste",
      0.0025
    ],
    [
      "nabab",
      0.0025
    ],
    [
      "exauce",
      0.0025
    ],
    [
      "euphorique",
      0.0025
    ],
    [
      "chancard",
      0.0025
    ],
    [
      "beni",
      0.0025
    ],
    [
      "equilibre",
      0.0025
    ]
  ],
  "satisfaire": [
    [
      "contenter",
      0.0775
    ],
    [
      "assouvir",
      0.05
    ],
    [
      "convenir",
      0.0425
    ],
    [
      "exaucer",
      0.0425
    ],
    [
      "observer",
      0.0425
    ],
    [
      "obeir",
      0.0425
    ],
    [
      "remplir",
      0.0425
    ],
    [
      "repondre",
      0.0325
    ],
    [
      "plaire",
      0.0325
    ],
    [
      "passer",
      0.0325
    ],
    [
      "apaiser",
      0.0325
    ],
    [
      "agreer",
      0.0325
    ],
    [
      "rassasier",
      0.025
    ],
    [
      "faire",
      0.025
    ],
    [
      "combler",
      0.025
    ],
    [
      "calmer",
      0.025
    ],
    [
      "arranger",
      0.025
    ],
    [
      "accomplir",
      0.025
    ],
    [
      "accommoder",
      0.025
    ],
    [
      "ecouter",
      0.015
    ],
    [
      "tenir",
      0.015
    ],
    [
      "suffire",
      0.015
    ],
    [
      "s'acquitter",
      0.015
    ],
    [
      "revenir",
      0.015
    ],
    [
      "respecter",
      0.015
    ],
    [
      "pourvoir",
      0.015
    ],
    [
      "accorder",
      0.015
    ],
    [
      "executer",
      0.015
    ],
    [
      "fournir",
      0.015
    ],
    [
      "payer",
      0.015
    ],
    [
      "souler",
      0.0075
    ],
    [
      "soulager",
      0.0075
    ],
    [
      "s'executer",
      0.0075
    ],
    [
      "s'abandonner",
      0.0075
    ],
    [
      "entendre",
      0.0075
    ],
    [
      "correspondre",
      0.0075
    ],
    [
      "complaire",
      0.0075
    ],
    [
      "etancher",
      0.0075
    ]
  ],
  "eau": [
    [
      "flot",
      0.09
    ],
    [
      "lustre",
      0.09
    ],
    [
      "pluie",
      0.09
    ],
    [
      "lotion",
      0.045
    ],
    [
      "onde",
      0.045
    ],
    [
      "orient",
      0.045
    ],
    [
      "parfum",
      0.045
    ],
    [
      "pisse",
      0.045
    ],
    [
      "suc",
      0.045
    ],
    [
      "lavure",
      0.045
    ],
    [
      "larme",
      0.045
    ],
    [
      "flotte",
      0.045
    ],
    [
      "brillant",
      0.045
    ],
    [
      "boisson",
      0.045
    ],
    [
      "bain",
      0.045
    ],
    [
      "baille",
      0.045
    ],
    [
      "alcool",
      0.045
    ],
    [
      "sueur",
      0.045
    ]
  ],
  "frais": [
    [
      "pur",
      0.0675
    ],
    [
      "froid",
      0.0525
    ],
    [
      "jeune",
      0.0525
    ],
    [
      "neuf",
      0.0525
    ],
    [
      "vif",
      0.04
    ],
    [
      "nouveau",
      0.04
    ],
    [
      "depense",
      0.04
    ],
    [
      "depens",
      0.04
    ],
    [
      "dispos",
      0.04
    ],
    [
      "sain",
      0.025
    ],
    [
      "printanier",
      0.025
    ],
    [
      "naif",
      0.025
    ],
    [
      "intact",
      0.025
    ],
    [
      "innocent",
      0.025
    ],
    [
      "gaillard",
      0.025
    ],
    [
      "candide",
      0.025
    ],
    [
      "net",
      0.0125
    ],
    [
      "nouvellement",
      0.0125
    ],
    [
      "poupard",
      0.0125
    ],
    [
      "propre",
      0.0125
    ],
    [
      "repose",
      0.0125
    ],
    [
      "rose",
      0.0125
    ],
    [
      "recemment",
      0.0125
    ],
    [
      "recent",
      0.0125
    ],
    [
      "reserve",
      0.0125
    ],
    [
      "tendre",
      0.0125
    ],
    [
      "vermeil",
      0.0125
    ],
    [
      "eclatant",
      0.0125
    ],
    [
      "moelleux",
      0.0125
    ],
    [
      "humide",
      0.0125
    ],
    [
      "glace",
      0.0125
    ],
    [
      "addition",
      0.0125
    ],
    [
      "agio",
      0.0125
    ],
    [
      "charge",
      0.0125
    ],
    [
      "cout",
      0.0125
    ],
    [
      "debours",
      0.0125
    ],
    [
      "fleuri",
      0.0125
    ],
    [
      "frappe",
      0.0125
    ],
    [
      "fraichement",
      0.0125
    ],
    [
      "fraicheur",
      0.0125
    ],
    [
      "frisquet",
      0.0125
    ],
    [
      "actuel",
      0.0125
    ]
  ],
  "verdure": [
    [
      "herbe",
      0.13
    ],
    [
      "boulingrin",
      0.085
    ],
    [
      "gazon",
      0.085
    ],
    [
      "parterre",
      0.085
    ],
    [
      "pre",
      0.085
    ],
    [
      "prairie",
      0.0425
    ],
    [
      "paturage",
      0.0425
    ],
    [
      "pature",
      0.0425
    ],
    [
      "tapisserie",
      0.0425
    ],
    [
      "peinture",
      0.0425
    ],
    [
      "paysage",
      0.0425
    ],
    [
      "herbage",
      0.0425
    ],
    [
      "frondaison",
      0.0425
    ],
    [
      "feuille",
      0.0425
    ],
    [
      "feuillage",
      0.0425
    ],
    [
      "vegetation",
      0.0425
    ]
  ],
  "prodiguer": [
    [
      "donner",
      0.095
    ],
    [
      "montrer",
      0.0825
    ],
    [
      "repandre",
      0.07
    ],
    [
      "depenser",
      0.0575
    ],
    [
      "dissiper",
      0.0575
    ],
    [
      "afficher",
      0.0575
    ],
    [
      "gaspiller",
      0.0475
    ],
    [
      "verser",
      0.0475
    ],
    [
      "porter",
      0.035
    ],
    [
      "manifester",
      0.035
    ],
    [
      "jeter",
      0.035
    ],
    [
      "deployer",
      0.035
    ],
    [
      "dilapider",
      0.035
    ],
    [
      "eparpiller",
      0.0225
    ],
    [
      "temoigner",
      0.0225
    ],
    [
      "repartir",
      0.0225
    ],
    [
      "marquer",
      0.0225
    ],
    [
      "manger",
      0.0225
    ],
    [
      "exposer",
      0.0225
    ],
    [
      "distribuer",
      0.0225
    ],
    [
      "adresser",
      0.0225
    ],
    [
      "sacrifier",
      0.01
    ],
    [
      "regorger",
      0.01
    ],
    [
      "gacher",
      0.01
    ],
    [
      "consumer",
      0.01
    ],
    [
      "affecter",
      0.01
    ],
    [
      "accorder",
      0.01
    ],
    [
      "accabler",
      0.01
    ],
    [
      "abonder",
      0.01
    ],
    [
      "epancher",
      0.01
    ]
  ],
  "prodigue": [
    [
      "genereux",
      0.1525
    ],
    [
      "abondant",
      0.1275
    ],
    [
      "depensier",
      0.1025
    ],
    [
      "bon",
      0.075
    ],
    [
      "large",
      0.075
    ],
    [
      "fertile",
      0.05
    ],
    [
      "dissipateur",
      0.05
    ],
    [
      "dilapidateur",
      0.05
    ],
    [
      "liberal",
      0.025
    ],
    [
      "gaspilleur",
      0.025
    ],
    [
      "fecond",
      0.025
    ],
    [
      "desordonne",
      0.025
    ],
    [
      "desinteresse",
      0.025
    ],
    [
      "debordant",
      0.025
    ],
    [
      "charitable",
      0.025
    ],
    [
      "prolixe",
      0.025
    ]
  ],
  "nature": [
    [
      "temperament",
      0.09
    ],
    [
      "caractere",
      0.085
    ],
    [
      "esprit",
      0.045
    ],
    [
      "naturel",
      0.0425
    ],
    [
      "disposition",
      0.0375
    ],
    [
      "qualite",
      0.035
    ],
    [
      "type",
      0.035
    ],
    [
      "sorte",
      0.0275
    ],
    [
      "espece",
      0.0275
    ],
    [
      "constitution",
      0.0275
    ],
    [
      "classe",
      0.025
    ],
    [
      "genre",
      0.025
    ],
    [
      "organisation",
      0.025
    ],
    [
      "trempe",
      0.02
    ],
    [
      "fond",
      0.02
    ],
    [
      "complexion",
      0.02
    ],
    [
      "acabit",
      0.02
    ],
    [
      "categorie",
      0.015
    ],
    [
      "essence",
      0.015
    ],
    [
      "etat",
      0.015
    ],
    [
      "ame",
      0.0125
    ],
    [
      "realite",
      0.0125
    ],
    [
      "propriete",
      0.0125
    ],
    [
      "personnalite",
      0.0125
    ],
    [
      "ordre",
      0.0125
    ],
    [
      "monde",
      0.0125
    ],
    [
      "humeur",
      0.0125
    ],
    [
      "genie",
      0.0125
    ],
    [
      "coeur",
      0.0125
    ],
    [
      "verite",
      0.01
    ],
    [
      "univers",
      0.01
    ],
    [
      "substance",
      0.01
    ],
    [
      "propre",
      0.01
    ],
    [
      "inclination",
      0.01
    ],
    [
      "gabarit",
      0.01
    ],
    [
      "champ",
      0.01
    ],
    [
      "penchant",
      0.005
    ],
    [
      "maniere",
      0.005
    ],
    [
      "existence",
      0.005
    ],
    [
      "creation",
      0.005
    ],
    [
      "condition",
      0.005
    ],
    [
      "caracteristique",
      0.005
    ],
    [
      "campagne",
      0.005
    ],
    [
      "macrocosme",
      0.0025
    ],
    [
      "modele",
      0.0025
    ],
    [
      "naturellement",
      0.0025
    ],
    [
      "physique",
      0.0025
    ],
    [
      "pate",
      0.0025
    ],
    [
      "quiddite",
      0.0025
    ],
    [
      "sang",
      0.0025
    ],
    [
      "sante",
      0.0025
    ],
    [
      "sexe",
      0.0025
    ],
    [
      "individualite",
      0.0025
    ],
    [
      "idiosyncrasie",
      0.0025
    ],
    [
      "entite",
      0.0025
    ],
    [
      "amoral",
      0.0025
    ],
    [
      "attribut",
      0.0025
    ],
    [
      "carcasse",
      0.0025
    ],
    [
      "chair",
      0.0025
    ],
    [
      "cosmos",
      0.0025
    ],
    [
      "dessin",
      0.0025
    ],
    [
      "diathese",
      0.0025
    ],
    [
      "detour",
      0.0025
    ],
    [
      "vitalite",
      0.0025
    ]
  ],
  "rayer": [
    [
      "supprimer",
      0.1225
    ],
    [
      "biffer",
      0.0825
    ],
    [
      "barrer",
      0.075
    ],
    [
      "effacer",
      0.075
    ],
    [
      "radier",
      0.075
    ],
    [
      "retrancher",
      0.06
    ],
    [
      "oter",
      0.06
    ],
    [
      "detruire",
      0.0525
    ],
    [
      "exclure",
      0.0375
    ],
    [
      "eliminer",
      0.0375
    ],
    [
      "annuler",
      0.03
    ],
    [
      "marquer",
      0.03
    ],
    [
      "zebrer",
      0.0225
    ],
    [
      "raturer",
      0.0225
    ],
    [
      "entamer",
      0.0225
    ],
    [
      "couper",
      0.0225
    ],
    [
      "bannir",
      0.0225
    ],
    [
      "egratigner",
      0.0125
    ],
    [
      "strier",
      0.0125
    ],
    [
      "sabrer",
      0.0125
    ],
    [
      "reformer",
      0.0125
    ],
    [
      "caviarder",
      0.0125
    ],
    [
      "sillonner",
      0.005
    ],
    [
      "rider",
      0.005
    ],
    [
      "rejeter",
      0.005
    ],
    [
      "ligner",
      0.005
    ],
    [
      "hachurer",
      0.005
    ],
    [
      "batonner",
      0.005
    ],
    [
      "bretteler",
      0.005
    ],
    [
      "abolir",
      0.005
    ],
    [
      "erafler",
      0.005
    ]
  ],
  "rayon": [
    [
      "trait",
      0.105
    ],
    [
      "domaine",
      0.0775
    ],
    [
      "etincelle",
      0.0525
    ],
    [
      "rayonnement",
      0.0525
    ],
    [
      "partie",
      0.0525
    ],
    [
      "lumiere",
      0.0525
    ],
    [
      "jet",
      0.0525
    ],
    [
      "rai",
      0.025
    ],
    [
      "rayonnage",
      0.025
    ],
    [
      "sillon",
      0.025
    ],
    [
      "sphere",
      0.025
    ],
    [
      "stand",
      0.025
    ],
    [
      "tablette",
      0.025
    ],
    [
      "vibration",
      0.025
    ],
    [
      "etagere",
      0.025
    ],
    [
      "etalage",
      0.025
    ],
    [
      "planche",
      0.025
    ],
    [
      "lueur",
      0.025
    ],
    [
      "apparence",
      0.025
    ],
    [
      "bout",
      0.025
    ],
    [
      "casier",
      0.025
    ],
    [
      "degre",
      0.025
    ],
    [
      "distance",
      0.025
    ],
    [
      "district",
      0.025
    ],
    [
      "envergure",
      0.025
    ],
    [
      "ligne",
      0.025
    ],
    [
      "eventaire",
      0.025
    ]
  ],
  "miel": [
    [
      "agrement",
      0.25
    ],
    [
      "ambroisie",
      0.25
    ],
    [
      "douceur",
      0.25
    ],
    [
      "nectar",
      0.25
    ]
  ],
  "soleil": [
    [
      "tour",
      0.1175
    ],
    [
      "rougeur",
      0.0575
    ],
    [
      "rotation",
      0.0575
    ],
    [
      "pirouette",
      0.0575
    ],
    [
      "phebus",
      0.0575
    ],
    [
      "ostensoir",
      0.0575
    ],
    [
      "lumiere",
      0.0575
    ],
    [
      "jour",
      0.0575
    ],
    [
      "helianthe",
      0.0575
    ],
    [
      "girandole",
      0.0575
    ],
    [
      "bourguignon",
      0.0575
    ],
    [
      "astre",
      0.0575
    ],
    [
      "Phebus",
      0.0575
    ],
    [
      "tournesol",
      0.0575
    ]
  ],
  "dormir": [
    [
      "sommeiller",
      0.22
    ],
    [
      "somnoler",
      0.22
    ],
    [
      "ronfler",
      0.055
    ],
    [
      "reposer",
      0.0275
    ],
    [
      "roupiller",
      0.0275
    ],
    [
      "rever",
      0.0275
    ],
    [
      "s'assoupir",
      0.0275
    ],
    [
      "s'endormir",
      0.0275
    ],
    [
      "trainer",
      0.0275
    ],
    [
      "pioncer",
      0.0275
    ],
    [
      "oublier",
      0.0275
    ],
    [
      "negliger",
      0.0275
    ],
    [
      "lanterner",
      0.0275
    ],
    [
      "lambiner",
      0.0275
    ],
    [
      "dormailler",
      0.0275
    ],
    [
      "coucher",
      0.0275
    ]
  ],
  "ordinaire": [
    [
      "vulgaire",
      0.075
    ],
    [
      "commun",
      0.065
    ],
    [
      "courant",
      0.0625
    ],
    [
      "habituel",
      0.0625
    ],
    [
      "banal",
      0.05
    ],
    [
      "trivial",
      0.045
    ],
    [
      "quelconque",
      0.04
    ],
    [
      "simple",
      0.0375
    ],
    [
      "bas",
      0.03
    ],
    [
      "insignifiant",
      0.03
    ],
    [
      "usite",
      0.025
    ],
    [
      "petit",
      0.025
    ],
    [
      "mediocre",
      0.025
    ],
    [
      "grossier",
      0.025
    ],
    [
      "vil",
      0.02
    ],
    [
      "normal",
      0.0175
    ],
    [
      "prosaique",
      0.0175
    ],
    [
      "usuel",
      0.0175
    ],
    [
      "traditionnel",
      0.015
    ],
    [
      "repas",
      0.015
    ],
    [
      "familier",
      0.015
    ],
    [
      "facile",
      0.015
    ],
    [
      "cuisine",
      0.015
    ],
    [
      "classique",
      0.015
    ],
    [
      "quotidien",
      0.0125
    ],
    [
      "nourriture",
      0.0125
    ],
    [
      "moyen",
      0.0125
    ],
    [
      "menu",
      0.0125
    ],
    [
      "coutumier",
      0.0125
    ],
    [
      "accoutume",
      0.0125
    ],
    [
      "roturier",
      0.0075
    ],
    [
      "pratique",
      0.0075
    ],
    [
      "naturel",
      0.0075
    ],
    [
      "materiel",
      0.0075
    ],
    [
      "gros",
      0.0075
    ],
    [
      "frequent",
      0.0075
    ],
    [
      "chere",
      0.0075
    ],
    [
      "regulier",
      0.005
    ],
    [
      "populacier",
      0.005
    ],
    [
      "plebeien",
      0.005
    ],
    [
      "pitance",
      0.005
    ],
    [
      "lourd",
      0.005
    ],
    [
      "humble",
      0.005
    ],
    [
      "coutume",
      0.005
    ],
    [
      "alimentation",
      0.005
    ],
    [
      "lambda",
      0.0025
    ],
    [
      "norme",
      0.0025
    ],
    [
      "ration",
      0.0025
    ],
    [
      "sobre",
      0.0025
    ],
    [
      "table",
      0.0025
    ],
    [
      "invetere",
      0.0025
    ],
    [
      "habitude",
      0.0025
    ],
    [
      "general",
      0.0025
    ],
    [
      "consacre",
      0.0025
    ],
    [
      "casuiste",
      0.0025
    ],
    [
      "attitre",
      0.0025
    ],
    [
      "anonyme",
      0.0025
    ],
    [
      "usage",
      0.0025
    ]
  ],
  "sous": [
    [
      "centime",
      0.1175
    ],
    [
      "liard",
      0.1175
    ],
    [
      "radis",
      0.1175
    ],
    [
      "argent",
      0.0875
    ],
    [
      "denier",
      0.0875
    ],
    [
      "rond",
      0.0875
    ],
    [
      "piece",
      0.0575
    ],
    [
      "thune",
      0.0275
    ],
    [
      "sol",
      0.0275
    ],
    [
      "rotin",
      0.0275
    ],
    [
      "remise",
      0.0275
    ],
    [
      "picaillon",
      0.0275
    ],
    [
      "penny",
      0.0275
    ],
    [
      "patard",
      0.0275
    ],
    [
      "obole",
      0.0275
    ],
    [
      "monnaie",
      0.0275
    ],
    [
      "ferraille",
      0.0275
    ],
    [
      "ecu",
      0.0275
    ]
  ],
  "sou": [
    [
      "centime",
      0.1175
    ],
    [
      "liard",
      0.1175
    ],
    [
      "radis",
      0.1175
    ],
    [
      "argent",
      0.0875
    ],
    [
      "denier",
      0.0875
    ],
    [
      "rond",
      0.0875
    ],
    [
      "piece",
      0.0575
    ],
    [
      "thune",
      0.0275
    ],
    [
      "sol",
      0.0275
    ],
    [
      "rotin",
      0.0275
    ],
    [
      "remise",
      0.0275
    ],
    [
      "picaillon",
      0.0275
    ],
    [
      "penny",
      0.0275
    ],
    [
      "patard",
      0.0275
    ],
    [
      "obole",
      0.0275
    ],
    [
      "monnaie",
      0.0275
    ],
    [
      "ferraille",
      0.0275
    ],
    [
      "ecu",
      0.0275
    ]
  ],
  "frondaison": [
    [
      "feuillage",
      0.22
    ],
    [
      "ramure",
      0.155
    ],
    [
      "ramee",
      0.0875
    ],
    [
      "branchage",
      0.065
    ],
    [
      "feuillee",
      0.065
    ],
    [
      "ombrage",
      0.0425
    ],
    [
      "foret",
      0.0425
    ],
    [
      "feuille",
      0.0425
    ],
    [
      "bois",
      0.0425
    ],
    [
      "abri",
      0.0425
    ],
    [
      "rameau",
      0.02
    ],
    [
      "ombre",
      0.02
    ],
    [
      "futaie",
      0.02
    ],
    [
      "feuilles",
      0.02
    ],
    [
      "feuillaison",
      0.02
    ],
    [
      "branchure",
      0.02
    ],
    [
      "branches",
      0.02
    ],
    [
      "verdure",
      0.02
    ]
  ],
  "jungle": [
    [
      "foret",
      0.5
    ],
    [
      "labyrinthe",
      0.5
    ]
  ],
  "maison": [
    [
      "habitation",
      0.095
    ],
    [
      "abri",
      0.05
    ],
    [
      "demeure",
      0.0475
    ],
    [
      "foyer",
      0.04
    ],
    [
      "logis",
      0.0325
    ],
    [
      "cabane",
      0.0325
    ],
    [
      "toit",
      0.0275
    ],
    [
      "famille",
      0.0225
    ],
    [
      "logement",
      0.0225
    ],
    [
      "nid",
      0.02
    ],
    [
      "gite",
      0.02
    ],
    [
      "domicile",
      0.02
    ],
    [
      "baraque",
      0.02
    ],
    [
      "bicoque",
      0.0175
    ],
    [
      "chateau",
      0.015
    ],
    [
      "home",
      0.015
    ],
    [
      "penates",
      0.015
    ],
    [
      "taudis",
      0.0125
    ],
    [
      "race",
      0.0125
    ],
    [
      "origine",
      0.0125
    ],
    [
      "immeuble",
      0.0125
    ],
    [
      "gourbi",
      0.0125
    ],
    [
      "lignee",
      0.01
    ],
    [
      "hotel",
      0.01
    ],
    [
      "cahute",
      0.01
    ],
    [
      "batiment",
      0.01
    ],
    [
      "asile",
      0.01
    ],
    [
      "etablissement",
      0.0075
    ],
    [
      "residence",
      0.0075
    ],
    [
      "reduit",
      0.0075
    ],
    [
      "retraite",
      0.0075
    ],
    [
      "pavillon",
      0.0075
    ],
    [
      "palais",
      0.0075
    ],
    [
      "maisonnette",
      0.0075
    ],
    [
      "hutte",
      0.0075
    ],
    [
      "domestique",
      0.0075
    ],
    [
      "case",
      0.0075
    ],
    [
      "boite",
      0.0075
    ],
    [
      "bercail",
      0.0075
    ],
    [
      "masure",
      0.005
    ],
    [
      "menage",
      0.005
    ],
    [
      "naissance",
      0.005
    ],
    [
      "propriete",
      0.005
    ],
    [
      "suite",
      0.005
    ],
    [
      "villa",
      0.005
    ],
    [
      "lieu",
      0.005
    ],
    [
      "interieur",
      0.005
    ],
    [
      "gens",
      0.005
    ],
    [
      "appartement",
      0.005
    ],
    [
      "bouge",
      0.005
    ],
    [
      "batisse",
      0.005
    ],
    [
      "domesticite",
      0.005
    ],
    [
      "entreprise",
      0.005
    ],
    [
      "galetas",
      0.005
    ],
    [
      "hopital",
      0.0025
    ],
    [
      "institution",
      0.0025
    ],
    [
      "maisonnee",
      0.0025
    ],
    [
      "monde",
      0.0025
    ],
    [
      "prison",
      0.0025
    ],
    [
      "serviteur",
      0.0025
    ],
    [
      "sejour",
      0.0025
    ],
    [
      "edifice",
      0.0025
    ],
    [
      "habitacle",
      0.0025
    ],
    [
      "ferme",
      0.0025
    ],
    [
      "campagne",
      0.0025
    ],
    [
      "cassine",
      0.0025
    ],
    [
      "chalet",
      0.0025
    ],
    [
      "construction",
      0.0025
    ],
    [
      "descendance",
      0.0025
    ],
    [
      "dynastie",
      0.0025
    ],
    [
      "firme",
      0.0
    ],
    [
      "institut",
      0.0
    ],
    [
      "lares",
      0.0
    ],
    [
      "manoir",
      0.0
    ],
    [
      "nom",
      0.0
    ],
    [
      "parents",
      0.0
    ],
    [
      "pigeonnier",
      0.0
    ],
    [
      "place",
      0.0
    ],
    [
      "temple",
      0.0
    ],
    [
      "feu",
      0.0
    ],
    [
      "couvert",
      0.0
    ],
    [
      "branche",
      0.0
    ],
    [
      "building",
      0.0
    ],
    [
      "bungalow",
      0.0
    ],
    [
      "chacuniere",
      0.0
    ],
    [
      "chaumiere",
      0.0
    ],
    [
      "clapier",
      0.0
    ],
    [
      "clinique",
      0.0
    ],
    [
      "commerce",
      0.0
    ],
    [
      "couronne",
      0.0
    ],
    [
      "trone",
      0.0
    ]
  ],
  "abeille": [
    [
      "avette",
      0.4
    ],
    [
      "apis",
      0.2
    ],
    [
      "ouvriere",
      0.2
    ]
  ],
  "foret": [
    [
      "bois",
      0.2375
    ],
    [
      "frondaison",
      0.1175
    ],
    [
      "futaie",
      0.1175
    ],
    [
      "quantite",
      0.0575
    ],
    [
      "perchis",
      0.0575
    ],
    [
      "multitude",
      0.0575
    ],
    [
      "labyrinthe",
      0.0575
    ],
    [
      "jungle",
      0.0575
    ],
    [
      "arbre",
      0.0575
    ],
    [
      "affluence",
      0.0575
    ],
    [
      "abri",
      0.0575
    ],
    [
      "sylve",
      0.0575
    ]
  ],
  "bosquet": [
    [
      "bois",
      0.225
    ],
    [
      "boqueteau",
      0.135
    ],
    [
      "charmille",
      0.135
    ],
    [
      "touffe",
      0.09
    ],
    [
      "buisson",
      0.09
    ],
    [
      "bouquet",
      0.09
    ],
    [
      "bocage",
      0.09
    ],
    [
      "futaie",
      0.045
    ],
    [
      "massif",
      0.045
    ],
    [
      "tonnelle",
      0.045
    ]
  ],
  "retourner": [
    [
      "bouleverser",
      0.09
    ],
    [
      "secouer",
      0.06
    ],
    [
      "emouvoir",
      0.0475
    ],
    [
      "remuer",
      0.0425
    ],
    [
      "revenir",
      0.0425
    ],
    [
      "tourner",
      0.035
    ],
    [
      "revolutionner",
      0.035
    ],
    [
      "renverser",
      0.035
    ],
    [
      "troubler",
      0.03
    ],
    [
      "remettre",
      0.03
    ],
    [
      "partir",
      0.03
    ],
    [
      "impressionner",
      0.03
    ],
    [
      "frapper",
      0.03
    ],
    [
      "renvoyer",
      0.0225
    ],
    [
      "transposer",
      0.0175
    ],
    [
      "transformer",
      0.0175
    ],
    [
      "repasser",
      0.0175
    ],
    [
      "rentrer",
      0.0175
    ],
    [
      "regagner",
      0.0175
    ],
    [
      "fouiller",
      0.0175
    ],
    [
      "chavirer",
      0.0175
    ],
    [
      "retomber",
      0.01
    ],
    [
      "ruminer",
      0.01
    ],
    [
      "reintegrer",
      0.01
    ],
    [
      "saisir",
      0.01
    ],
    [
      "ecarter",
      0.01
    ],
    [
      "emotionner",
      0.01
    ],
    [
      "reporter",
      0.01
    ],
    [
      "rendre",
      0.01
    ],
    [
      "refluer",
      0.01
    ],
    [
      "agiter",
      0.01
    ],
    [
      "aller",
      0.01
    ],
    [
      "commotionner",
      0.01
    ],
    [
      "empoigner",
      0.01
    ],
    [
      "filer",
      0.01
    ],
    [
      "labourer",
      0.01
    ],
    [
      "redescendre",
      0.005
    ],
    [
      "refuser",
      0.005
    ],
    [
      "rejoindre",
      0.005
    ],
    [
      "repartir",
      0.005
    ],
    [
      "reprendre",
      0.005
    ],
    [
      "restituer",
      0.005
    ],
    [
      "reexpedier",
      0.005
    ],
    [
      "s'eloigner",
      0.005
    ],
    [
      "sonder",
      0.005
    ],
    [
      "tournebouler",
      0.005
    ],
    [
      "rebrousser",
      0.005
    ],
    [
      "amener",
      0.005
    ],
    [
      "becher",
      0.005
    ],
    [
      "chambarder",
      0.005
    ],
    [
      "chambouler",
      0.005
    ],
    [
      "dissequer",
      0.005
    ],
    [
      "decortiquer",
      0.005
    ],
    [
      "farfouiller",
      0.005
    ],
    [
      "influer",
      0.005
    ],
    [
      "intervertir",
      0.005
    ],
    [
      "rabattre",
      0.005
    ],
    [
      "rallier",
      0.005
    ],
    [
      "verser",
      0.005
    ]
  ],
  "retourne": [
    [
      "tourne",
      1.0
    ]
  ],
  "gros": [
    [
      "grand",
      0.0675
    ],
    [
      "fort",
      0.0625
    ],
    [
      "important",
      0.05
    ],
    [
      "considerable",
      0.0275
    ],
    [
      "beau",
      0.0275
    ],
    [
      "gras",
      0.0275
    ],
    [
      "rebondi",
      0.025
    ],
    [
      "enorme",
      0.025
    ],
    [
      "abondant",
      0.0225
    ],
    [
      "extraordinaire",
      0.0175
    ],
    [
      "vaste",
      0.0175
    ],
    [
      "epais",
      0.0175
    ],
    [
      "bon",
      0.0175
    ],
    [
      "puissant",
      0.015
    ],
    [
      "replet",
      0.015
    ],
    [
      "profond",
      0.015
    ],
    [
      "massif",
      0.015
    ],
    [
      "lourd",
      0.015
    ],
    [
      "haut",
      0.0125
    ],
    [
      "obese",
      0.0125
    ],
    [
      "renfle",
      0.0125
    ],
    [
      "plein",
      0.0125
    ],
    [
      "formidable",
      0.0125
    ],
    [
      "ample",
      0.0125
    ],
    [
      "eminent",
      0.01
    ],
    [
      "riche",
      0.01
    ],
    [
      "large",
      0.01
    ],
    [
      "imposant",
      0.01
    ],
    [
      "immense",
      0.01
    ],
    [
      "bouffi",
      0.0075
    ],
    [
      "corpulent",
      0.0075
    ],
    [
      "gonfle",
      0.0075
    ],
    [
      "grossier",
      0.0075
    ],
    [
      "eleve",
      0.0075
    ],
    [
      "retentissant",
      0.0075
    ],
    [
      "notable",
      0.0075
    ],
    [
      "colossal",
      0.005
    ],
    [
      "intense",
      0.005
    ],
    [
      "superieur",
      0.005
    ],
    [
      "trapu",
      0.005
    ],
    [
      "ventru",
      0.005
    ],
    [
      "solide",
      0.005
    ],
    [
      "rond",
      0.005
    ],
    [
      "pesant",
      0.005
    ],
    [
      "pansu",
      0.005
    ],
    [
      "grave",
      0.005
    ],
    [
      "excessif",
      0.005
    ],
    [
      "enfle",
      0.005
    ],
    [
      "empate",
      0.005
    ],
    [
      "volumineux",
      0.005
    ],
    [
      "souffle",
      0.005
    ],
    [
      "rondelet",
      0.005
    ],
    [
      "proeminent",
      0.005
    ],
    [
      "arrondi",
      0.005
    ],
    [
      "adipeux",
      0.005
    ],
    [
      "ventripotent",
      0.0025
    ],
    [
      "tumefie",
      0.0025
    ],
    [
      "serieux",
      0.0025
    ],
    [
      "simple",
      0.0025
    ],
    [
      "robuste",
      0.0025
    ],
    [
      "principal",
      0.0025
    ],
    [
      "joli",
      0.0025
    ],
    [
      "fabuleux",
      0.0025
    ],
    [
      "charnu",
      0.0025
    ],
    [
      "bombe",
      0.0025
    ],
    [
      "vulgaire",
      0.0025
    ],
    [
      "violent",
      0.0025
    ],
    [
      "trivial",
      0.0025
    ],
    [
      "opulent",
      0.0025
    ],
    [
      "nombreux",
      0.0025
    ],
    [
      "mastoc",
      0.0025
    ],
    [
      "dodu",
      0.0025
    ],
    [
      "coquet",
      0.0025
    ],
    [
      "boulot",
      0.0025
    ],
    [
      "potele",
      0.0
    ],
    [
      "poupard",
      0.0
    ],
    [
      "penible",
      0.0
    ],
    [
      "resonnant",
      0.0
    ],
    [
      "sonore",
      0.0
    ],
    [
      "severe",
      0.0
    ],
    [
      "vif",
      0.0
    ],
    [
      "ordinaire",
      0.0
    ],
    [
      "notabilite",
      0.0
    ],
    [
      "ballonne",
      0.0
    ],
    [
      "commun",
      0.0
    ],
    [
      "courtaud",
      0.0
    ],
    [
      "essentiel",
      0.0
    ],
    [
      "fertile",
      0.0
    ],
    [
      "joufflu",
      0.0
    ],
    [
      "monstrueux",
      0.0
    ],
    [
      "obscene",
      0.0
    ],
    [
      "paquet",
      0.0
    ],
    [
      "patapouf",
      0.0
    ],
    [
      "pataud",
      0.0
    ],
    [
      "piffre",
      0.0
    ],
    [
      "pepere",
      0.0
    ],
    [
      "spacieux",
      0.0
    ],
    [
      "tonneau",
      0.0
    ],
    [
      "etouffant",
      0.0
    ],
    [
      "mastodonte",
      0.0
    ],
    [
      "masse",
      0.0
    ],
    [
      "maous",
      0.0
    ],
    [
      "assourdissant",
      0.0
    ],
    [
      "barrique",
      0.0
    ],
    [
      "bedonnant",
      0.0
    ],
    [
      "boursoufle",
      0.0
    ],
    [
      "developpe",
      0.0
    ],
    [
      "faramineux",
      0.0
    ],
    [
      "gidouillard",
      0.0
    ],
    [
      "hypertrophie",
      0.0
    ],
    [
      "insupportable",
      0.0
    ],
    [
      "influent",
      0.0
    ],
    [
      "mastar",
      0.0
    ],
    [
      "membru",
      0.0
    ],
    [
      "nabab",
      0.0
    ],
    [
      "nourri",
      0.0
    ],
    [
      "porc",
      0.0
    ],
    [
      "pote",
      0.0
    ],
    [
      "poussah",
      0.0
    ],
    [
      "ragot",
      0.0
    ],
    [
      "rudimentaire",
      0.0
    ],
    [
      "vilain",
      0.0
    ],
    [
      "genant",
      0.0
    ],
    [
      "grossi",
      0.0
    ],
    [
      "appuye",
      0.0
    ],
    [
      "beaucoup",
      0.0
    ],
    [
      "bedon",
      0.0
    ],
    [
      "biquet",
      0.0
    ],
    [
      "caniculaire",
      0.0
    ],
    [
      "cher",
      0.0
    ],
    [
      "consequent",
      0.0
    ],
    [
      "exorbite",
      0.0
    ],
    [
      "fecond",
      0.0
    ],
    [
      "globuleux",
      0.0
    ],
    [
      "gravos",
      0.0
    ],
    [
      "epanoui",
      0.0
    ]
  ],
  "caillou": [
    [
      "pierre",
      0.12
    ],
    [
      "difficulte",
      0.08
    ],
    [
      "roche",
      0.08
    ],
    [
      "contrariete",
      0.06
    ],
    [
      "embarras",
      0.06
    ],
    [
      "obstacle",
      0.06
    ],
    [
      "traverse",
      0.06
    ],
    [
      "tete",
      0.04
    ],
    [
      "empechement",
      0.04
    ],
    [
      "cahot",
      0.04
    ],
    [
      "vicissitude",
      0.0175
    ],
    [
      "souci",
      0.0175
    ],
    [
      "silex",
      0.0175
    ],
    [
      "ruderation",
      0.0175
    ],
    [
      "roc",
      0.0175
    ],
    [
      "palet",
      0.0175
    ],
    [
      "jalet",
      0.0175
    ],
    [
      "inconvenient",
      0.0175
    ],
    [
      "gravier",
      0.0175
    ],
    [
      "galet",
      0.0175
    ],
    [
      "figure",
      0.0175
    ],
    [
      "crane",
      0.0175
    ],
    [
      "cailloutis",
      0.0175
    ],
    [
      "caillasse",
      0.0175
    ],
    [
      "bourrichon",
      0.0175
    ],
    [
      "bloc",
      0.0175
    ],
    [
      "epreuve",
      0.0175
    ]
  ],
  "fourmi": [],
  "dessous": [
    [
      "lingerie",
      0.1175
    ],
    [
      "sous",
      0.0575
    ],
    [
      "secret",
      0.0575
    ],
    [
      "linge",
      0.0575
    ],
    [
      "inferiorite",
      0.0575
    ],
    [
      "envers",
      0.0575
    ],
    [
      "defaite",
      0.0575
    ],
    [
      "deca",
      0.0575
    ],
    [
      "culotte",
      0.0575
    ],
    [
      "coulisse",
      0.0575
    ],
    [
      "base",
      0.0575
    ],
    [
      "bas",
      0.0575
    ],
    [
      "vetement",
      0.0575
    ]
  ],
  "votre": [],
  "esprit": [
    [
      "Dieu",
      1.0
    ]
  ],
  "vos": [],
  "souci": [
    [
      "tourment",
      0.1225
    ],
    [
      "ennui",
      0.0975
    ],
    [
      "inquietude",
      0.085
    ],
    [
      "tracas",
      0.075
    ],
    [
      "peine",
      0.0575
    ],
    [
      "difficulte",
      0.0425
    ],
    [
      "embarras",
      0.0425
    ],
    [
      "preoccupation",
      0.04
    ],
    [
      "chagrin",
      0.04
    ],
    [
      "angoisse",
      0.025
    ],
    [
      "contrariete",
      0.025
    ],
    [
      "desagrement",
      0.02
    ],
    [
      "emoi",
      0.015
    ],
    [
      "tirage",
      0.015
    ],
    [
      "tintouin",
      0.015
    ],
    [
      "scrupule",
      0.015
    ],
    [
      "obsession",
      0.015
    ],
    [
      "embetement",
      0.015
    ],
    [
      "incertitude",
      0.0125
    ],
    [
      "crainte",
      0.0125
    ],
    [
      "anxiete",
      0.0125
    ],
    [
      "tristesse",
      0.0075
    ],
    [
      "transe",
      0.0075
    ],
    [
      "tracasserie",
      0.0075
    ],
    [
      "soin",
      0.0075
    ],
    [
      "poids",
      0.0075
    ],
    [
      "empoisonnement",
      0.0075
    ],
    [
      "alarme",
      0.0075
    ],
    [
      "agitation",
      0.0075
    ],
    [
      "affaire",
      0.0075
    ],
    [
      "tribulation",
      0.005
    ],
    [
      "supplice",
      0.005
    ],
    [
      "probleme",
      0.005
    ],
    [
      "perplexite",
      0.005
    ],
    [
      "fardeau",
      0.005
    ],
    [
      "emmerdement",
      0.005
    ],
    [
      "cassement",
      0.005
    ],
    [
      "boulet",
      0.005
    ],
    [
      "bile",
      0.005
    ],
    [
      "aria",
      0.005
    ],
    [
      "sueur",
      0.0025
    ],
    [
      "spectre",
      0.0025
    ],
    [
      "sollicitude",
      0.0025
    ],
    [
      "martel",
      0.0025
    ],
    [
      "caillou",
      0.0025
    ],
    [
      "epine",
      0.0025
    ]
  ],
  "ours": [
    [
      "sauvage",
      0.235
    ],
    [
      "solitaire",
      0.115
    ],
    [
      "plantigrade",
      0.0575
    ],
    [
      "nounours",
      0.0575
    ],
    [
      "misanthrope",
      0.0575
    ],
    [
      "menstrues",
      0.0575
    ],
    [
      "loup",
      0.0575
    ],
    [
      "insociable",
      0.0575
    ],
    [
      "grossier",
      0.0575
    ],
    [
      "casanier",
      0.0575
    ],
    [
      "pressier",
      0.0575
    ]
  ],
  "leche": [
    [
      "adulation",
      0.11
    ],
    [
      "flagornerie",
      0.11
    ],
    [
      "languette",
      0.11
    ],
    [
      "liche",
      0.11
    ],
    [
      "lichette",
      0.11
    ],
    [
      "lechement",
      0.11
    ],
    [
      "lechage",
      0.11
    ],
    [
      "servilite",
      0.11
    ],
    [
      "tranche",
      0.11
    ]
  ],
  "lecher": [
    [
      "fignoler",
      0.1525
    ],
    [
      "polir",
      0.1125
    ],
    [
      "ciseler",
      0.1
    ],
    [
      "parfaire",
      0.0875
    ],
    [
      "perler",
      0.0625
    ],
    [
      "soigner",
      0.05
    ],
    [
      "limer",
      0.05
    ],
    [
      "finir",
      0.05
    ],
    [
      "parachever",
      0.0375
    ],
    [
      "travailler",
      0.025
    ],
    [
      "fouiller",
      0.025
    ],
    [
      "caresser",
      0.025
    ],
    [
      "ameliorer",
      0.025
    ],
    [
      "sucer",
      0.0125
    ],
    [
      "pourlecher",
      0.0125
    ],
    [
      "pignocher",
      0.0125
    ],
    [
      "peigner",
      0.0125
    ],
    [
      "lechouiller",
      0.0125
    ],
    [
      "lichotter",
      0.0125
    ],
    [
      "licher",
      0.0125
    ],
    [
      "lichailler",
      0.0125
    ],
    [
      "froler",
      0.0125
    ],
    [
      "flagorner",
      0.0125
    ],
    [
      "effleurer",
      0.0125
    ],
    [
      "blaireauter",
      0.0125
    ],
    [
      "aduler",
      0.0125
    ],
    [
      "terminer",
      0.0125
    ]
  ],
  "banane": [
    [
      "butoir",
      0.2
    ],
    [
      "coiffure",
      0.2
    ],
    [
      "decoration",
      0.2
    ],
    [
      "helicoptere",
      0.2
    ],
    [
      "meche",
      0.2
    ]
  ],
  "astuce": [
    [
      "ruse",
      0.125
    ],
    [
      "truc",
      0.125
    ],
    [
      "artifice",
      0.1225
    ],
    [
      "habilete",
      0.0425
    ],
    [
      "finesse",
      0.035
    ],
    [
      "rouerie",
      0.03
    ],
    [
      "moyen",
      0.025
    ],
    [
      "adresse",
      0.0225
    ],
    [
      "intrigue",
      0.02
    ],
    [
      "intelligence",
      0.0175
    ],
    [
      "matoiserie",
      0.015
    ],
    [
      "stratageme",
      0.015
    ],
    [
      "tromperie",
      0.015
    ],
    [
      "art",
      0.0125
    ],
    [
      "combine",
      0.0125
    ],
    [
      "manege",
      0.0125
    ],
    [
      "subtilite",
      0.0125
    ],
    [
      "subterfuge",
      0.01
    ],
    [
      "piege",
      0.01
    ],
    [
      "finasserie",
      0.01
    ],
    [
      "detour",
      0.01
    ],
    [
      "manoeuvre",
      0.01
    ],
    [
      "machination",
      0.01
    ],
    [
      "machiavelisme",
      0.01
    ],
    [
      "fourberie",
      0.01
    ],
    [
      "ficelle",
      0.01
    ],
    [
      "secret",
      0.0075
    ],
    [
      "roublardise",
      0.0075
    ],
    [
      "penetration",
      0.0075
    ],
    [
      "politique",
      0.0075
    ],
    [
      "plaisanterie",
      0.0075
    ],
    [
      "invention",
      0.0075
    ],
    [
      "ingeniosite",
      0.0075
    ],
    [
      "diplomatie",
      0.0075
    ],
    [
      "trame",
      0.005
    ],
    [
      "systeme",
      0.005
    ],
    [
      "sagacite",
      0.005
    ],
    [
      "ressource",
      0.005
    ],
    [
      "perfidie",
      0.005
    ],
    [
      "malice",
      0.005
    ],
    [
      "feinte",
      0.005
    ],
    [
      "facetie",
      0.005
    ],
    [
      "embuche",
      0.005
    ],
    [
      "dexterite",
      0.005
    ],
    [
      "debrouillardise",
      0.0025
    ],
    [
      "decouverte",
      0.0025
    ],
    [
      "machine",
      0.0025
    ],
    [
      "malignite",
      0.0025
    ],
    [
      "echappatoire",
      0.0025
    ],
    [
      "discernement",
      0.0025
    ],
    [
      "coup",
      0.0025
    ],
    [
      "clairvoyance",
      0.0025
    ],
    [
      "blague",
      0.0025
    ],
    [
      "botte",
      0.0025
    ],
    [
      "carotte",
      0.0025
    ],
    [
      "cautele",
      0.0025
    ],
    [
      "rubrique",
      0.0
    ],
    [
      "rets",
      0.0
    ],
    [
      "retour",
      0.0
    ],
    [
      "meandre",
      0.0
    ],
    [
      "jesuitisme",
      0.0
    ],
    [
      "fraude",
      0.0
    ],
    [
      "chafouinerie",
      0.0
    ],
    [
      "calembour",
      0.0
    ],
    [
      "betise",
      0.0
    ],
    [
      "boutade",
      0.0
    ],
    [
      "trouvaille",
      0.0
    ]
  ],
  "drame": [
    [
      "tragedie",
      0.225
    ],
    [
      "opera",
      0.18
    ],
    [
      "piece",
      0.09
    ],
    [
      "theatre",
      0.045
    ],
    [
      "oratorio",
      0.045
    ],
    [
      "melodrame",
      0.045
    ],
    [
      "dramatique",
      0.045
    ],
    [
      "catastrophe",
      0.045
    ],
    [
      "cantate",
      0.045
    ],
    [
      "accident",
      0.045
    ],
    [
      "evenement",
      0.045
    ]
  ],
  "cactus": [
    [
      "difficulte",
      0.3325
    ],
    [
      "obstacle",
      0.22
    ],
    [
      "cactees",
      0.11
    ],
    [
      "chardon",
      0.11
    ],
    [
      "os",
      0.11
    ],
    [
      "ecueil",
      0.11
    ]
  ],
  "chiper": [
    [
      "derober",
      0.125
    ],
    [
      "prendre",
      0.125
    ],
    [
      "voler",
      0.11
    ],
    [
      "piquer",
      0.095
    ],
    [
      "choper",
      0.0825
    ],
    [
      "faucher",
      0.075
    ],
    [
      "attraper",
      0.0675
    ],
    [
      "barboter",
      0.0325
    ],
    [
      "enlever",
      0.0325
    ],
    [
      "subtiliser",
      0.0275
    ],
    [
      "soustraire",
      0.02
    ],
    [
      "gagner",
      0.02
    ],
    [
      "chauffer",
      0.02
    ],
    [
      "epingler",
      0.0125
    ],
    [
      "souffler",
      0.0125
    ],
    [
      "pincer",
      0.0125
    ],
    [
      "marauder",
      0.0125
    ],
    [
      "kidnapper",
      0.0125
    ],
    [
      "harponner",
      0.0125
    ],
    [
      "faire",
      0.0125
    ],
    [
      "contracter",
      0.0125
    ],
    [
      "chaparder",
      0.0125
    ],
    [
      "agrafer",
      0.0125
    ],
    [
      "raboter",
      0.005
    ],
    [
      "ratiboiser",
      0.005
    ]
  ],
  "epine": [
    [
      "difficulte",
      0.13
    ],
    [
      "aiguille",
      0.085
    ],
    [
      "piquant",
      0.085
    ],
    [
      "tirage",
      0.085
    ],
    [
      "ronce",
      0.0425
    ],
    [
      "souci",
      0.0425
    ],
    [
      "spinelle",
      0.0425
    ],
    [
      "spinule",
      0.0425
    ],
    [
      "tracas",
      0.0425
    ],
    [
      "pointe",
      0.0425
    ],
    [
      "inconvenient",
      0.0425
    ],
    [
      "douleur",
      0.0425
    ],
    [
      "crete",
      0.0425
    ],
    [
      "contrariete",
      0.0425
    ],
    [
      "arete",
      0.0425
    ],
    [
      "apophyse",
      0.0425
    ],
    [
      "aiguillon",
      0.0425
    ],
    [
      "echarde",
      0.0425
    ]
  ],
  "rapine": [
    [
      "exaction",
      0.1175
    ],
    [
      "malversation",
      0.1175
    ],
    [
      "pillage",
      0.1175
    ],
    [
      "concussion",
      0.095
    ],
    [
      "vol",
      0.095
    ],
    [
      "brigandage",
      0.07
    ],
    [
      "prevarication",
      0.0475
    ],
    [
      "enlevement",
      0.0475
    ],
    [
      "depredation",
      0.0475
    ],
    [
      "butin",
      0.0475
    ],
    [
      "ravissement",
      0.0225
    ],
    [
      "rapinerie",
      0.0225
    ],
    [
      "peculat",
      0.0225
    ],
    [
      "piraterie",
      0.0225
    ],
    [
      "maraude",
      0.0225
    ],
    [
      "extorsion",
      0.0225
    ],
    [
      "capture",
      0.0225
    ],
    [
      "razzia",
      0.0225
    ]
  ],
  "beaucoup": [
    [
      "tres",
      0.09
    ],
    [
      "extremement",
      0.0775
    ],
    [
      "bien",
      0.05
    ],
    [
      "bigrement",
      0.0425
    ],
    [
      "fortement",
      0.0325
    ],
    [
      "excessivement",
      0.03
    ],
    [
      "bougrement",
      0.0275
    ],
    [
      "considerablement",
      0.0275
    ],
    [
      "prodigieusement",
      0.0275
    ],
    [
      "enormement",
      0.0275
    ],
    [
      "fort",
      0.025
    ],
    [
      "abondamment",
      0.025
    ],
    [
      "infiniment",
      0.0225
    ],
    [
      "joliment",
      0.0225
    ],
    [
      "extraordinairement",
      0.02
    ],
    [
      "amplement",
      0.0175
    ],
    [
      "vachement",
      0.015
    ],
    [
      "puissamment",
      0.015
    ],
    [
      "terriblement",
      0.0125
    ],
    [
      "intensement",
      0.0125
    ],
    [
      "grandement",
      0.0125
    ],
    [
      "formidablement",
      0.0125
    ],
    [
      "ferme",
      0.0125
    ],
    [
      "diablement",
      0.0125
    ],
    [
      "copieusement",
      0.0125
    ],
    [
      "vivement",
      0.01
    ],
    [
      "trop",
      0.01
    ],
    [
      "serieusement",
      0.01
    ],
    [
      "plusieurs",
      0.01
    ],
    [
      "plein",
      0.01
    ],
    [
      "largement",
      0.01
    ],
    [
      "immensement",
      0.01
    ],
    [
      "violemment",
      0.0075
    ],
    [
      "pleinement",
      0.0075
    ],
    [
      "vigoureusement",
      0.005
    ],
    [
      "salement",
      0.005
    ],
    [
      "passablement",
      0.005
    ],
    [
      "nettement",
      0.005
    ],
    [
      "maint",
      0.005
    ],
    [
      "singulierement",
      0.0025
    ],
    [
      "sacrement",
      0.0025
    ],
    [
      "richement",
      0.0025
    ],
    [
      "longuement",
      0.0025
    ],
    [
      "force",
      0.0025
    ],
    [
      "assez",
      0.0025
    ],
    [
      "quelques",
      0.0
    ],
    [
      "prou",
      0.0
    ],
    [
      "plantureusement",
      0.0
    ],
    [
      "passionnement",
      0.0
    ],
    [
      "nombre",
      0.0
    ],
    [
      "souvent",
      0.0
    ],
    [
      "moult",
      0.0
    ],
    [
      "mortellement",
      0.0
    ],
    [
      "magnifiquement",
      0.0
    ],
    [
      "autrement",
      0.0
    ],
    [
      "besef",
      0.0
    ],
    [
      "certains",
      0.0
    ],
    [
      "frequemment",
      0.0
    ],
    [
      "gros",
      0.0
    ],
    [
      "innombrable",
      0.0
    ],
    [
      "liberalement",
      0.0
    ],
    [
      "longtemps",
      0.0
    ],
    [
      "lourd",
      0.0
    ]
  ],
  "resoudre": [
    [
      "decider",
      0.1
    ],
    [
      "trancher",
      0.1
    ],
    [
      "regler",
      0.0725
    ],
    [
      "arreter",
      0.0525
    ],
    [
      "conclure",
      0.045
    ],
    [
      "dissoudre",
      0.045
    ],
    [
      "determiner",
      0.045
    ],
    [
      "juger",
      0.035
    ],
    [
      "denouer",
      0.035
    ],
    [
      "dechiffrer",
      0.035
    ],
    [
      "annuler",
      0.025
    ],
    [
      "calculer",
      0.025
    ],
    [
      "deviner",
      0.025
    ],
    [
      "demeler",
      0.025
    ],
    [
      "finir",
      0.0175
    ],
    [
      "resilier",
      0.0175
    ],
    [
      "statuer",
      0.0175
    ],
    [
      "trouver",
      0.0175
    ],
    [
      "entrainer",
      0.0175
    ],
    [
      "delier",
      0.0175
    ],
    [
      "deliberer",
      0.0175
    ],
    [
      "decomposer",
      0.0175
    ],
    [
      "debrouiller",
      0.0175
    ],
    [
      "convenir",
      0.0175
    ],
    [
      "analyser",
      0.0175
    ],
    [
      "solutionner",
      0.0075
    ],
    [
      "soudre",
      0.0075
    ],
    [
      "traiter",
      0.0075
    ],
    [
      "resorber",
      0.0075
    ],
    [
      "jurer",
      0.0075
    ],
    [
      "fondre",
      0.0075
    ],
    [
      "amener",
      0.0075
    ],
    [
      "abolir",
      0.0075
    ],
    [
      "vider",
      0.0075
    ]
  ],
  "resolu": [
    [
      "decide",
      0.165
    ],
    [
      "ferme",
      0.0975
    ],
    [
      "determine",
      0.075
    ],
    [
      "energique",
      0.05
    ],
    [
      "courageux",
      0.0425
    ],
    [
      "hardi",
      0.0375
    ],
    [
      "fort",
      0.0325
    ],
    [
      "audacieux",
      0.0275
    ],
    [
      "delibere",
      0.0275
    ],
    [
      "intrepide",
      0.0275
    ],
    [
      "opiniatre",
      0.0275
    ],
    [
      "volontaire",
      0.0275
    ],
    [
      "regle",
      0.0225
    ],
    [
      "robuste",
      0.0225
    ],
    [
      "assure",
      0.0225
    ],
    [
      "vigoureux",
      0.0175
    ],
    [
      "tenace",
      0.0175
    ],
    [
      "prononce",
      0.0175
    ],
    [
      "net",
      0.0175
    ],
    [
      "franc",
      0.0175
    ],
    [
      "arrete",
      0.0175
    ],
    [
      "tranchant",
      0.0125
    ],
    [
      "organise",
      0.0125
    ],
    [
      "ordonne",
      0.0125
    ],
    [
      "decisif",
      0.0125
    ],
    [
      "constant",
      0.0125
    ],
    [
      "brave",
      0.0125
    ],
    [
      "tranche",
      0.0075
    ],
    [
      "obstine",
      0.0075
    ],
    [
      "entendu",
      0.0075
    ],
    [
      "convaincu",
      0.0075
    ],
    [
      "tetu",
      0.0025
    ],
    [
      "pret",
      0.0025
    ],
    [
      "juge",
      0.0025
    ],
    [
      "irrevocable",
      0.0025
    ],
    [
      "fixe",
      0.0025
    ],
    [
      "decrete",
      0.0025
    ],
    [
      "crane",
      0.0025
    ],
    [
      "convenu",
      0.0025
    ],
    [
      "conclu",
      0.0025
    ],
    [
      "choisi",
      0.0025
    ],
    [
      "carre",
      0.0025
    ],
    [
      "vu",
      0.0025
    ]
  ],
  "passe": [
    [
      "tomber",
      0.0225
    ],
    [
      "disparaitre",
      0.0225
    ],
    [
      "aller",
      0.0175
    ],
    [
      "couler",
      0.0175
    ],
    [
      "penetrer",
      0.0175
    ],
    [
      "donner",
      0.015
    ],
    [
      "sortir",
      0.0125
    ],
    [
      "s'evanouir",
      0.0125
    ],
    [
      "s'eteindre",
      0.0125
    ],
    [
      "ceder",
      0.0125
    ],
    [
      "courir",
      0.0125
    ],
    [
      "cesser",
      0.0125
    ],
    [
      "tourner",
      0.0125
    ],
    [
      "marcher",
      0.0125
    ],
    [
      "finir",
      0.0125
    ],
    [
      "depasser",
      0.0125
    ],
    [
      "fuir",
      0.01
    ],
    [
      "s'enfuir",
      0.01
    ],
    [
      "traverser",
      0.01
    ],
    [
      "quitter",
      0.01
    ],
    [
      "laisser",
      0.01
    ],
    [
      "accepter",
      0.01
    ],
    [
      "s'ecouler",
      0.0075
    ],
    [
      "mettre",
      0.0075
    ],
    [
      "introduire",
      0.0075
    ],
    [
      "glisser",
      0.0075
    ],
    [
      "expirer",
      0.0075
    ],
    [
      "transmettre",
      0.0075
    ],
    [
      "tolerer",
      0.0075
    ],
    [
      "s'effacer",
      0.0075
    ],
    [
      "percer",
      0.0075
    ],
    [
      "lacher",
      0.0075
    ],
    [
      "enfoncer",
      0.0075
    ],
    [
      "distancer",
      0.0075
    ],
    [
      "devancer",
      0.0075
    ],
    [
      "appliquer",
      0.0075
    ],
    [
      "tendre",
      0.0075
    ],
    [
      "franchir",
      0.0075
    ],
    [
      "filer",
      0.0075
    ],
    [
      "admettre",
      0.0075
    ],
    [
      "semer",
      0.005
    ],
    [
      "souffrir",
      0.005
    ],
    [
      "supporter",
      0.005
    ],
    [
      "transporter",
      0.005
    ],
    [
      "venir",
      0.005
    ],
    [
      "sauter",
      0.005
    ],
    [
      "changer",
      0.005
    ],
    [
      "descendre",
      0.005
    ],
    [
      "entrer",
      0.005
    ],
    [
      "filtrer",
      0.005
    ],
    [
      "gratter",
      0.005
    ],
    [
      "palir",
      0.005
    ],
    [
      "s'envoler",
      0.005
    ],
    [
      "evoluer",
      0.005
    ],
    [
      "eviter",
      0.005
    ],
    [
      "subir",
      0.005
    ],
    [
      "plonger",
      0.005
    ],
    [
      "permettre",
      0.005
    ],
    [
      "engager",
      0.005
    ],
    [
      "employer",
      0.005
    ],
    [
      "baigner",
      0.005
    ],
    [
      "repandre",
      0.0025
    ],
    [
      "satisfaire",
      0.0025
    ],
    [
      "surpasser",
      0.0025
    ],
    [
      "tuer",
      0.0025
    ],
    [
      "violer",
      0.0025
    ],
    [
      "vivre",
      0.0025
    ],
    [
      "ecarter",
      0.0025
    ],
    [
      "revenir",
      0.0025
    ],
    [
      "remplir",
      0.0025
    ],
    [
      "doubler",
      0.0025
    ],
    [
      "fourrer",
      0.0025
    ],
    [
      "griller",
      0.0025
    ],
    [
      "laver",
      0.0025
    ],
    [
      "oublier",
      0.0025
    ],
    [
      "outrepasser",
      0.0025
    ],
    [
      "pardonner",
      0.0025
    ],
    [
      "pourrir",
      0.0025
    ],
    [
      "remettre",
      0.0025
    ],
    [
      "s'insinuer",
      0.0025
    ],
    [
      "s'infiltrer",
      0.0025
    ],
    [
      "s'engouffrer",
      0.0025
    ],
    [
      "s'achever",
      0.0025
    ],
    [
      "revetir",
      0.0025
    ],
    [
      "ressortir",
      0.0025
    ],
    [
      "rejoindre",
      0.0025
    ],
    [
      "refiler",
      0.0025
    ],
    [
      "eteindre",
      0.0025
    ],
    [
      "etaler",
      0.0025
    ],
    [
      "virer",
      0.0025
    ],
    [
      "transferer",
      0.0025
    ],
    [
      "tamiser",
      0.0025
    ],
    [
      "preceder",
      0.0025
    ],
    [
      "omettre",
      0.0025
    ],
    [
      "couper",
      0.0025
    ],
    [
      "conceder",
      0.0025
    ],
    [
      "communiquer",
      0.0025
    ],
    [
      "circuler",
      0.0025
    ],
    [
      "bruler",
      0.0025
    ],
    [
      "autoriser",
      0.0025
    ],
    [
      "assouvir",
      0.0025
    ],
    [
      "amener",
      0.0025
    ],
    [
      "devenir",
      0.0025
    ],
    [
      "enduire",
      0.0025
    ],
    [
      "occuper",
      0.0025
    ],
    [
      "jouer",
      0.0025
    ],
    [
      "frotter",
      0.0025
    ],
    [
      "faner",
      0.0025
    ],
    [
      "exceder",
      0.0025
    ],
    [
      "excuser",
      0.0025
    ],
    [
      "enjamber",
      0.0025
    ],
    [
      "enfiler",
      0.0025
    ],
    [
      "s'evaporer",
      0.0
    ],
    [
      "s'introduire",
      0.0
    ],
    [
      "s'estomper",
      0.0
    ],
    [
      "s'averer",
      0.0
    ],
    [
      "recevoir",
      0.0
    ],
    [
      "taire",
      0.0
    ],
    [
      "terminer",
      0.0
    ],
    [
      "vaincre",
      0.0
    ],
    [
      "eclairer",
      0.0
    ],
    [
      "eluder",
      0.0
    ],
    [
      "preter",
      0.0
    ],
    [
      "negliger",
      0.0
    ],
    [
      "aigrir",
      0.0
    ],
    [
      "consumer",
      0.0
    ],
    [
      "cribler",
      0.0
    ],
    [
      "croiser",
      0.0
    ],
    [
      "desservir",
      0.0
    ],
    [
      "deambuler",
      0.0
    ],
    [
      "defiler",
      0.0
    ],
    [
      "defleurir",
      0.0
    ],
    [
      "deteindre",
      0.0
    ],
    [
      "endosser",
      0.0
    ],
    [
      "enfreindre",
      0.0
    ],
    [
      "errer",
      0.0
    ],
    [
      "s'eventer",
      0.0
    ],
    [
      "s'eclaircir",
      0.0
    ],
    [
      "s'avarier",
      0.0
    ],
    [
      "s'affadir",
      0.0
    ],
    [
      "surir",
      0.0
    ],
    [
      "ternir",
      0.0
    ],
    [
      "transborder",
      0.0
    ],
    [
      "transfuser",
      0.0
    ],
    [
      "transiter",
      0.0
    ],
    [
      "trepasser",
      0.0
    ],
    [
      "vetir",
      0.0
    ],
    [
      "rallier",
      0.0
    ],
    [
      "poindre",
      0.0
    ],
    [
      "cacher",
      0.0
    ],
    [
      "chancir",
      0.0
    ],
    [
      "conclure",
      0.0
    ],
    [
      "contenter",
      0.0
    ],
    [
      "digerer",
      0.0
    ],
    [
      "enclencher",
      0.0
    ],
    [
      "escalader",
      0.0
    ],
    [
      "essayer",
      0.0
    ],
    [
      "illuminer",
      0.0
    ],
    [
      "imbiber",
      0.0
    ],
    [
      "jaunir",
      0.0
    ],
    [
      "lotionner",
      0.0
    ],
    [
      "leguer",
      0.0
    ],
    [
      "moisir",
      0.0
    ],
    [
      "agoniser",
      0.0
    ]
  ],
  "passer": [
    [
      "tomber",
      0.0225
    ],
    [
      "disparaitre",
      0.0225
    ],
    [
      "aller",
      0.0175
    ],
    [
      "couler",
      0.0175
    ],
    [
      "penetrer",
      0.0175
    ],
    [
      "donner",
      0.015
    ],
    [
      "sortir",
      0.0125
    ],
    [
      "s'evanouir",
      0.0125
    ],
    [
      "s'eteindre",
      0.0125
    ],
    [
      "ceder",
      0.0125
    ],
    [
      "courir",
      0.0125
    ],
    [
      "cesser",
      0.0125
    ],
    [
      "tourner",
      0.0125
    ],
    [
      "marcher",
      0.0125
    ],
    [
      "finir",
      0.0125
    ],
    [
      "depasser",
      0.0125
    ],
    [
      "fuir",
      0.01
    ],
    [
      "s'enfuir",
      0.01
    ],
    [
      "traverser",
      0.01
    ],
    [
      "quitter",
      0.01
    ],
    [
      "laisser",
      0.01
    ],
    [
      "accepter",
      0.01
    ],
    [
      "s'ecouler",
      0.0075
    ],
    [
      "mettre",
      0.0075
    ],
    [
      "introduire",
      0.0075
    ],
    [
      "glisser",
      0.0075
    ],
    [
      "expirer",
      0.0075
    ],
    [
      "transmettre",
      0.0075
    ],
    [
      "tolerer",
      0.0075
    ],
    [
      "s'effacer",
      0.0075
    ],
    [
      "percer",
      0.0075
    ],
    [
      "lacher",
      0.0075
    ],
    [
      "enfoncer",
      0.0075
    ],
    [
      "distancer",
      0.0075
    ],
    [
      "devancer",
      0.0075
    ],
    [
      "appliquer",
      0.0075
    ],
    [
      "tendre",
      0.0075
    ],
    [
      "franchir",
      0.0075
    ],
    [
      "filer",
      0.0075
    ],
    [
      "admettre",
      0.0075
    ],
    [
      "semer",
      0.005
    ],
    [
      "souffrir",
      0.005
    ],
    [
      "supporter",
      0.005
    ],
    [
      "transporter",
      0.005
    ],
    [
      "venir",
      0.005
    ],
    [
      "sauter",
      0.005
    ],
    [
      "changer",
      0.005
    ],
    [
      "descendre",
      0.005
    ],
    [
      "entrer",
      0.005
    ],
    [
      "filtrer",
      0.005
    ],
    [
      "gratter",
      0.005
    ],
    [
      "palir",
      0.005
    ],
    [
      "s'envoler",
      0.005
    ],
    [
      "evoluer",
      0.005
    ],
    [
      "eviter",
      0.005
    ],
    [
      "subir",
      0.005
    ],
    [
      "plonger",
      0.005
    ],
    [
      "permettre",
      0.005
    ],
    [
      "engager",
      0.005
    ],
    [
      "employer",
      0.005
    ],
    [
      "baigner",
      0.005
    ],
    [
      "repandre",
      0.0025
    ],
    [
      "satisfaire",
      0.0025
    ],
    [
      "surpasser",
      0.0025
    ],
    [
      "tuer",
      0.0025
    ],
    [
      "violer",
      0.0025
    ],
    [
      "vivre",
      0.0025
    ],
    [
      "ecarter",
      0.0025
    ],
    [
      "revenir",
      0.0025
    ],
    [
      "remplir",
      0.0025
    ],
    [
      "doubler",
      0.0025
    ],
    [
      "fourrer",
      0.0025
    ],
    [
      "griller",
      0.0025
    ],
    [
      "laver",
      0.0025
    ],
    [
      "oublier",
      0.0025
    ],
    [
      "outrepasser",
      0.0025
    ],
    [
      "pardonner",
      0.0025
    ],
    [
      "pourrir",
      0.0025
    ],
    [
      "remettre",
      0.0025
    ],
    [
      "s'insinuer",
      0.0025
    ],
    [
      "s'infiltrer",
      0.0025
    ],
    [
      "s'engouffrer",
      0.0025
    ],
    [
      "s'achever",
      0.0025
    ],
    [
      "revetir",
      0.0025
    ],
    [
      "ressortir",
      0.0025
    ],
    [
      "rejoindre",
      0.0025
    ],
    [
      "refiler",
      0.0025
    ],
    [
      "eteindre",
      0.0025
    ],
    [
      "etaler",
      0.0025
    ],
    [
      "virer",
      0.0025
    ],
    [
      "transferer",
      0.0025
    ],
    [
      "tamiser",
      0.0025
    ],
    [
      "preceder",
      0.0025
    ],
    [
      "omettre",
      0.0025
    ],
    [
      "couper",
      0.0025
    ],
    [
      "conceder",
      0.0025
    ],
    [
      "communiquer",
      0.0025
    ],
    [
      "circuler",
      0.0025
    ],
    [
      "bruler",
      0.0025
    ],
    [
      "autoriser",
      0.0025
    ],
    [
      "assouvir",
      0.0025
    ],
    [
      "amener",
      0.0025
    ],
    [
      "devenir",
      0.0025
    ],
    [
      "enduire",
      0.0025
    ],
    [
      "occuper",
      0.0025
    ],
    [
      "jouer",
      0.0025
    ],
    [
      "frotter",
      0.0025
    ],
    [
      "faner",
      0.0025
    ],
    [
      "exceder",
      0.0025
    ],
    [
      "excuser",
      0.0025
    ],
    [
      "enjamber",
      0.0025
    ],
    [
      "enfiler",
      0.0025
    ],
    [
      "s'evaporer",
      0.0
    ],
    [
      "s'introduire",
      0.0
    ],
    [
      "s'estomper",
      0.0
    ],
    [
      "s'averer",
      0.0
    ],
    [
      "recevoir",
      0.0
    ],
    [
      "taire",
      0.0
    ],
    [
      "terminer",
      0.0
    ],
    [
      "vaincre",
      0.0
    ],
    [
      "eclairer",
      0.0
    ],
    [
      "eluder",
      0.0
    ],
    [
      "preter",
      0.0
    ],
    [
      "negliger",
      0.0
    ],
    [
      "aigrir",
      0.0
    ],
    [
      "consumer",
      0.0
    ],
    [
      "cribler",
      0.0
    ],
    [
      "croiser",
      0.0
    ],
    [
      "desservir",
      0.0
    ],
    [
      "deambuler",
      0.0
    ],
    [
      "defiler",
      0.0
    ],
    [
      "defleurir",
      0.0
    ],
    [
      "deteindre",
      0.0
    ],
    [
      "endosser",
      0.0
    ],
    [
      "enfreindre",
      0.0
    ],
    [
      "errer",
      0.0
    ],
    [
      "s'eventer",
      0.0
    ],
    [
      "s'eclaircir",
      0.0
    ],
    [
      "s'avarier",
      0.0
    ],
    [
      "s'affadir",
      0.0
    ],
    [
      "surir",
      0.0
    ],
    [
      "ternir",
      0.0
    ],
    [
      "transborder",
      0.0
    ],
    [
      "transfuser",
      0.0
    ],
    [
      "transiter",
      0.0
    ],
    [
      "trepasser",
      0.0
    ],
    [
      "vetir",
      0.0
    ],
    [
      "rallier",
      0.0
    ],
    [
      "poindre",
      0.0
    ],
    [
      "cacher",
      0.0
    ],
    [
      "chancir",
      0.0
    ],
    [
      "conclure",
      0.0
    ],
    [
      "contenter",
      0.0
    ],
    [
      "digerer",
      0.0
    ],
    [
      "enclencher",
      0.0
    ],
    [
      "escalader",
      0.0
    ],
    [
      "essayer",
      0.0
    ],
    [
      "illuminer",
      0.0
    ],
    [
      "imbiber",
      0.0
    ],
    [
      "jaunir",
      0.0
    ],
    [
      "lotionner",
      0.0
    ],
    [
      "leguer",
      0.0
    ],
    [
      "moisir",
      0.0
    ],
    [
      "agoniser",
      0.0
    ]
  ],
  "superflu": [
    [
      "inutile",
      0.125
    ],
    [
      "accessoire",
      0.0925
    ],
    [
      "superfetatoire",
      0.0925
    ],
    [
      "oiseux",
      0.06
    ],
    [
      "excedent",
      0.06
    ],
    [
      "exces",
      0.06
    ],
    [
      "excessif",
      0.06
    ],
    [
      "vain",
      0.03
    ],
    [
      "surplus",
      0.03
    ],
    [
      "surabondant",
      0.03
    ],
    [
      "redondant",
      0.03
    ],
    [
      "profusion",
      0.03
    ],
    [
      "parasite",
      0.03
    ],
    [
      "luxe",
      0.03
    ],
    [
      "expletif",
      0.03
    ],
    [
      "exagere",
      0.03
    ],
    [
      "agrement",
      0.03
    ]
  ],
  "air": [
    [
      "allure",
      0.07
    ],
    [
      "exterieur",
      0.0625
    ],
    [
      "figure",
      0.06
    ],
    [
      "tournure",
      0.0525
    ],
    [
      "visage",
      0.0525
    ],
    [
      "apparence",
      0.0425
    ],
    [
      "attitude",
      0.0425
    ],
    [
      "aspect",
      0.04
    ],
    [
      "maintien",
      0.035
    ],
    [
      "genre",
      0.035
    ],
    [
      "mine",
      0.03
    ],
    [
      "physionomie",
      0.0275
    ],
    [
      "contenance",
      0.0275
    ],
    [
      "expression",
      0.0225
    ],
    [
      "dehors",
      0.0225
    ],
    [
      "tenue",
      0.02
    ],
    [
      "caractere",
      0.015
    ],
    [
      "demarche",
      0.015
    ],
    [
      "facon",
      0.015
    ],
    [
      "comportement",
      0.015
    ],
    [
      "forme",
      0.0125
    ],
    [
      "port",
      0.0125
    ],
    [
      "trait",
      0.0125
    ],
    [
      "affectation",
      0.01
    ],
    [
      "degaine",
      0.01
    ],
    [
      "masque",
      0.01
    ],
    [
      "touche",
      0.0075
    ],
    [
      "atmosphere",
      0.0075
    ],
    [
      "semblance",
      0.0075
    ],
    [
      "chant",
      0.005
    ],
    [
      "manieres",
      0.005
    ],
    [
      "souffle",
      0.005
    ],
    [
      "vent",
      0.005
    ],
    [
      "temps",
      0.005
    ],
    [
      "prestance",
      0.005
    ],
    [
      "influence",
      0.005
    ],
    [
      "espace",
      0.005
    ],
    [
      "ciel",
      0.005
    ],
    [
      "binette",
      0.005
    ],
    [
      "bille",
      0.005
    ],
    [
      "ether",
      0.0025
    ],
    [
      "ame",
      0.0025
    ],
    [
      "ton",
      0.0025
    ],
    [
      "simulacre",
      0.0025
    ],
    [
      "representation",
      0.0025
    ],
    [
      "melodie",
      0.0025
    ],
    [
      "front",
      0.0025
    ],
    [
      "facade",
      0.0025
    ],
    [
      "facies",
      0.0025
    ],
    [
      "climat",
      0.0025
    ],
    [
      "gueule",
      0.0025
    ],
    [
      "milieu",
      0.0025
    ],
    [
      "refrain",
      0.0025
    ],
    [
      "singerie",
      0.0025
    ],
    [
      "embarras",
      0.0025
    ],
    [
      "chanson",
      0.0025
    ],
    [
      "bouille",
      0.0025
    ],
    [
      "bouffee",
      0.0025
    ],
    [
      "aria",
      0.0025
    ],
    [
      "hymne",
      0.0
    ],
    [
      "impression",
      0.0
    ],
    [
      "oxygene",
      0.0
    ],
    [
      "ressemblance",
      0.0
    ],
    [
      "temperature",
      0.0
    ],
    [
      "theme",
      0.0
    ],
    [
      "grace",
      0.0
    ],
    [
      "emphase",
      0.0
    ],
    [
      "couplet",
      0.0
    ],
    [
      "composition",
      0.0
    ],
    [
      "cavatine",
      0.0
    ],
    [
      "brise",
      0.0
    ],
    [
      "bise",
      0.0
    ],
    [
      "azur",
      0.0
    ],
    [
      "ariette",
      0.0
    ],
    [
      "transport",
      0.0
    ]
  ],
  "guitare": [
    [
      "luth",
      0.085
    ],
    [
      "lyre",
      0.085
    ],
    [
      "mandoline",
      0.085
    ],
    [
      "refrain",
      0.085
    ],
    [
      "guimbarde",
      0.0425
    ],
    [
      "guimbri",
      0.0425
    ],
    [
      "guiterne",
      0.0425
    ],
    [
      "guzla",
      0.0425
    ],
    [
      "rengaine",
      0.0425
    ],
    [
      "turlurette",
      0.0425
    ],
    [
      "gratte",
      0.0425
    ],
    [
      "disque",
      0.0425
    ],
    [
      "cithare",
      0.0425
    ],
    [
      "chanson",
      0.0425
    ],
    [
      "basse",
      0.0425
    ],
    [
      "banjo",
      0.0425
    ],
    [
      "balalaika",
      0.0425
    ],
    [
      "antienne",
      0.0425
    ],
    [
      "ukulele",
      0.0425
    ]
  ],
  "bouger": [
    [
      "remuer",
      0.2
    ],
    [
      "voyager",
      0.06
    ],
    [
      "s'agiter",
      0.06
    ],
    [
      "changer",
      0.06
    ],
    [
      "broncher",
      0.06
    ],
    [
      "partir",
      0.0375
    ],
    [
      "mouvoir",
      0.0375
    ],
    [
      "gigoter",
      0.0375
    ],
    [
      "deplacer",
      0.0375
    ],
    [
      "agiter",
      0.0375
    ],
    [
      "branler",
      0.0175
    ],
    [
      "ciller",
      0.0175
    ],
    [
      "deranger",
      0.0175
    ],
    [
      "lever",
      0.0175
    ]
  ],
  "bouge": [
    [
      "taudis",
      0.14
    ],
    [
      "bousin",
      0.0875
    ],
    [
      "cabaret",
      0.075
    ],
    [
      "bauge",
      0.0625
    ],
    [
      "bordel",
      0.0625
    ],
    [
      "cambuse",
      0.05
    ],
    [
      "reduit",
      0.0375
    ],
    [
      "maison",
      0.0375
    ],
    [
      "galetas",
      0.0375
    ],
    [
      "beuglant",
      0.0375
    ],
    [
      "taniere",
      0.0225
    ],
    [
      "gite",
      0.0225
    ],
    [
      "gargote",
      0.0225
    ],
    [
      "chenil",
      0.0225
    ],
    [
      "bastringue",
      0.0225
    ],
    [
      "appartement",
      0.0225
    ],
    [
      "tonture",
      0.01
    ],
    [
      "tonneau",
      0.01
    ],
    [
      "repaire",
      0.01
    ],
    [
      "renflement",
      0.01
    ],
    [
      "convexite",
      0.01
    ],
    [
      "cabinet",
      0.01
    ],
    [
      "boxon",
      0.01
    ],
    [
      "bousingot",
      0.01
    ],
    [
      "bouic",
      0.01
    ],
    [
      "bombement",
      0.01
    ],
    [
      "tripot",
      0.01
    ]
  ],
  "cheveu": [
    [
      "difficulte",
      0.165
    ],
    [
      "obstacle",
      0.165
    ],
    [
      "persil",
      0.165
    ],
    [
      "poil",
      0.165
    ],
    [
      "tif",
      0.165
    ],
    [
      "tirage",
      0.165
    ]
  ],
  "noir": [
    [
      "sombre",
      0.125
    ],
    [
      "hale",
      0.1
    ],
    [
      "noiratre",
      0.1
    ],
    [
      "enfume",
      0.075
    ],
    [
      "fuligineux",
      0.075
    ],
    [
      "inquiet",
      0.05
    ],
    [
      "brun",
      0.05
    ],
    [
      "bronze",
      0.05
    ],
    [
      "basane",
      0.05
    ],
    [
      "preoccupe",
      0.0225
    ],
    [
      "nuit",
      0.0225
    ],
    [
      "gris",
      0.0225
    ],
    [
      "funebre",
      0.0225
    ],
    [
      "fume",
      0.0225
    ],
    [
      "couvert",
      0.0225
    ],
    [
      "charbonne",
      0.0225
    ],
    [
      "charbon",
      0.0225
    ],
    [
      "cafe",
      0.0225
    ],
    [
      "brule",
      0.0225
    ],
    [
      "assombri",
      0.0225
    ],
    [
      "africain",
      0.0225
    ],
    [
      "sable",
      0.0225
    ]
  ],
  "levre": [
    [
      "babine",
      0.285
    ],
    [
      "badigoince",
      0.1425
    ],
    [
      "bord",
      0.1425
    ],
    [
      "bouche",
      0.1425
    ],
    [
      "labre",
      0.1425
    ],
    [
      "lippe",
      0.1425
    ]
  ],
  "rouge": [
    [
      "grenat",
      0.065
    ],
    [
      "cramoisi",
      0.04
    ],
    [
      "empourpre",
      0.04
    ],
    [
      "pourpre",
      0.04
    ],
    [
      "rougeaud",
      0.04
    ],
    [
      "rutilant",
      0.04
    ],
    [
      "ecarlate",
      0.0325
    ],
    [
      "roux",
      0.0325
    ],
    [
      "orange",
      0.0325
    ],
    [
      "vermillon",
      0.0225
    ],
    [
      "vermeil",
      0.0225
    ],
    [
      "rubicond",
      0.0225
    ],
    [
      "rougeur",
      0.0225
    ],
    [
      "purpurin",
      0.0225
    ],
    [
      "carmine",
      0.0225
    ],
    [
      "erubescent",
      0.015
    ],
    [
      "vin",
      0.015
    ],
    [
      "sanguin",
      0.015
    ],
    [
      "rouquin",
      0.015
    ],
    [
      "rougeoyant",
      0.015
    ],
    [
      "rose",
      0.015
    ],
    [
      "pourpre",
      0.015
    ],
    [
      "ponceau",
      0.015
    ],
    [
      "bolchevik",
      0.015
    ],
    [
      "congestionne",
      0.015
    ],
    [
      "enflamme",
      0.015
    ],
    [
      "garance",
      0.015
    ],
    [
      "incarnat",
      0.015
    ],
    [
      "purpurace",
      0.005
    ],
    [
      "nacarat",
      0.005
    ],
    [
      "incarnadin",
      0.005
    ],
    [
      "incandescent",
      0.005
    ],
    [
      "geranium",
      0.005
    ],
    [
      "gueules",
      0.005
    ],
    [
      "groseille",
      0.005
    ],
    [
      "rubescent",
      0.005
    ],
    [
      "rubis",
      0.005
    ],
    [
      "ecrevisse",
      0.005
    ],
    [
      "vultueux",
      0.005
    ],
    [
      "vineux",
      0.005
    ],
    [
      "tomate",
      0.005
    ],
    [
      "sanglant",
      0.005
    ],
    [
      "sang",
      0.005
    ],
    [
      "safrane",
      0.005
    ],
    [
      "revolutionnaire",
      0.005
    ],
    [
      "fraise",
      0.005
    ],
    [
      "flamboyant",
      0.005
    ],
    [
      "feu",
      0.005
    ],
    [
      "andrinople",
      0.005
    ],
    [
      "bordeaux",
      0.005
    ],
    [
      "brique",
      0.005
    ],
    [
      "capucine",
      0.005
    ],
    [
      "carmin",
      0.005
    ],
    [
      "carotte",
      0.005
    ],
    [
      "cerise",
      0.005
    ],
    [
      "cinabre",
      0.005
    ],
    [
      "colore",
      0.005
    ],
    [
      "communiste",
      0.005
    ],
    [
      "coquelicot",
      0.005
    ],
    [
      "corail",
      0.005
    ],
    [
      "corallin",
      0.005
    ],
    [
      "couperose",
      0.005
    ],
    [
      "cuivre",
      0.005
    ],
    [
      "enfievre",
      0.005
    ],
    [
      "fard",
      0.005
    ],
    [
      "amarante",
      0.005
    ]
  ],
  "balance": [
    [
      "filet",
      0.0925
    ],
    [
      "compte",
      0.0725
    ],
    [
      "bascule",
      0.055
    ],
    [
      "donneur",
      0.055
    ],
    [
      "solde",
      0.035
    ],
    [
      "romaine",
      0.035
    ],
    [
      "jugement",
      0.035
    ],
    [
      "comptabilite",
      0.035
    ],
    [
      "bilan",
      0.035
    ],
    [
      "balancement",
      0.035
    ],
    [
      "poche",
      0.0175
    ],
    [
      "pochette",
      0.0175
    ],
    [
      "ponderation",
      0.0175
    ],
    [
      "pechette",
      0.0175
    ],
    [
      "salope",
      0.0175
    ],
    [
      "suspension",
      0.0175
    ],
    [
      "truble",
      0.0175
    ],
    [
      "trebuchet",
      0.0175
    ],
    [
      "peson",
      0.0175
    ],
    [
      "pesette",
      0.0175
    ],
    [
      "microbalance",
      0.0175
    ],
    [
      "ajustoir",
      0.0175
    ],
    [
      "appreciation",
      0.0175
    ],
    [
      "baroscope",
      0.0175
    ],
    [
      "bourraque",
      0.0175
    ],
    [
      "budget",
      0.0175
    ],
    [
      "caudrette",
      0.0175
    ],
    [
      "cerceau",
      0.0175
    ],
    [
      "comparaison",
      0.0175
    ],
    [
      "compensation",
      0.0175
    ],
    [
      "difference",
      0.0175
    ],
    [
      "denonciateur",
      0.0175
    ],
    [
      "grilleur",
      0.0175
    ],
    [
      "equilibre",
      0.0175
    ]
  ],
  "balancer": [
    [
      "remuer",
      0.0625
    ],
    [
      "renvoyer",
      0.045
    ],
    [
      "osciller",
      0.04
    ],
    [
      "chasser",
      0.03
    ],
    [
      "tanguer",
      0.03
    ],
    [
      "vider",
      0.03
    ],
    [
      "agiter",
      0.0275
    ],
    [
      "congedier",
      0.0275
    ],
    [
      "lancer",
      0.025
    ],
    [
      "jeter",
      0.025
    ],
    [
      "hesiter",
      0.025
    ],
    [
      "balayer",
      0.02
    ],
    [
      "branler",
      0.02
    ],
    [
      "dodeliner",
      0.02
    ],
    [
      "rejeter",
      0.02
    ],
    [
      "ballotter",
      0.0175
    ],
    [
      "abandonner",
      0.0175
    ],
    [
      "tergiverser",
      0.015
    ],
    [
      "secouer",
      0.015
    ],
    [
      "remercier",
      0.015
    ],
    [
      "larguer",
      0.015
    ],
    [
      "flotter",
      0.015
    ],
    [
      "vaciller",
      0.0125
    ],
    [
      "rouler",
      0.0125
    ],
    [
      "mouvoir",
      0.0125
    ],
    [
      "expulser",
      0.0125
    ],
    [
      "examiner",
      0.0125
    ],
    [
      "compenser",
      0.0125
    ],
    [
      "brimbaler",
      0.0125
    ],
    [
      "brandiller",
      0.0125
    ],
    [
      "bazarder",
      0.0125
    ],
    [
      "onduler",
      0.0075
    ],
    [
      "tortiller",
      0.0075
    ],
    [
      "virer",
      0.0075
    ],
    [
      "equilibrer",
      0.0075
    ],
    [
      "flanquer",
      0.0075
    ],
    [
      "envoyer",
      0.0075
    ],
    [
      "donner",
      0.0075
    ],
    [
      "dire",
      0.0075
    ],
    [
      "danser",
      0.0075
    ],
    [
      "bercer",
      0.0075
    ],
    [
      "baller",
      0.0075
    ],
    [
      "neutraliser",
      0.005
    ],
    [
      "opposer",
      0.005
    ],
    [
      "peser",
      0.005
    ],
    [
      "saquer",
      0.005
    ],
    [
      "tituber",
      0.005
    ],
    [
      "tromper",
      0.005
    ],
    [
      "ebranler",
      0.005
    ],
    [
      "lourder",
      0.005
    ],
    [
      "ficher",
      0.005
    ],
    [
      "balanstiquer",
      0.005
    ],
    [
      "barguigner",
      0.005
    ],
    [
      "comparer",
      0.005
    ],
    [
      "consulter",
      0.005
    ],
    [
      "contrebalancer",
      0.005
    ],
    [
      "couvrir",
      0.005
    ],
    [
      "debarquer",
      0.005
    ],
    [
      "plaquer",
      0.0025
    ],
    [
      "reconduire",
      0.0025
    ],
    [
      "sabrer",
      0.0025
    ],
    [
      "solder",
      0.0025
    ],
    [
      "swinguer",
      0.0025
    ],
    [
      "valser",
      0.0025
    ],
    [
      "egaler",
      0.0025
    ],
    [
      "egaliser",
      0.0025
    ],
    [
      "brandir",
      0.0025
    ],
    [
      "bringuebaler",
      0.0025
    ],
    [
      "considerer",
      0.0025
    ],
    [
      "corriger",
      0.0025
    ],
    [
      "dandiner",
      0.0025
    ],
    [
      "dodiner",
      0.0025
    ],
    [
      "douter",
      0.0025
    ],
    [
      "denoncer",
      0.0025
    ]
  ],
  "rester": [
    [
      "demeurer",
      0.125
    ],
    [
      "subsister",
      0.1125
    ],
    [
      "durer",
      0.0725
    ],
    [
      "trainer",
      0.0725
    ],
    [
      "s'eterniser",
      0.0625
    ],
    [
      "continuer",
      0.055
    ],
    [
      "tenir",
      0.05
    ],
    [
      "sejourner",
      0.04
    ],
    [
      "persister",
      0.0275
    ],
    [
      "survivre",
      0.0275
    ],
    [
      "vivre",
      0.0275
    ],
    [
      "s'attarder",
      0.0225
    ],
    [
      "surnager",
      0.015
    ],
    [
      "moisir",
      0.015
    ],
    [
      "habiter",
      0.015
    ],
    [
      "garder",
      0.015
    ],
    [
      "croupir",
      0.015
    ],
    [
      "conserver",
      0.015
    ],
    [
      "attendre",
      0.015
    ],
    [
      "s'enfermer",
      0.01
    ],
    [
      "resider",
      0.01
    ],
    [
      "posseder",
      0.01
    ],
    [
      "loger",
      0.01
    ],
    [
      "lambiner",
      0.01
    ],
    [
      "detenir",
      0.01
    ],
    [
      "stationner",
      0.005
    ],
    [
      "stagner",
      0.005
    ],
    [
      "s'enteter",
      0.005
    ],
    [
      "s'arreter",
      0.005
    ],
    [
      "avoir",
      0.005
    ],
    [
      "trainasser",
      0.005
    ]
  ],
  "reste": [
    [
      "debris",
      0.125
    ],
    [
      "reliquat",
      0.0475
    ],
    [
      "residu",
      0.0475
    ],
    [
      "vestige",
      0.0475
    ],
    [
      "excedent",
      0.0375
    ],
    [
      "ruine",
      0.0275
    ],
    [
      "resultat",
      0.0275
    ],
    [
      "souvenir",
      0.0275
    ],
    [
      "suite",
      0.0275
    ],
    [
      "rognure",
      0.0275
    ],
    [
      "restant",
      0.0275
    ],
    [
      "marque",
      0.0275
    ],
    [
      "complement",
      0.0275
    ],
    [
      "cendre",
      0.0275
    ],
    [
      "benefice",
      0.0275
    ],
    [
      "bribe",
      0.0275
    ],
    [
      "relief",
      0.0175
    ],
    [
      "rogaton",
      0.0175
    ],
    [
      "solde",
      0.0175
    ],
    [
      "surplus",
      0.0175
    ],
    [
      "survivance",
      0.0175
    ],
    [
      "trace",
      0.0175
    ],
    [
      "epave",
      0.0175
    ],
    [
      "rebut",
      0.0175
    ],
    [
      "poussiere",
      0.0175
    ],
    [
      "boni",
      0.0175
    ],
    [
      "difference",
      0.0175
    ],
    [
      "depouille",
      0.0175
    ],
    [
      "detritus",
      0.0175
    ],
    [
      "exces",
      0.0175
    ],
    [
      "fragment",
      0.0175
    ],
    [
      "os",
      0.0175
    ],
    [
      "signe",
      0.0075
    ],
    [
      "relent",
      0.0075
    ],
    [
      "decharge",
      0.0075
    ],
    [
      "deblai",
      0.0075
    ],
    [
      "desserte",
      0.0075
    ],
    [
      "autre",
      0.0075
    ],
    [
      "soulte",
      0.0075
    ]
  ],
  "importance": [
    [
      "poids",
      0.0775
    ],
    [
      "force",
      0.065
    ],
    [
      "grandeur",
      0.065
    ],
    [
      "influence",
      0.065
    ],
    [
      "portee",
      0.065
    ],
    [
      "dimension",
      0.0525
    ],
    [
      "etendue",
      0.0375
    ],
    [
      "valeur",
      0.0375
    ],
    [
      "superbe",
      0.0375
    ],
    [
      "puissance",
      0.0375
    ],
    [
      "orgueil",
      0.0375
    ],
    [
      "credit",
      0.0375
    ],
    [
      "vanite",
      0.025
    ],
    [
      "suffisance",
      0.025
    ],
    [
      "profondeur",
      0.025
    ],
    [
      "prestige",
      0.025
    ],
    [
      "outrecuidance",
      0.025
    ],
    [
      "gravite",
      0.025
    ],
    [
      "fatuite",
      0.025
    ],
    [
      "extension",
      0.025
    ],
    [
      "consideration",
      0.025
    ],
    [
      "ascendant",
      0.025
    ],
    [
      "ostentation",
      0.0125
    ],
    [
      "necessite",
      0.0125
    ],
    [
      "interet",
      0.0125
    ],
    [
      "format",
      0.0125
    ],
    [
      "essor",
      0.0125
    ],
    [
      "consequence",
      0.0125
    ],
    [
      "arrogance",
      0.0125
    ],
    [
      "taille",
      0.0125
    ]
  ],
  "bruler": [
    [
      "consumer",
      0.075
    ],
    [
      "embraser",
      0.055
    ],
    [
      "griller",
      0.0525
    ],
    [
      "enflammer",
      0.0475
    ],
    [
      "devorer",
      0.0375
    ],
    [
      "calciner",
      0.0375
    ],
    [
      "detruire",
      0.035
    ],
    [
      "piquer",
      0.03
    ],
    [
      "prendre",
      0.03
    ],
    [
      "manger",
      0.025
    ],
    [
      "flamber",
      0.025
    ],
    [
      "exciter",
      0.025
    ],
    [
      "dessecher",
      0.025
    ],
    [
      "chauffer",
      0.025
    ],
    [
      "cuire",
      0.02
    ],
    [
      "ronger",
      0.02
    ],
    [
      "rotir",
      0.02
    ],
    [
      "incendier",
      0.0175
    ],
    [
      "faire",
      0.0175
    ],
    [
      "donner",
      0.0175
    ],
    [
      "carboniser",
      0.0175
    ],
    [
      "boucaner",
      0.0175
    ],
    [
      "attiser",
      0.0175
    ],
    [
      "passer",
      0.0125
    ],
    [
      "cramer",
      0.0125
    ],
    [
      "consommer",
      0.0125
    ],
    [
      "allumer",
      0.0125
    ],
    [
      "miner",
      0.0075
    ],
    [
      "ravager",
      0.0075
    ],
    [
      "riffauder",
      0.0075
    ],
    [
      "s'embraser",
      0.0075
    ],
    [
      "tanner",
      0.0075
    ],
    [
      "trahir",
      0.0075
    ],
    [
      "livrer",
      0.0075
    ],
    [
      "irriter",
      0.0075
    ],
    [
      "corroder",
      0.0075
    ],
    [
      "discrediter",
      0.0075
    ],
    [
      "denoncer",
      0.0075
    ],
    [
      "enfievrer",
      0.0075
    ],
    [
      "flamboyer",
      0.0075
    ],
    [
      "fumer",
      0.0075
    ],
    [
      "haler",
      0.0075
    ],
    [
      "passionner",
      0.0025
    ],
    [
      "pincer",
      0.0025
    ],
    [
      "rougeoyer",
      0.0025
    ],
    [
      "roussir",
      0.0025
    ],
    [
      "roustir",
      0.0025
    ],
    [
      "rutiler",
      0.0025
    ],
    [
      "s'enflammer",
      0.0025
    ],
    [
      "incinerer",
      0.0025
    ],
    [
      "gresiller",
      0.0025
    ],
    [
      "fondre",
      0.0025
    ],
    [
      "arder",
      0.0025
    ],
    [
      "ardre",
      0.0025
    ],
    [
      "blesser",
      0.0025
    ],
    [
      "brouir",
      0.0025
    ],
    [
      "cauteriser",
      0.0025
    ],
    [
      "charbonner",
      0.0025
    ],
    [
      "convoiter",
      0.0025
    ],
    [
      "couver",
      0.0025
    ],
    [
      "culotter",
      0.0025
    ],
    [
      "demasquer",
      0.0025
    ],
    [
      "torrefier",
      0.0025
    ]
  ],
  "reveiller": [
    [
      "ranimer",
      0.18
    ],
    [
      "exciter",
      0.0875
    ],
    [
      "exalter",
      0.07
    ],
    [
      "raviver",
      0.06
    ],
    [
      "revivifier",
      0.06
    ],
    [
      "stimuler",
      0.055
    ],
    [
      "rechauffer",
      0.045
    ],
    [
      "reconforter",
      0.045
    ],
    [
      "vivifier",
      0.04
    ],
    [
      "attiser",
      0.03
    ],
    [
      "aviver",
      0.03
    ],
    [
      "ressusciter",
      0.03
    ],
    [
      "revigorer",
      0.03
    ],
    [
      "retremper",
      0.025
    ],
    [
      "soutenir",
      0.025
    ],
    [
      "eveiller",
      0.02
    ],
    [
      "rehausser",
      0.0125
    ],
    [
      "rallumer",
      0.0125
    ],
    [
      "evoquer",
      0.0075
    ],
    [
      "soulever",
      0.0075
    ],
    [
      "renouveler",
      0.0075
    ],
    [
      "rappeler",
      0.0075
    ],
    [
      "galvaniser",
      0.0075
    ],
    [
      "exhumer",
      0.0075
    ],
    [
      "degourdir",
      0.0075
    ],
    [
      "secouer",
      0.0025
    ],
    [
      "reactiver",
      0.0025
    ],
    [
      "revitaliser",
      0.0025
    ],
    [
      "rafraichir",
      0.0025
    ],
    [
      "inquieter",
      0.0025
    ],
    [
      "desengourdir",
      0.0025
    ],
    [
      "derouiller",
      0.0025
    ],
    [
      "degeler",
      0.0025
    ],
    [
      "emoustiller",
      0.0025
    ]
  ],
  "sud": [
    [
      "austral",
      0.4
    ],
    [
      "antarctique",
      0.2
    ],
    [
      "midi",
      0.2
    ],
    [
      "meridional",
      0.2
    ]
  ],
  "feu": [
    [
      "ardeur",
      0.095
    ],
    [
      "chaleur",
      0.0825
    ],
    [
      "bouillonnement",
      0.0575
    ],
    [
      "flamme",
      0.0475
    ],
    [
      "exaltation",
      0.0375
    ],
    [
      "passion",
      0.0375
    ],
    [
      "fougue",
      0.03
    ],
    [
      "vehemence",
      0.0275
    ],
    [
      "enthousiasme",
      0.0275
    ],
    [
      "emportement",
      0.025
    ],
    [
      "animation",
      0.0225
    ],
    [
      "elan",
      0.0225
    ],
    [
      "impetuosite",
      0.0175
    ],
    [
      "vivacite",
      0.015
    ],
    [
      "excitation",
      0.015
    ],
    [
      "lumiere",
      0.015
    ],
    [
      "agitation",
      0.01
    ],
    [
      "brulure",
      0.01
    ],
    [
      "incendie",
      0.01
    ],
    [
      "eclat",
      0.01
    ],
    [
      "violence",
      0.01
    ],
    [
      "fievre",
      0.01
    ],
    [
      "fanatisme",
      0.01
    ],
    [
      "colere",
      0.01
    ],
    [
      "brasier",
      0.01
    ],
    [
      "action",
      0.01
    ],
    [
      "phare",
      0.0075
    ],
    [
      "irritation",
      0.0075
    ],
    [
      "combustion",
      0.0075
    ],
    [
      "amour",
      0.0075
    ],
    [
      "emballement",
      0.0075
    ],
    [
      "embrasement",
      0.0075
    ],
    [
      "petulance",
      0.0075
    ],
    [
      "force",
      0.005
    ],
    [
      "foyer",
      0.005
    ],
    [
      "inflammation",
      0.005
    ],
    [
      "etincelle",
      0.005
    ],
    [
      "flamboiement",
      0.005
    ],
    [
      "flambeau",
      0.005
    ],
    [
      "explosion",
      0.005
    ],
    [
      "empressement",
      0.005
    ],
    [
      "desir",
      0.005
    ],
    [
      "conflagration",
      0.005
    ],
    [
      "guerre",
      0.0025
    ],
    [
      "incandescence",
      0.0025
    ],
    [
      "lampe",
      0.0025
    ],
    [
      "lanterne",
      0.0025
    ],
    [
      "orage",
      0.0025
    ],
    [
      "ame",
      0.0025
    ],
    [
      "eruption",
      0.0025
    ],
    [
      "foudre",
      0.0025
    ],
    [
      "entrainement",
      0.0025
    ],
    [
      "entrain",
      0.0025
    ],
    [
      "balise",
      0.0025
    ],
    [
      "brandon",
      0.0025
    ],
    [
      "brillant",
      0.0025
    ],
    [
      "brulement",
      0.0025
    ],
    [
      "bucher",
      0.0025
    ],
    [
      "combat",
      0.0025
    ],
    [
      "decharge",
      0.0025
    ],
    [
      "demangeaison",
      0.0025
    ],
    [
      "prurit",
      0.0025
    ],
    [
      "petard",
      0.0025
    ],
    [
      "revolver",
      0.0025
    ],
    [
      "rougeur",
      0.0025
    ],
    [
      "revolte",
      0.0025
    ],
    [
      "revolution",
      0.0025
    ],
    [
      "signal",
      0.0025
    ],
    [
      "signalisation",
      0.0025
    ],
    [
      "tonnerre",
      0.0025
    ],
    [
      "echauffement",
      0.0025
    ],
    [
      "eclairage",
      0.0025
    ],
    [
      "pistolet",
      0.0025
    ],
    [
      "lueur",
      0.0025
    ],
    [
      "fusillade",
      0.0025
    ],
    [
      "attachement",
      0.0025
    ],
    [
      "attaque",
      0.0025
    ],
    [
      "bataille",
      0.0025
    ],
    [
      "braise",
      0.0025
    ],
    [
      "calibre",
      0.0025
    ],
    [
      "calefaction",
      0.0025
    ],
    [
      "cuisson",
      0.0025
    ],
    [
      "fanal",
      0.0025
    ],
    [
      "flambee",
      0.0025
    ],
    [
      "fournaise",
      0.0025
    ],
    [
      "fulguration",
      0.0025
    ],
    [
      "menage",
      0.0
    ],
    [
      "mort",
      0.0
    ],
    [
      "maison",
      0.0
    ],
    [
      "lustre",
      0.0
    ],
    [
      "inspiration",
      0.0
    ],
    [
      "ignition",
      0.0
    ],
    [
      "ignescence",
      0.0
    ],
    [
      "pilonnage",
      0.0
    ],
    [
      "rif",
      0.0
    ],
    [
      "rouge",
      0.0
    ],
    [
      "scintillement",
      0.0
    ],
    [
      "sinistre",
      0.0
    ],
    [
      "temperament",
      0.0
    ],
    [
      "tendresse",
      0.0
    ],
    [
      "tir",
      0.0
    ],
    [
      "torche",
      0.0
    ],
    [
      "atre",
      0.0
    ],
    [
      "flingue",
      0.0
    ],
    [
      "famille",
      0.0
    ],
    [
      "autodafe",
      0.0
    ],
    [
      "balisage",
      0.0
    ],
    [
      "briquet",
      0.0
    ],
    [
      "calcination",
      0.0
    ],
    [
      "canonnade",
      0.0
    ],
    [
      "cautere",
      0.0
    ],
    [
      "chauffe",
      0.0
    ],
    [
      "cheminee",
      0.0
    ],
    [
      "code",
      0.0
    ],
    [
      "consomption",
      0.0
    ],
    [
      "conviction",
      0.0
    ],
    [
      "courroux",
      0.0
    ],
    [
      "cremation",
      0.0
    ],
    [
      "decede",
      0.0
    ],
    [
      "defunt",
      0.0
    ],
    [
      "enfer",
      0.0
    ],
    [
      "allumette",
      0.0
    ]
  ],
  "temps": [
    [
      "epoque",
      0.0675
    ],
    [
      "periode",
      0.0625
    ],
    [
      "occasion",
      0.0475
    ],
    [
      "siecle",
      0.0475
    ],
    [
      "moment",
      0.04
    ],
    [
      "circonstance",
      0.035
    ],
    [
      "age",
      0.03
    ],
    [
      "heure",
      0.025
    ],
    [
      "date",
      0.025
    ],
    [
      "climat",
      0.025
    ],
    [
      "air",
      0.02
    ],
    [
      "delai",
      0.02
    ],
    [
      "vie",
      0.02
    ],
    [
      "jours",
      0.015
    ],
    [
      "possibilite",
      0.015
    ],
    [
      "repit",
      0.015
    ],
    [
      "etape",
      0.015
    ],
    [
      "etendue",
      0.015
    ],
    [
      "hasard",
      0.015
    ],
    [
      "futur",
      0.015
    ],
    [
      "facilite",
      0.015
    ],
    [
      "an",
      0.015
    ],
    [
      "atmosphere",
      0.015
    ],
    [
      "cas",
      0.015
    ],
    [
      "duree",
      0.015
    ],
    [
      "espace",
      0.015
    ],
    [
      "nuage",
      0.01
    ],
    [
      "orage",
      0.01
    ],
    [
      "saison",
      0.01
    ],
    [
      "stade",
      0.01
    ],
    [
      "vent",
      0.01
    ],
    [
      "ere",
      0.01
    ],
    [
      "eclaircie",
      0.01
    ],
    [
      "evenement",
      0.01
    ],
    [
      "mouvement",
      0.01
    ],
    [
      "marge",
      0.01
    ],
    [
      "jour",
      0.01
    ],
    [
      "anciennete",
      0.01
    ],
    [
      "brouillard",
      0.01
    ],
    [
      "chance",
      0.01
    ],
    [
      "ciel",
      0.01
    ],
    [
      "conjoncture",
      0.01
    ],
    [
      "cycle",
      0.01
    ],
    [
      "instant",
      0.01
    ],
    [
      "intemperie",
      0.01
    ],
    [
      "posteriorite",
      0.005
    ],
    [
      "passe",
      0.005
    ],
    [
      "palier",
      0.005
    ],
    [
      "opportunite",
      0.005
    ],
    [
      "meteorologie",
      0.005
    ],
    [
      "present",
      0.005
    ],
    [
      "rythme",
      0.005
    ],
    [
      "regime",
      0.005
    ],
    [
      "silence",
      0.005
    ],
    [
      "succession",
      0.005
    ],
    [
      "sursis",
      0.005
    ],
    [
      "temporalite",
      0.005
    ],
    [
      "meteo",
      0.005
    ],
    [
      "minute",
      0.005
    ],
    [
      "loisir",
      0.005
    ],
    [
      "ambiance",
      0.005
    ],
    [
      "anteriorite",
      0.005
    ],
    [
      "aujourd'hui",
      0.005
    ],
    [
      "avenir",
      0.005
    ],
    [
      "bruine",
      0.005
    ],
    [
      "brume",
      0.005
    ],
    [
      "categorie",
      0.005
    ],
    [
      "conjugaison",
      0.005
    ],
    [
      "demain",
      0.005
    ],
    [
      "embellie",
      0.005
    ],
    [
      "generation",
      0.005
    ],
    [
      "jadis",
      0.005
    ],
    [
      "temperature",
      0.005
    ]
  ],
  "nord": [
    [
      "arctique",
      0.22
    ],
    [
      "septentrional",
      0.22
    ],
    [
      "boreal",
      0.11
    ],
    [
      "boree",
      0.11
    ],
    [
      "hyperboreen",
      0.11
    ],
    [
      "septentrion",
      0.11
    ],
    [
      "tramontane",
      0.11
    ]
  ],
  "epaule": [
    [
      "galon",
      0.125
    ],
    [
      "joue",
      0.125
    ],
    [
      "omoplate",
      0.125
    ],
    [
      "patte",
      0.125
    ],
    [
      "replat",
      0.125
    ],
    [
      "eclanche",
      0.125
    ],
    [
      "epaulette",
      0.125
    ],
    [
      "epauliere",
      0.125
    ]
  ],
  "epauler": [
    [
      "appuyer",
      0.175
    ],
    [
      "soutenir",
      0.125
    ],
    [
      "proteger",
      0.1125
    ],
    [
      "aider",
      0.1
    ],
    [
      "servir",
      0.0875
    ],
    [
      "pistonner",
      0.0625
    ],
    [
      "favoriser",
      0.0625
    ],
    [
      "pousser",
      0.0475
    ],
    [
      "patronner",
      0.0375
    ],
    [
      "seconder",
      0.0225
    ],
    [
      "recommander",
      0.0225
    ],
    [
      "assister",
      0.0225
    ],
    [
      "buter",
      0.01
    ],
    [
      "coucher",
      0.01
    ],
    [
      "faire",
      0.01
    ],
    [
      "secourir",
      0.01
    ]
  ],
  "autour": [
    [
      "alentour",
      0.1775
    ],
    [
      "pres",
      0.115
    ],
    [
      "rapace",
      0.0575
    ],
    [
      "ceinture",
      0.0575
    ],
    [
      "aupres",
      0.0575
    ]
  ],
  "orient": [],
  "brulant": [
    [
      "ardent",
      0.1375
    ],
    [
      "chaud",
      0.1325
    ],
    [
      "bouillonnant",
      0.0825
    ],
    [
      "passionne",
      0.0625
    ],
    [
      "fanatique",
      0.04
    ],
    [
      "bouillant",
      0.04
    ],
    [
      "embrase",
      0.0325
    ],
    [
      "enflamme",
      0.0325
    ],
    [
      "enthousiaste",
      0.0325
    ],
    [
      "vif",
      0.0325
    ],
    [
      "transporte",
      0.025
    ],
    [
      "torride",
      0.025
    ],
    [
      "surchauffe",
      0.02
    ],
    [
      "incandescent",
      0.02
    ],
    [
      "flambant",
      0.02
    ],
    [
      "fervent",
      0.02
    ],
    [
      "dangereux",
      0.02
    ],
    [
      "cuisant",
      0.02
    ],
    [
      "caustique",
      0.02
    ],
    [
      "scabreux",
      0.0125
    ],
    [
      "risque",
      0.0125
    ],
    [
      "delicat",
      0.0125
    ],
    [
      "anime",
      0.0125
    ],
    [
      "amoureux",
      0.0125
    ],
    [
      "tabou",
      0.005
    ],
    [
      "perilleux",
      0.005
    ],
    [
      "passionnant",
      0.005
    ],
    [
      "incendie",
      0.005
    ],
    [
      "glissant",
      0.005
    ],
    [
      "fumant",
      0.005
    ],
    [
      "flamboyant",
      0.005
    ],
    [
      "fievreux",
      0.005
    ],
    [
      "devore",
      0.005
    ],
    [
      "devorant",
      0.005
    ],
    [
      "corrosif",
      0.005
    ],
    [
      "corrodant",
      0.005
    ],
    [
      "caniculaire",
      0.005
    ],
    [
      "actuel",
      0.005
    ],
    [
      "accablant",
      0.005
    ],
    [
      "epineux",
      0.005
    ]
  ],
  "ebene": [],
  "onduler": [
    [
      "remuer",
      0.1775
    ],
    [
      "friser",
      0.0775
    ],
    [
      "balancer",
      0.0575
    ],
    [
      "frissonner",
      0.0575
    ],
    [
      "ondoyer",
      0.0575
    ],
    [
      "serpenter",
      0.0575
    ],
    [
      "travailler",
      0.0375
    ],
    [
      "rouler",
      0.0375
    ],
    [
      "moutonner",
      0.0375
    ],
    [
      "gondoler",
      0.0375
    ],
    [
      "flotter",
      0.0375
    ],
    [
      "boucler",
      0.0375
    ],
    [
      "bercer",
      0.0375
    ],
    [
      "tournoyer",
      0.0175
    ],
    [
      "sinuer",
      0.0175
    ],
    [
      "plisser",
      0.0175
    ],
    [
      "onder",
      0.0175
    ],
    [
      "fremir",
      0.0175
    ],
    [
      "frisotter",
      0.0175
    ],
    [
      "cranter",
      0.0175
    ],
    [
      "calamistrer",
      0.0175
    ],
    [
      "zigzaguer",
      0.0175
    ]
  ],
  "pensee": [
    [
      "imaginer",
      0.0775
    ],
    [
      "considerer",
      0.0525
    ],
    [
      "voir",
      0.0525
    ],
    [
      "croire",
      0.045
    ],
    [
      "reflechir",
      0.0425
    ],
    [
      "examiner",
      0.035
    ],
    [
      "juger",
      0.035
    ],
    [
      "etudier",
      0.0325
    ],
    [
      "songer",
      0.0325
    ],
    [
      "mediter",
      0.0325
    ],
    [
      "compter",
      0.03
    ],
    [
      "estimer",
      0.03
    ],
    [
      "envisager",
      0.0275
    ],
    [
      "regarder",
      0.0275
    ],
    [
      "trouver",
      0.02
    ],
    [
      "supposer",
      0.02
    ],
    [
      "presumer",
      0.02
    ],
    [
      "concevoir",
      0.02
    ],
    [
      "soupconner",
      0.015
    ],
    [
      "s'attendre",
      0.015
    ],
    [
      "conjecturer",
      0.015
    ],
    [
      "evoquer",
      0.0125
    ],
    [
      "s'occuper",
      0.0125
    ],
    [
      "rever",
      0.0125
    ],
    [
      "raisonner",
      0.0125
    ],
    [
      "prevoir",
      0.0125
    ],
    [
      "projeter",
      0.0125
    ],
    [
      "peser",
      0.0125
    ],
    [
      "murir",
      0.01
    ],
    [
      "esperer",
      0.01
    ],
    [
      "connaitre",
      0.01
    ],
    [
      "s'aviser",
      0.0075
    ],
    [
      "ruminer",
      0.0075
    ],
    [
      "repenser",
      0.0075
    ],
    [
      "deliberer",
      0.0075
    ],
    [
      "contempler",
      0.0075
    ],
    [
      "admettre",
      0.0075
    ],
    [
      "saisir",
      0.0025
    ],
    [
      "faillir",
      0.0025
    ],
    [
      "cogiter",
      0.0025
    ],
    [
      "speculer",
      0.0
    ],
    [
      "elaborer",
      0.0
    ],
    [
      "scruter",
      0.0
    ],
    [
      "revasser",
      0.0
    ],
    [
      "devoir",
      0.0
    ],
    [
      "manquer",
      0.0
    ],
    [
      "ordonnancer",
      0.0
    ],
    [
      "rouler",
      0.0
    ]
  ],
  "bousculer": [
    [
      "bouleverser",
      0.1
    ],
    [
      "renverser",
      0.08
    ],
    [
      "pousser",
      0.06
    ],
    [
      "culbuter",
      0.045
    ],
    [
      "exciter",
      0.045
    ],
    [
      "secouer",
      0.045
    ],
    [
      "troubler",
      0.04
    ],
    [
      "battre",
      0.04
    ],
    [
      "chambarder",
      0.0325
    ],
    [
      "heurter",
      0.0325
    ],
    [
      "revolutionner",
      0.0325
    ],
    [
      "vaincre",
      0.025
    ],
    [
      "presser",
      0.025
    ],
    [
      "rudoyer",
      0.02
    ],
    [
      "repousser",
      0.02
    ],
    [
      "chavirer",
      0.02
    ],
    [
      "chasser",
      0.02
    ],
    [
      "chambouler",
      0.02
    ],
    [
      "agiter",
      0.02
    ],
    [
      "activer",
      0.02
    ],
    [
      "eliminer",
      0.0125
    ],
    [
      "stimuler",
      0.0125
    ],
    [
      "precipiter",
      0.0125
    ],
    [
      "houspiller",
      0.0125
    ],
    [
      "deranger",
      0.0125
    ],
    [
      "cogner",
      0.0125
    ],
    [
      "accrocher",
      0.0125
    ],
    [
      "aiguillonner",
      0.0125
    ],
    [
      "bouter",
      0.0125
    ],
    [
      "brusquer",
      0.0125
    ],
    [
      "chahuter",
      0.0125
    ],
    [
      "tarabiscoter",
      0.005
    ],
    [
      "percuter",
      0.005
    ],
    [
      "malmener",
      0.005
    ],
    [
      "gourmander",
      0.005
    ],
    [
      "exhorter",
      0.005
    ],
    [
      "entamer",
      0.005
    ],
    [
      "ballotter",
      0.005
    ],
    [
      "avertir",
      0.005
    ],
    [
      "asticoter",
      0.005
    ],
    [
      "evincer",
      0.005
    ]
  ],
  "lumiere": [
    [
      "eclat",
      0.075
    ],
    [
      "feu",
      0.06
    ],
    [
      "clarte",
      0.055
    ],
    [
      "gloire",
      0.0425
    ],
    [
      "lueur",
      0.0425
    ],
    [
      "jour",
      0.0325
    ],
    [
      "splendeur",
      0.0275
    ],
    [
      "renseignement",
      0.0275
    ],
    [
      "flamme",
      0.0275
    ],
    [
      "eclairage",
      0.02
    ],
    [
      "phare",
      0.02
    ],
    [
      "miroitement",
      0.02
    ],
    [
      "illustration",
      0.02
    ],
    [
      "illumination",
      0.02
    ],
    [
      "explication",
      0.02
    ],
    [
      "chatoiement",
      0.02
    ],
    [
      "brillant",
      0.02
    ],
    [
      "etincelle",
      0.015
    ],
    [
      "scintillement",
      0.015
    ],
    [
      "precision",
      0.015
    ],
    [
      "luminosite",
      0.015
    ],
    [
      "lampe",
      0.015
    ],
    [
      "intelligence",
      0.015
    ],
    [
      "halo",
      0.015
    ],
    [
      "genie",
      0.015
    ],
    [
      "flamboiement",
      0.015
    ],
    [
      "embrasement",
      0.015
    ],
    [
      "connaissance",
      0.015
    ],
    [
      "rayon",
      0.01
    ],
    [
      "rayonnement",
      0.01
    ],
    [
      "reflet",
      0.01
    ],
    [
      "savoir",
      0.01
    ],
    [
      "sommite",
      0.01
    ],
    [
      "eclair",
      0.01
    ],
    [
      "eclairement",
      0.01
    ],
    [
      "evidence",
      0.01
    ],
    [
      "raison",
      0.01
    ],
    [
      "phenix",
      0.01
    ],
    [
      "beaute",
      0.01
    ],
    [
      "flambeau",
      0.01
    ],
    [
      "fleuron",
      0.01
    ],
    [
      "indication",
      0.01
    ],
    [
      "information",
      0.01
    ],
    [
      "lanterne",
      0.01
    ],
    [
      "ornement",
      0.01
    ],
    [
      "ouverture",
      0.01
    ],
    [
      "savant",
      0.005
    ],
    [
      "soleil",
      0.005
    ],
    [
      "vie",
      0.005
    ],
    [
      "verite",
      0.005
    ],
    [
      "eclaircissement",
      0.005
    ],
    [
      "publicite",
      0.005
    ],
    [
      "poudroiement",
      0.005
    ],
    [
      "personnalite",
      0.005
    ],
    [
      "orifice",
      0.005
    ],
    [
      "notabilite",
      0.005
    ],
    [
      "coruscation",
      0.005
    ],
    [
      "bougeoir",
      0.005
    ],
    [
      "electricite",
      0.005
    ]
  ],
  "eclairer": [
    [
      "instruire",
      0.1325
    ],
    [
      "apprendre",
      0.07
    ],
    [
      "eclaircir",
      0.07
    ],
    [
      "renseigner",
      0.0625
    ],
    [
      "enseigner",
      0.045
    ],
    [
      "informer",
      0.0375
    ],
    [
      "illustrer",
      0.0375
    ],
    [
      "illuminer",
      0.0375
    ],
    [
      "expliquer",
      0.0375
    ],
    [
      "edifier",
      0.03
    ],
    [
      "detromper",
      0.03
    ],
    [
      "eduquer",
      0.0225
    ],
    [
      "initier",
      0.0225
    ],
    [
      "desabuser",
      0.0225
    ],
    [
      "demystifier",
      0.0225
    ],
    [
      "briller",
      0.0225
    ],
    [
      "elucider",
      0.015
    ],
    [
      "resplendir",
      0.015
    ],
    [
      "passer",
      0.015
    ],
    [
      "former",
      0.015
    ],
    [
      "fixer",
      0.015
    ],
    [
      "enluminer",
      0.015
    ],
    [
      "enflammer",
      0.015
    ],
    [
      "endoctriner",
      0.015
    ],
    [
      "dessiller",
      0.015
    ],
    [
      "avertir",
      0.015
    ],
    [
      "luire",
      0.0075
    ],
    [
      "payer",
      0.0075
    ],
    [
      "reconnaitre",
      0.0075
    ],
    [
      "reluire",
      0.0075
    ],
    [
      "repandre",
      0.0075
    ],
    [
      "etinceler",
      0.0075
    ],
    [
      "guider",
      0.0075
    ],
    [
      "flamboyer",
      0.0075
    ],
    [
      "faciliter",
      0.0075
    ],
    [
      "embraser",
      0.0075
    ],
    [
      "dorer",
      0.0075
    ],
    [
      "clarifier",
      0.0075
    ],
    [
      "brillanter",
      0.0075
    ],
    [
      "balayer",
      0.0075
    ],
    [
      "allumer",
      0.0075
    ],
    [
      "etoiler",
      0.0075
    ]
  ],
  "eclaire": [
    [
      "instruire",
      0.1325
    ],
    [
      "apprendre",
      0.07
    ],
    [
      "eclaircir",
      0.07
    ],
    [
      "renseigner",
      0.0625
    ],
    [
      "enseigner",
      0.045
    ],
    [
      "informer",
      0.0375
    ],
    [
      "illustrer",
      0.0375
    ],
    [
      "illuminer",
      0.0375
    ],
    [
      "expliquer",
      0.0375
    ],
    [
      "edifier",
      0.03
    ],
    [
      "detromper",
      0.03
    ],
    [
      "eduquer",
      0.0225
    ],
    [
      "initier",
      0.0225
    ],
    [
      "desabuser",
      0.0225
    ],
    [
      "demystifier",
      0.0225
    ],
    [
      "briller",
      0.0225
    ],
    [
      "elucider",
      0.015
    ],
    [
      "resplendir",
      0.015
    ],
    [
      "passer",
      0.015
    ],
    [
      "former",
      0.015
    ],
    [
      "fixer",
      0.015
    ],
    [
      "enluminer",
      0.015
    ],
    [
      "enflammer",
      0.015
    ],
    [
      "endoctriner",
      0.015
    ],
    [
      "dessiller",
      0.015
    ],
    [
      "avertir",
      0.015
    ],
    [
      "luire",
      0.0075
    ],
    [
      "payer",
      0.0075
    ],
    [
      "reconnaitre",
      0.0075
    ],
    [
      "reluire",
      0.0075
    ],
    [
      "repandre",
      0.0075
    ],
    [
      "etinceler",
      0.0075
    ],
    [
      "guider",
      0.0075
    ],
    [
      "flamboyer",
      0.0075
    ],
    [
      "faciliter",
      0.0075
    ],
    [
      "embraser",
      0.0075
    ],
    [
      "dorer",
      0.0075
    ],
    [
      "clarifier",
      0.0075
    ],
    [
      "brillanter",
      0.0075
    ],
    [
      "balayer",
      0.0075
    ],
    [
      "allumer",
      0.0075
    ],
    [
      "etoiler",
      0.0075
    ]
  ],
  "chaud": [
    [
      "ardent",
      0.1475
    ],
    [
      "bouillonnant",
      0.085
    ],
    [
      "passionne",
      0.075
    ],
    [
      "enthousiaste",
      0.06
    ],
    [
      "brulant",
      0.05
    ],
    [
      "enflamme",
      0.045
    ],
    [
      "vif",
      0.04
    ],
    [
      "fanatique",
      0.04
    ],
    [
      "bouillant",
      0.035
    ],
    [
      "chaleureux",
      0.035
    ],
    [
      "fougueux",
      0.03
    ],
    [
      "vehement",
      0.02
    ],
    [
      "frenetique",
      0.02
    ],
    [
      "fervent",
      0.02
    ],
    [
      "transporte",
      0.0175
    ],
    [
      "violent",
      0.0175
    ],
    [
      "zele",
      0.0175
    ],
    [
      "emporte",
      0.015
    ],
    [
      "torride",
      0.015
    ],
    [
      "embrase",
      0.0125
    ],
    [
      "anime",
      0.0125
    ],
    [
      "amoureux",
      0.01
    ],
    [
      "cuisant",
      0.01
    ],
    [
      "emballe",
      0.01
    ],
    [
      "febrile",
      0.01
    ],
    [
      "apre",
      0.01
    ],
    [
      "dur",
      0.0075
    ],
    [
      "bon",
      0.0075
    ],
    [
      "acharne",
      0.0075
    ],
    [
      "echauffe",
      0.005
    ],
    [
      "voluptueux",
      0.005
    ],
    [
      "mou",
      0.005
    ],
    [
      "incandescent",
      0.005
    ],
    [
      "feru",
      0.005
    ],
    [
      "fievreux",
      0.005
    ],
    [
      "delirant",
      0.005
    ],
    [
      "dangereux",
      0.005
    ],
    [
      "cordial",
      0.005
    ],
    [
      "combustible",
      0.005
    ],
    [
      "sanglant",
      0.0
    ],
    [
      "suffocant",
      0.0
    ],
    [
      "severe",
      0.0
    ],
    [
      "thermique",
      0.0
    ],
    [
      "tiede",
      0.0
    ],
    [
      "tropical",
      0.0
    ],
    [
      "risque",
      0.0
    ],
    [
      "pressant",
      0.0
    ],
    [
      "lascif",
      0.0
    ],
    [
      "empresse",
      0.0
    ],
    [
      "determine",
      0.0
    ],
    [
      "decide",
      0.0
    ],
    [
      "cher",
      0.0
    ],
    [
      "chaleur",
      0.0
    ],
    [
      "equatorial",
      0.0
    ]
  ],
  "soi": [
    [
      "lui",
      0.25
    ],
    [
      "personnalite",
      0.25
    ],
    [
      "self",
      0.25
    ],
    [
      "substance",
      0.25
    ]
  ],
  "autrefois": [
    [
      "anciennement",
      0.19
    ],
    [
      "jadis",
      0.19
    ],
    [
      "auparavant",
      0.095
    ],
    [
      "naguere",
      0.0475
    ],
    [
      "longtemps",
      0.0475
    ],
    [
      "avant",
      0.0475
    ]
  ],
  "ecoute": [
    [
      "cordage",
      0.285
    ],
    [
      "audition",
      0.1425
    ],
    [
      "bouline",
      0.1425
    ],
    [
      "drisse",
      0.1425
    ],
    [
      "detection",
      0.1425
    ],
    [
      "surveillance",
      0.1425
    ]
  ],
  "ecouter": [
    [
      "suivre",
      0.1225
    ],
    [
      "considerer",
      0.09
    ],
    [
      "entendre",
      0.09
    ],
    [
      "obeir",
      0.09
    ],
    [
      "voir",
      0.09
    ],
    [
      "satisfaire",
      0.06
    ],
    [
      "percevoir",
      0.06
    ],
    [
      "ouir",
      0.06
    ],
    [
      "croire",
      0.06
    ],
    [
      "accueillir",
      0.0275
    ],
    [
      "consulter",
      0.0275
    ],
    [
      "ceder",
      0.0275
    ],
    [
      "exaucer",
      0.0275
    ],
    [
      "s'occuper",
      0.0275
    ]
  ],
  "juste": [
    [
      "exact",
      0.07
    ],
    [
      "bon",
      0.06
    ],
    [
      "honnete",
      0.0525
    ],
    [
      "vrai",
      0.0525
    ],
    [
      "convenable",
      0.05
    ],
    [
      "droit",
      0.03
    ],
    [
      "correct",
      0.03
    ],
    [
      "fidele",
      0.025
    ],
    [
      "approprie",
      0.025
    ],
    [
      "logique",
      0.0225
    ],
    [
      "sortable",
      0.0225
    ],
    [
      "precis",
      0.02
    ],
    [
      "net",
      0.02
    ],
    [
      "conforme",
      0.0175
    ],
    [
      "propre",
      0.0175
    ],
    [
      "raisonnable",
      0.0175
    ],
    [
      "sur",
      0.0175
    ],
    [
      "sincere",
      0.0175
    ],
    [
      "seyant",
      0.0175
    ],
    [
      "probe",
      0.0175
    ],
    [
      "equitable",
      0.015
    ],
    [
      "serre",
      0.015
    ],
    [
      "rigoureux",
      0.015
    ],
    [
      "bien",
      0.015
    ],
    [
      "beau",
      0.0125
    ],
    [
      "judicieux",
      0.0125
    ],
    [
      "maigre",
      0.0125
    ],
    [
      "objectif",
      0.0125
    ],
    [
      "veritable",
      0.01
    ],
    [
      "strict",
      0.01
    ],
    [
      "pauvre",
      0.01
    ],
    [
      "loyal",
      0.01
    ],
    [
      "etroit",
      0.0075
    ],
    [
      "scrupuleux",
      0.0075
    ],
    [
      "sage",
      0.0075
    ],
    [
      "reel",
      0.0075
    ],
    [
      "rationnel",
      0.0075
    ],
    [
      "court",
      0.0075
    ],
    [
      "moral",
      0.0075
    ],
    [
      "impartial",
      0.0075
    ],
    [
      "fonde",
      0.0075
    ],
    [
      "authentique",
      0.0075
    ],
    [
      "tangible",
      0.005
    ],
    [
      "petit",
      0.005
    ],
    [
      "pertinent",
      0.005
    ],
    [
      "parcimonieux",
      0.005
    ],
    [
      "legitime",
      0.005
    ],
    [
      "jeune",
      0.005
    ],
    [
      "irreprochable",
      0.005
    ],
    [
      "insuffisant",
      0.005
    ],
    [
      "adequat",
      0.005
    ],
    [
      "sense",
      0.0025
    ],
    [
      "moyen",
      0.0025
    ],
    [
      "mesure",
      0.0025
    ],
    [
      "justifie",
      0.0025
    ],
    [
      "integre",
      0.0025
    ],
    [
      "heureux",
      0.0025
    ],
    [
      "harmonieux",
      0.0025
    ],
    [
      "exactement",
      0.0025
    ],
    [
      "collant",
      0.0025
    ],
    [
      "ajuste",
      0.0025
    ],
    [
      "precisement",
      0.0
    ],
    [
      "seulement",
      0.0
    ],
    [
      "sonnant",
      0.0
    ],
    [
      "tangent",
      0.0
    ],
    [
      "merite",
      0.0
    ],
    [
      "motive",
      0.0
    ],
    [
      "justifiable",
      0.0
    ],
    [
      "justement",
      0.0
    ],
    [
      "impassible",
      0.0
    ],
    [
      "bienvenu",
      0.0
    ],
    [
      "avere",
      0.0
    ],
    [
      "apte",
      0.0
    ],
    [
      "etrique",
      0.0
    ]
  ],
  "fragile": [
    [
      "faible",
      0.0875
    ],
    [
      "precaire",
      0.08
    ],
    [
      "instable",
      0.0575
    ],
    [
      "delicat",
      0.045
    ],
    [
      "leger",
      0.035
    ],
    [
      "perissable",
      0.03
    ],
    [
      "frele",
      0.03
    ],
    [
      "caduc",
      0.0275
    ],
    [
      "fugace",
      0.0275
    ],
    [
      "mince",
      0.0275
    ],
    [
      "ephemere",
      0.025
    ],
    [
      "passager",
      0.025
    ],
    [
      "menu",
      0.025
    ],
    [
      "incertain",
      0.025
    ],
    [
      "chancelant",
      0.025
    ],
    [
      "grele",
      0.02
    ],
    [
      "inconstant",
      0.02
    ],
    [
      "labile",
      0.02
    ],
    [
      "volage",
      0.02
    ],
    [
      "tenu",
      0.0175
    ],
    [
      "fugitif",
      0.0175
    ],
    [
      "debile",
      0.0175
    ],
    [
      "changeant",
      0.015
    ],
    [
      "fluet",
      0.015
    ],
    [
      "mobile",
      0.015
    ],
    [
      "svelte",
      0.01
    ],
    [
      "malingre",
      0.01
    ],
    [
      "inconsistant",
      0.01
    ],
    [
      "chetif",
      0.01
    ],
    [
      "cassant",
      0.01
    ],
    [
      "transitoire",
      0.0075
    ],
    [
      "tendre",
      0.0075
    ],
    [
      "succinct",
      0.0075
    ],
    [
      "pale",
      0.0075
    ],
    [
      "delie",
      0.0075
    ],
    [
      "court",
      0.0075
    ],
    [
      "branlant",
      0.0075
    ],
    [
      "anemie",
      0.0075
    ],
    [
      "vulnerable",
      0.005
    ],
    [
      "temporaire",
      0.005
    ],
    [
      "sensible",
      0.005
    ],
    [
      "provisoire",
      0.005
    ],
    [
      "menace",
      0.005
    ],
    [
      "maladif",
      0.005
    ],
    [
      "fusele",
      0.005
    ],
    [
      "destructible",
      0.005
    ],
    [
      "boiteux",
      0.005
    ],
    [
      "alterable",
      0.005
    ],
    [
      "tachant",
      0.0025
    ],
    [
      "souffreteux",
      0.0025
    ],
    [
      "mievre",
      0.0025
    ],
    [
      "faillible",
      0.0025
    ],
    [
      "douillet",
      0.0025
    ],
    [
      "cassable",
      0.0025
    ],
    [
      "ebranle",
      0.0025
    ]
  ],
  "flamme": [
    [
      "ardeur",
      0.1125
    ],
    [
      "chaleur",
      0.1
    ],
    [
      "feu",
      0.075
    ],
    [
      "bouillonnement",
      0.0625
    ],
    [
      "passion",
      0.06
    ],
    [
      "exaltation",
      0.0575
    ],
    [
      "enthousiasme",
      0.0525
    ],
    [
      "fougue",
      0.0375
    ],
    [
      "fanatisme",
      0.0275
    ],
    [
      "fievre",
      0.0275
    ],
    [
      "vehemence",
      0.0275
    ],
    [
      "frenesie",
      0.0225
    ],
    [
      "elan",
      0.0225
    ],
    [
      "impetuosite",
      0.02
    ],
    [
      "transport",
      0.0175
    ],
    [
      "excitation",
      0.0175
    ],
    [
      "amour",
      0.0125
    ],
    [
      "animation",
      0.0125
    ],
    [
      "zele",
      0.0125
    ],
    [
      "etincelle",
      0.0125
    ],
    [
      "eclat",
      0.01
    ],
    [
      "lumiere",
      0.01
    ],
    [
      "attachement",
      0.0075
    ],
    [
      "drapeau",
      0.0075
    ],
    [
      "ferveur",
      0.0075
    ],
    [
      "touffe",
      0.005
    ],
    [
      "petulance",
      0.005
    ],
    [
      "lueur",
      0.005
    ],
    [
      "houppe",
      0.005
    ],
    [
      "brasier",
      0.005
    ],
    [
      "banniere",
      0.005
    ],
    [
      "aigrette",
      0.005
    ],
    [
      "ame",
      0.0025
    ],
    [
      "tendresse",
      0.0025
    ],
    [
      "surexcitation",
      0.0025
    ],
    [
      "oriflamme",
      0.0025
    ],
    [
      "genie",
      0.0025
    ],
    [
      "fournaise",
      0.0025
    ],
    [
      "flamboiement",
      0.0025
    ],
    [
      "banderole",
      0.0025
    ],
    [
      "flammeche",
      0.0
    ],
    [
      "foyer",
      0.0
    ],
    [
      "gonfalon",
      0.0
    ],
    [
      "pinceau",
      0.0
    ],
    [
      "plumet",
      0.0
    ],
    [
      "tampon",
      0.0
    ],
    [
      "eclair",
      0.0
    ],
    [
      "flambe",
      0.0
    ],
    [
      "fanion",
      0.0
    ],
    [
      "desir",
      0.0
    ],
    [
      "demon",
      0.0
    ],
    [
      "cornette",
      0.0
    ],
    [
      "clarte",
      0.0
    ],
    [
      "bucher",
      0.0
    ],
    [
      "braise",
      0.0
    ],
    [
      "bouquet",
      0.0
    ],
    [
      "eloquence",
      0.0
    ]
  ],
  "bouillir": [
    [
      "s'irriter",
      0.125
    ],
    [
      "fermenter",
      0.1
    ],
    [
      "s'agiter",
      0.075
    ],
    [
      "s'impatienter",
      0.075
    ],
    [
      "s'emporter",
      0.05
    ],
    [
      "mijoter",
      0.05
    ],
    [
      "frissonner",
      0.05
    ],
    [
      "cuire",
      0.05
    ],
    [
      "bouillonner",
      0.05
    ],
    [
      "s'echauffer",
      0.0225
    ],
    [
      "s'exasperer",
      0.0225
    ],
    [
      "mitonner",
      0.0225
    ],
    [
      "fremir",
      0.0225
    ],
    [
      "exploser",
      0.0225
    ],
    [
      "chanter",
      0.0225
    ],
    [
      "bouler",
      0.0225
    ],
    [
      "travailler",
      0.0225
    ]
  ],
  "bout": [
    [
      "s'irriter",
      0.125
    ],
    [
      "fermenter",
      0.1
    ],
    [
      "s'agiter",
      0.075
    ],
    [
      "s'impatienter",
      0.075
    ],
    [
      "s'emporter",
      0.05
    ],
    [
      "mijoter",
      0.05
    ],
    [
      "frissonner",
      0.05
    ],
    [
      "cuire",
      0.05
    ],
    [
      "bouillonner",
      0.05
    ],
    [
      "s'echauffer",
      0.0225
    ],
    [
      "s'exasperer",
      0.0225
    ],
    [
      "mitonner",
      0.0225
    ],
    [
      "fremir",
      0.0225
    ],
    [
      "exploser",
      0.0225
    ],
    [
      "chanter",
      0.0225
    ],
    [
      "bouler",
      0.0225
    ],
    [
      "travailler",
      0.0225
    ]
  ],
  "armer": [
    [
      "munir",
      0.1
    ],
    [
      "proteger",
      0.1
    ],
    [
      "equiper",
      0.1
    ],
    [
      "renforcer",
      0.0825
    ],
    [
      "fortifier",
      0.065
    ],
    [
      "exciter",
      0.065
    ],
    [
      "cuirasser",
      0.0475
    ],
    [
      "pourvoir",
      0.0475
    ],
    [
      "soutenir",
      0.0325
    ],
    [
      "soulever",
      0.0325
    ],
    [
      "irriter",
      0.0325
    ],
    [
      "fournir",
      0.0325
    ],
    [
      "endurcir",
      0.0325
    ],
    [
      "dechainer",
      0.0325
    ],
    [
      "opposer",
      0.015
    ],
    [
      "nantir",
      0.015
    ],
    [
      "lever",
      0.015
    ],
    [
      "herisser",
      0.015
    ],
    [
      "greer",
      0.015
    ],
    [
      "freter",
      0.015
    ],
    [
      "doter",
      0.015
    ],
    [
      "barder",
      0.015
    ],
    [
      "animer",
      0.015
    ],
    [
      "adouber",
      0.015
    ],
    [
      "premunir",
      0.015
    ]
  ],
  "arme": [
    [
      "munir",
      0.1
    ],
    [
      "proteger",
      0.1
    ],
    [
      "equiper",
      0.1
    ],
    [
      "renforcer",
      0.0825
    ],
    [
      "fortifier",
      0.065
    ],
    [
      "exciter",
      0.065
    ],
    [
      "cuirasser",
      0.0475
    ],
    [
      "pourvoir",
      0.0475
    ],
    [
      "soutenir",
      0.0325
    ],
    [
      "soulever",
      0.0325
    ],
    [
      "irriter",
      0.0325
    ],
    [
      "fournir",
      0.0325
    ],
    [
      "endurcir",
      0.0325
    ],
    [
      "dechainer",
      0.0325
    ],
    [
      "opposer",
      0.015
    ],
    [
      "nantir",
      0.015
    ],
    [
      "lever",
      0.015
    ],
    [
      "herisser",
      0.015
    ],
    [
      "greer",
      0.015
    ],
    [
      "freter",
      0.015
    ],
    [
      "doter",
      0.015
    ],
    [
      "barder",
      0.015
    ],
    [
      "animer",
      0.015
    ],
    [
      "adouber",
      0.015
    ],
    [
      "premunir",
      0.015
    ]
  ],
  "notre": [],
  "histoire": [
    [
      "conte",
      0.065
    ],
    [
      "fable",
      0.0525
    ],
    [
      "recit",
      0.05
    ],
    [
      "roman",
      0.035
    ],
    [
      "affaire",
      0.03
    ],
    [
      "mensonge",
      0.03
    ],
    [
      "difficulte",
      0.03
    ],
    [
      "boniment",
      0.0225
    ],
    [
      "bruit",
      0.0225
    ],
    [
      "invention",
      0.0225
    ],
    [
      "evenement",
      0.02
    ],
    [
      "intrigue",
      0.02
    ],
    [
      "fait",
      0.02
    ],
    [
      "embarras",
      0.02
    ],
    [
      "chanson",
      0.02
    ],
    [
      "aventure",
      0.02
    ],
    [
      "anecdote",
      0.02
    ],
    [
      "propos",
      0.0175
    ],
    [
      "mythe",
      0.0175
    ],
    [
      "incident",
      0.0175
    ],
    [
      "complication",
      0.0175
    ],
    [
      "chronique",
      0.0175
    ],
    [
      "bateau",
      0.0175
    ],
    [
      "annales",
      0.0175
    ],
    [
      "truc",
      0.0125
    ],
    [
      "legende",
      0.0125
    ],
    [
      "ennui",
      0.0125
    ],
    [
      "comedie",
      0.0125
    ],
    [
      "blague",
      0.0125
    ],
    [
      "sujet",
      0.01
    ],
    [
      "souvenir",
      0.01
    ],
    [
      "craque",
      0.01
    ],
    [
      "anicroche",
      0.01
    ],
    [
      "allegorie",
      0.01
    ],
    [
      "vie",
      0.0075
    ],
    [
      "tirage",
      0.0075
    ],
    [
      "sornette",
      0.0075
    ],
    [
      "salade",
      0.0075
    ],
    [
      "relation",
      0.0075
    ],
    [
      "probleme",
      0.0075
    ],
    [
      "peinture",
      0.0075
    ],
    [
      "narration",
      0.0075
    ],
    [
      "maniere",
      0.0075
    ],
    [
      "feuilleton",
      0.0075
    ],
    [
      "bobard",
      0.0075
    ],
    [
      "facon",
      0.005
    ],
    [
      "geste",
      0.005
    ],
    [
      "memoires",
      0.005
    ],
    [
      "mesaventure",
      0.005
    ],
    [
      "querelle",
      0.005
    ],
    [
      "episode",
      0.005
    ],
    [
      "detour",
      0.005
    ],
    [
      "description",
      0.005
    ],
    [
      "accroc",
      0.005
    ],
    [
      "affectation",
      0.005
    ],
    [
      "baliverne",
      0.005
    ],
    [
      "cas",
      0.005
    ],
    [
      "chicane",
      0.005
    ],
    [
      "commentaire",
      0.005
    ],
    [
      "musique",
      0.0
    ],
    [
      "mythologie",
      0.0
    ],
    [
      "paleographie",
      0.0
    ],
    [
      "parabole",
      0.0
    ],
    [
      "passe",
      0.0
    ],
    [
      "protohistoire",
      0.0
    ],
    [
      "prehistoire",
      0.0
    ],
    [
      "version",
      0.0
    ],
    [
      "echo",
      0.0
    ],
    [
      "etude",
      0.0
    ],
    [
      "evangile",
      0.0
    ],
    [
      "evocation",
      0.0
    ],
    [
      "evolution",
      0.0
    ],
    [
      "machin",
      0.0
    ],
    [
      "historiette",
      0.0
    ],
    [
      "archeologie",
      0.0
    ],
    [
      "bible",
      0.0
    ],
    [
      "biographie",
      0.0
    ],
    [
      "chronologie",
      0.0
    ],
    [
      "confessions",
      0.0
    ],
    [
      "diplomatique",
      0.0
    ],
    [
      "dit",
      0.0
    ],
    [
      "existence",
      0.0
    ],
    [
      "fastes",
      0.0
    ],
    [
      "genealogie",
      0.0
    ],
    [
      "hagiographie",
      0.0
    ],
    [
      "heuristique",
      0.0
    ],
    [
      "archives",
      0.0
    ]
  ],
  "tellement": [
    [
      "aussi",
      0.25
    ],
    [
      "quellement",
      0.25
    ],
    [
      "si",
      0.25
    ],
    [
      "tant",
      0.25
    ]
  ],
  "loi": [
    [
      "regle",
      0.0825
    ],
    [
      "reglement",
      0.0825
    ],
    [
      "statut",
      0.05
    ],
    [
      "prescription",
      0.0425
    ],
    [
      "commandement",
      0.0375
    ],
    [
      "obligation",
      0.0375
    ],
    [
      "norme",
      0.0325
    ],
    [
      "droit",
      0.0325
    ],
    [
      "contrainte",
      0.0325
    ],
    [
      "autorite",
      0.0325
    ],
    [
      "precepte",
      0.0275
    ],
    [
      "pouvoir",
      0.0275
    ],
    [
      "decret",
      0.0275
    ],
    [
      "code",
      0.0275
    ],
    [
      "titre",
      0.02
    ],
    [
      "principe",
      0.02
    ],
    [
      "imperatif",
      0.02
    ],
    [
      "exigence",
      0.02
    ],
    [
      "dogme",
      0.02
    ],
    [
      "arrete",
      0.02
    ],
    [
      "acte",
      0.02
    ],
    [
      "evangile",
      0.015
    ],
    [
      "puissance",
      0.015
    ],
    [
      "griffe",
      0.015
    ],
    [
      "empire",
      0.015
    ],
    [
      "constitution",
      0.015
    ],
    [
      "verite",
      0.01
    ],
    [
      "theorie",
      0.01
    ],
    [
      "ordonnance",
      0.01
    ],
    [
      "necessite",
      0.01
    ],
    [
      "main",
      0.01
    ],
    [
      "legislation",
      0.01
    ],
    [
      "domination",
      0.01
    ],
    [
      "discipline",
      0.01
    ],
    [
      "devoir",
      0.01
    ],
    [
      "coupe",
      0.01
    ],
    [
      "canon",
      0.01
    ],
    [
      "legislateur",
      0.005
    ],
    [
      "observance",
      0.005
    ],
    [
      "pente",
      0.005
    ],
    [
      "proposition",
      0.005
    ],
    [
      "justice",
      0.005
    ],
    [
      "instinct",
      0.005
    ],
    [
      "inclination",
      0.005
    ],
    [
      "devise",
      0.005
    ],
    [
      "bill",
      0.005
    ],
    [
      "arret",
      0.005
    ],
    [
      "aloi",
      0.005
    ],
    [
      "edit",
      0.005
    ]
  ],
  "sauver": [
    [
      "preserver",
      0.165
    ],
    [
      "garantir",
      0.0825
    ],
    [
      "proteger",
      0.0825
    ],
    [
      "garder",
      0.0625
    ],
    [
      "soustraire",
      0.0625
    ],
    [
      "eviter",
      0.04
    ],
    [
      "epargner",
      0.04
    ],
    [
      "sauvegarder",
      0.04
    ],
    [
      "reserver",
      0.04
    ],
    [
      "remedier",
      0.04
    ],
    [
      "guerir",
      0.04
    ],
    [
      "defendre",
      0.04
    ],
    [
      "conserver",
      0.04
    ],
    [
      "arracher",
      0.04
    ],
    [
      "retablir",
      0.02
    ],
    [
      "ressusciter",
      0.02
    ],
    [
      "repecher",
      0.02
    ],
    [
      "racheter",
      0.02
    ],
    [
      "justifier",
      0.02
    ],
    [
      "excuser",
      0.02
    ],
    [
      "tirer",
      0.02
    ]
  ],
  "enflammer": [
    [
      "exciter",
      0.1525
    ],
    [
      "exalter",
      0.08
    ],
    [
      "attiser",
      0.06
    ],
    [
      "animer",
      0.0425
    ],
    [
      "aiguillonner",
      0.0275
    ],
    [
      "stimuler",
      0.0275
    ],
    [
      "aviver",
      0.025
    ],
    [
      "pousser",
      0.025
    ],
    [
      "transporter",
      0.0225
    ],
    [
      "embraser",
      0.0225
    ],
    [
      "enfievrer",
      0.0225
    ],
    [
      "enthousiasmer",
      0.0225
    ],
    [
      "soulever",
      0.0225
    ],
    [
      "surexciter",
      0.0225
    ],
    [
      "allumer",
      0.0175
    ],
    [
      "ranimer",
      0.0175
    ],
    [
      "augmenter",
      0.0175
    ],
    [
      "bruler",
      0.015
    ],
    [
      "galvaniser",
      0.015
    ],
    [
      "irriter",
      0.015
    ],
    [
      "echauffer",
      0.015
    ],
    [
      "electriser",
      0.015
    ],
    [
      "provoquer",
      0.0125
    ],
    [
      "entrainer",
      0.0125
    ],
    [
      "dechainer",
      0.0125
    ],
    [
      "aiguiser",
      0.0125
    ],
    [
      "eperonner",
      0.0125
    ],
    [
      "charmer",
      0.01
    ],
    [
      "chauffer",
      0.01
    ],
    [
      "exasperer",
      0.01
    ],
    [
      "piquer",
      0.01
    ],
    [
      "emouvoir",
      0.0075
    ],
    [
      "passionner",
      0.0075
    ],
    [
      "agiter",
      0.0075
    ],
    [
      "accroitre",
      0.0075
    ],
    [
      "encourager",
      0.0075
    ],
    [
      "enivrer",
      0.0075
    ],
    [
      "exacerber",
      0.0075
    ],
    [
      "inspirer",
      0.0075
    ],
    [
      "rechauffer",
      0.005
    ],
    [
      "enlever",
      0.005
    ],
    [
      "consumer",
      0.005
    ],
    [
      "attirer",
      0.005
    ],
    [
      "affoler",
      0.005
    ],
    [
      "ebranler",
      0.0025
    ],
    [
      "seduire",
      0.0025
    ],
    [
      "incendier",
      0.0025
    ],
    [
      "illuminer",
      0.0025
    ],
    [
      "griser",
      0.0025
    ],
    [
      "eclairer",
      0.0025
    ],
    [
      "survolter",
      0.0025
    ],
    [
      "remplir",
      0.0025
    ],
    [
      "fanatiser",
      0.0025
    ],
    [
      "envouter",
      0.0025
    ],
    [
      "ensorceler",
      0.0025
    ],
    [
      "emporter",
      0.0025
    ],
    [
      "devorer",
      0.0025
    ],
    [
      "rougir",
      0.0
    ],
    [
      "ignifier",
      0.0
    ],
    [
      "griller",
      0.0
    ],
    [
      "envenimer",
      0.0
    ],
    [
      "enluminer",
      0.0
    ],
    [
      "empourprer",
      0.0
    ],
    [
      "doper",
      0.0
    ],
    [
      "communiquer",
      0.0
    ],
    [
      "rotir",
      0.0
    ]
  ],
  "bas": [
    [
      "vil",
      0.0475
    ],
    [
      "abject",
      0.0475
    ],
    [
      "ignoble",
      0.0475
    ],
    [
      "infame",
      0.0375
    ],
    [
      "honteux",
      0.0325
    ],
    [
      "petit",
      0.0325
    ],
    [
      "impur",
      0.0325
    ],
    [
      "mediocre",
      0.03
    ],
    [
      "indigne",
      0.0275
    ],
    [
      "insignifiant",
      0.0275
    ],
    [
      "obscene",
      0.0275
    ],
    [
      "sordide",
      0.0275
    ],
    [
      "vulgaire",
      0.025
    ],
    [
      "degoutant",
      0.025
    ],
    [
      "commun",
      0.0225
    ],
    [
      "grossier",
      0.02
    ],
    [
      "immoral",
      0.02
    ],
    [
      "trivial",
      0.0175
    ],
    [
      "plat",
      0.0175
    ],
    [
      "ordinaire",
      0.0175
    ],
    [
      "mesquin",
      0.0175
    ],
    [
      "mauvais",
      0.0175
    ],
    [
      "base",
      0.015
    ],
    [
      "odieux",
      0.01
    ],
    [
      "malpropre",
      0.01
    ],
    [
      "laid",
      0.01
    ],
    [
      "avilissant",
      0.01
    ],
    [
      "vicieux",
      0.01
    ],
    [
      "inqualifiable",
      0.01
    ],
    [
      "inferieur",
      0.01
    ],
    [
      "infime",
      0.01
    ],
    [
      "humble",
      0.01
    ],
    [
      "faible",
      0.01
    ],
    [
      "deprave",
      0.01
    ],
    [
      "corrompu",
      0.01
    ],
    [
      "servile",
      0.0075
    ],
    [
      "meprisable",
      0.0075
    ],
    [
      "mechant",
      0.0075
    ],
    [
      "subalterne",
      0.005
    ],
    [
      "prosaique",
      0.005
    ],
    [
      "profond",
      0.005
    ],
    [
      "populacier",
      0.005
    ],
    [
      "licencieux",
      0.005
    ],
    [
      "innommable",
      0.005
    ],
    [
      "fondement",
      0.005
    ],
    [
      "crapuleux",
      0.005
    ],
    [
      "avili",
      0.005
    ],
    [
      "sombre",
      0.0025
    ],
    [
      "roturier",
      0.0025
    ],
    [
      "modique",
      0.0025
    ],
    [
      "minuscule",
      0.0025
    ],
    [
      "lache",
      0.0025
    ],
    [
      "grivois",
      0.0025
    ],
    [
      "grave",
      0.0025
    ],
    [
      "degradant",
      0.0025
    ],
    [
      "chaussette",
      0.0025
    ],
    [
      "baisse",
      0.0025
    ],
    [
      "assise",
      0.0025
    ],
    [
      "pornographique",
      0.0025
    ],
    [
      "rampant",
      0.0025
    ],
    [
      "salope",
      0.0025
    ],
    [
      "socle",
      0.0025
    ],
    [
      "soubassement",
      0.0025
    ],
    [
      "support",
      0.0025
    ],
    [
      "tombe",
      0.0025
    ],
    [
      "ecrase",
      0.0025
    ],
    [
      "populaire",
      0.0025
    ],
    [
      "poissard",
      0.0025
    ],
    [
      "bouche",
      0.0025
    ],
    [
      "boueux",
      0.0025
    ],
    [
      "brutal",
      0.0025
    ],
    [
      "chausse",
      0.0025
    ],
    [
      "fond",
      0.0025
    ],
    [
      "incline",
      0.0025
    ],
    [
      "libre",
      0.0025
    ],
    [
      "moindre",
      0.0025
    ],
    [
      "pied",
      0.0
    ],
    [
      "pendant",
      0.0
    ],
    [
      "nadir",
      0.0
    ],
    [
      "modere",
      0.0
    ],
    [
      "porno",
      0.0
    ],
    [
      "rabattu",
      0.0
    ],
    [
      "racine",
      0.0
    ],
    [
      "ravili",
      0.0
    ],
    [
      "tenebreux",
      0.0
    ],
    [
      "venal",
      0.0
    ],
    [
      "mal",
      0.0
    ],
    [
      "caverneux",
      0.0
    ],
    [
      "chaussure",
      0.0
    ],
    [
      "collant",
      0.0
    ],
    [
      "court",
      0.0
    ],
    [
      "dessous",
      0.0
    ],
    [
      "deferent",
      0.0
    ],
    [
      "embase",
      0.0
    ],
    [
      "enfonce",
      0.0
    ],
    [
      "fondation",
      0.0
    ],
    [
      "inaudible",
      0.0
    ],
    [
      "infamant",
      0.0
    ],
    [
      "bout",
      0.0
    ]
  ],
  "damner": [
    [
      "condamner",
      0.4
    ],
    [
      "perdre",
      0.2
    ],
    [
      "reprouver",
      0.2
    ],
    [
      "tourmenter",
      0.2
    ]
  ],
  "oublie": [
    [
      "negliger",
      0.13
    ],
    [
      "abandonner",
      0.1175
    ],
    [
      "delaisser",
      0.08
    ],
    [
      "laisser",
      0.08
    ],
    [
      "passer",
      0.045
    ],
    [
      "pardonner",
      0.045
    ],
    [
      "omettre",
      0.045
    ],
    [
      "lacher",
      0.045
    ],
    [
      "manquer",
      0.035
    ],
    [
      "transgresser",
      0.0225
    ],
    [
      "sauter",
      0.0225
    ],
    [
      "pecher",
      0.0225
    ],
    [
      "perdre",
      0.0225
    ],
    [
      "manger",
      0.0225
    ],
    [
      "excepter",
      0.0225
    ],
    [
      "meconnaitre",
      0.01
    ],
    [
      "noyer",
      0.01
    ],
    [
      "faillir",
      0.01
    ],
    [
      "enterrer",
      0.01
    ],
    [
      "effacer",
      0.01
    ],
    [
      "deserter",
      0.01
    ],
    [
      "desapprendre",
      0.01
    ],
    [
      "dormir",
      0.01
    ],
    [
      "amnistier",
      0.01
    ],
    [
      "epargner",
      0.01
    ]
  ],
  "condamner": [
    [
      "blamer",
      0.085
    ],
    [
      "critiquer",
      0.0575
    ],
    [
      "reprimander",
      0.05
    ],
    [
      "tancer",
      0.05
    ],
    [
      "censurer",
      0.045
    ],
    [
      "reprouver",
      0.045
    ],
    [
      "fletrir",
      0.035
    ],
    [
      "desapprouver",
      0.03
    ],
    [
      "fermer",
      0.03
    ],
    [
      "reprocher",
      0.0275
    ],
    [
      "vituperer",
      0.0225
    ],
    [
      "forcer",
      0.0175
    ],
    [
      "stigmatiser",
      0.0175
    ],
    [
      "punir",
      0.015
    ],
    [
      "obliger",
      0.015
    ],
    [
      "interdire",
      0.015
    ],
    [
      "imposer",
      0.015
    ],
    [
      "fustiger",
      0.015
    ],
    [
      "frapper",
      0.015
    ],
    [
      "empecher",
      0.015
    ],
    [
      "defendre",
      0.015
    ],
    [
      "contraindre",
      0.015
    ],
    [
      "charger",
      0.015
    ],
    [
      "boucher",
      0.015
    ],
    [
      "barrer",
      0.015
    ],
    [
      "assujettir",
      0.015
    ],
    [
      "sevir",
      0.01
    ],
    [
      "proscrire",
      0.01
    ],
    [
      "obstruer",
      0.01
    ],
    [
      "bloquer",
      0.01
    ],
    [
      "astreindre",
      0.01
    ],
    [
      "anathematiser",
      0.01
    ],
    [
      "perdre",
      0.0075
    ],
    [
      "prohiber",
      0.0075
    ],
    [
      "rejeter",
      0.0075
    ],
    [
      "reprendre",
      0.0075
    ],
    [
      "reduire",
      0.0075
    ],
    [
      "sermonner",
      0.0075
    ],
    [
      "epiloguer",
      0.0075
    ],
    [
      "occuper",
      0.0075
    ],
    [
      "obturer",
      0.0075
    ],
    [
      "accabler",
      0.0075
    ],
    [
      "bannir",
      0.0075
    ],
    [
      "barricader",
      0.0075
    ],
    [
      "damner",
      0.0075
    ],
    [
      "incriminer",
      0.0075
    ],
    [
      "maudire",
      0.0075
    ],
    [
      "maconner",
      0.0075
    ],
    [
      "vouer",
      0.0025
    ],
    [
      "sanctionner",
      0.0025
    ],
    [
      "necessiter",
      0.0025
    ],
    [
      "murer",
      0.0025
    ],
    [
      "improuver",
      0.0025
    ],
    [
      "executer",
      0.0025
    ],
    [
      "desavouer",
      0.0025
    ],
    [
      "dejuger",
      0.0025
    ]
  ],
  "voie": [
    [
      "chemin",
      0.1075
    ],
    [
      "passage",
      0.055
    ],
    [
      "route",
      0.055
    ],
    [
      "moyen",
      0.045
    ],
    [
      "avenue",
      0.04
    ],
    [
      "rue",
      0.04
    ],
    [
      "marche",
      0.03
    ],
    [
      "cours",
      0.03
    ],
    [
      "chaussee",
      0.03
    ],
    [
      "allee",
      0.03
    ],
    [
      "canal",
      0.025
    ],
    [
      "direction",
      0.025
    ],
    [
      "truc",
      0.02
    ],
    [
      "trace",
      0.02
    ],
    [
      "sentier",
      0.02
    ],
    [
      "methode",
      0.02
    ],
    [
      "ligne",
      0.02
    ],
    [
      "couloir",
      0.02
    ],
    [
      "conduit",
      0.02
    ],
    [
      "boulevard",
      0.02
    ],
    [
      "trajet",
      0.0125
    ],
    [
      "piste",
      0.0125
    ],
    [
      "maniere",
      0.0125
    ],
    [
      "conduite",
      0.0125
    ],
    [
      "artere",
      0.0125
    ],
    [
      "train",
      0.01
    ],
    [
      "sillon",
      0.01
    ],
    [
      "sillage",
      0.01
    ],
    [
      "promenade",
      0.01
    ],
    [
      "levee",
      0.01
    ],
    [
      "itineraire",
      0.01
    ],
    [
      "intermediaire",
      0.01
    ],
    [
      "foulee",
      0.01
    ],
    [
      "asphalte",
      0.01
    ],
    [
      "biais",
      0.01
    ],
    [
      "chenal",
      0.01
    ],
    [
      "detour",
      0.01
    ],
    [
      "entremise",
      0.01
    ],
    [
      "instrument",
      0.0025
    ],
    [
      "rails",
      0.0025
    ],
    [
      "rocade",
      0.0025
    ],
    [
      "ruelle",
      0.0025
    ],
    [
      "reseau",
      0.0025
    ],
    [
      "sente",
      0.0025
    ],
    [
      "talus",
      0.0025
    ],
    [
      "traboule",
      0.0025
    ],
    [
      "trimard",
      0.0025
    ],
    [
      "impasse",
      0.0025
    ],
    [
      "expedient",
      0.0025
    ],
    [
      "autoroute",
      0.0025
    ],
    [
      "autostrade",
      0.0025
    ],
    [
      "axe",
      0.0025
    ],
    [
      "ballast",
      0.0025
    ],
    [
      "brisees",
      0.0025
    ],
    [
      "carriere",
      0.0025
    ],
    [
      "dessein",
      0.0025
    ],
    [
      "draille",
      0.0025
    ],
    [
      "exemple",
      0.0025
    ],
    [
      "truchement",
      0.0025
    ]
  ],
  "eteint": [
    [
      "diminuer",
      0.0675
    ],
    [
      "moderer",
      0.0675
    ],
    [
      "temperer",
      0.045
    ],
    [
      "attenuer",
      0.045
    ],
    [
      "amortir",
      0.045
    ],
    [
      "adoucir",
      0.045
    ],
    [
      "calmer",
      0.04
    ],
    [
      "detruire",
      0.04
    ],
    [
      "obscurcir",
      0.035
    ],
    [
      "etouffer",
      0.035
    ],
    [
      "estomper",
      0.03
    ],
    [
      "effacer",
      0.03
    ],
    [
      "affaiblir",
      0.03
    ],
    [
      "aneantir",
      0.025
    ],
    [
      "apaiser",
      0.025
    ],
    [
      "supprimer",
      0.025
    ],
    [
      "ternir",
      0.025
    ],
    [
      "voiler",
      0.025
    ],
    [
      "emousser",
      0.02
    ],
    [
      "freiner",
      0.02
    ],
    [
      "tamiser",
      0.015
    ],
    [
      "passer",
      0.015
    ],
    [
      "liquider",
      0.015
    ],
    [
      "endormir",
      0.015
    ],
    [
      "couvrir",
      0.015
    ],
    [
      "contenir",
      0.015
    ],
    [
      "assoupir",
      0.015
    ],
    [
      "annuler",
      0.015
    ],
    [
      "abolir",
      0.015
    ],
    [
      "resilier",
      0.01
    ],
    [
      "refrener",
      0.01
    ],
    [
      "refroidir",
      0.01
    ],
    [
      "ralentir",
      0.01
    ],
    [
      "faner",
      0.01
    ],
    [
      "assouvir",
      0.01
    ],
    [
      "tarir",
      0.005
    ],
    [
      "souffler",
      0.005
    ],
    [
      "solder",
      0.005
    ],
    [
      "fermer",
      0.005
    ],
    [
      "exterminer",
      0.005
    ],
    [
      "atrophier",
      0.005
    ],
    [
      "assourdir",
      0.005
    ],
    [
      "assombrir",
      0.005
    ],
    [
      "acquitter",
      0.005
    ],
    [
      "etancher",
      0.005
    ]
  ],
  "eteindre": [
    [
      "diminuer",
      0.0675
    ],
    [
      "moderer",
      0.0675
    ],
    [
      "temperer",
      0.045
    ],
    [
      "attenuer",
      0.045
    ],
    [
      "amortir",
      0.045
    ],
    [
      "adoucir",
      0.045
    ],
    [
      "calmer",
      0.04
    ],
    [
      "detruire",
      0.04
    ],
    [
      "obscurcir",
      0.035
    ],
    [
      "etouffer",
      0.035
    ],
    [
      "estomper",
      0.03
    ],
    [
      "effacer",
      0.03
    ],
    [
      "affaiblir",
      0.03
    ],
    [
      "aneantir",
      0.025
    ],
    [
      "apaiser",
      0.025
    ],
    [
      "supprimer",
      0.025
    ],
    [
      "ternir",
      0.025
    ],
    [
      "voiler",
      0.025
    ],
    [
      "emousser",
      0.02
    ],
    [
      "freiner",
      0.02
    ],
    [
      "tamiser",
      0.015
    ],
    [
      "passer",
      0.015
    ],
    [
      "liquider",
      0.015
    ],
    [
      "endormir",
      0.015
    ],
    [
      "couvrir",
      0.015
    ],
    [
      "contenir",
      0.015
    ],
    [
      "assoupir",
      0.015
    ],
    [
      "annuler",
      0.015
    ],
    [
      "abolir",
      0.015
    ],
    [
      "resilier",
      0.01
    ],
    [
      "refrener",
      0.01
    ],
    [
      "refroidir",
      0.01
    ],
    [
      "ralentir",
      0.01
    ],
    [
      "faner",
      0.01
    ],
    [
      "assouvir",
      0.01
    ],
    [
      "tarir",
      0.005
    ],
    [
      "souffler",
      0.005
    ],
    [
      "solder",
      0.005
    ],
    [
      "fermer",
      0.005
    ],
    [
      "exterminer",
      0.005
    ],
    [
      "atrophier",
      0.005
    ],
    [
      "assourdir",
      0.005
    ],
    [
      "assombrir",
      0.005
    ],
    [
      "acquitter",
      0.005
    ],
    [
      "etancher",
      0.005
    ]
  ],
  "reperage": [
    [
      "depistage",
      0.5
    ],
    [
      "detection",
      0.5
    ]
  ],
  "reseau": [
    [
      "enchevetrement",
      0.1
    ],
    [
      "lacis",
      0.1
    ],
    [
      "engrenage",
      0.075
    ],
    [
      "entrelacement",
      0.075
    ],
    [
      "filet",
      0.075
    ],
    [
      "tissu",
      0.05
    ],
    [
      "piege",
      0.05
    ],
    [
      "labyrinthe",
      0.05
    ],
    [
      "dedale",
      0.05
    ],
    [
      "complication",
      0.05
    ],
    [
      "chaine",
      0.05
    ],
    [
      "reticule",
      0.0225
    ],
    [
      "resille",
      0.0225
    ],
    [
      "rets",
      0.0225
    ],
    [
      "organisation",
      0.0225
    ],
    [
      "lacs",
      0.0225
    ],
    [
      "entrelacs",
      0.0225
    ],
    [
      "enlacement",
      0.0225
    ],
    [
      "confusion",
      0.0225
    ],
    [
      "canalisation",
      0.0225
    ],
    [
      "voie",
      0.0225
    ]
  ],
  "lolo": [
    [
      "sein",
      1.0
    ]
  ],
  "connaitre": [
    [
      "voir",
      0.0925
    ],
    [
      "entendre",
      0.08
    ],
    [
      "comprendre",
      0.0675
    ],
    [
      "percevoir",
      0.0625
    ],
    [
      "sentir",
      0.055
    ],
    [
      "penetrer",
      0.055
    ],
    [
      "apercevoir",
      0.055
    ],
    [
      "eprouver",
      0.0425
    ],
    [
      "apprehender",
      0.0325
    ],
    [
      "concevoir",
      0.0325
    ],
    [
      "discerner",
      0.0325
    ],
    [
      "savoir",
      0.0275
    ],
    [
      "prendre",
      0.025
    ],
    [
      "apprecier",
      0.02
    ],
    [
      "constater",
      0.02
    ],
    [
      "juger",
      0.02
    ],
    [
      "subir",
      0.02
    ],
    [
      "ressentir",
      0.015
    ],
    [
      "penser",
      0.015
    ],
    [
      "embrasser",
      0.015
    ],
    [
      "considerer",
      0.015
    ],
    [
      "posseder",
      0.0125
    ],
    [
      "experimenter",
      0.0125
    ],
    [
      "estimer",
      0.0125
    ],
    [
      "apprendre",
      0.0125
    ],
    [
      "s'apercevoir",
      0.0075
    ],
    [
      "reconnaitre",
      0.0075
    ],
    [
      "pratiquer",
      0.0075
    ],
    [
      "entrevoir",
      0.0075
    ],
    [
      "endurer",
      0.0075
    ],
    [
      "supporter",
      0.0025
    ],
    [
      "s'occuper",
      0.0025
    ],
    [
      "assavoir",
      0.0025
    ]
  ],
  "vendu": [
    [
      "donner",
      0.11
    ],
    [
      "solder",
      0.0625
    ],
    [
      "laisser",
      0.055
    ],
    [
      "liquider",
      0.055
    ],
    [
      "trafiquer",
      0.045
    ],
    [
      "livrer",
      0.035
    ],
    [
      "faire",
      0.035
    ],
    [
      "brader",
      0.035
    ],
    [
      "ecouler",
      0.025
    ],
    [
      "echanger",
      0.025
    ],
    [
      "prostituer",
      0.025
    ],
    [
      "offrir",
      0.025
    ],
    [
      "fournir",
      0.025
    ],
    [
      "debiter",
      0.025
    ],
    [
      "ceder",
      0.025
    ],
    [
      "brocanter",
      0.025
    ],
    [
      "bazarder",
      0.025
    ],
    [
      "aliener",
      0.025
    ],
    [
      "violer",
      0.0175
    ],
    [
      "trahir",
      0.0175
    ],
    [
      "sacrifier",
      0.0175
    ],
    [
      "realiser",
      0.0175
    ],
    [
      "placer",
      0.0175
    ],
    [
      "laver",
      0.0175
    ],
    [
      "coller",
      0.0175
    ],
    [
      "negocier",
      0.0075
    ],
    [
      "mevendre",
      0.0075
    ],
    [
      "monnayer",
      0.0075
    ],
    [
      "lessiver",
      0.0075
    ],
    [
      "exporter",
      0.0075
    ],
    [
      "detailler",
      0.0075
    ],
    [
      "denoncer",
      0.0075
    ],
    [
      "cameloter",
      0.0075
    ],
    [
      "adjuger",
      0.0075
    ]
  ],
  "meche": [
    [
      "boucle",
      0.0725
    ],
    [
      "coiffure",
      0.0725
    ],
    [
      "intelligence",
      0.0725
    ],
    [
      "touffe",
      0.0725
    ],
    [
      "mouchette",
      0.035
    ],
    [
      "moyen",
      0.035
    ],
    [
      "rouflaquette",
      0.035
    ],
    [
      "toupet",
      0.035
    ],
    [
      "vrille",
      0.035
    ],
    [
      "epi",
      0.035
    ],
    [
      "moucheron",
      0.035
    ],
    [
      "lumignon",
      0.035
    ],
    [
      "houppe",
      0.035
    ],
    [
      "guiche",
      0.035
    ],
    [
      "fouet",
      0.035
    ],
    [
      "cordeau",
      0.035
    ],
    [
      "connivence",
      0.035
    ],
    [
      "chichi",
      0.035
    ],
    [
      "bickford",
      0.035
    ],
    [
      "banane",
      0.035
    ],
    [
      "etoupille",
      0.035
    ]
  ],
  "connu": [
    [
      "voir",
      0.0925
    ],
    [
      "entendre",
      0.08
    ],
    [
      "comprendre",
      0.0675
    ],
    [
      "percevoir",
      0.0625
    ],
    [
      "sentir",
      0.055
    ],
    [
      "penetrer",
      0.055
    ],
    [
      "apercevoir",
      0.055
    ],
    [
      "eprouver",
      0.0425
    ],
    [
      "apprehender",
      0.0325
    ],
    [
      "concevoir",
      0.0325
    ],
    [
      "discerner",
      0.0325
    ],
    [
      "savoir",
      0.0275
    ],
    [
      "prendre",
      0.025
    ],
    [
      "apprecier",
      0.02
    ],
    [
      "constater",
      0.02
    ],
    [
      "juger",
      0.02
    ],
    [
      "subir",
      0.02
    ],
    [
      "ressentir",
      0.015
    ],
    [
      "penser",
      0.015
    ],
    [
      "embrasser",
      0.015
    ],
    [
      "considerer",
      0.015
    ],
    [
      "posseder",
      0.0125
    ],
    [
      "experimenter",
      0.0125
    ],
    [
      "estimer",
      0.0125
    ],
    [
      "apprendre",
      0.0125
    ],
    [
      "s'apercevoir",
      0.0075
    ],
    [
      "reconnaitre",
      0.0075
    ],
    [
      "pratiquer",
      0.0075
    ],
    [
      "entrevoir",
      0.0075
    ],
    [
      "endurer",
      0.0075
    ],
    [
      "supporter",
      0.0025
    ],
    [
      "s'occuper",
      0.0025
    ],
    [
      "assavoir",
      0.0025
    ]
  ],
  "deche": [
    [
      "misere",
      0.17
    ],
    [
      "pauvrete",
      0.17
    ],
    [
      "besoin",
      0.0975
    ],
    [
      "denuement",
      0.0975
    ],
    [
      "puree",
      0.0725
    ],
    [
      "poisse",
      0.0725
    ],
    [
      "indigence",
      0.0725
    ],
    [
      "gene",
      0.0725
    ],
    [
      "necessite",
      0.0475
    ],
    [
      "penurie",
      0.0475
    ],
    [
      "debine",
      0.0225
    ],
    [
      "mouscaille",
      0.0225
    ],
    [
      "mediocrite",
      0.0225
    ]
  ],
  "client": [
    [
      "acheteur",
      0.1725
    ],
    [
      "pratique",
      0.1375
    ],
    [
      "chaland",
      0.1025
    ],
    [
      "acquereur",
      0.0675
    ],
    [
      "individu",
      0.0325
    ],
    [
      "malade",
      0.0325
    ],
    [
      "patient",
      0.0325
    ],
    [
      "preneur",
      0.0325
    ],
    [
      "prospect",
      0.0325
    ],
    [
      "protege",
      0.0325
    ],
    [
      "importateur",
      0.0325
    ],
    [
      "habitue",
      0.0325
    ],
    [
      "fidele",
      0.0325
    ],
    [
      "demandeur",
      0.0325
    ],
    [
      "consommateur",
      0.0325
    ],
    [
      "clille",
      0.0325
    ],
    [
      "clientele",
      0.0325
    ],
    [
      "amateur",
      0.0325
    ],
    [
      "type",
      0.0325
    ]
  ],
  "bah": [
    [
      "baste",
      1.0
    ]
  ],
  "taro": [
    [
      "colocase",
      1.0
    ]
  ],
  "galerer": [],
  "galer": [],
  "monter": [
    [
      "elever",
      0.0525
    ],
    [
      "augmenter",
      0.05
    ],
    [
      "hausser",
      0.05
    ],
    [
      "relever",
      0.035
    ],
    [
      "faire",
      0.03
    ],
    [
      "disposer",
      0.025
    ],
    [
      "preparer",
      0.025
    ],
    [
      "soulever",
      0.025
    ],
    [
      "prendre",
      0.02
    ],
    [
      "rehausser",
      0.02
    ],
    [
      "combiner",
      0.02
    ],
    [
      "etablir",
      0.02
    ],
    [
      "s'elever",
      0.0175
    ],
    [
      "dresser",
      0.015
    ],
    [
      "creer",
      0.015
    ],
    [
      "batir",
      0.015
    ],
    [
      "aller",
      0.015
    ],
    [
      "organiser",
      0.0125
    ],
    [
      "lever",
      0.0125
    ],
    [
      "grandir",
      0.0125
    ],
    [
      "entrer",
      0.0125
    ],
    [
      "enlever",
      0.0125
    ],
    [
      "atteindre",
      0.0125
    ],
    [
      "assembler",
      0.0125
    ],
    [
      "agencer",
      0.0125
    ],
    [
      "rencherir",
      0.0125
    ],
    [
      "porter",
      0.0125
    ],
    [
      "fabriquer",
      0.0125
    ],
    [
      "arriver",
      0.0125
    ],
    [
      "surhausser",
      0.0075
    ],
    [
      "remonter",
      0.0075
    ],
    [
      "grossir",
      0.0075
    ],
    [
      "exhausser",
      0.0075
    ],
    [
      "exciter",
      0.0075
    ],
    [
      "couvrir",
      0.0075
    ],
    [
      "ajuster",
      0.0075
    ],
    [
      "voler",
      0.0075
    ],
    [
      "tisser",
      0.0075
    ],
    [
      "surelever",
      0.0075
    ],
    [
      "revaloriser",
      0.0075
    ],
    [
      "parvenir",
      0.0075
    ],
    [
      "mijoter",
      0.0075
    ],
    [
      "grimper",
      0.0075
    ],
    [
      "croitre",
      0.0075
    ],
    [
      "appareiller",
      0.0075
    ],
    [
      "manigancer",
      0.005
    ],
    [
      "ourdir",
      0.005
    ],
    [
      "percer",
      0.005
    ],
    [
      "s'accroitre",
      0.005
    ],
    [
      "tramer",
      0.005
    ],
    [
      "majorer",
      0.005
    ],
    [
      "jouer",
      0.005
    ],
    [
      "installer",
      0.005
    ],
    [
      "constituer",
      0.005
    ],
    [
      "escalader",
      0.005
    ],
    [
      "forcer",
      0.005
    ],
    [
      "franchir",
      0.005
    ],
    [
      "gravir",
      0.005
    ],
    [
      "hisser",
      0.005
    ],
    [
      "reussir",
      0.0025
    ],
    [
      "s'accoupler",
      0.0025
    ],
    [
      "s'engouffrer",
      0.0025
    ],
    [
      "s'envoler",
      0.0025
    ],
    [
      "sertir",
      0.0025
    ],
    [
      "servir",
      0.0025
    ],
    [
      "tresser",
      0.0025
    ],
    [
      "echafauder",
      0.0025
    ],
    [
      "realiser",
      0.0025
    ],
    [
      "redoubler",
      0.0025
    ],
    [
      "affluer",
      0.0025
    ],
    [
      "aviver",
      0.0025
    ],
    [
      "doubler",
      0.0025
    ],
    [
      "embarquer",
      0.0025
    ],
    [
      "enchasser",
      0.0025
    ],
    [
      "machiner",
      0.0025
    ],
    [
      "nouer",
      0.0025
    ],
    [
      "planter",
      0.0025
    ],
    [
      "pourvoir",
      0.0025
    ],
    [
      "procurer",
      0.0025
    ],
    [
      "progresser",
      0.0025
    ],
    [
      "s'installer",
      0.0
    ],
    [
      "s'intensifier",
      0.0
    ],
    [
      "s'echapper",
      0.0
    ],
    [
      "s'edifier",
      0.0
    ],
    [
      "saillir",
      0.0
    ],
    [
      "s'embarquer",
      0.0
    ],
    [
      "s'amplifier",
      0.0
    ],
    [
      "s'accentuer",
      0.0
    ],
    [
      "mitonner",
      0.0
    ],
    [
      "enfourcher",
      0.0
    ],
    [
      "enchatonner",
      0.0
    ],
    [
      "coudre",
      0.0
    ],
    [
      "chevaucher",
      0.0
    ],
    [
      "ascensionner",
      0.0
    ]
  ],
  "bolide": [
    [
      "aerolithe",
      0.1875
    ],
    [
      "meteore",
      0.125
    ],
    [
      "meteorite",
      0.125
    ],
    [
      "trombe",
      0.06
    ],
    [
      "projectile",
      0.06
    ],
    [
      "pierre",
      0.06
    ],
    [
      "fusee",
      0.06
    ],
    [
      "asteroide",
      0.06
    ]
  ],
  "fondre": [
    [
      "foncer",
      0.0475
    ],
    [
      "attaquer",
      0.0375
    ],
    [
      "disparaitre",
      0.0375
    ],
    [
      "reunir",
      0.0275
    ],
    [
      "diminuer",
      0.0275
    ],
    [
      "amalgamer",
      0.0275
    ],
    [
      "confondre",
      0.0225
    ],
    [
      "dissoudre",
      0.0225
    ],
    [
      "s'elancer",
      0.0225
    ],
    [
      "unir",
      0.0175
    ],
    [
      "s'evanouir",
      0.0175
    ],
    [
      "piquer",
      0.0175
    ],
    [
      "maigrir",
      0.0175
    ],
    [
      "couler",
      0.0175
    ],
    [
      "s'aneantir",
      0.0125
    ],
    [
      "s'abimer",
      0.0125
    ],
    [
      "melanger",
      0.0125
    ],
    [
      "integrer",
      0.0125
    ],
    [
      "incorporer",
      0.0125
    ],
    [
      "fusionner",
      0.0125
    ],
    [
      "fuser",
      0.0125
    ],
    [
      "adoucir",
      0.0125
    ],
    [
      "aneantir",
      0.0125
    ],
    [
      "attenuer",
      0.0125
    ],
    [
      "charger",
      0.0125
    ],
    [
      "courir",
      0.0125
    ],
    [
      "filer",
      0.0125
    ],
    [
      "reduire",
      0.0075
    ],
    [
      "s'abattre",
      0.0075
    ],
    [
      "surprendre",
      0.0075
    ],
    [
      "nuancer",
      0.0075
    ],
    [
      "meler",
      0.0075
    ],
    [
      "liquefier",
      0.0075
    ],
    [
      "assimiler",
      0.0075
    ],
    [
      "degeler",
      0.0075
    ],
    [
      "degrader",
      0.0075
    ],
    [
      "delayer",
      0.0075
    ],
    [
      "estomper",
      0.0075
    ],
    [
      "grouper",
      0.0075
    ],
    [
      "refondre",
      0.0025
    ],
    [
      "resoudre",
      0.0025
    ],
    [
      "s'amollir",
      0.0025
    ],
    [
      "s'attendrir",
      0.0025
    ],
    [
      "s'emacier",
      0.0025
    ],
    [
      "parfondre",
      0.0025
    ],
    [
      "mouler",
      0.0025
    ],
    [
      "mincir",
      0.0025
    ],
    [
      "amaigrir",
      0.0025
    ],
    [
      "assaillir",
      0.0025
    ],
    [
      "attendrir",
      0.0025
    ],
    [
      "bruler",
      0.0025
    ],
    [
      "dissiper",
      0.0025
    ],
    [
      "deglacer",
      0.0025
    ],
    [
      "desagreger",
      0.0025
    ],
    [
      "effacer",
      0.0025
    ],
    [
      "geminer",
      0.0025
    ],
    [
      "harmoniser",
      0.0025
    ],
    [
      "vitrifier",
      0.0025
    ]
  ],
  "fond": [
    [
      "coeur",
      0.055
    ],
    [
      "matiere",
      0.05
    ],
    [
      "profondeur",
      0.045
    ],
    [
      "substance",
      0.0375
    ],
    [
      "sujet",
      0.0375
    ],
    [
      "ame",
      0.0375
    ],
    [
      "nature",
      0.0325
    ],
    [
      "fondement",
      0.0325
    ],
    [
      "fermete",
      0.0325
    ],
    [
      "base",
      0.0325
    ],
    [
      "esprit",
      0.0275
    ],
    [
      "solidite",
      0.0275
    ],
    [
      "secret",
      0.02
    ],
    [
      "interieur",
      0.02
    ],
    [
      "essence",
      0.02
    ],
    [
      "enfoncement",
      0.02
    ],
    [
      "creux",
      0.02
    ],
    [
      "champ",
      0.02
    ],
    [
      "caractere",
      0.02
    ],
    [
      "trefonds",
      0.015
    ],
    [
      "theme",
      0.015
    ],
    [
      "sein",
      0.015
    ],
    [
      "perspective",
      0.015
    ],
    [
      "objet",
      0.015
    ],
    [
      "noeud",
      0.015
    ],
    [
      "naturel",
      0.015
    ],
    [
      "intime",
      0.015
    ],
    [
      "essentiel",
      0.015
    ],
    [
      "culot",
      0.01
    ],
    [
      "extremite",
      0.01
    ],
    [
      "fable",
      0.01
    ],
    [
      "idee",
      0.01
    ],
    [
      "plan",
      0.01
    ],
    [
      "cul",
      0.01
    ],
    [
      "cran",
      0.01
    ],
    [
      "bout",
      0.01
    ],
    [
      "bas",
      0.01
    ],
    [
      "assise",
      0.01
    ],
    [
      "assiette",
      0.01
    ],
    [
      "renfoncement",
      0.0025
    ],
    [
      "residu",
      0.0025
    ],
    [
      "substrat",
      0.0025
    ],
    [
      "substratum",
      0.0025
    ],
    [
      "tissure",
      0.0025
    ],
    [
      "toile",
      0.0025
    ],
    [
      "vif",
      0.0025
    ],
    [
      "lointain",
      0.0025
    ],
    [
      "fonds",
      0.0025
    ],
    [
      "derriere",
      0.0025
    ],
    [
      "cuvette",
      0.0025
    ],
    [
      "contrecoeur",
      0.0025
    ],
    [
      "contenu",
      0.0025
    ],
    [
      "bassesse",
      0.0025
    ],
    [
      "affabulation",
      0.0025
    ],
    [
      "abysse",
      0.0025
    ],
    [
      "etoffe",
      0.0025
    ]
  ],
  "roule": [
    [
      "tromper",
      0.1025
    ],
    [
      "duper",
      0.0425
    ],
    [
      "berner",
      0.0375
    ],
    [
      "remuer",
      0.0375
    ],
    [
      "voler",
      0.0325
    ],
    [
      "abuser",
      0.0325
    ],
    [
      "avoir",
      0.03
    ],
    [
      "refaire",
      0.03
    ],
    [
      "flouer",
      0.0275
    ],
    [
      "posseder",
      0.0275
    ],
    [
      "escroquer",
      0.025
    ],
    [
      "mystifier",
      0.0225
    ],
    [
      "jouer",
      0.02
    ],
    [
      "battre",
      0.015
    ],
    [
      "gruger",
      0.015
    ],
    [
      "pigeonner",
      0.015
    ],
    [
      "tourner",
      0.015
    ],
    [
      "porter",
      0.01
    ],
    [
      "tomber",
      0.01
    ],
    [
      "traiter",
      0.01
    ],
    [
      "marcher",
      0.01
    ],
    [
      "envelopper",
      0.01
    ],
    [
      "enrouler",
      0.01
    ],
    [
      "empiler",
      0.01
    ],
    [
      "empaumer",
      0.01
    ],
    [
      "charrier",
      0.01
    ],
    [
      "carotter",
      0.01
    ],
    [
      "tortiller",
      0.01
    ],
    [
      "naviguer",
      0.01
    ],
    [
      "entuber",
      0.01
    ],
    [
      "entrainer",
      0.01
    ],
    [
      "entortiller",
      0.01
    ],
    [
      "emporter",
      0.01
    ],
    [
      "couler",
      0.01
    ],
    [
      "balancer",
      0.01
    ],
    [
      "ruminer",
      0.005
    ],
    [
      "toucher",
      0.005
    ],
    [
      "transporter",
      0.005
    ],
    [
      "triompher",
      0.005
    ],
    [
      "vaincre",
      0.005
    ],
    [
      "preparer",
      0.005
    ],
    [
      "projeter",
      0.005
    ],
    [
      "baiser",
      0.005
    ],
    [
      "circuler",
      0.005
    ],
    [
      "degringoler",
      0.005
    ],
    [
      "exploiter",
      0.005
    ],
    [
      "faconner",
      0.005
    ],
    [
      "glisser",
      0.005
    ],
    [
      "pousser",
      0.005
    ],
    [
      "ecraser",
      0.005
    ],
    [
      "reposer",
      0.005
    ],
    [
      "plier",
      0.005
    ],
    [
      "onduler",
      0.005
    ],
    [
      "mediter",
      0.005
    ],
    [
      "leurrer",
      0.005
    ],
    [
      "feinter",
      0.005
    ],
    [
      "deplacer",
      0.005
    ],
    [
      "dodeliner",
      0.005
    ],
    [
      "bouler",
      0.005
    ],
    [
      "remacher",
      0.0
    ],
    [
      "penser",
      0.0
    ],
    [
      "peloter",
      0.0
    ],
    [
      "lover",
      0.0
    ],
    [
      "ressasser",
      0.0
    ],
    [
      "ronfler",
      0.0
    ],
    [
      "s'ebouler",
      0.0
    ],
    [
      "tonner",
      0.0
    ],
    [
      "voiturer",
      0.0
    ],
    [
      "emotter",
      0.0
    ],
    [
      "houler",
      0.0
    ],
    [
      "gronder",
      0.0
    ],
    [
      "errer",
      0.0
    ],
    [
      "bicher",
      0.0
    ],
    [
      "bourlinguer",
      0.0
    ],
    [
      "debouler",
      0.0
    ],
    [
      "dechoir",
      0.0
    ],
    [
      "dependre",
      0.0
    ],
    [
      "devaler",
      0.0
    ],
    [
      "empaqueter",
      0.0
    ],
    [
      "enfiler",
      0.0
    ],
    [
      "enrober",
      0.0
    ]
  ],
  "rouler": [
    [
      "tromper",
      0.1025
    ],
    [
      "duper",
      0.0425
    ],
    [
      "berner",
      0.0375
    ],
    [
      "remuer",
      0.0375
    ],
    [
      "voler",
      0.0325
    ],
    [
      "abuser",
      0.0325
    ],
    [
      "avoir",
      0.03
    ],
    [
      "refaire",
      0.03
    ],
    [
      "flouer",
      0.0275
    ],
    [
      "posseder",
      0.0275
    ],
    [
      "escroquer",
      0.025
    ],
    [
      "mystifier",
      0.0225
    ],
    [
      "jouer",
      0.02
    ],
    [
      "battre",
      0.015
    ],
    [
      "gruger",
      0.015
    ],
    [
      "pigeonner",
      0.015
    ],
    [
      "tourner",
      0.015
    ],
    [
      "porter",
      0.01
    ],
    [
      "tomber",
      0.01
    ],
    [
      "traiter",
      0.01
    ],
    [
      "marcher",
      0.01
    ],
    [
      "envelopper",
      0.01
    ],
    [
      "enrouler",
      0.01
    ],
    [
      "empiler",
      0.01
    ],
    [
      "empaumer",
      0.01
    ],
    [
      "charrier",
      0.01
    ],
    [
      "carotter",
      0.01
    ],
    [
      "tortiller",
      0.01
    ],
    [
      "naviguer",
      0.01
    ],
    [
      "entuber",
      0.01
    ],
    [
      "entrainer",
      0.01
    ],
    [
      "entortiller",
      0.01
    ],
    [
      "emporter",
      0.01
    ],
    [
      "couler",
      0.01
    ],
    [
      "balancer",
      0.01
    ],
    [
      "ruminer",
      0.005
    ],
    [
      "toucher",
      0.005
    ],
    [
      "transporter",
      0.005
    ],
    [
      "triompher",
      0.005
    ],
    [
      "vaincre",
      0.005
    ],
    [
      "preparer",
      0.005
    ],
    [
      "projeter",
      0.005
    ],
    [
      "baiser",
      0.005
    ],
    [
      "circuler",
      0.005
    ],
    [
      "degringoler",
      0.005
    ],
    [
      "exploiter",
      0.005
    ],
    [
      "faconner",
      0.005
    ],
    [
      "glisser",
      0.005
    ],
    [
      "pousser",
      0.005
    ],
    [
      "ecraser",
      0.005
    ],
    [
      "reposer",
      0.005
    ],
    [
      "plier",
      0.005
    ],
    [
      "onduler",
      0.005
    ],
    [
      "mediter",
      0.005
    ],
    [
      "leurrer",
      0.005
    ],
    [
      "feinter",
      0.005
    ],
    [
      "deplacer",
      0.005
    ],
    [
      "dodeliner",
      0.005
    ],
    [
      "bouler",
      0.005
    ],
    [
      "remacher",
      0.0
    ],
    [
      "penser",
      0.0
    ],
    [
      "peloter",
      0.0
    ],
    [
      "lover",
      0.0
    ],
    [
      "ressasser",
      0.0
    ],
    [
      "ronfler",
      0.0
    ],
    [
      "s'ebouler",
      0.0
    ],
    [
      "tonner",
      0.0
    ],
    [
      "voiturer",
      0.0
    ],
    [
      "emotter",
      0.0
    ],
    [
      "houler",
      0.0
    ],
    [
      "gronder",
      0.0
    ],
    [
      "errer",
      0.0
    ],
    [
      "bicher",
      0.0
    ],
    [
      "bourlinguer",
      0.0
    ],
    [
      "debouler",
      0.0
    ],
    [
      "dechoir",
      0.0
    ],
    [
      "dependre",
      0.0
    ],
    [
      "devaler",
      0.0
    ],
    [
      "empaqueter",
      0.0
    ],
    [
      "enfiler",
      0.0
    ],
    [
      "enrober",
      0.0
    ]
  ],
  "ville": [
    [
      "agglomeration",
      0.2275
    ],
    [
      "centre",
      0.135
    ],
    [
      "commune",
      0.135
    ],
    [
      "cite",
      0.09
    ],
    [
      "village",
      0.09
    ],
    [
      "municipe",
      0.045
    ],
    [
      "municipalite",
      0.045
    ],
    [
      "localite",
      0.045
    ],
    [
      "capitale",
      0.045
    ],
    [
      "bourg",
      0.045
    ],
    [
      "acropole",
      0.045
    ],
    [
      "metropole",
      0.045
    ]
  ],
  "entier": [
    [
      "absolu",
      0.105
    ],
    [
      "complet",
      0.105
    ],
    [
      "total",
      0.0975
    ],
    [
      "franc",
      0.065
    ],
    [
      "parfait",
      0.0475
    ],
    [
      "pur",
      0.04
    ],
    [
      "categorique",
      0.0325
    ],
    [
      "intraitable",
      0.0325
    ],
    [
      "tout",
      0.0225
    ],
    [
      "sincere",
      0.0225
    ],
    [
      "plein",
      0.0225
    ],
    [
      "integral",
      0.0225
    ],
    [
      "intact",
      0.0225
    ],
    [
      "exclusif",
      0.0225
    ],
    [
      "entete",
      0.0225
    ],
    [
      "tetu",
      0.015
    ],
    [
      "totalite",
      0.015
    ],
    [
      "long",
      0.015
    ],
    [
      "inflexible",
      0.015
    ],
    [
      "illimite",
      0.015
    ],
    [
      "fier",
      0.015
    ],
    [
      "ensemble",
      0.015
    ],
    [
      "brutal",
      0.015
    ],
    [
      "acheve",
      0.015
    ],
    [
      "opiniatre",
      0.0075
    ],
    [
      "orgueilleux",
      0.0075
    ],
    [
      "plenier",
      0.0075
    ],
    [
      "rigide",
      0.0075
    ],
    [
      "unanime",
      0.0075
    ],
    [
      "obstine",
      0.0075
    ],
    [
      "loyal",
      0.0075
    ],
    [
      "integralite",
      0.0075
    ],
    [
      "arrete",
      0.0075
    ],
    [
      "autoritaire",
      0.0075
    ],
    [
      "aveugle",
      0.0075
    ],
    [
      "definitif",
      0.0075
    ],
    [
      "formel",
      0.0075
    ],
    [
      "global",
      0.0075
    ],
    [
      "indemne",
      0.0075
    ],
    [
      "integre",
      0.0075
    ],
    [
      "egoiste",
      0.0075
    ]
  ],
  "allumer": [
    [
      "exciter",
      0.15
    ],
    [
      "enflammer",
      0.09
    ],
    [
      "animer",
      0.0775
    ],
    [
      "provoquer",
      0.0775
    ],
    [
      "attiser",
      0.065
    ],
    [
      "susciter",
      0.0375
    ],
    [
      "soulever",
      0.03
    ],
    [
      "embraser",
      0.03
    ],
    [
      "dechainer",
      0.03
    ],
    [
      "aiguillonner",
      0.03
    ],
    [
      "emoustiller",
      0.025
    ],
    [
      "inspirer",
      0.025
    ],
    [
      "causer",
      0.025
    ],
    [
      "aviver",
      0.025
    ],
    [
      "aguicher",
      0.025
    ],
    [
      "eperonner",
      0.0175
    ],
    [
      "occasionner",
      0.0175
    ],
    [
      "fouetter",
      0.0175
    ],
    [
      "fomenter",
      0.0175
    ],
    [
      "declencher",
      0.0175
    ],
    [
      "bruler",
      0.0175
    ],
    [
      "illuminer",
      0.0125
    ],
    [
      "exasperer",
      0.0125
    ],
    [
      "agacer",
      0.0125
    ],
    [
      "eclairer",
      0.005
    ],
    [
      "vamper",
      0.005
    ],
    [
      "soutenir",
      0.005
    ],
    [
      "incendier",
      0.005
    ],
    [
      "frotter",
      0.005
    ],
    [
      "fonctionner",
      0.005
    ],
    [
      "commencer",
      0.005
    ],
    [
      "bouter",
      0.005
    ],
    [
      "eprendre",
      0.005
    ]
  ],
  "graver": [
    [
      "marquer",
      0.1775
    ],
    [
      "inscrire",
      0.1175
    ],
    [
      "imprimer",
      0.0975
    ],
    [
      "buriner",
      0.0575
    ],
    [
      "empreindre",
      0.0575
    ],
    [
      "fixer",
      0.0575
    ],
    [
      "incruster",
      0.0575
    ],
    [
      "ecrire",
      0.0375
    ],
    [
      "tracer",
      0.0375
    ],
    [
      "tatouer",
      0.0175
    ],
    [
      "sculpter",
      0.0175
    ],
    [
      "poinconner",
      0.0175
    ],
    [
      "nieller",
      0.0175
    ],
    [
      "lithographier",
      0.0175
    ],
    [
      "intailler",
      0.0175
    ],
    [
      "insculper",
      0.0175
    ],
    [
      "inculquer",
      0.0175
    ],
    [
      "immortaliser",
      0.0175
    ],
    [
      "guillocher",
      0.0175
    ],
    [
      "estamper",
      0.0175
    ],
    [
      "enregistrer",
      0.0175
    ],
    [
      "engraver",
      0.0175
    ],
    [
      "dessiner",
      0.0175
    ],
    [
      "echopper",
      0.0175
    ]
  ],
  "ancien": [
    [
      "vieux",
      0.15
    ],
    [
      "antique",
      0.1025
    ],
    [
      "demode",
      0.06
    ],
    [
      "suranne",
      0.055
    ],
    [
      "vieillot",
      0.035
    ],
    [
      "passe",
      0.035
    ],
    [
      "ancetre",
      0.0325
    ],
    [
      "use",
      0.0325
    ],
    [
      "desuet",
      0.0275
    ],
    [
      "vetuste",
      0.0275
    ],
    [
      "seculaire",
      0.0225
    ],
    [
      "aine",
      0.0225
    ],
    [
      "archaique",
      0.0175
    ],
    [
      "perime",
      0.0175
    ],
    [
      "eloigne",
      0.0175
    ],
    [
      "predecesseur",
      0.0125
    ],
    [
      "recule",
      0.0125
    ],
    [
      "rococo",
      0.0125
    ],
    [
      "usage",
      0.0125
    ],
    [
      "age",
      0.0125
    ],
    [
      "precedent",
      0.0125
    ],
    [
      "primitif",
      0.0125
    ],
    [
      "premier",
      0.0125
    ],
    [
      "haut",
      0.0125
    ],
    [
      "fane",
      0.0125
    ],
    [
      "devancier",
      0.0125
    ],
    [
      "antediluvien",
      0.0125
    ],
    [
      "ancestral",
      0.0125
    ],
    [
      "precurseur",
      0.0075
    ],
    [
      "pere",
      0.0075
    ],
    [
      "revolu",
      0.0075
    ],
    [
      "venerable",
      0.0075
    ],
    [
      "veteran",
      0.0075
    ],
    [
      "patriarcal",
      0.0075
    ],
    [
      "long",
      0.0075
    ],
    [
      "anterieur",
      0.0075
    ],
    [
      "aieul",
      0.0075
    ],
    [
      "doyen",
      0.0075
    ],
    [
      "fletri",
      0.0075
    ],
    [
      "immemorial",
      0.0075
    ],
    [
      "prehistorique",
      0.0025
    ],
    [
      "poussiereux",
      0.0025
    ],
    [
      "gothique",
      0.0025
    ],
    [
      "d'epoque",
      0.0025
    ],
    [
      "croulant",
      0.0025
    ],
    [
      "chevronne",
      0.0025
    ],
    [
      "briscard",
      0.0025
    ],
    [
      "authentique",
      0.0025
    ],
    [
      "ascendant",
      0.0025
    ],
    [
      "vieillard",
      0.0025
    ]
  ],
  "chaine": [
    [
      "assujettissement",
      0.0625
    ],
    [
      "lien",
      0.0625
    ],
    [
      "servitude",
      0.0475
    ],
    [
      "attache",
      0.04
    ],
    [
      "joug",
      0.04
    ],
    [
      "liaison",
      0.035
    ],
    [
      "contrainte",
      0.0325
    ],
    [
      "suite",
      0.0275
    ],
    [
      "enchainement",
      0.025
    ],
    [
      "dependance",
      0.025
    ],
    [
      "attachement",
      0.025
    ],
    [
      "alliance",
      0.02
    ],
    [
      "anneau",
      0.02
    ],
    [
      "esclavage",
      0.02
    ],
    [
      "sujetion",
      0.0175
    ],
    [
      "entrave",
      0.0175
    ],
    [
      "collier",
      0.0175
    ],
    [
      "carcan",
      0.0175
    ],
    [
      "asservissement",
      0.0175
    ],
    [
      "union",
      0.0125
    ],
    [
      "obligation",
      0.0125
    ],
    [
      "mont",
      0.0125
    ],
    [
      "bracelet",
      0.0125
    ],
    [
      "astreinte",
      0.0125
    ],
    [
      "trame",
      0.01
    ],
    [
      "serie",
      0.01
    ],
    [
      "prison",
      0.01
    ],
    [
      "menottes",
      0.01
    ],
    [
      "mariage",
      0.01
    ],
    [
      "filiation",
      0.01
    ],
    [
      "engagement",
      0.01
    ],
    [
      "corde",
      0.01
    ],
    [
      "chainette",
      0.01
    ],
    [
      "captivite",
      0.01
    ],
    [
      "cage",
      0.01
    ],
    [
      "bijou",
      0.01
    ],
    [
      "association",
      0.01
    ],
    [
      "gene",
      0.005
    ],
    [
      "noeud",
      0.005
    ],
    [
      "parente",
      0.005
    ],
    [
      "reseau",
      0.005
    ],
    [
      "succession",
      0.005
    ],
    [
      "engrenage",
      0.005
    ],
    [
      "cortege",
      0.005
    ],
    [
      "continuite",
      0.005
    ],
    [
      "clavier",
      0.005
    ],
    [
      "breloque",
      0.005
    ],
    [
      "amarrage",
      0.005
    ],
    [
      "affection",
      0.005
    ],
    [
      "jaseron",
      0.0025
    ],
    [
      "jaseran",
      0.0025
    ],
    [
      "hauteur",
      0.0025
    ],
    [
      "gourmette",
      0.0025
    ],
    [
      "geole",
      0.0025
    ],
    [
      "gaine",
      0.0025
    ],
    [
      "maille",
      0.0025
    ],
    [
      "maillon",
      0.0025
    ],
    [
      "mancelle",
      0.0025
    ],
    [
      "sautoir",
      0.0025
    ],
    [
      "serra",
      0.0025
    ],
    [
      "sierra",
      0.0025
    ],
    [
      "solidite",
      0.0025
    ],
    [
      "touage",
      0.0025
    ],
    [
      "tyrannie",
      0.0025
    ],
    [
      "ferronniere",
      0.0025
    ],
    [
      "farandole",
      0.0025
    ],
    [
      "estacade",
      0.0025
    ],
    [
      "alganon",
      0.0025
    ],
    [
      "boulet",
      0.0025
    ],
    [
      "cabriolet",
      0.0025
    ],
    [
      "cadene",
      0.0025
    ],
    [
      "cep",
      0.0025
    ],
    [
      "chapelet",
      0.0025
    ],
    [
      "chainon",
      0.0025
    ],
    [
      "chatelaine",
      0.0025
    ],
    [
      "cloture",
      0.0025
    ],
    [
      "cordillere",
      0.0025
    ],
    [
      "cable",
      0.0025
    ],
    [
      "danse",
      0.0025
    ],
    [
      "discipline",
      0.0025
    ],
    [
      "decoration",
      0.0025
    ],
    [
      "entrelacement",
      0.0025
    ],
    [
      "usine",
      0.0025
    ]
  ],
  "alimentaire": [
    [
      "nutritif",
      0.25
    ],
    [
      "bromatologique",
      0.125
    ],
    [
      "comestible",
      0.125
    ],
    [
      "digestible",
      0.125
    ],
    [
      "digestif",
      0.125
    ],
    [
      "nourrissant",
      0.125
    ]
  ],
  "terre": [
    [
      "domaine",
      0.1
    ],
    [
      "pays",
      0.1
    ],
    [
      "terrain",
      0.0925
    ],
    [
      "champ",
      0.06
    ],
    [
      "propriete",
      0.05
    ],
    [
      "sol",
      0.04
    ],
    [
      "region",
      0.04
    ],
    [
      "monde",
      0.04
    ],
    [
      "univers",
      0.03
    ],
    [
      "terroir",
      0.03
    ],
    [
      "globe",
      0.03
    ],
    [
      "fonds",
      0.03
    ],
    [
      "clos",
      0.03
    ],
    [
      "campagne",
      0.03
    ],
    [
      "territoire",
      0.02
    ],
    [
      "lieu",
      0.02
    ],
    [
      "humus",
      0.02
    ],
    [
      "glebe",
      0.02
    ],
    [
      "exploitation",
      0.02
    ],
    [
      "bien",
      0.02
    ],
    [
      "parcelle",
      0.0075
    ],
    [
      "parterre",
      0.0075
    ],
    [
      "patrie",
      0.0075
    ],
    [
      "paturage",
      0.0075
    ],
    [
      "terreau",
      0.0075
    ],
    [
      "vigne",
      0.0075
    ],
    [
      "limon",
      0.0075
    ],
    [
      "labour",
      0.0075
    ],
    [
      "jardin",
      0.0075
    ],
    [
      "dure",
      0.0075
    ],
    [
      "continent",
      0.0075
    ],
    [
      "closeau",
      0.0075
    ],
    [
      "capital",
      0.0075
    ],
    [
      "boule",
      0.0075
    ],
    [
      "ile",
      0.0075
    ]
  ],
  "terrer": [
    [
      "blanchir",
      0.165
    ],
    [
      "degraisser",
      0.165
    ],
    [
      "enfouir",
      0.165
    ],
    [
      "enterrer",
      0.165
    ],
    [
      "loger",
      0.165
    ],
    [
      "recouvrir",
      0.165
    ]
  ],
  "fermer": [
    [
      "barrer",
      0.075
    ],
    [
      "clore",
      0.065
    ],
    [
      "boucher",
      0.0575
    ],
    [
      "enfermer",
      0.0475
    ],
    [
      "bloquer",
      0.0475
    ],
    [
      "arreter",
      0.0475
    ],
    [
      "entourer",
      0.0425
    ],
    [
      "barricader",
      0.0325
    ],
    [
      "condamner",
      0.0325
    ],
    [
      "couper",
      0.03
    ],
    [
      "obstruer",
      0.025
    ],
    [
      "murer",
      0.025
    ],
    [
      "empecher",
      0.025
    ],
    [
      "cerner",
      0.02
    ],
    [
      "enclore",
      0.02
    ],
    [
      "obturer",
      0.02
    ],
    [
      "borner",
      0.015
    ],
    [
      "capsuler",
      0.015
    ],
    [
      "interdire",
      0.0125
    ],
    [
      "interrompre",
      0.0125
    ],
    [
      "maconner",
      0.0125
    ],
    [
      "suspendre",
      0.0125
    ],
    [
      "terminer",
      0.0125
    ],
    [
      "ecluser",
      0.0125
    ],
    [
      "finir",
      0.0125
    ],
    [
      "enceindre",
      0.0125
    ],
    [
      "consigner",
      0.0125
    ],
    [
      "bander",
      0.0125
    ],
    [
      "boucler",
      0.0125
    ],
    [
      "cacheter",
      0.0125
    ],
    [
      "cadenasser",
      0.0125
    ],
    [
      "cloturer",
      0.0125
    ],
    [
      "coller",
      0.0125
    ],
    [
      "verrouiller",
      0.0075
    ],
    [
      "sceller",
      0.0075
    ],
    [
      "parquer",
      0.0075
    ],
    [
      "investir",
      0.0075
    ],
    [
      "combler",
      0.0075
    ],
    [
      "colmater",
      0.0075
    ],
    [
      "cercler",
      0.0075
    ],
    [
      "bacler",
      0.0075
    ],
    [
      "nouer",
      0.0025
    ],
    [
      "occlure",
      0.0025
    ],
    [
      "occulter",
      0.0025
    ],
    [
      "plier",
      0.0025
    ],
    [
      "relacher",
      0.0025
    ],
    [
      "suturer",
      0.0025
    ],
    [
      "tirer",
      0.0025
    ],
    [
      "lourder",
      0.0025
    ],
    [
      "defendre",
      0.0025
    ],
    [
      "abaisser",
      0.0025
    ],
    [
      "boutonner",
      0.0025
    ],
    [
      "baillonner",
      0.0025
    ],
    [
      "chomer",
      0.0025
    ],
    [
      "cicatriser",
      0.0025
    ],
    [
      "claquer",
      0.0025
    ],
    [
      "clouer",
      0.0025
    ],
    [
      "coudre",
      0.0025
    ],
    [
      "disjoncter",
      0.0025
    ],
    [
      "eteindre",
      0.0025
    ]
  ],
  "ferme": [
    [
      "barrer",
      0.075
    ],
    [
      "clore",
      0.065
    ],
    [
      "boucher",
      0.0575
    ],
    [
      "enfermer",
      0.0475
    ],
    [
      "bloquer",
      0.0475
    ],
    [
      "arreter",
      0.0475
    ],
    [
      "entourer",
      0.0425
    ],
    [
      "barricader",
      0.0325
    ],
    [
      "condamner",
      0.0325
    ],
    [
      "couper",
      0.03
    ],
    [
      "obstruer",
      0.025
    ],
    [
      "murer",
      0.025
    ],
    [
      "empecher",
      0.025
    ],
    [
      "cerner",
      0.02
    ],
    [
      "enclore",
      0.02
    ],
    [
      "obturer",
      0.02
    ],
    [
      "borner",
      0.015
    ],
    [
      "capsuler",
      0.015
    ],
    [
      "interdire",
      0.0125
    ],
    [
      "interrompre",
      0.0125
    ],
    [
      "maconner",
      0.0125
    ],
    [
      "suspendre",
      0.0125
    ],
    [
      "terminer",
      0.0125
    ],
    [
      "ecluser",
      0.0125
    ],
    [
      "finir",
      0.0125
    ],
    [
      "enceindre",
      0.0125
    ],
    [
      "consigner",
      0.0125
    ],
    [
      "bander",
      0.0125
    ],
    [
      "boucler",
      0.0125
    ],
    [
      "cacheter",
      0.0125
    ],
    [
      "cadenasser",
      0.0125
    ],
    [
      "cloturer",
      0.0125
    ],
    [
      "coller",
      0.0125
    ],
    [
      "verrouiller",
      0.0075
    ],
    [
      "sceller",
      0.0075
    ],
    [
      "parquer",
      0.0075
    ],
    [
      "investir",
      0.0075
    ],
    [
      "combler",
      0.0075
    ],
    [
      "colmater",
      0.0075
    ],
    [
      "cercler",
      0.0075
    ],
    [
      "bacler",
      0.0075
    ],
    [
      "nouer",
      0.0025
    ],
    [
      "occlure",
      0.0025
    ],
    [
      "occulter",
      0.0025
    ],
    [
      "plier",
      0.0025
    ],
    [
      "relacher",
      0.0025
    ],
    [
      "suturer",
      0.0025
    ],
    [
      "tirer",
      0.0025
    ],
    [
      "lourder",
      0.0025
    ],
    [
      "defendre",
      0.0025
    ],
    [
      "abaisser",
      0.0025
    ],
    [
      "boutonner",
      0.0025
    ],
    [
      "baillonner",
      0.0025
    ],
    [
      "chomer",
      0.0025
    ],
    [
      "cicatriser",
      0.0025
    ],
    [
      "claquer",
      0.0025
    ],
    [
      "clouer",
      0.0025
    ],
    [
      "coudre",
      0.0025
    ],
    [
      "disjoncter",
      0.0025
    ],
    [
      "eteindre",
      0.0025
    ]
  ],
  "gueule": [
    [
      "visage",
      0.1425
    ],
    [
      "bouche",
      0.1125
    ],
    [
      "figure",
      0.1125
    ],
    [
      "tete",
      0.1125
    ],
    [
      "margoulette",
      0.055
    ],
    [
      "degaine",
      0.055
    ],
    [
      "air",
      0.055
    ],
    [
      "peche",
      0.0275
    ],
    [
      "poire",
      0.0275
    ],
    [
      "ouverture",
      0.0275
    ],
    [
      "nourriture",
      0.0275
    ],
    [
      "look",
      0.0275
    ],
    [
      "gosier",
      0.0275
    ],
    [
      "face",
      0.0275
    ],
    [
      "boite",
      0.0275
    ],
    [
      "bouffe",
      0.0275
    ],
    [
      "bec",
      0.0275
    ],
    [
      "battant",
      0.0275
    ],
    [
      "tronche",
      0.0275
    ]
  ],
  "gueuler": [
    [
      "crier",
      0.2225
    ],
    [
      "hurler",
      0.13
    ],
    [
      "brailler",
      0.0725
    ],
    [
      "vociferer",
      0.055
    ],
    [
      "tonner",
      0.055
    ],
    [
      "tempeter",
      0.055
    ],
    [
      "fulminer",
      0.055
    ],
    [
      "chanter",
      0.055
    ],
    [
      "tonitruer",
      0.035
    ],
    [
      "s'egosiller",
      0.035
    ],
    [
      "rouspeter",
      0.035
    ],
    [
      "protester",
      0.035
    ],
    [
      "bramer",
      0.035
    ],
    [
      "beugler",
      0.035
    ],
    [
      "aboyer",
      0.0175
    ],
    [
      "parler",
      0.0175
    ],
    [
      "peter",
      0.0175
    ]
  ],
  "poser": [
    [
      "mettre",
      0.11
    ],
    [
      "placer",
      0.0625
    ],
    [
      "etablir",
      0.0425
    ],
    [
      "appliquer",
      0.04
    ],
    [
      "appuyer",
      0.0325
    ],
    [
      "porter",
      0.0325
    ],
    [
      "fixer",
      0.0275
    ],
    [
      "situer",
      0.025
    ],
    [
      "dresser",
      0.025
    ],
    [
      "camper",
      0.025
    ],
    [
      "affecter",
      0.025
    ],
    [
      "installer",
      0.02
    ],
    [
      "enoncer",
      0.0175
    ],
    [
      "ecrire",
      0.0175
    ],
    [
      "soutenir",
      0.0175
    ],
    [
      "plastronner",
      0.0175
    ],
    [
      "flanquer",
      0.0175
    ],
    [
      "avancer",
      0.0175
    ],
    [
      "asseoir",
      0.0175
    ],
    [
      "adresser",
      0.0175
    ],
    [
      "etendre",
      0.0125
    ],
    [
      "planter",
      0.0125
    ],
    [
      "jeter",
      0.0125
    ],
    [
      "formuler",
      0.0125
    ],
    [
      "fonder",
      0.0125
    ],
    [
      "deposer",
      0.0125
    ],
    [
      "disposer",
      0.0125
    ],
    [
      "etaler",
      0.01
    ],
    [
      "tendre",
      0.01
    ],
    [
      "simuler",
      0.01
    ],
    [
      "reposer",
      0.01
    ],
    [
      "poster",
      0.01
    ],
    [
      "paraitre",
      0.01
    ],
    [
      "craner",
      0.01
    ],
    [
      "charger",
      0.01
    ],
    [
      "abandonner",
      0.01
    ],
    [
      "peser",
      0.005
    ],
    [
      "pontifier",
      0.005
    ],
    [
      "presupposer",
      0.005
    ],
    [
      "quitter",
      0.005
    ],
    [
      "rendre",
      0.005
    ],
    [
      "parader",
      0.005
    ],
    [
      "paonner",
      0.005
    ],
    [
      "jouer",
      0.005
    ],
    [
      "conjecturer",
      0.005
    ],
    [
      "attendre",
      0.005
    ],
    [
      "alleguer",
      0.005
    ],
    [
      "affirmer",
      0.005
    ],
    [
      "pouffer",
      0.0025
    ],
    [
      "soulever",
      0.0025
    ],
    [
      "supposer",
      0.0025
    ],
    [
      "epingler",
      0.0025
    ],
    [
      "postuler",
      0.0025
    ],
    [
      "percher",
      0.0025
    ],
    [
      "moisir",
      0.0025
    ],
    [
      "minauder",
      0.0025
    ],
    [
      "interposer",
      0.0025
    ],
    [
      "hierarchiser",
      0.0025
    ],
    [
      "coqueter",
      0.0025
    ],
    [
      "batir",
      0.0025
    ],
    [
      "apposer",
      0.0025
    ],
    [
      "evoquer",
      0.0025
    ]
  ],
  "pose": [
    [
      "affectation",
      0.145
    ],
    [
      "appret",
      0.0725
    ],
    [
      "pretention",
      0.0525
    ],
    [
      "position",
      0.0525
    ],
    [
      "manieres",
      0.0525
    ],
    [
      "attitude",
      0.0525
    ],
    [
      "etablissement",
      0.035
    ],
    [
      "sottise",
      0.035
    ],
    [
      "recherche",
      0.035
    ],
    [
      "pedantisme",
      0.035
    ],
    [
      "posture",
      0.035
    ],
    [
      "orgueil",
      0.035
    ],
    [
      "manierisme",
      0.035
    ],
    [
      "facon",
      0.035
    ],
    [
      "exterieur",
      0.035
    ],
    [
      "modele",
      0.0175
    ],
    [
      "photographie",
      0.0175
    ],
    [
      "posage",
      0.0175
    ],
    [
      "snobisme",
      0.0175
    ],
    [
      "installation",
      0.0175
    ],
    [
      "coffrage",
      0.0175
    ],
    [
      "cambrure",
      0.0175
    ],
    [
      "assiette",
      0.0175
    ],
    [
      "application",
      0.0175
    ],
    [
      "affeterie",
      0.0175
    ],
    [
      "superbe",
      0.0175
    ]
  ],
  "battre": [
    [
      "frapper",
      0.055
    ],
    [
      "rosser",
      0.03
    ],
    [
      "remuer",
      0.025
    ],
    [
      "ecraser",
      0.025
    ],
    [
      "maltraiter",
      0.0225
    ],
    [
      "vaincre",
      0.02
    ],
    [
      "blesser",
      0.0175
    ],
    [
      "triompher",
      0.0175
    ],
    [
      "ereinter",
      0.0175
    ],
    [
      "corriger",
      0.015
    ],
    [
      "etriller",
      0.0125
    ],
    [
      "cogner",
      0.0125
    ],
    [
      "agiter",
      0.0125
    ],
    [
      "attaquer",
      0.0125
    ],
    [
      "briser",
      0.0125
    ],
    [
      "malmener",
      0.0125
    ],
    [
      "rudoyer",
      0.0125
    ],
    [
      "taper",
      0.0125
    ],
    [
      "travailler",
      0.0125
    ],
    [
      "touiller",
      0.0125
    ],
    [
      "fatiguer",
      0.0125
    ],
    [
      "enfoncer",
      0.0125
    ],
    [
      "secouer",
      0.01
    ],
    [
      "fustiger",
      0.01
    ],
    [
      "frotter",
      0.01
    ],
    [
      "cingler",
      0.01
    ],
    [
      "casser",
      0.01
    ],
    [
      "brutaliser",
      0.01
    ],
    [
      "broyer",
      0.01
    ],
    [
      "fouetter",
      0.0075
    ],
    [
      "fesser",
      0.0075
    ],
    [
      "bigorner",
      0.0075
    ],
    [
      "heurter",
      0.0075
    ],
    [
      "nettoyer",
      0.0075
    ],
    [
      "piler",
      0.0075
    ],
    [
      "houspiller",
      0.005
    ],
    [
      "meurtrir",
      0.005
    ],
    [
      "pilonner",
      0.005
    ],
    [
      "pulveriser",
      0.005
    ],
    [
      "rouler",
      0.005
    ],
    [
      "souffleter",
      0.005
    ],
    [
      "demolir",
      0.005
    ],
    [
      "chatier",
      0.005
    ],
    [
      "aneantir",
      0.005
    ],
    [
      "arranger",
      0.005
    ],
    [
      "assommer",
      0.005
    ],
    [
      "bombarder",
      0.005
    ],
    [
      "bousculer",
      0.005
    ],
    [
      "brasser",
      0.005
    ],
    [
      "brosser",
      0.005
    ],
    [
      "tourner",
      0.005
    ],
    [
      "surpasser",
      0.005
    ],
    [
      "surclasser",
      0.005
    ],
    [
      "recurer",
      0.005
    ],
    [
      "osciller",
      0.005
    ],
    [
      "matraquer",
      0.005
    ],
    [
      "lutter",
      0.005
    ],
    [
      "flageller",
      0.005
    ],
    [
      "faconner",
      0.005
    ],
    [
      "defaire",
      0.005
    ],
    [
      "l'emporter",
      0.0025
    ],
    [
      "melanger",
      0.0025
    ],
    [
      "meler",
      0.0025
    ],
    [
      "soigner",
      0.0025
    ],
    [
      "tambouriner",
      0.0025
    ],
    [
      "fouiller",
      0.0025
    ],
    [
      "culbuter",
      0.0025
    ],
    [
      "combattre",
      0.0025
    ],
    [
      "ballotter",
      0.0025
    ],
    [
      "bastonner",
      0.0025
    ],
    [
      "bouler",
      0.0025
    ],
    [
      "claquer",
      0.0025
    ],
    [
      "marteler",
      0.0025
    ],
    [
      "moudre",
      0.0025
    ],
    [
      "punir",
      0.0025
    ],
    [
      "tabasser",
      0.0025
    ],
    [
      "echarper",
      0.0025
    ],
    [
      "echiner",
      0.0025
    ],
    [
      "eliminer",
      0.0025
    ],
    [
      "marquer",
      0.0025
    ],
    [
      "lyncher",
      0.0025
    ],
    [
      "gifler",
      0.0025
    ],
    [
      "astiquer",
      0.0025
    ],
    [
      "bouiller",
      0.0025
    ],
    [
      "cribler",
      0.0025
    ],
    [
      "devancer",
      0.0025
    ],
    [
      "depasser",
      0.0025
    ],
    [
      "derouiller",
      0.0025
    ],
    [
      "explorer",
      0.0025
    ],
    [
      "flotter",
      0.0025
    ],
    [
      "forger",
      0.0025
    ],
    [
      "refouler",
      0.0
    ],
    [
      "parcourir",
      0.0
    ],
    [
      "palpiter",
      0.0
    ],
    [
      "houssiner",
      0.0
    ],
    [
      "gratifier",
      0.0
    ],
    [
      "gagner",
      0.0
    ],
    [
      "s'escrimer",
      0.0
    ],
    [
      "sangler",
      0.0
    ],
    [
      "epousseter",
      0.0
    ],
    [
      "vanner",
      0.0
    ],
    [
      "torcher",
      0.0
    ],
    [
      "tanner",
      0.0
    ],
    [
      "tamponner",
      0.0
    ],
    [
      "talocher",
      0.0
    ],
    [
      "frictionner",
      0.0
    ],
    [
      "boxer",
      0.0
    ],
    [
      "bouter",
      0.0
    ],
    [
      "bourrer",
      0.0
    ],
    [
      "batailler",
      0.0
    ],
    [
      "avoir",
      0.0
    ],
    [
      "avoiner",
      0.0
    ],
    [
      "assaisonner",
      0.0
    ],
    [
      "assaillir",
      0.0
    ],
    [
      "brandiller",
      0.0
    ],
    [
      "brouiller",
      0.0
    ],
    [
      "bucher",
      0.0
    ],
    [
      "fonctionner",
      0.0
    ],
    [
      "faseyer",
      0.0
    ],
    [
      "dauber",
      0.0
    ],
    [
      "cravacher",
      0.0
    ],
    [
      "cligner",
      0.0
    ],
    [
      "canonner",
      0.0
    ],
    [
      "rechercher",
      0.0
    ],
    [
      "ralinguer",
      0.0
    ],
    [
      "rabouiller",
      0.0
    ],
    [
      "rabattre",
      0.0
    ],
    [
      "locher",
      0.0
    ],
    [
      "gourmer",
      0.0
    ],
    [
      "gauler",
      0.0
    ],
    [
      "fouler",
      0.0
    ],
    [
      "fouailler",
      0.0
    ],
    [
      "reconnaitre",
      0.0
    ],
    [
      "s'acharner",
      0.0
    ],
    [
      "tisaner",
      0.0
    ],
    [
      "testonner",
      0.0
    ],
    [
      "tatouiller",
      0.0
    ],
    [
      "tarauder",
      0.0
    ],
    [
      "talmouser",
      0.0
    ],
    [
      "sevir",
      0.0
    ],
    [
      "sonner",
      0.0
    ],
    [
      "sabouler",
      0.0
    ],
    [
      "triquer",
      0.0
    ],
    [
      "batonner",
      0.0
    ],
    [
      "bringuebaler",
      0.0
    ],
    [
      "bourrader",
      0.0
    ],
    [
      "botter",
      0.0
    ],
    [
      "blackbouler",
      0.0
    ],
    [
      "baratter",
      0.0
    ],
    [
      "attiger",
      0.0
    ],
    [
      "cabosser",
      0.0
    ],
    [
      "calotter",
      0.0
    ],
    [
      "estourbir",
      0.0
    ],
    [
      "depoussierer",
      0.0
    ],
    [
      "depiquer",
      0.0
    ],
    [
      "debattre",
      0.0
    ],
    [
      "disperser",
      0.0
    ],
    [
      "damer",
      0.0
    ],
    [
      "clignoter",
      0.0
    ],
    [
      "carder",
      0.0
    ],
    [
      "arpenter",
      0.0
    ]
  ],
  "boulanger": [
    [
      "fournier",
      0.3325
    ],
    [
      "gindre",
      0.3325
    ],
    [
      "mitron",
      0.3325
    ]
  ],
  "fumer": [
    [
      "rager",
      0.155
    ],
    [
      "ronchonner",
      0.1
    ],
    [
      "raler",
      0.0775
    ],
    [
      "pester",
      0.055
    ],
    [
      "tempeter",
      0.0425
    ],
    [
      "rouspeter",
      0.0425
    ],
    [
      "fulminer",
      0.0425
    ],
    [
      "enrager",
      0.0425
    ],
    [
      "bisquer",
      0.0325
    ],
    [
      "ecumer",
      0.02
    ],
    [
      "rogner",
      0.02
    ],
    [
      "preparer",
      0.02
    ],
    [
      "maronner",
      0.02
    ],
    [
      "bruler",
      0.02
    ],
    [
      "amender",
      0.02
    ],
    [
      "pipailler",
      0.01
    ],
    [
      "petuner",
      0.01
    ],
    [
      "saurer",
      0.01
    ],
    [
      "tonner",
      0.01
    ],
    [
      "megoter",
      0.01
    ],
    [
      "griller",
      0.01
    ],
    [
      "fumiger",
      0.01
    ],
    [
      "fertiliser",
      0.01
    ],
    [
      "engraisser",
      0.01
    ],
    [
      "endever",
      0.01
    ],
    [
      "boucaner",
      0.01
    ],
    [
      "barder",
      0.01
    ],
    [
      "ameliorer",
      0.01
    ]
  ],
  "gabarit": [
    [
      "forme",
      0.085
    ],
    [
      "type",
      0.085
    ],
    [
      "calibre",
      0.07
    ],
    [
      "classe",
      0.07
    ],
    [
      "genre",
      0.07
    ],
    [
      "modele",
      0.07
    ],
    [
      "taille",
      0.07
    ],
    [
      "espece",
      0.055
    ],
    [
      "dimension",
      0.055
    ],
    [
      "nature",
      0.0425
    ],
    [
      "stature",
      0.0425
    ],
    [
      "valeur",
      0.0275
    ],
    [
      "patron",
      0.0275
    ],
    [
      "mesure",
      0.0275
    ],
    [
      "format",
      0.0275
    ],
    [
      "exemplaire",
      0.0275
    ],
    [
      "carrure",
      0.0275
    ],
    [
      "acabit",
      0.0275
    ],
    [
      "arceau",
      0.0125
    ],
    [
      "cerce",
      0.0125
    ],
    [
      "grosseur",
      0.0125
    ],
    [
      "silhouette",
      0.0125
    ],
    [
      "tonnage",
      0.0125
    ]
  ],
  "bagarrer": [
    [
      "batailler",
      0.2075
    ],
    [
      "discuter",
      0.125
    ],
    [
      "lutter",
      0.125
    ],
    [
      "agir",
      0.04
    ],
    [
      "barouder",
      0.04
    ]
  ],
  "marquer": [
    [
      "montrer",
      0.0625
    ],
    [
      "reveler",
      0.06
    ],
    [
      "indiquer",
      0.055
    ],
    [
      "signaler",
      0.04
    ],
    [
      "afficher",
      0.0275
    ],
    [
      "manifester",
      0.0275
    ],
    [
      "signifier",
      0.0275
    ],
    [
      "inscrire",
      0.025
    ],
    [
      "temoigner",
      0.025
    ],
    [
      "noter",
      0.0175
    ],
    [
      "designer",
      0.015
    ],
    [
      "exprimer",
      0.0125
    ],
    [
      "graver",
      0.0125
    ],
    [
      "ecrire",
      0.0125
    ],
    [
      "relever",
      0.0125
    ],
    [
      "produire",
      0.0125
    ],
    [
      "imprimer",
      0.0125
    ],
    [
      "fixer",
      0.0125
    ],
    [
      "determiner",
      0.0125
    ],
    [
      "denoter",
      0.0125
    ],
    [
      "dire",
      0.0125
    ],
    [
      "annoncer",
      0.0125
    ],
    [
      "tracer",
      0.01
    ],
    [
      "souligner",
      0.01
    ],
    [
      "reperer",
      0.01
    ],
    [
      "presenter",
      0.01
    ],
    [
      "ponctuer",
      0.01
    ],
    [
      "piqueter",
      0.01
    ],
    [
      "mettre",
      0.01
    ],
    [
      "percer",
      0.0075
    ],
    [
      "frapper",
      0.0075
    ],
    [
      "affecter",
      0.0075
    ],
    [
      "trahir",
      0.0075
    ],
    [
      "tacheter",
      0.0075
    ],
    [
      "prouver",
      0.0075
    ],
    [
      "poinconner",
      0.0075
    ],
    [
      "paraitre",
      0.0075
    ],
    [
      "mentionner",
      0.0075
    ],
    [
      "empreindre",
      0.0075
    ],
    [
      "accuser",
      0.0075
    ],
    [
      "assigner",
      0.0075
    ],
    [
      "baliser",
      0.0075
    ],
    [
      "briller",
      0.0075
    ],
    [
      "denoncer",
      0.0075
    ],
    [
      "toucher",
      0.005
    ],
    [
      "rendre",
      0.005
    ],
    [
      "rayer",
      0.005
    ],
    [
      "penetrer",
      0.005
    ],
    [
      "prononcer",
      0.005
    ],
    [
      "observer",
      0.005
    ],
    [
      "immatriculer",
      0.005
    ],
    [
      "estampiller",
      0.005
    ],
    [
      "estamper",
      0.005
    ],
    [
      "colorer",
      0.005
    ],
    [
      "jalonner",
      0.0025
    ],
    [
      "mander",
      0.0025
    ],
    [
      "pointer",
      0.0025
    ],
    [
      "pointiller",
      0.0025
    ],
    [
      "refleter",
      0.0025
    ],
    [
      "transcrire",
      0.0025
    ],
    [
      "emerger",
      0.0025
    ],
    [
      "etiqueter",
      0.0025
    ],
    [
      "impregner",
      0.0025
    ],
    [
      "exceller",
      0.0025
    ],
    [
      "attester",
      0.0025
    ],
    [
      "battre",
      0.0025
    ],
    [
      "borner",
      0.0025
    ],
    [
      "buriner",
      0.0025
    ],
    [
      "caracteriser",
      0.0025
    ],
    [
      "compter",
      0.0025
    ],
    [
      "consigner",
      0.0025
    ],
    [
      "delimiter",
      0.0025
    ],
    [
      "prodiguer",
      0.0025
    ],
    [
      "remarquer",
      0.0025
    ],
    [
      "respirer",
      0.0025
    ],
    [
      "sangler",
      0.0025
    ],
    [
      "scander",
      0.0025
    ],
    [
      "supposer",
      0.0025
    ],
    [
      "taveler",
      0.0025
    ],
    [
      "triompher",
      0.0025
    ],
    [
      "etamper",
      0.0025
    ],
    [
      "numeroter",
      0.0025
    ],
    [
      "matriculer",
      0.0025
    ],
    [
      "cacheter",
      0.0025
    ],
    [
      "cocher",
      0.0025
    ],
    [
      "copier",
      0.0025
    ],
    [
      "coter",
      0.0025
    ],
    [
      "deteindre",
      0.0025
    ],
    [
      "feter",
      0.0025
    ],
    [
      "influencer",
      0.0025
    ],
    [
      "ligner",
      0.0025
    ],
    [
      "limiter",
      0.0025
    ],
    [
      "s'illustrer",
      0.0
    ],
    [
      "reagir",
      0.0
    ],
    [
      "rider",
      0.0
    ],
    [
      "rayonner",
      0.0
    ],
    [
      "presager",
      0.0
    ],
    [
      "predestiner",
      0.0
    ],
    [
      "signer",
      0.0
    ],
    [
      "sillonner",
      0.0
    ],
    [
      "stigmatiser",
      0.0
    ],
    [
      "tacher",
      0.0
    ],
    [
      "tatouer",
      0.0
    ],
    [
      "timbrer",
      0.0
    ],
    [
      "zebrer",
      0.0
    ],
    [
      "etalonner",
      0.0
    ],
    [
      "picoter",
      0.0
    ],
    [
      "mouler",
      0.0
    ],
    [
      "meurtrir",
      0.0
    ],
    [
      "biseauter",
      0.0
    ],
    [
      "crener",
      0.0
    ],
    [
      "celebrer",
      0.0
    ],
    [
      "dater",
      0.0
    ],
    [
      "degoter",
      0.0
    ],
    [
      "farder",
      0.0
    ],
    [
      "gainer",
      0.0
    ],
    [
      "impacter",
      0.0
    ],
    [
      "insculper",
      0.0
    ],
    [
      "laisser",
      0.0
    ],
    [
      "marbrer",
      0.0
    ],
    [
      "marqueter",
      0.0
    ],
    [
      "materialiser",
      0.0
    ],
    [
      "baguer",
      0.0
    ]
  ],
  "marque": [
    [
      "montrer",
      0.0625
    ],
    [
      "reveler",
      0.06
    ],
    [
      "indiquer",
      0.055
    ],
    [
      "signaler",
      0.04
    ],
    [
      "afficher",
      0.0275
    ],
    [
      "manifester",
      0.0275
    ],
    [
      "signifier",
      0.0275
    ],
    [
      "inscrire",
      0.025
    ],
    [
      "temoigner",
      0.025
    ],
    [
      "noter",
      0.0175
    ],
    [
      "designer",
      0.015
    ],
    [
      "exprimer",
      0.0125
    ],
    [
      "graver",
      0.0125
    ],
    [
      "ecrire",
      0.0125
    ],
    [
      "relever",
      0.0125
    ],
    [
      "produire",
      0.0125
    ],
    [
      "imprimer",
      0.0125
    ],
    [
      "fixer",
      0.0125
    ],
    [
      "determiner",
      0.0125
    ],
    [
      "denoter",
      0.0125
    ],
    [
      "dire",
      0.0125
    ],
    [
      "annoncer",
      0.0125
    ],
    [
      "tracer",
      0.01
    ],
    [
      "souligner",
      0.01
    ],
    [
      "reperer",
      0.01
    ],
    [
      "presenter",
      0.01
    ],
    [
      "ponctuer",
      0.01
    ],
    [
      "piqueter",
      0.01
    ],
    [
      "mettre",
      0.01
    ],
    [
      "percer",
      0.0075
    ],
    [
      "frapper",
      0.0075
    ],
    [
      "affecter",
      0.0075
    ],
    [
      "trahir",
      0.0075
    ],
    [
      "tacheter",
      0.0075
    ],
    [
      "prouver",
      0.0075
    ],
    [
      "poinconner",
      0.0075
    ],
    [
      "paraitre",
      0.0075
    ],
    [
      "mentionner",
      0.0075
    ],
    [
      "empreindre",
      0.0075
    ],
    [
      "accuser",
      0.0075
    ],
    [
      "assigner",
      0.0075
    ],
    [
      "baliser",
      0.0075
    ],
    [
      "briller",
      0.0075
    ],
    [
      "denoncer",
      0.0075
    ],
    [
      "toucher",
      0.005
    ],
    [
      "rendre",
      0.005
    ],
    [
      "rayer",
      0.005
    ],
    [
      "penetrer",
      0.005
    ],
    [
      "prononcer",
      0.005
    ],
    [
      "observer",
      0.005
    ],
    [
      "immatriculer",
      0.005
    ],
    [
      "estampiller",
      0.005
    ],
    [
      "estamper",
      0.005
    ],
    [
      "colorer",
      0.005
    ],
    [
      "jalonner",
      0.0025
    ],
    [
      "mander",
      0.0025
    ],
    [
      "pointer",
      0.0025
    ],
    [
      "pointiller",
      0.0025
    ],
    [
      "refleter",
      0.0025
    ],
    [
      "transcrire",
      0.0025
    ],
    [
      "emerger",
      0.0025
    ],
    [
      "etiqueter",
      0.0025
    ],
    [
      "impregner",
      0.0025
    ],
    [
      "exceller",
      0.0025
    ],
    [
      "attester",
      0.0025
    ],
    [
      "battre",
      0.0025
    ],
    [
      "borner",
      0.0025
    ],
    [
      "buriner",
      0.0025
    ],
    [
      "caracteriser",
      0.0025
    ],
    [
      "compter",
      0.0025
    ],
    [
      "consigner",
      0.0025
    ],
    [
      "delimiter",
      0.0025
    ],
    [
      "prodiguer",
      0.0025
    ],
    [
      "remarquer",
      0.0025
    ],
    [
      "respirer",
      0.0025
    ],
    [
      "sangler",
      0.0025
    ],
    [
      "scander",
      0.0025
    ],
    [
      "supposer",
      0.0025
    ],
    [
      "taveler",
      0.0025
    ],
    [
      "triompher",
      0.0025
    ],
    [
      "etamper",
      0.0025
    ],
    [
      "numeroter",
      0.0025
    ],
    [
      "matriculer",
      0.0025
    ],
    [
      "cacheter",
      0.0025
    ],
    [
      "cocher",
      0.0025
    ],
    [
      "copier",
      0.0025
    ],
    [
      "coter",
      0.0025
    ],
    [
      "deteindre",
      0.0025
    ],
    [
      "feter",
      0.0025
    ],
    [
      "influencer",
      0.0025
    ],
    [
      "ligner",
      0.0025
    ],
    [
      "limiter",
      0.0025
    ],
    [
      "s'illustrer",
      0.0
    ],
    [
      "reagir",
      0.0
    ],
    [
      "rider",
      0.0
    ],
    [
      "rayonner",
      0.0
    ],
    [
      "presager",
      0.0
    ],
    [
      "predestiner",
      0.0
    ],
    [
      "signer",
      0.0
    ],
    [
      "sillonner",
      0.0
    ],
    [
      "stigmatiser",
      0.0
    ],
    [
      "tacher",
      0.0
    ],
    [
      "tatouer",
      0.0
    ],
    [
      "timbrer",
      0.0
    ],
    [
      "zebrer",
      0.0
    ],
    [
      "etalonner",
      0.0
    ],
    [
      "picoter",
      0.0
    ],
    [
      "mouler",
      0.0
    ],
    [
      "meurtrir",
      0.0
    ],
    [
      "biseauter",
      0.0
    ],
    [
      "crener",
      0.0
    ],
    [
      "celebrer",
      0.0
    ],
    [
      "dater",
      0.0
    ],
    [
      "degoter",
      0.0
    ],
    [
      "farder",
      0.0
    ],
    [
      "gainer",
      0.0
    ],
    [
      "impacter",
      0.0
    ],
    [
      "insculper",
      0.0
    ],
    [
      "laisser",
      0.0
    ],
    [
      "marbrer",
      0.0
    ],
    [
      "marqueter",
      0.0
    ],
    [
      "materialiser",
      0.0
    ],
    [
      "baguer",
      0.0
    ]
  ],
  "rappeur": [],
  "modeler": [
    [
      "faconner",
      0.1525
    ],
    [
      "forger",
      0.1275
    ],
    [
      "former",
      0.1275
    ],
    [
      "faire",
      0.1025
    ],
    [
      "petrir",
      0.075
    ],
    [
      "sculpter",
      0.05
    ],
    [
      "plier",
      0.05
    ],
    [
      "mouler",
      0.05
    ],
    [
      "figurer",
      0.05
    ],
    [
      "construire",
      0.05
    ],
    [
      "fabriquer",
      0.025
    ],
    [
      "manier",
      0.025
    ],
    [
      "normaliser",
      0.025
    ],
    [
      "regler",
      0.025
    ],
    [
      "tripoter",
      0.025
    ],
    [
      "elever",
      0.025
    ]
  ],
  "modele": [
    [
      "faconner",
      0.1525
    ],
    [
      "forger",
      0.1275
    ],
    [
      "former",
      0.1275
    ],
    [
      "faire",
      0.1025
    ],
    [
      "petrir",
      0.075
    ],
    [
      "sculpter",
      0.05
    ],
    [
      "plier",
      0.05
    ],
    [
      "mouler",
      0.05
    ],
    [
      "figurer",
      0.05
    ],
    [
      "construire",
      0.05
    ],
    [
      "fabriquer",
      0.025
    ],
    [
      "manier",
      0.025
    ],
    [
      "normaliser",
      0.025
    ],
    [
      "regler",
      0.025
    ],
    [
      "tripoter",
      0.025
    ],
    [
      "elever",
      0.025
    ]
  ],
  "maille": [
    [
      "anneau",
      0.125
    ],
    [
      "tache",
      0.125
    ],
    [
      "point",
      0.0625
    ],
    [
      "paillon",
      0.0625
    ],
    [
      "obole",
      0.0625
    ],
    [
      "moucheture",
      0.0625
    ],
    [
      "maillure",
      0.0625
    ],
    [
      "maillon",
      0.0625
    ],
    [
      "demele",
      0.0625
    ],
    [
      "chainon",
      0.0625
    ],
    [
      "chaine",
      0.0625
    ],
    [
      "bourgeon",
      0.0625
    ],
    [
      "boucle",
      0.0625
    ],
    [
      "treillage",
      0.0625
    ]
  ],
  "mailler": [
    [
      "lacer",
      0.3325
    ],
    [
      "relier",
      0.3325
    ],
    [
      "tordre",
      0.3325
    ]
  ],
  "devant": [
    [
      "avant",
      0.115
    ],
    [
      "face",
      0.0925
    ],
    [
      "facade",
      0.0925
    ],
    [
      "front",
      0.0925
    ],
    [
      "seuil",
      0.07
    ],
    [
      "tete",
      0.07
    ],
    [
      "devanture",
      0.045
    ],
    [
      "proue",
      0.0225
    ],
    [
      "pas",
      0.0225
    ],
    [
      "endroit",
      0.0225
    ],
    [
      "auparavant",
      0.0225
    ]
  ],
  "principe": [
    [
      "theorie",
      0.0825
    ],
    [
      "origine",
      0.06
    ],
    [
      "cause",
      0.0475
    ],
    [
      "commencement",
      0.035
    ],
    [
      "source",
      0.035
    ],
    [
      "fondement",
      0.0325
    ],
    [
      "regle",
      0.03
    ],
    [
      "germe",
      0.03
    ],
    [
      "axiome",
      0.03
    ],
    [
      "base",
      0.0275
    ],
    [
      "dogme",
      0.0275
    ],
    [
      "hypothese",
      0.0225
    ],
    [
      "precepte",
      0.0225
    ],
    [
      "element",
      0.02
    ],
    [
      "maxime",
      0.02
    ],
    [
      "idee",
      0.02
    ],
    [
      "credo",
      0.0175
    ],
    [
      "opinion",
      0.0175
    ],
    [
      "proposition",
      0.0175
    ],
    [
      "systeme",
      0.0125
    ],
    [
      "raison",
      0.0125
    ],
    [
      "racine",
      0.0125
    ],
    [
      "premisse",
      0.0125
    ],
    [
      "debut",
      0.0125
    ],
    [
      "doctrine",
      0.0125
    ],
    [
      "verite",
      0.01
    ],
    [
      "seuil",
      0.01
    ],
    [
      "religion",
      0.01
    ],
    [
      "postulat",
      0.01
    ],
    [
      "philosophie",
      0.01
    ],
    [
      "loi",
      0.01
    ],
    [
      "demonstration",
      0.01
    ],
    [
      "donnee",
      0.01
    ],
    [
      "agent",
      0.01
    ],
    [
      "morale",
      0.0075
    ],
    [
      "motif",
      0.0075
    ],
    [
      "norme",
      0.0075
    ],
    [
      "substance",
      0.0075
    ],
    [
      "ame",
      0.0075
    ],
    [
      "ferment",
      0.0075
    ],
    [
      "facteur",
      0.0075
    ],
    [
      "esprit",
      0.0075
    ],
    [
      "abc",
      0.0075
    ],
    [
      "auteur",
      0.0075
    ],
    [
      "centre",
      0.0075
    ],
    [
      "convention",
      0.0075
    ],
    [
      "definition",
      0.0075
    ],
    [
      "depart",
      0.0075
    ],
    [
      "provenance",
      0.005
    ],
    [
      "premier",
      0.005
    ],
    [
      "notion",
      0.005
    ],
    [
      "moteur",
      0.005
    ],
    [
      "essence",
      0.005
    ],
    [
      "createur",
      0.005
    ],
    [
      "conseil",
      0.0025
    ],
    [
      "catechisme",
      0.0025
    ],
    [
      "axe",
      0.0025
    ],
    [
      "archetype",
      0.0025
    ],
    [
      "alphabet",
      0.0025
    ],
    [
      "premices",
      0.0025
    ]
  ],
  "modeste": [
    [
      "petit",
      0.095
    ],
    [
      "faible",
      0.07
    ],
    [
      "pauvre",
      0.06
    ],
    [
      "mediocre",
      0.045
    ],
    [
      "reserve",
      0.0425
    ],
    [
      "modique",
      0.0425
    ],
    [
      "retenu",
      0.0375
    ],
    [
      "reduit",
      0.0375
    ],
    [
      "simple",
      0.0375
    ],
    [
      "maigre",
      0.0325
    ],
    [
      "humble",
      0.0325
    ],
    [
      "honnete",
      0.0275
    ],
    [
      "insignifiant",
      0.0275
    ],
    [
      "mince",
      0.0275
    ],
    [
      "modere",
      0.0225
    ],
    [
      "mesquin",
      0.0225
    ],
    [
      "decent",
      0.0225
    ],
    [
      "sage",
      0.0175
    ],
    [
      "raisonnable",
      0.0175
    ],
    [
      "pudique",
      0.0175
    ],
    [
      "moyen",
      0.0175
    ],
    [
      "limite",
      0.0175
    ],
    [
      "discret",
      0.0175
    ],
    [
      "etroit",
      0.0125
    ],
    [
      "mesure",
      0.0125
    ],
    [
      "malheureux",
      0.0125
    ],
    [
      "efface",
      0.0125
    ],
    [
      "derisoire",
      0.0125
    ],
    [
      "correct",
      0.0125
    ],
    [
      "vulgaire",
      0.0075
    ],
    [
      "timide",
      0.0075
    ],
    [
      "succinct",
      0.0075
    ],
    [
      "sobre",
      0.0075
    ],
    [
      "convenable",
      0.0075
    ],
    [
      "chaste",
      0.0075
    ],
    [
      "bonasse",
      0.0075
    ],
    [
      "besogneux",
      0.0075
    ],
    [
      "subalterne",
      0.0025
    ],
    [
      "prude",
      0.0025
    ],
    [
      "prosterne",
      0.0025
    ],
    [
      "embarrasse",
      0.0025
    ],
    [
      "digne",
      0.0025
    ],
    [
      "bonhomme",
      0.0025
    ],
    [
      "uni",
      0.0025
    ]
  ],
  "cramer": [
    [
      "bruler",
      0.2725
    ],
    [
      "griller",
      0.18
    ],
    [
      "cuire",
      0.09
    ],
    [
      "flamber",
      0.09
    ],
    [
      "gratiner",
      0.09
    ],
    [
      "prendre",
      0.09
    ],
    [
      "rimer",
      0.09
    ],
    [
      "roussir",
      0.09
    ]
  ],
  "dix": [],
  "vice": [
    [
      "turpitude",
      0.075
    ],
    [
      "debauche",
      0.07
    ],
    [
      "defaut",
      0.0625
    ],
    [
      "corruption",
      0.0525
    ],
    [
      "imperfection",
      0.0525
    ],
    [
      "stupre",
      0.05
    ],
    [
      "depravation",
      0.04
    ],
    [
      "travers",
      0.035
    ],
    [
      "immoralite",
      0.0325
    ],
    [
      "tare",
      0.0225
    ],
    [
      "peche",
      0.0225
    ],
    [
      "perversion",
      0.0225
    ],
    [
      "impurete",
      0.0225
    ],
    [
      "faute",
      0.0225
    ],
    [
      "tache",
      0.02
    ],
    [
      "maladie",
      0.02
    ],
    [
      "mal",
      0.02
    ],
    [
      "licence",
      0.02
    ],
    [
      "libertinage",
      0.02
    ],
    [
      "faiblesse",
      0.02
    ],
    [
      "faible",
      0.02
    ],
    [
      "dereglement",
      0.02
    ],
    [
      "defectuosite",
      0.02
    ],
    [
      "mechancete",
      0.015
    ],
    [
      "manie",
      0.015
    ],
    [
      "luxure",
      0.015
    ],
    [
      "devergondage",
      0.015
    ],
    [
      "bassesse",
      0.015
    ],
    [
      "perversite",
      0.01
    ],
    [
      "passion",
      0.01
    ],
    [
      "difformite",
      0.01
    ],
    [
      "boue",
      0.01
    ],
    [
      "penchant",
      0.0075
    ],
    [
      "malformation",
      0.0075
    ],
    [
      "malfacon",
      0.0075
    ],
    [
      "lubricite",
      0.0075
    ],
    [
      "laideur",
      0.0075
    ],
    [
      "inconduite",
      0.0075
    ],
    [
      "amoralite",
      0.0025
    ],
    [
      "cassation",
      0.0025
    ],
    [
      "chancre",
      0.0025
    ],
    [
      "intemperance",
      0.0025
    ],
    [
      "prostitution",
      0.0025
    ]
  ],
  "avance": [
    [
      "marcher",
      0.065
    ],
    [
      "donner",
      0.0525
    ],
    [
      "aller",
      0.0375
    ],
    [
      "pousser",
      0.0325
    ],
    [
      "progresser",
      0.03
    ],
    [
      "venir",
      0.025
    ],
    [
      "presenter",
      0.025
    ],
    [
      "offrir",
      0.025
    ],
    [
      "tendre",
      0.0225
    ],
    [
      "s'avancer",
      0.0225
    ],
    [
      "gagner",
      0.0225
    ],
    [
      "depasser",
      0.0225
    ],
    [
      "alleguer",
      0.0225
    ],
    [
      "affirmer",
      0.0225
    ],
    [
      "reussir",
      0.0175
    ],
    [
      "precipiter",
      0.0175
    ],
    [
      "proposer",
      0.0175
    ],
    [
      "poser",
      0.0175
    ],
    [
      "brusquer",
      0.0175
    ],
    [
      "enoncer",
      0.015
    ],
    [
      "emettre",
      0.015
    ],
    [
      "soumettre",
      0.015
    ],
    [
      "pretendre",
      0.015
    ],
    [
      "profiter",
      0.015
    ],
    [
      "grandir",
      0.015
    ],
    [
      "deborder",
      0.015
    ],
    [
      "accelerer",
      0.015
    ],
    [
      "prosperer",
      0.01
    ],
    [
      "preter",
      0.01
    ],
    [
      "ressortir",
      0.01
    ],
    [
      "saillir",
      0.01
    ],
    [
      "soutenir",
      0.01
    ],
    [
      "ecrire",
      0.01
    ],
    [
      "payer",
      0.01
    ],
    [
      "hater",
      0.01
    ],
    [
      "forcer",
      0.01
    ],
    [
      "accorder",
      0.01
    ],
    [
      "aligner",
      0.01
    ],
    [
      "allonger",
      0.01
    ],
    [
      "anticiper",
      0.01
    ],
    [
      "approcher",
      0.01
    ],
    [
      "devancer",
      0.01
    ],
    [
      "empieter",
      0.01
    ],
    [
      "s'acheminer",
      0.005
    ],
    [
      "rapprocher",
      0.005
    ],
    [
      "pretexter",
      0.005
    ],
    [
      "proceder",
      0.005
    ],
    [
      "mordre",
      0.005
    ],
    [
      "degager",
      0.005
    ],
    [
      "cheminer",
      0.005
    ],
    [
      "arguer",
      0.005
    ],
    [
      "activer",
      0.005
    ],
    [
      "glisser",
      0.0025
    ],
    [
      "hasarder",
      0.0025
    ],
    [
      "opposer",
      0.0025
    ],
    [
      "s'ebranler",
      0.0025
    ],
    [
      "surplomber",
      0.0025
    ],
    [
      "fonctionner",
      0.0025
    ],
    [
      "escompter",
      0.0025
    ],
    [
      "decaler",
      0.0025
    ],
    [
      "citer",
      0.0025
    ],
    [
      "ameliorer",
      0.0025
    ],
    [
      "allouer",
      0.0025
    ],
    [
      "agiter",
      0.0025
    ],
    [
      "vieillir",
      0.0025
    ]
  ],
  "avancer": [
    [
      "marcher",
      0.065
    ],
    [
      "donner",
      0.0525
    ],
    [
      "aller",
      0.0375
    ],
    [
      "pousser",
      0.0325
    ],
    [
      "progresser",
      0.03
    ],
    [
      "venir",
      0.025
    ],
    [
      "presenter",
      0.025
    ],
    [
      "offrir",
      0.025
    ],
    [
      "tendre",
      0.0225
    ],
    [
      "s'avancer",
      0.0225
    ],
    [
      "gagner",
      0.0225
    ],
    [
      "depasser",
      0.0225
    ],
    [
      "alleguer",
      0.0225
    ],
    [
      "affirmer",
      0.0225
    ],
    [
      "reussir",
      0.0175
    ],
    [
      "precipiter",
      0.0175
    ],
    [
      "proposer",
      0.0175
    ],
    [
      "poser",
      0.0175
    ],
    [
      "brusquer",
      0.0175
    ],
    [
      "enoncer",
      0.015
    ],
    [
      "emettre",
      0.015
    ],
    [
      "soumettre",
      0.015
    ],
    [
      "pretendre",
      0.015
    ],
    [
      "profiter",
      0.015
    ],
    [
      "grandir",
      0.015
    ],
    [
      "deborder",
      0.015
    ],
    [
      "accelerer",
      0.015
    ],
    [
      "prosperer",
      0.01
    ],
    [
      "preter",
      0.01
    ],
    [
      "ressortir",
      0.01
    ],
    [
      "saillir",
      0.01
    ],
    [
      "soutenir",
      0.01
    ],
    [
      "ecrire",
      0.01
    ],
    [
      "payer",
      0.01
    ],
    [
      "hater",
      0.01
    ],
    [
      "forcer",
      0.01
    ],
    [
      "accorder",
      0.01
    ],
    [
      "aligner",
      0.01
    ],
    [
      "allonger",
      0.01
    ],
    [
      "anticiper",
      0.01
    ],
    [
      "approcher",
      0.01
    ],
    [
      "devancer",
      0.01
    ],
    [
      "empieter",
      0.01
    ],
    [
      "s'acheminer",
      0.005
    ],
    [
      "rapprocher",
      0.005
    ],
    [
      "pretexter",
      0.005
    ],
    [
      "proceder",
      0.005
    ],
    [
      "mordre",
      0.005
    ],
    [
      "degager",
      0.005
    ],
    [
      "cheminer",
      0.005
    ],
    [
      "arguer",
      0.005
    ],
    [
      "activer",
      0.005
    ],
    [
      "glisser",
      0.0025
    ],
    [
      "hasarder",
      0.0025
    ],
    [
      "opposer",
      0.0025
    ],
    [
      "s'ebranler",
      0.0025
    ],
    [
      "surplomber",
      0.0025
    ],
    [
      "fonctionner",
      0.0025
    ],
    [
      "escompter",
      0.0025
    ],
    [
      "decaler",
      0.0025
    ],
    [
      "citer",
      0.0025
    ],
    [
      "ameliorer",
      0.0025
    ],
    [
      "allouer",
      0.0025
    ],
    [
      "agiter",
      0.0025
    ],
    [
      "vieillir",
      0.0025
    ]
  ],
  "maitresse": [
    [
      "chef",
      0.0875
    ],
    [
      "souverain",
      0.0375
    ],
    [
      "superieur",
      0.0375
    ],
    [
      "directeur",
      0.0325
    ],
    [
      "precepteur",
      0.0325
    ],
    [
      "puissant",
      0.0325
    ],
    [
      "regent",
      0.025
    ],
    [
      "principal",
      0.025
    ],
    [
      "instituteur",
      0.025
    ],
    [
      "expert",
      0.025
    ],
    [
      "educateur",
      0.02
    ],
    [
      "virtuose",
      0.02
    ],
    [
      "savant",
      0.02
    ],
    [
      "pedant",
      0.02
    ],
    [
      "pedagogue",
      0.02
    ],
    [
      "professeur",
      0.02
    ],
    [
      "premier",
      0.02
    ],
    [
      "patron",
      0.02
    ],
    [
      "gouverneur",
      0.02
    ],
    [
      "surveillant",
      0.015
    ],
    [
      "preponderant",
      0.015
    ],
    [
      "inspirateur",
      0.015
    ],
    [
      "initiateur",
      0.015
    ],
    [
      "gouvernant",
      0.015
    ],
    [
      "dominateur",
      0.015
    ],
    [
      "dirigeant",
      0.015
    ],
    [
      "despote",
      0.015
    ],
    [
      "champion",
      0.015
    ],
    [
      "magister",
      0.01
    ],
    [
      "modele",
      0.01
    ],
    [
      "primordial",
      0.01
    ],
    [
      "prince",
      0.01
    ],
    [
      "seigneur",
      0.01
    ],
    [
      "maestro",
      0.01
    ],
    [
      "fort",
      0.01
    ],
    [
      "essentiel",
      0.01
    ],
    [
      "enseignant",
      0.01
    ],
    [
      "dictateur",
      0.01
    ],
    [
      "contremaitre",
      0.01
    ],
    [
      "as",
      0.01
    ],
    [
      "arbitre",
      0.01
    ],
    [
      "prefet",
      0.005
    ],
    [
      "proprietaire",
      0.005
    ],
    [
      "poete",
      0.005
    ],
    [
      "possesseur",
      0.005
    ],
    [
      "pion",
      0.005
    ],
    [
      "singe",
      0.005
    ],
    [
      "tyran",
      0.005
    ],
    [
      "tenor",
      0.005
    ],
    [
      "universitaire",
      0.005
    ],
    [
      "verse",
      0.005
    ],
    [
      "vital",
      0.005
    ],
    [
      "moniteur",
      0.005
    ],
    [
      "architecte",
      0.005
    ],
    [
      "artiste",
      0.005
    ],
    [
      "barbacole",
      0.005
    ],
    [
      "censeur",
      0.005
    ],
    [
      "competent",
      0.005
    ],
    [
      "devancier",
      0.005
    ],
    [
      "doyen",
      0.005
    ],
    [
      "enseigneur",
      0.005
    ],
    [
      "familier",
      0.005
    ],
    [
      "fondamental",
      0.005
    ],
    [
      "gourmet",
      0.005
    ],
    [
      "majeur",
      0.005
    ],
    [
      "ame",
      0.005
    ]
  ],
  "maitre": [
    [
      "chef",
      0.0875
    ],
    [
      "souverain",
      0.0375
    ],
    [
      "superieur",
      0.0375
    ],
    [
      "directeur",
      0.0325
    ],
    [
      "precepteur",
      0.0325
    ],
    [
      "puissant",
      0.0325
    ],
    [
      "regent",
      0.025
    ],
    [
      "principal",
      0.025
    ],
    [
      "instituteur",
      0.025
    ],
    [
      "expert",
      0.025
    ],
    [
      "educateur",
      0.02
    ],
    [
      "virtuose",
      0.02
    ],
    [
      "savant",
      0.02
    ],
    [
      "pedant",
      0.02
    ],
    [
      "pedagogue",
      0.02
    ],
    [
      "professeur",
      0.02
    ],
    [
      "premier",
      0.02
    ],
    [
      "patron",
      0.02
    ],
    [
      "gouverneur",
      0.02
    ],
    [
      "surveillant",
      0.015
    ],
    [
      "preponderant",
      0.015
    ],
    [
      "inspirateur",
      0.015
    ],
    [
      "initiateur",
      0.015
    ],
    [
      "gouvernant",
      0.015
    ],
    [
      "dominateur",
      0.015
    ],
    [
      "dirigeant",
      0.015
    ],
    [
      "despote",
      0.015
    ],
    [
      "champion",
      0.015
    ],
    [
      "magister",
      0.01
    ],
    [
      "modele",
      0.01
    ],
    [
      "primordial",
      0.01
    ],
    [
      "prince",
      0.01
    ],
    [
      "seigneur",
      0.01
    ],
    [
      "maestro",
      0.01
    ],
    [
      "fort",
      0.01
    ],
    [
      "essentiel",
      0.01
    ],
    [
      "enseignant",
      0.01
    ],
    [
      "dictateur",
      0.01
    ],
    [
      "contremaitre",
      0.01
    ],
    [
      "as",
      0.01
    ],
    [
      "arbitre",
      0.01
    ],
    [
      "prefet",
      0.005
    ],
    [
      "proprietaire",
      0.005
    ],
    [
      "poete",
      0.005
    ],
    [
      "possesseur",
      0.005
    ],
    [
      "pion",
      0.005
    ],
    [
      "singe",
      0.005
    ],
    [
      "tyran",
      0.005
    ],
    [
      "tenor",
      0.005
    ],
    [
      "universitaire",
      0.005
    ],
    [
      "verse",
      0.005
    ],
    [
      "vital",
      0.005
    ],
    [
      "moniteur",
      0.005
    ],
    [
      "architecte",
      0.005
    ],
    [
      "artiste",
      0.005
    ],
    [
      "barbacole",
      0.005
    ],
    [
      "censeur",
      0.005
    ],
    [
      "competent",
      0.005
    ],
    [
      "devancier",
      0.005
    ],
    [
      "doyen",
      0.005
    ],
    [
      "enseigneur",
      0.005
    ],
    [
      "familier",
      0.005
    ],
    [
      "fondamental",
      0.005
    ],
    [
      "gourmet",
      0.005
    ],
    [
      "majeur",
      0.005
    ],
    [
      "ame",
      0.005
    ]
  ],
  "fil": [
    [
      "corde",
      0.1475
    ],
    [
      "attache",
      0.0925
    ],
    [
      "lien",
      0.0925
    ],
    [
      "suite",
      0.04
    ],
    [
      "liaison",
      0.04
    ],
    [
      "cable",
      0.04
    ],
    [
      "cours",
      0.04
    ],
    [
      "courant",
      0.04
    ],
    [
      "cordon",
      0.04
    ],
    [
      "trame",
      0.025
    ],
    [
      "succession",
      0.025
    ],
    [
      "filet",
      0.025
    ],
    [
      "fibre",
      0.025
    ],
    [
      "enchainement",
      0.025
    ],
    [
      "cage",
      0.025
    ],
    [
      "but",
      0.025
    ],
    [
      "amarrage",
      0.025
    ],
    [
      "ligature",
      0.0125
    ],
    [
      "ligneul",
      0.0125
    ],
    [
      "linon",
      0.0125
    ],
    [
      "ronce",
      0.0125
    ],
    [
      "toron",
      0.0125
    ],
    [
      "torque",
      0.0125
    ],
    [
      "larme",
      0.0125
    ],
    [
      "guide",
      0.0125
    ],
    [
      "flot",
      0.0125
    ],
    [
      "filigrane",
      0.0125
    ],
    [
      "ficelle",
      0.0125
    ],
    [
      "deroulement",
      0.0125
    ],
    [
      "cordage",
      0.0125
    ],
    [
      "catgut",
      0.0125
    ],
    [
      "brin",
      0.0125
    ],
    [
      "tranchant",
      0.0125
    ]
  ],
  "fils": [
    [
      "corde",
      0.1475
    ],
    [
      "attache",
      0.0925
    ],
    [
      "lien",
      0.0925
    ],
    [
      "suite",
      0.04
    ],
    [
      "liaison",
      0.04
    ],
    [
      "cable",
      0.04
    ],
    [
      "cours",
      0.04
    ],
    [
      "courant",
      0.04
    ],
    [
      "cordon",
      0.04
    ],
    [
      "trame",
      0.025
    ],
    [
      "succession",
      0.025
    ],
    [
      "filet",
      0.025
    ],
    [
      "fibre",
      0.025
    ],
    [
      "enchainement",
      0.025
    ],
    [
      "cage",
      0.025
    ],
    [
      "but",
      0.025
    ],
    [
      "amarrage",
      0.025
    ],
    [
      "ligature",
      0.0125
    ],
    [
      "ligneul",
      0.0125
    ],
    [
      "linon",
      0.0125
    ],
    [
      "ronce",
      0.0125
    ],
    [
      "toron",
      0.0125
    ],
    [
      "torque",
      0.0125
    ],
    [
      "larme",
      0.0125
    ],
    [
      "guide",
      0.0125
    ],
    [
      "flot",
      0.0125
    ],
    [
      "filigrane",
      0.0125
    ],
    [
      "ficelle",
      0.0125
    ],
    [
      "deroulement",
      0.0125
    ],
    [
      "cordage",
      0.0125
    ],
    [
      "catgut",
      0.0125
    ],
    [
      "brin",
      0.0125
    ],
    [
      "tranchant",
      0.0125
    ]
  ],
  "jouer": [
    [
      "faire",
      0.05
    ],
    [
      "representer",
      0.0325
    ],
    [
      "rouler",
      0.0275
    ],
    [
      "s'amuser",
      0.0275
    ],
    [
      "simuler",
      0.0275
    ],
    [
      "tourner",
      0.0275
    ],
    [
      "tromper",
      0.0225
    ],
    [
      "reproduire",
      0.0225
    ],
    [
      "remuer",
      0.0225
    ],
    [
      "plaisanter",
      0.0225
    ],
    [
      "agir",
      0.0225
    ],
    [
      "abuser",
      0.02
    ],
    [
      "imiter",
      0.02
    ],
    [
      "mystifier",
      0.02
    ],
    [
      "interpreter",
      0.015
    ],
    [
      "marcher",
      0.015
    ],
    [
      "pratiquer",
      0.015
    ],
    [
      "refaire",
      0.015
    ],
    [
      "fonctionner",
      0.015
    ],
    [
      "duper",
      0.015
    ],
    [
      "contrefaire",
      0.015
    ],
    [
      "berner",
      0.015
    ],
    [
      "badiner",
      0.015
    ],
    [
      "affecter",
      0.015
    ],
    [
      "rire",
      0.0125
    ],
    [
      "manier",
      0.0125
    ],
    [
      "folatrer",
      0.0125
    ],
    [
      "donner",
      0.0125
    ],
    [
      "monter",
      0.01
    ],
    [
      "passer",
      0.01
    ],
    [
      "railler",
      0.01
    ],
    [
      "s'ebattre",
      0.01
    ],
    [
      "singer",
      0.01
    ],
    [
      "souffler",
      0.01
    ],
    [
      "toucher",
      0.01
    ],
    [
      "user",
      0.01
    ],
    [
      "miser",
      0.01
    ],
    [
      "mentir",
      0.01
    ],
    [
      "amuser",
      0.01
    ],
    [
      "blaguer",
      0.01
    ],
    [
      "boursicoter",
      0.01
    ],
    [
      "enlever",
      0.01
    ],
    [
      "exposer",
      0.01
    ],
    [
      "executer",
      0.01
    ],
    [
      "feindre",
      0.01
    ],
    [
      "gratter",
      0.01
    ],
    [
      "ponter",
      0.005
    ],
    [
      "poser",
      0.005
    ],
    [
      "risquer",
      0.005
    ],
    [
      "s'entrainer",
      0.005
    ],
    [
      "s'ebrouer",
      0.005
    ],
    [
      "sonner",
      0.005
    ],
    [
      "taquiner",
      0.005
    ],
    [
      "tenir",
      0.005
    ],
    [
      "tripoter",
      0.005
    ],
    [
      "mimer",
      0.005
    ],
    [
      "agiter",
      0.005
    ],
    [
      "batifoler",
      0.005
    ],
    [
      "copier",
      0.005
    ],
    [
      "creer",
      0.005
    ],
    [
      "figurer",
      0.005
    ],
    [
      "flouer",
      0.005
    ],
    [
      "hasarder",
      0.005
    ],
    [
      "incarner",
      0.005
    ],
    [
      "influer",
      0.005
    ],
    [
      "intervenir",
      0.005
    ],
    [
      "parier",
      0.0025
    ],
    [
      "pianoter",
      0.0025
    ],
    [
      "pincer",
      0.0025
    ],
    [
      "plastronner",
      0.0025
    ],
    [
      "racler",
      0.0025
    ],
    [
      "s'exercer",
      0.0025
    ],
    [
      "secouer",
      0.0025
    ],
    [
      "jongler",
      0.0025
    ],
    [
      "gondoler",
      0.0025
    ],
    [
      "attaquer",
      0.0025
    ],
    [
      "aventurer",
      0.0025
    ],
    [
      "compromettre",
      0.0025
    ],
    [
      "coulisser",
      0.0025
    ],
    [
      "feinter",
      0.0025
    ],
    [
      "flamber",
      0.0025
    ],
    [
      "gauchir",
      0.0025
    ],
    [
      "speculer",
      0.0025
    ]
  ],
  "joue": [
    [
      "faire",
      0.05
    ],
    [
      "representer",
      0.0325
    ],
    [
      "rouler",
      0.0275
    ],
    [
      "s'amuser",
      0.0275
    ],
    [
      "simuler",
      0.0275
    ],
    [
      "tourner",
      0.0275
    ],
    [
      "tromper",
      0.0225
    ],
    [
      "reproduire",
      0.0225
    ],
    [
      "remuer",
      0.0225
    ],
    [
      "plaisanter",
      0.0225
    ],
    [
      "agir",
      0.0225
    ],
    [
      "abuser",
      0.02
    ],
    [
      "imiter",
      0.02
    ],
    [
      "mystifier",
      0.02
    ],
    [
      "interpreter",
      0.015
    ],
    [
      "marcher",
      0.015
    ],
    [
      "pratiquer",
      0.015
    ],
    [
      "refaire",
      0.015
    ],
    [
      "fonctionner",
      0.015
    ],
    [
      "duper",
      0.015
    ],
    [
      "contrefaire",
      0.015
    ],
    [
      "berner",
      0.015
    ],
    [
      "badiner",
      0.015
    ],
    [
      "affecter",
      0.015
    ],
    [
      "rire",
      0.0125
    ],
    [
      "manier",
      0.0125
    ],
    [
      "folatrer",
      0.0125
    ],
    [
      "donner",
      0.0125
    ],
    [
      "monter",
      0.01
    ],
    [
      "passer",
      0.01
    ],
    [
      "railler",
      0.01
    ],
    [
      "s'ebattre",
      0.01
    ],
    [
      "singer",
      0.01
    ],
    [
      "souffler",
      0.01
    ],
    [
      "toucher",
      0.01
    ],
    [
      "user",
      0.01
    ],
    [
      "miser",
      0.01
    ],
    [
      "mentir",
      0.01
    ],
    [
      "amuser",
      0.01
    ],
    [
      "blaguer",
      0.01
    ],
    [
      "boursicoter",
      0.01
    ],
    [
      "enlever",
      0.01
    ],
    [
      "exposer",
      0.01
    ],
    [
      "executer",
      0.01
    ],
    [
      "feindre",
      0.01
    ],
    [
      "gratter",
      0.01
    ],
    [
      "ponter",
      0.005
    ],
    [
      "poser",
      0.005
    ],
    [
      "risquer",
      0.005
    ],
    [
      "s'entrainer",
      0.005
    ],
    [
      "s'ebrouer",
      0.005
    ],
    [
      "sonner",
      0.005
    ],
    [
      "taquiner",
      0.005
    ],
    [
      "tenir",
      0.005
    ],
    [
      "tripoter",
      0.005
    ],
    [
      "mimer",
      0.005
    ],
    [
      "agiter",
      0.005
    ],
    [
      "batifoler",
      0.005
    ],
    [
      "copier",
      0.005
    ],
    [
      "creer",
      0.005
    ],
    [
      "figurer",
      0.005
    ],
    [
      "flouer",
      0.005
    ],
    [
      "hasarder",
      0.005
    ],
    [
      "incarner",
      0.005
    ],
    [
      "influer",
      0.005
    ],
    [
      "intervenir",
      0.005
    ],
    [
      "parier",
      0.0025
    ],
    [
      "pianoter",
      0.0025
    ],
    [
      "pincer",
      0.0025
    ],
    [
      "plastronner",
      0.0025
    ],
    [
      "racler",
      0.0025
    ],
    [
      "s'exercer",
      0.0025
    ],
    [
      "secouer",
      0.0025
    ],
    [
      "jongler",
      0.0025
    ],
    [
      "gondoler",
      0.0025
    ],
    [
      "attaquer",
      0.0025
    ],
    [
      "aventurer",
      0.0025
    ],
    [
      "compromettre",
      0.0025
    ],
    [
      "coulisser",
      0.0025
    ],
    [
      "feinter",
      0.0025
    ],
    [
      "flamber",
      0.0025
    ],
    [
      "gauchir",
      0.0025
    ],
    [
      "speculer",
      0.0025
    ]
  ],
  "appuyer": [
    [
      "soutenir",
      0.1125
    ],
    [
      "aider",
      0.0475
    ],
    [
      "proteger",
      0.045
    ],
    [
      "fortifier",
      0.0425
    ],
    [
      "pousser",
      0.04
    ],
    [
      "epauler",
      0.035
    ],
    [
      "etayer",
      0.035
    ],
    [
      "porter",
      0.0275
    ],
    [
      "servir",
      0.025
    ],
    [
      "confirmer",
      0.0225
    ],
    [
      "maintenir",
      0.0225
    ],
    [
      "poser",
      0.0225
    ],
    [
      "tenir",
      0.0225
    ],
    [
      "renforcer",
      0.02
    ],
    [
      "mettre",
      0.02
    ],
    [
      "encourager",
      0.02
    ],
    [
      "etablir",
      0.0175
    ],
    [
      "pistonner",
      0.0175
    ],
    [
      "fixer",
      0.0175
    ],
    [
      "favoriser",
      0.0175
    ],
    [
      "consolider",
      0.0175
    ],
    [
      "accentuer",
      0.015
    ],
    [
      "faire",
      0.015
    ],
    [
      "supporter",
      0.0125
    ],
    [
      "peser",
      0.0125
    ],
    [
      "patronner",
      0.0125
    ],
    [
      "defendre",
      0.0125
    ],
    [
      "secourir",
      0.0075
    ],
    [
      "reposer",
      0.0075
    ],
    [
      "presser",
      0.0075
    ],
    [
      "participer",
      0.0075
    ],
    [
      "insister",
      0.0075
    ],
    [
      "fonder",
      0.0075
    ],
    [
      "corroborer",
      0.0075
    ],
    [
      "assister",
      0.0075
    ],
    [
      "asseoir",
      0.0075
    ],
    [
      "prononcer",
      0.0075
    ],
    [
      "recommander",
      0.0075
    ],
    [
      "serrer",
      0.0075
    ],
    [
      "souligner",
      0.0075
    ],
    [
      "etanconner",
      0.0075
    ],
    [
      "parrainer",
      0.0075
    ],
    [
      "caler",
      0.0075
    ],
    [
      "adosser",
      0.0075
    ],
    [
      "alleguer",
      0.0075
    ],
    [
      "appliquer",
      0.0075
    ],
    [
      "autoriser",
      0.0075
    ],
    [
      "seconder",
      0.0025
    ],
    [
      "ressortir",
      0.0025
    ],
    [
      "frotter",
      0.0025
    ],
    [
      "coller",
      0.0025
    ],
    [
      "cautionner",
      0.0025
    ],
    [
      "buter",
      0.0025
    ],
    [
      "baser",
      0.0025
    ],
    [
      "accoter",
      0.0025
    ],
    [
      "s'appesantir",
      0.0
    ],
    [
      "s'assurer",
      0.0
    ],
    [
      "exciper",
      0.0
    ],
    [
      "exagerer",
      0.0
    ],
    [
      "avouer",
      0.0
    ],
    [
      "avaliser",
      0.0
    ],
    [
      "arguer",
      0.0
    ]
  ],
  "traitre": [
    [
      "deloyal",
      0.1175
    ],
    [
      "perfide",
      0.1175
    ],
    [
      "renegat",
      0.1
    ],
    [
      "fourbe",
      0.0825
    ],
    [
      "transfuge",
      0.0825
    ],
    [
      "trompeur",
      0.0675
    ],
    [
      "judas",
      0.0675
    ],
    [
      "infidele",
      0.0675
    ],
    [
      "sournois",
      0.0325
    ],
    [
      "lache",
      0.0325
    ],
    [
      "espion",
      0.0325
    ],
    [
      "deserteur",
      0.0325
    ],
    [
      "vendu",
      0.015
    ],
    [
      "parjure",
      0.015
    ],
    [
      "mouchard",
      0.015
    ],
    [
      "insidieux",
      0.015
    ],
    [
      "felon",
      0.015
    ],
    [
      "delateur",
      0.015
    ],
    [
      "dangereux",
      0.015
    ],
    [
      "vilain",
      0.015
    ]
  ],
  "voisin": [
    [
      "proche",
      0.1225
    ],
    [
      "contigu",
      0.085
    ],
    [
      "analogue",
      0.0725
    ],
    [
      "prochain",
      0.06
    ],
    [
      "semblable",
      0.06
    ],
    [
      "similaire",
      0.0475
    ],
    [
      "riverain",
      0.0475
    ],
    [
      "limitrophe",
      0.0475
    ],
    [
      "avoisinant",
      0.0475
    ],
    [
      "attenant",
      0.0475
    ],
    [
      "approchant",
      0.0475
    ],
    [
      "comparable",
      0.035
    ],
    [
      "analogique",
      0.035
    ],
    [
      "adjacent",
      0.035
    ],
    [
      "approximatif",
      0.0225
    ],
    [
      "environnant",
      0.0225
    ],
    [
      "jouxtant",
      0.0225
    ],
    [
      "ressemblant",
      0.01
    ],
    [
      "rapproche",
      0.01
    ],
    [
      "pres",
      0.01
    ],
    [
      "mitoyen",
      0.01
    ],
    [
      "germain",
      0.01
    ],
    [
      "connexe",
      0.01
    ],
    [
      "circonvoisin",
      0.01
    ],
    [
      "approche",
      0.01
    ],
    [
      "apparente",
      0.01
    ],
    [
      "voisinage",
      0.01
    ]
  ],
  "dinette": [
    [
      "diner",
      0.3325
    ],
    [
      "dinee",
      0.3325
    ],
    [
      "repas",
      0.3325
    ]
  ],
  "fenetre": [
    [
      "ouverture",
      0.2625
    ],
    [
      "baie",
      0.07
    ],
    [
      "lucarne",
      0.07
    ],
    [
      "vue",
      0.0475
    ],
    [
      "vitre",
      0.0475
    ],
    [
      "tabatiere",
      0.0475
    ],
    [
      "lunette",
      0.0475
    ],
    [
      "jour",
      0.0475
    ],
    [
      "croisee",
      0.0475
    ],
    [
      "chassis",
      0.0475
    ],
    [
      "carreau",
      0.0475
    ],
    [
      "soupirail",
      0.0225
    ],
    [
      "sabord",
      0.0225
    ],
    [
      "hublot",
      0.0225
    ],
    [
      "fermeture",
      0.0225
    ],
    [
      "blanc",
      0.0225
    ],
    [
      "ajour",
      0.0225
    ],
    [
      "vasistas",
      0.0225
    ]
  ],
  "nez": [
    [
      "museau",
      0.1
    ],
    [
      "blase",
      0.0675
    ],
    [
      "flair",
      0.0675
    ],
    [
      "pif",
      0.0675
    ],
    [
      "visage",
      0.0675
    ],
    [
      "perspicacite",
      0.0325
    ],
    [
      "piton",
      0.0325
    ],
    [
      "proue",
      0.0325
    ],
    [
      "penetration",
      0.0325
    ],
    [
      "reniflant",
      0.0325
    ],
    [
      "renifloir",
      0.0325
    ],
    [
      "tarin",
      0.0325
    ],
    [
      "trompe",
      0.0325
    ],
    [
      "organe",
      0.0325
    ],
    [
      "odorat",
      0.0325
    ],
    [
      "appendice",
      0.0325
    ],
    [
      "avant",
      0.0325
    ],
    [
      "binette",
      0.0325
    ],
    [
      "blair",
      0.0325
    ],
    [
      "bouquet",
      0.0325
    ],
    [
      "clairvoyance",
      0.0325
    ],
    [
      "narine",
      0.0325
    ],
    [
      "nase",
      0.0325
    ],
    [
      "truffe",
      0.0325
    ]
  ],
  "cuvette": [
    [
      "bassin",
      0.1425
    ],
    [
      "depression",
      0.1425
    ],
    [
      "bassine",
      0.095
    ],
    [
      "creux",
      0.095
    ],
    [
      "repli",
      0.0475
    ],
    [
      "pli",
      0.0475
    ],
    [
      "lavabo",
      0.0475
    ],
    [
      "fond",
      0.0475
    ],
    [
      "entonnoir",
      0.0475
    ],
    [
      "cuve",
      0.0475
    ],
    [
      "chott",
      0.0475
    ],
    [
      "caisse",
      0.0475
    ],
    [
      "bidet",
      0.0475
    ],
    [
      "bassinet",
      0.0475
    ],
    [
      "vallee",
      0.0475
    ]
  ],
  "voler": [
    [
      "derober",
      0.085
    ],
    [
      "prendre",
      0.0625
    ],
    [
      "enlever",
      0.035
    ],
    [
      "piquer",
      0.03
    ],
    [
      "escroquer",
      0.03
    ],
    [
      "soustraire",
      0.03
    ],
    [
      "piller",
      0.0275
    ],
    [
      "attraper",
      0.025
    ],
    [
      "chiper",
      0.0225
    ],
    [
      "depouiller",
      0.0225
    ],
    [
      "faucher",
      0.0225
    ],
    [
      "s'approprier",
      0.0225
    ],
    [
      "tromper",
      0.0225
    ],
    [
      "courir",
      0.0175
    ],
    [
      "ravir",
      0.0175
    ],
    [
      "rouler",
      0.0175
    ],
    [
      "s'emparer",
      0.015
    ],
    [
      "detourner",
      0.0125
    ],
    [
      "exploiter",
      0.0125
    ],
    [
      "extorquer",
      0.0125
    ],
    [
      "refaire",
      0.0125
    ],
    [
      "subtiliser",
      0.0125
    ],
    [
      "plagier",
      0.01
    ],
    [
      "choper",
      0.01
    ],
    [
      "carotter",
      0.01
    ],
    [
      "chaparder",
      0.01
    ],
    [
      "estamper",
      0.01
    ],
    [
      "gruger",
      0.01
    ],
    [
      "tirer",
      0.0075
    ],
    [
      "s'elancer",
      0.0075
    ],
    [
      "kidnapper",
      0.0075
    ],
    [
      "grappiller",
      0.0075
    ],
    [
      "filouter",
      0.0075
    ],
    [
      "emporter",
      0.0075
    ],
    [
      "devaliser",
      0.0075
    ],
    [
      "barboter",
      0.0075
    ],
    [
      "s'envoler",
      0.0075
    ],
    [
      "soutirer",
      0.0075
    ],
    [
      "spolier",
      0.0075
    ],
    [
      "tondre",
      0.0075
    ],
    [
      "ecorcher",
      0.0075
    ],
    [
      "rafler",
      0.0075
    ],
    [
      "marauder",
      0.0075
    ],
    [
      "gratter",
      0.0075
    ],
    [
      "foncer",
      0.0075
    ],
    [
      "filer",
      0.0075
    ],
    [
      "chauffer",
      0.0075
    ],
    [
      "aller",
      0.0075
    ],
    [
      "voltiger",
      0.005
    ],
    [
      "s'elever",
      0.005
    ],
    [
      "ratiboiser",
      0.005
    ],
    [
      "monter",
      0.005
    ],
    [
      "frustrer",
      0.005
    ],
    [
      "flouer",
      0.005
    ],
    [
      "escamoter",
      0.005
    ],
    [
      "naviguer",
      0.0025
    ],
    [
      "planer",
      0.0025
    ],
    [
      "priver",
      0.0025
    ],
    [
      "ranconner",
      0.0025
    ],
    [
      "sevrer",
      0.0025
    ],
    [
      "usurper",
      0.0025
    ],
    [
      "voleter",
      0.0025
    ],
    [
      "etriller",
      0.0025
    ],
    [
      "fuir",
      0.0025
    ],
    [
      "flotter",
      0.0025
    ],
    [
      "flamber",
      0.0025
    ],
    [
      "bondir",
      0.0025
    ],
    [
      "copier",
      0.0025
    ],
    [
      "cueillir",
      0.0025
    ],
    [
      "demunir",
      0.0025
    ],
    [
      "deposseder",
      0.0025
    ],
    [
      "detrousser",
      0.0025
    ],
    [
      "empiler",
      0.0025
    ],
    [
      "emprunter",
      0.0025
    ],
    [
      "piper",
      0.0025
    ],
    [
      "poursuivre",
      0.0025
    ],
    [
      "repasser",
      0.0025
    ],
    [
      "s'enfuir",
      0.0025
    ],
    [
      "soulager",
      0.0025
    ],
    [
      "matraquer",
      0.0025
    ],
    [
      "arnaquer",
      0.0025
    ],
    [
      "butiner",
      0.0025
    ],
    [
      "cambrioler",
      0.0025
    ],
    [
      "confisquer",
      0.0025
    ],
    [
      "distraire",
      0.0025
    ],
    [
      "delester",
      0.0025
    ],
    [
      "demarquer",
      0.0025
    ],
    [
      "empaumer",
      0.0025
    ],
    [
      "larronner",
      0.0
    ],
    [
      "papillonner",
      0.0
    ],
    [
      "pointer",
      0.0
    ],
    [
      "rapiner",
      0.0
    ],
    [
      "rifler",
      0.0
    ],
    [
      "s'attribuer",
      0.0
    ],
    [
      "survoler",
      0.0
    ],
    [
      "tournoyer",
      0.0
    ],
    [
      "griveler",
      0.0
    ],
    [
      "grincher",
      0.0
    ],
    [
      "friponner",
      0.0
    ],
    [
      "alleger",
      0.0
    ],
    [
      "arranger",
      0.0
    ],
    [
      "brigander",
      0.0
    ],
    [
      "calotter",
      0.0
    ],
    [
      "chouraver",
      0.0
    ],
    [
      "cravater",
      0.0
    ],
    [
      "emmener",
      0.0
    ],
    [
      "entoler",
      0.0
    ],
    [
      "flibuster",
      0.0
    ],
    [
      "etouffer",
      0.0
    ]
  ],
  "vole": [
    [
      "derober",
      0.085
    ],
    [
      "prendre",
      0.0625
    ],
    [
      "enlever",
      0.035
    ],
    [
      "piquer",
      0.03
    ],
    [
      "escroquer",
      0.03
    ],
    [
      "soustraire",
      0.03
    ],
    [
      "piller",
      0.0275
    ],
    [
      "attraper",
      0.025
    ],
    [
      "chiper",
      0.0225
    ],
    [
      "depouiller",
      0.0225
    ],
    [
      "faucher",
      0.0225
    ],
    [
      "s'approprier",
      0.0225
    ],
    [
      "tromper",
      0.0225
    ],
    [
      "courir",
      0.0175
    ],
    [
      "ravir",
      0.0175
    ],
    [
      "rouler",
      0.0175
    ],
    [
      "s'emparer",
      0.015
    ],
    [
      "detourner",
      0.0125
    ],
    [
      "exploiter",
      0.0125
    ],
    [
      "extorquer",
      0.0125
    ],
    [
      "refaire",
      0.0125
    ],
    [
      "subtiliser",
      0.0125
    ],
    [
      "plagier",
      0.01
    ],
    [
      "choper",
      0.01
    ],
    [
      "carotter",
      0.01
    ],
    [
      "chaparder",
      0.01
    ],
    [
      "estamper",
      0.01
    ],
    [
      "gruger",
      0.01
    ],
    [
      "tirer",
      0.0075
    ],
    [
      "s'elancer",
      0.0075
    ],
    [
      "kidnapper",
      0.0075
    ],
    [
      "grappiller",
      0.0075
    ],
    [
      "filouter",
      0.0075
    ],
    [
      "emporter",
      0.0075
    ],
    [
      "devaliser",
      0.0075
    ],
    [
      "barboter",
      0.0075
    ],
    [
      "s'envoler",
      0.0075
    ],
    [
      "soutirer",
      0.0075
    ],
    [
      "spolier",
      0.0075
    ],
    [
      "tondre",
      0.0075
    ],
    [
      "ecorcher",
      0.0075
    ],
    [
      "rafler",
      0.0075
    ],
    [
      "marauder",
      0.0075
    ],
    [
      "gratter",
      0.0075
    ],
    [
      "foncer",
      0.0075
    ],
    [
      "filer",
      0.0075
    ],
    [
      "chauffer",
      0.0075
    ],
    [
      "aller",
      0.0075
    ],
    [
      "voltiger",
      0.005
    ],
    [
      "s'elever",
      0.005
    ],
    [
      "ratiboiser",
      0.005
    ],
    [
      "monter",
      0.005
    ],
    [
      "frustrer",
      0.005
    ],
    [
      "flouer",
      0.005
    ],
    [
      "escamoter",
      0.005
    ],
    [
      "naviguer",
      0.0025
    ],
    [
      "planer",
      0.0025
    ],
    [
      "priver",
      0.0025
    ],
    [
      "ranconner",
      0.0025
    ],
    [
      "sevrer",
      0.0025
    ],
    [
      "usurper",
      0.0025
    ],
    [
      "voleter",
      0.0025
    ],
    [
      "etriller",
      0.0025
    ],
    [
      "fuir",
      0.0025
    ],
    [
      "flotter",
      0.0025
    ],
    [
      "flamber",
      0.0025
    ],
    [
      "bondir",
      0.0025
    ],
    [
      "copier",
      0.0025
    ],
    [
      "cueillir",
      0.0025
    ],
    [
      "demunir",
      0.0025
    ],
    [
      "deposseder",
      0.0025
    ],
    [
      "detrousser",
      0.0025
    ],
    [
      "empiler",
      0.0025
    ],
    [
      "emprunter",
      0.0025
    ],
    [
      "piper",
      0.0025
    ],
    [
      "poursuivre",
      0.0025
    ],
    [
      "repasser",
      0.0025
    ],
    [
      "s'enfuir",
      0.0025
    ],
    [
      "soulager",
      0.0025
    ],
    [
      "matraquer",
      0.0025
    ],
    [
      "arnaquer",
      0.0025
    ],
    [
      "butiner",
      0.0025
    ],
    [
      "cambrioler",
      0.0025
    ],
    [
      "confisquer",
      0.0025
    ],
    [
      "distraire",
      0.0025
    ],
    [
      "delester",
      0.0025
    ],
    [
      "demarquer",
      0.0025
    ],
    [
      "empaumer",
      0.0025
    ],
    [
      "larronner",
      0.0
    ],
    [
      "papillonner",
      0.0
    ],
    [
      "pointer",
      0.0
    ],
    [
      "rapiner",
      0.0
    ],
    [
      "rifler",
      0.0
    ],
    [
      "s'attribuer",
      0.0
    ],
    [
      "survoler",
      0.0
    ],
    [
      "tournoyer",
      0.0
    ],
    [
      "griveler",
      0.0
    ],
    [
      "grincher",
      0.0
    ],
    [
      "friponner",
      0.0
    ],
    [
      "alleger",
      0.0
    ],
    [
      "arranger",
      0.0
    ],
    [
      "brigander",
      0.0
    ],
    [
      "calotter",
      0.0
    ],
    [
      "chouraver",
      0.0
    ],
    [
      "cravater",
      0.0
    ],
    [
      "emmener",
      0.0
    ],
    [
      "entoler",
      0.0
    ],
    [
      "flibuster",
      0.0
    ],
    [
      "etouffer",
      0.0
    ]
  ],
  "voyager": [
    [
      "aller",
      0.11
    ],
    [
      "errer",
      0.11
    ],
    [
      "circuler",
      0.0875
    ],
    [
      "bouger",
      0.065
    ],
    [
      "courir",
      0.065
    ],
    [
      "visiter",
      0.0425
    ],
    [
      "partir",
      0.0425
    ],
    [
      "naviguer",
      0.0425
    ],
    [
      "vagabonder",
      0.02
    ],
    [
      "peregriner",
      0.02
    ],
    [
      "migrer",
      0.02
    ],
    [
      "excursionner",
      0.02
    ],
    [
      "bourlinguer",
      0.02
    ],
    [
      "voir",
      0.02
    ]
  ],
  "caisse": [
    [
      "boite",
      0.0875
    ],
    [
      "coffre",
      0.0875
    ],
    [
      "bagage",
      0.035
    ],
    [
      "ballot",
      0.035
    ],
    [
      "cagnotte",
      0.035
    ],
    [
      "cantine",
      0.035
    ],
    [
      "malle",
      0.035
    ],
    [
      "fonds",
      0.025
    ],
    [
      "finance",
      0.025
    ],
    [
      "contenant",
      0.025
    ],
    [
      "cageot",
      0.025
    ],
    [
      "bureau",
      0.025
    ],
    [
      "tirelire",
      0.015
    ],
    [
      "estomac",
      0.015
    ],
    [
      "emballage",
      0.015
    ],
    [
      "colis",
      0.015
    ],
    [
      "coffret",
      0.015
    ],
    [
      "carcasse",
      0.015
    ],
    [
      "caissette",
      0.015
    ],
    [
      "cadre",
      0.015
    ],
    [
      "buffet",
      0.015
    ],
    [
      "automobile",
      0.015
    ],
    [
      "bagnole",
      0.015
    ],
    [
      "balle",
      0.015
    ],
    [
      "barda",
      0.015
    ],
    [
      "billot",
      0.015
    ],
    [
      "bourse",
      0.015
    ],
    [
      "montant",
      0.0075
    ],
    [
      "masse",
      0.0075
    ],
    [
      "harasse",
      0.0075
    ],
    [
      "guichet",
      0.0075
    ],
    [
      "gaine",
      0.0075
    ],
    [
      "encaisse",
      0.0075
    ],
    [
      "papillote",
      0.0075
    ],
    [
      "poitrine",
      0.0075
    ],
    [
      "prison",
      0.0075
    ],
    [
      "reservoir",
      0.0075
    ],
    [
      "tambour",
      0.0075
    ],
    [
      "timbale",
      0.0075
    ],
    [
      "tire",
      0.0075
    ],
    [
      "tresorerie",
      0.0075
    ],
    [
      "cuvette",
      0.0075
    ],
    [
      "coque",
      0.0075
    ],
    [
      "comptoir",
      0.0075
    ],
    [
      "banne",
      0.0075
    ],
    [
      "batterie",
      0.0075
    ],
    [
      "benne",
      0.0075
    ],
    [
      "biere",
      0.0075
    ],
    [
      "boitier",
      0.0075
    ],
    [
      "caisson",
      0.0075
    ],
    [
      "cale",
      0.0075
    ],
    [
      "carrosserie",
      0.0075
    ],
    [
      "cave",
      0.0075
    ],
    [
      "cercueil",
      0.0075
    ],
    [
      "chignole",
      0.0075
    ],
    [
      "comptabilite",
      0.0075
    ],
    [
      "actif",
      0.0075
    ]
  ],
  "ban": [
    [
      "ovation",
      0.165
    ],
    [
      "proclamation",
      0.165
    ],
    [
      "hourra",
      0.0825
    ],
    [
      "exposition",
      0.0825
    ],
    [
      "exil",
      0.0825
    ],
    [
      "declaration",
      0.0825
    ],
    [
      "bannissement",
      0.0825
    ],
    [
      "avis",
      0.0825
    ],
    [
      "applaudissement",
      0.0825
    ],
    [
      "publication",
      0.0825
    ]
  ],
  "reconnaitre": [
    [
      "decouvrir",
      0.05
    ],
    [
      "admettre",
      0.045
    ],
    [
      "avouer",
      0.045
    ],
    [
      "confesser",
      0.045
    ],
    [
      "discerner",
      0.045
    ],
    [
      "juger",
      0.0375
    ],
    [
      "constater",
      0.0375
    ],
    [
      "accorder",
      0.0325
    ],
    [
      "examiner",
      0.0325
    ],
    [
      "reveler",
      0.0325
    ],
    [
      "eprouver",
      0.0325
    ],
    [
      "trouver",
      0.0275
    ],
    [
      "sonder",
      0.0275
    ],
    [
      "declarer",
      0.0275
    ],
    [
      "distinguer",
      0.0275
    ],
    [
      "convenir",
      0.0275
    ],
    [
      "deviner",
      0.02
    ],
    [
      "verifier",
      0.02
    ],
    [
      "etablir",
      0.015
    ],
    [
      "tater",
      0.015
    ],
    [
      "retrouver",
      0.015
    ],
    [
      "remettre",
      0.015
    ],
    [
      "identifier",
      0.015
    ],
    [
      "explorer",
      0.015
    ],
    [
      "entendre",
      0.015
    ],
    [
      "attribuer",
      0.015
    ],
    [
      "recevoir",
      0.01
    ],
    [
      "nommer",
      0.01
    ],
    [
      "croire",
      0.01
    ],
    [
      "connaitre",
      0.01
    ],
    [
      "conceder",
      0.01
    ],
    [
      "certifier",
      0.01
    ],
    [
      "affirmer",
      0.01
    ],
    [
      "proclamer",
      0.0025
    ],
    [
      "prospecter",
      0.0025
    ],
    [
      "preter",
      0.0025
    ],
    [
      "recompenser",
      0.0025
    ],
    [
      "s'accuser",
      0.0025
    ],
    [
      "subsumer",
      0.0025
    ],
    [
      "visiter",
      0.0025
    ],
    [
      "legitimer",
      0.0025
    ],
    [
      "endosser",
      0.0025
    ],
    [
      "apparaitre",
      0.0025
    ],
    [
      "arraisonner",
      0.0025
    ],
    [
      "assurer",
      0.0025
    ],
    [
      "averer",
      0.0025
    ],
    [
      "battre",
      0.0025
    ],
    [
      "crediter",
      0.0025
    ],
    [
      "diagnostiquer",
      0.0025
    ],
    [
      "differencier",
      0.0025
    ],
    [
      "discriminer",
      0.0025
    ],
    [
      "eclairer",
      0.0025
    ]
  ],
  "trouve": [
    [
      "decouvrir",
      0.0925
    ],
    [
      "saisir",
      0.0675
    ],
    [
      "deviner",
      0.0525
    ],
    [
      "voir",
      0.0525
    ],
    [
      "imaginer",
      0.0475
    ],
    [
      "juger",
      0.0475
    ],
    [
      "reperer",
      0.0425
    ],
    [
      "comprendre",
      0.04
    ],
    [
      "penser",
      0.035
    ],
    [
      "apercevoir",
      0.035
    ],
    [
      "concevoir",
      0.025
    ],
    [
      "rencontrer",
      0.025
    ],
    [
      "atteindre",
      0.02
    ],
    [
      "percer",
      0.02
    ],
    [
      "reconnaitre",
      0.02
    ],
    [
      "surprendre",
      0.015
    ],
    [
      "inventer",
      0.015
    ],
    [
      "estimer",
      0.015
    ],
    [
      "dechiffrer",
      0.015
    ],
    [
      "deceler",
      0.015
    ],
    [
      "considerer",
      0.015
    ],
    [
      "eprouver",
      0.0125
    ],
    [
      "toucher",
      0.0125
    ],
    [
      "retrouver",
      0.0125
    ],
    [
      "regarder",
      0.0125
    ],
    [
      "joindre",
      0.0125
    ],
    [
      "croire",
      0.0125
    ],
    [
      "sentir",
      0.0075
    ],
    [
      "s'aviser",
      0.0075
    ],
    [
      "resoudre",
      0.0075
    ],
    [
      "relever",
      0.0075
    ],
    [
      "rejoindre",
      0.0075
    ],
    [
      "pincer",
      0.0075
    ],
    [
      "obtenir",
      0.0075
    ],
    [
      "denicher",
      0.0075
    ],
    [
      "creer",
      0.0075
    ],
    [
      "acquerir",
      0.0075
    ],
    [
      "procurer",
      0.0025
    ],
    [
      "pecher",
      0.0025
    ],
    [
      "reussir",
      0.0025
    ],
    [
      "elucider",
      0.0025
    ],
    [
      "mettre",
      0.0025
    ],
    [
      "innover",
      0.0025
    ],
    [
      "forger",
      0.0025
    ],
    [
      "deterrer",
      0.0025
    ],
    [
      "detecter",
      0.0025
    ],
    [
      "desapprouver",
      0.0025
    ],
    [
      "degoter",
      0.0025
    ],
    [
      "cueillir",
      0.0025
    ],
    [
      "avoir",
      0.0025
    ]
  ],
  "rentraire": [
    [
      "raccommoder",
      0.25
    ],
    [
      "ravauder",
      0.25
    ],
    [
      "repriser",
      0.25
    ],
    [
      "coudre",
      0.125
    ],
    [
      "stopper",
      0.125
    ]
  ],
  "rentrer": [
    [
      "refouler",
      0.07
    ],
    [
      "dissimuler",
      0.06
    ],
    [
      "entrer",
      0.06
    ],
    [
      "penetrer",
      0.06
    ],
    [
      "regagner",
      0.04
    ],
    [
      "contenir",
      0.04
    ],
    [
      "etouffer",
      0.03
    ],
    [
      "revenir",
      0.03
    ],
    [
      "retrouver",
      0.03
    ],
    [
      "retourner",
      0.03
    ],
    [
      "retenir",
      0.03
    ],
    [
      "renfoncer",
      0.03
    ],
    [
      "rallier",
      0.03
    ],
    [
      "concentrer",
      0.03
    ],
    [
      "cacher",
      0.03
    ],
    [
      "reprimer",
      0.0175
    ],
    [
      "s'enfoncer",
      0.0175
    ],
    [
      "s'engager",
      0.0175
    ],
    [
      "s'insinuer",
      0.0175
    ],
    [
      "s'introduire",
      0.0175
    ],
    [
      "taire",
      0.0175
    ],
    [
      "reintegrer",
      0.0175
    ],
    [
      "remettre",
      0.0175
    ],
    [
      "rejoindre",
      0.0175
    ],
    [
      "avaler",
      0.0175
    ],
    [
      "devorer",
      0.0175
    ],
    [
      "escamoter",
      0.0175
    ],
    [
      "introduire",
      0.0175
    ],
    [
      "percuter",
      0.0175
    ],
    [
      "ravaler",
      0.0175
    ],
    [
      "tamponner",
      0.0075
    ],
    [
      "retracter",
      0.0075
    ],
    [
      "rengainer",
      0.0075
    ],
    [
      "refrener",
      0.0075
    ],
    [
      "reconquerir",
      0.0075
    ],
    [
      "emboutir",
      0.0075
    ],
    [
      "creuser",
      0.0075
    ],
    [
      "telescoper",
      0.0075
    ]
  ],
  "chez": [
    [
      "dans",
      0.3325
    ],
    [
      "aupres",
      0.165
    ],
    [
      "parmi",
      0.165
    ],
    [
      "a",
      0.165
    ]
  ],
  "escorter": [
    [
      "accompagner",
      0.3325
    ],
    [
      "chaperonner",
      0.11
    ],
    [
      "conduire",
      0.11
    ],
    [
      "convoyer",
      0.11
    ],
    [
      "proteger",
      0.11
    ],
    [
      "suivre",
      0.11
    ],
    [
      "flanquer",
      0.0725
    ],
    [
      "reconduire",
      0.035
    ]
  ],
  "escorte": [
    [
      "cortege",
      0.2
    ],
    [
      "troupe",
      0.2
    ],
    [
      "accompagnement",
      0.1325
    ],
    [
      "suite",
      0.065
    ],
    [
      "garde",
      0.065
    ],
    [
      "detachement",
      0.065
    ],
    [
      "conduite",
      0.065
    ],
    [
      "appareil",
      0.065
    ],
    [
      "accompagnateur",
      0.065
    ],
    [
      "equipage",
      0.065
    ]
  ],
  "revenu": [
    [
      "renaitre",
      0.055
    ],
    [
      "recommencer",
      0.0475
    ],
    [
      "reprendre",
      0.0475
    ],
    [
      "retourner",
      0.0475
    ],
    [
      "regagner",
      0.0325
    ],
    [
      "reapparaitre",
      0.0275
    ],
    [
      "retomber",
      0.0275
    ],
    [
      "passer",
      0.0275
    ],
    [
      "recidiver",
      0.02
    ],
    [
      "ressortir",
      0.02
    ],
    [
      "repousser",
      0.02
    ],
    [
      "reparaitre",
      0.02
    ],
    [
      "rentrer",
      0.02
    ],
    [
      "rejoindre",
      0.02
    ],
    [
      "rallier",
      0.02
    ],
    [
      "incomber",
      0.02
    ],
    [
      "guerir",
      0.02
    ],
    [
      "appartenir",
      0.02
    ],
    [
      "satisfaire",
      0.0125
    ],
    [
      "sortir",
      0.0125
    ],
    [
      "valoir",
      0.0125
    ],
    [
      "echoir",
      0.0125
    ],
    [
      "recuperer",
      0.0125
    ],
    [
      "retrouver",
      0.0125
    ],
    [
      "apparaitre",
      0.0125
    ],
    [
      "convenir",
      0.0125
    ],
    [
      "reculer",
      0.0125
    ],
    [
      "refluer",
      0.0125
    ],
    [
      "relever",
      0.0125
    ],
    [
      "retrograder",
      0.005
    ],
    [
      "s'occuper",
      0.005
    ],
    [
      "sauter",
      0.005
    ],
    [
      "equivaloir",
      0.005
    ],
    [
      "reintegrer",
      0.005
    ],
    [
      "reexaminer",
      0.005
    ],
    [
      "ressurgir",
      0.005
    ],
    [
      "afferer",
      0.005
    ],
    [
      "agreer",
      0.005
    ],
    [
      "contremander",
      0.005
    ],
    [
      "couter",
      0.005
    ],
    [
      "obtenir",
      0.005
    ],
    [
      "plaire",
      0.005
    ],
    [
      "rappliquer",
      0.005
    ],
    [
      "reconduire",
      0.005
    ],
    [
      "reconsiderer",
      0.005
    ],
    [
      "reparler",
      0.005
    ],
    [
      "repasser",
      0.005
    ]
  ],
  "renifleur": [],
  "suivi": [
    [
      "continu",
      0.18
    ],
    [
      "constant",
      0.0875
    ],
    [
      "incessant",
      0.0675
    ],
    [
      "perpetuel",
      0.06
    ],
    [
      "persistant",
      0.0475
    ],
    [
      "eternel",
      0.04
    ],
    [
      "soutenu",
      0.0325
    ],
    [
      "sempiternel",
      0.0325
    ],
    [
      "regulier",
      0.0325
    ],
    [
      "ininterrompu",
      0.0325
    ],
    [
      "continuel",
      0.0325
    ],
    [
      "assidu",
      0.0325
    ],
    [
      "permanent",
      0.0275
    ],
    [
      "immuable",
      0.0275
    ],
    [
      "durable",
      0.02
    ],
    [
      "logique",
      0.02
    ],
    [
      "successif",
      0.0125
    ],
    [
      "rationnel",
      0.0125
    ],
    [
      "ordonne",
      0.0125
    ],
    [
      "invariable",
      0.0125
    ],
    [
      "interminable",
      0.0125
    ],
    [
      "infini",
      0.0125
    ],
    [
      "coherent",
      0.0125
    ],
    [
      "surveillance",
      0.005
    ],
    [
      "serre",
      0.005
    ],
    [
      "prolonge",
      0.005
    ],
    [
      "opiniatre",
      0.005
    ],
    [
      "indefectible",
      0.005
    ],
    [
      "frequente",
      0.005
    ],
    [
      "d'affilee",
      0.005
    ],
    [
      "couru",
      0.005
    ],
    [
      "tracabilite",
      0.005
    ]
  ],
  "garce": [
    [
      "gerce",
      0.25
    ],
    [
      "megere",
      0.25
    ],
    [
      "prostituee",
      0.25
    ],
    [
      "putain",
      0.25
    ]
  ],
  "emporter": [
    [
      "enlever",
      0.0925
    ],
    [
      "prendre",
      0.09
    ],
    [
      "entrainer",
      0.08
    ],
    [
      "conquerir",
      0.0475
    ],
    [
      "gagner",
      0.045
    ],
    [
      "forcer",
      0.04
    ],
    [
      "obtenir",
      0.03
    ],
    [
      "transporter",
      0.03
    ],
    [
      "voler",
      0.025
    ],
    [
      "pousser",
      0.025
    ],
    [
      "arracher",
      0.025
    ],
    [
      "aneantir",
      0.025
    ],
    [
      "attirer",
      0.02
    ],
    [
      "ravir",
      0.02
    ],
    [
      "rouler",
      0.0175
    ],
    [
      "s'emparer",
      0.0175
    ],
    [
      "supprimer",
      0.0175
    ],
    [
      "trainer",
      0.0175
    ],
    [
      "vaincre",
      0.0175
    ],
    [
      "rompre",
      0.0175
    ],
    [
      "remporter",
      0.0175
    ],
    [
      "ratiboiser",
      0.0175
    ],
    [
      "porter",
      0.0175
    ],
    [
      "emmener",
      0.0175
    ],
    [
      "embarquer",
      0.0175
    ],
    [
      "detruire",
      0.0175
    ],
    [
      "charrier",
      0.0175
    ],
    [
      "triompher",
      0.0125
    ],
    [
      "soustraire",
      0.0125
    ],
    [
      "rafler",
      0.0125
    ],
    [
      "couper",
      0.0125
    ],
    [
      "balayer",
      0.0125
    ],
    [
      "acquerir",
      0.0125
    ],
    [
      "tuer",
      0.0075
    ],
    [
      "ratisser",
      0.0075
    ],
    [
      "piller",
      0.0075
    ],
    [
      "impliquer",
      0.0075
    ],
    [
      "enflammer",
      0.0075
    ],
    [
      "devaster",
      0.0075
    ],
    [
      "submerger",
      0.0025
    ],
    [
      "renfermer",
      0.0025
    ],
    [
      "rallier",
      0.0025
    ],
    [
      "exterminer",
      0.0025
    ],
    [
      "devancer",
      0.0025
    ],
    [
      "comporter",
      0.0025
    ],
    [
      "bercer",
      0.0025
    ],
    [
      "eparpiller",
      0.0025
    ]
  ],
  "careme": [
    [
      "jeune",
      0.25
    ],
    [
      "quadragesime",
      0.25
    ],
    [
      "quarantaine",
      0.25
    ]
  ],
  "large": [
    [
      "grand",
      0.0775
    ],
    [
      "vaste",
      0.0675
    ],
    [
      "gros",
      0.0625
    ],
    [
      "abondant",
      0.0575
    ],
    [
      "fort",
      0.0525
    ],
    [
      "genereux",
      0.0425
    ],
    [
      "riche",
      0.0375
    ],
    [
      "liberal",
      0.0375
    ],
    [
      "ample",
      0.0375
    ],
    [
      "important",
      0.0325
    ],
    [
      "profond",
      0.0275
    ],
    [
      "etendu",
      0.0275
    ],
    [
      "souple",
      0.0225
    ],
    [
      "ouvert",
      0.0225
    ],
    [
      "copieux",
      0.0225
    ],
    [
      "considerable",
      0.0225
    ],
    [
      "elastique",
      0.0175
    ],
    [
      "indulgent",
      0.0175
    ],
    [
      "coulant",
      0.0175
    ],
    [
      "comprehensif",
      0.0175
    ],
    [
      "enorme",
      0.0125
    ],
    [
      "vague",
      0.0125
    ],
    [
      "relache",
      0.0125
    ],
    [
      "prodigue",
      0.0125
    ],
    [
      "philanthrope",
      0.0125
    ],
    [
      "lache",
      0.0125
    ],
    [
      "libre",
      0.0125
    ],
    [
      "aise",
      0.0125
    ],
    [
      "epais",
      0.0075
    ],
    [
      "spacieux",
      0.0075
    ],
    [
      "flou",
      0.0075
    ],
    [
      "complaisant",
      0.0075
    ],
    [
      "beant",
      0.0075
    ],
    [
      "largeur",
      0.0025
    ],
    [
      "largue",
      0.0025
    ],
    [
      "latitudinaire",
      0.0025
    ],
    [
      "laxiste",
      0.0025
    ],
    [
      "mer",
      0.0025
    ],
    [
      "munificent",
      0.0025
    ],
    [
      "rapide",
      0.0025
    ],
    [
      "largement",
      0.0025
    ],
    [
      "genereusement",
      0.0025
    ],
    [
      "general",
      0.0025
    ],
    [
      "fastueux",
      0.0025
    ],
    [
      "fastueusement",
      0.0025
    ],
    [
      "depensier",
      0.0025
    ],
    [
      "donnant",
      0.0025
    ],
    [
      "confortable",
      0.0025
    ],
    [
      "appreciable",
      0.0025
    ],
    [
      "evase",
      0.0025
    ]
  ],
  "cerner": [
    [
      "entourer",
      0.13
    ],
    [
      "enfermer",
      0.11
    ],
    [
      "encercler",
      0.105
    ],
    [
      "envelopper",
      0.0725
    ],
    [
      "investir",
      0.0675
    ],
    [
      "emprisonner",
      0.0625
    ],
    [
      "assieger",
      0.0575
    ],
    [
      "enserrer",
      0.045
    ],
    [
      "environner",
      0.045
    ],
    [
      "ceindre",
      0.035
    ],
    [
      "boucler",
      0.03
    ],
    [
      "enclore",
      0.03
    ],
    [
      "fermer",
      0.025
    ],
    [
      "circonscrire",
      0.025
    ],
    [
      "bloquer",
      0.02
    ],
    [
      "resserrer",
      0.02
    ],
    [
      "ceinturer",
      0.015
    ],
    [
      "delimiter",
      0.015
    ],
    [
      "encadrer",
      0.015
    ],
    [
      "limiter",
      0.0075
    ],
    [
      "circonvenir",
      0.0075
    ],
    [
      "attaquer",
      0.0075
    ],
    [
      "acculer",
      0.0025
    ],
    [
      "liserer",
      0.0025
    ],
    [
      "longer",
      0.0025
    ],
    [
      "obseder",
      0.0025
    ],
    [
      "etreindre",
      0.0025
    ]
  ],
  "cerne": [
    [
      "cercle",
      0.165
    ],
    [
      "rond",
      0.0825
    ],
    [
      "poche",
      0.0825
    ],
    [
      "nimbe",
      0.0825
    ],
    [
      "marbrure",
      0.0825
    ],
    [
      "halo",
      0.0825
    ],
    [
      "cernure",
      0.0825
    ],
    [
      "bleu",
      0.0825
    ],
    [
      "aureole",
      0.0825
    ],
    [
      "anneau",
      0.0825
    ],
    [
      "valise",
      0.0825
    ]
  ],
  "coeur": [
    [
      "courage",
      0.0775
    ],
    [
      "ame",
      0.0575
    ],
    [
      "force",
      0.035
    ],
    [
      "energie",
      0.035
    ],
    [
      "fermete",
      0.03
    ],
    [
      "ardeur",
      0.0275
    ],
    [
      "hardiesse",
      0.0275
    ],
    [
      "sein",
      0.0275
    ],
    [
      "generosite",
      0.025
    ],
    [
      "amour",
      0.025
    ],
    [
      "ressort",
      0.0225
    ],
    [
      "conscience",
      0.0225
    ],
    [
      "fond",
      0.0225
    ],
    [
      "passion",
      0.0225
    ],
    [
      "sentiment",
      0.0225
    ],
    [
      "zele",
      0.0225
    ],
    [
      "intrepidite",
      0.0175
    ],
    [
      "centre",
      0.0175
    ],
    [
      "audace",
      0.0175
    ],
    [
      "vigueur",
      0.0175
    ],
    [
      "attachement",
      0.015
    ],
    [
      "interieur",
      0.015
    ],
    [
      "sensibilite",
      0.015
    ],
    [
      "valeur",
      0.0125
    ],
    [
      "tendresse",
      0.0125
    ],
    [
      "noeud",
      0.0125
    ],
    [
      "esprit",
      0.0125
    ],
    [
      "chaleur",
      0.0125
    ],
    [
      "vaillance",
      0.01
    ],
    [
      "temerite",
      0.01
    ],
    [
      "solidite",
      0.01
    ],
    [
      "devouement",
      0.01
    ],
    [
      "charite",
      0.01
    ],
    [
      "nature",
      0.0075
    ],
    [
      "milieu",
      0.0075
    ],
    [
      "interet",
      0.0075
    ],
    [
      "inclination",
      0.0075
    ],
    [
      "entrailles",
      0.0075
    ],
    [
      "delicatesse",
      0.0075
    ],
    [
      "bienveillance",
      0.0075
    ],
    [
      "altruisme",
      0.0075
    ],
    [
      "affection",
      0.0075
    ],
    [
      "noyau",
      0.005
    ],
    [
      "point",
      0.005
    ],
    [
      "soin",
      0.005
    ],
    [
      "temperament",
      0.005
    ],
    [
      "vertu",
      0.005
    ],
    [
      "naturel",
      0.005
    ],
    [
      "intuition",
      0.005
    ],
    [
      "foyer",
      0.005
    ],
    [
      "bravoure",
      0.005
    ],
    [
      "cerveau",
      0.005
    ],
    [
      "enthousiasme",
      0.005
    ],
    [
      "essentiel",
      0.005
    ],
    [
      "fort",
      0.005
    ],
    [
      "vif",
      0.0025
    ],
    [
      "plein",
      0.0025
    ],
    [
      "pitie",
      0.0025
    ],
    [
      "pensee",
      0.0025
    ],
    [
      "magnanimite",
      0.0025
    ],
    [
      "instinct",
      0.0025
    ],
    [
      "gout",
      0.0025
    ],
    [
      "giron",
      0.0025
    ],
    [
      "estomac",
      0.0025
    ],
    [
      "compassion",
      0.0025
    ],
    [
      "biquet",
      0.0025
    ],
    [
      "franchise",
      0.0
    ],
    [
      "impudence",
      0.0
    ],
    [
      "myocarde",
      0.0
    ],
    [
      "memoire",
      0.0
    ],
    [
      "oreillette",
      0.0
    ],
    [
      "palpitant",
      0.0
    ],
    [
      "poitrine",
      0.0
    ],
    [
      "fibre",
      0.0
    ],
    [
      "entrain",
      0.0
    ],
    [
      "endocarde",
      0.0
    ],
    [
      "duramen",
      0.0
    ],
    [
      "dedans",
      0.0
    ],
    [
      "cardi",
      0.0
    ],
    [
      "carde",
      0.0
    ],
    [
      "battant",
      0.0
    ],
    [
      "aubier",
      0.0
    ],
    [
      "trognon",
      0.0
    ]
  ],
  "bleme": [
    [
      "pale",
      0.195
    ],
    [
      "blafard",
      0.1075
    ],
    [
      "livide",
      0.0725
    ],
    [
      "terne",
      0.0725
    ],
    [
      "decolore",
      0.0475
    ],
    [
      "fade",
      0.0475
    ],
    [
      "terreux",
      0.0475
    ],
    [
      "vitreux",
      0.035
    ],
    [
      "plombe",
      0.035
    ],
    [
      "incolore",
      0.035
    ],
    [
      "bleu",
      0.035
    ],
    [
      "eteint",
      0.0225
    ],
    [
      "vert",
      0.0225
    ],
    [
      "verdatre",
      0.0225
    ],
    [
      "mat",
      0.0225
    ],
    [
      "faible",
      0.0225
    ],
    [
      "exsangue",
      0.0225
    ],
    [
      "cireux",
      0.0225
    ],
    [
      "blanc",
      0.0225
    ],
    [
      "blanchatre",
      0.01
    ],
    [
      "have",
      0.01
    ],
    [
      "poussiereux",
      0.01
    ],
    [
      "palot",
      0.01
    ]
  ],
  "desoler": [
    [
      "chagriner",
      0.1075
    ],
    [
      "affliger",
      0.095
    ],
    [
      "navrer",
      0.0875
    ],
    [
      "facher",
      0.08
    ],
    [
      "ennuyer",
      0.075
    ],
    [
      "desesperer",
      0.06
    ],
    [
      "tourmenter",
      0.0475
    ],
    [
      "contrarier",
      0.0475
    ],
    [
      "attrister",
      0.04
    ],
    [
      "abattre",
      0.025
    ],
    [
      "consterner",
      0.025
    ],
    [
      "embeter",
      0.025
    ],
    [
      "detruire",
      0.02
    ],
    [
      "dechirer",
      0.02
    ],
    [
      "decevoir",
      0.02
    ],
    [
      "contrister",
      0.02
    ],
    [
      "chiffonner",
      0.02
    ],
    [
      "accabler",
      0.02
    ],
    [
      "saccager",
      0.0125
    ],
    [
      "ruiner",
      0.0125
    ],
    [
      "ravager",
      0.0125
    ],
    [
      "peiner",
      0.0125
    ],
    [
      "mecontenter",
      0.0125
    ],
    [
      "irriter",
      0.0125
    ],
    [
      "infester",
      0.0125
    ],
    [
      "importuner",
      0.0125
    ],
    [
      "devaster",
      0.0125
    ],
    [
      "arracher",
      0.0125
    ],
    [
      "desillusionner",
      0.005
    ],
    [
      "fletrir",
      0.005
    ]
  ],
  "desole": [
    [
      "chagriner",
      0.1075
    ],
    [
      "affliger",
      0.095
    ],
    [
      "navrer",
      0.0875
    ],
    [
      "facher",
      0.08
    ],
    [
      "ennuyer",
      0.075
    ],
    [
      "desesperer",
      0.06
    ],
    [
      "tourmenter",
      0.0475
    ],
    [
      "contrarier",
      0.0475
    ],
    [
      "attrister",
      0.04
    ],
    [
      "abattre",
      0.025
    ],
    [
      "consterner",
      0.025
    ],
    [
      "embeter",
      0.025
    ],
    [
      "detruire",
      0.02
    ],
    [
      "dechirer",
      0.02
    ],
    [
      "decevoir",
      0.02
    ],
    [
      "contrister",
      0.02
    ],
    [
      "chiffonner",
      0.02
    ],
    [
      "accabler",
      0.02
    ],
    [
      "saccager",
      0.0125
    ],
    [
      "ruiner",
      0.0125
    ],
    [
      "ravager",
      0.0125
    ],
    [
      "peiner",
      0.0125
    ],
    [
      "mecontenter",
      0.0125
    ],
    [
      "irriter",
      0.0125
    ],
    [
      "infester",
      0.0125
    ],
    [
      "importuner",
      0.0125
    ],
    [
      "devaster",
      0.0125
    ],
    [
      "arracher",
      0.0125
    ],
    [
      "desillusionner",
      0.005
    ],
    [
      "fletrir",
      0.005
    ]
  ],
  "moire": [
    [
      "chatoiement",
      0.4
    ],
    [
      "luisant",
      0.2
    ],
    [
      "mohair",
      0.2
    ],
    [
      "reflet",
      0.2
    ]
  ],
  "peigne": [
    [
      "demeloir",
      0.125
    ],
    [
      "herse",
      0.125
    ],
    [
      "regayoir",
      0.125
    ],
    [
      "ros",
      0.125
    ],
    [
      "rateau",
      0.125
    ],
    [
      "seran",
      0.125
    ]
  ],
  "peigner": [
    [
      "polir",
      0.125
    ],
    [
      "soigner",
      0.125
    ],
    [
      "fignoler",
      0.0825
    ],
    [
      "demeler",
      0.0825
    ],
    [
      "coiffer",
      0.0825
    ],
    [
      "arranger",
      0.0825
    ],
    [
      "perler",
      0.04
    ],
    [
      "lecher",
      0.04
    ],
    [
      "limer",
      0.04
    ],
    [
      "houpper",
      0.04
    ],
    [
      "faire",
      0.04
    ],
    [
      "ciseler",
      0.04
    ],
    [
      "carder",
      0.04
    ],
    [
      "brosser",
      0.04
    ],
    [
      "babichonner",
      0.04
    ],
    [
      "testonner",
      0.04
    ]
  ],
  "mine": [
    [
      "air",
      0.0925
    ],
    [
      "exterieur",
      0.085
    ],
    [
      "figure",
      0.075
    ],
    [
      "tournure",
      0.0725
    ],
    [
      "visage",
      0.0625
    ],
    [
      "apparence",
      0.0575
    ],
    [
      "contenance",
      0.0375
    ],
    [
      "physionomie",
      0.0325
    ],
    [
      "maintien",
      0.0325
    ],
    [
      "allure",
      0.0325
    ],
    [
      "dehors",
      0.0275
    ],
    [
      "face",
      0.025
    ],
    [
      "trait",
      0.015
    ],
    [
      "tenue",
      0.015
    ],
    [
      "source",
      0.015
    ],
    [
      "galerie",
      0.015
    ],
    [
      "filon",
      0.015
    ],
    [
      "facade",
      0.015
    ],
    [
      "cavite",
      0.015
    ],
    [
      "surface",
      0.01
    ],
    [
      "prestance",
      0.01
    ],
    [
      "grimace",
      0.01
    ],
    [
      "facon",
      0.01
    ],
    [
      "affectation",
      0.01
    ],
    [
      "tete",
      0.0075
    ],
    [
      "taille",
      0.0075
    ],
    [
      "singerie",
      0.0075
    ],
    [
      "simagree",
      0.0075
    ],
    [
      "recueil",
      0.0075
    ],
    [
      "puits",
      0.0075
    ],
    [
      "physique",
      0.0075
    ],
    [
      "minauderie",
      0.0075
    ],
    [
      "expression",
      0.0075
    ],
    [
      "carnation",
      0.0075
    ],
    [
      "bouille",
      0.0075
    ],
    [
      "piege",
      0.0025
    ],
    [
      "moisson",
      0.0025
    ],
    [
      "minois",
      0.0025
    ],
    [
      "houillere",
      0.0025
    ],
    [
      "poids",
      0.0025
    ],
    [
      "pepiniere",
      0.0025
    ],
    [
      "sape",
      0.0025
    ],
    [
      "souterrain",
      0.0025
    ],
    [
      "teint",
      0.0025
    ],
    [
      "torpille",
      0.0025
    ],
    [
      "gisement",
      0.0025
    ],
    [
      "froncement",
      0.0025
    ],
    [
      "fosse",
      0.0025
    ],
    [
      "accueil",
      0.0025
    ],
    [
      "affleurement",
      0.0025
    ],
    [
      "carriere",
      0.0025
    ],
    [
      "cartouche",
      0.0025
    ],
    [
      "charbonnage",
      0.0025
    ],
    [
      "demarche",
      0.0025
    ],
    [
      "engin",
      0.0025
    ],
    [
      "explosif",
      0.0025
    ],
    [
      "fiole",
      0.0025
    ],
    [
      "fonds",
      0.0025
    ],
    [
      "tresor",
      0.0025
    ]
  ],
  "miner": [
    [
      "detruire",
      0.135
    ],
    [
      "ronger",
      0.12
    ],
    [
      "saper",
      0.0825
    ],
    [
      "consumer",
      0.0675
    ],
    [
      "ruiner",
      0.06
    ],
    [
      "affaiblir",
      0.055
    ],
    [
      "corroder",
      0.045
    ],
    [
      "user",
      0.04
    ],
    [
      "epuiser",
      0.035
    ],
    [
      "abattre",
      0.03
    ],
    [
      "diminuer",
      0.0225
    ],
    [
      "devorer",
      0.0225
    ],
    [
      "mordre",
      0.0225
    ],
    [
      "eroder",
      0.0225
    ],
    [
      "fouiller",
      0.0175
    ],
    [
      "tourmenter",
      0.0175
    ],
    [
      "ravager",
      0.0125
    ],
    [
      "devaster",
      0.0125
    ],
    [
      "desagreger",
      0.0125
    ],
    [
      "attaquer",
      0.0125
    ],
    [
      "affouiller",
      0.0125
    ],
    [
      "ebranler",
      0.0075
    ],
    [
      "tuer",
      0.0075
    ],
    [
      "trifouiller",
      0.0075
    ],
    [
      "inquieter",
      0.0075
    ],
    [
      "harceler",
      0.0075
    ],
    [
      "fouir",
      0.0075
    ],
    [
      "desintegrer",
      0.0075
    ],
    [
      "creuser",
      0.0075
    ],
    [
      "caver",
      0.0075
    ],
    [
      "bruler",
      0.0075
    ],
    [
      "gratter",
      0.0025
    ],
    [
      "fragiliser",
      0.0025
    ],
    [
      "fissurer",
      0.0025
    ],
    [
      "defaire",
      0.0025
    ],
    [
      "submerger",
      0.0025
    ]
  ],
  "desespoir": [
    [
      "affliction",
      0.13
    ],
    [
      "chagrin",
      0.13
    ],
    [
      "tristesse",
      0.12
    ],
    [
      "douleur",
      0.0925
    ],
    [
      "ennui",
      0.065
    ],
    [
      "desolation",
      0.055
    ],
    [
      "accablement",
      0.055
    ],
    [
      "abattement",
      0.055
    ],
    [
      "consternation",
      0.035
    ],
    [
      "tourment",
      0.035
    ],
    [
      "souffrance",
      0.025
    ],
    [
      "detresse",
      0.025
    ],
    [
      "desesperance",
      0.025
    ],
    [
      "degout",
      0.025
    ],
    [
      "angoisse",
      0.025
    ],
    [
      "boulet",
      0.0175
    ],
    [
      "decouragement",
      0.0175
    ],
    [
      "regret",
      0.0175
    ],
    [
      "remords",
      0.0175
    ],
    [
      "resipiscence",
      0.0075
    ]
  ],
  "ailleurs": [
    [
      "dehors",
      0.5
    ]
  ],
  "ennui": [
    [
      "peine",
      0.0575
    ],
    [
      "chagrin",
      0.055
    ],
    [
      "difficulte",
      0.05
    ],
    [
      "tristesse",
      0.0475
    ],
    [
      "embarras",
      0.045
    ],
    [
      "souci",
      0.04
    ],
    [
      "douleur",
      0.025
    ],
    [
      "melancolie",
      0.025
    ],
    [
      "tribulation",
      0.0225
    ],
    [
      "malheur",
      0.0225
    ],
    [
      "mal",
      0.0225
    ],
    [
      "desagrement",
      0.0225
    ],
    [
      "affliction",
      0.0225
    ],
    [
      "tracas",
      0.0225
    ],
    [
      "inconvenient",
      0.02
    ],
    [
      "tourment",
      0.02
    ],
    [
      "abattement",
      0.02
    ],
    [
      "anicroche",
      0.0175
    ],
    [
      "contrariete",
      0.0175
    ],
    [
      "accident",
      0.015
    ],
    [
      "tirage",
      0.015
    ],
    [
      "obstacle",
      0.015
    ],
    [
      "embetement",
      0.015
    ],
    [
      "deplaisir",
      0.015
    ],
    [
      "accablement",
      0.0125
    ],
    [
      "gene",
      0.0125
    ],
    [
      "spleen",
      0.0125
    ],
    [
      "traverse",
      0.0125
    ],
    [
      "desolation",
      0.01
    ],
    [
      "inquietude",
      0.01
    ],
    [
      "epreuve",
      0.01
    ],
    [
      "desespoir",
      0.0075
    ],
    [
      "degout",
      0.0075
    ],
    [
      "complication",
      0.0075
    ],
    [
      "pepin",
      0.0075
    ],
    [
      "incident",
      0.0075
    ],
    [
      "decouragement",
      0.0075
    ],
    [
      "contretemps",
      0.0075
    ],
    [
      "cafard",
      0.0075
    ],
    [
      "affaire",
      0.0075
    ],
    [
      "tuile",
      0.005
    ],
    [
      "misere",
      0.005
    ],
    [
      "malaise",
      0.005
    ],
    [
      "incommodite",
      0.005
    ],
    [
      "histoire",
      0.005
    ],
    [
      "fatigue",
      0.005
    ],
    [
      "emmerdement",
      0.005
    ],
    [
      "deception",
      0.005
    ],
    [
      "tracasserie",
      0.005
    ],
    [
      "preoccupation",
      0.005
    ],
    [
      "probleme",
      0.005
    ],
    [
      "mecontentement",
      0.005
    ],
    [
      "morosite",
      0.005
    ],
    [
      "lassitude",
      0.005
    ],
    [
      "deboire",
      0.005
    ],
    [
      "neurasthenie",
      0.0025
    ],
    [
      "langueur",
      0.0025
    ],
    [
      "empoisonnement",
      0.0025
    ],
    [
      "desavantage",
      0.0025
    ],
    [
      "derangement",
      0.0025
    ],
    [
      "defaut",
      0.0025
    ],
    [
      "dommage",
      0.0025
    ],
    [
      "agacement",
      0.0025
    ],
    [
      "alea",
      0.0025
    ],
    [
      "casse",
      0.0025
    ],
    [
      "cassement",
      0.0025
    ],
    [
      "emoi",
      0.0025
    ],
    [
      "nostalgie",
      0.0025
    ],
    [
      "monotonie",
      0.0025
    ],
    [
      "hypocondrie",
      0.0025
    ],
    [
      "hic",
      0.0025
    ],
    [
      "emmerde",
      0.0025
    ],
    [
      "embetant",
      0.0025
    ],
    [
      "bourdon",
      0.0025
    ],
    [
      "aria",
      0.0025
    ],
    [
      "maussaderie",
      0.0
    ],
    [
      "nuage",
      0.0
    ],
    [
      "poisse",
      0.0
    ],
    [
      "torpeur",
      0.0
    ],
    [
      "fastidiosite",
      0.0
    ],
    [
      "fardeau",
      0.0
    ],
    [
      "fadeur",
      0.0
    ],
    [
      "chiotte",
      0.0
    ],
    [
      "barbe",
      0.0
    ],
    [
      "avatar",
      0.0
    ],
    [
      "avaro",
      0.0
    ],
    [
      "avanie",
      0.0
    ],
    [
      "vide",
      0.0
    ]
  ],
  "gout": [
    [
      "inclination",
      0.075
    ],
    [
      "desir",
      0.0575
    ],
    [
      "passion",
      0.0575
    ],
    [
      "penchant",
      0.0575
    ],
    [
      "faible",
      0.0375
    ],
    [
      "amour",
      0.0325
    ],
    [
      "tendance",
      0.03
    ],
    [
      "caprice",
      0.025
    ],
    [
      "sens",
      0.0225
    ],
    [
      "preference",
      0.0225
    ],
    [
      "manie",
      0.0225
    ],
    [
      "attrait",
      0.0225
    ],
    [
      "appetit",
      0.0225
    ],
    [
      "appetence",
      0.0225
    ],
    [
      "affection",
      0.0225
    ],
    [
      "talent",
      0.0175
    ],
    [
      "style",
      0.0175
    ],
    [
      "soif",
      0.0175
    ],
    [
      "humeur",
      0.0175
    ],
    [
      "faiblesse",
      0.0175
    ],
    [
      "disposition",
      0.0175
    ],
    [
      "travers",
      0.015
    ],
    [
      "propension",
      0.015
    ],
    [
      "mode",
      0.015
    ],
    [
      "maniere",
      0.015
    ],
    [
      "gre",
      0.015
    ],
    [
      "grace",
      0.015
    ],
    [
      "envie",
      0.015
    ],
    [
      "delicatesse",
      0.015
    ],
    [
      "elegance",
      0.01
    ],
    [
      "vocation",
      0.01
    ],
    [
      "saveur",
      0.01
    ],
    [
      "predisposition",
      0.01
    ],
    [
      "predilection",
      0.01
    ],
    [
      "convenance",
      0.01
    ],
    [
      "attirance",
      0.01
    ],
    [
      "aptitude",
      0.01
    ],
    [
      "ton",
      0.005
    ],
    [
      "tic",
      0.005
    ],
    [
      "opinion",
      0.005
    ],
    [
      "guise",
      0.005
    ],
    [
      "fumet",
      0.005
    ],
    [
      "facture",
      0.005
    ],
    [
      "esthetique",
      0.005
    ],
    [
      "coeur",
      0.005
    ],
    [
      "beau",
      0.005
    ],
    [
      "attachement",
      0.005
    ],
    [
      "humanisme",
      0.0025
    ],
    [
      "montant",
      0.0025
    ],
    [
      "odeur",
      0.0025
    ],
    [
      "palais",
      0.0025
    ],
    [
      "pli",
      0.0025
    ],
    [
      "raison",
      0.0025
    ],
    [
      "relent",
      0.0025
    ],
    [
      "sapidite",
      0.0025
    ],
    [
      "senteur",
      0.0025
    ],
    [
      "genie",
      0.0025
    ],
    [
      "genre",
      0.0025
    ],
    [
      "aloi",
      0.0025
    ],
    [
      "attache",
      0.0025
    ],
    [
      "besoin",
      0.0025
    ],
    [
      "conception",
      0.0025
    ],
    [
      "effluve",
      0.0025
    ],
    [
      "entichement",
      0.0025
    ],
    [
      "exhalaison",
      0.0025
    ],
    [
      "fabrication",
      0.0025
    ],
    [
      "subjectivite",
      0.0025
    ]
  ],
  "malheur": [
    [
      "tribulation",
      0.15
    ],
    [
      "calamite",
      0.075
    ],
    [
      "affliction",
      0.0525
    ],
    [
      "catastrophe",
      0.04
    ],
    [
      "epreuve",
      0.0375
    ],
    [
      "malchance",
      0.0375
    ],
    [
      "chagrin",
      0.0375
    ],
    [
      "accident",
      0.0375
    ],
    [
      "ennui",
      0.0325
    ],
    [
      "adversite",
      0.0275
    ],
    [
      "douleur",
      0.0275
    ],
    [
      "infortune",
      0.0275
    ],
    [
      "mal",
      0.0225
    ],
    [
      "peine",
      0.0225
    ],
    [
      "tristesse",
      0.02
    ],
    [
      "deuil",
      0.02
    ],
    [
      "detresse",
      0.0175
    ],
    [
      "misere",
      0.0175
    ],
    [
      "mesaventure",
      0.0175
    ],
    [
      "revers",
      0.0175
    ],
    [
      "fatalite",
      0.015
    ],
    [
      "evenement",
      0.0125
    ],
    [
      "malediction",
      0.0125
    ],
    [
      "desastre",
      0.0125
    ],
    [
      "cataclysme",
      0.01
    ],
    [
      "disgrace",
      0.01
    ],
    [
      "embarras",
      0.01
    ],
    [
      "tuile",
      0.0075
    ],
    [
      "traverse",
      0.0075
    ],
    [
      "ruine",
      0.0075
    ],
    [
      "pauvrete",
      0.0075
    ],
    [
      "echec",
      0.005
    ],
    [
      "sort",
      0.005
    ],
    [
      "perte",
      0.005
    ],
    [
      "orage",
      0.005
    ],
    [
      "desagrement",
      0.005
    ],
    [
      "rafale",
      0.0025
    ],
    [
      "precipice",
      0.0025
    ],
    [
      "malencontre",
      0.0025
    ],
    [
      "inconvenient",
      0.0025
    ],
    [
      "fleau",
      0.0025
    ],
    [
      "deveine",
      0.0025
    ],
    [
      "deconvenue",
      0.0025
    ],
    [
      "destin",
      0.0025
    ],
    [
      "melasse",
      0.0
    ],
    [
      "mechef",
      0.0
    ],
    [
      "malefice",
      0.0
    ],
    [
      "infelicite",
      0.0
    ],
    [
      "coup",
      0.0
    ],
    [
      "succes",
      0.0
    ]
  ],
  "hanche": [
    [
      "croupe",
      0.2
    ],
    [
      "flanc",
      0.2
    ],
    [
      "aine",
      0.1
    ],
    [
      "cote",
      0.1
    ],
    [
      "fesse",
      0.1
    ],
    [
      "femur",
      0.1
    ],
    [
      "iles",
      0.1
    ],
    [
      "reins",
      0.1
    ]
  ],
  "saouler": [],
  "payer": [
    [
      "donner",
      0.0625
    ],
    [
      "rembourser",
      0.0425
    ],
    [
      "debourser",
      0.035
    ],
    [
      "regler",
      0.035
    ],
    [
      "retribuer",
      0.035
    ],
    [
      "verser",
      0.035
    ],
    [
      "remunerer",
      0.0275
    ],
    [
      "offrir",
      0.0275
    ],
    [
      "couvrir",
      0.0275
    ],
    [
      "servir",
      0.02
    ],
    [
      "salarier",
      0.02
    ],
    [
      "s'acquitter",
      0.02
    ],
    [
      "reparer",
      0.02
    ],
    [
      "indemniser",
      0.02
    ],
    [
      "financer",
      0.02
    ],
    [
      "depenser",
      0.02
    ],
    [
      "dedommager",
      0.02
    ],
    [
      "casquer",
      0.02
    ],
    [
      "avancer",
      0.02
    ],
    [
      "aligner",
      0.02
    ],
    [
      "acheter",
      0.02
    ],
    [
      "remettre",
      0.0125
    ],
    [
      "rendre",
      0.0125
    ],
    [
      "satisfaire",
      0.0125
    ],
    [
      "solder",
      0.0125
    ],
    [
      "soudoyer",
      0.0125
    ],
    [
      "racheter",
      0.0125
    ],
    [
      "desinteresser",
      0.0125
    ],
    [
      "acquitter",
      0.0125
    ],
    [
      "allonger",
      0.0125
    ],
    [
      "appointer",
      0.0125
    ],
    [
      "arroser",
      0.0125
    ],
    [
      "contenter",
      0.0125
    ],
    [
      "decaisser",
      0.0125
    ],
    [
      "defrayer",
      0.0125
    ],
    [
      "raquer",
      0.005
    ],
    [
      "recompenser",
      0.005
    ],
    [
      "regaler",
      0.005
    ],
    [
      "souscrire",
      0.005
    ],
    [
      "stipendier",
      0.005
    ],
    [
      "subir",
      0.005
    ],
    [
      "suer",
      0.005
    ],
    [
      "virer",
      0.005
    ],
    [
      "eclairer",
      0.005
    ],
    [
      "rapporter",
      0.005
    ],
    [
      "punir",
      0.005
    ],
    [
      "ordonnancer",
      0.005
    ],
    [
      "compter",
      0.005
    ],
    [
      "corrompre",
      0.005
    ],
    [
      "cracher",
      0.005
    ],
    [
      "douiller",
      0.005
    ],
    [
      "depocher",
      0.005
    ],
    [
      "expier",
      0.005
    ],
    [
      "foncer",
      0.005
    ],
    [
      "gager",
      0.005
    ],
    [
      "liquider",
      0.005
    ],
    [
      "mandater",
      0.005
    ],
    [
      "ecoper",
      0.005
    ]
  ],
  "battant": [
    [
      "abattant",
      0.04
    ],
    [
      "marteau",
      0.04
    ],
    [
      "menuiserie",
      0.04
    ],
    [
      "ouvrant",
      0.04
    ],
    [
      "palpitant",
      0.04
    ],
    [
      "porte",
      0.04
    ],
    [
      "puncheur",
      0.04
    ],
    [
      "petant",
      0.04
    ],
    [
      "sonnant",
      0.04
    ],
    [
      "tapant",
      0.04
    ],
    [
      "traquet",
      0.04
    ],
    [
      "liteau",
      0.04
    ],
    [
      "gueule",
      0.04
    ],
    [
      "feuillure",
      0.04
    ],
    [
      "accrocheur",
      0.04
    ],
    [
      "battement",
      0.04
    ],
    [
      "battoir",
      0.04
    ],
    [
      "battee",
      0.04
    ],
    [
      "brocheur",
      0.04
    ],
    [
      "claquant",
      0.04
    ],
    [
      "clenche",
      0.04
    ],
    [
      "coeur",
      0.04
    ],
    [
      "combatif",
      0.04
    ],
    [
      "vantail",
      0.04
    ]
  ],
  "sonner": [
    [
      "tinter",
      0.145
    ],
    [
      "carillonner",
      0.0825
    ],
    [
      "corner",
      0.0825
    ],
    [
      "tintinnabuler",
      0.0625
    ],
    [
      "resonner",
      0.0625
    ],
    [
      "frapper",
      0.0625
    ],
    [
      "bourdonner",
      0.0625
    ],
    [
      "souffler",
      0.04
    ],
    [
      "retentir",
      0.04
    ],
    [
      "jouer",
      0.04
    ],
    [
      "avertir",
      0.04
    ],
    [
      "assommer",
      0.04
    ],
    [
      "vanter",
      0.02
    ],
    [
      "sonnailler",
      0.02
    ],
    [
      "proclamer",
      0.02
    ],
    [
      "copter",
      0.02
    ],
    [
      "claironner",
      0.02
    ],
    [
      "battre",
      0.02
    ],
    [
      "arriver",
      0.02
    ],
    [
      "appeler",
      0.02
    ],
    [
      "etourdir",
      0.02
    ]
  ],
  "souffle": [
    [
      "vent",
      0.1125
    ],
    [
      "air",
      0.06
    ],
    [
      "bouffee",
      0.06
    ],
    [
      "haleine",
      0.06
    ],
    [
      "inspiration",
      0.06
    ],
    [
      "emanation",
      0.06
    ],
    [
      "ame",
      0.0375
    ],
    [
      "exhalaison",
      0.0375
    ],
    [
      "esprit",
      0.0375
    ],
    [
      "bruit",
      0.0375
    ],
    [
      "brise",
      0.0375
    ],
    [
      "soupir",
      0.0225
    ],
    [
      "respiration",
      0.0225
    ],
    [
      "influence",
      0.0225
    ],
    [
      "flux",
      0.0225
    ],
    [
      "explosion",
      0.0225
    ],
    [
      "enthousiasme",
      0.0225
    ],
    [
      "culot",
      0.0225
    ],
    [
      "frisson",
      0.01
    ],
    [
      "lyrisme",
      0.01
    ],
    [
      "poussee",
      0.01
    ],
    [
      "rafale",
      0.01
    ],
    [
      "soufflement",
      0.01
    ],
    [
      "veine",
      0.01
    ],
    [
      "vie",
      0.01
    ],
    [
      "expiration",
      0.01
    ],
    [
      "exaltation",
      0.01
    ],
    [
      "effluve",
      0.01
    ],
    [
      "creativite",
      0.01
    ],
    [
      "courant",
      0.01
    ],
    [
      "coffre",
      0.01
    ],
    [
      "bise",
      0.01
    ],
    [
      "aura",
      0.01
    ],
    [
      "aplomb",
      0.01
    ],
    [
      "zephyr",
      0.01
    ]
  ],
  "souffler": [
    [
      "pousser",
      0.065
    ],
    [
      "derober",
      0.04
    ],
    [
      "exciter",
      0.04
    ],
    [
      "prendre",
      0.035
    ],
    [
      "inspirer",
      0.035
    ],
    [
      "enlever",
      0.035
    ],
    [
      "dire",
      0.035
    ],
    [
      "animer",
      0.035
    ],
    [
      "attiser",
      0.0275
    ],
    [
      "respirer",
      0.0275
    ],
    [
      "epoustoufler",
      0.0225
    ],
    [
      "stupefier",
      0.0225
    ],
    [
      "ravir",
      0.0225
    ],
    [
      "piquer",
      0.0225
    ],
    [
      "gonfler",
      0.0225
    ],
    [
      "exalter",
      0.0225
    ],
    [
      "enfler",
      0.0225
    ],
    [
      "siderer",
      0.015
    ],
    [
      "murmurer",
      0.015
    ],
    [
      "jouer",
      0.015
    ],
    [
      "conseiller",
      0.015
    ],
    [
      "s'approprier",
      0.01
    ],
    [
      "s'emparer",
      0.01
    ],
    [
      "s'essouffler",
      0.01
    ],
    [
      "s'ebrouer",
      0.01
    ],
    [
      "sonner",
      0.01
    ],
    [
      "suffoquer",
      0.01
    ],
    [
      "suggerer",
      0.01
    ],
    [
      "epater",
      0.01
    ],
    [
      "oter",
      0.01
    ],
    [
      "propager",
      0.01
    ],
    [
      "prononcer",
      0.01
    ],
    [
      "ahurir",
      0.01
    ],
    [
      "bouffer",
      0.01
    ],
    [
      "bourdonner",
      0.01
    ],
    [
      "chiper",
      0.01
    ],
    [
      "chuchoter",
      0.01
    ],
    [
      "escamoter",
      0.01
    ],
    [
      "haleter",
      0.01
    ],
    [
      "insinuer",
      0.01
    ],
    [
      "insuffler",
      0.01
    ],
    [
      "meduser",
      0.01
    ],
    [
      "s'epandre",
      0.0025
    ],
    [
      "renverser",
      0.0025
    ],
    [
      "rememorer",
      0.0025
    ],
    [
      "semer",
      0.0025
    ],
    [
      "susurrer",
      0.0025
    ],
    [
      "tricher",
      0.0025
    ],
    [
      "venter",
      0.0025
    ],
    [
      "ventiler",
      0.0025
    ],
    [
      "vomir",
      0.0025
    ],
    [
      "ebouriffer",
      0.0025
    ],
    [
      "rafler",
      0.0025
    ],
    [
      "grossir",
      0.0025
    ],
    [
      "glisser",
      0.0025
    ],
    [
      "activer",
      0.0025
    ],
    [
      "aider",
      0.0025
    ],
    [
      "apprendre",
      0.0025
    ],
    [
      "balayer",
      0.0025
    ],
    [
      "boursoufler",
      0.0025
    ],
    [
      "confier",
      0.0025
    ],
    [
      "dicter",
      0.0025
    ],
    [
      "dechainer",
      0.0025
    ],
    [
      "deferler",
      0.0025
    ],
    [
      "estomaquer",
      0.0025
    ],
    [
      "exhaler",
      0.0025
    ],
    [
      "expirer",
      0.0025
    ],
    [
      "eteindre",
      0.0025
    ]
  ],
  "reciter": [
    [
      "dire",
      0.1875
    ],
    [
      "debiter",
      0.1875
    ],
    [
      "prononcer",
      0.1875
    ],
    [
      "raconter",
      0.125
    ],
    [
      "declamer",
      0.0625
    ],
    [
      "lire",
      0.0625
    ],
    [
      "psalmodier",
      0.0625
    ],
    [
      "redire",
      0.0625
    ],
    [
      "retracer",
      0.0625
    ]
  ],
  "leurs": [
    [
      "sien",
      1.0
    ]
  ],
  "poeme": [
    [
      "poesie",
      0.0825
    ],
    [
      "chant",
      0.0625
    ],
    [
      "piece",
      0.0625
    ],
    [
      "chanson",
      0.0425
    ],
    [
      "strophe",
      0.0375
    ],
    [
      "satire",
      0.03
    ],
    [
      "hymne",
      0.025
    ],
    [
      "melodie",
      0.025
    ],
    [
      "quatrain",
      0.025
    ],
    [
      "eloge",
      0.0175
    ],
    [
      "eglogue",
      0.0175
    ],
    [
      "complainte",
      0.0175
    ],
    [
      "ballade",
      0.0175
    ],
    [
      "oeuvre",
      0.01
    ],
    [
      "ouvrage",
      0.01
    ],
    [
      "rhapsodie",
      0.01
    ],
    [
      "rondeau",
      0.01
    ],
    [
      "septain",
      0.01
    ],
    [
      "sizain",
      0.01
    ],
    [
      "stance",
      0.01
    ],
    [
      "vers",
      0.01
    ],
    [
      "virelai",
      0.01
    ],
    [
      "elegie",
      0.01
    ],
    [
      "epigramme",
      0.01
    ],
    [
      "epopee",
      0.01
    ],
    [
      "ode",
      0.01
    ],
    [
      "lied",
      0.01
    ],
    [
      "blason",
      0.01
    ],
    [
      "bouquet",
      0.01
    ],
    [
      "bucolique",
      0.01
    ],
    [
      "cantilene",
      0.01
    ],
    [
      "cantique",
      0.01
    ],
    [
      "comedie",
      0.01
    ],
    [
      "dialogue",
      0.01
    ],
    [
      "impromptu",
      0.01
    ],
    [
      "heroide",
      0.01
    ],
    [
      "geste",
      0.01
    ],
    [
      "fable",
      0.01
    ],
    [
      "dit",
      0.01
    ],
    [
      "sonnet",
      0.005
    ],
    [
      "sirvente",
      0.005
    ],
    [
      "sille",
      0.005
    ],
    [
      "rotrouenge",
      0.005
    ],
    [
      "romance",
      0.005
    ],
    [
      "psaume",
      0.005
    ],
    [
      "priapee",
      0.005
    ],
    [
      "pastourelle",
      0.005
    ],
    [
      "stichomythie",
      0.005
    ],
    [
      "tenson",
      0.005
    ],
    [
      "epitre",
      0.005
    ],
    [
      "epithalame",
      0.005
    ],
    [
      "villanelle",
      0.005
    ],
    [
      "triolet",
      0.005
    ],
    [
      "tragedie",
      0.005
    ],
    [
      "threne",
      0.005
    ],
    [
      "tercet",
      0.005
    ],
    [
      "pantoum",
      0.005
    ],
    [
      "opera",
      0.005
    ],
    [
      "odelette",
      0.005
    ],
    [
      "bergerie",
      0.005
    ],
    [
      "cantate",
      0.005
    ],
    [
      "canzone",
      0.005
    ],
    [
      "centon",
      0.005
    ],
    [
      "distique",
      0.005
    ],
    [
      "dithyrambe",
      0.005
    ],
    [
      "dizain",
      0.005
    ],
    [
      "douzain",
      0.005
    ],
    [
      "fabliau",
      0.005
    ],
    [
      "haikai",
      0.005
    ],
    [
      "huitain",
      0.005
    ],
    [
      "iambe",
      0.005
    ],
    [
      "idylle",
      0.005
    ],
    [
      "lai",
      0.005
    ],
    [
      "macaronee",
      0.005
    ],
    [
      "madrigal",
      0.005
    ],
    [
      "nome",
      0.005
    ],
    [
      "acrostiche",
      0.005
    ]
  ],
  "monsieur": [
    [
      "prince",
      1.0
    ]
  ],
  "cou": [
    [
      "col",
      0.375
    ],
    [
      "collet",
      0.125
    ],
    [
      "encolure",
      0.125
    ],
    [
      "gorge",
      0.125
    ],
    [
      "goulot",
      0.125
    ],
    [
      "nuque",
      0.125
    ]
  ],
  "enrouler": [
    [
      "rouler",
      0.1425
    ],
    [
      "envelopper",
      0.115
    ],
    [
      "bobiner",
      0.085
    ],
    [
      "embobiner",
      0.085
    ],
    [
      "peloter",
      0.085
    ],
    [
      "envider",
      0.055
    ],
    [
      "entourer",
      0.055
    ],
    [
      "emmitoufler",
      0.055
    ],
    [
      "emmailloter",
      0.055
    ],
    [
      "rouer",
      0.0275
    ],
    [
      "renvider",
      0.0275
    ],
    [
      "plier",
      0.0275
    ],
    [
      "pelotonner",
      0.0275
    ],
    [
      "lover",
      0.0275
    ],
    [
      "ceinturer",
      0.0275
    ],
    [
      "ceindre",
      0.0275
    ],
    [
      "caneter",
      0.0275
    ],
    [
      "tourner",
      0.0275
    ]
  ],
  "couche": [
    [
      "mettre",
      0.1125
    ],
    [
      "etendre",
      0.0975
    ],
    [
      "porter",
      0.07
    ],
    [
      "abattre",
      0.055
    ],
    [
      "renverser",
      0.055
    ],
    [
      "placer",
      0.04
    ],
    [
      "pencher",
      0.04
    ],
    [
      "inscrire",
      0.04
    ],
    [
      "incliner",
      0.04
    ],
    [
      "etaler",
      0.0275
    ],
    [
      "verser",
      0.0275
    ],
    [
      "terrasser",
      0.0275
    ],
    [
      "miser",
      0.0275
    ],
    [
      "loger",
      0.0275
    ],
    [
      "baisser",
      0.0275
    ],
    [
      "allonger",
      0.0275
    ],
    [
      "giter",
      0.0125
    ],
    [
      "habiter",
      0.0125
    ],
    [
      "marcotter",
      0.0125
    ],
    [
      "rabattre",
      0.0125
    ],
    [
      "situer",
      0.0125
    ],
    [
      "transcrire",
      0.0125
    ],
    [
      "viser",
      0.0125
    ],
    [
      "faucher",
      0.0125
    ],
    [
      "dormir",
      0.0125
    ],
    [
      "courber",
      0.0125
    ],
    [
      "couchotter",
      0.0125
    ],
    [
      "couchailler",
      0.0125
    ],
    [
      "consigner",
      0.0125
    ],
    [
      "baiser",
      0.0125
    ],
    [
      "aliter",
      0.0125
    ],
    [
      "epauler",
      0.0125
    ]
  ],
  "coucher": [
    [
      "crepuscule",
      0.22
    ],
    [
      "soir",
      0.22
    ],
    [
      "baisser",
      0.11
    ],
    [
      "brune",
      0.11
    ],
    [
      "couchant",
      0.11
    ],
    [
      "disparition",
      0.11
    ],
    [
      "gite",
      0.11
    ]
  ],
  "genou": [
    [
      "articulation",
      0.5
    ],
    [
      "jointure",
      0.25
    ],
    [
      "rotule",
      0.25
    ]
  ],
  "attendre": [
    [
      "esperer",
      0.0525
    ],
    [
      "prevoir",
      0.0525
    ],
    [
      "moisir",
      0.04
    ],
    [
      "temporiser",
      0.03
    ],
    [
      "rester",
      0.03
    ],
    [
      "remettre",
      0.03
    ],
    [
      "presumer",
      0.03
    ],
    [
      "pressentir",
      0.03
    ],
    [
      "poireauter",
      0.03
    ],
    [
      "guetter",
      0.03
    ],
    [
      "atermoyer",
      0.03
    ],
    [
      "patienter",
      0.02
    ],
    [
      "poser",
      0.02
    ],
    [
      "presager",
      0.02
    ],
    [
      "retarder",
      0.02
    ],
    [
      "souhaiter",
      0.02
    ],
    [
      "surseoir",
      0.02
    ],
    [
      "vouloir",
      0.02
    ],
    [
      "mettre",
      0.02
    ],
    [
      "menacer",
      0.02
    ],
    [
      "imaginer",
      0.02
    ],
    [
      "compter",
      0.02
    ],
    [
      "craindre",
      0.02
    ],
    [
      "croire",
      0.02
    ],
    [
      "demeurer",
      0.02
    ],
    [
      "differer",
      0.02
    ],
    [
      "desirer",
      0.02
    ],
    [
      "escompter",
      0.02
    ],
    [
      "hesiter",
      0.02
    ],
    [
      "reserver",
      0.01
    ],
    [
      "sejourner",
      0.01
    ],
    [
      "reporter",
      0.01
    ],
    [
      "redouter",
      0.01
    ],
    [
      "languir",
      0.01
    ],
    [
      "exiger",
      0.01
    ],
    [
      "durer",
      0.01
    ],
    [
      "droguer",
      0.01
    ]
  ],
  "touche": [
    [
      "atteindre",
      0.065
    ],
    [
      "gagner",
      0.045
    ],
    [
      "emouvoir",
      0.045
    ],
    [
      "bouleverser",
      0.0325
    ],
    [
      "prendre",
      0.03
    ],
    [
      "frapper",
      0.0275
    ],
    [
      "troubler",
      0.025
    ],
    [
      "remuer",
      0.0225
    ],
    [
      "attaquer",
      0.02
    ],
    [
      "traiter",
      0.02
    ],
    [
      "ebranler",
      0.02
    ],
    [
      "saisir",
      0.0175
    ],
    [
      "attraper",
      0.0175
    ],
    [
      "penetrer",
      0.015
    ],
    [
      "percevoir",
      0.015
    ],
    [
      "entamer",
      0.015
    ],
    [
      "aborder",
      0.015
    ],
    [
      "regarder",
      0.0125
    ],
    [
      "joindre",
      0.0125
    ],
    [
      "encaisser",
      0.0125
    ],
    [
      "aller",
      0.0125
    ],
    [
      "affecter",
      0.0125
    ],
    [
      "ramasser",
      0.0125
    ],
    [
      "interesser",
      0.0125
    ],
    [
      "heurter",
      0.0125
    ],
    [
      "effleurer",
      0.0125
    ],
    [
      "blesser",
      0.0125
    ],
    [
      "arriver",
      0.0125
    ],
    [
      "recevoir",
      0.01
    ],
    [
      "impressionner",
      0.01
    ],
    [
      "flechir",
      0.01
    ],
    [
      "attendrir",
      0.01
    ],
    [
      "accoster",
      0.0075
    ],
    [
      "adoucir",
      0.0075
    ],
    [
      "caresser",
      0.0075
    ],
    [
      "porter",
      0.0075
    ],
    [
      "rencontrer",
      0.0075
    ],
    [
      "presser",
      0.0075
    ],
    [
      "concerner",
      0.0075
    ],
    [
      "approcher",
      0.0075
    ],
    [
      "tater",
      0.005
    ],
    [
      "tirer",
      0.005
    ],
    [
      "parvenir",
      0.005
    ],
    [
      "marquer",
      0.005
    ],
    [
      "manier",
      0.005
    ],
    [
      "examiner",
      0.005
    ],
    [
      "entreprendre",
      0.005
    ],
    [
      "empocher",
      0.005
    ],
    [
      "amadouer",
      0.005
    ],
    [
      "rallier",
      0.0025
    ],
    [
      "persuader",
      0.0025
    ],
    [
      "palper",
      0.0025
    ],
    [
      "offenser",
      0.0025
    ],
    [
      "relacher",
      0.0025
    ],
    [
      "rouler",
      0.0025
    ],
    [
      "s'adresser",
      0.0025
    ],
    [
      "tripoter",
      0.0025
    ],
    [
      "trouver",
      0.0025
    ],
    [
      "viser",
      0.0025
    ],
    [
      "manger",
      0.0025
    ],
    [
      "leser",
      0.0025
    ],
    [
      "aboutir",
      0.0025
    ],
    [
      "aiguillonner",
      0.0025
    ],
    [
      "apitoyer",
      0.0025
    ],
    [
      "chatouiller",
      0.0025
    ],
    [
      "deranger",
      0.0025
    ],
    [
      "desarmer",
      0.0025
    ],
    [
      "embrasser",
      0.0025
    ],
    [
      "entailler",
      0.0025
    ],
    [
      "humaniser",
      0.0025
    ],
    [
      "jouer",
      0.0025
    ],
    [
      "perturber",
      0.0025
    ],
    [
      "pencher",
      0.0025
    ],
    [
      "parler",
      0.0025
    ],
    [
      "manipuler",
      0.0025
    ],
    [
      "recueillir",
      0.0025
    ],
    [
      "s'occuper",
      0.0025
    ],
    [
      "sonder",
      0.0025
    ],
    [
      "transformer",
      0.0025
    ],
    [
      "froler",
      0.0025
    ],
    [
      "fouetter",
      0.0025
    ],
    [
      "affliger",
      0.0025
    ],
    [
      "atterrer",
      0.0025
    ],
    [
      "atterrir",
      0.0025
    ],
    [
      "avoisiner",
      0.0025
    ],
    [
      "borner",
      0.0025
    ],
    [
      "changer",
      0.0025
    ],
    [
      "contacter",
      0.0025
    ],
    [
      "coudoyer",
      0.0025
    ],
    [
      "courir",
      0.0025
    ],
    [
      "empieter",
      0.0025
    ],
    [
      "retirer",
      0.0
    ],
    [
      "renouveler",
      0.0
    ],
    [
      "recouvrer",
      0.0
    ],
    [
      "modifier",
      0.0
    ],
    [
      "tatonner",
      0.0
    ],
    [
      "voisiner",
      0.0
    ],
    [
      "ecorner",
      0.0
    ],
    [
      "emarger",
      0.0
    ],
    [
      "impacter",
      0.0
    ],
    [
      "gouter",
      0.0
    ],
    [
      "flatter",
      0.0
    ],
    [
      "affleurer",
      0.0
    ],
    [
      "attoucher",
      0.0
    ],
    [
      "chavirer",
      0.0
    ],
    [
      "convaincre",
      0.0
    ],
    [
      "emotionner",
      0.0
    ]
  ],
  "dur": [
    [
      "rude",
      0.0675
    ],
    [
      "severe",
      0.045
    ],
    [
      "cruel",
      0.04
    ],
    [
      "apre",
      0.0325
    ],
    [
      "implacable",
      0.0275
    ],
    [
      "difficile",
      0.025
    ],
    [
      "inflexible",
      0.0225
    ],
    [
      "sec",
      0.0225
    ],
    [
      "ferme",
      0.02
    ],
    [
      "terrible",
      0.02
    ],
    [
      "raide",
      0.02
    ],
    [
      "mauvais",
      0.02
    ],
    [
      "insensible",
      0.0175
    ],
    [
      "penible",
      0.0175
    ],
    [
      "fort",
      0.015
    ],
    [
      "intraitable",
      0.015
    ],
    [
      "rigide",
      0.015
    ],
    [
      "violent",
      0.015
    ],
    [
      "impitoyable",
      0.015
    ],
    [
      "inhumain",
      0.015
    ],
    [
      "aigre",
      0.0125
    ],
    [
      "brutal",
      0.0125
    ],
    [
      "abrupt",
      0.0125
    ],
    [
      "feroce",
      0.0125
    ],
    [
      "rigoureux",
      0.0125
    ],
    [
      "tendu",
      0.01
    ],
    [
      "bourru",
      0.01
    ],
    [
      "farouche",
      0.01
    ],
    [
      "vif",
      0.01
    ],
    [
      "sauvage",
      0.01
    ],
    [
      "reveche",
      0.01
    ],
    [
      "froid",
      0.01
    ],
    [
      "austere",
      0.01
    ],
    [
      "amer",
      0.01
    ],
    [
      "mechant",
      0.0075
    ],
    [
      "cassant",
      0.0075
    ],
    [
      "tenace",
      0.0075
    ],
    [
      "strict",
      0.0075
    ],
    [
      "solide",
      0.0075
    ],
    [
      "resistant",
      0.0075
    ],
    [
      "inebranlable",
      0.0075
    ],
    [
      "raboteux",
      0.005
    ],
    [
      "lourd",
      0.005
    ],
    [
      "intransigeant",
      0.005
    ],
    [
      "autoritaire",
      0.005
    ],
    [
      "atroce",
      0.005
    ],
    [
      "ardu",
      0.005
    ],
    [
      "barbare",
      0.005
    ],
    [
      "impassible",
      0.005
    ],
    [
      "stoique",
      0.005
    ],
    [
      "rogue",
      0.005
    ],
    [
      "indocile",
      0.005
    ],
    [
      "indifferent",
      0.005
    ],
    [
      "desobeissant",
      0.005
    ],
    [
      "douloureux",
      0.005
    ],
    [
      "energique",
      0.0025
    ],
    [
      "tranchant",
      0.0025
    ],
    [
      "rebarbatif",
      0.0025
    ],
    [
      "inexorable",
      0.0025
    ],
    [
      "endurci",
      0.0025
    ],
    [
      "cru",
      0.0025
    ],
    [
      "acharne",
      0.0025
    ],
    [
      "infernal",
      0.0025
    ],
    [
      "inhospitalier",
      0.0025
    ],
    [
      "malheureux",
      0.0025
    ],
    [
      "patient",
      0.0025
    ],
    [
      "reche",
      0.0025
    ],
    [
      "trapu",
      0.0025
    ],
    [
      "energiquement",
      0.0025
    ],
    [
      "epais",
      0.0025
    ],
    [
      "epineux",
      0.0025
    ],
    [
      "infatigable",
      0.0025
    ],
    [
      "indiscipline",
      0.0025
    ],
    [
      "herisse",
      0.0025
    ],
    [
      "acerbe",
      0.0025
    ],
    [
      "bete",
      0.0025
    ],
    [
      "cale",
      0.0025
    ],
    [
      "coriace",
      0.0025
    ],
    [
      "courageux",
      0.0025
    ],
    [
      "diable",
      0.0025
    ],
    [
      "endurant",
      0.0025
    ],
    [
      "entete",
      0.0025
    ],
    [
      "exigeant",
      0.0025
    ],
    [
      "glacial",
      0.0025
    ],
    [
      "sale",
      0.0025
    ],
    [
      "rocailleux",
      0.0025
    ],
    [
      "malaise",
      0.0025
    ],
    [
      "intenable",
      0.0025
    ],
    [
      "insoumis",
      0.0025
    ],
    [
      "impossible",
      0.0025
    ],
    [
      "delicat",
      0.0025
    ],
    [
      "criard",
      0.0025
    ],
    [
      "blessant",
      0.0025
    ],
    [
      "invulnerable",
      0.0
    ],
    [
      "laborieux",
      0.0
    ],
    [
      "turbulent",
      0.0
    ],
    [
      "vache",
      0.0
    ],
    [
      "violemment",
      0.0
    ],
    [
      "virulent",
      0.0
    ],
    [
      "inaccessible",
      0.0
    ],
    [
      "facheux",
      0.0
    ],
    [
      "durement",
      0.0
    ],
    [
      "affligeant",
      0.0
    ],
    [
      "chaud",
      0.0
    ],
    [
      "cinglant",
      0.0
    ],
    [
      "desseche",
      0.0
    ],
    [
      "draconien",
      0.0
    ],
    [
      "filandreux",
      0.0
    ],
    [
      "fortement",
      0.0
    ],
    [
      "mec",
      0.0
    ],
    [
      "racorni",
      0.0
    ],
    [
      "rigoriste",
      0.0
    ],
    [
      "rudement",
      0.0
    ],
    [
      "savant",
      0.0
    ],
    [
      "strident",
      0.0
    ],
    [
      "torturant",
      0.0
    ],
    [
      "vivace",
      0.0
    ],
    [
      "faucon",
      0.0
    ],
    [
      "empese",
      0.0
    ],
    [
      "dissipe",
      0.0
    ],
    [
      "aguerri",
      0.0
    ],
    [
      "borne",
      0.0
    ],
    [
      "bouche",
      0.0
    ],
    [
      "bute",
      0.0
    ],
    [
      "calleux",
      0.0
    ],
    [
      "caid",
      0.0
    ],
    [
      "consistant",
      0.0
    ],
    [
      "croquant",
      0.0
    ],
    [
      "croustillant",
      0.0
    ],
    [
      "cuirasse",
      0.0
    ],
    [
      "inclement",
      0.0
    ],
    [
      "infrangible",
      0.0
    ],
    [
      "offensant",
      0.0
    ],
    [
      "pris",
      0.0
    ],
    [
      "rassis",
      0.0
    ],
    [
      "rugueux",
      0.0
    ],
    [
      "serieusement",
      0.0
    ],
    [
      "guttural",
      0.0
    ],
    [
      "granitique",
      0.0
    ],
    [
      "adamantin",
      0.0
    ],
    [
      "affranchi",
      0.0
    ],
    [
      "amidonne",
      0.0
    ],
    [
      "bronze",
      0.0
    ],
    [
      "courageusement",
      0.0
    ],
    [
      "craquant",
      0.0
    ],
    [
      "duraille",
      0.0
    ],
    [
      "fibreux",
      0.0
    ],
    [
      "epervier",
      0.0
    ]
  ],
  "dure": [
    [
      "rude",
      0.0675
    ],
    [
      "severe",
      0.045
    ],
    [
      "cruel",
      0.04
    ],
    [
      "apre",
      0.0325
    ],
    [
      "implacable",
      0.0275
    ],
    [
      "difficile",
      0.025
    ],
    [
      "inflexible",
      0.0225
    ],
    [
      "sec",
      0.0225
    ],
    [
      "ferme",
      0.02
    ],
    [
      "terrible",
      0.02
    ],
    [
      "raide",
      0.02
    ],
    [
      "mauvais",
      0.02
    ],
    [
      "insensible",
      0.0175
    ],
    [
      "penible",
      0.0175
    ],
    [
      "fort",
      0.015
    ],
    [
      "intraitable",
      0.015
    ],
    [
      "rigide",
      0.015
    ],
    [
      "violent",
      0.015
    ],
    [
      "impitoyable",
      0.015
    ],
    [
      "inhumain",
      0.015
    ],
    [
      "aigre",
      0.0125
    ],
    [
      "brutal",
      0.0125
    ],
    [
      "abrupt",
      0.0125
    ],
    [
      "feroce",
      0.0125
    ],
    [
      "rigoureux",
      0.0125
    ],
    [
      "tendu",
      0.01
    ],
    [
      "bourru",
      0.01
    ],
    [
      "farouche",
      0.01
    ],
    [
      "vif",
      0.01
    ],
    [
      "sauvage",
      0.01
    ],
    [
      "reveche",
      0.01
    ],
    [
      "froid",
      0.01
    ],
    [
      "austere",
      0.01
    ],
    [
      "amer",
      0.01
    ],
    [
      "mechant",
      0.0075
    ],
    [
      "cassant",
      0.0075
    ],
    [
      "tenace",
      0.0075
    ],
    [
      "strict",
      0.0075
    ],
    [
      "solide",
      0.0075
    ],
    [
      "resistant",
      0.0075
    ],
    [
      "inebranlable",
      0.0075
    ],
    [
      "raboteux",
      0.005
    ],
    [
      "lourd",
      0.005
    ],
    [
      "intransigeant",
      0.005
    ],
    [
      "autoritaire",
      0.005
    ],
    [
      "atroce",
      0.005
    ],
    [
      "ardu",
      0.005
    ],
    [
      "barbare",
      0.005
    ],
    [
      "impassible",
      0.005
    ],
    [
      "stoique",
      0.005
    ],
    [
      "rogue",
      0.005
    ],
    [
      "indocile",
      0.005
    ],
    [
      "indifferent",
      0.005
    ],
    [
      "desobeissant",
      0.005
    ],
    [
      "douloureux",
      0.005
    ],
    [
      "energique",
      0.0025
    ],
    [
      "tranchant",
      0.0025
    ],
    [
      "rebarbatif",
      0.0025
    ],
    [
      "inexorable",
      0.0025
    ],
    [
      "endurci",
      0.0025
    ],
    [
      "cru",
      0.0025
    ],
    [
      "acharne",
      0.0025
    ],
    [
      "infernal",
      0.0025
    ],
    [
      "inhospitalier",
      0.0025
    ],
    [
      "malheureux",
      0.0025
    ],
    [
      "patient",
      0.0025
    ],
    [
      "reche",
      0.0025
    ],
    [
      "trapu",
      0.0025
    ],
    [
      "energiquement",
      0.0025
    ],
    [
      "epais",
      0.0025
    ],
    [
      "epineux",
      0.0025
    ],
    [
      "infatigable",
      0.0025
    ],
    [
      "indiscipline",
      0.0025
    ],
    [
      "herisse",
      0.0025
    ],
    [
      "acerbe",
      0.0025
    ],
    [
      "bete",
      0.0025
    ],
    [
      "cale",
      0.0025
    ],
    [
      "coriace",
      0.0025
    ],
    [
      "courageux",
      0.0025
    ],
    [
      "diable",
      0.0025
    ],
    [
      "endurant",
      0.0025
    ],
    [
      "entete",
      0.0025
    ],
    [
      "exigeant",
      0.0025
    ],
    [
      "glacial",
      0.0025
    ],
    [
      "sale",
      0.0025
    ],
    [
      "rocailleux",
      0.0025
    ],
    [
      "malaise",
      0.0025
    ],
    [
      "intenable",
      0.0025
    ],
    [
      "insoumis",
      0.0025
    ],
    [
      "impossible",
      0.0025
    ],
    [
      "delicat",
      0.0025
    ],
    [
      "criard",
      0.0025
    ],
    [
      "blessant",
      0.0025
    ],
    [
      "invulnerable",
      0.0
    ],
    [
      "laborieux",
      0.0
    ],
    [
      "turbulent",
      0.0
    ],
    [
      "vache",
      0.0
    ],
    [
      "violemment",
      0.0
    ],
    [
      "virulent",
      0.0
    ],
    [
      "inaccessible",
      0.0
    ],
    [
      "facheux",
      0.0
    ],
    [
      "durement",
      0.0
    ],
    [
      "affligeant",
      0.0
    ],
    [
      "chaud",
      0.0
    ],
    [
      "cinglant",
      0.0
    ],
    [
      "desseche",
      0.0
    ],
    [
      "draconien",
      0.0
    ],
    [
      "filandreux",
      0.0
    ],
    [
      "fortement",
      0.0
    ],
    [
      "mec",
      0.0
    ],
    [
      "racorni",
      0.0
    ],
    [
      "rigoriste",
      0.0
    ],
    [
      "rudement",
      0.0
    ],
    [
      "savant",
      0.0
    ],
    [
      "strident",
      0.0
    ],
    [
      "torturant",
      0.0
    ],
    [
      "vivace",
      0.0
    ],
    [
      "faucon",
      0.0
    ],
    [
      "empese",
      0.0
    ],
    [
      "dissipe",
      0.0
    ],
    [
      "aguerri",
      0.0
    ],
    [
      "borne",
      0.0
    ],
    [
      "bouche",
      0.0
    ],
    [
      "bute",
      0.0
    ],
    [
      "calleux",
      0.0
    ],
    [
      "caid",
      0.0
    ],
    [
      "consistant",
      0.0
    ],
    [
      "croquant",
      0.0
    ],
    [
      "croustillant",
      0.0
    ],
    [
      "cuirasse",
      0.0
    ],
    [
      "inclement",
      0.0
    ],
    [
      "infrangible",
      0.0
    ],
    [
      "offensant",
      0.0
    ],
    [
      "pris",
      0.0
    ],
    [
      "rassis",
      0.0
    ],
    [
      "rugueux",
      0.0
    ],
    [
      "serieusement",
      0.0
    ],
    [
      "guttural",
      0.0
    ],
    [
      "granitique",
      0.0
    ],
    [
      "adamantin",
      0.0
    ],
    [
      "affranchi",
      0.0
    ],
    [
      "amidonne",
      0.0
    ],
    [
      "bronze",
      0.0
    ],
    [
      "courageusement",
      0.0
    ],
    [
      "craquant",
      0.0
    ],
    [
      "duraille",
      0.0
    ],
    [
      "fibreux",
      0.0
    ],
    [
      "epervier",
      0.0
    ]
  ],
  "durer": [
    [
      "demeurer",
      0.1225
    ],
    [
      "subsister",
      0.115
    ],
    [
      "trainer",
      0.1
    ],
    [
      "rester",
      0.0925
    ],
    [
      "tenir",
      0.0925
    ],
    [
      "continuer",
      0.085
    ],
    [
      "persister",
      0.0575
    ],
    [
      "s'eterniser",
      0.05
    ],
    [
      "perseverer",
      0.0275
    ],
    [
      "s'etendre",
      0.0275
    ],
    [
      "exister",
      0.0125
    ],
    [
      "occuper",
      0.0125
    ],
    [
      "vivre",
      0.0125
    ],
    [
      "s'allonger",
      0.005
    ],
    [
      "resister",
      0.005
    ],
    [
      "finir",
      0.005
    ],
    [
      "faire",
      0.005
    ],
    [
      "attendre",
      0.005
    ]
  ],
  "chaque": [
    [
      "chacun",
      0.5
    ],
    [
      "tout",
      0.5
    ]
  ],
  "blessure": [
    [
      "coup",
      0.1
    ],
    [
      "bleu",
      0.045
    ],
    [
      "contusion",
      0.04
    ],
    [
      "torgnole",
      0.04
    ],
    [
      "plaie",
      0.0325
    ],
    [
      "douleur",
      0.0325
    ],
    [
      "beigne",
      0.0325
    ],
    [
      "taillade",
      0.025
    ],
    [
      "morsure",
      0.025
    ],
    [
      "meurtrissure",
      0.025
    ],
    [
      "entaille",
      0.025
    ],
    [
      "dechirure",
      0.025
    ],
    [
      "coupure",
      0.025
    ],
    [
      "atteinte",
      0.025
    ],
    [
      "egratignure",
      0.02
    ],
    [
      "vexation",
      0.02
    ],
    [
      "lesion",
      0.02
    ],
    [
      "choc",
      0.02
    ],
    [
      "brulure",
      0.02
    ],
    [
      "balafre",
      0.02
    ],
    [
      "offense",
      0.0125
    ],
    [
      "piqure",
      0.0125
    ],
    [
      "tort",
      0.0125
    ],
    [
      "traumatisme",
      0.0125
    ],
    [
      "ecorchure",
      0.0125
    ],
    [
      "elongation",
      0.0125
    ],
    [
      "fracture",
      0.0125
    ],
    [
      "estafilade",
      0.0125
    ],
    [
      "entorse",
      0.0125
    ],
    [
      "bosse",
      0.0125
    ],
    [
      "cassure",
      0.0125
    ],
    [
      "cicatrice",
      0.0125
    ],
    [
      "commotion",
      0.0125
    ],
    [
      "coquard",
      0.0125
    ],
    [
      "ecchymose",
      0.0125
    ],
    [
      "humiliation",
      0.005
    ],
    [
      "injure",
      0.005
    ],
    [
      "luxation",
      0.005
    ],
    [
      "mutilation",
      0.005
    ],
    [
      "pique",
      0.005
    ],
    [
      "souffrance",
      0.005
    ],
    [
      "sevices",
      0.005
    ],
    [
      "trait",
      0.005
    ],
    [
      "trauma",
      0.005
    ],
    [
      "tumefaction",
      0.005
    ],
    [
      "griffure",
      0.005
    ],
    [
      "felure",
      0.005
    ],
    [
      "froissement",
      0.005
    ],
    [
      "atout",
      0.005
    ],
    [
      "bobo",
      0.005
    ],
    [
      "chataigne",
      0.005
    ],
    [
      "distension",
      0.005
    ],
    [
      "decousure",
      0.005
    ],
    [
      "deplaisir",
      0.005
    ],
    [
      "estocade",
      0.005
    ],
    [
      "excoriation",
      0.005
    ],
    [
      "foulure",
      0.005
    ],
    [
      "eraflure",
      0.005
    ]
  ],
  "connais": [
    [
      "voir",
      0.0925
    ],
    [
      "entendre",
      0.08
    ],
    [
      "comprendre",
      0.0675
    ],
    [
      "percevoir",
      0.0625
    ],
    [
      "sentir",
      0.055
    ],
    [
      "penetrer",
      0.055
    ],
    [
      "apercevoir",
      0.055
    ],
    [
      "eprouver",
      0.0425
    ],
    [
      "apprehender",
      0.0325
    ],
    [
      "concevoir",
      0.0325
    ],
    [
      "discerner",
      0.0325
    ],
    [
      "savoir",
      0.0275
    ],
    [
      "prendre",
      0.025
    ],
    [
      "apprecier",
      0.02
    ],
    [
      "constater",
      0.02
    ],
    [
      "juger",
      0.02
    ],
    [
      "subir",
      0.02
    ],
    [
      "ressentir",
      0.015
    ],
    [
      "penser",
      0.015
    ],
    [
      "embrasser",
      0.015
    ],
    [
      "considerer",
      0.015
    ],
    [
      "posseder",
      0.0125
    ],
    [
      "experimenter",
      0.0125
    ],
    [
      "estimer",
      0.0125
    ],
    [
      "apprendre",
      0.0125
    ],
    [
      "s'apercevoir",
      0.0075
    ],
    [
      "reconnaitre",
      0.0075
    ],
    [
      "pratiquer",
      0.0075
    ],
    [
      "entrevoir",
      0.0075
    ],
    [
      "endurer",
      0.0075
    ],
    [
      "supporter",
      0.0025
    ],
    [
      "s'occuper",
      0.0025
    ],
    [
      "assavoir",
      0.0025
    ]
  ],
  "drole": [
    [
      "amusant",
      0.09
    ],
    [
      "comique",
      0.0725
    ],
    [
      "bizarre",
      0.0625
    ],
    [
      "plaisant",
      0.0625
    ],
    [
      "original",
      0.035
    ],
    [
      "risible",
      0.035
    ],
    [
      "tordant",
      0.035
    ],
    [
      "cocasse",
      0.03
    ],
    [
      "curieux",
      0.025
    ],
    [
      "extraordinaire",
      0.025
    ],
    [
      "rigolo",
      0.025
    ],
    [
      "beau",
      0.0225
    ],
    [
      "ridicule",
      0.0225
    ],
    [
      "etonnant",
      0.0225
    ],
    [
      "gai",
      0.02
    ],
    [
      "truculent",
      0.02
    ],
    [
      "etrange",
      0.0175
    ],
    [
      "fantastique",
      0.015
    ],
    [
      "bouffon",
      0.0125
    ],
    [
      "desopilant",
      0.0125
    ],
    [
      "gaillard",
      0.0125
    ],
    [
      "marrant",
      0.0125
    ],
    [
      "polisson",
      0.01
    ],
    [
      "impayable",
      0.01
    ],
    [
      "gamin",
      0.01
    ],
    [
      "drolatique",
      0.01
    ],
    [
      "surprenant",
      0.0075
    ],
    [
      "spirituel",
      0.0075
    ],
    [
      "singulier",
      0.0075
    ],
    [
      "rejouissant",
      0.0075
    ],
    [
      "pittoresque",
      0.0075
    ],
    [
      "insolite",
      0.0075
    ],
    [
      "homme",
      0.0075
    ],
    [
      "facetieux",
      0.0075
    ],
    [
      "badin",
      0.0075
    ],
    [
      "coquin",
      0.0075
    ],
    [
      "divertissant",
      0.0075
    ],
    [
      "enfant",
      0.0075
    ],
    [
      "extravagant",
      0.0075
    ],
    [
      "vaurien",
      0.005
    ],
    [
      "type",
      0.005
    ],
    [
      "turlupin",
      0.005
    ],
    [
      "sensationnel",
      0.005
    ],
    [
      "lascar",
      0.005
    ],
    [
      "hilarant",
      0.005
    ],
    [
      "farceur",
      0.005
    ],
    [
      "diable",
      0.005
    ],
    [
      "bon",
      0.005
    ],
    [
      "rocambolesque",
      0.0025
    ],
    [
      "numero",
      0.0025
    ],
    [
      "inenarrable",
      0.0025
    ],
    [
      "garcon",
      0.0025
    ],
    [
      "fripouille",
      0.0025
    ],
    [
      "fier",
      0.0025
    ],
    [
      "bougre",
      0.0025
    ],
    [
      "bidonnant",
      0.0025
    ],
    [
      "pierrot",
      0.0
    ],
    [
      "poilant",
      0.0
    ],
    [
      "rude",
      0.0
    ],
    [
      "recreatif",
      0.0
    ],
    [
      "truand",
      0.0
    ],
    [
      "maraud",
      0.0
    ],
    [
      "gosse",
      0.0
    ],
    [
      "gondolant",
      0.0
    ],
    [
      "folichon",
      0.0
    ],
    [
      "fichu",
      0.0
    ],
    [
      "farfelu",
      0.0
    ],
    [
      "farce",
      0.0
    ],
    [
      "briscard",
      0.0
    ],
    [
      "egayant",
      0.0
    ]
  ],
  "froler": [
    [
      "effleurer",
      0.185
    ],
    [
      "caresser",
      0.1225
    ],
    [
      "friser",
      0.1225
    ],
    [
      "raser",
      0.1
    ],
    [
      "serrer",
      0.06
    ],
    [
      "egratigner",
      0.04
    ],
    [
      "toucher",
      0.04
    ],
    [
      "cotoyer",
      0.04
    ],
    [
      "coudoyer",
      0.04
    ],
    [
      "frayer",
      0.0175
    ],
    [
      "frotter",
      0.0175
    ],
    [
      "glisser",
      0.0175
    ],
    [
      "lecher",
      0.0175
    ],
    [
      "risquer",
      0.0175
    ],
    [
      "s'approcher",
      0.0175
    ]
  ],
  "ressembler": [
    [
      "s'apparenter",
      0.085
    ],
    [
      "approcher",
      0.05
    ],
    [
      "correspondre",
      0.05
    ],
    [
      "imiter",
      0.05
    ],
    [
      "rappeler",
      0.05
    ],
    [
      "tirer",
      0.0325
    ],
    [
      "representer",
      0.0325
    ],
    [
      "participer",
      0.0325
    ],
    [
      "sembler",
      0.015
    ],
    [
      "retirer",
      0.015
    ],
    [
      "proceder",
      0.015
    ],
    [
      "copier",
      0.015
    ],
    [
      "avoir",
      0.015
    ],
    [
      "approximer",
      0.015
    ]
  ],
  "ensemble": [
    [
      "assemblage",
      0.0875
    ],
    [
      "groupe",
      0.0775
    ],
    [
      "reunion",
      0.0725
    ],
    [
      "bloc",
      0.065
    ],
    [
      "harmonie",
      0.0475
    ],
    [
      "accord",
      0.0475
    ],
    [
      "totalite",
      0.04
    ],
    [
      "union",
      0.04
    ],
    [
      "masse",
      0.035
    ],
    [
      "unite",
      0.035
    ],
    [
      "tout",
      0.0225
    ],
    [
      "orchestre",
      0.0225
    ],
    [
      "collection",
      0.0225
    ],
    [
      "troupe",
      0.015
    ],
    [
      "total",
      0.015
    ],
    [
      "quantite",
      0.015
    ],
    [
      "fraternite",
      0.015
    ],
    [
      "composition",
      0.015
    ],
    [
      "colonie",
      0.015
    ],
    [
      "agglomeration",
      0.015
    ],
    [
      "edifice",
      0.01
    ],
    [
      "unanimite",
      0.01
    ],
    [
      "teneur",
      0.01
    ],
    [
      "synthese",
      0.01
    ],
    [
      "integralite",
      0.01
    ],
    [
      "entier",
      0.01
    ],
    [
      "concert",
      0.01
    ],
    [
      "commun",
      0.01
    ],
    [
      "collectif",
      0.01
    ],
    [
      "assortiment",
      0.01
    ],
    [
      "appareil",
      0.01
    ],
    [
      "pate",
      0.005
    ],
    [
      "quatuor",
      0.005
    ],
    [
      "quintette",
      0.005
    ],
    [
      "reuni",
      0.005
    ],
    [
      "somme",
      0.005
    ],
    [
      "tous",
      0.005
    ],
    [
      "unisson",
      0.005
    ],
    [
      "univers",
      0.005
    ],
    [
      "vetement",
      0.005
    ],
    [
      "organisme",
      0.005
    ],
    [
      "immeuble",
      0.005
    ],
    [
      "building",
      0.005
    ],
    [
      "cadre",
      0.005
    ],
    [
      "choeur",
      0.005
    ],
    [
      "clavier",
      0.005
    ],
    [
      "cohesion",
      0.005
    ],
    [
      "collectivite",
      0.005
    ],
    [
      "complexe",
      0.005
    ],
    [
      "concordance",
      0.005
    ],
    [
      "globalite",
      0.005
    ],
    [
      "ilot",
      0.005
    ]
  ],
  "impatience": [
    [
      "vivacite",
      0.085
    ],
    [
      "bouillonnement",
      0.06
    ],
    [
      "desir",
      0.06
    ],
    [
      "impetuosite",
      0.06
    ],
    [
      "irritation",
      0.06
    ],
    [
      "enervement",
      0.0475
    ],
    [
      "soif",
      0.0475
    ],
    [
      "precipitation",
      0.0475
    ],
    [
      "irritabilite",
      0.0475
    ],
    [
      "humeur",
      0.0475
    ],
    [
      "colere",
      0.0475
    ],
    [
      "hate",
      0.035
    ],
    [
      "fougue",
      0.035
    ],
    [
      "fievre",
      0.035
    ],
    [
      "empressement",
      0.035
    ],
    [
      "caprice",
      0.035
    ],
    [
      "avidite",
      0.035
    ],
    [
      "exasperation",
      0.0225
    ],
    [
      "irascibilite",
      0.0225
    ],
    [
      "toquade",
      0.01
    ],
    [
      "supplice",
      0.01
    ],
    [
      "petulance",
      0.01
    ],
    [
      "inquietude",
      0.01
    ],
    [
      "brusquerie",
      0.01
    ],
    [
      "balsamine",
      0.01
    ],
    [
      "attente",
      0.01
    ],
    [
      "agacement",
      0.01
    ],
    [
      "torture",
      0.01
    ]
  ],
  "souffrance": [
    [
      "douleur",
      0.1425
    ],
    [
      "affliction",
      0.13
    ],
    [
      "mal",
      0.0775
    ],
    [
      "chagrin",
      0.07
    ],
    [
      "peine",
      0.065
    ],
    [
      "tourment",
      0.065
    ],
    [
      "epreuve",
      0.0425
    ],
    [
      "tristesse",
      0.0425
    ],
    [
      "desolation",
      0.035
    ],
    [
      "deuil",
      0.0275
    ],
    [
      "dechirement",
      0.0275
    ],
    [
      "supplice",
      0.0275
    ],
    [
      "malaise",
      0.02
    ],
    [
      "maladie",
      0.02
    ],
    [
      "desespoir",
      0.02
    ],
    [
      "croix",
      0.02
    ],
    [
      "boulet",
      0.02
    ],
    [
      "amertume",
      0.0125
    ],
    [
      "larme",
      0.0125
    ],
    [
      "torture",
      0.0125
    ],
    [
      "instance",
      0.005
    ],
    [
      "passion",
      0.005
    ],
    [
      "patience",
      0.005
    ],
    [
      "rage",
      0.005
    ],
    [
      "indisposition",
      0.005
    ],
    [
      "gemissement",
      0.005
    ],
    [
      "gehenne",
      0.005
    ],
    [
      "endurance",
      0.005
    ],
    [
      "bat",
      0.005
    ],
    [
      "blessure",
      0.005
    ],
    [
      "elancement",
      0.005
    ]
  ],
  "parfois": [
    [
      "quelquefois",
      0.3325
    ],
    [
      "tantot",
      0.165
    ]
  ],
  "mot": [
    [
      "parole",
      0.0825
    ],
    [
      "pointe",
      0.0825
    ],
    [
      "trait",
      0.07
    ],
    [
      "pique",
      0.06
    ],
    [
      "terme",
      0.06
    ],
    [
      "boutade",
      0.0475
    ],
    [
      "nom",
      0.0475
    ],
    [
      "vocable",
      0.035
    ],
    [
      "saillie",
      0.035
    ],
    [
      "rosserie",
      0.035
    ],
    [
      "invective",
      0.035
    ],
    [
      "expression",
      0.035
    ],
    [
      "sentence",
      0.0225
    ],
    [
      "repartie",
      0.0225
    ],
    [
      "pensee",
      0.0225
    ],
    [
      "injure",
      0.0225
    ],
    [
      "denomination",
      0.0225
    ],
    [
      "concetto",
      0.0225
    ],
    [
      "appellation",
      0.0225
    ],
    [
      "pli",
      0.01
    ],
    [
      "pretexte",
      0.01
    ],
    [
      "sottise",
      0.01
    ],
    [
      "verbe",
      0.01
    ],
    [
      "ecrit",
      0.01
    ],
    [
      "pas",
      0.01
    ],
    [
      "particule",
      0.01
    ],
    [
      "missive",
      0.01
    ],
    [
      "message",
      0.01
    ],
    [
      "lettre",
      0.01
    ],
    [
      "dicton",
      0.01
    ],
    [
      "billet",
      0.01
    ],
    [
      "allocution",
      0.01
    ],
    [
      "epigramme",
      0.01
    ]
  ],
  "dechirer": [
    [
      "blesser",
      0.07
    ],
    [
      "couper",
      0.07
    ],
    [
      "rompre",
      0.0475
    ],
    [
      "casser",
      0.0375
    ],
    [
      "dechiqueter",
      0.035
    ],
    [
      "ereinter",
      0.03
    ],
    [
      "percer",
      0.03
    ],
    [
      "ecorcher",
      0.025
    ],
    [
      "entamer",
      0.0225
    ],
    [
      "fendre",
      0.0225
    ],
    [
      "labourer",
      0.0225
    ],
    [
      "ouvrir",
      0.0225
    ],
    [
      "mordre",
      0.02
    ],
    [
      "briser",
      0.02
    ],
    [
      "taillader",
      0.0175
    ],
    [
      "esquinter",
      0.0175
    ],
    [
      "diviser",
      0.0175
    ],
    [
      "broyer",
      0.0175
    ],
    [
      "balafrer",
      0.0175
    ],
    [
      "affliger",
      0.0175
    ],
    [
      "erafler",
      0.015
    ],
    [
      "egratigner",
      0.015
    ],
    [
      "transpercer",
      0.015
    ],
    [
      "tourmenter",
      0.015
    ],
    [
      "tailler",
      0.015
    ],
    [
      "navrer",
      0.015
    ],
    [
      "medire",
      0.015
    ],
    [
      "denigrer",
      0.015
    ],
    [
      "arracher",
      0.015
    ],
    [
      "triturer",
      0.01
    ],
    [
      "morceler",
      0.01
    ],
    [
      "griffer",
      0.01
    ],
    [
      "defaire",
      0.01
    ],
    [
      "crever",
      0.01
    ],
    [
      "chagriner",
      0.01
    ],
    [
      "emouvoir",
      0.0075
    ],
    [
      "traverser",
      0.0075
    ],
    [
      "offenser",
      0.0075
    ],
    [
      "lacerer",
      0.0075
    ],
    [
      "desoler",
      0.0075
    ],
    [
      "depecer",
      0.0075
    ],
    [
      "delabrer",
      0.0075
    ],
    [
      "discrediter",
      0.0075
    ],
    [
      "critiquer",
      0.0075
    ],
    [
      "meurtrir",
      0.005
    ],
    [
      "reveler",
      0.005
    ],
    [
      "scinder",
      0.005
    ],
    [
      "tirailler",
      0.005
    ],
    [
      "torturer",
      0.005
    ],
    [
      "trouer",
      0.005
    ],
    [
      "attrister",
      0.005
    ],
    [
      "calomnier",
      0.005
    ],
    [
      "diffamer",
      0.005
    ],
    [
      "decoudre",
      0.005
    ],
    [
      "desunir",
      0.005
    ],
    [
      "devoiler",
      0.005
    ],
    [
      "erailler",
      0.0
    ],
    [
      "elargir",
      0.0
    ],
    [
      "ecarteler",
      0.0
    ],
    [
      "outrager",
      0.0
    ],
    [
      "dilacerer",
      0.0
    ],
    [
      "crosser",
      0.0
    ],
    [
      "carder",
      0.0
    ],
    [
      "annuler",
      0.0
    ],
    [
      "accrocher",
      0.0
    ],
    [
      "etreindre",
      0.0
    ]
  ],
  "ose": [
    [
      "risquer",
      0.1425
    ],
    [
      "s'aviser",
      0.105
    ],
    [
      "tenter",
      0.105
    ],
    [
      "s'aventurer",
      0.07
    ],
    [
      "hasarder",
      0.07
    ],
    [
      "vouloir",
      0.035
    ],
    [
      "s'enhardir",
      0.035
    ],
    [
      "entreprendre",
      0.035
    ]
  ],
  "oser": [
    [
      "risquer",
      0.1425
    ],
    [
      "s'aviser",
      0.105
    ],
    [
      "tenter",
      0.105
    ],
    [
      "s'aventurer",
      0.07
    ],
    [
      "hasarder",
      0.07
    ],
    [
      "vouloir",
      0.035
    ],
    [
      "s'enhardir",
      0.035
    ],
    [
      "entreprendre",
      0.035
    ]
  ],
  "desirer": [
    [
      "vouloir",
      0.1425
    ],
    [
      "souhaiter",
      0.125
    ],
    [
      "pretendre",
      0.0575
    ],
    [
      "viser",
      0.0575
    ],
    [
      "convoiter",
      0.0525
    ],
    [
      "rever",
      0.0475
    ],
    [
      "ambitionner",
      0.0425
    ],
    [
      "aspirer",
      0.0425
    ],
    [
      "demander",
      0.0425
    ],
    [
      "briguer",
      0.035
    ],
    [
      "rechercher",
      0.03
    ],
    [
      "revendiquer",
      0.025
    ],
    [
      "solliciter",
      0.025
    ],
    [
      "exiger",
      0.02
    ],
    [
      "lorgner",
      0.02
    ],
    [
      "soupirer",
      0.02
    ],
    [
      "tendre",
      0.02
    ],
    [
      "chercher",
      0.0175
    ],
    [
      "aimer",
      0.0125
    ],
    [
      "appeler",
      0.0125
    ],
    [
      "envier",
      0.0125
    ],
    [
      "guigner",
      0.0075
    ],
    [
      "esperer",
      0.0075
    ],
    [
      "attendre",
      0.0075
    ],
    [
      "appeter",
      0.0075
    ],
    [
      "interesser",
      0.0025
    ],
    [
      "incliner",
      0.0025
    ],
    [
      "griller",
      0.0025
    ],
    [
      "entendre",
      0.0025
    ]
  ],
  "tirer": [
    [
      "prendre",
      0.065
    ],
    [
      "retirer",
      0.055
    ],
    [
      "sortir",
      0.05
    ],
    [
      "enlever",
      0.04
    ],
    [
      "faire",
      0.0275
    ],
    [
      "degager",
      0.025
    ],
    [
      "gagner",
      0.0225
    ],
    [
      "lancer",
      0.0225
    ],
    [
      "oter",
      0.02
    ],
    [
      "soutirer",
      0.02
    ],
    [
      "extraire",
      0.02
    ],
    [
      "arracher",
      0.02
    ],
    [
      "aller",
      0.0175
    ],
    [
      "piquer",
      0.0175
    ],
    [
      "tendre",
      0.0175
    ],
    [
      "voler",
      0.015
    ],
    [
      "produire",
      0.015
    ],
    [
      "attirer",
      0.015
    ],
    [
      "recueillir",
      0.0125
    ],
    [
      "recevoir",
      0.0125
    ],
    [
      "extorquer",
      0.0125
    ],
    [
      "emprunter",
      0.0125
    ],
    [
      "amener",
      0.0125
    ],
    [
      "allonger",
      0.0125
    ],
    [
      "abattre",
      0.0125
    ],
    [
      "etendre",
      0.01
    ],
    [
      "emettre",
      0.01
    ],
    [
      "toucher",
      0.01
    ],
    [
      "recolter",
      0.01
    ],
    [
      "retrancher",
      0.01
    ],
    [
      "partir",
      0.01
    ],
    [
      "lever",
      0.01
    ],
    [
      "descendre",
      0.01
    ],
    [
      "quitter",
      0.0075
    ],
    [
      "remorquer",
      0.0075
    ],
    [
      "regler",
      0.0075
    ],
    [
      "servir",
      0.0075
    ],
    [
      "sucer",
      0.0075
    ],
    [
      "trainer",
      0.0075
    ],
    [
      "eliminer",
      0.0075
    ],
    [
      "etirer",
      0.0075
    ],
    [
      "eveiller",
      0.0075
    ],
    [
      "puiser",
      0.0075
    ],
    [
      "percevoir",
      0.0075
    ],
    [
      "ouvrir",
      0.0075
    ],
    [
      "bombarder",
      0.0075
    ],
    [
      "couler",
      0.0075
    ],
    [
      "decharger",
      0.0075
    ],
    [
      "deriver",
      0.0075
    ],
    [
      "entrainer",
      0.0075
    ],
    [
      "exprimer",
      0.0075
    ],
    [
      "extirper",
      0.0075
    ],
    [
      "haler",
      0.0075
    ],
    [
      "lacher",
      0.0075
    ],
    [
      "provenir",
      0.0025
    ],
    [
      "rallonger",
      0.0025
    ],
    [
      "ramener",
      0.0025
    ],
    [
      "remmener",
      0.0025
    ],
    [
      "remuer",
      0.0025
    ],
    [
      "ressembler",
      0.0025
    ],
    [
      "shooter",
      0.0025
    ],
    [
      "touer",
      0.0025
    ],
    [
      "tracer",
      0.0025
    ],
    [
      "pomper",
      0.0025
    ],
    [
      "inferer",
      0.0025
    ],
    [
      "aspirer",
      0.0025
    ],
    [
      "bander",
      0.0025
    ],
    [
      "botter",
      0.0025
    ],
    [
      "conclure",
      0.0025
    ],
    [
      "distendre",
      0.0025
    ],
    [
      "deduire",
      0.0025
    ],
    [
      "delivrer",
      0.0025
    ],
    [
      "depetrer",
      0.0025
    ],
    [
      "deraciner",
      0.0025
    ],
    [
      "heriter",
      0.0025
    ],
    [
      "mitrailler",
      0.0
    ],
    [
      "raidir",
      0.0
    ],
    [
      "s'apparenter",
      0.0
    ],
    [
      "saquer",
      0.0
    ],
    [
      "sauver",
      0.0
    ],
    [
      "tirailler",
      0.0
    ],
    [
      "tracter",
      0.0
    ],
    [
      "traire",
      0.0
    ],
    [
      "interpreter",
      0.0
    ],
    [
      "imprimer",
      0.0
    ],
    [
      "filouter",
      0.0
    ],
    [
      "canarder",
      0.0
    ],
    [
      "decaisser",
      0.0
    ],
    [
      "degainer",
      0.0
    ],
    [
      "detirer",
      0.0
    ],
    [
      "fermer",
      0.0
    ],
    [
      "ferrer",
      0.0
    ],
    [
      "ecarteler",
      0.0
    ]
  ],
  "tire": [
    [
      "prendre",
      0.065
    ],
    [
      "retirer",
      0.055
    ],
    [
      "sortir",
      0.05
    ],
    [
      "enlever",
      0.04
    ],
    [
      "faire",
      0.0275
    ],
    [
      "degager",
      0.025
    ],
    [
      "gagner",
      0.0225
    ],
    [
      "lancer",
      0.0225
    ],
    [
      "oter",
      0.02
    ],
    [
      "soutirer",
      0.02
    ],
    [
      "extraire",
      0.02
    ],
    [
      "arracher",
      0.02
    ],
    [
      "aller",
      0.0175
    ],
    [
      "piquer",
      0.0175
    ],
    [
      "tendre",
      0.0175
    ],
    [
      "voler",
      0.015
    ],
    [
      "produire",
      0.015
    ],
    [
      "attirer",
      0.015
    ],
    [
      "recueillir",
      0.0125
    ],
    [
      "recevoir",
      0.0125
    ],
    [
      "extorquer",
      0.0125
    ],
    [
      "emprunter",
      0.0125
    ],
    [
      "amener",
      0.0125
    ],
    [
      "allonger",
      0.0125
    ],
    [
      "abattre",
      0.0125
    ],
    [
      "etendre",
      0.01
    ],
    [
      "emettre",
      0.01
    ],
    [
      "toucher",
      0.01
    ],
    [
      "recolter",
      0.01
    ],
    [
      "retrancher",
      0.01
    ],
    [
      "partir",
      0.01
    ],
    [
      "lever",
      0.01
    ],
    [
      "descendre",
      0.01
    ],
    [
      "quitter",
      0.0075
    ],
    [
      "remorquer",
      0.0075
    ],
    [
      "regler",
      0.0075
    ],
    [
      "servir",
      0.0075
    ],
    [
      "sucer",
      0.0075
    ],
    [
      "trainer",
      0.0075
    ],
    [
      "eliminer",
      0.0075
    ],
    [
      "etirer",
      0.0075
    ],
    [
      "eveiller",
      0.0075
    ],
    [
      "puiser",
      0.0075
    ],
    [
      "percevoir",
      0.0075
    ],
    [
      "ouvrir",
      0.0075
    ],
    [
      "bombarder",
      0.0075
    ],
    [
      "couler",
      0.0075
    ],
    [
      "decharger",
      0.0075
    ],
    [
      "deriver",
      0.0075
    ],
    [
      "entrainer",
      0.0075
    ],
    [
      "exprimer",
      0.0075
    ],
    [
      "extirper",
      0.0075
    ],
    [
      "haler",
      0.0075
    ],
    [
      "lacher",
      0.0075
    ],
    [
      "provenir",
      0.0025
    ],
    [
      "rallonger",
      0.0025
    ],
    [
      "ramener",
      0.0025
    ],
    [
      "remmener",
      0.0025
    ],
    [
      "remuer",
      0.0025
    ],
    [
      "ressembler",
      0.0025
    ],
    [
      "shooter",
      0.0025
    ],
    [
      "touer",
      0.0025
    ],
    [
      "tracer",
      0.0025
    ],
    [
      "pomper",
      0.0025
    ],
    [
      "inferer",
      0.0025
    ],
    [
      "aspirer",
      0.0025
    ],
    [
      "bander",
      0.0025
    ],
    [
      "botter",
      0.0025
    ],
    [
      "conclure",
      0.0025
    ],
    [
      "distendre",
      0.0025
    ],
    [
      "deduire",
      0.0025
    ],
    [
      "delivrer",
      0.0025
    ],
    [
      "depetrer",
      0.0025
    ],
    [
      "deraciner",
      0.0025
    ],
    [
      "heriter",
      0.0025
    ],
    [
      "mitrailler",
      0.0
    ],
    [
      "raidir",
      0.0
    ],
    [
      "s'apparenter",
      0.0
    ],
    [
      "saquer",
      0.0
    ],
    [
      "sauver",
      0.0
    ],
    [
      "tirailler",
      0.0
    ],
    [
      "tracter",
      0.0
    ],
    [
      "traire",
      0.0
    ],
    [
      "interpreter",
      0.0
    ],
    [
      "imprimer",
      0.0
    ],
    [
      "filouter",
      0.0
    ],
    [
      "canarder",
      0.0
    ],
    [
      "decaisser",
      0.0
    ],
    [
      "degainer",
      0.0
    ],
    [
      "detirer",
      0.0
    ],
    [
      "fermer",
      0.0
    ],
    [
      "ferrer",
      0.0
    ],
    [
      "ecarteler",
      0.0
    ]
  ],
  "pourquoi": [
    [
      "subsequemment",
      0.0625
    ],
    [
      "raison",
      0.0625
    ],
    [
      "que",
      0.0625
    ],
    [
      "motif",
      0.0625
    ],
    [
      "consequemment",
      0.0625
    ],
    [
      "cause",
      0.0625
    ],
    [
      "aussi",
      0.0625
    ]
  ],
  "parti": [
    [
      "association",
      0.07
    ],
    [
      "clan",
      0.065
    ],
    [
      "faction",
      0.06
    ],
    [
      "groupe",
      0.06
    ],
    [
      "secte",
      0.06
    ],
    [
      "ligue",
      0.055
    ],
    [
      "societe",
      0.055
    ],
    [
      "coalition",
      0.045
    ],
    [
      "coterie",
      0.035
    ],
    [
      "cabale",
      0.035
    ],
    [
      "bande",
      0.035
    ],
    [
      "phalange",
      0.0275
    ],
    [
      "troupe",
      0.0275
    ],
    [
      "rassemblement",
      0.025
    ],
    [
      "resolution",
      0.025
    ],
    [
      "organisation",
      0.0175
    ],
    [
      "complot",
      0.0175
    ],
    [
      "alliance",
      0.0175
    ],
    [
      "union",
      0.0125
    ],
    [
      "tribu",
      0.0125
    ],
    [
      "position",
      0.0125
    ],
    [
      "determination",
      0.0125
    ],
    [
      "decision",
      0.0125
    ],
    [
      "dessein",
      0.0125
    ],
    [
      "camp",
      0.0125
    ],
    [
      "volonte",
      0.0075
    ],
    [
      "tendance",
      0.0075
    ],
    [
      "situation",
      0.0075
    ],
    [
      "intrigue",
      0.0075
    ],
    [
      "formation",
      0.0075
    ],
    [
      "faisceau",
      0.0075
    ],
    [
      "chapelle",
      0.0075
    ],
    [
      "brigue",
      0.0075
    ],
    [
      "ivre",
      0.0025
    ],
    [
      "mouvement",
      0.0025
    ],
    [
      "partialite",
      0.0025
    ],
    [
      "profession",
      0.0025
    ],
    [
      "profit",
      0.0025
    ],
    [
      "propos",
      0.0025
    ],
    [
      "gai",
      0.0025
    ],
    [
      "conseil",
      0.0025
    ],
    [
      "choix",
      0.0025
    ],
    [
      "cause",
      0.0025
    ],
    [
      "benefice",
      0.0025
    ],
    [
      "avantage",
      0.0025
    ],
    [
      "absent",
      0.0025
    ],
    [
      "solution",
      0.0025
    ]
  ],
  "motif": [
    [
      "cause",
      0.1425
    ],
    [
      "raison",
      0.1075
    ],
    [
      "but",
      0.0625
    ],
    [
      "fondement",
      0.0625
    ],
    [
      "sujet",
      0.0525
    ],
    [
      "mobile",
      0.0525
    ],
    [
      "pretexte",
      0.0425
    ],
    [
      "intention",
      0.035
    ],
    [
      "justification",
      0.035
    ],
    [
      "principe",
      0.025
    ],
    [
      "origine",
      0.025
    ],
    [
      "matiere",
      0.025
    ],
    [
      "finalite",
      0.025
    ],
    [
      "theme",
      0.0175
    ],
    [
      "propos",
      0.0175
    ],
    [
      "preuve",
      0.0175
    ],
    [
      "occasion",
      0.0175
    ],
    [
      "motivation",
      0.0175
    ],
    [
      "moteur",
      0.0175
    ],
    [
      "germe",
      0.0175
    ],
    [
      "fin",
      0.0175
    ],
    [
      "explication",
      0.0175
    ],
    [
      "excuse",
      0.0175
    ],
    [
      "considerant",
      0.0175
    ],
    [
      "leitmotiv",
      0.0075
    ],
    [
      "modele",
      0.0075
    ],
    [
      "ornement",
      0.0075
    ],
    [
      "pourquoi",
      0.0075
    ],
    [
      "impulsion",
      0.0075
    ],
    [
      "dessin",
      0.0075
    ],
    [
      "couleur",
      0.0075
    ],
    [
      "comment",
      0.0075
    ],
    [
      "attendu",
      0.0075
    ],
    [
      "agent",
      0.0075
    ],
    [
      "temoignage",
      0.0075
    ]
  ],
  "sens": [
    [
      "esprit",
      0.0525
    ],
    [
      "sentiment",
      0.0425
    ],
    [
      "jugement",
      0.04
    ],
    [
      "tendance",
      0.0325
    ],
    [
      "raison",
      0.0325
    ],
    [
      "opinion",
      0.0325
    ],
    [
      "conception",
      0.025
    ],
    [
      "concupiscence",
      0.025
    ],
    [
      "sensualite",
      0.02
    ],
    [
      "plaisir",
      0.02
    ],
    [
      "ligne",
      0.02
    ],
    [
      "gout",
      0.02
    ],
    [
      "amour",
      0.02
    ],
    [
      "vue",
      0.0175
    ],
    [
      "tact",
      0.0175
    ],
    [
      "sagesse",
      0.0175
    ],
    [
      "point",
      0.0175
    ],
    [
      "perception",
      0.0175
    ],
    [
      "instinct",
      0.0175
    ],
    [
      "faculte",
      0.0175
    ],
    [
      "entendement",
      0.0175
    ],
    [
      "discernement",
      0.0175
    ],
    [
      "direction",
      0.0175
    ],
    [
      "aptitude",
      0.0175
    ],
    [
      "signification",
      0.0125
    ],
    [
      "lucidite",
      0.0125
    ],
    [
      "intuition",
      0.0125
    ],
    [
      "cote",
      0.0125
    ],
    [
      "comprehension",
      0.0125
    ],
    [
      "but",
      0.0125
    ],
    [
      "volupte",
      0.01
    ],
    [
      "valeur",
      0.01
    ],
    [
      "portee",
      0.01
    ],
    [
      "orientation",
      0.01
    ],
    [
      "libido",
      0.01
    ],
    [
      "gre",
      0.01
    ],
    [
      "don",
      0.01
    ],
    [
      "conscience",
      0.01
    ],
    [
      "chaleur",
      0.01
    ],
    [
      "caractere",
      0.01
    ],
    [
      "perspicacite",
      0.005
    ],
    [
      "philosophie",
      0.005
    ],
    [
      "sensation",
      0.005
    ],
    [
      "notion",
      0.005
    ],
    [
      "mesure",
      0.005
    ],
    [
      "lascivete",
      0.005
    ],
    [
      "avis",
      0.005
    ],
    [
      "destination",
      0.005
    ],
    [
      "entente",
      0.005
    ],
    [
      "face",
      0.005
    ],
    [
      "jugeote",
      0.005
    ],
    [
      "odorat",
      0.0025
    ],
    [
      "organe",
      0.0025
    ],
    [
      "ouie",
      0.0025
    ],
    [
      "raisonnement",
      0.0025
    ],
    [
      "route",
      0.0025
    ],
    [
      "sapience",
      0.0025
    ],
    [
      "signifie",
      0.0025
    ],
    [
      "sybaritisme",
      0.0025
    ],
    [
      "toucher",
      0.0025
    ],
    [
      "lettre",
      0.0025
    ],
    [
      "acception",
      0.0025
    ],
    [
      "ardeur",
      0.0025
    ],
    [
      "audition",
      0.0025
    ],
    [
      "chair",
      0.0025
    ],
    [
      "chemin",
      0.0025
    ],
    [
      "clef",
      0.0025
    ],
    [
      "interpretation",
      0.0025
    ],
    [
      "jouissance",
      0.0025
    ],
    [
      "acceptation",
      0.0025
    ]
  ],
  "sentir": [
    [
      "percevoir",
      0.0575
    ],
    [
      "connaitre",
      0.0525
    ],
    [
      "puer",
      0.0525
    ],
    [
      "apercevoir",
      0.05
    ],
    [
      "deviner",
      0.045
    ],
    [
      "decouvrir",
      0.045
    ],
    [
      "flairer",
      0.045
    ],
    [
      "eprouver",
      0.0325
    ],
    [
      "exhaler",
      0.0325
    ],
    [
      "entendre",
      0.0325
    ],
    [
      "comprendre",
      0.0325
    ],
    [
      "discerner",
      0.0275
    ],
    [
      "penetrer",
      0.0275
    ],
    [
      "reveler",
      0.025
    ],
    [
      "remarquer",
      0.025
    ],
    [
      "pressentir",
      0.02
    ],
    [
      "subodorer",
      0.015
    ],
    [
      "subir",
      0.015
    ],
    [
      "souffrir",
      0.015
    ],
    [
      "ressentir",
      0.015
    ],
    [
      "respirer",
      0.015
    ],
    [
      "recevoir",
      0.015
    ],
    [
      "constater",
      0.015
    ],
    [
      "apprecier",
      0.015
    ],
    [
      "eventer",
      0.01
    ],
    [
      "renifler",
      0.01
    ],
    [
      "gouter",
      0.01
    ],
    [
      "empester",
      0.01
    ],
    [
      "degager",
      0.01
    ],
    [
      "trouver",
      0.0075
    ],
    [
      "suinter",
      0.0075
    ],
    [
      "schlinguer",
      0.0075
    ],
    [
      "odorer",
      0.0075
    ],
    [
      "halener",
      0.0075
    ],
    [
      "fleurer",
      0.0075
    ],
    [
      "encaisser",
      0.0075
    ],
    [
      "empuantir",
      0.0075
    ],
    [
      "cogner",
      0.0075
    ],
    [
      "cocotter",
      0.0075
    ],
    [
      "apparaitre",
      0.0075
    ],
    [
      "pifer",
      0.0025
    ],
    [
      "prevoir",
      0.0025
    ],
    [
      "savourer",
      0.0025
    ],
    [
      "soupconner",
      0.0025
    ],
    [
      "suer",
      0.0025
    ],
    [
      "taper",
      0.0025
    ],
    [
      "trahir",
      0.0025
    ],
    [
      "trouilloter",
      0.0025
    ],
    [
      "paraitre",
      0.0025
    ],
    [
      "musser",
      0.0025
    ],
    [
      "blairer",
      0.0025
    ],
    [
      "denoncer",
      0.0025
    ],
    [
      "embaumer",
      0.0025
    ],
    [
      "empoisonner",
      0.0025
    ],
    [
      "fouetter",
      0.0025
    ],
    [
      "gazouiller",
      0.0025
    ],
    [
      "hair",
      0.0025
    ],
    [
      "humer",
      0.0025
    ],
    [
      "indiquer",
      0.0025
    ]
  ],
  "c": [],
  "endurcir": [
    [
      "cuirasser",
      0.1675
    ],
    [
      "durcir",
      0.1
    ],
    [
      "tremper",
      0.0825
    ],
    [
      "aguerrir",
      0.065
    ],
    [
      "blinder",
      0.065
    ],
    [
      "raidir",
      0.0475
    ],
    [
      "racornir",
      0.0475
    ],
    [
      "fortifier",
      0.0475
    ],
    [
      "bronzer",
      0.0475
    ],
    [
      "affermir",
      0.0475
    ],
    [
      "styler",
      0.0325
    ],
    [
      "habituer",
      0.0325
    ],
    [
      "exercer",
      0.0325
    ],
    [
      "entrainer",
      0.0325
    ],
    [
      "dessecher",
      0.0325
    ],
    [
      "armer",
      0.0325
    ],
    [
      "accoutumer",
      0.0325
    ],
    [
      "geler",
      0.015
    ],
    [
      "ossifier",
      0.015
    ]
  ],
  "attrister": [
    [
      "chagriner",
      0.1625
    ],
    [
      "affliger",
      0.14
    ],
    [
      "navrer",
      0.1275
    ],
    [
      "peiner",
      0.0925
    ],
    [
      "desoler",
      0.0675
    ],
    [
      "emouvoir",
      0.045
    ],
    [
      "facher",
      0.0325
    ],
    [
      "consterner",
      0.0325
    ],
    [
      "assombrir",
      0.0325
    ],
    [
      "rembrunir",
      0.0225
    ],
    [
      "desesperer",
      0.0225
    ],
    [
      "dechirer",
      0.0225
    ],
    [
      "contrister",
      0.0225
    ],
    [
      "chiffonner",
      0.0225
    ],
    [
      "affecter",
      0.0225
    ],
    [
      "obscurcir",
      0.01
    ],
    [
      "frapper",
      0.01
    ],
    [
      "endolorir",
      0.01
    ],
    [
      "embrunir",
      0.01
    ],
    [
      "embrumer",
      0.01
    ],
    [
      "apitoyer",
      0.01
    ],
    [
      "eplorer",
      0.01
    ]
  ],
  "f": [],
  "artiste": [
    [
      "acteur",
      0.085
    ],
    [
      "chanteur",
      0.085
    ],
    [
      "interprete",
      0.0625
    ],
    [
      "saltimbanque",
      0.0625
    ],
    [
      "vedette",
      0.0625
    ],
    [
      "virtuose",
      0.0425
    ],
    [
      "musicien",
      0.0425
    ],
    [
      "fantaisiste",
      0.0425
    ],
    [
      "comedien",
      0.0425
    ],
    [
      "clown",
      0.0425
    ],
    [
      "maitre",
      0.02
    ],
    [
      "ouvrier",
      0.02
    ],
    [
      "peintre",
      0.02
    ],
    [
      "prestidigitateur",
      0.02
    ],
    [
      "sculpteur",
      0.02
    ],
    [
      "star",
      0.02
    ],
    [
      "ecrivain",
      0.02
    ],
    [
      "etoile",
      0.02
    ],
    [
      "graveur",
      0.02
    ],
    [
      "executant",
      0.02
    ],
    [
      "esthete",
      0.02
    ],
    [
      "artisan",
      0.02
    ],
    [
      "artistique",
      0.02
    ],
    [
      "boheme",
      0.02
    ],
    [
      "chanteuse",
      0.02
    ],
    [
      "coiffeur",
      0.02
    ],
    [
      "danseur",
      0.02
    ],
    [
      "dessinateur",
      0.02
    ],
    [
      "decorateur",
      0.02
    ],
    [
      "etudiant",
      0.02
    ]
  ],
  "clicher": [
    [
      "couler",
      0.5
    ],
    [
      "stereotyper",
      0.5
    ]
  ],
  "cliche": [
    [
      "couler",
      0.5
    ],
    [
      "stereotyper",
      0.5
    ]
  ],
  "cible": [
    [
      "but",
      0.22
    ],
    [
      "jouet",
      0.11
    ],
    [
      "mire",
      0.11
    ],
    [
      "mouche",
      0.11
    ],
    [
      "objectif",
      0.11
    ],
    [
      "papegai",
      0.11
    ],
    [
      "quintaine",
      0.11
    ]
  ],
  "rime": [
    [
      "consonance",
      0.3325
    ],
    [
      "terminaison",
      0.3325
    ],
    [
      "vers",
      0.3325
    ]
  ],
  "rimer": [
    [
      "versifier",
      0.2
    ],
    [
      "composer",
      0.0975
    ],
    [
      "correspondre",
      0.0975
    ],
    [
      "cramer",
      0.0975
    ],
    [
      "poetiser",
      0.0975
    ],
    [
      "rimailler",
      0.0975
    ],
    [
      "signifier",
      0.0975
    ]
  ],
  "endroit": [
    [
      "lieu",
      0.1
    ],
    [
      "coin",
      0.0675
    ],
    [
      "face",
      0.0575
    ],
    [
      "point",
      0.0575
    ],
    [
      "pays",
      0.05
    ],
    [
      "region",
      0.0425
    ],
    [
      "place",
      0.0425
    ],
    [
      "origine",
      0.0425
    ],
    [
      "emplacement",
      0.0425
    ],
    [
      "site",
      0.0325
    ],
    [
      "patelin",
      0.0325
    ],
    [
      "facade",
      0.0325
    ],
    [
      "exterieur",
      0.0325
    ],
    [
      "cote",
      0.0325
    ],
    [
      "aspect",
      0.0325
    ],
    [
      "apparence",
      0.0325
    ],
    [
      "trou",
      0.025
    ],
    [
      "tournure",
      0.025
    ],
    [
      "source",
      0.015
    ],
    [
      "situation",
      0.015
    ],
    [
      "passage",
      0.015
    ],
    [
      "parages",
      0.015
    ],
    [
      "moment",
      0.015
    ],
    [
      "dehors",
      0.015
    ],
    [
      "bourg",
      0.015
    ],
    [
      "berceau",
      0.015
    ],
    [
      "theatre",
      0.0075
    ],
    [
      "sejour",
      0.0075
    ],
    [
      "recto",
      0.0075
    ],
    [
      "quartier",
      0.0075
    ],
    [
      "provenance",
      0.0075
    ],
    [
      "devant",
      0.0075
    ],
    [
      "dessus",
      0.0075
    ],
    [
      "adret",
      0.0075
    ],
    [
      "village",
      0.0075
    ]
  ],
  "suspect": [
    [
      "douteux",
      0.1925
    ],
    [
      "louche",
      0.1925
    ],
    [
      "equivoque",
      0.12
    ],
    [
      "borgne",
      0.0475
    ],
    [
      "vereux",
      0.0475
    ],
    [
      "problematique",
      0.0225
    ],
    [
      "sale",
      0.0225
    ],
    [
      "soupconne",
      0.0225
    ],
    [
      "suspectable",
      0.0225
    ],
    [
      "suspecte",
      0.0225
    ],
    [
      "marron",
      0.0225
    ],
    [
      "malfame",
      0.0225
    ],
    [
      "interlope",
      0.0225
    ],
    [
      "inculpe",
      0.0225
    ],
    [
      "incertain",
      0.0225
    ],
    [
      "frelate",
      0.0225
    ],
    [
      "factieux",
      0.0225
    ],
    [
      "compromettant",
      0.0225
    ],
    [
      "apocryphe",
      0.0225
    ],
    [
      "trouble",
      0.0225
    ]
  ],
  "echanger": [
    [
      "troquer",
      0.1275
    ],
    [
      "changer",
      0.095
    ],
    [
      "donner",
      0.095
    ],
    [
      "vendre",
      0.095
    ],
    [
      "brocanter",
      0.0625
    ],
    [
      "monnayer",
      0.0625
    ],
    [
      "permuter",
      0.03
    ],
    [
      "remplacer",
      0.03
    ],
    [
      "jaboter",
      0.03
    ],
    [
      "interchanger",
      0.03
    ],
    [
      "essanger",
      0.03
    ],
    [
      "copermuter",
      0.03
    ],
    [
      "compenser",
      0.03
    ],
    [
      "communiquer",
      0.03
    ],
    [
      "bavarder",
      0.03
    ],
    [
      "aliener",
      0.03
    ],
    [
      "trafiquer",
      0.03
    ]
  ],
  "soin": [
    [
      "attention",
      0.08
    ],
    [
      "application",
      0.0425
    ],
    [
      "delicatesse",
      0.0425
    ],
    [
      "zele",
      0.0425
    ],
    [
      "conscience",
      0.04
    ],
    [
      "scrupule",
      0.035
    ],
    [
      "precaution",
      0.0325
    ],
    [
      "circonspection",
      0.0325
    ],
    [
      "diligence",
      0.0275
    ],
    [
      "menagement",
      0.0275
    ],
    [
      "service",
      0.0275
    ],
    [
      "travail",
      0.0275
    ],
    [
      "charge",
      0.0225
    ],
    [
      "exactitude",
      0.0225
    ],
    [
      "occupation",
      0.0175
    ],
    [
      "devoir",
      0.0175
    ],
    [
      "vigilance",
      0.015
    ],
    [
      "serieux",
      0.015
    ],
    [
      "sollicitude",
      0.015
    ],
    [
      "reserve",
      0.015
    ],
    [
      "regularite",
      0.015
    ],
    [
      "prevenance",
      0.015
    ],
    [
      "prudence",
      0.015
    ],
    [
      "minutie",
      0.015
    ],
    [
      "empressement",
      0.015
    ],
    [
      "complaisance",
      0.015
    ],
    [
      "preoccupation",
      0.01
    ],
    [
      "souci",
      0.01
    ],
    [
      "tourment",
      0.01
    ],
    [
      "traitement",
      0.01
    ],
    [
      "ordre",
      0.01
    ],
    [
      "inquietude",
      0.01
    ],
    [
      "honnetete",
      0.01
    ],
    [
      "gaterie",
      0.01
    ],
    [
      "coeur",
      0.01
    ],
    [
      "assiduite",
      0.01
    ],
    [
      "severite",
      0.0075
    ],
    [
      "therapeutique",
      0.0075
    ],
    [
      "veille",
      0.0075
    ],
    [
      "economie",
      0.0075
    ],
    [
      "egard",
      0.0075
    ],
    [
      "etude",
      0.0075
    ],
    [
      "sensibilite",
      0.0075
    ],
    [
      "rigueur",
      0.0075
    ],
    [
      "prevoyance",
      0.0075
    ],
    [
      "douceur",
      0.0075
    ],
    [
      "garde",
      0.0075
    ],
    [
      "hommage",
      0.0075
    ],
    [
      "hygiene",
      0.0075
    ],
    [
      "mission",
      0.0075
    ],
    [
      "proprete",
      0.0075
    ],
    [
      "medication",
      0.0025
    ],
    [
      "meticulosite",
      0.0025
    ],
    [
      "responsabilite",
      0.0025
    ],
    [
      "superstition",
      0.0025
    ],
    [
      "toilette",
      0.0025
    ],
    [
      "fignolage",
      0.0025
    ],
    [
      "diplomatie",
      0.0025
    ],
    [
      "cure",
      0.0025
    ],
    [
      "conduite",
      0.0025
    ],
    [
      "cajolerie",
      0.0025
    ],
    [
      "besogne",
      0.0025
    ],
    [
      "assistance",
      0.0025
    ],
    [
      "art",
      0.0025
    ],
    [
      "tracas",
      0.0025
    ]
  ],
  "tape": [
    [
      "battre",
      0.145
    ],
    [
      "frapper",
      0.1175
    ],
    [
      "cogner",
      0.105
    ],
    [
      "tambouriner",
      0.065
    ],
    [
      "heurter",
      0.0525
    ],
    [
      "rosser",
      0.025
    ],
    [
      "marteler",
      0.025
    ],
    [
      "fesser",
      0.025
    ],
    [
      "claquer",
      0.025
    ],
    [
      "boxer",
      0.025
    ],
    [
      "meurtrir",
      0.0125
    ],
    [
      "medire",
      0.0125
    ],
    [
      "puer",
      0.0125
    ],
    [
      "quemander",
      0.0125
    ],
    [
      "rencontrer",
      0.0125
    ],
    [
      "sentir",
      0.0125
    ],
    [
      "souffleter",
      0.0125
    ],
    [
      "talocher",
      0.0125
    ],
    [
      "tapoter",
      0.0125
    ],
    [
      "toper",
      0.0125
    ],
    [
      "ecrire",
      0.0125
    ],
    [
      "griser",
      0.0125
    ],
    [
      "gifler",
      0.0125
    ],
    [
      "botter",
      0.0125
    ],
    [
      "bottiner",
      0.0125
    ],
    [
      "boucher",
      0.0125
    ],
    [
      "brutaliser",
      0.0125
    ],
    [
      "calotter",
      0.0125
    ],
    [
      "choquer",
      0.0125
    ],
    [
      "consommer",
      0.0125
    ],
    [
      "critiquer",
      0.0125
    ],
    [
      "dactylographier",
      0.0125
    ],
    [
      "emprunter",
      0.0125
    ],
    [
      "enivrer",
      0.0125
    ],
    [
      "entamer",
      0.0125
    ],
    [
      "friser",
      0.0125
    ],
    [
      "etourdir",
      0.0125
    ]
  ],
  "taper": [
    [
      "battre",
      0.145
    ],
    [
      "frapper",
      0.1175
    ],
    [
      "cogner",
      0.105
    ],
    [
      "tambouriner",
      0.065
    ],
    [
      "heurter",
      0.0525
    ],
    [
      "rosser",
      0.025
    ],
    [
      "marteler",
      0.025
    ],
    [
      "fesser",
      0.025
    ],
    [
      "claquer",
      0.025
    ],
    [
      "boxer",
      0.025
    ],
    [
      "meurtrir",
      0.0125
    ],
    [
      "medire",
      0.0125
    ],
    [
      "puer",
      0.0125
    ],
    [
      "quemander",
      0.0125
    ],
    [
      "rencontrer",
      0.0125
    ],
    [
      "sentir",
      0.0125
    ],
    [
      "souffleter",
      0.0125
    ],
    [
      "talocher",
      0.0125
    ],
    [
      "tapoter",
      0.0125
    ],
    [
      "toper",
      0.0125
    ],
    [
      "ecrire",
      0.0125
    ],
    [
      "griser",
      0.0125
    ],
    [
      "gifler",
      0.0125
    ],
    [
      "botter",
      0.0125
    ],
    [
      "bottiner",
      0.0125
    ],
    [
      "boucher",
      0.0125
    ],
    [
      "brutaliser",
      0.0125
    ],
    [
      "calotter",
      0.0125
    ],
    [
      "choquer",
      0.0125
    ],
    [
      "consommer",
      0.0125
    ],
    [
      "critiquer",
      0.0125
    ],
    [
      "dactylographier",
      0.0125
    ],
    [
      "emprunter",
      0.0125
    ],
    [
      "enivrer",
      0.0125
    ],
    [
      "entamer",
      0.0125
    ],
    [
      "friser",
      0.0125
    ],
    [
      "etourdir",
      0.0125
    ]
  ],
  "tap": [],
  "fuir": [
    [
      "s'enfuir",
      0.13
    ],
    [
      "partir",
      0.075
    ],
    [
      "disparaitre",
      0.055
    ],
    [
      "filer",
      0.0425
    ],
    [
      "s'echapper",
      0.04
    ],
    [
      "s'eclipser",
      0.0375
    ],
    [
      "s'evader",
      0.0325
    ],
    [
      "deguerpir",
      0.03
    ],
    [
      "echapper",
      0.025
    ],
    [
      "s'envoler",
      0.02
    ],
    [
      "couler",
      0.02
    ],
    [
      "courir",
      0.02
    ],
    [
      "decamper",
      0.02
    ],
    [
      "quitter",
      0.0175
    ],
    [
      "s'ecouler",
      0.015
    ],
    [
      "s'esquiver",
      0.015
    ],
    [
      "passer",
      0.015
    ],
    [
      "abandonner",
      0.01
    ],
    [
      "detaler",
      0.01
    ],
    [
      "eviter",
      0.01
    ],
    [
      "s'evanouir",
      0.0075
    ],
    [
      "s'eloigner",
      0.0075
    ],
    [
      "ceder",
      0.0075
    ],
    [
      "perdre",
      0.0075
    ],
    [
      "reculer",
      0.0075
    ],
    [
      "eluder",
      0.0075
    ],
    [
      "s'enfoncer",
      0.005
    ],
    [
      "deloger",
      0.005
    ],
    [
      "voler",
      0.0025
    ],
    [
      "suinter",
      0.0025
    ],
    [
      "s'exiler",
      0.0025
    ],
    [
      "esquiver",
      0.0025
    ],
    [
      "cavaler",
      0.0025
    ],
    [
      "sourdre",
      0.0025
    ],
    [
      "filtrer",
      0.0025
    ],
    [
      "caleter",
      0.0025
    ],
    [
      "refuir",
      0.0
    ],
    [
      "s'affaisser",
      0.0
    ],
    [
      "s'esbigner",
      0.0
    ],
    [
      "s'escamper",
      0.0
    ],
    [
      "pisser",
      0.0
    ],
    [
      "bannir",
      0.0
    ],
    [
      "defiler",
      0.0
    ],
    [
      "effrayer",
      0.0
    ],
    [
      "hair",
      0.0
    ]
  ],
  "peste": [
    [
      "cholera",
      0.1775
    ],
    [
      "mechant",
      0.1775
    ],
    [
      "lepre",
      0.115
    ],
    [
      "petechie",
      0.0575
    ],
    [
      "poison",
      0.0575
    ],
    [
      "masque",
      0.0575
    ],
    [
      "maladie",
      0.0575
    ],
    [
      "gale",
      0.0575
    ],
    [
      "fleau",
      0.0575
    ],
    [
      "chipie",
      0.0575
    ],
    [
      "epidemie",
      0.0575
    ]
  ],
  "pester": [
    [
      "fulminer",
      0.1075
    ],
    [
      "tempeter",
      0.1075
    ],
    [
      "rouspeter",
      0.09
    ],
    [
      "raler",
      0.09
    ],
    [
      "fumer",
      0.075
    ],
    [
      "protester",
      0.06
    ],
    [
      "vituperer",
      0.06
    ],
    [
      "s'indigner",
      0.045
    ],
    [
      "rager",
      0.045
    ],
    [
      "maugreer",
      0.045
    ],
    [
      "maudire",
      0.045
    ],
    [
      "s'emporter",
      0.03
    ],
    [
      "jurer",
      0.03
    ],
    [
      "grogner",
      0.03
    ],
    [
      "detester",
      0.03
    ],
    [
      "bisquer",
      0.015
    ],
    [
      "deblaterer",
      0.015
    ],
    [
      "exploser",
      0.015
    ],
    [
      "invectiver",
      0.015
    ]
  ],
  "interview": [
    [
      "article",
      0.165
    ],
    [
      "conversation",
      0.165
    ],
    [
      "dialogue",
      0.165
    ],
    [
      "entretien",
      0.165
    ],
    [
      "interrogation",
      0.165
    ],
    [
      "reportage",
      0.165
    ]
  ],
  "verite": [
    [
      "exactitude",
      0.075
    ],
    [
      "sincerite",
      0.0675
    ],
    [
      "foi",
      0.0425
    ],
    [
      "authenticite",
      0.0375
    ],
    [
      "axiome",
      0.0375
    ],
    [
      "justesse",
      0.0375
    ],
    [
      "evidence",
      0.0375
    ],
    [
      "regularite",
      0.03
    ],
    [
      "realite",
      0.03
    ],
    [
      "fidelite",
      0.03
    ],
    [
      "dogme",
      0.03
    ],
    [
      "croyance",
      0.03
    ],
    [
      "propriete",
      0.0225
    ],
    [
      "principe",
      0.0225
    ],
    [
      "nettete",
      0.0225
    ],
    [
      "naturel",
      0.0225
    ],
    [
      "franchise",
      0.0225
    ],
    [
      "certitude",
      0.0225
    ],
    [
      "veridicite",
      0.0175
    ],
    [
      "veracite",
      0.0175
    ],
    [
      "pensee",
      0.0175
    ],
    [
      "parole",
      0.0175
    ],
    [
      "nature",
      0.0175
    ],
    [
      "maxime",
      0.0175
    ],
    [
      "evangile",
      0.01
    ],
    [
      "vrai",
      0.01
    ],
    [
      "valeur",
      0.01
    ],
    [
      "spontaneite",
      0.01
    ],
    [
      "sentence",
      0.01
    ],
    [
      "revelation",
      0.01
    ],
    [
      "reel",
      0.01
    ],
    [
      "loyaute",
      0.01
    ],
    [
      "loi",
      0.01
    ],
    [
      "droiture",
      0.01
    ],
    [
      "bonte",
      0.01
    ],
    [
      "prophetie",
      0.005
    ],
    [
      "ressemblance",
      0.005
    ],
    [
      "sagesse",
      0.005
    ],
    [
      "science",
      0.005
    ],
    [
      "sophisme",
      0.005
    ],
    [
      "theoreme",
      0.005
    ],
    [
      "truisme",
      0.005
    ],
    [
      "verbe",
      0.005
    ],
    [
      "postulat",
      0.005
    ],
    [
      "orthodoxie",
      0.005
    ],
    [
      "oracle",
      0.005
    ],
    [
      "conviction",
      0.005
    ],
    [
      "fait",
      0.005
    ],
    [
      "lapalissade",
      0.005
    ],
    [
      "lucidite",
      0.005
    ],
    [
      "lumiere",
      0.005
    ],
    [
      "mystere",
      0.005
    ],
    [
      "objectivite",
      0.005
    ],
    [
      "vraisemblance",
      0.005
    ]
  ],
  "detester": [
    [
      "abhorrer",
      0.16
    ],
    [
      "abominer",
      0.16
    ],
    [
      "hair",
      0.16
    ],
    [
      "execrer",
      0.1275
    ],
    [
      "maudire",
      0.095
    ],
    [
      "pester",
      0.0625
    ],
    [
      "repugner",
      0.03
    ],
    [
      "reprouver",
      0.03
    ],
    [
      "jurer",
      0.03
    ],
    [
      "vomir",
      0.03
    ]
  ],
  "preserver": [
    [
      "proteger",
      0.14
    ],
    [
      "garder",
      0.0825
    ],
    [
      "garantir",
      0.075
    ],
    [
      "sauver",
      0.065
    ],
    [
      "sauvegarder",
      0.0575
    ],
    [
      "defendre",
      0.05
    ],
    [
      "maintenir",
      0.05
    ],
    [
      "eviter",
      0.04
    ],
    [
      "soustraire",
      0.04
    ],
    [
      "conserver",
      0.0325
    ],
    [
      "parer",
      0.0325
    ],
    [
      "reserver",
      0.0325
    ],
    [
      "veiller",
      0.0325
    ],
    [
      "epargner",
      0.0325
    ],
    [
      "detourner",
      0.025
    ],
    [
      "assurer",
      0.025
    ],
    [
      "arracher",
      0.025
    ],
    [
      "separer",
      0.015
    ],
    [
      "renforcer",
      0.015
    ],
    [
      "remedier",
      0.015
    ],
    [
      "premunir",
      0.015
    ],
    [
      "exempter",
      0.015
    ],
    [
      "chaperonner",
      0.015
    ],
    [
      "abriter",
      0.015
    ],
    [
      "entretenir",
      0.0075
    ],
    [
      "garer",
      0.0075
    ],
    [
      "ouater",
      0.0075
    ],
    [
      "prevenir",
      0.0075
    ],
    [
      "vacciner",
      0.0075
    ]
  ],
  "tel": [
    [
      "semblable",
      0.2725
    ],
    [
      "pareil",
      0.18
    ],
    [
      "assimile",
      0.09
    ],
    [
      "celui",
      0.09
    ],
    [
      "certain",
      0.09
    ],
    [
      "comme",
      0.09
    ],
    [
      "meme",
      0.09
    ],
    [
      "quelqu'un",
      0.09
    ]
  ],
  "ceux": [
    [
      "tel",
      1.0
    ]
  ],
  "couleur": [
    [
      "teinte",
      0.095
    ],
    [
      "apparence",
      0.05
    ],
    [
      "aspect",
      0.05
    ],
    [
      "tournure",
      0.05
    ],
    [
      "coloris",
      0.0425
    ],
    [
      "eclat",
      0.0325
    ],
    [
      "vie",
      0.0325
    ],
    [
      "exterieur",
      0.0325
    ],
    [
      "caractere",
      0.0325
    ],
    [
      "allure",
      0.0325
    ],
    [
      "vivacite",
      0.025
    ],
    [
      "tour",
      0.025
    ],
    [
      "tonalite",
      0.025
    ],
    [
      "relief",
      0.025
    ],
    [
      "pittoresque",
      0.025
    ],
    [
      "physionomie",
      0.025
    ],
    [
      "peinture",
      0.025
    ],
    [
      "coloration",
      0.025
    ],
    [
      "carnation",
      0.025
    ],
    [
      "brillant",
      0.025
    ],
    [
      "vigueur",
      0.015
    ],
    [
      "ton",
      0.015
    ],
    [
      "teinture",
      0.015
    ],
    [
      "pretexte",
      0.015
    ],
    [
      "force",
      0.015
    ],
    [
      "fard",
      0.015
    ],
    [
      "animation",
      0.015
    ],
    [
      "opinion",
      0.0075
    ],
    [
      "pavillon",
      0.0075
    ],
    [
      "pigment",
      0.0075
    ],
    [
      "raison",
      0.0075
    ],
    [
      "teint",
      0.0075
    ],
    [
      "truculence",
      0.0075
    ],
    [
      "visage",
      0.0075
    ],
    [
      "veracite",
      0.0075
    ],
    [
      "nuance",
      0.0075
    ],
    [
      "motif",
      0.0075
    ],
    [
      "bariolage",
      0.0075
    ],
    [
      "colorant",
      0.0075
    ],
    [
      "cote",
      0.0075
    ],
    [
      "drapeau",
      0.0075
    ],
    [
      "enluminure",
      0.0075
    ],
    [
      "figure",
      0.0075
    ],
    [
      "gouache",
      0.0075
    ],
    [
      "etiquette",
      0.0075
    ]
  ],
  "reflechir": [
    [
      "penser",
      0.1125
    ],
    [
      "mediter",
      0.1
    ],
    [
      "etudier",
      0.1
    ],
    [
      "examiner",
      0.0625
    ],
    [
      "considerer",
      0.04
    ],
    [
      "voir",
      0.035
    ],
    [
      "raisonner",
      0.035
    ],
    [
      "peser",
      0.035
    ],
    [
      "murir",
      0.035
    ],
    [
      "deliberer",
      0.035
    ],
    [
      "calculer",
      0.035
    ],
    [
      "approfondir",
      0.0275
    ],
    [
      "chercher",
      0.0275
    ],
    [
      "observer",
      0.02
    ],
    [
      "contempler",
      0.02
    ],
    [
      "speculer",
      0.0125
    ],
    [
      "songer",
      0.0125
    ],
    [
      "repeter",
      0.0125
    ],
    [
      "ruminer",
      0.0125
    ],
    [
      "refleter",
      0.0125
    ],
    [
      "briller",
      0.0125
    ],
    [
      "cogiter",
      0.0125
    ],
    [
      "envisager",
      0.0125
    ],
    [
      "premediter",
      0.0125
    ],
    [
      "penetrer",
      0.0125
    ],
    [
      "s'arreter",
      0.005
    ],
    [
      "rever",
      0.005
    ],
    [
      "reverberer",
      0.005
    ],
    [
      "repercuter",
      0.005
    ],
    [
      "renvoyer",
      0.005
    ],
    [
      "remacher",
      0.005
    ],
    [
      "miroiter",
      0.005
    ],
    [
      "luire",
      0.005
    ],
    [
      "consulter",
      0.005
    ],
    [
      "concentrer",
      0.005
    ]
  ],
  "reflechi": [
    [
      "pose",
      0.1225
    ],
    [
      "sage",
      0.1125
    ],
    [
      "serieux",
      0.09
    ],
    [
      "prudent",
      0.0775
    ],
    [
      "pondere",
      0.0675
    ],
    [
      "raisonnable",
      0.045
    ],
    [
      "circonspect",
      0.045
    ],
    [
      "calme",
      0.045
    ],
    [
      "mur",
      0.0325
    ],
    [
      "pense",
      0.0325
    ],
    [
      "rassis",
      0.0325
    ],
    [
      "etudie",
      0.0225
    ],
    [
      "pese",
      0.0225
    ],
    [
      "meditatif",
      0.0225
    ],
    [
      "mesure",
      0.0225
    ],
    [
      "grave",
      0.0225
    ],
    [
      "delibere",
      0.0225
    ],
    [
      "calcule",
      0.0225
    ],
    [
      "reflexe",
      0.01
    ],
    [
      "recueilli",
      0.01
    ],
    [
      "raisonne",
      0.01
    ],
    [
      "prevoyant",
      0.01
    ],
    [
      "philosophe",
      0.01
    ],
    [
      "muri",
      0.01
    ],
    [
      "methodique",
      0.01
    ],
    [
      "intentionnel",
      0.01
    ],
    [
      "conscient",
      0.01
    ],
    [
      "concentre",
      0.01
    ],
    [
      "avise",
      0.01
    ],
    [
      "vigilant",
      0.01
    ]
  ],
  "parole": [
    [
      "elocution",
      0.0725
    ],
    [
      "pensee",
      0.065
    ],
    [
      "sentence",
      0.055
    ],
    [
      "verbe",
      0.0475
    ],
    [
      "parler",
      0.0475
    ],
    [
      "discours",
      0.0475
    ],
    [
      "expression",
      0.04
    ],
    [
      "mot",
      0.04
    ],
    [
      "propos",
      0.04
    ],
    [
      "voix",
      0.0275
    ],
    [
      "phrase",
      0.0275
    ],
    [
      "langue",
      0.0275
    ],
    [
      "debit",
      0.0225
    ],
    [
      "ton",
      0.0225
    ],
    [
      "verite",
      0.0175
    ],
    [
      "prononciation",
      0.0175
    ],
    [
      "promesse",
      0.0175
    ],
    [
      "phonation",
      0.0175
    ],
    [
      "injure",
      0.0175
    ],
    [
      "foi",
      0.0175
    ],
    [
      "declaration",
      0.0175
    ],
    [
      "assurance",
      0.0175
    ],
    [
      "articulation",
      0.0175
    ],
    [
      "langage",
      0.01
    ],
    [
      "observation",
      0.01
    ],
    [
      "reflexion",
      0.01
    ],
    [
      "terme",
      0.01
    ],
    [
      "eloquence",
      0.01
    ],
    [
      "engagement",
      0.01
    ],
    [
      "dire",
      0.01
    ],
    [
      "dicton",
      0.01
    ],
    [
      "diction",
      0.01
    ],
    [
      "apophtegme",
      0.01
    ],
    [
      "aphorisme",
      0.01
    ],
    [
      "accent",
      0.01
    ],
    [
      "palabre",
      0.005
    ],
    [
      "parabole",
      0.005
    ],
    [
      "pique",
      0.005
    ],
    [
      "proverbe",
      0.005
    ],
    [
      "serment",
      0.005
    ],
    [
      "son",
      0.005
    ],
    [
      "outrage",
      0.005
    ],
    [
      "logos",
      0.005
    ],
    [
      "grossierete",
      0.005
    ],
    [
      "faculte",
      0.005
    ],
    [
      "dit",
      0.005
    ],
    [
      "devise",
      0.005
    ],
    [
      "compliment",
      0.005
    ],
    [
      "circonlocution",
      0.005
    ],
    [
      "vocable",
      0.005
    ]
  ],
  "celle": [
    [
      "tel",
      1.0
    ]
  ],
  "abandonner": [
    [
      "quitter",
      0.09
    ],
    [
      "renoncer",
      0.0625
    ],
    [
      "ceder",
      0.045
    ],
    [
      "partir",
      0.03
    ],
    [
      "rompre",
      0.0275
    ],
    [
      "delaisser",
      0.025
    ],
    [
      "lacher",
      0.0225
    ],
    [
      "donner",
      0.0225
    ],
    [
      "reculer",
      0.0175
    ],
    [
      "laisser",
      0.0175
    ],
    [
      "s'enfuir",
      0.0175
    ],
    [
      "sortir",
      0.015
    ],
    [
      "s'eloigner",
      0.0125
    ],
    [
      "mourir",
      0.0125
    ],
    [
      "cesser",
      0.0125
    ],
    [
      "capituler",
      0.0125
    ],
    [
      "disparaitre",
      0.0125
    ],
    [
      "remettre",
      0.0125
    ],
    [
      "tomber",
      0.0125
    ],
    [
      "negliger",
      0.01
    ],
    [
      "plaquer",
      0.01
    ],
    [
      "oublier",
      0.01
    ],
    [
      "fuir",
      0.01
    ],
    [
      "deposer",
      0.01
    ],
    [
      "caler",
      0.01
    ],
    [
      "abdiquer",
      0.01
    ],
    [
      "rejeter",
      0.0075
    ],
    [
      "interrompre",
      0.0075
    ],
    [
      "flechir",
      0.0075
    ],
    [
      "finir",
      0.0075
    ],
    [
      "deguerpir",
      0.0075
    ],
    [
      "evacuer",
      0.0075
    ],
    [
      "vider",
      0.0075
    ],
    [
      "repousser",
      0.0075
    ],
    [
      "rabattre",
      0.0075
    ],
    [
      "jeter",
      0.0075
    ],
    [
      "deloger",
      0.0075
    ],
    [
      "suspendre",
      0.005
    ],
    [
      "semer",
      0.005
    ],
    [
      "planter",
      0.005
    ],
    [
      "liquider",
      0.005
    ],
    [
      "deserter",
      0.005
    ],
    [
      "balancer",
      0.005
    ],
    [
      "supprimer",
      0.0025
    ],
    [
      "renier",
      0.0025
    ],
    [
      "livrer",
      0.0025
    ],
    [
      "flancher",
      0.0025
    ],
    [
      "abolir",
      0.0025
    ],
    [
      "relacher",
      0.0025
    ],
    [
      "resigner",
      0.0025
    ],
    [
      "resilier",
      0.0025
    ],
    [
      "s'incliner",
      0.0025
    ],
    [
      "sacrifier",
      0.0025
    ],
    [
      "succomber",
      0.0025
    ],
    [
      "poser",
      0.0025
    ],
    [
      "abjurer",
      0.0025
    ],
    [
      "accorder",
      0.0025
    ],
    [
      "aliener",
      0.0025
    ],
    [
      "caner",
      0.0025
    ],
    [
      "demissionner",
      0.0025
    ],
    [
      "demordre",
      0.0025
    ],
    [
      "demenager",
      0.0025
    ],
    [
      "larguer",
      0.0025
    ],
    [
      "releguer",
      0.0
    ],
    [
      "repudier",
      0.0
    ],
    [
      "omettre",
      0.0
    ],
    [
      "leguer",
      0.0
    ],
    [
      "apostasier",
      0.0
    ],
    [
      "bazarder",
      0.0
    ],
    [
      "conceder",
      0.0
    ],
    [
      "confier",
      0.0
    ],
    [
      "detourner",
      0.0
    ],
    [
      "immoler",
      0.0
    ],
    [
      "raccrocher",
      0.0
    ],
    [
      "depouiller",
      0.0
    ],
    [
      "deteler",
      0.0
    ],
    [
      "enterrer",
      0.0
    ],
    [
      "exposer",
      0.0
    ],
    [
      "violer",
      0.0
    ]
  ],
  "enfance": [
    [
      "commencement",
      0.145
    ],
    [
      "seuil",
      0.1175
    ],
    [
      "origine",
      0.0875
    ],
    [
      "ramollissement",
      0.0575
    ],
    [
      "gatisme",
      0.0575
    ],
    [
      "embryon",
      0.0575
    ],
    [
      "debut",
      0.0575
    ],
    [
      "aurore",
      0.0575
    ],
    [
      "ingenuite",
      0.0275
    ],
    [
      "inconscience",
      0.0275
    ],
    [
      "imbecillite",
      0.0275
    ],
    [
      "germe",
      0.0275
    ],
    [
      "fraicheur",
      0.0275
    ],
    [
      "balbutiement",
      0.0275
    ],
    [
      "aube",
      0.0275
    ],
    [
      "adolescence",
      0.0275
    ],
    [
      "senilite",
      0.0275
    ]
  ],
  "somme": [
    [
      "total",
      0.165
    ],
    [
      "fonds",
      0.07
    ],
    [
      "masse",
      0.07
    ],
    [
      "montant",
      0.07
    ],
    [
      "quantite",
      0.07
    ],
    [
      "prix",
      0.045
    ],
    [
      "compte",
      0.045
    ],
    [
      "charge",
      0.045
    ],
    [
      "addition",
      0.045
    ],
    [
      "sommeil",
      0.0225
    ],
    [
      "sommaire",
      0.0225
    ],
    [
      "sieste",
      0.0225
    ],
    [
      "resume",
      0.0225
    ],
    [
      "resultat",
      0.0225
    ],
    [
      "roupillon",
      0.0225
    ],
    [
      "extrait",
      0.0225
    ],
    [
      "ensemble",
      0.0225
    ],
    [
      "encyclopedie",
      0.0225
    ],
    [
      "compendium",
      0.0225
    ],
    [
      "chiffre",
      0.0225
    ],
    [
      "cagnotte",
      0.0225
    ],
    [
      "bat",
      0.0225
    ],
    [
      "argent",
      0.0225
    ],
    [
      "abrege",
      0.0225
    ],
    [
      "volume",
      0.0225
    ]
  ],
  "sommer": [
    [
      "demander",
      0.11
    ],
    [
      "ordonner",
      0.09
    ],
    [
      "commander",
      0.075
    ],
    [
      "enjoindre",
      0.075
    ],
    [
      "requerir",
      0.0625
    ],
    [
      "exiger",
      0.055
    ],
    [
      "revendiquer",
      0.0475
    ],
    [
      "prescrire",
      0.04
    ],
    [
      "imposer",
      0.04
    ],
    [
      "dire",
      0.04
    ],
    [
      "prier",
      0.0325
    ],
    [
      "solliciter",
      0.0325
    ],
    [
      "recommander",
      0.0275
    ],
    [
      "inviter",
      0.0275
    ],
    [
      "contraindre",
      0.0275
    ],
    [
      "avertir",
      0.02
    ],
    [
      "forcer",
      0.02
    ],
    [
      "signifier",
      0.02
    ],
    [
      "surmonter",
      0.0125
    ],
    [
      "obliger",
      0.0125
    ],
    [
      "intimer",
      0.0125
    ],
    [
      "interpeller",
      0.0125
    ],
    [
      "citer",
      0.0125
    ],
    [
      "assigner",
      0.0125
    ],
    [
      "additionner",
      0.005
    ],
    [
      "couronner",
      0.005
    ],
    [
      "decreter",
      0.005
    ],
    [
      "menacer",
      0.005
    ],
    [
      "totaliser",
      0.005
    ]
  ],
  "sombre": [
    [
      "triste",
      0.105
    ],
    [
      "melancolique",
      0.06
    ],
    [
      "obscur",
      0.06
    ],
    [
      "tenebreux",
      0.0575
    ],
    [
      "morne",
      0.0475
    ],
    [
      "sinistre",
      0.04
    ],
    [
      "grave",
      0.0325
    ],
    [
      "morose",
      0.03
    ],
    [
      "chagrin",
      0.03
    ],
    [
      "bilieux",
      0.025
    ],
    [
      "lugubre",
      0.025
    ],
    [
      "maussade",
      0.025
    ],
    [
      "assombri",
      0.02
    ],
    [
      "brumeux",
      0.02
    ],
    [
      "tragique",
      0.015
    ],
    [
      "taciturne",
      0.015
    ],
    [
      "sepulcral",
      0.015
    ],
    [
      "nebuleux",
      0.015
    ],
    [
      "inquietant",
      0.015
    ],
    [
      "voile",
      0.0125
    ],
    [
      "sourd",
      0.0125
    ],
    [
      "soucieux",
      0.0125
    ],
    [
      "noir",
      0.0125
    ],
    [
      "funebre",
      0.0125
    ],
    [
      "fuligineux",
      0.0125
    ],
    [
      "couvert",
      0.0125
    ],
    [
      "cafardeux",
      0.0125
    ],
    [
      "terne",
      0.01
    ],
    [
      "souterrain",
      0.01
    ],
    [
      "profond",
      0.01
    ],
    [
      "pessimiste",
      0.01
    ],
    [
      "inquiet",
      0.01
    ],
    [
      "funeste",
      0.01
    ],
    [
      "dramatique",
      0.01
    ],
    [
      "angoissant",
      0.01
    ],
    [
      "serieux",
      0.0075
    ],
    [
      "bouche",
      0.0075
    ],
    [
      "bas",
      0.0075
    ],
    [
      "atrabilaire",
      0.0075
    ],
    [
      "terrible",
      0.005
    ],
    [
      "opaque",
      0.005
    ],
    [
      "occulte",
      0.005
    ],
    [
      "occulte",
      0.005
    ],
    [
      "nuageux",
      0.005
    ],
    [
      "nostalgique",
      0.005
    ],
    [
      "fonce",
      0.005
    ],
    [
      "charge",
      0.005
    ],
    [
      "amer",
      0.005
    ],
    [
      "ombreux",
      0.0025
    ],
    [
      "orageux",
      0.0025
    ],
    [
      "preoccupant",
      0.0025
    ],
    [
      "rechigne",
      0.0025
    ],
    [
      "rembruni",
      0.0025
    ],
    [
      "obscurite",
      0.0025
    ],
    [
      "noiratre",
      0.0025
    ],
    [
      "menacant",
      0.0025
    ],
    [
      "malheureux",
      0.0025
    ],
    [
      "ineclaire",
      0.0025
    ],
    [
      "entenebre",
      0.0025
    ],
    [
      "deprime",
      0.0025
    ],
    [
      "anxieux",
      0.0025
    ],
    [
      "reveur",
      0.0025
    ]
  ],
  "sombrer": [
    [
      "s'enfoncer",
      0.115
    ],
    [
      "s'abimer",
      0.0775
    ],
    [
      "couler",
      0.07
    ],
    [
      "disparaitre",
      0.0625
    ],
    [
      "s'abandonner",
      0.05
    ],
    [
      "perir",
      0.0375
    ],
    [
      "s'evanouir",
      0.03
    ],
    [
      "s'ecrouler",
      0.03
    ],
    [
      "s'effondrer",
      0.03
    ],
    [
      "s'aneantir",
      0.03
    ],
    [
      "echouer",
      0.025
    ],
    [
      "s'engouffrer",
      0.0175
    ],
    [
      "s'engloutir",
      0.0175
    ],
    [
      "plonger",
      0.0175
    ],
    [
      "chavirer",
      0.0175
    ],
    [
      "etouffer",
      0.01
    ],
    [
      "succomber",
      0.01
    ],
    [
      "s'immerger",
      0.01
    ],
    [
      "s'absorber",
      0.01
    ],
    [
      "pericliter",
      0.01
    ],
    [
      "glisser",
      0.01
    ],
    [
      "craquer",
      0.01
    ],
    [
      "vegeter",
      0.005
    ],
    [
      "verser",
      0.005
    ],
    [
      "sancir",
      0.005
    ],
    [
      "s'enliser",
      0.005
    ],
    [
      "couvrir",
      0.005
    ],
    [
      "assourdir",
      0.005
    ]
  ],
  "implorer": [
    [
      "prier",
      0.1375
    ],
    [
      "supplier",
      0.12
    ],
    [
      "appeler",
      0.1025
    ],
    [
      "demander",
      0.1025
    ],
    [
      "reclamer",
      0.085
    ],
    [
      "solliciter",
      0.0675
    ],
    [
      "adjurer",
      0.05
    ],
    [
      "crier",
      0.05
    ],
    [
      "revendiquer",
      0.05
    ],
    [
      "requerir",
      0.0325
    ],
    [
      "queter",
      0.0325
    ],
    [
      "quemander",
      0.0325
    ],
    [
      "invoquer",
      0.0325
    ],
    [
      "conjurer",
      0.015
    ],
    [
      "embrasser",
      0.015
    ],
    [
      "mendier",
      0.015
    ],
    [
      "pleurer",
      0.015
    ]
  ],
  "implorant": [
    [
      "suppliant",
      1.0
    ]
  ],
  "hou": [],
  "signe": [
    [
      "accepter",
      0.1
    ],
    [
      "attester",
      0.1
    ],
    [
      "authentifier",
      0.1
    ],
    [
      "certifier",
      0.1
    ],
    [
      "viser",
      0.1
    ],
    [
      "traiter",
      0.05
    ],
    [
      "souscrire",
      0.05
    ],
    [
      "s'allier",
      0.05
    ],
    [
      "parapher",
      0.05
    ],
    [
      "marquer",
      0.05
    ],
    [
      "endosser",
      0.05
    ],
    [
      "contresigner",
      0.05
    ],
    [
      "conclure",
      0.05
    ],
    [
      "approuver",
      0.05
    ],
    [
      "emarger",
      0.05
    ]
  ],
  "signer": [
    [
      "accepter",
      0.1
    ],
    [
      "attester",
      0.1
    ],
    [
      "authentifier",
      0.1
    ],
    [
      "certifier",
      0.1
    ],
    [
      "viser",
      0.1
    ],
    [
      "traiter",
      0.05
    ],
    [
      "souscrire",
      0.05
    ],
    [
      "s'allier",
      0.05
    ],
    [
      "parapher",
      0.05
    ],
    [
      "marquer",
      0.05
    ],
    [
      "endosser",
      0.05
    ],
    [
      "contresigner",
      0.05
    ],
    [
      "conclure",
      0.05
    ],
    [
      "approuver",
      0.05
    ],
    [
      "emarger",
      0.05
    ]
  ],
  "evidence": [
    [
      "verite",
      0.2125
    ],
    [
      "certitude",
      0.105
    ],
    [
      "clarte",
      0.105
    ],
    [
      "truisme",
      0.07
    ],
    [
      "nettete",
      0.07
    ],
    [
      "lumiere",
      0.07
    ],
    [
      "lapalissade",
      0.07
    ],
    [
      "preuve",
      0.035
    ],
    [
      "palpabilite",
      0.035
    ],
    [
      "intelligibilite",
      0.035
    ],
    [
      "flagrance",
      0.035
    ],
    [
      "banalite",
      0.035
    ],
    [
      "axiome",
      0.035
    ],
    [
      "authenticite",
      0.035
    ],
    [
      "realite",
      0.035
    ]
  ],
  "perdu": [
    [
      "disparaitre",
      0.045
    ],
    [
      "diminuer",
      0.0425
    ],
    [
      "degrader",
      0.035
    ],
    [
      "ruiner",
      0.03
    ],
    [
      "detruire",
      0.0275
    ],
    [
      "gater",
      0.0275
    ],
    [
      "egarer",
      0.025
    ],
    [
      "s'enfoncer",
      0.02
    ],
    [
      "discrediter",
      0.02
    ],
    [
      "deshonorer",
      0.0175
    ],
    [
      "gacher",
      0.0175
    ],
    [
      "pervertir",
      0.0175
    ],
    [
      "s'eteindre",
      0.015
    ],
    [
      "s'abimer",
      0.015
    ],
    [
      "deprecier",
      0.015
    ],
    [
      "couler",
      0.015
    ],
    [
      "corrompre",
      0.015
    ],
    [
      "s'estomper",
      0.0125
    ],
    [
      "quitter",
      0.0125
    ],
    [
      "detourner",
      0.0125
    ],
    [
      "dissiper",
      0.0125
    ],
    [
      "baisser",
      0.0125
    ],
    [
      "seduire",
      0.01
    ],
    [
      "s'ecrouler",
      0.01
    ],
    [
      "s'aneantir",
      0.01
    ],
    [
      "s'amenuiser",
      0.01
    ],
    [
      "perir",
      0.01
    ],
    [
      "pourrir",
      0.01
    ],
    [
      "nuire",
      0.01
    ],
    [
      "manquer",
      0.01
    ],
    [
      "fuir",
      0.01
    ],
    [
      "fletrir",
      0.01
    ],
    [
      "decroitre",
      0.01
    ],
    [
      "s'affaiblir",
      0.0075
    ],
    [
      "s'effondrer",
      0.0075
    ],
    [
      "torcher",
      0.0075
    ],
    [
      "laisser",
      0.0075
    ],
    [
      "devoyer",
      0.0075
    ],
    [
      "derouter",
      0.0075
    ],
    [
      "depraver",
      0.0075
    ],
    [
      "degenerer",
      0.0075
    ],
    [
      "debaucher",
      0.0075
    ],
    [
      "dilapider",
      0.0075
    ],
    [
      "renoncer",
      0.005
    ],
    [
      "s'appauvrir",
      0.005
    ],
    [
      "s'effacer",
      0.005
    ],
    [
      "maigrir",
      0.005
    ],
    [
      "gaspiller",
      0.005
    ],
    [
      "deconsiderer",
      0.005
    ],
    [
      "demolir",
      0.005
    ],
    [
      "desorienter",
      0.005
    ],
    [
      "devaloriser",
      0.005
    ],
    [
      "expedier",
      0.005
    ],
    [
      "paumer",
      0.0025
    ],
    [
      "rater",
      0.0025
    ],
    [
      "s'atrophier",
      0.0025
    ],
    [
      "s'engloutir",
      0.0025
    ],
    [
      "s'engouffrer",
      0.0025
    ],
    [
      "s'egarer",
      0.0025
    ],
    [
      "echouer",
      0.0025
    ],
    [
      "oublier",
      0.0025
    ],
    [
      "galvauder",
      0.0025
    ],
    [
      "fourvoyer",
      0.0025
    ],
    [
      "aliener",
      0.0025
    ],
    [
      "avarier",
      0.0025
    ],
    [
      "condamner",
      0.0025
    ],
    [
      "demonetiser",
      0.0025
    ],
    [
      "depouiller",
      0.0025
    ],
    [
      "desaxer",
      0.0025
    ],
    [
      "fausser",
      0.0025
    ],
    [
      "flamber",
      0.0025
    ],
    [
      "s'alterer",
      0.0
    ],
    [
      "s'amortir",
      0.0
    ],
    [
      "s'effeuiller",
      0.0
    ],
    [
      "s'etouffer",
      0.0
    ],
    [
      "suinter",
      0.0
    ],
    [
      "echapper",
      0.0
    ],
    [
      "s'aliener",
      0.0
    ],
    [
      "pisser",
      0.0
    ],
    [
      "adirer",
      0.0
    ],
    [
      "damner",
      0.0
    ],
    [
      "disqualifier",
      0.0
    ],
    [
      "decrier",
      0.0
    ],
    [
      "deposer",
      0.0
    ],
    [
      "leser",
      0.0
    ],
    [
      "patauger",
      0.0
    ],
    [
      "etouffer",
      0.0
    ]
  ],
  "chacun": [
    [
      "chaque",
      0.2
    ],
    [
      "personne",
      0.2
    ],
    [
      "tous",
      0.2
    ],
    [
      "tout",
      0.2
    ],
    [
      "un",
      0.2
    ]
  ],
  "profond": [
    [
      "fort",
      0.06
    ],
    [
      "gros",
      0.06
    ],
    [
      "grand",
      0.055
    ],
    [
      "haut",
      0.035
    ],
    [
      "important",
      0.03
    ],
    [
      "obscur",
      0.03
    ],
    [
      "intense",
      0.0225
    ],
    [
      "large",
      0.02
    ],
    [
      "impenetrable",
      0.02
    ],
    [
      "essentiel",
      0.02
    ],
    [
      "vif",
      0.015
    ],
    [
      "serieux",
      0.015
    ],
    [
      "secret",
      0.015
    ],
    [
      "riche",
      0.015
    ],
    [
      "intime",
      0.015
    ],
    [
      "infini",
      0.015
    ],
    [
      "grave",
      0.015
    ],
    [
      "difficile",
      0.015
    ],
    [
      "beau",
      0.015
    ],
    [
      "epais",
      0.0125
    ],
    [
      "enorme",
      0.0125
    ],
    [
      "sombre",
      0.0125
    ],
    [
      "intelligent",
      0.0125
    ],
    [
      "insondable",
      0.0125
    ],
    [
      "immense",
      0.0125
    ],
    [
      "bas",
      0.0125
    ],
    [
      "aigu",
      0.0125
    ],
    [
      "absolu",
      0.0125
    ],
    [
      "retire",
      0.01
    ],
    [
      "savant",
      0.01
    ],
    [
      "severe",
      0.01
    ],
    [
      "vrai",
      0.01
    ],
    [
      "eleve",
      0.01
    ],
    [
      "eloigne",
      0.01
    ],
    [
      "esoterique",
      0.01
    ],
    [
      "etendu",
      0.01
    ],
    [
      "recule",
      0.01
    ],
    [
      "penetrant",
      0.01
    ],
    [
      "approfondi",
      0.01
    ],
    [
      "cale",
      0.01
    ],
    [
      "caverneux",
      0.01
    ],
    [
      "complet",
      0.01
    ],
    [
      "creux",
      0.01
    ],
    [
      "dense",
      0.01
    ],
    [
      "interieur",
      0.01
    ],
    [
      "puissant",
      0.01
    ],
    [
      "perdu",
      0.005
    ],
    [
      "pousse",
      0.005
    ],
    [
      "sepulcral",
      0.005
    ],
    [
      "ecarte",
      0.005
    ],
    [
      "eternel",
      0.005
    ],
    [
      "mysterieux",
      0.005
    ],
    [
      "lucide",
      0.005
    ],
    [
      "foncier",
      0.005
    ],
    [
      "abstrait",
      0.005
    ],
    [
      "abstrus",
      0.005
    ],
    [
      "durable",
      0.005
    ],
    [
      "enfonce",
      0.005
    ],
    [
      "extreme",
      0.005
    ],
    [
      "majeur",
      0.0025
    ],
    [
      "metaphysique",
      0.0025
    ],
    [
      "personnel",
      0.0025
    ],
    [
      "perspicace",
      0.0025
    ],
    [
      "plongeant",
      0.0025
    ],
    [
      "profondeurs",
      0.0025
    ],
    [
      "sagace",
      0.0025
    ],
    [
      "visceral",
      0.0025
    ],
    [
      "vital",
      0.0025
    ],
    [
      "ethere",
      0.0025
    ],
    [
      "lointain",
      0.0025
    ],
    [
      "latent",
      0.0025
    ],
    [
      "ardent",
      0.0025
    ],
    [
      "clairvoyant",
      0.0025
    ],
    [
      "cordial",
      0.0025
    ],
    [
      "encaisse",
      0.0025
    ],
    [
      "entrailles",
      0.0025
    ],
    [
      "extatique",
      0.0025
    ],
    [
      "fonce",
      0.0025
    ],
    [
      "inferieur",
      0.0025
    ],
    [
      "isole",
      0.0025
    ],
    [
      "abyssal",
      0.0025
    ]
  ],
  "ignorer": [
    [
      "mepriser",
      0.22
    ],
    [
      "meconnaitre",
      0.11
    ],
    [
      "rire",
      0.11
    ]
  ],
  "tort": [
    [
      "dommage",
      0.1475
    ],
    [
      "ravage",
      0.0725
    ],
    [
      "atteinte",
      0.065
    ],
    [
      "injure",
      0.0575
    ],
    [
      "prejudice",
      0.0575
    ],
    [
      "degat",
      0.0475
    ],
    [
      "degradation",
      0.04
    ],
    [
      "offense",
      0.04
    ],
    [
      "outrage",
      0.04
    ],
    [
      "perte",
      0.0325
    ],
    [
      "faute",
      0.0325
    ],
    [
      "defaut",
      0.0325
    ],
    [
      "coup",
      0.0325
    ],
    [
      "affront",
      0.0225
    ],
    [
      "demerite",
      0.0225
    ],
    [
      "desavantage",
      0.0225
    ],
    [
      "mal",
      0.0225
    ],
    [
      "travers",
      0.015
    ],
    [
      "manquement",
      0.015
    ],
    [
      "lesion",
      0.015
    ],
    [
      "injustice",
      0.015
    ],
    [
      "deterioration",
      0.015
    ],
    [
      "casse",
      0.015
    ],
    [
      "blessure",
      0.015
    ],
    [
      "ribordage",
      0.0075
    ],
    [
      "grief",
      0.0075
    ],
    [
      "endommagement",
      0.0075
    ],
    [
      "detriment",
      0.0075
    ],
    [
      "depredation",
      0.0075
    ],
    [
      "depreciation",
      0.0075
    ],
    [
      "dam",
      0.0075
    ],
    [
      "culpabilite",
      0.0075
    ],
    [
      "breche",
      0.0075
    ],
    [
      "avanie",
      0.0075
    ],
    [
      "sinistre",
      0.0075
    ]
  ],
  "defier": [
    [
      "braver",
      0.175
    ],
    [
      "attaquer",
      0.1075
    ],
    [
      "provoquer",
      0.1075
    ],
    [
      "affronter",
      0.0875
    ],
    [
      "narguer",
      0.0875
    ],
    [
      "risquer",
      0.065
    ],
    [
      "s'opposer",
      0.0425
    ],
    [
      "s'attaquer",
      0.0425
    ],
    [
      "resister",
      0.0425
    ],
    [
      "menacer",
      0.0425
    ],
    [
      "appeler",
      0.02
    ],
    [
      "challenger",
      0.02
    ],
    [
      "desarmer",
      0.02
    ],
    [
      "inviter",
      0.02
    ],
    [
      "rivaliser",
      0.02
    ]
  ],
  "remordre": [],
  "remords": [
    [
      "regret",
      0.235
    ],
    [
      "repentir",
      0.13
    ],
    [
      "resipiscence",
      0.13
    ],
    [
      "contrition",
      0.0775
    ],
    [
      "penitence",
      0.0525
    ],
    [
      "peine",
      0.0525
    ],
    [
      "desespoir",
      0.0525
    ],
    [
      "componction",
      0.0525
    ],
    [
      "chagrin",
      0.0525
    ],
    [
      "attrition",
      0.025
    ],
    [
      "bourrelement",
      0.025
    ],
    [
      "conscience",
      0.025
    ],
    [
      "honte",
      0.025
    ],
    [
      "repentance",
      0.025
    ],
    [
      "reproche",
      0.025
    ]
  ],
  "regard": [
    [
      "oeil",
      0.19
    ],
    [
      "vue",
      0.19
    ],
    [
      "ouverture",
      0.1425
    ],
    [
      "vision",
      0.0475
    ],
    [
      "soupirail",
      0.0475
    ],
    [
      "prunelle",
      0.0475
    ],
    [
      "oeillade",
      0.0475
    ],
    [
      "lucarne",
      0.0475
    ],
    [
      "comparaison",
      0.0475
    ],
    [
      "yeux",
      0.0475
    ]
  ],
  "tuer": [
    [
      "detruire",
      0.075
    ],
    [
      "abattre",
      0.07
    ],
    [
      "aneantir",
      0.05
    ],
    [
      "ruiner",
      0.0375
    ],
    [
      "executer",
      0.03
    ],
    [
      "supprimer",
      0.03
    ],
    [
      "egorger",
      0.03
    ],
    [
      "epuiser",
      0.0275
    ],
    [
      "fatiguer",
      0.025
    ],
    [
      "demolir",
      0.025
    ],
    [
      "massacrer",
      0.02
    ],
    [
      "ereinter",
      0.02
    ],
    [
      "faucher",
      0.0175
    ],
    [
      "etrangler",
      0.0175
    ],
    [
      "etouffer",
      0.015
    ],
    [
      "liquider",
      0.015
    ],
    [
      "bousiller",
      0.015
    ],
    [
      "assassiner",
      0.015
    ],
    [
      "ecraser",
      0.0125
    ],
    [
      "zigouiller",
      0.0125
    ],
    [
      "fusiller",
      0.0125
    ],
    [
      "exterminer",
      0.0125
    ],
    [
      "descendre",
      0.0125
    ],
    [
      "assommer",
      0.0125
    ],
    [
      "prendre",
      0.01
    ],
    [
      "poignarder",
      0.01
    ],
    [
      "exceder",
      0.01
    ],
    [
      "decimer",
      0.01
    ],
    [
      "decapiter",
      0.01
    ],
    [
      "achever",
      0.01
    ],
    [
      "saigner",
      0.0075
    ],
    [
      "passer",
      0.0075
    ],
    [
      "gacher",
      0.0075
    ],
    [
      "expedier",
      0.0075
    ],
    [
      "nettoyer",
      0.005
    ],
    [
      "peiner",
      0.005
    ],
    [
      "percer",
      0.005
    ],
    [
      "ratiboiser",
      0.005
    ],
    [
      "supplicier",
      0.005
    ],
    [
      "vanner",
      0.005
    ],
    [
      "meurtrir",
      0.005
    ],
    [
      "casser",
      0.005
    ],
    [
      "extenuer",
      0.005
    ],
    [
      "foudroyer",
      0.005
    ],
    [
      "guillotiner",
      0.005
    ],
    [
      "harasser",
      0.005
    ],
    [
      "immoler",
      0.005
    ],
    [
      "occuper",
      0.0025
    ],
    [
      "pendre",
      0.0025
    ],
    [
      "sacrifier",
      0.0025
    ],
    [
      "suriner",
      0.0025
    ],
    [
      "user",
      0.0025
    ],
    [
      "etendre",
      0.0025
    ],
    [
      "occire",
      0.0025
    ],
    [
      "miner",
      0.0025
    ],
    [
      "lapider",
      0.0025
    ],
    [
      "buter",
      0.0025
    ],
    [
      "crever",
      0.0025
    ],
    [
      "desesperer",
      0.0025
    ],
    [
      "emporter",
      0.0025
    ],
    [
      "flinguer",
      0.0025
    ],
    [
      "juguler",
      0.0025
    ],
    [
      "noyer",
      0.0
    ],
    [
      "navrer",
      0.0
    ],
    [
      "moissonner",
      0.0
    ],
    [
      "lyncher",
      0.0
    ],
    [
      "pourfendre",
      0.0
    ],
    [
      "refroidir",
      0.0
    ],
    [
      "servir",
      0.0
    ],
    [
      "steriliser",
      0.0
    ],
    [
      "trucider",
      0.0
    ],
    [
      "echiner",
      0.0
    ],
    [
      "allonger",
      0.0
    ],
    [
      "avoir",
      0.0
    ],
    [
      "chagriner",
      0.0
    ],
    [
      "chouriner",
      0.0
    ],
    [
      "degeler",
      0.0
    ],
    [
      "degringoler",
      0.0
    ],
    [
      "depecher",
      0.0
    ],
    [
      "empoisonner",
      0.0
    ],
    [
      "estourbir",
      0.0
    ],
    [
      "etriper",
      0.0
    ]
  ],
  "quitte": [
    [
      "degage",
      0.2
    ],
    [
      "dispense",
      0.1325
    ],
    [
      "exempt",
      0.1325
    ],
    [
      "exempte",
      0.1325
    ],
    [
      "libre",
      0.065
    ],
    [
      "depetre",
      0.065
    ],
    [
      "delivre",
      0.065
    ],
    [
      "debarrasse",
      0.065
    ],
    [
      "acquitte",
      0.065
    ],
    [
      "libere",
      0.065
    ]
  ],
  "peloter": [
    [
      "caresser",
      0.19
    ],
    [
      "tripoter",
      0.1075
    ],
    [
      "enrouler",
      0.08
    ],
    [
      "manier",
      0.08
    ],
    [
      "frotter",
      0.0525
    ],
    [
      "flatter",
      0.0525
    ],
    [
      "effleurer",
      0.0525
    ],
    [
      "chatouiller",
      0.0525
    ],
    [
      "pelotonner",
      0.025
    ],
    [
      "patiner",
      0.025
    ],
    [
      "papouiller",
      0.025
    ],
    [
      "palper",
      0.025
    ],
    [
      "lutiner",
      0.025
    ],
    [
      "empeloter",
      0.025
    ],
    [
      "courtiser",
      0.025
    ],
    [
      "chiffonner",
      0.025
    ],
    [
      "bobiner",
      0.025
    ],
    [
      "batifoler",
      0.025
    ],
    [
      "amadouer",
      0.025
    ],
    [
      "rouler",
      0.025
    ]
  ],
  "siroter": [
    [
      "boire",
      0.3
    ],
    [
      "buvoter",
      0.2
    ],
    [
      "s'abreuver",
      0.2
    ],
    [
      "deguster",
      0.1
    ],
    [
      "gobeloter",
      0.1
    ],
    [
      "sucer",
      0.1
    ]
  ],
  "cocktail": [
    [
      "lunch",
      0.2
    ],
    [
      "melange",
      0.2
    ],
    [
      "boisson",
      0.1
    ],
    [
      "buffet",
      0.1
    ],
    [
      "collation",
      0.1
    ],
    [
      "macedoine",
      0.1
    ],
    [
      "reception",
      0.1
    ]
  ],
  "mortel": [
    [
      "ennuyeux",
      0.09
    ],
    [
      "funeste",
      0.06
    ],
    [
      "penible",
      0.06
    ],
    [
      "cruel",
      0.04
    ],
    [
      "fatal",
      0.04
    ],
    [
      "sinistre",
      0.04
    ],
    [
      "somnifere",
      0.03
    ],
    [
      "meurtrier",
      0.03
    ],
    [
      "implacable",
      0.03
    ],
    [
      "grave",
      0.03
    ],
    [
      "assommant",
      0.03
    ],
    [
      "pernicieux",
      0.02
    ],
    [
      "personne",
      0.02
    ],
    [
      "sempiternel",
      0.02
    ],
    [
      "sepulcral",
      0.02
    ],
    [
      "tendu",
      0.02
    ],
    [
      "terrestre",
      0.02
    ],
    [
      "tueur",
      0.02
    ],
    [
      "nefaste",
      0.02
    ],
    [
      "lugubre",
      0.02
    ],
    [
      "impitoyable",
      0.02
    ],
    [
      "aigre",
      0.02
    ],
    [
      "cuisant",
      0.02
    ],
    [
      "destructeur",
      0.02
    ],
    [
      "endormant",
      0.02
    ],
    [
      "funebre",
      0.02
    ],
    [
      "homme",
      0.02
    ],
    [
      "humain",
      0.02
    ],
    [
      "macchabee",
      0.01
    ],
    [
      "mortifere",
      0.01
    ],
    [
      "mourant",
      0.01
    ],
    [
      "percant",
      0.01
    ],
    [
      "perissable",
      0.01
    ],
    [
      "soporifique",
      0.01
    ],
    [
      "temporel",
      0.01
    ],
    [
      "letal",
      0.01
    ],
    [
      "long",
      0.01
    ],
    [
      "lassant",
      0.01
    ],
    [
      "irreductible",
      0.01
    ],
    [
      "homicide",
      0.01
    ],
    [
      "foudroyant",
      0.01
    ],
    [
      "extreme",
      0.01
    ],
    [
      "creature",
      0.01
    ],
    [
      "corps",
      0.01
    ],
    [
      "etre",
      0.01
    ]
  ],
  "nique": [
    [
      "grimace",
      1.0
    ]
  ],
  "niquer": [
    [
      "baiser",
      0.5
    ],
    [
      "posseder",
      0.5
    ]
  ],
  "madame": [
    [
      "princesse",
      1.0
    ]
  ],
  "came": [
    [
      "camelote",
      0.25
    ],
    [
      "drogue",
      0.25
    ],
    [
      "dent",
      0.125
    ],
    [
      "marchandise",
      0.125
    ],
    [
      "merde",
      0.125
    ],
    [
      "pacotille",
      0.125
    ]
  ],
  "plonge": [
    [
      "plongee",
      0.5
    ],
    [
      "vaisselle",
      0.5
    ]
  ],
  "plonger": [
    [
      "enfoncer",
      0.09
    ],
    [
      "passer",
      0.075
    ],
    [
      "baigner",
      0.06
    ],
    [
      "sombrer",
      0.045
    ],
    [
      "sauter",
      0.045
    ],
    [
      "penetrer",
      0.045
    ],
    [
      "piquer",
      0.045
    ],
    [
      "noyer",
      0.045
    ],
    [
      "jeter",
      0.045
    ],
    [
      "ensevelir",
      0.045
    ],
    [
      "engloutir",
      0.045
    ],
    [
      "tremper",
      0.03
    ],
    [
      "precipiter",
      0.03
    ],
    [
      "mettre",
      0.03
    ],
    [
      "introduire",
      0.03
    ],
    [
      "immerger",
      0.03
    ],
    [
      "engager",
      0.03
    ],
    [
      "disparaitre",
      0.03
    ],
    [
      "descendre",
      0.03
    ],
    [
      "pocher",
      0.015
    ],
    [
      "fourrer",
      0.015
    ],
    [
      "enfouir",
      0.015
    ],
    [
      "abimer",
      0.015
    ],
    [
      "s'immerger",
      0.015
    ]
  ],
  "noyer": [
    [
      "brun",
      1.0
    ]
  ],
  "imaginer": [
    [
      "penser",
      0.1075
    ],
    [
      "concevoir",
      0.0625
    ],
    [
      "inventer",
      0.0575
    ],
    [
      "voir",
      0.0575
    ],
    [
      "trouver",
      0.0425
    ],
    [
      "croire",
      0.0425
    ],
    [
      "construire",
      0.0375
    ],
    [
      "supposer",
      0.03
    ],
    [
      "juger",
      0.03
    ],
    [
      "forger",
      0.03
    ],
    [
      "composer",
      0.03
    ],
    [
      "prevoir",
      0.025
    ],
    [
      "creer",
      0.025
    ],
    [
      "conjecturer",
      0.025
    ],
    [
      "decouvrir",
      0.0225
    ],
    [
      "soupconner",
      0.0175
    ],
    [
      "songer",
      0.0175
    ],
    [
      "s'attendre",
      0.0175
    ],
    [
      "former",
      0.0175
    ],
    [
      "fabriquer",
      0.0175
    ],
    [
      "deviner",
      0.0175
    ],
    [
      "comprendre",
      0.0175
    ],
    [
      "combiner",
      0.0175
    ],
    [
      "envisager",
      0.0125
    ],
    [
      "admettre",
      0.0125
    ],
    [
      "rever",
      0.01
    ],
    [
      "s'aviser",
      0.01
    ],
    [
      "s'imaginer",
      0.01
    ],
    [
      "evoquer",
      0.01
    ],
    [
      "savoir",
      0.005
    ],
    [
      "feindre",
      0.005
    ],
    [
      "chercher",
      0.005
    ],
    [
      "attendre",
      0.005
    ],
    [
      "pecher",
      0.0025
    ],
    [
      "manigancer",
      0.0025
    ],
    [
      "machiner",
      0.0025
    ],
    [
      "improviser",
      0.0025
    ],
    [
      "gamberger",
      0.0025
    ],
    [
      "figurer",
      0.0025
    ],
    [
      "anticiper",
      0.0025
    ],
    [
      "visualiser",
      0.0025
    ]
  ],
  "fier": [
    [
      "orgueilleux",
      0.07
    ],
    [
      "suffisant",
      0.0575
    ],
    [
      "superbe",
      0.055
    ],
    [
      "arrogant",
      0.0525
    ],
    [
      "fat",
      0.0425
    ],
    [
      "hautain",
      0.0425
    ],
    [
      "vaniteux",
      0.035
    ],
    [
      "pretentieux",
      0.035
    ],
    [
      "beau",
      0.035
    ],
    [
      "dedaigneux",
      0.0275
    ],
    [
      "grand",
      0.0275
    ],
    [
      "outrecuidant",
      0.025
    ],
    [
      "presomptueux",
      0.025
    ],
    [
      "avantageux",
      0.0225
    ],
    [
      "superieur",
      0.0175
    ],
    [
      "rude",
      0.0175
    ],
    [
      "haut",
      0.0175
    ],
    [
      "distant",
      0.0175
    ],
    [
      "courageux",
      0.0175
    ],
    [
      "sauvage",
      0.0125
    ],
    [
      "satisfait",
      0.0125
    ],
    [
      "rogue",
      0.0125
    ],
    [
      "rencheri",
      0.0125
    ],
    [
      "noble",
      0.0125
    ],
    [
      "glorieux",
      0.0125
    ],
    [
      "insolent",
      0.0125
    ],
    [
      "genereux",
      0.0125
    ],
    [
      "fort",
      0.0125
    ],
    [
      "becheur",
      0.0125
    ],
    [
      "intraitable",
      0.01
    ],
    [
      "infatue",
      0.01
    ],
    [
      "inabordable",
      0.01
    ],
    [
      "heureux",
      0.01
    ],
    [
      "hardi",
      0.01
    ],
    [
      "faraud",
      0.01
    ],
    [
      "vain",
      0.005
    ],
    [
      "meprisant",
      0.005
    ],
    [
      "majestueux",
      0.005
    ],
    [
      "indomptable",
      0.005
    ],
    [
      "froid",
      0.005
    ],
    [
      "farouche",
      0.005
    ],
    [
      "fameux",
      0.005
    ],
    [
      "digne",
      0.005
    ],
    [
      "craneur",
      0.005
    ],
    [
      "content",
      0.005
    ],
    [
      "conquerant",
      0.005
    ],
    [
      "altier",
      0.005
    ],
    [
      "sacre",
      0.0025
    ],
    [
      "reserve",
      0.0025
    ],
    [
      "intrepide",
      0.0025
    ],
    [
      "impetueux",
      0.0025
    ],
    [
      "fierot",
      0.0025
    ],
    [
      "entier",
      0.0025
    ],
    [
      "drole",
      0.0025
    ],
    [
      "mechant",
      0.0
    ],
    [
      "inapprivoisable",
      0.0
    ],
    [
      "enfle",
      0.0
    ],
    [
      "crane",
      0.0
    ],
    [
      "comble",
      0.0
    ],
    [
      "barbare",
      0.0
    ],
    [
      "accrete",
      0.0
    ],
    [
      "redoutable",
      0.0
    ]
  ],
  "engueuler": [
    [
      "reprimander",
      0.125
    ],
    [
      "tancer",
      0.125
    ],
    [
      "gronder",
      0.1
    ],
    [
      "sermonner",
      0.1
    ],
    [
      "injurier",
      0.06
    ],
    [
      "gourmander",
      0.06
    ],
    [
      "admonester",
      0.05
    ],
    [
      "attraper",
      0.05
    ],
    [
      "secouer",
      0.0375
    ],
    [
      "quereller",
      0.0375
    ],
    [
      "houspiller",
      0.0375
    ],
    [
      "enlever",
      0.0375
    ],
    [
      "maltraiter",
      0.0225
    ],
    [
      "insulter",
      0.0225
    ],
    [
      "enguirlander",
      0.0225
    ],
    [
      "emballer",
      0.0225
    ],
    [
      "disputer",
      0.0225
    ],
    [
      "agonir",
      0.01
    ],
    [
      "savonner",
      0.01
    ]
  ],
  "evader": [],
  "nostalgique": [
    [
      "morne",
      0.165
    ],
    [
      "melancolique",
      0.165
    ],
    [
      "sombre",
      0.165
    ],
    [
      "triste",
      0.165
    ],
    [
      "cafardeux",
      0.0825
    ],
    [
      "lugubre",
      0.0825
    ],
    [
      "morose",
      0.0825
    ],
    [
      "sinistre",
      0.0825
    ]
  ],
  "gentil": [
    [
      "aimable",
      0.1025
    ],
    [
      "gracieux",
      0.07
    ],
    [
      "bon",
      0.06
    ],
    [
      "joli",
      0.0525
    ],
    [
      "affable",
      0.0475
    ],
    [
      "agreable",
      0.0475
    ],
    [
      "beau",
      0.0475
    ],
    [
      "doux",
      0.045
    ],
    [
      "serviable",
      0.0375
    ],
    [
      "charmant",
      0.0325
    ],
    [
      "bienveillant",
      0.03
    ],
    [
      "delicat",
      0.0275
    ],
    [
      "mignon",
      0.025
    ],
    [
      "obligeant",
      0.0225
    ],
    [
      "complaisant",
      0.0225
    ],
    [
      "prevenant",
      0.02
    ],
    [
      "civil",
      0.0175
    ],
    [
      "coquet",
      0.0175
    ],
    [
      "empresse",
      0.0175
    ],
    [
      "exquis",
      0.015
    ],
    [
      "chic",
      0.015
    ],
    [
      "brave",
      0.015
    ],
    [
      "adorable",
      0.0125
    ],
    [
      "amene",
      0.0125
    ],
    [
      "bonhomme",
      0.01
    ],
    [
      "mignard",
      0.01
    ],
    [
      "plaisant",
      0.01
    ],
    [
      "sympathique",
      0.005
    ],
    [
      "pimpant",
      0.005
    ],
    [
      "mievre",
      0.005
    ],
    [
      "genereux",
      0.005
    ],
    [
      "bath",
      0.005
    ],
    [
      "tendre",
      0.005
    ],
    [
      "sage",
      0.005
    ],
    [
      "petit",
      0.005
    ],
    [
      "paien",
      0.005
    ],
    [
      "mimi",
      0.005
    ],
    [
      "gentillet",
      0.005
    ],
    [
      "croquignolet",
      0.005
    ],
    [
      "charitable",
      0.005
    ],
    [
      "calme",
      0.005
    ],
    [
      "attentionne",
      0.005
    ],
    [
      "affectueux",
      0.005
    ],
    [
      "accort",
      0.005
    ],
    [
      "infidele",
      0.0
    ],
    [
      "mecreant",
      0.0
    ],
    [
      "potable",
      0.0
    ],
    [
      "preux",
      0.0
    ],
    [
      "rondelet",
      0.0
    ],
    [
      "idolatre",
      0.0
    ],
    [
      "goy",
      0.0
    ],
    [
      "gentilhomme",
      0.0
    ],
    [
      "gent",
      0.0
    ],
    [
      "familier",
      0.0
    ],
    [
      "ethnique",
      0.0
    ],
    [
      "amiteux",
      0.0
    ],
    [
      "acceptable",
      0.0
    ],
    [
      "tranquille",
      0.0
    ]
  ],
  "simple": [
    [
      "naif",
      0.0325
    ],
    [
      "bon",
      0.0275
    ],
    [
      "facile",
      0.0275
    ],
    [
      "franc",
      0.0275
    ],
    [
      "grossier",
      0.0275
    ],
    [
      "naturel",
      0.025
    ],
    [
      "niais",
      0.025
    ],
    [
      "pur",
      0.025
    ],
    [
      "ordinaire",
      0.0225
    ],
    [
      "fruste",
      0.02
    ],
    [
      "bete",
      0.0175
    ],
    [
      "sobre",
      0.0175
    ],
    [
      "brut",
      0.0175
    ],
    [
      "rustique",
      0.0175
    ],
    [
      "vrai",
      0.0175
    ],
    [
      "vulgaire",
      0.0175
    ],
    [
      "sommaire",
      0.015
    ],
    [
      "pauvre",
      0.015
    ],
    [
      "modeste",
      0.015
    ],
    [
      "innocent",
      0.015
    ],
    [
      "elementaire",
      0.0125
    ],
    [
      "severe",
      0.0125
    ],
    [
      "spontane",
      0.0125
    ],
    [
      "reduit",
      0.0125
    ],
    [
      "rudimentaire",
      0.0125
    ],
    [
      "primitif",
      0.0125
    ],
    [
      "petit",
      0.0125
    ],
    [
      "familier",
      0.0125
    ],
    [
      "clair",
      0.0125
    ],
    [
      "candide",
      0.0125
    ],
    [
      "sincere",
      0.01
    ],
    [
      "rude",
      0.01
    ],
    [
      "idiot",
      0.01
    ],
    [
      "court",
      0.01
    ],
    [
      "bonhomme",
      0.01
    ],
    [
      "beau",
      0.01
    ],
    [
      "aise",
      0.01
    ],
    [
      "trivial",
      0.0075
    ],
    [
      "limpide",
      0.0075
    ],
    [
      "ingenu",
      0.0075
    ],
    [
      "gros",
      0.0075
    ],
    [
      "faible",
      0.0075
    ],
    [
      "droit",
      0.0075
    ],
    [
      "credule",
      0.0075
    ],
    [
      "bonasse",
      0.0075
    ],
    [
      "austere",
      0.0075
    ],
    [
      "unique",
      0.005
    ],
    [
      "transparent",
      0.005
    ],
    [
      "succinct",
      0.005
    ],
    [
      "seul",
      0.005
    ],
    [
      "rond",
      0.005
    ],
    [
      "paysan",
      0.005
    ],
    [
      "nu",
      0.005
    ],
    [
      "indecomposable",
      0.005
    ],
    [
      "inculte",
      0.005
    ],
    [
      "courant",
      0.005
    ],
    [
      "brave",
      0.005
    ],
    [
      "sec",
      0.005
    ],
    [
      "simplet",
      0.005
    ],
    [
      "simpliste",
      0.005
    ],
    [
      "stupide",
      0.005
    ],
    [
      "uni",
      0.005
    ],
    [
      "uniforme",
      0.005
    ],
    [
      "quelconque",
      0.005
    ],
    [
      "intelligible",
      0.005
    ],
    [
      "accessible",
      0.005
    ],
    [
      "arriere",
      0.005
    ],
    [
      "ascetique",
      0.005
    ],
    [
      "classique",
      0.005
    ],
    [
      "comprehensible",
      0.005
    ],
    [
      "direct",
      0.005
    ],
    [
      "insuffisant",
      0.005
    ],
    [
      "humble",
      0.0025
    ],
    [
      "individuel",
      0.0025
    ],
    [
      "jobard",
      0.0025
    ],
    [
      "primaire",
      0.0025
    ],
    [
      "prosaique",
      0.0025
    ],
    [
      "retenu",
      0.0025
    ],
    [
      "roturier",
      0.0025
    ],
    [
      "herbe",
      0.0025
    ],
    [
      "frugal",
      0.0025
    ],
    [
      "enfantin",
      0.0025
    ],
    [
      "abrege",
      0.0025
    ],
    [
      "agreste",
      0.0025
    ],
    [
      "aromate",
      0.0025
    ],
    [
      "campagnard",
      0.0025
    ],
    [
      "commode",
      0.0025
    ],
    [
      "cretin",
      0.0025
    ],
    [
      "demeure",
      0.0025
    ],
    [
      "depouille",
      0.0025
    ],
    [
      "plante",
      0.0
    ],
    [
      "primesautier",
      0.0
    ],
    [
      "reserve",
      0.0
    ],
    [
      "simplicite",
      0.0
    ],
    [
      "simplifie",
      0.0
    ],
    [
      "single",
      0.0
    ],
    [
      "superstitieux",
      0.0
    ],
    [
      "tempere",
      0.0
    ],
    [
      "un",
      0.0
    ],
    [
      "unitaire",
      0.0
    ],
    [
      "patriarcal",
      0.0
    ],
    [
      "nicodeme",
      0.0
    ],
    [
      "confiant",
      0.0
    ],
    [
      "fada",
      0.0
    ],
    [
      "gille",
      0.0
    ],
    [
      "harmonieux",
      0.0
    ],
    [
      "incomplexe",
      0.0
    ],
    [
      "indivisible",
      0.0
    ],
    [
      "irreductible",
      0.0
    ],
    [
      "lumineux",
      0.0
    ],
    [
      "nicaise",
      0.0
    ],
    [
      "nice",
      0.0
    ]
  ],
  "besoin": [
    [
      "pauvrete",
      0.1025
    ],
    [
      "penurie",
      0.075
    ],
    [
      "misere",
      0.065
    ],
    [
      "denuement",
      0.055
    ],
    [
      "gene",
      0.055
    ],
    [
      "indigence",
      0.055
    ],
    [
      "soif",
      0.045
    ],
    [
      "necessite",
      0.045
    ],
    [
      "desir",
      0.045
    ],
    [
      "disette",
      0.045
    ],
    [
      "appetit",
      0.0375
    ],
    [
      "deche",
      0.0375
    ],
    [
      "envie",
      0.0375
    ],
    [
      "faim",
      0.0375
    ],
    [
      "appetence",
      0.0275
    ],
    [
      "privation",
      0.0275
    ],
    [
      "manque",
      0.0175
    ],
    [
      "exigence",
      0.0175
    ],
    [
      "tentation",
      0.0075
    ],
    [
      "pulsion",
      0.0075
    ],
    [
      "peine",
      0.0075
    ],
    [
      "necessaire",
      0.0075
    ],
    [
      "mesaise",
      0.0075
    ],
    [
      "insatisfaction",
      0.0075
    ],
    [
      "indispensable",
      0.0075
    ],
    [
      "impecuniosite",
      0.0075
    ],
    [
      "gout",
      0.0075
    ],
    [
      "fringale",
      0.0075
    ],
    [
      "finalite",
      0.0075
    ],
    [
      "entretien",
      0.0075
    ],
    [
      "desiderata",
      0.0075
    ],
    [
      "commission",
      0.0075
    ],
    [
      "affaire",
      0.0075
    ],
    [
      "utilite",
      0.0075
    ]
  ],
  "venu": [
    [
      "provenir",
      0.055
    ],
    [
      "sortir",
      0.055
    ],
    [
      "arriver",
      0.0525
    ],
    [
      "decouler",
      0.04
    ],
    [
      "proceder",
      0.04
    ],
    [
      "tomber",
      0.04
    ],
    [
      "naitre",
      0.035
    ],
    [
      "surgir",
      0.0325
    ],
    [
      "suivre",
      0.0325
    ],
    [
      "resulter",
      0.0275
    ],
    [
      "apparaitre",
      0.025
    ],
    [
      "avancer",
      0.025
    ],
    [
      "marcher",
      0.025
    ],
    [
      "emaner",
      0.02
    ],
    [
      "passer",
      0.02
    ],
    [
      "partir",
      0.02
    ],
    [
      "descendre",
      0.02
    ],
    [
      "approcher",
      0.02
    ],
    [
      "survenir",
      0.0175
    ],
    [
      "pousser",
      0.0175
    ],
    [
      "aborder",
      0.0175
    ],
    [
      "reussir",
      0.0125
    ],
    [
      "parvenir",
      0.0125
    ],
    [
      "deriver",
      0.0125
    ],
    [
      "tenir",
      0.01
    ],
    [
      "s'avancer",
      0.01
    ],
    [
      "s'approcher",
      0.01
    ],
    [
      "s'amener",
      0.01
    ],
    [
      "s'abouler",
      0.01
    ],
    [
      "remonter",
      0.01
    ],
    [
      "pointer",
      0.01
    ],
    [
      "entrer",
      0.01
    ],
    [
      "dependre",
      0.01
    ],
    [
      "s'offrir",
      0.005
    ],
    [
      "rappliquer",
      0.005
    ],
    [
      "radiner",
      0.005
    ],
    [
      "grandir",
      0.005
    ],
    [
      "debarquer",
      0.005
    ],
    [
      "croitre",
      0.005
    ],
    [
      "aboutir",
      0.005
    ],
    [
      "succeder",
      0.0025
    ],
    [
      "echoir",
      0.0025
    ],
    [
      "s'aviser",
      0.0025
    ],
    [
      "intervenir",
      0.0025
    ],
    [
      "dater",
      0.0025
    ]
  ],
  "larme": [
    [
      "douleur",
      0.0825
    ],
    [
      "goutte",
      0.0825
    ],
    [
      "emotion",
      0.055
    ],
    [
      "soupcon",
      0.055
    ],
    [
      "souffrance",
      0.055
    ],
    [
      "pleurnichement",
      0.055
    ],
    [
      "pleur",
      0.055
    ],
    [
      "peu",
      0.055
    ],
    [
      "mal",
      0.055
    ],
    [
      "idee",
      0.055
    ],
    [
      "gemissement",
      0.055
    ],
    [
      "attendrissement",
      0.055
    ],
    [
      "pleurnicherie",
      0.0275
    ],
    [
      "perle",
      0.0275
    ],
    [
      "peine",
      0.0275
    ],
    [
      "larmoiement",
      0.0275
    ],
    [
      "humeur",
      0.0275
    ],
    [
      "fil",
      0.0275
    ],
    [
      "eau",
      0.0275
    ],
    [
      "chagrin",
      0.0275
    ],
    [
      "affliction",
      0.0275
    ],
    [
      "sanglot",
      0.0275
    ]
  ],
  "mauvais": [
    [
      "mechant",
      0.05
    ],
    [
      "cruel",
      0.03
    ],
    [
      "affreux",
      0.025
    ],
    [
      "malheureux",
      0.025
    ],
    [
      "terrible",
      0.025
    ],
    [
      "penible",
      0.02
    ],
    [
      "dur",
      0.02
    ],
    [
      "pernicieux",
      0.0175
    ],
    [
      "funeste",
      0.0175
    ],
    [
      "triste",
      0.0175
    ],
    [
      "atroce",
      0.0175
    ],
    [
      "desagreable",
      0.015
    ],
    [
      "nuisible",
      0.015
    ],
    [
      "odieux",
      0.015
    ],
    [
      "epouvantable",
      0.015
    ],
    [
      "nefaste",
      0.015
    ],
    [
      "horrible",
      0.015
    ],
    [
      "dangereux",
      0.015
    ],
    [
      "deplorable",
      0.0125
    ],
    [
      "rude",
      0.0125
    ],
    [
      "insupportable",
      0.0125
    ],
    [
      "facheux",
      0.0125
    ],
    [
      "abominable",
      0.0125
    ],
    [
      "malsain",
      0.0125
    ],
    [
      "sinistre",
      0.01
    ],
    [
      "detestable",
      0.01
    ],
    [
      "pitoyable",
      0.0075
    ],
    [
      "miserable",
      0.0075
    ],
    [
      "inhumain",
      0.0075
    ],
    [
      "grave",
      0.0075
    ],
    [
      "faible",
      0.0075
    ],
    [
      "vilain",
      0.0075
    ],
    [
      "severe",
      0.0075
    ],
    [
      "lamentable",
      0.0075
    ],
    [
      "amer",
      0.0075
    ],
    [
      "malfaisant",
      0.0075
    ],
    [
      "nocif",
      0.0075
    ],
    [
      "pervers",
      0.0075
    ],
    [
      "sale",
      0.005
    ],
    [
      "redoutable",
      0.005
    ],
    [
      "pauvre",
      0.005
    ],
    [
      "mediocre",
      0.005
    ],
    [
      "monstrueux",
      0.005
    ],
    [
      "laid",
      0.005
    ],
    [
      "indigne",
      0.005
    ],
    [
      "feroce",
      0.005
    ],
    [
      "difficile",
      0.005
    ],
    [
      "injuste",
      0.005
    ],
    [
      "fetide",
      0.005
    ],
    [
      "deletere",
      0.005
    ],
    [
      "dommageable",
      0.005
    ],
    [
      "bas",
      0.005
    ],
    [
      "tendu",
      0.005
    ],
    [
      "maudit",
      0.005
    ],
    [
      "insuffisant",
      0.005
    ],
    [
      "infect",
      0.005
    ],
    [
      "affligeant",
      0.005
    ],
    [
      "inquietant",
      0.0025
    ],
    [
      "malin",
      0.0025
    ],
    [
      "minable",
      0.0025
    ],
    [
      "moche",
      0.0025
    ],
    [
      "nauseabond",
      0.0025
    ],
    [
      "pestilentiel",
      0.0025
    ],
    [
      "prejudiciable",
      0.0025
    ],
    [
      "venimeux",
      0.0025
    ],
    [
      "vicieux",
      0.0025
    ],
    [
      "impur",
      0.0025
    ],
    [
      "imparfait",
      0.0025
    ],
    [
      "bourru",
      0.0025
    ],
    [
      "brutal",
      0.0025
    ],
    [
      "corrompu",
      0.0025
    ],
    [
      "diabolique",
      0.0025
    ],
    [
      "effrayant",
      0.0025
    ],
    [
      "execrable",
      0.0025
    ],
    [
      "fatal",
      0.0025
    ],
    [
      "faux",
      0.0025
    ],
    [
      "fichu",
      0.0025
    ],
    [
      "incapable",
      0.0025
    ],
    [
      "incorrect",
      0.0025
    ],
    [
      "malveillant",
      0.0025
    ],
    [
      "malefique",
      0.0025
    ],
    [
      "nul",
      0.0025
    ],
    [
      "perfide",
      0.0025
    ],
    [
      "reveche",
      0.0025
    ],
    [
      "implacable",
      0.0025
    ],
    [
      "immoral",
      0.0025
    ],
    [
      "catastrophique",
      0.0025
    ],
    [
      "contraire",
      0.0025
    ],
    [
      "defavorable",
      0.0025
    ],
    [
      "defectueux",
      0.0025
    ],
    [
      "desastreux",
      0.0025
    ],
    [
      "gate",
      0.0025
    ],
    [
      "hargneux",
      0.0025
    ],
    [
      "virulent",
      0.0025
    ],
    [
      "vache",
      0.0025
    ],
    [
      "pendable",
      0.0025
    ],
    [
      "mephitique",
      0.0025
    ],
    [
      "malade",
      0.0025
    ],
    [
      "foutu",
      0.0025
    ],
    [
      "fautif",
      0.0025
    ],
    [
      "absurde",
      0.0025
    ],
    [
      "chetif",
      0.0025
    ],
    [
      "coupable",
      0.0025
    ],
    [
      "diable",
      0.0025
    ],
    [
      "deficient",
      0.0025
    ],
    [
      "rate",
      0.0
    ],
    [
      "mordant",
      0.0
    ],
    [
      "morbide",
      0.0
    ],
    [
      "massacrant",
      0.0
    ],
    [
      "manque",
      0.0
    ],
    [
      "mal",
      0.0
    ],
    [
      "invivable",
      0.0
    ],
    [
      "inopportun",
      0.0
    ],
    [
      "rogue",
      0.0
    ],
    [
      "rosse",
      0.0
    ],
    [
      "veneneux",
      0.0
    ],
    [
      "serieux",
      0.0
    ],
    [
      "sournois",
      0.0
    ],
    [
      "scelerat",
      0.0
    ],
    [
      "sarcastique",
      0.0
    ],
    [
      "sadique",
      0.0
    ],
    [
      "reprehensible",
      0.0
    ],
    [
      "rebarbatif",
      0.0
    ],
    [
      "informe",
      0.0
    ],
    [
      "inexact",
      0.0
    ],
    [
      "inefficace",
      0.0
    ],
    [
      "critiquable",
      0.0
    ],
    [
      "criminel",
      0.0
    ],
    [
      "caustique",
      0.0
    ],
    [
      "calomnieux",
      0.0
    ],
    [
      "blamable",
      0.0
    ],
    [
      "avarie",
      0.0
    ],
    [
      "agressif",
      0.0
    ],
    [
      "aberrant",
      0.0
    ],
    [
      "douteux",
      0.0
    ],
    [
      "desavantageux",
      0.0
    ],
    [
      "impropre",
      0.0
    ],
    [
      "imbuvable",
      0.0
    ],
    [
      "hostile",
      0.0
    ],
    [
      "haissable",
      0.0
    ],
    [
      "haineux",
      0.0
    ],
    [
      "ferin",
      0.0
    ],
    [
      "fielleux",
      0.0
    ],
    [
      "empoisonne",
      0.0
    ],
    [
      "inferieur",
      0.0
    ],
    [
      "insalubre",
      0.0
    ],
    [
      "inutile",
      0.0
    ],
    [
      "maladroit",
      0.0
    ],
    [
      "malicieux",
      0.0
    ],
    [
      "ringard",
      0.0
    ],
    [
      "saumatre",
      0.0
    ],
    [
      "incompetent",
      0.0
    ],
    [
      "impitoyable",
      0.0
    ],
    [
      "errone",
      0.0
    ],
    [
      "abusif",
      0.0
    ],
    [
      "borgne",
      0.0
    ],
    [
      "damnable",
      0.0
    ],
    [
      "deraisonnable",
      0.0
    ],
    [
      "deshonnete",
      0.0
    ],
    [
      "deshonorant",
      0.0
    ],
    [
      "deteriore",
      0.0
    ],
    [
      "medisant",
      0.0
    ],
    [
      "pessimiste",
      0.0
    ],
    [
      "precaire",
      0.0
    ],
    [
      "roublard",
      0.0
    ],
    [
      "satanique",
      0.0
    ],
    [
      "tarte",
      0.0
    ],
    [
      "teigneux",
      0.0
    ],
    [
      "toxique",
      0.0
    ],
    [
      "malfame",
      0.0
    ],
    [
      "insatisfaisant",
      0.0
    ],
    [
      "cahoteux",
      0.0
    ],
    [
      "contagieux",
      0.0
    ],
    [
      "crapuleux",
      0.0
    ],
    [
      "debile",
      0.0
    ],
    [
      "demoniaque",
      0.0
    ],
    [
      "immangeable",
      0.0
    ],
    [
      "inadequat",
      0.0
    ],
    [
      "inesthetique",
      0.0
    ],
    [
      "use",
      0.0
    ]
  ],
  "souvenir": [
    [
      "memoire",
      0.095
    ],
    [
      "trace",
      0.065
    ],
    [
      "reminiscence",
      0.0525
    ],
    [
      "histoire",
      0.0425
    ],
    [
      "ressouvenir",
      0.0425
    ],
    [
      "evocation",
      0.03
    ],
    [
      "vestige",
      0.03
    ],
    [
      "stigmate",
      0.03
    ],
    [
      "recit",
      0.03
    ],
    [
      "reste",
      0.03
    ],
    [
      "rappel",
      0.03
    ],
    [
      "impression",
      0.03
    ],
    [
      "image",
      0.03
    ],
    [
      "tombeau",
      0.02
    ],
    [
      "souvenance",
      0.02
    ],
    [
      "remembrance",
      0.02
    ],
    [
      "passe",
      0.02
    ],
    [
      "ombre",
      0.02
    ],
    [
      "celebration",
      0.02
    ],
    [
      "commemoration",
      0.02
    ],
    [
      "commentaire",
      0.02
    ],
    [
      "annales",
      0.02
    ],
    [
      "memorial",
      0.01
    ],
    [
      "pensee",
      0.01
    ],
    [
      "plaque",
      0.01
    ],
    [
      "reconnaissance",
      0.01
    ],
    [
      "relique",
      0.01
    ],
    [
      "ressouvenance",
      0.01
    ],
    [
      "recurrence",
      0.01
    ],
    [
      "survivance",
      0.01
    ],
    [
      "tendresse",
      0.01
    ],
    [
      "trophee",
      0.01
    ],
    [
      "temoin",
      0.01
    ],
    [
      "monument",
      0.01
    ],
    [
      "journal",
      0.01
    ],
    [
      "autobiographie",
      0.01
    ],
    [
      "bibelot",
      0.01
    ],
    [
      "cadeau",
      0.01
    ],
    [
      "cendre",
      0.01
    ],
    [
      "chronique",
      0.01
    ],
    [
      "cicatrice",
      0.01
    ],
    [
      "confession",
      0.01
    ],
    [
      "don",
      0.01
    ],
    [
      "essai",
      0.01
    ],
    [
      "anniversaire",
      0.01
    ]
  ],
  "blemir": [
    [
      "blanchir",
      0.2
    ],
    [
      "bleuir",
      0.2
    ],
    [
      "palir",
      0.2
    ],
    [
      "verdir",
      0.2
    ]
  ],
  "sonne": [
    [
      "tinter",
      0.145
    ],
    [
      "carillonner",
      0.0825
    ],
    [
      "corner",
      0.0825
    ],
    [
      "tintinnabuler",
      0.0625
    ],
    [
      "resonner",
      0.0625
    ],
    [
      "frapper",
      0.0625
    ],
    [
      "bourdonner",
      0.0625
    ],
    [
      "souffler",
      0.04
    ],
    [
      "retentir",
      0.04
    ],
    [
      "jouer",
      0.04
    ],
    [
      "avertir",
      0.04
    ],
    [
      "assommer",
      0.04
    ],
    [
      "vanter",
      0.02
    ],
    [
      "sonnailler",
      0.02
    ],
    [
      "proclamer",
      0.02
    ],
    [
      "copter",
      0.02
    ],
    [
      "claironner",
      0.02
    ],
    [
      "battre",
      0.02
    ],
    [
      "arriver",
      0.02
    ],
    [
      "appeler",
      0.02
    ],
    [
      "etourdir",
      0.02
    ]
  ],
  "adieu": [
    [
      "bonsoir",
      0.22
    ],
    [
      "salut",
      0.22
    ],
    [
      "bonjour",
      0.11
    ],
    [
      "renoncement",
      0.11
    ],
    [
      "renonciation",
      0.11
    ]
  ],
  "regret": [
    [
      "remords",
      0.16
    ],
    [
      "repentir",
      0.0875
    ],
    [
      "resipiscence",
      0.0875
    ],
    [
      "chagrin",
      0.07
    ],
    [
      "peine",
      0.07
    ],
    [
      "melancolie",
      0.0525
    ],
    [
      "contrition",
      0.0525
    ],
    [
      "amertume",
      0.0525
    ],
    [
      "penitence",
      0.035
    ],
    [
      "plainte",
      0.035
    ],
    [
      "nostalgie",
      0.035
    ],
    [
      "desespoir",
      0.035
    ],
    [
      "componction",
      0.035
    ],
    [
      "repentance",
      0.015
    ],
    [
      "lamentation",
      0.015
    ],
    [
      "jeremiade",
      0.015
    ],
    [
      "honte",
      0.015
    ],
    [
      "excuse",
      0.015
    ],
    [
      "deception",
      0.015
    ],
    [
      "doleance",
      0.015
    ],
    [
      "attrition",
      0.015
    ],
    [
      "soupir",
      0.015
    ]
  ],
  "sanglot": [
    [
      "gemissement",
      0.25
    ],
    [
      "plainte",
      0.165
    ],
    [
      "pleur",
      0.165
    ],
    [
      "cri",
      0.0825
    ],
    [
      "hoquet",
      0.0825
    ],
    [
      "larme",
      0.0825
    ],
    [
      "soupir",
      0.0825
    ],
    [
      "spasme",
      0.0825
    ]
  ],
  "gemir": [
    [
      "geindre",
      0.1275
    ],
    [
      "crier",
      0.11
    ],
    [
      "reclamer",
      0.055
    ],
    [
      "pleurer",
      0.055
    ],
    [
      "murmurer",
      0.055
    ],
    [
      "beler",
      0.055
    ],
    [
      "recriminer",
      0.035
    ],
    [
      "larmoyer",
      0.035
    ],
    [
      "bruire",
      0.035
    ],
    [
      "appeler",
      0.035
    ],
    [
      "jeremiader",
      0.0175
    ],
    [
      "peiner",
      0.0175
    ],
    [
      "pleurnicher",
      0.0175
    ],
    [
      "reprocher",
      0.0175
    ],
    [
      "ronchonner",
      0.0175
    ],
    [
      "souffrir",
      0.0175
    ]
  ],
  "grace": [
    [
      "delicatesse",
      0.0525
    ],
    [
      "faveur",
      0.05
    ],
    [
      "bonte",
      0.0425
    ],
    [
      "douceur",
      0.0375
    ],
    [
      "agrement",
      0.035
    ],
    [
      "amabilite",
      0.03
    ],
    [
      "beaute",
      0.0275
    ],
    [
      "don",
      0.0275
    ],
    [
      "facilite",
      0.0275
    ],
    [
      "charme",
      0.025
    ],
    [
      "elegance",
      0.0225
    ],
    [
      "aide",
      0.02
    ],
    [
      "avantage",
      0.02
    ],
    [
      "bien",
      0.02
    ],
    [
      "bienfait",
      0.02
    ],
    [
      "galanterie",
      0.02
    ],
    [
      "indulgence",
      0.02
    ],
    [
      "service",
      0.02
    ],
    [
      "gentillesse",
      0.0175
    ],
    [
      "secours",
      0.015
    ],
    [
      "finesse",
      0.015
    ],
    [
      "amitie",
      0.0125
    ],
    [
      "bienveillance",
      0.0125
    ],
    [
      "joliesse",
      0.0125
    ],
    [
      "misericorde",
      0.0125
    ],
    [
      "remise",
      0.01
    ],
    [
      "mollesse",
      0.01
    ],
    [
      "legerete",
      0.01
    ],
    [
      "honneur",
      0.01
    ],
    [
      "esprit",
      0.01
    ],
    [
      "amenite",
      0.01
    ],
    [
      "amour",
      0.01
    ],
    [
      "aisance",
      0.01
    ],
    [
      "affabilite",
      0.01
    ],
    [
      "suavite",
      0.0075
    ],
    [
      "remission",
      0.0075
    ],
    [
      "purete",
      0.0075
    ],
    [
      "privilege",
      0.0075
    ],
    [
      "plaisir",
      0.0075
    ],
    [
      "pardon",
      0.0075
    ],
    [
      "merci",
      0.0075
    ],
    [
      "gout",
      0.0075
    ],
    [
      "coquetterie",
      0.0075
    ],
    [
      "benefice",
      0.0075
    ],
    [
      "benediction",
      0.0075
    ],
    [
      "protection",
      0.005
    ],
    [
      "pitie",
      0.005
    ],
    [
      "harmonie",
      0.005
    ],
    [
      "gracieusete",
      0.005
    ],
    [
      "beau",
      0.005
    ],
    [
      "aumone",
      0.005
    ],
    [
      "absolution",
      0.005
    ],
    [
      "inspiration",
      0.0025
    ],
    [
      "langueur",
      0.0025
    ],
    [
      "ornement",
      0.0025
    ],
    [
      "poesie",
      0.0025
    ],
    [
      "prerogative",
      0.0025
    ],
    [
      "simagree",
      0.0025
    ],
    [
      "subside",
      0.0025
    ],
    [
      "fraicheur",
      0.0025
    ],
    [
      "facon",
      0.0025
    ],
    [
      "exemption",
      0.0025
    ],
    [
      "agilite",
      0.0025
    ],
    [
      "appas",
      0.0025
    ],
    [
      "attrait",
      0.0025
    ],
    [
      "candeur",
      0.0025
    ],
    [
      "divinite",
      0.0025
    ],
    [
      "deesse",
      0.0025
    ],
    [
      "excellence",
      0.0025
    ],
    [
      "minauderie",
      0.0
    ],
    [
      "morbidesse",
      0.0
    ],
    [
      "quartier",
      0.0
    ],
    [
      "remerciement",
      0.0
    ],
    [
      "surnaturel",
      0.0
    ],
    [
      "sursis",
      0.0
    ],
    [
      "volonte",
      0.0
    ],
    [
      "mamours",
      0.0
    ],
    [
      "jolivete",
      0.0
    ],
    [
      "jolite",
      0.0
    ],
    [
      "abolition",
      0.0
    ],
    [
      "air",
      0.0
    ],
    [
      "alanguissement",
      0.0
    ],
    [
      "amnistie",
      0.0
    ],
    [
      "atermoiement",
      0.0
    ],
    [
      "consideration",
      0.0
    ],
    [
      "desinvolture",
      0.0
    ],
    [
      "venuste",
      0.0
    ]
  ],
  "veinard": [
    [
      "chanceux",
      0.355
    ],
    [
      "chancard",
      0.1425
    ],
    [
      "fortune",
      0.1425
    ],
    [
      "heureux",
      0.1425
    ],
    [
      "verni",
      0.1425
    ],
    [
      "bidard",
      0.07
    ]
  ],
  "passage": [
    [
      "chemin",
      0.05
    ],
    [
      "voie",
      0.05
    ],
    [
      "couloir",
      0.0275
    ],
    [
      "defile",
      0.0275
    ],
    [
      "galerie",
      0.0275
    ],
    [
      "passe",
      0.0275
    ],
    [
      "voyage",
      0.0225
    ],
    [
      "transport",
      0.0225
    ],
    [
      "rue",
      0.0225
    ],
    [
      "pas",
      0.0225
    ],
    [
      "conduit",
      0.0225
    ],
    [
      "canal",
      0.0225
    ],
    [
      "trace",
      0.0175
    ],
    [
      "port",
      0.0175
    ],
    [
      "ouverture",
      0.0175
    ],
    [
      "morceau",
      0.0175
    ],
    [
      "moment",
      0.0175
    ],
    [
      "gorge",
      0.0175
    ],
    [
      "fragment",
      0.0175
    ],
    [
      "detroit",
      0.0175
    ],
    [
      "col",
      0.0175
    ],
    [
      "circulation",
      0.0175
    ],
    [
      "avenue",
      0.0175
    ],
    [
      "allee",
      0.0175
    ],
    [
      "sentier",
      0.0125
    ],
    [
      "sejour",
      0.0125
    ],
    [
      "trafic",
      0.0125
    ],
    [
      "ecoulement",
      0.0125
    ],
    [
      "percee",
      0.0125
    ],
    [
      "foulee",
      0.0125
    ],
    [
      "extrait",
      0.0125
    ],
    [
      "corridor",
      0.0125
    ],
    [
      "communication",
      0.0125
    ],
    [
      "chenal",
      0.0125
    ],
    [
      "boyau",
      0.0125
    ],
    [
      "acces",
      0.0125
    ],
    [
      "piste",
      0.0075
    ],
    [
      "saut",
      0.0075
    ],
    [
      "stage",
      0.0075
    ],
    [
      "texte",
      0.0075
    ],
    [
      "traversee",
      0.0075
    ],
    [
      "trouee",
      0.0075
    ],
    [
      "tunnel",
      0.0075
    ],
    [
      "passee",
      0.0075
    ],
    [
      "partie",
      0.0075
    ],
    [
      "artere",
      0.0075
    ],
    [
      "bribe",
      0.0075
    ],
    [
      "breche",
      0.0075
    ],
    [
      "citation",
      0.0075
    ],
    [
      "degagement",
      0.0075
    ],
    [
      "endroit",
      0.0075
    ],
    [
      "page",
      0.0075
    ],
    [
      "lieu",
      0.0025
    ],
    [
      "paragraphe",
      0.0025
    ],
    [
      "passerelle",
      0.0025
    ],
    [
      "paturage",
      0.0025
    ],
    [
      "seuil",
      0.0025
    ],
    [
      "sillage",
      0.0025
    ],
    [
      "strophe",
      0.0025
    ],
    [
      "transit",
      0.0025
    ],
    [
      "transition",
      0.0025
    ],
    [
      "traverse",
      0.0025
    ],
    [
      "venelle",
      0.0025
    ],
    [
      "issue",
      0.0025
    ],
    [
      "gue",
      0.0025
    ],
    [
      "goulet",
      0.0025
    ],
    [
      "alinea",
      0.0025
    ],
    [
      "alteration",
      0.0025
    ],
    [
      "bazar",
      0.0025
    ],
    [
      "billet",
      0.0025
    ],
    [
      "bouffee",
      0.0025
    ],
    [
      "circonstance",
      0.0025
    ],
    [
      "conjoncture",
      0.0025
    ],
    [
      "deplacement",
      0.0025
    ],
    [
      "franchissement",
      0.0025
    ],
    [
      "fuite",
      0.0025
    ],
    [
      "vestibule",
      0.0025
    ]
  ],
  "applaudir": [
    [
      "approuver",
      0.1175
    ],
    [
      "exalter",
      0.1175
    ],
    [
      "vanter",
      0.0875
    ],
    [
      "encourager",
      0.0575
    ],
    [
      "complimenter",
      0.0575
    ],
    [
      "benir",
      0.0575
    ],
    [
      "admirer",
      0.0575
    ],
    [
      "acclamer",
      0.0575
    ],
    [
      "saluer",
      0.0275
    ],
    [
      "s'exclamer",
      0.0275
    ],
    [
      "feliciter",
      0.0275
    ],
    [
      "consentir",
      0.0275
    ],
    [
      "bisser",
      0.0275
    ]
  ],
  "acclamer": [
    [
      "bisser",
      0.2725
    ],
    [
      "applaudir",
      0.18
    ],
    [
      "approuver",
      0.09
    ],
    [
      "crier",
      0.09
    ],
    [
      "nommer",
      0.09
    ],
    [
      "ovationner",
      0.09
    ],
    [
      "rappeler",
      0.09
    ],
    [
      "vanter",
      0.09
    ]
  ],
  "tambour": [
    [
      "assise",
      0.0575
    ],
    [
      "tourniquet",
      0.0575
    ],
    [
      "tour",
      0.0575
    ],
    [
      "timbale",
      0.0575
    ],
    [
      "tarole",
      0.0575
    ],
    [
      "tapin",
      0.0575
    ],
    [
      "tambourinaire",
      0.0575
    ],
    [
      "tambourin",
      0.0575
    ],
    [
      "musicien",
      0.0575
    ],
    [
      "darbouka",
      0.0575
    ],
    [
      "cylindre",
      0.0575
    ],
    [
      "caisse",
      0.0575
    ],
    [
      "batterie",
      0.0575
    ],
    [
      "barillet",
      0.0575
    ],
    [
      "bamboula",
      0.0575
    ],
    [
      "tympan",
      0.0575
    ]
  ],
  "adorer": [
    [
      "venerer",
      0.1075
    ],
    [
      "aimer",
      0.0825
    ],
    [
      "reverer",
      0.0825
    ],
    [
      "honorer",
      0.07
    ],
    [
      "cherir",
      0.0575
    ],
    [
      "glorifier",
      0.045
    ],
    [
      "s'agenouiller",
      0.035
    ],
    [
      "respecter",
      0.035
    ],
    [
      "idolatrer",
      0.035
    ],
    [
      "gouter",
      0.035
    ],
    [
      "encenser",
      0.035
    ],
    [
      "deifier",
      0.035
    ],
    [
      "aduler",
      0.035
    ],
    [
      "admirer",
      0.035
    ],
    [
      "raffoler",
      0.0225
    ],
    [
      "flatter",
      0.0225
    ],
    [
      "flagorner",
      0.0225
    ],
    [
      "benir",
      0.0225
    ],
    [
      "affectionner",
      0.0225
    ],
    [
      "servir",
      0.01
    ],
    [
      "prier",
      0.01
    ],
    [
      "courtiser",
      0.01
    ]
  ],
  "idole": [
    [
      "statue",
      0.25
    ],
    [
      "coqueluche",
      0.125
    ],
    [
      "dieu",
      0.125
    ],
    [
      "deite",
      0.125
    ],
    [
      "figure",
      0.125
    ],
    [
      "fetiche",
      0.125
    ],
    [
      "simulacre",
      0.125
    ]
  ],
  "prosterner": [],
  "ravi": [
    [
      "heureux",
      0.1775
    ],
    [
      "content",
      0.165
    ],
    [
      "radieux",
      0.075
    ],
    [
      "bienheureux",
      0.0625
    ],
    [
      "rejoui",
      0.0625
    ],
    [
      "satisfait",
      0.0625
    ],
    [
      "epanoui",
      0.05
    ],
    [
      "joyeux",
      0.05
    ],
    [
      "enchante",
      0.05
    ],
    [
      "transporte",
      0.025
    ],
    [
      "rayonnant",
      0.025
    ],
    [
      "gai",
      0.025
    ],
    [
      "extasie",
      0.025
    ],
    [
      "comble",
      0.025
    ],
    [
      "charme",
      0.025
    ],
    [
      "beat",
      0.025
    ],
    [
      "aise",
      0.025
    ]
  ],
  "ravir": [
    [
      "enlever",
      0.085
    ],
    [
      "prendre",
      0.085
    ],
    [
      "voler",
      0.06
    ],
    [
      "charmer",
      0.05
    ],
    [
      "soustraire",
      0.0475
    ],
    [
      "exciter",
      0.0475
    ],
    [
      "derober",
      0.0475
    ],
    [
      "transporter",
      0.0425
    ],
    [
      "enchanter",
      0.0325
    ],
    [
      "oter",
      0.0275
    ],
    [
      "enthousiasmer",
      0.0275
    ],
    [
      "seduire",
      0.0225
    ],
    [
      "saisir",
      0.0225
    ],
    [
      "s'approprier",
      0.0225
    ],
    [
      "plaire",
      0.0225
    ],
    [
      "fasciner",
      0.0225
    ],
    [
      "emporter",
      0.0225
    ],
    [
      "emballer",
      0.0225
    ],
    [
      "captiver",
      0.0225
    ],
    [
      "souffler",
      0.0175
    ],
    [
      "retirer",
      0.0175
    ],
    [
      "exalter",
      0.0175
    ],
    [
      "priver",
      0.0125
    ],
    [
      "piller",
      0.0125
    ],
    [
      "enivrer",
      0.0125
    ],
    [
      "cueillir",
      0.0125
    ],
    [
      "confisquer",
      0.0125
    ],
    [
      "emerveiller",
      0.0075
    ],
    [
      "usurper",
      0.0075
    ],
    [
      "subtiliser",
      0.0075
    ],
    [
      "subjuguer",
      0.0075
    ],
    [
      "sevrer",
      0.0075
    ],
    [
      "rejouir",
      0.0075
    ],
    [
      "kidnapper",
      0.0075
    ],
    [
      "frustrer",
      0.0075
    ],
    [
      "emmener",
      0.0075
    ],
    [
      "arracher",
      0.0075
    ],
    [
      "amuser",
      0.0075
    ],
    [
      "ailer",
      0.0025
    ],
    [
      "brigander",
      0.0025
    ],
    [
      "briller",
      0.0025
    ]
  ],
  "panique": [
    [
      "affolement",
      0.1275
    ],
    [
      "epouvante",
      0.075
    ],
    [
      "frayeur",
      0.075
    ],
    [
      "effroi",
      0.075
    ],
    [
      "desordre",
      0.075
    ],
    [
      "agitation",
      0.075
    ],
    [
      "terreur",
      0.05
    ],
    [
      "ruee",
      0.05
    ],
    [
      "precipitation",
      0.05
    ],
    [
      "peur",
      0.05
    ],
    [
      "frousse",
      0.05
    ],
    [
      "deroute",
      0.05
    ],
    [
      "alarme",
      0.05
    ],
    [
      "fuite",
      0.025
    ],
    [
      "horreur",
      0.025
    ]
  ],
  "paniquer": [
    [
      "affoler",
      0.22
    ],
    [
      "agiter",
      0.22
    ],
    [
      "alarmer",
      0.11
    ],
    [
      "angoisser",
      0.11
    ],
    [
      "bouleverser",
      0.11
    ],
    [
      "s'affoler",
      0.11
    ]
  ],
  "calmer": [
    [
      "apaiser",
      0.155
    ],
    [
      "adoucir",
      0.105
    ],
    [
      "soulager",
      0.045
    ],
    [
      "attenuer",
      0.04
    ],
    [
      "consoler",
      0.04
    ],
    [
      "endormir",
      0.0375
    ],
    [
      "diminuer",
      0.0375
    ],
    [
      "arreter",
      0.03
    ],
    [
      "eteindre",
      0.03
    ],
    [
      "assoupir",
      0.025
    ],
    [
      "etouffer",
      0.025
    ],
    [
      "temperer",
      0.0225
    ],
    [
      "rasserener",
      0.0225
    ],
    [
      "moderer",
      0.0225
    ],
    [
      "amortir",
      0.0175
    ],
    [
      "bercer",
      0.0175
    ],
    [
      "reprimer",
      0.015
    ],
    [
      "rassurer",
      0.015
    ],
    [
      "lenifier",
      0.015
    ],
    [
      "flechir",
      0.015
    ],
    [
      "etancher",
      0.01
    ],
    [
      "tranquilliser",
      0.01
    ],
    [
      "satisfaire",
      0.01
    ],
    [
      "mater",
      0.01
    ],
    [
      "insensibiliser",
      0.01
    ],
    [
      "guerir",
      0.01
    ],
    [
      "assouvir",
      0.01
    ],
    [
      "anesthesier",
      0.01
    ],
    [
      "affaiblir",
      0.01
    ],
    [
      "maitriser",
      0.0075
    ],
    [
      "immobiliser",
      0.0075
    ],
    [
      "detendre",
      0.0075
    ],
    [
      "contenter",
      0.0075
    ],
    [
      "cicatriser",
      0.0075
    ],
    [
      "assagir",
      0.0075
    ],
    [
      "amadouer",
      0.0075
    ],
    [
      "panser",
      0.0025
    ],
    [
      "ponderer",
      0.0025
    ],
    [
      "radoucir",
      0.0025
    ],
    [
      "rapaiser",
      0.0025
    ],
    [
      "rassasier",
      0.0025
    ],
    [
      "remedier",
      0.0025
    ],
    [
      "pacifier",
      0.0025
    ],
    [
      "desenerver",
      0.0025
    ],
    [
      "desarmer",
      0.0025
    ],
    [
      "desalterer",
      0.0025
    ],
    [
      "dompter",
      0.0025
    ],
    [
      "charmer",
      0.0025
    ],
    [
      "assourdir",
      0.0025
    ],
    [
      "alleger",
      0.0025
    ],
    [
      "accoiser",
      0.0025
    ],
    [
      "securiser",
      0.0025
    ]
  ],
  "calme": [
    [
      "tranquille",
      0.0475
    ],
    [
      "serenite",
      0.0375
    ],
    [
      "tranquillite",
      0.035
    ],
    [
      "doux",
      0.0325
    ],
    [
      "serein",
      0.0325
    ],
    [
      "paix",
      0.03
    ],
    [
      "sage",
      0.03
    ],
    [
      "flegme",
      0.0275
    ],
    [
      "pose",
      0.0275
    ],
    [
      "placide",
      0.0225
    ],
    [
      "paisible",
      0.0225
    ],
    [
      "impassibilite",
      0.0225
    ],
    [
      "indifference",
      0.02
    ],
    [
      "quietude",
      0.0175
    ],
    [
      "repos",
      0.0175
    ],
    [
      "placidite",
      0.0175
    ],
    [
      "flegmatique",
      0.0175
    ],
    [
      "apaisement",
      0.0175
    ],
    [
      "serieux",
      0.015
    ],
    [
      "impassible",
      0.0125
    ],
    [
      "froideur",
      0.0125
    ],
    [
      "froid",
      0.0125
    ],
    [
      "accalmie",
      0.0125
    ],
    [
      "imperturbable",
      0.01
    ],
    [
      "modere",
      0.01
    ],
    [
      "reserve",
      0.01
    ],
    [
      "pondere",
      0.01
    ],
    [
      "douceur",
      0.01
    ],
    [
      "bonheur",
      0.01
    ],
    [
      "ataraxie",
      0.01
    ],
    [
      "equilibre",
      0.0075
    ],
    [
      "patience",
      0.0075
    ],
    [
      "imperturbabilite",
      0.0075
    ],
    [
      "immobile",
      0.0075
    ],
    [
      "bonace",
      0.0075
    ],
    [
      "beau",
      0.0075
    ],
    [
      "retenue",
      0.005
    ],
    [
      "reflechi",
      0.005
    ],
    [
      "remission",
      0.005
    ],
    [
      "sagesse",
      0.005
    ],
    [
      "securite",
      0.005
    ],
    [
      "tiedeur",
      0.005
    ],
    [
      "retenu",
      0.005
    ],
    [
      "quiet",
      0.005
    ],
    [
      "prudent",
      0.005
    ],
    [
      "beatitude",
      0.005
    ],
    [
      "heureux",
      0.005
    ],
    [
      "insensible",
      0.005
    ],
    [
      "maitrise",
      0.005
    ],
    [
      "philosophe",
      0.005
    ],
    [
      "ponderation",
      0.005
    ],
    [
      "philosophie",
      0.005
    ],
    [
      "rassure",
      0.005
    ],
    [
      "reserve",
      0.005
    ],
    [
      "satisfait",
      0.005
    ],
    [
      "silencieux",
      0.005
    ],
    [
      "patient",
      0.005
    ],
    [
      "pacifique",
      0.005
    ],
    [
      "assoupissement",
      0.005
    ],
    [
      "assurance",
      0.005
    ],
    [
      "beat",
      0.005
    ],
    [
      "detachement",
      0.005
    ],
    [
      "detente",
      0.005
    ],
    [
      "immobilite",
      0.005
    ],
    [
      "nirvana",
      0.0025
    ],
    [
      "ordre",
      0.0025
    ],
    [
      "peinard",
      0.0025
    ],
    [
      "rassis",
      0.0025
    ],
    [
      "rasserene",
      0.0025
    ],
    [
      "sommeil",
      0.0025
    ],
    [
      "soulagement",
      0.0025
    ],
    [
      "stabilite",
      0.0025
    ],
    [
      "tete",
      0.0025
    ],
    [
      "limpide",
      0.0025
    ],
    [
      "insensibilite",
      0.0025
    ],
    [
      "assouvissement",
      0.0025
    ],
    [
      "bercement",
      0.0025
    ],
    [
      "circonspection",
      0.0025
    ],
    [
      "embellie",
      0.0025
    ],
    [
      "gentil",
      0.0025
    ],
    [
      "impavide",
      0.0025
    ],
    [
      "inanime",
      0.0025
    ],
    [
      "inoffensif",
      0.0025
    ],
    [
      "purete",
      0.0
    ],
    [
      "silence",
      0.0
    ],
    [
      "sedation",
      0.0
    ],
    [
      "tiede",
      0.0
    ],
    [
      "uni",
      0.0
    ],
    [
      "lent",
      0.0
    ],
    [
      "extase",
      0.0
    ],
    [
      "detendu",
      0.0
    ],
    [
      "doucet",
      0.0
    ],
    [
      "cool",
      0.0
    ],
    [
      "controle",
      0.0
    ],
    [
      "benin",
      0.0
    ],
    [
      "alcyonien",
      0.0
    ],
    [
      "etale",
      0.0
    ]
  ],
  "vive": [
    [
      "ardent",
      0.0575
    ],
    [
      "violent",
      0.045
    ],
    [
      "fringant",
      0.04
    ],
    [
      "prompt",
      0.0375
    ],
    [
      "aigre",
      0.025
    ],
    [
      "eveille",
      0.025
    ],
    [
      "semillant",
      0.0225
    ],
    [
      "fougueux",
      0.0225
    ],
    [
      "agile",
      0.02
    ],
    [
      "aigu",
      0.02
    ],
    [
      "piquant",
      0.02
    ],
    [
      "turbulent",
      0.02
    ],
    [
      "fort",
      0.02
    ],
    [
      "impetueux",
      0.0175
    ],
    [
      "percant",
      0.0175
    ],
    [
      "rapide",
      0.0175
    ],
    [
      "mordant",
      0.015
    ],
    [
      "alerte",
      0.015
    ],
    [
      "actif",
      0.0125
    ],
    [
      "bouillonnant",
      0.0125
    ],
    [
      "leste",
      0.0125
    ],
    [
      "penetrant",
      0.0125
    ],
    [
      "allegre",
      0.0125
    ],
    [
      "bouillant",
      0.0125
    ],
    [
      "remuant",
      0.0125
    ],
    [
      "apre",
      0.0125
    ],
    [
      "amer",
      0.0125
    ],
    [
      "acerbe",
      0.01
    ],
    [
      "chaud",
      0.01
    ],
    [
      "cuisant",
      0.01
    ],
    [
      "dur",
      0.01
    ],
    [
      "vehement",
      0.01
    ],
    [
      "eclatant",
      0.01
    ],
    [
      "vivant",
      0.01
    ],
    [
      "frenetique",
      0.01
    ],
    [
      "anime",
      0.0075
    ],
    [
      "petillant",
      0.0075
    ],
    [
      "dispos",
      0.0075
    ],
    [
      "intelligent",
      0.0075
    ],
    [
      "leger",
      0.0075
    ],
    [
      "vigoureux",
      0.0075
    ],
    [
      "petulant",
      0.0075
    ],
    [
      "preste",
      0.0075
    ],
    [
      "agressif",
      0.005
    ],
    [
      "brillant",
      0.005
    ],
    [
      "brutal",
      0.005
    ],
    [
      "delie",
      0.005
    ],
    [
      "gaillard",
      0.005
    ],
    [
      "vert",
      0.005
    ],
    [
      "cru",
      0.005
    ],
    [
      "clair",
      0.005
    ],
    [
      "brusque",
      0.005
    ],
    [
      "acere",
      0.005
    ],
    [
      "energique",
      0.005
    ],
    [
      "passionne",
      0.005
    ],
    [
      "ouvert",
      0.005
    ],
    [
      "nerveux",
      0.005
    ],
    [
      "gai",
      0.005
    ],
    [
      "fou",
      0.005
    ],
    [
      "espiegle",
      0.005
    ],
    [
      "chaleureux",
      0.005
    ],
    [
      "caustique",
      0.005
    ],
    [
      "blessant",
      0.005
    ],
    [
      "acide",
      0.005
    ],
    [
      "mobile",
      0.0025
    ],
    [
      "impatient",
      0.0025
    ],
    [
      "guilleret",
      0.0025
    ],
    [
      "emporte",
      0.0025
    ],
    [
      "criard",
      0.0025
    ],
    [
      "vivace",
      0.0025
    ],
    [
      "vite",
      0.0025
    ],
    [
      "tapageur",
      0.0025
    ],
    [
      "spirituel",
      0.0025
    ],
    [
      "profond",
      0.0025
    ],
    [
      "intense",
      0.0025
    ],
    [
      "haut",
      0.0025
    ],
    [
      "habile",
      0.0025
    ],
    [
      "fretillant",
      0.0025
    ],
    [
      "brulant",
      0.0025
    ],
    [
      "colore",
      0.0025
    ],
    [
      "douloureux",
      0.0025
    ],
    [
      "debordant",
      0.0025
    ],
    [
      "delure",
      0.0025
    ],
    [
      "explosif",
      0.0025
    ],
    [
      "zele",
      0.0025
    ],
    [
      "presse",
      0.0025
    ],
    [
      "ingambe",
      0.0025
    ],
    [
      "incisif",
      0.0025
    ],
    [
      "febrile",
      0.0025
    ],
    [
      "expressif",
      0.0025
    ],
    [
      "excessif",
      0.0025
    ],
    [
      "degage",
      0.0025
    ],
    [
      "diable",
      0.0025
    ],
    [
      "allant",
      0.0025
    ],
    [
      "primesautier",
      0.0
    ],
    [
      "sensible",
      0.0
    ],
    [
      "soudain",
      0.0
    ],
    [
      "voyant",
      0.0
    ],
    [
      "etincelant",
      0.0
    ],
    [
      "pointu",
      0.0
    ],
    [
      "juvenile",
      0.0
    ],
    [
      "expeditif",
      0.0
    ],
    [
      "frais",
      0.0
    ],
    [
      "grand",
      0.0
    ],
    [
      "gros",
      0.0
    ],
    [
      "jeune",
      0.0
    ],
    [
      "eperdu",
      0.0
    ],
    [
      "soutenu",
      0.0
    ],
    [
      "saisissant",
      0.0
    ],
    [
      "printanier",
      0.0
    ],
    [
      "noeud",
      0.0
    ],
    [
      "injurieux",
      0.0
    ],
    [
      "franc",
      0.0
    ],
    [
      "exaspere",
      0.0
    ],
    [
      "durable",
      0.0
    ],
    [
      "corrosif",
      0.0
    ],
    [
      "coeur",
      0.0
    ],
    [
      "fond",
      0.0
    ],
    [
      "gueulard",
      0.0
    ],
    [
      "irritant",
      0.0
    ],
    [
      "pimpant",
      0.0
    ],
    [
      "principal",
      0.0
    ],
    [
      "verveux",
      0.0
    ],
    [
      "esche",
      0.0
    ],
    [
      "combustible",
      0.0
    ],
    [
      "combatif",
      0.0
    ],
    [
      "boulevardier",
      0.0
    ],
    [
      "appat",
      0.0
    ],
    [
      "allegro",
      0.0
    ],
    [
      "allegretto",
      0.0
    ],
    [
      "veloce",
      0.0
    ]
  ],
  "vif": [
    [
      "ardent",
      0.0575
    ],
    [
      "violent",
      0.045
    ],
    [
      "fringant",
      0.04
    ],
    [
      "prompt",
      0.0375
    ],
    [
      "aigre",
      0.025
    ],
    [
      "eveille",
      0.025
    ],
    [
      "semillant",
      0.0225
    ],
    [
      "fougueux",
      0.0225
    ],
    [
      "agile",
      0.02
    ],
    [
      "aigu",
      0.02
    ],
    [
      "piquant",
      0.02
    ],
    [
      "turbulent",
      0.02
    ],
    [
      "fort",
      0.02
    ],
    [
      "impetueux",
      0.0175
    ],
    [
      "percant",
      0.0175
    ],
    [
      "rapide",
      0.0175
    ],
    [
      "mordant",
      0.015
    ],
    [
      "alerte",
      0.015
    ],
    [
      "actif",
      0.0125
    ],
    [
      "bouillonnant",
      0.0125
    ],
    [
      "leste",
      0.0125
    ],
    [
      "penetrant",
      0.0125
    ],
    [
      "allegre",
      0.0125
    ],
    [
      "bouillant",
      0.0125
    ],
    [
      "remuant",
      0.0125
    ],
    [
      "apre",
      0.0125
    ],
    [
      "amer",
      0.0125
    ],
    [
      "acerbe",
      0.01
    ],
    [
      "chaud",
      0.01
    ],
    [
      "cuisant",
      0.01
    ],
    [
      "dur",
      0.01
    ],
    [
      "vehement",
      0.01
    ],
    [
      "eclatant",
      0.01
    ],
    [
      "vivant",
      0.01
    ],
    [
      "frenetique",
      0.01
    ],
    [
      "anime",
      0.0075
    ],
    [
      "petillant",
      0.0075
    ],
    [
      "dispos",
      0.0075
    ],
    [
      "intelligent",
      0.0075
    ],
    [
      "leger",
      0.0075
    ],
    [
      "vigoureux",
      0.0075
    ],
    [
      "petulant",
      0.0075
    ],
    [
      "preste",
      0.0075
    ],
    [
      "agressif",
      0.005
    ],
    [
      "brillant",
      0.005
    ],
    [
      "brutal",
      0.005
    ],
    [
      "delie",
      0.005
    ],
    [
      "gaillard",
      0.005
    ],
    [
      "vert",
      0.005
    ],
    [
      "cru",
      0.005
    ],
    [
      "clair",
      0.005
    ],
    [
      "brusque",
      0.005
    ],
    [
      "acere",
      0.005
    ],
    [
      "energique",
      0.005
    ],
    [
      "passionne",
      0.005
    ],
    [
      "ouvert",
      0.005
    ],
    [
      "nerveux",
      0.005
    ],
    [
      "gai",
      0.005
    ],
    [
      "fou",
      0.005
    ],
    [
      "espiegle",
      0.005
    ],
    [
      "chaleureux",
      0.005
    ],
    [
      "caustique",
      0.005
    ],
    [
      "blessant",
      0.005
    ],
    [
      "acide",
      0.005
    ],
    [
      "mobile",
      0.0025
    ],
    [
      "impatient",
      0.0025
    ],
    [
      "guilleret",
      0.0025
    ],
    [
      "emporte",
      0.0025
    ],
    [
      "criard",
      0.0025
    ],
    [
      "vivace",
      0.0025
    ],
    [
      "vite",
      0.0025
    ],
    [
      "tapageur",
      0.0025
    ],
    [
      "spirituel",
      0.0025
    ],
    [
      "profond",
      0.0025
    ],
    [
      "intense",
      0.0025
    ],
    [
      "haut",
      0.0025
    ],
    [
      "habile",
      0.0025
    ],
    [
      "fretillant",
      0.0025
    ],
    [
      "brulant",
      0.0025
    ],
    [
      "colore",
      0.0025
    ],
    [
      "douloureux",
      0.0025
    ],
    [
      "debordant",
      0.0025
    ],
    [
      "delure",
      0.0025
    ],
    [
      "explosif",
      0.0025
    ],
    [
      "zele",
      0.0025
    ],
    [
      "presse",
      0.0025
    ],
    [
      "ingambe",
      0.0025
    ],
    [
      "incisif",
      0.0025
    ],
    [
      "febrile",
      0.0025
    ],
    [
      "expressif",
      0.0025
    ],
    [
      "excessif",
      0.0025
    ],
    [
      "degage",
      0.0025
    ],
    [
      "diable",
      0.0025
    ],
    [
      "allant",
      0.0025
    ],
    [
      "primesautier",
      0.0
    ],
    [
      "sensible",
      0.0
    ],
    [
      "soudain",
      0.0
    ],
    [
      "voyant",
      0.0
    ],
    [
      "etincelant",
      0.0
    ],
    [
      "pointu",
      0.0
    ],
    [
      "juvenile",
      0.0
    ],
    [
      "expeditif",
      0.0
    ],
    [
      "frais",
      0.0
    ],
    [
      "grand",
      0.0
    ],
    [
      "gros",
      0.0
    ],
    [
      "jeune",
      0.0
    ],
    [
      "eperdu",
      0.0
    ],
    [
      "soutenu",
      0.0
    ],
    [
      "saisissant",
      0.0
    ],
    [
      "printanier",
      0.0
    ],
    [
      "noeud",
      0.0
    ],
    [
      "injurieux",
      0.0
    ],
    [
      "franc",
      0.0
    ],
    [
      "exaspere",
      0.0
    ],
    [
      "durable",
      0.0
    ],
    [
      "corrosif",
      0.0
    ],
    [
      "coeur",
      0.0
    ],
    [
      "fond",
      0.0
    ],
    [
      "gueulard",
      0.0
    ],
    [
      "irritant",
      0.0
    ],
    [
      "pimpant",
      0.0
    ],
    [
      "principal",
      0.0
    ],
    [
      "verveux",
      0.0
    ],
    [
      "esche",
      0.0
    ],
    [
      "combustible",
      0.0
    ],
    [
      "combatif",
      0.0
    ],
    [
      "boulevardier",
      0.0
    ],
    [
      "appat",
      0.0
    ],
    [
      "allegro",
      0.0
    ],
    [
      "allegretto",
      0.0
    ],
    [
      "veloce",
      0.0
    ]
  ],
  "spectacle": [
    [
      "feerie",
      0.1275
    ],
    [
      "scene",
      0.09
    ],
    [
      "tableau",
      0.0775
    ],
    [
      "seance",
      0.0625
    ],
    [
      "cirque",
      0.05
    ],
    [
      "exhibition",
      0.05
    ],
    [
      "representation",
      0.05
    ],
    [
      "vue",
      0.0375
    ],
    [
      "piece",
      0.0375
    ],
    [
      "numero",
      0.0375
    ],
    [
      "comedie",
      0.0375
    ],
    [
      "vision",
      0.025
    ],
    [
      "production",
      0.025
    ],
    [
      "fantasmagorie",
      0.025
    ],
    [
      "divertissement",
      0.025
    ],
    [
      "cinema",
      0.025
    ],
    [
      "ballet",
      0.025
    ],
    [
      "site",
      0.01
    ],
    [
      "show",
      0.01
    ],
    [
      "revue",
      0.01
    ],
    [
      "planches",
      0.01
    ],
    [
      "panorama",
      0.01
    ],
    [
      "montre",
      0.01
    ],
    [
      "fantaisie",
      0.01
    ],
    [
      "decor",
      0.01
    ],
    [
      "danse",
      0.01
    ],
    [
      "attraction",
      0.01
    ],
    [
      "aspect",
      0.01
    ],
    [
      "soiree",
      0.01
    ]
  ],
  "bras": [
    [
      "force",
      0.0625
    ],
    [
      "appui",
      0.04
    ],
    [
      "autorite",
      0.04
    ],
    [
      "influence",
      0.04
    ],
    [
      "travail",
      0.03
    ],
    [
      "tige",
      0.03
    ],
    [
      "puissance",
      0.03
    ],
    [
      "pouvoir",
      0.03
    ],
    [
      "manoeuvre",
      0.03
    ],
    [
      "detroit",
      0.03
    ],
    [
      "canal",
      0.03
    ],
    [
      "agent",
      0.03
    ],
    [
      "egide",
      0.02
    ],
    [
      "volonte",
      0.02
    ],
    [
      "soldat",
      0.02
    ],
    [
      "patte",
      0.02
    ],
    [
      "manche",
      0.02
    ],
    [
      "defenseur",
      0.02
    ],
    [
      "decision",
      0.02
    ],
    [
      "courage",
      0.02
    ],
    [
      "baton",
      0.02
    ],
    [
      "aile",
      0.02
    ],
    [
      "aide",
      0.02
    ],
    [
      "instrument",
      0.0075
    ],
    [
      "inflexibilite",
      0.0075
    ],
    [
      "homme",
      0.0075
    ],
    [
      "giron",
      0.0075
    ],
    [
      "defile",
      0.0075
    ],
    [
      "credit",
      0.0075
    ],
    [
      "lagune",
      0.0075
    ],
    [
      "membre",
      0.0075
    ],
    [
      "sein",
      0.0075
    ],
    [
      "torchere",
      0.0075
    ],
    [
      "tortionnaire",
      0.0075
    ],
    [
      "travailleur",
      0.0075
    ],
    [
      "tyrannie",
      0.0075
    ],
    [
      "vengeance",
      0.0075
    ],
    [
      "cordage",
      0.0075
    ],
    [
      "chatiment",
      0.0075
    ],
    [
      "chenal",
      0.0075
    ],
    [
      "accotoir",
      0.0075
    ],
    [
      "accoudoir",
      0.0075
    ],
    [
      "activite",
      0.0075
    ],
    [
      "aileron",
      0.0075
    ],
    [
      "allonge",
      0.0075
    ],
    [
      "bande",
      0.0075
    ],
    [
      "bayou",
      0.0075
    ],
    [
      "biceps",
      0.0075
    ],
    [
      "bielle",
      0.0075
    ],
    [
      "bourreau",
      0.0075
    ],
    [
      "brancard",
      0.0075
    ],
    [
      "branche",
      0.0075
    ],
    [
      "brutalite",
      0.0075
    ],
    [
      "chandelier",
      0.0075
    ],
    [
      "abattis",
      0.0075
    ]
  ],
  "vaincre": [
    [
      "triompher",
      0.1325
    ],
    [
      "ecraser",
      0.06
    ],
    [
      "battre",
      0.0525
    ],
    [
      "abattre",
      0.045
    ],
    [
      "enfoncer",
      0.045
    ],
    [
      "surmonter",
      0.0425
    ],
    [
      "culbuter",
      0.035
    ],
    [
      "gagner",
      0.03
    ],
    [
      "aneantir",
      0.0275
    ],
    [
      "dompter",
      0.0275
    ],
    [
      "conquerir",
      0.0225
    ],
    [
      "forcer",
      0.0225
    ],
    [
      "surpasser",
      0.0225
    ],
    [
      "terrasser",
      0.02
    ],
    [
      "renverser",
      0.02
    ],
    [
      "dominer",
      0.02
    ],
    [
      "accabler",
      0.0175
    ],
    [
      "l'emporter",
      0.0175
    ],
    [
      "maitriser",
      0.0175
    ],
    [
      "reduire",
      0.015
    ],
    [
      "mater",
      0.015
    ],
    [
      "captiver",
      0.015
    ],
    [
      "surclasser",
      0.01
    ],
    [
      "foudroyer",
      0.01
    ],
    [
      "emporter",
      0.01
    ],
    [
      "defaire",
      0.01
    ],
    [
      "disperser",
      0.01
    ],
    [
      "confondre",
      0.01
    ],
    [
      "chasser",
      0.01
    ],
    [
      "bousculer",
      0.01
    ],
    [
      "avoir",
      0.01
    ],
    [
      "etouffer",
      0.0075
    ],
    [
      "rouler",
      0.0075
    ],
    [
      "remporter",
      0.0075
    ],
    [
      "entamer",
      0.0075
    ],
    [
      "convaincre",
      0.0075
    ],
    [
      "eclipser",
      0.005
    ],
    [
      "echarper",
      0.005
    ],
    [
      "passer",
      0.005
    ],
    [
      "lasser",
      0.005
    ],
    [
      "franchir",
      0.005
    ],
    [
      "entailler",
      0.005
    ],
    [
      "endormir",
      0.005
    ],
    [
      "capter",
      0.005
    ],
    [
      "negocier",
      0.0025
    ],
    [
      "persuader",
      0.0025
    ],
    [
      "prevaloir",
      0.0025
    ],
    [
      "rosser",
      0.0025
    ],
    [
      "flechir",
      0.0025
    ],
    [
      "deconfire",
      0.0025
    ],
    [
      "controler",
      0.0025
    ],
    [
      "brosser",
      0.0025
    ],
    [
      "brider",
      0.0025
    ],
    [
      "brasser",
      0.0025
    ]
  ],
  "vaincu": [
    [
      "triompher",
      0.1325
    ],
    [
      "ecraser",
      0.06
    ],
    [
      "battre",
      0.0525
    ],
    [
      "abattre",
      0.045
    ],
    [
      "enfoncer",
      0.045
    ],
    [
      "surmonter",
      0.0425
    ],
    [
      "culbuter",
      0.035
    ],
    [
      "gagner",
      0.03
    ],
    [
      "aneantir",
      0.0275
    ],
    [
      "dompter",
      0.0275
    ],
    [
      "conquerir",
      0.0225
    ],
    [
      "forcer",
      0.0225
    ],
    [
      "surpasser",
      0.0225
    ],
    [
      "terrasser",
      0.02
    ],
    [
      "renverser",
      0.02
    ],
    [
      "dominer",
      0.02
    ],
    [
      "accabler",
      0.0175
    ],
    [
      "l'emporter",
      0.0175
    ],
    [
      "maitriser",
      0.0175
    ],
    [
      "reduire",
      0.015
    ],
    [
      "mater",
      0.015
    ],
    [
      "captiver",
      0.015
    ],
    [
      "surclasser",
      0.01
    ],
    [
      "foudroyer",
      0.01
    ],
    [
      "emporter",
      0.01
    ],
    [
      "defaire",
      0.01
    ],
    [
      "disperser",
      0.01
    ],
    [
      "confondre",
      0.01
    ],
    [
      "chasser",
      0.01
    ],
    [
      "bousculer",
      0.01
    ],
    [
      "avoir",
      0.01
    ],
    [
      "etouffer",
      0.0075
    ],
    [
      "rouler",
      0.0075
    ],
    [
      "remporter",
      0.0075
    ],
    [
      "entamer",
      0.0075
    ],
    [
      "convaincre",
      0.0075
    ],
    [
      "eclipser",
      0.005
    ],
    [
      "echarper",
      0.005
    ],
    [
      "passer",
      0.005
    ],
    [
      "lasser",
      0.005
    ],
    [
      "franchir",
      0.005
    ],
    [
      "entailler",
      0.005
    ],
    [
      "endormir",
      0.005
    ],
    [
      "capter",
      0.005
    ],
    [
      "negocier",
      0.0025
    ],
    [
      "persuader",
      0.0025
    ],
    [
      "prevaloir",
      0.0025
    ],
    [
      "rosser",
      0.0025
    ],
    [
      "flechir",
      0.0025
    ],
    [
      "deconfire",
      0.0025
    ],
    [
      "controler",
      0.0025
    ],
    [
      "brosser",
      0.0025
    ],
    [
      "brider",
      0.0025
    ],
    [
      "brasser",
      0.0025
    ]
  ],
  "armee": [
    [
      "munir",
      0.1
    ],
    [
      "proteger",
      0.1
    ],
    [
      "equiper",
      0.1
    ],
    [
      "renforcer",
      0.0825
    ],
    [
      "fortifier",
      0.065
    ],
    [
      "exciter",
      0.065
    ],
    [
      "cuirasser",
      0.0475
    ],
    [
      "pourvoir",
      0.0475
    ],
    [
      "soutenir",
      0.0325
    ],
    [
      "soulever",
      0.0325
    ],
    [
      "irriter",
      0.0325
    ],
    [
      "fournir",
      0.0325
    ],
    [
      "endurcir",
      0.0325
    ],
    [
      "dechainer",
      0.0325
    ],
    [
      "opposer",
      0.015
    ],
    [
      "nantir",
      0.015
    ],
    [
      "lever",
      0.015
    ],
    [
      "herisser",
      0.015
    ],
    [
      "greer",
      0.015
    ],
    [
      "freter",
      0.015
    ],
    [
      "doter",
      0.015
    ],
    [
      "barder",
      0.015
    ],
    [
      "animer",
      0.015
    ],
    [
      "adouber",
      0.015
    ],
    [
      "premunir",
      0.015
    ]
  ],
  "epee": [
    [
      "poignard",
      0.09
    ],
    [
      "cimeterre",
      0.065
    ],
    [
      "flamberge",
      0.065
    ],
    [
      "sabre",
      0.0425
    ],
    [
      "rapiere",
      0.0425
    ],
    [
      "lame",
      0.0425
    ],
    [
      "dague",
      0.0425
    ],
    [
      "espadon",
      0.02
    ],
    [
      "estoc",
      0.02
    ],
    [
      "estocade",
      0.02
    ],
    [
      "estramacon",
      0.02
    ],
    [
      "fer",
      0.02
    ],
    [
      "flambe",
      0.02
    ],
    [
      "fleuret",
      0.02
    ],
    [
      "glaive",
      0.02
    ],
    [
      "latte",
      0.02
    ],
    [
      "palache",
      0.02
    ],
    [
      "plommee",
      0.02
    ],
    [
      "rondelle",
      0.02
    ],
    [
      "spathe",
      0.02
    ],
    [
      "croisette",
      0.02
    ],
    [
      "coutille",
      0.02
    ],
    [
      "alfange",
      0.02
    ],
    [
      "badelaire",
      0.02
    ],
    [
      "bancal",
      0.02
    ],
    [
      "brand",
      0.02
    ],
    [
      "braquemart",
      0.02
    ],
    [
      "brette",
      0.02
    ],
    [
      "briquet",
      0.02
    ],
    [
      "carrelet",
      0.02
    ],
    [
      "claymore",
      0.02
    ],
    [
      "colichemarde",
      0.02
    ],
    [
      "coutelas",
      0.02
    ],
    [
      "yatagan",
      0.02
    ]
  ],
  "terreur": [
    [
      "bandit",
      0.0975
    ],
    [
      "frayeur",
      0.07
    ],
    [
      "brigand",
      0.0625
    ],
    [
      "peur",
      0.0625
    ],
    [
      "effroi",
      0.055
    ],
    [
      "epouvante",
      0.055
    ],
    [
      "fripouille",
      0.0475
    ],
    [
      "frousse",
      0.04
    ],
    [
      "malfaiteur",
      0.04
    ],
    [
      "vaurien",
      0.04
    ],
    [
      "voleur",
      0.04
    ],
    [
      "horreur",
      0.0275
    ],
    [
      "alarme",
      0.0275
    ],
    [
      "chenapan",
      0.02
    ],
    [
      "crainte",
      0.02
    ],
    [
      "forban",
      0.02
    ],
    [
      "inquietude",
      0.02
    ],
    [
      "gangster",
      0.0125
    ],
    [
      "panique",
      0.0125
    ],
    [
      "phobie",
      0.0125
    ],
    [
      "voyou",
      0.0125
    ],
    [
      "criminel",
      0.0125
    ],
    [
      "consternation",
      0.0125
    ],
    [
      "apache",
      0.0125
    ],
    [
      "angoisse",
      0.0125
    ],
    [
      "affres",
      0.0125
    ],
    [
      "affolement",
      0.0125
    ],
    [
      "pirate",
      0.005
    ],
    [
      "sacripant",
      0.005
    ],
    [
      "terrorisme",
      0.005
    ],
    [
      "epouvantement",
      0.005
    ],
    [
      "malandrin",
      0.005
    ],
    [
      "lachete",
      0.005
    ],
    [
      "escarpe",
      0.005
    ],
    [
      "assassin",
      0.005
    ],
    [
      "apprehension",
      0.005
    ],
    [
      "etonnement",
      0.005
    ]
  ],
  "ennemi": [
    [
      "adversaire",
      0.1125
    ],
    [
      "contraire",
      0.1125
    ],
    [
      "oppose",
      0.1125
    ],
    [
      "nuisible",
      0.075
    ],
    [
      "defavorable",
      0.075
    ],
    [
      "antagoniste",
      0.075
    ],
    [
      "hostile",
      0.055
    ],
    [
      "nefaste",
      0.055
    ],
    [
      "pernicieux",
      0.055
    ],
    [
      "rival",
      0.035
    ],
    [
      "opposant",
      0.035
    ],
    [
      "malefique",
      0.035
    ],
    [
      "adverse",
      0.035
    ],
    [
      "belligerant",
      0.0175
    ],
    [
      "concurrent",
      0.0175
    ],
    [
      "detracteur",
      0.0175
    ],
    [
      "irreconciliable",
      0.0175
    ],
    [
      "mal",
      0.0175
    ],
    [
      "malfaisant",
      0.0175
    ]
  ],
  "cent": [
    [
      "centaine",
      0.3325
    ],
    [
      "hecto",
      0.3325
    ],
    [
      "pourcentage",
      0.3325
    ]
  ],
  "trois": [
    [
      "ternaire",
      0.3325
    ],
    [
      "trio",
      0.3325
    ],
    [
      "triple",
      0.3325
    ]
  ],
  "chameau": [
    [
      "rosse",
      0.285
    ],
    [
      "carne",
      0.1425
    ],
    [
      "megere",
      0.1425
    ],
    [
      "vache",
      0.1425
    ],
    [
      "harpie",
      0.07
    ],
    [
      "mechant",
      0.07
    ],
    [
      "ponton",
      0.07
    ]
  ],
  "mignon": [
    [
      "joli",
      0.165
    ],
    [
      "gentil",
      0.125
    ],
    [
      "beau",
      0.075
    ],
    [
      "biquet",
      0.075
    ],
    [
      "gracieux",
      0.05
    ],
    [
      "petit",
      0.0375
    ],
    [
      "mimi",
      0.0375
    ],
    [
      "giton",
      0.0375
    ],
    [
      "charmant",
      0.0375
    ],
    [
      "adorable",
      0.0375
    ],
    [
      "mignard",
      0.025
    ],
    [
      "joliet",
      0.025
    ],
    [
      "gentillet",
      0.025
    ],
    [
      "delicat",
      0.025
    ],
    [
      "croquignolet",
      0.025
    ],
    [
      "coquet",
      0.025
    ],
    [
      "cheri",
      0.025
    ],
    [
      "chou",
      0.025
    ],
    [
      "bellot",
      0.025
    ],
    [
      "homosexuel",
      0.01
    ],
    [
      "girond",
      0.01
    ],
    [
      "ganymede",
      0.01
    ],
    [
      "favori",
      0.01
    ],
    [
      "chouchou",
      0.01
    ],
    [
      "bardache",
      0.01
    ],
    [
      "prefere",
      0.01
    ]
  ],
  "caravane": [
    [
      "bande",
      0.125
    ],
    [
      "groupe",
      0.125
    ],
    [
      "troupe",
      0.125
    ],
    [
      "roulotte",
      0.06
    ],
    [
      "remorque",
      0.06
    ],
    [
      "khan",
      0.06
    ],
    [
      "file",
      0.06
    ],
    [
      "convoi",
      0.06
    ],
    [
      "compagnie",
      0.06
    ],
    [
      "cohorte",
      0.06
    ],
    [
      "caravanserail",
      0.06
    ],
    [
      "smala",
      0.06
    ]
  ],
  "paon": [
    [
      "pedant",
      0.25
    ],
    [
      "vaniteux",
      0.25
    ],
    [
      "bete",
      0.125
    ],
    [
      "orgueilleux",
      0.125
    ],
    [
      "superbe",
      0.125
    ]
  ],
  "plumer": [
    [
      "plumarder",
      0.3325
    ]
  ],
  "plume": [
    [
      "style",
      0.0825
    ],
    [
      "ecriture",
      0.055
    ],
    [
      "ton",
      0.055
    ],
    [
      "plumet",
      0.055
    ],
    [
      "penne",
      0.055
    ],
    [
      "panache",
      0.055
    ],
    [
      "maniere",
      0.055
    ],
    [
      "genre",
      0.055
    ],
    [
      "aigrette",
      0.055
    ],
    [
      "plumage",
      0.0275
    ],
    [
      "plumard",
      0.0275
    ],
    [
      "rectrice",
      0.0275
    ],
    [
      "remige",
      0.0275
    ],
    [
      "tectrice",
      0.0275
    ],
    [
      "touffe",
      0.0275
    ],
    [
      "ecrit",
      0.0275
    ],
    [
      "pennage",
      0.0275
    ],
    [
      "patte",
      0.0275
    ],
    [
      "marque",
      0.0275
    ],
    [
      "marabout",
      0.0275
    ],
    [
      "main",
      0.0275
    ],
    [
      "lit",
      0.0275
    ],
    [
      "duvet",
      0.0275
    ],
    [
      "casoar",
      0.0275
    ],
    [
      "auteur",
      0.0275
    ],
    [
      "ecrivain",
      0.0275
    ]
  ],
  "gorille": [
    [
      "anthropoide",
      0.285
    ],
    [
      "primate",
      0.1425
    ],
    [
      "singe",
      0.1425
    ]
  ],
  "proteger": [
    [
      "appuyer",
      0.06
    ],
    [
      "defendre",
      0.06
    ],
    [
      "preserver",
      0.0575
    ],
    [
      "soutenir",
      0.0575
    ],
    [
      "garantir",
      0.0525
    ],
    [
      "renforcer",
      0.04
    ],
    [
      "fortifier",
      0.0325
    ],
    [
      "assurer",
      0.0325
    ],
    [
      "aider",
      0.0325
    ],
    [
      "couvrir",
      0.03
    ],
    [
      "epauler",
      0.03
    ],
    [
      "favoriser",
      0.025
    ],
    [
      "garder",
      0.025
    ],
    [
      "sauvegarder",
      0.0225
    ],
    [
      "pistonner",
      0.0225
    ],
    [
      "maintenir",
      0.0225
    ],
    [
      "armer",
      0.02
    ],
    [
      "encourager",
      0.02
    ],
    [
      "pousser",
      0.02
    ],
    [
      "veiller",
      0.015
    ],
    [
      "servir",
      0.015
    ],
    [
      "patronner",
      0.015
    ],
    [
      "chaperonner",
      0.015
    ],
    [
      "assister",
      0.015
    ],
    [
      "accompagner",
      0.0125
    ],
    [
      "cuirasser",
      0.0125
    ],
    [
      "sauver",
      0.0125
    ],
    [
      "secourir",
      0.01
    ],
    [
      "reserver",
      0.01
    ],
    [
      "premunir",
      0.01
    ],
    [
      "parrainer",
      0.01
    ],
    [
      "parer",
      0.01
    ],
    [
      "escorter",
      0.01
    ],
    [
      "blinder",
      0.01
    ],
    [
      "affermir",
      0.01
    ],
    [
      "abriter",
      0.01
    ],
    [
      "separer",
      0.005
    ],
    [
      "soustraire",
      0.005
    ],
    [
      "retrancher",
      0.005
    ],
    [
      "recommander",
      0.005
    ],
    [
      "promouvoir",
      0.005
    ],
    [
      "munir",
      0.005
    ],
    [
      "immuniser",
      0.005
    ],
    [
      "flanquer",
      0.005
    ],
    [
      "conserver",
      0.005
    ],
    [
      "barder",
      0.005
    ],
    [
      "precautionner",
      0.0025
    ],
    [
      "predestiner",
      0.0025
    ],
    [
      "restaurer",
      0.0025
    ],
    [
      "vernir",
      0.0025
    ],
    [
      "ouater",
      0.0025
    ],
    [
      "ombrager",
      0.0025
    ],
    [
      "ferrer",
      0.0025
    ],
    [
      "defiler",
      0.0025
    ],
    [
      "couver",
      0.0025
    ],
    [
      "convoyer",
      0.0025
    ],
    [
      "benir",
      0.0025
    ],
    [
      "verrouiller",
      0.0025
    ]
  ],
  "aile": [
    [
      "protection",
      0.1175
    ],
    [
      "egide",
      0.09
    ],
    [
      "soutien",
      0.0575
    ],
    [
      "sauvegarde",
      0.0575
    ],
    [
      "plan",
      0.0575
    ],
    [
      "empennage",
      0.0575
    ],
    [
      "bras",
      0.0575
    ],
    [
      "aileron",
      0.0575
    ],
    [
      "abri",
      0.0575
    ],
    [
      "voilure",
      0.0275
    ],
    [
      "surveillance",
      0.0275
    ],
    [
      "penne",
      0.0275
    ],
    [
      "pavillon",
      0.0275
    ],
    [
      "parrainage",
      0.0275
    ],
    [
      "pale",
      0.0275
    ],
    [
      "flanc",
      0.0275
    ],
    [
      "detachement",
      0.0275
    ],
    [
      "commun",
      0.0275
    ],
    [
      "ailette",
      0.0275
    ],
    [
      "elytre",
      0.0275
    ]
  ],
  "zoo": [
    [
      "menagerie",
      0.3325
    ],
    [
      "jardin",
      0.165
    ]
  ],
  "souk": [
    [
      "bazar",
      0.4
    ],
    [
      "bordel",
      0.2
    ],
    [
      "desordre",
      0.2
    ],
    [
      "marche",
      0.2
    ]
  ],
  "bouc": [
    [
      "barbe",
      0.11
    ],
    [
      "barbiche",
      0.11
    ],
    [
      "bookmaker",
      0.11
    ],
    [
      "bouquin",
      0.11
    ],
    [
      "chevre",
      0.11
    ],
    [
      "maudit",
      0.11
    ],
    [
      "male",
      0.11
    ],
    [
      "mechant",
      0.11
    ]
  ],
  "super": [
    [
      "beau",
      0.175
    ],
    [
      "formidable",
      0.175
    ],
    [
      "etonnant",
      0.175
    ],
    [
      "merveilleux",
      0.1175
    ],
    [
      "epatant",
      0.1175
    ],
    [
      "dingue",
      0.0575
    ],
    [
      "genial",
      0.0575
    ],
    [
      "surprenant",
      0.0575
    ]
  ],
  "menagerie": [
    [
      "zoo",
      0.285
    ],
    [
      "betail",
      0.1425
    ],
    [
      "cage",
      0.1425
    ],
    [
      "collection",
      0.1425
    ],
    [
      "jardin",
      0.1425
    ]
  ],
  "physique": [
    [
      "materiel",
      0.0875
    ],
    [
      "charnel",
      0.0725
    ],
    [
      "corporel",
      0.0575
    ],
    [
      "concret",
      0.0425
    ],
    [
      "naturel",
      0.0425
    ],
    [
      "physionomie",
      0.0425
    ],
    [
      "tournure",
      0.0425
    ],
    [
      "sensible",
      0.0275
    ],
    [
      "physiologique",
      0.0275
    ],
    [
      "organique",
      0.0275
    ],
    [
      "mine",
      0.0275
    ],
    [
      "animal",
      0.0275
    ],
    [
      "mecanique",
      0.0125
    ],
    [
      "nature",
      0.0125
    ],
    [
      "nervosite",
      0.0125
    ],
    [
      "optique",
      0.0125
    ],
    [
      "optometrie",
      0.0125
    ],
    [
      "prestance",
      0.0125
    ],
    [
      "reel",
      0.0125
    ],
    [
      "sensuel",
      0.0125
    ],
    [
      "sexuel",
      0.0125
    ],
    [
      "somatique",
      0.0125
    ],
    [
      "statique",
      0.0125
    ],
    [
      "temperament",
      0.0125
    ],
    [
      "terrestre",
      0.0125
    ],
    [
      "thermodynamique",
      0.0125
    ],
    [
      "traits",
      0.0125
    ],
    [
      "magnetisme",
      0.0125
    ],
    [
      "hydrostatique",
      0.0125
    ],
    [
      "astrophysique",
      0.0125
    ],
    [
      "aerodynamique",
      0.0125
    ],
    [
      "aerologie",
      0.0125
    ],
    [
      "biophysique",
      0.0125
    ],
    [
      "calorimetrie",
      0.0125
    ],
    [
      "cinematique",
      0.0125
    ],
    [
      "complexion",
      0.0125
    ],
    [
      "cryoscopie",
      0.0125
    ],
    [
      "dioptrique",
      0.0125
    ],
    [
      "dynamique",
      0.0125
    ],
    [
      "exterieur",
      0.0125
    ],
    [
      "facies",
      0.0125
    ],
    [
      "hydraulique",
      0.0125
    ],
    [
      "hydrodynamique",
      0.0125
    ],
    [
      "acoustique",
      0.0125
    ]
  ],
  "charmant": [
    [
      "agreable",
      0.085
    ],
    [
      "aimable",
      0.075
    ],
    [
      "beau",
      0.07
    ],
    [
      "joli",
      0.0625
    ],
    [
      "gracieux",
      0.0575
    ],
    [
      "seduisant",
      0.0525
    ],
    [
      "plaisant",
      0.0475
    ],
    [
      "attrayant",
      0.04
    ],
    [
      "ravissant",
      0.04
    ],
    [
      "enchanteur",
      0.04
    ],
    [
      "delicieux",
      0.03
    ],
    [
      "attirant",
      0.0275
    ],
    [
      "captivant",
      0.0225
    ],
    [
      "gentil",
      0.0175
    ],
    [
      "adorable",
      0.0175
    ],
    [
      "bon",
      0.0175
    ],
    [
      "exquis",
      0.0175
    ],
    [
      "engageant",
      0.015
    ],
    [
      "fascinant",
      0.015
    ],
    [
      "interessant",
      0.015
    ],
    [
      "doux",
      0.015
    ],
    [
      "amene",
      0.015
    ],
    [
      "merveilleux",
      0.0125
    ],
    [
      "charmeur",
      0.01
    ],
    [
      "piquant",
      0.01
    ],
    [
      "sympathique",
      0.01
    ],
    [
      "riant",
      0.01
    ],
    [
      "avenant",
      0.01
    ],
    [
      "amusant",
      0.0075
    ],
    [
      "enivrant",
      0.0075
    ],
    [
      "elegant",
      0.0075
    ],
    [
      "seducteur",
      0.0075
    ],
    [
      "grisant",
      0.0075
    ],
    [
      "gai",
      0.0075
    ],
    [
      "ensorcelant",
      0.0075
    ],
    [
      "pittoresque",
      0.005
    ],
    [
      "galant",
      0.005
    ],
    [
      "coquet",
      0.005
    ],
    [
      "attachant",
      0.005
    ],
    [
      "affable",
      0.005
    ],
    [
      "accueillant",
      0.005
    ],
    [
      "prenant",
      0.0025
    ],
    [
      "mignon",
      0.0025
    ],
    [
      "joyeux",
      0.0025
    ],
    [
      "affriolant",
      0.0025
    ],
    [
      "divin",
      0.0025
    ],
    [
      "ensorceleur",
      0.0025
    ],
    [
      "souriant",
      0.0025
    ],
    [
      "accommodant",
      0.0
    ],
    [
      "croquignolet",
      0.0
    ],
    [
      "enveloppant",
      0.0
    ]
  ],
  "charmer": [
    [
      "seduire",
      0.11
    ],
    [
      "captiver",
      0.085
    ],
    [
      "attirer",
      0.0525
    ],
    [
      "tenter",
      0.045
    ],
    [
      "fasciner",
      0.045
    ],
    [
      "exciter",
      0.045
    ],
    [
      "conquerir",
      0.045
    ],
    [
      "plaire",
      0.0375
    ],
    [
      "ravir",
      0.0375
    ],
    [
      "enchanter",
      0.03
    ],
    [
      "entrainer",
      0.03
    ],
    [
      "enflammer",
      0.0275
    ],
    [
      "gagner",
      0.0225
    ],
    [
      "envouter",
      0.0225
    ],
    [
      "ensorceler",
      0.0225
    ],
    [
      "enthousiasmer",
      0.02
    ],
    [
      "subjuguer",
      0.02
    ],
    [
      "transporter",
      0.02
    ],
    [
      "enlever",
      0.015
    ],
    [
      "flatter",
      0.015
    ],
    [
      "eblouir",
      0.0125
    ],
    [
      "enivrer",
      0.0125
    ],
    [
      "assujettir",
      0.0125
    ],
    [
      "emerveiller",
      0.01
    ],
    [
      "soumettre",
      0.01
    ],
    [
      "inviter",
      0.01
    ],
    [
      "enjoler",
      0.01
    ],
    [
      "briller",
      0.01
    ],
    [
      "bercer",
      0.01
    ],
    [
      "attacher",
      0.01
    ],
    [
      "apprivoiser",
      0.01
    ],
    [
      "rejouir",
      0.005
    ],
    [
      "regaler",
      0.005
    ],
    [
      "hypnotiser",
      0.005
    ],
    [
      "griser",
      0.005
    ],
    [
      "delecter",
      0.005
    ],
    [
      "consoler",
      0.005
    ],
    [
      "capter",
      0.005
    ],
    [
      "affrioler",
      0.005
    ],
    [
      "adoucir",
      0.005
    ],
    [
      "conjurer",
      0.0025
    ],
    [
      "complaire",
      0.0025
    ],
    [
      "chatouiller",
      0.0025
    ],
    [
      "calmer",
      0.0025
    ],
    [
      "apaiser",
      0.0025
    ]
  ],
  "balcon": [
    [
      "galerie",
      0.17
    ],
    [
      "veranda",
      0.055
    ],
    [
      "saillie",
      0.055
    ],
    [
      "poulailler",
      0.055
    ],
    [
      "paradis",
      0.055
    ],
    [
      "mezzanine",
      0.055
    ],
    [
      "loggia",
      0.055
    ],
    [
      "loge",
      0.025
    ],
    [
      "mirador",
      0.025
    ],
    [
      "moucharabieh",
      0.025
    ],
    [
      "machicoulis",
      0.025
    ],
    [
      "meniane",
      0.025
    ],
    [
      "sein",
      0.025
    ],
    [
      "jardiniere",
      0.025
    ],
    [
      "corbeille",
      0.025
    ],
    [
      "console",
      0.025
    ],
    [
      "colonne",
      0.025
    ],
    [
      "balconniere",
      0.025
    ],
    [
      "avancee",
      0.025
    ],
    [
      "avance",
      0.025
    ],
    [
      "amphitheatre",
      0.025
    ],
    [
      "accoudoir",
      0.025
    ],
    [
      "vire",
      0.025
    ]
  ],
  "menton": [],
  "evanouir": [],
  "deux": [
    [
      "double",
      0.105
    ],
    [
      "second",
      0.0525
    ],
    [
      "quelques",
      0.0525
    ],
    [
      "paire",
      0.0525
    ],
    [
      "moitie",
      0.0525
    ],
    [
      "jumeau",
      0.0525
    ],
    [
      "gemine",
      0.0525
    ],
    [
      "duo",
      0.0525
    ],
    [
      "dualite",
      0.0525
    ],
    [
      "different",
      0.0525
    ],
    [
      "deuzio",
      0.0525
    ],
    [
      "deuxiemement",
      0.0525
    ],
    [
      "deuxieme",
      0.0525
    ],
    [
      "demi",
      0.0525
    ],
    [
      "couple",
      0.0525
    ],
    [
      "alternative",
      0.0525
    ],
    [
      "accouplement",
      0.0525
    ],
    [
      "secundo",
      0.0525
    ]
  ],
  "cents": [
    [
      "centaine",
      0.3325
    ],
    [
      "hecto",
      0.3325
    ],
    [
      "pourcentage",
      0.3325
    ]
  ],
  "singer": [
    [
      "imiter",
      0.175
    ],
    [
      "reproduire",
      0.125
    ],
    [
      "copier",
      0.115
    ],
    [
      "simuler",
      0.09
    ],
    [
      "contrefaire",
      0.0825
    ],
    [
      "plagier",
      0.065
    ],
    [
      "calquer",
      0.04
    ],
    [
      "demarquer",
      0.04
    ],
    [
      "emprunter",
      0.04
    ],
    [
      "pasticher",
      0.04
    ],
    [
      "mimer",
      0.025
    ],
    [
      "jouer",
      0.025
    ],
    [
      "affecter",
      0.015
    ],
    [
      "parodier",
      0.015
    ],
    [
      "piller",
      0.015
    ],
    [
      "repeter",
      0.015
    ],
    [
      "picorer",
      0.0075
    ],
    [
      "faire",
      0.0075
    ],
    [
      "decalquer",
      0.0075
    ],
    [
      "compiler",
      0.0075
    ],
    [
      "caricaturer",
      0.0075
    ],
    [
      "adopter",
      0.0075
    ],
    [
      "pirater",
      0.0075
    ]
  ],
  "singe": [
    [
      "pitre",
      0.1175
    ],
    [
      "bouffon",
      0.0675
    ],
    [
      "clown",
      0.05
    ],
    [
      "comique",
      0.05
    ],
    [
      "magot",
      0.05
    ],
    [
      "patron",
      0.05
    ],
    [
      "monstre",
      0.0325
    ],
    [
      "macaque",
      0.0325
    ],
    [
      "laideron",
      0.0325
    ],
    [
      "guenon",
      0.0325
    ],
    [
      "male",
      0.015
    ],
    [
      "negrier",
      0.015
    ],
    [
      "paillasse",
      0.015
    ],
    [
      "primate",
      0.015
    ],
    [
      "quadrumane",
      0.015
    ],
    [
      "rigolo",
      0.015
    ],
    [
      "simien",
      0.015
    ],
    [
      "treuil",
      0.015
    ],
    [
      "viande",
      0.015
    ],
    [
      "zig",
      0.015
    ],
    [
      "zigomar",
      0.015
    ],
    [
      "maitre",
      0.015
    ],
    [
      "jocrisse",
      0.015
    ],
    [
      "jocko",
      0.015
    ],
    [
      "anthropoide",
      0.015
    ],
    [
      "bourgeois",
      0.015
    ],
    [
      "chef",
      0.015
    ],
    [
      "comedien",
      0.015
    ],
    [
      "conserve",
      0.015
    ],
    [
      "crapoussin",
      0.015
    ],
    [
      "directeur",
      0.015
    ],
    [
      "employeur",
      0.015
    ],
    [
      "gorille",
      0.015
    ],
    [
      "gugusse",
      0.015
    ],
    [
      "imitateur",
      0.015
    ],
    [
      "zigoto",
      0.015
    ]
  ],
  "singes": [
    [
      "pitre",
      0.1175
    ],
    [
      "bouffon",
      0.0675
    ],
    [
      "clown",
      0.05
    ],
    [
      "comique",
      0.05
    ],
    [
      "magot",
      0.05
    ],
    [
      "patron",
      0.05
    ],
    [
      "monstre",
      0.0325
    ],
    [
      "macaque",
      0.0325
    ],
    [
      "laideron",
      0.0325
    ],
    [
      "guenon",
      0.0325
    ],
    [
      "male",
      0.015
    ],
    [
      "negrier",
      0.015
    ],
    [
      "paillasse",
      0.015
    ],
    [
      "primate",
      0.015
    ],
    [
      "quadrumane",
      0.015
    ],
    [
      "rigolo",
      0.015
    ],
    [
      "simien",
      0.015
    ],
    [
      "treuil",
      0.015
    ],
    [
      "viande",
      0.015
    ],
    [
      "zig",
      0.015
    ],
    [
      "zigomar",
      0.015
    ],
    [
      "maitre",
      0.015
    ],
    [
      "jocrisse",
      0.015
    ],
    [
      "jocko",
      0.015
    ],
    [
      "anthropoide",
      0.015
    ],
    [
      "bourgeois",
      0.015
    ],
    [
      "chef",
      0.015
    ],
    [
      "comedien",
      0.015
    ],
    [
      "conserve",
      0.015
    ],
    [
      "crapoussin",
      0.015
    ],
    [
      "directeur",
      0.015
    ],
    [
      "employeur",
      0.015
    ],
    [
      "gorille",
      0.015
    ],
    [
      "gugusse",
      0.015
    ],
    [
      "imitateur",
      0.015
    ],
    [
      "zigoto",
      0.015
    ]
  ],
  "persan": [
    [
      "iranien",
      0.5
    ],
    [
      "parsi",
      0.5
    ]
  ],
  "payant": [
    [
      "avantageux",
      0.135
    ],
    [
      "fructueux",
      0.135
    ],
    [
      "profitable",
      0.1075
    ],
    [
      "valable",
      0.08
    ],
    [
      "remunerateur",
      0.08
    ],
    [
      "rentable",
      0.08
    ],
    [
      "lucratif",
      0.08
    ],
    [
      "interessant",
      0.08
    ],
    [
      "efficace",
      0.0525
    ],
    [
      "salutaire",
      0.0525
    ],
    [
      "beneficiaire",
      0.025
    ],
    [
      "juteux",
      0.025
    ],
    [
      "profitant",
      0.025
    ],
    [
      "recompensant",
      0.025
    ]
  ],
  "pourtant": [
    [
      "cependant",
      0.1425
    ],
    [
      "mais",
      0.1425
    ],
    [
      "neanmoins",
      0.1425
    ],
    [
      "seulement",
      0.1425
    ],
    [
      "toutefois",
      0.1425
    ],
    [
      "et",
      0.07
    ]
  ],
  "gratuit": [
    [
      "arbitraire",
      0.0725
    ],
    [
      "benevole",
      0.0725
    ],
    [
      "hasardeux",
      0.0725
    ],
    [
      "immotive",
      0.0725
    ],
    [
      "incertain",
      0.0725
    ],
    [
      "injustifie",
      0.0725
    ],
    [
      "hasarde",
      0.035
    ],
    [
      "injustifiable",
      0.035
    ],
    [
      "irrationnel",
      0.035
    ],
    [
      "libre",
      0.035
    ],
    [
      "permis",
      0.035
    ],
    [
      "gratis",
      0.035
    ],
    [
      "gracieux",
      0.035
    ],
    [
      "fantaisiste",
      0.035
    ],
    [
      "desinteresse",
      0.035
    ],
    [
      "douteux",
      0.035
    ],
    [
      "autorise",
      0.035
    ],
    [
      "absurde",
      0.035
    ],
    [
      "risque",
      0.035
    ]
  ],
  "esclave": [
    [
      "attache",
      0.08
    ],
    [
      "domestique",
      0.08
    ],
    [
      "dependant",
      0.08
    ],
    [
      "subordonne",
      0.08
    ],
    [
      "tributaire",
      0.08
    ],
    [
      "valet",
      0.0525
    ],
    [
      "jouet",
      0.0525
    ],
    [
      "inferieur",
      0.0525
    ],
    [
      "captif",
      0.0525
    ],
    [
      "asservi",
      0.0525
    ],
    [
      "serf",
      0.025
    ],
    [
      "proie",
      0.025
    ],
    [
      "prisonnier",
      0.025
    ],
    [
      "pantin",
      0.025
    ],
    [
      "opprime",
      0.025
    ],
    [
      "ilote",
      0.025
    ],
    [
      "chose",
      0.025
    ],
    [
      "chien",
      0.025
    ],
    [
      "assujetti",
      0.025
    ],
    [
      "aliene",
      0.025
    ],
    [
      "serviteur",
      0.025
    ]
  ],
  "obeir": [
    [
      "suivre",
      0.0825
    ],
    [
      "ceder",
      0.0625
    ],
    [
      "observer",
      0.0625
    ],
    [
      "satisfaire",
      0.0525
    ],
    [
      "obtemperer",
      0.0525
    ],
    [
      "acquiescer",
      0.0525
    ],
    [
      "accepter",
      0.04
    ],
    [
      "ecouter",
      0.03
    ],
    [
      "servir",
      0.03
    ],
    [
      "s'incliner",
      0.03
    ],
    [
      "flechir",
      0.03
    ],
    [
      "subir",
      0.02
    ],
    [
      "respecter",
      0.02
    ],
    [
      "marcher",
      0.02
    ],
    [
      "executer",
      0.02
    ],
    [
      "deferer",
      0.02
    ],
    [
      "sacrifier",
      0.01
    ],
    [
      "s'infeoder",
      0.01
    ],
    [
      "repondre",
      0.01
    ],
    [
      "rompre",
      0.01
    ],
    [
      "ployer",
      0.01
    ],
    [
      "plier",
      0.01
    ],
    [
      "admettre",
      0.01
    ]
  ],
  "joli": [
    [
      "beau",
      0.1275
    ],
    [
      "charmant",
      0.0875
    ],
    [
      "agreable",
      0.07
    ],
    [
      "aimable",
      0.0575
    ],
    [
      "gracieux",
      0.05
    ],
    [
      "gentil",
      0.04
    ],
    [
      "plaisant",
      0.035
    ],
    [
      "bon",
      0.0325
    ],
    [
      "ravissant",
      0.025
    ],
    [
      "mignon",
      0.025
    ],
    [
      "attrayant",
      0.0225
    ],
    [
      "adorable",
      0.0225
    ],
    [
      "delicieux",
      0.0225
    ],
    [
      "seduisant",
      0.0225
    ],
    [
      "coquet",
      0.02
    ],
    [
      "exquis",
      0.02
    ],
    [
      "interessant",
      0.0175
    ],
    [
      "enchanteur",
      0.0175
    ],
    [
      "doux",
      0.0175
    ],
    [
      "delicat",
      0.0125
    ],
    [
      "merveilleux",
      0.0125
    ],
    [
      "piquant",
      0.0125
    ],
    [
      "elegant",
      0.0125
    ],
    [
      "riant",
      0.01
    ],
    [
      "important",
      0.01
    ],
    [
      "gros",
      0.01
    ],
    [
      "biquet",
      0.01
    ],
    [
      "amusant",
      0.01
    ],
    [
      "bien",
      0.0075
    ],
    [
      "harmonieux",
      0.0075
    ],
    [
      "infame",
      0.0075
    ],
    [
      "rondelet",
      0.005
    ],
    [
      "pimpant",
      0.005
    ],
    [
      "petit",
      0.005
    ],
    [
      "mievre",
      0.005
    ],
    [
      "degoutant",
      0.005
    ],
    [
      "bath",
      0.005
    ],
    [
      "avantageux",
      0.005
    ],
    [
      "sordide",
      0.0025
    ],
    [
      "mimi",
      0.0025
    ],
    [
      "mignard",
      0.0025
    ],
    [
      "lucratif",
      0.0025
    ],
    [
      "joliet",
      0.0025
    ],
    [
      "honteux",
      0.0025
    ],
    [
      "esthetique",
      0.0025
    ],
    [
      "considerable",
      0.0025
    ],
    [
      "chouette",
      0.0025
    ],
    [
      "bellot",
      0.0025
    ],
    [
      "abject",
      0.0025
    ],
    [
      "melodieux",
      0.0
    ],
    [
      "piteux",
      0.0
    ],
    [
      "rentable",
      0.0
    ],
    [
      "remunerateur",
      0.0
    ],
    [
      "reussi",
      0.0
    ],
    [
      "magnifique",
      0.0
    ],
    [
      "innommable",
      0.0
    ],
    [
      "idyllique",
      0.0
    ],
    [
      "girond",
      0.0
    ],
    [
      "fichu",
      0.0
    ],
    [
      "desirable",
      0.0
    ],
    [
      "degradant",
      0.0
    ],
    [
      "cocasse",
      0.0
    ],
    [
      "accort",
      0.0
    ],
    [
      "reve",
      0.0
    ]
  ],
  "jolie": [
    [
      "beau",
      0.1275
    ],
    [
      "charmant",
      0.0875
    ],
    [
      "agreable",
      0.07
    ],
    [
      "aimable",
      0.0575
    ],
    [
      "gracieux",
      0.05
    ],
    [
      "gentil",
      0.04
    ],
    [
      "plaisant",
      0.035
    ],
    [
      "bon",
      0.0325
    ],
    [
      "ravissant",
      0.025
    ],
    [
      "mignon",
      0.025
    ],
    [
      "attrayant",
      0.0225
    ],
    [
      "adorable",
      0.0225
    ],
    [
      "delicieux",
      0.0225
    ],
    [
      "seduisant",
      0.0225
    ],
    [
      "coquet",
      0.02
    ],
    [
      "exquis",
      0.02
    ],
    [
      "interessant",
      0.0175
    ],
    [
      "enchanteur",
      0.0175
    ],
    [
      "doux",
      0.0175
    ],
    [
      "delicat",
      0.0125
    ],
    [
      "merveilleux",
      0.0125
    ],
    [
      "piquant",
      0.0125
    ],
    [
      "elegant",
      0.0125
    ],
    [
      "riant",
      0.01
    ],
    [
      "important",
      0.01
    ],
    [
      "gros",
      0.01
    ],
    [
      "biquet",
      0.01
    ],
    [
      "amusant",
      0.01
    ],
    [
      "bien",
      0.0075
    ],
    [
      "harmonieux",
      0.0075
    ],
    [
      "infame",
      0.0075
    ],
    [
      "rondelet",
      0.005
    ],
    [
      "pimpant",
      0.005
    ],
    [
      "petit",
      0.005
    ],
    [
      "mievre",
      0.005
    ],
    [
      "degoutant",
      0.005
    ],
    [
      "bath",
      0.005
    ],
    [
      "avantageux",
      0.005
    ],
    [
      "sordide",
      0.0025
    ],
    [
      "mimi",
      0.0025
    ],
    [
      "mignard",
      0.0025
    ],
    [
      "lucratif",
      0.0025
    ],
    [
      "joliet",
      0.0025
    ],
    [
      "honteux",
      0.0025
    ],
    [
      "esthetique",
      0.0025
    ],
    [
      "considerable",
      0.0025
    ],
    [
      "chouette",
      0.0025
    ],
    [
      "bellot",
      0.0025
    ],
    [
      "abject",
      0.0025
    ],
    [
      "melodieux",
      0.0
    ],
    [
      "piteux",
      0.0
    ],
    [
      "rentable",
      0.0
    ],
    [
      "remunerateur",
      0.0
    ],
    [
      "reussi",
      0.0
    ],
    [
      "magnifique",
      0.0
    ],
    [
      "innommable",
      0.0
    ],
    [
      "idyllique",
      0.0
    ],
    [
      "girond",
      0.0
    ],
    [
      "fichu",
      0.0
    ],
    [
      "desirable",
      0.0
    ],
    [
      "degradant",
      0.0
    ],
    [
      "cocasse",
      0.0
    ],
    [
      "accort",
      0.0
    ],
    [
      "reve",
      0.0
    ]
  ],
  "cortege": [
    [
      "suite",
      0.095
    ],
    [
      "defile",
      0.08
    ],
    [
      "troupe",
      0.0675
    ],
    [
      "succession",
      0.0675
    ],
    [
      "ribambelle",
      0.0675
    ],
    [
      "file",
      0.0675
    ],
    [
      "chapelet",
      0.0525
    ],
    [
      "ceremonie",
      0.0525
    ],
    [
      "serie",
      0.04
    ],
    [
      "procession",
      0.04
    ],
    [
      "escorte",
      0.04
    ],
    [
      "colonne",
      0.04
    ],
    [
      "mariage",
      0.025
    ],
    [
      "foule",
      0.025
    ],
    [
      "conduite",
      0.025
    ],
    [
      "cohorte",
      0.025
    ],
    [
      "chaine",
      0.025
    ],
    [
      "cavalcade",
      0.025
    ],
    [
      "appareil",
      0.025
    ],
    [
      "accompagnement",
      0.025
    ],
    [
      "cour",
      0.0125
    ],
    [
      "meute",
      0.0125
    ],
    [
      "theorie",
      0.0125
    ],
    [
      "equipage",
      0.0125
    ]
  ],
  "amoureux": [
    [
      "passionne",
      0.0725
    ],
    [
      "fanatique",
      0.05
    ],
    [
      "amant",
      0.0425
    ],
    [
      "fervent",
      0.0325
    ],
    [
      "fou",
      0.0325
    ],
    [
      "tendre",
      0.0275
    ],
    [
      "amateur",
      0.0275
    ],
    [
      "affectueux",
      0.0275
    ],
    [
      "gourmand",
      0.025
    ],
    [
      "transporte",
      0.02
    ],
    [
      "sentimental",
      0.02
    ],
    [
      "mordu",
      0.02
    ],
    [
      "feru",
      0.02
    ],
    [
      "friand",
      0.02
    ],
    [
      "flirt",
      0.02
    ],
    [
      "doux",
      0.02
    ],
    [
      "cheri",
      0.02
    ],
    [
      "ardent",
      0.02
    ],
    [
      "ami",
      0.02
    ],
    [
      "epris",
      0.015
    ],
    [
      "voluptueux",
      0.015
    ],
    [
      "soupirant",
      0.015
    ],
    [
      "sensible",
      0.015
    ],
    [
      "langoureux",
      0.015
    ],
    [
      "galant",
      0.015
    ],
    [
      "chaud",
      0.015
    ],
    [
      "avide",
      0.015
    ],
    [
      "erotique",
      0.0125
    ],
    [
      "sensuel",
      0.0125
    ],
    [
      "lascif",
      0.0125
    ],
    [
      "devoue",
      0.0125
    ],
    [
      "caressant",
      0.0125
    ],
    [
      "attentif",
      0.0125
    ],
    [
      "attache",
      0.0125
    ],
    [
      "aimable",
      0.0125
    ],
    [
      "adorateur",
      0.0125
    ],
    [
      "admirateur",
      0.0125
    ],
    [
      "calin",
      0.0075
    ],
    [
      "entiche",
      0.0075
    ],
    [
      "pretendant",
      0.0075
    ],
    [
      "salace",
      0.0075
    ],
    [
      "transi",
      0.0075
    ],
    [
      "copain",
      0.0075
    ],
    [
      "beguin",
      0.0075
    ],
    [
      "brulant",
      0.0075
    ],
    [
      "alangui",
      0.0075
    ],
    [
      "aimant",
      0.0075
    ],
    [
      "affectionne",
      0.0075
    ],
    [
      "passionnel",
      0.0025
    ],
    [
      "pince",
      0.0025
    ],
    [
      "porte",
      0.0025
    ],
    [
      "sexuel",
      0.0025
    ],
    [
      "toque",
      0.0025
    ],
    [
      "infatue",
      0.0025
    ],
    [
      "fana",
      0.0025
    ],
    [
      "enflamme",
      0.0025
    ],
    [
      "chipe",
      0.0025
    ],
    [
      "assoti",
      0.0025
    ],
    [
      "amical",
      0.0025
    ],
    [
      "amante",
      0.0025
    ],
    [
      "affole",
      0.0025
    ],
    [
      "tourtereau",
      0.0025
    ]
  ],
  "assieger": [
    [
      "cerner",
      0.0775
    ],
    [
      "harceler",
      0.07
    ],
    [
      "assaillir",
      0.0625
    ],
    [
      "poursuivre",
      0.0625
    ],
    [
      "presser",
      0.0625
    ],
    [
      "tourmenter",
      0.0625
    ],
    [
      "obseder",
      0.05
    ],
    [
      "importuner",
      0.05
    ],
    [
      "entourer",
      0.05
    ],
    [
      "encercler",
      0.0425
    ],
    [
      "envelopper",
      0.0425
    ],
    [
      "attaquer",
      0.035
    ],
    [
      "investir",
      0.035
    ],
    [
      "talonner",
      0.0275
    ],
    [
      "enfermer",
      0.0275
    ],
    [
      "emprisonner",
      0.0275
    ],
    [
      "accabler",
      0.0275
    ],
    [
      "bloquer",
      0.02
    ],
    [
      "bombarder",
      0.02
    ],
    [
      "fatiguer",
      0.02
    ],
    [
      "s'attacher",
      0.0125
    ],
    [
      "preoccuper",
      0.0125
    ],
    [
      "inquieter",
      0.0125
    ],
    [
      "coller",
      0.0125
    ],
    [
      "relancer",
      0.005
    ],
    [
      "solliciter",
      0.005
    ],
    [
      "taler",
      0.005
    ],
    [
      "tirailler",
      0.005
    ],
    [
      "troubler",
      0.005
    ]
  ],
  "trente": [],
  "elephant": [
    [
      "geant",
      0.3325
    ],
    [
      "mastodonte",
      0.3325
    ],
    [
      "pachyderme",
      0.3325
    ]
  ],
  "acrobate": [
    [
      "bateleur",
      0.1375
    ],
    [
      "saltimbanque",
      0.1375
    ],
    [
      "funambule",
      0.0775
    ],
    [
      "jongleur",
      0.0775
    ],
    [
      "pitre",
      0.0575
    ],
    [
      "danseur",
      0.0575
    ],
    [
      "baladin",
      0.0575
    ],
    [
      "equilibriste",
      0.0375
    ],
    [
      "sauteur",
      0.0375
    ],
    [
      "prestidigitateur",
      0.0375
    ],
    [
      "matassin",
      0.0375
    ],
    [
      "escamoteur",
      0.0375
    ],
    [
      "clown",
      0.0375
    ],
    [
      "trapeziste",
      0.0175
    ],
    [
      "illusionniste",
      0.0175
    ],
    [
      "gymnaste",
      0.0175
    ],
    [
      "danseuse",
      0.0175
    ],
    [
      "cascadeur",
      0.0175
    ],
    [
      "antipodiste",
      0.0175
    ],
    [
      "voltigeur",
      0.0175
    ]
  ],
  "lier": [
    [
      "attacher",
      0.1175
    ],
    [
      "joindre",
      0.085
    ],
    [
      "unir",
      0.075
    ],
    [
      "reunir",
      0.0625
    ],
    [
      "assembler",
      0.0575
    ],
    [
      "associer",
      0.0475
    ],
    [
      "enchainer",
      0.0475
    ],
    [
      "combiner",
      0.0275
    ],
    [
      "assujettir",
      0.025
    ],
    [
      "accoler",
      0.0225
    ],
    [
      "astreindre",
      0.0225
    ],
    [
      "relier",
      0.0225
    ],
    [
      "serrer",
      0.0225
    ],
    [
      "river",
      0.02
    ],
    [
      "rapprocher",
      0.015
    ],
    [
      "fixer",
      0.015
    ],
    [
      "engager",
      0.015
    ],
    [
      "allier",
      0.015
    ],
    [
      "adjoindre",
      0.015
    ],
    [
      "tenir",
      0.0125
    ],
    [
      "obliger",
      0.0125
    ],
    [
      "fusionner",
      0.0125
    ],
    [
      "contraindre",
      0.0125
    ],
    [
      "agencer",
      0.0125
    ],
    [
      "accorder",
      0.0125
    ],
    [
      "atteler",
      0.01
    ],
    [
      "coordonner",
      0.01
    ],
    [
      "rattacher",
      0.0075
    ],
    [
      "nouer",
      0.0075
    ],
    [
      "marier",
      0.0075
    ],
    [
      "ligoter",
      0.0075
    ],
    [
      "lacer",
      0.0075
    ],
    [
      "garrotter",
      0.0075
    ],
    [
      "ficeler",
      0.0075
    ],
    [
      "accoupler",
      0.0075
    ],
    [
      "suspendre",
      0.005
    ],
    [
      "enlacer",
      0.005
    ],
    [
      "conjuguer",
      0.005
    ],
    [
      "conglomerer",
      0.005
    ],
    [
      "boulonner",
      0.005
    ],
    [
      "agglutiner",
      0.005
    ],
    [
      "couler",
      0.0
    ],
    [
      "hypothequer",
      0.0
    ],
    [
      "ligaturer",
      0.0
    ],
    [
      "moiser",
      0.0
    ],
    [
      "s'atteler",
      0.0
    ],
    [
      "s'engager",
      0.0
    ],
    [
      "coudre",
      0.0
    ],
    [
      "correler",
      0.0
    ],
    [
      "corder",
      0.0
    ],
    [
      "cimenter",
      0.0
    ],
    [
      "charpenter",
      0.0
    ],
    [
      "carguer",
      0.0
    ],
    [
      "botteler",
      0.0
    ],
    [
      "amarrer",
      0.0
    ],
    [
      "solidariser",
      0.0
    ]
  ],
  "lion": [
    [
      "brave",
      0.4
    ],
    [
      "fauve",
      0.2
    ],
    [
      "heros",
      0.2
    ],
    [
      "elegant",
      0.2
    ]
  ],
  "clairon": [
    [
      "biniou",
      0.2
    ],
    [
      "clique",
      0.2
    ],
    [
      "cuivre",
      0.2
    ],
    [
      "fanfare",
      0.2
    ],
    [
      "trompette",
      0.2
    ]
  ],
  "quarante": [],
  "fakir": [
    [
      "ascete",
      0.1425
    ],
    [
      "derviche",
      0.1425
    ],
    [
      "mage",
      0.1425
    ],
    [
      "prestidigitateur",
      0.1425
    ],
    [
      "thaumaturge",
      0.1425
    ],
    [
      "voyant",
      0.1425
    ],
    [
      "yogi",
      0.1425
    ]
  ],
  "batterie": [
    [
      "accumulateur",
      0.0525
    ],
    [
      "combinaison",
      0.0525
    ],
    [
      "echauffouree",
      0.035
    ],
    [
      "rixe",
      0.035
    ],
    [
      "plan",
      0.035
    ],
    [
      "mesure",
      0.035
    ],
    [
      "casserole",
      0.035
    ],
    [
      "canon",
      0.035
    ],
    [
      "bataille",
      0.035
    ],
    [
      "bagarre",
      0.035
    ],
    [
      "querelle",
      0.0175
    ],
    [
      "poele",
      0.0175
    ],
    [
      "plat",
      0.0175
    ],
    [
      "pile",
      0.0175
    ],
    [
      "melee",
      0.0175
    ],
    [
      "rappel",
      0.0175
    ],
    [
      "roulade",
      0.0175
    ],
    [
      "roulement",
      0.0175
    ],
    [
      "reveil",
      0.0175
    ],
    [
      "tambour",
      0.0175
    ],
    [
      "timbale",
      0.0175
    ],
    [
      "train",
      0.0175
    ],
    [
      "trille",
      0.0175
    ],
    [
      "ustensile",
      0.0175
    ],
    [
      "marmite",
      0.0175
    ],
    [
      "machination",
      0.0175
    ],
    [
      "generale",
      0.0175
    ],
    [
      "accus",
      0.0175
    ],
    [
      "appel",
      0.0175
    ],
    [
      "artillerie",
      0.0175
    ],
    [
      "batteur",
      0.0175
    ],
    [
      "breloque",
      0.0175
    ],
    [
      "caisse",
      0.0175
    ],
    [
      "chamade",
      0.0175
    ],
    [
      "champ",
      0.0175
    ],
    [
      "charge",
      0.0175
    ],
    [
      "condensateur",
      0.0175
    ],
    [
      "cymbale",
      0.0175
    ],
    [
      "diane",
      0.0175
    ],
    [
      "drums",
      0.0175
    ],
    [
      "accessoire",
      0.0175
    ]
  ],
  "chef": [
    [
      "directeur",
      0.0575
    ],
    [
      "maitre",
      0.0475
    ],
    [
      "dirigeant",
      0.0325
    ],
    [
      "gouverneur",
      0.03
    ],
    [
      "souverain",
      0.03
    ],
    [
      "superieur",
      0.025
    ],
    [
      "patron",
      0.025
    ],
    [
      "responsable",
      0.0225
    ],
    [
      "meneur",
      0.0225
    ],
    [
      "magistrat",
      0.0225
    ],
    [
      "leader",
      0.0225
    ],
    [
      "instigateur",
      0.0225
    ],
    [
      "guide",
      0.0225
    ],
    [
      "principal",
      0.0175
    ],
    [
      "prince",
      0.0175
    ],
    [
      "officier",
      0.0175
    ],
    [
      "general",
      0.0175
    ],
    [
      "capitaine",
      0.0175
    ],
    [
      "ame",
      0.0125
    ],
    [
      "tete",
      0.0125
    ],
    [
      "regent",
      0.0125
    ],
    [
      "roi",
      0.0125
    ],
    [
      "pere",
      0.0125
    ],
    [
      "lieutenant",
      0.0125
    ],
    [
      "conducteur",
      0.0125
    ],
    [
      "animateur",
      0.0125
    ],
    [
      "president",
      0.01
    ],
    [
      "pasteur",
      0.01
    ],
    [
      "monarque",
      0.01
    ],
    [
      "despote",
      0.01
    ],
    [
      "berger",
      0.01
    ],
    [
      "as",
      0.01
    ],
    [
      "entraineur",
      0.005
    ],
    [
      "grade",
      0.005
    ],
    [
      "generalissime",
      0.005
    ],
    [
      "inspirateur",
      0.005
    ],
    [
      "maestro",
      0.005
    ],
    [
      "maire",
      0.005
    ],
    [
      "manitou",
      0.005
    ],
    [
      "ministre",
      0.005
    ],
    [
      "point",
      0.005
    ],
    [
      "emir",
      0.005
    ],
    [
      "doyen",
      0.005
    ],
    [
      "dominateur",
      0.005
    ],
    [
      "abbe",
      0.005
    ],
    [
      "administrateur",
      0.005
    ],
    [
      "architecte",
      0.005
    ],
    [
      "cacique",
      0.005
    ],
    [
      "cadre",
      0.005
    ],
    [
      "capiston",
      0.005
    ],
    [
      "caporal",
      0.005
    ],
    [
      "contremaitre",
      0.005
    ],
    [
      "commandant",
      0.005
    ],
    [
      "champion",
      0.005
    ],
    [
      "caid",
      0.005
    ],
    [
      "patriarche",
      0.0025
    ],
    [
      "pape",
      0.0025
    ],
    [
      "matiere",
      0.0025
    ],
    [
      "marechal",
      0.0025
    ],
    [
      "ingenieur",
      0.0025
    ],
    [
      "fondateur",
      0.0025
    ],
    [
      "empereur",
      0.0025
    ],
    [
      "sachem",
      0.0025
    ],
    [
      "eveque",
      0.0025
    ],
    [
      "echevin",
      0.0025
    ],
    [
      "tetrarque",
      0.0025
    ],
    [
      "stratege",
      0.0025
    ],
    [
      "singe",
      0.0025
    ],
    [
      "sergent",
      0.0025
    ],
    [
      "dynaste",
      0.0025
    ],
    [
      "doge",
      0.0025
    ],
    [
      "dictateur",
      0.0025
    ],
    [
      "capital",
      0.0025
    ],
    [
      "cap",
      0.0025
    ],
    [
      "brigadier",
      0.0025
    ],
    [
      "boss",
      0.0025
    ],
    [
      "aspirant",
      0.0025
    ],
    [
      "amiral",
      0.0025
    ],
    [
      "adjudant",
      0.0025
    ],
    [
      "cheffesse",
      0.0025
    ],
    [
      "cheftaine",
      0.0025
    ],
    [
      "cuisinier",
      0.0025
    ],
    [
      "coryphee",
      0.0025
    ],
    [
      "coq",
      0.0025
    ],
    [
      "consul",
      0.0025
    ],
    [
      "condottiere",
      0.0025
    ],
    [
      "colonel",
      0.0025
    ],
    [
      "cinquantenier",
      0.0025
    ],
    [
      "cheik",
      0.0025
    ],
    [
      "P.D.G.",
      0.0025
    ]
  ],
  "oiseau": [
    [
      "homme",
      0.15
    ],
    [
      "individu",
      0.15
    ],
    [
      "bougre",
      0.09
    ],
    [
      "personne",
      0.09
    ],
    [
      "pistolet",
      0.06
    ],
    [
      "moineau",
      0.06
    ],
    [
      "citoyen",
      0.06
    ],
    [
      "bete",
      0.06
    ],
    [
      "volaille",
      0.03
    ],
    [
      "tetrapode",
      0.03
    ],
    [
      "pierrot",
      0.03
    ],
    [
      "oisillon",
      0.03
    ],
    [
      "oiselet",
      0.03
    ],
    [
      "gibier",
      0.03
    ],
    [
      "civiere",
      0.03
    ],
    [
      "biquet",
      0.03
    ],
    [
      "volatile",
      0.03
    ]
  ],
  "vague": [
    [
      "incertain",
      0.0725
    ],
    [
      "flou",
      0.07
    ],
    [
      "indecis",
      0.055
    ],
    [
      "confus",
      0.0475
    ],
    [
      "nebuleux",
      0.0475
    ],
    [
      "obscur",
      0.0475
    ],
    [
      "timide",
      0.045
    ],
    [
      "indistinct",
      0.03
    ],
    [
      "indetermine",
      0.0275
    ],
    [
      "douteux",
      0.025
    ],
    [
      "imprecis",
      0.025
    ],
    [
      "trouble",
      0.0225
    ],
    [
      "flottant",
      0.02
    ],
    [
      "tenebreux",
      0.0175
    ],
    [
      "ambigu",
      0.015
    ],
    [
      "ondulation",
      0.015
    ],
    [
      "vaporeux",
      0.0125
    ],
    [
      "mou",
      0.0125
    ],
    [
      "hesitant",
      0.0125
    ],
    [
      "flot",
      0.0125
    ],
    [
      "voile",
      0.01
    ],
    [
      "onde",
      0.01
    ],
    [
      "indefini",
      0.01
    ],
    [
      "indecision",
      0.01
    ],
    [
      "indiscernable",
      0.01
    ],
    [
      "fumeux",
      0.01
    ],
    [
      "faible",
      0.01
    ],
    [
      "embarrasse",
      0.01
    ],
    [
      "sourd",
      0.0075
    ],
    [
      "sibyllin",
      0.0075
    ],
    [
      "remous",
      0.0075
    ],
    [
      "mouvement",
      0.0075
    ],
    [
      "lache",
      0.0075
    ],
    [
      "libre",
      0.0075
    ],
    [
      "brumeux",
      0.0075
    ],
    [
      "indeterminable",
      0.005
    ],
    [
      "insignifiant",
      0.005
    ],
    [
      "irresolu",
      0.005
    ],
    [
      "large",
      0.005
    ],
    [
      "nuageux",
      0.005
    ],
    [
      "vide",
      0.005
    ],
    [
      "inculte",
      0.005
    ],
    [
      "imprecision",
      0.005
    ],
    [
      "agitation",
      0.005
    ],
    [
      "efface",
      0.005
    ],
    [
      "flux",
      0.005
    ],
    [
      "grossier",
      0.005
    ],
    [
      "houle",
      0.005
    ],
    [
      "imperceptible",
      0.005
    ],
    [
      "evasif",
      0.0025
    ],
    [
      "terni",
      0.0025
    ],
    [
      "lointain",
      0.0025
    ],
    [
      "inoccupe",
      0.0025
    ],
    [
      "indetermination",
      0.0025
    ],
    [
      "indefinissable",
      0.0025
    ],
    [
      "incertitude",
      0.0025
    ],
    [
      "imparfait",
      0.0025
    ],
    [
      "general",
      0.0025
    ],
    [
      "distrait",
      0.0025
    ],
    [
      "confusion",
      0.0025
    ],
    [
      "approximatif",
      0.0025
    ],
    [
      "abstrait",
      0.0025
    ],
    [
      "quelconque",
      0.0
    ],
    [
      "perplexe",
      0.0
    ],
    [
      "orbe",
      0.0
    ],
    [
      "onde",
      0.0
    ],
    [
      "nappe",
      0.0
    ],
    [
      "mouton",
      0.0
    ],
    [
      "ressac",
      0.0
    ],
    [
      "rouleau",
      0.0
    ],
    [
      "rush",
      0.0
    ],
    [
      "ruee",
      0.0
    ],
    [
      "vacant",
      0.0
    ],
    [
      "vaguelette",
      0.0
    ],
    [
      "vasouillard",
      0.0
    ],
    [
      "epidemie",
      0.0
    ],
    [
      "mode",
      0.0
    ],
    [
      "maree",
      0.0
    ],
    [
      "barre",
      0.0
    ],
    [
      "brouille",
      0.0
    ],
    [
      "changeant",
      0.0
    ],
    [
      "deferlement",
      0.0
    ],
    [
      "estompe",
      0.0
    ],
    [
      "illimite",
      0.0
    ],
    [
      "incolore",
      0.0
    ],
    [
      "incomprehensible",
      0.0
    ],
    [
      "indistinction",
      0.0
    ],
    [
      "indefriche",
      0.0
    ],
    [
      "inexpressif",
      0.0
    ],
    [
      "lame",
      0.0
    ],
    [
      "amphibologique",
      0.0
    ]
  ],
  "vaguer": [
    [
      "errer",
      0.205
    ],
    [
      "roder",
      0.145
    ],
    [
      "vagabonder",
      0.1175
    ],
    [
      "flaner",
      0.0875
    ],
    [
      "trainer",
      0.0575
    ],
    [
      "deambuler",
      0.0575
    ],
    [
      "divaguer",
      0.0575
    ],
    [
      "aller",
      0.0275
    ],
    [
      "extravaguer",
      0.0275
    ],
    [
      "flotter",
      0.0275
    ],
    [
      "trainasser",
      0.0275
    ]
  ],
  "irresolu": [
    [
      "indecis",
      0.1525
    ],
    [
      "incertain",
      0.1375
    ],
    [
      "flottant",
      0.1225
    ],
    [
      "hesitant",
      0.1075
    ],
    [
      "indetermine",
      0.075
    ],
    [
      "vague",
      0.045
    ],
    [
      "vacillant",
      0.045
    ],
    [
      "suspendu",
      0.045
    ],
    [
      "perplexe",
      0.045
    ],
    [
      "fluctuant",
      0.045
    ],
    [
      "mobile",
      0.03
    ],
    [
      "versatile",
      0.03
    ],
    [
      "nebuleux",
      0.0125
    ],
    [
      "lent",
      0.0125
    ],
    [
      "lanternier",
      0.0125
    ],
    [
      "indecide",
      0.0125
    ],
    [
      "embarrasse",
      0.0125
    ],
    [
      "pusillanime",
      0.0125
    ]
  ],
  "rein": [
    [
      "rognon",
      1.0
    ]
  ],
  "retenir": [
    [
      "tenir",
      0.09
    ],
    [
      "arreter",
      0.0825
    ],
    [
      "fixer",
      0.05
    ],
    [
      "contenir",
      0.0475
    ],
    [
      "attacher",
      0.045
    ],
    [
      "prendre",
      0.04
    ],
    [
      "endiguer",
      0.0275
    ],
    [
      "brider",
      0.0275
    ],
    [
      "empecher",
      0.0275
    ],
    [
      "immobiliser",
      0.0275
    ],
    [
      "maintenir",
      0.0275
    ],
    [
      "reprimer",
      0.025
    ],
    [
      "enchainer",
      0.0225
    ],
    [
      "freiner",
      0.0225
    ],
    [
      "accrocher",
      0.02
    ],
    [
      "etouffer",
      0.02
    ],
    [
      "refrener",
      0.02
    ],
    [
      "coincer",
      0.02
    ],
    [
      "bloquer",
      0.0175
    ],
    [
      "contraindre",
      0.0175
    ],
    [
      "moderer",
      0.015
    ],
    [
      "saisir",
      0.0125
    ],
    [
      "emprisonner",
      0.0125
    ],
    [
      "captiver",
      0.0125
    ],
    [
      "assurer",
      0.0125
    ],
    [
      "arrimer",
      0.0125
    ],
    [
      "comprimer",
      0.01
    ],
    [
      "absorber",
      0.01
    ],
    [
      "retrancher",
      0.0075
    ],
    [
      "refouler",
      0.0075
    ],
    [
      "maitriser",
      0.0075
    ],
    [
      "garder",
      0.0075
    ],
    [
      "agrafer",
      0.0075
    ],
    [
      "soustraire",
      0.005
    ],
    [
      "reserver",
      0.005
    ],
    [
      "prelever",
      0.005
    ],
    [
      "museler",
      0.005
    ],
    [
      "engager",
      0.005
    ],
    [
      "consigner",
      0.005
    ],
    [
      "conserver",
      0.005
    ],
    [
      "barrer",
      0.005
    ],
    [
      "etreindre",
      0.0025
    ],
    [
      "rentrer",
      0.0025
    ],
    [
      "enregistrer",
      0.0025
    ],
    [
      "confisquer",
      0.0025
    ],
    [
      "capter",
      0.0025
    ],
    [
      "avaler",
      0.0025
    ],
    [
      "enserrer",
      0.0025
    ],
    [
      "envahir",
      0.0025
    ],
    [
      "frapper",
      0.0025
    ],
    [
      "inviter",
      0.0025
    ],
    [
      "ralentir",
      0.0025
    ],
    [
      "rattacher",
      0.0025
    ],
    [
      "ravaler",
      0.0025
    ],
    [
      "s'assurer",
      0.0025
    ],
    [
      "devorer",
      0.0025
    ],
    [
      "detenir",
      0.0025
    ],
    [
      "agripper",
      0.0025
    ],
    [
      "amarrer",
      0.0025
    ],
    [
      "barricader",
      0.0025
    ],
    [
      "clouer",
      0.0025
    ],
    [
      "cramponner",
      0.0025
    ],
    [
      "decompter",
      0.0025
    ],
    [
      "deduire",
      0.0025
    ],
    [
      "defalquer",
      0.0025
    ],
    [
      "precompter",
      0.0
    ],
    [
      "rabattre",
      0.0
    ],
    [
      "s'opposer",
      0.0
    ],
    [
      "ecluser",
      0.0
    ],
    [
      "prier",
      0.0
    ],
    [
      "apprendre",
      0.0
    ],
    [
      "choisir",
      0.0
    ],
    [
      "decourager",
      0.0
    ],
    [
      "lever",
      0.0
    ],
    [
      "louer",
      0.0
    ],
    [
      "pacifier",
      0.0
    ],
    [
      "parer",
      0.0
    ],
    [
      "etancher",
      0.0
    ]
  ],
  "ile": [
    [
      "ilot",
      0.3325
    ],
    [
      "havre",
      0.165
    ],
    [
      "oasis",
      0.165
    ],
    [
      "terre",
      0.165
    ],
    [
      "ilet",
      0.165
    ]
  ],
  "nu": [
    [
      "vide",
      0.09
    ],
    [
      "denude",
      0.0575
    ],
    [
      "depouille",
      0.0475
    ],
    [
      "pele",
      0.0475
    ],
    [
      "aride",
      0.04
    ],
    [
      "simple",
      0.0325
    ],
    [
      "pauvre",
      0.0325
    ],
    [
      "net",
      0.0325
    ],
    [
      "image",
      0.0325
    ],
    [
      "depourvu",
      0.0325
    ],
    [
      "demuni",
      0.0325
    ],
    [
      "sobre",
      0.0225
    ],
    [
      "pur",
      0.0225
    ],
    [
      "modele",
      0.0225
    ],
    [
      "desert",
      0.0225
    ],
    [
      "denue",
      0.0225
    ],
    [
      "degarni",
      0.0225
    ],
    [
      "chauve",
      0.0225
    ],
    [
      "anatomie",
      0.0225
    ],
    [
      "academie",
      0.0225
    ],
    [
      "sterile",
      0.015
    ],
    [
      "sculpture",
      0.015
    ],
    [
      "ras",
      0.015
    ],
    [
      "polaire",
      0.015
    ],
    [
      "plastique",
      0.015
    ],
    [
      "peinture",
      0.015
    ],
    [
      "blanc",
      0.015
    ],
    [
      "austere",
      0.015
    ],
    [
      "glabre",
      0.005
    ],
    [
      "imberbe",
      0.005
    ],
    [
      "impudique",
      0.005
    ],
    [
      "monacal",
      0.005
    ],
    [
      "nudite",
      0.005
    ],
    [
      "necessiteux",
      0.005
    ],
    [
      "sujet",
      0.005
    ],
    [
      "tableau",
      0.005
    ],
    [
      "abandonne",
      0.005
    ],
    [
      "beaute",
      0.005
    ],
    [
      "dessin",
      0.005
    ],
    [
      "decouvert",
      0.005
    ],
    [
      "defeuille",
      0.005
    ],
    [
      "deplume",
      0.005
    ],
    [
      "deshabille",
      0.005
    ],
    [
      "devaste",
      0.005
    ],
    [
      "devoile",
      0.005
    ],
    [
      "devetu",
      0.005
    ]
  ],
  "rejoindre": [
    [
      "joindre",
      0.1225
    ],
    [
      "retrouver",
      0.1075
    ],
    [
      "atteindre",
      0.09
    ],
    [
      "rallier",
      0.075
    ],
    [
      "revenir",
      0.045
    ],
    [
      "regagner",
      0.045
    ],
    [
      "passer",
      0.045
    ],
    [
      "gagner",
      0.045
    ],
    [
      "adherer",
      0.045
    ],
    [
      "trouver",
      0.03
    ],
    [
      "s'affilier",
      0.03
    ],
    [
      "reunir",
      0.03
    ],
    [
      "rentrer",
      0.03
    ],
    [
      "rencontrer",
      0.03
    ],
    [
      "rattraper",
      0.03
    ],
    [
      "attraper",
      0.03
    ],
    [
      "retourner",
      0.015
    ],
    [
      "renouer",
      0.015
    ],
    [
      "rapprocher",
      0.015
    ],
    [
      "contacter",
      0.015
    ],
    [
      "confluer",
      0.015
    ],
    [
      "tomber",
      0.015
    ]
  ],
  "issu": [
    [
      "descendant",
      0.1425
    ],
    [
      "derive",
      0.1425
    ],
    [
      "natif",
      0.1425
    ],
    [
      "ne",
      0.1425
    ],
    [
      "originaire",
      0.1425
    ],
    [
      "resultant",
      0.1425
    ],
    [
      "sorti",
      0.1425
    ]
  ],
  "issue": [
    [
      "descendant",
      0.1425
    ],
    [
      "derive",
      0.1425
    ],
    [
      "natif",
      0.1425
    ],
    [
      "ne",
      0.1425
    ],
    [
      "originaire",
      0.1425
    ],
    [
      "resultant",
      0.1425
    ],
    [
      "sorti",
      0.1425
    ]
  ],
  "habiter": [
    [
      "loger",
      0.0975
    ],
    [
      "demeurer",
      0.09
    ],
    [
      "resider",
      0.08
    ],
    [
      "sejourner",
      0.06
    ],
    [
      "vivre",
      0.0425
    ],
    [
      "s'etablir",
      0.0425
    ],
    [
      "hanter",
      0.0425
    ],
    [
      "giter",
      0.0425
    ],
    [
      "nicher",
      0.035
    ],
    [
      "s'installer",
      0.035
    ],
    [
      "travailler",
      0.025
    ],
    [
      "rester",
      0.025
    ],
    [
      "obseder",
      0.025
    ],
    [
      "exister",
      0.025
    ],
    [
      "camper",
      0.025
    ],
    [
      "poursuivre",
      0.0175
    ],
    [
      "posseder",
      0.0175
    ],
    [
      "occuper",
      0.0175
    ],
    [
      "frequenter",
      0.0175
    ],
    [
      "crecher",
      0.0175
    ],
    [
      "sieger",
      0.0075
    ],
    [
      "regner",
      0.0075
    ],
    [
      "preoccuper",
      0.0075
    ],
    [
      "percher",
      0.0075
    ],
    [
      "harceler",
      0.0075
    ],
    [
      "coucher",
      0.0075
    ],
    [
      "cabaner",
      0.0075
    ],
    [
      "animer",
      0.0075
    ]
  ],
  "maman": [
    [
      "mere",
      1.0
    ]
  ],
  "vieil": [
    [
      "vieux",
      1.0
    ]
  ],
  "appartement": [
    [
      "logement",
      0.1175
    ],
    [
      "chambre",
      0.0875
    ],
    [
      "maison",
      0.0875
    ],
    [
      "studio",
      0.0875
    ],
    [
      "taudis",
      0.0575
    ],
    [
      "piece",
      0.0575
    ],
    [
      "loge",
      0.0575
    ],
    [
      "habitation",
      0.0575
    ],
    [
      "bouge",
      0.0575
    ],
    [
      "bauge",
      0.0575
    ],
    [
      "meuble",
      0.0275
    ],
    [
      "logis",
      0.0275
    ],
    [
      "loft",
      0.0275
    ],
    [
      "harem",
      0.0275
    ],
    [
      "gynecee",
      0.0275
    ],
    [
      "garconniere",
      0.0275
    ],
    [
      "pigeonnier",
      0.0275
    ]
  ],
  "compagnie": [
    [
      "societe",
      0.09
    ],
    [
      "groupe",
      0.075
    ],
    [
      "troupe",
      0.075
    ],
    [
      "association",
      0.0675
    ],
    [
      "bande",
      0.0675
    ],
    [
      "reunion",
      0.0675
    ],
    [
      "colonie",
      0.045
    ],
    [
      "corps",
      0.045
    ],
    [
      "entourage",
      0.0375
    ],
    [
      "communaute",
      0.0375
    ],
    [
      "agglomeration",
      0.0375
    ],
    [
      "assemblee",
      0.03
    ],
    [
      "cercle",
      0.03
    ],
    [
      "harde",
      0.03
    ],
    [
      "unite",
      0.03
    ],
    [
      "milieu",
      0.0225
    ],
    [
      "armee",
      0.0225
    ],
    [
      "horde",
      0.0125
    ],
    [
      "environnement",
      0.0125
    ],
    [
      "congregation",
      0.0125
    ],
    [
      "bataillon",
      0.0125
    ],
    [
      "assistance",
      0.0125
    ],
    [
      "accompagnement",
      0.0125
    ],
    [
      "presence",
      0.005
    ],
    [
      "frequentation",
      0.005
    ],
    [
      "conseil",
      0.005
    ],
    [
      "compagnon",
      0.005
    ],
    [
      "compagne",
      0.005
    ],
    [
      "comite",
      0.005
    ],
    [
      "college",
      0.005
    ],
    [
      "caravane",
      0.005
    ],
    [
      "cadre",
      0.005
    ],
    [
      "areopage",
      0.005
    ],
    [
      "ambiance",
      0.005
    ],
    [
      "theatre",
      0.005
    ]
  ],
  "tortu": [
    [
      "tordu",
      0.2575
    ],
    [
      "tortueux",
      0.1175
    ],
    [
      "courbe",
      0.0675
    ],
    [
      "tors",
      0.0675
    ],
    [
      "retors",
      0.045
    ],
    [
      "fourbe",
      0.045
    ],
    [
      "faux",
      0.045
    ],
    [
      "cagneux",
      0.045
    ],
    [
      "bancal",
      0.045
    ],
    [
      "tortue",
      0.0225
    ],
    [
      "tortille",
      0.0225
    ],
    [
      "sinueux",
      0.0225
    ],
    [
      "roublard",
      0.0225
    ],
    [
      "entortille",
      0.0225
    ],
    [
      "croche",
      0.0225
    ],
    [
      "circonflexe",
      0.0225
    ],
    [
      "bancroche",
      0.0225
    ],
    [
      "arque",
      0.0225
    ],
    [
      "vrille",
      0.0225
    ]
  ],
  "tortue": [
    [
      "tordu",
      0.2575
    ],
    [
      "tortueux",
      0.1175
    ],
    [
      "courbe",
      0.0675
    ],
    [
      "tors",
      0.0675
    ],
    [
      "retors",
      0.045
    ],
    [
      "fourbe",
      0.045
    ],
    [
      "faux",
      0.045
    ],
    [
      "cagneux",
      0.045
    ],
    [
      "bancal",
      0.045
    ],
    [
      "tortue",
      0.0225
    ],
    [
      "tortille",
      0.0225
    ],
    [
      "sinueux",
      0.0225
    ],
    [
      "roublard",
      0.0225
    ],
    [
      "entortille",
      0.0225
    ],
    [
      "croche",
      0.0225
    ],
    [
      "circonflexe",
      0.0225
    ],
    [
      "bancroche",
      0.0225
    ],
    [
      "arque",
      0.0225
    ],
    [
      "vrille",
      0.0225
    ]
  ],
  "canari": [
    [
      "serin",
      1.0
    ]
  ],
  "chat": [
    [
      "minet",
      0.1425
    ],
    [
      "mimi",
      0.07
    ],
    [
      "minon",
      0.07
    ],
    [
      "minou",
      0.07
    ],
    [
      "mistigri",
      0.07
    ],
    [
      "matou",
      0.0325
    ],
    [
      "miaou",
      0.0325
    ],
    [
      "moumoute",
      0.0325
    ],
    [
      "ocelot",
      0.0325
    ],
    [
      "once",
      0.0325
    ],
    [
      "raminagrobis",
      0.0325
    ],
    [
      "margay",
      0.0325
    ],
    [
      "lynx",
      0.0325
    ],
    [
      "haret",
      0.0325
    ],
    [
      "grippeminaud",
      0.0325
    ],
    [
      "greffier",
      0.0325
    ],
    [
      "grappin",
      0.0325
    ],
    [
      "felin",
      0.0325
    ],
    [
      "chaton",
      0.0325
    ],
    [
      "biquet",
      0.0325
    ],
    [
      "serval",
      0.0325
    ]
  ],
  "laisser": [
    [
      "abandonner",
      0.12
    ],
    [
      "donner",
      0.0925
    ],
    [
      "ceder",
      0.07
    ],
    [
      "quitter",
      0.065
    ],
    [
      "renoncer",
      0.0525
    ],
    [
      "passer",
      0.0425
    ],
    [
      "lacher",
      0.0425
    ],
    [
      "aliener",
      0.035
    ],
    [
      "remettre",
      0.03
    ],
    [
      "oublier",
      0.03
    ],
    [
      "delaisser",
      0.03
    ],
    [
      "vendre",
      0.025
    ],
    [
      "deposer",
      0.02
    ],
    [
      "mettre",
      0.02
    ],
    [
      "transmettre",
      0.015
    ],
    [
      "tolerer",
      0.015
    ],
    [
      "planter",
      0.015
    ],
    [
      "permettre",
      0.015
    ],
    [
      "perdre",
      0.015
    ],
    [
      "negliger",
      0.015
    ],
    [
      "leguer",
      0.015
    ],
    [
      "livrer",
      0.015
    ],
    [
      "semer",
      0.0125
    ],
    [
      "plaquer",
      0.0125
    ],
    [
      "omettre",
      0.0125
    ],
    [
      "consentir",
      0.0125
    ],
    [
      "cesser",
      0.0125
    ],
    [
      "solder",
      0.0075
    ],
    [
      "offrir",
      0.0075
    ],
    [
      "manquer",
      0.0075
    ],
    [
      "immoler",
      0.0075
    ],
    [
      "confier",
      0.0075
    ],
    [
      "autoriser",
      0.0075
    ],
    [
      "abjurer",
      0.0025
    ],
    [
      "camper",
      0.0025
    ],
    [
      "marquer",
      0.0025
    ],
    [
      "souffrir",
      0.0025
    ]
  ],
  "reposer": [
    [
      "appuyer",
      0.115
    ],
    [
      "poser",
      0.085
    ],
    [
      "etablir",
      0.055
    ],
    [
      "s'appuyer",
      0.055
    ],
    [
      "rouler",
      0.055
    ],
    [
      "porter",
      0.055
    ],
    [
      "fonder",
      0.055
    ],
    [
      "deposer",
      0.055
    ],
    [
      "sommeiller",
      0.0275
    ],
    [
      "somnoler",
      0.0275
    ],
    [
      "resider",
      0.0275
    ],
    [
      "remettre",
      0.0275
    ],
    [
      "rasseoir",
      0.0275
    ],
    [
      "detendre",
      0.0275
    ],
    [
      "dependre",
      0.0275
    ],
    [
      "delasser",
      0.0275
    ],
    [
      "dormir",
      0.0275
    ],
    [
      "consister",
      0.0275
    ],
    [
      "baser",
      0.0275
    ],
    [
      "etanconner",
      0.0275
    ]
  ],
  "marcher": [
    [
      "marche",
      1.0
    ]
  ],
  "marche": [
    [
      "cours",
      0.065
    ],
    [
      "mouvement",
      0.0575
    ],
    [
      "allure",
      0.045
    ],
    [
      "evolution",
      0.0425
    ],
    [
      "developpement",
      0.0375
    ],
    [
      "progression",
      0.0375
    ],
    [
      "progres",
      0.0375
    ],
    [
      "tour",
      0.0375
    ],
    [
      "train",
      0.03
    ],
    [
      "demarche",
      0.03
    ],
    [
      "course",
      0.03
    ],
    [
      "tournure",
      0.025
    ],
    [
      "avancement",
      0.0225
    ],
    [
      "pas",
      0.0225
    ],
    [
      "voie",
      0.0225
    ],
    [
      "trajet",
      0.0175
    ],
    [
      "promenade",
      0.0175
    ],
    [
      "procede",
      0.0175
    ],
    [
      "processus",
      0.0175
    ],
    [
      "forme",
      0.0175
    ],
    [
      "conduite",
      0.0175
    ],
    [
      "cheminement",
      0.0175
    ],
    [
      "tactique",
      0.015
    ],
    [
      "methode",
      0.015
    ],
    [
      "moyen",
      0.015
    ],
    [
      "facon",
      0.015
    ],
    [
      "defile",
      0.015
    ],
    [
      "direction",
      0.015
    ],
    [
      "avance",
      0.015
    ],
    [
      "travail",
      0.01
    ],
    [
      "manoeuvre",
      0.01
    ],
    [
      "courant",
      0.01
    ],
    [
      "theorie",
      0.0075
    ],
    [
      "propagation",
      0.0075
    ],
    [
      "foulee",
      0.0075
    ],
    [
      "fonctionnement",
      0.0075
    ],
    [
      "deroulement",
      0.0075
    ],
    [
      "deplacement",
      0.0075
    ],
    [
      "degre",
      0.0075
    ],
    [
      "cavalcade",
      0.0075
    ],
    [
      "activite",
      0.0075
    ],
    [
      "procession",
      0.0025
    ],
    [
      "marquisat",
      0.0025
    ],
    [
      "marcher",
      0.0025
    ],
    [
      "manifestation",
      0.0025
    ],
    [
      "locomotion",
      0.0025
    ],
    [
      "proces",
      0.0025
    ],
    [
      "province",
      0.0025
    ],
    [
      "randonnee",
      0.0025
    ],
    [
      "repetition",
      0.0025
    ],
    [
      "revolution",
      0.0025
    ],
    [
      "transmission",
      0.0025
    ],
    [
      "echelle",
      0.0025
    ],
    [
      "limite",
      0.0025
    ],
    [
      "impulsion",
      0.0025
    ],
    [
      "acheminement",
      0.0025
    ],
    [
      "ambulation",
      0.0025
    ],
    [
      "ascendance",
      0.0025
    ],
    [
      "avancee",
      0.0025
    ],
    [
      "deambulation",
      0.0025
    ],
    [
      "erre",
      0.0025
    ],
    [
      "excursion",
      0.0025
    ],
    [
      "flanerie",
      0.0025
    ],
    [
      "footing",
      0.0025
    ],
    [
      "frontiere",
      0.0025
    ],
    [
      "gradin",
      0.0025
    ],
    [
      "hymne",
      0.0025
    ],
    [
      "echelon",
      0.0025
    ]
  ],
  "cuisiner": [
    [
      "preparer",
      0.1675
    ],
    [
      "mijoter",
      0.0825
    ],
    [
      "manigancer",
      0.0825
    ],
    [
      "fricoter",
      0.0825
    ],
    [
      "fricasser",
      0.0825
    ],
    [
      "cuire",
      0.0825
    ],
    [
      "arranger",
      0.0825
    ],
    [
      "questionner",
      0.04
    ],
    [
      "mitonner",
      0.04
    ],
    [
      "interroger",
      0.04
    ],
    [
      "influer",
      0.04
    ],
    [
      "demander",
      0.04
    ],
    [
      "appreter",
      0.04
    ],
    [
      "accommoder",
      0.04
    ],
    [
      "rotir",
      0.04
    ]
  ],
  "cuisine": [
    [
      "repas",
      0.11
    ],
    [
      "nourriture",
      0.0775
    ],
    [
      "mets",
      0.065
    ],
    [
      "tripotage",
      0.065
    ],
    [
      "chere",
      0.0375
    ],
    [
      "menu",
      0.0375
    ],
    [
      "soupe",
      0.0325
    ],
    [
      "ordinaire",
      0.0325
    ],
    [
      "mangeaille",
      0.0325
    ],
    [
      "intrigue",
      0.0325
    ],
    [
      "bouffe",
      0.0325
    ],
    [
      "alimentation",
      0.0325
    ],
    [
      "popote",
      0.025
    ],
    [
      "grenouillage",
      0.025
    ],
    [
      "gastronomie",
      0.025
    ],
    [
      "trafic",
      0.0175
    ],
    [
      "manoeuvre",
      0.0175
    ],
    [
      "manigance",
      0.0175
    ],
    [
      "manger",
      0.0175
    ],
    [
      "magouille",
      0.0175
    ],
    [
      "tambouille",
      0.0125
    ],
    [
      "table",
      0.0125
    ],
    [
      "ratatouille",
      0.0125
    ],
    [
      "rata",
      0.0125
    ],
    [
      "maquignonnage",
      0.0125
    ],
    [
      "machinerie",
      0.0125
    ],
    [
      "fricot",
      0.0125
    ],
    [
      "croute",
      0.0125
    ],
    [
      "cantine",
      0.0125
    ],
    [
      "bouffetance",
      0.0125
    ],
    [
      "aliment",
      0.0125
    ],
    [
      "frichti",
      0.005
    ],
    [
      "fricotage",
      0.005
    ],
    [
      "gastrologie",
      0.005
    ],
    [
      "graille",
      0.005
    ],
    [
      "kitchenette",
      0.005
    ],
    [
      "office",
      0.005
    ],
    [
      "cuistance",
      0.005
    ],
    [
      "coqueron",
      0.005
    ],
    [
      "coquerie",
      0.005
    ],
    [
      "combinaison",
      0.005
    ],
    [
      "charcuterie",
      0.005
    ],
    [
      "cambuse",
      0.005
    ],
    [
      "agissements",
      0.005
    ],
    [
      "preparation",
      0.005
    ]
  ],
  "ranger": [
    [
      "botte",
      0.3325
    ],
    [
      "brodequin",
      0.3325
    ]
  ],
  "essuyer": [
    [
      "recevoir",
      0.115
    ],
    [
      "souffrir",
      0.115
    ],
    [
      "boire",
      0.0925
    ],
    [
      "nettoyer",
      0.0675
    ],
    [
      "subir",
      0.0675
    ],
    [
      "secher",
      0.0675
    ],
    [
      "etancher",
      0.045
    ],
    [
      "eprouver",
      0.045
    ],
    [
      "eponger",
      0.045
    ],
    [
      "prendre",
      0.045
    ],
    [
      "frotter",
      0.045
    ],
    [
      "endurer",
      0.045
    ],
    [
      "encaisser",
      0.045
    ],
    [
      "assecher",
      0.0225
    ],
    [
      "bouchonner",
      0.0225
    ],
    [
      "depoussierer",
      0.0225
    ],
    [
      "empocher",
      0.0225
    ],
    [
      "torcher",
      0.0225
    ],
    [
      "epousseter",
      0.0225
    ]
  ],
  "essuie": [
    [
      "recevoir",
      0.115
    ],
    [
      "souffrir",
      0.115
    ],
    [
      "boire",
      0.0925
    ],
    [
      "nettoyer",
      0.0675
    ],
    [
      "subir",
      0.0675
    ],
    [
      "secher",
      0.0675
    ],
    [
      "etancher",
      0.045
    ],
    [
      "eprouver",
      0.045
    ],
    [
      "eponger",
      0.045
    ],
    [
      "prendre",
      0.045
    ],
    [
      "frotter",
      0.045
    ],
    [
      "endurer",
      0.045
    ],
    [
      "encaisser",
      0.045
    ],
    [
      "assecher",
      0.0225
    ],
    [
      "bouchonner",
      0.0225
    ],
    [
      "depoussierer",
      0.0225
    ],
    [
      "empocher",
      0.0225
    ],
    [
      "torcher",
      0.0225
    ],
    [
      "epousseter",
      0.0225
    ]
  ],
  "occasion": [
    [
      "circonstance",
      0.1175
    ],
    [
      "cas",
      0.105
    ],
    [
      "hasard",
      0.0625
    ],
    [
      "evenement",
      0.0625
    ],
    [
      "temps",
      0.055
    ],
    [
      "rencontre",
      0.05
    ],
    [
      "cause",
      0.0425
    ],
    [
      "sujet",
      0.0375
    ],
    [
      "possibilite",
      0.0375
    ],
    [
      "matiere",
      0.0375
    ],
    [
      "chance",
      0.0375
    ],
    [
      "pretexte",
      0.03
    ],
    [
      "eventualite",
      0.03
    ],
    [
      "accident",
      0.025
    ],
    [
      "affaire",
      0.025
    ],
    [
      "conjoncture",
      0.025
    ],
    [
      "incident",
      0.025
    ],
    [
      "lieu",
      0.025
    ],
    [
      "occurrence",
      0.0175
    ],
    [
      "aubaine",
      0.0125
    ],
    [
      "terrain",
      0.0125
    ],
    [
      "raison",
      0.0125
    ],
    [
      "moyen",
      0.0125
    ],
    [
      "motif",
      0.0125
    ],
    [
      "moment",
      0.0125
    ],
    [
      "facilite",
      0.0125
    ],
    [
      "rossignol",
      0.005
    ],
    [
      "opportunite",
      0.005
    ],
    [
      "occase",
      0.005
    ],
    [
      "loisir",
      0.005
    ],
    [
      "incidence",
      0.005
    ],
    [
      "heure",
      0.005
    ],
    [
      "coincidence",
      0.005
    ],
    [
      "champ",
      0.005
    ],
    [
      "solde",
      0.005
    ]
  ],
  "piquer": [
    [
      "prendre",
      0.085
    ],
    [
      "voler",
      0.0325
    ],
    [
      "attraper",
      0.0275
    ],
    [
      "derober",
      0.0275
    ],
    [
      "exciter",
      0.025
    ],
    [
      "blesser",
      0.0225
    ],
    [
      "saisir",
      0.02
    ],
    [
      "faire",
      0.02
    ],
    [
      "chiper",
      0.02
    ],
    [
      "faucher",
      0.0175
    ],
    [
      "gagner",
      0.0175
    ],
    [
      "irriter",
      0.0175
    ],
    [
      "pincer",
      0.0175
    ],
    [
      "froisser",
      0.015
    ],
    [
      "pousser",
      0.015
    ],
    [
      "percer",
      0.015
    ],
    [
      "attaquer",
      0.0125
    ],
    [
      "atteindre",
      0.0125
    ],
    [
      "choper",
      0.0125
    ],
    [
      "emouvoir",
      0.0125
    ],
    [
      "s'emparer",
      0.0125
    ],
    [
      "facher",
      0.0125
    ],
    [
      "enflammer",
      0.0125
    ],
    [
      "cueillir",
      0.0125
    ],
    [
      "agacer",
      0.0125
    ],
    [
      "transpercer",
      0.01
    ],
    [
      "tirer",
      0.01
    ],
    [
      "surprendre",
      0.01
    ],
    [
      "soulever",
      0.01
    ],
    [
      "ramasser",
      0.01
    ],
    [
      "piqueter",
      0.01
    ],
    [
      "indisposer",
      0.01
    ],
    [
      "entamer",
      0.01
    ],
    [
      "bruler",
      0.01
    ],
    [
      "aller",
      0.01
    ],
    [
      "epingler",
      0.0075
    ],
    [
      "offenser",
      0.0075
    ],
    [
      "foncer",
      0.0075
    ],
    [
      "chatouiller",
      0.0075
    ],
    [
      "attiser",
      0.0075
    ],
    [
      "attacher",
      0.0075
    ],
    [
      "pointer",
      0.0075
    ],
    [
      "s'elancer",
      0.0075
    ],
    [
      "sauter",
      0.0075
    ],
    [
      "subtiliser",
      0.0075
    ],
    [
      "poindre",
      0.0075
    ],
    [
      "mordre",
      0.0075
    ],
    [
      "aiguillonner",
      0.0075
    ],
    [
      "chiffonner",
      0.0075
    ],
    [
      "empoigner",
      0.0075
    ],
    [
      "enfoncer",
      0.0075
    ],
    [
      "escamoter",
      0.0075
    ],
    [
      "gratter",
      0.0075
    ],
    [
      "interesser",
      0.005
    ],
    [
      "picoter",
      0.005
    ],
    [
      "souffler",
      0.005
    ],
    [
      "taquiner",
      0.005
    ],
    [
      "turlupiner",
      0.005
    ],
    [
      "vexer",
      0.005
    ],
    [
      "fondre",
      0.005
    ],
    [
      "fixer",
      0.005
    ],
    [
      "ennuyer",
      0.005
    ],
    [
      "aigrir",
      0.005
    ],
    [
      "arreter",
      0.005
    ],
    [
      "choquer",
      0.005
    ],
    [
      "contracter",
      0.005
    ],
    [
      "couper",
      0.005
    ],
    [
      "desobliger",
      0.005
    ],
    [
      "eveiller",
      0.0025
    ],
    [
      "eperonner",
      0.0025
    ],
    [
      "egratigner",
      0.0025
    ],
    [
      "tacheter",
      0.0025
    ],
    [
      "surexciter",
      0.0025
    ],
    [
      "soustraire",
      0.0025
    ],
    [
      "pointiller",
      0.0025
    ],
    [
      "barboter",
      0.0025
    ],
    [
      "cuire",
      0.0025
    ],
    [
      "ficher",
      0.0025
    ],
    [
      "fuser",
      0.0025
    ],
    [
      "plonger",
      0.0025
    ],
    [
      "parsemer",
      0.0025
    ],
    [
      "piper",
      0.0025
    ],
    [
      "planter",
      0.0025
    ],
    [
      "ratiboiser",
      0.0025
    ],
    [
      "ronger",
      0.0025
    ],
    [
      "tomber",
      0.0025
    ],
    [
      "tracer",
      0.0025
    ],
    [
      "moucheter",
      0.0025
    ],
    [
      "larder",
      0.0025
    ],
    [
      "intriguer",
      0.0025
    ],
    [
      "coincer",
      0.0025
    ],
    [
      "coudre",
      0.0025
    ],
    [
      "cribler",
      0.0025
    ],
    [
      "demanger",
      0.0025
    ],
    [
      "detacher",
      0.0025
    ],
    [
      "filouter",
      0.0025
    ],
    [
      "harponner",
      0.0025
    ],
    [
      "impressionner",
      0.0025
    ],
    [
      "inoculer",
      0.0
    ],
    [
      "kidnapper",
      0.0
    ],
    [
      "marauder",
      0.0
    ],
    [
      "offusquer",
      0.0
    ],
    [
      "outrager",
      0.0
    ],
    [
      "trouer",
      0.0
    ],
    [
      "immuniser",
      0.0
    ],
    [
      "ferrer",
      0.0
    ],
    [
      "faufiler",
      0.0
    ],
    [
      "encourager",
      0.0
    ],
    [
      "darder",
      0.0
    ],
    [
      "critiquer",
      0.0
    ],
    [
      "cravater",
      0.0
    ],
    [
      "contrepointer",
      0.0
    ],
    [
      "ailler",
      0.0
    ],
    [
      "vacciner",
      0.0
    ]
  ],
  "pique": [
    [
      "prendre",
      0.085
    ],
    [
      "voler",
      0.0325
    ],
    [
      "attraper",
      0.0275
    ],
    [
      "derober",
      0.0275
    ],
    [
      "exciter",
      0.025
    ],
    [
      "blesser",
      0.0225
    ],
    [
      "saisir",
      0.02
    ],
    [
      "faire",
      0.02
    ],
    [
      "chiper",
      0.02
    ],
    [
      "faucher",
      0.0175
    ],
    [
      "gagner",
      0.0175
    ],
    [
      "irriter",
      0.0175
    ],
    [
      "pincer",
      0.0175
    ],
    [
      "froisser",
      0.015
    ],
    [
      "pousser",
      0.015
    ],
    [
      "percer",
      0.015
    ],
    [
      "attaquer",
      0.0125
    ],
    [
      "atteindre",
      0.0125
    ],
    [
      "choper",
      0.0125
    ],
    [
      "emouvoir",
      0.0125
    ],
    [
      "s'emparer",
      0.0125
    ],
    [
      "facher",
      0.0125
    ],
    [
      "enflammer",
      0.0125
    ],
    [
      "cueillir",
      0.0125
    ],
    [
      "agacer",
      0.0125
    ],
    [
      "transpercer",
      0.01
    ],
    [
      "tirer",
      0.01
    ],
    [
      "surprendre",
      0.01
    ],
    [
      "soulever",
      0.01
    ],
    [
      "ramasser",
      0.01
    ],
    [
      "piqueter",
      0.01
    ],
    [
      "indisposer",
      0.01
    ],
    [
      "entamer",
      0.01
    ],
    [
      "bruler",
      0.01
    ],
    [
      "aller",
      0.01
    ],
    [
      "epingler",
      0.0075
    ],
    [
      "offenser",
      0.0075
    ],
    [
      "foncer",
      0.0075
    ],
    [
      "chatouiller",
      0.0075
    ],
    [
      "attiser",
      0.0075
    ],
    [
      "attacher",
      0.0075
    ],
    [
      "pointer",
      0.0075
    ],
    [
      "s'elancer",
      0.0075
    ],
    [
      "sauter",
      0.0075
    ],
    [
      "subtiliser",
      0.0075
    ],
    [
      "poindre",
      0.0075
    ],
    [
      "mordre",
      0.0075
    ],
    [
      "aiguillonner",
      0.0075
    ],
    [
      "chiffonner",
      0.0075
    ],
    [
      "empoigner",
      0.0075
    ],
    [
      "enfoncer",
      0.0075
    ],
    [
      "escamoter",
      0.0075
    ],
    [
      "gratter",
      0.0075
    ],
    [
      "interesser",
      0.005
    ],
    [
      "picoter",
      0.005
    ],
    [
      "souffler",
      0.005
    ],
    [
      "taquiner",
      0.005
    ],
    [
      "turlupiner",
      0.005
    ],
    [
      "vexer",
      0.005
    ],
    [
      "fondre",
      0.005
    ],
    [
      "fixer",
      0.005
    ],
    [
      "ennuyer",
      0.005
    ],
    [
      "aigrir",
      0.005
    ],
    [
      "arreter",
      0.005
    ],
    [
      "choquer",
      0.005
    ],
    [
      "contracter",
      0.005
    ],
    [
      "couper",
      0.005
    ],
    [
      "desobliger",
      0.005
    ],
    [
      "eveiller",
      0.0025
    ],
    [
      "eperonner",
      0.0025
    ],
    [
      "egratigner",
      0.0025
    ],
    [
      "tacheter",
      0.0025
    ],
    [
      "surexciter",
      0.0025
    ],
    [
      "soustraire",
      0.0025
    ],
    [
      "pointiller",
      0.0025
    ],
    [
      "barboter",
      0.0025
    ],
    [
      "cuire",
      0.0025
    ],
    [
      "ficher",
      0.0025
    ],
    [
      "fuser",
      0.0025
    ],
    [
      "plonger",
      0.0025
    ],
    [
      "parsemer",
      0.0025
    ],
    [
      "piper",
      0.0025
    ],
    [
      "planter",
      0.0025
    ],
    [
      "ratiboiser",
      0.0025
    ],
    [
      "ronger",
      0.0025
    ],
    [
      "tomber",
      0.0025
    ],
    [
      "tracer",
      0.0025
    ],
    [
      "moucheter",
      0.0025
    ],
    [
      "larder",
      0.0025
    ],
    [
      "intriguer",
      0.0025
    ],
    [
      "coincer",
      0.0025
    ],
    [
      "coudre",
      0.0025
    ],
    [
      "cribler",
      0.0025
    ],
    [
      "demanger",
      0.0025
    ],
    [
      "detacher",
      0.0025
    ],
    [
      "filouter",
      0.0025
    ],
    [
      "harponner",
      0.0025
    ],
    [
      "impressionner",
      0.0025
    ],
    [
      "inoculer",
      0.0
    ],
    [
      "kidnapper",
      0.0
    ],
    [
      "marauder",
      0.0
    ],
    [
      "offusquer",
      0.0
    ],
    [
      "outrager",
      0.0
    ],
    [
      "trouer",
      0.0
    ],
    [
      "immuniser",
      0.0
    ],
    [
      "ferrer",
      0.0
    ],
    [
      "faufiler",
      0.0
    ],
    [
      "encourager",
      0.0
    ],
    [
      "darder",
      0.0
    ],
    [
      "critiquer",
      0.0
    ],
    [
      "cravater",
      0.0
    ],
    [
      "contrepointer",
      0.0
    ],
    [
      "ailler",
      0.0
    ],
    [
      "vacciner",
      0.0
    ]
  ],
  "decorateur": [
    [
      "antiquaire",
      0.2
    ],
    [
      "architecte",
      0.2
    ],
    [
      "artiste",
      0.2
    ],
    [
      "dessinateur",
      0.2
    ],
    [
      "ensemblier",
      0.2
    ]
  ],
  "styliste": [
    [
      "designer",
      0.5
    ],
    [
      "ecrivain",
      0.5
    ]
  ],
  "metier": [
    [
      "situation",
      0.0825
    ],
    [
      "travail",
      0.0825
    ],
    [
      "emploi",
      0.075
    ],
    [
      "fonction",
      0.075
    ],
    [
      "profession",
      0.075
    ],
    [
      "habilete",
      0.0675
    ],
    [
      "etat",
      0.0475
    ],
    [
      "technique",
      0.04
    ],
    [
      "position",
      0.04
    ],
    [
      "place",
      0.04
    ],
    [
      "art",
      0.0325
    ],
    [
      "experience",
      0.025
    ],
    [
      "occupation",
      0.025
    ],
    [
      "pratique",
      0.025
    ],
    [
      "maitrise",
      0.02
    ],
    [
      "job",
      0.02
    ],
    [
      "industrie",
      0.02
    ],
    [
      "faire",
      0.02
    ],
    [
      "specialite",
      0.0125
    ],
    [
      "role",
      0.0125
    ],
    [
      "qualification",
      0.0125
    ],
    [
      "condition",
      0.0125
    ],
    [
      "carriere",
      0.0125
    ],
    [
      "capacite",
      0.0125
    ],
    [
      "partie",
      0.005
    ],
    [
      "office",
      0.005
    ],
    [
      "mecanique",
      0.005
    ],
    [
      "ingeniosite",
      0.005
    ],
    [
      "corporation",
      0.005
    ],
    [
      "boulot",
      0.005
    ],
    [
      "appareil",
      0.005
    ],
    [
      "virtuosite",
      0.005
    ]
  ],
  "exercer": [
    [
      "former",
      0.1
    ],
    [
      "instruire",
      0.07
    ],
    [
      "cultiver",
      0.065
    ],
    [
      "styler",
      0.065
    ],
    [
      "habituer",
      0.0575
    ],
    [
      "faire",
      0.0575
    ],
    [
      "faconner",
      0.05
    ],
    [
      "pratiquer",
      0.05
    ],
    [
      "dresser",
      0.0425
    ],
    [
      "entrainer",
      0.0425
    ],
    [
      "eduquer",
      0.0425
    ],
    [
      "apprendre",
      0.0275
    ],
    [
      "aguerrir",
      0.02
    ],
    [
      "eprouver",
      0.02
    ],
    [
      "rompre",
      0.02
    ],
    [
      "produire",
      0.02
    ],
    [
      "executer",
      0.02
    ],
    [
      "developper",
      0.02
    ],
    [
      "user",
      0.0125
    ],
    [
      "tenir",
      0.0125
    ],
    [
      "remplir",
      0.0125
    ],
    [
      "professer",
      0.0125
    ],
    [
      "initier",
      0.0125
    ],
    [
      "endurcir",
      0.0125
    ],
    [
      "employer",
      0.0125
    ],
    [
      "deployer",
      0.0125
    ],
    [
      "s'acquitter",
      0.005
    ],
    [
      "plier",
      0.005
    ],
    [
      "perfectionner",
      0.005
    ],
    [
      "offrir",
      0.005
    ],
    [
      "influer",
      0.005
    ],
    [
      "acquitter",
      0.005
    ]
  ],
  "travestir": [
    [
      "deguiser",
      0.1325
    ],
    [
      "alterer",
      0.08
    ],
    [
      "maquiller",
      0.07
    ],
    [
      "farder",
      0.06
    ],
    [
      "masquer",
      0.06
    ],
    [
      "fausser",
      0.0525
    ],
    [
      "denaturer",
      0.0525
    ],
    [
      "deformer",
      0.0525
    ],
    [
      "dissimuler",
      0.0525
    ],
    [
      "defigurer",
      0.0425
    ],
    [
      "habiller",
      0.035
    ],
    [
      "voiler",
      0.025
    ],
    [
      "transformer",
      0.025
    ],
    [
      "falsifier",
      0.025
    ],
    [
      "contrefaire",
      0.025
    ],
    [
      "changer",
      0.025
    ],
    [
      "camoufler",
      0.025
    ],
    [
      "cacher",
      0.025
    ],
    [
      "fringuer",
      0.0175
    ],
    [
      "revetir",
      0.0175
    ],
    [
      "parodier",
      0.0075
    ],
    [
      "pallier",
      0.0075
    ],
    [
      "metamorphoser",
      0.0075
    ],
    [
      "modifier",
      0.0075
    ],
    [
      "interpoler",
      0.0075
    ],
    [
      "costumer",
      0.0075
    ],
    [
      "celer",
      0.0075
    ],
    [
      "affubler",
      0.0075
    ],
    [
      "peindre",
      0.0075
    ]
  ],
  "travesti": [
    [
      "deguisement",
      0.1875
    ],
    [
      "deguise",
      0.125
    ],
    [
      "masque",
      0.125
    ],
    [
      "travestissement",
      0.125
    ],
    [
      "travestisme",
      0.06
    ],
    [
      "masque",
      0.06
    ],
    [
      "mascarade",
      0.06
    ],
    [
      "faux",
      0.06
    ],
    [
      "domino",
      0.06
    ],
    [
      "accoutrement",
      0.06
    ],
    [
      "voile",
      0.06
    ]
  ],
  "numero": [
    [
      "gaillard",
      0.0975
    ],
    [
      "bizarre",
      0.0725
    ],
    [
      "rang",
      0.0725
    ],
    [
      "spectacle",
      0.0725
    ],
    [
      "zebre",
      0.0475
    ],
    [
      "zigoto",
      0.0475
    ],
    [
      "tour",
      0.0475
    ],
    [
      "lascar",
      0.0475
    ],
    [
      "feerie",
      0.0475
    ],
    [
      "drole",
      0.0475
    ],
    [
      "outil",
      0.0225
    ],
    [
      "position",
      0.0225
    ],
    [
      "show",
      0.0225
    ],
    [
      "sketch",
      0.0225
    ],
    [
      "seance",
      0.0225
    ],
    [
      "zig",
      0.0225
    ],
    [
      "original",
      0.0225
    ],
    [
      "nombre",
      0.0225
    ],
    [
      "loustic",
      0.0225
    ],
    [
      "livraison",
      0.0225
    ],
    [
      "jeton",
      0.0225
    ],
    [
      "exhibition",
      0.0225
    ],
    [
      "clownerie",
      0.0225
    ],
    [
      "cinema",
      0.0225
    ],
    [
      "billet",
      0.0225
    ],
    [
      "zouave",
      0.0225
    ]
  ],
  "special": [
    [
      "particulier",
      0.1475
    ],
    [
      "original",
      0.115
    ],
    [
      "singulier",
      0.0975
    ],
    [
      "extraordinaire",
      0.065
    ],
    [
      "propre",
      0.0575
    ],
    [
      "etonnant",
      0.0475
    ],
    [
      "specifique",
      0.0475
    ],
    [
      "personnel",
      0.0475
    ],
    [
      "individuel",
      0.0475
    ],
    [
      "caracteristique",
      0.0475
    ],
    [
      "unique",
      0.0325
    ],
    [
      "distinct",
      0.0325
    ],
    [
      "bizarre",
      0.0325
    ],
    [
      "exclusif",
      0.0225
    ],
    [
      "remarquable",
      0.0225
    ],
    [
      "truculent",
      0.0225
    ],
    [
      "sensationnel",
      0.015
    ],
    [
      "distinctif",
      0.015
    ],
    [
      "adequat",
      0.0075
    ],
    [
      "d'exception",
      0.0075
    ],
    [
      "restreint",
      0.0075
    ],
    [
      "technique",
      0.0075
    ]
  ],
  "integral": [
    [
      "complet",
      0.22
    ],
    [
      "entier",
      0.165
    ],
    [
      "total",
      0.165
    ],
    [
      "plein",
      0.11
    ],
    [
      "plenier",
      0.055
    ],
    [
      "integrant",
      0.055
    ],
    [
      "global",
      0.055
    ],
    [
      "absolu",
      0.055
    ],
    [
      "tout",
      0.055
    ]
  ],
  "strip": [],
  "salle": [
    [
      "galerie",
      0.1425
    ],
    [
      "antichambre",
      0.095
    ],
    [
      "auditoire",
      0.095
    ],
    [
      "chambre",
      0.095
    ],
    [
      "piece",
      0.095
    ],
    [
      "public",
      0.095
    ],
    [
      "spectateurs",
      0.0475
    ],
    [
      "permanence",
      0.0475
    ],
    [
      "hall",
      0.0475
    ],
    [
      "foyer",
      0.0475
    ],
    [
      "enceinte",
      0.0475
    ],
    [
      "cinema",
      0.0475
    ],
    [
      "assistance",
      0.0475
    ],
    [
      "theatre",
      0.0475
    ]
  ],
  "male": [
    [
      "courageux",
      0.0875
    ],
    [
      "energique",
      0.0875
    ],
    [
      "viril",
      0.07
    ],
    [
      "ferme",
      0.0525
    ],
    [
      "fort",
      0.0525
    ],
    [
      "masculin",
      0.0525
    ],
    [
      "vigoureux",
      0.0525
    ],
    [
      "reproducteur",
      0.0325
    ],
    [
      "muscle",
      0.0325
    ],
    [
      "hommasse",
      0.0325
    ],
    [
      "hardi",
      0.0325
    ],
    [
      "bouquin",
      0.0325
    ],
    [
      "macho",
      0.015
    ],
    [
      "malard",
      0.015
    ],
    [
      "martial",
      0.015
    ],
    [
      "matou",
      0.015
    ],
    [
      "noble",
      0.015
    ],
    [
      "phallocrate",
      0.015
    ],
    [
      "singe",
      0.015
    ],
    [
      "solitaire",
      0.015
    ],
    [
      "taureau",
      0.015
    ],
    [
      "lievre",
      0.015
    ],
    [
      "jars",
      0.015
    ],
    [
      "bouc",
      0.015
    ],
    [
      "brocard",
      0.015
    ],
    [
      "belier",
      0.015
    ],
    [
      "cerf",
      0.015
    ],
    [
      "charniere",
      0.015
    ],
    [
      "coq",
      0.015
    ],
    [
      "garconnier",
      0.015
    ],
    [
      "geniteur",
      0.015
    ],
    [
      "homme",
      0.015
    ],
    [
      "etalon",
      0.015
    ]
  ],
  "manger": [
    [
      "nourriture",
      0.2075
    ],
    [
      "repas",
      0.165
    ],
    [
      "cuisine",
      0.125
    ],
    [
      "aliment",
      0.0825
    ],
    [
      "mets",
      0.0825
    ],
    [
      "pitance",
      0.0825
    ],
    [
      "diner",
      0.04
    ],
    [
      "dejeuner",
      0.04
    ],
    [
      "croute",
      0.04
    ],
    [
      "bouffe",
      0.04
    ],
    [
      "alimentation",
      0.04
    ],
    [
      "pature",
      0.04
    ]
  ],
  "entrer": [
    [
      "penetrer",
      0.1
    ],
    [
      "s'engager",
      0.045
    ],
    [
      "s'introduire",
      0.045
    ],
    [
      "s'insinuer",
      0.04
    ],
    [
      "s'engouffrer",
      0.04
    ],
    [
      "s'enfoncer",
      0.04
    ],
    [
      "prendre",
      0.04
    ],
    [
      "monter",
      0.04
    ],
    [
      "rentrer",
      0.035
    ],
    [
      "passer",
      0.035
    ],
    [
      "embrasser",
      0.035
    ],
    [
      "tenir",
      0.0225
    ],
    [
      "introduire",
      0.0225
    ],
    [
      "enfoncer",
      0.0225
    ],
    [
      "arriver",
      0.0225
    ],
    [
      "aller",
      0.0225
    ],
    [
      "adherer",
      0.0225
    ],
    [
      "venir",
      0.015
    ],
    [
      "parvenir",
      0.015
    ],
    [
      "integrer",
      0.015
    ],
    [
      "forcer",
      0.015
    ],
    [
      "envahir",
      0.015
    ],
    [
      "comprendre",
      0.015
    ],
    [
      "acceder",
      0.015
    ],
    [
      "s'installer",
      0.01
    ],
    [
      "planter",
      0.01
    ],
    [
      "percuter",
      0.01
    ],
    [
      "participer",
      0.01
    ],
    [
      "inserer",
      0.01
    ],
    [
      "enfiler",
      0.01
    ],
    [
      "aborder",
      0.01
    ],
    [
      "s'ingerer",
      0.0025
    ],
    [
      "s'inscrire",
      0.0025
    ],
    [
      "epouser",
      0.0025
    ],
    [
      "s'incruster",
      0.0025
    ],
    [
      "s'incorporer",
      0.0025
    ],
    [
      "s'enfiler",
      0.0025
    ],
    [
      "s'affilier",
      0.0025
    ],
    [
      "ficher",
      0.0025
    ],
    [
      "considerer",
      0.0025
    ],
    [
      "accoster",
      0.0025
    ]
  ],
  "entre": [
    [
      "avec",
      0.22
    ],
    [
      "de",
      0.22
    ],
    [
      "parmi",
      0.22
    ],
    [
      "a",
      0.11
    ]
  ],
  "copain": [
    [
      "camarade",
      0.1325
    ],
    [
      "compagnon",
      0.1325
    ],
    [
      "ami",
      0.11
    ],
    [
      "acolyte",
      0.0875
    ],
    [
      "partenaire",
      0.0875
    ],
    [
      "compere",
      0.065
    ],
    [
      "pote",
      0.0425
    ],
    [
      "condisciple",
      0.0425
    ],
    [
      "complice",
      0.0425
    ],
    [
      "amoureux",
      0.0425
    ],
    [
      "amant",
      0.0425
    ],
    [
      "allie",
      0.0425
    ],
    [
      "flirt",
      0.02
    ],
    [
      "frere",
      0.02
    ],
    [
      "labadens",
      0.02
    ],
    [
      "poteau",
      0.02
    ]
  ],
  "sexe": [
    [
      "penis",
      0.1475
    ],
    [
      "verge",
      0.1475
    ],
    [
      "con",
      0.0725
    ],
    [
      "vulve",
      0.0725
    ],
    [
      "phallus",
      0.035
    ],
    [
      "pine",
      0.035
    ],
    [
      "queue",
      0.035
    ],
    [
      "vagin",
      0.035
    ],
    [
      "virilite",
      0.035
    ],
    [
      "parties",
      0.035
    ],
    [
      "nature",
      0.035
    ],
    [
      "feminite",
      0.035
    ],
    [
      "cul",
      0.035
    ],
    [
      "clitoris",
      0.035
    ],
    [
      "zizi",
      0.035
    ]
  ],
  "quelconque": [
    [
      "insignifiant",
      0.1525
    ],
    [
      "banal",
      0.1325
    ],
    [
      "ordinaire",
      0.08
    ],
    [
      "terne",
      0.0675
    ],
    [
      "fade",
      0.05
    ],
    [
      "mediocre",
      0.05
    ],
    [
      "plat",
      0.05
    ],
    [
      "vulgaire",
      0.0425
    ],
    [
      "commun",
      0.0425
    ],
    [
      "anodin",
      0.0425
    ],
    [
      "indifferent",
      0.0375
    ],
    [
      "prosaique",
      0.025
    ],
    [
      "petit",
      0.025
    ],
    [
      "neutre",
      0.025
    ],
    [
      "moyen",
      0.025
    ],
    [
      "ininteressant",
      0.025
    ],
    [
      "courant",
      0.025
    ],
    [
      "simple",
      0.0175
    ],
    [
      "facile",
      0.0175
    ],
    [
      "efface",
      0.0175
    ],
    [
      "anonyme",
      0.005
    ],
    [
      "divers",
      0.005
    ],
    [
      "lambda",
      0.005
    ],
    [
      "malheureux",
      0.005
    ],
    [
      "vague",
      0.005
    ]
  ],
  "bar": [
    [
      "cabaret",
      0.205
    ],
    [
      "cafe",
      0.185
    ],
    [
      "bistrot",
      0.08
    ],
    [
      "buvette",
      0.08
    ],
    [
      "brasserie",
      0.06
    ],
    [
      "zinc",
      0.04
    ],
    [
      "troquet",
      0.04
    ],
    [
      "taverne",
      0.04
    ],
    [
      "buffet",
      0.04
    ],
    [
      "saloon",
      0.0175
    ],
    [
      "pub",
      0.0175
    ],
    [
      "loup",
      0.0175
    ],
    [
      "hectopieze",
      0.0175
    ],
    [
      "debit",
      0.0175
    ],
    [
      "comptoir",
      0.0175
    ],
    [
      "club",
      0.0175
    ],
    [
      "bibine",
      0.0175
    ],
    [
      "atmosphere",
      0.0175
    ]
  ],
  "tabac": [
    [
      "torgnole",
      0.1075
    ],
    [
      "tabassee",
      0.05
    ],
    [
      "sumatra",
      0.05
    ],
    [
      "schnouff",
      0.05
    ],
    [
      "scaferlati",
      0.05
    ],
    [
      "petun",
      0.05
    ],
    [
      "perlot",
      0.05
    ],
    [
      "nicotiane",
      0.05
    ],
    [
      "maryland",
      0.05
    ],
    [
      "havane",
      0.05
    ],
    [
      "gris",
      0.05
    ],
    [
      "coup",
      0.05
    ],
    [
      "caporal",
      0.05
    ],
    [
      "brun",
      0.05
    ],
    [
      "Bresil",
      0.05
    ],
    [
      "virginie",
      0.05
    ]
  ],
  "joie": [
    [
      "bonheur",
      0.0875
    ],
    [
      "plaisir",
      0.08
    ],
    [
      "gaiete",
      0.075
    ],
    [
      "felicite",
      0.0525
    ],
    [
      "satisfaction",
      0.0525
    ],
    [
      "allegresse",
      0.0475
    ],
    [
      "euphorie",
      0.035
    ],
    [
      "ravissement",
      0.03
    ],
    [
      "enthousiasme",
      0.03
    ],
    [
      "contentement",
      0.03
    ],
    [
      "entrain",
      0.025
    ],
    [
      "volupte",
      0.02
    ],
    [
      "transport",
      0.02
    ],
    [
      "rejouissance",
      0.02
    ],
    [
      "ivresse",
      0.02
    ],
    [
      "extase",
      0.02
    ],
    [
      "delice",
      0.02
    ],
    [
      "rire",
      0.015
    ],
    [
      "jubilation",
      0.015
    ],
    [
      "jouissance",
      0.015
    ],
    [
      "exaltation",
      0.015
    ],
    [
      "beatitude",
      0.015
    ],
    [
      "amusement",
      0.015
    ],
    [
      "agrement",
      0.015
    ],
    [
      "exultation",
      0.0125
    ],
    [
      "enjouement",
      0.0125
    ],
    [
      "enchantement",
      0.0125
    ],
    [
      "douceur",
      0.0125
    ],
    [
      "regal",
      0.0075
    ],
    [
      "rigolade",
      0.0075
    ],
    [
      "liesse",
      0.0075
    ],
    [
      "hilarite",
      0.0075
    ],
    [
      "griserie",
      0.0075
    ],
    [
      "bienfait",
      0.0075
    ],
    [
      "ardeur",
      0.0075
    ],
    [
      "sourire",
      0.0025
    ],
    [
      "rayonnement",
      0.0025
    ],
    [
      "folichonnerie",
      0.0025
    ],
    [
      "fierte",
      0.0025
    ],
    [
      "consolation",
      0.0025
    ],
    [
      "avantage",
      0.0025
    ],
    [
      "aise",
      0.0025
    ],
    [
      "epanouissement",
      0.0025
    ]
  ],
  "complexe": [
    [
      "complique",
      0.1425
    ],
    [
      "obscur",
      0.0875
    ],
    [
      "tenebreux",
      0.0525
    ],
    [
      "sibyllin",
      0.0525
    ],
    [
      "embrouille",
      0.0525
    ],
    [
      "difficile",
      0.0525
    ],
    [
      "composite",
      0.0525
    ],
    [
      "nebuleux",
      0.035
    ],
    [
      "mixte",
      0.035
    ],
    [
      "groupe",
      0.035
    ],
    [
      "enchevetre",
      0.035
    ],
    [
      "embarrasse",
      0.035
    ],
    [
      "delicat",
      0.035
    ],
    [
      "compose",
      0.035
    ],
    [
      "entite",
      0.015
    ],
    [
      "groupement",
      0.015
    ],
    [
      "hantise",
      0.015
    ],
    [
      "implexe",
      0.015
    ],
    [
      "obsession",
      0.015
    ],
    [
      "trouble",
      0.015
    ],
    [
      "ensemble",
      0.015
    ],
    [
      "emmele",
      0.015
    ],
    [
      "double",
      0.015
    ],
    [
      "difficultueux",
      0.015
    ],
    [
      "combinat",
      0.015
    ],
    [
      "cale",
      0.015
    ],
    [
      "batard",
      0.015
    ],
    [
      "association",
      0.015
    ],
    [
      "varie",
      0.015
    ]
  ],
  "complexer": [
    [
      "inhiber",
      0.5
    ],
    [
      "paralyser",
      0.5
    ]
  ],
  "deballer": [
    [
      "defaire",
      0.075
    ],
    [
      "depaqueter",
      0.075
    ],
    [
      "deplier",
      0.075
    ],
    [
      "developper",
      0.075
    ],
    [
      "reveler",
      0.075
    ],
    [
      "s'ouvrir",
      0.075
    ],
    [
      "etaler",
      0.05
    ],
    [
      "s'epancher",
      0.05
    ],
    [
      "avouer",
      0.05
    ],
    [
      "ouvrir",
      0.025
    ],
    [
      "montrer",
      0.025
    ],
    [
      "desemballer",
      0.025
    ],
    [
      "deficeler",
      0.025
    ],
    [
      "decharger",
      0.025
    ],
    [
      "decaisser",
      0.025
    ],
    [
      "debiter",
      0.025
    ],
    [
      "debagouler",
      0.025
    ],
    [
      "confesser",
      0.025
    ],
    [
      "afficher",
      0.025
    ]
  ],
  "lapider": [
    [
      "massacrer",
      0.18
    ],
    [
      "tuer",
      0.18
    ],
    [
      "executer",
      0.09
    ],
    [
      "malmener",
      0.09
    ],
    [
      "maltraiter",
      0.09
    ],
    [
      "rudoyer",
      0.09
    ],
    [
      "vilipender",
      0.09
    ],
    [
      "echarper",
      0.09
    ]
  ],
  "humour": [
    [
      "esprit",
      0.1375
    ],
    [
      "ironie",
      0.1375
    ],
    [
      "raillerie",
      0.1025
    ],
    [
      "plaisanterie",
      0.1025
    ],
    [
      "humeur",
      0.1025
    ],
    [
      "gaiete",
      0.1025
    ],
    [
      "derision",
      0.1025
    ],
    [
      "sel",
      0.0675
    ],
    [
      "fantaisie",
      0.0325
    ],
    [
      "sarcasme",
      0.0325
    ],
    [
      "satire",
      0.0325
    ],
    [
      "verve",
      0.0325
    ]
  ],
  "calembour": [
    [
      "plaisanterie",
      0.1775
    ],
    [
      "turlupinade",
      0.105
    ],
    [
      "contrepeterie",
      0.07
    ],
    [
      "equivoque",
      0.07
    ],
    [
      "trait",
      0.035
    ],
    [
      "homophonie",
      0.035
    ],
    [
      "homonymie",
      0.035
    ],
    [
      "calembredaine",
      0.035
    ],
    [
      "astuce",
      0.035
    ]
  ],
  "acide": [
    [
      "aigre",
      0.1825
    ],
    [
      "acerbe",
      0.1225
    ],
    [
      "amer",
      0.1075
    ],
    [
      "piquant",
      0.065
    ],
    [
      "mordant",
      0.0575
    ],
    [
      "vif",
      0.0575
    ],
    [
      "aigrelet",
      0.0475
    ],
    [
      "acrimonieux",
      0.0475
    ],
    [
      "blessant",
      0.04
    ],
    [
      "agressif",
      0.0325
    ],
    [
      "caustique",
      0.0325
    ],
    [
      "acre",
      0.0225
    ],
    [
      "vert",
      0.015
    ],
    [
      "ginguet",
      0.015
    ],
    [
      "desagreable",
      0.015
    ],
    [
      "acidule",
      0.015
    ],
    [
      "acariatre",
      0.015
    ],
    [
      "suret",
      0.0075
    ],
    [
      "sur",
      0.0075
    ],
    [
      "pointu",
      0.0075
    ],
    [
      "pique",
      0.0075
    ],
    [
      "incisif",
      0.0075
    ],
    [
      "glacial",
      0.0075
    ],
    [
      "besaigre",
      0.0075
    ],
    [
      "acidule",
      0.0075
    ],
    [
      "acescent",
      0.0075
    ],
    [
      "virulent",
      0.0075
    ]
  ],
  "rencontre": [
    [
      "heurter",
      0.135
    ],
    [
      "atteindre",
      0.0675
    ],
    [
      "trouver",
      0.0675
    ],
    [
      "joindre",
      0.055
    ],
    [
      "porter",
      0.055
    ],
    [
      "toucher",
      0.055
    ],
    [
      "voir",
      0.0425
    ],
    [
      "cogner",
      0.0425
    ],
    [
      "buter",
      0.0325
    ],
    [
      "contacter",
      0.0325
    ],
    [
      "relever",
      0.02
    ],
    [
      "rejoindre",
      0.02
    ],
    [
      "percuter",
      0.02
    ],
    [
      "croiser",
      0.02
    ],
    [
      "coudoyer",
      0.02
    ],
    [
      "apercevoir",
      0.02
    ],
    [
      "affronter",
      0.02
    ],
    [
      "achopper",
      0.02
    ],
    [
      "accrocher",
      0.02
    ],
    [
      "accoster",
      0.02
    ],
    [
      "taper",
      0.01
    ],
    [
      "s'aboucher",
      0.01
    ],
    [
      "parvenir",
      0.01
    ],
    [
      "narguer",
      0.01
    ],
    [
      "deviner",
      0.01
    ],
    [
      "chopper",
      0.01
    ],
    [
      "braver",
      0.01
    ]
  ],
  "rencontrer": [
    [
      "heurter",
      0.135
    ],
    [
      "atteindre",
      0.0675
    ],
    [
      "trouver",
      0.0675
    ],
    [
      "joindre",
      0.055
    ],
    [
      "porter",
      0.055
    ],
    [
      "toucher",
      0.055
    ],
    [
      "voir",
      0.0425
    ],
    [
      "cogner",
      0.0425
    ],
    [
      "buter",
      0.0325
    ],
    [
      "contacter",
      0.0325
    ],
    [
      "relever",
      0.02
    ],
    [
      "rejoindre",
      0.02
    ],
    [
      "percuter",
      0.02
    ],
    [
      "croiser",
      0.02
    ],
    [
      "coudoyer",
      0.02
    ],
    [
      "apercevoir",
      0.02
    ],
    [
      "affronter",
      0.02
    ],
    [
      "achopper",
      0.02
    ],
    [
      "accrocher",
      0.02
    ],
    [
      "accoster",
      0.02
    ],
    [
      "taper",
      0.01
    ],
    [
      "s'aboucher",
      0.01
    ],
    [
      "parvenir",
      0.01
    ],
    [
      "narguer",
      0.01
    ],
    [
      "deviner",
      0.01
    ],
    [
      "chopper",
      0.01
    ],
    [
      "braver",
      0.01
    ]
  ],
  "attarder": [
    [
      "retarder",
      1.0
    ]
  ],
  "attarde": [
    [
      "retarder",
      1.0
    ]
  ],
  "epater": [
    [
      "etonner",
      0.1325
    ],
    [
      "stupefier",
      0.1
    ],
    [
      "eblouir",
      0.1
    ],
    [
      "impressionner",
      0.0825
    ],
    [
      "ebahir",
      0.065
    ],
    [
      "renverser",
      0.065
    ],
    [
      "imposer",
      0.065
    ],
    [
      "esbroufer",
      0.05
    ],
    [
      "siderer",
      0.05
    ],
    [
      "ecraser",
      0.05
    ],
    [
      "epoustoufler",
      0.0325
    ],
    [
      "surprendre",
      0.0325
    ],
    [
      "souffler",
      0.0325
    ],
    [
      "bluffer",
      0.0325
    ],
    [
      "aplatir",
      0.015
    ],
    [
      "asseoir",
      0.015
    ],
    [
      "casser",
      0.015
    ],
    [
      "illusionner",
      0.015
    ]
  ],
  "tablee": [
    [
      "compter",
      0.1675
    ],
    [
      "fonder",
      0.11
    ],
    [
      "s'appuyer",
      0.11
    ],
    [
      "esperer",
      0.055
    ],
    [
      "escompter",
      0.055
    ],
    [
      "caser",
      0.055
    ],
    [
      "baser",
      0.055
    ],
    [
      "speculer",
      0.055
    ]
  ],
  "couvrir": [
    [
      "recouvrir",
      0.0525
    ],
    [
      "cacher",
      0.035
    ],
    [
      "deguiser",
      0.035
    ],
    [
      "envelopper",
      0.035
    ],
    [
      "tapisser",
      0.0275
    ],
    [
      "remplir",
      0.0275
    ],
    [
      "masquer",
      0.0225
    ],
    [
      "proteger",
      0.0225
    ],
    [
      "semer",
      0.0225
    ],
    [
      "voiler",
      0.0225
    ],
    [
      "dissimuler",
      0.02
    ],
    [
      "parsemer",
      0.0175
    ],
    [
      "revetir",
      0.0175
    ],
    [
      "etendre",
      0.015
    ],
    [
      "habiller",
      0.015
    ],
    [
      "faire",
      0.015
    ],
    [
      "enduire",
      0.015
    ],
    [
      "combler",
      0.015
    ],
    [
      "etouffer",
      0.0125
    ],
    [
      "obscurcir",
      0.0125
    ],
    [
      "monter",
      0.0125
    ],
    [
      "inonder",
      0.0125
    ],
    [
      "farder",
      0.0125
    ],
    [
      "defendre",
      0.0125
    ],
    [
      "charger",
      0.0125
    ],
    [
      "servir",
      0.01
    ],
    [
      "s'accoupler",
      0.01
    ],
    [
      "repandre",
      0.01
    ],
    [
      "payer",
      0.01
    ],
    [
      "garantir",
      0.01
    ],
    [
      "envahir",
      0.01
    ],
    [
      "effacer",
      0.01
    ],
    [
      "coiffer",
      0.01
    ],
    [
      "barder",
      0.01
    ],
    [
      "abreuver",
      0.01
    ],
    [
      "repondre",
      0.0075
    ],
    [
      "reparer",
      0.0075
    ],
    [
      "renforcer",
      0.0075
    ],
    [
      "racheter",
      0.0075
    ],
    [
      "salir",
      0.0075
    ],
    [
      "souiller",
      0.0075
    ],
    [
      "submerger",
      0.0075
    ],
    [
      "vetir",
      0.0075
    ],
    [
      "eclipser",
      0.0075
    ],
    [
      "etaler",
      0.0075
    ],
    [
      "eteindre",
      0.0075
    ],
    [
      "joncher",
      0.0075
    ],
    [
      "fringuer",
      0.0075
    ],
    [
      "abriter",
      0.0075
    ],
    [
      "accabler",
      0.0075
    ],
    [
      "appliquer",
      0.0075
    ],
    [
      "bacher",
      0.0075
    ],
    [
      "camoufler",
      0.0075
    ],
    [
      "compenser",
      0.0075
    ],
    [
      "consteller",
      0.0075
    ],
    [
      "couronner",
      0.0075
    ],
    [
      "disposer",
      0.0075
    ],
    [
      "dominer",
      0.0075
    ],
    [
      "flanquer",
      0.0075
    ],
    [
      "poisser",
      0.0025
    ],
    [
      "platrer",
      0.0025
    ],
    [
      "paver",
      0.0025
    ],
    [
      "parcourir",
      0.0025
    ],
    [
      "poudrer",
      0.0025
    ],
    [
      "rembourser",
      0.0025
    ],
    [
      "regler",
      0.0025
    ],
    [
      "s'etendre",
      0.0025
    ],
    [
      "saillir",
      0.0025
    ],
    [
      "tenter",
      0.0025
    ],
    [
      "etoffer",
      0.0025
    ],
    [
      "ombrager",
      0.0025
    ],
    [
      "lutter",
      0.0025
    ],
    [
      "justifier",
      0.0025
    ],
    [
      "amortir",
      0.0025
    ],
    [
      "balancer",
      0.0025
    ],
    [
      "barbouiller",
      0.0025
    ],
    [
      "blinder",
      0.0025
    ],
    [
      "caparaconner",
      0.0025
    ],
    [
      "celer",
      0.0025
    ],
    [
      "chevaucher",
      0.0025
    ],
    [
      "cuirasser",
      0.0025
    ],
    [
      "draper",
      0.0025
    ],
    [
      "excuser",
      0.0025
    ],
    [
      "franchir",
      0.0025
    ],
    [
      "emmitoufler",
      0.0
    ],
    [
      "pallier",
      0.0
    ],
    [
      "sillonner",
      0.0
    ],
    [
      "sombrer",
      0.0
    ],
    [
      "taire",
      0.0
    ],
    [
      "eclabousser",
      0.0
    ],
    [
      "embrasser",
      0.0
    ],
    [
      "cribler",
      0.0
    ],
    [
      "coupler",
      0.0
    ],
    [
      "cocher",
      0.0
    ],
    [
      "charpenter",
      0.0
    ],
    [
      "chaperonner",
      0.0
    ],
    [
      "capuchonner",
      0.0
    ],
    [
      "banner",
      0.0
    ],
    [
      "bander",
      0.0
    ],
    [
      "approvisionner",
      0.0
    ],
    [
      "eparpiller",
      0.0
    ]
  ],
  "pauvre": [
    [
      "miserable",
      0.065
    ],
    [
      "maigre",
      0.0625
    ],
    [
      "necessiteux",
      0.0425
    ],
    [
      "faible",
      0.0375
    ],
    [
      "petit",
      0.0375
    ],
    [
      "mediocre",
      0.035
    ],
    [
      "pietre",
      0.0325
    ],
    [
      "besogneux",
      0.0325
    ],
    [
      "gueux",
      0.0275
    ],
    [
      "mechant",
      0.0275
    ],
    [
      "misereux",
      0.025
    ],
    [
      "mesquin",
      0.025
    ],
    [
      "pitoyable",
      0.0225
    ],
    [
      "malheureux",
      0.0225
    ],
    [
      "minable",
      0.02
    ],
    [
      "lamentable",
      0.0175
    ],
    [
      "modeste",
      0.0175
    ],
    [
      "piteux",
      0.0175
    ],
    [
      "mauvais",
      0.0175
    ],
    [
      "insuffisant",
      0.0175
    ],
    [
      "chetif",
      0.0125
    ],
    [
      "deplorable",
      0.0125
    ],
    [
      "mince",
      0.0125
    ],
    [
      "miteux",
      0.0125
    ],
    [
      "indigent",
      0.0125
    ],
    [
      "reduit",
      0.01
    ],
    [
      "simple",
      0.01
    ],
    [
      "triste",
      0.01
    ],
    [
      "sec",
      0.01
    ],
    [
      "vide",
      0.0075
    ],
    [
      "sterile",
      0.0075
    ],
    [
      "parcimonieux",
      0.0075
    ],
    [
      "juste",
      0.0075
    ],
    [
      "impecunieux",
      0.0075
    ],
    [
      "fauche",
      0.0075
    ],
    [
      "court",
      0.0075
    ],
    [
      "aride",
      0.0075
    ],
    [
      "ruine",
      0.005
    ],
    [
      "mendiant",
      0.005
    ],
    [
      "jeune",
      0.005
    ],
    [
      "humble",
      0.005
    ],
    [
      "derisoire",
      0.005
    ],
    [
      "demuni",
      0.005
    ],
    [
      "clochard",
      0.005
    ],
    [
      "succinct",
      0.005
    ],
    [
      "riquiqui",
      0.005
    ],
    [
      "pouilleux",
      0.005
    ],
    [
      "plat",
      0.005
    ],
    [
      "nu",
      0.005
    ],
    [
      "moyen",
      0.005
    ],
    [
      "modique",
      0.005
    ],
    [
      "improductif",
      0.005
    ],
    [
      "vagabond",
      0.0025
    ],
    [
      "ridicule",
      0.0025
    ],
    [
      "prive",
      0.0025
    ],
    [
      "depourvu",
      0.0025
    ],
    [
      "denue",
      0.0025
    ],
    [
      "chiche",
      0.0025
    ],
    [
      "banal",
      0.0025
    ],
    [
      "afflige",
      0.0025
    ],
    [
      "ingrat",
      0.0
    ],
    [
      "marmiteux",
      0.0
    ],
    [
      "panne",
      0.0
    ],
    [
      "tombe",
      0.0
    ],
    [
      "infortune",
      0.0
    ],
    [
      "infertile",
      0.0
    ],
    [
      "gene",
      0.0
    ],
    [
      "appauvri",
      0.0
    ],
    [
      "commun",
      0.0
    ],
    [
      "decharne",
      0.0
    ],
    [
      "dechu",
      0.0
    ],
    [
      "detestable",
      0.0
    ],
    [
      "famelique",
      0.0
    ],
    [
      "proletaire",
      0.0
    ],
    [
      "purotin",
      0.0
    ],
    [
      "rape",
      0.0
    ],
    [
      "squelettique",
      0.0
    ],
    [
      "trimardeur",
      0.0
    ],
    [
      "mendigot",
      0.0
    ],
    [
      "loqueteux",
      0.0
    ],
    [
      "lilliputien",
      0.0
    ],
    [
      "infecond",
      0.0
    ],
    [
      "defavorise",
      0.0
    ],
    [
      "disetteux",
      0.0
    ],
    [
      "congru",
      0.0
    ],
    [
      "chemineau",
      0.0
    ],
    [
      "anemique",
      0.0
    ]
  ],
  "ridicule": [
    [
      "comique",
      0.0925
    ],
    [
      "risible",
      0.0475
    ],
    [
      "grotesque",
      0.0425
    ],
    [
      "drole",
      0.0425
    ],
    [
      "bouffon",
      0.0425
    ],
    [
      "bizarre",
      0.0425
    ],
    [
      "cocasse",
      0.0375
    ],
    [
      "absurde",
      0.035
    ],
    [
      "amusant",
      0.035
    ],
    [
      "insense",
      0.035
    ],
    [
      "saugrenu",
      0.03
    ],
    [
      "burlesque",
      0.03
    ],
    [
      "loufoque",
      0.025
    ],
    [
      "plaisant",
      0.025
    ],
    [
      "incroyable",
      0.02
    ],
    [
      "tordant",
      0.02
    ],
    [
      "turlupin",
      0.0175
    ],
    [
      "sot",
      0.0175
    ],
    [
      "rigolo",
      0.0175
    ],
    [
      "impossible",
      0.0175
    ],
    [
      "impayable",
      0.0175
    ],
    [
      "derisoire",
      0.0175
    ],
    [
      "bete",
      0.0175
    ],
    [
      "aberrant",
      0.0175
    ],
    [
      "pietre",
      0.0125
    ],
    [
      "pauvre",
      0.0125
    ],
    [
      "mince",
      0.0125
    ],
    [
      "falot",
      0.0125
    ],
    [
      "travers",
      0.0075
    ],
    [
      "minime",
      0.0075
    ],
    [
      "maigre",
      0.0075
    ],
    [
      "inenarrable",
      0.0075
    ],
    [
      "infime",
      0.0075
    ],
    [
      "ineffable",
      0.0075
    ],
    [
      "funambulesque",
      0.0075
    ],
    [
      "fable",
      0.0075
    ],
    [
      "caricatural",
      0.0075
    ],
    [
      "maniaque",
      0.0025
    ],
    [
      "mijauree",
      0.0025
    ],
    [
      "pecque",
      0.0025
    ],
    [
      "plaisantin",
      0.0025
    ],
    [
      "prudhommesque",
      0.0025
    ],
    [
      "precieux",
      0.0025
    ],
    [
      "riquiqui",
      0.0025
    ],
    [
      "risee",
      0.0025
    ],
    [
      "reticule",
      0.0025
    ],
    [
      "sac",
      0.0025
    ],
    [
      "jocrisse",
      0.0025
    ],
    [
      "inelegant",
      0.0025
    ],
    [
      "academique",
      0.0025
    ],
    [
      "amusement",
      0.0025
    ],
    [
      "bizarrerie",
      0.0025
    ],
    [
      "divertissant",
      0.0025
    ],
    [
      "defaut",
      0.0025
    ],
    [
      "faux",
      0.0025
    ],
    [
      "galantin",
      0.0025
    ],
    [
      "gandin",
      0.0025
    ],
    [
      "hilarant",
      0.0025
    ],
    [
      "imperfection",
      0.0025
    ],
    [
      "inadmissible",
      0.0025
    ],
    [
      "ubuesque",
      0.0025
    ]
  ],
  "gesticuler": [
    [
      "remuer",
      0.4
    ],
    [
      "agiter",
      0.2
    ],
    [
      "s'agiter",
      0.2
    ]
  ],
  "diva": [
    [
      "cantatrice",
      0.375
    ],
    [
      "chanteuse",
      0.25
    ],
    [
      "chanteur",
      0.125
    ],
    [
      "soprano",
      0.125
    ]
  ],
  "tenor": [
    [
      "chanteur",
      0.165
    ],
    [
      "celebrite",
      0.165
    ],
    [
      "maitre",
      0.165
    ],
    [
      "sommite",
      0.165
    ],
    [
      "teneur",
      0.165
    ],
    [
      "tenorino",
      0.165
    ]
  ],
  "betise": [
    [
      "sottise",
      0.0875
    ],
    [
      "niaiserie",
      0.0475
    ],
    [
      "bagatelle",
      0.0325
    ],
    [
      "futilite",
      0.03
    ],
    [
      "stupidite",
      0.0275
    ],
    [
      "imbecillite",
      0.0275
    ],
    [
      "idiotie",
      0.0275
    ],
    [
      "frivolite",
      0.0275
    ],
    [
      "fadaise",
      0.0275
    ],
    [
      "bevue",
      0.0275
    ],
    [
      "anerie",
      0.0275
    ],
    [
      "blague",
      0.0225
    ],
    [
      "baliverne",
      0.0225
    ],
    [
      "maladresse",
      0.0225
    ],
    [
      "babiole",
      0.02
    ],
    [
      "bricole",
      0.02
    ],
    [
      "erreur",
      0.02
    ],
    [
      "faute",
      0.02
    ],
    [
      "propos",
      0.0175
    ],
    [
      "balourdise",
      0.0175
    ],
    [
      "ineptie",
      0.015
    ],
    [
      "plaisanterie",
      0.015
    ],
    [
      "sornette",
      0.0125
    ],
    [
      "ignorance",
      0.0125
    ],
    [
      "folie",
      0.0125
    ],
    [
      "bourde",
      0.0125
    ],
    [
      "aberration",
      0.0125
    ],
    [
      "cretinisme",
      0.01
    ],
    [
      "gaffe",
      0.01
    ],
    [
      "naivete",
      0.01
    ],
    [
      "connerie",
      0.0075
    ],
    [
      "broutille",
      0.0075
    ],
    [
      "simplicite",
      0.0075
    ],
    [
      "insanite",
      0.0075
    ],
    [
      "gaudriole",
      0.0075
    ],
    [
      "chanson",
      0.0075
    ],
    [
      "calembredaine",
      0.0075
    ],
    [
      "boniment",
      0.0075
    ],
    [
      "absurdite",
      0.0075
    ],
    [
      "rien",
      0.005
    ],
    [
      "polissonnerie",
      0.005
    ],
    [
      "nullite",
      0.005
    ],
    [
      "nigauderie",
      0.005
    ],
    [
      "legerete",
      0.005
    ],
    [
      "impair",
      0.005
    ],
    [
      "enfantillage",
      0.005
    ],
    [
      "cretinerie",
      0.005
    ],
    [
      "etourderie",
      0.0025
    ],
    [
      "meprise",
      0.0025
    ],
    [
      "lourdeur",
      0.0025
    ],
    [
      "insignifiance",
      0.0025
    ],
    [
      "gauloiserie",
      0.0025
    ],
    [
      "facetie",
      0.0025
    ],
    [
      "bibelot",
      0.0025
    ],
    [
      "badinerie",
      0.0025
    ],
    [
      "amusette",
      0.0025
    ],
    [
      "abrutissement",
      0.0025
    ],
    [
      "inintelligence",
      0.0025
    ],
    [
      "jobarderie",
      0.0025
    ],
    [
      "platitude",
      0.0025
    ],
    [
      "quiproquo",
      0.0025
    ],
    [
      "vanne",
      0.0025
    ],
    [
      "ecart",
      0.0025
    ],
    [
      "grivoiserie",
      0.0025
    ],
    [
      "ganacherie",
      0.0025
    ],
    [
      "fredaine",
      0.0025
    ],
    [
      "attrape",
      0.0025
    ],
    [
      "balancoire",
      0.0025
    ],
    [
      "boulette",
      0.0025
    ],
    [
      "calinotade",
      0.0025
    ],
    [
      "fantaisie",
      0.0025
    ],
    [
      "ilotisme",
      0.0
    ],
    [
      "maldonne",
      0.0
    ],
    [
      "paillardise",
      0.0
    ],
    [
      "perle",
      0.0
    ],
    [
      "pesanteur",
      0.0
    ],
    [
      "pedantisme",
      0.0
    ],
    [
      "epaisseur",
      0.0
    ],
    [
      "farce",
      0.0
    ],
    [
      "astuce",
      0.0
    ],
    [
      "badauderie",
      0.0
    ],
    [
      "baratin",
      0.0
    ],
    [
      "berlingot",
      0.0
    ],
    [
      "bonbon",
      0.0
    ],
    [
      "bonte",
      0.0
    ],
    [
      "belement",
      0.0
    ],
    [
      "crucherie",
      0.0
    ],
    [
      "detail",
      0.0
    ],
    [
      "amusement",
      0.0
    ]
  ],
  "lazzi": [
    [
      "brocard",
      0.1725
    ],
    [
      "moquerie",
      0.1725
    ],
    [
      "raillerie",
      0.1725
    ],
    [
      "plaisanterie",
      0.13
    ],
    [
      "quolibet",
      0.085
    ],
    [
      "sarcasme",
      0.085
    ],
    [
      "trait",
      0.085
    ],
    [
      "bouffonnerie",
      0.0425
    ],
    [
      "pantomime",
      0.0425
    ]
  ],
  "quolibet": [
    [
      "raillerie",
      0.18
    ],
    [
      "brocard",
      0.12
    ],
    [
      "moquerie",
      0.1
    ],
    [
      "plaisanterie",
      0.1
    ],
    [
      "pointe",
      0.08
    ],
    [
      "sarcasme",
      0.08
    ],
    [
      "persiflage",
      0.06
    ],
    [
      "lardon",
      0.04
    ],
    [
      "lazzi",
      0.04
    ],
    [
      "pique",
      0.04
    ],
    [
      "apostrophe",
      0.02
    ],
    [
      "huee",
      0.02
    ]
  ],
  "puisque": [
    [
      "car",
      0.1525
    ],
    [
      "si",
      0.075
    ],
    [
      "comme",
      0.075
    ]
  ],
  "nouveau": [
    [
      "neuf",
      0.105
    ],
    [
      "original",
      0.0825
    ],
    [
      "inusite",
      0.0525
    ],
    [
      "inedit",
      0.04
    ],
    [
      "moderne",
      0.04
    ],
    [
      "extraordinaire",
      0.035
    ],
    [
      "novice",
      0.0275
    ],
    [
      "insolite",
      0.0275
    ],
    [
      "inoui",
      0.0275
    ],
    [
      "inconnu",
      0.0275
    ],
    [
      "hardi",
      0.0275
    ],
    [
      "truculent",
      0.0225
    ],
    [
      "recent",
      0.0225
    ],
    [
      "jeune",
      0.0225
    ],
    [
      "inexperimente",
      0.0225
    ],
    [
      "vert",
      0.0175
    ],
    [
      "surprenant",
      0.0175
    ],
    [
      "ose",
      0.0175
    ],
    [
      "inhabituel",
      0.0175
    ],
    [
      "inattendu",
      0.0175
    ],
    [
      "inaccoutume",
      0.0175
    ],
    [
      "frais",
      0.0175
    ],
    [
      "debutant",
      0.0175
    ],
    [
      "different",
      0.0175
    ],
    [
      "audacieux",
      0.0175
    ],
    [
      "inimagine",
      0.01
    ],
    [
      "insoupconne",
      0.01
    ],
    [
      "ultramoderne",
      0.01
    ],
    [
      "vierge",
      0.01
    ],
    [
      "inexplore",
      0.01
    ],
    [
      "in",
      0.01
    ],
    [
      "bleu",
      0.01
    ],
    [
      "autre",
      0.01
    ],
    [
      "apprenti",
      0.01
    ],
    [
      "actuel",
      0.01
    ],
    [
      "personnel",
      0.005
    ],
    [
      "primeur",
      0.005
    ],
    [
      "printanier",
      0.005
    ],
    [
      "second",
      0.005
    ],
    [
      "neophyte",
      0.005
    ],
    [
      "novateur",
      0.005
    ],
    [
      "nouveaute",
      0.005
    ],
    [
      "metamorphose",
      0.005
    ],
    [
      "dernier",
      0.005
    ],
    [
      "change",
      0.005
    ],
    [
      "bizut",
      0.005
    ]
  ],
  "lot": [
    [
      "part",
      0.15
    ],
    [
      "sort",
      0.125
    ],
    [
      "portion",
      0.1
    ],
    [
      "morceau",
      0.075
    ],
    [
      "partage",
      0.075
    ],
    [
      "succession",
      0.0475
    ],
    [
      "quota",
      0.0475
    ],
    [
      "destinee",
      0.0475
    ],
    [
      "destin",
      0.0475
    ],
    [
      "apport",
      0.0475
    ],
    [
      "ration",
      0.0225
    ],
    [
      "parcelle",
      0.0225
    ],
    [
      "kit",
      0.0225
    ],
    [
      "contingent",
      0.0225
    ],
    [
      "bloc",
      0.0225
    ],
    [
      "attribution",
      0.0225
    ],
    [
      "assortiment",
      0.0225
    ],
    [
      "apanage",
      0.0225
    ],
    [
      "stock",
      0.0225
    ]
  ],
  "oter": [
    [
      "enlever",
      0.15
    ],
    [
      "retirer",
      0.0675
    ],
    [
      "supprimer",
      0.0625
    ],
    [
      "retrancher",
      0.0525
    ],
    [
      "depouiller",
      0.0325
    ],
    [
      "debarrasser",
      0.03
    ],
    [
      "couper",
      0.025
    ],
    [
      "arracher",
      0.025
    ],
    [
      "soustraire",
      0.0225
    ],
    [
      "effacer",
      0.0225
    ],
    [
      "degager",
      0.02
    ],
    [
      "detruire",
      0.02
    ],
    [
      "chasser",
      0.0175
    ],
    [
      "exclure",
      0.0175
    ],
    [
      "ecarter",
      0.0175
    ],
    [
      "prendre",
      0.0125
    ],
    [
      "extraire",
      0.0125
    ],
    [
      "biffer",
      0.0125
    ],
    [
      "barrer",
      0.0125
    ],
    [
      "tirer",
      0.0125
    ],
    [
      "separer",
      0.0125
    ],
    [
      "rayer",
      0.0125
    ],
    [
      "radier",
      0.0125
    ],
    [
      "lever",
      0.0125
    ],
    [
      "extirper",
      0.0125
    ],
    [
      "diminuer",
      0.0125
    ],
    [
      "sortir",
      0.01
    ],
    [
      "deposseder",
      0.01
    ],
    [
      "decharger",
      0.01
    ],
    [
      "demunir",
      0.0075
    ],
    [
      "priver",
      0.0075
    ],
    [
      "ravir",
      0.0075
    ],
    [
      "pousser",
      0.0075
    ],
    [
      "deposer",
      0.0075
    ],
    [
      "defaire",
      0.0075
    ],
    [
      "alleger",
      0.0075
    ],
    [
      "elaguer",
      0.005
    ],
    [
      "sevrer",
      0.005
    ],
    [
      "renvoyer",
      0.005
    ],
    [
      "quitter",
      0.005
    ],
    [
      "isoler",
      0.005
    ],
    [
      "gommer",
      0.005
    ],
    [
      "bannir",
      0.005
    ],
    [
      "amputer",
      0.005
    ],
    [
      "plumer",
      0.0025
    ],
    [
      "prelever",
      0.0025
    ],
    [
      "spolier",
      0.0025
    ],
    [
      "tondre",
      0.0025
    ],
    [
      "vider",
      0.0025
    ],
    [
      "peler",
      0.0025
    ],
    [
      "frustrer",
      0.0025
    ],
    [
      "excepter",
      0.0025
    ],
    [
      "derober",
      0.0025
    ],
    [
      "deduire",
      0.0025
    ],
    [
      "decouvrir",
      0.0025
    ],
    [
      "soulager",
      0.0025
    ],
    [
      "souffler",
      0.0025
    ],
    [
      "obliterer",
      0.0025
    ],
    [
      "deshabiller",
      0.0025
    ],
    [
      "deplacer",
      0.0025
    ],
    [
      "confisquer",
      0.0
    ],
    [
      "desservir",
      0.0
    ],
    [
      "decrocher",
      0.0
    ],
    [
      "defalquer",
      0.0
    ],
    [
      "retraire",
      0.0
    ]
  ],
  "cil": [
    [
      "poil",
      1.0
    ]
  ],
  "clown": [
    [
      "pitre",
      0.1425
    ],
    [
      "bouffon",
      0.1275
    ],
    [
      "saltimbanque",
      0.0825
    ],
    [
      "turlupin",
      0.075
    ],
    [
      "baladin",
      0.06
    ],
    [
      "farceur",
      0.06
    ],
    [
      "polichinelle",
      0.045
    ],
    [
      "guignol",
      0.0375
    ],
    [
      "pantin",
      0.0375
    ],
    [
      "bateleur",
      0.03
    ],
    [
      "plaisant",
      0.03
    ],
    [
      "singe",
      0.0225
    ],
    [
      "paillasse",
      0.0225
    ],
    [
      "histrion",
      0.0225
    ],
    [
      "gugusse",
      0.0225
    ],
    [
      "comique",
      0.0225
    ],
    [
      "zouave",
      0.015
    ],
    [
      "pierrot",
      0.015
    ],
    [
      "matassin",
      0.015
    ],
    [
      "fantaisiste",
      0.015
    ],
    [
      "auguste",
      0.015
    ],
    [
      "artiste",
      0.015
    ],
    [
      "acrobate",
      0.015
    ],
    [
      "amuseur",
      0.005
    ],
    [
      "cabotin",
      0.005
    ],
    [
      "charlot",
      0.005
    ],
    [
      "fantoche",
      0.005
    ],
    [
      "marionnette",
      0.005
    ],
    [
      "mime",
      0.005
    ]
  ],
  "malheureux": [
    [
      "mauvais",
      0.0975
    ],
    [
      "triste",
      0.0625
    ],
    [
      "funeste",
      0.05
    ],
    [
      "miserable",
      0.0475
    ],
    [
      "deplorable",
      0.045
    ],
    [
      "facheux",
      0.0425
    ],
    [
      "pitoyable",
      0.04
    ],
    [
      "pauvre",
      0.0375
    ],
    [
      "penible",
      0.0275
    ],
    [
      "desastreux",
      0.025
    ],
    [
      "lamentable",
      0.0225
    ],
    [
      "mechant",
      0.0225
    ],
    [
      "catastrophique",
      0.0175
    ],
    [
      "dangereux",
      0.0175
    ],
    [
      "insignifiant",
      0.0175
    ],
    [
      "piteux",
      0.015
    ],
    [
      "petit",
      0.015
    ],
    [
      "malencontreux",
      0.015
    ],
    [
      "fichu",
      0.015
    ],
    [
      "faible",
      0.015
    ],
    [
      "desagreable",
      0.015
    ],
    [
      "cruel",
      0.015
    ],
    [
      "maudit",
      0.0125
    ],
    [
      "rude",
      0.0125
    ],
    [
      "sinistre",
      0.01
    ],
    [
      "nefaste",
      0.01
    ],
    [
      "mince",
      0.01
    ],
    [
      "dur",
      0.01
    ],
    [
      "calamiteux",
      0.01
    ],
    [
      "afflige",
      0.01
    ],
    [
      "affligeant",
      0.01
    ],
    [
      "regrettable",
      0.0075
    ],
    [
      "infortune",
      0.0075
    ],
    [
      "fatal",
      0.0075
    ],
    [
      "desespere",
      0.0075
    ],
    [
      "difficile",
      0.0075
    ],
    [
      "sacre",
      0.005
    ],
    [
      "redoutable",
      0.005
    ],
    [
      "modeste",
      0.005
    ],
    [
      "misereux",
      0.005
    ],
    [
      "malchanceux",
      0.005
    ],
    [
      "indigent",
      0.005
    ],
    [
      "gueux",
      0.005
    ],
    [
      "eprouve",
      0.0025
    ],
    [
      "vil",
      0.0025
    ],
    [
      "peine",
      0.0025
    ],
    [
      "negligeable",
      0.0025
    ],
    [
      "necessiteux",
      0.0025
    ],
    [
      "irreparable",
      0.0025
    ],
    [
      "besogneux",
      0.0025
    ],
    [
      "quelconque",
      0.0
    ],
    [
      "rate",
      0.0
    ],
    [
      "risque",
      0.0
    ],
    [
      "satane",
      0.0
    ],
    [
      "sombre",
      0.0
    ],
    [
      "prejudiciable",
      0.0
    ],
    [
      "perdu",
      0.0
    ],
    [
      "malefique",
      0.0
    ],
    [
      "lugubre",
      0.0
    ],
    [
      "inhabile",
      0.0
    ],
    [
      "guignard",
      0.0
    ],
    [
      "frappe",
      0.0
    ],
    [
      "accable",
      0.0
    ]
  ],
  "lassitude": [
    [
      "abattement",
      0.205
    ],
    [
      "accablement",
      0.135
    ],
    [
      "decouragement",
      0.095
    ],
    [
      "fatigue",
      0.0675
    ],
    [
      "tristesse",
      0.0675
    ],
    [
      "epuisement",
      0.0525
    ],
    [
      "ecoeurement",
      0.0525
    ],
    [
      "ennui",
      0.0525
    ],
    [
      "desesperance",
      0.0525
    ],
    [
      "degout",
      0.0525
    ],
    [
      "depression",
      0.04
    ],
    [
      "langueur",
      0.04
    ],
    [
      "demoralisation",
      0.025
    ],
    [
      "brisement",
      0.0125
    ],
    [
      "courbature",
      0.0125
    ],
    [
      "ereintement",
      0.0125
    ]
  ],
  "garcon": [
    [
      "enfant",
      0.0875
    ],
    [
      "gars",
      0.0875
    ],
    [
      "type",
      0.0575
    ],
    [
      "homme",
      0.0575
    ],
    [
      "drole",
      0.0575
    ],
    [
      "celibataire",
      0.0575
    ],
    [
      "barman",
      0.0575
    ],
    [
      "steward",
      0.0275
    ],
    [
      "serveur",
      0.0275
    ],
    [
      "livreur",
      0.0275
    ],
    [
      "lad",
      0.0275
    ],
    [
      "jouvenceau",
      0.0275
    ],
    [
      "huissier",
      0.0275
    ],
    [
      "groom",
      0.0275
    ],
    [
      "garconnet",
      0.0275
    ],
    [
      "fils",
      0.0275
    ],
    [
      "employe",
      0.0275
    ],
    [
      "coursier",
      0.0275
    ],
    [
      "chasseur",
      0.0275
    ],
    [
      "boy",
      0.0275
    ],
    [
      "apprenti",
      0.0275
    ]
  ],
  "dieu": [
    [
      "Providence",
      0.0675
    ],
    [
      "Seigneur",
      0.0325
    ],
    [
      "Trinite",
      0.0325
    ],
    [
      "Verbe",
      0.0325
    ],
    [
      "bleu",
      0.0325
    ],
    [
      "logos",
      0.0325
    ],
    [
      "Eternel",
      0.0325
    ],
    [
      "Sauveur",
      0.0325
    ],
    [
      "Allah",
      0.0325
    ],
    [
      "Ciel",
      0.0325
    ],
    [
      "Createur",
      0.0325
    ],
    [
      "Demiurge",
      0.0325
    ],
    [
      "Esprit",
      0.0325
    ],
    [
      "Jahve",
      0.0325
    ],
    [
      "Jehovah",
      0.0325
    ],
    [
      "Pere",
      0.0325
    ]
  ],
  "mis": [
    [
      "placer",
      0.0875
    ],
    [
      "poser",
      0.0475
    ],
    [
      "appliquer",
      0.0375
    ],
    [
      "ficher",
      0.0325
    ],
    [
      "coller",
      0.0275
    ],
    [
      "situer",
      0.0275
    ],
    [
      "fixer",
      0.0275
    ],
    [
      "etablir",
      0.025
    ],
    [
      "introduire",
      0.0225
    ],
    [
      "porter",
      0.0225
    ],
    [
      "prendre",
      0.02
    ],
    [
      "fourrer",
      0.02
    ],
    [
      "disposer",
      0.0175
    ],
    [
      "attacher",
      0.0175
    ],
    [
      "installer",
      0.015
    ],
    [
      "camper",
      0.015
    ],
    [
      "tenir",
      0.0125
    ],
    [
      "planter",
      0.0125
    ],
    [
      "passer",
      0.0125
    ],
    [
      "loger",
      0.0125
    ],
    [
      "engager",
      0.0125
    ],
    [
      "caser",
      0.0125
    ],
    [
      "affecter",
      0.0125
    ],
    [
      "etendre",
      0.01
    ],
    [
      "remettre",
      0.01
    ],
    [
      "flanquer",
      0.01
    ],
    [
      "dresser",
      0.01
    ],
    [
      "coucher",
      0.01
    ],
    [
      "consigner",
      0.01
    ],
    [
      "appuyer",
      0.01
    ],
    [
      "marquer",
      0.01
    ],
    [
      "jeter",
      0.01
    ],
    [
      "inscrire",
      0.01
    ],
    [
      "charger",
      0.01
    ],
    [
      "ranger",
      0.0075
    ],
    [
      "employer",
      0.0075
    ],
    [
      "conduire",
      0.0075
    ],
    [
      "asseoir",
      0.0075
    ],
    [
      "arrimer",
      0.0075
    ],
    [
      "arranger",
      0.0075
    ],
    [
      "etaler",
      0.0075
    ],
    [
      "laisser",
      0.0075
    ],
    [
      "foutre",
      0.0075
    ],
    [
      "amener",
      0.0075
    ],
    [
      "mener",
      0.005
    ],
    [
      "noter",
      0.005
    ],
    [
      "plaquer",
      0.005
    ],
    [
      "poster",
      0.005
    ],
    [
      "preparer",
      0.005
    ],
    [
      "serrer",
      0.005
    ],
    [
      "ecrire",
      0.005
    ],
    [
      "imputer",
      0.005
    ],
    [
      "glisser",
      0.005
    ],
    [
      "afficher",
      0.005
    ],
    [
      "apporter",
      0.005
    ],
    [
      "attribuer",
      0.005
    ],
    [
      "classer",
      0.005
    ],
    [
      "deposer",
      0.005
    ],
    [
      "enfiler",
      0.005
    ],
    [
      "enfoncer",
      0.005
    ],
    [
      "verser",
      0.0025
    ],
    [
      "revetir",
      0.0025
    ],
    [
      "manger",
      0.0025
    ],
    [
      "interposer",
      0.0025
    ],
    [
      "inserer",
      0.0025
    ],
    [
      "fricoter",
      0.0025
    ],
    [
      "fonder",
      0.0025
    ],
    [
      "constituer",
      0.0025
    ],
    [
      "consacrer",
      0.0025
    ],
    [
      "adosser",
      0.0025
    ],
    [
      "melanger",
      0.0025
    ],
    [
      "opposer",
      0.0025
    ],
    [
      "plonger",
      0.0025
    ],
    [
      "reduire",
      0.0025
    ],
    [
      "s'habiller",
      0.0025
    ],
    [
      "traduire",
      0.0025
    ],
    [
      "imposer",
      0.0025
    ],
    [
      "immatriculer",
      0.0025
    ],
    [
      "admettre",
      0.0025
    ],
    [
      "attendre",
      0.0025
    ],
    [
      "considerer",
      0.0025
    ],
    [
      "croquer",
      0.0025
    ],
    [
      "emmener",
      0.0025
    ],
    [
      "endosser",
      0.0025
    ],
    [
      "fricasser",
      0.0025
    ],
    [
      "trouver",
      0.0
    ],
    [
      "rajouter",
      0.0
    ],
    [
      "miser",
      0.0
    ],
    [
      "mentionner",
      0.0
    ],
    [
      "garder",
      0.0
    ],
    [
      "empiler",
      0.0
    ],
    [
      "claquer",
      0.0
    ],
    [
      "chausser",
      0.0
    ],
    [
      "bouter",
      0.0
    ],
    [
      "apposer",
      0.0
    ],
    [
      "agrafer",
      0.0
    ],
    [
      "vetir",
      0.0
    ]
  ],
  "memoire": [
    [
      "souvenir",
      0.0925
    ],
    [
      "note",
      0.06
    ],
    [
      "commemoration",
      0.05
    ],
    [
      "memento",
      0.04
    ],
    [
      "rappel",
      0.04
    ],
    [
      "etat",
      0.03
    ],
    [
      "releve",
      0.03
    ],
    [
      "carnet",
      0.03
    ],
    [
      "renommee",
      0.02
    ],
    [
      "ressouvenir",
      0.02
    ],
    [
      "reminiscence",
      0.02
    ],
    [
      "repertoire",
      0.02
    ],
    [
      "souvenance",
      0.02
    ],
    [
      "trace",
      0.02
    ],
    [
      "traite",
      0.02
    ],
    [
      "relation",
      0.02
    ],
    [
      "reconnaissance",
      0.02
    ],
    [
      "anniversaire",
      0.02
    ],
    [
      "commentaire",
      0.02
    ],
    [
      "celebration",
      0.02
    ],
    [
      "essai",
      0.02
    ],
    [
      "expose",
      0.02
    ],
    [
      "facture",
      0.02
    ],
    [
      "passe",
      0.02
    ],
    [
      "recognition",
      0.0075
    ],
    [
      "rapport",
      0.0075
    ],
    [
      "posterite",
      0.0075
    ],
    [
      "memoration",
      0.0075
    ],
    [
      "moyen",
      0.0075
    ],
    [
      "monographie",
      0.0075
    ],
    [
      "remembrance",
      0.0075
    ],
    [
      "ressouvenance",
      0.0075
    ],
    [
      "reputation",
      0.0075
    ],
    [
      "savoir",
      0.0075
    ],
    [
      "tableau",
      0.0075
    ],
    [
      "tradition",
      0.0075
    ],
    [
      "tete",
      0.0075
    ],
    [
      "etude",
      0.0075
    ],
    [
      "mention",
      0.0075
    ],
    [
      "liste",
      0.0075
    ],
    [
      "imagination",
      0.0075
    ],
    [
      "anamnesie",
      0.0075
    ],
    [
      "cahier",
      0.0075
    ],
    [
      "catalogue",
      0.0075
    ],
    [
      "coeur",
      0.0075
    ],
    [
      "commemoraison",
      0.0075
    ],
    [
      "compte",
      0.0075
    ],
    [
      "confession",
      0.0075
    ],
    [
      "conservation",
      0.0075
    ],
    [
      "dissertation",
      0.0075
    ],
    [
      "empreinte",
      0.0075
    ],
    [
      "factum",
      0.0075
    ],
    [
      "faculte",
      0.0075
    ],
    [
      "facultes",
      0.0075
    ],
    [
      "anamnese",
      0.0075
    ]
  ],
  "tendre": [
    [
      "doux",
      0.115
    ],
    [
      "delicat",
      0.0825
    ],
    [
      "sensible",
      0.0675
    ],
    [
      "bon",
      0.0525
    ],
    [
      "affectueux",
      0.0475
    ],
    [
      "amoureux",
      0.0475
    ],
    [
      "faible",
      0.0475
    ],
    [
      "sentimental",
      0.0475
    ],
    [
      "gracieux",
      0.04
    ],
    [
      "calin",
      0.025
    ],
    [
      "douillet",
      0.025
    ],
    [
      "moelleux",
      0.025
    ],
    [
      "suave",
      0.02
    ],
    [
      "mou",
      0.02
    ],
    [
      "langoureux",
      0.02
    ],
    [
      "humain",
      0.02
    ],
    [
      "galant",
      0.02
    ],
    [
      "fragile",
      0.02
    ],
    [
      "fin",
      0.02
    ],
    [
      "caressant",
      0.02
    ],
    [
      "touchant",
      0.0125
    ],
    [
      "romanesque",
      0.0125
    ],
    [
      "pale",
      0.0125
    ],
    [
      "languissant",
      0.0125
    ],
    [
      "impressionnable",
      0.0125
    ],
    [
      "gentil",
      0.0125
    ],
    [
      "facile",
      0.0125
    ],
    [
      "attendrissant",
      0.0125
    ],
    [
      "alangui",
      0.0125
    ],
    [
      "aimant",
      0.0125
    ],
    [
      "penchant",
      0.005
    ],
    [
      "pastel",
      0.005
    ],
    [
      "fraternel",
      0.005
    ],
    [
      "frais",
      0.005
    ],
    [
      "fondant",
      0.005
    ],
    [
      "enjoleur",
      0.005
    ],
    [
      "compatissant",
      0.005
    ],
    [
      "cajoleur",
      0.005
    ],
    [
      "elegiaque",
      0.005
    ]
  ],
  "objet": [
    [
      "matiere",
      0.16
    ],
    [
      "but",
      0.0625
    ],
    [
      "cause",
      0.0625
    ],
    [
      "substance",
      0.0625
    ],
    [
      "theme",
      0.045
    ],
    [
      "intention",
      0.045
    ],
    [
      "fond",
      0.045
    ],
    [
      "dessein",
      0.045
    ],
    [
      "ustensile",
      0.03
    ],
    [
      "realite",
      0.03
    ],
    [
      "propos",
      0.03
    ],
    [
      "outil",
      0.03
    ],
    [
      "fin",
      0.03
    ],
    [
      "corps",
      0.03
    ],
    [
      "chose",
      0.03
    ],
    [
      "chapitre",
      0.03
    ],
    [
      "bidule",
      0.03
    ],
    [
      "article",
      0.03
    ],
    [
      "solide",
      0.015
    ],
    [
      "objectif",
      0.015
    ],
    [
      "lieu",
      0.015
    ],
    [
      "concept",
      0.015
    ],
    [
      "champ",
      0.015
    ],
    [
      "bibelot",
      0.015
    ],
    [
      "ambition",
      0.015
    ],
    [
      "agent",
      0.015
    ],
    [
      "teneur",
      0.015
    ]
  ],
  "clair": [
    [
      "evident",
      0.0675
    ],
    [
      "net",
      0.0575
    ],
    [
      "transparent",
      0.0475
    ],
    [
      "limpide",
      0.04
    ],
    [
      "intelligible",
      0.0375
    ],
    [
      "certain",
      0.0375
    ],
    [
      "manifeste",
      0.035
    ],
    [
      "sensible",
      0.03
    ],
    [
      "lumineux",
      0.0275
    ],
    [
      "visible",
      0.0275
    ],
    [
      "pur",
      0.025
    ],
    [
      "franc",
      0.025
    ],
    [
      "distinct",
      0.0225
    ],
    [
      "sincere",
      0.0225
    ],
    [
      "eclatant",
      0.0225
    ],
    [
      "formel",
      0.02
    ],
    [
      "ouvert",
      0.02
    ],
    [
      "precis",
      0.02
    ],
    [
      "vif",
      0.0175
    ],
    [
      "penetrant",
      0.0175
    ],
    [
      "lucide",
      0.0175
    ],
    [
      "comprehensible",
      0.0175
    ],
    [
      "simple",
      0.015
    ],
    [
      "sur",
      0.0125
    ],
    [
      "perceptible",
      0.0125
    ],
    [
      "facile",
      0.0125
    ],
    [
      "categorique",
      0.0125
    ],
    [
      "brillant",
      0.0125
    ],
    [
      "beau",
      0.0125
    ],
    [
      "etincelant",
      0.01
    ],
    [
      "perspicace",
      0.01
    ],
    [
      "leger",
      0.01
    ],
    [
      "poli",
      0.0075
    ],
    [
      "notoire",
      0.0075
    ],
    [
      "diaphane",
      0.0075
    ],
    [
      "apparent",
      0.0075
    ],
    [
      "aigu",
      0.0075
    ],
    [
      "translucide",
      0.005
    ],
    [
      "significatif",
      0.005
    ],
    [
      "pale",
      0.005
    ],
    [
      "luisant",
      0.005
    ],
    [
      "irrecusable",
      0.005
    ],
    [
      "gai",
      0.005
    ],
    [
      "doux",
      0.005
    ],
    [
      "cristallin",
      0.005
    ],
    [
      "clairvoyant",
      0.005
    ],
    [
      "blanc",
      0.005
    ],
    [
      "aise",
      0.005
    ],
    [
      "printanier",
      0.0025
    ],
    [
      "propre",
      0.0025
    ],
    [
      "penetrable",
      0.0025
    ],
    [
      "serein",
      0.0025
    ],
    [
      "eclaire",
      0.0025
    ],
    [
      "palpable",
      0.0025
    ],
    [
      "nettement",
      0.0025
    ],
    [
      "franchement",
      0.0025
    ],
    [
      "fluide",
      0.0025
    ],
    [
      "explicite",
      0.0025
    ],
    [
      "delie",
      0.0025
    ],
    [
      "droit",
      0.0025
    ],
    [
      "conscient",
      0.0025
    ],
    [
      "clairseme",
      0.0
    ],
    [
      "expres",
      0.0
    ],
    [
      "filasse",
      0.0
    ],
    [
      "rare",
      0.0
    ],
    [
      "sagace",
      0.0
    ],
    [
      "clairiere",
      0.0
    ],
    [
      "clairet",
      0.0
    ],
    [
      "clairement",
      0.0
    ],
    [
      "cartesien",
      0.0
    ],
    [
      "aere",
      0.0
    ],
    [
      "argentin",
      0.0
    ],
    [
      "apert",
      0.0
    ]
  ],
  "lit": [
    [
      "dechiffrer",
      0.1175
    ],
    [
      "decouvrir",
      0.1
    ],
    [
      "reperer",
      0.0825
    ],
    [
      "penetrer",
      0.0675
    ],
    [
      "voir",
      0.05
    ],
    [
      "expliquer",
      0.05
    ],
    [
      "dire",
      0.05
    ],
    [
      "deviner",
      0.05
    ],
    [
      "epeler",
      0.0325
    ],
    [
      "percer",
      0.0325
    ],
    [
      "interpreter",
      0.0325
    ],
    [
      "feuilleter",
      0.0325
    ],
    [
      "discerner",
      0.0325
    ],
    [
      "consulter",
      0.0325
    ],
    [
      "survoler",
      0.015
    ],
    [
      "reciter",
      0.015
    ],
    [
      "prononcer",
      0.015
    ],
    [
      "parcourir",
      0.015
    ],
    [
      "frequenter",
      0.015
    ],
    [
      "devorer",
      0.015
    ],
    [
      "depouiller",
      0.015
    ],
    [
      "decrypter",
      0.015
    ],
    [
      "decoder",
      0.015
    ],
    [
      "debrouiller",
      0.015
    ],
    [
      "compulser",
      0.015
    ],
    [
      "bouquiner",
      0.015
    ],
    [
      "anonner",
      0.015
    ]
  ],
  "droit": [
    [
      "bon",
      0.05
    ],
    [
      "juste",
      0.05
    ],
    [
      "net",
      0.0475
    ],
    [
      "honnete",
      0.045
    ],
    [
      "franc",
      0.04
    ],
    [
      "vrai",
      0.035
    ],
    [
      "pur",
      0.03
    ],
    [
      "pouvoir",
      0.025
    ],
    [
      "sincere",
      0.0225
    ],
    [
      "loyal",
      0.0175
    ],
    [
      "loi",
      0.0175
    ],
    [
      "ferme",
      0.0175
    ],
    [
      "faculte",
      0.0175
    ],
    [
      "bien",
      0.0175
    ],
    [
      "equitable",
      0.015
    ],
    [
      "simple",
      0.015
    ],
    [
      "raisonnable",
      0.015
    ],
    [
      "probe",
      0.015
    ],
    [
      "privilege",
      0.015
    ],
    [
      "judicieux",
      0.015
    ],
    [
      "avantage",
      0.015
    ],
    [
      "regulier",
      0.0125
    ],
    [
      "puissance",
      0.0125
    ],
    [
      "prerogative",
      0.0125
    ],
    [
      "logique",
      0.0125
    ],
    [
      "impartial",
      0.0125
    ],
    [
      "direct",
      0.0125
    ],
    [
      "debout",
      0.0125
    ],
    [
      "carre",
      0.0125
    ],
    [
      "titre",
      0.0075
    ],
    [
      "strict",
      0.0075
    ],
    [
      "sain",
      0.0075
    ],
    [
      "redevance",
      0.0075
    ],
    [
      "qualite",
      0.0075
    ],
    [
      "objectif",
      0.0075
    ],
    [
      "justice",
      0.0075
    ],
    [
      "code",
      0.0075
    ],
    [
      "autorisation",
      0.0075
    ],
    [
      "abrupt",
      0.0075
    ],
    [
      "raide",
      0.005
    ],
    [
      "rationnel",
      0.005
    ],
    [
      "rectiligne",
      0.005
    ],
    [
      "retribution",
      0.005
    ],
    [
      "sense",
      0.005
    ],
    [
      "uniforme",
      0.005
    ],
    [
      "usage",
      0.005
    ],
    [
      "vertical",
      0.005
    ],
    [
      "egal",
      0.005
    ],
    [
      "possibilite",
      0.005
    ],
    [
      "positif",
      0.005
    ],
    [
      "permission",
      0.005
    ],
    [
      "benefice",
      0.005
    ],
    [
      "clair",
      0.005
    ],
    [
      "coutume",
      0.005
    ],
    [
      "dette",
      0.005
    ],
    [
      "desinteresse",
      0.005
    ],
    [
      "impot",
      0.005
    ],
    [
      "irreprochable",
      0.005
    ],
    [
      "jurisprudence",
      0.005
    ],
    [
      "legislation",
      0.005
    ],
    [
      "obvers",
      0.0025
    ],
    [
      "morale",
      0.0025
    ],
    [
      "monopole",
      0.0025
    ],
    [
      "legitimite",
      0.0025
    ],
    [
      "legislateur",
      0.0025
    ],
    [
      "passeport",
      0.0025
    ],
    [
      "perpendiculaire",
      0.0025
    ],
    [
      "prud'homme",
      0.0025
    ],
    [
      "reglement",
      0.0025
    ],
    [
      "salaire",
      0.0025
    ],
    [
      "taxe",
      0.0025
    ],
    [
      "verticalement",
      0.0025
    ],
    [
      "legalite",
      0.0025
    ],
    [
      "liberte",
      0.0025
    ],
    [
      "imposition",
      0.0025
    ],
    [
      "aligne",
      0.0025
    ],
    [
      "attribution",
      0.0025
    ],
    [
      "avers",
      0.0025
    ],
    [
      "contribution",
      0.0025
    ],
    [
      "dextre",
      0.0025
    ],
    [
      "dextrogyre",
      0.0025
    ],
    [
      "digeste",
      0.0025
    ],
    [
      "directement",
      0.0025
    ],
    [
      "dresse",
      0.0025
    ],
    [
      "droitement",
      0.0025
    ],
    [
      "du",
      0.0025
    ],
    [
      "habilete",
      0.0025
    ],
    [
      "habilite",
      0.0025
    ]
  ],
  "blamer": [
    [
      "critiquer",
      0.105
    ],
    [
      "reprimander",
      0.0975
    ],
    [
      "tancer",
      0.0975
    ],
    [
      "condamner",
      0.0925
    ],
    [
      "censurer",
      0.04
    ],
    [
      "sermonner",
      0.0375
    ],
    [
      "reprocher",
      0.0375
    ],
    [
      "fletrir",
      0.0375
    ],
    [
      "reprouver",
      0.0325
    ],
    [
      "stigmatiser",
      0.0275
    ],
    [
      "vituperer",
      0.0275
    ],
    [
      "desapprouver",
      0.025
    ],
    [
      "corriger",
      0.025
    ],
    [
      "attaquer",
      0.025
    ],
    [
      "accuser",
      0.02
    ],
    [
      "chapitrer",
      0.02
    ],
    [
      "fustiger",
      0.02
    ],
    [
      "admonester",
      0.015
    ],
    [
      "anathematiser",
      0.015
    ],
    [
      "morigener",
      0.015
    ],
    [
      "reprendre",
      0.015
    ],
    [
      "incriminer",
      0.0125
    ],
    [
      "flageller",
      0.0125
    ],
    [
      "epiloguer",
      0.0075
    ],
    [
      "semoncer",
      0.0075
    ],
    [
      "punir",
      0.0075
    ],
    [
      "maudire",
      0.0075
    ],
    [
      "excommunier",
      0.0075
    ],
    [
      "improuver",
      0.0025
    ],
    [
      "honnir",
      0.0025
    ],
    [
      "fronder",
      0.0025
    ],
    [
      "desavouer",
      0.0025
    ],
    [
      "dauber",
      0.0025
    ],
    [
      "commenter",
      0.0025
    ],
    [
      "attraper",
      0.0025
    ],
    [
      "relever",
      0.0025
    ]
  ],
  "juger": [
    [
      "estimer",
      0.085
    ],
    [
      "considerer",
      0.0525
    ],
    [
      "voir",
      0.0525
    ],
    [
      "apprecier",
      0.0475
    ],
    [
      "examiner",
      0.045
    ],
    [
      "penser",
      0.045
    ],
    [
      "trouver",
      0.0375
    ],
    [
      "trancher",
      0.03
    ],
    [
      "evaluer",
      0.0275
    ],
    [
      "peser",
      0.0275
    ],
    [
      "imaginer",
      0.0275
    ],
    [
      "decider",
      0.0225
    ],
    [
      "reconnaitre",
      0.0225
    ],
    [
      "regarder",
      0.0225
    ],
    [
      "classer",
      0.02
    ],
    [
      "croire",
      0.02
    ],
    [
      "jauger",
      0.0175
    ],
    [
      "entendre",
      0.0175
    ],
    [
      "discerner",
      0.0175
    ],
    [
      "deviner",
      0.0175
    ],
    [
      "connaitre",
      0.0175
    ],
    [
      "verifier",
      0.0125
    ],
    [
      "sonder",
      0.0125
    ],
    [
      "resoudre",
      0.0125
    ],
    [
      "noter",
      0.0125
    ],
    [
      "mesurer",
      0.0125
    ],
    [
      "determiner",
      0.0125
    ],
    [
      "coter",
      0.0125
    ],
    [
      "statuer",
      0.01
    ],
    [
      "reputer",
      0.01
    ],
    [
      "regler",
      0.01
    ],
    [
      "prendre",
      0.01
    ],
    [
      "envisager",
      0.01
    ],
    [
      "distinguer",
      0.01
    ],
    [
      "controler",
      0.01
    ],
    [
      "conjecturer",
      0.01
    ],
    [
      "arbitrer",
      0.01
    ],
    [
      "etiqueter",
      0.005
    ],
    [
      "prononcer",
      0.005
    ],
    [
      "expertiser",
      0.005
    ],
    [
      "desapprouver",
      0.005
    ],
    [
      "dire",
      0.005
    ],
    [
      "critiquer",
      0.005
    ],
    [
      "conclure",
      0.005
    ],
    [
      "cataloguer",
      0.005
    ],
    [
      "soupeser",
      0.0025
    ],
    [
      "sentencier",
      0.0025
    ],
    [
      "raisonner",
      0.0025
    ],
    [
      "pronostiquer",
      0.0025
    ],
    [
      "departager",
      0.0025
    ],
    [
      "adjuger",
      0.0025
    ]
  ],
  "precis": [
    [
      "exact",
      0.0825
    ],
    [
      "net",
      0.06
    ],
    [
      "certain",
      0.045
    ],
    [
      "juste",
      0.0375
    ],
    [
      "resume",
      0.0325
    ],
    [
      "clair",
      0.03
    ],
    [
      "formel",
      0.025
    ],
    [
      "sur",
      0.025
    ],
    [
      "sommaire",
      0.0225
    ],
    [
      "rigoureux",
      0.0225
    ],
    [
      "propre",
      0.0225
    ],
    [
      "fort",
      0.0225
    ],
    [
      "ferme",
      0.0225
    ],
    [
      "abrege",
      0.0225
    ],
    [
      "logique",
      0.02
    ],
    [
      "franc",
      0.02
    ],
    [
      "fidele",
      0.02
    ],
    [
      "court",
      0.02
    ],
    [
      "categorique",
      0.02
    ],
    [
      "scrupuleux",
      0.015
    ],
    [
      "ponctuel",
      0.015
    ],
    [
      "determine",
      0.015
    ],
    [
      "distinct",
      0.015
    ],
    [
      "concis",
      0.015
    ],
    [
      "strict",
      0.0125
    ],
    [
      "regulier",
      0.0125
    ],
    [
      "fixe",
      0.0125
    ],
    [
      "extrait",
      0.0125
    ],
    [
      "analyse",
      0.0125
    ],
    [
      "absolu",
      0.0125
    ],
    [
      "specifique",
      0.01
    ],
    [
      "soigneux",
      0.01
    ],
    [
      "serre",
      0.01
    ],
    [
      "reduit",
      0.01
    ],
    [
      "ramasse",
      0.01
    ],
    [
      "memento",
      0.01
    ],
    [
      "mathematique",
      0.01
    ],
    [
      "marque",
      0.01
    ],
    [
      "concentre",
      0.01
    ],
    [
      "compendium",
      0.01
    ],
    [
      "manuel",
      0.005
    ],
    [
      "objectif",
      0.005
    ],
    [
      "particulier",
      0.005
    ],
    [
      "raccourci",
      0.005
    ],
    [
      "sonnant",
      0.005
    ],
    [
      "transparent",
      0.005
    ],
    [
      "veridique",
      0.005
    ],
    [
      "localise",
      0.005
    ],
    [
      "laconique",
      0.005
    ],
    [
      "assure",
      0.005
    ],
    [
      "bref",
      0.005
    ],
    [
      "defini",
      0.005
    ],
    [
      "explicite",
      0.005
    ],
    [
      "expres",
      0.005
    ],
    [
      "geometrique",
      0.005
    ],
    [
      "intelligible",
      0.005
    ],
    [
      "tapant",
      0.0025
    ],
    [
      "pile",
      0.0025
    ],
    [
      "developpe",
      0.0025
    ],
    [
      "detaille",
      0.0025
    ],
    [
      "congru",
      0.0025
    ],
    [
      "codex",
      0.0025
    ],
    [
      "code",
      0.0025
    ],
    [
      "circonstancie",
      0.0025
    ],
    [
      "adroit",
      0.0025
    ],
    [
      "epitome",
      0.0025
    ]
  ],
  "preciser": [
    [
      "specifier",
      0.1175
    ],
    [
      "caracteriser",
      0.0875
    ],
    [
      "indiquer",
      0.0725
    ],
    [
      "enoncer",
      0.0725
    ],
    [
      "expliquer",
      0.0575
    ],
    [
      "signifier",
      0.0575
    ],
    [
      "reduire",
      0.0425
    ],
    [
      "fixer",
      0.0425
    ],
    [
      "determiner",
      0.0425
    ],
    [
      "definir",
      0.0425
    ],
    [
      "etablir",
      0.0275
    ],
    [
      "stipuler",
      0.0275
    ],
    [
      "resumer",
      0.0275
    ],
    [
      "particulariser",
      0.0275
    ],
    [
      "exprimer",
      0.0275
    ],
    [
      "expliciter",
      0.0275
    ],
    [
      "circonstancier",
      0.0275
    ],
    [
      "abreger",
      0.0275
    ],
    [
      "ramasser",
      0.0125
    ],
    [
      "raccourcir",
      0.0125
    ],
    [
      "detailler",
      0.0125
    ],
    [
      "distinguer",
      0.0125
    ],
    [
      "concretiser",
      0.0125
    ],
    [
      "clarifier",
      0.0125
    ],
    [
      "souligner",
      0.0125
    ]
  ],
  "responsable": [
    [
      "chef",
      0.09
    ],
    [
      "coupable",
      0.06
    ],
    [
      "directeur",
      0.06
    ],
    [
      "dirigeant",
      0.06
    ],
    [
      "ame",
      0.06
    ],
    [
      "instigateur",
      0.045
    ],
    [
      "condamnable",
      0.045
    ],
    [
      "auteur",
      0.045
    ],
    [
      "tuteur",
      0.03
    ],
    [
      "reprehensible",
      0.03
    ],
    [
      "representant",
      0.03
    ],
    [
      "pilote",
      0.03
    ],
    [
      "leader",
      0.03
    ],
    [
      "garant",
      0.03
    ],
    [
      "comptable",
      0.03
    ],
    [
      "cerveau",
      0.03
    ],
    [
      "artisan",
      0.03
    ],
    [
      "animateur",
      0.03
    ],
    [
      "pendable",
      0.015
    ],
    [
      "pivot",
      0.015
    ],
    [
      "punissable",
      0.015
    ],
    [
      "repondant",
      0.015
    ],
    [
      "solidaire",
      0.015
    ],
    [
      "nautonier",
      0.015
    ],
    [
      "mandataire",
      0.015
    ],
    [
      "gouvernant",
      0.015
    ],
    [
      "fautif",
      0.015
    ],
    [
      "envoye",
      0.015
    ],
    [
      "decideur",
      0.015
    ],
    [
      "cadre",
      0.015
    ],
    [
      "adulte",
      0.015
    ],
    [
      "tenu",
      0.015
    ]
  ],
  "fleur": [
    [
      "beaute",
      0.1075
    ],
    [
      "gratin",
      0.1075
    ],
    [
      "elite",
      0.1075
    ],
    [
      "phenix",
      0.0525
    ],
    [
      "perfection",
      0.0525
    ],
    [
      "meilleur",
      0.0525
    ],
    [
      "creme",
      0.0525
    ],
    [
      "choix",
      0.0525
    ],
    [
      "virginite",
      0.025
    ],
    [
      "tresor",
      0.025
    ],
    [
      "seuil",
      0.025
    ],
    [
      "ornement",
      0.025
    ],
    [
      "lustre",
      0.025
    ],
    [
      "fraicheur",
      0.025
    ],
    [
      "force",
      0.025
    ],
    [
      "femelle",
      0.025
    ],
    [
      "efflorescence",
      0.025
    ],
    [
      "commencement",
      0.025
    ],
    [
      "charme",
      0.025
    ],
    [
      "eclat",
      0.025
    ]
  ],
  "faner": [
    [
      "fletrir",
      0.135
    ],
    [
      "ternir",
      0.1075
    ],
    [
      "passer",
      0.08
    ],
    [
      "eteindre",
      0.0525
    ],
    [
      "secher",
      0.0525
    ],
    [
      "manger",
      0.0525
    ],
    [
      "friper",
      0.0525
    ],
    [
      "deteindre",
      0.0525
    ],
    [
      "deperir",
      0.0525
    ],
    [
      "defraichir",
      0.0525
    ],
    [
      "defleurir",
      0.0525
    ],
    [
      "decolorer",
      0.0525
    ],
    [
      "s'etioler",
      0.025
    ],
    [
      "s'effeuiller",
      0.025
    ],
    [
      "gater",
      0.025
    ],
    [
      "effacer",
      0.025
    ],
    [
      "dessecher",
      0.025
    ]
  ],
  "fane": [
    [
      "fletrir",
      0.135
    ],
    [
      "ternir",
      0.1075
    ],
    [
      "passer",
      0.08
    ],
    [
      "eteindre",
      0.0525
    ],
    [
      "secher",
      0.0525
    ],
    [
      "manger",
      0.0525
    ],
    [
      "friper",
      0.0525
    ],
    [
      "deteindre",
      0.0525
    ],
    [
      "deperir",
      0.0525
    ],
    [
      "defraichir",
      0.0525
    ],
    [
      "defleurir",
      0.0525
    ],
    [
      "decolorer",
      0.0525
    ],
    [
      "s'etioler",
      0.025
    ],
    [
      "s'effeuiller",
      0.025
    ],
    [
      "gater",
      0.025
    ],
    [
      "effacer",
      0.025
    ],
    [
      "dessecher",
      0.025
    ]
  ],
  "zapper": [],
  "lasser": [
    [
      "fatiguer",
      0.1575
    ],
    [
      "ennuyer",
      0.095
    ],
    [
      "abattre",
      0.0525
    ],
    [
      "raser",
      0.0525
    ],
    [
      "exceder",
      0.04
    ],
    [
      "endormir",
      0.04
    ],
    [
      "degouter",
      0.04
    ],
    [
      "decourager",
      0.04
    ],
    [
      "barber",
      0.04
    ],
    [
      "assommer",
      0.04
    ],
    [
      "epuiser",
      0.03
    ],
    [
      "turlupiner",
      0.03
    ],
    [
      "rebuter",
      0.03
    ],
    [
      "enquiquiner",
      0.03
    ],
    [
      "briser",
      0.03
    ],
    [
      "agacer",
      0.03
    ],
    [
      "ereinter",
      0.02
    ],
    [
      "vaincre",
      0.02
    ],
    [
      "tanner",
      0.02
    ],
    [
      "importuner",
      0.02
    ],
    [
      "harasser",
      0.02
    ],
    [
      "extenuer",
      0.02
    ],
    [
      "desesperer",
      0.02
    ],
    [
      "blaser",
      0.02
    ],
    [
      "affadir",
      0.01
    ],
    [
      "impatienter",
      0.01
    ],
    [
      "vanner",
      0.01
    ]
  ],
  "las": [
    [
      "fatigue",
      0.1325
    ],
    [
      "rompu",
      0.1125
    ],
    [
      "harasse",
      0.0825
    ],
    [
      "recru",
      0.0625
    ],
    [
      "rendu",
      0.0625
    ],
    [
      "extenue",
      0.055
    ],
    [
      "fourbu",
      0.055
    ],
    [
      "epuise",
      0.0475
    ],
    [
      "aneanti",
      0.04
    ],
    [
      "vanne",
      0.04
    ],
    [
      "ereinte",
      0.04
    ],
    [
      "abattu",
      0.0275
    ],
    [
      "brise",
      0.0275
    ],
    [
      "flapi",
      0.02
    ],
    [
      "faible",
      0.02
    ],
    [
      "degoute",
      0.02
    ],
    [
      "moulu",
      0.0125
    ],
    [
      "lasse",
      0.0125
    ],
    [
      "excede",
      0.0125
    ],
    [
      "creve",
      0.0125
    ],
    [
      "claque",
      0.0125
    ],
    [
      "surmene",
      0.005
    ],
    [
      "pompe",
      0.005
    ],
    [
      "irrite",
      0.005
    ],
    [
      "helas",
      0.005
    ],
    [
      "ennuye",
      0.005
    ],
    [
      "desenchante",
      0.005
    ],
    [
      "decourage",
      0.005
    ],
    [
      "anemie",
      0.005
    ],
    [
      "ecoeure",
      0.005
    ]
  ],
  "autres": [
    [
      "different",
      0.12
    ],
    [
      "dissemblable",
      0.09
    ],
    [
      "second",
      0.09
    ],
    [
      "separe",
      0.06
    ],
    [
      "suivant",
      0.06
    ],
    [
      "prochain",
      0.06
    ],
    [
      "oppose",
      0.06
    ],
    [
      "nouveau",
      0.06
    ],
    [
      "distinct",
      0.06
    ],
    [
      "deuxieme",
      0.06
    ],
    [
      "supplementaire",
      0.03
    ],
    [
      "reste",
      0.03
    ],
    [
      "restant",
      0.03
    ],
    [
      "incompatible",
      0.03
    ],
    [
      "change",
      0.03
    ],
    [
      "autrui",
      0.03
    ],
    [
      "etranger",
      0.03
    ]
  ],
  "jeter": [
    [
      "lancer",
      0.07
    ],
    [
      "pousser",
      0.045
    ],
    [
      "repandre",
      0.04
    ],
    [
      "abandonner",
      0.035
    ],
    [
      "flanquer",
      0.035
    ],
    [
      "rejeter",
      0.0325
    ],
    [
      "balancer",
      0.0325
    ],
    [
      "mettre",
      0.0275
    ],
    [
      "lacher",
      0.0225
    ],
    [
      "ficher",
      0.0225
    ],
    [
      "envoyer",
      0.0225
    ],
    [
      "entrainer",
      0.0225
    ],
    [
      "conduire",
      0.0225
    ],
    [
      "emettre",
      0.02
    ],
    [
      "elever",
      0.02
    ],
    [
      "semer",
      0.02
    ],
    [
      "repousser",
      0.02
    ],
    [
      "dresser",
      0.02
    ],
    [
      "adresser",
      0.02
    ],
    [
      "eparpiller",
      0.015
    ],
    [
      "ejecter",
      0.015
    ],
    [
      "repartir",
      0.015
    ],
    [
      "projeter",
      0.015
    ],
    [
      "poser",
      0.015
    ],
    [
      "larguer",
      0.015
    ],
    [
      "foutre",
      0.015
    ],
    [
      "distribuer",
      0.015
    ],
    [
      "riposter",
      0.01
    ],
    [
      "verser",
      0.01
    ],
    [
      "epandre",
      0.01
    ],
    [
      "precipiter",
      0.01
    ],
    [
      "provoquer",
      0.01
    ],
    [
      "prodiguer",
      0.01
    ],
    [
      "plonger",
      0.01
    ],
    [
      "engager",
      0.01
    ],
    [
      "detruire",
      0.01
    ],
    [
      "bombarder",
      0.01
    ],
    [
      "bazarder",
      0.01
    ],
    [
      "glisser",
      0.0075
    ],
    [
      "liquider",
      0.0075
    ],
    [
      "proferer",
      0.0075
    ],
    [
      "releguer",
      0.0075
    ],
    [
      "eriger",
      0.0075
    ],
    [
      "deverser",
      0.0075
    ],
    [
      "disperser",
      0.0075
    ],
    [
      "catapulter",
      0.0075
    ],
    [
      "communiquer",
      0.0075
    ],
    [
      "construire",
      0.0075
    ],
    [
      "darder",
      0.0075
    ],
    [
      "descendre",
      0.0075
    ],
    [
      "edifier",
      0.0025
    ],
    [
      "retorquer",
      0.0025
    ],
    [
      "parsemer",
      0.0025
    ],
    [
      "insuffler",
      0.0025
    ],
    [
      "insinuer",
      0.0025
    ],
    [
      "imprimer",
      0.0025
    ],
    [
      "drosser",
      0.0025
    ],
    [
      "dispenser",
      0.0025
    ],
    [
      "causer",
      0.0025
    ],
    [
      "balanstiquer",
      0.0025
    ],
    [
      "ejaculer",
      0.0025
    ]
  ],
  "commencer": [
    [
      "entreprendre",
      0.07
    ],
    [
      "entamer",
      0.06
    ],
    [
      "amorcer",
      0.055
    ],
    [
      "debuter",
      0.05
    ],
    [
      "engager",
      0.0425
    ],
    [
      "demarrer",
      0.0375
    ],
    [
      "s'engager",
      0.0325
    ],
    [
      "partir",
      0.0325
    ],
    [
      "ouvrir",
      0.0325
    ],
    [
      "attaquer",
      0.0325
    ],
    [
      "naitre",
      0.0275
    ],
    [
      "prendre",
      0.0275
    ],
    [
      "ebaucher",
      0.02
    ],
    [
      "poindre",
      0.02
    ],
    [
      "lancer",
      0.02
    ],
    [
      "declencher",
      0.02
    ],
    [
      "creer",
      0.02
    ],
    [
      "eclore",
      0.015
    ],
    [
      "s'ouvrir",
      0.015
    ],
    [
      "s'embarquer",
      0.015
    ],
    [
      "inaugurer",
      0.015
    ],
    [
      "former",
      0.015
    ],
    [
      "eclater",
      0.01
    ],
    [
      "s'ebaucher",
      0.01
    ],
    [
      "s'emmancher",
      0.01
    ],
    [
      "s'amorcer",
      0.01
    ],
    [
      "initier",
      0.01
    ],
    [
      "fonder",
      0.01
    ],
    [
      "entailler",
      0.01
    ],
    [
      "embarquer",
      0.01
    ],
    [
      "degrossir",
      0.01
    ],
    [
      "s'initier",
      0.005
    ],
    [
      "s'inaugurer",
      0.005
    ],
    [
      "preluder",
      0.005
    ],
    [
      "progresser",
      0.005
    ],
    [
      "tatonner",
      0.005
    ],
    [
      "anonner",
      0.005
    ],
    [
      "emerger",
      0.005
    ],
    [
      "mener",
      0.005
    ],
    [
      "aligner",
      0.005
    ],
    [
      "allumer",
      0.005
    ],
    [
      "balbutier",
      0.005
    ],
    [
      "dater",
      0.005
    ],
    [
      "emmancher",
      0.005
    ],
    [
      "enfourner",
      0.005
    ],
    [
      "engrener",
      0.005
    ],
    [
      "entonner",
      0.005
    ],
    [
      "esquisser",
      0.005
    ],
    [
      "initialiser",
      0.005
    ],
    [
      "instituer",
      0.005
    ],
    [
      "intenter",
      0.005
    ],
    [
      "etrenner",
      0.005
    ]
  ],
  "attirer": [
    [
      "entrainer",
      0.0775
    ],
    [
      "seduire",
      0.05
    ],
    [
      "exciter",
      0.0475
    ],
    [
      "provoquer",
      0.045
    ],
    [
      "pousser",
      0.04
    ],
    [
      "tenter",
      0.035
    ],
    [
      "amener",
      0.0325
    ],
    [
      "charmer",
      0.0325
    ],
    [
      "soulever",
      0.03
    ],
    [
      "captiver",
      0.03
    ],
    [
      "conquerir",
      0.0275
    ],
    [
      "engager",
      0.0275
    ],
    [
      "appeler",
      0.025
    ],
    [
      "prendre",
      0.025
    ],
    [
      "gagner",
      0.0225
    ],
    [
      "attacher",
      0.0225
    ],
    [
      "inviter",
      0.02
    ],
    [
      "conduire",
      0.02
    ],
    [
      "occasionner",
      0.0175
    ],
    [
      "porter",
      0.0175
    ],
    [
      "susciter",
      0.0175
    ],
    [
      "allecher",
      0.015
    ],
    [
      "capter",
      0.015
    ],
    [
      "tirer",
      0.0125
    ],
    [
      "emporter",
      0.01
    ],
    [
      "amorcer",
      0.01
    ],
    [
      "trainer",
      0.0075
    ],
    [
      "plaire",
      0.0075
    ],
    [
      "fixer",
      0.0075
    ],
    [
      "enflammer",
      0.0075
    ],
    [
      "couter",
      0.0075
    ],
    [
      "commander",
      0.0075
    ],
    [
      "causer",
      0.0075
    ],
    [
      "aguicher",
      0.0075
    ],
    [
      "affrioler",
      0.0075
    ],
    [
      "valoir",
      0.005
    ],
    [
      "solliciter",
      0.005
    ],
    [
      "pomper",
      0.005
    ],
    [
      "enjoler",
      0.005
    ],
    [
      "aspirer",
      0.005
    ],
    [
      "arreter",
      0.005
    ],
    [
      "acquerir",
      0.005
    ],
    [
      "absorber",
      0.005
    ],
    [
      "obtenir",
      0.0025
    ],
    [
      "procurer",
      0.0025
    ],
    [
      "recruter",
      0.0025
    ],
    [
      "sucer",
      0.0025
    ],
    [
      "tromper",
      0.0025
    ],
    [
      "eveiller",
      0.0025
    ],
    [
      "incliner",
      0.0025
    ],
    [
      "frapper",
      0.0025
    ],
    [
      "abuser",
      0.0025
    ],
    [
      "affriander",
      0.0025
    ],
    [
      "appater",
      0.0025
    ],
    [
      "concilier",
      0.0025
    ],
    [
      "deriver",
      0.0025
    ],
    [
      "fasciner",
      0.0025
    ],
    [
      "rapprocher",
      0.0
    ],
    [
      "racoler",
      0.0
    ],
    [
      "polariser",
      0.0
    ],
    [
      "leurrer",
      0.0
    ],
    [
      "drainer",
      0.0
    ],
    [
      "attraire",
      0.0
    ],
    [
      "amasser",
      0.0
    ],
    [
      "agrainer",
      0.0
    ],
    [
      "accumuler",
      0.0
    ],
    [
      "s'attacher",
      0.0
    ]
  ],
  "tant": [
    [
      "aussi",
      0.22
    ],
    [
      "autant",
      0.11
    ],
    [
      "comme",
      0.11
    ],
    [
      "quantieme",
      0.11
    ],
    [
      "si",
      0.11
    ],
    [
      "tellement",
      0.11
    ]
  ],
  "hui": [
    [
      "aujourd'hui",
      0.5
    ]
  ],
  "attacher": [
    [
      "fixer",
      0.085
    ],
    [
      "lier",
      0.05
    ],
    [
      "joindre",
      0.0375
    ],
    [
      "assembler",
      0.035
    ],
    [
      "assujettir",
      0.035
    ],
    [
      "arrimer",
      0.0325
    ],
    [
      "retenir",
      0.03
    ],
    [
      "arreter",
      0.0275
    ],
    [
      "tenir",
      0.0275
    ],
    [
      "enchainer",
      0.0225
    ],
    [
      "prendre",
      0.02
    ],
    [
      "captiver",
      0.02
    ],
    [
      "river",
      0.02
    ],
    [
      "serrer",
      0.02
    ],
    [
      "immobiliser",
      0.0175
    ],
    [
      "coller",
      0.0175
    ],
    [
      "appliquer",
      0.015
    ],
    [
      "maintenir",
      0.015
    ],
    [
      "mettre",
      0.015
    ],
    [
      "reunir",
      0.015
    ],
    [
      "accrocher",
      0.0125
    ],
    [
      "unir",
      0.0125
    ],
    [
      "attirer",
      0.0125
    ],
    [
      "assurer",
      0.0125
    ],
    [
      "agrafer",
      0.0125
    ],
    [
      "donner",
      0.01
    ],
    [
      "relier",
      0.01
    ],
    [
      "rattacher",
      0.0075
    ],
    [
      "porter",
      0.0075
    ],
    [
      "associer",
      0.0075
    ],
    [
      "amarrer",
      0.0075
    ],
    [
      "adjoindre",
      0.0075
    ],
    [
      "suspendre",
      0.0075
    ],
    [
      "engager",
      0.0075
    ],
    [
      "boulonner",
      0.0075
    ],
    [
      "attribuer",
      0.0075
    ],
    [
      "ajuster",
      0.0075
    ],
    [
      "accorder",
      0.0075
    ],
    [
      "soumettre",
      0.005
    ],
    [
      "placer",
      0.005
    ],
    [
      "piquer",
      0.005
    ],
    [
      "frapper",
      0.005
    ],
    [
      "affecter",
      0.005
    ],
    [
      "absorber",
      0.005
    ],
    [
      "visser",
      0.005
    ],
    [
      "seduire",
      0.005
    ],
    [
      "nouer",
      0.005
    ],
    [
      "envelopper",
      0.005
    ],
    [
      "clouer",
      0.005
    ],
    [
      "ceindre",
      0.005
    ],
    [
      "astreindre",
      0.005
    ],
    [
      "accoler",
      0.005
    ],
    [
      "preter",
      0.0025
    ],
    [
      "interesser",
      0.0025
    ],
    [
      "ficeler",
      0.0025
    ],
    [
      "enlacer",
      0.0025
    ],
    [
      "encercler",
      0.0025
    ],
    [
      "cercler",
      0.0025
    ],
    [
      "brider",
      0.0025
    ],
    [
      "atteler",
      0.0025
    ],
    [
      "annexer",
      0.0025
    ],
    [
      "accoupler",
      0.0025
    ],
    [
      "lacer",
      0.0025
    ],
    [
      "ligoter",
      0.0025
    ],
    [
      "obliger",
      0.0025
    ],
    [
      "pendre",
      0.0025
    ],
    [
      "epingler",
      0.0025
    ],
    [
      "garrotter",
      0.0025
    ],
    [
      "entrelacer",
      0.0025
    ],
    [
      "entortiller",
      0.0025
    ],
    [
      "ancrer",
      0.0025
    ],
    [
      "charmer",
      0.0025
    ],
    [
      "consolider",
      0.0025
    ],
    [
      "corder",
      0.0025
    ],
    [
      "coudre",
      0.0025
    ],
    [
      "sangler",
      0.0
    ],
    [
      "pendiller",
      0.0
    ],
    [
      "passionner",
      0.0
    ],
    [
      "entraver",
      0.0
    ],
    [
      "empaqueter",
      0.0
    ],
    [
      "emballer",
      0.0
    ],
    [
      "diriger",
      0.0
    ],
    [
      "cramponner",
      0.0
    ],
    [
      "bander",
      0.0
    ],
    [
      "agreger",
      0.0
    ],
    [
      "adherer",
      0.0
    ],
    [
      "moucheter",
      0.0
    ],
    [
      "ligaturer",
      0.0
    ],
    [
      "harder",
      0.0
    ],
    [
      "encoller",
      0.0
    ],
    [
      "preoccuper",
      0.0
    ],
    [
      "riveter",
      0.0
    ],
    [
      "subordonner",
      0.0
    ],
    [
      "tenter",
      0.0
    ],
    [
      "vouer",
      0.0
    ],
    [
      "elinguer",
      0.0
    ],
    [
      "episser",
      0.0
    ],
    [
      "embrever",
      0.0
    ],
    [
      "cuire",
      0.0
    ],
    [
      "accouer",
      0.0
    ],
    [
      "appendre",
      0.0
    ],
    [
      "bosser",
      0.0
    ],
    [
      "botteler",
      0.0
    ],
    [
      "boucler",
      0.0
    ],
    [
      "boutonner",
      0.0
    ],
    [
      "brocher",
      0.0
    ],
    [
      "breler",
      0.0
    ],
    [
      "carguer",
      0.0
    ],
    [
      "cheviller",
      0.0
    ],
    [
      "coupler",
      0.0
    ],
    [
      "etalinguer",
      0.0
    ]
  ],
  "attache": [
    [
      "lien",
      0.0875
    ],
    [
      "corde",
      0.05
    ],
    [
      "attachement",
      0.045
    ],
    [
      "chaine",
      0.045
    ],
    [
      "agrafe",
      0.0375
    ],
    [
      "liaison",
      0.0325
    ],
    [
      "fil",
      0.0275
    ],
    [
      "cordon",
      0.0275
    ],
    [
      "boucle",
      0.0275
    ],
    [
      "amarrage",
      0.0275
    ],
    [
      "anneau",
      0.0225
    ],
    [
      "rapport",
      0.02
    ],
    [
      "noeud",
      0.02
    ],
    [
      "bride",
      0.02
    ],
    [
      "assemblage",
      0.02
    ],
    [
      "relation",
      0.015
    ],
    [
      "passion",
      0.015
    ],
    [
      "ligature",
      0.015
    ],
    [
      "fermoir",
      0.015
    ],
    [
      "cable",
      0.015
    ],
    [
      "courroie",
      0.015
    ],
    [
      "articulation",
      0.015
    ],
    [
      "longe",
      0.01
    ],
    [
      "licou",
      0.01
    ],
    [
      "licol",
      0.01
    ],
    [
      "jugulaire",
      0.01
    ],
    [
      "fixation",
      0.01
    ],
    [
      "fibule",
      0.01
    ],
    [
      "crochet",
      0.01
    ],
    [
      "cheville",
      0.01
    ],
    [
      "broche",
      0.01
    ],
    [
      "bandage",
      0.01
    ],
    [
      "affection",
      0.01
    ],
    [
      "jointure",
      0.0075
    ],
    [
      "joug",
      0.0075
    ],
    [
      "mentonniere",
      0.0075
    ],
    [
      "racine",
      0.0075
    ],
    [
      "ruban",
      0.0075
    ],
    [
      "epingle",
      0.0075
    ],
    [
      "interet",
      0.0075
    ],
    [
      "frequentation",
      0.0075
    ],
    [
      "accointance",
      0.0075
    ],
    [
      "clip",
      0.0075
    ],
    [
      "collier",
      0.0075
    ],
    [
      "commerce",
      0.0075
    ],
    [
      "crampon",
      0.0075
    ],
    [
      "fermail",
      0.0075
    ],
    [
      "jarretelle",
      0.0025
    ],
    [
      "jarretiere",
      0.0025
    ],
    [
      "lacet",
      0.0025
    ],
    [
      "laisse",
      0.0025
    ],
    [
      "laniere",
      0.0025
    ],
    [
      "ligament",
      0.0025
    ],
    [
      "menottes",
      0.0025
    ],
    [
      "naissance",
      0.0025
    ],
    [
      "poignet",
      0.0025
    ],
    [
      "sangle",
      0.0025
    ],
    [
      "tresse",
      0.0025
    ],
    [
      "trombone",
      0.0025
    ],
    [
      "vrille",
      0.0025
    ],
    [
      "insertion",
      0.0025
    ],
    [
      "inclination",
      0.0025
    ],
    [
      "hart",
      0.0025
    ],
    [
      "aiguillette",
      0.0025
    ],
    [
      "amarre",
      0.0025
    ],
    [
      "ancrage",
      0.0025
    ],
    [
      "ansette",
      0.0025
    ],
    [
      "assujettissement",
      0.0025
    ],
    [
      "attachage",
      0.0025
    ],
    [
      "bouton",
      0.0025
    ],
    [
      "chainette",
      0.0025
    ],
    [
      "cravate",
      0.0025
    ],
    [
      "entrave",
      0.0025
    ],
    [
      "fermeture",
      0.0025
    ],
    [
      "ficelle",
      0.0025
    ],
    [
      "gout",
      0.0025
    ],
    [
      "zele",
      0.0025
    ]
  ],
  "gacher": [
    [
      "torcher",
      0.1125
    ],
    [
      "gater",
      0.08
    ],
    [
      "ruiner",
      0.0625
    ],
    [
      "perdre",
      0.0625
    ],
    [
      "bousiller",
      0.0625
    ],
    [
      "abimer",
      0.0625
    ],
    [
      "dissiper",
      0.0475
    ],
    [
      "aneantir",
      0.0375
    ],
    [
      "saboter",
      0.0375
    ],
    [
      "tuer",
      0.03
    ],
    [
      "massacrer",
      0.03
    ],
    [
      "gaspiller",
      0.03
    ],
    [
      "bacler",
      0.0225
    ],
    [
      "cochonner",
      0.0225
    ],
    [
      "manquer",
      0.0225
    ],
    [
      "saloper",
      0.0225
    ],
    [
      "torchonner",
      0.015
    ],
    [
      "supprimer",
      0.015
    ],
    [
      "saveter",
      0.015
    ],
    [
      "savater",
      0.015
    ],
    [
      "rater",
      0.015
    ],
    [
      "louper",
      0.015
    ],
    [
      "dilapider",
      0.015
    ],
    [
      "barbouiller",
      0.015
    ],
    [
      "enlaidir",
      0.0075
    ],
    [
      "galvauder",
      0.0075
    ],
    [
      "prodiguer",
      0.0075
    ],
    [
      "petrir",
      0.0075
    ],
    [
      "sabouler",
      0.0075
    ],
    [
      "deparer",
      0.0075
    ],
    [
      "delayer",
      0.0075
    ],
    [
      "deflorer",
      0.0075
    ],
    [
      "diminuer",
      0.0075
    ],
    [
      "contrarier",
      0.0075
    ],
    [
      "brader",
      0.0075
    ],
    [
      "avarier",
      0.0075
    ],
    [
      "sabrer",
      0.0075
    ]
  ],
  "gache": [
    [
      "fermeture",
      0.3325
    ],
    [
      "pene",
      0.3325
    ],
    [
      "spatule",
      0.3325
    ]
  ],
  "langage": [
    [
      "langue",
      0.235
    ],
    [
      "parler",
      0.15
    ],
    [
      "jargon",
      0.085
    ],
    [
      "patois",
      0.0625
    ],
    [
      "style",
      0.0625
    ],
    [
      "elocution",
      0.0625
    ],
    [
      "vocabulaire",
      0.04
    ],
    [
      "parole",
      0.04
    ],
    [
      "idiome",
      0.04
    ],
    [
      "dialecte",
      0.04
    ],
    [
      "semiotique",
      0.02
    ],
    [
      "parlure",
      0.02
    ],
    [
      "parlage",
      0.02
    ],
    [
      "lexique",
      0.02
    ],
    [
      "discours",
      0.02
    ],
    [
      "code",
      0.02
    ],
    [
      "argot",
      0.02
    ],
    [
      "verbe",
      0.02
    ]
  ],
  "louange": [
    [
      "eloge",
      0.2425
    ],
    [
      "compliment",
      0.1025
    ],
    [
      "apologie",
      0.085
    ],
    [
      "glorification",
      0.085
    ],
    [
      "panegyrique",
      0.05
    ],
    [
      "flatterie",
      0.05
    ],
    [
      "discours",
      0.05
    ],
    [
      "celebration",
      0.05
    ],
    [
      "applaudissement",
      0.05
    ],
    [
      "felicitation",
      0.0325
    ],
    [
      "defense",
      0.0325
    ],
    [
      "los",
      0.015
    ],
    [
      "gloire",
      0.015
    ],
    [
      "flagornerie",
      0.015
    ],
    [
      "exaltation",
      0.015
    ],
    [
      "enguirlandement",
      0.015
    ],
    [
      "encouragement",
      0.015
    ],
    [
      "encens",
      0.015
    ],
    [
      "acclamation",
      0.015
    ],
    [
      "epithete",
      0.015
    ]
  ],
  "bagage": [
    [
      "ballot",
      0.125
    ],
    [
      "barda",
      0.0975
    ],
    [
      "attirail",
      0.0775
    ],
    [
      "savoir",
      0.0575
    ],
    [
      "balle",
      0.05
    ],
    [
      "fourbi",
      0.0375
    ],
    [
      "colis",
      0.03
    ],
    [
      "instruction",
      0.03
    ],
    [
      "equipement",
      0.025
    ],
    [
      "connaissance",
      0.025
    ],
    [
      "caisse",
      0.025
    ],
    [
      "erudition",
      0.0175
    ],
    [
      "equipage",
      0.0175
    ],
    [
      "science",
      0.0175
    ],
    [
      "paquet",
      0.0175
    ],
    [
      "malle",
      0.0175
    ],
    [
      "fourniment",
      0.0175
    ],
    [
      "culture",
      0.0175
    ],
    [
      "connaissances",
      0.0175
    ],
    [
      "chargement",
      0.0175
    ],
    [
      "bazar",
      0.0175
    ],
    [
      "formation",
      0.0125
    ],
    [
      "paquetage",
      0.0125
    ],
    [
      "train",
      0.0125
    ],
    [
      "valise",
      0.0125
    ],
    [
      "fardeau",
      0.0125
    ],
    [
      "competence",
      0.0125
    ],
    [
      "cantine",
      0.0125
    ],
    [
      "balluchon",
      0.0125
    ],
    [
      "acquis",
      0.0125
    ],
    [
      "lettres",
      0.005
    ],
    [
      "mobilier",
      0.005
    ],
    [
      "provision",
      0.005
    ],
    [
      "sac",
      0.005
    ],
    [
      "impedimenta",
      0.005
    ],
    [
      "cargaison",
      0.005
    ],
    [
      "capharnaum",
      0.005
    ],
    [
      "bague",
      0.005
    ],
    [
      "bagot",
      0.005
    ],
    [
      "arroi",
      0.005
    ],
    [
      "affaires",
      0.005
    ]
  ],
  "infini": [
    [
      "immense",
      0.0925
    ],
    [
      "grand",
      0.085
    ],
    [
      "demesure",
      0.06
    ],
    [
      "eternel",
      0.06
    ],
    [
      "incommensurable",
      0.0525
    ],
    [
      "interminable",
      0.045
    ],
    [
      "illimite",
      0.045
    ],
    [
      "profond",
      0.0375
    ],
    [
      "enorme",
      0.0375
    ],
    [
      "sempiternel",
      0.03
    ],
    [
      "indefini",
      0.03
    ],
    [
      "incalculable",
      0.03
    ],
    [
      "extreme",
      0.03
    ],
    [
      "long",
      0.0225
    ],
    [
      "inepuisable",
      0.0225
    ],
    [
      "excessif",
      0.0225
    ],
    [
      "continu",
      0.0225
    ],
    [
      "absolu",
      0.0225
    ],
    [
      "supreme",
      0.015
    ],
    [
      "suivi",
      0.015
    ],
    [
      "perpetuel",
      0.015
    ],
    [
      "insondable",
      0.015
    ],
    [
      "immensite",
      0.015
    ],
    [
      "espace",
      0.015
    ],
    [
      "eternite",
      0.0075
    ],
    [
      "universel",
      0.0075
    ],
    [
      "perdurable",
      0.0075
    ],
    [
      "parfait",
      0.0075
    ],
    [
      "innombrable",
      0.0075
    ],
    [
      "infinite",
      0.0075
    ],
    [
      "inexhaustible",
      0.0075
    ],
    [
      "indenombrable",
      0.0075
    ],
    [
      "inconditionne",
      0.0075
    ],
    [
      "illimitable",
      0.0075
    ],
    [
      "colossal",
      0.0075
    ],
    [
      "ciel",
      0.0075
    ],
    [
      "ether",
      0.0075
    ]
  ],
  "vendange": [
    [
      "cueillette",
      0.25
    ],
    [
      "raisin",
      0.25
    ],
    [
      "recolte",
      0.25
    ],
    [
      "vinee",
      0.25
    ]
  ],
  "vendanger": [
    [
      "prendre",
      0.4
    ],
    [
      "cueillir",
      0.2
    ],
    [
      "rafler",
      0.2
    ],
    [
      "recolter",
      0.2
    ]
  ],
  "formule": [
    [
      "expression",
      0.085
    ],
    [
      "regle",
      0.0725
    ],
    [
      "systeme",
      0.04
    ],
    [
      "sentence",
      0.04
    ],
    [
      "phrase",
      0.04
    ],
    [
      "methode",
      0.04
    ],
    [
      "moyen",
      0.04
    ],
    [
      "maxime",
      0.04
    ],
    [
      "forme",
      0.04
    ],
    [
      "enonce",
      0.03
    ],
    [
      "truc",
      0.03
    ],
    [
      "precepte",
      0.03
    ],
    [
      "mode",
      0.03
    ],
    [
      "locution",
      0.03
    ],
    [
      "dicton",
      0.03
    ],
    [
      "tournure",
      0.02
    ],
    [
      "texte",
      0.02
    ],
    [
      "terme",
      0.02
    ],
    [
      "slogan",
      0.02
    ],
    [
      "procede",
      0.02
    ],
    [
      "norme",
      0.02
    ],
    [
      "modalite",
      0.02
    ],
    [
      "aphorisme",
      0.02
    ],
    [
      "cliche",
      0.02
    ],
    [
      "ceremonial",
      0.02
    ],
    [
      "devise",
      0.02
    ],
    [
      "formalite",
      0.02
    ],
    [
      "equation",
      0.01
    ],
    [
      "redaction",
      0.01
    ],
    [
      "raccourci",
      0.01
    ],
    [
      "proverbe",
      0.01
    ],
    [
      "modele",
      0.01
    ],
    [
      "libelle",
      0.01
    ],
    [
      "intitule",
      0.01
    ],
    [
      "formulaire",
      0.01
    ],
    [
      "combinaison",
      0.01
    ],
    [
      "codex",
      0.01
    ],
    [
      "etiquette",
      0.01
    ]
  ],
  "formuler": [
    [
      "enoncer",
      0.2325
    ],
    [
      "exprimer",
      0.1025
    ],
    [
      "poser",
      0.1025
    ],
    [
      "etablir",
      0.0775
    ],
    [
      "emettre",
      0.05
    ],
    [
      "rendre",
      0.05
    ],
    [
      "prononcer",
      0.05
    ],
    [
      "former",
      0.05
    ],
    [
      "exposer",
      0.05
    ],
    [
      "dire",
      0.05
    ],
    [
      "notifier",
      0.025
    ],
    [
      "fixer",
      0.025
    ],
    [
      "expliciter",
      0.025
    ],
    [
      "expectorer",
      0.025
    ],
    [
      "deposer",
      0.025
    ],
    [
      "concretiser",
      0.025
    ],
    [
      "rediger",
      0.025
    ]
  ],
  "marabout": [
    [
      "mage",
      0.125
    ],
    [
      "sorcier",
      0.125
    ],
    [
      "saint",
      0.0825
    ],
    [
      "sage",
      0.04
    ],
    [
      "sanctuaire",
      0.04
    ],
    [
      "santon",
      0.04
    ],
    [
      "thaumaturge",
      0.04
    ],
    [
      "tombeau",
      0.04
    ],
    [
      "turbe",
      0.04
    ],
    [
      "pretre",
      0.04
    ],
    [
      "plume",
      0.04
    ],
    [
      "mausolee",
      0.04
    ],
    [
      "leptopilus",
      0.04
    ],
    [
      "garniture",
      0.04
    ],
    [
      "charlatan",
      0.04
    ],
    [
      "cafetiere",
      0.04
    ],
    [
      "aigrette",
      0.04
    ],
    [
      "venerable",
      0.04
    ]
  ],
  "inventer": [
    [
      "imaginer",
      0.145
    ],
    [
      "construire",
      0.0875
    ],
    [
      "creer",
      0.075
    ],
    [
      "composer",
      0.0675
    ],
    [
      "forger",
      0.0675
    ],
    [
      "romancer",
      0.0675
    ],
    [
      "concevoir",
      0.0475
    ],
    [
      "fabriquer",
      0.0375
    ],
    [
      "trouver",
      0.0375
    ],
    [
      "echafauder",
      0.0275
    ],
    [
      "supposer",
      0.0275
    ],
    [
      "mentir",
      0.0275
    ],
    [
      "feindre",
      0.0275
    ],
    [
      "decouvrir",
      0.0275
    ],
    [
      "batir",
      0.0275
    ],
    [
      "arranger",
      0.0275
    ],
    [
      "fabuler",
      0.0175
    ],
    [
      "chercher",
      0.0175
    ],
    [
      "broder",
      0.0175
    ],
    [
      "affabuler",
      0.0175
    ],
    [
      "rever",
      0.0075
    ],
    [
      "insinuer",
      0.0075
    ],
    [
      "innover",
      0.0075
    ],
    [
      "improviser",
      0.0075
    ],
    [
      "exagerer",
      0.0075
    ],
    [
      "engendrer",
      0.0075
    ],
    [
      "controuver",
      0.0075
    ],
    [
      "conter",
      0.0075
    ],
    [
      "s'aviser",
      0.0075
    ]
  ],
  "nouvelle": [
    [
      "neuf",
      0.105
    ],
    [
      "original",
      0.0825
    ],
    [
      "inusite",
      0.0525
    ],
    [
      "inedit",
      0.04
    ],
    [
      "moderne",
      0.04
    ],
    [
      "extraordinaire",
      0.035
    ],
    [
      "novice",
      0.0275
    ],
    [
      "insolite",
      0.0275
    ],
    [
      "inoui",
      0.0275
    ],
    [
      "inconnu",
      0.0275
    ],
    [
      "hardi",
      0.0275
    ],
    [
      "truculent",
      0.0225
    ],
    [
      "recent",
      0.0225
    ],
    [
      "jeune",
      0.0225
    ],
    [
      "inexperimente",
      0.0225
    ],
    [
      "vert",
      0.0175
    ],
    [
      "surprenant",
      0.0175
    ],
    [
      "ose",
      0.0175
    ],
    [
      "inhabituel",
      0.0175
    ],
    [
      "inattendu",
      0.0175
    ],
    [
      "inaccoutume",
      0.0175
    ],
    [
      "frais",
      0.0175
    ],
    [
      "debutant",
      0.0175
    ],
    [
      "different",
      0.0175
    ],
    [
      "audacieux",
      0.0175
    ],
    [
      "inimagine",
      0.01
    ],
    [
      "insoupconne",
      0.01
    ],
    [
      "ultramoderne",
      0.01
    ],
    [
      "vierge",
      0.01
    ],
    [
      "inexplore",
      0.01
    ],
    [
      "in",
      0.01
    ],
    [
      "bleu",
      0.01
    ],
    [
      "autre",
      0.01
    ],
    [
      "apprenti",
      0.01
    ],
    [
      "actuel",
      0.01
    ],
    [
      "personnel",
      0.005
    ],
    [
      "primeur",
      0.005
    ],
    [
      "printanier",
      0.005
    ],
    [
      "second",
      0.005
    ],
    [
      "neophyte",
      0.005
    ],
    [
      "novateur",
      0.005
    ],
    [
      "nouveaute",
      0.005
    ],
    [
      "metamorphose",
      0.005
    ],
    [
      "dernier",
      0.005
    ],
    [
      "change",
      0.005
    ],
    [
      "bizut",
      0.005
    ]
  ],
  "reprendre": [
    [
      "corriger",
      0.05
    ],
    [
      "recommencer",
      0.045
    ],
    [
      "relever",
      0.045
    ],
    [
      "revenir",
      0.045
    ],
    [
      "recuperer",
      0.0375
    ],
    [
      "retrouver",
      0.0375
    ],
    [
      "refaire",
      0.0375
    ],
    [
      "revoir",
      0.03
    ],
    [
      "reparer",
      0.03
    ],
    [
      "tancer",
      0.025
    ],
    [
      "repeter",
      0.025
    ],
    [
      "reprimander",
      0.025
    ],
    [
      "regagner",
      0.025
    ],
    [
      "blamer",
      0.025
    ],
    [
      "sermonner",
      0.0175
    ],
    [
      "retoucher",
      0.0175
    ],
    [
      "retirer",
      0.0175
    ],
    [
      "renaitre",
      0.0175
    ],
    [
      "remanier",
      0.0175
    ],
    [
      "recouvrer",
      0.0175
    ],
    [
      "rattraper",
      0.0175
    ],
    [
      "prendre",
      0.0175
    ],
    [
      "annuler",
      0.0175
    ],
    [
      "recidiver",
      0.0125
    ],
    [
      "renouer",
      0.0125
    ],
    [
      "remonter",
      0.0125
    ],
    [
      "delier",
      0.0125
    ],
    [
      "critiquer",
      0.0125
    ],
    [
      "condamner",
      0.0125
    ],
    [
      "censurer",
      0.0125
    ],
    [
      "reprocher",
      0.005
    ],
    [
      "reproduire",
      0.005
    ],
    [
      "ressaisir",
      0.005
    ],
    [
      "retourner",
      0.005
    ],
    [
      "recapituler",
      0.005
    ],
    [
      "reembaucher",
      0.005
    ],
    [
      "resumer",
      0.005
    ],
    [
      "retrecir",
      0.005
    ],
    [
      "remporter",
      0.005
    ],
    [
      "remmancher",
      0.005
    ],
    [
      "rembarrer",
      0.005
    ],
    [
      "changer",
      0.005
    ],
    [
      "chapitrer",
      0.005
    ],
    [
      "chatier",
      0.005
    ],
    [
      "continuer",
      0.005
    ],
    [
      "exhumer",
      0.005
    ],
    [
      "modifier",
      0.005
    ],
    [
      "morigener",
      0.005
    ],
    [
      "pincer",
      0.005
    ],
    [
      "rebondir",
      0.005
    ],
    [
      "reconquerir",
      0.005
    ],
    [
      "redire",
      0.005
    ]
  ],
  "plaisir": [
    [
      "joie",
      0.0725
    ],
    [
      "sensualite",
      0.06
    ],
    [
      "amusement",
      0.055
    ],
    [
      "bonheur",
      0.0425
    ],
    [
      "divertissement",
      0.0425
    ],
    [
      "volupte",
      0.0425
    ],
    [
      "delice",
      0.04
    ],
    [
      "jouissance",
      0.035
    ],
    [
      "satisfaction",
      0.03
    ],
    [
      "agrement",
      0.0275
    ],
    [
      "contentement",
      0.0275
    ],
    [
      "distraction",
      0.0275
    ],
    [
      "rejouissance",
      0.0275
    ],
    [
      "sens",
      0.0225
    ],
    [
      "gaiete",
      0.0225
    ],
    [
      "felicite",
      0.0225
    ],
    [
      "amour",
      0.02
    ],
    [
      "delectation",
      0.02
    ],
    [
      "lascivete",
      0.02
    ],
    [
      "regal",
      0.02
    ],
    [
      "recreation",
      0.015
    ],
    [
      "grace",
      0.015
    ],
    [
      "faveur",
      0.015
    ],
    [
      "concupiscence",
      0.015
    ],
    [
      "bienfait",
      0.015
    ],
    [
      "luxure",
      0.01
    ],
    [
      "euphorie",
      0.01
    ],
    [
      "complaisance",
      0.01
    ],
    [
      "ebats",
      0.005
    ],
    [
      "soulas",
      0.005
    ],
    [
      "service",
      0.005
    ],
    [
      "plaisance",
      0.005
    ],
    [
      "lubricite",
      0.005
    ],
    [
      "loisir",
      0.005
    ],
    [
      "hedonisme",
      0.005
    ],
    [
      "gre",
      0.005
    ],
    [
      "benediction",
      0.005
    ],
    [
      "caprice",
      0.005
    ],
    [
      "charme",
      0.005
    ],
    [
      "consolation",
      0.005
    ],
    [
      "fantaisie",
      0.005
    ],
    [
      "emotion",
      0.0025
    ],
    [
      "ebaudissement",
      0.0025
    ],
    [
      "patisserie",
      0.0025
    ],
    [
      "paillardise",
      0.0025
    ],
    [
      "oublie",
      0.0025
    ],
    [
      "libido",
      0.0025
    ],
    [
      "jeu",
      0.0025
    ],
    [
      "friandise",
      0.0025
    ],
    [
      "effet",
      0.0025
    ],
    [
      "baise",
      0.0025
    ],
    [
      "aise",
      0.0025
    ],
    [
      "epicurisme",
      0.0025
    ]
  ],
  "jeu": [
    [
      "amusement",
      0.0725
    ],
    [
      "bagatelle",
      0.0725
    ],
    [
      "babiole",
      0.06
    ],
    [
      "plaisanterie",
      0.06
    ],
    [
      "bricole",
      0.0475
    ],
    [
      "politique",
      0.0475
    ],
    [
      "divertissement",
      0.035
    ],
    [
      "comedie",
      0.035
    ],
    [
      "taquinerie",
      0.0225
    ],
    [
      "tactique",
      0.0225
    ],
    [
      "recreation",
      0.0225
    ],
    [
      "manege",
      0.0225
    ],
    [
      "manigance",
      0.0225
    ],
    [
      "futilite",
      0.0225
    ],
    [
      "frivolite",
      0.0225
    ],
    [
      "distraction",
      0.0225
    ],
    [
      "badinage",
      0.0225
    ],
    [
      "action",
      0.0225
    ],
    [
      "plaisir",
      0.01
    ],
    [
      "marge",
      0.01
    ],
    [
      "ludisme",
      0.01
    ],
    [
      "loterie",
      0.01
    ],
    [
      "sport",
      0.01
    ],
    [
      "speculation",
      0.01
    ],
    [
      "strategie",
      0.01
    ],
    [
      "systeme",
      0.01
    ],
    [
      "tombola",
      0.01
    ],
    [
      "ebat",
      0.01
    ],
    [
      "jouet",
      0.01
    ],
    [
      "interpretation",
      0.01
    ],
    [
      "articulation",
      0.01
    ],
    [
      "assortiment",
      0.01
    ],
    [
      "brimade",
      0.01
    ],
    [
      "chasse",
      0.01
    ],
    [
      "choix",
      0.01
    ],
    [
      "concours",
      0.01
    ],
    [
      "delassement",
      0.01
    ],
    [
      "espieglerie",
      0.01
    ],
    [
      "fonctionnement",
      0.01
    ],
    [
      "affectation",
      0.01
    ]
  ],
  "notres": [],
  "brillanter": [
    [
      "briller",
      0.2
    ],
    [
      "astiquer",
      0.1325
    ],
    [
      "tailler",
      0.065
    ],
    [
      "pomponner",
      0.065
    ],
    [
      "lustrer",
      0.065
    ],
    [
      "irradier",
      0.065
    ],
    [
      "iriser",
      0.065
    ],
    [
      "enjoliver",
      0.065
    ],
    [
      "empanacher",
      0.065
    ],
    [
      "chamarrer",
      0.065
    ],
    [
      "eclairer",
      0.065
    ]
  ],
  "brillant": [
    [
      "eclatant",
      0.08
    ],
    [
      "etincelant",
      0.05
    ],
    [
      "beau",
      0.0475
    ],
    [
      "eclat",
      0.04
    ],
    [
      "remarquable",
      0.0325
    ],
    [
      "splendide",
      0.025
    ],
    [
      "lumineux",
      0.025
    ],
    [
      "distingue",
      0.0225
    ],
    [
      "glorieux",
      0.0175
    ],
    [
      "eblouissant",
      0.0175
    ],
    [
      "vif",
      0.015
    ],
    [
      "rutilant",
      0.015
    ],
    [
      "poli",
      0.015
    ],
    [
      "lustre",
      0.015
    ],
    [
      "luisant",
      0.015
    ],
    [
      "flamboyant",
      0.015
    ],
    [
      "flambant",
      0.0125
    ],
    [
      "radieux",
      0.0125
    ],
    [
      "emerite",
      0.0125
    ],
    [
      "eminent",
      0.0125
    ],
    [
      "splendeur",
      0.0125
    ],
    [
      "resplendissant",
      0.0125
    ],
    [
      "petillant",
      0.0125
    ],
    [
      "fameux",
      0.0125
    ],
    [
      "chatoyant",
      0.0125
    ],
    [
      "ardent",
      0.0125
    ],
    [
      "superieur",
      0.01
    ],
    [
      "prestigieux",
      0.01
    ],
    [
      "notable",
      0.01
    ],
    [
      "magnifique",
      0.01
    ],
    [
      "interessant",
      0.01
    ],
    [
      "intelligent",
      0.01
    ],
    [
      "fin",
      0.01
    ],
    [
      "extraordinaire",
      0.01
    ],
    [
      "clinquant",
      0.01
    ],
    [
      "clair",
      0.01
    ],
    [
      "vernis",
      0.0075
    ],
    [
      "superbe",
      0.0075
    ],
    [
      "riche",
      0.0075
    ],
    [
      "illustre",
      0.0075
    ],
    [
      "habile",
      0.0075
    ],
    [
      "exterieur",
      0.0075
    ],
    [
      "beaute",
      0.0075
    ],
    [
      "rayonnant",
      0.005
    ],
    [
      "reluisant",
      0.005
    ],
    [
      "scintillant",
      0.005
    ],
    [
      "signale",
      0.005
    ],
    [
      "somptueux",
      0.005
    ],
    [
      "seduisant",
      0.005
    ],
    [
      "phosphorescent",
      0.005
    ],
    [
      "lumiere",
      0.005
    ],
    [
      "apparence",
      0.005
    ],
    [
      "clarte",
      0.005
    ],
    [
      "celebre",
      0.005
    ],
    [
      "diamant",
      0.005
    ],
    [
      "fulgurant",
      0.005
    ],
    [
      "insigne",
      0.005
    ],
    [
      "spirituel",
      0.0025
    ],
    [
      "solitaire",
      0.0025
    ],
    [
      "miroitant",
      0.0025
    ],
    [
      "lustre",
      0.0025
    ],
    [
      "luminosite",
      0.0025
    ],
    [
      "fulguration",
      0.0025
    ],
    [
      "brillance",
      0.0025
    ],
    [
      "brio",
      0.0025
    ],
    [
      "couleur",
      0.0025
    ],
    [
      "effet",
      0.0025
    ],
    [
      "feu",
      0.0025
    ],
    [
      "magnificence",
      0.0025
    ],
    [
      "miroitement",
      0.0025
    ],
    [
      "passionnant",
      0.0025
    ],
    [
      "phosphorescence",
      0.0025
    ],
    [
      "relief",
      0.0025
    ],
    [
      "satine",
      0.0025
    ],
    [
      "soyeux",
      0.0025
    ],
    [
      "semillant",
      0.0025
    ],
    [
      "trompeur",
      0.0025
    ],
    [
      "luminescence",
      0.0025
    ],
    [
      "fringant",
      0.0025
    ],
    [
      "attrayant",
      0.0025
    ],
    [
      "bijou",
      0.0025
    ],
    [
      "brasillant",
      0.0025
    ],
    [
      "captivant",
      0.0025
    ],
    [
      "chatoiement",
      0.0025
    ],
    [
      "criard",
      0.0025
    ],
    [
      "faste",
      0.0025
    ],
    [
      "fastueux",
      0.0025
    ],
    [
      "florissant",
      0.0025
    ],
    [
      "intensite",
      0.0
    ],
    [
      "luminescent",
      0.0
    ],
    [
      "luxueux",
      0.0
    ],
    [
      "nitescence",
      0.0
    ],
    [
      "nitescent",
      0.0
    ],
    [
      "pierre",
      0.0
    ],
    [
      "rose",
      0.0
    ],
    [
      "solide",
      0.0
    ],
    [
      "toc",
      0.0
    ],
    [
      "verveux",
      0.0
    ],
    [
      "impressionnant",
      0.0
    ],
    [
      "image",
      0.0
    ],
    [
      "fulgurance",
      0.0
    ],
    [
      "abattage",
      0.0
    ],
    [
      "allegre",
      0.0
    ],
    [
      "bague",
      0.0
    ],
    [
      "coruscant",
      0.0
    ],
    [
      "dore",
      0.0
    ],
    [
      "doue",
      0.0
    ],
    [
      "eau",
      0.0
    ],
    [
      "enviable",
      0.0
    ],
    [
      "fard",
      0.0
    ],
    [
      "eloquence",
      0.0
    ]
  ],
  "etinceler": [
    [
      "briller",
      0.1475
    ],
    [
      "luire",
      0.1275
    ],
    [
      "resplendir",
      0.1275
    ],
    [
      "flamboyer",
      0.1175
    ],
    [
      "reluire",
      0.0975
    ],
    [
      "scintiller",
      0.0875
    ],
    [
      "fulgurer",
      0.0575
    ],
    [
      "rayonner",
      0.0575
    ],
    [
      "chatoyer",
      0.0375
    ],
    [
      "miroiter",
      0.0275
    ],
    [
      "petiller",
      0.0275
    ],
    [
      "rutiler",
      0.0275
    ],
    [
      "flamber",
      0.0175
    ],
    [
      "brasiller",
      0.0075
    ],
    [
      "s'etoiler",
      0.0075
    ],
    [
      "eclairer",
      0.0075
    ]
  ],
  "etincelle": [
    [
      "briller",
      0.1475
    ],
    [
      "luire",
      0.1275
    ],
    [
      "resplendir",
      0.1275
    ],
    [
      "flamboyer",
      0.1175
    ],
    [
      "reluire",
      0.0975
    ],
    [
      "scintiller",
      0.0875
    ],
    [
      "fulgurer",
      0.0575
    ],
    [
      "rayonner",
      0.0575
    ],
    [
      "chatoyer",
      0.0375
    ],
    [
      "miroiter",
      0.0275
    ],
    [
      "petiller",
      0.0275
    ],
    [
      "rutiler",
      0.0275
    ],
    [
      "flamber",
      0.0175
    ],
    [
      "brasiller",
      0.0075
    ],
    [
      "s'etoiler",
      0.0075
    ],
    [
      "eclairer",
      0.0075
    ]
  ],
  "or": [
    [
      "argent",
      0.1
    ],
    [
      "presentement",
      0.1
    ],
    [
      "oripeau",
      0.1
    ],
    [
      "mais",
      0.1
    ],
    [
      "louis",
      0.1
    ],
    [
      "jaunet",
      0.1
    ],
    [
      "jaune",
      0.1
    ],
    [
      "donc",
      0.1
    ],
    [
      "chrysocale",
      0.1
    ],
    [
      "richesse",
      0.1
    ]
  ],
  "voulu": [
    [
      "desirer",
      0.13
    ],
    [
      "souhaiter",
      0.1175
    ],
    [
      "demander",
      0.055
    ],
    [
      "pretendre",
      0.0525
    ],
    [
      "convoiter",
      0.0475
    ],
    [
      "exiger",
      0.045
    ],
    [
      "rever",
      0.04
    ],
    [
      "revendiquer",
      0.035
    ],
    [
      "ambitionner",
      0.0325
    ],
    [
      "aspirer",
      0.0275
    ],
    [
      "requerir",
      0.0275
    ],
    [
      "reclamer",
      0.0275
    ],
    [
      "viser",
      0.0275
    ],
    [
      "prescrire",
      0.0225
    ],
    [
      "lorgner",
      0.0225
    ],
    [
      "briguer",
      0.0225
    ],
    [
      "commander",
      0.02
    ],
    [
      "soupirer",
      0.02
    ],
    [
      "aimer",
      0.015
    ],
    [
      "solliciter",
      0.01
    ],
    [
      "ordonner",
      0.01
    ],
    [
      "guigner",
      0.01
    ],
    [
      "envier",
      0.01
    ],
    [
      "decider",
      0.01
    ],
    [
      "esperer",
      0.0075
    ],
    [
      "attendre",
      0.0075
    ],
    [
      "arreter",
      0.0075
    ],
    [
      "gouverner",
      0.0025
    ],
    [
      "loucher",
      0.0025
    ],
    [
      "necessiter",
      0.0025
    ],
    [
      "oser",
      0.0025
    ],
    [
      "s'acharner",
      0.0025
    ],
    [
      "s'enteter",
      0.0025
    ],
    [
      "s'obstiner",
      0.0025
    ],
    [
      "s'opiniatrer",
      0.0025
    ],
    [
      "essayer",
      0.0025
    ],
    [
      "entendre",
      0.0025
    ],
    [
      "accepter",
      0.0025
    ],
    [
      "affirmer",
      0.0025
    ],
    [
      "alleguer",
      0.0025
    ],
    [
      "appeter",
      0.0025
    ],
    [
      "daigner",
      0.0025
    ]
  ],
  "ruer": [
    [
      "ginguer",
      0.2
    ],
    [
      "regimber",
      0.2
    ],
    [
      "recalcitrer",
      0.2
    ]
  ],
  "rue": [
    [
      "voie",
      0.1575
    ],
    [
      "chemin",
      0.0975
    ],
    [
      "passage",
      0.0975
    ],
    [
      "allee",
      0.0775
    ],
    [
      "avenue",
      0.0775
    ],
    [
      "chaussee",
      0.0575
    ],
    [
      "venelle",
      0.0375
    ],
    [
      "trottoir",
      0.0375
    ],
    [
      "ruelle",
      0.0375
    ],
    [
      "promenade",
      0.0375
    ],
    [
      "pave",
      0.0375
    ],
    [
      "galerie",
      0.0375
    ],
    [
      "boulevard",
      0.0375
    ],
    [
      "quai",
      0.0175
    ],
    [
      "impasse",
      0.0175
    ],
    [
      "cours",
      0.0175
    ],
    [
      "communication",
      0.0175
    ],
    [
      "cheminee",
      0.0175
    ],
    [
      "asphalte",
      0.0175
    ],
    [
      "artere",
      0.0175
    ],
    [
      "ruisseau",
      0.0175
    ]
  ],
  "addition": [
    [
      "supplement",
      0.1225
    ],
    [
      "ajout",
      0.0825
    ],
    [
      "complement",
      0.0825
    ],
    [
      "ajoutage",
      0.0675
    ],
    [
      "compte",
      0.0675
    ],
    [
      "rallonge",
      0.055
    ],
    [
      "annexe",
      0.055
    ],
    [
      "addenda",
      0.04
    ],
    [
      "facture",
      0.04
    ],
    [
      "somme",
      0.0275
    ],
    [
      "prix",
      0.0275
    ],
    [
      "note",
      0.0275
    ],
    [
      "augmentation",
      0.0275
    ],
    [
      "appendice",
      0.0275
    ],
    [
      "adjonction",
      0.0275
    ],
    [
      "decompte",
      0.0125
    ],
    [
      "du",
      0.0125
    ],
    [
      "frais",
      0.0125
    ],
    [
      "modification",
      0.0125
    ],
    [
      "releve",
      0.0125
    ],
    [
      "sommation",
      0.0125
    ],
    [
      "douloureuse",
      0.0125
    ],
    [
      "calcul",
      0.0125
    ],
    [
      "ajoute",
      0.0125
    ],
    [
      "ajouture",
      0.0125
    ],
    [
      "admixtion",
      0.0125
    ],
    [
      "additionnement",
      0.0125
    ],
    [
      "additif",
      0.0125
    ],
    [
      "accumulation",
      0.0125
    ],
    [
      "accroissement",
      0.0125
    ],
    [
      "total",
      0.0125
    ]
  ],
  "cadet": [
    [
      "benjamin",
      0.1875
    ],
    [
      "jeune",
      0.1875
    ],
    [
      "junior",
      0.1225
    ],
    [
      "novice",
      0.1225
    ],
    [
      "puine",
      0.1225
    ],
    [
      "apprenti",
      0.06
    ],
    [
      "caddie",
      0.06
    ],
    [
      "second",
      0.06
    ]
  ],
  "grandir": [
    [
      "augmenter",
      0.16
    ],
    [
      "croitre",
      0.07
    ],
    [
      "grossir",
      0.07
    ],
    [
      "pousser",
      0.0525
    ],
    [
      "developper",
      0.04
    ],
    [
      "exagerer",
      0.04
    ],
    [
      "elever",
      0.0325
    ],
    [
      "rencherir",
      0.0325
    ],
    [
      "hausser",
      0.0325
    ],
    [
      "exalter",
      0.0325
    ],
    [
      "enfler",
      0.0325
    ],
    [
      "amplifier",
      0.0325
    ],
    [
      "agrandir",
      0.0325
    ],
    [
      "monter",
      0.0275
    ],
    [
      "s'etendre",
      0.025
    ],
    [
      "profiter",
      0.02
    ],
    [
      "surfaire",
      0.015
    ],
    [
      "s'accroitre",
      0.015
    ],
    [
      "relever",
      0.015
    ],
    [
      "rehausser",
      0.015
    ],
    [
      "gagner",
      0.015
    ],
    [
      "fortifier",
      0.015
    ],
    [
      "avancer",
      0.015
    ],
    [
      "allonger",
      0.015
    ],
    [
      "aggraver",
      0.01
    ],
    [
      "venir",
      0.0075
    ],
    [
      "s'intensifier",
      0.0075
    ],
    [
      "redoubler",
      0.0075
    ],
    [
      "fleurir",
      0.0075
    ],
    [
      "ennoblir",
      0.0075
    ],
    [
      "s'elever",
      0.0025
    ],
    [
      "s'amplifier",
      0.0025
    ],
    [
      "s'allonger",
      0.0025
    ],
    [
      "s'agrandir",
      0.0025
    ],
    [
      "s'aggraver",
      0.0025
    ],
    [
      "murir",
      0.0025
    ],
    [
      "dramatiser",
      0.0025
    ]
  ],
  "illegal": [
    [
      "illicite",
      0.11
    ],
    [
      "illegitime",
      0.11
    ],
    [
      "injuste",
      0.11
    ],
    [
      "irregulier",
      0.11
    ],
    [
      "partial",
      0.055
    ],
    [
      "injustifie",
      0.055
    ],
    [
      "arbitraire",
      0.055
    ],
    [
      "sauvage",
      0.0275
    ],
    [
      "prohibe",
      0.0275
    ],
    [
      "permis",
      0.0275
    ],
    [
      "parallele",
      0.0275
    ],
    [
      "outlaw",
      0.0275
    ],
    [
      "interdit",
      0.0275
    ],
    [
      "injustifiable",
      0.0275
    ],
    [
      "frauduleux",
      0.0275
    ],
    [
      "factieux",
      0.0275
    ],
    [
      "extralegal",
      0.0275
    ],
    [
      "defendu",
      0.0275
    ],
    [
      "attaquable",
      0.0275
    ],
    [
      "usurpatoire",
      0.0275
    ]
  ],
  "phone": [
    [
      "sone",
      1.0
    ]
  ],
  "poisson": [
    [
      "maquereau",
      0.25
    ],
    [
      "alevin",
      0.125
    ],
    [
      "friture",
      0.125
    ],
    [
      "maree",
      0.125
    ],
    [
      "poisse",
      0.125
    ],
    [
      "peche",
      0.125
    ],
    [
      "souteneur",
      0.125
    ]
  ],
  "puer": [
    [
      "sentir",
      0.2375
    ],
    [
      "cogner",
      0.0775
    ],
    [
      "empester",
      0.0775
    ],
    [
      "cocotter",
      0.0575
    ],
    [
      "empuantir",
      0.0575
    ],
    [
      "exhaler",
      0.0575
    ],
    [
      "trouilloter",
      0.0375
    ],
    [
      "taper",
      0.0375
    ],
    [
      "schlinguer",
      0.0375
    ],
    [
      "infecter",
      0.0375
    ],
    [
      "empoisonner",
      0.0375
    ],
    [
      "poquer",
      0.0175
    ],
    [
      "gazouiller",
      0.0175
    ],
    [
      "fouetter",
      0.0175
    ],
    [
      "emboucaner",
      0.0175
    ],
    [
      "degager",
      0.0175
    ],
    [
      "suinter",
      0.0175
    ]
  ],
  "cul": [
    [
      "derriere",
      0.1225
    ],
    [
      "fessier",
      0.1225
    ],
    [
      "fesse",
      0.115
    ],
    [
      "anus",
      0.08
    ],
    [
      "posterieur",
      0.0525
    ],
    [
      "croupe",
      0.0325
    ],
    [
      "fondement",
      0.0325
    ],
    [
      "popotin",
      0.025
    ],
    [
      "croupion",
      0.025
    ],
    [
      "con",
      0.025
    ],
    [
      "bol",
      0.025
    ],
    [
      "troufignon",
      0.015
    ],
    [
      "petard",
      0.015
    ],
    [
      "imbecile",
      0.015
    ],
    [
      "idiot",
      0.015
    ],
    [
      "fond",
      0.015
    ],
    [
      "fion",
      0.015
    ],
    [
      "derche",
      0.015
    ],
    [
      "nazin",
      0.0075
    ],
    [
      "niais",
      0.0075
    ],
    [
      "oignon",
      0.0075
    ],
    [
      "panier",
      0.0075
    ],
    [
      "sexe",
      0.0075
    ],
    [
      "train",
      0.0075
    ],
    [
      "veine",
      0.0075
    ],
    [
      "lune",
      0.0075
    ],
    [
      "fiasse",
      0.0075
    ],
    [
      "fignard",
      0.0075
    ],
    [
      "arriere",
      0.0075
    ],
    [
      "baba",
      0.0075
    ],
    [
      "baise",
      0.0075
    ],
    [
      "base",
      0.0075
    ],
    [
      "cretin",
      0.0075
    ],
    [
      "cuisse",
      0.0075
    ],
    [
      "culasse",
      0.0075
    ],
    [
      "dargeot",
      0.0075
    ],
    [
      "fesses",
      0.0075
    ]
  ],
  "baigner": [
    [
      "tremper",
      0.0925
    ],
    [
      "arroser",
      0.08
    ],
    [
      "penetrer",
      0.07
    ],
    [
      "humecter",
      0.0575
    ],
    [
      "inonder",
      0.0575
    ],
    [
      "passer",
      0.0575
    ],
    [
      "plonger",
      0.045
    ],
    [
      "noyer",
      0.045
    ],
    [
      "mouiller",
      0.045
    ],
    [
      "laver",
      0.045
    ],
    [
      "impregner",
      0.045
    ],
    [
      "bassiner",
      0.045
    ],
    [
      "traverser",
      0.035
    ],
    [
      "immerger",
      0.035
    ],
    [
      "couler",
      0.035
    ],
    [
      "remplir",
      0.0225
    ],
    [
      "tuber",
      0.01
    ],
    [
      "nettoyer",
      0.01
    ],
    [
      "nager",
      0.01
    ],
    [
      "mariner",
      0.01
    ],
    [
      "macerer",
      0.01
    ],
    [
      "irriguer",
      0.01
    ],
    [
      "illuter",
      0.01
    ],
    [
      "envelopper",
      0.01
    ],
    [
      "entourer",
      0.01
    ],
    [
      "caresser",
      0.01
    ],
    [
      "aiguayer",
      0.01
    ]
  ],
  "dehors": [
    [
      "exterieur",
      0.1675
    ],
    [
      "air",
      0.0975
    ],
    [
      "apparence",
      0.0975
    ],
    [
      "aspect",
      0.055
    ],
    [
      "allure",
      0.0475
    ],
    [
      "figure",
      0.0475
    ],
    [
      "tournure",
      0.0475
    ],
    [
      "mine",
      0.0425
    ],
    [
      "facade",
      0.0425
    ],
    [
      "maintien",
      0.035
    ],
    [
      "visage",
      0.035
    ],
    [
      "attitude",
      0.03
    ],
    [
      "vernis",
      0.0225
    ],
    [
      "superficie",
      0.0175
    ],
    [
      "semblance",
      0.0175
    ],
    [
      "masque",
      0.0175
    ],
    [
      "forme",
      0.0175
    ],
    [
      "facon",
      0.0175
    ],
    [
      "ecorce",
      0.01
    ],
    [
      "surface",
      0.01
    ],
    [
      "manieres",
      0.01
    ],
    [
      "endroit",
      0.01
    ],
    [
      "abord",
      0.01
    ],
    [
      "ouvrage",
      0.005
    ],
    [
      "loin",
      0.005
    ],
    [
      "hors",
      0.005
    ],
    [
      "habit",
      0.005
    ],
    [
      "exterieurement",
      0.005
    ],
    [
      "dela",
      0.005
    ],
    [
      "ailleurs",
      0.005
    ]
  ],
  "valeur": [
    [
      "force",
      0.075
    ],
    [
      "courage",
      0.05
    ],
    [
      "qualite",
      0.045
    ],
    [
      "vertu",
      0.045
    ],
    [
      "grandeur",
      0.04
    ],
    [
      "merite",
      0.04
    ],
    [
      "classe",
      0.0375
    ],
    [
      "caractere",
      0.0375
    ],
    [
      "portee",
      0.0325
    ],
    [
      "titre",
      0.0325
    ],
    [
      "coeur",
      0.025
    ],
    [
      "capacite",
      0.025
    ],
    [
      "bonte",
      0.025
    ],
    [
      "bien",
      0.025
    ],
    [
      "ame",
      0.02
    ],
    [
      "ressort",
      0.02
    ],
    [
      "pouvoir",
      0.02
    ],
    [
      "interet",
      0.02
    ],
    [
      "heroisme",
      0.02
    ],
    [
      "generosite",
      0.02
    ],
    [
      "action",
      0.02
    ],
    [
      "effet",
      0.015
    ],
    [
      "prix",
      0.015
    ],
    [
      "vaillance",
      0.015
    ],
    [
      "trempe",
      0.0125
    ],
    [
      "stature",
      0.0125
    ],
    [
      "signification",
      0.0125
    ],
    [
      "sens",
      0.0125
    ],
    [
      "poids",
      0.0125
    ],
    [
      "importance",
      0.0125
    ],
    [
      "calibre",
      0.0125
    ],
    [
      "gabarit",
      0.0075
    ],
    [
      "morale",
      0.0075
    ],
    [
      "moralite",
      0.0075
    ],
    [
      "obligation",
      0.0075
    ],
    [
      "utilite",
      0.0075
    ],
    [
      "verite",
      0.0075
    ],
    [
      "envergure",
      0.0075
    ],
    [
      "efficacite",
      0.0075
    ],
    [
      "billet",
      0.0075
    ],
    [
      "bon",
      0.0075
    ],
    [
      "bravoure",
      0.0075
    ],
    [
      "carrure",
      0.0075
    ],
    [
      "cours",
      0.0075
    ],
    [
      "distinction",
      0.0075
    ],
    [
      "part",
      0.0025
    ],
    [
      "portefeuille",
      0.0025
    ],
    [
      "rente",
      0.0025
    ],
    [
      "validite",
      0.0025
    ],
    [
      "etoffe",
      0.0025
    ],
    [
      "papier",
      0.0025
    ],
    [
      "loyer",
      0.0025
    ],
    [
      "ideal",
      0.0025
    ],
    [
      "cote",
      0.0025
    ],
    [
      "capital",
      0.0025
    ],
    [
      "but",
      0.0025
    ],
    [
      "authenticite",
      0.0025
    ],
    [
      "aloi",
      0.0025
    ],
    [
      "evaluation",
      0.0025
    ]
  ],
  "mongol": [
    [
      "tartare",
      0.5
    ],
    [
      "tatar",
      0.5
    ]
  ],
  "insulter": [
    [
      "injurier",
      0.245
    ],
    [
      "blesser",
      0.075
    ],
    [
      "invectiver",
      0.075
    ],
    [
      "maltraiter",
      0.075
    ],
    [
      "offenser",
      0.075
    ],
    [
      "vilipender",
      0.055
    ],
    [
      "outrager",
      0.055
    ],
    [
      "attaquer",
      0.055
    ],
    [
      "agonir",
      0.055
    ],
    [
      "engueuler",
      0.0375
    ],
    [
      "braver",
      0.0375
    ],
    [
      "aubader",
      0.0175
    ],
    [
      "blasphemer",
      0.0175
    ],
    [
      "brocarder",
      0.0175
    ],
    [
      "harpailler",
      0.0175
    ],
    [
      "humilier",
      0.0175
    ],
    [
      "offusquer",
      0.0175
    ]
  ],
  "passant": [
    [
      "frequente",
      0.18
    ],
    [
      "marcheur",
      0.18
    ],
    [
      "coulant",
      0.09
    ],
    [
      "flaneur",
      0.09
    ],
    [
      "passager",
      0.09
    ],
    [
      "pieton",
      0.09
    ],
    [
      "populeux",
      0.09
    ],
    [
      "promeneur",
      0.09
    ],
    [
      "vivant",
      0.09
    ]
  ],
  "pute": [
    [
      "putain",
      0.5
    ],
    [
      "prostituee",
      0.25
    ],
    [
      "putasse",
      0.25
    ]
  ],
  "gronder": [
    [
      "reprimander",
      0.0725
    ],
    [
      "sermonner",
      0.0725
    ],
    [
      "tancer",
      0.0725
    ],
    [
      "crier",
      0.0475
    ],
    [
      "gourmander",
      0.0475
    ],
    [
      "protester",
      0.0475
    ],
    [
      "rouspeter",
      0.04
    ],
    [
      "murmurer",
      0.04
    ],
    [
      "engueuler",
      0.04
    ],
    [
      "admonester",
      0.04
    ],
    [
      "attraper",
      0.035
    ],
    [
      "grogner",
      0.035
    ],
    [
      "ronchonner",
      0.03
    ],
    [
      "raler",
      0.025
    ],
    [
      "bougonner",
      0.025
    ],
    [
      "disputer",
      0.02
    ],
    [
      "maugreer",
      0.02
    ],
    [
      "morigener",
      0.02
    ],
    [
      "quereller",
      0.02
    ],
    [
      "tonner",
      0.02
    ],
    [
      "secouer",
      0.015
    ],
    [
      "grommeler",
      0.015
    ],
    [
      "tempeter",
      0.01
    ],
    [
      "s'indigner",
      0.01
    ],
    [
      "rognonner",
      0.01
    ],
    [
      "mugir",
      0.01
    ],
    [
      "maronner",
      0.01
    ],
    [
      "hurler",
      0.01
    ],
    [
      "houspiller",
      0.01
    ],
    [
      "chapitrer",
      0.01
    ],
    [
      "menacer",
      0.0025
    ],
    [
      "rabrouer",
      0.0025
    ],
    [
      "rouler",
      0.0025
    ],
    [
      "rouscailler",
      0.0025
    ],
    [
      "savonner",
      0.0025
    ],
    [
      "grognonner",
      0.0025
    ],
    [
      "fremir",
      0.0025
    ],
    [
      "enguirlander",
      0.0025
    ],
    [
      "emballer",
      0.0025
    ],
    [
      "criailler",
      0.0025
    ],
    [
      "catechiser",
      0.0025
    ],
    [
      "beugler",
      0.0025
    ],
    [
      "vrombir",
      0.0025
    ]
  ],
  "pendant": [
    [
      "par",
      0.0925
    ],
    [
      "avachi",
      0.0725
    ],
    [
      "dans",
      0.055
    ],
    [
      "semblable",
      0.035
    ],
    [
      "pour",
      0.035
    ],
    [
      "pendentif",
      0.035
    ],
    [
      "pendeloque",
      0.035
    ],
    [
      "en",
      0.035
    ],
    [
      "durant",
      0.035
    ],
    [
      "de",
      0.035
    ],
    [
      "flasque",
      0.0175
    ],
    [
      "girandole",
      0.0175
    ],
    [
      "incline",
      0.0175
    ],
    [
      "retombant",
      0.0175
    ],
    [
      "replique",
      0.0175
    ],
    [
      "sautoir",
      0.0175
    ],
    [
      "sosie",
      0.0175
    ],
    [
      "symetrie",
      0.0175
    ],
    [
      "symetrique",
      0.0175
    ],
    [
      "tombant",
      0.0175
    ],
    [
      "trainant",
      0.0175
    ],
    [
      "fatigue",
      0.0175
    ],
    [
      "dormeuse",
      0.0175
    ],
    [
      "accord",
      0.0175
    ],
    [
      "affaisse",
      0.0175
    ],
    [
      "affale",
      0.0175
    ],
    [
      "avale",
      0.0175
    ],
    [
      "ballant",
      0.0175
    ],
    [
      "bas",
      0.0175
    ],
    [
      "boucle",
      0.0175
    ],
    [
      "cependant",
      0.0175
    ],
    [
      "contrepartie",
      0.0175
    ],
    [
      "correspondant",
      0.0175
    ],
    [
      "egal",
      0.0175
    ]
  ],
  "impression": [
    [
      "sentiment",
      0.0875
    ],
    [
      "influence",
      0.065
    ],
    [
      "image",
      0.0525
    ],
    [
      "sensation",
      0.0525
    ],
    [
      "vue",
      0.0425
    ],
    [
      "empreinte",
      0.0425
    ],
    [
      "trace",
      0.0325
    ],
    [
      "tirage",
      0.0325
    ],
    [
      "souvenir",
      0.0325
    ],
    [
      "reproduction",
      0.0325
    ],
    [
      "pression",
      0.0325
    ],
    [
      "perception",
      0.0325
    ],
    [
      "pensee",
      0.0325
    ],
    [
      "impulsion",
      0.0325
    ],
    [
      "gravure",
      0.0325
    ],
    [
      "effet",
      0.0325
    ],
    [
      "application",
      0.0325
    ],
    [
      "emotion",
      0.02
    ],
    [
      "vestige",
      0.02
    ],
    [
      "saisissement",
      0.02
    ],
    [
      "opinion",
      0.02
    ],
    [
      "notion",
      0.02
    ],
    [
      "marque",
      0.02
    ],
    [
      "action",
      0.02
    ],
    [
      "edition",
      0.01
    ],
    [
      "teinture",
      0.01
    ],
    [
      "sensibilite",
      0.01
    ],
    [
      "pressentiment",
      0.01
    ],
    [
      "poussee",
      0.01
    ],
    [
      "imprimerie",
      0.01
    ],
    [
      "fascination",
      0.01
    ],
    [
      "entrainement",
      0.01
    ],
    [
      "decalque",
      0.01
    ],
    [
      "decalquage",
      0.01
    ],
    [
      "appreciation",
      0.01
    ],
    [
      "air",
      0.01
    ],
    [
      "etonnement",
      0.01
    ]
  ],
  "fache": [
    [
      "chagriner",
      0.0925
    ],
    [
      "ennuyer",
      0.0925
    ],
    [
      "irriter",
      0.0725
    ],
    [
      "navrer",
      0.0575
    ],
    [
      "desoler",
      0.055
    ],
    [
      "agacer",
      0.055
    ],
    [
      "contrarier",
      0.05
    ],
    [
      "mecontenter",
      0.045
    ],
    [
      "tourmenter",
      0.035
    ],
    [
      "piquer",
      0.035
    ],
    [
      "deplaire",
      0.035
    ],
    [
      "affliger",
      0.035
    ],
    [
      "indisposer",
      0.03
    ],
    [
      "froisser",
      0.025
    ],
    [
      "chiffonner",
      0.0225
    ],
    [
      "desobliger",
      0.0225
    ],
    [
      "peiner",
      0.0175
    ],
    [
      "exasperer",
      0.0175
    ],
    [
      "embeter",
      0.0175
    ],
    [
      "aigrir",
      0.0175
    ],
    [
      "attrister",
      0.0125
    ],
    [
      "depiter",
      0.0125
    ],
    [
      "desesperer",
      0.0125
    ],
    [
      "revolter",
      0.0125
    ],
    [
      "mortifier",
      0.0075
    ],
    [
      "indigner",
      0.0075
    ],
    [
      "desappointer",
      0.0075
    ],
    [
      "degouter",
      0.0075
    ],
    [
      "cabrer",
      0.0075
    ],
    [
      "brouiller",
      0.0075
    ],
    [
      "bouder",
      0.0025
    ],
    [
      "contrister",
      0.0025
    ],
    [
      "courroucer",
      0.0025
    ],
    [
      "desaccorder",
      0.0025
    ],
    [
      "endever",
      0.0025
    ],
    [
      "refroidir",
      0.0025
    ]
  ],
  "facher": [
    [
      "chagriner",
      0.0925
    ],
    [
      "ennuyer",
      0.0925
    ],
    [
      "irriter",
      0.0725
    ],
    [
      "navrer",
      0.0575
    ],
    [
      "desoler",
      0.055
    ],
    [
      "agacer",
      0.055
    ],
    [
      "contrarier",
      0.05
    ],
    [
      "mecontenter",
      0.045
    ],
    [
      "tourmenter",
      0.035
    ],
    [
      "piquer",
      0.035
    ],
    [
      "deplaire",
      0.035
    ],
    [
      "affliger",
      0.035
    ],
    [
      "indisposer",
      0.03
    ],
    [
      "froisser",
      0.025
    ],
    [
      "chiffonner",
      0.0225
    ],
    [
      "desobliger",
      0.0225
    ],
    [
      "peiner",
      0.0175
    ],
    [
      "exasperer",
      0.0175
    ],
    [
      "embeter",
      0.0175
    ],
    [
      "aigrir",
      0.0175
    ],
    [
      "attrister",
      0.0125
    ],
    [
      "depiter",
      0.0125
    ],
    [
      "desesperer",
      0.0125
    ],
    [
      "revolter",
      0.0125
    ],
    [
      "mortifier",
      0.0075
    ],
    [
      "indigner",
      0.0075
    ],
    [
      "desappointer",
      0.0075
    ],
    [
      "degouter",
      0.0075
    ],
    [
      "cabrer",
      0.0075
    ],
    [
      "brouiller",
      0.0075
    ],
    [
      "bouder",
      0.0025
    ],
    [
      "contrister",
      0.0025
    ],
    [
      "courroucer",
      0.0025
    ],
    [
      "desaccorder",
      0.0025
    ],
    [
      "endever",
      0.0025
    ],
    [
      "refroidir",
      0.0025
    ]
  ],
  "eux": [],
  "traite": [
    [
      "tirer",
      1.0
    ]
  ],
  "trait": [
    [
      "tirer",
      1.0
    ]
  ],
  "traiter": [
    [
      "toucher",
      0.0525
    ],
    [
      "prendre",
      0.045
    ],
    [
      "conclure",
      0.035
    ],
    [
      "faire",
      0.035
    ],
    [
      "examiner",
      0.0325
    ],
    [
      "regarder",
      0.0325
    ],
    [
      "regler",
      0.0225
    ],
    [
      "arreter",
      0.0225
    ],
    [
      "arranger",
      0.0225
    ],
    [
      "agir",
      0.0225
    ],
    [
      "user",
      0.0175
    ],
    [
      "rouler",
      0.0175
    ],
    [
      "recevoir",
      0.0175
    ],
    [
      "parlementer",
      0.0175
    ],
    [
      "negocier",
      0.0175
    ],
    [
      "fixer",
      0.0175
    ],
    [
      "discuter",
      0.0175
    ],
    [
      "convenir",
      0.0175
    ],
    [
      "considerer",
      0.0175
    ],
    [
      "composer",
      0.0175
    ],
    [
      "inviter",
      0.015
    ],
    [
      "manier",
      0.015
    ],
    [
      "s'occuper",
      0.015
    ],
    [
      "etudier",
      0.015
    ],
    [
      "feter",
      0.015
    ],
    [
      "exposer",
      0.015
    ],
    [
      "effleurer",
      0.015
    ],
    [
      "agiter",
      0.015
    ],
    [
      "accueillir",
      0.015
    ],
    [
      "aborder",
      0.015
    ],
    [
      "transiger",
      0.01
    ],
    [
      "transformer",
      0.01
    ],
    [
      "terminer",
      0.01
    ],
    [
      "soumettre",
      0.01
    ],
    [
      "porter",
      0.01
    ],
    [
      "nommer",
      0.01
    ],
    [
      "mener",
      0.01
    ],
    [
      "debattre",
      0.01
    ],
    [
      "honorer",
      0.0075
    ],
    [
      "heberger",
      0.0075
    ],
    [
      "qualifier",
      0.0075
    ],
    [
      "raisonner",
      0.0075
    ],
    [
      "regaler",
      0.0075
    ],
    [
      "s'entendre",
      0.0075
    ],
    [
      "glisser",
      0.0075
    ],
    [
      "entreprendre",
      0.0075
    ],
    [
      "acheter",
      0.0075
    ],
    [
      "admettre",
      0.0075
    ],
    [
      "adoucir",
      0.0075
    ],
    [
      "appeler",
      0.0075
    ],
    [
      "discourir",
      0.0075
    ],
    [
      "denommer",
      0.0075
    ],
    [
      "designer",
      0.0075
    ],
    [
      "pivoter",
      0.0025
    ],
    [
      "resoudre",
      0.0025
    ],
    [
      "signer",
      0.0025
    ],
    [
      "soigner",
      0.0025
    ],
    [
      "taxer",
      0.0025
    ],
    [
      "guerir",
      0.0025
    ],
    [
      "brasser",
      0.0025
    ],
    [
      "capituler",
      0.0025
    ],
    [
      "conditionner",
      0.0025
    ],
    [
      "convier",
      0.0025
    ],
    [
      "disserter",
      0.0025
    ],
    [
      "developper",
      0.0025
    ],
    [
      "epuiser",
      0.0025
    ]
  ],
  "putain": [
    [
      "prostituee",
      0.38
    ],
    [
      "pute",
      0.095
    ],
    [
      "peripateticienne",
      0.0475
    ],
    [
      "putasse",
      0.0475
    ],
    [
      "poule",
      0.0475
    ],
    [
      "morue",
      0.0475
    ],
    [
      "grue",
      0.0475
    ],
    [
      "gourgandine",
      0.0475
    ],
    [
      "gaupe",
      0.0475
    ],
    [
      "garce",
      0.0475
    ],
    [
      "cocotte",
      0.0475
    ],
    [
      "catin",
      0.0475
    ],
    [
      "rouchie",
      0.0475
    ]
  ],
  "cherir": [
    [
      "aimer",
      0.235
    ],
    [
      "adorer",
      0.145
    ],
    [
      "estimer",
      0.1175
    ],
    [
      "venerer",
      0.1175
    ],
    [
      "reverer",
      0.0575
    ],
    [
      "idolatrer",
      0.0575
    ],
    [
      "affectionner",
      0.0575
    ],
    [
      "preferer",
      0.0275
    ],
    [
      "priser",
      0.0275
    ],
    [
      "aduler",
      0.0275
    ]
  ],
  "cheri": [
    [
      "beau",
      0.085
    ],
    [
      "bon",
      0.085
    ],
    [
      "favori",
      0.07
    ],
    [
      "cher",
      0.07
    ],
    [
      "amoureux",
      0.07
    ],
    [
      "amant",
      0.055
    ],
    [
      "ami",
      0.055
    ],
    [
      "biquet",
      0.055
    ],
    [
      "flirt",
      0.055
    ],
    [
      "prefere",
      0.04
    ],
    [
      "doux",
      0.04
    ],
    [
      "precieux",
      0.0275
    ],
    [
      "mignon",
      0.0275
    ],
    [
      "chouchou",
      0.0275
    ],
    [
      "affectionne",
      0.0275
    ],
    [
      "adore",
      0.0275
    ],
    [
      "beguin",
      0.0125
    ],
    [
      "gate",
      0.0125
    ],
    [
      "predilection",
      0.0125
    ],
    [
      "soupirant",
      0.0125
    ]
  ],
  "raconter": [
    [
      "exposer",
      0.115
    ],
    [
      "dire",
      0.0975
    ],
    [
      "retracer",
      0.08
    ],
    [
      "montrer",
      0.0625
    ],
    [
      "reveler",
      0.055
    ],
    [
      "exprimer",
      0.0425
    ],
    [
      "debiter",
      0.0375
    ],
    [
      "decrire",
      0.0375
    ],
    [
      "expliquer",
      0.0375
    ],
    [
      "rapporter",
      0.0325
    ],
    [
      "conter",
      0.03
    ],
    [
      "peindre",
      0.03
    ],
    [
      "publier",
      0.03
    ],
    [
      "representer",
      0.03
    ],
    [
      "parler",
      0.025
    ],
    [
      "developper",
      0.02
    ],
    [
      "redire",
      0.02
    ],
    [
      "depeindre",
      0.015
    ],
    [
      "bavarder",
      0.015
    ],
    [
      "etaler",
      0.0125
    ],
    [
      "enoncer",
      0.0125
    ],
    [
      "repeter",
      0.0125
    ],
    [
      "relater",
      0.0125
    ],
    [
      "informer",
      0.0125
    ],
    [
      "detailler",
      0.0125
    ],
    [
      "chanter",
      0.0125
    ],
    [
      "sortir",
      0.0075
    ],
    [
      "reciter",
      0.0075
    ],
    [
      "rappeler",
      0.0075
    ],
    [
      "narrer",
      0.0075
    ],
    [
      "jaboter",
      0.0075
    ],
    [
      "deduire",
      0.0075
    ],
    [
      "brosser",
      0.0025
    ],
    [
      "debagouler",
      0.0025
    ],
    [
      "pretendre",
      0.0025
    ],
    [
      "tracer",
      0.0025
    ]
  ],
  "salade": [
    [
      "histoire",
      0.135
    ],
    [
      "melange",
      0.135
    ],
    [
      "boniment",
      0.09
    ],
    [
      "bouillabaisse",
      0.09
    ],
    [
      "mensonge",
      0.09
    ],
    [
      "roman",
      0.045
    ],
    [
      "romaine",
      0.045
    ],
    [
      "marmelade",
      0.045
    ],
    [
      "macedoine",
      0.045
    ],
    [
      "fable",
      0.045
    ],
    [
      "enchevetrement",
      0.045
    ],
    [
      "desordre",
      0.045
    ],
    [
      "confusion",
      0.045
    ],
    [
      "casque",
      0.045
    ],
    [
      "sornette",
      0.045
    ]
  ],
  "verser": [
    [
      "repandre",
      0.085
    ],
    [
      "couler",
      0.0525
    ],
    [
      "donner",
      0.0525
    ],
    [
      "payer",
      0.0525
    ],
    [
      "renverser",
      0.0525
    ],
    [
      "prodiguer",
      0.04
    ],
    [
      "epandre",
      0.03
    ],
    [
      "transvaser",
      0.03
    ],
    [
      "mettre",
      0.03
    ],
    [
      "jeter",
      0.03
    ],
    [
      "chavirer",
      0.03
    ],
    [
      "arroser",
      0.03
    ],
    [
      "infuser",
      0.02
    ],
    [
      "instiller",
      0.02
    ],
    [
      "regler",
      0.02
    ],
    [
      "tomber",
      0.02
    ],
    [
      "transfuser",
      0.02
    ],
    [
      "vider",
      0.02
    ],
    [
      "epancher",
      0.02
    ],
    [
      "financer",
      0.02
    ],
    [
      "deverser",
      0.02
    ],
    [
      "deposer",
      0.02
    ],
    [
      "adjoindre",
      0.02
    ],
    [
      "basculer",
      0.02
    ],
    [
      "coucher",
      0.02
    ],
    [
      "culbuter",
      0.02
    ],
    [
      "debourser",
      0.02
    ],
    [
      "decaisser",
      0.02
    ],
    [
      "depenser",
      0.02
    ],
    [
      "sombrer",
      0.0075
    ],
    [
      "servir",
      0.0075
    ],
    [
      "retourner",
      0.0075
    ],
    [
      "remplir",
      0.0075
    ],
    [
      "nommer",
      0.0075
    ],
    [
      "muter",
      0.0075
    ],
    [
      "incorporer",
      0.0075
    ],
    [
      "entonner",
      0.0075
    ],
    [
      "ajouter",
      0.0075
    ],
    [
      "transvider",
      0.0075
    ]
  ],
  "mayo": [],
  "dealer": [],
  "dope": [
    [
      "droguer",
      0.25
    ],
    [
      "enflammer",
      0.25
    ],
    [
      "exciter",
      0.25
    ],
    [
      "stimuler",
      0.25
    ]
  ],
  "doper": [
    [
      "droguer",
      0.25
    ],
    [
      "enflammer",
      0.25
    ],
    [
      "exciter",
      0.25
    ],
    [
      "stimuler",
      0.25
    ]
  ],
  "deployer": [
    [
      "afficher",
      0.105
    ],
    [
      "etendre",
      0.095
    ],
    [
      "etaler",
      0.0875
    ],
    [
      "montrer",
      0.0675
    ],
    [
      "developper",
      0.0575
    ],
    [
      "reveler",
      0.0475
    ],
    [
      "rallonger",
      0.0375
    ],
    [
      "manifester",
      0.0375
    ],
    [
      "exposer",
      0.0375
    ],
    [
      "etirer",
      0.0275
    ],
    [
      "prodiguer",
      0.0275
    ],
    [
      "paraitre",
      0.0275
    ],
    [
      "ouvrir",
      0.0275
    ],
    [
      "exhiber",
      0.0275
    ],
    [
      "allonger",
      0.0275
    ],
    [
      "epanouir",
      0.0175
    ],
    [
      "user",
      0.0175
    ],
    [
      "exercer",
      0.0175
    ],
    [
      "employer",
      0.0175
    ],
    [
      "derouler",
      0.0175
    ],
    [
      "deplier",
      0.0175
    ],
    [
      "depenser",
      0.0175
    ],
    [
      "tendre",
      0.0075
    ],
    [
      "s'etirer",
      0.0075
    ],
    [
      "s'allonger",
      0.0075
    ],
    [
      "prouver",
      0.0075
    ],
    [
      "deferler",
      0.0075
    ],
    [
      "arborer",
      0.0075
    ],
    [
      "eployer",
      0.0075
    ]
  ],
  "deploye": [
    [
      "afficher",
      0.105
    ],
    [
      "etendre",
      0.095
    ],
    [
      "etaler",
      0.0875
    ],
    [
      "montrer",
      0.0675
    ],
    [
      "developper",
      0.0575
    ],
    [
      "reveler",
      0.0475
    ],
    [
      "rallonger",
      0.0375
    ],
    [
      "manifester",
      0.0375
    ],
    [
      "exposer",
      0.0375
    ],
    [
      "etirer",
      0.0275
    ],
    [
      "prodiguer",
      0.0275
    ],
    [
      "paraitre",
      0.0275
    ],
    [
      "ouvrir",
      0.0275
    ],
    [
      "exhiber",
      0.0275
    ],
    [
      "allonger",
      0.0275
    ],
    [
      "epanouir",
      0.0175
    ],
    [
      "user",
      0.0175
    ],
    [
      "exercer",
      0.0175
    ],
    [
      "employer",
      0.0175
    ],
    [
      "derouler",
      0.0175
    ],
    [
      "deplier",
      0.0175
    ],
    [
      "depenser",
      0.0175
    ],
    [
      "tendre",
      0.0075
    ],
    [
      "s'etirer",
      0.0075
    ],
    [
      "s'allonger",
      0.0075
    ],
    [
      "prouver",
      0.0075
    ],
    [
      "deferler",
      0.0075
    ],
    [
      "arborer",
      0.0075
    ],
    [
      "eployer",
      0.0075
    ]
  ],
  "emmerder": [
    [
      "ennuyer",
      0.2075
    ],
    [
      "embeter",
      0.1325
    ],
    [
      "barber",
      0.075
    ],
    [
      "turlupiner",
      0.055
    ],
    [
      "enquiquiner",
      0.055
    ],
    [
      "empoisonner",
      0.055
    ],
    [
      "bassiner",
      0.055
    ],
    [
      "embarrasser",
      0.0375
    ],
    [
      "contrarier",
      0.0375
    ],
    [
      "agacer",
      0.0375
    ],
    [
      "enculer",
      0.0175
    ],
    [
      "emmouscailler",
      0.0175
    ],
    [
      "emmieller",
      0.0175
    ],
    [
      "embrener",
      0.0175
    ],
    [
      "conchier",
      0.0175
    ],
    [
      "assommer",
      0.0175
    ],
    [
      "incaguer",
      0.0175
    ]
  ],
  "emmerde": [
    [
      "ennuyer",
      0.2075
    ],
    [
      "embeter",
      0.1325
    ],
    [
      "barber",
      0.075
    ],
    [
      "turlupiner",
      0.055
    ],
    [
      "enquiquiner",
      0.055
    ],
    [
      "empoisonner",
      0.055
    ],
    [
      "bassiner",
      0.055
    ],
    [
      "embarrasser",
      0.0375
    ],
    [
      "contrarier",
      0.0375
    ],
    [
      "agacer",
      0.0375
    ],
    [
      "enculer",
      0.0175
    ],
    [
      "emmouscailler",
      0.0175
    ],
    [
      "emmieller",
      0.0175
    ],
    [
      "embrener",
      0.0175
    ],
    [
      "conchier",
      0.0175
    ],
    [
      "assommer",
      0.0175
    ],
    [
      "incaguer",
      0.0175
    ]
  ],
  "bord": [
    [
      "bordure",
      0.1275
    ],
    [
      "limite",
      0.0825
    ],
    [
      "lisiere",
      0.0625
    ],
    [
      "contour",
      0.045
    ],
    [
      "cote",
      0.045
    ],
    [
      "rivage",
      0.025
    ],
    [
      "peripherie",
      0.025
    ],
    [
      "cote",
      0.025
    ],
    [
      "borde",
      0.025
    ],
    [
      "marge",
      0.0175
    ],
    [
      "oree",
      0.0175
    ],
    [
      "ourlet",
      0.0175
    ],
    [
      "pays",
      0.0175
    ],
    [
      "pourtour",
      0.0175
    ],
    [
      "perimetre",
      0.0175
    ],
    [
      "rive",
      0.0175
    ],
    [
      "littoral",
      0.0175
    ],
    [
      "levee",
      0.0175
    ],
    [
      "frontiere",
      0.0175
    ],
    [
      "banquette",
      0.0175
    ],
    [
      "berge",
      0.0175
    ],
    [
      "bordage",
      0.0175
    ],
    [
      "cadre",
      0.0175
    ],
    [
      "commencement",
      0.0175
    ],
    [
      "extremite",
      0.0175
    ],
    [
      "frange",
      0.0175
    ],
    [
      "greve",
      0.0075
    ],
    [
      "limbe",
      0.0075
    ],
    [
      "levre",
      0.0075
    ],
    [
      "margelle",
      0.0075
    ],
    [
      "marli",
      0.0075
    ],
    [
      "rebord",
      0.0075
    ],
    [
      "seuil",
      0.0075
    ],
    [
      "fosse",
      0.0075
    ],
    [
      "flanc",
      0.0075
    ],
    [
      "entourage",
      0.0075
    ],
    [
      "encadrement",
      0.0075
    ],
    [
      "corniche",
      0.0075
    ],
    [
      "contree",
      0.0075
    ],
    [
      "bordee",
      0.0075
    ],
    [
      "arete",
      0.0075
    ],
    [
      "accotement",
      0.0075
    ],
    [
      "abord",
      0.0075
    ],
    [
      "tranche",
      0.0075
    ]
  ],
  "mer": [
    [
      "multitude",
      0.1875
    ],
    [
      "quantite",
      0.1575
    ],
    [
      "ocean",
      0.06
    ],
    [
      "masse",
      0.06
    ],
    [
      "fourmillement",
      0.06
    ],
    [
      "flots",
      0.06
    ],
    [
      "deluge",
      0.06
    ],
    [
      "abondance",
      0.06
    ],
    [
      "marine",
      0.03
    ],
    [
      "large",
      0.03
    ],
    [
      "fourmiliere",
      0.03
    ],
    [
      "fleuve",
      0.03
    ],
    [
      "essaim",
      0.03
    ],
    [
      "eaux",
      0.03
    ],
    [
      "baille",
      0.03
    ],
    [
      "onde",
      0.03
    ]
  ],
  "bye": [],
  "augmenter": [
    [
      "grossir",
      0.0675
    ],
    [
      "accroitre",
      0.0575
    ],
    [
      "grandir",
      0.035
    ],
    [
      "hausser",
      0.035
    ],
    [
      "exalter",
      0.0325
    ],
    [
      "agrandir",
      0.0325
    ],
    [
      "developper",
      0.0275
    ],
    [
      "amplifier",
      0.0275
    ],
    [
      "pousser",
      0.025
    ],
    [
      "croitre",
      0.0225
    ],
    [
      "elever",
      0.0225
    ],
    [
      "aggraver",
      0.0225
    ],
    [
      "monter",
      0.0225
    ],
    [
      "exciter",
      0.02
    ],
    [
      "exagerer",
      0.02
    ],
    [
      "enfler",
      0.02
    ],
    [
      "ajouter",
      0.02
    ],
    [
      "rencherir",
      0.0175
    ],
    [
      "etendre",
      0.0175
    ],
    [
      "multiplier",
      0.0175
    ],
    [
      "fortifier",
      0.015
    ],
    [
      "renforcer",
      0.015
    ],
    [
      "relever",
      0.015
    ],
    [
      "gonfler",
      0.015
    ],
    [
      "allonger",
      0.015
    ],
    [
      "rehausser",
      0.0125
    ],
    [
      "stimuler",
      0.0125
    ],
    [
      "enflammer",
      0.01
    ],
    [
      "remonter",
      0.01
    ],
    [
      "s'etendre",
      0.01
    ],
    [
      "intensifier",
      0.01
    ],
    [
      "forcer",
      0.01
    ],
    [
      "aviver",
      0.0075
    ],
    [
      "majorer",
      0.0075
    ],
    [
      "ranimer",
      0.0075
    ],
    [
      "revaloriser",
      0.005
    ],
    [
      "elargir",
      0.005
    ],
    [
      "redoubler",
      0.005
    ],
    [
      "accentuer",
      0.005
    ],
    [
      "s'accroitre",
      0.005
    ],
    [
      "ouvrir",
      0.005
    ],
    [
      "exacerber",
      0.005
    ],
    [
      "enrichir",
      0.005
    ],
    [
      "doubler",
      0.005
    ],
    [
      "charger",
      0.005
    ],
    [
      "aiguiser",
      0.005
    ],
    [
      "revigorer",
      0.0025
    ],
    [
      "rallonger",
      0.0025
    ],
    [
      "gagner",
      0.0025
    ],
    [
      "dilater",
      0.0025
    ],
    [
      "ameliorer",
      0.0025
    ],
    [
      "alourdir",
      0.0025
    ],
    [
      "etirer",
      0.0025
    ],
    [
      "s'elargir",
      0.0025
    ],
    [
      "prolonger",
      0.0025
    ],
    [
      "lever",
      0.0025
    ],
    [
      "exhausser",
      0.0025
    ],
    [
      "encherir",
      0.0025
    ],
    [
      "completer",
      0.0025
    ],
    [
      "arrondir",
      0.0025
    ],
    [
      "accelerer",
      0.0025
    ],
    [
      "s'amplifier",
      0.0
    ],
    [
      "surexciter",
      0.0
    ],
    [
      "transformer",
      0.0
    ],
    [
      "epaissir",
      0.0
    ],
    [
      "s'ajouter",
      0.0
    ],
    [
      "revivifier",
      0.0
    ],
    [
      "quadrupler",
      0.0
    ],
    [
      "irriter",
      0.0
    ],
    [
      "empirer",
      0.0
    ],
    [
      "distendre",
      0.0
    ],
    [
      "conforter",
      0.0
    ],
    [
      "approfondir",
      0.0
    ],
    [
      "s'intensifier",
      0.0
    ],
    [
      "surcharger",
      0.0
    ],
    [
      "surencherir",
      0.0
    ],
    [
      "surhausser",
      0.0
    ],
    [
      "valoriser",
      0.0
    ],
    [
      "s'enrichir",
      0.0
    ],
    [
      "s'agrandir",
      0.0
    ],
    [
      "s'aggraver",
      0.0
    ],
    [
      "additionner",
      0.0
    ],
    [
      "centupler",
      0.0
    ],
    [
      "continuer",
      0.0
    ],
    [
      "devenir",
      0.0
    ],
    [
      "foisonner",
      0.0
    ],
    [
      "s'accentuer",
      0.0
    ],
    [
      "s'arrondir",
      0.0
    ],
    [
      "s'enfler",
      0.0
    ],
    [
      "s'exasperer",
      0.0
    ],
    [
      "s'exciter",
      0.0
    ],
    [
      "s'elever",
      0.0
    ],
    [
      "tripler",
      0.0
    ],
    [
      "s'apprecier",
      0.0
    ],
    [
      "s'accuser",
      0.0
    ],
    [
      "renfler",
      0.0
    ],
    [
      "graduer",
      0.0
    ],
    [
      "decupler",
      0.0
    ],
    [
      "consolider",
      0.0
    ],
    [
      "affluer",
      0.0
    ],
    [
      "elonger",
      0.0
    ]
  ],
  "baiser": [
    [
      "caresse",
      0.165
    ],
    [
      "poutou",
      0.0825
    ],
    [
      "pelle",
      0.0825
    ],
    [
      "patin",
      0.0825
    ],
    [
      "galoche",
      0.0825
    ],
    [
      "embrassade",
      0.0825
    ],
    [
      "contact",
      0.0825
    ],
    [
      "becot",
      0.0825
    ],
    [
      "bisou",
      0.0825
    ],
    [
      "bise",
      0.0825
    ],
    [
      "sucon",
      0.0825
    ]
  ],
  "baise": [
    [
      "avoir",
      0.07
    ],
    [
      "becoter",
      0.07
    ],
    [
      "embrasser",
      0.07
    ],
    [
      "tromper",
      0.07
    ],
    [
      "rouler",
      0.0525
    ],
    [
      "posseder",
      0.0525
    ],
    [
      "caresser",
      0.0525
    ],
    [
      "s'accoupler",
      0.035
    ],
    [
      "forniquer",
      0.035
    ],
    [
      "entuber",
      0.035
    ],
    [
      "biser",
      0.035
    ],
    [
      "berner",
      0.035
    ],
    [
      "foutre",
      0.015
    ],
    [
      "niquer",
      0.015
    ],
    [
      "piger",
      0.015
    ],
    [
      "ramoner",
      0.015
    ],
    [
      "refaire",
      0.015
    ],
    [
      "enculer",
      0.015
    ],
    [
      "effleurer",
      0.015
    ],
    [
      "coucher",
      0.015
    ],
    [
      "biter",
      0.015
    ],
    [
      "bisouter",
      0.015
    ],
    [
      "baisoter",
      0.015
    ],
    [
      "accoler",
      0.015
    ],
    [
      "troncher",
      0.015
    ]
  ],
  "prohibe": [
    [
      "interdire",
      0.26
    ],
    [
      "defendre",
      0.1725
    ],
    [
      "empecher",
      0.13
    ],
    [
      "proscrire",
      0.13
    ],
    [
      "condamner",
      0.085
    ],
    [
      "exclure",
      0.085
    ],
    [
      "inhiber",
      0.085
    ],
    [
      "censurer",
      0.0425
    ]
  ],
  "prohiber": [
    [
      "interdire",
      0.26
    ],
    [
      "defendre",
      0.1725
    ],
    [
      "empecher",
      0.13
    ],
    [
      "proscrire",
      0.13
    ],
    [
      "condamner",
      0.085
    ],
    [
      "exclure",
      0.085
    ],
    [
      "inhiber",
      0.085
    ],
    [
      "censurer",
      0.0425
    ]
  ],
  "paye": [
    [
      "donner",
      0.0625
    ],
    [
      "rembourser",
      0.0425
    ],
    [
      "debourser",
      0.035
    ],
    [
      "regler",
      0.035
    ],
    [
      "retribuer",
      0.035
    ],
    [
      "verser",
      0.035
    ],
    [
      "remunerer",
      0.0275
    ],
    [
      "offrir",
      0.0275
    ],
    [
      "couvrir",
      0.0275
    ],
    [
      "servir",
      0.02
    ],
    [
      "salarier",
      0.02
    ],
    [
      "s'acquitter",
      0.02
    ],
    [
      "reparer",
      0.02
    ],
    [
      "indemniser",
      0.02
    ],
    [
      "financer",
      0.02
    ],
    [
      "depenser",
      0.02
    ],
    [
      "dedommager",
      0.02
    ],
    [
      "casquer",
      0.02
    ],
    [
      "avancer",
      0.02
    ],
    [
      "aligner",
      0.02
    ],
    [
      "acheter",
      0.02
    ],
    [
      "remettre",
      0.0125
    ],
    [
      "rendre",
      0.0125
    ],
    [
      "satisfaire",
      0.0125
    ],
    [
      "solder",
      0.0125
    ],
    [
      "soudoyer",
      0.0125
    ],
    [
      "racheter",
      0.0125
    ],
    [
      "desinteresser",
      0.0125
    ],
    [
      "acquitter",
      0.0125
    ],
    [
      "allonger",
      0.0125
    ],
    [
      "appointer",
      0.0125
    ],
    [
      "arroser",
      0.0125
    ],
    [
      "contenter",
      0.0125
    ],
    [
      "decaisser",
      0.0125
    ],
    [
      "defrayer",
      0.0125
    ],
    [
      "raquer",
      0.005
    ],
    [
      "recompenser",
      0.005
    ],
    [
      "regaler",
      0.005
    ],
    [
      "souscrire",
      0.005
    ],
    [
      "stipendier",
      0.005
    ],
    [
      "subir",
      0.005
    ],
    [
      "suer",
      0.005
    ],
    [
      "virer",
      0.005
    ],
    [
      "eclairer",
      0.005
    ],
    [
      "rapporter",
      0.005
    ],
    [
      "punir",
      0.005
    ],
    [
      "ordonnancer",
      0.005
    ],
    [
      "compter",
      0.005
    ],
    [
      "corrompre",
      0.005
    ],
    [
      "cracher",
      0.005
    ],
    [
      "douiller",
      0.005
    ],
    [
      "depocher",
      0.005
    ],
    [
      "expier",
      0.005
    ],
    [
      "foncer",
      0.005
    ],
    [
      "gager",
      0.005
    ],
    [
      "liquider",
      0.005
    ],
    [
      "mandater",
      0.005
    ],
    [
      "ecoper",
      0.005
    ]
  ],
  "bayer": [
    [
      "rever",
      0.25
    ],
    [
      "badauder",
      0.125
    ],
    [
      "bader",
      0.125
    ],
    [
      "bailler",
      0.125
    ],
    [
      "beer",
      0.125
    ],
    [
      "revasser",
      0.125
    ]
  ],
  "brise": [
    [
      "detruire",
      0.0725
    ],
    [
      "aneantir",
      0.0575
    ],
    [
      "abattre",
      0.055
    ],
    [
      "casser",
      0.045
    ],
    [
      "ecraser",
      0.0425
    ],
    [
      "rompre",
      0.04
    ],
    [
      "broyer",
      0.04
    ],
    [
      "fatiguer",
      0.04
    ],
    [
      "demolir",
      0.035
    ],
    [
      "epuiser",
      0.0275
    ],
    [
      "ruiner",
      0.0275
    ],
    [
      "ereinter",
      0.025
    ],
    [
      "accabler",
      0.02
    ],
    [
      "pulveriser",
      0.02
    ],
    [
      "affaiblir",
      0.0175
    ],
    [
      "battre",
      0.0175
    ],
    [
      "supprimer",
      0.0175
    ],
    [
      "extenuer",
      0.015
    ],
    [
      "esquinter",
      0.015
    ],
    [
      "couper",
      0.015
    ],
    [
      "degrader",
      0.015
    ],
    [
      "arreter",
      0.0125
    ],
    [
      "enfoncer",
      0.01
    ],
    [
      "dechirer",
      0.01
    ],
    [
      "etouffer",
      0.01
    ],
    [
      "triturer",
      0.01
    ],
    [
      "renverser",
      0.01
    ],
    [
      "forcer",
      0.01
    ],
    [
      "deteriorer",
      0.01
    ],
    [
      "deprimer",
      0.01
    ],
    [
      "demanteler",
      0.01
    ],
    [
      "decourager",
      0.01
    ],
    [
      "dissoudre",
      0.0075
    ],
    [
      "trancher",
      0.0075
    ],
    [
      "reduire",
      0.0075
    ],
    [
      "foudroyer",
      0.0075
    ],
    [
      "aplatir",
      0.0075
    ],
    [
      "annihiler",
      0.0075
    ],
    [
      "surmener",
      0.005
    ],
    [
      "moudre",
      0.005
    ],
    [
      "harasser",
      0.005
    ],
    [
      "hacher",
      0.005
    ],
    [
      "fracasser",
      0.005
    ],
    [
      "endommager",
      0.005
    ],
    [
      "demantibuler",
      0.005
    ],
    [
      "defoncer",
      0.005
    ],
    [
      "disloquer",
      0.005
    ],
    [
      "bouleverser",
      0.005
    ],
    [
      "bigorner",
      0.005
    ],
    [
      "lasser",
      0.0025
    ],
    [
      "interrompre",
      0.0025
    ],
    [
      "infirmer",
      0.0025
    ],
    [
      "fendre",
      0.0025
    ],
    [
      "dompter",
      0.0025
    ],
    [
      "concasser",
      0.0025
    ],
    [
      "affliger",
      0.0025
    ],
    [
      "emouvoir",
      0.0025
    ],
    [
      "ebrecher",
      0.0025
    ],
    [
      "torpiller",
      0.0025
    ],
    [
      "mutiler",
      0.0025
    ],
    [
      "fracturer",
      0.0025
    ],
    [
      "effondrer",
      0.0025
    ],
    [
      "demoraliser",
      0.0025
    ],
    [
      "harceler",
      0.0
    ],
    [
      "enrayer",
      0.0
    ],
    [
      "enfreindre",
      0.0
    ],
    [
      "depasser",
      0.0
    ],
    [
      "demancher",
      0.0
    ],
    [
      "desceller",
      0.0
    ],
    [
      "comminuer",
      0.0
    ]
  ],
  "briser": [
    [
      "detruire",
      0.0725
    ],
    [
      "aneantir",
      0.0575
    ],
    [
      "abattre",
      0.055
    ],
    [
      "casser",
      0.045
    ],
    [
      "ecraser",
      0.0425
    ],
    [
      "rompre",
      0.04
    ],
    [
      "broyer",
      0.04
    ],
    [
      "fatiguer",
      0.04
    ],
    [
      "demolir",
      0.035
    ],
    [
      "epuiser",
      0.0275
    ],
    [
      "ruiner",
      0.0275
    ],
    [
      "ereinter",
      0.025
    ],
    [
      "accabler",
      0.02
    ],
    [
      "pulveriser",
      0.02
    ],
    [
      "affaiblir",
      0.0175
    ],
    [
      "battre",
      0.0175
    ],
    [
      "supprimer",
      0.0175
    ],
    [
      "extenuer",
      0.015
    ],
    [
      "esquinter",
      0.015
    ],
    [
      "couper",
      0.015
    ],
    [
      "degrader",
      0.015
    ],
    [
      "arreter",
      0.0125
    ],
    [
      "enfoncer",
      0.01
    ],
    [
      "dechirer",
      0.01
    ],
    [
      "etouffer",
      0.01
    ],
    [
      "triturer",
      0.01
    ],
    [
      "renverser",
      0.01
    ],
    [
      "forcer",
      0.01
    ],
    [
      "deteriorer",
      0.01
    ],
    [
      "deprimer",
      0.01
    ],
    [
      "demanteler",
      0.01
    ],
    [
      "decourager",
      0.01
    ],
    [
      "dissoudre",
      0.0075
    ],
    [
      "trancher",
      0.0075
    ],
    [
      "reduire",
      0.0075
    ],
    [
      "foudroyer",
      0.0075
    ],
    [
      "aplatir",
      0.0075
    ],
    [
      "annihiler",
      0.0075
    ],
    [
      "surmener",
      0.005
    ],
    [
      "moudre",
      0.005
    ],
    [
      "harasser",
      0.005
    ],
    [
      "hacher",
      0.005
    ],
    [
      "fracasser",
      0.005
    ],
    [
      "endommager",
      0.005
    ],
    [
      "demantibuler",
      0.005
    ],
    [
      "defoncer",
      0.005
    ],
    [
      "disloquer",
      0.005
    ],
    [
      "bouleverser",
      0.005
    ],
    [
      "bigorner",
      0.005
    ],
    [
      "lasser",
      0.0025
    ],
    [
      "interrompre",
      0.0025
    ],
    [
      "infirmer",
      0.0025
    ],
    [
      "fendre",
      0.0025
    ],
    [
      "dompter",
      0.0025
    ],
    [
      "concasser",
      0.0025
    ],
    [
      "affliger",
      0.0025
    ],
    [
      "emouvoir",
      0.0025
    ],
    [
      "ebrecher",
      0.0025
    ],
    [
      "torpiller",
      0.0025
    ],
    [
      "mutiler",
      0.0025
    ],
    [
      "fracturer",
      0.0025
    ],
    [
      "effondrer",
      0.0025
    ],
    [
      "demoraliser",
      0.0025
    ],
    [
      "harceler",
      0.0
    ],
    [
      "enrayer",
      0.0
    ],
    [
      "enfreindre",
      0.0
    ],
    [
      "depasser",
      0.0
    ],
    [
      "demancher",
      0.0
    ],
    [
      "desceller",
      0.0
    ],
    [
      "comminuer",
      0.0
    ]
  ],
  "vitrer": [],
  "vitre": [
    [
      "carreau",
      0.125
    ],
    [
      "fenetre",
      0.125
    ],
    [
      "verre",
      0.125
    ],
    [
      "vitrine",
      0.125
    ],
    [
      "etalage",
      0.125
    ],
    [
      "montre",
      0.06
    ],
    [
      "lunette",
      0.06
    ],
    [
      "glace",
      0.06
    ],
    [
      "devanture",
      0.06
    ],
    [
      "vitrage",
      0.06
    ]
  ],
  "fringuer": [
    [
      "habiller",
      0.205
    ],
    [
      "accoutrer",
      0.12
    ],
    [
      "deguiser",
      0.085
    ],
    [
      "vetir",
      0.085
    ],
    [
      "affubler",
      0.06
    ],
    [
      "fagoter",
      0.0475
    ],
    [
      "ficeler",
      0.035
    ],
    [
      "couvrir",
      0.035
    ],
    [
      "costumer",
      0.035
    ],
    [
      "attifer",
      0.035
    ],
    [
      "arranger",
      0.035
    ],
    [
      "travestir",
      0.0225
    ],
    [
      "frusquer",
      0.0225
    ],
    [
      "envelopper",
      0.0225
    ],
    [
      "endimancher",
      0.0225
    ],
    [
      "ajuster",
      0.0225
    ],
    [
      "sautiller",
      0.01
    ],
    [
      "sauter",
      0.01
    ],
    [
      "saper",
      0.01
    ],
    [
      "nipper",
      0.01
    ],
    [
      "gambader",
      0.01
    ],
    [
      "draper",
      0.01
    ],
    [
      "arnaquer",
      0.01
    ],
    [
      "equiper",
      0.01
    ]
  ],
  "fringue": [
    [
      "habiller",
      0.205
    ],
    [
      "accoutrer",
      0.12
    ],
    [
      "deguiser",
      0.085
    ],
    [
      "vetir",
      0.085
    ],
    [
      "affubler",
      0.06
    ],
    [
      "fagoter",
      0.0475
    ],
    [
      "ficeler",
      0.035
    ],
    [
      "couvrir",
      0.035
    ],
    [
      "costumer",
      0.035
    ],
    [
      "attifer",
      0.035
    ],
    [
      "arranger",
      0.035
    ],
    [
      "travestir",
      0.0225
    ],
    [
      "frusquer",
      0.0225
    ],
    [
      "envelopper",
      0.0225
    ],
    [
      "endimancher",
      0.0225
    ],
    [
      "ajuster",
      0.0225
    ],
    [
      "sautiller",
      0.01
    ],
    [
      "sauter",
      0.01
    ],
    [
      "saper",
      0.01
    ],
    [
      "nipper",
      0.01
    ],
    [
      "gambader",
      0.01
    ],
    [
      "draper",
      0.01
    ],
    [
      "arnaquer",
      0.01
    ],
    [
      "equiper",
      0.01
    ]
  ],
  "bosser": [
    [
      "boulonner",
      0.1425
    ],
    [
      "bucher",
      0.1425
    ],
    [
      "travailler",
      0.1425
    ],
    [
      "turbiner",
      0.1425
    ],
    [
      "tapiner",
      0.045
    ],
    [
      "piocher",
      0.045
    ],
    [
      "bosseler",
      0.045
    ],
    [
      "attacher",
      0.045
    ],
    [
      "trimer",
      0.045
    ]
  ],
  "bosse": [
    [
      "protuberance",
      0.055
    ],
    [
      "saillie",
      0.055
    ],
    [
      "eminence",
      0.0375
    ],
    [
      "tumeur",
      0.0375
    ],
    [
      "grosseur",
      0.0375
    ],
    [
      "enflure",
      0.0375
    ],
    [
      "coup",
      0.0375
    ],
    [
      "cordage",
      0.0375
    ],
    [
      "beigne",
      0.0375
    ],
    [
      "torgnole",
      0.0275
    ],
    [
      "renflement",
      0.0275
    ],
    [
      "proeminence",
      0.0275
    ],
    [
      "gibbosite",
      0.0275
    ],
    [
      "bombement",
      0.0275
    ],
    [
      "apostume",
      0.0275
    ],
    [
      "elevation",
      0.0175
    ],
    [
      "relief",
      0.0175
    ],
    [
      "monticule",
      0.0175
    ],
    [
      "irregularite",
      0.0175
    ],
    [
      "figure",
      0.0175
    ],
    [
      "excroissance",
      0.0175
    ],
    [
      "disposition",
      0.0175
    ],
    [
      "convexite",
      0.0175
    ],
    [
      "capacite",
      0.0175
    ],
    [
      "blessure",
      0.0175
    ],
    [
      "garant",
      0.0075
    ],
    [
      "festin",
      0.0075
    ],
    [
      "decoration",
      0.0075
    ],
    [
      "don",
      0.0075
    ],
    [
      "cyphose",
      0.0075
    ],
    [
      "genie",
      0.0075
    ],
    [
      "hauteur",
      0.0075
    ],
    [
      "image",
      0.0075
    ],
    [
      "inegalite",
      0.0075
    ],
    [
      "saisine",
      0.0075
    ],
    [
      "suspense",
      0.0075
    ],
    [
      "talent",
      0.0075
    ],
    [
      "elevure",
      0.0075
    ],
    [
      "contusion",
      0.0075
    ],
    [
      "cabosse",
      0.0075
    ],
    [
      "apophyse",
      0.0075
    ],
    [
      "aptitude",
      0.0075
    ],
    [
      "arrondi",
      0.0075
    ],
    [
      "beignet",
      0.0075
    ],
    [
      "bigne",
      0.0075
    ],
    [
      "bossage",
      0.0075
    ],
    [
      "bosselage",
      0.0075
    ],
    [
      "bosselure",
      0.0075
    ],
    [
      "bossette",
      0.0075
    ],
    [
      "boudine",
      0.0075
    ],
    [
      "bouffissure",
      0.0075
    ],
    [
      "butte",
      0.0075
    ],
    [
      "agui",
      0.0075
    ]
  ],
  "dingue": [
    [
      "fou",
      0.1925
    ],
    [
      "cingle",
      0.1225
    ],
    [
      "pique",
      0.11
    ],
    [
      "dingo",
      0.08
    ],
    [
      "toque",
      0.08
    ],
    [
      "timbre",
      0.0525
    ],
    [
      "insense",
      0.0525
    ],
    [
      "aliene",
      0.0525
    ],
    [
      "ecervele",
      0.025
    ],
    [
      "hurluberlu",
      0.025
    ],
    [
      "dement",
      0.025
    ],
    [
      "barjo",
      0.025
    ],
    [
      "absurde",
      0.025
    ],
    [
      "malade",
      0.0125
    ],
    [
      "jete",
      0.0125
    ],
    [
      "givre",
      0.0125
    ],
    [
      "fondu",
      0.0125
    ],
    [
      "folingue",
      0.0125
    ],
    [
      "cintre",
      0.0125
    ],
    [
      "branquignol",
      0.0125
    ],
    [
      "super",
      0.0125
    ]
  ],
  "coup": [
    [
      "torgnole",
      0.1275
    ],
    [
      "volee",
      0.0425
    ],
    [
      "raclee",
      0.035
    ],
    [
      "blessure",
      0.0325
    ],
    [
      "choc",
      0.0325
    ],
    [
      "roulee",
      0.0275
    ],
    [
      "beigne",
      0.025
    ],
    [
      "atteinte",
      0.025
    ],
    [
      "attaque",
      0.025
    ],
    [
      "gifle",
      0.02
    ],
    [
      "soufflet",
      0.0175
    ],
    [
      "talmouse",
      0.0175
    ],
    [
      "heurt",
      0.0125
    ],
    [
      "correction",
      0.0125
    ],
    [
      "calotte",
      0.0125
    ],
    [
      "bleu",
      0.0125
    ],
    [
      "bruit",
      0.01
    ],
    [
      "rossee",
      0.01
    ],
    [
      "trait",
      0.01
    ],
    [
      "injure",
      0.0075
    ],
    [
      "outrage",
      0.0075
    ],
    [
      "poussee",
      0.0075
    ],
    [
      "tort",
      0.0075
    ],
    [
      "tour",
      0.0075
    ],
    [
      "impact",
      0.0075
    ],
    [
      "fessee",
      0.0075
    ],
    [
      "contusion",
      0.0075
    ],
    [
      "claque",
      0.0075
    ],
    [
      "chataigne",
      0.0075
    ],
    [
      "charge",
      0.0075
    ],
    [
      "bosse",
      0.0075
    ],
    [
      "action",
      0.0075
    ],
    [
      "punition",
      0.005
    ],
    [
      "tape",
      0.005
    ],
    [
      "tarte",
      0.005
    ],
    [
      "trempe",
      0.005
    ],
    [
      "echauffouree",
      0.005
    ],
    [
      "epreuve",
      0.005
    ],
    [
      "pile",
      0.005
    ],
    [
      "meurtrissure",
      0.005
    ],
    [
      "accident",
      0.005
    ],
    [
      "battement",
      0.005
    ],
    [
      "botte",
      0.005
    ],
    [
      "combine",
      0.005
    ],
    [
      "commotion",
      0.005
    ],
    [
      "dommage",
      0.005
    ],
    [
      "offense",
      0.0025
    ],
    [
      "melee",
      0.0025
    ],
    [
      "mornifle",
      0.0025
    ],
    [
      "marron",
      0.0025
    ],
    [
      "malheur",
      0.0025
    ],
    [
      "gorgee",
      0.0025
    ],
    [
      "peignee",
      0.0025
    ],
    [
      "salve",
      0.0025
    ],
    [
      "secousse",
      0.0025
    ],
    [
      "sevices",
      0.0025
    ],
    [
      "taloche",
      0.0025
    ],
    [
      "tournee",
      0.0025
    ],
    [
      "truc",
      0.0025
    ],
    [
      "verre",
      0.0025
    ],
    [
      "elan",
      0.0025
    ],
    [
      "giboulee",
      0.0025
    ],
    [
      "frappement",
      0.0025
    ],
    [
      "estocade",
      0.0025
    ],
    [
      "astuce",
      0.0025
    ],
    [
      "baffe",
      0.0025
    ],
    [
      "bagarre",
      0.0025
    ],
    [
      "baston",
      0.0025
    ],
    [
      "bastonnade",
      0.0025
    ],
    [
      "beignet",
      0.0025
    ],
    [
      "bourrade",
      0.0025
    ],
    [
      "castagne",
      0.0025
    ],
    [
      "catastrophe",
      0.0025
    ],
    [
      "entreprise",
      0.0025
    ],
    [
      "engagement",
      0.0025
    ],
    [
      "ecchymose",
      0.0025
    ],
    [
      "degelee",
      0.0025
    ],
    [
      "danse",
      0.0025
    ],
    [
      "coquard",
      0.0025
    ],
    [
      "chatiment",
      0.0025
    ],
    [
      "prejudice",
      0.0
    ],
    [
      "ramponneau",
      0.0
    ],
    [
      "ratatouille",
      0.0
    ],
    [
      "renfoncement",
      0.0
    ],
    [
      "rincee",
      0.0
    ],
    [
      "rouste",
      0.0
    ],
    [
      "point",
      0.0
    ],
    [
      "pochon",
      0.0
    ],
    [
      "pichenette",
      0.0
    ],
    [
      "percussion",
      0.0
    ],
    [
      "pain",
      0.0
    ],
    [
      "lampee",
      0.0
    ],
    [
      "jet",
      0.0
    ],
    [
      "horion",
      0.0
    ],
    [
      "saisissement",
      0.0
    ],
    [
      "sanglade",
      0.0
    ],
    [
      "eclat",
      0.0
    ],
    [
      "ebranlement",
      0.0
    ],
    [
      "tripotee",
      0.0
    ],
    [
      "tir",
      0.0
    ],
    [
      "tatouille",
      0.0
    ],
    [
      "taquet",
      0.0
    ],
    [
      "tannee",
      0.0
    ],
    [
      "tamponnement",
      0.0
    ],
    [
      "tampon",
      0.0
    ],
    [
      "tabac",
      0.0
    ],
    [
      "sevice",
      0.0
    ],
    [
      "son",
      0.0
    ],
    [
      "emotion",
      0.0
    ],
    [
      "hasard",
      0.0
    ],
    [
      "canonnade",
      0.0
    ],
    [
      "canon",
      0.0
    ],
    [
      "bafre",
      0.0
    ],
    [
      "but",
      0.0
    ],
    [
      "brulee",
      0.0
    ],
    [
      "brossee",
      0.0
    ],
    [
      "branlee",
      0.0
    ],
    [
      "bigne",
      0.0
    ],
    [
      "avoine",
      0.0
    ],
    [
      "atout",
      0.0
    ],
    [
      "arquebusade",
      0.0
    ],
    [
      "anguillade",
      0.0
    ],
    [
      "agiotage",
      0.0
    ],
    [
      "chiquenaude",
      0.0
    ],
    [
      "contredanse",
      0.0
    ],
    [
      "gourmade",
      0.0
    ],
    [
      "goulee",
      0.0
    ],
    [
      "gnon",
      0.0
    ],
    [
      "giroflee",
      0.0
    ],
    [
      "fusillade",
      0.0
    ],
    [
      "frolement",
      0.0
    ],
    [
      "frottee",
      0.0
    ],
    [
      "fois",
      0.0
    ],
    [
      "escourgee",
      0.0
    ],
    [
      "derouillee",
      0.0
    ],
    [
      "deculottee",
      0.0
    ],
    [
      "distribution",
      0.0
    ],
    [
      "abattage",
      0.0
    ]
  ],
  "liasse": [
    [
      "tas",
      0.5
    ],
    [
      "amas",
      0.25
    ],
    [
      "botte",
      0.25
    ]
  ],
  "enveloppe": [
    [
      "peau",
      0.055
    ],
    [
      "cosse",
      0.045
    ],
    [
      "etui",
      0.035
    ],
    [
      "ecorce",
      0.035
    ],
    [
      "sac",
      0.035
    ],
    [
      "robe",
      0.035
    ],
    [
      "protection",
      0.035
    ],
    [
      "ecale",
      0.025
    ],
    [
      "revetement",
      0.025
    ],
    [
      "manteau",
      0.025
    ],
    [
      "fourreau",
      0.025
    ],
    [
      "cuirasse",
      0.025
    ],
    [
      "contenant",
      0.025
    ],
    [
      "chape",
      0.025
    ],
    [
      "carapace",
      0.025
    ],
    [
      "housse",
      0.0175
    ],
    [
      "pellicule",
      0.0175
    ],
    [
      "test",
      0.0175
    ],
    [
      "trousse",
      0.0175
    ],
    [
      "vetement",
      0.0175
    ],
    [
      "ecaille",
      0.0175
    ],
    [
      "gaine",
      0.0175
    ],
    [
      "emballage",
      0.0175
    ],
    [
      "balle",
      0.0175
    ],
    [
      "bogue",
      0.0175
    ],
    [
      "bourse",
      0.0175
    ],
    [
      "brou",
      0.0175
    ],
    [
      "coquille",
      0.0175
    ],
    [
      "couvercle",
      0.0175
    ],
    [
      "plevre",
      0.0075
    ],
    [
      "portefeuille",
      0.0075
    ],
    [
      "pericarde",
      0.0075
    ],
    [
      "pericarpe",
      0.0075
    ],
    [
      "peritoine",
      0.0075
    ],
    [
      "symbole",
      0.0075
    ],
    [
      "tunique",
      0.0075
    ],
    [
      "tegument",
      0.0075
    ],
    [
      "voile",
      0.0075
    ],
    [
      "zeste",
      0.0075
    ],
    [
      "ecrin",
      0.0075
    ],
    [
      "epicarpe",
      0.0075
    ],
    [
      "membrane",
      0.0075
    ],
    [
      "gratification",
      0.0075
    ],
    [
      "gousse",
      0.0075
    ],
    [
      "atmosphere",
      0.0075
    ],
    [
      "bale",
      0.0075
    ],
    [
      "cadre",
      0.0075
    ],
    [
      "calice",
      0.0075
    ],
    [
      "capsule",
      0.0075
    ],
    [
      "chair",
      0.0075
    ],
    [
      "courbe",
      0.0075
    ],
    [
      "cupule",
      0.0075
    ],
    [
      "endocarpe",
      0.0075
    ],
    [
      "exterieur",
      0.0075
    ],
    [
      "gangue",
      0.0075
    ],
    [
      "garniture",
      0.0075
    ],
    [
      "epiderme",
      0.0075
    ]
  ],
  "envelopper": [
    [
      "entourer",
      0.07
    ],
    [
      "cerner",
      0.055
    ],
    [
      "couvrir",
      0.05
    ],
    [
      "entortiller",
      0.0425
    ],
    [
      "masquer",
      0.0375
    ],
    [
      "encercler",
      0.035
    ],
    [
      "deguiser",
      0.035
    ],
    [
      "emprisonner",
      0.0275
    ],
    [
      "recouvrir",
      0.0275
    ],
    [
      "investir",
      0.0225
    ],
    [
      "enserrer",
      0.0225
    ],
    [
      "emmailloter",
      0.0225
    ],
    [
      "cacher",
      0.0225
    ],
    [
      "assieger",
      0.0225
    ],
    [
      "voiler",
      0.0175
    ],
    [
      "rouler",
      0.0175
    ],
    [
      "revetir",
      0.0175
    ],
    [
      "habiller",
      0.0175
    ],
    [
      "enrober",
      0.0175
    ],
    [
      "empaqueter",
      0.0175
    ],
    [
      "emmitoufler",
      0.0175
    ],
    [
      "emballer",
      0.0175
    ],
    [
      "circonvenir",
      0.0175
    ],
    [
      "ceindre",
      0.0175
    ],
    [
      "attacher",
      0.0175
    ],
    [
      "tromper",
      0.015
    ],
    [
      "environner",
      0.015
    ],
    [
      "enrouler",
      0.015
    ],
    [
      "dissimuler",
      0.015
    ],
    [
      "tapisser",
      0.01
    ],
    [
      "farder",
      0.01
    ],
    [
      "entrainer",
      0.01
    ],
    [
      "draper",
      0.01
    ],
    [
      "bander",
      0.01
    ],
    [
      "ouater",
      0.0075
    ],
    [
      "inclure",
      0.0075
    ],
    [
      "impliquer",
      0.0075
    ],
    [
      "fringuer",
      0.0075
    ],
    [
      "fourrer",
      0.0075
    ],
    [
      "englober",
      0.0075
    ],
    [
      "emmitonner",
      0.0075
    ],
    [
      "embobeliner",
      0.0075
    ],
    [
      "attaquer",
      0.0075
    ],
    [
      "bloquer",
      0.0075
    ],
    [
      "camoufler",
      0.0075
    ],
    [
      "ceinturer",
      0.0075
    ],
    [
      "comprendre",
      0.0075
    ],
    [
      "symboliser",
      0.0025
    ],
    [
      "resserrer",
      0.0025
    ],
    [
      "obscurcir",
      0.0025
    ],
    [
      "nouer",
      0.0025
    ],
    [
      "gagner",
      0.0025
    ],
    [
      "enjoler",
      0.0025
    ],
    [
      "engoncer",
      0.0025
    ],
    [
      "endormir",
      0.0025
    ],
    [
      "chambrer",
      0.0025
    ],
    [
      "baigner",
      0.0025
    ],
    [
      "edulcorer",
      0.0025
    ]
  ],
  "enlever": [
    [
      "oter",
      0.0925
    ],
    [
      "prendre",
      0.0525
    ],
    [
      "retirer",
      0.045
    ],
    [
      "retrancher",
      0.0325
    ],
    [
      "supprimer",
      0.03
    ],
    [
      "arracher",
      0.025
    ],
    [
      "soustraire",
      0.025
    ],
    [
      "voler",
      0.025
    ],
    [
      "depouiller",
      0.02
    ],
    [
      "emporter",
      0.02
    ],
    [
      "couper",
      0.02
    ],
    [
      "ravir",
      0.0175
    ],
    [
      "debarrasser",
      0.0175
    ],
    [
      "derober",
      0.0175
    ],
    [
      "tirer",
      0.015
    ],
    [
      "gagner",
      0.015
    ],
    [
      "detruire",
      0.015
    ],
    [
      "degager",
      0.0125
    ],
    [
      "detacher",
      0.0125
    ],
    [
      "extraire",
      0.0125
    ],
    [
      "s'emparer",
      0.0125
    ],
    [
      "transporter",
      0.0125
    ],
    [
      "s'approprier",
      0.01
    ],
    [
      "separer",
      0.01
    ],
    [
      "entrainer",
      0.01
    ],
    [
      "effacer",
      0.01
    ],
    [
      "lever",
      0.01
    ],
    [
      "rafler",
      0.0075
    ],
    [
      "priver",
      0.0075
    ],
    [
      "obtenir",
      0.0075
    ],
    [
      "extirper",
      0.0075
    ],
    [
      "conquerir",
      0.0075
    ],
    [
      "attraper",
      0.0075
    ],
    [
      "soulever",
      0.0075
    ],
    [
      "gratter",
      0.0075
    ],
    [
      "exciter",
      0.0075
    ],
    [
      "detourner",
      0.0075
    ],
    [
      "deposseder",
      0.0075
    ],
    [
      "eliminer",
      0.005
    ],
    [
      "sortir",
      0.005
    ],
    [
      "sevrer",
      0.005
    ],
    [
      "quitter",
      0.005
    ],
    [
      "monter",
      0.005
    ],
    [
      "forcer",
      0.005
    ],
    [
      "defaire",
      0.005
    ],
    [
      "distraire",
      0.005
    ],
    [
      "aneantir",
      0.005
    ],
    [
      "spolier",
      0.005
    ],
    [
      "souffler",
      0.005
    ],
    [
      "remporter",
      0.005
    ],
    [
      "prelever",
      0.005
    ],
    [
      "frustrer",
      0.005
    ],
    [
      "faucher",
      0.005
    ],
    [
      "diminuer",
      0.005
    ],
    [
      "emballer",
      0.005
    ],
    [
      "deplacer",
      0.005
    ],
    [
      "demunir",
      0.005
    ],
    [
      "decharger",
      0.005
    ],
    [
      "chiper",
      0.005
    ],
    [
      "charmer",
      0.005
    ],
    [
      "barrer",
      0.005
    ],
    [
      "accaparer",
      0.005
    ],
    [
      "plumer",
      0.0025
    ],
    [
      "ramasser",
      0.0025
    ],
    [
      "ratisser",
      0.0025
    ],
    [
      "vider",
      0.0025
    ],
    [
      "elaguer",
      0.0025
    ],
    [
      "occuper",
      0.0025
    ],
    [
      "enflammer",
      0.0025
    ],
    [
      "emmener",
      0.0025
    ],
    [
      "biffer",
      0.0025
    ],
    [
      "confisquer",
      0.0025
    ],
    [
      "decrocher",
      0.0025
    ],
    [
      "deraciner",
      0.0025
    ],
    [
      "effeuiller",
      0.0025
    ],
    [
      "embarquer",
      0.0025
    ],
    [
      "enthousiasmer",
      0.0025
    ],
    [
      "jouer",
      0.0025
    ],
    [
      "kidnapper",
      0.0025
    ],
    [
      "laver",
      0.0025
    ],
    [
      "peler",
      0.0025
    ],
    [
      "remmener",
      0.0025
    ],
    [
      "engueuler",
      0.0025
    ],
    [
      "deposer",
      0.0025
    ],
    [
      "accrocher",
      0.0025
    ],
    [
      "accumuler",
      0.0025
    ],
    [
      "amputer",
      0.0025
    ],
    [
      "decouvrir",
      0.0025
    ],
    [
      "deduire",
      0.0025
    ],
    [
      "demenager",
      0.0025
    ],
    [
      "elever",
      0.0
    ],
    [
      "tancer",
      0.0
    ],
    [
      "reprimander",
      0.0
    ],
    [
      "racler",
      0.0
    ],
    [
      "gommer",
      0.0
    ],
    [
      "excepter",
      0.0
    ],
    [
      "envahir",
      0.0
    ],
    [
      "denicher",
      0.0
    ],
    [
      "injurier",
      0.0
    ],
    [
      "razzier",
      0.0
    ],
    [
      "rifler",
      0.0
    ],
    [
      "resequer",
      0.0
    ],
    [
      "hisser",
      0.0
    ],
    [
      "devisser",
      0.0
    ],
    [
      "defalquer",
      0.0
    ],
    [
      "decoller",
      0.0
    ],
    [
      "declouer",
      0.0
    ],
    [
      "desservir",
      0.0
    ],
    [
      "desceller",
      0.0
    ],
    [
      "charrier",
      0.0
    ],
    [
      "trousser",
      0.0
    ]
  ],
  "attitude": [
    [
      "air",
      0.1025
    ],
    [
      "allure",
      0.085
    ],
    [
      "comportement",
      0.0525
    ],
    [
      "exterieur",
      0.0525
    ],
    [
      "tenue",
      0.0525
    ],
    [
      "maintien",
      0.0475
    ],
    [
      "figure",
      0.0475
    ],
    [
      "contenance",
      0.0475
    ],
    [
      "genre",
      0.04
    ],
    [
      "visage",
      0.04
    ],
    [
      "conduite",
      0.035
    ],
    [
      "aspect",
      0.0325
    ],
    [
      "demarche",
      0.025
    ],
    [
      "position",
      0.025
    ],
    [
      "disposition",
      0.0225
    ],
    [
      "posture",
      0.0225
    ],
    [
      "degaine",
      0.02
    ],
    [
      "geste",
      0.02
    ],
    [
      "type",
      0.015
    ],
    [
      "trait",
      0.015
    ],
    [
      "physionomie",
      0.015
    ],
    [
      "manieres",
      0.015
    ],
    [
      "dehors",
      0.015
    ],
    [
      "expression",
      0.0125
    ],
    [
      "situation",
      0.01
    ],
    [
      "pose",
      0.01
    ],
    [
      "port",
      0.01
    ],
    [
      "orientation",
      0.01
    ],
    [
      "mouvement",
      0.01
    ],
    [
      "affectation",
      0.01
    ],
    [
      "etat",
      0.005
    ],
    [
      "tendance",
      0.005
    ],
    [
      "mime",
      0.005
    ],
    [
      "equilibre",
      0.0025
    ],
    [
      "station",
      0.0025
    ],
    [
      "reaction",
      0.0025
    ],
    [
      "procede",
      0.0025
    ],
    [
      "particularisme",
      0.0025
    ],
    [
      "humeur",
      0.0025
    ],
    [
      "habitude",
      0.0025
    ],
    [
      "front",
      0.0025
    ],
    [
      "decision",
      0.0025
    ],
    [
      "etude",
      0.0025
    ]
  ],
  "rene": [
    [
      "bride",
      0.1875
    ],
    [
      "licol",
      0.1875
    ],
    [
      "courroie",
      0.125
    ],
    [
      "guide",
      0.125
    ],
    [
      "laniere",
      0.125
    ],
    [
      "licou",
      0.125
    ],
    [
      "bridon",
      0.06
    ],
    [
      "chevetre",
      0.06
    ]
  ],
  "ami": [
    [
      "camarade",
      0.0925
    ],
    [
      "amoureux",
      0.05
    ],
    [
      "compagnon",
      0.05
    ],
    [
      "copain",
      0.05
    ],
    [
      "flirt",
      0.04
    ],
    [
      "cheri",
      0.04
    ],
    [
      "propice",
      0.03
    ],
    [
      "partenaire",
      0.03
    ],
    [
      "familier",
      0.03
    ],
    [
      "compere",
      0.03
    ],
    [
      "beau",
      0.03
    ],
    [
      "amical",
      0.03
    ],
    [
      "amant",
      0.03
    ],
    [
      "allie",
      0.03
    ],
    [
      "relation",
      0.02
    ],
    [
      "pote",
      0.02
    ],
    [
      "intime",
      0.02
    ],
    [
      "frere",
      0.02
    ],
    [
      "favorable",
      0.02
    ],
    [
      "cousin",
      0.02
    ],
    [
      "connaissance",
      0.02
    ],
    [
      "biquet",
      0.02
    ],
    [
      "bienveillant",
      0.02
    ],
    [
      "acolyte",
      0.02
    ],
    [
      "connaissances",
      0.0075
    ],
    [
      "copine",
      0.0075
    ],
    [
      "devoue",
      0.0075
    ],
    [
      "fiance",
      0.0075
    ],
    [
      "partisan",
      0.0075
    ],
    [
      "poteau",
      0.0075
    ],
    [
      "sectateur",
      0.0075
    ],
    [
      "confident",
      0.0075
    ],
    [
      "coalise",
      0.0075
    ],
    [
      "bienfaiteur",
      0.0075
    ],
    [
      "adepte",
      0.0075
    ],
    [
      "affectueux",
      0.0075
    ],
    [
      "amateur",
      0.0075
    ],
    [
      "aminche",
      0.0075
    ],
    [
      "ame",
      0.0075
    ],
    [
      "assorti",
      0.0075
    ],
    [
      "attache",
      0.0075
    ]
  ],
  "emmeler": [
    [
      "embrouiller",
      0.19
    ],
    [
      "brouiller",
      0.1425
    ],
    [
      "compliquer",
      0.1425
    ],
    [
      "enchevetrer",
      0.1425
    ],
    [
      "meler",
      0.095
    ],
    [
      "melanger",
      0.095
    ],
    [
      "emberlificoter",
      0.0475
    ],
    [
      "entremeler",
      0.0475
    ],
    [
      "obscurcir",
      0.0475
    ]
  ],
  "deranger": [
    [
      "troubler",
      0.1225
    ],
    [
      "bouleverser",
      0.08
    ],
    [
      "brouiller",
      0.0625
    ],
    [
      "alterer",
      0.04
    ],
    [
      "perturber",
      0.04
    ],
    [
      "changer",
      0.035
    ],
    [
      "detraquer",
      0.03
    ],
    [
      "pervertir",
      0.025
    ],
    [
      "embarrasser",
      0.025
    ],
    [
      "deregler",
      0.025
    ],
    [
      "deplacer",
      0.025
    ],
    [
      "defaire",
      0.025
    ],
    [
      "embrouiller",
      0.0225
    ],
    [
      "gener",
      0.0225
    ],
    [
      "remuer",
      0.0225
    ],
    [
      "rompre",
      0.0175
    ],
    [
      "detourner",
      0.0175
    ],
    [
      "emouvoir",
      0.0125
    ],
    [
      "toucher",
      0.0125
    ],
    [
      "interrompre",
      0.0125
    ],
    [
      "desorganiser",
      0.0125
    ],
    [
      "desajuster",
      0.0125
    ],
    [
      "disloquer",
      0.0125
    ],
    [
      "contrarier",
      0.0125
    ],
    [
      "chambouler",
      0.0125
    ],
    [
      "chambarder",
      0.0125
    ],
    [
      "desequilibrer",
      0.0075
    ],
    [
      "devoyer",
      0.0075
    ],
    [
      "embarbouiller",
      0.0075
    ],
    [
      "gater",
      0.0075
    ],
    [
      "importuner",
      0.0075
    ],
    [
      "incommoder",
      0.0075
    ],
    [
      "transporter",
      0.0075
    ],
    [
      "destabiliser",
      0.0075
    ],
    [
      "demenager",
      0.0075
    ],
    [
      "demolir",
      0.0075
    ],
    [
      "bousculer",
      0.0075
    ],
    [
      "distraire",
      0.0075
    ],
    [
      "debaucher",
      0.0075
    ],
    [
      "declasser",
      0.0075
    ],
    [
      "decoiffer",
      0.0075
    ],
    [
      "deconcerter",
      0.0075
    ],
    [
      "deglinguer",
      0.0075
    ],
    [
      "farfouiller",
      0.0025
    ],
    [
      "ennuyer",
      0.0025
    ],
    [
      "desaxer",
      0.0025
    ],
    [
      "desassortir",
      0.0025
    ],
    [
      "desassembler",
      0.0025
    ],
    [
      "depeigner",
      0.0025
    ],
    [
      "couper",
      0.0025
    ],
    [
      "contrecarrer",
      0.0025
    ],
    [
      "bouger",
      0.0025
    ],
    [
      "aliener",
      0.0025
    ],
    [
      "affoler",
      0.0025
    ],
    [
      "intervertir",
      0.0025
    ]
  ],
  "meler": [
    [
      "melanger",
      0.2175
    ],
    [
      "reunir",
      0.06
    ],
    [
      "unir",
      0.045
    ],
    [
      "amalgamer",
      0.04
    ],
    [
      "fusionner",
      0.04
    ],
    [
      "combiner",
      0.0325
    ],
    [
      "associer",
      0.0325
    ],
    [
      "joindre",
      0.025
    ],
    [
      "incorporer",
      0.025
    ],
    [
      "entrelacer",
      0.025
    ],
    [
      "couper",
      0.025
    ],
    [
      "confondre",
      0.025
    ],
    [
      "battre",
      0.025
    ],
    [
      "touiller",
      0.02
    ],
    [
      "entremeler",
      0.02
    ],
    [
      "enchevetrer",
      0.02
    ],
    [
      "croiser",
      0.02
    ],
    [
      "brouiller",
      0.02
    ],
    [
      "matiner",
      0.0125
    ],
    [
      "marier",
      0.0125
    ],
    [
      "fouetter",
      0.0125
    ],
    [
      "fondre",
      0.0125
    ],
    [
      "emmeler",
      0.0125
    ],
    [
      "embrouiller",
      0.0125
    ],
    [
      "comprendre",
      0.0125
    ],
    [
      "brasser",
      0.0125
    ],
    [
      "allier",
      0.0125
    ],
    [
      "agiter",
      0.0125
    ],
    [
      "agglomerer",
      0.0125
    ],
    [
      "accoupler",
      0.0125
    ],
    [
      "mixtionner",
      0.005
    ],
    [
      "mouiller",
      0.005
    ],
    [
      "panacher",
      0.005
    ],
    [
      "saupoudrer",
      0.005
    ],
    [
      "temperer",
      0.005
    ],
    [
      "manipuler",
      0.005
    ],
    [
      "malaxer",
      0.005
    ],
    [
      "impliquer",
      0.005
    ],
    [
      "ficher",
      0.005
    ],
    [
      "fatiguer",
      0.005
    ],
    [
      "doser",
      0.005
    ],
    [
      "agglutiner",
      0.005
    ],
    [
      "unifier",
      0.005
    ]
  ],
  "melanger": [
    [
      "meler",
      0.1325
    ],
    [
      "reunir",
      0.0725
    ],
    [
      "unir",
      0.065
    ],
    [
      "fusionner",
      0.0575
    ],
    [
      "associer",
      0.04
    ],
    [
      "assembler",
      0.04
    ],
    [
      "combiner",
      0.0325
    ],
    [
      "amalgamer",
      0.0275
    ],
    [
      "joindre",
      0.0275
    ],
    [
      "brouiller",
      0.0225
    ],
    [
      "allier",
      0.0225
    ],
    [
      "accoupler",
      0.0225
    ],
    [
      "confondre",
      0.02
    ],
    [
      "incorporer",
      0.02
    ],
    [
      "touiller",
      0.015
    ],
    [
      "marier",
      0.015
    ],
    [
      "entremeler",
      0.015
    ],
    [
      "entrelacer",
      0.015
    ],
    [
      "enchevetrer",
      0.015
    ],
    [
      "embrouiller",
      0.015
    ],
    [
      "couper",
      0.015
    ],
    [
      "brasser",
      0.015
    ],
    [
      "battre",
      0.015
    ],
    [
      "troubler",
      0.01
    ],
    [
      "fondre",
      0.01
    ],
    [
      "croiser",
      0.01
    ],
    [
      "assortir",
      0.01
    ],
    [
      "agiter",
      0.01
    ],
    [
      "agglomerer",
      0.01
    ],
    [
      "matiner",
      0.0075
    ],
    [
      "panacher",
      0.0075
    ],
    [
      "proportionner",
      0.0075
    ],
    [
      "petrir",
      0.0075
    ],
    [
      "rapprocher",
      0.0075
    ],
    [
      "etendre",
      0.0075
    ],
    [
      "mettre",
      0.0075
    ],
    [
      "manipuler",
      0.0075
    ],
    [
      "doser",
      0.0075
    ],
    [
      "emmeler",
      0.0075
    ],
    [
      "fouetter",
      0.0075
    ],
    [
      "geminer",
      0.0075
    ],
    [
      "introduire",
      0.0075
    ],
    [
      "malaxer",
      0.0075
    ],
    [
      "saupoudrer",
      0.0025
    ],
    [
      "recouper",
      0.0025
    ],
    [
      "mixtionner",
      0.0025
    ],
    [
      "mixer",
      0.0025
    ],
    [
      "frelater",
      0.0025
    ],
    [
      "fatiguer",
      0.0025
    ],
    [
      "entrelarder",
      0.0025
    ],
    [
      "coupler",
      0.0025
    ],
    [
      "comprendre",
      0.0025
    ],
    [
      "composer",
      0.0025
    ],
    [
      "barioler",
      0.0025
    ],
    [
      "agglutiner",
      0.0025
    ],
    [
      "abatardir",
      0.0025
    ],
    [
      "tremper",
      0.0025
    ]
  ],
  "melange": [
    [
      "meler",
      0.1325
    ],
    [
      "reunir",
      0.0725
    ],
    [
      "unir",
      0.065
    ],
    [
      "fusionner",
      0.0575
    ],
    [
      "associer",
      0.04
    ],
    [
      "assembler",
      0.04
    ],
    [
      "combiner",
      0.0325
    ],
    [
      "amalgamer",
      0.0275
    ],
    [
      "joindre",
      0.0275
    ],
    [
      "brouiller",
      0.0225
    ],
    [
      "allier",
      0.0225
    ],
    [
      "accoupler",
      0.0225
    ],
    [
      "confondre",
      0.02
    ],
    [
      "incorporer",
      0.02
    ],
    [
      "touiller",
      0.015
    ],
    [
      "marier",
      0.015
    ],
    [
      "entremeler",
      0.015
    ],
    [
      "entrelacer",
      0.015
    ],
    [
      "enchevetrer",
      0.015
    ],
    [
      "embrouiller",
      0.015
    ],
    [
      "couper",
      0.015
    ],
    [
      "brasser",
      0.015
    ],
    [
      "battre",
      0.015
    ],
    [
      "troubler",
      0.01
    ],
    [
      "fondre",
      0.01
    ],
    [
      "croiser",
      0.01
    ],
    [
      "assortir",
      0.01
    ],
    [
      "agiter",
      0.01
    ],
    [
      "agglomerer",
      0.01
    ],
    [
      "matiner",
      0.0075
    ],
    [
      "panacher",
      0.0075
    ],
    [
      "proportionner",
      0.0075
    ],
    [
      "petrir",
      0.0075
    ],
    [
      "rapprocher",
      0.0075
    ],
    [
      "etendre",
      0.0075
    ],
    [
      "mettre",
      0.0075
    ],
    [
      "manipuler",
      0.0075
    ],
    [
      "doser",
      0.0075
    ],
    [
      "emmeler",
      0.0075
    ],
    [
      "fouetter",
      0.0075
    ],
    [
      "geminer",
      0.0075
    ],
    [
      "introduire",
      0.0075
    ],
    [
      "malaxer",
      0.0075
    ],
    [
      "saupoudrer",
      0.0025
    ],
    [
      "recouper",
      0.0025
    ],
    [
      "mixtionner",
      0.0025
    ],
    [
      "mixer",
      0.0025
    ],
    [
      "frelater",
      0.0025
    ],
    [
      "fatiguer",
      0.0025
    ],
    [
      "entrelarder",
      0.0025
    ],
    [
      "coupler",
      0.0025
    ],
    [
      "comprendre",
      0.0025
    ],
    [
      "composer",
      0.0025
    ],
    [
      "barioler",
      0.0025
    ],
    [
      "agglutiner",
      0.0025
    ],
    [
      "abatardir",
      0.0025
    ],
    [
      "tremper",
      0.0025
    ]
  ],
  "endormir": [
    [
      "calmer",
      0.055
    ],
    [
      "adoucir",
      0.05
    ],
    [
      "apaiser",
      0.045
    ],
    [
      "tromper",
      0.045
    ],
    [
      "bercer",
      0.0375
    ],
    [
      "fatiguer",
      0.0375
    ],
    [
      "etourdir",
      0.0375
    ],
    [
      "soulager",
      0.0325
    ],
    [
      "enjoler",
      0.0325
    ],
    [
      "engourdir",
      0.0325
    ],
    [
      "diminuer",
      0.0325
    ],
    [
      "assoupir",
      0.0325
    ],
    [
      "raser",
      0.0275
    ],
    [
      "ennuyer",
      0.0275
    ],
    [
      "consoler",
      0.0275
    ],
    [
      "assommer",
      0.0275
    ],
    [
      "anesthesier",
      0.02
    ],
    [
      "barber",
      0.02
    ],
    [
      "lasser",
      0.02
    ],
    [
      "paralyser",
      0.015
    ],
    [
      "seduire",
      0.015
    ],
    [
      "emousser",
      0.015
    ],
    [
      "eteindre",
      0.015
    ],
    [
      "leurrer",
      0.015
    ],
    [
      "insensibiliser",
      0.015
    ],
    [
      "entortiller",
      0.015
    ],
    [
      "embobiner",
      0.015
    ],
    [
      "embobeliner",
      0.015
    ],
    [
      "circonvenir",
      0.015
    ],
    [
      "amuser",
      0.015
    ],
    [
      "vaincre",
      0.01
    ],
    [
      "stupefier",
      0.01
    ],
    [
      "immobiliser",
      0.01
    ],
    [
      "enquiquiner",
      0.01
    ],
    [
      "empoisonner",
      0.01
    ],
    [
      "chloroformer",
      0.01
    ],
    [
      "blaser",
      0.01
    ],
    [
      "mystifier",
      0.005
    ],
    [
      "hypnotiser",
      0.005
    ],
    [
      "fasciner",
      0.005
    ],
    [
      "envelopper",
      0.005
    ],
    [
      "ensommeiller",
      0.005
    ],
    [
      "emberlificoter",
      0.005
    ],
    [
      "cicatriser",
      0.005
    ],
    [
      "bourrer",
      0.005
    ],
    [
      "attiedir",
      0.005
    ],
    [
      "ankyloser",
      0.005
    ],
    [
      "alourdir",
      0.005
    ],
    [
      "surmonter",
      0.005
    ]
  ],
  "ressentir": [
    [
      "eprouver",
      0.2125
    ],
    [
      "connaitre",
      0.1425
    ],
    [
      "sentir",
      0.1425
    ],
    [
      "subir",
      0.1425
    ],
    [
      "endurer",
      0.07
    ],
    [
      "souffrir",
      0.07
    ],
    [
      "gouter",
      0.035
    ],
    [
      "discerner",
      0.035
    ],
    [
      "concevoir",
      0.035
    ],
    [
      "avoir",
      0.035
    ],
    [
      "pleurer",
      0.035
    ]
  ],
  "galere": [
    [
      "bagne",
      0.0625
    ],
    [
      "trireme",
      0.0625
    ],
    [
      "traquenard",
      0.0625
    ],
    [
      "tombereau",
      0.0625
    ],
    [
      "sultane",
      0.0625
    ],
    [
      "petaudiere",
      0.0625
    ],
    [
      "prame",
      0.0625
    ],
    [
      "piege",
      0.0625
    ],
    [
      "mesaventure",
      0.0625
    ],
    [
      "mahonne",
      0.0625
    ],
    [
      "guepier",
      0.0625
    ],
    [
      "galeasse",
      0.0625
    ],
    [
      "galiote",
      0.0625
    ],
    [
      "galion",
      0.0625
    ],
    [
      "fourneau",
      0.0625
    ],
    [
      "triere",
      0.0625
    ]
  ],
  "debout": [
    [
      "droit",
      0.22
    ],
    [
      "dresse",
      0.11
    ],
    [
      "verticalement",
      0.11
    ],
    [
      "vivant",
      0.055
    ],
    [
      "vertical",
      0.055
    ],
    [
      "plante",
      0.055
    ],
    [
      "leve",
      0.055
    ],
    [
      "d'aplomb",
      0.055
    ],
    [
      "carre",
      0.055
    ],
    [
      "erige",
      0.055
    ]
  ],
  "sorte": [
    [
      "classe",
      0.1025
    ],
    [
      "espece",
      0.09
    ],
    [
      "type",
      0.09
    ],
    [
      "genre",
      0.0825
    ],
    [
      "categorie",
      0.0625
    ],
    [
      "ordre",
      0.05
    ],
    [
      "nature",
      0.05
    ],
    [
      "division",
      0.045
    ],
    [
      "maniere",
      0.0375
    ],
    [
      "qualite",
      0.0375
    ],
    [
      "acabit",
      0.03
    ],
    [
      "etat",
      0.025
    ],
    [
      "style",
      0.025
    ],
    [
      "rang",
      0.025
    ],
    [
      "groupe",
      0.025
    ],
    [
      "facon",
      0.025
    ],
    [
      "variete",
      0.0175
    ],
    [
      "trempe",
      0.0175
    ],
    [
      "forme",
      0.0175
    ],
    [
      "famille",
      0.0175
    ],
    [
      "condition",
      0.0175
    ],
    [
      "clan",
      0.0175
    ],
    [
      "caste",
      0.0175
    ],
    [
      "race",
      0.0125
    ],
    [
      "embranchement",
      0.005
    ],
    [
      "griffe",
      0.005
    ],
    [
      "guise",
      0.005
    ],
    [
      "serie",
      0.005
    ]
  ],
  "faute": [
    [
      "erreur",
      0.0775
    ],
    [
      "bevue",
      0.04
    ],
    [
      "defaut",
      0.04
    ],
    [
      "manquement",
      0.0375
    ],
    [
      "peche",
      0.0375
    ],
    [
      "maladresse",
      0.0325
    ],
    [
      "betise",
      0.03
    ],
    [
      "crime",
      0.025
    ],
    [
      "imperfection",
      0.025
    ],
    [
      "infraction",
      0.02
    ],
    [
      "tache",
      0.02
    ],
    [
      "delit",
      0.0175
    ],
    [
      "faiblesse",
      0.015
    ],
    [
      "vice",
      0.015
    ],
    [
      "ecart",
      0.015
    ],
    [
      "inexactitude",
      0.01
    ],
    [
      "mal",
      0.01
    ],
    [
      "manque",
      0.01
    ],
    [
      "sottise",
      0.01
    ],
    [
      "souillure",
      0.01
    ],
    [
      "anerie",
      0.01
    ],
    [
      "indignite",
      0.01
    ],
    [
      "incorrection",
      0.01
    ],
    [
      "inattention",
      0.01
    ],
    [
      "absence",
      0.01
    ],
    [
      "balourdise",
      0.01
    ],
    [
      "decheance",
      0.01
    ],
    [
      "entorse",
      0.01
    ],
    [
      "gaffe",
      0.01
    ],
    [
      "transgression",
      0.01
    ],
    [
      "tort",
      0.01
    ],
    [
      "omission",
      0.01
    ],
    [
      "inconduite",
      0.01
    ],
    [
      "imprudence",
      0.01
    ],
    [
      "fredaine",
      0.01
    ],
    [
      "defectuosite",
      0.01
    ],
    [
      "attentat",
      0.01
    ],
    [
      "impair",
      0.005
    ],
    [
      "impurete",
      0.005
    ],
    [
      "irregularite",
      0.005
    ],
    [
      "lapsus",
      0.005
    ],
    [
      "meprise",
      0.005
    ],
    [
      "offense",
      0.005
    ],
    [
      "peine",
      0.005
    ],
    [
      "egarement",
      0.005
    ],
    [
      "imbecillite",
      0.005
    ],
    [
      "forfait",
      0.005
    ],
    [
      "bavure",
      0.005
    ],
    [
      "blague",
      0.005
    ],
    [
      "bourde",
      0.005
    ],
    [
      "chute",
      0.005
    ],
    [
      "connerie",
      0.005
    ],
    [
      "contresens",
      0.005
    ],
    [
      "cuir",
      0.005
    ],
    [
      "errements",
      0.005
    ],
    [
      "glissade",
      0.005
    ],
    [
      "ignorance",
      0.005
    ],
    [
      "impropriete",
      0.005
    ],
    [
      "infidelite",
      0.005
    ],
    [
      "negligence",
      0.005
    ],
    [
      "peccadille",
      0.005
    ],
    [
      "privation",
      0.005
    ],
    [
      "enormite",
      0.005
    ],
    [
      "forfaiture",
      0.005
    ],
    [
      "fait",
      0.005
    ],
    [
      "demerite",
      0.005
    ],
    [
      "accroc",
      0.005
    ],
    [
      "barbarisme",
      0.005
    ],
    [
      "boulette",
      0.005
    ],
    [
      "bourdon",
      0.005
    ],
    [
      "contravention",
      0.005
    ],
    [
      "coquille",
      0.005
    ],
    [
      "couillonnade",
      0.005
    ],
    [
      "doublon",
      0.005
    ],
    [
      "deformation",
      0.005
    ],
    [
      "mastic",
      0.0
    ],
    [
      "moine",
      0.0
    ],
    [
      "mefait",
      0.0
    ],
    [
      "pataques",
      0.0
    ],
    [
      "penurie",
      0.0
    ],
    [
      "responsabilite",
      0.0
    ],
    [
      "lourderie",
      0.0
    ],
    [
      "incongruite",
      0.0
    ],
    [
      "erratum",
      0.0
    ],
    [
      "derogation",
      0.0
    ],
    [
      "doublage",
      0.0
    ],
    [
      "coulpe",
      0.0
    ],
    [
      "brioche",
      0.0
    ],
    [
      "solecisme",
      0.0
    ]
  ],
  "fauter": [
    [
      "faillir",
      0.5
    ],
    [
      "manquer",
      0.5
    ]
  ],
  "squat": [],
  "troubadour": [
    [
      "poete",
      0.2075
    ],
    [
      "trouvere",
      0.2075
    ],
    [
      "chanteur",
      0.1675
    ],
    [
      "menestrel",
      0.125
    ],
    [
      "menetrier",
      0.04
    ],
    [
      "musicien",
      0.04
    ],
    [
      "minnesinger",
      0.04
    ],
    [
      "jongleur",
      0.04
    ],
    [
      "felibre",
      0.04
    ],
    [
      "barde",
      0.04
    ],
    [
      "trouveur",
      0.04
    ]
  ],
  "presse": [
    [
      "foule",
      0.1
    ],
    [
      "cohue",
      0.08
    ],
    [
      "bousculade",
      0.06
    ],
    [
      "precipitation",
      0.06
    ],
    [
      "tas",
      0.04
    ],
    [
      "multitude",
      0.04
    ],
    [
      "hate",
      0.04
    ],
    [
      "entassement",
      0.04
    ],
    [
      "amas",
      0.04
    ],
    [
      "affluence",
      0.04
    ],
    [
      "mouvement",
      0.02
    ],
    [
      "poussee",
      0.02
    ],
    [
      "pressoir",
      0.02
    ],
    [
      "periodique",
      0.02
    ],
    [
      "rapidite",
      0.02
    ],
    [
      "revue",
      0.02
    ],
    [
      "rotative",
      0.02
    ],
    [
      "vis",
      0.02
    ],
    [
      "vitesse",
      0.02
    ],
    [
      "minerve",
      0.02
    ],
    [
      "magazine",
      0.02
    ],
    [
      "laminoir",
      0.02
    ],
    [
      "affairement",
      0.02
    ],
    [
      "bourre",
      0.02
    ],
    [
      "bourree",
      0.02
    ],
    [
      "calandre",
      0.02
    ],
    [
      "concours",
      0.02
    ],
    [
      "empressement",
      0.02
    ],
    [
      "fouloir",
      0.02
    ],
    [
      "journal",
      0.02
    ],
    [
      "journalisme",
      0.02
    ],
    [
      "etau",
      0.02
    ]
  ],
  "presser": [
    [
      "pousser",
      0.065
    ],
    [
      "serrer",
      0.05
    ],
    [
      "exciter",
      0.04
    ],
    [
      "ecraser",
      0.0325
    ],
    [
      "poursuivre",
      0.0275
    ],
    [
      "harceler",
      0.0275
    ],
    [
      "accabler",
      0.025
    ],
    [
      "assieger",
      0.025
    ],
    [
      "tourmenter",
      0.0225
    ],
    [
      "precipiter",
      0.0225
    ],
    [
      "forcer",
      0.0225
    ],
    [
      "entrainer",
      0.0225
    ],
    [
      "engager",
      0.0225
    ],
    [
      "assaillir",
      0.0225
    ],
    [
      "inciter",
      0.02
    ],
    [
      "contraindre",
      0.02
    ],
    [
      "brusquer",
      0.02
    ],
    [
      "attaquer",
      0.02
    ],
    [
      "accelerer",
      0.0175
    ],
    [
      "activer",
      0.0175
    ],
    [
      "oppresser",
      0.0175
    ],
    [
      "tasser",
      0.0175
    ],
    [
      "etreindre",
      0.0125
    ],
    [
      "toucher",
      0.0125
    ],
    [
      "inviter",
      0.0125
    ],
    [
      "entourer",
      0.0125
    ],
    [
      "comprimer",
      0.0125
    ],
    [
      "aiguillonner",
      0.0125
    ],
    [
      "etrangler",
      0.01
    ],
    [
      "talonner",
      0.01
    ],
    [
      "resserrer",
      0.01
    ],
    [
      "obliger",
      0.01
    ],
    [
      "mordre",
      0.01
    ],
    [
      "exhorter",
      0.01
    ],
    [
      "embrasser",
      0.01
    ],
    [
      "courir",
      0.01
    ],
    [
      "bousculer",
      0.01
    ],
    [
      "bombarder",
      0.01
    ],
    [
      "appuyer",
      0.01
    ],
    [
      "persuader",
      0.0075
    ],
    [
      "peser",
      0.0075
    ],
    [
      "ruiner",
      0.0075
    ],
    [
      "supplier",
      0.0075
    ],
    [
      "obseder",
      0.0075
    ],
    [
      "hater",
      0.0075
    ],
    [
      "froisser",
      0.0075
    ],
    [
      "fouler",
      0.0075
    ],
    [
      "entasser",
      0.0075
    ],
    [
      "caresser",
      0.0075
    ],
    [
      "broyer",
      0.0075
    ],
    [
      "pressurer",
      0.005
    ],
    [
      "prier",
      0.005
    ],
    [
      "petrir",
      0.005
    ],
    [
      "epreindre",
      0.005
    ],
    [
      "masser",
      0.005
    ],
    [
      "insister",
      0.005
    ],
    [
      "hanter",
      0.005
    ],
    [
      "exprimer",
      0.005
    ],
    [
      "empiler",
      0.005
    ],
    [
      "conseiller",
      0.005
    ],
    [
      "persecuter",
      0.0
    ],
    [
      "pincer",
      0.0
    ],
    [
      "plomber",
      0.0
    ],
    [
      "rapprocher",
      0.0
    ],
    [
      "taller",
      0.0
    ],
    [
      "urger",
      0.0
    ],
    [
      "extraire",
      0.0
    ],
    [
      "esquicher",
      0.0
    ],
    [
      "encaquer",
      0.0
    ],
    [
      "depecher",
      0.0
    ],
    [
      "chauffer",
      0.0
    ],
    [
      "catir",
      0.0
    ],
    [
      "appliquer",
      0.0
    ],
    [
      "alourdir",
      0.0
    ]
  ],
  "lala": [],
  "piece": [
    [
      "morceau",
      0.06
    ],
    [
      "poeme",
      0.05
    ],
    [
      "chambre",
      0.045
    ],
    [
      "fragment",
      0.04
    ],
    [
      "partie",
      0.03
    ],
    [
      "titre",
      0.025
    ],
    [
      "debris",
      0.025
    ],
    [
      "service",
      0.0175
    ],
    [
      "pourboire",
      0.0175
    ],
    [
      "portion",
      0.0175
    ],
    [
      "ouvrage",
      0.0175
    ],
    [
      "document",
      0.0175
    ],
    [
      "division",
      0.0175
    ],
    [
      "comedie",
      0.0175
    ],
    [
      "unite",
      0.015
    ],
    [
      "taule",
      0.015
    ],
    [
      "spectacle",
      0.015
    ],
    [
      "papier",
      0.015
    ],
    [
      "louis",
      0.015
    ],
    [
      "lambeau",
      0.015
    ],
    [
      "gratification",
      0.015
    ],
    [
      "acte",
      0.015
    ],
    [
      "bloc",
      0.015
    ],
    [
      "cabinet",
      0.015
    ],
    [
      "certificat",
      0.015
    ],
    [
      "coupe",
      0.015
    ],
    [
      "poesie",
      0.0075
    ],
    [
      "preuve",
      0.0075
    ],
    [
      "production",
      0.0075
    ],
    [
      "ration",
      0.0075
    ],
    [
      "salle",
      0.0075
    ],
    [
      "sou",
      0.0075
    ],
    [
      "tragedie",
      0.0075
    ],
    [
      "eclat",
      0.0075
    ],
    [
      "ecu",
      0.0075
    ],
    [
      "plat",
      0.0075
    ],
    [
      "plaisanterie",
      0.0075
    ],
    [
      "appartement",
      0.0075
    ],
    [
      "bureau",
      0.0075
    ],
    [
      "cabine",
      0.0075
    ],
    [
      "cadeau",
      0.0075
    ],
    [
      "diplome",
      0.0075
    ],
    [
      "drame",
      0.0075
    ],
    [
      "loge",
      0.0075
    ],
    [
      "opera",
      0.0075
    ],
    [
      "organe",
      0.0075
    ],
    [
      "piaule",
      0.0075
    ],
    [
      "quartier",
      0.0025
    ],
    [
      "proverbe",
      0.0025
    ],
    [
      "opuscule",
      0.0025
    ],
    [
      "note",
      0.0025
    ],
    [
      "napoleon",
      0.0025
    ],
    [
      "melodie",
      0.0025
    ],
    [
      "medaille",
      0.0025
    ],
    [
      "miette",
      0.0025
    ],
    [
      "quatrain",
      0.0025
    ],
    [
      "ramification",
      0.0025
    ],
    [
      "ristourne",
      0.0025
    ],
    [
      "tole",
      0.0025
    ],
    [
      "tete",
      0.0025
    ],
    [
      "turne",
      0.0025
    ],
    [
      "tour",
      0.0025
    ],
    [
      "tonneau",
      0.0025
    ],
    [
      "thune",
      0.0025
    ],
    [
      "tesson",
      0.0025
    ],
    [
      "saynete",
      0.0025
    ],
    [
      "salon",
      0.0025
    ],
    [
      "materiau",
      0.0025
    ],
    [
      "loque",
      0.0025
    ],
    [
      "jaunet",
      0.0025
    ],
    [
      "coupon",
      0.0025
    ],
    [
      "carree",
      0.0025
    ],
    [
      "carre",
      0.0025
    ],
    [
      "canon",
      0.0025
    ],
    [
      "canfouine",
      0.0025
    ],
    [
      "cambriole",
      0.0025
    ],
    [
      "barrique",
      0.0025
    ],
    [
      "baril",
      0.0025
    ],
    [
      "creche",
      0.0025
    ],
    [
      "dit",
      0.0025
    ],
    [
      "gracieusete",
      0.0025
    ],
    [
      "galerie",
      0.0025
    ],
    [
      "fut",
      0.0025
    ],
    [
      "feerie",
      0.0025
    ],
    [
      "futaille",
      0.0025
    ],
    [
      "empiecement",
      0.0025
    ],
    [
      "decoupe",
      0.0025
    ],
    [
      "douzain",
      0.0025
    ],
    [
      "dizain",
      0.0025
    ],
    [
      "accessoire",
      0.0025
    ]
  ],
  "confesse": [
    [
      "confession",
      1.0
    ]
  ],
  "confesser": [
    [
      "reconnaitre",
      0.1625
    ],
    [
      "reveler",
      0.1425
    ],
    [
      "avouer",
      0.12
    ],
    [
      "declarer",
      0.12
    ],
    [
      "decouvrir",
      0.08
    ],
    [
      "sonder",
      0.04
    ],
    [
      "publier",
      0.04
    ],
    [
      "proclamer",
      0.04
    ],
    [
      "convenir",
      0.04
    ],
    [
      "admettre",
      0.04
    ],
    [
      "s'accuser",
      0.02
    ],
    [
      "entendre",
      0.02
    ],
    [
      "deballer",
      0.02
    ],
    [
      "confier",
      0.02
    ],
    [
      "affirmer",
      0.02
    ],
    [
      "accuser",
      0.02
    ],
    [
      "accorder",
      0.02
    ],
    [
      "tater",
      0.02
    ]
  ],
  "attester": [
    [
      "temoigner",
      0.13
    ],
    [
      "montrer",
      0.0925
    ],
    [
      "affirmer",
      0.0825
    ],
    [
      "afficher",
      0.065
    ],
    [
      "reveler",
      0.065
    ],
    [
      "prouver",
      0.055
    ],
    [
      "declarer",
      0.055
    ],
    [
      "certifier",
      0.055
    ],
    [
      "assurer",
      0.045
    ],
    [
      "indiquer",
      0.045
    ],
    [
      "demontrer",
      0.035
    ],
    [
      "garantir",
      0.035
    ],
    [
      "soutenir",
      0.0275
    ],
    [
      "marquer",
      0.0275
    ],
    [
      "confirmer",
      0.0275
    ],
    [
      "annoncer",
      0.0275
    ],
    [
      "jurer",
      0.0175
    ],
    [
      "repondre",
      0.0175
    ],
    [
      "signer",
      0.0175
    ],
    [
      "invoquer",
      0.0075
    ],
    [
      "deposer",
      0.0075
    ]
  ],
  "toit": [
    [
      "maison",
      0.1375
    ],
    [
      "abri",
      0.1025
    ],
    [
      "demeure",
      0.09
    ],
    [
      "foyer",
      0.09
    ],
    [
      "logis",
      0.0675
    ],
    [
      "nid",
      0.0675
    ],
    [
      "habitation",
      0.055
    ],
    [
      "bercail",
      0.055
    ],
    [
      "logement",
      0.045
    ],
    [
      "comble",
      0.0325
    ],
    [
      "domicile",
      0.0325
    ],
    [
      "niche",
      0.0225
    ],
    [
      "hangar",
      0.0225
    ],
    [
      "faite",
      0.0225
    ],
    [
      "famille",
      0.0225
    ],
    [
      "asile",
      0.0225
    ],
    [
      "appentis",
      0.0225
    ],
    [
      "auvent",
      0.01
    ],
    [
      "chaume",
      0.01
    ],
    [
      "couverture",
      0.01
    ],
    [
      "plafond",
      0.01
    ],
    [
      "terrasse",
      0.01
    ],
    [
      "toiture",
      0.01
    ]
  ],
  "adresse": [
    [
      "habilete",
      0.1875
    ],
    [
      "intelligence",
      0.0425
    ],
    [
      "dexterite",
      0.04
    ],
    [
      "art",
      0.0375
    ],
    [
      "talent",
      0.0375
    ],
    [
      "astuce",
      0.03
    ],
    [
      "virtuosite",
      0.03
    ],
    [
      "finesse",
      0.0275
    ],
    [
      "doigte",
      0.0275
    ],
    [
      "capacite",
      0.025
    ],
    [
      "ingeniosite",
      0.025
    ],
    [
      "chic",
      0.0225
    ],
    [
      "esprit",
      0.0225
    ],
    [
      "industrie",
      0.02
    ],
    [
      "diplomatie",
      0.02
    ],
    [
      "brio",
      0.02
    ],
    [
      "artifice",
      0.02
    ],
    [
      "aisance",
      0.02
    ],
    [
      "don",
      0.015
    ],
    [
      "maitrise",
      0.015
    ],
    [
      "ruse",
      0.015
    ],
    [
      "vivacite",
      0.0125
    ],
    [
      "subtilite",
      0.0125
    ],
    [
      "politique",
      0.0125
    ],
    [
      "agilite",
      0.0125
    ],
    [
      "elegance",
      0.01
    ],
    [
      "tact",
      0.01
    ],
    [
      "souplesse",
      0.01
    ],
    [
      "maestria",
      0.01
    ],
    [
      "facilite",
      0.01
    ],
    [
      "entregent",
      0.01
    ],
    [
      "discours",
      0.0075
    ],
    [
      "delicatesse",
      0.0075
    ],
    [
      "science",
      0.0075
    ],
    [
      "residence",
      0.005
    ],
    [
      "precision",
      0.005
    ],
    [
      "prestesse",
      0.005
    ],
    [
      "patte",
      0.005
    ],
    [
      "instruction",
      0.005
    ],
    [
      "domicile",
      0.005
    ],
    [
      "manifeste",
      0.0025
    ],
    [
      "manoeuvre",
      0.0025
    ],
    [
      "message",
      0.0025
    ],
    [
      "raccourci",
      0.0025
    ],
    [
      "suscription",
      0.0025
    ],
    [
      "lieu",
      0.0025
    ],
    [
      "habitation",
      0.0025
    ],
    [
      "escamotage",
      0.0025
    ],
    [
      "destination",
      0.0025
    ],
    [
      "demeure",
      0.0025
    ],
    [
      "communication",
      0.0025
    ],
    [
      "aptitude",
      0.0025
    ],
    [
      "allocution",
      0.0025
    ],
    [
      "acrobatie",
      0.0025
    ],
    [
      "villegiature",
      0.0025
    ]
  ],
  "adresser": [
    [
      "donner",
      0.1025
    ],
    [
      "appliquer",
      0.0925
    ],
    [
      "envoyer",
      0.0825
    ],
    [
      "ficher",
      0.0725
    ],
    [
      "flanquer",
      0.0725
    ],
    [
      "jeter",
      0.05
    ],
    [
      "porter",
      0.05
    ],
    [
      "poser",
      0.05
    ],
    [
      "foutre",
      0.04
    ],
    [
      "faire",
      0.03
    ],
    [
      "proferer",
      0.03
    ],
    [
      "prononcer",
      0.03
    ],
    [
      "presenter",
      0.03
    ],
    [
      "vouer",
      0.03
    ],
    [
      "enoncer",
      0.03
    ],
    [
      "prodiguer",
      0.02
    ],
    [
      "expedier",
      0.02
    ],
    [
      "coller",
      0.02
    ],
    [
      "suscrire",
      0.01
    ],
    [
      "soumettre",
      0.01
    ],
    [
      "questionner",
      0.01
    ],
    [
      "poster",
      0.01
    ],
    [
      "interpeller",
      0.01
    ],
    [
      "depecher",
      0.01
    ],
    [
      "dedier",
      0.01
    ],
    [
      "decocher",
      0.01
    ],
    [
      "destiner",
      0.01
    ],
    [
      "articuler",
      0.01
    ],
    [
      "agir",
      0.01
    ],
    [
      "acheminer",
      0.01
    ],
    [
      "transmettre",
      0.01
    ]
  ],
  "stresser": [
    [
      "agresser",
      1.0
    ]
  ],
  "moral": [
    [
      "honnete",
      0.1625
    ],
    [
      "bon",
      0.1075
    ],
    [
      "convenable",
      0.07
    ],
    [
      "irreprochable",
      0.07
    ],
    [
      "juste",
      0.07
    ],
    [
      "edifiant",
      0.0525
    ],
    [
      "vertueux",
      0.0525
    ],
    [
      "probe",
      0.0525
    ],
    [
      "exemplaire",
      0.0525
    ],
    [
      "spirituel",
      0.035
    ],
    [
      "regulier",
      0.035
    ],
    [
      "propre",
      0.035
    ],
    [
      "mental",
      0.035
    ],
    [
      "bien",
      0.035
    ],
    [
      "combativite",
      0.015
    ],
    [
      "honorable",
      0.015
    ],
    [
      "intellectuel",
      0.015
    ],
    [
      "mentalite",
      0.015
    ],
    [
      "moralisateur",
      0.015
    ],
    [
      "psychique",
      0.015
    ],
    [
      "psychisme",
      0.015
    ]
  ],
  "ivresse": [
    [
      "exaltation",
      0.1075
    ],
    [
      "transport",
      0.0675
    ],
    [
      "enthousiasme",
      0.0625
    ],
    [
      "enivrement",
      0.055
    ],
    [
      "griserie",
      0.055
    ],
    [
      "ivrognerie",
      0.0425
    ],
    [
      "excitation",
      0.0425
    ],
    [
      "delire",
      0.0425
    ],
    [
      "debauche",
      0.0375
    ],
    [
      "passion",
      0.0375
    ],
    [
      "vertige",
      0.03
    ],
    [
      "joie",
      0.03
    ],
    [
      "extase",
      0.03
    ],
    [
      "alcoolisme",
      0.025
    ],
    [
      "emotion",
      0.0175
    ],
    [
      "volupte",
      0.0175
    ],
    [
      "ravissement",
      0.0175
    ],
    [
      "enchantement",
      0.0175
    ],
    [
      "biture",
      0.0175
    ],
    [
      "etourdissement",
      0.01
    ],
    [
      "soulographie",
      0.01
    ],
    [
      "soulerie",
      0.01
    ],
    [
      "fureur",
      0.01
    ],
    [
      "fumee",
      0.01
    ],
    [
      "frenesie",
      0.01
    ],
    [
      "emballement",
      0.01
    ],
    [
      "cuite",
      0.01
    ],
    [
      "boisson",
      0.01
    ],
    [
      "alcool",
      0.01
    ],
    [
      "intemperance",
      0.005
    ],
    [
      "ivrogne",
      0.005
    ],
    [
      "pistache",
      0.005
    ],
    [
      "pamoison",
      0.005
    ],
    [
      "ribote",
      0.005
    ],
    [
      "ebriete",
      0.005
    ],
    [
      "ilotisme",
      0.005
    ],
    [
      "hebetude",
      0.005
    ],
    [
      "dipsomanie",
      0.005
    ],
    [
      "culotte",
      0.005
    ],
    [
      "crapule",
      0.005
    ],
    [
      "cocarde",
      0.005
    ],
    [
      "beurree",
      0.005
    ],
    [
      "amour",
      0.005
    ],
    [
      "alacrite",
      0.005
    ],
    [
      "ethylisme",
      0.005
    ]
  ],
  "futur": [
    [
      "avenir",
      0.1375
    ],
    [
      "fiance",
      0.05
    ],
    [
      "suite",
      0.05
    ],
    [
      "suivant",
      0.05
    ],
    [
      "temps",
      0.05
    ],
    [
      "ulterieur",
      0.0325
    ],
    [
      "prochain",
      0.0325
    ],
    [
      "posterite",
      0.0325
    ],
    [
      "lendemain",
      0.0325
    ],
    [
      "esperance",
      0.0325
    ],
    [
      "attente",
      0.0325
    ],
    [
      "posterieur",
      0.015
    ],
    [
      "posteriorite",
      0.015
    ],
    [
      "proche",
      0.015
    ],
    [
      "promis",
      0.015
    ],
    [
      "prospective",
      0.015
    ],
    [
      "pretendant",
      0.015
    ],
    [
      "pretendu",
      0.015
    ],
    [
      "prevision",
      0.015
    ],
    [
      "ulteriorite",
      0.015
    ],
    [
      "possible",
      0.015
    ],
    [
      "accorde",
      0.015
    ],
    [
      "demain",
      0.015
    ],
    [
      "destin",
      0.015
    ],
    [
      "destinee",
      0.015
    ],
    [
      "devenir",
      0.015
    ],
    [
      "expectative",
      0.015
    ],
    [
      "immortel",
      0.015
    ],
    [
      "eternite",
      0.015
    ]
  ],
  "promesse": [
    [
      "engagement",
      0.12
    ],
    [
      "assurance",
      0.1025
    ],
    [
      "annonce",
      0.0675
    ],
    [
      "declaration",
      0.0675
    ],
    [
      "serment",
      0.0675
    ],
    [
      "parole",
      0.05
    ],
    [
      "offre",
      0.05
    ],
    [
      "foi",
      0.05
    ],
    [
      "contrat",
      0.05
    ],
    [
      "presage",
      0.0325
    ],
    [
      "protestation",
      0.0325
    ],
    [
      "proposition",
      0.0325
    ],
    [
      "obligation",
      0.0325
    ],
    [
      "convention",
      0.0325
    ],
    [
      "vent",
      0.015
    ],
    [
      "traite",
      0.015
    ],
    [
      "surenchere",
      0.015
    ],
    [
      "signe",
      0.015
    ],
    [
      "prediction",
      0.015
    ],
    [
      "pollicitation",
      0.015
    ],
    [
      "gage",
      0.015
    ],
    [
      "esperance",
      0.015
    ],
    [
      "billet",
      0.015
    ],
    [
      "voeu",
      0.015
    ]
  ],
  "tronche": [
    [
      "tete",
      0.2725
    ],
    [
      "visage",
      0.2275
    ],
    [
      "binette",
      0.135
    ],
    [
      "trombine",
      0.045
    ],
    [
      "trogne",
      0.045
    ],
    [
      "terrine",
      0.045
    ],
    [
      "gueule",
      0.045
    ],
    [
      "buche",
      0.045
    ],
    [
      "bouille",
      0.045
    ],
    [
      "bobine",
      0.045
    ],
    [
      "tronc",
      0.045
    ]
  ],
  "tomber": [
    [
      "disparaitre",
      0.0325
    ],
    [
      "s'ecrouler",
      0.0325
    ],
    [
      "baisser",
      0.0275
    ],
    [
      "passer",
      0.0275
    ],
    [
      "diminuer",
      0.0275
    ],
    [
      "mourir",
      0.025
    ],
    [
      "ceder",
      0.0225
    ],
    [
      "s'evanouir",
      0.02
    ],
    [
      "s'affaisser",
      0.02
    ],
    [
      "degringoler",
      0.02
    ],
    [
      "decliner",
      0.02
    ],
    [
      "descendre",
      0.02
    ],
    [
      "s'effondrer",
      0.02
    ],
    [
      "s'eteindre",
      0.0175
    ],
    [
      "finir",
      0.0175
    ],
    [
      "dechoir",
      0.0175
    ],
    [
      "arriver",
      0.0175
    ],
    [
      "cesser",
      0.015
    ],
    [
      "s'enfoncer",
      0.015
    ],
    [
      "couler",
      0.015
    ],
    [
      "venir",
      0.0125
    ],
    [
      "s'affaiblir",
      0.0125
    ],
    [
      "s'abattre",
      0.0125
    ],
    [
      "perir",
      0.0125
    ],
    [
      "abandonner",
      0.0125
    ],
    [
      "faiblir",
      0.01
    ],
    [
      "sortir",
      0.01
    ],
    [
      "survenir",
      0.01
    ],
    [
      "s'abaisser",
      0.01
    ],
    [
      "crouler",
      0.01
    ],
    [
      "chuter",
      0.01
    ],
    [
      "aboutir",
      0.01
    ],
    [
      "s'aneantir",
      0.0075
    ],
    [
      "s'affaler",
      0.0075
    ],
    [
      "glisser",
      0.0075
    ],
    [
      "decroitre",
      0.0075
    ],
    [
      "aller",
      0.0075
    ],
    [
      "surgir",
      0.005
    ],
    [
      "s'abimer",
      0.005
    ],
    [
      "quitter",
      0.005
    ],
    [
      "manquer",
      0.005
    ],
    [
      "advenir",
      0.005
    ],
    [
      "ecraser",
      0.005
    ],
    [
      "succomber",
      0.005
    ],
    [
      "s'etaler",
      0.005
    ],
    [
      "rouler",
      0.005
    ],
    [
      "culbuter",
      0.005
    ],
    [
      "sauter",
      0.005
    ],
    [
      "trebucher",
      0.005
    ],
    [
      "echouer",
      0.005
    ],
    [
      "s'elancer",
      0.005
    ],
    [
      "s'aplatir",
      0.005
    ],
    [
      "fuser",
      0.005
    ],
    [
      "choir",
      0.005
    ],
    [
      "debouler",
      0.005
    ],
    [
      "defaillir",
      0.005
    ],
    [
      "degenerer",
      0.005
    ],
    [
      "faillir",
      0.005
    ],
    [
      "s'apaiser",
      0.0025
    ],
    [
      "s'avilir",
      0.0025
    ],
    [
      "s'envoler",
      0.0025
    ],
    [
      "echapper",
      0.0025
    ],
    [
      "s'accomplir",
      0.0025
    ],
    [
      "retomber",
      0.0025
    ],
    [
      "renverser",
      0.0025
    ],
    [
      "avoir",
      0.0025
    ],
    [
      "capituler",
      0.0025
    ],
    [
      "casser",
      0.0025
    ],
    [
      "devenir",
      0.0025
    ],
    [
      "deboucher",
      0.0025
    ],
    [
      "mollir",
      0.0025
    ],
    [
      "peser",
      0.0025
    ],
    [
      "pericliter",
      0.0025
    ],
    [
      "s'allonger",
      0.0
    ],
    [
      "s'offrir",
      0.0
    ],
    [
      "s'operer",
      0.0
    ],
    [
      "trainer",
      0.0
    ],
    [
      "verser",
      0.0
    ],
    [
      "echoir",
      0.0
    ],
    [
      "s'abatardir",
      0.0
    ],
    [
      "pecher",
      0.0
    ],
    [
      "pleuvoir",
      0.0
    ],
    [
      "basculer",
      0.0
    ],
    [
      "bouler",
      0.0
    ],
    [
      "devaler",
      0.0
    ],
    [
      "intervenir",
      0.0
    ],
    [
      "l'emporter",
      0.0
    ],
    [
      "pendiller",
      0.0
    ],
    [
      "pendre",
      0.0
    ],
    [
      "piquer",
      0.0
    ],
    [
      "seduire",
      0.0
    ],
    [
      "terrasser",
      0.0
    ],
    [
      "valdinguer",
      0.0
    ],
    [
      "ebouler",
      0.0
    ],
    [
      "s'attenuer",
      0.0
    ],
    [
      "s'amoindrir",
      0.0
    ],
    [
      "conquerir",
      0.0
    ],
    [
      "dinguer",
      0.0
    ],
    [
      "dire",
      0.0
    ],
    [
      "degoutter",
      0.0
    ],
    [
      "effondrer",
      0.0
    ],
    [
      "rejoindre",
      0.0
    ],
    [
      "retrograder",
      0.0
    ],
    [
      "s'amener",
      0.0
    ]
  ],
  "tombe": [
    [
      "disparaitre",
      0.0325
    ],
    [
      "s'ecrouler",
      0.0325
    ],
    [
      "baisser",
      0.0275
    ],
    [
      "passer",
      0.0275
    ],
    [
      "diminuer",
      0.0275
    ],
    [
      "mourir",
      0.025
    ],
    [
      "ceder",
      0.0225
    ],
    [
      "s'evanouir",
      0.02
    ],
    [
      "s'affaisser",
      0.02
    ],
    [
      "degringoler",
      0.02
    ],
    [
      "decliner",
      0.02
    ],
    [
      "descendre",
      0.02
    ],
    [
      "s'effondrer",
      0.02
    ],
    [
      "s'eteindre",
      0.0175
    ],
    [
      "finir",
      0.0175
    ],
    [
      "dechoir",
      0.0175
    ],
    [
      "arriver",
      0.0175
    ],
    [
      "cesser",
      0.015
    ],
    [
      "s'enfoncer",
      0.015
    ],
    [
      "couler",
      0.015
    ],
    [
      "venir",
      0.0125
    ],
    [
      "s'affaiblir",
      0.0125
    ],
    [
      "s'abattre",
      0.0125
    ],
    [
      "perir",
      0.0125
    ],
    [
      "abandonner",
      0.0125
    ],
    [
      "faiblir",
      0.01
    ],
    [
      "sortir",
      0.01
    ],
    [
      "survenir",
      0.01
    ],
    [
      "s'abaisser",
      0.01
    ],
    [
      "crouler",
      0.01
    ],
    [
      "chuter",
      0.01
    ],
    [
      "aboutir",
      0.01
    ],
    [
      "s'aneantir",
      0.0075
    ],
    [
      "s'affaler",
      0.0075
    ],
    [
      "glisser",
      0.0075
    ],
    [
      "decroitre",
      0.0075
    ],
    [
      "aller",
      0.0075
    ],
    [
      "surgir",
      0.005
    ],
    [
      "s'abimer",
      0.005
    ],
    [
      "quitter",
      0.005
    ],
    [
      "manquer",
      0.005
    ],
    [
      "advenir",
      0.005
    ],
    [
      "ecraser",
      0.005
    ],
    [
      "succomber",
      0.005
    ],
    [
      "s'etaler",
      0.005
    ],
    [
      "rouler",
      0.005
    ],
    [
      "culbuter",
      0.005
    ],
    [
      "sauter",
      0.005
    ],
    [
      "trebucher",
      0.005
    ],
    [
      "echouer",
      0.005
    ],
    [
      "s'elancer",
      0.005
    ],
    [
      "s'aplatir",
      0.005
    ],
    [
      "fuser",
      0.005
    ],
    [
      "choir",
      0.005
    ],
    [
      "debouler",
      0.005
    ],
    [
      "defaillir",
      0.005
    ],
    [
      "degenerer",
      0.005
    ],
    [
      "faillir",
      0.005
    ],
    [
      "s'apaiser",
      0.0025
    ],
    [
      "s'avilir",
      0.0025
    ],
    [
      "s'envoler",
      0.0025
    ],
    [
      "echapper",
      0.0025
    ],
    [
      "s'accomplir",
      0.0025
    ],
    [
      "retomber",
      0.0025
    ],
    [
      "renverser",
      0.0025
    ],
    [
      "avoir",
      0.0025
    ],
    [
      "capituler",
      0.0025
    ],
    [
      "casser",
      0.0025
    ],
    [
      "devenir",
      0.0025
    ],
    [
      "deboucher",
      0.0025
    ],
    [
      "mollir",
      0.0025
    ],
    [
      "peser",
      0.0025
    ],
    [
      "pericliter",
      0.0025
    ],
    [
      "s'allonger",
      0.0
    ],
    [
      "s'offrir",
      0.0
    ],
    [
      "s'operer",
      0.0
    ],
    [
      "trainer",
      0.0
    ],
    [
      "verser",
      0.0
    ],
    [
      "echoir",
      0.0
    ],
    [
      "s'abatardir",
      0.0
    ],
    [
      "pecher",
      0.0
    ],
    [
      "pleuvoir",
      0.0
    ],
    [
      "basculer",
      0.0
    ],
    [
      "bouler",
      0.0
    ],
    [
      "devaler",
      0.0
    ],
    [
      "intervenir",
      0.0
    ],
    [
      "l'emporter",
      0.0
    ],
    [
      "pendiller",
      0.0
    ],
    [
      "pendre",
      0.0
    ],
    [
      "piquer",
      0.0
    ],
    [
      "seduire",
      0.0
    ],
    [
      "terrasser",
      0.0
    ],
    [
      "valdinguer",
      0.0
    ],
    [
      "ebouler",
      0.0
    ],
    [
      "s'attenuer",
      0.0
    ],
    [
      "s'amoindrir",
      0.0
    ],
    [
      "conquerir",
      0.0
    ],
    [
      "dinguer",
      0.0
    ],
    [
      "dire",
      0.0
    ],
    [
      "degoutter",
      0.0
    ],
    [
      "effondrer",
      0.0
    ],
    [
      "rejoindre",
      0.0
    ],
    [
      "retrograder",
      0.0
    ],
    [
      "s'amener",
      0.0
    ]
  ],
  "bronche": [
    [
      "remuer",
      0.0975
    ],
    [
      "chopper",
      0.0775
    ],
    [
      "trebucher",
      0.0575
    ],
    [
      "s'agiter",
      0.0575
    ],
    [
      "chanceler",
      0.0575
    ],
    [
      "bouger",
      0.0575
    ],
    [
      "tituber",
      0.0375
    ],
    [
      "pecher",
      0.0375
    ],
    [
      "faillir",
      0.0375
    ],
    [
      "clocher",
      0.0375
    ],
    [
      "ciller",
      0.0375
    ],
    [
      "chahuter",
      0.0375
    ],
    [
      "buter",
      0.0375
    ],
    [
      "achopper",
      0.0375
    ],
    [
      "ronchonner",
      0.0175
    ],
    [
      "rouspeter",
      0.0175
    ],
    [
      "s'achopper",
      0.0175
    ],
    [
      "murmurer",
      0.0175
    ],
    [
      "manquer",
      0.0175
    ],
    [
      "manifester",
      0.0175
    ],
    [
      "hesiter",
      0.0175
    ],
    [
      "ceder",
      0.0175
    ],
    [
      "contester",
      0.0175
    ],
    [
      "cligner",
      0.0175
    ],
    [
      "tressaillir",
      0.0175
    ]
  ],
  "broncher": [
    [
      "remuer",
      0.0975
    ],
    [
      "chopper",
      0.0775
    ],
    [
      "trebucher",
      0.0575
    ],
    [
      "s'agiter",
      0.0575
    ],
    [
      "chanceler",
      0.0575
    ],
    [
      "bouger",
      0.0575
    ],
    [
      "tituber",
      0.0375
    ],
    [
      "pecher",
      0.0375
    ],
    [
      "faillir",
      0.0375
    ],
    [
      "clocher",
      0.0375
    ],
    [
      "ciller",
      0.0375
    ],
    [
      "chahuter",
      0.0375
    ],
    [
      "buter",
      0.0375
    ],
    [
      "achopper",
      0.0375
    ],
    [
      "ronchonner",
      0.0175
    ],
    [
      "rouspeter",
      0.0175
    ],
    [
      "s'achopper",
      0.0175
    ],
    [
      "murmurer",
      0.0175
    ],
    [
      "manquer",
      0.0175
    ],
    [
      "manifester",
      0.0175
    ],
    [
      "hesiter",
      0.0175
    ],
    [
      "ceder",
      0.0175
    ],
    [
      "contester",
      0.0175
    ],
    [
      "cligner",
      0.0175
    ],
    [
      "tressaillir",
      0.0175
    ]
  ],
  "etrangement": [
    [
      "curieusement",
      0.285
    ],
    [
      "bizarrement",
      0.19
    ],
    [
      "drolement",
      0.095
    ],
    [
      "extraordinairement",
      0.095
    ],
    [
      "terriblement",
      0.095
    ],
    [
      "singulierement",
      0.045
    ],
    [
      "paradoxalement",
      0.045
    ],
    [
      "inexplicablement",
      0.045
    ],
    [
      "anormalement",
      0.045
    ],
    [
      "etonnamment",
      0.045
    ]
  ],
  "normal": [
    [
      "regulier",
      0.0875
    ],
    [
      "regle",
      0.08
    ],
    [
      "exact",
      0.0525
    ],
    [
      "naturel",
      0.0525
    ],
    [
      "ordinaire",
      0.0525
    ],
    [
      "raisonnable",
      0.0425
    ],
    [
      "honnete",
      0.0425
    ],
    [
      "habituel",
      0.035
    ],
    [
      "logique",
      0.035
    ],
    [
      "sain",
      0.035
    ],
    [
      "solide",
      0.025
    ],
    [
      "robuste",
      0.025
    ],
    [
      "rationnel",
      0.025
    ],
    [
      "ordonne",
      0.025
    ],
    [
      "determine",
      0.025
    ],
    [
      "courant",
      0.025
    ],
    [
      "correct",
      0.025
    ],
    [
      "systematique",
      0.015
    ],
    [
      "range",
      0.015
    ],
    [
      "quotidien",
      0.015
    ],
    [
      "organise",
      0.015
    ],
    [
      "methodique",
      0.015
    ],
    [
      "moyen",
      0.015
    ],
    [
      "mesure",
      0.015
    ],
    [
      "legitime",
      0.015
    ],
    [
      "decide",
      0.015
    ],
    [
      "comprehensible",
      0.015
    ],
    [
      "classique",
      0.015
    ],
    [
      "journalier",
      0.0075
    ],
    [
      "perpendiculaire",
      0.0075
    ],
    [
      "ponctuel",
      0.0075
    ],
    [
      "previsible",
      0.0075
    ],
    [
      "traditionnel",
      0.0075
    ],
    [
      "inne",
      0.0075
    ],
    [
      "fixe",
      0.0075
    ],
    [
      "dispos",
      0.0075
    ],
    [
      "canonique",
      0.0075
    ],
    [
      "calcule",
      0.0075
    ],
    [
      "arrete",
      0.0075
    ],
    [
      "aise",
      0.0075
    ],
    [
      "valable",
      0.0075
    ]
  ],
  "manche": [
    [
      "baton",
      0.115
    ],
    [
      "bras",
      0.0775
    ],
    [
      "verge",
      0.0775
    ],
    [
      "manchette",
      0.0375
    ],
    [
      "manicle",
      0.0375
    ],
    [
      "manivelle",
      0.0375
    ],
    [
      "partie",
      0.0375
    ],
    [
      "poche",
      0.0375
    ],
    [
      "queue",
      0.0375
    ],
    [
      "revanche",
      0.0375
    ],
    [
      "set",
      0.0375
    ],
    [
      "imbecile",
      0.0375
    ],
    [
      "idiot",
      0.0375
    ],
    [
      "belle",
      0.0375
    ],
    [
      "conduit",
      0.0375
    ],
    [
      "couillon",
      0.0375
    ],
    [
      "detroit",
      0.0375
    ],
    [
      "emmanchure",
      0.0375
    ],
    [
      "ente",
      0.0375
    ],
    [
      "entournure",
      0.0375
    ],
    [
      "hampe",
      0.0375
    ],
    [
      "tuyau",
      0.0375
    ]
  ],
  "temperament": [
    [
      "nature",
      0.185
    ],
    [
      "caractere",
      0.0725
    ],
    [
      "constitution",
      0.065
    ],
    [
      "disposition",
      0.065
    ],
    [
      "naturel",
      0.065
    ],
    [
      "organisation",
      0.05
    ],
    [
      "complexion",
      0.0425
    ],
    [
      "esprit",
      0.0425
    ],
    [
      "humeur",
      0.035
    ],
    [
      "composition",
      0.035
    ],
    [
      "inclination",
      0.0275
    ],
    [
      "mesure",
      0.0275
    ],
    [
      "coeur",
      0.02
    ],
    [
      "equilibre",
      0.0125
    ],
    [
      "sante",
      0.0125
    ],
    [
      "pate",
      0.0125
    ],
    [
      "propension",
      0.0125
    ],
    [
      "personnalite",
      0.0125
    ],
    [
      "penchant",
      0.0125
    ],
    [
      "moderation",
      0.0125
    ],
    [
      "milieu",
      0.0125
    ],
    [
      "correction",
      0.0125
    ],
    [
      "attenuation",
      0.0125
    ],
    [
      "adoucissement",
      0.0125
    ],
    [
      "physique",
      0.005
    ],
    [
      "salacite",
      0.005
    ],
    [
      "sensualite",
      0.005
    ],
    [
      "trempe",
      0.005
    ],
    [
      "vitalite",
      0.005
    ],
    [
      "moyenne",
      0.005
    ],
    [
      "moyen",
      0.005
    ],
    [
      "modification",
      0.005
    ],
    [
      "impetuosite",
      0.005
    ],
    [
      "idiosyncrasie",
      0.005
    ],
    [
      "feu",
      0.005
    ],
    [
      "diathese",
      0.005
    ],
    [
      "carcasse",
      0.005
    ],
    [
      "etat",
      0.005
    ]
  ],
  "guerrier": [
    [
      "belliciste",
      0.125
    ],
    [
      "belliqueux",
      0.125
    ],
    [
      "combatif",
      0.125
    ],
    [
      "soldat",
      0.125
    ],
    [
      "militant",
      0.0825
    ],
    [
      "militaire",
      0.0825
    ],
    [
      "combattant",
      0.0825
    ],
    [
      "baroudeur",
      0.04
    ],
    [
      "boutefeu",
      0.04
    ],
    [
      "conquerant",
      0.04
    ],
    [
      "guerroyeur",
      0.04
    ],
    [
      "martial",
      0.04
    ]
  ],
  "celibataire": [
    [
      "fille",
      0.165
    ],
    [
      "garcon",
      0.11
    ],
    [
      "seul",
      0.11
    ],
    [
      "solitaire",
      0.055
    ],
    [
      "libre",
      0.055
    ],
    [
      "disponible",
      0.055
    ],
    [
      "demoiselle",
      0.055
    ],
    [
      "catherinette",
      0.055
    ]
  ],
  "gangster": [
    [
      "bandit",
      0.195
    ],
    [
      "brigand",
      0.12
    ],
    [
      "voleur",
      0.12
    ],
    [
      "fripouille",
      0.0975
    ],
    [
      "malfaiteur",
      0.0975
    ],
    [
      "truand",
      0.0725
    ],
    [
      "crapule",
      0.0725
    ],
    [
      "criminel",
      0.0475
    ],
    [
      "meurtrier",
      0.0475
    ],
    [
      "terreur",
      0.0475
    ],
    [
      "canaille",
      0.0225
    ],
    [
      "escroc",
      0.0225
    ],
    [
      "requin",
      0.0225
    ]
  ],
  "millionnaire": [
    [
      "nabab",
      0.3325
    ],
    [
      "riche",
      0.3325
    ],
    [
      "richissime",
      0.3325
    ]
  ],
  "bobo": [
    [
      "douleur",
      0.4
    ],
    [
      "blessure",
      0.2
    ],
    [
      "chancre",
      0.2
    ],
    [
      "mal",
      0.2
    ]
  ],
  "intello": [
    [
      "intellectuel",
      1.0
    ]
  ],
  "fumette": [],
  "quartier": [
    [
      "partie",
      0.105
    ],
    [
      "region",
      0.075
    ],
    [
      "zone",
      0.075
    ],
    [
      "coin",
      0.06
    ],
    [
      "morceau",
      0.06
    ],
    [
      "ration",
      0.045
    ],
    [
      "portion",
      0.045
    ],
    [
      "pays",
      0.045
    ],
    [
      "terme",
      0.03
    ],
    [
      "secteur",
      0.03
    ],
    [
      "logement",
      0.03
    ],
    [
      "gite",
      0.03
    ],
    [
      "casernement",
      0.03
    ],
    [
      "misericorde",
      0.015
    ],
    [
      "medina",
      0.015
    ],
    [
      "phase",
      0.015
    ],
    [
      "piece",
      0.015
    ],
    [
      "province",
      0.015
    ],
    [
      "quart",
      0.015
    ],
    [
      "taniere",
      0.015
    ],
    [
      "tranche",
      0.015
    ],
    [
      "trimestre",
      0.015
    ],
    [
      "merci",
      0.015
    ],
    [
      "mellah",
      0.015
    ],
    [
      "grace",
      0.015
    ],
    [
      "arrondissement",
      0.015
    ],
    [
      "caserne",
      0.015
    ],
    [
      "contree",
      0.015
    ],
    [
      "croissant",
      0.015
    ],
    [
      "district",
      0.015
    ],
    [
      "endroit",
      0.015
    ],
    [
      "faubourg",
      0.015
    ],
    [
      "fraction",
      0.015
    ],
    [
      "ghetto",
      0.015
    ],
    [
      "echeance",
      0.015
    ]
  ],
  "bloc": [
    [
      "assemblage",
      0.0875
    ],
    [
      "ensemble",
      0.07
    ],
    [
      "groupe",
      0.07
    ],
    [
      "masse",
      0.07
    ],
    [
      "reunion",
      0.07
    ],
    [
      "amas",
      0.0425
    ],
    [
      "groupement",
      0.03
    ],
    [
      "tas",
      0.03
    ],
    [
      "union",
      0.03
    ],
    [
      "unite",
      0.025
    ],
    [
      "roche",
      0.025
    ],
    [
      "quantite",
      0.025
    ],
    [
      "morceau",
      0.025
    ],
    [
      "coalition",
      0.025
    ],
    [
      "agglomerat",
      0.0175
    ],
    [
      "agglomeration",
      0.0175
    ],
    [
      "piece",
      0.0175
    ],
    [
      "pave",
      0.0125
    ],
    [
      "poids",
      0.0125
    ],
    [
      "pate",
      0.0125
    ],
    [
      "totalite",
      0.0125
    ],
    [
      "tout",
      0.0125
    ],
    [
      "ilot",
      0.0125
    ],
    [
      "paquet",
      0.0125
    ],
    [
      "ouvrage",
      0.0125
    ],
    [
      "moellon",
      0.0125
    ],
    [
      "bille",
      0.0125
    ],
    [
      "billot",
      0.0125
    ],
    [
      "cartel",
      0.0125
    ],
    [
      "cellule",
      0.0125
    ],
    [
      "front",
      0.0125
    ],
    [
      "federation",
      0.0125
    ],
    [
      "famille",
      0.005
    ],
    [
      "libage",
      0.005
    ],
    [
      "lot",
      0.005
    ],
    [
      "monolithe",
      0.005
    ],
    [
      "parpaing",
      0.005
    ],
    [
      "prison",
      0.005
    ],
    [
      "rocher",
      0.005
    ],
    [
      "commissariat",
      0.005
    ],
    [
      "cheminee",
      0.005
    ],
    [
      "caillou",
      0.005
    ],
    [
      "agregat",
      0.005
    ],
    [
      "aerolithe",
      0.005
    ],
    [
      "blocage",
      0.005
    ],
    [
      "blockhaus",
      0.005
    ],
    [
      "boulder",
      0.005
    ],
    [
      "cachot",
      0.005
    ],
    [
      "cahier",
      0.005
    ],
    [
      "zone",
      0.005
    ]
  ],
  "residence": [
    [
      "domicile",
      0.1775
    ],
    [
      "demeure",
      0.1425
    ],
    [
      "habitation",
      0.1425
    ],
    [
      "maison",
      0.1425
    ],
    [
      "sejour",
      0.07
    ],
    [
      "logement",
      0.07
    ],
    [
      "lieu",
      0.07
    ],
    [
      "adresse",
      0.07
    ],
    [
      "chateau",
      0.035
    ],
    [
      "penates",
      0.035
    ],
    [
      "siege",
      0.035
    ]
  ],
  "huppe": [
    [
      "fortune",
      0.285
    ],
    [
      "riche",
      0.285
    ],
    [
      "cossu",
      0.1425
    ],
    [
      "opulent",
      0.1425
    ],
    [
      "privilegie",
      0.1425
    ]
  ],
  "black": [],
  "jaune": [
    [
      "dore",
      0.1325
    ],
    [
      "kaki",
      0.11
    ],
    [
      "fauve",
      0.065
    ],
    [
      "renard",
      0.0425
    ],
    [
      "ocre",
      0.0425
    ],
    [
      "jaunatre",
      0.0425
    ],
    [
      "flavescent",
      0.0425
    ],
    [
      "ambre",
      0.0425
    ],
    [
      "jauni",
      0.02
    ],
    [
      "ocre",
      0.02
    ],
    [
      "or",
      0.02
    ],
    [
      "pique",
      0.02
    ],
    [
      "safran",
      0.02
    ],
    [
      "safrane",
      0.02
    ],
    [
      "saure",
      0.02
    ],
    [
      "terreux",
      0.02
    ],
    [
      "tigre",
      0.02
    ],
    [
      "isabelle",
      0.02
    ],
    [
      "cuivre",
      0.02
    ],
    [
      "bilieux",
      0.02
    ],
    [
      "blond",
      0.02
    ],
    [
      "briseur",
      0.02
    ],
    [
      "bronze",
      0.02
    ],
    [
      "chamois",
      0.02
    ],
    [
      "chinois",
      0.02
    ],
    [
      "cireux",
      0.02
    ],
    [
      "citron",
      0.02
    ],
    [
      "topaze",
      0.02
    ]
  ],
  "vert": [
    [
      "cru",
      0.075
    ],
    [
      "gaillard",
      0.055
    ],
    [
      "leste",
      0.055
    ],
    [
      "libre",
      0.055
    ],
    [
      "vif",
      0.055
    ],
    [
      "egrillard",
      0.04
    ],
    [
      "ose",
      0.04
    ],
    [
      "aigre",
      0.04
    ],
    [
      "violent",
      0.0325
    ],
    [
      "raide",
      0.0325
    ],
    [
      "licencieux",
      0.0325
    ],
    [
      "hardi",
      0.0325
    ],
    [
      "bleu",
      0.025
    ],
    [
      "graveleux",
      0.025
    ],
    [
      "rude",
      0.025
    ],
    [
      "vigoureux",
      0.025
    ],
    [
      "verdatre",
      0.02
    ],
    [
      "pers",
      0.02
    ],
    [
      "nouveau",
      0.02
    ],
    [
      "jeune",
      0.0125
    ],
    [
      "herbe",
      0.0125
    ],
    [
      "gaulois",
      0.0125
    ],
    [
      "brutal",
      0.0125
    ],
    [
      "bleme",
      0.0125
    ],
    [
      "allegre",
      0.0125
    ],
    [
      "aigrelet",
      0.0125
    ],
    [
      "acide",
      0.0125
    ],
    [
      "tilleul",
      0.005
    ],
    [
      "sinople",
      0.005
    ],
    [
      "rapeux",
      0.005
    ],
    [
      "pale",
      0.005
    ],
    [
      "prairie",
      0.005
    ],
    [
      "vaillant",
      0.005
    ],
    [
      "valide",
      0.005
    ],
    [
      "verdelet",
      0.005
    ],
    [
      "verdoyant",
      0.005
    ],
    [
      "ecolo",
      0.005
    ],
    [
      "ecologiste",
      0.005
    ],
    [
      "emeraude",
      0.005
    ],
    [
      "pomme",
      0.005
    ],
    [
      "polisson",
      0.005
    ],
    [
      "olivatre",
      0.005
    ],
    [
      "bilieux",
      0.005
    ],
    [
      "bouteille",
      0.005
    ],
    [
      "celadon",
      0.005
    ],
    [
      "gazon",
      0.005
    ],
    [
      "ginguet",
      0.005
    ],
    [
      "glauque",
      0.005
    ],
    [
      "herbeux",
      0.005
    ],
    [
      "jade",
      0.005
    ],
    [
      "juvenile",
      0.005
    ],
    [
      "mordant",
      0.005
    ],
    [
      "olive",
      0.005
    ],
    [
      "acerbe",
      0.005
    ]
  ],
  "gris": [
    [
      "ivre",
      0.105
    ],
    [
      "morne",
      0.0775
    ],
    [
      "emeche",
      0.05
    ],
    [
      "terne",
      0.05
    ],
    [
      "soul",
      0.05
    ],
    [
      "pale",
      0.05
    ],
    [
      "pompette",
      0.05
    ],
    [
      "livide",
      0.05
    ],
    [
      "bis",
      0.05
    ],
    [
      "morose",
      0.025
    ],
    [
      "noir",
      0.025
    ],
    [
      "nuageux",
      0.025
    ],
    [
      "plat",
      0.025
    ],
    [
      "poussiereux",
      0.025
    ],
    [
      "tabac",
      0.025
    ],
    [
      "monocorde",
      0.025
    ],
    [
      "grise",
      0.025
    ],
    [
      "grisette",
      0.025
    ],
    [
      "griset",
      0.025
    ],
    [
      "grisaille",
      0.025
    ],
    [
      "gai",
      0.025
    ],
    [
      "decolore",
      0.025
    ],
    [
      "bistre",
      0.025
    ],
    [
      "beige",
      0.025
    ],
    [
      "argente",
      0.025
    ],
    [
      "emu",
      0.025
    ]
  ],
  "amalgame": [
    [
      "melange",
      0.195
    ],
    [
      "combinaison",
      0.1125
    ],
    [
      "assemblage",
      0.0975
    ],
    [
      "reunion",
      0.08
    ],
    [
      "union",
      0.0475
    ],
    [
      "confusion",
      0.0475
    ],
    [
      "compose",
      0.0475
    ],
    [
      "assimilation",
      0.0475
    ],
    [
      "alliance",
      0.0475
    ],
    [
      "rapprochement",
      0.03
    ],
    [
      "integration",
      0.03
    ],
    [
      "incorporation",
      0.03
    ],
    [
      "composition",
      0.03
    ],
    [
      "plombage",
      0.015
    ],
    [
      "imbrication",
      0.015
    ],
    [
      "fusionnement",
      0.015
    ],
    [
      "dosage",
      0.015
    ],
    [
      "brassage",
      0.015
    ],
    [
      "alliage",
      0.015
    ],
    [
      "agglomerat",
      0.015
    ]
  ],
  "politique": [
    [
      "habilete",
      0.065
    ],
    [
      "diplomatie",
      0.0575
    ],
    [
      "gouvernement",
      0.0425
    ],
    [
      "truc",
      0.035
    ],
    [
      "ruse",
      0.035
    ],
    [
      "adresse",
      0.035
    ],
    [
      "tactique",
      0.0275
    ],
    [
      "systeme",
      0.0275
    ],
    [
      "jeu",
      0.0275
    ],
    [
      "habile",
      0.0275
    ],
    [
      "doigte",
      0.0275
    ],
    [
      "diplomate",
      0.0275
    ],
    [
      "astuce",
      0.0275
    ],
    [
      "adroit",
      0.0275
    ],
    [
      "strategie",
      0.02
    ],
    [
      "ruse",
      0.02
    ],
    [
      "finesse",
      0.02
    ],
    [
      "fin",
      0.02
    ],
    [
      "avise",
      0.02
    ],
    [
      "artifice",
      0.02
    ],
    [
      "affaire",
      0.02
    ],
    [
      "economie",
      0.0125
    ],
    [
      "souplesse",
      0.0125
    ],
    [
      "souple",
      0.0125
    ],
    [
      "prudent",
      0.0125
    ],
    [
      "prudence",
      0.0125
    ],
    [
      "pouvoir",
      0.0125
    ],
    [
      "negociateur",
      0.0125
    ],
    [
      "manege",
      0.0125
    ],
    [
      "machiavelique",
      0.0125
    ],
    [
      "circonspection",
      0.0125
    ],
    [
      "action",
      0.0125
    ],
    [
      "politicien",
      0.005
    ],
    [
      "policier",
      0.005
    ],
    [
      "police",
      0.005
    ],
    [
      "patient",
      0.005
    ],
    [
      "patience",
      0.005
    ],
    [
      "public",
      0.005
    ],
    [
      "renard",
      0.005
    ],
    [
      "sage",
      0.005
    ],
    [
      "sagesse",
      0.005
    ],
    [
      "social",
      0.005
    ],
    [
      "temporisation",
      0.005
    ],
    [
      "tractation",
      0.005
    ],
    [
      "negociation",
      0.005
    ],
    [
      "menage",
      0.005
    ],
    [
      "manoeuvrier",
      0.005
    ],
    [
      "ambassade",
      0.005
    ],
    [
      "calcul",
      0.005
    ],
    [
      "calculateur",
      0.005
    ],
    [
      "civil",
      0.005
    ],
    [
      "civique",
      0.005
    ],
    [
      "demagogie",
      0.005
    ],
    [
      "democratie",
      0.005
    ],
    [
      "federalisme",
      0.005
    ],
    [
      "etat",
      0.005
    ]
  ],
  "paix": [
    [
      "calme",
      0.1325
    ],
    [
      "tranquillite",
      0.11
    ],
    [
      "serenite",
      0.065
    ],
    [
      "quietude",
      0.0575
    ],
    [
      "accord",
      0.0425
    ],
    [
      "harmonie",
      0.0425
    ],
    [
      "repos",
      0.0425
    ],
    [
      "entente",
      0.035
    ],
    [
      "accalmie",
      0.035
    ],
    [
      "apaisement",
      0.0275
    ],
    [
      "equilibre",
      0.0275
    ],
    [
      "union",
      0.02
    ],
    [
      "securite",
      0.02
    ],
    [
      "ordre",
      0.02
    ],
    [
      "motus",
      0.02
    ],
    [
      "concorde",
      0.02
    ],
    [
      "conciliation",
      0.02
    ],
    [
      "bonheur",
      0.02
    ],
    [
      "bonace",
      0.02
    ],
    [
      "treve",
      0.0125
    ],
    [
      "traite",
      0.0125
    ],
    [
      "silence",
      0.0125
    ],
    [
      "reconciliation",
      0.0125
    ],
    [
      "pacification",
      0.0125
    ],
    [
      "douceur",
      0.0125
    ],
    [
      "beatitude",
      0.0125
    ],
    [
      "ataraxie",
      0.0125
    ],
    [
      "assouvissement",
      0.0125
    ],
    [
      "pacte",
      0.005
    ],
    [
      "negociation",
      0.005
    ],
    [
      "fraternite",
      0.005
    ],
    [
      "diktat",
      0.005
    ],
    [
      "chut",
      0.005
    ],
    [
      "armistice",
      0.005
    ],
    [
      "sagesse",
      0.005
    ]
  ],
  "tenue": [
    [
      "retenir",
      0.07
    ],
    [
      "contenir",
      0.035
    ],
    [
      "fixer",
      0.0325
    ],
    [
      "prendre",
      0.0325
    ],
    [
      "attacher",
      0.0325
    ],
    [
      "maintenir",
      0.025
    ],
    [
      "arreter",
      0.0225
    ],
    [
      "enchainer",
      0.02
    ],
    [
      "demeurer",
      0.02
    ],
    [
      "assujettir",
      0.02
    ],
    [
      "durer",
      0.0175
    ],
    [
      "observer",
      0.0175
    ],
    [
      "soutenir",
      0.0175
    ],
    [
      "occuper",
      0.015
    ],
    [
      "garder",
      0.015
    ],
    [
      "continuer",
      0.015
    ],
    [
      "avoir",
      0.0125
    ],
    [
      "embrasser",
      0.0125
    ],
    [
      "suivre",
      0.0125
    ],
    [
      "rester",
      0.0125
    ],
    [
      "mettre",
      0.0125
    ],
    [
      "immobiliser",
      0.0125
    ],
    [
      "faire",
      0.0125
    ],
    [
      "contraindre",
      0.0125
    ],
    [
      "appuyer",
      0.0125
    ],
    [
      "s'etendre",
      0.01
    ],
    [
      "posseder",
      0.01
    ],
    [
      "emprisonner",
      0.01
    ],
    [
      "coller",
      0.01
    ],
    [
      "brider",
      0.01
    ],
    [
      "trainer",
      0.0075
    ],
    [
      "pratiquer",
      0.0075
    ],
    [
      "porter",
      0.0075
    ],
    [
      "freiner",
      0.0075
    ],
    [
      "executer",
      0.0075
    ],
    [
      "engager",
      0.0075
    ],
    [
      "empecher",
      0.0075
    ],
    [
      "detenir",
      0.0075
    ],
    [
      "conserver",
      0.0075
    ],
    [
      "coincer",
      0.0075
    ],
    [
      "renfermer",
      0.0075
    ],
    [
      "perseverer",
      0.0075
    ],
    [
      "persister",
      0.0075
    ],
    [
      "endiguer",
      0.0075
    ],
    [
      "consigner",
      0.0075
    ],
    [
      "adherer",
      0.0075
    ],
    [
      "supporter",
      0.005
    ],
    [
      "subsister",
      0.005
    ],
    [
      "saisir",
      0.005
    ],
    [
      "s'attacher",
      0.005
    ],
    [
      "mener",
      0.005
    ],
    [
      "maitriser",
      0.005
    ],
    [
      "loger",
      0.005
    ],
    [
      "lier",
      0.005
    ],
    [
      "diriger",
      0.005
    ],
    [
      "recevoir",
      0.005
    ],
    [
      "remplir",
      0.005
    ],
    [
      "respecter",
      0.005
    ],
    [
      "resister",
      0.005
    ],
    [
      "moderer",
      0.005
    ],
    [
      "gouverner",
      0.005
    ],
    [
      "accomplir",
      0.005
    ],
    [
      "accrocher",
      0.005
    ],
    [
      "astreindre",
      0.005
    ],
    [
      "comprimer",
      0.005
    ],
    [
      "entrer",
      0.005
    ],
    [
      "venir",
      0.0025
    ],
    [
      "s'obstiner",
      0.0025
    ],
    [
      "resulter",
      0.0025
    ],
    [
      "ressortir",
      0.0025
    ],
    [
      "rendre",
      0.0025
    ],
    [
      "participer",
      0.0025
    ],
    [
      "manier",
      0.0025
    ],
    [
      "dependre",
      0.0025
    ],
    [
      "defendre",
      0.0025
    ],
    [
      "amarrer",
      0.0025
    ],
    [
      "absorber",
      0.0025
    ],
    [
      "resider",
      0.0025
    ],
    [
      "s'acquitter",
      0.0025
    ],
    [
      "s'etaler",
      0.0025
    ],
    [
      "satisfaire",
      0.0025
    ],
    [
      "surveiller",
      0.0025
    ],
    [
      "etreindre",
      0.0025
    ],
    [
      "ralentir",
      0.0025
    ],
    [
      "provenir",
      0.0025
    ],
    [
      "jouer",
      0.0025
    ],
    [
      "accaparer",
      0.0025
    ],
    [
      "administrer",
      0.0025
    ],
    [
      "clouer",
      0.0025
    ],
    [
      "comporter",
      0.0025
    ],
    [
      "discuter",
      0.0025
    ],
    [
      "exercer",
      0.0025
    ],
    [
      "jauger",
      0.0025
    ],
    [
      "s'etirer",
      0.0
    ],
    [
      "recouvrir",
      0.0
    ],
    [
      "naviguer",
      0.0
    ],
    [
      "gerer",
      0.0
    ],
    [
      "envisager",
      0.0
    ],
    [
      "effectuer",
      0.0
    ],
    [
      "deliberer",
      0.0
    ],
    [
      "appartenir",
      0.0
    ],
    [
      "agripper",
      0.0
    ]
  ],
  "tenu": [
    [
      "retenir",
      0.07
    ],
    [
      "contenir",
      0.035
    ],
    [
      "fixer",
      0.0325
    ],
    [
      "prendre",
      0.0325
    ],
    [
      "attacher",
      0.0325
    ],
    [
      "maintenir",
      0.025
    ],
    [
      "arreter",
      0.0225
    ],
    [
      "enchainer",
      0.02
    ],
    [
      "demeurer",
      0.02
    ],
    [
      "assujettir",
      0.02
    ],
    [
      "durer",
      0.0175
    ],
    [
      "observer",
      0.0175
    ],
    [
      "soutenir",
      0.0175
    ],
    [
      "occuper",
      0.015
    ],
    [
      "garder",
      0.015
    ],
    [
      "continuer",
      0.015
    ],
    [
      "avoir",
      0.0125
    ],
    [
      "embrasser",
      0.0125
    ],
    [
      "suivre",
      0.0125
    ],
    [
      "rester",
      0.0125
    ],
    [
      "mettre",
      0.0125
    ],
    [
      "immobiliser",
      0.0125
    ],
    [
      "faire",
      0.0125
    ],
    [
      "contraindre",
      0.0125
    ],
    [
      "appuyer",
      0.0125
    ],
    [
      "s'etendre",
      0.01
    ],
    [
      "posseder",
      0.01
    ],
    [
      "emprisonner",
      0.01
    ],
    [
      "coller",
      0.01
    ],
    [
      "brider",
      0.01
    ],
    [
      "trainer",
      0.0075
    ],
    [
      "pratiquer",
      0.0075
    ],
    [
      "porter",
      0.0075
    ],
    [
      "freiner",
      0.0075
    ],
    [
      "executer",
      0.0075
    ],
    [
      "engager",
      0.0075
    ],
    [
      "empecher",
      0.0075
    ],
    [
      "detenir",
      0.0075
    ],
    [
      "conserver",
      0.0075
    ],
    [
      "coincer",
      0.0075
    ],
    [
      "renfermer",
      0.0075
    ],
    [
      "perseverer",
      0.0075
    ],
    [
      "persister",
      0.0075
    ],
    [
      "endiguer",
      0.0075
    ],
    [
      "consigner",
      0.0075
    ],
    [
      "adherer",
      0.0075
    ],
    [
      "supporter",
      0.005
    ],
    [
      "subsister",
      0.005
    ],
    [
      "saisir",
      0.005
    ],
    [
      "s'attacher",
      0.005
    ],
    [
      "mener",
      0.005
    ],
    [
      "maitriser",
      0.005
    ],
    [
      "loger",
      0.005
    ],
    [
      "lier",
      0.005
    ],
    [
      "diriger",
      0.005
    ],
    [
      "recevoir",
      0.005
    ],
    [
      "remplir",
      0.005
    ],
    [
      "respecter",
      0.005
    ],
    [
      "resister",
      0.005
    ],
    [
      "moderer",
      0.005
    ],
    [
      "gouverner",
      0.005
    ],
    [
      "accomplir",
      0.005
    ],
    [
      "accrocher",
      0.005
    ],
    [
      "astreindre",
      0.005
    ],
    [
      "comprimer",
      0.005
    ],
    [
      "entrer",
      0.005
    ],
    [
      "venir",
      0.0025
    ],
    [
      "s'obstiner",
      0.0025
    ],
    [
      "resulter",
      0.0025
    ],
    [
      "ressortir",
      0.0025
    ],
    [
      "rendre",
      0.0025
    ],
    [
      "participer",
      0.0025
    ],
    [
      "manier",
      0.0025
    ],
    [
      "dependre",
      0.0025
    ],
    [
      "defendre",
      0.0025
    ],
    [
      "amarrer",
      0.0025
    ],
    [
      "absorber",
      0.0025
    ],
    [
      "resider",
      0.0025
    ],
    [
      "s'acquitter",
      0.0025
    ],
    [
      "s'etaler",
      0.0025
    ],
    [
      "satisfaire",
      0.0025
    ],
    [
      "surveiller",
      0.0025
    ],
    [
      "etreindre",
      0.0025
    ],
    [
      "ralentir",
      0.0025
    ],
    [
      "provenir",
      0.0025
    ],
    [
      "jouer",
      0.0025
    ],
    [
      "accaparer",
      0.0025
    ],
    [
      "administrer",
      0.0025
    ],
    [
      "clouer",
      0.0025
    ],
    [
      "comporter",
      0.0025
    ],
    [
      "discuter",
      0.0025
    ],
    [
      "exercer",
      0.0025
    ],
    [
      "jauger",
      0.0025
    ],
    [
      "s'etirer",
      0.0
    ],
    [
      "recouvrir",
      0.0
    ],
    [
      "naviguer",
      0.0
    ],
    [
      "gerer",
      0.0
    ],
    [
      "envisager",
      0.0
    ],
    [
      "effectuer",
      0.0
    ],
    [
      "deliberer",
      0.0
    ],
    [
      "appartenir",
      0.0
    ],
    [
      "agripper",
      0.0
    ]
  ],
  "exiger": [
    [
      "demander",
      0.1125
    ],
    [
      "commander",
      0.08
    ],
    [
      "requerir",
      0.08
    ],
    [
      "vouloir",
      0.0675
    ],
    [
      "prescrire",
      0.06
    ],
    [
      "reclamer",
      0.06
    ],
    [
      "sommer",
      0.0475
    ],
    [
      "revendiquer",
      0.0475
    ],
    [
      "ordonner",
      0.0475
    ],
    [
      "contraindre",
      0.0425
    ],
    [
      "souhaiter",
      0.0425
    ],
    [
      "imposer",
      0.035
    ],
    [
      "necessiter",
      0.035
    ],
    [
      "desirer",
      0.03
    ],
    [
      "obliger",
      0.0225
    ],
    [
      "enjoindre",
      0.0225
    ],
    [
      "appeler",
      0.0225
    ],
    [
      "pretendre",
      0.0175
    ],
    [
      "supposer",
      0.01
    ],
    [
      "recommander",
      0.01
    ],
    [
      "prelever",
      0.01
    ],
    [
      "prendre",
      0.01
    ],
    [
      "astreindre",
      0.01
    ],
    [
      "attendre",
      0.005
    ],
    [
      "entendre",
      0.005
    ],
    [
      "motiver",
      0.005
    ],
    [
      "redemander",
      0.005
    ]
  ],
  "rap": [],
  "punk": [],
  "reggae": [],
  "decale": [
    [
      "deplacer",
      0.22
    ],
    [
      "reculer",
      0.22
    ],
    [
      "avancer",
      0.11
    ],
    [
      "changer",
      0.11
    ],
    [
      "retarder",
      0.11
    ],
    [
      "temporiser",
      0.11
    ]
  ],
  "decaler": [
    [
      "deplacer",
      0.22
    ],
    [
      "reculer",
      0.22
    ],
    [
      "avancer",
      0.11
    ],
    [
      "changer",
      0.11
    ],
    [
      "retarder",
      0.11
    ],
    [
      "temporiser",
      0.11
    ]
  ],
  "zouk": [],
  "hall": [
    [
      "antichambre",
      0.22
    ],
    [
      "entree",
      0.22
    ],
    [
      "vestibule",
      0.22
    ],
    [
      "accueil",
      0.11
    ],
    [
      "porche",
      0.11
    ],
    [
      "salle",
      0.11
    ]
  ],
  "boxer": [
    [
      "battre",
      0.25
    ],
    [
      "tambouriner",
      0.25
    ],
    [
      "taper",
      0.25
    ],
    [
      "cogner",
      0.125
    ],
    [
      "marteler",
      0.125
    ]
  ],
  "boxe": [
    [
      "lutte",
      0.2
    ],
    [
      "pugilat",
      0.2
    ],
    [
      "savate",
      0.2
    ]
  ],
  "foot": [
    [
      "football",
      0.5
    ]
  ],
  "mariage": [
    [
      "alliance",
      0.1125
    ],
    [
      "association",
      0.0825
    ],
    [
      "accord",
      0.055
    ],
    [
      "reunion",
      0.055
    ],
    [
      "union",
      0.055
    ],
    [
      "hymen",
      0.04
    ],
    [
      "ceremonie",
      0.04
    ],
    [
      "chaine",
      0.04
    ],
    [
      "sacrement",
      0.0275
    ],
    [
      "noce",
      0.0275
    ],
    [
      "melange",
      0.0275
    ],
    [
      "hymenee",
      0.0275
    ],
    [
      "engagement",
      0.0275
    ],
    [
      "couple",
      0.0275
    ],
    [
      "cortege",
      0.0275
    ],
    [
      "combinaison",
      0.0275
    ],
    [
      "assortiment",
      0.0275
    ],
    [
      "assemblage",
      0.0275
    ],
    [
      "amour",
      0.0275
    ],
    [
      "harmonisation",
      0.0125
    ],
    [
      "lit",
      0.0125
    ],
    [
      "menage",
      0.0125
    ],
    [
      "epousailles",
      0.0125
    ],
    [
      "celebration",
      0.0125
    ],
    [
      "conjungo",
      0.0125
    ],
    [
      "besigue",
      0.0125
    ],
    [
      "benediction",
      0.0125
    ],
    [
      "brisque",
      0.0125
    ],
    [
      "billet",
      0.0125
    ],
    [
      "amadouage",
      0.0125
    ],
    [
      "accordailles",
      0.0125
    ],
    [
      "etablissement",
      0.0125
    ]
  ],
  "metisser": [
    [
      "croiser",
      1.0
    ]
  ],
  "chauve": [
    [
      "nu",
      0.3
    ],
    [
      "pele",
      0.3
    ],
    [
      "degarni",
      0.1
    ],
    [
      "denude",
      0.1
    ],
    [
      "deplume",
      0.1
    ],
    [
      "depouille",
      0.1
    ]
  ],
  "crete": [
    [
      "sommet",
      0.13
    ],
    [
      "saillie",
      0.085
    ],
    [
      "hauteur",
      0.085
    ],
    [
      "haut",
      0.085
    ],
    [
      "dent",
      0.085
    ],
    [
      "apophyse",
      0.085
    ],
    [
      "touffe",
      0.0425
    ],
    [
      "passement",
      0.0425
    ],
    [
      "parapet",
      0.0425
    ],
    [
      "orgueil",
      0.0425
    ],
    [
      "intersillon",
      0.0425
    ],
    [
      "huppe",
      0.0425
    ],
    [
      "houppe",
      0.0425
    ],
    [
      "faite",
      0.0425
    ],
    [
      "cime",
      0.0425
    ],
    [
      "epine",
      0.0425
    ]
  ],
  "frise": [
    [
      "froler",
      0.1
    ],
    [
      "boucler",
      0.0825
    ],
    [
      "onduler",
      0.0675
    ],
    [
      "moutonner",
      0.05
    ],
    [
      "effleurer",
      0.05
    ],
    [
      "cotoyer",
      0.05
    ],
    [
      "raser",
      0.0325
    ],
    [
      "heurter",
      0.0325
    ],
    [
      "coudoyer",
      0.0325
    ],
    [
      "calamistrer",
      0.0325
    ],
    [
      "approcher",
      0.0325
    ],
    [
      "anneler",
      0.0325
    ],
    [
      "frissonner",
      0.015
    ],
    [
      "froncer",
      0.015
    ],
    [
      "risquer",
      0.015
    ],
    [
      "taper",
      0.015
    ],
    [
      "frisotter",
      0.015
    ],
    [
      "friseler",
      0.015
    ],
    [
      "creper",
      0.015
    ],
    [
      "cligner",
      0.015
    ],
    [
      "canneler",
      0.015
    ],
    [
      "bichonner",
      0.015
    ],
    [
      "egratigner",
      0.015
    ]
  ],
  "friser": [
    [
      "froler",
      0.1
    ],
    [
      "boucler",
      0.0825
    ],
    [
      "onduler",
      0.0675
    ],
    [
      "moutonner",
      0.05
    ],
    [
      "effleurer",
      0.05
    ],
    [
      "cotoyer",
      0.05
    ],
    [
      "raser",
      0.0325
    ],
    [
      "heurter",
      0.0325
    ],
    [
      "coudoyer",
      0.0325
    ],
    [
      "calamistrer",
      0.0325
    ],
    [
      "approcher",
      0.0325
    ],
    [
      "anneler",
      0.0325
    ],
    [
      "frissonner",
      0.015
    ],
    [
      "froncer",
      0.015
    ],
    [
      "risquer",
      0.015
    ],
    [
      "taper",
      0.015
    ],
    [
      "frisotter",
      0.015
    ],
    [
      "friseler",
      0.015
    ],
    [
      "creper",
      0.015
    ],
    [
      "cligner",
      0.015
    ],
    [
      "canneler",
      0.015
    ],
    [
      "bichonner",
      0.015
    ],
    [
      "egratigner",
      0.015
    ]
  ],
  "blond": [
    [
      "ambre",
      0.075
    ],
    [
      "roux",
      0.075
    ],
    [
      "oxygene",
      0.075
    ],
    [
      "lin",
      0.075
    ],
    [
      "jaune",
      0.075
    ],
    [
      "filasse",
      0.075
    ],
    [
      "decolore",
      0.075
    ],
    [
      "dore",
      0.075
    ],
    [
      "blondinet",
      0.075
    ],
    [
      "blondin",
      0.075
    ],
    [
      "blondasse",
      0.075
    ],
    [
      "beige",
      0.075
    ],
    [
      "ecru",
      0.075
    ]
  ],
  "brune": [
    [
      "basane",
      0.1175
    ],
    [
      "hale",
      0.1
    ],
    [
      "bistre",
      0.0675
    ],
    [
      "bronze",
      0.0675
    ],
    [
      "boucane",
      0.05
    ],
    [
      "tanne",
      0.05
    ],
    [
      "noir",
      0.0325
    ],
    [
      "brule",
      0.0325
    ],
    [
      "bruni",
      0.0325
    ],
    [
      "bistre",
      0.0325
    ],
    [
      "bis",
      0.0325
    ],
    [
      "fonce",
      0.015
    ],
    [
      "kaki",
      0.015
    ],
    [
      "marron",
      0.015
    ],
    [
      "mordore",
      0.015
    ],
    [
      "noyer",
      0.015
    ],
    [
      "puce",
      0.015
    ],
    [
      "tabac",
      0.015
    ],
    [
      "terreux",
      0.015
    ],
    [
      "chene",
      0.015
    ],
    [
      "chatain",
      0.015
    ],
    [
      "chocolat",
      0.015
    ],
    [
      "auburn",
      0.015
    ],
    [
      "bai",
      0.015
    ],
    [
      "brique",
      0.015
    ],
    [
      "brunet",
      0.015
    ],
    [
      "brunette",
      0.015
    ],
    [
      "brunatre",
      0.015
    ],
    [
      "carmelite",
      0.015
    ]
  ],
  "brun": [
    [
      "basane",
      0.1175
    ],
    [
      "hale",
      0.1
    ],
    [
      "bistre",
      0.0675
    ],
    [
      "bronze",
      0.0675
    ],
    [
      "boucane",
      0.05
    ],
    [
      "tanne",
      0.05
    ],
    [
      "noir",
      0.0325
    ],
    [
      "brule",
      0.0325
    ],
    [
      "bruni",
      0.0325
    ],
    [
      "bistre",
      0.0325
    ],
    [
      "bis",
      0.0325
    ],
    [
      "fonce",
      0.015
    ],
    [
      "kaki",
      0.015
    ],
    [
      "marron",
      0.015
    ],
    [
      "mordore",
      0.015
    ],
    [
      "noyer",
      0.015
    ],
    [
      "puce",
      0.015
    ],
    [
      "tabac",
      0.015
    ],
    [
      "terreux",
      0.015
    ],
    [
      "chene",
      0.015
    ],
    [
      "chatain",
      0.015
    ],
    [
      "chocolat",
      0.015
    ],
    [
      "auburn",
      0.015
    ],
    [
      "bai",
      0.015
    ],
    [
      "brique",
      0.015
    ],
    [
      "brunet",
      0.015
    ],
    [
      "brunette",
      0.015
    ],
    [
      "brunatre",
      0.015
    ],
    [
      "carmelite",
      0.015
    ]
  ],
  "tisse": [
    [
      "combiner",
      0.1175
    ],
    [
      "manigancer",
      0.105
    ],
    [
      "ourdir",
      0.105
    ],
    [
      "tresser",
      0.09
    ],
    [
      "tramer",
      0.0775
    ],
    [
      "machiner",
      0.065
    ],
    [
      "preparer",
      0.065
    ],
    [
      "monter",
      0.0525
    ],
    [
      "fabriquer",
      0.0525
    ],
    [
      "arranger",
      0.0525
    ],
    [
      "agencer",
      0.0525
    ],
    [
      "nouer",
      0.025
    ],
    [
      "conspirer",
      0.025
    ],
    [
      "comploter",
      0.025
    ],
    [
      "amenager",
      0.025
    ],
    [
      "brasser",
      0.0125
    ],
    [
      "brocher",
      0.0125
    ],
    [
      "broder",
      0.0125
    ],
    [
      "entrelacer",
      0.0125
    ]
  ],
  "tisser": [
    [
      "combiner",
      0.1175
    ],
    [
      "manigancer",
      0.105
    ],
    [
      "ourdir",
      0.105
    ],
    [
      "tresser",
      0.09
    ],
    [
      "tramer",
      0.0775
    ],
    [
      "machiner",
      0.065
    ],
    [
      "preparer",
      0.065
    ],
    [
      "monter",
      0.0525
    ],
    [
      "fabriquer",
      0.0525
    ],
    [
      "arranger",
      0.0525
    ],
    [
      "agencer",
      0.0525
    ],
    [
      "nouer",
      0.025
    ],
    [
      "conspirer",
      0.025
    ],
    [
      "comploter",
      0.025
    ],
    [
      "amenager",
      0.025
    ],
    [
      "brasser",
      0.0125
    ],
    [
      "brocher",
      0.0125
    ],
    [
      "broder",
      0.0125
    ],
    [
      "entrelacer",
      0.0125
    ]
  ],
  "divis": [],
  "diviser": [
    [
      "separer",
      0.105
    ],
    [
      "morceler",
      0.0875
    ],
    [
      "couper",
      0.06
    ],
    [
      "partager",
      0.06
    ],
    [
      "desunir",
      0.05
    ],
    [
      "casser",
      0.04
    ],
    [
      "sectionner",
      0.0325
    ],
    [
      "disjoindre",
      0.0325
    ],
    [
      "disloquer",
      0.03
    ],
    [
      "rompre",
      0.03
    ],
    [
      "depecer",
      0.025
    ],
    [
      "fendre",
      0.025
    ],
    [
      "fractionner",
      0.0225
    ],
    [
      "fragmenter",
      0.0225
    ],
    [
      "scinder",
      0.0225
    ],
    [
      "desagreger",
      0.02
    ],
    [
      "disperser",
      0.0175
    ],
    [
      "dissocier",
      0.0175
    ],
    [
      "dechirer",
      0.0175
    ],
    [
      "repartir",
      0.0175
    ],
    [
      "ecarter",
      0.0175
    ],
    [
      "trancher",
      0.015
    ],
    [
      "demembrer",
      0.015
    ],
    [
      "decouper",
      0.015
    ],
    [
      "distribuer",
      0.015
    ],
    [
      "decomposer",
      0.01
    ],
    [
      "subdiviser",
      0.01
    ],
    [
      "emietter",
      0.0075
    ],
    [
      "echelonner",
      0.0075
    ],
    [
      "lotir",
      0.0075
    ],
    [
      "hacher",
      0.0075
    ],
    [
      "desassembler",
      0.0075
    ],
    [
      "debiter",
      0.0075
    ],
    [
      "classer",
      0.0075
    ],
    [
      "tronconner",
      0.005
    ],
    [
      "serier",
      0.005
    ],
    [
      "fissurer",
      0.005
    ],
    [
      "demancher",
      0.005
    ],
    [
      "cloisonner",
      0.005
    ],
    [
      "analyser",
      0.005
    ],
    [
      "amenager",
      0.005
    ],
    [
      "detailler",
      0.0025
    ],
    [
      "exfolier",
      0.0025
    ],
    [
      "graduer",
      0.0025
    ],
    [
      "opposer",
      0.0025
    ],
    [
      "parceller",
      0.0025
    ],
    [
      "partir",
      0.0025
    ],
    [
      "desolidariser",
      0.0025
    ],
    [
      "dedoubler",
      0.0025
    ],
    [
      "dispenser",
      0.0025
    ],
    [
      "diminuer",
      0.0025
    ],
    [
      "compartimenter",
      0.0025
    ],
    [
      "cliver",
      0.0025
    ],
    [
      "brouiller",
      0.0025
    ],
    [
      "bissecter",
      0.0025
    ],
    [
      "ponctuer",
      0.0025
    ]
  ],
  "leve": [
    [
      "soulever",
      0.065
    ],
    [
      "supprimer",
      0.0575
    ],
    [
      "enlever",
      0.0525
    ],
    [
      "elever",
      0.0525
    ],
    [
      "hausser",
      0.0475
    ],
    [
      "oter",
      0.0425
    ],
    [
      "relever",
      0.0425
    ],
    [
      "monter",
      0.035
    ],
    [
      "couper",
      0.03
    ],
    [
      "faire",
      0.03
    ],
    [
      "dresser",
      0.025
    ],
    [
      "assembler",
      0.025
    ],
    [
      "tirer",
      0.02
    ],
    [
      "retrancher",
      0.02
    ],
    [
      "hisser",
      0.02
    ],
    [
      "augmenter",
      0.02
    ],
    [
      "amasser",
      0.02
    ],
    [
      "abolir",
      0.02
    ],
    [
      "trousser",
      0.015
    ],
    [
      "retirer",
      0.015
    ],
    [
      "redresser",
      0.015
    ],
    [
      "recueillir",
      0.015
    ],
    [
      "prelever",
      0.015
    ],
    [
      "pousser",
      0.015
    ],
    [
      "gonfler",
      0.015
    ],
    [
      "effacer",
      0.015
    ],
    [
      "aneantir",
      0.015
    ],
    [
      "ecarter",
      0.01
    ],
    [
      "terminer",
      0.01
    ],
    [
      "rehausser",
      0.01
    ],
    [
      "percevoir",
      0.01
    ],
    [
      "mobiliser",
      0.01
    ],
    [
      "haler",
      0.01
    ],
    [
      "aplanir",
      0.01
    ],
    [
      "accumuler",
      0.01
    ],
    [
      "fermenter",
      0.005
    ],
    [
      "guinder",
      0.005
    ],
    [
      "recruter",
      0.005
    ],
    [
      "retenir",
      0.005
    ],
    [
      "retrousser",
      0.005
    ],
    [
      "exhausser",
      0.005
    ],
    [
      "enroler",
      0.005
    ],
    [
      "decouper",
      0.005
    ],
    [
      "draguer",
      0.005
    ],
    [
      "dessiner",
      0.005
    ],
    [
      "braconner",
      0.005
    ],
    [
      "bouger",
      0.005
    ],
    [
      "armer",
      0.005
    ],
    [
      "ruiner",
      0.005
    ]
  ],
  "lever": [
    [
      "leve",
      0.3325
    ],
    [
      "levee",
      0.3325
    ],
    [
      "prelude",
      0.3325
    ]
  ],
  "uni": [
    [
      "adherent",
      0.0625
    ],
    [
      "lisse",
      0.0625
    ],
    [
      "plat",
      0.0625
    ],
    [
      "uniforme",
      0.0625
    ],
    [
      "egal",
      0.0625
    ],
    [
      "simple",
      0.045
    ],
    [
      "joint",
      0.045
    ],
    [
      "inseparable",
      0.045
    ],
    [
      "tranquille",
      0.03
    ],
    [
      "soude",
      0.03
    ],
    [
      "poli",
      0.03
    ],
    [
      "plan",
      0.03
    ],
    [
      "monotone",
      0.03
    ],
    [
      "homogene",
      0.03
    ],
    [
      "doux",
      0.03
    ],
    [
      "conjoint",
      0.03
    ],
    [
      "modeste",
      0.015
    ],
    [
      "morne",
      0.015
    ],
    [
      "net",
      0.015
    ],
    [
      "nivele",
      0.015
    ],
    [
      "plain",
      0.015
    ],
    [
      "reuni",
      0.015
    ],
    [
      "solidaire",
      0.015
    ],
    [
      "unicolore",
      0.015
    ],
    [
      "glabre",
      0.015
    ],
    [
      "connexe",
      0.015
    ],
    [
      "abouche",
      0.015
    ],
    [
      "allie",
      0.015
    ],
    [
      "appareille",
      0.015
    ],
    [
      "assemble",
      0.015
    ],
    [
      "calme",
      0.015
    ],
    [
      "coherent",
      0.015
    ],
    [
      "combine",
      0.015
    ],
    [
      "confondu",
      0.015
    ],
    [
      "unitaire",
      0.015
    ]
  ],
  "unir": [
    [
      "reunir",
      0.135
    ],
    [
      "joindre",
      0.095
    ],
    [
      "assembler",
      0.08
    ],
    [
      "associer",
      0.0725
    ],
    [
      "fusionner",
      0.0525
    ],
    [
      "lier",
      0.045
    ],
    [
      "combiner",
      0.03
    ],
    [
      "allier",
      0.03
    ],
    [
      "accoupler",
      0.0275
    ],
    [
      "melanger",
      0.0275
    ],
    [
      "adjoindre",
      0.0225
    ],
    [
      "marier",
      0.02
    ],
    [
      "rapprocher",
      0.0175
    ],
    [
      "juxtaposer",
      0.0175
    ],
    [
      "attacher",
      0.0175
    ],
    [
      "apparier",
      0.0175
    ],
    [
      "accoler",
      0.0175
    ],
    [
      "assortir",
      0.0175
    ],
    [
      "appareiller",
      0.015
    ],
    [
      "relier",
      0.015
    ],
    [
      "rassembler",
      0.01
    ],
    [
      "meler",
      0.01
    ],
    [
      "grouper",
      0.01
    ],
    [
      "federer",
      0.01
    ],
    [
      "amalgamer",
      0.01
    ],
    [
      "adapter",
      0.01
    ],
    [
      "agencer",
      0.01
    ],
    [
      "agreger",
      0.0075
    ],
    [
      "agglomerer",
      0.0075
    ],
    [
      "coaliser",
      0.005
    ],
    [
      "coordonner",
      0.005
    ],
    [
      "enchainer",
      0.005
    ],
    [
      "fondre",
      0.005
    ],
    [
      "souder",
      0.005
    ],
    [
      "liguer",
      0.005
    ],
    [
      "coupler",
      0.005
    ],
    [
      "conjuguer",
      0.005
    ],
    [
      "annexer",
      0.005
    ],
    [
      "agglutiner",
      0.005
    ],
    [
      "egaliser",
      0.0025
    ],
    [
      "unifier",
      0.0025
    ],
    [
      "solidariser",
      0.0025
    ],
    [
      "raccorder",
      0.0025
    ],
    [
      "polir",
      0.0025
    ],
    [
      "integrer",
      0.0025
    ],
    [
      "geminer",
      0.0025
    ],
    [
      "enter",
      0.0025
    ],
    [
      "confondre",
      0.0025
    ],
    [
      "cimenter",
      0.0025
    ],
    [
      "aplanir",
      0.0025
    ],
    [
      "ajouter",
      0.0025
    ],
    [
      "lisser",
      0.0
    ],
    [
      "fiancer",
      0.0
    ],
    [
      "desservir",
      0.0
    ],
    [
      "conjoindre",
      0.0
    ],
    [
      "confederer",
      0.0
    ],
    [
      "planer",
      0.0
    ]
  ],
  "folie": [
    [
      "alienation",
      0.06
    ],
    [
      "delire",
      0.05
    ],
    [
      "extravagance",
      0.0475
    ],
    [
      "egarement",
      0.045
    ],
    [
      "toquade",
      0.0425
    ],
    [
      "demence",
      0.035
    ],
    [
      "passion",
      0.0325
    ],
    [
      "caprice",
      0.03
    ],
    [
      "frenesie",
      0.03
    ],
    [
      "manie",
      0.03
    ],
    [
      "trouble",
      0.0225
    ],
    [
      "aberration",
      0.02
    ],
    [
      "fantaisie",
      0.02
    ],
    [
      "insanite",
      0.0175
    ],
    [
      "fureur",
      0.0175
    ],
    [
      "fredaine",
      0.0175
    ],
    [
      "divagation",
      0.0175
    ],
    [
      "betise",
      0.0175
    ],
    [
      "absurdite",
      0.0175
    ],
    [
      "ecart",
      0.015
    ],
    [
      "hallucination",
      0.015
    ],
    [
      "fanatisme",
      0.015
    ],
    [
      "bizarrerie",
      0.015
    ],
    [
      "fievre",
      0.0125
    ],
    [
      "imagination",
      0.0125
    ],
    [
      "sottise",
      0.01
    ],
    [
      "pavillon",
      0.01
    ],
    [
      "frasque",
      0.01
    ],
    [
      "erreur",
      0.01
    ],
    [
      "vision",
      0.0075
    ],
    [
      "rage",
      0.0075
    ],
    [
      "psychose",
      0.0075
    ],
    [
      "idiotie",
      0.0075
    ],
    [
      "humeur",
      0.0075
    ],
    [
      "exces",
      0.0075
    ],
    [
      "derangement",
      0.0075
    ],
    [
      "chimere",
      0.0075
    ],
    [
      "aveuglement",
      0.0075
    ],
    [
      "incartade",
      0.005
    ],
    [
      "lubie",
      0.005
    ],
    [
      "marotte",
      0.005
    ],
    [
      "mode",
      0.005
    ],
    [
      "vertige",
      0.005
    ],
    [
      "imbecillite",
      0.005
    ],
    [
      "habitation",
      0.005
    ],
    [
      "emportement",
      0.005
    ],
    [
      "deraison",
      0.005
    ],
    [
      "dada",
      0.005
    ],
    [
      "chaleur",
      0.005
    ],
    [
      "amour",
      0.005
    ],
    [
      "inconscience",
      0.0025
    ],
    [
      "monstruosite",
      0.0025
    ],
    [
      "temerite",
      0.0025
    ],
    [
      "enormite",
      0.0025
    ],
    [
      "equipee",
      0.0025
    ],
    [
      "inconduite",
      0.0025
    ],
    [
      "imprudence",
      0.0025
    ],
    [
      "affolement",
      0.0025
    ],
    [
      "chateau",
      0.0025
    ],
    [
      "cretinisme",
      0.0025
    ],
    [
      "desequilibre",
      0.0025
    ],
    [
      "escapade",
      0.0025
    ],
    [
      "maisonnette",
      0.0
    ],
    [
      "nevrose",
      0.0
    ],
    [
      "obstination",
      0.0
    ],
    [
      "paranoia",
      0.0
    ],
    [
      "perversion",
      0.0
    ],
    [
      "saugrenuite",
      0.0
    ],
    [
      "villa",
      0.0
    ],
    [
      "lypemanie",
      0.0
    ],
    [
      "haine",
      0.0
    ],
    [
      "gaiete",
      0.0
    ],
    [
      "castel",
      0.0
    ],
    [
      "connerie",
      0.0
    ],
    [
      "dissipation",
      0.0
    ],
    [
      "depense",
      0.0
    ],
    [
      "depression",
      0.0
    ],
    [
      "ermitage",
      0.0
    ],
    [
      "felure",
      0.0
    ],
    [
      "vesanie",
      0.0
    ]
  ],
  "mental": [
    [
      "psychique",
      0.25
    ],
    [
      "cerebral",
      0.165
    ],
    [
      "intellectuel",
      0.165
    ],
    [
      "moral",
      0.165
    ],
    [
      "psychisme",
      0.0825
    ],
    [
      "psychologique",
      0.0825
    ],
    [
      "spirituel",
      0.0825
    ]
  ],
  "zone": [
    [
      "region",
      0.125
    ],
    [
      "quartier",
      0.0875
    ],
    [
      "pays",
      0.07
    ],
    [
      "sphere",
      0.07
    ],
    [
      "territoire",
      0.0525
    ],
    [
      "secteur",
      0.0525
    ],
    [
      "lieu",
      0.0525
    ],
    [
      "espace",
      0.0525
    ],
    [
      "division",
      0.0525
    ],
    [
      "canton",
      0.0525
    ],
    [
      "peripherie",
      0.035
    ],
    [
      "faubourg",
      0.035
    ],
    [
      "district",
      0.035
    ],
    [
      "cercle",
      0.035
    ],
    [
      "arrondissement",
      0.035
    ],
    [
      "aire",
      0.035
    ],
    [
      "bande",
      0.015
    ],
    [
      "bidonville",
      0.015
    ],
    [
      "bloc",
      0.015
    ],
    [
      "ceinture",
      0.015
    ],
    [
      "fortification",
      0.015
    ],
    [
      "perimetre",
      0.015
    ]
  ],
  "resonner": [
    [
      "retentir",
      0.2375
    ],
    [
      "sonner",
      0.1425
    ],
    [
      "tinter",
      0.1425
    ],
    [
      "bruire",
      0.095
    ],
    [
      "tintinnabuler",
      0.045
    ],
    [
      "renvoyer",
      0.045
    ],
    [
      "rebondir",
      0.045
    ],
    [
      "bondir",
      0.045
    ],
    [
      "vibrer",
      0.045
    ]
  ],
  "caractere": [
    [
      "nature",
      0.0425
    ],
    [
      "signe",
      0.035
    ],
    [
      "tournure",
      0.0325
    ],
    [
      "marque",
      0.03
    ],
    [
      "genre",
      0.025
    ],
    [
      "fermete",
      0.025
    ],
    [
      "courage",
      0.025
    ],
    [
      "caracteristique",
      0.025
    ],
    [
      "expression",
      0.0225
    ],
    [
      "air",
      0.02
    ],
    [
      "aspect",
      0.02
    ],
    [
      "figure",
      0.02
    ],
    [
      "type",
      0.02
    ],
    [
      "style",
      0.02
    ],
    [
      "esprit",
      0.02
    ],
    [
      "cachet",
      0.02
    ],
    [
      "apparence",
      0.02
    ],
    [
      "ame",
      0.0175
    ],
    [
      "volonte",
      0.0175
    ],
    [
      "temperament",
      0.0175
    ],
    [
      "resolution",
      0.0175
    ],
    [
      "qualite",
      0.0175
    ],
    [
      "originalite",
      0.0175
    ],
    [
      "maniere",
      0.0175
    ],
    [
      "energie",
      0.015
    ],
    [
      "valeur",
      0.015
    ],
    [
      "personnalite",
      0.0125
    ],
    [
      "trait",
      0.0125
    ],
    [
      "trempe",
      0.0125
    ],
    [
      "visage",
      0.0125
    ],
    [
      "symbole",
      0.0125
    ],
    [
      "propre",
      0.0125
    ],
    [
      "particularite",
      0.0125
    ],
    [
      "attribut",
      0.0125
    ],
    [
      "solidite",
      0.01
    ],
    [
      "propriete",
      0.01
    ],
    [
      "physionomie",
      0.01
    ],
    [
      "naturel",
      0.01
    ],
    [
      "exterieur",
      0.01
    ],
    [
      "comportement",
      0.01
    ],
    [
      "classe",
      0.01
    ],
    [
      "allure",
      0.01
    ],
    [
      "ressort",
      0.0075
    ],
    [
      "decision",
      0.0075
    ],
    [
      "audace",
      0.0075
    ],
    [
      "humeur",
      0.005
    ],
    [
      "genie",
      0.005
    ],
    [
      "fond",
      0.005
    ],
    [
      "empreinte",
      0.005
    ],
    [
      "couleur",
      0.005
    ],
    [
      "constitution",
      0.005
    ],
    [
      "chiffre",
      0.005
    ],
    [
      "chic",
      0.005
    ],
    [
      "assurance",
      0.005
    ],
    [
      "note",
      0.0025
    ],
    [
      "organisation",
      0.0025
    ],
    [
      "sens",
      0.0025
    ],
    [
      "titre",
      0.0025
    ],
    [
      "tenacite",
      0.0025
    ],
    [
      "moeurs",
      0.0025
    ],
    [
      "mentalite",
      0.0025
    ],
    [
      "individualite",
      0.0025
    ],
    [
      "indice",
      0.0025
    ],
    [
      "essence",
      0.0025
    ],
    [
      "entetement",
      0.0025
    ],
    [
      "composition",
      0.0025
    ],
    [
      "poincon",
      0.0025
    ],
    [
      "psychologie",
      0.0025
    ],
    [
      "sceau",
      0.0025
    ],
    [
      "tonalite",
      0.0025
    ],
    [
      "pittoresque",
      0.0025
    ],
    [
      "particularisme",
      0.0025
    ],
    [
      "lettre",
      0.0025
    ],
    [
      "abord",
      0.0025
    ],
    [
      "critere",
      0.0025
    ],
    [
      "determination",
      0.0025
    ],
    [
      "facture",
      0.0025
    ],
    [
      "idiosyncrasie",
      0.0025
    ],
    [
      "pictogramme",
      0.0
    ],
    [
      "plomb",
      0.0
    ],
    [
      "relief",
      0.0
    ],
    [
      "ressource",
      0.0
    ],
    [
      "sigle",
      0.0
    ],
    [
      "signification",
      0.0
    ],
    [
      "specificite",
      0.0
    ],
    [
      "stigmate",
      0.0
    ],
    [
      "matrice",
      0.0
    ],
    [
      "inflexibilite",
      0.0
    ],
    [
      "airain",
      0.0
    ],
    [
      "cadrat",
      0.0
    ],
    [
      "cadratin",
      0.0
    ],
    [
      "criterium",
      0.0
    ],
    [
      "dignite",
      0.0
    ],
    [
      "entite",
      0.0
    ],
    [
      "espace",
      0.0
    ],
    [
      "ideogramme",
      0.0
    ],
    [
      "texte",
      0.0
    ]
  ],
  "ter": [
    [
      "troisieme",
      1.0
    ]
  ],
  "secteur": [
    [
      "lieu",
      0.1325
    ],
    [
      "partie",
      0.1325
    ],
    [
      "matiere",
      0.11
    ],
    [
      "coin",
      0.0875
    ],
    [
      "point",
      0.0875
    ],
    [
      "terrain",
      0.0875
    ],
    [
      "zone",
      0.065
    ],
    [
      "domaine",
      0.065
    ],
    [
      "emplacement",
      0.0425
    ],
    [
      "quartier",
      0.0425
    ],
    [
      "territoire",
      0.0425
    ],
    [
      "departement",
      0.02
    ],
    [
      "parages",
      0.02
    ],
    [
      "ramification",
      0.02
    ],
    [
      "ressort",
      0.02
    ]
  ],
  "insomnie": [
    [
      "agrypnie",
      0.5
    ],
    [
      "veille",
      0.5
    ]
  ],
  "ennuyer": [
    [
      "fatiguer",
      0.0675
    ],
    [
      "contrarier",
      0.0475
    ],
    [
      "importuner",
      0.0475
    ],
    [
      "agacer",
      0.0475
    ],
    [
      "tourmenter",
      0.045
    ],
    [
      "embeter",
      0.0425
    ],
    [
      "turlupiner",
      0.04
    ],
    [
      "chagriner",
      0.04
    ],
    [
      "facher",
      0.035
    ],
    [
      "assommer",
      0.0325
    ],
    [
      "tracasser",
      0.0325
    ],
    [
      "barber",
      0.0275
    ],
    [
      "raser",
      0.0275
    ],
    [
      "navrer",
      0.0225
    ],
    [
      "bassiner",
      0.0225
    ],
    [
      "desoler",
      0.0175
    ],
    [
      "embarrasser",
      0.0175
    ],
    [
      "emmerder",
      0.0175
    ],
    [
      "enquiquiner",
      0.0175
    ],
    [
      "exceder",
      0.0175
    ],
    [
      "tanner",
      0.0175
    ],
    [
      "irriter",
      0.0175
    ],
    [
      "empoisonner",
      0.0175
    ],
    [
      "lasser",
      0.015
    ],
    [
      "gener",
      0.0125
    ],
    [
      "etourdir",
      0.0125
    ],
    [
      "mecontenter",
      0.0125
    ],
    [
      "deplaire",
      0.0125
    ],
    [
      "chiffonner",
      0.0125
    ],
    [
      "harceler",
      0.01
    ],
    [
      "obseder",
      0.01
    ],
    [
      "peser",
      0.0075
    ],
    [
      "inquieter",
      0.0075
    ],
    [
      "endormir",
      0.0075
    ],
    [
      "accabler",
      0.0075
    ],
    [
      "enerver",
      0.005
    ],
    [
      "piquer",
      0.005
    ],
    [
      "degouter",
      0.005
    ],
    [
      "assourdir",
      0.005
    ],
    [
      "affliger",
      0.005
    ],
    [
      "canuler",
      0.005
    ],
    [
      "impatienter",
      0.005
    ],
    [
      "preoccuper",
      0.005
    ],
    [
      "rebuter",
      0.0025
    ],
    [
      "desobliger",
      0.0025
    ],
    [
      "defriser",
      0.0025
    ],
    [
      "decevoir",
      0.0025
    ],
    [
      "cramponner",
      0.0025
    ],
    [
      "assombrir",
      0.0025
    ],
    [
      "assassiner",
      0.0025
    ],
    [
      "soucier",
      0.0
    ],
    [
      "seriner",
      0.0
    ],
    [
      "emmouscailler",
      0.0
    ],
    [
      "emmieller",
      0.0
    ],
    [
      "embater",
      0.0
    ],
    [
      "deranger",
      0.0
    ],
    [
      "souler",
      0.0
    ]
  ],
  "deplaire": [
    [
      "contrarier",
      0.0725
    ],
    [
      "facher",
      0.0725
    ],
    [
      "choquer",
      0.065
    ],
    [
      "desobliger",
      0.065
    ],
    [
      "ennuyer",
      0.065
    ],
    [
      "vexer",
      0.055
    ],
    [
      "blesser",
      0.055
    ],
    [
      "heurter",
      0.045
    ],
    [
      "mecontenter",
      0.045
    ],
    [
      "peiner",
      0.045
    ],
    [
      "offenser",
      0.035
    ],
    [
      "indisposer",
      0.035
    ],
    [
      "froisser",
      0.035
    ],
    [
      "chagriner",
      0.035
    ],
    [
      "degouter",
      0.0275
    ],
    [
      "gener",
      0.0275
    ],
    [
      "irriter",
      0.0275
    ],
    [
      "rebuter",
      0.0275
    ],
    [
      "repousser",
      0.0175
    ],
    [
      "offusquer",
      0.0175
    ],
    [
      "importuner",
      0.0175
    ],
    [
      "couter",
      0.0075
    ],
    [
      "disconvenir",
      0.0075
    ],
    [
      "repugner",
      0.0075
    ],
    [
      "souffrir",
      0.0075
    ]
  ],
  "calculer": [
    [
      "arranger",
      0.0725
    ],
    [
      "combiner",
      0.0625
    ],
    [
      "preparer",
      0.0625
    ],
    [
      "mesurer",
      0.0525
    ],
    [
      "reflechir",
      0.0525
    ],
    [
      "evaluer",
      0.04
    ],
    [
      "etablir",
      0.04
    ],
    [
      "regler",
      0.04
    ],
    [
      "proportionner",
      0.04
    ],
    [
      "peser",
      0.04
    ],
    [
      "mediter",
      0.04
    ],
    [
      "adapter",
      0.04
    ],
    [
      "resoudre",
      0.03
    ],
    [
      "premediter",
      0.03
    ],
    [
      "estimer",
      0.03
    ],
    [
      "determiner",
      0.03
    ],
    [
      "compter",
      0.03
    ],
    [
      "supputer",
      0.02
    ],
    [
      "prevoir",
      0.02
    ],
    [
      "planifier",
      0.02
    ],
    [
      "deliberer",
      0.02
    ],
    [
      "concerter",
      0.02
    ],
    [
      "appreter",
      0.02
    ],
    [
      "apprecier",
      0.02
    ],
    [
      "ajuster",
      0.02
    ],
    [
      "agencer",
      0.02
    ],
    [
      "chercher",
      0.0075
    ],
    [
      "chiffrer",
      0.0075
    ],
    [
      "coordonner",
      0.0075
    ],
    [
      "minuter",
      0.0075
    ],
    [
      "raisonner",
      0.0075
    ]
  ],
  "serre": [
    [
      "attacher",
      0.0525
    ],
    [
      "presser",
      0.0525
    ],
    [
      "entourer",
      0.0475
    ],
    [
      "comprimer",
      0.0325
    ],
    [
      "prendre",
      0.0325
    ],
    [
      "etreindre",
      0.03
    ],
    [
      "enserrer",
      0.025
    ],
    [
      "resserrer",
      0.0225
    ],
    [
      "oppresser",
      0.0225
    ],
    [
      "lier",
      0.0225
    ],
    [
      "gener",
      0.0225
    ],
    [
      "enlacer",
      0.0225
    ],
    [
      "encercler",
      0.0225
    ],
    [
      "embrasser",
      0.0225
    ],
    [
      "ceindre",
      0.02
    ],
    [
      "enfermer",
      0.02
    ],
    [
      "sangler",
      0.0175
    ],
    [
      "renfermer",
      0.0175
    ],
    [
      "pincer",
      0.0175
    ],
    [
      "etouffer",
      0.015
    ],
    [
      "ecraser",
      0.015
    ],
    [
      "tasser",
      0.015
    ],
    [
      "contraindre",
      0.015
    ],
    [
      "brider",
      0.015
    ],
    [
      "bloquer",
      0.015
    ],
    [
      "ranger",
      0.01
    ],
    [
      "poursuivre",
      0.01
    ],
    [
      "placer",
      0.01
    ],
    [
      "mettre",
      0.01
    ],
    [
      "joindre",
      0.01
    ],
    [
      "freiner",
      0.01
    ],
    [
      "entasser",
      0.01
    ],
    [
      "accoler",
      0.01
    ],
    [
      "assembler",
      0.01
    ],
    [
      "coincer",
      0.01
    ],
    [
      "contracter",
      0.01
    ],
    [
      "emprisonner",
      0.01
    ],
    [
      "etrangler",
      0.0075
    ],
    [
      "saisir",
      0.0075
    ],
    [
      "raser",
      0.0075
    ],
    [
      "mouler",
      0.0075
    ],
    [
      "froler",
      0.0075
    ],
    [
      "empoigner",
      0.0075
    ],
    [
      "caresser",
      0.0075
    ],
    [
      "boucler",
      0.0075
    ],
    [
      "bander",
      0.0075
    ],
    [
      "atteler",
      0.0075
    ],
    [
      "appuyer",
      0.0075
    ],
    [
      "rapprocher",
      0.005
    ],
    [
      "rencogner",
      0.005
    ],
    [
      "souquer",
      0.005
    ],
    [
      "suivre",
      0.005
    ],
    [
      "talonner",
      0.005
    ],
    [
      "visser",
      0.005
    ],
    [
      "mordre",
      0.005
    ],
    [
      "gripper",
      0.005
    ],
    [
      "cacher",
      0.005
    ],
    [
      "caler",
      0.005
    ],
    [
      "caser",
      0.005
    ],
    [
      "corder",
      0.005
    ],
    [
      "effleurer",
      0.005
    ],
    [
      "entrelacer",
      0.005
    ],
    [
      "lacer",
      0.0
    ],
    [
      "remiser",
      0.0
    ],
    [
      "s'approcher",
      0.0
    ],
    [
      "economiser",
      0.0
    ],
    [
      "epreindre",
      0.0
    ],
    [
      "harper",
      0.0
    ],
    [
      "gainer",
      0.0
    ],
    [
      "froisser",
      0.0
    ],
    [
      "emmailloter",
      0.0
    ],
    [
      "crisper",
      0.0
    ],
    [
      "corseter",
      0.0
    ],
    [
      "compresser",
      0.0
    ],
    [
      "carguer",
      0.0
    ],
    [
      "boudiner",
      0.0
    ]
  ],
  "degat": [
    [
      "ravage",
      0.1525
    ],
    [
      "dommage",
      0.1325
    ],
    [
      "degradation",
      0.1225
    ],
    [
      "deterioration",
      0.06
    ],
    [
      "tort",
      0.06
    ],
    [
      "ruine",
      0.05
    ],
    [
      "destruction",
      0.05
    ],
    [
      "casse",
      0.05
    ],
    [
      "alteration",
      0.05
    ],
    [
      "perte",
      0.04
    ],
    [
      "avarie",
      0.04
    ],
    [
      "depredation",
      0.03
    ],
    [
      "sinistre",
      0.02
    ],
    [
      "grabuge",
      0.02
    ],
    [
      "endommagement",
      0.02
    ],
    [
      "devastation",
      0.02
    ],
    [
      "desordre",
      0.02
    ],
    [
      "atteinte",
      0.02
    ],
    [
      "bris",
      0.0075
    ],
    [
      "debacle",
      0.0075
    ],
    [
      "mefait",
      0.0075
    ]
  ],
  "gars": [
    [
      "type",
      0.17
    ],
    [
      "homme",
      0.1425
    ],
    [
      "mec",
      0.1125
    ],
    [
      "fils",
      0.085
    ],
    [
      "garcon",
      0.085
    ],
    [
      "jeune",
      0.055
    ],
    [
      "individu",
      0.055
    ],
    [
      "enfant",
      0.055
    ],
    [
      "bete",
      0.0275
    ],
    [
      "fiston",
      0.0275
    ],
    [
      "gaillard",
      0.0275
    ],
    [
      "gamin",
      0.0275
    ],
    [
      "gazier",
      0.0275
    ],
    [
      "gonze",
      0.0275
    ]
  ],
  "souffrir": [
    [
      "supporter",
      0.0875
    ],
    [
      "subir",
      0.08
    ],
    [
      "endurer",
      0.0725
    ],
    [
      "accepter",
      0.065
    ],
    [
      "tolerer",
      0.065
    ],
    [
      "recevoir",
      0.0575
    ],
    [
      "passer",
      0.0425
    ],
    [
      "admettre",
      0.035
    ],
    [
      "essuyer",
      0.035
    ],
    [
      "eprouver",
      0.035
    ],
    [
      "sentir",
      0.0275
    ],
    [
      "permettre",
      0.0275
    ],
    [
      "boire",
      0.0275
    ],
    [
      "avaler",
      0.0275
    ],
    [
      "autoriser",
      0.0275
    ],
    [
      "digerer",
      0.02
    ],
    [
      "peiner",
      0.02
    ],
    [
      "soutenir",
      0.02
    ],
    [
      "secher",
      0.0125
    ],
    [
      "ressentir",
      0.0125
    ],
    [
      "pifer",
      0.0125
    ],
    [
      "languir",
      0.0125
    ],
    [
      "mourir",
      0.005
    ],
    [
      "pardonner",
      0.005
    ],
    [
      "porter",
      0.005
    ],
    [
      "patir",
      0.005
    ],
    [
      "resister",
      0.005
    ],
    [
      "s'abimer",
      0.005
    ],
    [
      "s'etioler",
      0.005
    ],
    [
      "laisser",
      0.005
    ],
    [
      "hair",
      0.005
    ],
    [
      "ahaner",
      0.005
    ],
    [
      "blairer",
      0.005
    ],
    [
      "comporter",
      0.005
    ],
    [
      "deplaire",
      0.005
    ],
    [
      "gemir",
      0.005
    ]
  ],
  "ouvrir": [
    [
      "percer",
      0.0525
    ],
    [
      "entamer",
      0.0425
    ],
    [
      "dechirer",
      0.0375
    ],
    [
      "etendre",
      0.0375
    ],
    [
      "pousser",
      0.0325
    ],
    [
      "enfoncer",
      0.0325
    ],
    [
      "couper",
      0.0325
    ],
    [
      "augmenter",
      0.0275
    ],
    [
      "commencer",
      0.0275
    ],
    [
      "defaire",
      0.0275
    ],
    [
      "transpercer",
      0.0275
    ],
    [
      "elargir",
      0.0225
    ],
    [
      "labourer",
      0.0225
    ],
    [
      "fendre",
      0.0225
    ],
    [
      "engager",
      0.0225
    ],
    [
      "creuser",
      0.0225
    ],
    [
      "entailler",
      0.0175
    ],
    [
      "lancer",
      0.0175
    ],
    [
      "preparer",
      0.0175
    ],
    [
      "frayer",
      0.0125
    ],
    [
      "stimuler",
      0.0125
    ],
    [
      "tirer",
      0.0125
    ],
    [
      "ecarter",
      0.0125
    ],
    [
      "etirer",
      0.0125
    ],
    [
      "forcer",
      0.0125
    ],
    [
      "entrouvrir",
      0.0125
    ],
    [
      "deployer",
      0.0125
    ],
    [
      "defoncer",
      0.0125
    ],
    [
      "decouvrir",
      0.0125
    ],
    [
      "dilater",
      0.0125
    ],
    [
      "desserrer",
      0.0125
    ],
    [
      "ecarquiller",
      0.0075
    ],
    [
      "eclore",
      0.0075
    ],
    [
      "epancher",
      0.0075
    ],
    [
      "epanouir",
      0.0075
    ],
    [
      "eveiller",
      0.0075
    ],
    [
      "eventrer",
      0.0075
    ],
    [
      "ebaucher",
      0.0075
    ],
    [
      "trouer",
      0.0075
    ],
    [
      "amorcer",
      0.0075
    ],
    [
      "attaquer",
      0.0075
    ],
    [
      "creer",
      0.0075
    ],
    [
      "deplier",
      0.0075
    ],
    [
      "faciliter",
      0.0075
    ],
    [
      "inciser",
      0.0075
    ],
    [
      "declore",
      0.0025
    ],
    [
      "declouer",
      0.0025
    ],
    [
      "demurer",
      0.0025
    ],
    [
      "depaqueter",
      0.0025
    ],
    [
      "deverrouiller",
      0.0025
    ],
    [
      "entrebailler",
      0.0025
    ],
    [
      "fissurer",
      0.0025
    ],
    [
      "fonder",
      0.0025
    ],
    [
      "inaugurer",
      0.0025
    ],
    [
      "offrir",
      0.0025
    ],
    [
      "pratiquer",
      0.0025
    ],
    [
      "promouvoir",
      0.0025
    ],
    [
      "ebraser",
      0.0025
    ],
    [
      "decapsuler",
      0.0025
    ],
    [
      "decalotter",
      0.0025
    ],
    [
      "aerer",
      0.0025
    ],
    [
      "crevasser",
      0.0025
    ],
    [
      "crocheter",
      0.0025
    ],
    [
      "desceller",
      0.0025
    ],
    [
      "donner",
      0.0025
    ],
    [
      "deballer",
      0.0025
    ],
    [
      "debarrer",
      0.0025
    ],
    [
      "debonder",
      0.0025
    ],
    [
      "deboucher",
      0.0025
    ],
    [
      "deboutonner",
      0.0025
    ],
    [
      "debrider",
      0.0025
    ],
    [
      "debacler",
      0.0025
    ],
    [
      "decacheter",
      0.0025
    ],
    [
      "evaser",
      0.0025
    ]
  ],
  "bisou": [
    [
      "bise",
      0.3325
    ],
    [
      "baise",
      0.165
    ],
    [
      "baiser",
      0.165
    ],
    [
      "becot",
      0.165
    ],
    [
      "poutou",
      0.165
    ]
  ],
  "gate": [
    [
      "corrompre",
      0.1
    ],
    [
      "alterer",
      0.0825
    ],
    [
      "degrader",
      0.0725
    ],
    [
      "abimer",
      0.045
    ],
    [
      "fletrir",
      0.03
    ],
    [
      "souiller",
      0.03
    ],
    [
      "pourrir",
      0.0275
    ],
    [
      "salir",
      0.0275
    ],
    [
      "frelater",
      0.0275
    ],
    [
      "denaturer",
      0.0275
    ],
    [
      "pervertir",
      0.0225
    ],
    [
      "gangrener",
      0.0225
    ],
    [
      "deteriorer",
      0.0225
    ],
    [
      "depraver",
      0.0225
    ],
    [
      "avarier",
      0.0225
    ],
    [
      "avilir",
      0.02
    ],
    [
      "detruire",
      0.02
    ],
    [
      "perdre",
      0.0175
    ],
    [
      "vicier",
      0.0175
    ],
    [
      "ruiner",
      0.0175
    ],
    [
      "gacher",
      0.015
    ],
    [
      "infecter",
      0.015
    ],
    [
      "ternir",
      0.015
    ],
    [
      "carier",
      0.0125
    ],
    [
      "diminuer",
      0.01
    ],
    [
      "tarer",
      0.01
    ],
    [
      "polluer",
      0.01
    ],
    [
      "fausser",
      0.01
    ],
    [
      "deshonorer",
      0.01
    ],
    [
      "deformer",
      0.01
    ],
    [
      "defigurer",
      0.01
    ],
    [
      "endommager",
      0.0075
    ],
    [
      "empester",
      0.0075
    ],
    [
      "empoisonner",
      0.0075
    ],
    [
      "troubler",
      0.005
    ],
    [
      "torcher",
      0.005
    ],
    [
      "tacher",
      0.005
    ],
    [
      "massacrer",
      0.005
    ],
    [
      "galvauder",
      0.005
    ],
    [
      "delabrer",
      0.005
    ],
    [
      "decomposer",
      0.005
    ],
    [
      "choyer",
      0.005
    ],
    [
      "barbouiller",
      0.005
    ],
    [
      "saccager",
      0.0025
    ],
    [
      "ravager",
      0.0025
    ],
    [
      "enlaidir",
      0.0025
    ],
    [
      "deparer",
      0.0025
    ],
    [
      "dorloter",
      0.0025
    ],
    [
      "couver",
      0.0025
    ],
    [
      "brouiller",
      0.0025
    ],
    [
      "user",
      0.0025
    ],
    [
      "soigner",
      0.0025
    ],
    [
      "saboter",
      0.0025
    ],
    [
      "putrefier",
      0.0025
    ],
    [
      "mignoter",
      0.0025
    ],
    [
      "meurtrir",
      0.0025
    ],
    [
      "deranger",
      0.0025
    ],
    [
      "adulterer",
      0.0025
    ],
    [
      "aigrir",
      0.0025
    ],
    [
      "chouchouter",
      0.0025
    ],
    [
      "combler",
      0.0025
    ],
    [
      "deflorer",
      0.0025
    ],
    [
      "sophistiquer",
      0.0
    ],
    [
      "savater",
      0.0
    ],
    [
      "moisir",
      0.0
    ],
    [
      "maltraiter",
      0.0
    ],
    [
      "gorger",
      0.0
    ],
    [
      "gaspiller",
      0.0
    ],
    [
      "faner",
      0.0
    ],
    [
      "entacher",
      0.0
    ],
    [
      "cajoler",
      0.0
    ],
    [
      "bichonner",
      0.0
    ],
    [
      "eventer",
      0.0
    ]
  ],
  "gater": [
    [
      "corrompre",
      0.1
    ],
    [
      "alterer",
      0.0825
    ],
    [
      "degrader",
      0.0725
    ],
    [
      "abimer",
      0.045
    ],
    [
      "fletrir",
      0.03
    ],
    [
      "souiller",
      0.03
    ],
    [
      "pourrir",
      0.0275
    ],
    [
      "salir",
      0.0275
    ],
    [
      "frelater",
      0.0275
    ],
    [
      "denaturer",
      0.0275
    ],
    [
      "pervertir",
      0.0225
    ],
    [
      "gangrener",
      0.0225
    ],
    [
      "deteriorer",
      0.0225
    ],
    [
      "depraver",
      0.0225
    ],
    [
      "avarier",
      0.0225
    ],
    [
      "avilir",
      0.02
    ],
    [
      "detruire",
      0.02
    ],
    [
      "perdre",
      0.0175
    ],
    [
      "vicier",
      0.0175
    ],
    [
      "ruiner",
      0.0175
    ],
    [
      "gacher",
      0.015
    ],
    [
      "infecter",
      0.015
    ],
    [
      "ternir",
      0.015
    ],
    [
      "carier",
      0.0125
    ],
    [
      "diminuer",
      0.01
    ],
    [
      "tarer",
      0.01
    ],
    [
      "polluer",
      0.01
    ],
    [
      "fausser",
      0.01
    ],
    [
      "deshonorer",
      0.01
    ],
    [
      "deformer",
      0.01
    ],
    [
      "defigurer",
      0.01
    ],
    [
      "endommager",
      0.0075
    ],
    [
      "empester",
      0.0075
    ],
    [
      "empoisonner",
      0.0075
    ],
    [
      "troubler",
      0.005
    ],
    [
      "torcher",
      0.005
    ],
    [
      "tacher",
      0.005
    ],
    [
      "massacrer",
      0.005
    ],
    [
      "galvauder",
      0.005
    ],
    [
      "delabrer",
      0.005
    ],
    [
      "decomposer",
      0.005
    ],
    [
      "choyer",
      0.005
    ],
    [
      "barbouiller",
      0.005
    ],
    [
      "saccager",
      0.0025
    ],
    [
      "ravager",
      0.0025
    ],
    [
      "enlaidir",
      0.0025
    ],
    [
      "deparer",
      0.0025
    ],
    [
      "dorloter",
      0.0025
    ],
    [
      "couver",
      0.0025
    ],
    [
      "brouiller",
      0.0025
    ],
    [
      "user",
      0.0025
    ],
    [
      "soigner",
      0.0025
    ],
    [
      "saboter",
      0.0025
    ],
    [
      "putrefier",
      0.0025
    ],
    [
      "mignoter",
      0.0025
    ],
    [
      "meurtrir",
      0.0025
    ],
    [
      "deranger",
      0.0025
    ],
    [
      "adulterer",
      0.0025
    ],
    [
      "aigrir",
      0.0025
    ],
    [
      "chouchouter",
      0.0025
    ],
    [
      "combler",
      0.0025
    ],
    [
      "deflorer",
      0.0025
    ],
    [
      "sophistiquer",
      0.0
    ],
    [
      "savater",
      0.0
    ],
    [
      "moisir",
      0.0
    ],
    [
      "maltraiter",
      0.0
    ],
    [
      "gorger",
      0.0
    ],
    [
      "gaspiller",
      0.0
    ],
    [
      "faner",
      0.0
    ],
    [
      "entacher",
      0.0
    ],
    [
      "cajoler",
      0.0
    ],
    [
      "bichonner",
      0.0
    ],
    [
      "eventer",
      0.0
    ]
  ],
  "douce": [
    [
      "accorte",
      1.0
    ]
  ],
  "craquer": [
    [
      "rompre",
      0.1075
    ],
    [
      "claquer",
      0.09
    ],
    [
      "crever",
      0.0725
    ],
    [
      "peter",
      0.0725
    ],
    [
      "echouer",
      0.0725
    ],
    [
      "s'ecrouler",
      0.0525
    ],
    [
      "s'effondrer",
      0.0525
    ],
    [
      "ceder",
      0.0525
    ],
    [
      "casser",
      0.0525
    ],
    [
      "sombrer",
      0.035
    ],
    [
      "petiller",
      0.035
    ],
    [
      "crepiter",
      0.035
    ],
    [
      "crouler",
      0.035
    ],
    [
      "grincer",
      0.0175
    ],
    [
      "flechir",
      0.0175
    ],
    [
      "filer",
      0.0175
    ],
    [
      "desorganiser",
      0.0175
    ],
    [
      "croquer",
      0.0175
    ],
    [
      "crisser",
      0.0175
    ],
    [
      "craqueter",
      0.0175
    ]
  ],
  "tourne": [
    [
      "passer",
      0.045
    ],
    [
      "changer",
      0.04
    ],
    [
      "remuer",
      0.0325
    ],
    [
      "jouer",
      0.03
    ],
    [
      "marcher",
      0.03
    ],
    [
      "tournoyer",
      0.025
    ],
    [
      "obliquer",
      0.025
    ],
    [
      "virevolter",
      0.0225
    ],
    [
      "virer",
      0.0225
    ],
    [
      "rouler",
      0.0225
    ],
    [
      "retourner",
      0.0225
    ],
    [
      "detourner",
      0.0225
    ],
    [
      "arranger",
      0.0225
    ],
    [
      "tordre",
      0.0175
    ],
    [
      "tendre",
      0.0175
    ],
    [
      "orienter",
      0.0175
    ],
    [
      "incliner",
      0.0175
    ],
    [
      "battre",
      0.0175
    ],
    [
      "eluder",
      0.0125
    ],
    [
      "transformer",
      0.0125
    ],
    [
      "rabattre",
      0.0125
    ],
    [
      "prendre",
      0.0125
    ],
    [
      "pivoter",
      0.0125
    ],
    [
      "partir",
      0.0125
    ],
    [
      "influer",
      0.0125
    ],
    [
      "diriger",
      0.0125
    ],
    [
      "disposer",
      0.0125
    ],
    [
      "devier",
      0.0125
    ],
    [
      "exposer",
      0.0125
    ],
    [
      "fonctionner",
      0.0125
    ],
    [
      "evoluer",
      0.01
    ],
    [
      "tournailler",
      0.01
    ],
    [
      "tortiller",
      0.01
    ],
    [
      "presenter",
      0.01
    ],
    [
      "influencer",
      0.01
    ],
    [
      "finir",
      0.01
    ],
    [
      "metamorphoser",
      0.005
    ],
    [
      "pourrir",
      0.005
    ],
    [
      "prevenir",
      0.005
    ],
    [
      "ruminer",
      0.005
    ],
    [
      "roder",
      0.005
    ],
    [
      "serpenter",
      0.005
    ],
    [
      "tourniller",
      0.005
    ],
    [
      "tourniquer",
      0.005
    ],
    [
      "violer",
      0.005
    ],
    [
      "modifier",
      0.005
    ],
    [
      "manipuler",
      0.005
    ],
    [
      "interpreter",
      0.005
    ],
    [
      "appliquer",
      0.005
    ],
    [
      "braquer",
      0.005
    ],
    [
      "brasser",
      0.005
    ],
    [
      "cinematographier",
      0.005
    ],
    [
      "considerer",
      0.005
    ],
    [
      "contourner",
      0.005
    ],
    [
      "degenerer",
      0.005
    ],
    [
      "deriver",
      0.005
    ],
    [
      "encercler",
      0.005
    ],
    [
      "esquiver",
      0.005
    ],
    [
      "graviter",
      0.005
    ],
    [
      "tortillonner",
      0.0025
    ],
    [
      "s'aigrir",
      0.0025
    ],
    [
      "pirouetter",
      0.0025
    ],
    [
      "murir",
      0.0025
    ],
    [
      "touiller",
      0.0025
    ],
    [
      "toupiller",
      0.0025
    ],
    [
      "toupiner",
      0.0025
    ],
    [
      "tourbillonner",
      0.0025
    ],
    [
      "tournicoter",
      0.0025
    ],
    [
      "transgresser",
      0.0025
    ],
    [
      "trousser",
      0.0025
    ],
    [
      "virevousser",
      0.0025
    ],
    [
      "zigzaguer",
      0.0025
    ],
    [
      "girer",
      0.0025
    ],
    [
      "finasser",
      0.0025
    ],
    [
      "alterner",
      0.0025
    ],
    [
      "aleser",
      0.0025
    ],
    [
      "bistourner",
      0.0025
    ],
    [
      "cinegraphier",
      0.0025
    ],
    [
      "convertir",
      0.0025
    ],
    [
      "devenir",
      0.0025
    ],
    [
      "doubler",
      0.0025
    ],
    [
      "deborder",
      0.0025
    ],
    [
      "enfermer",
      0.0025
    ],
    [
      "enrouler",
      0.0025
    ],
    [
      "escamoter",
      0.0025
    ],
    [
      "examiner",
      0.0025
    ],
    [
      "exprimer",
      0.0025
    ],
    [
      "filmer",
      0.0025
    ],
    [
      "aigrir",
      0.0025
    ]
  ],
  "lundi": [],
  "tester": [
    [
      "verifier",
      0.25
    ],
    [
      "essayer",
      0.125
    ],
    [
      "experimenter",
      0.125
    ],
    [
      "interviewer",
      0.125
    ],
    [
      "questionner",
      0.125
    ],
    [
      "recoler",
      0.125
    ],
    [
      "testamenter",
      0.125
    ]
  ],
  "affoler": [
    [
      "inquieter",
      0.0975
    ],
    [
      "alarmer",
      0.0825
    ],
    [
      "effrayer",
      0.0825
    ],
    [
      "troubler",
      0.0825
    ],
    [
      "terroriser",
      0.075
    ],
    [
      "epouvanter",
      0.075
    ],
    [
      "agiter",
      0.0675
    ],
    [
      "effaroucher",
      0.045
    ],
    [
      "terrifier",
      0.0375
    ],
    [
      "emouvoir",
      0.0375
    ],
    [
      "enflammer",
      0.03
    ],
    [
      "intimider",
      0.03
    ],
    [
      "enfievrer",
      0.0225
    ],
    [
      "effarer",
      0.0225
    ],
    [
      "bouleverser",
      0.0225
    ],
    [
      "apeurer",
      0.0225
    ],
    [
      "angoisser",
      0.0225
    ],
    [
      "paniquer",
      0.015
    ],
    [
      "egarer",
      0.015
    ],
    [
      "exasperer",
      0.0075
    ],
    [
      "desorienter",
      0.0075
    ],
    [
      "deranger",
      0.0075
    ],
    [
      "deboussoler",
      0.0075
    ],
    [
      "aveugler",
      0.0075
    ],
    [
      "atterrer",
      0.0075
    ],
    [
      "affrioler",
      0.0075
    ],
    [
      "passionner",
      0.0075
    ]
  ],
  "zen": [
    [
      "bouddhisme",
      1.0
    ]
  ],
  "drogue": [
    [
      "remede",
      0.2
    ],
    [
      "came",
      0.1
    ],
    [
      "schnouff",
      0.05
    ],
    [
      "purge",
      0.05
    ],
    [
      "potion",
      0.05
    ],
    [
      "orvietan",
      0.05
    ],
    [
      "opium",
      0.05
    ],
    [
      "onguent",
      0.05
    ],
    [
      "medicament",
      0.05
    ],
    [
      "medecine",
      0.05
    ],
    [
      "mixture",
      0.05
    ],
    [
      "merde",
      0.05
    ],
    [
      "decoction",
      0.05
    ],
    [
      "camelote",
      0.05
    ],
    [
      "alcaloide",
      0.05
    ],
    [
      "stupefiant",
      0.05
    ]
  ],
  "droguer": [
    [
      "attendre",
      0.3325
    ],
    [
      "doper",
      0.3325
    ]
  ],
  "picoler": [
    [
      "boire",
      0.2175
    ],
    [
      "pinter",
      0.2175
    ],
    [
      "s'enivrer",
      0.1725
    ],
    [
      "gobeloter",
      0.085
    ],
    [
      "pomper",
      0.085
    ],
    [
      "s'abreuver",
      0.085
    ],
    [
      "ivrogner",
      0.0425
    ],
    [
      "s'alcooliser",
      0.0425
    ],
    [
      "s'ivrogner",
      0.0425
    ]
  ],
  "solide": [
    [
      "resistant",
      0.0675
    ],
    [
      "ferme",
      0.0625
    ],
    [
      "fort",
      0.0525
    ],
    [
      "robuste",
      0.0475
    ],
    [
      "vrai",
      0.0375
    ],
    [
      "sur",
      0.035
    ],
    [
      "bon",
      0.03
    ],
    [
      "certain",
      0.03
    ],
    [
      "inebranlable",
      0.03
    ],
    [
      "immuable",
      0.0275
    ],
    [
      "stable",
      0.0225
    ],
    [
      "exact",
      0.0225
    ],
    [
      "dur",
      0.02
    ],
    [
      "durable",
      0.02
    ],
    [
      "tenace",
      0.02
    ],
    [
      "puissant",
      0.02
    ],
    [
      "fidele",
      0.02
    ],
    [
      "vigoureux",
      0.0175
    ],
    [
      "honnete",
      0.015
    ],
    [
      "imperissable",
      0.015
    ],
    [
      "indestructible",
      0.015
    ],
    [
      "irrefragable",
      0.0125
    ],
    [
      "assure",
      0.0125
    ],
    [
      "franc",
      0.0125
    ],
    [
      "gros",
      0.0125
    ],
    [
      "invariable",
      0.0125
    ],
    [
      "positif",
      0.0125
    ],
    [
      "trapu",
      0.0125
    ],
    [
      "vivace",
      0.01
    ],
    [
      "sincere",
      0.01
    ],
    [
      "reel",
      0.01
    ],
    [
      "infrangible",
      0.01
    ],
    [
      "infatigable",
      0.01
    ],
    [
      "fixe",
      0.01
    ],
    [
      "energique",
      0.0075
    ],
    [
      "serieux",
      0.0075
    ],
    [
      "regulier",
      0.0075
    ],
    [
      "important",
      0.0075
    ],
    [
      "beau",
      0.0075
    ],
    [
      "tangible",
      0.005
    ],
    [
      "rustique",
      0.005
    ],
    [
      "loyal",
      0.005
    ],
    [
      "logique",
      0.005
    ],
    [
      "indefectible",
      0.005
    ],
    [
      "increvable",
      0.005
    ],
    [
      "endurant",
      0.005
    ],
    [
      "eternel",
      0.0025
    ],
    [
      "substantiel",
      0.0025
    ],
    [
      "pesant",
      0.0025
    ],
    [
      "normal",
      0.0025
    ],
    [
      "irrefutable",
      0.0025
    ],
    [
      "inusable",
      0.0025
    ],
    [
      "inattaquable",
      0.0025
    ],
    [
      "coriace",
      0.0025
    ],
    [
      "consistant",
      0.0025
    ],
    [
      "muscle",
      0.0025
    ],
    [
      "mathematique",
      0.0025
    ],
    [
      "intense",
      0.0025
    ],
    [
      "gaillard",
      0.0025
    ],
    [
      "dense",
      0.0025
    ],
    [
      "assis",
      0.0025
    ],
    [
      "objet",
      0.0
    ],
    [
      "probe",
      0.0
    ],
    [
      "rable",
      0.0
    ],
    [
      "vaillant",
      0.0
    ],
    [
      "volume",
      0.0
    ],
    [
      "nourrissant",
      0.0
    ],
    [
      "matiere",
      0.0
    ],
    [
      "indechirable",
      0.0
    ],
    [
      "incassable",
      0.0
    ],
    [
      "enracine",
      0.0
    ],
    [
      "corps",
      0.0
    ],
    [
      "cartesien",
      0.0
    ],
    [
      "brillant",
      0.0
    ],
    [
      "affermi",
      0.0
    ],
    [
      "equilibre",
      0.0
    ]
  ],
  "nager": [
    [
      "flotter",
      0.2
    ],
    [
      "voguer",
      0.1325
    ],
    [
      "s'embourber",
      0.065
    ],
    [
      "ramer",
      0.065
    ],
    [
      "patauger",
      0.065
    ],
    [
      "naviguer",
      0.065
    ],
    [
      "baigner",
      0.065
    ],
    [
      "surnager",
      0.065
    ]
  ],
  "nage": [
    [
      "natation",
      1.0
    ]
  ],
  "age": [
    [
      "fleche",
      0.3325
    ],
    [
      "haie",
      0.3325
    ],
    [
      "perche",
      0.3325
    ]
  ],
  "quelle": [
    [
      "qui",
      0.5
    ],
    [
      "quoi",
      0.5
    ]
  ],
  "chant": [
    [
      "chanson",
      0.115
    ],
    [
      "melodie",
      0.0825
    ],
    [
      "poeme",
      0.075
    ],
    [
      "musique",
      0.0525
    ],
    [
      "air",
      0.0375
    ],
    [
      "hymne",
      0.0375
    ],
    [
      "refrain",
      0.0375
    ],
    [
      "bruit",
      0.03
    ],
    [
      "rengaine",
      0.02
    ],
    [
      "voix",
      0.0125
    ],
    [
      "romance",
      0.0125
    ],
    [
      "ramage",
      0.0125
    ],
    [
      "poesie",
      0.0125
    ],
    [
      "melopee",
      0.0125
    ],
    [
      "lied",
      0.0125
    ],
    [
      "gazouillis",
      0.0125
    ],
    [
      "gazouillement",
      0.0125
    ],
    [
      "aria",
      0.0125
    ],
    [
      "ballade",
      0.0125
    ],
    [
      "barcarolle",
      0.0125
    ],
    [
      "cantilene",
      0.0125
    ],
    [
      "complainte",
      0.0125
    ],
    [
      "couplet",
      0.0125
    ],
    [
      "roulade",
      0.005
    ],
    [
      "rondeau",
      0.005
    ],
    [
      "ritournelle",
      0.005
    ],
    [
      "rhapsodie",
      0.005
    ],
    [
      "ranz",
      0.005
    ],
    [
      "pepiement",
      0.005
    ],
    [
      "pean",
      0.005
    ],
    [
      "psalmodie",
      0.005
    ],
    [
      "recitatif",
      0.005
    ],
    [
      "spiritual",
      0.005
    ],
    [
      "eloge",
      0.005
    ],
    [
      "vocero",
      0.005
    ],
    [
      "variation",
      0.005
    ],
    [
      "tyrolienne",
      0.005
    ],
    [
      "trio",
      0.005
    ],
    [
      "tranche",
      0.005
    ],
    [
      "serenade",
      0.005
    ],
    [
      "stridulation",
      0.005
    ],
    [
      "phrase",
      0.005
    ],
    [
      "partie",
      0.005
    ],
    [
      "oratorio",
      0.005
    ],
    [
      "arioso",
      0.005
    ],
    [
      "aubade",
      0.005
    ],
    [
      "bardit",
      0.005
    ],
    [
      "berceuse",
      0.005
    ],
    [
      "beuglante",
      0.005
    ],
    [
      "blues",
      0.005
    ],
    [
      "bramement",
      0.005
    ],
    [
      "cantabile",
      0.005
    ],
    [
      "cantate",
      0.005
    ],
    [
      "cantique",
      0.005
    ],
    [
      "cavatine",
      0.005
    ],
    [
      "choral",
      0.005
    ],
    [
      "fado",
      0.005
    ],
    [
      "goualante",
      0.005
    ],
    [
      "litanie",
      0.005
    ],
    [
      "messe",
      0.005
    ],
    [
      "nome",
      0.005
    ],
    [
      "ariette",
      0.005
    ]
  ],
  "fantastique": [
    [
      "extraordinaire",
      0.0925
    ],
    [
      "etonnant",
      0.0775
    ],
    [
      "fabuleux",
      0.055
    ],
    [
      "prodigieux",
      0.055
    ],
    [
      "sensationnel",
      0.055
    ],
    [
      "formidable",
      0.0525
    ],
    [
      "inoui",
      0.0425
    ],
    [
      "incroyable",
      0.0375
    ],
    [
      "enorme",
      0.03
    ],
    [
      "invraisemblable",
      0.0275
    ],
    [
      "extravagant",
      0.0275
    ],
    [
      "merveilleux",
      0.025
    ],
    [
      "surprenant",
      0.025
    ],
    [
      "phenomenal",
      0.0225
    ],
    [
      "stupefiant",
      0.0175
    ],
    [
      "bizarre",
      0.015
    ],
    [
      "faramineux",
      0.015
    ],
    [
      "beau",
      0.015
    ],
    [
      "fantasmagorique",
      0.015
    ],
    [
      "fou",
      0.0125
    ],
    [
      "colossal",
      0.0125
    ],
    [
      "rocambolesque",
      0.0125
    ],
    [
      "etrange",
      0.01
    ],
    [
      "monumental",
      0.01
    ],
    [
      "admirable",
      0.01
    ],
    [
      "abracadabrant",
      0.01
    ],
    [
      "imposant",
      0.0075
    ],
    [
      "epatant",
      0.0075
    ],
    [
      "inimaginable",
      0.0075
    ],
    [
      "impressionnant",
      0.0075
    ],
    [
      "gigantesque",
      0.0075
    ],
    [
      "insense",
      0.0075
    ],
    [
      "renversant",
      0.0075
    ],
    [
      "inconcevable",
      0.005
    ],
    [
      "epoustouflant",
      0.005
    ],
    [
      "terrible",
      0.005
    ],
    [
      "demesure",
      0.005
    ],
    [
      "drole",
      0.005
    ],
    [
      "effarant",
      0.005
    ],
    [
      "mirifique",
      0.0025
    ],
    [
      "incoherent",
      0.0025
    ],
    [
      "imaginaire",
      0.0025
    ],
    [
      "boeuf",
      0.0025
    ],
    [
      "surnaturel",
      0.0025
    ],
    [
      "monstre",
      0.0025
    ],
    [
      "mirobolant",
      0.0025
    ],
    [
      "magique",
      0.0025
    ],
    [
      "grandiose",
      0.0025
    ],
    [
      "feerique",
      0.0025
    ],
    [
      "deraisonnable",
      0.0025
    ],
    [
      "delirant",
      0.0025
    ],
    [
      "chimerique",
      0.0025
    ],
    [
      "architectural",
      0.0025
    ],
    [
      "titanesque",
      0.0025
    ],
    [
      "irreel",
      0.0025
    ],
    [
      "astronomique",
      0.0025
    ],
    [
      "furieux",
      0.0
    ],
    [
      "homerique",
      0.0
    ],
    [
      "incalculable",
      0.0
    ],
    [
      "mensonger",
      0.0
    ],
    [
      "miraculeux",
      0.0
    ],
    [
      "romanesque",
      0.0
    ],
    [
      "epique",
      0.0
    ],
    [
      "thaumaturgique",
      0.0
    ],
    [
      "hyperbolique",
      0.0
    ],
    [
      "genial",
      0.0
    ],
    [
      "apocalyptique",
      0.0
    ],
    [
      "expressionnisme",
      0.0
    ],
    [
      "fantomatique",
      0.0
    ],
    [
      "feerie",
      0.0
    ],
    [
      "satane",
      0.0
    ],
    [
      "eblouissant",
      0.0
    ]
  ],
  "signifier": [
    [
      "reveler",
      0.085
    ],
    [
      "montrer",
      0.08
    ],
    [
      "indiquer",
      0.075
    ],
    [
      "signaler",
      0.0675
    ],
    [
      "exprimer",
      0.0575
    ],
    [
      "annoncer",
      0.0525
    ],
    [
      "declarer",
      0.045
    ],
    [
      "manifester",
      0.0425
    ],
    [
      "dire",
      0.04
    ],
    [
      "exposer",
      0.035
    ],
    [
      "expliquer",
      0.0325
    ],
    [
      "marquer",
      0.0275
    ],
    [
      "notifier",
      0.0225
    ],
    [
      "communiquer",
      0.02
    ],
    [
      "temoigner",
      0.02
    ],
    [
      "afficher",
      0.0175
    ],
    [
      "representer",
      0.0175
    ],
    [
      "enoncer",
      0.0125
    ],
    [
      "informer",
      0.01
    ],
    [
      "denoncer",
      0.01
    ],
    [
      "designer",
      0.01
    ],
    [
      "traduire",
      0.01
    ],
    [
      "peindre",
      0.0075
    ],
    [
      "mander",
      0.0075
    ],
    [
      "enseigner",
      0.0075
    ],
    [
      "denoter",
      0.0075
    ],
    [
      "citer",
      0.005
    ],
    [
      "figurer",
      0.005
    ],
    [
      "preciser",
      0.005
    ],
    [
      "rendre",
      0.005
    ],
    [
      "specifier",
      0.005
    ],
    [
      "tracer",
      0.005
    ],
    [
      "sommer",
      0.005
    ],
    [
      "prouver",
      0.005
    ],
    [
      "ordonner",
      0.005
    ],
    [
      "transmettre",
      0.0025
    ],
    [
      "materialiser",
      0.0025
    ],
    [
      "intimer",
      0.0025
    ],
    [
      "exterioriser",
      0.0025
    ],
    [
      "aviser",
      0.0
    ],
    [
      "impliquer",
      0.0
    ],
    [
      "presager",
      0.0
    ],
    [
      "rimer",
      0.0
    ],
    [
      "s'entendre",
      0.0
    ],
    [
      "equivaloir",
      0.0
    ]
  ],
  "philosophie": [
    [
      "theorie",
      0.095
    ],
    [
      "systeme",
      0.075
    ],
    [
      "tendance",
      0.0625
    ],
    [
      "position",
      0.0625
    ],
    [
      "pensee",
      0.0625
    ],
    [
      "doctrine",
      0.0625
    ],
    [
      "principe",
      0.0425
    ],
    [
      "raison",
      0.0425
    ],
    [
      "ecole",
      0.03
    ],
    [
      "serenite",
      0.03
    ],
    [
      "indifference",
      0.03
    ],
    [
      "idee",
      0.03
    ],
    [
      "calme",
      0.03
    ],
    [
      "sens",
      0.02
    ],
    [
      "sagesse",
      0.02
    ],
    [
      "morale",
      0.02
    ],
    [
      "logique",
      0.02
    ],
    [
      "insouciance",
      0.02
    ],
    [
      "impassibilite",
      0.02
    ],
    [
      "idees",
      0.02
    ],
    [
      "tact",
      0.01
    ],
    [
      "these",
      0.01
    ],
    [
      "epistemologie",
      0.01
    ],
    [
      "equanimite",
      0.01
    ],
    [
      "secte",
      0.01
    ],
    [
      "resignation",
      0.01
    ],
    [
      "metaphysique",
      0.01
    ],
    [
      "legerete",
      0.01
    ],
    [
      "ideologie",
      0.01
    ],
    [
      "esthetique",
      0.01
    ],
    [
      "dialectique",
      0.01
    ],
    [
      "ataraxie",
      0.01
    ],
    [
      "ethique",
      0.01
    ]
  ],
  "jeune": [
    [
      "adolescent",
      0.0525
    ],
    [
      "maigre",
      0.0525
    ],
    [
      "novice",
      0.0525
    ],
    [
      "pauvre",
      0.0525
    ],
    [
      "petit",
      0.0525
    ],
    [
      "nouveau",
      0.0425
    ],
    [
      "inexperimente",
      0.0425
    ],
    [
      "frais",
      0.0425
    ],
    [
      "vif",
      0.03
    ],
    [
      "neuf",
      0.03
    ],
    [
      "naif",
      0.03
    ],
    [
      "mesquin",
      0.03
    ],
    [
      "juvenile",
      0.03
    ],
    [
      "juste",
      0.03
    ],
    [
      "candide",
      0.03
    ],
    [
      "cadet",
      0.03
    ],
    [
      "vert",
      0.02
    ],
    [
      "printanier",
      0.02
    ],
    [
      "parcimonieux",
      0.02
    ],
    [
      "mineur",
      0.02
    ],
    [
      "leger",
      0.02
    ],
    [
      "immature",
      0.02
    ],
    [
      "gars",
      0.02
    ],
    [
      "fils",
      0.02
    ],
    [
      "mesure",
      0.01
    ],
    [
      "miserable",
      0.01
    ],
    [
      "naissant",
      0.01
    ],
    [
      "profane",
      0.01
    ],
    [
      "recent",
      0.01
    ],
    [
      "teenager",
      0.01
    ],
    [
      "junior",
      0.01
    ],
    [
      "jouvenceau",
      0.01
    ],
    [
      "jeunot",
      0.01
    ],
    [
      "jeunet",
      0.01
    ],
    [
      "jeunesse",
      0.01
    ],
    [
      "credule",
      0.01
    ],
    [
      "bourru",
      0.01
    ],
    [
      "benjamin",
      0.01
    ],
    [
      "ephebe",
      0.01
    ]
  ],
  "phacochere": [
    [
      "sanglier",
      1.0
    ]
  ],
  "organe": [
    [
      "accessoire",
      0.0875
    ],
    [
      "agent",
      0.0875
    ],
    [
      "ame",
      0.0575
    ],
    [
      "representant",
      0.0575
    ],
    [
      "piece",
      0.0575
    ],
    [
      "moyen",
      0.0575
    ],
    [
      "journal",
      0.0575
    ],
    [
      "instrument",
      0.0575
    ],
    [
      "penis",
      0.0275
    ],
    [
      "revue",
      0.0275
    ],
    [
      "sens",
      0.0275
    ],
    [
      "service",
      0.0275
    ],
    [
      "vehicule",
      0.0275
    ],
    [
      "orgue",
      0.0275
    ],
    [
      "nez",
      0.0275
    ],
    [
      "moteur",
      0.0275
    ],
    [
      "membre",
      0.0275
    ],
    [
      "feuille",
      0.0275
    ],
    [
      "entremise",
      0.0275
    ],
    [
      "corps",
      0.0275
    ],
    [
      "centre",
      0.0275
    ],
    [
      "attribut",
      0.0275
    ],
    [
      "equipement",
      0.0275
    ]
  ],
  "horreur": [
    [
      "atrocite",
      0.065
    ],
    [
      "infamie",
      0.0525
    ],
    [
      "peur",
      0.0525
    ],
    [
      "repulsion",
      0.0375
    ],
    [
      "vilenie",
      0.0375
    ],
    [
      "repugnance",
      0.0325
    ],
    [
      "monstruosite",
      0.0325
    ],
    [
      "haine",
      0.0325
    ],
    [
      "abjection",
      0.0325
    ],
    [
      "epouvante",
      0.025
    ],
    [
      "turpitude",
      0.025
    ],
    [
      "terreur",
      0.025
    ],
    [
      "mechancete",
      0.025
    ],
    [
      "ferocite",
      0.025
    ],
    [
      "frayeur",
      0.025
    ],
    [
      "execration",
      0.025
    ],
    [
      "effroi",
      0.025
    ],
    [
      "degout",
      0.025
    ],
    [
      "eloignement",
      0.0175
    ],
    [
      "phobie",
      0.0175
    ],
    [
      "obscenite",
      0.0175
    ],
    [
      "noirceur",
      0.0175
    ],
    [
      "ignominie",
      0.0175
    ],
    [
      "honte",
      0.0175
    ],
    [
      "hideur",
      0.0175
    ],
    [
      "cruaute",
      0.0175
    ],
    [
      "calomnie",
      0.0175
    ],
    [
      "aversion",
      0.0175
    ],
    [
      "abomination",
      0.0175
    ],
    [
      "epouvantement",
      0.0125
    ],
    [
      "stupefaction",
      0.0125
    ],
    [
      "medisance",
      0.0125
    ],
    [
      "monstre",
      0.0125
    ],
    [
      "laideur",
      0.0125
    ],
    [
      "grossierete",
      0.0125
    ],
    [
      "crime",
      0.0125
    ],
    [
      "saisissement",
      0.005
    ],
    [
      "poison",
      0.005
    ],
    [
      "plaie",
      0.005
    ],
    [
      "panique",
      0.005
    ],
    [
      "nausee",
      0.005
    ],
    [
      "laideron",
      0.005
    ],
    [
      "detestation",
      0.005
    ],
    [
      "degoutation",
      0.005
    ],
    [
      "cochonnerie",
      0.005
    ],
    [
      "cauchemar",
      0.005
    ],
    [
      "affres",
      0.005
    ],
    [
      "epouvantail",
      0.005
    ]
  ],
  "odeur": [
    [
      "senteur",
      0.1575
    ],
    [
      "emanation",
      0.125
    ],
    [
      "fumet",
      0.11
    ],
    [
      "exhalaison",
      0.095
    ],
    [
      "effluve",
      0.0775
    ],
    [
      "arome",
      0.0775
    ],
    [
      "parfum",
      0.0625
    ],
    [
      "relent",
      0.0625
    ],
    [
      "vent",
      0.03
    ],
    [
      "puanteur",
      0.03
    ],
    [
      "haleine",
      0.03
    ],
    [
      "empyreume",
      0.03
    ],
    [
      "bouquet",
      0.015
    ],
    [
      "effluence",
      0.015
    ],
    [
      "fragrance",
      0.015
    ],
    [
      "gout",
      0.015
    ],
    [
      "remugle",
      0.015
    ],
    [
      "trace",
      0.015
    ]
  ],
  "lieu": [
    [
      "endroit",
      0.07
    ],
    [
      "place",
      0.07
    ],
    [
      "emplacement",
      0.0575
    ],
    [
      "coin",
      0.0525
    ],
    [
      "situation",
      0.0475
    ],
    [
      "site",
      0.04
    ],
    [
      "point",
      0.04
    ],
    [
      "matiere",
      0.04
    ],
    [
      "terrain",
      0.0325
    ],
    [
      "secteur",
      0.0325
    ],
    [
      "region",
      0.0325
    ],
    [
      "pays",
      0.0325
    ],
    [
      "origine",
      0.0325
    ],
    [
      "cause",
      0.0275
    ],
    [
      "position",
      0.0275
    ],
    [
      "occasion",
      0.0225
    ],
    [
      "sujet",
      0.0225
    ],
    [
      "zone",
      0.015
    ],
    [
      "rang",
      0.015
    ],
    [
      "parages",
      0.015
    ],
    [
      "milieu",
      0.015
    ],
    [
      "maison",
      0.015
    ],
    [
      "espace",
      0.015
    ],
    [
      "canton",
      0.015
    ],
    [
      "terre",
      0.01
    ],
    [
      "sejour",
      0.01
    ],
    [
      "residence",
      0.01
    ],
    [
      "raison",
      0.01
    ],
    [
      "pretexte",
      0.01
    ],
    [
      "poste",
      0.01
    ],
    [
      "domicile",
      0.01
    ],
    [
      "cas",
      0.01
    ],
    [
      "berceau",
      0.01
    ],
    [
      "objet",
      0.005
    ],
    [
      "part",
      0.005
    ],
    [
      "passage",
      0.005
    ],
    [
      "theatre",
      0.005
    ],
    [
      "merlan",
      0.005
    ],
    [
      "localite",
      0.005
    ],
    [
      "extraction",
      0.005
    ],
    [
      "colin",
      0.005
    ],
    [
      "categorie",
      0.005
    ],
    [
      "adresse",
      0.005
    ],
    [
      "etape",
      0.005
    ]
  ],
  "soulever": [
    [
      "exciter",
      0.0975
    ],
    [
      "entrainer",
      0.065
    ],
    [
      "provoquer",
      0.0575
    ],
    [
      "susciter",
      0.045
    ],
    [
      "pousser",
      0.04
    ],
    [
      "occasionner",
      0.0375
    ],
    [
      "elever",
      0.0325
    ],
    [
      "enflammer",
      0.03
    ],
    [
      "amener",
      0.0275
    ],
    [
      "determiner",
      0.0275
    ],
    [
      "attirer",
      0.025
    ],
    [
      "monter",
      0.025
    ],
    [
      "transporter",
      0.0225
    ],
    [
      "lever",
      0.0225
    ],
    [
      "exalter",
      0.0225
    ],
    [
      "causer",
      0.02
    ],
    [
      "relever",
      0.02
    ],
    [
      "appeler",
      0.0175
    ],
    [
      "faire",
      0.015
    ],
    [
      "hausser",
      0.015
    ],
    [
      "enlever",
      0.015
    ],
    [
      "dechainer",
      0.015
    ],
    [
      "conduire",
      0.015
    ],
    [
      "creer",
      0.0125
    ],
    [
      "piquer",
      0.0125
    ],
    [
      "prendre",
      0.0125
    ],
    [
      "remonter",
      0.01
    ],
    [
      "galvaniser",
      0.01
    ],
    [
      "declencher",
      0.01
    ],
    [
      "dresser",
      0.01
    ],
    [
      "apporter",
      0.01
    ],
    [
      "eveiller",
      0.0075
    ],
    [
      "emouvoir",
      0.0075
    ],
    [
      "trousser",
      0.0075
    ],
    [
      "produire",
      0.0075
    ],
    [
      "allumer",
      0.0075
    ],
    [
      "agiter",
      0.0075
    ],
    [
      "engendrer",
      0.005
    ],
    [
      "procurer",
      0.005
    ],
    [
      "redresser",
      0.005
    ],
    [
      "electriser",
      0.005
    ],
    [
      "ebranler",
      0.005
    ],
    [
      "hisser",
      0.005
    ],
    [
      "fouetter",
      0.005
    ],
    [
      "faucher",
      0.005
    ],
    [
      "ameuter",
      0.005
    ],
    [
      "ecarter",
      0.0025
    ],
    [
      "s'emparer",
      0.0025
    ],
    [
      "reveiller",
      0.0025
    ],
    [
      "retrousser",
      0.0025
    ],
    [
      "remuer",
      0.0025
    ],
    [
      "motiver",
      0.0025
    ],
    [
      "escamoter",
      0.0025
    ],
    [
      "emballer",
      0.0025
    ],
    [
      "armer",
      0.0025
    ],
    [
      "revolter",
      0.0
    ],
    [
      "poser",
      0.0
    ],
    [
      "haler",
      0.0
    ],
    [
      "gonfler",
      0.0
    ],
    [
      "enivrer",
      0.0
    ],
    [
      "surhausser",
      0.0
    ]
  ],
  "cochon": [
    [
      "obscene",
      0.09
    ],
    [
      "licencieux",
      0.0775
    ],
    [
      "degoutant",
      0.06
    ],
    [
      "malpropre",
      0.06
    ],
    [
      "repugnant",
      0.055
    ],
    [
      "porc",
      0.0475
    ],
    [
      "grivois",
      0.04
    ],
    [
      "grossier",
      0.035
    ],
    [
      "egrillard",
      0.035
    ],
    [
      "sordide",
      0.03
    ],
    [
      "sale",
      0.03
    ],
    [
      "polisson",
      0.03
    ],
    [
      "debauche",
      0.03
    ],
    [
      "inconvenant",
      0.0225
    ],
    [
      "ordurier",
      0.0225
    ],
    [
      "sale",
      0.0225
    ],
    [
      "erotique",
      0.0175
    ],
    [
      "pourceau",
      0.0175
    ],
    [
      "pornographique",
      0.0175
    ],
    [
      "leste",
      0.0175
    ],
    [
      "vicieux",
      0.01
    ],
    [
      "verrat",
      0.01
    ],
    [
      "souillon",
      0.01
    ],
    [
      "solitaire",
      0.01
    ],
    [
      "sanglier",
      0.01
    ],
    [
      "sagouin",
      0.01
    ],
    [
      "nauseabond",
      0.01
    ],
    [
      "marcassin",
      0.01
    ],
    [
      "goret",
      0.01
    ],
    [
      "deprave",
      0.01
    ],
    [
      "bete",
      0.01
    ],
    [
      "paillard",
      0.005
    ],
    [
      "pervers",
      0.005
    ],
    [
      "porcelet",
      0.005
    ],
    [
      "porno",
      0.005
    ],
    [
      "pecari",
      0.005
    ],
    [
      "raide",
      0.005
    ],
    [
      "ordure",
      0.005
    ],
    [
      "hamster",
      0.005
    ],
    [
      "cochonnee",
      0.005
    ],
    [
      "cochonnet",
      0.005
    ],
    [
      "cochonnerie",
      0.005
    ],
    [
      "cochonnaille",
      0.005
    ],
    [
      "coche",
      0.005
    ],
    [
      "cobaye",
      0.005
    ],
    [
      "breneux",
      0.005
    ],
    [
      "truie",
      0.005
    ]
  ],
  "poete": [
    [
      "chanteur",
      0.12
    ],
    [
      "troubadour",
      0.085
    ],
    [
      "barde",
      0.0675
    ],
    [
      "trouvere",
      0.0675
    ],
    [
      "auteur",
      0.05
    ],
    [
      "versificateur",
      0.0325
    ],
    [
      "reveur",
      0.0325
    ],
    [
      "menestrel",
      0.0325
    ],
    [
      "minnesinger",
      0.015
    ],
    [
      "metromane",
      0.015
    ],
    [
      "parolier",
      0.015
    ],
    [
      "poetereau",
      0.015
    ],
    [
      "prophete",
      0.015
    ],
    [
      "rhapsode",
      0.015
    ],
    [
      "rhetoriqueur",
      0.015
    ],
    [
      "rimailleur",
      0.015
    ],
    [
      "rimeur",
      0.015
    ],
    [
      "scalde",
      0.015
    ],
    [
      "utopiste",
      0.015
    ],
    [
      "voyant",
      0.015
    ],
    [
      "maitre",
      0.015
    ],
    [
      "jongleur",
      0.015
    ],
    [
      "amant",
      0.015
    ],
    [
      "aede",
      0.015
    ],
    [
      "chantre",
      0.015
    ],
    [
      "cigale",
      0.015
    ],
    [
      "favori",
      0.015
    ],
    [
      "felibre",
      0.015
    ],
    [
      "idealiste",
      0.015
    ],
    [
      "inspire",
      0.015
    ],
    [
      "ecrivain",
      0.015
    ]
  ],
  "sommeiller": [
    [
      "dormir",
      0.32
    ],
    [
      "somnoler",
      0.32
    ],
    [
      "s'endormir",
      0.0375
    ],
    [
      "s'assoupir",
      0.0375
    ],
    [
      "roupiller",
      0.0375
    ],
    [
      "ronfler",
      0.0375
    ],
    [
      "reposer",
      0.0375
    ],
    [
      "pioncer",
      0.0375
    ],
    [
      "dormailler",
      0.0375
    ]
  ],
  "martyr": [
    [
      "victime",
      0.285
    ],
    [
      "battu",
      0.1425
    ],
    [
      "persecution",
      0.1425
    ],
    [
      "persecute",
      0.1425
    ],
    [
      "saint",
      0.1425
    ]
  ],
  "parfum": [
    [
      "arome",
      0.09
    ],
    [
      "baume",
      0.09
    ],
    [
      "essence",
      0.09
    ],
    [
      "fumet",
      0.09
    ],
    [
      "odeur",
      0.09
    ],
    [
      "senteur",
      0.09
    ],
    [
      "emanation",
      0.0675
    ],
    [
      "exhalaison",
      0.0675
    ],
    [
      "aromate",
      0.045
    ],
    [
      "effluve",
      0.045
    ],
    [
      "onguent",
      0.0225
    ],
    [
      "huile",
      0.0225
    ],
    [
      "haleine",
      0.0225
    ],
    [
      "fetidite",
      0.0225
    ],
    [
      "fragrance",
      0.0225
    ],
    [
      "extrait",
      0.0225
    ],
    [
      "eau",
      0.0225
    ],
    [
      "bouquet",
      0.0225
    ],
    [
      "beaute",
      0.0225
    ]
  ],
  "infame": [
    [
      "ignoble",
      0.1175
    ],
    [
      "abject",
      0.1
    ],
    [
      "honteux",
      0.06
    ],
    [
      "immonde",
      0.06
    ],
    [
      "sordide",
      0.055
    ],
    [
      "degoutant",
      0.0475
    ],
    [
      "vil",
      0.045
    ],
    [
      "repugnant",
      0.045
    ],
    [
      "bas",
      0.045
    ],
    [
      "sale",
      0.04
    ],
    [
      "avilissant",
      0.0325
    ],
    [
      "indigne",
      0.025
    ],
    [
      "impur",
      0.025
    ],
    [
      "degradant",
      0.0225
    ],
    [
      "infect",
      0.0225
    ],
    [
      "ignominieux",
      0.02
    ],
    [
      "odieux",
      0.02
    ],
    [
      "laid",
      0.0175
    ],
    [
      "innommable",
      0.0175
    ],
    [
      "horrible",
      0.015
    ],
    [
      "deshonorant",
      0.0125
    ],
    [
      "malpropre",
      0.0125
    ],
    [
      "meprisable",
      0.01
    ],
    [
      "infamant",
      0.01
    ],
    [
      "hideux",
      0.01
    ],
    [
      "joli",
      0.0075
    ],
    [
      "ordurier",
      0.0075
    ],
    [
      "salope",
      0.0075
    ],
    [
      "vilain",
      0.0075
    ],
    [
      "inavouable",
      0.005
    ],
    [
      "boueux",
      0.005
    ],
    [
      "atroce",
      0.005
    ],
    [
      "turpide",
      0.0025
    ],
    [
      "scandaleux",
      0.0025
    ],
    [
      "puant",
      0.0025
    ],
    [
      "haissable",
      0.0025
    ],
    [
      "scelerat",
      0.0
    ],
    [
      "injustifiable",
      0.0
    ],
    [
      "fletrissant",
      0.0
    ],
    [
      "diffamatoire",
      0.0
    ],
    [
      "diffamant",
      0.0
    ],
    [
      "crapuleux",
      0.0
    ],
    [
      "coupable",
      0.0
    ],
    [
      "ehonte",
      0.0
    ]
  ],
  "inonder": [
    [
      "submerger",
      0.1125
    ],
    [
      "remplir",
      0.0925
    ],
    [
      "envahir",
      0.0825
    ],
    [
      "abreuver",
      0.07
    ],
    [
      "penetrer",
      0.06
    ],
    [
      "impregner",
      0.05
    ],
    [
      "couvrir",
      0.05
    ],
    [
      "baigner",
      0.05
    ],
    [
      "arroser",
      0.05
    ],
    [
      "mouiller",
      0.04
    ],
    [
      "noyer",
      0.04
    ],
    [
      "tremper",
      0.04
    ],
    [
      "recouvrir",
      0.03
    ],
    [
      "deborder",
      0.03
    ],
    [
      "garnir",
      0.0175
    ],
    [
      "gorger",
      0.0175
    ],
    [
      "occuper",
      0.0175
    ],
    [
      "saturer",
      0.0175
    ],
    [
      "ecraser",
      0.0175
    ],
    [
      "illuminer",
      0.0075
    ],
    [
      "encombrer",
      0.0075
    ],
    [
      "devaster",
      0.0075
    ],
    [
      "asperger",
      0.0075
    ],
    [
      "affluer",
      0.0075
    ],
    [
      "immerger",
      0.0075
    ]
  ],
  "declencher": [
    [
      "provoquer",
      0.1
    ],
    [
      "susciter",
      0.1
    ],
    [
      "exciter",
      0.085
    ],
    [
      "occasionner",
      0.085
    ],
    [
      "soulever",
      0.085
    ],
    [
      "entrainer",
      0.0575
    ],
    [
      "commencer",
      0.0575
    ],
    [
      "allumer",
      0.0425
    ],
    [
      "causer",
      0.0425
    ],
    [
      "creer",
      0.0425
    ],
    [
      "lancer",
      0.0425
    ],
    [
      "produire",
      0.0275
    ],
    [
      "entreprendre",
      0.0275
    ],
    [
      "determiner",
      0.0275
    ],
    [
      "dechainer",
      0.0275
    ],
    [
      "amener",
      0.0275
    ],
    [
      "amorcer",
      0.0125
    ],
    [
      "apporter",
      0.0125
    ],
    [
      "decliquer",
      0.0125
    ],
    [
      "mouvoir",
      0.0125
    ],
    [
      "operer",
      0.0125
    ],
    [
      "eveiller",
      0.0125
    ]
  ],
  "declenche": [
    [
      "provoquer",
      0.1
    ],
    [
      "susciter",
      0.1
    ],
    [
      "exciter",
      0.085
    ],
    [
      "occasionner",
      0.085
    ],
    [
      "soulever",
      0.085
    ],
    [
      "entrainer",
      0.0575
    ],
    [
      "commencer",
      0.0575
    ],
    [
      "allumer",
      0.0425
    ],
    [
      "causer",
      0.0425
    ],
    [
      "creer",
      0.0425
    ],
    [
      "lancer",
      0.0425
    ],
    [
      "produire",
      0.0275
    ],
    [
      "entreprendre",
      0.0275
    ],
    [
      "determiner",
      0.0275
    ],
    [
      "dechainer",
      0.0275
    ],
    [
      "amener",
      0.0275
    ],
    [
      "amorcer",
      0.0125
    ],
    [
      "apporter",
      0.0125
    ],
    [
      "decliquer",
      0.0125
    ],
    [
      "mouvoir",
      0.0125
    ],
    [
      "operer",
      0.0125
    ],
    [
      "eveiller",
      0.0125
    ]
  ],
  "tempeter": [
    [
      "fulminer",
      0.1675
    ],
    [
      "crier",
      0.0925
    ],
    [
      "tonner",
      0.0925
    ],
    [
      "invectiver",
      0.0825
    ],
    [
      "pester",
      0.0725
    ],
    [
      "vituperer",
      0.0625
    ],
    [
      "protester",
      0.0625
    ],
    [
      "fumer",
      0.04
    ],
    [
      "hurler",
      0.04
    ],
    [
      "injurier",
      0.04
    ],
    [
      "maudire",
      0.03
    ],
    [
      "gueuler",
      0.03
    ],
    [
      "attaquer",
      0.03
    ],
    [
      "deblaterer",
      0.02
    ],
    [
      "declamer",
      0.02
    ],
    [
      "exploser",
      0.02
    ],
    [
      "gronder",
      0.02
    ],
    [
      "jurer",
      0.02
    ],
    [
      "rager",
      0.02
    ],
    [
      "reclamer",
      0.01
    ],
    [
      "ecumer",
      0.01
    ]
  ],
  "tempete": [
    [
      "ouragan",
      0.085
    ],
    [
      "orage",
      0.0725
    ],
    [
      "bourrasque",
      0.07
    ],
    [
      "agitation",
      0.065
    ],
    [
      "tornade",
      0.065
    ],
    [
      "tourmente",
      0.055
    ],
    [
      "typhon",
      0.05
    ],
    [
      "trouble",
      0.0425
    ],
    [
      "tumulte",
      0.035
    ],
    [
      "tourbillon",
      0.03
    ],
    [
      "rafale",
      0.03
    ],
    [
      "dechainement",
      0.03
    ],
    [
      "vent",
      0.0225
    ],
    [
      "trombe",
      0.0225
    ],
    [
      "frenesie",
      0.0225
    ],
    [
      "bouillonnement",
      0.0225
    ],
    [
      "cyclone",
      0.0175
    ],
    [
      "debordement",
      0.0175
    ],
    [
      "explosion",
      0.0175
    ],
    [
      "perturbation",
      0.0125
    ],
    [
      "fracas",
      0.0125
    ],
    [
      "cataclysme",
      0.0125
    ],
    [
      "tonnerre",
      0.0075
    ],
    [
      "renversement",
      0.0075
    ],
    [
      "intemperie",
      0.0075
    ],
    [
      "deferlement",
      0.0075
    ],
    [
      "commotion",
      0.0075
    ],
    [
      "simoun",
      0.0025
    ],
    [
      "querelle",
      0.0025
    ],
    [
      "houle",
      0.0025
    ],
    [
      "grain",
      0.0025
    ],
    [
      "desarroi",
      0.0025
    ],
    [
      "discussion",
      0.0025
    ],
    [
      "colere",
      0.0025
    ],
    [
      "sedition",
      0.0025
    ]
  ],
  "pitie": [
    [
      "bonte",
      0.1125
    ],
    [
      "compassion",
      0.1125
    ],
    [
      "misericorde",
      0.095
    ],
    [
      "indulgence",
      0.08
    ],
    [
      "sensibilite",
      0.065
    ],
    [
      "humanite",
      0.065
    ],
    [
      "charite",
      0.065
    ],
    [
      "grace",
      0.0475
    ],
    [
      "sympathie",
      0.03
    ],
    [
      "mansuetude",
      0.03
    ],
    [
      "dedain",
      0.03
    ],
    [
      "douceur",
      0.03
    ],
    [
      "condescendance",
      0.03
    ],
    [
      "comprehension",
      0.03
    ],
    [
      "commiseration",
      0.03
    ],
    [
      "coeur",
      0.03
    ],
    [
      "attendrissement",
      0.03
    ],
    [
      "apitoiement",
      0.015
    ],
    [
      "merci",
      0.015
    ],
    [
      "misere",
      0.015
    ],
    [
      "mepris",
      0.015
    ]
  ],
  "pardon": [
    [
      "remission",
      0.205
    ],
    [
      "grace",
      0.1175
    ],
    [
      "absolution",
      0.0875
    ],
    [
      "amnistie",
      0.0875
    ],
    [
      "misericorde",
      0.0575
    ],
    [
      "jubile",
      0.0575
    ],
    [
      "indulgence",
      0.0575
    ],
    [
      "remise",
      0.0275
    ],
    [
      "pelerinage",
      0.0275
    ],
    [
      "procession",
      0.0275
    ],
    [
      "oubli",
      0.0275
    ],
    [
      "hein",
      0.0275
    ],
    [
      "fete",
      0.0275
    ],
    [
      "excuse",
      0.0275
    ],
    [
      "comment",
      0.0275
    ],
    [
      "acquittement",
      0.0275
    ],
    [
      "abolition",
      0.0275
    ],
    [
      "redemption",
      0.0275
    ]
  ],
  "ha": [],
  "finalement": [
    [
      "enfin",
      0.14
    ],
    [
      "definitivement",
      0.0325
    ],
    [
      "decidement",
      0.0325
    ]
  ],
  "quelques": [
    [
      "environ",
      0.155
    ],
    [
      "si",
      0.075
    ],
    [
      "relatif",
      0.075
    ],
    [
      "pour",
      0.075
    ],
    [
      "certain",
      0.075
    ],
    [
      "aussi",
      0.075
    ],
    [
      "aucun",
      0.075
    ],
    [
      "approximativement",
      0.075
    ],
    [
      "un",
      0.075
    ]
  ],
  "annee": [
    [
      "an",
      0.3325
    ],
    [
      "annuite",
      0.165
    ],
    [
      "berge",
      0.165
    ],
    [
      "date",
      0.165
    ],
    [
      "promotion",
      0.165
    ]
  ],
  "remplacer": [
    [
      "servir",
      0.0925
    ],
    [
      "succeder",
      0.0925
    ],
    [
      "suppleer",
      0.0925
    ],
    [
      "supplanter",
      0.055
    ],
    [
      "substituer",
      0.055
    ],
    [
      "subroger",
      0.055
    ],
    [
      "relever",
      0.055
    ],
    [
      "relayer",
      0.055
    ],
    [
      "changer",
      0.055
    ],
    [
      "suivre",
      0.0375
    ],
    [
      "representer",
      0.0375
    ],
    [
      "repousser",
      0.0375
    ],
    [
      "remettre",
      0.0375
    ],
    [
      "troquer",
      0.0175
    ],
    [
      "revolutionner",
      0.0175
    ],
    [
      "renouveler",
      0.0175
    ],
    [
      "detroner",
      0.0175
    ],
    [
      "doubler",
      0.0175
    ],
    [
      "commuter",
      0.0175
    ],
    [
      "echanger",
      0.0175
    ]
  ],
  "poupee": [
    [
      "amante",
      0.0825
    ],
    [
      "fantoche",
      0.0825
    ],
    [
      "marionnette",
      0.0825
    ],
    [
      "pantin",
      0.0825
    ],
    [
      "statuette",
      0.0825
    ],
    [
      "machoire",
      0.04
    ],
    [
      "pansement",
      0.04
    ],
    [
      "poupard",
      0.04
    ],
    [
      "poupon",
      0.04
    ],
    [
      "pepee",
      0.04
    ],
    [
      "mannequin",
      0.04
    ],
    [
      "mandrin",
      0.04
    ],
    [
      "filasse",
      0.04
    ],
    [
      "figurine",
      0.04
    ],
    [
      "cherie",
      0.04
    ],
    [
      "bebe",
      0.04
    ],
    [
      "biquette",
      0.04
    ],
    [
      "baigneur",
      0.04
    ],
    [
      "etoupe",
      0.04
    ]
  ],
  "glaieul": [],
  "chambre": [
    [
      "piece",
      0.075
    ],
    [
      "habitation",
      0.0575
    ],
    [
      "abri",
      0.05
    ],
    [
      "cabinet",
      0.05
    ],
    [
      "taule",
      0.04
    ],
    [
      "piaule",
      0.04
    ],
    [
      "case",
      0.04
    ],
    [
      "cambuse",
      0.04
    ],
    [
      "logement",
      0.0325
    ],
    [
      "gourbi",
      0.0325
    ],
    [
      "cagibi",
      0.0325
    ],
    [
      "cabine",
      0.0325
    ],
    [
      "studio",
      0.0225
    ],
    [
      "conseil",
      0.0225
    ],
    [
      "cellule",
      0.0225
    ],
    [
      "assemblee",
      0.0225
    ],
    [
      "appartement",
      0.0225
    ],
    [
      "vide",
      0.015
    ],
    [
      "turne",
      0.015
    ],
    [
      "salle",
      0.015
    ],
    [
      "mansarde",
      0.015
    ],
    [
      "local",
      0.015
    ],
    [
      "galetas",
      0.015
    ],
    [
      "demeure",
      0.015
    ],
    [
      "creche",
      0.015
    ],
    [
      "compartiment",
      0.015
    ],
    [
      "cavite",
      0.015
    ],
    [
      "carree",
      0.015
    ],
    [
      "alveole",
      0.015
    ],
    [
      "nursery",
      0.0075
    ],
    [
      "parlement",
      0.0075
    ],
    [
      "poele",
      0.0075
    ],
    [
      "reposee",
      0.0075
    ],
    [
      "studette",
      0.0075
    ],
    [
      "senat",
      0.0075
    ],
    [
      "tourelle",
      0.0075
    ],
    [
      "dortoir",
      0.0075
    ],
    [
      "creux",
      0.0075
    ],
    [
      "corps",
      0.0075
    ],
    [
      "chambree",
      0.0075
    ],
    [
      "chambrette",
      0.0075
    ],
    [
      "canfouine",
      0.0075
    ],
    [
      "cambriole",
      0.0075
    ],
    [
      "association",
      0.0075
    ],
    [
      "antichambre",
      0.0075
    ],
    [
      "alcove",
      0.0075
    ],
    [
      "tribunal",
      0.0075
    ]
  ],
  "chambrer": [
    [
      "circonvenir",
      0.085
    ],
    [
      "cloitrer",
      0.085
    ],
    [
      "endoctriner",
      0.085
    ],
    [
      "enfermer",
      0.085
    ],
    [
      "sequestrer",
      0.085
    ],
    [
      "railler",
      0.0425
    ],
    [
      "renfermer",
      0.0425
    ],
    [
      "rechauffer",
      0.0425
    ],
    [
      "sermonner",
      0.0425
    ],
    [
      "isoler",
      0.0425
    ],
    [
      "envelopper",
      0.0425
    ],
    [
      "cohabiter",
      0.0425
    ],
    [
      "claustrer",
      0.0425
    ],
    [
      "claquemurer",
      0.0425
    ],
    [
      "charrier",
      0.0425
    ],
    [
      "temperer",
      0.0425
    ]
  ],
  "champ": [
    [
      "domaine",
      0.0675
    ],
    [
      "terrain",
      0.0575
    ],
    [
      "terre",
      0.05
    ],
    [
      "sphere",
      0.0425
    ],
    [
      "etendue",
      0.0325
    ],
    [
      "paturage",
      0.0325
    ],
    [
      "matiere",
      0.0325
    ],
    [
      "fond",
      0.0325
    ],
    [
      "plaine",
      0.0225
    ],
    [
      "nature",
      0.0225
    ],
    [
      "carriere",
      0.0225
    ],
    [
      "campagne",
      0.0225
    ],
    [
      "etat",
      0.015
    ],
    [
      "sujet",
      0.015
    ],
    [
      "stade",
      0.015
    ],
    [
      "specialite",
      0.015
    ],
    [
      "patis",
      0.015
    ],
    [
      "profession",
      0.015
    ],
    [
      "prairie",
      0.015
    ],
    [
      "plantation",
      0.015
    ],
    [
      "perspective",
      0.015
    ],
    [
      "aire",
      0.015
    ],
    [
      "espace",
      0.015
    ],
    [
      "friche",
      0.015
    ],
    [
      "horizon",
      0.015
    ],
    [
      "labour",
      0.015
    ],
    [
      "lice",
      0.015
    ],
    [
      "influence",
      0.0075
    ],
    [
      "houblonniere",
      0.0075
    ],
    [
      "herbe",
      0.0075
    ],
    [
      "gueret",
      0.0075
    ],
    [
      "glebe",
      0.0075
    ],
    [
      "genetiere",
      0.0075
    ],
    [
      "genevriere",
      0.0075
    ],
    [
      "lopin",
      0.0075
    ],
    [
      "luzerniere",
      0.0075
    ],
    [
      "melonniere",
      0.0075
    ],
    [
      "objet",
      0.0075
    ],
    [
      "occasion",
      0.0075
    ],
    [
      "pre",
      0.0075
    ],
    [
      "terroir",
      0.0075
    ],
    [
      "verger",
      0.0075
    ],
    [
      "garenne",
      0.0075
    ],
    [
      "garanciere",
      0.0075
    ],
    [
      "fourragere",
      0.0075
    ],
    [
      "aspergerie",
      0.0075
    ],
    [
      "barrage",
      0.0075
    ],
    [
      "batterie",
      0.0075
    ],
    [
      "brulis",
      0.0075
    ],
    [
      "camp",
      0.0075
    ],
    [
      "cercle",
      0.0075
    ],
    [
      "champagne",
      0.0075
    ],
    [
      "chaume",
      0.0075
    ],
    [
      "cheneviere",
      0.0075
    ],
    [
      "culture",
      0.0075
    ],
    [
      "capriere",
      0.0075
    ],
    [
      "emblavure",
      0.0075
    ],
    [
      "enceinte",
      0.0075
    ],
    [
      "essart",
      0.0075
    ],
    [
      "fougeraie",
      0.0075
    ],
    [
      "arene",
      0.0075
    ]
  ],
  "court": [
    [
      "filer",
      0.0525
    ],
    [
      "aller",
      0.05
    ],
    [
      "poursuivre",
      0.045
    ],
    [
      "voler",
      0.035
    ],
    [
      "passer",
      0.035
    ],
    [
      "fuir",
      0.035
    ],
    [
      "couler",
      0.0325
    ],
    [
      "foncer",
      0.0325
    ],
    [
      "s'enfuir",
      0.0325
    ],
    [
      "detaler",
      0.0225
    ],
    [
      "circuler",
      0.0225
    ],
    [
      "chercher",
      0.0175
    ],
    [
      "s'envoler",
      0.0125
    ],
    [
      "s'empresser",
      0.0125
    ],
    [
      "s'agiter",
      0.0125
    ],
    [
      "chasser",
      0.0125
    ],
    [
      "affluer",
      0.0125
    ],
    [
      "traverser",
      0.01
    ],
    [
      "tendre",
      0.01
    ],
    [
      "s'elancer",
      0.01
    ],
    [
      "s'ecouler",
      0.01
    ],
    [
      "presser",
      0.01
    ],
    [
      "pourchasser",
      0.01
    ],
    [
      "hanter",
      0.01
    ],
    [
      "galoper",
      0.01
    ],
    [
      "errer",
      0.01
    ],
    [
      "bondir",
      0.01
    ],
    [
      "sillonner",
      0.0075
    ],
    [
      "talonner",
      0.0075
    ],
    [
      "tracer",
      0.0075
    ],
    [
      "visiter",
      0.0075
    ],
    [
      "voyager",
      0.0075
    ],
    [
      "parcourir",
      0.0075
    ],
    [
      "glisser",
      0.0075
    ],
    [
      "cavaler",
      0.0075
    ],
    [
      "decaniller",
      0.0075
    ],
    [
      "essayer",
      0.0075
    ],
    [
      "faire",
      0.0075
    ],
    [
      "fondre",
      0.0075
    ],
    [
      "frequenter",
      0.0075
    ],
    [
      "sprinter",
      0.0025
    ],
    [
      "toucher",
      0.0025
    ],
    [
      "troler",
      0.0025
    ],
    [
      "voltiger",
      0.0025
    ],
    [
      "s'etendre",
      0.0025
    ],
    [
      "roder",
      0.0025
    ],
    [
      "relancer",
      0.0025
    ],
    [
      "accourir",
      0.0025
    ],
    [
      "accelerer",
      0.0025
    ],
    [
      "aspirer",
      0.0025
    ],
    [
      "continuer",
      0.0025
    ],
    [
      "gazer",
      0.0025
    ],
    [
      "importuner",
      0.0025
    ],
    [
      "rechercher",
      0.0025
    ],
    [
      "gambader",
      0.0
    ],
    [
      "pouloper",
      0.0
    ],
    [
      "pedaler",
      0.0
    ],
    [
      "tenter",
      0.0
    ],
    [
      "trisser",
      0.0
    ],
    [
      "droper",
      0.0
    ],
    [
      "draguer",
      0.0
    ],
    [
      "caleter",
      0.0
    ],
    [
      "claquer",
      0.0
    ],
    [
      "courailler",
      0.0
    ],
    [
      "courre",
      0.0
    ],
    [
      "courser",
      0.0
    ],
    [
      "distancer",
      0.0
    ],
    [
      "trotter",
      0.0
    ]
  ],
  "serieux": [
    [
      "grave",
      0.085
    ],
    [
      "sage",
      0.0525
    ],
    [
      "bon",
      0.05
    ],
    [
      "honnete",
      0.04
    ],
    [
      "reserve",
      0.03
    ],
    [
      "calme",
      0.0275
    ],
    [
      "pose",
      0.0275
    ],
    [
      "reflechi",
      0.0225
    ],
    [
      "raisonnable",
      0.0225
    ],
    [
      "important",
      0.0225
    ],
    [
      "prudent",
      0.02
    ],
    [
      "vrai",
      0.0175
    ],
    [
      "severe",
      0.0175
    ],
    [
      "soigneux",
      0.0175
    ],
    [
      "pondere",
      0.0175
    ],
    [
      "digne",
      0.0175
    ],
    [
      "solide",
      0.015
    ],
    [
      "scrupuleux",
      0.015
    ],
    [
      "profond",
      0.015
    ],
    [
      "gros",
      0.015
    ],
    [
      "froid",
      0.015
    ],
    [
      "convenable",
      0.015
    ],
    [
      "tragique",
      0.01
    ],
    [
      "sur",
      0.01
    ],
    [
      "soin",
      0.01
    ],
    [
      "ponctuel",
      0.01
    ],
    [
      "notable",
      0.01
    ],
    [
      "minutieux",
      0.01
    ],
    [
      "mauvais",
      0.01
    ],
    [
      "gravite",
      0.01
    ],
    [
      "dramatique",
      0.01
    ],
    [
      "diligent",
      0.01
    ],
    [
      "consciencieux",
      0.01
    ],
    [
      "range",
      0.0075
    ],
    [
      "respectable",
      0.0075
    ],
    [
      "sombre",
      0.0075
    ],
    [
      "valable",
      0.0075
    ],
    [
      "vertueux",
      0.0075
    ],
    [
      "zele",
      0.0075
    ],
    [
      "prude",
      0.0075
    ],
    [
      "inquietant",
      0.0075
    ],
    [
      "fort",
      0.0075
    ],
    [
      "alarmant",
      0.0075
    ],
    [
      "applique",
      0.0075
    ],
    [
      "assidu",
      0.0075
    ],
    [
      "austere",
      0.0075
    ],
    [
      "bien",
      0.0075
    ],
    [
      "dangereux",
      0.0075
    ],
    [
      "severite",
      0.005
    ],
    [
      "sincere",
      0.005
    ],
    [
      "reel",
      0.005
    ],
    [
      "redoutable",
      0.005
    ],
    [
      "rassis",
      0.005
    ],
    [
      "principal",
      0.005
    ],
    [
      "positif",
      0.005
    ],
    [
      "ponderation",
      0.005
    ],
    [
      "conscience",
      0.005
    ],
    [
      "approfondi",
      0.005
    ],
    [
      "application",
      0.005
    ],
    [
      "imperieux",
      0.0025
    ],
    [
      "pendable",
      0.0025
    ],
    [
      "philosophe",
      0.0025
    ],
    [
      "ponctualite",
      0.0025
    ],
    [
      "scrupule",
      0.0025
    ],
    [
      "sincerite",
      0.0025
    ],
    [
      "solennel",
      0.0025
    ],
    [
      "seriosite",
      0.0025
    ],
    [
      "desespere",
      0.0025
    ],
    [
      "diligence",
      0.0025
    ],
    [
      "adulte",
      0.0025
    ],
    [
      "ardeur",
      0.0025
    ],
    [
      "consequence",
      0.0025
    ],
    [
      "conviction",
      0.0025
    ],
    [
      "corse",
      0.0025
    ],
    [
      "critique",
      0.0025
    ],
    [
      "dignite",
      0.0025
    ],
    [
      "tangible",
      0.0025
    ]
  ],
  "rendu": [
    [
      "donner",
      0.0725
    ],
    [
      "exprimer",
      0.0725
    ],
    [
      "faire",
      0.0725
    ],
    [
      "produire",
      0.0625
    ],
    [
      "remettre",
      0.05
    ],
    [
      "porter",
      0.045
    ],
    [
      "restituer",
      0.0375
    ],
    [
      "rapporter",
      0.0375
    ],
    [
      "reproduire",
      0.0325
    ],
    [
      "representer",
      0.0275
    ],
    [
      "signifier",
      0.02
    ],
    [
      "repeter",
      0.02
    ],
    [
      "refaire",
      0.02
    ],
    [
      "redonner",
      0.02
    ],
    [
      "prononcer",
      0.02
    ],
    [
      "marquer",
      0.02
    ],
    [
      "livrer",
      0.02
    ],
    [
      "enoncer",
      0.015
    ],
    [
      "emettre",
      0.015
    ],
    [
      "traduire",
      0.015
    ],
    [
      "retroceder",
      0.015
    ],
    [
      "renvoyer",
      0.015
    ],
    [
      "rejeter",
      0.015
    ],
    [
      "obtenir",
      0.015
    ],
    [
      "fructifier",
      0.015
    ],
    [
      "fournir",
      0.015
    ],
    [
      "attraper",
      0.015
    ],
    [
      "rembourser",
      0.01
    ],
    [
      "retourner",
      0.01
    ],
    [
      "tenir",
      0.01
    ],
    [
      "travailler",
      0.01
    ],
    [
      "vomir",
      0.01
    ],
    [
      "ramener",
      0.01
    ],
    [
      "poser",
      0.01
    ],
    [
      "payer",
      0.01
    ],
    [
      "observer",
      0.01
    ],
    [
      "lacher",
      0.01
    ],
    [
      "formuler",
      0.01
    ],
    [
      "exhaler",
      0.01
    ],
    [
      "repondre",
      0.0025
    ],
    [
      "repercuter",
      0.0025
    ],
    [
      "revetir",
      0.0025
    ],
    [
      "degueuler",
      0.0025
    ],
    [
      "devenir",
      0.0025
    ],
    [
      "compenser",
      0.0025
    ],
    [
      "reverberer",
      0.0025
    ]
  ],
  "orgueilleux": [
    [
      "superbe",
      0.11
    ],
    [
      "vaniteux",
      0.1025
    ],
    [
      "fat",
      0.09
    ],
    [
      "suffisant",
      0.085
    ],
    [
      "fier",
      0.075
    ],
    [
      "pretentieux",
      0.0675
    ],
    [
      "arrogant",
      0.055
    ],
    [
      "important",
      0.0425
    ],
    [
      "outrecuidant",
      0.0325
    ],
    [
      "hautain",
      0.025
    ],
    [
      "craneur",
      0.02
    ],
    [
      "infatue",
      0.02
    ],
    [
      "presomptueux",
      0.0175
    ],
    [
      "poseur",
      0.0175
    ],
    [
      "dedaigneux",
      0.0175
    ],
    [
      "avantageux",
      0.0175
    ],
    [
      "becheur",
      0.015
    ],
    [
      "sot",
      0.015
    ],
    [
      "vain",
      0.0125
    ],
    [
      "insolent",
      0.01
    ],
    [
      "glorieux",
      0.01
    ],
    [
      "faraud",
      0.01
    ],
    [
      "rogue",
      0.0075
    ],
    [
      "rencheri",
      0.0075
    ],
    [
      "meprisant",
      0.0075
    ],
    [
      "imposant",
      0.0075
    ],
    [
      "haut",
      0.0075
    ],
    [
      "sourcilleux",
      0.005
    ],
    [
      "puant",
      0.005
    ],
    [
      "plastronneur",
      0.005
    ],
    [
      "majestueux",
      0.005
    ],
    [
      "content",
      0.005
    ],
    [
      "penetre",
      0.0
    ],
    [
      "paon",
      0.0
    ],
    [
      "ostentatoire",
      0.0
    ],
    [
      "megalomane",
      0.0
    ],
    [
      "grandiose",
      0.0
    ],
    [
      "gobeur",
      0.0
    ],
    [
      "flambard",
      0.0
    ],
    [
      "entier",
      0.0
    ],
    [
      "altier",
      0.0
    ]
  ],
  "manque": [
    [
      "faillir",
      0.0725
    ],
    [
      "disparaitre",
      0.0425
    ],
    [
      "pecher",
      0.0425
    ],
    [
      "tomber",
      0.0425
    ],
    [
      "perdre",
      0.035
    ],
    [
      "rater",
      0.035
    ],
    [
      "echouer",
      0.03
    ],
    [
      "violer",
      0.03
    ],
    [
      "enfreindre",
      0.03
    ],
    [
      "deroger",
      0.03
    ],
    [
      "s'eloigner",
      0.02
    ],
    [
      "rompre",
      0.02
    ],
    [
      "oublier",
      0.02
    ],
    [
      "negliger",
      0.02
    ],
    [
      "gacher",
      0.02
    ],
    [
      "fausser",
      0.02
    ],
    [
      "faiblir",
      0.02
    ],
    [
      "s'ecarter",
      0.0125
    ],
    [
      "s'eclipser",
      0.0125
    ],
    [
      "secher",
      0.0125
    ],
    [
      "torcher",
      0.0125
    ],
    [
      "trahir",
      0.0125
    ],
    [
      "s'absenter",
      0.0125
    ],
    [
      "louper",
      0.0125
    ],
    [
      "abimer",
      0.0125
    ],
    [
      "avorter",
      0.0125
    ],
    [
      "contrevenir",
      0.0125
    ],
    [
      "dechoir",
      0.0125
    ],
    [
      "defaillir",
      0.0125
    ],
    [
      "flechir",
      0.0125
    ],
    [
      "laisser",
      0.0125
    ],
    [
      "transiger",
      0.005
    ],
    [
      "risquer",
      0.005
    ],
    [
      "penser",
      0.005
    ],
    [
      "omettre",
      0.005
    ],
    [
      "broncher",
      0.005
    ],
    [
      "esquinter",
      0.005
    ],
    [
      "fauter",
      0.005
    ],
    [
      "forfaire",
      0.005
    ],
    [
      "glisser",
      0.005
    ],
    [
      "offenser",
      0.005
    ]
  ],
  "manquer": [
    [
      "faillir",
      0.0725
    ],
    [
      "disparaitre",
      0.0425
    ],
    [
      "pecher",
      0.0425
    ],
    [
      "tomber",
      0.0425
    ],
    [
      "perdre",
      0.035
    ],
    [
      "rater",
      0.035
    ],
    [
      "echouer",
      0.03
    ],
    [
      "violer",
      0.03
    ],
    [
      "enfreindre",
      0.03
    ],
    [
      "deroger",
      0.03
    ],
    [
      "s'eloigner",
      0.02
    ],
    [
      "rompre",
      0.02
    ],
    [
      "oublier",
      0.02
    ],
    [
      "negliger",
      0.02
    ],
    [
      "gacher",
      0.02
    ],
    [
      "fausser",
      0.02
    ],
    [
      "faiblir",
      0.02
    ],
    [
      "s'ecarter",
      0.0125
    ],
    [
      "s'eclipser",
      0.0125
    ],
    [
      "secher",
      0.0125
    ],
    [
      "torcher",
      0.0125
    ],
    [
      "trahir",
      0.0125
    ],
    [
      "s'absenter",
      0.0125
    ],
    [
      "louper",
      0.0125
    ],
    [
      "abimer",
      0.0125
    ],
    [
      "avorter",
      0.0125
    ],
    [
      "contrevenir",
      0.0125
    ],
    [
      "dechoir",
      0.0125
    ],
    [
      "defaillir",
      0.0125
    ],
    [
      "flechir",
      0.0125
    ],
    [
      "laisser",
      0.0125
    ],
    [
      "transiger",
      0.005
    ],
    [
      "risquer",
      0.005
    ],
    [
      "penser",
      0.005
    ],
    [
      "omettre",
      0.005
    ],
    [
      "broncher",
      0.005
    ],
    [
      "esquinter",
      0.005
    ],
    [
      "fauter",
      0.005
    ],
    [
      "forfaire",
      0.005
    ],
    [
      "glisser",
      0.005
    ],
    [
      "offenser",
      0.005
    ]
  ],
  "vieillir": [
    [
      "decliner",
      0.11
    ],
    [
      "s'affiner",
      0.055
    ],
    [
      "s'affaiblir",
      0.055
    ],
    [
      "murir",
      0.055
    ],
    [
      "envieillir",
      0.055
    ],
    [
      "desavantager",
      0.055
    ],
    [
      "dechoir",
      0.055
    ],
    [
      "dater",
      0.055
    ],
    [
      "blanchir",
      0.055
    ],
    [
      "avancer",
      0.055
    ],
    [
      "affiner",
      0.055
    ]
  ],
  "voiture": [
    [
      "automobile",
      0.1475
    ],
    [
      "bagnole",
      0.1025
    ],
    [
      "chignole",
      0.0725
    ],
    [
      "train",
      0.0425
    ],
    [
      "tacot",
      0.0425
    ],
    [
      "fourgon",
      0.0425
    ],
    [
      "camion",
      0.0425
    ],
    [
      "equipage",
      0.0275
    ],
    [
      "vehicule",
      0.0275
    ],
    [
      "patache",
      0.0275
    ],
    [
      "guimbarde",
      0.0275
    ],
    [
      "coche",
      0.0275
    ],
    [
      "clou",
      0.0275
    ],
    [
      "berline",
      0.0275
    ],
    [
      "auto",
      0.0275
    ],
    [
      "fiacre",
      0.0125
    ],
    [
      "jardiniere",
      0.0125
    ],
    [
      "landau",
      0.0125
    ],
    [
      "poussette",
      0.0125
    ],
    [
      "tire",
      0.0125
    ],
    [
      "transport",
      0.0125
    ],
    [
      "voituree",
      0.0125
    ],
    [
      "ferraille",
      0.0125
    ],
    [
      "fardier",
      0.0125
    ],
    [
      "attelage",
      0.0125
    ],
    [
      "baladeuse",
      0.0125
    ],
    [
      "berlingot",
      0.0125
    ],
    [
      "brouette",
      0.0125
    ],
    [
      "car",
      0.0125
    ],
    [
      "charrette",
      0.0125
    ],
    [
      "chiotte",
      0.0125
    ],
    [
      "coucou",
      0.0125
    ],
    [
      "wagon",
      0.0125
    ]
  ],
  "voiturer": [
    [
      "transporter",
      0.4275
    ],
    [
      "carrosser",
      0.1425
    ],
    [
      "charrier",
      0.1425
    ],
    [
      "rouler",
      0.1425
    ],
    [
      "vehiculer",
      0.1425
    ]
  ],
  "plastiquer": [],
  "plastique": [
    [
      "anatomie",
      0.11
    ],
    [
      "forme",
      0.11
    ],
    [
      "malleable",
      0.11
    ],
    [
      "mou",
      0.11
    ],
    [
      "nu",
      0.11
    ],
    [
      "sculpture",
      0.055
    ],
    [
      "sculptural",
      0.055
    ],
    [
      "plastoc",
      0.055
    ],
    [
      "modele",
      0.055
    ],
    [
      "modelage",
      0.055
    ],
    [
      "flexible",
      0.055
    ],
    [
      "apathique",
      0.055
    ],
    [
      "statuaire",
      0.055
    ]
  ],
  "true": [],
  "affaire": [
    [
      "evenement",
      0.04
    ],
    [
      "travail",
      0.0325
    ],
    [
      "action",
      0.03
    ],
    [
      "cas",
      0.03
    ],
    [
      "fait",
      0.0275
    ],
    [
      "commerce",
      0.025
    ],
    [
      "difficulte",
      0.025
    ],
    [
      "histoire",
      0.0225
    ],
    [
      "bataille",
      0.0225
    ],
    [
      "aventure",
      0.0225
    ],
    [
      "bazar",
      0.0225
    ],
    [
      "boite",
      0.0225
    ],
    [
      "dispute",
      0.0225
    ],
    [
      "rencontre",
      0.0175
    ],
    [
      "querelle",
      0.0175
    ],
    [
      "entreprise",
      0.0175
    ],
    [
      "combat",
      0.0175
    ],
    [
      "accident",
      0.0175
    ],
    [
      "circonstance",
      0.0175
    ],
    [
      "cause",
      0.015
    ],
    [
      "etablissement",
      0.0125
    ],
    [
      "tache",
      0.0125
    ],
    [
      "transaction",
      0.0125
    ],
    [
      "occupation",
      0.0125
    ],
    [
      "ennui",
      0.0125
    ],
    [
      "engagement",
      0.0125
    ],
    [
      "choc",
      0.0125
    ],
    [
      "truc",
      0.01
    ],
    [
      "situation",
      0.01
    ],
    [
      "operation",
      0.01
    ],
    [
      "marche",
      0.01
    ],
    [
      "intrigue",
      0.01
    ],
    [
      "guerre",
      0.01
    ],
    [
      "discussion",
      0.01
    ],
    [
      "complication",
      0.01
    ],
    [
      "boutique",
      0.01
    ],
    [
      "besogne",
      0.01
    ],
    [
      "attaque",
      0.01
    ],
    [
      "occasion",
      0.0075
    ],
    [
      "magasin",
      0.0075
    ],
    [
      "industrie",
      0.0075
    ],
    [
      "embarras",
      0.0075
    ],
    [
      "chantier",
      0.0075
    ],
    [
      "bourse",
      0.0075
    ],
    [
      "accrochage",
      0.0075
    ],
    [
      "oeuvre",
      0.005
    ],
    [
      "politique",
      0.005
    ],
    [
      "probleme",
      0.005
    ],
    [
      "proces",
      0.005
    ],
    [
      "question",
      0.005
    ],
    [
      "scandale",
      0.005
    ],
    [
      "societe",
      0.005
    ],
    [
      "souci",
      0.005
    ],
    [
      "usine",
      0.005
    ],
    [
      "episode",
      0.005
    ],
    [
      "negoce",
      0.005
    ],
    [
      "machin",
      0.005
    ],
    [
      "litige",
      0.005
    ],
    [
      "activite",
      0.005
    ],
    [
      "agence",
      0.005
    ],
    [
      "atelier",
      0.005
    ],
    [
      "bidule",
      0.005
    ],
    [
      "bordel",
      0.005
    ],
    [
      "business",
      0.005
    ],
    [
      "chose",
      0.005
    ],
    [
      "convention",
      0.005
    ],
    [
      "devoir",
      0.005
    ],
    [
      "demele",
      0.005
    ],
    [
      "obligation",
      0.0025
    ],
    [
      "preoccupation",
      0.0025
    ],
    [
      "role",
      0.0025
    ],
    [
      "speculation",
      0.0025
    ],
    [
      "economie",
      0.0025
    ],
    [
      "mesaventure",
      0.0025
    ],
    [
      "galanterie",
      0.0025
    ],
    [
      "finance",
      0.0025
    ],
    [
      "duel",
      0.0025
    ],
    [
      "differend",
      0.0025
    ],
    [
      "conjoncture",
      0.0025
    ],
    [
      "bureau",
      0.0025
    ],
    [
      "baroud",
      0.0025
    ],
    [
      "dossier",
      0.0
    ],
    [
      "espece",
      0.0
    ],
    [
      "firme",
      0.0
    ],
    [
      "holding",
      0.0
    ],
    [
      "trust",
      0.0
    ],
    [
      "vente",
      0.0
    ],
    [
      "danger",
      0.0
    ],
    [
      "comedie",
      0.0
    ],
    [
      "compte",
      0.0
    ],
    [
      "cabinet",
      0.0
    ],
    [
      "but",
      0.0
    ],
    [
      "besoin",
      0.0
    ],
    [
      "bataclan",
      0.0
    ],
    [
      "barda",
      0.0
    ],
    [
      "accusation",
      0.0
    ],
    [
      "echange",
      0.0
    ]
  ],
  "affairer": [],
  "jouet": [
    [
      "babiole",
      0.13
    ],
    [
      "bagatelle",
      0.13
    ],
    [
      "pantin",
      0.13
    ],
    [
      "victime",
      0.085
    ],
    [
      "proie",
      0.085
    ],
    [
      "joujou",
      0.085
    ],
    [
      "esclave",
      0.085
    ],
    [
      "automate",
      0.0425
    ],
    [
      "bimbelot",
      0.0425
    ],
    [
      "cible",
      0.0425
    ],
    [
      "hochet",
      0.0425
    ],
    [
      "jeu",
      0.0425
    ]
  ],
  "acharner": [
    [
      "animer",
      0.5
    ],
    [
      "exciter",
      0.5
    ]
  ],
  "recommencer": [
    [
      "refaire",
      0.1175
    ],
    [
      "reprendre",
      0.0875
    ],
    [
      "revenir",
      0.0875
    ],
    [
      "renaitre",
      0.0575
    ],
    [
      "repeter",
      0.0425
    ],
    [
      "recidiver",
      0.0425
    ],
    [
      "reiterer",
      0.0275
    ],
    [
      "repartir",
      0.0275
    ],
    [
      "renouveler",
      0.0275
    ],
    [
      "redoubler",
      0.0275
    ],
    [
      "rebondir",
      0.0275
    ],
    [
      "retomber",
      0.0125
    ],
    [
      "repiquer",
      0.0125
    ],
    [
      "bisser",
      0.0125
    ],
    [
      "doubler",
      0.0125
    ],
    [
      "rebiffer",
      0.0125
    ],
    [
      "refleurir",
      0.0125
    ],
    [
      "remettre",
      0.0125
    ],
    [
      "rentamer",
      0.0125
    ],
    [
      "reparaitre",
      0.0125
    ]
  ],
  "deambuler": [
    [
      "marcher",
      0.15
    ],
    [
      "aller",
      0.13
    ],
    [
      "errer",
      0.1125
    ],
    [
      "vagabonder",
      0.055
    ],
    [
      "roder",
      0.055
    ],
    [
      "flaner",
      0.055
    ],
    [
      "passer",
      0.0375
    ],
    [
      "vaguer",
      0.0375
    ],
    [
      "evoluer",
      0.0375
    ],
    [
      "ambuler",
      0.0175
    ],
    [
      "vadrouiller",
      0.0175
    ]
  ],
  "metro": [
    [
      "rame",
      0.5
    ]
  ],
  "immense": [
    [
      "grand",
      0.12
    ],
    [
      "enorme",
      0.12
    ],
    [
      "demesure",
      0.065
    ],
    [
      "gigantesque",
      0.0625
    ],
    [
      "colossal",
      0.055
    ],
    [
      "extraordinaire",
      0.05
    ],
    [
      "formidable",
      0.0475
    ],
    [
      "infini",
      0.0375
    ],
    [
      "gros",
      0.0375
    ],
    [
      "considerable",
      0.0375
    ],
    [
      "titanesque",
      0.03
    ],
    [
      "imposant",
      0.0275
    ],
    [
      "incommensurable",
      0.0275
    ],
    [
      "vaste",
      0.0225
    ],
    [
      "prodigieux",
      0.0225
    ],
    [
      "monumental",
      0.0225
    ],
    [
      "extreme",
      0.0175
    ],
    [
      "illimite",
      0.0175
    ],
    [
      "interminable",
      0.0175
    ],
    [
      "incalculable",
      0.015
    ],
    [
      "fou",
      0.01
    ],
    [
      "profond",
      0.01
    ],
    [
      "violent",
      0.01
    ],
    [
      "etendu",
      0.0075
    ],
    [
      "long",
      0.0075
    ],
    [
      "effrayant",
      0.0075
    ],
    [
      "ample",
      0.0075
    ],
    [
      "spacieux",
      0.005
    ],
    [
      "insense",
      0.005
    ],
    [
      "indefini",
      0.005
    ],
    [
      "geant",
      0.005
    ],
    [
      "cyclopeen",
      0.005
    ],
    [
      "grandiose",
      0.0025
    ],
    [
      "grandissime",
      0.0025
    ],
    [
      "immensurable",
      0.0025
    ],
    [
      "mammouth",
      0.0025
    ],
    [
      "elephantesque",
      0.0025
    ]
  ],
  "remue": [
    [
      "transhumance",
      1.0
    ]
  ],
  "remuer": [
    [
      "agiter",
      0.065
    ],
    [
      "bouleverser",
      0.0425
    ],
    [
      "emouvoir",
      0.04
    ],
    [
      "troubler",
      0.0375
    ],
    [
      "battre",
      0.035
    ],
    [
      "balancer",
      0.0325
    ],
    [
      "osciller",
      0.0275
    ],
    [
      "secouer",
      0.0275
    ],
    [
      "ebranler",
      0.0275
    ],
    [
      "toucher",
      0.025
    ],
    [
      "s'agiter",
      0.025
    ],
    [
      "rouler",
      0.025
    ],
    [
      "travailler",
      0.02
    ],
    [
      "mouvoir",
      0.0175
    ],
    [
      "bouger",
      0.015
    ],
    [
      "touiller",
      0.015
    ],
    [
      "tourner",
      0.015
    ],
    [
      "onduler",
      0.015
    ],
    [
      "impressionner",
      0.015
    ],
    [
      "vaciller",
      0.0125
    ],
    [
      "flotter",
      0.0125
    ],
    [
      "dodeliner",
      0.0125
    ],
    [
      "branler",
      0.0125
    ],
    [
      "jouer",
      0.01
    ],
    [
      "retourner",
      0.01
    ],
    [
      "trembler",
      0.0075
    ],
    [
      "tanguer",
      0.0075
    ],
    [
      "exciter",
      0.0075
    ],
    [
      "brandiller",
      0.0075
    ],
    [
      "ballotter",
      0.0075
    ],
    [
      "pousser",
      0.0075
    ],
    [
      "perturber",
      0.0075
    ],
    [
      "gigoter",
      0.0075
    ],
    [
      "frapper",
      0.0075
    ],
    [
      "fouiller",
      0.0075
    ],
    [
      "fonctionner",
      0.0075
    ],
    [
      "deranger",
      0.0075
    ],
    [
      "deplacer",
      0.0075
    ],
    [
      "broncher",
      0.0075
    ],
    [
      "tracasser",
      0.005
    ],
    [
      "tortiller",
      0.005
    ],
    [
      "manipuler",
      0.005
    ],
    [
      "changer",
      0.005
    ],
    [
      "chanceler",
      0.005
    ],
    [
      "brouiller",
      0.005
    ],
    [
      "bouler",
      0.005
    ],
    [
      "atteindre",
      0.005
    ],
    [
      "labourer",
      0.0025
    ],
    [
      "lancer",
      0.0025
    ],
    [
      "petrir",
      0.0025
    ],
    [
      "emotionner",
      0.0025
    ],
    [
      "fretiller",
      0.0025
    ],
    [
      "frissonner",
      0.0025
    ],
    [
      "bercer",
      0.0025
    ],
    [
      "brasser",
      0.0025
    ],
    [
      "ciller",
      0.0025
    ],
    [
      "cligner",
      0.0025
    ],
    [
      "fatiguer",
      0.0025
    ],
    [
      "soulever",
      0.0025
    ],
    [
      "sourciller",
      0.0025
    ],
    [
      "sursauter",
      0.0025
    ],
    [
      "tirer",
      0.0025
    ],
    [
      "trepider",
      0.0025
    ],
    [
      "penetrer",
      0.0025
    ],
    [
      "alarmer",
      0.0025
    ],
    [
      "attendrir",
      0.0025
    ],
    [
      "empoigner",
      0.0025
    ],
    [
      "gambiller",
      0.0025
    ],
    [
      "gesticuler",
      0.0025
    ],
    [
      "gratter",
      0.0025
    ],
    [
      "grouiller",
      0.0025
    ],
    [
      "ondoyer",
      0.0025
    ],
    [
      "s'insurger",
      0.0
    ],
    [
      "s'evertuer",
      0.0
    ],
    [
      "sauter",
      0.0
    ],
    [
      "mouver",
      0.0
    ],
    [
      "moutonner",
      0.0
    ],
    [
      "apitoyer",
      0.0
    ],
    [
      "brandir",
      0.0
    ],
    [
      "chiffonner",
      0.0
    ],
    [
      "effondrer",
      0.0
    ],
    [
      "fouir",
      0.0
    ],
    [
      "fourmiller",
      0.0
    ],
    [
      "hocher",
      0.0
    ],
    [
      "malaxer",
      0.0
    ]
  ],
  "pluie": [
    [
      "flot",
      0.1
    ],
    [
      "deluge",
      0.09
    ],
    [
      "avalanche",
      0.08
    ],
    [
      "multitude",
      0.07
    ],
    [
      "averse",
      0.06
    ],
    [
      "affluence",
      0.05
    ],
    [
      "quantite",
      0.05
    ],
    [
      "grain",
      0.04
    ],
    [
      "debordement",
      0.04
    ],
    [
      "brouillard",
      0.04
    ],
    [
      "abondance",
      0.03
    ],
    [
      "grele",
      0.03
    ],
    [
      "orage",
      0.03
    ],
    [
      "saucee",
      0.02
    ],
    [
      "giboulee",
      0.02
    ],
    [
      "eau",
      0.02
    ],
    [
      "cataracte",
      0.02
    ],
    [
      "lavasse",
      0.0075
    ],
    [
      "maree",
      0.0075
    ],
    [
      "nielle",
      0.0075
    ],
    [
      "nuee",
      0.0075
    ],
    [
      "ondee",
      0.0075
    ],
    [
      "pleiade",
      0.0075
    ],
    [
      "profusion",
      0.0075
    ],
    [
      "precipitations",
      0.0075
    ],
    [
      "rincee",
      0.0075
    ],
    [
      "intemperie",
      0.0075
    ],
    [
      "hydrometeore",
      0.0075
    ],
    [
      "abat",
      0.0075
    ],
    [
      "abattee",
      0.0075
    ],
    [
      "arrosement",
      0.0075
    ],
    [
      "brouillasse",
      0.0075
    ],
    [
      "bruine",
      0.0075
    ],
    [
      "chute",
      0.0075
    ],
    [
      "crachin",
      0.0075
    ],
    [
      "flotte",
      0.0075
    ],
    [
      "goutte",
      0.0075
    ],
    [
      "sauce",
      0.0075
    ]
  ],
  "brin": [
    [
      "grain",
      0.1275
    ],
    [
      "miette",
      0.09
    ],
    [
      "peu",
      0.09
    ],
    [
      "parcelle",
      0.0725
    ],
    [
      "morceau",
      0.0725
    ],
    [
      "goutte",
      0.0725
    ],
    [
      "atome",
      0.0725
    ],
    [
      "branche",
      0.0525
    ],
    [
      "pointe",
      0.0525
    ],
    [
      "nuance",
      0.035
    ],
    [
      "fetu",
      0.035
    ],
    [
      "brindille",
      0.035
    ],
    [
      "bout",
      0.035
    ],
    [
      "teinte",
      0.0175
    ],
    [
      "pousse",
      0.0175
    ],
    [
      "liard",
      0.0175
    ],
    [
      "filament",
      0.0175
    ],
    [
      "fil",
      0.0175
    ],
    [
      "doigt",
      0.0175
    ],
    [
      "brisure",
      0.0175
    ],
    [
      "tige",
      0.0175
    ]
  ],
  "bruit": [
    [
      "murmurer",
      0.11
    ],
    [
      "bourdonner",
      0.08
    ],
    [
      "crier",
      0.08
    ],
    [
      "ronfler",
      0.08
    ],
    [
      "resonner",
      0.0525
    ],
    [
      "retentir",
      0.0525
    ],
    [
      "gemir",
      0.0525
    ],
    [
      "fremir",
      0.0525
    ],
    [
      "froufrouter",
      0.0525
    ],
    [
      "chuchoter",
      0.0525
    ],
    [
      "susurrer",
      0.025
    ],
    [
      "siffler",
      0.025
    ],
    [
      "imbiber",
      0.025
    ],
    [
      "humecter",
      0.025
    ],
    [
      "grincer",
      0.025
    ],
    [
      "gazouiller",
      0.025
    ],
    [
      "frissonner",
      0.025
    ],
    [
      "fredonner",
      0.025
    ],
    [
      "chuinter",
      0.025
    ],
    [
      "bruisser",
      0.025
    ],
    [
      "vrombir",
      0.025
    ]
  ],
  "bruire": [
    [
      "murmurer",
      0.11
    ],
    [
      "bourdonner",
      0.08
    ],
    [
      "crier",
      0.08
    ],
    [
      "ronfler",
      0.08
    ],
    [
      "resonner",
      0.0525
    ],
    [
      "retentir",
      0.0525
    ],
    [
      "gemir",
      0.0525
    ],
    [
      "fremir",
      0.0525
    ],
    [
      "froufrouter",
      0.0525
    ],
    [
      "chuchoter",
      0.0525
    ],
    [
      "susurrer",
      0.025
    ],
    [
      "siffler",
      0.025
    ],
    [
      "imbiber",
      0.025
    ],
    [
      "humecter",
      0.025
    ],
    [
      "grincer",
      0.025
    ],
    [
      "gazouiller",
      0.025
    ],
    [
      "frissonner",
      0.025
    ],
    [
      "fredonner",
      0.025
    ],
    [
      "chuinter",
      0.025
    ],
    [
      "bruisser",
      0.025
    ],
    [
      "vrombir",
      0.025
    ]
  ],
  "cours": [
    [
      "assemblee",
      0.12
    ],
    [
      "conseil",
      0.08
    ],
    [
      "tribunal",
      0.08
    ],
    [
      "galanterie",
      0.04
    ],
    [
      "gouvernement",
      0.04
    ],
    [
      "parlement",
      0.04
    ],
    [
      "patio",
      0.04
    ],
    [
      "preau",
      0.04
    ],
    [
      "pretoire",
      0.04
    ],
    [
      "flatterie",
      0.04
    ],
    [
      "cortege",
      0.04
    ],
    [
      "cloitre",
      0.04
    ],
    [
      "cercle",
      0.04
    ],
    [
      "cassation",
      0.04
    ],
    [
      "aula",
      0.04
    ],
    [
      "atrium",
      0.04
    ],
    [
      "assiduite",
      0.04
    ],
    [
      "adulation",
      0.04
    ],
    [
      "suite",
      0.04
    ]
  ],
  "douleur": [
    [
      "affliction",
      0.1325
    ],
    [
      "chagrin",
      0.095
    ],
    [
      "peine",
      0.0925
    ],
    [
      "souffrance",
      0.055
    ],
    [
      "mal",
      0.0475
    ],
    [
      "tourment",
      0.045
    ],
    [
      "tristesse",
      0.0425
    ],
    [
      "desolation",
      0.035
    ],
    [
      "ennui",
      0.035
    ],
    [
      "malheur",
      0.0325
    ],
    [
      "epreuve",
      0.0275
    ],
    [
      "supplice",
      0.0275
    ],
    [
      "desespoir",
      0.0275
    ],
    [
      "angoisse",
      0.0275
    ],
    [
      "deuil",
      0.0225
    ],
    [
      "tribulation",
      0.0225
    ],
    [
      "dechirement",
      0.0175
    ],
    [
      "detresse",
      0.015
    ],
    [
      "torture",
      0.0125
    ],
    [
      "boulet",
      0.0125
    ],
    [
      "blessure",
      0.0125
    ],
    [
      "amertume",
      0.01
    ],
    [
      "deplaisir",
      0.01
    ],
    [
      "plaie",
      0.0075
    ],
    [
      "misere",
      0.0075
    ],
    [
      "larme",
      0.0075
    ],
    [
      "gehenne",
      0.0075
    ],
    [
      "calvaire",
      0.0075
    ],
    [
      "emotion",
      0.005
    ],
    [
      "navrement",
      0.005
    ],
    [
      "martyre",
      0.005
    ],
    [
      "enfer",
      0.005
    ],
    [
      "brulure",
      0.005
    ],
    [
      "bobo",
      0.005
    ],
    [
      "affres",
      0.005
    ],
    [
      "elancement",
      0.0
    ],
    [
      "rhumatisme",
      0.0
    ],
    [
      "repentir",
      0.0
    ],
    [
      "point",
      0.0
    ],
    [
      "gemissement",
      0.0
    ],
    [
      "endolorissement",
      0.0
    ],
    [
      "contrition",
      0.0
    ],
    [
      "contraction",
      0.0
    ],
    [
      "consternation",
      0.0
    ],
    [
      "componction",
      0.0
    ],
    [
      "brisement",
      0.0
    ],
    [
      "epine",
      0.0
    ]
  ],
  "esperance": [
    [
      "attente",
      0.125
    ],
    [
      "espoir",
      0.0825
    ],
    [
      "foi",
      0.0825
    ],
    [
      "conviction",
      0.0675
    ],
    [
      "soif",
      0.055
    ],
    [
      "prevision",
      0.055
    ],
    [
      "desir",
      0.055
    ],
    [
      "croyance",
      0.055
    ],
    [
      "assurance",
      0.055
    ],
    [
      "perspective",
      0.04
    ],
    [
      "expectative",
      0.04
    ],
    [
      "certitude",
      0.04
    ],
    [
      "reve",
      0.0275
    ],
    [
      "pressentiment",
      0.0275
    ],
    [
      "futur",
      0.0275
    ],
    [
      "expectance",
      0.0275
    ],
    [
      "confiance",
      0.0275
    ],
    [
      "aspiration",
      0.0275
    ],
    [
      "confession",
      0.0125
    ],
    [
      "illusion",
      0.0125
    ],
    [
      "promesse",
      0.0125
    ],
    [
      "pretention",
      0.0125
    ],
    [
      "vertu",
      0.0125
    ]
  ],
  "absence": [
    [
      "manque",
      0.1125
    ],
    [
      "defaut",
      0.0675
    ],
    [
      "omission",
      0.0675
    ],
    [
      "vide",
      0.0675
    ],
    [
      "faute",
      0.055
    ],
    [
      "oubli",
      0.055
    ],
    [
      "eloignement",
      0.055
    ],
    [
      "trou",
      0.045
    ],
    [
      "privation",
      0.045
    ],
    [
      "disparition",
      0.045
    ],
    [
      "carence",
      0.0325
    ],
    [
      "distraction",
      0.0325
    ],
    [
      "eclipse",
      0.02
    ],
    [
      "separation",
      0.02
    ],
    [
      "inattention",
      0.02
    ],
    [
      "fugue",
      0.02
    ],
    [
      "depart",
      0.02
    ],
    [
      "defaillance",
      0.02
    ],
    [
      "distance",
      0.02
    ],
    [
      "bevue",
      0.02
    ],
    [
      "echappee",
      0.01
    ],
    [
      "rien",
      0.01
    ],
    [
      "escapade",
      0.01
    ],
    [
      "defection",
      0.01
    ],
    [
      "disette",
      0.01
    ],
    [
      "apathie",
      0.01
    ],
    [
      "amnesie",
      0.01
    ],
    [
      "abstraction",
      0.01
    ],
    [
      "absenteisme",
      0.01
    ],
    [
      "egarement",
      0.01
    ]
  ],
  "trimer": [
    [
      "peiner",
      0.165
    ],
    [
      "travailler",
      0.165
    ],
    [
      "marcher",
      0.11
    ],
    [
      "suer",
      0.11
    ],
    [
      "trimarder",
      0.055
    ],
    [
      "fatiguer",
      0.055
    ],
    [
      "cheminer",
      0.055
    ],
    [
      "bosser",
      0.055
    ],
    [
      "besogner",
      0.055
    ],
    [
      "turbiner",
      0.055
    ]
  ],
  "decor": [
    [
      "decoration",
      0.14
    ],
    [
      "appareil",
      0.11
    ],
    [
      "scene",
      0.0825
    ],
    [
      "peinture",
      0.055
    ],
    [
      "ornement",
      0.055
    ],
    [
      "milieu",
      0.055
    ],
    [
      "cadre",
      0.055
    ],
    [
      "apparat",
      0.055
    ],
    [
      "theatre",
      0.025
    ],
    [
      "spectacle",
      0.025
    ],
    [
      "scenographie",
      0.025
    ],
    [
      "praticable",
      0.025
    ],
    [
      "paysage",
      0.025
    ],
    [
      "ornementation",
      0.025
    ],
    [
      "guirlande",
      0.025
    ],
    [
      "atmosphere",
      0.025
    ],
    [
      "apparence",
      0.025
    ],
    [
      "ambiance",
      0.025
    ],
    [
      "agencement",
      0.025
    ]
  ],
  "offenser": [
    [
      "blesser",
      0.1675
    ],
    [
      "choquer",
      0.1
    ],
    [
      "froisser",
      0.065
    ],
    [
      "heurter",
      0.0575
    ],
    [
      "piquer",
      0.05
    ],
    [
      "vexer",
      0.05
    ],
    [
      "outrager",
      0.04
    ],
    [
      "offusquer",
      0.04
    ],
    [
      "atteindre",
      0.0325
    ],
    [
      "deplaire",
      0.0325
    ],
    [
      "insulter",
      0.0325
    ],
    [
      "troubler",
      0.0225
    ],
    [
      "toucher",
      0.0225
    ],
    [
      "mortifier",
      0.0225
    ],
    [
      "humilier",
      0.0225
    ],
    [
      "entamer",
      0.0225
    ],
    [
      "dechirer",
      0.0225
    ],
    [
      "ecorcher",
      0.015
    ],
    [
      "souffleter",
      0.015
    ],
    [
      "scandaliser",
      0.015
    ],
    [
      "desobliger",
      0.015
    ],
    [
      "chiffonner",
      0.015
    ],
    [
      "braver",
      0.015
    ],
    [
      "pecher",
      0.0075
    ],
    [
      "outrer",
      0.0075
    ],
    [
      "narguer",
      0.0075
    ],
    [
      "mecontenter",
      0.0075
    ],
    [
      "manquer",
      0.0075
    ],
    [
      "injurier",
      0.0075
    ],
    [
      "alarmer",
      0.0075
    ]
  ],
  "offense": [
    [
      "injure",
      0.125
    ],
    [
      "affront",
      0.1125
    ],
    [
      "avanie",
      0.0925
    ],
    [
      "outrage",
      0.0925
    ],
    [
      "insulte",
      0.0825
    ],
    [
      "vexation",
      0.05
    ],
    [
      "tort",
      0.05
    ],
    [
      "atteinte",
      0.05
    ],
    [
      "camouflet",
      0.03
    ],
    [
      "faute",
      0.03
    ],
    [
      "indignite",
      0.03
    ],
    [
      "mortification",
      0.03
    ],
    [
      "insolence",
      0.02
    ],
    [
      "froissement",
      0.02
    ],
    [
      "coup",
      0.02
    ],
    [
      "couleuvre",
      0.02
    ],
    [
      "blessure",
      0.02
    ],
    [
      "attentat",
      0.02
    ],
    [
      "infamie",
      0.01
    ],
    [
      "incartade",
      0.01
    ],
    [
      "impertinence",
      0.01
    ],
    [
      "dementi",
      0.01
    ],
    [
      "brimade",
      0.01
    ],
    [
      "blaspheme",
      0.01
    ],
    [
      "algarade",
      0.01
    ],
    [
      "peche",
      0.01
    ]
  ],
  "ramasser": [
    [
      "prendre",
      0.1
    ],
    [
      "gagner",
      0.08
    ],
    [
      "recueillir",
      0.0625
    ],
    [
      "attraper",
      0.045
    ],
    [
      "recolter",
      0.045
    ],
    [
      "cueillir",
      0.04
    ],
    [
      "encaisser",
      0.035
    ],
    [
      "reunir",
      0.035
    ],
    [
      "toucher",
      0.035
    ],
    [
      "saisir",
      0.03
    ],
    [
      "rassembler",
      0.03
    ],
    [
      "piquer",
      0.03
    ],
    [
      "amasser",
      0.03
    ],
    [
      "assembler",
      0.025
    ],
    [
      "faire",
      0.025
    ],
    [
      "percevoir",
      0.0175
    ],
    [
      "moissonner",
      0.0175
    ],
    [
      "enlever",
      0.0175
    ],
    [
      "capter",
      0.0175
    ],
    [
      "accumuler",
      0.0175
    ],
    [
      "reduire",
      0.0125
    ],
    [
      "resserrer",
      0.0125
    ],
    [
      "rallier",
      0.0125
    ],
    [
      "empocher",
      0.0125
    ],
    [
      "emballer",
      0.0125
    ],
    [
      "contracter",
      0.0125
    ],
    [
      "capturer",
      0.0125
    ],
    [
      "arreter",
      0.0125
    ],
    [
      "resumer",
      0.0075
    ],
    [
      "rafler",
      0.0075
    ],
    [
      "pincer",
      0.0075
    ],
    [
      "grappiller",
      0.0075
    ],
    [
      "entasser",
      0.0075
    ],
    [
      "collectionner",
      0.0075
    ],
    [
      "collecter",
      0.0075
    ],
    [
      "plier",
      0.0025
    ],
    [
      "preciser",
      0.0025
    ],
    [
      "recroqueviller",
      0.0025
    ],
    [
      "regrouper",
      0.0025
    ],
    [
      "relever",
      0.0025
    ],
    [
      "pelotonner",
      0.0025
    ],
    [
      "palper",
      0.0025
    ],
    [
      "glaner",
      0.0025
    ],
    [
      "garer",
      0.0025
    ],
    [
      "condenser",
      0.0025
    ],
    [
      "amonceler",
      0.0025
    ],
    [
      "adopter",
      0.0025
    ],
    [
      "abriter",
      0.0025
    ],
    [
      "rateler",
      0.0025
    ]
  ],
  "ramasse": [
    [
      "prendre",
      0.1
    ],
    [
      "gagner",
      0.08
    ],
    [
      "recueillir",
      0.0625
    ],
    [
      "attraper",
      0.045
    ],
    [
      "recolter",
      0.045
    ],
    [
      "cueillir",
      0.04
    ],
    [
      "encaisser",
      0.035
    ],
    [
      "reunir",
      0.035
    ],
    [
      "toucher",
      0.035
    ],
    [
      "saisir",
      0.03
    ],
    [
      "rassembler",
      0.03
    ],
    [
      "piquer",
      0.03
    ],
    [
      "amasser",
      0.03
    ],
    [
      "assembler",
      0.025
    ],
    [
      "faire",
      0.025
    ],
    [
      "percevoir",
      0.0175
    ],
    [
      "moissonner",
      0.0175
    ],
    [
      "enlever",
      0.0175
    ],
    [
      "capter",
      0.0175
    ],
    [
      "accumuler",
      0.0175
    ],
    [
      "reduire",
      0.0125
    ],
    [
      "resserrer",
      0.0125
    ],
    [
      "rallier",
      0.0125
    ],
    [
      "empocher",
      0.0125
    ],
    [
      "emballer",
      0.0125
    ],
    [
      "contracter",
      0.0125
    ],
    [
      "capturer",
      0.0125
    ],
    [
      "arreter",
      0.0125
    ],
    [
      "resumer",
      0.0075
    ],
    [
      "rafler",
      0.0075
    ],
    [
      "pincer",
      0.0075
    ],
    [
      "grappiller",
      0.0075
    ],
    [
      "entasser",
      0.0075
    ],
    [
      "collectionner",
      0.0075
    ],
    [
      "collecter",
      0.0075
    ],
    [
      "plier",
      0.0025
    ],
    [
      "preciser",
      0.0025
    ],
    [
      "recroqueviller",
      0.0025
    ],
    [
      "regrouper",
      0.0025
    ],
    [
      "relever",
      0.0025
    ],
    [
      "pelotonner",
      0.0025
    ],
    [
      "palper",
      0.0025
    ],
    [
      "glaner",
      0.0025
    ],
    [
      "garer",
      0.0025
    ],
    [
      "condenser",
      0.0025
    ],
    [
      "amonceler",
      0.0025
    ],
    [
      "adopter",
      0.0025
    ],
    [
      "abriter",
      0.0025
    ],
    [
      "rateler",
      0.0025
    ]
  ],
  "pleur": [
    [
      "cri",
      0.21
    ],
    [
      "gemissement",
      0.1575
    ],
    [
      "plainte",
      0.1575
    ],
    [
      "larme",
      0.105
    ],
    [
      "sanglot",
      0.105
    ],
    [
      "seve",
      0.05
    ],
    [
      "lamentation",
      0.05
    ],
    [
      "hurlement",
      0.05
    ],
    [
      "attendrissement",
      0.05
    ],
    [
      "vagissement",
      0.05
    ]
  ],
  "fosse": [
    [
      "cavite",
      0.15
    ],
    [
      "tranchee",
      0.1275
    ],
    [
      "fosse",
      0.085
    ],
    [
      "abime",
      0.0625
    ],
    [
      "excavation",
      0.0625
    ],
    [
      "gouffre",
      0.0625
    ],
    [
      "renfoncement",
      0.0625
    ],
    [
      "trou",
      0.0425
    ],
    [
      "depression",
      0.0425
    ],
    [
      "tombe",
      0.02
    ],
    [
      "silo",
      0.02
    ],
    [
      "rigole",
      0.02
    ],
    [
      "puisard",
      0.02
    ],
    [
      "oubliette",
      0.02
    ],
    [
      "mine",
      0.02
    ],
    [
      "geosynclinal",
      0.02
    ],
    [
      "fouille",
      0.02
    ],
    [
      "douve",
      0.02
    ],
    [
      "cachot",
      0.02
    ],
    [
      "boyau",
      0.02
    ],
    [
      "abysse",
      0.02
    ],
    [
      "trappe",
      0.02
    ]
  ],
  "emmener": [
    [
      "conduire",
      0.1175
    ],
    [
      "mener",
      0.1175
    ],
    [
      "transporter",
      0.1175
    ],
    [
      "emporter",
      0.095
    ],
    [
      "enlever",
      0.095
    ],
    [
      "entrainer",
      0.095
    ],
    [
      "trainer",
      0.07
    ],
    [
      "remmener",
      0.0475
    ],
    [
      "ravir",
      0.0475
    ],
    [
      "prendre",
      0.0475
    ],
    [
      "mettre",
      0.0475
    ],
    [
      "accompagner",
      0.0225
    ],
    [
      "diriger",
      0.0225
    ],
    [
      "promener",
      0.0225
    ],
    [
      "voler",
      0.0225
    ]
  ],
  "frere": [
    [
      "religieux",
      0.1075
    ],
    [
      "semblable",
      0.1075
    ],
    [
      "camarade",
      0.08
    ],
    [
      "moine",
      0.08
    ],
    [
      "parent",
      0.08
    ],
    [
      "egal",
      0.0525
    ],
    [
      "cousin",
      0.0525
    ],
    [
      "compagnon",
      0.0525
    ],
    [
      "ami",
      0.0525
    ],
    [
      "pote",
      0.025
    ],
    [
      "homologue",
      0.025
    ],
    [
      "germain",
      0.025
    ],
    [
      "frerot",
      0.025
    ],
    [
      "frater",
      0.025
    ],
    [
      "frangin",
      0.025
    ],
    [
      "dominicain",
      0.025
    ],
    [
      "copain",
      0.025
    ],
    [
      "convers",
      0.025
    ],
    [
      "congreganiste",
      0.025
    ],
    [
      "confrere",
      0.025
    ],
    [
      "prochain",
      0.025
    ]
  ],
  "malade": [
    [
      "souffrant",
      0.07
    ],
    [
      "fou",
      0.065
    ],
    [
      "maladif",
      0.0575
    ],
    [
      "pique",
      0.0475
    ],
    [
      "fatigue",
      0.04
    ],
    [
      "toque",
      0.04
    ],
    [
      "timbre",
      0.035
    ],
    [
      "cingle",
      0.0275
    ],
    [
      "gate",
      0.0275
    ],
    [
      "mauvais",
      0.0275
    ],
    [
      "souffreteux",
      0.0225
    ],
    [
      "pourri",
      0.0225
    ],
    [
      "malsain",
      0.0225
    ],
    [
      "cacochyme",
      0.0225
    ],
    [
      "aliene",
      0.0225
    ],
    [
      "egrotant",
      0.0175
    ],
    [
      "valetudinaire",
      0.0175
    ],
    [
      "patraque",
      0.0175
    ],
    [
      "patient",
      0.0175
    ],
    [
      "morbide",
      0.0175
    ],
    [
      "detraque",
      0.0175
    ],
    [
      "derange",
      0.0175
    ],
    [
      "abattu",
      0.0175
    ],
    [
      "malingre",
      0.01
    ],
    [
      "infirme",
      0.01
    ],
    [
      "indispose",
      0.01
    ],
    [
      "incommode",
      0.01
    ],
    [
      "foutu",
      0.01
    ],
    [
      "fievreux",
      0.01
    ],
    [
      "chetif",
      0.01
    ],
    [
      "avarie",
      0.01
    ],
    [
      "atteint",
      0.01
    ],
    [
      "aneanti",
      0.01
    ],
    [
      "rachitique",
      0.005
    ],
    [
      "pale",
      0.005
    ],
    [
      "perturbe",
      0.005
    ],
    [
      "raide",
      0.005
    ],
    [
      "retourne",
      0.005
    ],
    [
      "revolutionne",
      0.005
    ],
    [
      "secoue",
      0.005
    ],
    [
      "sonne",
      0.005
    ],
    [
      "sujet",
      0.005
    ],
    [
      "traumatise",
      0.005
    ],
    [
      "mal",
      0.005
    ],
    [
      "maboul",
      0.005
    ],
    [
      "lepreux",
      0.005
    ],
    [
      "alite",
      0.005
    ],
    [
      "altere",
      0.005
    ],
    [
      "anormal",
      0.005
    ],
    [
      "client",
      0.005
    ],
    [
      "dingue",
      0.005
    ],
    [
      "dolent",
      0.005
    ],
    [
      "demoli",
      0.005
    ],
    [
      "deprime",
      0.005
    ],
    [
      "desaxe",
      0.005
    ],
    [
      "fada",
      0.005
    ],
    [
      "grabataire",
      0.005
    ],
    [
      "gateux",
      0.005
    ],
    [
      "vicie",
      0.005
    ]
  ],
  "cueillir": [
    [
      "prendre",
      0.15
    ],
    [
      "ramasser",
      0.1225
    ],
    [
      "piquer",
      0.11
    ],
    [
      "recolter",
      0.0675
    ],
    [
      "saisir",
      0.0675
    ],
    [
      "recueillir",
      0.055
    ],
    [
      "voler",
      0.04
    ],
    [
      "ravir",
      0.04
    ],
    [
      "pincer",
      0.04
    ],
    [
      "faire",
      0.04
    ],
    [
      "derober",
      0.04
    ],
    [
      "moissonner",
      0.025
    ],
    [
      "grappiller",
      0.025
    ],
    [
      "emballer",
      0.025
    ],
    [
      "arreter",
      0.025
    ],
    [
      "vendanger",
      0.0125
    ],
    [
      "trouver",
      0.0125
    ],
    [
      "picoter",
      0.0125
    ],
    [
      "glaner",
      0.0125
    ],
    [
      "detacher",
      0.0125
    ],
    [
      "defruiter",
      0.0125
    ],
    [
      "collecter",
      0.0125
    ],
    [
      "epingler",
      0.0125
    ]
  ],
  "balader": [
    [
      "promener",
      0.3325
    ],
    [
      "sortir",
      0.3325
    ],
    [
      "trimballer",
      0.3325
    ]
  ],
  "balade": [
    [
      "promenade",
      0.285
    ],
    [
      "tour",
      0.2125
    ],
    [
      "baguenaude",
      0.07
    ],
    [
      "excursion",
      0.07
    ],
    [
      "flanerie",
      0.07
    ],
    [
      "randonnee",
      0.07
    ],
    [
      "sortie",
      0.07
    ],
    [
      "vadrouille",
      0.07
    ],
    [
      "voyage",
      0.07
    ]
  ],
  "soumis": [
    [
      "assujettir",
      0.105
    ],
    [
      "dompter",
      0.0675
    ],
    [
      "enchainer",
      0.065
    ],
    [
      "asservir",
      0.0525
    ],
    [
      "plier",
      0.04
    ],
    [
      "maitriser",
      0.035
    ],
    [
      "courber",
      0.035
    ],
    [
      "subjuguer",
      0.03
    ],
    [
      "mater",
      0.0275
    ],
    [
      "reduire",
      0.0225
    ],
    [
      "dominer",
      0.0225
    ],
    [
      "contraindre",
      0.0225
    ],
    [
      "captiver",
      0.0225
    ],
    [
      "attacher",
      0.0225
    ],
    [
      "presenter",
      0.0175
    ],
    [
      "opprimer",
      0.0175
    ],
    [
      "obliger",
      0.0175
    ],
    [
      "museler",
      0.0175
    ],
    [
      "donner",
      0.0175
    ],
    [
      "astreindre",
      0.0175
    ],
    [
      "tyranniser",
      0.015
    ],
    [
      "reprimer",
      0.015
    ],
    [
      "proposer",
      0.015
    ],
    [
      "offrir",
      0.015
    ],
    [
      "avancer",
      0.015
    ],
    [
      "arreter",
      0.015
    ],
    [
      "traiter",
      0.01
    ],
    [
      "ployer",
      0.01
    ],
    [
      "imposer",
      0.01
    ],
    [
      "exposer",
      0.01
    ],
    [
      "conquerir",
      0.01
    ],
    [
      "charmer",
      0.01
    ],
    [
      "apprivoiser",
      0.01
    ],
    [
      "abaisser",
      0.01
    ],
    [
      "subordonner",
      0.0075
    ],
    [
      "incliner",
      0.0075
    ],
    [
      "domestiquer",
      0.0075
    ],
    [
      "discipliner",
      0.0075
    ],
    [
      "capturer",
      0.0075
    ],
    [
      "brusquer",
      0.0075
    ],
    [
      "assouplir",
      0.0075
    ],
    [
      "agiter",
      0.0075
    ],
    [
      "s'accoupler",
      0.0025
    ],
    [
      "reglementer",
      0.0025
    ],
    [
      "pacifier",
      0.0025
    ],
    [
      "infeoder",
      0.0025
    ],
    [
      "controler",
      0.0025
    ],
    [
      "adresser",
      0.0025
    ],
    [
      "accabler",
      0.0025
    ],
    [
      "suggerer",
      0.0025
    ]
  ],
  "soumettre": [
    [
      "assujettir",
      0.105
    ],
    [
      "dompter",
      0.0675
    ],
    [
      "enchainer",
      0.065
    ],
    [
      "asservir",
      0.0525
    ],
    [
      "plier",
      0.04
    ],
    [
      "maitriser",
      0.035
    ],
    [
      "courber",
      0.035
    ],
    [
      "subjuguer",
      0.03
    ],
    [
      "mater",
      0.0275
    ],
    [
      "reduire",
      0.0225
    ],
    [
      "dominer",
      0.0225
    ],
    [
      "contraindre",
      0.0225
    ],
    [
      "captiver",
      0.0225
    ],
    [
      "attacher",
      0.0225
    ],
    [
      "presenter",
      0.0175
    ],
    [
      "opprimer",
      0.0175
    ],
    [
      "obliger",
      0.0175
    ],
    [
      "museler",
      0.0175
    ],
    [
      "donner",
      0.0175
    ],
    [
      "astreindre",
      0.0175
    ],
    [
      "tyranniser",
      0.015
    ],
    [
      "reprimer",
      0.015
    ],
    [
      "proposer",
      0.015
    ],
    [
      "offrir",
      0.015
    ],
    [
      "avancer",
      0.015
    ],
    [
      "arreter",
      0.015
    ],
    [
      "traiter",
      0.01
    ],
    [
      "ployer",
      0.01
    ],
    [
      "imposer",
      0.01
    ],
    [
      "exposer",
      0.01
    ],
    [
      "conquerir",
      0.01
    ],
    [
      "charmer",
      0.01
    ],
    [
      "apprivoiser",
      0.01
    ],
    [
      "abaisser",
      0.01
    ],
    [
      "subordonner",
      0.0075
    ],
    [
      "incliner",
      0.0075
    ],
    [
      "domestiquer",
      0.0075
    ],
    [
      "discipliner",
      0.0075
    ],
    [
      "capturer",
      0.0075
    ],
    [
      "brusquer",
      0.0075
    ],
    [
      "assouplir",
      0.0075
    ],
    [
      "agiter",
      0.0075
    ],
    [
      "s'accoupler",
      0.0025
    ],
    [
      "reglementer",
      0.0025
    ],
    [
      "pacifier",
      0.0025
    ],
    [
      "infeoder",
      0.0025
    ],
    [
      "controler",
      0.0025
    ],
    [
      "adresser",
      0.0025
    ],
    [
      "accabler",
      0.0025
    ],
    [
      "suggerer",
      0.0025
    ]
  ],
  "jurer": [
    [
      "affirmer",
      0.1075
    ],
    [
      "assurer",
      0.0975
    ],
    [
      "certifier",
      0.065
    ],
    [
      "dire",
      0.065
    ],
    [
      "trancher",
      0.065
    ],
    [
      "declarer",
      0.0525
    ],
    [
      "promettre",
      0.0525
    ],
    [
      "temoigner",
      0.0425
    ],
    [
      "soutenir",
      0.0425
    ],
    [
      "decider",
      0.0325
    ],
    [
      "garantir",
      0.0325
    ],
    [
      "pretendre",
      0.0325
    ],
    [
      "tempeter",
      0.02
    ],
    [
      "pester",
      0.02
    ],
    [
      "hurler",
      0.02
    ],
    [
      "detonner",
      0.02
    ],
    [
      "crier",
      0.02
    ],
    [
      "blasphemer",
      0.02
    ],
    [
      "attester",
      0.02
    ],
    [
      "nuire",
      0.01
    ],
    [
      "outrager",
      0.01
    ],
    [
      "resoudre",
      0.01
    ],
    [
      "s'engager",
      0.01
    ],
    [
      "engager",
      0.01
    ],
    [
      "detester",
      0.01
    ],
    [
      "decreter",
      0.01
    ],
    [
      "dissoner",
      0.01
    ],
    [
      "croire",
      0.01
    ],
    [
      "contraster",
      0.01
    ],
    [
      "sacrer",
      0.01
    ]
  ],
  "torture": [
    [
      "supplice",
      0.2275
    ],
    [
      "douleur",
      0.08
    ],
    [
      "peine",
      0.08
    ],
    [
      "mal",
      0.0625
    ],
    [
      "tourment",
      0.0625
    ],
    [
      "gene",
      0.0475
    ],
    [
      "gehenne",
      0.0475
    ],
    [
      "violence",
      0.03
    ],
    [
      "souffrance",
      0.03
    ],
    [
      "question",
      0.03
    ],
    [
      "punition",
      0.03
    ],
    [
      "martyre",
      0.03
    ],
    [
      "inquietude",
      0.03
    ],
    [
      "calvaire",
      0.03
    ],
    [
      "affliction",
      0.03
    ],
    [
      "persecution",
      0.015
    ],
    [
      "mort",
      0.015
    ],
    [
      "impatience",
      0.015
    ],
    [
      "execution",
      0.015
    ],
    [
      "chatiment",
      0.015
    ],
    [
      "atrocite",
      0.015
    ],
    [
      "pilori",
      0.015
    ]
  ],
  "torturer": [
    [
      "tourmenter",
      0.1625
    ],
    [
      "martyriser",
      0.0575
    ],
    [
      "tenailler",
      0.0575
    ],
    [
      "denaturer",
      0.0475
    ],
    [
      "travailler",
      0.0375
    ],
    [
      "supplicier",
      0.0375
    ],
    [
      "poursuivre",
      0.0375
    ],
    [
      "harceler",
      0.0375
    ],
    [
      "gener",
      0.0375
    ],
    [
      "forcer",
      0.0375
    ],
    [
      "bourreler",
      0.0375
    ],
    [
      "affliger",
      0.0275
    ],
    [
      "chagriner",
      0.0275
    ],
    [
      "navrer",
      0.0275
    ],
    [
      "persecuter",
      0.0175
    ],
    [
      "questionner",
      0.0175
    ],
    [
      "taler",
      0.0175
    ],
    [
      "trifouiller",
      0.0175
    ],
    [
      "violenter",
      0.0175
    ],
    [
      "obseder",
      0.0175
    ],
    [
      "meurtrir",
      0.0175
    ],
    [
      "infliger",
      0.0175
    ],
    [
      "gehenner",
      0.0175
    ],
    [
      "deformer",
      0.0175
    ],
    [
      "dechirer",
      0.0175
    ],
    [
      "crucifier",
      0.0175
    ],
    [
      "ravager",
      0.0075
    ],
    [
      "interpreter",
      0.0075
    ],
    [
      "detourner",
      0.0075
    ],
    [
      "defigurer",
      0.0075
    ],
    [
      "alambiquer",
      0.0075
    ],
    [
      "agiter",
      0.0075
    ],
    [
      "tortionner",
      0.0075
    ]
  ],
  "haillon": [
    [
      "guenille",
      0.3
    ],
    [
      "loque",
      0.2
    ],
    [
      "chiffon",
      0.1
    ],
    [
      "defroque",
      0.1
    ],
    [
      "penaillon",
      0.05
    ],
    [
      "penaille",
      0.05
    ],
    [
      "nippe",
      0.05
    ],
    [
      "lambeau",
      0.05
    ],
    [
      "harde",
      0.05
    ],
    [
      "vetement",
      0.05
    ]
  ],
  "guerison": [
    [
      "amelioration",
      0.15
    ],
    [
      "retablissement",
      0.15
    ],
    [
      "apaisement",
      0.1
    ],
    [
      "cessation",
      0.1
    ],
    [
      "cicatrisation",
      0.1
    ],
    [
      "soulagement",
      0.1
    ],
    [
      "resurrection",
      0.05
    ],
    [
      "restauration",
      0.05
    ],
    [
      "fin",
      0.05
    ],
    [
      "cure",
      0.05
    ],
    [
      "convalescence",
      0.05
    ],
    [
      "salut",
      0.05
    ]
  ],
  "degout": [
    [
      "tristesse",
      0.0775
    ],
    [
      "amertume",
      0.055
    ],
    [
      "chagrin",
      0.055
    ],
    [
      "desesperance",
      0.055
    ],
    [
      "ennui",
      0.0475
    ],
    [
      "abattement",
      0.0475
    ],
    [
      "deception",
      0.04
    ],
    [
      "repugnance",
      0.04
    ],
    [
      "repulsion",
      0.04
    ],
    [
      "ecoeurement",
      0.0325
    ],
    [
      "deboire",
      0.0325
    ],
    [
      "eloignement",
      0.0275
    ],
    [
      "lassitude",
      0.0275
    ],
    [
      "horreur",
      0.0275
    ],
    [
      "haine",
      0.0275
    ],
    [
      "desenchantement",
      0.0275
    ],
    [
      "nausee",
      0.02
    ],
    [
      "melancolie",
      0.02
    ],
    [
      "humiliation",
      0.02
    ],
    [
      "desespoir",
      0.02
    ],
    [
      "desabusement",
      0.02
    ],
    [
      "deplaisir",
      0.02
    ],
    [
      "aversion",
      0.02
    ],
    [
      "antipathie",
      0.02
    ],
    [
      "satiete",
      0.0125
    ],
    [
      "ressentiment",
      0.0125
    ],
    [
      "mortification",
      0.0125
    ],
    [
      "honte",
      0.0125
    ],
    [
      "execration",
      0.0125
    ],
    [
      "depit",
      0.0125
    ],
    [
      "spleen",
      0.005
    ],
    [
      "phobie",
      0.005
    ],
    [
      "mepris",
      0.005
    ],
    [
      "indigestion",
      0.005
    ],
    [
      "inappetence",
      0.005
    ],
    [
      "demoralisation",
      0.005
    ],
    [
      "blasement",
      0.005
    ],
    [
      "anorexie",
      0.005
    ],
    [
      "allergie",
      0.005
    ],
    [
      "affadissement",
      0.005
    ]
  ],
  "fleuri": [
    [
      "orne",
      0.175
    ],
    [
      "elegant",
      0.0575
    ],
    [
      "vermeil",
      0.0575
    ],
    [
      "seduisant",
      0.0575
    ],
    [
      "riant",
      0.0575
    ],
    [
      "recherche",
      0.0575
    ],
    [
      "pigmente",
      0.0575
    ],
    [
      "frais",
      0.0575
    ],
    [
      "florissant",
      0.0575
    ],
    [
      "disert",
      0.0575
    ],
    [
      "charge",
      0.0575
    ],
    [
      "brillante",
      0.0575
    ],
    [
      "boutonneux",
      0.0575
    ],
    [
      "bourgeonnant",
      0.0575
    ],
    [
      "emaille",
      0.0575
    ]
  ],
  "fleurir": [
    [
      "prosperer",
      0.1175
    ],
    [
      "gagner",
      0.0775
    ],
    [
      "s'enrichir",
      0.0575
    ],
    [
      "reussir",
      0.0575
    ],
    [
      "orner",
      0.0575
    ],
    [
      "marcher",
      0.0575
    ],
    [
      "croitre",
      0.0575
    ],
    [
      "s'epanouir",
      0.0375
    ],
    [
      "grandir",
      0.0375
    ],
    [
      "embellir",
      0.0375
    ],
    [
      "epanouir",
      0.0175
    ],
    [
      "eclore",
      0.0175
    ],
    [
      "verdoyer",
      0.0175
    ],
    [
      "saupoudrer",
      0.0175
    ],
    [
      "parer",
      0.0175
    ],
    [
      "imager",
      0.0175
    ],
    [
      "enrichir",
      0.0175
    ],
    [
      "enjoliver",
      0.0175
    ],
    [
      "briller",
      0.0175
    ],
    [
      "bourgeonner",
      0.0175
    ]
  ],
  "bourgeon": [
    [
      "pousse",
      0.1
    ],
    [
      "scion",
      0.0675
    ],
    [
      "rejeton",
      0.0675
    ],
    [
      "rejet",
      0.0675
    ],
    [
      "oeil",
      0.0675
    ],
    [
      "jet",
      0.0675
    ],
    [
      "bouton",
      0.0675
    ],
    [
      "gemme",
      0.0325
    ],
    [
      "gourme",
      0.0325
    ],
    [
      "greffe",
      0.0325
    ],
    [
      "maille",
      0.0325
    ],
    [
      "mailleton",
      0.0325
    ],
    [
      "stolon",
      0.0325
    ],
    [
      "drageon",
      0.0325
    ],
    [
      "dard",
      0.0325
    ],
    [
      "commencement",
      0.0325
    ],
    [
      "chaton",
      0.0325
    ],
    [
      "caieu",
      0.0325
    ],
    [
      "bulbille",
      0.0325
    ],
    [
      "bourre",
      0.0325
    ],
    [
      "acne",
      0.0325
    ],
    [
      "turion",
      0.0325
    ]
  ],
  "paradis": [
    [
      "ciel",
      0.17
    ],
    [
      "eden",
      0.145
    ],
    [
      "eldorado",
      0.0725
    ],
    [
      "poulailler",
      0.0725
    ],
    [
      "elysee",
      0.0725
    ],
    [
      "balcon",
      0.0475
    ],
    [
      "nirvana",
      0.0225
    ],
    [
      "oasis",
      0.0225
    ],
    [
      "olympe",
      0.0225
    ],
    [
      "pigeonnier",
      0.0225
    ],
    [
      "jardin",
      0.0225
    ],
    [
      "galerie",
      0.0225
    ],
    [
      "cocagne",
      0.0225
    ],
    [
      "amphitheatre",
      0.0225
    ],
    [
      "Walhalla",
      0.0225
    ]
  ],
  "front": [
    [
      "figure",
      0.075
    ],
    [
      "face",
      0.0625
    ],
    [
      "visage",
      0.05
    ],
    [
      "tete",
      0.05
    ],
    [
      "hardiesse",
      0.05
    ],
    [
      "facade",
      0.05
    ],
    [
      "devant",
      0.05
    ],
    [
      "apparence",
      0.05
    ],
    [
      "temerite",
      0.0375
    ],
    [
      "toupet",
      0.0375
    ],
    [
      "courage",
      0.0375
    ],
    [
      "coalition",
      0.0375
    ],
    [
      "avant",
      0.0375
    ],
    [
      "audace",
      0.0375
    ],
    [
      "air",
      0.0375
    ],
    [
      "union",
      0.025
    ],
    [
      "maintien",
      0.025
    ],
    [
      "groupement",
      0.025
    ],
    [
      "bloc",
      0.025
    ],
    [
      "ligue",
      0.0125
    ],
    [
      "lignes",
      0.0125
    ],
    [
      "ligne",
      0.0125
    ],
    [
      "impudence",
      0.0125
    ],
    [
      "haut",
      0.0125
    ],
    [
      "guerre",
      0.0125
    ],
    [
      "effronterie",
      0.0125
    ],
    [
      "confiance",
      0.0125
    ],
    [
      "cartel",
      0.0125
    ],
    [
      "bravoure",
      0.0125
    ],
    [
      "attitude",
      0.0125
    ],
    [
      "anterieur",
      0.0125
    ],
    [
      "sommet",
      0.0125
    ]
  ],
  "siffler": [
    [
      "boire",
      0.0875
    ],
    [
      "chanter",
      0.0875
    ],
    [
      "huer",
      0.0575
    ],
    [
      "lamper",
      0.0575
    ],
    [
      "humer",
      0.0275
    ],
    [
      "heler",
      0.0275
    ],
    [
      "persifler",
      0.0275
    ],
    [
      "pepier",
      0.0275
    ],
    [
      "s'enfiler",
      0.0275
    ],
    [
      "s'envoyer",
      0.0275
    ],
    [
      "seriner",
      0.0275
    ],
    [
      "siffloter",
      0.0275
    ],
    [
      "striduler",
      0.0275
    ],
    [
      "tinter",
      0.0275
    ],
    [
      "vider",
      0.0275
    ],
    [
      "hucher",
      0.0275
    ],
    [
      "houspiller",
      0.0275
    ],
    [
      "appeler",
      0.0275
    ],
    [
      "assibiler",
      0.0275
    ],
    [
      "bruire",
      0.0275
    ],
    [
      "chahuter",
      0.0275
    ],
    [
      "conspuer",
      0.0275
    ],
    [
      "corner",
      0.0275
    ],
    [
      "desapprouver",
      0.0275
    ],
    [
      "enfiler",
      0.0275
    ],
    [
      "engloutir",
      0.0275
    ],
    [
      "fluter",
      0.0275
    ],
    [
      "honnir",
      0.0275
    ],
    [
      "vilipender",
      0.0275
    ]
  ],
  "refrain": [
    [
      "chanson",
      0.1375
    ],
    [
      "rengaine",
      0.1375
    ],
    [
      "ritournelle",
      0.1025
    ],
    [
      "antienne",
      0.085
    ],
    [
      "chant",
      0.085
    ],
    [
      "scie",
      0.05
    ],
    [
      "repetition",
      0.05
    ],
    [
      "disque",
      0.05
    ],
    [
      "theme",
      0.0325
    ],
    [
      "romance",
      0.0325
    ],
    [
      "musique",
      0.0325
    ],
    [
      "leitmotiv",
      0.0325
    ],
    [
      "guitare",
      0.0325
    ],
    [
      "couplet",
      0.0325
    ],
    [
      "air",
      0.0325
    ],
    [
      "ballade",
      0.015
    ],
    [
      "rabachage",
      0.015
    ],
    [
      "topo",
      0.015
    ]
  ],
  "supplier": [
    [
      "prier",
      0.1875
    ],
    [
      "demander",
      0.14
    ],
    [
      "implorer",
      0.1075
    ],
    [
      "appeler",
      0.0625
    ],
    [
      "reclamer",
      0.0625
    ],
    [
      "solliciter",
      0.045
    ],
    [
      "recommander",
      0.045
    ],
    [
      "presser",
      0.045
    ],
    [
      "inviter",
      0.045
    ],
    [
      "insister",
      0.045
    ],
    [
      "revendiquer",
      0.03
    ],
    [
      "requerir",
      0.03
    ],
    [
      "embrasser",
      0.03
    ],
    [
      "crier",
      0.03
    ],
    [
      "adjurer",
      0.03
    ],
    [
      "conjurer",
      0.015
    ],
    [
      "convier",
      0.015
    ],
    [
      "pleurer",
      0.015
    ]
  ],
  "cajoler": [
    [
      "caresser",
      0.1525
    ],
    [
      "flatter",
      0.095
    ],
    [
      "choyer",
      0.0825
    ],
    [
      "caliner",
      0.0825
    ],
    [
      "mignoter",
      0.0675
    ],
    [
      "dorloter",
      0.0675
    ],
    [
      "amadouer",
      0.0675
    ],
    [
      "aduler",
      0.055
    ],
    [
      "couver",
      0.04
    ],
    [
      "flagorner",
      0.04
    ],
    [
      "seduire",
      0.0275
    ],
    [
      "enjoler",
      0.0275
    ],
    [
      "embabouiner",
      0.0275
    ],
    [
      "chouchouter",
      0.0275
    ],
    [
      "bouchonner",
      0.0275
    ],
    [
      "amignarder",
      0.0125
    ],
    [
      "courtiser",
      0.0125
    ],
    [
      "gater",
      0.0125
    ],
    [
      "mignarder",
      0.0125
    ],
    [
      "mitonner",
      0.0125
    ],
    [
      "pouponner",
      0.0125
    ]
  ],
  "scene": [
    [
      "dispute",
      0.1
    ],
    [
      "querelle",
      0.075
    ],
    [
      "seance",
      0.075
    ],
    [
      "altercation",
      0.0675
    ],
    [
      "spectacle",
      0.0575
    ],
    [
      "discussion",
      0.05
    ],
    [
      "sortie",
      0.04
    ],
    [
      "algarade",
      0.0325
    ],
    [
      "comedie",
      0.0325
    ],
    [
      "theatre",
      0.0225
    ],
    [
      "tableau",
      0.0225
    ],
    [
      "peinture",
      0.0225
    ],
    [
      "grabuge",
      0.0225
    ],
    [
      "engueulade",
      0.0225
    ],
    [
      "decor",
      0.0225
    ],
    [
      "accrochage",
      0.0225
    ],
    [
      "vue",
      0.015
    ],
    [
      "saynete",
      0.015
    ],
    [
      "reprimande",
      0.015
    ],
    [
      "planches",
      0.015
    ],
    [
      "paysage",
      0.015
    ],
    [
      "heurt",
      0.015
    ],
    [
      "feerie",
      0.015
    ],
    [
      "esclandre",
      0.015
    ],
    [
      "criaillerie",
      0.015
    ],
    [
      "cirque",
      0.015
    ],
    [
      "carillon",
      0.015
    ],
    [
      "proverbe",
      0.0075
    ],
    [
      "sketch",
      0.0075
    ],
    [
      "sequence",
      0.0075
    ],
    [
      "treteaux",
      0.0075
    ],
    [
      "plateau",
      0.0075
    ],
    [
      "partie",
      0.0075
    ],
    [
      "estrade",
      0.0075
    ],
    [
      "differend",
      0.0075
    ],
    [
      "bambochade",
      0.0075
    ],
    [
      "avanie",
      0.0075
    ],
    [
      "acces",
      0.0075
    ],
    [
      "evenement",
      0.0075
    ]
  ],
  "montrer": [
    [
      "reveler",
      0.14
    ],
    [
      "indiquer",
      0.0525
    ],
    [
      "exposer",
      0.05
    ],
    [
      "afficher",
      0.0425
    ],
    [
      "manifester",
      0.0375
    ],
    [
      "signaler",
      0.035
    ],
    [
      "dire",
      0.0275
    ],
    [
      "signifier",
      0.0275
    ],
    [
      "temoigner",
      0.0275
    ],
    [
      "exprimer",
      0.025
    ],
    [
      "marquer",
      0.025
    ],
    [
      "annoncer",
      0.0225
    ],
    [
      "donner",
      0.0225
    ],
    [
      "declarer",
      0.0225
    ],
    [
      "expliquer",
      0.02
    ],
    [
      "presenter",
      0.0175
    ],
    [
      "representer",
      0.015
    ],
    [
      "devoiler",
      0.015
    ],
    [
      "decouvrir",
      0.015
    ],
    [
      "prouver",
      0.015
    ],
    [
      "trahir",
      0.015
    ],
    [
      "produire",
      0.0125
    ],
    [
      "porter",
      0.0125
    ],
    [
      "demontrer",
      0.01
    ],
    [
      "etaler",
      0.01
    ],
    [
      "rapporter",
      0.01
    ],
    [
      "denoncer",
      0.01
    ],
    [
      "apprendre",
      0.01
    ],
    [
      "affirmer",
      0.0075
    ],
    [
      "raconter",
      0.0075
    ],
    [
      "developper",
      0.0075
    ],
    [
      "peindre",
      0.0075
    ],
    [
      "exhiber",
      0.0075
    ],
    [
      "dessiner",
      0.0075
    ],
    [
      "attester",
      0.005
    ],
    [
      "offrir",
      0.005
    ],
    [
      "livrer",
      0.005
    ],
    [
      "enseigner",
      0.005
    ],
    [
      "denoter",
      0.005
    ],
    [
      "souligner",
      0.005
    ],
    [
      "retracer",
      0.005
    ],
    [
      "instruire",
      0.005
    ],
    [
      "designer",
      0.005
    ],
    [
      "decrire",
      0.005
    ],
    [
      "accuser",
      0.005
    ],
    [
      "traduire",
      0.0025
    ],
    [
      "prodiguer",
      0.0025
    ],
    [
      "deployer",
      0.0025
    ],
    [
      "deceler",
      0.0025
    ],
    [
      "avertir",
      0.0025
    ],
    [
      "degager",
      0.0025
    ],
    [
      "etablir",
      0.0025
    ],
    [
      "ecrire",
      0.0025
    ],
    [
      "confirmer",
      0.0025
    ],
    [
      "affecter",
      0.0025
    ],
    [
      "respirer",
      0.0025
    ],
    [
      "garantir",
      0.0025
    ],
    [
      "fournir",
      0.0025
    ],
    [
      "exterioriser",
      0.0025
    ],
    [
      "exhaler",
      0.0025
    ],
    [
      "depeindre",
      0.0025
    ],
    [
      "demasquer",
      0.0025
    ],
    [
      "reproduire",
      0.0
    ],
    [
      "deshabiller",
      0.0
    ],
    [
      "denuder",
      0.0
    ],
    [
      "caracteriser",
      0.0
    ],
    [
      "evoquer",
      0.0
    ],
    [
      "detromper",
      0.0
    ],
    [
      "arborer",
      0.0
    ],
    [
      "accentuer",
      0.0
    ],
    [
      "relater",
      0.0
    ],
    [
      "proposer",
      0.0
    ],
    [
      "profiler",
      0.0
    ],
    [
      "deballer",
      0.0
    ],
    [
      "brandir",
      0.0
    ],
    [
      "apercevoir",
      0.0
    ],
    [
      "abattre",
      0.0
    ]
  ],
  "trou": [
    [
      "excavation",
      0.0575
    ],
    [
      "cavite",
      0.0525
    ],
    [
      "fente",
      0.05
    ],
    [
      "ouverture",
      0.0325
    ],
    [
      "renfoncement",
      0.0325
    ],
    [
      "patelin",
      0.0275
    ],
    [
      "manque",
      0.0275
    ],
    [
      "faille",
      0.0275
    ],
    [
      "vide",
      0.025
    ],
    [
      "trouee",
      0.025
    ],
    [
      "dechirure",
      0.025
    ],
    [
      "creux",
      0.025
    ],
    [
      "coin",
      0.025
    ],
    [
      "retraite",
      0.02
    ],
    [
      "lacune",
      0.02
    ],
    [
      "grotte",
      0.02
    ],
    [
      "enfoncement",
      0.02
    ],
    [
      "coupure",
      0.02
    ],
    [
      "caverne",
      0.02
    ],
    [
      "breche",
      0.02
    ],
    [
      "abri",
      0.02
    ],
    [
      "taniere",
      0.015
    ],
    [
      "repaire",
      0.015
    ],
    [
      "omission",
      0.015
    ],
    [
      "hiatus",
      0.015
    ],
    [
      "bled",
      0.015
    ],
    [
      "antre",
      0.015
    ],
    [
      "absence",
      0.015
    ],
    [
      "village",
      0.01
    ],
    [
      "terrier",
      0.01
    ],
    [
      "souterrain",
      0.01
    ],
    [
      "percee",
      0.01
    ],
    [
      "pays",
      0.01
    ],
    [
      "oubli",
      0.01
    ],
    [
      "interstice",
      0.01
    ],
    [
      "anfractuosite",
      0.01
    ],
    [
      "bourg",
      0.01
    ],
    [
      "cache",
      0.01
    ],
    [
      "crevasse",
      0.01
    ],
    [
      "endroit",
      0.01
    ],
    [
      "tranchee",
      0.0075
    ],
    [
      "repli",
      0.0075
    ],
    [
      "puits",
      0.0075
    ],
    [
      "pore",
      0.0075
    ],
    [
      "niche",
      0.0075
    ],
    [
      "localite",
      0.0075
    ],
    [
      "fuite",
      0.0075
    ],
    [
      "fosse",
      0.0075
    ],
    [
      "desert",
      0.0075
    ],
    [
      "accroc",
      0.0075
    ],
    [
      "habitation",
      0.0025
    ],
    [
      "hypogee",
      0.0025
    ],
    [
      "jouette",
      0.0025
    ],
    [
      "orifice",
      0.0025
    ],
    [
      "perforation",
      0.0025
    ],
    [
      "pertuis",
      0.0025
    ],
    [
      "poquet",
      0.0025
    ],
    [
      "forure",
      0.0025
    ],
    [
      "entonnoir",
      0.0025
    ],
    [
      "enfoncure",
      0.0025
    ],
    [
      "deficit",
      0.0025
    ],
    [
      "defaillance",
      0.0025
    ],
    [
      "cheminee",
      0.0025
    ],
    [
      "cambrousse",
      0.0025
    ],
    [
      "brulure",
      0.0025
    ],
    [
      "amnesie",
      0.0025
    ],
    [
      "prison",
      0.0025
    ]
  ],
  "haute": [
    [
      "grand",
      0.0775
    ],
    [
      "beau",
      0.055
    ],
    [
      "superieur",
      0.05
    ],
    [
      "eleve",
      0.05
    ],
    [
      "important",
      0.045
    ],
    [
      "fort",
      0.0425
    ],
    [
      "gros",
      0.0375
    ],
    [
      "eminent",
      0.0275
    ],
    [
      "sommet",
      0.0275
    ],
    [
      "noble",
      0.0275
    ],
    [
      "profond",
      0.0225
    ],
    [
      "sublime",
      0.0225
    ],
    [
      "bon",
      0.02
    ],
    [
      "superbe",
      0.02
    ],
    [
      "releve",
      0.0175
    ],
    [
      "extreme",
      0.015
    ],
    [
      "fier",
      0.015
    ],
    [
      "eclatant",
      0.015
    ],
    [
      "retentissant",
      0.0125
    ],
    [
      "remarquable",
      0.0125
    ],
    [
      "puissant",
      0.0125
    ],
    [
      "faite",
      0.0125
    ],
    [
      "comble",
      0.0125
    ],
    [
      "arrogant",
      0.01
    ],
    [
      "considerable",
      0.01
    ],
    [
      "hauteur",
      0.01
    ],
    [
      "vif",
      0.01
    ],
    [
      "eloigne",
      0.0075
    ],
    [
      "sonore",
      0.0075
    ],
    [
      "cime",
      0.0075
    ],
    [
      "vieux",
      0.005
    ],
    [
      "tete",
      0.005
    ],
    [
      "transcendant",
      0.005
    ],
    [
      "tonitruant",
      0.005
    ],
    [
      "supreme",
      0.005
    ],
    [
      "resonnant",
      0.005
    ],
    [
      "pointe",
      0.005
    ],
    [
      "orgueilleux",
      0.005
    ],
    [
      "intense",
      0.005
    ],
    [
      "aigu",
      0.005
    ],
    [
      "altier",
      0.005
    ],
    [
      "ancien",
      0.005
    ],
    [
      "exagere",
      0.005
    ],
    [
      "hautain",
      0.005
    ],
    [
      "heroique",
      0.005
    ],
    [
      "percant",
      0.0025
    ],
    [
      "pinacle",
      0.0025
    ],
    [
      "recule",
      0.0025
    ],
    [
      "rencheri",
      0.0025
    ],
    [
      "sommite",
      0.0025
    ],
    [
      "sourcilleux",
      0.0025
    ],
    [
      "soutenu",
      0.0025
    ],
    [
      "elevation",
      0.0025
    ],
    [
      "eminence",
      0.0025
    ],
    [
      "ethere",
      0.0025
    ],
    [
      "ouvertement",
      0.0025
    ],
    [
      "nettement",
      0.0025
    ],
    [
      "crete",
      0.0025
    ],
    [
      "digne",
      0.0025
    ],
    [
      "dominant",
      0.0025
    ],
    [
      "dedaigneux",
      0.0025
    ],
    [
      "exemplaire",
      0.0025
    ],
    [
      "fleche",
      0.0025
    ],
    [
      "fortement",
      0.0025
    ],
    [
      "franchement",
      0.0025
    ],
    [
      "hautement",
      0.0025
    ],
    [
      "long",
      0.0025
    ],
    [
      "proeminent",
      0.0
    ],
    [
      "perche",
      0.0
    ],
    [
      "noeud",
      0.0
    ],
    [
      "loin",
      0.0
    ],
    [
      "publiquement",
      0.0
    ],
    [
      "ronflant",
      0.0
    ],
    [
      "sureleve",
      0.0
    ],
    [
      "toiture",
      0.0
    ],
    [
      "vibrant",
      0.0
    ],
    [
      "edifiant",
      0.0
    ],
    [
      "elance",
      0.0
    ],
    [
      "leve",
      0.0
    ],
    [
      "intensement",
      0.0
    ],
    [
      "front",
      0.0
    ],
    [
      "altitude",
      0.0
    ],
    [
      "apogee",
      0.0
    ],
    [
      "colline",
      0.0
    ],
    [
      "corsage",
      0.0
    ],
    [
      "couronnement",
      0.0
    ],
    [
      "culminant",
      0.0
    ],
    [
      "celeste",
      0.0
    ],
    [
      "dessus",
      0.0
    ],
    [
      "dresse",
      0.0
    ],
    [
      "demesure",
      0.0
    ],
    [
      "fortune",
      0.0
    ],
    [
      "epice",
      0.0
    ]
  ],
  "demeure": [
    [
      "maison",
      0.1775
    ],
    [
      "habitation",
      0.15
    ],
    [
      "abri",
      0.0975
    ],
    [
      "logement",
      0.0775
    ],
    [
      "toit",
      0.07
    ],
    [
      "logis",
      0.06
    ],
    [
      "penates",
      0.0425
    ],
    [
      "nid",
      0.0425
    ],
    [
      "foyer",
      0.0425
    ],
    [
      "domicile",
      0.035
    ],
    [
      "residence",
      0.035
    ],
    [
      "gite",
      0.025
    ],
    [
      "chateau",
      0.025
    ],
    [
      "asile",
      0.025
    ],
    [
      "chambre",
      0.0175
    ],
    [
      "adresse",
      0.0075
    ],
    [
      "delai",
      0.0075
    ],
    [
      "habitacle",
      0.0075
    ],
    [
      "palais",
      0.0075
    ],
    [
      "reposee",
      0.0075
    ],
    [
      "retard",
      0.0075
    ],
    [
      "sejour",
      0.0075
    ]
  ],
  "demeurer": [
    [
      "rester",
      0.0875
    ],
    [
      "durer",
      0.065
    ],
    [
      "subsister",
      0.0625
    ],
    [
      "loger",
      0.0575
    ],
    [
      "sejourner",
      0.0575
    ],
    [
      "tenir",
      0.0525
    ],
    [
      "continuer",
      0.05
    ],
    [
      "resider",
      0.045
    ],
    [
      "habiter",
      0.04
    ],
    [
      "trainer",
      0.04
    ],
    [
      "persister",
      0.0375
    ],
    [
      "vivre",
      0.0375
    ],
    [
      "s'eterniser",
      0.0325
    ],
    [
      "perseverer",
      0.025
    ],
    [
      "exister",
      0.02
    ],
    [
      "s'attarder",
      0.02
    ],
    [
      "etre",
      0.02
    ],
    [
      "conserver",
      0.015
    ],
    [
      "occuper",
      0.01
    ],
    [
      "s'enteter",
      0.0075
    ],
    [
      "s'obstiner",
      0.0075
    ],
    [
      "sieger",
      0.0075
    ],
    [
      "survivre",
      0.0075
    ],
    [
      "tarder",
      0.0075
    ],
    [
      "s'arreter",
      0.0075
    ],
    [
      "percher",
      0.0075
    ],
    [
      "nicher",
      0.0075
    ],
    [
      "attendre",
      0.0075
    ],
    [
      "descendre",
      0.0075
    ],
    [
      "entretenir",
      0.0075
    ],
    [
      "garder",
      0.0075
    ],
    [
      "giter",
      0.0075
    ],
    [
      "jucher",
      0.0075
    ],
    [
      "stationner",
      0.0025
    ],
    [
      "s'etablir",
      0.0025
    ],
    [
      "pourrir",
      0.0025
    ],
    [
      "lutter",
      0.0025
    ],
    [
      "crecher",
      0.0025
    ],
    [
      "coller",
      0.0025
    ]
  ],
  "cesser": [
    [
      "finir",
      0.11
    ],
    [
      "passer",
      0.0625
    ],
    [
      "tomber",
      0.0625
    ],
    [
      "s'evanouir",
      0.0575
    ],
    [
      "disparaitre",
      0.0575
    ],
    [
      "abandonner",
      0.0575
    ],
    [
      "s'eteindre",
      0.0475
    ],
    [
      "expirer",
      0.0375
    ],
    [
      "interrompre",
      0.0375
    ],
    [
      "mourir",
      0.0325
    ],
    [
      "ceder",
      0.0275
    ],
    [
      "arreter",
      0.0275
    ],
    [
      "renoncer",
      0.0225
    ],
    [
      "s'arreter",
      0.0225
    ],
    [
      "terminer",
      0.0175
    ],
    [
      "s'achever",
      0.0175
    ],
    [
      "lacher",
      0.0175
    ],
    [
      "diminuer",
      0.0175
    ],
    [
      "couper",
      0.0175
    ],
    [
      "tarir",
      0.0125
    ],
    [
      "suspendre",
      0.0125
    ],
    [
      "s'effacer",
      0.0125
    ],
    [
      "laisser",
      0.0125
    ],
    [
      "s'enfuir",
      0.0075
    ],
    [
      "discontinuer",
      0.0075
    ],
    [
      "achever",
      0.0075
    ],
    [
      "stationner",
      0.0025
    ],
    [
      "s'interrompre",
      0.0025
    ],
    [
      "s'apaiser",
      0.0025
    ],
    [
      "s'abstenir",
      0.0025
    ],
    [
      "chomer",
      0.0025
    ],
    [
      "abroger",
      0.0025
    ],
    [
      "vaquer",
      0.0025
    ]
  ],
  "rire": [
    [
      "joie",
      0.1425
    ],
    [
      "ris",
      0.1425
    ],
    [
      "sourire",
      0.1075
    ],
    [
      "risee",
      0.07
    ],
    [
      "rictus",
      0.07
    ],
    [
      "ricanement",
      0.07
    ],
    [
      "raillerie",
      0.07
    ],
    [
      "gaiete",
      0.07
    ],
    [
      "cachinnation",
      0.035
    ],
    [
      "enjouement",
      0.035
    ],
    [
      "hilarite",
      0.035
    ],
    [
      "rigolade",
      0.035
    ],
    [
      "risette",
      0.035
    ],
    [
      "souris",
      0.035
    ]
  ],
  "oubli": [
    [
      "omission",
      0.0975
    ],
    [
      "absence",
      0.0825
    ],
    [
      "inattention",
      0.0825
    ],
    [
      "manque",
      0.0825
    ],
    [
      "negligence",
      0.0825
    ],
    [
      "carence",
      0.065
    ],
    [
      "distraction",
      0.0475
    ],
    [
      "trou",
      0.0475
    ],
    [
      "eloignement",
      0.0475
    ],
    [
      "manquement",
      0.0325
    ],
    [
      "lacune",
      0.0325
    ],
    [
      "inobservation",
      0.0325
    ],
    [
      "indifference",
      0.0325
    ],
    [
      "remission",
      0.015
    ],
    [
      "preterition",
      0.015
    ],
    [
      "pardon",
      0.015
    ],
    [
      "ombre",
      0.015
    ],
    [
      "meconnaissance",
      0.015
    ],
    [
      "inobservance",
      0.015
    ],
    [
      "ingratitude",
      0.015
    ],
    [
      "inadvertance",
      0.015
    ],
    [
      "effacement",
      0.015
    ],
    [
      "discredit",
      0.015
    ],
    [
      "amnesie",
      0.015
    ],
    [
      "amnistie",
      0.015
    ],
    [
      "abandon",
      0.015
    ],
    [
      "etourderie",
      0.015
    ]
  ],
  "mepris": [
    [
      "dedain",
      0.1475
    ],
    [
      "affront",
      0.09
    ],
    [
      "refus",
      0.0575
    ],
    [
      "rebuffade",
      0.0575
    ],
    [
      "mesestime",
      0.0575
    ],
    [
      "camouflet",
      0.0575
    ],
    [
      "avanie",
      0.0575
    ],
    [
      "inconsideration",
      0.0275
    ],
    [
      "indignite",
      0.0275
    ],
    [
      "morgue",
      0.0275
    ],
    [
      "negation",
      0.0275
    ],
    [
      "pilori",
      0.0275
    ],
    [
      "pitie",
      0.0275
    ],
    [
      "hauteur",
      0.0275
    ],
    [
      "desinteret",
      0.0275
    ],
    [
      "desaffection",
      0.0275
    ],
    [
      "derision",
      0.0275
    ],
    [
      "degout",
      0.0275
    ],
    [
      "deconsideration",
      0.0275
    ],
    [
      "distance",
      0.0275
    ],
    [
      "couleuvre",
      0.0275
    ],
    [
      "arrogance",
      0.0275
    ],
    [
      "superbe",
      0.0275
    ]
  ],
  "meprendre": [
    [
      "s'abuser",
      0.23
    ],
    [
      "mejuger",
      0.1525
    ],
    [
      "confondre",
      0.075
    ],
    [
      "errer",
      0.075
    ],
    [
      "meconnaitre",
      0.075
    ]
  ],
  "repris": [
    [
      "corriger",
      0.05
    ],
    [
      "recommencer",
      0.045
    ],
    [
      "relever",
      0.045
    ],
    [
      "revenir",
      0.045
    ],
    [
      "recuperer",
      0.0375
    ],
    [
      "retrouver",
      0.0375
    ],
    [
      "refaire",
      0.0375
    ],
    [
      "revoir",
      0.03
    ],
    [
      "reparer",
      0.03
    ],
    [
      "tancer",
      0.025
    ],
    [
      "repeter",
      0.025
    ],
    [
      "reprimander",
      0.025
    ],
    [
      "regagner",
      0.025
    ],
    [
      "blamer",
      0.025
    ],
    [
      "sermonner",
      0.0175
    ],
    [
      "retoucher",
      0.0175
    ],
    [
      "retirer",
      0.0175
    ],
    [
      "renaitre",
      0.0175
    ],
    [
      "remanier",
      0.0175
    ],
    [
      "recouvrer",
      0.0175
    ],
    [
      "rattraper",
      0.0175
    ],
    [
      "prendre",
      0.0175
    ],
    [
      "annuler",
      0.0175
    ],
    [
      "recidiver",
      0.0125
    ],
    [
      "renouer",
      0.0125
    ],
    [
      "remonter",
      0.0125
    ],
    [
      "delier",
      0.0125
    ],
    [
      "critiquer",
      0.0125
    ],
    [
      "condamner",
      0.0125
    ],
    [
      "censurer",
      0.0125
    ],
    [
      "reprocher",
      0.005
    ],
    [
      "reproduire",
      0.005
    ],
    [
      "ressaisir",
      0.005
    ],
    [
      "retourner",
      0.005
    ],
    [
      "recapituler",
      0.005
    ],
    [
      "reembaucher",
      0.005
    ],
    [
      "resumer",
      0.005
    ],
    [
      "retrecir",
      0.005
    ],
    [
      "remporter",
      0.005
    ],
    [
      "remmancher",
      0.005
    ],
    [
      "rembarrer",
      0.005
    ],
    [
      "changer",
      0.005
    ],
    [
      "chapitrer",
      0.005
    ],
    [
      "chatier",
      0.005
    ],
    [
      "continuer",
      0.005
    ],
    [
      "exhumer",
      0.005
    ],
    [
      "modifier",
      0.005
    ],
    [
      "morigener",
      0.005
    ],
    [
      "pincer",
      0.005
    ],
    [
      "rebondir",
      0.005
    ],
    [
      "reconquerir",
      0.005
    ],
    [
      "redire",
      0.005
    ]
  ],
  "baton": [
    [
      "baguette",
      0.0675
    ],
    [
      "tige",
      0.0525
    ],
    [
      "canne",
      0.0425
    ],
    [
      "cravache",
      0.0325
    ],
    [
      "massue",
      0.0325
    ],
    [
      "rondin",
      0.025
    ],
    [
      "trique",
      0.025
    ],
    [
      "tuteur",
      0.025
    ],
    [
      "verge",
      0.025
    ],
    [
      "pieu",
      0.025
    ],
    [
      "perche",
      0.025
    ],
    [
      "manche",
      0.025
    ],
    [
      "gaule",
      0.025
    ],
    [
      "fouet",
      0.025
    ],
    [
      "cylindre",
      0.025
    ],
    [
      "piquet",
      0.015
    ],
    [
      "schlague",
      0.015
    ],
    [
      "stick",
      0.015
    ],
    [
      "tringle",
      0.015
    ],
    [
      "echalas",
      0.015
    ],
    [
      "matraque",
      0.015
    ],
    [
      "hampe",
      0.015
    ],
    [
      "gourdin",
      0.015
    ],
    [
      "buche",
      0.015
    ],
    [
      "bras",
      0.015
    ],
    [
      "bourdon",
      0.015
    ],
    [
      "badine",
      0.015
    ],
    [
      "alpenstock",
      0.015
    ],
    [
      "piolet",
      0.0075
    ],
    [
      "million",
      0.0075
    ],
    [
      "masse",
      0.0075
    ],
    [
      "lituus",
      0.0075
    ],
    [
      "latte",
      0.0075
    ],
    [
      "jalon",
      0.0075
    ],
    [
      "houlette",
      0.0075
    ],
    [
      "rabouilloir",
      0.0075
    ],
    [
      "rondelet",
      0.0075
    ],
    [
      "rouleau",
      0.0075
    ],
    [
      "sceptre",
      0.0075
    ],
    [
      "tortoir",
      0.0075
    ],
    [
      "tribart",
      0.0075
    ],
    [
      "tricot",
      0.0075
    ],
    [
      "temoin",
      0.0075
    ],
    [
      "epieu",
      0.0075
    ],
    [
      "garrot",
      0.0075
    ],
    [
      "gaffe",
      0.0075
    ],
    [
      "assommoir",
      0.0075
    ],
    [
      "baratton",
      0.0075
    ],
    [
      "barre",
      0.0075
    ],
    [
      "batte",
      0.0075
    ],
    [
      "billot",
      0.0075
    ],
    [
      "brigadier",
      0.0075
    ],
    [
      "briquage",
      0.0075
    ],
    [
      "brique",
      0.0075
    ],
    [
      "bequille",
      0.0075
    ],
    [
      "caducee",
      0.0075
    ],
    [
      "carassonne",
      0.0075
    ],
    [
      "chevillon",
      0.0075
    ],
    [
      "crosse",
      0.0075
    ],
    [
      "debouchoir",
      0.0075
    ],
    [
      "ferule",
      0.0075
    ],
    [
      "aiguillon",
      0.0075
    ]
  ],
  "guenille": [
    [
      "haillon",
      0.2125
    ],
    [
      "loque",
      0.1775
    ],
    [
      "chiffon",
      0.105
    ],
    [
      "defroque",
      0.105
    ],
    [
      "corps",
      0.07
    ],
    [
      "penaillon",
      0.035
    ],
    [
      "penaille",
      0.035
    ],
    [
      "peau",
      0.035
    ],
    [
      "nippe",
      0.035
    ],
    [
      "lambeau",
      0.035
    ],
    [
      "harde",
      0.035
    ],
    [
      "guenipe",
      0.035
    ],
    [
      "chiffe",
      0.035
    ],
    [
      "vetement",
      0.035
    ]
  ],
  "semelle": [
    [
      "bidoche",
      0.125
    ],
    [
      "bifteck",
      0.125
    ],
    [
      "boisage",
      0.125
    ],
    [
      "carne",
      0.125
    ],
    [
      "comble",
      0.125
    ],
    [
      "ferme",
      0.125
    ],
    [
      "patin",
      0.125
    ],
    [
      "etai",
      0.125
    ]
  ],
  "pays": [
    [
      "region",
      0.13
    ],
    [
      "terre",
      0.0625
    ],
    [
      "coin",
      0.0425
    ],
    [
      "domaine",
      0.035
    ],
    [
      "endroit",
      0.035
    ],
    [
      "lieu",
      0.035
    ],
    [
      "etat",
      0.035
    ],
    [
      "territoire",
      0.03
    ],
    [
      "terrain",
      0.03
    ],
    [
      "patelin",
      0.03
    ],
    [
      "nation",
      0.03
    ],
    [
      "zone",
      0.0225
    ],
    [
      "sphere",
      0.0225
    ],
    [
      "rivage",
      0.0225
    ],
    [
      "patrie",
      0.0225
    ],
    [
      "contree",
      0.0225
    ],
    [
      "univers",
      0.0175
    ],
    [
      "trou",
      0.0175
    ],
    [
      "terroir",
      0.0175
    ],
    [
      "sol",
      0.0175
    ],
    [
      "royaume",
      0.0175
    ],
    [
      "quartier",
      0.0175
    ],
    [
      "origine",
      0.0175
    ],
    [
      "climat",
      0.0175
    ],
    [
      "canton",
      0.0175
    ],
    [
      "bled",
      0.0175
    ],
    [
      "mere",
      0.01
    ],
    [
      "parages",
      0.01
    ],
    [
      "province",
      0.01
    ],
    [
      "puissance",
      0.01
    ],
    [
      "empire",
      0.01
    ],
    [
      "commune",
      0.01
    ],
    [
      "ciel",
      0.01
    ],
    [
      "campagne",
      0.01
    ],
    [
      "bourg",
      0.01
    ],
    [
      "bord",
      0.01
    ],
    [
      "cru",
      0.005
    ],
    [
      "foyer",
      0.005
    ],
    [
      "paroisse",
      0.005
    ],
    [
      "peuple",
      0.005
    ],
    [
      "concitoyen",
      0.005
    ],
    [
      "compatriote",
      0.005
    ],
    [
      "clocher",
      0.005
    ],
    [
      "cite",
      0.005
    ],
    [
      "bourgade",
      0.005
    ],
    [
      "Nation",
      0.005
    ],
    [
      "plage",
      0.005
    ]
  ],
  "fontaine": [
    [
      "abreuvoir",
      0.25
    ],
    [
      "puits",
      0.25
    ],
    [
      "source",
      0.25
    ],
    [
      "timbre",
      0.25
    ]
  ],
  "detour": [
    [
      "meandre",
      0.06
    ],
    [
      "tournant",
      0.0525
    ],
    [
      "artifice",
      0.0425
    ],
    [
      "truc",
      0.0425
    ],
    [
      "moyen",
      0.0375
    ],
    [
      "astuce",
      0.0325
    ],
    [
      "ruse",
      0.0325
    ],
    [
      "tour",
      0.025
    ],
    [
      "subterfuge",
      0.025
    ],
    [
      "sinuosite",
      0.025
    ],
    [
      "contour",
      0.025
    ],
    [
      "circuit",
      0.025
    ],
    [
      "zigzag",
      0.02
    ],
    [
      "repli",
      0.02
    ],
    [
      "lacet",
      0.02
    ],
    [
      "finasserie",
      0.02
    ],
    [
      "dedale",
      0.02
    ],
    [
      "circonlocution",
      0.02
    ],
    [
      "biais",
      0.02
    ],
    [
      "labyrinthe",
      0.015
    ],
    [
      "manege",
      0.015
    ],
    [
      "periphrase",
      0.015
    ],
    [
      "secret",
      0.015
    ],
    [
      "tergiversation",
      0.015
    ],
    [
      "virage",
      0.015
    ],
    [
      "fuite",
      0.015
    ],
    [
      "deviation",
      0.015
    ],
    [
      "circonvolution",
      0.015
    ],
    [
      "coin",
      0.015
    ],
    [
      "complication",
      0.015
    ],
    [
      "coude",
      0.015
    ],
    [
      "courbe",
      0.015
    ],
    [
      "crochet",
      0.015
    ],
    [
      "voie",
      0.01
    ],
    [
      "subtilite",
      0.01
    ],
    [
      "mystere",
      0.01
    ],
    [
      "histoire",
      0.01
    ],
    [
      "boucle",
      0.01
    ],
    [
      "angle",
      0.01
    ],
    [
      "nature",
      0.005
    ],
    [
      "obliquite",
      0.005
    ],
    [
      "parade",
      0.005
    ],
    [
      "phrase",
      0.005
    ],
    [
      "symbole",
      0.005
    ],
    [
      "tripotage",
      0.005
    ],
    [
      "manigance",
      0.005
    ],
    [
      "louvoiement",
      0.005
    ],
    [
      "hypocrisie",
      0.005
    ],
    [
      "derivation",
      0.005
    ],
    [
      "diversion",
      0.005
    ],
    [
      "digression",
      0.005
    ],
    [
      "bande",
      0.005
    ],
    [
      "anfractuosite",
      0.005
    ],
    [
      "ambages",
      0.005
    ],
    [
      "evitement",
      0.005
    ]
  ],
  "pretendre": [
    [
      "desirer",
      0.09
    ],
    [
      "vouloir",
      0.09
    ],
    [
      "souhaiter",
      0.0675
    ],
    [
      "affirmer",
      0.06
    ],
    [
      "ambitionner",
      0.04
    ],
    [
      "dire",
      0.04
    ],
    [
      "viser",
      0.0325
    ],
    [
      "rever",
      0.0325
    ],
    [
      "revendiquer",
      0.0325
    ],
    [
      "donner",
      0.0325
    ],
    [
      "briguer",
      0.0325
    ],
    [
      "assurer",
      0.0325
    ],
    [
      "aspirer",
      0.0325
    ],
    [
      "avancer",
      0.025
    ],
    [
      "demander",
      0.025
    ],
    [
      "soutenir",
      0.025
    ],
    [
      "tendre",
      0.02
    ],
    [
      "poursuivre",
      0.02
    ],
    [
      "jurer",
      0.02
    ],
    [
      "exiger",
      0.02
    ],
    [
      "soupirer",
      0.0125
    ],
    [
      "simuler",
      0.0125
    ],
    [
      "lorgner",
      0.0125
    ],
    [
      "garantir",
      0.0125
    ],
    [
      "faire",
      0.0125
    ],
    [
      "alleguer",
      0.0125
    ],
    [
      "affecter",
      0.0125
    ],
    [
      "reclamer",
      0.005
    ],
    [
      "raconter",
      0.005
    ],
    [
      "presumer",
      0.005
    ],
    [
      "insinuer",
      0.005
    ],
    [
      "entendre",
      0.005
    ],
    [
      "endosser",
      0.005
    ],
    [
      "declarer",
      0.005
    ]
  ],
  "pont": [
    [
      "bordage",
      0.085
    ],
    [
      "ponceau",
      0.085
    ],
    [
      "passerelle",
      0.04
    ],
    [
      "pontil",
      0.04
    ],
    [
      "spardeck",
      0.04
    ],
    [
      "superstructure",
      0.04
    ],
    [
      "tillac",
      0.04
    ],
    [
      "transition",
      0.04
    ],
    [
      "vacances",
      0.04
    ],
    [
      "viaduc",
      0.04
    ],
    [
      "passavant",
      0.04
    ],
    [
      "intermediaire",
      0.04
    ],
    [
      "appontement",
      0.04
    ],
    [
      "aqueduc",
      0.04
    ],
    [
      "bau",
      0.04
    ],
    [
      "borde",
      0.04
    ],
    [
      "desmosome",
      0.04
    ],
    [
      "dunette",
      0.04
    ],
    [
      "embelle",
      0.04
    ],
    [
      "gaillard",
      0.04
    ],
    [
      "wharf",
      0.04
    ]
  ],
  "succes": [
    [
      "bonheur",
      0.08
    ],
    [
      "triomphe",
      0.0675
    ],
    [
      "avantage",
      0.0575
    ],
    [
      "bien",
      0.045
    ],
    [
      "chance",
      0.045
    ],
    [
      "reussite",
      0.045
    ],
    [
      "victoire",
      0.045
    ],
    [
      "prosperite",
      0.0325
    ],
    [
      "honneur",
      0.0325
    ],
    [
      "gloire",
      0.0325
    ],
    [
      "fortune",
      0.0325
    ],
    [
      "exploit",
      0.0325
    ],
    [
      "evenement",
      0.0225
    ],
    [
      "vogue",
      0.0225
    ],
    [
      "tour",
      0.0225
    ],
    [
      "resultat",
      0.0225
    ],
    [
      "issue",
      0.0225
    ],
    [
      "gain",
      0.0225
    ],
    [
      "benediction",
      0.0225
    ],
    [
      "celebrite",
      0.0225
    ],
    [
      "enthousiasme",
      0.0225
    ],
    [
      "fureur",
      0.0225
    ],
    [
      "trophee",
      0.01
    ],
    [
      "retentissement",
      0.01
    ],
    [
      "prouesse",
      0.01
    ],
    [
      "performance",
      0.01
    ],
    [
      "mode",
      0.01
    ],
    [
      "malheur",
      0.01
    ],
    [
      "lauriers",
      0.01
    ],
    [
      "boum",
      0.01
    ],
    [
      "bis",
      0.01
    ],
    [
      "tube",
      0.01
    ]
  ],
  "accorder": [
    [
      "adapter",
      0.07
    ],
    [
      "reunir",
      0.05
    ],
    [
      "donner",
      0.0475
    ],
    [
      "accommoder",
      0.0375
    ],
    [
      "ajuster",
      0.0375
    ],
    [
      "arranger",
      0.035
    ],
    [
      "harmoniser",
      0.0325
    ],
    [
      "assembler",
      0.0325
    ],
    [
      "attribuer",
      0.03
    ],
    [
      "concilier",
      0.03
    ],
    [
      "joindre",
      0.025
    ],
    [
      "disposer",
      0.025
    ],
    [
      "combiner",
      0.025
    ],
    [
      "allier",
      0.025
    ],
    [
      "agencer",
      0.02
    ],
    [
      "assortir",
      0.0175
    ],
    [
      "admettre",
      0.0175
    ],
    [
      "conceder",
      0.0175
    ],
    [
      "consentir",
      0.0175
    ],
    [
      "permettre",
      0.0175
    ],
    [
      "rapprocher",
      0.015
    ],
    [
      "associer",
      0.015
    ],
    [
      "appareiller",
      0.015
    ],
    [
      "allouer",
      0.0125
    ],
    [
      "attacher",
      0.0125
    ],
    [
      "octroyer",
      0.0125
    ],
    [
      "tolerer",
      0.01
    ],
    [
      "regler",
      0.01
    ],
    [
      "reconnaitre",
      0.01
    ],
    [
      "convenir",
      0.01
    ],
    [
      "conformer",
      0.01
    ],
    [
      "remettre",
      0.0075
    ],
    [
      "preter",
      0.0075
    ],
    [
      "lier",
      0.0075
    ],
    [
      "ceder",
      0.0075
    ],
    [
      "reconcilier",
      0.0075
    ],
    [
      "rattacher",
      0.0075
    ],
    [
      "gratifier",
      0.0075
    ],
    [
      "avouer",
      0.0075
    ],
    [
      "autoriser",
      0.0075
    ],
    [
      "approprier",
      0.0075
    ],
    [
      "appliquer",
      0.0075
    ],
    [
      "apparier",
      0.0075
    ],
    [
      "amenager",
      0.0075
    ],
    [
      "adjuger",
      0.0075
    ],
    [
      "proportionner",
      0.005
    ],
    [
      "dispenser",
      0.005
    ],
    [
      "avancer",
      0.005
    ],
    [
      "appreter",
      0.005
    ],
    [
      "abandonner",
      0.005
    ],
    [
      "satisfaire",
      0.0025
    ],
    [
      "repandre",
      0.0025
    ],
    [
      "rythmer",
      0.0025
    ],
    [
      "raccommoder",
      0.0025
    ],
    [
      "lacher",
      0.0025
    ],
    [
      "decerner",
      0.0025
    ],
    [
      "doter",
      0.0025
    ],
    [
      "consacrer",
      0.0025
    ],
    [
      "cadencer",
      0.0025
    ],
    [
      "apparenter",
      0.0025
    ],
    [
      "aligner",
      0.0025
    ],
    [
      "offrir",
      0.0
    ],
    [
      "prodiguer",
      0.0
    ],
    [
      "rappareiller",
      0.0
    ],
    [
      "rassembler",
      0.0
    ],
    [
      "installer",
      0.0
    ],
    [
      "impartir",
      0.0
    ],
    [
      "goupiller",
      0.0
    ],
    [
      "favoriser",
      0.0
    ],
    [
      "exaucer",
      0.0
    ],
    [
      "confesser",
      0.0
    ],
    [
      "benir",
      0.0
    ],
    [
      "arbitrer",
      0.0
    ],
    [
      "equilibrer",
      0.0
    ]
  ],
  "route": [
    [
      "chemin",
      0.185
    ],
    [
      "voie",
      0.155
    ],
    [
      "trajet",
      0.1
    ],
    [
      "parcours",
      0.055
    ],
    [
      "itineraire",
      0.0425
    ],
    [
      "direction",
      0.0425
    ],
    [
      "chaussee",
      0.0425
    ],
    [
      "avenue",
      0.0425
    ],
    [
      "voyage",
      0.0275
    ],
    [
      "sentier",
      0.0275
    ],
    [
      "ligne",
      0.0275
    ],
    [
      "cours",
      0.0275
    ],
    [
      "trimard",
      0.0125
    ],
    [
      "transport",
      0.0125
    ],
    [
      "sens",
      0.0125
    ],
    [
      "ruban",
      0.0125
    ],
    [
      "pave",
      0.0125
    ],
    [
      "laie",
      0.0125
    ],
    [
      "estrade",
      0.0125
    ],
    [
      "distance",
      0.0125
    ],
    [
      "couloir",
      0.0125
    ],
    [
      "bordee",
      0.0125
    ],
    [
      "autostrade",
      0.0125
    ],
    [
      "autoroute",
      0.0125
    ],
    [
      "asphalte",
      0.0125
    ],
    [
      "artere",
      0.0125
    ],
    [
      "etape",
      0.0125
    ]
  ],
  "indiquer": [
    [
      "reveler",
      0.115
    ],
    [
      "montrer",
      0.09
    ],
    [
      "signaler",
      0.0675
    ],
    [
      "dire",
      0.0475
    ],
    [
      "annoncer",
      0.0475
    ],
    [
      "signifier",
      0.045
    ],
    [
      "marquer",
      0.035
    ],
    [
      "declarer",
      0.035
    ],
    [
      "manifester",
      0.0275
    ],
    [
      "expliquer",
      0.025
    ],
    [
      "denoncer",
      0.025
    ],
    [
      "trahir",
      0.0225
    ],
    [
      "apprendre",
      0.02
    ],
    [
      "communiquer",
      0.02
    ],
    [
      "exposer",
      0.02
    ],
    [
      "afficher",
      0.0175
    ],
    [
      "devoiler",
      0.015
    ],
    [
      "designer",
      0.015
    ],
    [
      "temoigner",
      0.015
    ],
    [
      "donner",
      0.015
    ],
    [
      "prouver",
      0.015
    ],
    [
      "nommer",
      0.0125
    ],
    [
      "decouvrir",
      0.0125
    ],
    [
      "denoter",
      0.01
    ],
    [
      "determiner",
      0.01
    ],
    [
      "enseigner",
      0.0075
    ],
    [
      "representer",
      0.0075
    ],
    [
      "avertir",
      0.005
    ],
    [
      "tracer",
      0.005
    ],
    [
      "specifier",
      0.005
    ],
    [
      "demontrer",
      0.005
    ],
    [
      "deceler",
      0.005
    ],
    [
      "accuser",
      0.005
    ],
    [
      "enoncer",
      0.0025
    ],
    [
      "preciser",
      0.0025
    ],
    [
      "porter",
      0.0025
    ],
    [
      "mentionner",
      0.0025
    ],
    [
      "fixer",
      0.0025
    ],
    [
      "divulguer",
      0.0025
    ],
    [
      "dessiner",
      0.0025
    ],
    [
      "citer",
      0.0025
    ],
    [
      "attester",
      0.0025
    ],
    [
      "assigner",
      0.0025
    ],
    [
      "inscrire",
      0.0025
    ],
    [
      "enumerer",
      0.0025
    ],
    [
      "definir",
      0.0025
    ],
    [
      "caracteriser",
      0.0025
    ],
    [
      "etiqueter",
      0.0
    ],
    [
      "supposer",
      0.0
    ],
    [
      "refleter",
      0.0
    ],
    [
      "presager",
      0.0
    ],
    [
      "guider",
      0.0
    ],
    [
      "figurer",
      0.0
    ],
    [
      "denommer",
      0.0
    ],
    [
      "baliser",
      0.0
    ],
    [
      "ebaucher",
      0.0
    ],
    [
      "sentir",
      0.0
    ],
    [
      "prescrire",
      0.0
    ],
    [
      "ponctuer",
      0.0
    ],
    [
      "fournir",
      0.0
    ],
    [
      "esquisser",
      0.0
    ],
    [
      "crayonner",
      0.0
    ]
  ],
  "troquer": [
    [
      "echanger",
      0.4425
    ],
    [
      "brocanter",
      0.11
    ],
    [
      "changer",
      0.11
    ],
    [
      "donner",
      0.11
    ],
    [
      "interchanger",
      0.11
    ],
    [
      "remplacer",
      0.11
    ]
  ],
  "contre": [
    [
      "vers",
      0.155
    ],
    [
      "sur",
      0.075
    ],
    [
      "pres",
      0.075
    ],
    [
      "oppose",
      0.075
    ],
    [
      "aupres",
      0.075
    ],
    [
      "a",
      0.0375
    ],
    [
      "parade",
      0.0375
    ],
    [
      "nonobstant",
      0.0375
    ],
    [
      "moyennant",
      0.0375
    ],
    [
      "malgre",
      0.0375
    ],
    [
      "ici",
      0.0375
    ]
  ],
  "contrer": [
    [
      "contrecarrer",
      0.5
    ],
    [
      "surcontrer",
      0.5
    ]
  ],
  "disque": [
    [
      "refrain",
      0.3325
    ],
    [
      "cercle",
      0.11
    ],
    [
      "guitare",
      0.11
    ],
    [
      "musique",
      0.11
    ],
    [
      "palet",
      0.11
    ],
    [
      "ritournelle",
      0.11
    ],
    [
      "rond",
      0.11
    ]
  ],
  "platine": [
    [
      "faconde",
      0.1575
    ],
    [
      "bagou",
      0.105
    ],
    [
      "loquacite",
      0.105
    ],
    [
      "volubilite",
      0.105
    ],
    [
      "eloquence",
      0.105
    ],
    [
      "prolixite",
      0.05
    ],
    [
      "plateau",
      0.05
    ],
    [
      "obturateur",
      0.05
    ],
    [
      "langue",
      0.05
    ],
    [
      "blanc",
      0.05
    ],
    [
      "baratin",
      0.05
    ],
    [
      "electrophone",
      0.05
    ]
  ],
  "tot": [
    [
      "rapidement",
      0.1575
    ],
    [
      "vite",
      0.1575
    ],
    [
      "promptement",
      0.105
    ],
    [
      "vitement",
      0.0525
    ],
    [
      "premature",
      0.0525
    ],
    [
      "matinal",
      0.0525
    ],
    [
      "matin",
      0.0525
    ],
    [
      "bientot",
      0.0525
    ],
    [
      "aussitot",
      0.0525
    ]
  ],
  "tard": [
    [
      "avant",
      0.3325
    ],
    [
      "loin",
      0.3325
    ],
    [
      "tardivement",
      0.3325
    ]
  ],
  "public": [
    [
      "auditoire",
      0.055
    ],
    [
      "commun",
      0.0475
    ],
    [
      "foule",
      0.0475
    ],
    [
      "officiel",
      0.0475
    ],
    [
      "notoire",
      0.04
    ],
    [
      "monde",
      0.035
    ],
    [
      "galerie",
      0.035
    ],
    [
      "connu",
      0.035
    ],
    [
      "evident",
      0.0275
    ],
    [
      "peuple",
      0.0275
    ],
    [
      "manifeste",
      0.0275
    ],
    [
      "assistance",
      0.0275
    ],
    [
      "spectateur",
      0.02
    ],
    [
      "societe",
      0.02
    ],
    [
      "publie",
      0.02
    ],
    [
      "populaire",
      0.02
    ],
    [
      "patent",
      0.02
    ],
    [
      "masse",
      0.02
    ],
    [
      "auditeur",
      0.02
    ],
    [
      "assemblee",
      0.02
    ],
    [
      "reconnu",
      0.0125
    ],
    [
      "renomme",
      0.0125
    ],
    [
      "repandu",
      0.0125
    ],
    [
      "revele",
      0.0125
    ],
    [
      "salle",
      0.0125
    ],
    [
      "solennel",
      0.0125
    ],
    [
      "ouvert",
      0.0125
    ],
    [
      "multitude",
      0.0125
    ],
    [
      "general",
      0.0125
    ],
    [
      "affiche",
      0.0125
    ],
    [
      "authentique",
      0.0125
    ],
    [
      "collectif",
      0.0125
    ],
    [
      "communique",
      0.0125
    ],
    [
      "celebre",
      0.0125
    ],
    [
      "gens",
      0.0125
    ],
    [
      "national",
      0.005
    ],
    [
      "nationalise",
      0.005
    ],
    [
      "opinion",
      0.005
    ],
    [
      "ostensible",
      0.005
    ],
    [
      "parterre",
      0.005
    ],
    [
      "politique",
      0.005
    ],
    [
      "propage",
      0.005
    ],
    [
      "spectateurs",
      0.005
    ],
    [
      "universel",
      0.005
    ],
    [
      "vicinal",
      0.005
    ],
    [
      "vulgarise",
      0.005
    ],
    [
      "frequente",
      0.005
    ],
    [
      "expose",
      0.005
    ],
    [
      "administratif",
      0.005
    ],
    [
      "annonce",
      0.005
    ],
    [
      "audience",
      0.005
    ],
    [
      "banal",
      0.005
    ],
    [
      "chambree",
      0.005
    ],
    [
      "clientele",
      0.005
    ],
    [
      "colporte",
      0.005
    ],
    [
      "communal",
      0.005
    ],
    [
      "communautaire",
      0.005
    ],
    [
      "divulgue",
      0.005
    ],
    [
      "devoile",
      0.005
    ],
    [
      "ebruite",
      0.005
    ]
  ],
  "pietiner": [
    [
      "fouler",
      0.105
    ],
    [
      "languir",
      0.105
    ],
    [
      "piaffer",
      0.105
    ],
    [
      "trepigner",
      0.105
    ],
    [
      "transgresser",
      0.0525
    ],
    [
      "stagner",
      0.0525
    ],
    [
      "s'agiter",
      0.0525
    ],
    [
      "patauger",
      0.0525
    ],
    [
      "marcher",
      0.0525
    ],
    [
      "froisser",
      0.0525
    ],
    [
      "enfreindre",
      0.0525
    ],
    [
      "contrevenir",
      0.0525
    ],
    [
      "vegeter",
      0.0525
    ]
  ],
  "cran": [
    [
      "fermete",
      0.125
    ],
    [
      "courage",
      0.115
    ],
    [
      "solidite",
      0.08
    ],
    [
      "ressort",
      0.07
    ],
    [
      "assurance",
      0.0625
    ],
    [
      "energie",
      0.0525
    ],
    [
      "volonte",
      0.0525
    ],
    [
      "decision",
      0.0525
    ],
    [
      "audace",
      0.0525
    ],
    [
      "force",
      0.035
    ],
    [
      "resolution",
      0.035
    ],
    [
      "culot",
      0.025
    ],
    [
      "determination",
      0.025
    ],
    [
      "surete",
      0.015
    ],
    [
      "fond",
      0.015
    ],
    [
      "estomac",
      0.015
    ],
    [
      "arret",
      0.015
    ],
    [
      "resistance",
      0.0075
    ],
    [
      "ressource",
      0.0075
    ],
    [
      "rainure",
      0.0075
    ],
    [
      "ondulation",
      0.0075
    ],
    [
      "entaille",
      0.0075
    ],
    [
      "encoche",
      0.0075
    ],
    [
      "declic",
      0.0075
    ],
    [
      "dent",
      0.0075
    ],
    [
      "degre",
      0.0075
    ],
    [
      "coche",
      0.0075
    ],
    [
      "boucle",
      0.0075
    ],
    [
      "vaillance",
      0.0075
    ]
  ],
  "taler": [
    [
      "meurtrir",
      0.23
    ],
    [
      "tourmenter",
      0.23
    ],
    [
      "torturer",
      0.1525
    ],
    [
      "assieger",
      0.075
    ],
    [
      "cotir",
      0.075
    ],
    [
      "fouler",
      0.075
    ],
    [
      "talonner",
      0.075
    ],
    [
      "tenailler",
      0.075
    ]
  ],
  "talent": [
    [
      "disposition",
      0.0975
    ],
    [
      "capacite",
      0.0825
    ],
    [
      "aptitude",
      0.055
    ],
    [
      "don",
      0.05
    ],
    [
      "genie",
      0.05
    ],
    [
      "penchant",
      0.0475
    ],
    [
      "adresse",
      0.0475
    ],
    [
      "habilete",
      0.04
    ],
    [
      "facilite",
      0.0325
    ],
    [
      "esprit",
      0.03
    ],
    [
      "faculte",
      0.03
    ],
    [
      "tendance",
      0.03
    ],
    [
      "inclination",
      0.025
    ],
    [
      "art",
      0.02
    ],
    [
      "chic",
      0.02
    ],
    [
      "instinct",
      0.02
    ],
    [
      "propension",
      0.02
    ],
    [
      "qualite",
      0.02
    ],
    [
      "vocation",
      0.0175
    ],
    [
      "gout",
      0.0175
    ],
    [
      "force",
      0.0175
    ],
    [
      "vertu",
      0.0125
    ],
    [
      "merite",
      0.0125
    ],
    [
      "dexterite",
      0.0125
    ],
    [
      "classe",
      0.0125
    ],
    [
      "brio",
      0.0125
    ],
    [
      "sentiment",
      0.01
    ],
    [
      "predisposition",
      0.01
    ],
    [
      "ingeniosite",
      0.01
    ],
    [
      "industrie",
      0.01
    ],
    [
      "distinction",
      0.01
    ],
    [
      "aisance",
      0.01
    ],
    [
      "etoffe",
      0.005
    ],
    [
      "virtuosite",
      0.005
    ],
    [
      "style",
      0.005
    ],
    [
      "inspiration",
      0.005
    ],
    [
      "avantage",
      0.005
    ],
    [
      "bosse",
      0.0025
    ],
    [
      "entendement",
      0.0025
    ],
    [
      "fibre",
      0.0025
    ],
    [
      "moyens",
      0.0025
    ],
    [
      "poids",
      0.0025
    ]
  ],
  "capture": [
    [
      "prise",
      0.2625
    ],
    [
      "butin",
      0.21
    ],
    [
      "saisie",
      0.1025
    ],
    [
      "rapine",
      0.05
    ],
    [
      "proie",
      0.05
    ],
    [
      "ferrement",
      0.05
    ],
    [
      "conquete",
      0.05
    ],
    [
      "confiscation",
      0.05
    ],
    [
      "arrestation",
      0.05
    ],
    [
      "trophee",
      0.05
    ]
  ],
  "capturer": [
    [
      "prendre",
      0.16
    ],
    [
      "attraper",
      0.1425
    ],
    [
      "s'emparer",
      0.105
    ],
    [
      "saisir",
      0.105
    ],
    [
      "capter",
      0.0875
    ],
    [
      "accrocher",
      0.07
    ],
    [
      "arreter",
      0.07
    ],
    [
      "ramasser",
      0.0525
    ],
    [
      "asservir",
      0.035
    ],
    [
      "s'approprier",
      0.035
    ],
    [
      "soumettre",
      0.035
    ],
    [
      "seduire",
      0.035
    ],
    [
      "avoir",
      0.015
    ],
    [
      "ferrer",
      0.015
    ]
  ],
  "image": [
    [
      "figure",
      0.08
    ],
    [
      "representation",
      0.0575
    ],
    [
      "portrait",
      0.05
    ],
    [
      "dessin",
      0.04
    ],
    [
      "tableau",
      0.025
    ],
    [
      "idee",
      0.025
    ],
    [
      "apparence",
      0.025
    ],
    [
      "peinture",
      0.0225
    ],
    [
      "symbole",
      0.0225
    ],
    [
      "vision",
      0.0225
    ],
    [
      "visage",
      0.0175
    ],
    [
      "ombre",
      0.0175
    ],
    [
      "modele",
      0.0175
    ],
    [
      "expression",
      0.015
    ],
    [
      "gravure",
      0.015
    ],
    [
      "imitation",
      0.015
    ],
    [
      "vue",
      0.015
    ],
    [
      "simulacre",
      0.015
    ],
    [
      "illustration",
      0.015
    ],
    [
      "forme",
      0.015
    ],
    [
      "type",
      0.0125
    ],
    [
      "sculpture",
      0.0125
    ],
    [
      "ressemblance",
      0.0125
    ],
    [
      "reproduction",
      0.0125
    ],
    [
      "plan",
      0.0125
    ],
    [
      "illusion",
      0.0125
    ],
    [
      "effigie",
      0.0125
    ],
    [
      "allegorie",
      0.0125
    ],
    [
      "semblance",
      0.01
    ],
    [
      "impression",
      0.01
    ],
    [
      "graphique",
      0.01
    ],
    [
      "exemple",
      0.01
    ],
    [
      "croquis",
      0.01
    ],
    [
      "comparaison",
      0.01
    ],
    [
      "tete",
      0.0075
    ],
    [
      "statue",
      0.0075
    ],
    [
      "signe",
      0.0075
    ],
    [
      "schema",
      0.0075
    ],
    [
      "replique",
      0.0075
    ],
    [
      "nu",
      0.0075
    ],
    [
      "caricature",
      0.0075
    ],
    [
      "photographie",
      0.005
    ],
    [
      "reflet",
      0.005
    ],
    [
      "souvenir",
      0.005
    ],
    [
      "trace",
      0.005
    ],
    [
      "echantillon",
      0.005
    ],
    [
      "echo",
      0.005
    ],
    [
      "photo",
      0.005
    ],
    [
      "metaphore",
      0.005
    ],
    [
      "mirage",
      0.005
    ],
    [
      "cliche",
      0.005
    ],
    [
      "description",
      0.005
    ],
    [
      "estampe",
      0.005
    ],
    [
      "figuration",
      0.005
    ],
    [
      "figurine",
      0.005
    ],
    [
      "miniature",
      0.005
    ],
    [
      "miroir",
      0.0025
    ],
    [
      "parabole",
      0.0025
    ],
    [
      "perception",
      0.0025
    ],
    [
      "reve",
      0.0025
    ],
    [
      "reverie",
      0.0025
    ],
    [
      "statuette",
      0.0025
    ],
    [
      "sepia",
      0.0025
    ],
    [
      "vignette",
      0.0025
    ],
    [
      "manifestation",
      0.0025
    ],
    [
      "lithographie",
      0.0025
    ],
    [
      "aquarelle",
      0.0025
    ],
    [
      "buste",
      0.0025
    ],
    [
      "face",
      0.0025
    ],
    [
      "fetiche",
      0.0025
    ],
    [
      "gouache",
      0.0025
    ],
    [
      "incarnation",
      0.0025
    ],
    [
      "litho",
      0.0025
    ],
    [
      "heliogravure",
      0.0
    ],
    [
      "icone",
      0.0
    ],
    [
      "medaillon",
      0.0
    ],
    [
      "metonymie",
      0.0
    ],
    [
      "planche",
      0.0
    ],
    [
      "reminiscence",
      0.0
    ],
    [
      "fresque",
      0.0
    ],
    [
      "fantasme",
      0.0
    ],
    [
      "enseigne",
      0.0
    ],
    [
      "embleme",
      0.0
    ],
    [
      "decalcomanie",
      0.0
    ],
    [
      "chromo",
      0.0
    ],
    [
      "bosse",
      0.0
    ],
    [
      "aquatinte",
      0.0
    ],
    [
      "application",
      0.0
    ],
    [
      "specimen",
      0.0
    ]
  ],
  "imager": [
    [
      "orner",
      0.1925
    ],
    [
      "embellir",
      0.1325
    ],
    [
      "parer",
      0.1325
    ],
    [
      "enjoliver",
      0.0825
    ],
    [
      "enrichir",
      0.07
    ],
    [
      "agrementer",
      0.06
    ],
    [
      "colorer",
      0.035
    ],
    [
      "decorer",
      0.035
    ],
    [
      "garnir",
      0.035
    ],
    [
      "egayer",
      0.0225
    ],
    [
      "rehausser",
      0.0225
    ],
    [
      "ornementer",
      0.0225
    ],
    [
      "historier",
      0.0225
    ],
    [
      "farder",
      0.0225
    ],
    [
      "sculpter",
      0.01
    ],
    [
      "fleurir",
      0.01
    ],
    [
      "fignoler",
      0.01
    ],
    [
      "enluminer",
      0.01
    ],
    [
      "broder",
      0.01
    ],
    [
      "ajouter",
      0.01
    ],
    [
      "adorner",
      0.01
    ],
    [
      "emailler",
      0.01
    ]
  ],
  "douter": [
    [
      "hesiter",
      0.1425
    ],
    [
      "soupconner",
      0.1425
    ],
    [
      "pressentir",
      0.07
    ],
    [
      "discuter",
      0.07
    ],
    [
      "contester",
      0.07
    ],
    [
      "balancer",
      0.07
    ],
    [
      "tergiverser",
      0.07
    ]
  ],
  "daron": [
    [
      "dab",
      0.3325
    ],
    [
      "patron",
      0.3325
    ],
    [
      "pere",
      0.3325
    ]
  ],
  "peter": [
    [
      "craquer",
      0.1075
    ],
    [
      "rompre",
      0.1075
    ],
    [
      "eclater",
      0.1075
    ],
    [
      "crever",
      0.0825
    ],
    [
      "echouer",
      0.0825
    ],
    [
      "rater",
      0.0525
    ],
    [
      "petiller",
      0.0525
    ],
    [
      "casser",
      0.0525
    ],
    [
      "venter",
      0.025
    ],
    [
      "sauter",
      0.025
    ],
    [
      "prouter",
      0.025
    ],
    [
      "louper",
      0.025
    ],
    [
      "gueuler",
      0.025
    ],
    [
      "exploser",
      0.025
    ],
    [
      "debourrer",
      0.025
    ],
    [
      "vesser",
      0.025
    ]
  ],
  "pete": [
    [
      "craquer",
      0.1075
    ],
    [
      "rompre",
      0.1075
    ],
    [
      "eclater",
      0.1075
    ],
    [
      "crever",
      0.0825
    ],
    [
      "echouer",
      0.0825
    ],
    [
      "rater",
      0.0525
    ],
    [
      "petiller",
      0.0525
    ],
    [
      "casser",
      0.0525
    ],
    [
      "venter",
      0.025
    ],
    [
      "sauter",
      0.025
    ],
    [
      "prouter",
      0.025
    ],
    [
      "louper",
      0.025
    ],
    [
      "gueuler",
      0.025
    ],
    [
      "exploser",
      0.025
    ],
    [
      "debourrer",
      0.025
    ],
    [
      "vesser",
      0.025
    ]
  ],
  "plomb": [
    [
      "balle",
      0.1425
    ],
    [
      "cendree",
      0.095
    ],
    [
      "sceau",
      0.0475
    ],
    [
      "saturne",
      0.0475
    ],
    [
      "pruneau",
      0.0475
    ],
    [
      "prison",
      0.0475
    ],
    [
      "menuise",
      0.0475
    ],
    [
      "lest",
      0.0475
    ],
    [
      "grenaille",
      0.0475
    ],
    [
      "fusible",
      0.0475
    ],
    [
      "dragee",
      0.0475
    ],
    [
      "chevrotine",
      0.0475
    ],
    [
      "charge",
      0.0475
    ],
    [
      "cendre",
      0.0475
    ],
    [
      "caractere",
      0.0475
    ],
    [
      "boulette",
      0.0475
    ],
    [
      "scelle",
      0.0475
    ]
  ],
  "ecole": [
    [
      "groupe",
      0.0775
    ],
    [
      "lycee",
      0.0775
    ],
    [
      "college",
      0.055
    ],
    [
      "cours",
      0.055
    ],
    [
      "institut",
      0.055
    ],
    [
      "institution",
      0.055
    ],
    [
      "cenacle",
      0.0375
    ],
    [
      "coterie",
      0.0375
    ],
    [
      "academie",
      0.03
    ],
    [
      "boite",
      0.03
    ],
    [
      "etablissement",
      0.0225
    ],
    [
      "tendance",
      0.0225
    ],
    [
      "seminaire",
      0.0225
    ],
    [
      "systeme",
      0.0225
    ],
    [
      "reunion",
      0.0225
    ],
    [
      "philosophie",
      0.0225
    ],
    [
      "pension",
      0.0225
    ],
    [
      "famille",
      0.0225
    ],
    [
      "doctrine",
      0.0225
    ],
    [
      "colonie",
      0.0225
    ],
    [
      "cercle",
      0.0225
    ],
    [
      "secte",
      0.015
    ],
    [
      "mouvement",
      0.015
    ],
    [
      "lecon",
      0.015
    ],
    [
      "gymnase",
      0.015
    ],
    [
      "classe",
      0.015
    ],
    [
      "chapelle",
      0.015
    ],
    [
      "bahut",
      0.015
    ],
    [
      "maternelle",
      0.0075
    ],
    [
      "orthodoxie",
      0.0075
    ],
    [
      "pleiade",
      0.0075
    ],
    [
      "pepiniere",
      0.0075
    ],
    [
      "universite",
      0.0075
    ],
    [
      "manecanterie",
      0.0075
    ],
    [
      "faculte",
      0.0075
    ],
    [
      "conservatoire",
      0.0075
    ],
    [
      "club",
      0.0075
    ],
    [
      "centre",
      0.0075
    ],
    [
      "bazar",
      0.0075
    ],
    [
      "autorite",
      0.0075
    ],
    [
      "etudes",
      0.0075
    ]
  ],
  "direction": [
    [
      "conduite",
      0.0725
    ],
    [
      "administration",
      0.0675
    ],
    [
      "gouvernement",
      0.0475
    ],
    [
      "autorite",
      0.04
    ],
    [
      "gestion",
      0.04
    ],
    [
      "ligne",
      0.04
    ],
    [
      "voie",
      0.0275
    ],
    [
      "sens",
      0.0275
    ],
    [
      "ordre",
      0.0275
    ],
    [
      "commandement",
      0.0275
    ],
    [
      "tete",
      0.0225
    ],
    [
      "tutelle",
      0.0225
    ],
    [
      "tournure",
      0.0225
    ],
    [
      "orientation",
      0.0225
    ],
    [
      "organisation",
      0.0225
    ],
    [
      "marche",
      0.0225
    ],
    [
      "trajet",
      0.0175
    ],
    [
      "tour",
      0.0175
    ],
    [
      "tenue",
      0.0175
    ],
    [
      "route",
      0.0175
    ],
    [
      "influence",
      0.0175
    ],
    [
      "gouvernail",
      0.0175
    ],
    [
      "chemin",
      0.0175
    ],
    [
      "axe",
      0.0175
    ],
    [
      "regime",
      0.01
    ],
    [
      "service",
      0.01
    ],
    [
      "surveillance",
      0.01
    ],
    [
      "tendance",
      0.01
    ],
    [
      "reglement",
      0.01
    ],
    [
      "presidence",
      0.01
    ],
    [
      "pilotage",
      0.01
    ],
    [
      "auspice",
      0.01
    ],
    [
      "cote",
      0.01
    ],
    [
      "gouvernance",
      0.01
    ],
    [
      "hegemonie",
      0.01
    ],
    [
      "leadership",
      0.01
    ],
    [
      "intendance",
      0.005
    ],
    [
      "management",
      0.005
    ],
    [
      "maniement",
      0.005
    ],
    [
      "regie",
      0.005
    ],
    [
      "siege",
      0.005
    ],
    [
      "supervision",
      0.005
    ],
    [
      "timon",
      0.005
    ],
    [
      "vecteur",
      0.005
    ],
    [
      "instruction",
      0.005
    ],
    [
      "ferule",
      0.005
    ],
    [
      "directorat",
      0.005
    ],
    [
      "animation",
      0.005
    ],
    [
      "attrait",
      0.005
    ],
    [
      "azimut",
      0.005
    ],
    [
      "boussole",
      0.005
    ],
    [
      "bureau",
      0.005
    ],
    [
      "but",
      0.005
    ],
    [
      "cap",
      0.005
    ],
    [
      "destination",
      0.005
    ],
    [
      "directive",
      0.005
    ],
    [
      "volant",
      0.005
    ]
  ],
  "baisser": [
    [
      "coucher",
      0.5
    ],
    [
      "tombee",
      0.5
    ]
  ],
  "faible": [
    [
      "petit",
      0.045
    ],
    [
      "mediocre",
      0.035
    ],
    [
      "insignifiant",
      0.0275
    ],
    [
      "debile",
      0.0275
    ],
    [
      "fragile",
      0.0275
    ],
    [
      "pauvre",
      0.025
    ],
    [
      "mou",
      0.025
    ],
    [
      "chetif",
      0.0225
    ],
    [
      "maigre",
      0.02
    ],
    [
      "mince",
      0.02
    ],
    [
      "mechant",
      0.0175
    ],
    [
      "delicat",
      0.015
    ],
    [
      "leger",
      0.015
    ],
    [
      "mauvais",
      0.015
    ],
    [
      "modeste",
      0.015
    ],
    [
      "modique",
      0.015
    ],
    [
      "insuffisant",
      0.0125
    ],
    [
      "pietre",
      0.0125
    ],
    [
      "doux",
      0.0125
    ],
    [
      "inconsistant",
      0.01
    ],
    [
      "caduc",
      0.01
    ],
    [
      "anemie",
      0.01
    ],
    [
      "chancelant",
      0.0075
    ],
    [
      "gout",
      0.0075
    ],
    [
      "pale",
      0.0075
    ],
    [
      "penchant",
      0.0075
    ],
    [
      "negligeable",
      0.0075
    ],
    [
      "malingre",
      0.0075
    ],
    [
      "impuissant",
      0.0075
    ],
    [
      "faiblesse",
      0.0075
    ],
    [
      "facile",
      0.0075
    ],
    [
      "deficient",
      0.0075
    ],
    [
      "nul",
      0.0075
    ],
    [
      "languissant",
      0.0075
    ],
    [
      "inclination",
      0.0075
    ],
    [
      "incertain",
      0.0075
    ],
    [
      "fatigue",
      0.0075
    ],
    [
      "derisoire",
      0.0075
    ],
    [
      "anemique",
      0.0075
    ],
    [
      "tendre",
      0.005
    ],
    [
      "reduit",
      0.005
    ],
    [
      "precaire",
      0.005
    ],
    [
      "minime",
      0.005
    ],
    [
      "malheureux",
      0.005
    ],
    [
      "instable",
      0.005
    ],
    [
      "grele",
      0.005
    ],
    [
      "gringalet",
      0.005
    ],
    [
      "frele",
      0.005
    ],
    [
      "velleitaire",
      0.005
    ],
    [
      "pitoyable",
      0.005
    ],
    [
      "lache",
      0.005
    ],
    [
      "labile",
      0.005
    ],
    [
      "fluet",
      0.005
    ],
    [
      "falot",
      0.005
    ],
    [
      "cacochyme",
      0.005
    ],
    [
      "bon",
      0.005
    ],
    [
      "bas",
      0.005
    ],
    [
      "affaibli",
      0.005
    ],
    [
      "limite",
      0.0025
    ],
    [
      "maladif",
      0.0025
    ],
    [
      "menu",
      0.0025
    ],
    [
      "passion",
      0.0025
    ],
    [
      "simple",
      0.0025
    ],
    [
      "vague",
      0.0025
    ],
    [
      "vice",
      0.0025
    ],
    [
      "invalide",
      0.0025
    ],
    [
      "infirme",
      0.0025
    ],
    [
      "indecis",
      0.0025
    ],
    [
      "abattu",
      0.0025
    ],
    [
      "aboulique",
      0.0025
    ],
    [
      "apathique",
      0.0025
    ],
    [
      "borne",
      0.0025
    ],
    [
      "bouche",
      0.0025
    ],
    [
      "fade",
      0.0025
    ],
    [
      "inconstant",
      0.0025
    ],
    [
      "manie",
      0.0025
    ],
    [
      "minable",
      0.0025
    ],
    [
      "moyen",
      0.0025
    ],
    [
      "preference",
      0.0025
    ],
    [
      "souffreteux",
      0.0025
    ],
    [
      "travers",
      0.0025
    ],
    [
      "vulnerable",
      0.0025
    ],
    [
      "etroit",
      0.0025
    ],
    [
      "malleable",
      0.0025
    ],
    [
      "lymphatique",
      0.0025
    ],
    [
      "lamentable",
      0.0025
    ],
    [
      "aneanti",
      0.0025
    ],
    [
      "bonasse",
      0.0025
    ],
    [
      "branlant",
      0.0025
    ],
    [
      "benin",
      0.0025
    ],
    [
      "casse",
      0.0025
    ],
    [
      "complaisant",
      0.0025
    ],
    [
      "debonnaire",
      0.0025
    ],
    [
      "impotent",
      0.0025
    ],
    [
      "inerte",
      0.0025
    ],
    [
      "influencable",
      0.0025
    ],
    [
      "las",
      0.0025
    ],
    [
      "modere",
      0.0025
    ],
    [
      "rabougri",
      0.0025
    ],
    [
      "sympathie",
      0.0025
    ],
    [
      "veule",
      0.0025
    ],
    [
      "indigent",
      0.0025
    ],
    [
      "imperceptible",
      0.0025
    ],
    [
      "attaquable",
      0.0025
    ],
    [
      "avorton",
      0.0025
    ],
    [
      "coulant",
      0.0025
    ],
    [
      "defaillant",
      0.0025
    ],
    [
      "defaut",
      0.0025
    ],
    [
      "faiblard",
      0.0025
    ],
    [
      "imbecile",
      0.0025
    ],
    [
      "pliant",
      0.0
    ],
    [
      "pente",
      0.0
    ],
    [
      "patraque",
      0.0
    ],
    [
      "obtus",
      0.0
    ],
    [
      "mourant",
      0.0
    ],
    [
      "mollasse",
      0.0
    ],
    [
      "propension",
      0.0
    ],
    [
      "predilection",
      0.0
    ],
    [
      "ramolli",
      0.0
    ],
    [
      "vacillant",
      0.0
    ],
    [
      "volage",
      0.0
    ],
    [
      "ebranlable",
      0.0
    ],
    [
      "epuise",
      0.0
    ],
    [
      "etiole",
      0.0
    ],
    [
      "mauviette",
      0.0
    ],
    [
      "inefficace",
      0.0
    ],
    [
      "accommodant",
      0.0
    ],
    [
      "attirance",
      0.0
    ],
    [
      "bleme",
      0.0
    ],
    [
      "cassant",
      0.0
    ],
    [
      "complaisance",
      0.0
    ],
    [
      "cotonneux",
      0.0
    ],
    [
      "creve",
      0.0
    ],
    [
      "critiquable",
      0.0
    ],
    [
      "difforme",
      0.0
    ],
    [
      "incolore",
      0.0
    ],
    [
      "exsangue",
      0.0
    ],
    [
      "deprime",
      0.0
    ],
    [
      "delie",
      0.0
    ],
    [
      "delabre",
      0.0
    ],
    [
      "douteux",
      0.0
    ],
    [
      "impersonnel",
      0.0
    ],
    [
      "inferiorite",
      0.0
    ],
    [
      "ouate",
      0.0
    ],
    [
      "pusillanime",
      0.0
    ],
    [
      "refutable",
      0.0
    ],
    [
      "titubant",
      0.0
    ],
    [
      "imperfection",
      0.0
    ],
    [
      "freluquet",
      0.0
    ],
    [
      "entrainable",
      0.0
    ],
    [
      "desarme",
      0.0
    ],
    [
      "bleche",
      0.0
    ],
    [
      "asthenique",
      0.0
    ],
    [
      "amour",
      0.0
    ],
    [
      "adynamique",
      0.0
    ],
    [
      "etouffe",
      0.0
    ]
  ],
  "malediction": [
    [
      "malheur",
      0.115
    ],
    [
      "tribulation",
      0.115
    ],
    [
      "infortune",
      0.095
    ],
    [
      "malchance",
      0.095
    ],
    [
      "catastrophe",
      0.0575
    ],
    [
      "calamite",
      0.0575
    ],
    [
      "anatheme",
      0.0575
    ],
    [
      "tuile",
      0.0375
    ],
    [
      "pepin",
      0.0375
    ],
    [
      "imprecation",
      0.0375
    ],
    [
      "fatalite",
      0.0375
    ],
    [
      "condamnation",
      0.0375
    ],
    [
      "blame",
      0.0375
    ],
    [
      "maudissement",
      0.0175
    ],
    [
      "jurement",
      0.0175
    ],
    [
      "fleau",
      0.0175
    ],
    [
      "execration",
      0.0175
    ],
    [
      "excommunication",
      0.0175
    ],
    [
      "deprecation",
      0.0175
    ],
    [
      "damnation",
      0.0175
    ],
    [
      "blaspheme",
      0.0175
    ],
    [
      "reprobation",
      0.0175
    ]
  ],
  "fui": [
    [
      "s'enfuir",
      0.13
    ],
    [
      "partir",
      0.075
    ],
    [
      "disparaitre",
      0.055
    ],
    [
      "filer",
      0.0425
    ],
    [
      "s'echapper",
      0.04
    ],
    [
      "s'eclipser",
      0.0375
    ],
    [
      "s'evader",
      0.0325
    ],
    [
      "deguerpir",
      0.03
    ],
    [
      "echapper",
      0.025
    ],
    [
      "s'envoler",
      0.02
    ],
    [
      "couler",
      0.02
    ],
    [
      "courir",
      0.02
    ],
    [
      "decamper",
      0.02
    ],
    [
      "quitter",
      0.0175
    ],
    [
      "s'ecouler",
      0.015
    ],
    [
      "s'esquiver",
      0.015
    ],
    [
      "passer",
      0.015
    ],
    [
      "abandonner",
      0.01
    ],
    [
      "detaler",
      0.01
    ],
    [
      "eviter",
      0.01
    ],
    [
      "s'evanouir",
      0.0075
    ],
    [
      "s'eloigner",
      0.0075
    ],
    [
      "ceder",
      0.0075
    ],
    [
      "perdre",
      0.0075
    ],
    [
      "reculer",
      0.0075
    ],
    [
      "eluder",
      0.0075
    ],
    [
      "s'enfoncer",
      0.005
    ],
    [
      "deloger",
      0.005
    ],
    [
      "voler",
      0.0025
    ],
    [
      "suinter",
      0.0025
    ],
    [
      "s'exiler",
      0.0025
    ],
    [
      "esquiver",
      0.0025
    ],
    [
      "cavaler",
      0.0025
    ],
    [
      "sourdre",
      0.0025
    ],
    [
      "filtrer",
      0.0025
    ],
    [
      "caleter",
      0.0025
    ],
    [
      "refuir",
      0.0
    ],
    [
      "s'affaisser",
      0.0
    ],
    [
      "s'esbigner",
      0.0
    ],
    [
      "s'escamper",
      0.0
    ],
    [
      "pisser",
      0.0
    ],
    [
      "bannir",
      0.0
    ],
    [
      "defiler",
      0.0
    ],
    [
      "effrayer",
      0.0
    ],
    [
      "hair",
      0.0
    ]
  ],
  "sonnerie": [
    [
      "bruit",
      0.0825
    ],
    [
      "cloche",
      0.0825
    ],
    [
      "timbre",
      0.0825
    ],
    [
      "ton",
      0.0825
    ],
    [
      "generale",
      0.04
    ],
    [
      "hallali",
      0.04
    ],
    [
      "quete",
      0.04
    ],
    [
      "ralliement",
      0.04
    ],
    [
      "rassemblement",
      0.04
    ],
    [
      "retraite",
      0.04
    ],
    [
      "fanfare",
      0.04
    ],
    [
      "debucher",
      0.04
    ],
    [
      "diane",
      0.04
    ],
    [
      "chamade",
      0.04
    ],
    [
      "breloque",
      0.04
    ],
    [
      "avertisseur",
      0.04
    ],
    [
      "appel",
      0.04
    ],
    [
      "reveil",
      0.04
    ]
  ],
  "style": [
    [
      "habituer",
      0.1275
    ],
    [
      "instruire",
      0.115
    ],
    [
      "former",
      0.085
    ],
    [
      "dresser",
      0.0725
    ],
    [
      "eduquer",
      0.06
    ],
    [
      "faconner",
      0.0525
    ],
    [
      "exercer",
      0.0525
    ],
    [
      "accoutumer",
      0.0475
    ],
    [
      "familiariser",
      0.0425
    ],
    [
      "apprendre",
      0.035
    ],
    [
      "entrainer",
      0.035
    ],
    [
      "rompre",
      0.03
    ],
    [
      "initier",
      0.03
    ],
    [
      "acclimater",
      0.03
    ],
    [
      "enseigner",
      0.0225
    ],
    [
      "apprivoiser",
      0.0175
    ],
    [
      "catechiser",
      0.0175
    ],
    [
      "plier",
      0.0175
    ],
    [
      "preparer",
      0.0175
    ],
    [
      "elever",
      0.01
    ],
    [
      "endurcir",
      0.01
    ],
    [
      "endoctriner",
      0.01
    ],
    [
      "adapter",
      0.005
    ],
    [
      "gouverner",
      0.005
    ],
    [
      "instituer",
      0.005
    ]
  ],
  "richesse": [
    [
      "abondance",
      0.09
    ],
    [
      "fortune",
      0.055
    ],
    [
      "luxe",
      0.055
    ],
    [
      "profusion",
      0.055
    ],
    [
      "somptuosite",
      0.055
    ],
    [
      "surabondance",
      0.055
    ],
    [
      "opulence",
      0.04
    ],
    [
      "exuberance",
      0.035
    ],
    [
      "bien",
      0.035
    ],
    [
      "argent",
      0.03
    ],
    [
      "luxuriance",
      0.03
    ],
    [
      "magnificence",
      0.03
    ],
    [
      "eclat",
      0.03
    ],
    [
      "splendeur",
      0.0225
    ],
    [
      "capital",
      0.0225
    ],
    [
      "beaute",
      0.0225
    ],
    [
      "avoir",
      0.0225
    ],
    [
      "prosperite",
      0.0175
    ],
    [
      "generosite",
      0.0175
    ],
    [
      "faste",
      0.0175
    ],
    [
      "exces",
      0.0175
    ],
    [
      "aisance",
      0.0175
    ],
    [
      "affluence",
      0.0175
    ],
    [
      "tresor",
      0.01
    ],
    [
      "possession",
      0.01
    ],
    [
      "pompe",
      0.01
    ],
    [
      "patrimoine",
      0.01
    ],
    [
      "majeste",
      0.01
    ],
    [
      "fecondite",
      0.01
    ],
    [
      "foisonnement",
      0.01
    ],
    [
      "debauche",
      0.01
    ],
    [
      "confort",
      0.01
    ],
    [
      "chose",
      0.01
    ],
    [
      "or",
      0.005
    ],
    [
      "pactole",
      0.005
    ],
    [
      "profondeur",
      0.005
    ],
    [
      "ressource",
      0.005
    ],
    [
      "riche",
      0.005
    ],
    [
      "moyens",
      0.005
    ],
    [
      "fertilite",
      0.005
    ],
    [
      "enrichissement",
      0.005
    ],
    [
      "butin",
      0.005
    ],
    [
      "biens",
      0.005
    ],
    [
      "apparat",
      0.005
    ],
    [
      "ampleur",
      0.005
    ],
    [
      "souplesse",
      0.005
    ]
  ],
  "pige": [
    [
      "an",
      0.2
    ],
    [
      "balai",
      0.2
    ],
    [
      "berge",
      0.2
    ],
    [
      "remuneration",
      0.2
    ],
    [
      "retribution",
      0.2
    ]
  ],
  "piger": [
    [
      "prendre",
      0.21
    ],
    [
      "saisir",
      0.1575
    ],
    [
      "apercevoir",
      0.105
    ],
    [
      "attraper",
      0.105
    ],
    [
      "comprendre",
      0.105
    ],
    [
      "entraver",
      0.05
    ],
    [
      "contracter",
      0.05
    ],
    [
      "bitter",
      0.05
    ],
    [
      "biter",
      0.05
    ],
    [
      "baiser",
      0.05
    ],
    [
      "regarder",
      0.05
    ]
  ],
  "rature": [
    [
      "correction",
      0.25
    ],
    [
      "barre",
      0.165
    ],
    [
      "biffure",
      0.165
    ],
    [
      "biffage",
      0.0825
    ],
    [
      "effacure",
      0.0825
    ],
    [
      "modification",
      0.0825
    ],
    [
      "surcharge",
      0.0825
    ],
    [
      "trait",
      0.0825
    ]
  ],
  "gratter": [
    [
      "enlever",
      0.0625
    ],
    [
      "passer",
      0.0475
    ],
    [
      "racler",
      0.0475
    ],
    [
      "voler",
      0.0375
    ],
    [
      "travailler",
      0.0375
    ],
    [
      "piquer",
      0.0375
    ],
    [
      "grappiller",
      0.0375
    ],
    [
      "gagner",
      0.0375
    ],
    [
      "depasser",
      0.03
    ],
    [
      "retrancher",
      0.03
    ],
    [
      "nettoyer",
      0.0225
    ],
    [
      "jouer",
      0.0225
    ],
    [
      "griller",
      0.0225
    ],
    [
      "frotter",
      0.0225
    ],
    [
      "effacer",
      0.0225
    ],
    [
      "distancer",
      0.0225
    ],
    [
      "bricoler",
      0.0225
    ],
    [
      "peler",
      0.015
    ],
    [
      "radier",
      0.015
    ],
    [
      "ratisser",
      0.015
    ],
    [
      "remuer",
      0.015
    ],
    [
      "raper",
      0.015
    ],
    [
      "semer",
      0.015
    ],
    [
      "tondre",
      0.015
    ],
    [
      "grignoter",
      0.015
    ],
    [
      "fouiller",
      0.015
    ],
    [
      "censurer",
      0.015
    ],
    [
      "chatouiller",
      0.015
    ],
    [
      "cuire",
      0.015
    ],
    [
      "devancer",
      0.015
    ],
    [
      "entretenir",
      0.015
    ],
    [
      "faconner",
      0.015
    ],
    [
      "flatter",
      0.015
    ],
    [
      "megoter",
      0.005
    ],
    [
      "picoter",
      0.005
    ],
    [
      "rabioter",
      0.005
    ],
    [
      "ranimer",
      0.005
    ],
    [
      "ravaler",
      0.005
    ],
    [
      "rogner",
      0.005
    ],
    [
      "ecailler",
      0.005
    ],
    [
      "economiser",
      0.005
    ],
    [
      "ecrire",
      0.005
    ],
    [
      "miner",
      0.005
    ],
    [
      "lacher",
      0.005
    ],
    [
      "accrocher",
      0.005
    ],
    [
      "ameublir",
      0.005
    ],
    [
      "biner",
      0.005
    ],
    [
      "bucher",
      0.005
    ],
    [
      "doubler",
      0.005
    ],
    [
      "demanger",
      0.005
    ],
    [
      "glaner",
      0.005
    ],
    [
      "gratouiller",
      0.005
    ],
    [
      "griveler",
      0.005
    ],
    [
      "egratigner",
      0.005
    ]
  ],
  "gratte": [
    [
      "boni",
      0.1425
    ],
    [
      "benefice",
      0.1425
    ],
    [
      "gain",
      0.1425
    ],
    [
      "grappillage",
      0.1425
    ],
    [
      "grattelle",
      0.1425
    ],
    [
      "guitare",
      0.1425
    ],
    [
      "profit",
      0.1425
    ]
  ],
  "papier": [
    [
      "billet",
      0.1175
    ],
    [
      "titre",
      0.0825
    ],
    [
      "ecrit",
      0.0825
    ],
    [
      "document",
      0.0675
    ],
    [
      "piece",
      0.05
    ],
    [
      "note",
      0.05
    ],
    [
      "feuille",
      0.05
    ],
    [
      "copie",
      0.05
    ],
    [
      "certificat",
      0.05
    ],
    [
      "bulletin",
      0.05
    ],
    [
      "article",
      0.05
    ],
    [
      "lettre",
      0.0325
    ],
    [
      "manuscrit",
      0.0325
    ],
    [
      "identite",
      0.015
    ],
    [
      "imprime",
      0.015
    ],
    [
      "papelard",
      0.015
    ],
    [
      "paperasse",
      0.015
    ],
    [
      "tract",
      0.015
    ],
    [
      "filtre",
      0.015
    ],
    [
      "fiche",
      0.015
    ],
    [
      "effet",
      0.015
    ],
    [
      "dossier",
      0.015
    ],
    [
      "devise",
      0.015
    ],
    [
      "chiffon",
      0.015
    ],
    [
      "cartel",
      0.015
    ],
    [
      "valeur",
      0.015
    ]
  ],
  "eparpiller": [
    [
      "disperser",
      0.1275
    ],
    [
      "repandre",
      0.1275
    ],
    [
      "semer",
      0.1075
    ],
    [
      "jeter",
      0.0725
    ],
    [
      "repartir",
      0.0725
    ],
    [
      "etaler",
      0.0525
    ],
    [
      "distribuer",
      0.0525
    ],
    [
      "epandre",
      0.035
    ],
    [
      "separer",
      0.035
    ],
    [
      "prodiguer",
      0.035
    ],
    [
      "gaspiller",
      0.035
    ],
    [
      "entrainer",
      0.035
    ],
    [
      "disseminer",
      0.035
    ],
    [
      "dissiper",
      0.035
    ],
    [
      "emietter",
      0.0175
    ],
    [
      "saupoudrer",
      0.0175
    ],
    [
      "isoler",
      0.0175
    ],
    [
      "emporter",
      0.0175
    ],
    [
      "couvrir",
      0.0175
    ],
    [
      "etendre",
      0.0175
    ]
  ],
  "eparpille": [
    [
      "disperser",
      0.1275
    ],
    [
      "repandre",
      0.1275
    ],
    [
      "semer",
      0.1075
    ],
    [
      "jeter",
      0.0725
    ],
    [
      "repartir",
      0.0725
    ],
    [
      "etaler",
      0.0525
    ],
    [
      "distribuer",
      0.0525
    ],
    [
      "epandre",
      0.035
    ],
    [
      "separer",
      0.035
    ],
    [
      "prodiguer",
      0.035
    ],
    [
      "gaspiller",
      0.035
    ],
    [
      "entrainer",
      0.035
    ],
    [
      "disseminer",
      0.035
    ],
    [
      "dissiper",
      0.035
    ],
    [
      "emietter",
      0.0175
    ],
    [
      "saupoudrer",
      0.0175
    ],
    [
      "isoler",
      0.0175
    ],
    [
      "emporter",
      0.0175
    ],
    [
      "couvrir",
      0.0175
    ],
    [
      "etendre",
      0.0175
    ]
  ],
  "aider": [
    [
      "servir",
      0.1775
    ],
    [
      "soutenir",
      0.0775
    ],
    [
      "appuyer",
      0.0675
    ],
    [
      "assister",
      0.0375
    ],
    [
      "proteger",
      0.035
    ],
    [
      "favoriser",
      0.0325
    ],
    [
      "secourir",
      0.0325
    ],
    [
      "epauler",
      0.0275
    ],
    [
      "repecher",
      0.0275
    ],
    [
      "participer",
      0.0275
    ],
    [
      "fortifier",
      0.0275
    ],
    [
      "pousser",
      0.0225
    ],
    [
      "collaborer",
      0.02
    ],
    [
      "concourir",
      0.02
    ],
    [
      "contribuer",
      0.02
    ],
    [
      "encourager",
      0.02
    ],
    [
      "reconforter",
      0.02
    ],
    [
      "seconder",
      0.015
    ],
    [
      "donner",
      0.015
    ],
    [
      "conforter",
      0.0125
    ],
    [
      "faire",
      0.0125
    ],
    [
      "partager",
      0.0125
    ],
    [
      "soulager",
      0.01
    ],
    [
      "renforcer",
      0.01
    ],
    [
      "profiter",
      0.01
    ],
    [
      "defendre",
      0.01
    ],
    [
      "agir",
      0.01
    ],
    [
      "s'occuper",
      0.005
    ],
    [
      "subventionner",
      0.005
    ],
    [
      "etayer",
      0.005
    ],
    [
      "patronner",
      0.005
    ],
    [
      "cooperer",
      0.005
    ],
    [
      "depanner",
      0.005
    ],
    [
      "lancer",
      0.005
    ],
    [
      "obliger",
      0.005
    ],
    [
      "remonter",
      0.0025
    ],
    [
      "revigorer",
      0.0025
    ],
    [
      "s'entraider",
      0.0025
    ],
    [
      "souffler",
      0.0025
    ],
    [
      "permettre",
      0.0025
    ],
    [
      "offrir",
      0.0025
    ],
    [
      "guider",
      0.0025
    ],
    [
      "faciliter",
      0.0025
    ],
    [
      "alleger",
      0.0025
    ]
  ],
  "aide": [
    [
      "service",
      0.0825
    ],
    [
      "appui",
      0.065
    ],
    [
      "secours",
      0.065
    ],
    [
      "soutien",
      0.0625
    ],
    [
      "adjoint",
      0.0425
    ],
    [
      "auxiliaire",
      0.025
    ],
    [
      "associe",
      0.025
    ],
    [
      "protection",
      0.0225
    ],
    [
      "charite",
      0.02
    ],
    [
      "concours",
      0.02
    ],
    [
      "don",
      0.02
    ],
    [
      "soulagement",
      0.0175
    ],
    [
      "second",
      0.0175
    ],
    [
      "grace",
      0.0175
    ],
    [
      "faveur",
      0.0175
    ],
    [
      "assistance",
      0.0175
    ],
    [
      "partenaire",
      0.0175
    ],
    [
      "pret",
      0.0175
    ],
    [
      "subvention",
      0.0125
    ],
    [
      "rescousse",
      0.0125
    ],
    [
      "bourse",
      0.0125
    ],
    [
      "bienfait",
      0.0125
    ],
    [
      "participation",
      0.0125
    ],
    [
      "allie",
      0.0125
    ],
    [
      "subside",
      0.01
    ],
    [
      "facilite",
      0.01
    ],
    [
      "cooperation",
      0.01
    ],
    [
      "complice",
      0.01
    ],
    [
      "complaisance",
      0.01
    ],
    [
      "collaborateur",
      0.01
    ],
    [
      "aumone",
      0.01
    ],
    [
      "acolyte",
      0.01
    ],
    [
      "reconfort",
      0.0075
    ],
    [
      "piston",
      0.0075
    ],
    [
      "patronage",
      0.0075
    ],
    [
      "intervention",
      0.0075
    ],
    [
      "encouragement",
      0.0075
    ],
    [
      "contribution",
      0.0075
    ],
    [
      "complicite",
      0.0075
    ],
    [
      "collaboration",
      0.0075
    ],
    [
      "bienveillance",
      0.0075
    ],
    [
      "tutelle",
      0.005
    ],
    [
      "employe",
      0.005
    ],
    [
      "depannage",
      0.005
    ],
    [
      "bienfaisance",
      0.005
    ],
    [
      "avance",
      0.005
    ],
    [
      "assistant",
      0.005
    ],
    [
      "office",
      0.0025
    ],
    [
      "protecteur",
      0.0025
    ],
    [
      "providence",
      0.0025
    ],
    [
      "recors",
      0.0025
    ],
    [
      "remplacant",
      0.0025
    ],
    [
      "renfort",
      0.0025
    ],
    [
      "suivant",
      0.0025
    ],
    [
      "etai",
      0.0025
    ],
    [
      "manoeuvre",
      0.0025
    ],
    [
      "influence",
      0.0025
    ],
    [
      "appoint",
      0.0025
    ],
    [
      "apprenti",
      0.0025
    ],
    [
      "assesseur",
      0.0025
    ],
    [
      "bras",
      0.0025
    ],
    [
      "coadjuteur",
      0.0025
    ],
    [
      "defense",
      0.0025
    ],
    [
      "entraide",
      0.0025
    ],
    [
      "investissement",
      0.0
    ],
    [
      "main",
      0.0
    ],
    [
      "personnel",
      0.0
    ],
    [
      "prestation",
      0.0
    ],
    [
      "repechage",
      0.0
    ],
    [
      "conseil",
      0.0
    ],
    [
      "connivence",
      0.0
    ],
    [
      "confort",
      0.0
    ],
    [
      "cadeau",
      0.0
    ],
    [
      "allegement",
      0.0
    ],
    [
      "adjuteur",
      0.0
    ],
    [
      "adjudant",
      0.0
    ]
  ],
  "guise": [
    [
      "maniere",
      0.175
    ],
    [
      "mode",
      0.175
    ],
    [
      "fantaisie",
      0.1175
    ],
    [
      "facon",
      0.1175
    ],
    [
      "gout",
      0.1175
    ],
    [
      "gre",
      0.1175
    ],
    [
      "volonte",
      0.1175
    ],
    [
      "sorte",
      0.0575
    ]
  ],
  "estrade": [
    [
      "echafaud",
      0.2
    ],
    [
      "plancher",
      0.1325
    ],
    [
      "tribune",
      0.1325
    ],
    [
      "scene",
      0.065
    ],
    [
      "route",
      0.065
    ],
    [
      "ring",
      0.065
    ],
    [
      "podium",
      0.065
    ],
    [
      "chaire",
      0.065
    ],
    [
      "catafalque",
      0.065
    ],
    [
      "echafaudage",
      0.065
    ]
  ],
  "boire": [
    [
      "boisson",
      1.0
    ]
  ],
  "but": [
    [
      "s'abreuver",
      0.15
    ],
    [
      "absorber",
      0.0475
    ],
    [
      "s'enivrer",
      0.045
    ],
    [
      "pomper",
      0.04
    ],
    [
      "pinter",
      0.03
    ],
    [
      "s'imbiber",
      0.025
    ],
    [
      "recevoir",
      0.025
    ],
    [
      "ingurgiter",
      0.025
    ],
    [
      "avaler",
      0.025
    ],
    [
      "picoler",
      0.0225
    ],
    [
      "prendre",
      0.0225
    ],
    [
      "sucer",
      0.015
    ],
    [
      "souffrir",
      0.015
    ],
    [
      "s'alcooliser",
      0.015
    ],
    [
      "humer",
      0.015
    ],
    [
      "essuyer",
      0.015
    ],
    [
      "entonner",
      0.015
    ],
    [
      "deguster",
      0.015
    ],
    [
      "chopiner",
      0.015
    ],
    [
      "aspirer",
      0.015
    ],
    [
      "siroter",
      0.0125
    ],
    [
      "siffler",
      0.0125
    ],
    [
      "s'ivrogner",
      0.0125
    ],
    [
      "s'impregner",
      0.0125
    ],
    [
      "licher",
      0.0125
    ],
    [
      "lamper",
      0.0125
    ],
    [
      "ivrogner",
      0.0125
    ],
    [
      "endurer",
      0.0125
    ],
    [
      "supporter",
      0.0075
    ],
    [
      "teter",
      0.0075
    ],
    [
      "vider",
      0.0075
    ],
    [
      "ecluser",
      0.0075
    ],
    [
      "eponger",
      0.0075
    ],
    [
      "arroser",
      0.0075
    ],
    [
      "biberonner",
      0.0075
    ],
    [
      "consommer",
      0.0075
    ],
    [
      "respirer",
      0.0075
    ],
    [
      "s'aviner",
      0.0075
    ],
    [
      "savourer",
      0.0025
    ],
    [
      "sabler",
      0.0025
    ],
    [
      "s'inonder",
      0.0025
    ],
    [
      "s'humecter",
      0.0025
    ],
    [
      "rincer",
      0.0025
    ],
    [
      "soiffer",
      0.0025
    ],
    [
      "tolerer",
      0.0025
    ],
    [
      "trinquer",
      0.0025
    ],
    [
      "riboter",
      0.0025
    ],
    [
      "renifler",
      0.0025
    ],
    [
      "abreuver",
      0.0025
    ],
    [
      "bidonner",
      0.0025
    ],
    [
      "boissonner",
      0.0025
    ],
    [
      "buvoter",
      0.0025
    ],
    [
      "depenser",
      0.0025
    ],
    [
      "fouetter",
      0.0025
    ],
    [
      "godailler",
      0.0025
    ],
    [
      "laper",
      0.0025
    ],
    [
      "lichailler",
      0.0025
    ],
    [
      "lipper",
      0.0025
    ],
    [
      "pictancher",
      0.0025
    ],
    [
      "picter",
      0.0025
    ],
    [
      "pictonner",
      0.0025
    ]
  ],
  "choir": [
    [
      "tomber",
      0.3075
    ],
    [
      "s'ecrouler",
      0.23
    ],
    [
      "chuter",
      0.1525
    ],
    [
      "degringoler",
      0.075
    ],
    [
      "faillir",
      0.075
    ],
    [
      "s'etaler",
      0.075
    ],
    [
      "trebucher",
      0.075
    ]
  ],
  "chut": [
    [
      "tomber",
      0.3075
    ],
    [
      "s'ecrouler",
      0.23
    ],
    [
      "chuter",
      0.1525
    ],
    [
      "degringoler",
      0.075
    ],
    [
      "faillir",
      0.075
    ],
    [
      "s'etaler",
      0.075
    ],
    [
      "trebucher",
      0.075
    ]
  ],
  "base": [
    [
      "fondement",
      0.165
    ],
    [
      "bas",
      0.055
    ],
    [
      "principe",
      0.055
    ],
    [
      "soubassement",
      0.05
    ],
    [
      "support",
      0.035
    ],
    [
      "fondation",
      0.035
    ],
    [
      "fond",
      0.035
    ],
    [
      "assise",
      0.035
    ],
    [
      "origine",
      0.03
    ],
    [
      "source",
      0.0225
    ],
    [
      "socle",
      0.0225
    ],
    [
      "racine",
      0.0225
    ],
    [
      "centre",
      0.0225
    ],
    [
      "cause",
      0.0225
    ],
    [
      "theorie",
      0.0175
    ],
    [
      "soutien",
      0.0175
    ],
    [
      "regle",
      0.0175
    ],
    [
      "pivot",
      0.0175
    ],
    [
      "appui",
      0.0175
    ],
    [
      "substruction",
      0.01
    ],
    [
      "rudiments",
      0.01
    ],
    [
      "plan",
      0.01
    ],
    [
      "piedestal",
      0.01
    ],
    [
      "pied",
      0.01
    ],
    [
      "matiere",
      0.01
    ],
    [
      "ligne",
      0.01
    ],
    [
      "armature",
      0.01
    ],
    [
      "assiette",
      0.01
    ],
    [
      "credo",
      0.01
    ],
    [
      "embase",
      0.01
    ],
    [
      "germe",
      0.01
    ],
    [
      "principal",
      0.005
    ],
    [
      "premisse",
      0.005
    ],
    [
      "radical",
      0.005
    ],
    [
      "raison",
      0.005
    ],
    [
      "siege",
      0.005
    ],
    [
      "taux",
      0.005
    ],
    [
      "masse",
      0.005
    ],
    [
      "bible",
      0.005
    ],
    [
      "bout",
      0.005
    ],
    [
      "caserne",
      0.005
    ],
    [
      "condition",
      0.005
    ],
    [
      "cul",
      0.005
    ],
    [
      "dessous",
      0.005
    ],
    [
      "embasement",
      0.005
    ],
    [
      "empattement",
      0.005
    ],
    [
      "elements",
      0.005
    ]
  ],
  "baser": [
    [
      "fonder",
      0.2775
    ],
    [
      "etablir",
      0.22
    ],
    [
      "appuyer",
      0.11
    ],
    [
      "asseoir",
      0.11
    ],
    [
      "batir",
      0.11
    ],
    [
      "reposer",
      0.055
    ],
    [
      "tabler",
      0.055
    ],
    [
      "echafauder",
      0.055
    ]
  ],
  "ble": [
    [
      "cereale",
      0.1375
    ],
    [
      "argent",
      0.0925
    ],
    [
      "peze",
      0.045
    ],
    [
      "oseille",
      0.045
    ],
    [
      "froment",
      0.045
    ],
    [
      "fric",
      0.045
    ],
    [
      "orge",
      0.0225
    ],
    [
      "osier",
      0.0225
    ],
    [
      "sarrasin",
      0.0225
    ],
    [
      "seigle",
      0.0225
    ],
    [
      "semoule",
      0.0225
    ],
    [
      "son",
      0.0225
    ],
    [
      "sorgho",
      0.0225
    ],
    [
      "thune",
      0.0225
    ],
    [
      "touselle",
      0.0225
    ],
    [
      "trefle",
      0.0225
    ],
    [
      "epeautre",
      0.0225
    ],
    [
      "melampyre",
      0.0225
    ],
    [
      "mouture",
      0.0225
    ],
    [
      "alpiste",
      0.0225
    ],
    [
      "avoine",
      0.0225
    ],
    [
      "bucail",
      0.0225
    ],
    [
      "chaume",
      0.0225
    ],
    [
      "fane",
      0.0225
    ],
    [
      "farine",
      0.0225
    ],
    [
      "feurre",
      0.0225
    ],
    [
      "galette",
      0.0225
    ],
    [
      "gruau",
      0.0225
    ],
    [
      "gremil",
      0.0225
    ],
    [
      "mais",
      0.0225
    ],
    [
      "eteule",
      0.0225
    ]
  ],
  "entasser": [
    [
      "amasser",
      0.1525
    ],
    [
      "accumuler",
      0.1175
    ],
    [
      "empiler",
      0.065
    ],
    [
      "reunir",
      0.065
    ],
    [
      "assembler",
      0.0525
    ],
    [
      "thesauriser",
      0.0425
    ],
    [
      "serrer",
      0.0425
    ],
    [
      "bloquer",
      0.0425
    ],
    [
      "amonceler",
      0.0425
    ],
    [
      "agglomerer",
      0.0425
    ],
    [
      "economiser",
      0.0325
    ],
    [
      "tasser",
      0.0325
    ],
    [
      "presser",
      0.0325
    ],
    [
      "masser",
      0.0325
    ],
    [
      "emmagasiner",
      0.0325
    ],
    [
      "ramasser",
      0.02
    ],
    [
      "epargner",
      0.02
    ],
    [
      "superposer",
      0.01
    ],
    [
      "stocker",
      0.01
    ],
    [
      "parquer",
      0.01
    ],
    [
      "multiplier",
      0.01
    ],
    [
      "gerber",
      0.01
    ],
    [
      "engerber",
      0.01
    ],
    [
      "encaquer",
      0.01
    ],
    [
      "conglober",
      0.01
    ],
    [
      "collectionner",
      0.01
    ],
    [
      "capitaliser",
      0.01
    ],
    [
      "echafauder",
      0.01
    ]
  ],
  "ecrire": [
    [
      "faire",
      0.0625
    ],
    [
      "donner",
      0.055
    ],
    [
      "produire",
      0.055
    ],
    [
      "marquer",
      0.05
    ],
    [
      "composer",
      0.045
    ],
    [
      "reveler",
      0.04
    ],
    [
      "former",
      0.04
    ],
    [
      "exposer",
      0.04
    ],
    [
      "fixer",
      0.0325
    ],
    [
      "publier",
      0.0275
    ],
    [
      "poser",
      0.0275
    ],
    [
      "montrer",
      0.0275
    ],
    [
      "exprimer",
      0.0275
    ],
    [
      "mettre",
      0.02
    ],
    [
      "travailler",
      0.015
    ],
    [
      "tracer",
      0.015
    ],
    [
      "rediger",
      0.015
    ],
    [
      "noter",
      0.015
    ],
    [
      "mander",
      0.015
    ],
    [
      "inscrire",
      0.015
    ],
    [
      "informer",
      0.015
    ],
    [
      "griffonner",
      0.015
    ],
    [
      "accoucher",
      0.015
    ],
    [
      "avancer",
      0.015
    ],
    [
      "communiquer",
      0.015
    ],
    [
      "creer",
      0.015
    ],
    [
      "dresser",
      0.015
    ],
    [
      "enoncer",
      0.01
    ],
    [
      "ecrivasser",
      0.01
    ],
    [
      "ecrivailler",
      0.01
    ],
    [
      "transcrire",
      0.01
    ],
    [
      "soutenir",
      0.01
    ],
    [
      "graver",
      0.01
    ],
    [
      "crayonner",
      0.01
    ],
    [
      "copier",
      0.01
    ],
    [
      "ponctuer",
      0.005
    ],
    [
      "pondre",
      0.005
    ],
    [
      "recopier",
      0.005
    ],
    [
      "roler",
      0.005
    ],
    [
      "scribouiller",
      0.005
    ],
    [
      "stenographier",
      0.005
    ],
    [
      "stenotyper",
      0.005
    ],
    [
      "taper",
      0.005
    ],
    [
      "tartiner",
      0.005
    ],
    [
      "orthographier",
      0.005
    ],
    [
      "minuter",
      0.005
    ],
    [
      "libeller",
      0.005
    ],
    [
      "barbouiller",
      0.005
    ],
    [
      "calligraphier",
      0.005
    ],
    [
      "consigner",
      0.005
    ],
    [
      "correspondre",
      0.005
    ],
    [
      "dactylographier",
      0.005
    ],
    [
      "demontrer",
      0.005
    ],
    [
      "forger",
      0.005
    ],
    [
      "gratter",
      0.005
    ],
    [
      "gribouiller",
      0.005
    ],
    [
      "elucubrer",
      0.005
    ]
  ],
  "sacrifice": [
    [
      "abandon",
      0.0825
    ],
    [
      "offrande",
      0.0825
    ],
    [
      "abnegation",
      0.0625
    ],
    [
      "devouement",
      0.0625
    ],
    [
      "holocauste",
      0.0625
    ],
    [
      "renoncement",
      0.0625
    ],
    [
      "resignation",
      0.04
    ],
    [
      "oblativite",
      0.04
    ],
    [
      "oblation",
      0.04
    ],
    [
      "immolation",
      0.04
    ],
    [
      "don",
      0.04
    ],
    [
      "messe",
      0.02
    ],
    [
      "offre",
      0.02
    ],
    [
      "privation",
      0.02
    ],
    [
      "propitiation",
      0.02
    ],
    [
      "rabais",
      0.02
    ],
    [
      "renonciation",
      0.02
    ],
    [
      "lustration",
      0.02
    ],
    [
      "libation",
      0.02
    ],
    [
      "heroisme",
      0.02
    ],
    [
      "hecatombe",
      0.02
    ],
    [
      "hostie",
      0.02
    ],
    [
      "desinteressement",
      0.02
    ],
    [
      "depense",
      0.02
    ],
    [
      "dessaisissement",
      0.02
    ],
    [
      "abattage",
      0.02
    ],
    [
      "taurobole",
      0.02
    ]
  ],
  "patience": [
    [
      "constance",
      0.095
    ],
    [
      "calme",
      0.0775
    ],
    [
      "perseverance",
      0.0775
    ],
    [
      "placidite",
      0.0775
    ],
    [
      "flegme",
      0.0625
    ],
    [
      "tranquillite",
      0.0475
    ],
    [
      "serenite",
      0.0475
    ],
    [
      "impassibilite",
      0.0475
    ],
    [
      "douceur",
      0.0475
    ],
    [
      "stoicisme",
      0.03
    ],
    [
      "persistance",
      0.03
    ],
    [
      "longanimite",
      0.03
    ],
    [
      "indulgence",
      0.03
    ],
    [
      "imperturbabilite",
      0.03
    ],
    [
      "habilete",
      0.03
    ],
    [
      "endurance",
      0.03
    ],
    [
      "courage",
      0.03
    ],
    [
      "tolerance",
      0.015
    ],
    [
      "souffrance",
      0.015
    ],
    [
      "reussite",
      0.015
    ],
    [
      "resignation",
      0.015
    ],
    [
      "politique",
      0.015
    ],
    [
      "lenteur",
      0.015
    ],
    [
      "aptitude",
      0.015
    ],
    [
      "tenacite",
      0.015
    ]
  ],
  "rememorer": [
    [
      "retracer",
      0.2
    ],
    [
      "rappeler",
      0.1325
    ],
    [
      "redire",
      0.1325
    ],
    [
      "repasser",
      0.1325
    ],
    [
      "ressasser",
      0.1325
    ],
    [
      "evoquer",
      0.1325
    ],
    [
      "relater",
      0.065
    ],
    [
      "souffler",
      0.065
    ]
  ],
  "concours": [
    [
      "aider",
      0.1425
    ],
    [
      "collaborer",
      0.1425
    ],
    [
      "contribuer",
      0.1175
    ],
    [
      "servir",
      0.1175
    ],
    [
      "participer",
      0.095
    ],
    [
      "tendre",
      0.07
    ],
    [
      "seconder",
      0.0475
    ],
    [
      "cooperer",
      0.0475
    ],
    [
      "converger",
      0.0475
    ],
    [
      "conspirer",
      0.0475
    ],
    [
      "assister",
      0.0475
    ],
    [
      "agir",
      0.0225
    ],
    [
      "s'unir",
      0.0225
    ]
  ],
  "concourir": [
    [
      "aider",
      0.1425
    ],
    [
      "collaborer",
      0.1425
    ],
    [
      "contribuer",
      0.1175
    ],
    [
      "servir",
      0.1175
    ],
    [
      "participer",
      0.095
    ],
    [
      "tendre",
      0.07
    ],
    [
      "seconder",
      0.0475
    ],
    [
      "cooperer",
      0.0475
    ],
    [
      "converger",
      0.0475
    ],
    [
      "conspirer",
      0.0475
    ],
    [
      "assister",
      0.0475
    ],
    [
      "agir",
      0.0225
    ],
    [
      "s'unir",
      0.0225
    ]
  ],
  "masse": [
    [
      "multitude",
      0.0725
    ],
    [
      "foule",
      0.07
    ],
    [
      "quantite",
      0.07
    ],
    [
      "tas",
      0.0625
    ],
    [
      "peuple",
      0.0425
    ],
    [
      "amas",
      0.04
    ],
    [
      "affluence",
      0.04
    ],
    [
      "assemblage",
      0.0325
    ],
    [
      "flot",
      0.03
    ],
    [
      "armee",
      0.025
    ],
    [
      "bloc",
      0.025
    ],
    [
      "essaim",
      0.0225
    ],
    [
      "accumulation",
      0.0225
    ],
    [
      "groupe",
      0.02
    ],
    [
      "nuee",
      0.02
    ],
    [
      "reunion",
      0.02
    ],
    [
      "bande",
      0.0175
    ],
    [
      "rassemblement",
      0.0175
    ],
    [
      "societe",
      0.015
    ],
    [
      "abondance",
      0.0125
    ],
    [
      "agglomerat",
      0.0125
    ],
    [
      "ensemble",
      0.0125
    ],
    [
      "total",
      0.01
    ],
    [
      "populace",
      0.01
    ],
    [
      "poids",
      0.01
    ],
    [
      "commun",
      0.01
    ],
    [
      "tapee",
      0.0075
    ],
    [
      "paquet",
      0.0075
    ],
    [
      "monceau",
      0.0075
    ],
    [
      "afflux",
      0.0075
    ],
    [
      "volume",
      0.005
    ],
    [
      "somme",
      0.005
    ],
    [
      "public",
      0.005
    ],
    [
      "horde",
      0.005
    ],
    [
      "fonds",
      0.005
    ],
    [
      "cohue",
      0.005
    ],
    [
      "amoncellement",
      0.005
    ],
    [
      "agregat",
      0.005
    ],
    [
      "nombre",
      0.0025
    ],
    [
      "populo",
      0.0025
    ],
    [
      "poussee",
      0.0025
    ],
    [
      "profusion",
      0.0025
    ],
    [
      "ribambelle",
      0.0025
    ],
    [
      "totalite",
      0.0025
    ],
    [
      "tourbe",
      0.0025
    ],
    [
      "volee",
      0.0025
    ],
    [
      "morceau",
      0.0025
    ],
    [
      "montagne",
      0.0025
    ],
    [
      "mer",
      0.0025
    ],
    [
      "ampleur",
      0.0025
    ],
    [
      "batelee",
      0.0025
    ],
    [
      "densite",
      0.0025
    ],
    [
      "foultitude",
      0.0025
    ],
    [
      "gros",
      0.0025
    ],
    [
      "maillet",
      0.0025
    ],
    [
      "marteau",
      0.0025
    ],
    [
      "massue",
      0.0025
    ],
    [
      "magma",
      0.0
    ],
    [
      "mail",
      0.0
    ],
    [
      "majorite",
      0.0
    ],
    [
      "massette",
      0.0
    ],
    [
      "mise",
      0.0
    ],
    [
      "moisson",
      0.0
    ],
    [
      "pisoir",
      0.0
    ],
    [
      "plommee",
      0.0
    ],
    [
      "roture",
      0.0
    ],
    [
      "succession",
      0.0
    ],
    [
      "lourdeur",
      0.0
    ],
    [
      "filon",
      0.0
    ],
    [
      "armada",
      0.0
    ],
    [
      "base",
      0.0
    ],
    [
      "bigorne",
      0.0
    ],
    [
      "botte",
      0.0
    ],
    [
      "baton",
      0.0
    ],
    [
      "betail",
      0.0
    ],
    [
      "caisse",
      0.0
    ],
    [
      "carrier",
      0.0
    ],
    [
      "conglomerat",
      0.0
    ],
    [
      "tassement",
      0.0
    ]
  ],
  "masser": [
    [
      "reunir",
      0.12
    ],
    [
      "amasser",
      0.1
    ],
    [
      "rassembler",
      0.1
    ],
    [
      "assembler",
      0.08
    ],
    [
      "grouper",
      0.08
    ],
    [
      "entasser",
      0.06
    ],
    [
      "petrir",
      0.06
    ],
    [
      "presser",
      0.0375
    ],
    [
      "bloquer",
      0.0375
    ],
    [
      "agglomerer",
      0.0375
    ],
    [
      "palper",
      0.0175
    ],
    [
      "malaxer",
      0.0175
    ],
    [
      "frotter",
      0.0175
    ],
    [
      "frictionner",
      0.0175
    ],
    [
      "exagerer",
      0.0175
    ],
    [
      "concentrer",
      0.0175
    ],
    [
      "bouchonner",
      0.0175
    ],
    [
      "bluffer",
      0.0175
    ],
    [
      "assouplir",
      0.0175
    ],
    [
      "ameuter",
      0.0175
    ],
    [
      "tasser",
      0.0175
    ]
  ],
  "agresser": [
    [
      "attaquer",
      0.3325
    ],
    [
      "assaillir",
      0.165
    ],
    [
      "atteindre",
      0.165
    ],
    [
      "stresser",
      0.165
    ],
    [
      "etriper",
      0.165
    ]
  ],
  "apaiser": [
    [
      "calmer",
      0.1875
    ],
    [
      "adoucir",
      0.1225
    ],
    [
      "consoler",
      0.06
    ],
    [
      "soulager",
      0.05
    ],
    [
      "attenuer",
      0.0375
    ],
    [
      "diminuer",
      0.0375
    ],
    [
      "endormir",
      0.0375
    ],
    [
      "rasserener",
      0.0325
    ],
    [
      "bercer",
      0.0275
    ],
    [
      "assoupir",
      0.0225
    ],
    [
      "rassurer",
      0.0225
    ],
    [
      "eteindre",
      0.0225
    ],
    [
      "tranquilliser",
      0.0175
    ],
    [
      "temperer",
      0.0175
    ],
    [
      "satisfaire",
      0.0175
    ],
    [
      "flechir",
      0.0175
    ],
    [
      "lenifier",
      0.0125
    ],
    [
      "guerir",
      0.0125
    ],
    [
      "detendre",
      0.0125
    ],
    [
      "contenter",
      0.0125
    ],
    [
      "assouvir",
      0.0125
    ],
    [
      "amortir",
      0.0125
    ],
    [
      "amadouer",
      0.0125
    ],
    [
      "etancher",
      0.0075
    ],
    [
      "moderer",
      0.0075
    ],
    [
      "dissiper",
      0.0075
    ],
    [
      "cicatriser",
      0.0075
    ],
    [
      "attendrir",
      0.0075
    ],
    [
      "assagir",
      0.0075
    ],
    [
      "anesthesier",
      0.0075
    ],
    [
      "abattre",
      0.0075
    ],
    [
      "radoucir",
      0.0025
    ],
    [
      "rapaiser",
      0.0025
    ],
    [
      "rassasier",
      0.0025
    ],
    [
      "rasseoir",
      0.0025
    ],
    [
      "suffire",
      0.0025
    ],
    [
      "securiser",
      0.0025
    ],
    [
      "tromper",
      0.0025
    ],
    [
      "pacifier",
      0.0025
    ],
    [
      "froidir",
      0.0025
    ],
    [
      "desenerver",
      0.0025
    ],
    [
      "desarmer",
      0.0025
    ],
    [
      "desalterer",
      0.0025
    ],
    [
      "delivrer",
      0.0025
    ],
    [
      "decrisper",
      0.0025
    ],
    [
      "charmer",
      0.0025
    ],
    [
      "alleger",
      0.0025
    ]
  ],
  "flic": [
    [
      "agent",
      0.25
    ],
    [
      "policier",
      0.1875
    ],
    [
      "cafard",
      0.125
    ],
    [
      "conde",
      0.125
    ],
    [
      "poulet",
      0.125
    ],
    [
      "argousin",
      0.06
    ],
    [
      "cogne",
      0.06
    ],
    [
      "flicard",
      0.06
    ]
  ],
  "rabaisser": [
    [
      "diminuer",
      0.125
    ],
    [
      "abaisser",
      0.1175
    ],
    [
      "deprecier",
      0.1025
    ],
    [
      "avilir",
      0.0625
    ],
    [
      "ravaler",
      0.0375
    ],
    [
      "degrader",
      0.0375
    ],
    [
      "discrediter",
      0.0325
    ],
    [
      "humilier",
      0.0325
    ],
    [
      "vilipender",
      0.0275
    ],
    [
      "reduire",
      0.0275
    ],
    [
      "rabattre",
      0.0275
    ],
    [
      "denigrer",
      0.0275
    ],
    [
      "abattre",
      0.0275
    ],
    [
      "baisser",
      0.0225
    ],
    [
      "deconsiderer",
      0.0225
    ],
    [
      "ecraser",
      0.0225
    ],
    [
      "rapetisser",
      0.0175
    ],
    [
      "devaluer",
      0.0175
    ],
    [
      "aplatir",
      0.0175
    ],
    [
      "abatardir",
      0.0125
    ],
    [
      "affaiblir",
      0.0125
    ],
    [
      "amoindrir",
      0.0125
    ],
    [
      "mepriser",
      0.0125
    ],
    [
      "inferioriser",
      0.0075
    ],
    [
      "detracter",
      0.0075
    ],
    [
      "courber",
      0.0075
    ],
    [
      "descendre",
      0.0025
    ],
    [
      "enlaidir",
      0.0025
    ],
    [
      "mortifier",
      0.0025
    ],
    [
      "mejuger",
      0.0025
    ],
    [
      "mesestimer",
      0.0025
    ],
    [
      "ravilir",
      0.0025
    ],
    [
      "restreindre",
      0.0025
    ]
  ],
  "donc": [
    [
      "ainsi",
      0.1825
    ],
    [
      "consequemment",
      0.09
    ],
    [
      "partant",
      0.06
    ],
    [
      "ergo",
      0.06
    ],
    [
      "alors",
      0.06
    ],
    [
      "adonc",
      0.0275
    ],
    [
      "d'ou",
      0.0275
    ],
    [
      "or",
      0.0275
    ]
  ],
  "becher": [
    [
      "medire",
      0.1425
    ],
    [
      "denigrer",
      0.095
    ],
    [
      "clabauder",
      0.07
    ],
    [
      "gloser",
      0.07
    ],
    [
      "labourer",
      0.07
    ],
    [
      "jaser",
      0.0475
    ],
    [
      "faconner",
      0.0475
    ],
    [
      "deblaterer",
      0.0475
    ],
    [
      "debiner",
      0.0475
    ],
    [
      "cultiver",
      0.0475
    ],
    [
      "critiquer",
      0.0475
    ],
    [
      "ameublir",
      0.0475
    ],
    [
      "retourner",
      0.0225
    ],
    [
      "ragoter",
      0.0225
    ],
    [
      "preparer",
      0.0225
    ],
    [
      "mesoyer",
      0.0225
    ],
    [
      "creuser",
      0.0225
    ],
    [
      "biner",
      0.0225
    ],
    [
      "becqueter",
      0.0225
    ],
    [
      "baver",
      0.0225
    ],
    [
      "snober",
      0.0225
    ]
  ],
  "beche": [
    [
      "houe",
      0.2
    ],
    [
      "binette",
      0.1325
    ],
    [
      "palot",
      0.065
    ],
    [
      "louchet",
      0.065
    ],
    [
      "houlette",
      0.065
    ],
    [
      "bechot",
      0.065
    ],
    [
      "bechoir",
      0.065
    ],
    [
      "bechette",
      0.065
    ],
    [
      "becheton",
      0.065
    ],
    [
      "bechelon",
      0.065
    ],
    [
      "bechard",
      0.065
    ],
    [
      "pelle",
      0.065
    ]
  ],
  "secher": [
    [
      "dessecher",
      0.1325
    ],
    [
      "assecher",
      0.065
    ],
    [
      "essuyer",
      0.0475
    ],
    [
      "epuiser",
      0.0475
    ],
    [
      "etancher",
      0.0475
    ],
    [
      "steriliser",
      0.0325
    ],
    [
      "tarir",
      0.0325
    ],
    [
      "echouer",
      0.0325
    ],
    [
      "eponger",
      0.0325
    ],
    [
      "etuver",
      0.0325
    ],
    [
      "souffrir",
      0.0325
    ],
    [
      "racornir",
      0.0325
    ],
    [
      "manquer",
      0.0325
    ],
    [
      "languir",
      0.0325
    ],
    [
      "faner",
      0.0325
    ],
    [
      "deperir",
      0.0325
    ],
    [
      "durcir",
      0.0325
    ],
    [
      "boucaner",
      0.0325
    ],
    [
      "ressuyer",
      0.015
    ],
    [
      "s'evaporer",
      0.015
    ],
    [
      "vider",
      0.015
    ],
    [
      "fletrir",
      0.015
    ],
    [
      "essorer",
      0.015
    ],
    [
      "deshydrater",
      0.015
    ],
    [
      "drainer",
      0.015
    ],
    [
      "courber",
      0.015
    ],
    [
      "coller",
      0.015
    ],
    [
      "brosser",
      0.015
    ]
  ],
  "sec": [
    [
      "dur",
      0.0925
    ],
    [
      "rude",
      0.0875
    ],
    [
      "bourru",
      0.0525
    ],
    [
      "abrupt",
      0.045
    ],
    [
      "severe",
      0.045
    ],
    [
      "apre",
      0.0325
    ],
    [
      "aigre",
      0.03
    ],
    [
      "brusque",
      0.03
    ],
    [
      "raide",
      0.0275
    ],
    [
      "insensible",
      0.0275
    ],
    [
      "froid",
      0.0275
    ],
    [
      "cassant",
      0.0275
    ],
    [
      "aride",
      0.0275
    ],
    [
      "austere",
      0.025
    ],
    [
      "maigre",
      0.0225
    ],
    [
      "reveche",
      0.015
    ],
    [
      "pauvre",
      0.015
    ],
    [
      "ingrat",
      0.015
    ],
    [
      "desagreable",
      0.015
    ],
    [
      "decharne",
      0.015
    ],
    [
      "desseche",
      0.015
    ],
    [
      "autoritaire",
      0.015
    ],
    [
      "brutal",
      0.0125
    ],
    [
      "rebarbatif",
      0.0125
    ],
    [
      "tranchant",
      0.0125
    ],
    [
      "cru",
      0.01
    ],
    [
      "indifferent",
      0.01
    ],
    [
      "sterile",
      0.0075
    ],
    [
      "rebutant",
      0.0075
    ],
    [
      "glacial",
      0.0075
    ],
    [
      "etique",
      0.005
    ],
    [
      "squelettique",
      0.005
    ],
    [
      "simple",
      0.005
    ],
    [
      "rogue",
      0.005
    ],
    [
      "rigide",
      0.005
    ],
    [
      "glace",
      0.005
    ],
    [
      "desargente",
      0.005
    ],
    [
      "deplaisant",
      0.005
    ],
    [
      "bref",
      0.005
    ],
    [
      "blessant",
      0.005
    ],
    [
      "egoiste",
      0.0025
    ],
    [
      "secot",
      0.0025
    ],
    [
      "sechement",
      0.0025
    ],
    [
      "rudement",
      0.0025
    ],
    [
      "impecunieux",
      0.0025
    ],
    [
      "improductif",
      0.0025
    ],
    [
      "fauche",
      0.0025
    ],
    [
      "desobligeant",
      0.0025
    ],
    [
      "pince",
      0.0
    ],
    [
      "racorni",
      0.0
    ],
    [
      "rapidement",
      0.0
    ],
    [
      "seul",
      0.0
    ],
    [
      "seche",
      0.0
    ],
    [
      "vide",
      0.0
    ],
    [
      "emacie",
      0.0
    ],
    [
      "maigrelet",
      0.0
    ],
    [
      "ferme",
      0.0
    ],
    [
      "essuye",
      0.0
    ],
    [
      "endurci",
      0.0
    ],
    [
      "efflanque",
      0.0
    ],
    [
      "desertique",
      0.0
    ],
    [
      "dessechant",
      0.0
    ],
    [
      "concis",
      0.0
    ],
    [
      "brutalement",
      0.0
    ],
    [
      "asseche",
      0.0
    ],
    [
      "etrique",
      0.0
    ]
  ],
  "passion": [
    [
      "ardeur",
      0.07
    ],
    [
      "exaltation",
      0.05
    ],
    [
      "bouillonnement",
      0.045
    ],
    [
      "chaleur",
      0.0425
    ],
    [
      "amour",
      0.0425
    ],
    [
      "enthousiasme",
      0.04
    ],
    [
      "frenesie",
      0.035
    ],
    [
      "fureur",
      0.0325
    ],
    [
      "fanatisme",
      0.0275
    ],
    [
      "flamme",
      0.025
    ],
    [
      "feu",
      0.025
    ],
    [
      "transport",
      0.0225
    ],
    [
      "delire",
      0.0225
    ],
    [
      "agitation",
      0.0225
    ],
    [
      "emportement",
      0.0225
    ],
    [
      "fievre",
      0.0225
    ],
    [
      "excitation",
      0.02
    ],
    [
      "emotion",
      0.0175
    ],
    [
      "affection",
      0.015
    ],
    [
      "attachement",
      0.015
    ],
    [
      "manie",
      0.015
    ],
    [
      "mouvement",
      0.015
    ],
    [
      "gout",
      0.015
    ],
    [
      "folie",
      0.0125
    ],
    [
      "engouement",
      0.0125
    ],
    [
      "inclination",
      0.0125
    ],
    [
      "emballement",
      0.0125
    ],
    [
      "desir",
      0.01
    ],
    [
      "elan",
      0.01
    ],
    [
      "toquade",
      0.01
    ],
    [
      "rage",
      0.01
    ],
    [
      "coeur",
      0.01
    ],
    [
      "zele",
      0.0075
    ],
    [
      "vehemence",
      0.0075
    ],
    [
      "animation",
      0.0075
    ],
    [
      "adoration",
      0.0075
    ],
    [
      "penchant",
      0.0075
    ],
    [
      "violence",
      0.005
    ],
    [
      "trouble",
      0.005
    ],
    [
      "tendresse",
      0.005
    ],
    [
      "sentiment",
      0.005
    ],
    [
      "admiration",
      0.005
    ],
    [
      "caprice",
      0.005
    ],
    [
      "furie",
      0.005
    ],
    [
      "ivresse",
      0.005
    ],
    [
      "marotte",
      0.0025
    ],
    [
      "maladie",
      0.0025
    ],
    [
      "faible",
      0.0025
    ],
    [
      "mode",
      0.0025
    ],
    [
      "interet",
      0.0025
    ],
    [
      "habitude",
      0.0025
    ],
    [
      "courage",
      0.0025
    ],
    [
      "convoitise",
      0.0025
    ],
    [
      "avidite",
      0.0025
    ],
    [
      "attache",
      0.0025
    ],
    [
      "appetit",
      0.0025
    ],
    [
      "vice",
      0.0025
    ],
    [
      "liaison",
      0.0025
    ],
    [
      "entichement",
      0.0025
    ],
    [
      "culte",
      0.0025
    ],
    [
      "veneration",
      0.0
    ],
    [
      "vie",
      0.0
    ],
    [
      "sensibilite",
      0.0
    ],
    [
      "preference",
      0.0
    ],
    [
      "passade",
      0.0
    ],
    [
      "idolatrie",
      0.0
    ],
    [
      "fascination",
      0.0
    ],
    [
      "embrasement",
      0.0
    ],
    [
      "demangeaison",
      0.0
    ],
    [
      "beguin",
      0.0
    ],
    [
      "appetence",
      0.0
    ],
    [
      "ambition",
      0.0
    ],
    [
      "prevention",
      0.0
    ],
    [
      "souffrance",
      0.0
    ],
    [
      "tarentule",
      0.0
    ],
    [
      "tentation",
      0.0
    ],
    [
      "violon",
      0.0
    ],
    [
      "vocation",
      0.0
    ],
    [
      "prejuge",
      0.0
    ],
    [
      "predisposition",
      0.0
    ],
    [
      "pathetique",
      0.0
    ],
    [
      "oeilleres",
      0.0
    ],
    [
      "lyrisme",
      0.0
    ],
    [
      "envoutement",
      0.0
    ],
    [
      "ensorcellement",
      0.0
    ],
    [
      "brasier",
      0.0
    ],
    [
      "avarice",
      0.0
    ],
    [
      "adulation",
      0.0
    ],
    [
      "erethisme",
      0.0
    ]
  ],
  "reconnaissance": [
    [
      "exploration",
      0.0975
    ],
    [
      "recherche",
      0.085
    ],
    [
      "examen",
      0.0675
    ],
    [
      "obligation",
      0.0425
    ],
    [
      "investigation",
      0.0425
    ],
    [
      "inspection",
      0.0425
    ],
    [
      "gratitude",
      0.0425
    ],
    [
      "confession",
      0.0425
    ],
    [
      "titre",
      0.025
    ],
    [
      "recepisse",
      0.025
    ],
    [
      "recu",
      0.025
    ],
    [
      "remerciement",
      0.025
    ],
    [
      "perquisition",
      0.025
    ],
    [
      "memoire",
      0.025
    ],
    [
      "incursion",
      0.025
    ],
    [
      "chevauchee",
      0.025
    ],
    [
      "benediction",
      0.025
    ],
    [
      "billet",
      0.025
    ],
    [
      "legitimation",
      0.0125
    ],
    [
      "observation",
      0.0125
    ],
    [
      "prospection",
      0.0125
    ],
    [
      "quittance",
      0.0125
    ],
    [
      "recognition",
      0.0125
    ],
    [
      "recompense",
      0.0125
    ],
    [
      "sondage",
      0.0125
    ],
    [
      "souvenir",
      0.0125
    ],
    [
      "lecture",
      0.0125
    ],
    [
      "gre",
      0.0125
    ],
    [
      "acception",
      0.0125
    ],
    [
      "arraisonnement",
      0.0125
    ],
    [
      "aveu",
      0.0125
    ],
    [
      "decouverte",
      0.0125
    ],
    [
      "engagement",
      0.0125
    ],
    [
      "filiation",
      0.0125
    ],
    [
      "verification",
      0.0125
    ]
  ],
  "espece": [
    [
      "sorte",
      0.105
    ],
    [
      "genre",
      0.0975
    ],
    [
      "type",
      0.0975
    ],
    [
      "classe",
      0.09
    ],
    [
      "categorie",
      0.06
    ],
    [
      "nature",
      0.06
    ],
    [
      "acabit",
      0.045
    ],
    [
      "qualite",
      0.035
    ],
    [
      "calibre",
      0.03
    ],
    [
      "division",
      0.03
    ],
    [
      "famille",
      0.03
    ],
    [
      "gabarit",
      0.03
    ],
    [
      "ordre",
      0.03
    ],
    [
      "etat",
      0.0225
    ],
    [
      "variete",
      0.0225
    ],
    [
      "race",
      0.0225
    ],
    [
      "maniere",
      0.0225
    ],
    [
      "groupe",
      0.0225
    ],
    [
      "echantillon",
      0.0125
    ],
    [
      "condition",
      0.0125
    ],
    [
      "cause",
      0.0125
    ],
    [
      "cas",
      0.0125
    ],
    [
      "taxon",
      0.005
    ],
    [
      "specimen",
      0.005
    ],
    [
      "hybridation",
      0.005
    ],
    [
      "homme",
      0.005
    ],
    [
      "gent",
      0.005
    ],
    [
      "fonds",
      0.005
    ],
    [
      "facon",
      0.005
    ],
    [
      "consecration",
      0.005
    ],
    [
      "argent",
      0.005
    ],
    [
      "affaire",
      0.005
    ],
    [
      "etoffe",
      0.005
    ]
  ],
  "heberger": [
    [
      "accueillir",
      0.2
    ],
    [
      "recevoir",
      0.2
    ],
    [
      "loger",
      0.1325
    ],
    [
      "traiter",
      0.1325
    ],
    [
      "abriter",
      0.065
    ],
    [
      "prendre",
      0.065
    ]
  ],
  "attaquer": [
    [
      "atteindre",
      0.0275
    ],
    [
      "accuser",
      0.025
    ],
    [
      "toucher",
      0.025
    ],
    [
      "critiquer",
      0.025
    ],
    [
      "detruire",
      0.025
    ],
    [
      "battre",
      0.0225
    ],
    [
      "entamer",
      0.0225
    ],
    [
      "vilipender",
      0.02
    ],
    [
      "piquer",
      0.0175
    ],
    [
      "prendre",
      0.0175
    ],
    [
      "mordre",
      0.015
    ],
    [
      "frapper",
      0.015
    ],
    [
      "fondre",
      0.015
    ],
    [
      "denigrer",
      0.015
    ],
    [
      "discrediter",
      0.015
    ],
    [
      "combattre",
      0.015
    ],
    [
      "assaillir",
      0.015
    ],
    [
      "alterer",
      0.015
    ],
    [
      "ronger",
      0.0125
    ],
    [
      "presser",
      0.0125
    ],
    [
      "pousser",
      0.0125
    ],
    [
      "heurter",
      0.0125
    ],
    [
      "harceler",
      0.0125
    ],
    [
      "foncer",
      0.0125
    ],
    [
      "engager",
      0.0125
    ],
    [
      "charger",
      0.0125
    ],
    [
      "calomnier",
      0.0125
    ],
    [
      "braver",
      0.0125
    ],
    [
      "ebranler",
      0.0125
    ],
    [
      "s'elever",
      0.0125
    ],
    [
      "provoquer",
      0.0125
    ],
    [
      "commencer",
      0.0125
    ],
    [
      "blamer",
      0.0125
    ],
    [
      "affronter",
      0.0125
    ],
    [
      "sauter",
      0.01
    ],
    [
      "s'attaquer",
      0.01
    ],
    [
      "manger",
      0.01
    ],
    [
      "defier",
      0.01
    ],
    [
      "diffamer",
      0.01
    ],
    [
      "corroder",
      0.01
    ],
    [
      "assieger",
      0.01
    ],
    [
      "affecter",
      0.01
    ],
    [
      "vituperer",
      0.0075
    ],
    [
      "protester",
      0.0075
    ],
    [
      "nuire",
      0.0075
    ],
    [
      "medire",
      0.0075
    ],
    [
      "flageller",
      0.0075
    ],
    [
      "entreprendre",
      0.0075
    ],
    [
      "endommager",
      0.0075
    ],
    [
      "corrompre",
      0.0075
    ],
    [
      "bombarder",
      0.0075
    ],
    [
      "aborder",
      0.0075
    ],
    [
      "miner",
      0.005
    ],
    [
      "surprendre",
      0.005
    ],
    [
      "tempeter",
      0.005
    ],
    [
      "leser",
      0.005
    ],
    [
      "invectiver",
      0.005
    ],
    [
      "cingler",
      0.005
    ],
    [
      "contester",
      0.005
    ],
    [
      "deprecier",
      0.005
    ],
    [
      "deteriorer",
      0.005
    ],
    [
      "incriminer",
      0.005
    ],
    [
      "injurier",
      0.005
    ],
    [
      "insulter",
      0.005
    ],
    [
      "imputer",
      0.0025
    ],
    [
      "investir",
      0.0025
    ],
    [
      "lutter",
      0.0025
    ],
    [
      "narguer",
      0.0025
    ],
    [
      "ouvrir",
      0.0025
    ],
    [
      "quereller",
      0.0025
    ],
    [
      "envelopper",
      0.0025
    ],
    [
      "entourer",
      0.0025
    ],
    [
      "encercler",
      0.0025
    ],
    [
      "agresser",
      0.0025
    ],
    [
      "amorcer",
      0.0025
    ],
    [
      "arguer",
      0.0025
    ],
    [
      "canonner",
      0.0025
    ],
    [
      "cerner",
      0.0025
    ],
    [
      "devaliser",
      0.0025
    ],
    [
      "jouer",
      0.0
    ],
    [
      "molester",
      0.0
    ],
    [
      "intenter",
      0.0
    ],
    [
      "infester",
      0.0
    ],
    [
      "fronder",
      0.0
    ],
    [
      "braquer",
      0.0
    ]
  ],
  "autant": [
    [
      "aussi",
      0.4
    ],
    [
      "tant",
      0.2
    ],
    [
      "egalement",
      0.2
    ]
  ],
  "ramer": [
    [
      "canoter",
      0.1425
    ],
    [
      "godiller",
      0.1425
    ],
    [
      "nager",
      0.1425
    ],
    [
      "pagayer",
      0.1425
    ],
    [
      "souquer",
      0.1425
    ],
    [
      "tuteurer",
      0.1425
    ],
    [
      "voguer",
      0.1425
    ]
  ],
  "stock": [
    [
      "approvisionnement",
      0.23
    ],
    [
      "assortiment",
      0.1525
    ],
    [
      "provision",
      0.1525
    ],
    [
      "reserve",
      0.1525
    ],
    [
      "achalandage",
      0.075
    ],
    [
      "depot",
      0.075
    ],
    [
      "lot",
      0.075
    ],
    [
      "surplus",
      0.075
    ]
  ],
  "arrivee": [
    [
      "parvenir",
      0.06
    ],
    [
      "tomber",
      0.0525
    ],
    [
      "venir",
      0.0525
    ],
    [
      "atteindre",
      0.0475
    ],
    [
      "surgir",
      0.045
    ],
    [
      "survenir",
      0.045
    ],
    [
      "aller",
      0.04
    ],
    [
      "gagner",
      0.0325
    ],
    [
      "aborder",
      0.03
    ],
    [
      "aboutir",
      0.03
    ],
    [
      "accoster",
      0.03
    ],
    [
      "toucher",
      0.03
    ],
    [
      "reussir",
      0.025
    ],
    [
      "percer",
      0.025
    ],
    [
      "advenir",
      0.02
    ],
    [
      "apparaitre",
      0.02
    ],
    [
      "monter",
      0.02
    ],
    [
      "s'elever",
      0.0175
    ],
    [
      "approcher",
      0.0175
    ],
    [
      "acceder",
      0.0175
    ],
    [
      "entrer",
      0.0125
    ],
    [
      "emerger",
      0.01
    ],
    [
      "s'approcher",
      0.01
    ],
    [
      "s'accomplir",
      0.01
    ],
    [
      "pointer",
      0.01
    ],
    [
      "joindre",
      0.01
    ],
    [
      "affluer",
      0.01
    ],
    [
      "echoir",
      0.005
    ],
    [
      "suivre",
      0.005
    ],
    [
      "finir",
      0.005
    ],
    [
      "accourir",
      0.005
    ],
    [
      "surprendre",
      0.0025
    ],
    [
      "sonner",
      0.0025
    ],
    [
      "s'ensuivre",
      0.0025
    ],
    [
      "s'abouler",
      0.0025
    ],
    [
      "preceder",
      0.0025
    ],
    [
      "debarquer",
      0.0025
    ],
    [
      "devancer",
      0.0025
    ],
    [
      "atterrir",
      0.0025
    ],
    [
      "amerrir",
      0.0025
    ],
    [
      "abattre",
      0.0025
    ]
  ],
  "chavirer": [
    [
      "bouleverser",
      0.1125
    ],
    [
      "renverser",
      0.075
    ],
    [
      "revolutionner",
      0.0625
    ],
    [
      "culbuter",
      0.05
    ],
    [
      "emouvoir",
      0.035
    ],
    [
      "ebranler",
      0.035
    ],
    [
      "verser",
      0.035
    ],
    [
      "tituber",
      0.035
    ],
    [
      "sombrer",
      0.035
    ],
    [
      "secouer",
      0.035
    ],
    [
      "retourner",
      0.035
    ],
    [
      "couler",
      0.035
    ],
    [
      "chanceler",
      0.035
    ],
    [
      "bousculer",
      0.035
    ],
    [
      "basculer",
      0.035
    ],
    [
      "etourdir",
      0.025
    ],
    [
      "vaciller",
      0.025
    ],
    [
      "capoter",
      0.025
    ],
    [
      "transporter",
      0.01
    ],
    [
      "toucher",
      0.01
    ],
    [
      "tanguer",
      0.01
    ],
    [
      "s'enfoncer",
      0.01
    ],
    [
      "s'abimer",
      0.01
    ],
    [
      "pamer",
      0.01
    ],
    [
      "dessaler",
      0.01
    ],
    [
      "cabaner",
      0.01
    ],
    [
      "barbouiller",
      0.01
    ],
    [
      "trebucher",
      0.01
    ]
  ],
  "deplacer": [
    [
      "changer",
      0.0925
    ],
    [
      "transporter",
      0.0825
    ],
    [
      "deranger",
      0.0625
    ],
    [
      "enlever",
      0.05
    ],
    [
      "remuer",
      0.05
    ],
    [
      "transplanter",
      0.04
    ],
    [
      "pousser",
      0.04
    ],
    [
      "demenager",
      0.04
    ],
    [
      "detourner",
      0.03
    ],
    [
      "mouvoir",
      0.02
    ],
    [
      "muter",
      0.02
    ],
    [
      "nommer",
      0.02
    ],
    [
      "reculer",
      0.02
    ],
    [
      "rouler",
      0.02
    ],
    [
      "revoquer",
      0.02
    ],
    [
      "transferer",
      0.02
    ],
    [
      "transposer",
      0.02
    ],
    [
      "oter",
      0.02
    ],
    [
      "manipuler",
      0.02
    ],
    [
      "intervertir",
      0.02
    ],
    [
      "affecter",
      0.02
    ],
    [
      "bouger",
      0.02
    ],
    [
      "destituer",
      0.02
    ],
    [
      "decaler",
      0.02
    ],
    [
      "demettre",
      0.02
    ],
    [
      "deporter",
      0.02
    ],
    [
      "deraciner",
      0.02
    ],
    [
      "detroner",
      0.02
    ],
    [
      "envoyer",
      0.02
    ],
    [
      "inverser",
      0.0075
    ],
    [
      "excentrer",
      0.0075
    ],
    [
      "desacclimater",
      0.0075
    ],
    [
      "deriver",
      0.0075
    ],
    [
      "deloger",
      0.0075
    ],
    [
      "declasser",
      0.0075
    ],
    [
      "deboiter",
      0.0075
    ],
    [
      "accrocher",
      0.0075
    ],
    [
      "limoger",
      0.0075
    ]
  ],
  "montagne": [
    [
      "monceau",
      0.1075
    ],
    [
      "tas",
      0.1075
    ],
    [
      "accumulation",
      0.075
    ],
    [
      "amas",
      0.075
    ],
    [
      "mont",
      0.075
    ],
    [
      "amoncellement",
      0.06
    ],
    [
      "entassement",
      0.045
    ],
    [
      "monticule",
      0.045
    ],
    [
      "eminence",
      0.03
    ],
    [
      "quantite",
      0.03
    ],
    [
      "masse",
      0.03
    ],
    [
      "hauteur",
      0.03
    ],
    [
      "fatras",
      0.03
    ],
    [
      "colline",
      0.03
    ],
    [
      "puy",
      0.0125
    ],
    [
      "paturage",
      0.0125
    ],
    [
      "roche",
      0.0125
    ],
    [
      "sierra",
      0.0125
    ],
    [
      "sommet",
      0.0125
    ],
    [
      "volcan",
      0.0125
    ],
    [
      "piton",
      0.0125
    ],
    [
      "pile",
      0.0125
    ],
    [
      "fouillis",
      0.0125
    ],
    [
      "alpage",
      0.0125
    ],
    [
      "accident",
      0.0125
    ],
    [
      "elevation",
      0.0125
    ]
  ],
  "foi": [
    [
      "croyance",
      0.1
    ],
    [
      "conviction",
      0.0525
    ],
    [
      "honnetete",
      0.045
    ],
    [
      "religion",
      0.045
    ],
    [
      "verite",
      0.045
    ],
    [
      "esperance",
      0.04
    ],
    [
      "dogme",
      0.04
    ],
    [
      "credo",
      0.04
    ],
    [
      "certitude",
      0.04
    ],
    [
      "loyaute",
      0.0325
    ],
    [
      "fidelite",
      0.0325
    ],
    [
      "assurance",
      0.025
    ],
    [
      "confiance",
      0.025
    ],
    [
      "conscience",
      0.025
    ],
    [
      "zele",
      0.025
    ],
    [
      "probite",
      0.0175
    ],
    [
      "promesse",
      0.0175
    ],
    [
      "sincerite",
      0.0175
    ],
    [
      "evangile",
      0.0175
    ],
    [
      "parole",
      0.0175
    ],
    [
      "franchise",
      0.0175
    ],
    [
      "exactitude",
      0.0175
    ],
    [
      "droiture",
      0.0175
    ],
    [
      "culte",
      0.0175
    ],
    [
      "confession",
      0.0175
    ],
    [
      "temoignage",
      0.0125
    ],
    [
      "opinion",
      0.0125
    ],
    [
      "honneur",
      0.0125
    ],
    [
      "hommage",
      0.0125
    ],
    [
      "fanatisme",
      0.0125
    ],
    [
      "engagement",
      0.0125
    ],
    [
      "theogonie",
      0.005
    ],
    [
      "spiritualite",
      0.005
    ],
    [
      "serment",
      0.005
    ],
    [
      "perfidie",
      0.005
    ],
    [
      "mystique",
      0.005
    ],
    [
      "mysticisme",
      0.005
    ],
    [
      "fourberie",
      0.005
    ],
    [
      "faussete",
      0.005
    ],
    [
      "creance",
      0.005
    ],
    [
      "catechisme",
      0.005
    ],
    [
      "autorite",
      0.005
    ],
    [
      "eglise",
      0.005
    ]
  ],
  "baisse": [
    [
      "abaissement",
      0.16
    ],
    [
      "diminution",
      0.1375
    ],
    [
      "declin",
      0.075
    ],
    [
      "affaiblissement",
      0.0525
    ],
    [
      "chute",
      0.0525
    ],
    [
      "depreciation",
      0.045
    ],
    [
      "degenerescence",
      0.045
    ],
    [
      "decroissance",
      0.045
    ],
    [
      "affaissement",
      0.045
    ],
    [
      "ralentissement",
      0.0275
    ],
    [
      "regression",
      0.0225
    ],
    [
      "reduction",
      0.0225
    ],
    [
      "devaluation",
      0.0225
    ],
    [
      "depression",
      0.0225
    ],
    [
      "avilissement",
      0.0225
    ],
    [
      "rabaissement",
      0.0125
    ],
    [
      "rabais",
      0.0125
    ],
    [
      "mouvement",
      0.0125
    ],
    [
      "flechissement",
      0.0125
    ],
    [
      "effondrement",
      0.0125
    ],
    [
      "deterioration",
      0.0125
    ],
    [
      "decrue",
      0.0125
    ],
    [
      "decroissement",
      0.0125
    ],
    [
      "descente",
      0.0125
    ],
    [
      "amoindrissement",
      0.0125
    ],
    [
      "tassement",
      0.005
    ],
    [
      "reflux",
      0.005
    ],
    [
      "perte",
      0.005
    ],
    [
      "faiblissement",
      0.005
    ],
    [
      "baissement",
      0.005
    ],
    [
      "etiage",
      0.005
    ]
  ],
  "indenombrable": [
    [
      "illimite",
      0.2
    ],
    [
      "incalculable",
      0.2
    ],
    [
      "incommensurable",
      0.2
    ],
    [
      "infini",
      0.2
    ],
    [
      "innombrable",
      0.2
    ]
  ],
  "bac": [
    [
      "bachot",
      0.0975
    ],
    [
      "barque",
      0.0975
    ],
    [
      "bateau",
      0.0975
    ],
    [
      "navette",
      0.0625
    ],
    [
      "embarcation",
      0.0625
    ],
    [
      "coche",
      0.0625
    ],
    [
      "bassin",
      0.0625
    ],
    [
      "baquet",
      0.0625
    ],
    [
      "auge",
      0.0625
    ],
    [
      "traversier",
      0.03
    ],
    [
      "traille",
      0.03
    ],
    [
      "toue",
      0.03
    ],
    [
      "timbre",
      0.03
    ],
    [
      "examen",
      0.03
    ],
    [
      "cuve",
      0.03
    ],
    [
      "baccalaureat",
      0.03
    ]
  ],
  "pro": [],
  "decouvert": [
    [
      "deficit",
      0.105
    ],
    [
      "degage",
      0.105
    ],
    [
      "revele",
      0.0525
    ],
    [
      "penetre",
      0.0525
    ],
    [
      "ouvert",
      0.0525
    ],
    [
      "nu",
      0.0525
    ],
    [
      "invente",
      0.0525
    ],
    [
      "flambe",
      0.0525
    ],
    [
      "expose",
      0.0525
    ],
    [
      "denude",
      0.0525
    ],
    [
      "decollete",
      0.0525
    ],
    [
      "deboise",
      0.0525
    ],
    [
      "dette",
      0.0525
    ],
    [
      "connu",
      0.0525
    ],
    [
      "compte",
      0.0525
    ],
    [
      "apercu",
      0.0525
    ],
    [
      "trouve",
      0.0525
    ]
  ],
  "decouvrir": [
    [
      "reveler",
      0.08
    ],
    [
      "apercevoir",
      0.0525
    ],
    [
      "reperer",
      0.05
    ],
    [
      "saisir",
      0.0475
    ],
    [
      "deviner",
      0.04
    ],
    [
      "voir",
      0.0325
    ],
    [
      "montrer",
      0.0325
    ],
    [
      "comprendre",
      0.0325
    ],
    [
      "remarquer",
      0.0275
    ],
    [
      "trouver",
      0.0275
    ],
    [
      "penetrer",
      0.025
    ],
    [
      "declarer",
      0.025
    ],
    [
      "deceler",
      0.025
    ],
    [
      "discerner",
      0.0225
    ],
    [
      "dire",
      0.02
    ],
    [
      "devoiler",
      0.02
    ],
    [
      "percer",
      0.02
    ],
    [
      "signaler",
      0.0175
    ],
    [
      "indiquer",
      0.0175
    ],
    [
      "exposer",
      0.0175
    ],
    [
      "percevoir",
      0.0125
    ],
    [
      "sentir",
      0.0125
    ],
    [
      "communiquer",
      0.01
    ],
    [
      "reconnaitre",
      0.01
    ],
    [
      "surprendre",
      0.01
    ],
    [
      "publier",
      0.01
    ],
    [
      "afficher",
      0.01
    ],
    [
      "exprimer",
      0.0075
    ],
    [
      "etaler",
      0.0075
    ],
    [
      "trahir",
      0.0075
    ],
    [
      "lire",
      0.0075
    ],
    [
      "imaginer",
      0.0075
    ],
    [
      "depister",
      0.0075
    ],
    [
      "demasquer",
      0.0075
    ],
    [
      "degager",
      0.0075
    ],
    [
      "dechiffrer",
      0.0075
    ],
    [
      "constater",
      0.0075
    ],
    [
      "concevoir",
      0.0075
    ],
    [
      "livrer",
      0.005
    ],
    [
      "detecter",
      0.005
    ],
    [
      "denoncer",
      0.005
    ],
    [
      "divulguer",
      0.005
    ],
    [
      "distinguer",
      0.005
    ],
    [
      "apprendre",
      0.005
    ],
    [
      "eventer",
      0.0025
    ],
    [
      "etablir",
      0.0025
    ],
    [
      "s'apercevoir",
      0.0025
    ],
    [
      "observer",
      0.0025
    ],
    [
      "entrevoir",
      0.0025
    ],
    [
      "deshabiller",
      0.0025
    ],
    [
      "denuder",
      0.0025
    ],
    [
      "confier",
      0.0025
    ],
    [
      "confesser",
      0.0025
    ],
    [
      "avouer",
      0.0025
    ],
    [
      "arracher",
      0.0025
    ],
    [
      "relever",
      0.0025
    ],
    [
      "s'aviser",
      0.0025
    ],
    [
      "s'ouvrir",
      0.0025
    ],
    [
      "sonder",
      0.0025
    ],
    [
      "epancher",
      0.0025
    ],
    [
      "oter",
      0.0025
    ],
    [
      "ouvrir",
      0.0025
    ],
    [
      "inventer",
      0.0025
    ],
    [
      "enlever",
      0.0025
    ],
    [
      "deterrer",
      0.0025
    ],
    [
      "denicher",
      0.0025
    ],
    [
      "creer",
      0.0025
    ],
    [
      "embrasser",
      0.0
    ],
    [
      "chercher",
      0.0
    ],
    [
      "aviser",
      0.0
    ],
    [
      "tatonner",
      0.0
    ],
    [
      "recruter",
      0.0
    ],
    [
      "exhumer",
      0.0
    ],
    [
      "envisager",
      0.0
    ],
    [
      "degoter",
      0.0
    ],
    [
      "degarnir",
      0.0
    ],
    [
      "deculotter",
      0.0
    ],
    [
      "decolleter",
      0.0
    ],
    [
      "decapoter",
      0.0
    ],
    [
      "acquerir",
      0.0
    ]
  ],
  "patron": [
    [
      "chef",
      0.1
    ],
    [
      "modele",
      0.0825
    ],
    [
      "maitre",
      0.065
    ],
    [
      "singe",
      0.0475
    ],
    [
      "protecteur",
      0.0475
    ],
    [
      "forme",
      0.0475
    ],
    [
      "directeur",
      0.0475
    ],
    [
      "dessin",
      0.0475
    ],
    [
      "ame",
      0.0325
    ],
    [
      "tenancier",
      0.0325
    ],
    [
      "manitou",
      0.0325
    ],
    [
      "gabarit",
      0.0325
    ],
    [
      "carton",
      0.0325
    ],
    [
      "exemplaire",
      0.015
    ],
    [
      "mandarin",
      0.015
    ],
    [
      "moule",
      0.015
    ],
    [
      "negrier",
      0.015
    ],
    [
      "patricien",
      0.015
    ],
    [
      "plastron",
      0.015
    ],
    [
      "pochoir",
      0.015
    ],
    [
      "ponte",
      0.015
    ],
    [
      "superieur",
      0.015
    ],
    [
      "entrepreneur",
      0.015
    ],
    [
      "employeur",
      0.015
    ],
    [
      "appui",
      0.015
    ],
    [
      "artisan",
      0.015
    ],
    [
      "bienfaiteur",
      0.015
    ],
    [
      "boss",
      0.015
    ],
    [
      "bourgeois",
      0.015
    ],
    [
      "cabaretier",
      0.015
    ],
    [
      "capitaine",
      0.015
    ],
    [
      "daron",
      0.015
    ],
    [
      "doyen",
      0.015
    ],
    [
      "tuteur",
      0.015
    ]
  ],
  "conquete": [
    [
      "occupation",
      0.085
    ],
    [
      "assujettissement",
      0.0625
    ],
    [
      "possession",
      0.0625
    ],
    [
      "soumission",
      0.0425
    ],
    [
      "prise",
      0.0425
    ],
    [
      "gain",
      0.0425
    ],
    [
      "envahissement",
      0.0425
    ],
    [
      "domination",
      0.0425
    ],
    [
      "domestication",
      0.0425
    ],
    [
      "butin",
      0.0425
    ],
    [
      "attaque",
      0.0425
    ],
    [
      "appropriation",
      0.0425
    ],
    [
      "apprivoisement",
      0.0425
    ],
    [
      "agression",
      0.0425
    ],
    [
      "deduction",
      0.02
    ],
    [
      "guerre",
      0.02
    ],
    [
      "obtention",
      0.02
    ],
    [
      "resultat",
      0.02
    ],
    [
      "sympathie",
      0.02
    ],
    [
      "seduction",
      0.02
    ],
    [
      "decouverte",
      0.02
    ],
    [
      "capture",
      0.02
    ],
    [
      "bien",
      0.02
    ],
    [
      "aventure",
      0.02
    ],
    [
      "amourette",
      0.02
    ],
    [
      "amour",
      0.02
    ],
    [
      "agrandissement",
      0.02
    ],
    [
      "acquis",
      0.02
    ],
    [
      "victoire",
      0.02
    ]
  ],
  "projet": [
    [
      "dessein",
      0.1225
    ],
    [
      "plan",
      0.11
    ],
    [
      "intention",
      0.065
    ],
    [
      "esquisse",
      0.0575
    ],
    [
      "ebauche",
      0.05
    ],
    [
      "dessin",
      0.0375
    ],
    [
      "etude",
      0.03
    ],
    [
      "vue",
      0.03
    ],
    [
      "pensee",
      0.03
    ],
    [
      "idee",
      0.03
    ],
    [
      "but",
      0.03
    ],
    [
      "calcul",
      0.025
    ],
    [
      "machination",
      0.025
    ],
    [
      "resolution",
      0.025
    ],
    [
      "theorie",
      0.025
    ],
    [
      "speculation",
      0.0175
    ],
    [
      "schema",
      0.0175
    ],
    [
      "proposition",
      0.0175
    ],
    [
      "programme",
      0.0175
    ],
    [
      "conseil",
      0.0175
    ],
    [
      "carton",
      0.0175
    ],
    [
      "canevas",
      0.0175
    ],
    [
      "preparation",
      0.0125
    ],
    [
      "propos",
      0.0125
    ],
    [
      "planning",
      0.0125
    ],
    [
      "maquette",
      0.0125
    ],
    [
      "complot",
      0.0125
    ],
    [
      "combinaison",
      0.0125
    ],
    [
      "carcasse",
      0.0125
    ],
    [
      "topo",
      0.005
    ],
    [
      "suggestion",
      0.005
    ],
    [
      "premeditation",
      0.005
    ],
    [
      "lineaments",
      0.005
    ],
    [
      "espoir",
      0.005
    ],
    [
      "entreprise",
      0.005
    ],
    [
      "devis",
      0.005
    ],
    [
      "conspiration",
      0.005
    ],
    [
      "ambition",
      0.005
    ],
    [
      "utopie",
      0.005
    ]
  ],
  "suicidaire": [
    [
      "suicidant",
      0.3325
    ],
    [
      "suicide",
      0.3325
    ],
    [
      "suicideur",
      0.3325
    ]
  ],
  "armure": [
    [
      "bouclier",
      0.12
    ],
    [
      "cuirasse",
      0.12
    ],
    [
      "cotte",
      0.08
    ],
    [
      "protection",
      0.08
    ],
    [
      "tissu",
      0.08
    ],
    [
      "defense",
      0.04
    ],
    [
      "harnais",
      0.04
    ],
    [
      "haubert",
      0.04
    ],
    [
      "panoplie",
      0.04
    ],
    [
      "tissage",
      0.04
    ],
    [
      "contexture",
      0.04
    ],
    [
      "casque",
      0.04
    ],
    [
      "carapace",
      0.04
    ],
    [
      "caparacon",
      0.04
    ],
    [
      "armeuse",
      0.04
    ],
    [
      "arme",
      0.04
    ],
    [
      "armature",
      0.04
    ],
    [
      "etoffe",
      0.04
    ]
  ],
  "foncer": [
    [
      "courir",
      0.0875
    ],
    [
      "fondre",
      0.0725
    ],
    [
      "s'elancer",
      0.0675
    ],
    [
      "attaquer",
      0.0525
    ],
    [
      "piquer",
      0.0425
    ],
    [
      "fuser",
      0.0425
    ],
    [
      "sauter",
      0.035
    ],
    [
      "voler",
      0.035
    ],
    [
      "bondir",
      0.02
    ],
    [
      "charger",
      0.02
    ],
    [
      "filer",
      0.02
    ],
    [
      "obscurcir",
      0.0125
    ],
    [
      "enfoncer",
      0.0125
    ],
    [
      "brunir",
      0.0125
    ],
    [
      "galoper",
      0.005
    ],
    [
      "gazer",
      0.005
    ],
    [
      "ombrer",
      0.005
    ],
    [
      "payer",
      0.005
    ],
    [
      "poursuivre",
      0.005
    ],
    [
      "s'obscurcir",
      0.005
    ],
    [
      "financer",
      0.005
    ],
    [
      "enjabler",
      0.005
    ],
    [
      "creuser",
      0.005
    ],
    [
      "casquer",
      0.005
    ],
    [
      "bomber",
      0.005
    ],
    [
      "batailler",
      0.005
    ],
    [
      "barouder",
      0.005
    ],
    [
      "assombrir",
      0.005
    ],
    [
      "sprinter",
      0.005
    ]
  ],
  "mur": [
    [
      "adulte",
      0.0975
    ],
    [
      "raisonnable",
      0.0725
    ],
    [
      "reflechi",
      0.0725
    ],
    [
      "pret",
      0.0475
    ],
    [
      "propre",
      0.0475
    ],
    [
      "pose",
      0.0475
    ],
    [
      "grand",
      0.0475
    ],
    [
      "fait",
      0.0475
    ],
    [
      "cuit",
      0.0475
    ],
    [
      "apte",
      0.0475
    ],
    [
      "accompli",
      0.0475
    ],
    [
      "pondere",
      0.0225
    ],
    [
      "prepare",
      0.0225
    ],
    [
      "rassis",
      0.0225
    ],
    [
      "soul",
      0.0225
    ],
    [
      "usage",
      0.0225
    ],
    [
      "use",
      0.0225
    ],
    [
      "pense",
      0.0225
    ],
    [
      "muri",
      0.0225
    ],
    [
      "medite",
      0.0225
    ],
    [
      "moyen",
      0.0225
    ],
    [
      "mature",
      0.0225
    ],
    [
      "ivre",
      0.0225
    ],
    [
      "developpe",
      0.0225
    ],
    [
      "elime",
      0.0225
    ]
  ],
  "fiston": [
    [
      "fils",
      0.5
    ],
    [
      "gars",
      0.5
    ]
  ],
  "preparer": [
    [
      "arranger",
      0.0575
    ],
    [
      "combiner",
      0.0575
    ],
    [
      "faire",
      0.05
    ],
    [
      "faconner",
      0.0375
    ],
    [
      "former",
      0.0375
    ],
    [
      "elaborer",
      0.03
    ],
    [
      "disposer",
      0.0275
    ],
    [
      "composer",
      0.0275
    ],
    [
      "mediter",
      0.025
    ],
    [
      "dresser",
      0.0225
    ],
    [
      "monter",
      0.0225
    ],
    [
      "organiser",
      0.0225
    ],
    [
      "tramer",
      0.02
    ],
    [
      "mijoter",
      0.02
    ],
    [
      "ourdir",
      0.02
    ],
    [
      "produire",
      0.02
    ],
    [
      "travailler",
      0.02
    ],
    [
      "appreter",
      0.0175
    ],
    [
      "fabriquer",
      0.0175
    ],
    [
      "cultiver",
      0.015
    ],
    [
      "manigancer",
      0.015
    ],
    [
      "premediter",
      0.015
    ],
    [
      "projeter",
      0.01
    ],
    [
      "nourrir",
      0.01
    ],
    [
      "menager",
      0.01
    ],
    [
      "labourer",
      0.01
    ],
    [
      "instruire",
      0.01
    ],
    [
      "fricoter",
      0.01
    ],
    [
      "concevoir",
      0.01
    ],
    [
      "calculer",
      0.01
    ],
    [
      "accommoder",
      0.01
    ],
    [
      "echafauder",
      0.0075
    ],
    [
      "tisser",
      0.0075
    ],
    [
      "prevoir",
      0.0075
    ],
    [
      "murir",
      0.0075
    ],
    [
      "entrainer",
      0.0075
    ],
    [
      "amenager",
      0.0075
    ],
    [
      "etudier",
      0.005
    ],
    [
      "ouvrir",
      0.005
    ],
    [
      "mettre",
      0.005
    ],
    [
      "machiner",
      0.005
    ],
    [
      "cuisiner",
      0.005
    ],
    [
      "concerter",
      0.005
    ],
    [
      "amener",
      0.005
    ],
    [
      "provoquer",
      0.005
    ],
    [
      "presager",
      0.005
    ],
    [
      "rouler",
      0.005
    ],
    [
      "reserver",
      0.005
    ],
    [
      "styler",
      0.005
    ],
    [
      "tresser",
      0.005
    ],
    [
      "ebaucher",
      0.005
    ],
    [
      "eduquer",
      0.005
    ],
    [
      "promettre",
      0.005
    ],
    [
      "parer",
      0.005
    ],
    [
      "faciliter",
      0.005
    ],
    [
      "accoutumer",
      0.005
    ],
    [
      "ameublir",
      0.005
    ],
    [
      "annoncer",
      0.005
    ],
    [
      "aplanir",
      0.005
    ],
    [
      "barder",
      0.005
    ],
    [
      "conspirer",
      0.005
    ],
    [
      "cuire",
      0.005
    ],
    [
      "deblayer",
      0.005
    ],
    [
      "fumer",
      0.0025
    ],
    [
      "goupiller",
      0.0025
    ],
    [
      "mitonner",
      0.0025
    ],
    [
      "nouer",
      0.0025
    ],
    [
      "piocher",
      0.0025
    ],
    [
      "potasser",
      0.0025
    ],
    [
      "proportionner",
      0.0025
    ],
    [
      "predisposer",
      0.0025
    ],
    [
      "fricasser",
      0.0025
    ],
    [
      "farcir",
      0.0025
    ],
    [
      "aguerrir",
      0.0025
    ],
    [
      "amender",
      0.0025
    ],
    [
      "arrimer",
      0.0025
    ],
    [
      "bucher",
      0.0025
    ],
    [
      "couver",
      0.0025
    ],
    [
      "destiner",
      0.0025
    ],
    [
      "dechaumer",
      0.0025
    ],
    [
      "defricher",
      0.0025
    ],
    [
      "frayer",
      0.0
    ],
    [
      "herser",
      0.0
    ],
    [
      "macher",
      0.0
    ],
    [
      "plumer",
      0.0
    ],
    [
      "preluder",
      0.0
    ],
    [
      "truffer",
      0.0
    ],
    [
      "enfanter",
      0.0
    ],
    [
      "corroyer",
      0.0
    ],
    [
      "concocter",
      0.0
    ],
    [
      "chiader",
      0.0
    ],
    [
      "becher",
      0.0
    ],
    [
      "brider",
      0.0
    ],
    [
      "braquer",
      0.0
    ],
    [
      "bachoter",
      0.0
    ],
    [
      "assaisonner",
      0.0
    ],
    [
      "appareiller",
      0.0
    ],
    [
      "vider",
      0.0
    ]
  ],
  "negligent": [
    [
      "inattentif",
      0.135
    ],
    [
      "insouciant",
      0.135
    ],
    [
      "etourdi",
      0.1125
    ],
    [
      "irreflechi",
      0.09
    ],
    [
      "indifferent",
      0.0675
    ],
    [
      "nonchalant",
      0.045
    ],
    [
      "indolent",
      0.045
    ],
    [
      "imprevoyant",
      0.045
    ],
    [
      "imprudent",
      0.045
    ],
    [
      "absent",
      0.045
    ],
    [
      "trainard",
      0.0225
    ],
    [
      "rossard",
      0.0225
    ],
    [
      "relache",
      0.0225
    ],
    [
      "paresseux",
      0.0225
    ],
    [
      "oublieux",
      0.0225
    ],
    [
      "morosif",
      0.0225
    ],
    [
      "inexistant",
      0.0225
    ],
    [
      "distrait",
      0.0225
    ],
    [
      "temeraire",
      0.0225
    ]
  ],
  "negliger": [
    [
      "oublier",
      0.13
    ],
    [
      "abandonner",
      0.105
    ],
    [
      "delaisser",
      0.08
    ],
    [
      "mepriser",
      0.0675
    ],
    [
      "omettre",
      0.045
    ],
    [
      "ecarter",
      0.045
    ],
    [
      "s'eloigner",
      0.0325
    ],
    [
      "meconnaitre",
      0.0325
    ],
    [
      "manquer",
      0.0325
    ],
    [
      "passer",
      0.0225
    ],
    [
      "excepter",
      0.0225
    ],
    [
      "detourner",
      0.0225
    ],
    [
      "deserter",
      0.0225
    ],
    [
      "dedaigner",
      0.0225
    ],
    [
      "s'abstenir",
      0.01
    ],
    [
      "saboter",
      0.01
    ],
    [
      "epargner",
      0.01
    ],
    [
      "relacher",
      0.01
    ],
    [
      "laisser",
      0.01
    ],
    [
      "dormir",
      0.01
    ],
    [
      "bacler",
      0.01
    ]
  ],
  "bienvenu": [
    [
      "juste",
      0.3325
    ],
    [
      "opportun",
      0.3325
    ]
  ],
  "invite": [
    [
      "appel",
      0.3
    ],
    [
      "invitation",
      0.2
    ],
    [
      "attaque",
      0.1
    ],
    [
      "attrait",
      0.1
    ],
    [
      "consigne",
      0.1
    ],
    [
      "exhortation",
      0.1
    ],
    [
      "ordre",
      0.1
    ]
  ],
  "inviter": [
    [
      "pousser",
      0.0975
    ],
    [
      "engager",
      0.0925
    ],
    [
      "exciter",
      0.08
    ],
    [
      "inciter",
      0.08
    ],
    [
      "provoquer",
      0.0625
    ],
    [
      "appeler",
      0.0475
    ],
    [
      "solliciter",
      0.0425
    ],
    [
      "entrainer",
      0.04
    ],
    [
      "attirer",
      0.04
    ],
    [
      "porter",
      0.035
    ],
    [
      "convier",
      0.03
    ],
    [
      "prier",
      0.03
    ],
    [
      "demander",
      0.025
    ],
    [
      "exhorter",
      0.025
    ],
    [
      "presser",
      0.02
    ],
    [
      "traiter",
      0.0175
    ],
    [
      "tenter",
      0.0175
    ],
    [
      "sommer",
      0.0175
    ],
    [
      "encourager",
      0.0175
    ],
    [
      "conseiller",
      0.0175
    ],
    [
      "charmer",
      0.0125
    ],
    [
      "incliner",
      0.0125
    ],
    [
      "recommander",
      0.0125
    ],
    [
      "supplier",
      0.0125
    ],
    [
      "reunir",
      0.0075
    ],
    [
      "regaler",
      0.0075
    ],
    [
      "retenir",
      0.0075
    ],
    [
      "induire",
      0.0075
    ],
    [
      "enjoindre",
      0.0075
    ],
    [
      "convoquer",
      0.0075
    ],
    [
      "stimuler",
      0.0025
    ],
    [
      "recevoir",
      0.0025
    ],
    [
      "ordonner",
      0.0025
    ],
    [
      "defier",
      0.0025
    ],
    [
      "attabler",
      0.0025
    ],
    [
      "asseoir",
      0.0025
    ],
    [
      "seduire",
      0.0025
    ]
  ],
  "diriger": [
    [
      "conduire",
      0.1175
    ],
    [
      "gouverner",
      0.08
    ],
    [
      "mener",
      0.0625
    ],
    [
      "commander",
      0.0475
    ],
    [
      "guider",
      0.0475
    ],
    [
      "regler",
      0.03
    ],
    [
      "regir",
      0.03
    ],
    [
      "pousser",
      0.03
    ],
    [
      "conseiller",
      0.0275
    ],
    [
      "orienter",
      0.0275
    ],
    [
      "porter",
      0.0275
    ],
    [
      "regenter",
      0.0225
    ],
    [
      "manier",
      0.0225
    ],
    [
      "inspirer",
      0.0225
    ],
    [
      "entrainer",
      0.0225
    ],
    [
      "determiner",
      0.0225
    ],
    [
      "administrer",
      0.0225
    ],
    [
      "appliquer",
      0.015
    ],
    [
      "manoeuvrer",
      0.015
    ],
    [
      "piloter",
      0.015
    ],
    [
      "tenir",
      0.015
    ],
    [
      "tourner",
      0.0125
    ],
    [
      "dominer",
      0.0125
    ],
    [
      "concentrer",
      0.0125
    ],
    [
      "canaliser",
      0.0125
    ],
    [
      "presider",
      0.01
    ],
    [
      "presenter",
      0.01
    ],
    [
      "pointer",
      0.01
    ],
    [
      "organiser",
      0.01
    ],
    [
      "ordonner",
      0.01
    ],
    [
      "incliner",
      0.01
    ],
    [
      "gerer",
      0.01
    ],
    [
      "centrer",
      0.01
    ],
    [
      "aiguiller",
      0.01
    ],
    [
      "etendre",
      0.005
    ],
    [
      "rapporter",
      0.005
    ],
    [
      "planifier",
      0.005
    ],
    [
      "naviguer",
      0.005
    ],
    [
      "maitriser",
      0.005
    ],
    [
      "chaperonner",
      0.005
    ],
    [
      "braquer",
      0.005
    ],
    [
      "attacher",
      0.005
    ],
    [
      "animer",
      0.005
    ],
    [
      "acheminer",
      0.005
    ],
    [
      "superviser",
      0.0025
    ],
    [
      "preceder",
      0.0025
    ],
    [
      "focaliser",
      0.0025
    ],
    [
      "expedier",
      0.0025
    ],
    [
      "emmener",
      0.0025
    ],
    [
      "cultiver",
      0.0025
    ],
    [
      "converger",
      0.0025
    ],
    [
      "barrer",
      0.0025
    ],
    [
      "tailler",
      0.0025
    ]
  ],
  "vers": [
    [
      "appat",
      0.165
    ],
    [
      "chenille",
      0.165
    ],
    [
      "esche",
      0.165
    ],
    [
      "larve",
      0.165
    ],
    [
      "stongle",
      0.165
    ],
    [
      "vermisseau",
      0.165
    ]
  ],
  "gloire": [
    [
      "illustration",
      0.09
    ],
    [
      "honneur",
      0.065
    ],
    [
      "eclat",
      0.065
    ],
    [
      "lumiere",
      0.0475
    ],
    [
      "reputation",
      0.0475
    ],
    [
      "splendeur",
      0.0475
    ],
    [
      "celebrite",
      0.035
    ],
    [
      "lustre",
      0.035
    ],
    [
      "prestige",
      0.03
    ],
    [
      "ornement",
      0.03
    ],
    [
      "apotheose",
      0.03
    ],
    [
      "triomphe",
      0.0225
    ],
    [
      "orgueil",
      0.0225
    ],
    [
      "majeste",
      0.0225
    ],
    [
      "estime",
      0.0225
    ],
    [
      "beaute",
      0.0225
    ],
    [
      "succes",
      0.015
    ],
    [
      "renommee",
      0.015
    ],
    [
      "rayonnement",
      0.015
    ],
    [
      "popularite",
      0.015
    ],
    [
      "merite",
      0.015
    ],
    [
      "grandeur",
      0.015
    ],
    [
      "glorification",
      0.015
    ],
    [
      "fleuron",
      0.015
    ],
    [
      "notoriete",
      0.01
    ],
    [
      "phare",
      0.01
    ],
    [
      "prince",
      0.01
    ],
    [
      "renom",
      0.01
    ],
    [
      "respect",
      0.01
    ],
    [
      "vertu",
      0.01
    ],
    [
      "magnificence",
      0.01
    ],
    [
      "lauriers",
      0.01
    ],
    [
      "aureole",
      0.01
    ],
    [
      "consecration",
      0.01
    ],
    [
      "fierte",
      0.01
    ],
    [
      "halo",
      0.01
    ],
    [
      "immortalite",
      0.01
    ],
    [
      "phenix",
      0.005
    ],
    [
      "personnage",
      0.005
    ],
    [
      "nom",
      0.005
    ],
    [
      "nimbe",
      0.005
    ],
    [
      "louange",
      0.005
    ],
    [
      "hommage",
      0.005
    ],
    [
      "apogee",
      0.005
    ],
    [
      "saintete",
      0.005
    ]
  ],
  "foutu": [
    [
      "ficher",
      0.23
    ],
    [
      "flanquer",
      0.115
    ],
    [
      "appliquer",
      0.0675
    ],
    [
      "mettre",
      0.055
    ],
    [
      "lancer",
      0.045
    ],
    [
      "jeter",
      0.045
    ],
    [
      "donner",
      0.045
    ],
    [
      "adresser",
      0.045
    ],
    [
      "allonger",
      0.0325
    ],
    [
      "fabriquer",
      0.0325
    ],
    [
      "faire",
      0.0325
    ],
    [
      "placer",
      0.0225
    ],
    [
      "fricoter",
      0.0225
    ],
    [
      "fourrer",
      0.0225
    ],
    [
      "branler",
      0.0225
    ],
    [
      "bougre",
      0.0225
    ],
    [
      "administrer",
      0.0225
    ],
    [
      "releguer",
      0.01
    ],
    [
      "maquiller",
      0.01
    ],
    [
      "fichtre",
      0.01
    ],
    [
      "enfiler",
      0.01
    ],
    [
      "diable",
      0.01
    ],
    [
      "cyprine",
      0.01
    ],
    [
      "baiser",
      0.01
    ],
    [
      "tringler",
      0.01
    ]
  ],
  "situation": [
    [
      "position",
      0.1675
    ],
    [
      "etat",
      0.0725
    ],
    [
      "place",
      0.06
    ],
    [
      "fonction",
      0.045
    ],
    [
      "metier",
      0.045
    ],
    [
      "condition",
      0.04
    ],
    [
      "disposition",
      0.0325
    ],
    [
      "rang",
      0.03
    ],
    [
      "point",
      0.03
    ],
    [
      "occupation",
      0.03
    ],
    [
      "lieu",
      0.03
    ],
    [
      "emploi",
      0.03
    ],
    [
      "profession",
      0.025
    ],
    [
      "travail",
      0.025
    ],
    [
      "conjoncture",
      0.0225
    ],
    [
      "emplacement",
      0.0175
    ],
    [
      "affaire",
      0.0175
    ],
    [
      "cas",
      0.015
    ],
    [
      "engagement",
      0.015
    ],
    [
      "orientation",
      0.015
    ],
    [
      "site",
      0.01
    ],
    [
      "posture",
      0.01
    ],
    [
      "poste",
      0.01
    ],
    [
      "circonstance",
      0.01
    ],
    [
      "attitude",
      0.01
    ],
    [
      "etablissement",
      0.0075
    ],
    [
      "sort",
      0.0075
    ],
    [
      "resolution",
      0.0075
    ],
    [
      "rencontre",
      0.0075
    ],
    [
      "parti",
      0.0075
    ],
    [
      "opinion",
      0.0075
    ],
    [
      "job",
      0.0075
    ],
    [
      "idee",
      0.0075
    ],
    [
      "endroit",
      0.0075
    ],
    [
      "degre",
      0.0075
    ],
    [
      "categorie",
      0.0075
    ],
    [
      "carriere",
      0.0075
    ],
    [
      "assiette",
      0.0075
    ],
    [
      "positionnement",
      0.0025
    ],
    [
      "statut",
      0.0025
    ],
    [
      "equipage",
      0.0025
    ],
    [
      "paysage",
      0.0025
    ],
    [
      "inclinaison",
      0.0025
    ],
    [
      "gisement",
      0.0025
    ],
    [
      "fortune",
      0.0025
    ],
    [
      "exposition",
      0.0025
    ],
    [
      "coordonnees",
      0.0025
    ],
    [
      "bilan",
      0.0025
    ],
    [
      "affaires",
      0.0025
    ],
    [
      "evenements",
      0.0025
    ]
  ],
  "poitrine": [
    [
      "sein",
      0.2025
    ],
    [
      "buste",
      0.0675
    ],
    [
      "coffre",
      0.0675
    ],
    [
      "thorax",
      0.0675
    ],
    [
      "torse",
      0.0675
    ],
    [
      "gorge",
      0.0325
    ],
    [
      "mamelle",
      0.0325
    ],
    [
      "nichon",
      0.0325
    ],
    [
      "pis",
      0.0325
    ],
    [
      "poitrail",
      0.0325
    ],
    [
      "poumon",
      0.0325
    ],
    [
      "decollete",
      0.0325
    ],
    [
      "corsage",
      0.0325
    ],
    [
      "coeur",
      0.0325
    ],
    [
      "carrure",
      0.0325
    ],
    [
      "caisse",
      0.0325
    ],
    [
      "buffet",
      0.0325
    ],
    [
      "brechet",
      0.0325
    ],
    [
      "seins",
      0.0325
    ]
  ],
  "flamber": [
    [
      "bruler",
      0.14
    ],
    [
      "flamboyer",
      0.07
    ],
    [
      "voler",
      0.07
    ],
    [
      "etinceler",
      0.045
    ],
    [
      "refaire",
      0.045
    ],
    [
      "perdre",
      0.045
    ],
    [
      "luire",
      0.045
    ],
    [
      "griller",
      0.045
    ],
    [
      "dilapider",
      0.045
    ],
    [
      "briller",
      0.045
    ],
    [
      "rayonner",
      0.0225
    ],
    [
      "repasser",
      0.0225
    ],
    [
      "ruiner",
      0.0225
    ],
    [
      "s'embraser",
      0.0225
    ],
    [
      "s'enflammer",
      0.0225
    ],
    [
      "scintiller",
      0.0225
    ],
    [
      "steriliser",
      0.0225
    ],
    [
      "jouer",
      0.0225
    ],
    [
      "gazer",
      0.0225
    ],
    [
      "depenser",
      0.0225
    ],
    [
      "cuire",
      0.0225
    ],
    [
      "cramer",
      0.0225
    ],
    [
      "ardre",
      0.0225
    ],
    [
      "ardoir",
      0.0225
    ],
    [
      "arder",
      0.0225
    ],
    [
      "tondre",
      0.0225
    ]
  ],
  "pyromane": [
    [
      "bruleur",
      0.5
    ],
    [
      "incendiaire",
      0.5
    ]
  ],
  "transformer": [
    [
      "changer",
      0.16
    ],
    [
      "renouveler",
      0.0625
    ],
    [
      "modifier",
      0.06
    ],
    [
      "alterer",
      0.045
    ],
    [
      "metamorphoser",
      0.045
    ],
    [
      "reformer",
      0.0325
    ],
    [
      "transmuer",
      0.03
    ],
    [
      "arranger",
      0.03
    ],
    [
      "ameliorer",
      0.0225
    ],
    [
      "bouleverser",
      0.0225
    ],
    [
      "convertir",
      0.0225
    ],
    [
      "deguiser",
      0.0225
    ],
    [
      "transposer",
      0.0175
    ],
    [
      "tourner",
      0.0175
    ],
    [
      "revolutionner",
      0.0175
    ],
    [
      "faconner",
      0.0175
    ],
    [
      "faire",
      0.0175
    ],
    [
      "travestir",
      0.015
    ],
    [
      "transmuter",
      0.015
    ],
    [
      "traiter",
      0.015
    ],
    [
      "renover",
      0.015
    ],
    [
      "retourner",
      0.015
    ],
    [
      "corriger",
      0.015
    ],
    [
      "contrefaire",
      0.015
    ],
    [
      "augmenter",
      0.015
    ],
    [
      "adapter",
      0.015
    ],
    [
      "moderniser",
      0.0075
    ],
    [
      "remanier",
      0.0075
    ],
    [
      "renverser",
      0.0075
    ],
    [
      "toucher",
      0.0075
    ],
    [
      "truquer",
      0.0075
    ],
    [
      "elaborer",
      0.0075
    ],
    [
      "fausser",
      0.0075
    ],
    [
      "denaturer",
      0.0075
    ],
    [
      "aggraver",
      0.0075
    ],
    [
      "chambarder",
      0.0075
    ],
    [
      "chambouler",
      0.0075
    ],
    [
      "diminuer",
      0.0075
    ],
    [
      "defigurer",
      0.0075
    ],
    [
      "deformer",
      0.0075
    ],
    [
      "varier",
      0.0025
    ],
    [
      "transsubstantier",
      0.0025
    ],
    [
      "transfigurer",
      0.0025
    ],
    [
      "reduire",
      0.0025
    ],
    [
      "refondre",
      0.0025
    ],
    [
      "rectifier",
      0.0025
    ],
    [
      "petrir",
      0.0025
    ],
    [
      "muer",
      0.0025
    ],
    [
      "innover",
      0.0025
    ],
    [
      "digerer",
      0.0025
    ],
    [
      "commuer",
      0.0025
    ],
    [
      "assimiler",
      0.0025
    ],
    [
      "agrandir",
      0.0025
    ],
    [
      "eriger",
      0.0025
    ]
  ],
  "flatter": [
    [
      "caresser",
      0.095
    ],
    [
      "aduler",
      0.065
    ],
    [
      "amadouer",
      0.0475
    ],
    [
      "encenser",
      0.0475
    ],
    [
      "flagorner",
      0.0475
    ],
    [
      "cajoler",
      0.04
    ],
    [
      "plaire",
      0.035
    ],
    [
      "courtiser",
      0.035
    ],
    [
      "chatouiller",
      0.035
    ],
    [
      "charmer",
      0.0275
    ],
    [
      "louer",
      0.0275
    ],
    [
      "seduire",
      0.0275
    ],
    [
      "tromper",
      0.0225
    ],
    [
      "entretenir",
      0.0225
    ],
    [
      "complimenter",
      0.0225
    ],
    [
      "bercer",
      0.0225
    ],
    [
      "abuser",
      0.0225
    ],
    [
      "embellir",
      0.0175
    ],
    [
      "encourager",
      0.0175
    ],
    [
      "exciter",
      0.0175
    ],
    [
      "louanger",
      0.0175
    ],
    [
      "gratter",
      0.01
    ],
    [
      "leurrer",
      0.01
    ],
    [
      "peloter",
      0.01
    ],
    [
      "repaitre",
      0.01
    ],
    [
      "vanter",
      0.01
    ],
    [
      "favoriser",
      0.01
    ],
    [
      "enjoliver",
      0.01
    ],
    [
      "adorer",
      0.01
    ],
    [
      "amuser",
      0.01
    ],
    [
      "avantager",
      0.01
    ],
    [
      "berner",
      0.01
    ],
    [
      "consoler",
      0.01
    ],
    [
      "caliner",
      0.01
    ],
    [
      "mentir",
      0.005
    ],
    [
      "mignoter",
      0.005
    ],
    [
      "menager",
      0.005
    ],
    [
      "parfaire",
      0.005
    ],
    [
      "ramper",
      0.005
    ],
    [
      "surfaire",
      0.005
    ],
    [
      "idealiser",
      0.005
    ],
    [
      "gratouiller",
      0.005
    ],
    [
      "delecter",
      0.005
    ],
    [
      "complaire",
      0.005
    ],
    [
      "bouchonner",
      0.005
    ],
    [
      "allecher",
      0.005
    ],
    [
      "toucher",
      0.005
    ]
  ],
  "priere": [
    [
      "demande",
      0.1025
    ],
    [
      "requete",
      0.0725
    ],
    [
      "supplication",
      0.0725
    ],
    [
      "sollicitation",
      0.065
    ],
    [
      "adjuration",
      0.055
    ],
    [
      "revendication",
      0.045
    ],
    [
      "imploration",
      0.035
    ],
    [
      "appel",
      0.035
    ],
    [
      "conjuration",
      0.0275
    ],
    [
      "invocation",
      0.0275
    ],
    [
      "oraison",
      0.0275
    ],
    [
      "supplique",
      0.0175
    ],
    [
      "petition",
      0.0175
    ],
    [
      "patenotre",
      0.0175
    ],
    [
      "obsecration",
      0.0175
    ],
    [
      "messe",
      0.0175
    ],
    [
      "litanie",
      0.0175
    ],
    [
      "instance",
      0.0175
    ],
    [
      "culte",
      0.0175
    ],
    [
      "chapelet",
      0.0175
    ],
    [
      "neuvaine",
      0.0075
    ],
    [
      "memento",
      0.0075
    ],
    [
      "meditation",
      0.0075
    ],
    [
      "libera",
      0.0075
    ],
    [
      "invitation",
      0.0075
    ],
    [
      "intercession",
      0.0075
    ],
    [
      "offertoire",
      0.0075
    ],
    [
      "oremus",
      0.0075
    ],
    [
      "pater",
      0.0075
    ],
    [
      "preface",
      0.0075
    ],
    [
      "voeux",
      0.0075
    ],
    [
      "ejaculation",
      0.0075
    ],
    [
      "elevation",
      0.0075
    ],
    [
      "heures",
      0.0075
    ],
    [
      "exorcisme",
      0.0075
    ],
    [
      "acte",
      0.0075
    ],
    [
      "angelus",
      0.0075
    ],
    [
      "ave",
      0.0075
    ],
    [
      "breviaire",
      0.0075
    ],
    [
      "benedicite",
      0.0075
    ],
    [
      "benediction",
      0.0075
    ],
    [
      "confiteor",
      0.0075
    ],
    [
      "credo",
      0.0075
    ],
    [
      "cri",
      0.0075
    ],
    [
      "doxologie",
      0.0075
    ],
    [
      "deprecation",
      0.0075
    ],
    [
      "devotion",
      0.0075
    ],
    [
      "absoute",
      0.0075
    ]
  ],
  "choque": [
    [
      "heurter",
      0.1125
    ],
    [
      "blesser",
      0.0975
    ],
    [
      "offenser",
      0.0975
    ],
    [
      "deplaire",
      0.055
    ],
    [
      "froisser",
      0.055
    ],
    [
      "vexer",
      0.04
    ],
    [
      "offusquer",
      0.04
    ],
    [
      "frapper",
      0.04
    ],
    [
      "atteindre",
      0.0325
    ],
    [
      "piquer",
      0.0325
    ],
    [
      "secouer",
      0.0225
    ],
    [
      "contrarier",
      0.0225
    ],
    [
      "commotionner",
      0.0225
    ],
    [
      "cogner",
      0.0225
    ],
    [
      "chiffonner",
      0.0225
    ],
    [
      "ebranler",
      0.015
    ],
    [
      "traumatiser",
      0.015
    ],
    [
      "scandaliser",
      0.015
    ],
    [
      "revolter",
      0.015
    ],
    [
      "rebuter",
      0.015
    ],
    [
      "mecontenter",
      0.015
    ],
    [
      "effaroucher",
      0.015
    ],
    [
      "desobliger",
      0.015
    ],
    [
      "cabrer",
      0.015
    ],
    [
      "buter",
      0.015
    ],
    [
      "abasourdir",
      0.015
    ],
    [
      "tamponner",
      0.0075
    ],
    [
      "taper",
      0.0075
    ],
    [
      "ulcerer",
      0.0075
    ],
    [
      "ecorcher",
      0.0075
    ],
    [
      "indigner",
      0.0075
    ],
    [
      "abrutir",
      0.0075
    ]
  ],
  "choquer": [
    [
      "heurter",
      0.1125
    ],
    [
      "blesser",
      0.0975
    ],
    [
      "offenser",
      0.0975
    ],
    [
      "deplaire",
      0.055
    ],
    [
      "froisser",
      0.055
    ],
    [
      "vexer",
      0.04
    ],
    [
      "offusquer",
      0.04
    ],
    [
      "frapper",
      0.04
    ],
    [
      "atteindre",
      0.0325
    ],
    [
      "piquer",
      0.0325
    ],
    [
      "secouer",
      0.0225
    ],
    [
      "contrarier",
      0.0225
    ],
    [
      "commotionner",
      0.0225
    ],
    [
      "cogner",
      0.0225
    ],
    [
      "chiffonner",
      0.0225
    ],
    [
      "ebranler",
      0.015
    ],
    [
      "traumatiser",
      0.015
    ],
    [
      "scandaliser",
      0.015
    ],
    [
      "revolter",
      0.015
    ],
    [
      "rebuter",
      0.015
    ],
    [
      "mecontenter",
      0.015
    ],
    [
      "effaroucher",
      0.015
    ],
    [
      "desobliger",
      0.015
    ],
    [
      "cabrer",
      0.015
    ],
    [
      "buter",
      0.015
    ],
    [
      "abasourdir",
      0.015
    ],
    [
      "tamponner",
      0.0075
    ],
    [
      "taper",
      0.0075
    ],
    [
      "ulcerer",
      0.0075
    ],
    [
      "ecorcher",
      0.0075
    ],
    [
      "indigner",
      0.0075
    ],
    [
      "abrutir",
      0.0075
    ]
  ],
  "cesse": [
    [
      "arret",
      0.2
    ],
    [
      "cessation",
      0.2
    ],
    [
      "interruption",
      0.2
    ],
    [
      "relache",
      0.2
    ],
    [
      "repos",
      0.2
    ]
  ],
  "indomptable": [
    [
      "invincible",
      0.1875
    ],
    [
      "fier",
      0.0925
    ],
    [
      "intraitable",
      0.0925
    ],
    [
      "sauvage",
      0.0625
    ],
    [
      "recalcitrant",
      0.0625
    ],
    [
      "irreductible",
      0.0625
    ],
    [
      "inflexible",
      0.0625
    ],
    [
      "indocile",
      0.0625
    ],
    [
      "irresistible",
      0.03
    ],
    [
      "invulnerable",
      0.03
    ],
    [
      "intenable",
      0.03
    ],
    [
      "infatigable",
      0.03
    ],
    [
      "inexpugnable",
      0.03
    ],
    [
      "incontrolable",
      0.03
    ],
    [
      "inapprivoisable",
      0.03
    ],
    [
      "farouche",
      0.03
    ],
    [
      "courageux",
      0.03
    ],
    [
      "retif",
      0.03
    ]
  ],
  "allie": [
    [
      "reunir",
      0.11
    ],
    [
      "associer",
      0.105
    ],
    [
      "unir",
      0.09
    ],
    [
      "assembler",
      0.0725
    ],
    [
      "accorder",
      0.0675
    ],
    [
      "combiner",
      0.0675
    ],
    [
      "joindre",
      0.0625
    ],
    [
      "fusionner",
      0.0475
    ],
    [
      "adapter",
      0.04
    ],
    [
      "lier",
      0.03
    ],
    [
      "marier",
      0.03
    ],
    [
      "melanger",
      0.03
    ],
    [
      "rapprocher",
      0.03
    ],
    [
      "assortir",
      0.025
    ],
    [
      "harmoniser",
      0.02
    ],
    [
      "federer",
      0.02
    ],
    [
      "concilier",
      0.02
    ],
    [
      "accommoder",
      0.02
    ],
    [
      "meler",
      0.01
    ],
    [
      "liguer",
      0.01
    ],
    [
      "coaliser",
      0.01
    ],
    [
      "amalgamer",
      0.01
    ],
    [
      "hallier",
      0.0025
    ],
    [
      "fiancer",
      0.0025
    ],
    [
      "enchainer",
      0.0025
    ],
    [
      "embrancher",
      0.0025
    ],
    [
      "conjuguer",
      0.0025
    ],
    [
      "confederer",
      0.0025
    ],
    [
      "apparenter",
      0.0025
    ],
    [
      "s'apparenter",
      0.0025
    ]
  ],
  "allier": [
    [
      "reunir",
      0.11
    ],
    [
      "associer",
      0.105
    ],
    [
      "unir",
      0.09
    ],
    [
      "assembler",
      0.0725
    ],
    [
      "accorder",
      0.0675
    ],
    [
      "combiner",
      0.0675
    ],
    [
      "joindre",
      0.0625
    ],
    [
      "fusionner",
      0.0475
    ],
    [
      "adapter",
      0.04
    ],
    [
      "lier",
      0.03
    ],
    [
      "marier",
      0.03
    ],
    [
      "melanger",
      0.03
    ],
    [
      "rapprocher",
      0.03
    ],
    [
      "assortir",
      0.025
    ],
    [
      "harmoniser",
      0.02
    ],
    [
      "federer",
      0.02
    ],
    [
      "concilier",
      0.02
    ],
    [
      "accommoder",
      0.02
    ],
    [
      "meler",
      0.01
    ],
    [
      "liguer",
      0.01
    ],
    [
      "coaliser",
      0.01
    ],
    [
      "amalgamer",
      0.01
    ],
    [
      "hallier",
      0.0025
    ],
    [
      "fiancer",
      0.0025
    ],
    [
      "enchainer",
      0.0025
    ],
    [
      "embrancher",
      0.0025
    ],
    [
      "conjuguer",
      0.0025
    ],
    [
      "confederer",
      0.0025
    ],
    [
      "apparenter",
      0.0025
    ],
    [
      "s'apparenter",
      0.0025
    ]
  ],
  "advenir": [
    [
      "arriver",
      0.175
    ],
    [
      "tomber",
      0.175
    ],
    [
      "survenir",
      0.145
    ],
    [
      "intervenir",
      0.0275
    ],
    [
      "devenir",
      0.0275
    ],
    [
      "echoir",
      0.0275
    ]
  ],
  "maladie": [
    [
      "malaise",
      0.075
    ],
    [
      "trouble",
      0.075
    ],
    [
      "affection",
      0.055
    ],
    [
      "mal",
      0.055
    ],
    [
      "manie",
      0.055
    ],
    [
      "vice",
      0.045
    ],
    [
      "passion",
      0.045
    ],
    [
      "atteinte",
      0.045
    ],
    [
      "alteration",
      0.045
    ],
    [
      "travers",
      0.035
    ],
    [
      "indisposition",
      0.035
    ],
    [
      "tare",
      0.0275
    ],
    [
      "souffrance",
      0.0275
    ],
    [
      "rage",
      0.0275
    ],
    [
      "marotte",
      0.0275
    ],
    [
      "crise",
      0.0275
    ],
    [
      "attaque",
      0.0275
    ],
    [
      "epreuve",
      0.0175
    ],
    [
      "obsession",
      0.0175
    ],
    [
      "lepre",
      0.0175
    ],
    [
      "infirmite",
      0.0175
    ],
    [
      "incommodite",
      0.0175
    ],
    [
      "derangement",
      0.0175
    ],
    [
      "chancre",
      0.0175
    ],
    [
      "traumatisme",
      0.0075
    ],
    [
      "tic",
      0.0075
    ],
    [
      "syndrome",
      0.0075
    ],
    [
      "recidive",
      0.0075
    ],
    [
      "rechute",
      0.0075
    ],
    [
      "plaie",
      0.0075
    ],
    [
      "peste",
      0.0075
    ],
    [
      "morbidite",
      0.0075
    ],
    [
      "hantise",
      0.0075
    ],
    [
      "entite",
      0.0075
    ],
    [
      "cas",
      0.0075
    ],
    [
      "amour",
      0.0075
    ],
    [
      "troubles",
      0.0075
    ]
  ],
  "illuminer": [
    [
      "eclairer",
      0.2075
    ],
    [
      "enflammer",
      0.125
    ],
    [
      "allumer",
      0.0825
    ],
    [
      "enluminer",
      0.0825
    ],
    [
      "orner",
      0.0825
    ],
    [
      "rejouir",
      0.04
    ],
    [
      "resplendir",
      0.04
    ],
    [
      "passer",
      0.04
    ],
    [
      "inonder",
      0.04
    ],
    [
      "ensoleiller",
      0.04
    ],
    [
      "embraser",
      0.04
    ],
    [
      "embellir",
      0.04
    ],
    [
      "briller",
      0.04
    ],
    [
      "animer",
      0.04
    ],
    [
      "eclaircir",
      0.04
    ]
  ],
  "confondre": [
    [
      "deconcerter",
      0.09
    ],
    [
      "etonner",
      0.08
    ],
    [
      "derouter",
      0.055
    ],
    [
      "troubler",
      0.05
    ],
    [
      "accabler",
      0.045
    ],
    [
      "interloquer",
      0.04
    ],
    [
      "demonter",
      0.04
    ],
    [
      "abattre",
      0.04
    ],
    [
      "stupefier",
      0.035
    ],
    [
      "renverser",
      0.035
    ],
    [
      "aneantir",
      0.035
    ],
    [
      "ahurir",
      0.035
    ],
    [
      "surprendre",
      0.03
    ],
    [
      "melanger",
      0.025
    ],
    [
      "foudroyer",
      0.025
    ],
    [
      "fondre",
      0.025
    ],
    [
      "desorienter",
      0.025
    ],
    [
      "decontenancer",
      0.025
    ],
    [
      "meler",
      0.0175
    ],
    [
      "vaincre",
      0.0175
    ],
    [
      "interdire",
      0.0125
    ],
    [
      "embrouiller",
      0.0125
    ],
    [
      "desarconner",
      0.0125
    ],
    [
      "consterner",
      0.0125
    ],
    [
      "atterrer",
      0.0125
    ],
    [
      "amalgamer",
      0.0125
    ],
    [
      "unir",
      0.0075
    ],
    [
      "reunir",
      0.0075
    ],
    [
      "reduire",
      0.0075
    ],
    [
      "fusionner",
      0.0075
    ],
    [
      "brouiller",
      0.0075
    ],
    [
      "assommer",
      0.0075
    ],
    [
      "assimiler",
      0.0075
    ],
    [
      "aplatir",
      0.0075
    ],
    [
      "refuter",
      0.0025
    ],
    [
      "identifier",
      0.0025
    ],
    [
      "humilier",
      0.0025
    ],
    [
      "entrelacer",
      0.0025
    ],
    [
      "depasser",
      0.0025
    ],
    [
      "demasquer",
      0.0025
    ],
    [
      "dejouer",
      0.0025
    ],
    [
      "convaincre",
      0.0025
    ],
    [
      "catastropher",
      0.0025
    ],
    [
      "associer",
      0.0025
    ]
  ],
  "rappeler": [
    [
      "evoquer",
      0.135
    ],
    [
      "retracer",
      0.0825
    ],
    [
      "ressembler",
      0.05
    ],
    [
      "redire",
      0.0325
    ],
    [
      "rememorer",
      0.0325
    ],
    [
      "ressortir",
      0.0325
    ],
    [
      "reveiller",
      0.0325
    ],
    [
      "s'apparenter",
      0.0325
    ],
    [
      "raconter",
      0.0325
    ],
    [
      "mobiliser",
      0.0325
    ],
    [
      "appeler",
      0.0325
    ],
    [
      "citer",
      0.0325
    ],
    [
      "exhumer",
      0.0325
    ],
    [
      "figurer",
      0.0325
    ],
    [
      "imiter",
      0.0325
    ],
    [
      "mentionner",
      0.0325
    ],
    [
      "recouvrer",
      0.015
    ],
    [
      "remobiliser",
      0.015
    ],
    [
      "retelephoner",
      0.015
    ],
    [
      "revoquer",
      0.015
    ],
    [
      "songer",
      0.015
    ],
    [
      "ramener",
      0.015
    ],
    [
      "pendre",
      0.015
    ],
    [
      "detroner",
      0.015
    ],
    [
      "destituer",
      0.015
    ],
    [
      "commemorer",
      0.015
    ],
    [
      "bisser",
      0.015
    ],
    [
      "avoir",
      0.015
    ],
    [
      "acclamer",
      0.015
    ],
    [
      "suggerer",
      0.015
    ]
  ],
  "ailler": [
    [
      "assaisonner",
      0.3325
    ],
    [
      "piquer",
      0.3325
    ],
    [
      "piqueter",
      0.3325
    ]
  ],
  "photographe": [
    [
      "daguerreotypeur",
      0.25
    ],
    [
      "journaliste",
      0.25
    ],
    [
      "operateur",
      0.25
    ],
    [
      "reporter",
      0.25
    ]
  ],
  "styler": [
    [
      "habituer",
      0.1275
    ],
    [
      "instruire",
      0.115
    ],
    [
      "former",
      0.085
    ],
    [
      "dresser",
      0.0725
    ],
    [
      "eduquer",
      0.06
    ],
    [
      "faconner",
      0.0525
    ],
    [
      "exercer",
      0.0525
    ],
    [
      "accoutumer",
      0.0475
    ],
    [
      "familiariser",
      0.0425
    ],
    [
      "apprendre",
      0.035
    ],
    [
      "entrainer",
      0.035
    ],
    [
      "rompre",
      0.03
    ],
    [
      "initier",
      0.03
    ],
    [
      "acclimater",
      0.03
    ],
    [
      "enseigner",
      0.0225
    ],
    [
      "apprivoiser",
      0.0175
    ],
    [
      "catechiser",
      0.0175
    ],
    [
      "plier",
      0.0175
    ],
    [
      "preparer",
      0.0175
    ],
    [
      "elever",
      0.01
    ],
    [
      "endurcir",
      0.01
    ],
    [
      "endoctriner",
      0.01
    ],
    [
      "adapter",
      0.005
    ],
    [
      "gouverner",
      0.005
    ],
    [
      "instituer",
      0.005
    ]
  ],
  "pair": [
    [
      "egal",
      0.3325
    ],
    [
      "confrere",
      0.165
    ],
    [
      "pareil",
      0.165
    ],
    [
      "senateur",
      0.165
    ],
    [
      "taux",
      0.165
    ]
  ],
  "paire": [
    [
      "egal",
      0.3325
    ],
    [
      "confrere",
      0.165
    ],
    [
      "pareil",
      0.165
    ],
    [
      "senateur",
      0.165
    ],
    [
      "taux",
      0.165
    ]
  ],
  "chocolat": [
    [
      "pastille",
      0.1325
    ],
    [
      "tablette",
      0.1325
    ],
    [
      "plaque",
      0.065
    ],
    [
      "desappointe",
      0.065
    ],
    [
      "crotte",
      0.065
    ],
    [
      "croquette",
      0.065
    ],
    [
      "cacao",
      0.065
    ],
    [
      "brun",
      0.065
    ],
    [
      "bouchee",
      0.065
    ],
    [
      "bonbon",
      0.065
    ],
    [
      "boisson",
      0.065
    ],
    [
      "bille",
      0.065
    ],
    [
      "truffe",
      0.065
    ]
  ],
  "nul": [
    [
      "faible",
      0.055
    ],
    [
      "insignifiant",
      0.0475
    ],
    [
      "vide",
      0.0475
    ],
    [
      "zero",
      0.0475
    ],
    [
      "incapable",
      0.04
    ],
    [
      "mauvais",
      0.04
    ],
    [
      "nullite",
      0.0325
    ],
    [
      "mechant",
      0.0325
    ],
    [
      "inutile",
      0.0325
    ],
    [
      "bete",
      0.0325
    ],
    [
      "stupide",
      0.0275
    ],
    [
      "insuffisant",
      0.0275
    ],
    [
      "inefficace",
      0.0275
    ],
    [
      "inconsistant",
      0.0275
    ],
    [
      "ignorant",
      0.0275
    ],
    [
      "sterile",
      0.02
    ],
    [
      "sot",
      0.02
    ],
    [
      "plat",
      0.02
    ],
    [
      "inexistant",
      0.02
    ],
    [
      "idiot",
      0.02
    ],
    [
      "caduc",
      0.02
    ],
    [
      "annule",
      0.02
    ],
    [
      "negatif",
      0.0125
    ],
    [
      "neant",
      0.0125
    ],
    [
      "nullard",
      0.0125
    ],
    [
      "minable",
      0.0125
    ],
    [
      "lamentable",
      0.0125
    ],
    [
      "inintelligent",
      0.0125
    ],
    [
      "infime",
      0.0125
    ],
    [
      "inepte",
      0.0125
    ],
    [
      "incompetent",
      0.0125
    ],
    [
      "falot",
      0.0125
    ],
    [
      "cancre",
      0.0125
    ],
    [
      "bouche",
      0.0125
    ],
    [
      "personne",
      0.005
    ],
    [
      "prescrit",
      0.005
    ],
    [
      "perime",
      0.005
    ],
    [
      "rien",
      0.005
    ],
    [
      "moindre",
      0.005
    ],
    [
      "invalide",
      0.005
    ],
    [
      "invalide",
      0.005
    ],
    [
      "ignare",
      0.005
    ],
    [
      "crasse",
      0.005
    ],
    [
      "aucun",
      0.005
    ],
    [
      "aboli",
      0.005
    ],
    [
      "suranne",
      0.005
    ]
  ],
  "cool": [
    [
      "calme",
      0.3325
    ],
    [
      "decontracte",
      0.3325
    ],
    [
      "tranquille",
      0.3325
    ]
  ],
  "couille": [
    [
      "bite",
      0.3325
    ],
    [
      "couillon",
      0.3325
    ],
    [
      "testicule",
      0.3325
    ]
  ],
  "puceau": [
    [
      "adolescent",
      0.5
    ],
    [
      "vierge",
      0.5
    ]
  ],
  "admettre": [
    [
      "accepter",
      0.0825
    ],
    [
      "permettre",
      0.07
    ],
    [
      "consentir",
      0.055
    ],
    [
      "autoriser",
      0.05
    ],
    [
      "acquiescer",
      0.0475
    ],
    [
      "tolerer",
      0.0475
    ],
    [
      "accorder",
      0.035
    ],
    [
      "approuver",
      0.03
    ],
    [
      "reconnaitre",
      0.03
    ],
    [
      "passer",
      0.025
    ],
    [
      "supporter",
      0.0175
    ],
    [
      "souffrir",
      0.0175
    ],
    [
      "recevoir",
      0.0175
    ],
    [
      "prendre",
      0.0175
    ],
    [
      "convenir",
      0.0175
    ],
    [
      "comprendre",
      0.0175
    ],
    [
      "avouer",
      0.0175
    ],
    [
      "agreer",
      0.0175
    ],
    [
      "imaginer",
      0.015
    ],
    [
      "conceder",
      0.015
    ],
    [
      "concevoir",
      0.015
    ],
    [
      "adopter",
      0.015
    ],
    [
      "voir",
      0.01
    ],
    [
      "supposer",
      0.01
    ],
    [
      "penser",
      0.01
    ],
    [
      "pardonner",
      0.01
    ],
    [
      "introduire",
      0.01
    ],
    [
      "excuser",
      0.01
    ],
    [
      "entendre",
      0.01
    ],
    [
      "daigner",
      0.01
    ],
    [
      "croire",
      0.01
    ],
    [
      "comporter",
      0.01
    ],
    [
      "affilier",
      0.01
    ],
    [
      "traiter",
      0.0075
    ],
    [
      "s'accommoder",
      0.0075
    ],
    [
      "mettre",
      0.0075
    ],
    [
      "justifier",
      0.0075
    ],
    [
      "confesser",
      0.0075
    ],
    [
      "accueillir",
      0.0075
    ],
    [
      "souscrire",
      0.0025
    ],
    [
      "obeir",
      0.0025
    ],
    [
      "introniser",
      0.0025
    ],
    [
      "endurer",
      0.0025
    ],
    [
      "agreger",
      0.0025
    ]
  ],
  "adulte": [
    [
      "mur",
      0.21
    ],
    [
      "grand",
      0.105
    ],
    [
      "raisonnable",
      0.105
    ],
    [
      "senior",
      0.0525
    ],
    [
      "responsable",
      0.0525
    ],
    [
      "mature",
      0.0525
    ],
    [
      "majeur",
      0.0525
    ],
    [
      "homme",
      0.0525
    ],
    [
      "grandi",
      0.0525
    ],
    [
      "developpement",
      0.0525
    ],
    [
      "averti",
      0.0525
    ],
    [
      "accompli",
      0.0525
    ],
    [
      "serieux",
      0.0525
    ]
  ],
  "esperer": [
    [
      "compter",
      0.1125
    ],
    [
      "escompter",
      0.1125
    ],
    [
      "prevoir",
      0.0975
    ],
    [
      "s'attendre",
      0.0975
    ],
    [
      "attendre",
      0.07
    ],
    [
      "presumer",
      0.07
    ],
    [
      "penser",
      0.055
    ],
    [
      "croire",
      0.055
    ],
    [
      "pressentir",
      0.04
    ],
    [
      "vouloir",
      0.0275
    ],
    [
      "souhaiter",
      0.0275
    ],
    [
      "desirer",
      0.0275
    ],
    [
      "supputer",
      0.0125
    ],
    [
      "promettre",
      0.0125
    ],
    [
      "entrevoir",
      0.0125
    ],
    [
      "aspirer",
      0.0125
    ],
    [
      "tabler",
      0.0125
    ]
  ],
  "beuh": [],
  "caissier": [
    [
      "comptable",
      0.3325
    ],
    [
      "gestionnaire",
      0.165
    ],
    [
      "intendant",
      0.165
    ],
    [
      "receveur",
      0.165
    ],
    [
      "tresorier",
      0.165
    ]
  ],
  "gerer": [
    [
      "administrer",
      0.1575
    ],
    [
      "conduire",
      0.1575
    ],
    [
      "diriger",
      0.1575
    ],
    [
      "gouverner",
      0.1575
    ],
    [
      "manier",
      0.105
    ],
    [
      "regir",
      0.0525
    ],
    [
      "regenter",
      0.0525
    ],
    [
      "presider",
      0.0525
    ],
    [
      "manager",
      0.0525
    ],
    [
      "tenir",
      0.0525
    ]
  ],
  "compte": [
    [
      "solde",
      0.0525
    ],
    [
      "addition",
      0.0425
    ],
    [
      "comptabilite",
      0.0425
    ],
    [
      "gain",
      0.0425
    ],
    [
      "note",
      0.0425
    ],
    [
      "facture",
      0.035
    ],
    [
      "benefice",
      0.035
    ],
    [
      "balance",
      0.035
    ],
    [
      "total",
      0.025
    ],
    [
      "revue",
      0.025
    ],
    [
      "releve",
      0.025
    ],
    [
      "profit",
      0.025
    ],
    [
      "denombrement",
      0.025
    ],
    [
      "decompte",
      0.025
    ],
    [
      "calcul",
      0.025
    ],
    [
      "budget",
      0.025
    ],
    [
      "boni",
      0.025
    ],
    [
      "bilan",
      0.025
    ],
    [
      "somme",
      0.015
    ],
    [
      "reglement",
      0.015
    ],
    [
      "reliquat",
      0.015
    ],
    [
      "operation",
      0.015
    ],
    [
      "deficit",
      0.015
    ],
    [
      "difference",
      0.015
    ],
    [
      "avantage",
      0.015
    ],
    [
      "precompte",
      0.0075
    ],
    [
      "nombre",
      0.0075
    ],
    [
      "memoire",
      0.0075
    ],
    [
      "mecompte",
      0.0075
    ],
    [
      "montant",
      0.0075
    ],
    [
      "livre",
      0.0075
    ],
    [
      "recensement",
      0.0075
    ],
    [
      "rectificatif",
      0.0075
    ],
    [
      "ristourne",
      0.0075
    ],
    [
      "soulte",
      0.0075
    ],
    [
      "statistique",
      0.0075
    ],
    [
      "supputation",
      0.0075
    ],
    [
      "ecriture",
      0.0075
    ],
    [
      "enumeration",
      0.0075
    ],
    [
      "liquidation",
      0.0075
    ],
    [
      "justification",
      0.0075
    ],
    [
      "interet",
      0.0075
    ],
    [
      "appoint",
      0.0075
    ],
    [
      "ardoise",
      0.0075
    ],
    [
      "arrete",
      0.0075
    ],
    [
      "article",
      0.0075
    ],
    [
      "avoir",
      0.0075
    ],
    [
      "bordereau",
      0.0075
    ],
    [
      "doit",
      0.0075
    ],
    [
      "douloureuse",
      0.0075
    ],
    [
      "debet",
      0.0075
    ],
    [
      "decouvert",
      0.0075
    ],
    [
      "depens",
      0.0075
    ],
    [
      "du",
      0.0075
    ],
    [
      "encaisse",
      0.0075
    ],
    [
      "affaire",
      0.0075
    ]
  ],
  "soiree": [
    [
      "reception",
      0.1775
    ],
    [
      "soir",
      0.1775
    ],
    [
      "fete",
      0.1175
    ],
    [
      "veillee",
      0.1175
    ],
    [
      "spectacle",
      0.0575
    ],
    [
      "reunion",
      0.0575
    ],
    [
      "raout",
      0.0575
    ],
    [
      "bal",
      0.0575
    ],
    [
      "vepree",
      0.0575
    ]
  ],
  "bizarre": [
    [
      "extraordinaire",
      0.07
    ],
    [
      "extravagant",
      0.0525
    ],
    [
      "original",
      0.0525
    ],
    [
      "etrange",
      0.04
    ],
    [
      "etonnant",
      0.04
    ],
    [
      "singulier",
      0.04
    ],
    [
      "fou",
      0.0325
    ],
    [
      "fantasque",
      0.0275
    ],
    [
      "drole",
      0.0275
    ],
    [
      "surprenant",
      0.025
    ],
    [
      "incroyable",
      0.025
    ],
    [
      "abracadabrant",
      0.025
    ],
    [
      "curieux",
      0.025
    ],
    [
      "insolite",
      0.025
    ],
    [
      "fantastique",
      0.0225
    ],
    [
      "capricieux",
      0.02
    ],
    [
      "baroque",
      0.0175
    ],
    [
      "tordu",
      0.0175
    ],
    [
      "farfelu",
      0.015
    ],
    [
      "excentrique",
      0.015
    ],
    [
      "sensationnel",
      0.015
    ],
    [
      "saugrenu",
      0.0125
    ],
    [
      "biscornu",
      0.0125
    ],
    [
      "insense",
      0.0125
    ],
    [
      "anormal",
      0.0125
    ],
    [
      "irregulier",
      0.0125
    ],
    [
      "rocambolesque",
      0.01
    ],
    [
      "truculent",
      0.01
    ],
    [
      "ridicule",
      0.01
    ],
    [
      "invraisemblable",
      0.01
    ],
    [
      "toque",
      0.0075
    ],
    [
      "inusite",
      0.0075
    ],
    [
      "fantaisiste",
      0.0075
    ],
    [
      "deconcertant",
      0.0075
    ],
    [
      "braque",
      0.0075
    ],
    [
      "beau",
      0.0075
    ],
    [
      "comique",
      0.0075
    ],
    [
      "loufoque",
      0.0075
    ],
    [
      "amusant",
      0.005
    ],
    [
      "unique",
      0.005
    ],
    [
      "rare",
      0.005
    ],
    [
      "impossible",
      0.005
    ],
    [
      "grotesque",
      0.005
    ],
    [
      "aliene",
      0.005
    ],
    [
      "timbre",
      0.0025
    ],
    [
      "plaisant",
      0.0025
    ],
    [
      "paradoxal",
      0.0025
    ],
    [
      "maniaque",
      0.0025
    ],
    [
      "inegal",
      0.0025
    ],
    [
      "inhabituel",
      0.0025
    ],
    [
      "incoherent",
      0.0025
    ],
    [
      "funambulesque",
      0.0025
    ],
    [
      "fantasmagorique",
      0.0025
    ],
    [
      "cocasse",
      0.0025
    ],
    [
      "changeant",
      0.0025
    ],
    [
      "zigoto",
      0.0025
    ],
    [
      "type",
      0.0025
    ],
    [
      "special",
      0.0025
    ],
    [
      "remarquable",
      0.0025
    ],
    [
      "pittoresque",
      0.0025
    ],
    [
      "monstrueux",
      0.0025
    ],
    [
      "lunatique",
      0.0025
    ],
    [
      "desequilibre",
      0.0025
    ],
    [
      "bizarroide",
      0.0025
    ],
    [
      "zebre",
      0.0025
    ],
    [
      "quinteux",
      0.0025
    ],
    [
      "phenomene",
      0.0025
    ],
    [
      "numero",
      0.0025
    ],
    [
      "heteroclite",
      0.0025
    ],
    [
      "deroutant",
      0.0025
    ],
    [
      "pistolet",
      0.0
    ],
    [
      "inquietant",
      0.0
    ],
    [
      "incomprehensible",
      0.0
    ],
    [
      "fele",
      0.0
    ],
    [
      "derange",
      0.0
    ],
    [
      "penible",
      0.0
    ],
    [
      "olibrius",
      0.0
    ],
    [
      "mobile",
      0.0
    ],
    [
      "marrant",
      0.0
    ],
    [
      "hallucine",
      0.0
    ],
    [
      "cornu",
      0.0
    ],
    [
      "cingle",
      0.0
    ],
    [
      "chinois",
      0.0
    ],
    [
      "brindezingue",
      0.0
    ],
    [
      "abrupt",
      0.0
    ]
  ],
  "repere": [
    [
      "marque",
      0.335
    ],
    [
      "trace",
      0.11
    ],
    [
      "signet",
      0.055
    ],
    [
      "reference",
      0.055
    ],
    [
      "point",
      0.055
    ],
    [
      "piquet",
      0.055
    ],
    [
      "jalon",
      0.055
    ],
    [
      "indice",
      0.055
    ],
    [
      "immatriculation",
      0.055
    ],
    [
      "empreinte",
      0.055
    ],
    [
      "amer",
      0.055
    ],
    [
      "taquet",
      0.055
    ]
  ],
  "reperer": [
    [
      "decouvrir",
      0.165
    ],
    [
      "saisir",
      0.095
    ],
    [
      "deviner",
      0.0725
    ],
    [
      "percer",
      0.065
    ],
    [
      "penetrer",
      0.06
    ],
    [
      "comprendre",
      0.055
    ],
    [
      "apercevoir",
      0.0525
    ],
    [
      "deceler",
      0.0475
    ],
    [
      "trouver",
      0.0425
    ],
    [
      "reveler",
      0.035
    ],
    [
      "voir",
      0.035
    ],
    [
      "marquer",
      0.03
    ],
    [
      "discerner",
      0.025
    ],
    [
      "dechiffrer",
      0.025
    ],
    [
      "remarquer",
      0.025
    ],
    [
      "lire",
      0.02
    ],
    [
      "detecter",
      0.02
    ],
    [
      "depister",
      0.0175
    ],
    [
      "pressentir",
      0.0125
    ],
    [
      "eventer",
      0.0125
    ],
    [
      "piqueter",
      0.0075
    ],
    [
      "flairer",
      0.0075
    ],
    [
      "denicher",
      0.0075
    ],
    [
      "degoter",
      0.0075
    ],
    [
      "baliser",
      0.0025
    ],
    [
      "borner",
      0.0025
    ],
    [
      "deterrer",
      0.0025
    ],
    [
      "immatriculer",
      0.0025
    ],
    [
      "jalonner",
      0.0025
    ],
    [
      "situer",
      0.0025
    ]
  ],
  "joint": [
    [
      "reunir",
      0.1025
    ],
    [
      "assembler",
      0.085
    ],
    [
      "unir",
      0.085
    ],
    [
      "attacher",
      0.0475
    ],
    [
      "lier",
      0.045
    ],
    [
      "associer",
      0.045
    ],
    [
      "adjoindre",
      0.025
    ],
    [
      "combiner",
      0.0225
    ],
    [
      "fusionner",
      0.0225
    ],
    [
      "rapprocher",
      0.0225
    ],
    [
      "relier",
      0.0175
    ],
    [
      "accorder",
      0.0175
    ],
    [
      "accoler",
      0.0175
    ],
    [
      "allier",
      0.0175
    ],
    [
      "juxtaposer",
      0.0175
    ],
    [
      "rattacher",
      0.0175
    ],
    [
      "marier",
      0.015
    ],
    [
      "accoupler",
      0.015
    ],
    [
      "adapter",
      0.0125
    ],
    [
      "annexer",
      0.0125
    ],
    [
      "atteindre",
      0.0125
    ],
    [
      "toucher",
      0.0125
    ],
    [
      "rejoindre",
      0.01
    ],
    [
      "ajuster",
      0.01
    ],
    [
      "apparier",
      0.01
    ],
    [
      "incorporer",
      0.01
    ],
    [
      "melanger",
      0.01
    ],
    [
      "raccorder",
      0.0075
    ],
    [
      "appareiller",
      0.0075
    ],
    [
      "ajouter",
      0.0075
    ],
    [
      "aboucher",
      0.0075
    ],
    [
      "rencontrer",
      0.005
    ],
    [
      "rassembler",
      0.005
    ],
    [
      "rallier",
      0.005
    ],
    [
      "inserer",
      0.005
    ],
    [
      "gagner",
      0.005
    ],
    [
      "agrafer",
      0.005
    ],
    [
      "accoster",
      0.005
    ],
    [
      "abouter",
      0.005
    ],
    [
      "aborder",
      0.005
    ],
    [
      "souder",
      0.005
    ],
    [
      "serrer",
      0.005
    ],
    [
      "river",
      0.005
    ],
    [
      "rapporter",
      0.005
    ],
    [
      "meler",
      0.005
    ],
    [
      "intercaler",
      0.005
    ],
    [
      "grouper",
      0.005
    ],
    [
      "embrancher",
      0.005
    ],
    [
      "nouer",
      0.0025
    ],
    [
      "parvenir",
      0.0025
    ],
    [
      "rabouter",
      0.0025
    ],
    [
      "retrouver",
      0.0025
    ],
    [
      "trouver",
      0.0025
    ],
    [
      "visser",
      0.0025
    ],
    [
      "jumeler",
      0.0025
    ],
    [
      "entrelacer",
      0.0025
    ],
    [
      "enter",
      0.0025
    ],
    [
      "approcher",
      0.0025
    ],
    [
      "arriver",
      0.0025
    ],
    [
      "attribuer",
      0.0025
    ],
    [
      "coller",
      0.0025
    ],
    [
      "contacter",
      0.0025
    ],
    [
      "enchainer",
      0.0025
    ],
    [
      "inclure",
      0.0
    ],
    [
      "greffer",
      0.0
    ],
    [
      "englober",
      0.0
    ],
    [
      "conjuguer",
      0.0
    ],
    [
      "brancher",
      0.0
    ],
    [
      "ajointer",
      0.0
    ],
    [
      "adherer",
      0.0
    ],
    [
      "sceller",
      0.0
    ],
    [
      "coudre",
      0.0
    ],
    [
      "connecter",
      0.0
    ],
    [
      "conjoindre",
      0.0
    ],
    [
      "braser",
      0.0
    ],
    [
      "articuler",
      0.0
    ],
    [
      "appointer",
      0.0
    ],
    [
      "accouer",
      0.0
    ],
    [
      "accompagner",
      0.0
    ],
    [
      "episser",
      0.0
    ]
  ],
  "joindre": [
    [
      "reunir",
      0.1025
    ],
    [
      "assembler",
      0.085
    ],
    [
      "unir",
      0.085
    ],
    [
      "attacher",
      0.0475
    ],
    [
      "lier",
      0.045
    ],
    [
      "associer",
      0.045
    ],
    [
      "adjoindre",
      0.025
    ],
    [
      "combiner",
      0.0225
    ],
    [
      "fusionner",
      0.0225
    ],
    [
      "rapprocher",
      0.0225
    ],
    [
      "relier",
      0.0175
    ],
    [
      "accorder",
      0.0175
    ],
    [
      "accoler",
      0.0175
    ],
    [
      "allier",
      0.0175
    ],
    [
      "juxtaposer",
      0.0175
    ],
    [
      "rattacher",
      0.0175
    ],
    [
      "marier",
      0.015
    ],
    [
      "accoupler",
      0.015
    ],
    [
      "adapter",
      0.0125
    ],
    [
      "annexer",
      0.0125
    ],
    [
      "atteindre",
      0.0125
    ],
    [
      "toucher",
      0.0125
    ],
    [
      "rejoindre",
      0.01
    ],
    [
      "ajuster",
      0.01
    ],
    [
      "apparier",
      0.01
    ],
    [
      "incorporer",
      0.01
    ],
    [
      "melanger",
      0.01
    ],
    [
      "raccorder",
      0.0075
    ],
    [
      "appareiller",
      0.0075
    ],
    [
      "ajouter",
      0.0075
    ],
    [
      "aboucher",
      0.0075
    ],
    [
      "rencontrer",
      0.005
    ],
    [
      "rassembler",
      0.005
    ],
    [
      "rallier",
      0.005
    ],
    [
      "inserer",
      0.005
    ],
    [
      "gagner",
      0.005
    ],
    [
      "agrafer",
      0.005
    ],
    [
      "accoster",
      0.005
    ],
    [
      "abouter",
      0.005
    ],
    [
      "aborder",
      0.005
    ],
    [
      "souder",
      0.005
    ],
    [
      "serrer",
      0.005
    ],
    [
      "river",
      0.005
    ],
    [
      "rapporter",
      0.005
    ],
    [
      "meler",
      0.005
    ],
    [
      "intercaler",
      0.005
    ],
    [
      "grouper",
      0.005
    ],
    [
      "embrancher",
      0.005
    ],
    [
      "nouer",
      0.0025
    ],
    [
      "parvenir",
      0.0025
    ],
    [
      "rabouter",
      0.0025
    ],
    [
      "retrouver",
      0.0025
    ],
    [
      "trouver",
      0.0025
    ],
    [
      "visser",
      0.0025
    ],
    [
      "jumeler",
      0.0025
    ],
    [
      "entrelacer",
      0.0025
    ],
    [
      "enter",
      0.0025
    ],
    [
      "approcher",
      0.0025
    ],
    [
      "arriver",
      0.0025
    ],
    [
      "attribuer",
      0.0025
    ],
    [
      "coller",
      0.0025
    ],
    [
      "contacter",
      0.0025
    ],
    [
      "enchainer",
      0.0025
    ],
    [
      "inclure",
      0.0
    ],
    [
      "greffer",
      0.0
    ],
    [
      "englober",
      0.0
    ],
    [
      "conjuguer",
      0.0
    ],
    [
      "brancher",
      0.0
    ],
    [
      "ajointer",
      0.0
    ],
    [
      "adherer",
      0.0
    ],
    [
      "sceller",
      0.0
    ],
    [
      "coudre",
      0.0
    ],
    [
      "connecter",
      0.0
    ],
    [
      "conjoindre",
      0.0
    ],
    [
      "braser",
      0.0
    ],
    [
      "articuler",
      0.0
    ],
    [
      "appointer",
      0.0
    ],
    [
      "accouer",
      0.0
    ],
    [
      "accompagner",
      0.0
    ],
    [
      "episser",
      0.0
    ]
  ],
  "clean": [],
  "defonce": [
    [
      "briser",
      0.1425
    ],
    [
      "detruire",
      0.1425
    ],
    [
      "enfoncer",
      0.1425
    ],
    [
      "creuser",
      0.105
    ],
    [
      "ouvrir",
      0.105
    ],
    [
      "effondrer",
      0.07
    ],
    [
      "degrader",
      0.07
    ],
    [
      "culbuter",
      0.035
    ],
    [
      "deteriorer",
      0.035
    ],
    [
      "emboutir",
      0.035
    ],
    [
      "labourer",
      0.035
    ],
    [
      "s'effondrer",
      0.035
    ],
    [
      "eventrer",
      0.035
    ]
  ],
  "defoncer": [
    [
      "briser",
      0.1425
    ],
    [
      "detruire",
      0.1425
    ],
    [
      "enfoncer",
      0.1425
    ],
    [
      "creuser",
      0.105
    ],
    [
      "ouvrir",
      0.105
    ],
    [
      "effondrer",
      0.07
    ],
    [
      "degrader",
      0.07
    ],
    [
      "culbuter",
      0.035
    ],
    [
      "deteriorer",
      0.035
    ],
    [
      "emboutir",
      0.035
    ],
    [
      "labourer",
      0.035
    ],
    [
      "s'effondrer",
      0.035
    ],
    [
      "eventrer",
      0.035
    ]
  ],
  "flemme": [
    [
      "paresse",
      0.25
    ],
    [
      "faineantise",
      0.165
    ],
    [
      "cagnardise",
      0.0825
    ],
    [
      "cagne",
      0.0825
    ],
    [
      "cosse",
      0.0825
    ],
    [
      "flemmard",
      0.0825
    ],
    [
      "flemmardise",
      0.0825
    ],
    [
      "flemingite",
      0.0825
    ],
    [
      "inertie",
      0.0825
    ]
  ],
  "quotidien": [
    [
      "courant",
      0.125
    ],
    [
      "habituel",
      0.125
    ],
    [
      "journalier",
      0.125
    ],
    [
      "ordinaire",
      0.125
    ],
    [
      "frequent",
      0.0925
    ],
    [
      "normal",
      0.0625
    ],
    [
      "journal",
      0.0625
    ],
    [
      "gazette",
      0.03
    ],
    [
      "fastidieux",
      0.03
    ],
    [
      "diurne",
      0.03
    ],
    [
      "diurnal",
      0.03
    ],
    [
      "continuel",
      0.03
    ],
    [
      "banal",
      0.03
    ],
    [
      "accoutume",
      0.03
    ],
    [
      "reitere",
      0.03
    ]
  ],
  "coupler": [
    [
      "accoupler",
      0.1875
    ],
    [
      "unir",
      0.1875
    ],
    [
      "assembler",
      0.125
    ],
    [
      "fusionner",
      0.125
    ],
    [
      "s'accoupler",
      0.0625
    ],
    [
      "melanger",
      0.0625
    ],
    [
      "couvrir",
      0.0625
    ],
    [
      "attacher",
      0.0625
    ],
    [
      "apparier",
      0.0625
    ],
    [
      "saillir",
      0.0625
    ]
  ],
  "couple": [
    [
      "paire",
      0.1875
    ],
    [
      "mariage",
      0.125
    ],
    [
      "tandem",
      0.0625
    ],
    [
      "reunion",
      0.0625
    ],
    [
      "menage",
      0.0625
    ],
    [
      "duo",
      0.0625
    ],
    [
      "doublet",
      0.0625
    ],
    [
      "deux",
      0.0625
    ],
    [
      "bordage",
      0.0625
    ],
    [
      "bipoint",
      0.0625
    ],
    [
      "bielle",
      0.0625
    ],
    [
      "accouple",
      0.0625
    ],
    [
      "epoux",
      0.0625
    ]
  ],
  "prouver": [
    [
      "montrer",
      0.1375
    ],
    [
      "reveler",
      0.115
    ],
    [
      "demontrer",
      0.0975
    ],
    [
      "indiquer",
      0.08
    ],
    [
      "afficher",
      0.0575
    ],
    [
      "manifester",
      0.0575
    ],
    [
      "temoigner",
      0.05
    ],
    [
      "expliquer",
      0.04
    ],
    [
      "trahir",
      0.0325
    ],
    [
      "attester",
      0.0325
    ],
    [
      "confirmer",
      0.0275
    ],
    [
      "marquer",
      0.0275
    ],
    [
      "annoncer",
      0.0225
    ],
    [
      "devoiler",
      0.0225
    ],
    [
      "etablir",
      0.015
    ],
    [
      "verifier",
      0.015
    ],
    [
      "signifier",
      0.015
    ],
    [
      "justifier",
      0.015
    ],
    [
      "deceler",
      0.015
    ],
    [
      "constater",
      0.015
    ],
    [
      "affirmer",
      0.015
    ],
    [
      "convaincre",
      0.01
    ],
    [
      "illustrer",
      0.005
    ],
    [
      "deployer",
      0.005
    ],
    [
      "corroborer",
      0.005
    ]
  ],
  "manquant": [
    [
      "absent",
      1.0
    ]
  ],
  "puzzle": [],
  "possession": [
    [
      "bien",
      0.1
    ],
    [
      "propriete",
      0.0875
    ],
    [
      "usage",
      0.0625
    ],
    [
      "etablissement",
      0.035
    ],
    [
      "pouvoir",
      0.035
    ],
    [
      "fief",
      0.035
    ],
    [
      "empire",
      0.035
    ],
    [
      "domination",
      0.035
    ],
    [
      "domaine",
      0.035
    ],
    [
      "disposition",
      0.035
    ],
    [
      "conquete",
      0.035
    ],
    [
      "richesse",
      0.025
    ],
    [
      "occupation",
      0.025
    ],
    [
      "maitrise",
      0.025
    ],
    [
      "jouissance",
      0.025
    ],
    [
      "installation",
      0.025
    ],
    [
      "connaissance",
      0.025
    ],
    [
      "colonie",
      0.025
    ],
    [
      "chose",
      0.025
    ],
    [
      "avoir",
      0.025
    ],
    [
      "appropriation",
      0.025
    ],
    [
      "acquisition",
      0.025
    ],
    [
      "malefice",
      0.01
    ],
    [
      "pratique",
      0.01
    ],
    [
      "tenure",
      0.01
    ],
    [
      "territoire",
      0.01
    ],
    [
      "usufruit",
      0.01
    ],
    [
      "immeuble",
      0.01
    ],
    [
      "fureur",
      0.01
    ],
    [
      "detention",
      0.01
    ],
    [
      "demonopathie",
      0.01
    ],
    [
      "douaire",
      0.01
    ],
    [
      "controle",
      0.01
    ],
    [
      "appartenance",
      0.01
    ],
    [
      "apanage",
      0.01
    ],
    [
      "utilisation",
      0.01
    ]
  ],
  "fetard": [
    [
      "debauche",
      0.2125
    ],
    [
      "noceur",
      0.2125
    ],
    [
      "bambocheur",
      0.1425
    ],
    [
      "viveur",
      0.1425
    ],
    [
      "arsouille",
      0.07
    ],
    [
      "festoyeur",
      0.07
    ],
    [
      "jouisseur",
      0.07
    ],
    [
      "noctambule",
      0.07
    ]
  ],
  "ironie": [
    [
      "raillerie",
      0.1625
    ],
    [
      "moquerie",
      0.1125
    ],
    [
      "plaisanterie",
      0.1125
    ],
    [
      "persiflage",
      0.08
    ],
    [
      "brocard",
      0.065
    ],
    [
      "derision",
      0.065
    ],
    [
      "humour",
      0.065
    ],
    [
      "trait",
      0.065
    ],
    [
      "sarcasme",
      0.0475
    ],
    [
      "gausserie",
      0.0475
    ],
    [
      "esprit",
      0.0325
    ],
    [
      "goguenardise",
      0.0325
    ],
    [
      "malice",
      0.0325
    ],
    [
      "amertume",
      0.015
    ],
    [
      "antiphrase",
      0.015
    ],
    [
      "gaiete",
      0.015
    ],
    [
      "pointe",
      0.015
    ]
  ],
  "position": [
    [
      "situation",
      0.15
    ],
    [
      "etat",
      0.045
    ],
    [
      "opinion",
      0.04
    ],
    [
      "place",
      0.04
    ],
    [
      "disposition",
      0.0375
    ],
    [
      "fonction",
      0.0325
    ],
    [
      "tendance",
      0.03
    ],
    [
      "rang",
      0.03
    ],
    [
      "condition",
      0.03
    ],
    [
      "attitude",
      0.0275
    ],
    [
      "emploi",
      0.0275
    ],
    [
      "pensee",
      0.0275
    ],
    [
      "idee",
      0.0225
    ],
    [
      "point",
      0.0225
    ],
    [
      "theorie",
      0.02
    ],
    [
      "sentiment",
      0.02
    ],
    [
      "posture",
      0.02
    ],
    [
      "philosophie",
      0.02
    ],
    [
      "metier",
      0.02
    ],
    [
      "doctrine",
      0.015
    ],
    [
      "lieu",
      0.015
    ],
    [
      "orientation",
      0.015
    ],
    [
      "profession",
      0.0125
    ],
    [
      "poste",
      0.0125
    ],
    [
      "degre",
      0.0125
    ],
    [
      "assiette",
      0.0125
    ],
    [
      "equilibre",
      0.01
    ],
    [
      "pose",
      0.01
    ],
    [
      "parti",
      0.01
    ],
    [
      "occupation",
      0.01
    ],
    [
      "mouvement",
      0.01
    ],
    [
      "jugement",
      0.01
    ],
    [
      "emplacement",
      0.01
    ],
    [
      "charge",
      0.01
    ],
    [
      "etablissement",
      0.005
    ],
    [
      "echelon",
      0.005
    ],
    [
      "supposition",
      0.005
    ],
    [
      "station",
      0.005
    ],
    [
      "site",
      0.005
    ],
    [
      "role",
      0.005
    ],
    [
      "resolution",
      0.005
    ],
    [
      "idees",
      0.005
    ],
    [
      "engagement",
      0.005
    ],
    [
      "croyance",
      0.005
    ],
    [
      "cas",
      0.005
    ],
    [
      "localisation",
      0.0025
    ],
    [
      "numero",
      0.0025
    ],
    [
      "sort",
      0.0025
    ],
    [
      "standing",
      0.0025
    ],
    [
      "volee",
      0.0025
    ],
    [
      "inclinaison",
      0.0025
    ],
    [
      "gisement",
      0.0025
    ],
    [
      "formulation",
      0.0025
    ],
    [
      "exposition",
      0.0025
    ],
    [
      "coordonnees",
      0.0025
    ],
    [
      "appreciation",
      0.0025
    ],
    [
      "aplomb",
      0.0025
    ],
    [
      "allegation",
      0.0025
    ],
    [
      "enonciation",
      0.0025
    ]
  ],
  "vieux": [
    [
      "demode",
      0.085
    ],
    [
      "suranne",
      0.08
    ],
    [
      "ancien",
      0.07
    ],
    [
      "antique",
      0.065
    ],
    [
      "use",
      0.065
    ],
    [
      "desuet",
      0.0475
    ],
    [
      "vetuste",
      0.0475
    ],
    [
      "perime",
      0.0375
    ],
    [
      "vieillot",
      0.035
    ],
    [
      "passe",
      0.0325
    ],
    [
      "vieilli",
      0.0325
    ],
    [
      "archaique",
      0.025
    ],
    [
      "caduc",
      0.0225
    ],
    [
      "usage",
      0.02
    ],
    [
      "rococo",
      0.0175
    ],
    [
      "age",
      0.0175
    ],
    [
      "fatigue",
      0.0175
    ],
    [
      "depasse",
      0.0175
    ],
    [
      "seculaire",
      0.015
    ],
    [
      "vieillard",
      0.015
    ],
    [
      "decrepit",
      0.01
    ],
    [
      "fane",
      0.01
    ],
    [
      "poussiereux",
      0.0075
    ],
    [
      "fossile",
      0.0075
    ],
    [
      "croulant",
      0.0075
    ],
    [
      "arriere",
      0.0075
    ],
    [
      "antediluvien",
      0.0075
    ],
    [
      "amorti",
      0.0075
    ],
    [
      "eloigne",
      0.005
    ],
    [
      "vieillerie",
      0.005
    ],
    [
      "revolu",
      0.005
    ],
    [
      "pere",
      0.005
    ],
    [
      "immemorial",
      0.005
    ],
    [
      "haut",
      0.005
    ],
    [
      "defraichi",
      0.005
    ],
    [
      "centenaire",
      0.005
    ],
    [
      "aine",
      0.005
    ],
    [
      "ancetre",
      0.005
    ],
    [
      "millenaire",
      0.0025
    ],
    [
      "patriarche",
      0.0025
    ],
    [
      "senile",
      0.0025
    ],
    [
      "vioque",
      0.0025
    ],
    [
      "veteran",
      0.0025
    ],
    [
      "long",
      0.0025
    ],
    [
      "gothique",
      0.0025
    ],
    [
      "ancestral",
      0.0025
    ],
    [
      "casse",
      0.0025
    ],
    [
      "doyen",
      0.0025
    ],
    [
      "delabre",
      0.0025
    ],
    [
      "endurci",
      0.0025
    ],
    [
      "invetere",
      0.0
    ],
    [
      "loin",
      0.0
    ],
    [
      "obsolete",
      0.0
    ],
    [
      "parents",
      0.0
    ],
    [
      "sempiternel",
      0.0
    ],
    [
      "vieil",
      0.0
    ],
    [
      "venerable",
      0.0
    ],
    [
      "vetuste",
      0.0
    ],
    [
      "impenitent",
      0.0
    ],
    [
      "historique",
      0.0
    ],
    [
      "amant",
      0.0
    ],
    [
      "antiquaille",
      0.0
    ],
    [
      "avance",
      0.0
    ],
    [
      "baderne",
      0.0
    ],
    [
      "banal",
      0.0
    ],
    [
      "barbon",
      0.0
    ],
    [
      "confirme",
      0.0
    ],
    [
      "dab",
      0.0
    ],
    [
      "elime",
      0.0
    ]
  ],
  "reveur": [
    [
      "chimerique",
      0.075
    ],
    [
      "songeur",
      0.075
    ],
    [
      "pensif",
      0.0525
    ],
    [
      "preoccupe",
      0.0525
    ],
    [
      "speculatif",
      0.0425
    ],
    [
      "romanesque",
      0.0425
    ],
    [
      "idealiste",
      0.0425
    ],
    [
      "abstrait",
      0.0425
    ],
    [
      "absorbe",
      0.0425
    ],
    [
      "utopiste",
      0.03
    ],
    [
      "romantique",
      0.03
    ],
    [
      "meditatif",
      0.03
    ],
    [
      "lunaire",
      0.03
    ],
    [
      "imaginatif",
      0.03
    ],
    [
      "contemplatif",
      0.03
    ],
    [
      "absent",
      0.03
    ],
    [
      "visionnaire",
      0.02
    ],
    [
      "soucieux",
      0.02
    ],
    [
      "poete",
      0.02
    ],
    [
      "penseur",
      0.02
    ],
    [
      "occupe",
      0.02
    ],
    [
      "illumine",
      0.02
    ],
    [
      "ideologue",
      0.02
    ],
    [
      "distrait",
      0.02
    ],
    [
      "sombre",
      0.01
    ],
    [
      "revasseur",
      0.01
    ],
    [
      "faineant",
      0.01
    ],
    [
      "contemplateur",
      0.01
    ],
    [
      "aile",
      0.01
    ],
    [
      "etourdi",
      0.01
    ]
  ],
  "avenir": [
    [
      "futur",
      0.295
    ],
    [
      "destin",
      0.11
    ],
    [
      "destinee",
      0.0725
    ],
    [
      "temps",
      0.035
    ],
    [
      "sort",
      0.035
    ],
    [
      "prediction",
      0.035
    ],
    [
      "posterite",
      0.035
    ],
    [
      "lendemain",
      0.035
    ],
    [
      "horizon",
      0.035
    ],
    [
      "fortune",
      0.035
    ],
    [
      "carriere",
      0.035
    ],
    [
      "aventure",
      0.035
    ],
    [
      "astrologie",
      0.035
    ],
    [
      "eternite",
      0.035
    ]
  ],
  "reserver": [
    [
      "conserver",
      0.12
    ],
    [
      "garder",
      0.105
    ],
    [
      "destiner",
      0.0525
    ],
    [
      "maintenir",
      0.0525
    ],
    [
      "preserver",
      0.0525
    ],
    [
      "retenir",
      0.0525
    ],
    [
      "epargner",
      0.04
    ],
    [
      "preparer",
      0.04
    ],
    [
      "proteger",
      0.04
    ],
    [
      "menager",
      0.04
    ],
    [
      "arreter",
      0.04
    ],
    [
      "economiser",
      0.025
    ],
    [
      "soigner",
      0.025
    ],
    [
      "sauver",
      0.025
    ],
    [
      "sauvegarder",
      0.025
    ],
    [
      "prevoir",
      0.025
    ],
    [
      "predestiner",
      0.025
    ],
    [
      "garantir",
      0.025
    ],
    [
      "excepter",
      0.025
    ],
    [
      "entretenir",
      0.025
    ],
    [
      "s'assurer",
      0.0125
    ],
    [
      "louer",
      0.0125
    ],
    [
      "attribuer",
      0.0125
    ],
    [
      "attendre",
      0.0125
    ],
    [
      "affecter",
      0.0125
    ],
    [
      "vouer",
      0.0125
    ]
  ],
  "ira": [
    [
      "marcher",
      0.065
    ],
    [
      "courir",
      0.0375
    ],
    [
      "passer",
      0.0375
    ],
    [
      "gagner",
      0.0325
    ],
    [
      "convenir",
      0.0275
    ],
    [
      "aboutir",
      0.025
    ],
    [
      "arriver",
      0.0225
    ],
    [
      "prendre",
      0.0225
    ],
    [
      "avancer",
      0.02
    ],
    [
      "toucher",
      0.0175
    ],
    [
      "tendre",
      0.0175
    ],
    [
      "monter",
      0.0175
    ],
    [
      "tomber",
      0.015
    ],
    [
      "tirer",
      0.015
    ],
    [
      "s'acheminer",
      0.015
    ],
    [
      "pousser",
      0.015
    ],
    [
      "piquer",
      0.015
    ],
    [
      "deambuler",
      0.015
    ],
    [
      "atteindre",
      0.015
    ],
    [
      "progresser",
      0.0125
    ],
    [
      "filer",
      0.0125
    ],
    [
      "errer",
      0.0125
    ],
    [
      "concorder",
      0.0125
    ],
    [
      "cadrer",
      0.0125
    ],
    [
      "affluer",
      0.0125
    ],
    [
      "voyager",
      0.01
    ],
    [
      "voler",
      0.01
    ],
    [
      "poursuivre",
      0.01
    ],
    [
      "plaire",
      0.01
    ],
    [
      "s'accorder",
      0.0075
    ],
    [
      "interesser",
      0.0075
    ],
    [
      "gazer",
      0.0075
    ],
    [
      "entrer",
      0.0075
    ],
    [
      "conduire",
      0.0075
    ],
    [
      "coller",
      0.0075
    ],
    [
      "cheminer",
      0.0075
    ],
    [
      "s'ajuster",
      0.005
    ],
    [
      "s'harmoniser",
      0.005
    ],
    [
      "traverser",
      0.005
    ],
    [
      "evoluer",
      0.005
    ],
    [
      "s'adresser",
      0.005
    ],
    [
      "s'adapter",
      0.005
    ],
    [
      "botter",
      0.005
    ],
    [
      "devancer",
      0.005
    ],
    [
      "distancer",
      0.005
    ],
    [
      "deriver",
      0.005
    ],
    [
      "penetrer",
      0.005
    ],
    [
      "proceder",
      0.0025
    ],
    [
      "preceder",
      0.0025
    ],
    [
      "retourner",
      0.0025
    ],
    [
      "s'approcher",
      0.0025
    ],
    [
      "s'ecouler",
      0.0025
    ],
    [
      "s'elever",
      0.0025
    ],
    [
      "seoir",
      0.0025
    ],
    [
      "solliciter",
      0.0025
    ],
    [
      "obliquer",
      0.0025
    ],
    [
      "mener",
      0.0025
    ],
    [
      "agreer",
      0.0025
    ],
    [
      "bicher",
      0.0025
    ],
    [
      "cingler",
      0.0025
    ],
    [
      "continuer",
      0.0025
    ],
    [
      "converger",
      0.0025
    ],
    [
      "correspondre",
      0.0025
    ],
    [
      "desservir",
      0.0025
    ],
    [
      "devier",
      0.0025
    ],
    [
      "habiller",
      0.0025
    ],
    [
      "peregriner",
      0.0
    ],
    [
      "refluer",
      0.0
    ],
    [
      "saquer",
      0.0
    ],
    [
      "sourire",
      0.0
    ],
    [
      "vaguer",
      0.0
    ],
    [
      "etre",
      0.0
    ],
    [
      "parcourir",
      0.0
    ],
    [
      "galoper",
      0.0
    ],
    [
      "accompagner",
      0.0
    ],
    [
      "baguenauder",
      0.0
    ],
    [
      "biaiser",
      0.0
    ],
    [
      "concerner",
      0.0
    ],
    [
      "fonctionner",
      0.0
    ],
    [
      "frequenter",
      0.0
    ]
  ],
  "epicier": [
    [
      "bourgeois",
      0.4
    ],
    [
      "commun",
      0.2
    ],
    [
      "marchand",
      0.2
    ],
    [
      "profane",
      0.2
    ]
  ],
  "ouvert": [
    [
      "franc",
      0.05
    ],
    [
      "clair",
      0.045
    ],
    [
      "vif",
      0.035
    ],
    [
      "evident",
      0.03
    ],
    [
      "manifeste",
      0.03
    ],
    [
      "libre",
      0.03
    ],
    [
      "bon",
      0.03
    ],
    [
      "sincere",
      0.0225
    ],
    [
      "sensible",
      0.0225
    ],
    [
      "patent",
      0.0225
    ],
    [
      "large",
      0.0225
    ],
    [
      "intelligent",
      0.0225
    ],
    [
      "bienveillant",
      0.0225
    ],
    [
      "aimable",
      0.0225
    ],
    [
      "accessible",
      0.0225
    ],
    [
      "percant",
      0.0175
    ],
    [
      "penetrant",
      0.0175
    ],
    [
      "spontane",
      0.0175
    ],
    [
      "vrai",
      0.0175
    ],
    [
      "eveille",
      0.0175
    ],
    [
      "notoire",
      0.0175
    ],
    [
      "gracieux",
      0.0175
    ],
    [
      "expansif",
      0.0175
    ],
    [
      "degage",
      0.0175
    ],
    [
      "cordial",
      0.0175
    ],
    [
      "comprehensif",
      0.0175
    ],
    [
      "aise",
      0.0175
    ],
    [
      "accueillant",
      0.0175
    ],
    [
      "perspicace",
      0.0125
    ],
    [
      "ostensible",
      0.0125
    ],
    [
      "liberal",
      0.0125
    ],
    [
      "tolerant",
      0.0075
    ],
    [
      "public",
      0.0075
    ],
    [
      "philanthrope",
      0.0075
    ],
    [
      "permeable",
      0.0075
    ],
    [
      "flagrant",
      0.0075
    ],
    [
      "demonstratif",
      0.0075
    ],
    [
      "declare",
      0.0075
    ],
    [
      "direct",
      0.0075
    ],
    [
      "communicatif",
      0.0075
    ],
    [
      "carre",
      0.0075
    ],
    [
      "beant",
      0.0075
    ],
    [
      "aigu",
      0.0075
    ],
    [
      "permis",
      0.0025
    ],
    [
      "obtus",
      0.0025
    ],
    [
      "lacere",
      0.0025
    ],
    [
      "hospitalier",
      0.0025
    ],
    [
      "fendu",
      0.0025
    ],
    [
      "poreux",
      0.0025
    ],
    [
      "receptif",
      0.0025
    ],
    [
      "sectionne",
      0.0025
    ],
    [
      "vulnerable",
      0.0025
    ],
    [
      "echancre",
      0.0025
    ],
    [
      "eclos",
      0.0025
    ],
    [
      "epanoui",
      0.0025
    ],
    [
      "extraverti",
      0.0025
    ],
    [
      "entaille",
      0.0025
    ],
    [
      "ajoure",
      0.0025
    ],
    [
      "autorise",
      0.0025
    ],
    [
      "baillant",
      0.0025
    ],
    [
      "causant",
      0.0025
    ],
    [
      "confiant",
      0.0025
    ],
    [
      "coupe",
      0.0025
    ],
    [
      "dilate",
      0.0025
    ],
    [
      "disjoint",
      0.0025
    ],
    [
      "disponible",
      0.0025
    ],
    [
      "dispos",
      0.0025
    ],
    [
      "decouvert",
      0.0025
    ],
    [
      "deplie",
      0.0025
    ],
    [
      "evase",
      0.0025
    ]
  ],
  "veranda": [
    [
      "auvent",
      0.165
    ],
    [
      "balcon",
      0.165
    ],
    [
      "galerie",
      0.165
    ],
    [
      "marquise",
      0.0825
    ],
    [
      "varangue",
      0.0825
    ],
    [
      "verriere",
      0.0825
    ]
  ],
  "da": [],
  "commander": [
    [
      "ordonner",
      0.055
    ],
    [
      "diriger",
      0.0475
    ],
    [
      "demander",
      0.045
    ],
    [
      "exiger",
      0.045
    ],
    [
      "prescrire",
      0.0425
    ],
    [
      "sommer",
      0.0375
    ],
    [
      "gouverner",
      0.0375
    ],
    [
      "conduire",
      0.0375
    ],
    [
      "dominer",
      0.035
    ],
    [
      "requerir",
      0.03
    ],
    [
      "regler",
      0.03
    ],
    [
      "contraindre",
      0.0275
    ],
    [
      "necessiter",
      0.0225
    ],
    [
      "maitriser",
      0.0225
    ],
    [
      "imposer",
      0.0225
    ],
    [
      "guider",
      0.0225
    ],
    [
      "entrainer",
      0.0225
    ],
    [
      "decider",
      0.0225
    ],
    [
      "appeler",
      0.02
    ],
    [
      "enjoindre",
      0.02
    ],
    [
      "regir",
      0.02
    ],
    [
      "vouloir",
      0.015
    ],
    [
      "reclamer",
      0.015
    ],
    [
      "mener",
      0.015
    ],
    [
      "disposer",
      0.015
    ],
    [
      "dire",
      0.015
    ],
    [
      "dicter",
      0.015
    ],
    [
      "regner",
      0.0125
    ],
    [
      "recommander",
      0.0125
    ],
    [
      "obliger",
      0.0125
    ],
    [
      "inspirer",
      0.0125
    ],
    [
      "dompter",
      0.0125
    ],
    [
      "conseiller",
      0.0125
    ],
    [
      "attirer",
      0.0125
    ],
    [
      "regenter",
      0.01
    ],
    [
      "decreter",
      0.01
    ],
    [
      "communiquer",
      0.01
    ],
    [
      "reprimer",
      0.005
    ],
    [
      "meriter",
      0.005
    ],
    [
      "mater",
      0.005
    ],
    [
      "assujettir",
      0.005
    ],
    [
      "administrer",
      0.005
    ],
    [
      "intimer",
      0.0025
    ],
    [
      "desservir",
      0.0025
    ],
    [
      "conditionner",
      0.0025
    ],
    [
      "acheter",
      0.0025
    ]
  ],
  "verre": [
    [
      "godet",
      0.075
    ],
    [
      "canon",
      0.0575
    ],
    [
      "pot",
      0.0575
    ],
    [
      "vitre",
      0.0375
    ],
    [
      "transparence",
      0.0375
    ],
    [
      "hanap",
      0.0375
    ],
    [
      "gobelet",
      0.0375
    ],
    [
      "formidable",
      0.0375
    ],
    [
      "drink",
      0.0375
    ],
    [
      "demi",
      0.0375
    ],
    [
      "coupe",
      0.0375
    ],
    [
      "coup",
      0.0375
    ],
    [
      "bock",
      0.0375
    ],
    [
      "glass",
      0.0175
    ],
    [
      "gorgee",
      0.0175
    ],
    [
      "goutte",
      0.0175
    ],
    [
      "lentille",
      0.0175
    ],
    [
      "lorgnon",
      0.0175
    ],
    [
      "mazagran",
      0.0175
    ],
    [
      "pyrex",
      0.0175
    ],
    [
      "recipient",
      0.0175
    ],
    [
      "securit",
      0.0175
    ],
    [
      "glace",
      0.0175
    ],
    [
      "flute",
      0.0175
    ],
    [
      "baron",
      0.0175
    ],
    [
      "boitout",
      0.0175
    ],
    [
      "carreau",
      0.0175
    ],
    [
      "chopine",
      0.0175
    ],
    [
      "clarte",
      0.0175
    ],
    [
      "craquele",
      0.0175
    ],
    [
      "cristal",
      0.0175
    ],
    [
      "vitrage",
      0.0175
    ]
  ],
  "vertige": [
    [
      "trouble",
      0.1275
    ],
    [
      "enivrement",
      0.07
    ],
    [
      "exaltation",
      0.07
    ],
    [
      "ivresse",
      0.07
    ],
    [
      "etourdissement",
      0.07
    ],
    [
      "emotion",
      0.04
    ],
    [
      "egarement",
      0.04
    ],
    [
      "transport",
      0.04
    ],
    [
      "tourbillon",
      0.04
    ],
    [
      "malaise",
      0.04
    ],
    [
      "folie",
      0.04
    ],
    [
      "eblouissement",
      0.0275
    ],
    [
      "vapeurs",
      0.0275
    ],
    [
      "tourmente",
      0.0275
    ],
    [
      "peur",
      0.0275
    ],
    [
      "griserie",
      0.0275
    ],
    [
      "frisson",
      0.0275
    ],
    [
      "extase",
      0.0275
    ],
    [
      "caprice",
      0.0275
    ],
    [
      "vertigo",
      0.0125
    ],
    [
      "tournis",
      0.0125
    ],
    [
      "tourbillonnement",
      0.0125
    ],
    [
      "fumee",
      0.0125
    ],
    [
      "entetement",
      0.0125
    ],
    [
      "emballement",
      0.0125
    ],
    [
      "desequilibre",
      0.0125
    ],
    [
      "evanouissement",
      0.0125
    ]
  ],
  "accomplir": [
    [
      "faire",
      0.1
    ],
    [
      "realiser",
      0.1
    ],
    [
      "executer",
      0.09
    ],
    [
      "achever",
      0.08
    ],
    [
      "consommer",
      0.06
    ],
    [
      "pratiquer",
      0.05
    ],
    [
      "tenir",
      0.04
    ],
    [
      "remplir",
      0.04
    ],
    [
      "observer",
      0.04
    ],
    [
      "commettre",
      0.04
    ],
    [
      "couronner",
      0.03
    ],
    [
      "satisfaire",
      0.03
    ],
    [
      "terminer",
      0.03
    ],
    [
      "etre",
      0.02
    ],
    [
      "perpetrer",
      0.02
    ],
    [
      "parachever",
      0.02
    ],
    [
      "finir",
      0.02
    ],
    [
      "effectuer",
      0.02
    ],
    [
      "atteindre",
      0.02
    ],
    [
      "aboutir",
      0.02
    ],
    [
      "s'acquitter",
      0.0075
    ],
    [
      "proceder",
      0.0075
    ],
    [
      "parvenir",
      0.0075
    ],
    [
      "materialiser",
      0.0075
    ],
    [
      "fournir",
      0.0075
    ],
    [
      "exaucer",
      0.0075
    ],
    [
      "boucler",
      0.0075
    ],
    [
      "acquitter",
      0.0075
    ],
    [
      "suivre",
      0.0075
    ]
  ],
  "pret": [
    [
      "aide",
      0.155
    ],
    [
      "avance",
      0.0775
    ],
    [
      "bourse",
      0.0775
    ],
    [
      "service",
      0.0575
    ],
    [
      "subvention",
      0.0375
    ],
    [
      "solde",
      0.0375
    ],
    [
      "remuneration",
      0.0375
    ],
    [
      "mur",
      0.0375
    ],
    [
      "depannage",
      0.0375
    ],
    [
      "cuit",
      0.0375
    ],
    [
      "credit",
      0.0375
    ],
    [
      "pour",
      0.0175
    ],
    [
      "prestation",
      0.0175
    ],
    [
      "prime",
      0.0175
    ],
    [
      "prepare",
      0.0175
    ],
    [
      "resolu",
      0.0175
    ],
    [
      "retribution",
      0.0175
    ],
    [
      "traitement",
      0.0175
    ],
    [
      "usure",
      0.0175
    ],
    [
      "pare",
      0.0175
    ],
    [
      "paie",
      0.0175
    ],
    [
      "bon",
      0.0175
    ],
    [
      "commodat",
      0.0175
    ],
    [
      "contrat",
      0.0175
    ],
    [
      "dispose",
      0.0175
    ],
    [
      "decide",
      0.0175
    ],
    [
      "determine",
      0.0175
    ],
    [
      "facilite",
      0.0175
    ],
    [
      "operationnel",
      0.0175
    ],
    [
      "warrant",
      0.0175
    ]
  ],
  "bu": [
    [
      "s'abreuver",
      0.15
    ],
    [
      "absorber",
      0.0475
    ],
    [
      "s'enivrer",
      0.045
    ],
    [
      "pomper",
      0.04
    ],
    [
      "pinter",
      0.03
    ],
    [
      "s'imbiber",
      0.025
    ],
    [
      "recevoir",
      0.025
    ],
    [
      "ingurgiter",
      0.025
    ],
    [
      "avaler",
      0.025
    ],
    [
      "picoler",
      0.0225
    ],
    [
      "prendre",
      0.0225
    ],
    [
      "sucer",
      0.015
    ],
    [
      "souffrir",
      0.015
    ],
    [
      "s'alcooliser",
      0.015
    ],
    [
      "humer",
      0.015
    ],
    [
      "essuyer",
      0.015
    ],
    [
      "entonner",
      0.015
    ],
    [
      "deguster",
      0.015
    ],
    [
      "chopiner",
      0.015
    ],
    [
      "aspirer",
      0.015
    ],
    [
      "siroter",
      0.0125
    ],
    [
      "siffler",
      0.0125
    ],
    [
      "s'ivrogner",
      0.0125
    ],
    [
      "s'impregner",
      0.0125
    ],
    [
      "licher",
      0.0125
    ],
    [
      "lamper",
      0.0125
    ],
    [
      "ivrogner",
      0.0125
    ],
    [
      "endurer",
      0.0125
    ],
    [
      "supporter",
      0.0075
    ],
    [
      "teter",
      0.0075
    ],
    [
      "vider",
      0.0075
    ],
    [
      "ecluser",
      0.0075
    ],
    [
      "eponger",
      0.0075
    ],
    [
      "arroser",
      0.0075
    ],
    [
      "biberonner",
      0.0075
    ],
    [
      "consommer",
      0.0075
    ],
    [
      "respirer",
      0.0075
    ],
    [
      "s'aviner",
      0.0075
    ],
    [
      "savourer",
      0.0025
    ],
    [
      "sabler",
      0.0025
    ],
    [
      "s'inonder",
      0.0025
    ],
    [
      "s'humecter",
      0.0025
    ],
    [
      "rincer",
      0.0025
    ],
    [
      "soiffer",
      0.0025
    ],
    [
      "tolerer",
      0.0025
    ],
    [
      "trinquer",
      0.0025
    ],
    [
      "riboter",
      0.0025
    ],
    [
      "renifler",
      0.0025
    ],
    [
      "abreuver",
      0.0025
    ],
    [
      "bidonner",
      0.0025
    ],
    [
      "boissonner",
      0.0025
    ],
    [
      "buvoter",
      0.0025
    ],
    [
      "depenser",
      0.0025
    ],
    [
      "fouetter",
      0.0025
    ],
    [
      "godailler",
      0.0025
    ],
    [
      "laper",
      0.0025
    ],
    [
      "lichailler",
      0.0025
    ],
    [
      "lipper",
      0.0025
    ],
    [
      "pictancher",
      0.0025
    ],
    [
      "picter",
      0.0025
    ],
    [
      "pictonner",
      0.0025
    ]
  ],
  "conduire": [
    [
      "diriger",
      0.075
    ],
    [
      "mener",
      0.075
    ],
    [
      "entrainer",
      0.065
    ],
    [
      "pousser",
      0.065
    ],
    [
      "gouverner",
      0.0425
    ],
    [
      "guider",
      0.0375
    ],
    [
      "transporter",
      0.0325
    ],
    [
      "amener",
      0.025
    ],
    [
      "inspirer",
      0.0225
    ],
    [
      "determiner",
      0.0225
    ],
    [
      "commander",
      0.0225
    ],
    [
      "animer",
      0.02
    ],
    [
      "attirer",
      0.02
    ],
    [
      "exciter",
      0.02
    ],
    [
      "porter",
      0.02
    ],
    [
      "conseiller",
      0.0175
    ],
    [
      "soulever",
      0.0175
    ],
    [
      "elever",
      0.015
    ],
    [
      "agir",
      0.015
    ],
    [
      "accompagner",
      0.015
    ],
    [
      "jeter",
      0.0125
    ],
    [
      "mettre",
      0.0125
    ],
    [
      "regenter",
      0.0125
    ],
    [
      "regir",
      0.0125
    ],
    [
      "trainer",
      0.01
    ],
    [
      "piloter",
      0.01
    ],
    [
      "persuader",
      0.01
    ],
    [
      "manoeuvrer",
      0.01
    ],
    [
      "manier",
      0.01
    ],
    [
      "emmener",
      0.01
    ],
    [
      "conclure",
      0.01
    ],
    [
      "administrer",
      0.01
    ],
    [
      "regler",
      0.0075
    ],
    [
      "introduire",
      0.0075
    ],
    [
      "distribuer",
      0.0075
    ],
    [
      "chaperonner",
      0.0075
    ],
    [
      "canaliser",
      0.0075
    ],
    [
      "aller",
      0.0075
    ],
    [
      "eduquer",
      0.005
    ],
    [
      "presider",
      0.005
    ],
    [
      "promener",
      0.005
    ],
    [
      "orienter",
      0.005
    ],
    [
      "influencer",
      0.005
    ],
    [
      "induire",
      0.005
    ],
    [
      "gerer",
      0.005
    ],
    [
      "escorter",
      0.005
    ],
    [
      "acheminer",
      0.005
    ],
    [
      "aboutir",
      0.005
    ],
    [
      "raisonner",
      0.0025
    ],
    [
      "reconduire",
      0.0025
    ],
    [
      "reduire",
      0.0025
    ],
    [
      "surveiller",
      0.0025
    ],
    [
      "terminer",
      0.0025
    ],
    [
      "deduire",
      0.0025
    ],
    [
      "acculer",
      0.0025
    ],
    [
      "achever",
      0.0025
    ],
    [
      "capter",
      0.0025
    ],
    [
      "convaincre",
      0.0025
    ],
    [
      "convoyer",
      0.0025
    ],
    [
      "descendre",
      0.0025
    ],
    [
      "transmettre",
      0.0
    ],
    [
      "tailler",
      0.0
    ],
    [
      "raccompagner",
      0.0
    ],
    [
      "poursuivre",
      0.0
    ],
    [
      "manager",
      0.0
    ],
    [
      "initier",
      0.0
    ],
    [
      "deboucher",
      0.0
    ],
    [
      "drainer",
      0.0
    ],
    [
      "construire",
      0.0
    ],
    [
      "tyranniser",
      0.0
    ]
  ],
  "file": [
    [
      "fuir",
      0.1075
    ],
    [
      "partir",
      0.105
    ],
    [
      "courir",
      0.0725
    ],
    [
      "s'enfuir",
      0.07
    ],
    [
      "deguerpir",
      0.0525
    ],
    [
      "decamper",
      0.04
    ],
    [
      "detaler",
      0.0375
    ],
    [
      "passer",
      0.025
    ],
    [
      "decaniller",
      0.025
    ],
    [
      "disparaitre",
      0.025
    ],
    [
      "aller",
      0.0225
    ],
    [
      "couler",
      0.0225
    ],
    [
      "voler",
      0.0175
    ],
    [
      "s'eclipser",
      0.0175
    ],
    [
      "marcher",
      0.0175
    ],
    [
      "s'esquiver",
      0.015
    ],
    [
      "s'echapper",
      0.015
    ],
    [
      "suivre",
      0.01
    ],
    [
      "gazer",
      0.01
    ],
    [
      "fondre",
      0.01
    ],
    [
      "foncer",
      0.01
    ],
    [
      "deloger",
      0.01
    ],
    [
      "naviguer",
      0.0075
    ],
    [
      "pister",
      0.0075
    ],
    [
      "retourner",
      0.0075
    ],
    [
      "riper",
      0.0075
    ],
    [
      "lacher",
      0.0075
    ],
    [
      "caleter",
      0.0075
    ],
    [
      "droper",
      0.0075
    ],
    [
      "ficher",
      0.0075
    ],
    [
      "flanquer",
      0.0075
    ],
    [
      "glisser",
      0.0075
    ],
    [
      "larguer",
      0.0075
    ],
    [
      "tricher",
      0.0025
    ],
    [
      "tordre",
      0.0025
    ],
    [
      "renvider",
      0.0025
    ],
    [
      "refiler",
      0.0025
    ],
    [
      "devider",
      0.0025
    ],
    [
      "developper",
      0.0025
    ],
    [
      "demenager",
      0.0025
    ],
    [
      "demailler",
      0.0025
    ],
    [
      "craquer",
      0.0025
    ],
    [
      "epier",
      0.0025
    ]
  ],
  "filer": [
    [
      "fuir",
      0.1075
    ],
    [
      "partir",
      0.105
    ],
    [
      "courir",
      0.0725
    ],
    [
      "s'enfuir",
      0.07
    ],
    [
      "deguerpir",
      0.0525
    ],
    [
      "decamper",
      0.04
    ],
    [
      "detaler",
      0.0375
    ],
    [
      "passer",
      0.025
    ],
    [
      "decaniller",
      0.025
    ],
    [
      "disparaitre",
      0.025
    ],
    [
      "aller",
      0.0225
    ],
    [
      "couler",
      0.0225
    ],
    [
      "voler",
      0.0175
    ],
    [
      "s'eclipser",
      0.0175
    ],
    [
      "marcher",
      0.0175
    ],
    [
      "s'esquiver",
      0.015
    ],
    [
      "s'echapper",
      0.015
    ],
    [
      "suivre",
      0.01
    ],
    [
      "gazer",
      0.01
    ],
    [
      "fondre",
      0.01
    ],
    [
      "foncer",
      0.01
    ],
    [
      "deloger",
      0.01
    ],
    [
      "naviguer",
      0.0075
    ],
    [
      "pister",
      0.0075
    ],
    [
      "retourner",
      0.0075
    ],
    [
      "riper",
      0.0075
    ],
    [
      "lacher",
      0.0075
    ],
    [
      "caleter",
      0.0075
    ],
    [
      "droper",
      0.0075
    ],
    [
      "ficher",
      0.0075
    ],
    [
      "flanquer",
      0.0075
    ],
    [
      "glisser",
      0.0075
    ],
    [
      "larguer",
      0.0075
    ],
    [
      "tricher",
      0.0025
    ],
    [
      "tordre",
      0.0025
    ],
    [
      "renvider",
      0.0025
    ],
    [
      "refiler",
      0.0025
    ],
    [
      "devider",
      0.0025
    ],
    [
      "developper",
      0.0025
    ],
    [
      "demenager",
      0.0025
    ],
    [
      "demailler",
      0.0025
    ],
    [
      "craquer",
      0.0025
    ],
    [
      "epier",
      0.0025
    ]
  ],
  "enchainer": [
    [
      "assujettir",
      0.1025
    ],
    [
      "attacher",
      0.0625
    ],
    [
      "lier",
      0.055
    ],
    [
      "soumettre",
      0.0525
    ],
    [
      "tenir",
      0.0475
    ],
    [
      "retenir",
      0.0425
    ],
    [
      "contenir",
      0.035
    ],
    [
      "museler",
      0.0325
    ],
    [
      "asservir",
      0.0325
    ],
    [
      "fixer",
      0.0275
    ],
    [
      "etouffer",
      0.0275
    ],
    [
      "dompter",
      0.025
    ],
    [
      "maitriser",
      0.0225
    ],
    [
      "dominer",
      0.0225
    ],
    [
      "contraindre",
      0.0225
    ],
    [
      "astreindre",
      0.0225
    ],
    [
      "captiver",
      0.0175
    ],
    [
      "opprimer",
      0.0175
    ],
    [
      "ecraser",
      0.015
    ],
    [
      "tyranniser",
      0.015
    ],
    [
      "subjuguer",
      0.015
    ],
    [
      "river",
      0.015
    ],
    [
      "garrotter",
      0.015
    ],
    [
      "courber",
      0.015
    ],
    [
      "unir",
      0.0125
    ],
    [
      "obliger",
      0.0125
    ],
    [
      "maintenir",
      0.0125
    ],
    [
      "ligoter",
      0.0125
    ],
    [
      "immobiliser",
      0.0125
    ],
    [
      "empecher",
      0.0125
    ],
    [
      "emprisonner",
      0.0125
    ],
    [
      "baillonner",
      0.0125
    ],
    [
      "atteler",
      0.0125
    ],
    [
      "reunir",
      0.0075
    ],
    [
      "plier",
      0.0075
    ],
    [
      "joindre",
      0.0075
    ],
    [
      "associer",
      0.0075
    ],
    [
      "amarrer",
      0.0075
    ],
    [
      "vassaliser",
      0.005
    ],
    [
      "relier",
      0.005
    ],
    [
      "enlacer",
      0.005
    ],
    [
      "agencer",
      0.005
    ],
    [
      "marier",
      0.0025
    ],
    [
      "jointoyer",
      0.0025
    ],
    [
      "engrener",
      0.0025
    ],
    [
      "domestiquer",
      0.0025
    ],
    [
      "coordonner",
      0.0025
    ],
    [
      "charpenter",
      0.0025
    ],
    [
      "charger",
      0.0025
    ],
    [
      "allier",
      0.0025
    ],
    [
      "s'atteler",
      0.0025
    ]
  ],
  "defait": [
    [
      "detruire",
      0.0525
    ],
    [
      "degager",
      0.045
    ],
    [
      "demolir",
      0.0375
    ],
    [
      "abattre",
      0.035
    ],
    [
      "culbuter",
      0.03
    ],
    [
      "renverser",
      0.025
    ],
    [
      "enlever",
      0.025
    ],
    [
      "detacher",
      0.025
    ],
    [
      "demanteler",
      0.025
    ],
    [
      "debarrasser",
      0.025
    ],
    [
      "casser",
      0.025
    ],
    [
      "alterer",
      0.025
    ],
    [
      "rompre",
      0.02
    ],
    [
      "ouvrir",
      0.02
    ],
    [
      "liberer",
      0.02
    ],
    [
      "enfoncer",
      0.02
    ],
    [
      "deranger",
      0.02
    ],
    [
      "depouiller",
      0.02
    ],
    [
      "delier",
      0.02
    ],
    [
      "bouleverser",
      0.02
    ],
    [
      "battre",
      0.015
    ],
    [
      "oter",
      0.015
    ],
    [
      "vaincre",
      0.0125
    ],
    [
      "quitter",
      0.0125
    ],
    [
      "denouer",
      0.0125
    ],
    [
      "decoudre",
      0.0125
    ],
    [
      "dechirer",
      0.0125
    ],
    [
      "changer",
      0.0125
    ],
    [
      "triompher",
      0.01
    ],
    [
      "effiler",
      0.01
    ],
    [
      "developper",
      0.01
    ],
    [
      "demunir",
      0.01
    ],
    [
      "demonter",
      0.01
    ],
    [
      "delivrer",
      0.01
    ],
    [
      "decomposer",
      0.01
    ],
    [
      "debatir",
      0.01
    ],
    [
      "affaiblir",
      0.01
    ],
    [
      "desserrer",
      0.01
    ],
    [
      "dissoudre",
      0.01
    ],
    [
      "deballer",
      0.01
    ],
    [
      "deboutonner",
      0.01
    ],
    [
      "depiquer",
      0.005
    ],
    [
      "deplier",
      0.005
    ],
    [
      "depetrer",
      0.005
    ],
    [
      "desajuster",
      0.005
    ],
    [
      "deshabiller",
      0.005
    ],
    [
      "devisser",
      0.005
    ],
    [
      "saper",
      0.005
    ],
    [
      "tailler",
      0.005
    ],
    [
      "depaqueter",
      0.005
    ],
    [
      "delacer",
      0.005
    ],
    [
      "affranchir",
      0.005
    ],
    [
      "deboucler",
      0.005
    ],
    [
      "declouer",
      0.005
    ],
    [
      "decoiffer",
      0.005
    ],
    [
      "deconstruire",
      0.005
    ],
    [
      "deficeler",
      0.005
    ],
    [
      "defigurer",
      0.005
    ],
    [
      "degrafer",
      0.005
    ],
    [
      "detordre",
      0.0025
    ],
    [
      "detortiller",
      0.0025
    ],
    [
      "infirmer",
      0.0025
    ],
    [
      "miner",
      0.0025
    ],
    [
      "modifier",
      0.0025
    ],
    [
      "parfiler",
      0.0025
    ],
    [
      "redresser",
      0.0025
    ],
    [
      "detisser",
      0.0025
    ],
    [
      "deriver",
      0.0025
    ],
    [
      "dessangler",
      0.0025
    ],
    [
      "declasser",
      0.0025
    ],
    [
      "decorder",
      0.0025
    ],
    [
      "defaufiler",
      0.0025
    ],
    [
      "defroncer",
      0.0025
    ],
    [
      "delicoter",
      0.0025
    ],
    [
      "denatter",
      0.0025
    ],
    [
      "depiauter",
      0.0025
    ],
    [
      "deplisser",
      0.0025
    ]
  ],
  "defaire": [
    [
      "detruire",
      0.0525
    ],
    [
      "degager",
      0.045
    ],
    [
      "demolir",
      0.0375
    ],
    [
      "abattre",
      0.035
    ],
    [
      "culbuter",
      0.03
    ],
    [
      "renverser",
      0.025
    ],
    [
      "enlever",
      0.025
    ],
    [
      "detacher",
      0.025
    ],
    [
      "demanteler",
      0.025
    ],
    [
      "debarrasser",
      0.025
    ],
    [
      "casser",
      0.025
    ],
    [
      "alterer",
      0.025
    ],
    [
      "rompre",
      0.02
    ],
    [
      "ouvrir",
      0.02
    ],
    [
      "liberer",
      0.02
    ],
    [
      "enfoncer",
      0.02
    ],
    [
      "deranger",
      0.02
    ],
    [
      "depouiller",
      0.02
    ],
    [
      "delier",
      0.02
    ],
    [
      "bouleverser",
      0.02
    ],
    [
      "battre",
      0.015
    ],
    [
      "oter",
      0.015
    ],
    [
      "vaincre",
      0.0125
    ],
    [
      "quitter",
      0.0125
    ],
    [
      "denouer",
      0.0125
    ],
    [
      "decoudre",
      0.0125
    ],
    [
      "dechirer",
      0.0125
    ],
    [
      "changer",
      0.0125
    ],
    [
      "triompher",
      0.01
    ],
    [
      "effiler",
      0.01
    ],
    [
      "developper",
      0.01
    ],
    [
      "demunir",
      0.01
    ],
    [
      "demonter",
      0.01
    ],
    [
      "delivrer",
      0.01
    ],
    [
      "decomposer",
      0.01
    ],
    [
      "debatir",
      0.01
    ],
    [
      "affaiblir",
      0.01
    ],
    [
      "desserrer",
      0.01
    ],
    [
      "dissoudre",
      0.01
    ],
    [
      "deballer",
      0.01
    ],
    [
      "deboutonner",
      0.01
    ],
    [
      "depiquer",
      0.005
    ],
    [
      "deplier",
      0.005
    ],
    [
      "depetrer",
      0.005
    ],
    [
      "desajuster",
      0.005
    ],
    [
      "deshabiller",
      0.005
    ],
    [
      "devisser",
      0.005
    ],
    [
      "saper",
      0.005
    ],
    [
      "tailler",
      0.005
    ],
    [
      "depaqueter",
      0.005
    ],
    [
      "delacer",
      0.005
    ],
    [
      "affranchir",
      0.005
    ],
    [
      "deboucler",
      0.005
    ],
    [
      "declouer",
      0.005
    ],
    [
      "decoiffer",
      0.005
    ],
    [
      "deconstruire",
      0.005
    ],
    [
      "deficeler",
      0.005
    ],
    [
      "defigurer",
      0.005
    ],
    [
      "degrafer",
      0.005
    ],
    [
      "detordre",
      0.0025
    ],
    [
      "detortiller",
      0.0025
    ],
    [
      "infirmer",
      0.0025
    ],
    [
      "miner",
      0.0025
    ],
    [
      "modifier",
      0.0025
    ],
    [
      "parfiler",
      0.0025
    ],
    [
      "redresser",
      0.0025
    ],
    [
      "detisser",
      0.0025
    ],
    [
      "deriver",
      0.0025
    ],
    [
      "dessangler",
      0.0025
    ],
    [
      "declasser",
      0.0025
    ],
    [
      "decorder",
      0.0025
    ],
    [
      "defaufiler",
      0.0025
    ],
    [
      "defroncer",
      0.0025
    ],
    [
      "delicoter",
      0.0025
    ],
    [
      "denatter",
      0.0025
    ],
    [
      "depiauter",
      0.0025
    ],
    [
      "deplisser",
      0.0025
    ]
  ],
  "defaite": [
    [
      "detruire",
      0.0525
    ],
    [
      "degager",
      0.045
    ],
    [
      "demolir",
      0.0375
    ],
    [
      "abattre",
      0.035
    ],
    [
      "culbuter",
      0.03
    ],
    [
      "renverser",
      0.025
    ],
    [
      "enlever",
      0.025
    ],
    [
      "detacher",
      0.025
    ],
    [
      "demanteler",
      0.025
    ],
    [
      "debarrasser",
      0.025
    ],
    [
      "casser",
      0.025
    ],
    [
      "alterer",
      0.025
    ],
    [
      "rompre",
      0.02
    ],
    [
      "ouvrir",
      0.02
    ],
    [
      "liberer",
      0.02
    ],
    [
      "enfoncer",
      0.02
    ],
    [
      "deranger",
      0.02
    ],
    [
      "depouiller",
      0.02
    ],
    [
      "delier",
      0.02
    ],
    [
      "bouleverser",
      0.02
    ],
    [
      "battre",
      0.015
    ],
    [
      "oter",
      0.015
    ],
    [
      "vaincre",
      0.0125
    ],
    [
      "quitter",
      0.0125
    ],
    [
      "denouer",
      0.0125
    ],
    [
      "decoudre",
      0.0125
    ],
    [
      "dechirer",
      0.0125
    ],
    [
      "changer",
      0.0125
    ],
    [
      "triompher",
      0.01
    ],
    [
      "effiler",
      0.01
    ],
    [
      "developper",
      0.01
    ],
    [
      "demunir",
      0.01
    ],
    [
      "demonter",
      0.01
    ],
    [
      "delivrer",
      0.01
    ],
    [
      "decomposer",
      0.01
    ],
    [
      "debatir",
      0.01
    ],
    [
      "affaiblir",
      0.01
    ],
    [
      "desserrer",
      0.01
    ],
    [
      "dissoudre",
      0.01
    ],
    [
      "deballer",
      0.01
    ],
    [
      "deboutonner",
      0.01
    ],
    [
      "depiquer",
      0.005
    ],
    [
      "deplier",
      0.005
    ],
    [
      "depetrer",
      0.005
    ],
    [
      "desajuster",
      0.005
    ],
    [
      "deshabiller",
      0.005
    ],
    [
      "devisser",
      0.005
    ],
    [
      "saper",
      0.005
    ],
    [
      "tailler",
      0.005
    ],
    [
      "depaqueter",
      0.005
    ],
    [
      "delacer",
      0.005
    ],
    [
      "affranchir",
      0.005
    ],
    [
      "deboucler",
      0.005
    ],
    [
      "declouer",
      0.005
    ],
    [
      "decoiffer",
      0.005
    ],
    [
      "deconstruire",
      0.005
    ],
    [
      "deficeler",
      0.005
    ],
    [
      "defigurer",
      0.005
    ],
    [
      "degrafer",
      0.005
    ],
    [
      "detordre",
      0.0025
    ],
    [
      "detortiller",
      0.0025
    ],
    [
      "infirmer",
      0.0025
    ],
    [
      "miner",
      0.0025
    ],
    [
      "modifier",
      0.0025
    ],
    [
      "parfiler",
      0.0025
    ],
    [
      "redresser",
      0.0025
    ],
    [
      "detisser",
      0.0025
    ],
    [
      "deriver",
      0.0025
    ],
    [
      "dessangler",
      0.0025
    ],
    [
      "declasser",
      0.0025
    ],
    [
      "decorder",
      0.0025
    ],
    [
      "defaufiler",
      0.0025
    ],
    [
      "defroncer",
      0.0025
    ],
    [
      "delicoter",
      0.0025
    ],
    [
      "denatter",
      0.0025
    ],
    [
      "depiauter",
      0.0025
    ],
    [
      "deplisser",
      0.0025
    ]
  ],
  "rater": [
    [
      "manquer",
      0.1775
    ],
    [
      "echouer",
      0.1775
    ],
    [
      "avorter",
      0.1425
    ],
    [
      "louper",
      0.1425
    ],
    [
      "peter",
      0.07
    ],
    [
      "perdre",
      0.07
    ],
    [
      "gacher",
      0.07
    ],
    [
      "foirer",
      0.07
    ],
    [
      "torcher",
      0.035
    ]
  ],
  "mater": [
    [
      "maitriser",
      0.1075
    ],
    [
      "dompter",
      0.1
    ],
    [
      "reprimer",
      0.08
    ],
    [
      "museler",
      0.0525
    ],
    [
      "soumettre",
      0.045
    ],
    [
      "etouffer",
      0.04
    ],
    [
      "reduire",
      0.04
    ],
    [
      "regarder",
      0.04
    ],
    [
      "asservir",
      0.0325
    ],
    [
      "juguler",
      0.0325
    ],
    [
      "vaincre",
      0.0325
    ],
    [
      "triompher",
      0.025
    ],
    [
      "viser",
      0.02
    ],
    [
      "terrasser",
      0.02
    ],
    [
      "regner",
      0.02
    ],
    [
      "humilier",
      0.02
    ],
    [
      "calmer",
      0.02
    ],
    [
      "brider",
      0.02
    ],
    [
      "arreter",
      0.02
    ],
    [
      "etrangler",
      0.0125
    ],
    [
      "surmonter",
      0.0125
    ],
    [
      "stopper",
      0.0125
    ],
    [
      "reluquer",
      0.0125
    ],
    [
      "refouler",
      0.0125
    ],
    [
      "mortifier",
      0.0125
    ],
    [
      "mirer",
      0.0125
    ],
    [
      "lorgner",
      0.0125
    ],
    [
      "commander",
      0.0125
    ],
    [
      "chatier",
      0.0125
    ],
    [
      "bigler",
      0.0125
    ],
    [
      "aplatir",
      0.0125
    ],
    [
      "abattre",
      0.0125
    ],
    [
      "rechasser",
      0.005
    ],
    [
      "moucher",
      0.005
    ],
    [
      "matir",
      0.005
    ],
    [
      "macerer",
      0.005
    ],
    [
      "depolir",
      0.005
    ],
    [
      "dresser",
      0.005
    ],
    [
      "voir",
      0.005
    ]
  ],
  "pirater": [
    [
      "imiter",
      0.25
    ],
    [
      "piller",
      0.25
    ],
    [
      "plagier",
      0.25
    ],
    [
      "singer",
      0.25
    ]
  ],
  "guerre": [
    [
      "dispute",
      0.1
    ],
    [
      "querelle",
      0.0875
    ],
    [
      "combat",
      0.0825
    ],
    [
      "bataille",
      0.0625
    ],
    [
      "conflit",
      0.0625
    ],
    [
      "lutte",
      0.055
    ],
    [
      "attaque",
      0.0375
    ],
    [
      "contestation",
      0.03
    ],
    [
      "affaire",
      0.03
    ],
    [
      "campagne",
      0.025
    ],
    [
      "offensive",
      0.025
    ],
    [
      "emeute",
      0.0175
    ],
    [
      "revolution",
      0.0175
    ],
    [
      "opposition",
      0.0175
    ],
    [
      "feu",
      0.0175
    ],
    [
      "demele",
      0.0175
    ],
    [
      "dissension",
      0.0175
    ],
    [
      "difficulte",
      0.0175
    ],
    [
      "troubles",
      0.0125
    ],
    [
      "polemique",
      0.0125
    ],
    [
      "insurrection",
      0.0125
    ],
    [
      "hostilites",
      0.0125
    ],
    [
      "escarmouche",
      0.0125
    ],
    [
      "croisade",
      0.0125
    ],
    [
      "conflagration",
      0.0125
    ],
    [
      "cataclysme",
      0.0125
    ],
    [
      "baroud",
      0.0125
    ],
    [
      "bagarre",
      0.0125
    ],
    [
      "conquete",
      0.005
    ],
    [
      "expedition",
      0.005
    ],
    [
      "front",
      0.005
    ],
    [
      "guerilla",
      0.005
    ],
    [
      "incendie",
      0.005
    ],
    [
      "invasion",
      0.005
    ],
    [
      "strategie",
      0.005
    ],
    [
      "animosite",
      0.005
    ],
    [
      "armes",
      0.005
    ],
    [
      "belligerance",
      0.005
    ],
    [
      "boucherie",
      0.005
    ],
    [
      "camp",
      0.005
    ],
    [
      "tactique",
      0.005
    ]
  ],
  "renflouer": [
    [
      "afflouer",
      0.25
    ],
    [
      "desechouer",
      0.25
    ]
  ],
  "queue": [
    [
      "fin",
      0.09
    ],
    [
      "verge",
      0.0775
    ],
    [
      "denouement",
      0.0525
    ],
    [
      "terminaison",
      0.0375
    ],
    [
      "resolution",
      0.0375
    ],
    [
      "penis",
      0.0375
    ],
    [
      "extremite",
      0.0375
    ],
    [
      "bout",
      0.0375
    ],
    [
      "tige",
      0.025
    ],
    [
      "file",
      0.025
    ],
    [
      "conclusion",
      0.025
    ],
    [
      "coiffure",
      0.025
    ],
    [
      "coda",
      0.025
    ],
    [
      "bite",
      0.025
    ],
    [
      "rang",
      0.0125
    ],
    [
      "quequette",
      0.0125
    ],
    [
      "quenouille",
      0.0125
    ],
    [
      "petiole",
      0.0125
    ],
    [
      "pedoncule",
      0.0125
    ],
    [
      "sexe",
      0.0125
    ],
    [
      "sortie",
      0.0125
    ],
    [
      "successeur",
      0.0125
    ],
    [
      "suite",
      0.0125
    ],
    [
      "theorie",
      0.0125
    ],
    [
      "tonneau",
      0.0125
    ],
    [
      "traine",
      0.0125
    ],
    [
      "vit",
      0.0125
    ],
    [
      "zob",
      0.0125
    ],
    [
      "pedicule",
      0.0125
    ],
    [
      "procession",
      0.0125
    ],
    [
      "arriere",
      0.0125
    ],
    [
      "attente",
      0.0125
    ],
    [
      "balai",
      0.0125
    ],
    [
      "barrique",
      0.0125
    ],
    [
      "basque",
      0.0125
    ],
    [
      "catogan",
      0.0125
    ],
    [
      "cordier",
      0.0125
    ],
    [
      "couette",
      0.0125
    ],
    [
      "dernier",
      0.0125
    ],
    [
      "fouet",
      0.0125
    ],
    [
      "foule",
      0.0125
    ],
    [
      "futaille",
      0.0125
    ],
    [
      "manche",
      0.0125
    ],
    [
      "pan",
      0.0125
    ],
    [
      "appendice",
      0.0125
    ]
  ],
  "chier": [
    [
      "defequer",
      0.2125
    ],
    [
      "faire",
      0.1425
    ],
    [
      "evacuer",
      0.1425
    ],
    [
      "debourrer",
      0.07
    ],
    [
      "crotter",
      0.07
    ],
    [
      "caquer",
      0.07
    ],
    [
      "bouser",
      0.07
    ],
    [
      "barder",
      0.07
    ],
    [
      "tartir",
      0.07
    ]
  ],
  "rappliquer": [
    [
      "radiner",
      0.2
    ],
    [
      "venir",
      0.2
    ],
    [
      "revenir",
      0.1
    ],
    [
      "s'abouler",
      0.1
    ]
  ],
  "insulte": [
    [
      "injurier",
      0.245
    ],
    [
      "blesser",
      0.075
    ],
    [
      "invectiver",
      0.075
    ],
    [
      "maltraiter",
      0.075
    ],
    [
      "offenser",
      0.075
    ],
    [
      "vilipender",
      0.055
    ],
    [
      "outrager",
      0.055
    ],
    [
      "attaquer",
      0.055
    ],
    [
      "agonir",
      0.055
    ],
    [
      "engueuler",
      0.0375
    ],
    [
      "braver",
      0.0375
    ],
    [
      "aubader",
      0.0175
    ],
    [
      "blasphemer",
      0.0175
    ],
    [
      "brocarder",
      0.0175
    ],
    [
      "harpailler",
      0.0175
    ],
    [
      "humilier",
      0.0175
    ],
    [
      "offusquer",
      0.0175
    ]
  ],
  "lancer": [
    [
      "jet",
      0.3325
    ],
    [
      "lancement",
      0.3325
    ],
    [
      "lacher",
      0.3325
    ]
  ],
  "lanc": [],
  "lance": [
    [
      "pique",
      0.19
    ],
    [
      "javelot",
      0.1425
    ],
    [
      "dard",
      0.095
    ],
    [
      "haste",
      0.095
    ],
    [
      "scion",
      0.0475
    ],
    [
      "sarisse",
      0.0475
    ],
    [
      "sagaie",
      0.0475
    ],
    [
      "pertuisane",
      0.0475
    ],
    [
      "lancier",
      0.0475
    ],
    [
      "lancette",
      0.0475
    ],
    [
      "javeline",
      0.0475
    ],
    [
      "hallebarde",
      0.0475
    ],
    [
      "framee",
      0.0475
    ],
    [
      "epieu",
      0.0475
    ]
  ],
  "consonance": [
    [
      "harmonie",
      0.25
    ],
    [
      "terminaison",
      0.1675
    ],
    [
      "assonance",
      0.0825
    ],
    [
      "concordance",
      0.0825
    ],
    [
      "contrassonance",
      0.0825
    ],
    [
      "rime",
      0.0825
    ],
    [
      "symphonie",
      0.0825
    ],
    [
      "unisson",
      0.0825
    ],
    [
      "echo",
      0.0825
    ]
  ],
  "bouffe": [
    [
      "nourriture",
      0.145
    ],
    [
      "cuisine",
      0.09
    ],
    [
      "boustifaille",
      0.0725
    ],
    [
      "repas",
      0.0725
    ],
    [
      "mangeaille",
      0.0525
    ],
    [
      "bouffetance",
      0.0525
    ],
    [
      "ripaille",
      0.035
    ],
    [
      "gueuleton",
      0.035
    ],
    [
      "graille",
      0.035
    ],
    [
      "festin",
      0.035
    ],
    [
      "comique",
      0.035
    ],
    [
      "burlesque",
      0.035
    ],
    [
      "bouffon",
      0.035
    ],
    [
      "becquetance",
      0.035
    ],
    [
      "tortore",
      0.0175
    ],
    [
      "operette",
      0.0175
    ],
    [
      "manger",
      0.0175
    ],
    [
      "gueule",
      0.0175
    ],
    [
      "facetie",
      0.0175
    ],
    [
      "cuistance",
      0.0175
    ],
    [
      "croute",
      0.0175
    ],
    [
      "croque",
      0.0175
    ],
    [
      "bafre",
      0.0175
    ],
    [
      "briffe",
      0.0175
    ],
    [
      "turlupin",
      0.0175
    ]
  ],
  "consommation": [
    [
      "achevement",
      0.115
    ],
    [
      "couronnement",
      0.115
    ],
    [
      "fin",
      0.115
    ],
    [
      "usage",
      0.075
    ],
    [
      "perfection",
      0.075
    ],
    [
      "aneantissement",
      0.075
    ],
    [
      "union",
      0.0375
    ],
    [
      "terminaison",
      0.0375
    ],
    [
      "rafraichissement",
      0.0375
    ],
    [
      "perpetration",
      0.0375
    ],
    [
      "parachevement",
      0.0375
    ],
    [
      "depense",
      0.0375
    ],
    [
      "demande",
      0.0375
    ],
    [
      "commande",
      0.0375
    ],
    [
      "boisson",
      0.0375
    ],
    [
      "absorption",
      0.0375
    ],
    [
      "utilisation",
      0.0375
    ]
  ],
  "rapide": [
    [
      "prompt",
      0.1225
    ],
    [
      "vif",
      0.0925
    ],
    [
      "brusque",
      0.0575
    ],
    [
      "presse",
      0.04
    ],
    [
      "expeditif",
      0.0325
    ],
    [
      "court",
      0.0325
    ],
    [
      "ardent",
      0.0275
    ],
    [
      "bref",
      0.0275
    ],
    [
      "vite",
      0.0225
    ],
    [
      "impetueux",
      0.0225
    ],
    [
      "hatif",
      0.0225
    ],
    [
      "brutal",
      0.0225
    ],
    [
      "actif",
      0.0225
    ],
    [
      "agile",
      0.0175
    ],
    [
      "preste",
      0.0175
    ],
    [
      "succinct",
      0.0175
    ],
    [
      "violent",
      0.0175
    ],
    [
      "turbulent",
      0.015
    ],
    [
      "subit",
      0.015
    ],
    [
      "soudain",
      0.015
    ],
    [
      "instantane",
      0.015
    ],
    [
      "fringant",
      0.015
    ],
    [
      "diligent",
      0.015
    ],
    [
      "sommaire",
      0.01
    ],
    [
      "remuant",
      0.01
    ],
    [
      "raide",
      0.01
    ],
    [
      "nerveux",
      0.01
    ],
    [
      "leste",
      0.01
    ],
    [
      "fugitif",
      0.01
    ],
    [
      "alerte",
      0.01
    ],
    [
      "abrupt",
      0.01
    ],
    [
      "semillant",
      0.0075
    ],
    [
      "soutenu",
      0.0075
    ],
    [
      "precipite",
      0.0075
    ],
    [
      "pressant",
      0.0075
    ],
    [
      "immediat",
      0.0075
    ],
    [
      "furtif",
      0.0075
    ],
    [
      "fulgurant",
      0.0075
    ],
    [
      "escarpe",
      0.0075
    ],
    [
      "empresse",
      0.0075
    ],
    [
      "concis",
      0.0075
    ],
    [
      "premature",
      0.0025
    ],
    [
      "saut",
      0.0025
    ],
    [
      "spontane",
      0.0025
    ],
    [
      "surprenant",
      0.0025
    ],
    [
      "torrentueux",
      0.0025
    ],
    [
      "train",
      0.0025
    ],
    [
      "veloce",
      0.0025
    ],
    [
      "eleve",
      0.0025
    ],
    [
      "large",
      0.0025
    ],
    [
      "frequent",
      0.0025
    ],
    [
      "enleve",
      0.0025
    ],
    [
      "aile",
      0.0025
    ],
    [
      "bacle",
      0.0025
    ],
    [
      "cascade",
      0.0025
    ],
    [
      "chute",
      0.0025
    ],
    [
      "compendieux",
      0.0025
    ],
    [
      "cursif",
      0.0025
    ],
    [
      "celere",
      0.0025
    ],
    [
      "emmene",
      0.0025
    ],
    [
      "ephemere",
      0.0025
    ]
  ],
  "star": [
    [
      "vedette",
      0.25
    ],
    [
      "etoile",
      0.25
    ],
    [
      "acteur",
      0.125
    ],
    [
      "artiste",
      0.125
    ],
    [
      "astre",
      0.125
    ],
    [
      "beaute",
      0.125
    ]
  ],
  "debile": [
    [
      "faible",
      0.1925
    ],
    [
      "chetif",
      0.0625
    ],
    [
      "malingre",
      0.055
    ],
    [
      "deficient",
      0.0475
    ],
    [
      "fragile",
      0.04
    ],
    [
      "maladif",
      0.04
    ],
    [
      "souffreteux",
      0.04
    ],
    [
      "idiot",
      0.035
    ],
    [
      "cacochyme",
      0.035
    ],
    [
      "anemique",
      0.035
    ],
    [
      "affaibli",
      0.0275
    ],
    [
      "anemie",
      0.0275
    ],
    [
      "caduc",
      0.0275
    ],
    [
      "imbecile",
      0.0275
    ],
    [
      "rachitique",
      0.02
    ],
    [
      "impuissant",
      0.02
    ],
    [
      "delicat",
      0.02
    ],
    [
      "degenere",
      0.02
    ],
    [
      "chancelant",
      0.02
    ],
    [
      "casse",
      0.02
    ],
    [
      "tare",
      0.0125
    ],
    [
      "minus",
      0.0125
    ],
    [
      "maigre",
      0.0125
    ],
    [
      "labile",
      0.0125
    ],
    [
      "infirme",
      0.0125
    ],
    [
      "frele",
      0.0125
    ],
    [
      "defaillant",
      0.0125
    ],
    [
      "cretin",
      0.0125
    ],
    [
      "retarde",
      0.005
    ],
    [
      "obtus",
      0.005
    ],
    [
      "mauvais",
      0.005
    ],
    [
      "lymphatique",
      0.005
    ],
    [
      "asthenique",
      0.005
    ],
    [
      "egrotant",
      0.005
    ]
  ],
  "midi": [
    [
      "sud",
      1.0
    ]
  ],
  "reviser": [
    [
      "corriger",
      0.19
    ],
    [
      "revoir",
      0.165
    ],
    [
      "reformer",
      0.1
    ],
    [
      "ameliorer",
      0.0625
    ],
    [
      "rectifier",
      0.0625
    ],
    [
      "remanier",
      0.05
    ],
    [
      "repasser",
      0.05
    ],
    [
      "retoucher",
      0.05
    ],
    [
      "repeter",
      0.0375
    ],
    [
      "reparer",
      0.0375
    ],
    [
      "modifier",
      0.0375
    ],
    [
      "amender",
      0.025
    ],
    [
      "verifier",
      0.025
    ],
    [
      "revisiter",
      0.01
    ],
    [
      "reconsiderer",
      0.01
    ],
    [
      "collationner",
      0.01
    ],
    [
      "chauffer",
      0.01
    ],
    [
      "apprendre",
      0.01
    ],
    [
      "rhabiller",
      0.01
    ]
  ],
  "ecrivain": [
    [
      "auteur",
      0.2325
    ],
    [
      "plumitif",
      0.05
    ],
    [
      "scribe",
      0.04
    ],
    [
      "journaliste",
      0.04
    ],
    [
      "employe",
      0.04
    ],
    [
      "barbouilleur",
      0.04
    ],
    [
      "ecrivassier",
      0.02
    ],
    [
      "ecrivant",
      0.02
    ],
    [
      "ecrivailleur",
      0.02
    ],
    [
      "redacteur",
      0.02
    ],
    [
      "publiciste",
      0.02
    ],
    [
      "nouvelliste",
      0.02
    ],
    [
      "gendelettre",
      0.02
    ],
    [
      "historien",
      0.02
    ],
    [
      "litterateur",
      0.02
    ],
    [
      "logographe",
      0.02
    ],
    [
      "polygraphe",
      0.01
    ],
    [
      "poete",
      0.01
    ],
    [
      "prosateur",
      0.01
    ],
    [
      "romancier",
      0.01
    ],
    [
      "scribouillard",
      0.01
    ],
    [
      "scripteur",
      0.01
    ],
    [
      "styliste",
      0.01
    ],
    [
      "tragique",
      0.01
    ],
    [
      "vaudevilliste",
      0.01
    ],
    [
      "ecrivaillon",
      0.01
    ],
    [
      "epistolier",
      0.01
    ],
    [
      "plume",
      0.01
    ],
    [
      "grimaud",
      0.01
    ],
    [
      "artiste",
      0.01
    ],
    [
      "calligraphe",
      0.01
    ],
    [
      "comique",
      0.01
    ],
    [
      "copiste",
      0.01
    ],
    [
      "dramaturge",
      0.01
    ],
    [
      "essayiste",
      0.01
    ],
    [
      "greffier",
      0.01
    ],
    [
      "annaliste",
      0.01
    ]
  ],
  "amuser": [
    [
      "tromper",
      0.1375
    ],
    [
      "berner",
      0.0975
    ],
    [
      "abuser",
      0.0825
    ],
    [
      "leurrer",
      0.0675
    ],
    [
      "duper",
      0.045
    ],
    [
      "mystifier",
      0.045
    ],
    [
      "seduire",
      0.045
    ],
    [
      "egayer",
      0.0375
    ],
    [
      "enjoler",
      0.0375
    ],
    [
      "bercer",
      0.0375
    ],
    [
      "distraire",
      0.03
    ],
    [
      "divertir",
      0.03
    ],
    [
      "rejouir",
      0.03
    ],
    [
      "occuper",
      0.0225
    ],
    [
      "jouer",
      0.0225
    ],
    [
      "endormir",
      0.0225
    ],
    [
      "derider",
      0.0225
    ],
    [
      "ravir",
      0.015
    ],
    [
      "flouer",
      0.015
    ],
    [
      "flatter",
      0.015
    ],
    [
      "enchanter",
      0.015
    ],
    [
      "desennuyer",
      0.015
    ],
    [
      "decevoir",
      0.015
    ],
    [
      "regaler",
      0.005
    ],
    [
      "recreer",
      0.005
    ],
    [
      "rire",
      0.005
    ],
    [
      "promener",
      0.005
    ],
    [
      "interesser",
      0.005
    ],
    [
      "delasser",
      0.005
    ],
    [
      "degeler",
      0.005
    ],
    [
      "ebaudir",
      0.005
    ]
  ],
  "coke": [
    [
      "carbonisation",
      0.3325
    ],
    [
      "charbon",
      0.3325
    ],
    [
      "combustible",
      0.3325
    ]
  ],
  "fonctionner": [
    [
      "jouer",
      0.1025
    ],
    [
      "marcher",
      0.1025
    ],
    [
      "remuer",
      0.1025
    ],
    [
      "agir",
      0.0825
    ],
    [
      "mouvoir",
      0.0825
    ],
    [
      "tourner",
      0.0825
    ],
    [
      "travailler",
      0.0625
    ],
    [
      "battre",
      0.04
    ],
    [
      "partir",
      0.02
    ],
    [
      "oeuvrer",
      0.02
    ],
    [
      "manoeuvrer",
      0.02
    ],
    [
      "carburer",
      0.02
    ],
    [
      "besogner",
      0.02
    ],
    [
      "avancer",
      0.02
    ],
    [
      "allumer",
      0.02
    ],
    [
      "aller",
      0.02
    ],
    [
      "actionner",
      0.02
    ],
    [
      "remplir",
      0.02
    ]
  ],
  "nerf": [
    [
      "force",
      0.21
    ],
    [
      "energie",
      0.21
    ],
    [
      "vigueur",
      0.1575
    ],
    [
      "dynamisme",
      0.105
    ],
    [
      "ressort",
      0.105
    ],
    [
      "muscle",
      0.0525
    ],
    [
      "puissance",
      0.0525
    ],
    [
      "tendon",
      0.0525
    ],
    [
      "tonus",
      0.0525
    ]
  ],
  "destin": [
    [
      "sort",
      0.145
    ],
    [
      "destinee",
      0.1225
    ],
    [
      "fortune",
      0.0775
    ],
    [
      "hasard",
      0.055
    ],
    [
      "evenement",
      0.0425
    ],
    [
      "vie",
      0.0425
    ],
    [
      "fatalite",
      0.0425
    ],
    [
      "etat",
      0.0325
    ],
    [
      "prediction",
      0.0325
    ],
    [
      "providence",
      0.0325
    ],
    [
      "condition",
      0.0325
    ],
    [
      "aventure",
      0.0325
    ],
    [
      "avenir",
      0.0325
    ],
    [
      "etoile",
      0.02
    ],
    [
      "malheur",
      0.02
    ],
    [
      "lot",
      0.02
    ],
    [
      "issue",
      0.02
    ],
    [
      "existence",
      0.02
    ],
    [
      "chance",
      0.02
    ],
    [
      "alea",
      0.02
    ],
    [
      "oracle",
      0.01
    ],
    [
      "necessite",
      0.01
    ],
    [
      "horoscope",
      0.01
    ],
    [
      "futur",
      0.01
    ],
    [
      "fatum",
      0.01
    ],
    [
      "dieu",
      0.01
    ],
    [
      "ciel",
      0.01
    ],
    [
      "astre",
      0.01
    ],
    [
      "adversite",
      0.01
    ],
    [
      "part",
      0.01
    ]
  ],
  "cri": [
    [
      "hurlement",
      0.0775
    ],
    [
      "bruit",
      0.055
    ],
    [
      "plainte",
      0.055
    ],
    [
      "clameur",
      0.05
    ],
    [
      "braillement",
      0.045
    ],
    [
      "criaillerie",
      0.045
    ],
    [
      "appel",
      0.0375
    ],
    [
      "bramement",
      0.0325
    ],
    [
      "voix",
      0.0275
    ],
    [
      "protestation",
      0.0275
    ],
    [
      "reclamation",
      0.0225
    ],
    [
      "pleur",
      0.0225
    ],
    [
      "belement",
      0.0225
    ],
    [
      "beuglement",
      0.0225
    ],
    [
      "vociferation",
      0.015
    ],
    [
      "tumulte",
      0.015
    ],
    [
      "recrimination",
      0.015
    ],
    [
      "mugissement",
      0.015
    ],
    [
      "interjection",
      0.015
    ],
    [
      "gemissement",
      0.015
    ],
    [
      "glapissement",
      0.015
    ],
    [
      "braiment",
      0.015
    ],
    [
      "acclamation",
      0.015
    ],
    [
      "piaillerie",
      0.01
    ],
    [
      "rugissement",
      0.01
    ],
    [
      "tapage",
      0.01
    ],
    [
      "tintamarre",
      0.01
    ],
    [
      "tolle",
      0.01
    ],
    [
      "vacarme",
      0.01
    ],
    [
      "onomatopee",
      0.01
    ],
    [
      "lamentation",
      0.01
    ],
    [
      "gueulement",
      0.01
    ],
    [
      "aboi",
      0.01
    ],
    [
      "alarme",
      0.01
    ],
    [
      "approbation",
      0.01
    ],
    [
      "avertissement",
      0.01
    ],
    [
      "bruissement",
      0.01
    ],
    [
      "clabauderie",
      0.01
    ],
    [
      "crierie",
      0.01
    ],
    [
      "mouvement",
      0.005
    ],
    [
      "ovation",
      0.005
    ],
    [
      "piaillement",
      0.005
    ],
    [
      "priere",
      0.005
    ],
    [
      "pepiement",
      0.005
    ],
    [
      "sanglot",
      0.005
    ],
    [
      "stridulation",
      0.005
    ],
    [
      "jurement",
      0.005
    ],
    [
      "improbation",
      0.005
    ],
    [
      "huee",
      0.005
    ],
    [
      "hourvari",
      0.005
    ],
    [
      "haro",
      0.005
    ],
    [
      "grognement",
      0.005
    ],
    [
      "feulement",
      0.005
    ],
    [
      "exigence",
      0.005
    ],
    [
      "exclamation",
      0.005
    ],
    [
      "vagissement",
      0.005
    ]
  ],
  "reunir": [
    [
      "unir",
      0.09
    ],
    [
      "assembler",
      0.0875
    ],
    [
      "joindre",
      0.0775
    ],
    [
      "associer",
      0.0625
    ],
    [
      "rassembler",
      0.0375
    ],
    [
      "accorder",
      0.03
    ],
    [
      "fusionner",
      0.0275
    ],
    [
      "combiner",
      0.0275
    ],
    [
      "lier",
      0.025
    ],
    [
      "allier",
      0.025
    ],
    [
      "grouper",
      0.02
    ],
    [
      "melanger",
      0.02
    ],
    [
      "amasser",
      0.0175
    ],
    [
      "accoupler",
      0.015
    ],
    [
      "adapter",
      0.015
    ],
    [
      "appareiller",
      0.015
    ],
    [
      "apparier",
      0.015
    ],
    [
      "assortir",
      0.015
    ],
    [
      "rapprocher",
      0.015
    ],
    [
      "agglomerer",
      0.0125
    ],
    [
      "attacher",
      0.0125
    ],
    [
      "marier",
      0.0125
    ],
    [
      "adjoindre",
      0.0125
    ],
    [
      "concentrer",
      0.01
    ],
    [
      "amalgamer",
      0.01
    ],
    [
      "agencer",
      0.01
    ],
    [
      "accumuler",
      0.01
    ],
    [
      "meler",
      0.01
    ],
    [
      "relier",
      0.01
    ],
    [
      "ramasser",
      0.0075
    ],
    [
      "incorporer",
      0.0075
    ],
    [
      "agreger",
      0.0075
    ],
    [
      "conglomerer",
      0.0075
    ],
    [
      "rallier",
      0.005
    ],
    [
      "masser",
      0.005
    ],
    [
      "juxtaposer",
      0.005
    ],
    [
      "fondre",
      0.005
    ],
    [
      "entasser",
      0.005
    ],
    [
      "concilier",
      0.005
    ],
    [
      "agglutiner",
      0.005
    ],
    [
      "integrer",
      0.005
    ],
    [
      "ajuster",
      0.005
    ],
    [
      "accommoder",
      0.005
    ],
    [
      "souder",
      0.0025
    ],
    [
      "regrouper",
      0.0025
    ],
    [
      "recueillir",
      0.0025
    ],
    [
      "raccorder",
      0.0025
    ],
    [
      "federer",
      0.0025
    ],
    [
      "colliger",
      0.0025
    ],
    [
      "collectionner",
      0.0025
    ],
    [
      "bloquer",
      0.0025
    ],
    [
      "annexer",
      0.0025
    ],
    [
      "aboucher",
      0.0025
    ],
    [
      "recomposer",
      0.0025
    ],
    [
      "enchainer",
      0.0025
    ],
    [
      "canaliser",
      0.0025
    ],
    [
      "geminer",
      0.0
    ],
    [
      "inviter",
      0.0
    ],
    [
      "rabouter",
      0.0
    ],
    [
      "rejoindre",
      0.0
    ],
    [
      "reconcilier",
      0.0
    ],
    [
      "synthetiser",
      0.0
    ],
    [
      "totaliser",
      0.0
    ],
    [
      "former",
      0.0
    ],
    [
      "englober",
      0.0
    ],
    [
      "abouter",
      0.0
    ],
    [
      "capter",
      0.0
    ],
    [
      "centraliser",
      0.0
    ],
    [
      "coaliser",
      0.0
    ],
    [
      "confondre",
      0.0
    ],
    [
      "conglutiner",
      0.0
    ],
    [
      "conjuguer",
      0.0
    ],
    [
      "convoquer",
      0.0
    ],
    [
      "coudre",
      0.0
    ],
    [
      "cumuler",
      0.0
    ],
    [
      "desservir",
      0.0
    ],
    [
      "remettre",
      0.0
    ],
    [
      "epingler",
      0.0
    ],
    [
      "connecter",
      0.0
    ],
    [
      "conglober",
      0.0
    ],
    [
      "collecter",
      0.0
    ],
    [
      "codifier",
      0.0
    ],
    [
      "classer",
      0.0
    ],
    [
      "attabler",
      0.0
    ],
    [
      "asseoir",
      0.0
    ],
    [
      "additionner",
      0.0
    ],
    [
      "episser",
      0.0
    ]
  ],
  "vider": [
    [
      "renvoyer",
      0.0675
    ],
    [
      "epuiser",
      0.055
    ],
    [
      "chasser",
      0.04
    ],
    [
      "congedier",
      0.0325
    ],
    [
      "aneantir",
      0.03
    ],
    [
      "expulser",
      0.0275
    ],
    [
      "balancer",
      0.0275
    ],
    [
      "liquider",
      0.025
    ],
    [
      "virer",
      0.0225
    ],
    [
      "sortir",
      0.0225
    ],
    [
      "remercier",
      0.0225
    ],
    [
      "limoger",
      0.0225
    ],
    [
      "balayer",
      0.0225
    ],
    [
      "debarquer",
      0.02
    ],
    [
      "deloger",
      0.02
    ],
    [
      "evacuer",
      0.015
    ],
    [
      "ereinter",
      0.015
    ],
    [
      "nettoyer",
      0.015
    ],
    [
      "licencier",
      0.015
    ],
    [
      "extenuer",
      0.015
    ],
    [
      "abattre",
      0.015
    ],
    [
      "abandonner",
      0.015
    ],
    [
      "vanner",
      0.0125
    ],
    [
      "ruiner",
      0.0125
    ],
    [
      "pomper",
      0.0125
    ],
    [
      "finir",
      0.0125
    ],
    [
      "fatiguer",
      0.0125
    ],
    [
      "debarrasser",
      0.0125
    ],
    [
      "terminer",
      0.01
    ],
    [
      "regler",
      0.01
    ],
    [
      "exclure",
      0.01
    ],
    [
      "enlever",
      0.01
    ],
    [
      "demenager",
      0.01
    ],
    [
      "claquer",
      0.01
    ],
    [
      "oter",
      0.0075
    ],
    [
      "econduire",
      0.0075
    ],
    [
      "trancher",
      0.0075
    ],
    [
      "tarir",
      0.0075
    ],
    [
      "revoquer",
      0.0075
    ],
    [
      "retirer",
      0.0075
    ],
    [
      "partir",
      0.0075
    ],
    [
      "lourder",
      0.0075
    ],
    [
      "harasser",
      0.0075
    ],
    [
      "degommer",
      0.0075
    ],
    [
      "reconduire",
      0.005
    ],
    [
      "sabrer",
      0.005
    ],
    [
      "saigner",
      0.005
    ],
    [
      "saquer",
      0.005
    ],
    [
      "verser",
      0.005
    ],
    [
      "vidanger",
      0.005
    ],
    [
      "larguer",
      0.005
    ],
    [
      "degoter",
      0.005
    ],
    [
      "degarnir",
      0.005
    ],
    [
      "assecher",
      0.005
    ],
    [
      "boire",
      0.005
    ],
    [
      "crever",
      0.005
    ],
    [
      "dessecher",
      0.005
    ],
    [
      "deboulonner",
      0.005
    ],
    [
      "debusquer",
      0.005
    ],
    [
      "parer",
      0.0025
    ],
    [
      "piller",
      0.0025
    ],
    [
      "preparer",
      0.0025
    ],
    [
      "resoudre",
      0.0025
    ],
    [
      "siffler",
      0.0025
    ],
    [
      "secher",
      0.0025
    ],
    [
      "transvaser",
      0.0025
    ],
    [
      "transvider",
      0.0025
    ],
    [
      "ecoper",
      0.0025
    ],
    [
      "etriper",
      0.0025
    ],
    [
      "eviscerer",
      0.0025
    ],
    [
      "lessiver",
      0.0025
    ],
    [
      "ingurgiter",
      0.0025
    ],
    [
      "debonder",
      0.0025
    ],
    [
      "debourrer",
      0.0025
    ],
    [
      "decider",
      0.0025
    ],
    [
      "demeubler",
      0.0025
    ],
    [
      "depeupler",
      0.0025
    ],
    [
      "deprimer",
      0.0025
    ],
    [
      "desarconner",
      0.0025
    ],
    [
      "desemplir",
      0.0025
    ],
    [
      "desobstruer",
      0.0025
    ],
    [
      "bordurer",
      0.0025
    ]
  ],
  "mi": [
    [
      "semi",
      1.0
    ]
  ],
  "fin": [
    [
      "delicat",
      0.0425
    ],
    [
      "habile",
      0.0325
    ],
    [
      "achevement",
      0.0275
    ],
    [
      "subtil",
      0.0275
    ],
    [
      "leger",
      0.025
    ],
    [
      "beau",
      0.0225
    ],
    [
      "adroit",
      0.0225
    ],
    [
      "but",
      0.02
    ],
    [
      "delie",
      0.0175
    ],
    [
      "denouement",
      0.0175
    ],
    [
      "svelte",
      0.0175
    ],
    [
      "terminaison",
      0.0175
    ],
    [
      "terme",
      0.0175
    ],
    [
      "mince",
      0.0175
    ],
    [
      "resolution",
      0.015
    ],
    [
      "intelligent",
      0.015
    ],
    [
      "penetrant",
      0.015
    ],
    [
      "solution",
      0.015
    ],
    [
      "conclusion",
      0.0125
    ],
    [
      "grele",
      0.0125
    ],
    [
      "resultat",
      0.0125
    ],
    [
      "malin",
      0.0125
    ],
    [
      "extremite",
      0.0125
    ],
    [
      "bout",
      0.0125
    ],
    [
      "aboutissement",
      0.01
    ],
    [
      "cessation",
      0.01
    ],
    [
      "chute",
      0.01
    ],
    [
      "tenu",
      0.01
    ],
    [
      "elegant",
      0.01
    ],
    [
      "spirituel",
      0.01
    ],
    [
      "ruse",
      0.01
    ],
    [
      "distingue",
      0.01
    ],
    [
      "astucieux",
      0.01
    ],
    [
      "queue",
      0.0075
    ],
    [
      "piquant",
      0.0075
    ],
    [
      "mort",
      0.0075
    ],
    [
      "extinction",
      0.0075
    ],
    [
      "exquis",
      0.0075
    ],
    [
      "dessein",
      0.0075
    ],
    [
      "aigu",
      0.0075
    ],
    [
      "souple",
      0.0075
    ],
    [
      "ruine",
      0.0075
    ],
    [
      "raffine",
      0.0075
    ],
    [
      "menu",
      0.0075
    ],
    [
      "issue",
      0.0075
    ],
    [
      "fute",
      0.0075
    ],
    [
      "fusele",
      0.0075
    ],
    [
      "effondrement",
      0.0075
    ],
    [
      "doux",
      0.0075
    ],
    [
      "brillant",
      0.0075
    ],
    [
      "aneantissement",
      0.0075
    ],
    [
      "ingenieux",
      0.005
    ],
    [
      "intention",
      0.005
    ],
    [
      "perspicace",
      0.005
    ],
    [
      "percant",
      0.005
    ],
    [
      "petit",
      0.005
    ],
    [
      "excellent",
      0.005
    ],
    [
      "decadence",
      0.005
    ],
    [
      "coda",
      0.005
    ],
    [
      "couronnement",
      0.005
    ],
    [
      "destruction",
      0.005
    ],
    [
      "diplomate",
      0.005
    ],
    [
      "disparition",
      0.005
    ],
    [
      "elance",
      0.005
    ],
    [
      "roublard",
      0.005
    ],
    [
      "retors",
      0.005
    ],
    [
      "pur",
      0.005
    ],
    [
      "maigre",
      0.005
    ],
    [
      "galant",
      0.005
    ],
    [
      "finalite",
      0.005
    ],
    [
      "declin",
      0.005
    ],
    [
      "arret",
      0.005
    ],
    [
      "agonie",
      0.005
    ],
    [
      "pointu",
      0.0025
    ],
    [
      "politique",
      0.0025
    ],
    [
      "precieux",
      0.0025
    ],
    [
      "sagace",
      0.0025
    ],
    [
      "superieur",
      0.0025
    ],
    [
      "tendre",
      0.0025
    ],
    [
      "objectif",
      0.0025
    ],
    [
      "matois",
      0.0025
    ],
    [
      "avise",
      0.0025
    ],
    [
      "consommation",
      0.0025
    ],
    [
      "effet",
      0.0025
    ],
    [
      "filiforme",
      0.0025
    ],
    [
      "finition",
      0.0025
    ],
    [
      "gracile",
      0.0025
    ],
    [
      "limite",
      0.0025
    ],
    [
      "motif",
      0.0025
    ],
    [
      "objet",
      0.0025
    ],
    [
      "perfection",
      0.0025
    ],
    [
      "remarquable",
      0.0025
    ],
    [
      "sortie",
      0.0025
    ],
    [
      "soyeux",
      0.0025
    ],
    [
      "succulent",
      0.0025
    ],
    [
      "visee",
      0.0025
    ],
    [
      "epilogue",
      0.0025
    ],
    [
      "etroit",
      0.0025
    ],
    [
      "evenement",
      0.0025
    ],
    [
      "intrigant",
      0.0025
    ],
    [
      "frele",
      0.0025
    ],
    [
      "frontiere",
      0.0025
    ],
    [
      "acere",
      0.0025
    ],
    [
      "affine",
      0.0025
    ],
    [
      "ambition",
      0.0025
    ],
    [
      "borne",
      0.0025
    ],
    [
      "cauteleux",
      0.0025
    ],
    [
      "clairvoyant",
      0.0025
    ],
    [
      "cloture",
      0.0025
    ],
    [
      "crepuscule",
      0.0025
    ],
    [
      "destination",
      0.0025
    ],
    [
      "enterrement",
      0.0025
    ],
    [
      "expiration",
      0.0025
    ],
    [
      "finaud",
      0.0025
    ],
    [
      "sensible",
      0.0
    ],
    [
      "peroraison",
      0.0
    ],
    [
      "narquois",
      0.0
    ],
    [
      "minuscule",
      0.0
    ],
    [
      "microscopique",
      0.0
    ],
    [
      "impalpable",
      0.0
    ],
    [
      "soir",
      0.0
    ],
    [
      "sort",
      0.0
    ],
    [
      "suspension",
      0.0
    ],
    [
      "tendance",
      0.0
    ],
    [
      "terminus",
      0.0
    ],
    [
      "trepas",
      0.0
    ],
    [
      "vaporeux",
      0.0
    ],
    [
      "vues",
      0.0
    ],
    [
      "guerison",
      0.0
    ],
    [
      "finissage",
      0.0
    ],
    [
      "finale",
      0.0
    ],
    [
      "acheve",
      0.0
    ],
    [
      "aiguise",
      0.0
    ],
    [
      "allonge",
      0.0
    ],
    [
      "arachneen",
      0.0
    ],
    [
      "averti",
      0.0
    ],
    [
      "completement",
      0.0
    ],
    [
      "dessert",
      0.0
    ],
    [
      "debacle",
      0.0
    ],
    [
      "deces",
      0.0
    ],
    [
      "detourne",
      0.0
    ],
    [
      "entendu",
      0.0
    ],
    [
      "entierement",
      0.0
    ],
    [
      "extra",
      0.0
    ],
    [
      "final",
      0.0
    ],
    [
      "absolument",
      0.0
    ]
  ],
  "chaleureux": [
    [
      "ardent",
      0.1625
    ],
    [
      "chaud",
      0.125
    ],
    [
      "bouillonnant",
      0.075
    ],
    [
      "vif",
      0.065
    ],
    [
      "enthousiaste",
      0.0575
    ],
    [
      "zele",
      0.0575
    ],
    [
      "prompt",
      0.0375
    ],
    [
      "fanatique",
      0.0375
    ],
    [
      "enflamme",
      0.0375
    ],
    [
      "cordial",
      0.0375
    ],
    [
      "bouillant",
      0.0375
    ],
    [
      "sympathique",
      0.0275
    ],
    [
      "empresse",
      0.0275
    ],
    [
      "anime",
      0.0275
    ],
    [
      "amical",
      0.0275
    ],
    [
      "vehement",
      0.0175
    ],
    [
      "semillant",
      0.0175
    ],
    [
      "gracieux",
      0.0175
    ],
    [
      "fringant",
      0.0175
    ],
    [
      "fervent",
      0.0175
    ],
    [
      "affectueux",
      0.0075
    ],
    [
      "convivial",
      0.0075
    ],
    [
      "pressant",
      0.0075
    ],
    [
      "triomphal",
      0.0075
    ],
    [
      "emouvant",
      0.0075
    ]
  ],
  "respect": [
    [
      "reverence",
      0.0925
    ],
    [
      "veneration",
      0.0775
    ],
    [
      "honneur",
      0.07
    ],
    [
      "politesse",
      0.0625
    ],
    [
      "hommage",
      0.045
    ],
    [
      "estime",
      0.045
    ],
    [
      "culte",
      0.045
    ],
    [
      "egards",
      0.0375
    ],
    [
      "reserve",
      0.0375
    ],
    [
      "pudeur",
      0.0375
    ],
    [
      "deference",
      0.0375
    ],
    [
      "consideration",
      0.0375
    ],
    [
      "civilite",
      0.0375
    ],
    [
      "courtoisie",
      0.03
    ],
    [
      "retenue",
      0.03
    ],
    [
      "piete",
      0.0225
    ],
    [
      "honte",
      0.0225
    ],
    [
      "galanterie",
      0.0225
    ],
    [
      "decence",
      0.0225
    ],
    [
      "distinction",
      0.0225
    ],
    [
      "humilite",
      0.015
    ],
    [
      "gloire",
      0.015
    ],
    [
      "crainte",
      0.015
    ],
    [
      "adoration",
      0.015
    ],
    [
      "salutation",
      0.005
    ],
    [
      "observance",
      0.005
    ],
    [
      "loyaute",
      0.005
    ],
    [
      "fetichisme",
      0.005
    ],
    [
      "devoir",
      0.005
    ],
    [
      "conformite",
      0.005
    ],
    [
      "affection",
      0.005
    ],
    [
      "tolerance",
      0.005
    ]
  ],
  "lien": [
    [
      "attache",
      0.1075
    ],
    [
      "chaine",
      0.085
    ],
    [
      "liaison",
      0.055
    ],
    [
      "rapport",
      0.055
    ],
    [
      "attachement",
      0.04
    ],
    [
      "corde",
      0.04
    ],
    [
      "fil",
      0.035
    ],
    [
      "relation",
      0.03
    ],
    [
      "assujettissement",
      0.03
    ],
    [
      "ligature",
      0.0225
    ],
    [
      "servitude",
      0.0225
    ],
    [
      "union",
      0.0175
    ],
    [
      "similitude",
      0.0175
    ],
    [
      "joug",
      0.0175
    ],
    [
      "enchainement",
      0.0175
    ],
    [
      "correlation",
      0.0175
    ],
    [
      "cordon",
      0.0175
    ],
    [
      "affinite",
      0.0175
    ],
    [
      "ressemblance",
      0.0125
    ],
    [
      "licou",
      0.0125
    ],
    [
      "licol",
      0.0125
    ],
    [
      "entrave",
      0.0125
    ],
    [
      "courroie",
      0.0125
    ],
    [
      "cage",
      0.0125
    ],
    [
      "bande",
      0.0125
    ],
    [
      "analogie",
      0.0125
    ],
    [
      "amarrage",
      0.0125
    ],
    [
      "affection",
      0.0125
    ],
    [
      "suite",
      0.0075
    ],
    [
      "sangle",
      0.0075
    ],
    [
      "obligation",
      0.0075
    ],
    [
      "noeud",
      0.0075
    ],
    [
      "frequentation",
      0.0075
    ],
    [
      "astreinte",
      0.0075
    ],
    [
      "filiation",
      0.0025
    ],
    [
      "fraternite",
      0.0025
    ],
    [
      "garrot",
      0.0025
    ],
    [
      "hart",
      0.0025
    ],
    [
      "intermediaire",
      0.0025
    ],
    [
      "lacet",
      0.0025
    ],
    [
      "laisse",
      0.0025
    ],
    [
      "prison",
      0.0025
    ],
    [
      "racine",
      0.0025
    ],
    [
      "rouette",
      0.0025
    ],
    [
      "ficelle",
      0.0025
    ],
    [
      "cousinage",
      0.0025
    ],
    [
      "accointage",
      0.0025
    ],
    [
      "accointance",
      0.0025
    ],
    [
      "accolure",
      0.0025
    ],
    [
      "boulet",
      0.0025
    ],
    [
      "bride",
      0.0025
    ],
    [
      "bridure",
      0.0025
    ],
    [
      "bulletin",
      0.0025
    ],
    [
      "carcan",
      0.0025
    ],
    [
      "cep",
      0.0025
    ],
    [
      "ciment",
      0.0025
    ]
  ],
  "croiser": [
    [
      "couper",
      0.12
    ],
    [
      "melanger",
      0.0875
    ],
    [
      "meler",
      0.0875
    ],
    [
      "voir",
      0.0575
    ],
    [
      "rencontrer",
      0.0575
    ],
    [
      "passer",
      0.0575
    ],
    [
      "entrelacer",
      0.0575
    ],
    [
      "s'entrecouper",
      0.0275
    ],
    [
      "parader",
      0.0275
    ],
    [
      "naviguer",
      0.0275
    ],
    [
      "metisser",
      0.0275
    ],
    [
      "matiner",
      0.0275
    ],
    [
      "hybrider",
      0.0275
    ],
    [
      "entrecroiser",
      0.0275
    ],
    [
      "enlacer",
      0.0275
    ],
    [
      "effacer",
      0.0275
    ],
    [
      "coudoyer",
      0.0275
    ],
    [
      "contrepasser",
      0.0275
    ],
    [
      "traverser",
      0.0275
    ]
  ],
  "mien": [],
  "milieu": [
    [
      "atmosphere",
      0.065
    ],
    [
      "ambiance",
      0.055
    ],
    [
      "entourage",
      0.055
    ],
    [
      "sphere",
      0.0425
    ],
    [
      "sein",
      0.0425
    ],
    [
      "environnement",
      0.0425
    ],
    [
      "coeur",
      0.0425
    ],
    [
      "societe",
      0.0325
    ],
    [
      "rang",
      0.0325
    ],
    [
      "lieu",
      0.0325
    ],
    [
      "intermediaire",
      0.0325
    ],
    [
      "espace",
      0.0325
    ],
    [
      "compagnie",
      0.0325
    ],
    [
      "cercle",
      0.0325
    ],
    [
      "centre",
      0.0325
    ],
    [
      "cadre",
      0.0325
    ],
    [
      "terrain",
      0.02
    ],
    [
      "temperament",
      0.02
    ],
    [
      "monde",
      0.02
    ],
    [
      "decor",
      0.02
    ],
    [
      "condition",
      0.02
    ],
    [
      "climat",
      0.02
    ],
    [
      "air",
      0.02
    ],
    [
      "mitan",
      0.0075
    ],
    [
      "moitie",
      0.0075
    ],
    [
      "medium",
      0.0075
    ],
    [
      "patrie",
      0.0075
    ],
    [
      "tiers",
      0.0075
    ],
    [
      "transaction",
      0.0075
    ],
    [
      "volee",
      0.0075
    ],
    [
      "mesure",
      0.0075
    ],
    [
      "intermede",
      0.0075
    ],
    [
      "habitat",
      0.0075
    ],
    [
      "giron",
      0.0075
    ],
    [
      "entrailles",
      0.0075
    ],
    [
      "biotope",
      0.0075
    ],
    [
      "axe",
      0.0075
    ],
    [
      "aura",
      0.0075
    ],
    [
      "element",
      0.0075
    ]
  ],
  "soudain": [
    [
      "aussitot",
      0.1
    ],
    [
      "immediatement",
      0.06
    ],
    [
      "instantanement",
      0.0475
    ],
    [
      "subito",
      0.0375
    ],
    [
      "subit",
      0.0375
    ],
    [
      "rapide",
      0.0375
    ],
    [
      "prompt",
      0.0375
    ],
    [
      "brusque",
      0.0375
    ],
    [
      "vif",
      0.03
    ],
    [
      "subitement",
      0.03
    ],
    [
      "soudainement",
      0.03
    ],
    [
      "illico",
      0.03
    ],
    [
      "d'emblee",
      0.03
    ],
    [
      "incontinent",
      0.0175
    ],
    [
      "inattendu",
      0.0175
    ],
    [
      "imprevu",
      0.0175
    ],
    [
      "immediat",
      0.0175
    ],
    [
      "fulgurant",
      0.0175
    ],
    [
      "brusquement",
      0.0175
    ],
    [
      "incessamment",
      0.0075
    ],
    [
      "instantane",
      0.0075
    ],
    [
      "rapidement",
      0.0075
    ],
    [
      "saisissant",
      0.0075
    ],
    [
      "foudroyant",
      0.0075
    ],
    [
      "brutalement",
      0.0075
    ],
    [
      "brusque",
      0.0075
    ],
    [
      "actif",
      0.0075
    ]
  ],
  "sang": [
    [
      "race",
      0.2175
    ],
    [
      "famille",
      0.13
    ],
    [
      "souche",
      0.13
    ],
    [
      "lignee",
      0.0875
    ],
    [
      "tige",
      0.0425
    ],
    [
      "seve",
      0.0425
    ],
    [
      "rouge",
      0.0425
    ],
    [
      "origine",
      0.0425
    ],
    [
      "nature",
      0.0425
    ],
    [
      "lignage",
      0.0425
    ],
    [
      "heredite",
      0.0425
    ],
    [
      "humeur",
      0.0425
    ],
    [
      "fils",
      0.0425
    ],
    [
      "vermeil",
      0.0425
    ]
  ],
  "gitan": [
    [
      "bohemien",
      0.265
    ],
    [
      "tzigane",
      0.265
    ],
    [
      "romanichel",
      0.1325
    ],
    [
      "boheme",
      0.065
    ],
    [
      "boumian",
      0.065
    ],
    [
      "gipsy",
      0.065
    ],
    [
      "zingaro",
      0.065
    ],
    [
      "egyptien",
      0.065
    ]
  ],
  "goutter": [
    [
      "suinter",
      0.3075
    ],
    [
      "couler",
      0.1525
    ],
    [
      "degoutter",
      0.1525
    ],
    [
      "perler",
      0.1525
    ],
    [
      "transpirer",
      0.1525
    ],
    [
      "s'egoutter",
      0.075
    ]
  ],
  "goutte": [
    [
      "grain",
      0.12
    ],
    [
      "peu",
      0.12
    ],
    [
      "brin",
      0.0675
    ],
    [
      "larme",
      0.05
    ],
    [
      "liard",
      0.05
    ],
    [
      "once",
      0.05
    ],
    [
      "soupcon",
      0.05
    ],
    [
      "perle",
      0.0325
    ],
    [
      "pas",
      0.0325
    ],
    [
      "idee",
      0.0325
    ],
    [
      "gramme",
      0.0325
    ],
    [
      "atome",
      0.0325
    ],
    [
      "podagre",
      0.015
    ],
    [
      "rhumatisme",
      0.015
    ],
    [
      "rien",
      0.015
    ],
    [
      "rincette",
      0.015
    ],
    [
      "roupie",
      0.015
    ],
    [
      "tache",
      0.015
    ],
    [
      "urate",
      0.015
    ],
    [
      "verre",
      0.015
    ],
    [
      "pluie",
      0.015
    ],
    [
      "pincee",
      0.015
    ],
    [
      "alcool",
      0.015
    ],
    [
      "doigt",
      0.015
    ],
    [
      "filet",
      0.015
    ],
    [
      "globule",
      0.015
    ],
    [
      "gouttelette",
      0.015
    ],
    [
      "morve",
      0.015
    ],
    [
      "ne",
      0.015
    ],
    [
      "egoutture",
      0.015
    ]
  ],
  "sueur": [
    [
      "travail",
      0.13
    ],
    [
      "peine",
      0.085
    ],
    [
      "transpiration",
      0.085
    ],
    [
      "mouillure",
      0.0425
    ],
    [
      "souci",
      0.0425
    ],
    [
      "sudation",
      0.0425
    ],
    [
      "suee",
      0.0425
    ],
    [
      "vapeurs",
      0.0425
    ],
    [
      "veille",
      0.0425
    ],
    [
      "moiteur",
      0.0425
    ],
    [
      "hydrorrhee",
      0.0425
    ],
    [
      "humeur",
      0.0425
    ],
    [
      "hidrorrhee",
      0.0425
    ],
    [
      "fatigue",
      0.0425
    ],
    [
      "excretion",
      0.0425
    ],
    [
      "eau",
      0.0425
    ],
    [
      "corvee",
      0.0425
    ],
    [
      "buee",
      0.0425
    ],
    [
      "ecume",
      0.0425
    ]
  ],
  "celebrite": [
    [
      "gloire",
      0.0775
    ],
    [
      "popularite",
      0.0775
    ],
    [
      "renommee",
      0.0775
    ],
    [
      "reputation",
      0.0775
    ],
    [
      "sommite",
      0.065
    ],
    [
      "vogue",
      0.065
    ],
    [
      "personnage",
      0.0525
    ],
    [
      "illustration",
      0.0525
    ],
    [
      "faveur",
      0.0525
    ],
    [
      "credit",
      0.0525
    ],
    [
      "consideration",
      0.0525
    ],
    [
      "renom",
      0.0375
    ],
    [
      "personnalite",
      0.0375
    ],
    [
      "notoriete",
      0.0375
    ],
    [
      "nom",
      0.025
    ],
    [
      "prince",
      0.025
    ],
    [
      "succes",
      0.025
    ],
    [
      "eclat",
      0.0125
    ],
    [
      "vedette",
      0.0125
    ],
    [
      "tenor",
      0.0125
    ],
    [
      "marque",
      0.0125
    ],
    [
      "homme",
      0.0125
    ],
    [
      "fable",
      0.0125
    ],
    [
      "eminence",
      0.0125
    ]
  ],
  "creuser": [
    [
      "fouiller",
      0.0975
    ],
    [
      "percer",
      0.0875
    ],
    [
      "transpercer",
      0.0775
    ],
    [
      "sonder",
      0.0575
    ],
    [
      "ouvrir",
      0.0475
    ],
    [
      "penetrer",
      0.0475
    ],
    [
      "labourer",
      0.0375
    ],
    [
      "fouir",
      0.0375
    ],
    [
      "forer",
      0.0375
    ],
    [
      "enfoncer",
      0.0375
    ],
    [
      "approfondir",
      0.0375
    ],
    [
      "affouiller",
      0.0275
    ],
    [
      "defoncer",
      0.0275
    ],
    [
      "piocher",
      0.0275
    ],
    [
      "trouer",
      0.0275
    ],
    [
      "etudier",
      0.0175
    ],
    [
      "echancrer",
      0.0175
    ],
    [
      "scruter",
      0.0175
    ],
    [
      "miner",
      0.0175
    ],
    [
      "entailler",
      0.0175
    ],
    [
      "effondrer",
      0.0175
    ],
    [
      "caver",
      0.0175
    ],
    [
      "terrasser",
      0.0075
    ],
    [
      "rentrer",
      0.0075
    ],
    [
      "raviner",
      0.0075
    ],
    [
      "foncer",
      0.0075
    ],
    [
      "excaver",
      0.0075
    ],
    [
      "chever",
      0.0075
    ],
    [
      "champlever",
      0.0075
    ],
    [
      "cambrer",
      0.0075
    ],
    [
      "becher",
      0.0075
    ],
    [
      "amaigrir",
      0.0075
    ],
    [
      "aleser",
      0.0075
    ],
    [
      "evider",
      0.0075
    ]
  ],
  "creux": [
    [
      "cavite",
      0.1075
    ],
    [
      "renfoncement",
      0.065
    ],
    [
      "enfoncement",
      0.0575
    ],
    [
      "excavation",
      0.0425
    ],
    [
      "trou",
      0.0425
    ],
    [
      "vide",
      0.0425
    ],
    [
      "depression",
      0.035
    ],
    [
      "abime",
      0.0275
    ],
    [
      "cave",
      0.0275
    ],
    [
      "fond",
      0.0275
    ],
    [
      "vain",
      0.02
    ],
    [
      "profond",
      0.02
    ],
    [
      "gouffre",
      0.02
    ],
    [
      "enfoncee",
      0.02
    ],
    [
      "enfonce",
      0.02
    ],
    [
      "anfractuosite",
      0.02
    ],
    [
      "souffle",
      0.0125
    ],
    [
      "rentre",
      0.0125
    ],
    [
      "ravin",
      0.0125
    ],
    [
      "rainure",
      0.0125
    ],
    [
      "profondeur",
      0.0125
    ],
    [
      "futile",
      0.0125
    ],
    [
      "enfoncure",
      0.0125
    ],
    [
      "emphatique",
      0.0125
    ],
    [
      "ampoule",
      0.0125
    ],
    [
      "caverneux",
      0.0125
    ],
    [
      "concave",
      0.0125
    ],
    [
      "concavite",
      0.0125
    ],
    [
      "cuvette",
      0.0125
    ],
    [
      "leger",
      0.005
    ],
    [
      "maigre",
      0.005
    ],
    [
      "niche",
      0.005
    ],
    [
      "orniere",
      0.005
    ],
    [
      "paume",
      0.005
    ],
    [
      "phraseologie",
      0.005
    ],
    [
      "rentrant",
      0.005
    ],
    [
      "ride",
      0.005
    ],
    [
      "ronflant",
      0.005
    ],
    [
      "sonorite",
      0.005
    ],
    [
      "sourd",
      0.005
    ],
    [
      "irregularite",
      0.005
    ],
    [
      "inutile",
      0.005
    ],
    [
      "interstice",
      0.005
    ],
    [
      "cerne",
      0.005
    ],
    [
      "chambre",
      0.005
    ],
    [
      "chimerique",
      0.005
    ],
    [
      "courbe",
      0.005
    ],
    [
      "encaisse",
      0.005
    ],
    [
      "entaille",
      0.005
    ],
    [
      "faim",
      0.005
    ],
    [
      "fosse",
      0.005
    ],
    [
      "fourche",
      0.005
    ],
    [
      "fringale",
      0.005
    ],
    [
      "imaginaire",
      0.005
    ],
    [
      "evide",
      0.005
    ]
  ],
  "recompter": [],
  "rhabiller": [
    [
      "reparer",
      0.25
    ],
    [
      "refaire",
      0.165
    ],
    [
      "restaurer",
      0.165
    ],
    [
      "arranger",
      0.0825
    ],
    [
      "raccommoder",
      0.0825
    ],
    [
      "renouveler",
      0.0825
    ],
    [
      "revetir",
      0.0825
    ],
    [
      "reviser",
      0.0825
    ]
  ],
  "offrir": [
    [
      "donner",
      0.145
    ],
    [
      "presenter",
      0.1175
    ],
    [
      "montrer",
      0.0575
    ],
    [
      "exposer",
      0.0525
    ],
    [
      "avancer",
      0.045
    ],
    [
      "preter",
      0.0375
    ],
    [
      "proposer",
      0.0375
    ],
    [
      "reveler",
      0.0325
    ],
    [
      "soumettre",
      0.025
    ],
    [
      "porter",
      0.025
    ],
    [
      "payer",
      0.025
    ],
    [
      "fournir",
      0.025
    ],
    [
      "afficher",
      0.025
    ],
    [
      "vouer",
      0.0175
    ],
    [
      "vendre",
      0.0175
    ],
    [
      "servir",
      0.0175
    ],
    [
      "sacrifier",
      0.0175
    ],
    [
      "procurer",
      0.0175
    ],
    [
      "former",
      0.0175
    ],
    [
      "acheter",
      0.0175
    ],
    [
      "etaler",
      0.0125
    ],
    [
      "tendre",
      0.0125
    ],
    [
      "promettre",
      0.0125
    ],
    [
      "laisser",
      0.0125
    ],
    [
      "immoler",
      0.0125
    ],
    [
      "exhiber",
      0.0125
    ],
    [
      "devouer",
      0.0125
    ],
    [
      "dessiner",
      0.0125
    ],
    [
      "avoir",
      0.0125
    ],
    [
      "menager",
      0.005
    ],
    [
      "ouvrir",
      0.005
    ],
    [
      "respirer",
      0.005
    ],
    [
      "exercer",
      0.005
    ],
    [
      "derouler",
      0.005
    ],
    [
      "dedier",
      0.005
    ],
    [
      "allouer",
      0.005
    ],
    [
      "aider",
      0.005
    ],
    [
      "affecter",
      0.005
    ],
    [
      "accorder",
      0.005
    ],
    [
      "soumissionner",
      0.005
    ]
  ],
  "billet": [
    [
      "lettre",
      0.0675
    ],
    [
      "bulletin",
      0.0525
    ],
    [
      "papier",
      0.0525
    ],
    [
      "titre",
      0.0525
    ],
    [
      "message",
      0.045
    ],
    [
      "carte",
      0.045
    ],
    [
      "bon",
      0.0375
    ],
    [
      "certificat",
      0.0375
    ],
    [
      "missive",
      0.0375
    ],
    [
      "ticket",
      0.0275
    ],
    [
      "avis",
      0.0275
    ],
    [
      "argent",
      0.0275
    ],
    [
      "annonce",
      0.0275
    ],
    [
      "bafouille",
      0.0225
    ],
    [
      "depeche",
      0.0225
    ],
    [
      "effet",
      0.0225
    ],
    [
      "pli",
      0.0125
    ],
    [
      "reconnaissance",
      0.0125
    ],
    [
      "recu",
      0.0125
    ],
    [
      "recepisse",
      0.0125
    ],
    [
      "valeur",
      0.0125
    ],
    [
      "numeraire",
      0.0125
    ],
    [
      "monnaie",
      0.0125
    ],
    [
      "especes",
      0.0125
    ],
    [
      "cartel",
      0.0125
    ],
    [
      "bifton",
      0.0125
    ],
    [
      "attestation",
      0.0125
    ],
    [
      "numero",
      0.005
    ],
    [
      "mot",
      0.005
    ],
    [
      "mariage",
      0.005
    ],
    [
      "fonds",
      0.005
    ],
    [
      "passage",
      0.005
    ],
    [
      "poulet",
      0.005
    ],
    [
      "promesse",
      0.005
    ],
    [
      "peze",
      0.005
    ],
    [
      "talbin",
      0.005
    ],
    [
      "fafiot",
      0.005
    ],
    [
      "entree",
      0.005
    ],
    [
      "devise",
      0.005
    ],
    [
      "anonyme",
      0.005
    ],
    [
      "article",
      0.005
    ],
    [
      "assignat",
      0.005
    ],
    [
      "billette",
      0.005
    ],
    [
      "circulaire",
      0.005
    ],
    [
      "contremarque",
      0.005
    ],
    [
      "convocation",
      0.005
    ],
    [
      "correspondance",
      0.005
    ],
    [
      "coupon",
      0.005
    ],
    [
      "coupure",
      0.005
    ],
    [
      "cedule",
      0.005
    ],
    [
      "traite",
      0.005
    ]
  ],
  "violet": [
    [
      "aubergine",
      0.07
    ],
    [
      "violine",
      0.07
    ],
    [
      "violace",
      0.07
    ],
    [
      "prune",
      0.07
    ],
    [
      "pourpre",
      0.07
    ],
    [
      "pensee",
      0.07
    ],
    [
      "parme",
      0.07
    ],
    [
      "mauve",
      0.07
    ],
    [
      "lilas",
      0.07
    ],
    [
      "janthine",
      0.07
    ],
    [
      "incarnat",
      0.07
    ],
    [
      "bleu",
      0.07
    ],
    [
      "zinzolin",
      0.07
    ]
  ],
  "clope": [
    [
      "cigarette",
      0.3325
    ],
    [
      "megot",
      0.3325
    ],
    [
      "pipe",
      0.3325
    ]
  ],
  "cloper": [],
  "tasser": [
    [
      "presser",
      0.1375
    ],
    [
      "serrer",
      0.115
    ],
    [
      "comprimer",
      0.0925
    ],
    [
      "resserrer",
      0.0925
    ],
    [
      "ecraser",
      0.0925
    ],
    [
      "entasser",
      0.0675
    ],
    [
      "reduire",
      0.045
    ],
    [
      "pilonner",
      0.045
    ],
    [
      "empiler",
      0.045
    ],
    [
      "contracter",
      0.045
    ],
    [
      "s'envoyer",
      0.0225
    ],
    [
      "masser",
      0.0225
    ],
    [
      "fouler",
      0.0225
    ],
    [
      "encaquer",
      0.0225
    ],
    [
      "damer",
      0.0225
    ],
    [
      "compresser",
      0.0225
    ],
    [
      "bourrer",
      0.0225
    ],
    [
      "affaisser",
      0.0225
    ]
  ],
  "tasse": [
    [
      "bol",
      0.125
    ],
    [
      "gobelet",
      0.125
    ],
    [
      "jatte",
      0.125
    ],
    [
      "merde",
      0.125
    ],
    [
      "pissotiere",
      0.125
    ],
    [
      "urinoir",
      0.125
    ],
    [
      "vespasienne",
      0.125
    ]
  ],
  "menotte": [
    [
      "main",
      1.0
    ]
  ],
  "plaine": [
    [
      "plan",
      0.2
    ],
    [
      "plat",
      0.2
    ],
    [
      "plein",
      0.2
    ],
    [
      "uni",
      0.2
    ],
    [
      "egal",
      0.2
    ]
  ],
  "clochard": [
    [
      "vagabond",
      0.1475
    ],
    [
      "gueux",
      0.1125
    ],
    [
      "mendiant",
      0.0975
    ],
    [
      "miserable",
      0.0975
    ],
    [
      "pauvre",
      0.08
    ],
    [
      "cloche",
      0.065
    ],
    [
      "chemineau",
      0.0475
    ],
    [
      "clodo",
      0.0475
    ],
    [
      "truand",
      0.0325
    ],
    [
      "trimardeur",
      0.0325
    ],
    [
      "pouilleux",
      0.0325
    ],
    [
      "necessiteux",
      0.0325
    ],
    [
      "misereux",
      0.0325
    ],
    [
      "bohemien",
      0.015
    ],
    [
      "clopinard",
      0.015
    ],
    [
      "deguenille",
      0.015
    ],
    [
      "trimard",
      0.015
    ]
  ],
  "regardant": [
    [
      "avare",
      0.15
    ],
    [
      "chiche",
      0.15
    ],
    [
      "parcimonieux",
      0.12
    ],
    [
      "vetilleux",
      0.06
    ],
    [
      "tatillon",
      0.06
    ],
    [
      "spectateur",
      0.06
    ],
    [
      "serre",
      0.06
    ],
    [
      "pingre",
      0.06
    ],
    [
      "mesquin",
      0.06
    ],
    [
      "avaricieux",
      0.06
    ],
    [
      "curieux",
      0.03
    ],
    [
      "radin",
      0.03
    ],
    [
      "scrupuleux",
      0.03
    ],
    [
      "temoin",
      0.03
    ],
    [
      "econome",
      0.03
    ]
  ],
  "lettre": [
    [
      "billet",
      0.13
    ],
    [
      "missive",
      0.115
    ],
    [
      "bafouille",
      0.0875
    ],
    [
      "message",
      0.0875
    ],
    [
      "note",
      0.0575
    ],
    [
      "depeche",
      0.0425
    ],
    [
      "correspondance",
      0.0425
    ],
    [
      "babillarde",
      0.0425
    ],
    [
      "epitre",
      0.0275
    ],
    [
      "poulet",
      0.0275
    ],
    [
      "pli",
      0.0275
    ],
    [
      "papier",
      0.0275
    ],
    [
      "caractere",
      0.0275
    ],
    [
      "bulletin",
      0.0275
    ],
    [
      "bifton",
      0.0275
    ],
    [
      "voyelle",
      0.0125
    ],
    [
      "tartine",
      0.0125
    ],
    [
      "syllabe",
      0.0125
    ],
    [
      "sens",
      0.0125
    ],
    [
      "savoir",
      0.0125
    ],
    [
      "mot",
      0.0125
    ],
    [
      "litterature",
      0.0125
    ],
    [
      "lazagne",
      0.0125
    ],
    [
      "humanite",
      0.0125
    ],
    [
      "courrier",
      0.0125
    ],
    [
      "carte",
      0.0125
    ],
    [
      "avertissement",
      0.0125
    ],
    [
      "epistole",
      0.0125
    ]
  ],
  "ole": [],
  "parisien": [
    [
      "boulevardier",
      0.3325
    ],
    [
      "parigot",
      0.3325
    ]
  ],
  "encule": [
    [
      "baiser",
      0.3325
    ],
    [
      "emmerder",
      0.3325
    ],
    [
      "sodomiser",
      0.3325
    ]
  ],
  "enculer": [
    [
      "baiser",
      0.3325
    ],
    [
      "emmerder",
      0.3325
    ],
    [
      "sodomiser",
      0.3325
    ]
  ],
  "riche": [
    [
      "abondant",
      0.075
    ],
    [
      "nabab",
      0.065
    ],
    [
      "nanti",
      0.0425
    ],
    [
      "beau",
      0.04
    ],
    [
      "gros",
      0.04
    ],
    [
      "plein",
      0.0325
    ],
    [
      "opulent",
      0.0325
    ],
    [
      "genereux",
      0.03
    ],
    [
      "gras",
      0.0275
    ],
    [
      "bon",
      0.025
    ],
    [
      "large",
      0.025
    ],
    [
      "plantureux",
      0.025
    ],
    [
      "somptueux",
      0.02
    ],
    [
      "fortune",
      0.02
    ],
    [
      "fertile",
      0.02
    ],
    [
      "ample",
      0.0175
    ],
    [
      "fastueux",
      0.0175
    ],
    [
      "heureux",
      0.0175
    ],
    [
      "prospere",
      0.015
    ],
    [
      "profond",
      0.015
    ],
    [
      "magnifique",
      0.015
    ],
    [
      "copieux",
      0.015
    ],
    [
      "brillant",
      0.015
    ],
    [
      "etoffe",
      0.0125
    ],
    [
      "eclatant",
      0.0125
    ],
    [
      "splendide",
      0.0125
    ],
    [
      "luxueux",
      0.0125
    ],
    [
      "cossu",
      0.0125
    ],
    [
      "aise",
      0.0125
    ],
    [
      "substantiel",
      0.0075
    ],
    [
      "rupin",
      0.0075
    ],
    [
      "richissime",
      0.0075
    ],
    [
      "privilegie",
      0.0075
    ],
    [
      "pourvu",
      0.0075
    ],
    [
      "possedant",
      0.0075
    ],
    [
      "nourri",
      0.0075
    ],
    [
      "luxuriant",
      0.0075
    ],
    [
      "florissant",
      0.0075
    ],
    [
      "bourgeois",
      0.0075
    ],
    [
      "argente",
      0.0075
    ],
    [
      "puissant",
      0.005
    ],
    [
      "petri",
      0.005
    ],
    [
      "rentier",
      0.005
    ],
    [
      "succulent",
      0.005
    ],
    [
      "superbe",
      0.005
    ],
    [
      "etendu",
      0.005
    ],
    [
      "precieux",
      0.005
    ],
    [
      "parvenu",
      0.005
    ],
    [
      "nourrissant",
      0.005
    ],
    [
      "cale",
      0.005
    ],
    [
      "capitaliste",
      0.005
    ],
    [
      "exquis",
      0.005
    ],
    [
      "foisonnant",
      0.005
    ],
    [
      "fecond",
      0.005
    ],
    [
      "huppe",
      0.005
    ],
    [
      "onereux",
      0.0
    ],
    [
      "ploutocrate",
      0.0
    ],
    [
      "pompeux",
      0.0
    ],
    [
      "profiteur",
      0.0
    ],
    [
      "pecunieux",
      0.0
    ],
    [
      "raffine",
      0.0
    ],
    [
      "rente",
      0.0
    ],
    [
      "richard",
      0.0
    ],
    [
      "richesse",
      0.0
    ],
    [
      "ruineux",
      0.0
    ],
    [
      "satrape",
      0.0
    ],
    [
      "multimillionnaire",
      0.0
    ],
    [
      "milord",
      0.0
    ],
    [
      "millionnaire",
      0.0
    ],
    [
      "Cresus",
      0.0
    ],
    [
      "argenteux",
      0.0
    ],
    [
      "bourre",
      0.0
    ],
    [
      "boyard",
      0.0
    ],
    [
      "chatoyant",
      0.0
    ],
    [
      "couteux",
      0.0
    ],
    [
      "cresus",
      0.0
    ],
    [
      "dispendieux",
      0.0
    ],
    [
      "debordant",
      0.0
    ],
    [
      "frique",
      0.0
    ],
    [
      "galetteux",
      0.0
    ],
    [
      "milliardaire",
      0.0
    ],
    [
      "souple",
      0.0
    ]
  ],
  "salope": [
    [
      "ignoble",
      0.1925
    ],
    [
      "infame",
      0.1275
    ],
    [
      "sale",
      0.1275
    ],
    [
      "abject",
      0.095
    ],
    [
      "malpropre",
      0.095
    ],
    [
      "vil",
      0.0625
    ],
    [
      "degueulasse",
      0.0625
    ],
    [
      "bas",
      0.0625
    ],
    [
      "balance",
      0.03
    ],
    [
      "donneur",
      0.03
    ],
    [
      "gonzesse",
      0.03
    ],
    [
      "ordure",
      0.03
    ],
    [
      "salete",
      0.03
    ]
  ],
  "legende": [
    [
      "mythe",
      0.21
    ],
    [
      "fable",
      0.13
    ],
    [
      "histoire",
      0.13
    ],
    [
      "folklore",
      0.0775
    ],
    [
      "invention",
      0.0775
    ],
    [
      "recit",
      0.0775
    ],
    [
      "saga",
      0.0775
    ],
    [
      "conte",
      0.0525
    ],
    [
      "devise",
      0.025
    ],
    [
      "inscription",
      0.025
    ],
    [
      "lecture",
      0.025
    ],
    [
      "legendaire",
      0.025
    ],
    [
      "mythologie",
      0.025
    ],
    [
      "tradition",
      0.025
    ]
  ],
  "terrain": [
    [
      "terre",
      0.105
    ],
    [
      "domaine",
      0.0925
    ],
    [
      "champ",
      0.0825
    ],
    [
      "lieu",
      0.07
    ],
    [
      "matiere",
      0.07
    ],
    [
      "pays",
      0.0575
    ],
    [
      "territoire",
      0.045
    ],
    [
      "secteur",
      0.045
    ],
    [
      "aire",
      0.0325
    ],
    [
      "emplacement",
      0.0325
    ],
    [
      "sphere",
      0.0325
    ],
    [
      "sujet",
      0.0325
    ],
    [
      "terroir",
      0.0225
    ],
    [
      "place",
      0.0225
    ],
    [
      "occasion",
      0.0225
    ],
    [
      "milieu",
      0.0225
    ],
    [
      "fief",
      0.0225
    ],
    [
      "theme",
      0.01
    ],
    [
      "stade",
      0.01
    ],
    [
      "sol",
      0.01
    ],
    [
      "rink",
      0.01
    ],
    [
      "relief",
      0.01
    ],
    [
      "parcelle",
      0.01
    ],
    [
      "lotissement",
      0.01
    ],
    [
      "lieux",
      0.01
    ],
    [
      "ground",
      0.01
    ],
    [
      "formation",
      0.01
    ],
    [
      "fonds",
      0.01
    ],
    [
      "clos",
      0.01
    ],
    [
      "chapitre",
      0.01
    ],
    [
      "camp",
      0.01
    ],
    [
      "echiquier",
      0.01
    ]
  ],
  "grailler": [
    [
      "bouffer",
      0.2
    ],
    [
      "crailler",
      0.2
    ],
    [
      "graillonner",
      0.2
    ],
    [
      "grainer",
      0.2
    ],
    [
      "manger",
      0.2
    ]
  ],
  "condamne": [
    [
      "blamer",
      0.085
    ],
    [
      "critiquer",
      0.0575
    ],
    [
      "reprimander",
      0.05
    ],
    [
      "tancer",
      0.05
    ],
    [
      "censurer",
      0.045
    ],
    [
      "reprouver",
      0.045
    ],
    [
      "fletrir",
      0.035
    ],
    [
      "desapprouver",
      0.03
    ],
    [
      "fermer",
      0.03
    ],
    [
      "reprocher",
      0.0275
    ],
    [
      "vituperer",
      0.0225
    ],
    [
      "forcer",
      0.0175
    ],
    [
      "stigmatiser",
      0.0175
    ],
    [
      "punir",
      0.015
    ],
    [
      "obliger",
      0.015
    ],
    [
      "interdire",
      0.015
    ],
    [
      "imposer",
      0.015
    ],
    [
      "fustiger",
      0.015
    ],
    [
      "frapper",
      0.015
    ],
    [
      "empecher",
      0.015
    ],
    [
      "defendre",
      0.015
    ],
    [
      "contraindre",
      0.015
    ],
    [
      "charger",
      0.015
    ],
    [
      "boucher",
      0.015
    ],
    [
      "barrer",
      0.015
    ],
    [
      "assujettir",
      0.015
    ],
    [
      "sevir",
      0.01
    ],
    [
      "proscrire",
      0.01
    ],
    [
      "obstruer",
      0.01
    ],
    [
      "bloquer",
      0.01
    ],
    [
      "astreindre",
      0.01
    ],
    [
      "anathematiser",
      0.01
    ],
    [
      "perdre",
      0.0075
    ],
    [
      "prohiber",
      0.0075
    ],
    [
      "rejeter",
      0.0075
    ],
    [
      "reprendre",
      0.0075
    ],
    [
      "reduire",
      0.0075
    ],
    [
      "sermonner",
      0.0075
    ],
    [
      "epiloguer",
      0.0075
    ],
    [
      "occuper",
      0.0075
    ],
    [
      "obturer",
      0.0075
    ],
    [
      "accabler",
      0.0075
    ],
    [
      "bannir",
      0.0075
    ],
    [
      "barricader",
      0.0075
    ],
    [
      "damner",
      0.0075
    ],
    [
      "incriminer",
      0.0075
    ],
    [
      "maudire",
      0.0075
    ],
    [
      "maconner",
      0.0075
    ],
    [
      "vouer",
      0.0025
    ],
    [
      "sanctionner",
      0.0025
    ],
    [
      "necessiter",
      0.0025
    ],
    [
      "murer",
      0.0025
    ],
    [
      "improuver",
      0.0025
    ],
    [
      "executer",
      0.0025
    ],
    [
      "desavouer",
      0.0025
    ],
    [
      "dejuger",
      0.0025
    ]
  ],
  "degre": [
    [
      "echelon",
      0.1175
    ],
    [
      "rang",
      0.0925
    ],
    [
      "echelle",
      0.0675
    ],
    [
      "point",
      0.0575
    ],
    [
      "etage",
      0.045
    ],
    [
      "stade",
      0.045
    ],
    [
      "position",
      0.045
    ],
    [
      "phase",
      0.045
    ],
    [
      "niveau",
      0.045
    ],
    [
      "grade",
      0.045
    ],
    [
      "mesure",
      0.0325
    ],
    [
      "titre",
      0.0325
    ],
    [
      "etape",
      0.0225
    ],
    [
      "situation",
      0.0225
    ],
    [
      "poids",
      0.0225
    ],
    [
      "marche",
      0.0225
    ],
    [
      "gradin",
      0.0225
    ],
    [
      "escalier",
      0.0225
    ],
    [
      "classe",
      0.0225
    ],
    [
      "rayon",
      0.01
    ],
    [
      "rangee",
      0.01
    ],
    [
      "periode",
      0.01
    ],
    [
      "proximite",
      0.01
    ],
    [
      "perron",
      0.01
    ],
    [
      "nuance",
      0.01
    ],
    [
      "note",
      0.01
    ],
    [
      "marchepied",
      0.01
    ],
    [
      "graduation",
      0.01
    ],
    [
      "diplome",
      0.01
    ],
    [
      "difference",
      0.01
    ],
    [
      "cran",
      0.01
    ],
    [
      "amplitude",
      0.01
    ],
    [
      "transition",
      0.01
    ]
  ],
  "pedaler": [
    [
      "cavaler",
      0.5
    ],
    [
      "courir",
      0.5
    ]
  ],
  "laisse": [
    [
      "abandonner",
      0.12
    ],
    [
      "donner",
      0.0925
    ],
    [
      "ceder",
      0.07
    ],
    [
      "quitter",
      0.065
    ],
    [
      "renoncer",
      0.0525
    ],
    [
      "passer",
      0.0425
    ],
    [
      "lacher",
      0.0425
    ],
    [
      "aliener",
      0.035
    ],
    [
      "remettre",
      0.03
    ],
    [
      "oublier",
      0.03
    ],
    [
      "delaisser",
      0.03
    ],
    [
      "vendre",
      0.025
    ],
    [
      "deposer",
      0.02
    ],
    [
      "mettre",
      0.02
    ],
    [
      "transmettre",
      0.015
    ],
    [
      "tolerer",
      0.015
    ],
    [
      "planter",
      0.015
    ],
    [
      "permettre",
      0.015
    ],
    [
      "perdre",
      0.015
    ],
    [
      "negliger",
      0.015
    ],
    [
      "leguer",
      0.015
    ],
    [
      "livrer",
      0.015
    ],
    [
      "semer",
      0.0125
    ],
    [
      "plaquer",
      0.0125
    ],
    [
      "omettre",
      0.0125
    ],
    [
      "consentir",
      0.0125
    ],
    [
      "cesser",
      0.0125
    ],
    [
      "solder",
      0.0075
    ],
    [
      "offrir",
      0.0075
    ],
    [
      "manquer",
      0.0075
    ],
    [
      "immoler",
      0.0075
    ],
    [
      "confier",
      0.0075
    ],
    [
      "autoriser",
      0.0075
    ],
    [
      "abjurer",
      0.0025
    ],
    [
      "camper",
      0.0025
    ],
    [
      "marquer",
      0.0025
    ],
    [
      "souffrir",
      0.0025
    ]
  ],
  "hotesse": [
    [
      "receptionniste",
      1.0
    ]
  ],
  "the": [
    [
      "collation",
      0.1675
    ],
    [
      "theier",
      0.0825
    ],
    [
      "reception",
      0.0825
    ],
    [
      "mate",
      0.0825
    ],
    [
      "gouter",
      0.0825
    ],
    [
      "boisson",
      0.0825
    ],
    [
      "bavaroise",
      0.0825
    ],
    [
      "ambroisie",
      0.0825
    ],
    [
      "theine",
      0.0825
    ]
  ],
  "continue": [
    [
      "suivi",
      0.145
    ],
    [
      "constant",
      0.1
    ],
    [
      "incessant",
      0.06
    ],
    [
      "eternel",
      0.055
    ],
    [
      "perpetuel",
      0.0475
    ],
    [
      "persistant",
      0.0475
    ],
    [
      "immuable",
      0.0425
    ],
    [
      "permanent",
      0.0325
    ],
    [
      "ininterrompu",
      0.0325
    ],
    [
      "durable",
      0.0325
    ],
    [
      "continuel",
      0.0325
    ],
    [
      "stable",
      0.0275
    ],
    [
      "soutenu",
      0.0275
    ],
    [
      "sempiternel",
      0.0275
    ],
    [
      "regulier",
      0.0275
    ],
    [
      "invariable",
      0.0275
    ],
    [
      "assidu",
      0.0275
    ],
    [
      "inepuisable",
      0.015
    ],
    [
      "infini",
      0.015
    ],
    [
      "fixe",
      0.015
    ],
    [
      "successif",
      0.01
    ],
    [
      "interminable",
      0.01
    ],
    [
      "indefectible",
      0.01
    ],
    [
      "d'affilee",
      0.01
    ],
    [
      "tenant",
      0.005
    ],
    [
      "prolonge",
      0.005
    ],
    [
      "opiniatre",
      0.005
    ],
    [
      "inextinguible",
      0.005
    ],
    [
      "indiscontinu",
      0.005
    ],
    [
      "continent",
      0.005
    ],
    [
      "uniforme",
      0.005
    ]
  ],
  "continuer": [
    [
      "demeurer",
      0.0675
    ],
    [
      "perseverer",
      0.0675
    ],
    [
      "durer",
      0.0625
    ],
    [
      "persister",
      0.0625
    ],
    [
      "tenir",
      0.0575
    ],
    [
      "subsister",
      0.0525
    ],
    [
      "rester",
      0.0525
    ],
    [
      "trainer",
      0.0475
    ],
    [
      "poursuivre",
      0.0425
    ],
    [
      "s'obstiner",
      0.0425
    ],
    [
      "s'eterniser",
      0.035
    ],
    [
      "soutenir",
      0.03
    ],
    [
      "prolonger",
      0.025
    ],
    [
      "s'etendre",
      0.025
    ],
    [
      "s'enteter",
      0.02
    ],
    [
      "survivre",
      0.015
    ],
    [
      "suivre",
      0.015
    ],
    [
      "s'opiniatrer",
      0.015
    ],
    [
      "s'acharner",
      0.015
    ],
    [
      "pousser",
      0.015
    ],
    [
      "maintenir",
      0.015
    ],
    [
      "insister",
      0.015
    ],
    [
      "conserver",
      0.015
    ],
    [
      "allonger",
      0.015
    ],
    [
      "eterniser",
      0.01
    ],
    [
      "perpetuer",
      0.01
    ],
    [
      "courir",
      0.01
    ],
    [
      "augmenter",
      0.01
    ],
    [
      "aller",
      0.01
    ],
    [
      "succeder",
      0.005
    ],
    [
      "substituer",
      0.005
    ],
    [
      "reprendre",
      0.005
    ],
    [
      "reconduire",
      0.005
    ],
    [
      "proroger",
      0.005
    ],
    [
      "exister",
      0.005
    ],
    [
      "etendre",
      0.005
    ]
  ],
  "voter": [
    [
      "adopter",
      0.25
    ],
    [
      "deliberer",
      0.25
    ],
    [
      "opiner",
      0.25
    ],
    [
      "plebisciter",
      0.25
    ]
  ],
  "escalier": [
    [
      "degre",
      0.2
    ],
    [
      "echelle",
      0.2
    ],
    [
      "colimacon",
      0.0975
    ],
    [
      "descente",
      0.0975
    ],
    [
      "escadrin",
      0.0975
    ],
    [
      "marches",
      0.0975
    ],
    [
      "montee",
      0.0975
    ],
    [
      "perron",
      0.0975
    ]
  ],
  "prononcer": [
    [
      "dire",
      0.0975
    ],
    [
      "exprimer",
      0.0575
    ],
    [
      "decider",
      0.0425
    ],
    [
      "faire",
      0.0425
    ],
    [
      "proferer",
      0.0425
    ],
    [
      "enoncer",
      0.0425
    ],
    [
      "pousser",
      0.0325
    ],
    [
      "declarer",
      0.0325
    ],
    [
      "articuler",
      0.0275
    ],
    [
      "debiter",
      0.0275
    ],
    [
      "parler",
      0.0275
    ],
    [
      "trancher",
      0.0275
    ],
    [
      "emettre",
      0.0225
    ],
    [
      "temoigner",
      0.0225
    ],
    [
      "affirmer",
      0.0225
    ],
    [
      "rendre",
      0.0175
    ],
    [
      "publier",
      0.0175
    ],
    [
      "porter",
      0.0175
    ],
    [
      "ordonner",
      0.0175
    ],
    [
      "marquer",
      0.0175
    ],
    [
      "declamer",
      0.0175
    ],
    [
      "statuer",
      0.0125
    ],
    [
      "scander",
      0.0125
    ],
    [
      "reciter",
      0.0125
    ],
    [
      "proclamer",
      0.0125
    ],
    [
      "marteler",
      0.0125
    ],
    [
      "detailler",
      0.0125
    ],
    [
      "bredouiller",
      0.0125
    ],
    [
      "balbutier",
      0.0125
    ],
    [
      "appuyer",
      0.0125
    ],
    [
      "adresser",
      0.0125
    ],
    [
      "accentuer",
      0.0125
    ],
    [
      "souffler",
      0.0075
    ],
    [
      "nasiller",
      0.0075
    ],
    [
      "murmurer",
      0.0075
    ],
    [
      "juger",
      0.0075
    ],
    [
      "formuler",
      0.0075
    ],
    [
      "bafouiller",
      0.0075
    ],
    [
      "accuser",
      0.0075
    ],
    [
      "nasonner",
      0.0025
    ],
    [
      "machonner",
      0.0025
    ],
    [
      "lire",
      0.0025
    ],
    [
      "infliger",
      0.0025
    ],
    [
      "grasseyer",
      0.0025
    ],
    [
      "detacher",
      0.0025
    ],
    [
      "decreter",
      0.0025
    ],
    [
      "chuchoter",
      0.0025
    ],
    [
      "begayer",
      0.0025
    ],
    [
      "arreter",
      0.0025
    ],
    [
      "psalmodier",
      0.0025
    ]
  ],
  "blaze": [],
  "rigoler": [
    [
      "rire",
      0.265
    ],
    [
      "blaguer",
      0.1325
    ],
    [
      "plaisanter",
      0.1325
    ],
    [
      "badiner",
      0.065
    ]
  ],
  "ouh": [],
  "poster": [
    [
      "affiche",
      1.0
    ]
  ],
  "totalement": [
    [
      "entierement",
      0.1325
    ],
    [
      "completement",
      0.125
    ],
    [
      "absolument",
      0.095
    ],
    [
      "integralement",
      0.0575
    ],
    [
      "pleinement",
      0.0425
    ],
    [
      "parfaitement",
      0.0425
    ],
    [
      "bien",
      0.0425
    ],
    [
      "foncierement",
      0.035
    ],
    [
      "exactement",
      0.0275
    ],
    [
      "radicalement",
      0.02
    ],
    [
      "strictement",
      0.02
    ],
    [
      "unanimement",
      0.0125
    ],
    [
      "profondement",
      0.0125
    ],
    [
      "diametralement",
      0.0125
    ],
    [
      "remarquablement",
      0.005
    ],
    [
      "rigoureusement",
      0.005
    ],
    [
      "royalement",
      0.005
    ],
    [
      "generalement",
      0.005
    ],
    [
      "franchement",
      0.005
    ],
    [
      "fondamentalement",
      0.005
    ],
    [
      "exhaustivement",
      0.005
    ],
    [
      "ensemble",
      0.005
    ]
  ],
  "clique": [
    [
      "clan",
      0.1625
    ],
    [
      "coterie",
      0.1625
    ],
    [
      "groupe",
      0.1
    ],
    [
      "camarilla",
      0.08
    ],
    [
      "boutique",
      0.06
    ],
    [
      "chapelle",
      0.06
    ],
    [
      "fanfare",
      0.06
    ],
    [
      "reunion",
      0.04
    ],
    [
      "orchestre",
      0.04
    ],
    [
      "musique",
      0.04
    ],
    [
      "faction",
      0.04
    ],
    [
      "bande",
      0.04
    ],
    [
      "cabale",
      0.02
    ],
    [
      "clairon",
      0.02
    ],
    [
      "maffia",
      0.02
    ],
    [
      "musicien",
      0.02
    ],
    [
      "quarteron",
      0.02
    ]
  ],
  "cloque": [
    [
      "ampoule",
      0.25
    ],
    [
      "boursouflure",
      0.25
    ],
    [
      "bulle",
      0.125
    ],
    [
      "bouffissure",
      0.0625
    ],
    [
      "brulure",
      0.0625
    ],
    [
      "cloche",
      0.0625
    ],
    [
      "gonflement",
      0.0625
    ],
    [
      "phlyctene",
      0.0625
    ],
    [
      "vesicule",
      0.0625
    ]
  ],
  "peser": [
    [
      "examiner",
      0.0575
    ],
    [
      "estimer",
      0.0475
    ],
    [
      "evaluer",
      0.0475
    ],
    [
      "apprecier",
      0.04
    ],
    [
      "considerer",
      0.035
    ],
    [
      "etudier",
      0.0275
    ],
    [
      "pousser",
      0.0275
    ],
    [
      "mesurer",
      0.0275
    ],
    [
      "juger",
      0.0275
    ],
    [
      "faire",
      0.0275
    ],
    [
      "accabler",
      0.0275
    ],
    [
      "compter",
      0.025
    ],
    [
      "ecraser",
      0.02
    ],
    [
      "porter",
      0.02
    ],
    [
      "oppresser",
      0.02
    ],
    [
      "voir",
      0.0175
    ],
    [
      "reflechir",
      0.0175
    ],
    [
      "penser",
      0.0175
    ],
    [
      "fatiguer",
      0.0175
    ],
    [
      "ennuyer",
      0.0175
    ],
    [
      "determiner",
      0.0175
    ],
    [
      "charger",
      0.0175
    ],
    [
      "appuyer",
      0.0175
    ],
    [
      "approfondir",
      0.0175
    ],
    [
      "alourdir",
      0.0175
    ],
    [
      "sonder",
      0.0125
    ],
    [
      "opprimer",
      0.0125
    ],
    [
      "comparer",
      0.0125
    ],
    [
      "calculer",
      0.0125
    ],
    [
      "etouffer",
      0.01
    ],
    [
      "tomber",
      0.01
    ],
    [
      "supputer",
      0.01
    ],
    [
      "regarder",
      0.01
    ],
    [
      "presser",
      0.01
    ],
    [
      "murir",
      0.01
    ],
    [
      "importer",
      0.01
    ],
    [
      "gener",
      0.01
    ],
    [
      "grever",
      0.01
    ],
    [
      "assombrir",
      0.01
    ],
    [
      "influencer",
      0.005
    ],
    [
      "influer",
      0.005
    ],
    [
      "peiner",
      0.005
    ],
    [
      "poser",
      0.005
    ],
    [
      "retomber",
      0.005
    ],
    [
      "valoir",
      0.005
    ],
    [
      "incliner",
      0.005
    ],
    [
      "importuner",
      0.005
    ],
    [
      "aggraver",
      0.005
    ],
    [
      "appesantir",
      0.005
    ],
    [
      "balancer",
      0.005
    ],
    [
      "compasser",
      0.005
    ],
    [
      "controler",
      0.005
    ],
    [
      "exceder",
      0.005
    ],
    [
      "reagir",
      0.0025
    ],
    [
      "soupeser",
      0.0025
    ],
    [
      "suffoquer",
      0.0025
    ],
    [
      "tamiser",
      0.0025
    ],
    [
      "tarer",
      0.0025
    ],
    [
      "intimider",
      0.0025
    ],
    [
      "incomber",
      0.0025
    ],
    [
      "haler",
      0.0025
    ],
    [
      "degouter",
      0.0025
    ],
    [
      "couter",
      0.0025
    ],
    [
      "accentuer",
      0.0025
    ],
    [
      "trebucher",
      0.0025
    ]
  ],
  "entrainer": [
    [
      "pousser",
      0.065
    ],
    [
      "provoquer",
      0.0575
    ],
    [
      "exciter",
      0.055
    ],
    [
      "determiner",
      0.045
    ],
    [
      "soulever",
      0.045
    ],
    [
      "attirer",
      0.0425
    ],
    [
      "amener",
      0.0375
    ],
    [
      "conduire",
      0.035
    ],
    [
      "occasionner",
      0.0275
    ],
    [
      "susciter",
      0.0275
    ],
    [
      "appeler",
      0.0225
    ],
    [
      "emporter",
      0.0225
    ],
    [
      "engager",
      0.0225
    ],
    [
      "transporter",
      0.0225
    ],
    [
      "porter",
      0.02
    ],
    [
      "produire",
      0.0175
    ],
    [
      "mener",
      0.0125
    ],
    [
      "inciter",
      0.0125
    ],
    [
      "enlever",
      0.0125
    ],
    [
      "causer",
      0.0125
    ],
    [
      "enflammer",
      0.0125
    ],
    [
      "forcer",
      0.0125
    ],
    [
      "trainer",
      0.01
    ],
    [
      "persuader",
      0.01
    ],
    [
      "inviter",
      0.01
    ],
    [
      "charmer",
      0.01
    ],
    [
      "seduire",
      0.0075
    ],
    [
      "presser",
      0.0075
    ],
    [
      "necessiter",
      0.0075
    ],
    [
      "former",
      0.0075
    ],
    [
      "engendrer",
      0.0075
    ],
    [
      "diriger",
      0.0075
    ],
    [
      "conquerir",
      0.0075
    ],
    [
      "commander",
      0.0075
    ],
    [
      "styler",
      0.0075
    ],
    [
      "jeter",
      0.0075
    ],
    [
      "exercer",
      0.0075
    ],
    [
      "dresser",
      0.0075
    ],
    [
      "contraindre",
      0.0075
    ],
    [
      "charrier",
      0.0075
    ],
    [
      "captiver",
      0.0075
    ],
    [
      "apporter",
      0.0075
    ],
    [
      "agir",
      0.0075
    ],
    [
      "tenter",
      0.005
    ],
    [
      "preparer",
      0.005
    ],
    [
      "obliger",
      0.005
    ],
    [
      "impliquer",
      0.005
    ],
    [
      "habituer",
      0.005
    ],
    [
      "embarquer",
      0.005
    ],
    [
      "creer",
      0.005
    ],
    [
      "convaincre",
      0.005
    ],
    [
      "conseiller",
      0.005
    ],
    [
      "rouler",
      0.0025
    ],
    [
      "rompre",
      0.0025
    ],
    [
      "guider",
      0.0025
    ],
    [
      "emmener",
      0.0025
    ],
    [
      "declencher",
      0.0025
    ],
    [
      "decider",
      0.0025
    ],
    [
      "dechainer",
      0.0025
    ],
    [
      "eduquer",
      0.0025
    ],
    [
      "tirer",
      0.0025
    ],
    [
      "operer",
      0.0025
    ],
    [
      "motiver",
      0.0025
    ],
    [
      "envelopper",
      0.0025
    ],
    [
      "emballer",
      0.0025
    ],
    [
      "aguerrir",
      0.0025
    ],
    [
      "eparpiller",
      0.0
    ],
    [
      "resulter",
      0.0
    ],
    [
      "resoudre",
      0.0
    ],
    [
      "galvaniser",
      0.0
    ],
    [
      "familiariser",
      0.0
    ],
    [
      "endurcir",
      0.0
    ],
    [
      "s'accompagner",
      0.0
    ],
    [
      "influencer",
      0.0
    ],
    [
      "engrener",
      0.0
    ],
    [
      "debaucher",
      0.0
    ],
    [
      "drosser",
      0.0
    ],
    [
      "actionner",
      0.0
    ],
    [
      "acclimater",
      0.0
    ],
    [
      "electriser",
      0.0
    ]
  ],
  "metrage": [],
  "sage": [
    [
      "bon",
      0.0525
    ],
    [
      "calme",
      0.0525
    ],
    [
      "prudent",
      0.0525
    ],
    [
      "serieux",
      0.0525
    ],
    [
      "raisonnable",
      0.05
    ],
    [
      "pose",
      0.0425
    ],
    [
      "reserve",
      0.0375
    ],
    [
      "reflechi",
      0.03
    ],
    [
      "pondere",
      0.03
    ],
    [
      "honnete",
      0.03
    ],
    [
      "modere",
      0.0275
    ],
    [
      "avise",
      0.025
    ],
    [
      "retenu",
      0.025
    ],
    [
      "vertueux",
      0.025
    ],
    [
      "eclaire",
      0.02
    ],
    [
      "mesure",
      0.02
    ],
    [
      "judicieux",
      0.02
    ],
    [
      "doux",
      0.02
    ],
    [
      "grave",
      0.0175
    ],
    [
      "tranquille",
      0.0175
    ],
    [
      "sense",
      0.015
    ],
    [
      "pur",
      0.015
    ],
    [
      "pudique",
      0.015
    ],
    [
      "juste",
      0.015
    ],
    [
      "decent",
      0.015
    ],
    [
      "circonspect",
      0.015
    ],
    [
      "chaste",
      0.015
    ],
    [
      "sain",
      0.01
    ],
    [
      "modeste",
      0.01
    ],
    [
      "intelligent",
      0.01
    ],
    [
      "equilibre",
      0.0075
    ],
    [
      "sur",
      0.0075
    ],
    [
      "serein",
      0.0075
    ],
    [
      "savant",
      0.0075
    ],
    [
      "regle",
      0.0075
    ],
    [
      "philosophe",
      0.0075
    ],
    [
      "continent",
      0.0075
    ],
    [
      "averti",
      0.0075
    ],
    [
      "severe",
      0.005
    ],
    [
      "soumis",
      0.005
    ],
    [
      "silencieux",
      0.005
    ],
    [
      "sagace",
      0.005
    ],
    [
      "raisonne",
      0.005
    ],
    [
      "obeissant",
      0.005
    ],
    [
      "logique",
      0.005
    ],
    [
      "instruit",
      0.005
    ],
    [
      "gentil",
      0.005
    ],
    [
      "docile",
      0.005
    ],
    [
      "discipline",
      0.005
    ],
    [
      "prevoyant",
      0.0025
    ],
    [
      "politique",
      0.0025
    ],
    [
      "pacifique",
      0.0025
    ],
    [
      "nestor",
      0.0025
    ],
    [
      "mature",
      0.0025
    ],
    [
      "marabout",
      0.0025
    ],
    [
      "mage",
      0.0025
    ],
    [
      "gourou",
      0.0025
    ],
    [
      "yogi",
      0.0025
    ]
  ],
  "su": [
    [
      "connaitre",
      0.26
    ],
    [
      "apprendre",
      0.11
    ],
    [
      "comprendre",
      0.11
    ],
    [
      "voir",
      0.11
    ],
    [
      "imaginer",
      0.0725
    ],
    [
      "s'attendre",
      0.035
    ],
    [
      "pouvoir",
      0.035
    ],
    [
      "posseder",
      0.035
    ]
  ],
  "diable": [
    [
      "demon",
      0.075
    ],
    [
      "espiegle",
      0.075
    ],
    [
      "mechant",
      0.075
    ],
    [
      "terrible",
      0.0675
    ],
    [
      "turbulent",
      0.05
    ],
    [
      "polisson",
      0.0375
    ],
    [
      "mauvais",
      0.0375
    ],
    [
      "dur",
      0.0375
    ],
    [
      "coquin",
      0.0375
    ],
    [
      "vif",
      0.0275
    ],
    [
      "malin",
      0.0275
    ],
    [
      "insupportable",
      0.0275
    ],
    [
      "infernal",
      0.0275
    ],
    [
      "fripon",
      0.0275
    ],
    [
      "diablotin",
      0.0275
    ],
    [
      "gaillard",
      0.0225
    ],
    [
      "fou",
      0.0225
    ],
    [
      "drole",
      0.0225
    ],
    [
      "eveille",
      0.0125
    ],
    [
      "serpent",
      0.0125
    ],
    [
      "miserable",
      0.0125
    ],
    [
      "lutin",
      0.0125
    ],
    [
      "intenable",
      0.0125
    ],
    [
      "furie",
      0.0125
    ],
    [
      "enfant",
      0.0125
    ],
    [
      "dragon",
      0.0125
    ],
    [
      "bougre",
      0.0125
    ],
    [
      "harpie",
      0.005
    ],
    [
      "homme",
      0.005
    ],
    [
      "incube",
      0.005
    ],
    [
      "indiscipline",
      0.005
    ],
    [
      "maudit",
      0.005
    ],
    [
      "succube",
      0.005
    ],
    [
      "garnement",
      0.005
    ],
    [
      "foutre",
      0.005
    ],
    [
      "fardier",
      0.005
    ],
    [
      "diantre",
      0.005
    ],
    [
      "diabolo",
      0.005
    ],
    [
      "diableteau",
      0.005
    ],
    [
      "chariot",
      0.005
    ],
    [
      "cabrouet",
      0.005
    ],
    [
      "brouette",
      0.005
    ],
    [
      "boufre",
      0.005
    ],
    [
      "tentateur",
      0.005
    ]
  ],
  "apotre": [
    [
      "proselyte",
      0.1525
    ],
    [
      "champion",
      0.12
    ],
    [
      "missionnaire",
      0.09
    ],
    [
      "zelateur",
      0.09
    ],
    [
      "tenant",
      0.06
    ],
    [
      "sermonnaire",
      0.06
    ],
    [
      "propagateur",
      0.06
    ],
    [
      "defenseur",
      0.06
    ],
    [
      "disciple",
      0.06
    ],
    [
      "combattant",
      0.06
    ],
    [
      "avocat",
      0.03
    ],
    [
      "convertisseur",
      0.03
    ],
    [
      "ministre",
      0.03
    ],
    [
      "professeur",
      0.03
    ],
    [
      "predicateur",
      0.03
    ],
    [
      "saint",
      0.03
    ]
  ],
  "perler": [
    [
      "polir",
      0.1025
    ],
    [
      "ciseler",
      0.0875
    ],
    [
      "fignoler",
      0.0875
    ],
    [
      "parfaire",
      0.0875
    ],
    [
      "lecher",
      0.0725
    ],
    [
      "soigner",
      0.0725
    ],
    [
      "suinter",
      0.0575
    ],
    [
      "limer",
      0.0425
    ],
    [
      "transpirer",
      0.0425
    ],
    [
      "poindre",
      0.0275
    ],
    [
      "percer",
      0.0275
    ],
    [
      "peaufiner",
      0.0275
    ],
    [
      "parachever",
      0.0275
    ],
    [
      "naitre",
      0.0275
    ],
    [
      "goutter",
      0.0275
    ],
    [
      "degoutter",
      0.0275
    ],
    [
      "degouliner",
      0.0275
    ],
    [
      "raffiner",
      0.0125
    ],
    [
      "pourlecher",
      0.0125
    ],
    [
      "peigner",
      0.0125
    ],
    [
      "fouiller",
      0.0125
    ],
    [
      "emperler",
      0.0125
    ],
    [
      "apparaitre",
      0.0125
    ],
    [
      "s'ecouler",
      0.0125
    ]
  ],
  "perle": [
    [
      "merveille",
      0.12
    ],
    [
      "perfection",
      0.12
    ],
    [
      "phenix",
      0.12
    ],
    [
      "tresor",
      0.08
    ],
    [
      "goutte",
      0.08
    ],
    [
      "bijou",
      0.08
    ],
    [
      "modele",
      0.04
    ],
    [
      "marguerite",
      0.04
    ],
    [
      "larme",
      0.04
    ],
    [
      "lapsus",
      0.04
    ],
    [
      "joyau",
      0.04
    ],
    [
      "grain",
      0.04
    ],
    [
      "betise",
      0.04
    ],
    [
      "bevue",
      0.04
    ],
    [
      "boule",
      0.04
    ],
    [
      "perlouse",
      0.04
    ]
  ],
  "eloigner": [
    [
      "ecarter",
      0.1025
    ],
    [
      "repousser",
      0.08
    ],
    [
      "renvoyer",
      0.075
    ],
    [
      "chasser",
      0.065
    ],
    [
      "exclure",
      0.045
    ],
    [
      "refuser",
      0.045
    ],
    [
      "rejeter",
      0.04
    ],
    [
      "detourner",
      0.04
    ],
    [
      "arracher",
      0.0325
    ],
    [
      "eliminer",
      0.0325
    ],
    [
      "detacher",
      0.0275
    ],
    [
      "exiler",
      0.0225
    ],
    [
      "bannir",
      0.0225
    ],
    [
      "econduire",
      0.0175
    ],
    [
      "separer",
      0.0175
    ],
    [
      "remercier",
      0.0175
    ],
    [
      "reculer",
      0.0175
    ],
    [
      "proscrire",
      0.0175
    ],
    [
      "distraire",
      0.0175
    ],
    [
      "ajourner",
      0.0175
    ],
    [
      "retirer",
      0.0125
    ],
    [
      "deraciner",
      0.0125
    ],
    [
      "degouter",
      0.0125
    ],
    [
      "dissuader",
      0.0125
    ],
    [
      "congedier",
      0.0125
    ],
    [
      "evincer",
      0.0075
    ],
    [
      "egarer",
      0.0075
    ],
    [
      "temporiser",
      0.0075
    ],
    [
      "retarder",
      0.0075
    ],
    [
      "remettre",
      0.0075
    ],
    [
      "releguer",
      0.0075
    ],
    [
      "pousser",
      0.0075
    ],
    [
      "conjurer",
      0.0075
    ],
    [
      "differer",
      0.0075
    ],
    [
      "dissiper",
      0.0075
    ],
    [
      "debouter",
      0.0075
    ],
    [
      "decliner",
      0.0075
    ],
    [
      "desaffectionner",
      0.0075
    ],
    [
      "surseoir",
      0.0025
    ],
    [
      "devier",
      0.0025
    ],
    [
      "derouter",
      0.0025
    ],
    [
      "distancer",
      0.0025
    ],
    [
      "aliener",
      0.0025
    ],
    [
      "epargner",
      0.0025
    ]
  ],
  "ramener": [
    [
      "remettre",
      0.15
    ],
    [
      "rapporter",
      0.1
    ],
    [
      "remmener",
      0.0825
    ],
    [
      "retablir",
      0.0475
    ],
    [
      "reduire",
      0.0475
    ],
    [
      "remener",
      0.0475
    ],
    [
      "concentrer",
      0.0475
    ],
    [
      "tirer",
      0.0325
    ],
    [
      "restaurer",
      0.0325
    ],
    [
      "reporter",
      0.0325
    ],
    [
      "rendre",
      0.0325
    ],
    [
      "remporter",
      0.0325
    ],
    [
      "redonner",
      0.0325
    ],
    [
      "reconduire",
      0.0325
    ],
    [
      "mener",
      0.0325
    ],
    [
      "diminuer",
      0.0325
    ],
    [
      "amener",
      0.0325
    ],
    [
      "remonter",
      0.015
    ],
    [
      "rappeler",
      0.015
    ],
    [
      "raccompagner",
      0.015
    ],
    [
      "rabouler",
      0.015
    ],
    [
      "rabattre",
      0.015
    ],
    [
      "centraliser",
      0.015
    ],
    [
      "ressusciter",
      0.015
    ]
  ],
  "dessaper": [],
  "vouer": [
    [
      "donner",
      0.1775
    ],
    [
      "appliquer",
      0.11
    ],
    [
      "destiner",
      0.11
    ],
    [
      "consacrer",
      0.0875
    ],
    [
      "devouer",
      0.0875
    ],
    [
      "offrir",
      0.065
    ],
    [
      "dedier",
      0.065
    ],
    [
      "adresser",
      0.065
    ],
    [
      "promettre",
      0.0425
    ],
    [
      "predestiner",
      0.0425
    ],
    [
      "sacrifier",
      0.0425
    ],
    [
      "appeler",
      0.02
    ],
    [
      "attacher",
      0.02
    ],
    [
      "condamner",
      0.02
    ],
    [
      "reserver",
      0.02
    ]
  ],
  "voue": [
    [
      "donner",
      0.1775
    ],
    [
      "appliquer",
      0.11
    ],
    [
      "destiner",
      0.11
    ],
    [
      "consacrer",
      0.0875
    ],
    [
      "devouer",
      0.0875
    ],
    [
      "offrir",
      0.065
    ],
    [
      "dedier",
      0.065
    ],
    [
      "adresser",
      0.065
    ],
    [
      "promettre",
      0.0425
    ],
    [
      "predestiner",
      0.0425
    ],
    [
      "sacrifier",
      0.0425
    ],
    [
      "appeler",
      0.02
    ],
    [
      "attacher",
      0.02
    ],
    [
      "condamner",
      0.02
    ],
    [
      "reserver",
      0.02
    ]
  ],
  "enfer": [
    [
      "douleur",
      0.1
    ],
    [
      "desordre",
      0.1
    ],
    [
      "peine",
      0.05
    ],
    [
      "pandemonium",
      0.05
    ],
    [
      "mal",
      0.05
    ],
    [
      "limbes",
      0.05
    ],
    [
      "gehenne",
      0.05
    ],
    [
      "feu",
      0.05
    ],
    [
      "confusion",
      0.05
    ],
    [
      "caveau",
      0.05
    ],
    [
      "brasier",
      0.05
    ],
    [
      "bagne",
      0.05
    ],
    [
      "ardeur",
      0.05
    ],
    [
      "abime",
      0.05
    ],
    [
      "Tartare",
      0.05
    ],
    [
      "scheol",
      0.05
    ]
  ],
  "ascenseur": [
    [
      "elevateur",
      0.5
    ]
  ],
  "panne": [
    [
      "lard",
      0.125
    ],
    [
      "entretoise",
      0.0825
    ],
    [
      "poutre",
      0.0825
    ],
    [
      "fourrure",
      0.04
    ],
    [
      "graisse",
      0.04
    ],
    [
      "incident",
      0.04
    ],
    [
      "interruption",
      0.04
    ],
    [
      "misere",
      0.04
    ],
    [
      "pauvrete",
      0.04
    ],
    [
      "roustissure",
      0.04
    ],
    [
      "ferme",
      0.04
    ],
    [
      "entremise",
      0.04
    ],
    [
      "couenne",
      0.04
    ],
    [
      "comble",
      0.04
    ],
    [
      "charcuterie",
      0.04
    ],
    [
      "barde",
      0.04
    ],
    [
      "arret",
      0.04
    ],
    [
      "accroc",
      0.04
    ],
    [
      "accident",
      0.04
    ],
    [
      "velours",
      0.04
    ]
  ],
  "bloque": [
    [
      "arreter",
      0.1175
    ],
    [
      "fixer",
      0.0575
    ],
    [
      "immobiliser",
      0.0575
    ],
    [
      "fermer",
      0.05
    ],
    [
      "retenir",
      0.045
    ],
    [
      "endiguer",
      0.04
    ],
    [
      "paralyser",
      0.035
    ],
    [
      "freiner",
      0.03
    ],
    [
      "barrer",
      0.03
    ],
    [
      "caler",
      0.025
    ],
    [
      "stopper",
      0.025
    ],
    [
      "suspendre",
      0.02
    ],
    [
      "serrer",
      0.02
    ],
    [
      "obstruer",
      0.02
    ],
    [
      "maintenir",
      0.02
    ],
    [
      "contenir",
      0.02
    ],
    [
      "coincer",
      0.02
    ],
    [
      "amasser",
      0.02
    ],
    [
      "reunir",
      0.0175
    ],
    [
      "entourer",
      0.0175
    ],
    [
      "entasser",
      0.0175
    ],
    [
      "enrayer",
      0.0175
    ],
    [
      "empecher",
      0.0175
    ],
    [
      "coller",
      0.0175
    ],
    [
      "cerner",
      0.0175
    ],
    [
      "encercler",
      0.0125
    ],
    [
      "couper",
      0.0125
    ],
    [
      "condamner",
      0.0125
    ],
    [
      "barricader",
      0.0125
    ],
    [
      "assieger",
      0.0125
    ],
    [
      "accumuler",
      0.0125
    ],
    [
      "stabiliser",
      0.0075
    ],
    [
      "rassembler",
      0.0075
    ],
    [
      "masser",
      0.0075
    ],
    [
      "investir",
      0.0075
    ],
    [
      "grouper",
      0.0075
    ],
    [
      "geler",
      0.0075
    ],
    [
      "envelopper",
      0.0075
    ],
    [
      "encombrer",
      0.0075
    ],
    [
      "consolider",
      0.0075
    ],
    [
      "verrouiller",
      0.0025
    ],
    [
      "souquer",
      0.0025
    ],
    [
      "potasser",
      0.0025
    ],
    [
      "obturer",
      0.0025
    ],
    [
      "isoler",
      0.0025
    ],
    [
      "empiler",
      0.0025
    ],
    [
      "embouteiller",
      0.0025
    ],
    [
      "bucher",
      0.0025
    ],
    [
      "ankyloser",
      0.0025
    ],
    [
      "echouer",
      0.0025
    ]
  ],
  "bloquer": [
    [
      "arreter",
      0.1175
    ],
    [
      "fixer",
      0.0575
    ],
    [
      "immobiliser",
      0.0575
    ],
    [
      "fermer",
      0.05
    ],
    [
      "retenir",
      0.045
    ],
    [
      "endiguer",
      0.04
    ],
    [
      "paralyser",
      0.035
    ],
    [
      "freiner",
      0.03
    ],
    [
      "barrer",
      0.03
    ],
    [
      "caler",
      0.025
    ],
    [
      "stopper",
      0.025
    ],
    [
      "suspendre",
      0.02
    ],
    [
      "serrer",
      0.02
    ],
    [
      "obstruer",
      0.02
    ],
    [
      "maintenir",
      0.02
    ],
    [
      "contenir",
      0.02
    ],
    [
      "coincer",
      0.02
    ],
    [
      "amasser",
      0.02
    ],
    [
      "reunir",
      0.0175
    ],
    [
      "entourer",
      0.0175
    ],
    [
      "entasser",
      0.0175
    ],
    [
      "enrayer",
      0.0175
    ],
    [
      "empecher",
      0.0175
    ],
    [
      "coller",
      0.0175
    ],
    [
      "cerner",
      0.0175
    ],
    [
      "encercler",
      0.0125
    ],
    [
      "couper",
      0.0125
    ],
    [
      "condamner",
      0.0125
    ],
    [
      "barricader",
      0.0125
    ],
    [
      "assieger",
      0.0125
    ],
    [
      "accumuler",
      0.0125
    ],
    [
      "stabiliser",
      0.0075
    ],
    [
      "rassembler",
      0.0075
    ],
    [
      "masser",
      0.0075
    ],
    [
      "investir",
      0.0075
    ],
    [
      "grouper",
      0.0075
    ],
    [
      "geler",
      0.0075
    ],
    [
      "envelopper",
      0.0075
    ],
    [
      "encombrer",
      0.0075
    ],
    [
      "consolider",
      0.0075
    ],
    [
      "verrouiller",
      0.0025
    ],
    [
      "souquer",
      0.0025
    ],
    [
      "potasser",
      0.0025
    ],
    [
      "obturer",
      0.0025
    ],
    [
      "isoler",
      0.0025
    ],
    [
      "empiler",
      0.0025
    ],
    [
      "embouteiller",
      0.0025
    ],
    [
      "bucher",
      0.0025
    ],
    [
      "ankyloser",
      0.0025
    ],
    [
      "echouer",
      0.0025
    ]
  ],
  "famille": [
    [
      "race",
      0.125
    ],
    [
      "filiation",
      0.07
    ],
    [
      "lignee",
      0.06
    ],
    [
      "descendance",
      0.055
    ],
    [
      "groupe",
      0.0475
    ],
    [
      "origine",
      0.0425
    ],
    [
      "ascendance",
      0.0375
    ],
    [
      "parente",
      0.035
    ],
    [
      "maison",
      0.035
    ],
    [
      "extraction",
      0.035
    ],
    [
      "clan",
      0.0225
    ],
    [
      "souche",
      0.0225
    ],
    [
      "societe",
      0.02
    ],
    [
      "ligne",
      0.02
    ],
    [
      "lignage",
      0.02
    ],
    [
      "genealogie",
      0.02
    ],
    [
      "classe",
      0.02
    ],
    [
      "tribu",
      0.0125
    ],
    [
      "generation",
      0.0125
    ],
    [
      "foyer",
      0.0125
    ],
    [
      "espece",
      0.0125
    ],
    [
      "consanguinite",
      0.0125
    ],
    [
      "ecole",
      0.01
    ],
    [
      "sorte",
      0.01
    ],
    [
      "sang",
      0.01
    ],
    [
      "posterite",
      0.01
    ],
    [
      "portee",
      0.01
    ],
    [
      "heredite",
      0.01
    ],
    [
      "coterie",
      0.01
    ],
    [
      "colonie",
      0.01
    ],
    [
      "toit",
      0.005
    ],
    [
      "progeniture",
      0.005
    ],
    [
      "parents",
      0.005
    ],
    [
      "menage",
      0.005
    ],
    [
      "genre",
      0.005
    ],
    [
      "couvee",
      0.005
    ],
    [
      "categorie",
      0.005
    ],
    [
      "branche",
      0.005
    ],
    [
      "alliance",
      0.005
    ],
    [
      "maisonnee",
      0.0025
    ],
    [
      "marmaille",
      0.0025
    ],
    [
      "matriarcat",
      0.0025
    ],
    [
      "nichee",
      0.0025
    ],
    [
      "parentele",
      0.0025
    ],
    [
      "patriarcat",
      0.0025
    ],
    [
      "patrie",
      0.0025
    ],
    [
      "smala",
      0.0025
    ],
    [
      "taxon",
      0.0025
    ],
    [
      "tendance",
      0.0025
    ],
    [
      "logis",
      0.0025
    ],
    [
      "humanite",
      0.0025
    ],
    [
      "gent",
      0.0025
    ],
    [
      "agnation",
      0.0025
    ],
    [
      "auteurs",
      0.0025
    ],
    [
      "bercail",
      0.0025
    ],
    [
      "bloc",
      0.0025
    ],
    [
      "cognation",
      0.0025
    ],
    [
      "collection",
      0.0025
    ],
    [
      "communion",
      0.0025
    ],
    [
      "dynastie",
      0.0025
    ],
    [
      "entourage",
      0.0025
    ],
    [
      "feu",
      0.0025
    ],
    [
      "type",
      0.0025
    ]
  ],
  "faim": [
    [
      "appetit",
      0.14
    ],
    [
      "fringale",
      0.1025
    ],
    [
      "avidite",
      0.0925
    ],
    [
      "desir",
      0.0925
    ],
    [
      "soif",
      0.075
    ],
    [
      "envie",
      0.065
    ],
    [
      "convoitise",
      0.065
    ],
    [
      "appetence",
      0.055
    ],
    [
      "boulimie",
      0.055
    ],
    [
      "ambition",
      0.0375
    ],
    [
      "besoin",
      0.0375
    ],
    [
      "voracite",
      0.0275
    ],
    [
      "cupidite",
      0.0275
    ],
    [
      "disette",
      0.0175
    ],
    [
      "famine",
      0.0175
    ],
    [
      "souhait",
      0.0175
    ],
    [
      "necessite",
      0.0075
    ],
    [
      "inanition",
      0.0075
    ],
    [
      "dent",
      0.0075
    ],
    [
      "creux",
      0.0075
    ],
    [
      "polyphagie",
      0.0075
    ]
  ],
  "treve": [
    [
      "repos",
      0.095
    ],
    [
      "arret",
      0.0825
    ],
    [
      "cessation",
      0.0825
    ],
    [
      "repit",
      0.0825
    ],
    [
      "suspension",
      0.0725
    ],
    [
      "pause",
      0.06
    ],
    [
      "armistice",
      0.06
    ],
    [
      "interruption",
      0.0475
    ],
    [
      "remission",
      0.035
    ],
    [
      "relache",
      0.035
    ],
    [
      "detente",
      0.035
    ],
    [
      "bonace",
      0.035
    ],
    [
      "accalmie",
      0.035
    ],
    [
      "abandon",
      0.035
    ],
    [
      "tranquillite",
      0.0225
    ],
    [
      "paix",
      0.0225
    ],
    [
      "halte",
      0.0225
    ],
    [
      "delai",
      0.0225
    ],
    [
      "conge",
      0.01
    ],
    [
      "discontinuation",
      0.01
    ],
    [
      "delassement",
      0.01
    ],
    [
      "moratoire",
      0.01
    ]
  ],
  "baliverne": [
    [
      "fadaise",
      0.0975
    ],
    [
      "bagatelle",
      0.0875
    ],
    [
      "chanson",
      0.0775
    ],
    [
      "sornette",
      0.0675
    ],
    [
      "betise",
      0.0625
    ],
    [
      "niaiserie",
      0.05
    ],
    [
      "sottise",
      0.05
    ],
    [
      "futilite",
      0.045
    ],
    [
      "frivolite",
      0.04
    ],
    [
      "calembredaine",
      0.04
    ],
    [
      "babiole",
      0.03
    ],
    [
      "bricole",
      0.03
    ],
    [
      "faribole",
      0.0275
    ],
    [
      "rien",
      0.0275
    ],
    [
      "propos",
      0.0225
    ],
    [
      "foutaise",
      0.0225
    ],
    [
      "fichaise",
      0.0225
    ],
    [
      "billevesee",
      0.0225
    ],
    [
      "enfantillage",
      0.0175
    ],
    [
      "conte",
      0.0125
    ],
    [
      "connerie",
      0.0125
    ],
    [
      "balancoire",
      0.0125
    ],
    [
      "vetille",
      0.0075
    ],
    [
      "superfluite",
      0.0075
    ],
    [
      "rigolade",
      0.0075
    ],
    [
      "puerilite",
      0.0075
    ],
    [
      "naivete",
      0.0075
    ],
    [
      "histoire",
      0.0075
    ],
    [
      "facetie",
      0.0075
    ],
    [
      "coquecigrue",
      0.0075
    ],
    [
      "bourde",
      0.0075
    ],
    [
      "bibelot",
      0.0025
    ],
    [
      "cocasserie",
      0.0025
    ],
    [
      "inutilite",
      0.0025
    ],
    [
      "postiche",
      0.0025
    ]
  ],
  "calin": [
    [
      "tendre",
      0.2
    ],
    [
      "affectueux",
      0.1
    ],
    [
      "amoureux",
      0.1
    ],
    [
      "caressant",
      0.1
    ],
    [
      "doux",
      0.1
    ],
    [
      "paresseux",
      0.0475
    ],
    [
      "mignard",
      0.0475
    ],
    [
      "gracieux",
      0.0475
    ],
    [
      "enjoleur",
      0.0475
    ],
    [
      "calinerie",
      0.0475
    ],
    [
      "cajoleur",
      0.0475
    ],
    [
      "aimant",
      0.0475
    ],
    [
      "sentimental",
      0.0475
    ]
  ],
  "glacon": [
    [
      "glace",
      1.0
    ]
  ],
  "string": [
    [
      "culotte",
      0.5
    ]
  ],
  "ficelle": [
    [
      "accoutrer",
      0.1
    ],
    [
      "attacher",
      0.1
    ],
    [
      "habiller",
      0.1
    ],
    [
      "affubler",
      0.0725
    ],
    [
      "fagoter",
      0.0725
    ],
    [
      "fringuer",
      0.0725
    ],
    [
      "lier",
      0.0725
    ],
    [
      "ligoter",
      0.0475
    ],
    [
      "garrotter",
      0.0475
    ],
    [
      "entourer",
      0.0475
    ],
    [
      "emprisonner",
      0.0475
    ],
    [
      "attifer",
      0.0475
    ],
    [
      "arranger",
      0.0225
    ],
    [
      "atteler",
      0.0225
    ],
    [
      "brider",
      0.0225
    ],
    [
      "lacer",
      0.0225
    ],
    [
      "paqueter",
      0.0225
    ],
    [
      "vetir",
      0.0225
    ]
  ],
  "ficeler": [
    [
      "accoutrer",
      0.1
    ],
    [
      "attacher",
      0.1
    ],
    [
      "habiller",
      0.1
    ],
    [
      "affubler",
      0.0725
    ],
    [
      "fagoter",
      0.0725
    ],
    [
      "fringuer",
      0.0725
    ],
    [
      "lier",
      0.0725
    ],
    [
      "ligoter",
      0.0475
    ],
    [
      "garrotter",
      0.0475
    ],
    [
      "entourer",
      0.0475
    ],
    [
      "emprisonner",
      0.0475
    ],
    [
      "attifer",
      0.0475
    ],
    [
      "arranger",
      0.0225
    ],
    [
      "atteler",
      0.0225
    ],
    [
      "brider",
      0.0225
    ],
    [
      "lacer",
      0.0225
    ],
    [
      "paqueter",
      0.0225
    ],
    [
      "vetir",
      0.0225
    ]
  ],
  "allo": [],
  "trace": [
    [
      "marque",
      0.1375
    ],
    [
      "empreinte",
      0.0675
    ],
    [
      "vestige",
      0.0675
    ],
    [
      "foulee",
      0.05
    ],
    [
      "souvenir",
      0.05
    ],
    [
      "stigmate",
      0.0425
    ],
    [
      "voie",
      0.0325
    ],
    [
      "sillon",
      0.0325
    ],
    [
      "passage",
      0.0325
    ],
    [
      "temoignage",
      0.025
    ],
    [
      "trainee",
      0.025
    ],
    [
      "sillage",
      0.025
    ],
    [
      "pas",
      0.025
    ],
    [
      "ombre",
      0.025
    ],
    [
      "impression",
      0.025
    ],
    [
      "reste",
      0.015
    ],
    [
      "repere",
      0.015
    ],
    [
      "preuve",
      0.015
    ],
    [
      "pied",
      0.015
    ],
    [
      "peu",
      0.015
    ],
    [
      "passee",
      0.015
    ],
    [
      "memoire",
      0.015
    ],
    [
      "indice",
      0.015
    ],
    [
      "fumet",
      0.015
    ],
    [
      "cicatrice",
      0.015
    ],
    [
      "brisees",
      0.015
    ],
    [
      "pointe",
      0.0075
    ],
    [
      "ride",
      0.0075
    ],
    [
      "reminiscence",
      0.0075
    ],
    [
      "sceau",
      0.0075
    ],
    [
      "senteur",
      0.0075
    ],
    [
      "signature",
      0.0075
    ],
    [
      "tache",
      0.0075
    ],
    [
      "teinte",
      0.0075
    ],
    [
      "piste",
      0.0075
    ],
    [
      "orniere",
      0.0075
    ],
    [
      "arome",
      0.0075
    ],
    [
      "bavure",
      0.0075
    ],
    [
      "connaissance",
      0.0075
    ],
    [
      "degoulinade",
      0.0075
    ],
    [
      "erre",
      0.0075
    ],
    [
      "fumee",
      0.0075
    ],
    [
      "lueur",
      0.0075
    ],
    [
      "odeur",
      0.0075
    ],
    [
      "vermoulure",
      0.0075
    ]
  ],
  "tracer": [
    [
      "dessiner",
      0.09
    ],
    [
      "representer",
      0.0825
    ],
    [
      "faire",
      0.065
    ],
    [
      "marquer",
      0.065
    ],
    [
      "figurer",
      0.055
    ],
    [
      "indiquer",
      0.055
    ],
    [
      "peindre",
      0.045
    ],
    [
      "former",
      0.035
    ],
    [
      "piqueter",
      0.035
    ],
    [
      "ecrire",
      0.025
    ],
    [
      "signifier",
      0.025
    ],
    [
      "signaler",
      0.025
    ],
    [
      "dresser",
      0.025
    ],
    [
      "courir",
      0.025
    ],
    [
      "aligner",
      0.025
    ],
    [
      "tirer",
      0.0175
    ],
    [
      "regler",
      0.0175
    ],
    [
      "retracer",
      0.0175
    ],
    [
      "pointiller",
      0.0175
    ],
    [
      "piquer",
      0.0175
    ],
    [
      "inscrire",
      0.0175
    ],
    [
      "graver",
      0.0175
    ],
    [
      "esquisser",
      0.0175
    ],
    [
      "decrire",
      0.0175
    ],
    [
      "crayonner",
      0.0175
    ],
    [
      "baliser",
      0.0175
    ],
    [
      "normaliser",
      0.0075
    ],
    [
      "poursuivre",
      0.0075
    ],
    [
      "profiler",
      0.0075
    ],
    [
      "raconter",
      0.0075
    ],
    [
      "ligner",
      0.0075
    ],
    [
      "jalonner",
      0.0075
    ],
    [
      "frayer",
      0.0075
    ],
    [
      "delineer",
      0.0075
    ],
    [
      "courser",
      0.0075
    ],
    [
      "construire",
      0.0075
    ],
    [
      "ebaucher",
      0.0075
    ]
  ],
  "transe": [
    [
      "alarme",
      0.0775
    ],
    [
      "angoisse",
      0.0775
    ],
    [
      "inquietude",
      0.0775
    ],
    [
      "crainte",
      0.055
    ],
    [
      "exaltation",
      0.055
    ],
    [
      "transport",
      0.045
    ],
    [
      "enthousiasme",
      0.045
    ],
    [
      "epouvante",
      0.0375
    ],
    [
      "tourment",
      0.0375
    ],
    [
      "frayeur",
      0.0375
    ],
    [
      "excitation",
      0.0375
    ],
    [
      "effroi",
      0.0375
    ],
    [
      "delire",
      0.0375
    ],
    [
      "affres",
      0.0375
    ],
    [
      "emotion",
      0.03
    ],
    [
      "peur",
      0.03
    ],
    [
      "anxiete",
      0.03
    ],
    [
      "ravissement",
      0.0225
    ],
    [
      "souci",
      0.0225
    ],
    [
      "surexcitation",
      0.015
    ],
    [
      "supplice",
      0.015
    ],
    [
      "frenesie",
      0.015
    ],
    [
      "crise",
      0.015
    ],
    [
      "apprehension",
      0.015
    ],
    [
      "allegresse",
      0.0075
    ],
    [
      "extase",
      0.0075
    ],
    [
      "hypnose",
      0.0075
    ],
    [
      "inspiration",
      0.0075
    ],
    [
      "tintouin",
      0.0075
    ]
  ],
  "buller": [],
  "bulle": [
    [
      "rescrit",
      0.095
    ],
    [
      "decretale",
      0.06
    ],
    [
      "decret",
      0.06
    ],
    [
      "constitution",
      0.06
    ],
    [
      "cloque",
      0.06
    ],
    [
      "bref",
      0.06
    ],
    [
      "boursouflure",
      0.06
    ],
    [
      "ampoule",
      0.06
    ],
    [
      "acte",
      0.06
    ],
    [
      "mandement",
      0.03
    ],
    [
      "mousse",
      0.03
    ],
    [
      "phlyctene",
      0.03
    ],
    [
      "phylactere",
      0.03
    ],
    [
      "sceau",
      0.03
    ],
    [
      "globule",
      0.03
    ],
    [
      "fermeture",
      0.03
    ],
    [
      "cachet",
      0.03
    ],
    [
      "boule",
      0.03
    ],
    [
      "bouillon",
      0.03
    ],
    [
      "ballon",
      0.03
    ],
    [
      "balle",
      0.03
    ],
    [
      "vesicule",
      0.03
    ]
  ],
  "shit": [],
  "pull": [],
  "miens": [],
  "convenir": [
    [
      "aller",
      0.065
    ],
    [
      "plaire",
      0.045
    ],
    [
      "s'accorder",
      0.045
    ],
    [
      "agreer",
      0.0325
    ],
    [
      "concorder",
      0.0325
    ],
    [
      "correspondre",
      0.03
    ],
    [
      "conclure",
      0.03
    ],
    [
      "cadrer",
      0.03
    ],
    [
      "avouer",
      0.03
    ],
    [
      "arranger",
      0.03
    ],
    [
      "accorder",
      0.03
    ],
    [
      "traiter",
      0.0225
    ],
    [
      "seoir",
      0.0225
    ],
    [
      "satisfaire",
      0.0225
    ],
    [
      "s'harmoniser",
      0.0225
    ],
    [
      "s'adapter",
      0.0225
    ],
    [
      "regler",
      0.0225
    ],
    [
      "reconnaitre",
      0.0225
    ],
    [
      "admettre",
      0.0225
    ],
    [
      "dire",
      0.0175
    ],
    [
      "s'entendre",
      0.015
    ],
    [
      "trancher",
      0.015
    ],
    [
      "s'appliquer",
      0.015
    ],
    [
      "repondre",
      0.015
    ],
    [
      "accommoder",
      0.015
    ],
    [
      "appartenir",
      0.015
    ],
    [
      "chanter",
      0.015
    ],
    [
      "decider",
      0.015
    ],
    [
      "declarer",
      0.015
    ],
    [
      "sourire",
      0.0075
    ],
    [
      "s'assortir",
      0.0075
    ],
    [
      "s'approprier",
      0.0075
    ],
    [
      "resoudre",
      0.0075
    ],
    [
      "revenir",
      0.0075
    ],
    [
      "habiller",
      0.0075
    ],
    [
      "confesser",
      0.0075
    ],
    [
      "botter",
      0.0075
    ],
    [
      "arreter",
      0.0075
    ],
    [
      "s'agir",
      0.0025
    ],
    [
      "ganter",
      0.0025
    ],
    [
      "gager",
      0.0025
    ],
    [
      "falloir",
      0.0025
    ],
    [
      "constater",
      0.0025
    ],
    [
      "conceder",
      0.0025
    ],
    [
      "assortir",
      0.0025
    ]
  ],
  "convier": [
    [
      "appeler",
      0.17
    ],
    [
      "inviter",
      0.17
    ],
    [
      "inciter",
      0.0975
    ],
    [
      "convoquer",
      0.0725
    ],
    [
      "engager",
      0.0725
    ],
    [
      "solliciter",
      0.0475
    ],
    [
      "provoquer",
      0.0475
    ],
    [
      "mander",
      0.0475
    ],
    [
      "exciter",
      0.0475
    ],
    [
      "demander",
      0.0475
    ],
    [
      "exhorter",
      0.0225
    ],
    [
      "incliner",
      0.0225
    ],
    [
      "induire",
      0.0225
    ],
    [
      "prier",
      0.0225
    ],
    [
      "semondre",
      0.0225
    ],
    [
      "supplier",
      0.0225
    ],
    [
      "traiter",
      0.0225
    ]
  ],
  "rond": [
    [
      "rebondi",
      0.07
    ],
    [
      "cercle",
      0.0475
    ],
    [
      "gras",
      0.0475
    ],
    [
      "gros",
      0.0475
    ],
    [
      "dodu",
      0.04
    ],
    [
      "rondelet",
      0.035
    ],
    [
      "replet",
      0.035
    ],
    [
      "potele",
      0.035
    ],
    [
      "plein",
      0.035
    ],
    [
      "franc",
      0.035
    ],
    [
      "simple",
      0.0275
    ],
    [
      "orbe",
      0.0275
    ],
    [
      "courbe",
      0.0275
    ],
    [
      "charnu",
      0.0275
    ],
    [
      "arrondi",
      0.0275
    ],
    [
      "sphere",
      0.02
    ],
    [
      "sou",
      0.02
    ],
    [
      "renfle",
      0.02
    ],
    [
      "poupard",
      0.02
    ],
    [
      "grassouillet",
      0.02
    ],
    [
      "boulot",
      0.02
    ],
    [
      "vrai",
      0.0125
    ],
    [
      "sincere",
      0.0125
    ],
    [
      "rondouillard",
      0.0125
    ],
    [
      "rondelle",
      0.0125
    ],
    [
      "radis",
      0.0125
    ],
    [
      "mafflu",
      0.0125
    ],
    [
      "globe",
      0.0125
    ],
    [
      "court",
      0.0125
    ],
    [
      "circonference",
      0.0125
    ],
    [
      "boule",
      0.0125
    ],
    [
      "balle",
      0.0125
    ],
    [
      "ring",
      0.005
    ],
    [
      "orbite",
      0.005
    ],
    [
      "orbiculaire",
      0.005
    ],
    [
      "onde",
      0.005
    ],
    [
      "rotin",
      0.005
    ],
    [
      "soul",
      0.005
    ],
    [
      "spherique",
      0.005
    ],
    [
      "spheroide",
      0.005
    ],
    [
      "tranche",
      0.005
    ],
    [
      "ventripotent",
      0.005
    ],
    [
      "loyal",
      0.005
    ],
    [
      "ivre",
      0.005
    ],
    [
      "disque",
      0.005
    ],
    [
      "anneau",
      0.005
    ],
    [
      "centime",
      0.005
    ],
    [
      "cerceau",
      0.005
    ],
    [
      "cerne",
      0.005
    ],
    [
      "circulaire",
      0.005
    ],
    [
      "cordial",
      0.005
    ],
    [
      "cylindre",
      0.005
    ],
    [
      "cylindrique",
      0.005
    ],
    [
      "denier",
      0.005
    ],
    [
      "direct",
      0.005
    ],
    [
      "voute",
      0.005
    ]
  ],
  "attraper": [
    [
      "prendre",
      0.095
    ],
    [
      "gagner",
      0.0425
    ],
    [
      "tromper",
      0.0375
    ],
    [
      "saisir",
      0.0325
    ],
    [
      "derober",
      0.03
    ],
    [
      "piquer",
      0.0275
    ],
    [
      "voler",
      0.025
    ],
    [
      "seduire",
      0.025
    ],
    [
      "obtenir",
      0.025
    ],
    [
      "faire",
      0.025
    ],
    [
      "capter",
      0.0225
    ],
    [
      "abuser",
      0.02
    ],
    [
      "berner",
      0.02
    ],
    [
      "remporter",
      0.0175
    ],
    [
      "enjoler",
      0.0175
    ],
    [
      "avoir",
      0.0175
    ],
    [
      "atteindre",
      0.0175
    ],
    [
      "duper",
      0.0175
    ],
    [
      "toucher",
      0.0175
    ],
    [
      "reprimander",
      0.015
    ],
    [
      "ramasser",
      0.015
    ],
    [
      "conquerir",
      0.015
    ],
    [
      "chiper",
      0.015
    ],
    [
      "tancer",
      0.0125
    ],
    [
      "soutirer",
      0.0125
    ],
    [
      "sermonner",
      0.0125
    ],
    [
      "s'emparer",
      0.0125
    ],
    [
      "enlever",
      0.0125
    ],
    [
      "accrocher",
      0.0125
    ],
    [
      "surprendre",
      0.01
    ],
    [
      "refaire",
      0.01
    ],
    [
      "faucher",
      0.01
    ],
    [
      "capturer",
      0.01
    ],
    [
      "choper",
      0.01
    ],
    [
      "extorquer",
      0.01
    ],
    [
      "gronder",
      0.01
    ],
    [
      "piper",
      0.0075
    ],
    [
      "leurrer",
      0.0075
    ],
    [
      "empaumer",
      0.0075
    ],
    [
      "admonester",
      0.0075
    ],
    [
      "embabouiner",
      0.0075
    ],
    [
      "encaisser",
      0.0075
    ],
    [
      "gourmander",
      0.0075
    ],
    [
      "recevoir",
      0.0075
    ],
    [
      "morigener",
      0.005
    ],
    [
      "frapper",
      0.005
    ],
    [
      "engueuler",
      0.005
    ],
    [
      "disputer",
      0.005
    ],
    [
      "subtiliser",
      0.0025
    ],
    [
      "secouer",
      0.0025
    ],
    [
      "retrouver",
      0.0025
    ],
    [
      "rendre",
      0.0025
    ],
    [
      "penetrer",
      0.0025
    ],
    [
      "happer",
      0.0025
    ],
    [
      "empoigner",
      0.0025
    ],
    [
      "decevoir",
      0.0025
    ],
    [
      "crier",
      0.0025
    ],
    [
      "contracter",
      0.0025
    ],
    [
      "agripper",
      0.0025
    ],
    [
      "imiter",
      0.0025
    ],
    [
      "mystifier",
      0.0025
    ],
    [
      "piger",
      0.0025
    ],
    [
      "profiter",
      0.0025
    ],
    [
      "quereller",
      0.0025
    ],
    [
      "rejoindre",
      0.0025
    ],
    [
      "reproduire",
      0.0025
    ],
    [
      "heurter",
      0.0025
    ],
    [
      "gripper",
      0.0025
    ],
    [
      "exprimer",
      0.0025
    ],
    [
      "agrafer",
      0.0025
    ],
    [
      "chapitrer",
      0.0025
    ],
    [
      "chauffer",
      0.0025
    ],
    [
      "decrocher",
      0.0025
    ],
    [
      "emberlificoter",
      0.0025
    ],
    [
      "empocher",
      0.0025
    ],
    [
      "escamoter",
      0.0025
    ],
    [
      "echauder",
      0.0
    ],
    [
      "sauter",
      0.0
    ],
    [
      "rattraper",
      0.0
    ],
    [
      "poisser",
      0.0
    ],
    [
      "paumer",
      0.0
    ],
    [
      "entendre",
      0.0
    ],
    [
      "enquinauder",
      0.0
    ],
    [
      "enguirlander",
      0.0
    ],
    [
      "devaliser",
      0.0
    ],
    [
      "contrefaire",
      0.0
    ],
    [
      "blamer",
      0.0
    ],
    [
      "ecoper",
      0.0
    ]
  ],
  "char": [
    [
      "blinde",
      0.2
    ],
    [
      "automobile",
      0.0975
    ],
    [
      "bige",
      0.0975
    ],
    [
      "cavalerie",
      0.0975
    ],
    [
      "chariot",
      0.0975
    ],
    [
      "charrette",
      0.0975
    ],
    [
      "quadrige",
      0.0975
    ],
    [
      "tank",
      0.0975
    ]
  ],
  "valoir": [
    [
      "procurer",
      0.125
    ],
    [
      "faire",
      0.1
    ],
    [
      "attirer",
      0.075
    ],
    [
      "couter",
      0.075
    ],
    [
      "equivaloir",
      0.05
    ],
    [
      "revenir",
      0.05
    ],
    [
      "rapporter",
      0.05
    ],
    [
      "peser",
      0.05
    ],
    [
      "meriter",
      0.05
    ],
    [
      "causer",
      0.05
    ],
    [
      "acquerir",
      0.05
    ],
    [
      "evaluer",
      0.0225
    ],
    [
      "egaler",
      0.0225
    ],
    [
      "interesser",
      0.0225
    ],
    [
      "gratifier",
      0.0225
    ],
    [
      "fructifier",
      0.0225
    ],
    [
      "concilier",
      0.0225
    ],
    [
      "assurer",
      0.0225
    ]
  ],
  "honneur": [
    [
      "distinction",
      0.0575
    ],
    [
      "gloire",
      0.0575
    ],
    [
      "estime",
      0.0475
    ],
    [
      "respect",
      0.0475
    ],
    [
      "consideration",
      0.0425
    ],
    [
      "honnetete",
      0.0425
    ],
    [
      "dignite",
      0.035
    ],
    [
      "faveur",
      0.03
    ],
    [
      "merite",
      0.03
    ],
    [
      "reverence",
      0.03
    ],
    [
      "vertu",
      0.03
    ],
    [
      "pudeur",
      0.025
    ],
    [
      "hommage",
      0.025
    ],
    [
      "grace",
      0.025
    ],
    [
      "grandeur",
      0.025
    ],
    [
      "culte",
      0.025
    ],
    [
      "egards",
      0.02
    ],
    [
      "veneration",
      0.02
    ],
    [
      "triomphe",
      0.02
    ],
    [
      "reputation",
      0.02
    ],
    [
      "ornement",
      0.02
    ],
    [
      "avantage",
      0.02
    ],
    [
      "eclat",
      0.015
    ],
    [
      "tenue",
      0.015
    ],
    [
      "succes",
      0.015
    ],
    [
      "purete",
      0.015
    ],
    [
      "illustration",
      0.015
    ],
    [
      "decence",
      0.015
    ],
    [
      "bien",
      0.015
    ],
    [
      "eloge",
      0.01
    ],
    [
      "egard",
      0.01
    ],
    [
      "renommee",
      0.01
    ],
    [
      "prerogative",
      0.01
    ],
    [
      "orgueil",
      0.01
    ],
    [
      "foi",
      0.01
    ],
    [
      "fierte",
      0.01
    ],
    [
      "couronne",
      0.01
    ],
    [
      "charge",
      0.01
    ],
    [
      "apotheose",
      0.01
    ],
    [
      "poste",
      0.005
    ],
    [
      "panache",
      0.005
    ],
    [
      "ovation",
      0.005
    ],
    [
      "intention",
      0.005
    ],
    [
      "honorabilite",
      0.005
    ],
    [
      "grade",
      0.005
    ],
    [
      "devotion",
      0.005
    ],
    [
      "ceremonie",
      0.005
    ],
    [
      "continence",
      0.005
    ],
    [
      "privilege",
      0.005
    ]
  ],
  "pomme": [
    [
      "tete",
      0.15
    ],
    [
      "boule",
      0.1
    ],
    [
      "figure",
      0.1
    ],
    [
      "poire",
      0.1
    ],
    [
      "pommeau",
      0.1
    ],
    [
      "visage",
      0.1
    ],
    [
      "pommette",
      0.05
    ],
    [
      "fruit",
      0.05
    ],
    [
      "frimousse",
      0.05
    ],
    [
      "chataigne",
      0.05
    ],
    [
      "cave",
      0.05
    ],
    [
      "cassis",
      0.05
    ],
    [
      "vert",
      0.05
    ]
  ],
  "pommer": [],
  "pourrir": [
    [
      "gater",
      0.11
    ],
    [
      "corrompre",
      0.0975
    ],
    [
      "alterer",
      0.0475
    ],
    [
      "detruire",
      0.035
    ],
    [
      "gangrener",
      0.035
    ],
    [
      "perdre",
      0.03
    ],
    [
      "moisir",
      0.03
    ],
    [
      "infecter",
      0.03
    ],
    [
      "degrader",
      0.03
    ],
    [
      "carier",
      0.03
    ],
    [
      "avarier",
      0.03
    ],
    [
      "s'alterer",
      0.0225
    ],
    [
      "pervertir",
      0.0225
    ],
    [
      "passer",
      0.0225
    ],
    [
      "vivre",
      0.0175
    ],
    [
      "ronger",
      0.0175
    ],
    [
      "fletrir",
      0.0175
    ],
    [
      "depraver",
      0.0175
    ],
    [
      "decomposer",
      0.0175
    ],
    [
      "croupir",
      0.0175
    ],
    [
      "abimer",
      0.0175
    ],
    [
      "tourner",
      0.01
    ],
    [
      "s'avarier",
      0.01
    ],
    [
      "s'abimer",
      0.01
    ],
    [
      "putrefier",
      0.01
    ],
    [
      "empester",
      0.01
    ],
    [
      "desagreger",
      0.01
    ],
    [
      "contaminer",
      0.01
    ],
    [
      "chancir",
      0.01
    ],
    [
      "rancir",
      0.005
    ],
    [
      "plomber",
      0.005
    ],
    [
      "meurtrir",
      0.005
    ],
    [
      "demeurer",
      0.005
    ]
  ],
  "pourri": [
    [
      "gate",
      0.17
    ],
    [
      "corrompu",
      0.1
    ],
    [
      "decompose",
      0.055
    ],
    [
      "putride",
      0.055
    ],
    [
      "malade",
      0.0425
    ],
    [
      "faisande",
      0.0425
    ],
    [
      "avarie",
      0.0425
    ],
    [
      "infect",
      0.0325
    ],
    [
      "malsain",
      0.0325
    ],
    [
      "tare",
      0.02
    ],
    [
      "rempli",
      0.02
    ],
    [
      "plein",
      0.02
    ],
    [
      "pique",
      0.02
    ],
    [
      "perdu",
      0.02
    ],
    [
      "morbide",
      0.02
    ],
    [
      "frelate",
      0.02
    ],
    [
      "gave",
      0.01
    ],
    [
      "moisi",
      0.01
    ],
    [
      "mouille",
      0.01
    ],
    [
      "nase",
      0.01
    ],
    [
      "perverti",
      0.01
    ],
    [
      "pourriture",
      0.01
    ],
    [
      "putrefie",
      0.01
    ],
    [
      "rance",
      0.01
    ],
    [
      "vil",
      0.01
    ],
    [
      "vereux",
      0.01
    ],
    [
      "verole",
      0.01
    ],
    [
      "gangrene",
      0.01
    ],
    [
      "devalue",
      0.01
    ],
    [
      "devalorise",
      0.01
    ],
    [
      "altere",
      0.01
    ],
    [
      "bourre",
      0.01
    ],
    [
      "choye",
      0.01
    ],
    [
      "compromis",
      0.01
    ],
    [
      "contamine",
      0.01
    ],
    [
      "croupi",
      0.01
    ],
    [
      "debordant",
      0.01
    ],
    [
      "degrade",
      0.01
    ],
    [
      "degueulasse",
      0.01
    ],
    [
      "deteriore",
      0.01
    ],
    [
      "abime",
      0.01
    ]
  ],
  "ecarter": [
    [
      "chasser",
      0.075
    ],
    [
      "exclure",
      0.065
    ],
    [
      "eloigner",
      0.065
    ],
    [
      "renvoyer",
      0.0375
    ],
    [
      "separer",
      0.0375
    ],
    [
      "eliminer",
      0.0375
    ],
    [
      "supprimer",
      0.035
    ],
    [
      "repousser",
      0.035
    ],
    [
      "bannir",
      0.035
    ],
    [
      "rejeter",
      0.0325
    ],
    [
      "oter",
      0.0325
    ],
    [
      "balayer",
      0.02
    ],
    [
      "detourner",
      0.02
    ],
    [
      "eviter",
      0.0175
    ],
    [
      "refuser",
      0.0175
    ],
    [
      "proscrire",
      0.0175
    ],
    [
      "detacher",
      0.0175
    ],
    [
      "diviser",
      0.0175
    ],
    [
      "congedier",
      0.0175
    ],
    [
      "arracher",
      0.0175
    ],
    [
      "disjoindre",
      0.0125
    ],
    [
      "dissiper",
      0.0125
    ],
    [
      "exiler",
      0.0125
    ],
    [
      "remercier",
      0.01
    ],
    [
      "passer",
      0.01
    ],
    [
      "negliger",
      0.01
    ],
    [
      "isoler",
      0.01
    ],
    [
      "empecher",
      0.01
    ],
    [
      "desunir",
      0.01
    ],
    [
      "evincer",
      0.0075
    ],
    [
      "refouler",
      0.0075
    ],
    [
      "partir",
      0.0075
    ],
    [
      "ouvrir",
      0.0075
    ],
    [
      "excepter",
      0.0075
    ],
    [
      "escamoter",
      0.0075
    ],
    [
      "devier",
      0.0075
    ],
    [
      "changer",
      0.0075
    ],
    [
      "disperser",
      0.0075
    ],
    [
      "distancer",
      0.0075
    ],
    [
      "decliner",
      0.0075
    ],
    [
      "derouter",
      0.0075
    ],
    [
      "egarer",
      0.005
    ],
    [
      "soulever",
      0.005
    ],
    [
      "retourner",
      0.005
    ],
    [
      "releguer",
      0.005
    ],
    [
      "relever",
      0.005
    ],
    [
      "partager",
      0.005
    ],
    [
      "lever",
      0.005
    ],
    [
      "fendre",
      0.005
    ],
    [
      "espacer",
      0.005
    ],
    [
      "retrousser",
      0.0025
    ],
    [
      "s'aliener",
      0.0025
    ],
    [
      "trousser",
      0.0025
    ],
    [
      "devoyer",
      0.0025
    ],
    [
      "desassembler",
      0.0025
    ],
    [
      "debarquer",
      0.0025
    ],
    [
      "dissuader",
      0.0025
    ],
    [
      "desserrer",
      0.0025
    ],
    [
      "ecarquiller",
      0.0025
    ]
  ],
  "panier": [
    [
      "bannette",
      0.075
    ],
    [
      "manne",
      0.075
    ],
    [
      "corbeille",
      0.0575
    ],
    [
      "mannette",
      0.0375
    ],
    [
      "mannequin",
      0.0375
    ],
    [
      "hotte",
      0.0375
    ],
    [
      "crinoline",
      0.0375
    ],
    [
      "couffin",
      0.0375
    ],
    [
      "cabas",
      0.0375
    ],
    [
      "banneton",
      0.0375
    ],
    [
      "banne",
      0.0375
    ],
    [
      "fesse",
      0.0175
    ],
    [
      "fessier",
      0.0175
    ],
    [
      "flein",
      0.0175
    ],
    [
      "gabion",
      0.0175
    ],
    [
      "jupon",
      0.0175
    ],
    [
      "paneree",
      0.0175
    ],
    [
      "paneton",
      0.0175
    ],
    [
      "paniere",
      0.0175
    ],
    [
      "repas",
      0.0175
    ],
    [
      "vendangeoir",
      0.0175
    ],
    [
      "vendangerot",
      0.0175
    ],
    [
      "derriere",
      0.0175
    ],
    [
      "cul",
      0.0175
    ],
    [
      "couffe",
      0.0175
    ],
    [
      "banneau",
      0.0175
    ],
    [
      "barquette",
      0.0175
    ],
    [
      "benne",
      0.0175
    ],
    [
      "berceau",
      0.0175
    ],
    [
      "bouffante",
      0.0175
    ],
    [
      "bourriche",
      0.0175
    ],
    [
      "but",
      0.0175
    ],
    [
      "ciste",
      0.0175
    ],
    [
      "cloyere",
      0.0175
    ],
    [
      "contenant",
      0.0175
    ],
    [
      "corbillon",
      0.0175
    ],
    [
      "vertugadin",
      0.0175
    ]
  ],
  "salaire": [
    [
      "retribution",
      0.13
    ],
    [
      "traitement",
      0.0975
    ],
    [
      "remuneration",
      0.085
    ],
    [
      "recompense",
      0.0675
    ],
    [
      "gain",
      0.06
    ],
    [
      "paiement",
      0.06
    ],
    [
      "appointements",
      0.0475
    ],
    [
      "paye",
      0.0475
    ],
    [
      "commission",
      0.035
    ],
    [
      "prime",
      0.03
    ],
    [
      "emoluments",
      0.03
    ],
    [
      "honoraires",
      0.0225
    ],
    [
      "pourboire",
      0.0225
    ],
    [
      "prix",
      0.0225
    ],
    [
      "revenu",
      0.0225
    ],
    [
      "solde",
      0.0225
    ],
    [
      "paie",
      0.0175
    ],
    [
      "loyer",
      0.0175
    ],
    [
      "indemnite",
      0.0175
    ],
    [
      "ressource",
      0.01
    ],
    [
      "profit",
      0.01
    ],
    [
      "mensualite",
      0.01
    ],
    [
      "gages",
      0.01
    ],
    [
      "fixe",
      0.01
    ],
    [
      "cachet",
      0.01
    ],
    [
      "tribut",
      0.005
    ],
    [
      "guelte",
      0.005
    ],
    [
      "droit",
      0.005
    ],
    [
      "chatiment",
      0.005
    ],
    [
      "budget",
      0.005
    ],
    [
      "vacations",
      0.005
    ]
  ],
  "couronner": [
    [
      "achever",
      0.0975
    ],
    [
      "finir",
      0.08
    ],
    [
      "parachever",
      0.08
    ],
    [
      "consommer",
      0.065
    ],
    [
      "terminer",
      0.0475
    ],
    [
      "surmonter",
      0.0475
    ],
    [
      "couvrir",
      0.0475
    ],
    [
      "accomplir",
      0.0475
    ],
    [
      "realiser",
      0.0325
    ],
    [
      "remplir",
      0.0325
    ],
    [
      "parfaire",
      0.0325
    ],
    [
      "entourer",
      0.0325
    ],
    [
      "dominer",
      0.0325
    ],
    [
      "conclure",
      0.0325
    ],
    [
      "completer",
      0.0325
    ],
    [
      "coiffer",
      0.0325
    ],
    [
      "ceindre",
      0.0325
    ],
    [
      "aureoler",
      0.0325
    ],
    [
      "sommer",
      0.015
    ],
    [
      "sacrer",
      0.015
    ],
    [
      "recompenser",
      0.015
    ],
    [
      "nimber",
      0.015
    ],
    [
      "introniser",
      0.015
    ],
    [
      "honorer",
      0.015
    ],
    [
      "environner",
      0.015
    ],
    [
      "blesser",
      0.015
    ],
    [
      "surplomber",
      0.015
    ]
  ],
  "couronne": [
    [
      "achever",
      0.0975
    ],
    [
      "finir",
      0.08
    ],
    [
      "parachever",
      0.08
    ],
    [
      "consommer",
      0.065
    ],
    [
      "terminer",
      0.0475
    ],
    [
      "surmonter",
      0.0475
    ],
    [
      "couvrir",
      0.0475
    ],
    [
      "accomplir",
      0.0475
    ],
    [
      "realiser",
      0.0325
    ],
    [
      "remplir",
      0.0325
    ],
    [
      "parfaire",
      0.0325
    ],
    [
      "entourer",
      0.0325
    ],
    [
      "dominer",
      0.0325
    ],
    [
      "conclure",
      0.0325
    ],
    [
      "completer",
      0.0325
    ],
    [
      "coiffer",
      0.0325
    ],
    [
      "ceindre",
      0.0325
    ],
    [
      "aureoler",
      0.0325
    ],
    [
      "sommer",
      0.015
    ],
    [
      "sacrer",
      0.015
    ],
    [
      "recompenser",
      0.015
    ],
    [
      "nimber",
      0.015
    ],
    [
      "introniser",
      0.015
    ],
    [
      "honorer",
      0.015
    ],
    [
      "environner",
      0.015
    ],
    [
      "blesser",
      0.015
    ],
    [
      "surplomber",
      0.015
    ]
  ],
  "misere": [
    [
      "pauvrete",
      0.1
    ],
    [
      "detresse",
      0.035
    ],
    [
      "gene",
      0.035
    ],
    [
      "indigence",
      0.035
    ],
    [
      "malheur",
      0.035
    ],
    [
      "tribulation",
      0.03
    ],
    [
      "rien",
      0.03
    ],
    [
      "penurie",
      0.03
    ],
    [
      "puree",
      0.03
    ],
    [
      "poisse",
      0.03
    ],
    [
      "deche",
      0.03
    ],
    [
      "besoin",
      0.03
    ],
    [
      "bagatelle",
      0.0275
    ],
    [
      "denuement",
      0.0275
    ],
    [
      "peine",
      0.0225
    ],
    [
      "mouise",
      0.0225
    ],
    [
      "ennui",
      0.0225
    ],
    [
      "bassesse",
      0.0225
    ],
    [
      "faiblesse",
      0.0175
    ],
    [
      "adversite",
      0.0175
    ],
    [
      "vetille",
      0.0125
    ],
    [
      "futilite",
      0.0125
    ],
    [
      "debine",
      0.0125
    ],
    [
      "douleur",
      0.0125
    ],
    [
      "disgrace",
      0.0125
    ],
    [
      "crotte",
      0.0125
    ],
    [
      "crasse",
      0.0125
    ],
    [
      "chagrin",
      0.0125
    ],
    [
      "calamite",
      0.0125
    ],
    [
      "broutille",
      0.0125
    ],
    [
      "mechancete",
      0.0075
    ],
    [
      "niaiserie",
      0.0075
    ],
    [
      "neant",
      0.0075
    ],
    [
      "pouillerie",
      0.0075
    ],
    [
      "privation",
      0.0075
    ],
    [
      "epreuve",
      0.0075
    ],
    [
      "mouscaille",
      0.0075
    ],
    [
      "mistoufle",
      0.0075
    ],
    [
      "laideur",
      0.0075
    ],
    [
      "babiole",
      0.0075
    ],
    [
      "boue",
      0.0075
    ],
    [
      "bricole",
      0.0075
    ],
    [
      "crise",
      0.0075
    ],
    [
      "disette",
      0.0075
    ],
    [
      "decheance",
      0.0075
    ],
    [
      "panade",
      0.0025
    ],
    [
      "panne",
      0.0025
    ],
    [
      "pastis",
      0.0025
    ],
    [
      "pauperisme",
      0.0025
    ],
    [
      "pitie",
      0.0025
    ],
    [
      "pouille",
      0.0025
    ],
    [
      "poussiere",
      0.0025
    ],
    [
      "melasse",
      0.0025
    ],
    [
      "misericorde",
      0.0025
    ],
    [
      "foutaise",
      0.0025
    ],
    [
      "fetu",
      0.0025
    ],
    [
      "gueuserie",
      0.0025
    ],
    [
      "impuissance",
      0.0025
    ],
    [
      "impecuniosite",
      0.0025
    ],
    [
      "incommodite",
      0.0025
    ],
    [
      "infortune",
      0.0025
    ],
    [
      "malice",
      0.0025
    ],
    [
      "proletariat",
      0.0025
    ]
  ],
  "redonner": [
    [
      "remettre",
      0.2325
    ],
    [
      "retroceder",
      0.1325
    ],
    [
      "rendre",
      0.1
    ],
    [
      "restituer",
      0.1
    ],
    [
      "retablir",
      0.1
    ],
    [
      "ramener",
      0.065
    ],
    [
      "repasser",
      0.0325
    ],
    [
      "rembourser",
      0.0325
    ],
    [
      "relever",
      0.0325
    ],
    [
      "redoubler",
      0.0325
    ],
    [
      "degorger",
      0.0325
    ],
    [
      "donner",
      0.0325
    ],
    [
      "retomber",
      0.0325
    ]
  ],
  "oxygener": [
    [
      "oxyder",
      1.0
    ]
  ],
  "oxygene": [
    [
      "air",
      1.0
    ]
  ],
  "relever": [
    [
      "rehausser",
      0.0525
    ],
    [
      "remonter",
      0.0475
    ],
    [
      "hausser",
      0.045
    ],
    [
      "elever",
      0.0425
    ],
    [
      "monter",
      0.035
    ],
    [
      "augmenter",
      0.0325
    ],
    [
      "exalter",
      0.0325
    ],
    [
      "retablir",
      0.0275
    ],
    [
      "redresser",
      0.0275
    ],
    [
      "ranimer",
      0.025
    ],
    [
      "noter",
      0.0225
    ],
    [
      "revigorer",
      0.0225
    ],
    [
      "soulever",
      0.0225
    ],
    [
      "revivifier",
      0.02
    ],
    [
      "exciter",
      0.0175
    ],
    [
      "lever",
      0.015
    ],
    [
      "marquer",
      0.015
    ],
    [
      "corriger",
      0.0125
    ],
    [
      "remettre",
      0.0125
    ],
    [
      "reconforter",
      0.0125
    ],
    [
      "reparer",
      0.0125
    ],
    [
      "reprendre",
      0.0125
    ],
    [
      "porter",
      0.0125
    ],
    [
      "inscrire",
      0.0125
    ],
    [
      "assaisonner",
      0.0125
    ],
    [
      "trousser",
      0.01
    ],
    [
      "transcrire",
      0.01
    ],
    [
      "revaloriser",
      0.01
    ],
    [
      "restaurer",
      0.01
    ],
    [
      "ressusciter",
      0.01
    ],
    [
      "guerir",
      0.01
    ],
    [
      "dresser",
      0.01
    ],
    [
      "surelever",
      0.0075
    ],
    [
      "retremper",
      0.0075
    ],
    [
      "rencherir",
      0.0075
    ],
    [
      "recueillir",
      0.0075
    ],
    [
      "orner",
      0.0075
    ],
    [
      "mentionner",
      0.0075
    ],
    [
      "grandir",
      0.0075
    ],
    [
      "exhausser",
      0.0075
    ],
    [
      "enregistrer",
      0.0075
    ],
    [
      "ennoblir",
      0.0075
    ],
    [
      "consigner",
      0.0075
    ],
    [
      "retrousser",
      0.005
    ],
    [
      "regenerer",
      0.005
    ],
    [
      "reprimander",
      0.005
    ],
    [
      "reedifier",
      0.005
    ],
    [
      "souligner",
      0.005
    ],
    [
      "remplacer",
      0.005
    ],
    [
      "remarquer",
      0.005
    ],
    [
      "constater",
      0.005
    ],
    [
      "decouvrir",
      0.005
    ],
    [
      "degager",
      0.005
    ],
    [
      "detacher",
      0.005
    ],
    [
      "extraire",
      0.005
    ],
    [
      "observer",
      0.005
    ],
    [
      "recopier",
      0.0025
    ],
    [
      "rencontrer",
      0.0025
    ],
    [
      "revenir",
      0.0025
    ],
    [
      "rehabiliter",
      0.0025
    ],
    [
      "sermonner",
      0.0025
    ],
    [
      "tancer",
      0.0025
    ],
    [
      "trouver",
      0.0025
    ],
    [
      "ecarter",
      0.0025
    ],
    [
      "reconstruire",
      0.0025
    ],
    [
      "pimenter",
      0.0025
    ],
    [
      "majorer",
      0.0025
    ],
    [
      "agrementer",
      0.0025
    ],
    [
      "appreter",
      0.0025
    ],
    [
      "colorer",
      0.0025
    ],
    [
      "conforter",
      0.0025
    ],
    [
      "consoler",
      0.0025
    ],
    [
      "copier",
      0.0025
    ],
    [
      "delier",
      0.0025
    ],
    [
      "illustrer",
      0.0025
    ],
    [
      "recoquiller",
      0.0
    ],
    [
      "redonner",
      0.0
    ],
    [
      "regonfler",
      0.0
    ],
    [
      "relayer",
      0.0
    ],
    [
      "reformer",
      0.0
    ],
    [
      "subroger",
      0.0
    ],
    [
      "succeder",
      0.0
    ],
    [
      "teindre",
      0.0
    ],
    [
      "rebatir",
      0.0
    ],
    [
      "rattraper",
      0.0
    ],
    [
      "ramasser",
      0.0
    ],
    [
      "attiser",
      0.0
    ],
    [
      "blamer",
      0.0
    ],
    [
      "estamper",
      0.0
    ],
    [
      "liberer",
      0.0
    ],
    [
      "lister",
      0.0
    ],
    [
      "louer",
      0.0
    ],
    [
      "ponctuer",
      0.0
    ],
    [
      "epicer",
      0.0
    ]
  ],
  "releve": [
    [
      "rehausser",
      0.0525
    ],
    [
      "remonter",
      0.0475
    ],
    [
      "hausser",
      0.045
    ],
    [
      "elever",
      0.0425
    ],
    [
      "monter",
      0.035
    ],
    [
      "augmenter",
      0.0325
    ],
    [
      "exalter",
      0.0325
    ],
    [
      "retablir",
      0.0275
    ],
    [
      "redresser",
      0.0275
    ],
    [
      "ranimer",
      0.025
    ],
    [
      "noter",
      0.0225
    ],
    [
      "revigorer",
      0.0225
    ],
    [
      "soulever",
      0.0225
    ],
    [
      "revivifier",
      0.02
    ],
    [
      "exciter",
      0.0175
    ],
    [
      "lever",
      0.015
    ],
    [
      "marquer",
      0.015
    ],
    [
      "corriger",
      0.0125
    ],
    [
      "remettre",
      0.0125
    ],
    [
      "reconforter",
      0.0125
    ],
    [
      "reparer",
      0.0125
    ],
    [
      "reprendre",
      0.0125
    ],
    [
      "porter",
      0.0125
    ],
    [
      "inscrire",
      0.0125
    ],
    [
      "assaisonner",
      0.0125
    ],
    [
      "trousser",
      0.01
    ],
    [
      "transcrire",
      0.01
    ],
    [
      "revaloriser",
      0.01
    ],
    [
      "restaurer",
      0.01
    ],
    [
      "ressusciter",
      0.01
    ],
    [
      "guerir",
      0.01
    ],
    [
      "dresser",
      0.01
    ],
    [
      "surelever",
      0.0075
    ],
    [
      "retremper",
      0.0075
    ],
    [
      "rencherir",
      0.0075
    ],
    [
      "recueillir",
      0.0075
    ],
    [
      "orner",
      0.0075
    ],
    [
      "mentionner",
      0.0075
    ],
    [
      "grandir",
      0.0075
    ],
    [
      "exhausser",
      0.0075
    ],
    [
      "enregistrer",
      0.0075
    ],
    [
      "ennoblir",
      0.0075
    ],
    [
      "consigner",
      0.0075
    ],
    [
      "retrousser",
      0.005
    ],
    [
      "regenerer",
      0.005
    ],
    [
      "reprimander",
      0.005
    ],
    [
      "reedifier",
      0.005
    ],
    [
      "souligner",
      0.005
    ],
    [
      "remplacer",
      0.005
    ],
    [
      "remarquer",
      0.005
    ],
    [
      "constater",
      0.005
    ],
    [
      "decouvrir",
      0.005
    ],
    [
      "degager",
      0.005
    ],
    [
      "detacher",
      0.005
    ],
    [
      "extraire",
      0.005
    ],
    [
      "observer",
      0.005
    ],
    [
      "recopier",
      0.0025
    ],
    [
      "rencontrer",
      0.0025
    ],
    [
      "revenir",
      0.0025
    ],
    [
      "rehabiliter",
      0.0025
    ],
    [
      "sermonner",
      0.0025
    ],
    [
      "tancer",
      0.0025
    ],
    [
      "trouver",
      0.0025
    ],
    [
      "ecarter",
      0.0025
    ],
    [
      "reconstruire",
      0.0025
    ],
    [
      "pimenter",
      0.0025
    ],
    [
      "majorer",
      0.0025
    ],
    [
      "agrementer",
      0.0025
    ],
    [
      "appreter",
      0.0025
    ],
    [
      "colorer",
      0.0025
    ],
    [
      "conforter",
      0.0025
    ],
    [
      "consoler",
      0.0025
    ],
    [
      "copier",
      0.0025
    ],
    [
      "delier",
      0.0025
    ],
    [
      "illustrer",
      0.0025
    ],
    [
      "recoquiller",
      0.0
    ],
    [
      "redonner",
      0.0
    ],
    [
      "regonfler",
      0.0
    ],
    [
      "relayer",
      0.0
    ],
    [
      "reformer",
      0.0
    ],
    [
      "subroger",
      0.0
    ],
    [
      "succeder",
      0.0
    ],
    [
      "teindre",
      0.0
    ],
    [
      "rebatir",
      0.0
    ],
    [
      "rattraper",
      0.0
    ],
    [
      "ramasser",
      0.0
    ],
    [
      "attiser",
      0.0
    ],
    [
      "blamer",
      0.0
    ],
    [
      "estamper",
      0.0
    ],
    [
      "liberer",
      0.0
    ],
    [
      "lister",
      0.0
    ],
    [
      "louer",
      0.0
    ],
    [
      "ponctuer",
      0.0
    ],
    [
      "epicer",
      0.0
    ]
  ],
  "echelle": [
    [
      "escalader",
      0.5
    ],
    [
      "grimper",
      0.5
    ]
  ],
  "empiler": [
    [
      "tromper",
      0.1025
    ],
    [
      "entasser",
      0.0875
    ],
    [
      "rouler",
      0.0725
    ],
    [
      "accumuler",
      0.0575
    ],
    [
      "escroquer",
      0.0575
    ],
    [
      "voler",
      0.0425
    ],
    [
      "exploiter",
      0.0425
    ],
    [
      "estamper",
      0.0425
    ],
    [
      "duper",
      0.0425
    ],
    [
      "bourrer",
      0.0425
    ],
    [
      "amonceler",
      0.0425
    ],
    [
      "amasser",
      0.0425
    ],
    [
      "etrangler",
      0.0275
    ],
    [
      "tasser",
      0.0275
    ],
    [
      "refaire",
      0.0275
    ],
    [
      "presser",
      0.0275
    ],
    [
      "posseder",
      0.0275
    ],
    [
      "charger",
      0.0275
    ],
    [
      "avoir",
      0.0275
    ],
    [
      "thesauriser",
      0.0125
    ],
    [
      "superposer",
      0.0125
    ],
    [
      "mettre",
      0.0125
    ],
    [
      "encaquer",
      0.0125
    ],
    [
      "bloquer",
      0.0125
    ],
    [
      "agglomerer",
      0.0125
    ],
    [
      "echafauder",
      0.0125
    ]
  ],
  "pecher": [
    [
      "braconner",
      0.25
    ],
    [
      "imaginer",
      0.25
    ],
    [
      "repecher",
      0.25
    ],
    [
      "trouver",
      0.25
    ]
  ],
  "peche": [
    [
      "chasse",
      0.09
    ],
    [
      "poisson",
      0.09
    ],
    [
      "patate",
      0.09
    ],
    [
      "halieutique",
      0.09
    ],
    [
      "gueule",
      0.09
    ],
    [
      "frite",
      0.09
    ],
    [
      "excrement",
      0.09
    ],
    [
      "decouverte",
      0.09
    ],
    [
      "cueillette",
      0.09
    ],
    [
      "chataigne",
      0.09
    ],
    [
      "recolte",
      0.09
    ]
  ],
  "escalade": [
    [
      "alpinisme",
      0.1525
    ],
    [
      "ascension",
      0.1525
    ],
    [
      "montee",
      0.1525
    ],
    [
      "surenchere",
      0.075
    ],
    [
      "grimpette",
      0.075
    ],
    [
      "grimpement",
      0.075
    ],
    [
      "engrenage",
      0.075
    ],
    [
      "assaut",
      0.075
    ],
    [
      "aggravation",
      0.075
    ],
    [
      "varappe",
      0.075
    ]
  ],
  "escalader": [
    [
      "grimper",
      0.2225
    ],
    [
      "monter",
      0.1675
    ],
    [
      "franchir",
      0.11
    ],
    [
      "gravir",
      0.11
    ],
    [
      "varapper",
      0.055
    ],
    [
      "ramoner",
      0.055
    ],
    [
      "passer",
      0.055
    ],
    [
      "enjamber",
      0.055
    ],
    [
      "ascensionner",
      0.055
    ],
    [
      "echeler",
      0.055
    ]
  ],
  "plutot": [
    [
      "assez",
      0.25
    ],
    [
      "preferablement",
      0.25
    ]
  ],
  "batard": [
    [
      "matine",
      0.135
    ],
    [
      "melange",
      0.135
    ],
    [
      "hybride",
      0.1075
    ],
    [
      "composite",
      0.08
    ],
    [
      "croise",
      0.08
    ],
    [
      "mixte",
      0.08
    ],
    [
      "mele",
      0.0525
    ],
    [
      "metis",
      0.0525
    ],
    [
      "naturel",
      0.025
    ],
    [
      "metisse",
      0.025
    ],
    [
      "illegitime",
      0.025
    ],
    [
      "degenere",
      0.025
    ],
    [
      "corniaud",
      0.025
    ],
    [
      "complexe",
      0.025
    ],
    [
      "champi",
      0.025
    ],
    [
      "adulterin",
      0.025
    ]
  ],
  "apprendre": [
    [
      "instruire",
      0.06
    ],
    [
      "reveler",
      0.0525
    ],
    [
      "annoncer",
      0.0475
    ],
    [
      "indiquer",
      0.0475
    ],
    [
      "signaler",
      0.045
    ],
    [
      "enseigner",
      0.04
    ],
    [
      "montrer",
      0.04
    ],
    [
      "expliquer",
      0.0325
    ],
    [
      "dire",
      0.03
    ],
    [
      "avertir",
      0.02
    ],
    [
      "communiquer",
      0.02
    ],
    [
      "informer",
      0.02
    ],
    [
      "eclairer",
      0.02
    ],
    [
      "declarer",
      0.0175
    ],
    [
      "etudier",
      0.0125
    ],
    [
      "eduquer",
      0.0125
    ],
    [
      "styler",
      0.0125
    ],
    [
      "absorber",
      0.0125
    ],
    [
      "comprendre",
      0.01
    ],
    [
      "decouvrir",
      0.01
    ],
    [
      "initier",
      0.01
    ],
    [
      "renseigner",
      0.01
    ],
    [
      "repeter",
      0.01
    ],
    [
      "travailler",
      0.0075
    ],
    [
      "s'instruire",
      0.0075
    ],
    [
      "s'appliquer",
      0.0075
    ],
    [
      "exercer",
      0.0075
    ],
    [
      "repasser",
      0.005
    ],
    [
      "s'exercer",
      0.005
    ],
    [
      "s'impregner",
      0.005
    ],
    [
      "s'intoxiquer",
      0.005
    ],
    [
      "savoir",
      0.005
    ],
    [
      "professer",
      0.005
    ],
    [
      "guider",
      0.005
    ],
    [
      "assimiler",
      0.005
    ],
    [
      "avaler",
      0.005
    ],
    [
      "connaitre",
      0.005
    ],
    [
      "cultiver",
      0.005
    ],
    [
      "degrossir",
      0.005
    ],
    [
      "deniaiser",
      0.005
    ],
    [
      "ruminer",
      0.0025
    ],
    [
      "s'abreuver",
      0.0025
    ],
    [
      "s'abrutir",
      0.0025
    ],
    [
      "s'habituer",
      0.0025
    ],
    [
      "s'initier",
      0.0025
    ],
    [
      "remacher",
      0.0025
    ],
    [
      "aviser",
      0.0025
    ],
    [
      "bourrer",
      0.0025
    ],
    [
      "digerer",
      0.0025
    ],
    [
      "dresser",
      0.0025
    ],
    [
      "debrouiller",
      0.0025
    ],
    [
      "degourdir",
      0.0025
    ],
    [
      "demontrer",
      0.0025
    ],
    [
      "ingurgiter",
      0.0025
    ],
    [
      "inculquer",
      0.0025
    ],
    [
      "habituer",
      0.0025
    ],
    [
      "enfoncer",
      0.0025
    ],
    [
      "endoctriner",
      0.0025
    ],
    [
      "s'assommer",
      0.0
    ],
    [
      "s'enfoncer",
      0.0
    ],
    [
      "souffler",
      0.0
    ],
    [
      "suivre",
      0.0
    ],
    [
      "s'acharner",
      0.0
    ],
    [
      "s'accoutumer",
      0.0
    ],
    [
      "abreuver",
      0.0
    ],
    [
      "apporter",
      0.0
    ],
    [
      "approfondir",
      0.0
    ],
    [
      "bachoter",
      0.0
    ],
    [
      "dessaler",
      0.0
    ],
    [
      "macher",
      0.0
    ],
    [
      "profiter",
      0.0
    ],
    [
      "rabacher",
      0.0
    ],
    [
      "retenir",
      0.0
    ],
    [
      "reviser",
      0.0
    ],
    [
      "transmettre",
      0.0
    ]
  ],
  "lecon": [
    [
      "enseignement",
      0.105
    ],
    [
      "instruction",
      0.075
    ],
    [
      "conseil",
      0.065
    ],
    [
      "avis",
      0.0575
    ],
    [
      "recommandation",
      0.0575
    ],
    [
      "exhortation",
      0.0475
    ],
    [
      "reprimande",
      0.0375
    ],
    [
      "precepte",
      0.0375
    ],
    [
      "morale",
      0.0375
    ],
    [
      "conference",
      0.0375
    ],
    [
      "avertissement",
      0.0375
    ],
    [
      "admonestation",
      0.0375
    ],
    [
      "moralite",
      0.0275
    ],
    [
      "exemple",
      0.0275
    ],
    [
      "discours",
      0.0275
    ],
    [
      "cours",
      0.0275
    ],
    [
      "admonition",
      0.0275
    ],
    [
      "ecole",
      0.0175
    ],
    [
      "variante",
      0.0175
    ],
    [
      "expose",
      0.0175
    ],
    [
      "doctrine",
      0.0175
    ],
    [
      "correction",
      0.0175
    ],
    [
      "conclusion",
      0.0175
    ],
    [
      "texte",
      0.0075
    ],
    [
      "repetition",
      0.0075
    ],
    [
      "punition",
      0.0075
    ],
    [
      "piquette",
      0.0075
    ],
    [
      "lecture",
      0.0075
    ],
    [
      "exemplaire",
      0.0075
    ],
    [
      "demonstration",
      0.0075
    ],
    [
      "classe",
      0.0075
    ],
    [
      "anagogie",
      0.0075
    ],
    [
      "version",
      0.0075
    ]
  ],
  "tuile": [
    [
      "accident",
      0.13
    ],
    [
      "malchance",
      0.13
    ],
    [
      "mesaventure",
      0.13
    ],
    [
      "ennui",
      0.1075
    ],
    [
      "infortune",
      0.085
    ],
    [
      "malheur",
      0.085
    ],
    [
      "pepin",
      0.085
    ],
    [
      "malediction",
      0.0425
    ],
    [
      "avatar",
      0.0425
    ],
    [
      "avaro",
      0.0425
    ],
    [
      "biscuit",
      0.02
    ],
    [
      "emmerdement",
      0.02
    ],
    [
      "noue",
      0.02
    ],
    [
      "pureau",
      0.02
    ],
    [
      "tuileau",
      0.02
    ]
  ],
  "croisee": [
    [
      "couper",
      0.12
    ],
    [
      "melanger",
      0.0875
    ],
    [
      "meler",
      0.0875
    ],
    [
      "voir",
      0.0575
    ],
    [
      "rencontrer",
      0.0575
    ],
    [
      "passer",
      0.0575
    ],
    [
      "entrelacer",
      0.0575
    ],
    [
      "s'entrecouper",
      0.0275
    ],
    [
      "parader",
      0.0275
    ],
    [
      "naviguer",
      0.0275
    ],
    [
      "metisser",
      0.0275
    ],
    [
      "matiner",
      0.0275
    ],
    [
      "hybrider",
      0.0275
    ],
    [
      "entrecroiser",
      0.0275
    ],
    [
      "enlacer",
      0.0275
    ],
    [
      "effacer",
      0.0275
    ],
    [
      "coudoyer",
      0.0275
    ],
    [
      "contrepasser",
      0.0275
    ],
    [
      "traverser",
      0.0275
    ]
  ],
  "croise": [
    [
      "couper",
      0.12
    ],
    [
      "melanger",
      0.0875
    ],
    [
      "meler",
      0.0875
    ],
    [
      "voir",
      0.0575
    ],
    [
      "rencontrer",
      0.0575
    ],
    [
      "passer",
      0.0575
    ],
    [
      "entrelacer",
      0.0575
    ],
    [
      "s'entrecouper",
      0.0275
    ],
    [
      "parader",
      0.0275
    ],
    [
      "naviguer",
      0.0275
    ],
    [
      "metisser",
      0.0275
    ],
    [
      "matiner",
      0.0275
    ],
    [
      "hybrider",
      0.0275
    ],
    [
      "entrecroiser",
      0.0275
    ],
    [
      "enlacer",
      0.0275
    ],
    [
      "effacer",
      0.0275
    ],
    [
      "coudoyer",
      0.0275
    ],
    [
      "contrepasser",
      0.0275
    ],
    [
      "traverser",
      0.0275
    ]
  ],
  "hortensia": [],
  "palmier": [
    [
      "cocotier",
      0.5
    ],
    [
      "dattier",
      0.5
    ]
  ],
  "cieux": [
    [
      "ciel",
      0.3325
    ],
    [
      "firmament",
      0.3325
    ],
    [
      "nue",
      0.3325
    ]
  ],
  "crepitant": [
    [
      "gresillant",
      1.0
    ]
  ],
  "pres": [
    [
      "proche",
      0.1275
    ],
    [
      "aupres",
      0.1
    ],
    [
      "touchant",
      0.05
    ],
    [
      "sur",
      0.05
    ],
    [
      "contre",
      0.05
    ],
    [
      "autour",
      0.05
    ],
    [
      "presque",
      0.0225
    ],
    [
      "voisin",
      0.0225
    ],
    [
      "lez",
      0.0225
    ],
    [
      "jouxte",
      0.0225
    ],
    [
      "joignant",
      0.0225
    ],
    [
      "imminent",
      0.0225
    ],
    [
      "avoisinant",
      0.0225
    ]
  ],
  "angora": [],
  "accompli": [
    [
      "parfait",
      0.15
    ],
    [
      "beau",
      0.0925
    ],
    [
      "acheve",
      0.08
    ],
    [
      "consomme",
      0.08
    ],
    [
      "excellent",
      0.045
    ],
    [
      "incomparable",
      0.045
    ],
    [
      "revolu",
      0.0325
    ],
    [
      "irreprochable",
      0.0325
    ],
    [
      "ideal",
      0.0325
    ],
    [
      "fini",
      0.0325
    ],
    [
      "fieffe",
      0.0325
    ],
    [
      "distingue",
      0.0325
    ],
    [
      "complet",
      0.0325
    ],
    [
      "eminent",
      0.0225
    ],
    [
      "termine",
      0.0225
    ],
    [
      "mur",
      0.0225
    ],
    [
      "modele",
      0.0225
    ],
    [
      "impeccable",
      0.0225
    ],
    [
      "honnete",
      0.0225
    ],
    [
      "fait",
      0.0225
    ],
    [
      "sonne",
      0.01
    ],
    [
      "realise",
      0.01
    ],
    [
      "passe",
      0.01
    ],
    [
      "magistral",
      0.01
    ],
    [
      "forme",
      0.01
    ],
    [
      "effectue",
      0.01
    ],
    [
      "adulte",
      0.01
    ],
    [
      "emerite",
      0.01
    ]
  ],
  "grenier": [
    [
      "mansarde",
      0.2
    ],
    [
      "soupente",
      0.12
    ],
    [
      "galetas",
      0.08
    ],
    [
      "grange",
      0.08
    ],
    [
      "hangar",
      0.08
    ],
    [
      "pigeonnier",
      0.04
    ],
    [
      "silo",
      0.04
    ],
    [
      "solier",
      0.04
    ],
    [
      "tasserie",
      0.04
    ],
    [
      "pailler",
      0.04
    ],
    [
      "fenil",
      0.04
    ],
    [
      "debarras",
      0.04
    ],
    [
      "combles",
      0.04
    ],
    [
      "comble",
      0.04
    ],
    [
      "abri",
      0.04
    ],
    [
      "taudis",
      0.04
    ]
  ],
  "cave": [
    [
      "souterrain",
      0.09
    ],
    [
      "cavite",
      0.0725
    ],
    [
      "creux",
      0.0725
    ],
    [
      "excavation",
      0.0725
    ],
    [
      "caveau",
      0.0525
    ],
    [
      "cellier",
      0.0525
    ],
    [
      "renfoncement",
      0.0525
    ],
    [
      "maigre",
      0.035
    ],
    [
      "hypogee",
      0.035
    ],
    [
      "grotte",
      0.035
    ],
    [
      "caverne",
      0.035
    ],
    [
      "oubliette",
      0.0175
    ],
    [
      "pante",
      0.0175
    ],
    [
      "pomme",
      0.0175
    ],
    [
      "pressoir",
      0.0175
    ],
    [
      "rentre",
      0.0175
    ],
    [
      "silo",
      0.0175
    ],
    [
      "vendangeoir",
      0.0175
    ],
    [
      "vinee",
      0.0175
    ],
    [
      "mise",
      0.0175
    ],
    [
      "micheton",
      0.0175
    ],
    [
      "bourgeois",
      0.0175
    ],
    [
      "bucher",
      0.0175
    ],
    [
      "cabaret",
      0.0175
    ],
    [
      "caisse",
      0.0175
    ],
    [
      "chai",
      0.0175
    ],
    [
      "cuverie",
      0.0175
    ],
    [
      "cuvier",
      0.0175
    ],
    [
      "enfoncee",
      0.0175
    ],
    [
      "enjeu",
      0.0175
    ],
    [
      "etique",
      0.0175
    ]
  ],
  "stylo": [
    [
      "bic",
      0.3325
    ],
    [
      "crayon",
      0.3325
    ]
  ],
  "emplume": [
    [
      "empenner",
      1.0
    ]
  ],
  "emplumer": [
    [
      "empenner",
      1.0
    ]
  ],
  "archange": [
    [
      "ange",
      1.0
    ]
  ],
  "raye": [
    [
      "supprimer",
      0.1225
    ],
    [
      "biffer",
      0.0825
    ],
    [
      "barrer",
      0.075
    ],
    [
      "effacer",
      0.075
    ],
    [
      "radier",
      0.075
    ],
    [
      "retrancher",
      0.06
    ],
    [
      "oter",
      0.06
    ],
    [
      "detruire",
      0.0525
    ],
    [
      "exclure",
      0.0375
    ],
    [
      "eliminer",
      0.0375
    ],
    [
      "annuler",
      0.03
    ],
    [
      "marquer",
      0.03
    ],
    [
      "zebrer",
      0.0225
    ],
    [
      "raturer",
      0.0225
    ],
    [
      "entamer",
      0.0225
    ],
    [
      "couper",
      0.0225
    ],
    [
      "bannir",
      0.0225
    ],
    [
      "egratigner",
      0.0125
    ],
    [
      "strier",
      0.0125
    ],
    [
      "sabrer",
      0.0125
    ],
    [
      "reformer",
      0.0125
    ],
    [
      "caviarder",
      0.0125
    ],
    [
      "sillonner",
      0.005
    ],
    [
      "rider",
      0.005
    ],
    [
      "rejeter",
      0.005
    ],
    [
      "ligner",
      0.005
    ],
    [
      "hachurer",
      0.005
    ],
    [
      "batonner",
      0.005
    ],
    [
      "bretteler",
      0.005
    ],
    [
      "abolir",
      0.005
    ],
    [
      "erafler",
      0.005
    ]
  ],
  "forcat": [
    [
      "bagnard",
      0.375
    ],
    [
      "detenu",
      0.25
    ],
    [
      "captif",
      0.125
    ],
    [
      "chiourme",
      0.125
    ],
    [
      "galerien",
      0.125
    ]
  ],
  "drap": [
    [
      "linge",
      0.2
    ],
    [
      "chabraque",
      0.0975
    ],
    [
      "linceul",
      0.0975
    ],
    [
      "lingerie",
      0.0975
    ],
    [
      "literie",
      0.0975
    ],
    [
      "marengo",
      0.0975
    ],
    [
      "poele",
      0.0975
    ],
    [
      "tiretaine",
      0.0975
    ],
    [
      "tissu",
      0.0975
    ]
  ],
  "sommeil": [
    [
      "assoupissement",
      0.1075
    ],
    [
      "inaction",
      0.1075
    ],
    [
      "engourdissement",
      0.0875
    ],
    [
      "lethargie",
      0.0875
    ],
    [
      "sieste",
      0.0875
    ],
    [
      "repos",
      0.07
    ],
    [
      "narcose",
      0.0525
    ],
    [
      "somnolence",
      0.0525
    ],
    [
      "torpeur",
      0.0525
    ],
    [
      "inertie",
      0.035
    ],
    [
      "inactivite",
      0.035
    ],
    [
      "calme",
      0.035
    ],
    [
      "somme",
      0.015
    ],
    [
      "roupillon",
      0.015
    ],
    [
      "meridienne",
      0.015
    ],
    [
      "hibernation",
      0.015
    ],
    [
      "dormition",
      0.015
    ],
    [
      "dodo",
      0.015
    ],
    [
      "coma",
      0.015
    ],
    [
      "anesthesie",
      0.015
    ],
    [
      "eclipse",
      0.015
    ]
  ],
  "sommier": [
    [
      "linteau",
      0.2
    ],
    [
      "architrave",
      0.0975
    ],
    [
      "cerceau",
      0.0975
    ],
    [
      "claveau",
      0.0975
    ],
    [
      "paillasse",
      0.0975
    ],
    [
      "poitrail",
      0.0975
    ],
    [
      "registre",
      0.0975
    ],
    [
      "renseignement",
      0.0975
    ],
    [
      "traverse",
      0.0975
    ]
  ],
  "voyou": [
    [
      "vaurien",
      0.1475
    ],
    [
      "fripouille",
      0.1175
    ],
    [
      "truand",
      0.1175
    ],
    [
      "chenapan",
      0.0875
    ],
    [
      "bandit",
      0.0725
    ],
    [
      "canaille",
      0.0575
    ],
    [
      "garnement",
      0.0425
    ],
    [
      "gredin",
      0.0425
    ],
    [
      "vulgaire",
      0.0275
    ],
    [
      "terreur",
      0.0275
    ],
    [
      "gouape",
      0.0275
    ],
    [
      "galopin",
      0.0275
    ],
    [
      "arsouille",
      0.0275
    ],
    [
      "individu",
      0.0125
    ],
    [
      "gamin",
      0.0125
    ],
    [
      "galapiat",
      0.0125
    ],
    [
      "frappe",
      0.0125
    ],
    [
      "faubourien",
      0.0125
    ],
    [
      "crapule",
      0.0125
    ],
    [
      "apache",
      0.0125
    ],
    [
      "aigrefin",
      0.0125
    ],
    [
      "affranchi",
      0.0125
    ],
    [
      "populaire",
      0.0125
    ]
  ],
  "rosee": [
    [
      "rosir",
      1.0
    ]
  ],
  "furieux": [
    [
      "frenetique",
      0.085
    ],
    [
      "enrage",
      0.075
    ],
    [
      "fou",
      0.0725
    ],
    [
      "violent",
      0.0575
    ],
    [
      "terrible",
      0.04
    ],
    [
      "exalte",
      0.0375
    ],
    [
      "excessif",
      0.0375
    ],
    [
      "impetueux",
      0.03
    ],
    [
      "grand",
      0.03
    ],
    [
      "forcene",
      0.03
    ],
    [
      "dechaine",
      0.03
    ],
    [
      "extraordinaire",
      0.0275
    ],
    [
      "fanatique",
      0.0275
    ],
    [
      "bouillonnant",
      0.025
    ],
    [
      "fougueux",
      0.025
    ],
    [
      "irrite",
      0.02
    ],
    [
      "endiable",
      0.02
    ],
    [
      "extreme",
      0.0175
    ],
    [
      "acharne",
      0.015
    ],
    [
      "effrene",
      0.015
    ],
    [
      "exaspere",
      0.015
    ],
    [
      "energumene",
      0.015
    ],
    [
      "eperdu",
      0.015
    ],
    [
      "prodigieux",
      0.0125
    ],
    [
      "furibond",
      0.0125
    ],
    [
      "enthousiaste",
      0.0125
    ],
    [
      "enflamme",
      0.0125
    ],
    [
      "surexcite",
      0.0075
    ],
    [
      "sectaire",
      0.0075
    ],
    [
      "intolerant",
      0.0075
    ],
    [
      "farouche",
      0.0075
    ],
    [
      "fantastique",
      0.0075
    ],
    [
      "fabuleux",
      0.0075
    ],
    [
      "delirant",
      0.0075
    ],
    [
      "courrouce",
      0.0075
    ],
    [
      "colereux",
      0.0075
    ],
    [
      "colere",
      0.0075
    ],
    [
      "agite",
      0.0075
    ],
    [
      "maniaque",
      0.005
    ],
    [
      "fameux",
      0.005
    ],
    [
      "exacerbe",
      0.005
    ],
    [
      "ecumant",
      0.0025
    ],
    [
      "sacre",
      0.0025
    ],
    [
      "rogneux",
      0.0025
    ],
    [
      "possede",
      0.0025
    ],
    [
      "mecontent",
      0.0025
    ],
    [
      "hysterique",
      0.0025
    ],
    [
      "furibard",
      0.0025
    ],
    [
      "furax",
      0.0025
    ],
    [
      "fumasse",
      0.0025
    ],
    [
      "fumant",
      0.0025
    ],
    [
      "aliene",
      0.0025
    ],
    [
      "aigri",
      0.0025
    ],
    [
      "epileptique",
      0.0025
    ]
  ],
  "poudrer": [
    [
      "couvrir",
      0.22
    ],
    [
      "recouvrir",
      0.22
    ],
    [
      "enfariner",
      0.11
    ],
    [
      "farder",
      0.11
    ],
    [
      "garnir",
      0.11
    ],
    [
      "nuer",
      0.11
    ],
    [
      "saupoudrer",
      0.11
    ]
  ],
  "poudre": [
    [
      "charge",
      0.2
    ],
    [
      "explosif",
      0.2
    ],
    [
      "fard",
      0.2
    ],
    [
      "particule",
      0.2
    ],
    [
      "poussiere",
      0.2
    ]
  ],
  "foudre": [
    [
      "tonnerre",
      0.165
    ],
    [
      "feu",
      0.1
    ],
    [
      "fulguration",
      0.1
    ],
    [
      "critique",
      0.065
    ],
    [
      "epart",
      0.065
    ],
    [
      "futaille",
      0.0325
    ],
    [
      "orage",
      0.0325
    ],
    [
      "reproche",
      0.0325
    ],
    [
      "tonneau",
      0.0325
    ],
    [
      "eclair",
      0.0325
    ],
    [
      "emballage",
      0.0325
    ],
    [
      "condamnation",
      0.0325
    ],
    [
      "colere",
      0.0325
    ],
    [
      "chatiment",
      0.0325
    ],
    [
      "carreau",
      0.0325
    ],
    [
      "barrique",
      0.0325
    ],
    [
      "baril",
      0.0325
    ],
    [
      "epars",
      0.0325
    ]
  ],
  "rat": [
    [
      "avare",
      0.1075
    ],
    [
      "pingre",
      0.1075
    ],
    [
      "radin",
      0.1075
    ],
    [
      "chiche",
      0.0875
    ],
    [
      "ladre",
      0.065
    ],
    [
      "rongeur",
      0.0425
    ],
    [
      "rapiat",
      0.0425
    ],
    [
      "mulot",
      0.0425
    ],
    [
      "lesineur",
      0.0425
    ],
    [
      "chien",
      0.0425
    ],
    [
      "souris",
      0.02
    ],
    [
      "raton",
      0.02
    ],
    [
      "ragondin",
      0.02
    ],
    [
      "ondatra",
      0.02
    ],
    [
      "hamster",
      0.02
    ],
    [
      "danseuse",
      0.02
    ],
    [
      "castor",
      0.02
    ],
    [
      "campagnol",
      0.02
    ],
    [
      "biquet",
      0.02
    ],
    [
      "arvicole",
      0.02
    ],
    [
      "surmulot",
      0.02
    ]
  ],
  "gentiment": [
    [
      "agreablement",
      0.175
    ],
    [
      "joliment",
      0.1175
    ],
    [
      "gracieusement",
      0.1175
    ],
    [
      "complaisamment",
      0.1175
    ],
    [
      "bien",
      0.1175
    ],
    [
      "aimablement",
      0.1175
    ],
    [
      "adorablement",
      0.0575
    ],
    [
      "affectueusement",
      0.0575
    ],
    [
      "obligeamment",
      0.0575
    ],
    [
      "tranquillement",
      0.0575
    ]
  ],
  "scintillant": [
    [
      "brillant",
      0.235
    ],
    [
      "etincelant",
      0.175
    ],
    [
      "miroitant",
      0.1175
    ],
    [
      "papillotant",
      0.1175
    ],
    [
      "reluisant",
      0.1175
    ],
    [
      "clignotant",
      0.0575
    ],
    [
      "flambant",
      0.0575
    ],
    [
      "luisant",
      0.0575
    ],
    [
      "petillant",
      0.0575
    ]
  ],
  "scintiller": [
    [
      "luire",
      0.125
    ],
    [
      "briller",
      0.1025
    ],
    [
      "resplendir",
      0.1025
    ],
    [
      "etinceler",
      0.1025
    ],
    [
      "reluire",
      0.08
    ],
    [
      "chatoyer",
      0.055
    ],
    [
      "flamboyer",
      0.055
    ],
    [
      "vaciller",
      0.045
    ],
    [
      "papilloter",
      0.045
    ],
    [
      "miroiter",
      0.045
    ],
    [
      "fulgurer",
      0.045
    ],
    [
      "trembler",
      0.0225
    ],
    [
      "rutiler",
      0.0225
    ],
    [
      "petiller",
      0.0225
    ],
    [
      "poudroyer",
      0.0225
    ],
    [
      "clignoter",
      0.0225
    ],
    [
      "brasiller",
      0.0225
    ],
    [
      "cligner",
      0.01
    ],
    [
      "flamber",
      0.01
    ],
    [
      "frissonner",
      0.01
    ],
    [
      "palpiter",
      0.01
    ]
  ],
  "vigueur": [
    [
      "force",
      0.1525
    ],
    [
      "ardeur",
      0.09
    ],
    [
      "energie",
      0.08
    ],
    [
      "vie",
      0.055
    ],
    [
      "vivacite",
      0.0475
    ],
    [
      "vitalite",
      0.0425
    ],
    [
      "chaleur",
      0.035
    ],
    [
      "dynamisme",
      0.035
    ],
    [
      "fermete",
      0.035
    ],
    [
      "puissance",
      0.035
    ],
    [
      "violence",
      0.035
    ],
    [
      "coeur",
      0.03
    ],
    [
      "seve",
      0.0275
    ],
    [
      "bouillonnement",
      0.0225
    ],
    [
      "activite",
      0.0175
    ],
    [
      "solidite",
      0.0175
    ],
    [
      "vehemence",
      0.0175
    ],
    [
      "ame",
      0.015
    ],
    [
      "verdeur",
      0.015
    ],
    [
      "profondeur",
      0.015
    ],
    [
      "virilite",
      0.01
    ],
    [
      "robustesse",
      0.01
    ],
    [
      "nerf",
      0.01
    ],
    [
      "hardiesse",
      0.01
    ],
    [
      "generosite",
      0.01
    ],
    [
      "muscle",
      0.0075
    ],
    [
      "mordant",
      0.0075
    ],
    [
      "jeunesse",
      0.0075
    ],
    [
      "exuberance",
      0.0075
    ],
    [
      "couleur",
      0.0075
    ],
    [
      "biceps",
      0.0075
    ],
    [
      "autorite",
      0.0075
    ],
    [
      "allegresse",
      0.0075
    ],
    [
      "punch",
      0.0025
    ],
    [
      "pesanteur",
      0.0025
    ],
    [
      "nervosite",
      0.0025
    ],
    [
      "luxuriance",
      0.0025
    ],
    [
      "fringance",
      0.0025
    ],
    [
      "franchise",
      0.0025
    ],
    [
      "application",
      0.0025
    ],
    [
      "animosite",
      0.0025
    ],
    [
      "eloquence",
      0.0025
    ]
  ],
  "os": [
    [
      "difficulte",
      0.11
    ],
    [
      "debris",
      0.11
    ],
    [
      "obstacle",
      0.11
    ],
    [
      "squelette",
      0.0725
    ],
    [
      "reste",
      0.0725
    ],
    [
      "ossement",
      0.0725
    ],
    [
      "ossature",
      0.0725
    ],
    [
      "depouille",
      0.0725
    ],
    [
      "carcasse",
      0.0725
    ],
    [
      "accroc",
      0.035
    ],
    [
      "achoppement",
      0.035
    ],
    [
      "cactus",
      0.035
    ],
    [
      "cadavre",
      0.035
    ],
    [
      "restes",
      0.035
    ],
    [
      "tirage",
      0.035
    ]
  ],
  "clarte": [
    [
      "lumiere",
      0.1075
    ],
    [
      "nettete",
      0.085
    ],
    [
      "eclat",
      0.0625
    ],
    [
      "limpidite",
      0.0525
    ],
    [
      "intelligibilite",
      0.0525
    ],
    [
      "connaissance",
      0.0525
    ],
    [
      "brillant",
      0.0425
    ],
    [
      "luminosite",
      0.0425
    ],
    [
      "evidence",
      0.03
    ],
    [
      "transparence",
      0.03
    ],
    [
      "lueur",
      0.03
    ],
    [
      "jour",
      0.03
    ],
    [
      "splendeur",
      0.02
    ],
    [
      "simplicite",
      0.02
    ],
    [
      "purete",
      0.02
    ],
    [
      "precision",
      0.02
    ],
    [
      "notion",
      0.02
    ],
    [
      "nitescence",
      0.02
    ],
    [
      "lucidite",
      0.02
    ],
    [
      "facilite",
      0.02
    ],
    [
      "comprehension",
      0.02
    ],
    [
      "certitude",
      0.02
    ],
    [
      "perspicuite",
      0.0075
    ],
    [
      "poli",
      0.0075
    ],
    [
      "proprete",
      0.0075
    ],
    [
      "teinture",
      0.0075
    ],
    [
      "verre",
      0.0075
    ],
    [
      "eclairage",
      0.0075
    ],
    [
      "perspicacite",
      0.0075
    ],
    [
      "idee",
      0.0075
    ],
    [
      "fulguration",
      0.0075
    ],
    [
      "flamme",
      0.0075
    ],
    [
      "embrasement",
      0.0075
    ],
    [
      "comprehensibilite",
      0.0075
    ],
    [
      "blancheur",
      0.0075
    ],
    [
      "eclairement",
      0.0075
    ]
  ],
  "deceder": [
    [
      "mourir",
      0.2
    ],
    [
      "perir",
      0.2
    ],
    [
      "trepasser",
      0.2
    ],
    [
      "expirer",
      0.1
    ],
    [
      "finir",
      0.1
    ],
    [
      "succomber",
      0.1
    ]
  ],
  "decede": [
    [
      "mourir",
      0.2
    ],
    [
      "perir",
      0.2
    ],
    [
      "trepasser",
      0.2
    ],
    [
      "expirer",
      0.1
    ],
    [
      "finir",
      0.1
    ],
    [
      "succomber",
      0.1
    ]
  ],
  "chair": [
    [
      "concupiscence",
      0.075
    ],
    [
      "peau",
      0.075
    ],
    [
      "viande",
      0.05
    ],
    [
      "sensualite",
      0.05
    ],
    [
      "corps",
      0.05
    ],
    [
      "carne",
      0.05
    ],
    [
      "carnation",
      0.05
    ],
    [
      "barbaque",
      0.05
    ],
    [
      "luxure",
      0.0225
    ],
    [
      "muscle",
      0.0225
    ],
    [
      "nature",
      0.0225
    ],
    [
      "pulpe",
      0.0225
    ],
    [
      "sarcocarpe",
      0.0225
    ],
    [
      "sens",
      0.0225
    ],
    [
      "teint",
      0.0225
    ],
    [
      "tentation",
      0.0225
    ],
    [
      "tissu",
      0.0225
    ],
    [
      "libido",
      0.0225
    ],
    [
      "incarnadin",
      0.0225
    ],
    [
      "forme",
      0.0225
    ],
    [
      "bidoche",
      0.0225
    ],
    [
      "carnage",
      0.0225
    ],
    [
      "carogne",
      0.0225
    ],
    [
      "charogne",
      0.0225
    ],
    [
      "creature",
      0.0225
    ],
    [
      "defroque",
      0.0225
    ],
    [
      "enveloppe",
      0.0225
    ],
    [
      "faiblesse",
      0.0225
    ],
    [
      "fibre",
      0.0225
    ],
    [
      "venaison",
      0.0225
    ]
  ],
  "bonhomme": [
    [
      "brave",
      0.0725
    ],
    [
      "type",
      0.0525
    ],
    [
      "simple",
      0.0525
    ],
    [
      "homme",
      0.0525
    ],
    [
      "debonnaire",
      0.0525
    ],
    [
      "doux",
      0.0525
    ],
    [
      "bonasse",
      0.0525
    ],
    [
      "bienveillant",
      0.0525
    ],
    [
      "facile",
      0.045
    ],
    [
      "individu",
      0.035
    ],
    [
      "gentil",
      0.035
    ],
    [
      "aimable",
      0.025
    ],
    [
      "bon",
      0.025
    ],
    [
      "hypocrite",
      0.025
    ],
    [
      "mec",
      0.0175
    ],
    [
      "naif",
      0.0175
    ],
    [
      "obligeant",
      0.0175
    ],
    [
      "serviable",
      0.0175
    ],
    [
      "trompeur",
      0.0175
    ],
    [
      "gaillard",
      0.0175
    ],
    [
      "familier",
      0.0175
    ],
    [
      "credule",
      0.0175
    ],
    [
      "affable",
      0.0175
    ],
    [
      "amant",
      0.0175
    ],
    [
      "boniface",
      0.0175
    ],
    [
      "bougre",
      0.0175
    ],
    [
      "conciliant",
      0.0175
    ],
    [
      "simulateur",
      0.0075
    ],
    [
      "patelin",
      0.0075
    ],
    [
      "modeste",
      0.0075
    ],
    [
      "maraud",
      0.0075
    ],
    [
      "manant",
      0.0075
    ],
    [
      "guignol",
      0.0075
    ],
    [
      "citoyen",
      0.0075
    ],
    [
      "candide",
      0.0075
    ],
    [
      "altruiste",
      0.0075
    ],
    [
      "zig",
      0.0075
    ]
  ],
  "velo": [
    [
      "bicyclette",
      0.3475
    ],
    [
      "becane",
      0.2175
    ],
    [
      "cycle",
      0.13
    ],
    [
      "tandem",
      0.0425
    ],
    [
      "clou",
      0.0425
    ],
    [
      "bicycle",
      0.0425
    ],
    [
      "biclou",
      0.0425
    ],
    [
      "biclo",
      0.0425
    ],
    [
      "velocipede",
      0.0425
    ]
  ],
  "cour": [
    [
      "assemblee",
      0.12
    ],
    [
      "conseil",
      0.08
    ],
    [
      "tribunal",
      0.08
    ],
    [
      "galanterie",
      0.04
    ],
    [
      "gouvernement",
      0.04
    ],
    [
      "parlement",
      0.04
    ],
    [
      "patio",
      0.04
    ],
    [
      "preau",
      0.04
    ],
    [
      "pretoire",
      0.04
    ],
    [
      "flatterie",
      0.04
    ],
    [
      "cortege",
      0.04
    ],
    [
      "cloitre",
      0.04
    ],
    [
      "cercle",
      0.04
    ],
    [
      "cassation",
      0.04
    ],
    [
      "aula",
      0.04
    ],
    [
      "atrium",
      0.04
    ],
    [
      "assiduite",
      0.04
    ],
    [
      "adulation",
      0.04
    ],
    [
      "suite",
      0.04
    ]
  ],
  "portraire": [
    [
      "peindre",
      0.3325
    ],
    [
      "portraiturer",
      0.3325
    ],
    [
      "representer",
      0.3325
    ]
  ],
  "portrait": [
    [
      "image",
      0.2125
    ],
    [
      "figure",
      0.12
    ],
    [
      "visage",
      0.0625
    ],
    [
      "dessin",
      0.0525
    ],
    [
      "representation",
      0.0525
    ],
    [
      "peinture",
      0.045
    ],
    [
      "semblance",
      0.035
    ],
    [
      "effigie",
      0.035
    ],
    [
      "croquis",
      0.035
    ],
    [
      "caricature",
      0.035
    ],
    [
      "physionomie",
      0.025
    ],
    [
      "tete",
      0.0175
    ],
    [
      "type",
      0.0175
    ],
    [
      "tableau",
      0.0175
    ],
    [
      "silhouette",
      0.0175
    ],
    [
      "replique",
      0.0175
    ],
    [
      "ressemblance",
      0.0175
    ],
    [
      "profil",
      0.0175
    ],
    [
      "modele",
      0.0175
    ],
    [
      "miniature",
      0.0175
    ],
    [
      "description",
      0.0175
    ],
    [
      "crayon",
      0.0175
    ],
    [
      "physiologie",
      0.0075
    ],
    [
      "photographie",
      0.0075
    ],
    [
      "photo",
      0.0075
    ],
    [
      "miroir",
      0.0075
    ],
    [
      "maternite",
      0.0075
    ],
    [
      "fresque",
      0.0075
    ],
    [
      "buste",
      0.0075
    ],
    [
      "autoportrait",
      0.0075
    ],
    [
      "portraiture",
      0.0075
    ]
  ],
  "entourer": [
    [
      "enserrer",
      0.07
    ],
    [
      "enfermer",
      0.0675
    ],
    [
      "ceindre",
      0.065
    ],
    [
      "encercler",
      0.065
    ],
    [
      "cerner",
      0.06
    ],
    [
      "enclore",
      0.045
    ],
    [
      "envelopper",
      0.0425
    ],
    [
      "serrer",
      0.0375
    ],
    [
      "renfermer",
      0.03
    ],
    [
      "emprisonner",
      0.03
    ],
    [
      "ceinturer",
      0.0225
    ],
    [
      "enceindre",
      0.0225
    ],
    [
      "fermer",
      0.0225
    ],
    [
      "environner",
      0.0175
    ],
    [
      "enlacer",
      0.0175
    ],
    [
      "embrasser",
      0.0175
    ],
    [
      "cercler",
      0.0175
    ],
    [
      "etreindre",
      0.015
    ],
    [
      "resserrer",
      0.015
    ],
    [
      "clore",
      0.015
    ],
    [
      "assieger",
      0.015
    ],
    [
      "boucler",
      0.0125
    ],
    [
      "encadrer",
      0.0125
    ],
    [
      "presser",
      0.01
    ],
    [
      "contenir",
      0.01
    ],
    [
      "borner",
      0.01
    ],
    [
      "parer",
      0.0075
    ],
    [
      "murer",
      0.0075
    ],
    [
      "garnir",
      0.0075
    ],
    [
      "emmailloter",
      0.0075
    ],
    [
      "combler",
      0.0075
    ],
    [
      "circonscrire",
      0.0075
    ],
    [
      "choyer",
      0.0075
    ],
    [
      "bloquer",
      0.0075
    ],
    [
      "bichonner",
      0.0075
    ],
    [
      "habiller",
      0.005
    ],
    [
      "fortifier",
      0.005
    ],
    [
      "entortiller",
      0.005
    ],
    [
      "border",
      0.005
    ],
    [
      "bander",
      0.005
    ],
    [
      "accabler",
      0.005
    ],
    [
      "voiler",
      0.0025
    ],
    [
      "orner",
      0.0025
    ],
    [
      "ficeler",
      0.0025
    ],
    [
      "enrouler",
      0.0025
    ],
    [
      "couronner",
      0.0025
    ],
    [
      "corder",
      0.0025
    ],
    [
      "cloturer",
      0.0025
    ],
    [
      "aureoler",
      0.0025
    ],
    [
      "attaquer",
      0.0025
    ],
    [
      "enrubanner",
      0.0
    ],
    [
      "espionner",
      0.0
    ],
    [
      "frequenter",
      0.0
    ],
    [
      "herisser",
      0.0
    ],
    [
      "lamper",
      0.0
    ],
    [
      "palissader",
      0.0
    ],
    [
      "s'empresser",
      0.0
    ],
    [
      "s'enrouler",
      0.0
    ],
    [
      "venerer",
      0.0
    ],
    [
      "enrober",
      0.0
    ],
    [
      "enclaver",
      0.0
    ],
    [
      "abreuver",
      0.0
    ],
    [
      "accompagner",
      0.0
    ],
    [
      "approcher",
      0.0
    ],
    [
      "assister",
      0.0
    ],
    [
      "baigner",
      0.0
    ],
    [
      "balustrer",
      0.0
    ],
    [
      "chouchouter",
      0.0
    ],
    [
      "draper",
      0.0
    ],
    [
      "encaisser",
      0.0
    ],
    [
      "enchasser",
      0.0
    ]
  ],
  "glace": [
    [
      "geler",
      0.095
    ],
    [
      "paralyser",
      0.095
    ],
    [
      "lustrer",
      0.08
    ],
    [
      "figer",
      0.0625
    ],
    [
      "petrifier",
      0.0625
    ],
    [
      "transir",
      0.0625
    ],
    [
      "frapper",
      0.045
    ],
    [
      "vernisser",
      0.03
    ],
    [
      "vernir",
      0.03
    ],
    [
      "troubler",
      0.03
    ],
    [
      "transpercer",
      0.03
    ],
    [
      "refroidir",
      0.03
    ],
    [
      "intimider",
      0.03
    ],
    [
      "immobiliser",
      0.03
    ],
    [
      "frigorifier",
      0.03
    ],
    [
      "congeler",
      0.03
    ],
    [
      "cirer",
      0.03
    ],
    [
      "refrigerer",
      0.015
    ],
    [
      "satiner",
      0.015
    ],
    [
      "scleroser",
      0.015
    ],
    [
      "tetaniser",
      0.015
    ],
    [
      "polir",
      0.015
    ],
    [
      "enrober",
      0.015
    ],
    [
      "engourdir",
      0.015
    ],
    [
      "enduire",
      0.015
    ],
    [
      "durcir",
      0.015
    ],
    [
      "calandrer",
      0.015
    ],
    [
      "etrangler",
      0.015
    ]
  ],
  "glacer": [
    [
      "geler",
      0.095
    ],
    [
      "paralyser",
      0.095
    ],
    [
      "lustrer",
      0.08
    ],
    [
      "figer",
      0.0625
    ],
    [
      "petrifier",
      0.0625
    ],
    [
      "transir",
      0.0625
    ],
    [
      "frapper",
      0.045
    ],
    [
      "vernisser",
      0.03
    ],
    [
      "vernir",
      0.03
    ],
    [
      "troubler",
      0.03
    ],
    [
      "transpercer",
      0.03
    ],
    [
      "refroidir",
      0.03
    ],
    [
      "intimider",
      0.03
    ],
    [
      "immobiliser",
      0.03
    ],
    [
      "frigorifier",
      0.03
    ],
    [
      "congeler",
      0.03
    ],
    [
      "cirer",
      0.03
    ],
    [
      "refrigerer",
      0.015
    ],
    [
      "satiner",
      0.015
    ],
    [
      "scleroser",
      0.015
    ],
    [
      "tetaniser",
      0.015
    ],
    [
      "polir",
      0.015
    ],
    [
      "enrober",
      0.015
    ],
    [
      "engourdir",
      0.015
    ],
    [
      "enduire",
      0.015
    ],
    [
      "durcir",
      0.015
    ],
    [
      "calandrer",
      0.015
    ],
    [
      "etrangler",
      0.015
    ]
  ],
  "enferme": [
    [
      "renfermer",
      0.105
    ],
    [
      "entourer",
      0.0825
    ],
    [
      "emprisonner",
      0.0725
    ],
    [
      "cerner",
      0.0625
    ],
    [
      "encercler",
      0.0425
    ],
    [
      "boucler",
      0.04
    ],
    [
      "sequestrer",
      0.0375
    ],
    [
      "enclore",
      0.0375
    ],
    [
      "enserrer",
      0.0325
    ],
    [
      "fermer",
      0.0325
    ],
    [
      "cloitrer",
      0.0225
    ],
    [
      "murer",
      0.0225
    ],
    [
      "serrer",
      0.02
    ],
    [
      "investir",
      0.02
    ],
    [
      "ceindre",
      0.02
    ],
    [
      "contenir",
      0.015
    ],
    [
      "isoler",
      0.015
    ],
    [
      "parquer",
      0.015
    ],
    [
      "interner",
      0.0125
    ],
    [
      "environner",
      0.0125
    ],
    [
      "clore",
      0.0125
    ],
    [
      "claquemurer",
      0.0125
    ],
    [
      "cacher",
      0.0125
    ],
    [
      "resserrer",
      0.01
    ],
    [
      "enceindre",
      0.01
    ],
    [
      "consigner",
      0.01
    ],
    [
      "circonscrire",
      0.01
    ],
    [
      "cadenasser",
      0.01
    ],
    [
      "assieger",
      0.01
    ],
    [
      "ecrouer",
      0.0075
    ],
    [
      "ranger",
      0.0075
    ],
    [
      "limiter",
      0.0075
    ],
    [
      "garder",
      0.0075
    ],
    [
      "comprendre",
      0.0075
    ],
    [
      "coffrer",
      0.0075
    ],
    [
      "claustrer",
      0.0075
    ],
    [
      "barricader",
      0.0075
    ],
    [
      "verrouiller",
      0.005
    ],
    [
      "reclure",
      0.005
    ],
    [
      "inclure",
      0.005
    ],
    [
      "empecher",
      0.005
    ],
    [
      "emmurer",
      0.005
    ],
    [
      "emballer",
      0.005
    ],
    [
      "detenir",
      0.005
    ],
    [
      "confiner",
      0.005
    ],
    [
      "chambrer",
      0.005
    ],
    [
      "impliquer",
      0.0025
    ],
    [
      "enfouir",
      0.0025
    ],
    [
      "encoffrer",
      0.0025
    ],
    [
      "enclaver",
      0.0025
    ],
    [
      "comporter",
      0.0025
    ],
    [
      "calfeutrer",
      0.0025
    ],
    [
      "acculer",
      0.0025
    ],
    [
      "tourner",
      0.0025
    ]
  ],
  "enfermer": [
    [
      "renfermer",
      0.105
    ],
    [
      "entourer",
      0.0825
    ],
    [
      "emprisonner",
      0.0725
    ],
    [
      "cerner",
      0.0625
    ],
    [
      "encercler",
      0.0425
    ],
    [
      "boucler",
      0.04
    ],
    [
      "sequestrer",
      0.0375
    ],
    [
      "enclore",
      0.0375
    ],
    [
      "enserrer",
      0.0325
    ],
    [
      "fermer",
      0.0325
    ],
    [
      "cloitrer",
      0.0225
    ],
    [
      "murer",
      0.0225
    ],
    [
      "serrer",
      0.02
    ],
    [
      "investir",
      0.02
    ],
    [
      "ceindre",
      0.02
    ],
    [
      "contenir",
      0.015
    ],
    [
      "isoler",
      0.015
    ],
    [
      "parquer",
      0.015
    ],
    [
      "interner",
      0.0125
    ],
    [
      "environner",
      0.0125
    ],
    [
      "clore",
      0.0125
    ],
    [
      "claquemurer",
      0.0125
    ],
    [
      "cacher",
      0.0125
    ],
    [
      "resserrer",
      0.01
    ],
    [
      "enceindre",
      0.01
    ],
    [
      "consigner",
      0.01
    ],
    [
      "circonscrire",
      0.01
    ],
    [
      "cadenasser",
      0.01
    ],
    [
      "assieger",
      0.01
    ],
    [
      "ecrouer",
      0.0075
    ],
    [
      "ranger",
      0.0075
    ],
    [
      "limiter",
      0.0075
    ],
    [
      "garder",
      0.0075
    ],
    [
      "comprendre",
      0.0075
    ],
    [
      "coffrer",
      0.0075
    ],
    [
      "claustrer",
      0.0075
    ],
    [
      "barricader",
      0.0075
    ],
    [
      "verrouiller",
      0.005
    ],
    [
      "reclure",
      0.005
    ],
    [
      "inclure",
      0.005
    ],
    [
      "empecher",
      0.005
    ],
    [
      "emmurer",
      0.005
    ],
    [
      "emballer",
      0.005
    ],
    [
      "detenir",
      0.005
    ],
    [
      "confiner",
      0.005
    ],
    [
      "chambrer",
      0.005
    ],
    [
      "impliquer",
      0.0025
    ],
    [
      "enfouir",
      0.0025
    ],
    [
      "encoffrer",
      0.0025
    ],
    [
      "enclaver",
      0.0025
    ],
    [
      "comporter",
      0.0025
    ],
    [
      "calfeutrer",
      0.0025
    ],
    [
      "acculer",
      0.0025
    ],
    [
      "tourner",
      0.0025
    ]
  ],
  "forte": [
    [
      "gros",
      0.0525
    ],
    [
      "grand",
      0.035
    ],
    [
      "bon",
      0.025
    ],
    [
      "ferme",
      0.025
    ],
    [
      "robuste",
      0.025
    ],
    [
      "beau",
      0.0225
    ],
    [
      "solide",
      0.0225
    ],
    [
      "energique",
      0.02
    ],
    [
      "puissant",
      0.02
    ],
    [
      "dur",
      0.0175
    ],
    [
      "vif",
      0.0175
    ],
    [
      "abondant",
      0.0175
    ],
    [
      "violent",
      0.0175
    ],
    [
      "trapu",
      0.015
    ],
    [
      "important",
      0.015
    ],
    [
      "vigoureux",
      0.015
    ],
    [
      "epais",
      0.0125
    ],
    [
      "haut",
      0.0125
    ],
    [
      "resistant",
      0.0125
    ],
    [
      "profond",
      0.0125
    ],
    [
      "excessif",
      0.0125
    ],
    [
      "plein",
      0.01
    ],
    [
      "lourd",
      0.01
    ],
    [
      "vaste",
      0.01
    ],
    [
      "eclatant",
      0.0075
    ],
    [
      "intense",
      0.0075
    ],
    [
      "genereux",
      0.0075
    ],
    [
      "extraordinaire",
      0.0075
    ],
    [
      "retentissant",
      0.0075
    ],
    [
      "percant",
      0.0075
    ],
    [
      "muscle",
      0.0075
    ],
    [
      "massif",
      0.0075
    ],
    [
      "large",
      0.0075
    ],
    [
      "habile",
      0.0075
    ],
    [
      "gras",
      0.0075
    ],
    [
      "courageux",
      0.0075
    ],
    [
      "costaud",
      0.0075
    ],
    [
      "capable",
      0.0075
    ],
    [
      "aigu",
      0.0075
    ],
    [
      "dense",
      0.0075
    ],
    [
      "etonnant",
      0.005
    ],
    [
      "enorme",
      0.005
    ],
    [
      "tenace",
      0.005
    ],
    [
      "intelligent",
      0.005
    ],
    [
      "formidable",
      0.005
    ],
    [
      "extreme",
      0.005
    ],
    [
      "cale",
      0.005
    ],
    [
      "vivant",
      0.005
    ],
    [
      "savant",
      0.005
    ],
    [
      "rude",
      0.005
    ],
    [
      "raide",
      0.005
    ],
    [
      "inebranlable",
      0.005
    ],
    [
      "infatigable",
      0.005
    ],
    [
      "efficace",
      0.005
    ],
    [
      "autoritaire",
      0.005
    ],
    [
      "ample",
      0.005
    ],
    [
      "touffu",
      0.0025
    ],
    [
      "sonore",
      0.0025
    ],
    [
      "resolu",
      0.0025
    ],
    [
      "precis",
      0.0025
    ],
    [
      "irresistible",
      0.0025
    ],
    [
      "baraque",
      0.0025
    ],
    [
      "agissant",
      0.0025
    ],
    [
      "genial",
      0.0025
    ],
    [
      "incroyable",
      0.0025
    ],
    [
      "insupportable",
      0.0025
    ],
    [
      "piquant",
      0.0025
    ],
    [
      "penetrant",
      0.0025
    ],
    [
      "resonnant",
      0.0025
    ],
    [
      "sale",
      0.0025
    ],
    [
      "tonitruant",
      0.0025
    ],
    [
      "volontaire",
      0.0025
    ],
    [
      "volumineux",
      0.0025
    ],
    [
      "grave",
      0.0025
    ],
    [
      "forteresse",
      0.0025
    ],
    [
      "absolu",
      0.0025
    ],
    [
      "actif",
      0.0025
    ],
    [
      "adroit",
      0.0025
    ],
    [
      "brutal",
      0.0025
    ],
    [
      "carabine",
      0.0025
    ],
    [
      "charge",
      0.0025
    ],
    [
      "copieux",
      0.0025
    ],
    [
      "dru",
      0.0025
    ],
    [
      "exagere",
      0.0025
    ],
    [
      "fier",
      0.0025
    ],
    [
      "instruit",
      0.0025
    ],
    [
      "invulnerable",
      0.0025
    ],
    [
      "marque",
      0.0025
    ],
    [
      "opulent",
      0.0025
    ],
    [
      "rable",
      0.0025
    ],
    [
      "strict",
      0.0025
    ],
    [
      "stupefiant",
      0.0025
    ],
    [
      "valide",
      0.0025
    ],
    [
      "eblouissant",
      0.0025
    ],
    [
      "inoui",
      0.0025
    ],
    [
      "influent",
      0.0025
    ],
    [
      "abri",
      0.0025
    ],
    [
      "baleze",
      0.0025
    ],
    [
      "colore",
      0.0025
    ],
    [
      "comble",
      0.0025
    ],
    [
      "convaincant",
      0.0025
    ],
    [
      "corpulent",
      0.0025
    ],
    [
      "corse",
      0.0025
    ],
    [
      "impetueux",
      0.0025
    ],
    [
      "prononce",
      0.0
    ],
    [
      "propre",
      0.0
    ],
    [
      "rebondi",
      0.0
    ],
    [
      "releve",
      0.0
    ],
    [
      "replet",
      0.0
    ],
    [
      "rigide",
      0.0
    ],
    [
      "serieux",
      0.0
    ],
    [
      "trempe",
      0.0
    ],
    [
      "eloquent",
      0.0
    ],
    [
      "epice",
      0.0
    ],
    [
      "etourdissant",
      0.0
    ],
    [
      "nombreux",
      0.0
    ],
    [
      "male",
      0.0
    ],
    [
      "invraisemblable",
      0.0
    ],
    [
      "amer",
      0.0
    ],
    [
      "coeur",
      0.0
    ],
    [
      "cuisant",
      0.0
    ],
    [
      "doue",
      0.0
    ],
    [
      "decisif",
      0.0
    ],
    [
      "expressif",
      0.0
    ],
    [
      "ferre",
      0.0
    ],
    [
      "fortification",
      0.0
    ],
    [
      "insoutenable",
      0.0
    ],
    [
      "intolerable",
      0.0
    ],
    [
      "invincible",
      0.0
    ],
    [
      "krak",
      0.0
    ],
    [
      "hercule",
      0.0
    ],
    [
      "fortin",
      0.0
    ],
    [
      "fortifie",
      0.0
    ],
    [
      "fortiche",
      0.0
    ],
    [
      "maitre",
      0.0
    ],
    [
      "outre",
      0.0
    ],
    [
      "ouvrage",
      0.0
    ],
    [
      "repaire",
      0.0
    ],
    [
      "rustique",
      0.0
    ],
    [
      "strident",
      0.0
    ],
    [
      "summum",
      0.0
    ],
    [
      "experimente",
      0.0
    ],
    [
      "enivrant",
      0.0
    ],
    [
      "accuse",
      0.0
    ],
    [
      "aguerri",
      0.0
    ],
    [
      "appuye",
      0.0
    ],
    [
      "bruyant",
      0.0
    ],
    [
      "choquant",
      0.0
    ],
    [
      "chateau",
      0.0
    ],
    [
      "concis",
      0.0
    ],
    [
      "constant",
      0.0
    ],
    [
      "docte",
      0.0
    ],
    [
      "developpe",
      0.0
    ],
    [
      "marquant",
      0.0
    ],
    [
      "maous",
      0.0
    ],
    [
      "malin",
      0.0
    ],
    [
      "malabar",
      0.0
    ],
    [
      "inusable",
      0.0
    ],
    [
      "poivre",
      0.0
    ],
    [
      "porteur",
      0.0
    ],
    [
      "pousse",
      0.0
    ],
    [
      "pepere",
      0.0
    ],
    [
      "sein",
      0.0
    ],
    [
      "soigne",
      0.0
    ],
    [
      "taille",
      0.0
    ],
    [
      "taniere",
      0.0
    ],
    [
      "imbattable",
      0.0
    ],
    [
      "herculeen",
      0.0
    ],
    [
      "fetide",
      0.0
    ],
    [
      "alcoolise",
      0.0
    ],
    [
      "arme",
      0.0
    ],
    [
      "athletique",
      0.0
    ],
    [
      "aveuglant",
      0.0
    ],
    [
      "centre",
      0.0
    ],
    [
      "claironnant",
      0.0
    ],
    [
      "despotique",
      0.0
    ],
    [
      "dictatorial",
      0.0
    ],
    [
      "entetant",
      0.0
    ],
    [
      "excellent",
      0.0
    ],
    [
      "alcide",
      0.0
    ]
  ],
  "arranger": [
    [
      "disposer",
      0.0725
    ],
    [
      "combiner",
      0.045
    ],
    [
      "preparer",
      0.045
    ],
    [
      "harmoniser",
      0.0425
    ],
    [
      "organiser",
      0.0425
    ],
    [
      "composer",
      0.03
    ],
    [
      "agencer",
      0.03
    ],
    [
      "accommoder",
      0.025
    ],
    [
      "accorder",
      0.025
    ],
    [
      "ajuster",
      0.025
    ],
    [
      "ordonner",
      0.025
    ],
    [
      "amenager",
      0.0225
    ],
    [
      "construire",
      0.02
    ],
    [
      "adapter",
      0.02
    ],
    [
      "former",
      0.02
    ],
    [
      "regler",
      0.0175
    ],
    [
      "appreter",
      0.015
    ],
    [
      "ranger",
      0.0125
    ],
    [
      "faconner",
      0.0125
    ],
    [
      "assembler",
      0.0125
    ],
    [
      "habiller",
      0.0125
    ],
    [
      "placer",
      0.0125
    ],
    [
      "classer",
      0.01
    ],
    [
      "parer",
      0.01
    ],
    [
      "reparer",
      0.01
    ],
    [
      "fabriquer",
      0.01
    ],
    [
      "dresser",
      0.01
    ],
    [
      "calculer",
      0.01
    ],
    [
      "transformer",
      0.0075
    ],
    [
      "traiter",
      0.0075
    ],
    [
      "tourner",
      0.0075
    ],
    [
      "soigner",
      0.0075
    ],
    [
      "refaire",
      0.0075
    ],
    [
      "mettre",
      0.0075
    ],
    [
      "maltraiter",
      0.0075
    ],
    [
      "finir",
      0.0075
    ],
    [
      "convenir",
      0.0075
    ],
    [
      "constituer",
      0.0075
    ],
    [
      "battre",
      0.0075
    ],
    [
      "accoutrer",
      0.0075
    ],
    [
      "retablir",
      0.005
    ],
    [
      "rudoyer",
      0.005
    ],
    [
      "restaurer",
      0.005
    ],
    [
      "presenter",
      0.005
    ],
    [
      "distribuer",
      0.005
    ],
    [
      "ameliorer",
      0.005
    ],
    [
      "tisser",
      0.005
    ],
    [
      "recomposer",
      0.005
    ],
    [
      "parfaire",
      0.005
    ],
    [
      "menager",
      0.005
    ],
    [
      "manigancer",
      0.005
    ],
    [
      "installer",
      0.005
    ],
    [
      "fignoler",
      0.005
    ],
    [
      "exposer",
      0.005
    ],
    [
      "abimer",
      0.005
    ],
    [
      "aligner",
      0.005
    ],
    [
      "assaisonner",
      0.005
    ],
    [
      "attifer",
      0.005
    ],
    [
      "coordonner",
      0.005
    ],
    [
      "terminer",
      0.0025
    ],
    [
      "satisfaire",
      0.0025
    ],
    [
      "remanier",
      0.0025
    ],
    [
      "rajuster",
      0.0025
    ],
    [
      "medire",
      0.0025
    ],
    [
      "inventer",
      0.0025
    ],
    [
      "fringuer",
      0.0025
    ],
    [
      "embellir",
      0.0025
    ],
    [
      "deguiser",
      0.0025
    ],
    [
      "critiquer",
      0.0025
    ],
    [
      "conclure",
      0.0025
    ],
    [
      "peigner",
      0.0025
    ],
    [
      "prevoir",
      0.0025
    ],
    [
      "remedier",
      0.0025
    ],
    [
      "retoucher",
      0.0025
    ],
    [
      "reprimander",
      0.0025
    ],
    [
      "tramer",
      0.0025
    ],
    [
      "tresser",
      0.0025
    ],
    [
      "edifier",
      0.0025
    ],
    [
      "ourdir",
      0.0025
    ],
    [
      "grouper",
      0.0025
    ],
    [
      "aplanir",
      0.0025
    ],
    [
      "arrimer",
      0.0025
    ],
    [
      "assortir",
      0.0025
    ],
    [
      "blesser",
      0.0025
    ],
    [
      "concerter",
      0.0025
    ],
    [
      "concilier",
      0.0025
    ],
    [
      "cuisiner",
      0.0025
    ],
    [
      "goupiller",
      0.0025
    ],
    [
      "orchestrer",
      0.0
    ],
    [
      "pacifier",
      0.0
    ],
    [
      "retaper",
      0.0
    ],
    [
      "rhabiller",
      0.0
    ],
    [
      "romancer",
      0.0
    ],
    [
      "s'agencer",
      0.0
    ],
    [
      "sermonner",
      0.0
    ],
    [
      "tancer",
      0.0
    ],
    [
      "trier",
      0.0
    ],
    [
      "trousser",
      0.0
    ],
    [
      "manipuler",
      0.0
    ],
    [
      "agreer",
      0.0
    ],
    [
      "approprier",
      0.0
    ],
    [
      "arbitrer",
      0.0
    ],
    [
      "coiffer",
      0.0
    ],
    [
      "contenter",
      0.0
    ],
    [
      "deteriorer",
      0.0
    ],
    [
      "faciliter",
      0.0
    ],
    [
      "fagoter",
      0.0
    ],
    [
      "ficeler",
      0.0
    ],
    [
      "malmener",
      0.0
    ],
    [
      "voler",
      0.0
    ]
  ],
  "exister": [
    [
      "demeurer",
      0.16
    ],
    [
      "etre",
      0.1275
    ],
    [
      "habiter",
      0.095
    ],
    [
      "subsister",
      0.095
    ],
    [
      "vivre",
      0.095
    ],
    [
      "regner",
      0.0625
    ],
    [
      "durer",
      0.0625
    ],
    [
      "avoir",
      0.03
    ],
    [
      "compter",
      0.03
    ],
    [
      "continuer",
      0.03
    ],
    [
      "persister",
      0.03
    ]
  ],
  "contraire": [
    [
      "oppose",
      0.1325
    ],
    [
      "nuisible",
      0.0575
    ],
    [
      "defavorable",
      0.05
    ],
    [
      "pernicieux",
      0.0425
    ],
    [
      "nefaste",
      0.0425
    ],
    [
      "mauvais",
      0.0425
    ],
    [
      "ennemi",
      0.0425
    ],
    [
      "antithese",
      0.035
    ],
    [
      "contrepartie",
      0.035
    ],
    [
      "dommageable",
      0.035
    ],
    [
      "hostile",
      0.035
    ],
    [
      "inverse",
      0.035
    ],
    [
      "prejudiciable",
      0.0275
    ],
    [
      "adverse",
      0.02
    ],
    [
      "incompatible",
      0.02
    ],
    [
      "funeste",
      0.02
    ],
    [
      "discordant",
      0.02
    ],
    [
      "contradictoire",
      0.02
    ],
    [
      "opposition",
      0.0125
    ],
    [
      "negation",
      0.0125
    ],
    [
      "extreme",
      0.0125
    ],
    [
      "desavantageux",
      0.0125
    ],
    [
      "different",
      0.0125
    ],
    [
      "attentatoire",
      0.0125
    ],
    [
      "antipode",
      0.0125
    ],
    [
      "antinomique",
      0.0125
    ],
    [
      "antagoniste",
      0.0125
    ],
    [
      "adversaire",
      0.0125
    ],
    [
      "irreductible",
      0.005
    ],
    [
      "nocif",
      0.005
    ],
    [
      "paradoxal",
      0.005
    ],
    [
      "paradoxe",
      0.005
    ],
    [
      "heterogene",
      0.005
    ],
    [
      "envers",
      0.005
    ],
    [
      "contraste",
      0.005
    ],
    [
      "antonyme",
      0.005
    ],
    [
      "antithetique",
      0.005
    ],
    [
      "antiphrase",
      0.005
    ],
    [
      "separe",
      0.005
    ]
  ],
  "oblige": [
    [
      "contraindre",
      0.16
    ],
    [
      "astreindre",
      0.1025
    ],
    [
      "assujettir",
      0.08
    ],
    [
      "forcer",
      0.0725
    ],
    [
      "imposer",
      0.0425
    ],
    [
      "soumettre",
      0.035
    ],
    [
      "necessiter",
      0.035
    ],
    [
      "lier",
      0.035
    ],
    [
      "entrainer",
      0.035
    ],
    [
      "engager",
      0.035
    ],
    [
      "reduire",
      0.0275
    ],
    [
      "presser",
      0.0275
    ],
    [
      "exiger",
      0.0275
    ],
    [
      "enchainer",
      0.0275
    ],
    [
      "condamner",
      0.0275
    ],
    [
      "commander",
      0.0275
    ],
    [
      "attacher",
      0.02
    ],
    [
      "sommer",
      0.0125
    ],
    [
      "servir",
      0.0125
    ],
    [
      "s'engager",
      0.0125
    ],
    [
      "promettre",
      0.0125
    ],
    [
      "occuper",
      0.0125
    ],
    [
      "brusquer",
      0.0125
    ],
    [
      "atteler",
      0.0125
    ],
    [
      "aider",
      0.0125
    ],
    [
      "secourir",
      0.005
    ],
    [
      "exciter",
      0.005
    ],
    [
      "depanner",
      0.005
    ],
    [
      "acculer",
      0.005
    ],
    [
      "violenter",
      0.005
    ]
  ],
  "obliger": [
    [
      "contraindre",
      0.16
    ],
    [
      "astreindre",
      0.1025
    ],
    [
      "assujettir",
      0.08
    ],
    [
      "forcer",
      0.0725
    ],
    [
      "imposer",
      0.0425
    ],
    [
      "soumettre",
      0.035
    ],
    [
      "necessiter",
      0.035
    ],
    [
      "lier",
      0.035
    ],
    [
      "entrainer",
      0.035
    ],
    [
      "engager",
      0.035
    ],
    [
      "reduire",
      0.0275
    ],
    [
      "presser",
      0.0275
    ],
    [
      "exiger",
      0.0275
    ],
    [
      "enchainer",
      0.0275
    ],
    [
      "condamner",
      0.0275
    ],
    [
      "commander",
      0.0275
    ],
    [
      "attacher",
      0.02
    ],
    [
      "sommer",
      0.0125
    ],
    [
      "servir",
      0.0125
    ],
    [
      "s'engager",
      0.0125
    ],
    [
      "promettre",
      0.0125
    ],
    [
      "occuper",
      0.0125
    ],
    [
      "brusquer",
      0.0125
    ],
    [
      "atteler",
      0.0125
    ],
    [
      "aider",
      0.0125
    ],
    [
      "secourir",
      0.005
    ],
    [
      "exciter",
      0.005
    ],
    [
      "depanner",
      0.005
    ],
    [
      "acculer",
      0.005
    ],
    [
      "violenter",
      0.005
    ]
  ],
  "spleen": [
    [
      "melancolie",
      0.21
    ],
    [
      "tristesse",
      0.155
    ],
    [
      "ennui",
      0.14
    ],
    [
      "cafard",
      0.1125
    ],
    [
      "neurasthenie",
      0.055
    ],
    [
      "nostalgie",
      0.055
    ],
    [
      "chagrin",
      0.04
    ],
    [
      "hypocondrie",
      0.0275
    ],
    [
      "bourdon",
      0.0275
    ],
    [
      "brumaille",
      0.0125
    ],
    [
      "degout",
      0.0125
    ],
    [
      "depression",
      0.0125
    ]
  ],
  "mode": [
    [
      "maniere",
      0.08
    ],
    [
      "facon",
      0.0475
    ],
    [
      "methode",
      0.0475
    ],
    [
      "vogue",
      0.0375
    ],
    [
      "pratique",
      0.0375
    ],
    [
      "moyen",
      0.0375
    ],
    [
      "modalite",
      0.0375
    ],
    [
      "habitude",
      0.0375
    ],
    [
      "usage",
      0.03
    ],
    [
      "passion",
      0.03
    ],
    [
      "gout",
      0.03
    ],
    [
      "fureur",
      0.03
    ],
    [
      "forme",
      0.03
    ],
    [
      "truc",
      0.0225
    ],
    [
      "style",
      0.0225
    ],
    [
      "moeurs",
      0.0225
    ],
    [
      "guise",
      0.0225
    ],
    [
      "formule",
      0.0225
    ],
    [
      "folie",
      0.0225
    ],
    [
      "fantaisie",
      0.0225
    ],
    [
      "engouement",
      0.0225
    ],
    [
      "convenance",
      0.0225
    ],
    [
      "epidemie",
      0.015
    ],
    [
      "ton",
      0.015
    ],
    [
      "genre",
      0.015
    ],
    [
      "dada",
      0.015
    ],
    [
      "coutume",
      0.015
    ],
    [
      "snobisme",
      0.0075
    ],
    [
      "succes",
      0.0075
    ],
    [
      "toilette",
      0.0075
    ],
    [
      "tradition",
      0.0075
    ],
    [
      "usages",
      0.0075
    ],
    [
      "vague",
      0.0075
    ],
    [
      "vent",
      0.0075
    ],
    [
      "volonte",
      0.0075
    ],
    [
      "qualite",
      0.0075
    ],
    [
      "nouveaute",
      0.0075
    ],
    [
      "actualite",
      0.0075
    ],
    [
      "chic",
      0.0075
    ],
    [
      "couture",
      0.0075
    ],
    [
      "credit",
      0.0075
    ],
    [
      "fashion",
      0.0075
    ],
    [
      "ferveur",
      0.0075
    ],
    [
      "frivolite",
      0.0075
    ],
    [
      "futilite",
      0.0075
    ],
    [
      "vetement",
      0.0075
    ]
  ],
  "compliquer": [
    [
      "embrouiller",
      0.1675
    ],
    [
      "brouiller",
      0.1
    ],
    [
      "emmeler",
      0.1
    ],
    [
      "raffiner",
      0.065
    ],
    [
      "enchevetrer",
      0.065
    ],
    [
      "emberlificoter",
      0.065
    ],
    [
      "embarrasser",
      0.065
    ],
    [
      "obscurcir",
      0.0325
    ],
    [
      "entortiller",
      0.0325
    ],
    [
      "enrichir",
      0.0325
    ],
    [
      "embroussailler",
      0.0325
    ],
    [
      "diversifier",
      0.0325
    ],
    [
      "chinoiser",
      0.0325
    ],
    [
      "appreter",
      0.0325
    ],
    [
      "alambiquer",
      0.0325
    ],
    [
      "aggraver",
      0.0325
    ],
    [
      "quintessencier",
      0.0325
    ]
  ],
  "complique": [
    [
      "embrouiller",
      0.1675
    ],
    [
      "brouiller",
      0.1
    ],
    [
      "emmeler",
      0.1
    ],
    [
      "raffiner",
      0.065
    ],
    [
      "enchevetrer",
      0.065
    ],
    [
      "emberlificoter",
      0.065
    ],
    [
      "embarrasser",
      0.065
    ],
    [
      "obscurcir",
      0.0325
    ],
    [
      "entortiller",
      0.0325
    ],
    [
      "enrichir",
      0.0325
    ],
    [
      "embroussailler",
      0.0325
    ],
    [
      "diversifier",
      0.0325
    ],
    [
      "chinoiser",
      0.0325
    ],
    [
      "appreter",
      0.0325
    ],
    [
      "alambiquer",
      0.0325
    ],
    [
      "aggraver",
      0.0325
    ],
    [
      "quintessencier",
      0.0325
    ]
  ],
  "aurai": [
    [
      "prendre",
      0.0725
    ],
    [
      "tromper",
      0.0675
    ],
    [
      "posseder",
      0.0575
    ],
    [
      "attraper",
      0.0475
    ],
    [
      "rouler",
      0.0475
    ],
    [
      "tenir",
      0.045
    ],
    [
      "obtenir",
      0.03
    ],
    [
      "conquerir",
      0.03
    ],
    [
      "berner",
      0.03
    ],
    [
      "duper",
      0.0275
    ],
    [
      "seduire",
      0.0275
    ],
    [
      "remporter",
      0.0225
    ],
    [
      "occuper",
      0.0225
    ],
    [
      "faire",
      0.0225
    ],
    [
      "disposer",
      0.0225
    ],
    [
      "acquerir",
      0.02
    ],
    [
      "contenir",
      0.02
    ],
    [
      "empaumer",
      0.02
    ],
    [
      "refaire",
      0.02
    ],
    [
      "vaincre",
      0.015
    ],
    [
      "recevoir",
      0.015
    ],
    [
      "presenter",
      0.015
    ],
    [
      "enjoler",
      0.015
    ],
    [
      "detenir",
      0.015
    ],
    [
      "baiser",
      0.015
    ],
    [
      "triompher",
      0.01
    ],
    [
      "tomber",
      0.01
    ],
    [
      "porter",
      0.01
    ],
    [
      "pigeonner",
      0.01
    ],
    [
      "mener",
      0.01
    ],
    [
      "acheter",
      0.01
    ],
    [
      "offrir",
      0.0075
    ],
    [
      "l'emporter",
      0.0075
    ],
    [
      "jouir",
      0.0075
    ],
    [
      "entuber",
      0.0075
    ],
    [
      "empiler",
      0.0075
    ],
    [
      "battre",
      0.0075
    ],
    [
      "recueillir",
      0.0025
    ],
    [
      "ressembler",
      0.0025
    ],
    [
      "ressentir",
      0.0025
    ],
    [
      "rester",
      0.0025
    ],
    [
      "trouver",
      0.0025
    ],
    [
      "tuer",
      0.0025
    ],
    [
      "rappeler",
      0.0025
    ],
    [
      "mesurer",
      0.0025
    ],
    [
      "feinter",
      0.0025
    ],
    [
      "exister",
      0.0025
    ],
    [
      "entourlouper",
      0.0025
    ],
    [
      "emberlificoter",
      0.0025
    ],
    [
      "devoir",
      0.0025
    ],
    [
      "capturer",
      0.0025
    ],
    [
      "beneficier",
      0.0025
    ]
  ],
  "jeunesse": [
    [
      "adolescence",
      0.0925
    ],
    [
      "ardeur",
      0.0925
    ],
    [
      "vivacite",
      0.0925
    ],
    [
      "vigueur",
      0.06
    ],
    [
      "verdeur",
      0.06
    ],
    [
      "juvenilite",
      0.06
    ],
    [
      "fraicheur",
      0.06
    ],
    [
      "jouvence",
      0.0275
    ],
    [
      "nouveaute",
      0.0275
    ],
    [
      "nubilite",
      0.0275
    ],
    [
      "printemps",
      0.0275
    ],
    [
      "tendron",
      0.0275
    ],
    [
      "jeunes",
      0.0275
    ],
    [
      "jeune",
      0.0275
    ],
    [
      "gamine",
      0.0275
    ],
    [
      "fille",
      0.0275
    ],
    [
      "enthousiasme",
      0.0275
    ],
    [
      "vitalite",
      0.0275
    ]
  ],
  "inconditionnel": [
    [
      "absolu",
      0.3325
    ],
    [
      "imperatif",
      0.165
    ],
    [
      "inconditionne",
      0.165
    ],
    [
      "suiveur",
      0.165
    ],
    [
      "systematique",
      0.165
    ]
  ],
  "malaise": [
    [
      "indonesien",
      1.0
    ]
  ],
  "delaisser": [
    [
      "abandonner",
      0.2325
    ],
    [
      "quitter",
      0.11
    ],
    [
      "lacher",
      0.0725
    ],
    [
      "oublier",
      0.0625
    ],
    [
      "negliger",
      0.0625
    ],
    [
      "laisser",
      0.0625
    ],
    [
      "renoncer",
      0.055
    ],
    [
      "s'eloigner",
      0.045
    ],
    [
      "ceder",
      0.035
    ],
    [
      "deserter",
      0.0275
    ],
    [
      "semer",
      0.0175
    ],
    [
      "plaquer",
      0.0175
    ],
    [
      "deguerpir",
      0.0075
    ]
  ],
  "delaisse": [
    [
      "abandonner",
      0.2325
    ],
    [
      "quitter",
      0.11
    ],
    [
      "lacher",
      0.0725
    ],
    [
      "oublier",
      0.0625
    ],
    [
      "negliger",
      0.0625
    ],
    [
      "laisser",
      0.0625
    ],
    [
      "renoncer",
      0.055
    ],
    [
      "s'eloigner",
      0.045
    ],
    [
      "ceder",
      0.035
    ],
    [
      "deserter",
      0.0275
    ],
    [
      "semer",
      0.0175
    ],
    [
      "plaquer",
      0.0175
    ],
    [
      "deguerpir",
      0.0075
    ]
  ],
  "apres": [
    [
      "ensuite",
      0.075
    ],
    [
      "ulterieurement",
      0.075
    ],
    [
      "successivement",
      0.05
    ],
    [
      "subsequemment",
      0.05
    ],
    [
      "derriere",
      0.05
    ],
    [
      "posterieurement",
      0.0225
    ],
    [
      "puis",
      0.0225
    ],
    [
      "suivant",
      0.0225
    ],
    [
      "a",
      0.0225
    ],
    [
      "passe",
      0.0225
    ],
    [
      "consecutivement",
      0.0225
    ],
    [
      "consequemment",
      0.0225
    ],
    [
      "infra",
      0.0225
    ],
    [
      "loin",
      0.0225
    ]
  ],
  "solde": [
    [
      "compte",
      0.0825
    ],
    [
      "remuneration",
      0.0675
    ],
    [
      "retribution",
      0.0675
    ],
    [
      "traitement",
      0.0675
    ],
    [
      "difference",
      0.055
    ],
    [
      "paiement",
      0.055
    ],
    [
      "salaire",
      0.055
    ],
    [
      "paye",
      0.04
    ],
    [
      "paie",
      0.04
    ],
    [
      "liquidation",
      0.04
    ],
    [
      "appointements",
      0.04
    ],
    [
      "recompense",
      0.025
    ],
    [
      "reglement",
      0.025
    ],
    [
      "reste",
      0.025
    ],
    [
      "reliquat",
      0.025
    ],
    [
      "pret",
      0.025
    ],
    [
      "gain",
      0.025
    ],
    [
      "complement",
      0.025
    ],
    [
      "balance",
      0.025
    ],
    [
      "appoint",
      0.025
    ],
    [
      "restant",
      0.0125
    ],
    [
      "rabais",
      0.0125
    ],
    [
      "occasion",
      0.0125
    ],
    [
      "indemnite",
      0.0125
    ],
    [
      "credit",
      0.0125
    ],
    [
      "boom",
      0.0125
    ],
    [
      "bilan",
      0.0125
    ],
    [
      "bazardage",
      0.0125
    ],
    [
      "aubaine",
      0.0125
    ],
    [
      "vente",
      0.0125
    ]
  ],
  "blesser": [
    [
      "dechirer",
      0.0525
    ],
    [
      "offenser",
      0.045
    ],
    [
      "battre",
      0.0375
    ],
    [
      "couper",
      0.0375
    ],
    [
      "entamer",
      0.0375
    ],
    [
      "piquer",
      0.0325
    ],
    [
      "frapper",
      0.0275
    ],
    [
      "choquer",
      0.025
    ],
    [
      "atteindre",
      0.0225
    ],
    [
      "froisser",
      0.0225
    ],
    [
      "vexer",
      0.0225
    ],
    [
      "nuire",
      0.0225
    ],
    [
      "heurter",
      0.0225
    ],
    [
      "casser",
      0.02
    ],
    [
      "meurtrir",
      0.02
    ],
    [
      "taillader",
      0.02
    ],
    [
      "toucher",
      0.0175
    ],
    [
      "maltraiter",
      0.0175
    ],
    [
      "balafrer",
      0.0175
    ],
    [
      "abimer",
      0.015
    ],
    [
      "offusquer",
      0.015
    ],
    [
      "ereinter",
      0.0125
    ],
    [
      "emouvoir",
      0.0125
    ],
    [
      "ecorcher",
      0.0125
    ],
    [
      "outrager",
      0.0125
    ],
    [
      "entailler",
      0.0125
    ],
    [
      "deplaire",
      0.0125
    ],
    [
      "egratigner",
      0.01
    ],
    [
      "rompre",
      0.01
    ],
    [
      "percer",
      0.01
    ],
    [
      "navrer",
      0.01
    ],
    [
      "leser",
      0.01
    ],
    [
      "contrarier",
      0.01
    ],
    [
      "broyer",
      0.01
    ],
    [
      "prejudicier",
      0.0075
    ],
    [
      "tailler",
      0.0075
    ],
    [
      "transpercer",
      0.0075
    ],
    [
      "violer",
      0.0075
    ],
    [
      "echarper",
      0.0075
    ],
    [
      "ecraser",
      0.0075
    ],
    [
      "mutiler",
      0.0075
    ],
    [
      "mordre",
      0.0075
    ],
    [
      "cingler",
      0.0075
    ],
    [
      "desobliger",
      0.0075
    ],
    [
      "estropier",
      0.0075
    ],
    [
      "insulter",
      0.0075
    ],
    [
      "labourer",
      0.0075
    ],
    [
      "souffleter",
      0.005
    ],
    [
      "mortifier",
      0.005
    ],
    [
      "interesser",
      0.005
    ],
    [
      "fouler",
      0.005
    ],
    [
      "compromettre",
      0.005
    ],
    [
      "affecter",
      0.005
    ],
    [
      "irriter",
      0.0025
    ],
    [
      "molester",
      0.0025
    ],
    [
      "transgresser",
      0.0025
    ],
    [
      "eblouir",
      0.0025
    ],
    [
      "erafler",
      0.0025
    ],
    [
      "injurier",
      0.0025
    ],
    [
      "inciser",
      0.0025
    ],
    [
      "arranger",
      0.0025
    ],
    [
      "attiger",
      0.0025
    ],
    [
      "cabosser",
      0.0025
    ],
    [
      "contusionner",
      0.0025
    ],
    [
      "corriger",
      0.0025
    ],
    [
      "enfreindre",
      0.0025
    ],
    [
      "encorner",
      0.0
    ],
    [
      "luxer",
      0.0
    ],
    [
      "poignarder",
      0.0
    ],
    [
      "scandaliser",
      0.0
    ],
    [
      "ulcerer",
      0.0
    ],
    [
      "ecloper",
      0.0
    ],
    [
      "effaroucher",
      0.0
    ],
    [
      "couronner",
      0.0
    ],
    [
      "contrevenir",
      0.0
    ],
    [
      "bruler",
      0.0
    ],
    [
      "assommer",
      0.0
    ],
    [
      "amocher",
      0.0
    ]
  ],
  "blesse": [
    [
      "dechirer",
      0.0525
    ],
    [
      "offenser",
      0.045
    ],
    [
      "battre",
      0.0375
    ],
    [
      "couper",
      0.0375
    ],
    [
      "entamer",
      0.0375
    ],
    [
      "piquer",
      0.0325
    ],
    [
      "frapper",
      0.0275
    ],
    [
      "choquer",
      0.025
    ],
    [
      "atteindre",
      0.0225
    ],
    [
      "froisser",
      0.0225
    ],
    [
      "vexer",
      0.0225
    ],
    [
      "nuire",
      0.0225
    ],
    [
      "heurter",
      0.0225
    ],
    [
      "casser",
      0.02
    ],
    [
      "meurtrir",
      0.02
    ],
    [
      "taillader",
      0.02
    ],
    [
      "toucher",
      0.0175
    ],
    [
      "maltraiter",
      0.0175
    ],
    [
      "balafrer",
      0.0175
    ],
    [
      "abimer",
      0.015
    ],
    [
      "offusquer",
      0.015
    ],
    [
      "ereinter",
      0.0125
    ],
    [
      "emouvoir",
      0.0125
    ],
    [
      "ecorcher",
      0.0125
    ],
    [
      "outrager",
      0.0125
    ],
    [
      "entailler",
      0.0125
    ],
    [
      "deplaire",
      0.0125
    ],
    [
      "egratigner",
      0.01
    ],
    [
      "rompre",
      0.01
    ],
    [
      "percer",
      0.01
    ],
    [
      "navrer",
      0.01
    ],
    [
      "leser",
      0.01
    ],
    [
      "contrarier",
      0.01
    ],
    [
      "broyer",
      0.01
    ],
    [
      "prejudicier",
      0.0075
    ],
    [
      "tailler",
      0.0075
    ],
    [
      "transpercer",
      0.0075
    ],
    [
      "violer",
      0.0075
    ],
    [
      "echarper",
      0.0075
    ],
    [
      "ecraser",
      0.0075
    ],
    [
      "mutiler",
      0.0075
    ],
    [
      "mordre",
      0.0075
    ],
    [
      "cingler",
      0.0075
    ],
    [
      "desobliger",
      0.0075
    ],
    [
      "estropier",
      0.0075
    ],
    [
      "insulter",
      0.0075
    ],
    [
      "labourer",
      0.0075
    ],
    [
      "souffleter",
      0.005
    ],
    [
      "mortifier",
      0.005
    ],
    [
      "interesser",
      0.005
    ],
    [
      "fouler",
      0.005
    ],
    [
      "compromettre",
      0.005
    ],
    [
      "affecter",
      0.005
    ],
    [
      "irriter",
      0.0025
    ],
    [
      "molester",
      0.0025
    ],
    [
      "transgresser",
      0.0025
    ],
    [
      "eblouir",
      0.0025
    ],
    [
      "erafler",
      0.0025
    ],
    [
      "injurier",
      0.0025
    ],
    [
      "inciser",
      0.0025
    ],
    [
      "arranger",
      0.0025
    ],
    [
      "attiger",
      0.0025
    ],
    [
      "cabosser",
      0.0025
    ],
    [
      "contusionner",
      0.0025
    ],
    [
      "corriger",
      0.0025
    ],
    [
      "enfreindre",
      0.0025
    ],
    [
      "encorner",
      0.0
    ],
    [
      "luxer",
      0.0
    ],
    [
      "poignarder",
      0.0
    ],
    [
      "scandaliser",
      0.0
    ],
    [
      "ulcerer",
      0.0
    ],
    [
      "ecloper",
      0.0
    ],
    [
      "effaroucher",
      0.0
    ],
    [
      "couronner",
      0.0
    ],
    [
      "contrevenir",
      0.0
    ],
    [
      "bruler",
      0.0
    ],
    [
      "assommer",
      0.0
    ],
    [
      "amocher",
      0.0
    ]
  ],
  "tromper": [
    [
      "abuser",
      0.1
    ],
    [
      "berner",
      0.0825
    ],
    [
      "duper",
      0.06
    ],
    [
      "rouler",
      0.055
    ],
    [
      "seduire",
      0.045
    ],
    [
      "enjoler",
      0.0425
    ],
    [
      "leurrer",
      0.0325
    ],
    [
      "attraper",
      0.0325
    ],
    [
      "mystifier",
      0.0325
    ],
    [
      "amuser",
      0.025
    ],
    [
      "avoir",
      0.0225
    ],
    [
      "voler",
      0.02
    ],
    [
      "embobiner",
      0.02
    ],
    [
      "refaire",
      0.0175
    ],
    [
      "embabouiner",
      0.015
    ],
    [
      "capter",
      0.015
    ],
    [
      "empaumer",
      0.015
    ],
    [
      "escroquer",
      0.0125
    ],
    [
      "posseder",
      0.0125
    ],
    [
      "flouer",
      0.01
    ],
    [
      "endormir",
      0.01
    ],
    [
      "decevoir",
      0.01
    ],
    [
      "circonvenir",
      0.01
    ],
    [
      "bercer",
      0.01
    ],
    [
      "pigeonner",
      0.01
    ],
    [
      "mentir",
      0.01
    ],
    [
      "jouer",
      0.01
    ],
    [
      "entortiller",
      0.01
    ],
    [
      "empiler",
      0.01
    ],
    [
      "embobeliner",
      0.01
    ],
    [
      "trahir",
      0.005
    ],
    [
      "surprendre",
      0.005
    ],
    [
      "piper",
      0.005
    ],
    [
      "deguiser",
      0.005
    ],
    [
      "carotter",
      0.005
    ],
    [
      "tricher",
      0.005
    ],
    [
      "frauder",
      0.005
    ],
    [
      "flatter",
      0.005
    ],
    [
      "exploiter",
      0.005
    ],
    [
      "envelopper",
      0.005
    ],
    [
      "entuber",
      0.005
    ],
    [
      "baiser",
      0.005
    ],
    [
      "bluffer",
      0.005
    ],
    [
      "cocufier",
      0.005
    ],
    [
      "dissimuler",
      0.005
    ],
    [
      "emberlificoter",
      0.005
    ],
    [
      "eblouir",
      0.0025
    ],
    [
      "frustrer",
      0.0025
    ],
    [
      "feindre",
      0.0025
    ],
    [
      "estamper",
      0.0025
    ],
    [
      "enquinauder",
      0.0025
    ],
    [
      "blouser",
      0.0025
    ],
    [
      "entoler",
      0.0025
    ],
    [
      "feinter",
      0.0025
    ],
    [
      "gonfler",
      0.0025
    ],
    [
      "jobarder",
      0.0025
    ],
    [
      "occuper",
      0.0025
    ],
    [
      "promener",
      0.0025
    ],
    [
      "truquer",
      0.0025
    ],
    [
      "entourlouper",
      0.0025
    ],
    [
      "enfiler",
      0.0025
    ],
    [
      "encorner",
      0.0025
    ],
    [
      "attirer",
      0.0025
    ],
    [
      "balancer",
      0.0025
    ],
    [
      "charrier",
      0.0025
    ],
    [
      "coiffer",
      0.0025
    ],
    [
      "consoler",
      0.0025
    ],
    [
      "couillonner",
      0.0025
    ],
    [
      "emmitonner",
      0.0025
    ],
    [
      "imposer",
      0.0
    ],
    [
      "lanterner",
      0.0
    ],
    [
      "renarder",
      0.0
    ],
    [
      "repasser",
      0.0
    ],
    [
      "resquiller",
      0.0
    ],
    [
      "echauder",
      0.0
    ],
    [
      "egarer",
      0.0
    ],
    [
      "gourer",
      0.0
    ],
    [
      "apaiser",
      0.0
    ],
    [
      "croire",
      0.0
    ],
    [
      "dejouer",
      0.0
    ],
    [
      "depiter",
      0.0
    ],
    [
      "engeigner",
      0.0
    ],
    [
      "etriller",
      0.0
    ]
  ],
  "trompe": [
    [
      "avertisseur",
      0.1525
    ],
    [
      "corne",
      0.1525
    ],
    [
      "cornet",
      0.1525
    ],
    [
      "sucoir",
      0.075
    ],
    [
      "stylet",
      0.075
    ],
    [
      "nez",
      0.075
    ],
    [
      "klaxon",
      0.075
    ],
    [
      "cor",
      0.075
    ],
    [
      "bouche",
      0.075
    ],
    [
      "trompette",
      0.075
    ]
  ],
  "abord": [
    [
      "accueil",
      0.075
    ],
    [
      "approche",
      0.075
    ],
    [
      "entree",
      0.075
    ],
    [
      "exterieur",
      0.075
    ],
    [
      "reception",
      0.05
    ],
    [
      "maintien",
      0.05
    ],
    [
      "environs",
      0.05
    ],
    [
      "entour",
      0.05
    ],
    [
      "dehors",
      0.05
    ],
    [
      "comportement",
      0.05
    ],
    [
      "caractere",
      0.05
    ],
    [
      "aspect",
      0.05
    ],
    [
      "apparence",
      0.05
    ],
    [
      "alentours",
      0.05
    ],
    [
      "acces",
      0.05
    ],
    [
      "environ",
      0.025
    ],
    [
      "chere",
      0.025
    ],
    [
      "bord",
      0.025
    ],
    [
      "arrivage",
      0.025
    ],
    [
      "accostage",
      0.025
    ],
    [
      "frequentation",
      0.025
    ]
  ],
  "ensuite": [
    [
      "apres",
      0.25
    ],
    [
      "puis",
      0.0825
    ],
    [
      "subsequemment",
      0.0825
    ],
    [
      "ulterieurement",
      0.0825
    ]
  ],
  "fele": [
    [
      "fendiller",
      0.285
    ],
    [
      "fendre",
      0.285
    ],
    [
      "casser",
      0.1425
    ],
    [
      "fissurer",
      0.1425
    ],
    [
      "etoiler",
      0.1425
    ]
  ],
  "feler": [
    [
      "fendiller",
      0.285
    ],
    [
      "fendre",
      0.285
    ],
    [
      "casser",
      0.1425
    ],
    [
      "fissurer",
      0.1425
    ],
    [
      "etoiler",
      0.1425
    ]
  ],
  "solo": [],
  "pote": [
    [
      "ami",
      0.1525
    ],
    [
      "camarade",
      0.1525
    ],
    [
      "compagnon",
      0.1525
    ],
    [
      "copain",
      0.1525
    ],
    [
      "enfle",
      0.075
    ],
    [
      "frere",
      0.075
    ],
    [
      "gourd",
      0.075
    ],
    [
      "gros",
      0.075
    ],
    [
      "poteau",
      0.075
    ]
  ],
  "consommer": [
    [
      "user",
      0.0925
    ],
    [
      "consumer",
      0.0725
    ],
    [
      "manger",
      0.0725
    ],
    [
      "accomplir",
      0.06
    ],
    [
      "achever",
      0.05
    ],
    [
      "prendre",
      0.04
    ],
    [
      "finir",
      0.04
    ],
    [
      "employer",
      0.04
    ],
    [
      "depenser",
      0.04
    ],
    [
      "couronner",
      0.04
    ],
    [
      "absorber",
      0.04
    ],
    [
      "epuiser",
      0.03
    ],
    [
      "terminer",
      0.03
    ],
    [
      "realiser",
      0.03
    ],
    [
      "pratiquer",
      0.03
    ],
    [
      "parachever",
      0.03
    ],
    [
      "commettre",
      0.03
    ],
    [
      "bruler",
      0.03
    ],
    [
      "vivre",
      0.02
    ],
    [
      "utiliser",
      0.02
    ],
    [
      "parfaire",
      0.02
    ],
    [
      "detruire",
      0.02
    ],
    [
      "boire",
      0.02
    ],
    [
      "boucler",
      0.01
    ],
    [
      "bouffer",
      0.01
    ],
    [
      "completer",
      0.01
    ],
    [
      "perpetrer",
      0.01
    ],
    [
      "taper",
      0.01
    ]
  ],
  "choix": [
    [
      "selection",
      0.14
    ],
    [
      "elite",
      0.075
    ],
    [
      "gratin",
      0.0525
    ],
    [
      "election",
      0.0525
    ],
    [
      "option",
      0.0425
    ],
    [
      "preference",
      0.03
    ],
    [
      "collection",
      0.03
    ],
    [
      "assortiment",
      0.03
    ],
    [
      "agrement",
      0.03
    ],
    [
      "eclectisme",
      0.02
    ],
    [
      "volonte",
      0.02
    ],
    [
      "recueil",
      0.02
    ],
    [
      "liberte",
      0.02
    ],
    [
      "fleur",
      0.02
    ],
    [
      "determination",
      0.02
    ],
    [
      "designation",
      0.02
    ],
    [
      "anthologie",
      0.02
    ],
    [
      "cooptation",
      0.02
    ],
    [
      "creme",
      0.02
    ],
    [
      "decision",
      0.02
    ],
    [
      "nomination",
      0.01
    ],
    [
      "parti",
      0.01
    ],
    [
      "prix",
      0.01
    ],
    [
      "predilection",
      0.01
    ],
    [
      "qualite",
      0.01
    ],
    [
      "resolution",
      0.01
    ],
    [
      "reunion",
      0.01
    ],
    [
      "tri",
      0.01
    ],
    [
      "triage",
      0.01
    ],
    [
      "eventail",
      0.01
    ],
    [
      "jeu",
      0.01
    ],
    [
      "acte",
      0.01
    ],
    [
      "adoption",
      0.01
    ],
    [
      "alternative",
      0.01
    ],
    [
      "aristocratie",
      0.01
    ],
    [
      "carte",
      0.01
    ],
    [
      "convenance",
      0.01
    ],
    [
      "d'election",
      0.01
    ],
    [
      "dilemme",
      0.01
    ],
    [
      "florilege",
      0.01
    ],
    [
      "acceptation",
      0.01
    ]
  ],
  "vouler": [],
  "camion": [
    [
      "chariot",
      0.125
    ],
    [
      "fourgon",
      0.125
    ],
    [
      "voiture",
      0.125
    ],
    [
      "automobile",
      0.0825
    ],
    [
      "fardier",
      0.0825
    ],
    [
      "vehicule",
      0.04
    ],
    [
      "citerne",
      0.04
    ],
    [
      "camionnette",
      0.04
    ],
    [
      "betaillere",
      0.04
    ],
    [
      "benne",
      0.04
    ],
    [
      "bahut",
      0.04
    ],
    [
      "epingle",
      0.04
    ]
  ],
  "offre": [
    [
      "promesse",
      0.15
    ],
    [
      "proposition",
      0.15
    ],
    [
      "avance",
      0.1
    ],
    [
      "surenchere",
      0.1
    ],
    [
      "soumission",
      0.05
    ],
    [
      "sacrifice",
      0.05
    ],
    [
      "pollicitation",
      0.05
    ],
    [
      "ouverture",
      0.05
    ],
    [
      "offrande",
      0.05
    ],
    [
      "oblation",
      0.05
    ],
    [
      "facilite",
      0.05
    ],
    [
      "enchere",
      0.05
    ],
    [
      "demarche",
      0.05
    ],
    [
      "transaction",
      0.05
    ]
  ],
  "unique": [
    [
      "extraordinaire",
      0.1225
    ],
    [
      "incomparable",
      0.07
    ],
    [
      "parfait",
      0.0525
    ],
    [
      "singulier",
      0.0525
    ],
    [
      "bizarre",
      0.04
    ],
    [
      "extravagant",
      0.04
    ],
    [
      "original",
      0.035
    ],
    [
      "incroyable",
      0.035
    ],
    [
      "exceptionnel",
      0.035
    ],
    [
      "beau",
      0.035
    ],
    [
      "un",
      0.0275
    ],
    [
      "superieur",
      0.0275
    ],
    [
      "seul",
      0.0275
    ],
    [
      "rare",
      0.0275
    ],
    [
      "inoui",
      0.0275
    ],
    [
      "curieux",
      0.0275
    ],
    [
      "simple",
      0.0225
    ],
    [
      "special",
      0.0225
    ],
    [
      "stupefiant",
      0.0225
    ],
    [
      "uniforme",
      0.0175
    ],
    [
      "transcendant",
      0.0175
    ],
    [
      "inegalable",
      0.0175
    ],
    [
      "inimitable",
      0.0175
    ],
    [
      "individuel",
      0.0175
    ],
    [
      "abracadabrant",
      0.0175
    ],
    [
      "isole",
      0.01
    ],
    [
      "ideal",
      0.01
    ],
    [
      "exclusif",
      0.01
    ],
    [
      "excellent",
      0.01
    ],
    [
      "d'exception",
      0.01
    ],
    [
      "phenomenal",
      0.005
    ],
    [
      "memorable",
      0.005
    ],
    [
      "irremplacable",
      0.005
    ],
    [
      "inegale",
      0.005
    ],
    [
      "introuvable",
      0.005
    ],
    [
      "identique",
      0.005
    ],
    [
      "constant",
      0.005
    ],
    [
      "univoque",
      0.005
    ]
  ],
  "deja": [
    [
      "auparavant",
      0.3325
    ],
    [
      "avant",
      0.3325
    ],
    [
      "ja",
      0.3325
    ]
  ],
  "danger": [
    [
      "difficulte",
      0.12
    ],
    [
      "peril",
      0.12
    ],
    [
      "traverse",
      0.065
    ],
    [
      "embarras",
      0.0525
    ],
    [
      "ecueil",
      0.04
    ],
    [
      "risque",
      0.04
    ],
    [
      "piege",
      0.04
    ],
    [
      "inconvenient",
      0.04
    ],
    [
      "detresse",
      0.04
    ],
    [
      "crise",
      0.04
    ],
    [
      "alea",
      0.04
    ],
    [
      "alarme",
      0.04
    ],
    [
      "epreuve",
      0.025
    ],
    [
      "impasse",
      0.025
    ],
    [
      "embuche",
      0.025
    ],
    [
      "alerte",
      0.025
    ],
    [
      "S.O.S.",
      0.025
    ],
    [
      "tirage",
      0.01
    ],
    [
      "precipice",
      0.01
    ],
    [
      "perdition",
      0.01
    ],
    [
      "menace",
      0.01
    ],
    [
      "insecurite",
      0.01
    ],
    [
      "inquietude",
      0.01
    ],
    [
      "imprudence",
      0.01
    ],
    [
      "hasard",
      0.01
    ],
    [
      "guepier",
      0.01
    ],
    [
      "delicatesse",
      0.01
    ],
    [
      "affaire",
      0.01
    ],
    [
      "abime",
      0.01
    ],
    [
      "volcan",
      0.01
    ]
  ],
  "ticket": [
    [
      "billet",
      0.3325
    ],
    [
      "bon",
      0.0825
    ],
    [
      "bulletin",
      0.0825
    ],
    [
      "cachet",
      0.0825
    ],
    [
      "carte",
      0.0825
    ],
    [
      "coupon",
      0.0825
    ],
    [
      "touche",
      0.0825
    ]
  ],
  "venger": [
    [
      "corriger",
      0.1825
    ],
    [
      "punir",
      0.135
    ],
    [
      "chatier",
      0.09
    ],
    [
      "redresser",
      0.09
    ],
    [
      "reparer",
      0.09
    ],
    [
      "sevir",
      0.09
    ],
    [
      "reprimer",
      0.045
    ],
    [
      "riposter",
      0.045
    ],
    [
      "laver",
      0.045
    ],
    [
      "frapper",
      0.045
    ],
    [
      "compenser",
      0.045
    ]
  ],
  "mets": [
    [
      "cuisine",
      0.175
    ],
    [
      "repas",
      0.14
    ],
    [
      "nourriture",
      0.07
    ],
    [
      "ragout",
      0.07
    ],
    [
      "soupe",
      0.07
    ],
    [
      "rata",
      0.0525
    ],
    [
      "plat",
      0.0525
    ],
    [
      "fricot",
      0.0525
    ],
    [
      "ratatouille",
      0.0325
    ],
    [
      "menu",
      0.0325
    ],
    [
      "manger",
      0.0325
    ],
    [
      "chere",
      0.0325
    ],
    [
      "brouet",
      0.0325
    ],
    [
      "alimentation",
      0.0325
    ],
    [
      "aliment",
      0.015
    ],
    [
      "frichti",
      0.015
    ],
    [
      "galimafree",
      0.015
    ],
    [
      "morceau",
      0.015
    ],
    [
      "specialite",
      0.015
    ]
  ],
  "cage": [
    [
      "boite",
      0.085
    ],
    [
      "abri",
      0.065
    ],
    [
      "case",
      0.065
    ],
    [
      "chaine",
      0.065
    ],
    [
      "lien",
      0.065
    ],
    [
      "prison",
      0.065
    ],
    [
      "niche",
      0.0425
    ],
    [
      "loge",
      0.0425
    ],
    [
      "fil",
      0.0425
    ],
    [
      "cavite",
      0.0425
    ],
    [
      "menagerie",
      0.02
    ],
    [
      "mesangette",
      0.02
    ],
    [
      "nichoir",
      0.02
    ],
    [
      "oisellerie",
      0.02
    ],
    [
      "servitude",
      0.02
    ],
    [
      "taule",
      0.02
    ],
    [
      "tournette",
      0.02
    ],
    [
      "voliere",
      0.02
    ],
    [
      "mue",
      0.02
    ],
    [
      "logette",
      0.02
    ],
    [
      "boitier",
      0.02
    ],
    [
      "but",
      0.02
    ],
    [
      "cagibi",
      0.02
    ],
    [
      "chanterelle",
      0.02
    ],
    [
      "clapier",
      0.02
    ],
    [
      "enceinte",
      0.02
    ],
    [
      "geole",
      0.02
    ],
    [
      "lapiniere",
      0.02
    ],
    [
      "epinette",
      0.02
    ]
  ],
  "exercice": [
    [
      "travail",
      0.105
    ],
    [
      "entrainement",
      0.0875
    ],
    [
      "application",
      0.07
    ],
    [
      "preparation",
      0.07
    ],
    [
      "usage",
      0.07
    ],
    [
      "mouvement",
      0.05
    ],
    [
      "gymnastique",
      0.05
    ],
    [
      "activite",
      0.05
    ],
    [
      "etude",
      0.035
    ],
    [
      "education",
      0.035
    ],
    [
      "pratique",
      0.035
    ],
    [
      "peine",
      0.035
    ],
    [
      "emploi",
      0.035
    ],
    [
      "devoir",
      0.035
    ],
    [
      "composition",
      0.035
    ],
    [
      "apprentissage",
      0.035
    ],
    [
      "vocalise",
      0.015
    ],
    [
      "visite",
      0.015
    ],
    [
      "utilisation",
      0.015
    ],
    [
      "tourment",
      0.015
    ],
    [
      "sport",
      0.015
    ],
    [
      "manoeuvre",
      0.015
    ],
    [
      "instruction",
      0.015
    ],
    [
      "evolution",
      0.015
    ]
  ],
  "fillette": [
    [
      "enfant",
      0.2
    ],
    [
      "fille",
      0.2
    ],
    [
      "bouteille",
      0.1
    ],
    [
      "demoiselle",
      0.1
    ],
    [
      "galopin",
      0.1
    ],
    [
      "pinte",
      0.1
    ],
    [
      "tendron",
      0.1
    ]
  ],
  "fleche": [
    [
      "baliser",
      1.0
    ]
  ],
  "vibrer": [
    [
      "trembler",
      0.2175
    ],
    [
      "fremir",
      0.1725
    ],
    [
      "frissonner",
      0.085
    ],
    [
      "palpiter",
      0.085
    ],
    [
      "tressaillir",
      0.085
    ],
    [
      "tremuler",
      0.085
    ],
    [
      "trepider",
      0.0425
    ],
    [
      "resonner",
      0.0425
    ],
    [
      "retentir",
      0.0425
    ],
    [
      "pervibrer",
      0.0425
    ],
    [
      "gresiller",
      0.0425
    ],
    [
      "vrombir",
      0.0425
    ]
  ],
  "frappe": [
    [
      "battre",
      0.0875
    ],
    [
      "toucher",
      0.0375
    ],
    [
      "heurter",
      0.035
    ],
    [
      "atteindre",
      0.03
    ],
    [
      "emouvoir",
      0.03
    ],
    [
      "bouleverser",
      0.0275
    ],
    [
      "blesser",
      0.025
    ],
    [
      "impressionner",
      0.0225
    ],
    [
      "troubler",
      0.0225
    ],
    [
      "saisir",
      0.02
    ],
    [
      "taper",
      0.0175
    ],
    [
      "secouer",
      0.0175
    ],
    [
      "maltraiter",
      0.0175
    ],
    [
      "donner",
      0.0175
    ],
    [
      "cogner",
      0.0175
    ],
    [
      "affecter",
      0.0175
    ],
    [
      "porter",
      0.015
    ],
    [
      "corriger",
      0.015
    ],
    [
      "attaquer",
      0.015
    ],
    [
      "chatier",
      0.0125
    ],
    [
      "etonner",
      0.0125
    ],
    [
      "rosser",
      0.01
    ],
    [
      "punir",
      0.01
    ],
    [
      "marquer",
      0.01
    ],
    [
      "brutaliser",
      0.01
    ],
    [
      "attacher",
      0.01
    ],
    [
      "eblouir",
      0.01
    ],
    [
      "transpercer",
      0.01
    ],
    [
      "retourner",
      0.01
    ],
    [
      "remuer",
      0.01
    ],
    [
      "meurtrir",
      0.01
    ],
    [
      "imposer",
      0.01
    ],
    [
      "choquer",
      0.01
    ],
    [
      "charger",
      0.01
    ],
    [
      "captiver",
      0.01
    ],
    [
      "appliquer",
      0.01
    ],
    [
      "affliger",
      0.01
    ],
    [
      "malmener",
      0.0075
    ],
    [
      "surprendre",
      0.0075
    ],
    [
      "tambouriner",
      0.0075
    ],
    [
      "tamponner",
      0.0075
    ],
    [
      "fustiger",
      0.0075
    ],
    [
      "fesser",
      0.0075
    ],
    [
      "condamner",
      0.0075
    ],
    [
      "attraper",
      0.0075
    ],
    [
      "assommer",
      0.0075
    ],
    [
      "abattre",
      0.0075
    ],
    [
      "molester",
      0.005
    ],
    [
      "produire",
      0.005
    ],
    [
      "rudoyer",
      0.005
    ],
    [
      "sonner",
      0.005
    ],
    [
      "sevir",
      0.005
    ],
    [
      "grever",
      0.005
    ],
    [
      "gratifier",
      0.005
    ],
    [
      "glacer",
      0.005
    ],
    [
      "administrer",
      0.005
    ],
    [
      "assassiner",
      0.005
    ],
    [
      "cingler",
      0.005
    ],
    [
      "empoigner",
      0.005
    ],
    [
      "foudroyer",
      0.005
    ],
    [
      "fouetter",
      0.005
    ],
    [
      "imprimer",
      0.0025
    ],
    [
      "marteler",
      0.0025
    ],
    [
      "pilonner",
      0.0025
    ],
    [
      "poignarder",
      0.0025
    ],
    [
      "poinconner",
      0.0025
    ],
    [
      "retenir",
      0.0025
    ],
    [
      "frotter",
      0.0025
    ],
    [
      "cribler",
      0.0025
    ],
    [
      "commotionner",
      0.0025
    ],
    [
      "alourdir",
      0.0025
    ],
    [
      "appesantir",
      0.0025
    ],
    [
      "assujettir",
      0.0025
    ],
    [
      "attirer",
      0.0025
    ],
    [
      "briller",
      0.0025
    ],
    [
      "claquer",
      0.0025
    ],
    [
      "percuter",
      0.0
    ],
    [
      "pianoter",
      0.0
    ],
    [
      "refroidir",
      0.0
    ],
    [
      "retentir",
      0.0
    ],
    [
      "revolutionner",
      0.0
    ],
    [
      "s'abattre",
      0.0
    ],
    [
      "tapoter",
      0.0
    ],
    [
      "testonner",
      0.0
    ],
    [
      "toquer",
      0.0
    ],
    [
      "venger",
      0.0
    ],
    [
      "epousseter",
      0.0
    ],
    [
      "eprouver",
      0.0
    ],
    [
      "parler",
      0.0
    ],
    [
      "lyncher",
      0.0
    ],
    [
      "attrister",
      0.0
    ],
    [
      "bourrader",
      0.0
    ],
    [
      "copter",
      0.0
    ],
    [
      "crepiter",
      0.0
    ],
    [
      "dauber",
      0.0
    ],
    [
      "embrocher",
      0.0
    ],
    [
      "empreindre",
      0.0
    ],
    [
      "frigorifier",
      0.0
    ],
    [
      "geler",
      0.0
    ],
    [
      "houssiner",
      0.0
    ],
    [
      "assener",
      0.0
    ]
  ],
  "frapper": [
    [
      "battre",
      0.0875
    ],
    [
      "toucher",
      0.0375
    ],
    [
      "heurter",
      0.035
    ],
    [
      "atteindre",
      0.03
    ],
    [
      "emouvoir",
      0.03
    ],
    [
      "bouleverser",
      0.0275
    ],
    [
      "blesser",
      0.025
    ],
    [
      "impressionner",
      0.0225
    ],
    [
      "troubler",
      0.0225
    ],
    [
      "saisir",
      0.02
    ],
    [
      "taper",
      0.0175
    ],
    [
      "secouer",
      0.0175
    ],
    [
      "maltraiter",
      0.0175
    ],
    [
      "donner",
      0.0175
    ],
    [
      "cogner",
      0.0175
    ],
    [
      "affecter",
      0.0175
    ],
    [
      "porter",
      0.015
    ],
    [
      "corriger",
      0.015
    ],
    [
      "attaquer",
      0.015
    ],
    [
      "chatier",
      0.0125
    ],
    [
      "etonner",
      0.0125
    ],
    [
      "rosser",
      0.01
    ],
    [
      "punir",
      0.01
    ],
    [
      "marquer",
      0.01
    ],
    [
      "brutaliser",
      0.01
    ],
    [
      "attacher",
      0.01
    ],
    [
      "eblouir",
      0.01
    ],
    [
      "transpercer",
      0.01
    ],
    [
      "retourner",
      0.01
    ],
    [
      "remuer",
      0.01
    ],
    [
      "meurtrir",
      0.01
    ],
    [
      "imposer",
      0.01
    ],
    [
      "choquer",
      0.01
    ],
    [
      "charger",
      0.01
    ],
    [
      "captiver",
      0.01
    ],
    [
      "appliquer",
      0.01
    ],
    [
      "affliger",
      0.01
    ],
    [
      "malmener",
      0.0075
    ],
    [
      "surprendre",
      0.0075
    ],
    [
      "tambouriner",
      0.0075
    ],
    [
      "tamponner",
      0.0075
    ],
    [
      "fustiger",
      0.0075
    ],
    [
      "fesser",
      0.0075
    ],
    [
      "condamner",
      0.0075
    ],
    [
      "attraper",
      0.0075
    ],
    [
      "assommer",
      0.0075
    ],
    [
      "abattre",
      0.0075
    ],
    [
      "molester",
      0.005
    ],
    [
      "produire",
      0.005
    ],
    [
      "rudoyer",
      0.005
    ],
    [
      "sonner",
      0.005
    ],
    [
      "sevir",
      0.005
    ],
    [
      "grever",
      0.005
    ],
    [
      "gratifier",
      0.005
    ],
    [
      "glacer",
      0.005
    ],
    [
      "administrer",
      0.005
    ],
    [
      "assassiner",
      0.005
    ],
    [
      "cingler",
      0.005
    ],
    [
      "empoigner",
      0.005
    ],
    [
      "foudroyer",
      0.005
    ],
    [
      "fouetter",
      0.005
    ],
    [
      "imprimer",
      0.0025
    ],
    [
      "marteler",
      0.0025
    ],
    [
      "pilonner",
      0.0025
    ],
    [
      "poignarder",
      0.0025
    ],
    [
      "poinconner",
      0.0025
    ],
    [
      "retenir",
      0.0025
    ],
    [
      "frotter",
      0.0025
    ],
    [
      "cribler",
      0.0025
    ],
    [
      "commotionner",
      0.0025
    ],
    [
      "alourdir",
      0.0025
    ],
    [
      "appesantir",
      0.0025
    ],
    [
      "assujettir",
      0.0025
    ],
    [
      "attirer",
      0.0025
    ],
    [
      "briller",
      0.0025
    ],
    [
      "claquer",
      0.0025
    ],
    [
      "percuter",
      0.0
    ],
    [
      "pianoter",
      0.0
    ],
    [
      "refroidir",
      0.0
    ],
    [
      "retentir",
      0.0
    ],
    [
      "revolutionner",
      0.0
    ],
    [
      "s'abattre",
      0.0
    ],
    [
      "tapoter",
      0.0
    ],
    [
      "testonner",
      0.0
    ],
    [
      "toquer",
      0.0
    ],
    [
      "venger",
      0.0
    ],
    [
      "epousseter",
      0.0
    ],
    [
      "eprouver",
      0.0
    ],
    [
      "parler",
      0.0
    ],
    [
      "lyncher",
      0.0
    ],
    [
      "attrister",
      0.0
    ],
    [
      "bourrader",
      0.0
    ],
    [
      "copter",
      0.0
    ],
    [
      "crepiter",
      0.0
    ],
    [
      "dauber",
      0.0
    ],
    [
      "embrocher",
      0.0
    ],
    [
      "empreindre",
      0.0
    ],
    [
      "frigorifier",
      0.0
    ],
    [
      "geler",
      0.0
    ],
    [
      "houssiner",
      0.0
    ],
    [
      "assener",
      0.0
    ]
  ],
  "equilibrer": [
    [
      "compenser",
      0.18
    ],
    [
      "balancer",
      0.09
    ],
    [
      "contrebalancer",
      0.09
    ],
    [
      "egaler",
      0.06
    ],
    [
      "neutraliser",
      0.06
    ],
    [
      "corriger",
      0.06
    ],
    [
      "contrepeser",
      0.06
    ],
    [
      "assainir",
      0.06
    ],
    [
      "egaliser",
      0.03
    ],
    [
      "stabiliser",
      0.03
    ],
    [
      "repartir",
      0.03
    ],
    [
      "ponderer",
      0.03
    ],
    [
      "normaliser",
      0.03
    ],
    [
      "harmoniser",
      0.03
    ],
    [
      "charpenter",
      0.03
    ],
    [
      "boucler",
      0.03
    ],
    [
      "adapter",
      0.03
    ],
    [
      "accorder",
      0.03
    ],
    [
      "equivaloir",
      0.03
    ]
  ],
  "equilibre": [
    [
      "harmonie",
      0.1
    ],
    [
      "ponderation",
      0.07
    ],
    [
      "accord",
      0.06
    ],
    [
      "calme",
      0.05
    ],
    [
      "ordre",
      0.05
    ],
    [
      "tranquillite",
      0.0375
    ],
    [
      "proportion",
      0.0375
    ],
    [
      "paix",
      0.0375
    ],
    [
      "mesure",
      0.0375
    ],
    [
      "balancement",
      0.0375
    ],
    [
      "aplomb",
      0.0375
    ],
    [
      "egalite",
      0.03
    ],
    [
      "symetrie",
      0.03
    ],
    [
      "stabilite",
      0.03
    ],
    [
      "position",
      0.03
    ],
    [
      "compensation",
      0.03
    ],
    [
      "combinaison",
      0.03
    ],
    [
      "assiette",
      0.03
    ],
    [
      "temperament",
      0.0175
    ],
    [
      "serenite",
      0.0175
    ],
    [
      "solidite",
      0.0175
    ],
    [
      "eurythmie",
      0.0175
    ],
    [
      "plenitude",
      0.0075
    ],
    [
      "indifference",
      0.0075
    ],
    [
      "forme",
      0.0075
    ],
    [
      "entrain",
      0.0075
    ],
    [
      "correspondance",
      0.0075
    ],
    [
      "contrepoids",
      0.0075
    ],
    [
      "balance",
      0.0075
    ],
    [
      "balance",
      0.0075
    ],
    [
      "attitude",
      0.0075
    ],
    [
      "acrobatie",
      0.0075
    ],
    [
      "sante",
      0.0075
    ]
  ],
  "vainqueur": [
    [
      "conquerant",
      0.15
    ],
    [
      "gagnant",
      0.1
    ],
    [
      "suffisant",
      0.1
    ],
    [
      "triomphateur",
      0.1
    ],
    [
      "victorieux",
      0.1
    ],
    [
      "satisfait",
      0.05
    ],
    [
      "pretentieux",
      0.05
    ],
    [
      "laureat",
      0.05
    ],
    [
      "gagneur",
      0.05
    ],
    [
      "dompteur",
      0.05
    ],
    [
      "dominateur",
      0.05
    ],
    [
      "champion",
      0.05
    ],
    [
      "captivant",
      0.05
    ],
    [
      "triomphant",
      0.05
    ]
  ],
  "femmelette": [
    [
      "femme",
      0.5
    ],
    [
      "mou",
      0.5
    ]
  ],
  "regime": [
    [
      "constitution",
      0.1225
    ],
    [
      "forme",
      0.0825
    ],
    [
      "gouvernement",
      0.0825
    ],
    [
      "organisation",
      0.06
    ],
    [
      "systeme",
      0.06
    ],
    [
      "etat",
      0.04
    ],
    [
      "traitement",
      0.04
    ],
    [
      "structure",
      0.04
    ],
    [
      "regle",
      0.04
    ],
    [
      "remede",
      0.04
    ],
    [
      "diete",
      0.04
    ],
    [
      "direction",
      0.04
    ],
    [
      "conduite",
      0.04
    ],
    [
      "administration",
      0.04
    ],
    [
      "therapeutique",
      0.0175
    ],
    [
      "temps",
      0.0175
    ],
    [
      "pouvoir",
      0.0175
    ],
    [
      "jeune",
      0.0175
    ],
    [
      "institutions",
      0.0175
    ],
    [
      "hygiene",
      0.0175
    ],
    [
      "debit",
      0.0175
    ],
    [
      "cure",
      0.0175
    ],
    [
      "climat",
      0.0175
    ],
    [
      "alimentation",
      0.0175
    ],
    [
      "vitesse",
      0.0175
    ]
  ],
  "gym": [],
  "flanquer": [
    [
      "ficher",
      0.1525
    ],
    [
      "appliquer",
      0.085
    ],
    [
      "foutre",
      0.0775
    ],
    [
      "jeter",
      0.065
    ],
    [
      "envoyer",
      0.0575
    ],
    [
      "placer",
      0.0575
    ],
    [
      "mettre",
      0.05
    ],
    [
      "lancer",
      0.05
    ],
    [
      "coller",
      0.05
    ],
    [
      "adresser",
      0.05
    ],
    [
      "poser",
      0.035
    ],
    [
      "allonger",
      0.0275
    ],
    [
      "fourrer",
      0.0275
    ],
    [
      "couvrir",
      0.02
    ],
    [
      "balancer",
      0.02
    ],
    [
      "suivre",
      0.0125
    ],
    [
      "proteger",
      0.0125
    ],
    [
      "filer",
      0.0125
    ],
    [
      "escorter",
      0.0125
    ],
    [
      "encadrer",
      0.0125
    ],
    [
      "decocher",
      0.0125
    ],
    [
      "accompagner",
      0.0125
    ],
    [
      "enserrer",
      0.005
    ],
    [
      "defendre",
      0.005
    ],
    [
      "communiquer",
      0.005
    ],
    [
      "camper",
      0.005
    ],
    [
      "border",
      0.005
    ],
    [
      "bazarder",
      0.005
    ],
    [
      "administrer",
      0.005
    ],
    [
      "renforcer",
      0.005
    ]
  ],
  "foie": [],
  "violer": [
    [
      "enfreindre",
      0.0925
    ],
    [
      "transgresser",
      0.08
    ],
    [
      "contrevenir",
      0.07
    ],
    [
      "blesser",
      0.045
    ],
    [
      "manquer",
      0.045
    ],
    [
      "passer",
      0.045
    ],
    [
      "trahir",
      0.035
    ],
    [
      "souiller",
      0.035
    ],
    [
      "forcer",
      0.035
    ],
    [
      "fausser",
      0.035
    ],
    [
      "deroger",
      0.035
    ],
    [
      "violenter",
      0.0225
    ],
    [
      "vendre",
      0.0225
    ],
    [
      "tourner",
      0.0225
    ],
    [
      "penetrer",
      0.0225
    ],
    [
      "pecher",
      0.0225
    ],
    [
      "prostituer",
      0.0225
    ],
    [
      "profaner",
      0.0225
    ],
    [
      "abuser",
      0.0225
    ],
    [
      "contrarier",
      0.0225
    ],
    [
      "franchir",
      0.0225
    ],
    [
      "mepriser",
      0.0225
    ],
    [
      "nuire",
      0.0225
    ],
    [
      "polluer",
      0.0225
    ],
    [
      "outrager",
      0.01
    ],
    [
      "desobeir",
      0.01
    ],
    [
      "deflorer",
      0.01
    ],
    [
      "braver",
      0.01
    ],
    [
      "apostasier",
      0.01
    ],
    [
      "abjurer",
      0.01
    ],
    [
      "abandonner",
      0.01
    ],
    [
      "vicier",
      0.01
    ]
  ],
  "violent": [
    [
      "vif",
      0.0825
    ],
    [
      "dur",
      0.0375
    ],
    [
      "excessif",
      0.0325
    ],
    [
      "fort",
      0.0325
    ],
    [
      "fou",
      0.0325
    ],
    [
      "frenetique",
      0.03
    ],
    [
      "apre",
      0.025
    ],
    [
      "terrible",
      0.025
    ],
    [
      "furieux",
      0.025
    ],
    [
      "brutal",
      0.025
    ],
    [
      "ardent",
      0.025
    ],
    [
      "grand",
      0.025
    ],
    [
      "cruel",
      0.0225
    ],
    [
      "rude",
      0.02
    ],
    [
      "enrage",
      0.0175
    ],
    [
      "impetueux",
      0.0175
    ],
    [
      "extreme",
      0.0175
    ],
    [
      "fougueux",
      0.0175
    ],
    [
      "aigre",
      0.015
    ],
    [
      "intense",
      0.0125
    ],
    [
      "feroce",
      0.0125
    ],
    [
      "farouche",
      0.0125
    ],
    [
      "cuisant",
      0.0125
    ],
    [
      "cru",
      0.0125
    ],
    [
      "percant",
      0.0125
    ],
    [
      "passionne",
      0.0125
    ],
    [
      "emporte",
      0.0125
    ],
    [
      "aigu",
      0.01
    ],
    [
      "energique",
      0.01
    ],
    [
      "vehement",
      0.01
    ],
    [
      "douloureux",
      0.01
    ],
    [
      "chaud",
      0.01
    ],
    [
      "bouillonnant",
      0.01
    ],
    [
      "eperdu",
      0.0075
    ],
    [
      "vigoureux",
      0.0075
    ],
    [
      "tranchant",
      0.0075
    ],
    [
      "sauvage",
      0.0075
    ],
    [
      "effrene",
      0.0075
    ],
    [
      "dechaine",
      0.0075
    ],
    [
      "dangereux",
      0.0075
    ],
    [
      "brusque",
      0.0075
    ],
    [
      "eclatant",
      0.005
    ],
    [
      "vert",
      0.005
    ],
    [
      "rapide",
      0.005
    ],
    [
      "lourd",
      0.005
    ],
    [
      "demesure",
      0.005
    ],
    [
      "colereux",
      0.005
    ],
    [
      "agressif",
      0.005
    ],
    [
      "epouvantable",
      0.005
    ],
    [
      "penetrant",
      0.005
    ],
    [
      "irresistible",
      0.005
    ],
    [
      "immodere",
      0.005
    ],
    [
      "immense",
      0.005
    ],
    [
      "gros",
      0.005
    ],
    [
      "foudroyant",
      0.005
    ],
    [
      "explosif",
      0.005
    ],
    [
      "effroyable",
      0.005
    ],
    [
      "effrayant",
      0.005
    ],
    [
      "criard",
      0.005
    ],
    [
      "poignant",
      0.0025
    ],
    [
      "puissant",
      0.0025
    ],
    [
      "spontane",
      0.0025
    ],
    [
      "tyrannique",
      0.0025
    ],
    [
      "virulent",
      0.0025
    ],
    [
      "energumene",
      0.0025
    ],
    [
      "outre",
      0.0025
    ],
    [
      "irascible",
      0.0025
    ],
    [
      "intolerant",
      0.0025
    ],
    [
      "actif",
      0.0025
    ],
    [
      "carabine",
      0.0025
    ],
    [
      "cassant",
      0.0025
    ],
    [
      "dement",
      0.0025
    ],
    [
      "fulgurant",
      0.0025
    ],
    [
      "inextinguible",
      0.0025
    ],
    [
      "vivace",
      0.0025
    ],
    [
      "tapageur",
      0.0025
    ],
    [
      "sectaire",
      0.0025
    ],
    [
      "imperieux",
      0.0025
    ],
    [
      "impulsif",
      0.0025
    ],
    [
      "impitoyable",
      0.0025
    ],
    [
      "febrile",
      0.0025
    ],
    [
      "funeste",
      0.0025
    ],
    [
      "fievreux",
      0.0025
    ],
    [
      "exacerbe",
      0.0025
    ],
    [
      "atrabilaire",
      0.0025
    ],
    [
      "oppressif",
      0.0
    ],
    [
      "sanguinaire",
      0.0
    ],
    [
      "tempetueux",
      0.0
    ],
    [
      "torrentiel",
      0.0
    ],
    [
      "injurieux",
      0.0
    ],
    [
      "gueulard",
      0.0
    ],
    [
      "convulsif",
      0.0
    ],
    [
      "belliqueux",
      0.0
    ],
    [
      "alouvi",
      0.0
    ],
    [
      "accidentel",
      0.0
    ],
    [
      "truculent",
      0.0
    ]
  ],
  "torrent": [
    [
      "deluge",
      0.1075
    ],
    [
      "flot",
      0.1075
    ],
    [
      "riviere",
      0.07
    ],
    [
      "multitude",
      0.07
    ],
    [
      "force",
      0.07
    ],
    [
      "fleuve",
      0.07
    ],
    [
      "debordement",
      0.07
    ],
    [
      "courant",
      0.07
    ],
    [
      "avalanche",
      0.07
    ],
    [
      "puissance",
      0.035
    ],
    [
      "inondation",
      0.035
    ],
    [
      "gave",
      0.035
    ],
    [
      "cataracte",
      0.035
    ],
    [
      "bordee",
      0.035
    ],
    [
      "violence",
      0.035
    ]
  ],
  "puissant": [
    [
      "fort",
      0.1175
    ],
    [
      "grand",
      0.0775
    ],
    [
      "gros",
      0.0775
    ],
    [
      "important",
      0.0675
    ],
    [
      "solide",
      0.0475
    ],
    [
      "robuste",
      0.0325
    ],
    [
      "vigoureux",
      0.03
    ],
    [
      "trapu",
      0.03
    ],
    [
      "haut",
      0.025
    ],
    [
      "maitre",
      0.025
    ],
    [
      "superieur",
      0.02
    ],
    [
      "souverain",
      0.02
    ],
    [
      "massif",
      0.02
    ],
    [
      "influent",
      0.02
    ],
    [
      "ferme",
      0.02
    ],
    [
      "energique",
      0.015
    ],
    [
      "muscle",
      0.015
    ],
    [
      "intense",
      0.015
    ],
    [
      "efficace",
      0.015
    ],
    [
      "violent",
      0.0125
    ],
    [
      "resistant",
      0.0125
    ],
    [
      "preponderant",
      0.0125
    ],
    [
      "profond",
      0.0125
    ],
    [
      "principal",
      0.0125
    ],
    [
      "pesant",
      0.0125
    ],
    [
      "notabilite",
      0.0125
    ],
    [
      "infatigable",
      0.0125
    ],
    [
      "agissant",
      0.0125
    ],
    [
      "seigneur",
      0.0075
    ],
    [
      "sommite",
      0.0075
    ],
    [
      "supreme",
      0.0075
    ],
    [
      "terrible",
      0.0075
    ],
    [
      "viril",
      0.0075
    ],
    [
      "eminent",
      0.0075
    ],
    [
      "riche",
      0.0075
    ],
    [
      "redoutable",
      0.0075
    ],
    [
      "baraque",
      0.0075
    ],
    [
      "considerable",
      0.0075
    ],
    [
      "gouvernant",
      0.0075
    ],
    [
      "imposant",
      0.0075
    ],
    [
      "invulnerable",
      0.0075
    ],
    [
      "personnalite",
      0.0075
    ],
    [
      "eloquent",
      0.0025
    ],
    [
      "surpuissant",
      0.0025
    ],
    [
      "ramasse",
      0.0025
    ],
    [
      "puissance",
      0.0025
    ],
    [
      "prepotent",
      0.0025
    ],
    [
      "pressant",
      0.0025
    ],
    [
      "patricien",
      0.0025
    ],
    [
      "omnipotent",
      0.0025
    ],
    [
      "createur",
      0.0025
    ],
    [
      "capable",
      0.0025
    ],
    [
      "athletique",
      0.0025
    ],
    [
      "etoffe",
      0.0025
    ]
  ],
  "ouragan": [
    [
      "tempete",
      0.18
    ],
    [
      "tornade",
      0.08
    ],
    [
      "bourrasque",
      0.07
    ],
    [
      "typhon",
      0.07
    ],
    [
      "tourbillon",
      0.06
    ],
    [
      "tourmente",
      0.06
    ],
    [
      "tumulte",
      0.05
    ],
    [
      "orage",
      0.05
    ],
    [
      "frenesie",
      0.05
    ],
    [
      "cyclone",
      0.05
    ],
    [
      "dechainement",
      0.04
    ],
    [
      "rafale",
      0.03
    ],
    [
      "fureur",
      0.03
    ],
    [
      "bouillonnement",
      0.03
    ],
    [
      "vent",
      0.02
    ],
    [
      "trouble",
      0.02
    ],
    [
      "trombe",
      0.02
    ],
    [
      "fracas",
      0.02
    ],
    [
      "explosion",
      0.02
    ],
    [
      "cataclysme",
      0.01
    ],
    [
      "deferlement",
      0.01
    ],
    [
      "hurricane",
      0.01
    ],
    [
      "rage",
      0.01
    ],
    [
      "tintamarre",
      0.01
    ]
  ],
  "ardent": [
    [
      "vif",
      0.0775
    ],
    [
      "bouillonnant",
      0.0675
    ],
    [
      "chaud",
      0.0575
    ],
    [
      "passionne",
      0.0525
    ],
    [
      "fougueux",
      0.04
    ],
    [
      "enthousiaste",
      0.035
    ],
    [
      "fringant",
      0.0325
    ],
    [
      "semillant",
      0.0275
    ],
    [
      "enflamme",
      0.025
    ],
    [
      "fanatique",
      0.025
    ],
    [
      "frenetique",
      0.025
    ],
    [
      "prompt",
      0.025
    ],
    [
      "bouillant",
      0.025
    ],
    [
      "exalte",
      0.025
    ],
    [
      "brulant",
      0.02
    ],
    [
      "chaleureux",
      0.0175
    ],
    [
      "violent",
      0.0175
    ],
    [
      "impetueux",
      0.015
    ],
    [
      "zele",
      0.0125
    ],
    [
      "vehement",
      0.0125
    ],
    [
      "emporte",
      0.0125
    ],
    [
      "eveille",
      0.0125
    ],
    [
      "actif",
      0.01
    ],
    [
      "transporte",
      0.01
    ],
    [
      "febrile",
      0.01
    ],
    [
      "fervent",
      0.01
    ],
    [
      "anime",
      0.01
    ],
    [
      "agile",
      0.0075
    ],
    [
      "alerte",
      0.0075
    ],
    [
      "petillant",
      0.0075
    ],
    [
      "rapide",
      0.005
    ],
    [
      "leste",
      0.005
    ],
    [
      "impatient",
      0.005
    ],
    [
      "excite",
      0.005
    ],
    [
      "brillant",
      0.005
    ],
    [
      "allegre",
      0.005
    ],
    [
      "eclatant",
      0.005
    ],
    [
      "leger",
      0.005
    ],
    [
      "endiable",
      0.005
    ],
    [
      "empresse",
      0.005
    ],
    [
      "emballe",
      0.005
    ],
    [
      "avide",
      0.005
    ],
    [
      "petulant",
      0.005
    ],
    [
      "incandescent",
      0.005
    ],
    [
      "embrase",
      0.005
    ],
    [
      "courageux",
      0.005
    ],
    [
      "amoureux",
      0.005
    ],
    [
      "eperdu",
      0.0025
    ],
    [
      "echauffe",
      0.0025
    ],
    [
      "apre",
      0.0025
    ],
    [
      "flamboyant",
      0.0025
    ],
    [
      "flambant",
      0.0025
    ],
    [
      "fievreux",
      0.0025
    ],
    [
      "excessif",
      0.0025
    ],
    [
      "devoue",
      0.0025
    ],
    [
      "acharne",
      0.0025
    ],
    [
      "agressif",
      0.0025
    ],
    [
      "colereux",
      0.0025
    ],
    [
      "dispos",
      0.0025
    ],
    [
      "devorant",
      0.0025
    ],
    [
      "vivant",
      0.0025
    ],
    [
      "torride",
      0.0025
    ],
    [
      "intelligent",
      0.0025
    ],
    [
      "genereux",
      0.0025
    ],
    [
      "effervescent",
      0.0025
    ],
    [
      "degage",
      0.0025
    ],
    [
      "brusque",
      0.0025
    ],
    [
      "batailleur",
      0.0025
    ],
    [
      "ingambe",
      0.0
    ],
    [
      "lumineux",
      0.0
    ],
    [
      "mobile",
      0.0
    ],
    [
      "pressant",
      0.0
    ],
    [
      "rutilant",
      0.0
    ],
    [
      "guilleret",
      0.0
    ],
    [
      "gaillard",
      0.0
    ],
    [
      "fretillant",
      0.0
    ],
    [
      "delure",
      0.0
    ],
    [
      "dynamique",
      0.0
    ],
    [
      "combustible",
      0.0
    ],
    [
      "aigre",
      0.0
    ],
    [
      "primesautier",
      0.0
    ],
    [
      "profond",
      0.0
    ],
    [
      "releve",
      0.0
    ],
    [
      "salace",
      0.0
    ],
    [
      "vibrant",
      0.0
    ],
    [
      "mordant",
      0.0
    ],
    [
      "juvenile",
      0.0
    ],
    [
      "inextinguible",
      0.0
    ],
    [
      "incendiaire",
      0.0
    ],
    [
      "igne",
      0.0
    ],
    [
      "haletant",
      0.0
    ],
    [
      "baroudeur",
      0.0
    ],
    [
      "alouvi",
      0.0
    ],
    [
      "affame",
      0.0
    ],
    [
      "volcanique",
      0.0
    ]
  ],
  "volcan": [
    [
      "ardeur",
      0.165
    ],
    [
      "cratere",
      0.165
    ],
    [
      "danger",
      0.165
    ],
    [
      "emporte",
      0.165
    ],
    [
      "montagne",
      0.165
    ],
    [
      "violence",
      0.165
    ]
  ],
  "lune": [
    [
      "caprice",
      0.11
    ],
    [
      "cul",
      0.11
    ],
    [
      "derriere",
      0.11
    ],
    [
      "fesse",
      0.11
    ],
    [
      "fessier",
      0.11
    ],
    [
      "lunaison",
      0.11
    ],
    [
      "manie",
      0.11
    ],
    [
      "toquade",
      0.11
    ]
  ],
  "vaillant": [
    [
      "courageux",
      0.145
    ],
    [
      "brave",
      0.0825
    ],
    [
      "hardi",
      0.0825
    ],
    [
      "intrepide",
      0.0825
    ],
    [
      "travailleur",
      0.0825
    ],
    [
      "zele",
      0.0625
    ],
    [
      "vigoureux",
      0.0625
    ],
    [
      "genereux",
      0.0625
    ],
    [
      "actif",
      0.0625
    ],
    [
      "valeureux",
      0.04
    ],
    [
      "heroique",
      0.04
    ],
    [
      "gaillard",
      0.04
    ],
    [
      "acharne",
      0.02
    ],
    [
      "dynamique",
      0.02
    ],
    [
      "fougueux",
      0.02
    ],
    [
      "laborieux",
      0.02
    ],
    [
      "preux",
      0.02
    ],
    [
      "solide",
      0.02
    ],
    [
      "vert",
      0.02
    ]
  ],
  "grimper": [
    [
      "escalader",
      0.2225
    ],
    [
      "monter",
      0.2225
    ],
    [
      "s'elever",
      0.11
    ],
    [
      "varapper",
      0.0525
    ],
    [
      "sauter",
      0.0525
    ],
    [
      "gravir",
      0.0525
    ],
    [
      "ascensionner",
      0.0525
    ],
    [
      "echeler",
      0.0525
    ]
  ],
  "lacher": [
    [
      "lancer",
      1.0
    ]
  ],
  "parce": [],
  "appetit": [
    [
      "desir",
      0.145
    ],
    [
      "appetence",
      0.12
    ],
    [
      "faim",
      0.0725
    ],
    [
      "soif",
      0.0725
    ],
    [
      "avidite",
      0.0625
    ],
    [
      "convoitise",
      0.0525
    ],
    [
      "envie",
      0.05
    ],
    [
      "boulimie",
      0.0425
    ],
    [
      "fringale",
      0.04
    ],
    [
      "gout",
      0.03
    ],
    [
      "inclination",
      0.03
    ],
    [
      "ambition",
      0.0225
    ],
    [
      "voracite",
      0.02
    ],
    [
      "passion",
      0.02
    ],
    [
      "gloutonnerie",
      0.02
    ],
    [
      "curiosite",
      0.02
    ],
    [
      "concupiscence",
      0.02
    ],
    [
      "besoin",
      0.02
    ],
    [
      "aspiration",
      0.02
    ],
    [
      "attrait",
      0.0125
    ],
    [
      "souhait",
      0.0125
    ],
    [
      "tendance",
      0.0125
    ],
    [
      "instinct",
      0.01
    ],
    [
      "gourmandise",
      0.01
    ],
    [
      "frenesie",
      0.01
    ],
    [
      "exigence",
      0.01
    ],
    [
      "appetition",
      0.0025
    ],
    [
      "malacie",
      0.0025
    ],
    [
      "pica",
      0.0025
    ],
    [
      "prurit",
      0.0025
    ]
  ],
  "realite": [
    [
      "verite",
      0.1425
    ],
    [
      "nature",
      0.1125
    ],
    [
      "fait",
      0.085
    ],
    [
      "substance",
      0.085
    ],
    [
      "etre",
      0.055
    ],
    [
      "reel",
      0.055
    ],
    [
      "objet",
      0.055
    ],
    [
      "existence",
      0.055
    ],
    [
      "chose",
      0.055
    ],
    [
      "vrai",
      0.0275
    ],
    [
      "realisme",
      0.0275
    ],
    [
      "present",
      0.0275
    ],
    [
      "monde",
      0.0275
    ],
    [
      "materialite",
      0.0275
    ],
    [
      "factualite",
      0.0275
    ],
    [
      "experience",
      0.0275
    ],
    [
      "exactitude",
      0.0275
    ],
    [
      "certitude",
      0.0275
    ],
    [
      "evidence",
      0.0275
    ]
  ],
  "fader": [],
  "fade": [
    [
      "terne",
      0.1275
    ],
    [
      "insignifiant",
      0.085
    ],
    [
      "insipide",
      0.0775
    ],
    [
      "plat",
      0.055
    ],
    [
      "banal",
      0.045
    ],
    [
      "pale",
      0.0425
    ],
    [
      "quelconque",
      0.0325
    ],
    [
      "neutre",
      0.0275
    ],
    [
      "morne",
      0.0275
    ],
    [
      "eteint",
      0.025
    ],
    [
      "ininteressant",
      0.02
    ],
    [
      "faible",
      0.02
    ],
    [
      "fadasse",
      0.02
    ],
    [
      "ennuyeux",
      0.02
    ],
    [
      "decolore",
      0.02
    ],
    [
      "doux",
      0.02
    ],
    [
      "douceatre",
      0.02
    ],
    [
      "doucereux",
      0.02
    ],
    [
      "anodin",
      0.02
    ],
    [
      "sucre",
      0.015
    ],
    [
      "languissant",
      0.015
    ],
    [
      "incolore",
      0.015
    ],
    [
      "froid",
      0.015
    ],
    [
      "fastidieux",
      0.015
    ],
    [
      "desagreable",
      0.015
    ],
    [
      "bleme",
      0.015
    ],
    [
      "ecoeurant",
      0.0125
    ],
    [
      "mort",
      0.0125
    ],
    [
      "melliflu",
      0.0125
    ],
    [
      "degoutant",
      0.0125
    ],
    [
      "sirupeux",
      0.0075
    ],
    [
      "rampant",
      0.0075
    ],
    [
      "inodore",
      0.0075
    ],
    [
      "inexpressif",
      0.0075
    ],
    [
      "impersonnel",
      0.0075
    ],
    [
      "delave",
      0.0075
    ],
    [
      "pied",
      0.0025
    ],
    [
      "nauseabond",
      0.0025
    ],
    [
      "conventionnel",
      0.0025
    ],
    [
      "butin",
      0.0025
    ],
    [
      "blafard",
      0.0025
    ],
    [
      "affecte",
      0.0025
    ],
    [
      "trainant",
      0.0025
    ]
  ],
  "saveur": [
    [
      "piquant",
      0.19
    ],
    [
      "gout",
      0.1425
    ],
    [
      "charme",
      0.095
    ],
    [
      "fumet",
      0.095
    ],
    [
      "montant",
      0.095
    ],
    [
      "piment",
      0.095
    ],
    [
      "sel",
      0.0475
    ],
    [
      "sapidite",
      0.0475
    ],
    [
      "generosite",
      0.0475
    ],
    [
      "bouquet",
      0.0475
    ],
    [
      "agrement",
      0.0475
    ],
    [
      "succulence",
      0.0475
    ]
  ],
  "ado": [
    [
      "adolescent",
      1.0
    ]
  ],
  "troupeau": [
    [
      "troupe",
      0.165
    ],
    [
      "horde",
      0.1
    ],
    [
      "multitude",
      0.1
    ],
    [
      "bande",
      0.0825
    ],
    [
      "foule",
      0.065
    ],
    [
      "peuple",
      0.065
    ],
    [
      "meute",
      0.05
    ],
    [
      "harde",
      0.05
    ],
    [
      "essaim",
      0.05
    ],
    [
      "agglomeration",
      0.05
    ],
    [
      "sarabande",
      0.0325
    ],
    [
      "populace",
      0.0325
    ],
    [
      "cohorte",
      0.0325
    ],
    [
      "betail",
      0.0325
    ],
    [
      "bataillon",
      0.0325
    ],
    [
      "cheptel",
      0.015
    ],
    [
      "manade",
      0.015
    ],
    [
      "tourbe",
      0.015
    ]
  ],
  "tetu": [
    [
      "opiniatre",
      0.1625
    ],
    [
      "entete",
      0.1
    ],
    [
      "obstine",
      0.1
    ],
    [
      "tenace",
      0.09
    ],
    [
      "ferme",
      0.06
    ],
    [
      "volontaire",
      0.06
    ],
    [
      "recalcitrant",
      0.05
    ],
    [
      "perseverant",
      0.05
    ],
    [
      "intraitable",
      0.04
    ],
    [
      "acharne",
      0.03
    ],
    [
      "insoumis",
      0.03
    ],
    [
      "resistant",
      0.03
    ],
    [
      "retif",
      0.02
    ],
    [
      "indocile",
      0.02
    ],
    [
      "entier",
      0.02
    ],
    [
      "bute",
      0.02
    ],
    [
      "persistant",
      0.01
    ],
    [
      "mutin",
      0.01
    ],
    [
      "hutin",
      0.01
    ],
    [
      "cabochard",
      0.01
    ],
    [
      "aheurte",
      0.01
    ],
    [
      "accrocheur",
      0.01
    ],
    [
      "absolu",
      0.01
    ],
    [
      "resolu",
      0.01
    ]
  ],
  "determination": [
    [
      "resolution",
      0.1025
    ],
    [
      "volonte",
      0.0925
    ],
    [
      "decision",
      0.0725
    ],
    [
      "dessein",
      0.065
    ],
    [
      "fermete",
      0.065
    ],
    [
      "energie",
      0.035
    ],
    [
      "intention",
      0.035
    ],
    [
      "precision",
      0.0275
    ],
    [
      "propos",
      0.0275
    ],
    [
      "parti",
      0.0275
    ],
    [
      "limitation",
      0.0275
    ],
    [
      "cran",
      0.0275
    ],
    [
      "caracterisation",
      0.0275
    ],
    [
      "calcul",
      0.0275
    ],
    [
      "evaluation",
      0.0175
    ],
    [
      "tenacite",
      0.0175
    ],
    [
      "predestination",
      0.0175
    ],
    [
      "mesure",
      0.0175
    ],
    [
      "finalite",
      0.0175
    ],
    [
      "choix",
      0.0175
    ],
    [
      "caractere",
      0.0175
    ],
    [
      "but",
      0.0175
    ],
    [
      "initiative",
      0.0075
    ],
    [
      "localisation",
      0.0075
    ],
    [
      "opiniatrete",
      0.0075
    ],
    [
      "option",
      0.0075
    ],
    [
      "predetermination",
      0.0075
    ],
    [
      "solution",
      0.0075
    ],
    [
      "specification",
      0.0075
    ],
    [
      "indication",
      0.0075
    ],
    [
      "idee",
      0.0075
    ],
    [
      "circonstance",
      0.0075
    ],
    [
      "comprehension",
      0.0075
    ],
    [
      "definition",
      0.0075
    ],
    [
      "delimitation",
      0.0075
    ],
    [
      "estimation",
      0.0075
    ],
    [
      "fixation",
      0.0075
    ],
    [
      "force",
      0.0075
    ],
    [
      "hardiesse",
      0.0075
    ],
    [
      "temerite",
      0.0075
    ]
  ],
  "medecin": [
    [
      "praticien",
      0.08
    ],
    [
      "charlatan",
      0.06
    ],
    [
      "docteur",
      0.04
    ],
    [
      "empirique",
      0.04
    ],
    [
      "guerisseur",
      0.04
    ],
    [
      "generaliste",
      0.04
    ],
    [
      "omnipraticien",
      0.0175
    ],
    [
      "oculiste",
      0.0175
    ],
    [
      "neurologue",
      0.0175
    ],
    [
      "medicastre",
      0.0175
    ],
    [
      "morticole",
      0.0175
    ],
    [
      "mire",
      0.0175
    ],
    [
      "phlebologue",
      0.0175
    ],
    [
      "physicien",
      0.0175
    ],
    [
      "psychiatre",
      0.0175
    ],
    [
      "pediatre",
      0.0175
    ],
    [
      "radiologue",
      0.0175
    ],
    [
      "specialiste",
      0.0175
    ],
    [
      "stomatologiste",
      0.0175
    ],
    [
      "therapeute",
      0.0175
    ],
    [
      "toubib",
      0.0175
    ],
    [
      "major",
      0.0175
    ],
    [
      "interniste",
      0.0175
    ],
    [
      "anesthesiste",
      0.0175
    ],
    [
      "archiatre",
      0.0175
    ],
    [
      "auriste",
      0.0175
    ],
    [
      "carabin",
      0.0175
    ],
    [
      "cardiologue",
      0.0175
    ],
    [
      "chirurgien",
      0.0175
    ],
    [
      "clinicien",
      0.0175
    ],
    [
      "dermatologiste",
      0.0175
    ],
    [
      "doctoresse",
      0.0175
    ],
    [
      "drogueur",
      0.0175
    ],
    [
      "empiriste",
      0.0175
    ],
    [
      "esculape",
      0.0175
    ],
    [
      "externe",
      0.0175
    ],
    [
      "faculte",
      0.0175
    ],
    [
      "gynecologue",
      0.0175
    ],
    [
      "interne",
      0.0175
    ],
    [
      "accoucheur",
      0.0175
    ]
  ],
  "soigner": [
    [
      "polir",
      0.07
    ],
    [
      "parfaire",
      0.05
    ],
    [
      "cultiver",
      0.0425
    ],
    [
      "fignoler",
      0.0425
    ],
    [
      "couver",
      0.0375
    ],
    [
      "choyer",
      0.0375
    ],
    [
      "arranger",
      0.0375
    ],
    [
      "travailler",
      0.03
    ],
    [
      "perler",
      0.03
    ],
    [
      "nourrir",
      0.03
    ],
    [
      "entretenir",
      0.03
    ],
    [
      "dorloter",
      0.03
    ],
    [
      "ciseler",
      0.03
    ],
    [
      "menager",
      0.025
    ],
    [
      "lecher",
      0.025
    ],
    [
      "former",
      0.025
    ],
    [
      "conserver",
      0.025
    ],
    [
      "chatier",
      0.025
    ],
    [
      "battre",
      0.025
    ],
    [
      "elever",
      0.0175
    ],
    [
      "peigner",
      0.0175
    ],
    [
      "mignoter",
      0.0175
    ],
    [
      "fouiller",
      0.0175
    ],
    [
      "brosser",
      0.0175
    ],
    [
      "bouchonner",
      0.0175
    ],
    [
      "eduquer",
      0.0125
    ],
    [
      "reserver",
      0.0125
    ],
    [
      "raffiner",
      0.0125
    ],
    [
      "pomponner",
      0.0125
    ],
    [
      "panser",
      0.0125
    ],
    [
      "limer",
      0.0125
    ],
    [
      "gater",
      0.0125
    ],
    [
      "caliner",
      0.0125
    ],
    [
      "chouchouter",
      0.0125
    ],
    [
      "bichonner",
      0.0125
    ],
    [
      "peaufiner",
      0.005
    ],
    [
      "pouponner",
      0.005
    ],
    [
      "raboter",
      0.005
    ],
    [
      "traiter",
      0.005
    ],
    [
      "medicamenter",
      0.005
    ],
    [
      "mitonner",
      0.005
    ],
    [
      "instruire",
      0.005
    ],
    [
      "complaire",
      0.005
    ],
    [
      "bander",
      0.005
    ],
    [
      "assister",
      0.005
    ],
    [
      "allaiter",
      0.005
    ],
    [
      "veiller",
      0.005
    ]
  ],
  "fievre": [
    [
      "exaltation",
      0.095
    ],
    [
      "excitation",
      0.085
    ],
    [
      "agitation",
      0.0675
    ],
    [
      "ardeur",
      0.065
    ],
    [
      "bouillonnement",
      0.0625
    ],
    [
      "passion",
      0.06
    ],
    [
      "chaleur",
      0.0475
    ],
    [
      "frenesie",
      0.0475
    ],
    [
      "effervescence",
      0.0425
    ],
    [
      "surexcitation",
      0.0325
    ],
    [
      "flamme",
      0.0325
    ],
    [
      "delire",
      0.03
    ],
    [
      "trouble",
      0.0275
    ],
    [
      "transport",
      0.025
    ],
    [
      "emotion",
      0.0175
    ],
    [
      "fougue",
      0.0175
    ],
    [
      "feu",
      0.0175
    ],
    [
      "fanatisme",
      0.0175
    ],
    [
      "animation",
      0.0175
    ],
    [
      "folie",
      0.015
    ],
    [
      "impetuosite",
      0.015
    ],
    [
      "rage",
      0.0125
    ],
    [
      "affolement",
      0.01
    ],
    [
      "nervosite",
      0.01
    ],
    [
      "fermentation",
      0.0075
    ],
    [
      "febrilite",
      0.0075
    ],
    [
      "impatience",
      0.0075
    ],
    [
      "enervement",
      0.0075
    ],
    [
      "erethisme",
      0.0075
    ],
    [
      "etourdissement",
      0.005
    ],
    [
      "surtension",
      0.005
    ],
    [
      "manie",
      0.005
    ],
    [
      "desordre",
      0.005
    ],
    [
      "amour",
      0.005
    ],
    [
      "tic",
      0.0025
    ],
    [
      "temperature",
      0.0025
    ],
    [
      "soif",
      0.0025
    ],
    [
      "malaria",
      0.0025
    ],
    [
      "hyperthermie",
      0.0025
    ],
    [
      "frisson",
      0.0025
    ],
    [
      "brulure",
      0.0025
    ],
    [
      "affairement",
      0.0025
    ],
    [
      "travers",
      0.0025
    ]
  ],
  "possible": [
    [
      "acceptable",
      0.095
    ],
    [
      "admissible",
      0.0475
    ],
    [
      "convenable",
      0.0475
    ],
    [
      "passable",
      0.0475
    ],
    [
      "plausible",
      0.0475
    ],
    [
      "realisable",
      0.0475
    ],
    [
      "supportable",
      0.0375
    ],
    [
      "probable",
      0.0375
    ],
    [
      "pensable",
      0.0375
    ],
    [
      "facile",
      0.0375
    ],
    [
      "correct",
      0.0375
    ],
    [
      "soutenable",
      0.0275
    ],
    [
      "potable",
      0.0275
    ],
    [
      "permis",
      0.0275
    ],
    [
      "envisageable",
      0.0275
    ],
    [
      "croyable",
      0.0275
    ],
    [
      "commode",
      0.0275
    ],
    [
      "vraisemblable",
      0.0175
    ],
    [
      "vivable",
      0.0175
    ],
    [
      "virtuel",
      0.0175
    ],
    [
      "tolere",
      0.0175
    ],
    [
      "tolerable",
      0.0175
    ],
    [
      "sortable",
      0.0175
    ],
    [
      "previsible",
      0.0175
    ],
    [
      "pratique",
      0.0175
    ],
    [
      "decent",
      0.0175
    ],
    [
      "buvable",
      0.0175
    ],
    [
      "mangeable",
      0.0075
    ],
    [
      "potentiel",
      0.0075
    ],
    [
      "praticable",
      0.0075
    ],
    [
      "virtualite",
      0.0075
    ],
    [
      "loisible",
      0.0075
    ],
    [
      "imaginable",
      0.0075
    ],
    [
      "futur",
      0.0075
    ],
    [
      "faisable",
      0.0075
    ],
    [
      "executable",
      0.0075
    ],
    [
      "contingent",
      0.0075
    ],
    [
      "accessible",
      0.0075
    ],
    [
      "abordable",
      0.0075
    ],
    [
      "eventuel",
      0.0075
    ]
  ],
  "contempler": [
    [
      "regarder",
      0.175
    ],
    [
      "examiner",
      0.105
    ],
    [
      "considerer",
      0.0875
    ],
    [
      "devisager",
      0.0875
    ],
    [
      "voir",
      0.0875
    ],
    [
      "observer",
      0.07
    ],
    [
      "zieuter",
      0.07
    ],
    [
      "reflechir",
      0.0525
    ],
    [
      "penser",
      0.0525
    ],
    [
      "fixer",
      0.0525
    ],
    [
      "envisager",
      0.0525
    ],
    [
      "admirer",
      0.035
    ],
    [
      "bigler",
      0.035
    ],
    [
      "mediter",
      0.0175
    ]
  ],
  "sommet": [
    [
      "comble",
      0.08
    ],
    [
      "faite",
      0.08
    ],
    [
      "haut",
      0.08
    ],
    [
      "cime",
      0.0525
    ],
    [
      "pointe",
      0.0525
    ],
    [
      "hauteur",
      0.045
    ],
    [
      "summum",
      0.04
    ],
    [
      "pic",
      0.04
    ],
    [
      "apogee",
      0.04
    ],
    [
      "aiguille",
      0.0325
    ],
    [
      "mont",
      0.0325
    ],
    [
      "eminence",
      0.025
    ],
    [
      "pinacle",
      0.025
    ],
    [
      "zenith",
      0.0175
    ],
    [
      "piton",
      0.0175
    ],
    [
      "extremite",
      0.0175
    ],
    [
      "dent",
      0.0175
    ],
    [
      "crete",
      0.0175
    ],
    [
      "couronnement",
      0.0175
    ],
    [
      "tete",
      0.0125
    ],
    [
      "pole",
      0.0125
    ],
    [
      "perfection",
      0.0125
    ],
    [
      "maximum",
      0.0125
    ],
    [
      "mamelon",
      0.0125
    ],
    [
      "extreme",
      0.0125
    ],
    [
      "dome",
      0.0125
    ],
    [
      "culmen",
      0.0125
    ],
    [
      "calotte",
      0.0125
    ],
    [
      "acme",
      0.0125
    ],
    [
      "paroxysme",
      0.005
    ],
    [
      "sommite",
      0.005
    ],
    [
      "sublime",
      0.005
    ],
    [
      "suprematie",
      0.005
    ],
    [
      "montagne",
      0.005
    ],
    [
      "front",
      0.005
    ],
    [
      "dessus",
      0.005
    ],
    [
      "croupe",
      0.005
    ],
    [
      "ballon",
      0.005
    ],
    [
      "arete",
      0.005
    ],
    [
      "apotheose",
      0.005
    ],
    [
      "table",
      0.005
    ]
  ],
  "by": [],
  "pain": [
    [
      "bricheton",
      0.075
    ],
    [
      "briffe",
      0.075
    ],
    [
      "briffeton",
      0.075
    ],
    [
      "nourriture",
      0.075
    ],
    [
      "miche",
      0.0375
    ],
    [
      "pistolet",
      0.0375
    ],
    [
      "pitance",
      0.0375
    ],
    [
      "soufflet",
      0.0375
    ],
    [
      "subsistance",
      0.0375
    ],
    [
      "talmouse",
      0.0375
    ],
    [
      "torgnole",
      0.0375
    ],
    [
      "lingot",
      0.0375
    ],
    [
      "gifle",
      0.0375
    ],
    [
      "flute",
      0.0375
    ],
    [
      "couronne",
      0.0375
    ],
    [
      "coup",
      0.0375
    ],
    [
      "brique",
      0.0375
    ],
    [
      "brignolet",
      0.0375
    ],
    [
      "boule",
      0.0375
    ],
    [
      "baguette",
      0.0375
    ],
    [
      "aliment",
      0.0375
    ],
    [
      "tourteau",
      0.0375
    ]
  ],
  "melancolique": [
    [
      "triste",
      0.1675
    ],
    [
      "sombre",
      0.13
    ],
    [
      "morne",
      0.105
    ],
    [
      "morose",
      0.0625
    ],
    [
      "chagrin",
      0.055
    ],
    [
      "maussade",
      0.0475
    ],
    [
      "cafardeux",
      0.0425
    ],
    [
      "sinistre",
      0.035
    ],
    [
      "lugubre",
      0.035
    ],
    [
      "bilieux",
      0.03
    ],
    [
      "taciturne",
      0.03
    ],
    [
      "tenebreux",
      0.03
    ],
    [
      "abattu",
      0.0225
    ],
    [
      "pessimiste",
      0.0175
    ],
    [
      "neurasthenique",
      0.0175
    ],
    [
      "funebre",
      0.0175
    ],
    [
      "atrabilaire",
      0.0175
    ],
    [
      "sepulcral",
      0.01
    ],
    [
      "nevrose",
      0.01
    ],
    [
      "nostalgique",
      0.01
    ],
    [
      "desabuse",
      0.01
    ],
    [
      "deprime",
      0.01
    ],
    [
      "amer",
      0.01
    ],
    [
      "romantique",
      0.005
    ],
    [
      "pleurard",
      0.005
    ],
    [
      "humoriste",
      0.005
    ],
    [
      "fou",
      0.005
    ],
    [
      "desenchante",
      0.005
    ],
    [
      "brumeux",
      0.005
    ],
    [
      "elegiaque",
      0.005
    ]
  ],
  "positif": [
    [
      "certain",
      0.0925
    ],
    [
      "vrai",
      0.075
    ],
    [
      "evident",
      0.07
    ],
    [
      "incontestable",
      0.0575
    ],
    [
      "reel",
      0.05
    ],
    [
      "indubitable",
      0.0475
    ],
    [
      "tangible",
      0.0375
    ],
    [
      "authentique",
      0.0375
    ],
    [
      "indiscutable",
      0.035
    ],
    [
      "formel",
      0.03
    ],
    [
      "irrefragable",
      0.0275
    ],
    [
      "sur",
      0.025
    ],
    [
      "sincere",
      0.025
    ],
    [
      "net",
      0.025
    ],
    [
      "indeniable",
      0.025
    ],
    [
      "assure",
      0.025
    ],
    [
      "solide",
      0.02
    ],
    [
      "realiste",
      0.015
    ],
    [
      "materiel",
      0.015
    ],
    [
      "irrefutable",
      0.015
    ],
    [
      "concret",
      0.015
    ],
    [
      "categorique",
      0.015
    ],
    [
      "pratique",
      0.0125
    ],
    [
      "objectif",
      0.0125
    ],
    [
      "materialiste",
      0.0125
    ],
    [
      "manifeste",
      0.0125
    ],
    [
      "irrecusable",
      0.0125
    ],
    [
      "effectif",
      0.0125
    ],
    [
      "inattaquable",
      0.0075
    ],
    [
      "palpable",
      0.0075
    ],
    [
      "prosaique",
      0.0075
    ],
    [
      "utilitaire",
      0.0075
    ],
    [
      "serieux",
      0.005
    ],
    [
      "existant",
      0.005
    ],
    [
      "droit",
      0.005
    ],
    [
      "affirmatif",
      0.005
    ],
    [
      "pragmatique",
      0.0025
    ],
    [
      "positivisme",
      0.0025
    ],
    [
      "mesquin",
      0.0025
    ],
    [
      "favorable",
      0.0025
    ],
    [
      "expres",
      0.0025
    ],
    [
      "explicite",
      0.0025
    ],
    [
      "constructif",
      0.0025
    ],
    [
      "constant",
      0.0025
    ],
    [
      "scientifique",
      0.0025
    ]
  ],
  "desabuse": [
    [
      "eclairer",
      0.235
    ],
    [
      "detromper",
      0.175
    ],
    [
      "dessiller",
      0.1175
    ],
    [
      "degouter",
      0.1175
    ],
    [
      "blaser",
      0.0575
    ],
    [
      "desillusionner",
      0.0575
    ],
    [
      "detourner",
      0.0575
    ]
  ],
  "desabuser": [
    [
      "eclairer",
      0.235
    ],
    [
      "detromper",
      0.175
    ],
    [
      "dessiller",
      0.1175
    ],
    [
      "degouter",
      0.1175
    ],
    [
      "blaser",
      0.0575
    ],
    [
      "desillusionner",
      0.0575
    ],
    [
      "detourner",
      0.0575
    ]
  ],
  "braque": [
    [
      "fou",
      0.1225
    ],
    [
      "farfelu",
      0.11
    ],
    [
      "bizarre",
      0.1
    ],
    [
      "fantasque",
      0.065
    ],
    [
      "hurluberlu",
      0.055
    ],
    [
      "loufoque",
      0.055
    ],
    [
      "tordu",
      0.055
    ],
    [
      "toque",
      0.0425
    ],
    [
      "baroque",
      0.0325
    ],
    [
      "capricieux",
      0.0325
    ],
    [
      "original",
      0.0325
    ],
    [
      "timbre",
      0.0325
    ],
    [
      "etourdi",
      0.02
    ],
    [
      "ecervele",
      0.02
    ],
    [
      "pique",
      0.02
    ],
    [
      "lunatique",
      0.02
    ],
    [
      "foufou",
      0.02
    ],
    [
      "branquignol",
      0.02
    ],
    [
      "aliene",
      0.02
    ],
    [
      "sourcilleux",
      0.01
    ],
    [
      "sensible",
      0.01
    ],
    [
      "quinteux",
      0.01
    ],
    [
      "brindezingue",
      0.01
    ],
    [
      "branque",
      0.01
    ],
    [
      "bourbonnais",
      0.01
    ],
    [
      "susceptible",
      0.01
    ]
  ],
  "braquer": [
    [
      "dresser",
      0.1775
    ],
    [
      "elever",
      0.07
    ],
    [
      "tourner",
      0.07
    ],
    [
      "orienter",
      0.07
    ],
    [
      "opposer",
      0.07
    ],
    [
      "instruire",
      0.07
    ],
    [
      "diriger",
      0.07
    ],
    [
      "cabrer",
      0.07
    ],
    [
      "preparer",
      0.035
    ],
    [
      "pointer",
      0.035
    ],
    [
      "obliquer",
      0.035
    ],
    [
      "exciter",
      0.035
    ],
    [
      "devaliser",
      0.035
    ],
    [
      "buter",
      0.035
    ],
    [
      "attaquer",
      0.035
    ],
    [
      "virer",
      0.035
    ]
  ],
  "plier": [
    [
      "flechir",
      0.11
    ],
    [
      "courber",
      0.08
    ],
    [
      "ployer",
      0.0625
    ],
    [
      "ceder",
      0.05
    ],
    [
      "soumettre",
      0.0425
    ],
    [
      "faconner",
      0.0325
    ],
    [
      "faire",
      0.0325
    ],
    [
      "habituer",
      0.025
    ],
    [
      "s'incliner",
      0.02
    ],
    [
      "incliner",
      0.02
    ],
    [
      "faiblir",
      0.02
    ],
    [
      "assujettir",
      0.02
    ],
    [
      "accoutumer",
      0.02
    ],
    [
      "s'abaisser",
      0.015
    ],
    [
      "inflechir",
      0.015
    ],
    [
      "gauchir",
      0.015
    ],
    [
      "flancher",
      0.015
    ],
    [
      "capituler",
      0.015
    ],
    [
      "cambrer",
      0.015
    ],
    [
      "abaisser",
      0.015
    ],
    [
      "styler",
      0.0125
    ],
    [
      "refluer",
      0.0125
    ],
    [
      "reculer",
      0.0125
    ],
    [
      "mollir",
      0.0125
    ],
    [
      "lacher",
      0.0125
    ],
    [
      "instruire",
      0.0125
    ],
    [
      "forger",
      0.0125
    ],
    [
      "enchainer",
      0.0125
    ],
    [
      "renoncer",
      0.0075
    ],
    [
      "rouler",
      0.0075
    ],
    [
      "s'affaisser",
      0.0075
    ],
    [
      "s'humilier",
      0.0075
    ],
    [
      "succomber",
      0.0075
    ],
    [
      "tordre",
      0.0075
    ],
    [
      "recourber",
      0.0075
    ],
    [
      "ranger",
      0.0075
    ],
    [
      "opprimer",
      0.0075
    ],
    [
      "arquer",
      0.0075
    ],
    [
      "assouplir",
      0.0075
    ],
    [
      "dompter",
      0.0075
    ],
    [
      "exercer",
      0.0075
    ],
    [
      "familiariser",
      0.0075
    ],
    [
      "modeler",
      0.0075
    ],
    [
      "incurver",
      0.0025
    ],
    [
      "mouler",
      0.0025
    ],
    [
      "obeir",
      0.0025
    ],
    [
      "plisser",
      0.0025
    ],
    [
      "ramasser",
      0.0025
    ],
    [
      "replier",
      0.0025
    ],
    [
      "s'assouplir",
      0.0025
    ],
    [
      "fermer",
      0.0025
    ],
    [
      "fausser",
      0.0025
    ],
    [
      "fatiguer",
      0.0025
    ],
    [
      "enrouler",
      0.0025
    ],
    [
      "doubler",
      0.0025
    ],
    [
      "discipliner",
      0.0025
    ],
    [
      "couder",
      0.0025
    ],
    [
      "corner",
      0.0025
    ],
    [
      "chanceler",
      0.0025
    ],
    [
      "astreindre",
      0.0025
    ],
    [
      "subordonner",
      0.0025
    ]
  ],
  "moteur": [
    [
      "agent",
      0.095
    ],
    [
      "promoteur",
      0.095
    ],
    [
      "cause",
      0.08
    ],
    [
      "instigateur",
      0.08
    ],
    [
      "ame",
      0.0675
    ],
    [
      "protagoniste",
      0.0525
    ],
    [
      "meneur",
      0.0525
    ],
    [
      "animateur",
      0.0525
    ],
    [
      "directeur",
      0.04
    ],
    [
      "mobile",
      0.04
    ],
    [
      "regisseur",
      0.025
    ],
    [
      "ressort",
      0.025
    ],
    [
      "principe",
      0.025
    ],
    [
      "motif",
      0.025
    ],
    [
      "machine",
      0.025
    ],
    [
      "inspirateur",
      0.025
    ],
    [
      "appareil",
      0.025
    ],
    [
      "reacteur",
      0.0125
    ],
    [
      "parrain",
      0.0125
    ],
    [
      "origine",
      0.0125
    ],
    [
      "organe",
      0.0125
    ],
    [
      "mecanique",
      0.0125
    ],
    [
      "mouvant",
      0.0125
    ],
    [
      "moulin",
      0.0125
    ],
    [
      "motrice",
      0.0125
    ],
    [
      "incitateur",
      0.0125
    ],
    [
      "engin",
      0.0125
    ],
    [
      "turbine",
      0.0125
    ]
  ],
  "carre": [
    [
      "franc",
      0.0725
    ],
    [
      "droit",
      0.0475
    ],
    [
      "net",
      0.0475
    ],
    [
      "echarpe",
      0.035
    ],
    [
      "pointe",
      0.035
    ],
    [
      "fichu",
      0.035
    ],
    [
      "coiffure",
      0.035
    ],
    [
      "carrelet",
      0.035
    ],
    [
      "vrai",
      0.0225
    ],
    [
      "sincere",
      0.0225
    ],
    [
      "place",
      0.0225
    ],
    [
      "ouvert",
      0.0225
    ],
    [
      "morceau",
      0.0225
    ],
    [
      "massif",
      0.0225
    ],
    [
      "mantille",
      0.0225
    ],
    [
      "foulard",
      0.0225
    ],
    [
      "filet",
      0.0225
    ],
    [
      "ferme",
      0.0225
    ],
    [
      "direct",
      0.0225
    ],
    [
      "coin",
      0.0225
    ],
    [
      "bout",
      0.0225
    ],
    [
      "quadrangulaire",
      0.01
    ],
    [
      "popote",
      0.01
    ],
    [
      "planche",
      0.01
    ],
    [
      "piece",
      0.01
    ],
    [
      "quadrature",
      0.01
    ],
    [
      "quadrilatere",
      0.01
    ],
    [
      "resolu",
      0.01
    ],
    [
      "square",
      0.01
    ],
    [
      "eleve",
      0.01
    ],
    [
      "epais",
      0.01
    ],
    [
      "etage",
      0.01
    ],
    [
      "parterre",
      0.01
    ],
    [
      "parallelogramme",
      0.01
    ],
    [
      "palier",
      0.01
    ],
    [
      "case",
      0.01
    ],
    [
      "cellule",
      0.01
    ],
    [
      "chale",
      0.01
    ],
    [
      "corbeille",
      0.01
    ],
    [
      "cote",
      0.01
    ],
    [
      "damier",
      0.01
    ],
    [
      "debout",
      0.01
    ],
    [
      "de",
      0.01
    ],
    [
      "decide",
      0.01
    ],
    [
      "gamelle",
      0.01
    ],
    [
      "loyal",
      0.01
    ],
    [
      "carreau",
      0.01
    ]
  ],
  "carrer": [],
  "cercler": [
    [
      "entourer",
      0.17
    ],
    [
      "ceindre",
      0.105
    ],
    [
      "attacher",
      0.085
    ],
    [
      "enclore",
      0.085
    ],
    [
      "encercler",
      0.0625
    ],
    [
      "enceindre",
      0.0625
    ],
    [
      "fermer",
      0.04
    ],
    [
      "enserrer",
      0.04
    ],
    [
      "encadrer",
      0.04
    ],
    [
      "corder",
      0.04
    ],
    [
      "consolider",
      0.04
    ],
    [
      "clore",
      0.04
    ],
    [
      "borner",
      0.04
    ],
    [
      "border",
      0.04
    ],
    [
      "ceinturer",
      0.02
    ],
    [
      "courber",
      0.02
    ],
    [
      "relier",
      0.02
    ],
    [
      "renforcer",
      0.02
    ]
  ],
  "cercle": [
    [
      "tour",
      0.0475
    ],
    [
      "groupe",
      0.0425
    ],
    [
      "rond",
      0.0325
    ],
    [
      "coterie",
      0.0275
    ],
    [
      "reunion",
      0.0275
    ],
    [
      "sphere",
      0.0275
    ],
    [
      "cenacle",
      0.0225
    ],
    [
      "contour",
      0.0225
    ],
    [
      "clan",
      0.0225
    ],
    [
      "circuit",
      0.0225
    ],
    [
      "anneau",
      0.0225
    ],
    [
      "societe",
      0.0175
    ],
    [
      "revolution",
      0.0175
    ],
    [
      "orbe",
      0.0175
    ],
    [
      "compagnie",
      0.0175
    ],
    [
      "circonference",
      0.0175
    ],
    [
      "cadre",
      0.0175
    ],
    [
      "association",
      0.0175
    ],
    [
      "ecole",
      0.0125
    ],
    [
      "perimetre",
      0.0125
    ],
    [
      "milieu",
      0.0125
    ],
    [
      "limite",
      0.0125
    ],
    [
      "halo",
      0.0125
    ],
    [
      "entourage",
      0.0125
    ],
    [
      "domaine",
      0.0125
    ],
    [
      "courbe",
      0.0125
    ],
    [
      "club",
      0.0125
    ],
    [
      "cintre",
      0.0125
    ],
    [
      "chapelle",
      0.0125
    ],
    [
      "assemblee",
      0.0125
    ],
    [
      "pourtour",
      0.0075
    ],
    [
      "peripherie",
      0.0075
    ],
    [
      "rotation",
      0.0075
    ],
    [
      "salon",
      0.0075
    ],
    [
      "voute",
      0.0075
    ],
    [
      "zone",
      0.0075
    ],
    [
      "orbite",
      0.0075
    ],
    [
      "nimbe",
      0.0075
    ],
    [
      "couronne",
      0.0075
    ],
    [
      "arceau",
      0.0075
    ],
    [
      "aureole",
      0.0075
    ],
    [
      "bague",
      0.0075
    ],
    [
      "bracelet",
      0.0075
    ],
    [
      "cerceau",
      0.0075
    ],
    [
      "cerne",
      0.0075
    ],
    [
      "rondelle",
      0.0025
    ],
    [
      "retour",
      0.0025
    ],
    [
      "periple",
      0.0025
    ],
    [
      "prison",
      0.0025
    ],
    [
      "piege",
      0.0025
    ],
    [
      "paraselene",
      0.0025
    ],
    [
      "parallele",
      0.0025
    ],
    [
      "onde",
      0.0025
    ],
    [
      "meridien",
      0.0025
    ],
    [
      "rosace",
      0.0025
    ],
    [
      "roue",
      0.0025
    ],
    [
      "etreinte",
      0.0025
    ],
    [
      "etendue",
      0.0025
    ],
    [
      "etau",
      0.0025
    ],
    [
      "equateur",
      0.0025
    ],
    [
      "epicycle",
      0.0025
    ],
    [
      "ecliptique",
      0.0025
    ],
    [
      "tropique",
      0.0025
    ],
    [
      "tourbillon",
      0.0025
    ],
    [
      "theodolite",
      0.0025
    ],
    [
      "lobe",
      0.0025
    ],
    [
      "giration",
      0.0025
    ],
    [
      "champ",
      0.0025
    ],
    [
      "boutique",
      0.0025
    ],
    [
      "bandage",
      0.0025
    ],
    [
      "assistance",
      0.0025
    ],
    [
      "areole",
      0.0025
    ],
    [
      "armille",
      0.0025
    ],
    [
      "arcade",
      0.0025
    ],
    [
      "amphitheatre",
      0.0025
    ],
    [
      "champs",
      0.0025
    ],
    [
      "circonvolution",
      0.0025
    ],
    [
      "cirque",
      0.0025
    ],
    [
      "frette",
      0.0025
    ],
    [
      "environnement",
      0.0025
    ],
    [
      "disque",
      0.0025
    ],
    [
      "cycle",
      0.0025
    ],
    [
      "cour",
      0.0025
    ],
    [
      "colure",
      0.0025
    ],
    [
      "collier",
      0.0025
    ],
    [
      "collerette",
      0.0025
    ],
    [
      "abside",
      0.0025
    ]
  ],
  "familial": [
    [
      "domestique",
      0.285
    ],
    [
      "familier",
      0.1425
    ],
    [
      "interieur",
      0.1425
    ],
    [
      "parental",
      0.1425
    ],
    [
      "patriarcal",
      0.1425
    ],
    [
      "transmis",
      0.1425
    ]
  ],
  "projecteur": [
    [
      "appareil",
      0.1425
    ],
    [
      "luminaire",
      0.1425
    ],
    [
      "phare",
      0.1425
    ],
    [
      "reflecteur",
      0.1425
    ],
    [
      "scialytique",
      0.1425
    ],
    [
      "spot",
      0.1425
    ],
    [
      "sunlight",
      0.1425
    ]
  ],
  "discourir": [
    [
      "palabrer",
      0.1125
    ],
    [
      "parler",
      0.1125
    ],
    [
      "perorer",
      0.0875
    ],
    [
      "bavarder",
      0.075
    ],
    [
      "jaboter",
      0.0625
    ],
    [
      "pontifier",
      0.05
    ],
    [
      "haranguer",
      0.05
    ],
    [
      "disserter",
      0.05
    ],
    [
      "debiter",
      0.0375
    ],
    [
      "ergoter",
      0.0375
    ],
    [
      "precher",
      0.0375
    ],
    [
      "epiloguer",
      0.025
    ],
    [
      "traiter",
      0.025
    ],
    [
      "sermonner",
      0.025
    ],
    [
      "parlementer",
      0.025
    ],
    [
      "laiusser",
      0.025
    ],
    [
      "disputer",
      0.025
    ],
    [
      "causer",
      0.025
    ],
    [
      "baratiner",
      0.025
    ],
    [
      "patrociner",
      0.0125
    ],
    [
      "lantiponner",
      0.0125
    ],
    [
      "deconner",
      0.0125
    ],
    [
      "declamer",
      0.0125
    ],
    [
      "bavasser",
      0.0125
    ],
    [
      "allocutionner",
      0.0125
    ],
    [
      "tartiner",
      0.0125
    ]
  ],
  "discours": [
    [
      "palabrer",
      0.1125
    ],
    [
      "parler",
      0.1125
    ],
    [
      "perorer",
      0.0875
    ],
    [
      "bavarder",
      0.075
    ],
    [
      "jaboter",
      0.0625
    ],
    [
      "pontifier",
      0.05
    ],
    [
      "haranguer",
      0.05
    ],
    [
      "disserter",
      0.05
    ],
    [
      "debiter",
      0.0375
    ],
    [
      "ergoter",
      0.0375
    ],
    [
      "precher",
      0.0375
    ],
    [
      "epiloguer",
      0.025
    ],
    [
      "traiter",
      0.025
    ],
    [
      "sermonner",
      0.025
    ],
    [
      "parlementer",
      0.025
    ],
    [
      "laiusser",
      0.025
    ],
    [
      "disputer",
      0.025
    ],
    [
      "causer",
      0.025
    ],
    [
      "baratiner",
      0.025
    ],
    [
      "patrociner",
      0.0125
    ],
    [
      "lantiponner",
      0.0125
    ],
    [
      "deconner",
      0.0125
    ],
    [
      "declamer",
      0.0125
    ],
    [
      "bavasser",
      0.0125
    ],
    [
      "allocutionner",
      0.0125
    ],
    [
      "tartiner",
      0.0125
    ]
  ],
  "combat": [
    [
      "bataille",
      0.13
    ],
    [
      "lutte",
      0.1125
    ],
    [
      "dispute",
      0.055
    ],
    [
      "duel",
      0.0425
    ],
    [
      "guerre",
      0.04
    ],
    [
      "choc",
      0.0375
    ],
    [
      "querelle",
      0.0325
    ],
    [
      "conflit",
      0.0325
    ],
    [
      "competition",
      0.03
    ],
    [
      "echauffouree",
      0.03
    ],
    [
      "rixe",
      0.0275
    ],
    [
      "rivalite",
      0.0275
    ],
    [
      "affaire",
      0.0275
    ],
    [
      "accrochage",
      0.0275
    ],
    [
      "affrontement",
      0.025
    ],
    [
      "opposition",
      0.025
    ],
    [
      "bagarre",
      0.02
    ],
    [
      "engagement",
      0.02
    ],
    [
      "rencontre",
      0.02
    ],
    [
      "escarmouche",
      0.0175
    ],
    [
      "assaut",
      0.015
    ],
    [
      "contestation",
      0.015
    ],
    [
      "joute",
      0.015
    ],
    [
      "melee",
      0.015
    ],
    [
      "tournoi",
      0.0125
    ],
    [
      "baroud",
      0.0125
    ],
    [
      "antagonisme",
      0.0125
    ],
    [
      "action",
      0.0125
    ],
    [
      "feu",
      0.0075
    ],
    [
      "emulation",
      0.0075
    ],
    [
      "operation",
      0.005
    ],
    [
      "match",
      0.005
    ],
    [
      "hostilites",
      0.005
    ],
    [
      "escrime",
      0.005
    ],
    [
      "campagne",
      0.005
    ],
    [
      "savate",
      0.0025
    ],
    [
      "resistance",
      0.0025
    ],
    [
      "pugilat",
      0.0025
    ],
    [
      "partie",
      0.0025
    ],
    [
      "naumachie",
      0.0025
    ],
    [
      "hoplomachie",
      0.0025
    ],
    [
      "gigantomachie",
      0.0025
    ],
    [
      "fusillade",
      0.0025
    ],
    [
      "fureur",
      0.0025
    ],
    [
      "dechainement",
      0.0025
    ],
    [
      "debat",
      0.0025
    ],
    [
      "armes",
      0.0025
    ],
    [
      "tauromachie",
      0.0025
    ]
  ],
  "combattre": [
    [
      "lutter",
      0.135
    ],
    [
      "s'opposer",
      0.1025
    ],
    [
      "attaquer",
      0.0825
    ],
    [
      "batailler",
      0.0825
    ],
    [
      "resister",
      0.05
    ],
    [
      "heurter",
      0.05
    ],
    [
      "affronter",
      0.05
    ],
    [
      "battre",
      0.04
    ],
    [
      "contrarier",
      0.03
    ],
    [
      "s'elever",
      0.03
    ],
    [
      "maitriser",
      0.02
    ],
    [
      "guerroyer",
      0.02
    ],
    [
      "contredire",
      0.02
    ],
    [
      "braver",
      0.02
    ],
    [
      "surmonter",
      0.01
    ],
    [
      "s'evertuer",
      0.01
    ],
    [
      "s'attaquer",
      0.01
    ],
    [
      "refuter",
      0.01
    ],
    [
      "rivaliser",
      0.01
    ],
    [
      "neutraliser",
      0.01
    ],
    [
      "ferrailler",
      0.01
    ],
    [
      "barouder",
      0.01
    ],
    [
      "assaillir",
      0.01
    ]
  ],
  "cancer": [
    [
      "tumeur",
      0.2775
    ],
    [
      "lepre",
      0.11
    ],
    [
      "ulcere",
      0.055
    ],
    [
      "squirrhe",
      0.055
    ],
    [
      "sarcome",
      0.055
    ],
    [
      "neoplasme",
      0.055
    ],
    [
      "metastase",
      0.055
    ],
    [
      "leucemie",
      0.055
    ],
    [
      "gangrene",
      0.055
    ],
    [
      "fongus",
      0.055
    ],
    [
      "crabe",
      0.055
    ],
    [
      "carcinome",
      0.055
    ],
    [
      "epitheliome",
      0.055
    ]
  ],
  "eponger": [
    [
      "boire",
      0.18
    ],
    [
      "essuyer",
      0.18
    ],
    [
      "secher",
      0.18
    ],
    [
      "etancher",
      0.18
    ],
    [
      "absorber",
      0.09
    ],
    [
      "amortir",
      0.09
    ],
    [
      "ressuyer",
      0.09
    ]
  ],
  "meilleur": [
    [
      "superieur",
      0.1425
    ],
    [
      "fleur",
      0.095
    ],
    [
      "gratin",
      0.095
    ],
    [
      "preferable",
      0.095
    ],
    [
      "elite",
      0.095
    ],
    [
      "premier",
      0.0475
    ],
    [
      "mieux",
      0.0475
    ],
    [
      "grand",
      0.0475
    ],
    [
      "fleuron",
      0.0475
    ],
    [
      "excellent",
      0.0475
    ],
    [
      "creme",
      0.0475
    ],
    [
      "bon",
      0.0475
    ],
    [
      "quintessence",
      0.0475
    ]
  ],
  "fusil": [
    [
      "arquebuse",
      0.0675
    ],
    [
      "carabine",
      0.0675
    ],
    [
      "escopette",
      0.0675
    ],
    [
      "flingue",
      0.0675
    ],
    [
      "pistolet",
      0.0675
    ],
    [
      "haquebute",
      0.0325
    ],
    [
      "mitraillette",
      0.0325
    ],
    [
      "mousquet",
      0.0325
    ],
    [
      "mousqueton",
      0.0325
    ],
    [
      "petoire",
      0.0325
    ],
    [
      "rifle",
      0.0325
    ],
    [
      "sulfateuse",
      0.0325
    ],
    [
      "gosier",
      0.0325
    ],
    [
      "flingot",
      0.0325
    ],
    [
      "espingole",
      0.0325
    ],
    [
      "couleuvrine",
      0.0325
    ],
    [
      "chassepot",
      0.0325
    ],
    [
      "canardiere",
      0.0325
    ],
    [
      "briquet",
      0.0325
    ],
    [
      "affiloir",
      0.0325
    ],
    [
      "tromblon",
      0.0325
    ]
  ],
  "retour": [
    [
      "changement",
      0.085
    ],
    [
      "variation",
      0.0725
    ],
    [
      "renouveau",
      0.0625
    ],
    [
      "renouvellement",
      0.0525
    ],
    [
      "tour",
      0.0525
    ],
    [
      "recommencement",
      0.0425
    ],
    [
      "repetition",
      0.0425
    ],
    [
      "renaissance",
      0.03
    ],
    [
      "oscillation",
      0.03
    ],
    [
      "alternance",
      0.03
    ],
    [
      "evolution",
      0.02
    ],
    [
      "vicissitude",
      0.02
    ],
    [
      "truc",
      0.02
    ],
    [
      "tournant",
      0.02
    ],
    [
      "reveil",
      0.02
    ],
    [
      "ruse",
      0.02
    ],
    [
      "revirement",
      0.02
    ],
    [
      "retournement",
      0.02
    ],
    [
      "artifice",
      0.02
    ],
    [
      "coude",
      0.02
    ],
    [
      "fluctuation",
      0.02
    ],
    [
      "regain",
      0.02
    ],
    [
      "reprise",
      0.02
    ],
    [
      "revers",
      0.01
    ],
    [
      "ricochet",
      0.01
    ],
    [
      "rythme",
      0.01
    ],
    [
      "reapparition",
      0.01
    ],
    [
      "reciprocite",
      0.01
    ],
    [
      "reexpedition",
      0.01
    ],
    [
      "retroaction",
      0.01
    ],
    [
      "sinuosite",
      0.01
    ],
    [
      "revanche",
      0.01
    ],
    [
      "renvoi",
      0.01
    ],
    [
      "renversement",
      0.01
    ],
    [
      "anaphore",
      0.01
    ],
    [
      "angle",
      0.01
    ],
    [
      "astuce",
      0.01
    ],
    [
      "cercle",
      0.01
    ],
    [
      "compensation",
      0.01
    ],
    [
      "nutation",
      0.01
    ],
    [
      "plongee",
      0.01
    ],
    [
      "rentree",
      0.01
    ],
    [
      "echange",
      0.01
    ]
  ],
  "gaiete": [
    [
      "joie",
      0.1325
    ],
    [
      "entrain",
      0.1025
    ],
    [
      "allegresse",
      0.07
    ],
    [
      "enjouement",
      0.0625
    ],
    [
      "plaisir",
      0.045
    ],
    [
      "amusement",
      0.0375
    ],
    [
      "vivacite",
      0.03
    ],
    [
      "humeur",
      0.03
    ],
    [
      "euphorie",
      0.03
    ],
    [
      "satisfaction",
      0.0225
    ],
    [
      "rejouissance",
      0.0225
    ],
    [
      "plaisanterie",
      0.0225
    ],
    [
      "jubilation",
      0.0225
    ],
    [
      "humour",
      0.0225
    ],
    [
      "enthousiasme",
      0.0225
    ],
    [
      "bonheur",
      0.0225
    ],
    [
      "ardeur",
      0.0225
    ],
    [
      "alacrite",
      0.0225
    ],
    [
      "agrement",
      0.0225
    ],
    [
      "rire",
      0.015
    ],
    [
      "liesse",
      0.015
    ],
    [
      "hilarite",
      0.015
    ],
    [
      "gaillardise",
      0.015
    ],
    [
      "divertissement",
      0.015
    ],
    [
      "distraction",
      0.015
    ],
    [
      "badinage",
      0.015
    ],
    [
      "rayonnement",
      0.0075
    ],
    [
      "juvenilite",
      0.0075
    ],
    [
      "joyeusete",
      0.0075
    ],
    [
      "jovialite",
      0.0075
    ],
    [
      "ironie",
      0.0075
    ],
    [
      "goguette",
      0.0075
    ],
    [
      "folie",
      0.0075
    ],
    [
      "folichonnerie",
      0.0075
    ],
    [
      "exultation",
      0.0075
    ],
    [
      "contentement",
      0.0075
    ],
    [
      "animation",
      0.0075
    ],
    [
      "sel",
      0.0075
    ]
  ],
  "quelque": [
    [
      "environ",
      0.155
    ],
    [
      "si",
      0.075
    ],
    [
      "relatif",
      0.075
    ],
    [
      "pour",
      0.075
    ],
    [
      "certain",
      0.075
    ],
    [
      "aussi",
      0.075
    ],
    [
      "aucun",
      0.075
    ],
    [
      "approximativement",
      0.075
    ],
    [
      "un",
      0.075
    ]
  ],
  "paraitre": [
    [
      "apparence",
      0.5
    ],
    [
      "aspect",
      0.5
    ]
  ],
  "peupler": [
    [
      "hanter",
      0.2
    ],
    [
      "multiplier",
      0.2
    ],
    [
      "planter",
      0.2
    ],
    [
      "remplir",
      0.2
    ]
  ],
  "peuple": [
    [
      "hanter",
      0.2
    ],
    [
      "multiplier",
      0.2
    ],
    [
      "planter",
      0.2
    ],
    [
      "remplir",
      0.2
    ]
  ],
  "don": [
    [
      "cadeau",
      0.0525
    ],
    [
      "liberalite",
      0.05
    ],
    [
      "capacite",
      0.0475
    ],
    [
      "bienfait",
      0.045
    ],
    [
      "talent",
      0.0375
    ],
    [
      "secours",
      0.0325
    ],
    [
      "grace",
      0.0325
    ],
    [
      "faveur",
      0.0325
    ],
    [
      "faculte",
      0.0325
    ],
    [
      "disposition",
      0.0325
    ],
    [
      "gratification",
      0.03
    ],
    [
      "facilite",
      0.03
    ],
    [
      "aptitude",
      0.03
    ],
    [
      "aide",
      0.0275
    ],
    [
      "art",
      0.025
    ],
    [
      "aumone",
      0.02
    ],
    [
      "qualite",
      0.0175
    ],
    [
      "pouvoir",
      0.0175
    ],
    [
      "largesse",
      0.0175
    ],
    [
      "intelligence",
      0.0175
    ],
    [
      "genie",
      0.0175
    ],
    [
      "charite",
      0.0175
    ],
    [
      "bien",
      0.0175
    ],
    [
      "avantage",
      0.0175
    ],
    [
      "moyen",
      0.015
    ],
    [
      "habilete",
      0.015
    ],
    [
      "esprit",
      0.015
    ],
    [
      "adresse",
      0.015
    ],
    [
      "donation",
      0.0125
    ],
    [
      "offrande",
      0.0125
    ],
    [
      "present",
      0.0125
    ],
    [
      "privilege",
      0.01
    ],
    [
      "generosite",
      0.01
    ],
    [
      "gracieusete",
      0.01
    ],
    [
      "abandon",
      0.01
    ],
    [
      "sens",
      0.0075
    ],
    [
      "remise",
      0.0075
    ],
    [
      "prerogative",
      0.0075
    ],
    [
      "distribution",
      0.0075
    ],
    [
      "concession",
      0.0075
    ],
    [
      "bourse",
      0.0075
    ],
    [
      "apanage",
      0.0075
    ],
    [
      "subvention",
      0.0025
    ],
    [
      "subside",
      0.0025
    ],
    [
      "sacrifice",
      0.0025
    ],
    [
      "repartition",
      0.0025
    ],
    [
      "pourboire",
      0.0025
    ],
    [
      "instinct",
      0.0025
    ],
    [
      "oblation",
      0.0
    ],
    [
      "predisposition",
      0.0
    ],
    [
      "souvenir",
      0.0
    ],
    [
      "sportule",
      0.0
    ],
    [
      "surprise",
      0.0
    ],
    [
      "etrenne",
      0.0
    ],
    [
      "legs",
      0.0
    ],
    [
      "honnetete",
      0.0
    ],
    [
      "hommage",
      0.0
    ],
    [
      "gratuite",
      0.0
    ],
    [
      "depannage",
      0.0
    ],
    [
      "dotation",
      0.0
    ],
    [
      "charisme",
      0.0
    ],
    [
      "benediction",
      0.0
    ],
    [
      "bosse",
      0.0
    ],
    [
      "bakchich",
      0.0
    ],
    [
      "etrennes",
      0.0
    ]
  ],
  "supplement": [
    [
      "complement",
      0.1325
    ],
    [
      "addition",
      0.12
    ],
    [
      "surplus",
      0.065
    ],
    [
      "ajout",
      0.0525
    ],
    [
      "annexe",
      0.0525
    ],
    [
      "rallonge",
      0.0525
    ],
    [
      "surcroit",
      0.0375
    ],
    [
      "excedent",
      0.0375
    ],
    [
      "exces",
      0.0375
    ],
    [
      "appoint",
      0.0375
    ],
    [
      "ajoutage",
      0.0375
    ],
    [
      "difference",
      0.025
    ],
    [
      "appendice",
      0.025
    ],
    [
      "allonge",
      0.025
    ],
    [
      "ajouture",
      0.025
    ],
    [
      "addenda",
      0.025
    ],
    [
      "accessoire",
      0.025
    ],
    [
      "soulte",
      0.0125
    ],
    [
      "rabiot",
      0.0125
    ],
    [
      "preciput",
      0.0125
    ],
    [
      "extra",
      0.0125
    ],
    [
      "comble",
      0.0125
    ],
    [
      "casuel",
      0.0125
    ],
    [
      "avenant",
      0.0125
    ],
    [
      "additif",
      0.0125
    ],
    [
      "subrecot",
      0.0125
    ]
  ],
  "indefinissable": [
    [
      "indiscernable",
      0.0775
    ],
    [
      "inexplicable",
      0.0775
    ],
    [
      "insaisissable",
      0.0775
    ],
    [
      "mysterieux",
      0.0775
    ],
    [
      "enigmatique",
      0.0525
    ],
    [
      "vague",
      0.0525
    ],
    [
      "secret",
      0.0525
    ],
    [
      "inexprimable",
      0.0525
    ],
    [
      "indetermine",
      0.0525
    ],
    [
      "indistinct",
      0.0525
    ],
    [
      "impenetrable",
      0.0525
    ],
    [
      "imprecis",
      0.0525
    ],
    [
      "confus",
      0.0525
    ],
    [
      "ineffable",
      0.025
    ],
    [
      "indeterminable",
      0.025
    ],
    [
      "indefini",
      0.025
    ],
    [
      "indicible",
      0.025
    ],
    [
      "indescriptible",
      0.025
    ],
    [
      "incertain",
      0.025
    ],
    [
      "fuyant",
      0.025
    ],
    [
      "etrange",
      0.025
    ]
  ],
  "charme": [
    [
      "seduire",
      0.11
    ],
    [
      "captiver",
      0.085
    ],
    [
      "attirer",
      0.0525
    ],
    [
      "tenter",
      0.045
    ],
    [
      "fasciner",
      0.045
    ],
    [
      "exciter",
      0.045
    ],
    [
      "conquerir",
      0.045
    ],
    [
      "plaire",
      0.0375
    ],
    [
      "ravir",
      0.0375
    ],
    [
      "enchanter",
      0.03
    ],
    [
      "entrainer",
      0.03
    ],
    [
      "enflammer",
      0.0275
    ],
    [
      "gagner",
      0.0225
    ],
    [
      "envouter",
      0.0225
    ],
    [
      "ensorceler",
      0.0225
    ],
    [
      "enthousiasmer",
      0.02
    ],
    [
      "subjuguer",
      0.02
    ],
    [
      "transporter",
      0.02
    ],
    [
      "enlever",
      0.015
    ],
    [
      "flatter",
      0.015
    ],
    [
      "eblouir",
      0.0125
    ],
    [
      "enivrer",
      0.0125
    ],
    [
      "assujettir",
      0.0125
    ],
    [
      "emerveiller",
      0.01
    ],
    [
      "soumettre",
      0.01
    ],
    [
      "inviter",
      0.01
    ],
    [
      "enjoler",
      0.01
    ],
    [
      "briller",
      0.01
    ],
    [
      "bercer",
      0.01
    ],
    [
      "attacher",
      0.01
    ],
    [
      "apprivoiser",
      0.01
    ],
    [
      "rejouir",
      0.005
    ],
    [
      "regaler",
      0.005
    ],
    [
      "hypnotiser",
      0.005
    ],
    [
      "griser",
      0.005
    ],
    [
      "delecter",
      0.005
    ],
    [
      "consoler",
      0.005
    ],
    [
      "capter",
      0.005
    ],
    [
      "affrioler",
      0.005
    ],
    [
      "adoucir",
      0.005
    ],
    [
      "conjurer",
      0.0025
    ],
    [
      "complaire",
      0.0025
    ],
    [
      "chatouiller",
      0.0025
    ],
    [
      "calmer",
      0.0025
    ],
    [
      "apaiser",
      0.0025
    ]
  ],
  "tonneau": [
    [
      "baril",
      0.18
    ],
    [
      "barrique",
      0.1625
    ],
    [
      "futaille",
      0.13
    ],
    [
      "fut",
      0.065
    ],
    [
      "quartaut",
      0.0325
    ],
    [
      "gros",
      0.0325
    ],
    [
      "obese",
      0.015
    ],
    [
      "pipe",
      0.015
    ],
    [
      "piece",
      0.015
    ],
    [
      "poincon",
      0.015
    ],
    [
      "queue",
      0.015
    ],
    [
      "tine",
      0.015
    ],
    [
      "tinette",
      0.015
    ],
    [
      "tonne",
      0.015
    ],
    [
      "tonnelet",
      0.015
    ],
    [
      "muid",
      0.015
    ],
    [
      "ivrogne",
      0.015
    ],
    [
      "foudre",
      0.015
    ],
    [
      "accident",
      0.015
    ],
    [
      "bascule",
      0.015
    ],
    [
      "biberon",
      0.015
    ],
    [
      "botte",
      0.015
    ],
    [
      "boucaut",
      0.015
    ],
    [
      "bouge",
      0.015
    ],
    [
      "cabriolet",
      0.015
    ],
    [
      "caque",
      0.015
    ],
    [
      "feuillette",
      0.015
    ],
    [
      "velte",
      0.015
    ]
  ],
  "piano": [
    [
      "doucement",
      0.18
    ],
    [
      "lentement",
      0.18
    ],
    [
      "pianissimo",
      0.18
    ],
    [
      "dolce",
      0.09
    ],
    [
      "doux",
      0.09
    ]
  ],
  "montre": [
    [
      "etalage",
      0.165
    ],
    [
      "ostentation",
      0.0825
    ],
    [
      "parade",
      0.0825
    ],
    [
      "deploiement",
      0.065
    ],
    [
      "exhibition",
      0.065
    ],
    [
      "affectation",
      0.05
    ],
    [
      "vitrine",
      0.0325
    ],
    [
      "exposition",
      0.0325
    ],
    [
      "demonstration",
      0.0325
    ],
    [
      "chronometre",
      0.0325
    ],
    [
      "apparence",
      0.0325
    ],
    [
      "oignon",
      0.015
    ],
    [
      "patraque",
      0.015
    ],
    [
      "savonnette",
      0.015
    ],
    [
      "spectacle",
      0.015
    ],
    [
      "tocante",
      0.015
    ],
    [
      "vitre",
      0.015
    ],
    [
      "facade",
      0.015
    ],
    [
      "effet",
      0.015
    ],
    [
      "apparat",
      0.015
    ],
    [
      "bassinoire",
      0.015
    ],
    [
      "chique",
      0.015
    ],
    [
      "chronographe",
      0.015
    ],
    [
      "compteur",
      0.015
    ],
    [
      "coucou",
      0.015
    ],
    [
      "depense",
      0.015
    ],
    [
      "eventaire",
      0.015
    ]
  ],
  "roi": [
    [
      "monarque",
      0.1425
    ],
    [
      "prince",
      0.105
    ],
    [
      "empereur",
      0.0875
    ],
    [
      "souverain",
      0.0875
    ],
    [
      "chef",
      0.07
    ],
    [
      "tyran",
      0.035
    ],
    [
      "tresor",
      0.035
    ],
    [
      "seigneur",
      0.035
    ],
    [
      "potentat",
      0.035
    ],
    [
      "magnat",
      0.035
    ],
    [
      "despote",
      0.035
    ],
    [
      "couronne",
      0.035
    ],
    [
      "biquet",
      0.035
    ],
    [
      "autocrate",
      0.035
    ],
    [
      "schah",
      0.0175
    ],
    [
      "ponte",
      0.0175
    ],
    [
      "phenix",
      0.0175
    ],
    [
      "pharaon",
      0.0175
    ],
    [
      "majeste",
      0.0175
    ],
    [
      "khan",
      0.0175
    ],
    [
      "dynaste",
      0.0175
    ],
    [
      "cesar",
      0.0175
    ],
    [
      "sultan",
      0.0175
    ]
  ],
  "gouter": [
    [
      "collation",
      0.3325
    ],
    [
      "repas",
      0.165
    ],
    [
      "gouteron",
      0.0825
    ],
    [
      "lunch",
      0.0825
    ],
    [
      "the",
      0.0825
    ]
  ],
  "meandre": [
    [
      "detour",
      0.1475
    ],
    [
      "sinuosite",
      0.1325
    ],
    [
      "courbe",
      0.08
    ],
    [
      "tournant",
      0.065
    ],
    [
      "contour",
      0.0525
    ],
    [
      "zigzag",
      0.0525
    ],
    [
      "repli",
      0.0375
    ],
    [
      "ondulation",
      0.0375
    ],
    [
      "lacet",
      0.0375
    ],
    [
      "inflexion",
      0.0375
    ],
    [
      "courbure",
      0.0375
    ],
    [
      "truc",
      0.025
    ],
    [
      "tour",
      0.025
    ],
    [
      "ruse",
      0.025
    ],
    [
      "labyrinthe",
      0.025
    ],
    [
      "grecque",
      0.025
    ],
    [
      "dedale",
      0.025
    ],
    [
      "dessin",
      0.025
    ],
    [
      "artifice",
      0.025
    ],
    [
      "astuce",
      0.0125
    ],
    [
      "boucle",
      0.0125
    ],
    [
      "coude",
      0.0125
    ],
    [
      "frette",
      0.0125
    ]
  ],
  "message": [
    [
      "depeche",
      0.0925
    ],
    [
      "annonce",
      0.08
    ],
    [
      "avis",
      0.08
    ],
    [
      "billet",
      0.08
    ],
    [
      "lettre",
      0.08
    ],
    [
      "communication",
      0.0675
    ],
    [
      "missive",
      0.0525
    ],
    [
      "pli",
      0.0375
    ],
    [
      "note",
      0.0375
    ],
    [
      "declaration",
      0.0375
    ],
    [
      "telegramme",
      0.025
    ],
    [
      "presage",
      0.025
    ],
    [
      "information",
      0.025
    ],
    [
      "delegation",
      0.025
    ],
    [
      "discours",
      0.025
    ],
    [
      "correspondance",
      0.025
    ],
    [
      "communique",
      0.025
    ],
    [
      "bafouille",
      0.025
    ],
    [
      "prodrome",
      0.0125
    ],
    [
      "mot",
      0.0125
    ],
    [
      "flash",
      0.0125
    ],
    [
      "cable",
      0.0125
    ],
    [
      "commission",
      0.0125
    ],
    [
      "bible",
      0.0125
    ],
    [
      "babillarde",
      0.0125
    ],
    [
      "ambassade",
      0.0125
    ],
    [
      "adresse",
      0.0125
    ],
    [
      "signe",
      0.0125
    ]
  ],
  "trajectoire": [
    [
      "course",
      0.2325
    ],
    [
      "trajet",
      0.2325
    ],
    [
      "chemin",
      0.075
    ],
    [
      "espace",
      0.075
    ],
    [
      "jet",
      0.075
    ],
    [
      "mouvement",
      0.075
    ],
    [
      "orbite",
      0.075
    ],
    [
      "parabole",
      0.075
    ],
    [
      "portee",
      0.075
    ]
  ],
  "course": [
    [
      "trajet",
      0.0625
    ],
    [
      "marche",
      0.055
    ],
    [
      "promenade",
      0.055
    ],
    [
      "tour",
      0.055
    ],
    [
      "mouvement",
      0.0475
    ],
    [
      "cours",
      0.04
    ],
    [
      "circuit",
      0.0325
    ],
    [
      "randonnee",
      0.0275
    ],
    [
      "parcours",
      0.0275
    ],
    [
      "competition",
      0.0275
    ],
    [
      "allure",
      0.0275
    ],
    [
      "trajectoire",
      0.02
    ],
    [
      "tournee",
      0.02
    ],
    [
      "excursion",
      0.02
    ],
    [
      "errance",
      0.02
    ],
    [
      "demarche",
      0.02
    ],
    [
      "chevauchee",
      0.02
    ],
    [
      "chemin",
      0.02
    ],
    [
      "poursuite",
      0.0125
    ],
    [
      "succession",
      0.0125
    ],
    [
      "suite",
      0.0125
    ],
    [
      "traite",
      0.0125
    ],
    [
      "elan",
      0.0125
    ],
    [
      "emulation",
      0.0125
    ],
    [
      "incursion",
      0.0125
    ],
    [
      "fuite",
      0.0125
    ],
    [
      "carriere",
      0.0125
    ],
    [
      "distance",
      0.0125
    ],
    [
      "debandade",
      0.0125
    ],
    [
      "deplacement",
      0.0125
    ],
    [
      "emplette",
      0.0125
    ],
    [
      "espace",
      0.0125
    ],
    [
      "navette",
      0.005
    ],
    [
      "omnium",
      0.005
    ],
    [
      "rallye",
      0.005
    ],
    [
      "ruee",
      0.005
    ],
    [
      "regate",
      0.005
    ],
    [
      "trekking",
      0.005
    ],
    [
      "trot",
      0.005
    ],
    [
      "trotte",
      0.005
    ],
    [
      "turf",
      0.005
    ],
    [
      "vagabondage",
      0.005
    ],
    [
      "marathon",
      0.005
    ],
    [
      "lampadephore",
      0.005
    ],
    [
      "achat",
      0.005
    ],
    [
      "arene",
      0.005
    ],
    [
      "ascension",
      0.005
    ],
    [
      "commission",
      0.005
    ],
    [
      "coupe",
      0.005
    ],
    [
      "courtine",
      0.005
    ],
    [
      "criterium",
      0.005
    ],
    [
      "drag",
      0.005
    ],
    [
      "galop",
      0.005
    ],
    [
      "gymkhana",
      0.005
    ],
    [
      "viree",
      0.005
    ]
  ],
  "courser": [
    [
      "courir",
      0.5
    ],
    [
      "tracer",
      0.5
    ]
  ],
  "instantane": [
    [
      "rapide",
      0.25
    ],
    [
      "bref",
      0.125
    ],
    [
      "brutal",
      0.125
    ],
    [
      "prompt",
      0.125
    ],
    [
      "subit",
      0.125
    ],
    [
      "immediat",
      0.0625
    ],
    [
      "instant",
      0.0625
    ],
    [
      "photographie",
      0.0625
    ],
    [
      "soudain",
      0.0625
    ]
  ],
  "velours": [
    [
      "panne",
      0.5
    ],
    [
      "peluche",
      0.5
    ]
  ],
  "caresse": [
    [
      "cajolerie",
      0.05
    ],
    [
      "tendresse",
      0.05
    ],
    [
      "gentillesse",
      0.0375
    ],
    [
      "flatterie",
      0.0375
    ],
    [
      "douceur",
      0.0375
    ],
    [
      "chatterie",
      0.0375
    ],
    [
      "attouchement",
      0.0375
    ],
    [
      "egards",
      0.03
    ],
    [
      "pression",
      0.03
    ],
    [
      "familiarite",
      0.03
    ],
    [
      "embrassade",
      0.03
    ],
    [
      "calinerie",
      0.03
    ],
    [
      "contact",
      0.03
    ],
    [
      "chatouillement",
      0.03
    ],
    [
      "bonte",
      0.03
    ],
    [
      "amitie",
      0.03
    ],
    [
      "amabilite",
      0.03
    ],
    [
      "faveur",
      0.0175
    ],
    [
      "gaterie",
      0.0175
    ],
    [
      "mignardise",
      0.0175
    ],
    [
      "etreinte",
      0.0175
    ],
    [
      "embrassement",
      0.0175
    ],
    [
      "effleurement",
      0.0175
    ],
    [
      "delice",
      0.0175
    ],
    [
      "chatouille",
      0.0175
    ],
    [
      "blandice",
      0.0175
    ],
    [
      "baiser",
      0.0175
    ],
    [
      "mamours",
      0.0075
    ],
    [
      "mignotise",
      0.0075
    ],
    [
      "papouille",
      0.0075
    ],
    [
      "patinage",
      0.0075
    ],
    [
      "pelotage",
      0.0075
    ],
    [
      "privaute",
      0.0075
    ],
    [
      "prevenances",
      0.0075
    ],
    [
      "titillation",
      0.0075
    ],
    [
      "volupte",
      0.0075
    ],
    [
      "lechement",
      0.0075
    ],
    [
      "illusion",
      0.0075
    ],
    [
      "accolade",
      0.0075
    ],
    [
      "attention",
      0.0075
    ],
    [
      "avance",
      0.0075
    ],
    [
      "bain",
      0.0075
    ],
    [
      "becquetage",
      0.0075
    ],
    [
      "enlacement",
      0.0075
    ],
    [
      "frottement",
      0.0075
    ],
    [
      "frolement",
      0.0075
    ],
    [
      "geste",
      0.0075
    ],
    [
      "ebat",
      0.0075
    ]
  ],
  "mitrailler": [
    [
      "bombarder",
      0.3325
    ],
    [
      "arroser",
      0.165
    ],
    [
      "canonner",
      0.165
    ],
    [
      "fusiller",
      0.165
    ],
    [
      "tirer",
      0.165
    ]
  ],
  "mitraille": [
    [
      "argent",
      0.2
    ],
    [
      "ferraille",
      0.2
    ],
    [
      "monnaie",
      0.2
    ],
    [
      "projectile",
      0.2
    ]
  ],
  "plaie": [
    [
      "blessure",
      0.15
    ],
    [
      "douleur",
      0.09
    ],
    [
      "meurtrissure",
      0.09
    ],
    [
      "tourment",
      0.06
    ],
    [
      "peine",
      0.06
    ],
    [
      "mal",
      0.06
    ],
    [
      "importun",
      0.06
    ],
    [
      "contusion",
      0.06
    ],
    [
      "affliction",
      0.06
    ],
    [
      "raseur",
      0.03
    ],
    [
      "morsure",
      0.03
    ],
    [
      "maladie",
      0.03
    ],
    [
      "lesion",
      0.03
    ],
    [
      "horreur",
      0.03
    ],
    [
      "geneur",
      0.03
    ],
    [
      "fleau",
      0.03
    ],
    [
      "dechirement",
      0.03
    ],
    [
      "cautere",
      0.03
    ],
    [
      "taillade",
      0.03
    ]
  ],
  "tirailler": [
    [
      "tourmenter",
      0.1875
    ],
    [
      "dechirer",
      0.125
    ],
    [
      "harceler",
      0.125
    ],
    [
      "ecarteler",
      0.125
    ],
    [
      "tendre",
      0.06
    ],
    [
      "importuner",
      0.06
    ],
    [
      "houspiller",
      0.06
    ],
    [
      "convulser",
      0.06
    ],
    [
      "ballotter",
      0.06
    ],
    [
      "assieger",
      0.06
    ],
    [
      "tirer",
      0.06
    ]
  ],
  "palais": [
    [
      "immeuble",
      0.1425
    ],
    [
      "maison",
      0.1425
    ],
    [
      "chateau",
      0.1075
    ],
    [
      "habitation",
      0.1075
    ],
    [
      "hotel",
      0.1075
    ],
    [
      "palace",
      0.07
    ],
    [
      "voile",
      0.035
    ],
    [
      "tribunal",
      0.035
    ],
    [
      "serail",
      0.035
    ],
    [
      "monument",
      0.035
    ],
    [
      "gout",
      0.035
    ],
    [
      "demeure",
      0.035
    ],
    [
      "castel",
      0.035
    ],
    [
      "casino",
      0.035
    ],
    [
      "eveche",
      0.035
    ]
  ],
  "hier": [
    [
      "recemment",
      1.0
    ]
  ],
  "bandouliere": [
    [
      "bande",
      0.22
    ],
    [
      "baudrier",
      0.22
    ],
    [
      "buffleterie",
      0.22
    ],
    [
      "courroie",
      0.22
    ],
    [
      "bretelle",
      0.11
    ]
  ],
  "chromosome": [],
  "atmosphere": [
    [
      "air",
      0.0975
    ],
    [
      "ambiance",
      0.085
    ],
    [
      "milieu",
      0.085
    ],
    [
      "ciel",
      0.055
    ],
    [
      "climat",
      0.055
    ],
    [
      "temps",
      0.0425
    ],
    [
      "influence",
      0.0425
    ],
    [
      "espace",
      0.0425
    ],
    [
      "aura",
      0.0425
    ],
    [
      "ether",
      0.025
    ],
    [
      "emanation",
      0.025
    ],
    [
      "fluide",
      0.025
    ],
    [
      "environnement",
      0.025
    ],
    [
      "homosphere",
      0.0125
    ],
    [
      "heterosphere",
      0.0125
    ],
    [
      "ionosphere",
      0.0125
    ],
    [
      "magnetosphere",
      0.0125
    ],
    [
      "mesosphere",
      0.0125
    ],
    [
      "pascal",
      0.0125
    ],
    [
      "photosphere",
      0.0125
    ],
    [
      "pieze",
      0.0125
    ],
    [
      "stratosphere",
      0.0125
    ],
    [
      "thermosphere",
      0.0125
    ],
    [
      "touffeur",
      0.0125
    ],
    [
      "gaz",
      0.0125
    ],
    [
      "exosphere",
      0.0125
    ],
    [
      "aureole",
      0.0125
    ],
    [
      "azur",
      0.0125
    ],
    [
      "aeronomie",
      0.0125
    ],
    [
      "aerosphere",
      0.0125
    ],
    [
      "bar",
      0.0125
    ],
    [
      "barye",
      0.0125
    ],
    [
      "biosphere",
      0.0125
    ],
    [
      "chaleur",
      0.0125
    ],
    [
      "decor",
      0.0125
    ],
    [
      "entourage",
      0.0125
    ],
    [
      "enveloppe",
      0.0125
    ],
    [
      "troposphere",
      0.0125
    ]
  ],
  "taxi": [
    [
      "automobile",
      0.075
    ],
    [
      "taxoche",
      0.075
    ],
    [
      "taxite",
      0.075
    ],
    [
      "taximetre",
      0.075
    ],
    [
      "tac",
      0.075
    ],
    [
      "rongeur",
      0.075
    ],
    [
      "prostituee",
      0.075
    ],
    [
      "chauffeur",
      0.075
    ],
    [
      "bahut",
      0.075
    ],
    [
      "bagnole",
      0.075
    ],
    [
      "avion",
      0.075
    ],
    [
      "zinc",
      0.075
    ]
  ],
  "galaxie": [
    [
      "nebuleuse",
      0.4
    ],
    [
      "astre",
      0.2
    ],
    [
      "univers",
      0.2
    ]
  ],
  "tapir": [
    [
      "fuir",
      0.0525
    ],
    [
      "disparaitre",
      0.0525
    ],
    [
      "s'eclipser",
      0.035
    ],
    [
      "s'abriter",
      0.035
    ],
    [
      "s'embusquer",
      0.015
    ],
    [
      "s'accroupir",
      0.015
    ],
    [
      "eviter",
      0.015
    ]
  ],
  "tapis": [
    [
      "fuir",
      0.0525
    ],
    [
      "disparaitre",
      0.0525
    ],
    [
      "s'eclipser",
      0.035
    ],
    [
      "s'abriter",
      0.035
    ],
    [
      "s'embusquer",
      0.015
    ],
    [
      "s'accroupir",
      0.015
    ],
    [
      "eviter",
      0.015
    ]
  ],
  "volant": [
    [
      "flottant",
      0.125
    ],
    [
      "ondoyant",
      0.125
    ],
    [
      "reserve",
      0.0625
    ],
    [
      "roue",
      0.0625
    ],
    [
      "ondulant",
      0.0625
    ],
    [
      "navigant",
      0.0625
    ],
    [
      "mobile",
      0.0625
    ],
    [
      "marge",
      0.0625
    ],
    [
      "garniture",
      0.0625
    ],
    [
      "falbala",
      0.0625
    ],
    [
      "direction",
      0.0625
    ],
    [
      "bande",
      0.0625
    ],
    [
      "aerien",
      0.0625
    ],
    [
      "serpe",
      0.0625
    ]
  ],
  "maree": [
    [
      "flot",
      0.2175
    ],
    [
      "flux",
      0.13
    ],
    [
      "reflux",
      0.13
    ],
    [
      "debordement",
      0.085
    ],
    [
      "mouvement",
      0.085
    ],
    [
      "vent",
      0.0425
    ],
    [
      "vague",
      0.0425
    ],
    [
      "poisson",
      0.0425
    ],
    [
      "pluie",
      0.0425
    ],
    [
      "perdant",
      0.0425
    ],
    [
      "jusant",
      0.0425
    ],
    [
      "ebe",
      0.0425
    ]
  ],
  "refaire": [
    [
      "retablir",
      0.0625
    ],
    [
      "restaurer",
      0.0475
    ],
    [
      "tromper",
      0.0475
    ],
    [
      "rouler",
      0.045
    ],
    [
      "duper",
      0.04
    ],
    [
      "reconstituer",
      0.035
    ],
    [
      "voler",
      0.0325
    ],
    [
      "reparer",
      0.0325
    ],
    [
      "reproduire",
      0.0325
    ],
    [
      "attraper",
      0.03
    ],
    [
      "berner",
      0.03
    ],
    [
      "recommencer",
      0.03
    ],
    [
      "repeter",
      0.03
    ],
    [
      "renouveler",
      0.025
    ],
    [
      "reprendre",
      0.02
    ],
    [
      "remonter",
      0.02
    ],
    [
      "recomposer",
      0.02
    ],
    [
      "arranger",
      0.02
    ],
    [
      "reconforter",
      0.0175
    ],
    [
      "restituer",
      0.0175
    ],
    [
      "remettre",
      0.0175
    ],
    [
      "jouer",
      0.0175
    ],
    [
      "faire",
      0.0175
    ],
    [
      "avoir",
      0.0175
    ],
    [
      "revigorer",
      0.015
    ],
    [
      "rendre",
      0.015
    ],
    [
      "mystifier",
      0.015
    ],
    [
      "flouer",
      0.015
    ],
    [
      "abuser",
      0.015
    ],
    [
      "reedifier",
      0.01
    ],
    [
      "regenerer",
      0.01
    ],
    [
      "retrouver",
      0.01
    ],
    [
      "reconstruire",
      0.01
    ],
    [
      "rajuster",
      0.01
    ],
    [
      "derober",
      0.01
    ],
    [
      "carotter",
      0.01
    ],
    [
      "reiterer",
      0.005
    ],
    [
      "rhabiller",
      0.005
    ],
    [
      "requinquer",
      0.005
    ],
    [
      "renouer",
      0.005
    ],
    [
      "refondre",
      0.005
    ],
    [
      "rafraichir",
      0.005
    ],
    [
      "pigeonner",
      0.005
    ],
    [
      "gruger",
      0.005
    ],
    [
      "flamber",
      0.005
    ],
    [
      "empiler",
      0.005
    ],
    [
      "repeindre",
      0.0025
    ],
    [
      "repiquer",
      0.0025
    ],
    [
      "recidiver",
      0.0025
    ],
    [
      "recrire",
      0.0025
    ],
    [
      "reformer",
      0.0025
    ],
    [
      "refabriquer",
      0.0025
    ],
    [
      "recreer",
      0.0025
    ],
    [
      "rebatir",
      0.0025
    ],
    [
      "rebiffer",
      0.0025
    ],
    [
      "fortifier",
      0.0025
    ],
    [
      "bricoler",
      0.0025
    ],
    [
      "baiser",
      0.0025
    ],
    [
      "reediter",
      0.0025
    ]
  ],
  "refait": [
    [
      "retablir",
      0.0625
    ],
    [
      "restaurer",
      0.0475
    ],
    [
      "tromper",
      0.0475
    ],
    [
      "rouler",
      0.045
    ],
    [
      "duper",
      0.04
    ],
    [
      "reconstituer",
      0.035
    ],
    [
      "voler",
      0.0325
    ],
    [
      "reparer",
      0.0325
    ],
    [
      "reproduire",
      0.0325
    ],
    [
      "attraper",
      0.03
    ],
    [
      "berner",
      0.03
    ],
    [
      "recommencer",
      0.03
    ],
    [
      "repeter",
      0.03
    ],
    [
      "renouveler",
      0.025
    ],
    [
      "reprendre",
      0.02
    ],
    [
      "remonter",
      0.02
    ],
    [
      "recomposer",
      0.02
    ],
    [
      "arranger",
      0.02
    ],
    [
      "reconforter",
      0.0175
    ],
    [
      "restituer",
      0.0175
    ],
    [
      "remettre",
      0.0175
    ],
    [
      "jouer",
      0.0175
    ],
    [
      "faire",
      0.0175
    ],
    [
      "avoir",
      0.0175
    ],
    [
      "revigorer",
      0.015
    ],
    [
      "rendre",
      0.015
    ],
    [
      "mystifier",
      0.015
    ],
    [
      "flouer",
      0.015
    ],
    [
      "abuser",
      0.015
    ],
    [
      "reedifier",
      0.01
    ],
    [
      "regenerer",
      0.01
    ],
    [
      "retrouver",
      0.01
    ],
    [
      "reconstruire",
      0.01
    ],
    [
      "rajuster",
      0.01
    ],
    [
      "derober",
      0.01
    ],
    [
      "carotter",
      0.01
    ],
    [
      "reiterer",
      0.005
    ],
    [
      "rhabiller",
      0.005
    ],
    [
      "requinquer",
      0.005
    ],
    [
      "renouer",
      0.005
    ],
    [
      "refondre",
      0.005
    ],
    [
      "rafraichir",
      0.005
    ],
    [
      "pigeonner",
      0.005
    ],
    [
      "gruger",
      0.005
    ],
    [
      "flamber",
      0.005
    ],
    [
      "empiler",
      0.005
    ],
    [
      "repeindre",
      0.0025
    ],
    [
      "repiquer",
      0.0025
    ],
    [
      "recidiver",
      0.0025
    ],
    [
      "recrire",
      0.0025
    ],
    [
      "reformer",
      0.0025
    ],
    [
      "refabriquer",
      0.0025
    ],
    [
      "recreer",
      0.0025
    ],
    [
      "rebatir",
      0.0025
    ],
    [
      "rebiffer",
      0.0025
    ],
    [
      "fortifier",
      0.0025
    ],
    [
      "bricoler",
      0.0025
    ],
    [
      "baiser",
      0.0025
    ],
    [
      "reediter",
      0.0025
    ]
  ],
  "poussiere": [
    [
      "debris",
      0.0825
    ],
    [
      "vetille",
      0.0525
    ],
    [
      "salete",
      0.0525
    ],
    [
      "rien",
      0.0525
    ],
    [
      "reste",
      0.0525
    ],
    [
      "particule",
      0.0525
    ],
    [
      "ordure",
      0.0525
    ],
    [
      "detritus",
      0.0525
    ],
    [
      "cendre",
      0.0525
    ],
    [
      "bagatelle",
      0.0525
    ],
    [
      "myriade",
      0.025
    ],
    [
      "pollen",
      0.025
    ],
    [
      "pollution",
      0.025
    ],
    [
      "poudre",
      0.025
    ],
    [
      "poussier",
      0.025
    ],
    [
      "pruine",
      0.025
    ],
    [
      "mouton",
      0.025
    ],
    [
      "misere",
      0.025
    ],
    [
      "fumee",
      0.025
    ],
    [
      "envol",
      0.025
    ],
    [
      "depouilles",
      0.025
    ],
    [
      "cendres",
      0.025
    ],
    [
      "broutille",
      0.025
    ],
    [
      "balayure",
      0.025
    ],
    [
      "atome",
      0.025
    ],
    [
      "retombee",
      0.025
    ]
  ],
  "animaux": [
    [
      "bete",
      0.13
    ],
    [
      "grossier",
      0.105
    ],
    [
      "materiel",
      0.105
    ],
    [
      "bestial",
      0.0775
    ],
    [
      "brute",
      0.0775
    ],
    [
      "charnel",
      0.0775
    ],
    [
      "stupide",
      0.0525
    ],
    [
      "sensuel",
      0.0525
    ],
    [
      "physique",
      0.0525
    ],
    [
      "brutal",
      0.0525
    ],
    [
      "pecore",
      0.025
    ],
    [
      "organique",
      0.025
    ],
    [
      "instinctif",
      0.025
    ],
    [
      "inne",
      0.025
    ],
    [
      "bestiole",
      0.025
    ],
    [
      "ballot",
      0.025
    ],
    [
      "abruti",
      0.025
    ],
    [
      "spontane",
      0.025
    ]
  ],
  "animal": [
    [
      "bete",
      0.13
    ],
    [
      "grossier",
      0.105
    ],
    [
      "materiel",
      0.105
    ],
    [
      "bestial",
      0.0775
    ],
    [
      "brute",
      0.0775
    ],
    [
      "charnel",
      0.0775
    ],
    [
      "stupide",
      0.0525
    ],
    [
      "sensuel",
      0.0525
    ],
    [
      "physique",
      0.0525
    ],
    [
      "brutal",
      0.0525
    ],
    [
      "pecore",
      0.025
    ],
    [
      "organique",
      0.025
    ],
    [
      "instinctif",
      0.025
    ],
    [
      "inne",
      0.025
    ],
    [
      "bestiole",
      0.025
    ],
    [
      "ballot",
      0.025
    ],
    [
      "abruti",
      0.025
    ],
    [
      "spontane",
      0.025
    ]
  ],
  "coder": [
    [
      "chiffrer",
      0.5
    ],
    [
      "encoder",
      0.5
    ]
  ],
  "code": [
    [
      "loi",
      0.115
    ],
    [
      "reglement",
      0.115
    ],
    [
      "convention",
      0.0675
    ],
    [
      "droit",
      0.0675
    ],
    [
      "evangile",
      0.045
    ],
    [
      "statut",
      0.045
    ],
    [
      "recueil",
      0.045
    ],
    [
      "norme",
      0.045
    ],
    [
      "ceremonie",
      0.045
    ],
    [
      "convenance",
      0.045
    ],
    [
      "catechisme",
      0.045
    ],
    [
      "phare",
      0.02
    ],
    [
      "methode",
      0.02
    ],
    [
      "legislation",
      0.02
    ],
    [
      "langue",
      0.02
    ],
    [
      "langage",
      0.02
    ],
    [
      "information",
      0.02
    ],
    [
      "feu",
      0.02
    ],
    [
      "digeste",
      0.02
    ],
    [
      "ceremonial",
      0.02
    ],
    [
      "conversion",
      0.02
    ],
    [
      "collection",
      0.02
    ],
    [
      "codification",
      0.02
    ],
    [
      "chiffre",
      0.02
    ],
    [
      "precis",
      0.02
    ]
  ],
  "radio": [
    [
      "T.S.F.",
      0.11
    ],
    [
      "tuner",
      0.055
    ],
    [
      "transistor",
      0.055
    ],
    [
      "radiotelephone",
      0.055
    ],
    [
      "radiotelegraphie",
      0.055
    ],
    [
      "radiosoleil",
      0.055
    ],
    [
      "radiophonie",
      0.055
    ],
    [
      "radionavigant",
      0.055
    ],
    [
      "radiographie",
      0.055
    ],
    [
      "radioamateur",
      0.055
    ],
    [
      "poste",
      0.055
    ],
    [
      "hertzien",
      0.055
    ],
    [
      "appareil",
      0.055
    ],
    [
      "telegramme",
      0.055
    ]
  ],
  "demi": [
    [
      "moitie",
      0.1675
    ],
    [
      "verre",
      0.1675
    ],
    [
      "presque",
      0.0825
    ],
    [
      "pinte",
      0.0825
    ],
    [
      "partiellement",
      0.0825
    ],
    [
      "formidable",
      0.0825
    ],
    [
      "deux",
      0.0825
    ],
    [
      "bock",
      0.0825
    ],
    [
      "semi",
      0.0825
    ]
  ],
  "laid": [
    [
      "affreux",
      0.08
    ],
    [
      "abject",
      0.0525
    ],
    [
      "horrible",
      0.0525
    ],
    [
      "repugnant",
      0.0525
    ],
    [
      "ignoble",
      0.05
    ],
    [
      "degoutant",
      0.0425
    ],
    [
      "repoussant",
      0.04
    ],
    [
      "difforme",
      0.035
    ],
    [
      "mauvais",
      0.035
    ],
    [
      "vilain",
      0.035
    ],
    [
      "honteux",
      0.03
    ],
    [
      "sale",
      0.0275
    ],
    [
      "hideux",
      0.0275
    ],
    [
      "desagreable",
      0.0275
    ],
    [
      "infame",
      0.025
    ],
    [
      "vil",
      0.025
    ],
    [
      "abominable",
      0.0225
    ],
    [
      "indigne",
      0.0225
    ],
    [
      "monstrueux",
      0.0225
    ],
    [
      "bas",
      0.02
    ],
    [
      "atroce",
      0.015
    ],
    [
      "disgracieux",
      0.015
    ],
    [
      "immoral",
      0.015
    ],
    [
      "malbati",
      0.015
    ],
    [
      "obscene",
      0.015
    ],
    [
      "ingrat",
      0.0125
    ],
    [
      "deplaisant",
      0.0125
    ],
    [
      "revoltant",
      0.0075
    ],
    [
      "moche",
      0.0075
    ],
    [
      "malhonnete",
      0.0075
    ],
    [
      "informe",
      0.0075
    ],
    [
      "effrayant",
      0.0075
    ],
    [
      "deshonnete",
      0.0075
    ],
    [
      "tarte",
      0.005
    ],
    [
      "malplaisant",
      0.005
    ],
    [
      "inelegant",
      0.005
    ],
    [
      "disgracie",
      0.005
    ],
    [
      "contrefait",
      0.005
    ],
    [
      "bleche",
      0.005
    ],
    [
      "malseant",
      0.0
    ],
    [
      "mal",
      0.0
    ],
    [
      "magot",
      0.0
    ],
    [
      "inesthetique",
      0.0
    ],
    [
      "enlaidi",
      0.0
    ],
    [
      "effroyable",
      0.0
    ],
    [
      "deforme",
      0.0
    ],
    [
      "defigure",
      0.0
    ],
    [
      "pendable",
      0.0
    ]
  ],
  "parent": [
    [
      "germain",
      0.1
    ],
    [
      "semblable",
      0.1
    ],
    [
      "ancetre",
      0.0725
    ],
    [
      "frere",
      0.0725
    ],
    [
      "pere",
      0.0475
    ],
    [
      "geniteur",
      0.0475
    ],
    [
      "consanguin",
      0.0475
    ],
    [
      "analogue",
      0.0475
    ],
    [
      "agnat",
      0.0475
    ],
    [
      "tante",
      0.0225
    ],
    [
      "procreateur",
      0.0225
    ],
    [
      "proche",
      0.0225
    ],
    [
      "oncle",
      0.0225
    ],
    [
      "mere",
      0.0225
    ],
    [
      "cousin",
      0.0225
    ],
    [
      "congenere",
      0.0225
    ],
    [
      "collateral",
      0.0225
    ],
    [
      "cognat",
      0.0225
    ],
    [
      "aieul",
      0.0225
    ],
    [
      "ascendant",
      0.0225
    ],
    [
      "apparente",
      0.0225
    ],
    [
      "analogique",
      0.0225
    ],
    [
      "allie",
      0.0225
    ],
    [
      "affin",
      0.0225
    ],
    [
      "uterin",
      0.0225
    ]
  ],
  "ecrit": [
    [
      "faire",
      0.0625
    ],
    [
      "donner",
      0.055
    ],
    [
      "produire",
      0.055
    ],
    [
      "marquer",
      0.05
    ],
    [
      "composer",
      0.045
    ],
    [
      "reveler",
      0.04
    ],
    [
      "former",
      0.04
    ],
    [
      "exposer",
      0.04
    ],
    [
      "fixer",
      0.0325
    ],
    [
      "publier",
      0.0275
    ],
    [
      "poser",
      0.0275
    ],
    [
      "montrer",
      0.0275
    ],
    [
      "exprimer",
      0.0275
    ],
    [
      "mettre",
      0.02
    ],
    [
      "travailler",
      0.015
    ],
    [
      "tracer",
      0.015
    ],
    [
      "rediger",
      0.015
    ],
    [
      "noter",
      0.015
    ],
    [
      "mander",
      0.015
    ],
    [
      "inscrire",
      0.015
    ],
    [
      "informer",
      0.015
    ],
    [
      "griffonner",
      0.015
    ],
    [
      "accoucher",
      0.015
    ],
    [
      "avancer",
      0.015
    ],
    [
      "communiquer",
      0.015
    ],
    [
      "creer",
      0.015
    ],
    [
      "dresser",
      0.015
    ],
    [
      "enoncer",
      0.01
    ],
    [
      "ecrivasser",
      0.01
    ],
    [
      "ecrivailler",
      0.01
    ],
    [
      "transcrire",
      0.01
    ],
    [
      "soutenir",
      0.01
    ],
    [
      "graver",
      0.01
    ],
    [
      "crayonner",
      0.01
    ],
    [
      "copier",
      0.01
    ],
    [
      "ponctuer",
      0.005
    ],
    [
      "pondre",
      0.005
    ],
    [
      "recopier",
      0.005
    ],
    [
      "roler",
      0.005
    ],
    [
      "scribouiller",
      0.005
    ],
    [
      "stenographier",
      0.005
    ],
    [
      "stenotyper",
      0.005
    ],
    [
      "taper",
      0.005
    ],
    [
      "tartiner",
      0.005
    ],
    [
      "orthographier",
      0.005
    ],
    [
      "minuter",
      0.005
    ],
    [
      "libeller",
      0.005
    ],
    [
      "barbouiller",
      0.005
    ],
    [
      "calligraphier",
      0.005
    ],
    [
      "consigner",
      0.005
    ],
    [
      "correspondre",
      0.005
    ],
    [
      "dactylographier",
      0.005
    ],
    [
      "demontrer",
      0.005
    ],
    [
      "forger",
      0.005
    ],
    [
      "gratter",
      0.005
    ],
    [
      "gribouiller",
      0.005
    ],
    [
      "elucubrer",
      0.005
    ]
  ],
  "rai": [
    [
      "raie",
      0.5
    ],
    [
      "rayon",
      0.5
    ]
  ],
  "poli": [
    [
      "delicat",
      0.065
    ],
    [
      "courtois",
      0.055
    ],
    [
      "gracieux",
      0.0525
    ],
    [
      "honnete",
      0.0475
    ],
    [
      "aimable",
      0.04
    ],
    [
      "beau",
      0.04
    ],
    [
      "civil",
      0.0375
    ],
    [
      "distingue",
      0.035
    ],
    [
      "galant",
      0.0325
    ],
    [
      "affable",
      0.0275
    ],
    [
      "brillant",
      0.0275
    ],
    [
      "correct",
      0.0225
    ],
    [
      "prevenant",
      0.0225
    ],
    [
      "serviable",
      0.0225
    ],
    [
      "elegant",
      0.0225
    ],
    [
      "travaille",
      0.0175
    ],
    [
      "soigne",
      0.0175
    ],
    [
      "leche",
      0.0175
    ],
    [
      "lustre",
      0.0175
    ],
    [
      "bienseant",
      0.0175
    ],
    [
      "luisant",
      0.015
    ],
    [
      "reserve",
      0.01
    ],
    [
      "retenu",
      0.01
    ],
    [
      "net",
      0.01
    ],
    [
      "lisse",
      0.01
    ],
    [
      "deferent",
      0.01
    ],
    [
      "clair",
      0.01
    ],
    [
      "lustre",
      0.0075
    ],
    [
      "perle",
      0.0075
    ],
    [
      "raffine",
      0.0075
    ],
    [
      "reverencieux",
      0.0075
    ],
    [
      "sociable",
      0.0075
    ],
    [
      "eclatant",
      0.0075
    ],
    [
      "glace",
      0.0075
    ],
    [
      "fini",
      0.0075
    ],
    [
      "amene",
      0.0075
    ],
    [
      "civilise",
      0.0075
    ],
    [
      "complaisant",
      0.0075
    ],
    [
      "convenable",
      0.0075
    ],
    [
      "decent",
      0.0075
    ],
    [
      "fignole",
      0.0075
    ],
    [
      "etincelant",
      0.005
    ],
    [
      "eclat",
      0.005
    ],
    [
      "uni",
      0.005
    ],
    [
      "satine",
      0.005
    ],
    [
      "police",
      0.005
    ],
    [
      "obsequieux",
      0.005
    ],
    [
      "frotte",
      0.005
    ],
    [
      "discret",
      0.005
    ],
    [
      "cisele",
      0.005
    ],
    [
      "calamistre",
      0.005
    ],
    [
      "astique",
      0.005
    ],
    [
      "peigne",
      0.0025
    ],
    [
      "polissure",
      0.0025
    ],
    [
      "respectueux",
      0.0025
    ],
    [
      "sortable",
      0.0025
    ],
    [
      "urbain",
      0.0025
    ],
    [
      "verni",
      0.0025
    ],
    [
      "diplomate",
      0.0025
    ],
    [
      "ceremonieux",
      0.0025
    ],
    [
      "clarte",
      0.0025
    ],
    [
      "chatie",
      0.0025
    ],
    [
      "brunissure",
      0.0025
    ],
    [
      "bruni",
      0.0025
    ],
    [
      "brique",
      0.0025
    ],
    [
      "apprivoise",
      0.0025
    ],
    [
      "eduque",
      0.0025
    ]
  ],
  "polir": [
    [
      "faconner",
      0.06
    ],
    [
      "parfaire",
      0.0525
    ],
    [
      "former",
      0.05
    ],
    [
      "faire",
      0.035
    ],
    [
      "fignoler",
      0.035
    ],
    [
      "soigner",
      0.0325
    ],
    [
      "frotter",
      0.03
    ],
    [
      "eduquer",
      0.03
    ],
    [
      "travailler",
      0.025
    ],
    [
      "lecher",
      0.025
    ],
    [
      "cultiver",
      0.025
    ],
    [
      "ciseler",
      0.025
    ],
    [
      "chatier",
      0.0225
    ],
    [
      "degrossir",
      0.0225
    ],
    [
      "limer",
      0.0225
    ],
    [
      "perler",
      0.02
    ],
    [
      "perfectionner",
      0.02
    ],
    [
      "nettoyer",
      0.02
    ],
    [
      "dresser",
      0.02
    ],
    [
      "corriger",
      0.02
    ],
    [
      "astiquer",
      0.02
    ],
    [
      "raboter",
      0.0175
    ],
    [
      "parachever",
      0.015
    ],
    [
      "lustrer",
      0.015
    ],
    [
      "finir",
      0.015
    ],
    [
      "civiliser",
      0.015
    ],
    [
      "apprivoiser",
      0.015
    ],
    [
      "affiner",
      0.015
    ],
    [
      "adoucir",
      0.015
    ],
    [
      "user",
      0.01
    ],
    [
      "assouplir",
      0.01
    ],
    [
      "aplanir",
      0.01
    ],
    [
      "eclaircir",
      0.0075
    ],
    [
      "revoir",
      0.0075
    ],
    [
      "policer",
      0.0075
    ],
    [
      "peigner",
      0.0075
    ],
    [
      "peaufiner",
      0.0075
    ],
    [
      "derouiller",
      0.0075
    ],
    [
      "defricher",
      0.0075
    ],
    [
      "composer",
      0.0075
    ],
    [
      "orner",
      0.005
    ],
    [
      "planer",
      0.005
    ],
    [
      "roder",
      0.005
    ],
    [
      "terminer",
      0.005
    ],
    [
      "unir",
      0.005
    ],
    [
      "lisser",
      0.005
    ],
    [
      "fourbir",
      0.005
    ],
    [
      "fouiller",
      0.005
    ],
    [
      "decrasser",
      0.005
    ],
    [
      "brosser",
      0.005
    ],
    [
      "aiguiser",
      0.005
    ],
    [
      "greser",
      0.0025
    ],
    [
      "poncer",
      0.0025
    ],
    [
      "pourlecher",
      0.0025
    ],
    [
      "ragreer",
      0.0025
    ],
    [
      "egaliser",
      0.0025
    ],
    [
      "egriser",
      0.0025
    ],
    [
      "gratteler",
      0.0025
    ],
    [
      "glacer",
      0.0025
    ],
    [
      "debrutir",
      0.0025
    ],
    [
      "debarbouiller",
      0.0025
    ],
    [
      "doucir",
      0.0025
    ],
    [
      "brunir",
      0.0025
    ],
    [
      "aleser",
      0.0025
    ],
    [
      "epurer",
      0.0025
    ]
  ],
  "tele": [
    [
      "televiseur",
      0.3325
    ],
    [
      "television",
      0.3325
    ],
    [
      "teve",
      0.3325
    ]
  ],
  "abuser": [
    [
      "tromper",
      0.19
    ],
    [
      "berner",
      0.1075
    ],
    [
      "seduire",
      0.055
    ],
    [
      "duper",
      0.0525
    ],
    [
      "leurrer",
      0.0475
    ],
    [
      "enjoler",
      0.045
    ],
    [
      "attraper",
      0.035
    ],
    [
      "mystifier",
      0.0325
    ],
    [
      "rouler",
      0.0325
    ],
    [
      "amuser",
      0.0275
    ],
    [
      "capter",
      0.0225
    ],
    [
      "embabouiner",
      0.02
    ],
    [
      "mentir",
      0.0175
    ],
    [
      "jouer",
      0.015
    ],
    [
      "surprendre",
      0.0125
    ],
    [
      "empaumer",
      0.0125
    ],
    [
      "embobiner",
      0.0125
    ],
    [
      "decevoir",
      0.0125
    ],
    [
      "refaire",
      0.01
    ],
    [
      "posseder",
      0.01
    ],
    [
      "pigeonner",
      0.01
    ],
    [
      "flatter",
      0.01
    ],
    [
      "exagerer",
      0.01
    ],
    [
      "bluffer",
      0.01
    ],
    [
      "eblouir",
      0.0075
    ],
    [
      "trahir",
      0.0075
    ],
    [
      "piper",
      0.0075
    ],
    [
      "escroquer",
      0.0075
    ],
    [
      "carotter",
      0.0075
    ],
    [
      "bercer",
      0.0075
    ],
    [
      "violer",
      0.0025
    ],
    [
      "violenter",
      0.0025
    ],
    [
      "entuber",
      0.0025
    ],
    [
      "enfiler",
      0.0025
    ],
    [
      "couillonner",
      0.0025
    ],
    [
      "attirer",
      0.0025
    ],
    [
      "blouser",
      0.0025
    ],
    [
      "charrier",
      0.0025
    ],
    [
      "circonvenir",
      0.0025
    ],
    [
      "mesuser",
      0.0
    ],
    [
      "outrepasser",
      0.0
    ],
    [
      "parasiter",
      0.0
    ],
    [
      "repaitre",
      0.0
    ],
    [
      "s'amuser",
      0.0
    ],
    [
      "tyranniser",
      0.0
    ],
    [
      "imposer",
      0.0
    ],
    [
      "impatienter",
      0.0
    ],
    [
      "agir",
      0.0
    ],
    [
      "attiger",
      0.0
    ],
    [
      "canuler",
      0.0
    ],
    [
      "croire",
      0.0
    ],
    [
      "deshonorer",
      0.0
    ],
    [
      "empapaouter",
      0.0
    ],
    [
      "entourlouper",
      0.0
    ],
    [
      "exploiter",
      0.0
    ],
    [
      "feindre",
      0.0
    ],
    [
      "egarer",
      0.0
    ]
  ],
  "appris": [
    [
      "instruire",
      0.06
    ],
    [
      "reveler",
      0.0525
    ],
    [
      "annoncer",
      0.0475
    ],
    [
      "indiquer",
      0.0475
    ],
    [
      "signaler",
      0.045
    ],
    [
      "enseigner",
      0.04
    ],
    [
      "montrer",
      0.04
    ],
    [
      "expliquer",
      0.0325
    ],
    [
      "dire",
      0.03
    ],
    [
      "avertir",
      0.02
    ],
    [
      "communiquer",
      0.02
    ],
    [
      "informer",
      0.02
    ],
    [
      "eclairer",
      0.02
    ],
    [
      "declarer",
      0.0175
    ],
    [
      "etudier",
      0.0125
    ],
    [
      "eduquer",
      0.0125
    ],
    [
      "styler",
      0.0125
    ],
    [
      "absorber",
      0.0125
    ],
    [
      "comprendre",
      0.01
    ],
    [
      "decouvrir",
      0.01
    ],
    [
      "initier",
      0.01
    ],
    [
      "renseigner",
      0.01
    ],
    [
      "repeter",
      0.01
    ],
    [
      "travailler",
      0.0075
    ],
    [
      "s'instruire",
      0.0075
    ],
    [
      "s'appliquer",
      0.0075
    ],
    [
      "exercer",
      0.0075
    ],
    [
      "repasser",
      0.005
    ],
    [
      "s'exercer",
      0.005
    ],
    [
      "s'impregner",
      0.005
    ],
    [
      "s'intoxiquer",
      0.005
    ],
    [
      "savoir",
      0.005
    ],
    [
      "professer",
      0.005
    ],
    [
      "guider",
      0.005
    ],
    [
      "assimiler",
      0.005
    ],
    [
      "avaler",
      0.005
    ],
    [
      "connaitre",
      0.005
    ],
    [
      "cultiver",
      0.005
    ],
    [
      "degrossir",
      0.005
    ],
    [
      "deniaiser",
      0.005
    ],
    [
      "ruminer",
      0.0025
    ],
    [
      "s'abreuver",
      0.0025
    ],
    [
      "s'abrutir",
      0.0025
    ],
    [
      "s'habituer",
      0.0025
    ],
    [
      "s'initier",
      0.0025
    ],
    [
      "remacher",
      0.0025
    ],
    [
      "aviser",
      0.0025
    ],
    [
      "bourrer",
      0.0025
    ],
    [
      "digerer",
      0.0025
    ],
    [
      "dresser",
      0.0025
    ],
    [
      "debrouiller",
      0.0025
    ],
    [
      "degourdir",
      0.0025
    ],
    [
      "demontrer",
      0.0025
    ],
    [
      "ingurgiter",
      0.0025
    ],
    [
      "inculquer",
      0.0025
    ],
    [
      "habituer",
      0.0025
    ],
    [
      "enfoncer",
      0.0025
    ],
    [
      "endoctriner",
      0.0025
    ],
    [
      "s'assommer",
      0.0
    ],
    [
      "s'enfoncer",
      0.0
    ],
    [
      "souffler",
      0.0
    ],
    [
      "suivre",
      0.0
    ],
    [
      "s'acharner",
      0.0
    ],
    [
      "s'accoutumer",
      0.0
    ],
    [
      "abreuver",
      0.0
    ],
    [
      "apporter",
      0.0
    ],
    [
      "approfondir",
      0.0
    ],
    [
      "bachoter",
      0.0
    ],
    [
      "dessaler",
      0.0
    ],
    [
      "macher",
      0.0
    ],
    [
      "profiter",
      0.0
    ],
    [
      "rabacher",
      0.0
    ],
    [
      "retenir",
      0.0
    ],
    [
      "reviser",
      0.0
    ],
    [
      "transmettre",
      0.0
    ]
  ],
  "purete": [
    [
      "honnetete",
      0.075
    ],
    [
      "vertu",
      0.075
    ],
    [
      "simplicite",
      0.05
    ],
    [
      "elegance",
      0.0425
    ],
    [
      "pudeur",
      0.0425
    ],
    [
      "nettete",
      0.0425
    ],
    [
      "fraicheur",
      0.0425
    ],
    [
      "candeur",
      0.0425
    ],
    [
      "sincerite",
      0.0325
    ],
    [
      "naivete",
      0.0325
    ],
    [
      "grace",
      0.0325
    ],
    [
      "chastete",
      0.0325
    ],
    [
      "beaute",
      0.0325
    ],
    [
      "proprete",
      0.025
    ],
    [
      "probite",
      0.025
    ],
    [
      "integrite",
      0.025
    ],
    [
      "innocence",
      0.025
    ],
    [
      "ingenuite",
      0.025
    ],
    [
      "honneur",
      0.025
    ],
    [
      "delicatesse",
      0.025
    ],
    [
      "correction",
      0.025
    ],
    [
      "virginite",
      0.015
    ],
    [
      "propriete",
      0.015
    ],
    [
      "perfection",
      0.015
    ],
    [
      "limpidite",
      0.015
    ],
    [
      "droiture",
      0.015
    ],
    [
      "continence",
      0.015
    ],
    [
      "clarte",
      0.015
    ],
    [
      "blancheur",
      0.015
    ],
    [
      "purisme",
      0.0075
    ],
    [
      "originalite",
      0.0075
    ],
    [
      "finesse",
      0.0075
    ],
    [
      "cristal",
      0.0075
    ],
    [
      "calme",
      0.0075
    ],
    [
      "authenticite",
      0.0075
    ],
    [
      "adequation",
      0.0075
    ],
    [
      "serenite",
      0.0075
    ]
  ],
  "former": [
    [
      "faire",
      0.0825
    ],
    [
      "faconner",
      0.0675
    ],
    [
      "construire",
      0.05
    ],
    [
      "composer",
      0.04
    ],
    [
      "creer",
      0.035
    ],
    [
      "instruire",
      0.035
    ],
    [
      "produire",
      0.0325
    ],
    [
      "eduquer",
      0.0325
    ],
    [
      "preparer",
      0.0275
    ],
    [
      "dresser",
      0.0275
    ],
    [
      "cultiver",
      0.025
    ],
    [
      "polir",
      0.025
    ],
    [
      "constituer",
      0.02
    ],
    [
      "arranger",
      0.02
    ],
    [
      "exercer",
      0.02
    ],
    [
      "styler",
      0.02
    ],
    [
      "etablir",
      0.0175
    ],
    [
      "elaborer",
      0.0175
    ],
    [
      "fabriquer",
      0.0175
    ],
    [
      "exposer",
      0.0175
    ],
    [
      "forger",
      0.0175
    ],
    [
      "organiser",
      0.0175
    ],
    [
      "elever",
      0.0175
    ],
    [
      "donner",
      0.015
    ],
    [
      "batir",
      0.0125
    ],
    [
      "presenter",
      0.0125
    ],
    [
      "degrossir",
      0.01
    ],
    [
      "ecrire",
      0.01
    ],
    [
      "representer",
      0.01
    ],
    [
      "habituer",
      0.01
    ],
    [
      "entrainer",
      0.01
    ],
    [
      "fonder",
      0.0075
    ],
    [
      "enoncer",
      0.005
    ],
    [
      "nourrir",
      0.005
    ],
    [
      "modeler",
      0.005
    ],
    [
      "instituer",
      0.005
    ],
    [
      "imaginer",
      0.005
    ],
    [
      "exprimer",
      0.005
    ],
    [
      "enseigner",
      0.005
    ],
    [
      "determiner",
      0.005
    ],
    [
      "dessiner",
      0.005
    ],
    [
      "tracer",
      0.005
    ],
    [
      "soigner",
      0.005
    ],
    [
      "petrir",
      0.005
    ],
    [
      "parfaire",
      0.005
    ],
    [
      "initier",
      0.005
    ],
    [
      "developper",
      0.005
    ],
    [
      "concevoir",
      0.005
    ],
    [
      "assembler",
      0.005
    ],
    [
      "rompre",
      0.0025
    ],
    [
      "perfectionner",
      0.0025
    ],
    [
      "offrir",
      0.0025
    ],
    [
      "degourdir",
      0.0025
    ],
    [
      "defricher",
      0.0025
    ],
    [
      "commencer",
      0.0025
    ],
    [
      "causer",
      0.0025
    ],
    [
      "articuler",
      0.0025
    ],
    [
      "amenager",
      0.0025
    ],
    [
      "policer",
      0.0025
    ],
    [
      "recomposer",
      0.0025
    ],
    [
      "reunir",
      0.0025
    ],
    [
      "sculpter",
      0.0025
    ],
    [
      "eclairer",
      0.0025
    ],
    [
      "mouler",
      0.0025
    ],
    [
      "formuler",
      0.0025
    ],
    [
      "assouplir",
      0.0025
    ],
    [
      "catechiser",
      0.0025
    ],
    [
      "discipliner",
      0.0025
    ],
    [
      "decrasser",
      0.0025
    ],
    [
      "familiariser",
      0.0025
    ],
    [
      "procreer",
      0.0
    ],
    [
      "lettrer",
      0.0
    ],
    [
      "gouverner",
      0.0
    ],
    [
      "desencrouter",
      0.0
    ],
    [
      "decrotter",
      0.0
    ],
    [
      "contracter",
      0.0
    ],
    [
      "conformer",
      0.0
    ],
    [
      "configurer",
      0.0
    ],
    [
      "etre",
      0.0
    ]
  ],
  "forme": [
    [
      "tournure",
      0.055
    ],
    [
      "allure",
      0.05
    ],
    [
      "genre",
      0.0475
    ],
    [
      "figure",
      0.035
    ],
    [
      "style",
      0.035
    ],
    [
      "facon",
      0.0325
    ],
    [
      "aspect",
      0.0325
    ],
    [
      "tour",
      0.03
    ],
    [
      "visage",
      0.025
    ],
    [
      "type",
      0.025
    ],
    [
      "expression",
      0.025
    ],
    [
      "apparence",
      0.025
    ],
    [
      "air",
      0.025
    ],
    [
      "maniere",
      0.02
    ],
    [
      "image",
      0.0175
    ],
    [
      "silhouette",
      0.0175
    ],
    [
      "structure",
      0.0175
    ],
    [
      "ton",
      0.015
    ],
    [
      "regle",
      0.015
    ],
    [
      "modele",
      0.015
    ],
    [
      "ligne",
      0.015
    ],
    [
      "gabarit",
      0.015
    ],
    [
      "etat",
      0.0125
    ],
    [
      "semblance",
      0.0125
    ],
    [
      "marche",
      0.0125
    ],
    [
      "exterieur",
      0.0125
    ],
    [
      "disposition",
      0.0125
    ],
    [
      "dessin",
      0.0125
    ],
    [
      "constitution",
      0.0125
    ],
    [
      "configuration",
      0.0125
    ],
    [
      "regime",
      0.01
    ],
    [
      "mode",
      0.01
    ],
    [
      "modalite",
      0.01
    ],
    [
      "formule",
      0.01
    ],
    [
      "formalite",
      0.01
    ],
    [
      "demarche",
      0.01
    ],
    [
      "contour",
      0.01
    ],
    [
      "conduite",
      0.01
    ],
    [
      "vision",
      0.0075
    ],
    [
      "sorte",
      0.0075
    ],
    [
      "patron",
      0.0075
    ],
    [
      "organisation",
      0.0075
    ],
    [
      "ombre",
      0.0075
    ],
    [
      "dehors",
      0.0075
    ],
    [
      "convenance",
      0.0075
    ],
    [
      "conformation",
      0.0075
    ],
    [
      "condition",
      0.0075
    ],
    [
      "architecture",
      0.0075
    ],
    [
      "anatomie",
      0.0075
    ],
    [
      "travail",
      0.005
    ],
    [
      "trace",
      0.005
    ],
    [
      "statut",
      0.005
    ],
    [
      "plastique",
      0.005
    ],
    [
      "moule",
      0.005
    ],
    [
      "modele",
      0.005
    ],
    [
      "locution",
      0.005
    ],
    [
      "format",
      0.005
    ],
    [
      "phase",
      0.0
    ],
    [
      "matrice",
      0.0
    ],
    [
      "gite",
      0.0
    ],
    [
      "galbe",
      0.0
    ],
    [
      "formette",
      0.0
    ],
    [
      "formalisme",
      0.0
    ],
    [
      "pointure",
      0.0
    ],
    [
      "relief",
      0.0
    ],
    [
      "scheme",
      0.0
    ],
    [
      "traits",
      0.0
    ],
    [
      "tumeur",
      0.0
    ],
    [
      "variete",
      0.0
    ],
    [
      "volume",
      0.0
    ],
    [
      "equilibre",
      0.0
    ],
    [
      "fonction",
      0.0
    ],
    [
      "flan",
      0.0
    ],
    [
      "apparition",
      0.0
    ],
    [
      "beaute",
      0.0
    ],
    [
      "bercale",
      0.0
    ],
    [
      "brio",
      0.0
    ],
    [
      "cagerotte",
      0.0
    ],
    [
      "caserette",
      0.0
    ],
    [
      "cerce",
      0.0
    ],
    [
      "chair",
      0.0
    ],
    [
      "chinoiserie",
      0.0
    ],
    [
      "ceremonial",
      0.0
    ],
    [
      "dock",
      0.0
    ],
    [
      "delineament",
      0.0
    ],
    [
      "embauchoir",
      0.0
    ],
    [
      "allegresse",
      0.0
    ]
  ],
  "indifference": [
    [
      "flegme",
      0.0775
    ],
    [
      "impassibilite",
      0.0775
    ],
    [
      "calme",
      0.0625
    ],
    [
      "apathie",
      0.0575
    ],
    [
      "insensibilite",
      0.0575
    ],
    [
      "froideur",
      0.0525
    ],
    [
      "tiedeur",
      0.045
    ],
    [
      "detachement",
      0.045
    ],
    [
      "indolence",
      0.03
    ],
    [
      "serenite",
      0.03
    ],
    [
      "nonchalance",
      0.025
    ],
    [
      "mollesse",
      0.02
    ],
    [
      "insouciance",
      0.02
    ],
    [
      "frigidite",
      0.02
    ],
    [
      "ataraxie",
      0.02
    ],
    [
      "philosophie",
      0.015
    ],
    [
      "irreligion",
      0.015
    ],
    [
      "impiete",
      0.015
    ],
    [
      "froid",
      0.015
    ],
    [
      "desinteressement",
      0.015
    ],
    [
      "desaffection",
      0.015
    ],
    [
      "oubli",
      0.01
    ],
    [
      "placidite",
      0.01
    ],
    [
      "rigueur",
      0.01
    ],
    [
      "scepticisme",
      0.01
    ],
    [
      "secheresse",
      0.01
    ],
    [
      "equanimite",
      0.01
    ],
    [
      "neutralite",
      0.01
    ],
    [
      "liberte",
      0.01
    ],
    [
      "assoupissement",
      0.01
    ],
    [
      "cruaute",
      0.01
    ],
    [
      "desinteret",
      0.01
    ],
    [
      "desinvolture",
      0.01
    ],
    [
      "inattention",
      0.01
    ],
    [
      "incredulite",
      0.01
    ],
    [
      "incuriosite",
      0.005
    ],
    [
      "indetermination",
      0.005
    ],
    [
      "nonchaloir",
      0.005
    ],
    [
      "stoicisme",
      0.005
    ],
    [
      "egoisme",
      0.005
    ],
    [
      "eloignement",
      0.005
    ],
    [
      "incomprehension",
      0.005
    ],
    [
      "inappetence",
      0.005
    ],
    [
      "abstention",
      0.005
    ],
    [
      "adiaphorie",
      0.005
    ],
    [
      "agnosticisme",
      0.005
    ],
    [
      "anesthesie",
      0.005
    ],
    [
      "anosodiaphorie",
      0.005
    ],
    [
      "aridite",
      0.005
    ],
    [
      "dedain",
      0.005
    ],
    [
      "degagement",
      0.005
    ],
    [
      "equilibre",
      0.005
    ]
  ],
  "silence": [
    [
      "reticence",
      0.1075
    ],
    [
      "discretion",
      0.07
    ],
    [
      "interruption",
      0.07
    ],
    [
      "mystere",
      0.07
    ],
    [
      "paix",
      0.07
    ],
    [
      "repos",
      0.07
    ],
    [
      "pause",
      0.035
    ],
    [
      "secret",
      0.035
    ],
    [
      "soupir",
      0.035
    ],
    [
      "temps",
      0.035
    ],
    [
      "tranquillite",
      0.035
    ],
    [
      "omission",
      0.035
    ],
    [
      "mutisme",
      0.035
    ],
    [
      "motus",
      0.035
    ],
    [
      "insonorite",
      0.035
    ],
    [
      "chut",
      0.035
    ],
    [
      "calme",
      0.035
    ],
    [
      "arret",
      0.035
    ]
  ],
  "traverse": [
    [
      "obstacle",
      0.17
    ],
    [
      "difficulte",
      0.13
    ],
    [
      "embarras",
      0.085
    ],
    [
      "empechement",
      0.07
    ],
    [
      "tirage",
      0.0475
    ],
    [
      "ennui",
      0.0425
    ],
    [
      "contrariete",
      0.04
    ],
    [
      "epreuve",
      0.02
    ],
    [
      "tribulation",
      0.02
    ],
    [
      "resistance",
      0.02
    ],
    [
      "opposition",
      0.02
    ],
    [
      "danger",
      0.02
    ],
    [
      "anicroche",
      0.02
    ],
    [
      "malheur",
      0.0175
    ],
    [
      "entrave",
      0.0175
    ],
    [
      "contretemps",
      0.0175
    ],
    [
      "accroc",
      0.0175
    ],
    [
      "ecueil",
      0.0125
    ],
    [
      "defense",
      0.0125
    ],
    [
      "caillou",
      0.0125
    ],
    [
      "cahot",
      0.0125
    ],
    [
      "alea",
      0.0125
    ],
    [
      "adversite",
      0.0125
    ],
    [
      "revers",
      0.0075
    ],
    [
      "obstruction",
      0.0075
    ],
    [
      "insucces",
      0.0075
    ],
    [
      "impasse",
      0.0075
    ],
    [
      "gene",
      0.0075
    ],
    [
      "frein",
      0.0075
    ],
    [
      "achoppement",
      0.0075
    ],
    [
      "raccourci",
      0.0025
    ],
    [
      "restriction",
      0.0025
    ],
    [
      "remora",
      0.0025
    ],
    [
      "sommier",
      0.0025
    ],
    [
      "traboule",
      0.0025
    ],
    [
      "passage",
      0.0025
    ],
    [
      "interdiction",
      0.0025
    ],
    [
      "impedimenta",
      0.0025
    ],
    [
      "hourvari",
      0.0025
    ],
    [
      "encombre",
      0.0025
    ],
    [
      "blocage",
      0.0025
    ],
    [
      "barreau",
      0.0025
    ],
    [
      "aria",
      0.0025
    ],
    [
      "epar",
      0.0025
    ]
  ],
  "traverser": [
    [
      "penetrer",
      0.1
    ],
    [
      "passer",
      0.09
    ],
    [
      "percer",
      0.075
    ],
    [
      "couler",
      0.0625
    ],
    [
      "fendre",
      0.05
    ],
    [
      "courir",
      0.05
    ],
    [
      "couper",
      0.05
    ],
    [
      "transpercer",
      0.0375
    ],
    [
      "parcourir",
      0.0375
    ],
    [
      "empecher",
      0.0375
    ],
    [
      "dechirer",
      0.0375
    ],
    [
      "barrer",
      0.0375
    ],
    [
      "baigner",
      0.0375
    ],
    [
      "aller",
      0.0375
    ],
    [
      "trouer",
      0.025
    ],
    [
      "sillonner",
      0.025
    ],
    [
      "franchir",
      0.025
    ],
    [
      "filtrer",
      0.025
    ],
    [
      "contrarier",
      0.025
    ],
    [
      "transir",
      0.01
    ],
    [
      "perforer",
      0.01
    ],
    [
      "interrompre",
      0.01
    ],
    [
      "infiltrer",
      0.01
    ],
    [
      "gener",
      0.01
    ],
    [
      "croiser",
      0.01
    ],
    [
      "arroser",
      0.01
    ],
    [
      "vivre",
      0.01
    ]
  ],
  "apercevoir": [
    [
      "decouvrir",
      0.135
    ],
    [
      "saisir",
      0.0875
    ],
    [
      "voir",
      0.0875
    ],
    [
      "remarquer",
      0.07
    ],
    [
      "comprendre",
      0.065
    ],
    [
      "percevoir",
      0.0525
    ],
    [
      "penetrer",
      0.0525
    ],
    [
      "deviner",
      0.045
    ],
    [
      "discerner",
      0.0425
    ],
    [
      "connaitre",
      0.0425
    ],
    [
      "reperer",
      0.04
    ],
    [
      "sentir",
      0.04
    ],
    [
      "deceler",
      0.025
    ],
    [
      "trouver",
      0.025
    ],
    [
      "constater",
      0.0225
    ],
    [
      "s'apercevoir",
      0.02
    ],
    [
      "reveler",
      0.02
    ],
    [
      "entrevoir",
      0.02
    ],
    [
      "surprendre",
      0.015
    ],
    [
      "apprehender",
      0.0125
    ],
    [
      "distinguer",
      0.0075
    ],
    [
      "noter",
      0.0075
    ],
    [
      "rencontrer",
      0.005
    ],
    [
      "piger",
      0.005
    ],
    [
      "observer",
      0.005
    ],
    [
      "embrasser",
      0.005
    ],
    [
      "aviser",
      0.005
    ],
    [
      "entraver",
      0.0025
    ],
    [
      "montrer",
      0.0025
    ]
  ],
  "voyage": [
    [
      "tour",
      0.1
    ],
    [
      "circuit",
      0.075
    ],
    [
      "promenade",
      0.065
    ],
    [
      "excursion",
      0.05
    ],
    [
      "expedition",
      0.04
    ],
    [
      "passage",
      0.04
    ],
    [
      "transport",
      0.04
    ],
    [
      "trajet",
      0.0325
    ],
    [
      "tournee",
      0.0325
    ],
    [
      "randonnee",
      0.0325
    ],
    [
      "periple",
      0.0325
    ],
    [
      "visite",
      0.025
    ],
    [
      "raid",
      0.025
    ],
    [
      "navette",
      0.025
    ],
    [
      "incursion",
      0.025
    ],
    [
      "errance",
      0.025
    ],
    [
      "deplacement",
      0.025
    ],
    [
      "traversee",
      0.015
    ],
    [
      "route",
      0.015
    ],
    [
      "rallye",
      0.015
    ],
    [
      "navigation",
      0.015
    ],
    [
      "locomotion",
      0.015
    ],
    [
      "itineraire",
      0.015
    ],
    [
      "exploration",
      0.015
    ],
    [
      "croisiere",
      0.015
    ],
    [
      "odyssee",
      0.0075
    ],
    [
      "perambulation",
      0.0075
    ],
    [
      "pelerinage",
      0.0075
    ],
    [
      "peregrination",
      0.0075
    ],
    [
      "sejour",
      0.0075
    ],
    [
      "tourisme",
      0.0075
    ],
    [
      "exode",
      0.0075
    ],
    [
      "defonce",
      0.0075
    ],
    [
      "campagne",
      0.0075
    ],
    [
      "bonheur",
      0.0075
    ],
    [
      "balade",
      0.0075
    ],
    [
      "anesthesie",
      0.0075
    ],
    [
      "trip",
      0.0075
    ]
  ],
  "ancre": [
    [
      "fixer",
      0.215
    ],
    [
      "arrimer",
      0.1775
    ],
    [
      "attacher",
      0.105
    ],
    [
      "consolider",
      0.105
    ],
    [
      "arreter",
      0.07
    ],
    [
      "enraciner",
      0.07
    ],
    [
      "river",
      0.035
    ],
    [
      "mouiller",
      0.035
    ],
    [
      "imprimer",
      0.035
    ],
    [
      "implanter",
      0.035
    ],
    [
      "amarrer",
      0.035
    ],
    [
      "affermir",
      0.035
    ],
    [
      "stopper",
      0.035
    ]
  ],
  "ancrer": [
    [
      "fixer",
      0.215
    ],
    [
      "arrimer",
      0.1775
    ],
    [
      "attacher",
      0.105
    ],
    [
      "consolider",
      0.105
    ],
    [
      "arreter",
      0.07
    ],
    [
      "enraciner",
      0.07
    ],
    [
      "river",
      0.035
    ],
    [
      "mouiller",
      0.035
    ],
    [
      "imprimer",
      0.035
    ],
    [
      "implanter",
      0.035
    ],
    [
      "amarrer",
      0.035
    ],
    [
      "affermir",
      0.035
    ],
    [
      "stopper",
      0.035
    ]
  ],
  "enchante": [
    [
      "charmer",
      0.15
    ],
    [
      "ravir",
      0.1175
    ],
    [
      "seduire",
      0.1175
    ],
    [
      "fasciner",
      0.1
    ],
    [
      "plaire",
      0.0825
    ],
    [
      "captiver",
      0.0825
    ],
    [
      "subjuguer",
      0.065
    ],
    [
      "emerveiller",
      0.0325
    ],
    [
      "eblouir",
      0.0325
    ],
    [
      "rejouir",
      0.0325
    ],
    [
      "envouter",
      0.0325
    ],
    [
      "ensorceler",
      0.0325
    ],
    [
      "conquerir",
      0.0325
    ],
    [
      "amuser",
      0.0325
    ],
    [
      "emballer",
      0.015
    ],
    [
      "endiabler",
      0.015
    ],
    [
      "sourire",
      0.015
    ]
  ],
  "enchanter": [
    [
      "charmer",
      0.15
    ],
    [
      "ravir",
      0.1175
    ],
    [
      "seduire",
      0.1175
    ],
    [
      "fasciner",
      0.1
    ],
    [
      "plaire",
      0.0825
    ],
    [
      "captiver",
      0.0825
    ],
    [
      "subjuguer",
      0.065
    ],
    [
      "emerveiller",
      0.0325
    ],
    [
      "eblouir",
      0.0325
    ],
    [
      "rejouir",
      0.0325
    ],
    [
      "envouter",
      0.0325
    ],
    [
      "ensorceler",
      0.0325
    ],
    [
      "conquerir",
      0.0325
    ],
    [
      "amuser",
      0.0325
    ],
    [
      "emballer",
      0.015
    ],
    [
      "endiabler",
      0.015
    ],
    [
      "sourire",
      0.015
    ]
  ],
  "accepter": [
    [
      "acquiescer",
      0.075
    ],
    [
      "admettre",
      0.075
    ],
    [
      "consentir",
      0.07
    ],
    [
      "approuver",
      0.05
    ],
    [
      "supporter",
      0.045
    ],
    [
      "passer",
      0.035
    ],
    [
      "permettre",
      0.035
    ],
    [
      "souffrir",
      0.03
    ],
    [
      "tolerer",
      0.03
    ],
    [
      "autoriser",
      0.0275
    ],
    [
      "subir",
      0.02
    ],
    [
      "s'accommoder",
      0.02
    ],
    [
      "endurer",
      0.0175
    ],
    [
      "daigner",
      0.0175
    ],
    [
      "condescendre",
      0.0175
    ],
    [
      "adopter",
      0.0175
    ],
    [
      "adherer",
      0.0175
    ],
    [
      "acceder",
      0.0175
    ],
    [
      "souscrire",
      0.0125
    ],
    [
      "recevoir",
      0.0125
    ],
    [
      "obeir",
      0.0125
    ],
    [
      "marcher",
      0.0125
    ],
    [
      "croire",
      0.0125
    ],
    [
      "agreer",
      0.0125
    ],
    [
      "avaler",
      0.01
    ],
    [
      "digerer",
      0.01
    ],
    [
      "endosser",
      0.01
    ],
    [
      "signer",
      0.005
    ],
    [
      "ratifier",
      0.005
    ],
    [
      "embrasser",
      0.005
    ],
    [
      "toper",
      0.0025
    ],
    [
      "patir",
      0.0025
    ],
    [
      "promettre",
      0.0025
    ],
    [
      "opiner",
      0.0025
    ],
    [
      "homologuer",
      0.0025
    ],
    [
      "assumer",
      0.0025
    ],
    [
      "accueillir",
      0.0025
    ],
    [
      "vouloir",
      0.0025
    ]
  ],
  "metis": [
    [
      "batard",
      0.1175
    ],
    [
      "hybride",
      0.1175
    ],
    [
      "matine",
      0.1175
    ],
    [
      "mulatre",
      0.0575
    ],
    [
      "mulet",
      0.0575
    ],
    [
      "mule",
      0.0575
    ],
    [
      "mulard",
      0.0575
    ],
    [
      "eurasien",
      0.0575
    ],
    [
      "capre",
      0.0575
    ],
    [
      "creole",
      0.0575
    ],
    [
      "croise",
      0.0575
    ],
    [
      "corniaud",
      0.0575
    ],
    [
      "zambo",
      0.0575
    ]
  ],
  "martyre": [
    [
      "supplice",
      0.25
    ],
    [
      "tourment",
      0.1
    ],
    [
      "torture",
      0.1
    ],
    [
      "mal",
      0.1
    ],
    [
      "douleur",
      0.1
    ],
    [
      "croix",
      0.1
    ],
    [
      "calvaire",
      0.1
    ],
    [
      "crucifiement",
      0.05
    ],
    [
      "gehenne",
      0.05
    ]
  ],
  "leger": [
    [
      "delicat",
      0.035
    ],
    [
      "fin",
      0.0275
    ],
    [
      "mince",
      0.0275
    ],
    [
      "insignifiant",
      0.0225
    ],
    [
      "petit",
      0.0225
    ],
    [
      "menu",
      0.02
    ],
    [
      "etourdi",
      0.02
    ],
    [
      "svelte",
      0.02
    ],
    [
      "faible",
      0.02
    ],
    [
      "delie",
      0.0175
    ],
    [
      "grele",
      0.0175
    ],
    [
      "frivole",
      0.0175
    ],
    [
      "irreflechi",
      0.0175
    ],
    [
      "leste",
      0.0175
    ],
    [
      "tenu",
      0.015
    ],
    [
      "evapore",
      0.015
    ],
    [
      "ecervele",
      0.015
    ],
    [
      "vif",
      0.015
    ],
    [
      "fragile",
      0.015
    ],
    [
      "aerien",
      0.015
    ],
    [
      "insouciant",
      0.0125
    ],
    [
      "libre",
      0.0125
    ],
    [
      "elegant",
      0.0125
    ],
    [
      "inconstant",
      0.0125
    ],
    [
      "imperceptible",
      0.0125
    ],
    [
      "futile",
      0.0125
    ],
    [
      "doux",
      0.0125
    ],
    [
      "agile",
      0.0125
    ],
    [
      "souple",
      0.01
    ],
    [
      "fringant",
      0.01
    ],
    [
      "degage",
      0.01
    ],
    [
      "badin",
      0.01
    ],
    [
      "alerte",
      0.01
    ],
    [
      "ethere",
      0.0075
    ],
    [
      "vide",
      0.0075
    ],
    [
      "subtil",
      0.0075
    ],
    [
      "negligeable",
      0.0075
    ],
    [
      "inconsistant",
      0.0075
    ],
    [
      "inattentif",
      0.0075
    ],
    [
      "volage",
      0.0075
    ],
    [
      "semillant",
      0.0075
    ],
    [
      "inconsequent",
      0.0075
    ],
    [
      "imprudent",
      0.0075
    ],
    [
      "gracile",
      0.0075
    ],
    [
      "gaillard",
      0.0075
    ],
    [
      "facile",
      0.0075
    ],
    [
      "dispos",
      0.0075
    ],
    [
      "benin",
      0.0075
    ],
    [
      "ardent",
      0.0075
    ],
    [
      "anodin",
      0.0075
    ],
    [
      "guilleret",
      0.005
    ],
    [
      "infime",
      0.005
    ],
    [
      "spirituel",
      0.005
    ],
    [
      "superficiel",
      0.005
    ],
    [
      "vaporeux",
      0.005
    ],
    [
      "gracieux",
      0.005
    ],
    [
      "galant",
      0.005
    ],
    [
      "frele",
      0.005
    ],
    [
      "folatre",
      0.005
    ],
    [
      "fluet",
      0.005
    ],
    [
      "clair",
      0.005
    ],
    [
      "changeant",
      0.005
    ],
    [
      "allegre",
      0.005
    ],
    [
      "minime",
      0.005
    ],
    [
      "mobile",
      0.005
    ],
    [
      "pur",
      0.005
    ],
    [
      "transparent",
      0.005
    ],
    [
      "vain",
      0.005
    ],
    [
      "elance",
      0.005
    ],
    [
      "instable",
      0.005
    ],
    [
      "inconscient",
      0.005
    ],
    [
      "agreable",
      0.005
    ],
    [
      "aile",
      0.005
    ],
    [
      "immateriel",
      0.005
    ],
    [
      "impalpable",
      0.005
    ],
    [
      "imponderable",
      0.005
    ],
    [
      "imprevoyant",
      0.005
    ],
    [
      "veniel",
      0.0025
    ],
    [
      "sommaire",
      0.0025
    ],
    [
      "licencieux",
      0.0025
    ],
    [
      "insensible",
      0.0025
    ],
    [
      "inconsidere",
      0.0025
    ],
    [
      "desinvolte",
      0.0025
    ],
    [
      "debarrasse",
      0.0025
    ],
    [
      "distrait",
      0.0025
    ],
    [
      "coureur",
      0.0025
    ],
    [
      "jeune",
      0.0025
    ],
    [
      "mondain",
      0.0025
    ],
    [
      "portatif",
      0.0025
    ],
    [
      "petillant",
      0.0025
    ],
    [
      "sensuel",
      0.0025
    ],
    [
      "succinct",
      0.0025
    ],
    [
      "temeraire",
      0.0025
    ],
    [
      "versatile",
      0.0025
    ],
    [
      "egrillard",
      0.0025
    ],
    [
      "ingambe",
      0.0025
    ],
    [
      "grivois",
      0.0025
    ],
    [
      "allege",
      0.0025
    ],
    [
      "arachneen",
      0.0025
    ],
    [
      "aere",
      0.0025
    ],
    [
      "capricieux",
      0.0025
    ],
    [
      "dissipe",
      0.0025
    ],
    [
      "deleste",
      0.0025
    ],
    [
      "enjoue",
      0.0025
    ],
    [
      "flou",
      0.0025
    ],
    [
      "folichon",
      0.0025
    ],
    [
      "infidele",
      0.0
    ],
    [
      "insuffisant",
      0.0
    ],
    [
      "irresponsable",
      0.0
    ],
    [
      "lascif",
      0.0
    ],
    [
      "oublieux",
      0.0
    ],
    [
      "philosophe",
      0.0
    ],
    [
      "preste",
      0.0
    ],
    [
      "volatil",
      0.0
    ],
    [
      "etourneau",
      0.0
    ],
    [
      "indecelable",
      0.0
    ],
    [
      "indiscernable",
      0.0
    ],
    [
      "inaudible",
      0.0
    ],
    [
      "cavaleur",
      0.0
    ],
    [
      "chiche",
      0.0
    ],
    [
      "creux",
      0.0
    ],
    [
      "croustillant",
      0.0
    ],
    [
      "digeste",
      0.0
    ],
    [
      "digestible",
      0.0
    ],
    [
      "discret",
      0.0
    ],
    [
      "demuni",
      0.0
    ],
    [
      "deraisonnable",
      0.0
    ],
    [
      "enfantin",
      0.0
    ],
    [
      "evente",
      0.0
    ]
  ],
  "bomber": [
    [
      "courber",
      0.1725
    ],
    [
      "gonfler",
      0.1725
    ],
    [
      "arrondir",
      0.085
    ],
    [
      "enfler",
      0.085
    ],
    [
      "gondoler",
      0.085
    ],
    [
      "renfler",
      0.0425
    ],
    [
      "goder",
      0.0425
    ],
    [
      "foncer",
      0.0425
    ],
    [
      "cintrer",
      0.0425
    ],
    [
      "busquer",
      0.0425
    ],
    [
      "bouffer",
      0.0425
    ],
    [
      "saillir",
      0.0425
    ]
  ],
  "torse": [
    [
      "tordu",
      0.22
    ],
    [
      "tortu",
      0.165
    ],
    [
      "cagneux",
      0.11
    ],
    [
      "courbe",
      0.11
    ],
    [
      "difforme",
      0.11
    ],
    [
      "tortueux",
      0.11
    ],
    [
      "arque",
      0.055
    ],
    [
      "contourne",
      0.055
    ],
    [
      "malbati",
      0.055
    ]
  ],
  "tors": [
    [
      "tordu",
      0.22
    ],
    [
      "tortu",
      0.165
    ],
    [
      "cagneux",
      0.11
    ],
    [
      "courbe",
      0.11
    ],
    [
      "difforme",
      0.11
    ],
    [
      "tortueux",
      0.11
    ],
    [
      "arque",
      0.055
    ],
    [
      "contourne",
      0.055
    ],
    [
      "malbati",
      0.055
    ]
  ],
  "redoubler": [
    [
      "augmenter",
      0.25
    ],
    [
      "doubler",
      0.105
    ],
    [
      "multiplier",
      0.105
    ],
    [
      "recommencer",
      0.07
    ],
    [
      "monter",
      0.07
    ],
    [
      "grandir",
      0.07
    ],
    [
      "aggraver",
      0.07
    ],
    [
      "accroitre",
      0.07
    ],
    [
      "ajouter",
      0.035
    ],
    [
      "redonner",
      0.035
    ],
    [
      "renouveler",
      0.035
    ],
    [
      "reiterer",
      0.035
    ]
  ],
  "effort": [
    [
      "travail",
      0.105
    ],
    [
      "force",
      0.0925
    ],
    [
      "action",
      0.07
    ],
    [
      "application",
      0.0575
    ],
    [
      "mal",
      0.045
    ],
    [
      "poussee",
      0.045
    ],
    [
      "resistance",
      0.045
    ],
    [
      "violence",
      0.035
    ],
    [
      "peine",
      0.035
    ],
    [
      "lutte",
      0.035
    ],
    [
      "difficulte",
      0.035
    ],
    [
      "tension",
      0.0225
    ],
    [
      "tendance",
      0.0225
    ],
    [
      "realisation",
      0.0225
    ],
    [
      "propulsion",
      0.0225
    ],
    [
      "pression",
      0.0225
    ],
    [
      "labeur",
      0.0225
    ],
    [
      "impetuosite",
      0.0225
    ],
    [
      "acharnement",
      0.0225
    ],
    [
      "activite",
      0.0225
    ],
    [
      "attention",
      0.0225
    ],
    [
      "concentration",
      0.0225
    ],
    [
      "tentative",
      0.01
    ],
    [
      "sursaut",
      0.01
    ],
    [
      "pesee",
      0.01
    ],
    [
      "instance",
      0.01
    ],
    [
      "hernie",
      0.01
    ],
    [
      "essai",
      0.01
    ],
    [
      "entorse",
      0.01
    ],
    [
      "dechainement",
      0.01
    ],
    [
      "contention",
      0.01
    ],
    [
      "art",
      0.01
    ],
    [
      "volonte",
      0.01
    ]
  ],
  "difference": [
    [
      "opposition",
      0.0775
    ],
    [
      "dissemblance",
      0.0675
    ],
    [
      "disparite",
      0.0575
    ],
    [
      "distance",
      0.04
    ],
    [
      "desaccord",
      0.035
    ],
    [
      "discordance",
      0.035
    ],
    [
      "changement",
      0.03
    ],
    [
      "contraste",
      0.03
    ],
    [
      "disproportion",
      0.03
    ],
    [
      "ecart",
      0.03
    ],
    [
      "variete",
      0.025
    ],
    [
      "inegalite",
      0.025
    ],
    [
      "contradiction",
      0.025
    ],
    [
      "variation",
      0.02
    ],
    [
      "separation",
      0.02
    ],
    [
      "solde",
      0.02
    ],
    [
      "intervalle",
      0.02
    ],
    [
      "heterogeneite",
      0.02
    ],
    [
      "exces",
      0.02
    ],
    [
      "diversite",
      0.02
    ],
    [
      "eloignement",
      0.015
    ],
    [
      "nuance",
      0.015
    ],
    [
      "depart",
      0.015
    ],
    [
      "divergence",
      0.015
    ],
    [
      "distinction",
      0.015
    ],
    [
      "disparate",
      0.015
    ],
    [
      "complement",
      0.015
    ],
    [
      "appoint",
      0.015
    ],
    [
      "incompatibilite",
      0.0075
    ],
    [
      "marge",
      0.0075
    ],
    [
      "modification",
      0.0075
    ],
    [
      "reste",
      0.0075
    ],
    [
      "supplement",
      0.0075
    ],
    [
      "variante",
      0.0075
    ],
    [
      "incoherence",
      0.0075
    ],
    [
      "excedent",
      0.0075
    ],
    [
      "defaut",
      0.0075
    ],
    [
      "abime",
      0.0075
    ],
    [
      "antinomie",
      0.0075
    ],
    [
      "antithese",
      0.0075
    ],
    [
      "caracteristique",
      0.0075
    ],
    [
      "compte",
      0.0075
    ],
    [
      "dissimilitude",
      0.0075
    ],
    [
      "partage",
      0.0025
    ],
    [
      "manque",
      0.0025
    ],
    [
      "deviation",
      0.0025
    ],
    [
      "differend",
      0.0025
    ],
    [
      "degre",
      0.0025
    ],
    [
      "contrariete",
      0.0025
    ],
    [
      "bigarrure",
      0.0025
    ],
    [
      "balance",
      0.0025
    ],
    [
      "alterite",
      0.0025
    ],
    [
      "agio",
      0.0025
    ],
    [
      "particularite",
      0.0025
    ]
  ],
  "injure": [
    [
      "insulte",
      0.1025
    ],
    [
      "affront",
      0.095
    ],
    [
      "outrage",
      0.095
    ],
    [
      "offense",
      0.0875
    ],
    [
      "tort",
      0.05
    ],
    [
      "grossierete",
      0.05
    ],
    [
      "atteinte",
      0.05
    ],
    [
      "avanie",
      0.035
    ],
    [
      "indignite",
      0.035
    ],
    [
      "invective",
      0.035
    ],
    [
      "infamie",
      0.0275
    ],
    [
      "ignominie",
      0.0275
    ],
    [
      "coup",
      0.0275
    ],
    [
      "attaque",
      0.02
    ],
    [
      "blaspheme",
      0.02
    ],
    [
      "insolence",
      0.02
    ],
    [
      "parole",
      0.02
    ],
    [
      "sottise",
      0.02
    ],
    [
      "mot",
      0.0125
    ],
    [
      "irreverence",
      0.0125
    ],
    [
      "dommage",
      0.0125
    ],
    [
      "calomnie",
      0.0125
    ],
    [
      "vilenie",
      0.005
    ],
    [
      "pouilles",
      0.005
    ],
    [
      "ordure",
      0.005
    ],
    [
      "manquement",
      0.005
    ],
    [
      "injustice",
      0.005
    ],
    [
      "imprecation",
      0.005
    ],
    [
      "engueulade",
      0.005
    ],
    [
      "couleuvre",
      0.005
    ],
    [
      "clameur",
      0.005
    ],
    [
      "camouflet",
      0.005
    ],
    [
      "blessure",
      0.005
    ],
    [
      "apostrophe",
      0.005
    ],
    [
      "epithete",
      0.005
    ]
  ],
  "incessant": [
    [
      "continu",
      0.165
    ],
    [
      "suivi",
      0.15
    ],
    [
      "constant",
      0.09
    ],
    [
      "continuel",
      0.09
    ],
    [
      "perpetuel",
      0.09
    ],
    [
      "ininterrompu",
      0.075
    ],
    [
      "persistant",
      0.075
    ],
    [
      "soutenu",
      0.06
    ],
    [
      "assidu",
      0.06
    ],
    [
      "permanent",
      0.03
    ],
    [
      "continue",
      0.015
    ],
    [
      "indiscontinu",
      0.015
    ],
    [
      "infatigable",
      0.015
    ],
    [
      "intarissable",
      0.015
    ],
    [
      "reconduit",
      0.015
    ],
    [
      "sempiternel",
      0.015
    ],
    [
      "eternel",
      0.015
    ]
  ],
  "usure": [
    [
      "degradation",
      0.1175
    ],
    [
      "erosion",
      0.0575
    ],
    [
      "interet",
      0.0575
    ],
    [
      "diminution",
      0.0575
    ],
    [
      "corrosion",
      0.0575
    ],
    [
      "agiotage",
      0.0575
    ],
    [
      "agio",
      0.0575
    ],
    [
      "affaiblissement",
      0.0575
    ],
    [
      "profit",
      0.0275
    ],
    [
      "pret",
      0.0275
    ],
    [
      "trafic",
      0.0275
    ],
    [
      "usage",
      0.0275
    ],
    [
      "vieillissement",
      0.0275
    ],
    [
      "ecaillement",
      0.0275
    ],
    [
      "placement",
      0.0275
    ],
    [
      "gain",
      0.0275
    ],
    [
      "frai",
      0.0275
    ],
    [
      "exaction",
      0.0275
    ],
    [
      "effritement",
      0.0275
    ],
    [
      "caducite",
      0.0275
    ],
    [
      "avarice",
      0.0275
    ],
    [
      "amoindrissement",
      0.0275
    ],
    [
      "abrasion",
      0.0275
    ],
    [
      "eraillement",
      0.0275
    ]
  ],
  "devisager": [
    [
      "regarder",
      0.22
    ],
    [
      "contempler",
      0.1
    ],
    [
      "fixer",
      0.1
    ],
    [
      "observer",
      0.1
    ],
    [
      "zieuter",
      0.1
    ],
    [
      "bigler",
      0.0775
    ],
    [
      "examiner",
      0.0775
    ],
    [
      "reluquer",
      0.06
    ],
    [
      "scruter",
      0.0375
    ],
    [
      "defigurer",
      0.0175
    ],
    [
      "detailler",
      0.0175
    ],
    [
      "devorer",
      0.0175
    ],
    [
      "envisager",
      0.0175
    ],
    [
      "lorgner",
      0.0175
    ],
    [
      "toiser",
      0.0175
    ]
  ],
  "deshabiller": [
    [
      "decouvrir",
      0.1125
    ],
    [
      "demunir",
      0.1125
    ],
    [
      "denuder",
      0.1125
    ],
    [
      "depouiller",
      0.1125
    ],
    [
      "montrer",
      0.085
    ],
    [
      "oter",
      0.055
    ],
    [
      "etaler",
      0.055
    ],
    [
      "devetir",
      0.055
    ],
    [
      "degarnir",
      0.055
    ],
    [
      "defaire",
      0.055
    ],
    [
      "defrusquer",
      0.0275
    ],
    [
      "delacer",
      0.0275
    ],
    [
      "demasquer",
      0.0275
    ],
    [
      "exhiber",
      0.0275
    ],
    [
      "medire",
      0.0275
    ],
    [
      "ecorcher",
      0.0275
    ]
  ],
  "rondeur": [
    [
      "franchise",
      0.1175
    ],
    [
      "embonpoint",
      0.095
    ],
    [
      "simplicite",
      0.095
    ],
    [
      "rotondite",
      0.07
    ],
    [
      "sincerite",
      0.07
    ],
    [
      "convexite",
      0.0475
    ],
    [
      "jovialite",
      0.0225
    ],
    [
      "liberte",
      0.0225
    ],
    [
      "loyaute",
      0.0225
    ],
    [
      "naturel",
      0.0225
    ],
    [
      "nettete",
      0.0225
    ],
    [
      "opulence",
      0.0225
    ],
    [
      "renflement",
      0.0225
    ],
    [
      "sein",
      0.0225
    ],
    [
      "harmonie",
      0.0225
    ],
    [
      "grosseur",
      0.0225
    ],
    [
      "adiposite",
      0.0225
    ],
    [
      "arrondi",
      0.0225
    ],
    [
      "arrondissement",
      0.0225
    ],
    [
      "bonhomie",
      0.0225
    ],
    [
      "circularite",
      0.0225
    ],
    [
      "cordialite",
      0.0225
    ],
    [
      "engraissement",
      0.0225
    ],
    [
      "sphericite",
      0.0225
    ]
  ],
  "rechauffer": [
    [
      "ranimer",
      0.1375
    ],
    [
      "reveiller",
      0.1125
    ],
    [
      "exalter",
      0.1
    ],
    [
      "attiser",
      0.075
    ],
    [
      "stimuler",
      0.06
    ],
    [
      "raviver",
      0.05
    ],
    [
      "enflammer",
      0.05
    ],
    [
      "chauffer",
      0.05
    ],
    [
      "revivifier",
      0.0375
    ],
    [
      "revigorer",
      0.0375
    ],
    [
      "aviver",
      0.0375
    ],
    [
      "attiedir",
      0.0375
    ],
    [
      "tiedir",
      0.0225
    ],
    [
      "temperer",
      0.0225
    ],
    [
      "soutenir",
      0.0225
    ],
    [
      "reconforter",
      0.0225
    ],
    [
      "retremper",
      0.0225
    ],
    [
      "degeler",
      0.0225
    ],
    [
      "bassiner",
      0.01
    ],
    [
      "chambrer",
      0.01
    ],
    [
      "deglacer",
      0.01
    ],
    [
      "radoucir",
      0.01
    ],
    [
      "echauffer",
      0.01
    ]
  ],
  "populaire": [
    [
      "commun",
      0.0925
    ],
    [
      "vulgaire",
      0.0925
    ],
    [
      "peuple",
      0.08
    ],
    [
      "populace",
      0.0575
    ],
    [
      "repute",
      0.045
    ],
    [
      "foule",
      0.045
    ],
    [
      "connu",
      0.045
    ],
    [
      "canaille",
      0.045
    ],
    [
      "tourbe",
      0.035
    ],
    [
      "renomme",
      0.035
    ],
    [
      "public",
      0.035
    ],
    [
      "populacier",
      0.035
    ],
    [
      "plebeien",
      0.035
    ],
    [
      "democratique",
      0.035
    ],
    [
      "celebre",
      0.035
    ],
    [
      "repandu",
      0.0225
    ],
    [
      "roturier",
      0.0225
    ],
    [
      "bas",
      0.0225
    ],
    [
      "recherche",
      0.01
    ],
    [
      "proverbial",
      0.01
    ],
    [
      "proletarien",
      0.01
    ],
    [
      "prise",
      0.01
    ],
    [
      "populo",
      0.01
    ],
    [
      "populiste",
      0.01
    ],
    [
      "peuple",
      0.01
    ],
    [
      "ouvrier",
      0.01
    ],
    [
      "illustre",
      0.01
    ],
    [
      "estime",
      0.01
    ],
    [
      "democrate",
      0.01
    ],
    [
      "considere",
      0.01
    ],
    [
      "apprecie",
      0.01
    ],
    [
      "aime",
      0.01
    ],
    [
      "voyou",
      0.01
    ]
  ],
  "force": [
    [
      "pousser",
      0.045
    ],
    [
      "contraindre",
      0.0325
    ],
    [
      "conquerir",
      0.03
    ],
    [
      "gagner",
      0.0275
    ],
    [
      "grossir",
      0.025
    ],
    [
      "exagerer",
      0.025
    ],
    [
      "augmenter",
      0.025
    ],
    [
      "assujettir",
      0.025
    ],
    [
      "entrainer",
      0.0225
    ],
    [
      "obliger",
      0.0225
    ],
    [
      "rencherir",
      0.02
    ],
    [
      "emporter",
      0.02
    ],
    [
      "vaincre",
      0.0175
    ],
    [
      "rompre",
      0.0175
    ],
    [
      "presser",
      0.0175
    ],
    [
      "prendre",
      0.0175
    ],
    [
      "denaturer",
      0.0175
    ],
    [
      "dompter",
      0.0175
    ],
    [
      "captiver",
      0.0175
    ],
    [
      "briser",
      0.015
    ],
    [
      "enlever",
      0.015
    ],
    [
      "reduire",
      0.0125
    ],
    [
      "enfoncer",
      0.0125
    ],
    [
      "enfler",
      0.0125
    ],
    [
      "dominer",
      0.0125
    ],
    [
      "brusquer",
      0.0125
    ],
    [
      "violenter",
      0.01
    ],
    [
      "triompher",
      0.01
    ],
    [
      "precipiter",
      0.01
    ],
    [
      "poursuivre",
      0.01
    ],
    [
      "condamner",
      0.01
    ],
    [
      "charger",
      0.01
    ],
    [
      "accelerer",
      0.01
    ],
    [
      "provoquer",
      0.0075
    ],
    [
      "penetrer",
      0.0075
    ],
    [
      "s'emparer",
      0.0075
    ],
    [
      "solliciter",
      0.0075
    ],
    [
      "surfaire",
      0.0075
    ],
    [
      "surmonter",
      0.0075
    ],
    [
      "tordre",
      0.0075
    ],
    [
      "torturer",
      0.0075
    ],
    [
      "outrer",
      0.0075
    ],
    [
      "occuper",
      0.0075
    ],
    [
      "imposer",
      0.0075
    ],
    [
      "alterer",
      0.0075
    ],
    [
      "arracher",
      0.0075
    ],
    [
      "astreindre",
      0.0075
    ],
    [
      "chasser",
      0.0075
    ],
    [
      "deformer",
      0.0075
    ],
    [
      "detourner",
      0.0075
    ],
    [
      "fausser",
      0.0075
    ],
    [
      "gonfler",
      0.0075
    ],
    [
      "obtenir",
      0.005
    ],
    [
      "ouvrir",
      0.005
    ],
    [
      "sommer",
      0.005
    ],
    [
      "tyranniser",
      0.005
    ],
    [
      "violer",
      0.005
    ],
    [
      "necessiter",
      0.005
    ],
    [
      "monter",
      0.005
    ],
    [
      "hausser",
      0.005
    ],
    [
      "fatiguer",
      0.005
    ],
    [
      "entrer",
      0.005
    ],
    [
      "avancer",
      0.005
    ],
    [
      "amener",
      0.005
    ],
    [
      "acculer",
      0.005
    ],
    [
      "inspirer",
      0.0025
    ],
    [
      "hater",
      0.0025
    ],
    [
      "gauchir",
      0.0025
    ],
    [
      "deteriorer",
      0.0025
    ],
    [
      "dramatiser",
      0.0025
    ],
    [
      "crever",
      0.0025
    ],
    [
      "surmener",
      0.0
    ],
    [
      "s'introduire",
      0.0
    ],
    [
      "s'attirer",
      0.0
    ],
    [
      "fracturer",
      0.0
    ],
    [
      "detraquer",
      0.0
    ],
    [
      "dessaisonner",
      0.0
    ],
    [
      "crocheter",
      0.0
    ],
    [
      "contrarier",
      0.0
    ],
    [
      "contourner",
      0.0
    ],
    [
      "claquer",
      0.0
    ],
    [
      "bouquer",
      0.0
    ],
    [
      "acquerir",
      0.0
    ],
    [
      "accentuer",
      0.0
    ],
    [
      "traquer",
      0.0
    ]
  ],
  "forcer": [
    [
      "pousser",
      0.045
    ],
    [
      "contraindre",
      0.0325
    ],
    [
      "conquerir",
      0.03
    ],
    [
      "gagner",
      0.0275
    ],
    [
      "grossir",
      0.025
    ],
    [
      "exagerer",
      0.025
    ],
    [
      "augmenter",
      0.025
    ],
    [
      "assujettir",
      0.025
    ],
    [
      "entrainer",
      0.0225
    ],
    [
      "obliger",
      0.0225
    ],
    [
      "rencherir",
      0.02
    ],
    [
      "emporter",
      0.02
    ],
    [
      "vaincre",
      0.0175
    ],
    [
      "rompre",
      0.0175
    ],
    [
      "presser",
      0.0175
    ],
    [
      "prendre",
      0.0175
    ],
    [
      "denaturer",
      0.0175
    ],
    [
      "dompter",
      0.0175
    ],
    [
      "captiver",
      0.0175
    ],
    [
      "briser",
      0.015
    ],
    [
      "enlever",
      0.015
    ],
    [
      "reduire",
      0.0125
    ],
    [
      "enfoncer",
      0.0125
    ],
    [
      "enfler",
      0.0125
    ],
    [
      "dominer",
      0.0125
    ],
    [
      "brusquer",
      0.0125
    ],
    [
      "violenter",
      0.01
    ],
    [
      "triompher",
      0.01
    ],
    [
      "precipiter",
      0.01
    ],
    [
      "poursuivre",
      0.01
    ],
    [
      "condamner",
      0.01
    ],
    [
      "charger",
      0.01
    ],
    [
      "accelerer",
      0.01
    ],
    [
      "provoquer",
      0.0075
    ],
    [
      "penetrer",
      0.0075
    ],
    [
      "s'emparer",
      0.0075
    ],
    [
      "solliciter",
      0.0075
    ],
    [
      "surfaire",
      0.0075
    ],
    [
      "surmonter",
      0.0075
    ],
    [
      "tordre",
      0.0075
    ],
    [
      "torturer",
      0.0075
    ],
    [
      "outrer",
      0.0075
    ],
    [
      "occuper",
      0.0075
    ],
    [
      "imposer",
      0.0075
    ],
    [
      "alterer",
      0.0075
    ],
    [
      "arracher",
      0.0075
    ],
    [
      "astreindre",
      0.0075
    ],
    [
      "chasser",
      0.0075
    ],
    [
      "deformer",
      0.0075
    ],
    [
      "detourner",
      0.0075
    ],
    [
      "fausser",
      0.0075
    ],
    [
      "gonfler",
      0.0075
    ],
    [
      "obtenir",
      0.005
    ],
    [
      "ouvrir",
      0.005
    ],
    [
      "sommer",
      0.005
    ],
    [
      "tyranniser",
      0.005
    ],
    [
      "violer",
      0.005
    ],
    [
      "necessiter",
      0.005
    ],
    [
      "monter",
      0.005
    ],
    [
      "hausser",
      0.005
    ],
    [
      "fatiguer",
      0.005
    ],
    [
      "entrer",
      0.005
    ],
    [
      "avancer",
      0.005
    ],
    [
      "amener",
      0.005
    ],
    [
      "acculer",
      0.005
    ],
    [
      "inspirer",
      0.0025
    ],
    [
      "hater",
      0.0025
    ],
    [
      "gauchir",
      0.0025
    ],
    [
      "deteriorer",
      0.0025
    ],
    [
      "dramatiser",
      0.0025
    ],
    [
      "crever",
      0.0025
    ],
    [
      "surmener",
      0.0
    ],
    [
      "s'introduire",
      0.0
    ],
    [
      "s'attirer",
      0.0
    ],
    [
      "fracturer",
      0.0
    ],
    [
      "detraquer",
      0.0
    ],
    [
      "dessaisonner",
      0.0
    ],
    [
      "crocheter",
      0.0
    ],
    [
      "contrarier",
      0.0
    ],
    [
      "contourner",
      0.0
    ],
    [
      "claquer",
      0.0
    ],
    [
      "bouquer",
      0.0
    ],
    [
      "acquerir",
      0.0
    ],
    [
      "accentuer",
      0.0
    ],
    [
      "traquer",
      0.0
    ]
  ],
  "premier": [
    [
      "primordial",
      0.1025
    ],
    [
      "principal",
      0.065
    ],
    [
      "essentiel",
      0.0575
    ],
    [
      "primitif",
      0.05
    ],
    [
      "fondamental",
      0.045
    ],
    [
      "elementaire",
      0.045
    ],
    [
      "superieur",
      0.0325
    ],
    [
      "preponderant",
      0.0325
    ],
    [
      "predominant",
      0.0325
    ],
    [
      "initial",
      0.0325
    ],
    [
      "vital",
      0.025
    ],
    [
      "maitre",
      0.025
    ],
    [
      "majeur",
      0.025
    ],
    [
      "dominant",
      0.025
    ],
    [
      "auteur",
      0.025
    ],
    [
      "preeminent",
      0.0175
    ],
    [
      "promoteur",
      0.0175
    ],
    [
      "original",
      0.0175
    ],
    [
      "initiateur",
      0.0175
    ],
    [
      "capital",
      0.0175
    ],
    [
      "ancien",
      0.0175
    ],
    [
      "originaire",
      0.0125
    ],
    [
      "originel",
      0.0125
    ],
    [
      "primaire",
      0.0125
    ],
    [
      "principe",
      0.0125
    ],
    [
      "prealable",
      0.0125
    ],
    [
      "remarquable",
      0.0125
    ],
    [
      "necessaire",
      0.0125
    ],
    [
      "liminaire",
      0.0125
    ],
    [
      "ancetre",
      0.0125
    ],
    [
      "anterieur",
      0.0125
    ],
    [
      "aine",
      0.0125
    ],
    [
      "brut",
      0.0125
    ],
    [
      "commencement",
      0.0125
    ],
    [
      "indispensable",
      0.0125
    ],
    [
      "preoriginal",
      0.005
    ],
    [
      "princeps",
      0.005
    ],
    [
      "prime",
      0.005
    ],
    [
      "pionnier",
      0.005
    ],
    [
      "meilleur",
      0.005
    ],
    [
      "major",
      0.005
    ],
    [
      "leader",
      0.005
    ],
    [
      "inventeur",
      0.005
    ],
    [
      "introducteur",
      0.005
    ],
    [
      "debut",
      0.005
    ],
    [
      "cacique",
      0.005
    ],
    [
      "un",
      0.005
    ]
  ],
  "poil": [
    [
      "toison",
      0.1025
    ],
    [
      "barbe",
      0.0675
    ],
    [
      "bourre",
      0.0675
    ],
    [
      "duvet",
      0.0675
    ],
    [
      "moustache",
      0.0675
    ],
    [
      "robe",
      0.0675
    ],
    [
      "laine",
      0.0325
    ],
    [
      "pelage",
      0.0325
    ],
    [
      "pilosite",
      0.0325
    ],
    [
      "savon",
      0.0325
    ],
    [
      "soie",
      0.0325
    ],
    [
      "sourcil",
      0.0325
    ],
    [
      "tonte",
      0.0325
    ],
    [
      "jarre",
      0.0325
    ],
    [
      "fourrure",
      0.0325
    ],
    [
      "foin",
      0.0325
    ],
    [
      "fibre",
      0.0325
    ],
    [
      "crin",
      0.0325
    ],
    [
      "cil",
      0.0325
    ],
    [
      "cheveu",
      0.0325
    ],
    [
      "chevelure",
      0.0325
    ],
    [
      "vibrisse",
      0.0325
    ]
  ],
  "entree": [
    [
      "penetrer",
      0.1
    ],
    [
      "s'engager",
      0.045
    ],
    [
      "s'introduire",
      0.045
    ],
    [
      "s'insinuer",
      0.04
    ],
    [
      "s'engouffrer",
      0.04
    ],
    [
      "s'enfoncer",
      0.04
    ],
    [
      "prendre",
      0.04
    ],
    [
      "monter",
      0.04
    ],
    [
      "rentrer",
      0.035
    ],
    [
      "passer",
      0.035
    ],
    [
      "embrasser",
      0.035
    ],
    [
      "tenir",
      0.0225
    ],
    [
      "introduire",
      0.0225
    ],
    [
      "enfoncer",
      0.0225
    ],
    [
      "arriver",
      0.0225
    ],
    [
      "aller",
      0.0225
    ],
    [
      "adherer",
      0.0225
    ],
    [
      "venir",
      0.015
    ],
    [
      "parvenir",
      0.015
    ],
    [
      "integrer",
      0.015
    ],
    [
      "forcer",
      0.015
    ],
    [
      "envahir",
      0.015
    ],
    [
      "comprendre",
      0.015
    ],
    [
      "acceder",
      0.015
    ],
    [
      "s'installer",
      0.01
    ],
    [
      "planter",
      0.01
    ],
    [
      "percuter",
      0.01
    ],
    [
      "participer",
      0.01
    ],
    [
      "inserer",
      0.01
    ],
    [
      "enfiler",
      0.01
    ],
    [
      "aborder",
      0.01
    ],
    [
      "s'ingerer",
      0.0025
    ],
    [
      "s'inscrire",
      0.0025
    ],
    [
      "epouser",
      0.0025
    ],
    [
      "s'incruster",
      0.0025
    ],
    [
      "s'incorporer",
      0.0025
    ],
    [
      "s'enfiler",
      0.0025
    ],
    [
      "s'affilier",
      0.0025
    ],
    [
      "ficher",
      0.0025
    ],
    [
      "considerer",
      0.0025
    ],
    [
      "accoster",
      0.0025
    ]
  ],
  "triomphal": [
    [
      "enthousiaste",
      0.1175
    ],
    [
      "eclatant",
      0.1175
    ],
    [
      "splendide",
      0.1175
    ],
    [
      "somptueux",
      0.1175
    ],
    [
      "magnifique",
      0.1175
    ],
    [
      "frenetique",
      0.1175
    ],
    [
      "chaleureux",
      0.0575
    ],
    [
      "delirant",
      0.0575
    ],
    [
      "fastueux",
      0.0575
    ],
    [
      "glorieux",
      0.0575
    ],
    [
      "solennel",
      0.0575
    ]
  ],
  "pousser": [
    [
      "exciter",
      0.06
    ],
    [
      "entrainer",
      0.0425
    ],
    [
      "provoquer",
      0.04
    ],
    [
      "inciter",
      0.03
    ],
    [
      "engager",
      0.0275
    ],
    [
      "porter",
      0.0275
    ],
    [
      "determiner",
      0.0275
    ],
    [
      "conduire",
      0.0225
    ],
    [
      "augmenter",
      0.02
    ],
    [
      "animer",
      0.02
    ],
    [
      "encourager",
      0.0175
    ],
    [
      "soulever",
      0.0175
    ],
    [
      "inviter",
      0.0175
    ],
    [
      "presser",
      0.0175
    ],
    [
      "forcer",
      0.0125
    ],
    [
      "lancer",
      0.0125
    ],
    [
      "inspirer",
      0.0125
    ],
    [
      "exalter",
      0.0125
    ],
    [
      "enflammer",
      0.0125
    ],
    [
      "attirer",
      0.0125
    ],
    [
      "appeler",
      0.0125
    ],
    [
      "appuyer",
      0.0125
    ],
    [
      "aiguillonner",
      0.01
    ],
    [
      "stimuler",
      0.01
    ],
    [
      "faire",
      0.01
    ],
    [
      "grandir",
      0.01
    ],
    [
      "solliciter",
      0.01
    ],
    [
      "elever",
      0.0075
    ],
    [
      "exhorter",
      0.0075
    ],
    [
      "attiser",
      0.0075
    ],
    [
      "amener",
      0.0075
    ],
    [
      "jeter",
      0.0075
    ],
    [
      "repousser",
      0.0075
    ],
    [
      "souffler",
      0.0075
    ],
    [
      "sortir",
      0.005
    ],
    [
      "produire",
      0.005
    ],
    [
      "piquer",
      0.005
    ],
    [
      "persuader",
      0.005
    ],
    [
      "exagerer",
      0.005
    ],
    [
      "developper",
      0.005
    ],
    [
      "conseiller",
      0.005
    ],
    [
      "chasser",
      0.005
    ],
    [
      "incliner",
      0.005
    ],
    [
      "mener",
      0.005
    ],
    [
      "peser",
      0.005
    ],
    [
      "poursuivre",
      0.005
    ],
    [
      "rejeter",
      0.005
    ],
    [
      "diriger",
      0.005
    ],
    [
      "bousculer",
      0.005
    ],
    [
      "avancer",
      0.005
    ],
    [
      "allonger",
      0.005
    ],
    [
      "agir",
      0.005
    ],
    [
      "activer",
      0.005
    ],
    [
      "accelerer",
      0.005
    ],
    [
      "accroitre",
      0.005
    ],
    [
      "proferer",
      0.005
    ],
    [
      "promouvoir",
      0.005
    ],
    [
      "prononcer",
      0.005
    ],
    [
      "precipiter",
      0.005
    ],
    [
      "etendre",
      0.005
    ],
    [
      "ouvrir",
      0.005
    ],
    [
      "mouvoir",
      0.005
    ],
    [
      "aider",
      0.005
    ],
    [
      "aller",
      0.005
    ],
    [
      "attaquer",
      0.005
    ],
    [
      "croitre",
      0.005
    ],
    [
      "enfoncer",
      0.005
    ],
    [
      "eperonner",
      0.0025
    ],
    [
      "emettre",
      0.0025
    ],
    [
      "servir",
      0.0025
    ],
    [
      "proteger",
      0.0025
    ],
    [
      "emporter",
      0.0025
    ],
    [
      "brusquer",
      0.0025
    ],
    [
      "aviver",
      0.0025
    ],
    [
      "accentuer",
      0.0025
    ],
    [
      "oter",
      0.0025
    ],
    [
      "venir",
      0.0025
    ],
    [
      "remuer",
      0.0025
    ],
    [
      "poindre",
      0.0025
    ],
    [
      "harceler",
      0.0025
    ],
    [
      "favoriser",
      0.0025
    ],
    [
      "contraindre",
      0.0025
    ],
    [
      "profiter",
      0.0025
    ],
    [
      "projeter",
      0.0025
    ],
    [
      "prolonger",
      0.0025
    ],
    [
      "refouler",
      0.0025
    ],
    [
      "rencherir",
      0.0025
    ],
    [
      "renvoyer",
      0.0025
    ],
    [
      "epauler",
      0.0025
    ],
    [
      "pointer",
      0.0025
    ],
    [
      "pistonner",
      0.0025
    ],
    [
      "balayer",
      0.0025
    ],
    [
      "charrier",
      0.0025
    ],
    [
      "culbuter",
      0.0025
    ],
    [
      "decider",
      0.0025
    ],
    [
      "deplacer",
      0.0025
    ],
    [
      "introduire",
      0.0025
    ],
    [
      "lever",
      0.0025
    ],
    [
      "parrainer",
      0.0
    ],
    [
      "predisposer",
      0.0
    ],
    [
      "reculer",
      0.0
    ],
    [
      "rouler",
      0.0
    ],
    [
      "surfaire",
      0.0
    ],
    [
      "lacher",
      0.0
    ],
    [
      "heurter",
      0.0
    ],
    [
      "fouetter",
      0.0
    ],
    [
      "baisser",
      0.0
    ],
    [
      "bourrer",
      0.0
    ],
    [
      "continuer",
      0.0
    ],
    [
      "crier",
      0.0
    ],
    [
      "disposer",
      0.0
    ],
    [
      "embarquer",
      0.0
    ],
    [
      "exhaler",
      0.0
    ],
    [
      "recommander",
      0.0
    ],
    [
      "respirer",
      0.0
    ],
    [
      "reussir",
      0.0
    ],
    [
      "sourdre",
      0.0
    ],
    [
      "tenter",
      0.0
    ],
    [
      "vegeter",
      0.0
    ],
    [
      "eloigner",
      0.0
    ],
    [
      "propulser",
      0.0
    ],
    [
      "outrer",
      0.0
    ],
    [
      "instiguer",
      0.0
    ],
    [
      "abaisser",
      0.0
    ],
    [
      "acculer",
      0.0
    ],
    [
      "approfondir",
      0.0
    ],
    [
      "bouter",
      0.0
    ],
    [
      "deborder",
      0.0
    ],
    [
      "forcir",
      0.0
    ],
    [
      "induire",
      0.0
    ],
    [
      "prevenir",
      0.0
    ],
    [
      "expirer",
      0.0
    ],
    [
      "cherrer",
      0.0
    ],
    [
      "basculer",
      0.0
    ],
    [
      "attiger",
      0.0
    ],
    [
      "pulluler",
      0.0
    ]
  ],
  "royalement": [
    [
      "parfaitement",
      0.125
    ],
    [
      "splendidement",
      0.125
    ],
    [
      "superbement",
      0.0825
    ],
    [
      "somptueusement",
      0.0825
    ],
    [
      "richement",
      0.0825
    ],
    [
      "luxueusement",
      0.0825
    ],
    [
      "completement",
      0.0825
    ],
    [
      "souverainement",
      0.04
    ],
    [
      "princierement",
      0.04
    ],
    [
      "magnifiquement",
      0.04
    ],
    [
      "imperialement",
      0.04
    ],
    [
      "genereusement",
      0.04
    ],
    [
      "fastueusement",
      0.04
    ],
    [
      "absolument",
      0.04
    ],
    [
      "totalement",
      0.04
    ]
  ],
  "rugissement": [
    [
      "hurlement",
      0.3
    ],
    [
      "cri",
      0.2
    ],
    [
      "mugissement",
      0.2
    ],
    [
      "grondement",
      0.1
    ],
    [
      "hennissement",
      0.1
    ],
    [
      "vociferation",
      0.1
    ]
  ],
  "bestial": [
    [
      "grossier",
      0.175
    ],
    [
      "barbare",
      0.15
    ],
    [
      "brutal",
      0.1
    ],
    [
      "brute",
      0.1
    ],
    [
      "sauvage",
      0.1
    ],
    [
      "animal",
      0.075
    ],
    [
      "feroce",
      0.05
    ],
    [
      "charnel",
      0.05
    ],
    [
      "brut",
      0.05
    ],
    [
      "bete",
      0.025
    ],
    [
      "glouton",
      0.025
    ],
    [
      "goujat",
      0.025
    ],
    [
      "inhumain",
      0.025
    ],
    [
      "lubrique",
      0.025
    ],
    [
      "rustique",
      0.025
    ]
  ],
  "mouche": [
    [
      "denonciateur",
      0.09
    ],
    [
      "espion",
      0.09
    ],
    [
      "mouchard",
      0.09
    ],
    [
      "esche",
      0.045
    ],
    [
      "guepe",
      0.045
    ],
    [
      "indicateur",
      0.045
    ],
    [
      "moucheture",
      0.045
    ],
    [
      "pamphile",
      0.045
    ],
    [
      "diptere",
      0.045
    ],
    [
      "cible",
      0.045
    ],
    [
      "cafard",
      0.045
    ],
    [
      "but",
      0.045
    ],
    [
      "barbe",
      0.045
    ],
    [
      "assassin",
      0.045
    ],
    [
      "appat",
      0.045
    ],
    [
      "amorce",
      0.045
    ],
    [
      "postiche",
      0.045
    ]
  ],
  "moucher": [
    [
      "cingler",
      0.135
    ],
    [
      "humilier",
      0.135
    ],
    [
      "souffleter",
      0.135
    ],
    [
      "repousser",
      0.09
    ],
    [
      "vexer",
      0.09
    ],
    [
      "tancer",
      0.045
    ],
    [
      "talocher",
      0.045
    ],
    [
      "sermonner",
      0.045
    ],
    [
      "reprimander",
      0.045
    ],
    [
      "remoucher",
      0.045
    ],
    [
      "rembarrer",
      0.045
    ],
    [
      "mater",
      0.045
    ],
    [
      "couper",
      0.045
    ],
    [
      "emecher",
      0.045
    ]
  ],
  "coude": [
    [
      "tournant",
      0.215
    ],
    [
      "angle",
      0.1075
    ],
    [
      "detour",
      0.1075
    ],
    [
      "tour",
      0.07
    ],
    [
      "sinuosite",
      0.07
    ],
    [
      "retour",
      0.07
    ],
    [
      "courbe",
      0.07
    ],
    [
      "contour",
      0.07
    ],
    [
      "coudoiement",
      0.035
    ],
    [
      "humerus",
      0.035
    ],
    [
      "meandre",
      0.035
    ],
    [
      "saignee",
      0.035
    ],
    [
      "saillie",
      0.035
    ],
    [
      "virage",
      0.035
    ]
  ],
  "langue": [
    [
      "langage",
      0.1375
    ],
    [
      "jargon",
      0.1125
    ],
    [
      "parler",
      0.0875
    ],
    [
      "style",
      0.0625
    ],
    [
      "elocution",
      0.0625
    ],
    [
      "patois",
      0.05
    ],
    [
      "vocabulaire",
      0.0375
    ],
    [
      "terminologie",
      0.0375
    ],
    [
      "parole",
      0.0375
    ],
    [
      "expression",
      0.0375
    ],
    [
      "dialecte",
      0.0375
    ],
    [
      "phraseologie",
      0.025
    ],
    [
      "idiome",
      0.025
    ],
    [
      "baragouin",
      0.025
    ],
    [
      "tapette",
      0.0125
    ],
    [
      "sabir",
      0.0125
    ],
    [
      "peninsule",
      0.0125
    ],
    [
      "platine",
      0.0125
    ],
    [
      "parlure",
      0.0125
    ],
    [
      "menteuse",
      0.0125
    ],
    [
      "lavette",
      0.0125
    ],
    [
      "languette",
      0.0125
    ],
    [
      "idiolecte",
      0.0125
    ],
    [
      "glacier",
      0.0125
    ],
    [
      "discours",
      0.0125
    ],
    [
      "dard",
      0.0125
    ],
    [
      "code",
      0.0125
    ],
    [
      "bouche",
      0.0125
    ],
    [
      "bec",
      0.0125
    ],
    [
      "bavarde",
      0.0125
    ],
    [
      "argot",
      0.0125
    ],
    [
      "verbe",
      0.0125
    ]
  ],
  "essayer": [
    [
      "experimenter",
      0.0925
    ],
    [
      "tenter",
      0.0925
    ],
    [
      "chercher",
      0.0725
    ],
    [
      "eprouver",
      0.0625
    ],
    [
      "examiner",
      0.05
    ],
    [
      "s'efforcer",
      0.05
    ],
    [
      "verifier",
      0.04
    ],
    [
      "tacher",
      0.04
    ],
    [
      "s'evertuer",
      0.04
    ],
    [
      "risquer",
      0.04
    ],
    [
      "courir",
      0.03
    ],
    [
      "gouter",
      0.03
    ],
    [
      "tendre",
      0.03
    ],
    [
      "tater",
      0.03
    ],
    [
      "tatonner",
      0.02
    ],
    [
      "s'ingenier",
      0.02
    ],
    [
      "s'escrimer",
      0.02
    ],
    [
      "s'aviser",
      0.02
    ],
    [
      "entreprendre",
      0.02
    ],
    [
      "analyser",
      0.02
    ],
    [
      "passer",
      0.01
    ],
    [
      "preluder",
      0.01
    ],
    [
      "s'embarquer",
      0.01
    ],
    [
      "tester",
      0.01
    ],
    [
      "user",
      0.01
    ],
    [
      "mesurer",
      0.01
    ],
    [
      "identifier",
      0.01
    ],
    [
      "hasarder",
      0.01
    ],
    [
      "deguster",
      0.01
    ],
    [
      "controler",
      0.01
    ],
    [
      "aventurer",
      0.01
    ],
    [
      "vouloir",
      0.01
    ]
  ],
  "mule": [
    [
      "mulet",
      0.2
    ],
    [
      "bourrique",
      0.0775
    ],
    [
      "brehaigne",
      0.0775
    ],
    [
      "chatre",
      0.0775
    ],
    [
      "ane",
      0.0775
    ],
    [
      "mulasse",
      0.0375
    ],
    [
      "metis",
      0.0375
    ],
    [
      "pantoufle",
      0.0375
    ],
    [
      "soulier",
      0.0375
    ],
    [
      "chaussure",
      0.0375
    ],
    [
      "chausson",
      0.0375
    ],
    [
      "brele",
      0.0375
    ],
    [
      "bique",
      0.0375
    ],
    [
      "bidet",
      0.0375
    ],
    [
      "babouche",
      0.0375
    ],
    [
      "sterile",
      0.0375
    ]
  ],
  "grandeur": [
    [
      "eminence",
      1.0
    ]
  ],
  "conseil": [
    [
      "assemblee",
      0.0625
    ],
    [
      "lecon",
      0.055
    ],
    [
      "avis",
      0.0475
    ],
    [
      "avertissement",
      0.0375
    ],
    [
      "suggestion",
      0.0375
    ],
    [
      "tribunal",
      0.03
    ],
    [
      "reunion",
      0.03
    ],
    [
      "recommandation",
      0.03
    ],
    [
      "inspiration",
      0.03
    ],
    [
      "resolution",
      0.0225
    ],
    [
      "precepte",
      0.0225
    ],
    [
      "proposition",
      0.0225
    ],
    [
      "projet",
      0.0225
    ],
    [
      "instigation",
      0.0225
    ],
    [
      "enseignement",
      0.0225
    ],
    [
      "dessein",
      0.0225
    ],
    [
      "chambre",
      0.0225
    ],
    [
      "cabinet",
      0.0225
    ],
    [
      "bureau",
      0.0225
    ],
    [
      "incitation",
      0.015
    ],
    [
      "inspirateur",
      0.015
    ],
    [
      "mentor",
      0.015
    ],
    [
      "service",
      0.015
    ],
    [
      "senat",
      0.015
    ],
    [
      "voix",
      0.015
    ],
    [
      "vue",
      0.015
    ],
    [
      "impulsion",
      0.015
    ],
    [
      "guide",
      0.015
    ],
    [
      "admonition",
      0.015
    ],
    [
      "areopage",
      0.015
    ],
    [
      "conference",
      0.015
    ],
    [
      "conseiller",
      0.015
    ],
    [
      "cour",
      0.015
    ],
    [
      "exhortation",
      0.015
    ],
    [
      "fabrique",
      0.015
    ],
    [
      "parti",
      0.0075
    ],
    [
      "principe",
      0.0075
    ],
    [
      "preconisation",
      0.0075
    ],
    [
      "presidence",
      0.0075
    ],
    [
      "representant",
      0.0075
    ],
    [
      "representation",
      0.0075
    ],
    [
      "juridiction",
      0.0075
    ],
    [
      "deliberation",
      0.0075
    ],
    [
      "defenseur",
      0.0075
    ],
    [
      "divan",
      0.0075
    ],
    [
      "consulte",
      0.0075
    ],
    [
      "consultant",
      0.0075
    ],
    [
      "compagnie",
      0.0075
    ],
    [
      "chapitre",
      0.0075
    ],
    [
      "ange",
      0.0075
    ],
    [
      "aide",
      0.0075
    ],
    [
      "soviet",
      0.0075
    ]
  ],
  "corneille": [
    [
      "choucas",
      0.3325
    ],
    [
      "corbeau",
      0.3325
    ],
    [
      "corvide",
      0.3325
    ]
  ],
  "monarchie": [
    [
      "gouvernement",
      0.185
    ],
    [
      "royaute",
      0.185
    ],
    [
      "regne",
      0.185
    ],
    [
      "couronne",
      0.125
    ],
    [
      "royaume",
      0.125
    ],
    [
      "trone",
      0.125
    ],
    [
      "autocratie",
      0.06
    ]
  ],
  "tyrannie": [
    [
      "autorite",
      0.115
    ],
    [
      "despotisme",
      0.0975
    ],
    [
      "absolutisme",
      0.06
    ],
    [
      "domination",
      0.06
    ],
    [
      "dictature",
      0.0525
    ],
    [
      "autoritarisme",
      0.0425
    ],
    [
      "autocratie",
      0.035
    ],
    [
      "asservissement",
      0.035
    ],
    [
      "totalitarisme",
      0.025
    ],
    [
      "oppression",
      0.025
    ],
    [
      "omnipotence",
      0.025
    ],
    [
      "joug",
      0.025
    ],
    [
      "influence",
      0.025
    ],
    [
      "gouvernement",
      0.025
    ],
    [
      "emprise",
      0.025
    ],
    [
      "empire",
      0.025
    ],
    [
      "cesarisme",
      0.025
    ],
    [
      "assujettissement",
      0.025
    ],
    [
      "servitude",
      0.0175
    ],
    [
      "prepotence",
      0.0175
    ],
    [
      "empietement",
      0.0175
    ],
    [
      "caporalisme",
      0.0175
    ],
    [
      "barbarie",
      0.0175
    ],
    [
      "ascendant",
      0.0175
    ],
    [
      "usurpation",
      0.0075
    ],
    [
      "sauvagerie",
      0.0075
    ],
    [
      "persecution",
      0.0075
    ],
    [
      "nazisme",
      0.0075
    ],
    [
      "mainmise",
      0.0075
    ],
    [
      "inhumanite",
      0.0075
    ],
    [
      "ferocite",
      0.0075
    ],
    [
      "fascisme",
      0.0075
    ],
    [
      "cruaute",
      0.0075
    ],
    [
      "chaine",
      0.0075
    ],
    [
      "carcan",
      0.0075
    ],
    [
      "bras",
      0.0075
    ],
    [
      "arbitraire",
      0.0075
    ],
    [
      "vandalisme",
      0.0075
    ]
  ],
  "boutique": [
    [
      "magasin",
      0.115
    ],
    [
      "bazar",
      0.0875
    ],
    [
      "affaire",
      0.0725
    ],
    [
      "boite",
      0.0725
    ],
    [
      "coterie",
      0.0575
    ],
    [
      "commerce",
      0.0575
    ],
    [
      "clan",
      0.0575
    ],
    [
      "baraque",
      0.0425
    ],
    [
      "clique",
      0.0425
    ],
    [
      "echoppe",
      0.0275
    ],
    [
      "debit",
      0.0275
    ],
    [
      "chapelle",
      0.0275
    ],
    [
      "camarilla",
      0.0275
    ],
    [
      "attirail",
      0.0275
    ],
    [
      "maffia",
      0.0125
    ],
    [
      "officine",
      0.0125
    ],
    [
      "outillage",
      0.0125
    ],
    [
      "reserve",
      0.0125
    ],
    [
      "turne",
      0.0125
    ],
    [
      "vitrine",
      0.0125
    ],
    [
      "fonds",
      0.0125
    ],
    [
      "cremerie",
      0.0125
    ],
    [
      "cercle",
      0.0125
    ],
    [
      "bicoque",
      0.0125
    ],
    [
      "banneton",
      0.0125
    ],
    [
      "bande",
      0.0125
    ],
    [
      "bahut",
      0.0125
    ],
    [
      "atelier",
      0.0125
    ],
    [
      "vivier",
      0.0125
    ]
  ],
  "ouest": [
    [
      "couchant",
      0.25
    ],
    [
      "occident",
      0.25
    ],
    [
      "occidental",
      0.25
    ],
    [
      "ponant",
      0.25
    ]
  ],
  "secours": [
    [
      "aider",
      0.2
    ],
    [
      "servir",
      0.1325
    ],
    [
      "appuyer",
      0.0875
    ],
    [
      "assister",
      0.0875
    ],
    [
      "soutenir",
      0.065
    ],
    [
      "repecher",
      0.065
    ],
    [
      "proteger",
      0.065
    ],
    [
      "defendre",
      0.0425
    ],
    [
      "veiller",
      0.02
    ],
    [
      "soulager",
      0.02
    ],
    [
      "profiter",
      0.02
    ],
    [
      "obliger",
      0.02
    ],
    [
      "intervenir",
      0.02
    ],
    [
      "epauler",
      0.02
    ]
  ],
  "secourir": [
    [
      "aider",
      0.2
    ],
    [
      "servir",
      0.1325
    ],
    [
      "appuyer",
      0.0875
    ],
    [
      "assister",
      0.0875
    ],
    [
      "soutenir",
      0.065
    ],
    [
      "repecher",
      0.065
    ],
    [
      "proteger",
      0.065
    ],
    [
      "defendre",
      0.0425
    ],
    [
      "veiller",
      0.02
    ],
    [
      "soulager",
      0.02
    ],
    [
      "profiter",
      0.02
    ],
    [
      "obliger",
      0.02
    ],
    [
      "intervenir",
      0.02
    ],
    [
      "epauler",
      0.02
    ]
  ],
  "contester": [
    [
      "discuter",
      0.0975
    ],
    [
      "chicaner",
      0.09
    ],
    [
      "protester",
      0.0575
    ],
    [
      "nier",
      0.0475
    ],
    [
      "s'opposer",
      0.04
    ],
    [
      "disputer",
      0.04
    ],
    [
      "controverser",
      0.04
    ],
    [
      "refuser",
      0.0325
    ],
    [
      "ergoter",
      0.0325
    ],
    [
      "arguer",
      0.0325
    ],
    [
      "s'insurger",
      0.0225
    ],
    [
      "resister",
      0.0225
    ],
    [
      "refuter",
      0.0225
    ],
    [
      "quereller",
      0.0225
    ],
    [
      "objecter",
      0.0225
    ],
    [
      "contredire",
      0.0225
    ],
    [
      "batailler",
      0.0225
    ],
    [
      "attaquer",
      0.0225
    ],
    [
      "argumenter",
      0.0225
    ],
    [
      "recuser",
      0.015
    ],
    [
      "reclamer",
      0.015
    ],
    [
      "demeler",
      0.015
    ],
    [
      "dementir",
      0.015
    ],
    [
      "debattre",
      0.015
    ],
    [
      "revoquer",
      0.0075
    ],
    [
      "revendiquer",
      0.0075
    ],
    [
      "pointiller",
      0.0075
    ],
    [
      "plaider",
      0.0075
    ],
    [
      "denier",
      0.0075
    ],
    [
      "douter",
      0.0075
    ],
    [
      "chinoiser",
      0.0075
    ],
    [
      "broncher",
      0.0075
    ]
  ],
  "conteste": [
    [
      "contestation",
      1.0
    ]
  ],
  "frontiere": [
    [
      "limite",
      0.265
    ],
    [
      "extremite",
      0.1
    ],
    [
      "demarcation",
      0.08
    ],
    [
      "borne",
      0.06
    ],
    [
      "lisiere",
      0.06
    ],
    [
      "separation",
      0.06
    ],
    [
      "terme",
      0.06
    ],
    [
      "ligne",
      0.04
    ],
    [
      "fin",
      0.04
    ],
    [
      "delimitation",
      0.04
    ],
    [
      "bordure",
      0.04
    ],
    [
      "bord",
      0.04
    ],
    [
      "bout",
      0.02
    ],
    [
      "confins",
      0.02
    ],
    [
      "limitrophe",
      0.02
    ],
    [
      "marche",
      0.02
    ],
    [
      "mur",
      0.02
    ]
  ],
  "rumeur": [
    [
      "bruit",
      0.1825
    ],
    [
      "potin",
      0.065
    ],
    [
      "tapage",
      0.0475
    ],
    [
      "nouvelle",
      0.0475
    ],
    [
      "brouhaha",
      0.0475
    ],
    [
      "bourdonnement",
      0.0475
    ],
    [
      "echo",
      0.0325
    ],
    [
      "tumulte",
      0.0325
    ],
    [
      "renommee",
      0.0325
    ],
    [
      "ragot",
      0.0325
    ],
    [
      "racontar",
      0.0325
    ],
    [
      "opinion",
      0.0325
    ],
    [
      "medisance",
      0.0325
    ],
    [
      "bobard",
      0.0325
    ],
    [
      "avis",
      0.0325
    ],
    [
      "ronron",
      0.015
    ],
    [
      "murmure",
      0.015
    ],
    [
      "jugement",
      0.015
    ],
    [
      "grondement",
      0.015
    ],
    [
      "confusion",
      0.015
    ],
    [
      "canard",
      0.015
    ],
    [
      "accusation",
      0.015
    ],
    [
      "eclat",
      0.015
    ]
  ],
  "repandre": [
    [
      "semer",
      0.065
    ],
    [
      "propager",
      0.045
    ],
    [
      "jeter",
      0.04
    ],
    [
      "donner",
      0.0375
    ],
    [
      "publier",
      0.0375
    ],
    [
      "emettre",
      0.0325
    ],
    [
      "verser",
      0.0325
    ],
    [
      "distribuer",
      0.0325
    ],
    [
      "dire",
      0.0325
    ],
    [
      "etaler",
      0.0275
    ],
    [
      "eparpiller",
      0.0275
    ],
    [
      "epandre",
      0.0275
    ],
    [
      "repartir",
      0.0275
    ],
    [
      "colporter",
      0.0225
    ],
    [
      "exhaler",
      0.0225
    ],
    [
      "prodiguer",
      0.0225
    ],
    [
      "etendre",
      0.0225
    ],
    [
      "epancher",
      0.02
    ],
    [
      "parsemer",
      0.02
    ],
    [
      "lancer",
      0.02
    ],
    [
      "disseminer",
      0.02
    ],
    [
      "disperser",
      0.02
    ],
    [
      "diffuser",
      0.02
    ],
    [
      "passer",
      0.015
    ],
    [
      "deverser",
      0.015
    ],
    [
      "degager",
      0.015
    ],
    [
      "divulguer",
      0.015
    ],
    [
      "dispenser",
      0.015
    ],
    [
      "couvrir",
      0.015
    ],
    [
      "introduire",
      0.01
    ],
    [
      "generaliser",
      0.01
    ],
    [
      "ebruiter",
      0.0075
    ],
    [
      "vulgariser",
      0.0075
    ],
    [
      "transporter",
      0.0075
    ],
    [
      "renverser",
      0.0075
    ],
    [
      "provoquer",
      0.0075
    ],
    [
      "parfumer",
      0.0075
    ],
    [
      "joncher",
      0.0075
    ],
    [
      "developper",
      0.0075
    ],
    [
      "accorder",
      0.0075
    ],
    [
      "accrediter",
      0.0075
    ],
    [
      "arroser",
      0.0075
    ],
    [
      "bavarder",
      0.0075
    ],
    [
      "crier",
      0.0075
    ],
    [
      "degorger",
      0.0075
    ],
    [
      "paver",
      0.0025
    ],
    [
      "pleurer",
      0.0025
    ],
    [
      "populariser",
      0.0025
    ],
    [
      "tambouriner",
      0.0025
    ],
    [
      "eclairer",
      0.0025
    ],
    [
      "epartir",
      0.0025
    ],
    [
      "evaporer",
      0.0025
    ],
    [
      "orchestrer",
      0.0025
    ],
    [
      "medire",
      0.0025
    ],
    [
      "jaboter",
      0.0025
    ],
    [
      "fleurer",
      0.0025
    ],
    [
      "essaimer",
      0.0025
    ],
    [
      "ensemencer",
      0.0025
    ],
    [
      "emplir",
      0.0025
    ],
    [
      "embaumer",
      0.0025
    ],
    [
      "distiller",
      0.0025
    ],
    [
      "eventer",
      0.0025
    ]
  ],
  "nouvel": [
    [
      "neuf",
      0.105
    ],
    [
      "original",
      0.0825
    ],
    [
      "inusite",
      0.0525
    ],
    [
      "inedit",
      0.04
    ],
    [
      "moderne",
      0.04
    ],
    [
      "extraordinaire",
      0.035
    ],
    [
      "novice",
      0.0275
    ],
    [
      "insolite",
      0.0275
    ],
    [
      "inoui",
      0.0275
    ],
    [
      "inconnu",
      0.0275
    ],
    [
      "hardi",
      0.0275
    ],
    [
      "truculent",
      0.0225
    ],
    [
      "recent",
      0.0225
    ],
    [
      "jeune",
      0.0225
    ],
    [
      "inexperimente",
      0.0225
    ],
    [
      "vert",
      0.0175
    ],
    [
      "surprenant",
      0.0175
    ],
    [
      "ose",
      0.0175
    ],
    [
      "inhabituel",
      0.0175
    ],
    [
      "inattendu",
      0.0175
    ],
    [
      "inaccoutume",
      0.0175
    ],
    [
      "frais",
      0.0175
    ],
    [
      "debutant",
      0.0175
    ],
    [
      "different",
      0.0175
    ],
    [
      "audacieux",
      0.0175
    ],
    [
      "inimagine",
      0.01
    ],
    [
      "insoupconne",
      0.01
    ],
    [
      "ultramoderne",
      0.01
    ],
    [
      "vierge",
      0.01
    ],
    [
      "inexplore",
      0.01
    ],
    [
      "in",
      0.01
    ],
    [
      "bleu",
      0.01
    ],
    [
      "autre",
      0.01
    ],
    [
      "apprenti",
      0.01
    ],
    [
      "actuel",
      0.01
    ],
    [
      "personnel",
      0.005
    ],
    [
      "primeur",
      0.005
    ],
    [
      "printanier",
      0.005
    ],
    [
      "second",
      0.005
    ],
    [
      "neophyte",
      0.005
    ],
    [
      "novateur",
      0.005
    ],
    [
      "nouveaute",
      0.005
    ],
    [
      "metamorphose",
      0.005
    ],
    [
      "dernier",
      0.005
    ],
    [
      "change",
      0.005
    ],
    [
      "bizut",
      0.005
    ]
  ],
  "album": [
    [
      "livre",
      0.2
    ],
    [
      "recueil",
      0.2
    ],
    [
      "registre",
      0.1325
    ],
    [
      "herbier",
      0.065
    ],
    [
      "collection",
      0.065
    ],
    [
      "coffret",
      0.065
    ],
    [
      "classeur",
      0.065
    ],
    [
      "carnet",
      0.065
    ],
    [
      "cahier",
      0.065
    ],
    [
      "keepsake",
      0.065
    ]
  ],
  "video": [
    [
      "audiovisuel",
      0.25
    ],
    [
      "magnetoscope",
      0.25
    ],
    [
      "videocassette",
      0.25
    ],
    [
      "videodisque",
      0.25
    ]
  ],
  "truc": [
    [
      "ruse",
      0.0975
    ],
    [
      "artifice",
      0.0925
    ],
    [
      "astuce",
      0.0925
    ],
    [
      "moyen",
      0.06
    ],
    [
      "methode",
      0.035
    ],
    [
      "procede",
      0.0275
    ],
    [
      "tromperie",
      0.0225
    ],
    [
      "combine",
      0.0225
    ],
    [
      "habilete",
      0.0175
    ],
    [
      "systeme",
      0.0175
    ],
    [
      "tour",
      0.0175
    ],
    [
      "stratageme",
      0.0175
    ],
    [
      "rouerie",
      0.0175
    ],
    [
      "intrigue",
      0.015
    ],
    [
      "art",
      0.0125
    ],
    [
      "combinaison",
      0.0125
    ],
    [
      "finesse",
      0.0125
    ],
    [
      "manoeuvre",
      0.0125
    ],
    [
      "maniere",
      0.0125
    ],
    [
      "machin",
      0.0125
    ],
    [
      "technique",
      0.01
    ],
    [
      "tactique",
      0.01
    ],
    [
      "matoiserie",
      0.01
    ],
    [
      "invention",
      0.01
    ],
    [
      "ficelle",
      0.01
    ],
    [
      "expedient",
      0.01
    ],
    [
      "detour",
      0.01
    ],
    [
      "fourberie",
      0.01
    ],
    [
      "piege",
      0.01
    ],
    [
      "secret",
      0.0075
    ],
    [
      "machination",
      0.0075
    ],
    [
      "instrument",
      0.0075
    ],
    [
      "finasserie",
      0.0075
    ],
    [
      "duperie",
      0.0075
    ],
    [
      "subterfuge",
      0.005
    ],
    [
      "ressource",
      0.005
    ],
    [
      "recette",
      0.005
    ],
    [
      "politique",
      0.005
    ],
    [
      "machine",
      0.005
    ],
    [
      "histoire",
      0.005
    ],
    [
      "bidule",
      0.005
    ],
    [
      "affaire",
      0.005
    ],
    [
      "voie",
      0.005
    ],
    [
      "truquage",
      0.005
    ],
    [
      "strategie",
      0.005
    ],
    [
      "pratique",
      0.005
    ],
    [
      "engin",
      0.005
    ],
    [
      "chose",
      0.005
    ],
    [
      "echappatoire",
      0.0025
    ],
    [
      "supercherie",
      0.0025
    ],
    [
      "subtilite",
      0.0025
    ],
    [
      "roublardise",
      0.0025
    ],
    [
      "mystification",
      0.0025
    ],
    [
      "mode",
      0.0025
    ],
    [
      "machiavelisme",
      0.0025
    ],
    [
      "fraude",
      0.0025
    ],
    [
      "formule",
      0.0025
    ],
    [
      "embuche",
      0.0025
    ],
    [
      "diplomatie",
      0.0025
    ],
    [
      "carotte",
      0.0025
    ],
    [
      "perfidie",
      0.0
    ],
    [
      "prestidigitation",
      0.0
    ],
    [
      "procedure",
      0.0
    ],
    [
      "retour",
      0.0
    ],
    [
      "rubrique",
      0.0
    ],
    [
      "trame",
      0.0
    ],
    [
      "meandre",
      0.0
    ],
    [
      "malice",
      0.0
    ],
    [
      "feinte",
      0.0
    ],
    [
      "acrobatie",
      0.0
    ],
    [
      "cautele",
      0.0
    ],
    [
      "coup",
      0.0
    ],
    [
      "dispositif",
      0.0
    ],
    [
      "demarche",
      0.0
    ],
    [
      "ustensile",
      0.0
    ],
    [
      "trucmuche",
      0.0
    ],
    [
      "theorie",
      0.0
    ],
    [
      "rets",
      0.0
    ],
    [
      "patente",
      0.0
    ],
    [
      "joint",
      0.0
    ],
    [
      "fourbi",
      0.0
    ],
    [
      "filon",
      0.0
    ],
    [
      "chafouinerie",
      0.0
    ],
    [
      "business",
      0.0
    ],
    [
      "zinzin",
      0.0
    ]
  ],
  "basique": [
    [
      "alcalin",
      0.3325
    ],
    [
      "basal",
      0.3325
    ],
    [
      "fondamental",
      0.3325
    ]
  ],
  "ok": [],
  "intelligent": [
    [
      "penetrant",
      0.075
    ],
    [
      "habile",
      0.0675
    ],
    [
      "perspicace",
      0.055
    ],
    [
      "fin",
      0.05
    ],
    [
      "vif",
      0.045
    ],
    [
      "subtil",
      0.045
    ],
    [
      "fort",
      0.0375
    ],
    [
      "percant",
      0.0375
    ],
    [
      "lucide",
      0.0325
    ],
    [
      "eclaire",
      0.0325
    ],
    [
      "malin",
      0.0275
    ],
    [
      "ingenieux",
      0.0275
    ],
    [
      "aigu",
      0.0275
    ],
    [
      "astucieux",
      0.025
    ],
    [
      "brillant",
      0.025
    ],
    [
      "capable",
      0.025
    ],
    [
      "sagace",
      0.025
    ],
    [
      "spirituel",
      0.02
    ],
    [
      "sense",
      0.02
    ],
    [
      "ouvert",
      0.02
    ],
    [
      "judicieux",
      0.02
    ],
    [
      "experimente",
      0.02
    ],
    [
      "clairvoyant",
      0.02
    ],
    [
      "adroit",
      0.02
    ],
    [
      "instruit",
      0.015
    ],
    [
      "profond",
      0.015
    ],
    [
      "sage",
      0.015
    ],
    [
      "eveille",
      0.015
    ],
    [
      "petillant",
      0.0125
    ],
    [
      "entendu",
      0.0125
    ],
    [
      "doue",
      0.0125
    ],
    [
      "ardent",
      0.0125
    ],
    [
      "competent",
      0.0075
    ],
    [
      "genial",
      0.0075
    ],
    [
      "pertinent",
      0.0075
    ],
    [
      "raisonnable",
      0.0075
    ],
    [
      "comprehensif",
      0.0025
    ],
    [
      "inventif",
      0.0025
    ],
    [
      "pensant",
      0.0025
    ]
  ],
  "sinon": [
    [
      "autrement",
      0.2
    ],
    [
      "excepte",
      0.2
    ],
    [
      "sauf",
      0.1
    ]
  ],
  "alcool": [
    [
      "boisson",
      0.0825
    ],
    [
      "liqueur",
      0.0675
    ],
    [
      "brandevin",
      0.04
    ],
    [
      "riquiqui",
      0.0275
    ],
    [
      "rincette",
      0.0275
    ],
    [
      "marc",
      0.0275
    ],
    [
      "ivresse",
      0.0275
    ],
    [
      "digestif",
      0.0275
    ],
    [
      "brandy",
      0.0275
    ],
    [
      "petrole",
      0.0125
    ],
    [
      "quintessence",
      0.0125
    ],
    [
      "rhum",
      0.0125
    ],
    [
      "rinconnette",
      0.0125
    ],
    [
      "rogomme",
      0.0125
    ],
    [
      "schnaps",
      0.0125
    ],
    [
      "schnick",
      0.0125
    ],
    [
      "soulerie",
      0.0125
    ],
    [
      "spiritueux",
      0.0125
    ],
    [
      "tafia",
      0.0125
    ],
    [
      "goutte",
      0.0125
    ],
    [
      "gnole",
      0.0125
    ],
    [
      "bibine",
      0.0125
    ],
    [
      "bistouille",
      0.0125
    ],
    [
      "blanche",
      0.0125
    ],
    [
      "combustible",
      0.0125
    ],
    [
      "cric",
      0.0125
    ],
    [
      "eau",
      0.0125
    ],
    [
      "esprit",
      0.0125
    ],
    [
      "ethanol",
      0.0125
    ]
  ],
  "personnes": [
    [
      "homme",
      0.195
    ],
    [
      "individu",
      0.1575
    ],
    [
      "type",
      0.085
    ],
    [
      "personnage",
      0.0425
    ],
    [
      "ame",
      0.035
    ],
    [
      "etre",
      0.035
    ],
    [
      "citoyen",
      0.0275
    ],
    [
      "bougre",
      0.0275
    ],
    [
      "zebre",
      0.02
    ],
    [
      "zigoto",
      0.02
    ],
    [
      "quidam",
      0.02
    ],
    [
      "quelqu'un",
      0.02
    ],
    [
      "personnalite",
      0.02
    ],
    [
      "oiseau",
      0.02
    ],
    [
      "habitant",
      0.02
    ],
    [
      "creature",
      0.02
    ],
    [
      "corps",
      0.02
    ],
    [
      "zig",
      0.0125
    ],
    [
      "pierrot",
      0.0125
    ],
    [
      "mortel",
      0.0125
    ],
    [
      "moi",
      0.0125
    ],
    [
      "mec",
      0.0125
    ],
    [
      "humain",
      0.0125
    ],
    [
      "coco",
      0.0125
    ],
    [
      "sujet",
      0.005
    ],
    [
      "quiconque",
      0.005
    ],
    [
      "peau",
      0.005
    ],
    [
      "particulier",
      0.005
    ],
    [
      "paroissien",
      0.005
    ],
    [
      "on",
      0.005
    ],
    [
      "nul",
      0.005
    ],
    [
      "moineau",
      0.005
    ],
    [
      "gonze",
      0.005
    ],
    [
      "femme",
      0.005
    ],
    [
      "chacun",
      0.005
    ],
    [
      "bipede",
      0.005
    ],
    [
      "tete",
      0.005
    ]
  ],
  "mechant": [
    [
      "mauvais",
      0.1325
    ],
    [
      "faible",
      0.03
    ],
    [
      "pauvre",
      0.03
    ],
    [
      "miserable",
      0.025
    ],
    [
      "terrible",
      0.025
    ],
    [
      "dur",
      0.0225
    ],
    [
      "insignifiant",
      0.02
    ],
    [
      "inhumain",
      0.02
    ],
    [
      "desagreable",
      0.02
    ],
    [
      "cruel",
      0.0175
    ],
    [
      "mediocre",
      0.0175
    ],
    [
      "amer",
      0.0175
    ],
    [
      "minable",
      0.0175
    ],
    [
      "odieux",
      0.0175
    ],
    [
      "pietre",
      0.015
    ],
    [
      "pitoyable",
      0.015
    ],
    [
      "malheureux",
      0.015
    ],
    [
      "lamentable",
      0.015
    ],
    [
      "insupportable",
      0.015
    ],
    [
      "diable",
      0.015
    ],
    [
      "atroce",
      0.0125
    ],
    [
      "hargneux",
      0.0125
    ],
    [
      "petit",
      0.0125
    ],
    [
      "malfaisant",
      0.0125
    ],
    [
      "insuffisant",
      0.0125
    ],
    [
      "venimeux",
      0.01
    ],
    [
      "pervers",
      0.01
    ],
    [
      "malveillant",
      0.01
    ],
    [
      "detestable",
      0.01
    ],
    [
      "deplorable",
      0.01
    ],
    [
      "affreux",
      0.01
    ],
    [
      "scelerat",
      0.0075
    ],
    [
      "infernal",
      0.0075
    ],
    [
      "acerbe",
      0.0075
    ],
    [
      "acariatre",
      0.0075
    ],
    [
      "piteux",
      0.0075
    ],
    [
      "perfide",
      0.0075
    ],
    [
      "nul",
      0.0075
    ],
    [
      "mordant",
      0.0075
    ],
    [
      "malin",
      0.0075
    ],
    [
      "intraitable",
      0.0075
    ],
    [
      "injuste",
      0.0075
    ],
    [
      "haineux",
      0.0075
    ],
    [
      "feroce",
      0.0075
    ],
    [
      "diabolique",
      0.0075
    ],
    [
      "bas",
      0.0075
    ],
    [
      "agressif",
      0.0075
    ],
    [
      "maigre",
      0.005
    ],
    [
      "malhonnete",
      0.005
    ],
    [
      "maussade",
      0.005
    ],
    [
      "rosse",
      0.005
    ],
    [
      "vache",
      0.005
    ],
    [
      "infime",
      0.005
    ],
    [
      "indigne",
      0.005
    ],
    [
      "acrimonieux",
      0.005
    ],
    [
      "brutal",
      0.005
    ],
    [
      "coquin",
      0.005
    ],
    [
      "dangereux",
      0.005
    ],
    [
      "fielleux",
      0.005
    ],
    [
      "vilain",
      0.0025
    ],
    [
      "turbulent",
      0.0025
    ],
    [
      "sauvage",
      0.0025
    ],
    [
      "peste",
      0.0025
    ],
    [
      "negligeable",
      0.0025
    ],
    [
      "nuisible",
      0.0025
    ],
    [
      "massacrant",
      0.0025
    ],
    [
      "demoniaque",
      0.0025
    ],
    [
      "corrosif",
      0.0025
    ],
    [
      "bourru",
      0.0025
    ],
    [
      "poison",
      0.0025
    ],
    [
      "sadique",
      0.0025
    ],
    [
      "salaud",
      0.0025
    ],
    [
      "satanique",
      0.0025
    ],
    [
      "sinistre",
      0.0025
    ],
    [
      "sournois",
      0.0025
    ],
    [
      "teigne",
      0.0025
    ],
    [
      "medisant",
      0.0025
    ],
    [
      "masque",
      0.0025
    ],
    [
      "malicieux",
      0.0025
    ],
    [
      "antipathique",
      0.0025
    ],
    [
      "calomnieux",
      0.0025
    ],
    [
      "cholera",
      0.0025
    ],
    [
      "criminel",
      0.0025
    ],
    [
      "demon",
      0.0025
    ],
    [
      "felon",
      0.0025
    ],
    [
      "gale",
      0.0025
    ],
    [
      "incapable",
      0.0025
    ],
    [
      "incompetent",
      0.0
    ],
    [
      "malintentionne",
      0.0
    ],
    [
      "miteux",
      0.0
    ],
    [
      "pendable",
      0.0
    ],
    [
      "rossard",
      0.0
    ],
    [
      "sale",
      0.0
    ],
    [
      "formidable",
      0.0
    ],
    [
      "fier",
      0.0
    ],
    [
      "enfielle",
      0.0
    ],
    [
      "defectueux",
      0.0
    ],
    [
      "charogne",
      0.0
    ],
    [
      "chameau",
      0.0
    ],
    [
      "calomniateur",
      0.0
    ],
    [
      "bouc",
      0.0
    ],
    [
      "vipere",
      0.0
    ]
  ],
  "film": [
    [
      "pellicule",
      0.1875
    ],
    [
      "emulsion",
      0.0625
    ],
    [
      "western",
      0.0625
    ],
    [
      "typon",
      0.0625
    ],
    [
      "thriller",
      0.0625
    ],
    [
      "peplum",
      0.0625
    ],
    [
      "production",
      0.0625
    ],
    [
      "processus",
      0.0625
    ],
    [
      "navet",
      0.0625
    ],
    [
      "couche",
      0.0625
    ],
    [
      "clip",
      0.0625
    ],
    [
      "bande",
      0.0625
    ],
    [
      "evolution",
      0.0625
    ]
  ],
  "fine": [
    [
      "delicat",
      0.0425
    ],
    [
      "habile",
      0.0325
    ],
    [
      "achevement",
      0.0275
    ],
    [
      "subtil",
      0.0275
    ],
    [
      "leger",
      0.025
    ],
    [
      "beau",
      0.0225
    ],
    [
      "adroit",
      0.0225
    ],
    [
      "but",
      0.02
    ],
    [
      "delie",
      0.0175
    ],
    [
      "denouement",
      0.0175
    ],
    [
      "svelte",
      0.0175
    ],
    [
      "terminaison",
      0.0175
    ],
    [
      "terme",
      0.0175
    ],
    [
      "mince",
      0.0175
    ],
    [
      "resolution",
      0.015
    ],
    [
      "intelligent",
      0.015
    ],
    [
      "penetrant",
      0.015
    ],
    [
      "solution",
      0.015
    ],
    [
      "conclusion",
      0.0125
    ],
    [
      "grele",
      0.0125
    ],
    [
      "resultat",
      0.0125
    ],
    [
      "malin",
      0.0125
    ],
    [
      "extremite",
      0.0125
    ],
    [
      "bout",
      0.0125
    ],
    [
      "aboutissement",
      0.01
    ],
    [
      "cessation",
      0.01
    ],
    [
      "chute",
      0.01
    ],
    [
      "tenu",
      0.01
    ],
    [
      "elegant",
      0.01
    ],
    [
      "spirituel",
      0.01
    ],
    [
      "ruse",
      0.01
    ],
    [
      "distingue",
      0.01
    ],
    [
      "astucieux",
      0.01
    ],
    [
      "queue",
      0.0075
    ],
    [
      "piquant",
      0.0075
    ],
    [
      "mort",
      0.0075
    ],
    [
      "extinction",
      0.0075
    ],
    [
      "exquis",
      0.0075
    ],
    [
      "dessein",
      0.0075
    ],
    [
      "aigu",
      0.0075
    ],
    [
      "souple",
      0.0075
    ],
    [
      "ruine",
      0.0075
    ],
    [
      "raffine",
      0.0075
    ],
    [
      "menu",
      0.0075
    ],
    [
      "issue",
      0.0075
    ],
    [
      "fute",
      0.0075
    ],
    [
      "fusele",
      0.0075
    ],
    [
      "effondrement",
      0.0075
    ],
    [
      "doux",
      0.0075
    ],
    [
      "brillant",
      0.0075
    ],
    [
      "aneantissement",
      0.0075
    ],
    [
      "ingenieux",
      0.005
    ],
    [
      "intention",
      0.005
    ],
    [
      "perspicace",
      0.005
    ],
    [
      "percant",
      0.005
    ],
    [
      "petit",
      0.005
    ],
    [
      "excellent",
      0.005
    ],
    [
      "decadence",
      0.005
    ],
    [
      "coda",
      0.005
    ],
    [
      "couronnement",
      0.005
    ],
    [
      "destruction",
      0.005
    ],
    [
      "diplomate",
      0.005
    ],
    [
      "disparition",
      0.005
    ],
    [
      "elance",
      0.005
    ],
    [
      "roublard",
      0.005
    ],
    [
      "retors",
      0.005
    ],
    [
      "pur",
      0.005
    ],
    [
      "maigre",
      0.005
    ],
    [
      "galant",
      0.005
    ],
    [
      "finalite",
      0.005
    ],
    [
      "declin",
      0.005
    ],
    [
      "arret",
      0.005
    ],
    [
      "agonie",
      0.005
    ],
    [
      "pointu",
      0.0025
    ],
    [
      "politique",
      0.0025
    ],
    [
      "precieux",
      0.0025
    ],
    [
      "sagace",
      0.0025
    ],
    [
      "superieur",
      0.0025
    ],
    [
      "tendre",
      0.0025
    ],
    [
      "objectif",
      0.0025
    ],
    [
      "matois",
      0.0025
    ],
    [
      "avise",
      0.0025
    ],
    [
      "consommation",
      0.0025
    ],
    [
      "effet",
      0.0025
    ],
    [
      "filiforme",
      0.0025
    ],
    [
      "finition",
      0.0025
    ],
    [
      "gracile",
      0.0025
    ],
    [
      "limite",
      0.0025
    ],
    [
      "motif",
      0.0025
    ],
    [
      "objet",
      0.0025
    ],
    [
      "perfection",
      0.0025
    ],
    [
      "remarquable",
      0.0025
    ],
    [
      "sortie",
      0.0025
    ],
    [
      "soyeux",
      0.0025
    ],
    [
      "succulent",
      0.0025
    ],
    [
      "visee",
      0.0025
    ],
    [
      "epilogue",
      0.0025
    ],
    [
      "etroit",
      0.0025
    ],
    [
      "evenement",
      0.0025
    ],
    [
      "intrigant",
      0.0025
    ],
    [
      "frele",
      0.0025
    ],
    [
      "frontiere",
      0.0025
    ],
    [
      "acere",
      0.0025
    ],
    [
      "affine",
      0.0025
    ],
    [
      "ambition",
      0.0025
    ],
    [
      "borne",
      0.0025
    ],
    [
      "cauteleux",
      0.0025
    ],
    [
      "clairvoyant",
      0.0025
    ],
    [
      "cloture",
      0.0025
    ],
    [
      "crepuscule",
      0.0025
    ],
    [
      "destination",
      0.0025
    ],
    [
      "enterrement",
      0.0025
    ],
    [
      "expiration",
      0.0025
    ],
    [
      "finaud",
      0.0025
    ],
    [
      "sensible",
      0.0
    ],
    [
      "peroraison",
      0.0
    ],
    [
      "narquois",
      0.0
    ],
    [
      "minuscule",
      0.0
    ],
    [
      "microscopique",
      0.0
    ],
    [
      "impalpable",
      0.0
    ],
    [
      "soir",
      0.0
    ],
    [
      "sort",
      0.0
    ],
    [
      "suspension",
      0.0
    ],
    [
      "tendance",
      0.0
    ],
    [
      "terminus",
      0.0
    ],
    [
      "trepas",
      0.0
    ],
    [
      "vaporeux",
      0.0
    ],
    [
      "vues",
      0.0
    ],
    [
      "guerison",
      0.0
    ],
    [
      "finissage",
      0.0
    ],
    [
      "finale",
      0.0
    ],
    [
      "acheve",
      0.0
    ],
    [
      "aiguise",
      0.0
    ],
    [
      "allonge",
      0.0
    ],
    [
      "arachneen",
      0.0
    ],
    [
      "averti",
      0.0
    ],
    [
      "completement",
      0.0
    ],
    [
      "dessert",
      0.0
    ],
    [
      "debacle",
      0.0
    ],
    [
      "deces",
      0.0
    ],
    [
      "detourne",
      0.0
    ],
    [
      "entendu",
      0.0
    ],
    [
      "entierement",
      0.0
    ],
    [
      "extra",
      0.0
    ],
    [
      "final",
      0.0
    ],
    [
      "absolument",
      0.0
    ]
  ],
  "habiller": [
    [
      "fringuer",
      0.0925
    ],
    [
      "accoutrer",
      0.08
    ],
    [
      "deguiser",
      0.07
    ],
    [
      "parer",
      0.0575
    ],
    [
      "vetir",
      0.0475
    ],
    [
      "arranger",
      0.0475
    ],
    [
      "affubler",
      0.0425
    ],
    [
      "attifer",
      0.0425
    ],
    [
      "ajuster",
      0.0375
    ],
    [
      "revetir",
      0.0375
    ],
    [
      "orner",
      0.03
    ],
    [
      "embellir",
      0.03
    ],
    [
      "couvrir",
      0.03
    ],
    [
      "envelopper",
      0.025
    ],
    [
      "fagoter",
      0.02
    ],
    [
      "ficeler",
      0.02
    ],
    [
      "masquer",
      0.02
    ],
    [
      "travestir",
      0.02
    ],
    [
      "harnacher",
      0.015
    ],
    [
      "entourer",
      0.015
    ],
    [
      "endimancher",
      0.015
    ],
    [
      "decorer",
      0.015
    ],
    [
      "draper",
      0.015
    ],
    [
      "costumer",
      0.015
    ],
    [
      "ridiculiser",
      0.01
    ],
    [
      "recouvrir",
      0.01
    ],
    [
      "medire",
      0.01
    ],
    [
      "dissimuler",
      0.01
    ],
    [
      "convenir",
      0.01
    ],
    [
      "camoufler",
      0.01
    ],
    [
      "aller",
      0.01
    ],
    [
      "tendre",
      0.005
    ],
    [
      "seoir",
      0.005
    ],
    [
      "nipper",
      0.005
    ],
    [
      "enrichir",
      0.005
    ],
    [
      "enharnacher",
      0.005
    ],
    [
      "culotter",
      0.005
    ],
    [
      "calomnier",
      0.005
    ],
    [
      "avantager",
      0.005
    ],
    [
      "equiper",
      0.005
    ]
  ],
  "nazi": [
    [
      "hitlerien",
      0.2
    ],
    [
      "neonazi",
      0.2
    ],
    [
      "totalitaire",
      0.2
    ]
  ],
  "dauphin": [
    [
      "jottereau",
      0.2
    ],
    [
      "prince",
      0.2
    ],
    [
      "souffleur",
      0.2
    ],
    [
      "successeur",
      0.2
    ],
    [
      "epaulard",
      0.2
    ]
  ],
  "violeur": [
    [
      "violateur",
      0.5
    ],
    [
      "violenteur",
      0.5
    ]
  ],
  "mefier": [
    [
      "soupconner",
      0.075
    ],
    [
      "douter",
      0.075
    ]
  ],
  "apparence": [
    [
      "aspect",
      0.0775
    ],
    [
      "exterieur",
      0.075
    ],
    [
      "tournure",
      0.0625
    ],
    [
      "air",
      0.055
    ],
    [
      "figure",
      0.055
    ],
    [
      "visage",
      0.0425
    ],
    [
      "dehors",
      0.0275
    ],
    [
      "semblant",
      0.0275
    ],
    [
      "facade",
      0.0275
    ],
    [
      "mine",
      0.025
    ],
    [
      "allure",
      0.0225
    ],
    [
      "physionomie",
      0.0225
    ],
    [
      "vernis",
      0.0225
    ],
    [
      "face",
      0.02
    ],
    [
      "image",
      0.02
    ],
    [
      "masque",
      0.02
    ],
    [
      "semblance",
      0.02
    ],
    [
      "simulacre",
      0.0175
    ],
    [
      "ombre",
      0.0175
    ],
    [
      "caractere",
      0.0175
    ],
    [
      "forme",
      0.0175
    ],
    [
      "type",
      0.015
    ],
    [
      "teinte",
      0.0125
    ],
    [
      "genre",
      0.0125
    ],
    [
      "couleur",
      0.01
    ],
    [
      "trait",
      0.01
    ],
    [
      "touche",
      0.0075
    ],
    [
      "surface",
      0.0075
    ],
    [
      "imitation",
      0.0075
    ],
    [
      "idee",
      0.0075
    ],
    [
      "facies",
      0.0075
    ],
    [
      "affectation",
      0.0075
    ],
    [
      "singerie",
      0.005
    ],
    [
      "ressemblance",
      0.005
    ],
    [
      "pretexte",
      0.005
    ],
    [
      "front",
      0.005
    ],
    [
      "endroit",
      0.005
    ],
    [
      "brillant",
      0.005
    ],
    [
      "eclat",
      0.005
    ],
    [
      "vue",
      0.005
    ],
    [
      "superficie",
      0.005
    ],
    [
      "soupcon",
      0.005
    ],
    [
      "convenance",
      0.005
    ],
    [
      "ecorce",
      0.0025
    ],
    [
      "voile",
      0.0025
    ],
    [
      "symbole",
      0.0025
    ],
    [
      "phenomene",
      0.0025
    ],
    [
      "montre",
      0.0025
    ],
    [
      "mirage",
      0.0025
    ],
    [
      "jour",
      0.0025
    ],
    [
      "fantome",
      0.0025
    ],
    [
      "carnation",
      0.0025
    ],
    [
      "cachet",
      0.0025
    ],
    [
      "appareil",
      0.0025
    ],
    [
      "abord",
      0.0025
    ],
    [
      "probabilite",
      0.0
    ],
    [
      "pronostic",
      0.0
    ],
    [
      "rayon",
      0.0
    ],
    [
      "vestige",
      0.0
    ],
    [
      "visibilite",
      0.0
    ],
    [
      "vraisemblance",
      0.0
    ],
    [
      "plausibilite",
      0.0
    ],
    [
      "phase",
      0.0
    ],
    [
      "paraitre",
      0.0
    ],
    [
      "ostentation",
      0.0
    ],
    [
      "look",
      0.0
    ],
    [
      "livree",
      0.0
    ],
    [
      "habit",
      0.0
    ],
    [
      "decor",
      0.0
    ],
    [
      "bouille",
      0.0
    ],
    [
      "bienseance",
      0.0
    ],
    [
      "epiderme",
      0.0
    ]
  ],
  "internet": [],
  "etranger": [
    [
      "impenetrable",
      0.0625
    ],
    [
      "eloigne",
      0.0475
    ],
    [
      "insensible",
      0.0475
    ],
    [
      "inconnu",
      0.0475
    ],
    [
      "inaccessible",
      0.0475
    ],
    [
      "different",
      0.0475
    ],
    [
      "ecarte",
      0.03
    ],
    [
      "refractaire",
      0.03
    ],
    [
      "perdu",
      0.03
    ],
    [
      "isole",
      0.03
    ],
    [
      "indifferent",
      0.03
    ],
    [
      "impermeable",
      0.03
    ],
    [
      "heterogene",
      0.03
    ],
    [
      "detache",
      0.03
    ],
    [
      "dissemblable",
      0.03
    ],
    [
      "allogene",
      0.03
    ],
    [
      "rasta",
      0.0125
    ],
    [
      "peregrin",
      0.0125
    ],
    [
      "profane",
      0.0125
    ],
    [
      "meteque",
      0.0125
    ],
    [
      "lointain",
      0.0125
    ],
    [
      "rastaquouere",
      0.0125
    ],
    [
      "refugie",
      0.0125
    ],
    [
      "resident",
      0.0125
    ],
    [
      "tiers",
      0.0125
    ],
    [
      "touriste",
      0.0125
    ],
    [
      "voyageur",
      0.0125
    ],
    [
      "etrange",
      0.0125
    ],
    [
      "immigre",
      0.0125
    ],
    [
      "immigrant",
      0.0125
    ],
    [
      "aubain",
      0.0125
    ],
    [
      "autre",
      0.0125
    ],
    [
      "distinct",
      0.0125
    ],
    [
      "exotique",
      0.0125
    ],
    [
      "extrinseque",
      0.0125
    ],
    [
      "exterieur",
      0.0125
    ],
    [
      "ferme",
      0.0125
    ],
    [
      "heimatlos",
      0.0125
    ],
    [
      "ignorant",
      0.0125
    ],
    [
      "ignore",
      0.0125
    ],
    [
      "allochtone",
      0.0125
    ]
  ],
  "raciste": [
    [
      "totalitaire",
      0.5
    ],
    [
      "xenophobe",
      0.5
    ]
  ],
  "moitie": [
    [
      "demi",
      0.1675
    ],
    [
      "epouse",
      0.0825
    ],
    [
      "semi",
      0.0825
    ],
    [
      "partie",
      0.0825
    ],
    [
      "milieu",
      0.0825
    ],
    [
      "femme",
      0.0825
    ],
    [
      "deux",
      0.0825
    ],
    [
      "demie",
      0.0825
    ],
    [
      "bourgeois",
      0.0825
    ],
    [
      "epoux",
      0.0825
    ]
  ],
  "globe": [
    [
      "sphere",
      0.16
    ],
    [
      "monde",
      0.1175
    ],
    [
      "terre",
      0.1175
    ],
    [
      "univers",
      0.1175
    ],
    [
      "rond",
      0.0775
    ],
    [
      "planete",
      0.0775
    ],
    [
      "boule",
      0.0775
    ],
    [
      "astre",
      0.0375
    ],
    [
      "globule",
      0.0375
    ],
    [
      "mappemonde",
      0.0375
    ],
    [
      "orbe",
      0.0375
    ]
  ],
  "ras": [
    [
      "denude",
      0.11
    ],
    [
      "nu",
      0.11
    ],
    [
      "pele",
      0.11
    ],
    [
      "tondu",
      0.055
    ],
    [
      "rez",
      0.055
    ],
    [
      "rempli",
      0.055
    ],
    [
      "rase",
      0.055
    ],
    [
      "rasant",
      0.055
    ],
    [
      "radeau",
      0.055
    ],
    [
      "plein",
      0.055
    ],
    [
      "plat",
      0.055
    ],
    [
      "court",
      0.055
    ],
    [
      "cap",
      0.055
    ],
    [
      "aride",
      0.055
    ],
    [
      "egal",
      0.055
    ]
  ],
  "quinte": [
    [
      "acces",
      0.22
    ],
    [
      "caprice",
      0.22
    ],
    [
      "toquade",
      0.22
    ],
    [
      "crise",
      0.11
    ],
    [
      "fantaisie",
      0.11
    ],
    [
      "humeur",
      0.11
    ]
  ],
  "ordre": [
    [
      "organisation",
      0.055
    ],
    [
      "disposition",
      0.0425
    ],
    [
      "arrangement",
      0.035
    ],
    [
      "agencement",
      0.03
    ],
    [
      "ordonnance",
      0.03
    ],
    [
      "distribution",
      0.025
    ],
    [
      "combinaison",
      0.025
    ],
    [
      "discipline",
      0.0175
    ],
    [
      "division",
      0.0175
    ],
    [
      "hierarchie",
      0.0175
    ],
    [
      "sorte",
      0.0175
    ],
    [
      "reglement",
      0.0175
    ],
    [
      "regle",
      0.0175
    ],
    [
      "instruction",
      0.0175
    ],
    [
      "harmonie",
      0.0175
    ],
    [
      "classe",
      0.0175
    ],
    [
      "type",
      0.0125
    ],
    [
      "structure",
      0.0125
    ],
    [
      "rang",
      0.0125
    ],
    [
      "prescription",
      0.0125
    ],
    [
      "methode",
      0.0125
    ],
    [
      "ligne",
      0.0125
    ],
    [
      "commandement",
      0.0125
    ],
    [
      "classement",
      0.0125
    ],
    [
      "categorie",
      0.0125
    ],
    [
      "systeme",
      0.01
    ],
    [
      "plan",
      0.01
    ],
    [
      "genre",
      0.01
    ],
    [
      "composition",
      0.01
    ],
    [
      "association",
      0.01
    ],
    [
      "equilibre",
      0.01
    ],
    [
      "economie",
      0.01
    ],
    [
      "recommandation",
      0.01
    ],
    [
      "injonction",
      0.01
    ],
    [
      "direction",
      0.01
    ],
    [
      "nature",
      0.0075
    ],
    [
      "norme",
      0.0075
    ],
    [
      "qualite",
      0.0075
    ],
    [
      "repartition",
      0.0075
    ],
    [
      "sommation",
      0.0075
    ],
    [
      "succession",
      0.0075
    ],
    [
      "mandement",
      0.0075
    ],
    [
      "groupe",
      0.0075
    ],
    [
      "espece",
      0.0075
    ],
    [
      "assemblage",
      0.0075
    ],
    [
      "avis",
      0.0075
    ],
    [
      "classification",
      0.0075
    ],
    [
      "consigne",
      0.0075
    ],
    [
      "coordination",
      0.0075
    ],
    [
      "demande",
      0.0075
    ],
    [
      "place",
      0.005
    ],
    [
      "police",
      0.005
    ],
    [
      "rangement",
      0.005
    ],
    [
      "relation",
      0.005
    ],
    [
      "soin",
      0.005
    ],
    [
      "tenue",
      0.005
    ],
    [
      "tranquillite",
      0.005
    ],
    [
      "ultimatum",
      0.005
    ],
    [
      "paix",
      0.005
    ],
    [
      "niveau",
      0.005
    ],
    [
      "amenagement",
      0.005
    ],
    [
      "charge",
      0.005
    ],
    [
      "communaute",
      0.005
    ],
    [
      "directive",
      0.005
    ],
    [
      "domaine",
      0.005
    ],
    [
      "enchainement",
      0.005
    ],
    [
      "exigence",
      0.005
    ],
    [
      "formation",
      0.005
    ],
    [
      "note",
      0.0025
    ],
    [
      "oukase",
      0.0025
    ],
    [
      "pretrise",
      0.0025
    ],
    [
      "sacerdoce",
      0.0025
    ],
    [
      "subordination",
      0.0025
    ],
    [
      "securite",
      0.0025
    ],
    [
      "logique",
      0.0025
    ],
    [
      "filiation",
      0.0025
    ],
    [
      "alignement",
      0.0025
    ],
    [
      "calme",
      0.0025
    ],
    [
      "caste",
      0.0025
    ],
    [
      "chronologie",
      0.0025
    ],
    [
      "commande",
      0.0025
    ],
    [
      "decret",
      0.0025
    ],
    [
      "nettete",
      0.0
    ],
    [
      "ordonnancement",
      0.0
    ],
    [
      "semonce",
      0.0
    ],
    [
      "sphere",
      0.0
    ],
    [
      "style",
      0.0
    ],
    [
      "successivite",
      0.0
    ],
    [
      "suite",
      0.0
    ],
    [
      "symetrie",
      0.0
    ],
    [
      "morale",
      0.0
    ],
    [
      "minutie",
      0.0
    ],
    [
      "invite",
      0.0
    ],
    [
      "bulletin",
      0.0
    ],
    [
      "benediction",
      0.0
    ],
    [
      "clerge",
      0.0
    ],
    [
      "congregation",
      0.0
    ],
    [
      "corporation",
      0.0
    ],
    [
      "corps",
      0.0
    ],
    [
      "eurythmie",
      0.0
    ],
    [
      "gradation",
      0.0
    ],
    [
      "surete",
      0.0
    ]
  ],
  "generation": [
    [
      "origine",
      0.075
    ],
    [
      "creation",
      0.0625
    ],
    [
      "race",
      0.0625
    ],
    [
      "reproduction",
      0.05
    ],
    [
      "procreation",
      0.05
    ],
    [
      "genese",
      0.05
    ],
    [
      "formation",
      0.05
    ],
    [
      "famille",
      0.05
    ],
    [
      "vie",
      0.0375
    ],
    [
      "production",
      0.0375
    ],
    [
      "fecondation",
      0.0375
    ],
    [
      "filiation",
      0.0375
    ],
    [
      "descendance",
      0.0375
    ],
    [
      "conception",
      0.0375
    ],
    [
      "elaboration",
      0.025
    ],
    [
      "naissance",
      0.025
    ],
    [
      "maternite",
      0.025
    ],
    [
      "engendrement",
      0.025
    ],
    [
      "ascendance",
      0.025
    ],
    [
      "accouplement",
      0.025
    ],
    [
      "theogonie",
      0.0125
    ],
    [
      "temps",
      0.0125
    ],
    [
      "sporulation",
      0.0125
    ],
    [
      "souche",
      0.0125
    ],
    [
      "scissiparite",
      0.0125
    ],
    [
      "progeniture",
      0.0125
    ],
    [
      "posterite",
      0.0125
    ],
    [
      "parthenogenese",
      0.0125
    ],
    [
      "multiplication",
      0.0125
    ],
    [
      "monogenie",
      0.0125
    ],
    [
      "gestation",
      0.0125
    ],
    [
      "gemmiparite",
      0.0125
    ],
    [
      "copulation",
      0.0125
    ],
    [
      "age",
      0.0125
    ]
  ],
  "baba": [
    [
      "stupefait",
      0.115
    ],
    [
      "etonne",
      0.115
    ],
    [
      "sidere",
      0.095
    ],
    [
      "ebahi",
      0.095
    ],
    [
      "meduse",
      0.075
    ],
    [
      "surpris",
      0.075
    ],
    [
      "estomaque",
      0.0575
    ],
    [
      "interloque",
      0.0575
    ],
    [
      "patisserie",
      0.0375
    ],
    [
      "ahuri",
      0.0375
    ],
    [
      "abasourdi",
      0.0375
    ],
    [
      "souffle",
      0.0175
    ],
    [
      "savarin",
      0.0175
    ],
    [
      "posterieur",
      0.0175
    ],
    [
      "marquise",
      0.0175
    ],
    [
      "hippie",
      0.0175
    ],
    [
      "fessier",
      0.0175
    ],
    [
      "fesse",
      0.0175
    ],
    [
      "cul",
      0.0175
    ],
    [
      "beatnik",
      0.0175
    ],
    [
      "epate",
      0.0175
    ]
  ],
  "planete": [
    [
      "astre",
      0.3325
    ],
    [
      "globe",
      0.22
    ],
    [
      "monde",
      0.11
    ],
    [
      "satellite",
      0.11
    ],
    [
      "univers",
      0.11
    ],
    [
      "etoile",
      0.11
    ]
  ],
  "eveiller": [
    [
      "exciter",
      0.2025
    ],
    [
      "soulever",
      0.07
    ],
    [
      "reveiller",
      0.0575
    ],
    [
      "stimuler",
      0.0575
    ],
    [
      "susciter",
      0.0575
    ],
    [
      "evoquer",
      0.0425
    ],
    [
      "tirer",
      0.0425
    ],
    [
      "provoquer",
      0.0425
    ],
    [
      "piquer",
      0.0425
    ],
    [
      "aviver",
      0.0425
    ],
    [
      "animer",
      0.0425
    ],
    [
      "aiguillonner",
      0.0425
    ],
    [
      "reveler",
      0.0275
    ],
    [
      "ouvrir",
      0.0275
    ],
    [
      "fouetter",
      0.0275
    ],
    [
      "fomenter",
      0.0275
    ],
    [
      "developper",
      0.0275
    ],
    [
      "attirer",
      0.0275
    ],
    [
      "alarmer",
      0.0125
    ],
    [
      "declencher",
      0.0125
    ],
    [
      "s'attirer",
      0.0125
    ]
  ],
  "merveille": [
    [
      "bijou",
      0.1125
    ],
    [
      "perfection",
      0.085
    ],
    [
      "perle",
      0.085
    ],
    [
      "prodige",
      0.085
    ],
    [
      "emerveillement",
      0.055
    ],
    [
      "splendeur",
      0.055
    ],
    [
      "phenomene",
      0.055
    ],
    [
      "phenix",
      0.055
    ],
    [
      "feerie",
      0.055
    ],
    [
      "bijouterie",
      0.055
    ],
    [
      "patisserie",
      0.0275
    ],
    [
      "miracle",
      0.0275
    ],
    [
      "merveilleux",
      0.0275
    ],
    [
      "joyau",
      0.0275
    ],
    [
      "enchantement",
      0.0275
    ],
    [
      "beignet",
      0.0275
    ],
    [
      "sensation",
      0.0275
    ]
  ],
  "franchir": [
    [
      "passer",
      0.15
    ],
    [
      "depasser",
      0.13
    ],
    [
      "monter",
      0.065
    ],
    [
      "outrepasser",
      0.065
    ],
    [
      "violer",
      0.0425
    ],
    [
      "vaincre",
      0.0425
    ],
    [
      "traverser",
      0.0425
    ],
    [
      "transgresser",
      0.0425
    ],
    [
      "surmonter",
      0.0425
    ],
    [
      "parcourir",
      0.0425
    ],
    [
      "escalader",
      0.0425
    ],
    [
      "enjamber",
      0.0425
    ],
    [
      "doubler",
      0.0425
    ],
    [
      "couvrir",
      0.0425
    ],
    [
      "sauter",
      0.02
    ],
    [
      "gravir",
      0.02
    ],
    [
      "exagerer",
      0.02
    ],
    [
      "deborder",
      0.02
    ],
    [
      "affranchir",
      0.02
    ],
    [
      "triompher",
      0.02
    ]
  ],
  "heritage": [
    [
      "succession",
      0.2725
    ],
    [
      "heredite",
      0.09
    ],
    [
      "legs",
      0.09
    ],
    [
      "patrimoine",
      0.09
    ],
    [
      "testament",
      0.045
    ],
    [
      "substitution",
      0.045
    ],
    [
      "propriete",
      0.045
    ],
    [
      "mortaille",
      0.045
    ],
    [
      "hoirie",
      0.045
    ],
    [
      "douaire",
      0.045
    ],
    [
      "domaine",
      0.045
    ],
    [
      "bien",
      0.045
    ],
    [
      "atavisme",
      0.045
    ],
    [
      "tradition",
      0.045
    ]
  ],
  "cycle": [
    [
      "bicyclette",
      0.12
    ],
    [
      "periode",
      0.09
    ],
    [
      "velo",
      0.09
    ],
    [
      "temps",
      0.0575
    ],
    [
      "repetition",
      0.0275
    ],
    [
      "revolution",
      0.0275
    ],
    [
      "saga",
      0.0275
    ],
    [
      "siecle",
      0.0275
    ],
    [
      "suite",
      0.0275
    ],
    [
      "serie",
      0.0275
    ],
    [
      "tandem",
      0.0275
    ],
    [
      "velocipede",
      0.0275
    ],
    [
      "ere",
      0.0275
    ],
    [
      "regles",
      0.0275
    ],
    [
      "rotation",
      0.0275
    ],
    [
      "ovulation",
      0.0275
    ],
    [
      "an",
      0.0275
    ],
    [
      "boucle",
      0.0275
    ],
    [
      "becane",
      0.0275
    ],
    [
      "cercle",
      0.0275
    ],
    [
      "celerifere",
      0.0275
    ],
    [
      "formation",
      0.0275
    ],
    [
      "menstrues",
      0.0275
    ],
    [
      "menopause",
      0.0275
    ],
    [
      "epoque",
      0.0275
    ]
  ],
  "benir": [
    [
      "consacrer",
      0.0825
    ],
    [
      "venerer",
      0.0525
    ],
    [
      "remercier",
      0.0525
    ],
    [
      "oindre",
      0.0525
    ],
    [
      "louer",
      0.0525
    ],
    [
      "glorifier",
      0.0525
    ],
    [
      "exalter",
      0.0525
    ],
    [
      "encenser",
      0.0525
    ],
    [
      "applaudir",
      0.0525
    ],
    [
      "adorer",
      0.0525
    ],
    [
      "recompenser",
      0.025
    ],
    [
      "sacrer",
      0.025
    ],
    [
      "proteger",
      0.025
    ],
    [
      "louanger",
      0.025
    ],
    [
      "estimer",
      0.025
    ],
    [
      "consoler",
      0.025
    ],
    [
      "baptiser",
      0.025
    ],
    [
      "assister",
      0.025
    ],
    [
      "accorder",
      0.025
    ]
  ],
  "immortel": [
    [
      "imperissable",
      0.11
    ],
    [
      "eternel",
      0.11
    ],
    [
      "immuable",
      0.095
    ],
    [
      "inalterable",
      0.095
    ],
    [
      "indestructible",
      0.095
    ],
    [
      "sempiternel",
      0.055
    ],
    [
      "perpetuel",
      0.04
    ],
    [
      "ineffacable",
      0.04
    ],
    [
      "memorable",
      0.025
    ],
    [
      "invincible",
      0.025
    ],
    [
      "indelebile",
      0.025
    ],
    [
      "indefectible",
      0.025
    ],
    [
      "imprescriptible",
      0.025
    ],
    [
      "illustre",
      0.025
    ],
    [
      "glorieux",
      0.025
    ],
    [
      "durable",
      0.025
    ],
    [
      "celebre",
      0.025
    ],
    [
      "legendaire",
      0.0125
    ],
    [
      "invulnerable",
      0.0125
    ],
    [
      "increvable",
      0.0125
    ],
    [
      "incorruptible",
      0.0125
    ],
    [
      "inalienable",
      0.0125
    ],
    [
      "futur",
      0.0125
    ],
    [
      "academicien",
      0.0125
    ]
  ],
  "ronde": [
    [
      "rebondi",
      0.07
    ],
    [
      "cercle",
      0.0475
    ],
    [
      "gras",
      0.0475
    ],
    [
      "gros",
      0.0475
    ],
    [
      "dodu",
      0.04
    ],
    [
      "rondelet",
      0.035
    ],
    [
      "replet",
      0.035
    ],
    [
      "potele",
      0.035
    ],
    [
      "plein",
      0.035
    ],
    [
      "franc",
      0.035
    ],
    [
      "simple",
      0.0275
    ],
    [
      "orbe",
      0.0275
    ],
    [
      "courbe",
      0.0275
    ],
    [
      "charnu",
      0.0275
    ],
    [
      "arrondi",
      0.0275
    ],
    [
      "sphere",
      0.02
    ],
    [
      "sou",
      0.02
    ],
    [
      "renfle",
      0.02
    ],
    [
      "poupard",
      0.02
    ],
    [
      "grassouillet",
      0.02
    ],
    [
      "boulot",
      0.02
    ],
    [
      "vrai",
      0.0125
    ],
    [
      "sincere",
      0.0125
    ],
    [
      "rondouillard",
      0.0125
    ],
    [
      "rondelle",
      0.0125
    ],
    [
      "radis",
      0.0125
    ],
    [
      "mafflu",
      0.0125
    ],
    [
      "globe",
      0.0125
    ],
    [
      "court",
      0.0125
    ],
    [
      "circonference",
      0.0125
    ],
    [
      "boule",
      0.0125
    ],
    [
      "balle",
      0.0125
    ],
    [
      "ring",
      0.005
    ],
    [
      "orbite",
      0.005
    ],
    [
      "orbiculaire",
      0.005
    ],
    [
      "onde",
      0.005
    ],
    [
      "rotin",
      0.005
    ],
    [
      "soul",
      0.005
    ],
    [
      "spherique",
      0.005
    ],
    [
      "spheroide",
      0.005
    ],
    [
      "tranche",
      0.005
    ],
    [
      "ventripotent",
      0.005
    ],
    [
      "loyal",
      0.005
    ],
    [
      "ivre",
      0.005
    ],
    [
      "disque",
      0.005
    ],
    [
      "anneau",
      0.005
    ],
    [
      "centime",
      0.005
    ],
    [
      "cerceau",
      0.005
    ],
    [
      "cerne",
      0.005
    ],
    [
      "circulaire",
      0.005
    ],
    [
      "cordial",
      0.005
    ],
    [
      "cylindre",
      0.005
    ],
    [
      "cylindrique",
      0.005
    ],
    [
      "denier",
      0.005
    ],
    [
      "direct",
      0.005
    ],
    [
      "voute",
      0.005
    ]
  ],
  "regretter": [
    [
      "pleurer",
      0.19
    ],
    [
      "plaindre",
      0.1425
    ],
    [
      "marchander",
      0.095
    ],
    [
      "s'excuser",
      0.0475
    ],
    [
      "geindre",
      0.0475
    ],
    [
      "desapprouver",
      0.0475
    ],
    [
      "deplorer",
      0.0475
    ],
    [
      "craindre",
      0.0475
    ],
    [
      "economiser",
      0.0475
    ]
  ],
  "egal": [
    [
      "semblable",
      0.0825
    ],
    [
      "pareil",
      0.06
    ],
    [
      "regulier",
      0.05
    ],
    [
      "equivalent",
      0.04
    ],
    [
      "uniforme",
      0.04
    ],
    [
      "uni",
      0.04
    ],
    [
      "similaire",
      0.04
    ],
    [
      "plat",
      0.04
    ],
    [
      "identique",
      0.04
    ],
    [
      "confrere",
      0.04
    ],
    [
      "tranquille",
      0.03
    ],
    [
      "meme",
      0.03
    ],
    [
      "constant",
      0.03
    ],
    [
      "compagnon",
      0.03
    ],
    [
      "emule",
      0.02
    ],
    [
      "pair",
      0.02
    ],
    [
      "monotone",
      0.02
    ],
    [
      "jumeau",
      0.02
    ],
    [
      "impartial",
      0.02
    ],
    [
      "frere",
      0.02
    ],
    [
      "fidele",
      0.02
    ],
    [
      "droit",
      0.02
    ],
    [
      "conforme",
      0.02
    ],
    [
      "comparable",
      0.02
    ],
    [
      "camarade",
      0.02
    ],
    [
      "plan",
      0.0075
    ],
    [
      "pondere",
      0.0075
    ],
    [
      "ras",
      0.0075
    ],
    [
      "rival",
      0.0075
    ],
    [
      "egalitaire",
      0.0075
    ],
    [
      "equilibre",
      0.0075
    ],
    [
      "plain",
      0.0075
    ],
    [
      "pendant",
      0.0075
    ],
    [
      "paisible",
      0.0075
    ],
    [
      "lisse",
      0.0075
    ],
    [
      "invariable",
      0.0075
    ],
    [
      "indifferent",
      0.0075
    ],
    [
      "collegue",
      0.0075
    ],
    [
      "citoyen",
      0.0075
    ],
    [
      "approchant",
      0.0075
    ],
    [
      "equitable",
      0.0075
    ]
  ],
  "balayer": [
    [
      "chasser",
      0.0675
    ],
    [
      "aneantir",
      0.0575
    ],
    [
      "nettoyer",
      0.0575
    ],
    [
      "renvoyer",
      0.0575
    ],
    [
      "congedier",
      0.0525
    ],
    [
      "supprimer",
      0.0475
    ],
    [
      "vider",
      0.04
    ],
    [
      "ecarter",
      0.035
    ],
    [
      "remercier",
      0.035
    ],
    [
      "debarrasser",
      0.035
    ],
    [
      "dissiper",
      0.035
    ],
    [
      "balancer",
      0.035
    ],
    [
      "liquider",
      0.03
    ],
    [
      "rejeter",
      0.03
    ],
    [
      "repousser",
      0.025
    ],
    [
      "ruiner",
      0.025
    ],
    [
      "eclaircir",
      0.02
    ],
    [
      "purifier",
      0.02
    ],
    [
      "pousser",
      0.02
    ],
    [
      "abolir",
      0.02
    ],
    [
      "recurer",
      0.015
    ],
    [
      "purger",
      0.015
    ],
    [
      "emporter",
      0.015
    ],
    [
      "degager",
      0.015
    ],
    [
      "ecraser",
      0.0075
    ],
    [
      "refouler",
      0.0075
    ],
    [
      "lessiver",
      0.0075
    ],
    [
      "deblayer",
      0.0075
    ],
    [
      "brosser",
      0.0075
    ],
    [
      "bazarder",
      0.0075
    ],
    [
      "annihiler",
      0.0075
    ],
    [
      "eclairer",
      0.0025
    ],
    [
      "trainer",
      0.0025
    ],
    [
      "souffler",
      0.0025
    ],
    [
      "pulveriser",
      0.0025
    ],
    [
      "frotter",
      0.0025
    ],
    [
      "fouiller",
      0.0025
    ],
    [
      "disperser",
      0.0025
    ],
    [
      "epousseter",
      0.0025
    ]
  ],
  "allume": [
    [
      "exciter",
      0.15
    ],
    [
      "enflammer",
      0.09
    ],
    [
      "animer",
      0.0775
    ],
    [
      "provoquer",
      0.0775
    ],
    [
      "attiser",
      0.065
    ],
    [
      "susciter",
      0.0375
    ],
    [
      "soulever",
      0.03
    ],
    [
      "embraser",
      0.03
    ],
    [
      "dechainer",
      0.03
    ],
    [
      "aiguillonner",
      0.03
    ],
    [
      "emoustiller",
      0.025
    ],
    [
      "inspirer",
      0.025
    ],
    [
      "causer",
      0.025
    ],
    [
      "aviver",
      0.025
    ],
    [
      "aguicher",
      0.025
    ],
    [
      "eperonner",
      0.0175
    ],
    [
      "occasionner",
      0.0175
    ],
    [
      "fouetter",
      0.0175
    ],
    [
      "fomenter",
      0.0175
    ],
    [
      "declencher",
      0.0175
    ],
    [
      "bruler",
      0.0175
    ],
    [
      "illuminer",
      0.0125
    ],
    [
      "exasperer",
      0.0125
    ],
    [
      "agacer",
      0.0125
    ],
    [
      "eclairer",
      0.005
    ],
    [
      "vamper",
      0.005
    ],
    [
      "soutenir",
      0.005
    ],
    [
      "incendier",
      0.005
    ],
    [
      "frotter",
      0.005
    ],
    [
      "fonctionner",
      0.005
    ],
    [
      "commencer",
      0.005
    ],
    [
      "bouter",
      0.005
    ],
    [
      "eprendre",
      0.005
    ]
  ],
  "tremolo": [
    [
      "belement",
      0.3325
    ],
    [
      "tremblement",
      0.3325
    ],
    [
      "vibrato",
      0.3325
    ]
  ],
  "repartir": [
    [
      "recommencer",
      0.2
    ],
    [
      "partir",
      0.1
    ],
    [
      "rebondir",
      0.1
    ],
    [
      "redemarrer",
      0.1
    ],
    [
      "retourner",
      0.1
    ],
    [
      "repondre",
      0.1
    ]
  ],
  "zero": [
    [
      "nul",
      0.305
    ],
    [
      "nullite",
      0.13
    ],
    [
      "vide",
      0.085
    ],
    [
      "neant",
      0.085
    ],
    [
      "inexistant",
      0.085
    ],
    [
      "aucun",
      0.0425
    ],
    [
      "incapable",
      0.0425
    ],
    [
      "nullard",
      0.0425
    ],
    [
      "pantin",
      0.0425
    ],
    [
      "rien",
      0.0425
    ]
  ],
  "talon": [
    [
      "chien",
      0.5
    ],
    [
      "souche",
      0.5
    ]
  ],
  "canon": [
    [
      "bombarde",
      0.055
    ],
    [
      "modele",
      0.055
    ],
    [
      "verre",
      0.04
    ],
    [
      "reglement",
      0.04
    ],
    [
      "regle",
      0.04
    ],
    [
      "type",
      0.0275
    ],
    [
      "obusier",
      0.0275
    ],
    [
      "norme",
      0.0275
    ],
    [
      "mortier",
      0.0275
    ],
    [
      "loi",
      0.0275
    ],
    [
      "ideal",
      0.0275
    ],
    [
      "faucon",
      0.0275
    ],
    [
      "couleuvrine",
      0.0275
    ],
    [
      "batterie",
      0.0275
    ],
    [
      "archetype",
      0.0275
    ],
    [
      "moule",
      0.0125
    ],
    [
      "liste",
      0.0125
    ],
    [
      "godet",
      0.0125
    ],
    [
      "fugue",
      0.0125
    ],
    [
      "fauconneau",
      0.0125
    ],
    [
      "pierrier",
      0.0125
    ],
    [
      "piece",
      0.0125
    ],
    [
      "statut",
      0.0125
    ],
    [
      "tableau",
      0.0125
    ],
    [
      "tube",
      0.0125
    ],
    [
      "veuglaire",
      0.0125
    ],
    [
      "emerillon",
      0.0125
    ],
    [
      "exemplaire",
      0.0125
    ],
    [
      "decision",
      0.0125
    ],
    [
      "cylindre",
      0.0125
    ],
    [
      "aspic",
      0.0125
    ],
    [
      "basilic",
      0.0125
    ],
    [
      "bertha",
      0.0125
    ],
    [
      "bible",
      0.0125
    ],
    [
      "bitte",
      0.0125
    ],
    [
      "bollard",
      0.0125
    ],
    [
      "capitulaire",
      0.0125
    ],
    [
      "catalogue",
      0.0125
    ],
    [
      "chopine",
      0.0125
    ],
    [
      "coup",
      0.0125
    ],
    [
      "crapouillot",
      0.0125
    ],
    [
      "artillerie",
      0.0125
    ]
  ],
  "inconnu": [
    [
      "secret",
      0.125
    ],
    [
      "obscur",
      0.095
    ],
    [
      "cache",
      0.0775
    ],
    [
      "ignore",
      0.065
    ],
    [
      "nouveau",
      0.0475
    ],
    [
      "mysterieux",
      0.0475
    ],
    [
      "tenebreux",
      0.0375
    ],
    [
      "etranger",
      0.0275
    ],
    [
      "enigmatique",
      0.0275
    ],
    [
      "voile",
      0.0275
    ],
    [
      "neuf",
      0.0275
    ],
    [
      "inedit",
      0.0275
    ],
    [
      "incertain",
      0.0275
    ],
    [
      "impenetrable",
      0.0275
    ],
    [
      "oublie",
      0.0175
    ],
    [
      "occulte",
      0.0175
    ],
    [
      "insoupconne",
      0.0175
    ],
    [
      "inoui",
      0.0175
    ],
    [
      "inexplore",
      0.0175
    ],
    [
      "incognito",
      0.0175
    ],
    [
      "dissimule",
      0.0175
    ],
    [
      "clandestin",
      0.0175
    ],
    [
      "anonyme",
      0.0175
    ],
    [
      "insu",
      0.0075
    ],
    [
      "irrevele",
      0.0075
    ],
    [
      "mystere",
      0.0075
    ],
    [
      "meconnu",
      0.0075
    ],
    [
      "rare",
      0.0075
    ],
    [
      "innovation",
      0.0075
    ],
    [
      "innomme",
      0.0075
    ],
    [
      "inimagine",
      0.0075
    ],
    [
      "inexperimente",
      0.0075
    ],
    [
      "inexplicable",
      0.0075
    ],
    [
      "indetermine",
      0.0075
    ],
    [
      "inaccessible",
      0.0075
    ],
    [
      "absent",
      0.0075
    ],
    [
      "tiers",
      0.0075
    ]
  ],
  "inoubliable": [
    [
      "memorable",
      0.14
    ],
    [
      "fameux",
      0.1125
    ],
    [
      "celebre",
      0.0825
    ],
    [
      "fabuleux",
      0.0825
    ],
    [
      "illustre",
      0.0825
    ],
    [
      "insigne",
      0.055
    ],
    [
      "glorieux",
      0.055
    ],
    [
      "retentissant",
      0.025
    ],
    [
      "perpetue",
      0.025
    ],
    [
      "marque",
      0.025
    ],
    [
      "introuvable",
      0.025
    ],
    [
      "ineffacable",
      0.025
    ],
    [
      "inarrachable",
      0.025
    ],
    [
      "imprime",
      0.025
    ],
    [
      "immortalise",
      0.025
    ],
    [
      "homerique",
      0.025
    ],
    [
      "historique",
      0.025
    ],
    [
      "grave",
      0.025
    ],
    [
      "grandiose",
      0.025
    ],
    [
      "frappant",
      0.025
    ],
    [
      "saillant",
      0.025
    ]
  ],
  "chaussures": [
    [
      "soulier",
      0.245
    ],
    [
      "botte",
      0.05
    ],
    [
      "bottine",
      0.05
    ],
    [
      "brodequin",
      0.05
    ],
    [
      "godillot",
      0.05
    ],
    [
      "bottillon",
      0.04
    ],
    [
      "pantoufle",
      0.0275
    ],
    [
      "chausson",
      0.0275
    ],
    [
      "socque",
      0.02
    ],
    [
      "sabot",
      0.02
    ],
    [
      "peniche",
      0.02
    ],
    [
      "patin",
      0.02
    ],
    [
      "godasse",
      0.02
    ],
    [
      "galoche",
      0.02
    ],
    [
      "croquenot",
      0.02
    ],
    [
      "babouche",
      0.02
    ],
    [
      "richelieu",
      0.0075
    ],
    [
      "ribouis",
      0.0075
    ],
    [
      "pompe",
      0.0075
    ],
    [
      "pataugas",
      0.0075
    ],
    [
      "sandale",
      0.0075
    ],
    [
      "savate",
      0.0075
    ],
    [
      "sorlot",
      0.0075
    ],
    [
      "spartiate",
      0.0075
    ],
    [
      "tatane",
      0.0075
    ],
    [
      "tennis",
      0.0075
    ],
    [
      "mule",
      0.0075
    ],
    [
      "mocassin",
      0.0075
    ],
    [
      "grolle",
      0.0075
    ],
    [
      "ballerine",
      0.0075
    ],
    [
      "bas",
      0.0075
    ],
    [
      "basket",
      0.0075
    ],
    [
      "bateau",
      0.0075
    ],
    [
      "boots",
      0.0075
    ],
    [
      "caoutchouc",
      0.0075
    ],
    [
      "charentaise",
      0.0075
    ],
    [
      "chaussette",
      0.0075
    ],
    [
      "cothurne",
      0.0075
    ],
    [
      "escarpin",
      0.0075
    ],
    [
      "espadrille",
      0.0075
    ]
  ],
  "sortie": [
    [
      "issue",
      0.0475
    ],
    [
      "reprimande",
      0.0475
    ],
    [
      "scene",
      0.0475
    ],
    [
      "echappee",
      0.0375
    ],
    [
      "tour",
      0.0375
    ],
    [
      "reproche",
      0.0375
    ],
    [
      "promenade",
      0.0375
    ],
    [
      "algarade",
      0.0375
    ],
    [
      "evacuation",
      0.03
    ],
    [
      "ecoulement",
      0.03
    ],
    [
      "seance",
      0.03
    ],
    [
      "semonce",
      0.03
    ],
    [
      "ouverture",
      0.03
    ],
    [
      "escapade",
      0.03
    ],
    [
      "engueulade",
      0.03
    ],
    [
      "evasion",
      0.0175
    ],
    [
      "echappement",
      0.0175
    ],
    [
      "echappatoire",
      0.0175
    ],
    [
      "porte",
      0.0175
    ],
    [
      "fin",
      0.0175
    ],
    [
      "degagement",
      0.0175
    ],
    [
      "debouche",
      0.0175
    ],
    [
      "dispute",
      0.0175
    ],
    [
      "avanie",
      0.0175
    ],
    [
      "admonestation",
      0.0175
    ],
    [
      "revenue",
      0.0075
    ],
    [
      "remarque",
      0.0075
    ],
    [
      "queue",
      0.0075
    ],
    [
      "publication",
      0.0075
    ],
    [
      "recrimination",
      0.0075
    ],
    [
      "viree",
      0.0075
    ],
    [
      "vomitoire",
      0.0075
    ],
    [
      "eclosion",
      0.0075
    ],
    [
      "emergence",
      0.0075
    ],
    [
      "equipee",
      0.0075
    ],
    [
      "eruption",
      0.0075
    ],
    [
      "output",
      0.0075
    ],
    [
      "observation",
      0.0075
    ],
    [
      "mechancete",
      0.0075
    ],
    [
      "balade",
      0.0075
    ],
    [
      "bretelle",
      0.0075
    ],
    [
      "catilinaire",
      0.0075
    ],
    [
      "compliment",
      0.0075
    ],
    [
      "credit",
      0.0075
    ],
    [
      "debit",
      0.0075
    ],
    [
      "depart",
      0.0075
    ],
    [
      "depense",
      0.0075
    ],
    [
      "incartade",
      0.0075
    ],
    [
      "invective",
      0.0075
    ],
    [
      "mercuriale",
      0.0075
    ],
    [
      "attaque",
      0.0075
    ]
  ],
  "debut": [
    [
      "commencement",
      0.235
    ],
    [
      "seuil",
      0.145
    ],
    [
      "origine",
      0.0625
    ],
    [
      "aurore",
      0.0425
    ],
    [
      "naissance",
      0.0375
    ],
    [
      "principe",
      0.03
    ],
    [
      "entree",
      0.03
    ],
    [
      "depart",
      0.03
    ],
    [
      "ebauche",
      0.0225
    ],
    [
      "premices",
      0.0225
    ],
    [
      "preambule",
      0.0225
    ],
    [
      "introduction",
      0.0225
    ],
    [
      "balbutiement",
      0.0225
    ],
    [
      "amorce",
      0.0225
    ],
    [
      "berceau",
      0.0175
    ],
    [
      "aube",
      0.0175
    ],
    [
      "arrivee",
      0.0175
    ],
    [
      "elements",
      0.01
    ],
    [
      "ouverture",
      0.01
    ],
    [
      "inauguration",
      0.01
    ],
    [
      "exorde",
      0.01
    ],
    [
      "essai",
      0.01
    ],
    [
      "enfance",
      0.01
    ],
    [
      "begaiement",
      0.01
    ],
    [
      "apprentissage",
      0.01
    ],
    [
      "abc",
      0.01
    ],
    [
      "tete",
      0.005
    ],
    [
      "premisse",
      0.005
    ],
    [
      "premier",
      0.005
    ],
    [
      "point",
      0.005
    ],
    [
      "limite",
      0.005
    ],
    [
      "bapteme",
      0.005
    ],
    [
      "attaque",
      0.005
    ],
    [
      "amont",
      0.005
    ],
    [
      "eclosion",
      0.005
    ]
  ],
  "cartel": [
    [
      "trust",
      0.145
    ],
    [
      "association",
      0.1025
    ],
    [
      "coalition",
      0.0725
    ],
    [
      "consortium",
      0.0725
    ],
    [
      "societe",
      0.0725
    ],
    [
      "entente",
      0.0575
    ],
    [
      "concentration",
      0.0425
    ],
    [
      "federation",
      0.0425
    ],
    [
      "comptoir",
      0.0275
    ],
    [
      "carte",
      0.0275
    ],
    [
      "bloc",
      0.0275
    ],
    [
      "billet",
      0.0275
    ],
    [
      "holding",
      0.0125
    ],
    [
      "horloge",
      0.0125
    ],
    [
      "konzern",
      0.0125
    ],
    [
      "papier",
      0.0125
    ],
    [
      "pendule",
      0.0125
    ],
    [
      "provocation",
      0.0125
    ],
    [
      "regulateur",
      0.0125
    ],
    [
      "feodalite",
      0.0125
    ],
    [
      "front",
      0.0125
    ],
    [
      "encadrement",
      0.0125
    ],
    [
      "defi",
      0.0125
    ],
    [
      "convention",
      0.0125
    ],
    [
      "cartouche",
      0.0125
    ],
    [
      "cartelliste",
      0.0125
    ],
    [
      "cartellisation",
      0.0125
    ],
    [
      "bristol",
      0.0125
    ],
    [
      "appel",
      0.0125
    ],
    [
      "traite",
      0.0125
    ]
  ],
  "val": [
    [
      "ravin",
      0.3325
    ],
    [
      "vallon",
      0.3325
    ],
    [
      "vallee",
      0.3325
    ]
  ],
  "charbon": [
    [
      "combustible",
      0.1775
    ],
    [
      "anthracnose",
      0.05
    ],
    [
      "brandon",
      0.05
    ],
    [
      "briquette",
      0.05
    ],
    [
      "houille",
      0.025
    ],
    [
      "lignite",
      0.025
    ],
    [
      "nielle",
      0.025
    ],
    [
      "noir",
      0.025
    ],
    [
      "noisette",
      0.025
    ],
    [
      "poussier",
      0.025
    ],
    [
      "pustule",
      0.025
    ],
    [
      "rouille",
      0.025
    ],
    [
      "tison",
      0.025
    ],
    [
      "tourbe",
      0.025
    ],
    [
      "gresillon",
      0.025
    ],
    [
      "gaillette",
      0.025
    ],
    [
      "gailletin",
      0.025
    ],
    [
      "agglomere",
      0.025
    ],
    [
      "anthracite",
      0.025
    ],
    [
      "boulet",
      0.025
    ],
    [
      "braise",
      0.025
    ],
    [
      "carie",
      0.025
    ],
    [
      "charbouille",
      0.025
    ],
    [
      "coke",
      0.025
    ],
    [
      "crayon",
      0.025
    ],
    [
      "escarbille",
      0.025
    ],
    [
      "fumeron",
      0.025
    ],
    [
      "fusain",
      0.025
    ],
    [
      "ustilaginisme",
      0.025
    ]
  ],
  "blason": [
    [
      "armoiries",
      0.1425
    ],
    [
      "embleme",
      0.105
    ],
    [
      "ecu",
      0.105
    ],
    [
      "ecusson",
      0.105
    ],
    [
      "poeme",
      0.07
    ],
    [
      "panonceau",
      0.035
    ],
    [
      "pennon",
      0.035
    ],
    [
      "satire",
      0.035
    ],
    [
      "sceau",
      0.035
    ],
    [
      "titre",
      0.035
    ],
    [
      "nom",
      0.035
    ],
    [
      "heraldique",
      0.035
    ],
    [
      "cartouche",
      0.035
    ],
    [
      "banniere",
      0.035
    ],
    [
      "armorial",
      0.035
    ],
    [
      "armes",
      0.035
    ],
    [
      "arme",
      0.035
    ],
    [
      "eloge",
      0.035
    ]
  ],
  "audition": [
    [
      "ouie",
      0.165
    ],
    [
      "emission",
      0.0825
    ],
    [
      "ecoute",
      0.0825
    ],
    [
      "test",
      0.0825
    ],
    [
      "sens",
      0.0825
    ],
    [
      "recital",
      0.0825
    ],
    [
      "oreille",
      0.0825
    ],
    [
      "examen",
      0.0825
    ],
    [
      "essai",
      0.0825
    ],
    [
      "concert",
      0.0825
    ],
    [
      "epreuve",
      0.0825
    ]
  ],
  "chauffeur": [
    [
      "conducteur",
      0.2
    ],
    [
      "routier",
      0.0975
    ],
    [
      "taxi",
      0.0475
    ],
    [
      "serviteur",
      0.0475
    ],
    [
      "pilote",
      0.0475
    ],
    [
      "pelleteur",
      0.0475
    ],
    [
      "mecanicien",
      0.0475
    ],
    [
      "malandrin",
      0.0475
    ],
    [
      "machiniste",
      0.0475
    ],
    [
      "incendiaire",
      0.0475
    ],
    [
      "camionneur",
      0.0475
    ],
    [
      "brigand",
      0.0475
    ],
    [
      "bricolier",
      0.0475
    ],
    [
      "automedon",
      0.0475
    ],
    [
      "automobiliste",
      0.0475
    ],
    [
      "taxite",
      0.0475
    ]
  ],
  "mission": [
    [
      "fonction",
      0.1075
    ],
    [
      "charge",
      0.0825
    ],
    [
      "travail",
      0.0825
    ],
    [
      "tache",
      0.0725
    ],
    [
      "mandat",
      0.06
    ],
    [
      "occupation",
      0.06
    ],
    [
      "vocation",
      0.0475
    ],
    [
      "poste",
      0.0475
    ],
    [
      "besogne",
      0.0475
    ],
    [
      "delegation",
      0.035
    ],
    [
      "office",
      0.035
    ],
    [
      "role",
      0.035
    ],
    [
      "sacerdoce",
      0.035
    ],
    [
      "soin",
      0.0225
    ],
    [
      "oeuvre",
      0.0225
    ],
    [
      "deputation",
      0.0225
    ],
    [
      "commission",
      0.0225
    ],
    [
      "but",
      0.0225
    ],
    [
      "ambassade",
      0.0225
    ],
    [
      "pouvoir",
      0.01
    ],
    [
      "objectif",
      0.01
    ],
    [
      "legation",
      0.01
    ],
    [
      "destinee",
      0.01
    ],
    [
      "destination",
      0.01
    ],
    [
      "apostolat",
      0.01
    ],
    [
      "action",
      0.01
    ],
    [
      "evangelisation",
      0.01
    ]
  ],
  "chacal": [
    [
      "canide",
      0.1425
    ],
    [
      "charognard",
      0.1425
    ],
    [
      "coyote",
      0.1425
    ],
    [
      "loup",
      0.1425
    ],
    [
      "renard",
      0.1425
    ],
    [
      "tigre",
      0.1425
    ],
    [
      "zouave",
      0.1425
    ]
  ],
  "gestion": [
    [
      "administration",
      0.19
    ],
    [
      "direction",
      0.165
    ],
    [
      "conduite",
      0.1175
    ],
    [
      "gouvernement",
      0.095
    ],
    [
      "economie",
      0.0475
    ],
    [
      "regie",
      0.0475
    ],
    [
      "organisation",
      0.0475
    ],
    [
      "intendance",
      0.0475
    ],
    [
      "tenue",
      0.0225
    ],
    [
      "presidence",
      0.0225
    ],
    [
      "manutention",
      0.0225
    ],
    [
      "maniement",
      0.0225
    ],
    [
      "mandat",
      0.0225
    ],
    [
      "management",
      0.0225
    ],
    [
      "gerance",
      0.0225
    ],
    [
      "gouverne",
      0.0225
    ],
    [
      "autogestion",
      0.0225
    ],
    [
      "economat",
      0.0225
    ]
  ],
  "bail": [
    [
      "louage",
      0.215
    ],
    [
      "contrat",
      0.1425
    ],
    [
      "fermage",
      0.1425
    ],
    [
      "metayage",
      0.07
    ],
    [
      "loyer",
      0.07
    ],
    [
      "location",
      0.07
    ],
    [
      "engagement",
      0.07
    ],
    [
      "convention",
      0.07
    ],
    [
      "commandite",
      0.07
    ],
    [
      "viager",
      0.07
    ]
  ],
  "aie": [
    [
      "prendre",
      0.0725
    ],
    [
      "tromper",
      0.0675
    ],
    [
      "posseder",
      0.0575
    ],
    [
      "attraper",
      0.0475
    ],
    [
      "rouler",
      0.0475
    ],
    [
      "tenir",
      0.045
    ],
    [
      "obtenir",
      0.03
    ],
    [
      "conquerir",
      0.03
    ],
    [
      "berner",
      0.03
    ],
    [
      "duper",
      0.0275
    ],
    [
      "seduire",
      0.0275
    ],
    [
      "remporter",
      0.0225
    ],
    [
      "occuper",
      0.0225
    ],
    [
      "faire",
      0.0225
    ],
    [
      "disposer",
      0.0225
    ],
    [
      "acquerir",
      0.02
    ],
    [
      "contenir",
      0.02
    ],
    [
      "empaumer",
      0.02
    ],
    [
      "refaire",
      0.02
    ],
    [
      "vaincre",
      0.015
    ],
    [
      "recevoir",
      0.015
    ],
    [
      "presenter",
      0.015
    ],
    [
      "enjoler",
      0.015
    ],
    [
      "detenir",
      0.015
    ],
    [
      "baiser",
      0.015
    ],
    [
      "triompher",
      0.01
    ],
    [
      "tomber",
      0.01
    ],
    [
      "porter",
      0.01
    ],
    [
      "pigeonner",
      0.01
    ],
    [
      "mener",
      0.01
    ],
    [
      "acheter",
      0.01
    ],
    [
      "offrir",
      0.0075
    ],
    [
      "l'emporter",
      0.0075
    ],
    [
      "jouir",
      0.0075
    ],
    [
      "entuber",
      0.0075
    ],
    [
      "empiler",
      0.0075
    ],
    [
      "battre",
      0.0075
    ],
    [
      "recueillir",
      0.0025
    ],
    [
      "ressembler",
      0.0025
    ],
    [
      "ressentir",
      0.0025
    ],
    [
      "rester",
      0.0025
    ],
    [
      "trouver",
      0.0025
    ],
    [
      "tuer",
      0.0025
    ],
    [
      "rappeler",
      0.0025
    ],
    [
      "mesurer",
      0.0025
    ],
    [
      "feinter",
      0.0025
    ],
    [
      "exister",
      0.0025
    ],
    [
      "entourlouper",
      0.0025
    ],
    [
      "emberlificoter",
      0.0025
    ],
    [
      "devoir",
      0.0025
    ],
    [
      "capturer",
      0.0025
    ],
    [
      "beneficier",
      0.0025
    ]
  ],
  "question": [
    [
      "difficulte",
      0.0675
    ],
    [
      "interrogation",
      0.0675
    ],
    [
      "probleme",
      0.0675
    ],
    [
      "sujet",
      0.0675
    ],
    [
      "point",
      0.0475
    ],
    [
      "examen",
      0.0475
    ],
    [
      "discussion",
      0.0475
    ],
    [
      "colle",
      0.0475
    ],
    [
      "affaire",
      0.0475
    ],
    [
      "enigme",
      0.0325
    ],
    [
      "torture",
      0.0325
    ],
    [
      "supplice",
      0.0325
    ],
    [
      "punition",
      0.0325
    ],
    [
      "matiere",
      0.0325
    ],
    [
      "gene",
      0.0325
    ],
    [
      "fait",
      0.0325
    ],
    [
      "chapitre",
      0.0325
    ],
    [
      "hic",
      0.015
    ],
    [
      "information",
      0.015
    ],
    [
      "interpellation",
      0.015
    ],
    [
      "revendication",
      0.015
    ],
    [
      "theme",
      0.015
    ],
    [
      "gehenne",
      0.015
    ],
    [
      "deliberation",
      0.015
    ],
    [
      "devinette",
      0.015
    ],
    [
      "demande",
      0.015
    ],
    [
      "controverse",
      0.015
    ],
    [
      "charade",
      0.015
    ],
    [
      "article",
      0.015
    ],
    [
      "epreuve",
      0.015
    ]
  ],
  "plain": [
    [
      "plan",
      0.2
    ],
    [
      "plat",
      0.2
    ],
    [
      "plein",
      0.2
    ],
    [
      "uni",
      0.2
    ],
    [
      "egal",
      0.2
    ]
  ],
  "armoricain": [
    [
      "breton",
      1.0
    ]
  ],
  "jette": [
    [
      "lancer",
      0.07
    ],
    [
      "pousser",
      0.045
    ],
    [
      "repandre",
      0.04
    ],
    [
      "abandonner",
      0.035
    ],
    [
      "flanquer",
      0.035
    ],
    [
      "rejeter",
      0.0325
    ],
    [
      "balancer",
      0.0325
    ],
    [
      "mettre",
      0.0275
    ],
    [
      "lacher",
      0.0225
    ],
    [
      "ficher",
      0.0225
    ],
    [
      "envoyer",
      0.0225
    ],
    [
      "entrainer",
      0.0225
    ],
    [
      "conduire",
      0.0225
    ],
    [
      "emettre",
      0.02
    ],
    [
      "elever",
      0.02
    ],
    [
      "semer",
      0.02
    ],
    [
      "repousser",
      0.02
    ],
    [
      "dresser",
      0.02
    ],
    [
      "adresser",
      0.02
    ],
    [
      "eparpiller",
      0.015
    ],
    [
      "ejecter",
      0.015
    ],
    [
      "repartir",
      0.015
    ],
    [
      "projeter",
      0.015
    ],
    [
      "poser",
      0.015
    ],
    [
      "larguer",
      0.015
    ],
    [
      "foutre",
      0.015
    ],
    [
      "distribuer",
      0.015
    ],
    [
      "riposter",
      0.01
    ],
    [
      "verser",
      0.01
    ],
    [
      "epandre",
      0.01
    ],
    [
      "precipiter",
      0.01
    ],
    [
      "provoquer",
      0.01
    ],
    [
      "prodiguer",
      0.01
    ],
    [
      "plonger",
      0.01
    ],
    [
      "engager",
      0.01
    ],
    [
      "detruire",
      0.01
    ],
    [
      "bombarder",
      0.01
    ],
    [
      "bazarder",
      0.01
    ],
    [
      "glisser",
      0.0075
    ],
    [
      "liquider",
      0.0075
    ],
    [
      "proferer",
      0.0075
    ],
    [
      "releguer",
      0.0075
    ],
    [
      "eriger",
      0.0075
    ],
    [
      "deverser",
      0.0075
    ],
    [
      "disperser",
      0.0075
    ],
    [
      "catapulter",
      0.0075
    ],
    [
      "communiquer",
      0.0075
    ],
    [
      "construire",
      0.0075
    ],
    [
      "darder",
      0.0075
    ],
    [
      "descendre",
      0.0075
    ],
    [
      "edifier",
      0.0025
    ],
    [
      "retorquer",
      0.0025
    ],
    [
      "parsemer",
      0.0025
    ],
    [
      "insuffler",
      0.0025
    ],
    [
      "insinuer",
      0.0025
    ],
    [
      "imprimer",
      0.0025
    ],
    [
      "drosser",
      0.0025
    ],
    [
      "dispenser",
      0.0025
    ],
    [
      "causer",
      0.0025
    ],
    [
      "balanstiquer",
      0.0025
    ],
    [
      "ejaculer",
      0.0025
    ]
  ],
  "domaine": [
    [
      "sphere",
      0.1025
    ],
    [
      "terre",
      0.055
    ],
    [
      "propriete",
      0.05
    ],
    [
      "champ",
      0.045
    ],
    [
      "terrain",
      0.045
    ],
    [
      "espace",
      0.0375
    ],
    [
      "bien",
      0.0325
    ],
    [
      "pays",
      0.0325
    ],
    [
      "region",
      0.0325
    ],
    [
      "univers",
      0.0275
    ],
    [
      "partie",
      0.0275
    ],
    [
      "ferme",
      0.0275
    ],
    [
      "etendue",
      0.02
    ],
    [
      "specialite",
      0.02
    ],
    [
      "fief",
      0.02
    ],
    [
      "departement",
      0.02
    ],
    [
      "campagne",
      0.02
    ],
    [
      "secteur",
      0.015
    ],
    [
      "royaume",
      0.015
    ],
    [
      "rayon",
      0.015
    ],
    [
      "possession",
      0.015
    ],
    [
      "ordre",
      0.015
    ],
    [
      "matiere",
      0.015
    ],
    [
      "district",
      0.015
    ],
    [
      "cercle",
      0.015
    ],
    [
      "aire",
      0.015
    ],
    [
      "orbite",
      0.01
    ],
    [
      "patrimoine",
      0.01
    ],
    [
      "ressort",
      0.01
    ],
    [
      "succession",
      0.01
    ],
    [
      "surface",
      0.01
    ],
    [
      "monde",
      0.01
    ],
    [
      "exploitation",
      0.01
    ],
    [
      "apanage",
      0.01
    ],
    [
      "attribution",
      0.01
    ],
    [
      "cadre",
      0.01
    ],
    [
      "clos",
      0.01
    ],
    [
      "competence",
      0.01
    ],
    [
      "latifundia",
      0.0025
    ],
    [
      "intervalle",
      0.0025
    ],
    [
      "heritage",
      0.0025
    ],
    [
      "hacienda",
      0.0025
    ],
    [
      "habitation",
      0.0025
    ],
    [
      "genre",
      0.0025
    ],
    [
      "fazenda",
      0.0025
    ],
    [
      "estancia",
      0.0025
    ],
    [
      "enclos",
      0.0025
    ],
    [
      "diagramme",
      0.0025
    ],
    [
      "limite",
      0.0025
    ]
  ],
  "forgeron": [
    [
      "ferronnier",
      0.3325
    ],
    [
      "forgeur",
      0.3325
    ]
  ],
  "druide": [
    [
      "pretre",
      0.5
    ],
    [
      "eubage",
      0.165
    ],
    [
      "ovate",
      0.165
    ],
    [
      "saronide",
      0.165
    ]
  ],
  "vallee": [
    [
      "ravin",
      0.16
    ],
    [
      "defile",
      0.12
    ],
    [
      "bassin",
      0.08
    ],
    [
      "canyon",
      0.08
    ],
    [
      "gorge",
      0.08
    ],
    [
      "porte",
      0.04
    ],
    [
      "ravine",
      0.04
    ],
    [
      "val",
      0.04
    ],
    [
      "valleuse",
      0.04
    ],
    [
      "plaine",
      0.04
    ],
    [
      "goulet",
      0.04
    ],
    [
      "depression",
      0.04
    ],
    [
      "cuvette",
      0.04
    ],
    [
      "combe",
      0.04
    ],
    [
      "cluse",
      0.04
    ],
    [
      "cavee",
      0.04
    ],
    [
      "vallon",
      0.04
    ]
  ],
  "ancetre": [
    [
      "ancien",
      0.1575
    ],
    [
      "pere",
      0.135
    ],
    [
      "aieul",
      0.09
    ],
    [
      "ascendant",
      0.0675
    ],
    [
      "aine",
      0.0675
    ],
    [
      "parent",
      0.0675
    ],
    [
      "vieux",
      0.0675
    ],
    [
      "predecesseur",
      0.045
    ],
    [
      "premier",
      0.045
    ],
    [
      "devancier",
      0.045
    ],
    [
      "auteur",
      0.045
    ],
    [
      "agnat",
      0.0225
    ],
    [
      "aieule",
      0.0225
    ],
    [
      "geniteur",
      0.0225
    ],
    [
      "precurseur",
      0.0225
    ],
    [
      "souche",
      0.0225
    ],
    [
      "totem",
      0.0225
    ],
    [
      "vieillard",
      0.0225
    ]
  ],
  "geant": [
    [
      "titan",
      0.1225
    ],
    [
      "grand",
      0.0925
    ],
    [
      "colossal",
      0.06
    ],
    [
      "enorme",
      0.045
    ],
    [
      "titanesque",
      0.045
    ],
    [
      "gigantesque",
      0.045
    ],
    [
      "surhomme",
      0.03
    ],
    [
      "perche",
      0.03
    ],
    [
      "monstre",
      0.03
    ],
    [
      "mastodonte",
      0.03
    ],
    [
      "immense",
      0.03
    ],
    [
      "heros",
      0.03
    ],
    [
      "hercule",
      0.03
    ],
    [
      "demesure",
      0.03
    ],
    [
      "colosse",
      0.03
    ],
    [
      "baleze",
      0.03
    ],
    [
      "girafe",
      0.0125
    ],
    [
      "goliath",
      0.0125
    ],
    [
      "genie",
      0.0125
    ],
    [
      "malabar",
      0.0125
    ],
    [
      "monopole",
      0.0125
    ],
    [
      "ogre",
      0.0125
    ],
    [
      "trust",
      0.0125
    ],
    [
      "gigue",
      0.0125
    ],
    [
      "gigantal",
      0.0125
    ],
    [
      "champion",
      0.0125
    ],
    [
      "cigogne",
      0.0125
    ],
    [
      "cyclope",
      0.0125
    ],
    [
      "cyclopeen",
      0.0125
    ],
    [
      "escogriffe",
      0.0125
    ],
    [
      "flandrin",
      0.0125
    ],
    [
      "elephant",
      0.0125
    ]
  ],
  "bataille": [
    [
      "combat",
      0.155
    ],
    [
      "lutte",
      0.08
    ],
    [
      "dispute",
      0.0625
    ],
    [
      "querelle",
      0.055
    ],
    [
      "bagarre",
      0.04
    ],
    [
      "affaire",
      0.04
    ],
    [
      "accrochage",
      0.0375
    ],
    [
      "guerre",
      0.0375
    ],
    [
      "rixe",
      0.0375
    ],
    [
      "echauffouree",
      0.0375
    ],
    [
      "choc",
      0.0325
    ],
    [
      "competition",
      0.03
    ],
    [
      "affrontement",
      0.025
    ],
    [
      "duel",
      0.025
    ],
    [
      "melee",
      0.0225
    ],
    [
      "rencontre",
      0.0175
    ],
    [
      "engagement",
      0.0175
    ],
    [
      "discussion",
      0.0175
    ],
    [
      "conflit",
      0.0175
    ],
    [
      "rivalite",
      0.015
    ],
    [
      "offensive",
      0.015
    ],
    [
      "escarmouche",
      0.015
    ],
    [
      "campagne",
      0.015
    ],
    [
      "baroud",
      0.015
    ],
    [
      "action",
      0.015
    ],
    [
      "operation",
      0.01
    ],
    [
      "emulation",
      0.005
    ],
    [
      "grabuge",
      0.005
    ],
    [
      "feu",
      0.005
    ],
    [
      "dada",
      0.005
    ],
    [
      "concurrence",
      0.005
    ],
    [
      "chicane",
      0.005
    ],
    [
      "batterie",
      0.005
    ],
    [
      "marotte",
      0.0025
    ],
    [
      "hobby",
      0.0025
    ],
    [
      "deroute",
      0.0025
    ],
    [
      "defaite",
      0.0025
    ],
    [
      "castagne",
      0.0025
    ],
    [
      "bombardement",
      0.0025
    ],
    [
      "bigorne",
      0.0025
    ],
    [
      "bigornage",
      0.0025
    ],
    [
      "bazar",
      0.0025
    ],
    [
      "baston",
      0.0025
    ],
    [
      "victoire",
      0.0025
    ]
  ],
  "imposer": [
    [
      "donner",
      0.055
    ],
    [
      "charger",
      0.0475
    ],
    [
      "commander",
      0.0475
    ],
    [
      "contraindre",
      0.0475
    ],
    [
      "sommer",
      0.04
    ],
    [
      "prescrire",
      0.04
    ],
    [
      "obliger",
      0.04
    ],
    [
      "impressionner",
      0.04
    ],
    [
      "exiger",
      0.04
    ],
    [
      "assujettir",
      0.04
    ],
    [
      "eblouir",
      0.0325
    ],
    [
      "frapper",
      0.0325
    ],
    [
      "epater",
      0.0275
    ],
    [
      "ordonner",
      0.0275
    ],
    [
      "forcer",
      0.0275
    ],
    [
      "fixer",
      0.0275
    ],
    [
      "condamner",
      0.0275
    ],
    [
      "soumettre",
      0.02
    ],
    [
      "inspirer",
      0.02
    ],
    [
      "imputer",
      0.02
    ],
    [
      "grever",
      0.02
    ],
    [
      "faire",
      0.02
    ],
    [
      "enjoindre",
      0.02
    ],
    [
      "demander",
      0.02
    ],
    [
      "bluffer",
      0.02
    ],
    [
      "astreindre",
      0.02
    ],
    [
      "subjuguer",
      0.0125
    ],
    [
      "mettre",
      0.0125
    ],
    [
      "esbroufer",
      0.0125
    ],
    [
      "dicter",
      0.0125
    ],
    [
      "assigner",
      0.0125
    ],
    [
      "tromper",
      0.005
    ],
    [
      "taxer",
      0.005
    ],
    [
      "surimposer",
      0.005
    ],
    [
      "surcharger",
      0.005
    ],
    [
      "revendiquer",
      0.005
    ],
    [
      "representer",
      0.005
    ],
    [
      "prelever",
      0.005
    ],
    [
      "pressurer",
      0.005
    ],
    [
      "meriter",
      0.005
    ],
    [
      "infliger",
      0.005
    ],
    [
      "impatroniser",
      0.005
    ],
    [
      "accrediter",
      0.005
    ],
    [
      "abuser",
      0.005
    ],
    [
      "edicter",
      0.005
    ]
  ],
  "impose": [
    [
      "donner",
      0.055
    ],
    [
      "charger",
      0.0475
    ],
    [
      "commander",
      0.0475
    ],
    [
      "contraindre",
      0.0475
    ],
    [
      "sommer",
      0.04
    ],
    [
      "prescrire",
      0.04
    ],
    [
      "obliger",
      0.04
    ],
    [
      "impressionner",
      0.04
    ],
    [
      "exiger",
      0.04
    ],
    [
      "assujettir",
      0.04
    ],
    [
      "eblouir",
      0.0325
    ],
    [
      "frapper",
      0.0325
    ],
    [
      "epater",
      0.0275
    ],
    [
      "ordonner",
      0.0275
    ],
    [
      "forcer",
      0.0275
    ],
    [
      "fixer",
      0.0275
    ],
    [
      "condamner",
      0.0275
    ],
    [
      "soumettre",
      0.02
    ],
    [
      "inspirer",
      0.02
    ],
    [
      "imputer",
      0.02
    ],
    [
      "grever",
      0.02
    ],
    [
      "faire",
      0.02
    ],
    [
      "enjoindre",
      0.02
    ],
    [
      "demander",
      0.02
    ],
    [
      "bluffer",
      0.02
    ],
    [
      "astreindre",
      0.02
    ],
    [
      "subjuguer",
      0.0125
    ],
    [
      "mettre",
      0.0125
    ],
    [
      "esbroufer",
      0.0125
    ],
    [
      "dicter",
      0.0125
    ],
    [
      "assigner",
      0.0125
    ],
    [
      "tromper",
      0.005
    ],
    [
      "taxer",
      0.005
    ],
    [
      "surimposer",
      0.005
    ],
    [
      "surcharger",
      0.005
    ],
    [
      "revendiquer",
      0.005
    ],
    [
      "representer",
      0.005
    ],
    [
      "prelever",
      0.005
    ],
    [
      "pressurer",
      0.005
    ],
    [
      "meriter",
      0.005
    ],
    [
      "infliger",
      0.005
    ],
    [
      "impatroniser",
      0.005
    ],
    [
      "accrediter",
      0.005
    ],
    [
      "abuser",
      0.005
    ],
    [
      "edicter",
      0.005
    ]
  ],
  "defendre": [
    [
      "proteger",
      0.125
    ],
    [
      "soutenir",
      0.075
    ],
    [
      "garantir",
      0.055
    ],
    [
      "assurer",
      0.04
    ],
    [
      "interdire",
      0.04
    ],
    [
      "maintenir",
      0.04
    ],
    [
      "preserver",
      0.04
    ],
    [
      "sauvegarder",
      0.0325
    ],
    [
      "renforcer",
      0.0325
    ],
    [
      "empecher",
      0.0325
    ],
    [
      "couvrir",
      0.0325
    ],
    [
      "appuyer",
      0.0325
    ],
    [
      "prohiber",
      0.0275
    ],
    [
      "garder",
      0.0275
    ],
    [
      "fortifier",
      0.0275
    ],
    [
      "condamner",
      0.0275
    ],
    [
      "tenir",
      0.02
    ],
    [
      "justifier",
      0.02
    ],
    [
      "excuser",
      0.02
    ],
    [
      "aider",
      0.02
    ],
    [
      "secourir",
      0.0125
    ],
    [
      "sauver",
      0.0125
    ],
    [
      "s'opposer",
      0.0125
    ],
    [
      "proscrire",
      0.0125
    ],
    [
      "intervenir",
      0.0125
    ],
    [
      "inhiber",
      0.0125
    ],
    [
      "chaperonner",
      0.0125
    ],
    [
      "censurer",
      0.0125
    ],
    [
      "abriter",
      0.0125
    ],
    [
      "prescrire",
      0.005
    ],
    [
      "refuser",
      0.005
    ],
    [
      "reprouver",
      0.005
    ],
    [
      "plaider",
      0.005
    ],
    [
      "interceder",
      0.005
    ],
    [
      "flanquer",
      0.005
    ],
    [
      "fermer",
      0.005
    ],
    [
      "disputer",
      0.005
    ],
    [
      "disculper",
      0.005
    ],
    [
      "assister",
      0.005
    ]
  ],
  "preter": [
    [
      "donner",
      0.175
    ],
    [
      "attribuer",
      0.07
    ],
    [
      "offrir",
      0.07
    ],
    [
      "porter",
      0.07
    ],
    [
      "accorder",
      0.0575
    ],
    [
      "attacher",
      0.045
    ],
    [
      "tendre",
      0.035
    ],
    [
      "procurer",
      0.035
    ],
    [
      "dresser",
      0.035
    ],
    [
      "avancer",
      0.035
    ],
    [
      "s'etendre",
      0.0225
    ],
    [
      "rapporter",
      0.0225
    ],
    [
      "placer",
      0.0225
    ],
    [
      "passer",
      0.0225
    ],
    [
      "inciter",
      0.0225
    ],
    [
      "imputer",
      0.0225
    ],
    [
      "engendrer",
      0.0225
    ],
    [
      "communiquer",
      0.0225
    ],
    [
      "appreter",
      0.0225
    ],
    [
      "allouer",
      0.0225
    ],
    [
      "reconnaitre",
      0.01
    ],
    [
      "s'engager",
      0.01
    ],
    [
      "s'exposer",
      0.01
    ],
    [
      "s'etirer",
      0.01
    ],
    [
      "supposer",
      0.01
    ],
    [
      "proposer",
      0.01
    ],
    [
      "octroyer",
      0.01
    ],
    [
      "menager",
      0.01
    ],
    [
      "fournir",
      0.01
    ],
    [
      "confier",
      0.01
    ],
    [
      "appeler",
      0.01
    ],
    [
      "adjoindre",
      0.01
    ]
  ],
  "fer": [
    [
      "poignard",
      0.2125
    ],
    [
      "acier",
      0.1425
    ],
    [
      "pointe",
      0.07
    ],
    [
      "metal",
      0.07
    ],
    [
      "limaille",
      0.07
    ],
    [
      "ferrement",
      0.07
    ],
    [
      "crampon",
      0.07
    ],
    [
      "couteau",
      0.07
    ],
    [
      "bronze",
      0.07
    ],
    [
      "arcelet",
      0.07
    ],
    [
      "epee",
      0.07
    ]
  ],
  "tribu": [
    [
      "groupe",
      0.16
    ],
    [
      "clan",
      0.1075
    ],
    [
      "peuple",
      0.0875
    ],
    [
      "societe",
      0.0875
    ],
    [
      "famille",
      0.07
    ],
    [
      "peuplade",
      0.07
    ],
    [
      "race",
      0.07
    ],
    [
      "troupe",
      0.0525
    ],
    [
      "parti",
      0.0525
    ],
    [
      "horde",
      0.0525
    ],
    [
      "association",
      0.0525
    ],
    [
      "coterie",
      0.035
    ],
    [
      "division",
      0.015
    ],
    [
      "ethnie",
      0.015
    ],
    [
      "phratrie",
      0.015
    ],
    [
      "smala",
      0.015
    ]
  ],
  "menhir": [
    [
      "cromlech",
      0.3325
    ],
    [
      "peulven",
      0.3325
    ]
  ],
  "invoquer": [
    [
      "alleguer",
      0.135
    ],
    [
      "appeler",
      0.1075
    ],
    [
      "citer",
      0.08
    ],
    [
      "pretexter",
      0.08
    ],
    [
      "produire",
      0.0525
    ],
    [
      "prier",
      0.0525
    ],
    [
      "opposer",
      0.0525
    ],
    [
      "objecter",
      0.0525
    ],
    [
      "implorer",
      0.0525
    ],
    [
      "reclamer",
      0.025
    ],
    [
      "crier",
      0.025
    ],
    [
      "attester",
      0.025
    ],
    [
      "arguer",
      0.025
    ],
    [
      "adjurer",
      0.025
    ],
    [
      "evoquer",
      0.025
    ]
  ],
  "afin": [],
  "zele": [
    [
      "ardeur",
      0.0775
    ],
    [
      "attachement",
      0.0575
    ],
    [
      "chaleur",
      0.0575
    ],
    [
      "soin",
      0.05
    ],
    [
      "coeur",
      0.045
    ],
    [
      "passion",
      0.04
    ],
    [
      "enthousiasme",
      0.04
    ],
    [
      "empressement",
      0.04
    ],
    [
      "application",
      0.035
    ],
    [
      "devouement",
      0.035
    ],
    [
      "elan",
      0.03
    ],
    [
      "fanatisme",
      0.03
    ],
    [
      "diligence",
      0.03
    ],
    [
      "conscience",
      0.025
    ],
    [
      "courage",
      0.025
    ],
    [
      "flamme",
      0.025
    ],
    [
      "vivacite",
      0.025
    ],
    [
      "tendresse",
      0.0225
    ],
    [
      "promptitude",
      0.0225
    ],
    [
      "attention",
      0.0225
    ],
    [
      "activite",
      0.0225
    ],
    [
      "foi",
      0.0175
    ],
    [
      "fidelite",
      0.0175
    ],
    [
      "entrain",
      0.0175
    ],
    [
      "celerite",
      0.0175
    ],
    [
      "assiduite",
      0.0175
    ],
    [
      "devotion",
      0.0125
    ],
    [
      "ferveur",
      0.0125
    ],
    [
      "religion",
      0.0125
    ],
    [
      "ressort",
      0.0125
    ],
    [
      "serieux",
      0.0125
    ],
    [
      "travail",
      0.0075
    ],
    [
      "perseverance",
      0.0075
    ],
    [
      "complaisance",
      0.0075
    ],
    [
      "vigilance",
      0.0025
    ],
    [
      "proselytisme",
      0.0025
    ],
    [
      "intrepidite",
      0.0025
    ],
    [
      "civisme",
      0.0025
    ],
    [
      "attache",
      0.0025
    ],
    [
      "apostolat",
      0.0025
    ],
    [
      "abnegation",
      0.0025
    ],
    [
      "emulation",
      0.0025
    ]
  ],
  "gorgee": [
    [
      "gaver",
      0.1175
    ],
    [
      "bourrer",
      0.1
    ],
    [
      "combler",
      0.0825
    ],
    [
      "saturer",
      0.0675
    ],
    [
      "remplir",
      0.0675
    ],
    [
      "rassasier",
      0.0675
    ],
    [
      "nourrir",
      0.0675
    ],
    [
      "abreuver",
      0.05
    ],
    [
      "engraisser",
      0.05
    ],
    [
      "ecraser",
      0.0325
    ],
    [
      "inonder",
      0.0325
    ],
    [
      "impregner",
      0.0325
    ],
    [
      "emplir",
      0.0325
    ],
    [
      "alimenter",
      0.0325
    ],
    [
      "accabler",
      0.0325
    ],
    [
      "repaitre",
      0.015
    ],
    [
      "gater",
      0.015
    ],
    [
      "empiffrer",
      0.015
    ],
    [
      "emboquer",
      0.015
    ],
    [
      "embecquer",
      0.015
    ],
    [
      "appater",
      0.015
    ],
    [
      "souler",
      0.015
    ]
  ],
  "gorger": [
    [
      "gaver",
      0.1175
    ],
    [
      "bourrer",
      0.1
    ],
    [
      "combler",
      0.0825
    ],
    [
      "saturer",
      0.0675
    ],
    [
      "remplir",
      0.0675
    ],
    [
      "rassasier",
      0.0675
    ],
    [
      "nourrir",
      0.0675
    ],
    [
      "abreuver",
      0.05
    ],
    [
      "engraisser",
      0.05
    ],
    [
      "ecraser",
      0.0325
    ],
    [
      "inonder",
      0.0325
    ],
    [
      "impregner",
      0.0325
    ],
    [
      "emplir",
      0.0325
    ],
    [
      "alimenter",
      0.0325
    ],
    [
      "accabler",
      0.0325
    ],
    [
      "repaitre",
      0.015
    ],
    [
      "gater",
      0.015
    ],
    [
      "empiffrer",
      0.015
    ],
    [
      "emboquer",
      0.015
    ],
    [
      "embecquer",
      0.015
    ],
    [
      "appater",
      0.015
    ],
    [
      "souler",
      0.015
    ]
  ],
  "hydromel": [
    [
      "boisson",
      1.0
    ]
  ],
  "courage": [
    [
      "coeur",
      0.0725
    ],
    [
      "energie",
      0.065
    ],
    [
      "ressort",
      0.0625
    ],
    [
      "fermete",
      0.06
    ],
    [
      "hardiesse",
      0.055
    ],
    [
      "audace",
      0.0525
    ],
    [
      "force",
      0.035
    ],
    [
      "volonte",
      0.0325
    ],
    [
      "assurance",
      0.03
    ],
    [
      "decision",
      0.03
    ],
    [
      "ame",
      0.0275
    ],
    [
      "temerite",
      0.0275
    ],
    [
      "resolution",
      0.0275
    ],
    [
      "caractere",
      0.0275
    ],
    [
      "cran",
      0.025
    ],
    [
      "intrepidite",
      0.025
    ],
    [
      "solidite",
      0.025
    ],
    [
      "valeur",
      0.025
    ],
    [
      "ardeur",
      0.0225
    ],
    [
      "vaillance",
      0.02
    ],
    [
      "bravoure",
      0.0175
    ],
    [
      "generosite",
      0.0175
    ],
    [
      "heroisme",
      0.0175
    ],
    [
      "constance",
      0.015
    ],
    [
      "zele",
      0.01
    ],
    [
      "impetuosite",
      0.01
    ],
    [
      "toupet",
      0.0075
    ],
    [
      "passion",
      0.0075
    ],
    [
      "estomac",
      0.0075
    ],
    [
      "culot",
      0.0075
    ],
    [
      "chaleur",
      0.0075
    ],
    [
      "vertu",
      0.005
    ],
    [
      "stoicisme",
      0.005
    ],
    [
      "perseverance",
      0.005
    ],
    [
      "front",
      0.005
    ],
    [
      "fanatisme",
      0.005
    ],
    [
      "cranerie",
      0.005
    ],
    [
      "conscience",
      0.005
    ],
    [
      "confiance",
      0.005
    ],
    [
      "sentiment",
      0.0025
    ],
    [
      "ressource",
      0.0025
    ],
    [
      "patience",
      0.0025
    ],
    [
      "furie",
      0.0025
    ],
    [
      "bras",
      0.0025
    ],
    [
      "contenance",
      0.0
    ],
    [
      "cruaute",
      0.0
    ],
    [
      "hardi",
      0.0
    ],
    [
      "resistance",
      0.0
    ]
  ],
  "failler": [],
  "faille": [
    [
      "fente",
      0.1375
    ],
    [
      "cassure",
      0.0725
    ],
    [
      "entaille",
      0.0725
    ],
    [
      "trou",
      0.0725
    ],
    [
      "fissure",
      0.0625
    ],
    [
      "dechirure",
      0.0625
    ],
    [
      "breche",
      0.0625
    ],
    [
      "brisure",
      0.05
    ],
    [
      "crevasse",
      0.05
    ],
    [
      "trouee",
      0.05
    ],
    [
      "echancrure",
      0.05
    ],
    [
      "lacune",
      0.03
    ],
    [
      "felure",
      0.03
    ],
    [
      "excavation",
      0.02
    ],
    [
      "faiblesse",
      0.02
    ],
    [
      "hiatus",
      0.02
    ],
    [
      "interstice",
      0.02
    ],
    [
      "rainure",
      0.02
    ],
    [
      "klippe",
      0.01
    ],
    [
      "fracture",
      0.01
    ],
    [
      "defile",
      0.01
    ],
    [
      "defaut",
      0.01
    ],
    [
      "decrochement",
      0.01
    ],
    [
      "dislocation",
      0.01
    ],
    [
      "soie",
      0.01
    ]
  ],
  "batailler": [
    [
      "lutter",
      0.1825
    ],
    [
      "combattre",
      0.0775
    ],
    [
      "discuter",
      0.0775
    ],
    [
      "disputer",
      0.0775
    ],
    [
      "ferrailler",
      0.0575
    ],
    [
      "bagarrer",
      0.0475
    ],
    [
      "barouder",
      0.0275
    ],
    [
      "chicaner",
      0.0275
    ],
    [
      "contester",
      0.0275
    ],
    [
      "s'escrimer",
      0.0275
    ],
    [
      "s'evertuer",
      0.0175
    ],
    [
      "rivaliser",
      0.0175
    ],
    [
      "jouter",
      0.0175
    ],
    [
      "battre",
      0.0175
    ],
    [
      "s'echiner",
      0.0075
    ],
    [
      "s'accrocher",
      0.0075
    ],
    [
      "quereller",
      0.0075
    ],
    [
      "militer",
      0.0075
    ],
    [
      "guerroyer",
      0.0075
    ],
    [
      "foncer",
      0.0075
    ],
    [
      "bretailler",
      0.0075
    ],
    [
      "argumenter",
      0.0075
    ],
    [
      "agir",
      0.0075
    ],
    [
      "affronter",
      0.0075
    ]
  ],
  "pars": [
    [
      "s'enfuir",
      0.095
    ],
    [
      "fuir",
      0.0625
    ],
    [
      "deguerpir",
      0.06
    ],
    [
      "decamper",
      0.04
    ],
    [
      "sortir",
      0.0375
    ],
    [
      "disparaitre",
      0.0375
    ],
    [
      "quitter",
      0.0325
    ],
    [
      "s'eclipser",
      0.03
    ],
    [
      "abandonner",
      0.025
    ],
    [
      "filer",
      0.025
    ],
    [
      "s'echapper",
      0.0225
    ],
    [
      "s'esquiver",
      0.0175
    ],
    [
      "deloger",
      0.0125
    ],
    [
      "s'elancer",
      0.01
    ],
    [
      "s'envoler",
      0.01
    ],
    [
      "jaillir",
      0.01
    ],
    [
      "detaler",
      0.01
    ],
    [
      "s'eloigner",
      0.0075
    ],
    [
      "echapper",
      0.0075
    ],
    [
      "venir",
      0.005
    ],
    [
      "s'effacer",
      0.005
    ],
    [
      "s'absenter",
      0.005
    ],
    [
      "mourir",
      0.005
    ],
    [
      "fuser",
      0.005
    ],
    [
      "demenager",
      0.005
    ],
    [
      "degager",
      0.005
    ],
    [
      "commencer",
      0.005
    ],
    [
      "retourner",
      0.005
    ],
    [
      "provenir",
      0.005
    ],
    [
      "proceder",
      0.005
    ],
    [
      "descendre",
      0.005
    ],
    [
      "changer",
      0.005
    ],
    [
      "eclater",
      0.0025
    ],
    [
      "tourner",
      0.0025
    ],
    [
      "tirer",
      0.0025
    ],
    [
      "sauter",
      0.0025
    ],
    [
      "marcher",
      0.0025
    ],
    [
      "demarrer",
      0.0025
    ],
    [
      "decaniller",
      0.0025
    ],
    [
      "saillir",
      0.0025
    ],
    [
      "semer",
      0.0025
    ],
    [
      "vider",
      0.0025
    ],
    [
      "ecarter",
      0.0025
    ],
    [
      "emaner",
      0.0025
    ],
    [
      "riper",
      0.0025
    ],
    [
      "bondir",
      0.0025
    ],
    [
      "caleter",
      0.0025
    ],
    [
      "circuler",
      0.0025
    ],
    [
      "finir",
      0.0025
    ],
    [
      "lancer",
      0.0025
    ],
    [
      "naitre",
      0.0025
    ],
    [
      "voyager",
      0.0
    ],
    [
      "s'oter",
      0.0
    ],
    [
      "s'emietter",
      0.0
    ],
    [
      "s'ouvrir",
      0.0
    ],
    [
      "bouger",
      0.0
    ],
    [
      "debuter",
      0.0
    ],
    [
      "decarrer",
      0.0
    ],
    [
      "denicher",
      0.0
    ],
    [
      "s'enlever",
      0.0
    ],
    [
      "s'ebranler",
      0.0
    ],
    [
      "s'embarquer",
      0.0
    ],
    [
      "s'appuyer",
      0.0
    ],
    [
      "repartir",
      0.0
    ],
    [
      "remonter",
      0.0
    ],
    [
      "emigrer",
      0.0
    ],
    [
      "diviser",
      0.0
    ],
    [
      "deserter",
      0.0
    ],
    [
      "ficher",
      0.0
    ],
    [
      "fonctionner",
      0.0
    ],
    [
      "gicler",
      0.0
    ],
    [
      "jouir",
      0.0
    ],
    [
      "partager",
      0.0
    ],
    [
      "appareiller",
      0.0
    ]
  ],
  "digne": [
    [
      "honnete",
      0.0875
    ],
    [
      "bon",
      0.065
    ],
    [
      "beau",
      0.06
    ],
    [
      "noble",
      0.055
    ],
    [
      "respectable",
      0.055
    ],
    [
      "honorable",
      0.05
    ],
    [
      "convenable",
      0.05
    ],
    [
      "correct",
      0.0425
    ],
    [
      "grave",
      0.0425
    ],
    [
      "serieux",
      0.0325
    ],
    [
      "sortable",
      0.0325
    ],
    [
      "reserve",
      0.0325
    ],
    [
      "majestueux",
      0.0325
    ],
    [
      "bien",
      0.0325
    ],
    [
      "decent",
      0.025
    ],
    [
      "imposant",
      0.025
    ],
    [
      "solennel",
      0.025
    ],
    [
      "seyant",
      0.02
    ],
    [
      "compasse",
      0.02
    ],
    [
      "venerable",
      0.015
    ],
    [
      "meritant",
      0.015
    ],
    [
      "fier",
      0.015
    ],
    [
      "auguste",
      0.015
    ],
    [
      "affecte",
      0.015
    ],
    [
      "retenu",
      0.01
    ],
    [
      "parfait",
      0.01
    ],
    [
      "meritoire",
      0.01
    ],
    [
      "louable",
      0.01
    ],
    [
      "haut",
      0.01
    ],
    [
      "guinde",
      0.01
    ],
    [
      "gourme",
      0.01
    ],
    [
      "distingue",
      0.01
    ],
    [
      "convenant",
      0.005
    ],
    [
      "modeste",
      0.005
    ],
    [
      "probe",
      0.005
    ],
    [
      "presentable",
      0.005
    ]
  ],
  "echo": [
    [
      "bruit",
      0.105
    ],
    [
      "copie",
      0.07
    ],
    [
      "imitation",
      0.07
    ],
    [
      "reproduction",
      0.07
    ],
    [
      "representation",
      0.05
    ],
    [
      "image",
      0.05
    ],
    [
      "anecdote",
      0.05
    ],
    [
      "ton",
      0.0325
    ],
    [
      "son",
      0.0325
    ],
    [
      "repetition",
      0.0325
    ],
    [
      "rumeur",
      0.0325
    ],
    [
      "potin",
      0.0325
    ],
    [
      "nouvelle",
      0.0325
    ],
    [
      "expression",
      0.0325
    ],
    [
      "redoublement",
      0.015
    ],
    [
      "reflet",
      0.015
    ],
    [
      "reduplication",
      0.015
    ],
    [
      "repercussion",
      0.015
    ],
    [
      "reponse",
      0.015
    ],
    [
      "resonance",
      0.015
    ],
    [
      "miroir",
      0.015
    ],
    [
      "histoire",
      0.015
    ],
    [
      "consonance",
      0.015
    ],
    [
      "calque",
      0.015
    ],
    [
      "article",
      0.015
    ],
    [
      "approbation",
      0.015
    ],
    [
      "adhesion",
      0.015
    ],
    [
      "sympathie",
      0.015
    ]
  ],
  "tombeau": [
    [
      "tombe",
      0.27
    ],
    [
      "mausolee",
      0.09
    ],
    [
      "caveau",
      0.065
    ],
    [
      "cenotaphe",
      0.065
    ],
    [
      "sepulcre",
      0.065
    ],
    [
      "sepulture",
      0.065
    ],
    [
      "souvenir",
      0.0425
    ],
    [
      "mort",
      0.0425
    ],
    [
      "monument",
      0.0425
    ],
    [
      "sarcophage",
      0.02
    ],
    [
      "mastaba",
      0.02
    ],
    [
      "marabout",
      0.02
    ],
    [
      "koubba",
      0.02
    ],
    [
      "hypogee",
      0.02
    ],
    [
      "celebration",
      0.02
    ],
    [
      "columbarium",
      0.02
    ],
    [
      "cippe",
      0.02
    ],
    [
      "stele",
      0.02
    ]
  ],
  "incantation": [
    [
      "magie",
      0.15
    ],
    [
      "sorcellerie",
      0.15
    ],
    [
      "charme",
      0.1
    ],
    [
      "conjuration",
      0.1
    ],
    [
      "sortilege",
      0.1
    ],
    [
      "obsecration",
      0.0475
    ],
    [
      "melodie",
      0.0475
    ],
    [
      "invocation",
      0.0475
    ],
    [
      "harmonie",
      0.0475
    ],
    [
      "exorcisme",
      0.0475
    ],
    [
      "envoutement",
      0.0475
    ],
    [
      "enchantement",
      0.0475
    ],
    [
      "evocation",
      0.0475
    ]
  ],
  "magie": [
    [
      "sorcellerie",
      0.1675
    ],
    [
      "charme",
      0.075
    ],
    [
      "occultisme",
      0.0525
    ],
    [
      "enchantement",
      0.0375
    ],
    [
      "envoutement",
      0.0375
    ],
    [
      "sortilege",
      0.0375
    ],
    [
      "malefice",
      0.03
    ],
    [
      "feerie",
      0.03
    ],
    [
      "fascination",
      0.03
    ],
    [
      "divination",
      0.03
    ],
    [
      "evocation",
      0.0225
    ],
    [
      "seduction",
      0.0225
    ],
    [
      "surnaturel",
      0.0225
    ],
    [
      "prestige",
      0.0225
    ],
    [
      "mystere",
      0.0225
    ],
    [
      "incantation",
      0.0225
    ],
    [
      "illusion",
      0.0225
    ],
    [
      "hermetisme",
      0.0225
    ],
    [
      "ensorcellement",
      0.0225
    ],
    [
      "cabale",
      0.0225
    ],
    [
      "spiritisme",
      0.015
    ],
    [
      "horoscope",
      0.015
    ],
    [
      "fantasmagorie",
      0.015
    ],
    [
      "diablerie",
      0.015
    ],
    [
      "conjuration",
      0.015
    ],
    [
      "beaute",
      0.015
    ],
    [
      "astrologie",
      0.015
    ],
    [
      "alchimie",
      0.015
    ],
    [
      "prestidigitation",
      0.0075
    ],
    [
      "puissance",
      0.0075
    ],
    [
      "rite",
      0.0075
    ],
    [
      "sort",
      0.0075
    ],
    [
      "thaumaturgie",
      0.0075
    ],
    [
      "theurgie",
      0.0075
    ],
    [
      "philtre",
      0.0075
    ],
    [
      "necromancie",
      0.0075
    ],
    [
      "magisme",
      0.0075
    ],
    [
      "goetie",
      0.0075
    ],
    [
      "archimagie",
      0.0075
    ],
    [
      "apparition",
      0.0075
    ],
    [
      "vaudou",
      0.0075
    ]
  ],
  "glaive": [
    [
      "epee",
      1.0
    ]
  ],
  "lutte": [
    [
      "combat",
      0.1325
    ],
    [
      "bataille",
      0.0775
    ],
    [
      "conflit",
      0.055
    ],
    [
      "opposition",
      0.0475
    ],
    [
      "choc",
      0.0425
    ],
    [
      "dispute",
      0.0425
    ],
    [
      "rivalite",
      0.04
    ],
    [
      "querelle",
      0.035
    ],
    [
      "affrontement",
      0.0325
    ],
    [
      "duel",
      0.0325
    ],
    [
      "guerre",
      0.0325
    ],
    [
      "competition",
      0.0275
    ],
    [
      "bagarre",
      0.0275
    ],
    [
      "antagonisme",
      0.02
    ],
    [
      "attaque",
      0.02
    ],
    [
      "contestation",
      0.02
    ],
    [
      "rixe",
      0.02
    ],
    [
      "echauffouree",
      0.0175
    ],
    [
      "resistance",
      0.0175
    ],
    [
      "emulation",
      0.0125
    ],
    [
      "revolte",
      0.0125
    ],
    [
      "pugilat",
      0.0125
    ],
    [
      "offensive",
      0.0125
    ],
    [
      "melee",
      0.0125
    ],
    [
      "joute",
      0.0125
    ],
    [
      "heurt",
      0.0125
    ],
    [
      "action",
      0.0125
    ],
    [
      "soulevement",
      0.01
    ],
    [
      "effort",
      0.01
    ],
    [
      "concurrence",
      0.01
    ],
    [
      "collision",
      0.01
    ],
    [
      "tournoi",
      0.005
    ],
    [
      "debat",
      0.005
    ],
    [
      "baroud",
      0.005
    ],
    [
      "agitation",
      0.005
    ],
    [
      "pancrace",
      0.0025
    ],
    [
      "lice",
      0.0025
    ],
    [
      "karate",
      0.0025
    ],
    [
      "judo",
      0.0025
    ],
    [
      "hostilites",
      0.0025
    ],
    [
      "escrime",
      0.0025
    ],
    [
      "defense",
      0.0025
    ],
    [
      "catch",
      0.0025
    ],
    [
      "boxe",
      0.0025
    ],
    [
      "acharnement",
      0.0025
    ],
    [
      "rahba",
      0.0025
    ]
  ],
  "terrible": [
    [
      "epouvantable",
      0.0525
    ],
    [
      "mauvais",
      0.05
    ],
    [
      "atroce",
      0.045
    ],
    [
      "cruel",
      0.04
    ],
    [
      "dur",
      0.04
    ],
    [
      "insupportable",
      0.035
    ],
    [
      "effrayant",
      0.035
    ],
    [
      "extraordinaire",
      0.0325
    ],
    [
      "monstrueux",
      0.03
    ],
    [
      "grand",
      0.0275
    ],
    [
      "affreux",
      0.0275
    ],
    [
      "feroce",
      0.025
    ],
    [
      "horrible",
      0.025
    ],
    [
      "violent",
      0.0225
    ],
    [
      "infernal",
      0.02
    ],
    [
      "penible",
      0.02
    ],
    [
      "rude",
      0.02
    ],
    [
      "mechant",
      0.02
    ],
    [
      "inhumain",
      0.02
    ],
    [
      "excessif",
      0.02
    ],
    [
      "effroyable",
      0.0175
    ],
    [
      "formidable",
      0.0175
    ],
    [
      "odieux",
      0.015
    ],
    [
      "furieux",
      0.015
    ],
    [
      "sensationnel",
      0.0125
    ],
    [
      "fou",
      0.01
    ],
    [
      "enorme",
      0.01
    ],
    [
      "sinistre",
      0.01
    ],
    [
      "prodigieux",
      0.01
    ],
    [
      "intense",
      0.01
    ],
    [
      "diable",
      0.01
    ],
    [
      "brutal",
      0.01
    ],
    [
      "etonnant",
      0.01
    ],
    [
      "apre",
      0.01
    ],
    [
      "severe",
      0.01
    ],
    [
      "intolerable",
      0.01
    ],
    [
      "implacable",
      0.01
    ],
    [
      "forcene",
      0.01
    ],
    [
      "fantastique",
      0.01
    ],
    [
      "difficile",
      0.01
    ],
    [
      "tragique",
      0.005
    ],
    [
      "terrifiant",
      0.005
    ],
    [
      "farouche",
      0.005
    ],
    [
      "abominable",
      0.005
    ],
    [
      "redoutable",
      0.005
    ],
    [
      "intenable",
      0.005
    ],
    [
      "inoui",
      0.005
    ],
    [
      "acharne",
      0.005
    ],
    [
      "dramatique",
      0.005
    ],
    [
      "dechaine",
      0.005
    ],
    [
      "turbulent",
      0.0025
    ],
    [
      "stupefiant",
      0.0025
    ],
    [
      "indocile",
      0.0025
    ],
    [
      "indiscipline",
      0.0025
    ],
    [
      "glacial",
      0.0025
    ],
    [
      "endiable",
      0.0025
    ],
    [
      "dantesque",
      0.0025
    ],
    [
      "catastrophique",
      0.0025
    ],
    [
      "apocalyptique",
      0.0025
    ],
    [
      "alarmant",
      0.0025
    ],
    [
      "admirable",
      0.0025
    ],
    [
      "epatant",
      0.0
    ],
    [
      "sombre",
      0.0
    ],
    [
      "puissant",
      0.0
    ],
    [
      "merveilleux",
      0.0
    ],
    [
      "incomparable",
      0.0
    ],
    [
      "fatigant",
      0.0
    ],
    [
      "dement",
      0.0
    ],
    [
      "terrorisant",
      0.0
    ],
    [
      "terrifique",
      0.0
    ],
    [
      "retentissant",
      0.0
    ],
    [
      "malcommode",
      0.0
    ],
    [
      "insoutenable",
      0.0
    ],
    [
      "insoumis",
      0.0
    ],
    [
      "foudroyant",
      0.0
    ],
    [
      "cataclysmique",
      0.0
    ],
    [
      "theatral",
      0.0
    ]
  ],
  "surnombre": [
    [
      "trop",
      0.5
    ],
    [
      "exces",
      0.25
    ],
    [
      "surnumeraire",
      0.25
    ]
  ],
  "poids": [
    [
      "charge",
      0.065
    ],
    [
      "force",
      0.065
    ],
    [
      "importance",
      0.0425
    ],
    [
      "portee",
      0.0425
    ],
    [
      "masse",
      0.035
    ],
    [
      "influence",
      0.035
    ],
    [
      "fardeau",
      0.035
    ],
    [
      "autorite",
      0.03
    ],
    [
      "grain",
      0.03
    ],
    [
      "mesure",
      0.03
    ],
    [
      "quantite",
      0.03
    ],
    [
      "valeur",
      0.02
    ],
    [
      "souci",
      0.02
    ],
    [
      "poussee",
      0.02
    ],
    [
      "gravite",
      0.02
    ],
    [
      "fret",
      0.02
    ],
    [
      "once",
      0.0125
    ],
    [
      "pesanteur",
      0.0125
    ],
    [
      "ponderation",
      0.0125
    ],
    [
      "pression",
      0.0125
    ],
    [
      "prestige",
      0.0125
    ],
    [
      "scrupule",
      0.0125
    ],
    [
      "titre",
      0.0125
    ],
    [
      "tourment",
      0.0125
    ],
    [
      "morceau",
      0.0125
    ],
    [
      "lourdeur",
      0.0125
    ],
    [
      "bloc",
      0.0125
    ],
    [
      "boulet",
      0.0125
    ],
    [
      "consideration",
      0.0125
    ],
    [
      "degre",
      0.0125
    ],
    [
      "densite",
      0.0125
    ],
    [
      "embarras",
      0.0125
    ],
    [
      "faix",
      0.0125
    ],
    [
      "interet",
      0.0125
    ],
    [
      "place",
      0.005
    ],
    [
      "pesee",
      0.005
    ],
    [
      "oppression",
      0.005
    ],
    [
      "mine",
      0.005
    ],
    [
      "milligramme",
      0.005
    ],
    [
      "quintal",
      0.005
    ],
    [
      "sicle",
      0.005
    ],
    [
      "statere",
      0.005
    ],
    [
      "surcharge",
      0.005
    ],
    [
      "talent",
      0.005
    ],
    [
      "tare",
      0.005
    ],
    [
      "tonne",
      0.005
    ],
    [
      "marc",
      0.005
    ],
    [
      "livre",
      0.005
    ],
    [
      "accablement",
      0.005
    ],
    [
      "as",
      0.005
    ],
    [
      "carat",
      0.005
    ],
    [
      "centigramme",
      0.005
    ],
    [
      "chargement",
      0.005
    ],
    [
      "drachme",
      0.005
    ],
    [
      "fatigue",
      0.005
    ],
    [
      "gramme",
      0.005
    ],
    [
      "hectogramme",
      0.005
    ],
    [
      "jauge",
      0.005
    ],
    [
      "kilogramme",
      0.005
    ],
    [
      "ligne",
      0.005
    ],
    [
      "etalon",
      0.005
    ]
  ],
  "barbare": [
    [
      "sauvage",
      0.1
    ],
    [
      "cruel",
      0.085
    ],
    [
      "grossier",
      0.085
    ],
    [
      "feroce",
      0.0725
    ],
    [
      "dur",
      0.05
    ],
    [
      "rude",
      0.045
    ],
    [
      "inhumain",
      0.0375
    ],
    [
      "farouche",
      0.0375
    ],
    [
      "brut",
      0.0375
    ],
    [
      "bestial",
      0.0325
    ],
    [
      "brutal",
      0.0325
    ],
    [
      "inculte",
      0.0325
    ],
    [
      "rustique",
      0.0325
    ],
    [
      "fruste",
      0.0275
    ],
    [
      "impoli",
      0.0275
    ],
    [
      "sanguinaire",
      0.02
    ],
    [
      "primitif",
      0.02
    ],
    [
      "implacable",
      0.02
    ],
    [
      "ignorant",
      0.02
    ],
    [
      "arriere",
      0.02
    ],
    [
      "sanglant",
      0.01
    ],
    [
      "ostrogoth",
      0.01
    ],
    [
      "inconvenant",
      0.01
    ],
    [
      "impitoyable",
      0.01
    ],
    [
      "gothique",
      0.01
    ],
    [
      "beotien",
      0.01
    ],
    [
      "brute",
      0.01
    ],
    [
      "atroce",
      0.01
    ],
    [
      "sadique",
      0.005
    ],
    [
      "malsonnant",
      0.005
    ],
    [
      "incorrect",
      0.005
    ],
    [
      "ignare",
      0.005
    ],
    [
      "fier",
      0.005
    ],
    [
      "cannibale",
      0.005
    ],
    [
      "barbarisme",
      0.005
    ],
    [
      "vandale",
      0.005
    ]
  ],
  "hache": [
    [
      "hachereau",
      0.1175
    ],
    [
      "hachette",
      0.1175
    ],
    [
      "tille",
      0.0575
    ],
    [
      "serpe",
      0.0575
    ],
    [
      "merlin",
      0.0575
    ],
    [
      "herminette",
      0.0575
    ],
    [
      "francisque",
      0.0575
    ],
    [
      "doloire",
      0.0575
    ],
    [
      "doleau",
      0.0575
    ],
    [
      "coutre",
      0.0575
    ],
    [
      "cognee",
      0.0575
    ],
    [
      "cochoir",
      0.0575
    ],
    [
      "aissette",
      0.0575
    ],
    [
      "aisseau",
      0.0575
    ],
    [
      "tomahawk",
      0.0575
    ]
  ],
  "hacher": [
    [
      "couper",
      0.18
    ],
    [
      "trancher",
      0.1075
    ],
    [
      "briser",
      0.07
    ],
    [
      "dechiqueter",
      0.07
    ],
    [
      "taillader",
      0.0525
    ],
    [
      "detruire",
      0.0525
    ],
    [
      "diviser",
      0.0525
    ],
    [
      "interrompre",
      0.035
    ],
    [
      "fendre",
      0.035
    ],
    [
      "faucher",
      0.035
    ],
    [
      "entrecouper",
      0.035
    ],
    [
      "decouper",
      0.035
    ],
    [
      "charcuter",
      0.035
    ],
    [
      "tronconner",
      0.015
    ],
    [
      "ravager",
      0.015
    ],
    [
      "macher",
      0.015
    ],
    [
      "lacerer",
      0.015
    ],
    [
      "heurter",
      0.015
    ],
    [
      "hachurer",
      0.015
    ],
    [
      "fracasser",
      0.015
    ],
    [
      "chapeler",
      0.015
    ],
    [
      "echarper",
      0.015
    ]
  ],
  "ecouler": [
    [
      "liquider",
      0.2725
    ],
    [
      "vendre",
      0.2725
    ],
    [
      "diffuser",
      0.09
    ],
    [
      "debiter",
      0.09
    ],
    [
      "placer",
      0.09
    ],
    [
      "solder",
      0.09
    ],
    [
      "epuiser",
      0.09
    ]
  ],
  "herbe": [
    [
      "prairie",
      0.1125
    ],
    [
      "gazon",
      0.075
    ],
    [
      "pre",
      0.055
    ],
    [
      "paturage",
      0.055
    ],
    [
      "verdure",
      0.055
    ],
    [
      "vert",
      0.0375
    ],
    [
      "simple",
      0.0375
    ],
    [
      "pature",
      0.0375
    ],
    [
      "plante",
      0.0375
    ],
    [
      "pelouse",
      0.0375
    ],
    [
      "ivraie",
      0.0375
    ],
    [
      "herbage",
      0.0375
    ],
    [
      "graminee",
      0.0375
    ],
    [
      "fetuque",
      0.0375
    ],
    [
      "fourrage",
      0.0175
    ],
    [
      "hasch",
      0.0175
    ],
    [
      "haschisch",
      0.0175
    ],
    [
      "herbette",
      0.0175
    ],
    [
      "regain",
      0.0175
    ],
    [
      "foin",
      0.0175
    ],
    [
      "dactyle",
      0.0175
    ],
    [
      "chiendent",
      0.0175
    ],
    [
      "champ",
      0.0175
    ],
    [
      "brome",
      0.0175
    ],
    [
      "boulingrin",
      0.0175
    ],
    [
      "aromate",
      0.0175
    ],
    [
      "andain",
      0.0175
    ],
    [
      "alpage",
      0.0175
    ],
    [
      "savane",
      0.0175
    ]
  ],
  "limite": [
    [
      "frontiere",
      0.0925
    ],
    [
      "bord",
      0.065
    ],
    [
      "borne",
      0.0575
    ],
    [
      "extremite",
      0.0575
    ],
    [
      "bordure",
      0.05
    ],
    [
      "contour",
      0.05
    ],
    [
      "lisiere",
      0.0425
    ],
    [
      "terme",
      0.035
    ],
    [
      "demarcation",
      0.035
    ],
    [
      "delimitation",
      0.035
    ],
    [
      "limitation",
      0.0275
    ],
    [
      "separation",
      0.02
    ],
    [
      "perimetre",
      0.02
    ],
    [
      "maximum",
      0.02
    ],
    [
      "ligne",
      0.02
    ],
    [
      "extreme",
      0.02
    ],
    [
      "enceinte",
      0.02
    ],
    [
      "commencement",
      0.02
    ],
    [
      "comble",
      0.02
    ],
    [
      "cercle",
      0.02
    ],
    [
      "cadre",
      0.02
    ],
    [
      "summum",
      0.0125
    ],
    [
      "seuil",
      0.0125
    ],
    [
      "oree",
      0.0125
    ],
    [
      "frein",
      0.0125
    ],
    [
      "fin",
      0.0125
    ],
    [
      "circuit",
      0.0125
    ],
    [
      "bout",
      0.0125
    ],
    [
      "barriere",
      0.0125
    ],
    [
      "interface",
      0.005
    ],
    [
      "marche",
      0.005
    ],
    [
      "mesure",
      0.005
    ],
    [
      "minimum",
      0.005
    ],
    [
      "plafond",
      0.005
    ],
    [
      "possibilite",
      0.005
    ],
    [
      "restriction",
      0.005
    ],
    [
      "faite",
      0.005
    ],
    [
      "entrave",
      0.005
    ],
    [
      "deficience",
      0.005
    ],
    [
      "debut",
      0.005
    ],
    [
      "domaine",
      0.005
    ],
    [
      "confins",
      0.005
    ],
    [
      "circonscription",
      0.005
    ],
    [
      "bornage",
      0.005
    ],
    [
      "sphere",
      0.005
    ]
  ],
  "limiter": [
    [
      "borner",
      0.135
    ],
    [
      "restreindre",
      0.1025
    ],
    [
      "circonscrire",
      0.0725
    ],
    [
      "arreter",
      0.0625
    ],
    [
      "moderer",
      0.0625
    ],
    [
      "renfermer",
      0.05
    ],
    [
      "reduire",
      0.04
    ],
    [
      "freiner",
      0.04
    ],
    [
      "delimiter",
      0.04
    ],
    [
      "diminuer",
      0.04
    ],
    [
      "temperer",
      0.03
    ],
    [
      "fixer",
      0.03
    ],
    [
      "enfermer",
      0.03
    ],
    [
      "determiner",
      0.03
    ],
    [
      "contenir",
      0.03
    ],
    [
      "retrecir",
      0.02
    ],
    [
      "marquer",
      0.02
    ],
    [
      "localiser",
      0.02
    ],
    [
      "gener",
      0.02
    ],
    [
      "cerner",
      0.02
    ],
    [
      "separer",
      0.01
    ],
    [
      "reguler",
      0.01
    ],
    [
      "demarquer",
      0.01
    ],
    [
      "contingenter",
      0.01
    ],
    [
      "cantonner",
      0.01
    ],
    [
      "boucher",
      0.01
    ],
    [
      "border",
      0.01
    ],
    [
      "abreger",
      0.01
    ],
    [
      "terminer",
      0.01
    ]
  ],
  "regner": [
    [
      "dominer",
      0.16
    ],
    [
      "maitriser",
      0.16
    ],
    [
      "dompter",
      0.14
    ],
    [
      "commander",
      0.0775
    ],
    [
      "asservir",
      0.06
    ],
    [
      "mater",
      0.06
    ],
    [
      "triompher",
      0.06
    ],
    [
      "regir",
      0.0375
    ],
    [
      "gouverner",
      0.0375
    ],
    [
      "exister",
      0.0375
    ],
    [
      "controler",
      0.0175
    ],
    [
      "habiter",
      0.0175
    ],
    [
      "primer",
      0.0175
    ],
    [
      "predominer",
      0.0175
    ],
    [
      "prevaloir",
      0.0175
    ],
    [
      "regenter",
      0.0175
    ],
    [
      "s'etendre",
      0.0175
    ],
    [
      "etre",
      0.0175
    ]
  ],
  "regne": [
    [
      "empire",
      0.1625
    ],
    [
      "pouvoir",
      0.1625
    ],
    [
      "monarchie",
      0.095
    ],
    [
      "royaume",
      0.095
    ],
    [
      "trone",
      0.095
    ],
    [
      "univers",
      0.0625
    ],
    [
      "souverainete",
      0.0625
    ],
    [
      "gouvernement",
      0.0625
    ],
    [
      "dynastie",
      0.03
    ],
    [
      "emprise",
      0.03
    ],
    [
      "monde",
      0.03
    ],
    [
      "prestige",
      0.03
    ],
    [
      "predominance",
      0.03
    ],
    [
      "epoque",
      0.03
    ]
  ],
  "telle": [
    [
      "semblable",
      0.2725
    ],
    [
      "pareil",
      0.18
    ],
    [
      "assimile",
      0.09
    ],
    [
      "celui",
      0.09
    ],
    [
      "certain",
      0.09
    ],
    [
      "comme",
      0.09
    ],
    [
      "meme",
      0.09
    ],
    [
      "quelqu'un",
      0.09
    ]
  ],
  "fierte": [
    [
      "orgueil",
      0.105
    ],
    [
      "superbe",
      0.09
    ],
    [
      "arrogance",
      0.0825
    ],
    [
      "outrecuidance",
      0.0725
    ],
    [
      "hauteur",
      0.0675
    ],
    [
      "morgue",
      0.06
    ],
    [
      "suffisance",
      0.06
    ],
    [
      "dedain",
      0.045
    ],
    [
      "pretention",
      0.035
    ],
    [
      "vanite",
      0.035
    ],
    [
      "dignite",
      0.0275
    ],
    [
      "presomption",
      0.0275
    ],
    [
      "superiorite",
      0.0275
    ],
    [
      "roguerie",
      0.0225
    ],
    [
      "hardiesse",
      0.0225
    ],
    [
      "cranerie",
      0.0225
    ],
    [
      "audace",
      0.0225
    ],
    [
      "satisfaction",
      0.0125
    ],
    [
      "noblesse",
      0.0125
    ],
    [
      "infatuation",
      0.0125
    ],
    [
      "honneur",
      0.0125
    ],
    [
      "gloire",
      0.0125
    ],
    [
      "estime",
      0.0125
    ],
    [
      "condescendance",
      0.0125
    ],
    [
      "contentement",
      0.005
    ],
    [
      "gloriole",
      0.005
    ],
    [
      "impetuosite",
      0.005
    ],
    [
      "joie",
      0.005
    ],
    [
      "reserve",
      0.005
    ]
  ],
  "couchant": [
    [
      "crepuscule",
      0.2
    ],
    [
      "declin",
      0.2
    ],
    [
      "decadence",
      0.1325
    ],
    [
      "soir",
      0.1325
    ],
    [
      "coucher",
      0.065
    ],
    [
      "decrepitude",
      0.065
    ],
    [
      "occident",
      0.065
    ],
    [
      "ouest",
      0.065
    ],
    [
      "ponant",
      0.065
    ]
  ],
  "ferocite": [
    [
      "cruaute",
      0.1725
    ],
    [
      "brutalite",
      0.0925
    ],
    [
      "inhumanite",
      0.0925
    ],
    [
      "violence",
      0.0525
    ],
    [
      "sauvagerie",
      0.0525
    ],
    [
      "horreur",
      0.0525
    ],
    [
      "fureur",
      0.0525
    ],
    [
      "durete",
      0.0525
    ],
    [
      "barbarie",
      0.0525
    ],
    [
      "atrocite",
      0.0525
    ],
    [
      "mechancete",
      0.0375
    ],
    [
      "haine",
      0.0375
    ],
    [
      "acharnement",
      0.0375
    ],
    [
      "frenesie",
      0.025
    ],
    [
      "monstruosite",
      0.025
    ],
    [
      "sadisme",
      0.025
    ],
    [
      "bestialite",
      0.0125
    ],
    [
      "cannibalisme",
      0.0125
    ],
    [
      "insensibilite",
      0.0125
    ],
    [
      "rage",
      0.0125
    ],
    [
      "tyrannie",
      0.0125
    ]
  ],
  "extreme": [
    [
      "excessif",
      0.1025
    ],
    [
      "grand",
      0.1025
    ],
    [
      "extraordinaire",
      0.065
    ],
    [
      "violent",
      0.055
    ],
    [
      "demesure",
      0.05
    ],
    [
      "fou",
      0.045
    ],
    [
      "fort",
      0.04
    ],
    [
      "haut",
      0.03
    ],
    [
      "exagere",
      0.03
    ],
    [
      "furieux",
      0.0275
    ],
    [
      "immense",
      0.0275
    ],
    [
      "supreme",
      0.0275
    ],
    [
      "intense",
      0.0225
    ],
    [
      "outre",
      0.0175
    ],
    [
      "infini",
      0.0175
    ],
    [
      "extremite",
      0.0175
    ],
    [
      "dernier",
      0.0175
    ],
    [
      "comble",
      0.0175
    ],
    [
      "epouvantable",
      0.0125
    ],
    [
      "eperdu",
      0.0125
    ],
    [
      "limite",
      0.0125
    ],
    [
      "immodere",
      0.0125
    ],
    [
      "final",
      0.0125
    ],
    [
      "desespere",
      0.0125
    ],
    [
      "ultime",
      0.0075
    ],
    [
      "sommet",
      0.0075
    ],
    [
      "profond",
      0.0075
    ],
    [
      "oppose",
      0.0075
    ],
    [
      "heroique",
      0.0075
    ],
    [
      "horrible",
      0.0075
    ],
    [
      "exces",
      0.0075
    ],
    [
      "contraire",
      0.0075
    ],
    [
      "bout",
      0.0075
    ],
    [
      "affreux",
      0.0075
    ],
    [
      "glacial",
      0.0025
    ],
    [
      "hasardeux",
      0.0025
    ],
    [
      "inoui",
      0.0025
    ],
    [
      "intensif",
      0.0025
    ],
    [
      "mortel",
      0.0025
    ],
    [
      "particulier",
      0.0025
    ],
    [
      "passionne",
      0.0025
    ],
    [
      "risque",
      0.0025
    ],
    [
      "extremiste",
      0.0025
    ],
    [
      "exquis",
      0.0025
    ],
    [
      "acheve",
      0.0025
    ],
    [
      "antipode",
      0.0025
    ],
    [
      "borne",
      0.0025
    ],
    [
      "disproportionne",
      0.0025
    ],
    [
      "definitif",
      0.0025
    ],
    [
      "desordonne",
      0.0025
    ],
    [
      "exaspere",
      0.0025
    ],
    [
      "exceptionnel",
      0.0025
    ],
    [
      "terminal",
      0.0025
    ]
  ],
  "acharnement": [
    [
      "ardeur",
      0.11
    ],
    [
      "fureur",
      0.11
    ],
    [
      "frenesie",
      0.09
    ],
    [
      "haine",
      0.0725
    ],
    [
      "opiniatrete",
      0.055
    ],
    [
      "ferocite",
      0.055
    ],
    [
      "entetement",
      0.055
    ],
    [
      "energie",
      0.035
    ],
    [
      "rage",
      0.035
    ],
    [
      "perseverance",
      0.035
    ],
    [
      "mal",
      0.035
    ],
    [
      "furie",
      0.035
    ],
    [
      "fanatisme",
      0.035
    ],
    [
      "effort",
      0.035
    ],
    [
      "cruaute",
      0.035
    ],
    [
      "bouillonnement",
      0.035
    ],
    [
      "animosite",
      0.035
    ],
    [
      "obstination",
      0.0175
    ],
    [
      "lutte",
      0.0175
    ],
    [
      "excitation",
      0.0175
    ],
    [
      "aveuglement",
      0.0175
    ],
    [
      "tenacite",
      0.0175
    ]
  ],
  "enterre": [
    [
      "engloutir",
      0.115
    ],
    [
      "detruire",
      0.075
    ],
    [
      "ensevelir",
      0.075
    ],
    [
      "inhumer",
      0.075
    ],
    [
      "etouffer",
      0.0575
    ],
    [
      "submerger",
      0.0575
    ],
    [
      "enfouir",
      0.0575
    ],
    [
      "cacher",
      0.0575
    ],
    [
      "aneantir",
      0.0575
    ],
    [
      "enfoncer",
      0.0375
    ],
    [
      "claquemurer",
      0.0375
    ],
    [
      "terrer",
      0.0175
    ],
    [
      "sequestrer",
      0.0175
    ],
    [
      "survivre",
      0.0175
    ],
    [
      "reclure",
      0.0175
    ],
    [
      "oublier",
      0.0175
    ],
    [
      "obscurcir",
      0.0175
    ],
    [
      "entomber",
      0.0175
    ],
    [
      "detroner",
      0.0175
    ],
    [
      "cloitrer",
      0.0175
    ],
    [
      "classer",
      0.0175
    ],
    [
      "abandonner",
      0.0175
    ],
    [
      "torpiller",
      0.0175
    ]
  ],
  "enterrer": [
    [
      "engloutir",
      0.115
    ],
    [
      "detruire",
      0.075
    ],
    [
      "ensevelir",
      0.075
    ],
    [
      "inhumer",
      0.075
    ],
    [
      "etouffer",
      0.0575
    ],
    [
      "submerger",
      0.0575
    ],
    [
      "enfouir",
      0.0575
    ],
    [
      "cacher",
      0.0575
    ],
    [
      "aneantir",
      0.0575
    ],
    [
      "enfoncer",
      0.0375
    ],
    [
      "claquemurer",
      0.0375
    ],
    [
      "terrer",
      0.0175
    ],
    [
      "sequestrer",
      0.0175
    ],
    [
      "survivre",
      0.0175
    ],
    [
      "reclure",
      0.0175
    ],
    [
      "oublier",
      0.0175
    ],
    [
      "obscurcir",
      0.0175
    ],
    [
      "entomber",
      0.0175
    ],
    [
      "detroner",
      0.0175
    ],
    [
      "cloitrer",
      0.0175
    ],
    [
      "classer",
      0.0175
    ],
    [
      "abandonner",
      0.0175
    ],
    [
      "torpiller",
      0.0175
    ]
  ],
  "corner": [
    [
      "societe",
      0.5
    ],
    [
      "trust",
      0.5
    ]
  ],
  "corne": [
    [
      "cor",
      0.1825
    ],
    [
      "bois",
      0.0775
    ],
    [
      "ramure",
      0.0775
    ],
    [
      "trompe",
      0.05
    ],
    [
      "cornet",
      0.05
    ],
    [
      "coin",
      0.05
    ],
    [
      "branche",
      0.05
    ],
    [
      "angle",
      0.05
    ],
    [
      "saillie",
      0.025
    ],
    [
      "rhyton",
      0.025
    ],
    [
      "rameau",
      0.025
    ],
    [
      "pli",
      0.025
    ],
    [
      "perche",
      0.025
    ],
    [
      "oreille",
      0.025
    ],
    [
      "keratine",
      0.025
    ],
    [
      "defense",
      0.025
    ],
    [
      "chataigne",
      0.025
    ],
    [
      "callosite",
      0.025
    ],
    [
      "bugle",
      0.025
    ],
    [
      "bouquin",
      0.025
    ],
    [
      "avertisseur",
      0.025
    ],
    [
      "andouiller",
      0.025
    ],
    [
      "serricorne",
      0.025
    ]
  ],
  "horde": [
    [
      "bande",
      0.125
    ],
    [
      "multitude",
      0.125
    ],
    [
      "troupe",
      0.095
    ],
    [
      "peuple",
      0.0825
    ],
    [
      "troupeau",
      0.0825
    ],
    [
      "meute",
      0.0675
    ],
    [
      "harde",
      0.055
    ],
    [
      "foule",
      0.04
    ],
    [
      "masse",
      0.04
    ],
    [
      "tribu",
      0.04
    ],
    [
      "sarabande",
      0.0275
    ],
    [
      "nuee",
      0.0275
    ],
    [
      "legion",
      0.0275
    ],
    [
      "compagnie",
      0.0275
    ],
    [
      "colonie",
      0.0275
    ],
    [
      "cohorte",
      0.0275
    ],
    [
      "clan",
      0.0275
    ],
    [
      "cohue",
      0.0125
    ],
    [
      "peuplade",
      0.0125
    ],
    [
      "ramassis",
      0.0125
    ]
  ],
  "appartenir": [
    [
      "ressortir",
      0.1125
    ],
    [
      "convenir",
      0.085
    ],
    [
      "dependre",
      0.085
    ],
    [
      "revenir",
      0.085
    ],
    [
      "concerner",
      0.055
    ],
    [
      "etre",
      0.025
    ],
    [
      "tenir",
      0.025
    ],
    [
      "seoir",
      0.025
    ],
    [
      "incomber",
      0.025
    ],
    [
      "devoir",
      0.025
    ],
    [
      "competer",
      0.025
    ],
    [
      "attenir",
      0.025
    ]
  ],
  "ecarte": [
    [
      "chasser",
      0.075
    ],
    [
      "exclure",
      0.065
    ],
    [
      "eloigner",
      0.065
    ],
    [
      "renvoyer",
      0.0375
    ],
    [
      "separer",
      0.0375
    ],
    [
      "eliminer",
      0.0375
    ],
    [
      "supprimer",
      0.035
    ],
    [
      "repousser",
      0.035
    ],
    [
      "bannir",
      0.035
    ],
    [
      "rejeter",
      0.0325
    ],
    [
      "oter",
      0.0325
    ],
    [
      "balayer",
      0.02
    ],
    [
      "detourner",
      0.02
    ],
    [
      "eviter",
      0.0175
    ],
    [
      "refuser",
      0.0175
    ],
    [
      "proscrire",
      0.0175
    ],
    [
      "detacher",
      0.0175
    ],
    [
      "diviser",
      0.0175
    ],
    [
      "congedier",
      0.0175
    ],
    [
      "arracher",
      0.0175
    ],
    [
      "disjoindre",
      0.0125
    ],
    [
      "dissiper",
      0.0125
    ],
    [
      "exiler",
      0.0125
    ],
    [
      "remercier",
      0.01
    ],
    [
      "passer",
      0.01
    ],
    [
      "negliger",
      0.01
    ],
    [
      "isoler",
      0.01
    ],
    [
      "empecher",
      0.01
    ],
    [
      "desunir",
      0.01
    ],
    [
      "evincer",
      0.0075
    ],
    [
      "refouler",
      0.0075
    ],
    [
      "partir",
      0.0075
    ],
    [
      "ouvrir",
      0.0075
    ],
    [
      "excepter",
      0.0075
    ],
    [
      "escamoter",
      0.0075
    ],
    [
      "devier",
      0.0075
    ],
    [
      "changer",
      0.0075
    ],
    [
      "disperser",
      0.0075
    ],
    [
      "distancer",
      0.0075
    ],
    [
      "decliner",
      0.0075
    ],
    [
      "derouter",
      0.0075
    ],
    [
      "egarer",
      0.005
    ],
    [
      "soulever",
      0.005
    ],
    [
      "retourner",
      0.005
    ],
    [
      "releguer",
      0.005
    ],
    [
      "relever",
      0.005
    ],
    [
      "partager",
      0.005
    ],
    [
      "lever",
      0.005
    ],
    [
      "fendre",
      0.005
    ],
    [
      "espacer",
      0.005
    ],
    [
      "retrousser",
      0.0025
    ],
    [
      "s'aliener",
      0.0025
    ],
    [
      "trousser",
      0.0025
    ],
    [
      "devoyer",
      0.0025
    ],
    [
      "desassembler",
      0.0025
    ],
    [
      "debarquer",
      0.0025
    ],
    [
      "dissuader",
      0.0025
    ],
    [
      "desserrer",
      0.0025
    ],
    [
      "ecarquiller",
      0.0025
    ]
  ],
  "miser": [
    [
      "ponter",
      0.2
    ],
    [
      "jouer",
      0.12
    ],
    [
      "risquer",
      0.12
    ],
    [
      "placer",
      0.08
    ],
    [
      "parier",
      0.08
    ],
    [
      "gager",
      0.08
    ],
    [
      "coucher",
      0.08
    ],
    [
      "boursicoter",
      0.08
    ],
    [
      "agioter",
      0.04
    ],
    [
      "allonger",
      0.04
    ],
    [
      "caver",
      0.04
    ],
    [
      "mettre",
      0.04
    ]
  ],
  "mise": [
    [
      "placer",
      0.0875
    ],
    [
      "poser",
      0.0475
    ],
    [
      "appliquer",
      0.0375
    ],
    [
      "ficher",
      0.0325
    ],
    [
      "coller",
      0.0275
    ],
    [
      "situer",
      0.0275
    ],
    [
      "fixer",
      0.0275
    ],
    [
      "etablir",
      0.025
    ],
    [
      "introduire",
      0.0225
    ],
    [
      "porter",
      0.0225
    ],
    [
      "prendre",
      0.02
    ],
    [
      "fourrer",
      0.02
    ],
    [
      "disposer",
      0.0175
    ],
    [
      "attacher",
      0.0175
    ],
    [
      "installer",
      0.015
    ],
    [
      "camper",
      0.015
    ],
    [
      "tenir",
      0.0125
    ],
    [
      "planter",
      0.0125
    ],
    [
      "passer",
      0.0125
    ],
    [
      "loger",
      0.0125
    ],
    [
      "engager",
      0.0125
    ],
    [
      "caser",
      0.0125
    ],
    [
      "affecter",
      0.0125
    ],
    [
      "etendre",
      0.01
    ],
    [
      "remettre",
      0.01
    ],
    [
      "flanquer",
      0.01
    ],
    [
      "dresser",
      0.01
    ],
    [
      "coucher",
      0.01
    ],
    [
      "consigner",
      0.01
    ],
    [
      "appuyer",
      0.01
    ],
    [
      "marquer",
      0.01
    ],
    [
      "jeter",
      0.01
    ],
    [
      "inscrire",
      0.01
    ],
    [
      "charger",
      0.01
    ],
    [
      "ranger",
      0.0075
    ],
    [
      "employer",
      0.0075
    ],
    [
      "conduire",
      0.0075
    ],
    [
      "asseoir",
      0.0075
    ],
    [
      "arrimer",
      0.0075
    ],
    [
      "arranger",
      0.0075
    ],
    [
      "etaler",
      0.0075
    ],
    [
      "laisser",
      0.0075
    ],
    [
      "foutre",
      0.0075
    ],
    [
      "amener",
      0.0075
    ],
    [
      "mener",
      0.005
    ],
    [
      "noter",
      0.005
    ],
    [
      "plaquer",
      0.005
    ],
    [
      "poster",
      0.005
    ],
    [
      "preparer",
      0.005
    ],
    [
      "serrer",
      0.005
    ],
    [
      "ecrire",
      0.005
    ],
    [
      "imputer",
      0.005
    ],
    [
      "glisser",
      0.005
    ],
    [
      "afficher",
      0.005
    ],
    [
      "apporter",
      0.005
    ],
    [
      "attribuer",
      0.005
    ],
    [
      "classer",
      0.005
    ],
    [
      "deposer",
      0.005
    ],
    [
      "enfiler",
      0.005
    ],
    [
      "enfoncer",
      0.005
    ],
    [
      "verser",
      0.0025
    ],
    [
      "revetir",
      0.0025
    ],
    [
      "manger",
      0.0025
    ],
    [
      "interposer",
      0.0025
    ],
    [
      "inserer",
      0.0025
    ],
    [
      "fricoter",
      0.0025
    ],
    [
      "fonder",
      0.0025
    ],
    [
      "constituer",
      0.0025
    ],
    [
      "consacrer",
      0.0025
    ],
    [
      "adosser",
      0.0025
    ],
    [
      "melanger",
      0.0025
    ],
    [
      "opposer",
      0.0025
    ],
    [
      "plonger",
      0.0025
    ],
    [
      "reduire",
      0.0025
    ],
    [
      "s'habiller",
      0.0025
    ],
    [
      "traduire",
      0.0025
    ],
    [
      "imposer",
      0.0025
    ],
    [
      "immatriculer",
      0.0025
    ],
    [
      "admettre",
      0.0025
    ],
    [
      "attendre",
      0.0025
    ],
    [
      "considerer",
      0.0025
    ],
    [
      "croquer",
      0.0025
    ],
    [
      "emmener",
      0.0025
    ],
    [
      "endosser",
      0.0025
    ],
    [
      "fricasser",
      0.0025
    ],
    [
      "trouver",
      0.0
    ],
    [
      "rajouter",
      0.0
    ],
    [
      "miser",
      0.0
    ],
    [
      "mentionner",
      0.0
    ],
    [
      "garder",
      0.0
    ],
    [
      "empiler",
      0.0
    ],
    [
      "claquer",
      0.0
    ],
    [
      "chausser",
      0.0
    ],
    [
      "bouter",
      0.0
    ],
    [
      "apposer",
      0.0
    ],
    [
      "agrafer",
      0.0
    ],
    [
      "vetir",
      0.0
    ]
  ],
  "couler": [
    [
      "passer",
      0.045
    ],
    [
      "s'ecouler",
      0.0375
    ],
    [
      "suinter",
      0.0375
    ],
    [
      "s'enfoncer",
      0.035
    ],
    [
      "fuir",
      0.0325
    ],
    [
      "courir",
      0.0275
    ],
    [
      "sortir",
      0.0275
    ],
    [
      "tomber",
      0.0275
    ],
    [
      "sombrer",
      0.025
    ],
    [
      "glisser",
      0.025
    ],
    [
      "degouliner",
      0.025
    ],
    [
      "s'echapper",
      0.025
    ],
    [
      "transpirer",
      0.0175
    ],
    [
      "ruisseler",
      0.015
    ],
    [
      "perdre",
      0.015
    ],
    [
      "degoutter",
      0.015
    ],
    [
      "decouler",
      0.015
    ],
    [
      "emaner",
      0.0125
    ],
    [
      "sourdre",
      0.0125
    ],
    [
      "s'enfuir",
      0.0125
    ],
    [
      "filtrer",
      0.0125
    ],
    [
      "filer",
      0.0125
    ],
    [
      "circuler",
      0.0125
    ],
    [
      "echouer",
      0.0125
    ],
    [
      "verser",
      0.0125
    ],
    [
      "traverser",
      0.0125
    ],
    [
      "s'abimer",
      0.0125
    ],
    [
      "ruiner",
      0.0075
    ],
    [
      "rouler",
      0.0075
    ],
    [
      "jaillir",
      0.0075
    ],
    [
      "fondre",
      0.0075
    ],
    [
      "exsuder",
      0.0075
    ],
    [
      "descendre",
      0.0075
    ],
    [
      "emettre",
      0.005
    ],
    [
      "torpiller",
      0.005
    ],
    [
      "tirer",
      0.005
    ],
    [
      "suer",
      0.005
    ],
    [
      "soutirer",
      0.005
    ],
    [
      "s'engouffrer",
      0.005
    ],
    [
      "introduire",
      0.005
    ],
    [
      "affluer",
      0.005
    ],
    [
      "baigner",
      0.005
    ],
    [
      "chavirer",
      0.005
    ],
    [
      "enfoncer",
      0.005
    ],
    [
      "fluer",
      0.005
    ],
    [
      "pisser",
      0.0025
    ],
    [
      "pleuvoir",
      0.0025
    ],
    [
      "s'engloutir",
      0.0025
    ],
    [
      "s'epancher",
      0.0025
    ],
    [
      "transvaser",
      0.0025
    ],
    [
      "vivre",
      0.0025
    ],
    [
      "instiller",
      0.0025
    ],
    [
      "insinuer",
      0.0025
    ],
    [
      "immerger",
      0.0025
    ],
    [
      "arroser",
      0.0025
    ],
    [
      "clarifier",
      0.0025
    ],
    [
      "deborder",
      0.0025
    ],
    [
      "demolir",
      0.0025
    ],
    [
      "engloutir",
      0.0025
    ],
    [
      "extravaser",
      0.0025
    ],
    [
      "gicler",
      0.0025
    ],
    [
      "goutter",
      0.0025
    ],
    [
      "ratiboiser",
      0.0
    ],
    [
      "refluer",
      0.0
    ],
    [
      "rejaillir",
      0.0
    ],
    [
      "risquer",
      0.0
    ],
    [
      "s'immerger",
      0.0
    ],
    [
      "s'egoutter",
      0.0
    ],
    [
      "saborder",
      0.0
    ],
    [
      "saboter",
      0.0
    ],
    [
      "sancir",
      0.0
    ],
    [
      "pleurer",
      0.0
    ],
    [
      "murmurer",
      0.0
    ],
    [
      "avorter",
      0.0
    ],
    [
      "baver",
      0.0
    ],
    [
      "clicher",
      0.0
    ],
    [
      "confluer",
      0.0
    ],
    [
      "coulisser",
      0.0
    ],
    [
      "delayer",
      0.0
    ],
    [
      "devaloriser",
      0.0
    ],
    [
      "lier",
      0.0
    ],
    [
      "mouler",
      0.0
    ]
  ],
  "epargner": [
    [
      "economiser",
      0.095
    ],
    [
      "exempter",
      0.075
    ],
    [
      "garder",
      0.075
    ],
    [
      "preserver",
      0.075
    ],
    [
      "eviter",
      0.055
    ],
    [
      "thesauriser",
      0.055
    ],
    [
      "reserver",
      0.055
    ],
    [
      "menager",
      0.055
    ],
    [
      "conserver",
      0.055
    ],
    [
      "amasser",
      0.055
    ],
    [
      "sauver",
      0.0375
    ],
    [
      "garantir",
      0.0375
    ],
    [
      "excepter",
      0.0375
    ],
    [
      "entasser",
      0.0375
    ],
    [
      "respecter",
      0.0175
    ],
    [
      "oublier",
      0.0175
    ],
    [
      "negliger",
      0.0175
    ],
    [
      "lesiner",
      0.0175
    ],
    [
      "liarder",
      0.0175
    ],
    [
      "gracier",
      0.0175
    ],
    [
      "dispenser",
      0.0175
    ],
    [
      "compter",
      0.0175
    ],
    [
      "accumuler",
      0.0175
    ],
    [
      "eloigner",
      0.0175
    ]
  ],
  "conter": [
    [
      "raconter",
      0.2
    ],
    [
      "exposer",
      0.1425
    ],
    [
      "dire",
      0.1125
    ],
    [
      "retracer",
      0.1125
    ],
    [
      "peindre",
      0.055
    ],
    [
      "narrer",
      0.055
    ],
    [
      "exprimer",
      0.055
    ],
    [
      "decrire",
      0.055
    ],
    [
      "debiter",
      0.055
    ],
    [
      "chanter",
      0.0275
    ],
    [
      "inventer",
      0.0275
    ],
    [
      "rapporter",
      0.0275
    ],
    [
      "relater",
      0.0275
    ],
    [
      "romancer",
      0.0275
    ]
  ],
  "rejoint": [
    [
      "joindre",
      0.1225
    ],
    [
      "retrouver",
      0.1075
    ],
    [
      "atteindre",
      0.09
    ],
    [
      "rallier",
      0.075
    ],
    [
      "revenir",
      0.045
    ],
    [
      "regagner",
      0.045
    ],
    [
      "passer",
      0.045
    ],
    [
      "gagner",
      0.045
    ],
    [
      "adherer",
      0.045
    ],
    [
      "trouver",
      0.03
    ],
    [
      "s'affilier",
      0.03
    ],
    [
      "reunir",
      0.03
    ],
    [
      "rentrer",
      0.03
    ],
    [
      "rencontrer",
      0.03
    ],
    [
      "rattraper",
      0.03
    ],
    [
      "attraper",
      0.03
    ],
    [
      "retourner",
      0.015
    ],
    [
      "renouer",
      0.015
    ],
    [
      "rapprocher",
      0.015
    ],
    [
      "contacter",
      0.015
    ],
    [
      "confluer",
      0.015
    ],
    [
      "tomber",
      0.015
    ]
  ],
  "recharge": [
    [
      "cartouche",
      0.5
    ],
    [
      "rechargement",
      0.5
    ]
  ],
  "recharger": [
    [
      "empierrer",
      0.5
    ],
    [
      "reapprovisionner",
      0.5
    ]
  ],
  "promettre": [
    [
      "affirmer",
      0.0725
    ],
    [
      "declarer",
      0.0725
    ],
    [
      "assurer",
      0.06
    ],
    [
      "jurer",
      0.06
    ],
    [
      "s'engager",
      0.0475
    ],
    [
      "repondre",
      0.0475
    ],
    [
      "presager",
      0.0475
    ],
    [
      "engager",
      0.0475
    ],
    [
      "certifier",
      0.0475
    ],
    [
      "prevoir",
      0.035
    ],
    [
      "preparer",
      0.035
    ],
    [
      "garantir",
      0.035
    ],
    [
      "gager",
      0.035
    ],
    [
      "annoncer",
      0.035
    ],
    [
      "vouer",
      0.0225
    ],
    [
      "predire",
      0.0225
    ],
    [
      "pronostiquer",
      0.0225
    ],
    [
      "offrir",
      0.0225
    ],
    [
      "obliger",
      0.0225
    ],
    [
      "destiner",
      0.0225
    ],
    [
      "augurer",
      0.0225
    ],
    [
      "protester",
      0.01
    ],
    [
      "proposer",
      0.01
    ],
    [
      "fiancer",
      0.01
    ],
    [
      "esperer",
      0.01
    ],
    [
      "appater",
      0.01
    ],
    [
      "accepter",
      0.01
    ],
    [
      "s'obliger",
      0.01
    ]
  ],
  "promis": [
    [
      "affirmer",
      0.0725
    ],
    [
      "declarer",
      0.0725
    ],
    [
      "assurer",
      0.06
    ],
    [
      "jurer",
      0.06
    ],
    [
      "s'engager",
      0.0475
    ],
    [
      "repondre",
      0.0475
    ],
    [
      "presager",
      0.0475
    ],
    [
      "engager",
      0.0475
    ],
    [
      "certifier",
      0.0475
    ],
    [
      "prevoir",
      0.035
    ],
    [
      "preparer",
      0.035
    ],
    [
      "garantir",
      0.035
    ],
    [
      "gager",
      0.035
    ],
    [
      "annoncer",
      0.035
    ],
    [
      "vouer",
      0.0225
    ],
    [
      "predire",
      0.0225
    ],
    [
      "pronostiquer",
      0.0225
    ],
    [
      "offrir",
      0.0225
    ],
    [
      "obliger",
      0.0225
    ],
    [
      "destiner",
      0.0225
    ],
    [
      "augurer",
      0.0225
    ],
    [
      "protester",
      0.01
    ],
    [
      "proposer",
      0.01
    ],
    [
      "fiancer",
      0.01
    ],
    [
      "esperer",
      0.01
    ],
    [
      "appater",
      0.01
    ],
    [
      "accepter",
      0.01
    ],
    [
      "s'obliger",
      0.01
    ]
  ],
  "distancer": [
    [
      "devancer",
      0.1375
    ],
    [
      "passer",
      0.1375
    ],
    [
      "depasser",
      0.085
    ],
    [
      "surpasser",
      0.085
    ],
    [
      "gagner",
      0.0675
    ],
    [
      "ecarter",
      0.05
    ],
    [
      "surclasser",
      0.05
    ],
    [
      "gratter",
      0.05
    ],
    [
      "aller",
      0.05
    ],
    [
      "semer",
      0.0325
    ],
    [
      "preceder",
      0.0325
    ],
    [
      "primer",
      0.0325
    ],
    [
      "lacher",
      0.0325
    ],
    [
      "enfoncer",
      0.0325
    ],
    [
      "courir",
      0.015
    ],
    [
      "disqualifier",
      0.015
    ],
    [
      "decoller",
      0.015
    ],
    [
      "espacer",
      0.015
    ],
    [
      "forlonger",
      0.015
    ],
    [
      "eloigner",
      0.015
    ]
  ],
  "distance": [
    [
      "difference",
      0.0775
    ],
    [
      "espace",
      0.0775
    ],
    [
      "eloignement",
      0.0775
    ],
    [
      "ecart",
      0.0675
    ],
    [
      "intervalle",
      0.0575
    ],
    [
      "profondeur",
      0.0375
    ],
    [
      "etendue",
      0.0375
    ],
    [
      "trajet",
      0.0275
    ],
    [
      "lointain",
      0.0275
    ],
    [
      "distinction",
      0.0275
    ],
    [
      "dissemblance",
      0.0275
    ],
    [
      "amplitude",
      0.0275
    ],
    [
      "elevation",
      0.0175
    ],
    [
      "ecartement",
      0.0175
    ],
    [
      "vide",
      0.0175
    ],
    [
      "parcours",
      0.0175
    ],
    [
      "opposition",
      0.0175
    ],
    [
      "marge",
      0.0175
    ],
    [
      "horizon",
      0.0175
    ],
    [
      "disparite",
      0.0175
    ],
    [
      "course",
      0.0175
    ],
    [
      "chemin",
      0.0175
    ],
    [
      "abime",
      0.0175
    ],
    [
      "absence",
      0.0175
    ],
    [
      "portee",
      0.0075
    ],
    [
      "perimetre",
      0.0075
    ],
    [
      "rayon",
      0.0075
    ],
    [
      "recul",
      0.0075
    ],
    [
      "route",
      0.0075
    ],
    [
      "reprobation",
      0.0075
    ],
    [
      "traite",
      0.0075
    ],
    [
      "nuance",
      0.0075
    ],
    [
      "mepris",
      0.0075
    ],
    [
      "interstice",
      0.0075
    ],
    [
      "froideur",
      0.0075
    ],
    [
      "espacement",
      0.0075
    ],
    [
      "dedain",
      0.0075
    ],
    [
      "declinaison",
      0.0075
    ],
    [
      "disproportion",
      0.0075
    ],
    [
      "discrimination",
      0.0075
    ],
    [
      "aversion",
      0.0075
    ],
    [
      "elongation",
      0.0075
    ]
  ],
  "plexus": [
    [
      "lacis",
      1.0
    ]
  ],
  "excuser": [
    [
      "justifier",
      0.14
    ],
    [
      "pardonner",
      0.095
    ],
    [
      "absoudre",
      0.085
    ],
    [
      "innocenter",
      0.075
    ],
    [
      "disculper",
      0.0625
    ],
    [
      "effacer",
      0.0525
    ],
    [
      "laver",
      0.0425
    ],
    [
      "amnistier",
      0.0425
    ],
    [
      "acquitter",
      0.0425
    ],
    [
      "rehabiliter",
      0.03
    ],
    [
      "remettre",
      0.03
    ],
    [
      "passer",
      0.03
    ],
    [
      "defendre",
      0.03
    ],
    [
      "decharger",
      0.03
    ],
    [
      "blanchir",
      0.03
    ],
    [
      "admettre",
      0.03
    ],
    [
      "exempter",
      0.02
    ],
    [
      "couvrir",
      0.02
    ],
    [
      "alleguer",
      0.01
    ],
    [
      "legitimer",
      0.01
    ],
    [
      "sauver",
      0.01
    ],
    [
      "tolerer",
      0.01
    ]
  ],
  "excuse": [
    [
      "pretexte",
      0.105
    ],
    [
      "raison",
      0.105
    ],
    [
      "echappatoire",
      0.105
    ],
    [
      "reparation",
      0.05
    ],
    [
      "moyen",
      0.05
    ],
    [
      "motif",
      0.05
    ],
    [
      "justification",
      0.05
    ],
    [
      "fuite",
      0.05
    ],
    [
      "defaite",
      0.05
    ],
    [
      "regret",
      0.025
    ],
    [
      "pardon",
      0.025
    ],
    [
      "indulgence",
      0.025
    ],
    [
      "explication",
      0.025
    ],
    [
      "derobade",
      0.025
    ],
    [
      "defense",
      0.025
    ],
    [
      "decharge",
      0.025
    ],
    [
      "disculpation",
      0.025
    ],
    [
      "allegation",
      0.025
    ],
    [
      "ressource",
      0.025
    ]
  ],
  "effet": [
    [
      "consequence",
      0.0975
    ],
    [
      "resultat",
      0.0575
    ],
    [
      "action",
      0.05
    ],
    [
      "contrecoup",
      0.045
    ],
    [
      "suite",
      0.04
    ],
    [
      "choc",
      0.04
    ],
    [
      "fruit",
      0.0275
    ],
    [
      "repercussion",
      0.0275
    ],
    [
      "valeur",
      0.0225
    ],
    [
      "reaction",
      0.0225
    ],
    [
      "ricochet",
      0.0225
    ],
    [
      "rapport",
      0.0225
    ],
    [
      "influence",
      0.0225
    ],
    [
      "accident",
      0.0225
    ],
    [
      "portee",
      0.015
    ],
    [
      "produit",
      0.015
    ],
    [
      "retentissement",
      0.015
    ],
    [
      "realisation",
      0.015
    ],
    [
      "sensation",
      0.015
    ],
    [
      "titre",
      0.015
    ],
    [
      "evenement",
      0.015
    ],
    [
      "incidence",
      0.015
    ],
    [
      "impression",
      0.015
    ],
    [
      "billet",
      0.015
    ],
    [
      "brillant",
      0.015
    ],
    [
      "conclusion",
      0.015
    ],
    [
      "dependance",
      0.015
    ],
    [
      "fin",
      0.015
    ],
    [
      "fonction",
      0.015
    ],
    [
      "impact",
      0.015
    ],
    [
      "eclat",
      0.01
    ],
    [
      "vetement",
      0.01
    ],
    [
      "main",
      0.01
    ],
    [
      "habit",
      0.01
    ],
    [
      "execution",
      0.01
    ],
    [
      "clinquant",
      0.01
    ],
    [
      "atteinte",
      0.01
    ],
    [
      "application",
      0.01
    ],
    [
      "papier",
      0.005
    ],
    [
      "plaisir",
      0.005
    ],
    [
      "rejaillissement",
      0.005
    ],
    [
      "rendement",
      0.005
    ],
    [
      "sentiment",
      0.005
    ],
    [
      "soulagement",
      0.005
    ],
    [
      "surprise",
      0.005
    ],
    [
      "traite",
      0.005
    ],
    [
      "trousseau",
      0.005
    ],
    [
      "montre",
      0.005
    ],
    [
      "mandat",
      0.005
    ],
    [
      "amelioration",
      0.005
    ],
    [
      "comportement",
      0.005
    ],
    [
      "corollaire",
      0.005
    ],
    [
      "defroque",
      0.005
    ],
    [
      "empire",
      0.005
    ],
    [
      "fille",
      0.005
    ],
    [
      "fils",
      0.005
    ],
    [
      "fringue",
      0.005
    ],
    [
      "harde",
      0.005
    ],
    [
      "vertu",
      0.005
    ]
  ],
  "cerveau": [
    [
      "esprit",
      0.125
    ],
    [
      "tete",
      0.1075
    ],
    [
      "entendement",
      0.09
    ],
    [
      "intelligence",
      0.0725
    ],
    [
      "ame",
      0.0725
    ],
    [
      "raison",
      0.0525
    ],
    [
      "coeur",
      0.0525
    ],
    [
      "visionnaire",
      0.035
    ],
    [
      "responsable",
      0.035
    ],
    [
      "jugement",
      0.035
    ],
    [
      "genie",
      0.035
    ],
    [
      "cervelle",
      0.035
    ],
    [
      "centre",
      0.035
    ],
    [
      "prophete",
      0.0175
    ],
    [
      "meninges",
      0.0175
    ],
    [
      "meneur",
      0.0175
    ],
    [
      "jugeote",
      0.0175
    ],
    [
      "foyer",
      0.0175
    ],
    [
      "encephale",
      0.0175
    ],
    [
      "crane",
      0.0175
    ],
    [
      "ciboulot",
      0.0175
    ],
    [
      "auteur",
      0.0175
    ]
  ],
  "agite": [
    [
      "remuer",
      0.1025
    ],
    [
      "troubler",
      0.07
    ],
    [
      "secouer",
      0.0575
    ],
    [
      "emouvoir",
      0.0425
    ],
    [
      "exciter",
      0.0375
    ],
    [
      "ebranler",
      0.0325
    ],
    [
      "bouleverser",
      0.0325
    ],
    [
      "battre",
      0.0325
    ],
    [
      "inquieter",
      0.0275
    ],
    [
      "touiller",
      0.0275
    ],
    [
      "travailler",
      0.0275
    ],
    [
      "tourmenter",
      0.025
    ],
    [
      "balancer",
      0.025
    ],
    [
      "alarmer",
      0.025
    ],
    [
      "affoler",
      0.025
    ],
    [
      "mouvoir",
      0.02
    ],
    [
      "enflammer",
      0.0175
    ],
    [
      "enfievrer",
      0.015
    ],
    [
      "brandiller",
      0.015
    ],
    [
      "ballotter",
      0.015
    ],
    [
      "brouiller",
      0.0125
    ],
    [
      "soulever",
      0.0125
    ],
    [
      "transporter",
      0.01
    ],
    [
      "traiter",
      0.01
    ],
    [
      "tracasser",
      0.01
    ],
    [
      "preoccuper",
      0.01
    ],
    [
      "manier",
      0.01
    ],
    [
      "branler",
      0.01
    ],
    [
      "echauffer",
      0.0075
    ],
    [
      "revolutionner",
      0.0075
    ],
    [
      "melanger",
      0.0075
    ],
    [
      "examiner",
      0.0075
    ],
    [
      "effrayer",
      0.0075
    ],
    [
      "debattre",
      0.0075
    ],
    [
      "discuter",
      0.0075
    ],
    [
      "brasser",
      0.0075
    ],
    [
      "bousculer",
      0.0075
    ],
    [
      "angoisser",
      0.0075
    ],
    [
      "meler",
      0.005
    ],
    [
      "occuper",
      0.005
    ],
    [
      "paniquer",
      0.005
    ],
    [
      "perturber",
      0.005
    ],
    [
      "retourner",
      0.005
    ],
    [
      "soumettre",
      0.005
    ],
    [
      "epouvanter",
      0.005
    ],
    [
      "jouer",
      0.005
    ],
    [
      "gigoter",
      0.005
    ],
    [
      "gauler",
      0.005
    ],
    [
      "animer",
      0.005
    ],
    [
      "bouger",
      0.005
    ],
    [
      "bouler",
      0.005
    ],
    [
      "cahoter",
      0.005
    ],
    [
      "dodeliner",
      0.005
    ],
    [
      "enthousiasmer",
      0.005
    ],
    [
      "flotter",
      0.005
    ],
    [
      "fretiller",
      0.0025
    ],
    [
      "gambiller",
      0.0025
    ],
    [
      "gesticuler",
      0.0025
    ],
    [
      "hocher",
      0.0025
    ],
    [
      "parlementer",
      0.0025
    ],
    [
      "proposer",
      0.0025
    ],
    [
      "revolter",
      0.0025
    ],
    [
      "terrifier",
      0.0025
    ],
    [
      "envahir",
      0.0025
    ],
    [
      "accidenter",
      0.0025
    ],
    [
      "ameuter",
      0.0025
    ],
    [
      "analyser",
      0.0025
    ],
    [
      "atteindre",
      0.0025
    ],
    [
      "avancer",
      0.0025
    ],
    [
      "bercer",
      0.0025
    ],
    [
      "brandir",
      0.0025
    ],
    [
      "convulser",
      0.0025
    ],
    [
      "embraser",
      0.0025
    ],
    [
      "torturer",
      0.0025
    ]
  ],
  "agiter": [
    [
      "remuer",
      0.1025
    ],
    [
      "troubler",
      0.07
    ],
    [
      "secouer",
      0.0575
    ],
    [
      "emouvoir",
      0.0425
    ],
    [
      "exciter",
      0.0375
    ],
    [
      "ebranler",
      0.0325
    ],
    [
      "bouleverser",
      0.0325
    ],
    [
      "battre",
      0.0325
    ],
    [
      "inquieter",
      0.0275
    ],
    [
      "touiller",
      0.0275
    ],
    [
      "travailler",
      0.0275
    ],
    [
      "tourmenter",
      0.025
    ],
    [
      "balancer",
      0.025
    ],
    [
      "alarmer",
      0.025
    ],
    [
      "affoler",
      0.025
    ],
    [
      "mouvoir",
      0.02
    ],
    [
      "enflammer",
      0.0175
    ],
    [
      "enfievrer",
      0.015
    ],
    [
      "brandiller",
      0.015
    ],
    [
      "ballotter",
      0.015
    ],
    [
      "brouiller",
      0.0125
    ],
    [
      "soulever",
      0.0125
    ],
    [
      "transporter",
      0.01
    ],
    [
      "traiter",
      0.01
    ],
    [
      "tracasser",
      0.01
    ],
    [
      "preoccuper",
      0.01
    ],
    [
      "manier",
      0.01
    ],
    [
      "branler",
      0.01
    ],
    [
      "echauffer",
      0.0075
    ],
    [
      "revolutionner",
      0.0075
    ],
    [
      "melanger",
      0.0075
    ],
    [
      "examiner",
      0.0075
    ],
    [
      "effrayer",
      0.0075
    ],
    [
      "debattre",
      0.0075
    ],
    [
      "discuter",
      0.0075
    ],
    [
      "brasser",
      0.0075
    ],
    [
      "bousculer",
      0.0075
    ],
    [
      "angoisser",
      0.0075
    ],
    [
      "meler",
      0.005
    ],
    [
      "occuper",
      0.005
    ],
    [
      "paniquer",
      0.005
    ],
    [
      "perturber",
      0.005
    ],
    [
      "retourner",
      0.005
    ],
    [
      "soumettre",
      0.005
    ],
    [
      "epouvanter",
      0.005
    ],
    [
      "jouer",
      0.005
    ],
    [
      "gigoter",
      0.005
    ],
    [
      "gauler",
      0.005
    ],
    [
      "animer",
      0.005
    ],
    [
      "bouger",
      0.005
    ],
    [
      "bouler",
      0.005
    ],
    [
      "cahoter",
      0.005
    ],
    [
      "dodeliner",
      0.005
    ],
    [
      "enthousiasmer",
      0.005
    ],
    [
      "flotter",
      0.005
    ],
    [
      "fretiller",
      0.0025
    ],
    [
      "gambiller",
      0.0025
    ],
    [
      "gesticuler",
      0.0025
    ],
    [
      "hocher",
      0.0025
    ],
    [
      "parlementer",
      0.0025
    ],
    [
      "proposer",
      0.0025
    ],
    [
      "revolter",
      0.0025
    ],
    [
      "terrifier",
      0.0025
    ],
    [
      "envahir",
      0.0025
    ],
    [
      "accidenter",
      0.0025
    ],
    [
      "ameuter",
      0.0025
    ],
    [
      "analyser",
      0.0025
    ],
    [
      "atteindre",
      0.0025
    ],
    [
      "avancer",
      0.0025
    ],
    [
      "bercer",
      0.0025
    ],
    [
      "brandir",
      0.0025
    ],
    [
      "convulser",
      0.0025
    ],
    [
      "embraser",
      0.0025
    ],
    [
      "torturer",
      0.0025
    ]
  ],
  "honnete": [
    [
      "bon",
      0.0875
    ],
    [
      "correct",
      0.0625
    ],
    [
      "convenable",
      0.055
    ],
    [
      "juste",
      0.0375
    ],
    [
      "beau",
      0.03
    ],
    [
      "sortable",
      0.03
    ],
    [
      "probe",
      0.0275
    ],
    [
      "pur",
      0.025
    ],
    [
      "honorable",
      0.025
    ],
    [
      "bien",
      0.025
    ],
    [
      "decent",
      0.0225
    ],
    [
      "digne",
      0.02
    ],
    [
      "regulier",
      0.02
    ],
    [
      "poli",
      0.02
    ],
    [
      "vertueux",
      0.0175
    ],
    [
      "delicat",
      0.0175
    ],
    [
      "droit",
      0.0175
    ],
    [
      "serieux",
      0.0175
    ],
    [
      "raisonnable",
      0.0175
    ],
    [
      "fidele",
      0.0175
    ],
    [
      "exact",
      0.0175
    ],
    [
      "propre",
      0.015
    ],
    [
      "loyal",
      0.015
    ],
    [
      "distingue",
      0.0125
    ],
    [
      "reserve",
      0.0125
    ],
    [
      "sage",
      0.0125
    ],
    [
      "seyant",
      0.0125
    ],
    [
      "solide",
      0.01
    ],
    [
      "moral",
      0.01
    ],
    [
      "gracieux",
      0.01
    ],
    [
      "irreprochable",
      0.01
    ],
    [
      "meritant",
      0.01
    ],
    [
      "net",
      0.01
    ],
    [
      "pudique",
      0.01
    ],
    [
      "respectable",
      0.01
    ],
    [
      "retenu",
      0.0075
    ],
    [
      "franc",
      0.0075
    ],
    [
      "consciencieux",
      0.0075
    ],
    [
      "bienseant",
      0.0075
    ],
    [
      "acceptable",
      0.0075
    ],
    [
      "satisfaisant",
      0.0075
    ],
    [
      "modeste",
      0.0075
    ],
    [
      "estimable",
      0.0075
    ],
    [
      "courtois",
      0.0075
    ],
    [
      "scrupuleux",
      0.005
    ],
    [
      "passable",
      0.005
    ],
    [
      "normal",
      0.005
    ],
    [
      "meritoire",
      0.005
    ],
    [
      "moyen",
      0.005
    ],
    [
      "louable",
      0.005
    ],
    [
      "integre",
      0.005
    ],
    [
      "civil",
      0.005
    ],
    [
      "chaste",
      0.005
    ],
    [
      "galant",
      0.005
    ],
    [
      "suffisant",
      0.005
    ],
    [
      "equitable",
      0.0025
    ],
    [
      "naturel",
      0.0025
    ],
    [
      "affable",
      0.0025
    ],
    [
      "supportable",
      0.0
    ],
    [
      "range",
      0.0
    ],
    [
      "prude",
      0.0
    ],
    [
      "prud'homme",
      0.0
    ],
    [
      "mettable",
      0.0
    ],
    [
      "legal",
      0.0
    ],
    [
      "desinteresse",
      0.0
    ],
    [
      "brave",
      0.0
    ],
    [
      "accompli",
      0.0
    ],
    [
      "incorruptible",
      0.0
    ],
    [
      "honorifique",
      0.0
    ],
    [
      "confortable",
      0.0
    ],
    [
      "avouable",
      0.0
    ],
    [
      "licite",
      0.0
    ]
  ],
  "atteindre": [
    [
      "toucher",
      0.1075
    ],
    [
      "frapper",
      0.04
    ],
    [
      "attaquer",
      0.0375
    ],
    [
      "saisir",
      0.0375
    ],
    [
      "arriver",
      0.035
    ],
    [
      "gagner",
      0.035
    ],
    [
      "emouvoir",
      0.0325
    ],
    [
      "ebranler",
      0.0275
    ],
    [
      "prendre",
      0.0275
    ],
    [
      "bouleverser",
      0.0275
    ],
    [
      "blesser",
      0.0275
    ],
    [
      "attraper",
      0.0275
    ],
    [
      "heurter",
      0.025
    ],
    [
      "parvenir",
      0.025
    ],
    [
      "troubler",
      0.025
    ],
    [
      "joindre",
      0.0225
    ],
    [
      "piquer",
      0.0225
    ],
    [
      "penetrer",
      0.02
    ],
    [
      "alterer",
      0.02
    ],
    [
      "affecter",
      0.02
    ],
    [
      "aller",
      0.0175
    ],
    [
      "monter",
      0.0175
    ],
    [
      "rejoindre",
      0.015
    ],
    [
      "rencontrer",
      0.015
    ],
    [
      "trouver",
      0.0125
    ],
    [
      "percer",
      0.0125
    ],
    [
      "detruire",
      0.0125
    ],
    [
      "accoster",
      0.0125
    ],
    [
      "aborder",
      0.0125
    ],
    [
      "abattre",
      0.0125
    ],
    [
      "s'elever",
      0.01
    ],
    [
      "retrouver",
      0.01
    ],
    [
      "remuer",
      0.01
    ],
    [
      "porter",
      0.01
    ],
    [
      "offenser",
      0.01
    ],
    [
      "choquer",
      0.01
    ],
    [
      "acceder",
      0.01
    ],
    [
      "aboutir",
      0.01
    ],
    [
      "affaiblir",
      0.0075
    ],
    [
      "leser",
      0.0075
    ],
    [
      "realiser",
      0.0075
    ],
    [
      "endommager",
      0.005
    ],
    [
      "contacter",
      0.005
    ],
    [
      "compromettre",
      0.005
    ],
    [
      "affliger",
      0.005
    ],
    [
      "accomplir",
      0.005
    ],
    [
      "egaler",
      0.0025
    ],
    [
      "rattraper",
      0.0025
    ],
    [
      "gravir",
      0.0025
    ],
    [
      "decrocher",
      0.0025
    ],
    [
      "chercher",
      0.0025
    ],
    [
      "aveindre",
      0.0025
    ],
    [
      "apparaitre",
      0.0025
    ],
    [
      "agresser",
      0.0025
    ],
    [
      "agiter",
      0.0025
    ]
  ],
  "stade": [
    [
      "phase",
      0.1075
    ],
    [
      "echelon",
      0.1075
    ],
    [
      "etape",
      0.1075
    ],
    [
      "degre",
      0.0875
    ],
    [
      "palier",
      0.065
    ],
    [
      "etage",
      0.0425
    ],
    [
      "temps",
      0.0425
    ],
    [
      "periode",
      0.0425
    ],
    [
      "point",
      0.0425
    ],
    [
      "niveau",
      0.0425
    ],
    [
      "lice",
      0.0425
    ],
    [
      "cirque",
      0.0425
    ],
    [
      "champ",
      0.0425
    ],
    [
      "carriere",
      0.0425
    ],
    [
      "terrain",
      0.02
    ],
    [
      "terme",
      0.02
    ],
    [
      "piste",
      0.02
    ],
    [
      "partie",
      0.02
    ],
    [
      "gymnase",
      0.02
    ],
    [
      "velodrome",
      0.02
    ]
  ],
  "stable": [
    [
      "fixe",
      0.12
    ],
    [
      "ferme",
      0.09
    ],
    [
      "immuable",
      0.09
    ],
    [
      "constant",
      0.085
    ],
    [
      "invariable",
      0.0775
    ],
    [
      "solide",
      0.0725
    ],
    [
      "durable",
      0.055
    ],
    [
      "assure",
      0.0375
    ],
    [
      "sur",
      0.0325
    ],
    [
      "certain",
      0.0325
    ],
    [
      "continu",
      0.0275
    ],
    [
      "immobile",
      0.0275
    ],
    [
      "permanent",
      0.0275
    ],
    [
      "arrete",
      0.0225
    ],
    [
      "determine",
      0.0225
    ],
    [
      "inalterable",
      0.0225
    ],
    [
      "sedentaire",
      0.015
    ],
    [
      "stationnaire",
      0.015
    ],
    [
      "regulier",
      0.015
    ],
    [
      "assis",
      0.01
    ],
    [
      "bon",
      0.01
    ],
    [
      "persistant",
      0.01
    ],
    [
      "regle",
      0.01
    ],
    [
      "viable",
      0.005
    ],
    [
      "statique",
      0.005
    ],
    [
      "resistant",
      0.005
    ],
    [
      "irrevocable",
      0.005
    ],
    [
      "defini",
      0.005
    ],
    [
      "d'aplomb",
      0.005
    ],
    [
      "ancre",
      0.005
    ],
    [
      "affermi",
      0.005
    ],
    [
      "equilibre",
      0.005
    ]
  ],
  "renaitre": [
    [
      "revenir",
      0.1775
    ],
    [
      "ressusciter",
      0.11
    ],
    [
      "recommencer",
      0.0875
    ],
    [
      "revivre",
      0.0875
    ],
    [
      "reprendre",
      0.065
    ],
    [
      "reapparaitre",
      0.065
    ],
    [
      "reparaitre",
      0.0425
    ],
    [
      "guerir",
      0.0425
    ],
    [
      "rebondir",
      0.02
    ],
    [
      "repercer",
      0.02
    ],
    [
      "repousser",
      0.02
    ],
    [
      "ressurgir",
      0.02
    ],
    [
      "reverdir",
      0.02
    ]
  ],
  "empieter": [
    [
      "mordre",
      0.1425
    ],
    [
      "avancer",
      0.085
    ],
    [
      "entamer",
      0.085
    ],
    [
      "envahir",
      0.085
    ],
    [
      "gagner",
      0.085
    ],
    [
      "usurper",
      0.085
    ],
    [
      "toucher",
      0.0575
    ],
    [
      "entreprendre",
      0.0575
    ],
    [
      "depasser",
      0.0575
    ],
    [
      "chevaucher",
      0.0575
    ],
    [
      "anticiper",
      0.0575
    ],
    [
      "grignoter",
      0.0275
    ],
    [
      "outrepasser",
      0.0275
    ]
  ],
  "vengeance": [
    [
      "represailles",
      0.2275
    ],
    [
      "revanche",
      0.2275
    ],
    [
      "ressentiment",
      0.1125
    ],
    [
      "punition",
      0.055
    ],
    [
      "colere",
      0.055
    ],
    [
      "chatiment",
      0.055
    ],
    [
      "vendetta",
      0.0275
    ],
    [
      "talion",
      0.0275
    ],
    [
      "retorsion",
      0.0275
    ],
    [
      "reparation",
      0.0275
    ],
    [
      "riposte",
      0.0275
    ],
    [
      "nemesis",
      0.0275
    ],
    [
      "haine",
      0.0275
    ],
    [
      "bras",
      0.0275
    ],
    [
      "vindicte",
      0.0275
    ]
  ],
  "crache": [
    [
      "vomir",
      0.185
    ],
    [
      "expulser",
      0.11
    ],
    [
      "expectorer",
      0.0725
    ],
    [
      "tousser",
      0.0725
    ],
    [
      "mollarder",
      0.035
    ],
    [
      "payer",
      0.035
    ],
    [
      "proferer",
      0.035
    ],
    [
      "projeter",
      0.035
    ],
    [
      "recracher",
      0.035
    ],
    [
      "rejeter",
      0.035
    ],
    [
      "graillonner",
      0.035
    ],
    [
      "glavioter",
      0.035
    ],
    [
      "fulminer",
      0.035
    ],
    [
      "debourser",
      0.035
    ],
    [
      "crachouiller",
      0.035
    ],
    [
      "crachoter",
      0.035
    ],
    [
      "crachailler",
      0.035
    ],
    [
      "casquer",
      0.035
    ],
    [
      "evacuer",
      0.035
    ]
  ],
  "cracher": [
    [
      "vomir",
      0.185
    ],
    [
      "expulser",
      0.11
    ],
    [
      "expectorer",
      0.0725
    ],
    [
      "tousser",
      0.0725
    ],
    [
      "mollarder",
      0.035
    ],
    [
      "payer",
      0.035
    ],
    [
      "proferer",
      0.035
    ],
    [
      "projeter",
      0.035
    ],
    [
      "recracher",
      0.035
    ],
    [
      "rejeter",
      0.035
    ],
    [
      "graillonner",
      0.035
    ],
    [
      "glavioter",
      0.035
    ],
    [
      "fulminer",
      0.035
    ],
    [
      "debourser",
      0.035
    ],
    [
      "crachouiller",
      0.035
    ],
    [
      "crachoter",
      0.035
    ],
    [
      "crachailler",
      0.035
    ],
    [
      "casquer",
      0.035
    ],
    [
      "evacuer",
      0.035
    ]
  ],
  "tranchant": [
    [
      "cassant",
      0.0725
    ],
    [
      "aigu",
      0.0675
    ],
    [
      "autoritaire",
      0.0475
    ],
    [
      "coupant",
      0.04
    ],
    [
      "peremptoire",
      0.035
    ],
    [
      "imperieux",
      0.035
    ],
    [
      "dur",
      0.035
    ],
    [
      "categorique",
      0.035
    ],
    [
      "violent",
      0.03
    ],
    [
      "severe",
      0.03
    ],
    [
      "sec",
      0.03
    ],
    [
      "aigre",
      0.03
    ],
    [
      "affile",
      0.03
    ],
    [
      "absolu",
      0.03
    ],
    [
      "rude",
      0.025
    ],
    [
      "penetrant",
      0.025
    ],
    [
      "brusque",
      0.025
    ],
    [
      "bref",
      0.025
    ],
    [
      "acere",
      0.025
    ],
    [
      "apre",
      0.02
    ],
    [
      "resolu",
      0.015
    ],
    [
      "prompt",
      0.015
    ],
    [
      "intransigeant",
      0.015
    ],
    [
      "incisif",
      0.015
    ],
    [
      "imperatif",
      0.015
    ],
    [
      "decisif",
      0.015
    ],
    [
      "decide",
      0.015
    ],
    [
      "dogmatique",
      0.015
    ],
    [
      "tranche",
      0.0075
    ],
    [
      "sentencieux",
      0.0075
    ],
    [
      "insolent",
      0.0075
    ],
    [
      "inflexible",
      0.0075
    ],
    [
      "doctoral",
      0.0075
    ],
    [
      "dictatorial",
      0.0075
    ],
    [
      "bourru",
      0.0075
    ],
    [
      "audacieux",
      0.0075
    ],
    [
      "aiguise",
      0.0075
    ],
    [
      "affute",
      0.0075
    ],
    [
      "taillant",
      0.0025
    ],
    [
      "taille",
      0.0025
    ],
    [
      "emorfile",
      0.0025
    ],
    [
      "repasse",
      0.0025
    ],
    [
      "pontifiant",
      0.0025
    ],
    [
      "morfil",
      0.0025
    ],
    [
      "lancinant",
      0.0025
    ],
    [
      "fil",
      0.0025
    ],
    [
      "affirmatif",
      0.0025
    ],
    [
      "emoulu",
      0.0025
    ]
  ],
  "morceau": [
    [
      "partie",
      0.1
    ],
    [
      "fragment",
      0.0875
    ],
    [
      "portion",
      0.0725
    ],
    [
      "debris",
      0.04
    ],
    [
      "piece",
      0.0375
    ],
    [
      "part",
      0.0375
    ],
    [
      "bout",
      0.0375
    ],
    [
      "division",
      0.0325
    ],
    [
      "bribe",
      0.03
    ],
    [
      "parcelle",
      0.03
    ],
    [
      "tranche",
      0.0275
    ],
    [
      "ration",
      0.0275
    ],
    [
      "ramification",
      0.0275
    ],
    [
      "miette",
      0.0225
    ],
    [
      "troncon",
      0.0225
    ],
    [
      "fraction",
      0.02
    ],
    [
      "lambeau",
      0.02
    ],
    [
      "rognure",
      0.015
    ],
    [
      "eclat",
      0.01
    ],
    [
      "quartier",
      0.01
    ],
    [
      "passage",
      0.01
    ],
    [
      "grain",
      0.01
    ],
    [
      "coin",
      0.01
    ],
    [
      "brin",
      0.01
    ],
    [
      "bloc",
      0.01
    ],
    [
      "lot",
      0.0075
    ],
    [
      "grignon",
      0.0075
    ],
    [
      "extrait",
      0.0075
    ],
    [
      "brisure",
      0.0075
    ],
    [
      "periode",
      0.005
    ],
    [
      "quignon",
      0.005
    ],
    [
      "relief",
      0.005
    ],
    [
      "rogaton",
      0.005
    ],
    [
      "tesson",
      0.005
    ],
    [
      "element",
      0.005
    ],
    [
      "poids",
      0.005
    ],
    [
      "plat",
      0.005
    ],
    [
      "bande",
      0.005
    ],
    [
      "bille",
      0.005
    ],
    [
      "carre",
      0.005
    ],
    [
      "masse",
      0.005
    ],
    [
      "page",
      0.005
    ],
    [
      "particule",
      0.005
    ],
    [
      "membre",
      0.0025
    ],
    [
      "mets",
      0.0025
    ],
    [
      "moment",
      0.0025
    ],
    [
      "motte",
      0.0025
    ],
    [
      "retaille",
      0.0025
    ],
    [
      "rondelle",
      0.0025
    ],
    [
      "segment",
      0.0025
    ],
    [
      "taillon",
      0.0025
    ],
    [
      "texte",
      0.0025
    ],
    [
      "echantillon",
      0.0025
    ],
    [
      "epave",
      0.0025
    ],
    [
      "etape",
      0.0025
    ],
    [
      "lotissement",
      0.0025
    ],
    [
      "loquette",
      0.0025
    ],
    [
      "lopin",
      0.0025
    ],
    [
      "bouchee",
      0.0025
    ],
    [
      "chanteau",
      0.0025
    ],
    [
      "chicot",
      0.0025
    ],
    [
      "chiffon",
      0.0025
    ],
    [
      "darne",
      0.0025
    ],
    [
      "decoupure",
      0.0025
    ],
    [
      "detail",
      0.0025
    ],
    [
      "entame",
      0.0025
    ],
    [
      "goulee",
      0.0025
    ],
    [
      "lame",
      0.0025
    ],
    [
      "lichette",
      0.0025
    ],
    [
      "lingot",
      0.0025
    ],
    [
      "etude",
      0.0025
    ]
  ],
  "concert": [
    [
      "harmonie",
      0.11
    ],
    [
      "serenade",
      0.0775
    ],
    [
      "union",
      0.0775
    ],
    [
      "accord",
      0.0625
    ],
    [
      "entente",
      0.0625
    ],
    [
      "recital",
      0.0625
    ],
    [
      "symphonie",
      0.0475
    ],
    [
      "fraternite",
      0.0475
    ],
    [
      "choeur",
      0.0475
    ],
    [
      "aubade",
      0.0475
    ],
    [
      "orchestre",
      0.03
    ],
    [
      "musique",
      0.03
    ],
    [
      "hymne",
      0.03
    ],
    [
      "ensemble",
      0.03
    ],
    [
      "charivari",
      0.03
    ],
    [
      "chahut",
      0.03
    ],
    [
      "association",
      0.03
    ],
    [
      "intelligence",
      0.015
    ],
    [
      "festival",
      0.015
    ],
    [
      "divertissement",
      0.015
    ],
    [
      "complot",
      0.015
    ],
    [
      "chorus",
      0.015
    ],
    [
      "cacophonie",
      0.015
    ],
    [
      "audition",
      0.015
    ],
    [
      "tintamarre",
      0.015
    ]
  ],
  "maquette": [
    [
      "esquisse",
      0.24
    ],
    [
      "etude",
      0.1175
    ],
    [
      "ebauche",
      0.08
    ],
    [
      "projet",
      0.08
    ],
    [
      "plan",
      0.08
    ],
    [
      "peinture",
      0.08
    ],
    [
      "modele",
      0.08
    ],
    [
      "copie",
      0.08
    ],
    [
      "canevas",
      0.08
    ],
    [
      "document",
      0.0375
    ],
    [
      "reduction",
      0.0375
    ]
  ],
  "daller": [
    [
      "carreler",
      0.5
    ],
    [
      "paver",
      0.5
    ]
  ],
  "dalle": [
    [
      "canal",
      0.165
    ],
    [
      "gosier",
      0.165
    ],
    [
      "pave",
      0.165
    ],
    [
      "gorge",
      0.11
    ],
    [
      "goulot",
      0.11
    ],
    [
      "massif",
      0.055
    ],
    [
      "darne",
      0.055
    ],
    [
      "dalot",
      0.055
    ],
    [
      "carreau",
      0.055
    ],
    [
      "pierre",
      0.055
    ]
  ],
  "combler": [
    [
      "remplir",
      0.105
    ],
    [
      "bourrer",
      0.0725
    ],
    [
      "abreuver",
      0.0625
    ],
    [
      "accabler",
      0.0625
    ],
    [
      "couvrir",
      0.0625
    ],
    [
      "charger",
      0.0525
    ],
    [
      "gorger",
      0.0525
    ],
    [
      "garnir",
      0.0425
    ],
    [
      "entourer",
      0.0425
    ],
    [
      "emplir",
      0.0425
    ],
    [
      "envahir",
      0.03
    ],
    [
      "satisfaire",
      0.03
    ],
    [
      "truffer",
      0.03
    ],
    [
      "rassasier",
      0.02
    ],
    [
      "gater",
      0.02
    ],
    [
      "fermer",
      0.02
    ],
    [
      "contenter",
      0.02
    ],
    [
      "choyer",
      0.02
    ],
    [
      "boucher",
      0.02
    ],
    [
      "assouvir",
      0.02
    ],
    [
      "niveler",
      0.0075
    ],
    [
      "obturer",
      0.0075
    ],
    [
      "remblayer",
      0.0075
    ],
    [
      "realiser",
      0.0075
    ],
    [
      "sourire",
      0.0075
    ],
    [
      "exaucer",
      0.0075
    ],
    [
      "desalterer",
      0.0075
    ],
    [
      "deborder",
      0.0075
    ],
    [
      "completer",
      0.0075
    ],
    [
      "compenser",
      0.0075
    ],
    [
      "colmater",
      0.0075
    ],
    [
      "bonder",
      0.0075
    ],
    [
      "aplanir",
      0.0075
    ],
    [
      "surcharger",
      0.0075
    ]
  ],
  "comble": [
    [
      "remplir",
      0.105
    ],
    [
      "bourrer",
      0.0725
    ],
    [
      "abreuver",
      0.0625
    ],
    [
      "accabler",
      0.0625
    ],
    [
      "couvrir",
      0.0625
    ],
    [
      "charger",
      0.0525
    ],
    [
      "gorger",
      0.0525
    ],
    [
      "garnir",
      0.0425
    ],
    [
      "entourer",
      0.0425
    ],
    [
      "emplir",
      0.0425
    ],
    [
      "envahir",
      0.03
    ],
    [
      "satisfaire",
      0.03
    ],
    [
      "truffer",
      0.03
    ],
    [
      "rassasier",
      0.02
    ],
    [
      "gater",
      0.02
    ],
    [
      "fermer",
      0.02
    ],
    [
      "contenter",
      0.02
    ],
    [
      "choyer",
      0.02
    ],
    [
      "boucher",
      0.02
    ],
    [
      "assouvir",
      0.02
    ],
    [
      "niveler",
      0.0075
    ],
    [
      "obturer",
      0.0075
    ],
    [
      "remblayer",
      0.0075
    ],
    [
      "realiser",
      0.0075
    ],
    [
      "sourire",
      0.0075
    ],
    [
      "exaucer",
      0.0075
    ],
    [
      "desalterer",
      0.0075
    ],
    [
      "deborder",
      0.0075
    ],
    [
      "completer",
      0.0075
    ],
    [
      "compenser",
      0.0075
    ],
    [
      "colmater",
      0.0075
    ],
    [
      "bonder",
      0.0075
    ],
    [
      "aplanir",
      0.0075
    ],
    [
      "surcharger",
      0.0075
    ]
  ],
  "vide": [
    [
      "renvoyer",
      0.0675
    ],
    [
      "epuiser",
      0.055
    ],
    [
      "chasser",
      0.04
    ],
    [
      "congedier",
      0.0325
    ],
    [
      "aneantir",
      0.03
    ],
    [
      "expulser",
      0.0275
    ],
    [
      "balancer",
      0.0275
    ],
    [
      "liquider",
      0.025
    ],
    [
      "virer",
      0.0225
    ],
    [
      "sortir",
      0.0225
    ],
    [
      "remercier",
      0.0225
    ],
    [
      "limoger",
      0.0225
    ],
    [
      "balayer",
      0.0225
    ],
    [
      "debarquer",
      0.02
    ],
    [
      "deloger",
      0.02
    ],
    [
      "evacuer",
      0.015
    ],
    [
      "ereinter",
      0.015
    ],
    [
      "nettoyer",
      0.015
    ],
    [
      "licencier",
      0.015
    ],
    [
      "extenuer",
      0.015
    ],
    [
      "abattre",
      0.015
    ],
    [
      "abandonner",
      0.015
    ],
    [
      "vanner",
      0.0125
    ],
    [
      "ruiner",
      0.0125
    ],
    [
      "pomper",
      0.0125
    ],
    [
      "finir",
      0.0125
    ],
    [
      "fatiguer",
      0.0125
    ],
    [
      "debarrasser",
      0.0125
    ],
    [
      "terminer",
      0.01
    ],
    [
      "regler",
      0.01
    ],
    [
      "exclure",
      0.01
    ],
    [
      "enlever",
      0.01
    ],
    [
      "demenager",
      0.01
    ],
    [
      "claquer",
      0.01
    ],
    [
      "oter",
      0.0075
    ],
    [
      "econduire",
      0.0075
    ],
    [
      "trancher",
      0.0075
    ],
    [
      "tarir",
      0.0075
    ],
    [
      "revoquer",
      0.0075
    ],
    [
      "retirer",
      0.0075
    ],
    [
      "partir",
      0.0075
    ],
    [
      "lourder",
      0.0075
    ],
    [
      "harasser",
      0.0075
    ],
    [
      "degommer",
      0.0075
    ],
    [
      "reconduire",
      0.005
    ],
    [
      "sabrer",
      0.005
    ],
    [
      "saigner",
      0.005
    ],
    [
      "saquer",
      0.005
    ],
    [
      "verser",
      0.005
    ],
    [
      "vidanger",
      0.005
    ],
    [
      "larguer",
      0.005
    ],
    [
      "degoter",
      0.005
    ],
    [
      "degarnir",
      0.005
    ],
    [
      "assecher",
      0.005
    ],
    [
      "boire",
      0.005
    ],
    [
      "crever",
      0.005
    ],
    [
      "dessecher",
      0.005
    ],
    [
      "deboulonner",
      0.005
    ],
    [
      "debusquer",
      0.005
    ],
    [
      "parer",
      0.0025
    ],
    [
      "piller",
      0.0025
    ],
    [
      "preparer",
      0.0025
    ],
    [
      "resoudre",
      0.0025
    ],
    [
      "siffler",
      0.0025
    ],
    [
      "secher",
      0.0025
    ],
    [
      "transvaser",
      0.0025
    ],
    [
      "transvider",
      0.0025
    ],
    [
      "ecoper",
      0.0025
    ],
    [
      "etriper",
      0.0025
    ],
    [
      "eviscerer",
      0.0025
    ],
    [
      "lessiver",
      0.0025
    ],
    [
      "ingurgiter",
      0.0025
    ],
    [
      "debonder",
      0.0025
    ],
    [
      "debourrer",
      0.0025
    ],
    [
      "decider",
      0.0025
    ],
    [
      "demeubler",
      0.0025
    ],
    [
      "depeupler",
      0.0025
    ],
    [
      "deprimer",
      0.0025
    ],
    [
      "desarconner",
      0.0025
    ],
    [
      "desemplir",
      0.0025
    ],
    [
      "desobstruer",
      0.0025
    ],
    [
      "bordurer",
      0.0025
    ]
  ],
  "precieux": [
    [
      "affecte",
      0.1025
    ],
    [
      "recherche",
      0.07
    ],
    [
      "maniere",
      0.055
    ],
    [
      "bon",
      0.0475
    ],
    [
      "sophistique",
      0.0375
    ],
    [
      "delicat",
      0.035
    ],
    [
      "beau",
      0.03
    ],
    [
      "etudie",
      0.03
    ],
    [
      "raffine",
      0.0275
    ],
    [
      "exquis",
      0.0275
    ],
    [
      "emphatique",
      0.0275
    ],
    [
      "apprete",
      0.0225
    ],
    [
      "distingue",
      0.0225
    ],
    [
      "important",
      0.0225
    ],
    [
      "pretentieux",
      0.0225
    ],
    [
      "tarabiscote",
      0.02
    ],
    [
      "affete",
      0.02
    ],
    [
      "avantageux",
      0.015
    ],
    [
      "rare",
      0.015
    ],
    [
      "theatral",
      0.015
    ],
    [
      "utile",
      0.015
    ],
    [
      "travaille",
      0.0125
    ],
    [
      "mignard",
      0.0125
    ],
    [
      "guinde",
      0.0125
    ],
    [
      "galant",
      0.0125
    ],
    [
      "choisi",
      0.0125
    ],
    [
      "cher",
      0.0125
    ],
    [
      "valable",
      0.01
    ],
    [
      "soigne",
      0.01
    ],
    [
      "mievre",
      0.01
    ],
    [
      "minaudier",
      0.01
    ],
    [
      "inestimable",
      0.01
    ],
    [
      "fin",
      0.01
    ],
    [
      "efficace",
      0.01
    ],
    [
      "artificiel",
      0.01
    ],
    [
      "alambique",
      0.01
    ],
    [
      "riche",
      0.005
    ],
    [
      "profitable",
      0.005
    ],
    [
      "parfait",
      0.005
    ],
    [
      "inappreciable",
      0.005
    ],
    [
      "fat",
      0.005
    ],
    [
      "estimable",
      0.005
    ],
    [
      "emprunte",
      0.005
    ],
    [
      "difficile",
      0.005
    ],
    [
      "cheri",
      0.005
    ],
    [
      "irremplacable",
      0.0025
    ],
    [
      "musque",
      0.0025
    ],
    [
      "necessaire",
      0.0025
    ],
    [
      "quintessencie",
      0.0025
    ],
    [
      "rarissime",
      0.0025
    ],
    [
      "ridicule",
      0.0025
    ],
    [
      "introuvable",
      0.0025
    ],
    [
      "grimacier",
      0.0025
    ],
    [
      "grandiloquent",
      0.0025
    ],
    [
      "effemine",
      0.0025
    ],
    [
      "contourne",
      0.0025
    ],
    [
      "competent",
      0.0025
    ],
    [
      "chichiteux",
      0.0025
    ],
    [
      "utilisable",
      0.0025
    ]
  ],
  "doute": [
    [
      "incertitude",
      0.12
    ],
    [
      "defiance",
      0.06
    ],
    [
      "hesitation",
      0.06
    ],
    [
      "indecision",
      0.06
    ],
    [
      "scepticisme",
      0.06
    ],
    [
      "tatonnement",
      0.06
    ],
    [
      "soupcon",
      0.0425
    ],
    [
      "ombre",
      0.0425
    ],
    [
      "obscurite",
      0.0425
    ],
    [
      "mefiance",
      0.0425
    ],
    [
      "indetermination",
      0.0425
    ],
    [
      "crainte",
      0.0425
    ],
    [
      "vacillation",
      0.0275
    ],
    [
      "perplexite",
      0.0275
    ],
    [
      "irresolution",
      0.0275
    ],
    [
      "incredulite",
      0.0275
    ],
    [
      "suspicion",
      0.0125
    ],
    [
      "supposition",
      0.0125
    ],
    [
      "scrupule",
      0.0125
    ],
    [
      "pyrrhonisme",
      0.0125
    ],
    [
      "jalousie",
      0.0125
    ],
    [
      "incroyance",
      0.0125
    ],
    [
      "flottement",
      0.0125
    ],
    [
      "embarras",
      0.0125
    ],
    [
      "apprehension",
      0.0125
    ],
    [
      "affres",
      0.0125
    ],
    [
      "equivoque",
      0.0125
    ]
  ],
  "demon": [
    [
      "diable",
      0.22
    ],
    [
      "genie",
      0.0875
    ],
    [
      "dragon",
      0.065
    ],
    [
      "espiegle",
      0.065
    ],
    [
      "serpent",
      0.0425
    ],
    [
      "mechant",
      0.0425
    ],
    [
      "malin",
      0.0425
    ],
    [
      "lutin",
      0.0425
    ],
    [
      "inspiration",
      0.0425
    ],
    [
      "furie",
      0.0425
    ],
    [
      "esprit",
      0.0425
    ],
    [
      "enthousiasme",
      0.0425
    ],
    [
      "succube",
      0.02
    ],
    [
      "incube",
      0.02
    ],
    [
      "harpie",
      0.02
    ],
    [
      "flamme",
      0.02
    ],
    [
      "dieu",
      0.02
    ],
    [
      "diablotin",
      0.02
    ],
    [
      "tentateur",
      0.02
    ]
  ],
  "reflet": [
    [
      "chatoiement",
      0.12
    ],
    [
      "image",
      0.12
    ],
    [
      "illusion",
      0.08
    ],
    [
      "lumiere",
      0.08
    ],
    [
      "ombre",
      0.04
    ],
    [
      "reproduction",
      0.04
    ],
    [
      "representation",
      0.04
    ],
    [
      "reflexion",
      0.04
    ],
    [
      "reverberation",
      0.04
    ],
    [
      "scintillement",
      0.04
    ],
    [
      "nitescence",
      0.04
    ],
    [
      "moire",
      0.04
    ],
    [
      "miroitement",
      0.04
    ],
    [
      "mirage",
      0.04
    ],
    [
      "marbrure",
      0.04
    ],
    [
      "irisation",
      0.04
    ],
    [
      "imitation",
      0.04
    ],
    [
      "halo",
      0.04
    ],
    [
      "echo",
      0.04
    ]
  ],
  "irremplacable": [
    [
      "precieux",
      0.5
    ],
    [
      "unique",
      0.5
    ]
  ],
  "profiter": [
    [
      "croitre",
      0.0825
    ],
    [
      "gagner",
      0.0825
    ],
    [
      "progresser",
      0.0625
    ],
    [
      "grandir",
      0.05
    ],
    [
      "utiliser",
      0.05
    ],
    [
      "s'accroitre",
      0.04
    ],
    [
      "prosperer",
      0.04
    ],
    [
      "pousser",
      0.04
    ],
    [
      "grossir",
      0.04
    ],
    [
      "fructifier",
      0.04
    ],
    [
      "avancer",
      0.04
    ],
    [
      "servir",
      0.03
    ],
    [
      "s'enrichir",
      0.03
    ],
    [
      "exploiter",
      0.03
    ],
    [
      "beneficier",
      0.03
    ],
    [
      "aider",
      0.03
    ],
    [
      "travailler",
      0.02
    ],
    [
      "rapporter",
      0.02
    ],
    [
      "forcir",
      0.02
    ],
    [
      "attraper",
      0.02
    ],
    [
      "secourir",
      0.01
    ],
    [
      "saisir",
      0.01
    ],
    [
      "parasiter",
      0.01
    ],
    [
      "jouir",
      0.01
    ],
    [
      "employer",
      0.01
    ],
    [
      "apprendre",
      0.01
    ],
    [
      "speculer",
      0.01
    ]
  ],
  "reponse": [
    [
      "riposte",
      0.1225
    ],
    [
      "replique",
      0.1225
    ],
    [
      "reaction",
      0.09
    ],
    [
      "retorsion",
      0.06
    ],
    [
      "resultat",
      0.06
    ],
    [
      "objection",
      0.06
    ],
    [
      "justification",
      0.06
    ],
    [
      "defense",
      0.06
    ],
    [
      "contrecoup",
      0.06
    ],
    [
      "verdict",
      0.0275
    ],
    [
      "solution",
      0.0275
    ],
    [
      "refutation",
      0.0275
    ],
    [
      "recrimination",
      0.0275
    ],
    [
      "rescrit",
      0.0275
    ],
    [
      "repartie",
      0.0275
    ],
    [
      "oracle",
      0.0275
    ],
    [
      "explication",
      0.0275
    ],
    [
      "apologie",
      0.0275
    ],
    [
      "echo",
      0.0275
    ]
  ],
  "fixer": [
    [
      "attacher",
      0.085
    ],
    [
      "arrimer",
      0.06
    ],
    [
      "immobiliser",
      0.0475
    ],
    [
      "arreter",
      0.045
    ],
    [
      "assujettir",
      0.035
    ],
    [
      "retenir",
      0.0325
    ],
    [
      "assurer",
      0.03
    ],
    [
      "maintenir",
      0.0275
    ],
    [
      "tenir",
      0.0275
    ],
    [
      "prendre",
      0.0225
    ],
    [
      "mettre",
      0.02
    ],
    [
      "coincer",
      0.0175
    ],
    [
      "coller",
      0.0175
    ],
    [
      "river",
      0.0175
    ],
    [
      "bloquer",
      0.015
    ],
    [
      "determiner",
      0.015
    ],
    [
      "consolider",
      0.015
    ],
    [
      "caler",
      0.0125
    ],
    [
      "etablir",
      0.0125
    ],
    [
      "donner",
      0.0125
    ],
    [
      "assembler",
      0.0125
    ],
    [
      "accrocher",
      0.01
    ],
    [
      "enchainer",
      0.01
    ],
    [
      "ficher",
      0.01
    ],
    [
      "regarder",
      0.01
    ],
    [
      "soutenir",
      0.0075
    ],
    [
      "poser",
      0.0075
    ],
    [
      "placer",
      0.0075
    ],
    [
      "marquer",
      0.0075
    ],
    [
      "clouer",
      0.0075
    ],
    [
      "amarrer",
      0.0075
    ],
    [
      "appuyer",
      0.0075
    ],
    [
      "captiver",
      0.0075
    ],
    [
      "ecrire",
      0.005
    ],
    [
      "suspendre",
      0.005
    ],
    [
      "planter",
      0.005
    ],
    [
      "lier",
      0.005
    ],
    [
      "boulonner",
      0.005
    ],
    [
      "ancrer",
      0.005
    ],
    [
      "agrafer",
      0.005
    ],
    [
      "affermir",
      0.005
    ],
    [
      "traiter",
      0.005
    ],
    [
      "stabiliser",
      0.005
    ],
    [
      "signaler",
      0.005
    ],
    [
      "regler",
      0.005
    ],
    [
      "indiquer",
      0.005
    ],
    [
      "examiner",
      0.005
    ],
    [
      "devisager",
      0.005
    ],
    [
      "decider",
      0.005
    ],
    [
      "assigner",
      0.005
    ],
    [
      "asseoir",
      0.005
    ],
    [
      "observer",
      0.0025
    ],
    [
      "piquer",
      0.0025
    ],
    [
      "situer",
      0.0025
    ],
    [
      "trancher",
      0.0025
    ],
    [
      "visser",
      0.0025
    ],
    [
      "instruire",
      0.0025
    ],
    [
      "installer",
      0.0025
    ],
    [
      "imposer",
      0.0025
    ],
    [
      "figer",
      0.0025
    ],
    [
      "envisager",
      0.0025
    ],
    [
      "definir",
      0.0025
    ],
    [
      "camper",
      0.0025
    ],
    [
      "attirer",
      0.0025
    ],
    [
      "limiter",
      0.0025
    ],
    [
      "nouer",
      0.0025
    ],
    [
      "prescrire",
      0.0025
    ],
    [
      "preciser",
      0.0025
    ],
    [
      "epingler",
      0.0025
    ],
    [
      "informer",
      0.0025
    ],
    [
      "imprimer",
      0.0025
    ],
    [
      "conquerir",
      0.0025
    ],
    [
      "contempler",
      0.0025
    ],
    [
      "delimiter",
      0.0025
    ],
    [
      "graver",
      0.0025
    ],
    [
      "implanter",
      0.0025
    ],
    [
      "reglementer",
      0.0
    ],
    [
      "sceller",
      0.0
    ],
    [
      "scruter",
      0.0
    ],
    [
      "specifier",
      0.0
    ],
    [
      "statuer",
      0.0
    ],
    [
      "zieuter",
      0.0
    ],
    [
      "eclairer",
      0.0
    ],
    [
      "edifier",
      0.0
    ],
    [
      "renseigner",
      0.0
    ],
    [
      "qualifier",
      0.0
    ],
    [
      "petrifier",
      0.0
    ],
    [
      "accorer",
      0.0
    ],
    [
      "caser",
      0.0
    ],
    [
      "conclure",
      0.0
    ],
    [
      "contingenter",
      0.0
    ],
    [
      "cramponner",
      0.0
    ],
    [
      "enraciner",
      0.0
    ],
    [
      "particulariser",
      0.0
    ],
    [
      "pendre",
      0.0
    ],
    [
      "immortaliser",
      0.0
    ],
    [
      "lacer",
      0.0
    ],
    [
      "normaliser",
      0.0
    ],
    [
      "peindre",
      0.0
    ],
    [
      "pendiller",
      0.0
    ],
    [
      "predefinir",
      0.0
    ],
    [
      "sertir",
      0.0
    ],
    [
      "formuler",
      0.0
    ],
    [
      "enclaver",
      0.0
    ],
    [
      "adherer",
      0.0
    ],
    [
      "boutonner",
      0.0
    ],
    [
      "breler",
      0.0
    ],
    [
      "cheviller",
      0.0
    ],
    [
      "concentrer",
      0.0
    ],
    [
      "cristalliser",
      0.0
    ],
    [
      "ceduler",
      0.0
    ],
    [
      "enchasser",
      0.0
    ],
    [
      "sedentariser",
      0.0
    ]
  ],
  "plafond": [
    [
      "altitude",
      0.0825
    ],
    [
      "tete",
      0.0825
    ],
    [
      "toit",
      0.0825
    ],
    [
      "solive",
      0.0825
    ],
    [
      "soffite",
      0.0825
    ],
    [
      "plafonnier",
      0.0825
    ],
    [
      "plafonnard",
      0.0825
    ],
    [
      "maximum",
      0.0825
    ],
    [
      "limite",
      0.0825
    ],
    [
      "lambris",
      0.0825
    ],
    [
      "caisson",
      0.0825
    ],
    [
      "voute",
      0.0825
    ]
  ],
  "cinq": [],
  "supreme": [
    [
      "parfait",
      0.1225
    ],
    [
      "grand",
      0.0925
    ],
    [
      "superieur",
      0.0925
    ],
    [
      "extraordinaire",
      0.08
    ],
    [
      "extreme",
      0.06
    ],
    [
      "sublime",
      0.06
    ],
    [
      "genial",
      0.05
    ],
    [
      "souverain",
      0.05
    ],
    [
      "absolu",
      0.04
    ],
    [
      "acheve",
      0.03
    ],
    [
      "divin",
      0.03
    ],
    [
      "haut",
      0.03
    ],
    [
      "ideal",
      0.03
    ],
    [
      "puissant",
      0.02
    ],
    [
      "prodigieux",
      0.02
    ],
    [
      "magistral",
      0.02
    ],
    [
      "infini",
      0.02
    ],
    [
      "fabuleux",
      0.02
    ],
    [
      "consomme",
      0.02
    ],
    [
      "total",
      0.0075
    ],
    [
      "superlatif",
      0.0075
    ],
    [
      "puree",
      0.0075
    ],
    [
      "final",
      0.0075
    ],
    [
      "filet",
      0.0075
    ],
    [
      "desespere",
      0.0075
    ],
    [
      "dernier",
      0.0075
    ],
    [
      "capital",
      0.0075
    ],
    [
      "blanc",
      0.0075
    ],
    [
      "ultime",
      0.0075
    ]
  ],
  "suite": [
    [
      "succession",
      0.06
    ],
    [
      "serie",
      0.0475
    ],
    [
      "consequence",
      0.04
    ],
    [
      "enchainement",
      0.0325
    ],
    [
      "ribambelle",
      0.0275
    ],
    [
      "prolongement",
      0.0275
    ],
    [
      "chaine",
      0.0275
    ],
    [
      "resultat",
      0.0225
    ],
    [
      "repercussion",
      0.0225
    ],
    [
      "ricochet",
      0.0225
    ],
    [
      "liaison",
      0.0225
    ],
    [
      "file",
      0.0225
    ],
    [
      "effet",
      0.0225
    ],
    [
      "cours",
      0.0225
    ],
    [
      "cortege",
      0.0225
    ],
    [
      "chapelet",
      0.0225
    ],
    [
      "developpement",
      0.02
    ],
    [
      "incidence",
      0.015
    ],
    [
      "continuation",
      0.015
    ],
    [
      "cascade",
      0.015
    ],
    [
      "trame",
      0.0125
    ],
    [
      "train",
      0.0125
    ],
    [
      "kyrielle",
      0.0125
    ],
    [
      "fruit",
      0.0125
    ],
    [
      "filiation",
      0.0125
    ],
    [
      "contrecoup",
      0.0125
    ],
    [
      "continuite",
      0.0125
    ],
    [
      "sequelle",
      0.0075
    ],
    [
      "reste",
      0.0075
    ],
    [
      "procession",
      0.0075
    ],
    [
      "maison",
      0.0075
    ],
    [
      "liste",
      0.0075
    ],
    [
      "lignee",
      0.0075
    ],
    [
      "lendemain",
      0.0075
    ],
    [
      "futur",
      0.0075
    ],
    [
      "accompagnement",
      0.0075
    ],
    [
      "defile",
      0.0075
    ],
    [
      "dependance",
      0.0075
    ],
    [
      "deroulement",
      0.0075
    ],
    [
      "fil",
      0.0075
    ],
    [
      "rancon",
      0.005
    ],
    [
      "reliquat",
      0.005
    ],
    [
      "repertoire",
      0.005
    ],
    [
      "survivance",
      0.005
    ],
    [
      "theorie",
      0.005
    ],
    [
      "tirade",
      0.005
    ],
    [
      "tissu",
      0.005
    ],
    [
      "echelle",
      0.005
    ],
    [
      "enumeration",
      0.005
    ],
    [
      "equipage",
      0.005
    ],
    [
      "progression",
      0.005
    ],
    [
      "produit",
      0.005
    ],
    [
      "aboutissement",
      0.005
    ],
    [
      "appareil",
      0.005
    ],
    [
      "collection",
      0.005
    ],
    [
      "course",
      0.005
    ],
    [
      "domestique",
      0.005
    ],
    [
      "engrenage",
      0.005
    ],
    [
      "lien",
      0.005
    ],
    [
      "posterite",
      0.005
    ],
    [
      "poursuite",
      0.005
    ],
    [
      "processus",
      0.005
    ],
    [
      "ordre",
      0.0025
    ],
    [
      "genealogie",
      0.0025
    ],
    [
      "gens",
      0.0025
    ],
    [
      "gamme",
      0.0025
    ],
    [
      "portee",
      0.0025
    ],
    [
      "prolongation",
      0.0025
    ],
    [
      "queue",
      0.0025
    ],
    [
      "reprise",
      0.0025
    ],
    [
      "suivant",
      0.0025
    ],
    [
      "sequence",
      0.0025
    ],
    [
      "fixite",
      0.0025
    ],
    [
      "escorte",
      0.0025
    ],
    [
      "entourage",
      0.0025
    ],
    [
      "alternance",
      0.0025
    ],
    [
      "alternative",
      0.0025
    ],
    [
      "apanage",
      0.0025
    ],
    [
      "coherence",
      0.0025
    ],
    [
      "cohesion",
      0.0025
    ],
    [
      "concatenation",
      0.0025
    ],
    [
      "corollaire",
      0.0025
    ],
    [
      "cour",
      0.0025
    ],
    [
      "cycle",
      0.0025
    ],
    [
      "enfilade",
      0.0025
    ],
    [
      "eclaboussure",
      0.0025
    ]
  ],
  "permis": [
    [
      "tolerer",
      0.13
    ],
    [
      "autoriser",
      0.1225
    ],
    [
      "admettre",
      0.1175
    ],
    [
      "consentir",
      0.07
    ],
    [
      "accepter",
      0.065
    ],
    [
      "accorder",
      0.0575
    ],
    [
      "donner",
      0.045
    ],
    [
      "acquiescer",
      0.045
    ],
    [
      "conceder",
      0.0325
    ],
    [
      "passer",
      0.0325
    ],
    [
      "souffrir",
      0.025
    ],
    [
      "laisser",
      0.025
    ],
    [
      "approuver",
      0.025
    ],
    [
      "agreer",
      0.0175
    ],
    [
      "daigner",
      0.0175
    ],
    [
      "supporter",
      0.0175
    ],
    [
      "justifier",
      0.0125
    ],
    [
      "dispenser",
      0.0125
    ],
    [
      "comporter",
      0.0125
    ],
    [
      "aider",
      0.005
    ],
    [
      "endurer",
      0.005
    ],
    [
      "habiliter",
      0.005
    ],
    [
      "legitimer",
      0.005
    ],
    [
      "servir",
      0.005
    ]
  ],
  "permettre": [
    [
      "tolerer",
      0.13
    ],
    [
      "autoriser",
      0.1225
    ],
    [
      "admettre",
      0.1175
    ],
    [
      "consentir",
      0.07
    ],
    [
      "accepter",
      0.065
    ],
    [
      "accorder",
      0.0575
    ],
    [
      "donner",
      0.045
    ],
    [
      "acquiescer",
      0.045
    ],
    [
      "conceder",
      0.0325
    ],
    [
      "passer",
      0.0325
    ],
    [
      "souffrir",
      0.025
    ],
    [
      "laisser",
      0.025
    ],
    [
      "approuver",
      0.025
    ],
    [
      "agreer",
      0.0175
    ],
    [
      "daigner",
      0.0175
    ],
    [
      "supporter",
      0.0175
    ],
    [
      "justifier",
      0.0125
    ],
    [
      "dispenser",
      0.0125
    ],
    [
      "comporter",
      0.0125
    ],
    [
      "aider",
      0.005
    ],
    [
      "endurer",
      0.005
    ],
    [
      "habiliter",
      0.005
    ],
    [
      "legitimer",
      0.005
    ],
    [
      "servir",
      0.005
    ]
  ],
  "eternite": [
    [
      "continuite",
      0.1825
    ],
    [
      "perennite",
      0.1825
    ],
    [
      "durabilite",
      0.09
    ],
    [
      "immortalite",
      0.09
    ],
    [
      "permanence",
      0.09
    ],
    [
      "perpetuite",
      0.09
    ],
    [
      "infini",
      0.045
    ],
    [
      "indestructibilite",
      0.045
    ],
    [
      "immuabilite",
      0.045
    ],
    [
      "futur",
      0.045
    ],
    [
      "avenir",
      0.045
    ],
    [
      "siecle",
      0.045
    ]
  ],
  "necessite": [
    [
      "entrainer",
      0.1075
    ],
    [
      "commander",
      0.095
    ],
    [
      "appeler",
      0.08
    ],
    [
      "contraindre",
      0.08
    ],
    [
      "exiger",
      0.08
    ],
    [
      "obliger",
      0.0675
    ],
    [
      "requerir",
      0.0525
    ],
    [
      "susciter",
      0.04
    ],
    [
      "reclamer",
      0.04
    ],
    [
      "provoquer",
      0.04
    ],
    [
      "occasionner",
      0.04
    ],
    [
      "forcer",
      0.04
    ],
    [
      "determiner",
      0.04
    ],
    [
      "demander",
      0.04
    ],
    [
      "astreindre",
      0.025
    ],
    [
      "motiver",
      0.025
    ],
    [
      "reduire",
      0.0125
    ],
    [
      "meriter",
      0.0125
    ],
    [
      "impliquer",
      0.0125
    ],
    [
      "engendrer",
      0.0125
    ],
    [
      "creer",
      0.0125
    ],
    [
      "condamner",
      0.0125
    ],
    [
      "vouloir",
      0.0125
    ]
  ],
  "necessiter": [
    [
      "entrainer",
      0.1075
    ],
    [
      "commander",
      0.095
    ],
    [
      "appeler",
      0.08
    ],
    [
      "contraindre",
      0.08
    ],
    [
      "exiger",
      0.08
    ],
    [
      "obliger",
      0.0675
    ],
    [
      "requerir",
      0.0525
    ],
    [
      "susciter",
      0.04
    ],
    [
      "reclamer",
      0.04
    ],
    [
      "provoquer",
      0.04
    ],
    [
      "occasionner",
      0.04
    ],
    [
      "forcer",
      0.04
    ],
    [
      "determiner",
      0.04
    ],
    [
      "demander",
      0.04
    ],
    [
      "astreindre",
      0.025
    ],
    [
      "motiver",
      0.025
    ],
    [
      "reduire",
      0.0125
    ],
    [
      "meriter",
      0.0125
    ],
    [
      "impliquer",
      0.0125
    ],
    [
      "engendrer",
      0.0125
    ],
    [
      "creer",
      0.0125
    ],
    [
      "condamner",
      0.0125
    ],
    [
      "vouloir",
      0.0125
    ]
  ],
  "delice": [
    [
      "plaisir",
      0.15
    ],
    [
      "volupte",
      0.09
    ],
    [
      "bonheur",
      0.075
    ],
    [
      "delectation",
      0.075
    ],
    [
      "joie",
      0.075
    ],
    [
      "regal",
      0.06
    ],
    [
      "jouissance",
      0.06
    ],
    [
      "charme",
      0.06
    ],
    [
      "ravissement",
      0.045
    ],
    [
      "fete",
      0.045
    ],
    [
      "felicite",
      0.045
    ],
    [
      "enchantement",
      0.045
    ],
    [
      "blandice",
      0.045
    ],
    [
      "amusement",
      0.03
    ],
    [
      "caresse",
      0.03
    ],
    [
      "sensualite",
      0.03
    ],
    [
      "appas",
      0.015
    ],
    [
      "friandise",
      0.015
    ]
  ],
  "dependance": [
    [
      "assujettissement",
      0.0525
    ],
    [
      "servitude",
      0.0525
    ],
    [
      "sujetion",
      0.0475
    ],
    [
      "subordination",
      0.0425
    ],
    [
      "asservissement",
      0.0375
    ],
    [
      "rapport",
      0.0375
    ],
    [
      "soumission",
      0.0375
    ],
    [
      "chaine",
      0.0325
    ],
    [
      "pouvoir",
      0.0275
    ],
    [
      "esclavage",
      0.0275
    ],
    [
      "domination",
      0.0275
    ],
    [
      "contrainte",
      0.0225
    ],
    [
      "enchainement",
      0.0225
    ],
    [
      "joug",
      0.0225
    ],
    [
      "liaison",
      0.0225
    ],
    [
      "relation",
      0.0225
    ],
    [
      "obedience",
      0.0175
    ],
    [
      "correlation",
      0.0175
    ],
    [
      "consequence",
      0.0175
    ],
    [
      "suite",
      0.0125
    ],
    [
      "obeissance",
      0.0125
    ],
    [
      "main",
      0.0125
    ],
    [
      "griffe",
      0.0125
    ],
    [
      "emprise",
      0.0125
    ],
    [
      "effet",
      0.0125
    ],
    [
      "attachement",
      0.0125
    ],
    [
      "appartenance",
      0.0125
    ],
    [
      "annexe",
      0.0125
    ],
    [
      "allegeance",
      0.0125
    ],
    [
      "oppression",
      0.0075
    ],
    [
      "patte",
      0.0075
    ],
    [
      "tutelle",
      0.0075
    ],
    [
      "vassalite",
      0.0075
    ],
    [
      "interdependance",
      0.0075
    ],
    [
      "gene",
      0.0075
    ],
    [
      "ferule",
      0.0075
    ],
    [
      "coupe",
      0.0075
    ],
    [
      "correspondance",
      0.0075
    ],
    [
      "captivite",
      0.0075
    ],
    [
      "accessoire",
      0.0075
    ],
    [
      "puissance",
      0.0025
    ],
    [
      "mouvance",
      0.0025
    ],
    [
      "merci",
      0.0025
    ],
    [
      "mainmise",
      0.0025
    ],
    [
      "ressort",
      0.0025
    ],
    [
      "servage",
      0.0025
    ],
    [
      "solidarite",
      0.0025
    ],
    [
      "succursale",
      0.0025
    ],
    [
      "tenant",
      0.0025
    ],
    [
      "hangar",
      0.0025
    ],
    [
      "fief",
      0.0025
    ],
    [
      "aboutissant",
      0.0025
    ],
    [
      "accoutumance",
      0.0025
    ],
    [
      "addiction",
      0.0025
    ],
    [
      "analogie",
      0.0025
    ],
    [
      "appendice",
      0.0025
    ],
    [
      "batiment",
      0.0025
    ],
    [
      "causalite",
      0.0025
    ],
    [
      "complement",
      0.0025
    ],
    [
      "connexite",
      0.0025
    ],
    [
      "domesticite",
      0.0025
    ],
    [
      "episode",
      0.0025
    ]
  ],
  "effacer": [
    [
      "supprimer",
      0.1075
    ],
    [
      "oter",
      0.0575
    ],
    [
      "biffer",
      0.0525
    ],
    [
      "detruire",
      0.0525
    ],
    [
      "barrer",
      0.045
    ],
    [
      "enlever",
      0.045
    ],
    [
      "radier",
      0.045
    ],
    [
      "rayer",
      0.04
    ],
    [
      "annuler",
      0.0275
    ],
    [
      "abolir",
      0.0225
    ],
    [
      "couper",
      0.0225
    ],
    [
      "obscurcir",
      0.0225
    ],
    [
      "eteindre",
      0.0225
    ],
    [
      "excuser",
      0.02
    ],
    [
      "affadir",
      0.015
    ],
    [
      "eclipser",
      0.015
    ],
    [
      "ternir",
      0.015
    ],
    [
      "laver",
      0.015
    ],
    [
      "estomper",
      0.015
    ],
    [
      "couvrir",
      0.015
    ],
    [
      "censurer",
      0.015
    ],
    [
      "caviarder",
      0.015
    ],
    [
      "eliminer",
      0.01
    ],
    [
      "sabrer",
      0.01
    ],
    [
      "raturer",
      0.01
    ],
    [
      "pardonner",
      0.01
    ],
    [
      "obliterer",
      0.01
    ],
    [
      "lever",
      0.01
    ],
    [
      "justifier",
      0.01
    ],
    [
      "gratter",
      0.01
    ],
    [
      "absoudre",
      0.01
    ],
    [
      "resilier",
      0.0075
    ],
    [
      "guerir",
      0.0075
    ],
    [
      "gommer",
      0.0075
    ],
    [
      "canceller",
      0.0075
    ],
    [
      "affaiblir",
      0.0075
    ],
    [
      "fondre",
      0.0025
    ],
    [
      "oublier",
      0.0025
    ],
    [
      "purger",
      0.0025
    ],
    [
      "racheter",
      0.0025
    ],
    [
      "reparer",
      0.0025
    ],
    [
      "surpasser",
      0.0025
    ],
    [
      "echopper",
      0.0025
    ],
    [
      "faner",
      0.0025
    ],
    [
      "escamoter",
      0.0025
    ],
    [
      "encaisser",
      0.0025
    ],
    [
      "detroner",
      0.0025
    ],
    [
      "demarquer",
      0.0025
    ],
    [
      "croiser",
      0.0025
    ],
    [
      "annihiler",
      0.0025
    ],
    [
      "abroger",
      0.0025
    ],
    [
      "eradiquer",
      0.0025
    ]
  ],
  "revient": [
    [
      "renaitre",
      0.055
    ],
    [
      "recommencer",
      0.0475
    ],
    [
      "reprendre",
      0.0475
    ],
    [
      "retourner",
      0.0475
    ],
    [
      "regagner",
      0.0325
    ],
    [
      "reapparaitre",
      0.0275
    ],
    [
      "retomber",
      0.0275
    ],
    [
      "passer",
      0.0275
    ],
    [
      "recidiver",
      0.02
    ],
    [
      "ressortir",
      0.02
    ],
    [
      "repousser",
      0.02
    ],
    [
      "reparaitre",
      0.02
    ],
    [
      "rentrer",
      0.02
    ],
    [
      "rejoindre",
      0.02
    ],
    [
      "rallier",
      0.02
    ],
    [
      "incomber",
      0.02
    ],
    [
      "guerir",
      0.02
    ],
    [
      "appartenir",
      0.02
    ],
    [
      "satisfaire",
      0.0125
    ],
    [
      "sortir",
      0.0125
    ],
    [
      "valoir",
      0.0125
    ],
    [
      "echoir",
      0.0125
    ],
    [
      "recuperer",
      0.0125
    ],
    [
      "retrouver",
      0.0125
    ],
    [
      "apparaitre",
      0.0125
    ],
    [
      "convenir",
      0.0125
    ],
    [
      "reculer",
      0.0125
    ],
    [
      "refluer",
      0.0125
    ],
    [
      "relever",
      0.0125
    ],
    [
      "retrograder",
      0.005
    ],
    [
      "s'occuper",
      0.005
    ],
    [
      "sauter",
      0.005
    ],
    [
      "equivaloir",
      0.005
    ],
    [
      "reintegrer",
      0.005
    ],
    [
      "reexaminer",
      0.005
    ],
    [
      "ressurgir",
      0.005
    ],
    [
      "afferer",
      0.005
    ],
    [
      "agreer",
      0.005
    ],
    [
      "contremander",
      0.005
    ],
    [
      "couter",
      0.005
    ],
    [
      "obtenir",
      0.005
    ],
    [
      "plaire",
      0.005
    ],
    [
      "rappliquer",
      0.005
    ],
    [
      "reconduire",
      0.005
    ],
    [
      "reconsiderer",
      0.005
    ],
    [
      "reparler",
      0.005
    ],
    [
      "repasser",
      0.005
    ]
  ],
  "terebenthine": [
    [
      "resine",
      1.0
    ]
  ],
  "mariole": [
    [
      "barjo",
      0.2
    ],
    [
      "cingle",
      0.2
    ],
    [
      "debrouillard",
      0.2
    ],
    [
      "degourdi",
      0.2
    ],
    [
      "malin",
      0.2
    ]
  ],
  "pelle": [
    [
      "baiser",
      0.11
    ],
    [
      "bide",
      0.11
    ],
    [
      "bidon",
      0.11
    ],
    [
      "beche",
      0.11
    ],
    [
      "chute",
      0.11
    ],
    [
      "excavateur",
      0.11
    ],
    [
      "gadin",
      0.11
    ],
    [
      "palot",
      0.11
    ],
    [
      "sape",
      0.11
    ]
  ],
  "seau": [
    [
      "bassin",
      0.5
    ],
    [
      "bassine",
      0.25
    ],
    [
      "recipient",
      0.25
    ]
  ],
  "culotter": [
    [
      "bronzer",
      0.1525
    ],
    [
      "noircir",
      0.1525
    ],
    [
      "tanner",
      0.1525
    ],
    [
      "tacher",
      0.075
    ],
    [
      "salir",
      0.075
    ],
    [
      "roder",
      0.075
    ],
    [
      "patiner",
      0.075
    ],
    [
      "habiller",
      0.075
    ],
    [
      "bruler",
      0.075
    ],
    [
      "user",
      0.075
    ]
  ],
  "culotte": [
    [
      "pantalon",
      0.1475
    ],
    [
      "calecon",
      0.0625
    ],
    [
      "chausse",
      0.0625
    ],
    [
      "slip",
      0.0425
    ],
    [
      "gregues",
      0.0425
    ],
    [
      "chausses",
      0.0425
    ],
    [
      "knickerbockers",
      0.02
    ],
    [
      "lessivage",
      0.02
    ],
    [
      "lessive",
      0.02
    ],
    [
      "lingerie",
      0.02
    ],
    [
      "panty",
      0.02
    ],
    [
      "parure",
      0.02
    ],
    [
      "perte",
      0.02
    ],
    [
      "short",
      0.02
    ],
    [
      "string",
      0.02
    ],
    [
      "trousse",
      0.02
    ],
    [
      "ivresse",
      0.02
    ],
    [
      "grimpant",
      0.02
    ],
    [
      "froc",
      0.02
    ],
    [
      "bermuda",
      0.02
    ],
    [
      "bloomer",
      0.02
    ],
    [
      "braie",
      0.02
    ],
    [
      "benard",
      0.02
    ],
    [
      "collant",
      0.02
    ],
    [
      "cuisse",
      0.02
    ],
    [
      "culbutant",
      0.02
    ],
    [
      "dessous",
      0.02
    ],
    [
      "falzar",
      0.02
    ],
    [
      "flottard",
      0.02
    ],
    [
      "trousses",
      0.02
    ]
  ],
  "defends": [
    [
      "proteger",
      0.125
    ],
    [
      "soutenir",
      0.075
    ],
    [
      "garantir",
      0.055
    ],
    [
      "assurer",
      0.04
    ],
    [
      "interdire",
      0.04
    ],
    [
      "maintenir",
      0.04
    ],
    [
      "preserver",
      0.04
    ],
    [
      "sauvegarder",
      0.0325
    ],
    [
      "renforcer",
      0.0325
    ],
    [
      "empecher",
      0.0325
    ],
    [
      "couvrir",
      0.0325
    ],
    [
      "appuyer",
      0.0325
    ],
    [
      "prohiber",
      0.0275
    ],
    [
      "garder",
      0.0275
    ],
    [
      "fortifier",
      0.0275
    ],
    [
      "condamner",
      0.0275
    ],
    [
      "tenir",
      0.02
    ],
    [
      "justifier",
      0.02
    ],
    [
      "excuser",
      0.02
    ],
    [
      "aider",
      0.02
    ],
    [
      "secourir",
      0.0125
    ],
    [
      "sauver",
      0.0125
    ],
    [
      "s'opposer",
      0.0125
    ],
    [
      "proscrire",
      0.0125
    ],
    [
      "intervenir",
      0.0125
    ],
    [
      "inhiber",
      0.0125
    ],
    [
      "chaperonner",
      0.0125
    ],
    [
      "censurer",
      0.0125
    ],
    [
      "abriter",
      0.0125
    ],
    [
      "prescrire",
      0.005
    ],
    [
      "refuser",
      0.005
    ],
    [
      "reprouver",
      0.005
    ],
    [
      "plaider",
      0.005
    ],
    [
      "interceder",
      0.005
    ],
    [
      "flanquer",
      0.005
    ],
    [
      "fermer",
      0.005
    ],
    [
      "disputer",
      0.005
    ],
    [
      "disculper",
      0.005
    ],
    [
      "assister",
      0.005
    ]
  ],
  "macho": [
    [
      "male",
      0.5
    ],
    [
      "phallo",
      0.5
    ]
  ],
  "docteur": [
    [
      "medecin",
      0.22
    ],
    [
      "canoniste",
      0.11
    ],
    [
      "praticien",
      0.11
    ],
    [
      "professeur",
      0.11
    ],
    [
      "savant",
      0.11
    ],
    [
      "theologien",
      0.11
    ],
    [
      "toubib",
      0.11
    ],
    [
      "erudit",
      0.11
    ]
  ],
  "causer": [
    [
      "susciter",
      0.0875
    ],
    [
      "provoquer",
      0.085
    ],
    [
      "occasionner",
      0.075
    ],
    [
      "determiner",
      0.0575
    ],
    [
      "produire",
      0.0475
    ],
    [
      "soulever",
      0.0475
    ],
    [
      "entrainer",
      0.04
    ],
    [
      "bavarder",
      0.04
    ],
    [
      "parler",
      0.0375
    ],
    [
      "donner",
      0.025
    ],
    [
      "exciter",
      0.025
    ],
    [
      "procurer",
      0.0225
    ],
    [
      "jaboter",
      0.0225
    ],
    [
      "faire",
      0.0225
    ],
    [
      "engendrer",
      0.0225
    ],
    [
      "allumer",
      0.02
    ],
    [
      "amener",
      0.015
    ],
    [
      "apporter",
      0.015
    ],
    [
      "creer",
      0.015
    ],
    [
      "papoter",
      0.0125
    ],
    [
      "inspirer",
      0.0125
    ],
    [
      "converser",
      0.0125
    ],
    [
      "attirer",
      0.0125
    ],
    [
      "potiner",
      0.01
    ],
    [
      "parloter",
      0.01
    ],
    [
      "jaser",
      0.01
    ],
    [
      "jacasser",
      0.01
    ],
    [
      "former",
      0.01
    ],
    [
      "declencher",
      0.01
    ],
    [
      "conferer",
      0.01
    ],
    [
      "valoir",
      0.005
    ],
    [
      "s'entretenir",
      0.005
    ],
    [
      "motiver",
      0.005
    ],
    [
      "jaspiner",
      0.005
    ],
    [
      "fomenter",
      0.005
    ],
    [
      "disserter",
      0.005
    ],
    [
      "discuter",
      0.005
    ],
    [
      "discourir",
      0.005
    ],
    [
      "dialoguer",
      0.005
    ],
    [
      "commerer",
      0.005
    ],
    [
      "cancaner",
      0.005
    ],
    [
      "jeter",
      0.0025
    ],
    [
      "giberner",
      0.0025
    ],
    [
      "deviser",
      0.0025
    ],
    [
      "confabuler",
      0.0025
    ],
    [
      "blaguer",
      0.0025
    ]
  ],
  "cause": [
    [
      "motif",
      0.065
    ],
    [
      "principe",
      0.065
    ],
    [
      "origine",
      0.0525
    ],
    [
      "raison",
      0.045
    ],
    [
      "germe",
      0.045
    ],
    [
      "fondement",
      0.045
    ],
    [
      "agent",
      0.035
    ],
    [
      "matiere",
      0.035
    ],
    [
      "sujet",
      0.0275
    ],
    [
      "pretexte",
      0.0275
    ],
    [
      "occasion",
      0.0275
    ],
    [
      "affaire",
      0.0275
    ],
    [
      "moteur",
      0.0225
    ],
    [
      "element",
      0.0225
    ],
    [
      "substance",
      0.02
    ],
    [
      "promoteur",
      0.02
    ],
    [
      "mobile",
      0.02
    ],
    [
      "lieu",
      0.02
    ],
    [
      "ferment",
      0.02
    ],
    [
      "but",
      0.02
    ],
    [
      "auteur",
      0.02
    ],
    [
      "source",
      0.015
    ],
    [
      "rapport",
      0.015
    ],
    [
      "objet",
      0.015
    ],
    [
      "convention",
      0.015
    ],
    [
      "condition",
      0.015
    ],
    [
      "cas",
      0.015
    ],
    [
      "brandon",
      0.015
    ],
    [
      "base",
      0.015
    ],
    [
      "ressort",
      0.01
    ],
    [
      "proces",
      0.01
    ],
    [
      "moyen",
      0.01
    ],
    [
      "intention",
      0.01
    ],
    [
      "facteur",
      0.01
    ],
    [
      "createur",
      0.01
    ],
    [
      "action",
      0.01
    ],
    [
      "modalite",
      0.0075
    ],
    [
      "inspirateur",
      0.0075
    ],
    [
      "espece",
      0.0075
    ],
    [
      "litige",
      0.0025
    ],
    [
      "mere",
      0.0025
    ],
    [
      "parti",
      0.0025
    ],
    [
      "pourquoi",
      0.0025
    ],
    [
      "role",
      0.0025
    ],
    [
      "semence",
      0.0025
    ],
    [
      "stipulation",
      0.0025
    ],
    [
      "etincelle",
      0.0025
    ],
    [
      "interet",
      0.0025
    ],
    [
      "instigateur",
      0.0025
    ],
    [
      "artisan",
      0.0025
    ],
    [
      "chicane",
      0.0025
    ],
    [
      "declencheur",
      0.0025
    ],
    [
      "defense",
      0.0025
    ],
    [
      "depart",
      0.0025
    ],
    [
      "explication",
      0.0025
    ],
    [
      "finalite",
      0.0025
    ],
    [
      "inspiration",
      0.0025
    ],
    [
      "etiologie",
      0.0025
    ]
  ],
  "draguer": [
    [
      "curer",
      0.2
    ],
    [
      "accoster",
      0.1
    ],
    [
      "chasser",
      0.1
    ],
    [
      "courir",
      0.1
    ],
    [
      "debourber",
      0.1
    ],
    [
      "devaser",
      0.1
    ],
    [
      "lever",
      0.1
    ],
    [
      "nettoyer",
      0.1
    ],
    [
      "racoler",
      0.1
    ]
  ],
  "tienne": [
    [
      "retenir",
      0.07
    ],
    [
      "contenir",
      0.035
    ],
    [
      "fixer",
      0.0325
    ],
    [
      "prendre",
      0.0325
    ],
    [
      "attacher",
      0.0325
    ],
    [
      "maintenir",
      0.025
    ],
    [
      "arreter",
      0.0225
    ],
    [
      "enchainer",
      0.02
    ],
    [
      "demeurer",
      0.02
    ],
    [
      "assujettir",
      0.02
    ],
    [
      "durer",
      0.0175
    ],
    [
      "observer",
      0.0175
    ],
    [
      "soutenir",
      0.0175
    ],
    [
      "occuper",
      0.015
    ],
    [
      "garder",
      0.015
    ],
    [
      "continuer",
      0.015
    ],
    [
      "avoir",
      0.0125
    ],
    [
      "embrasser",
      0.0125
    ],
    [
      "suivre",
      0.0125
    ],
    [
      "rester",
      0.0125
    ],
    [
      "mettre",
      0.0125
    ],
    [
      "immobiliser",
      0.0125
    ],
    [
      "faire",
      0.0125
    ],
    [
      "contraindre",
      0.0125
    ],
    [
      "appuyer",
      0.0125
    ],
    [
      "s'etendre",
      0.01
    ],
    [
      "posseder",
      0.01
    ],
    [
      "emprisonner",
      0.01
    ],
    [
      "coller",
      0.01
    ],
    [
      "brider",
      0.01
    ],
    [
      "trainer",
      0.0075
    ],
    [
      "pratiquer",
      0.0075
    ],
    [
      "porter",
      0.0075
    ],
    [
      "freiner",
      0.0075
    ],
    [
      "executer",
      0.0075
    ],
    [
      "engager",
      0.0075
    ],
    [
      "empecher",
      0.0075
    ],
    [
      "detenir",
      0.0075
    ],
    [
      "conserver",
      0.0075
    ],
    [
      "coincer",
      0.0075
    ],
    [
      "renfermer",
      0.0075
    ],
    [
      "perseverer",
      0.0075
    ],
    [
      "persister",
      0.0075
    ],
    [
      "endiguer",
      0.0075
    ],
    [
      "consigner",
      0.0075
    ],
    [
      "adherer",
      0.0075
    ],
    [
      "supporter",
      0.005
    ],
    [
      "subsister",
      0.005
    ],
    [
      "saisir",
      0.005
    ],
    [
      "s'attacher",
      0.005
    ],
    [
      "mener",
      0.005
    ],
    [
      "maitriser",
      0.005
    ],
    [
      "loger",
      0.005
    ],
    [
      "lier",
      0.005
    ],
    [
      "diriger",
      0.005
    ],
    [
      "recevoir",
      0.005
    ],
    [
      "remplir",
      0.005
    ],
    [
      "respecter",
      0.005
    ],
    [
      "resister",
      0.005
    ],
    [
      "moderer",
      0.005
    ],
    [
      "gouverner",
      0.005
    ],
    [
      "accomplir",
      0.005
    ],
    [
      "accrocher",
      0.005
    ],
    [
      "astreindre",
      0.005
    ],
    [
      "comprimer",
      0.005
    ],
    [
      "entrer",
      0.005
    ],
    [
      "venir",
      0.0025
    ],
    [
      "s'obstiner",
      0.0025
    ],
    [
      "resulter",
      0.0025
    ],
    [
      "ressortir",
      0.0025
    ],
    [
      "rendre",
      0.0025
    ],
    [
      "participer",
      0.0025
    ],
    [
      "manier",
      0.0025
    ],
    [
      "dependre",
      0.0025
    ],
    [
      "defendre",
      0.0025
    ],
    [
      "amarrer",
      0.0025
    ],
    [
      "absorber",
      0.0025
    ],
    [
      "resider",
      0.0025
    ],
    [
      "s'acquitter",
      0.0025
    ],
    [
      "s'etaler",
      0.0025
    ],
    [
      "satisfaire",
      0.0025
    ],
    [
      "surveiller",
      0.0025
    ],
    [
      "etreindre",
      0.0025
    ],
    [
      "ralentir",
      0.0025
    ],
    [
      "provenir",
      0.0025
    ],
    [
      "jouer",
      0.0025
    ],
    [
      "accaparer",
      0.0025
    ],
    [
      "administrer",
      0.0025
    ],
    [
      "clouer",
      0.0025
    ],
    [
      "comporter",
      0.0025
    ],
    [
      "discuter",
      0.0025
    ],
    [
      "exercer",
      0.0025
    ],
    [
      "jauger",
      0.0025
    ],
    [
      "s'etirer",
      0.0
    ],
    [
      "recouvrir",
      0.0
    ],
    [
      "naviguer",
      0.0
    ],
    [
      "gerer",
      0.0
    ],
    [
      "envisager",
      0.0
    ],
    [
      "effectuer",
      0.0
    ],
    [
      "deliberer",
      0.0
    ],
    [
      "appartenir",
      0.0
    ],
    [
      "agripper",
      0.0
    ]
  ],
  "cartable": [
    [
      "portefeuille",
      0.2125
    ],
    [
      "sacoche",
      0.2125
    ],
    [
      "carton",
      0.1425
    ],
    [
      "serviette",
      0.1425
    ],
    [
      "musette",
      0.07
    ],
    [
      "sac",
      0.07
    ]
  ],
  "fantome": [
    [
      "spectre",
      0.1225
    ],
    [
      "ombre",
      0.1
    ],
    [
      "revenant",
      0.0775
    ],
    [
      "vision",
      0.0775
    ],
    [
      "illusion",
      0.0675
    ],
    [
      "chimere",
      0.055
    ],
    [
      "simulacre",
      0.0325
    ],
    [
      "fantoche",
      0.0325
    ],
    [
      "fantasme",
      0.0325
    ],
    [
      "zombi",
      0.02
    ],
    [
      "songe",
      0.02
    ],
    [
      "semblant",
      0.02
    ],
    [
      "phantasme",
      0.02
    ],
    [
      "mort",
      0.02
    ],
    [
      "lemure",
      0.02
    ],
    [
      "irreel",
      0.02
    ],
    [
      "inexistant",
      0.02
    ],
    [
      "apparence",
      0.02
    ],
    [
      "apparition",
      0.02
    ],
    [
      "double",
      0.02
    ],
    [
      "ectoplasme",
      0.02
    ],
    [
      "esprit",
      0.02
    ],
    [
      "idee",
      0.02
    ],
    [
      "vampire",
      0.01
    ],
    [
      "squelette",
      0.01
    ],
    [
      "pantin",
      0.01
    ],
    [
      "maigre",
      0.01
    ],
    [
      "larve",
      0.01
    ],
    [
      "fiction",
      0.01
    ],
    [
      "epouvantail",
      0.01
    ]
  ],
  "mome": [
    [
      "enfant",
      0.2225
    ],
    [
      "bebe",
      0.11
    ],
    [
      "gamin",
      0.11
    ],
    [
      "gosse",
      0.11
    ],
    [
      "moutard",
      0.11
    ],
    [
      "momichon",
      0.035
    ],
    [
      "moujingue",
      0.035
    ],
    [
      "mioche",
      0.035
    ],
    [
      "loupiot",
      0.035
    ],
    [
      "gnard",
      0.035
    ],
    [
      "giton",
      0.035
    ],
    [
      "chiard",
      0.035
    ],
    [
      "amante",
      0.035
    ],
    [
      "petit",
      0.035
    ]
  ],
  "tatouer": [
    [
      "graver",
      0.3325
    ],
    [
      "inscrire",
      0.3325
    ],
    [
      "marquer",
      0.3325
    ]
  ],
  "machin": [
    [
      "truc",
      0.2375
    ],
    [
      "bidule",
      0.1825
    ],
    [
      "instrument",
      0.105
    ],
    [
      "affaire",
      0.0775
    ],
    [
      "chose",
      0.0775
    ],
    [
      "engin",
      0.0775
    ],
    [
      "fourbi",
      0.05
    ],
    [
      "bazar",
      0.05
    ],
    [
      "histoire",
      0.025
    ],
    [
      "machine",
      0.025
    ],
    [
      "patente",
      0.025
    ],
    [
      "ustensile",
      0.025
    ],
    [
      "zinzin",
      0.025
    ]
  ],
  "clou": [
    [
      "automobile",
      0.0525
    ],
    [
      "cheville",
      0.0525
    ],
    [
      "chignole",
      0.0525
    ],
    [
      "semence",
      0.0525
    ],
    [
      "voiture",
      0.0525
    ],
    [
      "instrument",
      0.025
    ],
    [
      "guimbarde",
      0.025
    ],
    [
      "furoncle",
      0.025
    ],
    [
      "crampillon",
      0.025
    ],
    [
      "couronnement",
      0.025
    ],
    [
      "pointe",
      0.025
    ],
    [
      "principal",
      0.025
    ],
    [
      "prison",
      0.025
    ],
    [
      "punaise",
      0.025
    ],
    [
      "pustule",
      0.025
    ],
    [
      "tumeur",
      0.025
    ],
    [
      "clavette",
      0.025
    ],
    [
      "chevillette",
      0.025
    ],
    [
      "abces",
      0.025
    ],
    [
      "apotheose",
      0.025
    ],
    [
      "attraction",
      0.025
    ],
    [
      "bagnole",
      0.025
    ],
    [
      "bequet",
      0.025
    ],
    [
      "bicyclette",
      0.025
    ],
    [
      "bossette",
      0.025
    ],
    [
      "broquette",
      0.025
    ],
    [
      "becane",
      0.025
    ],
    [
      "caboche",
      0.025
    ],
    [
      "cabochon",
      0.025
    ],
    [
      "cavalier",
      0.025
    ],
    [
      "velo",
      0.025
    ]
  ],
  "cuir": [
    [
      "peau",
      0.2375
    ],
    [
      "faute",
      0.1
    ],
    [
      "erreur",
      0.0675
    ],
    [
      "lapsus",
      0.0675
    ],
    [
      "daim",
      0.0325
    ],
    [
      "galuchat",
      0.0325
    ],
    [
      "manteau",
      0.0325
    ],
    [
      "pataques",
      0.0325
    ],
    [
      "peausserie",
      0.0325
    ],
    [
      "vachette",
      0.0325
    ],
    [
      "croupon",
      0.0325
    ],
    [
      "chamois",
      0.0325
    ],
    [
      "chagrin",
      0.0325
    ],
    [
      "bevue",
      0.0325
    ],
    [
      "bidoche",
      0.0325
    ],
    [
      "basane",
      0.0325
    ],
    [
      "ballon",
      0.0325
    ],
    [
      "asbeste",
      0.0325
    ],
    [
      "velin",
      0.0325
    ]
  ],
  "blouson": [
    [
      "veste",
      0.5
    ]
  ],
  "gonzesse": [
    [
      "amante",
      0.3325
    ],
    [
      "fille",
      0.3325
    ],
    [
      "salope",
      0.3325
    ]
  ],
  "demettre": [
    [
      "destituer",
      0.12
    ],
    [
      "revoquer",
      0.1025
    ],
    [
      "detroner",
      0.085
    ],
    [
      "renvoyer",
      0.0675
    ],
    [
      "deposer",
      0.0675
    ],
    [
      "deboiter",
      0.0675
    ],
    [
      "disloquer",
      0.0675
    ],
    [
      "casser",
      0.0675
    ],
    [
      "demancher",
      0.05
    ],
    [
      "suspendre",
      0.0325
    ],
    [
      "luxer",
      0.0325
    ],
    [
      "deplacer",
      0.0325
    ],
    [
      "demissionner",
      0.0325
    ],
    [
      "chasser",
      0.0325
    ],
    [
      "abdiquer",
      0.015
    ],
    [
      "debouter",
      0.015
    ],
    [
      "demantibuler",
      0.015
    ],
    [
      "desarticuler",
      0.015
    ],
    [
      "fouler",
      0.015
    ],
    [
      "retirer",
      0.015
    ]
  ],
  "moineau": [
    [
      "homme",
      0.23
    ],
    [
      "individu",
      0.1525
    ],
    [
      "oiseau",
      0.1525
    ],
    [
      "pierrot",
      0.1525
    ],
    [
      "biquet",
      0.075
    ],
    [
      "gaillard",
      0.075
    ],
    [
      "personne",
      0.075
    ],
    [
      "piaf",
      0.075
    ]
  ],
  "miche": [
    [
      "fesse",
      0.25
    ],
    [
      "meule",
      0.25
    ],
    [
      "pain",
      0.25
    ]
  ],
  "noisette": [
    [
      "charbon",
      0.3325
    ],
    [
      "crotte",
      0.3325
    ],
    [
      "noix",
      0.3325
    ]
  ],
  "risque": [
    [
      "hasarder",
      0.1
    ],
    [
      "aventurer",
      0.065
    ],
    [
      "tenter",
      0.065
    ],
    [
      "s'exposer",
      0.0425
    ],
    [
      "oser",
      0.0425
    ],
    [
      "exposer",
      0.0425
    ],
    [
      "essayer",
      0.0425
    ],
    [
      "entreprendre",
      0.0425
    ],
    [
      "ponter",
      0.0325
    ],
    [
      "miser",
      0.0325
    ],
    [
      "engager",
      0.0325
    ],
    [
      "defier",
      0.0325
    ],
    [
      "braver",
      0.0325
    ],
    [
      "emettre",
      0.02
    ],
    [
      "placer",
      0.02
    ],
    [
      "jouer",
      0.02
    ],
    [
      "gager",
      0.02
    ],
    [
      "experimenter",
      0.02
    ],
    [
      "compromettre",
      0.02
    ],
    [
      "chercher",
      0.02
    ],
    [
      "affronter",
      0.02
    ],
    [
      "pouvoir",
      0.01
    ],
    [
      "menacer",
      0.01
    ],
    [
      "manquer",
      0.01
    ],
    [
      "froler",
      0.01
    ],
    [
      "friser",
      0.01
    ],
    [
      "encourir",
      0.01
    ],
    [
      "couler",
      0.01
    ],
    [
      "commettre",
      0.01
    ],
    [
      "eprouver",
      0.01
    ]
  ],
  "risquer": [
    [
      "hasarder",
      0.1
    ],
    [
      "aventurer",
      0.065
    ],
    [
      "tenter",
      0.065
    ],
    [
      "s'exposer",
      0.0425
    ],
    [
      "oser",
      0.0425
    ],
    [
      "exposer",
      0.0425
    ],
    [
      "essayer",
      0.0425
    ],
    [
      "entreprendre",
      0.0425
    ],
    [
      "ponter",
      0.0325
    ],
    [
      "miser",
      0.0325
    ],
    [
      "engager",
      0.0325
    ],
    [
      "defier",
      0.0325
    ],
    [
      "braver",
      0.0325
    ],
    [
      "emettre",
      0.02
    ],
    [
      "placer",
      0.02
    ],
    [
      "jouer",
      0.02
    ],
    [
      "gager",
      0.02
    ],
    [
      "experimenter",
      0.02
    ],
    [
      "compromettre",
      0.02
    ],
    [
      "chercher",
      0.02
    ],
    [
      "affronter",
      0.02
    ],
    [
      "pouvoir",
      0.01
    ],
    [
      "menacer",
      0.01
    ],
    [
      "manquer",
      0.01
    ],
    [
      "froler",
      0.01
    ],
    [
      "friser",
      0.01
    ],
    [
      "encourir",
      0.01
    ],
    [
      "couler",
      0.01
    ],
    [
      "commettre",
      0.01
    ],
    [
      "eprouver",
      0.01
    ]
  ],
  "tas": [
    [
      "amas",
      0.14
    ],
    [
      "masse",
      0.07
    ],
    [
      "accumulation",
      0.0675
    ],
    [
      "foule",
      0.0625
    ],
    [
      "quantite",
      0.055
    ],
    [
      "assemblage",
      0.0525
    ],
    [
      "multitude",
      0.0425
    ],
    [
      "monceau",
      0.0425
    ],
    [
      "entassement",
      0.0375
    ],
    [
      "affluence",
      0.03
    ],
    [
      "amoncellement",
      0.03
    ],
    [
      "reunion",
      0.0275
    ],
    [
      "rassemblement",
      0.025
    ],
    [
      "agglomeration",
      0.0225
    ],
    [
      "agglomerat",
      0.0225
    ],
    [
      "montagne",
      0.0175
    ],
    [
      "fatras",
      0.015
    ],
    [
      "bloc",
      0.0125
    ],
    [
      "collection",
      0.0125
    ],
    [
      "ramassis",
      0.01
    ],
    [
      "pile",
      0.01
    ],
    [
      "peuple",
      0.01
    ],
    [
      "paquet",
      0.01
    ],
    [
      "concours",
      0.01
    ],
    [
      "tapee",
      0.0075
    ],
    [
      "ribambelle",
      0.0075
    ],
    [
      "nuee",
      0.0075
    ],
    [
      "encombrement",
      0.0075
    ],
    [
      "botte",
      0.0075
    ],
    [
      "attroupement",
      0.0075
    ],
    [
      "attirail",
      0.0075
    ],
    [
      "armee",
      0.0075
    ],
    [
      "tripotee",
      0.0025
    ],
    [
      "ramas",
      0.0025
    ],
    [
      "presse",
      0.0025
    ],
    [
      "pleiade",
      0.0025
    ],
    [
      "monticule",
      0.0025
    ],
    [
      "liasse",
      0.0025
    ],
    [
      "empilement",
      0.0025
    ],
    [
      "depot",
      0.0025
    ],
    [
      "concentration",
      0.0025
    ],
    [
      "agregat",
      0.0025
    ],
    [
      "mont",
      0.0
    ],
    [
      "tapin",
      0.0
    ],
    [
      "tasseau",
      0.0
    ],
    [
      "touffe",
      0.0
    ],
    [
      "echafaudage",
      0.0
    ],
    [
      "meule",
      0.0
    ],
    [
      "foultitude",
      0.0
    ],
    [
      "decombres",
      0.0
    ],
    [
      "bazar",
      0.0
    ],
    [
      "batelee",
      0.0
    ],
    [
      "bataclan",
      0.0
    ],
    [
      "alluvion",
      0.0
    ],
    [
      "ecroulement",
      0.0
    ]
  ],
  "frangin": [
    [
      "frere",
      1.0
    ]
  ],
  "magasin": [
    [
      "boutique",
      0.095
    ],
    [
      "abri",
      0.06
    ],
    [
      "entrepot",
      0.06
    ],
    [
      "reserve",
      0.06
    ],
    [
      "affaire",
      0.0475
    ],
    [
      "depot",
      0.0475
    ],
    [
      "etablissement",
      0.0475
    ],
    [
      "resserre",
      0.035
    ],
    [
      "hangar",
      0.035
    ],
    [
      "chantier",
      0.035
    ],
    [
      "bazar",
      0.035
    ],
    [
      "silo",
      0.0225
    ],
    [
      "fonds",
      0.0225
    ],
    [
      "debit",
      0.0225
    ],
    [
      "dock",
      0.0225
    ],
    [
      "comptoir",
      0.0225
    ],
    [
      "commerce",
      0.0225
    ],
    [
      "officine",
      0.01
    ],
    [
      "pavillon",
      0.01
    ],
    [
      "pavillonnerie",
      0.01
    ],
    [
      "poudriere",
      0.01
    ],
    [
      "revue",
      0.01
    ],
    [
      "soute",
      0.01
    ],
    [
      "stand",
      0.01
    ],
    [
      "succursale",
      0.01
    ],
    [
      "supermarche",
      0.01
    ],
    [
      "echoppe",
      0.01
    ],
    [
      "etal",
      0.01
    ],
    [
      "manutention",
      0.01
    ],
    [
      "magazine",
      0.01
    ],
    [
      "arsenal",
      0.01
    ],
    [
      "buffet",
      0.01
    ],
    [
      "cambuse",
      0.01
    ],
    [
      "chai",
      0.01
    ],
    [
      "grange",
      0.01
    ],
    [
      "halle",
      0.01
    ],
    [
      "hypermarche",
      0.01
    ]
  ],
  "assez": [
    [
      "beaucoup",
      0.11
    ],
    [
      "passablement",
      0.11
    ],
    [
      "suffisamment",
      0.11
    ],
    [
      "tres",
      0.055
    ],
    [
      "suffit",
      0.055
    ],
    [
      "rideau",
      0.055
    ],
    [
      "relativement",
      0.055
    ],
    [
      "plutot",
      0.055
    ],
    [
      "marre",
      0.055
    ]
  ],
  "nombreux": [
    [
      "abondant",
      0.1175
    ],
    [
      "grand",
      0.1175
    ],
    [
      "gros",
      0.1175
    ],
    [
      "vaste",
      0.1175
    ],
    [
      "fort",
      0.0875
    ],
    [
      "considerable",
      0.0875
    ],
    [
      "dense",
      0.0575
    ],
    [
      "important",
      0.0575
    ],
    [
      "populeux",
      0.0275
    ],
    [
      "multiples",
      0.0275
    ],
    [
      "maint",
      0.0275
    ],
    [
      "innombrable",
      0.0275
    ],
    [
      "harmonieux",
      0.0275
    ],
    [
      "frequent",
      0.0275
    ],
    [
      "cadence",
      0.0275
    ],
    [
      "varie",
      0.0275
    ]
  ],
  "tremble": [
    [
      "peuplier",
      0.2
    ],
    [
      "torpille",
      0.2
    ],
    [
      "tremblante",
      0.2
    ],
    [
      "trembleux",
      0.2
    ],
    [
      "tremouline",
      0.2
    ]
  ],
  "embarquer": [
    [
      "prendre",
      0.12
    ],
    [
      "entrainer",
      0.1
    ],
    [
      "porter",
      0.08
    ],
    [
      "enlever",
      0.08
    ],
    [
      "engager",
      0.08
    ],
    [
      "emporter",
      0.08
    ],
    [
      "charger",
      0.06
    ],
    [
      "pousser",
      0.06
    ],
    [
      "monter",
      0.04
    ],
    [
      "mener",
      0.04
    ],
    [
      "embringuer",
      0.04
    ],
    [
      "emballer",
      0.04
    ],
    [
      "commencer",
      0.04
    ],
    [
      "arreter",
      0.04
    ],
    [
      "emplir",
      0.0175
    ],
    [
      "emprisonner",
      0.0175
    ],
    [
      "empetrer",
      0.0175
    ],
    [
      "ratiboiser",
      0.0175
    ],
    [
      "remplir",
      0.0175
    ]
  ],
  "arche": [
    [
      "arc",
      0.165
    ],
    [
      "arcade",
      0.165
    ],
    [
      "bateau",
      0.165
    ],
    [
      "coffre",
      0.165
    ],
    [
      "ponceau",
      0.165
    ],
    [
      "voute",
      0.165
    ]
  ],
  "marmot": [
    [
      "gamin",
      0.2
    ],
    [
      "enfant",
      0.16
    ],
    [
      "mioche",
      0.1175
    ],
    [
      "petiot",
      0.08
    ],
    [
      "marmouset",
      0.08
    ],
    [
      "bebe",
      0.08
    ],
    [
      "bambin",
      0.08
    ],
    [
      "figurine",
      0.0375
    ],
    [
      "heurtoir",
      0.0375
    ],
    [
      "marmaille",
      0.0375
    ],
    [
      "moutard",
      0.0375
    ],
    [
      "statuette",
      0.0375
    ]
  ],
  "cimetiere": [
    [
      "necropole",
      0.3825
    ],
    [
      "ossuaire",
      0.1525
    ],
    [
      "camposanto",
      0.075
    ],
    [
      "catacombe",
      0.075
    ],
    [
      "charnier",
      0.075
    ],
    [
      "columbarium",
      0.075
    ],
    [
      "crypte",
      0.075
    ]
  ],
  "rougir": [
    [
      "colorer",
      0.1
    ],
    [
      "s'embraser",
      0.1
    ],
    [
      "roussir",
      0.1
    ],
    [
      "ensanglanter",
      0.1
    ],
    [
      "enflammer",
      0.1
    ],
    [
      "empourprer",
      0.1
    ],
    [
      "dorer",
      0.1
    ],
    [
      "cramoisir",
      0.1
    ],
    [
      "s'empourprer",
      0.1
    ]
  ],
  "fleuve": [
    [
      "flot",
      0.175
    ],
    [
      "multitude",
      0.175
    ],
    [
      "quantite",
      0.1175
    ],
    [
      "riviere",
      0.1175
    ],
    [
      "ruisseau",
      0.1175
    ],
    [
      "torrent",
      0.1175
    ],
    [
      "mer",
      0.0575
    ]
  ],
  "chapelle": [
    [
      "coterie",
      0.1875
    ],
    [
      "clan",
      0.155
    ],
    [
      "groupe",
      0.12
    ],
    [
      "camarilla",
      0.0675
    ],
    [
      "secte",
      0.0675
    ],
    [
      "eglise",
      0.05
    ],
    [
      "clique",
      0.05
    ],
    [
      "cercle",
      0.05
    ],
    [
      "ecole",
      0.0325
    ],
    [
      "parti",
      0.0325
    ],
    [
      "faction",
      0.0325
    ],
    [
      "cenacle",
      0.0325
    ],
    [
      "boutique",
      0.0325
    ],
    [
      "cantor",
      0.015
    ],
    [
      "catafalque",
      0.015
    ],
    [
      "chapiteau",
      0.015
    ],
    [
      "oratoire",
      0.015
    ]
  ],
  "univers": [
    [
      "monde",
      0.2
    ],
    [
      "domaine",
      0.1
    ],
    [
      "sphere",
      0.08
    ],
    [
      "terre",
      0.06
    ],
    [
      "pays",
      0.06
    ],
    [
      "nature",
      0.06
    ],
    [
      "globe",
      0.06
    ],
    [
      "espace",
      0.06
    ],
    [
      "regne",
      0.0375
    ],
    [
      "royaume",
      0.0375
    ],
    [
      "cosmos",
      0.0375
    ],
    [
      "ciel",
      0.0375
    ],
    [
      "planete",
      0.0175
    ],
    [
      "macrocosme",
      0.0175
    ],
    [
      "humanite",
      0.0175
    ],
    [
      "hommes",
      0.0175
    ],
    [
      "galaxie",
      0.0175
    ],
    [
      "ensemble",
      0.0175
    ],
    [
      "creation",
      0.0175
    ],
    [
      "tout",
      0.0175
    ]
  ],
  "grain": [
    [
      "brin",
      0.0675
    ],
    [
      "goutte",
      0.0675
    ],
    [
      "pointe",
      0.0675
    ],
    [
      "peu",
      0.0575
    ],
    [
      "nuance",
      0.0475
    ],
    [
      "once",
      0.0475
    ],
    [
      "parcelle",
      0.0475
    ],
    [
      "soupcon",
      0.0475
    ],
    [
      "poids",
      0.0375
    ],
    [
      "pluie",
      0.0375
    ],
    [
      "morceau",
      0.0375
    ],
    [
      "atome",
      0.0275
    ],
    [
      "averse",
      0.0275
    ],
    [
      "particule",
      0.0275
    ],
    [
      "teinte",
      0.0175
    ],
    [
      "semence",
      0.0175
    ],
    [
      "pilule",
      0.0175
    ],
    [
      "graine",
      0.0175
    ],
    [
      "globule",
      0.0175
    ],
    [
      "grenaille",
      0.0075
    ],
    [
      "grele",
      0.0075
    ],
    [
      "irregularite",
      0.0075
    ],
    [
      "ondee",
      0.0075
    ],
    [
      "perle",
      0.0075
    ],
    [
      "pigment",
      0.0075
    ],
    [
      "rafale",
      0.0075
    ],
    [
      "saucee",
      0.0075
    ],
    [
      "scrupule",
      0.0075
    ],
    [
      "tempete",
      0.0075
    ],
    [
      "tornade",
      0.0075
    ],
    [
      "granule",
      0.0075
    ],
    [
      "giboulee",
      0.0075
    ],
    [
      "bourrasque",
      0.0075
    ],
    [
      "carat",
      0.0075
    ],
    [
      "caryopse",
      0.0075
    ],
    [
      "corpuscule",
      0.0075
    ],
    [
      "farrago",
      0.0075
    ],
    [
      "fougue",
      0.0075
    ],
    [
      "fragment",
      0.0075
    ],
    [
      "fruit",
      0.0075
    ],
    [
      "germe",
      0.0075
    ],
    [
      "baie",
      0.0075
    ]
  ],
  "page": [
    [
      "chevalier",
      0.0625
    ],
    [
      "evenement",
      0.0625
    ],
    [
      "epoque",
      0.0625
    ],
    [
      "ecuyer",
      0.0625
    ],
    [
      "varlet",
      0.0625
    ],
    [
      "valet",
      0.0625
    ],
    [
      "passage",
      0.0625
    ],
    [
      "pageot",
      0.0625
    ],
    [
      "morceau",
      0.0625
    ],
    [
      "moment",
      0.0625
    ],
    [
      "lit",
      0.0625
    ],
    [
      "domestique",
      0.0625
    ],
    [
      "paddock",
      0.03
    ],
    [
      "menin",
      0.03
    ],
    [
      "jour",
      0.03
    ],
    [
      "feuillet",
      0.03
    ],
    [
      "feuille",
      0.03
    ],
    [
      "fait",
      0.03
    ],
    [
      "extrait",
      0.03
    ],
    [
      "pagnot",
      0.03
    ]
  ],
  "horizon": [
    [
      "site",
      0.12
    ],
    [
      "vue",
      0.12
    ],
    [
      "etendue",
      0.12
    ],
    [
      "perspective",
      0.08
    ],
    [
      "paysage",
      0.08
    ],
    [
      "distance",
      0.08
    ],
    [
      "champ",
      0.08
    ],
    [
      "avenir",
      0.04
    ],
    [
      "ligne",
      0.04
    ],
    [
      "lointain",
      0.04
    ],
    [
      "panorama",
      0.04
    ],
    [
      "zenith",
      0.04
    ]
  ],
  "saison": [
    [
      "siecle",
      0.18
    ],
    [
      "temps",
      0.18
    ],
    [
      "epoque",
      0.18
    ],
    [
      "calendrier",
      0.09
    ],
    [
      "campagne",
      0.09
    ],
    [
      "moment",
      0.09
    ],
    [
      "periode",
      0.09
    ],
    [
      "age",
      0.09
    ]
  ],
  "rivage": [
    [
      "pays",
      0.1725
    ],
    [
      "bord",
      0.13
    ],
    [
      "cote",
      0.13
    ],
    [
      "plage",
      0.13
    ],
    [
      "rive",
      0.085
    ],
    [
      "littoral",
      0.085
    ],
    [
      "greve",
      0.085
    ],
    [
      "berge",
      0.0425
    ],
    [
      "climat",
      0.0425
    ],
    [
      "marine",
      0.0425
    ],
    [
      "region",
      0.0425
    ]
  ],
  "ecumer": [
    [
      "fumer",
      0.1175
    ],
    [
      "piller",
      0.1175
    ],
    [
      "rager",
      0.1175
    ],
    [
      "ronchonner",
      0.0575
    ],
    [
      "prendre",
      0.0575
    ],
    [
      "moutonner",
      0.0575
    ],
    [
      "mousser",
      0.0575
    ],
    [
      "infester",
      0.0575
    ],
    [
      "enrager",
      0.0575
    ],
    [
      "debarrasser",
      0.0575
    ],
    [
      "braconner",
      0.0575
    ],
    [
      "bouillonner",
      0.0575
    ],
    [
      "baver",
      0.0575
    ],
    [
      "tempeter",
      0.0575
    ]
  ],
  "ecume": [
    [
      "lie",
      0.2075
    ],
    [
      "ramas",
      0.0825
    ],
    [
      "ramassis",
      0.0825
    ],
    [
      "rebut",
      0.0825
    ],
    [
      "tourbe",
      0.0825
    ],
    [
      "populace",
      0.04
    ],
    [
      "residu",
      0.04
    ],
    [
      "salive",
      0.04
    ],
    [
      "spume",
      0.04
    ],
    [
      "mouton",
      0.04
    ],
    [
      "mousse",
      0.04
    ],
    [
      "crasse",
      0.04
    ],
    [
      "chiasse",
      0.04
    ],
    [
      "bave",
      0.04
    ],
    [
      "sueur",
      0.04
    ]
  ],
  "drapeau": [
    [
      "banniere",
      0.185
    ],
    [
      "etendard",
      0.0925
    ],
    [
      "banderole",
      0.0775
    ],
    [
      "pavillon",
      0.0775
    ],
    [
      "guidon",
      0.06
    ],
    [
      "flamme",
      0.06
    ],
    [
      "fanion",
      0.06
    ],
    [
      "enseigne",
      0.045
    ],
    [
      "oriflamme",
      0.045
    ],
    [
      "pennon",
      0.03
    ],
    [
      "gonfalon",
      0.03
    ],
    [
      "embleme",
      0.03
    ],
    [
      "cornette",
      0.03
    ],
    [
      "aigle",
      0.03
    ],
    [
      "lange",
      0.0125
    ],
    [
      "fanon",
      0.0125
    ],
    [
      "couleurs",
      0.0125
    ],
    [
      "couleur",
      0.0125
    ],
    [
      "couche",
      0.0125
    ],
    [
      "chiffon",
      0.0125
    ],
    [
      "bandiere",
      0.0125
    ],
    [
      "bandage",
      0.0125
    ],
    [
      "symbole",
      0.0125
    ]
  ],
  "heros": [
    [
      "brave",
      0.15
    ],
    [
      "grand",
      0.15
    ],
    [
      "demiurge",
      0.1
    ],
    [
      "geant",
      0.1
    ],
    [
      "personnage",
      0.1
    ],
    [
      "protagoniste",
      0.05
    ],
    [
      "preux",
      0.05
    ],
    [
      "paladin",
      0.05
    ],
    [
      "modele",
      0.05
    ],
    [
      "lion",
      0.05
    ],
    [
      "deesse",
      0.05
    ],
    [
      "surhomme",
      0.05
    ]
  ],
  "saura": [
    [
      "fumer",
      1.0
    ]
  ],
  "gardien": [
    [
      "garde",
      0.085
    ],
    [
      "surveillant",
      0.075
    ],
    [
      "cerbere",
      0.0625
    ],
    [
      "portier",
      0.0625
    ],
    [
      "protecteur",
      0.0425
    ],
    [
      "maton",
      0.0425
    ],
    [
      "geolier",
      0.0425
    ],
    [
      "defenseur",
      0.0425
    ],
    [
      "veilleur",
      0.03
    ],
    [
      "sentinelle",
      0.03
    ],
    [
      "policier",
      0.03
    ],
    [
      "concierge",
      0.03
    ],
    [
      "chien",
      0.03
    ],
    [
      "berger",
      0.03
    ],
    [
      "tuteur",
      0.02
    ],
    [
      "mainteneur",
      0.02
    ],
    [
      "huissier",
      0.02
    ],
    [
      "goal",
      0.02
    ],
    [
      "gardeur",
      0.02
    ],
    [
      "depositaire",
      0.02
    ],
    [
      "conservateur",
      0.02
    ],
    [
      "conducteur",
      0.02
    ],
    [
      "argousin",
      0.02
    ],
    [
      "guide",
      0.01
    ],
    [
      "matuche",
      0.01
    ],
    [
      "pasteur",
      0.01
    ],
    [
      "suisse",
      0.01
    ],
    [
      "tutelaire",
      0.01
    ],
    [
      "guichetier",
      0.01
    ],
    [
      "gendarme",
      0.01
    ],
    [
      "garant",
      0.01
    ],
    [
      "gaffe",
      0.01
    ],
    [
      "detenteur",
      0.01
    ],
    [
      "dragon",
      0.01
    ],
    [
      "consignataire",
      0.01
    ],
    [
      "champion",
      0.01
    ],
    [
      "vacher",
      0.01
    ]
  ],
  "partager": [
    [
      "diviser",
      0.12
    ],
    [
      "morceler",
      0.0725
    ],
    [
      "donner",
      0.0475
    ],
    [
      "repartir",
      0.0475
    ],
    [
      "separer",
      0.0475
    ],
    [
      "distribuer",
      0.04
    ],
    [
      "sectionner",
      0.035
    ],
    [
      "participer",
      0.035
    ],
    [
      "depecer",
      0.035
    ],
    [
      "couper",
      0.03
    ],
    [
      "demembrer",
      0.03
    ],
    [
      "fractionner",
      0.03
    ],
    [
      "servir",
      0.03
    ],
    [
      "scinder",
      0.0225
    ],
    [
      "attribuer",
      0.0225
    ],
    [
      "aider",
      0.0225
    ],
    [
      "subdiviser",
      0.0175
    ],
    [
      "lotir",
      0.0175
    ],
    [
      "departir",
      0.0175
    ],
    [
      "decouper",
      0.0175
    ],
    [
      "doter",
      0.0175
    ],
    [
      "dispenser",
      0.0175
    ],
    [
      "ecarter",
      0.01
    ],
    [
      "impartir",
      0.01
    ],
    [
      "fragmenter",
      0.01
    ],
    [
      "favoriser",
      0.01
    ],
    [
      "debiter",
      0.01
    ],
    [
      "douer",
      0.01
    ],
    [
      "compatir",
      0.01
    ],
    [
      "mutualiser",
      0.005
    ],
    [
      "partir",
      0.005
    ],
    [
      "s'associer",
      0.005
    ],
    [
      "sympathiser",
      0.005
    ],
    [
      "ecarteler",
      0.005
    ],
    [
      "epouser",
      0.005
    ],
    [
      "embrasser",
      0.005
    ],
    [
      "departager",
      0.005
    ],
    [
      "dedoubler",
      0.005
    ],
    [
      "communiquer",
      0.005
    ],
    [
      "cloisonner",
      0.005
    ],
    [
      "bercer",
      0.005
    ],
    [
      "associer",
      0.005
    ],
    [
      "aliener",
      0.005
    ],
    [
      "eprouver",
      0.005
    ]
  ],
  "partage": [
    [
      "diviser",
      0.12
    ],
    [
      "morceler",
      0.0725
    ],
    [
      "donner",
      0.0475
    ],
    [
      "repartir",
      0.0475
    ],
    [
      "separer",
      0.0475
    ],
    [
      "distribuer",
      0.04
    ],
    [
      "sectionner",
      0.035
    ],
    [
      "participer",
      0.035
    ],
    [
      "depecer",
      0.035
    ],
    [
      "couper",
      0.03
    ],
    [
      "demembrer",
      0.03
    ],
    [
      "fractionner",
      0.03
    ],
    [
      "servir",
      0.03
    ],
    [
      "scinder",
      0.0225
    ],
    [
      "attribuer",
      0.0225
    ],
    [
      "aider",
      0.0225
    ],
    [
      "subdiviser",
      0.0175
    ],
    [
      "lotir",
      0.0175
    ],
    [
      "departir",
      0.0175
    ],
    [
      "decouper",
      0.0175
    ],
    [
      "doter",
      0.0175
    ],
    [
      "dispenser",
      0.0175
    ],
    [
      "ecarter",
      0.01
    ],
    [
      "impartir",
      0.01
    ],
    [
      "fragmenter",
      0.01
    ],
    [
      "favoriser",
      0.01
    ],
    [
      "debiter",
      0.01
    ],
    [
      "douer",
      0.01
    ],
    [
      "compatir",
      0.01
    ],
    [
      "mutualiser",
      0.005
    ],
    [
      "partir",
      0.005
    ],
    [
      "s'associer",
      0.005
    ],
    [
      "sympathiser",
      0.005
    ],
    [
      "ecarteler",
      0.005
    ],
    [
      "epouser",
      0.005
    ],
    [
      "embrasser",
      0.005
    ],
    [
      "departager",
      0.005
    ],
    [
      "dedoubler",
      0.005
    ],
    [
      "communiquer",
      0.005
    ],
    [
      "cloisonner",
      0.005
    ],
    [
      "bercer",
      0.005
    ],
    [
      "associer",
      0.005
    ],
    [
      "aliener",
      0.005
    ],
    [
      "eprouver",
      0.005
    ]
  ],
  "bijoux": [
    [
      "merveille",
      0.1025
    ],
    [
      "beaute",
      0.075
    ],
    [
      "chaine",
      0.075
    ],
    [
      "joyau",
      0.075
    ],
    [
      "perfection",
      0.075
    ],
    [
      "perle",
      0.05
    ],
    [
      "diamant",
      0.05
    ],
    [
      "brillant",
      0.05
    ],
    [
      "breloque",
      0.05
    ],
    [
      "bijouterie",
      0.05
    ],
    [
      "sautoir",
      0.025
    ],
    [
      "ornement",
      0.025
    ],
    [
      "collier",
      0.025
    ],
    [
      "camee",
      0.025
    ],
    [
      "broche",
      0.025
    ],
    [
      "bracelet",
      0.025
    ],
    [
      "boucle",
      0.025
    ],
    [
      "bonbonniere",
      0.025
    ],
    [
      "biquet",
      0.025
    ],
    [
      "bibelot",
      0.025
    ],
    [
      "email",
      0.025
    ]
  ],
  "limousin": [
    [
      "macon",
      1.0
    ]
  ],
  "personnel": [
    [
      "particulier",
      0.125
    ],
    [
      "original",
      0.0625
    ],
    [
      "special",
      0.0625
    ],
    [
      "propre",
      0.04
    ],
    [
      "intime",
      0.04
    ],
    [
      "individuel",
      0.04
    ],
    [
      "domesticite",
      0.04
    ],
    [
      "caracteristique",
      0.04
    ],
    [
      "egoiste",
      0.03
    ],
    [
      "truculent",
      0.03
    ],
    [
      "singulier",
      0.03
    ],
    [
      "serviteur",
      0.03
    ],
    [
      "prive",
      0.03
    ],
    [
      "interieur",
      0.03
    ],
    [
      "domestique",
      0.03
    ],
    [
      "valetaille",
      0.02
    ],
    [
      "typique",
      0.02
    ],
    [
      "journalier",
      0.02
    ],
    [
      "gens",
      0.02
    ],
    [
      "exclusif",
      0.02
    ],
    [
      "profond",
      0.01
    ],
    [
      "respectif",
      0.01
    ],
    [
      "revelateur",
      0.01
    ],
    [
      "spirituel",
      0.01
    ],
    [
      "subjectif",
      0.01
    ],
    [
      "egocentrique",
      0.01
    ],
    [
      "egotiste",
      0.01
    ],
    [
      "equipage",
      0.01
    ],
    [
      "ouvrier",
      0.01
    ],
    [
      "nouveau",
      0.01
    ],
    [
      "natif",
      0.01
    ],
    [
      "confidentiel",
      0.01
    ],
    [
      "employe",
      0.01
    ],
    [
      "excentrique",
      0.01
    ],
    [
      "individualiste",
      0.01
    ],
    [
      "inne",
      0.01
    ],
    [
      "monde",
      0.01
    ],
    [
      "aide",
      0.01
    ]
  ],
  "manoir": [
    [
      "chateau",
      0.3325
    ],
    [
      "gentilhommiere",
      0.25
    ],
    [
      "habitation",
      0.165
    ],
    [
      "castel",
      0.0825
    ],
    [
      "chatelet",
      0.0825
    ],
    [
      "maison",
      0.0825
    ]
  ],
  "bonne": [
    [
      "beau",
      0.0575
    ],
    [
      "honnete",
      0.0325
    ],
    [
      "convenable",
      0.0225
    ],
    [
      "aimable",
      0.02
    ],
    [
      "doux",
      0.02
    ],
    [
      "agreable",
      0.015
    ],
    [
      "bien",
      0.015
    ],
    [
      "genereux",
      0.015
    ],
    [
      "fort",
      0.015
    ],
    [
      "bienveillant",
      0.015
    ],
    [
      "juste",
      0.0125
    ],
    [
      "favorable",
      0.0125
    ],
    [
      "correct",
      0.01
    ],
    [
      "delicat",
      0.01
    ],
    [
      "exquis",
      0.01
    ],
    [
      "vrai",
      0.01
    ],
    [
      "pur",
      0.01
    ],
    [
      "honorable",
      0.01
    ],
    [
      "gentil",
      0.01
    ],
    [
      "brave",
      0.01
    ],
    [
      "benin",
      0.01
    ],
    [
      "grand",
      0.01
    ],
    [
      "parfait",
      0.01
    ],
    [
      "sur",
      0.01
    ],
    [
      "important",
      0.0075
    ],
    [
      "gros",
      0.0075
    ],
    [
      "gracieux",
      0.0075
    ],
    [
      "avantageux",
      0.0075
    ],
    [
      "acceptable",
      0.0075
    ],
    [
      "serieux",
      0.0075
    ],
    [
      "superieur",
      0.0075
    ],
    [
      "sage",
      0.0075
    ],
    [
      "humain",
      0.0075
    ],
    [
      "habile",
      0.0075
    ],
    [
      "franc",
      0.0075
    ],
    [
      "excellent",
      0.0075
    ],
    [
      "exact",
      0.0075
    ],
    [
      "solide",
      0.005
    ],
    [
      "simple",
      0.005
    ],
    [
      "raisonnable",
      0.005
    ],
    [
      "propre",
      0.005
    ],
    [
      "plaisant",
      0.005
    ],
    [
      "joli",
      0.005
    ],
    [
      "indulgent",
      0.005
    ],
    [
      "heureux",
      0.005
    ],
    [
      "droit",
      0.005
    ],
    [
      "complaisant",
      0.005
    ],
    [
      "charitable",
      0.005
    ],
    [
      "precieux",
      0.005
    ],
    [
      "propice",
      0.005
    ],
    [
      "fameux",
      0.005
    ],
    [
      "distingue",
      0.005
    ],
    [
      "digne",
      0.005
    ],
    [
      "bienfaisant",
      0.005
    ],
    [
      "valable",
      0.005
    ],
    [
      "sortable",
      0.005
    ],
    [
      "satisfaisant",
      0.005
    ],
    [
      "potable",
      0.005
    ],
    [
      "ferme",
      0.005
    ],
    [
      "estimable",
      0.005
    ],
    [
      "efficace",
      0.005
    ],
    [
      "debonnaire",
      0.005
    ],
    [
      "charmant",
      0.005
    ],
    [
      "capable",
      0.005
    ],
    [
      "bonhomme",
      0.005
    ],
    [
      "sensible",
      0.0025
    ],
    [
      "sain",
      0.0025
    ],
    [
      "noble",
      0.0025
    ],
    [
      "delicieux",
      0.0025
    ],
    [
      "affable",
      0.0025
    ],
    [
      "abondant",
      0.0025
    ],
    [
      "profitable",
      0.0025
    ],
    [
      "remarquable",
      0.0025
    ],
    [
      "riche",
      0.0025
    ],
    [
      "salutaire",
      0.0025
    ],
    [
      "serviable",
      0.0025
    ],
    [
      "strict",
      0.0025
    ],
    [
      "succulent",
      0.0025
    ],
    [
      "tendre",
      0.0025
    ],
    [
      "utile",
      0.0025
    ],
    [
      "vertueux",
      0.0025
    ],
    [
      "passable",
      0.0025
    ],
    [
      "obligeant",
      0.0025
    ],
    [
      "merveilleux",
      0.0025
    ],
    [
      "bonasse",
      0.0025
    ],
    [
      "cher",
      0.0025
    ],
    [
      "commode",
      0.0025
    ],
    [
      "fidele",
      0.0025
    ],
    [
      "formidable",
      0.0025
    ],
    [
      "genial",
      0.0025
    ],
    [
      "haut",
      0.0025
    ],
    [
      "interessant",
      0.0025
    ],
    [
      "judicieux",
      0.0025
    ],
    [
      "louable",
      0.0025
    ],
    [
      "moyen",
      0.0025
    ],
    [
      "moral",
      0.0025
    ],
    [
      "misericordieux",
      0.0025
    ],
    [
      "innocent",
      0.0025
    ],
    [
      "heroique",
      0.0025
    ],
    [
      "gai",
      0.0025
    ],
    [
      "fructueux",
      0.0025
    ],
    [
      "meritant",
      0.0025
    ],
    [
      "ouvert",
      0.0025
    ],
    [
      "piquant",
      0.0025
    ],
    [
      "robuste",
      0.0025
    ],
    [
      "spirituel",
      0.0025
    ],
    [
      "suffisant",
      0.0025
    ],
    [
      "tutelaire",
      0.0025
    ],
    [
      "eleve",
      0.0025
    ],
    [
      "energique",
      0.0025
    ],
    [
      "fertile",
      0.0025
    ],
    [
      "faible",
      0.0025
    ],
    [
      "adroit",
      0.0025
    ],
    [
      "altruiste",
      0.0025
    ],
    [
      "amusant",
      0.0025
    ],
    [
      "angelique",
      0.0025
    ],
    [
      "approprie",
      0.0025
    ],
    [
      "benefique",
      0.0025
    ],
    [
      "certain",
      0.0025
    ],
    [
      "chic",
      0.0025
    ],
    [
      "cheri",
      0.0025
    ],
    [
      "decent",
      0.0025
    ],
    [
      "divin",
      0.0025
    ],
    [
      "courageux",
      0.0025
    ],
    [
      "cordial",
      0.0025
    ],
    [
      "considerable",
      0.0025
    ],
    [
      "consciencieux",
      0.0025
    ],
    [
      "clement",
      0.0025
    ],
    [
      "lucratif",
      0.0
    ],
    [
      "meritoire",
      0.0
    ],
    [
      "naif",
      0.0
    ],
    [
      "opportun",
      0.0
    ],
    [
      "philanthrope",
      0.0
    ],
    [
      "providentiel",
      0.0
    ],
    [
      "prudent",
      0.0
    ],
    [
      "recevable",
      0.0
    ],
    [
      "savoureux",
      0.0
    ],
    [
      "secourable",
      0.0
    ],
    [
      "tolerant",
      0.0
    ],
    [
      "valide",
      0.0
    ],
    [
      "veritable",
      0.0
    ],
    [
      "ingenieux",
      0.0
    ],
    [
      "extra",
      0.0
    ],
    [
      "accessible",
      0.0
    ],
    [
      "admissible",
      0.0
    ],
    [
      "adequat",
      0.0
    ],
    [
      "apte",
      0.0
    ],
    [
      "avise",
      0.0
    ],
    [
      "billet",
      0.0
    ],
    [
      "benevole",
      0.0
    ],
    [
      "candide",
      0.0
    ],
    [
      "devoue",
      0.0
    ],
    [
      "desinteresse",
      0.0
    ],
    [
      "delectable",
      0.0
    ],
    [
      "complet",
      0.0
    ],
    [
      "compatissant",
      0.0
    ],
    [
      "reconfortant",
      0.0
    ],
    [
      "rigoureux",
      0.0
    ],
    [
      "rentable",
      0.0
    ],
    [
      "productif",
      0.0
    ],
    [
      "prodigue",
      0.0
    ],
    [
      "plein",
      0.0
    ],
    [
      "plausible",
      0.0
    ],
    [
      "pitoyable",
      0.0
    ],
    [
      "paterne",
      0.0
    ],
    [
      "mangeable",
      0.0
    ],
    [
      "magnanime",
      0.0
    ],
    [
      "remunerateur",
      0.0
    ],
    [
      "sauf",
      0.0
    ],
    [
      "eclaire",
      0.0
    ],
    [
      "venerable",
      0.0
    ],
    [
      "valeur",
      0.0
    ],
    [
      "titre",
      0.0
    ],
    [
      "susceptible",
      0.0
    ],
    [
      "suave",
      0.0
    ],
    [
      "stable",
      0.0
    ],
    [
      "souverain",
      0.0
    ],
    [
      "soit",
      0.0
    ],
    [
      "sentimental",
      0.0
    ],
    [
      "joyeux",
      0.0
    ],
    [
      "inoffensif",
      0.0
    ],
    [
      "affectueux",
      0.0
    ],
    [
      "certifie",
      0.0
    ],
    [
      "certificat",
      0.0
    ],
    [
      "bonte",
      0.0
    ],
    [
      "boniface",
      0.0
    ],
    [
      "biquet",
      0.0
    ],
    [
      "bienfaiteur",
      0.0
    ],
    [
      "benoit",
      0.0
    ],
    [
      "authentique",
      0.0
    ],
    [
      "agreablement",
      0.0
    ],
    [
      "chaud",
      0.0
    ],
    [
      "copieux",
      0.0
    ],
    [
      "ingenu",
      0.0
    ],
    [
      "friand",
      0.0
    ],
    [
      "fermement",
      0.0
    ],
    [
      "fait",
      0.0
    ],
    [
      "expert",
      0.0
    ],
    [
      "exemplaire",
      0.0
    ],
    [
      "drole",
      0.0
    ],
    [
      "doue",
      0.0
    ],
    [
      "cuit",
      0.0
    ],
    [
      "credule",
      0.0
    ],
    [
      "costaud",
      0.0
    ],
    [
      "performant",
      0.0
    ],
    [
      "paternel",
      0.0
    ],
    [
      "operant",
      0.0
    ],
    [
      "modele",
      0.0
    ],
    [
      "meilleur",
      0.0
    ],
    [
      "instructif",
      0.0
    ],
    [
      "pondere",
      0.0
    ],
    [
      "pret",
      0.0
    ],
    [
      "reposant",
      0.0
    ],
    [
      "sauve",
      0.0
    ],
    [
      "sociable",
      0.0
    ],
    [
      "solidement",
      0.0
    ],
    [
      "ticket",
      0.0
    ],
    [
      "utilisable",
      0.0
    ],
    [
      "equitable",
      0.0
    ],
    [
      "humanitaire",
      0.0
    ],
    [
      "faste",
      0.0
    ],
    [
      "appetissant",
      0.0
    ],
    [
      "aromatique",
      0.0
    ],
    [
      "attestation",
      0.0
    ],
    [
      "autorisation",
      0.0
    ],
    [
      "bonard",
      0.0
    ],
    [
      "bete",
      0.0
    ],
    [
      "carabine",
      0.0
    ],
    [
      "convaincant",
      0.0
    ],
    [
      "coupon",
      0.0
    ],
    [
      "coupure",
      0.0
    ],
    [
      "delicieusement",
      0.0
    ],
    [
      "emballe",
      0.0
    ],
    [
      "enviable",
      0.0
    ],
    [
      "adore",
      0.0
    ]
  ],
  "humeur": [
    [
      "caprice",
      0.085
    ],
    [
      "fantaisie",
      0.085
    ],
    [
      "toquade",
      0.045
    ],
    [
      "esprit",
      0.0425
    ],
    [
      "colere",
      0.0375
    ],
    [
      "volonte",
      0.0325
    ],
    [
      "temperament",
      0.0225
    ],
    [
      "gout",
      0.0225
    ],
    [
      "desir",
      0.0225
    ],
    [
      "disposition",
      0.0225
    ],
    [
      "bile",
      0.0225
    ],
    [
      "nature",
      0.0175
    ],
    [
      "irritation",
      0.0175
    ],
    [
      "impatience",
      0.0175
    ],
    [
      "idee",
      0.0175
    ],
    [
      "gaiete",
      0.0175
    ],
    [
      "folie",
      0.0175
    ],
    [
      "extravagance",
      0.0175
    ],
    [
      "caractere",
      0.0175
    ],
    [
      "bizarrerie",
      0.0175
    ],
    [
      "aigreur",
      0.0175
    ],
    [
      "vivacite",
      0.0125
    ],
    [
      "mecontentement",
      0.0125
    ],
    [
      "manie",
      0.0125
    ],
    [
      "lubie",
      0.0125
    ],
    [
      "humour",
      0.0125
    ],
    [
      "gre",
      0.0125
    ],
    [
      "facherie",
      0.0125
    ],
    [
      "envie",
      0.0125
    ],
    [
      "boutade",
      0.0125
    ],
    [
      "lymphe",
      0.0075
    ],
    [
      "morve",
      0.0075
    ],
    [
      "mucosite",
      0.0075
    ],
    [
      "naturel",
      0.0075
    ],
    [
      "pituite",
      0.0075
    ],
    [
      "verve",
      0.0075
    ],
    [
      "glaire",
      0.0075
    ],
    [
      "flegme",
      0.0075
    ],
    [
      "atrabile",
      0.0075
    ],
    [
      "bouderie",
      0.0075
    ],
    [
      "brouille",
      0.0075
    ],
    [
      "composition",
      0.0075
    ],
    [
      "contrariete",
      0.0075
    ],
    [
      "entrain",
      0.0075
    ],
    [
      "roupie",
      0.0025
    ],
    [
      "rancune",
      0.0025
    ],
    [
      "quinte",
      0.0025
    ],
    [
      "pus",
      0.0025
    ],
    [
      "predilection",
      0.0025
    ],
    [
      "passade",
      0.0025
    ],
    [
      "salive",
      0.0025
    ],
    [
      "sang",
      0.0025
    ],
    [
      "sanie",
      0.0025
    ],
    [
      "sueur",
      0.0025
    ],
    [
      "synovie",
      0.0025
    ],
    [
      "vapeur",
      0.0025
    ],
    [
      "veine",
      0.0025
    ],
    [
      "vertigo",
      0.0025
    ],
    [
      "melancolie",
      0.0025
    ],
    [
      "misanthropie",
      0.0025
    ],
    [
      "attitude",
      0.0025
    ],
    [
      "bisbille",
      0.0025
    ],
    [
      "bourrasque",
      0.0025
    ],
    [
      "chassie",
      0.0025
    ],
    [
      "chyle",
      0.0025
    ],
    [
      "complexion",
      0.0025
    ],
    [
      "croute",
      0.0025
    ],
    [
      "enjouement",
      0.0025
    ],
    [
      "ichor",
      0.0025
    ],
    [
      "impulsion",
      0.0025
    ],
    [
      "impurete",
      0.0025
    ],
    [
      "irregularite",
      0.0025
    ],
    [
      "larme",
      0.0025
    ],
    [
      "liquide",
      0.0025
    ]
  ],
  "ra": [],
  "bienvenue": [
    [
      "juste",
      0.3325
    ],
    [
      "opportun",
      0.3325
    ]
  ],
  "maniere": [
    [
      "genre",
      0.0775
    ],
    [
      "facon",
      0.0725
    ],
    [
      "style",
      0.0725
    ],
    [
      "procede",
      0.045
    ],
    [
      "type",
      0.0375
    ],
    [
      "methode",
      0.035
    ],
    [
      "moyen",
      0.0325
    ],
    [
      "ton",
      0.03
    ],
    [
      "tournure",
      0.0275
    ],
    [
      "mode",
      0.0275
    ],
    [
      "caractere",
      0.0275
    ],
    [
      "art",
      0.025
    ],
    [
      "expression",
      0.025
    ],
    [
      "truc",
      0.025
    ],
    [
      "marque",
      0.0225
    ],
    [
      "forme",
      0.0225
    ],
    [
      "conduite",
      0.0225
    ],
    [
      "comportement",
      0.0225
    ],
    [
      "technique",
      0.0175
    ],
    [
      "tenue",
      0.0175
    ],
    [
      "facture",
      0.015
    ],
    [
      "sorte",
      0.015
    ],
    [
      "touche",
      0.015
    ],
    [
      "maintien",
      0.01
    ],
    [
      "gout",
      0.01
    ],
    [
      "geste",
      0.01
    ],
    [
      "faire",
      0.01
    ],
    [
      "voie",
      0.0075
    ],
    [
      "trait",
      0.0075
    ],
    [
      "tic",
      0.0075
    ],
    [
      "tactique",
      0.0075
    ],
    [
      "singerie",
      0.0075
    ],
    [
      "minauderie",
      0.0075
    ],
    [
      "mime",
      0.0075
    ],
    [
      "histoire",
      0.0075
    ],
    [
      "habitude",
      0.0075
    ],
    [
      "guise",
      0.0075
    ],
    [
      "espece",
      0.0075
    ],
    [
      "artifice",
      0.0075
    ],
    [
      "point",
      0.005
    ],
    [
      "port",
      0.005
    ],
    [
      "simagree",
      0.005
    ],
    [
      "systeme",
      0.005
    ],
    [
      "travers",
      0.005
    ],
    [
      "usage",
      0.005
    ],
    [
      "variete",
      0.005
    ],
    [
      "plume",
      0.005
    ],
    [
      "pinceau",
      0.005
    ],
    [
      "accent",
      0.005
    ],
    [
      "chemin",
      0.005
    ],
    [
      "contorsion",
      0.005
    ],
    [
      "manie",
      0.005
    ],
    [
      "mesure",
      0.005
    ],
    [
      "modalite",
      0.005
    ],
    [
      "nature",
      0.005
    ],
    [
      "acabit",
      0.0025
    ],
    [
      "mignardise",
      0.0025
    ],
    [
      "pastiche",
      0.0025
    ],
    [
      "physionomie",
      0.0025
    ],
    [
      "ecriture",
      0.0025
    ]
  ],
  "franc": [
    [
      "sincere",
      0.065
    ],
    [
      "net",
      0.06
    ],
    [
      "vrai",
      0.06
    ],
    [
      "bon",
      0.045
    ],
    [
      "pur",
      0.045
    ],
    [
      "simple",
      0.04
    ],
    [
      "droit",
      0.035
    ],
    [
      "clair",
      0.0325
    ],
    [
      "sur",
      0.03
    ],
    [
      "ouvert",
      0.0275
    ],
    [
      "certain",
      0.025
    ],
    [
      "ferme",
      0.025
    ],
    [
      "spontane",
      0.02
    ],
    [
      "parfait",
      0.02
    ],
    [
      "entier",
      0.02
    ],
    [
      "direct",
      0.02
    ],
    [
      "complet",
      0.0175
    ],
    [
      "fidele",
      0.0175
    ],
    [
      "honnete",
      0.0175
    ],
    [
      "solide",
      0.0175
    ],
    [
      "precis",
      0.015
    ],
    [
      "naturel",
      0.015
    ],
    [
      "loyal",
      0.015
    ],
    [
      "decide",
      0.015
    ],
    [
      "categorique",
      0.015
    ],
    [
      "carre",
      0.015
    ],
    [
      "familier",
      0.0125
    ],
    [
      "libre",
      0.0125
    ],
    [
      "rond",
      0.0125
    ],
    [
      "veritable",
      0.01
    ],
    [
      "resolu",
      0.01
    ],
    [
      "franchement",
      0.01
    ],
    [
      "cru",
      0.01
    ],
    [
      "cordial",
      0.01
    ],
    [
      "plein",
      0.0075
    ],
    [
      "brutal",
      0.0075
    ],
    [
      "brave",
      0.0075
    ],
    [
      "acheve",
      0.0075
    ],
    [
      "vif",
      0.005
    ],
    [
      "tranche",
      0.005
    ],
    [
      "total",
      0.005
    ],
    [
      "resolument",
      0.005
    ],
    [
      "nettement",
      0.005
    ],
    [
      "intrepide",
      0.005
    ],
    [
      "hardi",
      0.005
    ],
    [
      "fieffe",
      0.005
    ],
    [
      "fameux",
      0.005
    ],
    [
      "declare",
      0.005
    ],
    [
      "candide",
      0.005
    ],
    [
      "limpide",
      0.0025
    ],
    [
      "ouvertement",
      0.0025
    ],
    [
      "ingenu",
      0.0025
    ],
    [
      "francique",
      0.0025
    ],
    [
      "expansif",
      0.0025
    ],
    [
      "exempt",
      0.0025
    ],
    [
      "desinvolte",
      0.0025
    ],
    [
      "demonstratif",
      0.0025
    ],
    [
      "balle",
      0.0025
    ]
  ],
  "hypocrisie": [
    [
      "simulation",
      0.1125
    ],
    [
      "tartuferie",
      0.1025
    ],
    [
      "feinte",
      0.0825
    ],
    [
      "faussete",
      0.0575
    ],
    [
      "comedie",
      0.05
    ],
    [
      "fourberie",
      0.045
    ],
    [
      "sournoiserie",
      0.0425
    ],
    [
      "mensonge",
      0.04
    ],
    [
      "singerie",
      0.04
    ],
    [
      "tromperie",
      0.04
    ],
    [
      "grimace",
      0.035
    ],
    [
      "duplicite",
      0.03
    ],
    [
      "momerie",
      0.0275
    ],
    [
      "affectation",
      0.0275
    ],
    [
      "dissimulation",
      0.0225
    ],
    [
      "cagoterie",
      0.015
    ],
    [
      "deloyaute",
      0.0125
    ],
    [
      "trahison",
      0.01
    ],
    [
      "devotion",
      0.01
    ],
    [
      "bigoterie",
      0.01
    ],
    [
      "simulacre",
      0.0075
    ],
    [
      "simagrees",
      0.0075
    ],
    [
      "pharisaisme",
      0.0075
    ],
    [
      "papelardise",
      0.0075
    ],
    [
      "pantalonnade",
      0.0075
    ],
    [
      "manege",
      0.0075
    ],
    [
      "cagotisme",
      0.0075
    ],
    [
      "cafardise",
      0.0075
    ],
    [
      "simagree",
      0.005
    ],
    [
      "patelinage",
      0.005
    ],
    [
      "machiavelisme",
      0.005
    ],
    [
      "jonglerie",
      0.005
    ],
    [
      "felonie",
      0.005
    ],
    [
      "chafouinerie",
      0.005
    ],
    [
      "cafarderie",
      0.005
    ],
    [
      "cabotinage",
      0.005
    ],
    [
      "bigotisme",
      0.005
    ],
    [
      "fraude",
      0.0
    ],
    [
      "imposture",
      0.0
    ],
    [
      "jesuitisme",
      0.0
    ],
    [
      "mascarade",
      0.0
    ],
    [
      "flatterie",
      0.0
    ],
    [
      "escobarderie",
      0.0
    ],
    [
      "detour",
      0.0
    ],
    [
      "chattemite",
      0.0
    ],
    [
      "cautele",
      0.0
    ],
    [
      "casuistique",
      0.0
    ],
    [
      "pudibonderie",
      0.0
    ]
  ],
  "bois": [
    [
      "s'abreuver",
      0.15
    ],
    [
      "absorber",
      0.0475
    ],
    [
      "s'enivrer",
      0.045
    ],
    [
      "pomper",
      0.04
    ],
    [
      "pinter",
      0.03
    ],
    [
      "s'imbiber",
      0.025
    ],
    [
      "recevoir",
      0.025
    ],
    [
      "ingurgiter",
      0.025
    ],
    [
      "avaler",
      0.025
    ],
    [
      "picoler",
      0.0225
    ],
    [
      "prendre",
      0.0225
    ],
    [
      "sucer",
      0.015
    ],
    [
      "souffrir",
      0.015
    ],
    [
      "s'alcooliser",
      0.015
    ],
    [
      "humer",
      0.015
    ],
    [
      "essuyer",
      0.015
    ],
    [
      "entonner",
      0.015
    ],
    [
      "deguster",
      0.015
    ],
    [
      "chopiner",
      0.015
    ],
    [
      "aspirer",
      0.015
    ],
    [
      "siroter",
      0.0125
    ],
    [
      "siffler",
      0.0125
    ],
    [
      "s'ivrogner",
      0.0125
    ],
    [
      "s'impregner",
      0.0125
    ],
    [
      "licher",
      0.0125
    ],
    [
      "lamper",
      0.0125
    ],
    [
      "ivrogner",
      0.0125
    ],
    [
      "endurer",
      0.0125
    ],
    [
      "supporter",
      0.0075
    ],
    [
      "teter",
      0.0075
    ],
    [
      "vider",
      0.0075
    ],
    [
      "ecluser",
      0.0075
    ],
    [
      "eponger",
      0.0075
    ],
    [
      "arroser",
      0.0075
    ],
    [
      "biberonner",
      0.0075
    ],
    [
      "consommer",
      0.0075
    ],
    [
      "respirer",
      0.0075
    ],
    [
      "s'aviner",
      0.0075
    ],
    [
      "savourer",
      0.0025
    ],
    [
      "sabler",
      0.0025
    ],
    [
      "s'inonder",
      0.0025
    ],
    [
      "s'humecter",
      0.0025
    ],
    [
      "rincer",
      0.0025
    ],
    [
      "soiffer",
      0.0025
    ],
    [
      "tolerer",
      0.0025
    ],
    [
      "trinquer",
      0.0025
    ],
    [
      "riboter",
      0.0025
    ],
    [
      "renifler",
      0.0025
    ],
    [
      "abreuver",
      0.0025
    ],
    [
      "bidonner",
      0.0025
    ],
    [
      "boissonner",
      0.0025
    ],
    [
      "buvoter",
      0.0025
    ],
    [
      "depenser",
      0.0025
    ],
    [
      "fouetter",
      0.0025
    ],
    [
      "godailler",
      0.0025
    ],
    [
      "laper",
      0.0025
    ],
    [
      "lichailler",
      0.0025
    ],
    [
      "lipper",
      0.0025
    ],
    [
      "pictancher",
      0.0025
    ],
    [
      "picter",
      0.0025
    ],
    [
      "pictonner",
      0.0025
    ]
  ],
  "game": [],
  "favori": [
    [
      "cheri",
      0.12
    ],
    [
      "chouchou",
      0.095
    ],
    [
      "prefere",
      0.095
    ],
    [
      "privilegie",
      0.0725
    ],
    [
      "protege",
      0.0475
    ],
    [
      "gate",
      0.0475
    ],
    [
      "choisi",
      0.0475
    ],
    [
      "cheval",
      0.0475
    ],
    [
      "amant",
      0.0475
    ],
    [
      "rouflaquette",
      0.0225
    ],
    [
      "predilection",
      0.0225
    ],
    [
      "poete",
      0.0225
    ],
    [
      "patte",
      0.0225
    ],
    [
      "mignon",
      0.0225
    ],
    [
      "dada",
      0.0225
    ],
    [
      "cotelette",
      0.0225
    ],
    [
      "creature",
      0.0225
    ],
    [
      "crack",
      0.0225
    ],
    [
      "coqueluche",
      0.0225
    ],
    [
      "benjamin",
      0.0225
    ],
    [
      "barbe",
      0.0225
    ],
    [
      "elu",
      0.0225
    ]
  ],
  "moustache": [
    [
      "poil",
      0.4
    ],
    [
      "bacchante",
      0.2
    ],
    [
      "barbe",
      0.2
    ],
    [
      "vibrisse",
      0.2
    ]
  ],
  "bientot": [
    [
      "incessamment",
      0.13
    ],
    [
      "promptement",
      0.085
    ],
    [
      "rapidement",
      0.085
    ],
    [
      "vite",
      0.085
    ],
    [
      "precipitamment",
      0.0425
    ],
    [
      "tantot",
      0.0425
    ],
    [
      "tot",
      0.0425
    ],
    [
      "prochainement",
      0.0425
    ],
    [
      "prestement",
      0.0425
    ],
    [
      "hativement",
      0.0425
    ],
    [
      "demain",
      0.0425
    ],
    [
      "vivement",
      0.0425
    ]
  ],
  "champion": [
    [
      "defenseur",
      0.1425
    ],
    [
      "apotre",
      0.0625
    ],
    [
      "tenant",
      0.0625
    ],
    [
      "soutien",
      0.0475
    ],
    [
      "partisan",
      0.0475
    ],
    [
      "maitre",
      0.0475
    ],
    [
      "combattant",
      0.0475
    ],
    [
      "as",
      0.0475
    ],
    [
      "zelateur",
      0.03
    ],
    [
      "virtuose",
      0.03
    ],
    [
      "soldat",
      0.03
    ],
    [
      "protecteur",
      0.03
    ],
    [
      "professeur",
      0.03
    ],
    [
      "chef",
      0.03
    ],
    [
      "appui",
      0.03
    ],
    [
      "gardien",
      0.015
    ],
    [
      "geant",
      0.015
    ],
    [
      "leader",
      0.015
    ],
    [
      "pilier",
      0.015
    ],
    [
      "recordman",
      0.015
    ],
    [
      "titan",
      0.015
    ],
    [
      "vainqueur",
      0.015
    ],
    [
      "gagnant",
      0.015
    ],
    [
      "crack",
      0.015
    ],
    [
      "concurrent",
      0.015
    ],
    [
      "chevalier",
      0.015
    ],
    [
      "avocat",
      0.015
    ],
    [
      "athlete",
      0.015
    ],
    [
      "antagoniste",
      0.015
    ],
    [
      "aigle",
      0.015
    ],
    [
      "adversaire",
      0.015
    ],
    [
      "vedette",
      0.015
    ]
  ],
  "avaler": [
    [
      "absorber",
      0.105
    ],
    [
      "manger",
      0.0975
    ],
    [
      "ingurgiter",
      0.065
    ],
    [
      "boire",
      0.0475
    ],
    [
      "devorer",
      0.0475
    ],
    [
      "prendre",
      0.0475
    ],
    [
      "supporter",
      0.0325
    ],
    [
      "souffrir",
      0.0325
    ],
    [
      "recevoir",
      0.0325
    ],
    [
      "engloutir",
      0.0325
    ],
    [
      "bouffer",
      0.0325
    ],
    [
      "sauter",
      0.0225
    ],
    [
      "retenir",
      0.0225
    ],
    [
      "escamoter",
      0.0225
    ],
    [
      "bafrer",
      0.0225
    ],
    [
      "aspirer",
      0.0225
    ],
    [
      "apprendre",
      0.0225
    ],
    [
      "accepter",
      0.0225
    ],
    [
      "tolerer",
      0.015
    ],
    [
      "rentrer",
      0.015
    ],
    [
      "inhaler",
      0.015
    ],
    [
      "ingerer",
      0.015
    ],
    [
      "humer",
      0.015
    ],
    [
      "gober",
      0.015
    ],
    [
      "entonner",
      0.015
    ],
    [
      "engouffrer",
      0.015
    ],
    [
      "endurer",
      0.015
    ],
    [
      "encaisser",
      0.015
    ],
    [
      "deglutir",
      0.015
    ],
    [
      "digerer",
      0.015
    ],
    [
      "croire",
      0.015
    ],
    [
      "s'enfiler",
      0.0075
    ],
    [
      "resorber",
      0.0075
    ],
    [
      "inspirer",
      0.0075
    ],
    [
      "friper",
      0.0075
    ],
    [
      "descendre",
      0.0075
    ],
    [
      "boulotter",
      0.0075
    ],
    [
      "tortiller",
      0.0075
    ]
  ],
  "champignon": [
    [
      "hymenomycete",
      0.1325
    ],
    [
      "agaric",
      0.1175
    ],
    [
      "chanterelle",
      0.0425
    ],
    [
      "lepiote",
      0.0425
    ],
    [
      "mousseron",
      0.0425
    ],
    [
      "rousset",
      0.0275
    ],
    [
      "psalliote",
      0.0275
    ],
    [
      "oronge",
      0.0275
    ],
    [
      "lactaire",
      0.0275
    ],
    [
      "coulemelle",
      0.0275
    ],
    [
      "coucoumelle",
      0.0275
    ],
    [
      "polypore",
      0.0125
    ],
    [
      "pleurote",
      0.0125
    ],
    [
      "morille",
      0.0125
    ],
    [
      "moisissure",
      0.0125
    ],
    [
      "marasme",
      0.0125
    ],
    [
      "pratelle",
      0.0125
    ],
    [
      "rose",
      0.0125
    ],
    [
      "russule",
      0.0125
    ],
    [
      "steinmann",
      0.0125
    ],
    [
      "thallophyte",
      0.0125
    ],
    [
      "tricholome",
      0.0125
    ],
    [
      "truffe",
      0.0125
    ],
    [
      "hydne",
      0.0125
    ],
    [
      "amanite",
      0.0125
    ],
    [
      "armillaire",
      0.0125
    ],
    [
      "bolet",
      0.0125
    ],
    [
      "cairn",
      0.0125
    ],
    [
      "clavaire",
      0.0125
    ],
    [
      "coprin",
      0.0125
    ],
    [
      "cortinaire",
      0.0125
    ],
    [
      "cepe",
      0.0125
    ],
    [
      "entolome",
      0.0125
    ],
    [
      "farinier",
      0.0125
    ],
    [
      "fistuline",
      0.0125
    ],
    [
      "girolle",
      0.0125
    ],
    [
      "golmotte",
      0.0125
    ],
    [
      "helvelle",
      0.0125
    ],
    [
      "accelerateur",
      0.0125
    ]
  ],
  "kart": [],
  "race": [
    [
      "famille",
      0.145
    ],
    [
      "lignee",
      0.0775
    ],
    [
      "descendance",
      0.0575
    ],
    [
      "filiation",
      0.0575
    ],
    [
      "origine",
      0.045
    ],
    [
      "extraction",
      0.045
    ],
    [
      "ascendance",
      0.04
    ],
    [
      "souche",
      0.04
    ],
    [
      "genealogie",
      0.0275
    ],
    [
      "posterite",
      0.0275
    ],
    [
      "progeniture",
      0.0225
    ],
    [
      "maison",
      0.0225
    ],
    [
      "classe",
      0.02
    ],
    [
      "generation",
      0.02
    ],
    [
      "lignage",
      0.02
    ],
    [
      "naissance",
      0.02
    ],
    [
      "sang",
      0.02
    ],
    [
      "tribu",
      0.015
    ],
    [
      "parents",
      0.015
    ],
    [
      "groupe",
      0.015
    ],
    [
      "tige",
      0.01
    ],
    [
      "peuplade",
      0.01
    ],
    [
      "ligne",
      0.01
    ],
    [
      "espece",
      0.01
    ],
    [
      "consanguinite",
      0.01
    ],
    [
      "categorie",
      0.01
    ],
    [
      "branche",
      0.01
    ],
    [
      "sorte",
      0.0075
    ],
    [
      "produit",
      0.0075
    ],
    [
      "peuple",
      0.0075
    ],
    [
      "parentage",
      0.0075
    ],
    [
      "nation",
      0.0075
    ],
    [
      "heredite",
      0.0075
    ],
    [
      "gent",
      0.0075
    ],
    [
      "genre",
      0.0075
    ],
    [
      "fils",
      0.0075
    ],
    [
      "extrance",
      0.0075
    ],
    [
      "couvee",
      0.0075
    ],
    [
      "ancetres",
      0.0075
    ],
    [
      "graine",
      0.0025
    ],
    [
      "heritiers",
      0.0025
    ],
    [
      "parage",
      0.0025
    ],
    [
      "rejetons",
      0.0025
    ],
    [
      "type",
      0.0025
    ],
    [
      "ethnie",
      0.0025
    ],
    [
      "estoc",
      0.0025
    ],
    [
      "engeance",
      0.0025
    ],
    [
      "enfants",
      0.0025
    ],
    [
      "dynastie",
      0.0025
    ],
    [
      "couche",
      0.0025
    ],
    [
      "chic",
      0.0025
    ],
    [
      "elegance",
      0.0025
    ]
  ],
  "carapace": [
    [
      "cuirasse",
      0.2325
    ],
    [
      "protection",
      0.165
    ],
    [
      "test",
      0.1325
    ],
    [
      "bouclier",
      0.1
    ],
    [
      "enveloppe",
      0.1
    ],
    [
      "habitacle",
      0.065
    ],
    [
      "coquille",
      0.065
    ],
    [
      "armure",
      0.0325
    ],
    [
      "blindage",
      0.0325
    ],
    [
      "plastron",
      0.0325
    ],
    [
      "rempart",
      0.0325
    ]
  ],
  "caser": [
    [
      "placer",
      0.1675
    ],
    [
      "mettre",
      0.1175
    ],
    [
      "ranger",
      0.1175
    ],
    [
      "situer",
      0.09
    ],
    [
      "disposer",
      0.065
    ],
    [
      "loger",
      0.065
    ],
    [
      "ordonner",
      0.05
    ],
    [
      "etablir",
      0.0375
    ],
    [
      "installer",
      0.0375
    ],
    [
      "fourrer",
      0.0375
    ],
    [
      "classer",
      0.0375
    ],
    [
      "serrer",
      0.025
    ],
    [
      "fixer",
      0.025
    ],
    [
      "distribuer",
      0.025
    ],
    [
      "coller",
      0.025
    ],
    [
      "aligner",
      0.0125
    ],
    [
      "enfourner",
      0.0125
    ],
    [
      "nicher",
      0.0125
    ],
    [
      "remiser",
      0.0125
    ],
    [
      "tabler",
      0.0125
    ]
  ],
  "case": [
    [
      "cabane",
      0.105
    ],
    [
      "hutte",
      0.08
    ],
    [
      "abri",
      0.065
    ],
    [
      "chambre",
      0.065
    ],
    [
      "compartiment",
      0.065
    ],
    [
      "maison",
      0.0525
    ],
    [
      "habitation",
      0.0525
    ],
    [
      "cellule",
      0.0525
    ],
    [
      "baraque",
      0.04
    ],
    [
      "boite",
      0.04
    ],
    [
      "cage",
      0.04
    ],
    [
      "cagibi",
      0.04
    ],
    [
      "division",
      0.04
    ],
    [
      "gourbi",
      0.025
    ],
    [
      "casier",
      0.025
    ],
    [
      "box",
      0.025
    ],
    [
      "alveole",
      0.025
    ],
    [
      "wigwam",
      0.0125
    ],
    [
      "vignette",
      0.0125
    ],
    [
      "vide",
      0.0125
    ],
    [
      "subdivision",
      0.0125
    ],
    [
      "partie",
      0.0125
    ],
    [
      "paillote",
      0.0125
    ],
    [
      "maisonnette",
      0.0125
    ],
    [
      "cartoon",
      0.0125
    ],
    [
      "carre",
      0.0125
    ],
    [
      "carbet",
      0.0125
    ],
    [
      "yourte",
      0.0125
    ]
  ],
  "kamikaze": [],
  "soit": [
    [
      "bien",
      0.2
    ],
    [
      "bon",
      0.2
    ],
    [
      "ou",
      0.2
    ]
  ],
  "mesure": [
    [
      "reserve",
      0.0425
    ],
    [
      "circonspection",
      0.0375
    ],
    [
      "retenue",
      0.0375
    ],
    [
      "moderation",
      0.0325
    ],
    [
      "dimension",
      0.0275
    ],
    [
      "capacite",
      0.0275
    ],
    [
      "sobriete",
      0.0225
    ],
    [
      "sagesse",
      0.0225
    ],
    [
      "precaution",
      0.0225
    ],
    [
      "prudence",
      0.0225
    ],
    [
      "proportion",
      0.0225
    ],
    [
      "point",
      0.0225
    ],
    [
      "moyen",
      0.0225
    ],
    [
      "disposition",
      0.0225
    ],
    [
      "accord",
      0.0225
    ],
    [
      "equilibre",
      0.0175
    ],
    [
      "echelle",
      0.0175
    ],
    [
      "temperament",
      0.0175
    ],
    [
      "rythme",
      0.0175
    ],
    [
      "rapport",
      0.0175
    ],
    [
      "quantite",
      0.0175
    ],
    [
      "ponderation",
      0.0175
    ],
    [
      "poids",
      0.0175
    ],
    [
      "discretion",
      0.0175
    ],
    [
      "combinaison",
      0.0175
    ],
    [
      "terme",
      0.0125
    ],
    [
      "unite",
      0.0125
    ],
    [
      "vers",
      0.0125
    ],
    [
      "economie",
      0.0125
    ],
    [
      "evaluation",
      0.0125
    ],
    [
      "taille",
      0.0125
    ],
    [
      "menagement",
      0.0125
    ],
    [
      "dose",
      0.0125
    ],
    [
      "degre",
      0.0125
    ],
    [
      "cote",
      0.0125
    ],
    [
      "charge",
      0.0125
    ],
    [
      "calcul",
      0.0125
    ],
    [
      "cadence",
      0.0125
    ],
    [
      "poesie",
      0.0075
    ],
    [
      "precision",
      0.0075
    ],
    [
      "sens",
      0.0075
    ],
    [
      "temperance",
      0.0075
    ],
    [
      "volume",
      0.0075
    ],
    [
      "etalon",
      0.0075
    ],
    [
      "norme",
      0.0075
    ],
    [
      "maniere",
      0.0075
    ],
    [
      "batterie",
      0.0075
    ],
    [
      "borne",
      0.0075
    ],
    [
      "comparaison",
      0.0075
    ],
    [
      "contenance",
      0.0075
    ],
    [
      "determination",
      0.0075
    ],
    [
      "gabarit",
      0.0075
    ],
    [
      "metrologie",
      0.0025
    ],
    [
      "metre",
      0.0025
    ],
    [
      "profondeur",
      0.0025
    ],
    [
      "preparatif",
      0.0025
    ],
    [
      "ration",
      0.0025
    ],
    [
      "regle",
      0.0025
    ],
    [
      "statistique",
      0.0025
    ],
    [
      "stature",
      0.0025
    ],
    [
      "versification",
      0.0025
    ],
    [
      "metrique",
      0.0025
    ],
    [
      "metre",
      0.0025
    ],
    [
      "mouvement",
      0.0025
    ],
    [
      "appreciation",
      0.0025
    ],
    [
      "jaugeage",
      0.0025
    ],
    [
      "limite",
      0.0025
    ],
    [
      "mensuration",
      0.0025
    ],
    [
      "mesurage",
      0.0025
    ],
    [
      "milieu",
      0.0025
    ],
    [
      "acte",
      0.0025
    ]
  ],
  "mesurer": [
    [
      "evaluer",
      0.105
    ],
    [
      "peser",
      0.07
    ],
    [
      "estimer",
      0.06
    ],
    [
      "regler",
      0.06
    ],
    [
      "apprecier",
      0.05
    ],
    [
      "temperer",
      0.05
    ],
    [
      "moderer",
      0.0425
    ],
    [
      "jauger",
      0.0425
    ],
    [
      "calculer",
      0.0425
    ],
    [
      "contenir",
      0.0325
    ],
    [
      "faire",
      0.0325
    ],
    [
      "juger",
      0.0325
    ],
    [
      "proportionner",
      0.025
    ],
    [
      "determiner",
      0.025
    ],
    [
      "doser",
      0.025
    ],
    [
      "compter",
      0.025
    ],
    [
      "supputer",
      0.015
    ],
    [
      "rythmer",
      0.015
    ],
    [
      "menager",
      0.015
    ],
    [
      "distribuer",
      0.015
    ],
    [
      "essayer",
      0.0075
    ],
    [
      "marchander",
      0.0075
    ],
    [
      "metrer",
      0.0075
    ],
    [
      "normaliser",
      0.0075
    ],
    [
      "nuancer",
      0.0075
    ],
    [
      "quantifier",
      0.0075
    ],
    [
      "ralentir",
      0.0075
    ],
    [
      "relativiser",
      0.0075
    ],
    [
      "sonder",
      0.0075
    ],
    [
      "toiser",
      0.0075
    ],
    [
      "developper",
      0.0075
    ],
    [
      "departir",
      0.0075
    ],
    [
      "auner",
      0.0075
    ],
    [
      "avoir",
      0.0075
    ],
    [
      "cadencer",
      0.0075
    ],
    [
      "calibrer",
      0.0075
    ],
    [
      "chainer",
      0.0075
    ],
    [
      "comparer",
      0.0075
    ],
    [
      "compasser",
      0.0075
    ],
    [
      "corder",
      0.0075
    ],
    [
      "cuber",
      0.0075
    ],
    [
      "arpenter",
      0.0075
    ]
  ],
  "metrer": [
    [
      "mesurer",
      1.0
    ]
  ],
  "metre": [
    [
      "mesure",
      0.2
    ],
    [
      "pied",
      0.2
    ],
    [
      "rythme",
      0.2
    ],
    [
      "syllabe",
      0.2
    ],
    [
      "vers",
      0.2
    ]
  ],
  "lopette": [],
  "salopette": [
    [
      "bleu",
      0.25
    ],
    [
      "combinaison",
      0.25
    ],
    [
      "cotte",
      0.25
    ],
    [
      "neglige",
      0.25
    ]
  ],
  "venerer": [
    [
      "adorer",
      0.1675
    ],
    [
      "estimer",
      0.11
    ],
    [
      "aimer",
      0.0925
    ],
    [
      "reverer",
      0.0925
    ],
    [
      "admirer",
      0.0725
    ],
    [
      "apprecier",
      0.0725
    ],
    [
      "cherir",
      0.0725
    ],
    [
      "honorer",
      0.055
    ],
    [
      "considerer",
      0.055
    ],
    [
      "benir",
      0.035
    ],
    [
      "deifier",
      0.035
    ],
    [
      "idolatrer",
      0.035
    ],
    [
      "respecter",
      0.035
    ],
    [
      "entourer",
      0.0175
    ],
    [
      "s'agenouiller",
      0.0175
    ]
  ],
  "eboueur": [
    [
      "balayeur",
      0.3325
    ],
    [
      "boueur",
      0.3325
    ],
    [
      "boueux",
      0.3325
    ]
  ],
  "ci": [
    [
      "ceci",
      0.3325
    ],
    [
      "ici",
      0.3325
    ],
    [
      "voici",
      0.3325
    ]
  ],
  "perso": [],
  "sport": [
    [
      "amusement",
      0.18
    ],
    [
      "gymnastique",
      0.18
    ],
    [
      "entrainement",
      0.09
    ],
    [
      "exercice",
      0.09
    ],
    [
      "jeu",
      0.09
    ],
    [
      "loyal",
      0.09
    ],
    [
      "ebats",
      0.09
    ]
  ],
  "max": [],
  "porc": [
    [
      "cochon",
      0.165
    ],
    [
      "obscene",
      0.1025
    ],
    [
      "degoutant",
      0.0825
    ],
    [
      "ordurier",
      0.0825
    ],
    [
      "gras",
      0.06
    ],
    [
      "grossier",
      0.06
    ],
    [
      "verrat",
      0.04
    ],
    [
      "sale",
      0.04
    ],
    [
      "pecari",
      0.04
    ],
    [
      "goret",
      0.04
    ],
    [
      "solitaire",
      0.0175
    ],
    [
      "pourceau",
      0.0175
    ],
    [
      "porcin",
      0.0175
    ],
    [
      "porcelet",
      0.0175
    ],
    [
      "peau",
      0.0175
    ],
    [
      "gros",
      0.0175
    ],
    [
      "glouton",
      0.0175
    ],
    [
      "debauche",
      0.0175
    ],
    [
      "cochonnet",
      0.0175
    ],
    [
      "coche",
      0.0175
    ],
    [
      "chatre",
      0.0175
    ],
    [
      "charcuterie",
      0.0175
    ],
    [
      "bete",
      0.0175
    ],
    [
      "truie",
      0.0175
    ]
  ],
  "carriere": [
    [
      "arene",
      0.07
    ],
    [
      "lice",
      0.07
    ],
    [
      "etat",
      0.0525
    ],
    [
      "profession",
      0.0525
    ],
    [
      "enceinte",
      0.0525
    ],
    [
      "cirque",
      0.0525
    ],
    [
      "champ",
      0.0525
    ],
    [
      "stade",
      0.035
    ],
    [
      "situation",
      0.035
    ],
    [
      "metier",
      0.035
    ],
    [
      "fonction",
      0.035
    ],
    [
      "course",
      0.035
    ],
    [
      "cours",
      0.035
    ],
    [
      "cavite",
      0.035
    ],
    [
      "marbriere",
      0.0175
    ],
    [
      "marniere",
      0.0175
    ],
    [
      "meuliere",
      0.0175
    ],
    [
      "mine",
      0.0175
    ],
    [
      "occupation",
      0.0175
    ],
    [
      "platriere",
      0.0175
    ],
    [
      "sabliere",
      0.0175
    ],
    [
      "vie",
      0.0175
    ],
    [
      "manege",
      0.0175
    ],
    [
      "gresiere",
      0.0175
    ],
    [
      "amphitheatre",
      0.0175
    ],
    [
      "ardoisiere",
      0.0175
    ],
    [
      "avenir",
      0.0175
    ],
    [
      "ballastiere",
      0.0175
    ],
    [
      "catacombe",
      0.0175
    ],
    [
      "glaisiere",
      0.0175
    ],
    [
      "voie",
      0.0175
    ]
  ],
  "tueur": [
    [
      "meurtrier",
      0.1825
    ],
    [
      "assassin",
      0.1
    ],
    [
      "criminel",
      0.1
    ],
    [
      "boucher",
      0.08
    ],
    [
      "bourreau",
      0.06
    ],
    [
      "massacreur",
      0.06
    ],
    [
      "tortionnaire",
      0.04
    ],
    [
      "mortel",
      0.04
    ],
    [
      "homicide",
      0.04
    ],
    [
      "bravo",
      0.04
    ],
    [
      "spadassin",
      0.0175
    ],
    [
      "sicaire",
      0.0175
    ],
    [
      "satellite",
      0.0175
    ],
    [
      "fatal",
      0.0175
    ],
    [
      "estafier",
      0.0175
    ],
    [
      "dangereux",
      0.0175
    ],
    [
      "brave",
      0.0175
    ],
    [
      "braconnier",
      0.0175
    ],
    [
      "assommeur",
      0.0175
    ],
    [
      "abatteur",
      0.0175
    ],
    [
      "egorgeur",
      0.0175
    ]
  ],
  "aspirateur": [
    [
      "balai",
      1.0
    ]
  ],
  "boiteux": [
    [
      "bancal",
      0.115
    ],
    [
      "infirme",
      0.0775
    ],
    [
      "instable",
      0.0775
    ],
    [
      "difforme",
      0.055
    ],
    [
      "estropie",
      0.055
    ],
    [
      "imparfait",
      0.055
    ],
    [
      "eclope",
      0.055
    ],
    [
      "inegal",
      0.0375
    ],
    [
      "fragile",
      0.0375
    ],
    [
      "chancelant",
      0.0375
    ],
    [
      "branlant",
      0.0375
    ],
    [
      "bancroche",
      0.0375
    ],
    [
      "precaire",
      0.0175
    ],
    [
      "podagre",
      0.0175
    ],
    [
      "mal",
      0.0175
    ],
    [
      "invalide",
      0.0175
    ],
    [
      "incomplet",
      0.0175
    ],
    [
      "faux",
      0.0175
    ],
    [
      "esquinte",
      0.0175
    ],
    [
      "defectueux",
      0.0175
    ],
    [
      "claudicant",
      0.0175
    ],
    [
      "clampin",
      0.0175
    ],
    [
      "bequillard",
      0.0175
    ],
    [
      "banban",
      0.0175
    ],
    [
      "aberrant",
      0.0175
    ]
  ],
  "joueur": [
    [
      "enjoue",
      0.25
    ],
    [
      "folatre",
      0.125
    ],
    [
      "joyeux",
      0.125
    ],
    [
      "musicien",
      0.125
    ],
    [
      "speculateur",
      0.125
    ],
    [
      "taquin",
      0.125
    ],
    [
      "equipier",
      0.125
    ]
  ],
  "saoul": [],
  "meuf": [],
  "brioche": [
    [
      "bedaine",
      0.1175
    ],
    [
      "bedon",
      0.1175
    ],
    [
      "tirelire",
      0.1175
    ],
    [
      "ventre",
      0.1175
    ],
    [
      "patisserie",
      0.0575
    ],
    [
      "massepain",
      0.0575
    ],
    [
      "maladresse",
      0.0575
    ],
    [
      "kouglof",
      0.0575
    ],
    [
      "faute",
      0.0575
    ],
    [
      "erreur",
      0.0575
    ],
    [
      "bide",
      0.0575
    ],
    [
      "abdomen",
      0.0575
    ],
    [
      "tete",
      0.0575
    ]
  ],
  "mega": [],
  "moche": [
    [
      "mauvais",
      0.1825
    ],
    [
      "affreux",
      0.09
    ],
    [
      "triste",
      0.09
    ],
    [
      "vilain",
      0.09
    ],
    [
      "horrible",
      0.0675
    ],
    [
      "laid",
      0.0675
    ],
    [
      "pitoyable",
      0.0675
    ],
    [
      "meprisable",
      0.045
    ],
    [
      "infect",
      0.045
    ],
    [
      "facheux",
      0.045
    ],
    [
      "desagreable",
      0.045
    ],
    [
      "bleche",
      0.02
    ],
    [
      "degueulasse",
      0.02
    ],
    [
      "loquedu",
      0.02
    ],
    [
      "mesquin",
      0.02
    ],
    [
      "mochard",
      0.02
    ],
    [
      "piteux",
      0.02
    ],
    [
      "vache",
      0.02
    ]
  ],
  "cascader": [
    [
      "bondir",
      0.5
    ],
    [
      "degringoler",
      0.5
    ]
  ],
  "cascade": [
    [
      "chute",
      0.0975
    ],
    [
      "kyrielle",
      0.0975
    ],
    [
      "chapelet",
      0.08
    ],
    [
      "suite",
      0.08
    ],
    [
      "saut",
      0.065
    ],
    [
      "grele",
      0.065
    ],
    [
      "ribambelle",
      0.0475
    ],
    [
      "ricochet",
      0.0475
    ],
    [
      "serie",
      0.0475
    ],
    [
      "succession",
      0.0325
    ],
    [
      "degringolade",
      0.0325
    ],
    [
      "culbute",
      0.0325
    ],
    [
      "cataracte",
      0.0325
    ],
    [
      "avalanche",
      0.0325
    ],
    [
      "ecart",
      0.015
    ],
    [
      "tirade",
      0.015
    ],
    [
      "sequelle",
      0.015
    ],
    [
      "saccade",
      0.015
    ],
    [
      "rebondissement",
      0.015
    ],
    [
      "rapide",
      0.015
    ],
    [
      "defile",
      0.015
    ],
    [
      "cascatelle",
      0.015
    ],
    [
      "buffet",
      0.015
    ],
    [
      "bordee",
      0.015
    ],
    [
      "bond",
      0.015
    ],
    [
      "ecroulement",
      0.015
    ]
  ],
  "doublure": [
    [
      "cascadeur",
      0.11
    ],
    [
      "figurant",
      0.11
    ],
    [
      "passepoil",
      0.11
    ],
    [
      "remplacant",
      0.11
    ],
    [
      "reproduction",
      0.11
    ],
    [
      "revers",
      0.11
    ],
    [
      "replique",
      0.11
    ]
  ],
  "figurine": [
    [
      "statuette",
      0.265
    ],
    [
      "image",
      0.1575
    ],
    [
      "sculpture",
      0.105
    ],
    [
      "statue",
      0.105
    ],
    [
      "poussah",
      0.05
    ],
    [
      "poupee",
      0.05
    ],
    [
      "marmouset",
      0.05
    ],
    [
      "marmot",
      0.05
    ],
    [
      "figure",
      0.05
    ],
    [
      "bilboquet",
      0.05
    ],
    [
      "santon",
      0.05
    ]
  ],
  "melon": [
    [
      "imbecile",
      0.5
    ],
    [
      "pasteque",
      0.5
    ]
  ],
  "cachet": [
    [
      "marque",
      0.13
    ],
    [
      "caractere",
      0.0825
    ],
    [
      "griffe",
      0.06
    ],
    [
      "style",
      0.06
    ],
    [
      "estampille",
      0.0525
    ],
    [
      "empreinte",
      0.045
    ],
    [
      "touche",
      0.045
    ],
    [
      "poincon",
      0.0375
    ],
    [
      "sceau",
      0.0375
    ],
    [
      "tournure",
      0.03
    ],
    [
      "aspect",
      0.0225
    ],
    [
      "caracteristique",
      0.0225
    ],
    [
      "signe",
      0.0225
    ],
    [
      "timbre",
      0.015
    ],
    [
      "salaire",
      0.015
    ],
    [
      "retribution",
      0.015
    ],
    [
      "pastille",
      0.015
    ],
    [
      "paiement",
      0.015
    ],
    [
      "originalite",
      0.015
    ],
    [
      "note",
      0.015
    ],
    [
      "apparence",
      0.015
    ],
    [
      "chiffre",
      0.015
    ],
    [
      "coin",
      0.015
    ],
    [
      "fermeture",
      0.015
    ],
    [
      "honoraires",
      0.015
    ],
    [
      "patte",
      0.005
    ],
    [
      "pli",
      0.005
    ],
    [
      "prix",
      0.005
    ],
    [
      "scelle",
      0.005
    ],
    [
      "seing",
      0.005
    ],
    [
      "tampon",
      0.005
    ],
    [
      "ticket",
      0.005
    ],
    [
      "traitement",
      0.005
    ],
    [
      "elegance",
      0.005
    ],
    [
      "obliteration",
      0.005
    ],
    [
      "monogramme",
      0.005
    ],
    [
      "main",
      0.005
    ],
    [
      "armes",
      0.005
    ],
    [
      "armoiries",
      0.005
    ],
    [
      "bulle",
      0.005
    ],
    [
      "capsule",
      0.005
    ],
    [
      "casuel",
      0.005
    ],
    [
      "comprime",
      0.005
    ],
    [
      "contremarque",
      0.005
    ],
    [
      "garantie",
      0.005
    ],
    [
      "gelule",
      0.005
    ],
    [
      "emoluments",
      0.005
    ]
  ],
  "episode": [
    [
      "evenement",
      0.175
    ],
    [
      "fait",
      0.135
    ],
    [
      "accident",
      0.1175
    ],
    [
      "aventure",
      0.0975
    ],
    [
      "incident",
      0.0975
    ],
    [
      "circonstance",
      0.0775
    ],
    [
      "affaire",
      0.0575
    ],
    [
      "epoque",
      0.0375
    ],
    [
      "peripetie",
      0.0375
    ],
    [
      "moment",
      0.0375
    ],
    [
      "histoire",
      0.0375
    ],
    [
      "acte",
      0.0175
    ],
    [
      "digression",
      0.0175
    ],
    [
      "dependance",
      0.0175
    ],
    [
      "phase",
      0.0175
    ]
  ],
  "milliardaire": [
    [
      "nabab",
      0.3325
    ],
    [
      "riche",
      0.3325
    ],
    [
      "richissime",
      0.3325
    ]
  ],
  "locataire": [
    [
      "fermier",
      0.25
    ],
    [
      "hote",
      0.25
    ],
    [
      "occupant",
      0.25
    ],
    [
      "preneur",
      0.25
    ]
  ],
  "proprietaire": [
    [
      "bailleur",
      0.1425
    ],
    [
      "detenteur",
      0.095
    ],
    [
      "hote",
      0.095
    ],
    [
      "possesseur",
      0.095
    ],
    [
      "proprio",
      0.095
    ],
    [
      "titulaire",
      0.0475
    ],
    [
      "probloque",
      0.0475
    ],
    [
      "occupant",
      0.0475
    ],
    [
      "maitre",
      0.0475
    ],
    [
      "logeur",
      0.0475
    ],
    [
      "locateur",
      0.0475
    ],
    [
      "capitaliste",
      0.0475
    ],
    [
      "beneficiaire",
      0.0475
    ],
    [
      "actionnaire",
      0.0475
    ],
    [
      "vautour",
      0.0475
    ]
  ],
  "brulure": [
    [
      "feu",
      0.1375
    ],
    [
      "cautere",
      0.0675
    ],
    [
      "blessure",
      0.0525
    ],
    [
      "inflammation",
      0.0525
    ],
    [
      "lesion",
      0.0525
    ],
    [
      "ulceration",
      0.0325
    ],
    [
      "irritation",
      0.0325
    ],
    [
      "douleur",
      0.0325
    ],
    [
      "chaleur",
      0.0325
    ],
    [
      "brulement",
      0.0325
    ],
    [
      "ardeur",
      0.0325
    ],
    [
      "aigreur",
      0.0325
    ],
    [
      "irradiation",
      0.015
    ],
    [
      "morsure",
      0.015
    ],
    [
      "mortification",
      0.015
    ],
    [
      "phlogose",
      0.015
    ],
    [
      "point",
      0.015
    ],
    [
      "rougeur",
      0.015
    ],
    [
      "tache",
      0.015
    ],
    [
      "trou",
      0.015
    ],
    [
      "urtication",
      0.015
    ],
    [
      "echaudure",
      0.015
    ],
    [
      "insolation",
      0.015
    ],
    [
      "incendie",
      0.015
    ],
    [
      "flambee",
      0.015
    ],
    [
      "acidite",
      0.015
    ],
    [
      "ampoule",
      0.015
    ],
    [
      "brouissure",
      0.015
    ],
    [
      "cloque",
      0.015
    ],
    [
      "corrosion",
      0.015
    ],
    [
      "cuisson",
      0.015
    ],
    [
      "dessechement",
      0.015
    ],
    [
      "escarre",
      0.015
    ],
    [
      "fievre",
      0.015
    ],
    [
      "echauffement",
      0.015
    ]
  ],
  "moquer": [
    [
      "railler",
      0.4
    ],
    [
      "chiner",
      0.2
    ],
    [
      "ridiculiser",
      0.2
    ]
  ],
  "allure": [
    [
      "air",
      0.095
    ],
    [
      "tournure",
      0.075
    ],
    [
      "aspect",
      0.05
    ],
    [
      "exterieur",
      0.05
    ],
    [
      "attitude",
      0.0475
    ],
    [
      "genre",
      0.045
    ],
    [
      "tenue",
      0.0375
    ],
    [
      "maintien",
      0.0375
    ],
    [
      "demarche",
      0.0375
    ],
    [
      "forme",
      0.0375
    ],
    [
      "facon",
      0.0325
    ],
    [
      "comportement",
      0.03
    ],
    [
      "apparence",
      0.025
    ],
    [
      "port",
      0.025
    ],
    [
      "tour",
      0.0225
    ],
    [
      "marche",
      0.0225
    ],
    [
      "contenance",
      0.02
    ],
    [
      "degaine",
      0.02
    ],
    [
      "physionomie",
      0.02
    ],
    [
      "touche",
      0.015
    ],
    [
      "style",
      0.015
    ],
    [
      "conduite",
      0.015
    ],
    [
      "dehors",
      0.015
    ],
    [
      "mine",
      0.015
    ],
    [
      "caractere",
      0.01
    ],
    [
      "mouvement",
      0.01
    ],
    [
      "prestance",
      0.01
    ],
    [
      "train",
      0.0075
    ],
    [
      "silhouette",
      0.0075
    ],
    [
      "procede",
      0.0075
    ],
    [
      "couleur",
      0.0075
    ],
    [
      "course",
      0.0075
    ],
    [
      "ligne",
      0.0075
    ],
    [
      "semblance",
      0.0075
    ],
    [
      "elegance",
      0.005
    ],
    [
      "teinte",
      0.005
    ],
    [
      "pas",
      0.005
    ],
    [
      "manieres",
      0.005
    ],
    [
      "geste",
      0.005
    ],
    [
      "configuration",
      0.005
    ],
    [
      "chic",
      0.005
    ],
    [
      "prestige",
      0.0025
    ],
    [
      "look",
      0.0025
    ],
    [
      "galop",
      0.0025
    ],
    [
      "facies",
      0.0025
    ],
    [
      "erre",
      0.0025
    ],
    [
      "trot",
      0.0
    ],
    [
      "rythme",
      0.0
    ],
    [
      "panache",
      0.0
    ],
    [
      "noblesse",
      0.0
    ],
    [
      "encolure",
      0.0
    ],
    [
      "chien",
      0.0
    ],
    [
      "canter",
      0.0
    ],
    [
      "cadence",
      0.0
    ],
    [
      "binette",
      0.0
    ],
    [
      "bille",
      0.0
    ],
    [
      "vitesse",
      0.0
    ]
  ],
  "guerir": [
    [
      "adoucir",
      0.055
    ],
    [
      "relever",
      0.055
    ],
    [
      "ressusciter",
      0.055
    ],
    [
      "soulager",
      0.0425
    ],
    [
      "retablir",
      0.0325
    ],
    [
      "revivre",
      0.0325
    ],
    [
      "revenir",
      0.0325
    ],
    [
      "remedier",
      0.0325
    ],
    [
      "remettre",
      0.0325
    ],
    [
      "delivrer",
      0.0325
    ],
    [
      "corriger",
      0.0325
    ],
    [
      "calmer",
      0.0325
    ],
    [
      "apaiser",
      0.0325
    ],
    [
      "echapper",
      0.02
    ],
    [
      "tranquilliser",
      0.02
    ],
    [
      "sauver",
      0.02
    ],
    [
      "renaitre",
      0.02
    ],
    [
      "estomper",
      0.02
    ],
    [
      "effacer",
      0.02
    ],
    [
      "consoler",
      0.02
    ],
    [
      "cicatriser",
      0.02
    ],
    [
      "ameliorer",
      0.02
    ],
    [
      "rambiner",
      0.01
    ],
    [
      "rechapper",
      0.01
    ],
    [
      "traiter",
      0.01
    ],
    [
      "vacciner",
      0.01
    ],
    [
      "pallier",
      0.01
    ],
    [
      "desintoxiquer",
      0.01
    ],
    [
      "debarrasser",
      0.01
    ],
    [
      "couper",
      0.01
    ],
    [
      "chatier",
      0.01
    ]
  ],
  "infortune": [
    [
      "malheur",
      0.1575
    ],
    [
      "tribulation",
      0.145
    ],
    [
      "malchance",
      0.13
    ],
    [
      "malediction",
      0.065
    ],
    [
      "tuile",
      0.0525
    ],
    [
      "pepin",
      0.0525
    ],
    [
      "mesaventure",
      0.0525
    ],
    [
      "calamite",
      0.0525
    ],
    [
      "revers",
      0.0375
    ],
    [
      "disgrace",
      0.0375
    ],
    [
      "catastrophe",
      0.0375
    ],
    [
      "adversite",
      0.0375
    ],
    [
      "deception",
      0.025
    ],
    [
      "detresse",
      0.025
    ],
    [
      "insucces",
      0.025
    ],
    [
      "infelicite",
      0.0125
    ],
    [
      "misere",
      0.0125
    ]
  ],
  "habitude": [
    [
      "usage",
      0.1125
    ],
    [
      "accoutumance",
      0.065
    ],
    [
      "pratique",
      0.065
    ],
    [
      "manie",
      0.055
    ],
    [
      "routine",
      0.045
    ],
    [
      "mode",
      0.045
    ],
    [
      "coutume",
      0.045
    ],
    [
      "methode",
      0.035
    ],
    [
      "passion",
      0.035
    ],
    [
      "travers",
      0.0275
    ],
    [
      "tradition",
      0.0275
    ],
    [
      "tic",
      0.0275
    ],
    [
      "penchant",
      0.0275
    ],
    [
      "maniere",
      0.0275
    ],
    [
      "fureur",
      0.0275
    ],
    [
      "endurcissement",
      0.0275
    ],
    [
      "disposition",
      0.0275
    ],
    [
      "regle",
      0.0175
    ],
    [
      "rite",
      0.0175
    ],
    [
      "pli",
      0.0175
    ],
    [
      "marotte",
      0.0175
    ],
    [
      "frequentation",
      0.0175
    ],
    [
      "experience",
      0.0175
    ],
    [
      "errements",
      0.0175
    ],
    [
      "habitus",
      0.0075
    ],
    [
      "ordinaire",
      0.0075
    ],
    [
      "relation",
      0.0075
    ],
    [
      "us",
      0.0075
    ],
    [
      "facon",
      0.0075
    ],
    [
      "entrainement",
      0.0075
    ],
    [
      "endurance",
      0.0075
    ],
    [
      "deformation",
      0.0075
    ],
    [
      "attitude",
      0.0075
    ],
    [
      "adaptation",
      0.0075
    ],
    [
      "acclimatement",
      0.0075
    ],
    [
      "acclimatation",
      0.0075
    ],
    [
      "usance",
      0.0075
    ]
  ],
  "occuper": [
    [
      "prendre",
      0.0825
    ],
    [
      "tenir",
      0.075
    ],
    [
      "envahir",
      0.0625
    ],
    [
      "s'emparer",
      0.0475
    ],
    [
      "avoir",
      0.04
    ],
    [
      "remplir",
      0.0325
    ],
    [
      "captiver",
      0.0325
    ],
    [
      "assujettir",
      0.0325
    ],
    [
      "travailler",
      0.0275
    ],
    [
      "forcer",
      0.0275
    ],
    [
      "enlever",
      0.0275
    ],
    [
      "accaparer",
      0.0275
    ],
    [
      "saisir",
      0.02
    ],
    [
      "s'etendre",
      0.02
    ],
    [
      "passer",
      0.02
    ],
    [
      "employer",
      0.02
    ],
    [
      "disposer",
      0.02
    ],
    [
      "demeurer",
      0.02
    ],
    [
      "amuser",
      0.02
    ],
    [
      "absorber",
      0.02
    ],
    [
      "interesser",
      0.0125
    ],
    [
      "loger",
      0.0125
    ],
    [
      "obliger",
      0.0125
    ],
    [
      "resider",
      0.0125
    ],
    [
      "tromper",
      0.0125
    ],
    [
      "tuer",
      0.0125
    ],
    [
      "inonder",
      0.0125
    ],
    [
      "habiter",
      0.0125
    ],
    [
      "garnir",
      0.0125
    ],
    [
      "agir",
      0.0125
    ],
    [
      "agiter",
      0.0125
    ],
    [
      "condamner",
      0.0125
    ],
    [
      "distraire",
      0.0125
    ],
    [
      "durer",
      0.0125
    ],
    [
      "detenir",
      0.0125
    ],
    [
      "embrasser",
      0.0125
    ],
    [
      "sejourner",
      0.005
    ],
    [
      "submerger",
      0.005
    ],
    [
      "s'approprier",
      0.005
    ],
    [
      "meubler",
      0.005
    ],
    [
      "emplir",
      0.005
    ],
    [
      "controler",
      0.005
    ],
    [
      "coloniser",
      0.005
    ],
    [
      "besogner",
      0.005
    ],
    [
      "atteler",
      0.005
    ],
    [
      "appliquer",
      0.005
    ],
    [
      "accabler",
      0.005
    ],
    [
      "truffer",
      0.005
    ]
  ],
  "cas": [
    [
      "evenement",
      0.115
    ],
    [
      "occasion",
      0.0975
    ],
    [
      "circonstance",
      0.0925
    ],
    [
      "affaire",
      0.08
    ],
    [
      "rencontre",
      0.07
    ],
    [
      "fait",
      0.0575
    ],
    [
      "hasard",
      0.045
    ],
    [
      "accident",
      0.045
    ],
    [
      "aventure",
      0.04
    ],
    [
      "incident",
      0.035
    ],
    [
      "conjoncture",
      0.0275
    ],
    [
      "eventualite",
      0.0225
    ],
    [
      "situation",
      0.0225
    ],
    [
      "cause",
      0.0225
    ],
    [
      "occurrence",
      0.0175
    ],
    [
      "possibilite",
      0.0175
    ],
    [
      "temps",
      0.0175
    ],
    [
      "etat",
      0.0175
    ],
    [
      "position",
      0.01
    ],
    [
      "matiere",
      0.01
    ],
    [
      "lieu",
      0.01
    ],
    [
      "histoire",
      0.01
    ],
    [
      "espece",
      0.01
    ],
    [
      "delit",
      0.01
    ],
    [
      "declinaison",
      0.01
    ],
    [
      "action",
      0.01
    ],
    [
      "nominatif",
      0.005
    ],
    [
      "maladie",
      0.005
    ],
    [
      "hypothese",
      0.005
    ],
    [
      "exemple",
      0.005
    ],
    [
      "desinence",
      0.005
    ],
    [
      "dossier",
      0.005
    ],
    [
      "crime",
      0.005
    ],
    [
      "casuistique",
      0.005
    ],
    [
      "casuel",
      0.005
    ],
    [
      "proces",
      0.005
    ]
  ],
  "quelquefois": [
    [
      "parfois",
      0.285
    ],
    [
      "rarement",
      0.1425
    ]
  ],
  "aventurer": [
    [
      "risquer",
      0.25
    ],
    [
      "hasarder",
      0.2075
    ],
    [
      "exposer",
      0.125
    ],
    [
      "compromettre",
      0.0825
    ],
    [
      "tenter",
      0.04
    ],
    [
      "jouer",
      0.04
    ],
    [
      "experimenter",
      0.04
    ],
    [
      "essayer",
      0.04
    ],
    [
      "engager",
      0.04
    ],
    [
      "commettre",
      0.04
    ],
    [
      "emettre",
      0.04
    ]
  ],
  "aventure": [
    [
      "evenement",
      0.15
    ],
    [
      "accident",
      0.0675
    ],
    [
      "affaire",
      0.0675
    ],
    [
      "fait",
      0.0675
    ],
    [
      "incident",
      0.0475
    ],
    [
      "histoire",
      0.0475
    ],
    [
      "cas",
      0.0475
    ],
    [
      "hasard",
      0.04
    ],
    [
      "amour",
      0.0325
    ],
    [
      "intrigue",
      0.0325
    ],
    [
      "episode",
      0.0325
    ],
    [
      "mesaventure",
      0.025
    ],
    [
      "alea",
      0.0175
    ],
    [
      "epreuve",
      0.0175
    ],
    [
      "rencontre",
      0.0175
    ],
    [
      "galanterie",
      0.0175
    ],
    [
      "fortune",
      0.0175
    ],
    [
      "destin",
      0.0175
    ],
    [
      "amourette",
      0.0175
    ],
    [
      "sort",
      0.0125
    ],
    [
      "revers",
      0.0125
    ],
    [
      "peripetie",
      0.0125
    ],
    [
      "peril",
      0.0125
    ],
    [
      "passade",
      0.0125
    ],
    [
      "liaison",
      0.0125
    ],
    [
      "expedition",
      0.0125
    ],
    [
      "entreprise",
      0.0125
    ],
    [
      "destinee",
      0.0125
    ],
    [
      "toquade",
      0.005
    ],
    [
      "odyssee",
      0.005
    ],
    [
      "imprudence",
      0.005
    ],
    [
      "heur",
      0.005
    ],
    [
      "errance",
      0.005
    ],
    [
      "conquete",
      0.005
    ],
    [
      "caprice",
      0.005
    ],
    [
      "beguin",
      0.005
    ],
    [
      "avenir",
      0.005
    ],
    [
      "equipee",
      0.005
    ]
  ],
  "inquiet": [
    [
      "soucieux",
      0.0825
    ],
    [
      "craintif",
      0.06
    ],
    [
      "affole",
      0.05
    ],
    [
      "effraye",
      0.05
    ],
    [
      "tourmente",
      0.05
    ],
    [
      "epouvante",
      0.05
    ],
    [
      "preoccupe",
      0.045
    ],
    [
      "trouble",
      0.045
    ],
    [
      "apeure",
      0.0375
    ],
    [
      "anxieux",
      0.0375
    ],
    [
      "angoisse",
      0.0375
    ],
    [
      "bilieux",
      0.0325
    ],
    [
      "embarrasse",
      0.0325
    ],
    [
      "alarme",
      0.0275
    ],
    [
      "effare",
      0.0275
    ],
    [
      "sombre",
      0.02
    ],
    [
      "agite",
      0.02
    ],
    [
      "terrifie",
      0.015
    ],
    [
      "peureux",
      0.015
    ],
    [
      "ombrageux",
      0.015
    ],
    [
      "nerveux",
      0.015
    ],
    [
      "ennuye",
      0.015
    ],
    [
      "effarouche",
      0.015
    ],
    [
      "epeure",
      0.01
    ],
    [
      "transi",
      0.01
    ],
    [
      "tracasse",
      0.01
    ],
    [
      "soupconneux",
      0.01
    ],
    [
      "pessimiste",
      0.01
    ],
    [
      "perplexe",
      0.01
    ],
    [
      "noir",
      0.01
    ],
    [
      "fievreux",
      0.01
    ],
    [
      "deconcerte",
      0.01
    ],
    [
      "chagrin",
      0.01
    ],
    [
      "sot",
      0.005
    ],
    [
      "tendu",
      0.005
    ],
    [
      "terrorise",
      0.005
    ],
    [
      "remuant",
      0.005
    ],
    [
      "insatisfait",
      0.005
    ],
    [
      "impatient",
      0.005
    ],
    [
      "crispe",
      0.005
    ],
    [
      "atterre",
      0.005
    ],
    [
      "traque",
      0.005
    ]
  ],
  "inquieter": [
    [
      "tourmenter",
      0.1175
    ],
    [
      "troubler",
      0.0675
    ],
    [
      "affoler",
      0.055
    ],
    [
      "tracasser",
      0.05
    ],
    [
      "alarmer",
      0.045
    ],
    [
      "effrayer",
      0.045
    ],
    [
      "harceler",
      0.0425
    ],
    [
      "agiter",
      0.0425
    ],
    [
      "embarrasser",
      0.0325
    ],
    [
      "preoccuper",
      0.0325
    ],
    [
      "epouvanter",
      0.03
    ],
    [
      "terroriser",
      0.03
    ],
    [
      "contrarier",
      0.03
    ],
    [
      "intimider",
      0.025
    ],
    [
      "travailler",
      0.025
    ],
    [
      "chagriner",
      0.02
    ],
    [
      "ennuyer",
      0.02
    ],
    [
      "secouer",
      0.02
    ],
    [
      "emouvoir",
      0.015
    ],
    [
      "effaroucher",
      0.015
    ],
    [
      "angoisser",
      0.015
    ],
    [
      "terrifier",
      0.0125
    ],
    [
      "tarabuster",
      0.0125
    ],
    [
      "ronger",
      0.0125
    ],
    [
      "navrer",
      0.0125
    ],
    [
      "molester",
      0.0125
    ],
    [
      "apeurer",
      0.0125
    ],
    [
      "vexer",
      0.0075
    ],
    [
      "persecuter",
      0.0075
    ],
    [
      "miner",
      0.0075
    ],
    [
      "deconcerter",
      0.0075
    ],
    [
      "chicaner",
      0.0075
    ],
    [
      "assieger",
      0.0075
    ],
    [
      "traquer",
      0.0025
    ],
    [
      "taquiner",
      0.0025
    ],
    [
      "reveiller",
      0.0025
    ],
    [
      "mordre",
      0.0025
    ],
    [
      "menacer",
      0.0025
    ],
    [
      "intriguer",
      0.0025
    ],
    [
      "derouter",
      0.0025
    ],
    [
      "alerter",
      0.0025
    ],
    [
      "emotionner",
      0.0025
    ]
  ],
  "juge": [
    [
      "magistrat",
      0.175
    ],
    [
      "inquisiteur",
      0.0575
    ],
    [
      "expert",
      0.0575
    ],
    [
      "critique",
      0.0575
    ],
    [
      "censeur",
      0.0575
    ],
    [
      "arbitre",
      0.0575
    ],
    [
      "appreciateur",
      0.0575
    ],
    [
      "heliaste",
      0.0275
    ],
    [
      "justicier",
      0.0275
    ],
    [
      "official",
      0.0275
    ],
    [
      "prevot",
      0.0275
    ],
    [
      "robin",
      0.0275
    ],
    [
      "tribunal",
      0.0275
    ],
    [
      "vengeur",
      0.0275
    ],
    [
      "examinateur",
      0.0275
    ],
    [
      "estimateur",
      0.0275
    ],
    [
      "departiteur",
      0.0275
    ],
    [
      "curieux",
      0.0275
    ],
    [
      "controleur",
      0.0275
    ],
    [
      "casuiste",
      0.0275
    ],
    [
      "cadi",
      0.0275
    ],
    [
      "alcade",
      0.0275
    ],
    [
      "viguier",
      0.0275
    ]
  ],
  "autrui": [
    [
      "prochain",
      0.5
    ],
    [
      "autre",
      0.25
    ],
    [
      "semblable",
      0.25
    ]
  ],
  "intenable": [
    [
      "infernal",
      0.1625
    ],
    [
      "insupportable",
      0.1375
    ],
    [
      "terrible",
      0.115
    ],
    [
      "dur",
      0.0925
    ],
    [
      "invivable",
      0.0675
    ],
    [
      "intolerable",
      0.0675
    ],
    [
      "indocile",
      0.0675
    ],
    [
      "indiscipline",
      0.0675
    ],
    [
      "diable",
      0.045
    ],
    [
      "impossible",
      0.045
    ],
    [
      "epouvantable",
      0.045
    ],
    [
      "desobeissant",
      0.0225
    ],
    [
      "indomptable",
      0.0225
    ],
    [
      "remuant",
      0.0225
    ]
  ],
  "guette": [
    [
      "guet",
      0.285
    ],
    [
      "sentinelle",
      0.285
    ],
    [
      "guetteur",
      0.1425
    ],
    [
      "surveillance",
      0.1425
    ],
    [
      "echauguette",
      0.1425
    ]
  ],
  "guetter": [
    [
      "surveiller",
      0.1525
    ],
    [
      "epier",
      0.1525
    ],
    [
      "attendre",
      0.115
    ],
    [
      "observer",
      0.075
    ],
    [
      "pister",
      0.0375
    ],
    [
      "menacer",
      0.0375
    ],
    [
      "guigner",
      0.0375
    ],
    [
      "espionner",
      0.0375
    ]
  ],
  "subir": [
    [
      "souffrir",
      0.085
    ],
    [
      "supporter",
      0.085
    ],
    [
      "endurer",
      0.07
    ],
    [
      "recevoir",
      0.07
    ],
    [
      "eprouver",
      0.07
    ],
    [
      "accepter",
      0.045
    ],
    [
      "prendre",
      0.0375
    ],
    [
      "passer",
      0.0375
    ],
    [
      "encaisser",
      0.0375
    ],
    [
      "connaitre",
      0.0375
    ],
    [
      "ecoper",
      0.03
    ],
    [
      "suivre",
      0.03
    ],
    [
      "sentir",
      0.03
    ],
    [
      "ressentir",
      0.03
    ],
    [
      "essuyer",
      0.0225
    ],
    [
      "soutenir",
      0.0225
    ],
    [
      "voir",
      0.0225
    ],
    [
      "vivre",
      0.015
    ],
    [
      "tolerer",
      0.015
    ],
    [
      "obeir",
      0.015
    ],
    [
      "experimenter",
      0.015
    ],
    [
      "deguster",
      0.015
    ],
    [
      "digerer",
      0.015
    ],
    [
      "trinquer",
      0.0075
    ],
    [
      "s'exposer",
      0.0075
    ],
    [
      "s'appuyer",
      0.0075
    ],
    [
      "resister",
      0.0075
    ],
    [
      "purger",
      0.0075
    ],
    [
      "payer",
      0.0075
    ],
    [
      "encourir",
      0.0075
    ],
    [
      "courber",
      0.0075
    ],
    [
      "accuser",
      0.0075
    ]
  ],
  "cacophonie": [
    [
      "tintamarre",
      0.1425
    ],
    [
      "chahut",
      0.1075
    ],
    [
      "tumulte",
      0.0875
    ],
    [
      "tapage",
      0.07
    ],
    [
      "confusion",
      0.07
    ],
    [
      "charivari",
      0.07
    ],
    [
      "bruit",
      0.0525
    ],
    [
      "dissonance",
      0.0525
    ],
    [
      "desordre",
      0.0525
    ],
    [
      "vacarme",
      0.0525
    ],
    [
      "serenade",
      0.035
    ],
    [
      "desaccord",
      0.035
    ],
    [
      "brouhaha",
      0.035
    ],
    [
      "babel",
      0.0175
    ],
    [
      "canard",
      0.0175
    ],
    [
      "concert",
      0.0175
    ],
    [
      "discordance",
      0.0175
    ],
    [
      "disparate",
      0.0175
    ],
    [
      "hiatus",
      0.0175
    ],
    [
      "melange",
      0.0175
    ]
  ],
  "scie": [
    [
      "antienne",
      0.1575
    ],
    [
      "refrain",
      0.1575
    ],
    [
      "rengaine",
      0.1575
    ],
    [
      "chanson",
      0.105
    ],
    [
      "ritournelle",
      0.105
    ],
    [
      "sciotte",
      0.05
    ],
    [
      "repetition",
      0.05
    ],
    [
      "romance",
      0.05
    ],
    [
      "barbe",
      0.05
    ],
    [
      "egoine",
      0.05
    ]
  ],
  "scier": [
    [
      "couper",
      0.3625
    ],
    [
      "abattre",
      0.09
    ],
    [
      "debiter",
      0.09
    ],
    [
      "decouper",
      0.09
    ],
    [
      "fendre",
      0.09
    ],
    [
      "separer",
      0.09
    ],
    [
      "tronconner",
      0.09
    ],
    [
      "etonner",
      0.09
    ]
  ],
  "delit": [
    [
      "faute",
      0.2175
    ],
    [
      "crime",
      0.155
    ],
    [
      "infraction",
      0.125
    ],
    [
      "peine",
      0.0625
    ],
    [
      "forfait",
      0.0625
    ],
    [
      "fait",
      0.0625
    ],
    [
      "cas",
      0.0625
    ],
    [
      "attentat",
      0.0625
    ],
    [
      "contravention",
      0.03
    ],
    [
      "manquement",
      0.03
    ],
    [
      "mefait",
      0.03
    ],
    [
      "recidive",
      0.03
    ],
    [
      "veine",
      0.03
    ]
  ],
  "requiem": [],
  "depit": [
    [
      "colere",
      0.105
    ],
    [
      "aigreur",
      0.0875
    ],
    [
      "deception",
      0.0875
    ],
    [
      "chagrin",
      0.07
    ],
    [
      "mecontentement",
      0.07
    ],
    [
      "ressentiment",
      0.0525
    ],
    [
      "irritation",
      0.0525
    ],
    [
      "facherie",
      0.0525
    ],
    [
      "desappointement",
      0.0525
    ],
    [
      "contrariete",
      0.0525
    ],
    [
      "amertume",
      0.0525
    ],
    [
      "rancoeur",
      0.035
    ],
    [
      "degout",
      0.035
    ],
    [
      "brouille",
      0.035
    ],
    [
      "bisbille",
      0.0175
    ],
    [
      "bouderie",
      0.0175
    ],
    [
      "courroux",
      0.0175
    ],
    [
      "deconvenue",
      0.0175
    ],
    [
      "jalousie",
      0.0175
    ],
    [
      "pique",
      0.0175
    ],
    [
      "vexation",
      0.0175
    ]
  ],
  "semer": [
    [
      "repandre",
      0.0925
    ],
    [
      "parsemer",
      0.0675
    ],
    [
      "couvrir",
      0.055
    ],
    [
      "lacher",
      0.0425
    ],
    [
      "passer",
      0.035
    ],
    [
      "eparpiller",
      0.035
    ],
    [
      "etendre",
      0.03
    ],
    [
      "tapisser",
      0.03
    ],
    [
      "quitter",
      0.03
    ],
    [
      "jeter",
      0.03
    ],
    [
      "disseminer",
      0.03
    ],
    [
      "abandonner",
      0.03
    ],
    [
      "etaler",
      0.0225
    ],
    [
      "propager",
      0.0225
    ],
    [
      "planter",
      0.0225
    ],
    [
      "faire",
      0.0225
    ],
    [
      "disperser",
      0.0225
    ],
    [
      "repartir",
      0.0175
    ],
    [
      "revetir",
      0.0175
    ],
    [
      "remplir",
      0.0175
    ],
    [
      "partir",
      0.0175
    ],
    [
      "orner",
      0.0175
    ],
    [
      "laisser",
      0.0175
    ],
    [
      "joncher",
      0.0175
    ],
    [
      "ensemencer",
      0.0175
    ],
    [
      "dresser",
      0.0175
    ],
    [
      "epandre",
      0.01
    ],
    [
      "echapper",
      0.01
    ],
    [
      "gratter",
      0.01
    ],
    [
      "depasser",
      0.01
    ],
    [
      "delaisser",
      0.01
    ],
    [
      "distribuer",
      0.01
    ],
    [
      "distancer",
      0.01
    ],
    [
      "cultiver",
      0.01
    ],
    [
      "consteller",
      0.01
    ],
    [
      "souffler",
      0.005
    ],
    [
      "multiplier",
      0.005
    ],
    [
      "larder",
      0.005
    ],
    [
      "emblaver",
      0.005
    ],
    [
      "detaler",
      0.005
    ],
    [
      "derouter",
      0.005
    ],
    [
      "depister",
      0.005
    ],
    [
      "decamper",
      0.005
    ],
    [
      "devancer",
      0.005
    ],
    [
      "emailler",
      0.005
    ]
  ],
  "seme": [
    [
      "repandre",
      0.0925
    ],
    [
      "parsemer",
      0.0675
    ],
    [
      "couvrir",
      0.055
    ],
    [
      "lacher",
      0.0425
    ],
    [
      "passer",
      0.035
    ],
    [
      "eparpiller",
      0.035
    ],
    [
      "etendre",
      0.03
    ],
    [
      "tapisser",
      0.03
    ],
    [
      "quitter",
      0.03
    ],
    [
      "jeter",
      0.03
    ],
    [
      "disseminer",
      0.03
    ],
    [
      "abandonner",
      0.03
    ],
    [
      "etaler",
      0.0225
    ],
    [
      "propager",
      0.0225
    ],
    [
      "planter",
      0.0225
    ],
    [
      "faire",
      0.0225
    ],
    [
      "disperser",
      0.0225
    ],
    [
      "repartir",
      0.0175
    ],
    [
      "revetir",
      0.0175
    ],
    [
      "remplir",
      0.0175
    ],
    [
      "partir",
      0.0175
    ],
    [
      "orner",
      0.0175
    ],
    [
      "laisser",
      0.0175
    ],
    [
      "joncher",
      0.0175
    ],
    [
      "ensemencer",
      0.0175
    ],
    [
      "dresser",
      0.0175
    ],
    [
      "epandre",
      0.01
    ],
    [
      "echapper",
      0.01
    ],
    [
      "gratter",
      0.01
    ],
    [
      "depasser",
      0.01
    ],
    [
      "delaisser",
      0.01
    ],
    [
      "distribuer",
      0.01
    ],
    [
      "distancer",
      0.01
    ],
    [
      "cultiver",
      0.01
    ],
    [
      "consteller",
      0.01
    ],
    [
      "souffler",
      0.005
    ],
    [
      "multiplier",
      0.005
    ],
    [
      "larder",
      0.005
    ],
    [
      "emblaver",
      0.005
    ],
    [
      "detaler",
      0.005
    ],
    [
      "derouter",
      0.005
    ],
    [
      "depister",
      0.005
    ],
    [
      "decamper",
      0.005
    ],
    [
      "devancer",
      0.005
    ],
    [
      "emailler",
      0.005
    ]
  ],
  "blaspheme": [
    [
      "injure",
      0.12
    ],
    [
      "jurement",
      0.12
    ],
    [
      "outrage",
      0.12
    ],
    [
      "sacrilege",
      0.08
    ],
    [
      "profanation",
      0.08
    ],
    [
      "insulte",
      0.08
    ],
    [
      "imprecation",
      0.08
    ],
    [
      "affront",
      0.08
    ],
    [
      "execration",
      0.0375
    ],
    [
      "grossierete",
      0.0375
    ],
    [
      "impiete",
      0.0375
    ],
    [
      "juron",
      0.0375
    ],
    [
      "malediction",
      0.0375
    ],
    [
      "offense",
      0.0375
    ]
  ],
  "blasphemer": [
    [
      "injurier",
      0.1525
    ],
    [
      "jurer",
      0.1525
    ],
    [
      "outrager",
      0.1525
    ],
    [
      "sacrer",
      0.075
    ],
    [
      "renier",
      0.075
    ],
    [
      "proferer",
      0.075
    ],
    [
      "profaner",
      0.075
    ],
    [
      "maudire",
      0.075
    ],
    [
      "insulter",
      0.075
    ]
  ],
  "maudire": [
    [
      "fulminer",
      0.11
    ],
    [
      "tempeter",
      0.065
    ],
    [
      "reprouver",
      0.065
    ],
    [
      "rejeter",
      0.065
    ],
    [
      "pester",
      0.065
    ],
    [
      "injurier",
      0.065
    ],
    [
      "detester",
      0.065
    ],
    [
      "tonner",
      0.0425
    ],
    [
      "s'indigner",
      0.0425
    ],
    [
      "execrer",
      0.0425
    ],
    [
      "excommunier",
      0.0425
    ],
    [
      "condamner",
      0.0425
    ],
    [
      "blamer",
      0.0425
    ],
    [
      "anathematiser",
      0.0425
    ],
    [
      "s'emporter",
      0.02
    ],
    [
      "hair",
      0.02
    ],
    [
      "fletrir",
      0.02
    ],
    [
      "blasphemer",
      0.02
    ],
    [
      "agonir",
      0.02
    ],
    [
      "abominer",
      0.02
    ],
    [
      "abhorrer",
      0.02
    ]
  ],
  "tapi": [
    [
      "fuir",
      0.0525
    ],
    [
      "disparaitre",
      0.0525
    ],
    [
      "s'eclipser",
      0.035
    ],
    [
      "s'abriter",
      0.035
    ],
    [
      "s'embusquer",
      0.015
    ],
    [
      "s'accroupir",
      0.015
    ],
    [
      "eviter",
      0.015
    ]
  ],
  "repit": [
    [
      "interruption",
      0.08
    ],
    [
      "remission",
      0.08
    ],
    [
      "pause",
      0.07
    ],
    [
      "treve",
      0.07
    ],
    [
      "repos",
      0.0575
    ],
    [
      "suspension",
      0.05
    ],
    [
      "delai",
      0.05
    ],
    [
      "cessation",
      0.05
    ],
    [
      "arret",
      0.05
    ],
    [
      "detente",
      0.0375
    ],
    [
      "relache",
      0.0375
    ],
    [
      "eclaircie",
      0.0275
    ],
    [
      "temps",
      0.0275
    ],
    [
      "remise",
      0.0275
    ],
    [
      "intermission",
      0.0275
    ],
    [
      "halte",
      0.0275
    ],
    [
      "accalmie",
      0.0275
    ],
    [
      "tranquillite",
      0.0175
    ],
    [
      "sursis",
      0.0175
    ],
    [
      "intervalle",
      0.0175
    ],
    [
      "bonace",
      0.0175
    ],
    [
      "amelioration",
      0.0175
    ],
    [
      "atermoiement",
      0.0075
    ],
    [
      "delassement",
      0.0075
    ],
    [
      "facilite",
      0.0075
    ]
  ],
  "renier": [
    [
      "desavouer",
      0.135
    ],
    [
      "abandonner",
      0.1075
    ],
    [
      "renoncer",
      0.1075
    ],
    [
      "trahir",
      0.0825
    ],
    [
      "quitter",
      0.0525
    ],
    [
      "deserter",
      0.0525
    ],
    [
      "abjurer",
      0.0525
    ],
    [
      "retracter",
      0.025
    ],
    [
      "repudier",
      0.025
    ],
    [
      "nier",
      0.025
    ],
    [
      "meconnaitre",
      0.025
    ],
    [
      "mentir",
      0.025
    ],
    [
      "demordre",
      0.025
    ],
    [
      "blasphemer",
      0.025
    ],
    [
      "apostasier",
      0.025
    ]
  ],
  "fatal": [
    [
      "funeste",
      0.0875
    ],
    [
      "mauvais",
      0.0875
    ],
    [
      "inevitable",
      0.0775
    ],
    [
      "nefaste",
      0.065
    ],
    [
      "pernicieux",
      0.0425
    ],
    [
      "nuisible",
      0.0425
    ],
    [
      "mortel",
      0.0425
    ],
    [
      "malheureux",
      0.0425
    ],
    [
      "ineluctable",
      0.0425
    ],
    [
      "implacable",
      0.0425
    ],
    [
      "desastreux",
      0.0425
    ],
    [
      "fatidique",
      0.0325
    ],
    [
      "immanquable",
      0.0325
    ],
    [
      "necessaire",
      0.0325
    ],
    [
      "obligatoire",
      0.02
    ],
    [
      "logique",
      0.02
    ],
    [
      "facheux",
      0.02
    ],
    [
      "force",
      0.02
    ],
    [
      "dommageable",
      0.02
    ],
    [
      "catastrophique",
      0.02
    ],
    [
      "sur",
      0.01
    ],
    [
      "ruineux",
      0.01
    ],
    [
      "nocif",
      0.01
    ],
    [
      "maudit",
      0.01
    ],
    [
      "letal",
      0.01
    ],
    [
      "irrevocable",
      0.01
    ],
    [
      "irremediable",
      0.01
    ],
    [
      "inexorable",
      0.01
    ],
    [
      "deplorable",
      0.01
    ],
    [
      "calamiteux",
      0.01
    ],
    [
      "tueur",
      0.01
    ]
  ],
  "heresie": [
    [
      "dissidence",
      0.18
    ],
    [
      "apostasie",
      0.09
    ],
    [
      "deviation",
      0.09
    ],
    [
      "erreur",
      0.09
    ],
    [
      "impiete",
      0.09
    ],
    [
      "secte",
      0.045
    ],
    [
      "schisme",
      0.045
    ],
    [
      "sacrilege",
      0.045
    ],
    [
      "revolte",
      0.045
    ],
    [
      "reforme",
      0.045
    ],
    [
      "reniement",
      0.045
    ],
    [
      "heterodoxie",
      0.045
    ],
    [
      "faussete",
      0.045
    ],
    [
      "contreverite",
      0.045
    ],
    [
      "separation",
      0.045
    ]
  ],
  "ronger": [
    [
      "detruire",
      0.1225
    ],
    [
      "miner",
      0.0925
    ],
    [
      "corroder",
      0.055
    ],
    [
      "ruiner",
      0.05
    ],
    [
      "consumer",
      0.045
    ],
    [
      "entamer",
      0.045
    ],
    [
      "user",
      0.045
    ],
    [
      "tourmenter",
      0.0375
    ],
    [
      "saper",
      0.0375
    ],
    [
      "mordre",
      0.0375
    ],
    [
      "devorer",
      0.0375
    ],
    [
      "manger",
      0.03
    ],
    [
      "harceler",
      0.0225
    ],
    [
      "degrader",
      0.0225
    ],
    [
      "attaquer",
      0.0225
    ],
    [
      "alterer",
      0.0225
    ],
    [
      "diminuer",
      0.02
    ],
    [
      "bruler",
      0.0175
    ],
    [
      "eroder",
      0.0125
    ],
    [
      "travailler",
      0.0125
    ],
    [
      "ravager",
      0.0125
    ],
    [
      "hanter",
      0.0125
    ],
    [
      "grignoter",
      0.0125
    ],
    [
      "epuiser",
      0.01
    ],
    [
      "trifouiller",
      0.01
    ],
    [
      "tenailler",
      0.01
    ],
    [
      "pourrir",
      0.01
    ],
    [
      "inquieter",
      0.01
    ],
    [
      "desagreger",
      0.01
    ],
    [
      "dissoudre",
      0.01
    ],
    [
      "affouiller",
      0.01
    ],
    [
      "piquer",
      0.005
    ],
    [
      "devaster",
      0.005
    ],
    [
      "bourreler",
      0.005
    ],
    [
      "assaillir",
      0.005
    ],
    [
      "caver",
      0.0025
    ],
    [
      "fouir",
      0.0025
    ],
    [
      "gangrener",
      0.0025
    ],
    [
      "mouliner",
      0.0025
    ],
    [
      "nettoyer",
      0.0025
    ],
    [
      "rouiller",
      0.0025
    ],
    [
      "ruminer",
      0.0025
    ]
  ],
  "violon": [
    [
      "dada",
      0.11
    ],
    [
      "marotte",
      0.11
    ],
    [
      "toquade",
      0.11
    ],
    [
      "stradivarius",
      0.055
    ],
    [
      "prison",
      0.055
    ],
    [
      "passion",
      0.055
    ],
    [
      "hobby",
      0.055
    ],
    [
      "crincrin",
      0.055
    ],
    [
      "corde",
      0.055
    ],
    [
      "cellule",
      0.055
    ],
    [
      "cachot",
      0.055
    ],
    [
      "amati",
      0.055
    ],
    [
      "alto",
      0.055
    ],
    [
      "violoniste",
      0.055
    ]
  ],
  "violence": [
    [
      "ardeur",
      0.075
    ],
    [
      "emportement",
      0.0525
    ],
    [
      "vehemence",
      0.05
    ],
    [
      "frenesie",
      0.0475
    ],
    [
      "fureur",
      0.0475
    ],
    [
      "force",
      0.0425
    ],
    [
      "vivacite",
      0.04
    ],
    [
      "impetuosite",
      0.035
    ],
    [
      "brutalite",
      0.035
    ],
    [
      "bouillonnement",
      0.035
    ],
    [
      "chaleur",
      0.03
    ],
    [
      "agitation",
      0.0275
    ],
    [
      "vigueur",
      0.0275
    ],
    [
      "passion",
      0.02
    ],
    [
      "feu",
      0.02
    ],
    [
      "colere",
      0.02
    ],
    [
      "fougue",
      0.0175
    ],
    [
      "aprete",
      0.015
    ],
    [
      "puissance",
      0.015
    ],
    [
      "profondeur",
      0.015
    ],
    [
      "furie",
      0.015
    ],
    [
      "animosite",
      0.015
    ],
    [
      "virulence",
      0.01
    ],
    [
      "sevices",
      0.01
    ],
    [
      "intensite",
      0.01
    ],
    [
      "ferocite",
      0.01
    ],
    [
      "dechainement",
      0.01
    ],
    [
      "agressivite",
      0.01
    ],
    [
      "viol",
      0.0075
    ],
    [
      "precipitation",
      0.0075
    ],
    [
      "exces",
      0.0075
    ],
    [
      "effort",
      0.0075
    ],
    [
      "durete",
      0.0075
    ],
    [
      "contrainte",
      0.0075
    ],
    [
      "agression",
      0.0075
    ],
    [
      "energie",
      0.005
    ],
    [
      "emeute",
      0.005
    ],
    [
      "torture",
      0.005
    ],
    [
      "soulevement",
      0.005
    ],
    [
      "sauvagerie",
      0.005
    ],
    [
      "revolution",
      0.005
    ],
    [
      "revolte",
      0.005
    ],
    [
      "outrance",
      0.005
    ],
    [
      "crudite",
      0.005
    ],
    [
      "gene",
      0.005
    ],
    [
      "irascibilite",
      0.005
    ],
    [
      "irritabilite",
      0.005
    ],
    [
      "mal",
      0.005
    ],
    [
      "kidnapping",
      0.0025
    ],
    [
      "obligation",
      0.0025
    ],
    [
      "oppression",
      0.0025
    ],
    [
      "pesanteur",
      0.0025
    ],
    [
      "pogrom",
      0.0025
    ],
    [
      "profanation",
      0.0025
    ],
    [
      "sevice",
      0.0025
    ],
    [
      "torrent",
      0.0025
    ],
    [
      "intolerance",
      0.0025
    ],
    [
      "intemperance",
      0.0025
    ],
    [
      "attentat",
      0.0025
    ],
    [
      "defloraison",
      0.0025
    ],
    [
      "defloration",
      0.0025
    ],
    [
      "demence",
      0.0025
    ],
    [
      "demesure",
      0.0025
    ],
    [
      "enlevement",
      0.0025
    ],
    [
      "exacerbation",
      0.0025
    ],
    [
      "faction",
      0.0025
    ],
    [
      "volcan",
      0.0025
    ]
  ],
  "symphonie": [
    [
      "harmonie",
      0.2375
    ],
    [
      "concert",
      0.1775
    ],
    [
      "hymne",
      0.1175
    ],
    [
      "polyphonie",
      0.0575
    ],
    [
      "musique",
      0.0575
    ],
    [
      "homophonie",
      0.0575
    ],
    [
      "entente",
      0.0575
    ],
    [
      "consonance",
      0.0575
    ],
    [
      "concerto",
      0.0575
    ],
    [
      "choeur",
      0.0575
    ],
    [
      "union",
      0.0575
    ]
  ],
  "concerto": [
    [
      "symphonie",
      1.0
    ]
  ],
  "phobie": [
    [
      "peur",
      0.16
    ],
    [
      "crainte",
      0.12
    ],
    [
      "horreur",
      0.12
    ],
    [
      "terreur",
      0.08
    ],
    [
      "spectre",
      0.08
    ],
    [
      "repulsion",
      0.08
    ],
    [
      "frayeur",
      0.08
    ],
    [
      "effroi",
      0.08
    ],
    [
      "degout",
      0.04
    ],
    [
      "execration",
      0.04
    ],
    [
      "frousse",
      0.04
    ],
    [
      "haine",
      0.04
    ],
    [
      "obsession",
      0.04
    ]
  ],
  "desharmonie": [],
  "neuf": [
    [
      "nouveau",
      0.2375
    ],
    [
      "inedit",
      0.0925
    ],
    [
      "original",
      0.0925
    ],
    [
      "frais",
      0.0525
    ],
    [
      "pur",
      0.0525
    ],
    [
      "vierge",
      0.0375
    ],
    [
      "recent",
      0.0375
    ],
    [
      "jeune",
      0.0375
    ],
    [
      "inexperimente",
      0.0375
    ],
    [
      "inconnu",
      0.0375
    ],
    [
      "novice",
      0.025
    ],
    [
      "moderne",
      0.025
    ],
    [
      "inusite",
      0.025
    ],
    [
      "intact",
      0.025
    ],
    [
      "inoui",
      0.025
    ],
    [
      "innocent",
      0.025
    ],
    [
      "inimagine",
      0.025
    ],
    [
      "immacule",
      0.025
    ],
    [
      "audacieux",
      0.0125
    ],
    [
      "different",
      0.0125
    ],
    [
      "debutant",
      0.0125
    ],
    [
      "printanier",
      0.0125
    ],
    [
      "truculent",
      0.0125
    ]
  ],
  "sauvage": [
    [
      "grossier",
      0.0625
    ],
    [
      "farouche",
      0.06
    ],
    [
      "barbare",
      0.055
    ],
    [
      "rude",
      0.05
    ],
    [
      "cruel",
      0.0475
    ],
    [
      "dur",
      0.0475
    ],
    [
      "feroce",
      0.0425
    ],
    [
      "rustique",
      0.03
    ],
    [
      "inhumain",
      0.025
    ],
    [
      "solitaire",
      0.0225
    ],
    [
      "fruste",
      0.02
    ],
    [
      "violent",
      0.0175
    ],
    [
      "sanguinaire",
      0.0175
    ],
    [
      "rustre",
      0.0175
    ],
    [
      "intraitable",
      0.0175
    ],
    [
      "inculte",
      0.0175
    ],
    [
      "fier",
      0.0175
    ],
    [
      "desert",
      0.0175
    ],
    [
      "brut",
      0.0175
    ],
    [
      "rustaud",
      0.01
    ],
    [
      "ours",
      0.01
    ],
    [
      "misanthrope",
      0.01
    ],
    [
      "malotru",
      0.01
    ],
    [
      "bestial",
      0.01
    ],
    [
      "retire",
      0.0075
    ],
    [
      "ostrogoth",
      0.0075
    ],
    [
      "mechant",
      0.0075
    ],
    [
      "irregulier",
      0.0075
    ],
    [
      "insoumis",
      0.0075
    ],
    [
      "insociable",
      0.0075
    ],
    [
      "inhospitalier",
      0.0075
    ],
    [
      "infrequente",
      0.0075
    ],
    [
      "abandonne",
      0.0075
    ],
    [
      "abrupt",
      0.0075
    ],
    [
      "agreste",
      0.0075
    ],
    [
      "butor",
      0.0075
    ],
    [
      "impitoyable",
      0.0075
    ],
    [
      "mufle",
      0.005
    ],
    [
      "ombrageux",
      0.005
    ],
    [
      "primitif",
      0.005
    ],
    [
      "sanglant",
      0.005
    ],
    [
      "seul",
      0.005
    ],
    [
      "timide",
      0.005
    ],
    [
      "triste",
      0.005
    ],
    [
      "apre",
      0.005
    ],
    [
      "inhabite",
      0.005
    ],
    [
      "indompte",
      0.005
    ],
    [
      "indomptable",
      0.005
    ],
    [
      "atroce",
      0.005
    ],
    [
      "brute",
      0.005
    ],
    [
      "cannibale",
      0.005
    ],
    [
      "carnassier",
      0.005
    ],
    [
      "craintif",
      0.005
    ],
    [
      "desole",
      0.005
    ],
    [
      "fauve",
      0.005
    ],
    [
      "goujat",
      0.005
    ],
    [
      "hirsute",
      0.005
    ],
    [
      "herisse",
      0.005
    ],
    [
      "redoutable",
      0.0025
    ],
    [
      "marron",
      0.0025
    ],
    [
      "sauvageon",
      0.0025
    ],
    [
      "spontane",
      0.0025
    ],
    [
      "truculent",
      0.0025
    ],
    [
      "tudesque",
      0.0025
    ],
    [
      "wisigoth",
      0.0025
    ],
    [
      "incivilise",
      0.0025
    ],
    [
      "inapprivoise",
      0.0025
    ],
    [
      "inapprivoisable",
      0.0025
    ],
    [
      "anthropophage",
      0.0025
    ],
    [
      "casanier",
      0.0025
    ],
    [
      "champetre",
      0.0025
    ],
    [
      "distant",
      0.0025
    ],
    [
      "ermite",
      0.0025
    ],
    [
      "gothique",
      0.0025
    ],
    [
      "hagard",
      0.0025
    ],
    [
      "illicite",
      0.0025
    ],
    [
      "illegal",
      0.0025
    ]
  ],
  "continent": [
    [
      "chaste",
      0.16
    ],
    [
      "sage",
      0.095
    ],
    [
      "vertueux",
      0.0625
    ],
    [
      "temperant",
      0.0625
    ],
    [
      "sobre",
      0.0625
    ],
    [
      "pur",
      0.0625
    ],
    [
      "pudique",
      0.0625
    ],
    [
      "modere",
      0.0625
    ],
    [
      "ascetique",
      0.0625
    ],
    [
      "abstinent",
      0.0625
    ],
    [
      "terre",
      0.03
    ],
    [
      "monde",
      0.03
    ],
    [
      "innocent",
      0.03
    ],
    [
      "decent",
      0.03
    ],
    [
      "continu",
      0.03
    ],
    [
      "vierge",
      0.03
    ]
  ],
  "grillage": [
    [
      "grille",
      0.2725
    ],
    [
      "cloture",
      0.18
    ],
    [
      "fermeture",
      0.09
    ],
    [
      "gazage",
      0.09
    ],
    [
      "grillade",
      0.09
    ],
    [
      "protection",
      0.09
    ],
    [
      "torrefaction",
      0.09
    ]
  ],
  "etroit": [
    [
      "petit",
      0.07
    ],
    [
      "court",
      0.065
    ],
    [
      "borne",
      0.0475
    ],
    [
      "etrique",
      0.0475
    ],
    [
      "severe",
      0.0375
    ],
    [
      "reduit",
      0.0375
    ],
    [
      "rigoureux",
      0.0375
    ],
    [
      "rigide",
      0.0375
    ],
    [
      "maigre",
      0.0375
    ],
    [
      "limite",
      0.0325
    ],
    [
      "mince",
      0.0325
    ],
    [
      "restreint",
      0.0325
    ],
    [
      "retreci",
      0.0325
    ],
    [
      "serre",
      0.025
    ],
    [
      "resserre",
      0.025
    ],
    [
      "juste",
      0.025
    ],
    [
      "exigu",
      0.02
    ],
    [
      "faible",
      0.02
    ],
    [
      "intolerant",
      0.02
    ],
    [
      "mesquin",
      0.02
    ],
    [
      "svelte",
      0.015
    ],
    [
      "strict",
      0.015
    ],
    [
      "sectaire",
      0.015
    ],
    [
      "modeste",
      0.015
    ],
    [
      "puritain",
      0.01
    ],
    [
      "janseniste",
      0.01
    ],
    [
      "fusele",
      0.01
    ],
    [
      "fin",
      0.01
    ],
    [
      "exclusif",
      0.01
    ],
    [
      "exact",
      0.01
    ],
    [
      "bute",
      0.01
    ],
    [
      "bouche",
      0.01
    ],
    [
      "inintelligent",
      0.005
    ],
    [
      "insensible",
      0.005
    ],
    [
      "intime",
      0.005
    ],
    [
      "prosaique",
      0.005
    ],
    [
      "ratatine",
      0.005
    ],
    [
      "restrictif",
      0.005
    ],
    [
      "routinier",
      0.005
    ],
    [
      "etire",
      0.005
    ],
    [
      "etrangle",
      0.005
    ],
    [
      "incomprehensif",
      0.005
    ],
    [
      "formaliste",
      0.005
    ],
    [
      "aplati",
      0.005
    ],
    [
      "begueule",
      0.005
    ],
    [
      "bete",
      0.005
    ],
    [
      "chauvin",
      0.005
    ],
    [
      "collant",
      0.005
    ],
    [
      "confine",
      0.005
    ],
    [
      "difficile",
      0.005
    ],
    [
      "effile",
      0.005
    ],
    [
      "encaisse",
      0.005
    ],
    [
      "familier",
      0.005
    ],
    [
      "etreci",
      0.005
    ]
  ],
  "portee": [
    [
      "pousser",
      0.055
    ],
    [
      "donner",
      0.04
    ],
    [
      "montrer",
      0.03
    ],
    [
      "exciter",
      0.025
    ],
    [
      "entrainer",
      0.025
    ],
    [
      "produire",
      0.0225
    ],
    [
      "transporter",
      0.02
    ],
    [
      "mettre",
      0.02
    ],
    [
      "appliquer",
      0.02
    ],
    [
      "provoquer",
      0.0175
    ],
    [
      "rapporter",
      0.0175
    ],
    [
      "elever",
      0.0175
    ],
    [
      "dire",
      0.0175
    ],
    [
      "determiner",
      0.0175
    ],
    [
      "engager",
      0.015
    ],
    [
      "appuyer",
      0.015
    ],
    [
      "temoigner",
      0.0125
    ],
    [
      "rendre",
      0.0125
    ],
    [
      "preter",
      0.0125
    ],
    [
      "lancer",
      0.0125
    ],
    [
      "frapper",
      0.0125
    ],
    [
      "attacher",
      0.0125
    ],
    [
      "apporter",
      0.0125
    ],
    [
      "poser",
      0.0125
    ],
    [
      "encourager",
      0.0125
    ],
    [
      "conduire",
      0.0125
    ],
    [
      "afficher",
      0.0125
    ],
    [
      "soutenir",
      0.01
    ],
    [
      "inviter",
      0.01
    ],
    [
      "inciter",
      0.01
    ],
    [
      "heurter",
      0.01
    ],
    [
      "exprimer",
      0.01
    ],
    [
      "diriger",
      0.01
    ],
    [
      "attirer",
      0.01
    ],
    [
      "etendre",
      0.01
    ],
    [
      "tenir",
      0.01
    ],
    [
      "presenter",
      0.01
    ],
    [
      "envoyer",
      0.01
    ],
    [
      "allonger",
      0.01
    ],
    [
      "toucher",
      0.0075
    ],
    [
      "susciter",
      0.0075
    ],
    [
      "relever",
      0.0075
    ],
    [
      "promouvoir",
      0.0075
    ],
    [
      "peser",
      0.0075
    ],
    [
      "monter",
      0.0075
    ],
    [
      "manifester",
      0.0075
    ],
    [
      "declarer",
      0.0075
    ],
    [
      "exalter",
      0.0075
    ],
    [
      "incliner",
      0.0075
    ],
    [
      "inscrire",
      0.0075
    ],
    [
      "livrer",
      0.0075
    ],
    [
      "traduire",
      0.005
    ],
    [
      "rouler",
      0.005
    ],
    [
      "rencontrer",
      0.005
    ],
    [
      "offrir",
      0.005
    ],
    [
      "occasionner",
      0.005
    ],
    [
      "indiquer",
      0.005
    ],
    [
      "imputer",
      0.005
    ],
    [
      "coucher",
      0.005
    ],
    [
      "charger",
      0.005
    ],
    [
      "adresser",
      0.005
    ],
    [
      "transcrire",
      0.005
    ],
    [
      "solliciter",
      0.005
    ],
    [
      "prononcer",
      0.005
    ],
    [
      "hausser",
      0.005
    ],
    [
      "emporter",
      0.005
    ],
    [
      "embarquer",
      0.005
    ],
    [
      "creer",
      0.005
    ],
    [
      "atteindre",
      0.005
    ],
    [
      "assener",
      0.005
    ],
    [
      "traiter",
      0.0025
    ],
    [
      "supporter",
      0.0025
    ],
    [
      "s'etendre",
      0.0025
    ],
    [
      "reporter",
      0.0025
    ],
    [
      "prodiguer",
      0.0025
    ],
    [
      "importer",
      0.0025
    ],
    [
      "hisser",
      0.0025
    ],
    [
      "exhiber",
      0.0025
    ],
    [
      "engendrer",
      0.0025
    ],
    [
      "avoir",
      0.0025
    ],
    [
      "posseder",
      0.0
    ],
    [
      "promener",
      0.0
    ],
    [
      "reposer",
      0.0
    ],
    [
      "revetir",
      0.0
    ],
    [
      "trimballer",
      0.0
    ],
    [
      "user",
      0.0
    ],
    [
      "pencher",
      0.0
    ],
    [
      "induire",
      0.0
    ],
    [
      "agrandir",
      0.0
    ],
    [
      "arborer",
      0.0
    ],
    [
      "catapulter",
      0.0
    ],
    [
      "charrier",
      0.0
    ],
    [
      "cogner",
      0.0
    ],
    [
      "fructifier",
      0.0
    ],
    [
      "vehiculer",
      0.0
    ],
    [
      "transferer",
      0.0
    ],
    [
      "stipuler",
      0.0
    ],
    [
      "souffrir",
      0.0
    ],
    [
      "s'habiller",
      0.0
    ],
    [
      "predisposer",
      0.0
    ],
    [
      "mouvoir",
      0.0
    ],
    [
      "exporter",
      0.0
    ],
    [
      "coltiner",
      0.0
    ],
    [
      "achopper",
      0.0
    ],
    [
      "etayer",
      0.0
    ]
  ],
  "dependre": [
    [
      "resulter",
      0.105
    ],
    [
      "ressortir",
      0.085
    ],
    [
      "appartenir",
      0.0625
    ],
    [
      "decouler",
      0.0625
    ],
    [
      "tenir",
      0.0625
    ],
    [
      "venir",
      0.0625
    ],
    [
      "s'ensuivre",
      0.04
    ],
    [
      "provenir",
      0.04
    ],
    [
      "proceder",
      0.04
    ],
    [
      "rouler",
      0.02
    ],
    [
      "reposer",
      0.02
    ],
    [
      "mouvoir",
      0.02
    ],
    [
      "detacher",
      0.02
    ],
    [
      "decrocher",
      0.02
    ],
    [
      "dissoudre",
      0.02
    ],
    [
      "concerner",
      0.02
    ]
  ],
  "roche": [
    [
      "pierre",
      0.2525
    ],
    [
      "bloc",
      0.1
    ],
    [
      "caillou",
      0.1
    ],
    [
      "rocher",
      0.0725
    ],
    [
      "roc",
      0.05
    ],
    [
      "pave",
      0.05
    ],
    [
      "parpaing",
      0.05
    ],
    [
      "moellon",
      0.05
    ],
    [
      "galet",
      0.05
    ],
    [
      "sediment",
      0.0225
    ],
    [
      "montagne",
      0.0225
    ],
    [
      "mineral",
      0.0225
    ],
    [
      "minerai",
      0.0225
    ],
    [
      "gres",
      0.0225
    ],
    [
      "granit",
      0.0225
    ],
    [
      "colline",
      0.0225
    ],
    [
      "caillasse",
      0.0225
    ],
    [
      "ecueil",
      0.0225
    ]
  ],
  "cuire": [
    [
      "fricasser",
      0.1025
    ],
    [
      "griller",
      0.0675
    ],
    [
      "mijoter",
      0.0675
    ],
    [
      "rotir",
      0.0675
    ],
    [
      "bruler",
      0.0575
    ],
    [
      "rissoler",
      0.045
    ],
    [
      "preparer",
      0.0325
    ],
    [
      "piquer",
      0.0325
    ],
    [
      "fricoter",
      0.0325
    ],
    [
      "chauffer",
      0.0325
    ],
    [
      "renverser",
      0.0225
    ],
    [
      "murir",
      0.0225
    ],
    [
      "mitonner",
      0.0225
    ],
    [
      "gratter",
      0.0225
    ],
    [
      "faire",
      0.0225
    ],
    [
      "cuisiner",
      0.0225
    ],
    [
      "calciner",
      0.0225
    ],
    [
      "bronzer",
      0.0225
    ],
    [
      "braiser",
      0.0225
    ],
    [
      "bouillir",
      0.0225
    ],
    [
      "boucaner",
      0.0225
    ],
    [
      "frire",
      0.01
    ],
    [
      "frissonner",
      0.01
    ],
    [
      "infuser",
      0.01
    ],
    [
      "recuire",
      0.01
    ],
    [
      "etouffer",
      0.01
    ],
    [
      "flamber",
      0.01
    ],
    [
      "digerer",
      0.01
    ],
    [
      "cramer",
      0.01
    ],
    [
      "carboniser",
      0.01
    ],
    [
      "blondir",
      0.01
    ],
    [
      "biscuiter",
      0.01
    ],
    [
      "attacher",
      0.01
    ],
    [
      "etuver",
      0.01
    ]
  ],
  "empirer": [
    [
      "s'aggraver",
      0.215
    ],
    [
      "augmenter",
      0.13
    ],
    [
      "aggraver",
      0.085
    ],
    [
      "s'inveterer",
      0.0425
    ],
    [
      "s'envenimer",
      0.0425
    ],
    [
      "s'empirer",
      0.0425
    ],
    [
      "s'aigrir",
      0.0425
    ],
    [
      "pericliter",
      0.0425
    ],
    [
      "progresser",
      0.0425
    ],
    [
      "decliner",
      0.0425
    ],
    [
      "aigrir",
      0.0425
    ]
  ],
  "empire": [
    [
      "pouvoir",
      0.1325
    ],
    [
      "autorite",
      0.12
    ],
    [
      "domination",
      0.0725
    ],
    [
      "influence",
      0.0725
    ],
    [
      "ascendant",
      0.06
    ],
    [
      "puissance",
      0.06
    ],
    [
      "maitrise",
      0.0475
    ],
    [
      "emprise",
      0.04
    ],
    [
      "etat",
      0.035
    ],
    [
      "gouvernement",
      0.035
    ],
    [
      "regne",
      0.0275
    ],
    [
      "souverainete",
      0.0275
    ],
    [
      "hegemonie",
      0.0225
    ],
    [
      "tyrannie",
      0.0175
    ],
    [
      "superiorite",
      0.0175
    ],
    [
      "royaume",
      0.0175
    ],
    [
      "possession",
      0.0175
    ],
    [
      "mainmise",
      0.0175
    ],
    [
      "loi",
      0.0175
    ],
    [
      "credit",
      0.0175
    ],
    [
      "prestige",
      0.01
    ],
    [
      "pays",
      0.01
    ],
    [
      "griffe",
      0.01
    ],
    [
      "couronne",
      0.01
    ],
    [
      "controle",
      0.01
    ],
    [
      "colonie",
      0.01
    ],
    [
      "preeminence",
      0.005
    ],
    [
      "prise",
      0.005
    ],
    [
      "pression",
      0.005
    ],
    [
      "effet",
      0.005
    ],
    [
      "commonwealth",
      0.005
    ],
    [
      "commandement",
      0.005
    ],
    [
      "aigle",
      0.005
    ]
  ],
  "penible": [
    [
      "tendu",
      0.0725
    ],
    [
      "triste",
      0.0525
    ],
    [
      "affligeant",
      0.045
    ],
    [
      "ennuyeux",
      0.045
    ],
    [
      "cruel",
      0.0425
    ],
    [
      "mauvais",
      0.04
    ],
    [
      "douloureux",
      0.0375
    ],
    [
      "dur",
      0.0325
    ],
    [
      "rude",
      0.0325
    ],
    [
      "difficile",
      0.0275
    ],
    [
      "insupportable",
      0.0275
    ],
    [
      "navrant",
      0.025
    ],
    [
      "desagreable",
      0.025
    ],
    [
      "fatigant",
      0.0225
    ],
    [
      "desolant",
      0.02
    ],
    [
      "terrible",
      0.02
    ],
    [
      "intolerable",
      0.0175
    ],
    [
      "amer",
      0.0175
    ],
    [
      "lourd",
      0.0175
    ],
    [
      "atroce",
      0.015
    ],
    [
      "pesant",
      0.015
    ],
    [
      "facheux",
      0.015
    ],
    [
      "deplorable",
      0.015
    ],
    [
      "accablant",
      0.015
    ],
    [
      "lamentable",
      0.0125
    ],
    [
      "malheureux",
      0.0125
    ],
    [
      "torturant",
      0.0125
    ],
    [
      "odieux",
      0.0125
    ],
    [
      "embarrassant",
      0.01
    ],
    [
      "attristant",
      0.01
    ],
    [
      "piteux",
      0.0075
    ],
    [
      "genant",
      0.0075
    ],
    [
      "grave",
      0.0075
    ],
    [
      "funeste",
      0.0075
    ],
    [
      "invivable",
      0.0075
    ],
    [
      "apre",
      0.0075
    ],
    [
      "epineux",
      0.0075
    ],
    [
      "epouvantable",
      0.0075
    ],
    [
      "epuisant",
      0.005
    ],
    [
      "tuant",
      0.005
    ],
    [
      "poignant",
      0.005
    ],
    [
      "mortel",
      0.005
    ],
    [
      "affreux",
      0.005
    ],
    [
      "aigre",
      0.005
    ],
    [
      "impossible",
      0.005
    ],
    [
      "infernal",
      0.005
    ],
    [
      "sempiternel",
      0.005
    ],
    [
      "ereintant",
      0.005
    ],
    [
      "laborieux",
      0.0025
    ],
    [
      "deplaisant",
      0.0025
    ],
    [
      "eprouvant",
      0.0025
    ],
    [
      "ecrasant",
      0.0025
    ],
    [
      "somnifere",
      0.0025
    ],
    [
      "peine",
      0.0025
    ],
    [
      "malcommode",
      0.0025
    ],
    [
      "malaise",
      0.0025
    ],
    [
      "ingrat",
      0.0025
    ],
    [
      "gros",
      0.0025
    ],
    [
      "dechirant",
      0.0025
    ],
    [
      "contraignant",
      0.0025
    ],
    [
      "assujettissant",
      0.0025
    ],
    [
      "ardu",
      0.0025
    ],
    [
      "lent",
      0.0
    ],
    [
      "harassant",
      0.0
    ],
    [
      "extenuant",
      0.0
    ],
    [
      "consternant",
      0.0
    ],
    [
      "cassant",
      0.0
    ],
    [
      "angoissant",
      0.0
    ],
    [
      "tourmentant",
      0.0
    ],
    [
      "touchant",
      0.0
    ],
    [
      "sensible",
      0.0
    ],
    [
      "onereux",
      0.0
    ],
    [
      "malplaisant",
      0.0
    ],
    [
      "embarrasse",
      0.0
    ],
    [
      "difficultueux",
      0.0
    ],
    [
      "bizarre",
      0.0
    ],
    [
      "astreignant",
      0.0
    ],
    [
      "tourmente",
      0.0
    ]
  ],
  "indestructible": [
    [
      "imperissable",
      0.15
    ],
    [
      "immuable",
      0.125
    ],
    [
      "inalterable",
      0.075
    ],
    [
      "solide",
      0.075
    ],
    [
      "eternel",
      0.075
    ],
    [
      "indefectible",
      0.0575
    ],
    [
      "immortel",
      0.0575
    ],
    [
      "durable",
      0.04
    ],
    [
      "inebranlable",
      0.04
    ],
    [
      "resistant",
      0.04
    ],
    [
      "sempiternel",
      0.0225
    ],
    [
      "perpetuel",
      0.0225
    ],
    [
      "invincible",
      0.0225
    ],
    [
      "infrangible",
      0.0225
    ],
    [
      "ineffacable",
      0.0225
    ],
    [
      "inattaquable",
      0.0225
    ],
    [
      "vivace",
      0.015
    ],
    [
      "inusable",
      0.015
    ],
    [
      "inextinguible",
      0.015
    ],
    [
      "indelebile",
      0.015
    ],
    [
      "indissoluble",
      0.015
    ],
    [
      "imprescriptible",
      0.0075
    ],
    [
      "inderacinable",
      0.0075
    ]
  ],
  "metal": [
    [
      "fer",
      0.3325
    ],
    [
      "matiere",
      0.3325
    ],
    [
      "substance",
      0.3325
    ]
  ],
  "bulldozer": [
    [
      "excavateur",
      1.0
    ]
  ],
  "nerveux": [
    [
      "vif",
      0.0925
    ],
    [
      "impatient",
      0.0775
    ],
    [
      "agite",
      0.065
    ],
    [
      "excite",
      0.065
    ],
    [
      "febrile",
      0.0525
    ],
    [
      "enerve",
      0.0525
    ],
    [
      "remuant",
      0.0375
    ],
    [
      "rapide",
      0.0375
    ],
    [
      "inquiet",
      0.0375
    ],
    [
      "fievreux",
      0.0375
    ],
    [
      "vigoureux",
      0.025
    ],
    [
      "turbulent",
      0.025
    ],
    [
      "sensible",
      0.025
    ],
    [
      "resistant",
      0.025
    ],
    [
      "muscle",
      0.025
    ],
    [
      "irritable",
      0.025
    ],
    [
      "filandreux",
      0.025
    ],
    [
      "coriace",
      0.025
    ],
    [
      "brusque",
      0.025
    ],
    [
      "nevrose",
      0.01
    ],
    [
      "nevrotique",
      0.01
    ],
    [
      "psychosomatique",
      0.01
    ],
    [
      "petillant",
      0.01
    ],
    [
      "rustique",
      0.01
    ],
    [
      "tendineux",
      0.01
    ],
    [
      "musculeux",
      0.01
    ],
    [
      "irrite",
      0.01
    ],
    [
      "hysterique",
      0.01
    ],
    [
      "hyperemotif",
      0.01
    ],
    [
      "hypernerveux",
      0.01
    ],
    [
      "fibreux",
      0.01
    ],
    [
      "excitable",
      0.01
    ],
    [
      "convulsif",
      0.01
    ],
    [
      "concis",
      0.01
    ],
    [
      "emotif",
      0.01
    ]
  ],
  "equilibriste": [
    [
      "saltimbanque",
      0.2725
    ],
    [
      "acrobate",
      0.18
    ],
    [
      "bateleur",
      0.18
    ],
    [
      "funambule",
      0.18
    ],
    [
      "jongleur",
      0.09
    ]
  ],
  "confiance": [
    [
      "assurance",
      0.085
    ],
    [
      "hardiesse",
      0.085
    ],
    [
      "abandon",
      0.07
    ],
    [
      "franchise",
      0.07
    ],
    [
      "foi",
      0.0575
    ],
    [
      "toupet",
      0.0425
    ],
    [
      "simplicite",
      0.0425
    ],
    [
      "croyance",
      0.0425
    ],
    [
      "courage",
      0.0425
    ],
    [
      "securite",
      0.0275
    ],
    [
      "intimite",
      0.0275
    ],
    [
      "esperance",
      0.0275
    ],
    [
      "effusion",
      0.0275
    ],
    [
      "culot",
      0.0275
    ],
    [
      "credulite",
      0.0275
    ],
    [
      "creance",
      0.0275
    ],
    [
      "cranerie",
      0.0275
    ],
    [
      "conviction",
      0.0275
    ],
    [
      "confidence",
      0.0275
    ],
    [
      "aplomb",
      0.0275
    ],
    [
      "presomption",
      0.0125
    ],
    [
      "ouverture",
      0.0125
    ],
    [
      "outrecuidance",
      0.0125
    ],
    [
      "oreille",
      0.0125
    ],
    [
      "front",
      0.0125
    ],
    [
      "fraternite",
      0.0125
    ],
    [
      "credit",
      0.0125
    ],
    [
      "braverie",
      0.0125
    ],
    [
      "tranquillite",
      0.0125
    ]
  ],
  "competence": [
    [
      "habilete",
      0.1175
    ],
    [
      "pouvoir",
      0.1175
    ],
    [
      "capacite",
      0.0875
    ],
    [
      "aptitude",
      0.0725
    ],
    [
      "science",
      0.0575
    ],
    [
      "savoir",
      0.0575
    ],
    [
      "qualification",
      0.0575
    ],
    [
      "art",
      0.0575
    ],
    [
      "connaissance",
      0.0425
    ],
    [
      "qualite",
      0.0425
    ],
    [
      "suffisance",
      0.0275
    ],
    [
      "ressort",
      0.0275
    ],
    [
      "juridiction",
      0.0275
    ],
    [
      "domaine",
      0.0275
    ],
    [
      "bagage",
      0.0275
    ],
    [
      "attribution",
      0.0275
    ],
    [
      "autorite",
      0.0125
    ],
    [
      "ballot",
      0.0125
    ],
    [
      "notion",
      0.0125
    ],
    [
      "pertinence",
      0.0125
    ],
    [
      "professionnalisme",
      0.0125
    ]
  ],
  "sol": [
    [
      "terre",
      0.265
    ],
    [
      "pays",
      0.2
    ],
    [
      "terroir",
      0.1325
    ],
    [
      "humus",
      0.065
    ],
    [
      "patrie",
      0.065
    ],
    [
      "plancher",
      0.065
    ],
    [
      "region",
      0.065
    ],
    [
      "sou",
      0.065
    ],
    [
      "terrain",
      0.065
    ]
  ],
  "craque": [
    [
      "mensonge",
      0.1725
    ],
    [
      "conte",
      0.1525
    ],
    [
      "hablerie",
      0.1075
    ],
    [
      "blague",
      0.085
    ],
    [
      "histoire",
      0.085
    ],
    [
      "rodomontade",
      0.065
    ],
    [
      "roman",
      0.065
    ],
    [
      "invention",
      0.0425
    ],
    [
      "fanfaronnade",
      0.0425
    ],
    [
      "fable",
      0.0425
    ],
    [
      "boniment",
      0.0425
    ],
    [
      "bateau",
      0.0425
    ],
    [
      "vantardise",
      0.02
    ],
    [
      "vanterie",
      0.02
    ]
  ],
  "deraper": [
    [
      "glisser",
      0.3325
    ],
    [
      "chasser",
      0.165
    ],
    [
      "derailler",
      0.165
    ],
    [
      "patiner",
      0.165
    ],
    [
      "riper",
      0.165
    ]
  ],
  "echapper": [
    [
      "s'echapper",
      0.105
    ],
    [
      "fuir",
      0.0975
    ],
    [
      "s'enfuir",
      0.0675
    ],
    [
      "sortir",
      0.0625
    ],
    [
      "partir",
      0.045
    ],
    [
      "s'evader",
      0.045
    ],
    [
      "eviter",
      0.04
    ],
    [
      "disparaitre",
      0.04
    ],
    [
      "eluder",
      0.0275
    ],
    [
      "esquiver",
      0.0225
    ],
    [
      "tomber",
      0.015
    ],
    [
      "s'ecouler",
      0.015
    ],
    [
      "semer",
      0.01
    ],
    [
      "rechapper",
      0.01
    ],
    [
      "mourir",
      0.01
    ],
    [
      "lacher",
      0.01
    ],
    [
      "guerir",
      0.01
    ],
    [
      "s'exempter",
      0.005
    ],
    [
      "perdre",
      0.005
    ],
    [
      "glisser",
      0.005
    ],
    [
      "deborder",
      0.005
    ]
  ],
  "pression": [
    [
      "influence",
      0.1125
    ],
    [
      "force",
      0.0925
    ],
    [
      "poussee",
      0.055
    ],
    [
      "impulsion",
      0.055
    ],
    [
      "impression",
      0.055
    ],
    [
      "contrainte",
      0.055
    ],
    [
      "caresse",
      0.055
    ],
    [
      "action",
      0.055
    ],
    [
      "etreinte",
      0.0375
    ],
    [
      "serrement",
      0.0375
    ],
    [
      "poids",
      0.0375
    ],
    [
      "effort",
      0.0375
    ],
    [
      "compression",
      0.0375
    ],
    [
      "pressage",
      0.0175
    ],
    [
      "menace",
      0.0175
    ],
    [
      "intimidation",
      0.0175
    ],
    [
      "frottement",
      0.0175
    ],
    [
      "exigence",
      0.0175
    ],
    [
      "empire",
      0.0175
    ],
    [
      "constriction",
      0.0175
    ],
    [
      "coercition",
      0.0175
    ],
    [
      "charge",
      0.0175
    ],
    [
      "chantage",
      0.0175
    ],
    [
      "bouton",
      0.0175
    ],
    [
      "attouchement",
      0.0175
    ],
    [
      "serre",
      0.0175
    ]
  ],
  "clic": [
    [
      "clac",
      0.4
    ],
    [
      "claquement",
      0.2
    ],
    [
      "cloc",
      0.2
    ]
  ],
  "bip": [],
  "bombe": [
    [
      "bringue",
      0.1175
    ],
    [
      "festin",
      0.1175
    ],
    [
      "bombance",
      0.0775
    ],
    [
      "noce",
      0.07
    ],
    [
      "fete",
      0.0475
    ],
    [
      "debauche",
      0.0475
    ],
    [
      "beuverie",
      0.0475
    ],
    [
      "bamboche",
      0.0475
    ],
    [
      "nouba",
      0.0375
    ],
    [
      "ripaille",
      0.0375
    ],
    [
      "foire",
      0.03
    ],
    [
      "projectile",
      0.03
    ],
    [
      "banquet",
      0.0225
    ],
    [
      "ribote",
      0.015
    ],
    [
      "charge",
      0.015
    ],
    [
      "atomiseur",
      0.015
    ],
    [
      "agapes",
      0.015
    ],
    [
      "grenade",
      0.005
    ],
    [
      "java",
      0.005
    ],
    [
      "machine",
      0.005
    ],
    [
      "mortier",
      0.005
    ],
    [
      "nouvelle",
      0.005
    ],
    [
      "obus",
      0.005
    ],
    [
      "petard",
      0.005
    ],
    [
      "sorbet",
      0.005
    ],
    [
      "spray",
      0.005
    ],
    [
      "torpille",
      0.005
    ],
    [
      "glace",
      0.005
    ],
    [
      "fusee",
      0.005
    ],
    [
      "explosif",
      0.005
    ],
    [
      "balthazar",
      0.005
    ],
    [
      "bombarde",
      0.005
    ],
    [
      "bonbonne",
      0.005
    ],
    [
      "boule",
      0.005
    ],
    [
      "casque",
      0.005
    ],
    [
      "casquette",
      0.005
    ],
    [
      "crapaud",
      0.005
    ],
    [
      "engin",
      0.005
    ],
    [
      "aerosol",
      0.005
    ]
  ],
  "role": [
    [
      "fonction",
      0.125
    ],
    [
      "emploi",
      0.0625
    ],
    [
      "etat",
      0.0625
    ],
    [
      "charge",
      0.0475
    ],
    [
      "liste",
      0.0475
    ],
    [
      "repertoire",
      0.0475
    ],
    [
      "travail",
      0.0475
    ],
    [
      "tache",
      0.0375
    ],
    [
      "tableau",
      0.0375
    ],
    [
      "mission",
      0.0375
    ],
    [
      "devoir",
      0.0375
    ],
    [
      "usage",
      0.0225
    ],
    [
      "registre",
      0.0225
    ],
    [
      "position",
      0.0225
    ],
    [
      "metier",
      0.0225
    ],
    [
      "matricule",
      0.0225
    ],
    [
      "figure",
      0.0225
    ],
    [
      "denombrement",
      0.0225
    ],
    [
      "catalogue",
      0.0225
    ],
    [
      "affaire",
      0.0225
    ],
    [
      "personnage",
      0.01
    ],
    [
      "rouleau",
      0.01
    ],
    [
      "statut",
      0.01
    ],
    [
      "statuts",
      0.01
    ],
    [
      "utilite",
      0.01
    ],
    [
      "vocation",
      0.01
    ],
    [
      "persona",
      0.01
    ],
    [
      "mandat",
      0.01
    ],
    [
      "intervention",
      0.01
    ],
    [
      "influence",
      0.01
    ],
    [
      "figuration",
      0.01
    ],
    [
      "cause",
      0.01
    ],
    [
      "bordereau",
      0.01
    ],
    [
      "attribution",
      0.01
    ],
    [
      "enumeration",
      0.01
    ]
  ],
  "ecorcer": [
    [
      "peler",
      0.22
    ],
    [
      "baguer",
      0.11
    ],
    [
      "decortiquer",
      0.11
    ],
    [
      "demascler",
      0.11
    ],
    [
      "depouiller",
      0.11
    ],
    [
      "gemmer",
      0.11
    ],
    [
      "inciser",
      0.11
    ],
    [
      "tondre",
      0.11
    ]
  ],
  "ecorce": [
    [
      "enveloppe",
      0.1525
    ],
    [
      "exterieur",
      0.1525
    ],
    [
      "vernis",
      0.075
    ],
    [
      "superficie",
      0.075
    ],
    [
      "robe",
      0.075
    ],
    [
      "peau",
      0.075
    ],
    [
      "dehors",
      0.075
    ],
    [
      "apparence",
      0.075
    ],
    [
      "aspect",
      0.0375
    ],
    [
      "croute",
      0.0375
    ],
    [
      "facade",
      0.0375
    ],
    [
      "pelure",
      0.0375
    ],
    [
      "zeste",
      0.0375
    ],
    [
      "ecale",
      0.0375
    ]
  ],
  "tic": [
    [
      "travers",
      0.23
    ],
    [
      "manie",
      0.2025
    ],
    [
      "marotte",
      0.0625
    ],
    [
      "toquade",
      0.0625
    ],
    [
      "rage",
      0.0375
    ],
    [
      "maniere",
      0.0375
    ],
    [
      "habitude",
      0.0375
    ],
    [
      "fureur",
      0.0375
    ],
    [
      "frenesie",
      0.0375
    ],
    [
      "caprice",
      0.0375
    ],
    [
      "demangeaison",
      0.025
    ],
    [
      "gout",
      0.025
    ],
    [
      "procede",
      0.01
    ],
    [
      "prurit",
      0.01
    ],
    [
      "rictus",
      0.01
    ],
    [
      "turlutaine",
      0.01
    ],
    [
      "monomanie",
      0.01
    ],
    [
      "maladie",
      0.01
    ],
    [
      "grimace",
      0.01
    ],
    [
      "fievre",
      0.01
    ],
    [
      "fantaisie",
      0.01
    ],
    [
      "dada",
      0.01
    ],
    [
      "bizarrerie",
      0.01
    ],
    [
      "epidemie",
      0.01
    ]
  ],
  "explosion": [
    [
      "bruit",
      0.0825
    ],
    [
      "feu",
      0.065
    ],
    [
      "orage",
      0.065
    ],
    [
      "tempete",
      0.065
    ],
    [
      "eruption",
      0.05
    ],
    [
      "detonation",
      0.05
    ],
    [
      "debordement",
      0.05
    ],
    [
      "eclatement",
      0.0325
    ],
    [
      "eclat",
      0.0325
    ],
    [
      "souffle",
      0.0325
    ],
    [
      "rupture",
      0.0325
    ],
    [
      "ouragan",
      0.0325
    ],
    [
      "manifestation",
      0.0325
    ],
    [
      "expansion",
      0.0325
    ],
    [
      "deflagration",
      0.0325
    ],
    [
      "apparition",
      0.0325
    ],
    [
      "bouffee",
      0.0325
    ],
    [
      "choc",
      0.0325
    ],
    [
      "commotion",
      0.0325
    ],
    [
      "dechainement",
      0.0325
    ],
    [
      "petarade",
      0.015
    ],
    [
      "fulmination",
      0.015
    ],
    [
      "desintegration",
      0.015
    ],
    [
      "crepitation",
      0.015
    ],
    [
      "conflagration",
      0.015
    ],
    [
      "boom",
      0.015
    ],
    [
      "allumage",
      0.015
    ],
    [
      "accident",
      0.015
    ]
  ],
  "iceberg": [
    [
      "banquise",
      0.5
    ],
    [
      "glace",
      0.5
    ]
  ],
  "telles": [
    [
      "semblable",
      0.2725
    ],
    [
      "pareil",
      0.18
    ],
    [
      "assimile",
      0.09
    ],
    [
      "celui",
      0.09
    ],
    [
      "certain",
      0.09
    ],
    [
      "comme",
      0.09
    ],
    [
      "meme",
      0.09
    ],
    [
      "quelqu'un",
      0.09
    ]
  ],
  "exigence": [
    [
      "desir",
      0.08
    ],
    [
      "contrainte",
      0.07
    ],
    [
      "volonte",
      0.07
    ],
    [
      "soif",
      0.045
    ],
    [
      "pretention",
      0.045
    ],
    [
      "obligation",
      0.045
    ],
    [
      "loi",
      0.045
    ],
    [
      "force",
      0.045
    ],
    [
      "demande",
      0.045
    ],
    [
      "regle",
      0.035
    ],
    [
      "revendication",
      0.035
    ],
    [
      "ordre",
      0.035
    ],
    [
      "necessite",
      0.035
    ],
    [
      "fermete",
      0.035
    ],
    [
      "resolution",
      0.0225
    ],
    [
      "reclamation",
      0.0225
    ],
    [
      "imperatif",
      0.0225
    ],
    [
      "discipline",
      0.0225
    ],
    [
      "besoin",
      0.0225
    ],
    [
      "appetit",
      0.0225
    ],
    [
      "tourment",
      0.01
    ],
    [
      "severite",
      0.01
    ],
    [
      "rigueur",
      0.01
    ],
    [
      "pression",
      0.01
    ],
    [
      "occurrence",
      0.01
    ],
    [
      "implication",
      0.01
    ],
    [
      "gre",
      0.01
    ],
    [
      "devoir",
      0.01
    ],
    [
      "despotisme",
      0.01
    ],
    [
      "cri",
      0.01
    ],
    [
      "condition",
      0.01
    ],
    [
      "autoritarisme",
      0.01
    ],
    [
      "aspiration",
      0.01
    ],
    [
      "ultimatum",
      0.01
    ]
  ],
  "domino": [
    [
      "masque",
      0.22
    ],
    [
      "camail",
      0.11
    ],
    [
      "capuchon",
      0.11
    ],
    [
      "carnaval",
      0.11
    ],
    [
      "costume",
      0.11
    ],
    [
      "dent",
      0.11
    ],
    [
      "robe",
      0.11
    ],
    [
      "travesti",
      0.11
    ]
  ],
  "ecrouler": [],
  "effondrer": [
    [
      "briser",
      0.11
    ],
    [
      "fouir",
      0.11
    ],
    [
      "fouiller",
      0.11
    ],
    [
      "detruire",
      0.11
    ],
    [
      "defoncer",
      0.11
    ],
    [
      "creuser",
      0.11
    ],
    [
      "casser",
      0.11
    ],
    [
      "catastropher",
      0.055
    ],
    [
      "remuer",
      0.055
    ],
    [
      "rompre",
      0.055
    ],
    [
      "tomber",
      0.055
    ]
  ],
  "ignorant": [
    [
      "bete",
      0.08
    ],
    [
      "sot",
      0.0575
    ],
    [
      "imbecile",
      0.05
    ],
    [
      "incapable",
      0.0425
    ],
    [
      "inexperimente",
      0.0425
    ],
    [
      "stupide",
      0.0425
    ],
    [
      "ane",
      0.035
    ],
    [
      "incompetent",
      0.035
    ],
    [
      "ignare",
      0.035
    ],
    [
      "profane",
      0.0275
    ],
    [
      "nul",
      0.0275
    ],
    [
      "novice",
      0.0275
    ],
    [
      "inhabile",
      0.0275
    ],
    [
      "inculte",
      0.0275
    ],
    [
      "idiot",
      0.0275
    ],
    [
      "barbare",
      0.0275
    ],
    [
      "balourd",
      0.02
    ],
    [
      "beotien",
      0.02
    ],
    [
      "cretin",
      0.02
    ],
    [
      "ganache",
      0.0125
    ],
    [
      "impuissant",
      0.0125
    ],
    [
      "ingenu",
      0.0125
    ],
    [
      "insuffisant",
      0.0125
    ],
    [
      "malhabile",
      0.0125
    ],
    [
      "primitif",
      0.0125
    ],
    [
      "croute",
      0.0125
    ],
    [
      "candide",
      0.0125
    ],
    [
      "cancre",
      0.0125
    ],
    [
      "abruti",
      0.0125
    ],
    [
      "analphabete",
      0.0125
    ],
    [
      "arriere",
      0.0125
    ],
    [
      "baudet",
      0.0125
    ],
    [
      "bate",
      0.0125
    ],
    [
      "bejaune",
      0.0125
    ],
    [
      "nullard",
      0.005
    ],
    [
      "indocte",
      0.005
    ],
    [
      "inconscient",
      0.005
    ],
    [
      "illettre",
      0.005
    ],
    [
      "ignorantissime",
      0.005
    ],
    [
      "ignorantin",
      0.005
    ],
    [
      "crouton",
      0.005
    ],
    [
      "bourrique",
      0.005
    ],
    [
      "aliboron",
      0.005
    ],
    [
      "etranger",
      0.005
    ]
  ],
  "pesant": [
    [
      "lourd",
      0.1775
    ],
    [
      "penible",
      0.07
    ],
    [
      "epais",
      0.0475
    ],
    [
      "gros",
      0.0375
    ],
    [
      "ennuyeux",
      0.0375
    ],
    [
      "accablant",
      0.0375
    ],
    [
      "bete",
      0.03
    ],
    [
      "lourdaud",
      0.03
    ],
    [
      "tendu",
      0.025
    ],
    [
      "stupide",
      0.025
    ],
    [
      "obtus",
      0.025
    ],
    [
      "massif",
      0.025
    ],
    [
      "important",
      0.025
    ],
    [
      "grossier",
      0.025
    ],
    [
      "grave",
      0.025
    ],
    [
      "balourd",
      0.02
    ],
    [
      "desagreable",
      0.02
    ],
    [
      "ecrasant",
      0.02
    ],
    [
      "solide",
      0.015
    ],
    [
      "puissant",
      0.015
    ],
    [
      "niais",
      0.015
    ],
    [
      "lent",
      0.015
    ],
    [
      "importun",
      0.015
    ],
    [
      "embarrasse",
      0.015
    ],
    [
      "dense",
      0.015
    ],
    [
      "etouffant",
      0.01
    ],
    [
      "pateux",
      0.01
    ],
    [
      "oppressant",
      0.01
    ],
    [
      "mastoc",
      0.01
    ],
    [
      "laborieux",
      0.01
    ],
    [
      "indigeste",
      0.01
    ],
    [
      "douloureux",
      0.01
    ],
    [
      "assujettissant",
      0.01
    ],
    [
      "appesanti",
      0.01
    ],
    [
      "alourdissant",
      0.01
    ],
    [
      "alourdi",
      0.01
    ],
    [
      "raseur",
      0.0025
    ],
    [
      "sempiternel",
      0.0025
    ],
    [
      "surcharge",
      0.0025
    ],
    [
      "tyrannique",
      0.0025
    ],
    [
      "pondereux",
      0.0025
    ],
    [
      "onereux",
      0.0025
    ],
    [
      "materiel",
      0.0025
    ],
    [
      "inintelligent",
      0.0025
    ],
    [
      "ferme",
      0.0025
    ],
    [
      "encombrant",
      0.0025
    ],
    [
      "vigoureux",
      0.0025
    ]
  ],
  "attente": [
    [
      "esperance",
      0.17
    ],
    [
      "prevision",
      0.1125
    ],
    [
      "expectative",
      0.075
    ],
    [
      "desir",
      0.055
    ],
    [
      "espoir",
      0.055
    ],
    [
      "perspective",
      0.055
    ],
    [
      "soif",
      0.055
    ],
    [
      "guet",
      0.0375
    ],
    [
      "futur",
      0.0375
    ],
    [
      "expectance",
      0.0375
    ],
    [
      "souhait",
      0.0175
    ],
    [
      "queue",
      0.0175
    ],
    [
      "presomption",
      0.0175
    ],
    [
      "pause",
      0.0175
    ],
    [
      "instance",
      0.0175
    ],
    [
      "impatience",
      0.0175
    ],
    [
      "faction",
      0.0175
    ],
    [
      "expectation",
      0.0175
    ],
    [
      "divination",
      0.0175
    ],
    [
      "croyance",
      0.0175
    ],
    [
      "crainte",
      0.0175
    ],
    [
      "calcul",
      0.0175
    ],
    [
      "anxiete",
      0.0175
    ],
    [
      "angoisse",
      0.0175
    ],
    [
      "affut",
      0.0175
    ],
    [
      "station",
      0.0175
    ]
  ],
  "detente": [
    [
      "repos",
      0.0825
    ],
    [
      "delassement",
      0.065
    ],
    [
      "relaxation",
      0.055
    ],
    [
      "relachement",
      0.055
    ],
    [
      "soulagement",
      0.045
    ],
    [
      "remission",
      0.045
    ],
    [
      "pause",
      0.045
    ],
    [
      "amelioration",
      0.045
    ],
    [
      "relache",
      0.035
    ],
    [
      "repit",
      0.035
    ],
    [
      "treve",
      0.0275
    ],
    [
      "recreation",
      0.0275
    ],
    [
      "loisir",
      0.0275
    ],
    [
      "expansion",
      0.0275
    ],
    [
      "distraction",
      0.0275
    ],
    [
      "calme",
      0.0275
    ],
    [
      "apaisement",
      0.0275
    ],
    [
      "aise",
      0.0275
    ],
    [
      "abandon",
      0.0275
    ],
    [
      "eclaircie",
      0.0175
    ],
    [
      "vacances",
      0.0175
    ],
    [
      "euphorie",
      0.0175
    ],
    [
      "embellie",
      0.0175
    ],
    [
      "decontraction",
      0.0175
    ],
    [
      "allegement",
      0.0175
    ],
    [
      "alanguissement",
      0.0175
    ],
    [
      "elasticite",
      0.0075
    ],
    [
      "halte",
      0.0075
    ],
    [
      "extension",
      0.0075
    ],
    [
      "derivatif",
      0.0075
    ],
    [
      "decompression",
      0.0075
    ],
    [
      "declic",
      0.0075
    ],
    [
      "desserre",
      0.0075
    ],
    [
      "evasion",
      0.0075
    ]
  ],
  "enorme": [
    [
      "extraordinaire",
      0.07
    ],
    [
      "formidable",
      0.0675
    ],
    [
      "gigantesque",
      0.0675
    ],
    [
      "grand",
      0.0575
    ],
    [
      "colossal",
      0.055
    ],
    [
      "prodigieux",
      0.0475
    ],
    [
      "fantastique",
      0.045
    ],
    [
      "immense",
      0.0425
    ],
    [
      "demesure",
      0.0325
    ],
    [
      "etonnant",
      0.0325
    ],
    [
      "fabuleux",
      0.03
    ],
    [
      "gros",
      0.03
    ],
    [
      "monstrueux",
      0.03
    ],
    [
      "monumental",
      0.0275
    ],
    [
      "titanesque",
      0.0275
    ],
    [
      "sensationnel",
      0.025
    ],
    [
      "imposant",
      0.0225
    ],
    [
      "faramineux",
      0.0225
    ],
    [
      "phenomenal",
      0.0225
    ],
    [
      "excessif",
      0.0175
    ],
    [
      "beau",
      0.0175
    ],
    [
      "considerable",
      0.0175
    ],
    [
      "inoui",
      0.015
    ],
    [
      "stupefiant",
      0.01
    ],
    [
      "architectural",
      0.0075
    ],
    [
      "fort",
      0.0075
    ],
    [
      "terrible",
      0.0075
    ],
    [
      "fou",
      0.0075
    ],
    [
      "monstre",
      0.0075
    ],
    [
      "vaste",
      0.005
    ],
    [
      "pyramidal",
      0.005
    ],
    [
      "incommensurable",
      0.005
    ],
    [
      "incalculable",
      0.005
    ],
    [
      "infini",
      0.005
    ],
    [
      "profond",
      0.0025
    ],
    [
      "effarant",
      0.0025
    ],
    [
      "boeuf",
      0.0025
    ],
    [
      "astronomique",
      0.0025
    ],
    [
      "abondant",
      0.0025
    ],
    [
      "epouvantable",
      0.0025
    ],
    [
      "ecrasant",
      0.0025
    ],
    [
      "renversant",
      0.0025
    ],
    [
      "large",
      0.0025
    ],
    [
      "geant",
      0.0025
    ],
    [
      "cyclopeen",
      0.0025
    ],
    [
      "ahurissant",
      0.0025
    ],
    [
      "elephantesque",
      0.0
    ],
    [
      "majestueux",
      0.0
    ],
    [
      "interminable",
      0.0
    ],
    [
      "hyperbolique",
      0.0
    ],
    [
      "gargantuesque",
      0.0
    ],
    [
      "exorbitant",
      0.0
    ],
    [
      "anormal",
      0.0
    ],
    [
      "fantasmagorique",
      0.0
    ],
    [
      "fichu",
      0.0
    ],
    [
      "hypertrophie",
      0.0
    ],
    [
      "mammouth",
      0.0
    ],
    [
      "tonitruant",
      0.0
    ]
  ],
  "detruire": [
    [
      "ruiner",
      0.0575
    ],
    [
      "aneantir",
      0.0525
    ],
    [
      "supprimer",
      0.0375
    ],
    [
      "abattre",
      0.0375
    ],
    [
      "briser",
      0.0325
    ],
    [
      "demolir",
      0.0275
    ],
    [
      "ronger",
      0.0225
    ],
    [
      "tuer",
      0.0225
    ],
    [
      "casser",
      0.0225
    ],
    [
      "miner",
      0.02
    ],
    [
      "affaiblir",
      0.02
    ],
    [
      "consumer",
      0.0175
    ],
    [
      "alterer",
      0.0175
    ],
    [
      "degrader",
      0.0175
    ],
    [
      "saper",
      0.0175
    ],
    [
      "diminuer",
      0.015
    ],
    [
      "epuiser",
      0.0125
    ],
    [
      "renverser",
      0.0125
    ],
    [
      "abimer",
      0.0125
    ],
    [
      "abolir",
      0.0125
    ],
    [
      "annuler",
      0.0125
    ],
    [
      "dissoudre",
      0.0125
    ],
    [
      "rompre",
      0.0125
    ],
    [
      "ecraser",
      0.01
    ],
    [
      "ebranler",
      0.01
    ],
    [
      "user",
      0.01
    ],
    [
      "enlever",
      0.01
    ],
    [
      "demanteler",
      0.01
    ],
    [
      "defaire",
      0.01
    ],
    [
      "bouleverser",
      0.01
    ],
    [
      "etouffer",
      0.0075
    ],
    [
      "resilier",
      0.0075
    ],
    [
      "devorer",
      0.0075
    ],
    [
      "oter",
      0.0075
    ],
    [
      "perdre",
      0.0075
    ],
    [
      "gater",
      0.0075
    ],
    [
      "entamer",
      0.0075
    ],
    [
      "effacer",
      0.0075
    ],
    [
      "attaquer",
      0.0075
    ],
    [
      "ravager",
      0.0075
    ],
    [
      "desagreger",
      0.0075
    ],
    [
      "dissiper",
      0.0075
    ],
    [
      "bousiller",
      0.0075
    ],
    [
      "saccager",
      0.005
    ],
    [
      "pulveriser",
      0.005
    ],
    [
      "engloutir",
      0.005
    ],
    [
      "enfoncer",
      0.005
    ],
    [
      "corroder",
      0.005
    ],
    [
      "broyer",
      0.005
    ],
    [
      "annihiler",
      0.005
    ],
    [
      "liquider",
      0.005
    ],
    [
      "infirmer",
      0.005
    ],
    [
      "foudroyer",
      0.005
    ],
    [
      "decomposer",
      0.005
    ],
    [
      "culbuter",
      0.005
    ],
    [
      "eteindre",
      0.005
    ],
    [
      "eliminer",
      0.005
    ],
    [
      "mordre",
      0.005
    ],
    [
      "faucher",
      0.005
    ],
    [
      "exterminer",
      0.005
    ],
    [
      "devaster",
      0.005
    ],
    [
      "corrompre",
      0.005
    ],
    [
      "bruler",
      0.005
    ],
    [
      "absorber",
      0.005
    ],
    [
      "troubler",
      0.0025
    ],
    [
      "rayer",
      0.0025
    ],
    [
      "pourrir",
      0.0025
    ],
    [
      "massacrer",
      0.0025
    ],
    [
      "extirper",
      0.0025
    ],
    [
      "discrediter",
      0.0025
    ],
    [
      "chasser",
      0.0025
    ],
    [
      "abroger",
      0.0025
    ],
    [
      "retrancher",
      0.0025
    ],
    [
      "desintegrer",
      0.0025
    ],
    [
      "biffer",
      0.0025
    ],
    [
      "atteindre",
      0.0025
    ],
    [
      "repousser",
      0.0025
    ],
    [
      "nuire",
      0.0025
    ],
    [
      "enterrer",
      0.0025
    ],
    [
      "emporter",
      0.0025
    ],
    [
      "desorganiser",
      0.0025
    ],
    [
      "deprecier",
      0.0025
    ],
    [
      "defoncer",
      0.0025
    ],
    [
      "fusiller",
      0.0
    ],
    [
      "hacher",
      0.0
    ],
    [
      "invalider",
      0.0
    ],
    [
      "jeter",
      0.0
    ],
    [
      "radier",
      0.0
    ],
    [
      "refuter",
      0.0
    ],
    [
      "emousser",
      0.0
    ],
    [
      "etrangler",
      0.0
    ],
    [
      "fracasser",
      0.0
    ],
    [
      "desoler",
      0.0
    ],
    [
      "deraciner",
      0.0
    ],
    [
      "accidenter",
      0.0
    ],
    [
      "atrophier",
      0.0
    ],
    [
      "bombarder",
      0.0
    ],
    [
      "dessecher",
      0.0
    ],
    [
      "disloquer",
      0.0
    ],
    [
      "decapiter",
      0.0
    ],
    [
      "decimer",
      0.0
    ],
    [
      "grignoter",
      0.0
    ],
    [
      "moissonner",
      0.0
    ],
    [
      "raser",
      0.0
    ],
    [
      "triturer",
      0.0
    ],
    [
      "etioler",
      0.0
    ],
    [
      "ensevelir",
      0.0
    ],
    [
      "embraser",
      0.0
    ],
    [
      "atomiser",
      0.0
    ],
    [
      "consommer",
      0.0
    ],
    [
      "crouler",
      0.0
    ],
    [
      "dilapider",
      0.0
    ],
    [
      "depecer",
      0.0
    ],
    [
      "effondrer",
      0.0
    ],
    [
      "juguler",
      0.0
    ],
    [
      "incendier",
      0.0
    ],
    [
      "desillusionner",
      0.0
    ],
    [
      "decrediter",
      0.0
    ],
    [
      "decouronner",
      0.0
    ],
    [
      "decevoir",
      0.0
    ],
    [
      "canonner",
      0.0
    ],
    [
      "vandaliser",
      0.0
    ]
  ],
  "envahir": [
    [
      "occuper",
      0.065
    ],
    [
      "prendre",
      0.065
    ],
    [
      "inonder",
      0.06
    ],
    [
      "remplir",
      0.06
    ],
    [
      "s'emparer",
      0.06
    ],
    [
      "gagner",
      0.0525
    ],
    [
      "penetrer",
      0.045
    ],
    [
      "submerger",
      0.0275
    ],
    [
      "mordre",
      0.0275
    ],
    [
      "couvrir",
      0.0275
    ],
    [
      "truffer",
      0.02
    ],
    [
      "s'etendre",
      0.02
    ],
    [
      "impregner",
      0.02
    ],
    [
      "garnir",
      0.02
    ],
    [
      "entrer",
      0.02
    ],
    [
      "emplir",
      0.02
    ],
    [
      "empieter",
      0.02
    ],
    [
      "deborder",
      0.02
    ],
    [
      "conquerir",
      0.02
    ],
    [
      "combler",
      0.02
    ],
    [
      "absorber",
      0.02
    ],
    [
      "s'immiscer",
      0.0125
    ],
    [
      "s'insinuer",
      0.0125
    ],
    [
      "usurper",
      0.0125
    ],
    [
      "retenir",
      0.0125
    ],
    [
      "pulluler",
      0.0125
    ],
    [
      "enlever",
      0.0125
    ],
    [
      "communiquer",
      0.0125
    ],
    [
      "coloniser",
      0.0125
    ],
    [
      "accaparer",
      0.0125
    ],
    [
      "proliferer",
      0.005
    ],
    [
      "infester",
      0.005
    ],
    [
      "descendre",
      0.005
    ],
    [
      "coller",
      0.005
    ],
    [
      "coincer",
      0.005
    ],
    [
      "agiter",
      0.005
    ],
    [
      "subjuguer",
      0.005
    ]
  ],
  "encaisser": [
    [
      "recevoir",
      0.1475
    ],
    [
      "gagner",
      0.1175
    ],
    [
      "prendre",
      0.1075
    ],
    [
      "toucher",
      0.0875
    ],
    [
      "ramasser",
      0.0775
    ],
    [
      "empocher",
      0.0675
    ],
    [
      "percevoir",
      0.0575
    ],
    [
      "attraper",
      0.0475
    ],
    [
      "recolter",
      0.0475
    ],
    [
      "subir",
      0.0475
    ],
    [
      "ecoper",
      0.0275
    ],
    [
      "supporter",
      0.0175
    ],
    [
      "sentir",
      0.0175
    ],
    [
      "resserrer",
      0.0175
    ],
    [
      "essuyer",
      0.0175
    ],
    [
      "avaler",
      0.0175
    ],
    [
      "accuser",
      0.0075
    ],
    [
      "effacer",
      0.0075
    ],
    [
      "emballer",
      0.0075
    ],
    [
      "entourer",
      0.0075
    ],
    [
      "palper",
      0.0075
    ],
    [
      "recouvrer",
      0.0075
    ]
  ],
  "patienter": [
    [
      "attendre",
      0.5
    ],
    [
      "poireauter",
      0.25
    ]
  ],
  "patient": [
    [
      "dur",
      0.0725
    ],
    [
      "constant",
      0.06
    ],
    [
      "perseverant",
      0.06
    ],
    [
      "imperturbable",
      0.0475
    ],
    [
      "impassible",
      0.0475
    ],
    [
      "courageux",
      0.0475
    ],
    [
      "acharne",
      0.0475
    ],
    [
      "tolerant",
      0.035
    ],
    [
      "tenace",
      0.035
    ],
    [
      "stoique",
      0.035
    ],
    [
      "resigne",
      0.035
    ],
    [
      "placide",
      0.035
    ],
    [
      "obstine",
      0.035
    ],
    [
      "malade",
      0.035
    ],
    [
      "infatigable",
      0.035
    ],
    [
      "endurant",
      0.035
    ],
    [
      "calme",
      0.035
    ],
    [
      "serein",
      0.0225
    ],
    [
      "flegmatique",
      0.0225
    ],
    [
      "doux",
      0.0225
    ],
    [
      "attentif",
      0.0225
    ],
    [
      "assidu",
      0.0225
    ],
    [
      "souffrant",
      0.01
    ],
    [
      "politique",
      0.01
    ],
    [
      "meticuleux",
      0.01
    ],
    [
      "minutieux",
      0.01
    ],
    [
      "longanime",
      0.01
    ],
    [
      "inlassable",
      0.01
    ],
    [
      "indulgent",
      0.01
    ],
    [
      "debonnaire",
      0.01
    ],
    [
      "client",
      0.01
    ],
    [
      "sujet",
      0.01
    ]
  ],
  "couloir": [
    [
      "passage",
      0.215
    ],
    [
      "voie",
      0.1425
    ],
    [
      "chemin",
      0.1075
    ],
    [
      "corridor",
      0.07
    ],
    [
      "conduit",
      0.07
    ],
    [
      "canal",
      0.07
    ],
    [
      "rail",
      0.035
    ],
    [
      "passe",
      0.035
    ],
    [
      "gorge",
      0.035
    ],
    [
      "galerie",
      0.035
    ],
    [
      "degagement",
      0.035
    ],
    [
      "defile",
      0.035
    ],
    [
      "coursive",
      0.035
    ],
    [
      "allee",
      0.035
    ],
    [
      "route",
      0.035
    ]
  ],
  "verrou": [
    [
      "serrure",
      0.31
    ],
    [
      "fermeture",
      0.1525
    ],
    [
      "cadenas",
      0.075
    ],
    [
      "clef",
      0.075
    ],
    [
      "coincement",
      0.075
    ],
    [
      "fermoir",
      0.075
    ],
    [
      "protection",
      0.075
    ],
    [
      "pene",
      0.075
    ],
    [
      "targette",
      0.075
    ]
  ],
  "fanfare": [
    [
      "orchestre",
      0.1675
    ],
    [
      "musique",
      0.1325
    ],
    [
      "bruit",
      0.1
    ],
    [
      "clique",
      0.1
    ],
    [
      "eclat",
      0.065
    ],
    [
      "harmonie",
      0.065
    ],
    [
      "sonnerie",
      0.0325
    ],
    [
      "pompe",
      0.0325
    ],
    [
      "orpheon",
      0.0325
    ],
    [
      "nouba",
      0.0325
    ],
    [
      "musicien",
      0.0325
    ],
    [
      "lyre",
      0.0325
    ],
    [
      "fracas",
      0.0325
    ],
    [
      "demonstration",
      0.0325
    ],
    [
      "cuivres",
      0.0325
    ],
    [
      "clairon",
      0.0325
    ],
    [
      "eloge",
      0.0325
    ]
  ],
  "barriere": [
    [
      "cloture",
      0.0925
    ],
    [
      "obstacle",
      0.0925
    ],
    [
      "barricade",
      0.0725
    ],
    [
      "fermeture",
      0.0725
    ],
    [
      "barrage",
      0.0625
    ],
    [
      "separation",
      0.0625
    ],
    [
      "enceinte",
      0.0525
    ],
    [
      "mur",
      0.0525
    ],
    [
      "digue",
      0.04
    ],
    [
      "borne",
      0.03
    ],
    [
      "fosse",
      0.03
    ],
    [
      "palissade",
      0.03
    ],
    [
      "treillage",
      0.02
    ],
    [
      "limite",
      0.02
    ],
    [
      "haie",
      0.02
    ],
    [
      "grille",
      0.02
    ],
    [
      "empechement",
      0.02
    ],
    [
      "arret",
      0.02
    ],
    [
      "stop",
      0.01
    ],
    [
      "recif",
      0.01
    ],
    [
      "retenue",
      0.01
    ],
    [
      "porte",
      0.01
    ],
    [
      "lice",
      0.01
    ],
    [
      "difficulte",
      0.01
    ],
    [
      "contradiction",
      0.01
    ],
    [
      "cledal",
      0.01
    ],
    [
      "cloison",
      0.01
    ],
    [
      "abime",
      0.01
    ],
    [
      "echalier",
      0.01
    ]
  ],
  "cru": [
    [
      "penser",
      0.115
    ],
    [
      "imaginer",
      0.0725
    ],
    [
      "compter",
      0.0525
    ],
    [
      "estimer",
      0.0525
    ],
    [
      "presumer",
      0.0475
    ],
    [
      "considerer",
      0.0475
    ],
    [
      "juger",
      0.04
    ],
    [
      "supposer",
      0.04
    ],
    [
      "s'attendre",
      0.0325
    ],
    [
      "esperer",
      0.025
    ],
    [
      "accepter",
      0.025
    ],
    [
      "admettre",
      0.02
    ],
    [
      "reputer",
      0.02
    ],
    [
      "soupconner",
      0.02
    ],
    [
      "trouver",
      0.02
    ],
    [
      "ecouter",
      0.0125
    ],
    [
      "s'imaginer",
      0.0125
    ],
    [
      "reconnaitre",
      0.0125
    ],
    [
      "avaler",
      0.0125
    ],
    [
      "attendre",
      0.0125
    ],
    [
      "apprecier",
      0.0125
    ],
    [
      "prejuger",
      0.005
    ],
    [
      "sembler",
      0.005
    ],
    [
      "tromper",
      0.005
    ],
    [
      "marcher",
      0.005
    ],
    [
      "jurer",
      0.005
    ],
    [
      "abuser",
      0.005
    ],
    [
      "adherer",
      0.005
    ],
    [
      "cuider",
      0.005
    ],
    [
      "donner",
      0.005
    ],
    [
      "faillir",
      0.005
    ],
    [
      "gober",
      0.005
    ]
  ],
  "refermer": [
    [
      "rabattre",
      0.5
    ],
    [
      "resserrer",
      0.5
    ]
  ],
  "reculer": [
    [
      "rompre",
      0.07
    ],
    [
      "abandonner",
      0.0625
    ],
    [
      "remettre",
      0.045
    ],
    [
      "ceder",
      0.04
    ],
    [
      "retarder",
      0.04
    ],
    [
      "renvoyer",
      0.0375
    ],
    [
      "repousser",
      0.0325
    ],
    [
      "differer",
      0.0275
    ],
    [
      "refluer",
      0.0275
    ],
    [
      "temporiser",
      0.0275
    ],
    [
      "flechir",
      0.025
    ],
    [
      "atermoyer",
      0.025
    ],
    [
      "ajourner",
      0.02
    ],
    [
      "fuir",
      0.02
    ],
    [
      "eloigner",
      0.015
    ],
    [
      "renoncer",
      0.015
    ],
    [
      "rejeter",
      0.015
    ],
    [
      "lanterner",
      0.015
    ],
    [
      "flancher",
      0.015
    ],
    [
      "disparaitre",
      0.015
    ],
    [
      "tarder",
      0.01
    ],
    [
      "surseoir",
      0.01
    ],
    [
      "retrograder",
      0.01
    ],
    [
      "reporter",
      0.01
    ],
    [
      "proroger",
      0.01
    ],
    [
      "pousser",
      0.01
    ],
    [
      "plier",
      0.01
    ],
    [
      "hesiter",
      0.01
    ],
    [
      "caler",
      0.01
    ],
    [
      "s'effacer",
      0.0075
    ],
    [
      "revenir",
      0.0075
    ],
    [
      "refouler",
      0.0075
    ],
    [
      "deplacer",
      0.0075
    ],
    [
      "decrocher",
      0.0075
    ],
    [
      "decaler",
      0.0075
    ],
    [
      "retirer",
      0.0025
    ],
    [
      "regresser",
      0.0025
    ],
    [
      "s'estomper",
      0.0025
    ],
    [
      "lambiner",
      0.0025
    ],
    [
      "foirer",
      0.0025
    ],
    [
      "culer",
      0.0025
    ],
    [
      "caner",
      0.0025
    ]
  ],
  "danseur": [
    [
      "acrobate",
      0.1575
    ],
    [
      "saltimbanque",
      0.1575
    ],
    [
      "bateleur",
      0.1025
    ],
    [
      "funambule",
      0.1025
    ],
    [
      "partenaire",
      0.05
    ],
    [
      "matassin",
      0.05
    ],
    [
      "choriste",
      0.05
    ],
    [
      "cavalier",
      0.05
    ],
    [
      "boy",
      0.05
    ],
    [
      "ballerine",
      0.05
    ],
    [
      "baladin",
      0.05
    ],
    [
      "artiste",
      0.05
    ],
    [
      "valseur",
      0.05
    ]
  ],
  "prairie": [
    [
      "paturage",
      0.1775
    ],
    [
      "herbe",
      0.1325
    ],
    [
      "herbage",
      0.0875
    ],
    [
      "patis",
      0.0875
    ],
    [
      "pature",
      0.0875
    ],
    [
      "steppe",
      0.0425
    ],
    [
      "pre",
      0.0425
    ],
    [
      "lande",
      0.0425
    ],
    [
      "champ",
      0.0425
    ],
    [
      "verdure",
      0.02
    ],
    [
      "toundra",
      0.02
    ],
    [
      "savane",
      0.02
    ],
    [
      "pelouse",
      0.02
    ],
    [
      "parc",
      0.02
    ],
    [
      "pampa",
      0.02
    ],
    [
      "pacage",
      0.02
    ],
    [
      "noue",
      0.02
    ],
    [
      "embouche",
      0.02
    ],
    [
      "alpage",
      0.02
    ],
    [
      "vert",
      0.02
    ]
  ],
  "border": [
    [
      "encadrer",
      0.12
    ],
    [
      "entourer",
      0.09
    ],
    [
      "garnir",
      0.09
    ],
    [
      "longer",
      0.09
    ],
    [
      "ourler",
      0.09
    ],
    [
      "cercler",
      0.06
    ],
    [
      "borner",
      0.06
    ],
    [
      "souligner",
      0.03
    ],
    [
      "s'etendre",
      0.03
    ],
    [
      "louvoyer",
      0.03
    ],
    [
      "limiter",
      0.03
    ],
    [
      "franger",
      0.03
    ],
    [
      "flanquer",
      0.03
    ],
    [
      "festonner",
      0.03
    ],
    [
      "cotoyer",
      0.03
    ],
    [
      "ceindre",
      0.03
    ],
    [
      "cadrer",
      0.03
    ],
    [
      "caboter",
      0.03
    ],
    [
      "bouliner",
      0.03
    ]
  ],
  "bordee": [
    [
      "encadrer",
      0.12
    ],
    [
      "entourer",
      0.09
    ],
    [
      "garnir",
      0.09
    ],
    [
      "longer",
      0.09
    ],
    [
      "ourler",
      0.09
    ],
    [
      "cercler",
      0.06
    ],
    [
      "borner",
      0.06
    ],
    [
      "souligner",
      0.03
    ],
    [
      "s'etendre",
      0.03
    ],
    [
      "louvoyer",
      0.03
    ],
    [
      "limiter",
      0.03
    ],
    [
      "franger",
      0.03
    ],
    [
      "flanquer",
      0.03
    ],
    [
      "festonner",
      0.03
    ],
    [
      "cotoyer",
      0.03
    ],
    [
      "ceindre",
      0.03
    ],
    [
      "cadrer",
      0.03
    ],
    [
      "caboter",
      0.03
    ],
    [
      "bouliner",
      0.03
    ]
  ],
  "pantin": [
    [
      "fantoche",
      0.1
    ],
    [
      "marionnette",
      0.1
    ],
    [
      "polichinelle",
      0.0875
    ],
    [
      "bouffon",
      0.075
    ],
    [
      "arlequin",
      0.0625
    ],
    [
      "clown",
      0.0625
    ],
    [
      "guignol",
      0.0625
    ],
    [
      "turlupin",
      0.05
    ],
    [
      "saltimbanque",
      0.0375
    ],
    [
      "jouet",
      0.0375
    ],
    [
      "girouette",
      0.0375
    ],
    [
      "automate",
      0.025
    ],
    [
      "poupee",
      0.025
    ],
    [
      "rigolo",
      0.025
    ],
    [
      "pierrot",
      0.0125
    ],
    [
      "pupazzo",
      0.0125
    ],
    [
      "sauteur",
      0.0125
    ],
    [
      "toton",
      0.0125
    ],
    [
      "toupie",
      0.0125
    ],
    [
      "zombi",
      0.0125
    ],
    [
      "pantalon",
      0.0125
    ],
    [
      "margotin",
      0.0125
    ],
    [
      "mannequin",
      0.0125
    ],
    [
      "joujou",
      0.0125
    ],
    [
      "fantome",
      0.0125
    ],
    [
      "esclave",
      0.0125
    ],
    [
      "cameleon",
      0.0125
    ],
    [
      "burattino",
      0.0125
    ],
    [
      "bamboche",
      0.0125
    ],
    [
      "zero",
      0.0125
    ]
  ],
  "minus": [
    [
      "debile",
      0.1325
    ],
    [
      "gringalet",
      0.1325
    ],
    [
      "idiot",
      0.1325
    ],
    [
      "imbecile",
      0.1325
    ],
    [
      "petit",
      0.1325
    ],
    [
      "freluquet",
      0.065
    ],
    [
      "degenere",
      0.065
    ],
    [
      "cretin",
      0.065
    ],
    [
      "criquet",
      0.065
    ]
  ],
  "chapeau": [
    [
      "coiffure",
      0.225
    ],
    [
      "galurin",
      0.05
    ],
    [
      "couvercle",
      0.05
    ],
    [
      "cloche",
      0.05
    ],
    [
      "calotte",
      0.05
    ],
    [
      "bonnet",
      0.05
    ],
    [
      "bitos",
      0.05
    ],
    [
      "bada",
      0.05
    ],
    [
      "coiffe",
      0.025
    ],
    [
      "doulos",
      0.025
    ],
    [
      "feutre",
      0.025
    ],
    [
      "gratification",
      0.025
    ],
    [
      "sommaire",
      0.025
    ],
    [
      "chapiteau",
      0.025
    ],
    [
      "casquette",
      0.025
    ],
    [
      "casque",
      0.025
    ],
    [
      "caloquet",
      0.025
    ],
    [
      "boisage",
      0.025
    ],
    [
      "bloum",
      0.025
    ],
    [
      "bibi",
      0.025
    ],
    [
      "abri",
      0.025
    ],
    [
      "suroit",
      0.025
    ]
  ],
  "torero": [
    [
      "banderillero",
      0.165
    ],
    [
      "espada",
      0.165
    ],
    [
      "matador",
      0.165
    ],
    [
      "picador",
      0.165
    ],
    [
      "puntillero",
      0.165
    ],
    [
      "quadrille",
      0.165
    ]
  ],
  "poursuivre": [
    [
      "harceler",
      0.0725
    ],
    [
      "tourmenter",
      0.0625
    ],
    [
      "obseder",
      0.06
    ],
    [
      "courir",
      0.0525
    ],
    [
      "hanter",
      0.0425
    ],
    [
      "talonner",
      0.035
    ],
    [
      "importuner",
      0.035
    ],
    [
      "presser",
      0.0325
    ],
    [
      "assieger",
      0.0275
    ],
    [
      "pousser",
      0.025
    ],
    [
      "continuer",
      0.025
    ],
    [
      "chasser",
      0.025
    ],
    [
      "pourchasser",
      0.0225
    ],
    [
      "chercher",
      0.02
    ],
    [
      "rechercher",
      0.02
    ],
    [
      "travailler",
      0.02
    ],
    [
      "suivre",
      0.015
    ],
    [
      "solliciter",
      0.015
    ],
    [
      "forcer",
      0.015
    ],
    [
      "assaillir",
      0.015
    ],
    [
      "aller",
      0.015
    ],
    [
      "viser",
      0.0125
    ],
    [
      "traquer",
      0.0125
    ],
    [
      "torturer",
      0.0125
    ],
    [
      "tarabuster",
      0.0125
    ],
    [
      "serrer",
      0.0125
    ],
    [
      "s'attacher",
      0.0125
    ],
    [
      "persecuter",
      0.0125
    ],
    [
      "lanciner",
      0.0125
    ],
    [
      "briguer",
      0.0125
    ],
    [
      "tenailler",
      0.0075
    ],
    [
      "soutenir",
      0.0075
    ],
    [
      "s'obstiner",
      0.0075
    ],
    [
      "s'acharner",
      0.0075
    ],
    [
      "relancer",
      0.0075
    ],
    [
      "pretendre",
      0.0075
    ],
    [
      "preoccuper",
      0.0075
    ],
    [
      "perseverer",
      0.0075
    ],
    [
      "ambitionner",
      0.0075
    ],
    [
      "voler",
      0.005
    ],
    [
      "s'enteter",
      0.005
    ],
    [
      "prolonger",
      0.005
    ],
    [
      "persister",
      0.005
    ],
    [
      "habiter",
      0.005
    ],
    [
      "courre",
      0.005
    ],
    [
      "aspirer",
      0.005
    ],
    [
      "inculper",
      0.0025
    ],
    [
      "larder",
      0.0025
    ],
    [
      "rattraper",
      0.0025
    ],
    [
      "rembucher",
      0.0025
    ],
    [
      "rencogner",
      0.0025
    ],
    [
      "s'attaquer",
      0.0025
    ],
    [
      "tracer",
      0.0025
    ],
    [
      "eterniser",
      0.0025
    ],
    [
      "foncer",
      0.0025
    ],
    [
      "aboyer",
      0.0025
    ],
    [
      "accabler",
      0.0025
    ],
    [
      "accuser",
      0.0025
    ],
    [
      "actionner",
      0.0025
    ],
    [
      "attraire",
      0.0025
    ],
    [
      "conduire",
      0.0025
    ],
    [
      "devorer",
      0.0025
    ],
    [
      "ester",
      0.0025
    ]
  ],
  "ballerine": [
    [
      "danseuse",
      0.375
    ],
    [
      "baladine",
      0.125
    ],
    [
      "chaussure",
      0.125
    ],
    [
      "danseur",
      0.125
    ],
    [
      "etoile",
      0.125
    ]
  ],
  "incliner": [
    [
      "pencher",
      0.0875
    ],
    [
      "flechir",
      0.0725
    ],
    [
      "pousser",
      0.065
    ],
    [
      "courber",
      0.055
    ],
    [
      "baisser",
      0.0475
    ],
    [
      "porter",
      0.0475
    ],
    [
      "tourner",
      0.04
    ],
    [
      "plier",
      0.04
    ],
    [
      "inflechir",
      0.04
    ],
    [
      "abaisser",
      0.04
    ],
    [
      "influencer",
      0.0325
    ],
    [
      "tendre",
      0.0225
    ],
    [
      "s'abaisser",
      0.0225
    ],
    [
      "ployer",
      0.0225
    ],
    [
      "orienter",
      0.0225
    ],
    [
      "inviter",
      0.0225
    ],
    [
      "inspirer",
      0.0225
    ],
    [
      "deriver",
      0.0225
    ],
    [
      "diriger",
      0.0225
    ],
    [
      "coucher",
      0.0225
    ],
    [
      "soumettre",
      0.015
    ],
    [
      "s'inflechir",
      0.015
    ],
    [
      "predisposer",
      0.015
    ],
    [
      "peser",
      0.015
    ],
    [
      "obliquer",
      0.015
    ],
    [
      "inciter",
      0.015
    ],
    [
      "encourager",
      0.015
    ],
    [
      "descendre",
      0.015
    ],
    [
      "attirer",
      0.015
    ],
    [
      "renverser",
      0.0075
    ],
    [
      "preferer",
      0.0075
    ],
    [
      "deverser",
      0.0075
    ],
    [
      "desirer",
      0.0075
    ],
    [
      "convier",
      0.0075
    ]
  ],
  "costumer": [
    [
      "fringuer",
      0.25
    ],
    [
      "habiller",
      0.25
    ],
    [
      "deguiser",
      0.165
    ],
    [
      "accoutrer",
      0.0825
    ],
    [
      "endimancher",
      0.0825
    ],
    [
      "travestir",
      0.0825
    ],
    [
      "vetir",
      0.0825
    ]
  ],
  "costume": [
    [
      "habillement",
      0.1425
    ],
    [
      "vetement",
      0.12
    ],
    [
      "mise",
      0.1
    ],
    [
      "habit",
      0.08
    ],
    [
      "accoutrement",
      0.06
    ],
    [
      "tenue",
      0.06
    ],
    [
      "equipage",
      0.06
    ],
    [
      "toilette",
      0.04
    ],
    [
      "tailleur",
      0.04
    ],
    [
      "complet",
      0.04
    ],
    [
      "toge",
      0.02
    ],
    [
      "smoking",
      0.02
    ],
    [
      "pantalon",
      0.02
    ],
    [
      "gilet",
      0.02
    ],
    [
      "effets",
      0.02
    ],
    [
      "deguisement",
      0.02
    ],
    [
      "domino",
      0.02
    ],
    [
      "costard",
      0.02
    ],
    [
      "appareil",
      0.02
    ],
    [
      "veste",
      0.02
    ]
  ],
  "rale": [
    [
      "bruit",
      0.3325
    ],
    [
      "agonie",
      0.165
    ],
    [
      "cornage",
      0.165
    ],
    [
      "rallide",
      0.165
    ],
    [
      "ralement",
      0.165
    ]
  ],
  "raler": [
    [
      "rouspeter",
      0.16
    ],
    [
      "ronchonner",
      0.0925
    ],
    [
      "grogner",
      0.0675
    ],
    [
      "murmurer",
      0.0675
    ],
    [
      "protester",
      0.0675
    ],
    [
      "rager",
      0.0575
    ],
    [
      "fumer",
      0.0575
    ],
    [
      "maugreer",
      0.05
    ],
    [
      "pester",
      0.05
    ],
    [
      "gronder",
      0.04
    ],
    [
      "rogner",
      0.025
    ],
    [
      "maronner",
      0.025
    ],
    [
      "bougonner",
      0.025
    ],
    [
      "bisquer",
      0.025
    ],
    [
      "rognonner",
      0.015
    ],
    [
      "rouscailler",
      0.015
    ],
    [
      "reclamer",
      0.015
    ],
    [
      "renauder",
      0.0075
    ],
    [
      "enrager",
      0.0075
    ],
    [
      "discuter",
      0.0075
    ],
    [
      "chiner",
      0.0075
    ],
    [
      "bouder",
      0.0075
    ],
    [
      "agoniser",
      0.0075
    ]
  ],
  "succomber": [
    [
      "mourir",
      0.21
    ],
    [
      "ceder",
      0.0625
    ],
    [
      "s'effondrer",
      0.045
    ],
    [
      "tomber",
      0.045
    ],
    [
      "perir",
      0.035
    ],
    [
      "flechir",
      0.035
    ],
    [
      "finir",
      0.035
    ],
    [
      "expirer",
      0.035
    ],
    [
      "disparaitre",
      0.035
    ],
    [
      "capituler",
      0.035
    ],
    [
      "abandonner",
      0.0275
    ],
    [
      "s'abandonner",
      0.0275
    ],
    [
      "s'affaisser",
      0.0275
    ],
    [
      "trepasser",
      0.0175
    ],
    [
      "sombrer",
      0.0175
    ],
    [
      "s'eteindre",
      0.0175
    ],
    [
      "ployer",
      0.0175
    ],
    [
      "plier",
      0.0175
    ],
    [
      "crever",
      0.0175
    ],
    [
      "clamser",
      0.0175
    ],
    [
      "s'abattre",
      0.0075
    ],
    [
      "calancher",
      0.0075
    ],
    [
      "claquer",
      0.0075
    ],
    [
      "cronir",
      0.0075
    ],
    [
      "deceder",
      0.0075
    ],
    [
      "degeler",
      0.0075
    ]
  ],
  "hombre": [
    [
      "quadrille",
      0.5
    ],
    [
      "tri",
      0.5
    ]
  ],
  "malsain": [
    [
      "mauvais",
      0.175
    ],
    [
      "pernicieux",
      0.085
    ],
    [
      "nuisible",
      0.07
    ],
    [
      "morbide",
      0.06
    ],
    [
      "fetide",
      0.0525
    ],
    [
      "pestilentiel",
      0.0525
    ],
    [
      "putride",
      0.0425
    ],
    [
      "deletere",
      0.0425
    ],
    [
      "malade",
      0.0325
    ],
    [
      "mephitique",
      0.0325
    ],
    [
      "nocif",
      0.0325
    ],
    [
      "pourri",
      0.025
    ],
    [
      "pervers",
      0.025
    ],
    [
      "nefaste",
      0.025
    ],
    [
      "malfaisant",
      0.025
    ],
    [
      "impur",
      0.025
    ],
    [
      "immoral",
      0.025
    ],
    [
      "maladif",
      0.015
    ],
    [
      "insalubre",
      0.015
    ],
    [
      "funeste",
      0.015
    ],
    [
      "frelate",
      0.015
    ],
    [
      "pornographique",
      0.0075
    ],
    [
      "licencieux",
      0.0075
    ],
    [
      "fievreux",
      0.0075
    ],
    [
      "faisande",
      0.0075
    ],
    [
      "deplace",
      0.0075
    ],
    [
      "defavorable",
      0.0075
    ],
    [
      "dissolvant",
      0.0075
    ],
    [
      "dangereux",
      0.0075
    ],
    [
      "contagieux",
      0.0075
    ],
    [
      "vilain",
      0.0075
    ]
  ],
  "eliminer": [
    [
      "exclure",
      0.0825
    ],
    [
      "supprimer",
      0.0825
    ],
    [
      "repousser",
      0.06
    ],
    [
      "ecarter",
      0.055
    ],
    [
      "chasser",
      0.0525
    ],
    [
      "retrancher",
      0.0475
    ],
    [
      "rejeter",
      0.035
    ],
    [
      "detruire",
      0.035
    ],
    [
      "bannir",
      0.035
    ],
    [
      "enlever",
      0.03
    ],
    [
      "retirer",
      0.03
    ],
    [
      "eloigner",
      0.03
    ],
    [
      "evincer",
      0.025
    ],
    [
      "refuser",
      0.025
    ],
    [
      "expulser",
      0.025
    ],
    [
      "dissiper",
      0.025
    ],
    [
      "proscrire",
      0.02
    ],
    [
      "rayer",
      0.02
    ],
    [
      "blackbouler",
      0.015
    ],
    [
      "epurer",
      0.0125
    ],
    [
      "tirer",
      0.0125
    ],
    [
      "sortir",
      0.0125
    ],
    [
      "refouler",
      0.0125
    ],
    [
      "excepter",
      0.0125
    ],
    [
      "effacer",
      0.0125
    ],
    [
      "battre",
      0.0125
    ],
    [
      "abattre",
      0.0125
    ],
    [
      "evacuer",
      0.0075
    ],
    [
      "recaler",
      0.0075
    ],
    [
      "ostraciser",
      0.0075
    ],
    [
      "coller",
      0.0075
    ],
    [
      "bousculer",
      0.0075
    ],
    [
      "ajourner",
      0.0075
    ],
    [
      "tamiser",
      0.0025
    ],
    [
      "omettre",
      0.0025
    ],
    [
      "neantiser",
      0.0025
    ],
    [
      "forclore",
      0.0025
    ],
    [
      "filtrer",
      0.0025
    ],
    [
      "executer",
      0.0025
    ],
    [
      "abstraire",
      0.0025
    ],
    [
      "eradiquer",
      0.0025
    ]
  ],
  "templier": [],
  "moine": [
    [
      "religieux",
      0.2775
    ],
    [
      "frere",
      0.0525
    ],
    [
      "ermite",
      0.035
    ],
    [
      "dominicain",
      0.035
    ],
    [
      "cenobite",
      0.035
    ],
    [
      "chauffage",
      0.035
    ],
    [
      "bassinoire",
      0.035
    ],
    [
      "ascete",
      0.035
    ],
    [
      "anachorete",
      0.035
    ],
    [
      "frater",
      0.0175
    ],
    [
      "frocard",
      0.0175
    ],
    [
      "monial",
      0.0175
    ],
    [
      "phoque",
      0.0175
    ],
    [
      "precheur",
      0.0175
    ],
    [
      "pere",
      0.0175
    ],
    [
      "regulier",
      0.0175
    ],
    [
      "solitaire",
      0.0175
    ],
    [
      "therapeute",
      0.0175
    ],
    [
      "toupie",
      0.0175
    ],
    [
      "faute",
      0.0175
    ],
    [
      "convers",
      0.0175
    ],
    [
      "augustin",
      0.0175
    ],
    [
      "bonze",
      0.0175
    ],
    [
      "bouillotte",
      0.0175
    ],
    [
      "benedictin",
      0.0175
    ],
    [
      "capucin",
      0.0175
    ],
    [
      "carme",
      0.0175
    ],
    [
      "chanoine",
      0.0175
    ],
    [
      "chartreux",
      0.0175
    ],
    [
      "cloitrier",
      0.0175
    ],
    [
      "trappiste",
      0.0175
    ]
  ],
  "anonymat": [
    [
      "incognito",
      0.285
    ],
    [
      "anonyme",
      0.1425
    ],
    [
      "anonymie",
      0.1425
    ],
    [
      "anonymite",
      0.1425
    ],
    [
      "banalite",
      0.1425
    ],
    [
      "obscurite",
      0.1425
    ]
  ],
  "embuche": [
    [
      "piege",
      0.22
    ],
    [
      "artifice",
      0.0725
    ],
    [
      "astuce",
      0.0725
    ],
    [
      "embuscade",
      0.0725
    ],
    [
      "ruse",
      0.0725
    ],
    [
      "truc",
      0.0725
    ],
    [
      "traquenard",
      0.0475
    ],
    [
      "rets",
      0.0475
    ],
    [
      "filet",
      0.0475
    ],
    [
      "danger",
      0.0475
    ],
    [
      "appat",
      0.0225
    ],
    [
      "difficulte",
      0.0225
    ],
    [
      "machination",
      0.0225
    ],
    [
      "surprise",
      0.0225
    ]
  ],
  "capuche": [
    [
      "capuchon",
      0.5
    ],
    [
      "cape",
      0.25
    ],
    [
      "coiffure",
      0.25
    ]
  ],
  "foule": [
    [
      "multitude",
      0.125
    ],
    [
      "affluence",
      0.07
    ],
    [
      "quantite",
      0.07
    ],
    [
      "masse",
      0.0675
    ],
    [
      "peuple",
      0.0625
    ],
    [
      "tas",
      0.055
    ],
    [
      "amas",
      0.03
    ],
    [
      "flot",
      0.0275
    ],
    [
      "populace",
      0.025
    ],
    [
      "rassemblement",
      0.025
    ],
    [
      "essaim",
      0.0225
    ],
    [
      "nuee",
      0.02
    ],
    [
      "ribambelle",
      0.0175
    ],
    [
      "tourbe",
      0.015
    ],
    [
      "public",
      0.015
    ],
    [
      "concours",
      0.015
    ],
    [
      "armee",
      0.015
    ],
    [
      "afflux",
      0.015
    ],
    [
      "troupe",
      0.0125
    ],
    [
      "tapee",
      0.0125
    ],
    [
      "flopee",
      0.0125
    ],
    [
      "commun",
      0.0125
    ],
    [
      "accumulation",
      0.0125
    ],
    [
      "vulgaire",
      0.01
    ],
    [
      "presse",
      0.01
    ],
    [
      "pleiade",
      0.01
    ],
    [
      "kyrielle",
      0.01
    ],
    [
      "flux",
      0.01
    ],
    [
      "entassement",
      0.01
    ],
    [
      "cohue",
      0.01
    ],
    [
      "troupeau",
      0.0075
    ],
    [
      "tripotee",
      0.0075
    ],
    [
      "populo",
      0.0075
    ],
    [
      "populaire",
      0.0075
    ],
    [
      "monde",
      0.0075
    ],
    [
      "encombrement",
      0.0075
    ],
    [
      "profusion",
      0.005
    ],
    [
      "horde",
      0.005
    ],
    [
      "collection",
      0.005
    ],
    [
      "assistance",
      0.005
    ],
    [
      "plebe",
      0.0025
    ],
    [
      "nombre",
      0.0025
    ],
    [
      "cortege",
      0.0025
    ],
    [
      "betail",
      0.0025
    ],
    [
      "attroupement",
      0.0025
    ],
    [
      "assemblee",
      0.0025
    ],
    [
      "armada",
      0.0025
    ],
    [
      "population",
      0.0
    ],
    [
      "pietaille",
      0.0
    ],
    [
      "majorite",
      0.0
    ],
    [
      "grouillement",
      0.0
    ],
    [
      "gens",
      0.0
    ],
    [
      "fougue",
      0.0
    ],
    [
      "defile",
      0.0
    ],
    [
      "bousculade",
      0.0
    ],
    [
      "auditoire",
      0.0
    ],
    [
      "animation",
      0.0
    ],
    [
      "queue",
      0.0
    ]
  ],
  "fouler": [
    [
      "ecraser",
      0.1375
    ],
    [
      "accabler",
      0.0675
    ],
    [
      "presser",
      0.05
    ],
    [
      "meurtrir",
      0.05
    ],
    [
      "luxer",
      0.05
    ],
    [
      "froisser",
      0.05
    ],
    [
      "blesser",
      0.05
    ],
    [
      "tordre",
      0.0325
    ],
    [
      "pressurer",
      0.0325
    ],
    [
      "pietiner",
      0.0325
    ],
    [
      "opprimer",
      0.0325
    ],
    [
      "fausser",
      0.0325
    ],
    [
      "disloquer",
      0.0325
    ],
    [
      "immoler",
      0.015
    ],
    [
      "marcher",
      0.015
    ],
    [
      "mepriser",
      0.015
    ],
    [
      "s'ereinter",
      0.015
    ],
    [
      "taler",
      0.015
    ],
    [
      "tasser",
      0.015
    ],
    [
      "foulonner",
      0.015
    ],
    [
      "demettre",
      0.015
    ],
    [
      "deboiter",
      0.015
    ],
    [
      "corroyer",
      0.015
    ],
    [
      "charger",
      0.015
    ],
    [
      "braver",
      0.015
    ],
    [
      "battre",
      0.015
    ],
    [
      "bafouer",
      0.015
    ],
    [
      "appreter",
      0.015
    ],
    [
      "tyranniser",
      0.015
    ]
  ],
  "assassiner": [
    [
      "tuer",
      0.16
    ],
    [
      "abattre",
      0.1125
    ],
    [
      "assommer",
      0.1125
    ],
    [
      "fatiguer",
      0.09
    ],
    [
      "frapper",
      0.0675
    ],
    [
      "egorger",
      0.0675
    ],
    [
      "etrangler",
      0.0425
    ],
    [
      "supprimer",
      0.0425
    ],
    [
      "poignarder",
      0.0425
    ],
    [
      "massacrer",
      0.0425
    ],
    [
      "ennuyer",
      0.0425
    ],
    [
      "accabler",
      0.0425
    ],
    [
      "calomnier",
      0.02
    ],
    [
      "executer",
      0.02
    ],
    [
      "immoler",
      0.02
    ],
    [
      "importuner",
      0.02
    ],
    [
      "maltraiter",
      0.02
    ]
  ],
  "calvitie": [
    [
      "atrichie",
      0.3325
    ],
    [
      "decalvation",
      0.3325
    ],
    [
      "pelade",
      0.3325
    ]
  ],
  "immiscer": [
    [
      "introduire",
      0.5
    ]
  ],
  "deguiser": [
    [
      "alterer",
      0.0575
    ],
    [
      "dissimuler",
      0.0575
    ],
    [
      "travestir",
      0.0575
    ],
    [
      "masquer",
      0.055
    ],
    [
      "habiller",
      0.05
    ],
    [
      "couvrir",
      0.05
    ],
    [
      "farder",
      0.045
    ],
    [
      "fausser",
      0.0425
    ],
    [
      "envelopper",
      0.035
    ],
    [
      "voiler",
      0.03
    ],
    [
      "maquiller",
      0.03
    ],
    [
      "frelater",
      0.03
    ],
    [
      "changer",
      0.03
    ],
    [
      "cacher",
      0.03
    ],
    [
      "fringuer",
      0.025
    ],
    [
      "revetir",
      0.025
    ],
    [
      "truquer",
      0.025
    ],
    [
      "denaturer",
      0.0225
    ],
    [
      "deformer",
      0.0225
    ],
    [
      "defigurer",
      0.0225
    ],
    [
      "camoufler",
      0.0225
    ],
    [
      "tromper",
      0.0175
    ],
    [
      "transformer",
      0.0175
    ],
    [
      "contrefaire",
      0.0175
    ],
    [
      "recouvrir",
      0.015
    ],
    [
      "vetir",
      0.015
    ],
    [
      "accoutrer",
      0.01
    ],
    [
      "arranger",
      0.01
    ],
    [
      "celer",
      0.01
    ],
    [
      "feindre",
      0.01
    ],
    [
      "pallier",
      0.0075
    ],
    [
      "costumer",
      0.0075
    ],
    [
      "composer",
      0.0075
    ],
    [
      "affubler",
      0.0075
    ],
    [
      "platrer",
      0.0025
    ],
    [
      "enrober",
      0.0025
    ],
    [
      "emmitoufler",
      0.0025
    ],
    [
      "desillusionner",
      0.0025
    ],
    [
      "decorer",
      0.0025
    ],
    [
      "colorer",
      0.0025
    ],
    [
      "taire",
      0.0025
    ]
  ],
  "deguise": [
    [
      "alterer",
      0.0575
    ],
    [
      "dissimuler",
      0.0575
    ],
    [
      "travestir",
      0.0575
    ],
    [
      "masquer",
      0.055
    ],
    [
      "habiller",
      0.05
    ],
    [
      "couvrir",
      0.05
    ],
    [
      "farder",
      0.045
    ],
    [
      "fausser",
      0.0425
    ],
    [
      "envelopper",
      0.035
    ],
    [
      "voiler",
      0.03
    ],
    [
      "maquiller",
      0.03
    ],
    [
      "frelater",
      0.03
    ],
    [
      "changer",
      0.03
    ],
    [
      "cacher",
      0.03
    ],
    [
      "fringuer",
      0.025
    ],
    [
      "revetir",
      0.025
    ],
    [
      "truquer",
      0.025
    ],
    [
      "denaturer",
      0.0225
    ],
    [
      "deformer",
      0.0225
    ],
    [
      "defigurer",
      0.0225
    ],
    [
      "camoufler",
      0.0225
    ],
    [
      "tromper",
      0.0175
    ],
    [
      "transformer",
      0.0175
    ],
    [
      "contrefaire",
      0.0175
    ],
    [
      "recouvrir",
      0.015
    ],
    [
      "vetir",
      0.015
    ],
    [
      "accoutrer",
      0.01
    ],
    [
      "arranger",
      0.01
    ],
    [
      "celer",
      0.01
    ],
    [
      "feindre",
      0.01
    ],
    [
      "pallier",
      0.0075
    ],
    [
      "costumer",
      0.0075
    ],
    [
      "composer",
      0.0075
    ],
    [
      "affubler",
      0.0075
    ],
    [
      "platrer",
      0.0025
    ],
    [
      "enrober",
      0.0025
    ],
    [
      "emmitoufler",
      0.0025
    ],
    [
      "desillusionner",
      0.0025
    ],
    [
      "decorer",
      0.0025
    ],
    [
      "colorer",
      0.0025
    ],
    [
      "taire",
      0.0025
    ]
  ],
  "lame": [
    [
      "couteau",
      0.105
    ],
    [
      "feuille",
      0.07
    ],
    [
      "plaque",
      0.07
    ],
    [
      "poignard",
      0.07
    ],
    [
      "epee",
      0.07
    ],
    [
      "morceau",
      0.0325
    ],
    [
      "onde",
      0.0325
    ],
    [
      "paillette",
      0.0325
    ],
    [
      "paquet",
      0.0325
    ],
    [
      "plaquette",
      0.0325
    ],
    [
      "table",
      0.0325
    ],
    [
      "tranche",
      0.0325
    ],
    [
      "limbe",
      0.0325
    ],
    [
      "languette",
      0.0325
    ],
    [
      "lamelle",
      0.0325
    ],
    [
      "flot",
      0.0325
    ],
    [
      "flamberge",
      0.0325
    ],
    [
      "feuillet",
      0.0325
    ],
    [
      "busc",
      0.0325
    ],
    [
      "bistouri",
      0.0325
    ],
    [
      "baleine",
      0.0325
    ],
    [
      "allumelle",
      0.0325
    ],
    [
      "vague",
      0.0325
    ]
  ],
  "aiguise": [
    [
      "exciter",
      0.1375
    ],
    [
      "enflammer",
      0.0975
    ],
    [
      "attiser",
      0.0775
    ],
    [
      "augmenter",
      0.0575
    ],
    [
      "stimuler",
      0.0575
    ],
    [
      "affiler",
      0.0475
    ],
    [
      "ranimer",
      0.0375
    ],
    [
      "surexciter",
      0.0375
    ],
    [
      "exasperer",
      0.0275
    ],
    [
      "aviver",
      0.0275
    ],
    [
      "amincir",
      0.0275
    ],
    [
      "aiguillonner",
      0.0275
    ],
    [
      "affuter",
      0.0275
    ],
    [
      "accroitre",
      0.0275
    ],
    [
      "travailler",
      0.0175
    ],
    [
      "repasser",
      0.0175
    ],
    [
      "polir",
      0.0175
    ],
    [
      "parfaire",
      0.0175
    ],
    [
      "fignoler",
      0.0175
    ],
    [
      "effiler",
      0.0175
    ],
    [
      "developper",
      0.0175
    ],
    [
      "appointer",
      0.0175
    ],
    [
      "emorfiler",
      0.0075
    ],
    [
      "morfiler",
      0.0075
    ],
    [
      "fouetter",
      0.0075
    ],
    [
      "delier",
      0.0075
    ],
    [
      "appointir",
      0.0075
    ],
    [
      "amenuiser",
      0.0075
    ],
    [
      "allegir",
      0.0075
    ],
    [
      "acerer",
      0.0075
    ],
    [
      "achever",
      0.0075
    ],
    [
      "emoudre",
      0.0075
    ]
  ],
  "aiguiser": [
    [
      "exciter",
      0.1375
    ],
    [
      "enflammer",
      0.0975
    ],
    [
      "attiser",
      0.0775
    ],
    [
      "augmenter",
      0.0575
    ],
    [
      "stimuler",
      0.0575
    ],
    [
      "affiler",
      0.0475
    ],
    [
      "ranimer",
      0.0375
    ],
    [
      "surexciter",
      0.0375
    ],
    [
      "exasperer",
      0.0275
    ],
    [
      "aviver",
      0.0275
    ],
    [
      "amincir",
      0.0275
    ],
    [
      "aiguillonner",
      0.0275
    ],
    [
      "affuter",
      0.0275
    ],
    [
      "accroitre",
      0.0275
    ],
    [
      "travailler",
      0.0175
    ],
    [
      "repasser",
      0.0175
    ],
    [
      "polir",
      0.0175
    ],
    [
      "parfaire",
      0.0175
    ],
    [
      "fignoler",
      0.0175
    ],
    [
      "effiler",
      0.0175
    ],
    [
      "developper",
      0.0175
    ],
    [
      "appointer",
      0.0175
    ],
    [
      "emorfiler",
      0.0075
    ],
    [
      "morfiler",
      0.0075
    ],
    [
      "fouetter",
      0.0075
    ],
    [
      "delier",
      0.0075
    ],
    [
      "appointir",
      0.0075
    ],
    [
      "amenuiser",
      0.0075
    ],
    [
      "allegir",
      0.0075
    ],
    [
      "acerer",
      0.0075
    ],
    [
      "achever",
      0.0075
    ],
    [
      "emoudre",
      0.0075
    ]
  ],
  "penombre": [
    [
      "ombre",
      0.375
    ],
    [
      "sombreur",
      0.25
    ],
    [
      "ombrage",
      0.125
    ]
  ],
  "fonds": [
    [
      "coeur",
      0.055
    ],
    [
      "matiere",
      0.05
    ],
    [
      "profondeur",
      0.045
    ],
    [
      "substance",
      0.0375
    ],
    [
      "sujet",
      0.0375
    ],
    [
      "ame",
      0.0375
    ],
    [
      "nature",
      0.0325
    ],
    [
      "fondement",
      0.0325
    ],
    [
      "fermete",
      0.0325
    ],
    [
      "base",
      0.0325
    ],
    [
      "esprit",
      0.0275
    ],
    [
      "solidite",
      0.0275
    ],
    [
      "secret",
      0.02
    ],
    [
      "interieur",
      0.02
    ],
    [
      "essence",
      0.02
    ],
    [
      "enfoncement",
      0.02
    ],
    [
      "creux",
      0.02
    ],
    [
      "champ",
      0.02
    ],
    [
      "caractere",
      0.02
    ],
    [
      "trefonds",
      0.015
    ],
    [
      "theme",
      0.015
    ],
    [
      "sein",
      0.015
    ],
    [
      "perspective",
      0.015
    ],
    [
      "objet",
      0.015
    ],
    [
      "noeud",
      0.015
    ],
    [
      "naturel",
      0.015
    ],
    [
      "intime",
      0.015
    ],
    [
      "essentiel",
      0.015
    ],
    [
      "culot",
      0.01
    ],
    [
      "extremite",
      0.01
    ],
    [
      "fable",
      0.01
    ],
    [
      "idee",
      0.01
    ],
    [
      "plan",
      0.01
    ],
    [
      "cul",
      0.01
    ],
    [
      "cran",
      0.01
    ],
    [
      "bout",
      0.01
    ],
    [
      "bas",
      0.01
    ],
    [
      "assise",
      0.01
    ],
    [
      "assiette",
      0.01
    ],
    [
      "renfoncement",
      0.0025
    ],
    [
      "residu",
      0.0025
    ],
    [
      "substrat",
      0.0025
    ],
    [
      "substratum",
      0.0025
    ],
    [
      "tissure",
      0.0025
    ],
    [
      "toile",
      0.0025
    ],
    [
      "vif",
      0.0025
    ],
    [
      "lointain",
      0.0025
    ],
    [
      "fonds",
      0.0025
    ],
    [
      "derriere",
      0.0025
    ],
    [
      "cuvette",
      0.0025
    ],
    [
      "contrecoeur",
      0.0025
    ],
    [
      "contenu",
      0.0025
    ],
    [
      "bassesse",
      0.0025
    ],
    [
      "affabulation",
      0.0025
    ],
    [
      "abysse",
      0.0025
    ],
    [
      "etoffe",
      0.0025
    ]
  ],
  "discret": [
    [
      "reserve",
      0.1825
    ],
    [
      "retenu",
      0.13
    ],
    [
      "secret",
      0.0775
    ],
    [
      "circonspect",
      0.05
    ],
    [
      "modeste",
      0.05
    ],
    [
      "silencieux",
      0.05
    ],
    [
      "sobre",
      0.0375
    ],
    [
      "pudique",
      0.0375
    ],
    [
      "mesure",
      0.0375
    ],
    [
      "delicat",
      0.0375
    ],
    [
      "timide",
      0.025
    ],
    [
      "reticent",
      0.025
    ],
    [
      "poli",
      0.025
    ],
    [
      "modere",
      0.025
    ],
    [
      "decent",
      0.025
    ],
    [
      "separe",
      0.0125
    ],
    [
      "retire",
      0.0125
    ],
    [
      "prudent",
      0.0125
    ],
    [
      "pondere",
      0.0125
    ],
    [
      "numerique",
      0.0125
    ],
    [
      "muet",
      0.0125
    ],
    [
      "leger",
      0.0125
    ],
    [
      "furtif",
      0.0125
    ],
    [
      "feutre",
      0.0125
    ],
    [
      "efface",
      0.0125
    ],
    [
      "discontinu",
      0.0125
    ],
    [
      "digital",
      0.0125
    ],
    [
      "voile",
      0.0125
    ]
  ],
  "instituteur": [
    [
      "educateur",
      0.2
    ],
    [
      "professeur",
      0.15
    ],
    [
      "precepteur",
      0.15
    ],
    [
      "instructeur",
      0.1
    ],
    [
      "maitre",
      0.1
    ],
    [
      "moniteur",
      0.0475
    ],
    [
      "instit",
      0.0475
    ],
    [
      "initiateur",
      0.0475
    ],
    [
      "enseignant",
      0.0475
    ],
    [
      "pedagogue",
      0.0475
    ]
  ],
  "grimpe": [
    [
      "escalader",
      0.2225
    ],
    [
      "monter",
      0.2225
    ],
    [
      "s'elever",
      0.11
    ],
    [
      "varapper",
      0.0525
    ],
    [
      "sauter",
      0.0525
    ],
    [
      "gravir",
      0.0525
    ],
    [
      "ascensionner",
      0.0525
    ],
    [
      "echeler",
      0.0525
    ]
  ],
  "arpenter": [
    [
      "battre",
      0.25
    ],
    [
      "marcher",
      0.25
    ],
    [
      "mesurer",
      0.25
    ],
    [
      "parcourir",
      0.25
    ]
  ],
  "abbaye": [
    [
      "cloitre",
      0.2125
    ],
    [
      "prieure",
      0.2125
    ],
    [
      "couvent",
      0.1425
    ],
    [
      "monastere",
      0.1425
    ],
    [
      "beguinage",
      0.07
    ],
    [
      "benefice",
      0.07
    ],
    [
      "ermitage",
      0.07
    ],
    [
      "moutier",
      0.07
    ]
  ],
  "acrobatie": [
    [
      "pirouette",
      0.13
    ],
    [
      "tour",
      0.13
    ],
    [
      "habilete",
      0.085
    ],
    [
      "truc",
      0.085
    ],
    [
      "sophisme",
      0.0425
    ],
    [
      "voltige",
      0.0425
    ],
    [
      "equilibre",
      0.0425
    ],
    [
      "pitrerie",
      0.0425
    ],
    [
      "gymnastique",
      0.0425
    ],
    [
      "expedient",
      0.0425
    ],
    [
      "agres",
      0.0425
    ],
    [
      "adresse",
      0.0425
    ],
    [
      "acrobatisme",
      0.0425
    ],
    [
      "equilibrisme",
      0.0425
    ]
  ],
  "cathedrale": [
    [
      "basilique",
      0.3325
    ],
    [
      "dome",
      0.165
    ],
    [
      "monument",
      0.165
    ],
    [
      "metropole",
      0.165
    ],
    [
      "eglise",
      0.165
    ]
  ],
  "oriental": [
    [
      "est",
      1.0
    ]
  ],
  "remonter": [
    [
      "revigorer",
      0.1
    ],
    [
      "reconforter",
      0.0675
    ],
    [
      "relever",
      0.065
    ],
    [
      "fortifier",
      0.0525
    ],
    [
      "ranimer",
      0.0525
    ],
    [
      "revivifier",
      0.035
    ],
    [
      "restaurer",
      0.035
    ],
    [
      "exalter",
      0.035
    ],
    [
      "augmenter",
      0.035
    ],
    [
      "soutenir",
      0.03
    ],
    [
      "retablir",
      0.0275
    ],
    [
      "raffermir",
      0.025
    ],
    [
      "retremper",
      0.025
    ],
    [
      "stimuler",
      0.02
    ],
    [
      "reparer",
      0.02
    ],
    [
      "remettre",
      0.02
    ],
    [
      "hausser",
      0.02
    ],
    [
      "ravigoter",
      0.02
    ],
    [
      "retaper",
      0.02
    ],
    [
      "elever",
      0.015
    ],
    [
      "soulever",
      0.015
    ],
    [
      "rehausser",
      0.015
    ],
    [
      "ragaillardir",
      0.015
    ],
    [
      "conforter",
      0.015
    ],
    [
      "monter",
      0.0125
    ],
    [
      "redresser",
      0.0125
    ],
    [
      "refaire",
      0.0125
    ],
    [
      "requinquer",
      0.01
    ],
    [
      "venir",
      0.0075
    ],
    [
      "tonifier",
      0.0075
    ],
    [
      "raviver",
      0.0075
    ],
    [
      "provenir",
      0.0075
    ],
    [
      "trousser",
      0.005
    ],
    [
      "suivre",
      0.005
    ],
    [
      "sortir",
      0.005
    ],
    [
      "revaloriser",
      0.005
    ],
    [
      "reprendre",
      0.005
    ],
    [
      "regonfler",
      0.005
    ],
    [
      "galvaniser",
      0.005
    ],
    [
      "consoler",
      0.005
    ],
    [
      "affermir",
      0.005
    ],
    [
      "refluer",
      0.0
    ],
    [
      "regrimper",
      0.0
    ],
    [
      "remboiter",
      0.0
    ],
    [
      "rencherir",
      0.0
    ],
    [
      "repousser",
      0.0
    ],
    [
      "retrousser",
      0.0
    ],
    [
      "reapprovisionner",
      0.0
    ],
    [
      "retrograder",
      0.0
    ],
    [
      "sustenter",
      0.0
    ],
    [
      "refleurir",
      0.0
    ],
    [
      "reconstituer",
      0.0
    ],
    [
      "aider",
      0.0
    ],
    [
      "ajuster",
      0.0
    ],
    [
      "dater",
      0.0
    ],
    [
      "exhausser",
      0.0
    ],
    [
      "partir",
      0.0
    ],
    [
      "proceder",
      0.0
    ],
    [
      "ramener",
      0.0
    ],
    [
      "rassembler",
      0.0
    ],
    [
      "electriser",
      0.0
    ]
  ],
  "accord": [
    [
      "harmonie",
      0.1
    ],
    [
      "union",
      0.065
    ],
    [
      "entente",
      0.04
    ],
    [
      "alliance",
      0.04
    ],
    [
      "convention",
      0.03
    ],
    [
      "convenance",
      0.0275
    ],
    [
      "traite",
      0.025
    ],
    [
      "rapport",
      0.025
    ],
    [
      "association",
      0.025
    ],
    [
      "conformite",
      0.0225
    ],
    [
      "fraternite",
      0.0225
    ],
    [
      "affinite",
      0.02
    ],
    [
      "correspondance",
      0.0175
    ],
    [
      "conciliation",
      0.0175
    ],
    [
      "arrangement",
      0.015
    ],
    [
      "communaute",
      0.015
    ],
    [
      "concordance",
      0.015
    ],
    [
      "unite",
      0.0125
    ],
    [
      "similitude",
      0.0125
    ],
    [
      "ensemble",
      0.0125
    ],
    [
      "communion",
      0.0125
    ],
    [
      "ajustement",
      0.0125
    ],
    [
      "accommodement",
      0.0125
    ],
    [
      "engagement",
      0.01
    ],
    [
      "compromis",
      0.01
    ],
    [
      "combinaison",
      0.01
    ],
    [
      "equilibre",
      0.01
    ],
    [
      "transaction",
      0.01
    ],
    [
      "ressemblance",
      0.01
    ],
    [
      "rapprochement",
      0.01
    ],
    [
      "proportion",
      0.01
    ],
    [
      "paix",
      0.01
    ],
    [
      "contrat",
      0.01
    ],
    [
      "consentement",
      0.01
    ],
    [
      "amitie",
      0.01
    ],
    [
      "agrement",
      0.01
    ],
    [
      "adherence",
      0.01
    ],
    [
      "sympathie",
      0.0075
    ],
    [
      "reunion",
      0.0075
    ],
    [
      "pacte",
      0.0075
    ],
    [
      "mesure",
      0.0075
    ],
    [
      "intelligence",
      0.0075
    ],
    [
      "assortiment",
      0.0075
    ],
    [
      "assentiment",
      0.0075
    ],
    [
      "approbation",
      0.0075
    ],
    [
      "rythme",
      0.005
    ],
    [
      "protocole",
      0.005
    ],
    [
      "mariage",
      0.005
    ],
    [
      "concert",
      0.005
    ],
    [
      "composition",
      0.005
    ],
    [
      "complicite",
      0.005
    ],
    [
      "analogie",
      0.005
    ],
    [
      "unanimite",
      0.0025
    ],
    [
      "ton",
      0.0025
    ],
    [
      "symetrie",
      0.0025
    ],
    [
      "reconciliation",
      0.0025
    ],
    [
      "permission",
      0.0025
    ],
    [
      "concorde",
      0.0025
    ],
    [
      "collusion",
      0.0025
    ],
    [
      "coherence",
      0.0025
    ],
    [
      "autorisation",
      0.0025
    ],
    [
      "appropriation",
      0.0025
    ],
    [
      "adhesion",
      0.0025
    ],
    [
      "adaptation",
      0.0025
    ],
    [
      "acquiescement",
      0.0025
    ],
    [
      "son",
      0.0025
    ],
    [
      "statut",
      0.0025
    ],
    [
      "stipulation",
      0.0025
    ],
    [
      "unisson",
      0.0025
    ],
    [
      "voix",
      0.0025
    ],
    [
      "reglement",
      0.0025
    ],
    [
      "marche",
      0.0025
    ],
    [
      "identite",
      0.0025
    ],
    [
      "adequation",
      0.0025
    ],
    [
      "appariement",
      0.0025
    ],
    [
      "cadence",
      0.0025
    ],
    [
      "connivence",
      0.0025
    ],
    [
      "eurythmie",
      0.0025
    ],
    [
      "corde",
      0.0
    ],
    [
      "couplage",
      0.0
    ],
    [
      "diapason",
      0.0
    ],
    [
      "interdependance",
      0.0
    ],
    [
      "obligation",
      0.0
    ],
    [
      "pendant",
      0.0
    ],
    [
      "pertinence",
      0.0
    ],
    [
      "raccommodement",
      0.0
    ],
    [
      "cooperation",
      0.0
    ],
    [
      "consensus",
      0.0
    ],
    [
      "congruite",
      0.0
    ],
    [
      "acceptation",
      0.0
    ],
    [
      "accompagnement",
      0.0
    ],
    [
      "accordage",
      0.0
    ],
    [
      "accordailles",
      0.0
    ],
    [
      "accordance",
      0.0
    ],
    [
      "adoption",
      0.0
    ],
    [
      "aveu",
      0.0
    ],
    [
      "caution",
      0.0
    ],
    [
      "compatibilite",
      0.0
    ],
    [
      "volontariat",
      0.0
    ]
  ],
  "grappin": [
    [
      "crampon",
      0.2
    ],
    [
      "harpon",
      0.2
    ],
    [
      "croc",
      0.1325
    ],
    [
      "harpeau",
      0.065
    ],
    [
      "crochet",
      0.065
    ],
    [
      "corbeau",
      0.065
    ],
    [
      "cigale",
      0.065
    ],
    [
      "chat",
      0.065
    ],
    [
      "ancre",
      0.065
    ],
    [
      "harpin",
      0.065
    ]
  ],
  "circulaire": [
    [
      "rotatif",
      0.22
    ],
    [
      "arrondi",
      0.11
    ],
    [
      "billet",
      0.11
    ],
    [
      "courbe",
      0.11
    ],
    [
      "giratoire",
      0.11
    ],
    [
      "instruction",
      0.11
    ],
    [
      "rond",
      0.11
    ],
    [
      "rotatoire",
      0.11
    ]
  ],
  "jugulaire": [
    [
      "attache",
      0.3
    ],
    [
      "bride",
      0.2
    ],
    [
      "buffleterie",
      0.2
    ],
    [
      "courroie",
      0.2
    ],
    [
      "mentonniere",
      0.1
    ]
  ],
  "kick": [],
  "esquive": [
    [
      "echappatoire",
      0.25
    ],
    [
      "derobade",
      0.165
    ],
    [
      "fuite",
      0.165
    ],
    [
      "subterfuge",
      0.165
    ],
    [
      "parade",
      0.0825
    ],
    [
      "pirouette",
      0.0825
    ],
    [
      "tergiversation",
      0.0825
    ]
  ],
  "esquiver": [
    [
      "eluder",
      0.1775
    ],
    [
      "eviter",
      0.1275
    ],
    [
      "echapper",
      0.1025
    ],
    [
      "detourner",
      0.075
    ],
    [
      "fuir",
      0.075
    ],
    [
      "tourner",
      0.05
    ],
    [
      "escamoter",
      0.05
    ],
    [
      "dejouer",
      0.025
    ],
    [
      "parer",
      0.025
    ],
    [
      "s'evader",
      0.025
    ]
  ],
  "uppercut": [
    [
      "crochet",
      1.0
    ]
  ],
  "tomahawk": [
    [
      "hache",
      1.0
    ]
  ],
  "branche": [
    [
      "rameau",
      0.0675
    ],
    [
      "bois",
      0.0575
    ],
    [
      "partie",
      0.0575
    ],
    [
      "ramure",
      0.0575
    ],
    [
      "division",
      0.045
    ],
    [
      "tige",
      0.0325
    ],
    [
      "ramification",
      0.0325
    ],
    [
      "race",
      0.0325
    ],
    [
      "pousse",
      0.0325
    ],
    [
      "lignee",
      0.0325
    ],
    [
      "brindille",
      0.0325
    ],
    [
      "brin",
      0.0325
    ],
    [
      "specialite",
      0.0225
    ],
    [
      "scion",
      0.0225
    ],
    [
      "rejeton",
      0.0225
    ],
    [
      "ramee",
      0.0225
    ],
    [
      "famille",
      0.0225
    ],
    [
      "corne",
      0.0225
    ],
    [
      "cor",
      0.0225
    ],
    [
      "branchage",
      0.0225
    ],
    [
      "palme",
      0.01
    ],
    [
      "nervure",
      0.01
    ],
    [
      "marre",
      0.01
    ],
    [
      "margotin",
      0.01
    ],
    [
      "maison",
      0.01
    ],
    [
      "pampre",
      0.01
    ],
    [
      "ramille",
      0.01
    ],
    [
      "rejet",
      0.01
    ],
    [
      "rouette",
      0.01
    ],
    [
      "section",
      0.01
    ],
    [
      "surgeon",
      0.01
    ],
    [
      "jambe",
      0.01
    ],
    [
      "gourmand",
      0.01
    ],
    [
      "fleche",
      0.01
    ],
    [
      "branchette",
      0.01
    ],
    [
      "bras",
      0.01
    ],
    [
      "brouture",
      0.01
    ],
    [
      "buche",
      0.01
    ],
    [
      "courcon",
      0.01
    ],
    [
      "crossette",
      0.01
    ],
    [
      "discipline",
      0.01
    ],
    [
      "departement",
      0.01
    ],
    [
      "embranchement",
      0.01
    ],
    [
      "ergot",
      0.01
    ],
    [
      "filiation",
      0.01
    ],
    [
      "ascendance",
      0.01
    ]
  ],
  "brancher": [
    [
      "joindre",
      0.2
    ],
    [
      "embrancher",
      0.1
    ],
    [
      "orienter",
      0.1
    ],
    [
      "pendiller",
      0.1
    ],
    [
      "pendre",
      0.1
    ],
    [
      "percher",
      0.1
    ],
    [
      "rattacher",
      0.1
    ],
    [
      "renseigner",
      0.1
    ]
  ],
  "animus": [],
  "slip": [
    [
      "calecon",
      0.3325
    ],
    [
      "culotte",
      0.3325
    ],
    [
      "maillot",
      0.165
    ]
  ],
  "canape": [
    [
      "sofa",
      0.3125
    ],
    [
      "siege",
      0.1375
    ],
    [
      "divan",
      0.0675
    ],
    [
      "lit",
      0.0675
    ],
    [
      "rotie",
      0.0325
    ],
    [
      "recamier",
      0.0325
    ],
    [
      "ottomane",
      0.0325
    ],
    [
      "meridienne",
      0.0325
    ],
    [
      "fauteuil",
      0.0325
    ],
    [
      "cosy",
      0.0325
    ],
    [
      "convertible",
      0.0325
    ],
    [
      "confident",
      0.0325
    ],
    [
      "causeuse",
      0.0325
    ],
    [
      "borne",
      0.0325
    ]
  ],
  "paquet": [
    [
      "ballot",
      0.0875
    ],
    [
      "groupe",
      0.0725
    ],
    [
      "balle",
      0.0575
    ],
    [
      "masse",
      0.0575
    ],
    [
      "tas",
      0.0575
    ],
    [
      "quantite",
      0.0425
    ],
    [
      "colis",
      0.0425
    ],
    [
      "barda",
      0.0425
    ],
    [
      "bagage",
      0.0425
    ],
    [
      "paquetage",
      0.0275
    ],
    [
      "monceau",
      0.0275
    ],
    [
      "gros",
      0.0275
    ],
    [
      "faisceau",
      0.0275
    ],
    [
      "empaquetage",
      0.0275
    ],
    [
      "bloc",
      0.0275
    ],
    [
      "attirail",
      0.0275
    ],
    [
      "pack",
      0.0125
    ],
    [
      "pacson",
      0.0125
    ],
    [
      "peloton",
      0.0125
    ],
    [
      "pile",
      0.0125
    ],
    [
      "poignee",
      0.0125
    ],
    [
      "quantum",
      0.0125
    ],
    [
      "reprimande",
      0.0125
    ],
    [
      "sachet",
      0.0125
    ],
    [
      "obese",
      0.0125
    ],
    [
      "lame",
      0.0125
    ],
    [
      "grappe",
      0.0125
    ],
    [
      "apostrophe",
      0.0125
    ],
    [
      "ballotin",
      0.0125
    ],
    [
      "balluchon",
      0.0125
    ],
    [
      "bouchon",
      0.0125
    ],
    [
      "courrier",
      0.0125
    ],
    [
      "envoi",
      0.0125
    ],
    [
      "excrement",
      0.0125
    ],
    [
      "fournee",
      0.0125
    ],
    [
      "tapon",
      0.0125
    ]
  ],
  "norme": [
    [
      "regle",
      0.195
    ],
    [
      "reglement",
      0.11
    ],
    [
      "loi",
      0.0825
    ],
    [
      "ordre",
      0.055
    ],
    [
      "prescription",
      0.055
    ],
    [
      "type",
      0.04
    ],
    [
      "theorie",
      0.04
    ],
    [
      "systeme",
      0.04
    ],
    [
      "precepte",
      0.04
    ],
    [
      "principe",
      0.04
    ],
    [
      "convention",
      0.04
    ],
    [
      "mesure",
      0.0275
    ],
    [
      "formule",
      0.0275
    ],
    [
      "coutume",
      0.0275
    ],
    [
      "code",
      0.0275
    ],
    [
      "canon",
      0.0275
    ],
    [
      "protocole",
      0.0125
    ],
    [
      "ordinaire",
      0.0125
    ],
    [
      "normale",
      0.0125
    ],
    [
      "ligne",
      0.0125
    ],
    [
      "cote",
      0.0125
    ],
    [
      "charte",
      0.0125
    ],
    [
      "arrete",
      0.0125
    ],
    [
      "standard",
      0.0125
    ]
  ],
  "clocher": [
    [
      "tour",
      0.25
    ],
    [
      "beffroi",
      0.125
    ],
    [
      "bulbe",
      0.125
    ],
    [
      "campanile",
      0.125
    ],
    [
      "clocheton",
      0.125
    ],
    [
      "fleche",
      0.125
    ],
    [
      "pays",
      0.125
    ]
  ],
  "mediter": [
    [
      "preparer",
      0.1025
    ],
    [
      "reflechir",
      0.1025
    ],
    [
      "penser",
      0.0875
    ],
    [
      "etudier",
      0.0725
    ],
    [
      "projeter",
      0.0575
    ],
    [
      "murir",
      0.0575
    ],
    [
      "combiner",
      0.0575
    ],
    [
      "premediter",
      0.05
    ],
    [
      "raisonner",
      0.0425
    ],
    [
      "elaborer",
      0.035
    ],
    [
      "ourdir",
      0.035
    ],
    [
      "calculer",
      0.0275
    ],
    [
      "mijoter",
      0.0275
    ],
    [
      "speculer",
      0.02
    ],
    [
      "tramer",
      0.02
    ],
    [
      "rever",
      0.0125
    ],
    [
      "songer",
      0.0125
    ],
    [
      "echafauder",
      0.0125
    ],
    [
      "ruminer",
      0.0125
    ],
    [
      "rouler",
      0.0125
    ],
    [
      "philosopher",
      0.0125
    ],
    [
      "deliberer",
      0.0125
    ],
    [
      "digerer",
      0.0125
    ],
    [
      "conspirer",
      0.0125
    ],
    [
      "s'arreter",
      0.005
    ],
    [
      "pourpenser",
      0.005
    ],
    [
      "converser",
      0.005
    ],
    [
      "contempler",
      0.005
    ],
    [
      "approfondir",
      0.005
    ]
  ],
  "longuement": [
    [
      "longtemps",
      0.2225
    ],
    [
      "minutieusement",
      0.1675
    ],
    [
      "beaucoup",
      0.11
    ],
    [
      "soigneusement",
      0.055
    ],
    [
      "scrupuleusement",
      0.055
    ],
    [
      "murement",
      0.055
    ],
    [
      "consciencieusement",
      0.055
    ],
    [
      "amplement",
      0.055
    ],
    [
      "abondamment",
      0.055
    ]
  ],
  "pompier": [
    [
      "emphatique",
      0.125
    ],
    [
      "souffle",
      0.125
    ],
    [
      "suranne",
      0.0625
    ],
    [
      "sentencieux",
      0.0625
    ],
    [
      "rococo",
      0.0625
    ],
    [
      "ringard",
      0.0625
    ],
    [
      "pipe",
      0.0625
    ],
    [
      "peintre",
      0.0625
    ],
    [
      "fontainier",
      0.0625
    ],
    [
      "boursoufle",
      0.0625
    ],
    [
      "barbouilleur",
      0.0625
    ],
    [
      "tailleur",
      0.0625
    ]
  ],
  "suicider": [],
  "tendu": [
    [
      "aller",
      0.055
    ],
    [
      "appliquer",
      0.0425
    ],
    [
      "passer",
      0.0425
    ],
    [
      "tirer",
      0.0425
    ],
    [
      "avancer",
      0.0375
    ],
    [
      "chercher",
      0.0375
    ],
    [
      "donner",
      0.0375
    ],
    [
      "tourner",
      0.03
    ],
    [
      "desirer",
      0.03
    ],
    [
      "allonger",
      0.03
    ],
    [
      "etendre",
      0.0225
    ],
    [
      "viser",
      0.0225
    ],
    [
      "s'efforcer",
      0.0225
    ],
    [
      "s'acheminer",
      0.0225
    ],
    [
      "marcher",
      0.0225
    ],
    [
      "courir",
      0.0225
    ],
    [
      "aspirer",
      0.0225
    ],
    [
      "raidir",
      0.0175
    ],
    [
      "preter",
      0.0175
    ],
    [
      "pretendre",
      0.0175
    ],
    [
      "poser",
      0.0175
    ],
    [
      "incliner",
      0.0175
    ],
    [
      "essayer",
      0.0175
    ],
    [
      "dresser",
      0.0175
    ],
    [
      "converger",
      0.0175
    ],
    [
      "concourir",
      0.0175
    ],
    [
      "bander",
      0.0175
    ],
    [
      "travailler",
      0.01
    ],
    [
      "s'attacher",
      0.01
    ],
    [
      "rallonger",
      0.01
    ],
    [
      "presenter",
      0.01
    ],
    [
      "offrir",
      0.01
    ],
    [
      "lancer",
      0.01
    ],
    [
      "disposer",
      0.01
    ],
    [
      "concentrer",
      0.01
    ],
    [
      "aboutir",
      0.01
    ],
    [
      "pencher",
      0.005
    ],
    [
      "pointer",
      0.005
    ],
    [
      "s'appliquer",
      0.005
    ],
    [
      "s'orienter",
      0.005
    ],
    [
      "tapisser",
      0.005
    ],
    [
      "tirailler",
      0.005
    ],
    [
      "ecarteler",
      0.005
    ],
    [
      "habiller",
      0.005
    ],
    [
      "graviter",
      0.005
    ],
    [
      "deployer",
      0.005
    ],
    [
      "distendre",
      0.005
    ],
    [
      "contribuer",
      0.005
    ],
    [
      "contracter",
      0.005
    ],
    [
      "conspirer",
      0.005
    ],
    [
      "confluer",
      0.005
    ],
    [
      "concorder",
      0.005
    ],
    [
      "etarquer",
      0.005
    ]
  ],
  "saut": [
    [
      "bond",
      0.1075
    ],
    [
      "soubresaut",
      0.0925
    ],
    [
      "cabriole",
      0.08
    ],
    [
      "chute",
      0.0675
    ],
    [
      "culbute",
      0.0675
    ],
    [
      "cascade",
      0.0525
    ],
    [
      "elan",
      0.04
    ],
    [
      "sursaut",
      0.04
    ],
    [
      "soulevement",
      0.04
    ],
    [
      "saillie",
      0.025
    ],
    [
      "ricochet",
      0.025
    ],
    [
      "pirouette",
      0.025
    ],
    [
      "passage",
      0.025
    ],
    [
      "pas",
      0.025
    ],
    [
      "gambade",
      0.025
    ],
    [
      "bondissement",
      0.025
    ],
    [
      "ruade",
      0.0125
    ],
    [
      "saute",
      0.0125
    ],
    [
      "sautillement",
      0.0125
    ],
    [
      "tour",
      0.0125
    ],
    [
      "tressaut",
      0.0125
    ],
    [
      "rebond",
      0.0125
    ],
    [
      "rapide",
      0.0125
    ],
    [
      "plongeon",
      0.0125
    ],
    [
      "monte",
      0.0125
    ],
    [
      "interruption",
      0.0125
    ],
    [
      "embardee",
      0.0125
    ],
    [
      "cataracte",
      0.0125
    ],
    [
      "cahot",
      0.0125
    ],
    [
      "alteration",
      0.0125
    ],
    [
      "voltige",
      0.0125
    ]
  ],
  "ange": [
    [
      "enfant",
      0.0925
    ],
    [
      "angelot",
      0.0675
    ],
    [
      "puissance",
      0.0675
    ],
    [
      "vertu",
      0.045
    ],
    [
      "putto",
      0.045
    ],
    [
      "protecteur",
      0.045
    ],
    [
      "inspirateur",
      0.045
    ],
    [
      "guide",
      0.045
    ],
    [
      "esprit",
      0.045
    ],
    [
      "amour",
      0.045
    ],
    [
      "messager",
      0.0225
    ],
    [
      "ministre",
      0.0225
    ],
    [
      "perfection",
      0.0225
    ],
    [
      "providence",
      0.0225
    ],
    [
      "soutien",
      0.0225
    ],
    [
      "seraphin",
      0.0225
    ],
    [
      "trone",
      0.0225
    ],
    [
      "mentor",
      0.0225
    ],
    [
      "instigateur",
      0.0225
    ],
    [
      "angelet",
      0.0225
    ],
    [
      "archange",
      0.0225
    ],
    [
      "biquet",
      0.0225
    ],
    [
      "cherubin",
      0.0225
    ],
    [
      "conseil",
      0.0225
    ],
    [
      "domination",
      0.0225
    ],
    [
      "exemple",
      0.0225
    ],
    [
      "genie",
      0.0225
    ],
    [
      "elu",
      0.0225
    ]
  ],
  "atterrir": [
    [
      "toucher",
      0.2225
    ],
    [
      "alunir",
      0.11
    ],
    [
      "apponter",
      0.11
    ],
    [
      "arriver",
      0.11
    ],
    [
      "assolir",
      0.11
    ],
    [
      "atterrer",
      0.11
    ],
    [
      "terrir",
      0.11
    ]
  ],
  "paille": [
    [
      "tige",
      0.2
    ],
    [
      "carton",
      0.0975
    ],
    [
      "chalumeau",
      0.0975
    ],
    [
      "chaume",
      0.0975
    ],
    [
      "chiffon",
      0.0975
    ],
    [
      "crapaud",
      0.0975
    ],
    [
      "defaut",
      0.0975
    ],
    [
      "fetu",
      0.0975
    ],
    [
      "paillette",
      0.0975
    ]
  ],
  "vetement": [
    [
      "accoutrement",
      0.0875
    ],
    [
      "habit",
      0.0875
    ],
    [
      "costume",
      0.075
    ],
    [
      "habillement",
      0.0625
    ],
    [
      "deguisement",
      0.05
    ],
    [
      "manteau",
      0.05
    ],
    [
      "mise",
      0.0375
    ],
    [
      "harnais",
      0.0375
    ],
    [
      "defroque",
      0.0375
    ],
    [
      "equipement",
      0.0225
    ],
    [
      "equipage",
      0.0225
    ],
    [
      "robe",
      0.0225
    ],
    [
      "masque",
      0.0225
    ],
    [
      "harnachement",
      0.0225
    ],
    [
      "harde",
      0.0225
    ],
    [
      "fringue",
      0.0225
    ],
    [
      "enveloppe",
      0.0225
    ],
    [
      "effet",
      0.0225
    ],
    [
      "ajustement",
      0.0225
    ],
    [
      "guenille",
      0.01
    ],
    [
      "haillon",
      0.01
    ],
    [
      "layette",
      0.01
    ],
    [
      "mode",
      0.01
    ],
    [
      "pelure",
      0.01
    ],
    [
      "souquenille",
      0.01
    ],
    [
      "survetement",
      0.01
    ],
    [
      "friperie",
      0.01
    ],
    [
      "fripe",
      0.01
    ],
    [
      "affublement",
      0.01
    ],
    [
      "complet",
      0.01
    ],
    [
      "costard",
      0.01
    ],
    [
      "dessous",
      0.01
    ],
    [
      "ensemble",
      0.01
    ],
    [
      "frac",
      0.01
    ],
    [
      "tailleur",
      0.01
    ]
  ],
  "boucler": [
    [
      "enfermer",
      0.16
    ],
    [
      "emprisonner",
      0.08
    ],
    [
      "cerner",
      0.0675
    ],
    [
      "entourer",
      0.0675
    ],
    [
      "renfermer",
      0.0675
    ],
    [
      "friser",
      0.055
    ],
    [
      "encercler",
      0.045
    ],
    [
      "serrer",
      0.0325
    ],
    [
      "investir",
      0.0325
    ],
    [
      "fermer",
      0.0325
    ],
    [
      "verrouiller",
      0.0225
    ],
    [
      "sequestrer",
      0.0225
    ],
    [
      "onduler",
      0.0225
    ],
    [
      "moutonner",
      0.0225
    ],
    [
      "coffrer",
      0.0225
    ],
    [
      "claquemurer",
      0.0225
    ],
    [
      "calamistrer",
      0.0225
    ],
    [
      "cadenasser",
      0.0225
    ],
    [
      "bichonner",
      0.0225
    ],
    [
      "anneler",
      0.0225
    ],
    [
      "incarcerer",
      0.01
    ],
    [
      "gonfler",
      0.01
    ],
    [
      "frisotter",
      0.01
    ],
    [
      "consommer",
      0.01
    ],
    [
      "confiner",
      0.01
    ],
    [
      "cloitrer",
      0.01
    ],
    [
      "attacher",
      0.01
    ],
    [
      "achever",
      0.01
    ],
    [
      "accomplir",
      0.01
    ],
    [
      "equilibrer",
      0.01
    ]
  ],
  "tatouage": [
    [
      "ferrade",
      1.0
    ]
  ],
  "flinguer": [
    [
      "tuer",
      0.5
    ],
    [
      "buter",
      0.25
    ],
    [
      "fusiller",
      0.25
    ]
  ],
  "flingue": [
    [
      "fusil",
      0.25
    ],
    [
      "pistolet",
      0.25
    ],
    [
      "calibre",
      0.125
    ],
    [
      "feu",
      0.125
    ],
    [
      "flingot",
      0.125
    ],
    [
      "petard",
      0.125
    ]
  ],
  "confrerie": [
    [
      "association",
      0.1875
    ],
    [
      "communaute",
      0.1875
    ],
    [
      "societe",
      0.1875
    ],
    [
      "congregation",
      0.125
    ],
    [
      "reunion",
      0.125
    ],
    [
      "corporation",
      0.0625
    ],
    [
      "corps",
      0.0625
    ],
    [
      "groupe",
      0.0625
    ]
  ],
  "menee": [
    [
      "conduire",
      0.14
    ],
    [
      "diriger",
      0.075
    ],
    [
      "gouverner",
      0.055
    ],
    [
      "entrainer",
      0.045
    ],
    [
      "pousser",
      0.0375
    ],
    [
      "transporter",
      0.0325
    ],
    [
      "regenter",
      0.0325
    ],
    [
      "manier",
      0.0325
    ],
    [
      "animer",
      0.0275
    ],
    [
      "guider",
      0.0275
    ],
    [
      "manoeuvrer",
      0.0275
    ],
    [
      "trainer",
      0.0275
    ],
    [
      "agir",
      0.025
    ],
    [
      "tenir",
      0.02
    ],
    [
      "inspirer",
      0.02
    ],
    [
      "emmener",
      0.02
    ],
    [
      "commander",
      0.02
    ],
    [
      "amener",
      0.02
    ],
    [
      "regir",
      0.015
    ],
    [
      "mettre",
      0.015
    ],
    [
      "influencer",
      0.015
    ],
    [
      "administrer",
      0.015
    ],
    [
      "traiter",
      0.0125
    ],
    [
      "presenter",
      0.0125
    ],
    [
      "promener",
      0.0125
    ],
    [
      "piloter",
      0.0125
    ],
    [
      "manipuler",
      0.0125
    ],
    [
      "dominer",
      0.0125
    ],
    [
      "avoir",
      0.0125
    ],
    [
      "tyranniser",
      0.0075
    ],
    [
      "traduire",
      0.0075
    ],
    [
      "suggestionner",
      0.0075
    ],
    [
      "remmener",
      0.0075
    ],
    [
      "remener",
      0.0075
    ],
    [
      "ramener",
      0.0075
    ],
    [
      "embarquer",
      0.0075
    ],
    [
      "conclure",
      0.0075
    ],
    [
      "charrier",
      0.0075
    ],
    [
      "aller",
      0.0075
    ],
    [
      "aboutir",
      0.0075
    ],
    [
      "trimballer",
      0.0025
    ],
    [
      "supporter",
      0.0025
    ],
    [
      "superviser",
      0.0025
    ],
    [
      "soutenir",
      0.0025
    ],
    [
      "manigancer",
      0.0025
    ],
    [
      "deboucher",
      0.0025
    ],
    [
      "commencer",
      0.0025
    ],
    [
      "vehiculer",
      0.0025
    ]
  ],
  "sein": [
    [
      "coeur",
      0.1475
    ],
    [
      "centre",
      0.09
    ],
    [
      "poitrine",
      0.0675
    ],
    [
      "interieur",
      0.0425
    ],
    [
      "mamelle",
      0.0425
    ],
    [
      "milieu",
      0.0425
    ],
    [
      "giron",
      0.0325
    ],
    [
      "fond",
      0.0325
    ],
    [
      "entrailles",
      0.0325
    ],
    [
      "ventre",
      0.02
    ],
    [
      "tetin",
      0.02
    ],
    [
      "point",
      0.02
    ],
    [
      "pis",
      0.02
    ],
    [
      "noeud",
      0.02
    ],
    [
      "nichon",
      0.02
    ],
    [
      "foyer",
      0.02
    ],
    [
      "nene",
      0.0075
    ],
    [
      "noyau",
      0.0075
    ],
    [
      "nombril",
      0.0075
    ],
    [
      "mitan",
      0.0075
    ],
    [
      "mandarine",
      0.0075
    ],
    [
      "robert",
      0.0075
    ],
    [
      "rondeur",
      0.0075
    ],
    [
      "trefonds",
      0.0075
    ],
    [
      "tetasse",
      0.0075
    ],
    [
      "tetine",
      0.0075
    ],
    [
      "teton",
      0.0075
    ],
    [
      "tete",
      0.0075
    ],
    [
      "uterus",
      0.0075
    ],
    [
      "mamelon",
      0.0075
    ],
    [
      "lolo",
      0.0075
    ],
    [
      "avantages",
      0.0075
    ],
    [
      "balcon",
      0.0075
    ],
    [
      "bossoir",
      0.0075
    ],
    [
      "bras",
      0.0075
    ],
    [
      "buste",
      0.0075
    ],
    [
      "counou",
      0.0075
    ],
    [
      "courbure",
      0.0075
    ],
    [
      "flanc",
      0.0075
    ],
    [
      "fort",
      0.0075
    ],
    [
      "glande",
      0.0075
    ],
    [
      "gorge",
      0.0075
    ],
    [
      "appas",
      0.0075
    ]
  ],
  "abondamment": [
    [
      "beaucoup",
      0.225
    ],
    [
      "copieusement",
      0.1025
    ],
    [
      "largement",
      0.0825
    ],
    [
      "amplement",
      0.06
    ],
    [
      "considerablement",
      0.04
    ],
    [
      "richement",
      0.0175
    ],
    [
      "profusement",
      0.0175
    ],
    [
      "plantureusement",
      0.0175
    ],
    [
      "longuement",
      0.0175
    ],
    [
      "liberalement",
      0.0175
    ],
    [
      "genereusement",
      0.0175
    ],
    [
      "fort",
      0.0175
    ]
  ],
  "bader": [
    [
      "bayer",
      0.25
    ],
    [
      "bigler",
      0.25
    ],
    [
      "flaner",
      0.25
    ],
    [
      "trainer",
      0.25
    ]
  ],
  "serie": [
    [
      "suite",
      0.17
    ],
    [
      "ribambelle",
      0.085
    ],
    [
      "chapelet",
      0.0725
    ],
    [
      "succession",
      0.0725
    ],
    [
      "kyrielle",
      0.06
    ],
    [
      "rang",
      0.0475
    ],
    [
      "quantite",
      0.035
    ],
    [
      "liste",
      0.035
    ],
    [
      "file",
      0.035
    ],
    [
      "cortege",
      0.035
    ],
    [
      "chaine",
      0.035
    ],
    [
      "cascade",
      0.035
    ],
    [
      "cours",
      0.0225
    ],
    [
      "collection",
      0.0225
    ],
    [
      "classe",
      0.0225
    ],
    [
      "categorie",
      0.0225
    ],
    [
      "tranche",
      0.01
    ],
    [
      "tirade",
      0.01
    ],
    [
      "sequence",
      0.01
    ],
    [
      "sequelle",
      0.01
    ],
    [
      "sorte",
      0.01
    ],
    [
      "repertoire",
      0.01
    ],
    [
      "qualification",
      0.01
    ],
    [
      "procession",
      0.01
    ],
    [
      "multitude",
      0.01
    ],
    [
      "cycle",
      0.01
    ],
    [
      "continuite",
      0.01
    ],
    [
      "clavier",
      0.01
    ],
    [
      "brochette",
      0.01
    ],
    [
      "echelle",
      0.01
    ]
  ],
  "signaler": [
    [
      "reveler",
      0.09
    ],
    [
      "indiquer",
      0.0775
    ],
    [
      "montrer",
      0.0675
    ],
    [
      "dire",
      0.0625
    ],
    [
      "annoncer",
      0.06
    ],
    [
      "declarer",
      0.0575
    ],
    [
      "signifier",
      0.045
    ],
    [
      "manifester",
      0.0325
    ],
    [
      "denoncer",
      0.0275
    ],
    [
      "marquer",
      0.0275
    ],
    [
      "apprendre",
      0.0225
    ],
    [
      "exposer",
      0.0225
    ],
    [
      "informer",
      0.02
    ],
    [
      "avertir",
      0.02
    ],
    [
      "communiquer",
      0.0175
    ],
    [
      "exprimer",
      0.0175
    ],
    [
      "publier",
      0.0175
    ],
    [
      "decouvrir",
      0.015
    ],
    [
      "temoigner",
      0.015
    ],
    [
      "designer",
      0.0125
    ],
    [
      "instruire",
      0.01
    ],
    [
      "denoter",
      0.01
    ],
    [
      "enseigner",
      0.01
    ],
    [
      "nommer",
      0.01
    ],
    [
      "notifier",
      0.01
    ],
    [
      "rapporter",
      0.0075
    ],
    [
      "devoiler",
      0.0075
    ],
    [
      "crier",
      0.0075
    ],
    [
      "affirmer",
      0.0075
    ],
    [
      "trahir",
      0.0075
    ],
    [
      "enoncer",
      0.0075
    ],
    [
      "citer",
      0.005
    ],
    [
      "proclamer",
      0.005
    ],
    [
      "souligner",
      0.005
    ],
    [
      "fixer",
      0.005
    ],
    [
      "accuser",
      0.005
    ],
    [
      "mentionner",
      0.0025
    ],
    [
      "enumerer",
      0.0025
    ],
    [
      "tracer",
      0.0025
    ],
    [
      "observer",
      0.0025
    ],
    [
      "deceler",
      0.0025
    ],
    [
      "caracteriser",
      0.0025
    ],
    [
      "particulariser",
      0.0
    ],
    [
      "detromper",
      0.0
    ],
    [
      "deposer",
      0.0
    ],
    [
      "decrire",
      0.0
    ],
    [
      "confier",
      0.0
    ],
    [
      "assurer",
      0.0
    ],
    [
      "appeler",
      0.0
    ],
    [
      "alerter",
      0.0
    ],
    [
      "baliser",
      0.0
    ],
    [
      "certifier",
      0.0
    ],
    [
      "materialiser",
      0.0
    ]
  ],
  "gilet": [
    [
      "chandail",
      0.22
    ],
    [
      "tricot",
      0.22
    ],
    [
      "brassiere",
      0.11
    ],
    [
      "camisole",
      0.11
    ],
    [
      "costume",
      0.11
    ],
    [
      "maillot",
      0.11
    ],
    [
      "sweater",
      0.11
    ]
  ],
  "balle": [
    [
      "bagage",
      0.0875
    ],
    [
      "ballot",
      0.0875
    ],
    [
      "barda",
      0.0875
    ],
    [
      "boule",
      0.065
    ],
    [
      "paquet",
      0.0425
    ],
    [
      "pruneau",
      0.03
    ],
    [
      "plomb",
      0.03
    ],
    [
      "colis",
      0.03
    ],
    [
      "attirail",
      0.03
    ],
    [
      "tete",
      0.02
    ],
    [
      "sac",
      0.02
    ],
    [
      "rond",
      0.02
    ],
    [
      "projectile",
      0.02
    ],
    [
      "figure",
      0.02
    ],
    [
      "faisceau",
      0.02
    ],
    [
      "enveloppe",
      0.02
    ],
    [
      "caisse",
      0.02
    ],
    [
      "boulette",
      0.02
    ],
    [
      "bouille",
      0.02
    ],
    [
      "bille",
      0.02
    ],
    [
      "pelote",
      0.01
    ],
    [
      "paquetage",
      0.01
    ],
    [
      "glumelle",
      0.01
    ],
    [
      "glume",
      0.01
    ],
    [
      "planche",
      0.01
    ],
    [
      "prune",
      0.01
    ],
    [
      "shrapnell",
      0.01
    ],
    [
      "son",
      0.01
    ],
    [
      "valda",
      0.01
    ],
    [
      "visage",
      0.01
    ],
    [
      "eteuf",
      0.01
    ],
    [
      "franc",
      0.01
    ],
    [
      "fourbi",
      0.01
    ],
    [
      "farde",
      0.01
    ],
    [
      "ballon",
      0.01
    ],
    [
      "balluchon",
      0.01
    ],
    [
      "bastos",
      0.01
    ],
    [
      "berlingot",
      0.01
    ],
    [
      "botte",
      0.01
    ],
    [
      "bulle",
      0.01
    ],
    [
      "cantine",
      0.01
    ],
    [
      "cartouche",
      0.01
    ],
    [
      "chevrotine",
      0.01
    ],
    [
      "cosse",
      0.01
    ],
    [
      "affaires",
      0.01
    ]
  ],
  "couteau": [
    [
      "poignard",
      0.085
    ],
    [
      "canif",
      0.0675
    ],
    [
      "bistouri",
      0.05
    ],
    [
      "dague",
      0.05
    ],
    [
      "lame",
      0.05
    ],
    [
      "surin",
      0.0325
    ],
    [
      "solen",
      0.0325
    ],
    [
      "schlass",
      0.0325
    ],
    [
      "opinel",
      0.0325
    ],
    [
      "hachoir",
      0.0325
    ],
    [
      "greffoir",
      0.0325
    ],
    [
      "allumelle",
      0.0325
    ],
    [
      "ratiche",
      0.015
    ],
    [
      "plioir",
      0.015
    ],
    [
      "plane",
      0.015
    ],
    [
      "navaja",
      0.015
    ],
    [
      "lancette",
      0.015
    ],
    [
      "saignoir",
      0.015
    ],
    [
      "scalpel",
      0.015
    ],
    [
      "scramasaxe",
      0.015
    ],
    [
      "tranchelard",
      0.015
    ],
    [
      "tranchoir",
      0.015
    ],
    [
      "truelle",
      0.015
    ],
    [
      "ecussonnoir",
      0.015
    ],
    [
      "epluchoir",
      0.015
    ],
    [
      "laguiole",
      0.015
    ],
    [
      "jambette",
      0.015
    ],
    [
      "coquillage",
      0.015
    ],
    [
      "couperet",
      0.015
    ],
    [
      "coutelas",
      0.015
    ],
    [
      "coutelier",
      0.015
    ],
    [
      "drayoir",
      0.015
    ],
    [
      "depecoir",
      0.015
    ],
    [
      "desoperculateur",
      0.015
    ],
    [
      "entoir",
      0.015
    ],
    [
      "eustache",
      0.015
    ],
    [
      "fer",
      0.015
    ],
    [
      "amassette",
      0.015
    ]
  ],
  "vivant": [
    [
      "vif",
      0.1125
    ],
    [
      "actif",
      0.0675
    ],
    [
      "fort",
      0.0675
    ],
    [
      "energique",
      0.0425
    ],
    [
      "fringant",
      0.0425
    ],
    [
      "expressif",
      0.0425
    ],
    [
      "anime",
      0.0425
    ],
    [
      "vigoureux",
      0.0325
    ],
    [
      "vivace",
      0.0325
    ],
    [
      "eveille",
      0.0325
    ],
    [
      "resistant",
      0.025
    ],
    [
      "remuant",
      0.025
    ],
    [
      "dynamique",
      0.025
    ],
    [
      "durable",
      0.025
    ],
    [
      "colore",
      0.025
    ],
    [
      "ardent",
      0.025
    ],
    [
      "turbulent",
      0.015
    ],
    [
      "trempe",
      0.015
    ],
    [
      "tenace",
      0.015
    ],
    [
      "semillant",
      0.015
    ],
    [
      "present",
      0.015
    ],
    [
      "parlant",
      0.015
    ],
    [
      "frequente",
      0.015
    ],
    [
      "debordant",
      0.015
    ],
    [
      "peuple",
      0.0075
    ],
    [
      "pittoresque",
      0.0075
    ],
    [
      "ranime",
      0.0075
    ],
    [
      "ressemblant",
      0.0075
    ],
    [
      "ressuscite",
      0.0075
    ],
    [
      "sauve",
      0.0075
    ],
    [
      "survivant",
      0.0075
    ],
    [
      "valide",
      0.0075
    ],
    [
      "viable",
      0.0075
    ],
    [
      "passant",
      0.0075
    ],
    [
      "organise",
      0.0075
    ],
    [
      "agissant",
      0.0075
    ],
    [
      "biologique",
      0.0075
    ],
    [
      "debout",
      0.0075
    ],
    [
      "demeurant",
      0.0075
    ],
    [
      "engendre",
      0.0075
    ],
    [
      "existant",
      0.0075
    ],
    [
      "mouvemente",
      0.0075
    ],
    [
      "vital",
      0.0075
    ]
  ],
  "fesser": [
    [
      "battre",
      0.25
    ],
    [
      "fustiger",
      0.155
    ],
    [
      "frapper",
      0.125
    ],
    [
      "chatier",
      0.0925
    ],
    [
      "corriger",
      0.0925
    ],
    [
      "taper",
      0.0625
    ],
    [
      "fouetter",
      0.0625
    ],
    [
      "flageller",
      0.0625
    ],
    [
      "bastonner",
      0.03
    ],
    [
      "botter",
      0.03
    ],
    [
      "punir",
      0.03
    ]
  ],
  "fesse": [
    [
      "derriere",
      0.1725
    ],
    [
      "cul",
      0.16
    ],
    [
      "fessier",
      0.16
    ],
    [
      "posterieur",
      0.0725
    ],
    [
      "croupe",
      0.0475
    ],
    [
      "petard",
      0.0225
    ],
    [
      "popotin",
      0.0225
    ],
    [
      "fondement",
      0.0225
    ],
    [
      "croupion",
      0.0225
    ],
    [
      "meule",
      0.01
    ],
    [
      "miche",
      0.01
    ],
    [
      "mouille",
      0.01
    ],
    [
      "noix",
      0.01
    ],
    [
      "panier",
      0.01
    ],
    [
      "postere",
      0.01
    ],
    [
      "prose",
      0.01
    ],
    [
      "siege",
      0.01
    ],
    [
      "lune",
      0.01
    ],
    [
      "joufflu",
      0.01
    ],
    [
      "hanche",
      0.01
    ],
    [
      "baba",
      0.01
    ],
    [
      "cuisse",
      0.01
    ],
    [
      "dargeot",
      0.01
    ],
    [
      "derche",
      0.01
    ],
    [
      "fion",
      0.01
    ],
    [
      "fouettard",
      0.01
    ],
    [
      "seant",
      0.01
    ]
  ],
  "test": [
    [
      "carapace",
      0.1475
    ],
    [
      "essai",
      0.11
    ],
    [
      "epreuve",
      0.11
    ],
    [
      "verification",
      0.0725
    ],
    [
      "habitacle",
      0.0725
    ],
    [
      "experience",
      0.0725
    ],
    [
      "examen",
      0.0725
    ],
    [
      "enveloppe",
      0.0725
    ],
    [
      "cuirasse",
      0.0725
    ],
    [
      "coquille",
      0.0725
    ],
    [
      "audition",
      0.035
    ],
    [
      "experimentation",
      0.035
    ],
    [
      "questionnaire",
      0.035
    ]
  ],
  "plaquette": [
    [
      "fascicule",
      0.165
    ],
    [
      "livraison",
      0.165
    ],
    [
      "livre",
      0.165
    ],
    [
      "recueil",
      0.165
    ],
    [
      "brochure",
      0.0825
    ],
    [
      "lame",
      0.0825
    ],
    [
      "livret",
      0.0825
    ],
    [
      "revue",
      0.0825
    ]
  ],
  "claquette": [
    [
      "babiller",
      0.5
    ],
    [
      "craqueter",
      0.5
    ]
  ],
  "trahi": [
    [
      "reveler",
      0.1325
    ],
    [
      "montrer",
      0.0975
    ],
    [
      "indiquer",
      0.09
    ],
    [
      "denoncer",
      0.065
    ],
    [
      "devoiler",
      0.0475
    ],
    [
      "livrer",
      0.04
    ],
    [
      "manifester",
      0.0325
    ],
    [
      "dire",
      0.0275
    ],
    [
      "donner",
      0.0275
    ],
    [
      "signaler",
      0.0275
    ],
    [
      "prouver",
      0.0225
    ],
    [
      "decouvrir",
      0.0225
    ],
    [
      "deceler",
      0.02
    ],
    [
      "expliquer",
      0.02
    ],
    [
      "marquer",
      0.02
    ],
    [
      "tromper",
      0.02
    ],
    [
      "temoigner",
      0.015
    ],
    [
      "demontrer",
      0.015
    ],
    [
      "violer",
      0.01
    ],
    [
      "rompre",
      0.01
    ],
    [
      "renier",
      0.01
    ],
    [
      "lacher",
      0.01
    ],
    [
      "denoter",
      0.01
    ],
    [
      "demasquer",
      0.01
    ],
    [
      "accuser",
      0.01
    ],
    [
      "abuser",
      0.01
    ],
    [
      "vendre",
      0.0075
    ],
    [
      "traduire",
      0.0075
    ],
    [
      "peindre",
      0.0075
    ],
    [
      "mentir",
      0.0075
    ],
    [
      "manquer",
      0.0075
    ],
    [
      "fausser",
      0.0075
    ],
    [
      "decevoir",
      0.0075
    ],
    [
      "bruler",
      0.0075
    ],
    [
      "berner",
      0.0075
    ],
    [
      "sentir",
      0.0025
    ],
    [
      "liberer",
      0.0025
    ],
    [
      "frustrer",
      0.0025
    ],
    [
      "deserter",
      0.0025
    ],
    [
      "denaturer",
      0.0025
    ],
    [
      "deformer",
      0.0025
    ],
    [
      "divulguer",
      0.0025
    ],
    [
      "corrompre",
      0.0025
    ],
    [
      "cocufier",
      0.0025
    ]
  ],
  "trahir": [
    [
      "reveler",
      0.1325
    ],
    [
      "montrer",
      0.0975
    ],
    [
      "indiquer",
      0.09
    ],
    [
      "denoncer",
      0.065
    ],
    [
      "devoiler",
      0.0475
    ],
    [
      "livrer",
      0.04
    ],
    [
      "manifester",
      0.0325
    ],
    [
      "dire",
      0.0275
    ],
    [
      "donner",
      0.0275
    ],
    [
      "signaler",
      0.0275
    ],
    [
      "prouver",
      0.0225
    ],
    [
      "decouvrir",
      0.0225
    ],
    [
      "deceler",
      0.02
    ],
    [
      "expliquer",
      0.02
    ],
    [
      "marquer",
      0.02
    ],
    [
      "tromper",
      0.02
    ],
    [
      "temoigner",
      0.015
    ],
    [
      "demontrer",
      0.015
    ],
    [
      "violer",
      0.01
    ],
    [
      "rompre",
      0.01
    ],
    [
      "renier",
      0.01
    ],
    [
      "lacher",
      0.01
    ],
    [
      "denoter",
      0.01
    ],
    [
      "demasquer",
      0.01
    ],
    [
      "accuser",
      0.01
    ],
    [
      "abuser",
      0.01
    ],
    [
      "vendre",
      0.0075
    ],
    [
      "traduire",
      0.0075
    ],
    [
      "peindre",
      0.0075
    ],
    [
      "mentir",
      0.0075
    ],
    [
      "manquer",
      0.0075
    ],
    [
      "fausser",
      0.0075
    ],
    [
      "decevoir",
      0.0075
    ],
    [
      "bruler",
      0.0075
    ],
    [
      "berner",
      0.0075
    ],
    [
      "sentir",
      0.0025
    ],
    [
      "liberer",
      0.0025
    ],
    [
      "frustrer",
      0.0025
    ],
    [
      "deserter",
      0.0025
    ],
    [
      "denaturer",
      0.0025
    ],
    [
      "deformer",
      0.0025
    ],
    [
      "divulguer",
      0.0025
    ],
    [
      "corrompre",
      0.0025
    ],
    [
      "cocufier",
      0.0025
    ]
  ],
  "cabrer": [
    [
      "braquer",
      0.125
    ],
    [
      "revolter",
      0.125
    ],
    [
      "facher",
      0.125
    ],
    [
      "dresser",
      0.125
    ],
    [
      "choquer",
      0.125
    ],
    [
      "buter",
      0.125
    ],
    [
      "irriter",
      0.0625
    ],
    [
      "raidir",
      0.0625
    ],
    [
      "redresser",
      0.0625
    ]
  ],
  "cacheter": [
    [
      "fermer",
      0.1475
    ],
    [
      "timbrer",
      0.1
    ],
    [
      "tamponner",
      0.1
    ],
    [
      "sceller",
      0.1
    ],
    [
      "marquer",
      0.1
    ],
    [
      "estampiller",
      0.1
    ],
    [
      "capsuler",
      0.1
    ],
    [
      "clore",
      0.0475
    ],
    [
      "coller",
      0.0475
    ],
    [
      "obliterer",
      0.0475
    ],
    [
      "plomber",
      0.0475
    ],
    [
      "poinconner",
      0.0475
    ]
  ],
  "cachette": [
    [
      "fermer",
      0.1475
    ],
    [
      "timbrer",
      0.1
    ],
    [
      "tamponner",
      0.1
    ],
    [
      "sceller",
      0.1
    ],
    [
      "marquer",
      0.1
    ],
    [
      "estampiller",
      0.1
    ],
    [
      "capsuler",
      0.1
    ],
    [
      "clore",
      0.0475
    ],
    [
      "coller",
      0.0475
    ],
    [
      "obliterer",
      0.0475
    ],
    [
      "plomber",
      0.0475
    ],
    [
      "poinconner",
      0.0475
    ]
  ],
  "cassette": [
    [
      "boite",
      0.1575
    ],
    [
      "cagnotte",
      0.1575
    ],
    [
      "bourse",
      0.1025
    ],
    [
      "coffret",
      0.1025
    ],
    [
      "videocassette",
      0.05
    ],
    [
      "tresor",
      0.05
    ],
    [
      "tirelire",
      0.05
    ],
    [
      "reserve",
      0.05
    ],
    [
      "magnetocassette",
      0.05
    ],
    [
      "coffre",
      0.05
    ],
    [
      "aumoniere",
      0.05
    ],
    [
      "ecrin",
      0.05
    ]
  ],
  "coffrer": [
    [
      "emprisonner",
      0.285
    ],
    [
      "enfermer",
      0.105
    ],
    [
      "incarcerer",
      0.105
    ],
    [
      "interner",
      0.105
    ],
    [
      "ecrouer",
      0.07
    ],
    [
      "renfermer",
      0.07
    ],
    [
      "boucler",
      0.07
    ],
    [
      "arreter",
      0.07
    ],
    [
      "claquemurer",
      0.035
    ]
  ],
  "plie": [
    [
      "carrelet",
      0.5
    ],
    [
      "sole",
      0.5
    ]
  ],
  "team": [],
  "imiter": [
    [
      "copier",
      0.1075
    ],
    [
      "singer",
      0.0975
    ],
    [
      "reproduire",
      0.095
    ],
    [
      "plagier",
      0.065
    ],
    [
      "simuler",
      0.06
    ],
    [
      "contrefaire",
      0.05
    ],
    [
      "emprunter",
      0.0425
    ],
    [
      "faire",
      0.035
    ],
    [
      "calquer",
      0.035
    ],
    [
      "jouer",
      0.0275
    ],
    [
      "suivre",
      0.0275
    ],
    [
      "demarquer",
      0.0225
    ],
    [
      "pasticher",
      0.0225
    ],
    [
      "representer",
      0.0175
    ],
    [
      "mimer",
      0.0175
    ],
    [
      "derober",
      0.0175
    ],
    [
      "adopter",
      0.0175
    ],
    [
      "repeter",
      0.0125
    ],
    [
      "ressembler",
      0.0125
    ],
    [
      "piller",
      0.0125
    ],
    [
      "parodier",
      0.0125
    ],
    [
      "sembler",
      0.0075
    ],
    [
      "rappeler",
      0.0075
    ],
    [
      "picorer",
      0.0075
    ],
    [
      "habituer",
      0.0075
    ],
    [
      "figurer",
      0.0075
    ],
    [
      "conformer",
      0.0075
    ],
    [
      "composer",
      0.0075
    ],
    [
      "charger",
      0.0075
    ],
    [
      "caricaturer",
      0.0075
    ],
    [
      "attraper",
      0.0075
    ],
    [
      "adapter",
      0.0075
    ],
    [
      "s'inspirer",
      0.0025
    ],
    [
      "transcrire",
      0.0025
    ],
    [
      "transmettre",
      0.0025
    ],
    [
      "pirater",
      0.0025
    ],
    [
      "feindre",
      0.0025
    ],
    [
      "embrasser",
      0.0025
    ],
    [
      "emboiter",
      0.0025
    ],
    [
      "decalquer",
      0.0025
    ],
    [
      "compiler",
      0.0025
    ],
    [
      "epouser",
      0.0025
    ]
  ],
  "mimi": [
    [
      "mignon",
      0.1675
    ],
    [
      "minet",
      0.11
    ],
    [
      "joli",
      0.11
    ],
    [
      "gentil",
      0.11
    ],
    [
      "chat",
      0.11
    ],
    [
      "biquet",
      0.11
    ],
    [
      "adorable",
      0.055
    ],
    [
      "croquignolet",
      0.055
    ],
    [
      "mignonnet",
      0.055
    ],
    [
      "minon",
      0.055
    ]
  ],
  "blafard": [
    [
      "bleme",
      0.1725
    ],
    [
      "livide",
      0.1325
    ],
    [
      "pale",
      0.1325
    ],
    [
      "terreux",
      0.075
    ],
    [
      "plombe",
      0.0575
    ],
    [
      "terne",
      0.0575
    ],
    [
      "vitreux",
      0.0375
    ],
    [
      "verdatre",
      0.0375
    ],
    [
      "mat",
      0.0375
    ],
    [
      "decolore",
      0.0375
    ],
    [
      "cireux",
      0.0375
    ],
    [
      "have",
      0.0175
    ],
    [
      "glauque",
      0.0175
    ],
    [
      "fade",
      0.0175
    ],
    [
      "exsangue",
      0.0175
    ],
    [
      "crepusculaire",
      0.0175
    ],
    [
      "blemissant",
      0.0175
    ],
    [
      "blanchatre",
      0.0175
    ],
    [
      "blanc",
      0.0175
    ],
    [
      "poussiereux",
      0.0175
    ]
  ],
  "mordre": [
    [
      "ronger",
      0.065
    ],
    [
      "attaquer",
      0.0475
    ],
    [
      "corroder",
      0.0475
    ],
    [
      "detruire",
      0.0475
    ],
    [
      "entamer",
      0.0475
    ],
    [
      "prendre",
      0.04
    ],
    [
      "dechirer",
      0.04
    ],
    [
      "broyer",
      0.035
    ],
    [
      "manger",
      0.035
    ],
    [
      "piquer",
      0.0275
    ],
    [
      "miner",
      0.0275
    ],
    [
      "empieter",
      0.0275
    ],
    [
      "user",
      0.0225
    ],
    [
      "triturer",
      0.0225
    ],
    [
      "tourmenter",
      0.0225
    ],
    [
      "presser",
      0.0225
    ],
    [
      "pincer",
      0.0225
    ],
    [
      "envahir",
      0.0225
    ],
    [
      "depasser",
      0.0225
    ],
    [
      "deborder",
      0.0225
    ],
    [
      "blesser",
      0.0225
    ],
    [
      "ereinter",
      0.0175
    ],
    [
      "penetrer",
      0.0175
    ],
    [
      "macher",
      0.0175
    ],
    [
      "critiquer",
      0.0175
    ],
    [
      "comprendre",
      0.0175
    ],
    [
      "serrer",
      0.01
    ],
    [
      "saper",
      0.01
    ],
    [
      "outrepasser",
      0.01
    ],
    [
      "machonner",
      0.01
    ],
    [
      "esquinter",
      0.01
    ],
    [
      "demolir",
      0.01
    ],
    [
      "dechiqueter",
      0.01
    ],
    [
      "croquer",
      0.01
    ],
    [
      "chevaucher",
      0.01
    ],
    [
      "avancer",
      0.01
    ],
    [
      "aimer",
      0.01
    ],
    [
      "mordiller",
      0.005
    ],
    [
      "ressortir",
      0.005
    ],
    [
      "s'enfoncer",
      0.005
    ],
    [
      "lacerer",
      0.005
    ],
    [
      "inquieter",
      0.005
    ],
    [
      "fustiger",
      0.005
    ],
    [
      "fouailler",
      0.005
    ],
    [
      "dissoudre",
      0.005
    ],
    [
      "dilacerer",
      0.005
    ]
  ],
  "aboyer": [
    [
      "crier",
      0.2275
    ],
    [
      "hurler",
      0.135
    ],
    [
      "chanter",
      0.09
    ],
    [
      "clabauder",
      0.09
    ],
    [
      "glapir",
      0.09
    ],
    [
      "japper",
      0.09
    ],
    [
      "poursuivre",
      0.045
    ],
    [
      "injurier",
      0.045
    ],
    [
      "importuner",
      0.045
    ],
    [
      "gueuler",
      0.045
    ],
    [
      "braire",
      0.045
    ],
    [
      "reclamer",
      0.045
    ]
  ],
  "grenade": [
    [
      "balauste",
      0.5
    ],
    [
      "bombe",
      0.5
    ]
  ],
  "madone": [
    [
      "Vierge",
      1.0
    ]
  ],
  "frissonner": [
    [
      "trembler",
      0.1975
    ],
    [
      "fremir",
      0.125
    ],
    [
      "grelotter",
      0.07
    ],
    [
      "vaciller",
      0.0525
    ],
    [
      "tremuler",
      0.0525
    ],
    [
      "s'agiter",
      0.0525
    ],
    [
      "remuer",
      0.0525
    ],
    [
      "onduler",
      0.0525
    ],
    [
      "vibrer",
      0.035
    ],
    [
      "tressaillir",
      0.035
    ],
    [
      "trembloter",
      0.035
    ],
    [
      "clignoter",
      0.035
    ],
    [
      "bouillir",
      0.035
    ],
    [
      "scintiller",
      0.015
    ],
    [
      "panteler",
      0.015
    ],
    [
      "friser",
      0.015
    ],
    [
      "cuire",
      0.015
    ],
    [
      "bruire",
      0.015
    ]
  ],
  "vorace": [
    [
      "insatiable",
      0.175
    ],
    [
      "avide",
      0.15
    ],
    [
      "glouton",
      0.1
    ],
    [
      "affame",
      0.075
    ],
    [
      "goulu",
      0.075
    ],
    [
      "inassouvi",
      0.075
    ],
    [
      "rapace",
      0.05
    ],
    [
      "inapaise",
      0.05
    ],
    [
      "gourmand",
      0.05
    ],
    [
      "goinfre",
      0.05
    ],
    [
      "boulimique",
      0.025
    ],
    [
      "carnassier",
      0.025
    ],
    [
      "devorant",
      0.025
    ],
    [
      "irrassasie",
      0.025
    ],
    [
      "safre",
      0.025
    ],
    [
      "apre",
      0.025
    ]
  ],
  "rager": [
    [
      "fumer",
      0.245
    ],
    [
      "ronchonner",
      0.1575
    ],
    [
      "raler",
      0.1225
    ],
    [
      "rouspeter",
      0.0525
    ],
    [
      "pester",
      0.0525
    ],
    [
      "enrager",
      0.0525
    ],
    [
      "bisquer",
      0.0525
    ],
    [
      "ecumer",
      0.0325
    ],
    [
      "tempeter",
      0.0325
    ],
    [
      "rogner",
      0.0325
    ],
    [
      "maronner",
      0.0325
    ],
    [
      "endever",
      0.015
    ]
  ],
  "rage": [
    [
      "fureur",
      0.15
    ],
    [
      "frenesie",
      0.1425
    ],
    [
      "passion",
      0.0925
    ],
    [
      "manie",
      0.075
    ],
    [
      "emportement",
      0.055
    ],
    [
      "furie",
      0.045
    ],
    [
      "fievre",
      0.045
    ],
    [
      "delire",
      0.045
    ],
    [
      "folie",
      0.0375
    ],
    [
      "impetuosite",
      0.0375
    ],
    [
      "transport",
      0.0375
    ],
    [
      "travers",
      0.0275
    ],
    [
      "tic",
      0.0275
    ],
    [
      "marotte",
      0.0275
    ],
    [
      "maladie",
      0.0275
    ],
    [
      "acharnement",
      0.0175
    ],
    [
      "colere",
      0.0175
    ],
    [
      "souffrance",
      0.0075
    ],
    [
      "paroxysme",
      0.0075
    ],
    [
      "ouragan",
      0.0075
    ],
    [
      "incendie",
      0.0075
    ],
    [
      "hydrophobie",
      0.0075
    ],
    [
      "ferocite",
      0.0075
    ],
    [
      "exasperation",
      0.0075
    ],
    [
      "aprete",
      0.0075
    ]
  ],
  "soupconner": [
    [
      "conjecturer",
      0.1
    ],
    [
      "penser",
      0.1
    ],
    [
      "pressentir",
      0.1
    ],
    [
      "deviner",
      0.085
    ],
    [
      "imaginer",
      0.085
    ],
    [
      "supposer",
      0.0675
    ],
    [
      "subodorer",
      0.05
    ],
    [
      "presumer",
      0.05
    ],
    [
      "croire",
      0.05
    ],
    [
      "douter",
      0.0325
    ],
    [
      "flairer",
      0.0325
    ],
    [
      "sentir",
      0.015
    ],
    [
      "redouter",
      0.015
    ],
    [
      "entrevoir",
      0.015
    ],
    [
      "suspecter",
      0.015
    ]
  ],
  "sel": [
    [
      "piquant",
      0.2125
    ],
    [
      "esprit",
      0.1425
    ],
    [
      "finesse",
      0.1425
    ],
    [
      "humour",
      0.1425
    ],
    [
      "piment",
      0.1425
    ],
    [
      "assaisonnement",
      0.07
    ],
    [
      "gaiete",
      0.07
    ],
    [
      "saveur",
      0.07
    ]
  ],
  "dessus": [
    [
      "avantage",
      0.1
    ],
    [
      "sur",
      0.1
    ],
    [
      "superiorite",
      0.1
    ],
    [
      "sommet",
      0.1
    ],
    [
      "predominance",
      0.1
    ],
    [
      "napperon",
      0.1
    ],
    [
      "haut",
      0.1
    ],
    [
      "endroit",
      0.1
    ],
    [
      "sus",
      0.1
    ]
  ],
  "dentelle": [
    [
      "decouper",
      0.285
    ],
    [
      "tailler",
      0.285
    ],
    [
      "bretteler",
      0.1425
    ],
    [
      "creneler",
      0.1425
    ],
    [
      "festonner",
      0.1425
    ]
  ],
  "cle": [],
  "different": [
    [
      "separe",
      0.0925
    ],
    [
      "dissemblable",
      0.0725
    ],
    [
      "oppose",
      0.0625
    ],
    [
      "distinct",
      0.05
    ],
    [
      "heterogene",
      0.05
    ],
    [
      "varie",
      0.05
    ],
    [
      "disparate",
      0.04
    ],
    [
      "discordant",
      0.04
    ],
    [
      "autre",
      0.04
    ],
    [
      "etranger",
      0.03
    ],
    [
      "eloigne",
      0.03
    ],
    [
      "singulier",
      0.03
    ],
    [
      "nouveau",
      0.03
    ],
    [
      "inegal",
      0.03
    ],
    [
      "divergent",
      0.03
    ],
    [
      "change",
      0.03
    ],
    [
      "transforme",
      0.02
    ],
    [
      "original",
      0.02
    ],
    [
      "modifie",
      0.02
    ],
    [
      "inhabituel",
      0.02
    ],
    [
      "heteroclite",
      0.02
    ],
    [
      "disproportionne",
      0.02
    ],
    [
      "contraire",
      0.02
    ],
    [
      "contradictoire",
      0.02
    ],
    [
      "variable",
      0.01
    ],
    [
      "tranche",
      0.01
    ],
    [
      "neuf",
      0.01
    ],
    [
      "meconnaissable",
      0.01
    ],
    [
      "mysterieux",
      0.01
    ],
    [
      "multiple",
      0.01
    ],
    [
      "inassimilable",
      0.01
    ],
    [
      "distant",
      0.01
    ],
    [
      "disjoint",
      0.01
    ],
    [
      "deux",
      0.01
    ]
  ],
  "veine": [
    [
      "chance",
      0.1275
    ],
    [
      "bonheur",
      0.095
    ],
    [
      "verve",
      0.0625
    ],
    [
      "prosperite",
      0.0625
    ],
    [
      "pot",
      0.0625
    ],
    [
      "inspiration",
      0.0625
    ],
    [
      "filon",
      0.0625
    ],
    [
      "bol",
      0.0625
    ],
    [
      "vaisseau",
      0.03
    ],
    [
      "souffle",
      0.03
    ],
    [
      "reussite",
      0.03
    ],
    [
      "humeur",
      0.03
    ],
    [
      "hasard",
      0.03
    ],
    [
      "gite",
      0.03
    ],
    [
      "gisement",
      0.03
    ],
    [
      "delit",
      0.03
    ],
    [
      "cul",
      0.03
    ],
    [
      "benediction",
      0.03
    ],
    [
      "baraka",
      0.03
    ],
    [
      "veinure",
      0.03
    ]
  ],
  "incandescent": [
    [
      "ardent",
      0.2075
    ],
    [
      "brulant",
      0.125
    ],
    [
      "etincelant",
      0.0825
    ],
    [
      "lumineux",
      0.0825
    ],
    [
      "flambant",
      0.0825
    ],
    [
      "embrase",
      0.0825
    ],
    [
      "chaud",
      0.0825
    ],
    [
      "bouillonnant",
      0.04
    ],
    [
      "igne",
      0.04
    ],
    [
      "rouge",
      0.04
    ],
    [
      "rougeoyant",
      0.04
    ],
    [
      "torride",
      0.04
    ],
    [
      "eblouissant",
      0.04
    ]
  ],
  "minuter": [
    [
      "calculer",
      0.3325
    ],
    [
      "organiser",
      0.3325
    ],
    [
      "ecrire",
      0.3325
    ]
  ],
  "minute": [
    [
      "instant",
      0.1525
    ],
    [
      "moment",
      0.1525
    ],
    [
      "original",
      0.1525
    ],
    [
      "temps",
      0.075
    ],
    [
      "seconde",
      0.075
    ],
    [
      "notule",
      0.075
    ],
    [
      "broquille",
      0.075
    ],
    [
      "acte",
      0.075
    ],
    [
      "ecrit",
      0.075
    ]
  ],
  "seconde": [
    [
      "adjoint",
      0.135
    ],
    [
      "aide",
      0.12
    ],
    [
      "auxiliaire",
      0.0675
    ],
    [
      "assistant",
      0.0525
    ],
    [
      "subalterne",
      0.0525
    ],
    [
      "inferieur",
      0.04
    ],
    [
      "collaborateur",
      0.04
    ],
    [
      "autre",
      0.04
    ],
    [
      "subordonne",
      0.025
    ],
    [
      "secondaire",
      0.025
    ],
    [
      "partenaire",
      0.025
    ],
    [
      "mineur",
      0.025
    ],
    [
      "deuxieme",
      0.025
    ],
    [
      "allie",
      0.025
    ],
    [
      "accessoire",
      0.025
    ],
    [
      "nouveau",
      0.0125
    ],
    [
      "mediocre",
      0.0125
    ],
    [
      "lieutenant",
      0.0125
    ],
    [
      "deux",
      0.0125
    ],
    [
      "cadet",
      0.0125
    ],
    [
      "assesseur",
      0.0125
    ],
    [
      "appui",
      0.0125
    ],
    [
      "temoin",
      0.0125
    ]
  ],
  "seconder": [
    [
      "servir",
      0.205
    ],
    [
      "aider",
      0.17
    ],
    [
      "soutenir",
      0.1025
    ],
    [
      "epauler",
      0.0675
    ],
    [
      "favoriser",
      0.0675
    ],
    [
      "contribuer",
      0.0675
    ],
    [
      "concourir",
      0.0675
    ],
    [
      "collaborer",
      0.0675
    ],
    [
      "assister",
      0.0675
    ],
    [
      "appuyer",
      0.0675
    ],
    [
      "suppleer",
      0.0325
    ]
  ],
  "second": [
    [
      "adjoint",
      0.135
    ],
    [
      "aide",
      0.12
    ],
    [
      "auxiliaire",
      0.0675
    ],
    [
      "assistant",
      0.0525
    ],
    [
      "subalterne",
      0.0525
    ],
    [
      "inferieur",
      0.04
    ],
    [
      "collaborateur",
      0.04
    ],
    [
      "autre",
      0.04
    ],
    [
      "subordonne",
      0.025
    ],
    [
      "secondaire",
      0.025
    ],
    [
      "partenaire",
      0.025
    ],
    [
      "mineur",
      0.025
    ],
    [
      "deuxieme",
      0.025
    ],
    [
      "allie",
      0.025
    ],
    [
      "accessoire",
      0.025
    ],
    [
      "nouveau",
      0.0125
    ],
    [
      "mediocre",
      0.0125
    ],
    [
      "lieutenant",
      0.0125
    ],
    [
      "deux",
      0.0125
    ],
    [
      "cadet",
      0.0125
    ],
    [
      "assesseur",
      0.0125
    ],
    [
      "appui",
      0.0125
    ],
    [
      "temoin",
      0.0125
    ]
  ],
  "insouciant": [
    [
      "leger",
      0.1075
    ],
    [
      "inattentif",
      0.085
    ],
    [
      "indifferent",
      0.085
    ],
    [
      "negligent",
      0.0625
    ],
    [
      "etourdi",
      0.0625
    ],
    [
      "evapore",
      0.0525
    ],
    [
      "irreflechi",
      0.0525
    ],
    [
      "oublieux",
      0.03
    ],
    [
      "nonchalant",
      0.03
    ],
    [
      "insoucieux",
      0.03
    ],
    [
      "imprevoyant",
      0.03
    ],
    [
      "frivole",
      0.03
    ],
    [
      "philosophe",
      0.02
    ],
    [
      "indolent",
      0.02
    ],
    [
      "inconscient",
      0.02
    ],
    [
      "flegmatique",
      0.02
    ],
    [
      "apathique",
      0.02
    ],
    [
      "riant",
      0.0075
    ],
    [
      "optimiste",
      0.0075
    ],
    [
      "irresponsable",
      0.0075
    ],
    [
      "inapplique",
      0.0075
    ],
    [
      "futile",
      0.0075
    ],
    [
      "folatre",
      0.0075
    ],
    [
      "detache",
      0.0075
    ],
    [
      "boheme",
      0.0075
    ]
  ],
  "rythmer": [
    [
      "cadencer",
      0.215
    ],
    [
      "accorder",
      0.1425
    ],
    [
      "mesurer",
      0.1425
    ],
    [
      "regler",
      0.1425
    ],
    [
      "scander",
      0.1425
    ],
    [
      "accentuer",
      0.07
    ],
    [
      "bercer",
      0.07
    ],
    [
      "harmoniser",
      0.07
    ]
  ],
  "rythme": [
    [
      "cadencer",
      0.215
    ],
    [
      "accorder",
      0.1425
    ],
    [
      "mesurer",
      0.1425
    ],
    [
      "regler",
      0.1425
    ],
    [
      "scander",
      0.1425
    ],
    [
      "accentuer",
      0.07
    ],
    [
      "bercer",
      0.07
    ],
    [
      "harmoniser",
      0.07
    ]
  ],
  "embrasser": [
    [
      "prendre",
      0.065
    ],
    [
      "comprendre",
      0.0625
    ],
    [
      "tenir",
      0.0475
    ],
    [
      "etreindre",
      0.0375
    ],
    [
      "serrer",
      0.0375
    ],
    [
      "entourer",
      0.0375
    ],
    [
      "adopter",
      0.0375
    ],
    [
      "enserrer",
      0.0325
    ],
    [
      "suivre",
      0.0325
    ],
    [
      "epouser",
      0.0275
    ],
    [
      "voir",
      0.0275
    ],
    [
      "penetrer",
      0.0275
    ],
    [
      "entrer",
      0.0275
    ],
    [
      "contenir",
      0.0275
    ],
    [
      "adherer",
      0.0225
    ],
    [
      "caresser",
      0.0225
    ],
    [
      "enlacer",
      0.0225
    ],
    [
      "s'etendre",
      0.0225
    ],
    [
      "renfermer",
      0.0175
    ],
    [
      "presser",
      0.0175
    ],
    [
      "connaitre",
      0.0175
    ],
    [
      "ceindre",
      0.0175
    ],
    [
      "baiser",
      0.0175
    ],
    [
      "toucher",
      0.0125
    ],
    [
      "s'appliquer",
      0.0125
    ],
    [
      "recouvrir",
      0.0125
    ],
    [
      "comporter",
      0.0125
    ],
    [
      "ceinturer",
      0.0125
    ],
    [
      "becoter",
      0.0125
    ],
    [
      "supplier",
      0.0075
    ],
    [
      "occuper",
      0.0075
    ],
    [
      "entendre",
      0.0075
    ],
    [
      "englober",
      0.0075
    ],
    [
      "decouvrir",
      0.0075
    ],
    [
      "concevoir",
      0.0075
    ],
    [
      "choisir",
      0.0075
    ],
    [
      "chausser",
      0.0075
    ],
    [
      "accepter",
      0.0075
    ],
    [
      "accoler",
      0.0075
    ],
    [
      "apercevoir",
      0.0075
    ],
    [
      "assimiler",
      0.0075
    ],
    [
      "biser",
      0.0075
    ],
    [
      "partager",
      0.0025
    ],
    [
      "implorer",
      0.0025
    ],
    [
      "imiter",
      0.0025
    ],
    [
      "environner",
      0.0025
    ],
    [
      "couvrir",
      0.0025
    ],
    [
      "biger",
      0.0025
    ],
    [
      "baisoter",
      0.0025
    ],
    [
      "selectionner",
      0.0025
    ]
  ],
  "embrasse": [
    [
      "prendre",
      0.065
    ],
    [
      "comprendre",
      0.0625
    ],
    [
      "tenir",
      0.0475
    ],
    [
      "etreindre",
      0.0375
    ],
    [
      "serrer",
      0.0375
    ],
    [
      "entourer",
      0.0375
    ],
    [
      "adopter",
      0.0375
    ],
    [
      "enserrer",
      0.0325
    ],
    [
      "suivre",
      0.0325
    ],
    [
      "epouser",
      0.0275
    ],
    [
      "voir",
      0.0275
    ],
    [
      "penetrer",
      0.0275
    ],
    [
      "entrer",
      0.0275
    ],
    [
      "contenir",
      0.0275
    ],
    [
      "adherer",
      0.0225
    ],
    [
      "caresser",
      0.0225
    ],
    [
      "enlacer",
      0.0225
    ],
    [
      "s'etendre",
      0.0225
    ],
    [
      "renfermer",
      0.0175
    ],
    [
      "presser",
      0.0175
    ],
    [
      "connaitre",
      0.0175
    ],
    [
      "ceindre",
      0.0175
    ],
    [
      "baiser",
      0.0175
    ],
    [
      "toucher",
      0.0125
    ],
    [
      "s'appliquer",
      0.0125
    ],
    [
      "recouvrir",
      0.0125
    ],
    [
      "comporter",
      0.0125
    ],
    [
      "ceinturer",
      0.0125
    ],
    [
      "becoter",
      0.0125
    ],
    [
      "supplier",
      0.0075
    ],
    [
      "occuper",
      0.0075
    ],
    [
      "entendre",
      0.0075
    ],
    [
      "englober",
      0.0075
    ],
    [
      "decouvrir",
      0.0075
    ],
    [
      "concevoir",
      0.0075
    ],
    [
      "choisir",
      0.0075
    ],
    [
      "chausser",
      0.0075
    ],
    [
      "accepter",
      0.0075
    ],
    [
      "accoler",
      0.0075
    ],
    [
      "apercevoir",
      0.0075
    ],
    [
      "assimiler",
      0.0075
    ],
    [
      "biser",
      0.0075
    ],
    [
      "partager",
      0.0025
    ],
    [
      "implorer",
      0.0025
    ],
    [
      "imiter",
      0.0025
    ],
    [
      "environner",
      0.0025
    ],
    [
      "couvrir",
      0.0025
    ],
    [
      "biger",
      0.0025
    ],
    [
      "baisoter",
      0.0025
    ],
    [
      "selectionner",
      0.0025
    ]
  ],
  "use": [
    [
      "consumer",
      0.055
    ],
    [
      "detruire",
      0.0525
    ],
    [
      "pratiquer",
      0.045
    ],
    [
      "ronger",
      0.045
    ],
    [
      "epuiser",
      0.045
    ],
    [
      "employer",
      0.0425
    ],
    [
      "manger",
      0.0375
    ],
    [
      "utiliser",
      0.035
    ],
    [
      "prendre",
      0.035
    ],
    [
      "consommer",
      0.03
    ],
    [
      "diminuer",
      0.03
    ],
    [
      "miner",
      0.03
    ],
    [
      "devorer",
      0.0275
    ],
    [
      "faire",
      0.0275
    ],
    [
      "ruiner",
      0.025
    ],
    [
      "affaiblir",
      0.025
    ],
    [
      "absorber",
      0.02
    ],
    [
      "corroder",
      0.02
    ],
    [
      "depenser",
      0.02
    ],
    [
      "entamer",
      0.02
    ],
    [
      "manier",
      0.02
    ],
    [
      "traiter",
      0.0175
    ],
    [
      "travailler",
      0.0125
    ],
    [
      "polir",
      0.0125
    ],
    [
      "mordre",
      0.0125
    ],
    [
      "disposer",
      0.0125
    ],
    [
      "agir",
      0.0125
    ],
    [
      "emousser",
      0.01
    ],
    [
      "terminer",
      0.01
    ],
    [
      "recourir",
      0.01
    ],
    [
      "jouer",
      0.01
    ],
    [
      "finir",
      0.01
    ],
    [
      "exercer",
      0.01
    ],
    [
      "eroder",
      0.005
    ],
    [
      "elimer",
      0.005
    ],
    [
      "tuer",
      0.005
    ],
    [
      "s'appliquer",
      0.005
    ],
    [
      "roder",
      0.005
    ],
    [
      "porter",
      0.005
    ],
    [
      "limer",
      0.005
    ],
    [
      "gater",
      0.005
    ],
    [
      "emprunter",
      0.005
    ],
    [
      "deployer",
      0.005
    ],
    [
      "attenuer",
      0.005
    ],
    [
      "appliquer",
      0.005
    ],
    [
      "amoindrir",
      0.005
    ],
    [
      "menager",
      0.0025
    ],
    [
      "obliterer",
      0.0025
    ],
    [
      "raguer",
      0.0025
    ],
    [
      "rogner",
      0.0025
    ],
    [
      "raper",
      0.0025
    ],
    [
      "jouir",
      0.0025
    ],
    [
      "frayer",
      0.0025
    ],
    [
      "essayer",
      0.0025
    ],
    [
      "effriter",
      0.0025
    ],
    [
      "culotter",
      0.0025
    ],
    [
      "abimer",
      0.0025
    ],
    [
      "abraser",
      0.0025
    ],
    [
      "epointer",
      0.0025
    ]
  ],
  "user": [
    [
      "consumer",
      0.055
    ],
    [
      "detruire",
      0.0525
    ],
    [
      "pratiquer",
      0.045
    ],
    [
      "ronger",
      0.045
    ],
    [
      "epuiser",
      0.045
    ],
    [
      "employer",
      0.0425
    ],
    [
      "manger",
      0.0375
    ],
    [
      "utiliser",
      0.035
    ],
    [
      "prendre",
      0.035
    ],
    [
      "consommer",
      0.03
    ],
    [
      "diminuer",
      0.03
    ],
    [
      "miner",
      0.03
    ],
    [
      "devorer",
      0.0275
    ],
    [
      "faire",
      0.0275
    ],
    [
      "ruiner",
      0.025
    ],
    [
      "affaiblir",
      0.025
    ],
    [
      "absorber",
      0.02
    ],
    [
      "corroder",
      0.02
    ],
    [
      "depenser",
      0.02
    ],
    [
      "entamer",
      0.02
    ],
    [
      "manier",
      0.02
    ],
    [
      "traiter",
      0.0175
    ],
    [
      "travailler",
      0.0125
    ],
    [
      "polir",
      0.0125
    ],
    [
      "mordre",
      0.0125
    ],
    [
      "disposer",
      0.0125
    ],
    [
      "agir",
      0.0125
    ],
    [
      "emousser",
      0.01
    ],
    [
      "terminer",
      0.01
    ],
    [
      "recourir",
      0.01
    ],
    [
      "jouer",
      0.01
    ],
    [
      "finir",
      0.01
    ],
    [
      "exercer",
      0.01
    ],
    [
      "eroder",
      0.005
    ],
    [
      "elimer",
      0.005
    ],
    [
      "tuer",
      0.005
    ],
    [
      "s'appliquer",
      0.005
    ],
    [
      "roder",
      0.005
    ],
    [
      "porter",
      0.005
    ],
    [
      "limer",
      0.005
    ],
    [
      "gater",
      0.005
    ],
    [
      "emprunter",
      0.005
    ],
    [
      "deployer",
      0.005
    ],
    [
      "attenuer",
      0.005
    ],
    [
      "appliquer",
      0.005
    ],
    [
      "amoindrir",
      0.005
    ],
    [
      "menager",
      0.0025
    ],
    [
      "obliterer",
      0.0025
    ],
    [
      "raguer",
      0.0025
    ],
    [
      "rogner",
      0.0025
    ],
    [
      "raper",
      0.0025
    ],
    [
      "jouir",
      0.0025
    ],
    [
      "frayer",
      0.0025
    ],
    [
      "essayer",
      0.0025
    ],
    [
      "effriter",
      0.0025
    ],
    [
      "culotter",
      0.0025
    ],
    [
      "abimer",
      0.0025
    ],
    [
      "abraser",
      0.0025
    ],
    [
      "epointer",
      0.0025
    ]
  ],
  "craie": [
    [
      "calcaire",
      0.3325
    ],
    [
      "marne",
      0.3325
    ],
    [
      "talc",
      0.3325
    ]
  ],
  "frottant": [
    [
      "nettoyer",
      0.12
    ],
    [
      "recurer",
      0.0775
    ],
    [
      "astiquer",
      0.0625
    ],
    [
      "polir",
      0.0525
    ],
    [
      "battre",
      0.045
    ],
    [
      "brosser",
      0.035
    ],
    [
      "bouchonner",
      0.035
    ],
    [
      "faire",
      0.03
    ],
    [
      "laver",
      0.03
    ],
    [
      "frictionner",
      0.025
    ],
    [
      "enduire",
      0.025
    ],
    [
      "caresser",
      0.025
    ],
    [
      "fourbir",
      0.02
    ],
    [
      "lustrer",
      0.02
    ],
    [
      "etriller",
      0.0125
    ],
    [
      "tamponner",
      0.0125
    ],
    [
      "racler",
      0.0125
    ],
    [
      "passer",
      0.0125
    ],
    [
      "oindre",
      0.0125
    ],
    [
      "limer",
      0.0125
    ],
    [
      "gratter",
      0.0125
    ],
    [
      "decrasser",
      0.0125
    ],
    [
      "cirer",
      0.0125
    ],
    [
      "blanchir",
      0.0125
    ],
    [
      "graisser",
      0.01
    ],
    [
      "maltraiter",
      0.01
    ],
    [
      "peloter",
      0.01
    ],
    [
      "poncer",
      0.01
    ],
    [
      "rosser",
      0.01
    ],
    [
      "raper",
      0.01
    ],
    [
      "torcher",
      0.01
    ],
    [
      "froisser",
      0.01
    ],
    [
      "frapper",
      0.01
    ],
    [
      "bichonner",
      0.01
    ],
    [
      "briquer",
      0.01
    ],
    [
      "debarbouiller",
      0.01
    ],
    [
      "decaper",
      0.01
    ],
    [
      "decrotter",
      0.01
    ],
    [
      "effleurer",
      0.01
    ],
    [
      "essuyer",
      0.01
    ],
    [
      "masser",
      0.0025
    ],
    [
      "rincer",
      0.0025
    ],
    [
      "roder",
      0.0025
    ],
    [
      "tripoter",
      0.0025
    ],
    [
      "egriser",
      0.0025
    ],
    [
      "huiler",
      0.0025
    ],
    [
      "gripper",
      0.0025
    ],
    [
      "froler",
      0.0025
    ],
    [
      "encaustiquer",
      0.0025
    ],
    [
      "carder",
      0.0025
    ],
    [
      "balayer",
      0.0025
    ],
    [
      "appuyer",
      0.0025
    ],
    [
      "allumer",
      0.0025
    ],
    [
      "eroder",
      0.0025
    ]
  ],
  "frotter": [
    [
      "nettoyer",
      0.12
    ],
    [
      "recurer",
      0.0775
    ],
    [
      "astiquer",
      0.0625
    ],
    [
      "polir",
      0.0525
    ],
    [
      "battre",
      0.045
    ],
    [
      "brosser",
      0.035
    ],
    [
      "bouchonner",
      0.035
    ],
    [
      "faire",
      0.03
    ],
    [
      "laver",
      0.03
    ],
    [
      "frictionner",
      0.025
    ],
    [
      "enduire",
      0.025
    ],
    [
      "caresser",
      0.025
    ],
    [
      "fourbir",
      0.02
    ],
    [
      "lustrer",
      0.02
    ],
    [
      "etriller",
      0.0125
    ],
    [
      "tamponner",
      0.0125
    ],
    [
      "racler",
      0.0125
    ],
    [
      "passer",
      0.0125
    ],
    [
      "oindre",
      0.0125
    ],
    [
      "limer",
      0.0125
    ],
    [
      "gratter",
      0.0125
    ],
    [
      "decrasser",
      0.0125
    ],
    [
      "cirer",
      0.0125
    ],
    [
      "blanchir",
      0.0125
    ],
    [
      "graisser",
      0.01
    ],
    [
      "maltraiter",
      0.01
    ],
    [
      "peloter",
      0.01
    ],
    [
      "poncer",
      0.01
    ],
    [
      "rosser",
      0.01
    ],
    [
      "raper",
      0.01
    ],
    [
      "torcher",
      0.01
    ],
    [
      "froisser",
      0.01
    ],
    [
      "frapper",
      0.01
    ],
    [
      "bichonner",
      0.01
    ],
    [
      "briquer",
      0.01
    ],
    [
      "debarbouiller",
      0.01
    ],
    [
      "decaper",
      0.01
    ],
    [
      "decrotter",
      0.01
    ],
    [
      "effleurer",
      0.01
    ],
    [
      "essuyer",
      0.01
    ],
    [
      "masser",
      0.0025
    ],
    [
      "rincer",
      0.0025
    ],
    [
      "roder",
      0.0025
    ],
    [
      "tripoter",
      0.0025
    ],
    [
      "egriser",
      0.0025
    ],
    [
      "huiler",
      0.0025
    ],
    [
      "gripper",
      0.0025
    ],
    [
      "froler",
      0.0025
    ],
    [
      "encaustiquer",
      0.0025
    ],
    [
      "carder",
      0.0025
    ],
    [
      "balayer",
      0.0025
    ],
    [
      "appuyer",
      0.0025
    ],
    [
      "allumer",
      0.0025
    ],
    [
      "eroder",
      0.0025
    ]
  ],
  "terminer": [
    [
      "finir",
      0.1625
    ],
    [
      "achever",
      0.0925
    ],
    [
      "arreter",
      0.0675
    ],
    [
      "conclure",
      0.0675
    ],
    [
      "parachever",
      0.04
    ],
    [
      "regler",
      0.04
    ],
    [
      "clore",
      0.0325
    ],
    [
      "couper",
      0.0325
    ],
    [
      "executer",
      0.0275
    ],
    [
      "epuiser",
      0.0225
    ],
    [
      "vider",
      0.0225
    ],
    [
      "parfaire",
      0.0225
    ],
    [
      "interrompre",
      0.0225
    ],
    [
      "cesser",
      0.0225
    ],
    [
      "user",
      0.015
    ],
    [
      "trancher",
      0.015
    ],
    [
      "traiter",
      0.015
    ],
    [
      "fermer",
      0.015
    ],
    [
      "couronner",
      0.015
    ],
    [
      "consommer",
      0.015
    ],
    [
      "arranger",
      0.015
    ],
    [
      "accomplir",
      0.015
    ],
    [
      "polir",
      0.01
    ],
    [
      "passer",
      0.01
    ],
    [
      "liquider",
      0.01
    ],
    [
      "lever",
      0.01
    ],
    [
      "fignoler",
      0.01
    ],
    [
      "expedier",
      0.01
    ],
    [
      "conduire",
      0.01
    ],
    [
      "cloturer",
      0.01
    ],
    [
      "borner",
      0.01
    ],
    [
      "lecher",
      0.005
    ],
    [
      "limiter",
      0.005
    ],
    [
      "denouer",
      0.005
    ],
    [
      "s'arreter",
      0.005
    ]
  ],
  "douceur": [
    [
      "bonte",
      0.07
    ],
    [
      "grace",
      0.0625
    ],
    [
      "delicatesse",
      0.055
    ],
    [
      "amabilite",
      0.0525
    ],
    [
      "gentillesse",
      0.045
    ],
    [
      "indulgence",
      0.04
    ],
    [
      "bienveillance",
      0.03
    ],
    [
      "serenite",
      0.025
    ],
    [
      "agrement",
      0.025
    ],
    [
      "calme",
      0.0225
    ],
    [
      "galanterie",
      0.0225
    ],
    [
      "mollesse",
      0.0225
    ],
    [
      "tendresse",
      0.0175
    ],
    [
      "mansuetude",
      0.0175
    ],
    [
      "gaterie",
      0.0175
    ],
    [
      "benignite",
      0.0175
    ],
    [
      "humanite",
      0.015
    ],
    [
      "friandise",
      0.015
    ],
    [
      "chatterie",
      0.015
    ],
    [
      "charme",
      0.015
    ],
    [
      "caresse",
      0.015
    ],
    [
      "bonheur",
      0.015
    ],
    [
      "affabilite",
      0.015
    ],
    [
      "placidite",
      0.01
    ],
    [
      "quietude",
      0.01
    ],
    [
      "sucrerie",
      0.01
    ],
    [
      "tiedeur",
      0.01
    ],
    [
      "tranquillite",
      0.01
    ],
    [
      "patience",
      0.01
    ],
    [
      "menagement",
      0.01
    ],
    [
      "moderation",
      0.01
    ],
    [
      "amenite",
      0.01
    ],
    [
      "bonhomie",
      0.01
    ],
    [
      "charite",
      0.01
    ],
    [
      "debonnairete",
      0.01
    ],
    [
      "finesse",
      0.01
    ],
    [
      "joie",
      0.01
    ],
    [
      "tolerance",
      0.0075
    ],
    [
      "suavite",
      0.0075
    ],
    [
      "soin",
      0.0075
    ],
    [
      "satisfaction",
      0.0075
    ],
    [
      "paleur",
      0.0075
    ],
    [
      "pitie",
      0.0075
    ],
    [
      "paix",
      0.0075
    ],
    [
      "moelleux",
      0.0075
    ],
    [
      "lenteur",
      0.0075
    ],
    [
      "gourmandise",
      0.0075
    ],
    [
      "fadeur",
      0.0075
    ],
    [
      "bonbon",
      0.0075
    ],
    [
      "bercement",
      0.0075
    ],
    [
      "humilite",
      0.0025
    ],
    [
      "jouissance",
      0.0025
    ],
    [
      "legerete",
      0.0025
    ],
    [
      "miel",
      0.0025
    ],
    [
      "onction",
      0.0025
    ],
    [
      "flatterie",
      0.0025
    ],
    [
      "docilite",
      0.0025
    ],
    [
      "confiserie",
      0.0025
    ],
    [
      "clemence",
      0.0025
    ],
    [
      "affection",
      0.0025
    ],
    [
      "veloute",
      0.0025
    ]
  ],
  "divin": [
    [
      "beau",
      0.125
    ],
    [
      "parfait",
      0.125
    ],
    [
      "merveilleux",
      0.115
    ],
    [
      "bon",
      0.0675
    ],
    [
      "celeste",
      0.055
    ],
    [
      "sublime",
      0.045
    ],
    [
      "supreme",
      0.0325
    ],
    [
      "splendide",
      0.0325
    ],
    [
      "sacre",
      0.0325
    ],
    [
      "paradisiaque",
      0.0325
    ],
    [
      "ineffable",
      0.0325
    ],
    [
      "feerique",
      0.0325
    ],
    [
      "surnaturel",
      0.02
    ],
    [
      "souverain",
      0.02
    ],
    [
      "genial",
      0.02
    ],
    [
      "delicieux",
      0.02
    ],
    [
      "charmant",
      0.02
    ],
    [
      "adorable",
      0.02
    ],
    [
      "admirable",
      0.02
    ],
    [
      "theologique",
      0.01
    ],
    [
      "seraphique",
      0.01
    ],
    [
      "radieux",
      0.01
    ],
    [
      "providentiel",
      0.01
    ],
    [
      "occulte",
      0.01
    ],
    [
      "bien",
      0.01
    ],
    [
      "archangelique",
      0.01
    ],
    [
      "eternel",
      0.01
    ]
  ],
  "heler": [
    [
      "appeler",
      0.3
    ],
    [
      "crier",
      0.2
    ],
    [
      "hucher",
      0.2
    ],
    [
      "apostropher",
      0.1
    ],
    [
      "interpeller",
      0.1
    ],
    [
      "siffler",
      0.1
    ]
  ],
  "helas": [
    [
      "gemissement",
      0.5
    ],
    [
      "las",
      0.5
    ]
  ],
  "mariner": [
    [
      "baigner",
      0.3325
    ],
    [
      "macerer",
      0.3325
    ],
    [
      "tremper",
      0.3325
    ]
  ],
  "marine": [
    [
      "matelot",
      0.215
    ],
    [
      "navigateur",
      0.1225
    ],
    [
      "gabier",
      0.06
    ],
    [
      "mathurin",
      0.06
    ],
    [
      "mousse",
      0.06
    ],
    [
      "naval",
      0.06
    ],
    [
      "nautique",
      0.0275
    ],
    [
      "nautonier",
      0.0275
    ],
    [
      "novice",
      0.0275
    ],
    [
      "pirate",
      0.0275
    ],
    [
      "pecheur",
      0.0275
    ],
    [
      "moussaillon",
      0.0275
    ],
    [
      "marsouin",
      0.0275
    ],
    [
      "maritime",
      0.0275
    ],
    [
      "marinier",
      0.0275
    ],
    [
      "corsaire",
      0.0275
    ],
    [
      "soldat",
      0.0275
    ]
  ],
  "algue": [
    [
      "goemon",
      0.1425
    ],
    [
      "laminaire",
      0.1425
    ],
    [
      "nostoc",
      0.1425
    ],
    [
      "pheophycee",
      0.1425
    ],
    [
      "thallophyte",
      0.1425
    ],
    [
      "varech",
      0.1425
    ]
  ],
  "naive": [
    [
      "simple",
      0.1225
    ],
    [
      "niais",
      0.0925
    ],
    [
      "candide",
      0.0625
    ],
    [
      "innocent",
      0.0625
    ],
    [
      "credule",
      0.055
    ],
    [
      "naturel",
      0.035
    ],
    [
      "jobard",
      0.035
    ],
    [
      "ingenu",
      0.035
    ],
    [
      "gogo",
      0.035
    ],
    [
      "bete",
      0.035
    ],
    [
      "bon",
      0.035
    ],
    [
      "simplet",
      0.0275
    ],
    [
      "pur",
      0.0275
    ],
    [
      "nigaud",
      0.0275
    ],
    [
      "jeune",
      0.02
    ],
    [
      "poire",
      0.02
    ],
    [
      "vrai",
      0.02
    ],
    [
      "irreflechi",
      0.0125
    ],
    [
      "pigeon",
      0.0125
    ],
    [
      "primitif",
      0.0125
    ],
    [
      "spontane",
      0.0125
    ],
    [
      "irraisonne",
      0.0125
    ],
    [
      "inexperimente",
      0.0125
    ],
    [
      "frais",
      0.0125
    ],
    [
      "dupe",
      0.0125
    ],
    [
      "brut",
      0.0125
    ],
    [
      "bonhomme",
      0.0125
    ],
    [
      "pueril",
      0.005
    ],
    [
      "peintre",
      0.005
    ],
    [
      "godiche",
      0.005
    ],
    [
      "gobeur",
      0.005
    ],
    [
      "gille",
      0.005
    ],
    [
      "confiant",
      0.005
    ],
    [
      "bonasse",
      0.005
    ],
    [
      "benet",
      0.005
    ],
    [
      "superstitieux",
      0.005
    ]
  ],
  "naif": [
    [
      "simple",
      0.1225
    ],
    [
      "niais",
      0.0925
    ],
    [
      "candide",
      0.0625
    ],
    [
      "innocent",
      0.0625
    ],
    [
      "credule",
      0.055
    ],
    [
      "naturel",
      0.035
    ],
    [
      "jobard",
      0.035
    ],
    [
      "ingenu",
      0.035
    ],
    [
      "gogo",
      0.035
    ],
    [
      "bete",
      0.035
    ],
    [
      "bon",
      0.035
    ],
    [
      "simplet",
      0.0275
    ],
    [
      "pur",
      0.0275
    ],
    [
      "nigaud",
      0.0275
    ],
    [
      "jeune",
      0.02
    ],
    [
      "poire",
      0.02
    ],
    [
      "vrai",
      0.02
    ],
    [
      "irreflechi",
      0.0125
    ],
    [
      "pigeon",
      0.0125
    ],
    [
      "primitif",
      0.0125
    ],
    [
      "spontane",
      0.0125
    ],
    [
      "irraisonne",
      0.0125
    ],
    [
      "inexperimente",
      0.0125
    ],
    [
      "frais",
      0.0125
    ],
    [
      "dupe",
      0.0125
    ],
    [
      "brut",
      0.0125
    ],
    [
      "bonhomme",
      0.0125
    ],
    [
      "pueril",
      0.005
    ],
    [
      "peintre",
      0.005
    ],
    [
      "godiche",
      0.005
    ],
    [
      "gobeur",
      0.005
    ],
    [
      "gille",
      0.005
    ],
    [
      "confiant",
      0.005
    ],
    [
      "bonasse",
      0.005
    ],
    [
      "benet",
      0.005
    ],
    [
      "superstitieux",
      0.005
    ]
  ],
  "ocean": [
    [
      "mer",
      0.3325
    ],
    [
      "abime",
      0.165
    ],
    [
      "deluge",
      0.165
    ],
    [
      "flots",
      0.165
    ],
    [
      "gouffre",
      0.165
    ]
  ],
  "saline": [
    [
      "sale",
      1.0
    ]
  ],
  "salin": [
    [
      "sale",
      1.0
    ]
  ],
  "parme": [
    [
      "violet",
      1.0
    ]
  ],
  "sublime": [
    [
      "beau",
      0.0775
    ],
    [
      "eleve",
      0.055
    ],
    [
      "grand",
      0.05
    ],
    [
      "merveilleux",
      0.05
    ],
    [
      "superieur",
      0.05
    ],
    [
      "sensationnel",
      0.045
    ],
    [
      "parfait",
      0.045
    ],
    [
      "noble",
      0.045
    ],
    [
      "magnifique",
      0.045
    ],
    [
      "haut",
      0.045
    ],
    [
      "extraordinaire",
      0.045
    ],
    [
      "admirable",
      0.03
    ],
    [
      "etonnant",
      0.03
    ],
    [
      "supreme",
      0.025
    ],
    [
      "splendide",
      0.025
    ],
    [
      "releve",
      0.025
    ],
    [
      "ideal",
      0.025
    ],
    [
      "transcendant",
      0.0225
    ],
    [
      "superbe",
      0.0175
    ],
    [
      "prodigieux",
      0.0175
    ],
    [
      "grandiose",
      0.0175
    ],
    [
      "divin",
      0.0175
    ],
    [
      "eminent",
      0.0125
    ],
    [
      "poetique",
      0.0125
    ],
    [
      "magique",
      0.0125
    ],
    [
      "inoui",
      0.0125
    ],
    [
      "ethere",
      0.0075
    ],
    [
      "pur",
      0.0075
    ],
    [
      "pompeux",
      0.0075
    ],
    [
      "paradisiaque",
      0.0075
    ],
    [
      "monumental",
      0.0075
    ],
    [
      "ineffable",
      0.0075
    ],
    [
      "heroique",
      0.0075
    ],
    [
      "aile",
      0.0075
    ],
    [
      "surhumain",
      0.0025
    ],
    [
      "soutenu",
      0.0025
    ],
    [
      "sommet",
      0.0025
    ],
    [
      "homerique",
      0.0025
    ],
    [
      "grandeur",
      0.0025
    ],
    [
      "fascinant",
      0.0025
    ],
    [
      "apotheotique",
      0.0025
    ],
    [
      "sureminent",
      0.0025
    ]
  ],
  "sublimer": [
    [
      "idealiser",
      0.2
    ],
    [
      "ennoblir",
      0.1325
    ],
    [
      "magnifier",
      0.1325
    ],
    [
      "spiritualiser",
      0.1325
    ],
    [
      "volatiliser",
      0.065
    ],
    [
      "transcender",
      0.065
    ],
    [
      "purifier",
      0.065
    ],
    [
      "gazeifier",
      0.065
    ],
    [
      "distiller",
      0.065
    ],
    [
      "elever",
      0.065
    ]
  ],
  "lointain": [
    [
      "eloigne",
      0.1375
    ],
    [
      "perdu",
      0.0975
    ],
    [
      "ecarte",
      0.0975
    ],
    [
      "absent",
      0.0575
    ],
    [
      "distance",
      0.0575
    ],
    [
      "distrait",
      0.0575
    ],
    [
      "voile",
      0.0375
    ],
    [
      "vague",
      0.0375
    ],
    [
      "retire",
      0.0375
    ],
    [
      "recule",
      0.0375
    ],
    [
      "profondeur",
      0.0375
    ],
    [
      "indirect",
      0.0375
    ],
    [
      "detourne",
      0.0375
    ],
    [
      "eloignement",
      0.0175
    ],
    [
      "profond",
      0.0175
    ],
    [
      "long",
      0.0175
    ],
    [
      "horizon",
      0.0175
    ],
    [
      "fond",
      0.0175
    ],
    [
      "enfoncement",
      0.0175
    ],
    [
      "distant",
      0.0175
    ],
    [
      "absorbe",
      0.0175
    ],
    [
      "etranger",
      0.0175
    ]
  ],
  "cygne": [],
  "origine": [
    [
      "commencement",
      0.06
    ],
    [
      "principe",
      0.06
    ],
    [
      "source",
      0.055
    ],
    [
      "seuil",
      0.045
    ],
    [
      "cause",
      0.0375
    ],
    [
      "famille",
      0.035
    ],
    [
      "germe",
      0.035
    ],
    [
      "naissance",
      0.035
    ],
    [
      "race",
      0.0325
    ],
    [
      "debut",
      0.03
    ],
    [
      "fondement",
      0.03
    ],
    [
      "racine",
      0.0275
    ],
    [
      "filiation",
      0.0225
    ],
    [
      "descendance",
      0.02
    ],
    [
      "extraction",
      0.02
    ],
    [
      "souche",
      0.0175
    ],
    [
      "maison",
      0.0175
    ],
    [
      "lieu",
      0.0175
    ],
    [
      "generation",
      0.0175
    ],
    [
      "depart",
      0.0175
    ],
    [
      "ascendance",
      0.0125
    ],
    [
      "base",
      0.0125
    ],
    [
      "endroit",
      0.0125
    ],
    [
      "ferment",
      0.0125
    ],
    [
      "genealogie",
      0.0125
    ],
    [
      "premices",
      0.01
    ],
    [
      "point",
      0.01
    ],
    [
      "embryon",
      0.01
    ],
    [
      "etre",
      0.0075
    ],
    [
      "raison",
      0.0075
    ],
    [
      "provenance",
      0.0075
    ],
    [
      "pays",
      0.0075
    ],
    [
      "mere",
      0.0075
    ],
    [
      "motif",
      0.0075
    ],
    [
      "genese",
      0.0075
    ],
    [
      "amorce",
      0.0075
    ],
    [
      "aurore",
      0.0075
    ],
    [
      "creation",
      0.0075
    ],
    [
      "enfance",
      0.0075
    ],
    [
      "formation",
      0.0075
    ],
    [
      "etymologie",
      0.005
    ],
    [
      "substance",
      0.005
    ],
    [
      "semence",
      0.005
    ],
    [
      "region",
      0.005
    ],
    [
      "pere",
      0.005
    ],
    [
      "parente",
      0.005
    ],
    [
      "derivation",
      0.005
    ],
    [
      "createur",
      0.005
    ],
    [
      "berceau",
      0.005
    ],
    [
      "agent",
      0.005
    ],
    [
      "pepiniere",
      0.0025
    ],
    [
      "sang",
      0.0025
    ],
    [
      "terroir",
      0.0025
    ],
    [
      "tronc",
      0.0025
    ],
    [
      "predeterminant",
      0.0025
    ],
    [
      "pivot",
      0.0025
    ],
    [
      "pedigree",
      0.0025
    ],
    [
      "oeuf",
      0.0025
    ],
    [
      "noyau",
      0.0025
    ],
    [
      "nid",
      0.0025
    ],
    [
      "moteur",
      0.0025
    ],
    [
      "anciennete",
      0.0025
    ],
    [
      "etage",
      0.0025
    ]
  ],
  "indicible": [
    [
      "inexprimable",
      0.24
    ],
    [
      "ineffable",
      0.17
    ],
    [
      "indescriptible",
      0.1375
    ],
    [
      "inoui",
      0.0675
    ],
    [
      "inenarrable",
      0.0675
    ],
    [
      "intraduisible",
      0.0325
    ],
    [
      "insense",
      0.0325
    ],
    [
      "inracontable",
      0.0325
    ],
    [
      "innommable",
      0.0325
    ],
    [
      "informulable",
      0.0325
    ],
    [
      "indefinissable",
      0.0325
    ],
    [
      "incommunicable",
      0.0325
    ],
    [
      "extraordinaire",
      0.0325
    ],
    [
      "inegalable",
      0.0325
    ]
  ],
  "avis": [
    [
      "annonce",
      0.0725
    ],
    [
      "avertissement",
      0.0675
    ],
    [
      "note",
      0.06
    ],
    [
      "opinion",
      0.04
    ],
    [
      "information",
      0.03
    ],
    [
      "recommandation",
      0.03
    ],
    [
      "jugement",
      0.0275
    ],
    [
      "indication",
      0.0275
    ],
    [
      "declaration",
      0.0275
    ],
    [
      "conseil",
      0.0225
    ],
    [
      "instruction",
      0.0225
    ],
    [
      "lecon",
      0.0225
    ],
    [
      "message",
      0.0225
    ],
    [
      "proclamation",
      0.0225
    ],
    [
      "sentiment",
      0.0225
    ],
    [
      "vue",
      0.02
    ],
    [
      "pensee",
      0.02
    ],
    [
      "nouvelle",
      0.02
    ],
    [
      "communique",
      0.02
    ],
    [
      "communication",
      0.02
    ],
    [
      "voix",
      0.015
    ],
    [
      "ordre",
      0.015
    ],
    [
      "introduction",
      0.015
    ],
    [
      "bulletin",
      0.015
    ],
    [
      "billet",
      0.015
    ],
    [
      "renseignement",
      0.01
    ],
    [
      "preface",
      0.01
    ],
    [
      "prospectus",
      0.01
    ],
    [
      "notice",
      0.01
    ],
    [
      "appreciation",
      0.01
    ],
    [
      "affiche",
      0.01
    ],
    [
      "rumeur",
      0.0075
    ],
    [
      "sens",
      0.0075
    ],
    [
      "suffrage",
      0.0075
    ],
    [
      "suggestion",
      0.0075
    ],
    [
      "tendance",
      0.0075
    ],
    [
      "vote",
      0.0075
    ],
    [
      "presage",
      0.0075
    ],
    [
      "notification",
      0.0075
    ],
    [
      "idee",
      0.0075
    ],
    [
      "approbation",
      0.0075
    ],
    [
      "directive",
      0.0075
    ],
    [
      "denonciation",
      0.0075
    ],
    [
      "depeche",
      0.0075
    ],
    [
      "enseignement",
      0.0075
    ],
    [
      "exhortation",
      0.0075
    ],
    [
      "manifeste",
      0.0025
    ],
    [
      "placard",
      0.0025
    ],
    [
      "preambule",
      0.0025
    ],
    [
      "preavis",
      0.0025
    ],
    [
      "preliminaire",
      0.0025
    ],
    [
      "voeu",
      0.0025
    ],
    [
      "mandement",
      0.0025
    ],
    [
      "frontispice",
      0.0025
    ],
    [
      "estimation",
      0.0025
    ],
    [
      "croyance",
      0.0025
    ],
    [
      "consultation",
      0.0025
    ],
    [
      "ban",
      0.0025
    ],
    [
      "vues",
      0.0025
    ]
  ],
  "commande": [
    [
      "ordonner",
      0.055
    ],
    [
      "diriger",
      0.0475
    ],
    [
      "demander",
      0.045
    ],
    [
      "exiger",
      0.045
    ],
    [
      "prescrire",
      0.0425
    ],
    [
      "sommer",
      0.0375
    ],
    [
      "gouverner",
      0.0375
    ],
    [
      "conduire",
      0.0375
    ],
    [
      "dominer",
      0.035
    ],
    [
      "requerir",
      0.03
    ],
    [
      "regler",
      0.03
    ],
    [
      "contraindre",
      0.0275
    ],
    [
      "necessiter",
      0.0225
    ],
    [
      "maitriser",
      0.0225
    ],
    [
      "imposer",
      0.0225
    ],
    [
      "guider",
      0.0225
    ],
    [
      "entrainer",
      0.0225
    ],
    [
      "decider",
      0.0225
    ],
    [
      "appeler",
      0.02
    ],
    [
      "enjoindre",
      0.02
    ],
    [
      "regir",
      0.02
    ],
    [
      "vouloir",
      0.015
    ],
    [
      "reclamer",
      0.015
    ],
    [
      "mener",
      0.015
    ],
    [
      "disposer",
      0.015
    ],
    [
      "dire",
      0.015
    ],
    [
      "dicter",
      0.015
    ],
    [
      "regner",
      0.0125
    ],
    [
      "recommander",
      0.0125
    ],
    [
      "obliger",
      0.0125
    ],
    [
      "inspirer",
      0.0125
    ],
    [
      "dompter",
      0.0125
    ],
    [
      "conseiller",
      0.0125
    ],
    [
      "attirer",
      0.0125
    ],
    [
      "regenter",
      0.01
    ],
    [
      "decreter",
      0.01
    ],
    [
      "communiquer",
      0.01
    ],
    [
      "reprimer",
      0.005
    ],
    [
      "meriter",
      0.005
    ],
    [
      "mater",
      0.005
    ],
    [
      "assujettir",
      0.005
    ],
    [
      "administrer",
      0.005
    ],
    [
      "intimer",
      0.0025
    ],
    [
      "desservir",
      0.0025
    ],
    [
      "conditionner",
      0.0025
    ],
    [
      "acheter",
      0.0025
    ]
  ],
  "representer": [
    [
      "montrer",
      0.0775
    ],
    [
      "exposer",
      0.055
    ],
    [
      "reveler",
      0.055
    ],
    [
      "faire",
      0.0525
    ],
    [
      "figurer",
      0.05
    ],
    [
      "donner",
      0.0425
    ],
    [
      "peindre",
      0.04
    ],
    [
      "dessiner",
      0.0375
    ],
    [
      "exprimer",
      0.0275
    ],
    [
      "jouer",
      0.0275
    ],
    [
      "reproduire",
      0.0275
    ],
    [
      "signifier",
      0.0275
    ],
    [
      "tracer",
      0.025
    ],
    [
      "retracer",
      0.0225
    ],
    [
      "presenter",
      0.0225
    ],
    [
      "indiquer",
      0.0225
    ],
    [
      "decrire",
      0.0225
    ],
    [
      "former",
      0.02
    ],
    [
      "raconter",
      0.02
    ],
    [
      "afficher",
      0.015
    ],
    [
      "symboliser",
      0.015
    ],
    [
      "servir",
      0.0125
    ],
    [
      "rendre",
      0.0125
    ],
    [
      "incarner",
      0.0125
    ],
    [
      "depeindre",
      0.0125
    ],
    [
      "imiter",
      0.01
    ],
    [
      "rapporter",
      0.01
    ],
    [
      "evoquer",
      0.01
    ],
    [
      "equivaloir",
      0.0075
    ],
    [
      "simuler",
      0.0075
    ],
    [
      "refleter",
      0.0075
    ],
    [
      "materialiser",
      0.0075
    ],
    [
      "interpreter",
      0.0075
    ],
    [
      "etre",
      0.005
    ],
    [
      "ressembler",
      0.005
    ],
    [
      "remplacer",
      0.005
    ],
    [
      "profiler",
      0.005
    ],
    [
      "portraiturer",
      0.005
    ],
    [
      "illustrer",
      0.005
    ],
    [
      "exhiber",
      0.005
    ],
    [
      "designer",
      0.005
    ],
    [
      "agir",
      0.005
    ],
    [
      "avertir",
      0.005
    ],
    [
      "brosser",
      0.005
    ],
    [
      "constituer",
      0.005
    ],
    [
      "copier",
      0.005
    ],
    [
      "correspondre",
      0.005
    ],
    [
      "reprocher",
      0.0025
    ],
    [
      "remontrer",
      0.0025
    ],
    [
      "portraire",
      0.0025
    ],
    [
      "photographier",
      0.0025
    ],
    [
      "personnifier",
      0.0025
    ],
    [
      "modeliser",
      0.0025
    ],
    [
      "mimer",
      0.0025
    ],
    [
      "imposer",
      0.0025
    ],
    [
      "couter",
      0.0025
    ],
    [
      "subroger",
      0.0025
    ]
  ],
  "salaud": [
    [
      "bete",
      0.1025
    ],
    [
      "malpropre",
      0.1025
    ],
    [
      "saligaud",
      0.1025
    ],
    [
      "fumier",
      0.0775
    ],
    [
      "salete",
      0.0775
    ],
    [
      "vaurien",
      0.05
    ],
    [
      "vache",
      0.05
    ],
    [
      "sagouin",
      0.05
    ],
    [
      "ordure",
      0.05
    ],
    [
      "mechant",
      0.05
    ],
    [
      "fripouille",
      0.05
    ],
    [
      "degueulasse",
      0.05
    ],
    [
      "charogne",
      0.05
    ],
    [
      "abject",
      0.0225
    ],
    [
      "canaille",
      0.0225
    ],
    [
      "goujat",
      0.0225
    ],
    [
      "salop",
      0.0225
    ],
    [
      "salopard",
      0.0225
    ]
  ],
  "chuter": [
    [
      "tomber",
      0.285
    ],
    [
      "s'ecrouler",
      0.1075
    ],
    [
      "echouer",
      0.07
    ],
    [
      "s'affaisser",
      0.07
    ],
    [
      "s'abattre",
      0.07
    ],
    [
      "faillir",
      0.07
    ],
    [
      "degringoler",
      0.07
    ],
    [
      "choir",
      0.07
    ],
    [
      "avorter",
      0.035
    ],
    [
      "basculer",
      0.035
    ],
    [
      "pecher",
      0.035
    ],
    [
      "s'affaler",
      0.035
    ]
  ],
  "journee": [
    [
      "jour",
      0.285
    ],
    [
      "journal",
      0.1425
    ],
    [
      "retribution",
      0.1425
    ],
    [
      "traitement",
      0.1425
    ],
    [
      "vie",
      0.1425
    ],
    [
      "etape",
      0.1425
    ]
  ],
  "squatter": [
    [
      "pionnier",
      1.0
    ]
  ],
  "skate": [],
  "glisser": [
    [
      "couler",
      0.0825
    ],
    [
      "introduire",
      0.0675
    ],
    [
      "passer",
      0.0675
    ],
    [
      "tomber",
      0.0525
    ],
    [
      "penetrer",
      0.0375
    ],
    [
      "s'enfoncer",
      0.03
    ],
    [
      "mettre",
      0.03
    ],
    [
      "insinuer",
      0.03
    ],
    [
      "evoluer",
      0.0225
    ],
    [
      "rouler",
      0.0225
    ],
    [
      "inserer",
      0.0225
    ],
    [
      "fourrer",
      0.0225
    ],
    [
      "courir",
      0.0225
    ],
    [
      "changer",
      0.0225
    ],
    [
      "patiner",
      0.015
    ],
    [
      "pencher",
      0.015
    ],
    [
      "riper",
      0.015
    ],
    [
      "s'infiltrer",
      0.015
    ],
    [
      "sombrer",
      0.015
    ],
    [
      "traiter",
      0.015
    ],
    [
      "jeter",
      0.015
    ],
    [
      "filtrer",
      0.015
    ],
    [
      "filer",
      0.015
    ],
    [
      "caresser",
      0.015
    ],
    [
      "chanceler",
      0.015
    ],
    [
      "chasser",
      0.015
    ],
    [
      "deraper",
      0.015
    ],
    [
      "effleurer",
      0.015
    ],
    [
      "engager",
      0.015
    ],
    [
      "s'abandonner",
      0.0075
    ],
    [
      "s'affaisser",
      0.0075
    ],
    [
      "s'affaler",
      0.0075
    ],
    [
      "s'incliner",
      0.0075
    ],
    [
      "serpenter",
      0.0075
    ],
    [
      "skier",
      0.0075
    ],
    [
      "souffler",
      0.0075
    ],
    [
      "tituber",
      0.0075
    ],
    [
      "ramper",
      0.0075
    ],
    [
      "placer",
      0.0075
    ],
    [
      "avancer",
      0.0075
    ],
    [
      "coulisser",
      0.0075
    ],
    [
      "crouler",
      0.0075
    ],
    [
      "dissimuler",
      0.0075
    ],
    [
      "froler",
      0.0075
    ],
    [
      "fuser",
      0.0075
    ],
    [
      "inclure",
      0.0075
    ],
    [
      "intercaler",
      0.0075
    ],
    [
      "manquer",
      0.0075
    ],
    [
      "papillonner",
      0.0075
    ],
    [
      "echapper",
      0.0075
    ]
  ],
  "etrange": [
    [
      "extraordinaire",
      0.1025
    ],
    [
      "bizarre",
      0.085
    ],
    [
      "etonnant",
      0.07
    ],
    [
      "singulier",
      0.0475
    ],
    [
      "surprenant",
      0.0475
    ],
    [
      "curieux",
      0.0425
    ],
    [
      "incroyable",
      0.04
    ],
    [
      "fantastique",
      0.0325
    ],
    [
      "insolite",
      0.0325
    ],
    [
      "original",
      0.0325
    ],
    [
      "inusite",
      0.03
    ],
    [
      "extravagant",
      0.03
    ],
    [
      "exceptionnel",
      0.0275
    ],
    [
      "invraisemblable",
      0.0275
    ],
    [
      "inconcevable",
      0.0225
    ],
    [
      "inoui",
      0.0225
    ],
    [
      "rocambolesque",
      0.0225
    ],
    [
      "paradoxal",
      0.0175
    ],
    [
      "abracadabrant",
      0.0175
    ],
    [
      "drole",
      0.015
    ],
    [
      "inhabituel",
      0.015
    ],
    [
      "rare",
      0.015
    ],
    [
      "inaccoutume",
      0.015
    ],
    [
      "deconcertant",
      0.015
    ],
    [
      "anormal",
      0.015
    ],
    [
      "incomprehensible",
      0.0125
    ],
    [
      "inexplicable",
      0.0125
    ],
    [
      "inattendu",
      0.01
    ],
    [
      "saugrenu",
      0.0075
    ],
    [
      "mysterieux",
      0.0075
    ],
    [
      "baroque",
      0.0075
    ],
    [
      "enigmatique",
      0.005
    ],
    [
      "truculent",
      0.005
    ],
    [
      "incoherent",
      0.005
    ],
    [
      "excentrique",
      0.005
    ],
    [
      "beau",
      0.005
    ],
    [
      "admirable",
      0.005
    ],
    [
      "louche",
      0.0025
    ],
    [
      "inquietant",
      0.0025
    ],
    [
      "choquant",
      0.0025
    ],
    [
      "etranger",
      0.0
    ],
    [
      "esoterique",
      0.0
    ],
    [
      "ebouriffant",
      0.0
    ],
    [
      "indefinissable",
      0.0
    ],
    [
      "inconvenant",
      0.0
    ],
    [
      "exotique",
      0.0
    ],
    [
      "deplace",
      0.0
    ],
    [
      "biscornu",
      0.0
    ],
    [
      "etrangete",
      0.0
    ]
  ],
  "troupe": [
    [
      "groupe",
      0.1
    ],
    [
      "bande",
      0.07
    ],
    [
      "armee",
      0.06
    ],
    [
      "agglomeration",
      0.0375
    ],
    [
      "cohorte",
      0.035
    ],
    [
      "multitude",
      0.035
    ],
    [
      "societe",
      0.035
    ],
    [
      "troupeau",
      0.0325
    ],
    [
      "compagnie",
      0.0325
    ],
    [
      "bataillon",
      0.0325
    ],
    [
      "peuple",
      0.025
    ],
    [
      "rassemblement",
      0.025
    ],
    [
      "unite",
      0.0225
    ],
    [
      "reunion",
      0.0225
    ],
    [
      "horde",
      0.0225
    ],
    [
      "essaim",
      0.0225
    ],
    [
      "foule",
      0.0175
    ],
    [
      "legion",
      0.0175
    ],
    [
      "parti",
      0.0175
    ],
    [
      "equipe",
      0.015
    ],
    [
      "harde",
      0.015
    ],
    [
      "cortege",
      0.015
    ],
    [
      "assemblage",
      0.015
    ],
    [
      "colonne",
      0.0125
    ],
    [
      "meute",
      0.0125
    ],
    [
      "regiment",
      0.0125
    ],
    [
      "escouade",
      0.0075
    ],
    [
      "formation",
      0.0075
    ],
    [
      "peloton",
      0.0075
    ],
    [
      "tribu",
      0.0075
    ],
    [
      "escorte",
      0.0075
    ],
    [
      "ensemble",
      0.0075
    ],
    [
      "detachement",
      0.0075
    ],
    [
      "corps",
      0.0075
    ],
    [
      "camp",
      0.0075
    ],
    [
      "brigade",
      0.0075
    ],
    [
      "attroupement",
      0.0075
    ],
    [
      "volee",
      0.005
    ],
    [
      "section",
      0.005
    ],
    [
      "quadrille",
      0.005
    ],
    [
      "phalange",
      0.005
    ],
    [
      "milice",
      0.005
    ],
    [
      "garde",
      0.005
    ],
    [
      "commando",
      0.005
    ],
    [
      "caravane",
      0.005
    ],
    [
      "armada",
      0.005
    ],
    [
      "manipule",
      0.0025
    ],
    [
      "patrouille",
      0.0025
    ],
    [
      "piquet",
      0.0025
    ],
    [
      "soldatesque",
      0.0025
    ],
    [
      "tabor",
      0.0025
    ],
    [
      "harpail",
      0.0025
    ],
    [
      "guerilla",
      0.0025
    ],
    [
      "goum",
      0.0025
    ],
    [
      "gang",
      0.0025
    ],
    [
      "escadron",
      0.0025
    ],
    [
      "cavalcade",
      0.0025
    ],
    [
      "echelon",
      0.0025
    ]
  ],
  "estimer": [
    [
      "considerer",
      0.11
    ],
    [
      "apprecier",
      0.0875
    ],
    [
      "juger",
      0.0875
    ],
    [
      "compter",
      0.0625
    ],
    [
      "regarder",
      0.055
    ],
    [
      "evaluer",
      0.05
    ],
    [
      "peser",
      0.0475
    ],
    [
      "examiner",
      0.04
    ],
    [
      "penser",
      0.04
    ],
    [
      "reputer",
      0.0275
    ],
    [
      "croire",
      0.0275
    ],
    [
      "mesurer",
      0.025
    ],
    [
      "voir",
      0.025
    ],
    [
      "venerer",
      0.02
    ],
    [
      "priser",
      0.02
    ],
    [
      "prendre",
      0.02
    ],
    [
      "aimer",
      0.0175
    ],
    [
      "trouver",
      0.0125
    ],
    [
      "presumer",
      0.0125
    ],
    [
      "jauger",
      0.0125
    ],
    [
      "envisager",
      0.0125
    ],
    [
      "cherir",
      0.0125
    ],
    [
      "calculer",
      0.01
    ],
    [
      "connaitre",
      0.01
    ],
    [
      "honorer",
      0.01
    ],
    [
      "sonder",
      0.01
    ],
    [
      "supputer",
      0.01
    ],
    [
      "reverer",
      0.005
    ],
    [
      "gouter",
      0.005
    ],
    [
      "determiner",
      0.005
    ],
    [
      "taxer",
      0.0025
    ],
    [
      "respecter",
      0.0025
    ],
    [
      "preferer",
      0.0025
    ],
    [
      "expertiser",
      0.0025
    ],
    [
      "coter",
      0.0025
    ],
    [
      "benir",
      0.0025
    ],
    [
      "arbitrer",
      0.0025
    ]
  ],
  "estime": [
    [
      "consideration",
      0.155
    ],
    [
      "honneur",
      0.1
    ],
    [
      "respect",
      0.065
    ],
    [
      "veneration",
      0.065
    ],
    [
      "faveur",
      0.055
    ],
    [
      "reputation",
      0.055
    ],
    [
      "reverence",
      0.055
    ],
    [
      "popularite",
      0.0425
    ],
    [
      "gloire",
      0.0425
    ],
    [
      "benediction",
      0.0325
    ],
    [
      "deference",
      0.0325
    ],
    [
      "hommage",
      0.0325
    ],
    [
      "egards",
      0.0325
    ],
    [
      "egard",
      0.02
    ],
    [
      "sympathie",
      0.02
    ],
    [
      "orgueil",
      0.02
    ],
    [
      "fierte",
      0.02
    ],
    [
      "credit",
      0.02
    ],
    [
      "attachement",
      0.02
    ],
    [
      "amour",
      0.02
    ],
    [
      "approbation",
      0.01
    ],
    [
      "approximation",
      0.01
    ],
    [
      "conscience",
      0.01
    ],
    [
      "opinion",
      0.01
    ],
    [
      "respectabilite",
      0.01
    ],
    [
      "superbe",
      0.01
    ]
  ],
  "truck": [
    [
      "chariot",
      0.5
    ],
    [
      "wagon",
      0.5
    ]
  ],
  "ramper": [
    [
      "s'aplatir",
      0.1325
    ],
    [
      "s'humilier",
      0.1325
    ],
    [
      "s'introduire",
      0.1325
    ],
    [
      "glisser",
      0.065
    ],
    [
      "flatter",
      0.065
    ]
  ],
  "rampe": [
    [
      "cote",
      0.16
    ],
    [
      "montee",
      0.16
    ],
    [
      "pente",
      0.12
    ],
    [
      "chemin",
      0.08
    ],
    [
      "grimpette",
      0.08
    ],
    [
      "raidillon",
      0.08
    ],
    [
      "volee",
      0.04
    ],
    [
      "toboggan",
      0.04
    ],
    [
      "inclinaison",
      0.04
    ],
    [
      "declivite",
      0.04
    ],
    [
      "balustrade",
      0.04
    ],
    [
      "appui",
      0.04
    ],
    [
      "ecuyer",
      0.04
    ]
  ],
  "selon": [
    [
      "d'apres",
      0.235
    ],
    [
      "suivant",
      0.235
    ],
    [
      "conformement",
      0.1175
    ],
    [
      "dans",
      0.1175
    ],
    [
      "sur",
      0.1175
    ],
    [
      "jouxte",
      0.0575
    ]
  ],
  "pa": [],
  "chute": [
    [
      "ruine",
      0.0725
    ],
    [
      "decadence",
      0.0525
    ],
    [
      "effondrement",
      0.0525
    ],
    [
      "faillite",
      0.045
    ],
    [
      "ecroulement",
      0.0375
    ],
    [
      "culbute",
      0.0325
    ],
    [
      "affaissement",
      0.03
    ],
    [
      "abaissement",
      0.0275
    ],
    [
      "debacle",
      0.0275
    ],
    [
      "aneantissement",
      0.025
    ],
    [
      "decheance",
      0.025
    ],
    [
      "fin",
      0.025
    ],
    [
      "echec",
      0.0225
    ],
    [
      "krach",
      0.0225
    ],
    [
      "baisse",
      0.02
    ],
    [
      "declin",
      0.02
    ],
    [
      "defaite",
      0.02
    ],
    [
      "perte",
      0.02
    ],
    [
      "eboulement",
      0.015
    ],
    [
      "fiasco",
      0.015
    ],
    [
      "degringolade",
      0.015
    ],
    [
      "deconfiture",
      0.015
    ],
    [
      "cascade",
      0.015
    ],
    [
      "saut",
      0.0125
    ],
    [
      "plongeon",
      0.0125
    ],
    [
      "mort",
      0.0125
    ],
    [
      "insucces",
      0.0125
    ],
    [
      "degenerescence",
      0.0125
    ],
    [
      "descente",
      0.0125
    ],
    [
      "renversement",
      0.01
    ],
    [
      "deliquescence",
      0.01
    ],
    [
      "cabriole",
      0.01
    ],
    [
      "eclipse",
      0.0075
    ],
    [
      "rognure",
      0.0075
    ],
    [
      "mouvement",
      0.0075
    ],
    [
      "faute",
      0.0075
    ],
    [
      "cataracte",
      0.0075
    ],
    [
      "capitulation",
      0.0075
    ],
    [
      "avalanche",
      0.0075
    ],
    [
      "agonie",
      0.0075
    ],
    [
      "abattement",
      0.0075
    ],
    [
      "terminaison",
      0.005
    ],
    [
      "peche",
      0.005
    ],
    [
      "glissement",
      0.005
    ],
    [
      "glissade",
      0.005
    ],
    [
      "extremite",
      0.005
    ],
    [
      "deplacement",
      0.005
    ],
    [
      "decouragement",
      0.005
    ],
    [
      "dechet",
      0.005
    ],
    [
      "disgrace",
      0.005
    ],
    [
      "bascule",
      0.005
    ],
    [
      "accident",
      0.005
    ],
    [
      "ptose",
      0.0
    ],
    [
      "precipitation",
      0.0
    ],
    [
      "prolapsus",
      0.0
    ],
    [
      "pluie",
      0.0
    ],
    [
      "plane",
      0.0
    ],
    [
      "pelle",
      0.0
    ],
    [
      "rapide",
      0.0
    ],
    [
      "recoupe",
      0.0
    ],
    [
      "reddition",
      0.0
    ],
    [
      "scandale",
      0.0
    ],
    [
      "syncope",
      0.0
    ],
    [
      "tombee",
      0.0
    ],
    [
      "ecrasement",
      0.0
    ],
    [
      "four",
      0.0
    ],
    [
      "abdication",
      0.0
    ],
    [
      "achevement",
      0.0
    ],
    [
      "apherese",
      0.0
    ],
    [
      "apocope",
      0.0
    ],
    [
      "brisure",
      0.0
    ],
    [
      "buche",
      0.0
    ],
    [
      "carambolage",
      0.0
    ],
    [
      "cascatelle",
      0.0
    ],
    [
      "crise",
      0.0
    ],
    [
      "croulement",
      0.0
    ],
    [
      "decoupure",
      0.0
    ],
    [
      "demoralisation",
      0.0
    ],
    [
      "depreciation",
      0.0
    ],
    [
      "devaluation",
      0.0
    ],
    [
      "epluchure",
      0.0
    ]
  ],
  "fracturer": [
    [
      "briser",
      0.285
    ],
    [
      "rompre",
      0.285
    ],
    [
      "casser",
      0.1425
    ],
    [
      "forcer",
      0.1425
    ],
    [
      "fracasser",
      0.1425
    ]
  ],
  "fracture": [
    [
      "cassure",
      0.2175
    ],
    [
      "brisure",
      0.1725
    ],
    [
      "rupture",
      0.13
    ],
    [
      "felure",
      0.085
    ],
    [
      "bris",
      0.085
    ],
    [
      "blessure",
      0.085
    ],
    [
      "clase",
      0.0425
    ],
    [
      "coupure",
      0.0425
    ],
    [
      "effraction",
      0.0425
    ],
    [
      "faille",
      0.0425
    ],
    [
      "fraction",
      0.0425
    ]
  ],
  "perone": [],
  "repeter": [
    [
      "redire",
      0.0525
    ],
    [
      "refaire",
      0.0525
    ],
    [
      "reproduire",
      0.0525
    ],
    [
      "seriner",
      0.0525
    ],
    [
      "rabacher",
      0.0475
    ],
    [
      "repasser",
      0.04
    ],
    [
      "apprendre",
      0.0325
    ],
    [
      "reverberer",
      0.025
    ],
    [
      "repercuter",
      0.025
    ],
    [
      "ressasser",
      0.025
    ],
    [
      "reprendre",
      0.025
    ],
    [
      "renvoyer",
      0.025
    ],
    [
      "rendre",
      0.025
    ],
    [
      "chanter",
      0.025
    ],
    [
      "revoir",
      0.0175
    ],
    [
      "reiterer",
      0.0175
    ],
    [
      "retablir",
      0.0175
    ],
    [
      "reviser",
      0.0175
    ],
    [
      "etudier",
      0.0175
    ],
    [
      "renouveler",
      0.0175
    ],
    [
      "refleter",
      0.0175
    ],
    [
      "recommencer",
      0.0175
    ],
    [
      "rapporter",
      0.0175
    ],
    [
      "raconter",
      0.0175
    ],
    [
      "imiter",
      0.0175
    ],
    [
      "exprimer",
      0.0175
    ],
    [
      "singer",
      0.0125
    ],
    [
      "reflechir",
      0.0125
    ],
    [
      "radoter",
      0.0125
    ],
    [
      "potasser",
      0.0125
    ],
    [
      "copier",
      0.0125
    ],
    [
      "bisser",
      0.0125
    ],
    [
      "bachoter",
      0.0125
    ],
    [
      "multiplier",
      0.005
    ],
    [
      "precher",
      0.005
    ],
    [
      "rajuster",
      0.005
    ],
    [
      "rebattre",
      0.005
    ],
    [
      "recorder",
      0.005
    ],
    [
      "restaurer",
      0.005
    ],
    [
      "reclamer",
      0.005
    ],
    [
      "maintenir",
      0.005
    ],
    [
      "iterer",
      0.005
    ],
    [
      "bourdonner",
      0.005
    ],
    [
      "contrefaire",
      0.005
    ],
    [
      "emprunter",
      0.005
    ],
    [
      "inculquer",
      0.005
    ],
    [
      "insister",
      0.005
    ]
  ],
  "perroquet": [
    [
      "babillard",
      0.165
    ],
    [
      "cacatoes",
      0.165
    ],
    [
      "fougue",
      0.165
    ],
    [
      "jacquot",
      0.165
    ],
    [
      "papegai",
      0.165
    ],
    [
      "psittacide",
      0.165
    ]
  ],
  "caille": [
    [
      "poule",
      0.25
    ],
    [
      "biquette",
      0.125
    ],
    [
      "cocotte",
      0.125
    ],
    [
      "gibier",
      0.125
    ],
    [
      "grue",
      0.125
    ],
    [
      "poulette",
      0.125
    ],
    [
      "turnix",
      0.125
    ]
  ],
  "cailler": [
    [
      "caillebotter",
      0.2125
    ],
    [
      "coaguler",
      0.2125
    ],
    [
      "geler",
      0.2125
    ],
    [
      "figer",
      0.07
    ],
    [
      "grumeler",
      0.07
    ]
  ],
  "hopital": [
    [
      "clinique",
      0.1125
    ],
    [
      "asile",
      0.075
    ],
    [
      "hospice",
      0.075
    ],
    [
      "maison",
      0.075
    ],
    [
      "sanatorium",
      0.075
    ],
    [
      "maternite",
      0.035
    ],
    [
      "mouroir",
      0.035
    ],
    [
      "polyclinique",
      0.035
    ],
    [
      "preventorium",
      0.035
    ],
    [
      "refuge",
      0.035
    ],
    [
      "leproserie",
      0.035
    ],
    [
      "lazaret",
      0.035
    ],
    [
      "infirmerie",
      0.035
    ],
    [
      "hosto",
      0.035
    ],
    [
      "dispensaire",
      0.035
    ],
    [
      "creche",
      0.035
    ],
    [
      "ambulance",
      0.035
    ],
    [
      "solarium",
      0.035
    ]
  ],
  "accueillir": [
    [
      "recevoir",
      0.22
    ],
    [
      "traiter",
      0.1475
    ],
    [
      "heberger",
      0.11
    ],
    [
      "admettre",
      0.0725
    ],
    [
      "prendre",
      0.0725
    ],
    [
      "saluer",
      0.035
    ],
    [
      "s'ouvrir",
      0.035
    ],
    [
      "receptionner",
      0.035
    ],
    [
      "loger",
      0.035
    ],
    [
      "feter",
      0.035
    ],
    [
      "agreer",
      0.035
    ],
    [
      "accepter",
      0.035
    ],
    [
      "ecouter",
      0.035
    ]
  ],
  "repos": [
    [
      "calme",
      0.0575
    ],
    [
      "detente",
      0.05
    ],
    [
      "pause",
      0.05
    ],
    [
      "relache",
      0.045
    ],
    [
      "treve",
      0.045
    ],
    [
      "vacances",
      0.0375
    ],
    [
      "tranquillite",
      0.0375
    ],
    [
      "accalmie",
      0.0325
    ],
    [
      "inaction",
      0.0325
    ],
    [
      "interruption",
      0.0325
    ],
    [
      "paix",
      0.0325
    ],
    [
      "repit",
      0.0325
    ],
    [
      "remission",
      0.0275
    ],
    [
      "bonace",
      0.0275
    ],
    [
      "arret",
      0.0275
    ],
    [
      "cessation",
      0.0225
    ],
    [
      "conge",
      0.0225
    ],
    [
      "delassement",
      0.0225
    ],
    [
      "loisir",
      0.0225
    ],
    [
      "quietude",
      0.0225
    ],
    [
      "sommeil",
      0.0225
    ],
    [
      "suspension",
      0.015
    ],
    [
      "inactivite",
      0.015
    ],
    [
      "immobilite",
      0.015
    ],
    [
      "halte",
      0.015
    ],
    [
      "etape",
      0.01
    ],
    [
      "serenite",
      0.01
    ],
    [
      "securite",
      0.01
    ],
    [
      "silence",
      0.01
    ],
    [
      "sieste",
      0.01
    ],
    [
      "recreation",
      0.01
    ],
    [
      "relachement",
      0.01
    ],
    [
      "inertie",
      0.01
    ],
    [
      "cesure",
      0.01
    ],
    [
      "meridienne",
      0.005
    ],
    [
      "palier",
      0.005
    ],
    [
      "respiration",
      0.005
    ],
    [
      "retraite",
      0.005
    ],
    [
      "jachere",
      0.005
    ],
    [
      "immuabilite",
      0.005
    ],
    [
      "friche",
      0.005
    ],
    [
      "entracte",
      0.005
    ],
    [
      "coupe",
      0.005
    ],
    [
      "convalescence",
      0.005
    ],
    [
      "cesse",
      0.005
    ],
    [
      "campos",
      0.005
    ],
    [
      "assurance",
      0.005
    ],
    [
      "assouvissement",
      0.005
    ]
  ],
  "maquer": [],
  "quete": [
    [
      "demande",
      0.1725
    ],
    [
      "recherche",
      0.13
    ],
    [
      "poursuite",
      0.085
    ],
    [
      "requete",
      0.085
    ],
    [
      "soif",
      0.085
    ],
    [
      "sonnerie",
      0.0425
    ],
    [
      "recolte",
      0.0425
    ],
    [
      "revendication",
      0.0425
    ],
    [
      "ramassage",
      0.0425
    ],
    [
      "enquete",
      0.0425
    ],
    [
      "collecte",
      0.0425
    ],
    [
      "chasse",
      0.0425
    ],
    [
      "aumone",
      0.0425
    ],
    [
      "ambition",
      0.0425
    ],
    [
      "supplication",
      0.0425
    ]
  ],
  "queter": [
    [
      "demander",
      0.1375
    ],
    [
      "rechercher",
      0.1375
    ],
    [
      "solliciter",
      0.1375
    ],
    [
      "quemander",
      0.1025
    ],
    [
      "revendiquer",
      0.1025
    ],
    [
      "pourchasser",
      0.0675
    ],
    [
      "implorer",
      0.0675
    ],
    [
      "recueillir",
      0.0325
    ],
    [
      "mendier",
      0.0325
    ],
    [
      "chercher",
      0.0325
    ],
    [
      "chasser",
      0.0325
    ],
    [
      "briller",
      0.0325
    ],
    [
      "ambitionner",
      0.0325
    ],
    [
      "reclamer",
      0.0325
    ]
  ],
  "bordel": [
    [
      "desordre",
      0.1175
    ],
    [
      "bazar",
      0.09
    ],
    [
      "tapage",
      0.0725
    ],
    [
      "bastringue",
      0.0625
    ],
    [
      "vacarme",
      0.0525
    ],
    [
      "foutoir",
      0.045
    ],
    [
      "bouge",
      0.045
    ],
    [
      "bruit",
      0.035
    ],
    [
      "scandale",
      0.025
    ],
    [
      "confusion",
      0.025
    ],
    [
      "boxon",
      0.025
    ],
    [
      "bousin",
      0.025
    ],
    [
      "boucan",
      0.025
    ],
    [
      "bataclan",
      0.025
    ],
    [
      "affaire",
      0.025
    ],
    [
      "tremblement",
      0.015
    ],
    [
      "taudis",
      0.015
    ],
    [
      "pagaille",
      0.015
    ],
    [
      "chaos",
      0.015
    ],
    [
      "capharnaum",
      0.015
    ],
    [
      "merde",
      0.0075
    ],
    [
      "margaille",
      0.0075
    ],
    [
      "lupanar",
      0.0075
    ],
    [
      "gynecee",
      0.0075
    ],
    [
      "fouillis",
      0.0075
    ],
    [
      "claque",
      0.0075
    ],
    [
      "clande",
      0.0075
    ],
    [
      "chabanais",
      0.0075
    ],
    [
      "bordeau",
      0.0075
    ],
    [
      "bocard",
      0.0075
    ],
    [
      "bobinard",
      0.0075
    ],
    [
      "bidule",
      0.0075
    ],
    [
      "bauge",
      0.0075
    ],
    [
      "souk",
      0.0075
    ]
  ],
  "stone": [],
  "clan": [
    [
      "groupe",
      0.135
    ],
    [
      "coterie",
      0.1275
    ],
    [
      "parti",
      0.0575
    ],
    [
      "association",
      0.05
    ],
    [
      "societe",
      0.045
    ],
    [
      "faction",
      0.04
    ],
    [
      "colonie",
      0.04
    ],
    [
      "chapelle",
      0.04
    ],
    [
      "bande",
      0.04
    ],
    [
      "secte",
      0.035
    ],
    [
      "clique",
      0.035
    ],
    [
      "famille",
      0.03
    ],
    [
      "reunion",
      0.03
    ],
    [
      "camarilla",
      0.025
    ],
    [
      "tribu",
      0.025
    ],
    [
      "cercle",
      0.02
    ],
    [
      "classe",
      0.02
    ],
    [
      "division",
      0.0175
    ],
    [
      "camp",
      0.0175
    ],
    [
      "boutique",
      0.0175
    ],
    [
      "cabale",
      0.0125
    ],
    [
      "caste",
      0.0125
    ],
    [
      "cenacle",
      0.0125
    ],
    [
      "ligue",
      0.0125
    ],
    [
      "phalange",
      0.0125
    ],
    [
      "sorte",
      0.0125
    ],
    [
      "eglise",
      0.0075
    ],
    [
      "horde",
      0.0075
    ],
    [
      "cote",
      0.0075
    ],
    [
      "cellule",
      0.0025
    ],
    [
      "lignee",
      0.0025
    ],
    [
      "maffia",
      0.0025
    ],
    [
      "matriclan",
      0.0025
    ],
    [
      "patriclan",
      0.0025
    ]
  ],
  "ventre": [
    [
      "abdomen",
      0.14
    ],
    [
      "bedaine",
      0.12
    ],
    [
      "bedon",
      0.1
    ],
    [
      "panse",
      0.08
    ],
    [
      "bidon",
      0.0575
    ],
    [
      "tirelire",
      0.0575
    ],
    [
      "sein",
      0.04
    ],
    [
      "brioche",
      0.04
    ],
    [
      "bide",
      0.04
    ],
    [
      "renflement",
      0.0175
    ],
    [
      "paillasse",
      0.0175
    ],
    [
      "hypogastre",
      0.0175
    ],
    [
      "gaster",
      0.0175
    ],
    [
      "flanc",
      0.0175
    ],
    [
      "fanal",
      0.0175
    ],
    [
      "estomac",
      0.0175
    ],
    [
      "entrailles",
      0.0175
    ],
    [
      "coquatre",
      0.0175
    ],
    [
      "buffet",
      0.0175
    ],
    [
      "bombement",
      0.0175
    ],
    [
      "bocal",
      0.0175
    ],
    [
      "berdouille",
      0.0175
    ],
    [
      "bedondaine",
      0.0175
    ],
    [
      "uterus",
      0.0175
    ]
  ],
  "investir": [
    [
      "cerner",
      0.185
    ],
    [
      "enfermer",
      0.1
    ],
    [
      "encercler",
      0.085
    ],
    [
      "envelopper",
      0.085
    ],
    [
      "assieger",
      0.07
    ],
    [
      "emprisonner",
      0.07
    ],
    [
      "environner",
      0.055
    ],
    [
      "boucler",
      0.04
    ],
    [
      "pourvoir",
      0.04
    ],
    [
      "revetir",
      0.0275
    ],
    [
      "placer",
      0.0275
    ],
    [
      "introniser",
      0.0275
    ],
    [
      "installer",
      0.0275
    ],
    [
      "fermer",
      0.0275
    ],
    [
      "bloquer",
      0.0275
    ],
    [
      "attaquer",
      0.0275
    ],
    [
      "conferer",
      0.0125
    ],
    [
      "doter",
      0.0125
    ],
    [
      "engager",
      0.0125
    ]
  ],
  "fortune": [
    [
      "richesse",
      0.085
    ],
    [
      "destin",
      0.065
    ],
    [
      "sort",
      0.065
    ],
    [
      "argent",
      0.055
    ],
    [
      "bien",
      0.045
    ],
    [
      "chance",
      0.045
    ],
    [
      "destinee",
      0.045
    ],
    [
      "hasard",
      0.045
    ],
    [
      "prosperite",
      0.045
    ],
    [
      "capital",
      0.0375
    ],
    [
      "abondance",
      0.0275
    ],
    [
      "aventure",
      0.0275
    ],
    [
      "avoir",
      0.0275
    ],
    [
      "issue",
      0.0275
    ],
    [
      "succes",
      0.0275
    ],
    [
      "vie",
      0.0275
    ],
    [
      "etat",
      0.0175
    ],
    [
      "ressource",
      0.0175
    ],
    [
      "patrimoine",
      0.0175
    ],
    [
      "opulence",
      0.0175
    ],
    [
      "fait",
      0.0175
    ],
    [
      "bonheur",
      0.0175
    ],
    [
      "biens",
      0.0175
    ],
    [
      "quibus",
      0.0075
    ],
    [
      "risque",
      0.0075
    ],
    [
      "reussite",
      0.0075
    ],
    [
      "situation",
      0.0075
    ],
    [
      "tresor",
      0.0075
    ],
    [
      "meuble",
      0.0075
    ],
    [
      "luxe",
      0.0075
    ],
    [
      "incertitude",
      0.0075
    ],
    [
      "grandeur",
      0.0075
    ],
    [
      "goelette",
      0.0075
    ],
    [
      "galette",
      0.0075
    ],
    [
      "fatalite",
      0.0075
    ],
    [
      "enrichissement",
      0.0075
    ],
    [
      "avenir",
      0.0075
    ],
    [
      "etoile",
      0.0075
    ]
  ],
  "formater": [
    [
      "initialiser",
      1.0
    ]
  ],
  "boulot": [
    [
      "gros",
      0.0875
    ],
    [
      "trapu",
      0.0875
    ],
    [
      "travail",
      0.0875
    ],
    [
      "turbin",
      0.065
    ],
    [
      "rond",
      0.065
    ],
    [
      "gras",
      0.065
    ],
    [
      "court",
      0.065
    ],
    [
      "besogne",
      0.065
    ],
    [
      "rondelet",
      0.0425
    ],
    [
      "ragot",
      0.0425
    ],
    [
      "job",
      0.0425
    ],
    [
      "courtaud",
      0.0425
    ],
    [
      "trimard",
      0.02
    ],
    [
      "tapin",
      0.02
    ],
    [
      "rondouillard",
      0.02
    ],
    [
      "ramasse",
      0.02
    ],
    [
      "ouvrage",
      0.02
    ],
    [
      "obese",
      0.02
    ],
    [
      "metier",
      0.02
    ],
    [
      "grassouillet",
      0.02
    ],
    [
      "boudin",
      0.02
    ],
    [
      "tache",
      0.02
    ]
  ],
  "epuise": [
    [
      "fatiguer",
      0.0675
    ],
    [
      "aneantir",
      0.06
    ],
    [
      "extenuer",
      0.0575
    ],
    [
      "ereinter",
      0.0525
    ],
    [
      "abattre",
      0.0475
    ],
    [
      "ruiner",
      0.045
    ],
    [
      "detruire",
      0.04
    ],
    [
      "vider",
      0.0375
    ],
    [
      "consumer",
      0.0375
    ],
    [
      "briser",
      0.0375
    ],
    [
      "affaiblir",
      0.03
    ],
    [
      "harasser",
      0.0275
    ],
    [
      "user",
      0.025
    ],
    [
      "tuer",
      0.0225
    ],
    [
      "devorer",
      0.02
    ],
    [
      "esquinter",
      0.0175
    ],
    [
      "diminuer",
      0.0175
    ],
    [
      "claquer",
      0.015
    ],
    [
      "dessecher",
      0.015
    ],
    [
      "demolir",
      0.015
    ],
    [
      "exceder",
      0.015
    ],
    [
      "miner",
      0.015
    ],
    [
      "vanner",
      0.015
    ],
    [
      "engloutir",
      0.0125
    ],
    [
      "accabler",
      0.0125
    ],
    [
      "dissiper",
      0.01
    ],
    [
      "depenser",
      0.01
    ],
    [
      "deprimer",
      0.01
    ],
    [
      "tarir",
      0.01
    ],
    [
      "pomper",
      0.0075
    ],
    [
      "liquider",
      0.0075
    ],
    [
      "absorber",
      0.0075
    ],
    [
      "crever",
      0.0075
    ],
    [
      "saigner",
      0.0075
    ],
    [
      "surmener",
      0.0075
    ],
    [
      "terminer",
      0.0075
    ],
    [
      "pressurer",
      0.005
    ],
    [
      "ronger",
      0.005
    ],
    [
      "steriliser",
      0.005
    ],
    [
      "secher",
      0.005
    ],
    [
      "lasser",
      0.005
    ],
    [
      "finir",
      0.005
    ],
    [
      "dilapider",
      0.005
    ],
    [
      "consommer",
      0.005
    ],
    [
      "assecher",
      0.005
    ],
    [
      "appauvrir",
      0.005
    ],
    [
      "amaigrir",
      0.005
    ],
    [
      "travailler",
      0.0025
    ],
    [
      "obseder",
      0.0025
    ],
    [
      "gaspiller",
      0.0025
    ],
    [
      "delabrer",
      0.0025
    ],
    [
      "anemier",
      0.0025
    ],
    [
      "traiter",
      0.0
    ],
    [
      "s'etendre",
      0.0
    ],
    [
      "effriter",
      0.0
    ],
    [
      "debiliter",
      0.0
    ],
    [
      "ecouler",
      0.0
    ]
  ],
  "epuiser": [
    [
      "fatiguer",
      0.0675
    ],
    [
      "aneantir",
      0.06
    ],
    [
      "extenuer",
      0.0575
    ],
    [
      "ereinter",
      0.0525
    ],
    [
      "abattre",
      0.0475
    ],
    [
      "ruiner",
      0.045
    ],
    [
      "detruire",
      0.04
    ],
    [
      "vider",
      0.0375
    ],
    [
      "consumer",
      0.0375
    ],
    [
      "briser",
      0.0375
    ],
    [
      "affaiblir",
      0.03
    ],
    [
      "harasser",
      0.0275
    ],
    [
      "user",
      0.025
    ],
    [
      "tuer",
      0.0225
    ],
    [
      "devorer",
      0.02
    ],
    [
      "esquinter",
      0.0175
    ],
    [
      "diminuer",
      0.0175
    ],
    [
      "claquer",
      0.015
    ],
    [
      "dessecher",
      0.015
    ],
    [
      "demolir",
      0.015
    ],
    [
      "exceder",
      0.015
    ],
    [
      "miner",
      0.015
    ],
    [
      "vanner",
      0.015
    ],
    [
      "engloutir",
      0.0125
    ],
    [
      "accabler",
      0.0125
    ],
    [
      "dissiper",
      0.01
    ],
    [
      "depenser",
      0.01
    ],
    [
      "deprimer",
      0.01
    ],
    [
      "tarir",
      0.01
    ],
    [
      "pomper",
      0.0075
    ],
    [
      "liquider",
      0.0075
    ],
    [
      "absorber",
      0.0075
    ],
    [
      "crever",
      0.0075
    ],
    [
      "saigner",
      0.0075
    ],
    [
      "surmener",
      0.0075
    ],
    [
      "terminer",
      0.0075
    ],
    [
      "pressurer",
      0.005
    ],
    [
      "ronger",
      0.005
    ],
    [
      "steriliser",
      0.005
    ],
    [
      "secher",
      0.005
    ],
    [
      "lasser",
      0.005
    ],
    [
      "finir",
      0.005
    ],
    [
      "dilapider",
      0.005
    ],
    [
      "consommer",
      0.005
    ],
    [
      "assecher",
      0.005
    ],
    [
      "appauvrir",
      0.005
    ],
    [
      "amaigrir",
      0.005
    ],
    [
      "travailler",
      0.0025
    ],
    [
      "obseder",
      0.0025
    ],
    [
      "gaspiller",
      0.0025
    ],
    [
      "delabrer",
      0.0025
    ],
    [
      "anemier",
      0.0025
    ],
    [
      "traiter",
      0.0
    ],
    [
      "s'etendre",
      0.0
    ],
    [
      "effriter",
      0.0
    ],
    [
      "debiliter",
      0.0
    ],
    [
      "ecouler",
      0.0
    ]
  ],
  "diffuser": [
    [
      "propager",
      0.17
    ],
    [
      "repandre",
      0.17
    ],
    [
      "generaliser",
      0.1025
    ],
    [
      "transmettre",
      0.1025
    ],
    [
      "vehiculer",
      0.0675
    ],
    [
      "universaliser",
      0.0325
    ],
    [
      "vulgariser",
      0.0325
    ],
    [
      "ecouler",
      0.0325
    ],
    [
      "reverberer",
      0.0325
    ],
    [
      "distribuer",
      0.0325
    ],
    [
      "disperser",
      0.0325
    ],
    [
      "colporter",
      0.0325
    ],
    [
      "accrediter",
      0.0325
    ],
    [
      "emettre",
      0.0325
    ]
  ],
  "porteur": [
    [
      "portefaix",
      0.105
    ],
    [
      "messager",
      0.0775
    ],
    [
      "facteur",
      0.0525
    ],
    [
      "dechargeur",
      0.0525
    ],
    [
      "docker",
      0.0525
    ],
    [
      "crocheteur",
      0.0525
    ],
    [
      "coltineur",
      0.0525
    ],
    [
      "fort",
      0.025
    ],
    [
      "laptot",
      0.025
    ],
    [
      "livreur",
      0.025
    ],
    [
      "manutentionnaire",
      0.025
    ],
    [
      "nervi",
      0.025
    ],
    [
      "sherpa",
      0.025
    ],
    [
      "faquin",
      0.025
    ],
    [
      "estafette",
      0.025
    ],
    [
      "detenteur",
      0.025
    ],
    [
      "demenageur",
      0.025
    ],
    [
      "debardeur",
      0.025
    ],
    [
      "coursier",
      0.025
    ],
    [
      "courrier",
      0.025
    ],
    [
      "coolie",
      0.025
    ],
    [
      "commissionnaire",
      0.025
    ],
    [
      "actionnaire",
      0.025
    ],
    [
      "telegraphiste",
      0.025
    ]
  ],
  "mangeur": [
    [
      "glouton",
      0.2
    ],
    [
      "bafreur",
      0.15
    ],
    [
      "goinfre",
      0.0975
    ],
    [
      "briffeur",
      0.0975
    ],
    [
      "briffaud",
      0.0975
    ],
    [
      "boustifailleur",
      0.0975
    ],
    [
      "bouffeur",
      0.0475
    ],
    [
      "exploiteur",
      0.0475
    ],
    [
      "gargantua",
      0.0475
    ]
  ],
  "amene": [
    [
      "entrainer",
      0.1125
    ],
    [
      "provoquer",
      0.06
    ],
    [
      "attirer",
      0.0525
    ],
    [
      "soulever",
      0.0525
    ],
    [
      "pousser",
      0.0425
    ],
    [
      "conduire",
      0.0425
    ],
    [
      "appeler",
      0.035
    ],
    [
      "apporter",
      0.035
    ],
    [
      "occasionner",
      0.035
    ],
    [
      "determiner",
      0.0325
    ],
    [
      "susciter",
      0.0325
    ],
    [
      "produire",
      0.0275
    ],
    [
      "transporter",
      0.025
    ],
    [
      "gagner",
      0.02
    ],
    [
      "tirer",
      0.0175
    ],
    [
      "mettre",
      0.0175
    ],
    [
      "mener",
      0.0175
    ],
    [
      "conquerir",
      0.0175
    ],
    [
      "causer",
      0.0175
    ],
    [
      "trainer",
      0.0125
    ],
    [
      "seduire",
      0.0125
    ],
    [
      "preparer",
      0.0125
    ],
    [
      "engager",
      0.0125
    ],
    [
      "descendre",
      0.0125
    ],
    [
      "convaincre",
      0.0125
    ],
    [
      "etablir",
      0.01
    ],
    [
      "procurer",
      0.01
    ],
    [
      "passer",
      0.01
    ],
    [
      "importer",
      0.01
    ],
    [
      "forcer",
      0.01
    ],
    [
      "engendrer",
      0.01
    ],
    [
      "creer",
      0.01
    ],
    [
      "ramener",
      0.005
    ],
    [
      "presenter",
      0.005
    ],
    [
      "predisposer",
      0.005
    ],
    [
      "preceder",
      0.005
    ],
    [
      "operer",
      0.005
    ],
    [
      "menager",
      0.005
    ],
    [
      "declencher",
      0.005
    ],
    [
      "convertir",
      0.005
    ],
    [
      "baisser",
      0.005
    ],
    [
      "abaisser",
      0.005
    ],
    [
      "resoudre",
      0.0025
    ],
    [
      "retourner",
      0.0025
    ],
    [
      "remener",
      0.0025
    ],
    [
      "querir",
      0.0025
    ],
    [
      "enroler",
      0.0025
    ],
    [
      "distribuer",
      0.0025
    ],
    [
      "acheminer",
      0.0025
    ],
    [
      "s'accompagner",
      0.0025
    ]
  ],
  "amener": [
    [
      "entrainer",
      0.1125
    ],
    [
      "provoquer",
      0.06
    ],
    [
      "attirer",
      0.0525
    ],
    [
      "soulever",
      0.0525
    ],
    [
      "pousser",
      0.0425
    ],
    [
      "conduire",
      0.0425
    ],
    [
      "appeler",
      0.035
    ],
    [
      "apporter",
      0.035
    ],
    [
      "occasionner",
      0.035
    ],
    [
      "determiner",
      0.0325
    ],
    [
      "susciter",
      0.0325
    ],
    [
      "produire",
      0.0275
    ],
    [
      "transporter",
      0.025
    ],
    [
      "gagner",
      0.02
    ],
    [
      "tirer",
      0.0175
    ],
    [
      "mettre",
      0.0175
    ],
    [
      "mener",
      0.0175
    ],
    [
      "conquerir",
      0.0175
    ],
    [
      "causer",
      0.0175
    ],
    [
      "trainer",
      0.0125
    ],
    [
      "seduire",
      0.0125
    ],
    [
      "preparer",
      0.0125
    ],
    [
      "engager",
      0.0125
    ],
    [
      "descendre",
      0.0125
    ],
    [
      "convaincre",
      0.0125
    ],
    [
      "etablir",
      0.01
    ],
    [
      "procurer",
      0.01
    ],
    [
      "passer",
      0.01
    ],
    [
      "importer",
      0.01
    ],
    [
      "forcer",
      0.01
    ],
    [
      "engendrer",
      0.01
    ],
    [
      "creer",
      0.01
    ],
    [
      "ramener",
      0.005
    ],
    [
      "presenter",
      0.005
    ],
    [
      "predisposer",
      0.005
    ],
    [
      "preceder",
      0.005
    ],
    [
      "operer",
      0.005
    ],
    [
      "menager",
      0.005
    ],
    [
      "declencher",
      0.005
    ],
    [
      "convertir",
      0.005
    ],
    [
      "baisser",
      0.005
    ],
    [
      "abaisser",
      0.005
    ],
    [
      "resoudre",
      0.0025
    ],
    [
      "retourner",
      0.0025
    ],
    [
      "remener",
      0.0025
    ],
    [
      "querir",
      0.0025
    ],
    [
      "enroler",
      0.0025
    ],
    [
      "distribuer",
      0.0025
    ],
    [
      "acheminer",
      0.0025
    ],
    [
      "s'accompagner",
      0.0025
    ]
  ],
  "priser": [
    [
      "estimer",
      0.2725
    ],
    [
      "apprecier",
      0.135
    ],
    [
      "aspirer",
      0.09
    ],
    [
      "sniffer",
      0.045
    ],
    [
      "renifler",
      0.045
    ],
    [
      "prendre",
      0.045
    ],
    [
      "inspirer",
      0.045
    ],
    [
      "humer",
      0.045
    ],
    [
      "honorer",
      0.045
    ],
    [
      "gouter",
      0.045
    ],
    [
      "cherir",
      0.045
    ],
    [
      "evaluer",
      0.045
    ]
  ],
  "prise": [
    [
      "gagner",
      0.035
    ],
    [
      "attraper",
      0.035
    ],
    [
      "saisir",
      0.0325
    ],
    [
      "piquer",
      0.03
    ],
    [
      "enlever",
      0.03
    ],
    [
      "voler",
      0.0225
    ],
    [
      "s'emparer",
      0.02
    ],
    [
      "faire",
      0.0175
    ],
    [
      "derober",
      0.0175
    ],
    [
      "obtenir",
      0.015
    ],
    [
      "recevoir",
      0.0125
    ],
    [
      "tenir",
      0.0125
    ],
    [
      "tirer",
      0.0125
    ],
    [
      "arreter",
      0.01
    ],
    [
      "ramasser",
      0.01
    ],
    [
      "retenir",
      0.01
    ],
    [
      "toucher",
      0.01
    ],
    [
      "s'approprier",
      0.01
    ],
    [
      "retirer",
      0.01
    ],
    [
      "fixer",
      0.01
    ],
    [
      "emporter",
      0.01
    ],
    [
      "conquerir",
      0.01
    ],
    [
      "ravir",
      0.01
    ],
    [
      "pincer",
      0.01
    ],
    [
      "chiper",
      0.01
    ],
    [
      "avoir",
      0.01
    ],
    [
      "attacher",
      0.01
    ],
    [
      "accrocher",
      0.01
    ],
    [
      "remporter",
      0.0075
    ],
    [
      "seduire",
      0.0075
    ],
    [
      "soustraire",
      0.0075
    ],
    [
      "mettre",
      0.0075
    ],
    [
      "faucher",
      0.0075
    ],
    [
      "embrasser",
      0.0075
    ],
    [
      "absorber",
      0.0075
    ],
    [
      "suivre",
      0.005
    ],
    [
      "s'attacher",
      0.005
    ],
    [
      "occuper",
      0.005
    ],
    [
      "empoigner",
      0.005
    ],
    [
      "attirer",
      0.005
    ],
    [
      "monter",
      0.005
    ],
    [
      "regarder",
      0.005
    ],
    [
      "recolter",
      0.005
    ],
    [
      "serrer",
      0.005
    ],
    [
      "soutirer",
      0.005
    ],
    [
      "traiter",
      0.005
    ],
    [
      "manger",
      0.005
    ],
    [
      "engager",
      0.005
    ],
    [
      "encaisser",
      0.005
    ],
    [
      "aller",
      0.005
    ],
    [
      "arracher",
      0.005
    ],
    [
      "atteindre",
      0.005
    ],
    [
      "choper",
      0.005
    ],
    [
      "cueillir",
      0.005
    ],
    [
      "emprunter",
      0.005
    ],
    [
      "piller",
      0.005
    ],
    [
      "rafler",
      0.005
    ],
    [
      "ratiboiser",
      0.005
    ],
    [
      "recueillir",
      0.005
    ],
    [
      "surprendre",
      0.005
    ],
    [
      "user",
      0.005
    ],
    [
      "epingler",
      0.005
    ],
    [
      "oter",
      0.005
    ],
    [
      "percevoir",
      0.005
    ],
    [
      "geler",
      0.005
    ],
    [
      "acquerir",
      0.005
    ],
    [
      "adopter",
      0.005
    ],
    [
      "attaquer",
      0.005
    ],
    [
      "capturer",
      0.005
    ],
    [
      "comprendre",
      0.005
    ],
    [
      "considerer",
      0.005
    ],
    [
      "contracter",
      0.005
    ],
    [
      "envahir",
      0.005
    ],
    [
      "figer",
      0.0025
    ],
    [
      "forcer",
      0.0025
    ],
    [
      "harponner",
      0.0025
    ],
    [
      "mordre",
      0.0025
    ],
    [
      "s'appliquer",
      0.0025
    ],
    [
      "soulever",
      0.0025
    ],
    [
      "usurper",
      0.0025
    ],
    [
      "etreindre",
      0.0025
    ],
    [
      "entrer",
      0.0025
    ],
    [
      "employer",
      0.0025
    ],
    [
      "accaparer",
      0.0025
    ],
    [
      "agrafer",
      0.0025
    ],
    [
      "apprehender",
      0.0025
    ],
    [
      "bruler",
      0.0025
    ],
    [
      "coincer",
      0.0025
    ],
    [
      "confisquer",
      0.0025
    ],
    [
      "disposer",
      0.0025
    ],
    [
      "devorer",
      0.0025
    ],
    [
      "plagier",
      0.0025
    ],
    [
      "posseder",
      0.0025
    ],
    [
      "prelever",
      0.0025
    ],
    [
      "s'assurer",
      0.0025
    ],
    [
      "souffler",
      0.0025
    ],
    [
      "estimer",
      0.0025
    ],
    [
      "embarquer",
      0.0025
    ],
    [
      "agripper",
      0.0025
    ],
    [
      "avaler",
      0.0025
    ],
    [
      "charger",
      0.0025
    ],
    [
      "choisir",
      0.0025
    ],
    [
      "coller",
      0.0025
    ],
    [
      "connaitre",
      0.0025
    ],
    [
      "retrancher",
      0.0
    ],
    [
      "ratisser",
      0.0
    ],
    [
      "piper",
      0.0
    ],
    [
      "piger",
      0.0
    ],
    [
      "nommer",
      0.0
    ],
    [
      "marcher",
      0.0
    ],
    [
      "happer",
      0.0
    ],
    [
      "reussir",
      0.0
    ],
    [
      "subir",
      0.0
    ],
    [
      "supposer",
      0.0
    ],
    [
      "selectionner",
      0.0
    ],
    [
      "tourner",
      0.0
    ],
    [
      "tuer",
      0.0
    ],
    [
      "utiliser",
      0.0
    ],
    [
      "ecoper",
      0.0
    ],
    [
      "extraire",
      0.0
    ],
    [
      "envisager",
      0.0
    ],
    [
      "acheter",
      0.0
    ],
    [
      "admettre",
      0.0
    ],
    [
      "affecter",
      0.0
    ],
    [
      "amadouer",
      0.0
    ],
    [
      "assurer",
      0.0
    ],
    [
      "barboter",
      0.0
    ],
    [
      "boire",
      0.0
    ],
    [
      "caillebotter",
      0.0
    ],
    [
      "chauffer",
      0.0
    ],
    [
      "entortiller",
      0.0
    ],
    [
      "enfiler",
      0.0
    ],
    [
      "designer",
      0.0
    ],
    [
      "consommer",
      0.0
    ],
    [
      "compter",
      0.0
    ],
    [
      "commencer",
      0.0
    ],
    [
      "chercher",
      0.0
    ],
    [
      "s'engager",
      0.0
    ],
    [
      "s'attribuer",
      0.0
    ],
    [
      "reputer",
      0.0
    ],
    [
      "reprendre",
      0.0
    ],
    [
      "recruter",
      0.0
    ],
    [
      "poisser",
      0.0
    ],
    [
      "persuader",
      0.0
    ],
    [
      "oppresser",
      0.0
    ],
    [
      "elire",
      0.0
    ],
    [
      "vendanger",
      0.0
    ],
    [
      "sortir",
      0.0
    ],
    [
      "juger",
      0.0
    ],
    [
      "interpreter",
      0.0
    ],
    [
      "intercepter",
      0.0
    ],
    [
      "couter",
      0.0
    ],
    [
      "compiler",
      0.0
    ],
    [
      "coaguler",
      0.0
    ],
    [
      "ceinturer",
      0.0
    ],
    [
      "assumer",
      0.0
    ],
    [
      "arquepincer",
      0.0
    ],
    [
      "apprivoiser",
      0.0
    ],
    [
      "apporter",
      0.0
    ],
    [
      "accueillir",
      0.0
    ],
    [
      "durcir",
      0.0
    ],
    [
      "deguster",
      0.0
    ],
    [
      "demarquer",
      0.0
    ],
    [
      "ingurgiter",
      0.0
    ],
    [
      "harper",
      0.0
    ],
    [
      "gripper",
      0.0
    ],
    [
      "ferrer",
      0.0
    ],
    [
      "exiger",
      0.0
    ],
    [
      "essuyer",
      0.0
    ],
    [
      "endosser",
      0.0
    ],
    [
      "emmener",
      0.0
    ],
    [
      "devaliser",
      0.0
    ],
    [
      "s'amorcer",
      0.0
    ],
    [
      "s'adjoindre",
      0.0
    ],
    [
      "puiser",
      0.0
    ],
    [
      "priser",
      0.0
    ],
    [
      "piocher",
      0.0
    ],
    [
      "s'associer",
      0.0
    ],
    [
      "s'implanter",
      0.0
    ],
    [
      "ecumer",
      0.0
    ],
    [
      "epaissir",
      0.0
    ],
    [
      "paumer",
      0.0
    ],
    [
      "ingerer",
      0.0
    ],
    [
      "aveindre",
      0.0
    ],
    [
      "chouraver",
      0.0
    ],
    [
      "colleter",
      0.0
    ],
    [
      "congeler",
      0.0
    ],
    [
      "coopter",
      0.0
    ],
    [
      "cramer",
      0.0
    ],
    [
      "crocher",
      0.0
    ],
    [
      "debuter",
      0.0
    ],
    [
      "decimer",
      0.0
    ],
    [
      "embaucher",
      0.0
    ],
    [
      "heberger",
      0.0
    ],
    [
      "arnaquer",
      0.0
    ]
  ],
  "aikido": [],
  "kilo": [],
  "dollar": [],
  "donnant": [
    [
      "genereux",
      0.3325
    ],
    [
      "large",
      0.3325
    ],
    [
      "philanthrope",
      0.3325
    ]
  ],
  "latte": [
    [
      "baton",
      0.125
    ],
    [
      "claquet",
      0.125
    ],
    [
      "perche",
      0.125
    ],
    [
      "pied",
      0.125
    ],
    [
      "planche",
      0.125
    ],
    [
      "plancher",
      0.125
    ],
    [
      "volige",
      0.125
    ],
    [
      "epee",
      0.125
    ]
  ],
  "latter": [
    [
      "botter",
      1.0
    ]
  ],
  "troue": [
    [
      "percer",
      0.25
    ],
    [
      "transpercer",
      0.25
    ],
    [
      "creuser",
      0.0925
    ],
    [
      "traverser",
      0.0625
    ],
    [
      "penetrer",
      0.0625
    ],
    [
      "perforer",
      0.0625
    ],
    [
      "ouvrir",
      0.0625
    ],
    [
      "forer",
      0.0625
    ],
    [
      "dechirer",
      0.0625
    ],
    [
      "piquer",
      0.03
    ]
  ],
  "trouer": [
    [
      "percer",
      0.25
    ],
    [
      "transpercer",
      0.25
    ],
    [
      "creuser",
      0.0925
    ],
    [
      "traverser",
      0.0625
    ],
    [
      "penetrer",
      0.0625
    ],
    [
      "perforer",
      0.0625
    ],
    [
      "ouvrir",
      0.0625
    ],
    [
      "forer",
      0.0625
    ],
    [
      "dechirer",
      0.0625
    ],
    [
      "piquer",
      0.03
    ]
  ],
  "affreux": [
    [
      "horrible",
      0.095
    ],
    [
      "mauvais",
      0.0775
    ],
    [
      "laid",
      0.0525
    ],
    [
      "epouvantable",
      0.05
    ],
    [
      "atroce",
      0.045
    ],
    [
      "terrible",
      0.0425
    ],
    [
      "repoussant",
      0.0425
    ],
    [
      "monstrueux",
      0.04
    ],
    [
      "abominable",
      0.035
    ],
    [
      "odieux",
      0.035
    ],
    [
      "repugnant",
      0.035
    ],
    [
      "ignoble",
      0.0325
    ],
    [
      "degoutant",
      0.0325
    ],
    [
      "desagreable",
      0.0275
    ],
    [
      "detestable",
      0.0275
    ],
    [
      "infect",
      0.02
    ],
    [
      "execrable",
      0.02
    ],
    [
      "effrayant",
      0.02
    ],
    [
      "cruel",
      0.02
    ],
    [
      "hideux",
      0.015
    ],
    [
      "sale",
      0.015
    ],
    [
      "vilain",
      0.015
    ],
    [
      "mechant",
      0.0125
    ],
    [
      "inhumain",
      0.0125
    ],
    [
      "effroyable",
      0.0125
    ],
    [
      "feroce",
      0.01
    ],
    [
      "penible",
      0.01
    ],
    [
      "triste",
      0.01
    ],
    [
      "difforme",
      0.0075
    ],
    [
      "vil",
      0.0075
    ],
    [
      "sinistre",
      0.005
    ],
    [
      "moche",
      0.005
    ],
    [
      "miserable",
      0.005
    ],
    [
      "extraordinaire",
      0.005
    ],
    [
      "deplaisant",
      0.005
    ],
    [
      "catastrophique",
      0.005
    ],
    [
      "excessif",
      0.005
    ],
    [
      "ennuyeux",
      0.005
    ],
    [
      "disgracieux",
      0.005
    ],
    [
      "damne",
      0.0025
    ],
    [
      "extreme",
      0.0025
    ],
    [
      "informe",
      0.0025
    ],
    [
      "mercenaire",
      0.0
    ],
    [
      "inesthetique",
      0.0
    ],
    [
      "horrifiant",
      0.0
    ],
    [
      "spadassin",
      0.0
    ]
  ],
  "pouilleux": [
    [
      "miserable",
      0.1275
    ],
    [
      "misereux",
      0.1275
    ],
    [
      "pauvre",
      0.1025
    ],
    [
      "gueux",
      0.075
    ],
    [
      "miteux",
      0.075
    ],
    [
      "sordide",
      0.05
    ],
    [
      "necessiteux",
      0.05
    ],
    [
      "deguenille",
      0.05
    ],
    [
      "clochard",
      0.05
    ],
    [
      "besogneux",
      0.05
    ],
    [
      "jacques",
      0.025
    ],
    [
      "malpropre",
      0.025
    ],
    [
      "minable",
      0.025
    ],
    [
      "puceux",
      0.025
    ],
    [
      "sterile",
      0.025
    ],
    [
      "vermineux",
      0.025
    ]
  ],
  "diamant": [
    [
      "solitaire",
      0.1775
    ],
    [
      "brillant",
      0.1425
    ],
    [
      "bague",
      0.105
    ],
    [
      "pierre",
      0.105
    ],
    [
      "joyau",
      0.07
    ],
    [
      "gemme",
      0.07
    ],
    [
      "bijou",
      0.07
    ],
    [
      "rose",
      0.035
    ],
    [
      "parangon",
      0.035
    ],
    [
      "marquise",
      0.035
    ],
    [
      "marguerite",
      0.035
    ],
    [
      "diam",
      0.035
    ],
    [
      "bronze",
      0.035
    ],
    [
      "strass",
      0.035
    ]
  ],
  "romantique": [
    [
      "romanesque",
      0.185
    ],
    [
      "chimerique",
      0.11
    ],
    [
      "reveur",
      0.11
    ],
    [
      "poetique",
      0.0725
    ],
    [
      "imaginatif",
      0.0725
    ],
    [
      "idealiste",
      0.0725
    ],
    [
      "triste",
      0.035
    ],
    [
      "speculatif",
      0.035
    ],
    [
      "sentimental",
      0.035
    ],
    [
      "sensible",
      0.035
    ],
    [
      "peintre",
      0.035
    ],
    [
      "passionne",
      0.035
    ],
    [
      "melancolique",
      0.035
    ],
    [
      "mysterieux",
      0.035
    ],
    [
      "exalte",
      0.035
    ],
    [
      "utopique",
      0.035
    ]
  ],
  "parfaire": [
    [
      "polir",
      0.1225
    ],
    [
      "fignoler",
      0.0875
    ],
    [
      "finir",
      0.06
    ],
    [
      "parachever",
      0.055
    ],
    [
      "soigner",
      0.055
    ],
    [
      "ameliorer",
      0.0475
    ],
    [
      "lecher",
      0.0475
    ],
    [
      "perler",
      0.04
    ],
    [
      "ciseler",
      0.04
    ],
    [
      "chatier",
      0.04
    ],
    [
      "achever",
      0.04
    ],
    [
      "completer",
      0.0325
    ],
    [
      "limer",
      0.0325
    ],
    [
      "perfectionner",
      0.0325
    ],
    [
      "terminer",
      0.025
    ],
    [
      "former",
      0.025
    ],
    [
      "arranger",
      0.025
    ],
    [
      "raboter",
      0.02
    ],
    [
      "revoir",
      0.02
    ],
    [
      "raffiner",
      0.0125
    ],
    [
      "peaufiner",
      0.0125
    ],
    [
      "faire",
      0.0125
    ],
    [
      "executer",
      0.0125
    ],
    [
      "enjoliver",
      0.0125
    ],
    [
      "couronner",
      0.0125
    ],
    [
      "consommer",
      0.0125
    ],
    [
      "aiguiser",
      0.0125
    ],
    [
      "ajouter",
      0.005
    ],
    [
      "arrondir",
      0.005
    ],
    [
      "flatter",
      0.005
    ],
    [
      "pourlecher",
      0.005
    ]
  ],
  "parfait": [
    [
      "polir",
      0.1225
    ],
    [
      "fignoler",
      0.0875
    ],
    [
      "finir",
      0.06
    ],
    [
      "parachever",
      0.055
    ],
    [
      "soigner",
      0.055
    ],
    [
      "ameliorer",
      0.0475
    ],
    [
      "lecher",
      0.0475
    ],
    [
      "perler",
      0.04
    ],
    [
      "ciseler",
      0.04
    ],
    [
      "chatier",
      0.04
    ],
    [
      "achever",
      0.04
    ],
    [
      "completer",
      0.0325
    ],
    [
      "limer",
      0.0325
    ],
    [
      "perfectionner",
      0.0325
    ],
    [
      "terminer",
      0.025
    ],
    [
      "former",
      0.025
    ],
    [
      "arranger",
      0.025
    ],
    [
      "raboter",
      0.02
    ],
    [
      "revoir",
      0.02
    ],
    [
      "raffiner",
      0.0125
    ],
    [
      "peaufiner",
      0.0125
    ],
    [
      "faire",
      0.0125
    ],
    [
      "executer",
      0.0125
    ],
    [
      "enjoliver",
      0.0125
    ],
    [
      "couronner",
      0.0125
    ],
    [
      "consommer",
      0.0125
    ],
    [
      "aiguiser",
      0.0125
    ],
    [
      "ajouter",
      0.005
    ],
    [
      "arrondir",
      0.005
    ],
    [
      "flatter",
      0.005
    ],
    [
      "pourlecher",
      0.005
    ]
  ],
  "royal": [
    [
      "splendide",
      0.1375
    ],
    [
      "souverain",
      0.09
    ],
    [
      "somptueux",
      0.09
    ],
    [
      "princier",
      0.09
    ],
    [
      "parfait",
      0.09
    ],
    [
      "magnifique",
      0.09
    ],
    [
      "luxueux",
      0.09
    ],
    [
      "fastueux",
      0.09
    ],
    [
      "grandiose",
      0.045
    ],
    [
      "imposant",
      0.045
    ],
    [
      "monarchique",
      0.045
    ],
    [
      "regalien",
      0.045
    ],
    [
      "triomphant",
      0.045
    ]
  ],
  "exil": [
    [
      "bannissement",
      0.1325
    ],
    [
      "deportation",
      0.09
    ],
    [
      "eloignement",
      0.09
    ],
    [
      "condamnation",
      0.065
    ],
    [
      "expatriation",
      0.065
    ],
    [
      "expulsion",
      0.065
    ],
    [
      "separation",
      0.065
    ],
    [
      "solitude",
      0.0425
    ],
    [
      "proscription",
      0.0425
    ],
    [
      "ostracisme",
      0.0425
    ],
    [
      "isolement",
      0.0425
    ],
    [
      "deracinement",
      0.0425
    ],
    [
      "transportation",
      0.02
    ],
    [
      "reclusion",
      0.02
    ],
    [
      "retraite",
      0.02
    ],
    [
      "renvoi",
      0.02
    ],
    [
      "relegation",
      0.02
    ],
    [
      "depaysement",
      0.02
    ],
    [
      "depart",
      0.02
    ],
    [
      "ban",
      0.02
    ],
    [
      "emigration",
      0.02
    ]
  ],
  "cirer": [
    [
      "astiquer",
      0.1575
    ],
    [
      "frotter",
      0.1575
    ],
    [
      "lustrer",
      0.105
    ],
    [
      "glacer",
      0.105
    ],
    [
      "faire",
      0.105
    ],
    [
      "enduire",
      0.105
    ],
    [
      "encaustiquer",
      0.0525
    ],
    [
      "nettoyer",
      0.0525
    ],
    [
      "recurer",
      0.0525
    ],
    [
      "vernir",
      0.0525
    ]
  ],
  "cire": [
    [
      "astiquer",
      0.1575
    ],
    [
      "frotter",
      0.1575
    ],
    [
      "lustrer",
      0.105
    ],
    [
      "glacer",
      0.105
    ],
    [
      "faire",
      0.105
    ],
    [
      "enduire",
      0.105
    ],
    [
      "encaustiquer",
      0.0525
    ],
    [
      "nettoyer",
      0.0525
    ],
    [
      "recurer",
      0.0525
    ],
    [
      "vernir",
      0.0525
    ]
  ],
  "chasse": [
    [
      "poursuite",
      0.1025
    ],
    [
      "charge",
      0.0675
    ],
    [
      "poste",
      0.0675
    ],
    [
      "recherche",
      0.0675
    ],
    [
      "piegeage",
      0.0325
    ],
    [
      "peche",
      0.0325
    ],
    [
      "quete",
      0.0325
    ],
    [
      "safari",
      0.0325
    ],
    [
      "tenderie",
      0.0325
    ],
    [
      "trappe",
      0.0325
    ],
    [
      "traque",
      0.0325
    ],
    [
      "volerie",
      0.0325
    ],
    [
      "pistage",
      0.0325
    ],
    [
      "jeu",
      0.0325
    ],
    [
      "garenne",
      0.0325
    ],
    [
      "affut",
      0.0325
    ],
    [
      "battue",
      0.0325
    ],
    [
      "braconnage",
      0.0325
    ],
    [
      "chaleur",
      0.0325
    ],
    [
      "cynegetique",
      0.0325
    ],
    [
      "fauconnerie",
      0.0325
    ],
    [
      "fouee",
      0.0325
    ],
    [
      "furetage",
      0.0325
    ],
    [
      "venerie",
      0.0325
    ]
  ],
  "chasser": [
    [
      "renvoyer",
      0.075
    ],
    [
      "repousser",
      0.0525
    ],
    [
      "ecarter",
      0.05
    ],
    [
      "expulser",
      0.045
    ],
    [
      "rejeter",
      0.045
    ],
    [
      "exclure",
      0.0375
    ],
    [
      "bannir",
      0.035
    ],
    [
      "congedier",
      0.0325
    ],
    [
      "vider",
      0.0275
    ],
    [
      "eloigner",
      0.0275
    ],
    [
      "balayer",
      0.025
    ],
    [
      "eliminer",
      0.0225
    ],
    [
      "exiler",
      0.02
    ],
    [
      "refouler",
      0.02
    ],
    [
      "oter",
      0.02
    ],
    [
      "econduire",
      0.02
    ],
    [
      "remercier",
      0.02
    ],
    [
      "proscrire",
      0.02
    ],
    [
      "pousser",
      0.02
    ],
    [
      "balancer",
      0.02
    ],
    [
      "poursuivre",
      0.015
    ],
    [
      "dissiper",
      0.0125
    ],
    [
      "arracher",
      0.0125
    ],
    [
      "deloger",
      0.01
    ],
    [
      "detruire",
      0.01
    ],
    [
      "lancer",
      0.01
    ],
    [
      "reconduire",
      0.01
    ],
    [
      "courir",
      0.01
    ],
    [
      "evincer",
      0.005
    ],
    [
      "vaincre",
      0.005
    ],
    [
      "separer",
      0.005
    ],
    [
      "pourchasser",
      0.005
    ],
    [
      "forcer",
      0.005
    ],
    [
      "traquer",
      0.005
    ],
    [
      "rabattre",
      0.005
    ],
    [
      "ostraciser",
      0.005
    ],
    [
      "licencier",
      0.005
    ],
    [
      "giboyer",
      0.005
    ],
    [
      "excommunier",
      0.005
    ],
    [
      "envoyer",
      0.005
    ],
    [
      "detroner",
      0.005
    ],
    [
      "denicher",
      0.005
    ],
    [
      "debusquer",
      0.005
    ],
    [
      "disperser",
      0.005
    ],
    [
      "bousculer",
      0.005
    ],
    [
      "relancer",
      0.0025
    ],
    [
      "rembucher",
      0.0025
    ],
    [
      "vomir",
      0.0025
    ],
    [
      "ejecter",
      0.0025
    ],
    [
      "glisser",
      0.0025
    ],
    [
      "extirper",
      0.0025
    ],
    [
      "expatrier",
      0.0025
    ],
    [
      "bouter",
      0.0025
    ],
    [
      "conjurer",
      0.0025
    ],
    [
      "courre",
      0.0025
    ],
    [
      "debucher",
      0.0025
    ],
    [
      "degoter",
      0.0025
    ],
    [
      "demettre",
      0.0025
    ],
    [
      "deposer",
      0.0025
    ],
    [
      "exorciser",
      0.0
    ],
    [
      "patiner",
      0.0
    ],
    [
      "purger",
      0.0
    ],
    [
      "queter",
      0.0
    ],
    [
      "servir",
      0.0
    ],
    [
      "deraper",
      0.0
    ],
    [
      "deporter",
      0.0
    ],
    [
      "depister",
      0.0
    ],
    [
      "demenager",
      0.0
    ],
    [
      "dejucher",
      0.0
    ],
    [
      "draguer",
      0.0
    ],
    [
      "charrier",
      0.0
    ],
    [
      "braconner",
      0.0
    ],
    [
      "boucaner",
      0.0
    ],
    [
      "vener",
      0.0
    ]
  ],
  "nettoyer": [
    [
      "recurer",
      0.1125
    ],
    [
      "frotter",
      0.0775
    ],
    [
      "laver",
      0.055
    ],
    [
      "balayer",
      0.035
    ],
    [
      "purifier",
      0.035
    ],
    [
      "debarrasser",
      0.0325
    ],
    [
      "brosser",
      0.025
    ],
    [
      "battre",
      0.0225
    ],
    [
      "polir",
      0.0225
    ],
    [
      "vider",
      0.0175
    ],
    [
      "ruiner",
      0.0175
    ],
    [
      "purger",
      0.0175
    ],
    [
      "lessiver",
      0.0175
    ],
    [
      "astiquer",
      0.0175
    ],
    [
      "decrasser",
      0.015
    ],
    [
      "detacher",
      0.015
    ],
    [
      "plumer",
      0.015
    ],
    [
      "etriller",
      0.0125
    ],
    [
      "torcher",
      0.0125
    ],
    [
      "racler",
      0.0125
    ],
    [
      "liquider",
      0.0125
    ],
    [
      "faire",
      0.0125
    ],
    [
      "depouiller",
      0.0125
    ],
    [
      "curer",
      0.0125
    ],
    [
      "blanchir",
      0.0125
    ],
    [
      "arracher",
      0.0125
    ],
    [
      "monder",
      0.0075
    ],
    [
      "tuer",
      0.0075
    ],
    [
      "vanner",
      0.0075
    ],
    [
      "eclaircir",
      0.0075
    ],
    [
      "epousseter",
      0.0075
    ],
    [
      "gratter",
      0.0075
    ],
    [
      "expurger",
      0.0075
    ],
    [
      "assainir",
      0.0075
    ],
    [
      "debarbouiller",
      0.0075
    ],
    [
      "debourber",
      0.0075
    ],
    [
      "degraisser",
      0.0075
    ],
    [
      "essuyer",
      0.0075
    ],
    [
      "liberer",
      0.005
    ],
    [
      "ratisser",
      0.005
    ],
    [
      "ravaler",
      0.005
    ],
    [
      "rincer",
      0.005
    ],
    [
      "trier",
      0.005
    ],
    [
      "vidanger",
      0.005
    ],
    [
      "eplucher",
      0.005
    ],
    [
      "fricoter",
      0.005
    ],
    [
      "fourbir",
      0.005
    ],
    [
      "affiner",
      0.005
    ],
    [
      "bouchonner",
      0.005
    ],
    [
      "cribler",
      0.005
    ],
    [
      "deblayer",
      0.005
    ],
    [
      "decaper",
      0.005
    ],
    [
      "decrotter",
      0.005
    ],
    [
      "degorger",
      0.005
    ],
    [
      "derouiller",
      0.005
    ],
    [
      "ramoner",
      0.0
    ],
    [
      "poutser",
      0.0
    ],
    [
      "lotionner",
      0.0
    ],
    [
      "housser",
      0.0
    ],
    [
      "fricasser",
      0.0
    ],
    [
      "rapproprier",
      0.0
    ],
    [
      "ronger",
      0.0
    ],
    [
      "sabler",
      0.0
    ],
    [
      "sarcler",
      0.0
    ],
    [
      "savonner",
      0.0
    ],
    [
      "toiletter",
      0.0
    ],
    [
      "torchonner",
      0.0
    ],
    [
      "filtrer",
      0.0
    ],
    [
      "deterger",
      0.0
    ],
    [
      "desencrasser",
      0.0
    ],
    [
      "absorber",
      0.0
    ],
    [
      "approprier",
      0.0
    ],
    [
      "babichonner",
      0.0
    ],
    [
      "baigner",
      0.0
    ],
    [
      "bichonner",
      0.0
    ],
    [
      "bricoler",
      0.0
    ],
    [
      "briquer",
      0.0
    ],
    [
      "cauteriser",
      0.0
    ],
    [
      "cirer",
      0.0
    ],
    [
      "croquer",
      0.0
    ],
    [
      "draguer",
      0.0
    ],
    [
      "derocher",
      0.0
    ],
    [
      "ecurer",
      0.0
    ]
  ],
  "placard": [
    [
      "affiche",
      0.11
    ],
    [
      "armoire",
      0.11
    ],
    [
      "libelle",
      0.11
    ],
    [
      "penderie",
      0.11
    ],
    [
      "ecriteau",
      0.055
    ],
    [
      "pasquinade",
      0.055
    ],
    [
      "pancarte",
      0.055
    ],
    [
      "pamphlet",
      0.055
    ],
    [
      "libelle",
      0.055
    ],
    [
      "feuille",
      0.055
    ],
    [
      "cagibi",
      0.055
    ],
    [
      "buffet",
      0.055
    ],
    [
      "avis",
      0.055
    ],
    [
      "epreuve",
      0.055
    ]
  ],
  "sept": [],
  "quart": [
    [
      "garde",
      0.1825
    ],
    [
      "timbale",
      0.09
    ],
    [
      "service",
      0.09
    ],
    [
      "recipient",
      0.09
    ],
    [
      "quatrieme",
      0.09
    ],
    [
      "quartier",
      0.09
    ],
    [
      "gobelet",
      0.09
    ],
    [
      "faction",
      0.09
    ],
    [
      "brigade",
      0.09
    ],
    [
      "veille",
      0.09
    ]
  ],
  "lis": [
    [
      "dechiffrer",
      0.1175
    ],
    [
      "decouvrir",
      0.1
    ],
    [
      "reperer",
      0.0825
    ],
    [
      "penetrer",
      0.0675
    ],
    [
      "voir",
      0.05
    ],
    [
      "expliquer",
      0.05
    ],
    [
      "dire",
      0.05
    ],
    [
      "deviner",
      0.05
    ],
    [
      "epeler",
      0.0325
    ],
    [
      "percer",
      0.0325
    ],
    [
      "interpreter",
      0.0325
    ],
    [
      "feuilleter",
      0.0325
    ],
    [
      "discerner",
      0.0325
    ],
    [
      "consulter",
      0.0325
    ],
    [
      "survoler",
      0.015
    ],
    [
      "reciter",
      0.015
    ],
    [
      "prononcer",
      0.015
    ],
    [
      "parcourir",
      0.015
    ],
    [
      "frequenter",
      0.015
    ],
    [
      "devorer",
      0.015
    ],
    [
      "depouiller",
      0.015
    ],
    [
      "decrypter",
      0.015
    ],
    [
      "decoder",
      0.015
    ],
    [
      "debrouiller",
      0.015
    ],
    [
      "compulser",
      0.015
    ],
    [
      "bouquiner",
      0.015
    ],
    [
      "anonner",
      0.015
    ]
  ],
  "livrer": [
    [
      "donner",
      0.135
    ],
    [
      "reveler",
      0.0925
    ],
    [
      "trahir",
      0.07
    ],
    [
      "montrer",
      0.0625
    ],
    [
      "exposer",
      0.055
    ],
    [
      "denoncer",
      0.05
    ],
    [
      "decouvrir",
      0.035
    ],
    [
      "vendre",
      0.0275
    ],
    [
      "rendre",
      0.0275
    ],
    [
      "remettre",
      0.0275
    ],
    [
      "porter",
      0.0275
    ],
    [
      "laisser",
      0.0275
    ],
    [
      "fournir",
      0.0275
    ],
    [
      "abandonner",
      0.0275
    ],
    [
      "communiquer",
      0.0275
    ],
    [
      "confier",
      0.0275
    ],
    [
      "ceder",
      0.0275
    ],
    [
      "devoiler",
      0.0275
    ],
    [
      "lacher",
      0.02
    ],
    [
      "transporter",
      0.0125
    ],
    [
      "peindre",
      0.0125
    ],
    [
      "engager",
      0.0125
    ],
    [
      "demasquer",
      0.0125
    ],
    [
      "deferer",
      0.0125
    ],
    [
      "bruler",
      0.0125
    ],
    [
      "prostituer",
      0.005
    ],
    [
      "procurer",
      0.005
    ],
    [
      "fier",
      0.005
    ],
    [
      "extrader",
      0.005
    ],
    [
      "devouer",
      0.005
    ],
    [
      "delivrer",
      0.005
    ],
    [
      "epancher",
      0.005
    ]
  ],
  "livre": [
    [
      "recueil",
      0.1625
    ],
    [
      "fascicule",
      0.075
    ],
    [
      "ecrit",
      0.0425
    ],
    [
      "volume",
      0.0425
    ],
    [
      "registre",
      0.0425
    ],
    [
      "ouvrage",
      0.0425
    ],
    [
      "livret",
      0.0425
    ],
    [
      "cahier",
      0.0425
    ],
    [
      "publication",
      0.03
    ],
    [
      "opuscule",
      0.03
    ],
    [
      "livraison",
      0.03
    ],
    [
      "carnet",
      0.03
    ],
    [
      "brochure",
      0.03
    ],
    [
      "album",
      0.03
    ],
    [
      "plaquette",
      0.02
    ],
    [
      "poids",
      0.0075
    ],
    [
      "partie",
      0.0075
    ],
    [
      "once",
      0.0075
    ],
    [
      "oeuvre",
      0.0075
    ],
    [
      "matricule",
      0.0075
    ],
    [
      "manuscrit",
      0.0075
    ],
    [
      "portulan",
      0.0075
    ],
    [
      "pound",
      0.0075
    ],
    [
      "rituel",
      0.0075
    ],
    [
      "rudiment",
      0.0075
    ],
    [
      "tome",
      0.0075
    ],
    [
      "travail",
      0.0075
    ],
    [
      "edition",
      0.0075
    ],
    [
      "manuel",
      0.0075
    ],
    [
      "keepsake",
      0.0075
    ],
    [
      "bouquin",
      0.0075
    ],
    [
      "brouillard",
      0.0075
    ],
    [
      "chapitre",
      0.0075
    ],
    [
      "comptabilite",
      0.0075
    ],
    [
      "compte",
      0.0075
    ],
    [
      "denier",
      0.0075
    ],
    [
      "elzevir",
      0.0075
    ],
    [
      "grimoire",
      0.0075
    ],
    [
      "incunable",
      0.0075
    ],
    [
      "journal",
      0.0075
    ],
    [
      "atlas",
      0.0075
    ]
  ],
  "ajoute": [
    [
      "ajout",
      1.0
    ]
  ],
  "ajouter": [
    [
      "augmenter",
      0.125
    ],
    [
      "accroitre",
      0.065
    ],
    [
      "aggraver",
      0.0475
    ],
    [
      "grossir",
      0.0475
    ],
    [
      "etendre",
      0.04
    ],
    [
      "completer",
      0.04
    ],
    [
      "amplifier",
      0.04
    ],
    [
      "agrandir",
      0.035
    ],
    [
      "exagerer",
      0.035
    ],
    [
      "joindre",
      0.035
    ],
    [
      "rencherir",
      0.0275
    ],
    [
      "ameliorer",
      0.0275
    ],
    [
      "adjoindre",
      0.0225
    ],
    [
      "enrichir",
      0.0225
    ],
    [
      "rapporter",
      0.0225
    ],
    [
      "renforcer",
      0.0225
    ],
    [
      "rajouter",
      0.0175
    ],
    [
      "intercaler",
      0.0175
    ],
    [
      "intensifier",
      0.0175
    ],
    [
      "inserer",
      0.0175
    ],
    [
      "encherir",
      0.0175
    ],
    [
      "embellir",
      0.0175
    ],
    [
      "annexer",
      0.0175
    ],
    [
      "allonger",
      0.0175
    ],
    [
      "additionner",
      0.0175
    ],
    [
      "unir",
      0.01
    ],
    [
      "suppleer",
      0.01
    ],
    [
      "rallonger",
      0.01
    ],
    [
      "juxtaposer",
      0.01
    ],
    [
      "corriger",
      0.01
    ],
    [
      "accentuer",
      0.01
    ],
    [
      "interpoler",
      0.005
    ],
    [
      "orner",
      0.005
    ],
    [
      "parfaire",
      0.005
    ],
    [
      "pimenter",
      0.005
    ],
    [
      "redoubler",
      0.005
    ],
    [
      "surcharger",
      0.005
    ],
    [
      "surencherir",
      0.005
    ],
    [
      "imager",
      0.005
    ],
    [
      "greffer",
      0.005
    ],
    [
      "dire",
      0.005
    ],
    [
      "couper",
      0.005
    ],
    [
      "assaisonner",
      0.005
    ],
    [
      "apporter",
      0.005
    ],
    [
      "accoler",
      0.005
    ],
    [
      "abouter",
      0.005
    ],
    [
      "verser",
      0.005
    ]
  ],
  "tricot": [
    [
      "chandail",
      0.165
    ],
    [
      "gilet",
      0.11
    ],
    [
      "maillot",
      0.11
    ],
    [
      "tricotage",
      0.055
    ],
    [
      "tresse",
      0.055
    ],
    [
      "tissu",
      0.055
    ],
    [
      "sweater",
      0.055
    ],
    [
      "point",
      0.055
    ],
    [
      "laine",
      0.055
    ],
    [
      "cardigan",
      0.055
    ],
    [
      "baton",
      0.055
    ],
    [
      "bonneterie",
      0.055
    ],
    [
      "trique",
      0.055
    ]
  ],
  "gateau": [
    [
      "patisserie",
      0.165
    ],
    [
      "tarte",
      0.165
    ],
    [
      "nanan",
      0.11
    ],
    [
      "sucrerie",
      0.055
    ],
    [
      "profit",
      0.055
    ],
    [
      "nougat",
      0.055
    ],
    [
      "millefeuille",
      0.055
    ],
    [
      "gaufre",
      0.055
    ],
    [
      "fromage",
      0.055
    ],
    [
      "entremets",
      0.055
    ],
    [
      "biscuit",
      0.055
    ],
    [
      "aubaine",
      0.055
    ],
    [
      "tourteau",
      0.055
    ]
  ],
  "flechette": [
    [
      "fleche",
      1.0
    ]
  ],
  "macher": [
    [
      "bredouiller",
      0.09
    ],
    [
      "broyer",
      0.09
    ],
    [
      "manger",
      0.09
    ],
    [
      "mordre",
      0.09
    ],
    [
      "machonner",
      0.09
    ],
    [
      "triturer",
      0.09
    ],
    [
      "mastiquer",
      0.06
    ],
    [
      "marmonner",
      0.06
    ],
    [
      "ruminer",
      0.03
    ],
    [
      "remacher",
      0.03
    ],
    [
      "preparer",
      0.03
    ],
    [
      "machouiller",
      0.03
    ],
    [
      "marmotter",
      0.03
    ],
    [
      "hacher",
      0.03
    ],
    [
      "faciliter",
      0.03
    ],
    [
      "chiquer",
      0.03
    ],
    [
      "bafouiller",
      0.03
    ],
    [
      "apprendre",
      0.03
    ],
    [
      "ecraser",
      0.03
    ]
  ],
  "classique": [
    [
      "ordinaire",
      0.1325
    ],
    [
      "habituel",
      0.105
    ],
    [
      "courant",
      0.0775
    ],
    [
      "simple",
      0.0775
    ],
    [
      "sobre",
      0.0775
    ],
    [
      "traditionnel",
      0.0775
    ],
    [
      "severe",
      0.05
    ],
    [
      "routinier",
      0.05
    ],
    [
      "rituel",
      0.05
    ],
    [
      "normal",
      0.05
    ],
    [
      "conventionnel",
      0.05
    ],
    [
      "banal",
      0.05
    ],
    [
      "arcadien",
      0.025
    ],
    [
      "chatie",
      0.025
    ],
    [
      "conforme",
      0.025
    ],
    [
      "peintre",
      0.025
    ],
    [
      "strict",
      0.025
    ]
  ],
  "echec": [
    [
      "insucces",
      0.115
    ],
    [
      "faillite",
      0.085
    ],
    [
      "chute",
      0.075
    ],
    [
      "defaite",
      0.075
    ],
    [
      "fiasco",
      0.075
    ],
    [
      "deception",
      0.055
    ],
    [
      "revers",
      0.0475
    ],
    [
      "debacle",
      0.0375
    ],
    [
      "malheur",
      0.0275
    ],
    [
      "krach",
      0.0275
    ],
    [
      "deconvenue",
      0.0275
    ],
    [
      "deboire",
      0.0275
    ],
    [
      "calamite",
      0.0275
    ],
    [
      "bidon",
      0.0275
    ],
    [
      "bide",
      0.0275
    ],
    [
      "eclipse",
      0.0175
    ],
    [
      "tribulation",
      0.0175
    ],
    [
      "honte",
      0.0175
    ],
    [
      "four",
      0.0175
    ],
    [
      "fessee",
      0.0175
    ],
    [
      "avortement",
      0.0175
    ],
    [
      "plongeon",
      0.0075
    ],
    [
      "pilule",
      0.0075
    ],
    [
      "naufrage",
      0.0075
    ],
    [
      "mat",
      0.0075
    ],
    [
      "malchance",
      0.0075
    ],
    [
      "foirade",
      0.0075
    ],
    [
      "enterrement",
      0.0075
    ],
    [
      "defaut",
      0.0075
    ],
    [
      "cacade",
      0.0075
    ],
    [
      "cabriole",
      0.0075
    ],
    [
      "veste",
      0.0075
    ]
  ],
  "mat": [
    [
      "artimon",
      0.125
    ],
    [
      "beaupre",
      0.125
    ],
    [
      "bigue",
      0.125
    ],
    [
      "cacatois",
      0.125
    ],
    [
      "misaine",
      0.125
    ],
    [
      "matereau",
      0.125
    ],
    [
      "pylone",
      0.125
    ],
    [
      "vergue",
      0.125
    ]
  ],
  "theatre": [
    [
      "comedie",
      0.0825
    ],
    [
      "scene",
      0.0825
    ],
    [
      "mimesis",
      0.0275
    ],
    [
      "miracle",
      0.0275
    ],
    [
      "mystere",
      0.0275
    ],
    [
      "no",
      0.0275
    ],
    [
      "oeuvre",
      0.0275
    ],
    [
      "opera",
      0.0275
    ],
    [
      "pigeonnier",
      0.0275
    ],
    [
      "planches",
      0.0275
    ],
    [
      "plateau",
      0.0275
    ],
    [
      "salle",
      0.0275
    ],
    [
      "site",
      0.0275
    ],
    [
      "studio",
      0.0275
    ],
    [
      "litterature",
      0.0275
    ],
    [
      "lieu",
      0.0275
    ],
    [
      "kabuki",
      0.0275
    ],
    [
      "amphitheatre",
      0.0275
    ],
    [
      "arene",
      0.0275
    ],
    [
      "boulevard",
      0.0275
    ],
    [
      "bunraku",
      0.0275
    ],
    [
      "compagnie",
      0.0275
    ],
    [
      "drame",
      0.0275
    ],
    [
      "decor",
      0.0275
    ],
    [
      "emplacement",
      0.0275
    ],
    [
      "endroit",
      0.0275
    ],
    [
      "farce",
      0.0275
    ],
    [
      "treteaux",
      0.0275
    ]
  ],
  "marionnette": [
    [
      "pantin",
      0.25
    ],
    [
      "fantoche",
      0.155
    ],
    [
      "arlequin",
      0.0925
    ],
    [
      "polichinelle",
      0.0925
    ],
    [
      "poupee",
      0.0625
    ],
    [
      "guignol",
      0.0625
    ],
    [
      "toton",
      0.03
    ],
    [
      "statuette",
      0.03
    ],
    [
      "pupazzo",
      0.03
    ],
    [
      "marotte",
      0.03
    ],
    [
      "girouette",
      0.03
    ],
    [
      "clown",
      0.03
    ],
    [
      "bamboche",
      0.03
    ],
    [
      "automate",
      0.03
    ],
    [
      "toupie",
      0.03
    ]
  ],
  "bougie": [
    [
      "chandelle",
      0.235
    ],
    [
      "sonde",
      0.0575
    ],
    [
      "luminaire",
      0.0575
    ],
    [
      "lumignon",
      0.0575
    ],
    [
      "flambeau",
      0.0575
    ],
    [
      "filtre",
      0.0575
    ],
    [
      "cierge",
      0.0575
    ],
    [
      "catheter",
      0.0575
    ],
    [
      "candela",
      0.0575
    ],
    [
      "camoufle",
      0.0575
    ],
    [
      "calbombe",
      0.0575
    ],
    [
      "binette",
      0.0575
    ],
    [
      "tete",
      0.0575
    ]
  ],
  "art": [
    [
      "habilete",
      0.1
    ],
    [
      "adresse",
      0.05
    ],
    [
      "truc",
      0.04
    ],
    [
      "technique",
      0.035
    ],
    [
      "moyen",
      0.035
    ],
    [
      "maniere",
      0.035
    ],
    [
      "don",
      0.035
    ],
    [
      "artifice",
      0.035
    ],
    [
      "facon",
      0.03
    ],
    [
      "procede",
      0.03
    ],
    [
      "astuce",
      0.0275
    ],
    [
      "intelligence",
      0.0275
    ],
    [
      "pouvoir",
      0.0275
    ],
    [
      "travail",
      0.0225
    ],
    [
      "talent",
      0.0225
    ],
    [
      "methode",
      0.0225
    ],
    [
      "maitrise",
      0.0225
    ],
    [
      "etude",
      0.02
    ],
    [
      "science",
      0.02
    ],
    [
      "ruse",
      0.02
    ],
    [
      "qualite",
      0.02
    ],
    [
      "metier",
      0.02
    ],
    [
      "industrie",
      0.02
    ],
    [
      "style",
      0.015
    ],
    [
      "competence",
      0.015
    ],
    [
      "chic",
      0.015
    ],
    [
      "appret",
      0.015
    ],
    [
      "etat",
      0.01
    ],
    [
      "secret",
      0.01
    ],
    [
      "recherche",
      0.01
    ],
    [
      "profession",
      0.01
    ],
    [
      "faire",
      0.01
    ],
    [
      "dexterite",
      0.01
    ],
    [
      "application",
      0.01
    ],
    [
      "tour",
      0.0075
    ],
    [
      "preparation",
      0.0075
    ],
    [
      "genie",
      0.0075
    ],
    [
      "discipline",
      0.0075
    ],
    [
      "beaute",
      0.0075
    ],
    [
      "beau",
      0.0075
    ],
    [
      "affectation",
      0.0075
    ],
    [
      "soin",
      0.0025
    ],
    [
      "puissance",
      0.0025
    ],
    [
      "poesie",
      0.0025
    ],
    [
      "fard",
      0.0025
    ],
    [
      "effort",
      0.0025
    ],
    [
      "artisanat",
      0.0025
    ],
    [
      "alchimie",
      0.0025
    ],
    [
      "eloquence",
      0.0025
    ]
  ],
  "corder": [
    [
      "attacher",
      0.1425
    ],
    [
      "serrer",
      0.095
    ],
    [
      "entourer",
      0.095
    ],
    [
      "cordeler",
      0.095
    ],
    [
      "concorder",
      0.095
    ],
    [
      "coller",
      0.095
    ],
    [
      "cercler",
      0.095
    ],
    [
      "biller",
      0.0475
    ],
    [
      "cadrer",
      0.0475
    ],
    [
      "cordonner",
      0.0475
    ],
    [
      "lier",
      0.0475
    ],
    [
      "mesurer",
      0.0475
    ],
    [
      "tortiller",
      0.0475
    ]
  ],
  "corde": [
    [
      "attache",
      0.1125
    ],
    [
      "fil",
      0.1025
    ],
    [
      "lien",
      0.0725
    ],
    [
      "cordon",
      0.055
    ],
    [
      "cable",
      0.055
    ],
    [
      "cordage",
      0.035
    ],
    [
      "amarrage",
      0.035
    ],
    [
      "chaine",
      0.0275
    ],
    [
      "ficelle",
      0.0275
    ],
    [
      "trame",
      0.015
    ],
    [
      "trait",
      0.015
    ],
    [
      "ton",
      0.015
    ],
    [
      "note",
      0.015
    ],
    [
      "longe",
      0.015
    ],
    [
      "cordelle",
      0.015
    ],
    [
      "catgut",
      0.015
    ],
    [
      "pendaison",
      0.0075
    ],
    [
      "peignon",
      0.0075
    ],
    [
      "notocorde",
      0.0075
    ],
    [
      "licou",
      0.0075
    ],
    [
      "licol",
      0.0075
    ],
    [
      "lasso",
      0.0075
    ],
    [
      "larderasse",
      0.0075
    ],
    [
      "laisse",
      0.0075
    ],
    [
      "point",
      0.0075
    ],
    [
      "quarantenier",
      0.0075
    ],
    [
      "quipou",
      0.0075
    ],
    [
      "etendoir",
      0.0075
    ],
    [
      "violoncelle",
      0.0075
    ],
    [
      "violon",
      0.0075
    ],
    [
      "tourtouse",
      0.0075
    ],
    [
      "tortis",
      0.0075
    ],
    [
      "toron",
      0.0075
    ],
    [
      "tendeur",
      0.0075
    ],
    [
      "lacet",
      0.0075
    ],
    [
      "hart",
      0.0075
    ],
    [
      "chanterelle",
      0.0075
    ],
    [
      "cannetille",
      0.0075
    ],
    [
      "boyau",
      0.0075
    ],
    [
      "bourdon",
      0.0075
    ],
    [
      "bolduc",
      0.0075
    ],
    [
      "assurance",
      0.0075
    ],
    [
      "alto",
      0.0075
    ],
    [
      "agres",
      0.0075
    ],
    [
      "chatiment",
      0.0075
    ],
    [
      "contrebasse",
      0.0075
    ],
    [
      "hallebarde",
      0.0075
    ],
    [
      "gibet",
      0.0075
    ],
    [
      "fibre",
      0.0075
    ],
    [
      "duite",
      0.0075
    ],
    [
      "courant",
      0.0075
    ],
    [
      "cordeliere",
      0.0075
    ],
    [
      "cordelette",
      0.0075
    ],
    [
      "cordeau",
      0.0075
    ],
    [
      "accord",
      0.0075
    ]
  ],
  "epate": [
    [
      "esbroufe",
      0.2725
    ],
    [
      "chique",
      0.135
    ],
    [
      "bluff",
      0.09
    ],
    [
      "embarras",
      0.09
    ],
    [
      "ostentation",
      0.09
    ],
    [
      "parade",
      0.09
    ],
    [
      "frime",
      0.0425
    ],
    [
      "illusionnisme",
      0.0425
    ]
  ],
  "relire": [
    [
      "repasser",
      1.0
    ]
  ],
  "brosse": [
    [
      "balai",
      0.1675
    ],
    [
      "epoussette",
      0.055
    ],
    [
      "spalter",
      0.055
    ],
    [
      "soie",
      0.055
    ],
    [
      "polissoire",
      0.055
    ],
    [
      "pinceau",
      0.055
    ],
    [
      "frottoir",
      0.055
    ],
    [
      "frotteur",
      0.055
    ],
    [
      "fermiere",
      0.055
    ],
    [
      "decrottoir",
      0.055
    ],
    [
      "carde",
      0.055
    ],
    [
      "blaireau",
      0.055
    ],
    [
      "etrille",
      0.055
    ]
  ],
  "brosser": [
    [
      "nettoyer",
      0.125
    ],
    [
      "frotter",
      0.11
    ],
    [
      "battre",
      0.0925
    ],
    [
      "etriller",
      0.0625
    ],
    [
      "recurer",
      0.0625
    ],
    [
      "bouchonner",
      0.0625
    ],
    [
      "soigner",
      0.045
    ],
    [
      "epousseter",
      0.03
    ],
    [
      "representer",
      0.03
    ],
    [
      "polir",
      0.03
    ],
    [
      "peindre",
      0.03
    ],
    [
      "panser",
      0.03
    ],
    [
      "frictionner",
      0.03
    ],
    [
      "depeindre",
      0.03
    ],
    [
      "balayer",
      0.03
    ],
    [
      "secher",
      0.015
    ],
    [
      "raconter",
      0.015
    ],
    [
      "portraiturer",
      0.015
    ],
    [
      "peigner",
      0.015
    ],
    [
      "detacher",
      0.015
    ],
    [
      "depoussierer",
      0.015
    ],
    [
      "decrotter",
      0.015
    ],
    [
      "decrire",
      0.015
    ],
    [
      "brousser",
      0.015
    ],
    [
      "brouillonner",
      0.015
    ],
    [
      "vaincre",
      0.015
    ]
  ],
  "chevelure": [
    [
      "cheveux",
      0.24
    ],
    [
      "perruque",
      0.12
    ],
    [
      "coiffure",
      0.08
    ],
    [
      "tignasse",
      0.08
    ],
    [
      "toison",
      0.08
    ],
    [
      "postiche",
      0.04
    ],
    [
      "poils",
      0.04
    ],
    [
      "poil",
      0.04
    ],
    [
      "plumes",
      0.04
    ],
    [
      "feuillage",
      0.04
    ],
    [
      "douilles",
      0.04
    ],
    [
      "crins",
      0.04
    ],
    [
      "criniere",
      0.04
    ],
    [
      "casque",
      0.04
    ],
    [
      "scalp",
      0.04
    ]
  ],
  "prison": [
    [
      "cachot",
      0.0675
    ],
    [
      "cellule",
      0.0675
    ],
    [
      "boite",
      0.0575
    ],
    [
      "emprisonnement",
      0.0575
    ],
    [
      "taule",
      0.0575
    ],
    [
      "detention",
      0.045
    ],
    [
      "tole",
      0.0325
    ],
    [
      "penitencier",
      0.0325
    ],
    [
      "chaine",
      0.0325
    ],
    [
      "cage",
      0.0325
    ],
    [
      "reclusion",
      0.0225
    ],
    [
      "maison",
      0.0225
    ],
    [
      "geole",
      0.0225
    ],
    [
      "captivite",
      0.0225
    ],
    [
      "cabane",
      0.0225
    ],
    [
      "bagne",
      0.0225
    ],
    [
      "gnouf",
      0.01
    ],
    [
      "latomie",
      0.01
    ],
    [
      "lien",
      0.01
    ],
    [
      "plomb",
      0.01
    ],
    [
      "prevention",
      0.01
    ],
    [
      "punition",
      0.01
    ],
    [
      "sechoir",
      0.01
    ],
    [
      "trou",
      0.01
    ],
    [
      "violon",
      0.01
    ],
    [
      "forteresse",
      0.01
    ],
    [
      "fers",
      0.01
    ],
    [
      "ergastule",
      0.01
    ],
    [
      "bastille",
      0.01
    ],
    [
      "bloc",
      0.01
    ],
    [
      "caisse",
      0.01
    ],
    [
      "centrale",
      0.01
    ],
    [
      "cercle",
      0.01
    ],
    [
      "chartre",
      0.01
    ],
    [
      "clou",
      0.01
    ],
    [
      "college",
      0.01
    ],
    [
      "depot",
      0.01
    ],
    [
      "ballon",
      0.01
    ]
  ],
  "anniversaire": [
    [
      "commemoration",
      0.23
    ],
    [
      "celebration",
      0.23
    ],
    [
      "memoire",
      0.1525
    ],
    [
      "commemoratif",
      0.075
    ],
    [
      "ceremonie",
      0.075
    ],
    [
      "fete",
      0.075
    ],
    [
      "memento",
      0.075
    ],
    [
      "souvenir",
      0.075
    ]
  ],
  "defaut": [
    [
      "manque",
      0.1
    ],
    [
      "imperfection",
      0.0825
    ],
    [
      "faiblesse",
      0.065
    ],
    [
      "faute",
      0.055
    ],
    [
      "insuffisance",
      0.05
    ],
    [
      "vice",
      0.05
    ],
    [
      "travers",
      0.0375
    ],
    [
      "deficience",
      0.0325
    ],
    [
      "defectuosite",
      0.03
    ],
    [
      "carence",
      0.0275
    ],
    [
      "pauvrete",
      0.0225
    ],
    [
      "penurie",
      0.02
    ],
    [
      "privation",
      0.02
    ],
    [
      "manquement",
      0.02
    ],
    [
      "mal",
      0.02
    ],
    [
      "difformite",
      0.02
    ],
    [
      "absence",
      0.02
    ],
    [
      "vide",
      0.0125
    ],
    [
      "tort",
      0.0125
    ],
    [
      "tare",
      0.0125
    ],
    [
      "tache",
      0.0125
    ],
    [
      "peche",
      0.0125
    ],
    [
      "malformation",
      0.0125
    ],
    [
      "irregularite",
      0.0125
    ],
    [
      "infirmite",
      0.0125
    ],
    [
      "erreur",
      0.0125
    ],
    [
      "rarete",
      0.0075
    ],
    [
      "nullite",
      0.0075
    ],
    [
      "inferiorite",
      0.0075
    ],
    [
      "indigence",
      0.0075
    ],
    [
      "inconvenient",
      0.0075
    ],
    [
      "faible",
      0.0075
    ],
    [
      "ennui",
      0.0075
    ],
    [
      "desavantage",
      0.0075
    ],
    [
      "defaillance",
      0.0075
    ],
    [
      "disproportion",
      0.0075
    ],
    [
      "disette",
      0.0075
    ],
    [
      "eclipse",
      0.005
    ],
    [
      "petitesse",
      0.005
    ],
    [
      "omission",
      0.005
    ],
    [
      "malfacon",
      0.005
    ],
    [
      "difference",
      0.005
    ],
    [
      "anomalie",
      0.005
    ],
    [
      "maladresse",
      0.0025
    ],
    [
      "ombre",
      0.0025
    ],
    [
      "paille",
      0.0025
    ],
    [
      "penchant",
      0.0025
    ],
    [
      "ridicule",
      0.0025
    ],
    [
      "sophisme",
      0.0025
    ],
    [
      "iniquite",
      0.0025
    ],
    [
      "faille",
      0.0025
    ],
    [
      "desequilibre",
      0.0025
    ],
    [
      "discordance",
      0.0025
    ],
    [
      "critique",
      0.0025
    ],
    [
      "crapaud",
      0.0025
    ],
    [
      "contumace",
      0.0025
    ],
    [
      "bat",
      0.0025
    ],
    [
      "echec",
      0.0025
    ]
  ],
  "brouillon": [
    [
      "confus",
      0.12
    ],
    [
      "agite",
      0.095
    ],
    [
      "tumultueux",
      0.095
    ],
    [
      "desordonne",
      0.07
    ],
    [
      "embrouille",
      0.07
    ],
    [
      "ebauche",
      0.0475
    ],
    [
      "trouble",
      0.0475
    ],
    [
      "nebuleux",
      0.0475
    ],
    [
      "manuscrit",
      0.0225
    ],
    [
      "plan",
      0.0225
    ],
    [
      "schema",
      0.0225
    ],
    [
      "taquin",
      0.0225
    ],
    [
      "topo",
      0.0225
    ],
    [
      "tracassier",
      0.0225
    ],
    [
      "trublion",
      0.0225
    ],
    [
      "instable",
      0.0225
    ],
    [
      "fumeux",
      0.0225
    ],
    [
      "filandreux",
      0.0225
    ],
    [
      "esquisse",
      0.0225
    ],
    [
      "embrouilleur",
      0.0225
    ],
    [
      "dissipe",
      0.0225
    ],
    [
      "complique",
      0.0225
    ],
    [
      "brouillard",
      0.0225
    ],
    [
      "etourdi",
      0.0225
    ]
  ],
  "malhabile": [
    [
      "inhabile",
      0.2075
    ],
    [
      "gauche",
      0.1375
    ],
    [
      "maladroit",
      0.1375
    ],
    [
      "inexperimente",
      0.1025
    ],
    [
      "novice",
      0.0675
    ],
    [
      "lourd",
      0.0675
    ],
    [
      "incapable",
      0.0675
    ],
    [
      "ignorant",
      0.0675
    ],
    [
      "gourd",
      0.0675
    ],
    [
      "inapte",
      0.0325
    ],
    [
      "malagauche",
      0.0325
    ]
  ],
  "faiblesse": [
    [
      "defaut",
      0.0475
    ],
    [
      "abattement",
      0.035
    ],
    [
      "imperfection",
      0.035
    ],
    [
      "affaiblissement",
      0.0325
    ],
    [
      "debilite",
      0.03
    ],
    [
      "insuffisance",
      0.03
    ],
    [
      "mollesse",
      0.0275
    ],
    [
      "langueur",
      0.0275
    ],
    [
      "deficience",
      0.025
    ],
    [
      "manque",
      0.025
    ],
    [
      "torpeur",
      0.0225
    ],
    [
      "pauvrete",
      0.0225
    ],
    [
      "faible",
      0.0225
    ],
    [
      "depression",
      0.0225
    ],
    [
      "aneantissement",
      0.02
    ],
    [
      "fatigue",
      0.02
    ],
    [
      "mediocrite",
      0.02
    ],
    [
      "petitesse",
      0.02
    ],
    [
      "epuisement",
      0.0175
    ],
    [
      "neant",
      0.0175
    ],
    [
      "travers",
      0.0125
    ],
    [
      "platitude",
      0.0125
    ],
    [
      "impuissance",
      0.0125
    ],
    [
      "fragilite",
      0.0125
    ],
    [
      "faute",
      0.0125
    ],
    [
      "defectuosite",
      0.0125
    ],
    [
      "bassesse",
      0.0125
    ],
    [
      "asthenie",
      0.0125
    ],
    [
      "vice",
      0.0125
    ],
    [
      "penchant",
      0.0125
    ],
    [
      "insignifiance",
      0.0125
    ],
    [
      "infirmite",
      0.0125
    ],
    [
      "gout",
      0.0125
    ],
    [
      "facilite",
      0.0125
    ],
    [
      "misere",
      0.0075
    ],
    [
      "lachete",
      0.0075
    ],
    [
      "lacune",
      0.0075
    ],
    [
      "inconsistance",
      0.0075
    ],
    [
      "inclination",
      0.0075
    ],
    [
      "delicatesse",
      0.0075
    ],
    [
      "defaillance",
      0.0075
    ],
    [
      "apathie",
      0.0075
    ],
    [
      "adynamie",
      0.0075
    ],
    [
      "evanouissement",
      0.005
    ],
    [
      "veulerie",
      0.005
    ],
    [
      "preference",
      0.005
    ],
    [
      "prostration",
      0.005
    ],
    [
      "nullite",
      0.005
    ],
    [
      "modicite",
      0.005
    ],
    [
      "inferiorite",
      0.005
    ],
    [
      "imbecillite",
      0.005
    ],
    [
      "erreur",
      0.005
    ],
    [
      "incertitude",
      0.0025
    ],
    [
      "indigence",
      0.0025
    ],
    [
      "indulgence",
      0.0025
    ],
    [
      "malaise",
      0.0025
    ],
    [
      "minceur",
      0.0025
    ],
    [
      "pente",
      0.0025
    ],
    [
      "predilection",
      0.0025
    ],
    [
      "syncope",
      0.0025
    ],
    [
      "faille",
      0.0025
    ],
    [
      "abandon",
      0.0025
    ],
    [
      "aboulie",
      0.0025
    ],
    [
      "anemie",
      0.0025
    ],
    [
      "caducite",
      0.0025
    ],
    [
      "complaisance",
      0.0025
    ],
    [
      "concupiscence",
      0.0025
    ],
    [
      "decouragement",
      0.0025
    ],
    [
      "demission",
      0.0025
    ],
    [
      "extenuation",
      0.0025
    ],
    [
      "inanition",
      0.0
    ],
    [
      "indecision",
      0.0
    ],
    [
      "irresolution",
      0.0
    ],
    [
      "modestie",
      0.0
    ],
    [
      "partialite",
      0.0
    ],
    [
      "pusillanimite",
      0.0
    ],
    [
      "pamoison",
      0.0
    ],
    [
      "ecart",
      0.0
    ],
    [
      "glissade",
      0.0
    ],
    [
      "fadeur",
      0.0
    ],
    [
      "arrieration",
      0.0
    ],
    [
      "aveulissement",
      0.0
    ],
    [
      "cachexie",
      0.0
    ],
    [
      "chair",
      0.0
    ],
    [
      "collapsus",
      0.0
    ],
    [
      "complicite",
      0.0
    ],
    [
      "debonnairete",
      0.0
    ],
    [
      "entrainement",
      0.0
    ],
    [
      "etourdissement",
      0.0
    ]
  ],
  "maladresse": [
    [
      "betise",
      0.09
    ],
    [
      "faute",
      0.09
    ],
    [
      "bevue",
      0.085
    ],
    [
      "sottise",
      0.07
    ],
    [
      "impair",
      0.0475
    ],
    [
      "erreur",
      0.0475
    ],
    [
      "balourdise",
      0.0475
    ],
    [
      "gaffe",
      0.04
    ],
    [
      "anerie",
      0.04
    ],
    [
      "ignorance",
      0.035
    ],
    [
      "incapacite",
      0.035
    ],
    [
      "etourderie",
      0.0275
    ],
    [
      "inexperience",
      0.0275
    ],
    [
      "gaucherie",
      0.0275
    ],
    [
      "blague",
      0.02
    ],
    [
      "bourde",
      0.02
    ],
    [
      "imperitie",
      0.02
    ],
    [
      "inhabilete",
      0.02
    ],
    [
      "naivete",
      0.0125
    ],
    [
      "lourderie",
      0.0125
    ],
    [
      "irreverence",
      0.0125
    ],
    [
      "ineptie",
      0.0125
    ],
    [
      "imprudence",
      0.0125
    ],
    [
      "grossierete",
      0.0125
    ],
    [
      "connerie",
      0.0125
    ],
    [
      "boulette",
      0.0125
    ],
    [
      "malhabilete",
      0.005
    ],
    [
      "maladroit",
      0.005
    ],
    [
      "lourdise",
      0.005
    ],
    [
      "inadvertance",
      0.005
    ],
    [
      "defaut",
      0.005
    ],
    [
      "couillonnade",
      0.005
    ],
    [
      "brioche",
      0.005
    ]
  ],
  "partout": [],
  "soda": [
    [
      "boisson",
      0.3325
    ],
    [
      "limonade",
      0.3325
    ],
    [
      "natron",
      0.3325
    ]
  ],
  "saxo": [
    [
      "saxophone",
      0.5
    ],
    [
      "saxophoniste",
      0.5
    ]
  ],
  "rumba": [],
  "rocke": [],
  "rock": [],
  "mambo": [],
  "rhum": [
    [
      "tafia",
      0.3325
    ],
    [
      "alcool",
      0.165
    ],
    [
      "ratafia",
      0.165
    ]
  ],
  "bidon": [
    [
      "bide",
      0.14
    ],
    [
      "bedaine",
      0.06
    ],
    [
      "insucces",
      0.06
    ],
    [
      "ventre",
      0.06
    ],
    [
      "echec",
      0.06
    ],
    [
      "panse",
      0.04
    ],
    [
      "fiasco",
      0.04
    ],
    [
      "buffet",
      0.04
    ],
    [
      "bouille",
      0.04
    ],
    [
      "abdomen",
      0.04
    ],
    [
      "four",
      0.02
    ],
    [
      "fut",
      0.02
    ],
    [
      "gamelle",
      0.02
    ],
    [
      "gourde",
      0.02
    ],
    [
      "jerrycan",
      0.02
    ],
    [
      "mensonge",
      0.02
    ],
    [
      "nourrice",
      0.02
    ],
    [
      "pelle",
      0.02
    ],
    [
      "reservoir",
      0.02
    ],
    [
      "fantoche",
      0.02
    ],
    [
      "defaite",
      0.02
    ],
    [
      "bedon",
      0.02
    ],
    [
      "berthe",
      0.02
    ],
    [
      "bocal",
      0.02
    ],
    [
      "boille",
      0.02
    ],
    [
      "bouillon",
      0.02
    ],
    [
      "broc",
      0.02
    ],
    [
      "coffre",
      0.02
    ],
    [
      "conteneur",
      0.02
    ],
    [
      "cuve",
      0.02
    ],
    [
      "veste",
      0.02
    ]
  ],
  "amazone": [
    [
      "cavaliere",
      0.25
    ],
    [
      "chasseresse",
      0.25
    ],
    [
      "ecuyere",
      0.25
    ]
  ],
  "chi": [],
  "remonte": [
    [
      "accouplement",
      0.2
    ],
    [
      "cavalerie",
      0.2
    ],
    [
      "monte",
      0.2
    ],
    [
      "remontage",
      0.2
    ],
    [
      "remontee",
      0.2
    ]
  ],
  "malgre": [
    [
      "nonobstant",
      0.31
    ],
    [
      "contre",
      0.075
    ],
    [
      "cependant",
      0.075
    ],
    [
      "avec",
      0.075
    ],
    [
      "absolument",
      0.075
    ]
  ],
  "retard": [
    [
      "atermoiement",
      0.2125
    ],
    [
      "delai",
      0.1775
    ],
    [
      "ajournement",
      0.07
    ],
    [
      "remise",
      0.07
    ],
    [
      "temporisation",
      0.07
    ],
    [
      "pietinement",
      0.035
    ],
    [
      "ralentissement",
      0.035
    ],
    [
      "recul",
      0.035
    ],
    [
      "lenteur",
      0.035
    ],
    [
      "decalage",
      0.035
    ],
    [
      "demeure",
      0.035
    ],
    [
      "arriere",
      0.035
    ],
    [
      "arriere",
      0.035
    ],
    [
      "amusement",
      0.035
    ],
    [
      "retardement",
      0.035
    ]
  ],
  "semblant": [
    [
      "apparence",
      0.225
    ],
    [
      "ombre",
      0.0975
    ],
    [
      "vernis",
      0.0975
    ],
    [
      "simulacre",
      0.0825
    ],
    [
      "teinte",
      0.055
    ],
    [
      "masque",
      0.055
    ],
    [
      "aspect",
      0.04
    ],
    [
      "pretexte",
      0.04
    ],
    [
      "tromperie",
      0.0275
    ],
    [
      "surface",
      0.0275
    ],
    [
      "soupcon",
      0.0275
    ],
    [
      "manteau",
      0.0275
    ],
    [
      "illusion",
      0.0275
    ],
    [
      "facade",
      0.0275
    ],
    [
      "fantome",
      0.0275
    ],
    [
      "imitation",
      0.0125
    ],
    [
      "semblance",
      0.0125
    ]
  ],
  "rentree": [
    [
      "refouler",
      0.07
    ],
    [
      "dissimuler",
      0.06
    ],
    [
      "entrer",
      0.06
    ],
    [
      "penetrer",
      0.06
    ],
    [
      "regagner",
      0.04
    ],
    [
      "contenir",
      0.04
    ],
    [
      "etouffer",
      0.03
    ],
    [
      "revenir",
      0.03
    ],
    [
      "retrouver",
      0.03
    ],
    [
      "retourner",
      0.03
    ],
    [
      "retenir",
      0.03
    ],
    [
      "renfoncer",
      0.03
    ],
    [
      "rallier",
      0.03
    ],
    [
      "concentrer",
      0.03
    ],
    [
      "cacher",
      0.03
    ],
    [
      "reprimer",
      0.0175
    ],
    [
      "s'enfoncer",
      0.0175
    ],
    [
      "s'engager",
      0.0175
    ],
    [
      "s'insinuer",
      0.0175
    ],
    [
      "s'introduire",
      0.0175
    ],
    [
      "taire",
      0.0175
    ],
    [
      "reintegrer",
      0.0175
    ],
    [
      "remettre",
      0.0175
    ],
    [
      "rejoindre",
      0.0175
    ],
    [
      "avaler",
      0.0175
    ],
    [
      "devorer",
      0.0175
    ],
    [
      "escamoter",
      0.0175
    ],
    [
      "introduire",
      0.0175
    ],
    [
      "percuter",
      0.0175
    ],
    [
      "ravaler",
      0.0175
    ],
    [
      "tamponner",
      0.0075
    ],
    [
      "retracter",
      0.0075
    ],
    [
      "rengainer",
      0.0075
    ],
    [
      "refrener",
      0.0075
    ],
    [
      "reconquerir",
      0.0075
    ],
    [
      "emboutir",
      0.0075
    ],
    [
      "creuser",
      0.0075
    ],
    [
      "telescoper",
      0.0075
    ]
  ],
  "marin": [
    [
      "matelot",
      0.215
    ],
    [
      "navigateur",
      0.1225
    ],
    [
      "gabier",
      0.06
    ],
    [
      "mathurin",
      0.06
    ],
    [
      "mousse",
      0.06
    ],
    [
      "naval",
      0.06
    ],
    [
      "nautique",
      0.0275
    ],
    [
      "nautonier",
      0.0275
    ],
    [
      "novice",
      0.0275
    ],
    [
      "pirate",
      0.0275
    ],
    [
      "pecheur",
      0.0275
    ],
    [
      "moussaillon",
      0.0275
    ],
    [
      "marsouin",
      0.0275
    ],
    [
      "maritime",
      0.0275
    ],
    [
      "marinier",
      0.0275
    ],
    [
      "corsaire",
      0.0275
    ],
    [
      "soldat",
      0.0275
    ]
  ],
  "oriflamme": [
    [
      "banniere",
      0.25
    ],
    [
      "drapeau",
      0.25
    ],
    [
      "banderole",
      0.165
    ],
    [
      "flamme",
      0.165
    ],
    [
      "gonfalon",
      0.0825
    ],
    [
      "guidon",
      0.0825
    ]
  ],
  "berge": [
    [
      "an",
      0.1325
    ],
    [
      "bord",
      0.1325
    ],
    [
      "levee",
      0.1325
    ],
    [
      "rive",
      0.065
    ],
    [
      "rivage",
      0.065
    ],
    [
      "pige",
      0.065
    ],
    [
      "chaloupe",
      0.065
    ],
    [
      "berme",
      0.065
    ],
    [
      "barge",
      0.065
    ],
    [
      "annee",
      0.065
    ],
    [
      "talus",
      0.065
    ]
  ],
  "morne": [
    [
      "triste",
      0.1
    ],
    [
      "terne",
      0.0925
    ],
    [
      "melancolique",
      0.0725
    ],
    [
      "sombre",
      0.0725
    ],
    [
      "morose",
      0.0425
    ],
    [
      "plat",
      0.0425
    ],
    [
      "cafardeux",
      0.0325
    ],
    [
      "monotone",
      0.03
    ],
    [
      "maussade",
      0.03
    ],
    [
      "insipide",
      0.03
    ],
    [
      "fade",
      0.03
    ],
    [
      "chagrin",
      0.03
    ],
    [
      "abattu",
      0.025
    ],
    [
      "lugubre",
      0.025
    ],
    [
      "sinistre",
      0.025
    ],
    [
      "tenebreux",
      0.02
    ],
    [
      "uniforme",
      0.015
    ],
    [
      "pale",
      0.015
    ],
    [
      "mort",
      0.015
    ],
    [
      "languissant",
      0.015
    ],
    [
      "eteint",
      0.0125
    ],
    [
      "taciturne",
      0.0125
    ],
    [
      "gris",
      0.0125
    ],
    [
      "funebre",
      0.0125
    ],
    [
      "decolore",
      0.0125
    ],
    [
      "aneanti",
      0.0125
    ],
    [
      "vide",
      0.0075
    ],
    [
      "sepulcral",
      0.0075
    ],
    [
      "silencieux",
      0.0075
    ],
    [
      "prosaique",
      0.0075
    ],
    [
      "nostalgique",
      0.0075
    ],
    [
      "monocorde",
      0.0075
    ],
    [
      "grisatre",
      0.0075
    ],
    [
      "deprime",
      0.0075
    ],
    [
      "brumeux",
      0.0075
    ],
    [
      "atone",
      0.0075
    ],
    [
      "accablant",
      0.0075
    ],
    [
      "mont",
      0.0025
    ],
    [
      "neutre",
      0.0025
    ],
    [
      "prostre",
      0.0025
    ],
    [
      "rechigne",
      0.0025
    ],
    [
      "hauteur",
      0.0025
    ],
    [
      "frette",
      0.0025
    ],
    [
      "desesperant",
      0.0025
    ],
    [
      "deprimant",
      0.0025
    ],
    [
      "couvert",
      0.0025
    ],
    [
      "anneau",
      0.0025
    ],
    [
      "uni",
      0.0025
    ]
  ],
  "biere": [
    [
      "ale",
      0.0575
    ],
    [
      "sake",
      0.0575
    ],
    [
      "porter",
      0.0575
    ],
    [
      "lambic",
      0.0575
    ],
    [
      "kriek",
      0.0575
    ],
    [
      "guinness",
      0.0575
    ],
    [
      "gueuze",
      0.0575
    ],
    [
      "faro",
      0.0575
    ],
    [
      "cervoise",
      0.0575
    ],
    [
      "cercueil",
      0.0575
    ],
    [
      "caisse",
      0.0575
    ],
    [
      "boite",
      0.0575
    ],
    [
      "boisson",
      0.0575
    ],
    [
      "bibine",
      0.0575
    ],
    [
      "stout",
      0.0575
    ]
  ],
  "lueur": [
    [
      "lumiere",
      0.18
    ],
    [
      "eclat",
      0.1325
    ],
    [
      "clarte",
      0.065
    ],
    [
      "flamme",
      0.065
    ],
    [
      "phosphorescence",
      0.065
    ],
    [
      "etincelle",
      0.065
    ],
    [
      "eclair",
      0.0425
    ],
    [
      "scintillement",
      0.0425
    ],
    [
      "halo",
      0.0425
    ],
    [
      "feu",
      0.0425
    ],
    [
      "brasillement",
      0.0425
    ],
    [
      "rayon",
      0.02
    ],
    [
      "paleur",
      0.02
    ],
    [
      "peu",
      0.02
    ],
    [
      "nitescence",
      0.02
    ],
    [
      "jour",
      0.02
    ],
    [
      "illumination",
      0.02
    ],
    [
      "aurore",
      0.02
    ],
    [
      "aube",
      0.02
    ],
    [
      "trace",
      0.02
    ]
  ],
  "chaleur": [
    [
      "ardeur",
      0.145
    ],
    [
      "bouillonnement",
      0.0725
    ],
    [
      "feu",
      0.06
    ],
    [
      "exaltation",
      0.05
    ],
    [
      "flamme",
      0.0475
    ],
    [
      "fougue",
      0.0475
    ],
    [
      "passion",
      0.0475
    ],
    [
      "enthousiasme",
      0.045
    ],
    [
      "vehemence",
      0.04
    ],
    [
      "elan",
      0.03
    ],
    [
      "emportement",
      0.0275
    ],
    [
      "vivacite",
      0.0275
    ],
    [
      "impetuosite",
      0.025
    ],
    [
      "animation",
      0.02
    ],
    [
      "frenesie",
      0.02
    ],
    [
      "fievre",
      0.0175
    ],
    [
      "fanatisme",
      0.0175
    ],
    [
      "force",
      0.015
    ],
    [
      "zele",
      0.0125
    ],
    [
      "transport",
      0.0125
    ],
    [
      "emballement",
      0.0125
    ],
    [
      "excitation",
      0.0125
    ],
    [
      "petulance",
      0.01
    ],
    [
      "vie",
      0.01
    ],
    [
      "violence",
      0.01
    ],
    [
      "vigueur",
      0.01
    ],
    [
      "entrain",
      0.01
    ],
    [
      "amour",
      0.01
    ],
    [
      "action",
      0.0075
    ],
    [
      "empressement",
      0.0075
    ],
    [
      "coeur",
      0.005
    ],
    [
      "effervescence",
      0.005
    ],
    [
      "ferveur",
      0.005
    ],
    [
      "energie",
      0.005
    ],
    [
      "eloquence",
      0.0025
    ],
    [
      "desir",
      0.0025
    ],
    [
      "courage",
      0.0025
    ],
    [
      "concupiscence",
      0.0025
    ],
    [
      "sens",
      0.0025
    ],
    [
      "promptitude",
      0.0025
    ],
    [
      "folie",
      0.0025
    ],
    [
      "entrainement",
      0.0025
    ],
    [
      "brio",
      0.0025
    ],
    [
      "verve",
      0.0
    ],
    [
      "libido",
      0.0
    ],
    [
      "fournaise",
      0.0
    ],
    [
      "brulure",
      0.0
    ],
    [
      "animosite",
      0.0
    ],
    [
      "lubricite",
      0.0
    ],
    [
      "lyrisme",
      0.0
    ],
    [
      "rayonnement",
      0.0
    ],
    [
      "rut",
      0.0
    ],
    [
      "reverberation",
      0.0
    ],
    [
      "touffeur",
      0.0
    ],
    [
      "trempe",
      0.0
    ],
    [
      "etuve",
      0.0
    ],
    [
      "insolation",
      0.0
    ],
    [
      "atmosphere",
      0.0
    ],
    [
      "caloricite",
      0.0
    ],
    [
      "calorification",
      0.0
    ],
    [
      "canicule",
      0.0
    ],
    [
      "chasse",
      0.0
    ],
    [
      "chaud",
      0.0
    ],
    [
      "chaudier",
      0.0
    ],
    [
      "cordialite",
      0.0
    ],
    [
      "ete",
      0.0
    ]
  ],
  "epais": [
    [
      "lourd",
      0.09
    ],
    [
      "gros",
      0.06
    ],
    [
      "fort",
      0.0575
    ],
    [
      "touffu",
      0.0525
    ],
    [
      "dense",
      0.05
    ],
    [
      "massif",
      0.045
    ],
    [
      "trapu",
      0.0275
    ],
    [
      "pesant",
      0.0275
    ],
    [
      "grossier",
      0.0275
    ],
    [
      "abondant",
      0.0225
    ],
    [
      "gras",
      0.0225
    ],
    [
      "compact",
      0.02
    ],
    [
      "ramasse",
      0.02
    ],
    [
      "serre",
      0.02
    ],
    [
      "replet",
      0.0175
    ],
    [
      "rebondi",
      0.0175
    ],
    [
      "lourdaud",
      0.0175
    ],
    [
      "impenetrable",
      0.0175
    ],
    [
      "charge",
      0.015
    ],
    [
      "corpulent",
      0.015
    ],
    [
      "dur",
      0.015
    ],
    [
      "mastoc",
      0.015
    ],
    [
      "pateux",
      0.01
    ],
    [
      "profond",
      0.01
    ],
    [
      "obscur",
      0.01
    ],
    [
      "dru",
      0.01
    ],
    [
      "bete",
      0.01
    ],
    [
      "beotien",
      0.01
    ],
    [
      "vulgaire",
      0.0075
    ],
    [
      "trivial",
      0.0075
    ],
    [
      "tasse",
      0.0075
    ],
    [
      "stupide",
      0.0075
    ],
    [
      "rable",
      0.0075
    ],
    [
      "pris",
      0.0075
    ],
    [
      "obtus",
      0.0075
    ],
    [
      "fourni",
      0.0075
    ],
    [
      "empate",
      0.0075
    ],
    [
      "courtaud",
      0.0075
    ],
    [
      "consistant",
      0.0075
    ],
    [
      "brut",
      0.0075
    ],
    [
      "opaque",
      0.005
    ],
    [
      "presse",
      0.005
    ],
    [
      "tenebreux",
      0.005
    ],
    [
      "visqueux",
      0.005
    ],
    [
      "volumineux",
      0.005
    ],
    [
      "nebuleux",
      0.005
    ],
    [
      "luxuriant",
      0.005
    ],
    [
      "lent",
      0.005
    ],
    [
      "large",
      0.005
    ],
    [
      "laborieux",
      0.005
    ],
    [
      "indigeste",
      0.005
    ],
    [
      "concentre",
      0.005
    ],
    [
      "charnu",
      0.005
    ],
    [
      "imposant",
      0.0025
    ],
    [
      "laineux",
      0.0025
    ],
    [
      "niais",
      0.0025
    ],
    [
      "platreux",
      0.0025
    ],
    [
      "renfle",
      0.0025
    ],
    [
      "gluant",
      0.0025
    ],
    [
      "feuillu",
      0.0025
    ],
    [
      "crasse",
      0.0025
    ],
    [
      "corse",
      0.0025
    ],
    [
      "concret",
      0.0025
    ],
    [
      "carre",
      0.0025
    ],
    [
      "butyreux",
      0.0025
    ],
    [
      "broussailleux",
      0.0025
    ],
    [
      "somnolent",
      0.0025
    ]
  ],
  "langueur": [
    [
      "torpeur",
      0.1425
    ],
    [
      "abattement",
      0.0925
    ],
    [
      "depression",
      0.06
    ],
    [
      "affaiblissement",
      0.055
    ],
    [
      "apathie",
      0.0475
    ],
    [
      "epuisement",
      0.04
    ],
    [
      "mollesse",
      0.0325
    ],
    [
      "faiblesse",
      0.0325
    ],
    [
      "atonie",
      0.0325
    ],
    [
      "aneantissement",
      0.0325
    ],
    [
      "alanguissement",
      0.0325
    ],
    [
      "accablement",
      0.0325
    ],
    [
      "lethargie",
      0.03
    ],
    [
      "prostration",
      0.03
    ],
    [
      "somnolence",
      0.025
    ],
    [
      "assoupissement",
      0.025
    ],
    [
      "engourdissement",
      0.02
    ],
    [
      "indolence",
      0.02
    ],
    [
      "nonchalance",
      0.02
    ],
    [
      "paresse",
      0.02
    ],
    [
      "decouragement",
      0.0175
    ],
    [
      "anemie",
      0.015
    ],
    [
      "marasme",
      0.01
    ],
    [
      "debilite",
      0.01
    ],
    [
      "consomption",
      0.01
    ],
    [
      "affaissement",
      0.01
    ],
    [
      "adynamie",
      0.01
    ],
    [
      "ennui",
      0.0075
    ],
    [
      "lassitude",
      0.0075
    ],
    [
      "stagnation",
      0.0075
    ],
    [
      "melancolie",
      0.005
    ],
    [
      "morbidesse",
      0.005
    ],
    [
      "inactivite",
      0.005
    ],
    [
      "grace",
      0.005
    ],
    [
      "deperissement",
      0.005
    ],
    [
      "languissement",
      0.0025
    ],
    [
      "relachement",
      0.0025
    ],
    [
      "sideration",
      0.0025
    ],
    [
      "tendresse",
      0.0025
    ],
    [
      "etiolement",
      0.0025
    ],
    [
      "etisie",
      0.0025
    ]
  ],
  "nappe": [
    [
      "lit",
      0.2
    ],
    [
      "corporal",
      0.0975
    ],
    [
      "couche",
      0.0975
    ],
    [
      "couvert",
      0.0975
    ],
    [
      "doublier",
      0.0975
    ],
    [
      "flaque",
      0.0975
    ],
    [
      "litiere",
      0.0975
    ],
    [
      "plaine",
      0.0975
    ],
    [
      "vague",
      0.0975
    ]
  ],
  "poisser": [
    [
      "enduire",
      0.1475
    ],
    [
      "engluer",
      0.11
    ],
    [
      "prendre",
      0.11
    ],
    [
      "souiller",
      0.0725
    ],
    [
      "salir",
      0.0725
    ],
    [
      "encrasser",
      0.0725
    ],
    [
      "empoisser",
      0.0725
    ],
    [
      "couvrir",
      0.0725
    ],
    [
      "arreter",
      0.035
    ],
    [
      "attraper",
      0.035
    ],
    [
      "empoicrer",
      0.035
    ],
    [
      "gluer",
      0.035
    ],
    [
      "harponner",
      0.035
    ],
    [
      "tacher",
      0.035
    ]
  ],
  "ruisselant": [
    [
      "degouttant",
      0.22
    ],
    [
      "radieux",
      0.22
    ],
    [
      "degoulinant",
      0.11
    ],
    [
      "mouille",
      0.11
    ],
    [
      "rayonnant",
      0.11
    ],
    [
      "resplendissant",
      0.11
    ],
    [
      "trempe",
      0.11
    ]
  ],
  "dent": [
    [
      "aiguille",
      0.0475
    ],
    [
      "haine",
      0.0475
    ],
    [
      "sommet",
      0.0475
    ],
    [
      "eperon",
      0.0325
    ],
    [
      "saillie",
      0.0325
    ],
    [
      "ressentiment",
      0.0325
    ],
    [
      "rancune",
      0.0325
    ],
    [
      "pic",
      0.0325
    ],
    [
      "molaire",
      0.0325
    ],
    [
      "denture",
      0.0325
    ],
    [
      "crete",
      0.0325
    ],
    [
      "croc",
      0.0325
    ],
    [
      "canine",
      0.0325
    ],
    [
      "jalousie",
      0.015
    ],
    [
      "indentation",
      0.015
    ],
    [
      "incisive",
      0.015
    ],
    [
      "fringale",
      0.015
    ],
    [
      "feston",
      0.015
    ],
    [
      "faim",
      0.015
    ],
    [
      "mont",
      0.015
    ],
    [
      "macheliere",
      0.015
    ],
    [
      "pince",
      0.015
    ],
    [
      "premolaire",
      0.015
    ],
    [
      "quenotte",
      0.015
    ],
    [
      "rancoeur",
      0.015
    ],
    [
      "ratiche",
      0.015
    ],
    [
      "surdent",
      0.015
    ],
    [
      "tabouret",
      0.015
    ],
    [
      "defense",
      0.015
    ],
    [
      "domino",
      0.015
    ],
    [
      "animosite",
      0.015
    ],
    [
      "arret",
      0.015
    ],
    [
      "broche",
      0.015
    ],
    [
      "came",
      0.015
    ],
    [
      "carnassiere",
      0.015
    ],
    [
      "chaille",
      0.015
    ],
    [
      "chicot",
      0.015
    ],
    [
      "chocotte",
      0.015
    ],
    [
      "cran",
      0.015
    ],
    [
      "crochet",
      0.015
    ],
    [
      "cement",
      0.015
    ],
    [
      "denticule",
      0.015
    ],
    [
      "dentier",
      0.015
    ],
    [
      "dentition",
      0.015
    ],
    [
      "alluchon",
      0.015
    ]
  ],
  "croquer": [
    [
      "manger",
      0.1225
    ],
    [
      "dilapider",
      0.0775
    ],
    [
      "dissiper",
      0.065
    ],
    [
      "engloutir",
      0.065
    ],
    [
      "esquisser",
      0.055
    ],
    [
      "claquer",
      0.055
    ],
    [
      "depenser",
      0.0425
    ],
    [
      "devorer",
      0.0425
    ],
    [
      "pocher",
      0.0325
    ],
    [
      "peindre",
      0.0325
    ],
    [
      "camper",
      0.0325
    ],
    [
      "broyer",
      0.0325
    ],
    [
      "bouffer",
      0.0325
    ],
    [
      "ebaucher",
      0.02
    ],
    [
      "triturer",
      0.02
    ],
    [
      "saisir",
      0.02
    ],
    [
      "mordre",
      0.02
    ],
    [
      "mettre",
      0.02
    ],
    [
      "gruger",
      0.02
    ],
    [
      "gaspiller",
      0.02
    ],
    [
      "engouffrer",
      0.02
    ],
    [
      "dessiner",
      0.02
    ],
    [
      "boulotter",
      0.02
    ],
    [
      "nettoyer",
      0.01
    ],
    [
      "escamoter",
      0.01
    ],
    [
      "croustiller",
      0.01
    ],
    [
      "crayonner",
      0.01
    ],
    [
      "craquer",
      0.01
    ],
    [
      "caricaturer",
      0.01
    ],
    [
      "ecraser",
      0.01
    ]
  ],
  "hauban": [
    [
      "cordage",
      0.3325
    ],
    [
      "galhauban",
      0.11
    ],
    [
      "guinderesse",
      0.11
    ],
    [
      "suspente",
      0.11
    ],
    [
      "tenseur",
      0.11
    ],
    [
      "etai",
      0.11
    ]
  ],
  "morue": [
    [
      "eglefin",
      0.285
    ],
    [
      "cabillaud",
      0.1425
    ],
    [
      "haddock",
      0.1425
    ],
    [
      "merluche",
      0.1425
    ],
    [
      "prostituee",
      0.1425
    ],
    [
      "putain",
      0.1425
    ]
  ],
  "frite": [
    [
      "cuire",
      0.25
    ],
    [
      "fricasser",
      0.25
    ],
    [
      "gresiller",
      0.25
    ],
    [
      "rotir",
      0.25
    ]
  ],
  "riant": [
    [
      "beau",
      0.1075
    ],
    [
      "agreable",
      0.095
    ],
    [
      "charmant",
      0.095
    ],
    [
      "aimable",
      0.08
    ],
    [
      "plaisant",
      0.0675
    ],
    [
      "joli",
      0.0675
    ],
    [
      "gai",
      0.0675
    ],
    [
      "joyeux",
      0.0525
    ],
    [
      "rejoui",
      0.04
    ],
    [
      "rieur",
      0.04
    ],
    [
      "enjoue",
      0.04
    ],
    [
      "enchanteur",
      0.04
    ],
    [
      "epanoui",
      0.025
    ],
    [
      "ravissant",
      0.025
    ],
    [
      "radieux",
      0.025
    ],
    [
      "hilare",
      0.025
    ],
    [
      "gracieux",
      0.025
    ],
    [
      "amusant",
      0.025
    ],
    [
      "fleuri",
      0.0125
    ],
    [
      "insouciant",
      0.0125
    ]
  ],
  "braguette": [],
  "roter": [
    [
      "beer",
      0.3325
    ],
    [
      "eructer",
      0.3325
    ]
  ],
  "panse": [
    [
      "ventre",
      0.22
    ],
    [
      "bedaine",
      0.11
    ],
    [
      "bedon",
      0.11
    ],
    [
      "bidon",
      0.11
    ],
    [
      "tirelire",
      0.11
    ],
    [
      "galbe",
      0.055
    ],
    [
      "estomac",
      0.055
    ],
    [
      "bocal",
      0.055
    ],
    [
      "bide",
      0.055
    ],
    [
      "abdomen",
      0.055
    ],
    [
      "rumen",
      0.055
    ]
  ],
  "panser": [
    [
      "bouchonner",
      0.2
    ],
    [
      "brosser",
      0.2
    ],
    [
      "soigner",
      0.2
    ],
    [
      "adoucir",
      0.1
    ],
    [
      "bander",
      0.1
    ],
    [
      "calmer",
      0.1
    ],
    [
      "etriller",
      0.1
    ]
  ],
  "dechire": [
    [
      "blesser",
      0.07
    ],
    [
      "couper",
      0.07
    ],
    [
      "rompre",
      0.0475
    ],
    [
      "casser",
      0.0375
    ],
    [
      "dechiqueter",
      0.035
    ],
    [
      "ereinter",
      0.03
    ],
    [
      "percer",
      0.03
    ],
    [
      "ecorcher",
      0.025
    ],
    [
      "entamer",
      0.0225
    ],
    [
      "fendre",
      0.0225
    ],
    [
      "labourer",
      0.0225
    ],
    [
      "ouvrir",
      0.0225
    ],
    [
      "mordre",
      0.02
    ],
    [
      "briser",
      0.02
    ],
    [
      "taillader",
      0.0175
    ],
    [
      "esquinter",
      0.0175
    ],
    [
      "diviser",
      0.0175
    ],
    [
      "broyer",
      0.0175
    ],
    [
      "balafrer",
      0.0175
    ],
    [
      "affliger",
      0.0175
    ],
    [
      "erafler",
      0.015
    ],
    [
      "egratigner",
      0.015
    ],
    [
      "transpercer",
      0.015
    ],
    [
      "tourmenter",
      0.015
    ],
    [
      "tailler",
      0.015
    ],
    [
      "navrer",
      0.015
    ],
    [
      "medire",
      0.015
    ],
    [
      "denigrer",
      0.015
    ],
    [
      "arracher",
      0.015
    ],
    [
      "triturer",
      0.01
    ],
    [
      "morceler",
      0.01
    ],
    [
      "griffer",
      0.01
    ],
    [
      "defaire",
      0.01
    ],
    [
      "crever",
      0.01
    ],
    [
      "chagriner",
      0.01
    ],
    [
      "emouvoir",
      0.0075
    ],
    [
      "traverser",
      0.0075
    ],
    [
      "offenser",
      0.0075
    ],
    [
      "lacerer",
      0.0075
    ],
    [
      "desoler",
      0.0075
    ],
    [
      "depecer",
      0.0075
    ],
    [
      "delabrer",
      0.0075
    ],
    [
      "discrediter",
      0.0075
    ],
    [
      "critiquer",
      0.0075
    ],
    [
      "meurtrir",
      0.005
    ],
    [
      "reveler",
      0.005
    ],
    [
      "scinder",
      0.005
    ],
    [
      "tirailler",
      0.005
    ],
    [
      "torturer",
      0.005
    ],
    [
      "trouer",
      0.005
    ],
    [
      "attrister",
      0.005
    ],
    [
      "calomnier",
      0.005
    ],
    [
      "diffamer",
      0.005
    ],
    [
      "decoudre",
      0.005
    ],
    [
      "desunir",
      0.005
    ],
    [
      "devoiler",
      0.005
    ],
    [
      "erailler",
      0.0
    ],
    [
      "elargir",
      0.0
    ],
    [
      "ecarteler",
      0.0
    ],
    [
      "outrager",
      0.0
    ],
    [
      "dilacerer",
      0.0
    ],
    [
      "crosser",
      0.0
    ],
    [
      "carder",
      0.0
    ],
    [
      "annuler",
      0.0
    ],
    [
      "accrocher",
      0.0
    ],
    [
      "etreindre",
      0.0
    ]
  ],
  "accordeon": [
    [
      "bandoneon",
      1.0
    ]
  ],
  "rance": [
    [
      "aigre",
      0.25
    ],
    [
      "bordage",
      0.125
    ],
    [
      "ginguet",
      0.125
    ],
    [
      "gate",
      0.125
    ],
    [
      "pourri",
      0.125
    ],
    [
      "ranci",
      0.125
    ],
    [
      "acre",
      0.125
    ]
  ],
  "rancer": [],
  "tordre": [
    [
      "deformer",
      0.09
    ],
    [
      "courber",
      0.065
    ],
    [
      "fausser",
      0.065
    ],
    [
      "gauchir",
      0.065
    ],
    [
      "tortiller",
      0.065
    ],
    [
      "tourner",
      0.065
    ],
    [
      "forcer",
      0.0525
    ],
    [
      "contourner",
      0.0375
    ],
    [
      "denaturer",
      0.0375
    ],
    [
      "tresser",
      0.025
    ],
    [
      "plier",
      0.025
    ],
    [
      "fouler",
      0.025
    ],
    [
      "detourner",
      0.025
    ],
    [
      "cintrer",
      0.025
    ],
    [
      "bistourner",
      0.025
    ],
    [
      "alterer",
      0.025
    ],
    [
      "manger",
      0.0125
    ],
    [
      "mouliner",
      0.0125
    ],
    [
      "ployer",
      0.0125
    ],
    [
      "retordre",
      0.0125
    ],
    [
      "tirebouchonner",
      0.0125
    ],
    [
      "torcher",
      0.0125
    ],
    [
      "torsader",
      0.0125
    ],
    [
      "tortillonner",
      0.0125
    ],
    [
      "mailler",
      0.0125
    ],
    [
      "luxer",
      0.0125
    ],
    [
      "filer",
      0.0125
    ],
    [
      "bouchonner",
      0.0125
    ],
    [
      "boudiner",
      0.0125
    ],
    [
      "coller",
      0.0125
    ],
    [
      "commettre",
      0.0125
    ],
    [
      "cordeler",
      0.0125
    ],
    [
      "cabler",
      0.0125
    ],
    [
      "distordre",
      0.0125
    ],
    [
      "entortiller",
      0.0125
    ],
    [
      "tourniller",
      0.0125
    ]
  ],
  "expirer": [
    [
      "s'eteindre",
      0.125
    ],
    [
      "mourir",
      0.0975
    ],
    [
      "finir",
      0.09
    ],
    [
      "disparaitre",
      0.0825
    ],
    [
      "s'evanouir",
      0.075
    ],
    [
      "passer",
      0.0625
    ],
    [
      "cesser",
      0.055
    ],
    [
      "s'effacer",
      0.0475
    ],
    [
      "perir",
      0.04
    ],
    [
      "agoniser",
      0.0275
    ],
    [
      "succomber",
      0.0275
    ],
    [
      "trepasser",
      0.02
    ],
    [
      "s'ecrouler",
      0.02
    ],
    [
      "s'estomper",
      0.02
    ],
    [
      "s'effondrer",
      0.02
    ],
    [
      "s'achever",
      0.02
    ],
    [
      "souffler",
      0.005
    ],
    [
      "respirer",
      0.005
    ],
    [
      "pousser",
      0.005
    ],
    [
      "exhaler",
      0.005
    ],
    [
      "deceder",
      0.005
    ]
  ],
  "geste": [
    [
      "attitude",
      0.085
    ],
    [
      "action",
      0.07
    ],
    [
      "mime",
      0.07
    ],
    [
      "mouvement",
      0.07
    ],
    [
      "tenue",
      0.07
    ],
    [
      "conduite",
      0.055
    ],
    [
      "maniere",
      0.055
    ],
    [
      "contenance",
      0.0425
    ],
    [
      "allure",
      0.0425
    ],
    [
      "signe",
      0.0275
    ],
    [
      "poeme",
      0.0275
    ],
    [
      "posture",
      0.0275
    ],
    [
      "pantomime",
      0.0275
    ],
    [
      "oeuvre",
      0.0275
    ],
    [
      "mimique",
      0.0275
    ],
    [
      "histoire",
      0.0275
    ],
    [
      "gesticulation",
      0.0275
    ],
    [
      "fait",
      0.0275
    ],
    [
      "exploit",
      0.0275
    ],
    [
      "acte",
      0.0275
    ],
    [
      "reflexe",
      0.0125
    ],
    [
      "minauderie",
      0.0125
    ],
    [
      "hochement",
      0.0125
    ],
    [
      "demonstration",
      0.0125
    ],
    [
      "contorsion",
      0.0125
    ],
    [
      "caresse",
      0.0125
    ],
    [
      "epopee",
      0.0125
    ]
  ],
  "grave": [
    [
      "marquer",
      0.1775
    ],
    [
      "inscrire",
      0.1175
    ],
    [
      "imprimer",
      0.0975
    ],
    [
      "buriner",
      0.0575
    ],
    [
      "empreindre",
      0.0575
    ],
    [
      "fixer",
      0.0575
    ],
    [
      "incruster",
      0.0575
    ],
    [
      "ecrire",
      0.0375
    ],
    [
      "tracer",
      0.0375
    ],
    [
      "tatouer",
      0.0175
    ],
    [
      "sculpter",
      0.0175
    ],
    [
      "poinconner",
      0.0175
    ],
    [
      "nieller",
      0.0175
    ],
    [
      "lithographier",
      0.0175
    ],
    [
      "intailler",
      0.0175
    ],
    [
      "insculper",
      0.0175
    ],
    [
      "inculquer",
      0.0175
    ],
    [
      "immortaliser",
      0.0175
    ],
    [
      "guillocher",
      0.0175
    ],
    [
      "estamper",
      0.0175
    ],
    [
      "enregistrer",
      0.0175
    ],
    [
      "engraver",
      0.0175
    ],
    [
      "dessiner",
      0.0175
    ],
    [
      "echopper",
      0.0175
    ]
  ],
  "sante": [
    [
      "temperament",
      0.155
    ],
    [
      "vie",
      0.075
    ],
    [
      "prosperite",
      0.075
    ],
    [
      "prosit",
      0.075
    ],
    [
      "nature",
      0.075
    ],
    [
      "hygiene",
      0.075
    ],
    [
      "force",
      0.075
    ],
    [
      "discours",
      0.075
    ],
    [
      "convalescence",
      0.075
    ],
    [
      "constitution",
      0.075
    ],
    [
      "complexion",
      0.075
    ],
    [
      "equilibre",
      0.075
    ]
  ],
  "dames": [
    [
      "amante",
      0.115
    ],
    [
      "maitresse",
      0.115
    ],
    [
      "femme",
      0.075
    ],
    [
      "parbleu",
      0.0375
    ],
    [
      "pardi",
      0.0375
    ],
    [
      "pilon",
      0.0375
    ],
    [
      "reine",
      0.0375
    ],
    [
      "religieuse",
      0.0375
    ],
    [
      "soeur",
      0.0375
    ],
    [
      "tolet",
      0.0375
    ],
    [
      "oui",
      0.0375
    ],
    [
      "nonne",
      0.0375
    ],
    [
      "madame",
      0.0375
    ],
    [
      "hie",
      0.0375
    ],
    [
      "dulcinee",
      0.0375
    ],
    [
      "bourgeoise",
      0.0375
    ],
    [
      "batte",
      0.0375
    ],
    [
      "atourneuse",
      0.0375
    ],
    [
      "amie",
      0.0375
    ],
    [
      "epouse",
      0.0375
    ]
  ],
  "vertu": [
    [
      "capacite",
      0.0525
    ],
    [
      "honnetete",
      0.0525
    ],
    [
      "valeur",
      0.0525
    ],
    [
      "merite",
      0.0475
    ],
    [
      "force",
      0.0475
    ],
    [
      "chastete",
      0.0475
    ],
    [
      "pouvoir",
      0.0425
    ],
    [
      "pudeur",
      0.0425
    ],
    [
      "purete",
      0.0425
    ],
    [
      "qualite",
      0.0425
    ],
    [
      "puissance",
      0.0375
    ],
    [
      "bien",
      0.0325
    ],
    [
      "faculte",
      0.0275
    ],
    [
      "honneur",
      0.0275
    ],
    [
      "reserve",
      0.0225
    ],
    [
      "perfection",
      0.0225
    ],
    [
      "morale",
      0.0225
    ],
    [
      "continence",
      0.0225
    ],
    [
      "talent",
      0.0175
    ],
    [
      "retenue",
      0.0175
    ],
    [
      "propriete",
      0.0175
    ],
    [
      "probite",
      0.0175
    ],
    [
      "moralite",
      0.0175
    ],
    [
      "integrite",
      0.0175
    ],
    [
      "efficacite",
      0.0175
    ],
    [
      "tenue",
      0.0125
    ],
    [
      "sagesse",
      0.0125
    ],
    [
      "decence",
      0.0125
    ],
    [
      "courage",
      0.0125
    ],
    [
      "coeur",
      0.0125
    ],
    [
      "energie",
      0.0075
    ],
    [
      "temperance",
      0.0075
    ],
    [
      "saintete",
      0.0075
    ],
    [
      "pudicite",
      0.0075
    ],
    [
      "justice",
      0.0075
    ],
    [
      "gloire",
      0.0075
    ],
    [
      "disposition",
      0.0075
    ],
    [
      "devoir",
      0.0075
    ],
    [
      "charite",
      0.0075
    ],
    [
      "ange",
      0.0075
    ],
    [
      "prudence",
      0.0025
    ],
    [
      "heroisme",
      0.0025
    ],
    [
      "esperance",
      0.0025
    ],
    [
      "effet",
      0.0025
    ],
    [
      "virginite",
      0.0025
    ]
  ],
  "pisser": [
    [
      "uriner",
      0.24
    ],
    [
      "couler",
      0.08
    ],
    [
      "faire",
      0.08
    ],
    [
      "produire",
      0.08
    ],
    [
      "evacuer",
      0.08
    ],
    [
      "pissoter",
      0.04
    ],
    [
      "pleuvoir",
      0.04
    ],
    [
      "rediger",
      0.04
    ],
    [
      "suinter",
      0.04
    ],
    [
      "perdre",
      0.04
    ],
    [
      "fuir",
      0.04
    ],
    [
      "compiler",
      0.04
    ]
  ],
  "plisser": [
    [
      "chiffonner",
      0.0825
    ],
    [
      "rider",
      0.0825
    ],
    [
      "plier",
      0.0825
    ],
    [
      "onduler",
      0.0825
    ],
    [
      "gresiller",
      0.0825
    ],
    [
      "gondoler",
      0.0825
    ],
    [
      "froncer",
      0.0825
    ],
    [
      "froisser",
      0.0825
    ],
    [
      "friper",
      0.0825
    ],
    [
      "fraiser",
      0.0825
    ],
    [
      "doubler",
      0.0825
    ],
    [
      "rucher",
      0.0825
    ]
  ],
  "plisse": [
    [
      "chiffonner",
      0.0825
    ],
    [
      "rider",
      0.0825
    ],
    [
      "plier",
      0.0825
    ],
    [
      "onduler",
      0.0825
    ],
    [
      "gresiller",
      0.0825
    ],
    [
      "gondoler",
      0.0825
    ],
    [
      "froncer",
      0.0825
    ],
    [
      "froisser",
      0.0825
    ],
    [
      "friper",
      0.0825
    ],
    [
      "fraiser",
      0.0825
    ],
    [
      "doubler",
      0.0825
    ],
    [
      "rucher",
      0.0825
    ]
  ],
  "creneau": [
    [
      "dentelure",
      0.165
    ],
    [
      "embrasure",
      0.165
    ],
    [
      "meurtriere",
      0.165
    ],
    [
      "machicoulis",
      0.165
    ],
    [
      "ouverture",
      0.165
    ],
    [
      "parapet",
      0.165
    ]
  ],
  "mecher": [
    [
      "soufrer",
      1.0
    ]
  ],
  "ejaculer": [
    [
      "jeter",
      0.3325
    ],
    [
      "projeter",
      0.3325
    ],
    [
      "ejecter",
      0.3325
    ]
  ],
  "capitale": [
    [
      "principal",
      0.105
    ],
    [
      "bien",
      0.0875
    ],
    [
      "essentiel",
      0.06
    ],
    [
      "fondamental",
      0.06
    ],
    [
      "primordial",
      0.06
    ],
    [
      "argent",
      0.0525
    ],
    [
      "important",
      0.0525
    ],
    [
      "fonds",
      0.0425
    ],
    [
      "richesse",
      0.0325
    ],
    [
      "fortune",
      0.0325
    ],
    [
      "vital",
      0.025
    ],
    [
      "propriete",
      0.025
    ],
    [
      "premier",
      0.025
    ],
    [
      "patrimoine",
      0.025
    ],
    [
      "finance",
      0.025
    ],
    [
      "avoir",
      0.025
    ],
    [
      "tresor",
      0.015
    ],
    [
      "majeur",
      0.015
    ],
    [
      "decisif",
      0.015
    ],
    [
      "dominant",
      0.015
    ],
    [
      "crucial",
      0.015
    ],
    [
      "chose",
      0.015
    ],
    [
      "clef",
      0.0075
    ],
    [
      "numeraire",
      0.0075
    ],
    [
      "radical",
      0.0075
    ],
    [
      "supreme",
      0.0075
    ],
    [
      "terre",
      0.0075
    ],
    [
      "valeur",
      0.0075
    ],
    [
      "vie",
      0.0075
    ],
    [
      "cheptel",
      0.0075
    ],
    [
      "chef",
      0.0075
    ],
    [
      "central",
      0.0075
    ],
    [
      "cardinal",
      0.0075
    ],
    [
      "capitalisme",
      0.0075
    ],
    [
      "benefice",
      0.0075
    ],
    [
      "acquis",
      0.0075
    ],
    [
      "etablissement",
      0.0075
    ]
  ],
  "capital": [
    [
      "principal",
      0.105
    ],
    [
      "bien",
      0.0875
    ],
    [
      "essentiel",
      0.06
    ],
    [
      "fondamental",
      0.06
    ],
    [
      "primordial",
      0.06
    ],
    [
      "argent",
      0.0525
    ],
    [
      "important",
      0.0525
    ],
    [
      "fonds",
      0.0425
    ],
    [
      "richesse",
      0.0325
    ],
    [
      "fortune",
      0.0325
    ],
    [
      "vital",
      0.025
    ],
    [
      "propriete",
      0.025
    ],
    [
      "premier",
      0.025
    ],
    [
      "patrimoine",
      0.025
    ],
    [
      "finance",
      0.025
    ],
    [
      "avoir",
      0.025
    ],
    [
      "tresor",
      0.015
    ],
    [
      "majeur",
      0.015
    ],
    [
      "decisif",
      0.015
    ],
    [
      "dominant",
      0.015
    ],
    [
      "crucial",
      0.015
    ],
    [
      "chose",
      0.015
    ],
    [
      "clef",
      0.0075
    ],
    [
      "numeraire",
      0.0075
    ],
    [
      "radical",
      0.0075
    ],
    [
      "supreme",
      0.0075
    ],
    [
      "terre",
      0.0075
    ],
    [
      "valeur",
      0.0075
    ],
    [
      "vie",
      0.0075
    ],
    [
      "cheptel",
      0.0075
    ],
    [
      "chef",
      0.0075
    ],
    [
      "central",
      0.0075
    ],
    [
      "cardinal",
      0.0075
    ],
    [
      "capitalisme",
      0.0075
    ],
    [
      "benefice",
      0.0075
    ],
    [
      "acquis",
      0.0075
    ],
    [
      "etablissement",
      0.0075
    ]
  ],
  "decapiter": [
    [
      "couper",
      0.16
    ],
    [
      "guillotiner",
      0.12
    ],
    [
      "executer",
      0.1
    ],
    [
      "tuer",
      0.1
    ],
    [
      "abattre",
      0.08
    ],
    [
      "detruire",
      0.06
    ],
    [
      "raccourcir",
      0.06
    ],
    [
      "ecimer",
      0.06
    ],
    [
      "supplicier",
      0.0375
    ],
    [
      "decoller",
      0.0375
    ],
    [
      "decouronner",
      0.0175
    ],
    [
      "exterminer",
      0.0175
    ],
    [
      "trancher",
      0.0175
    ],
    [
      "ecreter",
      0.0175
    ],
    [
      "emonder",
      0.0175
    ],
    [
      "eteter",
      0.0175
    ]
  ],
  "appart": [],
  "semaine": [
    [
      "bague",
      0.2
    ],
    [
      "retribution",
      0.2
    ],
    [
      "semainier",
      0.2
    ],
    [
      "traitement",
      0.2
    ]
  ],
  "parlement": [
    [
      "assemblee",
      0.375
    ],
    [
      "chambre",
      0.125
    ],
    [
      "cour",
      0.125
    ],
    [
      "legislateur",
      0.125
    ],
    [
      "legislature",
      0.125
    ]
  ],
  "troisieme": [
    [
      "ter",
      0.3325
    ],
    [
      "tertiaire",
      0.3325
    ],
    [
      "tiers",
      0.3325
    ]
  ],
  "jambe": [
    [
      "bequille",
      0.09
    ],
    [
      "pied",
      0.09
    ],
    [
      "quille",
      0.0575
    ],
    [
      "poutre",
      0.0575
    ],
    [
      "poteau",
      0.0575
    ],
    [
      "pinceau",
      0.0575
    ],
    [
      "cuisse",
      0.0575
    ],
    [
      "membre",
      0.0275
    ],
    [
      "patte",
      0.0275
    ],
    [
      "pilier",
      0.0275
    ],
    [
      "pilon",
      0.0275
    ],
    [
      "pincette",
      0.0275
    ],
    [
      "ripaton",
      0.0275
    ],
    [
      "jambage",
      0.0275
    ],
    [
      "guibole",
      0.0275
    ],
    [
      "gigue",
      0.0275
    ],
    [
      "gigot",
      0.0275
    ],
    [
      "gambette",
      0.0275
    ],
    [
      "fumeron",
      0.0275
    ],
    [
      "flute",
      0.0275
    ],
    [
      "compas",
      0.0275
    ],
    [
      "canne",
      0.0275
    ],
    [
      "branche",
      0.0275
    ],
    [
      "echasse",
      0.0275
    ]
  ],
  "stopper": [
    [
      "arreter",
      0.17
    ],
    [
      "paralyser",
      0.09
    ],
    [
      "bloquer",
      0.0775
    ],
    [
      "endiguer",
      0.065
    ],
    [
      "freiner",
      0.065
    ],
    [
      "juguler",
      0.065
    ],
    [
      "etouffer",
      0.05
    ],
    [
      "s'arreter",
      0.05
    ],
    [
      "contenir",
      0.0375
    ],
    [
      "immobiliser",
      0.0375
    ],
    [
      "repriser",
      0.025
    ],
    [
      "ravauder",
      0.025
    ],
    [
      "raccommoder",
      0.025
    ],
    [
      "maitriser",
      0.025
    ],
    [
      "mater",
      0.025
    ],
    [
      "stationner",
      0.0125
    ],
    [
      "s'interrompre",
      0.0125
    ],
    [
      "s'immobiliser",
      0.0125
    ],
    [
      "reparer",
      0.0125
    ],
    [
      "rentraire",
      0.0125
    ],
    [
      "obstruer",
      0.0125
    ],
    [
      "mouiller",
      0.0125
    ],
    [
      "circonscrire",
      0.0125
    ],
    [
      "ankyloser",
      0.0125
    ],
    [
      "ancrer",
      0.0125
    ],
    [
      "suspendre",
      0.0125
    ]
  ],
  "store": [
    [
      "rideau",
      0.3325
    ],
    [
      "banne",
      0.165
    ],
    [
      "fermeture",
      0.165
    ],
    [
      "jalousie",
      0.165
    ],
    [
      "ecran",
      0.165
    ]
  ],
  "retarder": [
    [
      "temporiser",
      0.0975
    ],
    [
      "differer",
      0.0925
    ],
    [
      "remettre",
      0.0925
    ],
    [
      "reculer",
      0.065
    ],
    [
      "renvoyer",
      0.0575
    ],
    [
      "ajourner",
      0.045
    ],
    [
      "proroger",
      0.045
    ],
    [
      "surseoir",
      0.0375
    ],
    [
      "atermoyer",
      0.025
    ],
    [
      "lanterner",
      0.025
    ],
    [
      "repousser",
      0.025
    ],
    [
      "trainer",
      0.025
    ],
    [
      "tarder",
      0.0175
    ],
    [
      "suspendre",
      0.0175
    ],
    [
      "reporter",
      0.0175
    ],
    [
      "ralentir",
      0.0175
    ],
    [
      "promener",
      0.0175
    ],
    [
      "arreter",
      0.0175
    ],
    [
      "eloigner",
      0.0125
    ],
    [
      "paralyser",
      0.0125
    ],
    [
      "freiner",
      0.0125
    ],
    [
      "entraver",
      0.0125
    ],
    [
      "attendre",
      0.0125
    ],
    [
      "allonger",
      0.0125
    ],
    [
      "gener",
      0.005
    ],
    [
      "decaler",
      0.005
    ],
    [
      "attarder",
      0.005
    ],
    [
      "arrierer",
      0.005
    ],
    [
      "accrocher",
      0.005
    ],
    [
      "prolonger",
      0.005
    ]
  ],
  "battement": [
    [
      "remous",
      0.0825
    ],
    [
      "balancement",
      0.0575
    ],
    [
      "bruit",
      0.0575
    ],
    [
      "oscillation",
      0.0575
    ],
    [
      "palpitation",
      0.0475
    ],
    [
      "fremissement",
      0.0475
    ],
    [
      "alternance",
      0.0475
    ],
    [
      "vibration",
      0.035
    ],
    [
      "rythme",
      0.035
    ],
    [
      "pulsation",
      0.035
    ],
    [
      "pause",
      0.035
    ],
    [
      "frisson",
      0.035
    ],
    [
      "coup",
      0.035
    ],
    [
      "mouvement",
      0.0225
    ],
    [
      "entracte",
      0.0225
    ],
    [
      "clignement",
      0.0225
    ],
    [
      "bruissement",
      0.0225
    ],
    [
      "intervalle",
      0.01
    ],
    [
      "martelement",
      0.01
    ],
    [
      "papillonnement",
      0.01
    ],
    [
      "roulement",
      0.01
    ],
    [
      "tambourinement",
      0.01
    ],
    [
      "tapement",
      0.01
    ],
    [
      "tapotement",
      0.01
    ],
    [
      "trille",
      0.01
    ],
    [
      "ebrouement",
      0.01
    ],
    [
      "interlude",
      0.01
    ],
    [
      "interference",
      0.01
    ],
    [
      "interclasse",
      0.01
    ],
    [
      "applaudissement",
      0.01
    ],
    [
      "battant",
      0.01
    ],
    [
      "battue",
      0.01
    ],
    [
      "bravo",
      0.01
    ],
    [
      "cillement",
      0.01
    ],
    [
      "clignotement",
      0.01
    ],
    [
      "frappement",
      0.01
    ],
    [
      "heurt",
      0.01
    ],
    [
      "acceleration",
      0.01
    ]
  ],
  "frein": [
    [
      "obstacle",
      0.21
    ],
    [
      "empechement",
      0.1575
    ],
    [
      "entrave",
      0.1575
    ],
    [
      "borne",
      0.105
    ],
    [
      "limite",
      0.105
    ],
    [
      "traverse",
      0.105
    ],
    [
      "digue",
      0.05
    ],
    [
      "mors",
      0.05
    ],
    [
      "resistance",
      0.05
    ]
  ],
  "calmant": [
    [
      "narcotique",
      0.1625
    ],
    [
      "sedatif",
      0.1625
    ],
    [
      "apaisant",
      0.0925
    ],
    [
      "lenitif",
      0.0575
    ],
    [
      "adoucissant",
      0.045
    ],
    [
      "somnifere",
      0.0325
    ],
    [
      "reposant",
      0.0325
    ],
    [
      "lenifiant",
      0.0325
    ],
    [
      "consolant",
      0.0325
    ],
    [
      "baume",
      0.0325
    ],
    [
      "reconfortant",
      0.0225
    ],
    [
      "hypnotique",
      0.0225
    ],
    [
      "berceur",
      0.0225
    ],
    [
      "antalgique",
      0.0225
    ],
    [
      "anodin",
      0.0225
    ],
    [
      "anesthesique",
      0.0225
    ],
    [
      "analgesique",
      0.0225
    ],
    [
      "tranquillisant",
      0.01
    ],
    [
      "remede",
      0.01
    ],
    [
      "relaxant",
      0.01
    ],
    [
      "rasserenant",
      0.01
    ],
    [
      "rafraichissant",
      0.01
    ],
    [
      "paregorique",
      0.01
    ],
    [
      "consolation",
      0.01
    ],
    [
      "balsamique",
      0.01
    ],
    [
      "assoupissant",
      0.01
    ],
    [
      "antispasmodique",
      0.01
    ],
    [
      "antipyretique",
      0.01
    ],
    [
      "vulneraire",
      0.01
    ]
  ],
  "douanier": [
    [
      "gabelou",
      0.5
    ]
  ],
  "usine": [
    [
      "affaire",
      0.0825
    ],
    [
      "exploitation",
      0.0825
    ],
    [
      "fabrique",
      0.0825
    ],
    [
      "fonderie",
      0.0825
    ],
    [
      "industrie",
      0.0825
    ],
    [
      "etablissement",
      0.0825
    ],
    [
      "manufacture",
      0.055
    ],
    [
      "boite",
      0.055
    ],
    [
      "atelier",
      0.055
    ],
    [
      "raffinerie",
      0.025
    ],
    [
      "papeterie",
      0.025
    ],
    [
      "minoterie",
      0.025
    ],
    [
      "forge",
      0.025
    ],
    [
      "filature",
      0.025
    ],
    [
      "distillerie",
      0.025
    ],
    [
      "cimenterie",
      0.025
    ],
    [
      "chaine",
      0.025
    ],
    [
      "acierie",
      0.025
    ],
    [
      "trefilerie",
      0.025
    ]
  ],
  "usiner": [
    [
      "aleser",
      0.25
    ],
    [
      "fabriquer",
      0.25
    ],
    [
      "faire",
      0.25
    ],
    [
      "faconner",
      0.25
    ]
  ],
  "foutoir": [
    [
      "bordel",
      0.25
    ],
    [
      "bazar",
      0.2
    ],
    [
      "desordre",
      0.2
    ],
    [
      "bastringue",
      0.1
    ],
    [
      "chaos",
      0.1
    ],
    [
      "bataclan",
      0.05
    ],
    [
      "confusion",
      0.05
    ]
  ],
  "depute": [
    [
      "deleguer",
      0.285
    ],
    [
      "depecher",
      0.285
    ],
    [
      "detacher",
      0.1425
    ],
    [
      "envoyer",
      0.1425
    ],
    [
      "mandater",
      0.1425
    ]
  ],
  "europeen": [
    [
      "paneuropeen",
      1.0
    ]
  ],
  "siecle": [
    [
      "temps",
      0.205
    ],
    [
      "epoque",
      0.16
    ],
    [
      "periode",
      0.135
    ],
    [
      "age",
      0.0675
    ],
    [
      "ere",
      0.0675
    ],
    [
      "etendue",
      0.0425
    ],
    [
      "saison",
      0.0425
    ],
    [
      "moment",
      0.0425
    ],
    [
      "duree",
      0.0425
    ],
    [
      "etape",
      0.02
    ],
    [
      "monde",
      0.02
    ],
    [
      "lustre",
      0.02
    ],
    [
      "jours",
      0.02
    ],
    [
      "hegire",
      0.02
    ],
    [
      "cycle",
      0.02
    ],
    [
      "ans",
      0.02
    ],
    [
      "eternite",
      0.02
    ]
  ],
  "ksar": [],
  "lendemain": [
    [
      "suite",
      0.23
    ],
    [
      "futur",
      0.1525
    ],
    [
      "prolongement",
      0.1525
    ],
    [
      "repercussion",
      0.1525
    ],
    [
      "avenir",
      0.075
    ],
    [
      "consequence",
      0.075
    ],
    [
      "incidence",
      0.075
    ]
  ],
  "quai": [
    [
      "embarcadere",
      0.16
    ],
    [
      "port",
      0.16
    ],
    [
      "wharf",
      0.08
    ],
    [
      "trottoir",
      0.08
    ],
    [
      "debarcadere",
      0.08
    ],
    [
      "dock",
      0.08
    ],
    [
      "appontement",
      0.08
    ],
    [
      "rive",
      0.04
    ],
    [
      "mole",
      0.04
    ],
    [
      "levee",
      0.04
    ],
    [
      "depot",
      0.04
    ],
    [
      "cale",
      0.04
    ],
    [
      "rue",
      0.04
    ]
  ],
  "train": [
    [
      "marche",
      0.0825
    ],
    [
      "cours",
      0.0625
    ],
    [
      "allure",
      0.05
    ],
    [
      "mouvement",
      0.05
    ],
    [
      "equipage",
      0.05
    ],
    [
      "tournure",
      0.04
    ],
    [
      "suite",
      0.04
    ],
    [
      "voiture",
      0.03
    ],
    [
      "transport",
      0.03
    ],
    [
      "developpement",
      0.03
    ],
    [
      "convoi",
      0.03
    ],
    [
      "charroi",
      0.03
    ],
    [
      "voie",
      0.02
    ],
    [
      "file",
      0.02
    ],
    [
      "fessier",
      0.02
    ],
    [
      "erre",
      0.02
    ],
    [
      "deroulement",
      0.02
    ],
    [
      "ballot",
      0.02
    ],
    [
      "bagage",
      0.02
    ],
    [
      "routine",
      0.0075
    ],
    [
      "rapide",
      0.0075
    ],
    [
      "rame",
      0.0075
    ],
    [
      "rail",
      0.0075
    ],
    [
      "popotin",
      0.0075
    ],
    [
      "tapage",
      0.0075
    ],
    [
      "tintamarre",
      0.0075
    ],
    [
      "tortillard",
      0.0075
    ],
    [
      "tumulte",
      0.0075
    ],
    [
      "vacarme",
      0.0075
    ],
    [
      "vitesse",
      0.0075
    ],
    [
      "pas",
      0.0075
    ],
    [
      "locomotive",
      0.0075
    ],
    [
      "arroi",
      0.0075
    ],
    [
      "aspect",
      0.0075
    ],
    [
      "attirail",
      0.0075
    ],
    [
      "batterie",
      0.0075
    ],
    [
      "chahut",
      0.0075
    ],
    [
      "chassis",
      0.0075
    ],
    [
      "courant",
      0.0075
    ],
    [
      "cul",
      0.0075
    ],
    [
      "domestique",
      0.0075
    ],
    [
      "enchainement",
      0.0075
    ],
    [
      "fourgon",
      0.0075
    ],
    [
      "S.N.C.F.",
      0.0075
    ]
  ],
  "bonnet": [
    [
      "coiffure",
      0.2
    ],
    [
      "coiffe",
      0.0825
    ],
    [
      "barbon",
      0.055
    ],
    [
      "beret",
      0.04
    ],
    [
      "calotte",
      0.04
    ],
    [
      "chapeau",
      0.025
    ],
    [
      "mortier",
      0.0125
    ],
    [
      "mitre",
      0.0125
    ],
    [
      "fez",
      0.0125
    ],
    [
      "faluche",
      0.0125
    ],
    [
      "estomac",
      0.0125
    ],
    [
      "emmerdeur",
      0.0125
    ],
    [
      "coqueluche",
      0.0125
    ],
    [
      "ourson",
      0.0125
    ],
    [
      "tetiere",
      0.0125
    ],
    [
      "toquet",
      0.0125
    ],
    [
      "toque",
      0.0125
    ],
    [
      "colinette",
      0.0125
    ],
    [
      "colback",
      0.0125
    ],
    [
      "bonnette",
      0.0125
    ],
    [
      "bonnetade",
      0.0125
    ],
    [
      "bonichon",
      0.0125
    ],
    [
      "bob",
      0.0125
    ],
    [
      "bavolet",
      0.0125
    ],
    [
      "barrette",
      0.0125
    ],
    [
      "baigneuse",
      0.0125
    ],
    [
      "baderne",
      0.0125
    ],
    [
      "bourrichon",
      0.0125
    ],
    [
      "beguin",
      0.0125
    ],
    [
      "chremeau",
      0.0125
    ],
    [
      "charlotte",
      0.0125
    ],
    [
      "chamka",
      0.0125
    ],
    [
      "capeline",
      0.0125
    ],
    [
      "calot",
      0.0125
    ],
    [
      "cale",
      0.0125
    ],
    [
      "cabochon",
      0.0125
    ],
    [
      "attifet",
      0.0125
    ]
  ],
  "nuage": [
    [
      "brume",
      0.085
    ],
    [
      "mesintelligence",
      0.0675
    ],
    [
      "nuee",
      0.0675
    ],
    [
      "tension",
      0.0675
    ],
    [
      "vapeur",
      0.0675
    ],
    [
      "trouble",
      0.05
    ],
    [
      "orage",
      0.05
    ],
    [
      "nebulosite",
      0.05
    ],
    [
      "melancolie",
      0.05
    ],
    [
      "brouillard",
      0.05
    ],
    [
      "temps",
      0.0325
    ],
    [
      "rupture",
      0.0325
    ],
    [
      "fumee",
      0.0325
    ],
    [
      "brouille",
      0.0325
    ],
    [
      "tristesse",
      0.015
    ],
    [
      "stratus",
      0.015
    ],
    [
      "soupcon",
      0.015
    ],
    [
      "quantite",
      0.015
    ],
    [
      "peril",
      0.015
    ],
    [
      "peu",
      0.015
    ],
    [
      "obscurite",
      0.015
    ],
    [
      "nebuleuse",
      0.015
    ],
    [
      "nue",
      0.015
    ],
    [
      "nimbus",
      0.015
    ],
    [
      "ennui",
      0.015
    ],
    [
      "cumulus",
      0.015
    ],
    [
      "cirrus",
      0.015
    ],
    [
      "voile",
      0.015
    ]
  ],
  "survenir": [
    [
      "arriver",
      0.1475
    ],
    [
      "surgir",
      0.0975
    ],
    [
      "tomber",
      0.0975
    ],
    [
      "venir",
      0.06
    ],
    [
      "apparaitre",
      0.06
    ],
    [
      "advenir",
      0.06
    ],
    [
      "echoir",
      0.0225
    ],
    [
      "s'elever",
      0.0225
    ],
    [
      "naitre",
      0.0225
    ],
    [
      "intervenir",
      0.0225
    ],
    [
      "accourir",
      0.0225
    ],
    [
      "affluer",
      0.01
    ],
    [
      "voir",
      0.01
    ]
  ],
  "malin": [
    [
      "fute",
      0.11
    ],
    [
      "roublard",
      0.0875
    ],
    [
      "ruse",
      0.0675
    ],
    [
      "habile",
      0.0475
    ],
    [
      "astucieux",
      0.0425
    ],
    [
      "retors",
      0.035
    ],
    [
      "roue",
      0.03
    ],
    [
      "narquois",
      0.03
    ],
    [
      "malicieux",
      0.03
    ],
    [
      "adroit",
      0.025
    ],
    [
      "debrouillard",
      0.025
    ],
    [
      "fin",
      0.025
    ],
    [
      "tortueux",
      0.0225
    ],
    [
      "eveille",
      0.0225
    ],
    [
      "mauvais",
      0.02
    ],
    [
      "espiegle",
      0.02
    ],
    [
      "degourdi",
      0.02
    ],
    [
      "finaud",
      0.0175
    ],
    [
      "intelligent",
      0.0175
    ],
    [
      "madre",
      0.0175
    ],
    [
      "matois",
      0.0175
    ],
    [
      "subtil",
      0.0175
    ],
    [
      "perspicace",
      0.0125
    ],
    [
      "mechant",
      0.0125
    ],
    [
      "ingenieux",
      0.0125
    ],
    [
      "fripon",
      0.0125
    ],
    [
      "delure",
      0.0125
    ],
    [
      "spirituel",
      0.01
    ],
    [
      "farceur",
      0.01
    ],
    [
      "diable",
      0.01
    ],
    [
      "combinard",
      0.01
    ],
    [
      "trompeur",
      0.0075
    ],
    [
      "sournois",
      0.0075
    ],
    [
      "renard",
      0.0075
    ],
    [
      "capable",
      0.0075
    ],
    [
      "satirique",
      0.0025
    ],
    [
      "railleur",
      0.0025
    ],
    [
      "pervers",
      0.0025
    ],
    [
      "pernicieux",
      0.0025
    ],
    [
      "hableur",
      0.0025
    ],
    [
      "ficelle",
      0.0025
    ],
    [
      "entendu",
      0.0025
    ],
    [
      "demon",
      0.0025
    ],
    [
      "demerdard",
      0.0025
    ],
    [
      "mutin",
      0.0
    ],
    [
      "nocif",
      0.0
    ],
    [
      "normand",
      0.0
    ],
    [
      "vicelard",
      0.0
    ],
    [
      "marle",
      0.0
    ],
    [
      "mariol",
      0.0
    ],
    [
      "malefique",
      0.0
    ],
    [
      "malveillant",
      0.0
    ],
    [
      "ferin",
      0.0
    ],
    [
      "fort",
      0.0
    ],
    [
      "faraud",
      0.0
    ],
    [
      "craneur",
      0.0
    ],
    [
      "zigoto",
      0.0
    ]
  ],
  "predire": [
    [
      "augurer",
      0.15
    ],
    [
      "pronostiquer",
      0.12
    ],
    [
      "prophetiser",
      0.12
    ],
    [
      "presager",
      0.12
    ],
    [
      "prevoir",
      0.09
    ],
    [
      "promettre",
      0.06
    ],
    [
      "deviner",
      0.06
    ],
    [
      "conjecturer",
      0.06
    ],
    [
      "annoncer",
      0.06
    ],
    [
      "devoiler",
      0.03
    ],
    [
      "vaticiner",
      0.03
    ]
  ],
  "predit": [
    [
      "augurer",
      0.15
    ],
    [
      "pronostiquer",
      0.12
    ],
    [
      "prophetiser",
      0.12
    ],
    [
      "presager",
      0.12
    ],
    [
      "prevoir",
      0.09
    ],
    [
      "promettre",
      0.06
    ],
    [
      "deviner",
      0.06
    ],
    [
      "conjecturer",
      0.06
    ],
    [
      "annoncer",
      0.06
    ],
    [
      "devoiler",
      0.03
    ],
    [
      "vaticiner",
      0.03
    ]
  ],
  "parapluie": [
    [
      "abri",
      0.1525
    ],
    [
      "parasol",
      0.1525
    ],
    [
      "pepin",
      0.1525
    ],
    [
      "riflard",
      0.075
    ],
    [
      "pebroc",
      0.075
    ],
    [
      "protection",
      0.075
    ],
    [
      "couverture",
      0.075
    ]
  ],
  "joyeux": [
    [
      "gai",
      0.14
    ],
    [
      "rejoui",
      0.11
    ],
    [
      "content",
      0.07
    ],
    [
      "rieur",
      0.07
    ],
    [
      "enjoue",
      0.055
    ],
    [
      "epanoui",
      0.055
    ],
    [
      "heureux",
      0.045
    ],
    [
      "radieux",
      0.0375
    ],
    [
      "plaisant",
      0.0375
    ],
    [
      "folatre",
      0.0375
    ],
    [
      "agreable",
      0.03
    ],
    [
      "ravi",
      0.03
    ],
    [
      "riant",
      0.03
    ],
    [
      "jovial",
      0.0225
    ],
    [
      "hilare",
      0.0225
    ],
    [
      "guilleret",
      0.0225
    ],
    [
      "gaillard",
      0.0225
    ],
    [
      "charmant",
      0.0225
    ],
    [
      "amusant",
      0.0225
    ],
    [
      "allegre",
      0.015
    ],
    [
      "bon",
      0.015
    ],
    [
      "euphorique",
      0.015
    ],
    [
      "jouette",
      0.005
    ],
    [
      "grisant",
      0.005
    ],
    [
      "fou",
      0.005
    ],
    [
      "bataillonnaire",
      0.005
    ],
    [
      "joueur",
      0.005
    ]
  ],
  "chuchoter": [
    [
      "murmurer",
      0.3175
    ],
    [
      "susurrer",
      0.135
    ],
    [
      "bruire",
      0.09
    ],
    [
      "souffler",
      0.09
    ],
    [
      "marmotter",
      0.045
    ],
    [
      "gazouiller",
      0.045
    ],
    [
      "fremir",
      0.045
    ],
    [
      "dire",
      0.045
    ],
    [
      "converser",
      0.045
    ],
    [
      "prononcer",
      0.045
    ]
  ],
  "chuchotant": [
    [
      "murmurer",
      0.3175
    ],
    [
      "susurrer",
      0.135
    ],
    [
      "bruire",
      0.09
    ],
    [
      "souffler",
      0.09
    ],
    [
      "marmotter",
      0.045
    ],
    [
      "gazouiller",
      0.045
    ],
    [
      "fremir",
      0.045
    ],
    [
      "dire",
      0.045
    ],
    [
      "converser",
      0.045
    ],
    [
      "prononcer",
      0.045
    ]
  ],
  "begayant": [
    [
      "bredouillant",
      0.5
    ],
    [
      "bafouillant",
      0.25
    ],
    [
      "balbutiant",
      0.25
    ]
  ],
  "marmonner": [
    [
      "bredouiller",
      0.1375
    ],
    [
      "marmotter",
      0.1375
    ],
    [
      "murmurer",
      0.1375
    ],
    [
      "balbutier",
      0.0825
    ],
    [
      "ronchonner",
      0.0825
    ],
    [
      "macher",
      0.055
    ],
    [
      "grommeler",
      0.055
    ],
    [
      "bougonner",
      0.055
    ],
    [
      "baragouiner",
      0.055
    ],
    [
      "bafouiller",
      0.055
    ],
    [
      "barboter",
      0.0275
    ],
    [
      "maugreer",
      0.0275
    ],
    [
      "machonner",
      0.0275
    ],
    [
      "protester",
      0.0275
    ],
    [
      "rognonner",
      0.0275
    ]
  ],
  "murmurer": [
    [
      "ronchonner",
      0.1125
    ],
    [
      "grogner",
      0.06
    ],
    [
      "bougonner",
      0.05
    ],
    [
      "rouspeter",
      0.05
    ],
    [
      "grommeler",
      0.045
    ],
    [
      "maugreer",
      0.045
    ],
    [
      "raler",
      0.04
    ],
    [
      "gronder",
      0.04
    ],
    [
      "chuchoter",
      0.035
    ],
    [
      "marmotter",
      0.03
    ],
    [
      "protester",
      0.03
    ],
    [
      "rognonner",
      0.025
    ],
    [
      "marmonner",
      0.025
    ],
    [
      "balbutier",
      0.02
    ],
    [
      "bourdonner",
      0.02
    ],
    [
      "bruire",
      0.02
    ],
    [
      "chanter",
      0.02
    ],
    [
      "maronner",
      0.015
    ],
    [
      "rogner",
      0.015
    ],
    [
      "souffler",
      0.015
    ],
    [
      "susurrer",
      0.015
    ],
    [
      "gemir",
      0.015
    ],
    [
      "geindre",
      0.015
    ],
    [
      "gazouiller",
      0.015
    ],
    [
      "fredonner",
      0.015
    ],
    [
      "dire",
      0.015
    ],
    [
      "bredouiller",
      0.015
    ],
    [
      "rouscailler",
      0.01
    ],
    [
      "prononcer",
      0.01
    ],
    [
      "gringotter",
      0.01
    ],
    [
      "fremir",
      0.01
    ],
    [
      "baragouiner",
      0.01
    ],
    [
      "bafouiller",
      0.01
    ],
    [
      "babiller",
      0.01
    ],
    [
      "ronfler",
      0.005
    ],
    [
      "renauder",
      0.005
    ],
    [
      "rechigner",
      0.005
    ],
    [
      "ragonner",
      0.005
    ],
    [
      "groumer",
      0.005
    ],
    [
      "grognonner",
      0.005
    ],
    [
      "grognasser",
      0.005
    ],
    [
      "couler",
      0.005
    ],
    [
      "broncher",
      0.005
    ]
  ],
  "murmurant": [
    [
      "ronchonner",
      0.1125
    ],
    [
      "grogner",
      0.06
    ],
    [
      "bougonner",
      0.05
    ],
    [
      "rouspeter",
      0.05
    ],
    [
      "grommeler",
      0.045
    ],
    [
      "maugreer",
      0.045
    ],
    [
      "raler",
      0.04
    ],
    [
      "gronder",
      0.04
    ],
    [
      "chuchoter",
      0.035
    ],
    [
      "marmotter",
      0.03
    ],
    [
      "protester",
      0.03
    ],
    [
      "rognonner",
      0.025
    ],
    [
      "marmonner",
      0.025
    ],
    [
      "balbutier",
      0.02
    ],
    [
      "bourdonner",
      0.02
    ],
    [
      "bruire",
      0.02
    ],
    [
      "chanter",
      0.02
    ],
    [
      "maronner",
      0.015
    ],
    [
      "rogner",
      0.015
    ],
    [
      "souffler",
      0.015
    ],
    [
      "susurrer",
      0.015
    ],
    [
      "gemir",
      0.015
    ],
    [
      "geindre",
      0.015
    ],
    [
      "gazouiller",
      0.015
    ],
    [
      "fredonner",
      0.015
    ],
    [
      "dire",
      0.015
    ],
    [
      "bredouiller",
      0.015
    ],
    [
      "rouscailler",
      0.01
    ],
    [
      "prononcer",
      0.01
    ],
    [
      "gringotter",
      0.01
    ],
    [
      "fremir",
      0.01
    ],
    [
      "baragouiner",
      0.01
    ],
    [
      "bafouiller",
      0.01
    ],
    [
      "babiller",
      0.01
    ],
    [
      "ronfler",
      0.005
    ],
    [
      "renauder",
      0.005
    ],
    [
      "rechigner",
      0.005
    ],
    [
      "ragonner",
      0.005
    ],
    [
      "groumer",
      0.005
    ],
    [
      "grognonner",
      0.005
    ],
    [
      "grognasser",
      0.005
    ],
    [
      "couler",
      0.005
    ],
    [
      "broncher",
      0.005
    ]
  ],
  "associer": [
    [
      "reunir",
      0.14
    ],
    [
      "unir",
      0.11
    ],
    [
      "joindre",
      0.0775
    ],
    [
      "assembler",
      0.0725
    ],
    [
      "combiner",
      0.06
    ],
    [
      "allier",
      0.0525
    ],
    [
      "lier",
      0.0425
    ],
    [
      "fusionner",
      0.03
    ],
    [
      "melanger",
      0.025
    ],
    [
      "rassembler",
      0.02
    ],
    [
      "rapprocher",
      0.02
    ],
    [
      "incorporer",
      0.02
    ],
    [
      "attacher",
      0.02
    ],
    [
      "adjoindre",
      0.02
    ],
    [
      "accorder",
      0.02
    ],
    [
      "federer",
      0.0175
    ],
    [
      "relier",
      0.015
    ],
    [
      "marier",
      0.015
    ],
    [
      "grouper",
      0.015
    ],
    [
      "amalgamer",
      0.015
    ],
    [
      "agencer",
      0.015
    ],
    [
      "adapter",
      0.015
    ],
    [
      "meler",
      0.0125
    ],
    [
      "juxtaposer",
      0.0125
    ],
    [
      "agreger",
      0.0125
    ],
    [
      "affilier",
      0.01
    ],
    [
      "coaliser",
      0.01
    ],
    [
      "integrer",
      0.01
    ],
    [
      "assortir",
      0.0075
    ],
    [
      "enchainer",
      0.0075
    ],
    [
      "liguer",
      0.0075
    ],
    [
      "s'adjoindre",
      0.005
    ],
    [
      "concentrer",
      0.005
    ],
    [
      "composer",
      0.005
    ],
    [
      "syndiquer",
      0.0025
    ],
    [
      "suspendre",
      0.0025
    ],
    [
      "solidariser",
      0.0025
    ],
    [
      "s'unir",
      0.0025
    ],
    [
      "s'attacher",
      0.0025
    ],
    [
      "partager",
      0.0025
    ],
    [
      "interesser",
      0.0025
    ],
    [
      "initier",
      0.0025
    ],
    [
      "enroler",
      0.0025
    ],
    [
      "embrancher",
      0.0025
    ],
    [
      "confederer",
      0.0025
    ],
    [
      "confondre",
      0.0025
    ],
    [
      "evoquer",
      0.0025
    ]
  ],
  "quel": [
    [
      "qui",
      0.5
    ],
    [
      "quoi",
      0.5
    ]
  ],
  "humiliant": [
    [
      "avilissant",
      0.18
    ],
    [
      "degradant",
      0.18
    ],
    [
      "abaissant",
      0.09
    ],
    [
      "amer",
      0.09
    ],
    [
      "mortifiant",
      0.09
    ],
    [
      "outrageant",
      0.09
    ],
    [
      "rabaissant",
      0.09
    ],
    [
      "vexant",
      0.09
    ],
    [
      "ecrasant",
      0.09
    ]
  ],
  "humilier": [
    [
      "abaisser",
      0.1225
    ],
    [
      "rabaisser",
      0.105
    ],
    [
      "aplatir",
      0.075
    ],
    [
      "ecraser",
      0.075
    ],
    [
      "accabler",
      0.06
    ],
    [
      "souffleter",
      0.045
    ],
    [
      "opprimer",
      0.045
    ],
    [
      "offenser",
      0.045
    ],
    [
      "moucher",
      0.045
    ],
    [
      "mortifier",
      0.045
    ],
    [
      "mater",
      0.045
    ],
    [
      "diminuer",
      0.045
    ],
    [
      "vexer",
      0.03
    ],
    [
      "rabattre",
      0.03
    ],
    [
      "gifler",
      0.03
    ],
    [
      "courber",
      0.03
    ],
    [
      "macerer",
      0.0125
    ],
    [
      "insulter",
      0.0125
    ],
    [
      "degrader",
      0.0125
    ],
    [
      "doucher",
      0.0125
    ],
    [
      "confondre",
      0.0125
    ],
    [
      "bafouer",
      0.0125
    ],
    [
      "avilir",
      0.0125
    ],
    [
      "ravaler",
      0.0125
    ]
  ],
  "intuition": [
    [
      "sentiment",
      0.1775
    ],
    [
      "conscience",
      0.08
    ],
    [
      "instinct",
      0.08
    ],
    [
      "pressentiment",
      0.08
    ],
    [
      "prescience",
      0.0625
    ],
    [
      "sens",
      0.0625
    ],
    [
      "premonition",
      0.0475
    ],
    [
      "inspiration",
      0.0475
    ],
    [
      "divination",
      0.0475
    ],
    [
      "coeur",
      0.0475
    ],
    [
      "tact",
      0.03
    ],
    [
      "notion",
      0.03
    ],
    [
      "flair",
      0.03
    ],
    [
      "finesse",
      0.03
    ],
    [
      "connaissance",
      0.03
    ],
    [
      "aperception",
      0.015
    ],
    [
      "instigation",
      0.015
    ],
    [
      "psychologie",
      0.015
    ],
    [
      "sensation",
      0.015
    ],
    [
      "vision",
      0.015
    ],
    [
      "ame",
      0.015
    ]
  ],
  "maladroitement": [
    [
      "gauchement",
      0.23
    ],
    [
      "lourdement",
      0.23
    ],
    [
      "mal",
      0.1525
    ],
    [
      "betement",
      0.075
    ],
    [
      "grossierement",
      0.075
    ],
    [
      "malhabilement",
      0.075
    ],
    [
      "pauvrement",
      0.075
    ],
    [
      "pesamment",
      0.075
    ]
  ],
  "prophetie": [
    [
      "prediction",
      0.1525
    ],
    [
      "divination",
      0.115
    ],
    [
      "oracle",
      0.115
    ],
    [
      "pronostic",
      0.115
    ],
    [
      "prevision",
      0.075
    ],
    [
      "presage",
      0.075
    ],
    [
      "conjecture",
      0.075
    ],
    [
      "ecriture",
      0.0375
    ],
    [
      "verite",
      0.0375
    ],
    [
      "vaticination",
      0.0375
    ],
    [
      "inspiration",
      0.0375
    ],
    [
      "anticipation",
      0.0375
    ],
    [
      "annonce",
      0.0375
    ],
    [
      "evenement",
      0.0375
    ]
  ],
  "mystere": [
    [
      "secret",
      0.1975
    ],
    [
      "esoterisme",
      0.0375
    ],
    [
      "enigme",
      0.0375
    ],
    [
      "tenebres",
      0.0375
    ],
    [
      "ombre",
      0.0375
    ],
    [
      "obscurite",
      0.0375
    ],
    [
      "magie",
      0.0375
    ],
    [
      "dissimulation",
      0.0375
    ],
    [
      "discretion",
      0.0375
    ],
    [
      "cabale",
      0.0375
    ],
    [
      "symbole",
      0.025
    ],
    [
      "silence",
      0.025
    ],
    [
      "reticence",
      0.025
    ],
    [
      "prudence",
      0.025
    ],
    [
      "profondeur",
      0.025
    ],
    [
      "incertitude",
      0.025
    ],
    [
      "detour",
      0.025
    ],
    [
      "cachotterie",
      0.025
    ],
    [
      "liturgie",
      0.0125
    ],
    [
      "miracle",
      0.0125
    ],
    [
      "rebus",
      0.0125
    ],
    [
      "revelation",
      0.0125
    ],
    [
      "surnaturel",
      0.0125
    ],
    [
      "theatre",
      0.0125
    ],
    [
      "voile",
      0.0125
    ],
    [
      "verite",
      0.0125
    ],
    [
      "inconnu",
      0.0125
    ],
    [
      "glace",
      0.0125
    ],
    [
      "allegorie",
      0.0125
    ],
    [
      "arcane",
      0.0125
    ],
    [
      "cachette",
      0.0125
    ],
    [
      "clandestinite",
      0.0125
    ],
    [
      "coulisse",
      0.0125
    ],
    [
      "culte",
      0.0125
    ],
    [
      "diablerie",
      0.0125
    ],
    [
      "ame",
      0.0125
    ]
  ],
  "frisson": [
    [
      "fremissement",
      0.105
    ],
    [
      "bruissement",
      0.0575
    ],
    [
      "tremblement",
      0.0575
    ],
    [
      "murmure",
      0.0475
    ],
    [
      "remous",
      0.0475
    ],
    [
      "secousse",
      0.0475
    ],
    [
      "soubresaut",
      0.0475
    ],
    [
      "emotion",
      0.0375
    ],
    [
      "vibration",
      0.0375
    ],
    [
      "tressaillement",
      0.0375
    ],
    [
      "convulsion",
      0.0375
    ],
    [
      "battement",
      0.0275
    ],
    [
      "friselis",
      0.0275
    ],
    [
      "saisissement",
      0.0275
    ],
    [
      "spasme",
      0.0175
    ],
    [
      "sursaut",
      0.0175
    ],
    [
      "susurrement",
      0.0175
    ],
    [
      "vertige",
      0.0175
    ],
    [
      "peur",
      0.0175
    ],
    [
      "palpitation",
      0.0175
    ],
    [
      "ondulation",
      0.0175
    ],
    [
      "onde",
      0.0175
    ],
    [
      "froissement",
      0.0175
    ],
    [
      "frissonnement",
      0.0175
    ],
    [
      "chuchotis",
      0.0175
    ],
    [
      "seisme",
      0.0075
    ],
    [
      "souffle",
      0.0075
    ],
    [
      "ondoiement",
      0.0075
    ],
    [
      "horripilation",
      0.0075
    ],
    [
      "grelottement",
      0.0075
    ],
    [
      "frousse",
      0.0075
    ],
    [
      "fievre",
      0.0075
    ],
    [
      "crispation",
      0.0075
    ],
    [
      "emoi",
      0.0075
    ]
  ],
  "lors": [
    [
      "alors",
      0.5
    ],
    [
      "dans",
      0.5
    ]
  ],
  "destinee": [
    [
      "vouer",
      0.1175
    ],
    [
      "affecter",
      0.095
    ],
    [
      "appliquer",
      0.095
    ],
    [
      "reserver",
      0.095
    ],
    [
      "predestiner",
      0.07
    ],
    [
      "consacrer",
      0.07
    ],
    [
      "attribuer",
      0.07
    ],
    [
      "assigner",
      0.07
    ],
    [
      "preparer",
      0.045
    ],
    [
      "promettre",
      0.045
    ],
    [
      "designer",
      0.045
    ],
    [
      "appeler",
      0.045
    ],
    [
      "adresser",
      0.0225
    ],
    [
      "decider",
      0.0225
    ],
    [
      "employer",
      0.0225
    ],
    [
      "garder",
      0.0225
    ],
    [
      "orienter",
      0.0225
    ]
  ],
  "destiner": [
    [
      "vouer",
      0.1175
    ],
    [
      "affecter",
      0.095
    ],
    [
      "appliquer",
      0.095
    ],
    [
      "reserver",
      0.095
    ],
    [
      "predestiner",
      0.07
    ],
    [
      "consacrer",
      0.07
    ],
    [
      "attribuer",
      0.07
    ],
    [
      "assigner",
      0.07
    ],
    [
      "preparer",
      0.045
    ],
    [
      "promettre",
      0.045
    ],
    [
      "designer",
      0.045
    ],
    [
      "appeler",
      0.045
    ],
    [
      "adresser",
      0.0225
    ],
    [
      "decider",
      0.0225
    ],
    [
      "employer",
      0.0225
    ],
    [
      "garder",
      0.0225
    ],
    [
      "orienter",
      0.0225
    ]
  ],
  "destine": [
    [
      "vouer",
      0.1175
    ],
    [
      "affecter",
      0.095
    ],
    [
      "appliquer",
      0.095
    ],
    [
      "reserver",
      0.095
    ],
    [
      "predestiner",
      0.07
    ],
    [
      "consacrer",
      0.07
    ],
    [
      "attribuer",
      0.07
    ],
    [
      "assigner",
      0.07
    ],
    [
      "preparer",
      0.045
    ],
    [
      "promettre",
      0.045
    ],
    [
      "designer",
      0.045
    ],
    [
      "appeler",
      0.045
    ],
    [
      "adresser",
      0.0225
    ],
    [
      "decider",
      0.0225
    ],
    [
      "employer",
      0.0225
    ],
    [
      "garder",
      0.0225
    ],
    [
      "orienter",
      0.0225
    ]
  ],
  "marier": [
    [
      "reunir",
      0.12
    ],
    [
      "unir",
      0.12
    ],
    [
      "joindre",
      0.1
    ],
    [
      "assembler",
      0.07
    ],
    [
      "fusionner",
      0.06
    ],
    [
      "combiner",
      0.06
    ],
    [
      "assortir",
      0.06
    ],
    [
      "associer",
      0.06
    ],
    [
      "allier",
      0.06
    ],
    [
      "appareiller",
      0.04
    ],
    [
      "apparier",
      0.04
    ],
    [
      "melanger",
      0.04
    ],
    [
      "lier",
      0.0275
    ],
    [
      "accompagner",
      0.0175
    ],
    [
      "meler",
      0.0175
    ],
    [
      "epouser",
      0.0075
    ],
    [
      "juxtaposer",
      0.0075
    ],
    [
      "harmoniser",
      0.0075
    ],
    [
      "entrelacer",
      0.0075
    ],
    [
      "engager",
      0.0075
    ],
    [
      "enchainer",
      0.0075
    ],
    [
      "amadouer",
      0.0075
    ],
    [
      "etablir",
      0.0075
    ]
  ],
  "propos": [
    [
      "betise",
      0.04
    ],
    [
      "bavardage",
      0.035
    ],
    [
      "potin",
      0.0275
    ],
    [
      "intention",
      0.0275
    ],
    [
      "discours",
      0.0275
    ],
    [
      "dessein",
      0.0275
    ],
    [
      "commerage",
      0.0275
    ],
    [
      "cancan",
      0.0275
    ],
    [
      "boniment",
      0.0275
    ],
    [
      "parole",
      0.025
    ],
    [
      "bagatelle",
      0.025
    ],
    [
      "resolution",
      0.02
    ],
    [
      "medisance",
      0.02
    ],
    [
      "histoire",
      0.02
    ],
    [
      "fadaise",
      0.02
    ],
    [
      "chanson",
      0.02
    ],
    [
      "bruit",
      0.02
    ],
    [
      "sottise",
      0.0175
    ],
    [
      "polissonnerie",
      0.0175
    ],
    [
      "grivoiserie",
      0.0175
    ],
    [
      "conversation",
      0.0175
    ],
    [
      "but",
      0.0175
    ],
    [
      "baliverne",
      0.0175
    ],
    [
      "badinage",
      0.0175
    ],
    [
      "allegation",
      0.0175
    ],
    [
      "sujet",
      0.0125
    ],
    [
      "gaudriole",
      0.0125
    ],
    [
      "blague",
      0.0125
    ],
    [
      "obscenite",
      0.01
    ],
    [
      "pensee",
      0.01
    ],
    [
      "phrase",
      0.01
    ],
    [
      "ragot",
      0.01
    ],
    [
      "sentence",
      0.01
    ],
    [
      "volonte",
      0.01
    ],
    [
      "gauloiserie",
      0.01
    ],
    [
      "galanterie",
      0.01
    ],
    [
      "determination",
      0.01
    ],
    [
      "calomnie",
      0.01
    ],
    [
      "cochonnerie",
      0.01
    ],
    [
      "commentaire",
      0.01
    ],
    [
      "dire",
      0.01
    ],
    [
      "decision",
      0.01
    ],
    [
      "declaration",
      0.01
    ],
    [
      "papotage",
      0.005
    ],
    [
      "projet",
      0.005
    ],
    [
      "salete",
      0.005
    ],
    [
      "theme",
      0.005
    ],
    [
      "trait",
      0.005
    ],
    [
      "vilenie",
      0.005
    ],
    [
      "observation",
      0.005
    ],
    [
      "objet",
      0.005
    ],
    [
      "motif",
      0.005
    ],
    [
      "attribut",
      0.005
    ],
    [
      "badinerie",
      0.005
    ],
    [
      "baratin",
      0.005
    ],
    [
      "calembredaine",
      0.005
    ],
    [
      "desir",
      0.005
    ],
    [
      "faribole",
      0.005
    ],
    [
      "matiere",
      0.005
    ],
    [
      "insinuation",
      0.0025
    ],
    [
      "parti",
      0.0025
    ],
    [
      "sermon",
      0.0025
    ],
    [
      "turlutaine",
      0.0025
    ],
    [
      "vantardise",
      0.0025
    ],
    [
      "vanterie",
      0.0025
    ],
    [
      "insanite",
      0.0025
    ],
    [
      "gaillardise",
      0.0025
    ],
    [
      "entretien",
      0.0025
    ],
    [
      "enjolerie",
      0.0025
    ],
    [
      "cajolerie",
      0.0025
    ],
    [
      "boutade",
      0.0025
    ],
    [
      "blablabla",
      0.0025
    ],
    [
      "banalite",
      0.0025
    ],
    [
      "balourdise",
      0.0025
    ],
    [
      "verbe",
      0.0025
    ]
  ],
  "tabler": [
    [
      "compter",
      0.1675
    ],
    [
      "fonder",
      0.11
    ],
    [
      "s'appuyer",
      0.11
    ],
    [
      "esperer",
      0.055
    ],
    [
      "escompter",
      0.055
    ],
    [
      "caser",
      0.055
    ],
    [
      "baser",
      0.055
    ],
    [
      "speculer",
      0.055
    ]
  ],
  "table": [
    [
      "tableau",
      0.105
    ],
    [
      "repertoire",
      0.07
    ],
    [
      "catalogue",
      0.0525
    ],
    [
      "liste",
      0.0525
    ],
    [
      "tablette",
      0.035
    ],
    [
      "pupitre",
      0.035
    ],
    [
      "plaque",
      0.035
    ],
    [
      "cuisine",
      0.035
    ],
    [
      "chere",
      0.035
    ],
    [
      "bureau",
      0.035
    ],
    [
      "lame",
      0.0175
    ],
    [
      "menu",
      0.0175
    ],
    [
      "ordinaire",
      0.0175
    ],
    [
      "panneau",
      0.0175
    ],
    [
      "planche",
      0.0175
    ],
    [
      "plateau",
      0.0175
    ],
    [
      "servante",
      0.0175
    ],
    [
      "sommet",
      0.0175
    ],
    [
      "surface",
      0.0175
    ],
    [
      "tablier",
      0.0175
    ],
    [
      "tablee",
      0.0175
    ],
    [
      "enumeration",
      0.0175
    ],
    [
      "etabli",
      0.0175
    ],
    [
      "inventaire",
      0.0175
    ],
    [
      "index",
      0.0175
    ],
    [
      "abaque",
      0.0175
    ],
    [
      "autel",
      0.0175
    ],
    [
      "banc",
      0.0175
    ],
    [
      "bareme",
      0.0175
    ],
    [
      "bibliographie",
      0.0175
    ],
    [
      "buffet",
      0.0175
    ],
    [
      "calendrier",
      0.0175
    ],
    [
      "comptoir",
      0.0175
    ],
    [
      "console",
      0.0175
    ],
    [
      "credence",
      0.0175
    ],
    [
      "desserte",
      0.0175
    ],
    [
      "gastronomie",
      0.0175
    ],
    [
      "gueridon",
      0.0175
    ],
    [
      "etal",
      0.0175
    ]
  ],
  "parle": [
    [
      "bavarder",
      0.1
    ],
    [
      "dire",
      0.065
    ],
    [
      "causer",
      0.0525
    ],
    [
      "jaboter",
      0.0525
    ],
    [
      "debiter",
      0.0475
    ],
    [
      "palabrer",
      0.0475
    ],
    [
      "discourir",
      0.0425
    ],
    [
      "discuter",
      0.0375
    ],
    [
      "jaser",
      0.0275
    ],
    [
      "prononcer",
      0.0275
    ],
    [
      "raconter",
      0.0275
    ],
    [
      "s'entretenir",
      0.0175
    ],
    [
      "reveler",
      0.0175
    ],
    [
      "perorer",
      0.0175
    ],
    [
      "parlementer",
      0.0175
    ],
    [
      "degoiser",
      0.0175
    ],
    [
      "disserter",
      0.0175
    ],
    [
      "balbutier",
      0.0175
    ],
    [
      "avouer",
      0.0175
    ],
    [
      "enoncer",
      0.0125
    ],
    [
      "declamer",
      0.0125
    ],
    [
      "converser",
      0.0125
    ],
    [
      "conferer",
      0.0125
    ],
    [
      "babiller",
      0.0125
    ],
    [
      "toucher",
      0.0075
    ],
    [
      "s'epancher",
      0.0075
    ],
    [
      "s'abandonner",
      0.0075
    ],
    [
      "retracer",
      0.0075
    ],
    [
      "plaire",
      0.0075
    ],
    [
      "parloter",
      0.0075
    ],
    [
      "jaspiner",
      0.0075
    ],
    [
      "impressionner",
      0.0075
    ],
    [
      "fasciner",
      0.0075
    ],
    [
      "bafouiller",
      0.0075
    ],
    [
      "baragouiner",
      0.0075
    ],
    [
      "bredouiller",
      0.0075
    ],
    [
      "begayer",
      0.0075
    ],
    [
      "dialoguer",
      0.0075
    ],
    [
      "deblaterer",
      0.0075
    ],
    [
      "s'adresser",
      0.0025
    ],
    [
      "relater",
      0.0025
    ],
    [
      "radoter",
      0.0025
    ],
    [
      "rabacher",
      0.0025
    ],
    [
      "pratiquer",
      0.0025
    ],
    [
      "ordonner",
      0.0025
    ],
    [
      "s'expliquer",
      0.0025
    ],
    [
      "s'exprimer",
      0.0025
    ],
    [
      "soliloquer",
      0.0025
    ],
    [
      "ecorcher",
      0.0025
    ],
    [
      "nasiller",
      0.0025
    ],
    [
      "jargonner",
      0.0025
    ],
    [
      "accoucher",
      0.0025
    ],
    [
      "articuler",
      0.0025
    ],
    [
      "chevroter",
      0.0025
    ],
    [
      "communiquer",
      0.0025
    ],
    [
      "confabuler",
      0.0025
    ],
    [
      "consulter",
      0.0025
    ],
    [
      "deviser",
      0.0025
    ],
    [
      "debattre",
      0.0025
    ],
    [
      "entretenir",
      0.0025
    ],
    [
      "frapper",
      0.0025
    ],
    [
      "giberner",
      0.0025
    ],
    [
      "gueuler",
      0.0025
    ],
    [
      "haranguer",
      0.0025
    ],
    [
      "intervenir",
      0.0025
    ],
    [
      "jacter",
      0.0025
    ],
    [
      "emouvoir",
      0.0025
    ]
  ],
  "amant": [
    [
      "amoureux",
      0.135
    ],
    [
      "galant",
      0.08
    ],
    [
      "cheri",
      0.0525
    ],
    [
      "flirt",
      0.0525
    ],
    [
      "soupirant",
      0.04
    ],
    [
      "mec",
      0.04
    ],
    [
      "homme",
      0.04
    ],
    [
      "ami",
      0.04
    ],
    [
      "type",
      0.025
    ],
    [
      "pretendant",
      0.025
    ],
    [
      "favori",
      0.025
    ],
    [
      "copain",
      0.025
    ],
    [
      "bonhomme",
      0.025
    ],
    [
      "amateur",
      0.025
    ],
    [
      "maquereau",
      0.0125
    ],
    [
      "micheton",
      0.0125
    ],
    [
      "miche",
      0.0125
    ],
    [
      "minet",
      0.0125
    ],
    [
      "poete",
      0.0125
    ],
    [
      "rival",
      0.0125
    ],
    [
      "tourtereau",
      0.0125
    ],
    [
      "vieux",
      0.0125
    ],
    [
      "jules",
      0.0125
    ],
    [
      "guignol",
      0.0125
    ],
    [
      "greluchon",
      0.0125
    ],
    [
      "adorateur",
      0.0125
    ],
    [
      "berger",
      0.0125
    ],
    [
      "branque",
      0.0125
    ],
    [
      "branquignol",
      0.0125
    ],
    [
      "beguin",
      0.0125
    ],
    [
      "colin",
      0.0125
    ],
    [
      "celadon",
      0.0125
    ],
    [
      "gigolo",
      0.0125
    ],
    [
      "godelureau",
      0.0125
    ]
  ],
  "parking": [
    [
      "parcage",
      0.5
    ],
    [
      "garage",
      0.165
    ],
    [
      "parc",
      0.165
    ],
    [
      "stationnement",
      0.165
    ]
  ],
  "melancolie": [
    [
      "tristesse",
      0.16
    ],
    [
      "chagrin",
      0.075
    ],
    [
      "ennui",
      0.075
    ],
    [
      "spleen",
      0.0575
    ],
    [
      "cafard",
      0.05
    ],
    [
      "abattement",
      0.0475
    ],
    [
      "depression",
      0.0425
    ],
    [
      "neurasthenie",
      0.035
    ],
    [
      "peine",
      0.035
    ],
    [
      "nostalgie",
      0.0275
    ],
    [
      "amertume",
      0.0275
    ],
    [
      "accablement",
      0.0275
    ],
    [
      "morosite",
      0.0225
    ],
    [
      "bile",
      0.0175
    ],
    [
      "maussaderie",
      0.01
    ],
    [
      "nuage",
      0.01
    ],
    [
      "pessimisme",
      0.01
    ],
    [
      "regret",
      0.01
    ],
    [
      "sombreur",
      0.01
    ],
    [
      "hypocondrie",
      0.01
    ],
    [
      "desolation",
      0.01
    ],
    [
      "alienation",
      0.01
    ],
    [
      "atrabile",
      0.01
    ],
    [
      "brumaille",
      0.01
    ],
    [
      "consternation",
      0.01
    ],
    [
      "degout",
      0.01
    ],
    [
      "deprime",
      0.01
    ],
    [
      "trouble",
      0.005
    ],
    [
      "ombre",
      0.005
    ],
    [
      "noirceur",
      0.005
    ],
    [
      "mal",
      0.005
    ],
    [
      "lypemanie",
      0.005
    ],
    [
      "langueur",
      0.005
    ],
    [
      "grisaille",
      0.005
    ],
    [
      "brume",
      0.005
    ],
    [
      "bourdon",
      0.005
    ],
    [
      "reverie",
      0.0025
    ],
    [
      "psychose",
      0.0025
    ],
    [
      "navrance",
      0.0025
    ],
    [
      "hyperthymie",
      0.0025
    ],
    [
      "humeur",
      0.0025
    ],
    [
      "dereliction",
      0.0025
    ],
    [
      "asthenie",
      0.0025
    ],
    [
      "assombrissement",
      0.0025
    ],
    [
      "angoisse",
      0.0025
    ]
  ],
  "blues": [
    [
      "bourdon",
      0.165
    ],
    [
      "cafard",
      0.165
    ],
    [
      "chant",
      0.165
    ],
    [
      "danse",
      0.165
    ],
    [
      "slow",
      0.165
    ]
  ],
  "indelebile": [
    [
      "durable",
      0.1325
    ],
    [
      "immuable",
      0.1325
    ],
    [
      "inalterable",
      0.1
    ],
    [
      "perpetuel",
      0.1
    ],
    [
      "eternel",
      0.1
    ],
    [
      "tenace",
      0.065
    ],
    [
      "permanent",
      0.065
    ],
    [
      "ineffacable",
      0.065
    ],
    [
      "indestructible",
      0.065
    ],
    [
      "imperissable",
      0.065
    ],
    [
      "immortel",
      0.065
    ],
    [
      "persistant",
      0.0325
    ]
  ],
  "barreau": [
    [
      "barre",
      0.1675
    ],
    [
      "defense",
      0.1675
    ],
    [
      "traverse",
      0.0825
    ],
    [
      "roulon",
      0.0825
    ],
    [
      "parquet",
      0.0825
    ],
    [
      "montant",
      0.0825
    ],
    [
      "basoche",
      0.0825
    ],
    [
      "avocat",
      0.0825
    ],
    [
      "echelon",
      0.0825
    ]
  ],
  "remplir": [
    [
      "emplir",
      0.0725
    ],
    [
      "couvrir",
      0.0575
    ],
    [
      "truffer",
      0.0575
    ],
    [
      "combler",
      0.05
    ],
    [
      "faire",
      0.05
    ],
    [
      "bourrer",
      0.045
    ],
    [
      "inonder",
      0.045
    ],
    [
      "envahir",
      0.04
    ],
    [
      "garnir",
      0.035
    ],
    [
      "abreuver",
      0.025
    ],
    [
      "charger",
      0.025
    ],
    [
      "impregner",
      0.025
    ],
    [
      "occuper",
      0.025
    ],
    [
      "penetrer",
      0.025
    ],
    [
      "satisfaire",
      0.025
    ],
    [
      "tenir",
      0.02
    ],
    [
      "realiser",
      0.02
    ],
    [
      "passer",
      0.02
    ],
    [
      "gorger",
      0.02
    ],
    [
      "accomplir",
      0.02
    ],
    [
      "semer",
      0.015
    ],
    [
      "saturer",
      0.015
    ],
    [
      "executer",
      0.015
    ],
    [
      "encombrer",
      0.015
    ],
    [
      "bonder",
      0.015
    ],
    [
      "farcir",
      0.0075
    ],
    [
      "gonfler",
      0.0075
    ],
    [
      "observer",
      0.0075
    ],
    [
      "repondre",
      0.0075
    ],
    [
      "s'acquitter",
      0.0075
    ],
    [
      "exercer",
      0.0075
    ],
    [
      "enflammer",
      0.0075
    ],
    [
      "acquitter",
      0.0075
    ],
    [
      "approvisionner",
      0.0075
    ],
    [
      "assouvir",
      0.0075
    ],
    [
      "baigner",
      0.0075
    ],
    [
      "couronner",
      0.0075
    ],
    [
      "devorer",
      0.0075
    ],
    [
      "retentir",
      0.0025
    ],
    [
      "respecter",
      0.0025
    ],
    [
      "peupler",
      0.0025
    ],
    [
      "parfumer",
      0.0025
    ],
    [
      "meubler",
      0.0025
    ],
    [
      "inserer",
      0.0025
    ],
    [
      "fonctionner",
      0.0025
    ],
    [
      "enivrer",
      0.0025
    ],
    [
      "enfler",
      0.0025
    ],
    [
      "embourrer",
      0.0025
    ],
    [
      "embarquer",
      0.0025
    ],
    [
      "consteller",
      0.0025
    ],
    [
      "capitonner",
      0.0025
    ],
    [
      "verser",
      0.0025
    ]
  ],
  "poumon": [
    [
      "mou",
      0.5
    ],
    [
      "poitrine",
      0.5
    ]
  ],
  "pere": [
    [
      "Dieu",
      1.0
    ]
  ],
  "innocent": [
    [
      "pur",
      0.095
    ],
    [
      "niais",
      0.085
    ],
    [
      "bete",
      0.0775
    ],
    [
      "naif",
      0.0775
    ],
    [
      "simple",
      0.07
    ],
    [
      "ingenu",
      0.0525
    ],
    [
      "candide",
      0.0525
    ],
    [
      "bon",
      0.0525
    ],
    [
      "idiot",
      0.0425
    ],
    [
      "vierge",
      0.0325
    ],
    [
      "chaste",
      0.0325
    ],
    [
      "angelique",
      0.025
    ],
    [
      "immacule",
      0.025
    ],
    [
      "nigaud",
      0.025
    ],
    [
      "simplet",
      0.015
    ],
    [
      "neuf",
      0.015
    ],
    [
      "inintelligent",
      0.015
    ],
    [
      "frais",
      0.015
    ],
    [
      "demeure",
      0.015
    ],
    [
      "cretin",
      0.015
    ],
    [
      "beta",
      0.015
    ],
    [
      "benin",
      0.015
    ],
    [
      "blanc",
      0.015
    ],
    [
      "irreprehensible",
      0.0075
    ],
    [
      "irreprochable",
      0.0075
    ],
    [
      "irresponsable",
      0.0075
    ],
    [
      "inoffensif",
      0.0075
    ],
    [
      "enfant",
      0.0075
    ],
    [
      "credule",
      0.0075
    ],
    [
      "coquebin",
      0.0075
    ],
    [
      "continent",
      0.0075
    ],
    [
      "attarde",
      0.0075
    ],
    [
      "vrai",
      0.0075
    ]
  ],
  "cigarette": [
    [
      "pipe",
      0.25
    ],
    [
      "seche",
      0.25
    ],
    [
      "cibiche",
      0.125
    ],
    [
      "clope",
      0.125
    ],
    [
      "tige",
      0.125
    ],
    [
      "tronc",
      0.125
    ]
  ],
  "etonner": [
    [
      "stupefier",
      0.075
    ],
    [
      "abasourdir",
      0.065
    ],
    [
      "ebahir",
      0.0625
    ],
    [
      "ahurir",
      0.055
    ],
    [
      "confondre",
      0.055
    ],
    [
      "siderer",
      0.05
    ],
    [
      "deconcerter",
      0.05
    ],
    [
      "surprendre",
      0.045
    ],
    [
      "interloquer",
      0.035
    ],
    [
      "meduser",
      0.035
    ],
    [
      "petrifier",
      0.035
    ],
    [
      "troubler",
      0.03
    ],
    [
      "renverser",
      0.03
    ],
    [
      "interdire",
      0.03
    ],
    [
      "epater",
      0.025
    ],
    [
      "frapper",
      0.0225
    ],
    [
      "saisir",
      0.0225
    ],
    [
      "eblouir",
      0.02
    ],
    [
      "foudroyer",
      0.02
    ],
    [
      "estomaquer",
      0.02
    ],
    [
      "derouter",
      0.015
    ],
    [
      "etourdir",
      0.015
    ],
    [
      "epoustoufler",
      0.0125
    ],
    [
      "impressionner",
      0.0125
    ],
    [
      "effarer",
      0.0125
    ],
    [
      "bouleverser",
      0.0125
    ],
    [
      "assommer",
      0.01
    ],
    [
      "decontenancer",
      0.01
    ],
    [
      "suffoquer",
      0.01
    ],
    [
      "ecraser",
      0.01
    ],
    [
      "ebouriffer",
      0.005
    ],
    [
      "eberluer",
      0.005
    ],
    [
      "transir",
      0.005
    ],
    [
      "terroriser",
      0.005
    ],
    [
      "desorienter",
      0.005
    ],
    [
      "ebaubir",
      0.0025
    ],
    [
      "stupefaire",
      0.0025
    ],
    [
      "scier",
      0.0025
    ],
    [
      "heurter",
      0.0025
    ],
    [
      "esbroufer",
      0.0025
    ],
    [
      "depasser",
      0.0025
    ],
    [
      "assourdir",
      0.0025
    ],
    [
      "emerveiller",
      0.0025
    ]
  ],
  "vacance": [
    [
      "inaction",
      0.165
    ],
    [
      "interruption",
      0.165
    ],
    [
      "suspension",
      0.165
    ],
    [
      "vide",
      0.165
    ],
    [
      "carence",
      0.0825
    ],
    [
      "disponibilite",
      0.0825
    ],
    [
      "vacation",
      0.0825
    ],
    [
      "vacuite",
      0.0825
    ]
  ],
  "mac": [
    [
      "julot",
      0.5
    ],
    [
      "maquereau",
      0.5
    ]
  ],
  "debarquer": [
    [
      "renvoyer",
      0.13
    ],
    [
      "limoger",
      0.1175
    ],
    [
      "revoquer",
      0.09
    ],
    [
      "vider",
      0.09
    ],
    [
      "congedier",
      0.0775
    ],
    [
      "remercier",
      0.065
    ],
    [
      "destituer",
      0.065
    ],
    [
      "degommer",
      0.0525
    ],
    [
      "decharger",
      0.0375
    ],
    [
      "virer",
      0.025
    ],
    [
      "venir",
      0.025
    ],
    [
      "detroner",
      0.025
    ],
    [
      "deboulonner",
      0.025
    ],
    [
      "casser",
      0.025
    ],
    [
      "balancer",
      0.025
    ],
    [
      "saquer",
      0.0125
    ],
    [
      "liquider",
      0.0125
    ],
    [
      "deverser",
      0.0125
    ],
    [
      "demissionner",
      0.0125
    ],
    [
      "debarder",
      0.0125
    ],
    [
      "descendre",
      0.0125
    ],
    [
      "arriver",
      0.0125
    ],
    [
      "ecarter",
      0.0125
    ]
  ],
  "far": [],
  "poncho": [
    [
      "couverture",
      0.3325
    ],
    [
      "manteau",
      0.3325
    ],
    [
      "plaid",
      0.3325
    ]
  ],
  "barioler": [
    [
      "bigarrer",
      0.1375
    ],
    [
      "barbouiller",
      0.0825
    ],
    [
      "tacher",
      0.055
    ],
    [
      "peinturlurer",
      0.055
    ],
    [
      "peindre",
      0.055
    ],
    [
      "panacher",
      0.055
    ],
    [
      "nuancer",
      0.055
    ],
    [
      "moucheter",
      0.055
    ],
    [
      "marqueter",
      0.055
    ],
    [
      "jasper",
      0.055
    ],
    [
      "diaprer",
      0.055
    ],
    [
      "colorer",
      0.055
    ],
    [
      "chamarrer",
      0.055
    ],
    [
      "teindre",
      0.0275
    ],
    [
      "peinturer",
      0.0275
    ],
    [
      "melanger",
      0.0275
    ],
    [
      "marbrer",
      0.0275
    ],
    [
      "chiner",
      0.0275
    ],
    [
      "veiner",
      0.0275
    ]
  ],
  "bariole": [
    [
      "bigarrer",
      0.1375
    ],
    [
      "barbouiller",
      0.0825
    ],
    [
      "tacher",
      0.055
    ],
    [
      "peinturlurer",
      0.055
    ],
    [
      "peindre",
      0.055
    ],
    [
      "panacher",
      0.055
    ],
    [
      "nuancer",
      0.055
    ],
    [
      "moucheter",
      0.055
    ],
    [
      "marqueter",
      0.055
    ],
    [
      "jasper",
      0.055
    ],
    [
      "diaprer",
      0.055
    ],
    [
      "colorer",
      0.055
    ],
    [
      "chamarrer",
      0.055
    ],
    [
      "teindre",
      0.0275
    ],
    [
      "peinturer",
      0.0275
    ],
    [
      "melanger",
      0.0275
    ],
    [
      "marbrer",
      0.0275
    ],
    [
      "chiner",
      0.0275
    ],
    [
      "veiner",
      0.0275
    ]
  ],
  "parier": [
    [
      "affirmer",
      0.1525
    ],
    [
      "certifier",
      0.1525
    ],
    [
      "gager",
      0.1525
    ],
    [
      "miser",
      0.1525
    ],
    [
      "ponter",
      0.1525
    ],
    [
      "assurer",
      0.075
    ],
    [
      "jouer",
      0.075
    ]
  ],
  "six": [],
  "barillet": [
    [
      "baricaut",
      0.25
    ],
    [
      "cavite",
      0.25
    ],
    [
      "cylindre",
      0.25
    ],
    [
      "tambour",
      0.25
    ]
  ],
  "craindre": [
    [
      "redouter",
      0.24
    ],
    [
      "apprehender",
      0.1025
    ],
    [
      "pressentir",
      0.1025
    ],
    [
      "attendre",
      0.0675
    ],
    [
      "s'effrayer",
      0.0325
    ],
    [
      "trembler",
      0.0325
    ],
    [
      "s'attendre",
      0.0325
    ],
    [
      "s'alarmer",
      0.0325
    ],
    [
      "reverer",
      0.0325
    ],
    [
      "regretter",
      0.0325
    ],
    [
      "plaindre",
      0.0325
    ],
    [
      "menager",
      0.0325
    ],
    [
      "honorer",
      0.0325
    ]
  ],
  "parer": [
    [
      "orner",
      0.12
    ],
    [
      "embellir",
      0.0625
    ],
    [
      "attifer",
      0.0525
    ],
    [
      "habiller",
      0.0475
    ],
    [
      "imager",
      0.0475
    ],
    [
      "garnir",
      0.04
    ],
    [
      "arranger",
      0.035
    ],
    [
      "remedier",
      0.025
    ],
    [
      "enjoliver",
      0.025
    ],
    [
      "decorer",
      0.025
    ],
    [
      "ajuster",
      0.0225
    ],
    [
      "farder",
      0.0225
    ],
    [
      "revetir",
      0.0225
    ],
    [
      "eviter",
      0.0225
    ],
    [
      "prevenir",
      0.015
    ],
    [
      "preserver",
      0.015
    ],
    [
      "pourvoir",
      0.015
    ],
    [
      "entourer",
      0.015
    ],
    [
      "enrichir",
      0.015
    ],
    [
      "agrementer",
      0.015
    ],
    [
      "preparer",
      0.0125
    ],
    [
      "proteger",
      0.0125
    ],
    [
      "pomponner",
      0.0125
    ],
    [
      "pallier",
      0.0125
    ],
    [
      "obvier",
      0.0125
    ],
    [
      "detourner",
      0.0125
    ],
    [
      "colorer",
      0.0125
    ],
    [
      "accoutrer",
      0.0125
    ],
    [
      "historier",
      0.0075
    ],
    [
      "ornementer",
      0.0075
    ],
    [
      "renforcer",
      0.0075
    ],
    [
      "veiller",
      0.0075
    ],
    [
      "egayer",
      0.0075
    ],
    [
      "broder",
      0.0075
    ],
    [
      "bichonner",
      0.0075
    ],
    [
      "accommoder",
      0.0075
    ],
    [
      "adorner",
      0.0075
    ],
    [
      "appreter",
      0.0075
    ],
    [
      "aureoler",
      0.0075
    ],
    [
      "aviser",
      0.0075
    ],
    [
      "perfectionner",
      0.0025
    ],
    [
      "plumer",
      0.0025
    ],
    [
      "poupiner",
      0.0025
    ],
    [
      "retenir",
      0.0025
    ],
    [
      "teinter",
      0.0025
    ],
    [
      "vider",
      0.0025
    ],
    [
      "nimber",
      0.0025
    ],
    [
      "garantir",
      0.0025
    ],
    [
      "adoniser",
      0.0025
    ],
    [
      "afistoler",
      0.0025
    ],
    [
      "chamarrer",
      0.0025
    ],
    [
      "conjurer",
      0.0025
    ],
    [
      "doubler",
      0.0025
    ],
    [
      "empanacher",
      0.0025
    ],
    [
      "endimancher",
      0.0025
    ],
    [
      "esquiver",
      0.0025
    ],
    [
      "ferrer",
      0.0025
    ],
    [
      "fleurir",
      0.0025
    ],
    [
      "emailler",
      0.0025
    ]
  ],
  "bastringue": [
    [
      "tapage",
      0.1
    ],
    [
      "vacarme",
      0.1
    ],
    [
      "bazar",
      0.09
    ],
    [
      "bordel",
      0.07
    ],
    [
      "desordre",
      0.07
    ],
    [
      "chahut",
      0.06
    ],
    [
      "bruit",
      0.06
    ],
    [
      "bal",
      0.04
    ],
    [
      "boucan",
      0.04
    ],
    [
      "fourbi",
      0.03
    ],
    [
      "cabaret",
      0.03
    ],
    [
      "beuglant",
      0.03
    ],
    [
      "tintamarre",
      0.02
    ],
    [
      "guinguette",
      0.02
    ],
    [
      "guinche",
      0.02
    ],
    [
      "foutoir",
      0.02
    ],
    [
      "fourniment",
      0.02
    ],
    [
      "attirail",
      0.02
    ],
    [
      "bataclan",
      0.02
    ],
    [
      "bouge",
      0.02
    ],
    [
      "chambard",
      0.02
    ],
    [
      "dancing",
      0.02
    ],
    [
      "barda",
      0.01
    ],
    [
      "musette",
      0.01
    ],
    [
      "musique",
      0.01
    ]
  ],
  "suffire": [
    [
      "pourvoir",
      0.18
    ],
    [
      "satisfaire",
      0.18
    ],
    [
      "apaiser",
      0.09
    ],
    [
      "baster",
      0.09
    ],
    [
      "contenter",
      0.09
    ],
    [
      "fournir",
      0.09
    ],
    [
      "subvenir",
      0.09
    ]
  ],
  "poule": [
    [
      "cocotte",
      0.1125
    ],
    [
      "poulet",
      0.1125
    ],
    [
      "prostituee",
      0.055
    ],
    [
      "poulette",
      0.055
    ],
    [
      "gibier",
      0.055
    ],
    [
      "caille",
      0.055
    ],
    [
      "biquette",
      0.055
    ],
    [
      "pintade",
      0.025
    ],
    [
      "poulaille",
      0.025
    ],
    [
      "poularde",
      0.025
    ],
    [
      "poulot",
      0.025
    ],
    [
      "poupoule",
      0.025
    ],
    [
      "putain",
      0.025
    ],
    [
      "perdrix",
      0.025
    ],
    [
      "mise",
      0.025
    ],
    [
      "gelinotte",
      0.025
    ],
    [
      "geline",
      0.025
    ],
    [
      "gallinacee",
      0.025
    ],
    [
      "faisane",
      0.025
    ],
    [
      "enjeu",
      0.025
    ],
    [
      "competition",
      0.025
    ],
    [
      "amante",
      0.025
    ],
    [
      "sultane",
      0.025
    ]
  ],
  "brute": [
    [
      "grossier",
      0.1325
    ],
    [
      "fruste",
      0.0775
    ],
    [
      "rude",
      0.06
    ],
    [
      "rustique",
      0.06
    ],
    [
      "simple",
      0.0525
    ],
    [
      "primitif",
      0.04
    ],
    [
      "lourd",
      0.04
    ],
    [
      "inculte",
      0.04
    ],
    [
      "barbare",
      0.04
    ],
    [
      "naturel",
      0.035
    ],
    [
      "sauvage",
      0.035
    ],
    [
      "stupide",
      0.0225
    ],
    [
      "cru",
      0.0225
    ],
    [
      "brutal",
      0.0225
    ],
    [
      "imparfait",
      0.0175
    ],
    [
      "vulgaire",
      0.0175
    ],
    [
      "elementaire",
      0.0175
    ],
    [
      "epais",
      0.0175
    ],
    [
      "originel",
      0.01
    ],
    [
      "premier",
      0.01
    ],
    [
      "pur",
      0.01
    ],
    [
      "rudimentaire",
      0.01
    ],
    [
      "trivial",
      0.01
    ],
    [
      "vierge",
      0.01
    ],
    [
      "naif",
      0.01
    ],
    [
      "natif",
      0.01
    ],
    [
      "abrupt",
      0.01
    ],
    [
      "balourd",
      0.01
    ],
    [
      "bestial",
      0.01
    ],
    [
      "bourru",
      0.01
    ],
    [
      "impoli",
      0.01
    ],
    [
      "informe",
      0.01
    ],
    [
      "ort",
      0.005
    ],
    [
      "machinal",
      0.005
    ],
    [
      "inorganique",
      0.005
    ],
    [
      "inintelligent",
      0.005
    ],
    [
      "inacheve",
      0.005
    ],
    [
      "immediat",
      0.005
    ],
    [
      "illettre",
      0.005
    ],
    [
      "grege",
      0.005
    ],
    [
      "farouche",
      0.005
    ],
    [
      "ecru",
      0.005
    ]
  ],
  "brut": [
    [
      "grossier",
      0.1325
    ],
    [
      "fruste",
      0.0775
    ],
    [
      "rude",
      0.06
    ],
    [
      "rustique",
      0.06
    ],
    [
      "simple",
      0.0525
    ],
    [
      "primitif",
      0.04
    ],
    [
      "lourd",
      0.04
    ],
    [
      "inculte",
      0.04
    ],
    [
      "barbare",
      0.04
    ],
    [
      "naturel",
      0.035
    ],
    [
      "sauvage",
      0.035
    ],
    [
      "stupide",
      0.0225
    ],
    [
      "cru",
      0.0225
    ],
    [
      "brutal",
      0.0225
    ],
    [
      "imparfait",
      0.0175
    ],
    [
      "vulgaire",
      0.0175
    ],
    [
      "elementaire",
      0.0175
    ],
    [
      "epais",
      0.0175
    ],
    [
      "originel",
      0.01
    ],
    [
      "premier",
      0.01
    ],
    [
      "pur",
      0.01
    ],
    [
      "rudimentaire",
      0.01
    ],
    [
      "trivial",
      0.01
    ],
    [
      "vierge",
      0.01
    ],
    [
      "naif",
      0.01
    ],
    [
      "natif",
      0.01
    ],
    [
      "abrupt",
      0.01
    ],
    [
      "balourd",
      0.01
    ],
    [
      "bestial",
      0.01
    ],
    [
      "bourru",
      0.01
    ],
    [
      "impoli",
      0.01
    ],
    [
      "informe",
      0.01
    ],
    [
      "ort",
      0.005
    ],
    [
      "machinal",
      0.005
    ],
    [
      "inorganique",
      0.005
    ],
    [
      "inintelligent",
      0.005
    ],
    [
      "inacheve",
      0.005
    ],
    [
      "immediat",
      0.005
    ],
    [
      "illettre",
      0.005
    ],
    [
      "grege",
      0.005
    ],
    [
      "farouche",
      0.005
    ],
    [
      "ecru",
      0.005
    ]
  ],
  "loyal": [
    [
      "honnete",
      0.13
    ],
    [
      "fidele",
      0.1175
    ],
    [
      "sincere",
      0.07
    ],
    [
      "juste",
      0.07
    ],
    [
      "franc",
      0.07
    ],
    [
      "droit",
      0.07
    ],
    [
      "net",
      0.0575
    ],
    [
      "regulier",
      0.0575
    ],
    [
      "vrai",
      0.0575
    ],
    [
      "solide",
      0.045
    ],
    [
      "sur",
      0.0325
    ],
    [
      "probe",
      0.0325
    ],
    [
      "correct",
      0.0325
    ],
    [
      "devoue",
      0.0225
    ],
    [
      "sportif",
      0.01
    ],
    [
      "sport",
      0.01
    ],
    [
      "reglo",
      0.01
    ],
    [
      "rond",
      0.01
    ],
    [
      "legal",
      0.01
    ],
    [
      "feal",
      0.01
    ],
    [
      "entier",
      0.01
    ],
    [
      "cordial",
      0.01
    ],
    [
      "carre",
      0.01
    ],
    [
      "equitable",
      0.01
    ]
  ],
  "volonte": [
    [
      "resolution",
      0.09
    ],
    [
      "fermete",
      0.075
    ],
    [
      "courage",
      0.055
    ],
    [
      "energie",
      0.05
    ],
    [
      "desir",
      0.0475
    ],
    [
      "decision",
      0.04
    ],
    [
      "determination",
      0.0325
    ],
    [
      "caractere",
      0.0325
    ],
    [
      "dessein",
      0.025
    ],
    [
      "fantaisie",
      0.025
    ],
    [
      "force",
      0.025
    ],
    [
      "intention",
      0.025
    ],
    [
      "solidite",
      0.025
    ],
    [
      "ressort",
      0.0225
    ],
    [
      "humeur",
      0.0225
    ],
    [
      "constance",
      0.0225
    ],
    [
      "caprice",
      0.02
    ],
    [
      "cran",
      0.02
    ],
    [
      "esprit",
      0.02
    ],
    [
      "exigence",
      0.02
    ],
    [
      "tenacite",
      0.015
    ],
    [
      "soif",
      0.015
    ],
    [
      "opiniatrete",
      0.015
    ],
    [
      "obstination",
      0.015
    ],
    [
      "idee",
      0.015
    ],
    [
      "gre",
      0.015
    ],
    [
      "souhait",
      0.0125
    ],
    [
      "disposition",
      0.0125
    ],
    [
      "ame",
      0.01
    ],
    [
      "vouloir",
      0.01
    ],
    [
      "voeu",
      0.01
    ],
    [
      "propos",
      0.01
    ],
    [
      "perseverance",
      0.01
    ],
    [
      "toquade",
      0.005
    ],
    [
      "revendication",
      0.005
    ],
    [
      "ressource",
      0.005
    ],
    [
      "parti",
      0.005
    ],
    [
      "liberte",
      0.005
    ],
    [
      "guise",
      0.005
    ],
    [
      "choix",
      0.005
    ],
    [
      "bras",
      0.005
    ],
    [
      "personnalite",
      0.0025
    ],
    [
      "mode",
      0.0025
    ],
    [
      "initiative",
      0.0025
    ],
    [
      "grace",
      0.0025
    ],
    [
      "effort",
      0.0025
    ],
    [
      "decret",
      0.0025
    ],
    [
      "volition",
      0.0025
    ]
  ],
  "botte": [
    [
      "bottine",
      0.065
    ],
    [
      "chaussure",
      0.065
    ],
    [
      "faisceau",
      0.065
    ],
    [
      "bottillon",
      0.0525
    ],
    [
      "tas",
      0.0375
    ],
    [
      "gerbe",
      0.0375
    ],
    [
      "fagot",
      0.0375
    ],
    [
      "coup",
      0.0375
    ],
    [
      "brodequin",
      0.0375
    ],
    [
      "bouquet",
      0.0375
    ],
    [
      "assemblage",
      0.0375
    ],
    [
      "trousse",
      0.025
    ],
    [
      "touffe",
      0.025
    ],
    [
      "soulier",
      0.025
    ],
    [
      "javelle",
      0.025
    ],
    [
      "brassee",
      0.025
    ],
    [
      "astuce",
      0.025
    ],
    [
      "houseau",
      0.01
    ],
    [
      "liasse",
      0.01
    ],
    [
      "manoque",
      0.01
    ],
    [
      "masse",
      0.01
    ],
    [
      "parade",
      0.01
    ],
    [
      "ranger",
      0.01
    ],
    [
      "santiag",
      0.01
    ],
    [
      "secret",
      0.01
    ],
    [
      "tonneau",
      0.01
    ],
    [
      "torgnole",
      0.01
    ],
    [
      "etui",
      0.01
    ],
    [
      "heuse",
      0.01
    ],
    [
      "guetre",
      0.01
    ],
    [
      "balle",
      0.01
    ],
    [
      "boots",
      0.01
    ],
    [
      "bottelette",
      0.01
    ],
    [
      "bottelee",
      0.01
    ],
    [
      "bottee",
      0.01
    ],
    [
      "bouchon",
      0.01
    ],
    [
      "bourree",
      0.01
    ],
    [
      "cuissard",
      0.01
    ],
    [
      "cuissarde",
      0.01
    ],
    [
      "estocade",
      0.01
    ],
    [
      "attaque",
      0.01
    ]
  ],
  "botter": [
    [
      "aller",
      0.1875
    ],
    [
      "convenir",
      0.125
    ],
    [
      "tirer",
      0.125
    ],
    [
      "shooter",
      0.06
    ],
    [
      "plaire",
      0.06
    ],
    [
      "latter",
      0.06
    ],
    [
      "fesser",
      0.06
    ],
    [
      "feindre",
      0.06
    ],
    [
      "chausser",
      0.06
    ],
    [
      "battre",
      0.06
    ],
    [
      "taper",
      0.06
    ]
  ],
  "rapper": [],
  "craner": [
    [
      "poser",
      0.2
    ],
    [
      "affecter",
      0.1325
    ],
    [
      "frimer",
      0.1325
    ],
    [
      "plastronner",
      0.1325
    ],
    [
      "fanfaronner",
      0.065
    ],
    [
      "braver",
      0.065
    ],
    [
      "simuler",
      0.065
    ]
  ],
  "crane": [
    [
      "tete",
      0.16
    ],
    [
      "courageux",
      0.12
    ],
    [
      "intrepide",
      0.0775
    ],
    [
      "decide",
      0.0775
    ],
    [
      "cervelle",
      0.0775
    ],
    [
      "bourrichon",
      0.0775
    ],
    [
      "resolu",
      0.0375
    ],
    [
      "fier",
      0.0375
    ],
    [
      "confiant",
      0.0375
    ],
    [
      "cerveau",
      0.0375
    ],
    [
      "caisson",
      0.0375
    ],
    [
      "caillou",
      0.0375
    ],
    [
      "brave",
      0.0375
    ],
    [
      "audacieux",
      0.0375
    ],
    [
      "tet",
      0.0375
    ]
  ],
  "tournee": [
    [
      "passer",
      0.045
    ],
    [
      "changer",
      0.04
    ],
    [
      "remuer",
      0.0325
    ],
    [
      "jouer",
      0.03
    ],
    [
      "marcher",
      0.03
    ],
    [
      "tournoyer",
      0.025
    ],
    [
      "obliquer",
      0.025
    ],
    [
      "virevolter",
      0.0225
    ],
    [
      "virer",
      0.0225
    ],
    [
      "rouler",
      0.0225
    ],
    [
      "retourner",
      0.0225
    ],
    [
      "detourner",
      0.0225
    ],
    [
      "arranger",
      0.0225
    ],
    [
      "tordre",
      0.0175
    ],
    [
      "tendre",
      0.0175
    ],
    [
      "orienter",
      0.0175
    ],
    [
      "incliner",
      0.0175
    ],
    [
      "battre",
      0.0175
    ],
    [
      "eluder",
      0.0125
    ],
    [
      "transformer",
      0.0125
    ],
    [
      "rabattre",
      0.0125
    ],
    [
      "prendre",
      0.0125
    ],
    [
      "pivoter",
      0.0125
    ],
    [
      "partir",
      0.0125
    ],
    [
      "influer",
      0.0125
    ],
    [
      "diriger",
      0.0125
    ],
    [
      "disposer",
      0.0125
    ],
    [
      "devier",
      0.0125
    ],
    [
      "exposer",
      0.0125
    ],
    [
      "fonctionner",
      0.0125
    ],
    [
      "evoluer",
      0.01
    ],
    [
      "tournailler",
      0.01
    ],
    [
      "tortiller",
      0.01
    ],
    [
      "presenter",
      0.01
    ],
    [
      "influencer",
      0.01
    ],
    [
      "finir",
      0.01
    ],
    [
      "metamorphoser",
      0.005
    ],
    [
      "pourrir",
      0.005
    ],
    [
      "prevenir",
      0.005
    ],
    [
      "ruminer",
      0.005
    ],
    [
      "roder",
      0.005
    ],
    [
      "serpenter",
      0.005
    ],
    [
      "tourniller",
      0.005
    ],
    [
      "tourniquer",
      0.005
    ],
    [
      "violer",
      0.005
    ],
    [
      "modifier",
      0.005
    ],
    [
      "manipuler",
      0.005
    ],
    [
      "interpreter",
      0.005
    ],
    [
      "appliquer",
      0.005
    ],
    [
      "braquer",
      0.005
    ],
    [
      "brasser",
      0.005
    ],
    [
      "cinematographier",
      0.005
    ],
    [
      "considerer",
      0.005
    ],
    [
      "contourner",
      0.005
    ],
    [
      "degenerer",
      0.005
    ],
    [
      "deriver",
      0.005
    ],
    [
      "encercler",
      0.005
    ],
    [
      "esquiver",
      0.005
    ],
    [
      "graviter",
      0.005
    ],
    [
      "tortillonner",
      0.0025
    ],
    [
      "s'aigrir",
      0.0025
    ],
    [
      "pirouetter",
      0.0025
    ],
    [
      "murir",
      0.0025
    ],
    [
      "touiller",
      0.0025
    ],
    [
      "toupiller",
      0.0025
    ],
    [
      "toupiner",
      0.0025
    ],
    [
      "tourbillonner",
      0.0025
    ],
    [
      "tournicoter",
      0.0025
    ],
    [
      "transgresser",
      0.0025
    ],
    [
      "trousser",
      0.0025
    ],
    [
      "virevousser",
      0.0025
    ],
    [
      "zigzaguer",
      0.0025
    ],
    [
      "girer",
      0.0025
    ],
    [
      "finasser",
      0.0025
    ],
    [
      "alterner",
      0.0025
    ],
    [
      "aleser",
      0.0025
    ],
    [
      "bistourner",
      0.0025
    ],
    [
      "cinegraphier",
      0.0025
    ],
    [
      "convertir",
      0.0025
    ],
    [
      "devenir",
      0.0025
    ],
    [
      "doubler",
      0.0025
    ],
    [
      "deborder",
      0.0025
    ],
    [
      "enfermer",
      0.0025
    ],
    [
      "enrouler",
      0.0025
    ],
    [
      "escamoter",
      0.0025
    ],
    [
      "examiner",
      0.0025
    ],
    [
      "exprimer",
      0.0025
    ],
    [
      "filmer",
      0.0025
    ],
    [
      "aigrir",
      0.0025
    ]
  ],
  "milligramme": [
    [
      "poids",
      1.0
    ]
  ],
  "mascotte": [
    [
      "amulette",
      0.22
    ],
    [
      "fetiche",
      0.22
    ],
    [
      "talisman",
      0.22
    ],
    [
      "charme",
      0.11
    ],
    [
      "totem",
      0.11
    ]
  ],
  "camper": [
    [
      "mettre",
      0.12
    ],
    [
      "placer",
      0.095
    ],
    [
      "poser",
      0.0825
    ],
    [
      "situer",
      0.06
    ],
    [
      "etablir",
      0.06
    ],
    [
      "planter",
      0.0475
    ],
    [
      "peindre",
      0.0475
    ],
    [
      "installer",
      0.0475
    ],
    [
      "fixer",
      0.0475
    ],
    [
      "croquer",
      0.035
    ],
    [
      "habiter",
      0.035
    ],
    [
      "loger",
      0.035
    ],
    [
      "poster",
      0.035
    ],
    [
      "sejourner",
      0.0225
    ],
    [
      "s'etablir",
      0.0225
    ],
    [
      "dresser",
      0.0225
    ],
    [
      "cantonner",
      0.0225
    ],
    [
      "asseoir",
      0.0225
    ],
    [
      "saisir",
      0.01
    ],
    [
      "s'installer",
      0.01
    ],
    [
      "s'arreter",
      0.01
    ],
    [
      "portraiturer",
      0.01
    ],
    [
      "laisser",
      0.01
    ],
    [
      "flanquer",
      0.01
    ],
    [
      "esquisser",
      0.01
    ],
    [
      "decrire",
      0.01
    ],
    [
      "bivouaquer",
      0.01
    ],
    [
      "affermir",
      0.01
    ],
    [
      "stationner",
      0.01
    ]
  ],
  "kicker": [],
  "boy": [
    [
      "serviteur",
      0.4
    ],
    [
      "cuisinier",
      0.1
    ],
    [
      "danseur",
      0.1
    ],
    [
      "domestique",
      0.1
    ],
    [
      "factotum",
      0.1
    ],
    [
      "garcon",
      0.1
    ],
    [
      "jardinier",
      0.1
    ]
  ],
  "cobaye": [
    [
      "cavia",
      0.25
    ],
    [
      "cochon",
      0.25
    ],
    [
      "sujet",
      0.25
    ]
  ],
  "scalpel": [
    [
      "bistouri",
      0.5
    ],
    [
      "couteau",
      0.5
    ]
  ],
  "letal": [
    [
      "fatal",
      0.5
    ],
    [
      "mortel",
      0.5
    ]
  ],
  "urgence": [
    [
      "acuite",
      1.0
    ]
  ],
  "ordonnance": [
    [
      "ordre",
      0.1075
    ],
    [
      "arrangement",
      0.085
    ],
    [
      "disposition",
      0.085
    ],
    [
      "reglement",
      0.075
    ],
    [
      "organisation",
      0.0675
    ],
    [
      "structure",
      0.045
    ],
    [
      "agencement",
      0.0375
    ],
    [
      "prescription",
      0.0375
    ],
    [
      "statut",
      0.0375
    ],
    [
      "economie",
      0.03
    ],
    [
      "decret",
      0.03
    ],
    [
      "distribution",
      0.03
    ],
    [
      "constitution",
      0.03
    ],
    [
      "amenagement",
      0.0225
    ],
    [
      "decision",
      0.0225
    ],
    [
      "edit",
      0.0225
    ],
    [
      "succession",
      0.015
    ],
    [
      "soldat",
      0.015
    ],
    [
      "plan",
      0.015
    ],
    [
      "mandement",
      0.015
    ],
    [
      "loi",
      0.015
    ],
    [
      "harmonie",
      0.015
    ],
    [
      "composition",
      0.015
    ],
    [
      "architecture",
      0.015
    ],
    [
      "planton",
      0.0075
    ],
    [
      "protocole",
      0.0075
    ],
    [
      "repartition",
      0.0075
    ],
    [
      "sentence",
      0.0075
    ],
    [
      "tampon",
      0.0075
    ],
    [
      "jugement",
      0.0075
    ],
    [
      "estafette",
      0.0075
    ],
    [
      "deroulement",
      0.0075
    ],
    [
      "cedule",
      0.0075
    ],
    [
      "coordination",
      0.0075
    ],
    [
      "brosseur",
      0.0075
    ],
    [
      "architectonique",
      0.0075
    ],
    [
      "ecuyer",
      0.0075
    ]
  ],
  "missile": [
    [
      "engin",
      0.5
    ],
    [
      "fusee",
      0.5
    ]
  ],
  "milice": [
    [
      "troupe",
      0.4
    ],
    [
      "armee",
      0.2
    ],
    [
      "garde",
      0.2
    ],
    [
      "police",
      0.2
    ]
  ],
  "ultime": [
    [
      "dernier",
      0.25
    ],
    [
      "extreme",
      0.25
    ],
    [
      "final",
      0.25
    ],
    [
      "definitif",
      0.125
    ],
    [
      "supreme",
      0.125
    ]
  ],
  "tarer": [
    [
      "gater",
      0.205
    ],
    [
      "alterer",
      0.1025
    ],
    [
      "corrompre",
      0.1025
    ],
    [
      "fletrir",
      0.1025
    ],
    [
      "salir",
      0.1025
    ],
    [
      "souiller",
      0.1025
    ],
    [
      "ternir",
      0.05
    ],
    [
      "tacher",
      0.05
    ],
    [
      "polluer",
      0.05
    ],
    [
      "frelater",
      0.05
    ],
    [
      "avarier",
      0.025
    ],
    [
      "entacher",
      0.025
    ],
    [
      "peser",
      0.025
    ]
  ],
  "tare": [
    [
      "gater",
      0.205
    ],
    [
      "alterer",
      0.1025
    ],
    [
      "corrompre",
      0.1025
    ],
    [
      "fletrir",
      0.1025
    ],
    [
      "salir",
      0.1025
    ],
    [
      "souiller",
      0.1025
    ],
    [
      "ternir",
      0.05
    ],
    [
      "tacher",
      0.05
    ],
    [
      "polluer",
      0.05
    ],
    [
      "frelater",
      0.05
    ],
    [
      "avarier",
      0.025
    ],
    [
      "entacher",
      0.025
    ],
    [
      "peser",
      0.025
    ]
  ],
  "haha": [],
  "tac": [
    [
      "taxi",
      1.0
    ]
  ],
  "decompter": [
    [
      "deduire",
      0.1425
    ],
    [
      "defalquer",
      0.1425
    ],
    [
      "retenir",
      0.1425
    ],
    [
      "retrancher",
      0.1425
    ],
    [
      "rabattre",
      0.07
    ],
    [
      "denombrer",
      0.07
    ],
    [
      "compter",
      0.07
    ],
    [
      "soustraire",
      0.07
    ]
  ],
  "decompte": [
    [
      "compte",
      0.125
    ],
    [
      "denombrement",
      0.125
    ],
    [
      "soustraction",
      0.0825
    ],
    [
      "retranchement",
      0.0825
    ],
    [
      "deduction",
      0.0825
    ],
    [
      "calcul",
      0.0825
    ],
    [
      "detail",
      0.04
    ],
    [
      "desillusion",
      0.04
    ],
    [
      "defalcation",
      0.04
    ],
    [
      "deduit",
      0.04
    ],
    [
      "decomposition",
      0.04
    ],
    [
      "deception",
      0.04
    ],
    [
      "comptabilite",
      0.04
    ],
    [
      "cens",
      0.04
    ],
    [
      "addition",
      0.04
    ],
    [
      "reduction",
      0.04
    ]
  ],
  "dingo": [
    [
      "cingle",
      0.175
    ],
    [
      "fou",
      0.175
    ],
    [
      "dingue",
      0.15
    ],
    [
      "pique",
      0.15
    ],
    [
      "toque",
      0.0475
    ],
    [
      "timbre",
      0.0475
    ],
    [
      "aliene",
      0.0475
    ],
    [
      "jete",
      0.0225
    ],
    [
      "givre",
      0.0225
    ],
    [
      "fondu",
      0.0225
    ],
    [
      "foldingue",
      0.0225
    ],
    [
      "canide",
      0.0225
    ],
    [
      "barjo",
      0.0225
    ],
    [
      "absurde",
      0.0225
    ],
    [
      "sonne",
      0.0225
    ]
  ],
  "valdinguer": [
    [
      "dinguer",
      0.285
    ],
    [
      "valser",
      0.285
    ],
    [
      "cabrioler",
      0.1425
    ],
    [
      "degringoler",
      0.1425
    ],
    [
      "tomber",
      0.1425
    ]
  ],
  "traquer": [
    [
      "poursuivre",
      0.25
    ],
    [
      "chasser",
      0.1875
    ],
    [
      "harceler",
      0.125
    ],
    [
      "pourchasser",
      0.125
    ],
    [
      "courre",
      0.0625
    ],
    [
      "forcer",
      0.0625
    ],
    [
      "inquieter",
      0.0625
    ],
    [
      "pieger",
      0.0625
    ],
    [
      "talonner",
      0.0625
    ]
  ],
  "tactique": [
    [
      "methode",
      0.12
    ],
    [
      "truc",
      0.1075
    ],
    [
      "moyen",
      0.0925
    ],
    [
      "procede",
      0.08
    ],
    [
      "strategie",
      0.08
    ],
    [
      "systeme",
      0.065
    ],
    [
      "politique",
      0.0525
    ],
    [
      "conduite",
      0.0375
    ],
    [
      "maniere",
      0.0375
    ],
    [
      "manoeuvre",
      0.0375
    ],
    [
      "marche",
      0.0375
    ],
    [
      "ruse",
      0.0375
    ],
    [
      "plan",
      0.025
    ],
    [
      "jeu",
      0.025
    ],
    [
      "facon",
      0.025
    ],
    [
      "recette",
      0.0125
    ],
    [
      "militaire",
      0.0125
    ],
    [
      "menees",
      0.0125
    ],
    [
      "guerre",
      0.0125
    ],
    [
      "diplomatique",
      0.0125
    ],
    [
      "diplomatie",
      0.0125
    ],
    [
      "strategique",
      0.0125
    ]
  ],
  "anorak": [
    [
      "veste",
      1.0
    ]
  ],
  "flipper": [
    [
      "appareil",
      1.0
    ]
  ],
  "trac": [
    [
      "crainte",
      0.2
    ],
    [
      "peur",
      0.2
    ],
    [
      "apprehension",
      0.1325
    ],
    [
      "frayeur",
      0.1325
    ],
    [
      "frousse",
      0.1325
    ],
    [
      "inquietude",
      0.065
    ],
    [
      "timidite",
      0.065
    ],
    [
      "trouille",
      0.065
    ]
  ],
  "eclater": [
    [
      "s'emporter",
      0.04
    ],
    [
      "paraitre",
      0.035
    ],
    [
      "rompre",
      0.035
    ],
    [
      "jaillir",
      0.0275
    ],
    [
      "sauter",
      0.0225
    ],
    [
      "s'ouvrir",
      0.0225
    ],
    [
      "resplendir",
      0.0225
    ],
    [
      "rayonner",
      0.0225
    ],
    [
      "petiller",
      0.0225
    ],
    [
      "peter",
      0.0225
    ],
    [
      "briller",
      0.0225
    ],
    [
      "exploser",
      0.0225
    ],
    [
      "fulminer",
      0.0225
    ],
    [
      "fuser",
      0.0225
    ],
    [
      "partir",
      0.0225
    ],
    [
      "tonner",
      0.0175
    ],
    [
      "s'etaler",
      0.0175
    ],
    [
      "s'irriter",
      0.0175
    ],
    [
      "luire",
      0.0175
    ],
    [
      "flamboyer",
      0.0175
    ],
    [
      "deborder",
      0.0175
    ],
    [
      "crier",
      0.0175
    ],
    [
      "rire",
      0.01
    ],
    [
      "reluire",
      0.01
    ],
    [
      "fulgurer",
      0.01
    ],
    [
      "crever",
      0.01
    ],
    [
      "commencer",
      0.01
    ],
    [
      "s'eveiller",
      0.005
    ],
    [
      "s'esclaffer",
      0.005
    ],
    [
      "s'encolerer",
      0.005
    ],
    [
      "s'emballer",
      0.005
    ],
    [
      "rutiler",
      0.005
    ],
    [
      "retentir",
      0.005
    ],
    [
      "pouffer",
      0.005
    ],
    [
      "debonder",
      0.005
    ],
    [
      "crepiter",
      0.005
    ],
    [
      "casser",
      0.005
    ]
  ],
  "ethique": [
    [
      "morale",
      0.5
    ],
    [
      "deontologie",
      0.25
    ],
    [
      "philosophie",
      0.25
    ]
  ],
  "toc": [
    [
      "clinquant",
      0.18
    ],
    [
      "faux",
      0.1075
    ],
    [
      "pacotille",
      0.1075
    ],
    [
      "camelote",
      0.07
    ],
    [
      "trompeur",
      0.07
    ],
    [
      "rococo",
      0.035
    ],
    [
      "salete",
      0.035
    ],
    [
      "similor",
      0.035
    ],
    [
      "toque",
      0.035
    ],
    [
      "quincaille",
      0.035
    ],
    [
      "plastoc",
      0.035
    ],
    [
      "pan",
      0.035
    ],
    [
      "imitation",
      0.035
    ],
    [
      "contreplaque",
      0.035
    ],
    [
      "brillant",
      0.035
    ],
    [
      "vilain",
      0.035
    ]
  ],
  "toc.": [],
  "froc": [
    [
      "cagoule",
      0.165
    ],
    [
      "culotte",
      0.165
    ],
    [
      "futal",
      0.165
    ],
    [
      "pantalon",
      0.165
    ],
    [
      "robe",
      0.165
    ],
    [
      "rochet",
      0.165
    ]
  ],
  "envoyer": [
    [
      "donner",
      0.0675
    ],
    [
      "lancer",
      0.0675
    ],
    [
      "adresser",
      0.055
    ],
    [
      "ficher",
      0.055
    ],
    [
      "flanquer",
      0.055
    ],
    [
      "porter",
      0.055
    ],
    [
      "expedier",
      0.0475
    ],
    [
      "transporter",
      0.0475
    ],
    [
      "renvoyer",
      0.04
    ],
    [
      "jeter",
      0.04
    ],
    [
      "coller",
      0.04
    ],
    [
      "appliquer",
      0.0325
    ],
    [
      "allonger",
      0.025
    ],
    [
      "balancer",
      0.025
    ],
    [
      "transmettre",
      0.025
    ],
    [
      "precipiter",
      0.02
    ],
    [
      "nommer",
      0.02
    ],
    [
      "depecher",
      0.02
    ],
    [
      "congedier",
      0.02
    ],
    [
      "chasser",
      0.02
    ],
    [
      "apporter",
      0.02
    ],
    [
      "econduire",
      0.0125
    ],
    [
      "refuser",
      0.0125
    ],
    [
      "lacher",
      0.0125
    ],
    [
      "exporter",
      0.0125
    ],
    [
      "detacher",
      0.0125
    ],
    [
      "deplacer",
      0.0125
    ],
    [
      "deleguer",
      0.0125
    ],
    [
      "decocher",
      0.0125
    ],
    [
      "communiquer",
      0.0125
    ],
    [
      "acheminer",
      0.0125
    ],
    [
      "renverser",
      0.005
    ],
    [
      "rembarrer",
      0.005
    ],
    [
      "projeter",
      0.005
    ],
    [
      "procurer",
      0.005
    ],
    [
      "hisser",
      0.005
    ],
    [
      "deputer",
      0.005
    ],
    [
      "elire",
      0.005
    ]
  ],
  "boom": [
    [
      "expansion",
      0.165
    ],
    [
      "accroissement",
      0.11
    ],
    [
      "hausse",
      0.11
    ],
    [
      "reclame",
      0.055
    ],
    [
      "relance",
      0.055
    ],
    [
      "publicite",
      0.055
    ],
    [
      "prosperite",
      0.055
    ],
    [
      "parade",
      0.055
    ],
    [
      "explosion",
      0.055
    ],
    [
      "boum",
      0.055
    ],
    [
      "bond",
      0.055
    ],
    [
      "augmentation",
      0.055
    ],
    [
      "afflux",
      0.055
    ],
    [
      "solde",
      0.055
    ]
  ],
  "joker": [],
  "pacotille": [
    [
      "clinquant",
      0.2
    ],
    [
      "camelote",
      0.15
    ],
    [
      "toc",
      0.15
    ],
    [
      "quincaille",
      0.1
    ],
    [
      "salete",
      0.1
    ],
    [
      "quincaillerie",
      0.0475
    ],
    [
      "marchandise",
      0.0475
    ],
    [
      "cochonnerie",
      0.0475
    ],
    [
      "came",
      0.0475
    ],
    [
      "ballot",
      0.0475
    ],
    [
      "verroterie",
      0.0475
    ]
  ],
  "copier": [
    [
      "imiter",
      0.145
    ],
    [
      "reproduire",
      0.1
    ],
    [
      "plagier",
      0.0875
    ],
    [
      "singer",
      0.0875
    ],
    [
      "simuler",
      0.0425
    ],
    [
      "contrefaire",
      0.0425
    ],
    [
      "calquer",
      0.0425
    ],
    [
      "demarquer",
      0.0375
    ],
    [
      "emprunter",
      0.0375
    ],
    [
      "transcrire",
      0.0375
    ],
    [
      "piller",
      0.025
    ],
    [
      "pasticher",
      0.025
    ],
    [
      "noter",
      0.025
    ],
    [
      "derober",
      0.025
    ],
    [
      "mimer",
      0.0175
    ],
    [
      "voler",
      0.0175
    ],
    [
      "ecrire",
      0.01
    ],
    [
      "suivre",
      0.01
    ],
    [
      "repeter",
      0.01
    ],
    [
      "representer",
      0.01
    ],
    [
      "relever",
      0.01
    ],
    [
      "recopier",
      0.01
    ],
    [
      "marquer",
      0.01
    ],
    [
      "jouer",
      0.01
    ],
    [
      "inscrire",
      0.01
    ],
    [
      "recrire",
      0.005
    ],
    [
      "ressembler",
      0.005
    ],
    [
      "pomper",
      0.005
    ],
    [
      "grossoyer",
      0.005
    ],
    [
      "frauder",
      0.005
    ],
    [
      "expedier",
      0.005
    ],
    [
      "dupliquer",
      0.005
    ],
    [
      "conformer",
      0.005
    ],
    [
      "compiler",
      0.005
    ],
    [
      "tricher",
      0.005
    ]
  ],
  "copie": [
    [
      "imitation",
      0.1175
    ],
    [
      "reproduction",
      0.11
    ],
    [
      "double",
      0.0575
    ],
    [
      "replique",
      0.0425
    ],
    [
      "representation",
      0.035
    ],
    [
      "echo",
      0.0275
    ],
    [
      "plagiat",
      0.0275
    ],
    [
      "calque",
      0.0275
    ],
    [
      "ampliation",
      0.0275
    ],
    [
      "papier",
      0.02
    ],
    [
      "figuration",
      0.02
    ],
    [
      "faux",
      0.02
    ],
    [
      "expedition",
      0.02
    ],
    [
      "exemplaire",
      0.02
    ],
    [
      "duplicata",
      0.02
    ],
    [
      "document",
      0.02
    ],
    [
      "maquette",
      0.0125
    ],
    [
      "pastiche",
      0.0125
    ],
    [
      "repetition",
      0.0125
    ],
    [
      "texte",
      0.0125
    ],
    [
      "transcription",
      0.0125
    ],
    [
      "epreuve",
      0.0125
    ],
    [
      "manuscrit",
      0.0125
    ],
    [
      "extrait",
      0.0125
    ],
    [
      "article",
      0.0125
    ],
    [
      "centon",
      0.0125
    ],
    [
      "composition",
      0.0125
    ],
    [
      "contrefacon",
      0.0125
    ],
    [
      "dessin",
      0.0125
    ],
    [
      "inscription",
      0.005
    ],
    [
      "photocopie",
      0.005
    ],
    [
      "polycopie",
      0.005
    ],
    [
      "reduction",
      0.005
    ],
    [
      "simulacre",
      0.005
    ],
    [
      "suivisme",
      0.005
    ],
    [
      "triplicata",
      0.005
    ],
    [
      "imposture",
      0.005
    ],
    [
      "grosse",
      0.005
    ],
    [
      "feuille",
      0.005
    ],
    [
      "emprunt",
      0.005
    ],
    [
      "decalquage",
      0.005
    ],
    [
      "devoir",
      0.005
    ],
    [
      "compulsoire",
      0.005
    ],
    [
      "compilation",
      0.005
    ],
    [
      "autocopie",
      0.005
    ],
    [
      "ampliatif",
      0.005
    ],
    [
      "echantillon",
      0.005
    ]
  ],
  "bouffon": [
    [
      "turlupin",
      0.1125
    ],
    [
      "comique",
      0.075
    ],
    [
      "clown",
      0.0675
    ],
    [
      "pitre",
      0.065
    ],
    [
      "plaisant",
      0.055
    ],
    [
      "farceur",
      0.0425
    ],
    [
      "ridicule",
      0.0375
    ],
    [
      "baladin",
      0.035
    ],
    [
      "burlesque",
      0.0275
    ],
    [
      "rigolo",
      0.0275
    ],
    [
      "saltimbanque",
      0.0225
    ],
    [
      "pantin",
      0.0225
    ],
    [
      "grotesque",
      0.0225
    ],
    [
      "drole",
      0.0225
    ],
    [
      "cocasse",
      0.0175
    ],
    [
      "paillasse",
      0.0175
    ],
    [
      "risible",
      0.0175
    ],
    [
      "singe",
      0.015
    ],
    [
      "histrion",
      0.015
    ],
    [
      "cabotin",
      0.015
    ],
    [
      "amusant",
      0.015
    ],
    [
      "tordant",
      0.01
    ],
    [
      "polichinelle",
      0.01
    ],
    [
      "plaisantin",
      0.01
    ],
    [
      "fou",
      0.01
    ],
    [
      "folatre",
      0.01
    ],
    [
      "extravagant",
      0.01
    ],
    [
      "bateleur",
      0.01
    ],
    [
      "arlequin",
      0.01
    ],
    [
      "acteur",
      0.01
    ],
    [
      "personnage",
      0.0075
    ],
    [
      "luron",
      0.0075
    ],
    [
      "loustic",
      0.0075
    ],
    [
      "gugusse",
      0.0075
    ],
    [
      "bouffe",
      0.0075
    ],
    [
      "matassin",
      0.0025
    ],
    [
      "nain",
      0.0025
    ],
    [
      "pantalon",
      0.0025
    ],
    [
      "pasquin",
      0.0025
    ],
    [
      "scurrile",
      0.0025
    ],
    [
      "trivelin",
      0.0025
    ],
    [
      "grimacier",
      0.0025
    ],
    [
      "gracioso",
      0.0025
    ],
    [
      "fantaisiste",
      0.0025
    ],
    [
      "fagotin",
      0.0025
    ],
    [
      "caricatural",
      0.0025
    ],
    [
      "cabot",
      0.0025
    ],
    [
      "bobeche",
      0.0025
    ],
    [
      "blaireau",
      0.0025
    ],
    [
      "amuseur",
      0.0025
    ],
    [
      "zanni",
      0.0025
    ]
  ],
  "mousse": [
    [
      "marin",
      0.125
    ],
    [
      "matelot",
      0.125
    ],
    [
      "ecume",
      0.0625
    ],
    [
      "spumosite",
      0.0625
    ],
    [
      "neige",
      0.0625
    ],
    [
      "moussaillon",
      0.0625
    ],
    [
      "gabier",
      0.0625
    ],
    [
      "floculation",
      0.0625
    ],
    [
      "flocon",
      0.0625
    ],
    [
      "creme",
      0.0625
    ],
    [
      "bulle",
      0.0625
    ],
    [
      "bryacee",
      0.0625
    ],
    [
      "apprenti",
      0.0625
    ],
    [
      "emousse",
      0.0625
    ]
  ],
  "mousser": [
    [
      "ecumer",
      0.5
    ]
  ],
  "face": [
    [
      "visage",
      0.1125
    ],
    [
      "figure",
      0.105
    ],
    [
      "apparence",
      0.0725
    ],
    [
      "facade",
      0.055
    ],
    [
      "tete",
      0.055
    ],
    [
      "aspect",
      0.0475
    ],
    [
      "endroit",
      0.0425
    ],
    [
      "cote",
      0.035
    ],
    [
      "exterieur",
      0.035
    ],
    [
      "mine",
      0.035
    ],
    [
      "tournure",
      0.035
    ],
    [
      "physionomie",
      0.03
    ],
    [
      "front",
      0.03
    ],
    [
      "devant",
      0.0225
    ],
    [
      "mufle",
      0.0225
    ],
    [
      "point",
      0.0225
    ],
    [
      "museau",
      0.0175
    ],
    [
      "hure",
      0.0175
    ],
    [
      "facies",
      0.0175
    ],
    [
      "trait",
      0.01
    ],
    [
      "semblance",
      0.01
    ],
    [
      "minois",
      0.01
    ],
    [
      "image",
      0.01
    ],
    [
      "groin",
      0.01
    ],
    [
      "frimousse",
      0.01
    ],
    [
      "coin",
      0.01
    ],
    [
      "angle",
      0.01
    ],
    [
      "obvers",
      0.005
    ],
    [
      "paroi",
      0.005
    ],
    [
      "sens",
      0.005
    ],
    [
      "surface",
      0.005
    ],
    [
      "gueule",
      0.005
    ],
    [
      "frontispice",
      0.005
    ],
    [
      "facette",
      0.005
    ],
    [
      "devanture",
      0.005
    ],
    [
      "croix",
      0.005
    ],
    [
      "couture",
      0.005
    ],
    [
      "avers",
      0.005
    ],
    [
      "versant",
      0.005
    ]
  ],
  "boots": [
    [
      "botte",
      0.25
    ],
    [
      "bottillon",
      0.25
    ],
    [
      "bottine",
      0.25
    ],
    [
      "chaussure",
      0.25
    ]
  ],
  "mister": [],
  "testament": [
    [
      "disposition",
      0.2
    ],
    [
      "donation",
      0.2
    ],
    [
      "legs",
      0.2
    ],
    [
      "succession",
      0.2
    ],
    [
      "acte",
      0.1
    ],
    [
      "heritage",
      0.1
    ]
  ],
  "piler": [
    [
      "battre",
      0.1325
    ],
    [
      "broyer",
      0.1325
    ],
    [
      "ecraser",
      0.1325
    ],
    [
      "pulveriser",
      0.1125
    ],
    [
      "triturer",
      0.055
    ],
    [
      "rosser",
      0.055
    ],
    [
      "moudre",
      0.055
    ],
    [
      "enfoncer",
      0.055
    ],
    [
      "concasser",
      0.055
    ],
    [
      "casser",
      0.055
    ],
    [
      "surclasser",
      0.0175
    ],
    [
      "infester",
      0.0175
    ],
    [
      "corroyer",
      0.0175
    ],
    [
      "cogner",
      0.0175
    ],
    [
      "attenuer",
      0.0175
    ],
    [
      "egruger",
      0.0175
    ]
  ],
  "volee": [
    [
      "derober",
      0.085
    ],
    [
      "prendre",
      0.0625
    ],
    [
      "enlever",
      0.035
    ],
    [
      "piquer",
      0.03
    ],
    [
      "escroquer",
      0.03
    ],
    [
      "soustraire",
      0.03
    ],
    [
      "piller",
      0.0275
    ],
    [
      "attraper",
      0.025
    ],
    [
      "chiper",
      0.0225
    ],
    [
      "depouiller",
      0.0225
    ],
    [
      "faucher",
      0.0225
    ],
    [
      "s'approprier",
      0.0225
    ],
    [
      "tromper",
      0.0225
    ],
    [
      "courir",
      0.0175
    ],
    [
      "ravir",
      0.0175
    ],
    [
      "rouler",
      0.0175
    ],
    [
      "s'emparer",
      0.015
    ],
    [
      "detourner",
      0.0125
    ],
    [
      "exploiter",
      0.0125
    ],
    [
      "extorquer",
      0.0125
    ],
    [
      "refaire",
      0.0125
    ],
    [
      "subtiliser",
      0.0125
    ],
    [
      "plagier",
      0.01
    ],
    [
      "choper",
      0.01
    ],
    [
      "carotter",
      0.01
    ],
    [
      "chaparder",
      0.01
    ],
    [
      "estamper",
      0.01
    ],
    [
      "gruger",
      0.01
    ],
    [
      "tirer",
      0.0075
    ],
    [
      "s'elancer",
      0.0075
    ],
    [
      "kidnapper",
      0.0075
    ],
    [
      "grappiller",
      0.0075
    ],
    [
      "filouter",
      0.0075
    ],
    [
      "emporter",
      0.0075
    ],
    [
      "devaliser",
      0.0075
    ],
    [
      "barboter",
      0.0075
    ],
    [
      "s'envoler",
      0.0075
    ],
    [
      "soutirer",
      0.0075
    ],
    [
      "spolier",
      0.0075
    ],
    [
      "tondre",
      0.0075
    ],
    [
      "ecorcher",
      0.0075
    ],
    [
      "rafler",
      0.0075
    ],
    [
      "marauder",
      0.0075
    ],
    [
      "gratter",
      0.0075
    ],
    [
      "foncer",
      0.0075
    ],
    [
      "filer",
      0.0075
    ],
    [
      "chauffer",
      0.0075
    ],
    [
      "aller",
      0.0075
    ],
    [
      "voltiger",
      0.005
    ],
    [
      "s'elever",
      0.005
    ],
    [
      "ratiboiser",
      0.005
    ],
    [
      "monter",
      0.005
    ],
    [
      "frustrer",
      0.005
    ],
    [
      "flouer",
      0.005
    ],
    [
      "escamoter",
      0.005
    ],
    [
      "naviguer",
      0.0025
    ],
    [
      "planer",
      0.0025
    ],
    [
      "priver",
      0.0025
    ],
    [
      "ranconner",
      0.0025
    ],
    [
      "sevrer",
      0.0025
    ],
    [
      "usurper",
      0.0025
    ],
    [
      "voleter",
      0.0025
    ],
    [
      "etriller",
      0.0025
    ],
    [
      "fuir",
      0.0025
    ],
    [
      "flotter",
      0.0025
    ],
    [
      "flamber",
      0.0025
    ],
    [
      "bondir",
      0.0025
    ],
    [
      "copier",
      0.0025
    ],
    [
      "cueillir",
      0.0025
    ],
    [
      "demunir",
      0.0025
    ],
    [
      "deposseder",
      0.0025
    ],
    [
      "detrousser",
      0.0025
    ],
    [
      "empiler",
      0.0025
    ],
    [
      "emprunter",
      0.0025
    ],
    [
      "piper",
      0.0025
    ],
    [
      "poursuivre",
      0.0025
    ],
    [
      "repasser",
      0.0025
    ],
    [
      "s'enfuir",
      0.0025
    ],
    [
      "soulager",
      0.0025
    ],
    [
      "matraquer",
      0.0025
    ],
    [
      "arnaquer",
      0.0025
    ],
    [
      "butiner",
      0.0025
    ],
    [
      "cambrioler",
      0.0025
    ],
    [
      "confisquer",
      0.0025
    ],
    [
      "distraire",
      0.0025
    ],
    [
      "delester",
      0.0025
    ],
    [
      "demarquer",
      0.0025
    ],
    [
      "empaumer",
      0.0025
    ],
    [
      "larronner",
      0.0
    ],
    [
      "papillonner",
      0.0
    ],
    [
      "pointer",
      0.0
    ],
    [
      "rapiner",
      0.0
    ],
    [
      "rifler",
      0.0
    ],
    [
      "s'attribuer",
      0.0
    ],
    [
      "survoler",
      0.0
    ],
    [
      "tournoyer",
      0.0
    ],
    [
      "griveler",
      0.0
    ],
    [
      "grincher",
      0.0
    ],
    [
      "friponner",
      0.0
    ],
    [
      "alleger",
      0.0
    ],
    [
      "arranger",
      0.0
    ],
    [
      "brigander",
      0.0
    ],
    [
      "calotter",
      0.0
    ],
    [
      "chouraver",
      0.0
    ],
    [
      "cravater",
      0.0
    ],
    [
      "emmener",
      0.0
    ],
    [
      "entoler",
      0.0
    ],
    [
      "flibuster",
      0.0
    ],
    [
      "etouffer",
      0.0
    ]
  ],
  "flasher": [],
  "depasse": [
    [
      "passer",
      0.0825
    ],
    [
      "devancer",
      0.0775
    ],
    [
      "outrepasser",
      0.0775
    ],
    [
      "surpasser",
      0.07
    ],
    [
      "deborder",
      0.0475
    ],
    [
      "avancer",
      0.04
    ],
    [
      "franchir",
      0.04
    ],
    [
      "sortir",
      0.04
    ],
    [
      "surmonter",
      0.035
    ],
    [
      "distancer",
      0.035
    ],
    [
      "exceder",
      0.0275
    ],
    [
      "gratter",
      0.0275
    ],
    [
      "l'emporter",
      0.0275
    ],
    [
      "mordre",
      0.0275
    ],
    [
      "ressortir",
      0.0275
    ],
    [
      "saillir",
      0.0275
    ],
    [
      "transgresser",
      0.02
    ],
    [
      "surclasser",
      0.02
    ],
    [
      "exagerer",
      0.02
    ],
    [
      "battre",
      0.02
    ],
    [
      "surplomber",
      0.0125
    ],
    [
      "semer",
      0.0125
    ],
    [
      "rencherir",
      0.0125
    ],
    [
      "lacher",
      0.0125
    ],
    [
      "griller",
      0.0125
    ],
    [
      "empieter",
      0.0125
    ],
    [
      "doubler",
      0.0125
    ],
    [
      "dominer",
      0.0125
    ],
    [
      "s'oublier",
      0.005
    ],
    [
      "s'avancer",
      0.005
    ],
    [
      "preceder",
      0.005
    ],
    [
      "interloquer",
      0.005
    ],
    [
      "encherir",
      0.005
    ],
    [
      "confondre",
      0.005
    ],
    [
      "briser",
      0.005
    ],
    [
      "etonner",
      0.005
    ]
  ],
  "depasser": [
    [
      "passer",
      0.0825
    ],
    [
      "devancer",
      0.0775
    ],
    [
      "outrepasser",
      0.0775
    ],
    [
      "surpasser",
      0.07
    ],
    [
      "deborder",
      0.0475
    ],
    [
      "avancer",
      0.04
    ],
    [
      "franchir",
      0.04
    ],
    [
      "sortir",
      0.04
    ],
    [
      "surmonter",
      0.035
    ],
    [
      "distancer",
      0.035
    ],
    [
      "exceder",
      0.0275
    ],
    [
      "gratter",
      0.0275
    ],
    [
      "l'emporter",
      0.0275
    ],
    [
      "mordre",
      0.0275
    ],
    [
      "ressortir",
      0.0275
    ],
    [
      "saillir",
      0.0275
    ],
    [
      "transgresser",
      0.02
    ],
    [
      "surclasser",
      0.02
    ],
    [
      "exagerer",
      0.02
    ],
    [
      "battre",
      0.02
    ],
    [
      "surplomber",
      0.0125
    ],
    [
      "semer",
      0.0125
    ],
    [
      "rencherir",
      0.0125
    ],
    [
      "lacher",
      0.0125
    ],
    [
      "griller",
      0.0125
    ],
    [
      "empieter",
      0.0125
    ],
    [
      "doubler",
      0.0125
    ],
    [
      "dominer",
      0.0125
    ],
    [
      "s'oublier",
      0.005
    ],
    [
      "s'avancer",
      0.005
    ],
    [
      "preceder",
      0.005
    ],
    [
      "interloquer",
      0.005
    ],
    [
      "encherir",
      0.005
    ],
    [
      "confondre",
      0.005
    ],
    [
      "briser",
      0.005
    ],
    [
      "etonner",
      0.005
    ]
  ],
  "cavalier": [
    [
      "desinvolte",
      0.0625
    ],
    [
      "impertinent",
      0.0575
    ],
    [
      "soldat",
      0.045
    ],
    [
      "degage",
      0.0375
    ],
    [
      "impoli",
      0.0375
    ],
    [
      "insolent",
      0.0375
    ],
    [
      "libre",
      0.0375
    ],
    [
      "leste",
      0.03
    ],
    [
      "inconvenant",
      0.03
    ],
    [
      "aise",
      0.025
    ],
    [
      "galant",
      0.025
    ],
    [
      "hardi",
      0.025
    ],
    [
      "ecuyer",
      0.0175
    ],
    [
      "effronte",
      0.0175
    ],
    [
      "dragon",
      0.0175
    ],
    [
      "chevalier",
      0.0175
    ],
    [
      "carabinier",
      0.0175
    ],
    [
      "audacieux",
      0.0175
    ],
    [
      "arrogant",
      0.0175
    ],
    [
      "elegant",
      0.0125
    ],
    [
      "uhlan",
      0.0125
    ],
    [
      "souple",
      0.0125
    ],
    [
      "sigisbee",
      0.0125
    ],
    [
      "reitre",
      0.0125
    ],
    [
      "noble",
      0.0125
    ],
    [
      "guide",
      0.0125
    ],
    [
      "gendarme",
      0.0125
    ],
    [
      "crampillon",
      0.0125
    ],
    [
      "cosaque",
      0.0125
    ],
    [
      "argoulet",
      0.0125
    ],
    [
      "partenaire",
      0.005
    ],
    [
      "mousquetaire",
      0.005
    ],
    [
      "mamelouk",
      0.005
    ],
    [
      "lancier",
      0.005
    ],
    [
      "jockey",
      0.005
    ],
    [
      "inelegant",
      0.005
    ],
    [
      "picador",
      0.005
    ],
    [
      "polaque",
      0.005
    ],
    [
      "postier",
      0.005
    ],
    [
      "postillon",
      0.005
    ],
    [
      "retranchement",
      0.005
    ],
    [
      "rogue",
      0.005
    ],
    [
      "seigneur",
      0.005
    ],
    [
      "spahi",
      0.005
    ],
    [
      "eclaireur",
      0.005
    ],
    [
      "hussard",
      0.005
    ],
    [
      "hautain",
      0.005
    ],
    [
      "goumier",
      0.005
    ],
    [
      "brusque",
      0.005
    ],
    [
      "carabin",
      0.005
    ],
    [
      "chasseur",
      0.005
    ],
    [
      "clou",
      0.005
    ],
    [
      "cornette",
      0.005
    ],
    [
      "cuirassier",
      0.005
    ],
    [
      "danseur",
      0.005
    ],
    [
      "deblai",
      0.005
    ],
    [
      "estradiot",
      0.005
    ],
    [
      "familier",
      0.005
    ],
    [
      "gentilhomme",
      0.005
    ],
    [
      "agrafe",
      0.005
    ]
  ],
  "pis": [
    [
      "mamelle",
      0.285
    ],
    [
      "sein",
      0.285
    ],
    [
      "pire",
      0.1425
    ],
    [
      "poitrine",
      0.1425
    ],
    [
      "tetine",
      0.1425
    ]
  ],
  "killer": [],
  "piller": [
    [
      "voler",
      0.15
    ],
    [
      "derober",
      0.09
    ],
    [
      "plagier",
      0.0825
    ],
    [
      "prendre",
      0.075
    ],
    [
      "soustraire",
      0.04
    ],
    [
      "s'approprier",
      0.0325
    ],
    [
      "depouiller",
      0.0325
    ],
    [
      "demarquer",
      0.0325
    ],
    [
      "copier",
      0.0325
    ],
    [
      "saccager",
      0.025
    ],
    [
      "ravir",
      0.025
    ],
    [
      "ravager",
      0.025
    ],
    [
      "imiter",
      0.025
    ],
    [
      "devaster",
      0.025
    ],
    [
      "devaliser",
      0.025
    ],
    [
      "detourner",
      0.025
    ],
    [
      "ecumer",
      0.015
    ],
    [
      "singer",
      0.015
    ],
    [
      "razzier",
      0.015
    ],
    [
      "marauder",
      0.015
    ],
    [
      "infester",
      0.015
    ],
    [
      "emporter",
      0.015
    ],
    [
      "devorer",
      0.015
    ],
    [
      "detrousser",
      0.015
    ],
    [
      "compiler",
      0.015
    ],
    [
      "butiner",
      0.015
    ],
    [
      "vider",
      0.0075
    ],
    [
      "usurper",
      0.0075
    ],
    [
      "rapiner",
      0.0075
    ],
    [
      "pirater",
      0.0075
    ],
    [
      "extorquer",
      0.0075
    ],
    [
      "distraire",
      0.0075
    ],
    [
      "assaillir",
      0.0075
    ],
    [
      "ecremer",
      0.0075
    ]
  ],
  "shooter": [
    [
      "tirer",
      0.5
    ],
    [
      "botter",
      0.25
    ],
    [
      "degager",
      0.25
    ]
  ],
  "cribler": [
    [
      "tamiser",
      0.1175
    ],
    [
      "battre",
      0.0875
    ],
    [
      "trier",
      0.0875
    ],
    [
      "transpercer",
      0.0575
    ],
    [
      "separer",
      0.0575
    ],
    [
      "piquer",
      0.0575
    ],
    [
      "percer",
      0.0575
    ],
    [
      "passer",
      0.0575
    ],
    [
      "nettoyer",
      0.0575
    ],
    [
      "frapper",
      0.0575
    ],
    [
      "bombarder",
      0.0575
    ],
    [
      "accabler",
      0.0575
    ],
    [
      "sasser",
      0.0275
    ],
    [
      "piqueter",
      0.0275
    ],
    [
      "demeler",
      0.0275
    ],
    [
      "distinguer",
      0.0275
    ],
    [
      "couvrir",
      0.0275
    ],
    [
      "epurer",
      0.0275
    ]
  ],
  "chou": [
    [
      "mignon",
      0.25
    ],
    [
      "adorable",
      0.125
    ],
    [
      "biquet",
      0.125
    ],
    [
      "bouffette",
      0.125
    ],
    [
      "choupette",
      0.125
    ],
    [
      "ruban",
      0.125
    ],
    [
      "trognon",
      0.125
    ]
  ],
  "fureur": [
    [
      "frenesie",
      0.115
    ],
    [
      "passion",
      0.0825
    ],
    [
      "exaltation",
      0.065
    ],
    [
      "emportement",
      0.0625
    ],
    [
      "delire",
      0.045
    ],
    [
      "ardeur",
      0.0425
    ],
    [
      "rage",
      0.0425
    ],
    [
      "violence",
      0.04
    ],
    [
      "agitation",
      0.03
    ],
    [
      "bouillonnement",
      0.03
    ],
    [
      "furie",
      0.03
    ],
    [
      "transport",
      0.03
    ],
    [
      "manie",
      0.025
    ],
    [
      "impetuosite",
      0.025
    ],
    [
      "enthousiasme",
      0.025
    ],
    [
      "dechainement",
      0.025
    ],
    [
      "fanatisme",
      0.02
    ],
    [
      "folie",
      0.02
    ],
    [
      "colere",
      0.0175
    ],
    [
      "acharnement",
      0.015
    ],
    [
      "haine",
      0.0125
    ],
    [
      "emotion",
      0.0125
    ],
    [
      "egarement",
      0.01
    ],
    [
      "mode",
      0.01
    ],
    [
      "ferocite",
      0.01
    ],
    [
      "exasperation",
      0.01
    ],
    [
      "aprete",
      0.0075
    ],
    [
      "travers",
      0.0075
    ],
    [
      "tic",
      0.0075
    ],
    [
      "ouragan",
      0.0075
    ],
    [
      "habitude",
      0.0075
    ],
    [
      "demangeaison",
      0.0075
    ],
    [
      "vogue",
      0.0025
    ],
    [
      "succes",
      0.0025
    ],
    [
      "ivresse",
      0.0025
    ],
    [
      "intolerance",
      0.0025
    ],
    [
      "incendie",
      0.0025
    ],
    [
      "engouement",
      0.0025
    ],
    [
      "demence",
      0.0025
    ],
    [
      "brutalite",
      0.0025
    ],
    [
      "alienation",
      0.0025
    ],
    [
      "paroxysme",
      0.0
    ],
    [
      "mecontentement",
      0.0
    ],
    [
      "inspiration",
      0.0
    ],
    [
      "hysterie",
      0.0
    ],
    [
      "furia",
      0.0
    ],
    [
      "envie",
      0.0
    ],
    [
      "cours",
      0.0
    ],
    [
      "courroux",
      0.0
    ],
    [
      "combat",
      0.0
    ],
    [
      "possession",
      0.0
    ]
  ],
  "dragon": [
    [
      "cavalier",
      0.0875
    ],
    [
      "demon",
      0.0875
    ],
    [
      "serpent",
      0.0875
    ],
    [
      "megere",
      0.0575
    ],
    [
      "furie",
      0.0575
    ],
    [
      "diable",
      0.0575
    ],
    [
      "gardien",
      0.0275
    ],
    [
      "grenadier",
      0.0275
    ],
    [
      "guivre",
      0.0275
    ],
    [
      "genie",
      0.0275
    ],
    [
      "harengere",
      0.0275
    ],
    [
      "hydre",
      0.0275
    ],
    [
      "portier",
      0.0275
    ],
    [
      "tarasque",
      0.0275
    ],
    [
      "dree",
      0.0275
    ],
    [
      "dragonneau",
      0.0275
    ],
    [
      "dragonnade",
      0.0275
    ],
    [
      "argoulet",
      0.0275
    ],
    [
      "carabin",
      0.0275
    ],
    [
      "cerbere",
      0.0275
    ],
    [
      "chimere",
      0.0275
    ],
    [
      "crapaud",
      0.0275
    ],
    [
      "cuirassier",
      0.0275
    ],
    [
      "diablesse",
      0.0275
    ],
    [
      "drac",
      0.0275
    ],
    [
      "virago",
      0.0275
    ]
  ],
  "viser": [
    [
      "desirer",
      0.09
    ],
    [
      "regarder",
      0.0775
    ],
    [
      "ambitionner",
      0.055
    ],
    [
      "chercher",
      0.0475
    ],
    [
      "rechercher",
      0.0475
    ],
    [
      "vouloir",
      0.0475
    ],
    [
      "souhaiter",
      0.04
    ],
    [
      "lorgner",
      0.04
    ],
    [
      "briguer",
      0.035
    ],
    [
      "pretendre",
      0.035
    ],
    [
      "rever",
      0.035
    ],
    [
      "voir",
      0.0275
    ],
    [
      "tendre",
      0.0275
    ],
    [
      "poursuivre",
      0.0275
    ],
    [
      "examiner",
      0.0275
    ],
    [
      "convoiter",
      0.0275
    ],
    [
      "emarger",
      0.02
    ],
    [
      "toucher",
      0.02
    ],
    [
      "mater",
      0.02
    ],
    [
      "interesser",
      0.02
    ],
    [
      "zieuter",
      0.0125
    ],
    [
      "signer",
      0.0125
    ],
    [
      "s'efforcer",
      0.0125
    ],
    [
      "s'attacher",
      0.0125
    ],
    [
      "s'appliquer",
      0.0125
    ],
    [
      "guigner",
      0.0125
    ],
    [
      "concerner",
      0.0125
    ],
    [
      "debarrasser",
      0.005
    ],
    [
      "mirer",
      0.005
    ],
    [
      "pointer",
      0.005
    ],
    [
      "rechasser",
      0.005
    ],
    [
      "tacher",
      0.005
    ],
    [
      "coucher",
      0.005
    ],
    [
      "citer",
      0.005
    ],
    [
      "bornoyer",
      0.005
    ],
    [
      "aviser",
      0.005
    ],
    [
      "authentifier",
      0.005
    ],
    [
      "apostiller",
      0.005
    ],
    [
      "ajuster",
      0.005
    ],
    [
      "valider",
      0.005
    ]
  ],
  "mile": [
    [
      "mille",
      1.0
    ]
  ],
  "expert": [
    [
      "habile",
      0.18
    ],
    [
      "experimente",
      0.0975
    ],
    [
      "capable",
      0.065
    ],
    [
      "competent",
      0.065
    ],
    [
      "exerce",
      0.06
    ],
    [
      "savant",
      0.0525
    ],
    [
      "verse",
      0.0425
    ],
    [
      "maitre",
      0.035
    ],
    [
      "averti",
      0.035
    ],
    [
      "connaisseur",
      0.03
    ],
    [
      "propre",
      0.03
    ],
    [
      "sur",
      0.03
    ],
    [
      "virtuose",
      0.02
    ],
    [
      "rompu",
      0.02
    ],
    [
      "entraine",
      0.02
    ],
    [
      "bon",
      0.02
    ],
    [
      "appreciateur",
      0.02
    ],
    [
      "adroit",
      0.02
    ],
    [
      "eprouve",
      0.0125
    ],
    [
      "juge",
      0.0125
    ],
    [
      "instruit",
      0.0125
    ],
    [
      "gourmet",
      0.0125
    ],
    [
      "chevronne",
      0.0125
    ],
    [
      "arbitre",
      0.0125
    ],
    [
      "aristarque",
      0.005
    ],
    [
      "assure",
      0.005
    ],
    [
      "clerc",
      0.005
    ],
    [
      "estimateur",
      0.005
    ],
    [
      "forme",
      0.005
    ],
    [
      "vigilant",
      0.005
    ]
  ],
  "balistique": [
    [
      "astronautique",
      0.2
    ],
    [
      "cinematique",
      0.2
    ],
    [
      "cinetique",
      0.2
    ],
    [
      "dynamique",
      0.2
    ],
    [
      "mecanique",
      0.2
    ]
  ],
  "baliser": [
    [
      "marquer",
      0.2275
    ],
    [
      "jalonner",
      0.1825
    ],
    [
      "piqueter",
      0.135
    ],
    [
      "tracer",
      0.09
    ],
    [
      "ponctuer",
      0.09
    ],
    [
      "indiquer",
      0.09
    ],
    [
      "flecher",
      0.0425
    ],
    [
      "reperer",
      0.0425
    ],
    [
      "signaler",
      0.0425
    ],
    [
      "signaliser",
      0.0425
    ]
  ],
  "balise": [
    [
      "feu",
      0.1875
    ],
    [
      "balisage",
      0.125
    ],
    [
      "bouee",
      0.125
    ],
    [
      "marque",
      0.125
    ],
    [
      "poteau",
      0.0625
    ],
    [
      "phare",
      0.0625
    ],
    [
      "perche",
      0.0625
    ],
    [
      "jalon",
      0.0625
    ],
    [
      "espar",
      0.0625
    ],
    [
      "clignotant",
      0.0625
    ],
    [
      "signal",
      0.0625
    ]
  ],
  "steak": [
    [
      "bifteck",
      0.4
    ],
    [
      "carbonade",
      0.2
    ],
    [
      "chateaubriand",
      0.2
    ],
    [
      "grillade",
      0.2
    ]
  ],
  "courant": [
    [
      "ordinaire",
      0.125
    ],
    [
      "commun",
      0.0875
    ],
    [
      "habituel",
      0.075
    ],
    [
      "banal",
      0.0425
    ],
    [
      "cours",
      0.0425
    ],
    [
      "vulgaire",
      0.0375
    ],
    [
      "mouvement",
      0.0375
    ],
    [
      "simple",
      0.025
    ],
    [
      "quotidien",
      0.025
    ],
    [
      "quelconque",
      0.025
    ],
    [
      "moyen",
      0.025
    ],
    [
      "flot",
      0.025
    ],
    [
      "familier",
      0.025
    ],
    [
      "usuel",
      0.0175
    ],
    [
      "usite",
      0.0175
    ],
    [
      "trivial",
      0.0175
    ],
    [
      "normal",
      0.0175
    ],
    [
      "marche",
      0.0175
    ],
    [
      "frequent",
      0.0175
    ],
    [
      "fil",
      0.0175
    ],
    [
      "facile",
      0.0175
    ],
    [
      "connu",
      0.0175
    ],
    [
      "classique",
      0.0175
    ],
    [
      "vent",
      0.0125
    ],
    [
      "torrent",
      0.0125
    ],
    [
      "succession",
      0.0125
    ],
    [
      "repandu",
      0.0125
    ],
    [
      "progression",
      0.0125
    ],
    [
      "force",
      0.0125
    ],
    [
      "accoutume",
      0.0125
    ],
    [
      "progres",
      0.005
    ],
    [
      "present",
      0.005
    ],
    [
      "souffle",
      0.005
    ],
    [
      "standard",
      0.005
    ],
    [
      "train",
      0.005
    ],
    [
      "vernaculaire",
      0.005
    ],
    [
      "electricite",
      0.005
    ],
    [
      "emigration",
      0.005
    ],
    [
      "immigration",
      0.005
    ],
    [
      "general",
      0.005
    ],
    [
      "fluide",
      0.005
    ],
    [
      "abondant",
      0.005
    ],
    [
      "actuel",
      0.005
    ],
    [
      "chenal",
      0.005
    ],
    [
      "circulation",
      0.005
    ],
    [
      "corde",
      0.005
    ],
    [
      "entrainement",
      0.005
    ],
    [
      "evolution",
      0.005
    ]
  ],
  "mouvement": [
    [
      "agitation",
      0.0625
    ],
    [
      "remous",
      0.035
    ],
    [
      "ardeur",
      0.03
    ],
    [
      "bouillonnement",
      0.03
    ],
    [
      "elan",
      0.0275
    ],
    [
      "animation",
      0.025
    ],
    [
      "trouble",
      0.025
    ],
    [
      "passion",
      0.02
    ],
    [
      "marche",
      0.02
    ],
    [
      "effervescence",
      0.02
    ],
    [
      "emotion",
      0.0175
    ],
    [
      "soulevement",
      0.015
    ],
    [
      "vivacite",
      0.015
    ],
    [
      "revolte",
      0.015
    ],
    [
      "fougue",
      0.015
    ],
    [
      "enthousiasme",
      0.015
    ],
    [
      "activite",
      0.015
    ],
    [
      "changement",
      0.0125
    ],
    [
      "oscillation",
      0.0125
    ],
    [
      "transport",
      0.0125
    ],
    [
      "evolution",
      0.01
    ],
    [
      "vie",
      0.01
    ],
    [
      "turbulence",
      0.01
    ],
    [
      "secousse",
      0.01
    ],
    [
      "action",
      0.01
    ],
    [
      "tendance",
      0.01
    ],
    [
      "sentiment",
      0.01
    ],
    [
      "impulsion",
      0.01
    ],
    [
      "fluctuation",
      0.01
    ],
    [
      "flot",
      0.01
    ],
    [
      "cours",
      0.01
    ],
    [
      "branle",
      0.01
    ],
    [
      "emeute",
      0.0075
    ],
    [
      "rythme",
      0.0075
    ],
    [
      "course",
      0.0075
    ],
    [
      "ballottement",
      0.0075
    ],
    [
      "variation",
      0.0075
    ],
    [
      "mobilite",
      0.0075
    ],
    [
      "courant",
      0.0075
    ],
    [
      "caprice",
      0.0075
    ],
    [
      "allure",
      0.0075
    ],
    [
      "train",
      0.005
    ],
    [
      "remuement",
      0.005
    ],
    [
      "petulance",
      0.005
    ],
    [
      "geste",
      0.005
    ],
    [
      "flux",
      0.005
    ],
    [
      "entrain",
      0.005
    ],
    [
      "desordre",
      0.005
    ],
    [
      "deplacement",
      0.005
    ],
    [
      "demarche",
      0.005
    ],
    [
      "circulation",
      0.005
    ],
    [
      "bousculade",
      0.005
    ],
    [
      "insurrection",
      0.005
    ],
    [
      "progres",
      0.005
    ],
    [
      "toquade",
      0.005
    ],
    [
      "vague",
      0.005
    ],
    [
      "fermentation",
      0.005
    ],
    [
      "entrainement",
      0.005
    ],
    [
      "developpement",
      0.005
    ],
    [
      "dynamisme",
      0.005
    ],
    [
      "cadence",
      0.005
    ],
    [
      "brimbalement",
      0.005
    ],
    [
      "amour",
      0.005
    ],
    [
      "position",
      0.0025
    ],
    [
      "poussee",
      0.0025
    ],
    [
      "reflux",
      0.0025
    ],
    [
      "sedition",
      0.0025
    ],
    [
      "tourbillon",
      0.0025
    ],
    [
      "trafic",
      0.0025
    ],
    [
      "pas",
      0.0025
    ],
    [
      "manoeuvre",
      0.0025
    ],
    [
      "affection",
      0.0025
    ],
    [
      "attitude",
      0.0025
    ],
    [
      "chute",
      0.0025
    ],
    [
      "cohue",
      0.0025
    ],
    [
      "devenir",
      0.0025
    ],
    [
      "exercice",
      0.0025
    ],
    [
      "ondulation",
      0.0
    ],
    [
      "processus",
      0.0
    ],
    [
      "progression",
      0.0
    ],
    [
      "roulis",
      0.0
    ],
    [
      "saute",
      0.0
    ],
    [
      "temps",
      0.0
    ],
    [
      "trajet",
      0.0
    ],
    [
      "tressaillement",
      0.0
    ],
    [
      "vacillation",
      0.0
    ],
    [
      "ecole",
      0.0
    ],
    [
      "ecoulement",
      0.0
    ],
    [
      "elevation",
      0.0
    ],
    [
      "emoi",
      0.0
    ],
    [
      "mutinerie",
      0.0
    ],
    [
      "maree",
      0.0
    ],
    [
      "immigration",
      0.0
    ],
    [
      "accident",
      0.0
    ],
    [
      "baisse",
      0.0
    ],
    [
      "battement",
      0.0
    ],
    [
      "bouffee",
      0.0
    ],
    [
      "boutade",
      0.0
    ],
    [
      "branlement",
      0.0
    ],
    [
      "cahot",
      0.0
    ],
    [
      "cahotement",
      0.0
    ],
    [
      "grouillement",
      0.0
    ],
    [
      "fonctionnement",
      0.0
    ],
    [
      "effusion",
      0.0
    ],
    [
      "convulsion",
      0.0
    ],
    [
      "comportement",
      0.0
    ],
    [
      "mecanisme",
      0.0
    ],
    [
      "nomination",
      0.0
    ],
    [
      "parti",
      0.0
    ],
    [
      "partie",
      0.0
    ],
    [
      "presse",
      0.0
    ],
    [
      "promotion",
      0.0
    ],
    [
      "relief",
      0.0
    ],
    [
      "reflexe",
      0.0
    ],
    [
      "tempo",
      0.0
    ],
    [
      "trajectoire",
      0.0
    ],
    [
      "tremoussement",
      0.0
    ],
    [
      "mouvant",
      0.0
    ],
    [
      "motion",
      0.0
    ],
    [
      "aspiration",
      0.0
    ],
    [
      "compassion",
      0.0
    ],
    [
      "cri",
      0.0
    ],
    [
      "crispation",
      0.0
    ],
    [
      "envolee",
      0.0
    ],
    [
      "gesticulation",
      0.0
    ],
    [
      "gymnastique",
      0.0
    ],
    [
      "harmonie",
      0.0
    ],
    [
      "mesure",
      0.0
    ],
    [
      "mimique",
      0.0
    ],
    [
      "motilite",
      0.0
    ],
    [
      "valse",
      0.0
    ]
  ],
  "score": [
    [
      "marque",
      0.5
    ],
    [
      "resultat",
      0.5
    ]
  ],
  "appel": [
    [
      "avertissement",
      0.0575
    ],
    [
      "demande",
      0.0575
    ],
    [
      "invitation",
      0.045
    ],
    [
      "sollicitation",
      0.0375
    ],
    [
      "revendication",
      0.0375
    ],
    [
      "requete",
      0.0375
    ],
    [
      "cri",
      0.0375
    ],
    [
      "convocation",
      0.0325
    ],
    [
      "desir",
      0.0275
    ],
    [
      "sommation",
      0.02
    ],
    [
      "soif",
      0.02
    ],
    [
      "signal",
      0.02
    ],
    [
      "rappel",
      0.02
    ],
    [
      "priere",
      0.02
    ],
    [
      "excitation",
      0.02
    ],
    [
      "attrait",
      0.02
    ],
    [
      "voix",
      0.015
    ],
    [
      "supplication",
      0.015
    ],
    [
      "reclamation",
      0.015
    ],
    [
      "recours",
      0.015
    ],
    [
      "provocation",
      0.015
    ],
    [
      "pourvoi",
      0.015
    ],
    [
      "invite",
      0.015
    ],
    [
      "incitation",
      0.015
    ],
    [
      "alarme",
      0.015
    ],
    [
      "attaque",
      0.015
    ],
    [
      "cloche",
      0.015
    ],
    [
      "exhortation",
      0.015
    ],
    [
      "impulsion",
      0.015
    ],
    [
      "tentation",
      0.01
    ],
    [
      "signe",
      0.01
    ],
    [
      "sifflet",
      0.01
    ],
    [
      "protestation",
      0.01
    ],
    [
      "mobilisation",
      0.01
    ],
    [
      "harangue",
      0.01
    ],
    [
      "attirance",
      0.01
    ],
    [
      "aspiration",
      0.01
    ],
    [
      "oeillade",
      0.005
    ],
    [
      "levee",
      0.005
    ],
    [
      "invocation",
      0.005
    ],
    [
      "intimation",
      0.005
    ],
    [
      "interrogation",
      0.005
    ],
    [
      "proclamation",
      0.005
    ],
    [
      "recensement",
      0.005
    ],
    [
      "recrutement",
      0.005
    ],
    [
      "revision",
      0.005
    ],
    [
      "saisine",
      0.005
    ],
    [
      "sonnerie",
      0.005
    ],
    [
      "sonnette",
      0.005
    ],
    [
      "vocation",
      0.005
    ],
    [
      "interjection",
      0.005
    ],
    [
      "incorporation",
      0.005
    ],
    [
      "apostrophe",
      0.005
    ],
    [
      "appeau",
      0.005
    ],
    [
      "appellation",
      0.005
    ],
    [
      "batterie",
      0.005
    ],
    [
      "beuglement",
      0.005
    ],
    [
      "bramement",
      0.005
    ],
    [
      "butoir",
      0.005
    ],
    [
      "cartel",
      0.005
    ],
    [
      "communication",
      0.005
    ],
    [
      "defi",
      0.005
    ],
    [
      "fascination",
      0.005
    ],
    [
      "evocation",
      0.005
    ]
  ],
  "decocher": [
    [
      "envoyer",
      0.285
    ],
    [
      "flanquer",
      0.285
    ],
    [
      "adresser",
      0.1425
    ],
    [
      "decharger",
      0.1425
    ],
    [
      "lancer",
      0.1425
    ]
  ],
  "transpercer": [
    [
      "percer",
      0.245
    ],
    [
      "creuser",
      0.0575
    ],
    [
      "trouer",
      0.0575
    ],
    [
      "piquer",
      0.05
    ],
    [
      "ouvrir",
      0.0425
    ],
    [
      "penetrer",
      0.0425
    ],
    [
      "frapper",
      0.035
    ],
    [
      "forer",
      0.035
    ],
    [
      "entamer",
      0.035
    ],
    [
      "enfoncer",
      0.035
    ],
    [
      "dechirer",
      0.035
    ],
    [
      "blesser",
      0.0275
    ],
    [
      "perforer",
      0.0275
    ],
    [
      "traverser",
      0.02
    ],
    [
      "crever",
      0.02
    ],
    [
      "eventrer",
      0.0125
    ],
    [
      "tremper",
      0.0125
    ],
    [
      "transir",
      0.0125
    ],
    [
      "tarauder",
      0.0125
    ],
    [
      "sonder",
      0.0125
    ],
    [
      "poinconner",
      0.0125
    ],
    [
      "glacer",
      0.0125
    ],
    [
      "enfiler",
      0.0125
    ],
    [
      "embrocher",
      0.0125
    ],
    [
      "cribler",
      0.0125
    ],
    [
      "larder",
      0.005
    ],
    [
      "mouiller",
      0.005
    ],
    [
      "poindre",
      0.005
    ],
    [
      "pointer",
      0.005
    ],
    [
      "excaver",
      0.005
    ],
    [
      "enfourcher",
      0.005
    ],
    [
      "enferrer",
      0.005
    ],
    [
      "encorner",
      0.005
    ],
    [
      "empaler",
      0.005
    ],
    [
      "darder",
      0.005
    ],
    [
      "vriller",
      0.005
    ]
  ],
  "malveillance": [
    [
      "haine",
      0.11
    ],
    [
      "animosite",
      0.09
    ],
    [
      "ressentiment",
      0.09
    ],
    [
      "mechancete",
      0.0725
    ],
    [
      "hostilite",
      0.0725
    ],
    [
      "aigreur",
      0.0725
    ],
    [
      "fiel",
      0.055
    ],
    [
      "rosserie",
      0.035
    ],
    [
      "rancune",
      0.035
    ],
    [
      "medisance",
      0.035
    ],
    [
      "malignite",
      0.035
    ],
    [
      "inimitie",
      0.035
    ],
    [
      "calomnie",
      0.035
    ],
    [
      "antipathie",
      0.035
    ],
    [
      "agressivite",
      0.035
    ],
    [
      "sabotage",
      0.0175
    ],
    [
      "injustice",
      0.0175
    ],
    [
      "indisposition",
      0.0175
    ],
    [
      "desobligeance",
      0.0175
    ],
    [
      "diffamation",
      0.0175
    ],
    [
      "terrorisme",
      0.0175
    ]
  ],
  "employer": [
    [
      "user",
      0.11
    ],
    [
      "utiliser",
      0.1025
    ],
    [
      "prendre",
      0.0825
    ],
    [
      "appliquer",
      0.065
    ],
    [
      "pratiquer",
      0.055
    ],
    [
      "consacrer",
      0.045
    ],
    [
      "disposer",
      0.045
    ],
    [
      "mettre",
      0.045
    ],
    [
      "passer",
      0.035
    ],
    [
      "consommer",
      0.035
    ],
    [
      "occuper",
      0.025
    ],
    [
      "engager",
      0.025
    ],
    [
      "donner",
      0.025
    ],
    [
      "consumer",
      0.025
    ],
    [
      "apporter",
      0.025
    ],
    [
      "exercer",
      0.0175
    ],
    [
      "deployer",
      0.0175
    ],
    [
      "depenser",
      0.0175
    ],
    [
      "commettre",
      0.0175
    ],
    [
      "charger",
      0.0175
    ],
    [
      "agir",
      0.0175
    ],
    [
      "adopter",
      0.0175
    ],
    [
      "recourir",
      0.0075
    ],
    [
      "preposer",
      0.0075
    ],
    [
      "profiter",
      0.0075
    ],
    [
      "embaucher",
      0.0075
    ],
    [
      "destiner",
      0.0075
    ],
    [
      "amortir",
      0.0075
    ],
    [
      "recruter",
      0.0075
    ]
  ],
  "rempli": [
    [
      "emplir",
      0.0725
    ],
    [
      "couvrir",
      0.0575
    ],
    [
      "truffer",
      0.0575
    ],
    [
      "combler",
      0.05
    ],
    [
      "faire",
      0.05
    ],
    [
      "bourrer",
      0.045
    ],
    [
      "inonder",
      0.045
    ],
    [
      "envahir",
      0.04
    ],
    [
      "garnir",
      0.035
    ],
    [
      "abreuver",
      0.025
    ],
    [
      "charger",
      0.025
    ],
    [
      "impregner",
      0.025
    ],
    [
      "occuper",
      0.025
    ],
    [
      "penetrer",
      0.025
    ],
    [
      "satisfaire",
      0.025
    ],
    [
      "tenir",
      0.02
    ],
    [
      "realiser",
      0.02
    ],
    [
      "passer",
      0.02
    ],
    [
      "gorger",
      0.02
    ],
    [
      "accomplir",
      0.02
    ],
    [
      "semer",
      0.015
    ],
    [
      "saturer",
      0.015
    ],
    [
      "executer",
      0.015
    ],
    [
      "encombrer",
      0.015
    ],
    [
      "bonder",
      0.015
    ],
    [
      "farcir",
      0.0075
    ],
    [
      "gonfler",
      0.0075
    ],
    [
      "observer",
      0.0075
    ],
    [
      "repondre",
      0.0075
    ],
    [
      "s'acquitter",
      0.0075
    ],
    [
      "exercer",
      0.0075
    ],
    [
      "enflammer",
      0.0075
    ],
    [
      "acquitter",
      0.0075
    ],
    [
      "approvisionner",
      0.0075
    ],
    [
      "assouvir",
      0.0075
    ],
    [
      "baigner",
      0.0075
    ],
    [
      "couronner",
      0.0075
    ],
    [
      "devorer",
      0.0075
    ],
    [
      "retentir",
      0.0025
    ],
    [
      "respecter",
      0.0025
    ],
    [
      "peupler",
      0.0025
    ],
    [
      "parfumer",
      0.0025
    ],
    [
      "meubler",
      0.0025
    ],
    [
      "inserer",
      0.0025
    ],
    [
      "fonctionner",
      0.0025
    ],
    [
      "enivrer",
      0.0025
    ],
    [
      "enfler",
      0.0025
    ],
    [
      "embourrer",
      0.0025
    ],
    [
      "embarquer",
      0.0025
    ],
    [
      "consteller",
      0.0025
    ],
    [
      "capitonner",
      0.0025
    ],
    [
      "verser",
      0.0025
    ]
  ],
  "marchant": [
    [
      "aller",
      0.0975
    ],
    [
      "avancer",
      0.0575
    ],
    [
      "passer",
      0.04
    ],
    [
      "errer",
      0.035
    ],
    [
      "tourner",
      0.025
    ],
    [
      "roder",
      0.025
    ],
    [
      "reussir",
      0.025
    ],
    [
      "progresser",
      0.025
    ],
    [
      "deambuler",
      0.025
    ],
    [
      "flaner",
      0.0225
    ],
    [
      "venir",
      0.0225
    ],
    [
      "gagner",
      0.0175
    ],
    [
      "evoluer",
      0.015
    ],
    [
      "s'avancer",
      0.015
    ],
    [
      "s'acheminer",
      0.015
    ],
    [
      "rouler",
      0.015
    ],
    [
      "prendre",
      0.015
    ],
    [
      "jouer",
      0.015
    ],
    [
      "fonctionner",
      0.015
    ],
    [
      "filer",
      0.015
    ],
    [
      "cingler",
      0.015
    ],
    [
      "cheminer",
      0.015
    ],
    [
      "vagabonder",
      0.0125
    ],
    [
      "trainer",
      0.0125
    ],
    [
      "tendre",
      0.0125
    ],
    [
      "suivre",
      0.0125
    ],
    [
      "prosperer",
      0.0125
    ],
    [
      "partir",
      0.0125
    ],
    [
      "naviguer",
      0.0125
    ],
    [
      "accepter",
      0.0125
    ],
    [
      "proceder",
      0.0075
    ],
    [
      "fleurir",
      0.0075
    ],
    [
      "vadrouiller",
      0.005
    ],
    [
      "trimer",
      0.005
    ],
    [
      "trimarder",
      0.005
    ],
    [
      "obeir",
      0.005
    ],
    [
      "gazer",
      0.005
    ],
    [
      "bicher",
      0.005
    ],
    [
      "s'elancer",
      0.0025
    ],
    [
      "servir",
      0.0025
    ],
    [
      "trotter",
      0.0025
    ],
    [
      "trottiner",
      0.0025
    ],
    [
      "s'ecouler",
      0.0025
    ],
    [
      "s'implanter",
      0.0025
    ],
    [
      "pietiner",
      0.0025
    ],
    [
      "fouler",
      0.0025
    ],
    [
      "enjamber",
      0.0025
    ],
    [
      "croire",
      0.0025
    ],
    [
      "consentir",
      0.0025
    ],
    [
      "arquer",
      0.0025
    ],
    [
      "arpenter",
      0.0025
    ]
  ],
  "loup": [
    [
      "renard",
      0.1
    ],
    [
      "tortueux",
      0.05
    ],
    [
      "ruse",
      0.05
    ],
    [
      "requin",
      0.05
    ],
    [
      "ours",
      0.05
    ],
    [
      "monstre",
      0.05
    ],
    [
      "masque",
      0.05
    ],
    [
      "lupus",
      0.05
    ],
    [
      "lubin",
      0.05
    ],
    [
      "louve",
      0.05
    ],
    [
      "louvat",
      0.05
    ],
    [
      "louvart",
      0.05
    ],
    [
      "imperfection",
      0.05
    ],
    [
      "chacal",
      0.05
    ],
    [
      "canide",
      0.05
    ],
    [
      "bete",
      0.05
    ],
    [
      "bar",
      0.05
    ],
    [
      "travers",
      0.05
    ]
  ],
  "peindre": [
    [
      "representer",
      0.08
    ],
    [
      "montrer",
      0.075
    ],
    [
      "reveler",
      0.0625
    ],
    [
      "exposer",
      0.045
    ],
    [
      "figurer",
      0.04
    ],
    [
      "raconter",
      0.04
    ],
    [
      "exprimer",
      0.0325
    ],
    [
      "depeindre",
      0.0325
    ],
    [
      "decrire",
      0.0325
    ],
    [
      "dessiner",
      0.0275
    ],
    [
      "retracer",
      0.0275
    ],
    [
      "signifier",
      0.0275
    ],
    [
      "tracer",
      0.0275
    ],
    [
      "farder",
      0.0225
    ],
    [
      "esquisser",
      0.0225
    ],
    [
      "colorer",
      0.0225
    ],
    [
      "camper",
      0.0225
    ],
    [
      "barbouiller",
      0.0225
    ],
    [
      "traduire",
      0.015
    ],
    [
      "teindre",
      0.015
    ],
    [
      "portraiturer",
      0.015
    ],
    [
      "peinturlurer",
      0.015
    ],
    [
      "devoiler",
      0.015
    ],
    [
      "croquer",
      0.015
    ],
    [
      "trahir",
      0.01
    ],
    [
      "maquiller",
      0.01
    ],
    [
      "livrer",
      0.01
    ],
    [
      "conter",
      0.01
    ],
    [
      "colorier",
      0.01
    ],
    [
      "brosser",
      0.01
    ],
    [
      "barioler",
      0.01
    ],
    [
      "badigeonner",
      0.01
    ],
    [
      "pocher",
      0.005
    ],
    [
      "portraire",
      0.005
    ],
    [
      "prefigurer",
      0.005
    ],
    [
      "repeindre",
      0.005
    ],
    [
      "ripoliner",
      0.005
    ],
    [
      "sculpter",
      0.005
    ],
    [
      "teinter",
      0.005
    ],
    [
      "torcher",
      0.005
    ],
    [
      "travestir",
      0.005
    ],
    [
      "pignocher",
      0.005
    ],
    [
      "peinturer",
      0.005
    ],
    [
      "laquer",
      0.005
    ],
    [
      "accoucher",
      0.005
    ],
    [
      "bricoler",
      0.005
    ],
    [
      "bronzer",
      0.005
    ],
    [
      "caracteriser",
      0.005
    ],
    [
      "fixer",
      0.005
    ],
    [
      "graniter",
      0.005
    ],
    [
      "grimer",
      0.005
    ],
    [
      "historier",
      0.005
    ],
    [
      "vernir",
      0.005
    ]
  ],
  "tresor": [
    [
      "phenix",
      0.17
    ],
    [
      "perfection",
      0.0675
    ],
    [
      "argent",
      0.05
    ],
    [
      "epargne",
      0.0325
    ],
    [
      "reserve",
      0.0325
    ],
    [
      "roi",
      0.0325
    ],
    [
      "richesse",
      0.0325
    ],
    [
      "perle",
      0.0325
    ],
    [
      "modele",
      0.0325
    ],
    [
      "ideal",
      0.0325
    ],
    [
      "genie",
      0.0325
    ],
    [
      "finance",
      0.0325
    ],
    [
      "capital",
      0.0325
    ],
    [
      "aigle",
      0.0325
    ],
    [
      "pactole",
      0.015
    ],
    [
      "parangon",
      0.015
    ],
    [
      "prodige",
      0.015
    ],
    [
      "reine",
      0.015
    ],
    [
      "source",
      0.015
    ],
    [
      "thesaurus",
      0.015
    ],
    [
      "tresorerie",
      0.015
    ],
    [
      "mine",
      0.015
    ],
    [
      "magot",
      0.015
    ],
    [
      "as",
      0.015
    ],
    [
      "biquet",
      0.015
    ],
    [
      "cassette",
      0.015
    ],
    [
      "dictionnaire",
      0.015
    ],
    [
      "eldorado",
      0.015
    ],
    [
      "fisc",
      0.015
    ],
    [
      "fleur",
      0.015
    ],
    [
      "fortune",
      0.015
    ],
    [
      "echiquier",
      0.015
    ]
  ],
  "soeur": [
    [
      "nonne",
      0.2925
    ],
    [
      "religieuse",
      0.2925
    ],
    [
      "nonnette",
      0.0275
    ],
    [
      "nonnain",
      0.0275
    ],
    [
      "mere",
      0.0275
    ],
    [
      "moniale",
      0.0275
    ],
    [
      "moinesse",
      0.0275
    ],
    [
      "jumelle",
      0.0275
    ],
    [
      "germain",
      0.0275
    ],
    [
      "frangine",
      0.0275
    ],
    [
      "fille",
      0.0275
    ],
    [
      "dame",
      0.0275
    ],
    [
      "congreganiste",
      0.0275
    ],
    [
      "carmelite",
      0.0275
    ],
    [
      "beguine",
      0.0275
    ],
    [
      "novice",
      0.0275
    ]
  ],
  "riviere": [
    [
      "ruisseau",
      0.0925
    ],
    [
      "torrent",
      0.0625
    ],
    [
      "gave",
      0.0625
    ],
    [
      "fleuve",
      0.0625
    ],
    [
      "affluent",
      0.0625
    ],
    [
      "tributaire",
      0.03
    ],
    [
      "ru",
      0.03
    ],
    [
      "ravine",
      0.03
    ],
    [
      "oued",
      0.03
    ],
    [
      "flux",
      0.03
    ],
    [
      "collier",
      0.03
    ],
    [
      "collecteur",
      0.03
    ],
    [
      "canal",
      0.03
    ],
    [
      "bain",
      0.03
    ],
    [
      "emissaire",
      0.03
    ]
  ],
  "loutre": [],
  "heron": [],
  "sycomore": [],
  "aigle": [
    [
      "rapace",
      0.105
    ],
    [
      "genie",
      0.085
    ],
    [
      "phenix",
      0.085
    ],
    [
      "as",
      0.0625
    ],
    [
      "crack",
      0.0625
    ],
    [
      "prodige",
      0.0625
    ],
    [
      "etendard",
      0.04
    ],
    [
      "virtuose",
      0.04
    ],
    [
      "tresor",
      0.04
    ],
    [
      "embleme",
      0.04
    ],
    [
      "drapeau",
      0.04
    ],
    [
      "banniere",
      0.04
    ],
    [
      "spizaete",
      0.02
    ],
    [
      "pygargue",
      0.02
    ],
    [
      "phenomene",
      0.02
    ],
    [
      "intelligence",
      0.02
    ],
    [
      "harpie",
      0.02
    ],
    [
      "gypaete",
      0.02
    ],
    [
      "enseigne",
      0.02
    ],
    [
      "empire",
      0.02
    ],
    [
      "circaete",
      0.02
    ],
    [
      "champion",
      0.02
    ],
    [
      "armoiries",
      0.02
    ],
    [
      "uraete",
      0.02
    ]
  ],
  "trone": [
    [
      "regne",
      0.135
    ],
    [
      "souverainete",
      0.135
    ],
    [
      "royaute",
      0.09
    ],
    [
      "puissance",
      0.09
    ],
    [
      "pouvoir",
      0.09
    ],
    [
      "monarchie",
      0.09
    ],
    [
      "dynastie",
      0.09
    ],
    [
      "ange",
      0.045
    ],
    [
      "autorite",
      0.045
    ],
    [
      "maison",
      0.045
    ],
    [
      "siege",
      0.045
    ]
  ],
  "troner": [
    [
      "pontifier",
      0.135
    ],
    [
      "presider",
      0.09
    ],
    [
      "plastronner",
      0.09
    ],
    [
      "parader",
      0.09
    ],
    [
      "sieger",
      0.045
    ],
    [
      "triompher",
      0.045
    ]
  ],
  "imperial": [],
  "creature": [
    [
      "personne",
      0.1775
    ],
    [
      "homme",
      0.1175
    ],
    [
      "humain",
      0.1175
    ],
    [
      "etre",
      0.1175
    ],
    [
      "protege",
      0.0575
    ],
    [
      "mortel",
      0.0575
    ],
    [
      "individu",
      0.0575
    ],
    [
      "femme",
      0.0575
    ],
    [
      "favori",
      0.0575
    ],
    [
      "courtisane",
      0.0575
    ],
    [
      "chair",
      0.0575
    ],
    [
      "emanation",
      0.0575
    ]
  ],
  "pur": [
    [
      "bon",
      0.05
    ],
    [
      "honnete",
      0.0425
    ],
    [
      "franc",
      0.0375
    ],
    [
      "beau",
      0.03
    ],
    [
      "simple",
      0.03
    ],
    [
      "propre",
      0.0275
    ],
    [
      "net",
      0.0275
    ],
    [
      "chaste",
      0.0275
    ],
    [
      "vrai",
      0.025
    ],
    [
      "vierge",
      0.025
    ],
    [
      "parfait",
      0.025
    ],
    [
      "clair",
      0.025
    ],
    [
      "innocent",
      0.025
    ],
    [
      "blanc",
      0.02
    ],
    [
      "droit",
      0.02
    ],
    [
      "immacule",
      0.02
    ],
    [
      "elegant",
      0.02
    ],
    [
      "intact",
      0.02
    ],
    [
      "candide",
      0.02
    ],
    [
      "vertueux",
      0.0175
    ],
    [
      "sincere",
      0.0175
    ],
    [
      "naturel",
      0.0175
    ],
    [
      "delicat",
      0.0175
    ],
    [
      "correct",
      0.0175
    ],
    [
      "angelique",
      0.0175
    ],
    [
      "limpide",
      0.015
    ],
    [
      "raffine",
      0.015
    ],
    [
      "ethere",
      0.0125
    ],
    [
      "sain",
      0.01
    ],
    [
      "sage",
      0.01
    ],
    [
      "probe",
      0.01
    ],
    [
      "ideal",
      0.01
    ],
    [
      "frais",
      0.01
    ],
    [
      "entier",
      0.01
    ],
    [
      "complet",
      0.01
    ],
    [
      "veritable",
      0.0075
    ],
    [
      "virginal",
      0.0075
    ],
    [
      "transparent",
      0.0075
    ],
    [
      "soigne",
      0.0075
    ],
    [
      "serein",
      0.0075
    ],
    [
      "pudique",
      0.0075
    ],
    [
      "neuf",
      0.0075
    ],
    [
      "naif",
      0.0075
    ],
    [
      "leger",
      0.0075
    ],
    [
      "ingenu",
      0.0075
    ],
    [
      "fin",
      0.0075
    ],
    [
      "absolu",
      0.0075
    ],
    [
      "epure",
      0.005
    ],
    [
      "platonique",
      0.005
    ],
    [
      "nu",
      0.005
    ],
    [
      "integre",
      0.005
    ],
    [
      "impeccable",
      0.005
    ],
    [
      "immateriel",
      0.005
    ],
    [
      "desinteresse",
      0.005
    ],
    [
      "seraphique",
      0.0025
    ],
    [
      "sublime",
      0.0025
    ],
    [
      "potable",
      0.0025
    ],
    [
      "cristallin",
      0.0025
    ],
    [
      "continent",
      0.0025
    ],
    [
      "chatie",
      0.0025
    ],
    [
      "brut",
      0.0025
    ],
    [
      "aerien",
      0.0025
    ],
    [
      "authentique",
      0.0025
    ],
    [
      "aile",
      0.0025
    ],
    [
      "purifie",
      0.0
    ],
    [
      "puritain",
      0.0
    ],
    [
      "rectifie",
      0.0
    ],
    [
      "saint",
      0.0
    ],
    [
      "seul",
      0.0
    ],
    [
      "insexuel",
      0.0
    ],
    [
      "inaltere",
      0.0
    ],
    [
      "filtre",
      0.0
    ],
    [
      "depourvu",
      0.0
    ],
    [
      "assaini",
      0.0
    ],
    [
      "argentin",
      0.0
    ],
    [
      "archangelique",
      0.0
    ],
    [
      "affine",
      0.0
    ],
    [
      "abstrait",
      0.0
    ],
    [
      "tamise",
      0.0
    ]
  ],
  "vitesse": [
    [
      "rapidite",
      0.13
    ],
    [
      "celerite",
      0.1125
    ],
    [
      "promptitude",
      0.1125
    ],
    [
      "vivacite",
      0.1125
    ],
    [
      "activite",
      0.075
    ],
    [
      "hate",
      0.075
    ],
    [
      "precipitation",
      0.055
    ],
    [
      "prestesse",
      0.055
    ],
    [
      "diligence",
      0.0375
    ],
    [
      "intensite",
      0.0375
    ],
    [
      "velocite",
      0.0175
    ],
    [
      "train",
      0.0175
    ],
    [
      "regime",
      0.0175
    ],
    [
      "presse",
      0.0175
    ],
    [
      "force",
      0.0175
    ],
    [
      "expedition",
      0.0175
    ],
    [
      "erre",
      0.0175
    ],
    [
      "allure",
      0.0175
    ],
    [
      "agilite",
      0.0175
    ],
    [
      "elan",
      0.0175
    ]
  ],
  "dedier": [
    [
      "donner",
      0.25
    ],
    [
      "vouer",
      0.25
    ],
    [
      "devouer",
      0.165
    ],
    [
      "adresser",
      0.0825
    ],
    [
      "consacrer",
      0.0825
    ],
    [
      "dedicacer",
      0.0825
    ],
    [
      "offrir",
      0.0825
    ]
  ],
  "souris": [
    [
      "plaire",
      0.1775
    ],
    [
      "convenir",
      0.1175
    ],
    [
      "rire",
      0.1175
    ],
    [
      "plaisanter",
      0.0575
    ],
    [
      "ironiser",
      0.0575
    ],
    [
      "favoriser",
      0.0575
    ],
    [
      "enchanter",
      0.0575
    ],
    [
      "combler",
      0.0575
    ],
    [
      "chanter",
      0.0575
    ],
    [
      "aller",
      0.0575
    ],
    [
      "servir",
      0.0575
    ]
  ],
  "ris": [
    [
      "railler",
      0.08
    ],
    [
      "s'amuser",
      0.07
    ],
    [
      "plaisanter",
      0.0575
    ],
    [
      "mepriser",
      0.0275
    ],
    [
      "blaguer",
      0.0275
    ],
    [
      "rigoler",
      0.0225
    ],
    [
      "jouer",
      0.0225
    ],
    [
      "brocarder",
      0.0225
    ],
    [
      "badiner",
      0.0225
    ],
    [
      "s'egayer",
      0.015
    ],
    [
      "pouffer",
      0.015
    ],
    [
      "ironiser",
      0.015
    ],
    [
      "eclater",
      0.01
    ],
    [
      "sourire",
      0.01
    ],
    [
      "s'esclaffer",
      0.01
    ],
    [
      "ridiculiser",
      0.01
    ],
    [
      "dedaigner",
      0.01
    ],
    [
      "s'etourdir",
      0.005
    ],
    [
      "rioter",
      0.005
    ],
    [
      "rigolbocher",
      0.005
    ],
    [
      "baratiner",
      0.005
    ],
    [
      "glousser",
      0.005
    ],
    [
      "ignorer",
      0.005
    ],
    [
      "luire",
      0.005
    ],
    [
      "narguer",
      0.005
    ],
    [
      "nasarder",
      0.005
    ],
    [
      "persifler",
      0.005
    ],
    [
      "ricaner",
      0.005
    ],
    [
      "amuser",
      0.005
    ]
  ],
  "lie": [
    [
      "attacher",
      0.1175
    ],
    [
      "joindre",
      0.085
    ],
    [
      "unir",
      0.075
    ],
    [
      "reunir",
      0.0625
    ],
    [
      "assembler",
      0.0575
    ],
    [
      "associer",
      0.0475
    ],
    [
      "enchainer",
      0.0475
    ],
    [
      "combiner",
      0.0275
    ],
    [
      "assujettir",
      0.025
    ],
    [
      "accoler",
      0.0225
    ],
    [
      "astreindre",
      0.0225
    ],
    [
      "relier",
      0.0225
    ],
    [
      "serrer",
      0.0225
    ],
    [
      "river",
      0.02
    ],
    [
      "rapprocher",
      0.015
    ],
    [
      "fixer",
      0.015
    ],
    [
      "engager",
      0.015
    ],
    [
      "allier",
      0.015
    ],
    [
      "adjoindre",
      0.015
    ],
    [
      "tenir",
      0.0125
    ],
    [
      "obliger",
      0.0125
    ],
    [
      "fusionner",
      0.0125
    ],
    [
      "contraindre",
      0.0125
    ],
    [
      "agencer",
      0.0125
    ],
    [
      "accorder",
      0.0125
    ],
    [
      "atteler",
      0.01
    ],
    [
      "coordonner",
      0.01
    ],
    [
      "rattacher",
      0.0075
    ],
    [
      "nouer",
      0.0075
    ],
    [
      "marier",
      0.0075
    ],
    [
      "ligoter",
      0.0075
    ],
    [
      "lacer",
      0.0075
    ],
    [
      "garrotter",
      0.0075
    ],
    [
      "ficeler",
      0.0075
    ],
    [
      "accoupler",
      0.0075
    ],
    [
      "suspendre",
      0.005
    ],
    [
      "enlacer",
      0.005
    ],
    [
      "conjuguer",
      0.005
    ],
    [
      "conglomerer",
      0.005
    ],
    [
      "boulonner",
      0.005
    ],
    [
      "agglutiner",
      0.005
    ],
    [
      "couler",
      0.0
    ],
    [
      "hypothequer",
      0.0
    ],
    [
      "ligaturer",
      0.0
    ],
    [
      "moiser",
      0.0
    ],
    [
      "s'atteler",
      0.0
    ],
    [
      "s'engager",
      0.0
    ],
    [
      "coudre",
      0.0
    ],
    [
      "correler",
      0.0
    ],
    [
      "corder",
      0.0
    ],
    [
      "cimenter",
      0.0
    ],
    [
      "charpenter",
      0.0
    ],
    [
      "carguer",
      0.0
    ],
    [
      "botteler",
      0.0
    ],
    [
      "amarrer",
      0.0
    ],
    [
      "solidariser",
      0.0
    ]
  ],
  "bref": [
    [
      "court",
      0.0975
    ],
    [
      "succinct",
      0.07
    ],
    [
      "rapide",
      0.06
    ],
    [
      "sommaire",
      0.06
    ],
    [
      "abrege",
      0.0525
    ],
    [
      "concis",
      0.0525
    ],
    [
      "resume",
      0.0525
    ],
    [
      "brusque",
      0.0425
    ],
    [
      "tranchant",
      0.0425
    ],
    [
      "prompt",
      0.035
    ],
    [
      "brutal",
      0.025
    ],
    [
      "compendieux",
      0.025
    ],
    [
      "fugitif",
      0.025
    ],
    [
      "sec",
      0.025
    ],
    [
      "transitoire",
      0.015
    ],
    [
      "rescrit",
      0.015
    ],
    [
      "raccourci",
      0.015
    ],
    [
      "precis",
      0.015
    ],
    [
      "momentane",
      0.015
    ],
    [
      "laconique",
      0.015
    ],
    [
      "instantane",
      0.015
    ],
    [
      "incisif",
      0.015
    ],
    [
      "fugace",
      0.015
    ],
    [
      "enfin",
      0.015
    ],
    [
      "bulle",
      0.015
    ],
    [
      "fuyant",
      0.0075
    ],
    [
      "imperatif",
      0.0075
    ],
    [
      "mandement",
      0.0075
    ],
    [
      "petit",
      0.0075
    ],
    [
      "coupant",
      0.0075
    ],
    [
      "constitution",
      0.0075
    ],
    [
      "condense",
      0.0075
    ],
    [
      "calendrier",
      0.0075
    ],
    [
      "breviaire",
      0.0075
    ]
  ],
  "romantisme": [
    [
      "romanticisme",
      1.0
    ]
  ],
  "express": [
    [
      "cafe",
      0.5
    ]
  ],
  "aube": [
    [
      "aurore",
      0.185
    ],
    [
      "commencement",
      0.105
    ],
    [
      "seuil",
      0.105
    ],
    [
      "debut",
      0.0775
    ],
    [
      "matin",
      0.0775
    ],
    [
      "naissance",
      0.025
    ],
    [
      "palette",
      0.025
    ],
    [
      "robe",
      0.025
    ],
    [
      "lueur",
      0.025
    ],
    [
      "enfance",
      0.025
    ],
    [
      "balbutiement",
      0.025
    ],
    [
      "aubage",
      0.025
    ],
    [
      "arrivee",
      0.025
    ],
    [
      "rochet",
      0.025
    ]
  ],
  "croyant": [
    [
      "penser",
      0.115
    ],
    [
      "imaginer",
      0.0725
    ],
    [
      "compter",
      0.0525
    ],
    [
      "estimer",
      0.0525
    ],
    [
      "presumer",
      0.0475
    ],
    [
      "considerer",
      0.0475
    ],
    [
      "juger",
      0.04
    ],
    [
      "supposer",
      0.04
    ],
    [
      "s'attendre",
      0.0325
    ],
    [
      "esperer",
      0.025
    ],
    [
      "accepter",
      0.025
    ],
    [
      "admettre",
      0.02
    ],
    [
      "reputer",
      0.02
    ],
    [
      "soupconner",
      0.02
    ],
    [
      "trouver",
      0.02
    ],
    [
      "ecouter",
      0.0125
    ],
    [
      "s'imaginer",
      0.0125
    ],
    [
      "reconnaitre",
      0.0125
    ],
    [
      "avaler",
      0.0125
    ],
    [
      "attendre",
      0.0125
    ],
    [
      "apprecier",
      0.0125
    ],
    [
      "prejuger",
      0.005
    ],
    [
      "sembler",
      0.005
    ],
    [
      "tromper",
      0.005
    ],
    [
      "marcher",
      0.005
    ],
    [
      "jurer",
      0.005
    ],
    [
      "abuser",
      0.005
    ],
    [
      "adherer",
      0.005
    ],
    [
      "cuider",
      0.005
    ],
    [
      "donner",
      0.005
    ],
    [
      "faillir",
      0.005
    ],
    [
      "gober",
      0.005
    ]
  ],
  "mensonge": [
    [
      "tromperie",
      0.065
    ],
    [
      "simulation",
      0.0575
    ],
    [
      "blague",
      0.0425
    ],
    [
      "bateau",
      0.04
    ],
    [
      "hypocrisie",
      0.04
    ],
    [
      "invention",
      0.04
    ],
    [
      "feinte",
      0.0375
    ],
    [
      "conte",
      0.035
    ],
    [
      "fable",
      0.0325
    ],
    [
      "faussete",
      0.0325
    ],
    [
      "histoire",
      0.0275
    ],
    [
      "sournoiserie",
      0.025
    ],
    [
      "roman",
      0.025
    ],
    [
      "imposture",
      0.025
    ],
    [
      "illusion",
      0.025
    ],
    [
      "farce",
      0.025
    ],
    [
      "craque",
      0.0225
    ],
    [
      "fourberie",
      0.0225
    ],
    [
      "hablerie",
      0.0225
    ],
    [
      "tartuferie",
      0.0175
    ],
    [
      "faux",
      0.0175
    ],
    [
      "comedie",
      0.0175
    ],
    [
      "boniment",
      0.0175
    ],
    [
      "mystification",
      0.0125
    ],
    [
      "rodomontade",
      0.01
    ],
    [
      "galejade",
      0.01
    ],
    [
      "fiction",
      0.01
    ],
    [
      "erreur",
      0.01
    ],
    [
      "duplicite",
      0.01
    ],
    [
      "contreverite",
      0.01
    ],
    [
      "bourde",
      0.01
    ],
    [
      "bobard",
      0.01
    ],
    [
      "artifice",
      0.01
    ],
    [
      "mythe",
      0.0075
    ],
    [
      "menterie",
      0.0075
    ],
    [
      "imagination",
      0.0075
    ],
    [
      "frime",
      0.0075
    ],
    [
      "canular",
      0.0075
    ],
    [
      "calomnie",
      0.0075
    ],
    [
      "vanterie",
      0.005
    ],
    [
      "vanite",
      0.005
    ],
    [
      "simulacre",
      0.005
    ],
    [
      "salade",
      0.005
    ],
    [
      "postiche",
      0.005
    ],
    [
      "momerie",
      0.005
    ],
    [
      "inexactitude",
      0.005
    ],
    [
      "fard",
      0.005
    ],
    [
      "fabulation",
      0.005
    ],
    [
      "carotte",
      0.005
    ],
    [
      "fumee",
      0.0025
    ],
    [
      "gausse",
      0.0025
    ],
    [
      "mirage",
      0.0025
    ],
    [
      "mythomanie",
      0.0025
    ],
    [
      "flatterie",
      0.0025
    ],
    [
      "fanfaronnade",
      0.0025
    ],
    [
      "euphemisme",
      0.0025
    ],
    [
      "bourrage",
      0.0025
    ],
    [
      "bidon",
      0.0025
    ],
    [
      "neant",
      0.0025
    ]
  ],
  "consumer": [
    [
      "detruire",
      0.1
    ],
    [
      "devorer",
      0.075
    ],
    [
      "epuiser",
      0.07
    ],
    [
      "bruler",
      0.0625
    ],
    [
      "user",
      0.06
    ],
    [
      "miner",
      0.055
    ],
    [
      "manger",
      0.0475
    ],
    [
      "ronger",
      0.0475
    ],
    [
      "ruiner",
      0.0475
    ],
    [
      "depenser",
      0.0275
    ],
    [
      "abattre",
      0.0275
    ],
    [
      "affaiblir",
      0.025
    ],
    [
      "aneantir",
      0.025
    ],
    [
      "consommer",
      0.025
    ],
    [
      "embraser",
      0.025
    ],
    [
      "engloutir",
      0.025
    ],
    [
      "saper",
      0.02
    ],
    [
      "dissiper",
      0.02
    ],
    [
      "diminuer",
      0.02
    ],
    [
      "absorber",
      0.02
    ],
    [
      "corroder",
      0.0175
    ],
    [
      "ravager",
      0.0125
    ],
    [
      "enflammer",
      0.0125
    ],
    [
      "dessecher",
      0.0125
    ],
    [
      "calciner",
      0.01
    ],
    [
      "employer",
      0.01
    ],
    [
      "tarir",
      0.005
    ],
    [
      "passer",
      0.005
    ],
    [
      "incendier",
      0.005
    ],
    [
      "fatiguer",
      0.005
    ],
    [
      "carboniser",
      0.0025
    ],
    [
      "consacrer",
      0.0025
    ],
    [
      "enfievrer",
      0.0025
    ],
    [
      "oxyder",
      0.0025
    ],
    [
      "prodiguer",
      0.0025
    ]
  ],
  "resumer": [
    [
      "reduire",
      0.2125
    ],
    [
      "abreger",
      0.105
    ],
    [
      "condenser",
      0.105
    ],
    [
      "resserrer",
      0.07
    ],
    [
      "ramasser",
      0.07
    ],
    [
      "preciser",
      0.07
    ],
    [
      "diminuer",
      0.07
    ],
    [
      "analyser",
      0.07
    ],
    [
      "extraire",
      0.035
    ],
    [
      "reprendre",
      0.035
    ],
    [
      "recapituler",
      0.035
    ],
    [
      "schematiser",
      0.035
    ],
    [
      "synthetiser",
      0.035
    ],
    [
      "ecourter",
      0.035
    ]
  ],
  "amertume": [
    [
      "aigreur",
      0.1
    ],
    [
      "chagrin",
      0.095
    ],
    [
      "tristesse",
      0.0525
    ],
    [
      "mechancete",
      0.0425
    ],
    [
      "degout",
      0.04
    ],
    [
      "peine",
      0.04
    ],
    [
      "melancolie",
      0.0325
    ],
    [
      "mal",
      0.0325
    ],
    [
      "desesperance",
      0.0325
    ],
    [
      "deception",
      0.0325
    ],
    [
      "acrimonie",
      0.0225
    ],
    [
      "bile",
      0.0225
    ],
    [
      "aprete",
      0.02
    ],
    [
      "acrete",
      0.02
    ],
    [
      "tourment",
      0.02
    ],
    [
      "maussaderie",
      0.02
    ],
    [
      "fiel",
      0.02
    ],
    [
      "desolation",
      0.02
    ],
    [
      "deplaisir",
      0.02
    ],
    [
      "deboire",
      0.02
    ],
    [
      "durete",
      0.02
    ],
    [
      "douleur",
      0.02
    ],
    [
      "causticite",
      0.02
    ],
    [
      "regret",
      0.0125
    ],
    [
      "desappointement",
      0.0125
    ],
    [
      "desagrement",
      0.0125
    ],
    [
      "depit",
      0.0125
    ],
    [
      "decouragement",
      0.0125
    ],
    [
      "cruaute",
      0.0125
    ],
    [
      "acerbite",
      0.0125
    ],
    [
      "ecoeurement",
      0.0075
    ],
    [
      "souffrance",
      0.0075
    ],
    [
      "nostalgie",
      0.0075
    ],
    [
      "navrement",
      0.0075
    ],
    [
      "hargne",
      0.0075
    ],
    [
      "animosite",
      0.0075
    ],
    [
      "agressivite",
      0.0075
    ],
    [
      "affliction",
      0.0075
    ],
    [
      "rancoeur",
      0.0025
    ],
    [
      "morosite",
      0.0025
    ],
    [
      "ironie",
      0.0025
    ],
    [
      "humiliation",
      0.0025
    ],
    [
      "cuisance",
      0.0025
    ],
    [
      "acidite",
      0.0025
    ],
    [
      "acariatrete",
      0.0025
    ],
    [
      "rudesse",
      0.0025
    ]
  ],
  "nulle": [
    [
      "faible",
      0.055
    ],
    [
      "insignifiant",
      0.0475
    ],
    [
      "vide",
      0.0475
    ],
    [
      "zero",
      0.0475
    ],
    [
      "incapable",
      0.04
    ],
    [
      "mauvais",
      0.04
    ],
    [
      "nullite",
      0.0325
    ],
    [
      "mechant",
      0.0325
    ],
    [
      "inutile",
      0.0325
    ],
    [
      "bete",
      0.0325
    ],
    [
      "stupide",
      0.0275
    ],
    [
      "insuffisant",
      0.0275
    ],
    [
      "inefficace",
      0.0275
    ],
    [
      "inconsistant",
      0.0275
    ],
    [
      "ignorant",
      0.0275
    ],
    [
      "sterile",
      0.02
    ],
    [
      "sot",
      0.02
    ],
    [
      "plat",
      0.02
    ],
    [
      "inexistant",
      0.02
    ],
    [
      "idiot",
      0.02
    ],
    [
      "caduc",
      0.02
    ],
    [
      "annule",
      0.02
    ],
    [
      "negatif",
      0.0125
    ],
    [
      "neant",
      0.0125
    ],
    [
      "nullard",
      0.0125
    ],
    [
      "minable",
      0.0125
    ],
    [
      "lamentable",
      0.0125
    ],
    [
      "inintelligent",
      0.0125
    ],
    [
      "infime",
      0.0125
    ],
    [
      "inepte",
      0.0125
    ],
    [
      "incompetent",
      0.0125
    ],
    [
      "falot",
      0.0125
    ],
    [
      "cancre",
      0.0125
    ],
    [
      "bouche",
      0.0125
    ],
    [
      "personne",
      0.005
    ],
    [
      "prescrit",
      0.005
    ],
    [
      "perime",
      0.005
    ],
    [
      "rien",
      0.005
    ],
    [
      "moindre",
      0.005
    ],
    [
      "invalide",
      0.005
    ],
    [
      "invalide",
      0.005
    ],
    [
      "ignare",
      0.005
    ],
    [
      "crasse",
      0.005
    ],
    [
      "aucun",
      0.005
    ],
    [
      "aboli",
      0.005
    ],
    [
      "suranne",
      0.005
    ]
  ],
  "bagnole": [
    [
      "automobile",
      0.2625
    ],
    [
      "voiture",
      0.205
    ],
    [
      "chignole",
      0.0875
    ],
    [
      "tire",
      0.0575
    ],
    [
      "charrette",
      0.0575
    ],
    [
      "caisse",
      0.0575
    ],
    [
      "taxi",
      0.0275
    ],
    [
      "tacot",
      0.0275
    ],
    [
      "hotte",
      0.0275
    ],
    [
      "ferraille",
      0.0275
    ],
    [
      "clou",
      0.0275
    ],
    [
      "carriole",
      0.0275
    ],
    [
      "bousine",
      0.0275
    ],
    [
      "auto",
      0.0275
    ],
    [
      "vehicule",
      0.0275
    ]
  ],
  "epingle": [
    [
      "agrafe",
      0.1425
    ],
    [
      "attache",
      0.1425
    ],
    [
      "broche",
      0.1425
    ],
    [
      "gratification",
      0.07
    ],
    [
      "fichoir",
      0.07
    ],
    [
      "fibule",
      0.07
    ],
    [
      "drapiere",
      0.07
    ],
    [
      "clip",
      0.07
    ],
    [
      "camion",
      0.07
    ],
    [
      "aiguille",
      0.07
    ],
    [
      "pince",
      0.07
    ]
  ],
  "epingler": [
    [
      "prendre",
      0.175
    ],
    [
      "piquer",
      0.105
    ],
    [
      "harponner",
      0.0875
    ],
    [
      "saisir",
      0.0875
    ],
    [
      "agrafer",
      0.07
    ],
    [
      "pincer",
      0.07
    ],
    [
      "fixer",
      0.0525
    ],
    [
      "empoigner",
      0.0525
    ],
    [
      "attacher",
      0.0525
    ],
    [
      "accrocher",
      0.0525
    ],
    [
      "chiper",
      0.0325
    ],
    [
      "choper",
      0.0325
    ],
    [
      "reunir",
      0.015
    ],
    [
      "poser",
      0.015
    ],
    [
      "piper",
      0.015
    ],
    [
      "cueillir",
      0.015
    ],
    [
      "alpaguer",
      0.015
    ],
    [
      "agriffer",
      0.015
    ],
    [
      "s'emparer",
      0.015
    ]
  ],
  "attendu": [
    [
      "esperer",
      0.0525
    ],
    [
      "prevoir",
      0.0525
    ],
    [
      "moisir",
      0.04
    ],
    [
      "temporiser",
      0.03
    ],
    [
      "rester",
      0.03
    ],
    [
      "remettre",
      0.03
    ],
    [
      "presumer",
      0.03
    ],
    [
      "pressentir",
      0.03
    ],
    [
      "poireauter",
      0.03
    ],
    [
      "guetter",
      0.03
    ],
    [
      "atermoyer",
      0.03
    ],
    [
      "patienter",
      0.02
    ],
    [
      "poser",
      0.02
    ],
    [
      "presager",
      0.02
    ],
    [
      "retarder",
      0.02
    ],
    [
      "souhaiter",
      0.02
    ],
    [
      "surseoir",
      0.02
    ],
    [
      "vouloir",
      0.02
    ],
    [
      "mettre",
      0.02
    ],
    [
      "menacer",
      0.02
    ],
    [
      "imaginer",
      0.02
    ],
    [
      "compter",
      0.02
    ],
    [
      "craindre",
      0.02
    ],
    [
      "croire",
      0.02
    ],
    [
      "demeurer",
      0.02
    ],
    [
      "differer",
      0.02
    ],
    [
      "desirer",
      0.02
    ],
    [
      "escompter",
      0.02
    ],
    [
      "hesiter",
      0.02
    ],
    [
      "reserver",
      0.01
    ],
    [
      "sejourner",
      0.01
    ],
    [
      "reporter",
      0.01
    ],
    [
      "redouter",
      0.01
    ],
    [
      "languir",
      0.01
    ],
    [
      "exiger",
      0.01
    ],
    [
      "durer",
      0.01
    ],
    [
      "droguer",
      0.01
    ]
  ],
  "sifflant": [
    [
      "aigu",
      0.165
    ],
    [
      "percant",
      0.165
    ],
    [
      "strident",
      0.165
    ],
    [
      "aigre",
      0.0825
    ],
    [
      "bruissant",
      0.0825
    ],
    [
      "chuintant",
      0.0825
    ],
    [
      "sibilant",
      0.0825
    ],
    [
      "striduleux",
      0.0825
    ],
    [
      "eclatant",
      0.0825
    ]
  ],
  "canette": [
    [
      "bobine",
      0.3325
    ],
    [
      "bouteille",
      0.165
    ],
    [
      "cane",
      0.165
    ],
    [
      "cylindre",
      0.165
    ],
    [
      "navette",
      0.165
    ]
  ],
  "paume": [
    [
      "creux",
      0.5
    ],
    [
      "paumee",
      0.5
    ]
  ],
  "paumer": [
    [
      "perdre",
      0.3325
    ],
    [
      "attraper",
      0.165
    ],
    [
      "prendre",
      0.165
    ],
    [
      "egarer",
      0.165
    ]
  ],
  "navire": [
    [
      "bateau",
      0.3075
    ],
    [
      "batiment",
      0.1525
    ],
    [
      "transatlantique",
      0.1525
    ],
    [
      "vaisseau",
      0.1525
    ],
    [
      "nef",
      0.075
    ],
    [
      "paquebot",
      0.075
    ],
    [
      "steamer",
      0.075
    ]
  ],
  "aime": [
    [
      "gouter",
      0.0575
    ],
    [
      "s'eprendre",
      0.0575
    ],
    [
      "cherir",
      0.05
    ],
    [
      "adorer",
      0.045
    ],
    [
      "apprecier",
      0.045
    ],
    [
      "affectionner",
      0.0375
    ],
    [
      "admirer",
      0.03
    ],
    [
      "estimer",
      0.03
    ],
    [
      "raffoler",
      0.03
    ],
    [
      "venerer",
      0.03
    ],
    [
      "vouloir",
      0.025
    ],
    [
      "s'enticher",
      0.025
    ],
    [
      "s'interesser",
      0.0175
    ],
    [
      "s'amouracher",
      0.0175
    ],
    [
      "desirer",
      0.0175
    ],
    [
      "s'emouvoir",
      0.0125
    ],
    [
      "s'attacher",
      0.0125
    ],
    [
      "preferer",
      0.0125
    ],
    [
      "mordre",
      0.0125
    ],
    [
      "demander",
      0.0125
    ],
    [
      "s'embeguiner",
      0.005
    ],
    [
      "s'embraser",
      0.005
    ],
    [
      "reclamer",
      0.005
    ],
    [
      "roucouler",
      0.005
    ],
    [
      "s'enamourer",
      0.005
    ],
    [
      "s'enflammer",
      0.005
    ],
    [
      "pincer",
      0.005
    ],
    [
      "gober",
      0.005
    ],
    [
      "idolatrer",
      0.005
    ]
  ],
  "presque": [
    [
      "quasi",
      0.165
    ],
    [
      "tantot",
      0.055
    ],
    [
      "quasiment",
      0.055
    ],
    [
      "pres",
      0.055
    ],
    [
      "environ",
      0.055
    ],
    [
      "demi",
      0.055
    ],
    [
      "comme",
      0.055
    ],
    [
      "approximativement",
      0.055
    ]
  ],
  "cendre": [
    [
      "reste",
      0.13
    ],
    [
      "debris",
      0.085
    ],
    [
      "poussiere",
      0.085
    ],
    [
      "residu",
      0.085
    ],
    [
      "penitence",
      0.0425
    ],
    [
      "ruine",
      0.0425
    ],
    [
      "scorie",
      0.0425
    ],
    [
      "soude",
      0.0425
    ],
    [
      "souvenir",
      0.0425
    ],
    [
      "potasse",
      0.0425
    ],
    [
      "plomb",
      0.0425
    ],
    [
      "lave",
      0.0425
    ],
    [
      "lapilli",
      0.0425
    ],
    [
      "fraisil",
      0.0425
    ],
    [
      "escarbille",
      0.0425
    ],
    [
      "envol",
      0.0425
    ],
    [
      "cendree",
      0.0425
    ],
    [
      "spodite",
      0.0425
    ]
  ],
  "station": [
    [
      "arret",
      0.12
    ],
    [
      "poste",
      0.08
    ],
    [
      "position",
      0.08
    ],
    [
      "pause",
      0.08
    ],
    [
      "office",
      0.08
    ],
    [
      "halte",
      0.08
    ],
    [
      "gare",
      0.08
    ],
    [
      "depot",
      0.08
    ],
    [
      "posture",
      0.04
    ],
    [
      "guichet",
      0.04
    ],
    [
      "fete",
      0.04
    ],
    [
      "biotope",
      0.04
    ],
    [
      "attitude",
      0.04
    ],
    [
      "attente",
      0.04
    ],
    [
      "agglomeration",
      0.04
    ],
    [
      "stage",
      0.04
    ]
  ],
  "descendre": [
    [
      "tomber",
      0.0875
    ],
    [
      "baisser",
      0.0625
    ],
    [
      "sortir",
      0.05
    ],
    [
      "s'abaisser",
      0.04
    ],
    [
      "dechoir",
      0.035
    ],
    [
      "venir",
      0.03
    ],
    [
      "tuer",
      0.03
    ],
    [
      "passer",
      0.03
    ],
    [
      "degringoler",
      0.03
    ],
    [
      "decliner",
      0.03
    ],
    [
      "partir",
      0.025
    ],
    [
      "sauter",
      0.025
    ],
    [
      "tirer",
      0.02
    ],
    [
      "s'enfoncer",
      0.02
    ],
    [
      "provenir",
      0.02
    ],
    [
      "pencher",
      0.02
    ],
    [
      "executer",
      0.02
    ],
    [
      "diminuer",
      0.02
    ],
    [
      "couler",
      0.02
    ],
    [
      "amener",
      0.02
    ],
    [
      "s'affaisser",
      0.015
    ],
    [
      "abattre",
      0.015
    ],
    [
      "abaisser",
      0.015
    ],
    [
      "s'incliner",
      0.0075
    ],
    [
      "sejourner",
      0.0075
    ],
    [
      "transporter",
      0.0075
    ],
    [
      "emaner",
      0.0075
    ],
    [
      "ereinter",
      0.0075
    ],
    [
      "s'effondrer",
      0.0075
    ],
    [
      "resider",
      0.0075
    ],
    [
      "proceder",
      0.0075
    ],
    [
      "conduire",
      0.0075
    ],
    [
      "demeurer",
      0.0075
    ],
    [
      "debouler",
      0.0075
    ],
    [
      "deroger",
      0.0075
    ],
    [
      "incliner",
      0.0075
    ],
    [
      "jeter",
      0.0075
    ],
    [
      "pendre",
      0.0075
    ],
    [
      "plonger",
      0.0075
    ],
    [
      "retrograder",
      0.0025
    ],
    [
      "rabaisser",
      0.0025
    ],
    [
      "perquisitionner",
      0.0025
    ],
    [
      "naitre",
      0.0025
    ],
    [
      "loger",
      0.0025
    ],
    [
      "s'arreter",
      0.0025
    ],
    [
      "s'avilir",
      0.0025
    ],
    [
      "sonder",
      0.0025
    ],
    [
      "envahir",
      0.0025
    ],
    [
      "aborder",
      0.0025
    ],
    [
      "affaler",
      0.0025
    ],
    [
      "avaler",
      0.0025
    ],
    [
      "bousiller",
      0.0025
    ],
    [
      "condescendre",
      0.0025
    ],
    [
      "critiquer",
      0.0025
    ],
    [
      "dessouder",
      0.0025
    ],
    [
      "debarquer",
      0.0025
    ],
    [
      "decrocher",
      0.0025
    ],
    [
      "decroitre",
      0.0025
    ],
    [
      "deposer",
      0.0025
    ],
    [
      "devaler",
      0.0025
    ],
    [
      "suivre",
      0.0025
    ]
  ],
  "lilas": [
    [
      "bleu",
      0.3325
    ],
    [
      "melia",
      0.3325
    ],
    [
      "violet",
      0.3325
    ]
  ],
  "humble": [
    [
      "mediocre",
      0.075
    ],
    [
      "petit",
      0.075
    ],
    [
      "modeste",
      0.065
    ],
    [
      "servile",
      0.065
    ],
    [
      "soumis",
      0.065
    ],
    [
      "plat",
      0.055
    ],
    [
      "mesquin",
      0.055
    ],
    [
      "bas",
      0.055
    ],
    [
      "pauvre",
      0.045
    ],
    [
      "subalterne",
      0.045
    ],
    [
      "deferent",
      0.0375
    ],
    [
      "timide",
      0.0275
    ],
    [
      "souple",
      0.0275
    ],
    [
      "respectueux",
      0.0275
    ],
    [
      "prosterne",
      0.0275
    ],
    [
      "obscur",
      0.0275
    ],
    [
      "efface",
      0.0275
    ],
    [
      "subordonne",
      0.0175
    ],
    [
      "simple",
      0.0175
    ],
    [
      "ordinaire",
      0.0175
    ],
    [
      "inferieur",
      0.0175
    ],
    [
      "falot",
      0.0175
    ],
    [
      "embarrasse",
      0.0175
    ],
    [
      "docile",
      0.0175
    ],
    [
      "besogneux",
      0.0175
    ],
    [
      "necessiteux",
      0.0075
    ],
    [
      "reverencieux",
      0.0075
    ],
    [
      "timore",
      0.0075
    ]
  ],
  "garnir": [
    [
      "orner",
      0.08
    ],
    [
      "parer",
      0.05
    ],
    [
      "bourrer",
      0.04
    ],
    [
      "remplir",
      0.04
    ],
    [
      "recouvrir",
      0.0325
    ],
    [
      "renforcer",
      0.0325
    ],
    [
      "truffer",
      0.0275
    ],
    [
      "pourvoir",
      0.0275
    ],
    [
      "munir",
      0.0275
    ],
    [
      "embellir",
      0.0275
    ],
    [
      "equiper",
      0.0225
    ],
    [
      "entourer",
      0.0225
    ],
    [
      "enrichir",
      0.0225
    ],
    [
      "emplir",
      0.0225
    ],
    [
      "combler",
      0.0225
    ],
    [
      "charger",
      0.0225
    ],
    [
      "etoffer",
      0.015
    ],
    [
      "revetir",
      0.015
    ],
    [
      "repeupler",
      0.015
    ],
    [
      "imager",
      0.015
    ],
    [
      "fournir",
      0.015
    ],
    [
      "fortifier",
      0.015
    ],
    [
      "envahir",
      0.015
    ],
    [
      "enjoliver",
      0.015
    ],
    [
      "decorer",
      0.015
    ],
    [
      "doubler",
      0.015
    ],
    [
      "capitonner",
      0.015
    ],
    [
      "border",
      0.015
    ],
    [
      "alourdir",
      0.015
    ],
    [
      "inonder",
      0.01
    ],
    [
      "occuper",
      0.01
    ],
    [
      "ouater",
      0.01
    ],
    [
      "ourler",
      0.01
    ],
    [
      "rembourrer",
      0.01
    ],
    [
      "egayer",
      0.01
    ],
    [
      "fourrer",
      0.01
    ],
    [
      "feutrer",
      0.01
    ],
    [
      "agrementer",
      0.01
    ],
    [
      "approvisionner",
      0.01
    ],
    [
      "assortir",
      0.01
    ],
    [
      "barder",
      0.01
    ],
    [
      "boiser",
      0.01
    ],
    [
      "festonner",
      0.01
    ],
    [
      "plafonner",
      0.005
    ],
    [
      "platrer",
      0.005
    ],
    [
      "poudrer",
      0.005
    ],
    [
      "rembourser",
      0.005
    ],
    [
      "rempailler",
      0.005
    ],
    [
      "s'enrichir",
      0.005
    ],
    [
      "passementer",
      0.005
    ],
    [
      "ornementer",
      0.005
    ],
    [
      "nantir",
      0.005
    ],
    [
      "lainer",
      0.005
    ],
    [
      "encadrer",
      0.005
    ],
    [
      "bonder",
      0.005
    ],
    [
      "attifer",
      0.005
    ],
    [
      "affermir",
      0.005
    ],
    [
      "soutacher",
      0.005
    ]
  ],
  "garni": [
    [
      "fourni",
      0.22
    ],
    [
      "abondant",
      0.165
    ],
    [
      "arme",
      0.11
    ],
    [
      "herisse",
      0.11
    ],
    [
      "rempli",
      0.11
    ],
    [
      "feutre",
      0.055
    ],
    [
      "feuillu",
      0.055
    ],
    [
      "assorti",
      0.055
    ],
    [
      "approvisionne",
      0.055
    ],
    [
      "meuble",
      0.055
    ]
  ],
  "nid": [
    [
      "abri",
      0.125
    ],
    [
      "maison",
      0.1125
    ],
    [
      "toit",
      0.075
    ],
    [
      "logement",
      0.0625
    ],
    [
      "habitation",
      0.0625
    ],
    [
      "gite",
      0.0625
    ],
    [
      "foyer",
      0.0625
    ],
    [
      "demeure",
      0.0625
    ],
    [
      "logis",
      0.05
    ],
    [
      "niche",
      0.05
    ],
    [
      "taniere",
      0.0375
    ],
    [
      "retraite",
      0.0375
    ],
    [
      "repaire",
      0.0375
    ],
    [
      "home",
      0.0375
    ],
    [
      "cache",
      0.025
    ],
    [
      "noeud",
      0.0125
    ],
    [
      "nitee",
      0.0125
    ],
    [
      "nichee",
      0.0125
    ],
    [
      "couvoir",
      0.0125
    ],
    [
      "cachette",
      0.0125
    ],
    [
      "bonbonniere",
      0.0125
    ],
    [
      "aire",
      0.0125
    ],
    [
      "origine",
      0.0125
    ]
  ],
  "uns": [
    [
      "unique",
      0.2375
    ],
    [
      "seul",
      0.19
    ],
    [
      "rare",
      0.0475
    ],
    [
      "quelque",
      0.0475
    ],
    [
      "premier",
      0.0475
    ],
    [
      "isole",
      0.0475
    ],
    [
      "indivis",
      0.0475
    ],
    [
      "exclusif",
      0.0475
    ],
    [
      "distinct",
      0.0475
    ],
    [
      "consubstantiel",
      0.0475
    ],
    [
      "constant",
      0.0475
    ],
    [
      "chacun",
      0.0475
    ],
    [
      "as",
      0.0475
    ],
    [
      "simple",
      0.0475
    ]
  ],
  "misereux": [
    [
      "gueux",
      0.1525
    ],
    [
      "pauvre",
      0.145
    ],
    [
      "necessiteux",
      0.12
    ],
    [
      "miserable",
      0.1025
    ],
    [
      "besogneux",
      0.0725
    ],
    [
      "indigent",
      0.0475
    ],
    [
      "pouilleux",
      0.04
    ],
    [
      "miteux",
      0.04
    ],
    [
      "jacques",
      0.03
    ],
    [
      "malheureux",
      0.0225
    ],
    [
      "mendiant",
      0.015
    ],
    [
      "clochard",
      0.015
    ],
    [
      "afflige",
      0.015
    ],
    [
      "famelique",
      0.0075
    ],
    [
      "loqueteux",
      0.0075
    ],
    [
      "marmiteux",
      0.0075
    ],
    [
      "minable",
      0.0075
    ],
    [
      "mouisard",
      0.0075
    ],
    [
      "sordide",
      0.0075
    ]
  ],
  "cession": [
    [
      "abandon",
      0.24
    ],
    [
      "renoncement",
      0.09
    ],
    [
      "transmission",
      0.06
    ],
    [
      "transfert",
      0.06
    ],
    [
      "renonciation",
      0.06
    ],
    [
      "passation",
      0.06
    ],
    [
      "delaissement",
      0.06
    ],
    [
      "alienation",
      0.06
    ],
    [
      "transport",
      0.03
    ],
    [
      "louage",
      0.03
    ],
    [
      "donation",
      0.03
    ],
    [
      "dessaisissement",
      0.03
    ],
    [
      "concession",
      0.03
    ],
    [
      "changement",
      0.03
    ],
    [
      "capitulation",
      0.03
    ],
    [
      "acte",
      0.03
    ],
    [
      "abandonnement",
      0.03
    ],
    [
      "vente",
      0.03
    ]
  ],
  "bistrot": [
    [
      "cafe",
      0.1975
    ],
    [
      "cabaret",
      0.18
    ],
    [
      "buvette",
      0.08
    ],
    [
      "troquet",
      0.08
    ],
    [
      "bar",
      0.065
    ],
    [
      "caboulot",
      0.065
    ],
    [
      "bibine",
      0.0475
    ],
    [
      "mastroquet",
      0.0475
    ],
    [
      "zinc",
      0.0325
    ],
    [
      "restaurant",
      0.0325
    ],
    [
      "estaminet",
      0.0325
    ],
    [
      "abreuvoir",
      0.015
    ],
    [
      "assommoir",
      0.015
    ],
    [
      "bistroquet",
      0.015
    ],
    [
      "cafeton",
      0.015
    ],
    [
      "debit",
      0.015
    ],
    [
      "gargote",
      0.015
    ],
    [
      "rade",
      0.015
    ]
  ],
  "repas": [
    [
      "cuisine",
      0.1025
    ],
    [
      "nourriture",
      0.065
    ],
    [
      "festin",
      0.06
    ],
    [
      "mets",
      0.0475
    ],
    [
      "collation",
      0.035
    ],
    [
      "menu",
      0.035
    ],
    [
      "pitance",
      0.03
    ],
    [
      "ordinaire",
      0.03
    ],
    [
      "chere",
      0.03
    ],
    [
      "bombance",
      0.03
    ],
    [
      "ripaille",
      0.0225
    ],
    [
      "manger",
      0.0225
    ],
    [
      "dejeuner",
      0.0225
    ],
    [
      "bouffe",
      0.0225
    ],
    [
      "alimentation",
      0.0225
    ],
    [
      "souper",
      0.0175
    ],
    [
      "soupe",
      0.0175
    ],
    [
      "rejouissance",
      0.0175
    ],
    [
      "regal",
      0.0175
    ],
    [
      "popote",
      0.0175
    ],
    [
      "mangeaille",
      0.0175
    ],
    [
      "gueuleton",
      0.0175
    ],
    [
      "diner",
      0.0175
    ],
    [
      "croute",
      0.0175
    ],
    [
      "agapes",
      0.0175
    ],
    [
      "reveillon",
      0.01
    ],
    [
      "lunch",
      0.01
    ],
    [
      "gouter",
      0.01
    ],
    [
      "fricot",
      0.01
    ],
    [
      "banquet",
      0.01
    ],
    [
      "lippee",
      0.005
    ],
    [
      "mangerie",
      0.005
    ],
    [
      "medianoche",
      0.005
    ],
    [
      "panier",
      0.005
    ],
    [
      "plat",
      0.005
    ],
    [
      "repue",
      0.005
    ],
    [
      "refection",
      0.005
    ],
    [
      "graillon",
      0.005
    ],
    [
      "graille",
      0.005
    ],
    [
      "gogaille",
      0.005
    ],
    [
      "Cene",
      0.005
    ],
    [
      "bafree",
      0.005
    ],
    [
      "croustille",
      0.005
    ],
    [
      "dinette",
      0.005
    ],
    [
      "dinee",
      0.005
    ],
    [
      "frichti",
      0.005
    ],
    [
      "gala",
      0.005
    ],
    [
      "gaudeamus",
      0.005
    ],
    [
      "sandwich",
      0.005
    ]
  ],
  "toile": [
    [
      "batiste",
      0.07
    ],
    [
      "tissu",
      0.07
    ],
    [
      "tente",
      0.07
    ],
    [
      "tableau",
      0.07
    ],
    [
      "serpilliere",
      0.07
    ],
    [
      "rideau",
      0.07
    ],
    [
      "prelart",
      0.07
    ],
    [
      "peinture",
      0.07
    ],
    [
      "linon",
      0.07
    ],
    [
      "linge",
      0.07
    ],
    [
      "fond",
      0.07
    ],
    [
      "bache",
      0.07
    ],
    [
      "voile",
      0.07
    ]
  ],
  "poeler": [],
  "poele": [
    [
      "casserole",
      0.11
    ],
    [
      "salamandre",
      0.055
    ],
    [
      "poelon",
      0.055
    ],
    [
      "plaque",
      0.055
    ],
    [
      "patelle",
      0.055
    ],
    [
      "pallium",
      0.055
    ],
    [
      "mirus",
      0.055
    ],
    [
      "godin",
      0.055
    ],
    [
      "fourneau",
      0.055
    ],
    [
      "drap",
      0.055
    ],
    [
      "dais",
      0.055
    ],
    [
      "creuset",
      0.055
    ],
    [
      "chauffage",
      0.055
    ],
    [
      "chambre",
      0.055
    ],
    [
      "casse",
      0.055
    ],
    [
      "batterie",
      0.055
    ],
    [
      "voile",
      0.055
    ]
  ],
  "avion": [
    [
      "U.L.M.",
      0.05
    ],
    [
      "coucou",
      0.05
    ],
    [
      "giravion",
      0.05
    ],
    [
      "hydravion",
      0.05
    ],
    [
      "jet",
      0.05
    ],
    [
      "taxi",
      0.05
    ],
    [
      "transport",
      0.05
    ],
    [
      "charter",
      0.05
    ],
    [
      "canadair",
      0.05
    ],
    [
      "appareil",
      0.05
    ],
    [
      "aerodyne",
      0.05
    ],
    [
      "aeronef",
      0.05
    ],
    [
      "aeroplane",
      0.05
    ],
    [
      "aeroscaphe",
      0.05
    ],
    [
      "zinc",
      0.05
    ]
  ],
  "chevalet": [
    [
      "banc",
      0.1425
    ],
    [
      "baudet",
      0.1425
    ],
    [
      "chevre",
      0.1425
    ],
    [
      "marotte",
      0.1425
    ],
    [
      "treteau",
      0.1425
    ],
    [
      "echafaudage",
      0.1425
    ],
    [
      "etai",
      0.1425
    ]
  ],
  "dessin": [
    [
      "image",
      0.0825
    ],
    [
      "plan",
      0.0775
    ],
    [
      "figure",
      0.06
    ],
    [
      "croquis",
      0.035
    ],
    [
      "representation",
      0.0275
    ],
    [
      "portrait",
      0.025
    ],
    [
      "projet",
      0.025
    ],
    [
      "schema",
      0.02
    ],
    [
      "forme",
      0.02
    ],
    [
      "disposition",
      0.02
    ],
    [
      "vue",
      0.0175
    ],
    [
      "trait",
      0.0175
    ],
    [
      "trace",
      0.0175
    ],
    [
      "ligne",
      0.0175
    ],
    [
      "illustration",
      0.0175
    ],
    [
      "esquisse",
      0.0175
    ],
    [
      "dessein",
      0.0175
    ],
    [
      "crayon",
      0.0175
    ],
    [
      "composition",
      0.0175
    ],
    [
      "carton",
      0.0175
    ],
    [
      "caricature",
      0.0175
    ],
    [
      "ebauche",
      0.01
    ],
    [
      "silhouette",
      0.01
    ],
    [
      "patron",
      0.01
    ],
    [
      "ornement",
      0.01
    ],
    [
      "graphique",
      0.01
    ],
    [
      "coupe",
      0.01
    ],
    [
      "contour",
      0.01
    ],
    [
      "conception",
      0.01
    ],
    [
      "canevas",
      0.01
    ],
    [
      "miniature",
      0.0075
    ],
    [
      "meandre",
      0.0075
    ],
    [
      "paysage",
      0.0075
    ],
    [
      "teneur",
      0.0075
    ],
    [
      "topographie",
      0.0075
    ],
    [
      "etude",
      0.0075
    ],
    [
      "leve",
      0.0075
    ],
    [
      "gravure",
      0.0075
    ],
    [
      "aquarelle",
      0.0075
    ],
    [
      "arabesque",
      0.0075
    ],
    [
      "cartographie",
      0.0075
    ],
    [
      "charge",
      0.0075
    ],
    [
      "copie",
      0.0075
    ],
    [
      "figuration",
      0.0075
    ],
    [
      "report",
      0.0025
    ],
    [
      "releve",
      0.0025
    ],
    [
      "ramification",
      0.0025
    ],
    [
      "ramage",
      0.0025
    ],
    [
      "racinage",
      0.0025
    ],
    [
      "projection",
      0.0025
    ],
    [
      "poncif",
      0.0025
    ],
    [
      "pochoir",
      0.0025
    ],
    [
      "sanguine",
      0.0025
    ],
    [
      "sauce",
      0.0025
    ],
    [
      "epure",
      0.0025
    ],
    [
      "elevation",
      0.0025
    ],
    [
      "vegetation",
      0.0025
    ],
    [
      "vignette",
      0.0025
    ],
    [
      "veinure",
      0.0025
    ],
    [
      "treillis",
      0.0025
    ],
    [
      "sepia",
      0.0025
    ],
    [
      "stereographie",
      0.0025
    ],
    [
      "section",
      0.0025
    ],
    [
      "oeuvre",
      0.0025
    ],
    [
      "nu",
      0.0025
    ],
    [
      "nature",
      0.0025
    ],
    [
      "diagraphe",
      0.0025
    ],
    [
      "chinure",
      0.0025
    ],
    [
      "cartouche",
      0.0025
    ],
    [
      "carreau",
      0.0025
    ],
    [
      "brochure",
      0.0025
    ],
    [
      "bistre",
      0.0025
    ],
    [
      "arborisation",
      0.0025
    ],
    [
      "anaglyphe",
      0.0025
    ],
    [
      "delineation",
      0.0025
    ],
    [
      "estampe",
      0.0025
    ],
    [
      "estompe",
      0.0025
    ],
    [
      "motif",
      0.0025
    ],
    [
      "lavis",
      0.0025
    ],
    [
      "grecque",
      0.0025
    ],
    [
      "graffiti",
      0.0025
    ],
    [
      "gouache",
      0.0025
    ],
    [
      "galbe",
      0.0025
    ],
    [
      "fusain",
      0.0025
    ],
    [
      "fleurage",
      0.0025
    ]
  ],
  "galbe": [
    [
      "contour",
      0.1725
    ],
    [
      "courbe",
      0.1725
    ],
    [
      "ligne",
      0.1375
    ],
    [
      "courbure",
      0.1025
    ],
    [
      "sinuosite",
      0.0675
    ],
    [
      "silhouette",
      0.0675
    ],
    [
      "profil",
      0.0675
    ],
    [
      "arrondi",
      0.0325
    ],
    [
      "cintrage",
      0.0325
    ],
    [
      "dessin",
      0.0325
    ],
    [
      "forme",
      0.0325
    ],
    [
      "lineament",
      0.0325
    ],
    [
      "panse",
      0.0325
    ]
  ],
  "creme": [
    [
      "gratin",
      0.15
    ],
    [
      "elite",
      0.15
    ],
    [
      "choix",
      0.0975
    ],
    [
      "fleur",
      0.0975
    ],
    [
      "puree",
      0.0475
    ],
    [
      "pommade",
      0.0475
    ],
    [
      "onguent",
      0.0475
    ],
    [
      "mousse",
      0.0475
    ],
    [
      "meilleur",
      0.0475
    ],
    [
      "flan",
      0.0475
    ],
    [
      "cafe",
      0.0475
    ],
    [
      "bouillie",
      0.0475
    ],
    [
      "blanc",
      0.0475
    ],
    [
      "selection",
      0.0475
    ]
  ],
  "hasard": [
    [
      "chance",
      0.0775
    ],
    [
      "evenement",
      0.07
    ],
    [
      "circonstance",
      0.0625
    ],
    [
      "occasion",
      0.0625
    ],
    [
      "alea",
      0.0575
    ],
    [
      "accident",
      0.0575
    ],
    [
      "cas",
      0.05
    ],
    [
      "aventure",
      0.0375
    ],
    [
      "eventualite",
      0.0375
    ],
    [
      "rencontre",
      0.03
    ],
    [
      "malchance",
      0.03
    ],
    [
      "incertitude",
      0.03
    ],
    [
      "fortune",
      0.03
    ],
    [
      "destin",
      0.03
    ],
    [
      "fatalite",
      0.025
    ],
    [
      "sort",
      0.025
    ],
    [
      "tribulation",
      0.025
    ],
    [
      "temps",
      0.0175
    ],
    [
      "risque",
      0.0175
    ],
    [
      "destinee",
      0.0175
    ],
    [
      "vicissitude",
      0.01
    ],
    [
      "peril",
      0.01
    ],
    [
      "occurrence",
      0.01
    ],
    [
      "loterie",
      0.01
    ],
    [
      "contingence",
      0.01
    ],
    [
      "conjoncture",
      0.01
    ],
    [
      "deveine",
      0.005
    ],
    [
      "imponderables",
      0.005
    ],
    [
      "imprevu",
      0.005
    ],
    [
      "indetermination",
      0.005
    ],
    [
      "tombola",
      0.005
    ],
    [
      "veine",
      0.005
    ],
    [
      "danger",
      0.005
    ],
    [
      "coincidence",
      0.005
    ],
    [
      "coup",
      0.005
    ],
    [
      "aubaine",
      0.005
    ],
    [
      "etoile",
      0.005
    ]
  ],
  "atelier": [
    [
      "affaire",
      0.13
    ],
    [
      "boite",
      0.13
    ],
    [
      "chantier",
      0.13
    ],
    [
      "fabrique",
      0.13
    ],
    [
      "usine",
      0.085
    ],
    [
      "ouvroir",
      0.0425
    ],
    [
      "manufacture",
      0.0425
    ],
    [
      "loge",
      0.0425
    ],
    [
      "laboratoire",
      0.0425
    ],
    [
      "groupe",
      0.0425
    ],
    [
      "couture",
      0.0425
    ],
    [
      "boutique",
      0.0425
    ],
    [
      "arsenal",
      0.0425
    ],
    [
      "studio",
      0.0425
    ]
  ],
  "subsister": [
    [
      "rester",
      0.1375
    ],
    [
      "demeurer",
      0.11
    ],
    [
      "durer",
      0.11
    ],
    [
      "continuer",
      0.0675
    ],
    [
      "trainer",
      0.0675
    ],
    [
      "s'eterniser",
      0.0625
    ],
    [
      "persister",
      0.055
    ],
    [
      "survivre",
      0.04
    ],
    [
      "tenir",
      0.0325
    ],
    [
      "vivre",
      0.0325
    ],
    [
      "surnager",
      0.0275
    ],
    [
      "vegeter",
      0.02
    ],
    [
      "exister",
      0.02
    ],
    [
      "conserver",
      0.0125
    ],
    [
      "perdurer",
      0.0125
    ],
    [
      "etre",
      0.0125
    ],
    [
      "s'inveterer",
      0.005
    ],
    [
      "s'entretenir",
      0.005
    ],
    [
      "entretenir",
      0.005
    ],
    [
      "consister",
      0.005
    ],
    [
      "vivoter",
      0.005
    ]
  ],
  "arriere": [
    [
      "derriere",
      0.2
    ],
    [
      "arriere",
      0.1
    ],
    [
      "cul",
      0.1
    ],
    [
      "dos",
      0.1
    ],
    [
      "posterieur",
      0.1
    ],
    [
      "poupe",
      0.1
    ],
    [
      "queue",
      0.1
    ],
    [
      "retard",
      0.1
    ]
  ],
  "redevenir": [],
  "final": [
    [
      "dernier",
      0.2125
    ],
    [
      "extreme",
      0.2125
    ],
    [
      "ultime",
      0.1425
    ],
    [
      "definitif",
      0.07
    ],
    [
      "fin",
      0.07
    ],
    [
      "supreme",
      0.07
    ],
    [
      "terme",
      0.07
    ],
    [
      "terminal",
      0.07
    ],
    [
      "teleologique",
      0.07
    ]
  ],
  "allee": [
    [
      "marcher",
      0.065
    ],
    [
      "courir",
      0.0375
    ],
    [
      "passer",
      0.0375
    ],
    [
      "gagner",
      0.0325
    ],
    [
      "convenir",
      0.0275
    ],
    [
      "aboutir",
      0.025
    ],
    [
      "arriver",
      0.0225
    ],
    [
      "prendre",
      0.0225
    ],
    [
      "avancer",
      0.02
    ],
    [
      "toucher",
      0.0175
    ],
    [
      "tendre",
      0.0175
    ],
    [
      "monter",
      0.0175
    ],
    [
      "tomber",
      0.015
    ],
    [
      "tirer",
      0.015
    ],
    [
      "s'acheminer",
      0.015
    ],
    [
      "pousser",
      0.015
    ],
    [
      "piquer",
      0.015
    ],
    [
      "deambuler",
      0.015
    ],
    [
      "atteindre",
      0.015
    ],
    [
      "progresser",
      0.0125
    ],
    [
      "filer",
      0.0125
    ],
    [
      "errer",
      0.0125
    ],
    [
      "concorder",
      0.0125
    ],
    [
      "cadrer",
      0.0125
    ],
    [
      "affluer",
      0.0125
    ],
    [
      "voyager",
      0.01
    ],
    [
      "voler",
      0.01
    ],
    [
      "poursuivre",
      0.01
    ],
    [
      "plaire",
      0.01
    ],
    [
      "s'accorder",
      0.0075
    ],
    [
      "interesser",
      0.0075
    ],
    [
      "gazer",
      0.0075
    ],
    [
      "entrer",
      0.0075
    ],
    [
      "conduire",
      0.0075
    ],
    [
      "coller",
      0.0075
    ],
    [
      "cheminer",
      0.0075
    ],
    [
      "s'ajuster",
      0.005
    ],
    [
      "s'harmoniser",
      0.005
    ],
    [
      "traverser",
      0.005
    ],
    [
      "evoluer",
      0.005
    ],
    [
      "s'adresser",
      0.005
    ],
    [
      "s'adapter",
      0.005
    ],
    [
      "botter",
      0.005
    ],
    [
      "devancer",
      0.005
    ],
    [
      "distancer",
      0.005
    ],
    [
      "deriver",
      0.005
    ],
    [
      "penetrer",
      0.005
    ],
    [
      "proceder",
      0.0025
    ],
    [
      "preceder",
      0.0025
    ],
    [
      "retourner",
      0.0025
    ],
    [
      "s'approcher",
      0.0025
    ],
    [
      "s'ecouler",
      0.0025
    ],
    [
      "s'elever",
      0.0025
    ],
    [
      "seoir",
      0.0025
    ],
    [
      "solliciter",
      0.0025
    ],
    [
      "obliquer",
      0.0025
    ],
    [
      "mener",
      0.0025
    ],
    [
      "agreer",
      0.0025
    ],
    [
      "bicher",
      0.0025
    ],
    [
      "cingler",
      0.0025
    ],
    [
      "continuer",
      0.0025
    ],
    [
      "converger",
      0.0025
    ],
    [
      "correspondre",
      0.0025
    ],
    [
      "desservir",
      0.0025
    ],
    [
      "devier",
      0.0025
    ],
    [
      "habiller",
      0.0025
    ],
    [
      "peregriner",
      0.0
    ],
    [
      "refluer",
      0.0
    ],
    [
      "saquer",
      0.0
    ],
    [
      "sourire",
      0.0
    ],
    [
      "vaguer",
      0.0
    ],
    [
      "etre",
      0.0
    ],
    [
      "parcourir",
      0.0
    ],
    [
      "galoper",
      0.0
    ],
    [
      "accompagner",
      0.0
    ],
    [
      "baguenauder",
      0.0
    ],
    [
      "biaiser",
      0.0
    ],
    [
      "concerner",
      0.0
    ],
    [
      "fonctionner",
      0.0
    ],
    [
      "frequenter",
      0.0
    ]
  ],
  "photo": [
    [
      "photographie",
      0.265
    ],
    [
      "image",
      0.2
    ],
    [
      "cliche",
      0.1325
    ],
    [
      "vue",
      0.1325
    ],
    [
      "carte",
      0.065
    ],
    [
      "diapositive",
      0.065
    ],
    [
      "pellicule",
      0.065
    ],
    [
      "portrait",
      0.065
    ]
  ],
  "rideau": [
    [
      "ecran",
      0.155
    ],
    [
      "voile",
      0.05
    ],
    [
      "voilage",
      0.05
    ],
    [
      "tenture",
      0.05
    ],
    [
      "tablier",
      0.05
    ],
    [
      "store",
      0.05
    ],
    [
      "protection",
      0.05
    ],
    [
      "draperie",
      0.05
    ],
    [
      "banne",
      0.05
    ],
    [
      "abri",
      0.05
    ],
    [
      "obstacle",
      0.025
    ],
    [
      "pan",
      0.025
    ],
    [
      "portiere",
      0.025
    ],
    [
      "rangee",
      0.025
    ],
    [
      "toile",
      0.025
    ],
    [
      "volet",
      0.025
    ],
    [
      "moustiquaire",
      0.025
    ],
    [
      "ligne",
      0.025
    ],
    [
      "custode",
      0.025
    ],
    [
      "courtine",
      0.025
    ],
    [
      "cantonniere",
      0.025
    ],
    [
      "assez",
      0.025
    ],
    [
      "etoffe",
      0.025
    ]
  ],
  "applaudissement": [
    [
      "eloge",
      0.1475
    ],
    [
      "approbation",
      0.1175
    ],
    [
      "acclamation",
      0.0875
    ],
    [
      "bravo",
      0.0875
    ],
    [
      "louange",
      0.0875
    ],
    [
      "ovation",
      0.0575
    ],
    [
      "felicitation",
      0.0575
    ],
    [
      "encouragement",
      0.0575
    ],
    [
      "compliment",
      0.0575
    ],
    [
      "satisfaction",
      0.0275
    ],
    [
      "claquement",
      0.0275
    ],
    [
      "benediction",
      0.0275
    ],
    [
      "bis",
      0.0275
    ],
    [
      "battement",
      0.0275
    ],
    [
      "ban",
      0.0275
    ],
    [
      "admiration",
      0.0275
    ],
    [
      "suffrage",
      0.0275
    ]
  ],
  "saigner": [
    [
      "tuer",
      0.1725
    ],
    [
      "epuiser",
      0.1725
    ],
    [
      "abattre",
      0.13
    ],
    [
      "egorger",
      0.13
    ],
    [
      "etriper",
      0.085
    ],
    [
      "vider",
      0.085
    ],
    [
      "depenser",
      0.0425
    ],
    [
      "depouiller",
      0.0425
    ],
    [
      "poignarder",
      0.0425
    ],
    [
      "pressurer",
      0.0425
    ],
    [
      "ranconner",
      0.0425
    ]
  ],
  "roder": [
    [
      "errer",
      0.205
    ],
    [
      "flaner",
      0.1125
    ],
    [
      "vagabonder",
      0.0925
    ],
    [
      "marcher",
      0.0825
    ],
    [
      "trainer",
      0.07
    ],
    [
      "vaguer",
      0.05
    ],
    [
      "trainasser",
      0.04
    ],
    [
      "deambuler",
      0.03
    ],
    [
      "s'egarer",
      0.03
    ],
    [
      "vadrouiller",
      0.03
    ],
    [
      "trotter",
      0.02
    ],
    [
      "tournoyer",
      0.02
    ],
    [
      "tourner",
      0.02
    ],
    [
      "tournailler",
      0.02
    ],
    [
      "divaguer",
      0.02
    ],
    [
      "courir",
      0.02
    ],
    [
      "rodailler",
      0.0075
    ],
    [
      "trimarder",
      0.0075
    ]
  ],
  "fraude": [
    [
      "tromperie",
      0.2
    ],
    [
      "escroquerie",
      0.0725
    ],
    [
      "tripotage",
      0.0725
    ],
    [
      "truquage",
      0.0725
    ],
    [
      "falsification",
      0.0525
    ],
    [
      "maquignonnage",
      0.0525
    ],
    [
      "truc",
      0.0525
    ],
    [
      "tricherie",
      0.035
    ],
    [
      "grivelerie",
      0.035
    ],
    [
      "artifice",
      0.035
    ],
    [
      "alteration",
      0.035
    ],
    [
      "supposition",
      0.0175
    ],
    [
      "supercherie",
      0.0175
    ],
    [
      "ruse",
      0.0175
    ],
    [
      "resquille",
      0.0175
    ],
    [
      "malversation",
      0.0175
    ],
    [
      "interlope",
      0.0175
    ],
    [
      "hypocrisie",
      0.0175
    ],
    [
      "gabegie",
      0.0175
    ],
    [
      "dol",
      0.0175
    ],
    [
      "crime",
      0.0175
    ],
    [
      "contrefacon",
      0.0175
    ],
    [
      "contrebande",
      0.0175
    ],
    [
      "astuce",
      0.0175
    ],
    [
      "tartuferie",
      0.0175
    ]
  ],
  "frauder": [
    [
      "tricher",
      0.235
    ],
    [
      "tromper",
      0.235
    ],
    [
      "frustrer",
      0.1175
    ],
    [
      "resquiller",
      0.0575
    ],
    [
      "priver",
      0.0575
    ],
    [
      "frelater",
      0.0575
    ],
    [
      "dissimuler",
      0.0575
    ],
    [
      "copier",
      0.0575
    ],
    [
      "berner",
      0.0575
    ],
    [
      "truander",
      0.0575
    ]
  ],
  "coton": [
    [
      "cale",
      0.1425
    ],
    [
      "cotonnade",
      0.1425
    ],
    [
      "difficile",
      0.1425
    ],
    [
      "duvet",
      0.1425
    ],
    [
      "jumel",
      0.1425
    ],
    [
      "ouate",
      0.1425
    ],
    [
      "pyroxyle",
      0.1425
    ]
  ],
  "recours": [
    [
      "user",
      0.1875
    ],
    [
      "s'adresser",
      0.125
    ],
    [
      "utiliser",
      0.125
    ],
    [
      "pratiquer",
      0.06
    ],
    [
      "emprunter",
      0.06
    ],
    [
      "employer",
      0.06
    ]
  ],
  "recourir": [
    [
      "user",
      0.1875
    ],
    [
      "s'adresser",
      0.125
    ],
    [
      "utiliser",
      0.125
    ],
    [
      "pratiquer",
      0.06
    ],
    [
      "emprunter",
      0.06
    ],
    [
      "employer",
      0.06
    ]
  ],
  "triche": [
    [
      "tricherie",
      1.0
    ]
  ],
  "tricher": [
    [
      "frauder",
      0.1725
    ],
    [
      "tromper",
      0.1725
    ],
    [
      "dissimuler",
      0.085
    ],
    [
      "gonfler",
      0.085
    ],
    [
      "maquiller",
      0.085
    ],
    [
      "truquer",
      0.085
    ],
    [
      "souffler",
      0.0425
    ],
    [
      "resquiller",
      0.0425
    ],
    [
      "piper",
      0.0425
    ],
    [
      "filouter",
      0.0425
    ],
    [
      "filer",
      0.0425
    ],
    [
      "copier",
      0.0425
    ],
    [
      "truander",
      0.0425
    ]
  ],
  "guide": [
    [
      "chef",
      0.0575
    ],
    [
      "conducteur",
      0.0575
    ],
    [
      "conseiller",
      0.0575
    ],
    [
      "inspirateur",
      0.0575
    ],
    [
      "directeur",
      0.0475
    ],
    [
      "instigateur",
      0.0475
    ],
    [
      "mentor",
      0.0475
    ],
    [
      "memento",
      0.0375
    ],
    [
      "pilote",
      0.0275
    ],
    [
      "notice",
      0.0275
    ],
    [
      "cicerone",
      0.0275
    ],
    [
      "educateur",
      0.0175
    ],
    [
      "rene",
      0.0175
    ],
    [
      "pasteur",
      0.0175
    ],
    [
      "nautonier",
      0.0175
    ],
    [
      "laniere",
      0.0175
    ],
    [
      "gouverneur",
      0.0175
    ],
    [
      "cornac",
      0.0175
    ],
    [
      "conseil",
      0.0175
    ],
    [
      "cavalier",
      0.0175
    ],
    [
      "buffleterie",
      0.0175
    ],
    [
      "bride",
      0.0175
    ],
    [
      "berger",
      0.0175
    ],
    [
      "ange",
      0.0175
    ],
    [
      "pygmalion",
      0.0075
    ],
    [
      "plan",
      0.0075
    ],
    [
      "muse",
      0.0075
    ],
    [
      "rainure",
      0.0075
    ],
    [
      "recette",
      0.0075
    ],
    [
      "rollet",
      0.0075
    ],
    [
      "soldat",
      0.0075
    ],
    [
      "eclaireur",
      0.0075
    ],
    [
      "egerie",
      0.0075
    ],
    [
      "manuel",
      0.0075
    ],
    [
      "introducteur",
      0.0075
    ],
    [
      "boitard",
      0.0075
    ],
    [
      "boussole",
      0.0075
    ],
    [
      "catalogue",
      0.0075
    ],
    [
      "coryphee",
      0.0075
    ],
    [
      "depliant",
      0.0075
    ],
    [
      "fil",
      0.0075
    ],
    [
      "flambeau",
      0.0075
    ],
    [
      "gardien",
      0.0075
    ],
    [
      "glissiere",
      0.0075
    ],
    [
      "indicateur",
      0.0075
    ],
    [
      "accompagnateur",
      0.0075
    ]
  ],
  "swing": [
    [
      "rythme",
      1.0
    ]
  ],
  "feeling": [],
  "decibel": [],
  "bang": [
    [
      "bing",
      1.0
    ]
  ],
  "remballer": [
    [
      "rabrouer",
      0.22
    ],
    [
      "rembarrer",
      0.22
    ],
    [
      "houspiller",
      0.11
    ],
    [
      "remiser",
      0.11
    ],
    [
      "rempaqueter",
      0.11
    ],
    [
      "reemballer",
      0.11
    ]
  ],
  "show": [
    [
      "feerie",
      0.25
    ],
    [
      "numero",
      0.25
    ],
    [
      "spectacle",
      0.25
    ]
  ],
  "equipe": [
    [
      "groupe",
      0.26
    ],
    [
      "troupe",
      0.215
    ],
    [
      "brigade",
      0.085
    ],
    [
      "quadrille",
      0.0425
    ],
    [
      "pool",
      0.0425
    ],
    [
      "formation",
      0.0425
    ],
    [
      "escouade",
      0.0425
    ],
    [
      "combinaison",
      0.0425
    ],
    [
      "collectif",
      0.0425
    ],
    [
      "camp",
      0.0425
    ],
    [
      "cabinet",
      0.0425
    ],
    [
      "bande",
      0.0425
    ],
    [
      "ecurie",
      0.0425
    ]
  ],
  "equiper": [
    [
      "munir",
      0.14
    ],
    [
      "armer",
      0.12
    ],
    [
      "pourvoir",
      0.12
    ],
    [
      "fournir",
      0.1
    ],
    [
      "garnir",
      0.08
    ],
    [
      "renforcer",
      0.08
    ],
    [
      "greer",
      0.04
    ],
    [
      "fortifier",
      0.04
    ],
    [
      "procurer",
      0.0175
    ],
    [
      "outiller",
      0.0175
    ],
    [
      "organiser",
      0.0175
    ],
    [
      "mecaniser",
      0.0175
    ],
    [
      "installer",
      0.0175
    ],
    [
      "habiller",
      0.0175
    ],
    [
      "freter",
      0.0175
    ],
    [
      "fringuer",
      0.0175
    ],
    [
      "entretenir",
      0.0175
    ],
    [
      "doter",
      0.0175
    ],
    [
      "appareiller",
      0.0175
    ],
    [
      "amenager",
      0.0175
    ],
    [
      "accoutrer",
      0.0175
    ],
    [
      "etoffer",
      0.0175
    ]
  ],
  "imbattable": [
    [
      "invincible",
      0.3
    ],
    [
      "invulnerable",
      0.2
    ],
    [
      "desesperant",
      0.1
    ],
    [
      "fort",
      0.1
    ],
    [
      "inattaquable",
      0.1
    ],
    [
      "incollable",
      0.1
    ],
    [
      "inexpugnable",
      0.1
    ]
  ],
  "babine": [
    [
      "levre",
      0.4
    ],
    [
      "babouin",
      0.2
    ],
    [
      "badigoince",
      0.2
    ],
    [
      "lippe",
      0.2
    ]
  ],
  "bagarre": [
    [
      "querelle",
      0.105
    ],
    [
      "dispute",
      0.0975
    ],
    [
      "bataille",
      0.0875
    ],
    [
      "discussion",
      0.08
    ],
    [
      "rixe",
      0.08
    ],
    [
      "lutte",
      0.0625
    ],
    [
      "combat",
      0.055
    ],
    [
      "grabuge",
      0.0475
    ],
    [
      "echauffouree",
      0.0475
    ],
    [
      "altercation",
      0.03
    ],
    [
      "melee",
      0.03
    ],
    [
      "chicane",
      0.0225
    ],
    [
      "chahut",
      0.0225
    ],
    [
      "bruit",
      0.0225
    ],
    [
      "barouf",
      0.0225
    ],
    [
      "baroud",
      0.0225
    ],
    [
      "noise",
      0.015
    ],
    [
      "guerre",
      0.015
    ],
    [
      "desordre",
      0.015
    ],
    [
      "coup",
      0.015
    ],
    [
      "batterie",
      0.015
    ],
    [
      "rififi",
      0.0075
    ],
    [
      "rif",
      0.0075
    ],
    [
      "pugilat",
      0.0075
    ],
    [
      "explication",
      0.0075
    ],
    [
      "crosses",
      0.0075
    ],
    [
      "collision",
      0.0075
    ],
    [
      "casse",
      0.0075
    ],
    [
      "rebecca",
      0.0075
    ]
  ],
  "prevenir": [
    [
      "avertir",
      0.115
    ],
    [
      "informer",
      0.09
    ],
    [
      "annoncer",
      0.0775
    ],
    [
      "devancer",
      0.0625
    ],
    [
      "eviter",
      0.0625
    ],
    [
      "parer",
      0.05
    ],
    [
      "detourner",
      0.05
    ],
    [
      "aviser",
      0.05
    ],
    [
      "alerter",
      0.0375
    ],
    [
      "instruire",
      0.0375
    ],
    [
      "tourner",
      0.025
    ],
    [
      "preceder",
      0.025
    ],
    [
      "dire",
      0.025
    ],
    [
      "crier",
      0.025
    ],
    [
      "conjurer",
      0.025
    ],
    [
      "preoccuper",
      0.0125
    ],
    [
      "pousser",
      0.0125
    ],
    [
      "obvier",
      0.0125
    ],
    [
      "influencer",
      0.0125
    ],
    [
      "escompter",
      0.0125
    ],
    [
      "empecher",
      0.0125
    ],
    [
      "anticiper",
      0.0125
    ],
    [
      "admonester",
      0.0125
    ],
    [
      "preserver",
      0.0125
    ]
  ],
  "negro": [],
  "peureux": [
    [
      "poltron",
      0.135
    ],
    [
      "lache",
      0.1025
    ],
    [
      "capon",
      0.0925
    ],
    [
      "froussard",
      0.0925
    ],
    [
      "pusillanime",
      0.0925
    ],
    [
      "craintif",
      0.0725
    ],
    [
      "couard",
      0.05
    ],
    [
      "timide",
      0.04
    ],
    [
      "timore",
      0.04
    ],
    [
      "trouillard",
      0.03
    ],
    [
      "pleutre",
      0.03
    ],
    [
      "inquiet",
      0.03
    ],
    [
      "foireux",
      0.03
    ],
    [
      "tremblant",
      0.02
    ],
    [
      "petochard",
      0.02
    ],
    [
      "peteux",
      0.02
    ],
    [
      "degonfle",
      0.02
    ],
    [
      "angoisse",
      0.02
    ],
    [
      "affole",
      0.02
    ],
    [
      "intimide",
      0.01
    ],
    [
      "ombrageux",
      0.01
    ]
  ],
  "verse": [
    [
      "repandre",
      0.085
    ],
    [
      "couler",
      0.0525
    ],
    [
      "donner",
      0.0525
    ],
    [
      "payer",
      0.0525
    ],
    [
      "renverser",
      0.0525
    ],
    [
      "prodiguer",
      0.04
    ],
    [
      "epandre",
      0.03
    ],
    [
      "transvaser",
      0.03
    ],
    [
      "mettre",
      0.03
    ],
    [
      "jeter",
      0.03
    ],
    [
      "chavirer",
      0.03
    ],
    [
      "arroser",
      0.03
    ],
    [
      "infuser",
      0.02
    ],
    [
      "instiller",
      0.02
    ],
    [
      "regler",
      0.02
    ],
    [
      "tomber",
      0.02
    ],
    [
      "transfuser",
      0.02
    ],
    [
      "vider",
      0.02
    ],
    [
      "epancher",
      0.02
    ],
    [
      "financer",
      0.02
    ],
    [
      "deverser",
      0.02
    ],
    [
      "deposer",
      0.02
    ],
    [
      "adjoindre",
      0.02
    ],
    [
      "basculer",
      0.02
    ],
    [
      "coucher",
      0.02
    ],
    [
      "culbuter",
      0.02
    ],
    [
      "debourser",
      0.02
    ],
    [
      "decaisser",
      0.02
    ],
    [
      "depenser",
      0.02
    ],
    [
      "sombrer",
      0.0075
    ],
    [
      "servir",
      0.0075
    ],
    [
      "retourner",
      0.0075
    ],
    [
      "remplir",
      0.0075
    ],
    [
      "nommer",
      0.0075
    ],
    [
      "muter",
      0.0075
    ],
    [
      "incorporer",
      0.0075
    ],
    [
      "entonner",
      0.0075
    ],
    [
      "ajouter",
      0.0075
    ],
    [
      "transvider",
      0.0075
    ]
  ],
  "rafale": [
    [
      "bourrasque",
      0.12
    ],
    [
      "tempete",
      0.105
    ],
    [
      "tornade",
      0.105
    ],
    [
      "typhon",
      0.09
    ],
    [
      "trombe",
      0.06
    ],
    [
      "salve",
      0.06
    ],
    [
      "decharge",
      0.06
    ],
    [
      "orage",
      0.045
    ],
    [
      "ouragan",
      0.045
    ],
    [
      "vent",
      0.045
    ],
    [
      "volee",
      0.03
    ],
    [
      "tourbillon",
      0.03
    ],
    [
      "malheur",
      0.03
    ],
    [
      "bordee",
      0.0125
    ],
    [
      "grain",
      0.0125
    ],
    [
      "risee",
      0.0125
    ],
    [
      "souffle",
      0.0125
    ],
    [
      "tir",
      0.0125
    ]
  ],
  "tir": [
    [
      "decharge",
      0.1825
    ],
    [
      "salve",
      0.1825
    ],
    [
      "bombardement",
      0.09
    ],
    [
      "coup",
      0.09
    ],
    [
      "feu",
      0.09
    ],
    [
      "pointage",
      0.09
    ],
    [
      "rafale",
      0.09
    ],
    [
      "shoot",
      0.09
    ],
    [
      "stand",
      0.09
    ]
  ],
  "couru": [
    [
      "filer",
      0.0525
    ],
    [
      "aller",
      0.05
    ],
    [
      "poursuivre",
      0.045
    ],
    [
      "voler",
      0.035
    ],
    [
      "passer",
      0.035
    ],
    [
      "fuir",
      0.035
    ],
    [
      "couler",
      0.0325
    ],
    [
      "foncer",
      0.0325
    ],
    [
      "s'enfuir",
      0.0325
    ],
    [
      "detaler",
      0.0225
    ],
    [
      "circuler",
      0.0225
    ],
    [
      "chercher",
      0.0175
    ],
    [
      "s'envoler",
      0.0125
    ],
    [
      "s'empresser",
      0.0125
    ],
    [
      "s'agiter",
      0.0125
    ],
    [
      "chasser",
      0.0125
    ],
    [
      "affluer",
      0.0125
    ],
    [
      "traverser",
      0.01
    ],
    [
      "tendre",
      0.01
    ],
    [
      "s'elancer",
      0.01
    ],
    [
      "s'ecouler",
      0.01
    ],
    [
      "presser",
      0.01
    ],
    [
      "pourchasser",
      0.01
    ],
    [
      "hanter",
      0.01
    ],
    [
      "galoper",
      0.01
    ],
    [
      "errer",
      0.01
    ],
    [
      "bondir",
      0.01
    ],
    [
      "sillonner",
      0.0075
    ],
    [
      "talonner",
      0.0075
    ],
    [
      "tracer",
      0.0075
    ],
    [
      "visiter",
      0.0075
    ],
    [
      "voyager",
      0.0075
    ],
    [
      "parcourir",
      0.0075
    ],
    [
      "glisser",
      0.0075
    ],
    [
      "cavaler",
      0.0075
    ],
    [
      "decaniller",
      0.0075
    ],
    [
      "essayer",
      0.0075
    ],
    [
      "faire",
      0.0075
    ],
    [
      "fondre",
      0.0075
    ],
    [
      "frequenter",
      0.0075
    ],
    [
      "sprinter",
      0.0025
    ],
    [
      "toucher",
      0.0025
    ],
    [
      "troler",
      0.0025
    ],
    [
      "voltiger",
      0.0025
    ],
    [
      "s'etendre",
      0.0025
    ],
    [
      "roder",
      0.0025
    ],
    [
      "relancer",
      0.0025
    ],
    [
      "accourir",
      0.0025
    ],
    [
      "accelerer",
      0.0025
    ],
    [
      "aspirer",
      0.0025
    ],
    [
      "continuer",
      0.0025
    ],
    [
      "gazer",
      0.0025
    ],
    [
      "importuner",
      0.0025
    ],
    [
      "rechercher",
      0.0025
    ],
    [
      "gambader",
      0.0
    ],
    [
      "pouloper",
      0.0
    ],
    [
      "pedaler",
      0.0
    ],
    [
      "tenter",
      0.0
    ],
    [
      "trisser",
      0.0
    ],
    [
      "droper",
      0.0
    ],
    [
      "draguer",
      0.0
    ],
    [
      "caleter",
      0.0
    ],
    [
      "claquer",
      0.0
    ],
    [
      "courailler",
      0.0
    ],
    [
      "courre",
      0.0
    ],
    [
      "courser",
      0.0
    ],
    [
      "distancer",
      0.0
    ],
    [
      "trotter",
      0.0
    ]
  ],
  "descente": [
    [
      "incursion",
      0.0875
    ],
    [
      "chute",
      0.0725
    ],
    [
      "invasion",
      0.0575
    ],
    [
      "raid",
      0.0575
    ],
    [
      "visite",
      0.0425
    ],
    [
      "irruption",
      0.0425
    ],
    [
      "expedition",
      0.0425
    ],
    [
      "decadence",
      0.0425
    ],
    [
      "attaque",
      0.0425
    ],
    [
      "abaissement",
      0.0425
    ],
    [
      "transport",
      0.0275
    ],
    [
      "razzia",
      0.0275
    ],
    [
      "baisse",
      0.0275
    ],
    [
      "operation",
      0.0125
    ],
    [
      "pente",
      0.0125
    ],
    [
      "perquisition",
      0.0125
    ],
    [
      "plongee",
      0.0125
    ],
    [
      "prolapsus",
      0.0125
    ],
    [
      "ptose",
      0.0125
    ],
    [
      "rafle",
      0.0125
    ],
    [
      "ruee",
      0.0125
    ],
    [
      "schuss",
      0.0125
    ],
    [
      "echelle",
      0.0125
    ],
    [
      "hernie",
      0.0125
    ],
    [
      "gosier",
      0.0125
    ],
    [
      "avalage",
      0.0125
    ],
    [
      "avalaison",
      0.0125
    ],
    [
      "carpette",
      0.0125
    ],
    [
      "chemin",
      0.0125
    ],
    [
      "debarquement",
      0.0125
    ],
    [
      "degringolade",
      0.0125
    ],
    [
      "deplacement",
      0.0125
    ],
    [
      "deposition",
      0.0125
    ],
    [
      "envahissement",
      0.0125
    ],
    [
      "escalier",
      0.0125
    ],
    [
      "etiage",
      0.0125
    ]
  ],
  "paver": [
    [
      "couvrir",
      0.25
    ],
    [
      "carreler",
      0.125
    ],
    [
      "daller",
      0.125
    ],
    [
      "recouvrir",
      0.125
    ],
    [
      "revetir",
      0.125
    ],
    [
      "repandre",
      0.125
    ],
    [
      "tapisser",
      0.125
    ]
  ],
  "pave": [
    [
      "couvrir",
      0.25
    ],
    [
      "carreler",
      0.125
    ],
    [
      "daller",
      0.125
    ],
    [
      "recouvrir",
      0.125
    ],
    [
      "revetir",
      0.125
    ],
    [
      "repandre",
      0.125
    ],
    [
      "tapisser",
      0.125
    ]
  ],
  "commando": [
    [
      "troupe",
      0.4
    ],
    [
      "colonne",
      0.2
    ],
    [
      "detachement",
      0.2
    ],
    [
      "raid",
      0.2
    ]
  ],
  "millier": [],
  "interdit": [
    [
      "empecher",
      0.095
    ],
    [
      "etonner",
      0.06
    ],
    [
      "supprimer",
      0.055
    ],
    [
      "exclure",
      0.0475
    ],
    [
      "proscrire",
      0.04
    ],
    [
      "prohiber",
      0.04
    ],
    [
      "defendre",
      0.04
    ],
    [
      "deconcerter",
      0.04
    ],
    [
      "bannir",
      0.0325
    ],
    [
      "petrifier",
      0.025
    ],
    [
      "interloquer",
      0.025
    ],
    [
      "embarrasser",
      0.025
    ],
    [
      "condamner",
      0.025
    ],
    [
      "casser",
      0.025
    ],
    [
      "ebahir",
      0.02
    ],
    [
      "troubler",
      0.02
    ],
    [
      "suspendre",
      0.02
    ],
    [
      "siderer",
      0.02
    ],
    [
      "saisir",
      0.02
    ],
    [
      "s'opposer",
      0.02
    ],
    [
      "revoquer",
      0.02
    ],
    [
      "priver",
      0.02
    ],
    [
      "paralyser",
      0.02
    ],
    [
      "inhiber",
      0.02
    ],
    [
      "fermer",
      0.02
    ],
    [
      "deposer",
      0.02
    ],
    [
      "destituer",
      0.02
    ],
    [
      "confondre",
      0.02
    ],
    [
      "censurer",
      0.02
    ],
    [
      "meduser",
      0.0125
    ],
    [
      "foudroyer",
      0.0125
    ],
    [
      "excommunier",
      0.0125
    ],
    [
      "consigner",
      0.0125
    ],
    [
      "boycotter",
      0.005
    ],
    [
      "dispenser",
      0.005
    ],
    [
      "deconfire",
      0.005
    ],
    [
      "releguer",
      0.005
    ],
    [
      "sevrer",
      0.005
    ]
  ],
  "interdire": [
    [
      "empecher",
      0.095
    ],
    [
      "etonner",
      0.06
    ],
    [
      "supprimer",
      0.055
    ],
    [
      "exclure",
      0.0475
    ],
    [
      "proscrire",
      0.04
    ],
    [
      "prohiber",
      0.04
    ],
    [
      "defendre",
      0.04
    ],
    [
      "deconcerter",
      0.04
    ],
    [
      "bannir",
      0.0325
    ],
    [
      "petrifier",
      0.025
    ],
    [
      "interloquer",
      0.025
    ],
    [
      "embarrasser",
      0.025
    ],
    [
      "condamner",
      0.025
    ],
    [
      "casser",
      0.025
    ],
    [
      "ebahir",
      0.02
    ],
    [
      "troubler",
      0.02
    ],
    [
      "suspendre",
      0.02
    ],
    [
      "siderer",
      0.02
    ],
    [
      "saisir",
      0.02
    ],
    [
      "s'opposer",
      0.02
    ],
    [
      "revoquer",
      0.02
    ],
    [
      "priver",
      0.02
    ],
    [
      "paralyser",
      0.02
    ],
    [
      "inhiber",
      0.02
    ],
    [
      "fermer",
      0.02
    ],
    [
      "deposer",
      0.02
    ],
    [
      "destituer",
      0.02
    ],
    [
      "confondre",
      0.02
    ],
    [
      "censurer",
      0.02
    ],
    [
      "meduser",
      0.0125
    ],
    [
      "foudroyer",
      0.0125
    ],
    [
      "excommunier",
      0.0125
    ],
    [
      "consigner",
      0.0125
    ],
    [
      "boycotter",
      0.005
    ],
    [
      "dispenser",
      0.005
    ],
    [
      "deconfire",
      0.005
    ],
    [
      "releguer",
      0.005
    ],
    [
      "sevrer",
      0.005
    ]
  ],
  "roupiller": [
    [
      "dormir",
      0.3325
    ],
    [
      "sommeiller",
      0.3325
    ],
    [
      "somnoler",
      0.3325
    ]
  ],
  "pallier": [
    [
      "remedier",
      0.125
    ],
    [
      "voiler",
      0.0725
    ],
    [
      "parer",
      0.0725
    ],
    [
      "farder",
      0.0725
    ],
    [
      "dissimuler",
      0.0725
    ],
    [
      "corriger",
      0.0725
    ],
    [
      "attenuer",
      0.0725
    ],
    [
      "temperer",
      0.0475
    ],
    [
      "suppleer",
      0.0475
    ],
    [
      "pourvoir",
      0.0475
    ],
    [
      "moderer",
      0.0475
    ],
    [
      "deguiser",
      0.0475
    ],
    [
      "cacher",
      0.0475
    ],
    [
      "couvrir",
      0.0225
    ],
    [
      "diminuer",
      0.0225
    ],
    [
      "guerir",
      0.0225
    ],
    [
      "obvier",
      0.0225
    ],
    [
      "travestir",
      0.0225
    ]
  ],
  "brigade": [
    [
      "groupe",
      0.265
    ],
    [
      "troupe",
      0.2
    ],
    [
      "equipe",
      0.1325
    ],
    [
      "armee",
      0.065
    ],
    [
      "escouade",
      0.065
    ],
    [
      "formation",
      0.065
    ],
    [
      "peloton",
      0.065
    ],
    [
      "pleiade",
      0.065
    ],
    [
      "quart",
      0.065
    ]
  ],
  "apporter": [
    [
      "produire",
      0.085
    ],
    [
      "donner",
      0.0725
    ],
    [
      "amener",
      0.06
    ],
    [
      "porter",
      0.055
    ],
    [
      "occasionner",
      0.0475
    ],
    [
      "provoquer",
      0.0475
    ],
    [
      "susciter",
      0.0475
    ],
    [
      "transporter",
      0.035
    ],
    [
      "soulever",
      0.035
    ],
    [
      "fournir",
      0.035
    ],
    [
      "entrainer",
      0.035
    ],
    [
      "determiner",
      0.035
    ],
    [
      "causer",
      0.03
    ],
    [
      "importer",
      0.03
    ],
    [
      "procurer",
      0.03
    ],
    [
      "rapporter",
      0.0225
    ],
    [
      "mettre",
      0.0225
    ],
    [
      "introduire",
      0.0175
    ],
    [
      "envoyer",
      0.0175
    ],
    [
      "engendrer",
      0.0175
    ],
    [
      "creer",
      0.0175
    ],
    [
      "appeler",
      0.0175
    ],
    [
      "prendre",
      0.01
    ],
    [
      "participer",
      0.01
    ],
    [
      "gratifier",
      0.01
    ],
    [
      "employer",
      0.01
    ],
    [
      "citer",
      0.01
    ],
    [
      "alleguer",
      0.01
    ],
    [
      "administrer",
      0.01
    ],
    [
      "faciliter",
      0.005
    ],
    [
      "declencher",
      0.005
    ],
    [
      "contribuer",
      0.005
    ],
    [
      "apprendre",
      0.005
    ],
    [
      "annoncer",
      0.005
    ],
    [
      "ajouter",
      0.005
    ],
    [
      "adoucir",
      0.005
    ],
    [
      "abouler",
      0.005
    ],
    [
      "soulager",
      0.005
    ]
  ],
  "belier": [
    [
      "boutoir",
      0.3325
    ],
    [
      "mouton",
      0.3325
    ],
    [
      "male",
      0.3325
    ]
  ],
  "chien": [
    [
      "charme",
      0.05
    ],
    [
      "elegance",
      0.0375
    ],
    [
      "radin",
      0.0375
    ],
    [
      "gardien",
      0.0375
    ],
    [
      "chic",
      0.0375
    ],
    [
      "avare",
      0.0375
    ],
    [
      "valet",
      0.025
    ],
    [
      "rat",
      0.025
    ],
    [
      "policier",
      0.025
    ],
    [
      "pingre",
      0.025
    ],
    [
      "ladre",
      0.025
    ],
    [
      "chiche",
      0.025
    ],
    [
      "cerbere",
      0.025
    ],
    [
      "canide",
      0.025
    ],
    [
      "appas",
      0.025
    ],
    [
      "lycaon",
      0.01
    ],
    [
      "limier",
      0.01
    ],
    [
      "lice",
      0.01
    ],
    [
      "larbin",
      0.01
    ],
    [
      "laquais",
      0.01
    ],
    [
      "lamie",
      0.01
    ],
    [
      "impitoyable",
      0.01
    ],
    [
      "houret",
      0.01
    ],
    [
      "molosse",
      0.01
    ],
    [
      "montant",
      0.01
    ],
    [
      "otocyon",
      0.01
    ],
    [
      "vautre",
      0.01
    ],
    [
      "toutou",
      0.01
    ],
    [
      "talon",
      0.01
    ],
    [
      "roquet",
      0.01
    ],
    [
      "rapiat",
      0.01
    ],
    [
      "piment",
      0.01
    ],
    [
      "pattu",
      0.01
    ],
    [
      "pataud",
      0.01
    ],
    [
      "grigou",
      0.01
    ],
    [
      "garde",
      0.01
    ],
    [
      "esclave",
      0.01
    ],
    [
      "canin",
      0.01
    ],
    [
      "caniche",
      0.01
    ],
    [
      "canaille",
      0.01
    ],
    [
      "caberu",
      0.01
    ],
    [
      "cabot",
      0.01
    ],
    [
      "berger",
      0.01
    ],
    [
      "barre",
      0.01
    ],
    [
      "attrait",
      0.01
    ],
    [
      "chienchien",
      0.01
    ],
    [
      "chienne",
      0.01
    ],
    [
      "cyon",
      0.01
    ],
    [
      "corniaud",
      0.01
    ],
    [
      "coriace",
      0.01
    ],
    [
      "clebard",
      0.01
    ],
    [
      "clebs",
      0.01
    ],
    [
      "classe",
      0.01
    ],
    [
      "clabaud",
      0.01
    ],
    [
      "chiot",
      0.01
    ],
    [
      "allure",
      0.01
    ]
  ],
  "renifler": [
    [
      "respirer",
      0.1475
    ],
    [
      "aspirer",
      0.11
    ],
    [
      "flairer",
      0.11
    ],
    [
      "humer",
      0.11
    ],
    [
      "sentir",
      0.11
    ],
    [
      "subodorer",
      0.0725
    ],
    [
      "renacler",
      0.0725
    ],
    [
      "repugner",
      0.035
    ],
    [
      "rechigner",
      0.035
    ],
    [
      "priser",
      0.035
    ],
    [
      "pressentir",
      0.035
    ],
    [
      "deviner",
      0.035
    ],
    [
      "boire",
      0.035
    ],
    [
      "s'ebrouer",
      0.035
    ]
  ],
  "bailler": [
    [
      "allouer",
      0.5
    ],
    [
      "donner",
      0.5
    ]
  ],
  "baille": [
    [
      "cuve",
      0.285
    ],
    [
      "baillotte",
      0.1425
    ],
    [
      "baquet",
      0.1425
    ],
    [
      "eau",
      0.1425
    ],
    [
      "mer",
      0.1425
    ],
    [
      "rafiot",
      0.1425
    ]
  ],
  "die": [],
  "million": [
    [
      "brique",
      0.5
    ],
    [
      "baton",
      0.5
    ]
  ],
  "detail": [
    [
      "bagatelle",
      0.0825
    ],
    [
      "developpement",
      0.0825
    ],
    [
      "expose",
      0.0825
    ],
    [
      "vetille",
      0.055
    ],
    [
      "ornement",
      0.055
    ],
    [
      "note",
      0.055
    ],
    [
      "denombrement",
      0.055
    ],
    [
      "broutille",
      0.055
    ],
    [
      "accessoire",
      0.055
    ],
    [
      "partie",
      0.025
    ],
    [
      "precision",
      0.025
    ],
    [
      "releve",
      0.025
    ],
    [
      "revue",
      0.025
    ],
    [
      "element",
      0.025
    ],
    [
      "particularite",
      0.025
    ],
    [
      "morceau",
      0.025
    ],
    [
      "minutie",
      0.025
    ],
    [
      "exposition",
      0.025
    ],
    [
      "decompte",
      0.025
    ],
    [
      "circonstance",
      0.025
    ],
    [
      "betise",
      0.025
    ],
    [
      "beatilles",
      0.025
    ],
    [
      "enumeration",
      0.025
    ]
  ],
  "perce": [
    [
      "transpercer",
      0.075
    ],
    [
      "penetrer",
      0.045
    ],
    [
      "paraitre",
      0.04
    ],
    [
      "poindre",
      0.0375
    ],
    [
      "reperer",
      0.0325
    ],
    [
      "decouvrir",
      0.0325
    ],
    [
      "ouvrir",
      0.0225
    ],
    [
      "saisir",
      0.0225
    ],
    [
      "surgir",
      0.0225
    ],
    [
      "piquer",
      0.0225
    ],
    [
      "dechirer",
      0.0225
    ],
    [
      "creuser",
      0.0175
    ],
    [
      "emerger",
      0.0175
    ],
    [
      "trouer",
      0.0175
    ],
    [
      "sortir",
      0.0175
    ],
    [
      "passer",
      0.0175
    ],
    [
      "naitre",
      0.0175
    ],
    [
      "transpirer",
      0.015
    ],
    [
      "sourdre",
      0.015
    ],
    [
      "pointer",
      0.015
    ],
    [
      "enfoncer",
      0.015
    ],
    [
      "crever",
      0.015
    ],
    [
      "arriver",
      0.015
    ],
    [
      "voir",
      0.0125
    ],
    [
      "traverser",
      0.0125
    ],
    [
      "reveler",
      0.0125
    ],
    [
      "marquer",
      0.0125
    ],
    [
      "eclore",
      0.01
    ],
    [
      "trouver",
      0.01
    ],
    [
      "forer",
      0.01
    ],
    [
      "entamer",
      0.01
    ],
    [
      "comprendre",
      0.01
    ],
    [
      "blesser",
      0.01
    ],
    [
      "atteindre",
      0.01
    ],
    [
      "sonder",
      0.0075
    ],
    [
      "s'elever",
      0.0075
    ],
    [
      "reussir",
      0.0075
    ],
    [
      "perforer",
      0.0075
    ],
    [
      "parvenir",
      0.0075
    ],
    [
      "fendre",
      0.0075
    ],
    [
      "deceler",
      0.0075
    ],
    [
      "tuer",
      0.005
    ],
    [
      "tarauder",
      0.005
    ],
    [
      "s'ouvrir",
      0.005
    ],
    [
      "rompre",
      0.005
    ],
    [
      "pressentir",
      0.005
    ],
    [
      "monter",
      0.005
    ],
    [
      "enfiler",
      0.005
    ],
    [
      "dechiffrer",
      0.005
    ],
    [
      "s'imposer",
      0.0025
    ],
    [
      "s'eventer",
      0.0025
    ],
    [
      "eventrer",
      0.0025
    ],
    [
      "prevoir",
      0.0025
    ],
    [
      "pratiquer",
      0.0025
    ],
    [
      "cribler",
      0.0025
    ],
    [
      "enfourcher",
      0.0025
    ],
    [
      "filtrer",
      0.0025
    ],
    [
      "frayer",
      0.0025
    ],
    [
      "lire",
      0.0025
    ],
    [
      "perler",
      0.0025
    ],
    [
      "poinconner",
      0.0025
    ],
    [
      "s'eveiller",
      0.0
    ],
    [
      "s'ebruiter",
      0.0
    ],
    [
      "s'ebaucher",
      0.0
    ],
    [
      "transparaitre",
      0.0
    ],
    [
      "tremper",
      0.0
    ],
    [
      "vriller",
      0.0
    ],
    [
      "ebraser",
      0.0
    ],
    [
      "etamper",
      0.0
    ],
    [
      "eventer",
      0.0
    ],
    [
      "s'infiltrer",
      0.0
    ],
    [
      "s'enfoncer",
      0.0
    ],
    [
      "aiguillonner",
      0.0
    ],
    [
      "aleser",
      0.0
    ],
    [
      "darder",
      0.0
    ],
    [
      "depister",
      0.0
    ],
    [
      "developper",
      0.0
    ],
    [
      "embrocher",
      0.0
    ],
    [
      "empaler",
      0.0
    ],
    [
      "encorner",
      0.0
    ],
    [
      "enferrer",
      0.0
    ],
    [
      "excaver",
      0.0
    ],
    [
      "fileter",
      0.0
    ],
    [
      "fusiller",
      0.0
    ],
    [
      "larder",
      0.0
    ],
    [
      "affleurer",
      0.0
    ]
  ],
  "percer": [
    [
      "transpercer",
      0.075
    ],
    [
      "penetrer",
      0.045
    ],
    [
      "paraitre",
      0.04
    ],
    [
      "poindre",
      0.0375
    ],
    [
      "reperer",
      0.0325
    ],
    [
      "decouvrir",
      0.0325
    ],
    [
      "ouvrir",
      0.0225
    ],
    [
      "saisir",
      0.0225
    ],
    [
      "surgir",
      0.0225
    ],
    [
      "piquer",
      0.0225
    ],
    [
      "dechirer",
      0.0225
    ],
    [
      "creuser",
      0.0175
    ],
    [
      "emerger",
      0.0175
    ],
    [
      "trouer",
      0.0175
    ],
    [
      "sortir",
      0.0175
    ],
    [
      "passer",
      0.0175
    ],
    [
      "naitre",
      0.0175
    ],
    [
      "transpirer",
      0.015
    ],
    [
      "sourdre",
      0.015
    ],
    [
      "pointer",
      0.015
    ],
    [
      "enfoncer",
      0.015
    ],
    [
      "crever",
      0.015
    ],
    [
      "arriver",
      0.015
    ],
    [
      "voir",
      0.0125
    ],
    [
      "traverser",
      0.0125
    ],
    [
      "reveler",
      0.0125
    ],
    [
      "marquer",
      0.0125
    ],
    [
      "eclore",
      0.01
    ],
    [
      "trouver",
      0.01
    ],
    [
      "forer",
      0.01
    ],
    [
      "entamer",
      0.01
    ],
    [
      "comprendre",
      0.01
    ],
    [
      "blesser",
      0.01
    ],
    [
      "atteindre",
      0.01
    ],
    [
      "sonder",
      0.0075
    ],
    [
      "s'elever",
      0.0075
    ],
    [
      "reussir",
      0.0075
    ],
    [
      "perforer",
      0.0075
    ],
    [
      "parvenir",
      0.0075
    ],
    [
      "fendre",
      0.0075
    ],
    [
      "deceler",
      0.0075
    ],
    [
      "tuer",
      0.005
    ],
    [
      "tarauder",
      0.005
    ],
    [
      "s'ouvrir",
      0.005
    ],
    [
      "rompre",
      0.005
    ],
    [
      "pressentir",
      0.005
    ],
    [
      "monter",
      0.005
    ],
    [
      "enfiler",
      0.005
    ],
    [
      "dechiffrer",
      0.005
    ],
    [
      "s'imposer",
      0.0025
    ],
    [
      "s'eventer",
      0.0025
    ],
    [
      "eventrer",
      0.0025
    ],
    [
      "prevoir",
      0.0025
    ],
    [
      "pratiquer",
      0.0025
    ],
    [
      "cribler",
      0.0025
    ],
    [
      "enfourcher",
      0.0025
    ],
    [
      "filtrer",
      0.0025
    ],
    [
      "frayer",
      0.0025
    ],
    [
      "lire",
      0.0025
    ],
    [
      "perler",
      0.0025
    ],
    [
      "poinconner",
      0.0025
    ],
    [
      "s'eveiller",
      0.0
    ],
    [
      "s'ebruiter",
      0.0
    ],
    [
      "s'ebaucher",
      0.0
    ],
    [
      "transparaitre",
      0.0
    ],
    [
      "tremper",
      0.0
    ],
    [
      "vriller",
      0.0
    ],
    [
      "ebraser",
      0.0
    ],
    [
      "etamper",
      0.0
    ],
    [
      "eventer",
      0.0
    ],
    [
      "s'infiltrer",
      0.0
    ],
    [
      "s'enfoncer",
      0.0
    ],
    [
      "aiguillonner",
      0.0
    ],
    [
      "aleser",
      0.0
    ],
    [
      "darder",
      0.0
    ],
    [
      "depister",
      0.0
    ],
    [
      "developper",
      0.0
    ],
    [
      "embrocher",
      0.0
    ],
    [
      "empaler",
      0.0
    ],
    [
      "encorner",
      0.0
    ],
    [
      "enferrer",
      0.0
    ],
    [
      "excaver",
      0.0
    ],
    [
      "fileter",
      0.0
    ],
    [
      "fusiller",
      0.0
    ],
    [
      "larder",
      0.0
    ],
    [
      "affleurer",
      0.0
    ]
  ],
  "consommateur": [
    [
      "acheteur",
      0.3325
    ],
    [
      "buveur",
      0.3325
    ],
    [
      "client",
      0.3325
    ]
  ],
  "superstar": [],
  "chichi": [
    [
      "affectation",
      0.1625
    ],
    [
      "manieres",
      0.1075
    ],
    [
      "simagrees",
      0.1075
    ],
    [
      "embarras",
      0.095
    ],
    [
      "facons",
      0.095
    ],
    [
      "grimace",
      0.0525
    ],
    [
      "ceremonie",
      0.0525
    ],
    [
      "chique",
      0.04
    ],
    [
      "singerie",
      0.04
    ],
    [
      "tralala",
      0.025
    ],
    [
      "simagree",
      0.025
    ],
    [
      "mines",
      0.025
    ],
    [
      "minauderies",
      0.025
    ],
    [
      "mignardise",
      0.025
    ],
    [
      "manierisme",
      0.025
    ],
    [
      "boucle",
      0.0125
    ],
    [
      "ceremonial",
      0.0125
    ],
    [
      "girie",
      0.0125
    ],
    [
      "meche",
      0.0125
    ],
    [
      "postiche",
      0.0125
    ]
  ],
  "fidele": [
    [
      "exact",
      0.1
    ],
    [
      "sur",
      0.06
    ],
    [
      "juste",
      0.0525
    ],
    [
      "honnete",
      0.05
    ],
    [
      "vrai",
      0.05
    ],
    [
      "solide",
      0.04
    ],
    [
      "loyal",
      0.0375
    ],
    [
      "sincere",
      0.0325
    ],
    [
      "scrupuleux",
      0.0325
    ],
    [
      "regulier",
      0.0325
    ],
    [
      "bon",
      0.0325
    ],
    [
      "franc",
      0.025
    ],
    [
      "attache",
      0.0225
    ],
    [
      "correct",
      0.0225
    ],
    [
      "precis",
      0.0225
    ],
    [
      "zele",
      0.0175
    ],
    [
      "veritable",
      0.0175
    ],
    [
      "ponctuel",
      0.0175
    ],
    [
      "devoue",
      0.0175
    ],
    [
      "constant",
      0.0175
    ],
    [
      "attentif",
      0.0175
    ],
    [
      "assidu",
      0.0175
    ],
    [
      "conforme",
      0.015
    ],
    [
      "veridique",
      0.01
    ],
    [
      "probe",
      0.01
    ],
    [
      "pratique",
      0.01
    ],
    [
      "perseverant",
      0.01
    ],
    [
      "objectif",
      0.01
    ],
    [
      "ouaille",
      0.005
    ],
    [
      "partisan",
      0.005
    ],
    [
      "pratiquant",
      0.005
    ],
    [
      "respectueux",
      0.005
    ],
    [
      "sectateur",
      0.005
    ],
    [
      "soumis",
      0.005
    ],
    [
      "egal",
      0.005
    ],
    [
      "immuable",
      0.005
    ],
    [
      "feal",
      0.005
    ],
    [
      "adorateur",
      0.005
    ],
    [
      "catholique",
      0.005
    ],
    [
      "chretien",
      0.005
    ],
    [
      "consequent",
      0.005
    ],
    [
      "croyant",
      0.005
    ],
    [
      "durable",
      0.005
    ],
    [
      "fervent",
      0.005
    ],
    [
      "observateur",
      0.0025
    ],
    [
      "obeissant",
      0.0025
    ],
    [
      "paroissien",
      0.0025
    ],
    [
      "proselyte",
      0.0025
    ],
    [
      "pelerin",
      0.0025
    ],
    [
      "regle",
      0.0025
    ],
    [
      "serviteur",
      0.0025
    ],
    [
      "litteral",
      0.0025
    ],
    [
      "fetichiste",
      0.0025
    ],
    [
      "fiable",
      0.0025
    ],
    [
      "favorable",
      0.0025
    ],
    [
      "disciple",
      0.0025
    ],
    [
      "conservateur",
      0.0025
    ],
    [
      "client",
      0.0025
    ],
    [
      "antrustion",
      0.0025
    ],
    [
      "adepte",
      0.0025
    ],
    [
      "eprouve",
      0.0025
    ]
  ],
  "chinois": [
    [
      "asiate",
      0.0625
    ],
    [
      "tamis",
      0.0625
    ],
    [
      "pointilleux",
      0.0625
    ],
    [
      "pinyin",
      0.0625
    ],
    [
      "passoire",
      0.0625
    ],
    [
      "original",
      0.0625
    ],
    [
      "mandarin",
      0.0625
    ],
    [
      "jaune",
      0.0625
    ],
    [
      "formosan",
      0.0625
    ],
    [
      "difficile",
      0.0625
    ],
    [
      "byzantin",
      0.0625
    ],
    [
      "bizarre",
      0.0625
    ],
    [
      "asiatique",
      0.0625
    ],
    [
      "taiwanais",
      0.0625
    ]
  ],
  "delta": [
    [
      "bouche",
      0.3325
    ],
    [
      "embouchure",
      0.3325
    ],
    [
      "triangle",
      0.3325
    ]
  ],
  "bif": [
    [
      "bifteck",
      0.5
    ],
    [
      "boeuf",
      0.5
    ]
  ],
  "brule": [
    [
      "consumer",
      0.075
    ],
    [
      "embraser",
      0.055
    ],
    [
      "griller",
      0.0525
    ],
    [
      "enflammer",
      0.0475
    ],
    [
      "devorer",
      0.0375
    ],
    [
      "calciner",
      0.0375
    ],
    [
      "detruire",
      0.035
    ],
    [
      "piquer",
      0.03
    ],
    [
      "prendre",
      0.03
    ],
    [
      "manger",
      0.025
    ],
    [
      "flamber",
      0.025
    ],
    [
      "exciter",
      0.025
    ],
    [
      "dessecher",
      0.025
    ],
    [
      "chauffer",
      0.025
    ],
    [
      "cuire",
      0.02
    ],
    [
      "ronger",
      0.02
    ],
    [
      "rotir",
      0.02
    ],
    [
      "incendier",
      0.0175
    ],
    [
      "faire",
      0.0175
    ],
    [
      "donner",
      0.0175
    ],
    [
      "carboniser",
      0.0175
    ],
    [
      "boucaner",
      0.0175
    ],
    [
      "attiser",
      0.0175
    ],
    [
      "passer",
      0.0125
    ],
    [
      "cramer",
      0.0125
    ],
    [
      "consommer",
      0.0125
    ],
    [
      "allumer",
      0.0125
    ],
    [
      "miner",
      0.0075
    ],
    [
      "ravager",
      0.0075
    ],
    [
      "riffauder",
      0.0075
    ],
    [
      "s'embraser",
      0.0075
    ],
    [
      "tanner",
      0.0075
    ],
    [
      "trahir",
      0.0075
    ],
    [
      "livrer",
      0.0075
    ],
    [
      "irriter",
      0.0075
    ],
    [
      "corroder",
      0.0075
    ],
    [
      "discrediter",
      0.0075
    ],
    [
      "denoncer",
      0.0075
    ],
    [
      "enfievrer",
      0.0075
    ],
    [
      "flamboyer",
      0.0075
    ],
    [
      "fumer",
      0.0075
    ],
    [
      "haler",
      0.0075
    ],
    [
      "passionner",
      0.0025
    ],
    [
      "pincer",
      0.0025
    ],
    [
      "rougeoyer",
      0.0025
    ],
    [
      "roussir",
      0.0025
    ],
    [
      "roustir",
      0.0025
    ],
    [
      "rutiler",
      0.0025
    ],
    [
      "s'enflammer",
      0.0025
    ],
    [
      "incinerer",
      0.0025
    ],
    [
      "gresiller",
      0.0025
    ],
    [
      "fondre",
      0.0025
    ],
    [
      "arder",
      0.0025
    ],
    [
      "ardre",
      0.0025
    ],
    [
      "blesser",
      0.0025
    ],
    [
      "brouir",
      0.0025
    ],
    [
      "cauteriser",
      0.0025
    ],
    [
      "charbonner",
      0.0025
    ],
    [
      "convoiter",
      0.0025
    ],
    [
      "couver",
      0.0025
    ],
    [
      "culotter",
      0.0025
    ],
    [
      "demasquer",
      0.0025
    ],
    [
      "torrefier",
      0.0025
    ]
  ],
  "lande": [
    [
      "friche",
      0.2125
    ],
    [
      "jachere",
      0.2125
    ],
    [
      "brande",
      0.07
    ],
    [
      "prairie",
      0.07
    ],
    [
      "patis",
      0.07
    ],
    [
      "paturage",
      0.07
    ],
    [
      "steppe",
      0.035
    ],
    [
      "maquis",
      0.035
    ],
    [
      "gatine",
      0.035
    ],
    [
      "gueret",
      0.035
    ],
    [
      "garrigue",
      0.035
    ],
    [
      "bruyere",
      0.035
    ],
    [
      "brousse",
      0.035
    ],
    [
      "varenne",
      0.035
    ]
  ],
  "lacs": [
    [
      "etang",
      0.3325
    ],
    [
      "mare",
      0.1425
    ],
    [
      "bassin",
      0.095
    ],
    [
      "lagon",
      0.095
    ],
    [
      "marais",
      0.045
    ],
    [
      "loch",
      0.045
    ],
    [
      "lagune",
      0.045
    ],
    [
      "chott",
      0.045
    ],
    [
      "reservoir",
      0.045
    ]
  ],
  "suivant": [
    [
      "selon",
      0.0875
    ],
    [
      "futur",
      0.065
    ],
    [
      "successeur",
      0.0425
    ],
    [
      "remplacant",
      0.0425
    ],
    [
      "prochain",
      0.0425
    ],
    [
      "posterieur",
      0.0425
    ],
    [
      "disciple",
      0.0425
    ],
    [
      "deuxieme",
      0.0425
    ],
    [
      "d'apres",
      0.0425
    ],
    [
      "continuateur",
      0.0425
    ],
    [
      "autre",
      0.0425
    ],
    [
      "aide",
      0.0425
    ],
    [
      "inferieur",
      0.02
    ],
    [
      "subsequent",
      0.02
    ],
    [
      "suite",
      0.02
    ],
    [
      "suiveur",
      0.02
    ],
    [
      "ulterieur",
      0.02
    ],
    [
      "dans",
      0.02
    ],
    [
      "conformement",
      0.02
    ],
    [
      "confident",
      0.02
    ],
    [
      "caudataire",
      0.02
    ],
    [
      "assidu",
      0.02
    ],
    [
      "apres",
      0.02
    ],
    [
      "adorateur",
      0.02
    ],
    [
      "acolyte",
      0.02
    ]
  ],
  "irlandais": [
    [
      "gaelique",
      1.0
    ]
  ],
  "lac": [
    [
      "etang",
      0.3325
    ],
    [
      "mare",
      0.1425
    ],
    [
      "bassin",
      0.095
    ],
    [
      "lagon",
      0.095
    ],
    [
      "marais",
      0.045
    ],
    [
      "loch",
      0.045
    ],
    [
      "lagune",
      0.045
    ],
    [
      "chott",
      0.045
    ],
    [
      "reservoir",
      0.045
    ]
  ],
  "catholique": [
    [
      "chretien",
      0.1825
    ],
    [
      "fidele",
      0.1825
    ],
    [
      "baptise",
      0.09
    ],
    [
      "catho",
      0.09
    ],
    [
      "converti",
      0.09
    ],
    [
      "croyant",
      0.09
    ],
    [
      "oecumenique",
      0.09
    ],
    [
      "papiste",
      0.09
    ],
    [
      "pratiquant",
      0.09
    ]
  ],
  "eglise": [
    [
      "catholicisme",
      0.165
    ],
    [
      "catholicite",
      0.165
    ],
    [
      "chretiente",
      0.165
    ],
    [
      "clerge",
      0.165
    ]
  ],
  "granit": [
    [
      "pierre",
      0.4
    ],
    [
      "marbre",
      0.2
    ],
    [
      "pegmatite",
      0.2
    ],
    [
      "roche",
      0.2
    ]
  ],
  "comte": [
    [
      "gruyere",
      0.5
    ],
    [
      "seigneurie",
      0.5
    ]
  ],
  "monstre": [
    [
      "enorme",
      0.105
    ],
    [
      "prodigieux",
      0.09
    ],
    [
      "colossal",
      0.0775
    ],
    [
      "fantastique",
      0.065
    ],
    [
      "gigantesque",
      0.065
    ],
    [
      "phenomenal",
      0.065
    ],
    [
      "titanesque",
      0.0375
    ],
    [
      "monstrueux",
      0.0375
    ],
    [
      "faramineux",
      0.0375
    ],
    [
      "bete",
      0.0375
    ],
    [
      "singe",
      0.025
    ],
    [
      "laideron",
      0.025
    ],
    [
      "inoui",
      0.025
    ],
    [
      "horreur",
      0.025
    ],
    [
      "geant",
      0.025
    ],
    [
      "boeuf",
      0.025
    ],
    [
      "loup",
      0.0125
    ],
    [
      "magot",
      0.0125
    ],
    [
      "phenomene",
      0.0125
    ],
    [
      "saltimbanque",
      0.0125
    ],
    [
      "scelerat",
      0.0125
    ],
    [
      "serpent",
      0.0125
    ],
    [
      "hideur",
      0.0125
    ],
    [
      "effrene",
      0.0125
    ],
    [
      "denature",
      0.0125
    ],
    [
      "dementiel",
      0.0125
    ],
    [
      "chimere",
      0.0125
    ],
    [
      "canevas",
      0.0125
    ],
    [
      "titan",
      0.0125
    ]
  ],
  "replonger": [
    [
      "enfoncer",
      1.0
    ]
  ],
  "croix": [
    [
      "affliction",
      0.1225
    ],
    [
      "supplice",
      0.1025
    ],
    [
      "tourment",
      0.08
    ],
    [
      "peine",
      0.08
    ],
    [
      "mal",
      0.08
    ],
    [
      "calvaire",
      0.08
    ],
    [
      "souffrance",
      0.06
    ],
    [
      "epreuve",
      0.04
    ],
    [
      "martyre",
      0.04
    ],
    [
      "insigne",
      0.04
    ],
    [
      "fardeau",
      0.04
    ],
    [
      "calice",
      0.04
    ],
    [
      "bat",
      0.04
    ],
    [
      "gibet",
      0.0175
    ],
    [
      "face",
      0.0175
    ],
    [
      "decoration",
      0.0175
    ],
    [
      "crucifix",
      0.0175
    ],
    [
      "croisette",
      0.0175
    ],
    [
      "marque",
      0.0175
    ]
  ],
  "splendeur": [
    [
      "eclat",
      0.1775
    ],
    [
      "beaute",
      0.0825
    ],
    [
      "magnificence",
      0.0825
    ],
    [
      "gloire",
      0.075
    ],
    [
      "brillant",
      0.065
    ],
    [
      "lustre",
      0.065
    ],
    [
      "somptuosite",
      0.045
    ],
    [
      "lumiere",
      0.045
    ],
    [
      "majeste",
      0.0375
    ],
    [
      "richesse",
      0.0375
    ],
    [
      "rayonnement",
      0.0275
    ],
    [
      "prestige",
      0.0275
    ],
    [
      "illustration",
      0.0275
    ],
    [
      "faste",
      0.0275
    ],
    [
      "emerveillement",
      0.0175
    ],
    [
      "relief",
      0.0175
    ],
    [
      "pompe",
      0.0175
    ],
    [
      "merveille",
      0.0175
    ],
    [
      "feerie",
      0.0175
    ],
    [
      "clarte",
      0.0175
    ],
    [
      "apparat",
      0.0075
    ],
    [
      "fulguration",
      0.0075
    ],
    [
      "luminosite",
      0.0075
    ],
    [
      "luxe",
      0.0075
    ],
    [
      "ornement",
      0.0075
    ],
    [
      "vernis",
      0.0075
    ]
  ],
  "prince": [
    [
      "roi",
      0.1
    ],
    [
      "chef",
      0.0825
    ],
    [
      "souverain",
      0.0825
    ],
    [
      "empereur",
      0.05
    ],
    [
      "eveque",
      0.0325
    ],
    [
      "emir",
      0.0325
    ],
    [
      "sultan",
      0.0325
    ],
    [
      "seigneur",
      0.0325
    ],
    [
      "monarque",
      0.0325
    ],
    [
      "maitre",
      0.0325
    ],
    [
      "majeste",
      0.0325
    ],
    [
      "gloire",
      0.0325
    ],
    [
      "celebrite",
      0.0325
    ],
    [
      "infant",
      0.015
    ],
    [
      "kronprinz",
      0.015
    ],
    [
      "landgrave",
      0.015
    ],
    [
      "maharajah",
      0.015
    ],
    [
      "margrave",
      0.015
    ],
    [
      "monseigneur",
      0.015
    ],
    [
      "principicule",
      0.015
    ],
    [
      "rajah",
      0.015
    ],
    [
      "rhingrave",
      0.015
    ],
    [
      "hospodar",
      0.015
    ],
    [
      "diadoque",
      0.015
    ],
    [
      "Monsieur",
      0.015
    ],
    [
      "altesse",
      0.015
    ],
    [
      "archiduc",
      0.015
    ],
    [
      "autorite",
      0.015
    ],
    [
      "biquet",
      0.015
    ],
    [
      "cardinal",
      0.015
    ],
    [
      "cherif",
      0.015
    ],
    [
      "dauphin",
      0.015
    ],
    [
      "sommite",
      0.015
    ]
  ],
  "merveilleux": [
    [
      "etonnant",
      0.09
    ],
    [
      "beau",
      0.0775
    ],
    [
      "sensationnel",
      0.075
    ],
    [
      "extraordinaire",
      0.0725
    ],
    [
      "fantastique",
      0.0625
    ],
    [
      "prodigieux",
      0.055
    ],
    [
      "admirable",
      0.05
    ],
    [
      "fabuleux",
      0.04
    ],
    [
      "formidable",
      0.0275
    ],
    [
      "parfait",
      0.025
    ],
    [
      "surprenant",
      0.02
    ],
    [
      "sublime",
      0.02
    ],
    [
      "epatant",
      0.02
    ],
    [
      "divin",
      0.0175
    ],
    [
      "magique",
      0.0175
    ],
    [
      "splendide",
      0.015
    ],
    [
      "feerique",
      0.015
    ],
    [
      "delicieux",
      0.015
    ],
    [
      "charmant",
      0.015
    ],
    [
      "bon",
      0.0125
    ],
    [
      "exquis",
      0.0125
    ],
    [
      "surnaturel",
      0.0125
    ],
    [
      "joli",
      0.0125
    ],
    [
      "adorable",
      0.0125
    ],
    [
      "inoui",
      0.01
    ],
    [
      "magnifique",
      0.01
    ],
    [
      "mirifique",
      0.01
    ],
    [
      "ravissant",
      0.01
    ],
    [
      "prestigieux",
      0.0075
    ],
    [
      "incroyable",
      0.0075
    ],
    [
      "fantasmagorique",
      0.0075
    ],
    [
      "excellent",
      0.0075
    ],
    [
      "etourdissant",
      0.005
    ],
    [
      "eblouissant",
      0.005
    ],
    [
      "paradisiaque",
      0.005
    ],
    [
      "miraculeux",
      0.005
    ],
    [
      "impressionnant",
      0.005
    ],
    [
      "enchanteur",
      0.005
    ],
    [
      "elegant",
      0.005
    ],
    [
      "superbe",
      0.005
    ],
    [
      "mirobolant",
      0.005
    ],
    [
      "ideal",
      0.005
    ],
    [
      "extra",
      0.005
    ],
    [
      "enivrant",
      0.005
    ],
    [
      "thaumaturgique",
      0.0025
    ],
    [
      "terrible",
      0.0025
    ],
    [
      "super",
      0.0025
    ],
    [
      "souverain",
      0.0025
    ],
    [
      "rare",
      0.0025
    ],
    [
      "feerie",
      0.0025
    ],
    [
      "saisissant",
      0.0
    ],
    [
      "romanesque",
      0.0
    ],
    [
      "muscadin",
      0.0
    ],
    [
      "merveille",
      0.0
    ],
    [
      "excentrique",
      0.0
    ],
    [
      "euphorique",
      0.0
    ],
    [
      "dore",
      0.0
    ],
    [
      "satane",
      0.0
    ]
  ],
  "fabuleux": [
    [
      "extraordinaire",
      0.0925
    ],
    [
      "fantastique",
      0.09
    ],
    [
      "etonnant",
      0.0525
    ],
    [
      "prodigieux",
      0.0525
    ],
    [
      "sensationnel",
      0.0475
    ],
    [
      "enorme",
      0.035
    ],
    [
      "formidable",
      0.035
    ],
    [
      "inoui",
      0.03
    ],
    [
      "grand",
      0.0275
    ],
    [
      "merveilleux",
      0.0275
    ],
    [
      "incroyable",
      0.0275
    ],
    [
      "beau",
      0.025
    ],
    [
      "fou",
      0.025
    ],
    [
      "imaginaire",
      0.0225
    ],
    [
      "phenomenal",
      0.02
    ],
    [
      "invraisemblable",
      0.02
    ],
    [
      "fantasmagorique",
      0.015
    ],
    [
      "faramineux",
      0.015
    ],
    [
      "surprenant",
      0.015
    ],
    [
      "excessif",
      0.015
    ],
    [
      "admirable",
      0.015
    ],
    [
      "colossal",
      0.0125
    ],
    [
      "gigantesque",
      0.0125
    ],
    [
      "chimerique",
      0.01
    ],
    [
      "extravagant",
      0.01
    ],
    [
      "monumental",
      0.01
    ],
    [
      "stupefiant",
      0.01
    ],
    [
      "mythique",
      0.01
    ],
    [
      "mensonger",
      0.01
    ],
    [
      "grandiose",
      0.01
    ],
    [
      "faux",
      0.01
    ],
    [
      "exagere",
      0.0075
    ],
    [
      "inimaginable",
      0.0075
    ],
    [
      "prestigieux",
      0.0075
    ],
    [
      "irreel",
      0.0075
    ],
    [
      "insense",
      0.0075
    ],
    [
      "genial",
      0.0075
    ],
    [
      "fictif",
      0.0075
    ],
    [
      "exceptionnel",
      0.0075
    ],
    [
      "astronomique",
      0.005
    ],
    [
      "gros",
      0.005
    ],
    [
      "splendide",
      0.005
    ],
    [
      "eblouissant",
      0.005
    ],
    [
      "romanesque",
      0.005
    ],
    [
      "inconcevable",
      0.005
    ],
    [
      "feerique",
      0.005
    ],
    [
      "exorbitant",
      0.005
    ],
    [
      "boeuf",
      0.005
    ],
    [
      "mirifique",
      0.0025
    ],
    [
      "miraculeux",
      0.0025
    ],
    [
      "legendaire",
      0.0025
    ],
    [
      "introuvable",
      0.0025
    ],
    [
      "inoubliable",
      0.0025
    ],
    [
      "furieux",
      0.0025
    ],
    [
      "surnaturel",
      0.0025
    ],
    [
      "supreme",
      0.0025
    ],
    [
      "spectaculaire",
      0.0025
    ],
    [
      "somptueux",
      0.0025
    ],
    [
      "mirobolant",
      0.0025
    ],
    [
      "invente",
      0.0025
    ],
    [
      "incalculable",
      0.0025
    ],
    [
      "allegorique",
      0.0025
    ],
    [
      "vertigineux",
      0.0
    ],
    [
      "mythologique",
      0.0
    ],
    [
      "insigne",
      0.0
    ],
    [
      "hallucinant",
      0.0
    ],
    [
      "feint",
      0.0
    ],
    [
      "fabrique",
      0.0
    ],
    [
      "epique",
      0.0
    ]
  ],
  "cristal": [
    [
      "limpidite",
      0.285
    ],
    [
      "transparence",
      0.285
    ],
    [
      "macle",
      0.1425
    ],
    [
      "purete",
      0.1425
    ],
    [
      "verre",
      0.1425
    ]
  ],
  "virer": [
    [
      "renvoyer",
      0.1225
    ],
    [
      "vider",
      0.1225
    ],
    [
      "tourner",
      0.0925
    ],
    [
      "licencier",
      0.075
    ],
    [
      "tournoyer",
      0.045
    ],
    [
      "passer",
      0.045
    ],
    [
      "lourder",
      0.045
    ],
    [
      "expulser",
      0.045
    ],
    [
      "congedier",
      0.045
    ],
    [
      "balancer",
      0.045
    ],
    [
      "virevolter",
      0.03
    ],
    [
      "sortir",
      0.03
    ],
    [
      "pivoter",
      0.03
    ],
    [
      "obliquer",
      0.03
    ],
    [
      "debarquer",
      0.03
    ],
    [
      "changer",
      0.03
    ],
    [
      "braquer",
      0.0125
    ],
    [
      "deboulonner",
      0.0125
    ],
    [
      "payer",
      0.0125
    ],
    [
      "serpenter",
      0.0125
    ],
    [
      "tourbillonner",
      0.0125
    ],
    [
      "transferer",
      0.0125
    ]
  ],
  "vire": [
    [
      "balcon",
      0.2
    ],
    [
      "palier",
      0.2
    ],
    [
      "panaris",
      0.2
    ],
    [
      "terrasse",
      0.2
    ],
    [
      "virette",
      0.2
    ]
  ],
  "delirer": [
    [
      "divaguer",
      0.175
    ],
    [
      "derailler",
      0.1175
    ],
    [
      "deraisonner",
      0.1175
    ],
    [
      "exulter",
      0.1175
    ],
    [
      "pamer",
      0.0575
    ],
    [
      "jubiler",
      0.0575
    ],
    [
      "extravaguer",
      0.0575
    ],
    [
      "deborder",
      0.0575
    ],
    [
      "s'egarer",
      0.0575
    ]
  ],
  "delire": [
    [
      "frenesie",
      0.085
    ],
    [
      "exaltation",
      0.0825
    ],
    [
      "passion",
      0.0775
    ],
    [
      "folie",
      0.075
    ],
    [
      "fureur",
      0.06
    ],
    [
      "alienation",
      0.0425
    ],
    [
      "excitation",
      0.0425
    ],
    [
      "egarement",
      0.0425
    ],
    [
      "transport",
      0.0375
    ],
    [
      "fievre",
      0.0375
    ],
    [
      "demence",
      0.03
    ],
    [
      "enthousiasme",
      0.03
    ],
    [
      "emotion",
      0.0275
    ],
    [
      "manie",
      0.0275
    ],
    [
      "agitation",
      0.0275
    ],
    [
      "ivresse",
      0.025
    ],
    [
      "emportement",
      0.02
    ],
    [
      "trouble",
      0.0175
    ],
    [
      "transe",
      0.0175
    ],
    [
      "rage",
      0.0175
    ],
    [
      "divagation",
      0.0175
    ],
    [
      "fanatisme",
      0.0125
    ],
    [
      "hallucination",
      0.0125
    ],
    [
      "surexcitation",
      0.0125
    ],
    [
      "psychose",
      0.01
    ],
    [
      "toquade",
      0.01
    ],
    [
      "etourdissement",
      0.01
    ],
    [
      "inspiration",
      0.005
    ],
    [
      "griserie",
      0.005
    ],
    [
      "debauche",
      0.005
    ],
    [
      "maboulisme",
      0.0025
    ],
    [
      "lypemanie",
      0.0025
    ],
    [
      "insanite",
      0.0025
    ],
    [
      "hysterie",
      0.0025
    ],
    [
      "fremissement",
      0.0025
    ],
    [
      "exultation",
      0.0025
    ],
    [
      "cauchemar",
      0.0025
    ],
    [
      "reverie",
      0.0025
    ]
  ],
  "montee": [
    [
      "elever",
      0.0525
    ],
    [
      "augmenter",
      0.05
    ],
    [
      "hausser",
      0.05
    ],
    [
      "relever",
      0.035
    ],
    [
      "faire",
      0.03
    ],
    [
      "disposer",
      0.025
    ],
    [
      "preparer",
      0.025
    ],
    [
      "soulever",
      0.025
    ],
    [
      "prendre",
      0.02
    ],
    [
      "rehausser",
      0.02
    ],
    [
      "combiner",
      0.02
    ],
    [
      "etablir",
      0.02
    ],
    [
      "s'elever",
      0.0175
    ],
    [
      "dresser",
      0.015
    ],
    [
      "creer",
      0.015
    ],
    [
      "batir",
      0.015
    ],
    [
      "aller",
      0.015
    ],
    [
      "organiser",
      0.0125
    ],
    [
      "lever",
      0.0125
    ],
    [
      "grandir",
      0.0125
    ],
    [
      "entrer",
      0.0125
    ],
    [
      "enlever",
      0.0125
    ],
    [
      "atteindre",
      0.0125
    ],
    [
      "assembler",
      0.0125
    ],
    [
      "agencer",
      0.0125
    ],
    [
      "rencherir",
      0.0125
    ],
    [
      "porter",
      0.0125
    ],
    [
      "fabriquer",
      0.0125
    ],
    [
      "arriver",
      0.0125
    ],
    [
      "surhausser",
      0.0075
    ],
    [
      "remonter",
      0.0075
    ],
    [
      "grossir",
      0.0075
    ],
    [
      "exhausser",
      0.0075
    ],
    [
      "exciter",
      0.0075
    ],
    [
      "couvrir",
      0.0075
    ],
    [
      "ajuster",
      0.0075
    ],
    [
      "voler",
      0.0075
    ],
    [
      "tisser",
      0.0075
    ],
    [
      "surelever",
      0.0075
    ],
    [
      "revaloriser",
      0.0075
    ],
    [
      "parvenir",
      0.0075
    ],
    [
      "mijoter",
      0.0075
    ],
    [
      "grimper",
      0.0075
    ],
    [
      "croitre",
      0.0075
    ],
    [
      "appareiller",
      0.0075
    ],
    [
      "manigancer",
      0.005
    ],
    [
      "ourdir",
      0.005
    ],
    [
      "percer",
      0.005
    ],
    [
      "s'accroitre",
      0.005
    ],
    [
      "tramer",
      0.005
    ],
    [
      "majorer",
      0.005
    ],
    [
      "jouer",
      0.005
    ],
    [
      "installer",
      0.005
    ],
    [
      "constituer",
      0.005
    ],
    [
      "escalader",
      0.005
    ],
    [
      "forcer",
      0.005
    ],
    [
      "franchir",
      0.005
    ],
    [
      "gravir",
      0.005
    ],
    [
      "hisser",
      0.005
    ],
    [
      "reussir",
      0.0025
    ],
    [
      "s'accoupler",
      0.0025
    ],
    [
      "s'engouffrer",
      0.0025
    ],
    [
      "s'envoler",
      0.0025
    ],
    [
      "sertir",
      0.0025
    ],
    [
      "servir",
      0.0025
    ],
    [
      "tresser",
      0.0025
    ],
    [
      "echafauder",
      0.0025
    ],
    [
      "realiser",
      0.0025
    ],
    [
      "redoubler",
      0.0025
    ],
    [
      "affluer",
      0.0025
    ],
    [
      "aviver",
      0.0025
    ],
    [
      "doubler",
      0.0025
    ],
    [
      "embarquer",
      0.0025
    ],
    [
      "enchasser",
      0.0025
    ],
    [
      "machiner",
      0.0025
    ],
    [
      "nouer",
      0.0025
    ],
    [
      "planter",
      0.0025
    ],
    [
      "pourvoir",
      0.0025
    ],
    [
      "procurer",
      0.0025
    ],
    [
      "progresser",
      0.0025
    ],
    [
      "s'installer",
      0.0
    ],
    [
      "s'intensifier",
      0.0
    ],
    [
      "s'echapper",
      0.0
    ],
    [
      "s'edifier",
      0.0
    ],
    [
      "saillir",
      0.0
    ],
    [
      "s'embarquer",
      0.0
    ],
    [
      "s'amplifier",
      0.0
    ],
    [
      "s'accentuer",
      0.0
    ],
    [
      "mitonner",
      0.0
    ],
    [
      "enfourcher",
      0.0
    ],
    [
      "enchatonner",
      0.0
    ],
    [
      "coudre",
      0.0
    ],
    [
      "chevaucher",
      0.0
    ],
    [
      "ascensionner",
      0.0
    ]
  ],
  "monte": [
    [
      "accouplement",
      0.285
    ],
    [
      "saillie",
      0.285
    ],
    [
      "remonte",
      0.1425
    ],
    [
      "reproduction",
      0.1425
    ],
    [
      "saut",
      0.1425
    ]
  ],
  "fraicheur": [
    [
      "purete",
      0.0875
    ],
    [
      "eclat",
      0.07
    ],
    [
      "vivacite",
      0.0525
    ],
    [
      "nouveaute",
      0.0525
    ],
    [
      "naivete",
      0.0525
    ],
    [
      "naturel",
      0.0525
    ],
    [
      "ingenuite",
      0.0525
    ],
    [
      "vie",
      0.035
    ],
    [
      "originalite",
      0.035
    ],
    [
      "nettete",
      0.035
    ],
    [
      "lustre",
      0.035
    ],
    [
      "jeunesse",
      0.035
    ],
    [
      "grace",
      0.035
    ],
    [
      "froid",
      0.035
    ],
    [
      "candeur",
      0.035
    ],
    [
      "beaute",
      0.035
    ],
    [
      "humidite",
      0.0175
    ],
    [
      "innocence",
      0.0175
    ],
    [
      "primeur",
      0.0175
    ],
    [
      "proprete",
      0.0175
    ],
    [
      "presence",
      0.0175
    ],
    [
      "rayonnement",
      0.0175
    ],
    [
      "froidure",
      0.0175
    ],
    [
      "froideur",
      0.0175
    ],
    [
      "fraiche",
      0.0175
    ],
    [
      "frais",
      0.0175
    ],
    [
      "fleur",
      0.0175
    ],
    [
      "exotisme",
      0.0175
    ],
    [
      "enfance",
      0.0175
    ],
    [
      "allant",
      0.0175
    ],
    [
      "spontaneite",
      0.0175
    ]
  ],
  "mannequin": [
    [
      "manne",
      0.1425
    ],
    [
      "panier",
      0.1425
    ],
    [
      "statue",
      0.07
    ],
    [
      "poupee",
      0.07
    ],
    [
      "pantin",
      0.07
    ],
    [
      "modele",
      0.07
    ],
    [
      "mannette",
      0.07
    ],
    [
      "figure",
      0.07
    ],
    [
      "fantoche",
      0.07
    ],
    [
      "billot",
      0.07
    ],
    [
      "epouvantail",
      0.07
    ]
  ],
  "jouir": [
    [
      "savourer",
      0.125
    ],
    [
      "deguster",
      0.0925
    ],
    [
      "posseder",
      0.0625
    ],
    [
      "gouter",
      0.0625
    ],
    [
      "disposer",
      0.0625
    ],
    [
      "beneficier",
      0.0625
    ],
    [
      "avoir",
      0.0625
    ],
    [
      "profiter",
      0.03
    ],
    [
      "partir",
      0.03
    ],
    [
      "jubiler",
      0.03
    ],
    [
      "apprecier",
      0.03
    ],
    [
      "user",
      0.03
    ]
  ],
  "moderne": [
    [
      "nouveau",
      0.25
    ],
    [
      "ultramoderne",
      0.07
    ],
    [
      "recent",
      0.07
    ],
    [
      "neuf",
      0.07
    ],
    [
      "moderniste",
      0.07
    ],
    [
      "inedit",
      0.07
    ],
    [
      "in",
      0.07
    ],
    [
      "actuel",
      0.07
    ],
    [
      "revolutionnaire",
      0.035
    ],
    [
      "present",
      0.035
    ],
    [
      "dernier",
      0.035
    ],
    [
      "contemporain",
      0.035
    ],
    [
      "evolue",
      0.035
    ]
  ],
  "defiler": [
    [
      "passer",
      0.18
    ],
    [
      "proteger",
      0.09
    ],
    [
      "processionner",
      0.09
    ],
    [
      "fuir",
      0.09
    ],
    [
      "effranger",
      0.09
    ],
    [
      "effilocher",
      0.09
    ],
    [
      "effiler",
      0.09
    ],
    [
      "desenfiler",
      0.09
    ],
    [
      "disparaitre",
      0.09
    ]
  ],
  "adversaire": [
    [
      "antagoniste",
      0.12
    ],
    [
      "concurrent",
      0.12
    ],
    [
      "ennemi",
      0.12
    ],
    [
      "combattant",
      0.1
    ],
    [
      "rival",
      0.1
    ],
    [
      "competiteur",
      0.06
    ],
    [
      "opposant",
      0.06
    ],
    [
      "oppose",
      0.06
    ],
    [
      "contraire",
      0.04
    ],
    [
      "contradicteur",
      0.04
    ],
    [
      "belligerant",
      0.04
    ],
    [
      "adverse",
      0.02
    ],
    [
      "challenger",
      0.02
    ],
    [
      "champion",
      0.02
    ],
    [
      "contestataire",
      0.02
    ],
    [
      "debatteur",
      0.02
    ],
    [
      "detracteur",
      0.02
    ],
    [
      "emule",
      0.02
    ]
  ],
  "effile": [
    [
      "defaire",
      0.1775
    ],
    [
      "aiguiser",
      0.115
    ],
    [
      "delier",
      0.115
    ],
    [
      "effilocher",
      0.115
    ],
    [
      "efaufiler",
      0.0575
    ],
    [
      "parfiler",
      0.0575
    ],
    [
      "effranger",
      0.0575
    ],
    [
      "detisser",
      0.0575
    ],
    [
      "defiler",
      0.0575
    ],
    [
      "attenuer",
      0.0575
    ],
    [
      "amincir",
      0.0575
    ],
    [
      "erailler",
      0.0575
    ]
  ],
  "effiler": [
    [
      "defaire",
      0.1775
    ],
    [
      "aiguiser",
      0.115
    ],
    [
      "delier",
      0.115
    ],
    [
      "effilocher",
      0.115
    ],
    [
      "efaufiler",
      0.0575
    ],
    [
      "parfiler",
      0.0575
    ],
    [
      "effranger",
      0.0575
    ],
    [
      "detisser",
      0.0575
    ],
    [
      "defiler",
      0.0575
    ],
    [
      "attenuer",
      0.0575
    ],
    [
      "amincir",
      0.0575
    ],
    [
      "erailler",
      0.0575
    ]
  ],
  "comparer": [
    [
      "collationner",
      0.1175
    ],
    [
      "examiner",
      0.1175
    ],
    [
      "peser",
      0.095
    ],
    [
      "confronter",
      0.07
    ],
    [
      "opposer",
      0.07
    ],
    [
      "verifier",
      0.07
    ],
    [
      "evaluer",
      0.0475
    ],
    [
      "rapprocher",
      0.0475
    ],
    [
      "conferer",
      0.0475
    ],
    [
      "balancer",
      0.0475
    ],
    [
      "apprecier",
      0.0475
    ],
    [
      "vidimer",
      0.0225
    ],
    [
      "recoler",
      0.0225
    ],
    [
      "mesurer",
      0.0225
    ],
    [
      "assimiler",
      0.0225
    ],
    [
      "analyser",
      0.0225
    ],
    [
      "echantillonner",
      0.0225
    ]
  ],
  "compliment": [
    [
      "eloge",
      0.12
    ],
    [
      "louange",
      0.1025
    ],
    [
      "civilite",
      0.085
    ],
    [
      "discours",
      0.0675
    ],
    [
      "flatterie",
      0.0675
    ],
    [
      "politesse",
      0.05
    ],
    [
      "ceremonie",
      0.05
    ],
    [
      "hommage",
      0.0325
    ],
    [
      "galanterie",
      0.0325
    ],
    [
      "felicitation",
      0.0325
    ],
    [
      "encens",
      0.0325
    ],
    [
      "celebration",
      0.0325
    ],
    [
      "boniment",
      0.0325
    ],
    [
      "applaudissement",
      0.0325
    ],
    [
      "speech",
      0.015
    ],
    [
      "sortie",
      0.015
    ],
    [
      "pommade",
      0.015
    ],
    [
      "phrase",
      0.015
    ],
    [
      "parole",
      0.015
    ],
    [
      "gentillesse",
      0.015
    ],
    [
      "enguirlandement",
      0.015
    ],
    [
      "encouragement",
      0.015
    ],
    [
      "congratulation",
      0.015
    ],
    [
      "complication",
      0.015
    ],
    [
      "amitie",
      0.015
    ],
    [
      "verbiage",
      0.015
    ]
  ],
  "recolter": [
    [
      "gagner",
      0.145
    ],
    [
      "prendre",
      0.135
    ],
    [
      "ramasser",
      0.12
    ],
    [
      "recueillir",
      0.11
    ],
    [
      "recevoir",
      0.06
    ],
    [
      "encaisser",
      0.06
    ],
    [
      "cueillir",
      0.06
    ],
    [
      "tirer",
      0.0475
    ],
    [
      "faire",
      0.035
    ],
    [
      "grappiller",
      0.035
    ],
    [
      "retirer",
      0.0225
    ],
    [
      "moissonner",
      0.0225
    ],
    [
      "glaner",
      0.0225
    ],
    [
      "empocher",
      0.0225
    ],
    [
      "affurer",
      0.01
    ],
    [
      "arracher",
      0.01
    ],
    [
      "butiner",
      0.01
    ],
    [
      "heriter",
      0.01
    ],
    [
      "rapporter",
      0.01
    ],
    [
      "vendanger",
      0.01
    ],
    [
      "ecoper",
      0.01
    ]
  ],
  "decolleter": [
    [
      "couper",
      0.25
    ],
    [
      "decouvrir",
      0.25
    ],
    [
      "degager",
      0.25
    ],
    [
      "echancrer",
      0.25
    ]
  ],
  "decollete": [
    [
      "couper",
      0.25
    ],
    [
      "decouvrir",
      0.25
    ],
    [
      "degager",
      0.25
    ],
    [
      "echancrer",
      0.25
    ]
  ],
  "dimension": [
    [
      "grandeur",
      0.1075
    ],
    [
      "etendue",
      0.1075
    ],
    [
      "profondeur",
      0.0775
    ],
    [
      "taille",
      0.0775
    ],
    [
      "grosseur",
      0.0675
    ],
    [
      "capacite",
      0.0625
    ],
    [
      "volume",
      0.0525
    ],
    [
      "mesure",
      0.045
    ],
    [
      "largeur",
      0.045
    ],
    [
      "calibre",
      0.03
    ],
    [
      "gabarit",
      0.03
    ],
    [
      "importance",
      0.03
    ],
    [
      "puissance",
      0.03
    ],
    [
      "epaisseur",
      0.03
    ],
    [
      "contenance",
      0.0225
    ],
    [
      "superficie",
      0.015
    ],
    [
      "longueur",
      0.015
    ],
    [
      "hauteur",
      0.015
    ],
    [
      "format",
      0.015
    ],
    [
      "force",
      0.015
    ],
    [
      "surface",
      0.005
    ],
    [
      "proportions",
      0.005
    ],
    [
      "pointure",
      0.005
    ],
    [
      "perspective",
      0.005
    ],
    [
      "module",
      0.005
    ],
    [
      "mensuration",
      0.005
    ],
    [
      "jauge",
      0.005
    ],
    [
      "extension",
      0.005
    ],
    [
      "cote",
      0.005
    ],
    [
      "coordonnee",
      0.005
    ],
    [
      "classe",
      0.005
    ],
    [
      "echelle",
      0.005
    ]
  ],
  "barque": [
    [
      "bateau",
      0.1575
    ],
    [
      "embarcation",
      0.11
    ],
    [
      "canot",
      0.0725
    ],
    [
      "bac",
      0.035
    ],
    [
      "canoe",
      0.035
    ],
    [
      "perissoire",
      0.0225
    ],
    [
      "pirogue",
      0.0225
    ],
    [
      "chaloupe",
      0.0225
    ],
    [
      "chaland",
      0.0225
    ],
    [
      "belandre",
      0.0225
    ],
    [
      "barge",
      0.0225
    ],
    [
      "rigue",
      0.01
    ],
    [
      "rafiot",
      0.01
    ],
    [
      "plate",
      0.01
    ],
    [
      "pinasse",
      0.01
    ],
    [
      "picoteux",
      0.01
    ],
    [
      "patache",
      0.01
    ],
    [
      "norvegienne",
      0.01
    ],
    [
      "satteau",
      0.01
    ],
    [
      "saugue",
      0.01
    ],
    [
      "sinagot",
      0.01
    ],
    [
      "taureau",
      0.01
    ],
    [
      "tillole",
      0.01
    ],
    [
      "toue",
      0.01
    ],
    [
      "voilier",
      0.01
    ],
    [
      "voirolle",
      0.01
    ],
    [
      "warnetteur",
      0.01
    ],
    [
      "youyou",
      0.01
    ],
    [
      "nacelle",
      0.01
    ],
    [
      "kayak",
      0.01
    ],
    [
      "barcasse",
      0.01
    ],
    [
      "barquerolle",
      0.01
    ],
    [
      "barquette",
      0.01
    ],
    [
      "barquot",
      0.01
    ],
    [
      "bette",
      0.01
    ],
    [
      "bireme",
      0.01
    ],
    [
      "biscaienne",
      0.01
    ],
    [
      "bisquine",
      0.01
    ],
    [
      "cange",
      0.01
    ],
    [
      "coble",
      0.01
    ],
    [
      "couralin",
      0.01
    ],
    [
      "esquif",
      0.01
    ],
    [
      "filadiere",
      0.01
    ],
    [
      "gondole",
      0.01
    ],
    [
      "gribane",
      0.01
    ],
    [
      "bachot",
      0.01
    ]
  ],
  "yacht": [
    [
      "bateau",
      0.5
    ],
    [
      "voilier",
      0.5
    ]
  ],
  "cotoyer": [
    [
      "approcher",
      0.12
    ],
    [
      "friser",
      0.12
    ],
    [
      "longer",
      0.12
    ],
    [
      "suivre",
      0.0775
    ],
    [
      "raser",
      0.0775
    ],
    [
      "froler",
      0.0775
    ],
    [
      "frequenter",
      0.0775
    ],
    [
      "border",
      0.0375
    ],
    [
      "coudoyer",
      0.0375
    ],
    [
      "s'etendre",
      0.0375
    ]
  ],
  "defi": [
    [
      "menace",
      0.1875
    ],
    [
      "bravade",
      0.125
    ],
    [
      "provocation",
      0.125
    ],
    [
      "insulte",
      0.06
    ],
    [
      "gageure",
      0.06
    ],
    [
      "fanfaronnade",
      0.06
    ],
    [
      "cranerie",
      0.06
    ],
    [
      "challenge",
      0.06
    ],
    [
      "cartel",
      0.06
    ],
    [
      "appel",
      0.06
    ],
    [
      "affrontement",
      0.06
    ],
    [
      "ultimatum",
      0.06
    ]
  ],
  "vautour": [
    [
      "rapace",
      0.2675
    ],
    [
      "requin",
      0.1325
    ],
    [
      "proprietaire",
      0.065
    ],
    [
      "pirate",
      0.065
    ],
    [
      "gypaete",
      0.065
    ],
    [
      "griffon",
      0.065
    ],
    [
      "condor",
      0.065
    ],
    [
      "charognard",
      0.065
    ],
    [
      "avare",
      0.065
    ],
    [
      "aegypiide",
      0.065
    ],
    [
      "usurier",
      0.065
    ]
  ],
  "duree": [
    [
      "demeurer",
      0.1225
    ],
    [
      "subsister",
      0.115
    ],
    [
      "trainer",
      0.1
    ],
    [
      "rester",
      0.0925
    ],
    [
      "tenir",
      0.0925
    ],
    [
      "continuer",
      0.085
    ],
    [
      "persister",
      0.0575
    ],
    [
      "s'eterniser",
      0.05
    ],
    [
      "perseverer",
      0.0275
    ],
    [
      "s'etendre",
      0.0275
    ],
    [
      "exister",
      0.0125
    ],
    [
      "occuper",
      0.0125
    ],
    [
      "vivre",
      0.0125
    ],
    [
      "s'allonger",
      0.005
    ],
    [
      "resister",
      0.005
    ],
    [
      "finir",
      0.005
    ],
    [
      "faire",
      0.005
    ],
    [
      "attendre",
      0.005
    ]
  ],
  "gala": [
    [
      "fete",
      0.2775
    ],
    [
      "festivite",
      0.165
    ],
    [
      "rejouissance",
      0.165
    ],
    [
      "ceremonie",
      0.11
    ],
    [
      "festin",
      0.11
    ],
    [
      "festival",
      0.055
    ],
    [
      "repas",
      0.055
    ],
    [
      "reception",
      0.055
    ]
  ],
  "habitation": [
    [
      "maison",
      0.1425
    ],
    [
      "abri",
      0.0675
    ],
    [
      "demeure",
      0.06
    ],
    [
      "logement",
      0.0425
    ],
    [
      "pavillon",
      0.04
    ],
    [
      "chateau",
      0.03
    ],
    [
      "cabane",
      0.03
    ],
    [
      "baraque",
      0.025
    ],
    [
      "chambre",
      0.025
    ],
    [
      "gourbi",
      0.025
    ],
    [
      "immeuble",
      0.025
    ],
    [
      "logis",
      0.025
    ],
    [
      "gite",
      0.02
    ],
    [
      "domicile",
      0.02
    ],
    [
      "batiment",
      0.02
    ],
    [
      "ferme",
      0.0175
    ],
    [
      "nid",
      0.0175
    ],
    [
      "toit",
      0.0175
    ],
    [
      "residence",
      0.0125
    ],
    [
      "retraite",
      0.0125
    ],
    [
      "ermitage",
      0.0125
    ],
    [
      "chartreuse",
      0.0125
    ],
    [
      "case",
      0.0125
    ],
    [
      "asile",
      0.0125
    ],
    [
      "villa",
      0.01
    ],
    [
      "tour",
      0.01
    ],
    [
      "penates",
      0.01
    ],
    [
      "propriete",
      0.01
    ],
    [
      "palais",
      0.01
    ],
    [
      "hutte",
      0.01
    ],
    [
      "home",
      0.01
    ],
    [
      "folie",
      0.01
    ],
    [
      "chalet",
      0.01
    ],
    [
      "cambuse",
      0.01
    ],
    [
      "bicoque",
      0.01
    ],
    [
      "tole",
      0.005
    ],
    [
      "taule",
      0.005
    ],
    [
      "manoir",
      0.005
    ],
    [
      "habitat",
      0.005
    ],
    [
      "habitacle",
      0.005
    ],
    [
      "galetas",
      0.005
    ],
    [
      "fermette",
      0.005
    ],
    [
      "cahute",
      0.005
    ],
    [
      "appartement",
      0.005
    ],
    [
      "mas",
      0.0025
    ],
    [
      "moulin",
      0.0025
    ],
    [
      "metairie",
      0.0025
    ],
    [
      "palace",
      0.0025
    ],
    [
      "presbytere",
      0.0025
    ],
    [
      "roulotte",
      0.0025
    ],
    [
      "sejour",
      0.0025
    ],
    [
      "tente",
      0.0025
    ],
    [
      "trou",
      0.0025
    ],
    [
      "turne",
      0.0025
    ],
    [
      "manse",
      0.0025
    ],
    [
      "isba",
      0.0025
    ],
    [
      "H.L.M.",
      0.0025
    ],
    [
      "adresse",
      0.0025
    ],
    [
      "couvent",
      0.0025
    ],
    [
      "cure",
      0.0025
    ],
    [
      "domaine",
      0.0025
    ],
    [
      "doyenne",
      0.0025
    ],
    [
      "enceinte",
      0.0025
    ],
    [
      "gentilhommiere",
      0.0025
    ],
    [
      "etablissement",
      0.0025
    ]
  ],
  "invitation": [
    [
      "appel",
      0.2275
    ],
    [
      "avertissement",
      0.085
    ],
    [
      "sommation",
      0.085
    ],
    [
      "sollicitation",
      0.055
    ],
    [
      "invite",
      0.055
    ],
    [
      "incitation",
      0.055
    ],
    [
      "exhortation",
      0.055
    ],
    [
      "excitation",
      0.055
    ],
    [
      "demande",
      0.055
    ],
    [
      "convocation",
      0.055
    ],
    [
      "signe",
      0.0275
    ],
    [
      "semonce",
      0.0275
    ],
    [
      "requete",
      0.0275
    ],
    [
      "priere",
      0.0275
    ],
    [
      "attrait",
      0.0275
    ],
    [
      "supplication",
      0.0275
    ]
  ],
  "aise": [
    [
      "aisance",
      0.13
    ],
    [
      "detente",
      0.0775
    ],
    [
      "relaxation",
      0.0775
    ],
    [
      "ravi",
      0.0525
    ],
    [
      "liberte",
      0.0525
    ],
    [
      "heureux",
      0.0525
    ],
    [
      "euphorie",
      0.0525
    ],
    [
      "decontraction",
      0.0525
    ],
    [
      "content",
      0.0525
    ],
    [
      "confort",
      0.0525
    ],
    [
      "plaisir",
      0.025
    ],
    [
      "joie",
      0.025
    ],
    [
      "felicite",
      0.025
    ],
    [
      "enchante",
      0.025
    ],
    [
      "contentement",
      0.025
    ],
    [
      "commodite",
      0.025
    ],
    [
      "assurance",
      0.025
    ],
    [
      "satisfaction",
      0.025
    ]
  ],
  "evenement": [
    [
      "accident",
      0.09
    ],
    [
      "aventure",
      0.0775
    ],
    [
      "cas",
      0.0675
    ],
    [
      "affaire",
      0.0625
    ],
    [
      "circonstance",
      0.06
    ],
    [
      "hasard",
      0.04
    ],
    [
      "incident",
      0.04
    ],
    [
      "occasion",
      0.0375
    ],
    [
      "rencontre",
      0.03
    ],
    [
      "peripetie",
      0.03
    ],
    [
      "histoire",
      0.025
    ],
    [
      "mesaventure",
      0.025
    ],
    [
      "episode",
      0.025
    ],
    [
      "catastrophe",
      0.0225
    ],
    [
      "fait",
      0.0225
    ],
    [
      "malheur",
      0.0225
    ],
    [
      "eventualite",
      0.0175
    ],
    [
      "action",
      0.0175
    ],
    [
      "destin",
      0.015
    ],
    [
      "intrigue",
      0.015
    ],
    [
      "resultat",
      0.015
    ],
    [
      "epreuve",
      0.015
    ],
    [
      "epoque",
      0.01
    ],
    [
      "issue",
      0.01
    ],
    [
      "effet",
      0.01
    ],
    [
      "chose",
      0.01
    ],
    [
      "calamite",
      0.01
    ],
    [
      "alea",
      0.01
    ],
    [
      "vicissitude",
      0.005
    ],
    [
      "temps",
      0.005
    ],
    [
      "succes",
      0.005
    ],
    [
      "occurrence",
      0.005
    ],
    [
      "fin",
      0.005
    ],
    [
      "experience",
      0.005
    ],
    [
      "denouement",
      0.005
    ],
    [
      "condition",
      0.005
    ],
    [
      "cataclysme",
      0.005
    ],
    [
      "avatar",
      0.005
    ],
    [
      "nouvelle",
      0.0025
    ],
    [
      "odyssee",
      0.0025
    ],
    [
      "page",
      0.0025
    ],
    [
      "perspective",
      0.0025
    ],
    [
      "prophetie",
      0.0025
    ],
    [
      "raccroc",
      0.0025
    ],
    [
      "scandale",
      0.0025
    ],
    [
      "scene",
      0.0025
    ],
    [
      "tragedie",
      0.0025
    ],
    [
      "manifestation",
      0.0025
    ],
    [
      "fete",
      0.0025
    ],
    [
      "contingence",
      0.0025
    ],
    [
      "contretemps",
      0.0025
    ],
    [
      "coincidence",
      0.0025
    ],
    [
      "date",
      0.0025
    ],
    [
      "drame",
      0.0025
    ],
    [
      "desastre",
      0.0025
    ],
    [
      "epopee",
      0.0025
    ]
  ],
  "courbe": [
    [
      "courbure",
      0.05
    ],
    [
      "courbe",
      0.04
    ],
    [
      "sinuosite",
      0.0375
    ],
    [
      "bombe",
      0.0275
    ],
    [
      "contour",
      0.0275
    ],
    [
      "convexe",
      0.0275
    ],
    [
      "meandre",
      0.0275
    ],
    [
      "voute",
      0.0225
    ],
    [
      "tournant",
      0.0225
    ],
    [
      "galbe",
      0.0225
    ],
    [
      "busque",
      0.0225
    ],
    [
      "arrondi",
      0.0225
    ],
    [
      "tortueux",
      0.0175
    ],
    [
      "tordu",
      0.0175
    ],
    [
      "sinueux",
      0.0175
    ],
    [
      "rond",
      0.0175
    ],
    [
      "renfle",
      0.0175
    ],
    [
      "recourbe",
      0.0175
    ],
    [
      "ondulation",
      0.0175
    ],
    [
      "arque",
      0.0175
    ],
    [
      "volute",
      0.0125
    ],
    [
      "tour",
      0.0125
    ],
    [
      "tortu",
      0.0125
    ],
    [
      "serpentin",
      0.0125
    ],
    [
      "ovale",
      0.0125
    ],
    [
      "indirect",
      0.0125
    ],
    [
      "detour",
      0.0125
    ],
    [
      "conique",
      0.0125
    ],
    [
      "cercle",
      0.0125
    ],
    [
      "arabesque",
      0.0125
    ],
    [
      "ligne",
      0.0075
    ],
    [
      "onduleux",
      0.0075
    ],
    [
      "orbe",
      0.0075
    ],
    [
      "rebondi",
      0.0075
    ],
    [
      "revolution",
      0.0075
    ],
    [
      "spirale",
      0.0075
    ],
    [
      "tors",
      0.0075
    ],
    [
      "virage",
      0.0075
    ],
    [
      "voussure",
      0.0075
    ],
    [
      "helice",
      0.0075
    ],
    [
      "ellipse",
      0.0075
    ],
    [
      "diagramme",
      0.0075
    ],
    [
      "arc",
      0.0075
    ],
    [
      "cambrure",
      0.0075
    ],
    [
      "cambre",
      0.0075
    ],
    [
      "cintrage",
      0.0075
    ],
    [
      "cintre",
      0.0075
    ],
    [
      "circonference",
      0.0075
    ],
    [
      "concave",
      0.0075
    ],
    [
      "coude",
      0.0075
    ],
    [
      "crochu",
      0.0075
    ],
    [
      "inflexe",
      0.0025
    ],
    [
      "incurve",
      0.0025
    ],
    [
      "incurvation",
      0.0025
    ],
    [
      "hyperbole",
      0.0025
    ],
    [
      "graphique",
      0.0025
    ],
    [
      "galbe",
      0.0025
    ],
    [
      "focale",
      0.0025
    ],
    [
      "inflexion",
      0.0025
    ],
    [
      "inflechi",
      0.0025
    ],
    [
      "lemniscate",
      0.0025
    ],
    [
      "ove",
      0.0025
    ],
    [
      "parabole",
      0.0025
    ],
    [
      "rebond",
      0.0025
    ],
    [
      "roulette",
      0.0025
    ],
    [
      "sinusoide",
      0.0025
    ],
    [
      "vallonnement",
      0.0025
    ],
    [
      "vallonne",
      0.0025
    ],
    [
      "flexueux",
      0.0025
    ],
    [
      "feston",
      0.0025
    ],
    [
      "bombement",
      0.0025
    ],
    [
      "boucle",
      0.0025
    ],
    [
      "cardioide",
      0.0025
    ],
    [
      "casse",
      0.0025
    ],
    [
      "caustique",
      0.0025
    ],
    [
      "chainette",
      0.0025
    ],
    [
      "circulaire",
      0.0025
    ],
    [
      "correspondance",
      0.0025
    ],
    [
      "coude",
      0.0025
    ],
    [
      "creux",
      0.0025
    ],
    [
      "cycloide",
      0.0025
    ],
    [
      "developpante",
      0.0025
    ],
    [
      "developpee",
      0.0025
    ],
    [
      "ellipsoide",
      0.0025
    ],
    [
      "enveloppe",
      0.0025
    ],
    [
      "enveloppee",
      0.0025
    ],
    [
      "anse",
      0.0025
    ]
  ],
  "exemple": [
    [
      "modele",
      0.1175
    ],
    [
      "echantillon",
      0.0875
    ],
    [
      "image",
      0.0725
    ],
    [
      "exemplaire",
      0.0575
    ],
    [
      "type",
      0.0575
    ],
    [
      "precedent",
      0.0425
    ],
    [
      "lecon",
      0.0425
    ],
    [
      "imitation",
      0.0425
    ],
    [
      "idee",
      0.0425
    ],
    [
      "specimen",
      0.0275
    ],
    [
      "preuve",
      0.0275
    ],
    [
      "illustration",
      0.0275
    ],
    [
      "ideal",
      0.0275
    ],
    [
      "jurisprudence",
      0.0125
    ],
    [
      "moralite",
      0.0125
    ],
    [
      "paradigme",
      0.0125
    ],
    [
      "parangon",
      0.0125
    ],
    [
      "regle",
      0.0125
    ],
    [
      "voie",
      0.0125
    ],
    [
      "edification",
      0.0125
    ],
    [
      "emulation",
      0.0125
    ],
    [
      "exhortation",
      0.0125
    ],
    [
      "exemplarite",
      0.0125
    ],
    [
      "ange",
      0.0125
    ],
    [
      "antecedent",
      0.0125
    ],
    [
      "apercu",
      0.0125
    ],
    [
      "cas",
      0.0125
    ],
    [
      "citation",
      0.0125
    ],
    [
      "contagion",
      0.0125
    ],
    [
      "enseignement",
      0.0125
    ],
    [
      "entrainement",
      0.0125
    ],
    [
      "enonce",
      0.0125
    ]
  ],
  "combien": [
    [
      "comme",
      0.3325
    ],
    [
      "quantieme",
      0.165
    ],
    [
      "que",
      0.165
    ],
    [
      "si",
      0.165
    ]
  ],
  "schema": [
    [
      "plan",
      0.1775
    ],
    [
      "esquisse",
      0.1
    ],
    [
      "canevas",
      0.0875
    ],
    [
      "ebauche",
      0.0875
    ],
    [
      "dessin",
      0.0625
    ],
    [
      "image",
      0.05
    ],
    [
      "representation",
      0.05
    ],
    [
      "projet",
      0.0375
    ],
    [
      "idee",
      0.0375
    ],
    [
      "croquis",
      0.0375
    ],
    [
      "carcasse",
      0.0375
    ],
    [
      "diagramme",
      0.025
    ],
    [
      "sujet",
      0.025
    ],
    [
      "organigramme",
      0.0125
    ],
    [
      "pattern",
      0.0125
    ],
    [
      "resume",
      0.0125
    ],
    [
      "scheme",
      0.0125
    ],
    [
      "sommaire",
      0.0125
    ],
    [
      "morphogramme",
      0.0125
    ],
    [
      "indication",
      0.0125
    ],
    [
      "figure",
      0.0125
    ],
    [
      "figuration",
      0.0125
    ],
    [
      "extrait",
      0.0125
    ],
    [
      "cadre",
      0.0125
    ],
    [
      "brouillon",
      0.0125
    ],
    [
      "abrege",
      0.0125
    ],
    [
      "squelette",
      0.0125
    ]
  ],
  "loucher": [
    [
      "lorgner",
      0.1875
    ],
    [
      "reluquer",
      0.1875
    ],
    [
      "zieuter",
      0.1875
    ],
    [
      "guigner",
      0.125
    ],
    [
      "bigler",
      0.0625
    ],
    [
      "convoiter",
      0.0625
    ],
    [
      "souhaiter",
      0.0625
    ],
    [
      "voir",
      0.0625
    ],
    [
      "vouloir",
      0.0625
    ]
  ],
  "louche": [
    [
      "douteux",
      0.13
    ],
    [
      "equivoque",
      0.13
    ],
    [
      "suspect",
      0.095
    ],
    [
      "obscur",
      0.0575
    ],
    [
      "ambigu",
      0.045
    ],
    [
      "incertain",
      0.045
    ],
    [
      "inquietant",
      0.045
    ],
    [
      "tenebreux",
      0.035
    ],
    [
      "trouble",
      0.035
    ],
    [
      "problematique",
      0.035
    ],
    [
      "nebuleux",
      0.035
    ],
    [
      "mysterieux",
      0.035
    ],
    [
      "etrange",
      0.0225
    ],
    [
      "oblique",
      0.0225
    ],
    [
      "cuiller",
      0.0225
    ],
    [
      "borgne",
      0.0225
    ],
    [
      "troublant",
      0.01
    ],
    [
      "torve",
      0.01
    ],
    [
      "sale",
      0.01
    ],
    [
      "pochon",
      0.01
    ],
    [
      "pince",
      0.01
    ],
    [
      "malfame",
      0.01
    ],
    [
      "main",
      0.01
    ],
    [
      "louchee",
      0.01
    ],
    [
      "louchon",
      0.01
    ],
    [
      "interlope",
      0.01
    ],
    [
      "compromettant",
      0.01
    ],
    [
      "bigle",
      0.01
    ],
    [
      "amphibologique",
      0.01
    ],
    [
      "vereux",
      0.01
    ]
  ],
  "critiquer": [
    [
      "blamer",
      0.08
    ],
    [
      "condamner",
      0.0475
    ],
    [
      "reprimander",
      0.0475
    ],
    [
      "tancer",
      0.045
    ],
    [
      "attaquer",
      0.0375
    ],
    [
      "vilipender",
      0.0375
    ],
    [
      "medire",
      0.0325
    ],
    [
      "denigrer",
      0.03
    ],
    [
      "censurer",
      0.03
    ],
    [
      "discrediter",
      0.025
    ],
    [
      "flageller",
      0.025
    ],
    [
      "reprocher",
      0.025
    ],
    [
      "ereinter",
      0.025
    ],
    [
      "abimer",
      0.0225
    ],
    [
      "maltraiter",
      0.0225
    ],
    [
      "vituperer",
      0.0175
    ],
    [
      "fletrir",
      0.0175
    ],
    [
      "esquinter",
      0.0175
    ],
    [
      "desapprouver",
      0.0175
    ],
    [
      "discuter",
      0.015
    ],
    [
      "deprecier",
      0.015
    ],
    [
      "examiner",
      0.015
    ],
    [
      "reprouver",
      0.015
    ],
    [
      "stigmatiser",
      0.015
    ],
    [
      "epiloguer",
      0.01
    ],
    [
      "sermonner",
      0.01
    ],
    [
      "rudoyer",
      0.01
    ],
    [
      "gloser",
      0.01
    ],
    [
      "accuser",
      0.01
    ],
    [
      "eplucher",
      0.0075
    ],
    [
      "mordre",
      0.0075
    ],
    [
      "incriminer",
      0.0075
    ],
    [
      "fronder",
      0.0075
    ],
    [
      "demolir",
      0.0075
    ],
    [
      "decrier",
      0.0075
    ],
    [
      "dechirer",
      0.0075
    ],
    [
      "analyser",
      0.0075
    ],
    [
      "arranger",
      0.0075
    ],
    [
      "chicaner",
      0.0075
    ],
    [
      "clabauder",
      0.0075
    ],
    [
      "contredire",
      0.0075
    ],
    [
      "controler",
      0.0075
    ],
    [
      "semoncer",
      0.005
    ],
    [
      "satiriser",
      0.005
    ],
    [
      "reprendre",
      0.005
    ],
    [
      "nier",
      0.005
    ],
    [
      "juger",
      0.005
    ],
    [
      "houspiller",
      0.005
    ],
    [
      "grogner",
      0.005
    ],
    [
      "fouetter",
      0.005
    ],
    [
      "commenter",
      0.005
    ],
    [
      "cingler",
      0.005
    ],
    [
      "becher",
      0.005
    ],
    [
      "piquer",
      0.0025
    ],
    [
      "remontrer",
      0.0025
    ],
    [
      "taper",
      0.0025
    ],
    [
      "jaser",
      0.0025
    ],
    [
      "improuver",
      0.0025
    ],
    [
      "descendre",
      0.0025
    ],
    [
      "chiner",
      0.0025
    ],
    [
      "blasonner",
      0.0025
    ],
    [
      "etudier",
      0.0025
    ]
  ],
  "marrant": [
    [
      "comique",
      0.1725
    ],
    [
      "amusant",
      0.1575
    ],
    [
      "tordant",
      0.13
    ],
    [
      "risible",
      0.115
    ],
    [
      "drole",
      0.085
    ],
    [
      "rigolo",
      0.0575
    ],
    [
      "roulant",
      0.0425
    ],
    [
      "gondolant",
      0.0425
    ],
    [
      "desopilant",
      0.0425
    ],
    [
      "bidonnant",
      0.0275
    ],
    [
      "bizarre",
      0.0125
    ],
    [
      "fendant",
      0.0125
    ],
    [
      "formidable",
      0.0125
    ],
    [
      "gonflant",
      0.0125
    ],
    [
      "hilarant",
      0.0125
    ],
    [
      "pissant",
      0.0125
    ]
  ],
  "certaines": [
    [
      "evident",
      0.0825
    ],
    [
      "vrai",
      0.06
    ],
    [
      "sur",
      0.055
    ],
    [
      "incontestable",
      0.045
    ],
    [
      "reel",
      0.0375
    ],
    [
      "authentique",
      0.0375
    ],
    [
      "positif",
      0.035
    ],
    [
      "avere",
      0.0275
    ],
    [
      "indubitable",
      0.0275
    ],
    [
      "manifeste",
      0.0275
    ],
    [
      "exact",
      0.025
    ],
    [
      "irrefragable",
      0.025
    ],
    [
      "formel",
      0.025
    ],
    [
      "sincere",
      0.025
    ],
    [
      "tangible",
      0.0225
    ],
    [
      "assure",
      0.02
    ],
    [
      "clair",
      0.02
    ],
    [
      "solide",
      0.0175
    ],
    [
      "indiscutable",
      0.0175
    ],
    [
      "indeniable",
      0.0175
    ],
    [
      "notoire",
      0.015
    ],
    [
      "precis",
      0.015
    ],
    [
      "net",
      0.015
    ],
    [
      "officiel",
      0.015
    ],
    [
      "etabli",
      0.0125
    ],
    [
      "patent",
      0.01
    ],
    [
      "veridique",
      0.01
    ],
    [
      "franc",
      0.01
    ],
    [
      "flagrant",
      0.01
    ],
    [
      "decide",
      0.01
    ],
    [
      "bon",
      0.0075
    ],
    [
      "decisif",
      0.0075
    ],
    [
      "determine",
      0.0075
    ],
    [
      "stable",
      0.0075
    ],
    [
      "probant",
      0.0075
    ],
    [
      "irrefutable",
      0.0075
    ],
    [
      "irrecusable",
      0.0075
    ],
    [
      "constant",
      0.005
    ],
    [
      "fixe",
      0.005
    ],
    [
      "peremptoire",
      0.005
    ],
    [
      "visible",
      0.0025
    ],
    [
      "reconnu",
      0.0025
    ],
    [
      "infaillible",
      0.0025
    ],
    [
      "dogmatique",
      0.0025
    ],
    [
      "convaincu",
      0.0025
    ],
    [
      "confirme",
      0.0025
    ],
    [
      "certifie",
      0.0025
    ],
    [
      "absolu",
      0.0025
    ],
    [
      "inattaquable",
      0.0025
    ],
    [
      "palpable",
      0.0025
    ],
    [
      "prouve",
      0.0025
    ],
    [
      "rigoureux",
      0.0025
    ],
    [
      "tranquille",
      0.0025
    ],
    [
      "fonde",
      0.0025
    ],
    [
      "efficace",
      0.0025
    ],
    [
      "effectif",
      0.0025
    ],
    [
      "declare",
      0.0025
    ],
    [
      "constate",
      0.0025
    ],
    [
      "connu",
      0.0025
    ],
    [
      "atteste",
      0.0025
    ],
    [
      "inconteste",
      0.0
    ],
    [
      "invariable",
      0.0
    ],
    [
      "ineluctable",
      0.0
    ],
    [
      "inevitable",
      0.0
    ],
    [
      "mathematique",
      0.0
    ],
    [
      "immanquable",
      0.0
    ],
    [
      "historique",
      0.0
    ],
    [
      "fixe",
      0.0
    ],
    [
      "demontre",
      0.0
    ],
    [
      "controle",
      0.0
    ],
    [
      "affirmatif",
      0.0
    ],
    [
      "admis",
      0.0
    ],
    [
      "relatif",
      0.0
    ],
    [
      "quelque",
      0.0
    ],
    [
      "persuade",
      0.0
    ],
    [
      "obligatoire",
      0.0
    ],
    [
      "donne",
      0.0
    ],
    [
      "couru",
      0.0
    ],
    [
      "tel",
      0.0
    ]
  ],
  "antipathique": [
    [
      "desagreable",
      0.1775
    ],
    [
      "deplaisant",
      0.1275
    ],
    [
      "repugnant",
      0.1025
    ],
    [
      "haissable",
      0.075
    ],
    [
      "odieux",
      0.075
    ],
    [
      "rebutant",
      0.05
    ],
    [
      "mechant",
      0.05
    ],
    [
      "malveillant",
      0.05
    ],
    [
      "inamical",
      0.05
    ],
    [
      "detestable",
      0.05
    ],
    [
      "grimacant",
      0.025
    ],
    [
      "incompatible",
      0.025
    ],
    [
      "inconciliable",
      0.025
    ],
    [
      "malplaisant",
      0.025
    ],
    [
      "oppose",
      0.025
    ],
    [
      "repoussant",
      0.025
    ]
  ],
  "angelique": [
    [
      "pur",
      0.185
    ],
    [
      "beau",
      0.1375
    ],
    [
      "bon",
      0.1375
    ],
    [
      "celeste",
      0.0675
    ],
    [
      "innocent",
      0.0675
    ],
    [
      "vertueux",
      0.0675
    ],
    [
      "seraphique",
      0.045
    ],
    [
      "parfait",
      0.045
    ],
    [
      "doux",
      0.045
    ],
    [
      "chaste",
      0.045
    ],
    [
      "benin",
      0.045
    ],
    [
      "archangelique",
      0.045
    ],
    [
      "ravissant",
      0.0225
    ],
    [
      "saint",
      0.0225
    ]
  ],
  "liqueur": [
    [
      "alcool",
      0.2275
    ],
    [
      "boisson",
      0.18
    ],
    [
      "liquide",
      0.09
    ],
    [
      "digestif",
      0.09
    ],
    [
      "fine",
      0.045
    ],
    [
      "lymphe",
      0.045
    ],
    [
      "marasquin",
      0.045
    ],
    [
      "spiritueux",
      0.045
    ]
  ],
  "han": [],
  "enjoliveur": [],
  "egosiller": [],
  "bousiller": [
    [
      "abimer",
      0.15
    ],
    [
      "detruire",
      0.0875
    ],
    [
      "demolir",
      0.07
    ],
    [
      "massacrer",
      0.07
    ],
    [
      "ruiner",
      0.07
    ],
    [
      "esquinter",
      0.0625
    ],
    [
      "gacher",
      0.0625
    ],
    [
      "tuer",
      0.055
    ],
    [
      "saboter",
      0.045
    ],
    [
      "deteriorer",
      0.0375
    ],
    [
      "saccager",
      0.03
    ],
    [
      "saloper",
      0.03
    ],
    [
      "torcher",
      0.03
    ],
    [
      "fusiller",
      0.0225
    ],
    [
      "bacler",
      0.0225
    ],
    [
      "accidenter",
      0.0225
    ],
    [
      "amocher",
      0.015
    ],
    [
      "demanteler",
      0.015
    ],
    [
      "ecraser",
      0.015
    ],
    [
      "sabrer",
      0.005
    ],
    [
      "ratatiner",
      0.005
    ],
    [
      "pulveriser",
      0.005
    ],
    [
      "louper",
      0.005
    ],
    [
      "descendre",
      0.005
    ],
    [
      "cochonner",
      0.005
    ],
    [
      "batir",
      0.005
    ],
    [
      "saligoter",
      0.005
    ]
  ],
  "abuse": [
    [
      "tromper",
      0.19
    ],
    [
      "berner",
      0.1075
    ],
    [
      "seduire",
      0.055
    ],
    [
      "duper",
      0.0525
    ],
    [
      "leurrer",
      0.0475
    ],
    [
      "enjoler",
      0.045
    ],
    [
      "attraper",
      0.035
    ],
    [
      "mystifier",
      0.0325
    ],
    [
      "rouler",
      0.0325
    ],
    [
      "amuser",
      0.0275
    ],
    [
      "capter",
      0.0225
    ],
    [
      "embabouiner",
      0.02
    ],
    [
      "mentir",
      0.0175
    ],
    [
      "jouer",
      0.015
    ],
    [
      "surprendre",
      0.0125
    ],
    [
      "empaumer",
      0.0125
    ],
    [
      "embobiner",
      0.0125
    ],
    [
      "decevoir",
      0.0125
    ],
    [
      "refaire",
      0.01
    ],
    [
      "posseder",
      0.01
    ],
    [
      "pigeonner",
      0.01
    ],
    [
      "flatter",
      0.01
    ],
    [
      "exagerer",
      0.01
    ],
    [
      "bluffer",
      0.01
    ],
    [
      "eblouir",
      0.0075
    ],
    [
      "trahir",
      0.0075
    ],
    [
      "piper",
      0.0075
    ],
    [
      "escroquer",
      0.0075
    ],
    [
      "carotter",
      0.0075
    ],
    [
      "bercer",
      0.0075
    ],
    [
      "violer",
      0.0025
    ],
    [
      "violenter",
      0.0025
    ],
    [
      "entuber",
      0.0025
    ],
    [
      "enfiler",
      0.0025
    ],
    [
      "couillonner",
      0.0025
    ],
    [
      "attirer",
      0.0025
    ],
    [
      "blouser",
      0.0025
    ],
    [
      "charrier",
      0.0025
    ],
    [
      "circonvenir",
      0.0025
    ],
    [
      "mesuser",
      0.0
    ],
    [
      "outrepasser",
      0.0
    ],
    [
      "parasiter",
      0.0
    ],
    [
      "repaitre",
      0.0
    ],
    [
      "s'amuser",
      0.0
    ],
    [
      "tyranniser",
      0.0
    ],
    [
      "imposer",
      0.0
    ],
    [
      "impatienter",
      0.0
    ],
    [
      "agir",
      0.0
    ],
    [
      "attiger",
      0.0
    ],
    [
      "canuler",
      0.0
    ],
    [
      "croire",
      0.0
    ],
    [
      "deshonorer",
      0.0
    ],
    [
      "empapaouter",
      0.0
    ],
    [
      "entourlouper",
      0.0
    ],
    [
      "exploiter",
      0.0
    ],
    [
      "feindre",
      0.0
    ],
    [
      "egarer",
      0.0
    ]
  ],
  "pardonner": [
    [
      "absoudre",
      0.1425
    ],
    [
      "excuser",
      0.1425
    ],
    [
      "amnistier",
      0.11
    ],
    [
      "oublier",
      0.0625
    ],
    [
      "passer",
      0.0625
    ],
    [
      "remettre",
      0.0475
    ],
    [
      "effacer",
      0.0475
    ],
    [
      "admettre",
      0.0475
    ],
    [
      "acquitter",
      0.0475
    ],
    [
      "abolir",
      0.0475
    ],
    [
      "tolerer",
      0.03
    ],
    [
      "innocenter",
      0.03
    ],
    [
      "gracier",
      0.03
    ],
    [
      "excepter",
      0.015
    ],
    [
      "indulgencier",
      0.015
    ],
    [
      "menager",
      0.015
    ],
    [
      "rehabiliter",
      0.015
    ],
    [
      "souffrir",
      0.015
    ],
    [
      "supporter",
      0.015
    ]
  ],
  "hun": [],
  "exporter": [
    [
      "envoyer",
      0.285
    ],
    [
      "transporter",
      0.285
    ],
    [
      "expedier",
      0.1425
    ],
    [
      "porter",
      0.1425
    ],
    [
      "vendre",
      0.1425
    ]
  ],
  "exploser": [
    [
      "fulminer",
      0.18
    ],
    [
      "eclater",
      0.18
    ],
    [
      "sauter",
      0.09
    ],
    [
      "tempeter",
      0.09
    ],
    [
      "tonner",
      0.09
    ],
    [
      "pester",
      0.045
    ],
    [
      "fuser",
      0.045
    ],
    [
      "detoner",
      0.045
    ],
    [
      "deborder",
      0.045
    ],
    [
      "bouillir",
      0.045
    ],
    [
      "peter",
      0.045
    ]
  ],
  "expliquer": [
    [
      "reveler",
      0.0975
    ],
    [
      "montrer",
      0.09
    ],
    [
      "indiquer",
      0.0675
    ],
    [
      "signifier",
      0.05
    ],
    [
      "dire",
      0.045
    ],
    [
      "exposer",
      0.045
    ],
    [
      "apprendre",
      0.0375
    ],
    [
      "annoncer",
      0.035
    ],
    [
      "exprimer",
      0.0325
    ],
    [
      "declarer",
      0.025
    ],
    [
      "manifester",
      0.025
    ],
    [
      "raconter",
      0.0225
    ],
    [
      "eclaircir",
      0.02
    ],
    [
      "enseigner",
      0.02
    ],
    [
      "demontrer",
      0.0175
    ],
    [
      "prouver",
      0.0175
    ],
    [
      "enoncer",
      0.0175
    ],
    [
      "instruire",
      0.015
    ],
    [
      "illustrer",
      0.015
    ],
    [
      "developper",
      0.015
    ],
    [
      "dechiffrer",
      0.015
    ],
    [
      "communiquer",
      0.015
    ],
    [
      "trahir",
      0.0125
    ],
    [
      "eclairer",
      0.0125
    ],
    [
      "elucider",
      0.01
    ],
    [
      "traduire",
      0.01
    ],
    [
      "retracer",
      0.01
    ],
    [
      "preciser",
      0.01
    ],
    [
      "interpreter",
      0.01
    ],
    [
      "devoiler",
      0.01
    ],
    [
      "debrouiller",
      0.01
    ],
    [
      "commenter",
      0.0075
    ],
    [
      "lire",
      0.0075
    ],
    [
      "renseigner",
      0.0075
    ],
    [
      "paraphraser",
      0.005
    ],
    [
      "justifier",
      0.005
    ],
    [
      "enfoncer",
      0.005
    ],
    [
      "decrire",
      0.005
    ],
    [
      "convaincre",
      0.005
    ],
    [
      "motiver",
      0.0
    ],
    [
      "expliciter",
      0.0
    ],
    [
      "demeler",
      0.0
    ],
    [
      "demystifier",
      0.0
    ],
    [
      "definir",
      0.0
    ],
    [
      "symboliser",
      0.0
    ]
  ],
  "expo": [
    [
      "exposition",
      1.0
    ]
  ],
  "construire": [
    [
      "former",
      0.0975
    ],
    [
      "composer",
      0.09
    ],
    [
      "creer",
      0.0725
    ],
    [
      "batir",
      0.065
    ],
    [
      "faire",
      0.06
    ],
    [
      "constituer",
      0.055
    ],
    [
      "organiser",
      0.0475
    ],
    [
      "fabriquer",
      0.045
    ],
    [
      "edifier",
      0.04
    ],
    [
      "arranger",
      0.04
    ],
    [
      "etablir",
      0.0375
    ],
    [
      "faconner",
      0.0325
    ],
    [
      "imaginer",
      0.0275
    ],
    [
      "elaborer",
      0.0275
    ],
    [
      "combiner",
      0.0225
    ],
    [
      "forger",
      0.0225
    ],
    [
      "inventer",
      0.0225
    ],
    [
      "elever",
      0.0225
    ],
    [
      "fonder",
      0.0225
    ],
    [
      "agencer",
      0.015
    ],
    [
      "disposer",
      0.015
    ],
    [
      "assembler",
      0.01
    ],
    [
      "echafauder",
      0.0075
    ],
    [
      "structurer",
      0.0075
    ],
    [
      "harmoniser",
      0.0075
    ],
    [
      "charpenter",
      0.0075
    ],
    [
      "articuler",
      0.0075
    ],
    [
      "amenager",
      0.0075
    ],
    [
      "eriger",
      0.005
    ],
    [
      "modeler",
      0.005
    ],
    [
      "jeter",
      0.005
    ],
    [
      "architecturer",
      0.0
    ],
    [
      "conduire",
      0.0
    ],
    [
      "maconner",
      0.0
    ],
    [
      "reconstruire",
      0.0
    ],
    [
      "tracer",
      0.0
    ],
    [
      "elucubrer",
      0.0
    ]
  ],
  "decapotable": [
    [
      "cabriolet",
      0.3325
    ],
    [
      "decouvrable",
      0.3325
    ],
    [
      "torpedo",
      0.3325
    ]
  ],
  "flottement": [
    [
      "hesitation",
      0.1325
    ],
    [
      "fluctuation",
      0.11
    ],
    [
      "incertitude",
      0.0875
    ],
    [
      "tatonnement",
      0.0875
    ],
    [
      "vacillation",
      0.0875
    ],
    [
      "oscillation",
      0.065
    ],
    [
      "indecision",
      0.065
    ],
    [
      "balancement",
      0.065
    ],
    [
      "agitation",
      0.065
    ],
    [
      "ondulation",
      0.0425
    ],
    [
      "vacillement",
      0.0425
    ],
    [
      "ondoiement",
      0.02
    ],
    [
      "flottaison",
      0.02
    ],
    [
      "errements",
      0.02
    ],
    [
      "desordre",
      0.02
    ],
    [
      "doute",
      0.02
    ],
    [
      "suspension",
      0.02
    ]
  ],
  "poignet": [
    [
      "attache",
      0.3325
    ],
    [
      "manchette",
      0.3325
    ],
    [
      "poigne",
      0.3325
    ]
  ],
  "avortement": [
    [
      "defaite",
      0.18
    ],
    [
      "fiasco",
      0.135
    ],
    [
      "insucces",
      0.135
    ],
    [
      "faillite",
      0.09
    ],
    [
      "echec",
      0.09
    ],
    [
      "perte",
      0.045
    ],
    [
      "deconfiture",
      0.045
    ],
    [
      "coulure",
      0.045
    ],
    [
      "accouchement",
      0.045
    ],
    [
      "I.V.G.",
      0.045
    ],
    [
      "revers",
      0.045
    ]
  ],
  "temoigner": [
    [
      "montrer",
      0.105
    ],
    [
      "reveler",
      0.0725
    ],
    [
      "affirmer",
      0.07
    ],
    [
      "declarer",
      0.0575
    ],
    [
      "dire",
      0.055
    ],
    [
      "manifester",
      0.055
    ],
    [
      "afficher",
      0.0475
    ],
    [
      "marquer",
      0.0375
    ],
    [
      "indiquer",
      0.035
    ],
    [
      "assurer",
      0.0325
    ],
    [
      "attester",
      0.0325
    ],
    [
      "signaler",
      0.03
    ],
    [
      "exprimer",
      0.03
    ],
    [
      "certifier",
      0.0275
    ],
    [
      "signifier",
      0.0275
    ],
    [
      "porter",
      0.025
    ],
    [
      "produire",
      0.025
    ],
    [
      "prouver",
      0.02
    ],
    [
      "soutenir",
      0.0175
    ],
    [
      "confirmer",
      0.0125
    ],
    [
      "repondre",
      0.0125
    ],
    [
      "rapporter",
      0.01
    ],
    [
      "prononcer",
      0.01
    ],
    [
      "demontrer",
      0.01
    ],
    [
      "garantir",
      0.0075
    ],
    [
      "jurer",
      0.0075
    ],
    [
      "trahir",
      0.0075
    ],
    [
      "deposer",
      0.005
    ],
    [
      "accuser",
      0.005
    ],
    [
      "protester",
      0.0025
    ],
    [
      "prodiguer",
      0.0025
    ],
    [
      "proclamer",
      0.0025
    ],
    [
      "maintenir",
      0.0025
    ],
    [
      "denoter",
      0.0025
    ],
    [
      "alleguer",
      0.0025
    ],
    [
      "renseigner",
      0.0
    ],
    [
      "proferer",
      0.0
    ],
    [
      "comparaitre",
      0.0
    ],
    [
      "transmettre",
      0.0
    ]
  ],
  "contenter": [
    [
      "satisfaire",
      0.2725
    ],
    [
      "assouvir",
      0.12
    ],
    [
      "apaiser",
      0.09
    ],
    [
      "rassasier",
      0.06
    ],
    [
      "plaire",
      0.06
    ],
    [
      "payer",
      0.06
    ],
    [
      "combler",
      0.06
    ],
    [
      "calmer",
      0.06
    ],
    [
      "arranger",
      0.03
    ],
    [
      "desinteresser",
      0.03
    ],
    [
      "exaucer",
      0.03
    ],
    [
      "passer",
      0.03
    ],
    [
      "rejouir",
      0.03
    ],
    [
      "suffire",
      0.03
    ],
    [
      "etancher",
      0.03
    ]
  ],
  "coffre": [
    [
      "caisse",
      0.15
    ],
    [
      "boite",
      0.09
    ],
    [
      "buffet",
      0.075
    ],
    [
      "bahut",
      0.06
    ],
    [
      "culot",
      0.045
    ],
    [
      "poitrine",
      0.0275
    ],
    [
      "malle",
      0.0275
    ],
    [
      "maie",
      0.0275
    ],
    [
      "huche",
      0.0275
    ],
    [
      "estomac",
      0.0275
    ],
    [
      "coffret",
      0.0275
    ],
    [
      "cantine",
      0.0275
    ],
    [
      "commode",
      0.0125
    ],
    [
      "gaine",
      0.0125
    ],
    [
      "layette",
      0.0125
    ],
    [
      "pectoraux",
      0.0125
    ],
    [
      "petrin",
      0.0125
    ],
    [
      "saloir",
      0.0125
    ],
    [
      "souffle",
      0.0125
    ],
    [
      "thorax",
      0.0125
    ],
    [
      "toupet",
      0.0125
    ],
    [
      "coffiot",
      0.0125
    ],
    [
      "chasse",
      0.0125
    ],
    [
      "arcasse",
      0.0125
    ],
    [
      "arche",
      0.0125
    ],
    [
      "armoire",
      0.0125
    ],
    [
      "bedaine",
      0.0125
    ],
    [
      "bidon",
      0.0125
    ],
    [
      "boitier",
      0.0125
    ],
    [
      "cabinet",
      0.0125
    ],
    [
      "caisson",
      0.0125
    ],
    [
      "cassette",
      0.0125
    ],
    [
      "ecrin",
      0.0125
    ]
  ],
  "masquer": [
    [
      "deguiser",
      0.1075
    ],
    [
      "cacher",
      0.0925
    ],
    [
      "voiler",
      0.0825
    ],
    [
      "dissimuler",
      0.075
    ],
    [
      "envelopper",
      0.075
    ],
    [
      "couvrir",
      0.0675
    ],
    [
      "travestir",
      0.0525
    ],
    [
      "recouvrir",
      0.0525
    ],
    [
      "farder",
      0.0525
    ],
    [
      "camoufler",
      0.0525
    ],
    [
      "revetir",
      0.0375
    ],
    [
      "maquiller",
      0.03
    ],
    [
      "habiller",
      0.03
    ],
    [
      "enrober",
      0.0225
    ],
    [
      "occulter",
      0.0225
    ],
    [
      "tapisser",
      0.0225
    ],
    [
      "eclipser",
      0.015
    ],
    [
      "ouater",
      0.015
    ],
    [
      "noyer",
      0.015
    ],
    [
      "murer",
      0.015
    ],
    [
      "derober",
      0.015
    ],
    [
      "celer",
      0.015
    ],
    [
      "empecher",
      0.005
    ],
    [
      "intercepter",
      0.005
    ]
  ],
  "masque": [
    [
      "apparence",
      0.1
    ],
    [
      "air",
      0.065
    ],
    [
      "exterieur",
      0.0575
    ],
    [
      "figure",
      0.0575
    ],
    [
      "visage",
      0.0575
    ],
    [
      "deguisement",
      0.05
    ],
    [
      "aspect",
      0.04
    ],
    [
      "manteau",
      0.04
    ],
    [
      "vernis",
      0.0325
    ],
    [
      "tournure",
      0.0325
    ],
    [
      "semblant",
      0.0325
    ],
    [
      "facade",
      0.0325
    ],
    [
      "semblance",
      0.025
    ],
    [
      "revetement",
      0.025
    ],
    [
      "physionomie",
      0.025
    ],
    [
      "dehors",
      0.025
    ],
    [
      "vetement",
      0.015
    ],
    [
      "voile",
      0.015
    ],
    [
      "travesti",
      0.015
    ],
    [
      "trait",
      0.015
    ],
    [
      "protection",
      0.015
    ],
    [
      "mechant",
      0.015
    ],
    [
      "mascarade",
      0.015
    ],
    [
      "facies",
      0.015
    ],
    [
      "expression",
      0.015
    ],
    [
      "domino",
      0.015
    ],
    [
      "carnaval",
      0.015
    ],
    [
      "abri",
      0.015
    ],
    [
      "teigne",
      0.0075
    ],
    [
      "pierrot",
      0.0075
    ],
    [
      "peste",
      0.0075
    ],
    [
      "mascaron",
      0.0075
    ],
    [
      "loup",
      0.0075
    ],
    [
      "camouflage",
      0.0075
    ],
    [
      "cagoule",
      0.0075
    ],
    [
      "touret",
      0.0075
    ]
  ],
  "hi": [],
  "soul": [
    [
      "ivre",
      0.1975
    ],
    [
      "rassasie",
      0.115
    ],
    [
      "repu",
      0.0975
    ],
    [
      "plein",
      0.08
    ],
    [
      "bourre",
      0.0475
    ],
    [
      "gave",
      0.0475
    ],
    [
      "sature",
      0.0475
    ],
    [
      "grise",
      0.0325
    ],
    [
      "gris",
      0.0325
    ],
    [
      "enivre",
      0.0325
    ],
    [
      "sursature",
      0.015
    ],
    [
      "schlass",
      0.015
    ],
    [
      "rond",
      0.015
    ],
    [
      "pompette",
      0.015
    ],
    [
      "pinte",
      0.015
    ],
    [
      "paf",
      0.015
    ],
    [
      "mur",
      0.015
    ],
    [
      "gorge",
      0.015
    ],
    [
      "degoute",
      0.015
    ],
    [
      "cuit",
      0.015
    ],
    [
      "content",
      0.015
    ],
    [
      "blinde",
      0.015
    ],
    [
      "assouvi",
      0.015
    ],
    [
      "etourdi",
      0.015
    ]
  ],
  "home": [
    [
      "maison",
      0.2
    ],
    [
      "foyer",
      0.1425
    ],
    [
      "interieur",
      0.1125
    ],
    [
      "logis",
      0.1125
    ],
    [
      "nid",
      0.085
    ],
    [
      "habitation",
      0.085
    ],
    [
      "domicile",
      0.085
    ],
    [
      "niche",
      0.0275
    ]
  ],
  "ring": [
    [
      "estrade",
      0.25
    ],
    [
      "planches",
      0.25
    ],
    [
      "podium",
      0.25
    ],
    [
      "rond",
      0.25
    ]
  ],
  "song": [],
  "note": [
    [
      "marquer",
      0.09
    ],
    [
      "relever",
      0.09
    ],
    [
      "inscrire",
      0.065
    ],
    [
      "remarquer",
      0.065
    ],
    [
      "consigner",
      0.055
    ],
    [
      "transcrire",
      0.0475
    ],
    [
      "mentionner",
      0.0475
    ],
    [
      "voir",
      0.04
    ],
    [
      "mettre",
      0.0325
    ],
    [
      "juger",
      0.0325
    ],
    [
      "enregistrer",
      0.0325
    ],
    [
      "copier",
      0.0325
    ],
    [
      "constater",
      0.0325
    ],
    [
      "ecrire",
      0.0225
    ],
    [
      "observer",
      0.0225
    ],
    [
      "coter",
      0.0225
    ],
    [
      "classer",
      0.0225
    ],
    [
      "apercevoir",
      0.0225
    ],
    [
      "etiqueter",
      0.015
    ],
    [
      "s'apercevoir",
      0.015
    ],
    [
      "recopier",
      0.015
    ],
    [
      "pointer",
      0.015
    ],
    [
      "jauger",
      0.015
    ],
    [
      "apprecier",
      0.015
    ],
    [
      "annoter",
      0.015
    ],
    [
      "rapporter",
      0.005
    ],
    [
      "marginer",
      0.005
    ],
    [
      "lister",
      0.005
    ],
    [
      "ficher",
      0.005
    ],
    [
      "cocher",
      0.005
    ],
    [
      "citer",
      0.005
    ],
    [
      "aviser",
      0.005
    ],
    [
      "apostiller",
      0.005
    ],
    [
      "souligner",
      0.005
    ]
  ],
  "propre": [
    [
      "convenable",
      0.055
    ],
    [
      "bon",
      0.0375
    ],
    [
      "apte",
      0.0325
    ],
    [
      "pur",
      0.0325
    ],
    [
      "honnete",
      0.03
    ],
    [
      "net",
      0.03
    ],
    [
      "correct",
      0.0275
    ],
    [
      "caracteristique",
      0.0275
    ],
    [
      "capable",
      0.0275
    ],
    [
      "habile",
      0.025
    ],
    [
      "juste",
      0.025
    ],
    [
      "particulier",
      0.025
    ],
    [
      "seyant",
      0.025
    ],
    [
      "approprie",
      0.0225
    ],
    [
      "sortable",
      0.0225
    ],
    [
      "soigne",
      0.02
    ],
    [
      "exact",
      0.02
    ],
    [
      "caractere",
      0.0175
    ],
    [
      "precis",
      0.0175
    ],
    [
      "special",
      0.0175
    ],
    [
      "specifique",
      0.0175
    ],
    [
      "elegant",
      0.0125
    ],
    [
      "frotte",
      0.0125
    ],
    [
      "attribut",
      0.0125
    ],
    [
      "adequat",
      0.0125
    ],
    [
      "qualite",
      0.0075
    ],
    [
      "qualifie",
      0.0075
    ],
    [
      "personnel",
      0.0075
    ],
    [
      "nettoye",
      0.0075
    ],
    [
      "individuel",
      0.0075
    ],
    [
      "idoine",
      0.0075
    ],
    [
      "expert",
      0.0075
    ],
    [
      "decrasse",
      0.0075
    ],
    [
      "distinct",
      0.0075
    ],
    [
      "congru",
      0.0075
    ],
    [
      "competent",
      0.0075
    ],
    [
      "chic",
      0.0075
    ],
    [
      "naturel",
      0.0075
    ],
    [
      "probe",
      0.0075
    ],
    [
      "propriete",
      0.0075
    ],
    [
      "raffine",
      0.0075
    ],
    [
      "soigneux",
      0.0075
    ],
    [
      "susceptible",
      0.0075
    ],
    [
      "nature",
      0.0075
    ],
    [
      "lave",
      0.0075
    ],
    [
      "blanc",
      0.0075
    ],
    [
      "decrotte",
      0.0075
    ],
    [
      "exerce",
      0.0075
    ],
    [
      "fort",
      0.0075
    ],
    [
      "impeccable",
      0.0075
    ],
    [
      "intact",
      0.0075
    ],
    [
      "mur",
      0.0025
    ],
    [
      "pimpant",
      0.0025
    ],
    [
      "propice",
      0.0025
    ],
    [
      "recure",
      0.0025
    ],
    [
      "revelateur",
      0.0025
    ],
    [
      "savonne",
      0.0025
    ],
    [
      "typique",
      0.0025
    ],
    [
      "verse",
      0.0025
    ],
    [
      "moral",
      0.0025
    ],
    [
      "immacule",
      0.0025
    ],
    [
      "fait",
      0.0025
    ],
    [
      "apanage",
      0.0025
    ],
    [
      "astique",
      0.0025
    ],
    [
      "clair",
      0.0025
    ],
    [
      "distinctif",
      0.0025
    ],
    [
      "distinction",
      0.0025
    ],
    [
      "decent",
      0.0025
    ],
    [
      "exclusif",
      0.0025
    ],
    [
      "prive",
      0.0
    ],
    [
      "privilege",
      0.0
    ],
    [
      "particularite",
      0.0
    ],
    [
      "nickel",
      0.0
    ],
    [
      "meme",
      0.0
    ],
    [
      "meticuleux",
      0.0
    ],
    [
      "presentable",
      0.0
    ],
    [
      "prevu",
      0.0
    ],
    [
      "rince",
      0.0
    ],
    [
      "signe",
      0.0
    ],
    [
      "specificite",
      0.0
    ],
    [
      "tenu",
      0.0
    ],
    [
      "textuel",
      0.0
    ],
    [
      "litteral",
      0.0
    ],
    [
      "lessive",
      0.0
    ],
    [
      "blanchi",
      0.0
    ],
    [
      "brique",
      0.0
    ],
    [
      "calamistre",
      0.0
    ],
    [
      "commode",
      0.0
    ],
    [
      "debarbouille",
      0.0
    ],
    [
      "entraine",
      0.0
    ],
    [
      "entretenu",
      0.0
    ],
    [
      "essence",
      0.0
    ],
    [
      "essuye",
      0.0
    ],
    [
      "frais",
      0.0
    ],
    [
      "gratte",
      0.0
    ],
    [
      "intrinseque",
      0.0
    ],
    [
      "adapte",
      0.0
    ]
  ],
  "tempo": [
    [
      "mouvement",
      0.5
    ],
    [
      "rythme",
      0.5
    ]
  ],
  "standard": [
    [
      "type",
      0.3
    ],
    [
      "commun",
      0.1
    ],
    [
      "courant",
      0.1
    ],
    [
      "modele",
      0.1
    ],
    [
      "normalise",
      0.1
    ],
    [
      "norme",
      0.1
    ],
    [
      "etalon",
      0.1
    ]
  ],
  "ancestral": [
    [
      "antique",
      0.21
    ],
    [
      "ancien",
      0.1575
    ],
    [
      "vieux",
      0.105
    ],
    [
      "seculaire",
      0.105
    ],
    [
      "primitif",
      0.105
    ],
    [
      "immemorial",
      0.105
    ],
    [
      "atavique",
      0.0525
    ],
    [
      "millenaire",
      0.0525
    ],
    [
      "naturel",
      0.0525
    ],
    [
      "patriarcal",
      0.0525
    ]
  ],
  "laissee": [
    [
      "abandonner",
      0.12
    ],
    [
      "donner",
      0.0925
    ],
    [
      "ceder",
      0.07
    ],
    [
      "quitter",
      0.065
    ],
    [
      "renoncer",
      0.0525
    ],
    [
      "passer",
      0.0425
    ],
    [
      "lacher",
      0.0425
    ],
    [
      "aliener",
      0.035
    ],
    [
      "remettre",
      0.03
    ],
    [
      "oublier",
      0.03
    ],
    [
      "delaisser",
      0.03
    ],
    [
      "vendre",
      0.025
    ],
    [
      "deposer",
      0.02
    ],
    [
      "mettre",
      0.02
    ],
    [
      "transmettre",
      0.015
    ],
    [
      "tolerer",
      0.015
    ],
    [
      "planter",
      0.015
    ],
    [
      "permettre",
      0.015
    ],
    [
      "perdre",
      0.015
    ],
    [
      "negliger",
      0.015
    ],
    [
      "leguer",
      0.015
    ],
    [
      "livrer",
      0.015
    ],
    [
      "semer",
      0.0125
    ],
    [
      "plaquer",
      0.0125
    ],
    [
      "omettre",
      0.0125
    ],
    [
      "consentir",
      0.0125
    ],
    [
      "cesser",
      0.0125
    ],
    [
      "solder",
      0.0075
    ],
    [
      "offrir",
      0.0075
    ],
    [
      "manquer",
      0.0075
    ],
    [
      "immoler",
      0.0075
    ],
    [
      "confier",
      0.0075
    ],
    [
      "autoriser",
      0.0075
    ],
    [
      "abjurer",
      0.0025
    ],
    [
      "camper",
      0.0025
    ],
    [
      "marquer",
      0.0025
    ],
    [
      "souffrir",
      0.0025
    ]
  ],
  "stupide": [
    [
      "bete",
      0.1425
    ],
    [
      "sot",
      0.1
    ],
    [
      "idiot",
      0.065
    ],
    [
      "niais",
      0.045
    ],
    [
      "imbecile",
      0.04
    ],
    [
      "ballot",
      0.04
    ],
    [
      "absurde",
      0.0375
    ],
    [
      "balourd",
      0.0275
    ],
    [
      "inintelligent",
      0.025
    ],
    [
      "abruti",
      0.0225
    ],
    [
      "cretin",
      0.0225
    ],
    [
      "lourd",
      0.0225
    ],
    [
      "ane",
      0.0225
    ],
    [
      "insense",
      0.02
    ],
    [
      "deraisonnable",
      0.0175
    ],
    [
      "inepte",
      0.0175
    ],
    [
      "cruche",
      0.015
    ],
    [
      "fou",
      0.015
    ],
    [
      "lourdaud",
      0.0125
    ],
    [
      "obtus",
      0.0125
    ],
    [
      "aberrant",
      0.01
    ],
    [
      "ignorant",
      0.01
    ],
    [
      "stupefait",
      0.01
    ],
    [
      "etonne",
      0.0075
    ],
    [
      "pesant",
      0.0075
    ],
    [
      "gourde",
      0.0075
    ],
    [
      "butor",
      0.0075
    ],
    [
      "buse",
      0.0075
    ],
    [
      "borne",
      0.0075
    ],
    [
      "ahuri",
      0.0075
    ],
    [
      "ebahi",
      0.005
    ],
    [
      "nul",
      0.005
    ],
    [
      "nigaud",
      0.005
    ],
    [
      "interdit",
      0.005
    ],
    [
      "hebete",
      0.005
    ],
    [
      "ganache",
      0.005
    ],
    [
      "extravagant",
      0.005
    ],
    [
      "dadais",
      0.005
    ],
    [
      "brute",
      0.005
    ],
    [
      "brut",
      0.005
    ],
    [
      "bouche",
      0.005
    ],
    [
      "epais",
      0.005
    ],
    [
      "surpris",
      0.005
    ],
    [
      "simple",
      0.005
    ],
    [
      "saugrenu",
      0.005
    ],
    [
      "incoherent",
      0.005
    ],
    [
      "engourdi",
      0.005
    ],
    [
      "abasourdi",
      0.005
    ],
    [
      "immobile",
      0.0025
    ],
    [
      "illogique",
      0.0025
    ],
    [
      "becasse",
      0.0025
    ],
    [
      "biscornu",
      0.0025
    ],
    [
      "benet",
      0.0025
    ],
    [
      "animal",
      0.0025
    ],
    [
      "abeti",
      0.0025
    ],
    [
      "souche",
      0.0
    ],
    [
      "ramolli",
      0.0
    ],
    [
      "plat",
      0.0
    ],
    [
      "lourdingue",
      0.0
    ],
    [
      "impardonnable",
      0.0
    ],
    [
      "huitre",
      0.0
    ],
    [
      "dandin",
      0.0
    ],
    [
      "belant",
      0.0
    ],
    [
      "beat",
      0.0
    ],
    [
      "bestiasse",
      0.0
    ],
    [
      "badaud",
      0.0
    ],
    [
      "aneanti",
      0.0
    ],
    [
      "vaseux",
      0.0
    ]
  ],
  "revivre": [
    [
      "ressusciter",
      0.1
    ],
    [
      "renaitre",
      0.08
    ],
    [
      "revoir",
      0.06
    ],
    [
      "guerir",
      0.06
    ],
    [
      "evoquer",
      0.04
    ],
    [
      "songer",
      0.04
    ],
    [
      "repasser",
      0.04
    ],
    [
      "recuperer",
      0.02
    ],
    [
      "reapparaitre",
      0.02
    ],
    [
      "resurgir",
      0.02
    ],
    [
      "respirer",
      0.02
    ]
  ],
  "conversation": [
    [
      "entretien",
      0.1125
    ],
    [
      "conference",
      0.0875
    ],
    [
      "dialogue",
      0.0725
    ],
    [
      "discours",
      0.0725
    ],
    [
      "discussion",
      0.055
    ],
    [
      "parlote",
      0.0475
    ],
    [
      "palabre",
      0.0475
    ],
    [
      "bavardage",
      0.0475
    ],
    [
      "debat",
      0.04
    ],
    [
      "propos",
      0.04
    ],
    [
      "conciliabule",
      0.03
    ],
    [
      "causerie",
      0.03
    ],
    [
      "causette",
      0.0225
    ],
    [
      "colloque",
      0.0225
    ],
    [
      "jacasserie",
      0.0225
    ],
    [
      "echange",
      0.0225
    ],
    [
      "soliloque",
      0.015
    ],
    [
      "monologue",
      0.015
    ],
    [
      "deliberation",
      0.015
    ],
    [
      "consultation",
      0.015
    ],
    [
      "communication",
      0.015
    ],
    [
      "aparte",
      0.015
    ],
    [
      "pourparler",
      0.005
    ],
    [
      "negociation",
      0.005
    ],
    [
      "interview",
      0.005
    ],
    [
      "interlocution",
      0.005
    ],
    [
      "devis",
      0.005
    ],
    [
      "commerage",
      0.005
    ],
    [
      "bavette",
      0.005
    ],
    [
      "badinage",
      0.005
    ],
    [
      "babillage",
      0.005
    ],
    [
      "sujet",
      0.005
    ]
  ],
  "imaginaire": [
    [
      "illusoire",
      0.1125
    ],
    [
      "chimerique",
      0.1
    ],
    [
      "fabuleux",
      0.085
    ],
    [
      "faux",
      0.0775
    ],
    [
      "fictif",
      0.0675
    ],
    [
      "irreel",
      0.06
    ],
    [
      "mensonger",
      0.0525
    ],
    [
      "mythique",
      0.0525
    ],
    [
      "vain",
      0.03
    ],
    [
      "fantastique",
      0.025
    ],
    [
      "fantasmagorique",
      0.025
    ],
    [
      "ideal",
      0.02
    ],
    [
      "invente",
      0.02
    ],
    [
      "fantaisiste",
      0.0175
    ],
    [
      "romanesque",
      0.0175
    ],
    [
      "utopique",
      0.0125
    ],
    [
      "theorique",
      0.0125
    ],
    [
      "impossible",
      0.0125
    ],
    [
      "fantaisie",
      0.0125
    ],
    [
      "fabrique",
      0.0125
    ],
    [
      "allegorique",
      0.0125
    ],
    [
      "abstrait",
      0.0125
    ],
    [
      "suppose",
      0.0075
    ],
    [
      "inexistant",
      0.0075
    ],
    [
      "imagination",
      0.0075
    ],
    [
      "feint",
      0.0075
    ],
    [
      "fantomatique",
      0.0075
    ],
    [
      "conventionnel",
      0.0075
    ],
    [
      "controuve",
      0.0075
    ],
    [
      "absurde",
      0.0075
    ],
    [
      "truque",
      0.0025
    ],
    [
      "reve",
      0.0025
    ],
    [
      "romance",
      0.0025
    ],
    [
      "pretendu",
      0.0025
    ],
    [
      "onirique",
      0.0025
    ],
    [
      "legendaire",
      0.0025
    ],
    [
      "inconscient",
      0.0025
    ],
    [
      "imagine",
      0.0025
    ],
    [
      "fallacieux",
      0.0025
    ],
    [
      "creux",
      0.0025
    ],
    [
      "visionnaire",
      0.0025
    ]
  ],
  "oint": [
    [
      "enduire",
      0.1425
    ],
    [
      "frotter",
      0.1425
    ],
    [
      "baptiser",
      0.0925
    ],
    [
      "benir",
      0.0925
    ],
    [
      "consacrer",
      0.0925
    ],
    [
      "graisser",
      0.0925
    ],
    [
      "sacrer",
      0.045
    ],
    [
      "parfumer",
      0.045
    ],
    [
      "mouiller",
      0.045
    ],
    [
      "lubrifier",
      0.045
    ],
    [
      "frictionner",
      0.045
    ],
    [
      "badigeonner",
      0.045
    ],
    [
      "tamponner",
      0.045
    ]
  ],
  "j": [],
  "linge": [
    [
      "drap",
      0.1325
    ],
    [
      "layette",
      0.1325
    ],
    [
      "lingerie",
      0.1325
    ],
    [
      "toile",
      0.065
    ],
    [
      "manuterge",
      0.065
    ],
    [
      "linceul",
      0.065
    ],
    [
      "frottoir",
      0.065
    ],
    [
      "dessous",
      0.065
    ],
    [
      "couche",
      0.065
    ],
    [
      "chiffon",
      0.065
    ],
    [
      "trousseau",
      0.065
    ]
  ],
  "petard": [
    [
      "bruit",
      0.065
    ],
    [
      "pistolet",
      0.065
    ],
    [
      "tapage",
      0.065
    ],
    [
      "tintamarre",
      0.065
    ],
    [
      "fessier",
      0.0475
    ],
    [
      "chahut",
      0.0475
    ],
    [
      "revolver",
      0.0325
    ],
    [
      "raffut",
      0.0325
    ],
    [
      "nouvelle",
      0.0325
    ],
    [
      "feu",
      0.0325
    ],
    [
      "fesse",
      0.0325
    ],
    [
      "esclandre",
      0.0325
    ],
    [
      "derriere",
      0.0325
    ],
    [
      "cul",
      0.0325
    ],
    [
      "calibre",
      0.0325
    ],
    [
      "malle",
      0.015
    ],
    [
      "marron",
      0.015
    ],
    [
      "miches",
      0.015
    ],
    [
      "pet",
      0.015
    ],
    [
      "popotin",
      0.015
    ],
    [
      "scandale",
      0.015
    ],
    [
      "sensation",
      0.015
    ],
    [
      "flingue",
      0.015
    ],
    [
      "cartouche",
      0.015
    ],
    [
      "browning",
      0.015
    ],
    [
      "boucan",
      0.015
    ],
    [
      "bombe",
      0.015
    ],
    [
      "arme",
      0.015
    ],
    [
      "amorce",
      0.015
    ],
    [
      "vacarme",
      0.015
    ]
  ],
  "gorge": [
    [
      "defile",
      0.1225
    ],
    [
      "gosier",
      0.1025
    ],
    [
      "canal",
      0.08
    ],
    [
      "passage",
      0.08
    ],
    [
      "col",
      0.06
    ],
    [
      "vallee",
      0.04
    ],
    [
      "porte",
      0.04
    ],
    [
      "passe",
      0.04
    ],
    [
      "ouverture",
      0.04
    ],
    [
      "kiki",
      0.04
    ],
    [
      "detroit",
      0.04
    ],
    [
      "dalle",
      0.04
    ],
    [
      "canyon",
      0.04
    ],
    [
      "sein",
      0.0175
    ],
    [
      "quiqui",
      0.0175
    ],
    [
      "poitrine",
      0.0175
    ],
    [
      "gavion",
      0.0175
    ],
    [
      "gargue",
      0.0175
    ],
    [
      "gargamelle",
      0.0175
    ],
    [
      "couloir",
      0.0175
    ],
    [
      "cou",
      0.0175
    ],
    [
      "cannelure",
      0.0175
    ],
    [
      "buste",
      0.0175
    ],
    [
      "sifflet",
      0.0175
    ]
  ],
  "thon": [
    [
      "bonite",
      1.0
    ]
  ],
  "pate": [
    [
      "composition",
      0.1325
    ],
    [
      "temperament",
      0.1325
    ],
    [
      "nouille",
      0.065
    ],
    [
      "naturel",
      0.065
    ],
    [
      "nature",
      0.065
    ],
    [
      "mortier",
      0.065
    ],
    [
      "confiture",
      0.065
    ],
    [
      "colle",
      0.065
    ],
    [
      "bete",
      0.065
    ],
    [
      "bouillie",
      0.065
    ],
    [
      "bouille",
      0.065
    ],
    [
      "barbotine",
      0.065
    ],
    [
      "pommade",
      0.065
    ]
  ],
  "involontaire": [
    [
      "automatique",
      0.18
    ],
    [
      "instinctif",
      0.15
    ],
    [
      "irreflechi",
      0.12
    ],
    [
      "machinal",
      0.09
    ],
    [
      "spontane",
      0.06
    ],
    [
      "reflexe",
      0.06
    ],
    [
      "mecanique",
      0.06
    ],
    [
      "inconscient",
      0.06
    ],
    [
      "accidentel",
      0.03
    ],
    [
      "convulsif",
      0.03
    ],
    [
      "force",
      0.03
    ],
    [
      "irraisonne",
      0.03
    ],
    [
      "naturel",
      0.03
    ],
    [
      "passif",
      0.03
    ],
    [
      "reflectif",
      0.03
    ]
  ],
  "trique": [
    [
      "baton",
      0.3325
    ],
    [
      "cravache",
      0.11
    ],
    [
      "fouet",
      0.11
    ],
    [
      "gourdin",
      0.11
    ],
    [
      "massue",
      0.11
    ],
    [
      "matraque",
      0.11
    ],
    [
      "tricot",
      0.11
    ]
  ],
  "triquer": [
    [
      "bander",
      0.3325
    ],
    [
      "bastonner",
      0.3325
    ],
    [
      "battre",
      0.3325
    ]
  ],
  "bite": [
    [
      "verge",
      0.2725
    ],
    [
      "penis",
      0.18
    ],
    [
      "queue",
      0.18
    ],
    [
      "biroute",
      0.09
    ],
    [
      "bitte",
      0.09
    ],
    [
      "couille",
      0.09
    ],
    [
      "vit",
      0.09
    ]
  ],
  "fric": [
    [
      "argent",
      0.3125
    ],
    [
      "peze",
      0.1875
    ],
    [
      "ble",
      0.125
    ],
    [
      "pognon",
      0.125
    ],
    [
      "flouze",
      0.0625
    ],
    [
      "monnaie",
      0.0625
    ],
    [
      "oseille",
      0.0625
    ],
    [
      "pepetes",
      0.0625
    ]
  ],
  "discuter": [
    [
      "chicaner",
      0.055
    ],
    [
      "contester",
      0.055
    ],
    [
      "disputer",
      0.05
    ],
    [
      "examiner",
      0.04
    ],
    [
      "ergoter",
      0.04
    ],
    [
      "debattre",
      0.04
    ],
    [
      "argumenter",
      0.035
    ],
    [
      "batailler",
      0.035
    ],
    [
      "parler",
      0.035
    ],
    [
      "raisonner",
      0.0325
    ],
    [
      "palabrer",
      0.0325
    ],
    [
      "lutter",
      0.0275
    ],
    [
      "controverser",
      0.0225
    ],
    [
      "critiquer",
      0.0225
    ],
    [
      "parlementer",
      0.0225
    ],
    [
      "traiter",
      0.0225
    ],
    [
      "analyser",
      0.0175
    ],
    [
      "epiloguer",
      0.0125
    ],
    [
      "soutenir",
      0.0125
    ],
    [
      "nier",
      0.0125
    ],
    [
      "marchander",
      0.0125
    ],
    [
      "ferrailler",
      0.0125
    ],
    [
      "discutailler",
      0.0125
    ],
    [
      "conferer",
      0.0125
    ],
    [
      "bagarrer",
      0.0125
    ],
    [
      "agiter",
      0.0125
    ],
    [
      "jouter",
      0.0075
    ],
    [
      "philosopher",
      0.0075
    ],
    [
      "perorer",
      0.0075
    ],
    [
      "ratiociner",
      0.0075
    ],
    [
      "tenir",
      0.0075
    ],
    [
      "grogner",
      0.0075
    ],
    [
      "deliberer",
      0.0075
    ],
    [
      "barguigner",
      0.0075
    ],
    [
      "bavarder",
      0.0075
    ],
    [
      "causer",
      0.0075
    ],
    [
      "considerer",
      0.0075
    ],
    [
      "consulter",
      0.0075
    ],
    [
      "disputailler",
      0.0075
    ],
    [
      "raler",
      0.0025
    ],
    [
      "s'escrimer",
      0.0025
    ],
    [
      "s'expliquer",
      0.0025
    ],
    [
      "negocier",
      0.0025
    ],
    [
      "megoter",
      0.0025
    ],
    [
      "fronder",
      0.0025
    ],
    [
      "demeler",
      0.0025
    ],
    [
      "douter",
      0.0025
    ],
    [
      "dialoguer",
      0.0025
    ],
    [
      "colloquer",
      0.0025
    ],
    [
      "arguer",
      0.0025
    ]
  ],
  "salut": [
    [
      "reverence",
      0.115
    ],
    [
      "sauvegarde",
      0.045
    ],
    [
      "inclination",
      0.045
    ],
    [
      "courbette",
      0.045
    ],
    [
      "bonsoir",
      0.045
    ],
    [
      "bonjour",
      0.045
    ],
    [
      "bonheur",
      0.045
    ],
    [
      "bienvenue",
      0.045
    ],
    [
      "adieu",
      0.045
    ],
    [
      "prosternation",
      0.0225
    ],
    [
      "rachat",
      0.0225
    ],
    [
      "recompense",
      0.0225
    ],
    [
      "redemption",
      0.0225
    ],
    [
      "saintete",
      0.0225
    ],
    [
      "salamalec",
      0.0225
    ],
    [
      "salutation",
      0.0225
    ],
    [
      "plongeon",
      0.0225
    ],
    [
      "office",
      0.0225
    ],
    [
      "benediction",
      0.0225
    ],
    [
      "conservation",
      0.0225
    ],
    [
      "felicite",
      0.0225
    ],
    [
      "garantie",
      0.0225
    ],
    [
      "guerison",
      0.0225
    ],
    [
      "hommage",
      0.0225
    ],
    [
      "messe",
      0.0225
    ],
    [
      "tchao",
      0.0225
    ]
  ],
  "bronzer": [
    [
      "boucaner",
      0.105
    ],
    [
      "haler",
      0.105
    ],
    [
      "brunir",
      0.0775
    ],
    [
      "dessecher",
      0.0775
    ],
    [
      "endurcir",
      0.0775
    ],
    [
      "tanner",
      0.0775
    ],
    [
      "rotir",
      0.0525
    ],
    [
      "noircir",
      0.0525
    ],
    [
      "griller",
      0.0525
    ],
    [
      "durcir",
      0.0525
    ],
    [
      "culotter",
      0.0525
    ],
    [
      "cuire",
      0.0525
    ],
    [
      "cuirasser",
      0.0525
    ],
    [
      "basaner",
      0.025
    ],
    [
      "blinder",
      0.025
    ],
    [
      "peindre",
      0.025
    ]
  ],
  "bronze": [
    [
      "boucaner",
      0.105
    ],
    [
      "haler",
      0.105
    ],
    [
      "brunir",
      0.0775
    ],
    [
      "dessecher",
      0.0775
    ],
    [
      "endurcir",
      0.0775
    ],
    [
      "tanner",
      0.0775
    ],
    [
      "rotir",
      0.0525
    ],
    [
      "noircir",
      0.0525
    ],
    [
      "griller",
      0.0525
    ],
    [
      "durcir",
      0.0525
    ],
    [
      "culotter",
      0.0525
    ],
    [
      "cuire",
      0.0525
    ],
    [
      "cuirasser",
      0.0525
    ],
    [
      "basaner",
      0.025
    ],
    [
      "blinder",
      0.025
    ],
    [
      "peindre",
      0.025
    ]
  ],
  "tater": [
    [
      "examiner",
      0.1275
    ],
    [
      "sonder",
      0.1275
    ],
    [
      "toucher",
      0.0625
    ],
    [
      "eprouver",
      0.0625
    ],
    [
      "etudier",
      0.0625
    ],
    [
      "reconnaitre",
      0.0475
    ],
    [
      "interroger",
      0.0475
    ],
    [
      "gouter",
      0.0475
    ],
    [
      "experimenter",
      0.0475
    ],
    [
      "explorer",
      0.0475
    ],
    [
      "essayer",
      0.0475
    ],
    [
      "tatonner",
      0.03
    ],
    [
      "questionner",
      0.03
    ],
    [
      "palper",
      0.03
    ],
    [
      "manger",
      0.03
    ],
    [
      "fouiller",
      0.03
    ],
    [
      "ausculter",
      0.015
    ],
    [
      "confesser",
      0.015
    ],
    [
      "manier",
      0.015
    ],
    [
      "manipuler",
      0.015
    ],
    [
      "pressentir",
      0.015
    ],
    [
      "savourer",
      0.015
    ],
    [
      "tripoter",
      0.015
    ]
  ],
  "immobilier": [
    [
      "immeuble",
      1.0
    ]
  ],
  "infinite": [
    [
      "immensite",
      0.25
    ],
    [
      "quantite",
      0.25
    ],
    [
      "infini",
      0.125
    ],
    [
      "infinitude",
      0.125
    ],
    [
      "multitude",
      0.125
    ],
    [
      "myriade",
      0.125
    ]
  ],
  "taule": [
    [
      "chambre",
      0.125
    ],
    [
      "prison",
      0.125
    ],
    [
      "tole",
      0.1
    ],
    [
      "turne",
      0.075
    ],
    [
      "piece",
      0.075
    ],
    [
      "piaule",
      0.075
    ],
    [
      "cellule",
      0.075
    ],
    [
      "cambuse",
      0.075
    ],
    [
      "boite",
      0.05
    ],
    [
      "cachot",
      0.05
    ],
    [
      "casbah",
      0.05
    ],
    [
      "habitation",
      0.05
    ],
    [
      "cage",
      0.025
    ],
    [
      "emprisonnement",
      0.025
    ],
    [
      "hotel",
      0.025
    ]
  ],
  "eviter": [
    [
      "s'abstenir",
      0.05
    ],
    [
      "fuir",
      0.045
    ],
    [
      "echapper",
      0.045
    ],
    [
      "detourner",
      0.0375
    ],
    [
      "eluder",
      0.0325
    ],
    [
      "ecarter",
      0.0325
    ],
    [
      "prevenir",
      0.0275
    ],
    [
      "preserver",
      0.0275
    ],
    [
      "passer",
      0.0275
    ],
    [
      "parer",
      0.0275
    ],
    [
      "esquiver",
      0.0275
    ],
    [
      "exempter",
      0.0225
    ],
    [
      "empecher",
      0.0225
    ],
    [
      "dispenser",
      0.0225
    ],
    [
      "epargner",
      0.015
    ],
    [
      "supprimer",
      0.015
    ],
    [
      "soustraire",
      0.015
    ],
    [
      "s'ecarter",
      0.015
    ],
    [
      "liberer",
      0.015
    ],
    [
      "bannir",
      0.015
    ],
    [
      "s'interdire",
      0.01
    ],
    [
      "s'eloigner",
      0.01
    ],
    [
      "sauver",
      0.01
    ],
    [
      "s'exempter",
      0.01
    ],
    [
      "decliner",
      0.01
    ],
    [
      "conjurer",
      0.01
    ],
    [
      "couper",
      0.01
    ],
    [
      "devancer",
      0.01
    ],
    [
      "decharger",
      0.01
    ],
    [
      "s'echapper",
      0.005
    ],
    [
      "resister",
      0.005
    ],
    [
      "obvier",
      0.005
    ],
    [
      "finasser",
      0.005
    ],
    [
      "delivrer",
      0.005
    ],
    [
      "contourner",
      0.005
    ]
  ],
  "intimite": [
    [
      "liaison",
      0.1475
    ],
    [
      "amitie",
      0.0975
    ],
    [
      "abandon",
      0.065
    ],
    [
      "commerce",
      0.065
    ],
    [
      "familiarite",
      0.065
    ],
    [
      "frequentation",
      0.065
    ],
    [
      "union",
      0.0475
    ],
    [
      "camaraderie",
      0.0475
    ],
    [
      "accointance",
      0.0475
    ],
    [
      "simplicite",
      0.0325
    ],
    [
      "secret",
      0.0325
    ],
    [
      "correspondance",
      0.0325
    ],
    [
      "contact",
      0.0325
    ],
    [
      "confidence",
      0.0325
    ],
    [
      "confiance",
      0.0325
    ],
    [
      "attachement",
      0.0325
    ],
    [
      "sanctuaire",
      0.015
    ],
    [
      "profondeur",
      0.015
    ],
    [
      "naturel",
      0.015
    ],
    [
      "liberte",
      0.015
    ],
    [
      "interieur",
      0.015
    ],
    [
      "compagnonnage",
      0.015
    ],
    [
      "subconscient",
      0.015
    ]
  ],
  "certifier": [
    [
      "affirmer",
      0.15
    ],
    [
      "assurer",
      0.15
    ],
    [
      "temoigner",
      0.1
    ],
    [
      "declarer",
      0.065
    ],
    [
      "soutenir",
      0.0575
    ],
    [
      "repondre",
      0.0475
    ],
    [
      "jurer",
      0.0475
    ],
    [
      "garantir",
      0.0475
    ],
    [
      "dire",
      0.0475
    ],
    [
      "attester",
      0.0475
    ],
    [
      "promettre",
      0.0325
    ],
    [
      "confirmer",
      0.0325
    ],
    [
      "authentifier",
      0.0325
    ],
    [
      "signer",
      0.015
    ],
    [
      "reconnaitre",
      0.015
    ],
    [
      "parier",
      0.015
    ],
    [
      "legaliser",
      0.015
    ],
    [
      "constater",
      0.015
    ],
    [
      "authentiquer",
      0.0075
    ],
    [
      "maintenir",
      0.0075
    ],
    [
      "signaler",
      0.0075
    ],
    [
      "vidimer",
      0.0075
    ]
  ],
  "certifie": [
    [
      "affirmer",
      0.15
    ],
    [
      "assurer",
      0.15
    ],
    [
      "temoigner",
      0.1
    ],
    [
      "declarer",
      0.065
    ],
    [
      "soutenir",
      0.0575
    ],
    [
      "repondre",
      0.0475
    ],
    [
      "jurer",
      0.0475
    ],
    [
      "garantir",
      0.0475
    ],
    [
      "dire",
      0.0475
    ],
    [
      "attester",
      0.0475
    ],
    [
      "promettre",
      0.0325
    ],
    [
      "confirmer",
      0.0325
    ],
    [
      "authentifier",
      0.0325
    ],
    [
      "signer",
      0.015
    ],
    [
      "reconnaitre",
      0.015
    ],
    [
      "parier",
      0.015
    ],
    [
      "legaliser",
      0.015
    ],
    [
      "constater",
      0.015
    ],
    [
      "authentiquer",
      0.0075
    ],
    [
      "maintenir",
      0.0075
    ],
    [
      "signaler",
      0.0075
    ],
    [
      "vidimer",
      0.0075
    ]
  ],
  "tantinet": [
    [
      "peu",
      0.5
    ],
    [
      "tantet",
      0.5
    ]
  ],
  "eh": [
    [
      "hein",
      0.25
    ],
    [
      "alors",
      0.125
    ],
    [
      "comment",
      0.125
    ],
    [
      "ho",
      0.125
    ],
    [
      "he",
      0.125
    ],
    [
      "quoi",
      0.125
    ]
  ],
  "mouler": [
    [
      "sangler",
      0.1
    ],
    [
      "serrer",
      0.1
    ],
    [
      "pincer",
      0.065
    ],
    [
      "modeler",
      0.065
    ],
    [
      "gainer",
      0.065
    ],
    [
      "former",
      0.065
    ],
    [
      "forger",
      0.065
    ],
    [
      "dessiner",
      0.065
    ],
    [
      "s'appliquer",
      0.0325
    ],
    [
      "s'ajuster",
      0.0325
    ],
    [
      "petrir",
      0.0325
    ],
    [
      "plier",
      0.0325
    ],
    [
      "marquer",
      0.0325
    ],
    [
      "fondre",
      0.0325
    ],
    [
      "emboiter",
      0.0325
    ],
    [
      "couler",
      0.0325
    ],
    [
      "brider",
      0.0325
    ],
    [
      "boudiner",
      0.0325
    ],
    [
      "ajuster",
      0.0325
    ],
    [
      "epouser",
      0.0325
    ]
  ],
  "vautrer": [],
  "vautre": [
    [
      "chien",
      1.0
    ]
  ],
  "pointer": [
    [
      "surgir",
      0.09
    ],
    [
      "poindre",
      0.08
    ],
    [
      "percer",
      0.0675
    ],
    [
      "emerger",
      0.0675
    ],
    [
      "apparaitre",
      0.06
    ],
    [
      "paraitre",
      0.06
    ],
    [
      "sourdre",
      0.06
    ],
    [
      "piquer",
      0.0475
    ],
    [
      "pousser",
      0.0375
    ],
    [
      "arriver",
      0.03
    ],
    [
      "diriger",
      0.03
    ],
    [
      "marquer",
      0.03
    ],
    [
      "naitre",
      0.03
    ],
    [
      "venir",
      0.03
    ],
    [
      "s'elancer",
      0.0175
    ],
    [
      "s'imposer",
      0.0175
    ],
    [
      "pointiller",
      0.0175
    ],
    [
      "noter",
      0.0175
    ],
    [
      "jaillir",
      0.0175
    ],
    [
      "voler",
      0.0075
    ],
    [
      "viser",
      0.0075
    ],
    [
      "transpercer",
      0.0075
    ],
    [
      "tendre",
      0.0075
    ],
    [
      "regler",
      0.0075
    ],
    [
      "orienter",
      0.0075
    ],
    [
      "enregistrer",
      0.0075
    ],
    [
      "controler",
      0.0075
    ],
    [
      "contrepointer",
      0.0075
    ],
    [
      "cocher",
      0.0075
    ],
    [
      "braquer",
      0.0075
    ],
    [
      "appointer",
      0.0075
    ],
    [
      "verifier",
      0.0075
    ]
  ],
  "coupable": [
    [
      "condamnable",
      0.1175
    ],
    [
      "reprehensible",
      0.1025
    ],
    [
      "fautif",
      0.0725
    ],
    [
      "mauvais",
      0.0725
    ],
    [
      "responsable",
      0.0575
    ],
    [
      "delictueux",
      0.0575
    ],
    [
      "damnable",
      0.0575
    ],
    [
      "criminel",
      0.0425
    ],
    [
      "indigne",
      0.0425
    ],
    [
      "irregulier",
      0.0425
    ],
    [
      "pendable",
      0.0425
    ],
    [
      "peccant",
      0.0275
    ],
    [
      "meurtrier",
      0.0275
    ],
    [
      "blamable",
      0.0275
    ],
    [
      "pecheur",
      0.0125
    ],
    [
      "punissable",
      0.0125
    ],
    [
      "infame",
      0.0125
    ],
    [
      "inculpe",
      0.0125
    ],
    [
      "inavouable",
      0.0125
    ],
    [
      "illegitime",
      0.0125
    ],
    [
      "illicite",
      0.0125
    ],
    [
      "honteux",
      0.0125
    ],
    [
      "delinquant",
      0.0125
    ],
    [
      "breneux",
      0.0125
    ],
    [
      "auteur",
      0.0125
    ],
    [
      "vicieux",
      0.0125
    ]
  ],
  "bienseance": [
    [
      "decence",
      0.12
    ],
    [
      "politesse",
      0.11
    ],
    [
      "tact",
      0.0925
    ],
    [
      "convenance",
      0.0825
    ],
    [
      "retenue",
      0.0725
    ],
    [
      "reserve",
      0.0725
    ],
    [
      "delicatesse",
      0.065
    ],
    [
      "tenue",
      0.035
    ],
    [
      "pudeur",
      0.035
    ],
    [
      "honnetete",
      0.035
    ],
    [
      "correction",
      0.0275
    ],
    [
      "discretion",
      0.0275
    ],
    [
      "usage",
      0.0275
    ],
    [
      "etiquette",
      0.0175
    ],
    [
      "education",
      0.0175
    ],
    [
      "courtoisie",
      0.0175
    ],
    [
      "apparence",
      0.0075
    ],
    [
      "decorum",
      0.0075
    ],
    [
      "protocole",
      0.0075
    ]
  ],
  "infernal": [
    [
      "terrible",
      0.1325
    ],
    [
      "insupportable",
      0.1075
    ],
    [
      "odieux",
      0.07
    ],
    [
      "intenable",
      0.0525
    ],
    [
      "atroce",
      0.045
    ],
    [
      "dur",
      0.045
    ],
    [
      "mechant",
      0.045
    ],
    [
      "epouvantable",
      0.045
    ],
    [
      "penible",
      0.0375
    ],
    [
      "demoniaque",
      0.0375
    ],
    [
      "diabolique",
      0.0375
    ],
    [
      "diable",
      0.03
    ],
    [
      "indiscipline",
      0.03
    ],
    [
      "inhumain",
      0.03
    ],
    [
      "intolerable",
      0.03
    ],
    [
      "invivable",
      0.03
    ],
    [
      "indocile",
      0.0225
    ],
    [
      "endiable",
      0.015
    ],
    [
      "insoumis",
      0.015
    ],
    [
      "intense",
      0.015
    ],
    [
      "satanique",
      0.015
    ],
    [
      "satane",
      0.015
    ],
    [
      "pervers",
      0.005
    ],
    [
      "pandemoniaque",
      0.005
    ],
    [
      "mephistophelique",
      0.005
    ],
    [
      "insubordonne",
      0.005
    ],
    [
      "forcene",
      0.005
    ],
    [
      "execrable",
      0.005
    ],
    [
      "dementiel",
      0.005
    ],
    [
      "d'enfer",
      0.005
    ],
    [
      "chtonien",
      0.005
    ],
    [
      "sulfureux",
      0.005
    ]
  ],
  "recherche": [
    [
      "affectation",
      0.0675
    ],
    [
      "etude",
      0.0675
    ],
    [
      "examen",
      0.055
    ],
    [
      "enquete",
      0.0475
    ],
    [
      "observation",
      0.0475
    ],
    [
      "reconnaissance",
      0.04
    ],
    [
      "investigation",
      0.04
    ],
    [
      "appret",
      0.0325
    ],
    [
      "exploration",
      0.0325
    ],
    [
      "perquisition",
      0.0325
    ],
    [
      "preciosite",
      0.0325
    ],
    [
      "manierisme",
      0.0275
    ],
    [
      "affeterie",
      0.0275
    ],
    [
      "speculation",
      0.02
    ],
    [
      "quete",
      0.02
    ],
    [
      "meditation",
      0.02
    ],
    [
      "mignardise",
      0.02
    ],
    [
      "information",
      0.02
    ],
    [
      "experimentation",
      0.02
    ],
    [
      "experience",
      0.02
    ],
    [
      "art",
      0.02
    ],
    [
      "soif",
      0.0125
    ],
    [
      "singularite",
      0.0125
    ],
    [
      "raffinement",
      0.0125
    ],
    [
      "pose",
      0.0125
    ],
    [
      "curiosite",
      0.0125
    ],
    [
      "chique",
      0.0125
    ],
    [
      "chasse",
      0.0125
    ],
    [
      "approfondissement",
      0.0125
    ],
    [
      "gongorisme",
      0.005
    ],
    [
      "inquisition",
      0.005
    ],
    [
      "instruction",
      0.005
    ],
    [
      "mievrerie",
      0.005
    ],
    [
      "poursuite",
      0.005
    ],
    [
      "prospection",
      0.005
    ],
    [
      "tentative",
      0.005
    ],
    [
      "theorie",
      0.005
    ],
    [
      "travail",
      0.005
    ],
    [
      "tatonnement",
      0.005
    ],
    [
      "fouille",
      0.005
    ],
    [
      "esbroufe",
      0.005
    ],
    [
      "ambition",
      0.005
    ],
    [
      "battue",
      0.005
    ],
    [
      "cambrure",
      0.005
    ],
    [
      "concentration",
      0.005
    ],
    [
      "cultisme",
      0.005
    ],
    [
      "dandysme",
      0.005
    ],
    [
      "disquisition",
      0.005
    ],
    [
      "decouverte",
      0.005
    ],
    [
      "delicatesse",
      0.005
    ],
    [
      "depistage",
      0.005
    ],
    [
      "xenophilie",
      0.005
    ]
  ],
  "rechercher": [
    [
      "chercher",
      0.12
    ],
    [
      "examiner",
      0.0825
    ],
    [
      "solliciter",
      0.065
    ],
    [
      "desirer",
      0.0525
    ],
    [
      "sonder",
      0.0525
    ],
    [
      "viser",
      0.0525
    ],
    [
      "etudier",
      0.0425
    ],
    [
      "poursuivre",
      0.0425
    ],
    [
      "demander",
      0.0425
    ],
    [
      "fouiller",
      0.035
    ],
    [
      "queter",
      0.0275
    ],
    [
      "enqueter",
      0.0275
    ],
    [
      "briguer",
      0.0275
    ],
    [
      "ambitionner",
      0.0275
    ],
    [
      "analyser",
      0.02
    ],
    [
      "revendiquer",
      0.02
    ],
    [
      "s'enquerir",
      0.02
    ],
    [
      "souhaiter",
      0.02
    ],
    [
      "regarder",
      0.0125
    ],
    [
      "prospecter",
      0.0125
    ],
    [
      "pourchasser",
      0.0125
    ],
    [
      "perquisitionner",
      0.0125
    ],
    [
      "investiguer",
      0.0125
    ],
    [
      "courir",
      0.0125
    ],
    [
      "querir",
      0.005
    ],
    [
      "raffiner",
      0.005
    ],
    [
      "rever",
      0.005
    ],
    [
      "s'informer",
      0.005
    ],
    [
      "simuler",
      0.005
    ],
    [
      "verifier",
      0.005
    ],
    [
      "quemander",
      0.005
    ],
    [
      "pister",
      0.005
    ],
    [
      "determiner",
      0.005
    ],
    [
      "compulser",
      0.005
    ],
    [
      "battre",
      0.005
    ],
    [
      "appeter",
      0.005
    ],
    [
      "approfondir",
      0.005
    ],
    [
      "affecter",
      0.005
    ]
  ],
  "bandit": [
    [
      "voleur",
      0.095
    ],
    [
      "fripouille",
      0.0925
    ],
    [
      "brigand",
      0.0875
    ],
    [
      "vaurien",
      0.0775
    ],
    [
      "truand",
      0.055
    ],
    [
      "malfaiteur",
      0.0475
    ],
    [
      "forban",
      0.04
    ],
    [
      "terreur",
      0.035
    ],
    [
      "canaille",
      0.03
    ],
    [
      "coquin",
      0.03
    ],
    [
      "scelerat",
      0.03
    ],
    [
      "fripon",
      0.0275
    ],
    [
      "pirate",
      0.025
    ],
    [
      "gredin",
      0.025
    ],
    [
      "escroc",
      0.025
    ],
    [
      "crapule",
      0.025
    ],
    [
      "gangster",
      0.02
    ],
    [
      "meurtrier",
      0.0175
    ],
    [
      "malandrin",
      0.0175
    ],
    [
      "filou",
      0.0175
    ],
    [
      "criminel",
      0.0175
    ],
    [
      "chenapan",
      0.015
    ],
    [
      "voyou",
      0.0125
    ],
    [
      "flibustier",
      0.01
    ],
    [
      "corsaire",
      0.01
    ],
    [
      "requin",
      0.0075
    ],
    [
      "sacripant",
      0.0075
    ],
    [
      "vagabond",
      0.0075
    ],
    [
      "routier",
      0.0025
    ],
    [
      "miserable",
      0.0025
    ],
    [
      "libertin",
      0.0025
    ],
    [
      "escarpe",
      0.0025
    ],
    [
      "brigandeau",
      0.0025
    ],
    [
      "assassin",
      0.0025
    ],
    [
      "apache",
      0.0025
    ],
    [
      "ecorcheur",
      0.0
    ],
    [
      "miquelet",
      0.0
    ],
    [
      "incendiaire",
      0.0
    ],
    [
      "ganster",
      0.0
    ],
    [
      "cotereaux",
      0.0
    ],
    [
      "brabancon",
      0.0
    ],
    [
      "bandolier",
      0.0
    ],
    [
      "arsouille",
      0.0
    ],
    [
      "ecumeur",
      0.0
    ]
  ],
  "justesse": [
    [
      "exactitude",
      0.1425
    ],
    [
      "regularite",
      0.075
    ],
    [
      "fidelite",
      0.065
    ],
    [
      "precision",
      0.065
    ],
    [
      "verite",
      0.065
    ],
    [
      "sincerite",
      0.0425
    ],
    [
      "convenance",
      0.0425
    ],
    [
      "surete",
      0.0325
    ],
    [
      "rectitude",
      0.0325
    ],
    [
      "propriete",
      0.0325
    ],
    [
      "nettete",
      0.0325
    ],
    [
      "logique",
      0.0325
    ],
    [
      "justice",
      0.0325
    ],
    [
      "correction",
      0.0325
    ],
    [
      "rigueur",
      0.02
    ],
    [
      "raison",
      0.02
    ],
    [
      "pertinence",
      0.02
    ],
    [
      "objectivite",
      0.02
    ],
    [
      "impartialite",
      0.02
    ],
    [
      "finesse",
      0.02
    ],
    [
      "authenticite",
      0.02
    ],
    [
      "acuite",
      0.02
    ],
    [
      "harmonie",
      0.01
    ],
    [
      "opportunite",
      0.01
    ],
    [
      "proportion",
      0.01
    ]
  ],
  "crocodile": [
    [
      "alligator",
      0.2
    ],
    [
      "caiman",
      0.2
    ],
    [
      "croco",
      0.2
    ],
    [
      "dinosaure",
      0.2
    ],
    [
      "peau",
      0.2
    ]
  ],
  "trafic": [
    [
      "commerce",
      0.125
    ],
    [
      "circulation",
      0.1125
    ],
    [
      "tripotage",
      0.1
    ],
    [
      "transport",
      0.05
    ],
    [
      "ecoulement",
      0.0375
    ],
    [
      "transaction",
      0.0375
    ],
    [
      "passage",
      0.0375
    ],
    [
      "mouvement",
      0.0375
    ],
    [
      "maquignonnage",
      0.0375
    ],
    [
      "intrigue",
      0.0375
    ],
    [
      "grenouillage",
      0.0375
    ],
    [
      "cuisine",
      0.0375
    ],
    [
      "agiotage",
      0.0375
    ],
    [
      "speculation",
      0.025
    ],
    [
      "micmac",
      0.025
    ],
    [
      "malversation",
      0.025
    ],
    [
      "debit",
      0.025
    ],
    [
      "combine",
      0.025
    ],
    [
      "traite",
      0.0125
    ],
    [
      "simonie",
      0.0125
    ],
    [
      "roulage",
      0.0125
    ],
    [
      "negoce",
      0.0125
    ],
    [
      "marchandage",
      0.0125
    ],
    [
      "machinerie",
      0.0125
    ],
    [
      "carambouille",
      0.0125
    ],
    [
      "carambouillage",
      0.0125
    ],
    [
      "bricolage",
      0.0125
    ],
    [
      "usure",
      0.0125
    ]
  ],
  "operation": [
    [
      "action",
      0.075
    ],
    [
      "acte",
      0.0625
    ],
    [
      "affaire",
      0.0625
    ],
    [
      "campagne",
      0.0625
    ],
    [
      "expedition",
      0.0625
    ],
    [
      "execution",
      0.0625
    ],
    [
      "intervention",
      0.05
    ],
    [
      "calcul",
      0.05
    ],
    [
      "bataille",
      0.0375
    ],
    [
      "entreprise",
      0.0375
    ],
    [
      "travail",
      0.0375
    ],
    [
      "traitement",
      0.025
    ],
    [
      "speculation",
      0.025
    ],
    [
      "realisation",
      0.025
    ],
    [
      "offensive",
      0.025
    ],
    [
      "croisade",
      0.025
    ],
    [
      "compte",
      0.025
    ],
    [
      "combat",
      0.025
    ],
    [
      "accomplissement",
      0.025
    ],
    [
      "moyen",
      0.0125
    ],
    [
      "resolution",
      0.0125
    ],
    [
      "transaction",
      0.0125
    ],
    [
      "tache",
      0.0125
    ],
    [
      "manipulation",
      0.0125
    ],
    [
      "excision",
      0.0125
    ],
    [
      "descente",
      0.0125
    ],
    [
      "bistouri",
      0.0125
    ],
    [
      "besogne",
      0.0125
    ],
    [
      "arithmetique",
      0.0125
    ],
    [
      "amputation",
      0.0125
    ],
    [
      "ablation",
      0.0125
    ],
    [
      "virement",
      0.0125
    ]
  ],
  "birman": [],
  "flibustier": [
    [
      "pirate",
      0.1825
    ],
    [
      "bandit",
      0.12
    ],
    [
      "corsaire",
      0.12
    ],
    [
      "forban",
      0.12
    ],
    [
      "voleur",
      0.12
    ],
    [
      "escroc",
      0.09
    ],
    [
      "filou",
      0.06
    ],
    [
      "boucanier",
      0.06
    ],
    [
      "flibuste",
      0.0275
    ],
    [
      "fripon",
      0.0275
    ],
    [
      "ecumeur",
      0.0275
    ]
  ],
  "demasquer": [
    [
      "decouvrir",
      0.175
    ],
    [
      "devoiler",
      0.145
    ],
    [
      "montrer",
      0.1175
    ],
    [
      "reveler",
      0.0875
    ],
    [
      "trahir",
      0.0875
    ],
    [
      "etaler",
      0.0575
    ],
    [
      "livrer",
      0.0575
    ],
    [
      "deviner",
      0.0575
    ],
    [
      "arracher",
      0.0275
    ],
    [
      "bruler",
      0.0275
    ],
    [
      "confondre",
      0.0275
    ],
    [
      "demontrer",
      0.0275
    ],
    [
      "deshabiller",
      0.0275
    ],
    [
      "penetrer",
      0.0275
    ]
  ],
  "collier": [
    [
      "chaine",
      0.19
    ],
    [
      "anneau",
      0.075
    ],
    [
      "attache",
      0.075
    ],
    [
      "carcan",
      0.075
    ],
    [
      "joug",
      0.075
    ],
    [
      "peine",
      0.0375
    ],
    [
      "rang",
      0.0375
    ],
    [
      "riviere",
      0.0375
    ],
    [
      "sautoir",
      0.0375
    ],
    [
      "servitude",
      0.0375
    ],
    [
      "harnais",
      0.0375
    ],
    [
      "gaine",
      0.0375
    ],
    [
      "esclavage",
      0.0375
    ],
    [
      "cercle",
      0.0375
    ],
    [
      "bijou",
      0.0375
    ],
    [
      "barbe",
      0.0375
    ],
    [
      "bague",
      0.0375
    ],
    [
      "torque",
      0.0375
    ]
  ],
  "surgir": [
    [
      "apparaitre",
      0.1
    ],
    [
      "paraitre",
      0.0875
    ],
    [
      "poindre",
      0.07
    ],
    [
      "naitre",
      0.055
    ],
    [
      "sortir",
      0.055
    ],
    [
      "emerger",
      0.055
    ],
    [
      "arriver",
      0.0525
    ],
    [
      "percer",
      0.0475
    ],
    [
      "sourdre",
      0.0425
    ],
    [
      "pointer",
      0.0375
    ],
    [
      "venir",
      0.0375
    ],
    [
      "survenir",
      0.0325
    ],
    [
      "s'elever",
      0.03
    ],
    [
      "tomber",
      0.025
    ],
    [
      "eclore",
      0.025
    ],
    [
      "s'offrir",
      0.015
    ],
    [
      "jaillir",
      0.015
    ],
    [
      "s'echapper",
      0.0025
    ],
    [
      "s'ebaucher",
      0.0025
    ],
    [
      "germer",
      0.0025
    ],
    [
      "debouler",
      0.0025
    ],
    [
      "deboucher",
      0.0025
    ],
    [
      "accourir",
      0.0025
    ]
  ],
  "aventurier": [
    [
      "vagabond",
      0.135
    ],
    [
      "forban",
      0.09
    ],
    [
      "fripouille",
      0.09
    ],
    [
      "truand",
      0.09
    ],
    [
      "vaurien",
      0.09
    ],
    [
      "faiseur",
      0.045
    ],
    [
      "intrigant",
      0.045
    ],
    [
      "mercenaire",
      0.045
    ],
    [
      "errant",
      0.045
    ],
    [
      "conquistador",
      0.045
    ],
    [
      "boucanier",
      0.045
    ],
    [
      "baroudeur",
      0.045
    ],
    [
      "aventureux",
      0.045
    ],
    [
      "voyageur",
      0.045
    ]
  ],
  "surnom": [
    [
      "pseudonyme",
      0.25
    ],
    [
      "heteronyme",
      0.165
    ],
    [
      "nom",
      0.165
    ],
    [
      "sobriquet",
      0.165
    ],
    [
      "qualificatif",
      0.0825
    ]
  ],
  "gang": [
    [
      "bande",
      0.3
    ],
    [
      "coterie",
      0.2
    ],
    [
      "groupe",
      0.2
    ],
    [
      "maffia",
      0.1
    ],
    [
      "ramassis",
      0.1
    ],
    [
      "troupe",
      0.1
    ]
  ],
  "otage": [
    [
      "garant",
      0.3
    ],
    [
      "caution",
      0.2
    ],
    [
      "captif",
      0.1
    ],
    [
      "comptable",
      0.1
    ],
    [
      "gage",
      0.1
    ],
    [
      "prisonnier",
      0.1
    ],
    [
      "repondant",
      0.1
    ]
  ],
  "solitaire": [
    [
      "sauvage",
      0.0775
    ],
    [
      "desert",
      0.0675
    ],
    [
      "isole",
      0.0675
    ],
    [
      "abandonne",
      0.0575
    ],
    [
      "inhabite",
      0.0575
    ],
    [
      "retire",
      0.0575
    ],
    [
      "seul",
      0.0575
    ],
    [
      "infrequente",
      0.0475
    ],
    [
      "diamant",
      0.0475
    ],
    [
      "sanglier",
      0.0375
    ],
    [
      "brillant",
      0.0275
    ],
    [
      "ermite",
      0.0275
    ],
    [
      "vide",
      0.0275
    ],
    [
      "ecarte",
      0.0175
    ],
    [
      "reclus",
      0.0175
    ],
    [
      "ours",
      0.0175
    ],
    [
      "misanthrope",
      0.0175
    ],
    [
      "depeuple",
      0.0175
    ],
    [
      "cochon",
      0.0175
    ],
    [
      "bete",
      0.0175
    ],
    [
      "bague",
      0.0175
    ],
    [
      "moine",
      0.0075
    ],
    [
      "male",
      0.0075
    ],
    [
      "pierre",
      0.0075
    ],
    [
      "porc",
      0.0075
    ],
    [
      "quartanier",
      0.0075
    ],
    [
      "ragot",
      0.0075
    ],
    [
      "rose",
      0.0075
    ],
    [
      "marquise",
      0.0075
    ],
    [
      "joyau",
      0.0075
    ],
    [
      "insociable",
      0.0075
    ],
    [
      "amer",
      0.0075
    ],
    [
      "anachorete",
      0.0075
    ],
    [
      "ascete",
      0.0075
    ],
    [
      "casanier",
      0.0075
    ],
    [
      "celibataire",
      0.0075
    ],
    [
      "desertique",
      0.0075
    ],
    [
      "desole",
      0.0075
    ],
    [
      "esseule",
      0.0075
    ],
    [
      "vacant",
      0.0075
    ]
  ],
  "veste": [
    [
      "habit",
      0.08
    ],
    [
      "insucces",
      0.0375
    ],
    [
      "jaquette",
      0.0375
    ],
    [
      "pourpoint",
      0.0375
    ],
    [
      "pelerine",
      0.0375
    ],
    [
      "saharienne",
      0.0375
    ],
    [
      "soubreveste",
      0.0375
    ],
    [
      "tunique",
      0.0375
    ],
    [
      "vareuse",
      0.0375
    ],
    [
      "veston",
      0.0375
    ],
    [
      "hoqueton",
      0.0375
    ],
    [
      "dolman",
      0.0375
    ],
    [
      "anorak",
      0.0375
    ],
    [
      "bide",
      0.0375
    ],
    [
      "bidon",
      0.0375
    ],
    [
      "blazer",
      0.0375
    ],
    [
      "blouson",
      0.0375
    ],
    [
      "bolero",
      0.0375
    ],
    [
      "caban",
      0.0375
    ],
    [
      "canadienne",
      0.0375
    ],
    [
      "cardigan",
      0.0375
    ],
    [
      "costume",
      0.0375
    ],
    [
      "echec",
      0.0375
    ]
  ],
  "cinema": [
    [
      "spectacle",
      0.1525
    ],
    [
      "pellicule",
      0.075
    ],
    [
      "numero",
      0.075
    ],
    [
      "fable",
      0.075
    ],
    [
      "comedie",
      0.075
    ],
    [
      "cirque",
      0.075
    ],
    [
      "cinematographe",
      0.075
    ],
    [
      "cine",
      0.075
    ],
    [
      "cinoche",
      0.075
    ],
    [
      "agissements",
      0.075
    ],
    [
      "salle",
      0.075
    ]
  ],
  "etc": [],
  "saurer": [
    [
      "fumer",
      1.0
    ]
  ],
  "empereur": [
    [
      "roi",
      0.2075
    ],
    [
      "cesar",
      0.125
    ],
    [
      "monarque",
      0.125
    ],
    [
      "prince",
      0.125
    ],
    [
      "sultan",
      0.0825
    ],
    [
      "padischah",
      0.04
    ],
    [
      "mikado",
      0.04
    ],
    [
      "majeste",
      0.04
    ],
    [
      "kaiser",
      0.04
    ],
    [
      "couronne",
      0.04
    ],
    [
      "chef",
      0.04
    ],
    [
      "tsar",
      0.04
    ]
  ],
  "suffisant": [
    [
      "pourvoir",
      0.18
    ],
    [
      "satisfaire",
      0.18
    ],
    [
      "apaiser",
      0.09
    ],
    [
      "baster",
      0.09
    ],
    [
      "contenter",
      0.09
    ],
    [
      "fournir",
      0.09
    ],
    [
      "subvenir",
      0.09
    ]
  ],
  "monotone": [
    [
      "morne",
      0.115
    ],
    [
      "uniforme",
      0.115
    ],
    [
      "terne",
      0.0975
    ],
    [
      "ennuyeux",
      0.08
    ],
    [
      "plat",
      0.08
    ],
    [
      "insipide",
      0.065
    ],
    [
      "barbant",
      0.065
    ],
    [
      "endormant",
      0.0475
    ],
    [
      "triste",
      0.0475
    ],
    [
      "egal",
      0.0325
    ],
    [
      "uni",
      0.0325
    ],
    [
      "rasoir",
      0.0325
    ],
    [
      "monocorde",
      0.0325
    ],
    [
      "lassant",
      0.0325
    ],
    [
      "froid",
      0.0325
    ],
    [
      "assoupissant",
      0.015
    ],
    [
      "grisatre",
      0.015
    ],
    [
      "psalmodique",
      0.015
    ],
    [
      "regulier",
      0.015
    ],
    [
      "trainant",
      0.015
    ]
  ],
  "indifferer": [],
  "cela": [
    [
      "ceci",
      0.5
    ],
    [
      "ca",
      0.5
    ]
  ],
  "automne": [],
  "exaucer": [
    [
      "satisfaire",
      0.415
    ],
    [
      "accomplir",
      0.0825
    ],
    [
      "accorder",
      0.0825
    ],
    [
      "agreer",
      0.0825
    ],
    [
      "combler",
      0.0825
    ],
    [
      "contenter",
      0.0825
    ],
    [
      "entendre",
      0.0825
    ],
    [
      "ecouter",
      0.0825
    ]
  ],
  "approcher": [
    [
      "venir",
      0.075
    ],
    [
      "toucher",
      0.0625
    ],
    [
      "s'approcher",
      0.0625
    ],
    [
      "arriver",
      0.0625
    ],
    [
      "aborder",
      0.0625
    ],
    [
      "accoster",
      0.05
    ],
    [
      "ressembler",
      0.0375
    ],
    [
      "joindre",
      0.0375
    ],
    [
      "cotoyer",
      0.0375
    ],
    [
      "avancer",
      0.0375
    ],
    [
      "egaler",
      0.025
    ],
    [
      "s'avancer",
      0.025
    ],
    [
      "rapprocher",
      0.025
    ],
    [
      "frequenter",
      0.025
    ],
    [
      "friser",
      0.025
    ],
    [
      "effleurer",
      0.025
    ],
    [
      "egaliser",
      0.0125
    ],
    [
      "s'apparenter",
      0.0125
    ],
    [
      "rivaliser",
      0.0125
    ],
    [
      "regarder",
      0.0125
    ],
    [
      "entourer",
      0.0125
    ],
    [
      "donner",
      0.0125
    ],
    [
      "contacter",
      0.0125
    ]
  ],
  "approche": [
    [
      "venir",
      0.075
    ],
    [
      "toucher",
      0.0625
    ],
    [
      "s'approcher",
      0.0625
    ],
    [
      "arriver",
      0.0625
    ],
    [
      "aborder",
      0.0625
    ],
    [
      "accoster",
      0.05
    ],
    [
      "ressembler",
      0.0375
    ],
    [
      "joindre",
      0.0375
    ],
    [
      "cotoyer",
      0.0375
    ],
    [
      "avancer",
      0.0375
    ],
    [
      "egaler",
      0.025
    ],
    [
      "s'avancer",
      0.025
    ],
    [
      "rapprocher",
      0.025
    ],
    [
      "frequenter",
      0.025
    ],
    [
      "friser",
      0.025
    ],
    [
      "effleurer",
      0.025
    ],
    [
      "egaliser",
      0.0125
    ],
    [
      "s'apparenter",
      0.0125
    ],
    [
      "rivaliser",
      0.0125
    ],
    [
      "regarder",
      0.0125
    ],
    [
      "entourer",
      0.0125
    ],
    [
      "donner",
      0.0125
    ],
    [
      "contacter",
      0.0125
    ]
  ],
  "barre": [
    [
      "bande",
      0.0625
    ],
    [
      "banc",
      0.045
    ],
    [
      "ligne",
      0.045
    ],
    [
      "ringard",
      0.03
    ],
    [
      "rable",
      0.03
    ],
    [
      "tige",
      0.03
    ],
    [
      "tisonnier",
      0.03
    ],
    [
      "trait",
      0.03
    ],
    [
      "tringle",
      0.03
    ],
    [
      "rature",
      0.03
    ],
    [
      "raie",
      0.03
    ],
    [
      "axe",
      0.03
    ],
    [
      "barreau",
      0.03
    ],
    [
      "fourgon",
      0.03
    ],
    [
      "levier",
      0.03
    ],
    [
      "montant",
      0.03
    ],
    [
      "pince",
      0.03
    ],
    [
      "gouvernail",
      0.015
    ],
    [
      "lingot",
      0.015
    ],
    [
      "lisiere",
      0.015
    ],
    [
      "mascaret",
      0.015
    ],
    [
      "meneau",
      0.015
    ],
    [
      "parquet",
      0.015
    ],
    [
      "rambarde",
      0.015
    ],
    [
      "raz",
      0.015
    ],
    [
      "ruban",
      0.015
    ],
    [
      "timonerie",
      0.015
    ],
    [
      "vague",
      0.015
    ],
    [
      "ganache",
      0.015
    ],
    [
      "flot",
      0.015
    ],
    [
      "appui",
      0.015
    ],
    [
      "arbre",
      0.015
    ],
    [
      "baguette",
      0.015
    ],
    [
      "biffage",
      0.015
    ],
    [
      "biffure",
      0.015
    ],
    [
      "bille",
      0.015
    ],
    [
      "baton",
      0.015
    ],
    [
      "chien",
      0.015
    ],
    [
      "cottiere",
      0.015
    ],
    [
      "davier",
      0.015
    ],
    [
      "diasteme",
      0.015
    ],
    [
      "agres",
      0.015
    ]
  ],
  "barrer": [
    [
      "fermer",
      0.0725
    ],
    [
      "couper",
      0.0675
    ],
    [
      "supprimer",
      0.0675
    ],
    [
      "biffer",
      0.06
    ],
    [
      "arreter",
      0.05
    ],
    [
      "effacer",
      0.045
    ],
    [
      "rayer",
      0.0425
    ],
    [
      "oter",
      0.0375
    ],
    [
      "retrancher",
      0.0375
    ],
    [
      "empecher",
      0.0375
    ],
    [
      "barricader",
      0.0375
    ],
    [
      "bloquer",
      0.0275
    ],
    [
      "censurer",
      0.025
    ],
    [
      "radier",
      0.025
    ],
    [
      "obstruer",
      0.02
    ],
    [
      "enlever",
      0.02
    ],
    [
      "boucher",
      0.02
    ],
    [
      "sabrer",
      0.015
    ],
    [
      "retirer",
      0.015
    ],
    [
      "retenir",
      0.015
    ],
    [
      "endiguer",
      0.015
    ],
    [
      "condamner",
      0.015
    ],
    [
      "clore",
      0.015
    ],
    [
      "caviarder",
      0.015
    ],
    [
      "ecluser",
      0.0125
    ],
    [
      "traverser",
      0.0125
    ],
    [
      "rompre",
      0.0125
    ],
    [
      "raturer",
      0.0125
    ],
    [
      "interrompre",
      0.0125
    ],
    [
      "borner",
      0.0125
    ],
    [
      "annuler",
      0.0125
    ],
    [
      "soustraire",
      0.0075
    ],
    [
      "contrarier",
      0.0075
    ],
    [
      "bacler",
      0.0075
    ],
    [
      "balafrer",
      0.0075
    ],
    [
      "batonner",
      0.0025
    ],
    [
      "cadenasser",
      0.0025
    ],
    [
      "cloturer",
      0.0025
    ],
    [
      "colmater",
      0.0025
    ],
    [
      "diriger",
      0.0025
    ],
    [
      "gouverner",
      0.0025
    ],
    [
      "rectifier",
      0.0025
    ]
  ],
  "legal": [
    [
      "regulier",
      0.2125
    ],
    [
      "licite",
      0.1425
    ],
    [
      "reglementaire",
      0.105
    ],
    [
      "valable",
      0.07
    ],
    [
      "tolere",
      0.07
    ],
    [
      "permis",
      0.07
    ],
    [
      "honnete",
      0.07
    ],
    [
      "legitime",
      0.035
    ],
    [
      "loyal",
      0.035
    ],
    [
      "juridique",
      0.035
    ],
    [
      "institutionnel",
      0.035
    ],
    [
      "competent",
      0.035
    ],
    [
      "authentique",
      0.035
    ],
    [
      "valide",
      0.035
    ]
  ],
  "samedi": [],
  "decevoir": [
    [
      "tromper",
      0.125
    ],
    [
      "abuser",
      0.0775
    ],
    [
      "berner",
      0.0775
    ],
    [
      "desappointer",
      0.0775
    ],
    [
      "chagriner",
      0.06
    ],
    [
      "navrer",
      0.06
    ],
    [
      "desoler",
      0.045
    ],
    [
      "attraper",
      0.045
    ],
    [
      "trahir",
      0.03
    ],
    [
      "seduire",
      0.03
    ],
    [
      "leurrer",
      0.03
    ],
    [
      "frustrer",
      0.03
    ],
    [
      "ennuyer",
      0.03
    ],
    [
      "desillusionner",
      0.03
    ],
    [
      "desenchanter",
      0.03
    ],
    [
      "depiter",
      0.03
    ],
    [
      "defriser",
      0.03
    ],
    [
      "duper",
      0.03
    ],
    [
      "amuser",
      0.03
    ],
    [
      "surprendre",
      0.015
    ],
    [
      "detruire",
      0.015
    ],
    [
      "desesperer",
      0.015
    ],
    [
      "dementir",
      0.015
    ],
    [
      "echauder",
      0.015
    ]
  ],
  "gicler": [
    [
      "jaillir",
      0.2775
    ],
    [
      "fuser",
      0.165
    ],
    [
      "rejaillir",
      0.165
    ],
    [
      "couler",
      0.11
    ],
    [
      "partir",
      0.055
    ],
    [
      "s'elancer",
      0.055
    ],
    [
      "eclabousser",
      0.055
    ]
  ],
  "giclee": [
    [
      "jaillir",
      0.2775
    ],
    [
      "fuser",
      0.165
    ],
    [
      "rejaillir",
      0.165
    ],
    [
      "couler",
      0.11
    ],
    [
      "partir",
      0.055
    ],
    [
      "s'elancer",
      0.055
    ],
    [
      "eclabousser",
      0.055
    ]
  ],
  "ho": [
    [
      "hola",
      0.3325
    ],
    [
      "he",
      0.3325
    ],
    [
      "eh",
      0.165
    ],
    [
      "oh",
      0.165
    ]
  ],
  "sauvageon": [
    [
      "sauvage",
      1.0
    ]
  ],
  "flash": [
    [
      "information",
      0.25
    ],
    [
      "message",
      0.25
    ],
    [
      "spot",
      0.25
    ],
    [
      "eclair",
      0.25
    ]
  ],
  "remettre": [
    [
      "donner",
      0.035
    ],
    [
      "retarder",
      0.035
    ],
    [
      "renvoyer",
      0.0325
    ],
    [
      "retablir",
      0.03
    ],
    [
      "differer",
      0.0275
    ],
    [
      "reculer",
      0.0275
    ],
    [
      "repousser",
      0.0225
    ],
    [
      "abandonner",
      0.0225
    ],
    [
      "ramener",
      0.0225
    ],
    [
      "rendre",
      0.0225
    ],
    [
      "temporiser",
      0.0175
    ],
    [
      "remonter",
      0.0175
    ],
    [
      "rapporter",
      0.0175
    ],
    [
      "mettre",
      0.0175
    ],
    [
      "transmettre",
      0.0175
    ],
    [
      "restaurer",
      0.0175
    ],
    [
      "relever",
      0.0175
    ],
    [
      "redonner",
      0.0175
    ],
    [
      "laisser",
      0.0175
    ],
    [
      "ajourner",
      0.0175
    ],
    [
      "surseoir",
      0.0125
    ],
    [
      "reconforter",
      0.0125
    ],
    [
      "revigorer",
      0.0125
    ],
    [
      "reporter",
      0.0125
    ],
    [
      "proroger",
      0.0125
    ],
    [
      "transporter",
      0.01
    ],
    [
      "retourner",
      0.01
    ],
    [
      "restituer",
      0.01
    ],
    [
      "refaire",
      0.01
    ],
    [
      "rapprocher",
      0.01
    ],
    [
      "raccommoder",
      0.01
    ],
    [
      "deposer",
      0.01
    ],
    [
      "accorder",
      0.01
    ],
    [
      "retroceder",
      0.0075
    ],
    [
      "retaper",
      0.0075
    ],
    [
      "ressusciter",
      0.0075
    ],
    [
      "passer",
      0.0075
    ],
    [
      "livrer",
      0.0075
    ],
    [
      "atermoyer",
      0.0075
    ],
    [
      "ranger",
      0.005
    ],
    [
      "reconnaitre",
      0.005
    ],
    [
      "renoncer",
      0.005
    ],
    [
      "repasser",
      0.005
    ],
    [
      "requinquer",
      0.005
    ],
    [
      "retrouver",
      0.005
    ],
    [
      "reduire",
      0.005
    ],
    [
      "suspendre",
      0.005
    ],
    [
      "rabibocher",
      0.005
    ],
    [
      "pardonner",
      0.005
    ],
    [
      "abolir",
      0.005
    ],
    [
      "attendre",
      0.005
    ],
    [
      "confier",
      0.005
    ],
    [
      "consigner",
      0.005
    ],
    [
      "excuser",
      0.005
    ],
    [
      "guerir",
      0.005
    ],
    [
      "leguer",
      0.005
    ],
    [
      "remiser",
      0.0025
    ],
    [
      "remmener",
      0.0025
    ],
    [
      "remplacer",
      0.0025
    ],
    [
      "rentrer",
      0.0025
    ],
    [
      "replacer",
      0.0025
    ],
    [
      "reintegrer",
      0.0025
    ],
    [
      "tarder",
      0.0025
    ],
    [
      "eloigner",
      0.0025
    ],
    [
      "redresser",
      0.0025
    ],
    [
      "reconduire",
      0.0025
    ],
    [
      "ravigoter",
      0.0025
    ],
    [
      "absoudre",
      0.0025
    ],
    [
      "allonger",
      0.0025
    ],
    [
      "amnistier",
      0.0025
    ],
    [
      "commettre",
      0.0025
    ],
    [
      "concilier",
      0.0025
    ],
    [
      "delivrer",
      0.0025
    ],
    [
      "lanterner",
      0.0025
    ],
    [
      "payer",
      0.0025
    ],
    [
      "rajouter",
      0.0025
    ],
    [
      "rembarrer",
      0.0
    ],
    [
      "remboiter",
      0.0
    ],
    [
      "remener",
      0.0
    ],
    [
      "reposer",
      0.0
    ],
    [
      "reendosser",
      0.0
    ],
    [
      "reunir",
      0.0
    ],
    [
      "recommencer",
      0.0
    ],
    [
      "rebouter",
      0.0
    ],
    [
      "rapatrier",
      0.0
    ],
    [
      "adjuger",
      0.0
    ],
    [
      "alleger",
      0.0
    ],
    [
      "exagerer",
      0.0
    ],
    [
      "identifier",
      0.0
    ],
    [
      "poster",
      0.0
    ],
    [
      "rabrouer",
      0.0
    ],
    [
      "rapapilloter",
      0.0
    ],
    [
      "tranquilliser",
      0.0
    ]
  ],
  "tissage": [
    [
      "armure",
      0.2
    ],
    [
      "lice",
      0.2
    ],
    [
      "textile",
      0.2
    ],
    [
      "texture",
      0.2
    ],
    [
      "tordage",
      0.2
    ]
  ],
  "funky": [],
  "cash": [
    [
      "recta",
      1.0
    ]
  ],
  "ralenti": [
    [
      "reduit",
      1.0
    ]
  ],
  "ralentir": [
    [
      "freiner",
      0.1375
    ],
    [
      "arreter",
      0.1075
    ],
    [
      "entraver",
      0.0925
    ],
    [
      "moderer",
      0.075
    ],
    [
      "paralyser",
      0.075
    ],
    [
      "temperer",
      0.06
    ],
    [
      "gener",
      0.06
    ],
    [
      "retarder",
      0.045
    ],
    [
      "eteindre",
      0.03
    ],
    [
      "tenir",
      0.03
    ],
    [
      "retenir",
      0.03
    ],
    [
      "obstruer",
      0.03
    ],
    [
      "immobiliser",
      0.03
    ],
    [
      "embarrasser",
      0.03
    ],
    [
      "diminuer",
      0.03
    ],
    [
      "nuire",
      0.0125
    ],
    [
      "mesurer",
      0.0125
    ],
    [
      "decelerer",
      0.0125
    ],
    [
      "attenuer",
      0.0125
    ],
    [
      "alentir",
      0.0125
    ],
    [
      "temporiser",
      0.0125
    ]
  ],
  "galanterie": [
    [
      "amabilite",
      0.07
    ],
    [
      "gentillesse",
      0.06
    ],
    [
      "amour",
      0.055
    ],
    [
      "civilite",
      0.05
    ],
    [
      "delicatesse",
      0.05
    ],
    [
      "politesse",
      0.05
    ],
    [
      "grace",
      0.045
    ],
    [
      "douceur",
      0.03
    ],
    [
      "courtoisie",
      0.03
    ],
    [
      "complaisance",
      0.03
    ],
    [
      "bagatelle",
      0.03
    ],
    [
      "badinage",
      0.03
    ],
    [
      "flirt",
      0.025
    ],
    [
      "coquetterie",
      0.0175
    ],
    [
      "amenite",
      0.0175
    ],
    [
      "agrement",
      0.0175
    ],
    [
      "affabilite",
      0.0175
    ],
    [
      "elegance",
      0.0125
    ],
    [
      "tendresse",
      0.0125
    ],
    [
      "respect",
      0.0125
    ],
    [
      "prevenance",
      0.0125
    ],
    [
      "propos",
      0.0125
    ],
    [
      "liaison",
      0.0125
    ],
    [
      "intrigue",
      0.0125
    ],
    [
      "fadaise",
      0.0125
    ],
    [
      "empressement",
      0.0125
    ],
    [
      "debauche",
      0.0125
    ],
    [
      "distinction",
      0.0125
    ],
    [
      "bluette",
      0.0125
    ],
    [
      "aventure",
      0.0125
    ],
    [
      "fadeur",
      0.0075
    ],
    [
      "marivaudage",
      0.0075
    ],
    [
      "passade",
      0.0075
    ],
    [
      "polissonnerie",
      0.0075
    ],
    [
      "seduction",
      0.0075
    ],
    [
      "deference",
      0.0075
    ],
    [
      "compliment",
      0.0075
    ],
    [
      "commerce",
      0.0075
    ],
    [
      "bricole",
      0.0075
    ],
    [
      "babiole",
      0.0075
    ],
    [
      "assiduite",
      0.0075
    ],
    [
      "affaire",
      0.0075
    ],
    [
      "libertinage",
      0.0025
    ],
    [
      "madrigal",
      0.0025
    ],
    [
      "pelotage",
      0.0025
    ],
    [
      "poursuite",
      0.0025
    ],
    [
      "prostitution",
      0.0025
    ],
    [
      "fredaine",
      0.0025
    ],
    [
      "fleurette",
      0.0025
    ],
    [
      "cour",
      0.0025
    ],
    [
      "coucherie",
      0.0025
    ],
    [
      "alcove",
      0.0025
    ],
    [
      "preciosite",
      0.0025
    ]
  ],
  "pil": [],
  "pile": [
    [
      "raclee",
      0.085
    ],
    [
      "rossee",
      0.085
    ],
    [
      "volee",
      0.085
    ],
    [
      "trempe",
      0.0625
    ],
    [
      "piquette",
      0.0525
    ],
    [
      "monceau",
      0.0525
    ],
    [
      "amoncellement",
      0.0425
    ],
    [
      "tas",
      0.0425
    ],
    [
      "roulee",
      0.03
    ],
    [
      "frottee",
      0.03
    ],
    [
      "entassement",
      0.03
    ],
    [
      "degelee",
      0.03
    ],
    [
      "defaite",
      0.03
    ],
    [
      "coup",
      0.03
    ],
    [
      "amas",
      0.03
    ],
    [
      "torgnole",
      0.02
    ],
    [
      "revers",
      0.02
    ],
    [
      "peignee",
      0.02
    ],
    [
      "empilement",
      0.02
    ],
    [
      "reacteur",
      0.01
    ],
    [
      "precis",
      0.01
    ],
    [
      "pilastre",
      0.01
    ],
    [
      "paquet",
      0.01
    ],
    [
      "montagne",
      0.01
    ],
    [
      "insucces",
      0.01
    ],
    [
      "generateur",
      0.01
    ],
    [
      "envers",
      0.01
    ],
    [
      "empilage",
      0.01
    ],
    [
      "batterie",
      0.01
    ],
    [
      "accumulateur",
      0.01
    ],
    [
      "ecroulement",
      0.01
    ]
  ],
  "loge": [
    [
      "abri",
      0.0825
    ],
    [
      "cabane",
      0.0825
    ],
    [
      "reduit",
      0.0525
    ],
    [
      "niche",
      0.0525
    ],
    [
      "compartiment",
      0.0525
    ],
    [
      "cellule",
      0.0525
    ],
    [
      "cabine",
      0.0525
    ],
    [
      "box",
      0.0525
    ],
    [
      "baraque",
      0.0525
    ],
    [
      "cahute",
      0.04
    ],
    [
      "piece",
      0.025
    ],
    [
      "hutte",
      0.025
    ],
    [
      "groupe",
      0.025
    ],
    [
      "cavite",
      0.025
    ],
    [
      "cage",
      0.025
    ],
    [
      "cabanon",
      0.025
    ],
    [
      "bicoque",
      0.025
    ],
    [
      "bauge",
      0.025
    ],
    [
      "appartement",
      0.025
    ],
    [
      "locule",
      0.0125
    ],
    [
      "loggia",
      0.0125
    ],
    [
      "renfoncement",
      0.0125
    ],
    [
      "stalle",
      0.0125
    ],
    [
      "stand",
      0.0125
    ],
    [
      "conciergerie",
      0.0125
    ],
    [
      "comptoir",
      0.0125
    ],
    [
      "casier",
      0.0125
    ],
    [
      "balcon",
      0.0125
    ],
    [
      "baignoire",
      0.0125
    ],
    [
      "atelier",
      0.0125
    ],
    [
      "etablissement",
      0.0125
    ]
  ],
  "loger": [
    [
      "demeurer",
      0.0975
    ],
    [
      "habiter",
      0.0775
    ],
    [
      "mettre",
      0.0625
    ],
    [
      "placer",
      0.0625
    ],
    [
      "resider",
      0.0625
    ],
    [
      "sejourner",
      0.0475
    ],
    [
      "situer",
      0.0425
    ],
    [
      "fourrer",
      0.0425
    ],
    [
      "caser",
      0.035
    ],
    [
      "tenir",
      0.035
    ],
    [
      "coller",
      0.0275
    ],
    [
      "nicher",
      0.0275
    ],
    [
      "etre",
      0.02
    ],
    [
      "s'etablir",
      0.02
    ],
    [
      "ficher",
      0.02
    ],
    [
      "camper",
      0.02
    ],
    [
      "etablir",
      0.0125
    ],
    [
      "vivre",
      0.0125
    ],
    [
      "s'introduire",
      0.0125
    ],
    [
      "rester",
      0.0125
    ],
    [
      "recevoir",
      0.0125
    ],
    [
      "penetrer",
      0.0125
    ],
    [
      "percher",
      0.0125
    ],
    [
      "coucher",
      0.0125
    ],
    [
      "enfoncer",
      0.0125
    ],
    [
      "giter",
      0.0125
    ],
    [
      "heberger",
      0.0125
    ],
    [
      "installer",
      0.0125
    ],
    [
      "occuper",
      0.0125
    ],
    [
      "terrer",
      0.005
    ],
    [
      "poster",
      0.005
    ],
    [
      "enfourner",
      0.005
    ],
    [
      "descendre",
      0.005
    ],
    [
      "crecher",
      0.005
    ],
    [
      "accueillir",
      0.005
    ],
    [
      "abriter",
      0.005
    ]
  ],
  "chiotte": [
    [
      "automobile",
      0.125
    ],
    [
      "cabinet",
      0.125
    ],
    [
      "chiasse",
      0.125
    ],
    [
      "chierie",
      0.125
    ],
    [
      "chignole",
      0.125
    ],
    [
      "emmerde",
      0.125
    ],
    [
      "ennui",
      0.125
    ],
    [
      "voiture",
      0.125
    ]
  ],
  "doucher": [
    [
      "mouiller",
      0.21
    ],
    [
      "tremper",
      0.105
    ],
    [
      "rincer",
      0.105
    ],
    [
      "laver",
      0.105
    ],
    [
      "asperger",
      0.105
    ],
    [
      "arroser",
      0.105
    ],
    [
      "decourager",
      0.0525
    ],
    [
      "gifler",
      0.0525
    ],
    [
      "humilier",
      0.0525
    ],
    [
      "refroidir",
      0.0525
    ],
    [
      "saucer",
      0.0525
    ]
  ],
  "douche": [
    [
      "affusion",
      0.1725
    ],
    [
      "bain",
      0.1725
    ],
    [
      "ablution",
      0.13
    ],
    [
      "arrosage",
      0.085
    ],
    [
      "aspersion",
      0.085
    ],
    [
      "lavage",
      0.085
    ],
    [
      "hydrotherapie",
      0.0425
    ],
    [
      "desappointement",
      0.0425
    ],
    [
      "deconvenue",
      0.0425
    ],
    [
      "deception",
      0.0425
    ],
    [
      "averse",
      0.0425
    ],
    [
      "remede",
      0.0425
    ]
  ],
  "accoster": [
    [
      "aborder",
      0.11
    ],
    [
      "arriver",
      0.11
    ],
    [
      "parvenir",
      0.0825
    ],
    [
      "toucher",
      0.0825
    ],
    [
      "atteindre",
      0.0675
    ],
    [
      "joindre",
      0.0675
    ],
    [
      "approcher",
      0.055
    ],
    [
      "accrocher",
      0.04
    ],
    [
      "acceder",
      0.04
    ],
    [
      "racoler",
      0.04
    ],
    [
      "s'approcher",
      0.0275
    ],
    [
      "rencontrer",
      0.0275
    ],
    [
      "agrafer",
      0.0275
    ],
    [
      "aboutir",
      0.0275
    ],
    [
      "relacher",
      0.0125
    ],
    [
      "rallier",
      0.0125
    ],
    [
      "raccrocher",
      0.0125
    ],
    [
      "entrer",
      0.0125
    ],
    [
      "draguer",
      0.0125
    ],
    [
      "arreter",
      0.0125
    ],
    [
      "afflanquer",
      0.0125
    ],
    [
      "echouer",
      0.0125
    ]
  ],
  "moyen": [
    [
      "truc",
      0.08
    ],
    [
      "methode",
      0.045
    ],
    [
      "procede",
      0.03
    ],
    [
      "ressource",
      0.0275
    ],
    [
      "astuce",
      0.025
    ],
    [
      "maniere",
      0.0225
    ],
    [
      "combinaison",
      0.0225
    ],
    [
      "artifice",
      0.0175
    ],
    [
      "systeme",
      0.0175
    ],
    [
      "voie",
      0.0175
    ],
    [
      "faculte",
      0.0175
    ],
    [
      "art",
      0.0175
    ],
    [
      "mediocre",
      0.015
    ],
    [
      "ruse",
      0.015
    ],
    [
      "tactique",
      0.015
    ],
    [
      "echappatoire",
      0.0125
    ],
    [
      "raisonnable",
      0.0125
    ],
    [
      "manoeuvre",
      0.0125
    ],
    [
      "facon",
      0.0125
    ],
    [
      "expedient",
      0.0125
    ],
    [
      "detour",
      0.0125
    ],
    [
      "disposition",
      0.0125
    ],
    [
      "correct",
      0.0125
    ],
    [
      "convenable",
      0.0125
    ],
    [
      "combine",
      0.0125
    ],
    [
      "subterfuge",
      0.01
    ],
    [
      "possibilite",
      0.01
    ],
    [
      "facilite",
      0.01
    ],
    [
      "don",
      0.01
    ],
    [
      "capacite",
      0.01
    ],
    [
      "bon",
      0.01
    ],
    [
      "secours",
      0.0075
    ],
    [
      "mode",
      0.0075
    ],
    [
      "mesure",
      0.0075
    ],
    [
      "issue",
      0.0075
    ],
    [
      "instrument",
      0.0075
    ],
    [
      "honnete",
      0.0075
    ],
    [
      "commun",
      0.0075
    ],
    [
      "acceptable",
      0.0075
    ],
    [
      "passable",
      0.005
    ],
    [
      "pauvre",
      0.005
    ],
    [
      "plan",
      0.005
    ],
    [
      "pouvoir",
      0.005
    ],
    [
      "quelconque",
      0.005
    ],
    [
      "recette",
      0.005
    ],
    [
      "remede",
      0.005
    ],
    [
      "secret",
      0.005
    ],
    [
      "stratageme",
      0.005
    ],
    [
      "ordinaire",
      0.005
    ],
    [
      "modeste",
      0.005
    ],
    [
      "modalite",
      0.005
    ],
    [
      "agent",
      0.005
    ],
    [
      "calcul",
      0.005
    ],
    [
      "courant",
      0.005
    ],
    [
      "faible",
      0.005
    ],
    [
      "formule",
      0.005
    ],
    [
      "insuffisant",
      0.005
    ],
    [
      "intelligence",
      0.005
    ],
    [
      "intermediaire",
      0.005
    ],
    [
      "marche",
      0.005
    ],
    [
      "mitoyen",
      0.005
    ],
    [
      "palliatif",
      0.005
    ],
    [
      "porte",
      0.005
    ],
    [
      "pretexte",
      0.005
    ],
    [
      "recours",
      0.005
    ],
    [
      "ressort",
      0.005
    ],
    [
      "maigre",
      0.005
    ],
    [
      "machine",
      0.005
    ],
    [
      "force",
      0.005
    ],
    [
      "banal",
      0.005
    ],
    [
      "biais",
      0.005
    ],
    [
      "cause",
      0.005
    ],
    [
      "chemin",
      0.005
    ],
    [
      "convention",
      0.005
    ],
    [
      "entremise",
      0.005
    ],
    [
      "normal",
      0.0025
    ],
    [
      "occasion",
      0.0025
    ],
    [
      "organe",
      0.0025
    ],
    [
      "ouverture",
      0.0025
    ],
    [
      "parade",
      0.0025
    ],
    [
      "potable",
      0.0025
    ],
    [
      "solution",
      0.0025
    ],
    [
      "tremplin",
      0.0025
    ],
    [
      "modere",
      0.0025
    ],
    [
      "modique",
      0.0025
    ],
    [
      "marchepied",
      0.0025
    ],
    [
      "canal",
      0.0025
    ],
    [
      "chance",
      0.0025
    ],
    [
      "engin",
      0.0025
    ],
    [
      "excuse",
      0.0025
    ],
    [
      "filon",
      0.0025
    ],
    [
      "honorable",
      0.0025
    ],
    [
      "joint",
      0.0025
    ],
    [
      "juste",
      0.0025
    ],
    [
      "liberte",
      0.0025
    ],
    [
      "outil",
      0.0
    ],
    [
      "piege",
      0.0
    ],
    [
      "procedure",
      0.0
    ],
    [
      "revenu",
      0.0
    ],
    [
      "temperament",
      0.0
    ],
    [
      "terne",
      0.0
    ],
    [
      "tolerable",
      0.0
    ],
    [
      "tournant",
      0.0
    ],
    [
      "truchement",
      0.0
    ],
    [
      "truquage",
      0.0
    ],
    [
      "operation",
      0.0
    ],
    [
      "mur",
      0.0
    ],
    [
      "memoire",
      0.0
    ],
    [
      "arme",
      0.0
    ],
    [
      "bourgeois",
      0.0
    ],
    [
      "bequille",
      0.0
    ],
    [
      "jour",
      0.0
    ],
    [
      "lambda",
      0.0
    ],
    [
      "levier",
      0.0
    ],
    [
      "materiau",
      0.0
    ],
    [
      "meche",
      0.0
    ],
    [
      "median",
      0.0
    ],
    [
      "viatique",
      0.0
    ]
  ],
  "gauche": [
    [
      "maladroit",
      0.0975
    ],
    [
      "balourd",
      0.07
    ],
    [
      "empote",
      0.07
    ],
    [
      "bete",
      0.065
    ],
    [
      "beta",
      0.0575
    ],
    [
      "lourd",
      0.0525
    ],
    [
      "emprunte",
      0.045
    ],
    [
      "godiche",
      0.045
    ],
    [
      "ballot",
      0.0375
    ],
    [
      "gourde",
      0.0375
    ],
    [
      "gourd",
      0.0325
    ],
    [
      "embarrasse",
      0.0325
    ],
    [
      "empaille",
      0.025
    ],
    [
      "lourdaud",
      0.025
    ],
    [
      "malhabile",
      0.025
    ],
    [
      "nigaud",
      0.025
    ],
    [
      "gene",
      0.0175
    ],
    [
      "devie",
      0.0175
    ],
    [
      "dadais",
      0.0175
    ],
    [
      "tordu",
      0.0125
    ],
    [
      "inhabile",
      0.0125
    ],
    [
      "godichon",
      0.0125
    ],
    [
      "gauchi",
      0.0125
    ],
    [
      "dejete",
      0.0125
    ],
    [
      "manchot",
      0.005
    ],
    [
      "oblique",
      0.005
    ],
    [
      "pataud",
      0.005
    ],
    [
      "piteux",
      0.005
    ],
    [
      "provincial",
      0.005
    ],
    [
      "senestre",
      0.005
    ],
    [
      "timide",
      0.005
    ],
    [
      "inexperimente",
      0.005
    ],
    [
      "flandrin",
      0.005
    ],
    [
      "empetre",
      0.005
    ],
    [
      "empeche",
      0.005
    ],
    [
      "emmanche",
      0.005
    ],
    [
      "disgracieux",
      0.005
    ],
    [
      "contraint",
      0.005
    ],
    [
      "cintre",
      0.005
    ],
    [
      "babord",
      0.005
    ],
    [
      "voile",
      0.005
    ]
  ],
  "mioche": [
    [
      "enfant",
      0.1825
    ],
    [
      "gamin",
      0.1825
    ],
    [
      "bebe",
      0.105
    ],
    [
      "petit",
      0.0775
    ],
    [
      "moutard",
      0.0775
    ],
    [
      "marmot",
      0.0775
    ],
    [
      "gosse",
      0.0775
    ],
    [
      "marmouset",
      0.05
    ],
    [
      "petiot",
      0.05
    ],
    [
      "lardon",
      0.025
    ],
    [
      "mouflet",
      0.025
    ],
    [
      "mome",
      0.025
    ],
    [
      "poupon",
      0.025
    ]
  ],
  "cinoche": [
    [
      "cine",
      0.5
    ],
    [
      "cinema",
      0.5
    ]
  ],
  "lingala": [],
  "hip": [
    [
      "hourra",
      1.0
    ]
  ],
  "hop": [],
  "breakdance": [],
  "top": [
    [
      "impulsion",
      0.5
    ],
    [
      "signal",
      0.5
    ]
  ],
  "litre": [
    [
      "bouteille",
      0.25
    ],
    [
      "kil",
      0.25
    ],
    [
      "litron",
      0.25
    ],
    [
      "vin",
      0.25
    ]
  ],
  "filature": [
    [
      "filage",
      0.2
    ],
    [
      "pistage",
      0.2
    ],
    [
      "surveillance",
      0.2
    ],
    [
      "textile",
      0.2
    ],
    [
      "usine",
      0.2
    ]
  ],
  "trinquer": [
    [
      "recevoir",
      0.3325
    ],
    [
      "boire",
      0.165
    ],
    [
      "subir",
      0.165
    ],
    [
      "ecoper",
      0.165
    ]
  ],
  "visser": [
    [
      "assembler",
      0.135
    ],
    [
      "attacher",
      0.135
    ],
    [
      "arrimer",
      0.1075
    ],
    [
      "fixer",
      0.1075
    ],
    [
      "river",
      0.1075
    ],
    [
      "joindre",
      0.08
    ],
    [
      "souquer",
      0.0525
    ],
    [
      "serrer",
      0.0525
    ],
    [
      "sceller",
      0.0525
    ],
    [
      "boulonner",
      0.0525
    ],
    [
      "assujettir",
      0.0525
    ],
    [
      "immobiliser",
      0.025
    ]
  ],
  "franchement": [
    [
      "nettement",
      0.085
    ],
    [
      "carrement",
      0.075
    ],
    [
      "simplement",
      0.075
    ],
    [
      "ouvertement",
      0.055
    ],
    [
      "vraiment",
      0.055
    ],
    [
      "hautement",
      0.045
    ],
    [
      "net",
      0.045
    ],
    [
      "sincerement",
      0.045
    ],
    [
      "franc",
      0.035
    ],
    [
      "clairement",
      0.035
    ],
    [
      "certainement",
      0.035
    ],
    [
      "formellement",
      0.0275
    ],
    [
      "directement",
      0.0275
    ],
    [
      "categoriquement",
      0.0275
    ],
    [
      "resolument",
      0.0175
    ],
    [
      "rondement",
      0.0175
    ],
    [
      "naturellement",
      0.0175
    ],
    [
      "loyalement",
      0.0175
    ],
    [
      "haut",
      0.0175
    ],
    [
      "hardiment",
      0.0175
    ],
    [
      "clair",
      0.0175
    ],
    [
      "bonnement",
      0.0175
    ],
    [
      "veritablement",
      0.0075
    ],
    [
      "uniment",
      0.0075
    ],
    [
      "totalement",
      0.0075
    ],
    [
      "nument",
      0.0075
    ],
    [
      "indiscutablement",
      0.0075
    ],
    [
      "franco",
      0.0075
    ],
    [
      "expressement",
      0.0075
    ],
    [
      "brutalement",
      0.0075
    ],
    [
      "evidemment",
      0.0075
    ]
  ],
  "mou": [
    [
      "faible",
      0.0625
    ],
    [
      "apathique",
      0.0525
    ],
    [
      "indolent",
      0.0475
    ],
    [
      "paresseux",
      0.0375
    ],
    [
      "malleable",
      0.035
    ],
    [
      "lent",
      0.035
    ],
    [
      "doux",
      0.035
    ],
    [
      "flasque",
      0.0325
    ],
    [
      "nonchalant",
      0.0325
    ],
    [
      "amorphe",
      0.0225
    ],
    [
      "lache",
      0.0225
    ],
    [
      "languissant",
      0.02
    ],
    [
      "inerte",
      0.02
    ],
    [
      "facile",
      0.02
    ],
    [
      "cotonneux",
      0.0175
    ],
    [
      "mollasse",
      0.0175
    ],
    [
      "souple",
      0.0175
    ],
    [
      "veule",
      0.0175
    ],
    [
      "elastique",
      0.0175
    ],
    [
      "vague",
      0.0125
    ],
    [
      "relache",
      0.0125
    ],
    [
      "maniable",
      0.0125
    ],
    [
      "lymphatique",
      0.0125
    ],
    [
      "endormi",
      0.0125
    ],
    [
      "cagnard",
      0.0125
    ],
    [
      "aboulique",
      0.0125
    ],
    [
      "moelleux",
      0.01
    ],
    [
      "inconsistant",
      0.01
    ],
    [
      "flexible",
      0.01
    ],
    [
      "engourdi",
      0.01
    ],
    [
      "douillet",
      0.01
    ],
    [
      "atone",
      0.01
    ],
    [
      "tiede",
      0.01
    ],
    [
      "ramolli",
      0.01
    ],
    [
      "indecis",
      0.01
    ],
    [
      "gnangnan",
      0.01
    ],
    [
      "avachi",
      0.01
    ],
    [
      "voluptueux",
      0.005
    ],
    [
      "velleitaire",
      0.005
    ],
    [
      "tendre",
      0.005
    ],
    [
      "sourd",
      0.005
    ],
    [
      "pateux",
      0.005
    ],
    [
      "pliant",
      0.005
    ],
    [
      "moule",
      0.005
    ],
    [
      "mollasson",
      0.005
    ],
    [
      "lambin",
      0.005
    ],
    [
      "flou",
      0.005
    ],
    [
      "effemine",
      0.005
    ],
    [
      "aneanti",
      0.005
    ],
    [
      "lavette",
      0.0025
    ],
    [
      "modere",
      0.0025
    ],
    [
      "plastique",
      0.0025
    ],
    [
      "rossard",
      0.0025
    ],
    [
      "somnolent",
      0.0025
    ],
    [
      "influencable",
      0.0025
    ],
    [
      "flemmard",
      0.0025
    ],
    [
      "flegmatique",
      0.0025
    ],
    [
      "chiffe",
      0.0025
    ],
    [
      "chaud",
      0.0025
    ],
    [
      "affaibli",
      0.0025
    ],
    [
      "abattu",
      0.0025
    ],
    [
      "soliveau",
      0.0
    ],
    [
      "poumon",
      0.0
    ],
    [
      "panade",
      0.0
    ],
    [
      "nouille",
      0.0
    ],
    [
      "mollet",
      0.0
    ],
    [
      "spongieux",
      0.0
    ],
    [
      "sybarite",
      0.0
    ],
    [
      "toton",
      0.0
    ],
    [
      "toupie",
      0.0
    ],
    [
      "vaporeux",
      0.0
    ],
    [
      "visqueux",
      0.0
    ],
    [
      "vegetatif",
      0.0
    ],
    [
      "mol",
      0.0
    ],
    [
      "loche",
      0.0
    ],
    [
      "flandrin",
      0.0
    ],
    [
      "amollissant",
      0.0
    ],
    [
      "aveuli",
      0.0
    ],
    [
      "bonasse",
      0.0
    ],
    [
      "boursoufle",
      0.0
    ],
    [
      "doucement",
      0.0
    ],
    [
      "ductile",
      0.0
    ],
    [
      "desosse",
      0.0
    ],
    [
      "detendu",
      0.0
    ],
    [
      "emplatre",
      0.0
    ],
    [
      "fangeux",
      0.0
    ],
    [
      "femmelette",
      0.0
    ],
    [
      "amolli",
      0.0
    ]
  ],
  "invincible": [
    [
      "indomptable",
      0.0775
    ],
    [
      "irresistible",
      0.0775
    ],
    [
      "inattaquable",
      0.0625
    ],
    [
      "invulnerable",
      0.0625
    ],
    [
      "insurmontable",
      0.05
    ],
    [
      "irrefutable",
      0.0375
    ],
    [
      "irrefragable",
      0.0375
    ],
    [
      "infatigable",
      0.0375
    ],
    [
      "inexpugnable",
      0.0375
    ],
    [
      "indestructible",
      0.0375
    ],
    [
      "imprenable",
      0.0375
    ],
    [
      "imbattable",
      0.0375
    ],
    [
      "fort",
      0.0375
    ],
    [
      "infranchissable",
      0.025
    ],
    [
      "indiscutable",
      0.025
    ],
    [
      "increvable",
      0.025
    ],
    [
      "incontrolable",
      0.025
    ],
    [
      "incontestable",
      0.025
    ],
    [
      "inaccessible",
      0.025
    ],
    [
      "imperissable",
      0.025
    ],
    [
      "imperieux",
      0.025
    ],
    [
      "immortel",
      0.025
    ],
    [
      "formel",
      0.025
    ],
    [
      "irrecusable",
      0.0125
    ],
    [
      "irraisonne",
      0.0125
    ],
    [
      "inflexible",
      0.0125
    ],
    [
      "inextirpable",
      0.0125
    ],
    [
      "inextinguible",
      0.0125
    ],
    [
      "foudroyant",
      0.0125
    ],
    [
      "brave",
      0.0125
    ],
    [
      "irreductible",
      0.0125
    ]
  ],
  "statue": [
    [
      "figure",
      0.1725
    ],
    [
      "image",
      0.1725
    ],
    [
      "sculpture",
      0.13
    ],
    [
      "figurine",
      0.085
    ],
    [
      "idole",
      0.085
    ],
    [
      "simulacre",
      0.085
    ],
    [
      "monument",
      0.0425
    ],
    [
      "marbre",
      0.0425
    ],
    [
      "mannequin",
      0.0425
    ],
    [
      "bronze",
      0.0425
    ],
    [
      "allegorie",
      0.0425
    ]
  ],
  "statuer": [
    [
      "trancher",
      0.21
    ],
    [
      "decider",
      0.1825
    ],
    [
      "regler",
      0.13
    ],
    [
      "arreter",
      0.105
    ],
    [
      "prononcer",
      0.0775
    ],
    [
      "juger",
      0.0775
    ],
    [
      "fixer",
      0.05
    ],
    [
      "ordonner",
      0.05
    ],
    [
      "resoudre",
      0.05
    ],
    [
      "etablir",
      0.025
    ]
  ],
  "voisiner": [
    [
      "avoisiner",
      0.22
    ],
    [
      "frayer",
      0.11
    ],
    [
      "frequenter",
      0.11
    ],
    [
      "jouxter",
      0.11
    ],
    [
      "toucher",
      0.11
    ],
    [
      "voir",
      0.11
    ]
  ],
  "entendu": [
    [
      "voir",
      0.105
    ],
    [
      "connaitre",
      0.1
    ],
    [
      "comprendre",
      0.0825
    ],
    [
      "percevoir",
      0.0775
    ],
    [
      "penetrer",
      0.0675
    ],
    [
      "saisir",
      0.0675
    ],
    [
      "concevoir",
      0.0575
    ],
    [
      "discerner",
      0.0475
    ],
    [
      "sentir",
      0.04
    ],
    [
      "apprehender",
      0.04
    ],
    [
      "apprecier",
      0.04
    ],
    [
      "juger",
      0.025
    ],
    [
      "distinguer",
      0.02
    ],
    [
      "ecouter",
      0.015
    ],
    [
      "realiser",
      0.015
    ],
    [
      "reconnaitre",
      0.015
    ],
    [
      "pratiquer",
      0.015
    ],
    [
      "admettre",
      0.015
    ],
    [
      "posseder",
      0.01
    ],
    [
      "embrasser",
      0.01
    ],
    [
      "compter",
      0.01
    ],
    [
      "exiger",
      0.0025
    ],
    [
      "gouter",
      0.0025
    ],
    [
      "interpreter",
      0.0025
    ],
    [
      "ouir",
      0.0025
    ],
    [
      "preferer",
      0.0025
    ],
    [
      "pretendre",
      0.0025
    ],
    [
      "satisfaire",
      0.0025
    ],
    [
      "souhaiter",
      0.0025
    ],
    [
      "exaucer",
      0.0025
    ],
    [
      "desirer",
      0.0025
    ],
    [
      "assister",
      0.0025
    ],
    [
      "attraper",
      0.0025
    ],
    [
      "auditionner",
      0.0025
    ],
    [
      "confesser",
      0.0025
    ],
    [
      "consentir",
      0.0025
    ],
    [
      "cultiver",
      0.0025
    ],
    [
      "vouloir",
      0.0025
    ]
  ],
  "peinture": [
    [
      "tableau",
      0.095
    ],
    [
      "image",
      0.08
    ],
    [
      "paysage",
      0.05
    ],
    [
      "barbouillage",
      0.035
    ],
    [
      "esquisse",
      0.035
    ],
    [
      "portrait",
      0.035
    ],
    [
      "enduit",
      0.0275
    ],
    [
      "vue",
      0.02
    ],
    [
      "vernis",
      0.02
    ],
    [
      "scene",
      0.02
    ],
    [
      "pochade",
      0.02
    ],
    [
      "histoire",
      0.02
    ],
    [
      "gouache",
      0.02
    ],
    [
      "fard",
      0.02
    ],
    [
      "description",
      0.02
    ],
    [
      "croute",
      0.02
    ],
    [
      "crayon",
      0.02
    ],
    [
      "couleur",
      0.02
    ],
    [
      "miniature",
      0.0125
    ],
    [
      "nu",
      0.0125
    ],
    [
      "representation",
      0.0125
    ],
    [
      "revetement",
      0.0125
    ],
    [
      "ebauche",
      0.0125
    ],
    [
      "etude",
      0.0125
    ],
    [
      "maquette",
      0.0125
    ],
    [
      "enluminure",
      0.0125
    ],
    [
      "decoration",
      0.0125
    ],
    [
      "allegorie",
      0.0125
    ],
    [
      "aquarelle",
      0.0125
    ],
    [
      "badigeon",
      0.0125
    ],
    [
      "badigeonnage",
      0.0125
    ],
    [
      "caricature",
      0.0125
    ],
    [
      "decor",
      0.0125
    ],
    [
      "panorama",
      0.005
    ],
    [
      "pastel",
      0.005
    ],
    [
      "polyptyque",
      0.005
    ],
    [
      "ravalement",
      0.005
    ],
    [
      "recouvrement",
      0.005
    ],
    [
      "retable",
      0.005
    ],
    [
      "sepia",
      0.005
    ],
    [
      "toile",
      0.005
    ],
    [
      "maternite",
      0.005
    ],
    [
      "marine",
      0.005
    ],
    [
      "lavis",
      0.005
    ],
    [
      "academie",
      0.005
    ],
    [
      "bambochade",
      0.005
    ],
    [
      "barbouille",
      0.005
    ],
    [
      "bergerie",
      0.005
    ],
    [
      "diptyque",
      0.005
    ],
    [
      "detrempe",
      0.005
    ],
    [
      "estampe",
      0.005
    ],
    [
      "fresque",
      0.005
    ],
    [
      "gribouillage",
      0.005
    ],
    [
      "icone",
      0.005
    ],
    [
      "laque",
      0.005
    ],
    [
      "verdure",
      0.005
    ]
  ],
  "attendant": [
    [
      "esperer",
      0.0525
    ],
    [
      "prevoir",
      0.0525
    ],
    [
      "moisir",
      0.04
    ],
    [
      "temporiser",
      0.03
    ],
    [
      "rester",
      0.03
    ],
    [
      "remettre",
      0.03
    ],
    [
      "presumer",
      0.03
    ],
    [
      "pressentir",
      0.03
    ],
    [
      "poireauter",
      0.03
    ],
    [
      "guetter",
      0.03
    ],
    [
      "atermoyer",
      0.03
    ],
    [
      "patienter",
      0.02
    ],
    [
      "poser",
      0.02
    ],
    [
      "presager",
      0.02
    ],
    [
      "retarder",
      0.02
    ],
    [
      "souhaiter",
      0.02
    ],
    [
      "surseoir",
      0.02
    ],
    [
      "vouloir",
      0.02
    ],
    [
      "mettre",
      0.02
    ],
    [
      "menacer",
      0.02
    ],
    [
      "imaginer",
      0.02
    ],
    [
      "compter",
      0.02
    ],
    [
      "craindre",
      0.02
    ],
    [
      "croire",
      0.02
    ],
    [
      "demeurer",
      0.02
    ],
    [
      "differer",
      0.02
    ],
    [
      "desirer",
      0.02
    ],
    [
      "escompter",
      0.02
    ],
    [
      "hesiter",
      0.02
    ],
    [
      "reserver",
      0.01
    ],
    [
      "sejourner",
      0.01
    ],
    [
      "reporter",
      0.01
    ],
    [
      "redouter",
      0.01
    ],
    [
      "languir",
      0.01
    ],
    [
      "exiger",
      0.01
    ],
    [
      "durer",
      0.01
    ],
    [
      "droguer",
      0.01
    ]
  ],
  "lunette": [
    [
      "fenetre",
      0.1825
    ],
    [
      "telescope",
      0.09
    ],
    [
      "siege",
      0.09
    ],
    [
      "ouverture",
      0.09
    ],
    [
      "microscope",
      0.09
    ],
    [
      "lorgnette",
      0.09
    ],
    [
      "jumelle",
      0.09
    ],
    [
      "guillotine",
      0.09
    ],
    [
      "vitre",
      0.09
    ]
  ],
  "vaccin": [
    [
      "inoculation",
      0.3325
    ],
    [
      "immunisation",
      0.165
    ],
    [
      "piqure",
      0.165
    ],
    [
      "serum",
      0.165
    ],
    [
      "vaccination",
      0.165
    ]
  ],
  "batiment": [
    [
      "immeuble",
      0.0975
    ],
    [
      "habitation",
      0.0825
    ],
    [
      "construction",
      0.07
    ],
    [
      "maison",
      0.07
    ],
    [
      "building",
      0.055
    ],
    [
      "bateau",
      0.055
    ],
    [
      "abri",
      0.055
    ],
    [
      "hangar",
      0.04
    ],
    [
      "oeuvre",
      0.04
    ],
    [
      "tour",
      0.04
    ],
    [
      "edifice",
      0.04
    ],
    [
      "navire",
      0.0275
    ],
    [
      "maconnerie",
      0.0275
    ],
    [
      "local",
      0.0275
    ],
    [
      "habitat",
      0.0275
    ],
    [
      "batisse",
      0.0275
    ],
    [
      "unite",
      0.0125
    ],
    [
      "transatlantique",
      0.0125
    ],
    [
      "paquebot",
      0.0125
    ],
    [
      "monument",
      0.0125
    ],
    [
      "hotel",
      0.0125
    ],
    [
      "fabrique",
      0.0125
    ],
    [
      "embarcation",
      0.0125
    ],
    [
      "dependance",
      0.0125
    ],
    [
      "cuirasse",
      0.0125
    ],
    [
      "creation",
      0.0125
    ],
    [
      "architecture",
      0.0125
    ],
    [
      "H.L.M.",
      0.0125
    ],
    [
      "vaisseau",
      0.0125
    ]
  ],
  "fabriquer": [
    [
      "faire",
      0.13
    ],
    [
      "construire",
      0.075
    ],
    [
      "former",
      0.06
    ],
    [
      "faconner",
      0.0575
    ],
    [
      "elaborer",
      0.0575
    ],
    [
      "creer",
      0.0475
    ],
    [
      "preparer",
      0.0475
    ],
    [
      "produire",
      0.0375
    ],
    [
      "combiner",
      0.0375
    ],
    [
      "arranger",
      0.0325
    ],
    [
      "travailler",
      0.0325
    ],
    [
      "batir",
      0.0275
    ],
    [
      "monter",
      0.0275
    ],
    [
      "imaginer",
      0.0225
    ],
    [
      "ficher",
      0.0225
    ],
    [
      "agencer",
      0.0225
    ],
    [
      "confectionner",
      0.0175
    ],
    [
      "forger",
      0.0175
    ],
    [
      "inventer",
      0.0175
    ],
    [
      "tisser",
      0.0175
    ],
    [
      "ouvrer",
      0.0125
    ],
    [
      "foutre",
      0.0125
    ],
    [
      "executer",
      0.0125
    ],
    [
      "susciter",
      0.0075
    ],
    [
      "realiser",
      0.0075
    ],
    [
      "medire",
      0.0075
    ],
    [
      "maquiller",
      0.0075
    ],
    [
      "fricoter",
      0.0075
    ],
    [
      "modeler",
      0.0025
    ],
    [
      "oeuvrer",
      0.0025
    ],
    [
      "ouvrager",
      0.0025
    ],
    [
      "sortir",
      0.0025
    ],
    [
      "torcher",
      0.0025
    ],
    [
      "torchonner",
      0.0025
    ],
    [
      "traficoter",
      0.0025
    ],
    [
      "manufacturer",
      0.0025
    ],
    [
      "fomenter",
      0.0025
    ],
    [
      "farfouiller",
      0.0025
    ],
    [
      "falsifier",
      0.0025
    ],
    [
      "fabricoter",
      0.0025
    ],
    [
      "calomnier",
      0.0025
    ],
    [
      "bacler",
      0.0025
    ],
    [
      "bricoler",
      0.0025
    ],
    [
      "branler",
      0.0025
    ],
    [
      "boutiquer",
      0.0025
    ],
    [
      "usiner",
      0.0025
    ]
  ],
  "treillis": [
    [
      "treillage",
      0.1875
    ],
    [
      "claie",
      0.125
    ],
    [
      "cloture",
      0.125
    ],
    [
      "graticule",
      0.0625
    ],
    [
      "fermeture",
      0.0625
    ],
    [
      "dessin",
      0.0625
    ],
    [
      "caillebotis",
      0.0625
    ],
    [
      "bourgeron",
      0.0625
    ],
    [
      "armature",
      0.0625
    ],
    [
      "jalousie",
      0.0625
    ]
  ],
  "clash": [
    [
      "dispute",
      0.3325
    ],
    [
      "desaccord",
      0.3325
    ],
    [
      "conflit",
      0.165
    ],
    [
      "rupture",
      0.165
    ]
  ],
  "deviner": [
    [
      "decouvrir",
      0.115
    ],
    [
      "reperer",
      0.065
    ],
    [
      "penetrer",
      0.0575
    ],
    [
      "apercevoir",
      0.0525
    ],
    [
      "pressentir",
      0.05
    ],
    [
      "trouver",
      0.045
    ],
    [
      "comprendre",
      0.045
    ],
    [
      "sentir",
      0.0425
    ],
    [
      "saisir",
      0.0375
    ],
    [
      "flairer",
      0.0325
    ],
    [
      "dechiffrer",
      0.0325
    ],
    [
      "discerner",
      0.0325
    ],
    [
      "percevoir",
      0.03
    ],
    [
      "deceler",
      0.025
    ],
    [
      "subodorer",
      0.0225
    ],
    [
      "entrevoir",
      0.0225
    ],
    [
      "conjecturer",
      0.0225
    ],
    [
      "imaginer",
      0.0175
    ],
    [
      "juger",
      0.0175
    ],
    [
      "prevoir",
      0.0175
    ],
    [
      "soupconner",
      0.0175
    ],
    [
      "eventer",
      0.0125
    ],
    [
      "reconnaitre",
      0.0125
    ],
    [
      "detecter",
      0.0125
    ],
    [
      "demeler",
      0.01
    ],
    [
      "devoiler",
      0.01
    ],
    [
      "interpreter",
      0.01
    ],
    [
      "lire",
      0.01
    ],
    [
      "resoudre",
      0.01
    ],
    [
      "predire",
      0.005
    ],
    [
      "entrapercevoir",
      0.005
    ],
    [
      "depister",
      0.005
    ],
    [
      "demasquer",
      0.005
    ],
    [
      "augurer",
      0.005
    ],
    [
      "traduire",
      0.0025
    ],
    [
      "renifler",
      0.0025
    ],
    [
      "rencontrer",
      0.0025
    ],
    [
      "prophetiser",
      0.0025
    ]
  ],
  "halluciner": [
    [
      "effrayer",
      0.25
    ],
    [
      "fantasmer",
      0.25
    ],
    [
      "hanter",
      0.25
    ],
    [
      "terroriser",
      0.25
    ]
  ],
  "mongolien": [
    [
      "mongoloide",
      0.5
    ],
    [
      "trisomique",
      0.5
    ]
  ],
  "creer": [
    [
      "construire",
      0.065
    ],
    [
      "former",
      0.065
    ],
    [
      "produire",
      0.0575
    ],
    [
      "composer",
      0.05
    ],
    [
      "constituer",
      0.0425
    ],
    [
      "etablir",
      0.0425
    ],
    [
      "faire",
      0.04
    ],
    [
      "fonder",
      0.035
    ],
    [
      "batir",
      0.035
    ],
    [
      "fabriquer",
      0.0275
    ],
    [
      "determiner",
      0.025
    ],
    [
      "engendrer",
      0.025
    ],
    [
      "elaborer",
      0.0225
    ],
    [
      "susciter",
      0.0225
    ],
    [
      "organiser",
      0.0225
    ],
    [
      "monter",
      0.0225
    ],
    [
      "inventer",
      0.0225
    ],
    [
      "concevoir",
      0.02
    ],
    [
      "imaginer",
      0.02
    ],
    [
      "elever",
      0.02
    ],
    [
      "edifier",
      0.015
    ],
    [
      "provoquer",
      0.015
    ],
    [
      "soulever",
      0.0125
    ],
    [
      "occasionner",
      0.0125
    ],
    [
      "lancer",
      0.0125
    ],
    [
      "entrainer",
      0.0125
    ],
    [
      "causer",
      0.0125
    ],
    [
      "accoucher",
      0.0125
    ],
    [
      "porter",
      0.01
    ],
    [
      "instituer",
      0.01
    ],
    [
      "commencer",
      0.01
    ],
    [
      "ecrire",
      0.0075
    ],
    [
      "realiser",
      0.0075
    ],
    [
      "procreer",
      0.0075
    ],
    [
      "enfanter",
      0.0075
    ],
    [
      "decouvrir",
      0.0075
    ],
    [
      "declencher",
      0.0075
    ],
    [
      "apporter",
      0.0075
    ],
    [
      "amener",
      0.0075
    ],
    [
      "eriger",
      0.005
    ],
    [
      "elucubrer",
      0.005
    ],
    [
      "trouver",
      0.005
    ],
    [
      "ouvrir",
      0.005
    ],
    [
      "jouer",
      0.005
    ],
    [
      "innover",
      0.005
    ],
    [
      "animer",
      0.005
    ],
    [
      "necessiter",
      0.0
    ],
    [
      "interpreter",
      0.0
    ],
    [
      "instaurer",
      0.0
    ],
    [
      "amenager",
      0.0
    ],
    [
      "vivifier",
      0.0
    ]
  ],
  "tentant": [
    [
      "seduisant",
      0.25
    ],
    [
      "affriolant",
      0.15
    ],
    [
      "allechant",
      0.1
    ],
    [
      "appetissant",
      0.1
    ],
    [
      "desirable",
      0.1
    ],
    [
      "invitant",
      0.05
    ],
    [
      "friand",
      0.05
    ],
    [
      "excitant",
      0.05
    ],
    [
      "enviable",
      0.05
    ],
    [
      "comestible",
      0.05
    ],
    [
      "ragoutant",
      0.05
    ]
  ],
  "tenter": [
    [
      "seduire",
      0.1075
    ],
    [
      "attirer",
      0.1
    ],
    [
      "charmer",
      0.0825
    ],
    [
      "essayer",
      0.055
    ],
    [
      "captiver",
      0.05
    ],
    [
      "exciter",
      0.0375
    ],
    [
      "risquer",
      0.0375
    ],
    [
      "entrainer",
      0.03
    ],
    [
      "chercher",
      0.03
    ],
    [
      "inviter",
      0.025
    ],
    [
      "plaire",
      0.025
    ],
    [
      "solliciter",
      0.0175
    ],
    [
      "oser",
      0.0175
    ],
    [
      "gagner",
      0.0175
    ],
    [
      "fasciner",
      0.0175
    ],
    [
      "experimenter",
      0.0175
    ],
    [
      "envouter",
      0.0175
    ],
    [
      "entreprendre",
      0.0175
    ],
    [
      "amorcer",
      0.0175
    ],
    [
      "allecher",
      0.0175
    ],
    [
      "aguicher",
      0.0175
    ],
    [
      "affrioler",
      0.0175
    ],
    [
      "s'aviser",
      0.01
    ],
    [
      "s'efforcer",
      0.01
    ],
    [
      "s'evertuer",
      0.01
    ],
    [
      "eprouver",
      0.01
    ],
    [
      "pousser",
      0.01
    ],
    [
      "hypnotiser",
      0.01
    ],
    [
      "hasarder",
      0.01
    ],
    [
      "dire",
      0.01
    ],
    [
      "couvrir",
      0.01
    ],
    [
      "coiffer",
      0.01
    ],
    [
      "gouter",
      0.005
    ],
    [
      "magnetiser",
      0.005
    ],
    [
      "s'ingenier",
      0.005
    ],
    [
      "ensorceler",
      0.005
    ],
    [
      "courir",
      0.005
    ],
    [
      "bacher",
      0.005
    ],
    [
      "aventurer",
      0.005
    ],
    [
      "attraire",
      0.005
    ],
    [
      "attacher",
      0.005
    ],
    [
      "appater",
      0.005
    ],
    [
      "tacher",
      0.005
    ]
  ],
  "obese": [
    [
      "gros",
      0.2225
    ],
    [
      "rebondi",
      0.11
    ],
    [
      "pansu",
      0.0975
    ],
    [
      "replet",
      0.0675
    ],
    [
      "ventru",
      0.0675
    ],
    [
      "adipeux",
      0.055
    ],
    [
      "empate",
      0.055
    ],
    [
      "gras",
      0.055
    ],
    [
      "ventripotent",
      0.04
    ],
    [
      "renfle",
      0.04
    ],
    [
      "bouffi",
      0.04
    ],
    [
      "bedonnant",
      0.0275
    ],
    [
      "corpulent",
      0.0275
    ],
    [
      "boulot",
      0.0125
    ],
    [
      "massif",
      0.0125
    ],
    [
      "mastodonte",
      0.0125
    ],
    [
      "paquet",
      0.0125
    ],
    [
      "poussah",
      0.0125
    ],
    [
      "tonneau",
      0.0125
    ]
  ],
  "moqueur": [
    [
      "railleur",
      0.1675
    ],
    [
      "blagueur",
      0.0825
    ],
    [
      "narquois",
      0.07
    ],
    [
      "farceur",
      0.0575
    ],
    [
      "ironique",
      0.0575
    ],
    [
      "taquin",
      0.045
    ],
    [
      "sarcastique",
      0.045
    ],
    [
      "plaisant",
      0.045
    ],
    [
      "goguenard",
      0.045
    ],
    [
      "facetieux",
      0.0375
    ],
    [
      "gouailleur",
      0.03
    ],
    [
      "sardonique",
      0.025
    ],
    [
      "plaisantin",
      0.025
    ],
    [
      "persifleur",
      0.025
    ],
    [
      "malicieux",
      0.025
    ],
    [
      "humoriste",
      0.025
    ],
    [
      "caustique",
      0.025
    ],
    [
      "chineur",
      0.0175
    ],
    [
      "piquant",
      0.0175
    ],
    [
      "satirique",
      0.0125
    ],
    [
      "hableur",
      0.0125
    ],
    [
      "frondeur",
      0.0125
    ],
    [
      "derisoire",
      0.0125
    ],
    [
      "dedaigneux",
      0.0125
    ],
    [
      "rencheri",
      0.005
    ],
    [
      "mordant",
      0.005
    ],
    [
      "ironiste",
      0.005
    ],
    [
      "gausseur",
      0.005
    ],
    [
      "daubeur",
      0.005
    ],
    [
      "comedien",
      0.005
    ],
    [
      "brocardeur",
      0.005
    ],
    [
      "ricaneur",
      0.005
    ]
  ],
  "majeur": [
    [
      "important",
      0.1275
    ],
    [
      "primordial",
      0.1275
    ],
    [
      "principal",
      0.1275
    ],
    [
      "essentiel",
      0.105
    ],
    [
      "grand",
      0.105
    ],
    [
      "premier",
      0.085
    ],
    [
      "substantiel",
      0.04
    ],
    [
      "predominant",
      0.04
    ],
    [
      "considerable",
      0.04
    ],
    [
      "capital",
      0.04
    ],
    [
      "adulte",
      0.02
    ],
    [
      "exceptionnel",
      0.02
    ],
    [
      "maitre",
      0.02
    ],
    [
      "medius",
      0.02
    ],
    [
      "profond",
      0.02
    ],
    [
      "preeminent",
      0.02
    ],
    [
      "age",
      0.02
    ]
  ],
  "absolument": [
    [
      "totalement",
      0.0925
    ],
    [
      "entierement",
      0.085
    ],
    [
      "completement",
      0.0775
    ],
    [
      "bien",
      0.07
    ],
    [
      "parfaitement",
      0.065
    ],
    [
      "certainement",
      0.05
    ],
    [
      "exactement",
      0.0425
    ],
    [
      "assurement",
      0.035
    ],
    [
      "vraiment",
      0.0275
    ],
    [
      "radicalement",
      0.0275
    ],
    [
      "pleinement",
      0.0275
    ],
    [
      "oui",
      0.0275
    ],
    [
      "formellement",
      0.0275
    ],
    [
      "diametralement",
      0.02
    ],
    [
      "necessairement",
      0.02
    ],
    [
      "strictement",
      0.02
    ],
    [
      "tout",
      0.02
    ],
    [
      "tres",
      0.02
    ],
    [
      "rigoureusement",
      0.0125
    ],
    [
      "foncierement",
      0.0125
    ],
    [
      "indispensablement",
      0.005
    ],
    [
      "intransitivement",
      0.005
    ],
    [
      "malgre",
      0.005
    ],
    [
      "royalement",
      0.005
    ],
    [
      "unanimement",
      0.005
    ],
    [
      "veritablement",
      0.005
    ],
    [
      "imperieusement",
      0.005
    ],
    [
      "forcement",
      0.005
    ],
    [
      "fin",
      0.005
    ],
    [
      "essentiellement",
      0.005
    ],
    [
      "dogmatiquement",
      0.005
    ],
    [
      "directement",
      0.005
    ],
    [
      "despotiquement",
      0.005
    ],
    [
      "capitalement",
      0.005
    ]
  ],
  "touriste": [
    [
      "vacancier",
      0.175
    ],
    [
      "voyageur",
      0.175
    ],
    [
      "excursionniste",
      0.1175
    ],
    [
      "pelerin",
      0.1175
    ],
    [
      "peregrin",
      0.1175
    ],
    [
      "visiteur",
      0.1175
    ],
    [
      "baigneur",
      0.0575
    ],
    [
      "villegiateur",
      0.0575
    ],
    [
      "etranger",
      0.0575
    ]
  ],
  "desquels": [
    [
      "dont",
      1.0
    ]
  ],
  "anime": [
    [
      "exciter",
      0.1275
    ],
    [
      "enflammer",
      0.075
    ],
    [
      "pousser",
      0.0625
    ],
    [
      "aiguillonner",
      0.0525
    ],
    [
      "attiser",
      0.0525
    ],
    [
      "exalter",
      0.0425
    ],
    [
      "inspirer",
      0.0425
    ],
    [
      "provoquer",
      0.035
    ],
    [
      "stimuler",
      0.0275
    ],
    [
      "encourager",
      0.0275
    ],
    [
      "allumer",
      0.0275
    ],
    [
      "aviver",
      0.025
    ],
    [
      "ranimer",
      0.025
    ],
    [
      "conduire",
      0.02
    ],
    [
      "vivifier",
      0.02
    ],
    [
      "eperonner",
      0.0175
    ],
    [
      "dechainer",
      0.0175
    ],
    [
      "mener",
      0.015
    ],
    [
      "souffler",
      0.0125
    ],
    [
      "mouvoir",
      0.0125
    ],
    [
      "insuffler",
      0.0125
    ],
    [
      "inciter",
      0.0125
    ],
    [
      "fouetter",
      0.0125
    ],
    [
      "agir",
      0.0125
    ],
    [
      "transporter",
      0.01
    ],
    [
      "irriter",
      0.01
    ],
    [
      "galvaniser",
      0.01
    ],
    [
      "activer",
      0.01
    ],
    [
      "enfievrer",
      0.0075
    ],
    [
      "impregner",
      0.0075
    ],
    [
      "influencer",
      0.0075
    ],
    [
      "eveiller",
      0.005
    ],
    [
      "emoustiller",
      0.005
    ],
    [
      "electriser",
      0.005
    ],
    [
      "echauffer",
      0.005
    ],
    [
      "passionner",
      0.0025
    ],
    [
      "infuser",
      0.0025
    ],
    [
      "influer",
      0.0025
    ],
    [
      "imprimer",
      0.0025
    ],
    [
      "diriger",
      0.0025
    ],
    [
      "creer",
      0.0025
    ],
    [
      "colorer",
      0.0025
    ],
    [
      "agiter",
      0.0025
    ],
    [
      "habiter",
      0.0
    ],
    [
      "illuminer",
      0.0
    ],
    [
      "impulser",
      0.0
    ],
    [
      "interesser",
      0.0
    ],
    [
      "promouvoir",
      0.0
    ],
    [
      "revivifier",
      0.0
    ],
    [
      "tisonner",
      0.0
    ],
    [
      "guider",
      0.0
    ],
    [
      "fouailler",
      0.0
    ],
    [
      "exhorter",
      0.0
    ],
    [
      "degourdir",
      0.0
    ],
    [
      "degeler",
      0.0
    ],
    [
      "armer",
      0.0
    ],
    [
      "acharner",
      0.0
    ],
    [
      "egayer",
      0.0
    ]
  ],
  "animer": [
    [
      "exciter",
      0.1275
    ],
    [
      "enflammer",
      0.075
    ],
    [
      "pousser",
      0.0625
    ],
    [
      "aiguillonner",
      0.0525
    ],
    [
      "attiser",
      0.0525
    ],
    [
      "exalter",
      0.0425
    ],
    [
      "inspirer",
      0.0425
    ],
    [
      "provoquer",
      0.035
    ],
    [
      "stimuler",
      0.0275
    ],
    [
      "encourager",
      0.0275
    ],
    [
      "allumer",
      0.0275
    ],
    [
      "aviver",
      0.025
    ],
    [
      "ranimer",
      0.025
    ],
    [
      "conduire",
      0.02
    ],
    [
      "vivifier",
      0.02
    ],
    [
      "eperonner",
      0.0175
    ],
    [
      "dechainer",
      0.0175
    ],
    [
      "mener",
      0.015
    ],
    [
      "souffler",
      0.0125
    ],
    [
      "mouvoir",
      0.0125
    ],
    [
      "insuffler",
      0.0125
    ],
    [
      "inciter",
      0.0125
    ],
    [
      "fouetter",
      0.0125
    ],
    [
      "agir",
      0.0125
    ],
    [
      "transporter",
      0.01
    ],
    [
      "irriter",
      0.01
    ],
    [
      "galvaniser",
      0.01
    ],
    [
      "activer",
      0.01
    ],
    [
      "enfievrer",
      0.0075
    ],
    [
      "impregner",
      0.0075
    ],
    [
      "influencer",
      0.0075
    ],
    [
      "eveiller",
      0.005
    ],
    [
      "emoustiller",
      0.005
    ],
    [
      "electriser",
      0.005
    ],
    [
      "echauffer",
      0.005
    ],
    [
      "passionner",
      0.0025
    ],
    [
      "infuser",
      0.0025
    ],
    [
      "influer",
      0.0025
    ],
    [
      "imprimer",
      0.0025
    ],
    [
      "diriger",
      0.0025
    ],
    [
      "creer",
      0.0025
    ],
    [
      "colorer",
      0.0025
    ],
    [
      "agiter",
      0.0025
    ],
    [
      "habiter",
      0.0
    ],
    [
      "illuminer",
      0.0
    ],
    [
      "impulser",
      0.0
    ],
    [
      "interesser",
      0.0
    ],
    [
      "promouvoir",
      0.0
    ],
    [
      "revivifier",
      0.0
    ],
    [
      "tisonner",
      0.0
    ],
    [
      "guider",
      0.0
    ],
    [
      "fouailler",
      0.0
    ],
    [
      "exhorter",
      0.0
    ],
    [
      "degourdir",
      0.0
    ],
    [
      "degeler",
      0.0
    ],
    [
      "armer",
      0.0
    ],
    [
      "acharner",
      0.0
    ],
    [
      "egayer",
      0.0
    ]
  ],
  "bus": [
    [
      "s'abreuver",
      0.15
    ],
    [
      "absorber",
      0.0475
    ],
    [
      "s'enivrer",
      0.045
    ],
    [
      "pomper",
      0.04
    ],
    [
      "pinter",
      0.03
    ],
    [
      "s'imbiber",
      0.025
    ],
    [
      "recevoir",
      0.025
    ],
    [
      "ingurgiter",
      0.025
    ],
    [
      "avaler",
      0.025
    ],
    [
      "picoler",
      0.0225
    ],
    [
      "prendre",
      0.0225
    ],
    [
      "sucer",
      0.015
    ],
    [
      "souffrir",
      0.015
    ],
    [
      "s'alcooliser",
      0.015
    ],
    [
      "humer",
      0.015
    ],
    [
      "essuyer",
      0.015
    ],
    [
      "entonner",
      0.015
    ],
    [
      "deguster",
      0.015
    ],
    [
      "chopiner",
      0.015
    ],
    [
      "aspirer",
      0.015
    ],
    [
      "siroter",
      0.0125
    ],
    [
      "siffler",
      0.0125
    ],
    [
      "s'ivrogner",
      0.0125
    ],
    [
      "s'impregner",
      0.0125
    ],
    [
      "licher",
      0.0125
    ],
    [
      "lamper",
      0.0125
    ],
    [
      "ivrogner",
      0.0125
    ],
    [
      "endurer",
      0.0125
    ],
    [
      "supporter",
      0.0075
    ],
    [
      "teter",
      0.0075
    ],
    [
      "vider",
      0.0075
    ],
    [
      "ecluser",
      0.0075
    ],
    [
      "eponger",
      0.0075
    ],
    [
      "arroser",
      0.0075
    ],
    [
      "biberonner",
      0.0075
    ],
    [
      "consommer",
      0.0075
    ],
    [
      "respirer",
      0.0075
    ],
    [
      "s'aviner",
      0.0075
    ],
    [
      "savourer",
      0.0025
    ],
    [
      "sabler",
      0.0025
    ],
    [
      "s'inonder",
      0.0025
    ],
    [
      "s'humecter",
      0.0025
    ],
    [
      "rincer",
      0.0025
    ],
    [
      "soiffer",
      0.0025
    ],
    [
      "tolerer",
      0.0025
    ],
    [
      "trinquer",
      0.0025
    ],
    [
      "riboter",
      0.0025
    ],
    [
      "renifler",
      0.0025
    ],
    [
      "abreuver",
      0.0025
    ],
    [
      "bidonner",
      0.0025
    ],
    [
      "boissonner",
      0.0025
    ],
    [
      "buvoter",
      0.0025
    ],
    [
      "depenser",
      0.0025
    ],
    [
      "fouetter",
      0.0025
    ],
    [
      "godailler",
      0.0025
    ],
    [
      "laper",
      0.0025
    ],
    [
      "lichailler",
      0.0025
    ],
    [
      "lipper",
      0.0025
    ],
    [
      "pictancher",
      0.0025
    ],
    [
      "picter",
      0.0025
    ],
    [
      "pictonner",
      0.0025
    ]
  ],
  "terminus": [
    [
      "but",
      0.5
    ],
    [
      "fin",
      0.5
    ]
  ],
  "niveau": [
    [
      "classe",
      0.09
    ],
    [
      "rang",
      0.09
    ],
    [
      "etage",
      0.09
    ],
    [
      "degre",
      0.0725
    ],
    [
      "echelon",
      0.0725
    ],
    [
      "plan",
      0.0525
    ],
    [
      "ordre",
      0.0525
    ],
    [
      "ligne",
      0.0525
    ],
    [
      "hauteur",
      0.0525
    ],
    [
      "stature",
      0.035
    ],
    [
      "standing",
      0.035
    ],
    [
      "stade",
      0.035
    ],
    [
      "qualite",
      0.035
    ],
    [
      "portee",
      0.035
    ],
    [
      "echelle",
      0.0175
    ],
    [
      "topographie",
      0.0175
    ],
    [
      "registre",
      0.0175
    ],
    [
      "palier",
      0.0175
    ],
    [
      "force",
      0.0175
    ],
    [
      "diapason",
      0.0175
    ],
    [
      "cote",
      0.0175
    ],
    [
      "condition",
      0.0175
    ],
    [
      "elevation",
      0.0175
    ]
  ],
  "minable": [
    [
      "pauvre",
      0.125
    ],
    [
      "mechant",
      0.0925
    ],
    [
      "lamentable",
      0.085
    ],
    [
      "miserable",
      0.075
    ],
    [
      "pietre",
      0.0675
    ],
    [
      "mauvais",
      0.0575
    ],
    [
      "pitoyable",
      0.0575
    ],
    [
      "maigre",
      0.05
    ],
    [
      "deplorable",
      0.05
    ],
    [
      "faible",
      0.0325
    ],
    [
      "mesquin",
      0.0325
    ],
    [
      "piteux",
      0.0325
    ],
    [
      "detestable",
      0.025
    ],
    [
      "miteux",
      0.025
    ],
    [
      "etique",
      0.015
    ],
    [
      "triste",
      0.015
    ],
    [
      "riquiqui",
      0.015
    ],
    [
      "nul",
      0.015
    ],
    [
      "tout",
      0.0075
    ],
    [
      "ringard",
      0.0075
    ],
    [
      "pouilleux",
      0.0075
    ],
    [
      "odieux",
      0.0075
    ],
    [
      "mite",
      0.0075
    ],
    [
      "misereux",
      0.0075
    ],
    [
      "merdeux",
      0.0075
    ],
    [
      "loquedu",
      0.0075
    ],
    [
      "foireux",
      0.0075
    ],
    [
      "besogneux",
      0.0075
    ],
    [
      "etrique",
      0.0075
    ]
  ],
  "equitable": [
    [
      "juste",
      0.2425
    ],
    [
      "droit",
      0.15
    ],
    [
      "impartial",
      0.15
    ],
    [
      "probe",
      0.12
    ],
    [
      "honnete",
      0.09
    ],
    [
      "integre",
      0.06
    ],
    [
      "objectif",
      0.03
    ],
    [
      "legitime",
      0.03
    ],
    [
      "loyal",
      0.03
    ],
    [
      "impassible",
      0.03
    ],
    [
      "bon",
      0.03
    ],
    [
      "egal",
      0.03
    ]
  ],
  "remarquer": [
    [
      "apercevoir",
      0.13
    ],
    [
      "decouvrir",
      0.13
    ],
    [
      "voir",
      0.0925
    ],
    [
      "saisir",
      0.0675
    ],
    [
      "s'apercevoir",
      0.0475
    ],
    [
      "noter",
      0.0475
    ],
    [
      "constater",
      0.0425
    ],
    [
      "observer",
      0.0425
    ],
    [
      "sentir",
      0.035
    ],
    [
      "reveler",
      0.035
    ],
    [
      "reperer",
      0.035
    ],
    [
      "discerner",
      0.035
    ],
    [
      "comprendre",
      0.035
    ],
    [
      "percevoir",
      0.0225
    ],
    [
      "surprendre",
      0.0175
    ],
    [
      "s'aviser",
      0.0175
    ],
    [
      "relever",
      0.0175
    ],
    [
      "deceler",
      0.0175
    ],
    [
      "aviser",
      0.0175
    ],
    [
      "distinguer",
      0.01
    ],
    [
      "marquer",
      0.01
    ],
    [
      "regarder",
      0.01
    ]
  ],
  "officiellement": [
    [
      "expressement",
      0.25
    ],
    [
      "formellement",
      0.25
    ],
    [
      "publiquement",
      0.25
    ],
    [
      "solennellement",
      0.25
    ]
  ],
  "francais": [
    [
      "hexagonal",
      0.5
    ],
    [
      "tricolore",
      0.5
    ]
  ],
  "handicaper": [
    [
      "desavantager",
      0.375
    ],
    [
      "desservir",
      0.25
    ],
    [
      "defavoriser",
      0.125
    ],
    [
      "gener",
      0.125
    ],
    [
      "pejorer",
      0.125
    ]
  ],
  "handicape": [
    [
      "desavantager",
      0.375
    ],
    [
      "desservir",
      0.25
    ],
    [
      "defavoriser",
      0.125
    ],
    [
      "gener",
      0.125
    ],
    [
      "pejorer",
      0.125
    ]
  ],
  "assiste": [
    [
      "servir",
      0.1375
    ],
    [
      "aider",
      0.125
    ],
    [
      "soutenir",
      0.0675
    ],
    [
      "proteger",
      0.055
    ],
    [
      "suivre",
      0.055
    ],
    [
      "voir",
      0.055
    ],
    [
      "veiller",
      0.045
    ],
    [
      "secourir",
      0.045
    ],
    [
      "appuyer",
      0.045
    ],
    [
      "accompagner",
      0.0325
    ],
    [
      "s'occuper",
      0.0325
    ],
    [
      "epauler",
      0.0225
    ],
    [
      "soulager",
      0.0225
    ],
    [
      "seconder",
      0.0225
    ],
    [
      "reconforter",
      0.0225
    ],
    [
      "participer",
      0.0225
    ],
    [
      "donner",
      0.0225
    ],
    [
      "concourir",
      0.0225
    ],
    [
      "collaborer",
      0.0225
    ],
    [
      "soigner",
      0.01
    ],
    [
      "entourer",
      0.01
    ],
    [
      "entendre",
      0.01
    ],
    [
      "defendre",
      0.01
    ],
    [
      "benir",
      0.01
    ]
  ],
  "assister": [
    [
      "servir",
      0.1375
    ],
    [
      "aider",
      0.125
    ],
    [
      "soutenir",
      0.0675
    ],
    [
      "proteger",
      0.055
    ],
    [
      "suivre",
      0.055
    ],
    [
      "voir",
      0.055
    ],
    [
      "veiller",
      0.045
    ],
    [
      "secourir",
      0.045
    ],
    [
      "appuyer",
      0.045
    ],
    [
      "accompagner",
      0.0325
    ],
    [
      "s'occuper",
      0.0325
    ],
    [
      "epauler",
      0.0225
    ],
    [
      "soulager",
      0.0225
    ],
    [
      "seconder",
      0.0225
    ],
    [
      "reconforter",
      0.0225
    ],
    [
      "participer",
      0.0225
    ],
    [
      "donner",
      0.0225
    ],
    [
      "concourir",
      0.0225
    ],
    [
      "collaborer",
      0.0225
    ],
    [
      "soigner",
      0.01
    ],
    [
      "entourer",
      0.01
    ],
    [
      "entendre",
      0.01
    ],
    [
      "defendre",
      0.01
    ],
    [
      "benir",
      0.01
    ]
  ],
  "supporter": [
    [
      "appui",
      0.5
    ],
    [
      "partisan",
      0.5
    ]
  ],
  "sympa": [
    [
      "agreable",
      0.5
    ],
    [
      "chouette",
      0.25
    ],
    [
      "sympathique",
      0.25
    ]
  ],
  "idiot": [
    [
      "bete",
      0.13
    ],
    [
      "sot",
      0.0975
    ],
    [
      "imbecile",
      0.09
    ],
    [
      "stupide",
      0.09
    ],
    [
      "niais",
      0.055
    ],
    [
      "ballot",
      0.05
    ],
    [
      "cretin",
      0.0475
    ],
    [
      "inintelligent",
      0.0325
    ],
    [
      "absurde",
      0.0275
    ],
    [
      "arriere",
      0.0225
    ],
    [
      "inepte",
      0.02
    ],
    [
      "con",
      0.0175
    ],
    [
      "beta",
      0.0175
    ],
    [
      "abruti",
      0.0175
    ],
    [
      "deraisonnable",
      0.015
    ],
    [
      "fou",
      0.015
    ],
    [
      "insense",
      0.015
    ],
    [
      "simple",
      0.015
    ],
    [
      "innocent",
      0.0125
    ],
    [
      "debile",
      0.0125
    ],
    [
      "demeure",
      0.0125
    ],
    [
      "aberrant",
      0.0125
    ],
    [
      "ane",
      0.01
    ],
    [
      "tare",
      0.01
    ],
    [
      "retarde",
      0.01
    ],
    [
      "ignorant",
      0.01
    ],
    [
      "degenere",
      0.01
    ],
    [
      "cruche",
      0.01
    ],
    [
      "cornichon",
      0.01
    ],
    [
      "borne",
      0.01
    ],
    [
      "nul",
      0.0075
    ],
    [
      "couillon",
      0.0075
    ],
    [
      "andouille",
      0.0075
    ],
    [
      "minus",
      0.0025
    ],
    [
      "jacques",
      0.0025
    ],
    [
      "cul",
      0.0025
    ],
    [
      "corniaud",
      0.0025
    ],
    [
      "cloche",
      0.0025
    ],
    [
      "bouche",
      0.0025
    ],
    [
      "injuste",
      0.0
    ],
    [
      "inconsequent",
      0.0
    ],
    [
      "gateux",
      0.0
    ],
    [
      "emmanche",
      0.0
    ],
    [
      "brele",
      0.0
    ],
    [
      "brute",
      0.0
    ],
    [
      "ahuri",
      0.0
    ],
    [
      "manche",
      0.0
    ]
  ],
  "meritant": [
    [
      "honnete",
      0.2275
    ],
    [
      "bon",
      0.17
    ],
    [
      "honorable",
      0.1125
    ],
    [
      "respectable",
      0.085
    ],
    [
      "meritoire",
      0.085
    ],
    [
      "estimable",
      0.085
    ],
    [
      "digne",
      0.085
    ],
    [
      "courageux",
      0.055
    ],
    [
      "vertueux",
      0.055
    ],
    [
      "valeureux",
      0.0275
    ]
  ],
  "mocassin": [
    [
      "chaussure",
      0.5
    ],
    [
      "soulier",
      0.5
    ]
  ],
  "gene": [
    [
      "embarras",
      0.135
    ],
    [
      "difficulte",
      0.0625
    ],
    [
      "ennui",
      0.0575
    ],
    [
      "misere",
      0.045
    ],
    [
      "contrainte",
      0.04
    ],
    [
      "malaise",
      0.04
    ],
    [
      "besoin",
      0.035
    ],
    [
      "pauvrete",
      0.035
    ],
    [
      "obstacle",
      0.0275
    ],
    [
      "incommodite",
      0.0275
    ],
    [
      "penurie",
      0.0225
    ],
    [
      "peine",
      0.0225
    ],
    [
      "inconvenient",
      0.0225
    ],
    [
      "empechement",
      0.0225
    ],
    [
      "derangement",
      0.0225
    ],
    [
      "torture",
      0.015
    ],
    [
      "timidite",
      0.015
    ],
    [
      "mesaise",
      0.015
    ],
    [
      "honte",
      0.015
    ],
    [
      "entrave",
      0.015
    ],
    [
      "deche",
      0.015
    ],
    [
      "confusion",
      0.015
    ],
    [
      "bat",
      0.015
    ],
    [
      "assujettissement",
      0.015
    ],
    [
      "question",
      0.01
    ],
    [
      "sujetion",
      0.01
    ],
    [
      "supplice",
      0.01
    ],
    [
      "traverse",
      0.01
    ],
    [
      "trouble",
      0.01
    ],
    [
      "violence",
      0.01
    ],
    [
      "pudeur",
      0.01
    ],
    [
      "poisse",
      0.01
    ],
    [
      "charge",
      0.01
    ],
    [
      "chaine",
      0.01
    ],
    [
      "denuement",
      0.01
    ],
    [
      "dependance",
      0.01
    ],
    [
      "esclavage",
      0.01
    ],
    [
      "necessite",
      0.01
    ],
    [
      "prejudice",
      0.005
    ],
    [
      "privation",
      0.005
    ],
    [
      "intimidation",
      0.005
    ],
    [
      "impecuniosite",
      0.005
    ],
    [
      "gehenne",
      0.005
    ],
    [
      "gaucherie",
      0.005
    ],
    [
      "froideur",
      0.005
    ],
    [
      "froid",
      0.005
    ],
    [
      "tutelle",
      0.005
    ]
  ],
  "clavecin": [
    [
      "virginal",
      0.5
    ],
    [
      "epinette",
      0.5
    ]
  ],
  "vote": [
    [
      "referendum",
      0.25
    ],
    [
      "suffrage",
      0.125
    ],
    [
      "election",
      0.125
    ],
    [
      "voix",
      0.0825
    ],
    [
      "plebiscite",
      0.0825
    ],
    [
      "consultation",
      0.0825
    ],
    [
      "avis",
      0.0825
    ],
    [
      "adoption",
      0.04
    ],
    [
      "scrutin",
      0.04
    ],
    [
      "votation",
      0.04
    ]
  ],
  "droite": [
    [
      "bon",
      0.05
    ],
    [
      "juste",
      0.05
    ],
    [
      "net",
      0.0475
    ],
    [
      "honnete",
      0.045
    ],
    [
      "franc",
      0.04
    ],
    [
      "vrai",
      0.035
    ],
    [
      "pur",
      0.03
    ],
    [
      "pouvoir",
      0.025
    ],
    [
      "sincere",
      0.0225
    ],
    [
      "loyal",
      0.0175
    ],
    [
      "loi",
      0.0175
    ],
    [
      "ferme",
      0.0175
    ],
    [
      "faculte",
      0.0175
    ],
    [
      "bien",
      0.0175
    ],
    [
      "equitable",
      0.015
    ],
    [
      "simple",
      0.015
    ],
    [
      "raisonnable",
      0.015
    ],
    [
      "probe",
      0.015
    ],
    [
      "privilege",
      0.015
    ],
    [
      "judicieux",
      0.015
    ],
    [
      "avantage",
      0.015
    ],
    [
      "regulier",
      0.0125
    ],
    [
      "puissance",
      0.0125
    ],
    [
      "prerogative",
      0.0125
    ],
    [
      "logique",
      0.0125
    ],
    [
      "impartial",
      0.0125
    ],
    [
      "direct",
      0.0125
    ],
    [
      "debout",
      0.0125
    ],
    [
      "carre",
      0.0125
    ],
    [
      "titre",
      0.0075
    ],
    [
      "strict",
      0.0075
    ],
    [
      "sain",
      0.0075
    ],
    [
      "redevance",
      0.0075
    ],
    [
      "qualite",
      0.0075
    ],
    [
      "objectif",
      0.0075
    ],
    [
      "justice",
      0.0075
    ],
    [
      "code",
      0.0075
    ],
    [
      "autorisation",
      0.0075
    ],
    [
      "abrupt",
      0.0075
    ],
    [
      "raide",
      0.005
    ],
    [
      "rationnel",
      0.005
    ],
    [
      "rectiligne",
      0.005
    ],
    [
      "retribution",
      0.005
    ],
    [
      "sense",
      0.005
    ],
    [
      "uniforme",
      0.005
    ],
    [
      "usage",
      0.005
    ],
    [
      "vertical",
      0.005
    ],
    [
      "egal",
      0.005
    ],
    [
      "possibilite",
      0.005
    ],
    [
      "positif",
      0.005
    ],
    [
      "permission",
      0.005
    ],
    [
      "benefice",
      0.005
    ],
    [
      "clair",
      0.005
    ],
    [
      "coutume",
      0.005
    ],
    [
      "dette",
      0.005
    ],
    [
      "desinteresse",
      0.005
    ],
    [
      "impot",
      0.005
    ],
    [
      "irreprochable",
      0.005
    ],
    [
      "jurisprudence",
      0.005
    ],
    [
      "legislation",
      0.005
    ],
    [
      "obvers",
      0.0025
    ],
    [
      "morale",
      0.0025
    ],
    [
      "monopole",
      0.0025
    ],
    [
      "legitimite",
      0.0025
    ],
    [
      "legislateur",
      0.0025
    ],
    [
      "passeport",
      0.0025
    ],
    [
      "perpendiculaire",
      0.0025
    ],
    [
      "prud'homme",
      0.0025
    ],
    [
      "reglement",
      0.0025
    ],
    [
      "salaire",
      0.0025
    ],
    [
      "taxe",
      0.0025
    ],
    [
      "verticalement",
      0.0025
    ],
    [
      "legalite",
      0.0025
    ],
    [
      "liberte",
      0.0025
    ],
    [
      "imposition",
      0.0025
    ],
    [
      "aligne",
      0.0025
    ],
    [
      "attribution",
      0.0025
    ],
    [
      "avers",
      0.0025
    ],
    [
      "contribution",
      0.0025
    ],
    [
      "dextre",
      0.0025
    ],
    [
      "dextrogyre",
      0.0025
    ],
    [
      "digeste",
      0.0025
    ],
    [
      "directement",
      0.0025
    ],
    [
      "dresse",
      0.0025
    ],
    [
      "droitement",
      0.0025
    ],
    [
      "du",
      0.0025
    ],
    [
      "habilete",
      0.0025
    ],
    [
      "habilite",
      0.0025
    ]
  ],
  "mepriser": [
    [
      "dedaigner",
      0.105
    ],
    [
      "braver",
      0.06
    ],
    [
      "deprecier",
      0.06
    ],
    [
      "meconnaitre",
      0.06
    ],
    [
      "negliger",
      0.0525
    ],
    [
      "rire",
      0.0425
    ],
    [
      "mesestimer",
      0.035
    ],
    [
      "vilipender",
      0.025
    ],
    [
      "rabaisser",
      0.025
    ],
    [
      "violer",
      0.0175
    ],
    [
      "transgresser",
      0.0175
    ],
    [
      "ravaler",
      0.0175
    ],
    [
      "narguer",
      0.0175
    ],
    [
      "mejuger",
      0.0175
    ],
    [
      "ignorer",
      0.0175
    ],
    [
      "decrier",
      0.0175
    ],
    [
      "snober",
      0.0075
    ],
    [
      "s'asseoir",
      0.0075
    ],
    [
      "repousser",
      0.0075
    ],
    [
      "jongler",
      0.0075
    ],
    [
      "honnir",
      0.0075
    ],
    [
      "fouler",
      0.0075
    ],
    [
      "desestimer",
      0.0075
    ],
    [
      "depriser",
      0.0075
    ]
  ],
  "ecolo": [
    [
      "vert",
      0.5
    ],
    [
      "ecologiste",
      0.5
    ]
  ],
  "revendre": [
    [
      "retroceder",
      0.3325
    ],
    [
      "brocanter",
      0.165
    ],
    [
      "carambouiller",
      0.165
    ],
    [
      "ceder",
      0.165
    ],
    [
      "receder",
      0.165
    ]
  ],
  "lise": [
    [
      "dechiffrer",
      0.1175
    ],
    [
      "decouvrir",
      0.1
    ],
    [
      "reperer",
      0.0825
    ],
    [
      "penetrer",
      0.0675
    ],
    [
      "voir",
      0.05
    ],
    [
      "expliquer",
      0.05
    ],
    [
      "dire",
      0.05
    ],
    [
      "deviner",
      0.05
    ],
    [
      "epeler",
      0.0325
    ],
    [
      "percer",
      0.0325
    ],
    [
      "interpreter",
      0.0325
    ],
    [
      "feuilleter",
      0.0325
    ],
    [
      "discerner",
      0.0325
    ],
    [
      "consulter",
      0.0325
    ],
    [
      "survoler",
      0.015
    ],
    [
      "reciter",
      0.015
    ],
    [
      "prononcer",
      0.015
    ],
    [
      "parcourir",
      0.015
    ],
    [
      "frequenter",
      0.015
    ],
    [
      "devorer",
      0.015
    ],
    [
      "depouiller",
      0.015
    ],
    [
      "decrypter",
      0.015
    ],
    [
      "decoder",
      0.015
    ],
    [
      "debrouiller",
      0.015
    ],
    [
      "compulser",
      0.015
    ],
    [
      "bouquiner",
      0.015
    ],
    [
      "anonner",
      0.015
    ]
  ],
  "culpabiliser": [],
  "diplome": [
    [
      "brevete",
      0.5
    ],
    [
      "qualifie",
      0.5
    ]
  ],
  "statistique": [
    [
      "denombrement",
      0.18
    ],
    [
      "revue",
      0.18
    ],
    [
      "etat",
      0.18
    ],
    [
      "classement",
      0.09
    ],
    [
      "compte",
      0.09
    ],
    [
      "description",
      0.09
    ],
    [
      "mathematique",
      0.09
    ],
    [
      "mesure",
      0.09
    ]
  ],
  "sterilet": [
    [
      "contraceptif",
      1.0
    ]
  ],
  "pantalon": [
    [
      "culotte",
      0.23
    ],
    [
      "gregues",
      0.065
    ],
    [
      "fendard",
      0.03
    ],
    [
      "fourreau",
      0.03
    ],
    [
      "froc",
      0.03
    ],
    [
      "fuseau",
      0.03
    ],
    [
      "grimpant",
      0.03
    ],
    [
      "jean",
      0.03
    ],
    [
      "knickerbockers",
      0.03
    ],
    [
      "pantin",
      0.03
    ],
    [
      "saroual",
      0.03
    ],
    [
      "fendant",
      0.03
    ],
    [
      "falzar",
      0.03
    ],
    [
      "decouverte",
      0.03
    ],
    [
      "bleu",
      0.03
    ],
    [
      "bouffon",
      0.03
    ],
    [
      "braies",
      0.03
    ],
    [
      "benard",
      0.03
    ],
    [
      "calecon",
      0.03
    ],
    [
      "costume",
      0.03
    ],
    [
      "cotte",
      0.03
    ],
    [
      "culbutant",
      0.03
    ],
    [
      "turlupin",
      0.03
    ]
  ],
  "chomage": [
    [
      "marasme",
      0.22
    ],
    [
      "cessation",
      0.11
    ],
    [
      "crise",
      0.11
    ],
    [
      "fermeture",
      0.11
    ],
    [
      "inaction",
      0.11
    ],
    [
      "inemploi",
      0.11
    ],
    [
      "licenciement",
      0.11
    ]
  ],
  "flechir": [
    [
      "ceder",
      0.0725
    ],
    [
      "plier",
      0.0675
    ],
    [
      "s'incliner",
      0.045
    ],
    [
      "faiblir",
      0.04
    ],
    [
      "s'abaisser",
      0.04
    ],
    [
      "baisser",
      0.035
    ],
    [
      "mollir",
      0.03
    ],
    [
      "ployer",
      0.0275
    ],
    [
      "adoucir",
      0.025
    ],
    [
      "diminuer",
      0.025
    ],
    [
      "incliner",
      0.0225
    ],
    [
      "rompre",
      0.0225
    ],
    [
      "courber",
      0.02
    ],
    [
      "toucher",
      0.0175
    ],
    [
      "pencher",
      0.0175
    ],
    [
      "capituler",
      0.0175
    ],
    [
      "abandonner",
      0.0175
    ],
    [
      "chanceler",
      0.015
    ],
    [
      "flancher",
      0.015
    ],
    [
      "reculer",
      0.015
    ],
    [
      "s'inflechir",
      0.0125
    ],
    [
      "s'affaisser",
      0.0125
    ],
    [
      "refluer",
      0.0125
    ],
    [
      "succomber",
      0.01
    ],
    [
      "s'humilier",
      0.01
    ],
    [
      "lacher",
      0.01
    ],
    [
      "gauchir",
      0.01
    ],
    [
      "desarmer",
      0.01
    ],
    [
      "defaillir",
      0.01
    ],
    [
      "decliner",
      0.01
    ],
    [
      "calmer",
      0.01
    ],
    [
      "abaisser",
      0.01
    ],
    [
      "affaiblir",
      0.01
    ],
    [
      "amadouer",
      0.01
    ],
    [
      "apaiser",
      0.01
    ],
    [
      "attendrir",
      0.01
    ],
    [
      "ebranler",
      0.0075
    ],
    [
      "trebucher",
      0.0075
    ],
    [
      "s'agenouiller",
      0.0075
    ],
    [
      "obeir",
      0.0075
    ],
    [
      "inflechir",
      0.0075
    ],
    [
      "gagner",
      0.0075
    ],
    [
      "caler",
      0.0075
    ],
    [
      "emouvoir",
      0.005
    ],
    [
      "s'abandonner",
      0.005
    ],
    [
      "manquer",
      0.005
    ],
    [
      "decrocher",
      0.005
    ],
    [
      "vaciller",
      0.0025
    ],
    [
      "tituber",
      0.0025
    ],
    [
      "s'arquer",
      0.0025
    ],
    [
      "s'amollir",
      0.0025
    ],
    [
      "recourber",
      0.0025
    ],
    [
      "incurver",
      0.0025
    ],
    [
      "craquer",
      0.0025
    ],
    [
      "arquer",
      0.0025
    ],
    [
      "arguer",
      0.0025
    ],
    [
      "apitoyer",
      0.0025
    ],
    [
      "vaincre",
      0.0025
    ]
  ],
  "poubelle": [
    [
      "boite",
      0.3325
    ]
  ],
  "renverse": [
    [
      "abattre",
      0.1
    ],
    [
      "bouleverser",
      0.0625
    ],
    [
      "detruire",
      0.055
    ],
    [
      "culbuter",
      0.0525
    ],
    [
      "aneantir",
      0.035
    ],
    [
      "bousculer",
      0.0325
    ],
    [
      "ecraser",
      0.0325
    ],
    [
      "terrasser",
      0.0275
    ],
    [
      "etonner",
      0.025
    ],
    [
      "troubler",
      0.025
    ],
    [
      "demolir",
      0.025
    ],
    [
      "vaincre",
      0.02
    ],
    [
      "ruiner",
      0.02
    ],
    [
      "foudroyer",
      0.02
    ],
    [
      "enfoncer",
      0.02
    ],
    [
      "defaire",
      0.02
    ],
    [
      "confondre",
      0.02
    ],
    [
      "briser",
      0.02
    ],
    [
      "revolutionner",
      0.015
    ],
    [
      "retourner",
      0.015
    ],
    [
      "chavirer",
      0.015
    ],
    [
      "chambarder",
      0.015
    ],
    [
      "deconcerter",
      0.0125
    ],
    [
      "precipiter",
      0.0125
    ],
    [
      "stupefier",
      0.0125
    ],
    [
      "verser",
      0.0125
    ],
    [
      "epater",
      0.01
    ],
    [
      "surprendre",
      0.01
    ],
    [
      "demonter",
      0.01
    ],
    [
      "demanteler",
      0.01
    ],
    [
      "coucher",
      0.01
    ],
    [
      "etendre",
      0.0075
    ],
    [
      "ebahir",
      0.0075
    ],
    [
      "transposer",
      0.0075
    ],
    [
      "tomber",
      0.0075
    ],
    [
      "faucher",
      0.0075
    ],
    [
      "crouler",
      0.0075
    ],
    [
      "chambouler",
      0.0075
    ],
    [
      "transformer",
      0.005
    ],
    [
      "saper",
      0.005
    ],
    [
      "saccager",
      0.005
    ],
    [
      "repandre",
      0.005
    ],
    [
      "inverser",
      0.005
    ],
    [
      "intervertir",
      0.005
    ],
    [
      "broyer",
      0.005
    ],
    [
      "basculer",
      0.005
    ],
    [
      "envoyer",
      0.0025
    ],
    [
      "incliner",
      0.0025
    ],
    [
      "invertir",
      0.0025
    ],
    [
      "pencher",
      0.0025
    ],
    [
      "souffler",
      0.0025
    ],
    [
      "subvertir",
      0.0025
    ],
    [
      "detroner",
      0.0025
    ],
    [
      "desarconner",
      0.0025
    ],
    [
      "accrocher",
      0.0025
    ],
    [
      "asseoir",
      0.0025
    ],
    [
      "cabaner",
      0.0025
    ],
    [
      "chahuter",
      0.0025
    ],
    [
      "colleter",
      0.0025
    ],
    [
      "cuire",
      0.0025
    ],
    [
      "deborder",
      0.0025
    ],
    [
      "deboulonner",
      0.0025
    ],
    [
      "surmonter",
      0.0025
    ]
  ],
  "renverser": [
    [
      "abattre",
      0.1
    ],
    [
      "bouleverser",
      0.0625
    ],
    [
      "detruire",
      0.055
    ],
    [
      "culbuter",
      0.0525
    ],
    [
      "aneantir",
      0.035
    ],
    [
      "bousculer",
      0.0325
    ],
    [
      "ecraser",
      0.0325
    ],
    [
      "terrasser",
      0.0275
    ],
    [
      "etonner",
      0.025
    ],
    [
      "troubler",
      0.025
    ],
    [
      "demolir",
      0.025
    ],
    [
      "vaincre",
      0.02
    ],
    [
      "ruiner",
      0.02
    ],
    [
      "foudroyer",
      0.02
    ],
    [
      "enfoncer",
      0.02
    ],
    [
      "defaire",
      0.02
    ],
    [
      "confondre",
      0.02
    ],
    [
      "briser",
      0.02
    ],
    [
      "revolutionner",
      0.015
    ],
    [
      "retourner",
      0.015
    ],
    [
      "chavirer",
      0.015
    ],
    [
      "chambarder",
      0.015
    ],
    [
      "deconcerter",
      0.0125
    ],
    [
      "precipiter",
      0.0125
    ],
    [
      "stupefier",
      0.0125
    ],
    [
      "verser",
      0.0125
    ],
    [
      "epater",
      0.01
    ],
    [
      "surprendre",
      0.01
    ],
    [
      "demonter",
      0.01
    ],
    [
      "demanteler",
      0.01
    ],
    [
      "coucher",
      0.01
    ],
    [
      "etendre",
      0.0075
    ],
    [
      "ebahir",
      0.0075
    ],
    [
      "transposer",
      0.0075
    ],
    [
      "tomber",
      0.0075
    ],
    [
      "faucher",
      0.0075
    ],
    [
      "crouler",
      0.0075
    ],
    [
      "chambouler",
      0.0075
    ],
    [
      "transformer",
      0.005
    ],
    [
      "saper",
      0.005
    ],
    [
      "saccager",
      0.005
    ],
    [
      "repandre",
      0.005
    ],
    [
      "inverser",
      0.005
    ],
    [
      "intervertir",
      0.005
    ],
    [
      "broyer",
      0.005
    ],
    [
      "basculer",
      0.005
    ],
    [
      "envoyer",
      0.0025
    ],
    [
      "incliner",
      0.0025
    ],
    [
      "invertir",
      0.0025
    ],
    [
      "pencher",
      0.0025
    ],
    [
      "souffler",
      0.0025
    ],
    [
      "subvertir",
      0.0025
    ],
    [
      "detroner",
      0.0025
    ],
    [
      "desarconner",
      0.0025
    ],
    [
      "accrocher",
      0.0025
    ],
    [
      "asseoir",
      0.0025
    ],
    [
      "cabaner",
      0.0025
    ],
    [
      "chahuter",
      0.0025
    ],
    [
      "colleter",
      0.0025
    ],
    [
      "cuire",
      0.0025
    ],
    [
      "deborder",
      0.0025
    ],
    [
      "deboulonner",
      0.0025
    ],
    [
      "surmonter",
      0.0025
    ]
  ],
  "bureau": [
    [
      "cabinet",
      0.09
    ],
    [
      "service",
      0.09
    ],
    [
      "administration",
      0.0625
    ],
    [
      "boite",
      0.0625
    ],
    [
      "guichet",
      0.05
    ],
    [
      "office",
      0.0375
    ],
    [
      "conseil",
      0.0375
    ],
    [
      "comptoir",
      0.0375
    ],
    [
      "caisse",
      0.0375
    ],
    [
      "agence",
      0.0375
    ],
    [
      "etude",
      0.0225
    ],
    [
      "table",
      0.0225
    ],
    [
      "succursale",
      0.0225
    ],
    [
      "secretariat",
      0.0225
    ],
    [
      "secretaire",
      0.0225
    ],
    [
      "piece",
      0.0225
    ],
    [
      "organisme",
      0.0225
    ],
    [
      "officine",
      0.0225
    ],
    [
      "classeur",
      0.0225
    ],
    [
      "bibliotheque",
      0.0225
    ],
    [
      "affaire",
      0.0225
    ],
    [
      "commission",
      0.01
    ],
    [
      "direction",
      0.01
    ],
    [
      "directoire",
      0.01
    ],
    [
      "fichier",
      0.01
    ],
    [
      "permanence",
      0.01
    ],
    [
      "pupitre",
      0.01
    ],
    [
      "comite",
      0.01
    ],
    [
      "college",
      0.01
    ],
    [
      "chancellerie",
      0.01
    ],
    [
      "cartonnier",
      0.01
    ],
    [
      "burlingue",
      0.01
    ],
    [
      "bure",
      0.01
    ],
    [
      "boudoir",
      0.01
    ],
    [
      "assemblee",
      0.01
    ],
    [
      "armoire",
      0.01
    ],
    [
      "ecritoire",
      0.01
    ]
  ],
  "supprimer": [
    [
      "detruire",
      0.0775
    ],
    [
      "oter",
      0.055
    ],
    [
      "aneantir",
      0.05
    ],
    [
      "retrancher",
      0.0475
    ],
    [
      "enlever",
      0.0425
    ],
    [
      "couper",
      0.0375
    ],
    [
      "effacer",
      0.035
    ],
    [
      "abolir",
      0.03
    ],
    [
      "eliminer",
      0.0275
    ],
    [
      "barrer",
      0.02
    ],
    [
      "rayer",
      0.02
    ],
    [
      "exclure",
      0.0175
    ],
    [
      "tuer",
      0.0175
    ],
    [
      "retirer",
      0.0175
    ],
    [
      "biffer",
      0.0175
    ],
    [
      "annuler",
      0.0175
    ],
    [
      "etouffer",
      0.015
    ],
    [
      "ecarter",
      0.015
    ],
    [
      "briser",
      0.015
    ],
    [
      "abattre",
      0.015
    ],
    [
      "arreter",
      0.015
    ],
    [
      "lever",
      0.015
    ],
    [
      "radier",
      0.0125
    ],
    [
      "liquider",
      0.0125
    ],
    [
      "demolir",
      0.0125
    ],
    [
      "dissiper",
      0.0125
    ],
    [
      "censurer",
      0.0125
    ],
    [
      "casser",
      0.0125
    ],
    [
      "balayer",
      0.0125
    ],
    [
      "empecher",
      0.01
    ],
    [
      "interdire",
      0.01
    ],
    [
      "resilier",
      0.0075
    ],
    [
      "bannir",
      0.0075
    ],
    [
      "eteindre",
      0.005
    ],
    [
      "suspendre",
      0.005
    ],
    [
      "paralyser",
      0.005
    ],
    [
      "executer",
      0.005
    ],
    [
      "extirper",
      0.005
    ],
    [
      "annihiler",
      0.005
    ],
    [
      "amputer",
      0.005
    ],
    [
      "elaguer",
      0.005
    ],
    [
      "gommer",
      0.005
    ],
    [
      "exterminer",
      0.005
    ],
    [
      "emporter",
      0.005
    ],
    [
      "deposer",
      0.005
    ],
    [
      "demanteler",
      0.005
    ],
    [
      "debarrasser",
      0.005
    ],
    [
      "abandonner",
      0.005
    ],
    [
      "eviter",
      0.0025
    ],
    [
      "etrangler",
      0.0025
    ],
    [
      "epurer",
      0.0025
    ],
    [
      "torpiller",
      0.0025
    ],
    [
      "tailler",
      0.0025
    ],
    [
      "saisir",
      0.0025
    ],
    [
      "escamoter",
      0.0025
    ],
    [
      "abroger",
      0.0025
    ],
    [
      "tronquer",
      0.0025
    ],
    [
      "priver",
      0.0025
    ],
    [
      "neantiser",
      0.0025
    ],
    [
      "gacher",
      0.0025
    ],
    [
      "expurger",
      0.0025
    ],
    [
      "congedier",
      0.0025
    ],
    [
      "caviarder",
      0.0025
    ],
    [
      "assassiner",
      0.0025
    ],
    [
      "absorber",
      0.0025
    ],
    [
      "emonder",
      0.0
    ],
    [
      "taire",
      0.0
    ],
    [
      "resequer",
      0.0
    ],
    [
      "invalider",
      0.0
    ],
    [
      "inhiber",
      0.0
    ],
    [
      "desagreger",
      0.0
    ],
    [
      "deleaturer",
      0.0
    ],
    [
      "aplanir",
      0.0
    ],
    [
      "eradiquer",
      0.0
    ]
  ],
  "chomeur": [
    [
      "inactif",
      0.285
    ],
    [
      "desoccupe",
      0.1425
    ]
  ],
  "improductif": [
    [
      "sterile",
      0.225
    ],
    [
      "aride",
      0.09
    ],
    [
      "inutile",
      0.09
    ],
    [
      "pauvre",
      0.09
    ],
    [
      "infertile",
      0.0675
    ],
    [
      "infecond",
      0.0675
    ],
    [
      "maigre",
      0.0675
    ],
    [
      "vide",
      0.045
    ],
    [
      "sec",
      0.045
    ],
    [
      "ingrat",
      0.045
    ],
    [
      "inefficace",
      0.045
    ],
    [
      "impuissant",
      0.045
    ],
    [
      "croupissant",
      0.0225
    ],
    [
      "inerte",
      0.0225
    ],
    [
      "negatif",
      0.0225
    ]
  ],
  "taxe": [
    [
      "imputer",
      0.1875
    ],
    [
      "accuser",
      0.1225
    ],
    [
      "charger",
      0.1225
    ],
    [
      "tarifier",
      0.06
    ],
    [
      "tarifer",
      0.06
    ],
    [
      "reprocher",
      0.06
    ],
    [
      "imposer",
      0.06
    ],
    [
      "estimer",
      0.06
    ],
    [
      "dimer",
      0.06
    ],
    [
      "denommer",
      0.06
    ],
    [
      "affranchir",
      0.06
    ],
    [
      "traiter",
      0.06
    ]
  ],
  "taxer": [
    [
      "imputer",
      0.1875
    ],
    [
      "accuser",
      0.1225
    ],
    [
      "charger",
      0.1225
    ],
    [
      "tarifier",
      0.06
    ],
    [
      "tarifer",
      0.06
    ],
    [
      "reprocher",
      0.06
    ],
    [
      "imposer",
      0.06
    ],
    [
      "estimer",
      0.06
    ],
    [
      "dimer",
      0.06
    ],
    [
      "denommer",
      0.06
    ],
    [
      "affranchir",
      0.06
    ],
    [
      "traiter",
      0.06
    ]
  ],
  "outrance": [
    [
      "exces",
      0.25
    ],
    [
      "exageration",
      0.1925
    ],
    [
      "demesure",
      0.1375
    ],
    [
      "violence",
      0.055
    ],
    [
      "trop",
      0.055
    ],
    [
      "intemperance",
      0.055
    ],
    [
      "emphase",
      0.055
    ],
    [
      "abus",
      0.055
    ],
    [
      "amplification",
      0.0275
    ],
    [
      "exorbitance",
      0.0275
    ],
    [
      "extravagance",
      0.0275
    ],
    [
      "exuberance",
      0.0275
    ],
    [
      "hypertrophie",
      0.0275
    ]
  ],
  "atterrissage": [
    [
      "alunissage",
      0.3325
    ],
    [
      "appontage",
      0.3325
    ],
    [
      "atterrage",
      0.3325
    ]
  ],
  "hyper": [],
  "arracher": [
    [
      "enlever",
      0.0975
    ],
    [
      "oter",
      0.055
    ],
    [
      "retirer",
      0.0475
    ],
    [
      "prendre",
      0.04
    ],
    [
      "separer",
      0.0325
    ],
    [
      "detacher",
      0.0325
    ],
    [
      "deraciner",
      0.0325
    ],
    [
      "couper",
      0.0325
    ],
    [
      "extirper",
      0.0275
    ],
    [
      "extraire",
      0.0275
    ],
    [
      "tirer",
      0.0275
    ],
    [
      "eloigner",
      0.025
    ],
    [
      "soustraire",
      0.025
    ],
    [
      "obtenir",
      0.025
    ],
    [
      "depouiller",
      0.025
    ],
    [
      "chasser",
      0.025
    ],
    [
      "ecarter",
      0.02
    ],
    [
      "soutirer",
      0.02
    ],
    [
      "emporter",
      0.02
    ],
    [
      "detourner",
      0.02
    ],
    [
      "debarrasser",
      0.02
    ],
    [
      "dechirer",
      0.0175
    ],
    [
      "sortir",
      0.0125
    ],
    [
      "sarcler",
      0.0125
    ],
    [
      "rompre",
      0.0125
    ],
    [
      "nettoyer",
      0.0125
    ],
    [
      "forcer",
      0.0125
    ],
    [
      "extorquer",
      0.0125
    ],
    [
      "decouvrir",
      0.0125
    ],
    [
      "surprendre",
      0.01
    ],
    [
      "preserver",
      0.01
    ],
    [
      "exiler",
      0.01
    ],
    [
      "bannir",
      0.01
    ],
    [
      "ecorcher",
      0.005
    ],
    [
      "sauver",
      0.005
    ],
    [
      "remporter",
      0.005
    ],
    [
      "ravir",
      0.005
    ],
    [
      "plumer",
      0.005
    ],
    [
      "expulser",
      0.005
    ],
    [
      "essarter",
      0.005
    ],
    [
      "effeuiller",
      0.005
    ],
    [
      "chaumer",
      0.005
    ],
    [
      "demunir",
      0.005
    ],
    [
      "desoler",
      0.005
    ],
    [
      "deterrer",
      0.005
    ],
    [
      "devoiler",
      0.005
    ],
    [
      "epiler",
      0.0025
    ],
    [
      "recolter",
      0.0025
    ],
    [
      "lacerer",
      0.0025
    ],
    [
      "essoucher",
      0.0025
    ],
    [
      "desesperer",
      0.0025
    ],
    [
      "deplanter",
      0.0025
    ],
    [
      "depiler",
      0.0025
    ],
    [
      "demasquer",
      0.0025
    ],
    [
      "defricher",
      0.0025
    ],
    [
      "dechaumer",
      0.0025
    ],
    [
      "debroussailler",
      0.0025
    ],
    [
      "etraper",
      0.0025
    ]
  ],
  "pieger": [
    [
      "traquer",
      1.0
    ]
  ],
  "piege": [
    [
      "artifice",
      0.0575
    ],
    [
      "embuche",
      0.0575
    ],
    [
      "filet",
      0.0575
    ],
    [
      "leurre",
      0.0575
    ],
    [
      "traquenard",
      0.0575
    ],
    [
      "ruse",
      0.05
    ],
    [
      "truc",
      0.0425
    ],
    [
      "astuce",
      0.0375
    ],
    [
      "embuscade",
      0.03
    ],
    [
      "guepier",
      0.03
    ],
    [
      "souriciere",
      0.03
    ],
    [
      "appat",
      0.025
    ],
    [
      "appeau",
      0.025
    ],
    [
      "rets",
      0.0175
    ],
    [
      "pipeau",
      0.0175
    ],
    [
      "nasse",
      0.0175
    ],
    [
      "lacs",
      0.0175
    ],
    [
      "feinte",
      0.0175
    ],
    [
      "danger",
      0.0175
    ],
    [
      "ecueil",
      0.01
    ],
    [
      "reseau",
      0.01
    ],
    [
      "piperie",
      0.01
    ],
    [
      "lacet",
      0.01
    ],
    [
      "hamecon",
      0.01
    ],
    [
      "duperie",
      0.01
    ],
    [
      "complication",
      0.01
    ],
    [
      "attrape",
      0.01
    ],
    [
      "amorce",
      0.01
    ],
    [
      "panneau",
      0.005
    ],
    [
      "mesangette",
      0.005
    ],
    [
      "moyen",
      0.005
    ],
    [
      "moquette",
      0.005
    ],
    [
      "petrin",
      0.005
    ],
    [
      "ratiere",
      0.005
    ],
    [
      "reginglette",
      0.005
    ],
    [
      "surprise",
      0.005
    ],
    [
      "taupiere",
      0.005
    ],
    [
      "trame",
      0.005
    ],
    [
      "trappe",
      0.005
    ],
    [
      "traquet",
      0.005
    ],
    [
      "mine",
      0.005
    ],
    [
      "arbalete",
      0.005
    ],
    [
      "attrapoire",
      0.005
    ],
    [
      "bourbier",
      0.005
    ],
    [
      "cercle",
      0.005
    ],
    [
      "chatiere",
      0.005
    ],
    [
      "collet",
      0.005
    ],
    [
      "dardiere",
      0.005
    ],
    [
      "galere",
      0.005
    ],
    [
      "glu",
      0.005
    ],
    [
      "gluau",
      0.005
    ],
    [
      "hallier",
      0.005
    ],
    [
      "machine",
      0.005
    ],
    [
      "trebuchet",
      0.005
    ]
  ],
  "grille": [
    [
      "cloture",
      0.19
    ],
    [
      "claie",
      0.115
    ],
    [
      "fermeture",
      0.115
    ],
    [
      "grillage",
      0.115
    ],
    [
      "barriere",
      0.075
    ],
    [
      "herse",
      0.0375
    ],
    [
      "entree",
      0.0375
    ],
    [
      "crible",
      0.0375
    ],
    [
      "coulisse",
      0.0375
    ],
    [
      "chiffre",
      0.0375
    ],
    [
      "barreaux",
      0.0375
    ],
    [
      "protection",
      0.0375
    ]
  ],
  "griller": [
    [
      "bruler",
      0.1675
    ],
    [
      "rotir",
      0.11
    ],
    [
      "cuire",
      0.0825
    ],
    [
      "dessecher",
      0.055
    ],
    [
      "passer",
      0.055
    ],
    [
      "gratter",
      0.04
    ],
    [
      "calciner",
      0.04
    ],
    [
      "fricasser",
      0.0275
    ],
    [
      "flamber",
      0.0275
    ],
    [
      "depasser",
      0.0275
    ],
    [
      "devancer",
      0.0275
    ],
    [
      "cramer",
      0.0275
    ],
    [
      "chauffer",
      0.0275
    ],
    [
      "bronzer",
      0.0275
    ],
    [
      "gazer",
      0.0125
    ],
    [
      "geler",
      0.0125
    ],
    [
      "grillager",
      0.0125
    ],
    [
      "racornir",
      0.0125
    ],
    [
      "rissoler",
      0.0125
    ],
    [
      "roussir",
      0.0125
    ],
    [
      "roustir",
      0.0125
    ],
    [
      "fumer",
      0.0125
    ],
    [
      "fricoter",
      0.0125
    ],
    [
      "enfoncer",
      0.0125
    ],
    [
      "enflammer",
      0.0125
    ],
    [
      "desirer",
      0.0125
    ],
    [
      "denoncer",
      0.0125
    ],
    [
      "doubler",
      0.0125
    ],
    [
      "discrediter",
      0.0125
    ],
    [
      "brouir",
      0.0125
    ],
    [
      "brasiller",
      0.0125
    ],
    [
      "torrefier",
      0.0125
    ]
  ],
  "statique": [
    [
      "immobile",
      0.25
    ],
    [
      "physique",
      0.25
    ],
    [
      "stable",
      0.25
    ],
    [
      "stationnaire",
      0.25
    ]
  ],
  "astiquer": [
    [
      "frotter",
      0.1875
    ],
    [
      "polir",
      0.11
    ],
    [
      "lustrer",
      0.0925
    ],
    [
      "nettoyer",
      0.0925
    ],
    [
      "faire",
      0.0625
    ],
    [
      "fourbir",
      0.0625
    ],
    [
      "recurer",
      0.045
    ],
    [
      "cirer",
      0.045
    ],
    [
      "briquer",
      0.045
    ],
    [
      "battre",
      0.045
    ],
    [
      "brillanter",
      0.03
    ],
    [
      "poncer",
      0.015
    ],
    [
      "pomponner",
      0.015
    ],
    [
      "peaufiner",
      0.015
    ],
    [
      "froisser",
      0.015
    ],
    [
      "frictionner",
      0.015
    ],
    [
      "avoiner",
      0.015
    ],
    [
      "poutser",
      0.015
    ]
  ],
  "pomper": [
    [
      "boire",
      0.125
    ],
    [
      "absorber",
      0.0825
    ],
    [
      "s'abreuver",
      0.07
    ],
    [
      "vider",
      0.07
    ],
    [
      "epuiser",
      0.07
    ],
    [
      "pinter",
      0.055
    ],
    [
      "sucer",
      0.055
    ],
    [
      "ereinter",
      0.04
    ],
    [
      "ingurgiter",
      0.04
    ],
    [
      "attirer",
      0.04
    ],
    [
      "aspirer",
      0.04
    ],
    [
      "vanner",
      0.0275
    ],
    [
      "tirer",
      0.0275
    ],
    [
      "s'imbiber",
      0.0275
    ],
    [
      "picoler",
      0.0275
    ],
    [
      "extenuer",
      0.0275
    ],
    [
      "claquer",
      0.0275
    ],
    [
      "aneantir",
      0.0275
    ],
    [
      "puiser",
      0.0125
    ],
    [
      "gobeloter",
      0.0125
    ],
    [
      "crever",
      0.0125
    ],
    [
      "copier",
      0.0125
    ],
    [
      "capter",
      0.0125
    ],
    [
      "assecher",
      0.0125
    ],
    [
      "ecluser",
      0.0125
    ]
  ],
  "pompe": [
    [
      "emphase",
      0.08
    ],
    [
      "eclat",
      0.08
    ],
    [
      "majeste",
      0.0675
    ],
    [
      "solennite",
      0.0675
    ],
    [
      "apparat",
      0.0525
    ],
    [
      "appareil",
      0.0525
    ],
    [
      "somptuosite",
      0.0525
    ],
    [
      "magnificence",
      0.04
    ],
    [
      "grandiloquence",
      0.04
    ],
    [
      "grandeur",
      0.04
    ],
    [
      "ceremonie",
      0.04
    ],
    [
      "vanite",
      0.025
    ],
    [
      "splendeur",
      0.025
    ],
    [
      "richesse",
      0.025
    ],
    [
      "gravite",
      0.025
    ],
    [
      "faste",
      0.025
    ],
    [
      "bouffissure",
      0.025
    ],
    [
      "affectation",
      0.025
    ],
    [
      "soulier",
      0.0125
    ],
    [
      "rhetorique",
      0.0125
    ],
    [
      "peniche",
      0.0125
    ],
    [
      "phraseologie",
      0.0125
    ],
    [
      "luxe",
      0.0125
    ],
    [
      "godillot",
      0.0125
    ],
    [
      "fumee",
      0.0125
    ],
    [
      "fanfare",
      0.0125
    ],
    [
      "chaussure",
      0.0125
    ],
    [
      "accompagnement",
      0.0125
    ],
    [
      "traction",
      0.0125
    ]
  ],
  "snipe": [],
  "toilette": [
    [
      "ajustement",
      0.0975
    ],
    [
      "tenue",
      0.0975
    ],
    [
      "habillement",
      0.0725
    ],
    [
      "mise",
      0.0725
    ],
    [
      "proprete",
      0.0725
    ],
    [
      "vetements",
      0.0725
    ],
    [
      "parure",
      0.0475
    ],
    [
      "nettoyage",
      0.0475
    ],
    [
      "costume",
      0.0475
    ],
    [
      "ablution",
      0.0475
    ],
    [
      "toilettage",
      0.0225
    ],
    [
      "tailleur",
      0.0225
    ],
    [
      "soin",
      0.0225
    ],
    [
      "robe",
      0.0225
    ],
    [
      "poudreuse",
      0.0225
    ],
    [
      "mode",
      0.0225
    ],
    [
      "lavabo",
      0.0225
    ],
    [
      "coiffeuse",
      0.0225
    ],
    [
      "chiffon",
      0.0225
    ],
    [
      "bain",
      0.0225
    ],
    [
      "astiquage",
      0.0225
    ],
    [
      "apprets",
      0.0225
    ],
    [
      "trousseau",
      0.0225
    ]
  ],
  "desagreable": [
    [
      "ennuyeux",
      0.055
    ],
    [
      "deplaisant",
      0.0525
    ],
    [
      "degoutant",
      0.04
    ],
    [
      "mauvais",
      0.0375
    ],
    [
      "repugnant",
      0.0325
    ],
    [
      "penible",
      0.03
    ],
    [
      "amer",
      0.0275
    ],
    [
      "insupportable",
      0.0275
    ],
    [
      "odieux",
      0.0225
    ],
    [
      "blessant",
      0.0225
    ],
    [
      "aigre",
      0.0225
    ],
    [
      "affreux",
      0.02
    ],
    [
      "facheux",
      0.02
    ],
    [
      "reveche",
      0.02
    ],
    [
      "importun",
      0.0175
    ],
    [
      "fastidieux",
      0.0175
    ],
    [
      "mechant",
      0.0175
    ],
    [
      "rebutant",
      0.0175
    ],
    [
      "acariatre",
      0.015
    ],
    [
      "hargneux",
      0.015
    ],
    [
      "rude",
      0.015
    ],
    [
      "malplaisant",
      0.015
    ],
    [
      "bourru",
      0.015
    ],
    [
      "grossier",
      0.0125
    ],
    [
      "laid",
      0.0125
    ],
    [
      "agacant",
      0.0125
    ],
    [
      "detestable",
      0.0125
    ],
    [
      "nauseabond",
      0.0125
    ],
    [
      "ecoeurant",
      0.01
    ],
    [
      "apre",
      0.01
    ],
    [
      "intolerable",
      0.01
    ],
    [
      "disgracieux",
      0.01
    ],
    [
      "sempiternel",
      0.0075
    ],
    [
      "sec",
      0.0075
    ],
    [
      "sale",
      0.0075
    ],
    [
      "malheureux",
      0.0075
    ],
    [
      "fatigant",
      0.0075
    ],
    [
      "contrariant",
      0.0075
    ],
    [
      "antipathique",
      0.0075
    ],
    [
      "acerbe",
      0.0075
    ],
    [
      "vilain",
      0.0075
    ],
    [
      "repoussant",
      0.0075
    ],
    [
      "ingrat",
      0.0075
    ],
    [
      "haissable",
      0.0075
    ],
    [
      "genant",
      0.0075
    ],
    [
      "embetant",
      0.0075
    ],
    [
      "enervant",
      0.005
    ],
    [
      "acre",
      0.005
    ],
    [
      "vexant",
      0.005
    ],
    [
      "saumatre",
      0.005
    ],
    [
      "offensant",
      0.005
    ],
    [
      "pesant",
      0.005
    ],
    [
      "obscene",
      0.005
    ],
    [
      "maussade",
      0.005
    ],
    [
      "irritant",
      0.005
    ],
    [
      "fetide",
      0.005
    ],
    [
      "fade",
      0.005
    ],
    [
      "desobligeant",
      0.005
    ],
    [
      "choquant",
      0.005
    ],
    [
      "regrettable",
      0.0025
    ],
    [
      "maudit",
      0.0025
    ],
    [
      "malencontreux",
      0.0025
    ],
    [
      "intraitable",
      0.0025
    ],
    [
      "inhospitalier",
      0.0025
    ],
    [
      "impoli",
      0.0025
    ],
    [
      "hostile",
      0.0025
    ],
    [
      "emmerdant",
      0.0025
    ],
    [
      "douloureux",
      0.0025
    ],
    [
      "criard",
      0.0025
    ],
    [
      "moche",
      0.0025
    ],
    [
      "insipide",
      0.0025
    ],
    [
      "inamical",
      0.0025
    ],
    [
      "desastreux",
      0.0025
    ],
    [
      "brusque",
      0.0025
    ],
    [
      "atrabilaire",
      0.0025
    ],
    [
      "acide",
      0.0025
    ],
    [
      "putride",
      0.0
    ],
    [
      "puant",
      0.0
    ],
    [
      "nauseeux",
      0.0
    ],
    [
      "mesavenant",
      0.0
    ],
    [
      "insolent",
      0.0
    ],
    [
      "incommodant",
      0.0
    ],
    [
      "impopulaire",
      0.0
    ],
    [
      "grimacant",
      0.0
    ],
    [
      "ennuyant",
      0.0
    ],
    [
      "discordant",
      0.0
    ],
    [
      "contraignant",
      0.0
    ],
    [
      "refrigerant",
      0.0
    ]
  ],
  "adverse": [
    [
      "oppose",
      0.25
    ],
    [
      "contraire",
      0.1875
    ],
    [
      "defavorable",
      0.125
    ],
    [
      "ennemi",
      0.125
    ],
    [
      "hostile",
      0.125
    ],
    [
      "adversaire",
      0.0625
    ],
    [
      "antagonique",
      0.0625
    ],
    [
      "discordant",
      0.0625
    ]
  ],
  "puissance": [
    [
      "pouvoir",
      0.1125
    ],
    [
      "force",
      0.09
    ],
    [
      "autorite",
      0.08
    ],
    [
      "domination",
      0.035
    ],
    [
      "empire",
      0.035
    ],
    [
      "vigueur",
      0.03
    ],
    [
      "influence",
      0.0275
    ],
    [
      "vertu",
      0.0275
    ],
    [
      "grandeur",
      0.025
    ],
    [
      "capacite",
      0.02
    ],
    [
      "faculte",
      0.02
    ],
    [
      "profondeur",
      0.02
    ],
    [
      "souverainete",
      0.02
    ],
    [
      "etat",
      0.02
    ],
    [
      "violence",
      0.0175
    ],
    [
      "qualite",
      0.0175
    ],
    [
      "omnipotence",
      0.0175
    ],
    [
      "efficacite",
      0.0175
    ],
    [
      "despotisme",
      0.0175
    ],
    [
      "energie",
      0.0125
    ],
    [
      "prepotence",
      0.0125
    ],
    [
      "grand",
      0.0125
    ],
    [
      "droit",
      0.0125
    ],
    [
      "dimension",
      0.0125
    ],
    [
      "credit",
      0.0125
    ],
    [
      "propriete",
      0.01
    ],
    [
      "possibilite",
      0.01
    ],
    [
      "loi",
      0.01
    ],
    [
      "intensite",
      0.01
    ],
    [
      "importance",
      0.01
    ],
    [
      "gouvernement",
      0.01
    ],
    [
      "bras",
      0.01
    ],
    [
      "ascendant",
      0.01
    ],
    [
      "ange",
      0.01
    ],
    [
      "volume",
      0.005
    ],
    [
      "usage",
      0.005
    ],
    [
      "trone",
      0.005
    ],
    [
      "seve",
      0.005
    ],
    [
      "reserve",
      0.005
    ],
    [
      "preponderance",
      0.005
    ],
    [
      "potentiel",
      0.005
    ],
    [
      "pays",
      0.005
    ],
    [
      "commandement",
      0.005
    ],
    [
      "biceps",
      0.005
    ],
    [
      "nerf",
      0.0025
    ],
    [
      "pesanteur",
      0.0025
    ],
    [
      "potentat",
      0.0025
    ],
    [
      "puissant",
      0.0025
    ],
    [
      "robustesse",
      0.0025
    ],
    [
      "torrent",
      0.0025
    ],
    [
      "virilite",
      0.0025
    ],
    [
      "nation",
      0.0025
    ],
    [
      "magnat",
      0.0025
    ],
    [
      "magie",
      0.0025
    ],
    [
      "aleph",
      0.0025
    ],
    [
      "art",
      0.0025
    ],
    [
      "couronne",
      0.0025
    ],
    [
      "dependance",
      0.0025
    ],
    [
      "entrainement",
      0.0025
    ],
    [
      "exposant",
      0.0025
    ],
    [
      "immensite",
      0.0025
    ],
    [
      "imperialisme",
      0.0025
    ],
    [
      "etoile",
      0.0025
    ]
  ],
  "forain": [
    [
      "camelot",
      0.2875
    ],
    [
      "saltimbanque",
      0.1425
    ],
    [
      "etalagiste",
      0.07
    ],
    [
      "nomade",
      0.07
    ],
    [
      "bonisseur",
      0.07
    ],
    [
      "bateleur",
      0.07
    ],
    [
      "etaleur",
      0.07
    ]
  ],
  "charisme": [
    [
      "autorite",
      0.3325
    ],
    [
      "charismatisme",
      0.3325
    ],
    [
      "don",
      0.3325
    ]
  ],
  "vilain": [
    [
      "mauvais",
      0.1175
    ],
    [
      "laid",
      0.1
    ],
    [
      "affreux",
      0.0675
    ],
    [
      "sale",
      0.0575
    ],
    [
      "desagreable",
      0.05
    ],
    [
      "grossier",
      0.05
    ],
    [
      "vil",
      0.04
    ],
    [
      "moche",
      0.0325
    ],
    [
      "infame",
      0.0325
    ],
    [
      "horrible",
      0.0325
    ],
    [
      "abject",
      0.0325
    ],
    [
      "detestable",
      0.0225
    ],
    [
      "malhonnete",
      0.0225
    ],
    [
      "mechant",
      0.0225
    ],
    [
      "meprisable",
      0.0225
    ],
    [
      "magot",
      0.015
    ],
    [
      "manant",
      0.015
    ],
    [
      "paysan",
      0.015
    ],
    [
      "pouacre",
      0.015
    ],
    [
      "tarte",
      0.015
    ],
    [
      "inelegant",
      0.015
    ],
    [
      "hideux",
      0.015
    ],
    [
      "avare",
      0.015
    ],
    [
      "corrompu",
      0.015
    ],
    [
      "deshonnete",
      0.015
    ],
    [
      "deshonorant",
      0.015
    ],
    [
      "facheux",
      0.015
    ],
    [
      "tocard",
      0.0075
    ],
    [
      "toc",
      0.0075
    ],
    [
      "roturier",
      0.0075
    ],
    [
      "malsain",
      0.0075
    ],
    [
      "macaque",
      0.0075
    ],
    [
      "inquietant",
      0.0075
    ],
    [
      "gros",
      0.0075
    ],
    [
      "foutu",
      0.0075
    ],
    [
      "chiche",
      0.0075
    ],
    [
      "traitre",
      0.0075
    ]
  ],
  "meprisant": [
    [
      "arrogant",
      0.1325
    ],
    [
      "dedaigneux",
      0.1325
    ],
    [
      "fier",
      0.1
    ],
    [
      "hautain",
      0.1
    ],
    [
      "orgueilleux",
      0.1
    ],
    [
      "rogue",
      0.065
    ],
    [
      "rencheri",
      0.065
    ],
    [
      "contempteur",
      0.065
    ],
    [
      "becheur",
      0.0325
    ],
    [
      "condescendant",
      0.0325
    ],
    [
      "denigreur",
      0.0325
    ],
    [
      "derisoire",
      0.0325
    ],
    [
      "detracteur",
      0.0325
    ],
    [
      "fat",
      0.0325
    ],
    [
      "ricaneur",
      0.0325
    ]
  ],
  "composant": [
    [
      "unite",
      0.25
    ],
    [
      "composante",
      0.125
    ],
    [
      "compose",
      0.125
    ],
    [
      "constituant",
      0.125
    ],
    [
      "corps",
      0.125
    ],
    [
      "terme",
      0.125
    ],
    [
      "element",
      0.125
    ]
  ],
  "lentement": [
    [
      "doucement",
      0.2375
    ],
    [
      "mollement",
      0.0875
    ],
    [
      "tranquillement",
      0.0575
    ],
    [
      "progressivement",
      0.0575
    ],
    [
      "posement",
      0.0575
    ],
    [
      "piano",
      0.0575
    ],
    [
      "pianissimo",
      0.0575
    ],
    [
      "insensiblement",
      0.0575
    ],
    [
      "precautionneusement",
      0.0275
    ],
    [
      "nonchalamment",
      0.0275
    ],
    [
      "mollo",
      0.0275
    ],
    [
      "lourdement",
      0.0275
    ],
    [
      "longtemps",
      0.0275
    ],
    [
      "doucettement",
      0.0275
    ]
  ],
  "epuisant": [
    [
      "fatigant",
      0.145
    ],
    [
      "ereintant",
      0.12
    ],
    [
      "extenuant",
      0.1075
    ],
    [
      "tuant",
      0.1075
    ],
    [
      "harassant",
      0.07
    ],
    [
      "penible",
      0.07
    ],
    [
      "accablant",
      0.06
    ],
    [
      "rude",
      0.035
    ],
    [
      "crevant",
      0.035
    ],
    [
      "brisant",
      0.035
    ],
    [
      "affaiblissant",
      0.035
    ],
    [
      "eprouvant",
      0.0225
    ],
    [
      "terrassant",
      0.0225
    ],
    [
      "exhaustif",
      0.0225
    ],
    [
      "esquintant",
      0.0225
    ],
    [
      "anemiant",
      0.0225
    ],
    [
      "debilitant",
      0.01
    ],
    [
      "excedant",
      0.01
    ],
    [
      "lassant",
      0.01
    ],
    [
      "usant",
      0.01
    ]
  ],
  "tremplin": [
    [
      "moyen",
      0.3325
    ],
    [
      "marchepied",
      0.165
    ],
    [
      "plongeoir",
      0.165
    ],
    [
      "porte",
      0.165
    ]
  ],
  "eclate": [
    [
      "s'emporter",
      0.04
    ],
    [
      "paraitre",
      0.035
    ],
    [
      "rompre",
      0.035
    ],
    [
      "jaillir",
      0.0275
    ],
    [
      "sauter",
      0.0225
    ],
    [
      "s'ouvrir",
      0.0225
    ],
    [
      "resplendir",
      0.0225
    ],
    [
      "rayonner",
      0.0225
    ],
    [
      "petiller",
      0.0225
    ],
    [
      "peter",
      0.0225
    ],
    [
      "briller",
      0.0225
    ],
    [
      "exploser",
      0.0225
    ],
    [
      "fulminer",
      0.0225
    ],
    [
      "fuser",
      0.0225
    ],
    [
      "partir",
      0.0225
    ],
    [
      "tonner",
      0.0175
    ],
    [
      "s'etaler",
      0.0175
    ],
    [
      "s'irriter",
      0.0175
    ],
    [
      "luire",
      0.0175
    ],
    [
      "flamboyer",
      0.0175
    ],
    [
      "deborder",
      0.0175
    ],
    [
      "crier",
      0.0175
    ],
    [
      "rire",
      0.01
    ],
    [
      "reluire",
      0.01
    ],
    [
      "fulgurer",
      0.01
    ],
    [
      "crever",
      0.01
    ],
    [
      "commencer",
      0.01
    ],
    [
      "s'eveiller",
      0.005
    ],
    [
      "s'esclaffer",
      0.005
    ],
    [
      "s'encolerer",
      0.005
    ],
    [
      "s'emballer",
      0.005
    ],
    [
      "rutiler",
      0.005
    ],
    [
      "retentir",
      0.005
    ],
    [
      "pouffer",
      0.005
    ],
    [
      "debonder",
      0.005
    ],
    [
      "crepiter",
      0.005
    ],
    [
      "casser",
      0.005
    ]
  ],
  "enclin": [
    [
      "porte",
      0.3
    ],
    [
      "dispose",
      0.2
    ],
    [
      "sujet",
      0.2
    ],
    [
      "d'humeur",
      0.1
    ],
    [
      "incline",
      0.1
    ],
    [
      "predispose",
      0.1
    ]
  ],
  "transpirer": [
    [
      "suinter",
      0.1325
    ],
    [
      "couler",
      0.0875
    ],
    [
      "percer",
      0.0775
    ],
    [
      "suer",
      0.0775
    ],
    [
      "sourdre",
      0.0425
    ],
    [
      "ruisseler",
      0.0425
    ],
    [
      "filtrer",
      0.0425
    ],
    [
      "degouliner",
      0.0325
    ],
    [
      "exsuder",
      0.0325
    ],
    [
      "perler",
      0.0325
    ],
    [
      "emaner",
      0.0325
    ],
    [
      "transsuder",
      0.02
    ],
    [
      "secreter",
      0.02
    ],
    [
      "paraitre",
      0.02
    ],
    [
      "goutter",
      0.02
    ],
    [
      "s'eventer",
      0.01
    ],
    [
      "s'echapper",
      0.01
    ],
    [
      "s'ebruiter",
      0.01
    ],
    [
      "s'exhaler",
      0.01
    ],
    [
      "moitir",
      0.01
    ],
    [
      "exhaler",
      0.01
    ]
  ],
  "camp": [
    [
      "campement",
      0.09
    ],
    [
      "clan",
      0.0725
    ],
    [
      "groupe",
      0.0725
    ],
    [
      "troupe",
      0.0525
    ],
    [
      "parti",
      0.0525
    ],
    [
      "coterie",
      0.0525
    ],
    [
      "cantonnement",
      0.0525
    ],
    [
      "agglomeration",
      0.0525
    ],
    [
      "colonie",
      0.035
    ],
    [
      "secte",
      0.035
    ],
    [
      "faction",
      0.0175
    ],
    [
      "goulag",
      0.0175
    ],
    [
      "guerre",
      0.0175
    ],
    [
      "offlag",
      0.0175
    ],
    [
      "ost",
      0.0175
    ],
    [
      "pavillon",
      0.0175
    ],
    [
      "quartiers",
      0.0175
    ],
    [
      "stalag",
      0.0175
    ],
    [
      "terrain",
      0.0175
    ],
    [
      "villa",
      0.0175
    ],
    [
      "cote",
      0.0175
    ],
    [
      "champ",
      0.0175
    ],
    [
      "aerodrome",
      0.0175
    ],
    [
      "aeroport",
      0.0175
    ],
    [
      "baraquement",
      0.0175
    ],
    [
      "bidonville",
      0.0175
    ],
    [
      "bivouac",
      0.0175
    ],
    [
      "bohemien",
      0.0175
    ],
    [
      "camping",
      0.0175
    ],
    [
      "campee",
      0.0175
    ],
    [
      "castrametation",
      0.0175
    ],
    [
      "chalet",
      0.0175
    ],
    [
      "equipe",
      0.0175
    ]
  ],
  "kit": [
    [
      "coffret",
      0.5
    ],
    [
      "lot",
      0.5
    ]
  ],
  "lampadaire": [
    [
      "candelabre",
      0.25
    ],
    [
      "reverbere",
      0.25
    ],
    [
      "torchere",
      0.25
    ]
  ],
  "skin": [],
  "loupe": [
    [
      "broussin",
      0.1425
    ],
    [
      "faineantise",
      0.1425
    ],
    [
      "gemme",
      0.1425
    ],
    [
      "nodosite",
      0.1425
    ],
    [
      "steatome",
      0.1425
    ],
    [
      "talpa",
      0.1425
    ],
    [
      "tumeur",
      0.1425
    ]
  ],
  "louper": [
    [
      "rater",
      0.2375
    ],
    [
      "avorter",
      0.1175
    ],
    [
      "gacher",
      0.1175
    ],
    [
      "manquer",
      0.1175
    ],
    [
      "saboter",
      0.0575
    ],
    [
      "queuter",
      0.0575
    ],
    [
      "peter",
      0.0575
    ],
    [
      "paresser",
      0.0575
    ],
    [
      "foirer",
      0.0575
    ],
    [
      "bousiller",
      0.0575
    ],
    [
      "saloper",
      0.0575
    ]
  ],
  "carrement": [
    [
      "franchement",
      0.21
    ],
    [
      "directement",
      0.0775
    ],
    [
      "nettement",
      0.0775
    ],
    [
      "ouvertement",
      0.0775
    ],
    [
      "resolument",
      0.0775
    ],
    [
      "simplement",
      0.0775
    ],
    [
      "sincerement",
      0.0525
    ],
    [
      "fermement",
      0.0525
    ],
    [
      "categoriquement",
      0.025
    ],
    [
      "hardiment",
      0.025
    ],
    [
      "librement",
      0.025
    ],
    [
      "nument",
      0.025
    ],
    [
      "rondement",
      0.025
    ]
  ],
  "damoiseau": [
    [
      "adolescent",
      0.2
    ],
    [
      "freluquet",
      0.2
    ],
    [
      "galant",
      0.2
    ],
    [
      "dameret",
      0.1
    ],
    [
      "ephebe",
      0.1
    ]
  ],
  "do": [],
  "gave": [
    [
      "riviere",
      0.285
    ],
    [
      "rio",
      0.1425
    ],
    [
      "ruisseau",
      0.1425
    ],
    [
      "torrent",
      0.1425
    ]
  ],
  "gaver": [
    [
      "gorger",
      0.28
    ],
    [
      "rassasier",
      0.12
    ],
    [
      "bourrer",
      0.0775
    ],
    [
      "engraisser",
      0.0775
    ],
    [
      "nourrir",
      0.0775
    ],
    [
      "saturer",
      0.0775
    ],
    [
      "souler",
      0.0375
    ],
    [
      "impregner",
      0.0375
    ],
    [
      "entonner",
      0.0375
    ],
    [
      "empiffrer",
      0.0375
    ],
    [
      "embecquer",
      0.0375
    ],
    [
      "appater",
      0.0375
    ],
    [
      "surnourrir",
      0.0375
    ]
  ],
  "miss": [],
  "retirer": [
    [
      "enlever",
      0.135
    ],
    [
      "oter",
      0.1225
    ],
    [
      "tirer",
      0.0625
    ],
    [
      "prendre",
      0.06
    ],
    [
      "retrancher",
      0.055
    ],
    [
      "supprimer",
      0.0375
    ],
    [
      "debarrasser",
      0.0375
    ],
    [
      "arracher",
      0.0375
    ],
    [
      "sortir",
      0.025
    ],
    [
      "soustraire",
      0.025
    ],
    [
      "couper",
      0.02
    ],
    [
      "depouiller",
      0.02
    ],
    [
      "extraire",
      0.02
    ],
    [
      "eliminer",
      0.02
    ],
    [
      "gagner",
      0.015
    ],
    [
      "extirper",
      0.015
    ],
    [
      "recueillir",
      0.0125
    ],
    [
      "recevoir",
      0.01
    ],
    [
      "ravir",
      0.01
    ],
    [
      "priver",
      0.01
    ],
    [
      "obtenir",
      0.01
    ],
    [
      "degager",
      0.01
    ],
    [
      "barrer",
      0.01
    ],
    [
      "annuler",
      0.01
    ],
    [
      "eloigner",
      0.0075
    ],
    [
      "vider",
      0.0075
    ],
    [
      "soutirer",
      0.0075
    ],
    [
      "reprendre",
      0.0075
    ],
    [
      "percevoir",
      0.0075
    ],
    [
      "lever",
      0.0075
    ],
    [
      "derober",
      0.0075
    ],
    [
      "deposseder",
      0.0075
    ],
    [
      "destituer",
      0.0075
    ],
    [
      "censurer",
      0.0075
    ],
    [
      "amputer",
      0.0075
    ],
    [
      "recolter",
      0.005
    ],
    [
      "quitter",
      0.005
    ],
    [
      "limoger",
      0.005
    ],
    [
      "excepter",
      0.005
    ],
    [
      "emprunter",
      0.005
    ],
    [
      "deraciner",
      0.005
    ],
    [
      "deduire",
      0.005
    ],
    [
      "alleger",
      0.005
    ],
    [
      "retracter",
      0.0
    ],
    [
      "retraire",
      0.0
    ],
    [
      "ressembler",
      0.0
    ],
    [
      "remmener",
      0.0
    ],
    [
      "reculer",
      0.0
    ],
    [
      "ranger",
      0.0
    ],
    [
      "demettre",
      0.0
    ],
    [
      "dissoudre",
      0.0
    ],
    [
      "confisquer",
      0.0
    ],
    [
      "beneficier",
      0.0
    ],
    [
      "abriter",
      0.0
    ],
    [
      "toucher",
      0.0
    ]
  ],
  "pousse": [
    [
      "exciter",
      0.06
    ],
    [
      "entrainer",
      0.0425
    ],
    [
      "provoquer",
      0.04
    ],
    [
      "inciter",
      0.03
    ],
    [
      "engager",
      0.0275
    ],
    [
      "porter",
      0.0275
    ],
    [
      "determiner",
      0.0275
    ],
    [
      "conduire",
      0.0225
    ],
    [
      "augmenter",
      0.02
    ],
    [
      "animer",
      0.02
    ],
    [
      "encourager",
      0.0175
    ],
    [
      "soulever",
      0.0175
    ],
    [
      "inviter",
      0.0175
    ],
    [
      "presser",
      0.0175
    ],
    [
      "forcer",
      0.0125
    ],
    [
      "lancer",
      0.0125
    ],
    [
      "inspirer",
      0.0125
    ],
    [
      "exalter",
      0.0125
    ],
    [
      "enflammer",
      0.0125
    ],
    [
      "attirer",
      0.0125
    ],
    [
      "appeler",
      0.0125
    ],
    [
      "appuyer",
      0.0125
    ],
    [
      "aiguillonner",
      0.01
    ],
    [
      "stimuler",
      0.01
    ],
    [
      "faire",
      0.01
    ],
    [
      "grandir",
      0.01
    ],
    [
      "solliciter",
      0.01
    ],
    [
      "elever",
      0.0075
    ],
    [
      "exhorter",
      0.0075
    ],
    [
      "attiser",
      0.0075
    ],
    [
      "amener",
      0.0075
    ],
    [
      "jeter",
      0.0075
    ],
    [
      "repousser",
      0.0075
    ],
    [
      "souffler",
      0.0075
    ],
    [
      "sortir",
      0.005
    ],
    [
      "produire",
      0.005
    ],
    [
      "piquer",
      0.005
    ],
    [
      "persuader",
      0.005
    ],
    [
      "exagerer",
      0.005
    ],
    [
      "developper",
      0.005
    ],
    [
      "conseiller",
      0.005
    ],
    [
      "chasser",
      0.005
    ],
    [
      "incliner",
      0.005
    ],
    [
      "mener",
      0.005
    ],
    [
      "peser",
      0.005
    ],
    [
      "poursuivre",
      0.005
    ],
    [
      "rejeter",
      0.005
    ],
    [
      "diriger",
      0.005
    ],
    [
      "bousculer",
      0.005
    ],
    [
      "avancer",
      0.005
    ],
    [
      "allonger",
      0.005
    ],
    [
      "agir",
      0.005
    ],
    [
      "activer",
      0.005
    ],
    [
      "accelerer",
      0.005
    ],
    [
      "accroitre",
      0.005
    ],
    [
      "proferer",
      0.005
    ],
    [
      "promouvoir",
      0.005
    ],
    [
      "prononcer",
      0.005
    ],
    [
      "precipiter",
      0.005
    ],
    [
      "etendre",
      0.005
    ],
    [
      "ouvrir",
      0.005
    ],
    [
      "mouvoir",
      0.005
    ],
    [
      "aider",
      0.005
    ],
    [
      "aller",
      0.005
    ],
    [
      "attaquer",
      0.005
    ],
    [
      "croitre",
      0.005
    ],
    [
      "enfoncer",
      0.005
    ],
    [
      "eperonner",
      0.0025
    ],
    [
      "emettre",
      0.0025
    ],
    [
      "servir",
      0.0025
    ],
    [
      "proteger",
      0.0025
    ],
    [
      "emporter",
      0.0025
    ],
    [
      "brusquer",
      0.0025
    ],
    [
      "aviver",
      0.0025
    ],
    [
      "accentuer",
      0.0025
    ],
    [
      "oter",
      0.0025
    ],
    [
      "venir",
      0.0025
    ],
    [
      "remuer",
      0.0025
    ],
    [
      "poindre",
      0.0025
    ],
    [
      "harceler",
      0.0025
    ],
    [
      "favoriser",
      0.0025
    ],
    [
      "contraindre",
      0.0025
    ],
    [
      "profiter",
      0.0025
    ],
    [
      "projeter",
      0.0025
    ],
    [
      "prolonger",
      0.0025
    ],
    [
      "refouler",
      0.0025
    ],
    [
      "rencherir",
      0.0025
    ],
    [
      "renvoyer",
      0.0025
    ],
    [
      "epauler",
      0.0025
    ],
    [
      "pointer",
      0.0025
    ],
    [
      "pistonner",
      0.0025
    ],
    [
      "balayer",
      0.0025
    ],
    [
      "charrier",
      0.0025
    ],
    [
      "culbuter",
      0.0025
    ],
    [
      "decider",
      0.0025
    ],
    [
      "deplacer",
      0.0025
    ],
    [
      "introduire",
      0.0025
    ],
    [
      "lever",
      0.0025
    ],
    [
      "parrainer",
      0.0
    ],
    [
      "predisposer",
      0.0
    ],
    [
      "reculer",
      0.0
    ],
    [
      "rouler",
      0.0
    ],
    [
      "surfaire",
      0.0
    ],
    [
      "lacher",
      0.0
    ],
    [
      "heurter",
      0.0
    ],
    [
      "fouetter",
      0.0
    ],
    [
      "baisser",
      0.0
    ],
    [
      "bourrer",
      0.0
    ],
    [
      "continuer",
      0.0
    ],
    [
      "crier",
      0.0
    ],
    [
      "disposer",
      0.0
    ],
    [
      "embarquer",
      0.0
    ],
    [
      "exhaler",
      0.0
    ],
    [
      "recommander",
      0.0
    ],
    [
      "respirer",
      0.0
    ],
    [
      "reussir",
      0.0
    ],
    [
      "sourdre",
      0.0
    ],
    [
      "tenter",
      0.0
    ],
    [
      "vegeter",
      0.0
    ],
    [
      "eloigner",
      0.0
    ],
    [
      "propulser",
      0.0
    ],
    [
      "outrer",
      0.0
    ],
    [
      "instiguer",
      0.0
    ],
    [
      "abaisser",
      0.0
    ],
    [
      "acculer",
      0.0
    ],
    [
      "approfondir",
      0.0
    ],
    [
      "bouter",
      0.0
    ],
    [
      "deborder",
      0.0
    ],
    [
      "forcir",
      0.0
    ],
    [
      "induire",
      0.0
    ],
    [
      "prevenir",
      0.0
    ],
    [
      "expirer",
      0.0
    ],
    [
      "cherrer",
      0.0
    ],
    [
      "basculer",
      0.0
    ],
    [
      "attiger",
      0.0
    ],
    [
      "pulluler",
      0.0
    ]
  ],
  "prolonger": [
    [
      "allonger",
      0.2075
    ],
    [
      "continuer",
      0.085
    ],
    [
      "augmenter",
      0.0675
    ],
    [
      "pousser",
      0.0675
    ],
    [
      "proroger",
      0.0675
    ],
    [
      "eterniser",
      0.0675
    ],
    [
      "etendre",
      0.05
    ],
    [
      "perpetuer",
      0.05
    ],
    [
      "rallonger",
      0.0325
    ],
    [
      "poursuivre",
      0.0325
    ],
    [
      "developper",
      0.0325
    ],
    [
      "accroitre",
      0.0325
    ],
    [
      "entretenir",
      0.015
    ],
    [
      "longer",
      0.015
    ],
    [
      "retarder",
      0.015
    ],
    [
      "s'attarder",
      0.015
    ],
    [
      "temporiser",
      0.015
    ]
  ],
  "demolir": [
    [
      "detruire",
      0.0875
    ],
    [
      "abimer",
      0.0625
    ],
    [
      "demanteler",
      0.0625
    ],
    [
      "casser",
      0.055
    ],
    [
      "ruiner",
      0.055
    ],
    [
      "esquinter",
      0.05
    ],
    [
      "briser",
      0.0475
    ],
    [
      "aneantir",
      0.0375
    ],
    [
      "abattre",
      0.0375
    ],
    [
      "degrader",
      0.0325
    ],
    [
      "ereinter",
      0.0325
    ],
    [
      "detraquer",
      0.03
    ],
    [
      "deteriorer",
      0.0275
    ],
    [
      "tuer",
      0.0225
    ],
    [
      "defaire",
      0.0225
    ],
    [
      "bousiller",
      0.0175
    ],
    [
      "renverser",
      0.0175
    ],
    [
      "supprimer",
      0.0175
    ],
    [
      "epuiser",
      0.015
    ],
    [
      "saper",
      0.0125
    ],
    [
      "endommager",
      0.0125
    ],
    [
      "disloquer",
      0.0125
    ],
    [
      "battre",
      0.0125
    ],
    [
      "accidenter",
      0.01
    ],
    [
      "abolir",
      0.0075
    ],
    [
      "deglinguer",
      0.0075
    ],
    [
      "demantibuler",
      0.0075
    ],
    [
      "massacrer",
      0.0075
    ],
    [
      "demonter",
      0.0075
    ],
    [
      "delabrer",
      0.0075
    ],
    [
      "bigorner",
      0.0075
    ],
    [
      "torpiller",
      0.005
    ],
    [
      "perdre",
      0.005
    ],
    [
      "liquider",
      0.005
    ],
    [
      "executer",
      0.005
    ],
    [
      "demancher",
      0.005
    ],
    [
      "culbuter",
      0.005
    ],
    [
      "critiquer",
      0.005
    ],
    [
      "etriller",
      0.0025
    ],
    [
      "terrasser",
      0.0025
    ],
    [
      "rosser",
      0.0025
    ],
    [
      "raser",
      0.0025
    ],
    [
      "mordre",
      0.0025
    ],
    [
      "devaster",
      0.0025
    ],
    [
      "couler",
      0.0025
    ],
    [
      "discrediter",
      0.0025
    ],
    [
      "debatir",
      0.0025
    ],
    [
      "deconstruire",
      0.0025
    ],
    [
      "deranger",
      0.0025
    ],
    [
      "ecrabouiller",
      0.0
    ],
    [
      "ebranler",
      0.0
    ],
    [
      "refuter",
      0.0
    ],
    [
      "matraquer",
      0.0
    ],
    [
      "emboutir",
      0.0
    ],
    [
      "detracter",
      0.0
    ],
    [
      "depecer",
      0.0
    ],
    [
      "deboulonner",
      0.0
    ],
    [
      "eventrer",
      0.0
    ]
  ],
  "formidable": [
    [
      "extraordinaire",
      0.095
    ],
    [
      "etonnant",
      0.0775
    ],
    [
      "fantastique",
      0.075
    ],
    [
      "enorme",
      0.065
    ],
    [
      "prodigieux",
      0.055
    ],
    [
      "sensationnel",
      0.0425
    ],
    [
      "beau",
      0.0325
    ],
    [
      "fabuleux",
      0.03
    ],
    [
      "inoui",
      0.03
    ],
    [
      "colossal",
      0.0275
    ],
    [
      "imposant",
      0.0225
    ],
    [
      "gigantesque",
      0.0225
    ],
    [
      "stupefiant",
      0.02
    ],
    [
      "considerable",
      0.0175
    ],
    [
      "merveilleux",
      0.0175
    ],
    [
      "epatant",
      0.0175
    ],
    [
      "surprenant",
      0.015
    ],
    [
      "phenomenal",
      0.015
    ],
    [
      "immense",
      0.015
    ],
    [
      "gros",
      0.015
    ],
    [
      "monumental",
      0.015
    ],
    [
      "terrible",
      0.015
    ],
    [
      "faramineux",
      0.0125
    ],
    [
      "admirable",
      0.0125
    ],
    [
      "remarquable",
      0.0125
    ],
    [
      "monstrueux",
      0.0125
    ],
    [
      "impressionnant",
      0.0125
    ],
    [
      "demesure",
      0.0125
    ],
    [
      "invraisemblable",
      0.01
    ],
    [
      "bon",
      0.01
    ],
    [
      "fort",
      0.01
    ],
    [
      "titanesque",
      0.01
    ],
    [
      "genial",
      0.0075
    ],
    [
      "extravagant",
      0.0075
    ],
    [
      "architectural",
      0.0075
    ],
    [
      "renversant",
      0.0075
    ],
    [
      "superieur",
      0.0075
    ],
    [
      "epoustouflant",
      0.005
    ],
    [
      "notable",
      0.005
    ],
    [
      "fantasmagorique",
      0.005
    ],
    [
      "effrayant",
      0.005
    ],
    [
      "incalculable",
      0.005
    ],
    [
      "boeuf",
      0.0025
    ],
    [
      "fameux",
      0.0025
    ],
    [
      "magnifique",
      0.0025
    ],
    [
      "prestigieux",
      0.0025
    ],
    [
      "rocambolesque",
      0.0025
    ],
    [
      "super",
      0.0025
    ],
    [
      "signale",
      0.0025
    ],
    [
      "epouvantable",
      0.0
    ],
    [
      "verre",
      0.0
    ],
    [
      "fumant",
      0.0
    ],
    [
      "dement",
      0.0
    ],
    [
      "chic",
      0.0
    ],
    [
      "redoutable",
      0.0
    ],
    [
      "mechant",
      0.0
    ],
    [
      "marrant",
      0.0
    ],
    [
      "impeccable",
      0.0
    ],
    [
      "demi",
      0.0
    ],
    [
      "dantesque",
      0.0
    ],
    [
      "chope",
      0.0
    ],
    [
      "baron",
      0.0
    ],
    [
      "soufflant",
      0.0
    ]
  ],
  "eclat": [
    [
      "brillant",
      0.065
    ],
    [
      "splendeur",
      0.0525
    ],
    [
      "lustre",
      0.0425
    ],
    [
      "lumiere",
      0.0375
    ],
    [
      "beaute",
      0.0325
    ],
    [
      "gloire",
      0.03
    ],
    [
      "bruit",
      0.0275
    ],
    [
      "magnificence",
      0.0275
    ],
    [
      "feu",
      0.0225
    ],
    [
      "luminosite",
      0.0175
    ],
    [
      "grandeur",
      0.0175
    ],
    [
      "vivacite",
      0.015
    ],
    [
      "rayonnement",
      0.015
    ],
    [
      "pompe",
      0.015
    ],
    [
      "majeste",
      0.015
    ],
    [
      "lueur",
      0.015
    ],
    [
      "clarte",
      0.015
    ],
    [
      "tapage",
      0.0125
    ],
    [
      "somptuosite",
      0.0125
    ],
    [
      "richesse",
      0.0125
    ],
    [
      "relief",
      0.0125
    ],
    [
      "prestige",
      0.0125
    ],
    [
      "flamme",
      0.0125
    ],
    [
      "faste",
      0.0125
    ],
    [
      "distinction",
      0.0125
    ],
    [
      "miroitement",
      0.01
    ],
    [
      "morceau",
      0.01
    ],
    [
      "scintillement",
      0.01
    ],
    [
      "tintamarre",
      0.01
    ],
    [
      "vernis",
      0.01
    ],
    [
      "illustration",
      0.01
    ],
    [
      "fraicheur",
      0.01
    ],
    [
      "fragment",
      0.01
    ],
    [
      "exterieur",
      0.01
    ],
    [
      "couleur",
      0.01
    ],
    [
      "clinquant",
      0.01
    ],
    [
      "brillance",
      0.01
    ],
    [
      "animation",
      0.01
    ],
    [
      "honneur",
      0.0075
    ],
    [
      "nitescence",
      0.0075
    ],
    [
      "panache",
      0.0075
    ],
    [
      "petillement",
      0.0075
    ],
    [
      "etincelle",
      0.0075
    ],
    [
      "fracas",
      0.0075
    ],
    [
      "flamboiement",
      0.0075
    ],
    [
      "appareil",
      0.0075
    ],
    [
      "apparence",
      0.0075
    ],
    [
      "brio",
      0.0075
    ],
    [
      "chatoiement",
      0.0075
    ],
    [
      "debris",
      0.0075
    ],
    [
      "exuberance",
      0.0075
    ],
    [
      "phosphorescence",
      0.005
    ],
    [
      "piece",
      0.005
    ],
    [
      "poli",
      0.005
    ],
    [
      "retentissement",
      0.005
    ],
    [
      "scintillation",
      0.005
    ],
    [
      "son",
      0.005
    ],
    [
      "nettete",
      0.005
    ],
    [
      "limpidite",
      0.005
    ],
    [
      "fanfare",
      0.005
    ],
    [
      "apparat",
      0.005
    ],
    [
      "boucan",
      0.005
    ],
    [
      "coruscation",
      0.005
    ],
    [
      "effet",
      0.005
    ],
    [
      "esclandre",
      0.005
    ],
    [
      "explosion",
      0.005
    ],
    [
      "parure",
      0.0
    ],
    [
      "popularite",
      0.0
    ],
    [
      "recoupe",
      0.0
    ],
    [
      "rumeur",
      0.0
    ],
    [
      "scandale",
      0.0
    ],
    [
      "echarde",
      0.0
    ],
    [
      "eclair",
      0.0
    ],
    [
      "eclisse",
      0.0
    ],
    [
      "ecornure",
      0.0
    ],
    [
      "emerveillement",
      0.0
    ],
    [
      "epanouissement",
      0.0
    ],
    [
      "partie",
      0.0
    ],
    [
      "magnitude",
      0.0
    ],
    [
      "luxe",
      0.0
    ],
    [
      "brillement",
      0.0
    ],
    [
      "brisure",
      0.0
    ],
    [
      "coloration",
      0.0
    ],
    [
      "coloris",
      0.0
    ],
    [
      "coup",
      0.0
    ],
    [
      "crudite",
      0.0
    ],
    [
      "celebrite",
      0.0
    ],
    [
      "dechet",
      0.0
    ],
    [
      "esquille",
      0.0
    ],
    [
      "fleur",
      0.0
    ],
    [
      "aureole",
      0.0
    ]
  ],
  "endormi": [
    [
      "engourdi",
      0.1125
    ],
    [
      "apathique",
      0.075
    ],
    [
      "inerte",
      0.075
    ],
    [
      "mou",
      0.075
    ],
    [
      "somnolent",
      0.0625
    ],
    [
      "paresseux",
      0.0625
    ],
    [
      "lent",
      0.0625
    ],
    [
      "insensible",
      0.0625
    ],
    [
      "indolent",
      0.0625
    ],
    [
      "assoupi",
      0.0625
    ],
    [
      "nonchalant",
      0.0375
    ],
    [
      "lourd",
      0.0375
    ],
    [
      "ensommeille",
      0.0375
    ],
    [
      "dormant",
      0.025
    ],
    [
      "inactif",
      0.025
    ],
    [
      "ronfleur",
      0.01
    ],
    [
      "mollasse",
      0.01
    ],
    [
      "latent",
      0.01
    ],
    [
      "dormeur",
      0.01
    ],
    [
      "calme",
      0.01
    ],
    [
      "appesanti",
      0.01
    ],
    [
      "apaise",
      0.01
    ],
    [
      "amorphe",
      0.01
    ],
    [
      "silencieux",
      0.01
    ]
  ],
  "flotter": [
    [
      "osciller",
      0.11
    ],
    [
      "remuer",
      0.11
    ],
    [
      "balancer",
      0.0675
    ],
    [
      "hesiter",
      0.055
    ],
    [
      "vaciller",
      0.055
    ],
    [
      "voler",
      0.04
    ],
    [
      "nager",
      0.04
    ],
    [
      "brandiller",
      0.04
    ],
    [
      "battre",
      0.04
    ],
    [
      "voltiger",
      0.0275
    ],
    [
      "tituber",
      0.0275
    ],
    [
      "onduler",
      0.0275
    ],
    [
      "ondoyer",
      0.0275
    ],
    [
      "naviguer",
      0.0275
    ],
    [
      "errer",
      0.0275
    ],
    [
      "chanceler",
      0.0275
    ],
    [
      "agiter",
      0.0275
    ],
    [
      "surnager",
      0.0125
    ],
    [
      "vaguer",
      0.0125
    ],
    [
      "varier",
      0.0125
    ],
    [
      "voguer",
      0.0125
    ],
    [
      "voleter",
      0.0125
    ],
    [
      "emerger",
      0.0125
    ],
    [
      "s'agiter",
      0.0125
    ],
    [
      "pleuvoir",
      0.0125
    ],
    [
      "planer",
      0.0125
    ],
    [
      "pendre",
      0.0125
    ],
    [
      "pendiller",
      0.0125
    ],
    [
      "faseyer",
      0.0125
    ],
    [
      "affleurer",
      0.0125
    ]
  ],
  "flotte": [
    [
      "armada",
      0.1825
    ],
    [
      "parc",
      0.09
    ],
    [
      "marine",
      0.09
    ],
    [
      "flottille",
      0.09
    ],
    [
      "flotteur",
      0.09
    ],
    [
      "escadre",
      0.09
    ],
    [
      "eau",
      0.09
    ],
    [
      "bouee",
      0.09
    ],
    [
      "pluie",
      0.09
    ]
  ],
  "bonbon": [
    [
      "friandise",
      0.1375
    ],
    [
      "pastille",
      0.1025
    ],
    [
      "sucrerie",
      0.1025
    ],
    [
      "berlingot",
      0.0675
    ],
    [
      "confiserie",
      0.0675
    ],
    [
      "douceur",
      0.0675
    ],
    [
      "gourmandise",
      0.0325
    ],
    [
      "papillote",
      0.0325
    ],
    [
      "praline",
      0.0325
    ],
    [
      "sucette",
      0.0325
    ],
    [
      "dragee",
      0.0325
    ],
    [
      "chocolat",
      0.0325
    ],
    [
      "chatterie",
      0.0325
    ],
    [
      "caramel",
      0.0325
    ],
    [
      "calisson",
      0.0325
    ],
    [
      "betise",
      0.0325
    ]
  ],
  "enrober": [
    [
      "envelopper",
      0.265
    ],
    [
      "masquer",
      0.1575
    ],
    [
      "entortiller",
      0.105
    ],
    [
      "recouvrir",
      0.105
    ],
    [
      "rouler",
      0.05
    ],
    [
      "noyer",
      0.05
    ],
    [
      "glacer",
      0.05
    ],
    [
      "fourrer",
      0.05
    ],
    [
      "entourer",
      0.05
    ],
    [
      "deguiser",
      0.05
    ],
    [
      "tapisser",
      0.05
    ]
  ],
  "enrobe": [
    [
      "envelopper",
      0.265
    ],
    [
      "masquer",
      0.1575
    ],
    [
      "entortiller",
      0.105
    ],
    [
      "recouvrir",
      0.105
    ],
    [
      "rouler",
      0.05
    ],
    [
      "noyer",
      0.05
    ],
    [
      "glacer",
      0.05
    ],
    [
      "fourrer",
      0.05
    ],
    [
      "entourer",
      0.05
    ],
    [
      "deguiser",
      0.05
    ],
    [
      "tapisser",
      0.05
    ]
  ],
  "defendu": [
    [
      "proteger",
      0.125
    ],
    [
      "soutenir",
      0.075
    ],
    [
      "garantir",
      0.055
    ],
    [
      "assurer",
      0.04
    ],
    [
      "interdire",
      0.04
    ],
    [
      "maintenir",
      0.04
    ],
    [
      "preserver",
      0.04
    ],
    [
      "sauvegarder",
      0.0325
    ],
    [
      "renforcer",
      0.0325
    ],
    [
      "empecher",
      0.0325
    ],
    [
      "couvrir",
      0.0325
    ],
    [
      "appuyer",
      0.0325
    ],
    [
      "prohiber",
      0.0275
    ],
    [
      "garder",
      0.0275
    ],
    [
      "fortifier",
      0.0275
    ],
    [
      "condamner",
      0.0275
    ],
    [
      "tenir",
      0.02
    ],
    [
      "justifier",
      0.02
    ],
    [
      "excuser",
      0.02
    ],
    [
      "aider",
      0.02
    ],
    [
      "secourir",
      0.0125
    ],
    [
      "sauver",
      0.0125
    ],
    [
      "s'opposer",
      0.0125
    ],
    [
      "proscrire",
      0.0125
    ],
    [
      "intervenir",
      0.0125
    ],
    [
      "inhiber",
      0.0125
    ],
    [
      "chaperonner",
      0.0125
    ],
    [
      "censurer",
      0.0125
    ],
    [
      "abriter",
      0.0125
    ],
    [
      "prescrire",
      0.005
    ],
    [
      "refuser",
      0.005
    ],
    [
      "reprouver",
      0.005
    ],
    [
      "plaider",
      0.005
    ],
    [
      "interceder",
      0.005
    ],
    [
      "flanquer",
      0.005
    ],
    [
      "fermer",
      0.005
    ],
    [
      "disputer",
      0.005
    ],
    [
      "disculper",
      0.005
    ],
    [
      "assister",
      0.005
    ]
  ],
  "dune": [
    [
      "butte",
      0.5
    ],
    [
      "erg",
      0.25
    ],
    [
      "hauteur",
      0.25
    ]
  ],
  "ephemere": [
    [
      "fugace",
      0.1175
    ],
    [
      "passager",
      0.1175
    ],
    [
      "fragile",
      0.095
    ],
    [
      "precaire",
      0.0825
    ],
    [
      "fugitif",
      0.07
    ],
    [
      "court",
      0.07
    ],
    [
      "perissable",
      0.0475
    ],
    [
      "succinct",
      0.0475
    ],
    [
      "transitoire",
      0.0475
    ],
    [
      "temporaire",
      0.035
    ],
    [
      "provisoire",
      0.035
    ],
    [
      "fuyant",
      0.035
    ],
    [
      "changeant",
      0.035
    ],
    [
      "volage",
      0.0225
    ],
    [
      "mouvant",
      0.0225
    ],
    [
      "momentane",
      0.0225
    ],
    [
      "frele",
      0.0225
    ],
    [
      "caduc",
      0.0225
    ],
    [
      "diurne",
      0.01
    ],
    [
      "rapide",
      0.01
    ],
    [
      "temporel",
      0.01
    ]
  ],
  "reveler": [
    [
      "montrer",
      0.12
    ],
    [
      "indiquer",
      0.0575
    ],
    [
      "exposer",
      0.0475
    ],
    [
      "signaler",
      0.04
    ],
    [
      "dire",
      0.035
    ],
    [
      "afficher",
      0.0325
    ],
    [
      "declarer",
      0.0325
    ],
    [
      "decouvrir",
      0.0325
    ],
    [
      "annoncer",
      0.03
    ],
    [
      "manifester",
      0.03
    ],
    [
      "signifier",
      0.0275
    ],
    [
      "exprimer",
      0.0225
    ],
    [
      "donner",
      0.02
    ],
    [
      "marquer",
      0.02
    ],
    [
      "communiquer",
      0.0175
    ],
    [
      "devoiler",
      0.0175
    ],
    [
      "expliquer",
      0.0175
    ],
    [
      "publier",
      0.0175
    ],
    [
      "denoncer",
      0.0175
    ],
    [
      "trahir",
      0.0175
    ],
    [
      "temoigner",
      0.015
    ],
    [
      "presenter",
      0.015
    ],
    [
      "apprendre",
      0.0125
    ],
    [
      "prouver",
      0.01
    ],
    [
      "representer",
      0.01
    ],
    [
      "etaler",
      0.01
    ],
    [
      "produire",
      0.0075
    ],
    [
      "rapporter",
      0.0075
    ],
    [
      "enseigner",
      0.0075
    ],
    [
      "developper",
      0.0075
    ],
    [
      "demontrer",
      0.0075
    ],
    [
      "livrer",
      0.005
    ],
    [
      "nommer",
      0.005
    ],
    [
      "raconter",
      0.005
    ],
    [
      "affirmer",
      0.005
    ],
    [
      "peindre",
      0.005
    ],
    [
      "deceler",
      0.005
    ],
    [
      "divulguer",
      0.005
    ],
    [
      "denoter",
      0.005
    ],
    [
      "designer",
      0.005
    ],
    [
      "dessiner",
      0.0025
    ],
    [
      "ecrire",
      0.0025
    ],
    [
      "traduire",
      0.0025
    ],
    [
      "reperer",
      0.0025
    ],
    [
      "proclamer",
      0.0025
    ],
    [
      "instruire",
      0.0025
    ],
    [
      "exhiber",
      0.0025
    ],
    [
      "degager",
      0.0025
    ],
    [
      "confesser",
      0.0025
    ],
    [
      "attester",
      0.0025
    ],
    [
      "accuser",
      0.0025
    ],
    [
      "remarquer",
      0.0025
    ],
    [
      "saisir",
      0.0025
    ],
    [
      "sentir",
      0.0025
    ],
    [
      "etablir",
      0.0025
    ],
    [
      "reconnaitre",
      0.0025
    ],
    [
      "percer",
      0.0025
    ],
    [
      "exhaler",
      0.0025
    ],
    [
      "confier",
      0.0025
    ],
    [
      "avouer",
      0.0025
    ],
    [
      "apercevoir",
      0.0025
    ],
    [
      "souligner",
      0.0025
    ],
    [
      "s'ouvrir",
      0.0025
    ],
    [
      "respirer",
      0.0025
    ],
    [
      "offrir",
      0.0025
    ],
    [
      "deployer",
      0.0025
    ],
    [
      "decrire",
      0.0025
    ],
    [
      "comprendre",
      0.0025
    ],
    [
      "affecter",
      0.0025
    ],
    [
      "evoquer",
      0.0
    ],
    [
      "epancher",
      0.0
    ],
    [
      "parler",
      0.0
    ],
    [
      "liberer",
      0.0
    ],
    [
      "denuder",
      0.0
    ],
    [
      "demasquer",
      0.0
    ],
    [
      "deballer",
      0.0
    ],
    [
      "discerner",
      0.0
    ],
    [
      "eveiller",
      0.0
    ],
    [
      "supposer",
      0.0
    ],
    [
      "initier",
      0.0
    ],
    [
      "depeindre",
      0.0
    ],
    [
      "dechirer",
      0.0
    ],
    [
      "baptiser",
      0.0
    ],
    [
      "redire",
      0.0
    ],
    [
      "devetir",
      0.0
    ],
    [
      "detecter",
      0.0
    ],
    [
      "arborer",
      0.0
    ]
  ],
  "autrement": [
    [
      "sinon",
      0.1525
    ],
    [
      "plus",
      0.075
    ],
    [
      "particulierement",
      0.075
    ],
    [
      "incomparablement",
      0.075
    ],
    [
      "differemment",
      0.075
    ],
    [
      "beaucoup",
      0.075
    ],
    [
      "alias",
      0.075
    ],
    [
      "specialement",
      0.075
    ]
  ],
  "empecher": [
    [
      "retenir",
      0.055
    ],
    [
      "arreter",
      0.0525
    ],
    [
      "interdire",
      0.0525
    ],
    [
      "gener",
      0.04
    ],
    [
      "etouffer",
      0.04
    ],
    [
      "entraver",
      0.0375
    ],
    [
      "paralyser",
      0.0375
    ],
    [
      "endiguer",
      0.0325
    ],
    [
      "contrarier",
      0.0325
    ],
    [
      "barrer",
      0.0325
    ],
    [
      "comprimer",
      0.03
    ],
    [
      "enrayer",
      0.03
    ],
    [
      "supprimer",
      0.03
    ],
    [
      "tenir",
      0.025
    ],
    [
      "s'opposer",
      0.025
    ],
    [
      "reprimer",
      0.025
    ],
    [
      "brider",
      0.025
    ],
    [
      "contraindre",
      0.02
    ],
    [
      "fermer",
      0.02
    ],
    [
      "embarrasser",
      0.0175
    ],
    [
      "defendre",
      0.0175
    ],
    [
      "couper",
      0.0175
    ],
    [
      "cacher",
      0.0175
    ],
    [
      "eviter",
      0.0125
    ],
    [
      "ecarter",
      0.0125
    ],
    [
      "museler",
      0.0125
    ],
    [
      "exclure",
      0.0125
    ],
    [
      "enchainer",
      0.0125
    ],
    [
      "detourner",
      0.0125
    ],
    [
      "condamner",
      0.0125
    ],
    [
      "bloquer",
      0.0125
    ],
    [
      "traverser",
      0.01
    ],
    [
      "prohiber",
      0.01
    ],
    [
      "inhiber",
      0.01
    ],
    [
      "derober",
      0.01
    ],
    [
      "contrecarrer",
      0.01
    ],
    [
      "consigner",
      0.01
    ],
    [
      "atteler",
      0.01
    ],
    [
      "priver",
      0.005
    ],
    [
      "offusquer",
      0.005
    ],
    [
      "enfermer",
      0.005
    ],
    [
      "derouter",
      0.005
    ],
    [
      "dejouer",
      0.005
    ],
    [
      "baillonner",
      0.005
    ],
    [
      "conjurer",
      0.0025
    ],
    [
      "masquer",
      0.0025
    ],
    [
      "prevenir",
      0.0025
    ],
    [
      "rompre",
      0.0025
    ],
    [
      "sevrer",
      0.0025
    ]
  ],
  "separer": [
    [
      "diviser",
      0.0975
    ],
    [
      "morceler",
      0.0375
    ],
    [
      "couper",
      0.035
    ],
    [
      "ecarter",
      0.035
    ],
    [
      "detacher",
      0.0325
    ],
    [
      "enlever",
      0.03
    ],
    [
      "desunir",
      0.03
    ],
    [
      "distinguer",
      0.03
    ],
    [
      "disjoindre",
      0.03
    ],
    [
      "sectionner",
      0.025
    ],
    [
      "rompre",
      0.025
    ],
    [
      "dissocier",
      0.025
    ],
    [
      "arracher",
      0.025
    ],
    [
      "isoler",
      0.025
    ],
    [
      "oter",
      0.02
    ],
    [
      "partager",
      0.02
    ],
    [
      "extraire",
      0.02
    ],
    [
      "degager",
      0.02
    ],
    [
      "casser",
      0.0175
    ],
    [
      "disloquer",
      0.0175
    ],
    [
      "denouer",
      0.0175
    ],
    [
      "desagreger",
      0.0175
    ],
    [
      "fendre",
      0.0175
    ],
    [
      "disperser",
      0.015
    ],
    [
      "dissoudre",
      0.0125
    ],
    [
      "debrouiller",
      0.0125
    ],
    [
      "decomposer",
      0.0125
    ],
    [
      "demeler",
      0.0125
    ],
    [
      "trier",
      0.0125
    ],
    [
      "eloigner",
      0.01
    ],
    [
      "scinder",
      0.01
    ],
    [
      "retrancher",
      0.01
    ],
    [
      "fragmenter",
      0.01
    ],
    [
      "distraire",
      0.01
    ],
    [
      "classer",
      0.01
    ],
    [
      "chasser",
      0.01
    ],
    [
      "analyser",
      0.0075
    ],
    [
      "discerner",
      0.0075
    ],
    [
      "demembrer",
      0.0075
    ],
    [
      "preserver",
      0.005
    ],
    [
      "ranger",
      0.005
    ],
    [
      "segmenter",
      0.005
    ],
    [
      "subdiviser",
      0.005
    ],
    [
      "trancher",
      0.005
    ],
    [
      "eparpiller",
      0.005
    ],
    [
      "proteger",
      0.005
    ],
    [
      "departager",
      0.005
    ],
    [
      "divorcer",
      0.005
    ],
    [
      "alterer",
      0.005
    ],
    [
      "borner",
      0.005
    ],
    [
      "brouiller",
      0.005
    ],
    [
      "cloisonner",
      0.005
    ],
    [
      "cribler",
      0.005
    ],
    [
      "differencier",
      0.005
    ],
    [
      "interposer",
      0.0
    ],
    [
      "limiter",
      0.0
    ],
    [
      "monder",
      0.0
    ],
    [
      "opposer",
      0.0
    ],
    [
      "ponctuer",
      0.0
    ],
    [
      "s'interposer",
      0.0
    ],
    [
      "scier",
      0.0
    ],
    [
      "sevrer",
      0.0
    ],
    [
      "espacer",
      0.0
    ],
    [
      "entrouvrir",
      0.0
    ],
    [
      "desaccoupler",
      0.0
    ],
    [
      "abstraire",
      0.0
    ],
    [
      "bifurquer",
      0.0
    ],
    [
      "compartimenter",
      0.0
    ],
    [
      "congedier",
      0.0
    ],
    [
      "discriminer",
      0.0
    ],
    [
      "dechiqueter",
      0.0
    ],
    [
      "decoller",
      0.0
    ],
    [
      "demarier",
      0.0
    ],
    [
      "deparier",
      0.0
    ],
    [
      "departir",
      0.0
    ],
    [
      "deprendre",
      0.0
    ],
    [
      "tamiser",
      0.0
    ]
  ],
  "impatient": [
    [
      "ardent",
      0.1
    ],
    [
      "nerveux",
      0.085
    ],
    [
      "prompt",
      0.085
    ],
    [
      "vif",
      0.085
    ],
    [
      "empresse",
      0.055
    ],
    [
      "irrite",
      0.055
    ],
    [
      "enerve",
      0.0425
    ],
    [
      "impetueux",
      0.0425
    ],
    [
      "febrile",
      0.0425
    ],
    [
      "fougueux",
      0.0425
    ],
    [
      "avide",
      0.0425
    ],
    [
      "presse",
      0.0275
    ],
    [
      "irritable",
      0.0275
    ],
    [
      "haletant",
      0.0275
    ],
    [
      "colereux",
      0.0275
    ],
    [
      "colere",
      0.0275
    ],
    [
      "brusque",
      0.0275
    ],
    [
      "bouillonnant",
      0.0275
    ],
    [
      "bouillant",
      0.0275
    ],
    [
      "inquiet",
      0.0125
    ],
    [
      "indocile",
      0.0125
    ],
    [
      "desireux",
      0.0125
    ],
    [
      "attentif",
      0.0125
    ],
    [
      "agace",
      0.0125
    ],
    [
      "surexcite",
      0.0125
    ]
  ],
  "casquer": [
    [
      "payer",
      0.2725
    ],
    [
      "financer",
      0.18
    ],
    [
      "banquer",
      0.09
    ],
    [
      "coiffer",
      0.09
    ],
    [
      "cracher",
      0.09
    ],
    [
      "douiller",
      0.09
    ],
    [
      "debourser",
      0.09
    ],
    [
      "foncer",
      0.09
    ]
  ],
  "casque": [
    [
      "coiffure",
      0.1425
    ],
    [
      "calotte",
      0.095
    ],
    [
      "salade",
      0.0475
    ],
    [
      "morion",
      0.0475
    ],
    [
      "heaume",
      0.0475
    ],
    [
      "gamelle",
      0.0475
    ],
    [
      "chevelure",
      0.0475
    ],
    [
      "chapeau",
      0.0475
    ],
    [
      "capeline",
      0.0475
    ],
    [
      "cabasset",
      0.0475
    ],
    [
      "bourguignotte",
      0.0475
    ],
    [
      "bombe",
      0.0475
    ],
    [
      "bicoquet",
      0.0475
    ],
    [
      "bassinet",
      0.0475
    ],
    [
      "barrette",
      0.0475
    ],
    [
      "armure",
      0.0475
    ],
    [
      "armet",
      0.0475
    ],
    [
      "sechoir",
      0.0475
    ]
  ],
  "cabler": [
    [
      "tordre",
      0.5
    ],
    [
      "telegraphier",
      0.5
    ]
  ],
  "cable": [
    [
      "cordage",
      0.17
    ],
    [
      "corde",
      0.0925
    ],
    [
      "amarrage",
      0.0625
    ],
    [
      "attache",
      0.0625
    ],
    [
      "telegramme",
      0.0625
    ],
    [
      "pneu",
      0.045
    ],
    [
      "fil",
      0.045
    ],
    [
      "depeche",
      0.045
    ],
    [
      "remorque",
      0.03
    ],
    [
      "liure",
      0.03
    ],
    [
      "cablot",
      0.03
    ],
    [
      "cordelle",
      0.03
    ],
    [
      "amarre",
      0.03
    ],
    [
      "touee",
      0.015
    ],
    [
      "pantoire",
      0.015
    ],
    [
      "orin",
      0.015
    ],
    [
      "message",
      0.015
    ],
    [
      "guinderesse",
      0.015
    ],
    [
      "filin",
      0.015
    ],
    [
      "expres",
      0.015
    ],
    [
      "embossure",
      0.015
    ],
    [
      "drosse",
      0.015
    ],
    [
      "cablogramme",
      0.015
    ],
    [
      "cordon",
      0.015
    ],
    [
      "chaine",
      0.015
    ],
    [
      "chableau",
      0.015
    ],
    [
      "chable",
      0.015
    ],
    [
      "bleu",
      0.015
    ],
    [
      "trait",
      0.015
    ]
  ],
  "quota": [
    [
      "apport",
      0.2125
    ],
    [
      "contingent",
      0.085
    ],
    [
      "part",
      0.07
    ],
    [
      "contribution",
      0.055
    ],
    [
      "ecot",
      0.0425
    ],
    [
      "quotite",
      0.0425
    ],
    [
      "impot",
      0.0425
    ],
    [
      "cote",
      0.0425
    ],
    [
      "attribution",
      0.0425
    ],
    [
      "repartition",
      0.0275
    ],
    [
      "portion",
      0.0275
    ],
    [
      "lot",
      0.0275
    ],
    [
      "imposition",
      0.0275
    ],
    [
      "cotisation",
      0.0275
    ],
    [
      "cens",
      0.0275
    ],
    [
      "allocation",
      0.0125
    ],
    [
      "cotation",
      0.0125
    ],
    [
      "fraction",
      0.0125
    ],
    [
      "montant",
      0.0125
    ],
    [
      "pourcentage",
      0.0125
    ],
    [
      "quantite",
      0.0125
    ]
  ],
  "quels": [
    [
      "qui",
      0.5
    ],
    [
      "quoi",
      0.5
    ]
  ],
  "omelette": [],
  "quinoa": [],
  "efficace": [
    [
      "bon",
      0.1325
    ],
    [
      "fort",
      0.08
    ],
    [
      "valable",
      0.08
    ],
    [
      "agissant",
      0.07
    ],
    [
      "capable",
      0.05
    ],
    [
      "energique",
      0.04
    ],
    [
      "sur",
      0.04
    ],
    [
      "souverain",
      0.04
    ],
    [
      "puissant",
      0.04
    ],
    [
      "profitable",
      0.04
    ],
    [
      "actif",
      0.04
    ],
    [
      "precieux",
      0.03
    ],
    [
      "effectif",
      0.03
    ],
    [
      "certain",
      0.03
    ],
    [
      "valide",
      0.02
    ],
    [
      "utile",
      0.02
    ],
    [
      "radical",
      0.02
    ],
    [
      "payant",
      0.02
    ],
    [
      "operant",
      0.02
    ],
    [
      "influent",
      0.02
    ],
    [
      "infaillible",
      0.02
    ],
    [
      "heroique",
      0.02
    ],
    [
      "efficient",
      0.02
    ],
    [
      "competent",
      0.02
    ],
    [
      "bienfaisant",
      0.0075
    ],
    [
      "percutant",
      0.0075
    ],
    [
      "performant",
      0.0075
    ],
    [
      "pratique",
      0.0075
    ]
  ],
  "apparaitre": [
    [
      "paraitre",
      0.1175
    ],
    [
      "surgir",
      0.0725
    ],
    [
      "sortir",
      0.0475
    ],
    [
      "poindre",
      0.045
    ],
    [
      "emerger",
      0.04
    ],
    [
      "ressortir",
      0.035
    ],
    [
      "naitre",
      0.035
    ],
    [
      "sourdre",
      0.0275
    ],
    [
      "venir",
      0.0225
    ],
    [
      "arriver",
      0.0175
    ],
    [
      "pointer",
      0.0175
    ],
    [
      "survenir",
      0.015
    ],
    [
      "transparaitre",
      0.0125
    ],
    [
      "s'averer",
      0.0125
    ],
    [
      "resulter",
      0.0125
    ],
    [
      "constater",
      0.0125
    ],
    [
      "eclore",
      0.0075
    ],
    [
      "sembler",
      0.0075
    ],
    [
      "s'offrir",
      0.0075
    ],
    [
      "jaillir",
      0.0075
    ],
    [
      "sentir",
      0.005
    ],
    [
      "s'apercevoir",
      0.005
    ],
    [
      "s'afficher",
      0.005
    ],
    [
      "revenir",
      0.005
    ],
    [
      "manifester",
      0.005
    ],
    [
      "apparoir",
      0.005
    ],
    [
      "reapparaitre",
      0.0025
    ],
    [
      "s'exciter",
      0.0025
    ],
    [
      "evoquer",
      0.0025
    ],
    [
      "reparaitre",
      0.0025
    ],
    [
      "reconnaitre",
      0.0025
    ],
    [
      "proliferer",
      0.0025
    ],
    [
      "perler",
      0.0025
    ],
    [
      "luire",
      0.0025
    ],
    [
      "atteindre",
      0.0025
    ],
    [
      "affleurer",
      0.0025
    ]
  ],
  "punch": [
    [
      "force",
      0.1425
    ],
    [
      "vitalite",
      0.1425
    ],
    [
      "energie",
      0.1425
    ],
    [
      "riposte",
      0.07
    ],
    [
      "pep",
      0.07
    ],
    [
      "efficacite",
      0.07
    ],
    [
      "dynamisme",
      0.07
    ],
    [
      "brulot",
      0.07
    ],
    [
      "boisson",
      0.07
    ],
    [
      "allonge",
      0.07
    ],
    [
      "vigueur",
      0.07
    ]
  ],
  "benediction": [
    [
      "faveur",
      0.095
    ],
    [
      "bonheur",
      0.0825
    ],
    [
      "bienfait",
      0.0525
    ],
    [
      "grace",
      0.0525
    ],
    [
      "protection",
      0.04
    ],
    [
      "prosperite",
      0.04
    ],
    [
      "estime",
      0.04
    ],
    [
      "bien",
      0.04
    ],
    [
      "approbation",
      0.04
    ],
    [
      "veneration",
      0.025
    ],
    [
      "succes",
      0.025
    ],
    [
      "reconnaissance",
      0.025
    ],
    [
      "recommandation",
      0.025
    ],
    [
      "penitence",
      0.025
    ],
    [
      "plaisir",
      0.025
    ],
    [
      "consecration",
      0.025
    ],
    [
      "confirmation",
      0.025
    ],
    [
      "confession",
      0.025
    ],
    [
      "absolution",
      0.025
    ],
    [
      "priere",
      0.0125
    ],
    [
      "reconciliation",
      0.0125
    ],
    [
      "sacrement",
      0.0125
    ],
    [
      "salut",
      0.0125
    ],
    [
      "tutelle",
      0.0125
    ],
    [
      "veine",
      0.0125
    ],
    [
      "voeu",
      0.0125
    ],
    [
      "ordre",
      0.0125
    ],
    [
      "onction",
      0.0125
    ],
    [
      "mariage",
      0.0125
    ],
    [
      "gratitude",
      0.0125
    ],
    [
      "don",
      0.0125
    ],
    [
      "bapteme",
      0.0125
    ],
    [
      "applaudissement",
      0.0125
    ],
    [
      "affection",
      0.0125
    ],
    [
      "abondance",
      0.0125
    ]
  ],
  "credible": [
    [
      "croyable",
      0.25
    ],
    [
      "fiable",
      0.25
    ],
    [
      "plausible",
      0.25
    ],
    [
      "vraisemblable",
      0.25
    ]
  ],
  "nouille": [
    [
      "bete",
      0.25
    ],
    [
      "beta",
      0.1875
    ],
    [
      "ballot",
      0.125
    ],
    [
      "moule",
      0.125
    ],
    [
      "empote",
      0.0625
    ],
    [
      "mou",
      0.0625
    ],
    [
      "niais",
      0.0625
    ],
    [
      "pate",
      0.0625
    ]
  ],
  "bouteille": [
    [
      "bonbonne",
      0.0775
    ],
    [
      "flacon",
      0.0775
    ],
    [
      "gourde",
      0.05
    ],
    [
      "fiole",
      0.05
    ],
    [
      "fiasque",
      0.05
    ],
    [
      "carafon",
      0.05
    ],
    [
      "carafe",
      0.05
    ],
    [
      "litre",
      0.0225
    ],
    [
      "magnum",
      0.0225
    ],
    [
      "mathusalem",
      0.0225
    ],
    [
      "nabuchodonosor",
      0.0225
    ],
    [
      "pot",
      0.0225
    ],
    [
      "roteuse",
      0.0225
    ],
    [
      "rouille",
      0.0225
    ],
    [
      "salmanazar",
      0.0225
    ],
    [
      "siphon",
      0.0225
    ],
    [
      "tourie",
      0.0225
    ],
    [
      "kil",
      0.0225
    ],
    [
      "jeroboam",
      0.0225
    ],
    [
      "jarre",
      0.0225
    ],
    [
      "balthazar",
      0.0225
    ],
    [
      "bordelaise",
      0.0225
    ],
    [
      "bouillotte",
      0.0225
    ],
    [
      "boutanche",
      0.0225
    ],
    [
      "burette",
      0.0225
    ],
    [
      "canette",
      0.0225
    ],
    [
      "chopine",
      0.0225
    ],
    [
      "demie",
      0.0225
    ],
    [
      "fillette",
      0.0225
    ],
    [
      "vert",
      0.0225
    ]
  ],
  "encyclopedie": [
    [
      "almanach",
      0.25
    ],
    [
      "dictionnaire",
      0.25
    ],
    [
      "somme",
      0.25
    ],
    [
      "traite",
      0.25
    ]
  ],
  "inanition": [
    [
      "faiblesse",
      0.3325
    ],
    [
      "faim",
      0.3325
    ],
    [
      "epuisement",
      0.3325
    ]
  ],
  "job": [
    [
      "travail",
      0.2925
    ],
    [
      "metier",
      0.175
    ],
    [
      "besogne",
      0.1175
    ],
    [
      "boulot",
      0.1175
    ],
    [
      "occupation",
      0.1175
    ],
    [
      "situation",
      0.1175
    ],
    [
      "place",
      0.0575
    ]
  ],
  "sample": [],
  "boss": [
    [
      "chef",
      0.5
    ],
    [
      "patron",
      0.5
    ]
  ],
  "neant": [
    [
      "fumee",
      0.115
    ],
    [
      "vanite",
      0.115
    ],
    [
      "futilite",
      0.08
    ],
    [
      "faiblesse",
      0.06
    ],
    [
      "vide",
      0.06
    ],
    [
      "rien",
      0.0525
    ],
    [
      "inanite",
      0.0425
    ],
    [
      "insignifiance",
      0.035
    ],
    [
      "inconsistance",
      0.035
    ],
    [
      "frivolite",
      0.035
    ],
    [
      "fragilite",
      0.025
    ],
    [
      "zero",
      0.0175
    ],
    [
      "pretention",
      0.0175
    ],
    [
      "nul",
      0.0175
    ],
    [
      "mort",
      0.0175
    ],
    [
      "misere",
      0.0175
    ],
    [
      "manque",
      0.0175
    ],
    [
      "illusion",
      0.0175
    ],
    [
      "erreur",
      0.0175
    ],
    [
      "desert",
      0.0175
    ],
    [
      "deficience",
      0.0175
    ],
    [
      "bouffissure",
      0.0175
    ],
    [
      "aneantissement",
      0.0175
    ],
    [
      "inutilite",
      0.0075
    ],
    [
      "mensonge",
      0.0075
    ],
    [
      "vacuite",
      0.0075
    ],
    [
      "vapeur",
      0.0075
    ],
    [
      "infatuation",
      0.0075
    ],
    [
      "inexistant",
      0.0075
    ],
    [
      "fatuite",
      0.0075
    ],
    [
      "enflure",
      0.0075
    ],
    [
      "chimere",
      0.0075
    ],
    [
      "boursouflure",
      0.0075
    ],
    [
      "abime",
      0.0075
    ],
    [
      "vent",
      0.0075
    ]
  ],
  "creve": [
    [
      "rompre",
      0.105
    ],
    [
      "claquer",
      0.095
    ],
    [
      "percer",
      0.0725
    ],
    [
      "ereinter",
      0.0725
    ],
    [
      "fatiguer",
      0.0525
    ],
    [
      "epuiser",
      0.0425
    ],
    [
      "mourir",
      0.0425
    ],
    [
      "dechirer",
      0.0425
    ],
    [
      "craquer",
      0.0425
    ],
    [
      "vanner",
      0.03
    ],
    [
      "transpercer",
      0.03
    ],
    [
      "peter",
      0.03
    ],
    [
      "harasser",
      0.03
    ],
    [
      "enfoncer",
      0.03
    ],
    [
      "eclater",
      0.02
    ],
    [
      "echouer",
      0.02
    ],
    [
      "vider",
      0.02
    ],
    [
      "tuer",
      0.02
    ],
    [
      "succomber",
      0.02
    ],
    [
      "s'ouvrir",
      0.02
    ],
    [
      "forcer",
      0.02
    ],
    [
      "esquinter",
      0.02
    ],
    [
      "clamser",
      0.02
    ],
    [
      "claboter",
      0.01
    ],
    [
      "fendre",
      0.01
    ],
    [
      "pomper",
      0.01
    ],
    [
      "eventrer",
      0.01
    ]
  ],
  "miroir": [
    [
      "image",
      0.1425
    ],
    [
      "representation",
      0.1425
    ],
    [
      "trumeau",
      0.07
    ],
    [
      "speculum",
      0.07
    ],
    [
      "retroviseur",
      0.07
    ],
    [
      "reflecteur",
      0.07
    ],
    [
      "psyche",
      0.07
    ],
    [
      "portrait",
      0.07
    ],
    [
      "moucheture",
      0.07
    ],
    [
      "glace",
      0.07
    ],
    [
      "courtoisie",
      0.07
    ],
    [
      "echo",
      0.07
    ]
  ],
  "sain": [
    [
      "bon",
      0.1275
    ],
    [
      "raisonnable",
      0.0875
    ],
    [
      "pur",
      0.0625
    ],
    [
      "judicieux",
      0.05
    ],
    [
      "normal",
      0.05
    ],
    [
      "sage",
      0.05
    ],
    [
      "valide",
      0.0375
    ],
    [
      "sense",
      0.0375
    ],
    [
      "robuste",
      0.0375
    ],
    [
      "potable",
      0.0375
    ],
    [
      "droit",
      0.0375
    ],
    [
      "dispos",
      0.0375
    ],
    [
      "tonique",
      0.025
    ],
    [
      "salutaire",
      0.025
    ],
    [
      "salubre",
      0.025
    ],
    [
      "naturel",
      0.025
    ],
    [
      "genereux",
      0.025
    ],
    [
      "gaillard",
      0.025
    ],
    [
      "frais",
      0.025
    ],
    [
      "viable",
      0.0125
    ],
    [
      "stimulant",
      0.0125
    ],
    [
      "sauf",
      0.0125
    ],
    [
      "profitable",
      0.0125
    ],
    [
      "lucide",
      0.0125
    ],
    [
      "hygienique",
      0.0125
    ],
    [
      "florissant",
      0.0125
    ],
    [
      "buvable",
      0.0125
    ],
    [
      "equilibre",
      0.0125
    ]
  ],
  "persienne": [
    [
      "volet",
      0.3325
    ],
    [
      "auvent",
      0.165
    ],
    [
      "contrevent",
      0.165
    ],
    [
      "fermeture",
      0.165
    ],
    [
      "jalousie",
      0.165
    ]
  ],
  "partiel": [
    [
      "limite",
      0.2
    ],
    [
      "borne",
      0.1
    ],
    [
      "examen",
      0.1
    ],
    [
      "fragmentaire",
      0.1
    ],
    [
      "incomplet",
      0.1
    ],
    [
      "mutile",
      0.1
    ],
    [
      "relatif",
      0.1
    ],
    [
      "reduit",
      0.1
    ],
    [
      "echelonne",
      0.1
    ]
  ],
  "impartial": [
    [
      "equitable",
      0.165
    ],
    [
      "droit",
      0.1325
    ],
    [
      "indifferent",
      0.1325
    ],
    [
      "juste",
      0.1325
    ],
    [
      "desinteresse",
      0.0975
    ],
    [
      "egal",
      0.065
    ],
    [
      "probe",
      0.065
    ],
    [
      "integre",
      0.065
    ],
    [
      "impassible",
      0.065
    ],
    [
      "neutre",
      0.0325
    ],
    [
      "objectif",
      0.0325
    ]
  ],
  "entoure": [
    [
      "enserrer",
      0.07
    ],
    [
      "enfermer",
      0.0675
    ],
    [
      "ceindre",
      0.065
    ],
    [
      "encercler",
      0.065
    ],
    [
      "cerner",
      0.06
    ],
    [
      "enclore",
      0.045
    ],
    [
      "envelopper",
      0.0425
    ],
    [
      "serrer",
      0.0375
    ],
    [
      "renfermer",
      0.03
    ],
    [
      "emprisonner",
      0.03
    ],
    [
      "ceinturer",
      0.0225
    ],
    [
      "enceindre",
      0.0225
    ],
    [
      "fermer",
      0.0225
    ],
    [
      "environner",
      0.0175
    ],
    [
      "enlacer",
      0.0175
    ],
    [
      "embrasser",
      0.0175
    ],
    [
      "cercler",
      0.0175
    ],
    [
      "etreindre",
      0.015
    ],
    [
      "resserrer",
      0.015
    ],
    [
      "clore",
      0.015
    ],
    [
      "assieger",
      0.015
    ],
    [
      "boucler",
      0.0125
    ],
    [
      "encadrer",
      0.0125
    ],
    [
      "presser",
      0.01
    ],
    [
      "contenir",
      0.01
    ],
    [
      "borner",
      0.01
    ],
    [
      "parer",
      0.0075
    ],
    [
      "murer",
      0.0075
    ],
    [
      "garnir",
      0.0075
    ],
    [
      "emmailloter",
      0.0075
    ],
    [
      "combler",
      0.0075
    ],
    [
      "circonscrire",
      0.0075
    ],
    [
      "choyer",
      0.0075
    ],
    [
      "bloquer",
      0.0075
    ],
    [
      "bichonner",
      0.0075
    ],
    [
      "habiller",
      0.005
    ],
    [
      "fortifier",
      0.005
    ],
    [
      "entortiller",
      0.005
    ],
    [
      "border",
      0.005
    ],
    [
      "bander",
      0.005
    ],
    [
      "accabler",
      0.005
    ],
    [
      "voiler",
      0.0025
    ],
    [
      "orner",
      0.0025
    ],
    [
      "ficeler",
      0.0025
    ],
    [
      "enrouler",
      0.0025
    ],
    [
      "couronner",
      0.0025
    ],
    [
      "corder",
      0.0025
    ],
    [
      "cloturer",
      0.0025
    ],
    [
      "aureoler",
      0.0025
    ],
    [
      "attaquer",
      0.0025
    ],
    [
      "enrubanner",
      0.0
    ],
    [
      "espionner",
      0.0
    ],
    [
      "frequenter",
      0.0
    ],
    [
      "herisser",
      0.0
    ],
    [
      "lamper",
      0.0
    ],
    [
      "palissader",
      0.0
    ],
    [
      "s'empresser",
      0.0
    ],
    [
      "s'enrouler",
      0.0
    ],
    [
      "venerer",
      0.0
    ],
    [
      "enrober",
      0.0
    ],
    [
      "enclaver",
      0.0
    ],
    [
      "abreuver",
      0.0
    ],
    [
      "accompagner",
      0.0
    ],
    [
      "approcher",
      0.0
    ],
    [
      "assister",
      0.0
    ],
    [
      "baigner",
      0.0
    ],
    [
      "balustrer",
      0.0
    ],
    [
      "chouchouter",
      0.0
    ],
    [
      "draper",
      0.0
    ],
    [
      "encaisser",
      0.0
    ],
    [
      "enchasser",
      0.0
    ]
  ],
  "sonar": [
    [
      "asdic",
      0.25
    ],
    [
      "detection",
      0.25
    ],
    [
      "hydrophone",
      0.25
    ]
  ],
  "accuse": [
    [
      "attaquer",
      0.085
    ],
    [
      "inculper",
      0.0525
    ],
    [
      "montrer",
      0.0525
    ],
    [
      "reveler",
      0.0525
    ],
    [
      "incriminer",
      0.045
    ],
    [
      "indiquer",
      0.0375
    ],
    [
      "signaler",
      0.03
    ],
    [
      "marquer",
      0.03
    ],
    [
      "charger",
      0.03
    ],
    [
      "blamer",
      0.03
    ],
    [
      "souligner",
      0.025
    ],
    [
      "reprocher",
      0.025
    ],
    [
      "imputer",
      0.025
    ],
    [
      "denoncer",
      0.025
    ],
    [
      "dessiner",
      0.025
    ],
    [
      "critiquer",
      0.025
    ],
    [
      "accentuer",
      0.025
    ],
    [
      "temoigner",
      0.0175
    ],
    [
      "trahir",
      0.0175
    ],
    [
      "denigrer",
      0.0175
    ],
    [
      "citer",
      0.0175
    ],
    [
      "calomnier",
      0.0175
    ],
    [
      "vilipender",
      0.0125
    ],
    [
      "taxer",
      0.0125
    ],
    [
      "s'elever",
      0.0125
    ],
    [
      "prononcer",
      0.0125
    ],
    [
      "exagerer",
      0.0125
    ],
    [
      "deferer",
      0.0125
    ],
    [
      "diffamer",
      0.0125
    ],
    [
      "arguer",
      0.0125
    ],
    [
      "afficher",
      0.0125
    ],
    [
      "poursuivre",
      0.005
    ],
    [
      "rejeter",
      0.005
    ],
    [
      "requerir",
      0.005
    ],
    [
      "ressortir",
      0.005
    ],
    [
      "insinuer",
      0.005
    ],
    [
      "impliquer",
      0.005
    ],
    [
      "encaisser",
      0.005
    ],
    [
      "crier",
      0.005
    ],
    [
      "confesser",
      0.005
    ],
    [
      "subir",
      0.005
    ]
  ],
  "accuser": [
    [
      "attaquer",
      0.085
    ],
    [
      "inculper",
      0.0525
    ],
    [
      "montrer",
      0.0525
    ],
    [
      "reveler",
      0.0525
    ],
    [
      "incriminer",
      0.045
    ],
    [
      "indiquer",
      0.0375
    ],
    [
      "signaler",
      0.03
    ],
    [
      "marquer",
      0.03
    ],
    [
      "charger",
      0.03
    ],
    [
      "blamer",
      0.03
    ],
    [
      "souligner",
      0.025
    ],
    [
      "reprocher",
      0.025
    ],
    [
      "imputer",
      0.025
    ],
    [
      "denoncer",
      0.025
    ],
    [
      "dessiner",
      0.025
    ],
    [
      "critiquer",
      0.025
    ],
    [
      "accentuer",
      0.025
    ],
    [
      "temoigner",
      0.0175
    ],
    [
      "trahir",
      0.0175
    ],
    [
      "denigrer",
      0.0175
    ],
    [
      "citer",
      0.0175
    ],
    [
      "calomnier",
      0.0175
    ],
    [
      "vilipender",
      0.0125
    ],
    [
      "taxer",
      0.0125
    ],
    [
      "s'elever",
      0.0125
    ],
    [
      "prononcer",
      0.0125
    ],
    [
      "exagerer",
      0.0125
    ],
    [
      "deferer",
      0.0125
    ],
    [
      "diffamer",
      0.0125
    ],
    [
      "arguer",
      0.0125
    ],
    [
      "afficher",
      0.0125
    ],
    [
      "poursuivre",
      0.005
    ],
    [
      "rejeter",
      0.005
    ],
    [
      "requerir",
      0.005
    ],
    [
      "ressortir",
      0.005
    ],
    [
      "insinuer",
      0.005
    ],
    [
      "impliquer",
      0.005
    ],
    [
      "encaisser",
      0.005
    ],
    [
      "crier",
      0.005
    ],
    [
      "confesser",
      0.005
    ],
    [
      "subir",
      0.005
    ]
  ],
  "banc": [
    [
      "barre",
      0.075
    ],
    [
      "couche",
      0.075
    ],
    [
      "ecueil",
      0.05
    ],
    [
      "recif",
      0.05
    ],
    [
      "brisant",
      0.05
    ],
    [
      "bande",
      0.05
    ],
    [
      "assise",
      0.05
    ],
    [
      "agglomeration",
      0.05
    ],
    [
      "gisement",
      0.025
    ],
    [
      "gradin",
      0.025
    ],
    [
      "huitriere",
      0.025
    ],
    [
      "mascaret",
      0.025
    ],
    [
      "rocher",
      0.025
    ],
    [
      "siege",
      0.025
    ],
    [
      "strate",
      0.025
    ],
    [
      "table",
      0.025
    ],
    [
      "formation",
      0.025
    ],
    [
      "colonie",
      0.025
    ],
    [
      "amas",
      0.025
    ],
    [
      "bancelle",
      0.025
    ],
    [
      "banquette",
      0.025
    ],
    [
      "banquise",
      0.025
    ],
    [
      "box",
      0.025
    ],
    [
      "chevalet",
      0.025
    ],
    [
      "etabli",
      0.025
    ]
  ],
  "sauna": [
    [
      "bain",
      0.25
    ],
    [
      "sudatoire",
      0.25
    ],
    [
      "sudatorium",
      0.25
    ],
    [
      "etuve",
      0.25
    ]
  ],
  "abri": [
    [
      "maison",
      0.0325
    ],
    [
      "habitation",
      0.03
    ],
    [
      "protection",
      0.03
    ],
    [
      "gite",
      0.0225
    ],
    [
      "repaire",
      0.0225
    ],
    [
      "taniere",
      0.0225
    ],
    [
      "retraite",
      0.0225
    ],
    [
      "demeure",
      0.0175
    ],
    [
      "nid",
      0.015
    ],
    [
      "hangar",
      0.015
    ],
    [
      "cache",
      0.015
    ],
    [
      "asile",
      0.015
    ],
    [
      "cabane",
      0.0125
    ],
    [
      "toit",
      0.0125
    ],
    [
      "fortification",
      0.0125
    ],
    [
      "niche",
      0.0125
    ],
    [
      "refuge",
      0.01
    ],
    [
      "logement",
      0.01
    ],
    [
      "defense",
      0.01
    ],
    [
      "baraque",
      0.01
    ],
    [
      "etable",
      0.0075
    ],
    [
      "tente",
      0.0075
    ],
    [
      "sauvegarde",
      0.0075
    ],
    [
      "rempart",
      0.0075
    ],
    [
      "port",
      0.0075
    ],
    [
      "loge",
      0.0075
    ],
    [
      "couverture",
      0.0075
    ],
    [
      "cloture",
      0.0075
    ],
    [
      "chambre",
      0.0075
    ],
    [
      "cachette",
      0.0075
    ],
    [
      "box",
      0.0075
    ],
    [
      "garantie",
      0.0075
    ],
    [
      "habitacle",
      0.0075
    ],
    [
      "magasin",
      0.0075
    ],
    [
      "mur",
      0.0075
    ],
    [
      "pavillon",
      0.0075
    ],
    [
      "trou",
      0.0075
    ],
    [
      "ecran",
      0.0075
    ],
    [
      "foyer",
      0.0075
    ],
    [
      "forteresse",
      0.0075
    ],
    [
      "arret",
      0.0075
    ],
    [
      "auvent",
      0.0075
    ],
    [
      "barricade",
      0.0075
    ],
    [
      "bercail",
      0.0075
    ],
    [
      "cabinet",
      0.0075
    ],
    [
      "case",
      0.0075
    ],
    [
      "chateau",
      0.0075
    ],
    [
      "hutte",
      0.005
    ],
    [
      "kiosque",
      0.005
    ],
    [
      "poulailler",
      0.005
    ],
    [
      "penates",
      0.005
    ],
    [
      "remise",
      0.005
    ],
    [
      "resserre",
      0.005
    ],
    [
      "retranchement",
      0.005
    ],
    [
      "terrier",
      0.005
    ],
    [
      "tour",
      0.005
    ],
    [
      "tranchee",
      0.005
    ],
    [
      "edicule",
      0.005
    ],
    [
      "havre",
      0.005
    ],
    [
      "grange",
      0.005
    ],
    [
      "assurance",
      0.005
    ],
    [
      "baie",
      0.005
    ],
    [
      "banne",
      0.005
    ],
    [
      "bauge",
      0.005
    ],
    [
      "batiment",
      0.005
    ],
    [
      "cabine",
      0.005
    ],
    [
      "cagna",
      0.005
    ],
    [
      "fermeture",
      0.005
    ],
    [
      "fort",
      0.005
    ],
    [
      "gloriette",
      0.005
    ],
    [
      "golfe",
      0.005
    ],
    [
      "muraille",
      0.0025
    ],
    [
      "manteau",
      0.0025
    ],
    [
      "halte",
      0.0025
    ],
    [
      "guerite",
      0.0025
    ],
    [
      "guitoune",
      0.0025
    ],
    [
      "parapet",
      0.0025
    ],
    [
      "paravent",
      0.0025
    ],
    [
      "porcherie",
      0.0025
    ],
    [
      "rade",
      0.0025
    ],
    [
      "relache",
      0.0025
    ],
    [
      "surete",
      0.0025
    ],
    [
      "tourelle",
      0.0025
    ],
    [
      "ecurie",
      0.0025
    ],
    [
      "galerie",
      0.0025
    ],
    [
      "feuillage",
      0.0025
    ],
    [
      "alcove",
      0.0025
    ],
    [
      "anse",
      0.0025
    ],
    [
      "baraquement",
      0.0025
    ],
    [
      "bicoque",
      0.0025
    ],
    [
      "bouclier",
      0.0025
    ],
    [
      "bache",
      0.0025
    ],
    [
      "cage",
      0.0025
    ],
    [
      "clapier",
      0.0025
    ],
    [
      "couvert",
      0.0025
    ],
    [
      "digue",
      0.0025
    ],
    [
      "dunette",
      0.0025
    ],
    [
      "enfoncement",
      0.0025
    ],
    [
      "marquise",
      0.0025
    ],
    [
      "lapiniere",
      0.0025
    ],
    [
      "garage",
      0.0025
    ],
    [
      "frondaison",
      0.0025
    ],
    [
      "fortin",
      0.0025
    ],
    [
      "dais",
      0.0025
    ],
    [
      "masque",
      0.0025
    ],
    [
      "mouillage",
      0.0025
    ],
    [
      "parapluie",
      0.0025
    ],
    [
      "parasol",
      0.0025
    ],
    [
      "preservation",
      0.0025
    ],
    [
      "reposoir",
      0.0025
    ],
    [
      "rideau",
      0.0025
    ],
    [
      "soue",
      0.0025
    ],
    [
      "tonnelle",
      0.0025
    ],
    [
      "coquille",
      0.0025
    ],
    [
      "cloche",
      0.0025
    ],
    [
      "chassis",
      0.0025
    ],
    [
      "abrivent",
      0.0025
    ],
    [
      "acrostole",
      0.0025
    ],
    [
      "aile",
      0.0025
    ],
    [
      "ancrage",
      0.0025
    ],
    [
      "antre",
      0.0025
    ],
    [
      "aubette",
      0.0025
    ],
    [
      "bassin",
      0.0025
    ],
    [
      "blindage",
      0.0025
    ],
    [
      "chenil",
      0.0025
    ],
    [
      "casemate",
      0.0025
    ],
    [
      "caponniere",
      0.0025
    ],
    [
      "brandebourg",
      0.0025
    ],
    [
      "boyau",
      0.0025
    ],
    [
      "bouverie",
      0.0025
    ],
    [
      "porche",
      0.0
    ],
    [
      "perchoir",
      0.0
    ],
    [
      "paillasson",
      0.0
    ],
    [
      "ombrelle",
      0.0
    ],
    [
      "oasis",
      0.0
    ],
    [
      "mole",
      0.0
    ],
    [
      "mantelet",
      0.0
    ],
    [
      "jetee",
      0.0
    ],
    [
      "immunite",
      0.0
    ],
    [
      "grenier",
      0.0
    ],
    [
      "preau",
      0.0
    ],
    [
      "rabouillere",
      0.0
    ],
    [
      "timonerie",
      0.0
    ],
    [
      "teugue",
      0.0
    ],
    [
      "tenderolle",
      0.0
    ],
    [
      "tendelet",
      0.0
    ],
    [
      "taud",
      0.0
    ],
    [
      "securite",
      0.0
    ],
    [
      "soute",
      0.0
    ],
    [
      "serre",
      0.0
    ],
    [
      "rouf",
      0.0
    ],
    [
      "retirade",
      0.0
    ],
    [
      "reposee",
      0.0
    ],
    [
      "epaulement",
      0.0
    ],
    [
      "garenne",
      0.0
    ],
    [
      "carbet",
      0.0
    ],
    [
      "cagnard",
      0.0
    ],
    [
      "batisse",
      0.0
    ],
    [
      "bouvril",
      0.0
    ],
    [
      "blockhaus",
      0.0
    ],
    [
      "bergerie",
      0.0
    ],
    [
      "bastingage",
      0.0
    ],
    [
      "barbele",
      0.0
    ],
    [
      "aire",
      0.0
    ],
    [
      "accul",
      0.0
    ],
    [
      "caserne",
      0.0
    ],
    [
      "chapeau",
      0.0
    ],
    [
      "gare",
      0.0
    ],
    [
      "gabionnade",
      0.0
    ],
    [
      "foret",
      0.0
    ],
    [
      "feuillee",
      0.0
    ],
    [
      "entrepot",
      0.0
    ],
    [
      "darse",
      0.0
    ],
    [
      "cocon",
      0.0
    ],
    [
      "cockpit",
      0.0
    ],
    [
      "claie",
      0.0
    ],
    [
      "chaperon",
      0.0
    ],
    [
      "abribus",
      0.0
    ]
  ],
  "sceller": [
    [
      "affermir",
      0.0925
    ],
    [
      "confirmer",
      0.0925
    ],
    [
      "visser",
      0.0625
    ],
    [
      "maconner",
      0.0625
    ],
    [
      "fixer",
      0.0625
    ],
    [
      "fermer",
      0.0625
    ],
    [
      "consacrer",
      0.0625
    ],
    [
      "cimenter",
      0.0625
    ],
    [
      "cacheter",
      0.0625
    ],
    [
      "assembler",
      0.0625
    ],
    [
      "arrimer",
      0.0625
    ],
    [
      "ratifier",
      0.03
    ],
    [
      "platrer",
      0.03
    ],
    [
      "plomber",
      0.03
    ],
    [
      "joindre",
      0.03
    ],
    [
      "enteriner",
      0.03
    ],
    [
      "capsuler",
      0.03
    ],
    [
      "cacher",
      0.03
    ],
    [
      "sanctionner",
      0.03
    ]
  ],
  "scelle": [
    [
      "affermir",
      0.0925
    ],
    [
      "confirmer",
      0.0925
    ],
    [
      "visser",
      0.0625
    ],
    [
      "maconner",
      0.0625
    ],
    [
      "fixer",
      0.0625
    ],
    [
      "fermer",
      0.0625
    ],
    [
      "consacrer",
      0.0625
    ],
    [
      "cimenter",
      0.0625
    ],
    [
      "cacheter",
      0.0625
    ],
    [
      "assembler",
      0.0625
    ],
    [
      "arrimer",
      0.0625
    ],
    [
      "ratifier",
      0.03
    ],
    [
      "platrer",
      0.03
    ],
    [
      "plomber",
      0.03
    ],
    [
      "joindre",
      0.03
    ],
    [
      "enteriner",
      0.03
    ],
    [
      "capsuler",
      0.03
    ],
    [
      "cacher",
      0.03
    ],
    [
      "sanctionner",
      0.03
    ]
  ],
  "deracine": [
    [
      "arracher",
      0.1675
    ],
    [
      "enlever",
      0.075
    ],
    [
      "extirper",
      0.075
    ],
    [
      "eloigner",
      0.055
    ],
    [
      "exiler",
      0.055
    ],
    [
      "detruire",
      0.055
    ],
    [
      "detacher",
      0.055
    ],
    [
      "abattre",
      0.055
    ],
    [
      "tirer",
      0.035
    ],
    [
      "retirer",
      0.035
    ],
    [
      "extraire",
      0.035
    ],
    [
      "essoucher",
      0.035
    ],
    [
      "deporter",
      0.035
    ],
    [
      "deplacer",
      0.035
    ],
    [
      "sarcler",
      0.0175
    ],
    [
      "exterminer",
      0.0175
    ],
    [
      "expatrier",
      0.0175
    ],
    [
      "deterrer",
      0.0175
    ],
    [
      "deplanter",
      0.0175
    ],
    [
      "depayser",
      0.0175
    ],
    [
      "deliter",
      0.0175
    ],
    [
      "dechausser",
      0.0175
    ],
    [
      "dessoucher",
      0.0175
    ],
    [
      "sortir",
      0.0175
    ]
  ],
  "deraciner": [
    [
      "arracher",
      0.1675
    ],
    [
      "enlever",
      0.075
    ],
    [
      "extirper",
      0.075
    ],
    [
      "eloigner",
      0.055
    ],
    [
      "exiler",
      0.055
    ],
    [
      "detruire",
      0.055
    ],
    [
      "detacher",
      0.055
    ],
    [
      "abattre",
      0.055
    ],
    [
      "tirer",
      0.035
    ],
    [
      "retirer",
      0.035
    ],
    [
      "extraire",
      0.035
    ],
    [
      "essoucher",
      0.035
    ],
    [
      "deporter",
      0.035
    ],
    [
      "deplacer",
      0.035
    ],
    [
      "sarcler",
      0.0175
    ],
    [
      "exterminer",
      0.0175
    ],
    [
      "expatrier",
      0.0175
    ],
    [
      "deterrer",
      0.0175
    ],
    [
      "deplanter",
      0.0175
    ],
    [
      "depayser",
      0.0175
    ],
    [
      "deliter",
      0.0175
    ],
    [
      "dechausser",
      0.0175
    ],
    [
      "dessoucher",
      0.0175
    ],
    [
      "sortir",
      0.0175
    ]
  ],
  "arbre": [
    [
      "axe",
      0.125
    ],
    [
      "tige",
      0.125
    ],
    [
      "bielle",
      0.0825
    ],
    [
      "manivelle",
      0.0825
    ],
    [
      "plante",
      0.0825
    ],
    [
      "fut",
      0.04
    ],
    [
      "pivot",
      0.04
    ],
    [
      "precipite",
      0.04
    ],
    [
      "vilebrequin",
      0.04
    ],
    [
      "foret",
      0.04
    ],
    [
      "essieu",
      0.04
    ],
    [
      "diagramme",
      0.04
    ],
    [
      "bois",
      0.04
    ],
    [
      "barre",
      0.04
    ],
    [
      "arbuste",
      0.04
    ],
    [
      "arborescence",
      0.04
    ],
    [
      "vegetal",
      0.04
    ]
  ],
  "vue": [
    [
      "examiner",
      0.0425
    ],
    [
      "apercevoir",
      0.04
    ],
    [
      "comprendre",
      0.04
    ],
    [
      "decouvrir",
      0.04
    ],
    [
      "concevoir",
      0.0375
    ],
    [
      "saisir",
      0.035
    ],
    [
      "connaitre",
      0.035
    ],
    [
      "entendre",
      0.03
    ],
    [
      "regarder",
      0.03
    ],
    [
      "penser",
      0.03
    ],
    [
      "considerer",
      0.0275
    ],
    [
      "remarquer",
      0.0225
    ],
    [
      "juger",
      0.0225
    ],
    [
      "imaginer",
      0.0225
    ],
    [
      "percevoir",
      0.02
    ],
    [
      "observer",
      0.02
    ],
    [
      "penetrer",
      0.02
    ],
    [
      "trouver",
      0.0175
    ],
    [
      "verifier",
      0.0175
    ],
    [
      "discerner",
      0.015
    ],
    [
      "constater",
      0.015
    ],
    [
      "experimenter",
      0.015
    ],
    [
      "pratiquer",
      0.015
    ],
    [
      "eprouver",
      0.015
    ],
    [
      "etudier",
      0.0125
    ],
    [
      "reperer",
      0.0125
    ],
    [
      "controler",
      0.0125
    ],
    [
      "apprecier",
      0.0125
    ],
    [
      "estimer",
      0.01
    ],
    [
      "frequenter",
      0.01
    ],
    [
      "suivre",
      0.01
    ],
    [
      "s'apercevoir",
      0.0075
    ],
    [
      "percer",
      0.0075
    ],
    [
      "envisager",
      0.0075
    ],
    [
      "embrasser",
      0.0075
    ],
    [
      "distinguer",
      0.0075
    ],
    [
      "reflechir",
      0.005
    ],
    [
      "realiser",
      0.005
    ],
    [
      "peser",
      0.005
    ],
    [
      "noter",
      0.005
    ],
    [
      "entrevoir",
      0.005
    ],
    [
      "contempler",
      0.005
    ],
    [
      "aviser",
      0.005
    ],
    [
      "assister",
      0.005
    ],
    [
      "visiter",
      0.005
    ],
    [
      "viser",
      0.005
    ],
    [
      "veiller",
      0.005
    ],
    [
      "rencontrer",
      0.005
    ],
    [
      "inspecter",
      0.005
    ],
    [
      "frayer",
      0.005
    ],
    [
      "analyser",
      0.005
    ],
    [
      "subir",
      0.0025
    ],
    [
      "surprendre",
      0.0025
    ],
    [
      "zieuter",
      0.0025
    ],
    [
      "ecouter",
      0.0025
    ],
    [
      "savoir",
      0.0025
    ],
    [
      "admettre",
      0.0025
    ],
    [
      "lire",
      0.0025
    ],
    [
      "prevoir",
      0.0025
    ],
    [
      "recoler",
      0.0025
    ],
    [
      "s'assurer",
      0.0025
    ],
    [
      "s'enquerir",
      0.0025
    ],
    [
      "s'accointer",
      0.0025
    ],
    [
      "revoir",
      0.0025
    ],
    [
      "jauger",
      0.0025
    ],
    [
      "inventorier",
      0.0025
    ],
    [
      "donner",
      0.0025
    ],
    [
      "dominer",
      0.0025
    ],
    [
      "croiser",
      0.0025
    ],
    [
      "surplomber",
      0.0
    ],
    [
      "survenir",
      0.0
    ],
    [
      "visionner",
      0.0
    ],
    [
      "visualiser",
      0.0
    ],
    [
      "voisiner",
      0.0
    ],
    [
      "voyager",
      0.0
    ],
    [
      "s'informer",
      0.0
    ],
    [
      "s'imaginer",
      0.0
    ],
    [
      "planer",
      0.0
    ],
    [
      "mater",
      0.0
    ],
    [
      "loucher",
      0.0
    ],
    [
      "contacter",
      0.0
    ],
    [
      "commercer",
      0.0
    ]
  ],
  "tente": [
    [
      "abri",
      0.23
    ],
    [
      "dais",
      0.115
    ],
    [
      "velum",
      0.115
    ],
    [
      "tendelet",
      0.075
    ],
    [
      "velarium",
      0.0375
    ],
    [
      "toile",
      0.0375
    ],
    [
      "taud",
      0.0375
    ],
    [
      "tabernacle",
      0.0375
    ],
    [
      "pavillon",
      0.0375
    ],
    [
      "marsouin",
      0.0375
    ],
    [
      "habitation",
      0.0375
    ],
    [
      "guitoune",
      0.0375
    ],
    [
      "chapiteau",
      0.0375
    ],
    [
      "campement",
      0.0375
    ],
    [
      "banne",
      0.0375
    ],
    [
      "wigwam",
      0.0375
    ]
  ],
  "teinter": [
    [
      "colorer",
      0.4
    ],
    [
      "colorier",
      0.2
    ],
    [
      "parer",
      0.2
    ],
    [
      "peindre",
      0.2
    ]
  ],
  "pourvoir": [
    [
      "fournir",
      0.1125
    ],
    [
      "munir",
      0.0925
    ],
    [
      "approvisionner",
      0.0475
    ],
    [
      "procurer",
      0.0475
    ],
    [
      "equiper",
      0.0425
    ],
    [
      "repeupler",
      0.0425
    ],
    [
      "doter",
      0.035
    ],
    [
      "garnir",
      0.035
    ],
    [
      "parer",
      0.0275
    ],
    [
      "nantir",
      0.0275
    ],
    [
      "donner",
      0.0275
    ],
    [
      "charger",
      0.0275
    ],
    [
      "assurer",
      0.0275
    ],
    [
      "etablir",
      0.02
    ],
    [
      "remedier",
      0.02
    ],
    [
      "ravitailler",
      0.02
    ],
    [
      "placer",
      0.02
    ],
    [
      "investir",
      0.02
    ],
    [
      "entretenir",
      0.02
    ],
    [
      "armer",
      0.02
    ],
    [
      "alimenter",
      0.02
    ],
    [
      "veiller",
      0.0125
    ],
    [
      "suppleer",
      0.0125
    ],
    [
      "suffire",
      0.0125
    ],
    [
      "satisfaire",
      0.0125
    ],
    [
      "revetir",
      0.0125
    ],
    [
      "pallier",
      0.0125
    ],
    [
      "orner",
      0.0125
    ],
    [
      "monter",
      0.0125
    ],
    [
      "gratifier",
      0.0125
    ],
    [
      "assortir",
      0.0125
    ],
    [
      "pensionner",
      0.005
    ],
    [
      "outiller",
      0.005
    ],
    [
      "lester",
      0.005
    ],
    [
      "douer",
      0.005
    ],
    [
      "aviser",
      0.005
    ],
    [
      "affreter",
      0.005
    ],
    [
      "subvenir",
      0.005
    ]
  ],
  "somnambule": [
    [
      "devin",
      0.5
    ],
    [
      "noctambule",
      0.5
    ]
  ],
  "certains": [
    [
      "evident",
      0.0825
    ],
    [
      "vrai",
      0.06
    ],
    [
      "sur",
      0.055
    ],
    [
      "incontestable",
      0.045
    ],
    [
      "reel",
      0.0375
    ],
    [
      "authentique",
      0.0375
    ],
    [
      "positif",
      0.035
    ],
    [
      "avere",
      0.0275
    ],
    [
      "indubitable",
      0.0275
    ],
    [
      "manifeste",
      0.0275
    ],
    [
      "exact",
      0.025
    ],
    [
      "irrefragable",
      0.025
    ],
    [
      "formel",
      0.025
    ],
    [
      "sincere",
      0.025
    ],
    [
      "tangible",
      0.0225
    ],
    [
      "assure",
      0.02
    ],
    [
      "clair",
      0.02
    ],
    [
      "solide",
      0.0175
    ],
    [
      "indiscutable",
      0.0175
    ],
    [
      "indeniable",
      0.0175
    ],
    [
      "notoire",
      0.015
    ],
    [
      "precis",
      0.015
    ],
    [
      "net",
      0.015
    ],
    [
      "officiel",
      0.015
    ],
    [
      "etabli",
      0.0125
    ],
    [
      "patent",
      0.01
    ],
    [
      "veridique",
      0.01
    ],
    [
      "franc",
      0.01
    ],
    [
      "flagrant",
      0.01
    ],
    [
      "decide",
      0.01
    ],
    [
      "bon",
      0.0075
    ],
    [
      "decisif",
      0.0075
    ],
    [
      "determine",
      0.0075
    ],
    [
      "stable",
      0.0075
    ],
    [
      "probant",
      0.0075
    ],
    [
      "irrefutable",
      0.0075
    ],
    [
      "irrecusable",
      0.0075
    ],
    [
      "constant",
      0.005
    ],
    [
      "fixe",
      0.005
    ],
    [
      "peremptoire",
      0.005
    ],
    [
      "visible",
      0.0025
    ],
    [
      "reconnu",
      0.0025
    ],
    [
      "infaillible",
      0.0025
    ],
    [
      "dogmatique",
      0.0025
    ],
    [
      "convaincu",
      0.0025
    ],
    [
      "confirme",
      0.0025
    ],
    [
      "certifie",
      0.0025
    ],
    [
      "absolu",
      0.0025
    ],
    [
      "inattaquable",
      0.0025
    ],
    [
      "palpable",
      0.0025
    ],
    [
      "prouve",
      0.0025
    ],
    [
      "rigoureux",
      0.0025
    ],
    [
      "tranquille",
      0.0025
    ],
    [
      "fonde",
      0.0025
    ],
    [
      "efficace",
      0.0025
    ],
    [
      "effectif",
      0.0025
    ],
    [
      "declare",
      0.0025
    ],
    [
      "constate",
      0.0025
    ],
    [
      "connu",
      0.0025
    ],
    [
      "atteste",
      0.0025
    ],
    [
      "inconteste",
      0.0
    ],
    [
      "invariable",
      0.0
    ],
    [
      "ineluctable",
      0.0
    ],
    [
      "inevitable",
      0.0
    ],
    [
      "mathematique",
      0.0
    ],
    [
      "immanquable",
      0.0
    ],
    [
      "historique",
      0.0
    ],
    [
      "fixe",
      0.0
    ],
    [
      "demontre",
      0.0
    ],
    [
      "controle",
      0.0
    ],
    [
      "affirmatif",
      0.0
    ],
    [
      "admis",
      0.0
    ],
    [
      "relatif",
      0.0
    ],
    [
      "quelque",
      0.0
    ],
    [
      "persuade",
      0.0
    ],
    [
      "obligatoire",
      0.0
    ],
    [
      "donne",
      0.0
    ],
    [
      "couru",
      0.0
    ],
    [
      "tel",
      0.0
    ]
  ],
  "sape": [
    [
      "boyau",
      0.1425
    ],
    [
      "galerie",
      0.1425
    ],
    [
      "tranchee",
      0.1425
    ],
    [
      "sapement",
      0.07
    ],
    [
      "pelle",
      0.07
    ],
    [
      "mine",
      0.07
    ],
    [
      "fringue",
      0.07
    ],
    [
      "destruction",
      0.07
    ],
    [
      "approche",
      0.07
    ],
    [
      "affaiblissement",
      0.07
    ],
    [
      "travail",
      0.07
    ]
  ],
  "b": [],
  "humanite": [
    [
      "bonte",
      0.175
    ],
    [
      "charite",
      0.0925
    ],
    [
      "indulgence",
      0.08
    ],
    [
      "bienveillance",
      0.0675
    ],
    [
      "generosite",
      0.0675
    ],
    [
      "douceur",
      0.045
    ],
    [
      "pitie",
      0.045
    ],
    [
      "societe",
      0.0325
    ],
    [
      "philanthropie",
      0.0325
    ],
    [
      "misericorde",
      0.0325
    ],
    [
      "mansuetude",
      0.0325
    ],
    [
      "clemence",
      0.0325
    ],
    [
      "sensibilite",
      0.0225
    ],
    [
      "monde",
      0.0225
    ],
    [
      "homme",
      0.0225
    ],
    [
      "delicatesse",
      0.0225
    ],
    [
      "compassion",
      0.0225
    ],
    [
      "bienfaisance",
      0.0225
    ],
    [
      "altruisme",
      0.0225
    ],
    [
      "lettre",
      0.01
    ],
    [
      "humanitarisme",
      0.01
    ],
    [
      "humain",
      0.01
    ],
    [
      "hommes",
      0.01
    ],
    [
      "famille",
      0.01
    ],
    [
      "desinteressement",
      0.01
    ],
    [
      "univers",
      0.01
    ]
  ],
  "inanime": [
    [
      "insensible",
      0.225
    ],
    [
      "froid",
      0.18
    ],
    [
      "inerte",
      0.18
    ],
    [
      "calme",
      0.09
    ],
    [
      "immobile",
      0.09
    ],
    [
      "mort",
      0.09
    ],
    [
      "desert",
      0.0425
    ],
    [
      "inexpressif",
      0.0425
    ],
    [
      "languissant",
      0.0425
    ]
  ],
  "immeuble": [
    [
      "batiment",
      0.12
    ],
    [
      "habitation",
      0.12
    ],
    [
      "maison",
      0.1025
    ],
    [
      "propriete",
      0.0675
    ],
    [
      "palais",
      0.0675
    ],
    [
      "building",
      0.0675
    ],
    [
      "hotel",
      0.05
    ],
    [
      "edifice",
      0.0325
    ],
    [
      "tour",
      0.0325
    ],
    [
      "palace",
      0.0325
    ],
    [
      "fonds",
      0.0325
    ],
    [
      "construction",
      0.0325
    ],
    [
      "bien",
      0.0325
    ],
    [
      "local",
      0.015
    ],
    [
      "immobilier",
      0.015
    ],
    [
      "ensemble",
      0.015
    ],
    [
      "caserne",
      0.015
    ],
    [
      "batisse",
      0.015
    ],
    [
      "H.L.M.",
      0.015
    ],
    [
      "possession",
      0.015
    ]
  ],
  "inhabite": [
    [
      "abandonne",
      0.17
    ],
    [
      "desert",
      0.1275
    ],
    [
      "solitaire",
      0.1275
    ],
    [
      "infrequente",
      0.105
    ],
    [
      "vide",
      0.105
    ],
    [
      "vacant",
      0.0425
    ],
    [
      "sauvage",
      0.0425
    ],
    [
      "isole",
      0.0425
    ],
    [
      "inoccupe",
      0.0425
    ],
    [
      "depeuple",
      0.0425
    ],
    [
      "delaisse",
      0.0425
    ],
    [
      "desertique",
      0.02
    ],
    [
      "deshabite",
      0.02
    ],
    [
      "desole",
      0.02
    ],
    [
      "mort",
      0.02
    ],
    [
      "vierge",
      0.02
    ]
  ],
  "atteint": [
    [
      "toucher",
      0.1075
    ],
    [
      "frapper",
      0.04
    ],
    [
      "attaquer",
      0.0375
    ],
    [
      "saisir",
      0.0375
    ],
    [
      "arriver",
      0.035
    ],
    [
      "gagner",
      0.035
    ],
    [
      "emouvoir",
      0.0325
    ],
    [
      "ebranler",
      0.0275
    ],
    [
      "prendre",
      0.0275
    ],
    [
      "bouleverser",
      0.0275
    ],
    [
      "blesser",
      0.0275
    ],
    [
      "attraper",
      0.0275
    ],
    [
      "heurter",
      0.025
    ],
    [
      "parvenir",
      0.025
    ],
    [
      "troubler",
      0.025
    ],
    [
      "joindre",
      0.0225
    ],
    [
      "piquer",
      0.0225
    ],
    [
      "penetrer",
      0.02
    ],
    [
      "alterer",
      0.02
    ],
    [
      "affecter",
      0.02
    ],
    [
      "aller",
      0.0175
    ],
    [
      "monter",
      0.0175
    ],
    [
      "rejoindre",
      0.015
    ],
    [
      "rencontrer",
      0.015
    ],
    [
      "trouver",
      0.0125
    ],
    [
      "percer",
      0.0125
    ],
    [
      "detruire",
      0.0125
    ],
    [
      "accoster",
      0.0125
    ],
    [
      "aborder",
      0.0125
    ],
    [
      "abattre",
      0.0125
    ],
    [
      "s'elever",
      0.01
    ],
    [
      "retrouver",
      0.01
    ],
    [
      "remuer",
      0.01
    ],
    [
      "porter",
      0.01
    ],
    [
      "offenser",
      0.01
    ],
    [
      "choquer",
      0.01
    ],
    [
      "acceder",
      0.01
    ],
    [
      "aboutir",
      0.01
    ],
    [
      "affaiblir",
      0.0075
    ],
    [
      "leser",
      0.0075
    ],
    [
      "realiser",
      0.0075
    ],
    [
      "endommager",
      0.005
    ],
    [
      "contacter",
      0.005
    ],
    [
      "compromettre",
      0.005
    ],
    [
      "affliger",
      0.005
    ],
    [
      "accomplir",
      0.005
    ],
    [
      "egaler",
      0.0025
    ],
    [
      "rattraper",
      0.0025
    ],
    [
      "gravir",
      0.0025
    ],
    [
      "decrocher",
      0.0025
    ],
    [
      "chercher",
      0.0025
    ],
    [
      "aveindre",
      0.0025
    ],
    [
      "apparaitre",
      0.0025
    ],
    [
      "agresser",
      0.0025
    ],
    [
      "agiter",
      0.0025
    ]
  ],
  "bise": [
    [
      "bistre",
      0.2625
    ],
    [
      "beige",
      0.1575
    ],
    [
      "brun",
      0.105
    ],
    [
      "gris",
      0.105
    ],
    [
      "jaunatre",
      0.105
    ],
    [
      "basane",
      0.05
    ],
    [
      "bistre",
      0.05
    ],
    [
      "brunatre",
      0.05
    ]
  ],
  "biser": [
    [
      "baiser",
      0.22
    ],
    [
      "embrasser",
      0.22
    ],
    [
      "biger",
      0.11
    ],
    [
      "bisouter",
      0.11
    ],
    [
      "becoter",
      0.11
    ],
    [
      "degenerer",
      0.11
    ],
    [
      "reteindre",
      0.11
    ]
  ],
  "carlingue": [
    [
      "carene",
      1.0
    ]
  ],
  "vantard": [
    [
      "hableur",
      0.235
    ],
    [
      "fanfaron",
      0.175
    ],
    [
      "menteur",
      0.1175
    ],
    [
      "mythomane",
      0.0575
    ],
    [
      "matamore",
      0.0575
    ],
    [
      "bravache",
      0.0575
    ],
    [
      "bluffeur",
      0.0575
    ],
    [
      "rodomont",
      0.0275
    ],
    [
      "presomptueux",
      0.0275
    ],
    [
      "faiseur",
      0.0275
    ],
    [
      "fabulateur",
      0.0275
    ],
    [
      "esbroufeur",
      0.0275
    ],
    [
      "craqueur",
      0.0275
    ],
    [
      "vanteur",
      0.0275
    ]
  ],
  "vandale": [
    [
      "barbare",
      0.1425
    ],
    [
      "brigand",
      0.1425
    ],
    [
      "destructeur",
      0.1425
    ],
    [
      "depredateur",
      0.1425
    ],
    [
      "devastateur",
      0.1425
    ],
    [
      "hooligan",
      0.1425
    ],
    [
      "iconoclaste",
      0.1425
    ]
  ],
  "oracle": [
    [
      "prediction",
      0.1825
    ],
    [
      "prophetie",
      0.135
    ],
    [
      "augure",
      0.09
    ],
    [
      "devin",
      0.09
    ],
    [
      "divination",
      0.09
    ],
    [
      "prophete",
      0.09
    ],
    [
      "vaticination",
      0.045
    ],
    [
      "vaticinateur",
      0.045
    ],
    [
      "reponse",
      0.045
    ],
    [
      "pronostic",
      0.045
    ],
    [
      "opinion",
      0.045
    ],
    [
      "destin",
      0.045
    ],
    [
      "verite",
      0.045
    ]
  ],
  "conscience": [
    [
      "coeur",
      0.0775
    ],
    [
      "sentiment",
      0.0775
    ],
    [
      "soin",
      0.0775
    ],
    [
      "honnetete",
      0.045
    ],
    [
      "idee",
      0.045
    ],
    [
      "zele",
      0.045
    ],
    [
      "pensee",
      0.0375
    ],
    [
      "intuition",
      0.0375
    ],
    [
      "ame",
      0.03
    ],
    [
      "scrupule",
      0.03
    ],
    [
      "notion",
      0.03
    ],
    [
      "foi",
      0.03
    ],
    [
      "exactitude",
      0.03
    ],
    [
      "esprit",
      0.03
    ],
    [
      "delicatesse",
      0.03
    ],
    [
      "connaissance",
      0.03
    ],
    [
      "regularite",
      0.0225
    ],
    [
      "probite",
      0.0225
    ],
    [
      "moralite",
      0.0225
    ],
    [
      "courage",
      0.0225
    ],
    [
      "attention",
      0.0225
    ],
    [
      "application",
      0.0225
    ],
    [
      "serieux",
      0.015
    ],
    [
      "sens",
      0.015
    ],
    [
      "representation",
      0.015
    ],
    [
      "pressentiment",
      0.015
    ],
    [
      "lucidite",
      0.015
    ],
    [
      "croyance",
      0.015
    ],
    [
      "remords",
      0.0075
    ],
    [
      "minutie",
      0.0075
    ],
    [
      "estime",
      0.0075
    ],
    [
      "devouement",
      0.0075
    ],
    [
      "advertance",
      0.0075
    ],
    [
      "etre",
      0.0075
    ]
  ],
  "quietude": [
    [
      "calme",
      0.1675
    ],
    [
      "tranquillite",
      0.1525
    ],
    [
      "paix",
      0.1225
    ],
    [
      "serenite",
      0.1225
    ],
    [
      "accalmie",
      0.075
    ],
    [
      "repos",
      0.06
    ],
    [
      "douceur",
      0.045
    ],
    [
      "securite",
      0.045
    ],
    [
      "placidite",
      0.03
    ],
    [
      "beatitude",
      0.03
    ],
    [
      "bonace",
      0.03
    ],
    [
      "apaisement",
      0.03
    ],
    [
      "assurance",
      0.015
    ],
    [
      "ataraxie",
      0.015
    ],
    [
      "rasserenement",
      0.015
    ]
  ],
  "peze": [
    [
      "argent",
      0.25
    ],
    [
      "fric",
      0.1875
    ],
    [
      "ble",
      0.125
    ],
    [
      "monnaie",
      0.125
    ],
    [
      "pognon",
      0.125
    ],
    [
      "billet",
      0.0625
    ],
    [
      "flouze",
      0.0625
    ],
    [
      "thune",
      0.0625
    ]
  ],
  "clouer": [
    [
      "fixer",
      0.145
    ],
    [
      "immobiliser",
      0.145
    ],
    [
      "petrifier",
      0.1075
    ],
    [
      "attacher",
      0.09
    ],
    [
      "river",
      0.09
    ],
    [
      "arrimer",
      0.0725
    ],
    [
      "figer",
      0.0725
    ],
    [
      "transir",
      0.035
    ],
    [
      "tenir",
      0.035
    ],
    [
      "retenir",
      0.035
    ],
    [
      "paralyser",
      0.035
    ],
    [
      "assujettir",
      0.035
    ],
    [
      "assembler",
      0.0175
    ],
    [
      "clouter",
      0.0175
    ],
    [
      "fermer",
      0.0175
    ],
    [
      "ficher",
      0.0175
    ],
    [
      "statufier",
      0.0175
    ]
  ],
  "bec": [
    [
      "bouche",
      0.15
    ],
    [
      "pointe",
      0.1175
    ],
    [
      "aiguille",
      0.0575
    ],
    [
      "promontoire",
      0.0575
    ],
    [
      "saillie",
      0.0575
    ],
    [
      "frimousse",
      0.0275
    ],
    [
      "goule",
      0.0275
    ],
    [
      "goulot",
      0.0275
    ],
    [
      "gueule",
      0.0275
    ],
    [
      "langue",
      0.0275
    ],
    [
      "minois",
      0.0275
    ],
    [
      "obstacle",
      0.0275
    ],
    [
      "rostre",
      0.0275
    ],
    [
      "embouchure",
      0.0275
    ],
    [
      "difficulte",
      0.0275
    ],
    [
      "avance",
      0.0275
    ],
    [
      "becquet",
      0.0275
    ],
    [
      "bruleur",
      0.0275
    ],
    [
      "becot",
      0.0275
    ],
    [
      "bequillon",
      0.0275
    ],
    [
      "cap",
      0.0275
    ],
    [
      "clapet",
      0.0275
    ],
    [
      "confluent",
      0.0275
    ],
    [
      "tirage",
      0.0275
    ]
  ],
  "enqueter": [
    [
      "rechercher",
      0.21
    ],
    [
      "s'enquerir",
      0.1575
    ],
    [
      "chercher",
      0.105
    ],
    [
      "questionner",
      0.105
    ],
    [
      "s'informer",
      0.105
    ],
    [
      "prospecter",
      0.05
    ],
    [
      "perquisitionner",
      0.05
    ],
    [
      "investiguer",
      0.05
    ],
    [
      "interviewer",
      0.05
    ],
    [
      "instruire",
      0.05
    ]
  ],
  "hirondelle": [
    [
      "agent",
      0.3325
    ],
    [
      "policier",
      0.3325
    ],
    [
      "vache",
      0.3325
    ]
  ],
  "magnolia": [],
  "lache": [
    [
      "abandonner",
      0.12
    ],
    [
      "quitter",
      0.07
    ],
    [
      "sortir",
      0.0575
    ],
    [
      "ceder",
      0.05
    ],
    [
      "rompre",
      0.045
    ],
    [
      "lancer",
      0.0425
    ],
    [
      "passer",
      0.0375
    ],
    [
      "delaisser",
      0.0325
    ],
    [
      "semer",
      0.0325
    ],
    [
      "faire",
      0.0275
    ],
    [
      "jeter",
      0.0275
    ],
    [
      "plaquer",
      0.0225
    ],
    [
      "larguer",
      0.0225
    ],
    [
      "cesser",
      0.0175
    ],
    [
      "flechir",
      0.0175
    ],
    [
      "livrer",
      0.0175
    ],
    [
      "trahir",
      0.0125
    ],
    [
      "tirer",
      0.0125
    ],
    [
      "relacher",
      0.0125
    ],
    [
      "pousser",
      0.0125
    ],
    [
      "plier",
      0.0125
    ],
    [
      "oublier",
      0.0125
    ],
    [
      "laisser",
      0.0125
    ],
    [
      "flancher",
      0.0125
    ],
    [
      "dire",
      0.0125
    ],
    [
      "filer",
      0.0075
    ],
    [
      "interrompre",
      0.0075
    ],
    [
      "rendre",
      0.0075
    ],
    [
      "echapper",
      0.0075
    ],
    [
      "envoyer",
      0.0075
    ],
    [
      "detendre",
      0.0075
    ],
    [
      "detacher",
      0.0075
    ],
    [
      "accorder",
      0.0075
    ],
    [
      "desserrer",
      0.0075
    ],
    [
      "distancer",
      0.0075
    ],
    [
      "decoller",
      0.0075
    ],
    [
      "depasser",
      0.0075
    ],
    [
      "octroyer",
      0.0025
    ],
    [
      "gratter",
      0.0025
    ],
    [
      "faiblir",
      0.0025
    ],
    [
      "deverser",
      0.0025
    ],
    [
      "decramponner",
      0.0025
    ],
    [
      "debourser",
      0.0025
    ],
    [
      "debander",
      0.0025
    ],
    [
      "casser",
      0.0025
    ]
  ],
  "centaines": [
    [
      "cent",
      1.0
    ]
  ],
  "centaine": [
    [
      "cent",
      1.0
    ]
  ],
  "timide": [
    [
      "vague",
      0.095
    ],
    [
      "confus",
      0.065
    ],
    [
      "indecis",
      0.055
    ],
    [
      "flou",
      0.0525
    ],
    [
      "incertain",
      0.0525
    ],
    [
      "nebuleux",
      0.0475
    ],
    [
      "craintif",
      0.0425
    ],
    [
      "embarrasse",
      0.0375
    ],
    [
      "indistinct",
      0.0325
    ],
    [
      "obscur",
      0.0325
    ],
    [
      "hesitant",
      0.0275
    ],
    [
      "trouble",
      0.0275
    ],
    [
      "timore",
      0.0225
    ],
    [
      "douteux",
      0.0225
    ],
    [
      "reserve",
      0.0175
    ],
    [
      "peureux",
      0.0175
    ],
    [
      "lache",
      0.0175
    ],
    [
      "indetermine",
      0.0175
    ],
    [
      "imprecis",
      0.0175
    ],
    [
      "honteux",
      0.0175
    ],
    [
      "pusillanime",
      0.0125
    ],
    [
      "poltron",
      0.0125
    ],
    [
      "imperceptible",
      0.0125
    ],
    [
      "humble",
      0.0125
    ],
    [
      "gene",
      0.0125
    ],
    [
      "frileux",
      0.0125
    ],
    [
      "flottant",
      0.0125
    ],
    [
      "capon",
      0.0125
    ],
    [
      "sauvage",
      0.0075
    ],
    [
      "modeste",
      0.0075
    ],
    [
      "intimide",
      0.0075
    ],
    [
      "indefini",
      0.0075
    ],
    [
      "imparfait",
      0.0075
    ],
    [
      "discret",
      0.0075
    ],
    [
      "circonspect",
      0.0075
    ],
    [
      "nuageux",
      0.0025
    ],
    [
      "pudibond",
      0.0025
    ],
    [
      "rougissant",
      0.0025
    ],
    [
      "subtil",
      0.0025
    ],
    [
      "transi",
      0.0025
    ],
    [
      "vergogneux",
      0.0025
    ],
    [
      "insensible",
      0.0025
    ],
    [
      "gauche",
      0.0025
    ],
    [
      "fumeux",
      0.0025
    ],
    [
      "froussard",
      0.0025
    ],
    [
      "farouche",
      0.0025
    ],
    [
      "effarouche",
      0.0025
    ],
    [
      "effarouchable",
      0.0025
    ],
    [
      "apprehensif",
      0.0025
    ],
    [
      "approximatif",
      0.0025
    ],
    [
      "ebauche",
      0.0025
    ]
  ],
  "violette": [
    [
      "aubergine",
      0.07
    ],
    [
      "violine",
      0.07
    ],
    [
      "violace",
      0.07
    ],
    [
      "prune",
      0.07
    ],
    [
      "pourpre",
      0.07
    ],
    [
      "pensee",
      0.07
    ],
    [
      "parme",
      0.07
    ],
    [
      "mauve",
      0.07
    ],
    [
      "lilas",
      0.07
    ],
    [
      "janthine",
      0.07
    ],
    [
      "incarnat",
      0.07
    ],
    [
      "bleu",
      0.07
    ],
    [
      "zinzolin",
      0.07
    ]
  ],
  "humide": [
    [
      "mouille",
      0.165
    ],
    [
      "embue",
      0.1325
    ],
    [
      "moite",
      0.1
    ],
    [
      "trempe",
      0.065
    ],
    [
      "suintant",
      0.065
    ],
    [
      "imbibe",
      0.065
    ],
    [
      "fluide",
      0.065
    ],
    [
      "liquide",
      0.0325
    ],
    [
      "impregne",
      0.0325
    ],
    [
      "hydrate",
      0.0325
    ],
    [
      "humidifie",
      0.0325
    ],
    [
      "humecte",
      0.0325
    ],
    [
      "frais",
      0.0325
    ],
    [
      "embrume",
      0.0325
    ],
    [
      "detrempe",
      0.0325
    ],
    [
      "aqueux",
      0.0325
    ],
    [
      "pluvieux",
      0.0325
    ]
  ],
  "encourager": [
    [
      "exciter",
      0.085
    ],
    [
      "pousser",
      0.085
    ],
    [
      "provoquer",
      0.0475
    ],
    [
      "soutenir",
      0.0475
    ],
    [
      "stimuler",
      0.045
    ],
    [
      "animer",
      0.045
    ],
    [
      "aiguillonner",
      0.04
    ],
    [
      "fortifier",
      0.04
    ],
    [
      "inciter",
      0.04
    ],
    [
      "exalter",
      0.035
    ],
    [
      "vivifier",
      0.0325
    ],
    [
      "porter",
      0.0325
    ],
    [
      "appuyer",
      0.0275
    ],
    [
      "ranimer",
      0.0275
    ],
    [
      "reconforter",
      0.0275
    ],
    [
      "favoriser",
      0.025
    ],
    [
      "proteger",
      0.02
    ],
    [
      "promouvoir",
      0.02
    ],
    [
      "enflammer",
      0.02
    ],
    [
      "aider",
      0.02
    ],
    [
      "engager",
      0.0175
    ],
    [
      "inviter",
      0.0125
    ],
    [
      "inspirer",
      0.0125
    ],
    [
      "determiner",
      0.0125
    ],
    [
      "confirmer",
      0.0125
    ],
    [
      "solliciter",
      0.01
    ],
    [
      "revivifier",
      0.01
    ],
    [
      "flatter",
      0.01
    ],
    [
      "exhorter",
      0.01
    ],
    [
      "affermir",
      0.01
    ],
    [
      "retremper",
      0.005
    ],
    [
      "incliner",
      0.005
    ],
    [
      "entretenir",
      0.005
    ],
    [
      "enhardir",
      0.005
    ],
    [
      "conforter",
      0.005
    ],
    [
      "complimenter",
      0.005
    ],
    [
      "autoriser",
      0.005
    ],
    [
      "approuver",
      0.005
    ],
    [
      "applaudir",
      0.005
    ],
    [
      "piquer",
      0.0025
    ],
    [
      "participer",
      0.0025
    ],
    [
      "impulser",
      0.0025
    ],
    [
      "disposer",
      0.0025
    ],
    [
      "chauffer",
      0.0025
    ],
    [
      "subventionner",
      0.0025
    ]
  ],
  "etouffer": [
    [
      "arreter",
      0.065
    ],
    [
      "detruire",
      0.0375
    ],
    [
      "paralyser",
      0.0325
    ],
    [
      "supprimer",
      0.0325
    ],
    [
      "etrangler",
      0.03
    ],
    [
      "reprimer",
      0.03
    ],
    [
      "retenir",
      0.03
    ],
    [
      "empecher",
      0.03
    ],
    [
      "contenir",
      0.025
    ],
    [
      "enchainer",
      0.0225
    ],
    [
      "aneantir",
      0.0225
    ],
    [
      "cacher",
      0.02
    ],
    [
      "enrayer",
      0.02
    ],
    [
      "museler",
      0.02
    ],
    [
      "oppresser",
      0.02
    ],
    [
      "ecraser",
      0.02
    ],
    [
      "eteindre",
      0.0175
    ],
    [
      "tuer",
      0.0175
    ],
    [
      "endiguer",
      0.0175
    ],
    [
      "calmer",
      0.0175
    ],
    [
      "briser",
      0.0175
    ],
    [
      "amortir",
      0.015
    ],
    [
      "juguler",
      0.015
    ],
    [
      "mater",
      0.015
    ],
    [
      "moderer",
      0.015
    ],
    [
      "torpiller",
      0.015
    ],
    [
      "serrer",
      0.0125
    ],
    [
      "immobiliser",
      0.0125
    ],
    [
      "dissimuler",
      0.0125
    ],
    [
      "diminuer",
      0.0125
    ],
    [
      "couvrir",
      0.0125
    ],
    [
      "suffoquer",
      0.01
    ],
    [
      "stopper",
      0.01
    ],
    [
      "opprimer",
      0.01
    ],
    [
      "noyer",
      0.01
    ],
    [
      "escamoter",
      0.01
    ],
    [
      "dominer",
      0.01
    ],
    [
      "assourdir",
      0.01
    ],
    [
      "asphyxier",
      0.01
    ],
    [
      "affaiblir",
      0.01
    ],
    [
      "neutraliser",
      0.0075
    ],
    [
      "peser",
      0.0075
    ],
    [
      "refouler",
      0.0075
    ],
    [
      "rentrer",
      0.0075
    ],
    [
      "vaincre",
      0.0075
    ],
    [
      "gener",
      0.0075
    ],
    [
      "garrotter",
      0.0075
    ],
    [
      "assoupir",
      0.0075
    ],
    [
      "attenuer",
      0.0075
    ],
    [
      "baillonner",
      0.0075
    ],
    [
      "derober",
      0.0075
    ],
    [
      "enterrer",
      0.0075
    ],
    [
      "etreindre",
      0.005
    ],
    [
      "etourdir",
      0.005
    ],
    [
      "etioler",
      0.005
    ],
    [
      "surmonter",
      0.005
    ],
    [
      "sombrer",
      0.005
    ],
    [
      "refroidir",
      0.005
    ],
    [
      "ravaler",
      0.005
    ],
    [
      "ouater",
      0.005
    ],
    [
      "lutter",
      0.005
    ],
    [
      "feutrer",
      0.005
    ],
    [
      "atrophier",
      0.005
    ],
    [
      "s'etrangler",
      0.0
    ],
    [
      "subtiliser",
      0.0
    ],
    [
      "tortiller",
      0.0
    ],
    [
      "perdre",
      0.0
    ],
    [
      "encager",
      0.0
    ],
    [
      "cuire",
      0.0
    ],
    [
      "voler",
      0.0
    ]
  ],
  "fut": [
    [
      "tonneau",
      0.165
    ],
    [
      "baril",
      0.125
    ],
    [
      "barrique",
      0.125
    ],
    [
      "futaille",
      0.125
    ],
    [
      "quartaut",
      0.0825
    ],
    [
      "tige",
      0.04
    ],
    [
      "piece",
      0.04
    ],
    [
      "futaie",
      0.04
    ],
    [
      "colonne",
      0.04
    ],
    [
      "bidon",
      0.04
    ],
    [
      "arbre",
      0.04
    ],
    [
      "affut",
      0.04
    ],
    [
      "tonnelet",
      0.04
    ]
  ],
  "savon": [
    [
      "reproche",
      0.225
    ],
    [
      "semonce",
      0.18
    ],
    [
      "mercuriale",
      0.09
    ],
    [
      "lessivage",
      0.09
    ],
    [
      "engueulade",
      0.09
    ],
    [
      "attrapade",
      0.09
    ],
    [
      "admonestation",
      0.09
    ],
    [
      "lavage",
      0.0425
    ],
    [
      "poil",
      0.0425
    ],
    [
      "savonnette",
      0.0425
    ]
  ],
  "fiction": [
    [
      "allegorie",
      0.085
    ],
    [
      "chimere",
      0.085
    ],
    [
      "illusion",
      0.085
    ],
    [
      "imagination",
      0.085
    ],
    [
      "mensonge",
      0.085
    ],
    [
      "songe",
      0.0625
    ],
    [
      "simulation",
      0.0625
    ],
    [
      "invention",
      0.0625
    ],
    [
      "fable",
      0.0625
    ],
    [
      "sournoiserie",
      0.04
    ],
    [
      "reve",
      0.04
    ],
    [
      "feinte",
      0.04
    ],
    [
      "conte",
      0.04
    ],
    [
      "abstraction",
      0.04
    ],
    [
      "apologue",
      0.02
    ],
    [
      "broderie",
      0.02
    ],
    [
      "convention",
      0.02
    ],
    [
      "dissimulation",
      0.02
    ],
    [
      "fantome",
      0.02
    ]
  ],
  "securite": [
    [
      "tranquillite",
      0.13
    ],
    [
      "assurance",
      0.105
    ],
    [
      "calme",
      0.105
    ],
    [
      "paix",
      0.0775
    ],
    [
      "quietude",
      0.0775
    ],
    [
      "surete",
      0.0775
    ],
    [
      "serenite",
      0.0525
    ],
    [
      "repos",
      0.0525
    ],
    [
      "police",
      0.0525
    ],
    [
      "ordre",
      0.0525
    ],
    [
      "confiance",
      0.0525
    ],
    [
      "abandon",
      0.025
    ],
    [
      "abri",
      0.025
    ],
    [
      "airain",
      0.025
    ],
    [
      "ataraxie",
      0.025
    ],
    [
      "fiabilite",
      0.025
    ],
    [
      "parade",
      0.025
    ]
  ],
  "perfection": [
    [
      "beaute",
      0.0675
    ],
    [
      "bien",
      0.055
    ],
    [
      "phenix",
      0.055
    ],
    [
      "vertu",
      0.055
    ],
    [
      "tresor",
      0.0425
    ],
    [
      "ideal",
      0.0425
    ],
    [
      "beau",
      0.0425
    ],
    [
      "achevement",
      0.0425
    ],
    [
      "perle",
      0.0325
    ],
    [
      "merveille",
      0.0325
    ],
    [
      "excellence",
      0.0325
    ],
    [
      "couronnement",
      0.0325
    ],
    [
      "bonte",
      0.0325
    ],
    [
      "bijou",
      0.0325
    ],
    [
      "epanouissement",
      0.02
    ],
    [
      "summum",
      0.02
    ],
    [
      "sommet",
      0.02
    ],
    [
      "qualite",
      0.02
    ],
    [
      "purete",
      0.02
    ],
    [
      "parachevement",
      0.02
    ],
    [
      "fleur",
      0.02
    ],
    [
      "fin",
      0.02
    ],
    [
      "fignolage",
      0.02
    ],
    [
      "consommation",
      0.02
    ],
    [
      "absolu",
      0.02
    ],
    [
      "saintete",
      0.01
    ],
    [
      "sublimite",
      0.01
    ],
    [
      "sureminence",
      0.01
    ],
    [
      "transcendance",
      0.01
    ],
    [
      "precellence",
      0.01
    ],
    [
      "merite",
      0.01
    ],
    [
      "maturite",
      0.01
    ],
    [
      "fini",
      0.01
    ],
    [
      "bijouterie",
      0.01
    ],
    [
      "ange",
      0.01
    ],
    [
      "elegance",
      0.01
    ]
  ],
  "rare": [
    [
      "extraordinaire",
      0.1325
    ],
    [
      "original",
      0.08
    ],
    [
      "etonnant",
      0.08
    ],
    [
      "inusite",
      0.0675
    ],
    [
      "singulier",
      0.0625
    ],
    [
      "exceptionnel",
      0.0575
    ],
    [
      "inhabituel",
      0.0425
    ],
    [
      "etrange",
      0.0425
    ],
    [
      "sensationnel",
      0.03
    ],
    [
      "remarquable",
      0.03
    ],
    [
      "insolite",
      0.03
    ],
    [
      "bizarre",
      0.03
    ],
    [
      "exquis",
      0.025
    ],
    [
      "precieux",
      0.025
    ],
    [
      "unique",
      0.025
    ],
    [
      "incomparable",
      0.02
    ],
    [
      "inaccoutume",
      0.02
    ],
    [
      "distingue",
      0.02
    ],
    [
      "clairseme",
      0.015
    ],
    [
      "signale",
      0.01
    ],
    [
      "notable",
      0.01
    ],
    [
      "merveilleux",
      0.01
    ],
    [
      "introuvable",
      0.01
    ],
    [
      "inappreciable",
      0.01
    ],
    [
      "difficile",
      0.01
    ],
    [
      "curieux",
      0.01
    ],
    [
      "un",
      0.0025
    ],
    [
      "recherche",
      0.0025
    ],
    [
      "rarefie",
      0.0025
    ],
    [
      "maigri",
      0.0025
    ],
    [
      "inusuel",
      0.0025
    ],
    [
      "inconnu",
      0.0025
    ],
    [
      "heureux",
      0.0025
    ],
    [
      "espace",
      0.0025
    ],
    [
      "clair",
      0.0025
    ],
    [
      "cher",
      0.0025
    ],
    [
      "avare",
      0.0025
    ],
    [
      "accidentel",
      0.0025
    ],
    [
      "epique",
      0.0025
    ]
  ],
  "adorable": [
    [
      "beau",
      0.1425
    ],
    [
      "charmant",
      0.1125
    ],
    [
      "joli",
      0.1025
    ],
    [
      "aimable",
      0.075
    ],
    [
      "gracieux",
      0.075
    ],
    [
      "merveilleux",
      0.065
    ],
    [
      "gentil",
      0.0475
    ],
    [
      "exquis",
      0.0475
    ],
    [
      "delicieux",
      0.0475
    ],
    [
      "admirable",
      0.0375
    ],
    [
      "ravissant",
      0.0375
    ],
    [
      "plaisant",
      0.0275
    ],
    [
      "parfait",
      0.0275
    ],
    [
      "mignon",
      0.0275
    ],
    [
      "attrayant",
      0.0275
    ],
    [
      "avenant",
      0.0175
    ],
    [
      "divin",
      0.0175
    ],
    [
      "chou",
      0.0075
    ],
    [
      "incomparable",
      0.0075
    ],
    [
      "mimi",
      0.0075
    ],
    [
      "pimpant",
      0.0075
    ],
    [
      "epatant",
      0.0075
    ]
  ],
  "pincer": [
    [
      "prendre",
      0.2025
    ],
    [
      "piquer",
      0.135
    ],
    [
      "saisir",
      0.0775
    ],
    [
      "serrer",
      0.065
    ],
    [
      "epingler",
      0.0425
    ],
    [
      "surprendre",
      0.0425
    ],
    [
      "mordre",
      0.0425
    ],
    [
      "contracter",
      0.0325
    ],
    [
      "cueillir",
      0.0325
    ],
    [
      "trouver",
      0.02
    ],
    [
      "ramasser",
      0.02
    ],
    [
      "mouler",
      0.02
    ],
    [
      "harponner",
      0.02
    ],
    [
      "empoigner",
      0.02
    ],
    [
      "coincer",
      0.02
    ],
    [
      "choper",
      0.02
    ],
    [
      "chiper",
      0.02
    ],
    [
      "reprendre",
      0.01
    ],
    [
      "repincer",
      0.01
    ],
    [
      "presser",
      0.01
    ],
    [
      "piper",
      0.01
    ],
    [
      "jouer",
      0.01
    ],
    [
      "gainer",
      0.01
    ],
    [
      "dessiner",
      0.01
    ],
    [
      "bruler",
      0.01
    ],
    [
      "arquepincer",
      0.01
    ],
    [
      "aimer",
      0.01
    ],
    [
      "sangler",
      0.01
    ]
  ],
  "souleve": [
    [
      "exciter",
      0.0975
    ],
    [
      "entrainer",
      0.065
    ],
    [
      "provoquer",
      0.0575
    ],
    [
      "susciter",
      0.045
    ],
    [
      "pousser",
      0.04
    ],
    [
      "occasionner",
      0.0375
    ],
    [
      "elever",
      0.0325
    ],
    [
      "enflammer",
      0.03
    ],
    [
      "amener",
      0.0275
    ],
    [
      "determiner",
      0.0275
    ],
    [
      "attirer",
      0.025
    ],
    [
      "monter",
      0.025
    ],
    [
      "transporter",
      0.0225
    ],
    [
      "lever",
      0.0225
    ],
    [
      "exalter",
      0.0225
    ],
    [
      "causer",
      0.02
    ],
    [
      "relever",
      0.02
    ],
    [
      "appeler",
      0.0175
    ],
    [
      "faire",
      0.015
    ],
    [
      "hausser",
      0.015
    ],
    [
      "enlever",
      0.015
    ],
    [
      "dechainer",
      0.015
    ],
    [
      "conduire",
      0.015
    ],
    [
      "creer",
      0.0125
    ],
    [
      "piquer",
      0.0125
    ],
    [
      "prendre",
      0.0125
    ],
    [
      "remonter",
      0.01
    ],
    [
      "galvaniser",
      0.01
    ],
    [
      "declencher",
      0.01
    ],
    [
      "dresser",
      0.01
    ],
    [
      "apporter",
      0.01
    ],
    [
      "eveiller",
      0.0075
    ],
    [
      "emouvoir",
      0.0075
    ],
    [
      "trousser",
      0.0075
    ],
    [
      "produire",
      0.0075
    ],
    [
      "allumer",
      0.0075
    ],
    [
      "agiter",
      0.0075
    ],
    [
      "engendrer",
      0.005
    ],
    [
      "procurer",
      0.005
    ],
    [
      "redresser",
      0.005
    ],
    [
      "electriser",
      0.005
    ],
    [
      "ebranler",
      0.005
    ],
    [
      "hisser",
      0.005
    ],
    [
      "fouetter",
      0.005
    ],
    [
      "faucher",
      0.005
    ],
    [
      "ameuter",
      0.005
    ],
    [
      "ecarter",
      0.0025
    ],
    [
      "s'emparer",
      0.0025
    ],
    [
      "reveiller",
      0.0025
    ],
    [
      "retrousser",
      0.0025
    ],
    [
      "remuer",
      0.0025
    ],
    [
      "motiver",
      0.0025
    ],
    [
      "escamoter",
      0.0025
    ],
    [
      "emballer",
      0.0025
    ],
    [
      "armer",
      0.0025
    ],
    [
      "revolter",
      0.0
    ],
    [
      "poser",
      0.0
    ],
    [
      "haler",
      0.0
    ],
    [
      "gonfler",
      0.0
    ],
    [
      "enivrer",
      0.0
    ],
    [
      "surhausser",
      0.0
    ]
  ],
  "lasso": [
    [
      "corde",
      1.0
    ]
  ],
  "deviser": [
    [
      "bavarder",
      0.165
    ],
    [
      "causer",
      0.165
    ],
    [
      "converser",
      0.165
    ],
    [
      "jaboter",
      0.165
    ],
    [
      "parler",
      0.165
    ],
    [
      "s'entretenir",
      0.165
    ]
  ],
  "devise": [
    [
      "sentence",
      0.13
    ],
    [
      "slogan",
      0.085
    ],
    [
      "pensee",
      0.085
    ],
    [
      "maxime",
      0.085
    ],
    [
      "formule",
      0.085
    ],
    [
      "apophtegme",
      0.085
    ],
    [
      "parole",
      0.0425
    ],
    [
      "papier",
      0.0425
    ],
    [
      "legende",
      0.0425
    ],
    [
      "loi",
      0.0425
    ],
    [
      "inscription",
      0.0425
    ],
    [
      "embleme",
      0.0425
    ],
    [
      "change",
      0.0425
    ],
    [
      "billet",
      0.0425
    ],
    [
      "symbole",
      0.0425
    ]
  ],
  "sensationnel": [
    [
      "etonnant",
      0.1325
    ],
    [
      "extraordinaire",
      0.11
    ],
    [
      "fantastique",
      0.0625
    ],
    [
      "surprenant",
      0.05
    ],
    [
      "prodigieux",
      0.045
    ],
    [
      "merveilleux",
      0.035
    ],
    [
      "fabuleux",
      0.035
    ],
    [
      "formidable",
      0.035
    ],
    [
      "inoui",
      0.0325
    ],
    [
      "stupefiant",
      0.025
    ],
    [
      "beau",
      0.0225
    ],
    [
      "admirable",
      0.02
    ],
    [
      "enorme",
      0.02
    ],
    [
      "incroyable",
      0.0175
    ],
    [
      "phenomenal",
      0.0175
    ],
    [
      "epatant",
      0.015
    ],
    [
      "bizarre",
      0.0125
    ],
    [
      "singulier",
      0.01
    ],
    [
      "renversant",
      0.01
    ],
    [
      "grand",
      0.01
    ],
    [
      "exceptionnel",
      0.01
    ],
    [
      "ahurissant",
      0.01
    ],
    [
      "impressionnant",
      0.01
    ],
    [
      "invraisemblable",
      0.01
    ],
    [
      "terrible",
      0.01
    ],
    [
      "original",
      0.01
    ],
    [
      "faramineux",
      0.0075
    ],
    [
      "sublime",
      0.0075
    ],
    [
      "parfait",
      0.0075
    ],
    [
      "epoustouflant",
      0.0075
    ],
    [
      "etourdissant",
      0.005
    ],
    [
      "inusite",
      0.005
    ],
    [
      "fantasmagorique",
      0.005
    ],
    [
      "anormal",
      0.005
    ],
    [
      "effarant",
      0.005
    ],
    [
      "incomparable",
      0.005
    ],
    [
      "magnifique",
      0.005
    ],
    [
      "monstrueux",
      0.005
    ],
    [
      "rare",
      0.005
    ],
    [
      "mirifique",
      0.005
    ],
    [
      "insolite",
      0.005
    ],
    [
      "genial",
      0.005
    ],
    [
      "deconcertant",
      0.005
    ],
    [
      "abracadabrant",
      0.005
    ],
    [
      "gigantesque",
      0.0025
    ],
    [
      "magique",
      0.0025
    ],
    [
      "mirobolant",
      0.0025
    ],
    [
      "splendide",
      0.0025
    ],
    [
      "saisissant",
      0.0025
    ],
    [
      "magistral",
      0.0025
    ],
    [
      "inhabituel",
      0.0025
    ],
    [
      "inattendu",
      0.0025
    ],
    [
      "confondant",
      0.0025
    ],
    [
      "epouvantable",
      0.0
    ],
    [
      "ebouriffant",
      0.0
    ],
    [
      "eblouissant",
      0.0
    ],
    [
      "troublant",
      0.0
    ],
    [
      "particulier",
      0.0
    ],
    [
      "imprevu",
      0.0
    ],
    [
      "drole",
      0.0
    ],
    [
      "ecrasant",
      0.0
    ],
    [
      "special",
      0.0
    ],
    [
      "spectaculaire",
      0.0
    ],
    [
      "passionnant",
      0.0
    ],
    [
      "inedit",
      0.0
    ],
    [
      "impeccable",
      0.0
    ],
    [
      "excitant",
      0.0
    ],
    [
      "pyramidal",
      0.0
    ],
    [
      "retentissant",
      0.0
    ],
    [
      "reussi",
      0.0
    ],
    [
      "sensass",
      0.0
    ],
    [
      "superbe",
      0.0
    ],
    [
      "ebahissant",
      0.0
    ],
    [
      "miraculeux",
      0.0
    ],
    [
      "inopine",
      0.0
    ],
    [
      "inconcevable",
      0.0
    ],
    [
      "ideal",
      0.0
    ],
    [
      "fumant",
      0.0
    ],
    [
      "frappant",
      0.0
    ],
    [
      "formid",
      0.0
    ],
    [
      "esbroufant",
      0.0
    ],
    [
      "ebaubissant",
      0.0
    ]
  ],
  "simplement": [
    [
      "franchement",
      0.165
    ],
    [
      "bonnement",
      0.0625
    ],
    [
      "carrement",
      0.0625
    ],
    [
      "naturellement",
      0.0625
    ],
    [
      "seulement",
      0.0625
    ],
    [
      "sincerement",
      0.0625
    ],
    [
      "purement",
      0.04
    ],
    [
      "directement",
      0.04
    ],
    [
      "candidement",
      0.04
    ],
    [
      "sobrement",
      0.02
    ],
    [
      "sommairement",
      0.02
    ],
    [
      "spontanement",
      0.02
    ],
    [
      "uniment",
      0.02
    ],
    [
      "uniquement",
      0.02
    ],
    [
      "nument",
      0.02
    ],
    [
      "familierement",
      0.02
    ],
    [
      "clairement",
      0.02
    ],
    [
      "betement",
      0.02
    ],
    [
      "bravement",
      0.02
    ],
    [
      "aisement",
      0.02
    ]
  ],
  "energumene": [
    [
      "enrage",
      0.15
    ],
    [
      "fou",
      0.115
    ],
    [
      "furieux",
      0.0825
    ],
    [
      "passionne",
      0.0825
    ],
    [
      "fanatique",
      0.065
    ],
    [
      "forcene",
      0.065
    ],
    [
      "violent",
      0.05
    ],
    [
      "phenomene",
      0.05
    ],
    [
      "excite",
      0.05
    ],
    [
      "exalte",
      0.05
    ],
    [
      "possede",
      0.0325
    ],
    [
      "original",
      0.0325
    ],
    [
      "individu",
      0.0325
    ],
    [
      "extravagant",
      0.0325
    ],
    [
      "agite",
      0.0325
    ],
    [
      "demoniaque",
      0.015
    ],
    [
      "emporte",
      0.015
    ],
    [
      "ostrogoth",
      0.015
    ],
    [
      "quidam",
      0.015
    ]
  ],
  "tue": [
    [
      "detruire",
      0.075
    ],
    [
      "abattre",
      0.07
    ],
    [
      "aneantir",
      0.05
    ],
    [
      "ruiner",
      0.0375
    ],
    [
      "executer",
      0.03
    ],
    [
      "supprimer",
      0.03
    ],
    [
      "egorger",
      0.03
    ],
    [
      "epuiser",
      0.0275
    ],
    [
      "fatiguer",
      0.025
    ],
    [
      "demolir",
      0.025
    ],
    [
      "massacrer",
      0.02
    ],
    [
      "ereinter",
      0.02
    ],
    [
      "faucher",
      0.0175
    ],
    [
      "etrangler",
      0.0175
    ],
    [
      "etouffer",
      0.015
    ],
    [
      "liquider",
      0.015
    ],
    [
      "bousiller",
      0.015
    ],
    [
      "assassiner",
      0.015
    ],
    [
      "ecraser",
      0.0125
    ],
    [
      "zigouiller",
      0.0125
    ],
    [
      "fusiller",
      0.0125
    ],
    [
      "exterminer",
      0.0125
    ],
    [
      "descendre",
      0.0125
    ],
    [
      "assommer",
      0.0125
    ],
    [
      "prendre",
      0.01
    ],
    [
      "poignarder",
      0.01
    ],
    [
      "exceder",
      0.01
    ],
    [
      "decimer",
      0.01
    ],
    [
      "decapiter",
      0.01
    ],
    [
      "achever",
      0.01
    ],
    [
      "saigner",
      0.0075
    ],
    [
      "passer",
      0.0075
    ],
    [
      "gacher",
      0.0075
    ],
    [
      "expedier",
      0.0075
    ],
    [
      "nettoyer",
      0.005
    ],
    [
      "peiner",
      0.005
    ],
    [
      "percer",
      0.005
    ],
    [
      "ratiboiser",
      0.005
    ],
    [
      "supplicier",
      0.005
    ],
    [
      "vanner",
      0.005
    ],
    [
      "meurtrir",
      0.005
    ],
    [
      "casser",
      0.005
    ],
    [
      "extenuer",
      0.005
    ],
    [
      "foudroyer",
      0.005
    ],
    [
      "guillotiner",
      0.005
    ],
    [
      "harasser",
      0.005
    ],
    [
      "immoler",
      0.005
    ],
    [
      "occuper",
      0.0025
    ],
    [
      "pendre",
      0.0025
    ],
    [
      "sacrifier",
      0.0025
    ],
    [
      "suriner",
      0.0025
    ],
    [
      "user",
      0.0025
    ],
    [
      "etendre",
      0.0025
    ],
    [
      "occire",
      0.0025
    ],
    [
      "miner",
      0.0025
    ],
    [
      "lapider",
      0.0025
    ],
    [
      "buter",
      0.0025
    ],
    [
      "crever",
      0.0025
    ],
    [
      "desesperer",
      0.0025
    ],
    [
      "emporter",
      0.0025
    ],
    [
      "flinguer",
      0.0025
    ],
    [
      "juguler",
      0.0025
    ],
    [
      "noyer",
      0.0
    ],
    [
      "navrer",
      0.0
    ],
    [
      "moissonner",
      0.0
    ],
    [
      "lyncher",
      0.0
    ],
    [
      "pourfendre",
      0.0
    ],
    [
      "refroidir",
      0.0
    ],
    [
      "servir",
      0.0
    ],
    [
      "steriliser",
      0.0
    ],
    [
      "trucider",
      0.0
    ],
    [
      "echiner",
      0.0
    ],
    [
      "allonger",
      0.0
    ],
    [
      "avoir",
      0.0
    ],
    [
      "chagriner",
      0.0
    ],
    [
      "chouriner",
      0.0
    ],
    [
      "degeler",
      0.0
    ],
    [
      "degringoler",
      0.0
    ],
    [
      "depecher",
      0.0
    ],
    [
      "empoisonner",
      0.0
    ],
    [
      "estourbir",
      0.0
    ],
    [
      "etriper",
      0.0
    ]
  ],
  "anguille": [
    [
      "congre",
      0.3325
    ],
    [
      "couleuvre",
      0.3325
    ],
    [
      "gymnote",
      0.3325
    ]
  ],
  "cocotier": [
    [
      "palmier",
      1.0
    ]
  ],
  "morale": [
    [
      "honnete",
      0.1625
    ],
    [
      "bon",
      0.1075
    ],
    [
      "convenable",
      0.07
    ],
    [
      "irreprochable",
      0.07
    ],
    [
      "juste",
      0.07
    ],
    [
      "edifiant",
      0.0525
    ],
    [
      "vertueux",
      0.0525
    ],
    [
      "probe",
      0.0525
    ],
    [
      "exemplaire",
      0.0525
    ],
    [
      "spirituel",
      0.035
    ],
    [
      "regulier",
      0.035
    ],
    [
      "propre",
      0.035
    ],
    [
      "mental",
      0.035
    ],
    [
      "bien",
      0.035
    ],
    [
      "combativite",
      0.015
    ],
    [
      "honorable",
      0.015
    ],
    [
      "intellectuel",
      0.015
    ],
    [
      "mentalite",
      0.015
    ],
    [
      "moralisateur",
      0.015
    ],
    [
      "psychique",
      0.015
    ],
    [
      "psychisme",
      0.015
    ]
  ],
  "fresque": [
    [
      "description",
      0.165
    ],
    [
      "image",
      0.165
    ],
    [
      "peinture",
      0.165
    ],
    [
      "portrait",
      0.165
    ],
    [
      "representation",
      0.165
    ],
    [
      "tableau",
      0.165
    ]
  ],
  "exploit": [
    [
      "action",
      0.1375
    ],
    [
      "prouesse",
      0.1025
    ],
    [
      "acte",
      0.0675
    ],
    [
      "performance",
      0.0675
    ],
    [
      "trait",
      0.05
    ],
    [
      "succes",
      0.05
    ],
    [
      "fait",
      0.05
    ],
    [
      "conduite",
      0.05
    ],
    [
      "assignation",
      0.05
    ],
    [
      "sommation",
      0.0325
    ],
    [
      "geste",
      0.0325
    ],
    [
      "commandement",
      0.0325
    ],
    [
      "citation",
      0.0325
    ],
    [
      "tour",
      0.015
    ],
    [
      "signification",
      0.015
    ],
    [
      "record",
      0.015
    ],
    [
      "notification",
      0.015
    ],
    [
      "bravoure",
      0.015
    ],
    [
      "ajournement",
      0.015
    ]
  ],
  "titanesque": [
    [
      "gigantesque",
      0.1775
    ],
    [
      "enorme",
      0.15
    ],
    [
      "colossal",
      0.115
    ],
    [
      "demesure",
      0.055
    ],
    [
      "immense",
      0.055
    ],
    [
      "prodigieux",
      0.05
    ],
    [
      "monstrueux",
      0.05
    ],
    [
      "grand",
      0.05
    ],
    [
      "formidable",
      0.05
    ],
    [
      "monumental",
      0.045
    ],
    [
      "cyclopeen",
      0.0225
    ],
    [
      "fantastique",
      0.0225
    ],
    [
      "etonnant",
      0.015
    ],
    [
      "monstre",
      0.015
    ],
    [
      "geant",
      0.015
    ],
    [
      "considerable",
      0.01
    ],
    [
      "excessif",
      0.01
    ],
    [
      "incommensurable",
      0.01
    ],
    [
      "pyramidal",
      0.01
    ],
    [
      "elephantesque",
      0.01
    ],
    [
      "pelasgique",
      0.005
    ],
    [
      "prometheen",
      0.005
    ],
    [
      "insondable",
      0.005
    ],
    [
      "herculeen",
      0.005
    ],
    [
      "babylonien",
      0.005
    ],
    [
      "titanique",
      0.005
    ]
  ],
  "cadence": [
    [
      "rythme",
      0.285
    ],
    [
      "harmonie",
      0.13
    ],
    [
      "mouvement",
      0.085
    ],
    [
      "balancement",
      0.0625
    ],
    [
      "mesure",
      0.0625
    ],
    [
      "vers",
      0.0425
    ],
    [
      "remous",
      0.0425
    ],
    [
      "nombre",
      0.0425
    ],
    [
      "alternance",
      0.0425
    ],
    [
      "accord",
      0.0425
    ],
    [
      "allure",
      0.02
    ],
    [
      "debit",
      0.02
    ],
    [
      "melodie",
      0.02
    ],
    [
      "poesie",
      0.02
    ],
    [
      "regularite",
      0.02
    ],
    [
      "repetition",
      0.02
    ],
    [
      "succession",
      0.02
    ]
  ],
  "cadencer": [
    [
      "rythmer",
      0.375
    ],
    [
      "accorder",
      0.25
    ],
    [
      "conformer",
      0.125
    ],
    [
      "mesurer",
      0.125
    ],
    [
      "scander",
      0.125
    ]
  ],
  "mini": [
    [
      "court",
      0.5
    ],
    [
      "petit",
      0.5
    ]
  ],
  "flot": [
    [
      "affluence",
      0.085
    ],
    [
      "multitude",
      0.0825
    ],
    [
      "flux",
      0.0625
    ],
    [
      "debordement",
      0.0525
    ],
    [
      "masse",
      0.05
    ],
    [
      "quantite",
      0.05
    ],
    [
      "foule",
      0.045
    ],
    [
      "deluge",
      0.0425
    ],
    [
      "abondance",
      0.0375
    ],
    [
      "pluie",
      0.0375
    ],
    [
      "essaim",
      0.035
    ],
    [
      "nuee",
      0.03
    ],
    [
      "mouvement",
      0.03
    ],
    [
      "avalanche",
      0.03
    ],
    [
      "vague",
      0.0225
    ],
    [
      "afflux",
      0.0175
    ],
    [
      "maree",
      0.0175
    ],
    [
      "profusion",
      0.0175
    ],
    [
      "onde",
      0.015
    ],
    [
      "courant",
      0.015
    ],
    [
      "armee",
      0.015
    ],
    [
      "torrent",
      0.01
    ],
    [
      "peuple",
      0.01
    ],
    [
      "ondulation",
      0.01
    ],
    [
      "inondation",
      0.01
    ],
    [
      "fleuve",
      0.01
    ],
    [
      "ecoulement",
      0.0075
    ],
    [
      "volee",
      0.0075
    ],
    [
      "vent",
      0.0075
    ],
    [
      "grele",
      0.0075
    ],
    [
      "effusion",
      0.0075
    ],
    [
      "eau",
      0.0075
    ],
    [
      "cours",
      0.0075
    ],
    [
      "cohue",
      0.0075
    ],
    [
      "bouillonnement",
      0.0075
    ],
    [
      "averse",
      0.0075
    ],
    [
      "houle",
      0.0025
    ],
    [
      "jet",
      0.0025
    ],
    [
      "lame",
      0.0025
    ],
    [
      "pelletee",
      0.0025
    ],
    [
      "reflux",
      0.0025
    ],
    [
      "fil",
      0.0025
    ],
    [
      "dechainement",
      0.0025
    ],
    [
      "coulee",
      0.0025
    ],
    [
      "bouillon",
      0.0025
    ],
    [
      "batelee",
      0.0025
    ],
    [
      "bataillon",
      0.0025
    ],
    [
      "barre",
      0.0025
    ],
    [
      "armada",
      0.0025
    ],
    [
      "ruisseau",
      0.0025
    ]
  ],
  "ciao": [
    [
      "tchao",
      0.25
    ]
  ],
  "eloigne": [
    [
      "ecarter",
      0.1025
    ],
    [
      "repousser",
      0.08
    ],
    [
      "renvoyer",
      0.075
    ],
    [
      "chasser",
      0.065
    ],
    [
      "exclure",
      0.045
    ],
    [
      "refuser",
      0.045
    ],
    [
      "rejeter",
      0.04
    ],
    [
      "detourner",
      0.04
    ],
    [
      "arracher",
      0.0325
    ],
    [
      "eliminer",
      0.0325
    ],
    [
      "detacher",
      0.0275
    ],
    [
      "exiler",
      0.0225
    ],
    [
      "bannir",
      0.0225
    ],
    [
      "econduire",
      0.0175
    ],
    [
      "separer",
      0.0175
    ],
    [
      "remercier",
      0.0175
    ],
    [
      "reculer",
      0.0175
    ],
    [
      "proscrire",
      0.0175
    ],
    [
      "distraire",
      0.0175
    ],
    [
      "ajourner",
      0.0175
    ],
    [
      "retirer",
      0.0125
    ],
    [
      "deraciner",
      0.0125
    ],
    [
      "degouter",
      0.0125
    ],
    [
      "dissuader",
      0.0125
    ],
    [
      "congedier",
      0.0125
    ],
    [
      "evincer",
      0.0075
    ],
    [
      "egarer",
      0.0075
    ],
    [
      "temporiser",
      0.0075
    ],
    [
      "retarder",
      0.0075
    ],
    [
      "remettre",
      0.0075
    ],
    [
      "releguer",
      0.0075
    ],
    [
      "pousser",
      0.0075
    ],
    [
      "conjurer",
      0.0075
    ],
    [
      "differer",
      0.0075
    ],
    [
      "dissiper",
      0.0075
    ],
    [
      "debouter",
      0.0075
    ],
    [
      "decliner",
      0.0075
    ],
    [
      "desaffectionner",
      0.0075
    ],
    [
      "surseoir",
      0.0025
    ],
    [
      "devier",
      0.0025
    ],
    [
      "derouter",
      0.0025
    ],
    [
      "distancer",
      0.0025
    ],
    [
      "aliener",
      0.0025
    ],
    [
      "epargner",
      0.0025
    ]
  ],
  "pensant": [
    [
      "intelligent",
      0.3325
    ],
    [
      "pensif",
      0.3325
    ],
    [
      "raisonnable",
      0.3325
    ]
  ],
  "clone": [
    [
      "replique",
      0.5
    ],
    [
      "sosie",
      0.5
    ]
  ],
  "euro": [],
  "parmi": [
    [
      "avec",
      0.15
    ],
    [
      "dans",
      0.15
    ],
    [
      "de",
      0.0975
    ],
    [
      "entre",
      0.0975
    ],
    [
      "sur",
      0.0975
    ],
    [
      "dont",
      0.0475
    ],
    [
      "chez",
      0.0475
    ]
  ],
  "ortie": [
    [
      "actinie",
      0.25
    ],
    [
      "lamier",
      0.25
    ],
    [
      "ramie",
      0.25
    ],
    [
      "urticacee",
      0.25
    ]
  ],
  "primaire": [
    [
      "elementaire",
      0.2075
    ],
    [
      "initial",
      0.125
    ],
    [
      "primitif",
      0.125
    ],
    [
      "rudimentaire",
      0.125
    ],
    [
      "sommaire",
      0.0825
    ],
    [
      "simple",
      0.0825
    ],
    [
      "premier",
      0.0825
    ],
    [
      "cambrien",
      0.04
    ],
    [
      "fondamental",
      0.04
    ],
    [
      "paleozoique",
      0.04
    ],
    [
      "simpliste",
      0.04
    ]
  ],
  "lycee": [
    [
      "ecole",
      0.2125
    ],
    [
      "college",
      0.1275
    ],
    [
      "institution",
      0.1275
    ],
    [
      "institut",
      0.085
    ],
    [
      "pension",
      0.085
    ],
    [
      "boite",
      0.0625
    ],
    [
      "cours",
      0.0625
    ],
    [
      "gymnase",
      0.0425
    ],
    [
      "bahut",
      0.0425
    ],
    [
      "academie",
      0.0425
    ],
    [
      "athenee",
      0.02
    ],
    [
      "bazar",
      0.02
    ],
    [
      "pensionnat",
      0.02
    ]
  ],
  "deprimer": [
    [
      "abattre",
      0.1675
    ],
    [
      "fatiguer",
      0.115
    ],
    [
      "accabler",
      0.1025
    ],
    [
      "affaiblir",
      0.09
    ],
    [
      "briser",
      0.09
    ],
    [
      "epuiser",
      0.075
    ],
    [
      "diminuer",
      0.0625
    ],
    [
      "degrader",
      0.0375
    ],
    [
      "decourager",
      0.0375
    ],
    [
      "affaisser",
      0.0375
    ],
    [
      "abaisser",
      0.0375
    ],
    [
      "deprecier",
      0.025
    ],
    [
      "enfoncer",
      0.025
    ],
    [
      "vider",
      0.01
    ],
    [
      "depriser",
      0.01
    ],
    [
      "demoraliser",
      0.01
    ],
    [
      "deforcer",
      0.01
    ],
    [
      "assommer",
      0.01
    ],
    [
      "anemier",
      0.01
    ],
    [
      "enerver",
      0.01
    ]
  ],
  "deprime": [
    [
      "abattre",
      0.1675
    ],
    [
      "fatiguer",
      0.115
    ],
    [
      "accabler",
      0.1025
    ],
    [
      "affaiblir",
      0.09
    ],
    [
      "briser",
      0.09
    ],
    [
      "epuiser",
      0.075
    ],
    [
      "diminuer",
      0.0625
    ],
    [
      "degrader",
      0.0375
    ],
    [
      "decourager",
      0.0375
    ],
    [
      "affaisser",
      0.0375
    ],
    [
      "abaisser",
      0.0375
    ],
    [
      "deprecier",
      0.025
    ],
    [
      "enfoncer",
      0.025
    ],
    [
      "vider",
      0.01
    ],
    [
      "depriser",
      0.01
    ],
    [
      "demoraliser",
      0.01
    ],
    [
      "deforcer",
      0.01
    ],
    [
      "assommer",
      0.01
    ],
    [
      "anemier",
      0.01
    ],
    [
      "enerver",
      0.01
    ]
  ],
  "prisonnier": [
    [
      "captif",
      0.25
    ],
    [
      "condamne",
      0.0975
    ],
    [
      "detenu",
      0.0975
    ],
    [
      "interne",
      0.0975
    ],
    [
      "sequestre",
      0.0475
    ],
    [
      "reclus",
      0.0475
    ],
    [
      "otage",
      0.0475
    ],
    [
      "esclave",
      0.0475
    ],
    [
      "emprisonne",
      0.0475
    ],
    [
      "detentionnaire",
      0.0475
    ],
    [
      "chetif",
      0.0475
    ],
    [
      "attache",
      0.0475
    ],
    [
      "taulard",
      0.0475
    ]
  ],
  "professeur": [
    [
      "maitre",
      0.1725
    ],
    [
      "precepteur",
      0.1725
    ],
    [
      "instituteur",
      0.13
    ],
    [
      "champion",
      0.085
    ],
    [
      "pedagogue",
      0.085
    ],
    [
      "educateur",
      0.085
    ],
    [
      "prof",
      0.0425
    ],
    [
      "instructeur",
      0.0425
    ],
    [
      "enseignant",
      0.0425
    ],
    [
      "docteur",
      0.0425
    ],
    [
      "apotre",
      0.0425
    ],
    [
      "regent",
      0.0425
    ]
  ],
  "noter": [
    [
      "marquer",
      0.09
    ],
    [
      "relever",
      0.09
    ],
    [
      "inscrire",
      0.065
    ],
    [
      "remarquer",
      0.065
    ],
    [
      "consigner",
      0.055
    ],
    [
      "transcrire",
      0.0475
    ],
    [
      "mentionner",
      0.0475
    ],
    [
      "voir",
      0.04
    ],
    [
      "mettre",
      0.0325
    ],
    [
      "juger",
      0.0325
    ],
    [
      "enregistrer",
      0.0325
    ],
    [
      "copier",
      0.0325
    ],
    [
      "constater",
      0.0325
    ],
    [
      "ecrire",
      0.0225
    ],
    [
      "observer",
      0.0225
    ],
    [
      "coter",
      0.0225
    ],
    [
      "classer",
      0.0225
    ],
    [
      "apercevoir",
      0.0225
    ],
    [
      "etiqueter",
      0.015
    ],
    [
      "s'apercevoir",
      0.015
    ],
    [
      "recopier",
      0.015
    ],
    [
      "pointer",
      0.015
    ],
    [
      "jauger",
      0.015
    ],
    [
      "apprecier",
      0.015
    ],
    [
      "annoter",
      0.015
    ],
    [
      "rapporter",
      0.005
    ],
    [
      "marginer",
      0.005
    ],
    [
      "lister",
      0.005
    ],
    [
      "ficher",
      0.005
    ],
    [
      "cocher",
      0.005
    ],
    [
      "citer",
      0.005
    ],
    [
      "aviser",
      0.005
    ],
    [
      "apostiller",
      0.005
    ],
    [
      "souligner",
      0.005
    ]
  ],
  "griffonner": [
    [
      "gribouiller",
      0.2125
    ],
    [
      "ecrire",
      0.2125
    ],
    [
      "barbouiller",
      0.1425
    ],
    [
      "crayonner",
      0.1425
    ],
    [
      "dessiner",
      0.1425
    ],
    [
      "peinturlurer",
      0.07
    ],
    [
      "rediger",
      0.07
    ]
  ],
  "devanture": [
    [
      "devant",
      0.1525
    ],
    [
      "facade",
      0.1525
    ],
    [
      "vitrine",
      0.1525
    ],
    [
      "etalage",
      0.1525
    ],
    [
      "face",
      0.075
    ],
    [
      "revetement",
      0.075
    ],
    [
      "seuil",
      0.075
    ],
    [
      "vitre",
      0.075
    ],
    [
      "eventaire",
      0.075
    ]
  ],
  "emettre": [
    [
      "exhaler",
      0.08
    ],
    [
      "exprimer",
      0.08
    ],
    [
      "lancer",
      0.0625
    ],
    [
      "repandre",
      0.0625
    ],
    [
      "produire",
      0.055
    ],
    [
      "publier",
      0.045
    ],
    [
      "pousser",
      0.045
    ],
    [
      "dire",
      0.045
    ],
    [
      "prononcer",
      0.04
    ],
    [
      "proferer",
      0.04
    ],
    [
      "jeter",
      0.04
    ],
    [
      "degager",
      0.04
    ],
    [
      "avancer",
      0.03
    ],
    [
      "tirer",
      0.03
    ],
    [
      "enoncer",
      0.03
    ],
    [
      "rendre",
      0.0225
    ],
    [
      "presenter",
      0.0225
    ],
    [
      "manifester",
      0.0225
    ],
    [
      "couler",
      0.0225
    ],
    [
      "eructer",
      0.015
    ],
    [
      "risquer",
      0.015
    ],
    [
      "propager",
      0.015
    ],
    [
      "hasarder",
      0.015
    ],
    [
      "formuler",
      0.015
    ],
    [
      "exsuder",
      0.015
    ],
    [
      "essaimer",
      0.015
    ],
    [
      "radiodiffuser",
      0.005
    ],
    [
      "promulguer",
      0.005
    ],
    [
      "expulser",
      0.005
    ],
    [
      "diffuser",
      0.005
    ],
    [
      "darder",
      0.005
    ],
    [
      "aventurer",
      0.005
    ],
    [
      "articuler",
      0.005
    ],
    [
      "epandre",
      0.005
    ]
  ],
  "emission": [
    [
      "transmission",
      0.125
    ],
    [
      "flux",
      0.0825
    ],
    [
      "jet",
      0.0825
    ],
    [
      "eruption",
      0.0825
    ],
    [
      "projection",
      0.04
    ],
    [
      "representation",
      0.04
    ],
    [
      "retransmission",
      0.04
    ],
    [
      "telegraphie",
      0.04
    ],
    [
      "ecoulement",
      0.04
    ],
    [
      "ejaculation",
      0.04
    ],
    [
      "programme",
      0.04
    ],
    [
      "production",
      0.04
    ],
    [
      "irradiation",
      0.04
    ],
    [
      "finance",
      0.04
    ],
    [
      "expulsion",
      0.04
    ],
    [
      "diffusion",
      0.04
    ],
    [
      "audition",
      0.04
    ],
    [
      "emanation",
      0.04
    ]
  ],
  "rappele": [
    [
      "evoquer",
      0.135
    ],
    [
      "retracer",
      0.0825
    ],
    [
      "ressembler",
      0.05
    ],
    [
      "redire",
      0.0325
    ],
    [
      "rememorer",
      0.0325
    ],
    [
      "ressortir",
      0.0325
    ],
    [
      "reveiller",
      0.0325
    ],
    [
      "s'apparenter",
      0.0325
    ],
    [
      "raconter",
      0.0325
    ],
    [
      "mobiliser",
      0.0325
    ],
    [
      "appeler",
      0.0325
    ],
    [
      "citer",
      0.0325
    ],
    [
      "exhumer",
      0.0325
    ],
    [
      "figurer",
      0.0325
    ],
    [
      "imiter",
      0.0325
    ],
    [
      "mentionner",
      0.0325
    ],
    [
      "recouvrer",
      0.015
    ],
    [
      "remobiliser",
      0.015
    ],
    [
      "retelephoner",
      0.015
    ],
    [
      "revoquer",
      0.015
    ],
    [
      "songer",
      0.015
    ],
    [
      "ramener",
      0.015
    ],
    [
      "pendre",
      0.015
    ],
    [
      "detroner",
      0.015
    ],
    [
      "destituer",
      0.015
    ],
    [
      "commemorer",
      0.015
    ],
    [
      "bisser",
      0.015
    ],
    [
      "avoir",
      0.015
    ],
    [
      "acclamer",
      0.015
    ],
    [
      "suggerer",
      0.015
    ]
  ],
  "moque": [
    [
      "recipient",
      1.0
    ]
  ],
  "bouquiner": [
    [
      "lire",
      0.5
    ],
    [
      "s'accoupler",
      0.5
    ]
  ],
  "gamin": [
    [
      "enfant",
      0.155
    ],
    [
      "gosse",
      0.0525
    ],
    [
      "mioche",
      0.0525
    ],
    [
      "moutard",
      0.0525
    ],
    [
      "polisson",
      0.0375
    ],
    [
      "petit",
      0.0375
    ],
    [
      "marmot",
      0.0375
    ],
    [
      "galopin",
      0.0375
    ],
    [
      "espiegle",
      0.0375
    ],
    [
      "drole",
      0.0375
    ],
    [
      "petiot",
      0.03
    ],
    [
      "bebe",
      0.03
    ],
    [
      "bambin",
      0.03
    ],
    [
      "vaurien",
      0.0225
    ],
    [
      "mome",
      0.0225
    ],
    [
      "mouflet",
      0.0225
    ],
    [
      "farceur",
      0.0225
    ],
    [
      "enfantin",
      0.0225
    ],
    [
      "badin",
      0.0225
    ],
    [
      "plaisantin",
      0.015
    ],
    [
      "mutin",
      0.015
    ],
    [
      "moujingue",
      0.015
    ],
    [
      "marmouset",
      0.015
    ],
    [
      "malicieux",
      0.015
    ],
    [
      "infantile",
      0.015
    ],
    [
      "gnard",
      0.015
    ],
    [
      "garnement",
      0.015
    ],
    [
      "titi",
      0.005
    ],
    [
      "rejeton",
      0.005
    ],
    [
      "pueril",
      0.005
    ],
    [
      "pitchoun",
      0.005
    ],
    [
      "morveux",
      0.005
    ],
    [
      "marmiton",
      0.005
    ],
    [
      "heritier",
      0.005
    ],
    [
      "gavroche",
      0.005
    ],
    [
      "gars",
      0.005
    ],
    [
      "chenapan",
      0.005
    ],
    [
      "apprenti",
      0.005
    ],
    [
      "voyou",
      0.005
    ]
  ],
  "epoque": [
    [
      "temps",
      0.195
    ],
    [
      "periode",
      0.135
    ],
    [
      "siecle",
      0.105
    ],
    [
      "moment",
      0.075
    ],
    [
      "evenement",
      0.0425
    ],
    [
      "ere",
      0.0425
    ],
    [
      "age",
      0.0425
    ],
    [
      "heure",
      0.0425
    ],
    [
      "date",
      0.0425
    ],
    [
      "episode",
      0.0275
    ],
    [
      "saison",
      0.0275
    ],
    [
      "page",
      0.0275
    ],
    [
      "jours",
      0.0275
    ],
    [
      "jour",
      0.0275
    ],
    [
      "division",
      0.0275
    ],
    [
      "cycle",
      0.0125
    ],
    [
      "partie",
      0.0125
    ],
    [
      "regne",
      0.0125
    ],
    [
      "etape",
      0.0125
    ],
    [
      "etendue",
      0.0125
    ]
  ],
  "imprime": [
    [
      "marquer",
      0.105
    ],
    [
      "communiquer",
      0.0775
    ],
    [
      "donner",
      0.0775
    ],
    [
      "empreindre",
      0.065
    ],
    [
      "graver",
      0.065
    ],
    [
      "insuffler",
      0.065
    ],
    [
      "impregner",
      0.0525
    ],
    [
      "fixer",
      0.0375
    ],
    [
      "inspirer",
      0.0375
    ],
    [
      "publier",
      0.025
    ],
    [
      "paraitre",
      0.025
    ],
    [
      "inculquer",
      0.025
    ],
    [
      "frapper",
      0.025
    ],
    [
      "estamper",
      0.025
    ],
    [
      "appliquer",
      0.025
    ],
    [
      "animer",
      0.025
    ],
    [
      "jeter",
      0.0125
    ],
    [
      "lithographier",
      0.0125
    ],
    [
      "penetrer",
      0.0125
    ],
    [
      "stigmatiser",
      0.0125
    ],
    [
      "tirer",
      0.0125
    ],
    [
      "transmettre",
      0.0125
    ],
    [
      "inscrire",
      0.0125
    ],
    [
      "inculper",
      0.0125
    ],
    [
      "gaufrer",
      0.0125
    ],
    [
      "estampiller",
      0.0125
    ],
    [
      "enraciner",
      0.0125
    ],
    [
      "decalquer",
      0.0125
    ],
    [
      "composer",
      0.0125
    ],
    [
      "apposer",
      0.0125
    ],
    [
      "ancrer",
      0.0125
    ],
    [
      "editer",
      0.0125
    ]
  ],
  "imprimer": [
    [
      "marquer",
      0.105
    ],
    [
      "communiquer",
      0.0775
    ],
    [
      "donner",
      0.0775
    ],
    [
      "empreindre",
      0.065
    ],
    [
      "graver",
      0.065
    ],
    [
      "insuffler",
      0.065
    ],
    [
      "impregner",
      0.0525
    ],
    [
      "fixer",
      0.0375
    ],
    [
      "inspirer",
      0.0375
    ],
    [
      "publier",
      0.025
    ],
    [
      "paraitre",
      0.025
    ],
    [
      "inculquer",
      0.025
    ],
    [
      "frapper",
      0.025
    ],
    [
      "estamper",
      0.025
    ],
    [
      "appliquer",
      0.025
    ],
    [
      "animer",
      0.025
    ],
    [
      "jeter",
      0.0125
    ],
    [
      "lithographier",
      0.0125
    ],
    [
      "penetrer",
      0.0125
    ],
    [
      "stigmatiser",
      0.0125
    ],
    [
      "tirer",
      0.0125
    ],
    [
      "transmettre",
      0.0125
    ],
    [
      "inscrire",
      0.0125
    ],
    [
      "inculper",
      0.0125
    ],
    [
      "gaufrer",
      0.0125
    ],
    [
      "estampiller",
      0.0125
    ],
    [
      "enraciner",
      0.0125
    ],
    [
      "decalquer",
      0.0125
    ],
    [
      "composer",
      0.0125
    ],
    [
      "apposer",
      0.0125
    ],
    [
      "ancrer",
      0.0125
    ],
    [
      "editer",
      0.0125
    ]
  ],
  "entraine": [
    [
      "pousser",
      0.065
    ],
    [
      "provoquer",
      0.0575
    ],
    [
      "exciter",
      0.055
    ],
    [
      "determiner",
      0.045
    ],
    [
      "soulever",
      0.045
    ],
    [
      "attirer",
      0.0425
    ],
    [
      "amener",
      0.0375
    ],
    [
      "conduire",
      0.035
    ],
    [
      "occasionner",
      0.0275
    ],
    [
      "susciter",
      0.0275
    ],
    [
      "appeler",
      0.0225
    ],
    [
      "emporter",
      0.0225
    ],
    [
      "engager",
      0.0225
    ],
    [
      "transporter",
      0.0225
    ],
    [
      "porter",
      0.02
    ],
    [
      "produire",
      0.0175
    ],
    [
      "mener",
      0.0125
    ],
    [
      "inciter",
      0.0125
    ],
    [
      "enlever",
      0.0125
    ],
    [
      "causer",
      0.0125
    ],
    [
      "enflammer",
      0.0125
    ],
    [
      "forcer",
      0.0125
    ],
    [
      "trainer",
      0.01
    ],
    [
      "persuader",
      0.01
    ],
    [
      "inviter",
      0.01
    ],
    [
      "charmer",
      0.01
    ],
    [
      "seduire",
      0.0075
    ],
    [
      "presser",
      0.0075
    ],
    [
      "necessiter",
      0.0075
    ],
    [
      "former",
      0.0075
    ],
    [
      "engendrer",
      0.0075
    ],
    [
      "diriger",
      0.0075
    ],
    [
      "conquerir",
      0.0075
    ],
    [
      "commander",
      0.0075
    ],
    [
      "styler",
      0.0075
    ],
    [
      "jeter",
      0.0075
    ],
    [
      "exercer",
      0.0075
    ],
    [
      "dresser",
      0.0075
    ],
    [
      "contraindre",
      0.0075
    ],
    [
      "charrier",
      0.0075
    ],
    [
      "captiver",
      0.0075
    ],
    [
      "apporter",
      0.0075
    ],
    [
      "agir",
      0.0075
    ],
    [
      "tenter",
      0.005
    ],
    [
      "preparer",
      0.005
    ],
    [
      "obliger",
      0.005
    ],
    [
      "impliquer",
      0.005
    ],
    [
      "habituer",
      0.005
    ],
    [
      "embarquer",
      0.005
    ],
    [
      "creer",
      0.005
    ],
    [
      "convaincre",
      0.005
    ],
    [
      "conseiller",
      0.005
    ],
    [
      "rouler",
      0.0025
    ],
    [
      "rompre",
      0.0025
    ],
    [
      "guider",
      0.0025
    ],
    [
      "emmener",
      0.0025
    ],
    [
      "declencher",
      0.0025
    ],
    [
      "decider",
      0.0025
    ],
    [
      "dechainer",
      0.0025
    ],
    [
      "eduquer",
      0.0025
    ],
    [
      "tirer",
      0.0025
    ],
    [
      "operer",
      0.0025
    ],
    [
      "motiver",
      0.0025
    ],
    [
      "envelopper",
      0.0025
    ],
    [
      "emballer",
      0.0025
    ],
    [
      "aguerrir",
      0.0025
    ],
    [
      "eparpiller",
      0.0
    ],
    [
      "resulter",
      0.0
    ],
    [
      "resoudre",
      0.0
    ],
    [
      "galvaniser",
      0.0
    ],
    [
      "familiariser",
      0.0
    ],
    [
      "endurcir",
      0.0
    ],
    [
      "s'accompagner",
      0.0
    ],
    [
      "influencer",
      0.0
    ],
    [
      "engrener",
      0.0
    ],
    [
      "debaucher",
      0.0
    ],
    [
      "drosser",
      0.0
    ],
    [
      "actionner",
      0.0
    ],
    [
      "acclimater",
      0.0
    ],
    [
      "electriser",
      0.0
    ]
  ],
  "ceder": [
    [
      "abandonner",
      0.0725
    ],
    [
      "flechir",
      0.0575
    ],
    [
      "tomber",
      0.035
    ],
    [
      "laisser",
      0.0325
    ],
    [
      "donner",
      0.03
    ],
    [
      "capituler",
      0.03
    ],
    [
      "s'incliner",
      0.0275
    ],
    [
      "passer",
      0.025
    ],
    [
      "rompre",
      0.025
    ],
    [
      "renoncer",
      0.0225
    ],
    [
      "quitter",
      0.0225
    ],
    [
      "plier",
      0.0225
    ],
    [
      "flancher",
      0.0225
    ],
    [
      "lacher",
      0.02
    ],
    [
      "reculer",
      0.02
    ],
    [
      "s'abaisser",
      0.02
    ],
    [
      "consentir",
      0.0175
    ],
    [
      "s'effondrer",
      0.015
    ],
    [
      "s'affaisser",
      0.015
    ],
    [
      "faiblir",
      0.015
    ],
    [
      "baisser",
      0.015
    ],
    [
      "caler",
      0.0125
    ],
    [
      "s'abandonner",
      0.0125
    ],
    [
      "succomber",
      0.0125
    ],
    [
      "transmettre",
      0.01
    ],
    [
      "ployer",
      0.01
    ],
    [
      "obeir",
      0.01
    ],
    [
      "mollir",
      0.01
    ],
    [
      "fuir",
      0.01
    ],
    [
      "cesser",
      0.01
    ],
    [
      "diminuer",
      0.01
    ],
    [
      "acquiescer",
      0.01
    ],
    [
      "accorder",
      0.01
    ],
    [
      "s'enfoncer",
      0.0075
    ],
    [
      "livrer",
      0.0075
    ],
    [
      "delaisser",
      0.0075
    ],
    [
      "conceder",
      0.0075
    ],
    [
      "casser",
      0.0075
    ],
    [
      "aliener",
      0.0075
    ],
    [
      "abdiquer",
      0.0075
    ],
    [
      "vendre",
      0.005
    ],
    [
      "s'ecrouler",
      0.005
    ],
    [
      "retroceder",
      0.005
    ],
    [
      "deferer",
      0.005
    ],
    [
      "craquer",
      0.005
    ],
    [
      "condescendre",
      0.005
    ],
    [
      "refiler",
      0.0025
    ],
    [
      "s'agenouiller",
      0.0025
    ],
    [
      "s'eloigner",
      0.0025
    ],
    [
      "transferer",
      0.0025
    ],
    [
      "obtemperer",
      0.0025
    ],
    [
      "allouer",
      0.0025
    ],
    [
      "approuver",
      0.0025
    ],
    [
      "caner",
      0.0025
    ],
    [
      "composer",
      0.0025
    ],
    [
      "desarmer",
      0.0025
    ],
    [
      "transiger",
      0.0
    ],
    [
      "solder",
      0.0
    ],
    [
      "sauter",
      0.0
    ],
    [
      "s'adonner",
      0.0
    ],
    [
      "revendre",
      0.0
    ],
    [
      "broncher",
      0.0
    ],
    [
      "ecouter",
      0.0
    ]
  ],
  "grouper": [
    [
      "rassembler",
      0.14
    ],
    [
      "reunir",
      0.14
    ],
    [
      "assembler",
      0.1075
    ],
    [
      "unir",
      0.0525
    ],
    [
      "associer",
      0.045
    ],
    [
      "concentrer",
      0.045
    ],
    [
      "amasser",
      0.0375
    ],
    [
      "masser",
      0.03
    ],
    [
      "joindre",
      0.03
    ],
    [
      "ameuter",
      0.03
    ],
    [
      "accumuler",
      0.0225
    ],
    [
      "combiner",
      0.0225
    ],
    [
      "harmoniser",
      0.0225
    ],
    [
      "regrouper",
      0.0225
    ],
    [
      "federer",
      0.015
    ],
    [
      "fondre",
      0.015
    ],
    [
      "coaliser",
      0.015
    ],
    [
      "classer",
      0.015
    ],
    [
      "bloquer",
      0.015
    ],
    [
      "attrouper",
      0.015
    ],
    [
      "arranger",
      0.015
    ],
    [
      "s'associer",
      0.005
    ],
    [
      "repertorier",
      0.005
    ],
    [
      "rapprocher",
      0.005
    ],
    [
      "ranger",
      0.005
    ],
    [
      "mobiliser",
      0.005
    ],
    [
      "conjuguer",
      0.005
    ],
    [
      "condenser",
      0.005
    ],
    [
      "comprendre",
      0.005
    ],
    [
      "collectionner",
      0.005
    ],
    [
      "canaliser",
      0.005
    ],
    [
      "botteler",
      0.005
    ],
    [
      "agrouper",
      0.005
    ],
    [
      "agrandir",
      0.005
    ],
    [
      "totaliser",
      0.005
    ]
  ],
  "groupe": [
    [
      "reunion",
      0.055
    ],
    [
      "clan",
      0.055
    ],
    [
      "societe",
      0.055
    ],
    [
      "troupe",
      0.055
    ],
    [
      "association",
      0.05
    ],
    [
      "coterie",
      0.045
    ],
    [
      "assemblage",
      0.045
    ],
    [
      "bande",
      0.03
    ],
    [
      "colonie",
      0.025
    ],
    [
      "famille",
      0.025
    ],
    [
      "ensemble",
      0.0225
    ],
    [
      "armee",
      0.02
    ],
    [
      "parti",
      0.02
    ],
    [
      "bloc",
      0.02
    ],
    [
      "compagnie",
      0.0175
    ],
    [
      "ecole",
      0.0175
    ],
    [
      "cercle",
      0.015
    ],
    [
      "masse",
      0.015
    ],
    [
      "tribu",
      0.015
    ],
    [
      "unite",
      0.015
    ],
    [
      "cenacle",
      0.0125
    ],
    [
      "amas",
      0.01
    ],
    [
      "chapelle",
      0.01
    ],
    [
      "classe",
      0.01
    ],
    [
      "equipe",
      0.01
    ],
    [
      "groupement",
      0.01
    ],
    [
      "essaim",
      0.01
    ],
    [
      "division",
      0.01
    ],
    [
      "communaute",
      0.01
    ],
    [
      "bataillon",
      0.01
    ],
    [
      "secte",
      0.0075
    ],
    [
      "paquet",
      0.0075
    ],
    [
      "formation",
      0.0075
    ],
    [
      "faisceau",
      0.0075
    ],
    [
      "clique",
      0.0075
    ],
    [
      "cellule",
      0.0075
    ],
    [
      "sorte",
      0.005
    ],
    [
      "race",
      0.005
    ],
    [
      "pool",
      0.005
    ],
    [
      "pleiade",
      0.005
    ],
    [
      "ordre",
      0.005
    ],
    [
      "collection",
      0.005
    ],
    [
      "camp",
      0.005
    ],
    [
      "brigade",
      0.005
    ],
    [
      "assemblee",
      0.005
    ],
    [
      "section",
      0.005
    ],
    [
      "trust",
      0.005
    ],
    [
      "volee",
      0.005
    ],
    [
      "eglise",
      0.005
    ],
    [
      "ilot",
      0.005
    ],
    [
      "orchestre",
      0.005
    ],
    [
      "nation",
      0.005
    ],
    [
      "attroupement",
      0.005
    ],
    [
      "club",
      0.005
    ],
    [
      "cohorte",
      0.005
    ],
    [
      "espece",
      0.005
    ],
    [
      "grappe",
      0.005
    ],
    [
      "gang",
      0.0025
    ],
    [
      "loge",
      0.0025
    ],
    [
      "noyau",
      0.0025
    ],
    [
      "peloton",
      0.0025
    ],
    [
      "poignee",
      0.0025
    ],
    [
      "pate",
      0.0025
    ],
    [
      "quarteron",
      0.0025
    ],
    [
      "tendance",
      0.0025
    ],
    [
      "escouade",
      0.0025
    ],
    [
      "complexe",
      0.0025
    ],
    [
      "assortiment",
      0.0025
    ],
    [
      "bouquet",
      0.0025
    ],
    [
      "camarilla",
      0.0025
    ],
    [
      "caravane",
      0.0025
    ],
    [
      "categorie",
      0.0025
    ],
    [
      "collectif",
      0.0025
    ],
    [
      "collectivite",
      0.0025
    ],
    [
      "comite",
      0.0025
    ],
    [
      "lobby",
      0.0
    ],
    [
      "manecanterie",
      0.0
    ],
    [
      "musique",
      0.0
    ],
    [
      "peuplade",
      0.0
    ],
    [
      "phratrie",
      0.0
    ],
    [
      "regiment",
      0.0
    ],
    [
      "gruppetto",
      0.0
    ],
    [
      "fournee",
      0.0
    ],
    [
      "escadron",
      0.0
    ],
    [
      "escadrille",
      0.0
    ],
    [
      "constellation",
      0.0
    ],
    [
      "confrerie",
      0.0
    ],
    [
      "commission",
      0.0
    ],
    [
      "atelier",
      0.0
    ],
    [
      "taxon",
      0.0
    ]
  ],
  "nomade": [
    [
      "ambulant",
      0.155
    ],
    [
      "errant",
      0.125
    ],
    [
      "voyageur",
      0.125
    ],
    [
      "vagabond",
      0.0925
    ],
    [
      "mobile",
      0.0925
    ],
    [
      "instable",
      0.0925
    ],
    [
      "bohemien",
      0.0625
    ],
    [
      "saltimbanque",
      0.03
    ],
    [
      "romanichel",
      0.03
    ],
    [
      "peregrin",
      0.03
    ],
    [
      "migrateur",
      0.03
    ],
    [
      "itinerant",
      0.03
    ],
    [
      "forain",
      0.03
    ],
    [
      "changeant",
      0.03
    ],
    [
      "tzigane",
      0.03
    ]
  ],
  "stagner": [
    [
      "croupir",
      0.2
    ],
    [
      "languir",
      0.2
    ],
    [
      "vivoter",
      0.2
    ],
    [
      "macerer",
      0.1
    ],
    [
      "pietiner",
      0.1
    ],
    [
      "rester",
      0.1
    ],
    [
      "sejourner",
      0.1
    ]
  ],
  "casanier": [
    [
      "sedentaire",
      0.23
    ],
    [
      "popote",
      0.1525
    ],
    [
      "solitaire",
      0.075
    ],
    [
      "sauvage",
      0.075
    ],
    [
      "rassis",
      0.075
    ],
    [
      "pantouflard",
      0.075
    ],
    [
      "ours",
      0.075
    ],
    [
      "bourru",
      0.075
    ],
    [
      "stationnaire",
      0.075
    ]
  ],
  "castagner": [
    [
      "bigorner",
      1.0
    ]
  ],
  "promener": [
    [
      "transporter",
      0.1075
    ],
    [
      "conduire",
      0.08
    ],
    [
      "mener",
      0.08
    ],
    [
      "retarder",
      0.08
    ],
    [
      "trainer",
      0.08
    ],
    [
      "vehiculer",
      0.0525
    ],
    [
      "tromper",
      0.0525
    ],
    [
      "temporiser",
      0.0525
    ],
    [
      "sortir",
      0.0525
    ],
    [
      "porter",
      0.0525
    ],
    [
      "lanterner",
      0.0525
    ],
    [
      "guider",
      0.025
    ],
    [
      "emmener",
      0.025
    ],
    [
      "balader",
      0.025
    ],
    [
      "aerer",
      0.025
    ],
    [
      "amuser",
      0.025
    ],
    [
      "piloter",
      0.025
    ]
  ],
  "pantins": [
    [
      "fantoche",
      0.1
    ],
    [
      "marionnette",
      0.1
    ],
    [
      "polichinelle",
      0.0875
    ],
    [
      "bouffon",
      0.075
    ],
    [
      "arlequin",
      0.0625
    ],
    [
      "clown",
      0.0625
    ],
    [
      "guignol",
      0.0625
    ],
    [
      "turlupin",
      0.05
    ],
    [
      "saltimbanque",
      0.0375
    ],
    [
      "jouet",
      0.0375
    ],
    [
      "girouette",
      0.0375
    ],
    [
      "automate",
      0.025
    ],
    [
      "poupee",
      0.025
    ],
    [
      "rigolo",
      0.025
    ],
    [
      "pierrot",
      0.0125
    ],
    [
      "pupazzo",
      0.0125
    ],
    [
      "sauteur",
      0.0125
    ],
    [
      "toton",
      0.0125
    ],
    [
      "toupie",
      0.0125
    ],
    [
      "zombi",
      0.0125
    ],
    [
      "pantalon",
      0.0125
    ],
    [
      "margotin",
      0.0125
    ],
    [
      "mannequin",
      0.0125
    ],
    [
      "joujou",
      0.0125
    ],
    [
      "fantome",
      0.0125
    ],
    [
      "esclave",
      0.0125
    ],
    [
      "cameleon",
      0.0125
    ],
    [
      "burattino",
      0.0125
    ],
    [
      "bamboche",
      0.0125
    ],
    [
      "zero",
      0.0125
    ]
  ],
  "ere": [
    [
      "periode",
      0.1875
    ],
    [
      "siecle",
      0.1875
    ],
    [
      "epoque",
      0.1875
    ],
    [
      "temps",
      0.125
    ],
    [
      "age",
      0.125
    ],
    [
      "cycle",
      0.0625
    ],
    [
      "hegire",
      0.0625
    ]
  ],
  "personnage": [
    [
      "notabilite",
      0.11
    ],
    [
      "sommite",
      0.095
    ],
    [
      "personnalite",
      0.085
    ],
    [
      "homme",
      0.045
    ],
    [
      "personne",
      0.045
    ],
    [
      "type",
      0.045
    ],
    [
      "figure",
      0.0375
    ],
    [
      "quelqu'un",
      0.03
    ],
    [
      "ponte",
      0.03
    ],
    [
      "individu",
      0.03
    ],
    [
      "celebrite",
      0.03
    ],
    [
      "autorite",
      0.03
    ],
    [
      "protagoniste",
      0.0225
    ],
    [
      "principal",
      0.0225
    ],
    [
      "notable",
      0.0225
    ],
    [
      "illustration",
      0.0225
    ],
    [
      "grand",
      0.0225
    ],
    [
      "zebre",
      0.0125
    ],
    [
      "visage",
      0.0125
    ],
    [
      "manitou",
      0.0125
    ],
    [
      "heros",
      0.0125
    ],
    [
      "huile",
      0.0125
    ],
    [
      "bouffon",
      0.0125
    ],
    [
      "bonze",
      0.0125
    ],
    [
      "interlocuteur",
      0.005
    ],
    [
      "legume",
      0.005
    ],
    [
      "matador",
      0.005
    ],
    [
      "original",
      0.005
    ],
    [
      "paillasse",
      0.005
    ],
    [
      "paroissien",
      0.005
    ],
    [
      "role",
      0.005
    ],
    [
      "heroine",
      0.005
    ],
    [
      "gloire",
      0.005
    ],
    [
      "dignitaire",
      0.005
    ],
    [
      "arlequin",
      0.005
    ],
    [
      "barbon",
      0.005
    ],
    [
      "capitan",
      0.005
    ],
    [
      "citoyen",
      0.005
    ],
    [
      "coco",
      0.005
    ],
    [
      "comparse",
      0.005
    ],
    [
      "comedien",
      0.005
    ],
    [
      "coquette",
      0.005
    ],
    [
      "zigoto",
      0.005
    ]
  ],
  "coter": [
    [
      "juger",
      0.1525
    ],
    [
      "jauger",
      0.115
    ],
    [
      "noter",
      0.115
    ],
    [
      "evaluer",
      0.075
    ],
    [
      "numeroter",
      0.075
    ],
    [
      "marquer",
      0.075
    ],
    [
      "classer",
      0.075
    ],
    [
      "apprecier",
      0.075
    ],
    [
      "cataloguer",
      0.0375
    ],
    [
      "estimer",
      0.0375
    ],
    [
      "faire",
      0.0375
    ],
    [
      "folioter",
      0.0375
    ],
    [
      "paginer",
      0.0375
    ],
    [
      "tarifer",
      0.0375
    ]
  ],
  "mirage": [
    [
      "illusion",
      0.2125
    ],
    [
      "chimere",
      0.105
    ],
    [
      "reve",
      0.0875
    ],
    [
      "reverie",
      0.07
    ],
    [
      "image",
      0.0525
    ],
    [
      "vision",
      0.0525
    ],
    [
      "utopie",
      0.035
    ],
    [
      "tromperie",
      0.035
    ],
    [
      "songe",
      0.035
    ],
    [
      "irrealite",
      0.035
    ],
    [
      "impossibilite",
      0.035
    ],
    [
      "hallucination",
      0.035
    ],
    [
      "apparence",
      0.035
    ],
    [
      "seduction",
      0.015
    ],
    [
      "reflet",
      0.015
    ],
    [
      "phenomene",
      0.015
    ],
    [
      "mirement",
      0.015
    ],
    [
      "mensonge",
      0.015
    ],
    [
      "leurre",
      0.015
    ],
    [
      "illusionnisme",
      0.015
    ],
    [
      "fantasmagorie",
      0.015
    ],
    [
      "attrait",
      0.015
    ]
  ],
  "vision": [
    [
      "idee",
      0.0675
    ],
    [
      "image",
      0.0625
    ],
    [
      "illusion",
      0.055
    ],
    [
      "vue",
      0.055
    ],
    [
      "hallucination",
      0.05
    ],
    [
      "spectre",
      0.045
    ],
    [
      "ombre",
      0.045
    ],
    [
      "chimere",
      0.045
    ],
    [
      "fantome",
      0.04
    ],
    [
      "reve",
      0.04
    ],
    [
      "reverie",
      0.0275
    ],
    [
      "representation",
      0.0275
    ],
    [
      "phantasme",
      0.0275
    ],
    [
      "imagination",
      0.0275
    ],
    [
      "fantasme",
      0.0275
    ],
    [
      "apparition",
      0.0275
    ],
    [
      "tableau",
      0.02
    ],
    [
      "simulacre",
      0.02
    ],
    [
      "folie",
      0.02
    ],
    [
      "aspect",
      0.02
    ],
    [
      "sentiment",
      0.015
    ],
    [
      "pressentiment",
      0.015
    ],
    [
      "obsession",
      0.015
    ],
    [
      "mirage",
      0.015
    ],
    [
      "forme",
      0.015
    ],
    [
      "divagation",
      0.015
    ],
    [
      "conception",
      0.015
    ],
    [
      "evocation",
      0.01
    ],
    [
      "spectacle",
      0.01
    ],
    [
      "revenant",
      0.01
    ],
    [
      "perspective",
      0.01
    ],
    [
      "optique",
      0.01
    ],
    [
      "hantise",
      0.01
    ],
    [
      "regard",
      0.005
    ],
    [
      "oeil",
      0.005
    ],
    [
      "mysticisme",
      0.005
    ],
    [
      "intuition",
      0.005
    ],
    [
      "extase",
      0.005
    ],
    [
      "discernement",
      0.005
    ],
    [
      "apprehension",
      0.005
    ],
    [
      "revelation",
      0.005
    ]
  ],
  "miserable": [
    [
      "pauvre",
      0.0825
    ],
    [
      "malheureux",
      0.05
    ],
    [
      "deplorable",
      0.04
    ],
    [
      "gueux",
      0.04
    ],
    [
      "necessiteux",
      0.0375
    ],
    [
      "mechant",
      0.0375
    ],
    [
      "mauvais",
      0.0375
    ],
    [
      "pietre",
      0.035
    ],
    [
      "triste",
      0.035
    ],
    [
      "insignifiant",
      0.0325
    ],
    [
      "pitoyable",
      0.03
    ],
    [
      "misereux",
      0.03
    ],
    [
      "besogneux",
      0.03
    ],
    [
      "lamentable",
      0.025
    ],
    [
      "piteux",
      0.0225
    ],
    [
      "minable",
      0.02
    ],
    [
      "miteux",
      0.0175
    ],
    [
      "chetif",
      0.015
    ],
    [
      "vil",
      0.0125
    ],
    [
      "mesquin",
      0.0125
    ],
    [
      "cruel",
      0.0125
    ],
    [
      "clochard",
      0.0125
    ],
    [
      "pouilleux",
      0.01
    ],
    [
      "mince",
      0.01
    ],
    [
      "mendiant",
      0.01
    ],
    [
      "maigre",
      0.01
    ],
    [
      "indigent",
      0.01
    ],
    [
      "funeste",
      0.01
    ],
    [
      "derisoire",
      0.01
    ],
    [
      "coquin",
      0.01
    ],
    [
      "vagabond",
      0.0075
    ],
    [
      "scelerat",
      0.0075
    ],
    [
      "meprisable",
      0.0075
    ],
    [
      "infime",
      0.0075
    ],
    [
      "horrible",
      0.0075
    ],
    [
      "affreux",
      0.0075
    ],
    [
      "facheux",
      0.005
    ],
    [
      "deguenille",
      0.005
    ],
    [
      "canaille",
      0.005
    ],
    [
      "affame",
      0.005
    ],
    [
      "marmiteux",
      0.0025
    ],
    [
      "minime",
      0.0025
    ],
    [
      "panne",
      0.0025
    ],
    [
      "paria",
      0.0025
    ],
    [
      "regrettable",
      0.0025
    ],
    [
      "ruine",
      0.0025
    ],
    [
      "malhonnete",
      0.0025
    ],
    [
      "infortune",
      0.0025
    ],
    [
      "abject",
      0.0025
    ],
    [
      "abominable",
      0.0025
    ],
    [
      "bandit",
      0.0025
    ],
    [
      "calamiteux",
      0.0025
    ],
    [
      "diable",
      0.0025
    ],
    [
      "desherite",
      0.0025
    ],
    [
      "fauche",
      0.0025
    ],
    [
      "impecunieux",
      0.0
    ],
    [
      "jeune",
      0.0
    ],
    [
      "pauvrete",
      0.0
    ],
    [
      "purotin",
      0.0
    ],
    [
      "sabouleux",
      0.0
    ],
    [
      "here",
      0.0
    ],
    [
      "honteux",
      0.0
    ],
    [
      "guenilleux",
      0.0
    ],
    [
      "claquedent",
      0.0
    ],
    [
      "cloche",
      0.0
    ],
    [
      "croquant",
      0.0
    ],
    [
      "disetteux",
      0.0
    ],
    [
      "drille",
      0.0
    ],
    [
      "dechu",
      0.0
    ],
    [
      "denue",
      0.0
    ],
    [
      "desespere",
      0.0
    ],
    [
      "vermine",
      0.0
    ]
  ],
  "rame": [
    [
      "aviron",
      0.1525
    ],
    [
      "train",
      0.075
    ],
    [
      "rameuse",
      0.075
    ],
    [
      "pieu",
      0.075
    ],
    [
      "perche",
      0.075
    ],
    [
      "paresse",
      0.075
    ],
    [
      "pagaie",
      0.075
    ],
    [
      "metro",
      0.075
    ],
    [
      "godille",
      0.075
    ],
    [
      "convoi",
      0.075
    ],
    [
      "cahier",
      0.075
    ],
    [
      "tuteur",
      0.075
    ]
  ],
  "rail": [
    [
      "couloir",
      0.25
    ],
    [
      "glissiere",
      0.25
    ],
    [
      "train",
      0.25
    ]
  ],
  "conforme": [
    [
      "convenable",
      0.1075
    ],
    [
      "juste",
      0.1075
    ],
    [
      "exact",
      0.075
    ],
    [
      "approprie",
      0.065
    ],
    [
      "vrai",
      0.0525
    ],
    [
      "semblable",
      0.0425
    ],
    [
      "fidele",
      0.0425
    ],
    [
      "assorti",
      0.0425
    ],
    [
      "seyant",
      0.0325
    ],
    [
      "orthodoxe",
      0.0325
    ],
    [
      "correct",
      0.0325
    ],
    [
      "adequat",
      0.0325
    ],
    [
      "egal",
      0.02
    ],
    [
      "similaire",
      0.02
    ],
    [
      "pareil",
      0.02
    ],
    [
      "logique",
      0.02
    ],
    [
      "identique",
      0.02
    ],
    [
      "homologue",
      0.02
    ],
    [
      "harmonieux",
      0.02
    ],
    [
      "correspondant",
      0.02
    ],
    [
      "consequent",
      0.02
    ],
    [
      "canonique",
      0.02
    ],
    [
      "analogue",
      0.02
    ],
    [
      "adapte",
      0.02
    ],
    [
      "conformiste",
      0.01
    ],
    [
      "classique",
      0.01
    ],
    [
      "canonial",
      0.01
    ],
    [
      "ajuste",
      0.01
    ],
    [
      "sincere",
      0.01
    ]
  ],
  "confort": [
    [
      "aisance",
      0.1725
    ],
    [
      "reconfort",
      0.0675
    ],
    [
      "richesse",
      0.0675
    ],
    [
      "luxe",
      0.0675
    ],
    [
      "commodite",
      0.0675
    ],
    [
      "aise",
      0.0675
    ],
    [
      "agrement",
      0.0675
    ],
    [
      "somptuosite",
      0.0325
    ],
    [
      "secours",
      0.0325
    ],
    [
      "hygiene",
      0.0325
    ],
    [
      "consolation",
      0.0325
    ],
    [
      "confortable",
      0.0325
    ],
    [
      "amelioration",
      0.0325
    ],
    [
      "aide",
      0.0325
    ],
    [
      "standing",
      0.0325
    ]
  ],
  "eduquer": [
    [
      "former",
      0.1325
    ],
    [
      "faconner",
      0.1
    ],
    [
      "instruire",
      0.0825
    ],
    [
      "styler",
      0.0575
    ],
    [
      "polir",
      0.0575
    ],
    [
      "dresser",
      0.0575
    ],
    [
      "cultiver",
      0.0575
    ],
    [
      "elever",
      0.0475
    ],
    [
      "apprendre",
      0.035
    ],
    [
      "exercer",
      0.035
    ],
    [
      "enseigner",
      0.0275
    ],
    [
      "nourrir",
      0.0225
    ],
    [
      "habituer",
      0.0225
    ],
    [
      "civiliser",
      0.0225
    ],
    [
      "affiner",
      0.0225
    ],
    [
      "eclairer",
      0.0175
    ],
    [
      "preparer",
      0.0175
    ],
    [
      "guider",
      0.0175
    ],
    [
      "gouverner",
      0.0175
    ],
    [
      "entrainer",
      0.0175
    ],
    [
      "degrossir",
      0.0175
    ],
    [
      "conduire",
      0.0175
    ],
    [
      "apprivoiser",
      0.0175
    ],
    [
      "soigner",
      0.01
    ],
    [
      "policer",
      0.01
    ],
    [
      "developper",
      0.01
    ],
    [
      "discipliner",
      0.005
    ],
    [
      "lettrer",
      0.005
    ],
    [
      "petrir",
      0.005
    ]
  ],
  "parlant": [
    [
      "bavard",
      0.145
    ],
    [
      "eloquent",
      0.1175
    ],
    [
      "causant",
      0.0875
    ],
    [
      "expressif",
      0.0875
    ],
    [
      "vivant",
      0.0575
    ],
    [
      "prolixe",
      0.0575
    ],
    [
      "loquace",
      0.0575
    ],
    [
      "exuberant",
      0.0575
    ],
    [
      "expansif",
      0.0575
    ],
    [
      "disert",
      0.0575
    ],
    [
      "significatif",
      0.0275
    ],
    [
      "ressemblant",
      0.0275
    ],
    [
      "probant",
      0.0275
    ],
    [
      "parleur",
      0.0275
    ],
    [
      "locuteur",
      0.0275
    ],
    [
      "communicatif",
      0.0275
    ],
    [
      "verbal",
      0.0275
    ]
  ],
  "decupler": [
    [
      "augmenter",
      0.3325
    ],
    [
      "doubler",
      0.3325
    ],
    [
      "multiplier",
      0.3325
    ]
  ],
  "decuple": [
    [
      "augmenter",
      0.3325
    ],
    [
      "doubler",
      0.3325
    ],
    [
      "multiplier",
      0.3325
    ]
  ],
  "plat": [
    [
      "terne",
      0.075
    ],
    [
      "insignifiant",
      0.0575
    ],
    [
      "insipide",
      0.0575
    ],
    [
      "fade",
      0.045
    ],
    [
      "mediocre",
      0.045
    ],
    [
      "banal",
      0.0425
    ],
    [
      "bas",
      0.035
    ],
    [
      "morne",
      0.035
    ],
    [
      "falot",
      0.0325
    ],
    [
      "quelconque",
      0.0275
    ],
    [
      "commun",
      0.025
    ],
    [
      "rampant",
      0.025
    ],
    [
      "servile",
      0.025
    ],
    [
      "humble",
      0.02
    ],
    [
      "inconsistant",
      0.02
    ],
    [
      "prosaique",
      0.02
    ],
    [
      "pale",
      0.02
    ],
    [
      "vil",
      0.02
    ],
    [
      "vide",
      0.0175
    ],
    [
      "monotone",
      0.0175
    ],
    [
      "mesquin",
      0.0175
    ],
    [
      "mince",
      0.0125
    ],
    [
      "pauvre",
      0.0125
    ],
    [
      "uni",
      0.0125
    ],
    [
      "egal",
      0.0125
    ],
    [
      "uniforme",
      0.01
    ],
    [
      "nul",
      0.01
    ],
    [
      "mets",
      0.01
    ],
    [
      "douceatre",
      0.01
    ],
    [
      "assiette",
      0.01
    ],
    [
      "aplati",
      0.01
    ],
    [
      "plan",
      0.005
    ],
    [
      "prosterne",
      0.005
    ],
    [
      "sot",
      0.005
    ],
    [
      "souple",
      0.005
    ],
    [
      "vaisselle",
      0.005
    ],
    [
      "ecrase",
      0.005
    ],
    [
      "piece",
      0.005
    ],
    [
      "obsequieux",
      0.005
    ],
    [
      "camus",
      0.005
    ],
    [
      "decolore",
      0.005
    ],
    [
      "fadasse",
      0.005
    ],
    [
      "froid",
      0.005
    ],
    [
      "morceau",
      0.005
    ],
    [
      "mort",
      0.005
    ],
    [
      "legumier",
      0.0025
    ],
    [
      "melliflu",
      0.0025
    ],
    [
      "plain",
      0.0025
    ],
    [
      "plateau",
      0.0025
    ],
    [
      "platee",
      0.0025
    ],
    [
      "ras",
      0.0025
    ],
    [
      "ravier",
      0.0025
    ],
    [
      "repas",
      0.0025
    ],
    [
      "serf",
      0.0025
    ],
    [
      "service",
      0.0025
    ],
    [
      "specialite",
      0.0025
    ],
    [
      "stupide",
      0.0025
    ],
    [
      "lisse",
      0.0025
    ],
    [
      "incolore",
      0.0025
    ],
    [
      "gris",
      0.0025
    ],
    [
      "abject",
      0.0025
    ],
    [
      "bassin",
      0.0025
    ],
    [
      "batterie",
      0.0025
    ],
    [
      "boniment",
      0.0025
    ],
    [
      "camard",
      0.0025
    ],
    [
      "compotier",
      0.0025
    ],
    [
      "contenant",
      0.0025
    ],
    [
      "degonfle",
      0.0025
    ],
    [
      "facile",
      0.0025
    ],
    [
      "fat",
      0.0025
    ],
    [
      "faience",
      0.0025
    ],
    [
      "flatterie",
      0.0025
    ],
    [
      "ecache",
      0.0025
    ]
  ],
  "assiette": [
    [
      "position",
      0.085
    ],
    [
      "assise",
      0.0625
    ],
    [
      "plat",
      0.0625
    ],
    [
      "posture",
      0.0625
    ],
    [
      "equilibre",
      0.0625
    ],
    [
      "stabilite",
      0.0425
    ],
    [
      "solidite",
      0.0425
    ],
    [
      "situation",
      0.0425
    ],
    [
      "platee",
      0.0425
    ],
    [
      "fondement",
      0.0425
    ],
    [
      "fond",
      0.0425
    ],
    [
      "base",
      0.0425
    ],
    [
      "pose",
      0.02
    ],
    [
      "repartition",
      0.02
    ],
    [
      "soubassement",
      0.02
    ],
    [
      "soucoupe",
      0.02
    ],
    [
      "tenue",
      0.02
    ],
    [
      "vaisselle",
      0.02
    ],
    [
      "fondation",
      0.02
    ],
    [
      "faience",
      0.02
    ],
    [
      "emplacement",
      0.02
    ],
    [
      "couvert",
      0.02
    ],
    [
      "contenance",
      0.02
    ],
    [
      "calotte",
      0.02
    ],
    [
      "auge",
      0.02
    ],
    [
      "assiettee",
      0.02
    ],
    [
      "angle",
      0.02
    ],
    [
      "ecuelle",
      0.02
    ]
  ],
  "figure": [
    [
      "visage",
      0.13
    ],
    [
      "air",
      0.0625
    ],
    [
      "image",
      0.0525
    ],
    [
      "apparence",
      0.0425
    ],
    [
      "tournure",
      0.0375
    ],
    [
      "tete",
      0.0325
    ],
    [
      "physionomie",
      0.03
    ],
    [
      "exterieur",
      0.03
    ],
    [
      "aspect",
      0.03
    ],
    [
      "mine",
      0.025
    ],
    [
      "face",
      0.0225
    ],
    [
      "trait",
      0.0225
    ],
    [
      "expression",
      0.02
    ],
    [
      "attitude",
      0.02
    ],
    [
      "dessin",
      0.02
    ],
    [
      "forme",
      0.0175
    ],
    [
      "portrait",
      0.0175
    ],
    [
      "representation",
      0.0175
    ],
    [
      "caractere",
      0.015
    ],
    [
      "symbole",
      0.015
    ],
    [
      "semblance",
      0.015
    ],
    [
      "type",
      0.0125
    ],
    [
      "signe",
      0.01
    ],
    [
      "maintien",
      0.01
    ],
    [
      "dehors",
      0.01
    ],
    [
      "contenance",
      0.01
    ],
    [
      "bouille",
      0.01
    ],
    [
      "binette",
      0.01
    ],
    [
      "masque",
      0.01
    ],
    [
      "illustration",
      0.01
    ],
    [
      "facies",
      0.01
    ],
    [
      "bille",
      0.01
    ],
    [
      "disposition",
      0.0075
    ],
    [
      "effigie",
      0.0075
    ],
    [
      "front",
      0.0075
    ],
    [
      "tableau",
      0.0075
    ],
    [
      "personnage",
      0.005
    ],
    [
      "gravure",
      0.005
    ],
    [
      "facade",
      0.005
    ],
    [
      "tenue",
      0.005
    ],
    [
      "structure",
      0.005
    ],
    [
      "statue",
      0.005
    ],
    [
      "gueule",
      0.005
    ],
    [
      "graphique",
      0.005
    ],
    [
      "frimousse",
      0.005
    ],
    [
      "configuration",
      0.005
    ],
    [
      "allegorie",
      0.005
    ],
    [
      "personnalite",
      0.0025
    ],
    [
      "paysage",
      0.0025
    ],
    [
      "empreinte",
      0.0025
    ],
    [
      "embleme",
      0.0025
    ],
    [
      "caricature",
      0.0025
    ],
    [
      "poire",
      0.0
    ],
    [
      "pomme",
      0.0
    ],
    [
      "profil",
      0.0
    ],
    [
      "role",
      0.0
    ],
    [
      "sommite",
      0.0
    ],
    [
      "trace",
      0.0
    ],
    [
      "trombine",
      0.0
    ],
    [
      "planche",
      0.0
    ],
    [
      "metaphore",
      0.0
    ],
    [
      "balle",
      0.0
    ],
    [
      "bobine",
      0.0
    ],
    [
      "bosse",
      0.0
    ],
    [
      "conformation",
      0.0
    ],
    [
      "estampe",
      0.0
    ],
    [
      "fiole",
      0.0
    ],
    [
      "minois",
      0.0
    ],
    [
      "margoulette",
      0.0
    ],
    [
      "marine",
      0.0
    ],
    [
      "notabilite",
      0.0
    ],
    [
      "ornement",
      0.0
    ],
    [
      "quelqu'un",
      0.0
    ],
    [
      "reproduction",
      0.0
    ],
    [
      "schema",
      0.0
    ],
    [
      "totem",
      0.0
    ],
    [
      "trogne",
      0.0
    ],
    [
      "trompette",
      0.0
    ],
    [
      "vignette",
      0.0
    ],
    [
      "ecorche",
      0.0
    ],
    [
      "mannequin",
      0.0
    ],
    [
      "lithographie",
      0.0
    ],
    [
      "buste",
      0.0
    ],
    [
      "cafetiere",
      0.0
    ],
    [
      "caillou",
      0.0
    ],
    [
      "chiffre",
      0.0
    ],
    [
      "couleur",
      0.0
    ],
    [
      "enseigne",
      0.0
    ],
    [
      "figurine",
      0.0
    ],
    [
      "gestalt",
      0.0
    ],
    [
      "hieroglyphe",
      0.0
    ],
    [
      "hure",
      0.0
    ],
    [
      "idole",
      0.0
    ],
    [
      "bouillotte",
      0.0
    ]
  ],
  "figurer": [
    [
      "representer",
      0.1975
    ],
    [
      "peindre",
      0.08
    ],
    [
      "faire",
      0.07
    ],
    [
      "tracer",
      0.07
    ],
    [
      "evoquer",
      0.045
    ],
    [
      "signifier",
      0.045
    ],
    [
      "retracer",
      0.045
    ],
    [
      "reproduire",
      0.045
    ],
    [
      "dessiner",
      0.045
    ],
    [
      "exprimer",
      0.035
    ],
    [
      "symboliser",
      0.035
    ],
    [
      "etre",
      0.0225
    ],
    [
      "sculpter",
      0.0225
    ],
    [
      "rappeler",
      0.0225
    ],
    [
      "modeler",
      0.0225
    ],
    [
      "jouer",
      0.0225
    ],
    [
      "indiquer",
      0.0225
    ],
    [
      "incarner",
      0.0225
    ],
    [
      "imiter",
      0.0225
    ],
    [
      "prefigurer",
      0.01
    ],
    [
      "participer",
      0.01
    ],
    [
      "paraitre",
      0.01
    ],
    [
      "imaginer",
      0.01
    ],
    [
      "illustrer",
      0.01
    ],
    [
      "traduire",
      0.01
    ]
  ],
  "provocateur": [
    [
      "agitateur",
      0.1425
    ],
    [
      "fomentateur",
      0.1425
    ],
    [
      "excitateur",
      0.105
    ],
    [
      "provocant",
      0.07
    ],
    [
      "fomenteur",
      0.07
    ],
    [
      "fauteur",
      0.07
    ],
    [
      "excitant",
      0.07
    ],
    [
      "trublion",
      0.035
    ],
    [
      "seditieux",
      0.035
    ],
    [
      "provocatoire",
      0.035
    ],
    [
      "meneur",
      0.035
    ],
    [
      "boutefeu",
      0.035
    ],
    [
      "aguichant",
      0.035
    ],
    [
      "agressif",
      0.035
    ],
    [
      "agresseur",
      0.035
    ],
    [
      "erotique",
      0.035
    ]
  ],
  "probablement": [
    [
      "apparemment",
      0.1425
    ],
    [
      "vraisemblablement",
      0.1425
    ],
    [
      "eventuellement",
      0.1425
    ]
  ],
  "inconscient": [
    [
      "irreflechi",
      0.15
    ],
    [
      "inconsequent",
      0.0925
    ],
    [
      "insense",
      0.0925
    ],
    [
      "deraisonnable",
      0.0725
    ],
    [
      "leger",
      0.0725
    ],
    [
      "fou",
      0.055
    ],
    [
      "imprudent",
      0.055
    ],
    [
      "machinal",
      0.035
    ],
    [
      "involontaire",
      0.035
    ],
    [
      "instinctif",
      0.035
    ],
    [
      "insouciant",
      0.035
    ],
    [
      "automatique",
      0.035
    ],
    [
      "subconscient",
      0.0175
    ],
    [
      "spontane",
      0.0175
    ],
    [
      "mecanique",
      0.0175
    ],
    [
      "maboul",
      0.0175
    ],
    [
      "irresponsable",
      0.0175
    ],
    [
      "inconsidere",
      0.0175
    ],
    [
      "imaginaire",
      0.0175
    ],
    [
      "ignorant",
      0.0175
    ],
    [
      "dement",
      0.0175
    ],
    [
      "visceral",
      0.0175
    ]
  ],
  "desesperer": [
    [
      "desoler",
      0.13
    ],
    [
      "abattre",
      0.115
    ],
    [
      "affliger",
      0.085
    ],
    [
      "chagriner",
      0.085
    ],
    [
      "decourager",
      0.085
    ],
    [
      "navrer",
      0.085
    ],
    [
      "facher",
      0.0425
    ],
    [
      "consterner",
      0.0425
    ],
    [
      "ecoeurer",
      0.0275
    ],
    [
      "tuer",
      0.0275
    ],
    [
      "rebuter",
      0.0275
    ],
    [
      "peiner",
      0.0275
    ],
    [
      "lasser",
      0.0275
    ],
    [
      "fletrir",
      0.0275
    ],
    [
      "contrarier",
      0.0275
    ],
    [
      "attrister",
      0.0275
    ],
    [
      "accabler",
      0.0275
    ],
    [
      "arracher",
      0.0125
    ],
    [
      "decevoir",
      0.0125
    ],
    [
      "tourmenter",
      0.0125
    ]
  ],
  "desespere": [
    [
      "desoler",
      0.13
    ],
    [
      "abattre",
      0.115
    ],
    [
      "affliger",
      0.085
    ],
    [
      "chagriner",
      0.085
    ],
    [
      "decourager",
      0.085
    ],
    [
      "navrer",
      0.085
    ],
    [
      "facher",
      0.0425
    ],
    [
      "consterner",
      0.0425
    ],
    [
      "ecoeurer",
      0.0275
    ],
    [
      "tuer",
      0.0275
    ],
    [
      "rebuter",
      0.0275
    ],
    [
      "peiner",
      0.0275
    ],
    [
      "lasser",
      0.0275
    ],
    [
      "fletrir",
      0.0275
    ],
    [
      "contrarier",
      0.0275
    ],
    [
      "attrister",
      0.0275
    ],
    [
      "accabler",
      0.0275
    ],
    [
      "arracher",
      0.0125
    ],
    [
      "decevoir",
      0.0125
    ],
    [
      "tourmenter",
      0.0125
    ]
  ],
  "volet": [
    [
      "persienne",
      0.2
    ],
    [
      "aileron",
      0.0975
    ],
    [
      "contrevent",
      0.0975
    ],
    [
      "fermeture",
      0.0975
    ],
    [
      "jalousie",
      0.0975
    ],
    [
      "pigeonnier",
      0.0975
    ],
    [
      "rideau",
      0.0975
    ],
    [
      "vantail",
      0.0975
    ],
    [
      "volette",
      0.0975
    ]
  ],
  "salon": [
    [
      "cabinet",
      0.25
    ],
    [
      "cercle",
      0.1225
    ],
    [
      "piece",
      0.06
    ],
    [
      "musee",
      0.06
    ],
    [
      "fumoir",
      0.06
    ],
    [
      "foire",
      0.06
    ],
    [
      "exposition",
      0.06
    ],
    [
      "entourage",
      0.06
    ],
    [
      "club",
      0.06
    ],
    [
      "boudoir",
      0.06
    ],
    [
      "bal",
      0.06
    ],
    [
      "ruelle",
      0.06
    ]
  ],
  "hate": [
    [
      "precipitation",
      0.14
    ],
    [
      "celerite",
      0.0925
    ],
    [
      "promptitude",
      0.0925
    ],
    [
      "vivacite",
      0.0925
    ],
    [
      "rapidite",
      0.0775
    ],
    [
      "empressement",
      0.0625
    ],
    [
      "vitesse",
      0.0625
    ],
    [
      "impatience",
      0.045
    ],
    [
      "agitation",
      0.045
    ],
    [
      "activite",
      0.045
    ],
    [
      "enervement",
      0.03
    ],
    [
      "presse",
      0.03
    ],
    [
      "impetuosite",
      0.03
    ],
    [
      "diligence",
      0.03
    ],
    [
      "acceleration",
      0.015
    ],
    [
      "haste",
      0.015
    ],
    [
      "hatereau",
      0.015
    ]
  ],
  "hater": [
    [
      "precipiter",
      0.195
    ],
    [
      "accelerer",
      0.17
    ],
    [
      "brusquer",
      0.12
    ],
    [
      "activer",
      0.0975
    ],
    [
      "avancer",
      0.0725
    ],
    [
      "presser",
      0.0725
    ],
    [
      "trousser",
      0.0475
    ],
    [
      "forcer",
      0.0475
    ],
    [
      "expedier",
      0.0475
    ],
    [
      "depecher",
      0.0475
    ],
    [
      "anticiper",
      0.0225
    ],
    [
      "diligenter",
      0.0225
    ]
  ],
  "renouveau": [
    [
      "renaissance",
      0.17
    ],
    [
      "retour",
      0.17
    ],
    [
      "renouvellement",
      0.1125
    ],
    [
      "reveil",
      0.1125
    ],
    [
      "regain",
      0.085
    ],
    [
      "resurrection",
      0.055
    ],
    [
      "renovation",
      0.055
    ],
    [
      "reprise",
      0.055
    ],
    [
      "recrudescence",
      0.055
    ],
    [
      "recommencement",
      0.055
    ],
    [
      "printemps",
      0.0275
    ],
    [
      "revif",
      0.0275
    ]
  ],
  "satin": [
    [
      "soie",
      1.0
    ]
  ],
  "dansant": [
    [
      "ondoyant",
      1.0
    ]
  ],
  "exalte": [
    [
      "exciter",
      0.105
    ],
    [
      "enflammer",
      0.0725
    ],
    [
      "augmenter",
      0.045
    ],
    [
      "ranimer",
      0.045
    ],
    [
      "attiser",
      0.0325
    ],
    [
      "elever",
      0.0275
    ],
    [
      "stimuler",
      0.0275
    ],
    [
      "animer",
      0.0225
    ],
    [
      "pousser",
      0.0225
    ],
    [
      "louer",
      0.02
    ],
    [
      "aviver",
      0.02
    ],
    [
      "enthousiasmer",
      0.02
    ],
    [
      "relever",
      0.02
    ],
    [
      "transporter",
      0.02
    ],
    [
      "galvaniser",
      0.0175
    ],
    [
      "rehausser",
      0.0175
    ],
    [
      "reveiller",
      0.0175
    ],
    [
      "remonter",
      0.015
    ],
    [
      "soulever",
      0.015
    ],
    [
      "fortifier",
      0.015
    ],
    [
      "accroitre",
      0.015
    ],
    [
      "glorifier",
      0.0125
    ],
    [
      "revivifier",
      0.0125
    ],
    [
      "vanter",
      0.0125
    ],
    [
      "electriser",
      0.0125
    ],
    [
      "encourager",
      0.0125
    ],
    [
      "vivifier",
      0.01
    ],
    [
      "retremper",
      0.01
    ],
    [
      "hausser",
      0.01
    ],
    [
      "echauffer",
      0.01
    ],
    [
      "surexciter",
      0.01
    ],
    [
      "rechauffer",
      0.01
    ],
    [
      "grandir",
      0.01
    ],
    [
      "enfievrer",
      0.01
    ],
    [
      "aiguillonner",
      0.01
    ],
    [
      "developper",
      0.0075
    ],
    [
      "porter",
      0.005
    ],
    [
      "irriter",
      0.005
    ],
    [
      "embraser",
      0.005
    ],
    [
      "celebrer",
      0.005
    ],
    [
      "chauffer",
      0.005
    ],
    [
      "raviver",
      0.005
    ],
    [
      "proner",
      0.005
    ],
    [
      "magnifier",
      0.005
    ],
    [
      "exacerber",
      0.005
    ],
    [
      "encenser",
      0.005
    ],
    [
      "dechainer",
      0.005
    ],
    [
      "applaudir",
      0.005
    ],
    [
      "surfaire",
      0.005
    ],
    [
      "souffler",
      0.005
    ],
    [
      "renforcer",
      0.005
    ],
    [
      "ravir",
      0.005
    ],
    [
      "passionner",
      0.005
    ],
    [
      "enivrer",
      0.005
    ],
    [
      "enfler",
      0.005
    ],
    [
      "emballer",
      0.005
    ],
    [
      "admirer",
      0.005
    ],
    [
      "publier",
      0.0025
    ],
    [
      "louanger",
      0.0025
    ],
    [
      "intensifier",
      0.0025
    ],
    [
      "diviniser",
      0.0025
    ],
    [
      "emouvoir",
      0.0
    ],
    [
      "ebranler",
      0.0
    ],
    [
      "survolter",
      0.0
    ],
    [
      "redresser",
      0.0
    ],
    [
      "idealiser",
      0.0
    ],
    [
      "griser",
      0.0
    ],
    [
      "chanter",
      0.0
    ],
    [
      "benir",
      0.0
    ],
    [
      "ameliorer",
      0.0
    ],
    [
      "precher",
      0.0
    ],
    [
      "perfectionner",
      0.0
    ],
    [
      "lyriser",
      0.0
    ],
    [
      "incendier",
      0.0
    ],
    [
      "fanatiser",
      0.0
    ],
    [
      "deifier",
      0.0
    ],
    [
      "ailer",
      0.0
    ],
    [
      "ressortir",
      0.0
    ]
  ],
  "exalter": [
    [
      "exciter",
      0.105
    ],
    [
      "enflammer",
      0.0725
    ],
    [
      "augmenter",
      0.045
    ],
    [
      "ranimer",
      0.045
    ],
    [
      "attiser",
      0.0325
    ],
    [
      "elever",
      0.0275
    ],
    [
      "stimuler",
      0.0275
    ],
    [
      "animer",
      0.0225
    ],
    [
      "pousser",
      0.0225
    ],
    [
      "louer",
      0.02
    ],
    [
      "aviver",
      0.02
    ],
    [
      "enthousiasmer",
      0.02
    ],
    [
      "relever",
      0.02
    ],
    [
      "transporter",
      0.02
    ],
    [
      "galvaniser",
      0.0175
    ],
    [
      "rehausser",
      0.0175
    ],
    [
      "reveiller",
      0.0175
    ],
    [
      "remonter",
      0.015
    ],
    [
      "soulever",
      0.015
    ],
    [
      "fortifier",
      0.015
    ],
    [
      "accroitre",
      0.015
    ],
    [
      "glorifier",
      0.0125
    ],
    [
      "revivifier",
      0.0125
    ],
    [
      "vanter",
      0.0125
    ],
    [
      "electriser",
      0.0125
    ],
    [
      "encourager",
      0.0125
    ],
    [
      "vivifier",
      0.01
    ],
    [
      "retremper",
      0.01
    ],
    [
      "hausser",
      0.01
    ],
    [
      "echauffer",
      0.01
    ],
    [
      "surexciter",
      0.01
    ],
    [
      "rechauffer",
      0.01
    ],
    [
      "grandir",
      0.01
    ],
    [
      "enfievrer",
      0.01
    ],
    [
      "aiguillonner",
      0.01
    ],
    [
      "developper",
      0.0075
    ],
    [
      "porter",
      0.005
    ],
    [
      "irriter",
      0.005
    ],
    [
      "embraser",
      0.005
    ],
    [
      "celebrer",
      0.005
    ],
    [
      "chauffer",
      0.005
    ],
    [
      "raviver",
      0.005
    ],
    [
      "proner",
      0.005
    ],
    [
      "magnifier",
      0.005
    ],
    [
      "exacerber",
      0.005
    ],
    [
      "encenser",
      0.005
    ],
    [
      "dechainer",
      0.005
    ],
    [
      "applaudir",
      0.005
    ],
    [
      "surfaire",
      0.005
    ],
    [
      "souffler",
      0.005
    ],
    [
      "renforcer",
      0.005
    ],
    [
      "ravir",
      0.005
    ],
    [
      "passionner",
      0.005
    ],
    [
      "enivrer",
      0.005
    ],
    [
      "enfler",
      0.005
    ],
    [
      "emballer",
      0.005
    ],
    [
      "admirer",
      0.005
    ],
    [
      "publier",
      0.0025
    ],
    [
      "louanger",
      0.0025
    ],
    [
      "intensifier",
      0.0025
    ],
    [
      "diviniser",
      0.0025
    ],
    [
      "emouvoir",
      0.0
    ],
    [
      "ebranler",
      0.0
    ],
    [
      "survolter",
      0.0
    ],
    [
      "redresser",
      0.0
    ],
    [
      "idealiser",
      0.0
    ],
    [
      "griser",
      0.0
    ],
    [
      "chanter",
      0.0
    ],
    [
      "benir",
      0.0
    ],
    [
      "ameliorer",
      0.0
    ],
    [
      "precher",
      0.0
    ],
    [
      "perfectionner",
      0.0
    ],
    [
      "lyriser",
      0.0
    ],
    [
      "incendier",
      0.0
    ],
    [
      "fanatiser",
      0.0
    ],
    [
      "deifier",
      0.0
    ],
    [
      "ailer",
      0.0
    ],
    [
      "ressortir",
      0.0
    ]
  ],
  "surexciter": [
    [
      "exciter",
      0.1875
    ],
    [
      "enflammer",
      0.15
    ],
    [
      "attiser",
      0.1125
    ],
    [
      "exalter",
      0.075
    ],
    [
      "stimuler",
      0.065
    ],
    [
      "irriter",
      0.055
    ],
    [
      "aiguillonner",
      0.055
    ],
    [
      "aiguiser",
      0.0375
    ],
    [
      "eperonner",
      0.0275
    ],
    [
      "piquer",
      0.0275
    ],
    [
      "fouetter",
      0.0275
    ],
    [
      "exasperer",
      0.0275
    ],
    [
      "enthousiasmer",
      0.0275
    ],
    [
      "augmenter",
      0.0275
    ],
    [
      "dechainer",
      0.0175
    ],
    [
      "emouvoir",
      0.0175
    ],
    [
      "transporter",
      0.0075
    ],
    [
      "survolter",
      0.0075
    ],
    [
      "surchauffer",
      0.0075
    ],
    [
      "enfievrer",
      0.0075
    ],
    [
      "enerver",
      0.0075
    ]
  ],
  "formel": [
    [
      "certain",
      0.0925
    ],
    [
      "evident",
      0.07
    ],
    [
      "categorique",
      0.06
    ],
    [
      "positif",
      0.045
    ],
    [
      "net",
      0.04
    ],
    [
      "incontestable",
      0.04
    ],
    [
      "clair",
      0.04
    ],
    [
      "precis",
      0.0375
    ],
    [
      "absolu",
      0.0325
    ],
    [
      "indiscutable",
      0.0325
    ],
    [
      "manifeste",
      0.0325
    ],
    [
      "sur",
      0.0325
    ],
    [
      "officiel",
      0.0275
    ],
    [
      "indubitable",
      0.0275
    ],
    [
      "assure",
      0.0225
    ],
    [
      "authentique",
      0.0225
    ],
    [
      "solennel",
      0.0175
    ],
    [
      "irrefragable",
      0.0175
    ],
    [
      "indeniable",
      0.0175
    ],
    [
      "ferme",
      0.0175
    ],
    [
      "expres",
      0.0175
    ],
    [
      "decisif",
      0.0175
    ],
    [
      "dogmatique",
      0.0175
    ],
    [
      "superficiel",
      0.0125
    ],
    [
      "significatif",
      0.0125
    ],
    [
      "irrefutable",
      0.0125
    ],
    [
      "imperieux",
      0.0125
    ],
    [
      "factice",
      0.0125
    ],
    [
      "exterieur",
      0.0125
    ],
    [
      "protocolaire",
      0.0075
    ],
    [
      "postiche",
      0.0075
    ],
    [
      "plaque",
      0.0075
    ],
    [
      "invincible",
      0.0075
    ],
    [
      "imperatif",
      0.0075
    ],
    [
      "explicite",
      0.0075
    ],
    [
      "constant",
      0.0075
    ],
    [
      "theorique",
      0.0025
    ],
    [
      "stereotype",
      0.0025
    ],
    [
      "stylistique",
      0.0025
    ],
    [
      "structurel",
      0.0025
    ],
    [
      "prononce",
      0.0025
    ],
    [
      "platonique",
      0.0025
    ],
    [
      "irrevocable",
      0.0025
    ],
    [
      "formaliste",
      0.0025
    ],
    [
      "entier",
      0.0025
    ],
    [
      "declare",
      0.0025
    ],
    [
      "verbal",
      0.0025
    ]
  ],
  "raffiner": [
    [
      "quintessencier",
      0.125
    ],
    [
      "epurer",
      0.125
    ],
    [
      "subtiliser",
      0.06
    ],
    [
      "soigner",
      0.06
    ],
    [
      "purifier",
      0.06
    ],
    [
      "parfaire",
      0.06
    ],
    [
      "distiller",
      0.06
    ],
    [
      "compliquer",
      0.06
    ],
    [
      "chatier",
      0.06
    ],
    [
      "alambiquer",
      0.06
    ],
    [
      "affiner",
      0.06
    ],
    [
      "policer",
      0.03
    ],
    [
      "perler",
      0.03
    ],
    [
      "fignoler",
      0.03
    ],
    [
      "ciseler",
      0.03
    ],
    [
      "apurer",
      0.03
    ],
    [
      "rechercher",
      0.03
    ]
  ],
  "raffine": [
    [
      "quintessencier",
      0.125
    ],
    [
      "epurer",
      0.125
    ],
    [
      "subtiliser",
      0.06
    ],
    [
      "soigner",
      0.06
    ],
    [
      "purifier",
      0.06
    ],
    [
      "parfaire",
      0.06
    ],
    [
      "distiller",
      0.06
    ],
    [
      "compliquer",
      0.06
    ],
    [
      "chatier",
      0.06
    ],
    [
      "alambiquer",
      0.06
    ],
    [
      "affiner",
      0.06
    ],
    [
      "policer",
      0.03
    ],
    [
      "perler",
      0.03
    ],
    [
      "fignoler",
      0.03
    ],
    [
      "ciseler",
      0.03
    ],
    [
      "apurer",
      0.03
    ],
    [
      "rechercher",
      0.03
    ]
  ],
  "bel": [
    [
      "bon",
      0.0575
    ],
    [
      "agreable",
      0.0275
    ],
    [
      "joli",
      0.0275
    ],
    [
      "grand",
      0.0275
    ],
    [
      "charmant",
      0.02
    ],
    [
      "parfait",
      0.02
    ],
    [
      "merveilleux",
      0.0175
    ],
    [
      "aimable",
      0.0175
    ],
    [
      "superieur",
      0.015
    ],
    [
      "etonnant",
      0.015
    ],
    [
      "distingue",
      0.015
    ],
    [
      "remarquable",
      0.015
    ],
    [
      "gracieux",
      0.0125
    ],
    [
      "bien",
      0.0125
    ],
    [
      "excellent",
      0.0125
    ],
    [
      "formidable",
      0.0125
    ],
    [
      "gros",
      0.0125
    ],
    [
      "elegant",
      0.0125
    ],
    [
      "fort",
      0.0125
    ],
    [
      "delicat",
      0.0125
    ],
    [
      "brillant",
      0.01
    ],
    [
      "exquis",
      0.01
    ],
    [
      "plaisant",
      0.01
    ],
    [
      "sensationnel",
      0.01
    ],
    [
      "important",
      0.01
    ],
    [
      "admirable",
      0.01
    ],
    [
      "fameux",
      0.01
    ],
    [
      "haut",
      0.01
    ],
    [
      "heureux",
      0.01
    ],
    [
      "honnete",
      0.01
    ],
    [
      "interessant",
      0.01
    ],
    [
      "magnifique",
      0.01
    ],
    [
      "imposant",
      0.0075
    ],
    [
      "fantastique",
      0.0075
    ],
    [
      "fabuleux",
      0.0075
    ],
    [
      "doux",
      0.0075
    ],
    [
      "convenable",
      0.0075
    ],
    [
      "superbe",
      0.0075
    ],
    [
      "noble",
      0.0075
    ],
    [
      "gentil",
      0.0075
    ],
    [
      "chic",
      0.0075
    ],
    [
      "eclatant",
      0.0075
    ],
    [
      "sublime",
      0.0075
    ],
    [
      "splendide",
      0.0075
    ],
    [
      "incomparable",
      0.0075
    ],
    [
      "fin",
      0.0075
    ],
    [
      "enorme",
      0.005
    ],
    [
      "ravissant",
      0.005
    ],
    [
      "piquant",
      0.005
    ],
    [
      "genial",
      0.005
    ],
    [
      "delicieux",
      0.005
    ],
    [
      "adorable",
      0.005
    ],
    [
      "eleve",
      0.005
    ],
    [
      "seduisant",
      0.005
    ],
    [
      "riche",
      0.005
    ],
    [
      "pur",
      0.005
    ],
    [
      "poli",
      0.005
    ],
    [
      "grandiose",
      0.005
    ],
    [
      "fier",
      0.005
    ],
    [
      "enchanteur",
      0.005
    ],
    [
      "correct",
      0.005
    ],
    [
      "genereux",
      0.005
    ],
    [
      "ideal",
      0.005
    ],
    [
      "monumental",
      0.005
    ],
    [
      "eminent",
      0.005
    ],
    [
      "epatant",
      0.005
    ],
    [
      "glorieux",
      0.005
    ],
    [
      "galant",
      0.005
    ],
    [
      "divin",
      0.005
    ],
    [
      "digne",
      0.005
    ],
    [
      "coquet",
      0.005
    ],
    [
      "avantageux",
      0.005
    ],
    [
      "attrayant",
      0.005
    ],
    [
      "propice",
      0.0025
    ],
    [
      "precieux",
      0.0025
    ],
    [
      "seyant",
      0.0025
    ],
    [
      "sortable",
      0.0025
    ],
    [
      "eblouissant",
      0.0025
    ],
    [
      "majestueux",
      0.0025
    ],
    [
      "magistral",
      0.0025
    ],
    [
      "harmonieux",
      0.0025
    ],
    [
      "gai",
      0.0025
    ],
    [
      "drole",
      0.0025
    ],
    [
      "considerable",
      0.0025
    ],
    [
      "chouette",
      0.0025
    ],
    [
      "riant",
      0.0025
    ],
    [
      "habile",
      0.0025
    ],
    [
      "favorable",
      0.0025
    ],
    [
      "brave",
      0.0025
    ],
    [
      "bizarre",
      0.0025
    ],
    [
      "bienseant",
      0.0025
    ],
    [
      "accompli",
      0.0025
    ],
    [
      "juste",
      0.0025
    ],
    [
      "mignon",
      0.0025
    ],
    [
      "proportionne",
      0.0025
    ],
    [
      "radieux",
      0.0025
    ],
    [
      "sacre",
      0.0025
    ],
    [
      "serein",
      0.0025
    ],
    [
      "simple",
      0.0025
    ],
    [
      "somptueux",
      0.0025
    ],
    [
      "unique",
      0.0025
    ],
    [
      "extra",
      0.0025
    ],
    [
      "curieux",
      0.0025
    ],
    [
      "acheve",
      0.0025
    ],
    [
      "adroit",
      0.0025
    ],
    [
      "angelique",
      0.0025
    ],
    [
      "bath",
      0.0025
    ],
    [
      "beaute",
      0.0025
    ],
    [
      "cheri",
      0.0025
    ],
    [
      "civil",
      0.0025
    ],
    [
      "clair",
      0.0025
    ],
    [
      "consomme",
      0.0025
    ],
    [
      "limpide",
      0.0
    ],
    [
      "magique",
      0.0
    ],
    [
      "passionnant",
      0.0
    ],
    [
      "perfection",
      0.0
    ],
    [
      "pittoresque",
      0.0
    ],
    [
      "profond",
      0.0
    ],
    [
      "resplendissant",
      0.0
    ],
    [
      "robuste",
      0.0
    ],
    [
      "solide",
      0.0
    ],
    [
      "stupefiant",
      0.0
    ],
    [
      "vertueux",
      0.0
    ],
    [
      "honorable",
      0.0
    ],
    [
      "gras",
      0.0
    ],
    [
      "absolu",
      0.0
    ],
    [
      "biquet",
      0.0
    ],
    [
      "calme",
      0.0
    ],
    [
      "decent",
      0.0
    ],
    [
      "esthetique",
      0.0
    ],
    [
      "fichu",
      0.0
    ],
    [
      "fieffe",
      0.0
    ],
    [
      "flatteur",
      0.0
    ],
    [
      "florissant",
      0.0
    ],
    [
      "feerique",
      0.0
    ],
    [
      "paisible",
      0.0
    ],
    [
      "mirifique",
      0.0
    ],
    [
      "menteur",
      0.0
    ],
    [
      "mensonger",
      0.0
    ],
    [
      "lucratif",
      0.0
    ],
    [
      "grace",
      0.0
    ],
    [
      "poetique",
      0.0
    ],
    [
      "prospere",
      0.0
    ],
    [
      "rupin",
      0.0
    ],
    [
      "saint",
      0.0
    ],
    [
      "super",
      0.0
    ],
    [
      "select",
      0.0
    ],
    [
      "trompeur",
      0.0
    ],
    [
      "vigoureux",
      0.0
    ],
    [
      "etrange",
      0.0
    ],
    [
      "gout",
      0.0
    ],
    [
      "flirt",
      0.0
    ],
    [
      "adequat",
      0.0
    ],
    [
      "ami",
      0.0
    ],
    [
      "approprie",
      0.0
    ],
    [
      "art",
      0.0
    ],
    [
      "astucieux",
      0.0
    ],
    [
      "choisi",
      0.0
    ],
    [
      "faux",
      0.0
    ],
    [
      "estimable",
      0.0
    ],
    [
      "ensoleille",
      0.0
    ],
    [
      "enjoue",
      0.0
    ],
    [
      "celeste",
      0.0
    ],
    [
      "comique",
      0.0
    ],
    [
      "fallacieux",
      0.0
    ],
    [
      "fastueux",
      0.0
    ],
    [
      "fructueux",
      0.0
    ],
    [
      "galantin",
      0.0
    ],
    [
      "gent",
      0.0
    ],
    [
      "girond",
      0.0
    ],
    [
      "magnanime",
      0.0
    ],
    [
      "printanier",
      0.0
    ],
    [
      "sculptural",
      0.0
    ],
    [
      "desirable",
      0.0
    ],
    [
      "dru",
      0.0
    ],
    [
      "dameret",
      0.0
    ],
    [
      "bellissime",
      0.0
    ],
    [
      "bellatre",
      0.0
    ],
    [
      "coureur",
      0.0
    ],
    [
      "cultive",
      0.0
    ],
    [
      "emouvant",
      0.0
    ]
  ],
  "raisonnable": [
    [
      "bon",
      0.0875
    ],
    [
      "sage",
      0.0875
    ],
    [
      "honnete",
      0.07
    ],
    [
      "juste",
      0.055
    ],
    [
      "judicieux",
      0.05
    ],
    [
      "correct",
      0.05
    ],
    [
      "convenable",
      0.0425
    ],
    [
      "serieux",
      0.0425
    ],
    [
      "moyen",
      0.0375
    ],
    [
      "sain",
      0.0375
    ],
    [
      "pondere",
      0.0325
    ],
    [
      "droit",
      0.0275
    ],
    [
      "normal",
      0.0275
    ],
    [
      "pose",
      0.0275
    ],
    [
      "sense",
      0.0275
    ],
    [
      "reflechi",
      0.02
    ],
    [
      "modeste",
      0.02
    ],
    [
      "logique",
      0.02
    ],
    [
      "rationnel",
      0.015
    ],
    [
      "passable",
      0.015
    ],
    [
      "naturel",
      0.015
    ],
    [
      "mur",
      0.015
    ],
    [
      "modere",
      0.015
    ],
    [
      "acceptable",
      0.015
    ],
    [
      "equilibre",
      0.01
    ],
    [
      "sortable",
      0.01
    ],
    [
      "rassis",
      0.01
    ],
    [
      "prudent",
      0.01
    ],
    [
      "potable",
      0.01
    ],
    [
      "legitime",
      0.01
    ],
    [
      "intelligent",
      0.01
    ],
    [
      "adulte",
      0.01
    ],
    [
      "seyant",
      0.005
    ],
    [
      "pensant",
      0.005
    ],
    [
      "fonde",
      0.005
    ],
    [
      "consequent",
      0.005
    ],
    [
      "abordable",
      0.005
    ],
    [
      "suffisant",
      0.005
    ]
  ],
  "romancer": [
    [
      "inventer",
      0.175
    ],
    [
      "exagerer",
      0.15
    ],
    [
      "habler",
      0.125
    ],
    [
      "broder",
      0.1
    ],
    [
      "mentir",
      0.0475
    ],
    [
      "galejer",
      0.0475
    ],
    [
      "composer",
      0.0475
    ],
    [
      "blaguer",
      0.0475
    ],
    [
      "amplifier",
      0.0475
    ],
    [
      "affabuler",
      0.0225
    ],
    [
      "arranger",
      0.0225
    ],
    [
      "conter",
      0.0225
    ],
    [
      "fanfaronner",
      0.0225
    ],
    [
      "forger",
      0.0225
    ],
    [
      "echafauder",
      0.0225
    ]
  ],
  "romance": [
    [
      "chanson",
      0.2075
    ],
    [
      "rengaine",
      0.125
    ],
    [
      "bergerade",
      0.0825
    ],
    [
      "cantilene",
      0.0825
    ],
    [
      "chant",
      0.0825
    ],
    [
      "refrain",
      0.0825
    ],
    [
      "romancero",
      0.04
    ],
    [
      "roman",
      0.04
    ],
    [
      "poeme",
      0.04
    ],
    [
      "melodie",
      0.04
    ],
    [
      "complainte",
      0.04
    ],
    [
      "canzonette",
      0.04
    ],
    [
      "antienne",
      0.04
    ],
    [
      "scie",
      0.04
    ]
  ],
  "ivoire": [
    [
      "ivoirin",
      0.4
    ],
    [
      "blanc",
      0.2
    ],
    [
      "ivoirien",
      0.2
    ],
    [
      "ivoire",
      0.2
    ]
  ],
  "marie": [
    [
      "reunir",
      0.12
    ],
    [
      "unir",
      0.12
    ],
    [
      "joindre",
      0.1
    ],
    [
      "assembler",
      0.07
    ],
    [
      "fusionner",
      0.06
    ],
    [
      "combiner",
      0.06
    ],
    [
      "assortir",
      0.06
    ],
    [
      "associer",
      0.06
    ],
    [
      "allier",
      0.06
    ],
    [
      "appareiller",
      0.04
    ],
    [
      "apparier",
      0.04
    ],
    [
      "melanger",
      0.04
    ],
    [
      "lier",
      0.0275
    ],
    [
      "accompagner",
      0.0175
    ],
    [
      "meler",
      0.0175
    ],
    [
      "epouser",
      0.0075
    ],
    [
      "juxtaposer",
      0.0075
    ],
    [
      "harmoniser",
      0.0075
    ],
    [
      "entrelacer",
      0.0075
    ],
    [
      "engager",
      0.0075
    ],
    [
      "enchainer",
      0.0075
    ],
    [
      "amadouer",
      0.0075
    ],
    [
      "etablir",
      0.0075
    ]
  ],
  "caleche": [
    [
      "briska",
      1.0
    ]
  ],
  "vin": [
    [
      "piquette",
      0.12
    ],
    [
      "picrate",
      0.09
    ],
    [
      "bibine",
      0.06
    ],
    [
      "rouge",
      0.06
    ],
    [
      "vinasse",
      0.06
    ],
    [
      "pinard",
      0.03
    ],
    [
      "piot",
      0.03
    ],
    [
      "pive",
      0.03
    ],
    [
      "production",
      0.03
    ],
    [
      "produit",
      0.03
    ],
    [
      "quille",
      0.03
    ],
    [
      "reginglard",
      0.03
    ],
    [
      "rose",
      0.03
    ],
    [
      "piccolo",
      0.03
    ],
    [
      "mazout",
      0.03
    ],
    [
      "litron",
      0.03
    ],
    [
      "blanc",
      0.03
    ],
    [
      "boisson",
      0.03
    ],
    [
      "chopine",
      0.03
    ],
    [
      "criquet",
      0.03
    ],
    [
      "cru",
      0.03
    ],
    [
      "ginglet",
      0.03
    ],
    [
      "guinguet",
      0.03
    ],
    [
      "litre",
      0.03
    ],
    [
      "rouquin",
      0.03
    ]
  ],
  "embrayer": [
    [
      "engrener",
      0.5
    ],
    [
      "emboiter",
      0.25
    ]
  ],
  "cabriolet": [
    [
      "menottes",
      0.2
    ],
    [
      "torpedo",
      0.065
    ],
    [
      "tonneau",
      0.065
    ],
    [
      "tilbury",
      0.065
    ],
    [
      "tandem",
      0.065
    ],
    [
      "poucettes",
      0.065
    ],
    [
      "decapotable",
      0.065
    ],
    [
      "chaine",
      0.065
    ],
    [
      "charrette",
      0.065
    ],
    [
      "cadenas",
      0.065
    ],
    [
      "cab",
      0.065
    ],
    [
      "boghei",
      0.065
    ],
    [
      "wiski",
      0.065
    ]
  ],
  "racisme": [
    [
      "haine",
      0.5
    ],
    [
      "xenophobie",
      0.5
    ]
  ],
  "cousin": [
    [
      "ami",
      0.22
    ],
    [
      "camarade",
      0.22
    ],
    [
      "frere",
      0.22
    ],
    [
      "commere",
      0.11
    ],
    [
      "compere",
      0.11
    ],
    [
      "parent",
      0.11
    ]
  ],
  "celles": [
    [
      "tel",
      1.0
    ]
  ],
  "feminisme": [
    [
      "feminite",
      0.5
    ]
  ],
  "battu": [
    [
      "frapper",
      0.055
    ],
    [
      "rosser",
      0.03
    ],
    [
      "remuer",
      0.025
    ],
    [
      "ecraser",
      0.025
    ],
    [
      "maltraiter",
      0.0225
    ],
    [
      "vaincre",
      0.02
    ],
    [
      "blesser",
      0.0175
    ],
    [
      "triompher",
      0.0175
    ],
    [
      "ereinter",
      0.0175
    ],
    [
      "corriger",
      0.015
    ],
    [
      "etriller",
      0.0125
    ],
    [
      "cogner",
      0.0125
    ],
    [
      "agiter",
      0.0125
    ],
    [
      "attaquer",
      0.0125
    ],
    [
      "briser",
      0.0125
    ],
    [
      "malmener",
      0.0125
    ],
    [
      "rudoyer",
      0.0125
    ],
    [
      "taper",
      0.0125
    ],
    [
      "travailler",
      0.0125
    ],
    [
      "touiller",
      0.0125
    ],
    [
      "fatiguer",
      0.0125
    ],
    [
      "enfoncer",
      0.0125
    ],
    [
      "secouer",
      0.01
    ],
    [
      "fustiger",
      0.01
    ],
    [
      "frotter",
      0.01
    ],
    [
      "cingler",
      0.01
    ],
    [
      "casser",
      0.01
    ],
    [
      "brutaliser",
      0.01
    ],
    [
      "broyer",
      0.01
    ],
    [
      "fouetter",
      0.0075
    ],
    [
      "fesser",
      0.0075
    ],
    [
      "bigorner",
      0.0075
    ],
    [
      "heurter",
      0.0075
    ],
    [
      "nettoyer",
      0.0075
    ],
    [
      "piler",
      0.0075
    ],
    [
      "houspiller",
      0.005
    ],
    [
      "meurtrir",
      0.005
    ],
    [
      "pilonner",
      0.005
    ],
    [
      "pulveriser",
      0.005
    ],
    [
      "rouler",
      0.005
    ],
    [
      "souffleter",
      0.005
    ],
    [
      "demolir",
      0.005
    ],
    [
      "chatier",
      0.005
    ],
    [
      "aneantir",
      0.005
    ],
    [
      "arranger",
      0.005
    ],
    [
      "assommer",
      0.005
    ],
    [
      "bombarder",
      0.005
    ],
    [
      "bousculer",
      0.005
    ],
    [
      "brasser",
      0.005
    ],
    [
      "brosser",
      0.005
    ],
    [
      "tourner",
      0.005
    ],
    [
      "surpasser",
      0.005
    ],
    [
      "surclasser",
      0.005
    ],
    [
      "recurer",
      0.005
    ],
    [
      "osciller",
      0.005
    ],
    [
      "matraquer",
      0.005
    ],
    [
      "lutter",
      0.005
    ],
    [
      "flageller",
      0.005
    ],
    [
      "faconner",
      0.005
    ],
    [
      "defaire",
      0.005
    ],
    [
      "l'emporter",
      0.0025
    ],
    [
      "melanger",
      0.0025
    ],
    [
      "meler",
      0.0025
    ],
    [
      "soigner",
      0.0025
    ],
    [
      "tambouriner",
      0.0025
    ],
    [
      "fouiller",
      0.0025
    ],
    [
      "culbuter",
      0.0025
    ],
    [
      "combattre",
      0.0025
    ],
    [
      "ballotter",
      0.0025
    ],
    [
      "bastonner",
      0.0025
    ],
    [
      "bouler",
      0.0025
    ],
    [
      "claquer",
      0.0025
    ],
    [
      "marteler",
      0.0025
    ],
    [
      "moudre",
      0.0025
    ],
    [
      "punir",
      0.0025
    ],
    [
      "tabasser",
      0.0025
    ],
    [
      "echarper",
      0.0025
    ],
    [
      "echiner",
      0.0025
    ],
    [
      "eliminer",
      0.0025
    ],
    [
      "marquer",
      0.0025
    ],
    [
      "lyncher",
      0.0025
    ],
    [
      "gifler",
      0.0025
    ],
    [
      "astiquer",
      0.0025
    ],
    [
      "bouiller",
      0.0025
    ],
    [
      "cribler",
      0.0025
    ],
    [
      "devancer",
      0.0025
    ],
    [
      "depasser",
      0.0025
    ],
    [
      "derouiller",
      0.0025
    ],
    [
      "explorer",
      0.0025
    ],
    [
      "flotter",
      0.0025
    ],
    [
      "forger",
      0.0025
    ],
    [
      "refouler",
      0.0
    ],
    [
      "parcourir",
      0.0
    ],
    [
      "palpiter",
      0.0
    ],
    [
      "houssiner",
      0.0
    ],
    [
      "gratifier",
      0.0
    ],
    [
      "gagner",
      0.0
    ],
    [
      "s'escrimer",
      0.0
    ],
    [
      "sangler",
      0.0
    ],
    [
      "epousseter",
      0.0
    ],
    [
      "vanner",
      0.0
    ],
    [
      "torcher",
      0.0
    ],
    [
      "tanner",
      0.0
    ],
    [
      "tamponner",
      0.0
    ],
    [
      "talocher",
      0.0
    ],
    [
      "frictionner",
      0.0
    ],
    [
      "boxer",
      0.0
    ],
    [
      "bouter",
      0.0
    ],
    [
      "bourrer",
      0.0
    ],
    [
      "batailler",
      0.0
    ],
    [
      "avoir",
      0.0
    ],
    [
      "avoiner",
      0.0
    ],
    [
      "assaisonner",
      0.0
    ],
    [
      "assaillir",
      0.0
    ],
    [
      "brandiller",
      0.0
    ],
    [
      "brouiller",
      0.0
    ],
    [
      "bucher",
      0.0
    ],
    [
      "fonctionner",
      0.0
    ],
    [
      "faseyer",
      0.0
    ],
    [
      "dauber",
      0.0
    ],
    [
      "cravacher",
      0.0
    ],
    [
      "cligner",
      0.0
    ],
    [
      "canonner",
      0.0
    ],
    [
      "rechercher",
      0.0
    ],
    [
      "ralinguer",
      0.0
    ],
    [
      "rabouiller",
      0.0
    ],
    [
      "rabattre",
      0.0
    ],
    [
      "locher",
      0.0
    ],
    [
      "gourmer",
      0.0
    ],
    [
      "gauler",
      0.0
    ],
    [
      "fouler",
      0.0
    ],
    [
      "fouailler",
      0.0
    ],
    [
      "reconnaitre",
      0.0
    ],
    [
      "s'acharner",
      0.0
    ],
    [
      "tisaner",
      0.0
    ],
    [
      "testonner",
      0.0
    ],
    [
      "tatouiller",
      0.0
    ],
    [
      "tarauder",
      0.0
    ],
    [
      "talmouser",
      0.0
    ],
    [
      "sevir",
      0.0
    ],
    [
      "sonner",
      0.0
    ],
    [
      "sabouler",
      0.0
    ],
    [
      "triquer",
      0.0
    ],
    [
      "batonner",
      0.0
    ],
    [
      "bringuebaler",
      0.0
    ],
    [
      "bourrader",
      0.0
    ],
    [
      "botter",
      0.0
    ],
    [
      "blackbouler",
      0.0
    ],
    [
      "baratter",
      0.0
    ],
    [
      "attiger",
      0.0
    ],
    [
      "cabosser",
      0.0
    ],
    [
      "calotter",
      0.0
    ],
    [
      "estourbir",
      0.0
    ],
    [
      "depoussierer",
      0.0
    ],
    [
      "depiquer",
      0.0
    ],
    [
      "debattre",
      0.0
    ],
    [
      "disperser",
      0.0
    ],
    [
      "damer",
      0.0
    ],
    [
      "clignoter",
      0.0
    ],
    [
      "carder",
      0.0
    ],
    [
      "arpenter",
      0.0
    ]
  ],
  "connerie": [
    [
      "betise",
      0.105
    ],
    [
      "idiotie",
      0.105
    ],
    [
      "sottise",
      0.105
    ],
    [
      "stupidite",
      0.0875
    ],
    [
      "cretinisme",
      0.07
    ],
    [
      "faute",
      0.0525
    ],
    [
      "baliverne",
      0.0525
    ],
    [
      "anerie",
      0.035
    ],
    [
      "maladresse",
      0.035
    ],
    [
      "cretinerie",
      0.035
    ],
    [
      "couillonnade",
      0.035
    ],
    [
      "bagatelle",
      0.035
    ],
    [
      "abrutissement",
      0.035
    ],
    [
      "futilite",
      0.0175
    ],
    [
      "frivolite",
      0.0175
    ],
    [
      "foutaise",
      0.0175
    ],
    [
      "folie",
      0.0175
    ],
    [
      "deconnage",
      0.0175
    ],
    [
      "bevue",
      0.0175
    ],
    [
      "bricole",
      0.0175
    ],
    [
      "billevesee",
      0.0175
    ],
    [
      "babiole",
      0.0175
    ],
    [
      "abetissement",
      0.0175
    ],
    [
      "manquement",
      0.0175
    ]
  ],
  "immigre": [
    [
      "immigrant",
      0.3325
    ],
    [
      "emigre",
      0.3325
    ],
    [
      "etranger",
      0.3325
    ]
  ],
  "immigrer": [],
  "colonie": [
    [
      "groupe",
      0.1075
    ],
    [
      "reunion",
      0.085
    ],
    [
      "association",
      0.0775
    ],
    [
      "agglomeration",
      0.065
    ],
    [
      "bande",
      0.065
    ],
    [
      "clan",
      0.065
    ],
    [
      "societe",
      0.065
    ],
    [
      "coterie",
      0.05
    ],
    [
      "compagnie",
      0.0425
    ],
    [
      "assemblage",
      0.0425
    ],
    [
      "etablissement",
      0.035
    ],
    [
      "ensemble",
      0.02
    ],
    [
      "famille",
      0.02
    ],
    [
      "ecole",
      0.02
    ],
    [
      "horde",
      0.0125
    ],
    [
      "plantation",
      0.0125
    ],
    [
      "possession",
      0.0125
    ],
    [
      "union",
      0.0125
    ],
    [
      "harde",
      0.0125
    ],
    [
      "essaim",
      0.0125
    ],
    [
      "empire",
      0.0125
    ],
    [
      "cenacle",
      0.0125
    ],
    [
      "culture",
      0.0125
    ],
    [
      "camp",
      0.0125
    ],
    [
      "mandat",
      0.005
    ],
    [
      "peuplement",
      0.005
    ],
    [
      "protectorat",
      0.005
    ],
    [
      "ruche",
      0.005
    ],
    [
      "fondation",
      0.005
    ],
    [
      "factorerie",
      0.005
    ],
    [
      "dominion",
      0.005
    ],
    [
      "comptoir",
      0.005
    ],
    [
      "communaute",
      0.005
    ],
    [
      "commonwealth",
      0.005
    ],
    [
      "banc",
      0.005
    ],
    [
      "tutelle",
      0.005
    ]
  ],
  "siens": [
    [
      "leur",
      1.0
    ]
  ],
  "couter": [
    [
      "attirer",
      0.1375
    ],
    [
      "faire",
      0.1375
    ],
    [
      "provoquer",
      0.1025
    ],
    [
      "valoir",
      0.1025
    ],
    [
      "susciter",
      0.0675
    ],
    [
      "prendre",
      0.0675
    ],
    [
      "occasionner",
      0.0675
    ],
    [
      "engager",
      0.0675
    ],
    [
      "deplaire",
      0.0325
    ],
    [
      "peser",
      0.0325
    ],
    [
      "representer",
      0.0325
    ],
    [
      "revenir",
      0.0325
    ],
    [
      "s'elever",
      0.0325
    ]
  ],
  "charter": [
    [
      "affretement",
      0.3325
    ],
    [
      "affreteur",
      0.3325
    ],
    [
      "avion",
      0.3325
    ]
  ],
  "suedois": [],
  "bucolique": [
    [
      "agreste",
      0.1325
    ],
    [
      "eglogue",
      0.1325
    ],
    [
      "bergerie",
      0.1
    ],
    [
      "pastoral",
      0.1
    ],
    [
      "poeme",
      0.065
    ],
    [
      "pastorale",
      0.065
    ],
    [
      "idylle",
      0.065
    ],
    [
      "champetre",
      0.065
    ],
    [
      "rural",
      0.0325
    ],
    [
      "paysan",
      0.0325
    ],
    [
      "paysage",
      0.0325
    ],
    [
      "idyllique",
      0.0325
    ],
    [
      "forestier",
      0.0325
    ],
    [
      "campagnard",
      0.0325
    ],
    [
      "bocager",
      0.0325
    ],
    [
      "rustique",
      0.0325
    ]
  ],
  "souhaiter": [
    [
      "vouloir",
      0.15
    ],
    [
      "desirer",
      0.145
    ],
    [
      "demander",
      0.0625
    ],
    [
      "rever",
      0.055
    ],
    [
      "pretendre",
      0.05
    ],
    [
      "convoiter",
      0.05
    ],
    [
      "revendiquer",
      0.04
    ],
    [
      "exiger",
      0.035
    ],
    [
      "viser",
      0.03
    ],
    [
      "solliciter",
      0.03
    ],
    [
      "lorgner",
      0.03
    ],
    [
      "aspirer",
      0.03
    ],
    [
      "ambitionner",
      0.025
    ],
    [
      "appeler",
      0.025
    ],
    [
      "requerir",
      0.025
    ],
    [
      "reclamer",
      0.025
    ],
    [
      "soupirer",
      0.025
    ],
    [
      "rechercher",
      0.015
    ],
    [
      "guigner",
      0.015
    ],
    [
      "envier",
      0.015
    ],
    [
      "dire",
      0.015
    ],
    [
      "appeter",
      0.01
    ],
    [
      "attendre",
      0.01
    ],
    [
      "esperer",
      0.01
    ],
    [
      "loucher",
      0.0025
    ],
    [
      "exprimer",
      0.0025
    ],
    [
      "entendre",
      0.0025
    ],
    [
      "arreter",
      0.0025
    ]
  ],
  "moisi": [
    [
      "gate",
      0.5
    ],
    [
      "pourri",
      0.5
    ]
  ],
  "moisir": [
    [
      "pourrir",
      0.1375
    ],
    [
      "attendre",
      0.11
    ],
    [
      "languir",
      0.11
    ],
    [
      "croupir",
      0.0825
    ],
    [
      "rester",
      0.0825
    ],
    [
      "vegeter",
      0.055
    ],
    [
      "vivoter",
      0.055
    ],
    [
      "trainer",
      0.055
    ],
    [
      "chancir",
      0.055
    ],
    [
      "gater",
      0.0275
    ],
    [
      "passer",
      0.0275
    ],
    [
      "poireauter",
      0.0275
    ],
    [
      "poser",
      0.0275
    ]
  ],
  "egard": [
    [
      "consideration",
      0.15
    ],
    [
      "soin",
      0.1
    ],
    [
      "reverence",
      0.1
    ],
    [
      "honneur",
      0.1
    ],
    [
      "hommage",
      0.1
    ],
    [
      "estime",
      0.1
    ],
    [
      "circonspection",
      0.1
    ],
    [
      "attention",
      0.1
    ],
    [
      "distinction",
      0.05
    ],
    [
      "deference",
      0.05
    ],
    [
      "menagement",
      0.05
    ]
  ],
  "ride": [
    [
      "sillon",
      0.1375
    ],
    [
      "fente",
      0.0825
    ],
    [
      "rainure",
      0.0825
    ],
    [
      "strie",
      0.055
    ],
    [
      "repli",
      0.055
    ],
    [
      "rayure",
      0.055
    ],
    [
      "raie",
      0.055
    ],
    [
      "pli",
      0.055
    ],
    [
      "ondulation",
      0.055
    ],
    [
      "ligne",
      0.055
    ],
    [
      "craquelure",
      0.055
    ],
    [
      "plissement",
      0.0275
    ],
    [
      "onde",
      0.0275
    ],
    [
      "inegalite",
      0.0275
    ],
    [
      "gercure",
      0.0275
    ],
    [
      "fletrissure",
      0.0275
    ],
    [
      "creux",
      0.0275
    ],
    [
      "cordage",
      0.0275
    ],
    [
      "trace",
      0.0275
    ]
  ],
  "rider": [
    [
      "convulser",
      0.09
    ],
    [
      "raviner",
      0.09
    ],
    [
      "ravager",
      0.09
    ],
    [
      "ratatiner",
      0.09
    ],
    [
      "rabougrir",
      0.09
    ],
    [
      "plisser",
      0.09
    ],
    [
      "marquer",
      0.09
    ],
    [
      "froncer",
      0.09
    ],
    [
      "fletrir",
      0.09
    ],
    [
      "crisper",
      0.09
    ],
    [
      "rayer",
      0.09
    ]
  ],
  "ternir": [
    [
      "fletrir",
      0.1275
    ],
    [
      "salir",
      0.105
    ],
    [
      "gater",
      0.075
    ],
    [
      "alterer",
      0.0425
    ],
    [
      "avilir",
      0.0425
    ],
    [
      "diminuer",
      0.0425
    ],
    [
      "deprecier",
      0.0425
    ],
    [
      "souiller",
      0.0425
    ],
    [
      "eteindre",
      0.035
    ],
    [
      "obscurcir",
      0.035
    ],
    [
      "abimer",
      0.0275
    ],
    [
      "effacer",
      0.0275
    ],
    [
      "faner",
      0.0275
    ],
    [
      "tacher",
      0.02
    ],
    [
      "noircir",
      0.02
    ],
    [
      "entacher",
      0.02
    ],
    [
      "diffamer",
      0.02
    ],
    [
      "compromettre",
      0.02
    ],
    [
      "affadir",
      0.02
    ],
    [
      "abaisser",
      0.02
    ],
    [
      "eclipser",
      0.0125
    ],
    [
      "voiler",
      0.0125
    ],
    [
      "tarer",
      0.0125
    ],
    [
      "galvauder",
      0.0125
    ],
    [
      "defraichir",
      0.0125
    ],
    [
      "deflorer",
      0.0125
    ],
    [
      "decolorer",
      0.0125
    ],
    [
      "delaver",
      0.005
    ],
    [
      "deparer",
      0.005
    ],
    [
      "emboire",
      0.005
    ],
    [
      "passer",
      0.005
    ]
  ],
  "murmure": [
    [
      "bruissement",
      0.1025
    ],
    [
      "bruit",
      0.0825
    ],
    [
      "gazouillis",
      0.0625
    ],
    [
      "chuchotement",
      0.055
    ],
    [
      "chuchotis",
      0.055
    ],
    [
      "gazouillement",
      0.055
    ],
    [
      "susurrement",
      0.045
    ],
    [
      "frisson",
      0.045
    ],
    [
      "friselis",
      0.045
    ],
    [
      "bourdonnement",
      0.045
    ],
    [
      "babil",
      0.045
    ],
    [
      "chanson",
      0.035
    ],
    [
      "plainte",
      0.0275
    ],
    [
      "musique",
      0.0275
    ],
    [
      "lamentation",
      0.0275
    ],
    [
      "jeremiade",
      0.0275
    ],
    [
      "fremissement",
      0.0275
    ],
    [
      "pleurnicherie",
      0.0175
    ],
    [
      "marmottement",
      0.0175
    ],
    [
      "gemissement",
      0.0175
    ],
    [
      "grogne",
      0.0175
    ],
    [
      "protestation",
      0.0075
    ],
    [
      "marmonnement",
      0.0075
    ],
    [
      "grognerie",
      0.0075
    ],
    [
      "grognement",
      0.0075
    ],
    [
      "chuchotage",
      0.0075
    ],
    [
      "borborygme",
      0.0075
    ],
    [
      "balbutiement",
      0.0075
    ],
    [
      "babillage",
      0.0075
    ],
    [
      "rumeur",
      0.0075
    ]
  ],
  "defense": [
    [
      "protection",
      0.1125
    ],
    [
      "sauvegarde",
      0.05
    ],
    [
      "rempart",
      0.045
    ],
    [
      "abri",
      0.04
    ],
    [
      "bastion",
      0.04
    ],
    [
      "fortification",
      0.0325
    ],
    [
      "eloge",
      0.0275
    ],
    [
      "tutelle",
      0.0275
    ],
    [
      "soutien",
      0.0275
    ],
    [
      "apologie",
      0.0275
    ],
    [
      "resistance",
      0.02
    ],
    [
      "obstacle",
      0.02
    ],
    [
      "justification",
      0.02
    ],
    [
      "garantie",
      0.02
    ],
    [
      "bouclier",
      0.02
    ],
    [
      "traverse",
      0.015
    ],
    [
      "secours",
      0.015
    ],
    [
      "retraite",
      0.015
    ],
    [
      "preservation",
      0.015
    ],
    [
      "interdiction",
      0.015
    ],
    [
      "asile",
      0.015
    ],
    [
      "interdit",
      0.01
    ],
    [
      "louange",
      0.01
    ],
    [
      "ouvrage",
      0.01
    ],
    [
      "plaidoyer",
      0.01
    ],
    [
      "prohibition",
      0.01
    ],
    [
      "retranchement",
      0.01
    ],
    [
      "reaction",
      0.01
    ],
    [
      "reponse",
      0.01
    ],
    [
      "garde",
      0.01
    ],
    [
      "embargo",
      0.01
    ],
    [
      "defenseur",
      0.01
    ],
    [
      "aide",
      0.01
    ],
    [
      "apologetique",
      0.01
    ],
    [
      "avocat",
      0.01
    ],
    [
      "barreau",
      0.01
    ],
    [
      "boulevard",
      0.01
    ],
    [
      "couverture",
      0.01
    ],
    [
      "cuirasse",
      0.01
    ],
    [
      "discours",
      0.01
    ],
    [
      "glorification",
      0.005
    ],
    [
      "indignite",
      0.005
    ],
    [
      "inhibition",
      0.005
    ],
    [
      "lutte",
      0.005
    ],
    [
      "maintien",
      0.005
    ],
    [
      "parade",
      0.005
    ],
    [
      "plaidoirie",
      0.005
    ],
    [
      "polemique",
      0.005
    ],
    [
      "repli",
      0.005
    ],
    [
      "rescousse",
      0.005
    ],
    [
      "riposte",
      0.005
    ],
    [
      "glacis",
      0.005
    ],
    [
      "fosse",
      0.005
    ],
    [
      "armure",
      0.005
    ],
    [
      "armee",
      0.005
    ],
    [
      "barrage",
      0.005
    ],
    [
      "canine",
      0.005
    ],
    [
      "cause",
      0.005
    ],
    [
      "citadelle",
      0.005
    ],
    [
      "corne",
      0.005
    ],
    [
      "dent",
      0.005
    ],
    [
      "decharge",
      0.005
    ],
    [
      "exception",
      0.005
    ],
    [
      "excuse",
      0.005
    ],
    [
      "reduit",
      0.005
    ]
  ],
  "traire": [
    [
      "tirer",
      1.0
    ]
  ],
  "fermant": [
    [
      "barrer",
      0.075
    ],
    [
      "clore",
      0.065
    ],
    [
      "boucher",
      0.0575
    ],
    [
      "enfermer",
      0.0475
    ],
    [
      "bloquer",
      0.0475
    ],
    [
      "arreter",
      0.0475
    ],
    [
      "entourer",
      0.0425
    ],
    [
      "barricader",
      0.0325
    ],
    [
      "condamner",
      0.0325
    ],
    [
      "couper",
      0.03
    ],
    [
      "obstruer",
      0.025
    ],
    [
      "murer",
      0.025
    ],
    [
      "empecher",
      0.025
    ],
    [
      "cerner",
      0.02
    ],
    [
      "enclore",
      0.02
    ],
    [
      "obturer",
      0.02
    ],
    [
      "borner",
      0.015
    ],
    [
      "capsuler",
      0.015
    ],
    [
      "interdire",
      0.0125
    ],
    [
      "interrompre",
      0.0125
    ],
    [
      "maconner",
      0.0125
    ],
    [
      "suspendre",
      0.0125
    ],
    [
      "terminer",
      0.0125
    ],
    [
      "ecluser",
      0.0125
    ],
    [
      "finir",
      0.0125
    ],
    [
      "enceindre",
      0.0125
    ],
    [
      "consigner",
      0.0125
    ],
    [
      "bander",
      0.0125
    ],
    [
      "boucler",
      0.0125
    ],
    [
      "cacheter",
      0.0125
    ],
    [
      "cadenasser",
      0.0125
    ],
    [
      "cloturer",
      0.0125
    ],
    [
      "coller",
      0.0125
    ],
    [
      "verrouiller",
      0.0075
    ],
    [
      "sceller",
      0.0075
    ],
    [
      "parquer",
      0.0075
    ],
    [
      "investir",
      0.0075
    ],
    [
      "combler",
      0.0075
    ],
    [
      "colmater",
      0.0075
    ],
    [
      "cercler",
      0.0075
    ],
    [
      "bacler",
      0.0075
    ],
    [
      "nouer",
      0.0025
    ],
    [
      "occlure",
      0.0025
    ],
    [
      "occulter",
      0.0025
    ],
    [
      "plier",
      0.0025
    ],
    [
      "relacher",
      0.0025
    ],
    [
      "suturer",
      0.0025
    ],
    [
      "tirer",
      0.0025
    ],
    [
      "lourder",
      0.0025
    ],
    [
      "defendre",
      0.0025
    ],
    [
      "abaisser",
      0.0025
    ],
    [
      "boutonner",
      0.0025
    ],
    [
      "baillonner",
      0.0025
    ],
    [
      "chomer",
      0.0025
    ],
    [
      "cicatriser",
      0.0025
    ],
    [
      "claquer",
      0.0025
    ],
    [
      "clouer",
      0.0025
    ],
    [
      "coudre",
      0.0025
    ],
    [
      "disjoncter",
      0.0025
    ],
    [
      "eteindre",
      0.0025
    ]
  ],
  "raturer": [
    [
      "biffer",
      0.215
    ],
    [
      "barrer",
      0.13
    ],
    [
      "effacer",
      0.13
    ],
    [
      "rayer",
      0.13
    ],
    [
      "retrancher",
      0.085
    ],
    [
      "radier",
      0.085
    ],
    [
      "batonner",
      0.0425
    ],
    [
      "canceller",
      0.0425
    ],
    [
      "corriger",
      0.0425
    ],
    [
      "obliterer",
      0.0425
    ],
    [
      "sabrer",
      0.0425
    ]
  ],
  "rembourser": [
    [
      "payer",
      0.3
    ],
    [
      "couvrir",
      0.1
    ],
    [
      "rendre",
      0.1
    ],
    [
      "retroceder",
      0.05
    ],
    [
      "reverser",
      0.05
    ],
    [
      "restituer",
      0.05
    ],
    [
      "redonner",
      0.05
    ],
    [
      "indemniser",
      0.05
    ],
    [
      "garnir",
      0.05
    ],
    [
      "depenser",
      0.05
    ],
    [
      "defrayer",
      0.05
    ],
    [
      "amortir",
      0.05
    ],
    [
      "s'acquitter",
      0.05
    ]
  ],
  "vicieux": [
    [
      "debauche",
      0.095
    ],
    [
      "deprave",
      0.065
    ],
    [
      "lascif",
      0.065
    ],
    [
      "impudique",
      0.0575
    ],
    [
      "mauvais",
      0.0475
    ],
    [
      "impur",
      0.0475
    ],
    [
      "immoral",
      0.0475
    ],
    [
      "corrompu",
      0.0475
    ],
    [
      "luxurieux",
      0.04
    ],
    [
      "obscene",
      0.04
    ],
    [
      "bas",
      0.035
    ],
    [
      "lubrique",
      0.035
    ],
    [
      "pervers",
      0.0275
    ],
    [
      "libertin",
      0.0275
    ],
    [
      "dissolu",
      0.0275
    ],
    [
      "libidineux",
      0.0225
    ],
    [
      "erotique",
      0.0175
    ],
    [
      "satyre",
      0.0175
    ],
    [
      "fautif",
      0.0175
    ],
    [
      "crapuleux",
      0.0175
    ],
    [
      "vaurien",
      0.01
    ],
    [
      "salace",
      0.01
    ],
    [
      "sadique",
      0.01
    ],
    [
      "roue",
      0.01
    ],
    [
      "incorrect",
      0.01
    ],
    [
      "devergonde",
      0.01
    ],
    [
      "deregle",
      0.01
    ],
    [
      "defectueux",
      0.01
    ],
    [
      "cochon",
      0.01
    ],
    [
      "ombrageux",
      0.005
    ],
    [
      "perverti",
      0.005
    ],
    [
      "recalcitrant",
      0.005
    ],
    [
      "retif",
      0.005
    ],
    [
      "tare",
      0.005
    ],
    [
      "tordu",
      0.005
    ],
    [
      "indocile",
      0.005
    ],
    [
      "impropre",
      0.005
    ],
    [
      "imparfait",
      0.005
    ],
    [
      "fripouille",
      0.005
    ],
    [
      "desordonne",
      0.005
    ],
    [
      "coupable",
      0.005
    ],
    [
      "boueux",
      0.005
    ],
    [
      "amoral",
      0.005
    ],
    [
      "vicelard",
      0.005
    ]
  ],
  "sauf": [
    [
      "excepte",
      0.15
    ],
    [
      "hormis",
      0.075
    ],
    [
      "hors",
      0.075
    ],
    [
      "rescape",
      0.075
    ],
    [
      "survivant",
      0.0475
    ],
    [
      "sauve",
      0.0475
    ],
    [
      "indemne",
      0.0475
    ],
    [
      "bon",
      0.0475
    ],
    [
      "sinon",
      0.0225
    ],
    [
      "si",
      0.0225
    ],
    [
      "sain",
      0.0225
    ],
    [
      "preserve",
      0.0225
    ],
    [
      "moins",
      0.0225
    ],
    [
      "intact",
      0.0225
    ],
    [
      "fors",
      0.0225
    ],
    [
      "ote",
      0.0225
    ]
  ],
  "poursuite": [
    [
      "action",
      0.125
    ],
    [
      "demande",
      0.1
    ],
    [
      "chasse",
      0.075
    ],
    [
      "suite",
      0.05
    ],
    [
      "quete",
      0.05
    ],
    [
      "instance",
      0.05
    ],
    [
      "demarche",
      0.05
    ],
    [
      "course",
      0.05
    ],
    [
      "continuation",
      0.05
    ],
    [
      "charge",
      0.05
    ],
    [
      "assignation",
      0.05
    ],
    [
      "accusation",
      0.05
    ],
    [
      "recherche",
      0.0225
    ],
    [
      "procedure",
      0.0225
    ],
    [
      "proces",
      0.0225
    ],
    [
      "pourchas",
      0.0225
    ],
    [
      "pistage",
      0.0225
    ],
    [
      "perseverance",
      0.0225
    ],
    [
      "intimation",
      0.0225
    ],
    [
      "galanterie",
      0.0225
    ],
    [
      "contrainte",
      0.0225
    ],
    [
      "reprise",
      0.0225
    ]
  ],
  "faineant": [
    [
      "paresseux",
      0.2275
    ],
    [
      "rossard",
      0.0925
    ],
    [
      "flaneur",
      0.08
    ],
    [
      "indolent",
      0.0675
    ],
    [
      "oisif",
      0.0675
    ],
    [
      "cagnard",
      0.0525
    ],
    [
      "clampin",
      0.04
    ],
    [
      "nonchalant",
      0.04
    ],
    [
      "vaurien",
      0.025
    ],
    [
      "musard",
      0.025
    ],
    [
      "fripouille",
      0.025
    ],
    [
      "flemmard",
      0.025
    ],
    [
      "desoeuvre",
      0.025
    ],
    [
      "cossard",
      0.025
    ],
    [
      "reveur",
      0.0125
    ],
    [
      "lezard",
      0.0125
    ],
    [
      "loupeur",
      0.0125
    ],
    [
      "inactif",
      0.0125
    ],
    [
      "feignasse",
      0.0125
    ],
    [
      "cancre",
      0.0125
    ],
    [
      "cagne",
      0.0125
    ],
    [
      "truand",
      0.0125
    ]
  ],
  "arret": [
    [
      "cessation",
      0.0775
    ],
    [
      "interruption",
      0.075
    ],
    [
      "suspension",
      0.0375
    ],
    [
      "pause",
      0.035
    ],
    [
      "halte",
      0.035
    ],
    [
      "fermeture",
      0.03
    ],
    [
      "relache",
      0.03
    ],
    [
      "treve",
      0.025
    ],
    [
      "suppression",
      0.0225
    ],
    [
      "paralysie",
      0.0225
    ],
    [
      "decision",
      0.0225
    ],
    [
      "abri",
      0.0175
    ],
    [
      "decret",
      0.0175
    ],
    [
      "repos",
      0.0175
    ],
    [
      "remission",
      0.0175
    ],
    [
      "repit",
      0.0175
    ],
    [
      "stagnation",
      0.015
    ],
    [
      "fin",
      0.015
    ],
    [
      "extinction",
      0.015
    ],
    [
      "discontinuation",
      0.015
    ],
    [
      "blocage",
      0.015
    ],
    [
      "barricade",
      0.015
    ],
    [
      "abandon",
      0.015
    ],
    [
      "station",
      0.01
    ],
    [
      "jugement",
      0.01
    ],
    [
      "intermittence",
      0.01
    ],
    [
      "coupure",
      0.01
    ],
    [
      "condamnation",
      0.01
    ],
    [
      "barrage",
      0.01
    ],
    [
      "arrete",
      0.01
    ],
    [
      "armistice",
      0.01
    ],
    [
      "punition",
      0.0075
    ],
    [
      "rupture",
      0.0075
    ],
    [
      "reglement",
      0.0075
    ],
    [
      "sentence",
      0.0075
    ],
    [
      "stage",
      0.0075
    ],
    [
      "stase",
      0.0075
    ],
    [
      "sejour",
      0.0075
    ],
    [
      "etape",
      0.0075
    ],
    [
      "privation",
      0.0075
    ],
    [
      "intervalle",
      0.0075
    ],
    [
      "immobilisation",
      0.0075
    ],
    [
      "abolition",
      0.0075
    ],
    [
      "ankylose",
      0.0075
    ],
    [
      "barriere",
      0.0075
    ],
    [
      "cran",
      0.0075
    ],
    [
      "dessein",
      0.0075
    ],
    [
      "digue",
      0.0075
    ],
    [
      "escale",
      0.0075
    ],
    [
      "gare",
      0.0075
    ],
    [
      "greve",
      0.0025
    ],
    [
      "inhibition",
      0.0025
    ],
    [
      "intermede",
      0.0025
    ],
    [
      "loi",
      0.0025
    ],
    [
      "mentonnet",
      0.0025
    ],
    [
      "panne",
      0.0025
    ],
    [
      "parade",
      0.0025
    ],
    [
      "retention",
      0.0025
    ],
    [
      "silence",
      0.0025
    ],
    [
      "stationnement",
      0.0025
    ],
    [
      "taquet",
      0.0025
    ],
    [
      "finition",
      0.0025
    ],
    [
      "embargo",
      0.0025
    ],
    [
      "anesthesie",
      0.0025
    ],
    [
      "arrestation",
      0.0025
    ],
    [
      "arretoir",
      0.0025
    ],
    [
      "blocus",
      0.0025
    ],
    [
      "butee",
      0.0025
    ],
    [
      "cadenas",
      0.0025
    ],
    [
      "cesse",
      0.0025
    ],
    [
      "cliquet",
      0.0025
    ],
    [
      "controle",
      0.0025
    ],
    [
      "dent",
      0.0025
    ],
    [
      "tenon",
      0.0025
    ]
  ],
  "calecon": [
    [
      "culotte",
      0.3
    ],
    [
      "slip",
      0.2
    ],
    [
      "calebar",
      0.1
    ],
    [
      "calecif",
      0.1
    ],
    [
      "chausse",
      0.1
    ],
    [
      "maillot",
      0.1
    ],
    [
      "pantalon",
      0.1
    ]
  ],
  "pyjama": [],
  "instant": [
    [
      "moment",
      0.235
    ],
    [
      "minute",
      0.1175
    ],
    [
      "pressant",
      0.1175
    ],
    [
      "temps",
      0.1175
    ],
    [
      "seconde",
      0.0575
    ],
    [
      "point",
      0.0575
    ],
    [
      "instantane",
      0.0575
    ],
    [
      "insistant",
      0.0575
    ],
    [
      "imminent",
      0.0575
    ],
    [
      "heure",
      0.0575
    ],
    [
      "urgent",
      0.0575
    ]
  ],
  "epanouir": [
    [
      "deployer",
      0.18
    ],
    [
      "ouvrir",
      0.18
    ],
    [
      "etendre",
      0.18
    ],
    [
      "dilater",
      0.09
    ],
    [
      "derider",
      0.09
    ],
    [
      "fleurir",
      0.09
    ],
    [
      "rejouir",
      0.09
    ],
    [
      "etaler",
      0.09
    ]
  ],
  "vasistas": [
    [
      "fenetre",
      0.25
    ],
    [
      "lucarne",
      0.25
    ],
    [
      "ouverture",
      0.25
    ],
    [
      "tabatiere",
      0.25
    ]
  ],
  "parquet": [
    [
      "corbeille",
      0.1675
    ],
    [
      "pretoire",
      0.0825
    ],
    [
      "plancher",
      0.0825
    ],
    [
      "planche",
      0.0825
    ],
    [
      "orchestre",
      0.0825
    ],
    [
      "magistrature",
      0.0825
    ],
    [
      "bourse",
      0.0825
    ],
    [
      "boiserie",
      0.0825
    ],
    [
      "barreau",
      0.0825
    ],
    [
      "barre",
      0.0825
    ],
    [
      "tribunal",
      0.0825
    ]
  ],
  "classer": [
    [
      "ranger",
      0.0975
    ],
    [
      "ordonner",
      0.0825
    ],
    [
      "distribuer",
      0.075
    ],
    [
      "arranger",
      0.06
    ],
    [
      "juger",
      0.045
    ],
    [
      "placer",
      0.0375
    ],
    [
      "distinguer",
      0.0375
    ],
    [
      "cataloguer",
      0.0375
    ],
    [
      "etiqueter",
      0.03
    ],
    [
      "separer",
      0.03
    ],
    [
      "mettre",
      0.03
    ],
    [
      "assigner",
      0.03
    ],
    [
      "trier",
      0.02
    ],
    [
      "repartir",
      0.02
    ],
    [
      "organiser",
      0.02
    ],
    [
      "noter",
      0.02
    ],
    [
      "hierarchiser",
      0.02
    ],
    [
      "harmoniser",
      0.02
    ],
    [
      "diviser",
      0.02
    ],
    [
      "classifier",
      0.02
    ],
    [
      "caser",
      0.02
    ],
    [
      "attribuer",
      0.02
    ],
    [
      "serier",
      0.015
    ],
    [
      "situer",
      0.015
    ],
    [
      "grouper",
      0.015
    ],
    [
      "determiner",
      0.015
    ],
    [
      "demeler",
      0.015
    ],
    [
      "delimiter",
      0.015
    ],
    [
      "coter",
      0.015
    ],
    [
      "affecter",
      0.015
    ],
    [
      "referencer",
      0.005
    ],
    [
      "enterrer",
      0.005
    ],
    [
      "denombrer",
      0.005
    ],
    [
      "differencier",
      0.005
    ],
    [
      "categoriser",
      0.005
    ],
    [
      "calibrer",
      0.005
    ],
    [
      "archiver",
      0.005
    ],
    [
      "reunir",
      0.005
    ]
  ],
  "classe": [
    [
      "ranger",
      0.0975
    ],
    [
      "ordonner",
      0.0825
    ],
    [
      "distribuer",
      0.075
    ],
    [
      "arranger",
      0.06
    ],
    [
      "juger",
      0.045
    ],
    [
      "placer",
      0.0375
    ],
    [
      "distinguer",
      0.0375
    ],
    [
      "cataloguer",
      0.0375
    ],
    [
      "etiqueter",
      0.03
    ],
    [
      "separer",
      0.03
    ],
    [
      "mettre",
      0.03
    ],
    [
      "assigner",
      0.03
    ],
    [
      "trier",
      0.02
    ],
    [
      "repartir",
      0.02
    ],
    [
      "organiser",
      0.02
    ],
    [
      "noter",
      0.02
    ],
    [
      "hierarchiser",
      0.02
    ],
    [
      "harmoniser",
      0.02
    ],
    [
      "diviser",
      0.02
    ],
    [
      "classifier",
      0.02
    ],
    [
      "caser",
      0.02
    ],
    [
      "attribuer",
      0.02
    ],
    [
      "serier",
      0.015
    ],
    [
      "situer",
      0.015
    ],
    [
      "grouper",
      0.015
    ],
    [
      "determiner",
      0.015
    ],
    [
      "demeler",
      0.015
    ],
    [
      "delimiter",
      0.015
    ],
    [
      "coter",
      0.015
    ],
    [
      "affecter",
      0.015
    ],
    [
      "referencer",
      0.005
    ],
    [
      "enterrer",
      0.005
    ],
    [
      "denombrer",
      0.005
    ],
    [
      "differencier",
      0.005
    ],
    [
      "categoriser",
      0.005
    ],
    [
      "calibrer",
      0.005
    ],
    [
      "archiver",
      0.005
    ],
    [
      "reunir",
      0.005
    ]
  ],
  "debattre": [
    [
      "discuter",
      0.2725
    ],
    [
      "agiter",
      0.09
    ],
    [
      "parlementer",
      0.09
    ],
    [
      "traiter",
      0.09
    ],
    [
      "examiner",
      0.06
    ],
    [
      "contester",
      0.06
    ],
    [
      "chicaner",
      0.06
    ],
    [
      "parler",
      0.03
    ],
    [
      "negocier",
      0.03
    ],
    [
      "marchander",
      0.03
    ],
    [
      "demeler",
      0.03
    ],
    [
      "deliberer",
      0.03
    ],
    [
      "disputer",
      0.03
    ],
    [
      "controverser",
      0.03
    ],
    [
      "battre",
      0.03
    ]
  ],
  "debat": [
    [
      "discussion",
      0.15
    ],
    [
      "dispute",
      0.1
    ],
    [
      "contestation",
      0.075
    ],
    [
      "querelle",
      0.0575
    ],
    [
      "conversation",
      0.04
    ],
    [
      "conference",
      0.04
    ],
    [
      "altercation",
      0.04
    ],
    [
      "seance",
      0.0325
    ],
    [
      "reunion",
      0.0325
    ],
    [
      "litige",
      0.0325
    ],
    [
      "deliberation",
      0.0325
    ],
    [
      "differend",
      0.0325
    ],
    [
      "controverse",
      0.0325
    ],
    [
      "symposium",
      0.025
    ],
    [
      "session",
      0.025
    ],
    [
      "conflit",
      0.025
    ],
    [
      "colloque",
      0.025
    ],
    [
      "lutte",
      0.015
    ],
    [
      "examen",
      0.015
    ],
    [
      "demele",
      0.015
    ],
    [
      "congres",
      0.015
    ],
    [
      "attaque",
      0.015
    ],
    [
      "proces",
      0.0075
    ],
    [
      "pourparler",
      0.0075
    ],
    [
      "polemique",
      0.0075
    ],
    [
      "panel",
      0.0075
    ],
    [
      "palabre",
      0.0075
    ],
    [
      "explication",
      0.0075
    ],
    [
      "dialogue",
      0.0075
    ],
    [
      "contention",
      0.0075
    ],
    [
      "combat",
      0.0075
    ]
  ],
  "coriace": [
    [
      "tenace",
      0.1625
    ],
    [
      "dur",
      0.1375
    ],
    [
      "resistant",
      0.1375
    ],
    [
      "ferme",
      0.0675
    ],
    [
      "opiniatre",
      0.0675
    ],
    [
      "solide",
      0.0675
    ],
    [
      "obstine",
      0.045
    ],
    [
      "nerveux",
      0.045
    ],
    [
      "filandreux",
      0.045
    ],
    [
      "acharne",
      0.045
    ],
    [
      "chien",
      0.0225
    ],
    [
      "difficile",
      0.0225
    ],
    [
      "increvable",
      0.0225
    ],
    [
      "inextirpable",
      0.0225
    ],
    [
      "racorni",
      0.0225
    ],
    [
      "vivace",
      0.0225
    ]
  ],
  "bruyant": [
    [
      "tapageur",
      0.16
    ],
    [
      "retentissant",
      0.0975
    ],
    [
      "assourdissant",
      0.0725
    ],
    [
      "tonitruant",
      0.0725
    ],
    [
      "fracassant",
      0.06
    ],
    [
      "eclatant",
      0.06
    ],
    [
      "sonore",
      0.035
    ],
    [
      "percant",
      0.035
    ],
    [
      "gueulard",
      0.035
    ],
    [
      "tumultueux",
      0.0225
    ],
    [
      "tintamarresque",
      0.0225
    ],
    [
      "resonnant",
      0.0225
    ],
    [
      "rugissant",
      0.0225
    ],
    [
      "indiscret",
      0.0225
    ],
    [
      "fort",
      0.0225
    ],
    [
      "criard",
      0.0225
    ],
    [
      "braillard",
      0.0225
    ],
    [
      "bavard",
      0.0225
    ],
    [
      "vociferant",
      0.01
    ],
    [
      "turbulent",
      0.01
    ],
    [
      "ronflant",
      0.01
    ],
    [
      "piaillard",
      0.01
    ],
    [
      "mugissant",
      0.01
    ],
    [
      "jacasse",
      0.01
    ],
    [
      "hurleur",
      0.01
    ],
    [
      "homerique",
      0.01
    ],
    [
      "grondeur",
      0.01
    ],
    [
      "grondant",
      0.01
    ],
    [
      "beuglard",
      0.01
    ],
    [
      "vrombissant",
      0.01
    ]
  ],
  "coucou": [
    [
      "chronometre",
      0.1425
    ],
    [
      "horloge",
      0.1425
    ],
    [
      "machine",
      0.1425
    ],
    [
      "tacot",
      0.07
    ],
    [
      "pendule",
      0.07
    ],
    [
      "narcisse",
      0.07
    ],
    [
      "montre",
      0.07
    ],
    [
      "locomotive",
      0.07
    ],
    [
      "becane",
      0.07
    ],
    [
      "avion",
      0.07
    ],
    [
      "voiture",
      0.07
    ]
  ],
  "aimant": [
    [
      "fascination",
      0.115
    ],
    [
      "seduction",
      0.115
    ],
    [
      "tendre",
      0.075
    ],
    [
      "attraction",
      0.075
    ],
    [
      "attirance",
      0.075
    ],
    [
      "amoureux",
      0.075
    ],
    [
      "affectueux",
      0.075
    ],
    [
      "sensible",
      0.0375
    ],
    [
      "influence",
      0.0375
    ],
    [
      "envoutement",
      0.0375
    ],
    [
      "doux",
      0.0375
    ],
    [
      "calin",
      0.0375
    ],
    [
      "caressant",
      0.0375
    ],
    [
      "boussole",
      0.0375
    ],
    [
      "attrait",
      0.0375
    ],
    [
      "ascendance",
      0.0375
    ]
  ],
  "fume": [
    [
      "rager",
      0.155
    ],
    [
      "ronchonner",
      0.1
    ],
    [
      "raler",
      0.0775
    ],
    [
      "pester",
      0.055
    ],
    [
      "tempeter",
      0.0425
    ],
    [
      "rouspeter",
      0.0425
    ],
    [
      "fulminer",
      0.0425
    ],
    [
      "enrager",
      0.0425
    ],
    [
      "bisquer",
      0.0325
    ],
    [
      "ecumer",
      0.02
    ],
    [
      "rogner",
      0.02
    ],
    [
      "preparer",
      0.02
    ],
    [
      "maronner",
      0.02
    ],
    [
      "bruler",
      0.02
    ],
    [
      "amender",
      0.02
    ],
    [
      "pipailler",
      0.01
    ],
    [
      "petuner",
      0.01
    ],
    [
      "saurer",
      0.01
    ],
    [
      "tonner",
      0.01
    ],
    [
      "megoter",
      0.01
    ],
    [
      "griller",
      0.01
    ],
    [
      "fumiger",
      0.01
    ],
    [
      "fertiliser",
      0.01
    ],
    [
      "engraisser",
      0.01
    ],
    [
      "endever",
      0.01
    ],
    [
      "boucaner",
      0.01
    ],
    [
      "barder",
      0.01
    ],
    [
      "ameliorer",
      0.01
    ]
  ],
  "fumee": [
    [
      "rager",
      0.155
    ],
    [
      "ronchonner",
      0.1
    ],
    [
      "raler",
      0.0775
    ],
    [
      "pester",
      0.055
    ],
    [
      "tempeter",
      0.0425
    ],
    [
      "rouspeter",
      0.0425
    ],
    [
      "fulminer",
      0.0425
    ],
    [
      "enrager",
      0.0425
    ],
    [
      "bisquer",
      0.0325
    ],
    [
      "ecumer",
      0.02
    ],
    [
      "rogner",
      0.02
    ],
    [
      "preparer",
      0.02
    ],
    [
      "maronner",
      0.02
    ],
    [
      "bruler",
      0.02
    ],
    [
      "amender",
      0.02
    ],
    [
      "pipailler",
      0.01
    ],
    [
      "petuner",
      0.01
    ],
    [
      "saurer",
      0.01
    ],
    [
      "tonner",
      0.01
    ],
    [
      "megoter",
      0.01
    ],
    [
      "griller",
      0.01
    ],
    [
      "fumiger",
      0.01
    ],
    [
      "fertiliser",
      0.01
    ],
    [
      "engraisser",
      0.01
    ],
    [
      "endever",
      0.01
    ],
    [
      "boucaner",
      0.01
    ],
    [
      "barder",
      0.01
    ],
    [
      "ameliorer",
      0.01
    ]
  ],
  "distinguer": [
    [
      "separer",
      0.095
    ],
    [
      "discerner",
      0.085
    ],
    [
      "voir",
      0.05
    ],
    [
      "reconnaitre",
      0.0425
    ],
    [
      "demeler",
      0.0425
    ],
    [
      "decouvrir",
      0.0425
    ],
    [
      "classer",
      0.0425
    ],
    [
      "trier",
      0.0325
    ],
    [
      "isoler",
      0.0325
    ],
    [
      "entendre",
      0.0325
    ],
    [
      "degager",
      0.0325
    ],
    [
      "debrouiller",
      0.0325
    ],
    [
      "differencier",
      0.0325
    ],
    [
      "percevoir",
      0.025
    ],
    [
      "juger",
      0.025
    ],
    [
      "individualiser",
      0.025
    ],
    [
      "caracteriser",
      0.025
    ],
    [
      "apercevoir",
      0.025
    ],
    [
      "analyser",
      0.025
    ],
    [
      "eclaircir",
      0.015
    ],
    [
      "selectionner",
      0.015
    ],
    [
      "saisir",
      0.015
    ],
    [
      "remarquer",
      0.015
    ],
    [
      "preferer",
      0.015
    ],
    [
      "dissocier",
      0.015
    ],
    [
      "discriminer",
      0.015
    ],
    [
      "choisir",
      0.015
    ],
    [
      "preciser",
      0.0075
    ],
    [
      "predestiner",
      0.0075
    ],
    [
      "retrouver",
      0.0075
    ],
    [
      "recompenser",
      0.0075
    ],
    [
      "singulariser",
      0.0075
    ],
    [
      "honorer",
      0.0075
    ],
    [
      "entrevoir",
      0.0075
    ],
    [
      "delimiter",
      0.0075
    ],
    [
      "distribuer",
      0.0075
    ],
    [
      "disjoindre",
      0.0075
    ],
    [
      "cribler",
      0.0075
    ],
    [
      "aviser",
      0.0075
    ],
    [
      "specifier",
      0.0075
    ]
  ],
  "energie": [
    [
      "force",
      0.095
    ],
    [
      "courage",
      0.085
    ],
    [
      "fermete",
      0.08
    ],
    [
      "vigueur",
      0.055
    ],
    [
      "ressort",
      0.0475
    ],
    [
      "resolution",
      0.0475
    ],
    [
      "coeur",
      0.0425
    ],
    [
      "ardeur",
      0.0425
    ],
    [
      "volonte",
      0.04
    ],
    [
      "decision",
      0.0325
    ],
    [
      "hardiesse",
      0.025
    ],
    [
      "ame",
      0.0225
    ],
    [
      "solidite",
      0.0225
    ],
    [
      "dynamisme",
      0.0225
    ],
    [
      "caractere",
      0.0225
    ],
    [
      "audace",
      0.0225
    ],
    [
      "vie",
      0.02
    ],
    [
      "action",
      0.015
    ],
    [
      "chaleur",
      0.015
    ],
    [
      "cran",
      0.015
    ],
    [
      "vitalite",
      0.015
    ],
    [
      "temerite",
      0.0125
    ],
    [
      "seve",
      0.0125
    ],
    [
      "constance",
      0.0125
    ],
    [
      "activite",
      0.0125
    ],
    [
      "puissance",
      0.01
    ],
    [
      "perseverance",
      0.01
    ],
    [
      "nerf",
      0.01
    ],
    [
      "efficacite",
      0.01
    ],
    [
      "determination",
      0.01
    ],
    [
      "endurance",
      0.0075
    ],
    [
      "entetement",
      0.0075
    ],
    [
      "vehemence",
      0.005
    ],
    [
      "violence",
      0.005
    ],
    [
      "vertu",
      0.005
    ],
    [
      "punch",
      0.005
    ],
    [
      "acharnement",
      0.005
    ],
    [
      "electricite",
      0.0
    ],
    [
      "verdeur",
      0.0
    ],
    [
      "tonus",
      0.0
    ],
    [
      "thermodynamique",
      0.0
    ],
    [
      "poigne",
      0.0
    ],
    [
      "entropie",
      0.0
    ],
    [
      "carburant",
      0.0
    ],
    [
      "emulation",
      0.0
    ]
  ],
  "telephoner": [
    [
      "appeler",
      0.3325
    ],
    [
      "bigophoner",
      0.3325
    ],
    [
      "tuber",
      0.3325
    ]
  ],
  "telephone": [
    [
      "bigophone",
      0.1825
    ],
    [
      "tube",
      0.09
    ],
    [
      "taxiphone",
      0.09
    ],
    [
      "portable",
      0.09
    ],
    [
      "mobile",
      0.09
    ],
    [
      "grelot",
      0.09
    ],
    [
      "biniou",
      0.09
    ],
    [
      "bigorneau",
      0.09
    ],
    [
      "appareil",
      0.09
    ],
    [
      "telecommunication",
      0.09
    ]
  ],
  "abonner": [],
  "abonne": [],
  "baleine": [
    [
      "busc",
      0.1
    ],
    [
      "rorque",
      0.1
    ],
    [
      "rorqual",
      0.1
    ],
    [
      "orque",
      0.1
    ],
    [
      "megaptere",
      0.1
    ],
    [
      "lame",
      0.1
    ],
    [
      "jubarte",
      0.1
    ],
    [
      "fanon",
      0.1
    ],
    [
      "belouga",
      0.1
    ],
    [
      "epaulard",
      0.1
    ]
  ],
  "clavier": [
    [
      "registre",
      0.2125
    ],
    [
      "chaine",
      0.1425
    ],
    [
      "etendue",
      0.1425
    ],
    [
      "serie",
      0.07
    ],
    [
      "portee",
      0.07
    ],
    [
      "machoire",
      0.07
    ],
    [
      "gamme",
      0.07
    ],
    [
      "ensemble",
      0.07
    ],
    [
      "anneau",
      0.07
    ],
    [
      "tessiture",
      0.07
    ]
  ],
  "manchot": [
    [
      "estropie",
      0.25
    ],
    [
      "gauche",
      0.25
    ],
    [
      "maladroit",
      0.25
    ],
    [
      "pingouin",
      0.25
    ]
  ],
  "levant": [
    [
      "aurore",
      0.3325
    ],
    [
      "est",
      0.3325
    ],
    [
      "orient",
      0.3325
    ]
  ],
  "gagner": [
    [
      "prendre",
      0.0625
    ],
    [
      "conquerir",
      0.055
    ],
    [
      "attraper",
      0.0375
    ],
    [
      "toucher",
      0.0375
    ],
    [
      "seduire",
      0.0275
    ],
    [
      "obtenir",
      0.0275
    ],
    [
      "ramasser",
      0.025
    ],
    [
      "aller",
      0.02
    ],
    [
      "enlever",
      0.02
    ],
    [
      "remporter",
      0.0175
    ],
    [
      "recevoir",
      0.0175
    ],
    [
      "captiver",
      0.0175
    ],
    [
      "capter",
      0.0175
    ],
    [
      "atteindre",
      0.0175
    ],
    [
      "recolter",
      0.0175
    ],
    [
      "s'emparer",
      0.015
    ],
    [
      "recueillir",
      0.015
    ],
    [
      "piquer",
      0.015
    ],
    [
      "forcer",
      0.015
    ],
    [
      "encaisser",
      0.015
    ],
    [
      "attirer",
      0.015
    ],
    [
      "acquerir",
      0.0125
    ],
    [
      "tirer",
      0.0125
    ],
    [
      "vaincre",
      0.0125
    ],
    [
      "emporter",
      0.0125
    ],
    [
      "arriver",
      0.01
    ],
    [
      "faire",
      0.01
    ],
    [
      "reussir",
      0.01
    ],
    [
      "retirer",
      0.01
    ],
    [
      "profiter",
      0.01
    ],
    [
      "amadouer",
      0.01
    ],
    [
      "charmer",
      0.0075
    ],
    [
      "envahir",
      0.0075
    ],
    [
      "percevoir",
      0.0075
    ],
    [
      "plaire",
      0.0075
    ],
    [
      "triompher",
      0.0075
    ],
    [
      "penetrer",
      0.0075
    ],
    [
      "marcher",
      0.0075
    ],
    [
      "empocher",
      0.0075
    ],
    [
      "avancer",
      0.0075
    ],
    [
      "amener",
      0.0075
    ],
    [
      "s'etendre",
      0.005
    ],
    [
      "rallier",
      0.005
    ],
    [
      "progresser",
      0.005
    ],
    [
      "persuader",
      0.005
    ],
    [
      "parvenir",
      0.005
    ],
    [
      "joindre",
      0.005
    ],
    [
      "gratter",
      0.005
    ],
    [
      "augmenter",
      0.005
    ],
    [
      "circonvenir",
      0.005
    ],
    [
      "convaincre",
      0.005
    ],
    [
      "convertir",
      0.005
    ],
    [
      "croitre",
      0.005
    ],
    [
      "subjuguer",
      0.0025
    ],
    [
      "s'attacher",
      0.0025
    ],
    [
      "rapporter",
      0.0025
    ],
    [
      "interesser",
      0.0025
    ],
    [
      "grandir",
      0.0025
    ],
    [
      "fleurir",
      0.0025
    ],
    [
      "distancer",
      0.0025
    ],
    [
      "aborder",
      0.0025
    ],
    [
      "s'attirer",
      0.0025
    ],
    [
      "s'enrichir",
      0.0025
    ],
    [
      "tenter",
      0.0025
    ],
    [
      "retrouver",
      0.0025
    ],
    [
      "rejoindre",
      0.0025
    ],
    [
      "flechir",
      0.0025
    ],
    [
      "acceder",
      0.0025
    ],
    [
      "apprivoiser",
      0.0025
    ],
    [
      "chiper",
      0.0025
    ],
    [
      "contracter",
      0.0025
    ],
    [
      "decrocher",
      0.0025
    ],
    [
      "empieter",
      0.0025
    ],
    [
      "primer",
      0.0
    ],
    [
      "rafler",
      0.0
    ],
    [
      "s'ameliorer",
      0.0
    ],
    [
      "s'assurer",
      0.0
    ],
    [
      "surclasser",
      0.0
    ],
    [
      "l'emporter",
      0.0
    ],
    [
      "grappiller",
      0.0
    ],
    [
      "envouter",
      0.0
    ],
    [
      "allecher",
      0.0
    ],
    [
      "assujettir",
      0.0
    ],
    [
      "battre",
      0.0
    ],
    [
      "beneficier",
      0.0
    ],
    [
      "corrompre",
      0.0
    ],
    [
      "endoctriner",
      0.0
    ],
    [
      "s'apprecier",
      0.0
    ],
    [
      "s'assujettir",
      0.0
    ],
    [
      "suborner",
      0.0
    ],
    [
      "palper",
      0.0
    ],
    [
      "meriter",
      0.0
    ],
    [
      "moissonner",
      0.0
    ],
    [
      "envelopper",
      0.0
    ],
    [
      "communiquer",
      0.0
    ],
    [
      "appater",
      0.0
    ],
    [
      "amorcer",
      0.0
    ],
    [
      "affurer",
      0.0
    ],
    [
      "economiser",
      0.0
    ]
  ],
  "dela": [
    [
      "dehors",
      1.0
    ]
  ],
  "intime": [
    [
      "interieur",
      0.0875
    ],
    [
      "profond",
      0.0875
    ],
    [
      "secret",
      0.0875
    ],
    [
      "familier",
      0.07
    ],
    [
      "personnel",
      0.07
    ],
    [
      "fond",
      0.0525
    ],
    [
      "ame",
      0.035
    ],
    [
      "prive",
      0.035
    ],
    [
      "lie",
      0.035
    ],
    [
      "essentiel",
      0.035
    ],
    [
      "domestique",
      0.035
    ],
    [
      "confidentiel",
      0.035
    ],
    [
      "ami",
      0.035
    ],
    [
      "particulier",
      0.015
    ],
    [
      "prochain",
      0.015
    ],
    [
      "proche",
      0.015
    ],
    [
      "sexuel",
      0.015
    ],
    [
      "trefonds",
      0.015
    ],
    [
      "visceral",
      0.015
    ],
    [
      "inseparable",
      0.015
    ],
    [
      "indefectible",
      0.015
    ],
    [
      "foncier",
      0.015
    ],
    [
      "dedans",
      0.015
    ],
    [
      "confident",
      0.015
    ],
    [
      "complet",
      0.015
    ],
    [
      "cache",
      0.015
    ],
    [
      "amical",
      0.015
    ],
    [
      "etroit",
      0.015
    ]
  ],
  "intimer": [
    [
      "signifier",
      0.25
    ],
    [
      "sommer",
      0.25
    ],
    [
      "citer",
      0.125
    ],
    [
      "commander",
      0.125
    ],
    [
      "enjoindre",
      0.125
    ],
    [
      "notifier",
      0.125
    ]
  ],
  "forcement": [
    [
      "necessairement",
      0.1425
    ],
    [
      "infailliblement",
      0.1075
    ],
    [
      "inevitablement",
      0.1075
    ],
    [
      "surement",
      0.1075
    ],
    [
      "evidemment",
      0.07
    ],
    [
      "obligatoirement",
      0.07
    ],
    [
      "naturellement",
      0.07
    ],
    [
      "ineluctablement",
      0.07
    ],
    [
      "immanquablement",
      0.07
    ],
    [
      "absolument",
      0.035
    ],
    [
      "automatiquement",
      0.035
    ],
    [
      "fatalement",
      0.035
    ]
  ],
  "octobre": [
    [
      "brumaire",
      0.5
    ],
    [
      "vendemiaire",
      0.5
    ]
  ],
  "avril": [
    [
      "aurore",
      0.3325
    ],
    [
      "germinal",
      0.3325
    ],
    [
      "printemps",
      0.3325
    ]
  ],
  "empreinte": [
    [
      "imprimer",
      0.25
    ],
    [
      "marquer",
      0.25
    ],
    [
      "graver",
      0.15
    ],
    [
      "estamper",
      0.1
    ],
    [
      "colorer",
      0.05
    ],
    [
      "estampiller",
      0.05
    ],
    [
      "frapper",
      0.05
    ],
    [
      "inculquer",
      0.05
    ],
    [
      "inscrire",
      0.05
    ]
  ],
  "luxer": [
    [
      "fouler",
      0.25
    ],
    [
      "disloquer",
      0.165
    ],
    [
      "deboiter",
      0.165
    ],
    [
      "demettre",
      0.165
    ],
    [
      "blesser",
      0.0825
    ],
    [
      "demancher",
      0.0825
    ],
    [
      "tordre",
      0.0825
    ]
  ],
  "luxe": [
    [
      "profusion",
      0.1175
    ],
    [
      "surabondance",
      0.0875
    ],
    [
      "exces",
      0.0775
    ],
    [
      "debauche",
      0.07
    ],
    [
      "richesse",
      0.07
    ],
    [
      "somptuosite",
      0.07
    ],
    [
      "abondance",
      0.0625
    ],
    [
      "prodigalite",
      0.0375
    ],
    [
      "opulence",
      0.03
    ],
    [
      "faste",
      0.03
    ],
    [
      "etalage",
      0.0225
    ],
    [
      "quantite",
      0.0225
    ],
    [
      "orgie",
      0.0225
    ],
    [
      "luxuriance",
      0.0225
    ],
    [
      "apparat",
      0.0225
    ],
    [
      "superfluite",
      0.015
    ],
    [
      "pullulement",
      0.015
    ],
    [
      "plethore",
      0.015
    ],
    [
      "magnificence",
      0.015
    ],
    [
      "depense",
      0.015
    ],
    [
      "deluge",
      0.015
    ],
    [
      "confort",
      0.015
    ],
    [
      "tralala",
      0.0075
    ],
    [
      "superfetation",
      0.0075
    ],
    [
      "superflu",
      0.0075
    ],
    [
      "splendeur",
      0.0075
    ],
    [
      "raffinement",
      0.0075
    ],
    [
      "pompe",
      0.0075
    ],
    [
      "plaisance",
      0.0075
    ],
    [
      "ostentation",
      0.0075
    ],
    [
      "gaspillage",
      0.0075
    ],
    [
      "fortune",
      0.0075
    ],
    [
      "eclat",
      0.0075
    ]
  ],
  "ri": [
    [
      "railler",
      0.08
    ],
    [
      "s'amuser",
      0.07
    ],
    [
      "plaisanter",
      0.0575
    ],
    [
      "mepriser",
      0.0275
    ],
    [
      "blaguer",
      0.0275
    ],
    [
      "rigoler",
      0.0225
    ],
    [
      "jouer",
      0.0225
    ],
    [
      "brocarder",
      0.0225
    ],
    [
      "badiner",
      0.0225
    ],
    [
      "s'egayer",
      0.015
    ],
    [
      "pouffer",
      0.015
    ],
    [
      "ironiser",
      0.015
    ],
    [
      "eclater",
      0.01
    ],
    [
      "sourire",
      0.01
    ],
    [
      "s'esclaffer",
      0.01
    ],
    [
      "ridiculiser",
      0.01
    ],
    [
      "dedaigner",
      0.01
    ],
    [
      "s'etourdir",
      0.005
    ],
    [
      "rioter",
      0.005
    ],
    [
      "rigolbocher",
      0.005
    ],
    [
      "baratiner",
      0.005
    ],
    [
      "glousser",
      0.005
    ],
    [
      "ignorer",
      0.005
    ],
    [
      "luire",
      0.005
    ],
    [
      "narguer",
      0.005
    ],
    [
      "nasarder",
      0.005
    ],
    [
      "persifler",
      0.005
    ],
    [
      "ricaner",
      0.005
    ],
    [
      "amuser",
      0.005
    ]
  ],
  "egerie": [
    [
      "amante",
      0.2
    ],
    [
      "conseillere",
      0.2
    ],
    [
      "femme",
      0.2
    ],
    [
      "guide",
      0.2
    ],
    [
      "inspiratrice",
      0.2
    ]
  ],
  "degouter": [
    [
      "fatiguer",
      0.1125
    ],
    [
      "rebuter",
      0.0975
    ],
    [
      "ecoeurer",
      0.0825
    ],
    [
      "decourager",
      0.07
    ],
    [
      "detourner",
      0.055
    ],
    [
      "ennuyer",
      0.055
    ],
    [
      "lasser",
      0.055
    ],
    [
      "eloigner",
      0.04
    ],
    [
      "repugner",
      0.04
    ],
    [
      "repousser",
      0.04
    ],
    [
      "deplaire",
      0.04
    ],
    [
      "revolter",
      0.0275
    ],
    [
      "facher",
      0.0275
    ],
    [
      "desabuser",
      0.0275
    ],
    [
      "dissuader",
      0.0275
    ],
    [
      "blaser",
      0.0275
    ],
    [
      "affadir",
      0.0275
    ],
    [
      "saturer",
      0.0125
    ],
    [
      "revulser",
      0.0125
    ],
    [
      "peser",
      0.0125
    ],
    [
      "desenchanter",
      0.0125
    ],
    [
      "desaffectionner",
      0.0125
    ],
    [
      "demoraliser",
      0.0125
    ],
    [
      "debecter",
      0.0125
    ]
  ],
  "portable": [
    [
      "mobile",
      0.25
    ],
    [
      "portatif",
      0.25
    ],
    [
      "convenable",
      0.125
    ],
    [
      "mettable",
      0.125
    ],
    [
      "transportable",
      0.125
    ],
    [
      "telephone",
      0.125
    ]
  ],
  "disquette": [],
  "mordu": [
    [
      "ronger",
      0.065
    ],
    [
      "attaquer",
      0.0475
    ],
    [
      "corroder",
      0.0475
    ],
    [
      "detruire",
      0.0475
    ],
    [
      "entamer",
      0.0475
    ],
    [
      "prendre",
      0.04
    ],
    [
      "dechirer",
      0.04
    ],
    [
      "broyer",
      0.035
    ],
    [
      "manger",
      0.035
    ],
    [
      "piquer",
      0.0275
    ],
    [
      "miner",
      0.0275
    ],
    [
      "empieter",
      0.0275
    ],
    [
      "user",
      0.0225
    ],
    [
      "triturer",
      0.0225
    ],
    [
      "tourmenter",
      0.0225
    ],
    [
      "presser",
      0.0225
    ],
    [
      "pincer",
      0.0225
    ],
    [
      "envahir",
      0.0225
    ],
    [
      "depasser",
      0.0225
    ],
    [
      "deborder",
      0.0225
    ],
    [
      "blesser",
      0.0225
    ],
    [
      "ereinter",
      0.0175
    ],
    [
      "penetrer",
      0.0175
    ],
    [
      "macher",
      0.0175
    ],
    [
      "critiquer",
      0.0175
    ],
    [
      "comprendre",
      0.0175
    ],
    [
      "serrer",
      0.01
    ],
    [
      "saper",
      0.01
    ],
    [
      "outrepasser",
      0.01
    ],
    [
      "machonner",
      0.01
    ],
    [
      "esquinter",
      0.01
    ],
    [
      "demolir",
      0.01
    ],
    [
      "dechiqueter",
      0.01
    ],
    [
      "croquer",
      0.01
    ],
    [
      "chevaucher",
      0.01
    ],
    [
      "avancer",
      0.01
    ],
    [
      "aimer",
      0.01
    ],
    [
      "mordiller",
      0.005
    ],
    [
      "ressortir",
      0.005
    ],
    [
      "s'enfoncer",
      0.005
    ],
    [
      "lacerer",
      0.005
    ],
    [
      "inquieter",
      0.005
    ],
    [
      "fustiger",
      0.005
    ],
    [
      "fouailler",
      0.005
    ],
    [
      "dissoudre",
      0.005
    ],
    [
      "dilacerer",
      0.005
    ]
  ],
  "oreiller": [
    [
      "traversin",
      0.4
    ],
    [
      "chevet",
      0.2
    ],
    [
      "coussin",
      0.2
    ],
    [
      "polochon",
      0.2
    ]
  ],
  "repertoire": [
    [
      "catalogue",
      0.13
    ],
    [
      "liste",
      0.13
    ],
    [
      "tableau",
      0.0725
    ],
    [
      "etat",
      0.055
    ],
    [
      "inventaire",
      0.045
    ],
    [
      "releve",
      0.045
    ],
    [
      "enumeration",
      0.035
    ],
    [
      "table",
      0.035
    ],
    [
      "role",
      0.035
    ],
    [
      "registre",
      0.035
    ],
    [
      "nomenclature",
      0.035
    ],
    [
      "denombrement",
      0.035
    ],
    [
      "recueil",
      0.0275
    ],
    [
      "carnet",
      0.0275
    ],
    [
      "calepin",
      0.0275
    ],
    [
      "bibliographie",
      0.0275
    ],
    [
      "suite",
      0.0175
    ],
    [
      "memoire",
      0.0175
    ],
    [
      "index",
      0.0175
    ],
    [
      "fichier",
      0.0175
    ],
    [
      "classement",
      0.0175
    ],
    [
      "bordereau",
      0.0175
    ],
    [
      "bareme",
      0.0175
    ],
    [
      "almanach",
      0.0075
    ],
    [
      "digeste",
      0.0075
    ],
    [
      "enregistrement",
      0.0075
    ],
    [
      "sommaire",
      0.0075
    ],
    [
      "serie",
      0.0075
    ]
  ],
  "reverbere": [
    [
      "lampadaire",
      0.3325
    ],
    [
      "lanterne",
      0.3325
    ]
  ],
  "surplace": [],
  "champagne": [
    [
      "champ",
      0.3325
    ],
    [
      "mousseux",
      0.3325
    ],
    [
      "plaine",
      0.3325
    ]
  ],
  "surface": [
    [
      "apparence",
      0.085
    ],
    [
      "exterieur",
      0.085
    ],
    [
      "superficie",
      0.085
    ],
    [
      "etendue",
      0.0675
    ],
    [
      "vernis",
      0.0675
    ],
    [
      "facade",
      0.0675
    ],
    [
      "espace",
      0.0675
    ],
    [
      "contenance",
      0.05
    ],
    [
      "mine",
      0.05
    ],
    [
      "teinte",
      0.0325
    ],
    [
      "semblant",
      0.0325
    ],
    [
      "domaine",
      0.0325
    ],
    [
      "dehors",
      0.0325
    ],
    [
      "aire",
      0.0325
    ],
    [
      "table",
      0.015
    ],
    [
      "supermarche",
      0.015
    ],
    [
      "solvabilite",
      0.015
    ],
    [
      "plan",
      0.015
    ],
    [
      "plaine",
      0.015
    ],
    [
      "parement",
      0.015
    ],
    [
      "face",
      0.015
    ],
    [
      "dos",
      0.015
    ],
    [
      "dimension",
      0.015
    ],
    [
      "credit",
      0.015
    ],
    [
      "teinture",
      0.015
    ]
  ],
  "arrose": [
    [
      "mouiller",
      0.1475
    ],
    [
      "baigner",
      0.08
    ],
    [
      "humecter",
      0.08
    ],
    [
      "tremper",
      0.08
    ],
    [
      "inonder",
      0.055
    ],
    [
      "asperger",
      0.0425
    ],
    [
      "bassiner",
      0.0425
    ],
    [
      "verser",
      0.0325
    ],
    [
      "imbiber",
      0.0325
    ],
    [
      "abreuver",
      0.0325
    ],
    [
      "submerger",
      0.02
    ],
    [
      "soudoyer",
      0.02
    ],
    [
      "repandre",
      0.02
    ],
    [
      "payer",
      0.02
    ],
    [
      "noyer",
      0.02
    ],
    [
      "laver",
      0.02
    ],
    [
      "doucher",
      0.02
    ],
    [
      "couler",
      0.02
    ],
    [
      "boire",
      0.02
    ],
    [
      "acheter",
      0.02
    ],
    [
      "mitrailler",
      0.01
    ],
    [
      "s'abreuver",
      0.01
    ],
    [
      "saucer",
      0.01
    ],
    [
      "seringuer",
      0.01
    ],
    [
      "traverser",
      0.01
    ],
    [
      "irriguer",
      0.01
    ],
    [
      "feter",
      0.01
    ],
    [
      "financer",
      0.01
    ],
    [
      "distribuer",
      0.01
    ],
    [
      "canonner",
      0.01
    ],
    [
      "bombarder",
      0.01
    ],
    [
      "eclabousser",
      0.01
    ]
  ],
  "arroser": [
    [
      "mouiller",
      0.1475
    ],
    [
      "baigner",
      0.08
    ],
    [
      "humecter",
      0.08
    ],
    [
      "tremper",
      0.08
    ],
    [
      "inonder",
      0.055
    ],
    [
      "asperger",
      0.0425
    ],
    [
      "bassiner",
      0.0425
    ],
    [
      "verser",
      0.0325
    ],
    [
      "imbiber",
      0.0325
    ],
    [
      "abreuver",
      0.0325
    ],
    [
      "submerger",
      0.02
    ],
    [
      "soudoyer",
      0.02
    ],
    [
      "repandre",
      0.02
    ],
    [
      "payer",
      0.02
    ],
    [
      "noyer",
      0.02
    ],
    [
      "laver",
      0.02
    ],
    [
      "doucher",
      0.02
    ],
    [
      "couler",
      0.02
    ],
    [
      "boire",
      0.02
    ],
    [
      "acheter",
      0.02
    ],
    [
      "mitrailler",
      0.01
    ],
    [
      "s'abreuver",
      0.01
    ],
    [
      "saucer",
      0.01
    ],
    [
      "seringuer",
      0.01
    ],
    [
      "traverser",
      0.01
    ],
    [
      "irriguer",
      0.01
    ],
    [
      "feter",
      0.01
    ],
    [
      "financer",
      0.01
    ],
    [
      "distribuer",
      0.01
    ],
    [
      "canonner",
      0.01
    ],
    [
      "bombarder",
      0.01
    ],
    [
      "eclabousser",
      0.01
    ]
  ],
  "oseille": [
    [
      "argent",
      0.2
    ],
    [
      "ble",
      0.2
    ],
    [
      "beurre",
      0.1
    ],
    [
      "fric",
      0.1
    ],
    [
      "hibiscus",
      0.1
    ],
    [
      "osier",
      0.1
    ],
    [
      "surelle",
      0.1
    ]
  ],
  "saumon": [
    [
      "saumone",
      0.5
    ],
    [
      "smolt",
      0.5
    ]
  ],
  "deplacement": [
    [
      "mouvement",
      0.1125
    ],
    [
      "changement",
      0.09
    ],
    [
      "voyage",
      0.065
    ],
    [
      "mutation",
      0.045
    ],
    [
      "marche",
      0.045
    ],
    [
      "locomotion",
      0.045
    ],
    [
      "inversion",
      0.045
    ],
    [
      "immigration",
      0.045
    ],
    [
      "errance",
      0.045
    ],
    [
      "derangement",
      0.045
    ],
    [
      "course",
      0.045
    ],
    [
      "chute",
      0.045
    ],
    [
      "migration",
      0.02
    ],
    [
      "passage",
      0.02
    ],
    [
      "remuement",
      0.02
    ],
    [
      "retroversion",
      0.02
    ],
    [
      "transfert",
      0.02
    ],
    [
      "translation",
      0.02
    ],
    [
      "fluctuation",
      0.02
    ],
    [
      "deportation",
      0.02
    ],
    [
      "demarche",
      0.02
    ],
    [
      "declassement",
      0.02
    ],
    [
      "deboitement",
      0.02
    ],
    [
      "descente",
      0.02
    ],
    [
      "affectation",
      0.02
    ],
    [
      "transposition",
      0.02
    ]
  ],
  "depassement": [
    [
      "doublement",
      0.3325
    ],
    [
      "exces",
      0.3325
    ],
    [
      "surpassement",
      0.3325
    ]
  ],
  "appliquer": [
    [
      "donner",
      0.06
    ],
    [
      "mettre",
      0.06
    ],
    [
      "poser",
      0.05
    ],
    [
      "coller",
      0.045
    ],
    [
      "placer",
      0.045
    ],
    [
      "ficher",
      0.0425
    ],
    [
      "porter",
      0.0425
    ],
    [
      "etendre",
      0.0425
    ],
    [
      "attacher",
      0.0375
    ],
    [
      "flanquer",
      0.035
    ],
    [
      "adresser",
      0.025
    ],
    [
      "consacrer",
      0.025
    ],
    [
      "affecter",
      0.0225
    ],
    [
      "etaler",
      0.02
    ],
    [
      "tendre",
      0.02
    ],
    [
      "passer",
      0.02
    ],
    [
      "foutre",
      0.02
    ],
    [
      "employer",
      0.02
    ],
    [
      "attribuer",
      0.02
    ],
    [
      "enduire",
      0.0175
    ],
    [
      "vouer",
      0.015
    ],
    [
      "plaquer",
      0.015
    ],
    [
      "lancer",
      0.015
    ],
    [
      "frapper",
      0.015
    ],
    [
      "envoyer",
      0.015
    ],
    [
      "diriger",
      0.015
    ],
    [
      "ajuster",
      0.015
    ],
    [
      "administrer",
      0.015
    ],
    [
      "situer",
      0.01
    ],
    [
      "pratiquer",
      0.01
    ],
    [
      "destiner",
      0.01
    ],
    [
      "assembler",
      0.01
    ],
    [
      "accorder",
      0.01
    ],
    [
      "tapisser",
      0.0075
    ],
    [
      "imputer",
      0.0075
    ],
    [
      "couvrir",
      0.0075
    ],
    [
      "concentrer",
      0.0075
    ],
    [
      "appuyer",
      0.0075
    ],
    [
      "apposer",
      0.0075
    ],
    [
      "vivre",
      0.005
    ],
    [
      "utiliser",
      0.005
    ],
    [
      "user",
      0.005
    ],
    [
      "tourner",
      0.005
    ],
    [
      "realiser",
      0.005
    ],
    [
      "recouvrir",
      0.005
    ],
    [
      "imprimer",
      0.005
    ],
    [
      "assener",
      0.005
    ],
    [
      "s'efforcer",
      0.0
    ],
    [
      "presser",
      0.0
    ],
    [
      "occuper",
      0.0
    ],
    [
      "infliger",
      0.0
    ],
    [
      "delivrer",
      0.0
    ],
    [
      "aplatir",
      0.0
    ],
    [
      "adapter",
      0.0
    ],
    [
      "superposer",
      0.0
    ]
  ],
  "applique": [
    [
      "application",
      0.3325
    ],
    [
      "chandelier",
      0.3325
    ],
    [
      "torchere",
      0.3325
    ]
  ],
  "couture": [
    [
      "point",
      0.1625
    ],
    [
      "assemblage",
      0.0975
    ],
    [
      "surjet",
      0.0975
    ],
    [
      "cicatrice",
      0.065
    ],
    [
      "marque",
      0.065
    ],
    [
      "mode",
      0.03
    ],
    [
      "montage",
      0.03
    ],
    [
      "piqure",
      0.03
    ],
    [
      "pli",
      0.03
    ],
    [
      "raboutissage",
      0.03
    ],
    [
      "rentraiture",
      0.03
    ],
    [
      "habillement",
      0.03
    ],
    [
      "faufilure",
      0.03
    ],
    [
      "faufilage",
      0.03
    ],
    [
      "face",
      0.03
    ],
    [
      "confection",
      0.03
    ],
    [
      "broderie",
      0.03
    ],
    [
      "brochage",
      0.03
    ],
    [
      "balafre",
      0.03
    ],
    [
      "atelier",
      0.03
    ],
    [
      "surfilage",
      0.03
    ]
  ],
  "detailler": [
    [
      "debiter",
      0.15
    ],
    [
      "exposer",
      0.075
    ],
    [
      "prononcer",
      0.075
    ],
    [
      "raconter",
      0.075
    ],
    [
      "retracer",
      0.075
    ],
    [
      "enumerer",
      0.05
    ],
    [
      "faire",
      0.05
    ],
    [
      "developper",
      0.05
    ],
    [
      "circonstancier",
      0.05
    ],
    [
      "vendre",
      0.025
    ],
    [
      "preciser",
      0.025
    ],
    [
      "marteler",
      0.025
    ],
    [
      "devisager",
      0.025
    ],
    [
      "depeindre",
      0.025
    ],
    [
      "denombrer",
      0.025
    ],
    [
      "decrire",
      0.025
    ],
    [
      "decouper",
      0.025
    ],
    [
      "declamer",
      0.025
    ],
    [
      "diviser",
      0.025
    ],
    [
      "articuler",
      0.025
    ],
    [
      "amplifier",
      0.025
    ],
    [
      "agrandir",
      0.025
    ],
    [
      "eplucher",
      0.025
    ]
  ],
  "loyer": [
    [
      "prix",
      0.1375
    ],
    [
      "fermage",
      0.11
    ],
    [
      "interet",
      0.11
    ],
    [
      "louage",
      0.0825
    ],
    [
      "revenu",
      0.0825
    ],
    [
      "salaire",
      0.0825
    ],
    [
      "taux",
      0.055
    ],
    [
      "remuneration",
      0.055
    ],
    [
      "recompense",
      0.055
    ],
    [
      "paiement",
      0.055
    ],
    [
      "ferme",
      0.055
    ],
    [
      "bail",
      0.0275
    ],
    [
      "montant",
      0.0275
    ],
    [
      "terme",
      0.0275
    ],
    [
      "valeur",
      0.0275
    ]
  ],
  "tailler": [
    [
      "couper",
      0.16
    ],
    [
      "decouper",
      0.05
    ],
    [
      "elaguer",
      0.045
    ],
    [
      "taillader",
      0.03
    ],
    [
      "emonder",
      0.025
    ],
    [
      "retrancher",
      0.025
    ],
    [
      "dechirer",
      0.025
    ],
    [
      "echarper",
      0.02
    ],
    [
      "faconner",
      0.02
    ],
    [
      "degrossir",
      0.02
    ],
    [
      "dechiqueter",
      0.02
    ],
    [
      "cisailler",
      0.02
    ],
    [
      "blesser",
      0.02
    ],
    [
      "equarrir",
      0.015
    ],
    [
      "trancher",
      0.015
    ],
    [
      "supprimer",
      0.015
    ],
    [
      "sculpter",
      0.015
    ],
    [
      "raccourcir",
      0.015
    ],
    [
      "mutiler",
      0.015
    ],
    [
      "fendre",
      0.015
    ],
    [
      "depecer",
      0.015
    ],
    [
      "debarrasser",
      0.015
    ],
    [
      "charpenter",
      0.015
    ],
    [
      "rafraichir",
      0.01
    ],
    [
      "ebarber",
      0.01
    ],
    [
      "ebrancher",
      0.01
    ],
    [
      "echancrer",
      0.01
    ],
    [
      "ecimer",
      0.01
    ],
    [
      "eclaircir",
      0.01
    ],
    [
      "evider",
      0.01
    ],
    [
      "inciser",
      0.01
    ],
    [
      "degarnir",
      0.01
    ],
    [
      "amputer",
      0.01
    ],
    [
      "balafrer",
      0.01
    ],
    [
      "chantourner",
      0.01
    ],
    [
      "ciseler",
      0.01
    ],
    [
      "denteler",
      0.01
    ],
    [
      "defaire",
      0.01
    ],
    [
      "degager",
      0.01
    ],
    [
      "tondre",
      0.005
    ],
    [
      "rustiquer",
      0.005
    ],
    [
      "retondre",
      0.005
    ],
    [
      "retailler",
      0.005
    ],
    [
      "receper",
      0.005
    ],
    [
      "ravaler",
      0.005
    ],
    [
      "patronner",
      0.005
    ],
    [
      "ebiseler",
      0.005
    ],
    [
      "ebourgeonner",
      0.005
    ],
    [
      "echarpiller",
      0.005
    ],
    [
      "egayer",
      0.005
    ],
    [
      "emincer",
      0.005
    ],
    [
      "epamprer",
      0.005
    ],
    [
      "epanneler",
      0.005
    ],
    [
      "etronconner",
      0.005
    ],
    [
      "eteter",
      0.005
    ],
    [
      "obtenir",
      0.005
    ],
    [
      "facetter",
      0.005
    ],
    [
      "escarper",
      0.005
    ],
    [
      "affuter",
      0.005
    ],
    [
      "appareiller",
      0.005
    ],
    [
      "appointer",
      0.005
    ],
    [
      "aviver",
      0.005
    ],
    [
      "biseauter",
      0.005
    ],
    [
      "bretteler",
      0.005
    ],
    [
      "brillanter",
      0.005
    ],
    [
      "chanfreiner",
      0.005
    ],
    [
      "charpir",
      0.005
    ],
    [
      "cliver",
      0.005
    ],
    [
      "conduire",
      0.005
    ],
    [
      "diriger",
      0.005
    ],
    [
      "dresser",
      0.005
    ],
    [
      "debillarder",
      0.005
    ],
    [
      "ergoter",
      0.005
    ],
    [
      "affiler",
      0.005
    ]
  ],
  "coupure": [
    [
      "entaille",
      0.1075
    ],
    [
      "fente",
      0.075
    ],
    [
      "dechirure",
      0.06
    ],
    [
      "breche",
      0.0375
    ],
    [
      "trou",
      0.0375
    ],
    [
      "echancrure",
      0.03
    ],
    [
      "interruption",
      0.03
    ],
    [
      "hiatus",
      0.03
    ],
    [
      "division",
      0.03
    ],
    [
      "coupe",
      0.03
    ],
    [
      "cassure",
      0.03
    ],
    [
      "blessure",
      0.03
    ],
    [
      "accroc",
      0.03
    ],
    [
      "taillade",
      0.02
    ],
    [
      "separation",
      0.02
    ],
    [
      "section",
      0.02
    ],
    [
      "rainure",
      0.02
    ],
    [
      "incision",
      0.02
    ],
    [
      "fosse",
      0.02
    ],
    [
      "fissure",
      0.02
    ],
    [
      "arret",
      0.02
    ],
    [
      "suppression",
      0.0125
    ],
    [
      "retranchement",
      0.0125
    ],
    [
      "estafilade",
      0.0125
    ],
    [
      "decoupure",
      0.0125
    ],
    [
      "cesure",
      0.0125
    ],
    [
      "cluse",
      0.0125
    ],
    [
      "canal",
      0.0125
    ],
    [
      "balafre",
      0.0125
    ],
    [
      "intersection",
      0.005
    ],
    [
      "rigole",
      0.005
    ],
    [
      "scarification",
      0.005
    ],
    [
      "solution",
      0.005
    ],
    [
      "tiret",
      0.005
    ],
    [
      "fracture",
      0.005
    ],
    [
      "fermeture",
      0.005
    ],
    [
      "excavation",
      0.005
    ],
    [
      "combe",
      0.005
    ],
    [
      "censure",
      0.005
    ],
    [
      "boutonniere",
      0.005
    ],
    [
      "bon",
      0.005
    ],
    [
      "billet",
      0.005
    ],
    [
      "ecorchure",
      0.005
    ]
  ],
  "monnaie": [
    [
      "argent",
      0.335
    ],
    [
      "billet",
      0.06
    ],
    [
      "ferraille",
      0.06
    ],
    [
      "pognon",
      0.06
    ],
    [
      "peze",
      0.06
    ],
    [
      "mitraille",
      0.03
    ],
    [
      "medaille",
      0.03
    ],
    [
      "numeraire",
      0.03
    ],
    [
      "picaillons",
      0.03
    ],
    [
      "ronds",
      0.03
    ],
    [
      "grisbi",
      0.03
    ],
    [
      "galette",
      0.03
    ],
    [
      "fric",
      0.03
    ],
    [
      "finance",
      0.03
    ],
    [
      "especes",
      0.03
    ],
    [
      "deniers",
      0.03
    ],
    [
      "bigaille",
      0.03
    ],
    [
      "appoint",
      0.03
    ],
    [
      "sou",
      0.03
    ]
  ],
  "monnayer": [
    [
      "changer",
      0.285
    ],
    [
      "echanger",
      0.285
    ],
    [
      "convertir",
      0.1425
    ],
    [
      "monetiser",
      0.1425
    ],
    [
      "vendre",
      0.1425
    ]
  ],
  "amitie": [
    [
      "union",
      0.0625
    ],
    [
      "bonte",
      0.0575
    ],
    [
      "amabilite",
      0.05
    ],
    [
      "complaisance",
      0.05
    ],
    [
      "bienveillance",
      0.045
    ],
    [
      "entente",
      0.045
    ],
    [
      "fraternite",
      0.045
    ],
    [
      "sympathie",
      0.04
    ],
    [
      "liaison",
      0.04
    ],
    [
      "attachement",
      0.04
    ],
    [
      "affection",
      0.04
    ],
    [
      "accord",
      0.0325
    ],
    [
      "camaraderie",
      0.0325
    ],
    [
      "faveur",
      0.0325
    ],
    [
      "grace",
      0.0325
    ],
    [
      "intimite",
      0.0325
    ],
    [
      "tendresse",
      0.0325
    ],
    [
      "harmonie",
      0.0275
    ],
    [
      "amour",
      0.0275
    ],
    [
      "service",
      0.0225
    ],
    [
      "familiarite",
      0.015
    ],
    [
      "cordialite",
      0.015
    ],
    [
      "civilite",
      0.015
    ],
    [
      "caresse",
      0.015
    ],
    [
      "alliance",
      0.015
    ],
    [
      "accointance",
      0.015
    ],
    [
      "intelligence",
      0.01
    ],
    [
      "inclination",
      0.01
    ],
    [
      "honnetete",
      0.01
    ],
    [
      "compagnonnage",
      0.01
    ],
    [
      "commerce",
      0.01
    ],
    [
      "compliment",
      0.005
    ],
    [
      "fraternisation",
      0.005
    ],
    [
      "sentiment",
      0.005
    ]
  ],
  "menteur": [
    [
      "hableur",
      0.1525
    ],
    [
      "fanfaron",
      0.07
    ],
    [
      "trompeur",
      0.07
    ],
    [
      "bonisseur",
      0.0575
    ],
    [
      "imposteur",
      0.0575
    ],
    [
      "vantard",
      0.045
    ],
    [
      "hypocrite",
      0.045
    ],
    [
      "bluffeur",
      0.045
    ],
    [
      "tartufe",
      0.035
    ],
    [
      "flatteur",
      0.035
    ],
    [
      "faux",
      0.035
    ],
    [
      "fallacieux",
      0.035
    ],
    [
      "esbroufeur",
      0.035
    ],
    [
      "mythomane",
      0.0225
    ],
    [
      "mystificateur",
      0.0225
    ],
    [
      "mensonger",
      0.0225
    ],
    [
      "craqueur",
      0.0225
    ],
    [
      "charlatan",
      0.0225
    ],
    [
      "blagueur",
      0.0225
    ],
    [
      "beau",
      0.0225
    ],
    [
      "gascon",
      0.01
    ],
    [
      "faussaire",
      0.01
    ],
    [
      "fabulateur",
      0.01
    ],
    [
      "conteur",
      0.01
    ],
    [
      "calomniateur",
      0.01
    ],
    [
      "baveux",
      0.01
    ],
    [
      "baratineur",
      0.01
    ],
    [
      "tartarin",
      0.01
    ]
  ],
  "rejeter": [
    [
      "repousser",
      0.1125
    ],
    [
      "chasser",
      0.08
    ],
    [
      "renvoyer",
      0.0625
    ],
    [
      "refuser",
      0.045
    ],
    [
      "exclure",
      0.0375
    ],
    [
      "ecarter",
      0.0375
    ],
    [
      "expulser",
      0.035
    ],
    [
      "eloigner",
      0.03
    ],
    [
      "bannir",
      0.0275
    ],
    [
      "jeter",
      0.0275
    ],
    [
      "lancer",
      0.0275
    ],
    [
      "pousser",
      0.0275
    ],
    [
      "vomir",
      0.0275
    ],
    [
      "eliminer",
      0.0275
    ],
    [
      "balancer",
      0.0225
    ],
    [
      "abandonner",
      0.02
    ],
    [
      "balayer",
      0.02
    ],
    [
      "proscrire",
      0.02
    ],
    [
      "refouler",
      0.02
    ],
    [
      "evacuer",
      0.0125
    ],
    [
      "ejecter",
      0.0125
    ],
    [
      "recuser",
      0.0125
    ],
    [
      "reculer",
      0.0125
    ],
    [
      "repudier",
      0.01
    ],
    [
      "rendre",
      0.01
    ],
    [
      "releguer",
      0.01
    ],
    [
      "maudire",
      0.01
    ],
    [
      "execrer",
      0.01
    ],
    [
      "excommunier",
      0.01
    ],
    [
      "decliner",
      0.01
    ],
    [
      "reporter",
      0.005
    ],
    [
      "rapporter",
      0.005
    ],
    [
      "nier",
      0.005
    ],
    [
      "infirmer",
      0.005
    ],
    [
      "degorger",
      0.005
    ],
    [
      "debouter",
      0.005
    ],
    [
      "condamner",
      0.005
    ],
    [
      "casser",
      0.005
    ],
    [
      "boycotter",
      0.005
    ],
    [
      "attribuer",
      0.005
    ],
    [
      "relancer",
      0.0025
    ],
    [
      "restituer",
      0.0025
    ],
    [
      "reprouver",
      0.0025
    ],
    [
      "s'affranchir",
      0.0025
    ],
    [
      "s'opposer",
      0.0025
    ],
    [
      "rebuter",
      0.0025
    ],
    [
      "rayer",
      0.0025
    ],
    [
      "prescrire",
      0.0025
    ],
    [
      "dedaigner",
      0.0025
    ],
    [
      "debecter",
      0.0025
    ],
    [
      "cracher",
      0.0025
    ],
    [
      "accuser",
      0.0025
    ],
    [
      "epurer",
      0.0025
    ]
  ],
  "gamma": [],
  "manga": [],
  "dangereux": [
    [
      "mauvais",
      0.0975
    ],
    [
      "risque",
      0.06
    ],
    [
      "perilleux",
      0.0475
    ],
    [
      "funeste",
      0.045
    ],
    [
      "sinistre",
      0.04
    ],
    [
      "grave",
      0.035
    ],
    [
      "hasardeux",
      0.035
    ],
    [
      "nefaste",
      0.035
    ],
    [
      "redoutable",
      0.0325
    ],
    [
      "malheureux",
      0.0325
    ],
    [
      "difficile",
      0.0325
    ],
    [
      "pernicieux",
      0.0225
    ],
    [
      "violent",
      0.0225
    ],
    [
      "alarmant",
      0.02
    ],
    [
      "nuisible",
      0.02
    ],
    [
      "hasarde",
      0.015
    ],
    [
      "menacant",
      0.015
    ],
    [
      "mechant",
      0.015
    ],
    [
      "nocif",
      0.015
    ],
    [
      "prejudiciable",
      0.015
    ],
    [
      "effrayant",
      0.015
    ],
    [
      "delicat",
      0.015
    ],
    [
      "aleatoire",
      0.015
    ],
    [
      "aventureux",
      0.015
    ],
    [
      "critique",
      0.015
    ],
    [
      "dommageable",
      0.015
    ],
    [
      "dramatique",
      0.015
    ],
    [
      "virulent",
      0.01
    ],
    [
      "temeraire",
      0.01
    ],
    [
      "serieux",
      0.01
    ],
    [
      "scabreux",
      0.01
    ],
    [
      "imprudent",
      0.01
    ],
    [
      "facheux",
      0.01
    ],
    [
      "brulant",
      0.01
    ],
    [
      "agressif",
      0.01
    ],
    [
      "perfide",
      0.0075
    ],
    [
      "meurtrier",
      0.0075
    ],
    [
      "malefique",
      0.0075
    ],
    [
      "inabordable",
      0.0075
    ],
    [
      "fou",
      0.0075
    ],
    [
      "compromettant",
      0.0075
    ],
    [
      "chaud",
      0.0075
    ],
    [
      "chanceux",
      0.0075
    ],
    [
      "tueur",
      0.0025
    ],
    [
      "traitre",
      0.0025
    ],
    [
      "malsain",
      0.0025
    ],
    [
      "impraticable",
      0.0025
    ],
    [
      "glissant",
      0.0025
    ],
    [
      "couteux",
      0.0025
    ],
    [
      "accidente",
      0.0025
    ],
    [
      "veneneux",
      0.0025
    ]
  ],
  "surete": [
    [
      "assurance",
      0.0975
    ],
    [
      "garantie",
      0.0975
    ],
    [
      "securite",
      0.0475
    ],
    [
      "solidite",
      0.0475
    ],
    [
      "justesse",
      0.0475
    ],
    [
      "gage",
      0.0475
    ],
    [
      "fidelite",
      0.0475
    ],
    [
      "fermete",
      0.0475
    ],
    [
      "abri",
      0.0475
    ],
    [
      "police",
      0.03
    ],
    [
      "nantissement",
      0.03
    ],
    [
      "cran",
      0.03
    ],
    [
      "certitude",
      0.03
    ],
    [
      "caution",
      0.03
    ],
    [
      "acuite",
      0.03
    ],
    [
      "infaillibilite",
      0.015
    ],
    [
      "lucidite",
      0.015
    ],
    [
      "ordre",
      0.015
    ],
    [
      "precaution",
      0.015
    ],
    [
      "precision",
      0.015
    ],
    [
      "serrure",
      0.015
    ],
    [
      "hypotheque",
      0.015
    ],
    [
      "garant",
      0.015
    ],
    [
      "force",
      0.015
    ],
    [
      "depot",
      0.015
    ],
    [
      "dedit",
      0.015
    ],
    [
      "clairvoyance",
      0.015
    ],
    [
      "cadenas",
      0.015
    ],
    [
      "cachette",
      0.015
    ],
    [
      "sincerite",
      0.015
    ]
  ],
  "filmer": [
    [
      "cinematographier",
      0.5
    ],
    [
      "enregistrer",
      0.165
    ],
    [
      "photographier",
      0.165
    ],
    [
      "tourner",
      0.165
    ]
  ],
  "impact": [
    [
      "coup",
      0.18
    ],
    [
      "choc",
      0.135
    ],
    [
      "effet",
      0.135
    ],
    [
      "bruit",
      0.09
    ],
    [
      "heurt",
      0.09
    ],
    [
      "retentissement",
      0.09
    ],
    [
      "renfoncement",
      0.045
    ],
    [
      "influence",
      0.045
    ],
    [
      "consequence",
      0.045
    ],
    [
      "collision",
      0.045
    ],
    [
      "but",
      0.045
    ],
    [
      "retombees",
      0.045
    ]
  ],
  "rapport": [
    [
      "relation",
      0.075
    ],
    [
      "liaison",
      0.06
    ],
    [
      "correspondance",
      0.04
    ],
    [
      "accord",
      0.035
    ],
    [
      "union",
      0.035
    ],
    [
      "similitude",
      0.03
    ],
    [
      "affinite",
      0.03
    ],
    [
      "correlation",
      0.025
    ],
    [
      "lien",
      0.025
    ],
    [
      "analogie",
      0.0225
    ],
    [
      "ressemblance",
      0.02
    ],
    [
      "connexion",
      0.02
    ],
    [
      "dependance",
      0.0175
    ],
    [
      "gain",
      0.0175
    ],
    [
      "interet",
      0.0175
    ],
    [
      "revenu",
      0.015
    ],
    [
      "note",
      0.015
    ],
    [
      "harmonie",
      0.015
    ],
    [
      "recit",
      0.0125
    ],
    [
      "rapprochement",
      0.0125
    ],
    [
      "expose",
      0.0125
    ],
    [
      "convenance",
      0.0125
    ],
    [
      "alliance",
      0.0125
    ],
    [
      "proportion",
      0.01
    ],
    [
      "produit",
      0.01
    ],
    [
      "frequentation",
      0.01
    ],
    [
      "attachement",
      0.01
    ],
    [
      "attache",
      0.01
    ],
    [
      "ressource",
      0.0075
    ],
    [
      "mesure",
      0.0075
    ],
    [
      "enchainement",
      0.0075
    ],
    [
      "effet",
      0.0075
    ],
    [
      "declaration",
      0.0075
    ],
    [
      "connexite",
      0.0075
    ],
    [
      "concordance",
      0.0075
    ],
    [
      "communication",
      0.0075
    ],
    [
      "cause",
      0.0075
    ],
    [
      "accointance",
      0.0075
    ],
    [
      "fruit",
      0.005
    ],
    [
      "intelligence",
      0.005
    ],
    [
      "parente",
      0.005
    ],
    [
      "rente",
      0.005
    ],
    [
      "revelation",
      0.005
    ],
    [
      "trait",
      0.005
    ],
    [
      "division",
      0.005
    ],
    [
      "contact",
      0.005
    ],
    [
      "consequence",
      0.005
    ],
    [
      "accouplement",
      0.005
    ],
    [
      "action",
      0.005
    ],
    [
      "benefice",
      0.005
    ],
    [
      "coherence",
      0.005
    ],
    [
      "commerce",
      0.005
    ],
    [
      "conformite",
      0.005
    ],
    [
      "precision",
      0.0025
    ],
    [
      "quotient",
      0.0025
    ],
    [
      "raison",
      0.0025
    ],
    [
      "recoupement",
      0.0025
    ],
    [
      "rendement",
      0.0025
    ],
    [
      "terme",
      0.0025
    ],
    [
      "temoignage",
      0.0025
    ],
    [
      "version",
      0.0025
    ],
    [
      "echelle",
      0.0025
    ],
    [
      "pourcentage",
      0.0025
    ],
    [
      "analyse",
      0.0025
    ],
    [
      "casuel",
      0.0025
    ],
    [
      "conte",
      0.0025
    ],
    [
      "contiguite",
      0.0025
    ],
    [
      "description",
      0.0025
    ],
    [
      "denonciation",
      0.0025
    ],
    [
      "facteur",
      0.0025
    ],
    [
      "interdependance",
      0.0025
    ],
    [
      "narration",
      0.0025
    ],
    [
      "mouchardage",
      0.0
    ],
    [
      "memoire",
      0.0
    ],
    [
      "pertinence",
      0.0
    ],
    [
      "prix",
      0.0
    ],
    [
      "rapportage",
      0.0
    ],
    [
      "ratio",
      0.0
    ],
    [
      "renvoi",
      0.0
    ],
    [
      "tantieme",
      0.0
    ],
    [
      "indiscretion",
      0.0
    ],
    [
      "frottement",
      0.0
    ],
    [
      "fraction",
      0.0
    ],
    [
      "abouchement",
      0.0
    ],
    [
      "ajustement",
      0.0
    ],
    [
      "aspect",
      0.0
    ],
    [
      "boni",
      0.0
    ],
    [
      "bulletin",
      0.0
    ],
    [
      "cafardage",
      0.0
    ],
    [
      "causalite",
      0.0
    ],
    [
      "concomitance",
      0.0
    ],
    [
      "dire",
      0.0
    ],
    [
      "topo",
      0.0
    ]
  ],
  "tache": [
    [
      "souillure",
      0.0975
    ],
    [
      "impurete",
      0.0725
    ],
    [
      "faute",
      0.0525
    ],
    [
      "fletrissure",
      0.0525
    ],
    [
      "imperfection",
      0.0375
    ],
    [
      "marque",
      0.0375
    ],
    [
      "vice",
      0.0325
    ],
    [
      "salissure",
      0.0325
    ],
    [
      "salete",
      0.0325
    ],
    [
      "peche",
      0.0325
    ],
    [
      "macule",
      0.025
    ],
    [
      "deshonneur",
      0.025
    ],
    [
      "defaut",
      0.025
    ],
    [
      "bavure",
      0.025
    ],
    [
      "tare",
      0.0175
    ],
    [
      "ordure",
      0.0175
    ],
    [
      "noirceur",
      0.0175
    ],
    [
      "moucheture",
      0.0175
    ],
    [
      "malproprete",
      0.0175
    ],
    [
      "infamie",
      0.0175
    ],
    [
      "degradation",
      0.0175
    ],
    [
      "alteration",
      0.0175
    ],
    [
      "eclaboussure",
      0.01
    ],
    [
      "travers",
      0.01
    ],
    [
      "maille",
      0.01
    ],
    [
      "maculature",
      0.01
    ],
    [
      "honte",
      0.01
    ],
    [
      "envie",
      0.01
    ],
    [
      "defectuosite",
      0.01
    ],
    [
      "crasse",
      0.01
    ],
    [
      "naevus",
      0.005
    ],
    [
      "panachure",
      0.005
    ],
    [
      "pigment",
      0.005
    ],
    [
      "pate",
      0.005
    ],
    [
      "signe",
      0.005
    ],
    [
      "tacheture",
      0.005
    ],
    [
      "tavelure",
      0.005
    ],
    [
      "tiqueture",
      0.005
    ],
    [
      "trace",
      0.005
    ],
    [
      "trainee",
      0.005
    ],
    [
      "meurtrissure",
      0.005
    ],
    [
      "maillure",
      0.005
    ],
    [
      "madrure",
      0.005
    ],
    [
      "accroc",
      0.005
    ],
    [
      "albugo",
      0.005
    ],
    [
      "balzane",
      0.005
    ],
    [
      "bleu",
      0.005
    ],
    [
      "brulure",
      0.005
    ],
    [
      "crime",
      0.005
    ],
    [
      "ecchymose",
      0.005
    ],
    [
      "goutte",
      0.005
    ],
    [
      "immondice",
      0.005
    ],
    [
      "impregnation",
      0.005
    ],
    [
      "ephelide",
      0.005
    ]
  ],
  "tacher": [
    [
      "salir",
      0.2
    ],
    [
      "souiller",
      0.1775
    ],
    [
      "maculer",
      0.0625
    ],
    [
      "barbouiller",
      0.0525
    ],
    [
      "gater",
      0.04
    ],
    [
      "moucheter",
      0.04
    ],
    [
      "noircir",
      0.04
    ],
    [
      "ternir",
      0.03
    ],
    [
      "fletrir",
      0.03
    ],
    [
      "encrasser",
      0.03
    ],
    [
      "eclabousser",
      0.02
    ],
    [
      "tarer",
      0.02
    ],
    [
      "tacheter",
      0.02
    ],
    [
      "polluer",
      0.02
    ],
    [
      "entacher",
      0.02
    ],
    [
      "contaminer",
      0.02
    ],
    [
      "cochonner",
      0.02
    ],
    [
      "barioler",
      0.02
    ],
    [
      "abimer",
      0.02
    ],
    [
      "machurer",
      0.01
    ],
    [
      "marquer",
      0.01
    ],
    [
      "jaunir",
      0.01
    ],
    [
      "graisser",
      0.01
    ],
    [
      "embouer",
      0.01
    ],
    [
      "culotter",
      0.01
    ],
    [
      "crotter",
      0.01
    ],
    [
      "charbonner",
      0.01
    ],
    [
      "poisser",
      0.01
    ]
  ],
  "mechancete": [
    [
      "rosserie",
      0.1075
    ],
    [
      "amertume",
      0.0375
    ],
    [
      "crasse",
      0.0375
    ],
    [
      "vilenie",
      0.0375
    ],
    [
      "perfidie",
      0.0325
    ],
    [
      "noirceur",
      0.0275
    ],
    [
      "malice",
      0.0275
    ],
    [
      "aigreur",
      0.0275
    ],
    [
      "vacherie",
      0.025
    ],
    [
      "tour",
      0.025
    ],
    [
      "malignite",
      0.025
    ],
    [
      "cruaute",
      0.025
    ],
    [
      "calomnie",
      0.025
    ],
    [
      "bassesse",
      0.025
    ],
    [
      "venin",
      0.02
    ],
    [
      "turpitude",
      0.02
    ],
    [
      "perversite",
      0.02
    ],
    [
      "medisance",
      0.02
    ],
    [
      "mal",
      0.02
    ],
    [
      "indignite",
      0.02
    ],
    [
      "durete",
      0.02
    ],
    [
      "vice",
      0.015
    ],
    [
      "tourment",
      0.015
    ],
    [
      "malveillance",
      0.015
    ],
    [
      "horreur",
      0.015
    ],
    [
      "fiel",
      0.015
    ],
    [
      "entourloupette",
      0.015
    ],
    [
      "taquinerie",
      0.0125
    ],
    [
      "saloperie",
      0.0125
    ],
    [
      "salete",
      0.0125
    ],
    [
      "pique",
      0.0125
    ],
    [
      "mistoufle",
      0.0125
    ],
    [
      "ferocite",
      0.0125
    ],
    [
      "bile",
      0.0125
    ],
    [
      "tracasserie",
      0.0075
    ],
    [
      "sceleratesse",
      0.0075
    ],
    [
      "perversion",
      0.0075
    ],
    [
      "mefait",
      0.0075
    ],
    [
      "misere",
      0.0075
    ],
    [
      "malhonnetete",
      0.0075
    ],
    [
      "jalousie",
      0.0075
    ],
    [
      "hargne",
      0.0075
    ],
    [
      "depravation",
      0.0075
    ],
    [
      "causticite",
      0.0075
    ],
    [
      "allegation",
      0.0075
    ],
    [
      "agressivite",
      0.0075
    ],
    [
      "malfaisance",
      0.0025
    ],
    [
      "mauvaisete",
      0.0025
    ],
    [
      "mediocrite",
      0.0025
    ],
    [
      "sadisme",
      0.0025
    ],
    [
      "sortie",
      0.0025
    ],
    [
      "sottise",
      0.0025
    ],
    [
      "ivraie",
      0.0025
    ],
    [
      "farce",
      0.0025
    ],
    [
      "espieglerie",
      0.0025
    ],
    [
      "envie",
      0.0025
    ],
    [
      "endurcissement",
      0.0025
    ],
    [
      "crosses",
      0.0025
    ],
    [
      "couleuvre",
      0.0025
    ],
    [
      "boutade",
      0.0025
    ],
    [
      "tripotage",
      0.0025
    ]
  ],
  "clitoridien": [],
  "suicide": [],
  "doue": [
    [
      "doter",
      0.265
    ],
    [
      "donner",
      0.1325
    ],
    [
      "favoriser",
      0.1325
    ],
    [
      "gratifier",
      0.1325
    ],
    [
      "partager",
      0.1325
    ],
    [
      "avantager",
      0.065
    ],
    [
      "pourvoir",
      0.065
    ]
  ],
  "douer": [
    [
      "doter",
      0.265
    ],
    [
      "donner",
      0.1325
    ],
    [
      "favoriser",
      0.1325
    ],
    [
      "gratifier",
      0.1325
    ],
    [
      "partager",
      0.1325
    ],
    [
      "avantager",
      0.065
    ],
    [
      "pourvoir",
      0.065
    ]
  ],
  "concentrer": [
    [
      "reunir",
      0.105
    ],
    [
      "rassembler",
      0.095
    ],
    [
      "assembler",
      0.0625
    ],
    [
      "grouper",
      0.0625
    ],
    [
      "refouler",
      0.04
    ],
    [
      "diriger",
      0.04
    ],
    [
      "reduire",
      0.03
    ],
    [
      "rentrer",
      0.03
    ],
    [
      "renfermer",
      0.03
    ],
    [
      "regrouper",
      0.03
    ],
    [
      "ramener",
      0.03
    ],
    [
      "rallier",
      0.03
    ],
    [
      "diminuer",
      0.03
    ],
    [
      "centraliser",
      0.03
    ],
    [
      "canaliser",
      0.03
    ],
    [
      "appliquer",
      0.03
    ],
    [
      "tendre",
      0.02
    ],
    [
      "rapporter",
      0.02
    ],
    [
      "focaliser",
      0.02
    ],
    [
      "dissimuler",
      0.02
    ],
    [
      "contenir",
      0.02
    ],
    [
      "condenser",
      0.02
    ],
    [
      "associer",
      0.02
    ],
    [
      "reflechir",
      0.0075
    ],
    [
      "polariser",
      0.0075
    ],
    [
      "masser",
      0.0075
    ],
    [
      "integrer",
      0.0075
    ],
    [
      "freiner",
      0.0075
    ],
    [
      "fixer",
      0.0075
    ],
    [
      "cohober",
      0.0075
    ],
    [
      "bander",
      0.0075
    ],
    [
      "axer",
      0.0075
    ],
    [
      "accumuler",
      0.0075
    ]
  ],
  "repondeur": [],
  "decrocher": [
    [
      "enlever",
      0.1075
    ],
    [
      "detacher",
      0.08
    ],
    [
      "gagner",
      0.08
    ],
    [
      "rompre",
      0.08
    ],
    [
      "reculer",
      0.0525
    ],
    [
      "obtenir",
      0.0525
    ],
    [
      "flechir",
      0.0525
    ],
    [
      "denicher",
      0.0525
    ],
    [
      "attraper",
      0.0525
    ],
    [
      "remporter",
      0.025
    ],
    [
      "deteler",
      0.025
    ],
    [
      "dependre",
      0.025
    ],
    [
      "demantibuler",
      0.025
    ],
    [
      "degoter",
      0.025
    ],
    [
      "descendre",
      0.025
    ],
    [
      "atteindre",
      0.025
    ],
    [
      "oter",
      0.025
    ]
  ],
  "amnesie": [
    [
      "absence",
      0.25
    ],
    [
      "oubli",
      0.25
    ],
    [
      "trou",
      0.25
    ]
  ],
  "assumer": [
    [
      "endosser",
      0.2925
    ],
    [
      "supporter",
      0.175
    ],
    [
      "prendre",
      0.1175
    ],
    [
      "accepter",
      0.0575
    ],
    [
      "assurer",
      0.0575
    ]
  ],
  "acte": [
    [
      "action",
      0.1175
    ],
    [
      "titre",
      0.0575
    ],
    [
      "operation",
      0.04
    ],
    [
      "traite",
      0.0325
    ],
    [
      "loi",
      0.0325
    ],
    [
      "fait",
      0.0325
    ],
    [
      "exploit",
      0.0325
    ],
    [
      "certificat",
      0.0325
    ],
    [
      "realisation",
      0.0225
    ],
    [
      "piece",
      0.0225
    ],
    [
      "oeuvre",
      0.0225
    ],
    [
      "execution",
      0.0225
    ],
    [
      "expedition",
      0.0225
    ],
    [
      "entreprise",
      0.0225
    ],
    [
      "decret",
      0.0225
    ],
    [
      "arrete",
      0.0225
    ],
    [
      "convention",
      0.0225
    ],
    [
      "diplome",
      0.0225
    ],
    [
      "document",
      0.0225
    ],
    [
      "decision",
      0.0225
    ],
    [
      "texte",
      0.015
    ],
    [
      "protocole",
      0.015
    ],
    [
      "pratique",
      0.015
    ],
    [
      "geste",
      0.015
    ],
    [
      "contrat",
      0.015
    ],
    [
      "constitution",
      0.015
    ],
    [
      "charte",
      0.015
    ],
    [
      "bulle",
      0.015
    ],
    [
      "intervention",
      0.005
    ],
    [
      "manifestation",
      0.005
    ],
    [
      "mesure",
      0.005
    ],
    [
      "minute",
      0.005
    ],
    [
      "partie",
      0.005
    ],
    [
      "priere",
      0.005
    ],
    [
      "requisitoire",
      0.005
    ],
    [
      "testament",
      0.005
    ],
    [
      "trait",
      0.005
    ],
    [
      "grosse",
      0.005
    ],
    [
      "bill",
      0.005
    ],
    [
      "brevet",
      0.005
    ],
    [
      "bulletin",
      0.005
    ],
    [
      "capitulaire",
      0.005
    ],
    [
      "cession",
      0.005
    ],
    [
      "choix",
      0.005
    ],
    [
      "clause",
      0.005
    ],
    [
      "comportement",
      0.005
    ],
    [
      "constatation",
      0.005
    ],
    [
      "demarche",
      0.005
    ],
    [
      "episode",
      0.005
    ]
  ],
  "fumant": [
    [
      "bouillonnant",
      0.1325
    ],
    [
      "formidable",
      0.1325
    ],
    [
      "etonnant",
      0.1325
    ],
    [
      "sensationnel",
      0.065
    ],
    [
      "furieux",
      0.065
    ],
    [
      "fumeux",
      0.065
    ],
    [
      "fuligineux",
      0.065
    ],
    [
      "comique",
      0.065
    ],
    [
      "brulant",
      0.065
    ],
    [
      "echauffe",
      0.065
    ]
  ],
  "noix": [
    [
      "niais",
      0.22
    ],
    [
      "crotte",
      0.11
    ],
    [
      "fesse",
      0.11
    ],
    [
      "imbecile",
      0.11
    ],
    [
      "miches",
      0.11
    ],
    [
      "nigaud",
      0.11
    ],
    [
      "noisette",
      0.11
    ],
    [
      "noyau",
      0.11
    ]
  ],
  "enterrement": [
    [
      "funerailles",
      0.2075
    ],
    [
      "aneantissement",
      0.0775
    ],
    [
      "mort",
      0.0775
    ],
    [
      "sepulture",
      0.05
    ],
    [
      "obseques",
      0.05
    ],
    [
      "inhumation",
      0.05
    ],
    [
      "fin",
      0.05
    ],
    [
      "ensevelissement",
      0.05
    ],
    [
      "effondrement",
      0.05
    ],
    [
      "convoi",
      0.05
    ],
    [
      "echec",
      0.025
    ],
    [
      "rejet",
      0.025
    ],
    [
      "extinction",
      0.025
    ],
    [
      "enfouissement",
      0.025
    ],
    [
      "deuil",
      0.025
    ],
    [
      "abandon",
      0.025
    ],
    [
      "ecroulement",
      0.025
    ]
  ],
  "depouiller": [
    [
      "demunir",
      0.0675
    ],
    [
      "enlever",
      0.0675
    ],
    [
      "oter",
      0.065
    ],
    [
      "voler",
      0.0475
    ],
    [
      "deposseder",
      0.035
    ],
    [
      "ecorcher",
      0.03
    ],
    [
      "spolier",
      0.03
    ],
    [
      "priver",
      0.03
    ],
    [
      "plumer",
      0.03
    ],
    [
      "debarrasser",
      0.0275
    ],
    [
      "degager",
      0.025
    ],
    [
      "tondre",
      0.02
    ],
    [
      "ruiner",
      0.02
    ],
    [
      "retirer",
      0.02
    ],
    [
      "peler",
      0.02
    ],
    [
      "frustrer",
      0.02
    ],
    [
      "arracher",
      0.02
    ],
    [
      "egorger",
      0.0175
    ],
    [
      "sevrer",
      0.0175
    ],
    [
      "estamper",
      0.0175
    ],
    [
      "defaire",
      0.0175
    ],
    [
      "escroquer",
      0.015
    ],
    [
      "raser",
      0.01
    ],
    [
      "quitter",
      0.01
    ],
    [
      "piller",
      0.01
    ],
    [
      "nettoyer",
      0.01
    ],
    [
      "deshabiller",
      0.01
    ],
    [
      "derober",
      0.01
    ],
    [
      "denuder",
      0.01
    ],
    [
      "degarnir",
      0.01
    ],
    [
      "destituer",
      0.01
    ],
    [
      "etriller",
      0.0075
    ],
    [
      "etrangler",
      0.0075
    ],
    [
      "ranconner",
      0.0075
    ],
    [
      "gruger",
      0.0075
    ],
    [
      "effeuiller",
      0.0075
    ],
    [
      "detroner",
      0.0075
    ],
    [
      "examiner",
      0.005
    ],
    [
      "filouter",
      0.005
    ],
    [
      "perdre",
      0.005
    ],
    [
      "razzier",
      0.005
    ],
    [
      "revoquer",
      0.005
    ],
    [
      "evincer",
      0.005
    ],
    [
      "developper",
      0.005
    ],
    [
      "devaster",
      0.005
    ],
    [
      "consulter",
      0.005
    ],
    [
      "dessaisir",
      0.005
    ],
    [
      "depiauter",
      0.005
    ],
    [
      "depourvoir",
      0.005
    ],
    [
      "desheriter",
      0.005
    ],
    [
      "detrousser",
      0.005
    ],
    [
      "devetir",
      0.0
    ],
    [
      "exproprier",
      0.0
    ],
    [
      "fouiller",
      0.0
    ],
    [
      "fusiller",
      0.0
    ],
    [
      "isoler",
      0.0
    ],
    [
      "lire",
      0.0
    ],
    [
      "saigner",
      0.0
    ],
    [
      "saler",
      0.0
    ],
    [
      "ebourrer",
      0.0
    ],
    [
      "ebrancher",
      0.0
    ],
    [
      "ecailler",
      0.0
    ],
    [
      "ecorcer",
      0.0
    ],
    [
      "devaliser",
      0.0
    ],
    [
      "desosser",
      0.0
    ],
    [
      "desenvelopper",
      0.0
    ],
    [
      "abandonner",
      0.0
    ],
    [
      "appauvrir",
      0.0
    ],
    [
      "condenser",
      0.0
    ],
    [
      "dechausser",
      0.0
    ],
    [
      "decouronner",
      0.0
    ],
    [
      "defeuiller",
      0.0
    ],
    [
      "demonetiser",
      0.0
    ],
    [
      "denantir",
      0.0
    ],
    [
      "denuer",
      0.0
    ],
    [
      "depecer",
      0.0
    ],
    [
      "desavantager",
      0.0
    ],
    [
      "desencombrer",
      0.0
    ],
    [
      "epurer",
      0.0
    ]
  ],
  "depouille": [
    [
      "cadavre",
      0.1525
    ],
    [
      "os",
      0.1525
    ],
    [
      "reste",
      0.1525
    ],
    [
      "restes",
      0.1525
    ],
    [
      "corps",
      0.075
    ],
    [
      "mort",
      0.075
    ],
    [
      "mue",
      0.075
    ],
    [
      "proie",
      0.075
    ],
    [
      "residu",
      0.075
    ]
  ],
  "prof": [
    [
      "professeur",
      1.0
    ]
  ],
  "dresse": [
    [
      "former",
      0.0625
    ],
    [
      "faire",
      0.0525
    ],
    [
      "faconner",
      0.05
    ],
    [
      "preparer",
      0.04
    ],
    [
      "elever",
      0.04
    ],
    [
      "styler",
      0.0375
    ],
    [
      "instruire",
      0.0325
    ],
    [
      "eduquer",
      0.03
    ],
    [
      "habituer",
      0.03
    ],
    [
      "disposer",
      0.03
    ],
    [
      "mettre",
      0.0225
    ],
    [
      "monter",
      0.0225
    ],
    [
      "arranger",
      0.02
    ],
    [
      "placer",
      0.02
    ],
    [
      "polir",
      0.02
    ],
    [
      "poser",
      0.02
    ],
    [
      "etablir",
      0.0175
    ],
    [
      "travailler",
      0.0175
    ],
    [
      "soulever",
      0.0175
    ],
    [
      "exercer",
      0.0175
    ],
    [
      "entrainer",
      0.0175
    ],
    [
      "relever",
      0.015
    ],
    [
      "lever",
      0.015
    ],
    [
      "jeter",
      0.015
    ],
    [
      "dompter",
      0.015
    ],
    [
      "corriger",
      0.015
    ],
    [
      "braquer",
      0.015
    ],
    [
      "aplanir",
      0.015
    ],
    [
      "rompre",
      0.01
    ],
    [
      "redresser",
      0.01
    ],
    [
      "raboter",
      0.01
    ],
    [
      "planter",
      0.01
    ],
    [
      "installer",
      0.01
    ],
    [
      "exciter",
      0.01
    ],
    [
      "appreter",
      0.01
    ],
    [
      "apprivoiser",
      0.01
    ],
    [
      "ecrire",
      0.0075
    ],
    [
      "tracer",
      0.0075
    ],
    [
      "tendre",
      0.0075
    ],
    [
      "semer",
      0.0075
    ],
    [
      "preter",
      0.0075
    ],
    [
      "opposer",
      0.0075
    ],
    [
      "familiariser",
      0.0075
    ],
    [
      "degauchir",
      0.0075
    ],
    [
      "eriger",
      0.005
    ],
    [
      "hausser",
      0.005
    ],
    [
      "dominer",
      0.005
    ],
    [
      "discipliner",
      0.005
    ],
    [
      "dessiner",
      0.005
    ],
    [
      "camper",
      0.005
    ],
    [
      "cabrer",
      0.005
    ],
    [
      "apprendre",
      0.005
    ],
    [
      "aligner",
      0.005
    ],
    [
      "planer",
      0.0025
    ],
    [
      "mater",
      0.0025
    ],
    [
      "domestiquer",
      0.0025
    ],
    [
      "darder",
      0.0025
    ],
    [
      "catechiser",
      0.0025
    ],
    [
      "tailler",
      0.0025
    ]
  ],
  "dresser": [
    [
      "former",
      0.0625
    ],
    [
      "faire",
      0.0525
    ],
    [
      "faconner",
      0.05
    ],
    [
      "preparer",
      0.04
    ],
    [
      "elever",
      0.04
    ],
    [
      "styler",
      0.0375
    ],
    [
      "instruire",
      0.0325
    ],
    [
      "eduquer",
      0.03
    ],
    [
      "habituer",
      0.03
    ],
    [
      "disposer",
      0.03
    ],
    [
      "mettre",
      0.0225
    ],
    [
      "monter",
      0.0225
    ],
    [
      "arranger",
      0.02
    ],
    [
      "placer",
      0.02
    ],
    [
      "polir",
      0.02
    ],
    [
      "poser",
      0.02
    ],
    [
      "etablir",
      0.0175
    ],
    [
      "travailler",
      0.0175
    ],
    [
      "soulever",
      0.0175
    ],
    [
      "exercer",
      0.0175
    ],
    [
      "entrainer",
      0.0175
    ],
    [
      "relever",
      0.015
    ],
    [
      "lever",
      0.015
    ],
    [
      "jeter",
      0.015
    ],
    [
      "dompter",
      0.015
    ],
    [
      "corriger",
      0.015
    ],
    [
      "braquer",
      0.015
    ],
    [
      "aplanir",
      0.015
    ],
    [
      "rompre",
      0.01
    ],
    [
      "redresser",
      0.01
    ],
    [
      "raboter",
      0.01
    ],
    [
      "planter",
      0.01
    ],
    [
      "installer",
      0.01
    ],
    [
      "exciter",
      0.01
    ],
    [
      "appreter",
      0.01
    ],
    [
      "apprivoiser",
      0.01
    ],
    [
      "ecrire",
      0.0075
    ],
    [
      "tracer",
      0.0075
    ],
    [
      "tendre",
      0.0075
    ],
    [
      "semer",
      0.0075
    ],
    [
      "preter",
      0.0075
    ],
    [
      "opposer",
      0.0075
    ],
    [
      "familiariser",
      0.0075
    ],
    [
      "degauchir",
      0.0075
    ],
    [
      "eriger",
      0.005
    ],
    [
      "hausser",
      0.005
    ],
    [
      "dominer",
      0.005
    ],
    [
      "discipliner",
      0.005
    ],
    [
      "dessiner",
      0.005
    ],
    [
      "camper",
      0.005
    ],
    [
      "cabrer",
      0.005
    ],
    [
      "apprendre",
      0.005
    ],
    [
      "aligner",
      0.005
    ],
    [
      "planer",
      0.0025
    ],
    [
      "mater",
      0.0025
    ],
    [
      "domestiquer",
      0.0025
    ],
    [
      "darder",
      0.0025
    ],
    [
      "catechiser",
      0.0025
    ],
    [
      "tailler",
      0.0025
    ]
  ],
  "chiasse": [
    [
      "chiotte",
      0.1425
    ],
    [
      "chiure",
      0.1425
    ],
    [
      "colique",
      0.1425
    ],
    [
      "crainte",
      0.1425
    ],
    [
      "diarrhee",
      0.1425
    ],
    [
      "excrement",
      0.1425
    ],
    [
      "ecume",
      0.1425
    ]
  ],
  "patate": [
    [
      "beta",
      0.1425
    ],
    [
      "bete",
      0.1425
    ],
    [
      "diagramme",
      0.1425
    ],
    [
      "frite",
      0.1425
    ],
    [
      "peche",
      0.1425
    ]
  ],
  "comptant": [],
  "braquage": [
    [
      "attaque",
      1.0
    ]
  ],
  "expres": [
    [
      "categorique",
      0.19
    ],
    [
      "formel",
      0.19
    ],
    [
      "precis",
      0.095
    ],
    [
      "net",
      0.095
    ],
    [
      "explicite",
      0.095
    ],
    [
      "absolu",
      0.095
    ],
    [
      "approprie",
      0.0475
    ],
    [
      "clair",
      0.0475
    ],
    [
      "imperatif",
      0.0475
    ],
    [
      "positif",
      0.0475
    ]
  ],
  "whisky": [
    [
      "bourbon",
      0.25
    ],
    [
      "drink",
      0.25
    ],
    [
      "rye",
      0.25
    ],
    [
      "scotch",
      0.25
    ]
  ],
  "ote": [
    [
      "enlever",
      0.15
    ],
    [
      "retirer",
      0.0675
    ],
    [
      "supprimer",
      0.0625
    ],
    [
      "retrancher",
      0.0525
    ],
    [
      "depouiller",
      0.0325
    ],
    [
      "debarrasser",
      0.03
    ],
    [
      "couper",
      0.025
    ],
    [
      "arracher",
      0.025
    ],
    [
      "soustraire",
      0.0225
    ],
    [
      "effacer",
      0.0225
    ],
    [
      "degager",
      0.02
    ],
    [
      "detruire",
      0.02
    ],
    [
      "chasser",
      0.0175
    ],
    [
      "exclure",
      0.0175
    ],
    [
      "ecarter",
      0.0175
    ],
    [
      "prendre",
      0.0125
    ],
    [
      "extraire",
      0.0125
    ],
    [
      "biffer",
      0.0125
    ],
    [
      "barrer",
      0.0125
    ],
    [
      "tirer",
      0.0125
    ],
    [
      "separer",
      0.0125
    ],
    [
      "rayer",
      0.0125
    ],
    [
      "radier",
      0.0125
    ],
    [
      "lever",
      0.0125
    ],
    [
      "extirper",
      0.0125
    ],
    [
      "diminuer",
      0.0125
    ],
    [
      "sortir",
      0.01
    ],
    [
      "deposseder",
      0.01
    ],
    [
      "decharger",
      0.01
    ],
    [
      "demunir",
      0.0075
    ],
    [
      "priver",
      0.0075
    ],
    [
      "ravir",
      0.0075
    ],
    [
      "pousser",
      0.0075
    ],
    [
      "deposer",
      0.0075
    ],
    [
      "defaire",
      0.0075
    ],
    [
      "alleger",
      0.0075
    ],
    [
      "elaguer",
      0.005
    ],
    [
      "sevrer",
      0.005
    ],
    [
      "renvoyer",
      0.005
    ],
    [
      "quitter",
      0.005
    ],
    [
      "isoler",
      0.005
    ],
    [
      "gommer",
      0.005
    ],
    [
      "bannir",
      0.005
    ],
    [
      "amputer",
      0.005
    ],
    [
      "plumer",
      0.0025
    ],
    [
      "prelever",
      0.0025
    ],
    [
      "spolier",
      0.0025
    ],
    [
      "tondre",
      0.0025
    ],
    [
      "vider",
      0.0025
    ],
    [
      "peler",
      0.0025
    ],
    [
      "frustrer",
      0.0025
    ],
    [
      "excepter",
      0.0025
    ],
    [
      "derober",
      0.0025
    ],
    [
      "deduire",
      0.0025
    ],
    [
      "decouvrir",
      0.0025
    ],
    [
      "soulager",
      0.0025
    ],
    [
      "souffler",
      0.0025
    ],
    [
      "obliterer",
      0.0025
    ],
    [
      "deshabiller",
      0.0025
    ],
    [
      "deplacer",
      0.0025
    ],
    [
      "confisquer",
      0.0
    ],
    [
      "desservir",
      0.0
    ],
    [
      "decrocher",
      0.0
    ],
    [
      "defalquer",
      0.0
    ],
    [
      "retraire",
      0.0
    ]
  ],
  "depoli": [
    [
      "mat",
      1.0
    ]
  ],
  "teint": [
    [
      "colorer",
      0.1925
    ],
    [
      "orner",
      0.0825
    ],
    [
      "peindre",
      0.0825
    ],
    [
      "rehausser",
      0.055
    ],
    [
      "peinturlurer",
      0.055
    ],
    [
      "farder",
      0.055
    ],
    [
      "embellir",
      0.055
    ],
    [
      "barbouiller",
      0.055
    ],
    [
      "renover",
      0.0275
    ],
    [
      "rocouer",
      0.0275
    ],
    [
      "relever",
      0.0275
    ],
    [
      "rajeunir",
      0.0275
    ],
    [
      "raciner",
      0.0275
    ],
    [
      "noircir",
      0.0275
    ],
    [
      "impregner",
      0.0275
    ],
    [
      "garancer",
      0.0275
    ],
    [
      "colorier",
      0.0275
    ],
    [
      "cocheniller",
      0.0275
    ],
    [
      "bresiller",
      0.0275
    ],
    [
      "barioler",
      0.0275
    ],
    [
      "safraner",
      0.0275
    ]
  ],
  "teindre": [
    [
      "colorer",
      0.1925
    ],
    [
      "orner",
      0.0825
    ],
    [
      "peindre",
      0.0825
    ],
    [
      "rehausser",
      0.055
    ],
    [
      "peinturlurer",
      0.055
    ],
    [
      "farder",
      0.055
    ],
    [
      "embellir",
      0.055
    ],
    [
      "barbouiller",
      0.055
    ],
    [
      "renover",
      0.0275
    ],
    [
      "rocouer",
      0.0275
    ],
    [
      "relever",
      0.0275
    ],
    [
      "rajeunir",
      0.0275
    ],
    [
      "raciner",
      0.0275
    ],
    [
      "noircir",
      0.0275
    ],
    [
      "impregner",
      0.0275
    ],
    [
      "garancer",
      0.0275
    ],
    [
      "colorier",
      0.0275
    ],
    [
      "cocheniller",
      0.0275
    ],
    [
      "bresiller",
      0.0275
    ],
    [
      "barioler",
      0.0275
    ],
    [
      "safraner",
      0.0275
    ]
  ],
  "defraichir": [
    [
      "fletrir",
      0.285
    ],
    [
      "defleurir",
      0.1425
    ],
    [
      "deflorer",
      0.1425
    ],
    [
      "faner",
      0.1425
    ],
    [
      "ternir",
      0.1425
    ],
    [
      "decatir",
      0.07
    ],
    [
      "decolorer",
      0.07
    ]
  ],
  "defraichi": [
    [
      "fane",
      0.1825
    ],
    [
      "use",
      0.15
    ],
    [
      "passe",
      0.12
    ],
    [
      "usage",
      0.12
    ],
    [
      "vieux",
      0.09
    ],
    [
      "fatigue",
      0.09
    ],
    [
      "fletri",
      0.06
    ],
    [
      "fripe",
      0.06
    ],
    [
      "vieilli",
      0.06
    ],
    [
      "deforme",
      0.0275
    ],
    [
      "elime",
      0.0275
    ]
  ],
  "votres": [],
  "terreux": [
    [
      "livide",
      0.1625
    ],
    [
      "plombe",
      0.1625
    ],
    [
      "blafard",
      0.0725
    ],
    [
      "bleme",
      0.0725
    ],
    [
      "cadaverique",
      0.0525
    ],
    [
      "cireux",
      0.0525
    ],
    [
      "vitreux",
      0.035
    ],
    [
      "verdatre",
      0.035
    ],
    [
      "sale",
      0.035
    ],
    [
      "pale",
      0.035
    ],
    [
      "poussiereux",
      0.035
    ],
    [
      "olivatre",
      0.035
    ],
    [
      "exsangue",
      0.035
    ],
    [
      "jaune",
      0.0175
    ],
    [
      "have",
      0.0175
    ],
    [
      "glaiseux",
      0.0175
    ],
    [
      "cendreux",
      0.0175
    ],
    [
      "cadavereux",
      0.0175
    ],
    [
      "brun",
      0.0175
    ],
    [
      "brouille",
      0.0175
    ],
    [
      "bouseux",
      0.0175
    ],
    [
      "malpropre",
      0.0175
    ]
  ],
  "hideux": [
    [
      "horrible",
      0.15
    ],
    [
      "repoussant",
      0.115
    ],
    [
      "ignoble",
      0.0875
    ],
    [
      "laid",
      0.0875
    ],
    [
      "abject",
      0.08
    ],
    [
      "affreux",
      0.08
    ],
    [
      "repugnant",
      0.08
    ],
    [
      "infect",
      0.07
    ],
    [
      "infame",
      0.0425
    ],
    [
      "abominable",
      0.0425
    ],
    [
      "atroce",
      0.025
    ],
    [
      "execrable",
      0.025
    ],
    [
      "monstrueux",
      0.025
    ],
    [
      "nauseabond",
      0.0175
    ],
    [
      "sordide",
      0.0175
    ],
    [
      "vilain",
      0.0175
    ],
    [
      "difforme",
      0.0075
    ],
    [
      "ord",
      0.0075
    ]
  ],
  "chatiment": [
    [
      "punition",
      0.205
    ],
    [
      "peine",
      0.165
    ],
    [
      "correction",
      0.06
    ],
    [
      "vengeance",
      0.04
    ],
    [
      "supplice",
      0.04
    ],
    [
      "sanction",
      0.04
    ],
    [
      "repression",
      0.04
    ],
    [
      "expiation",
      0.04
    ],
    [
      "damnation",
      0.04
    ],
    [
      "coup",
      0.04
    ],
    [
      "torgnole",
      0.0175
    ],
    [
      "salaire",
      0.0175
    ],
    [
      "revanche",
      0.0175
    ],
    [
      "represailles",
      0.0175
    ],
    [
      "penitence",
      0.0175
    ],
    [
      "prix",
      0.0175
    ],
    [
      "foudre",
      0.0175
    ],
    [
      "dam",
      0.0175
    ],
    [
      "corde",
      0.0175
    ],
    [
      "bras",
      0.0175
    ],
    [
      "boulet",
      0.0175
    ],
    [
      "torture",
      0.0175
    ]
  ],
  "pouls": [],
  "existence": [
    [
      "vie",
      0.2675
    ],
    [
      "etat",
      0.115
    ],
    [
      "destin",
      0.075
    ],
    [
      "nature",
      0.075
    ],
    [
      "realite",
      0.075
    ],
    [
      "etre",
      0.075
    ],
    [
      "presence",
      0.0375
    ],
    [
      "jours",
      0.0375
    ],
    [
      "jour",
      0.0375
    ],
    [
      "histoire",
      0.0375
    ],
    [
      "duree",
      0.0375
    ],
    [
      "destinee",
      0.0375
    ],
    [
      "cenesthesie",
      0.0375
    ],
    [
      "age",
      0.0375
    ]
  ],
  "solution": [
    [
      "fin",
      0.13
    ],
    [
      "resolution",
      0.0975
    ],
    [
      "conclusion",
      0.0875
    ],
    [
      "denouement",
      0.0875
    ],
    [
      "achevement",
      0.075
    ],
    [
      "resultat",
      0.075
    ],
    [
      "terminaison",
      0.0525
    ],
    [
      "terme",
      0.03
    ],
    [
      "reglement",
      0.03
    ],
    [
      "issue",
      0.03
    ],
    [
      "decision",
      0.03
    ],
    [
      "aboutissement",
      0.03
    ],
    [
      "remede",
      0.02
    ],
    [
      "moyen",
      0.02
    ],
    [
      "coda",
      0.02
    ],
    [
      "bout",
      0.02
    ],
    [
      "tisane",
      0.01
    ],
    [
      "solute",
      0.01
    ],
    [
      "reponse",
      0.01
    ],
    [
      "racine",
      0.01
    ],
    [
      "parti",
      0.01
    ],
    [
      "paiement",
      0.01
    ],
    [
      "interruption",
      0.01
    ],
    [
      "hiatus",
      0.01
    ],
    [
      "determination",
      0.01
    ],
    [
      "dissolution",
      0.01
    ],
    [
      "coupure",
      0.01
    ],
    [
      "clef",
      0.01
    ],
    [
      "epilogue",
      0.01
    ]
  ],
  "nuisance": [
    [
      "dommage",
      0.18
    ],
    [
      "degradation",
      0.18
    ],
    [
      "depredation",
      0.18
    ],
    [
      "pollution",
      0.18
    ],
    [
      "agression",
      0.09
    ],
    [
      "mefait",
      0.09
    ],
    [
      "nocivite",
      0.09
    ]
  ],
  "photocopier": [
    [
      "reprographier",
      0.5
    ]
  ],
  "photocopie": [
    [
      "photographie",
      0.18
    ],
    [
      "reproduction",
      0.09
    ],
    [
      "photostat",
      0.09
    ],
    [
      "photogramme",
      0.09
    ],
    [
      "photocalque",
      0.09
    ],
    [
      "double",
      0.09
    ],
    [
      "diapositive",
      0.09
    ],
    [
      "copie",
      0.09
    ],
    [
      "reprographie",
      0.09
    ]
  ],
  "monotonie": [
    [
      "platitude",
      0.215
    ],
    [
      "tristesse",
      0.215
    ],
    [
      "ennui",
      0.1425
    ],
    [
      "fadeur",
      0.1425
    ],
    [
      "grisaille",
      0.07
    ],
    [
      "prosaisme",
      0.07
    ],
    [
      "psalmodie",
      0.07
    ],
    [
      "uniformite",
      0.07
    ]
  ],
  "lobotomie": [
    [
      "leucotomie",
      1.0
    ]
  ],
  "chemise": [
    [
      "brassiere",
      0.0775
    ],
    [
      "cotte",
      0.0775
    ],
    [
      "dossier",
      0.0775
    ],
    [
      "haubert",
      0.0775
    ],
    [
      "jaseron",
      0.0375
    ],
    [
      "limace",
      0.0375
    ],
    [
      "lingerie",
      0.0375
    ],
    [
      "liquette",
      0.0375
    ],
    [
      "nuisette",
      0.0375
    ],
    [
      "parure",
      0.0375
    ],
    [
      "jaseran",
      0.0375
    ],
    [
      "haire",
      0.0375
    ],
    [
      "farde",
      0.0375
    ],
    [
      "combinaison",
      0.0375
    ],
    [
      "classeur",
      0.0375
    ],
    [
      "cilice",
      0.0375
    ],
    [
      "chemisette",
      0.0375
    ],
    [
      "camisole",
      0.0375
    ],
    [
      "banniere",
      0.0375
    ],
    [
      "revetement",
      0.0375
    ]
  ],
  "cravate": [
    [
      "rabat",
      0.2
    ],
    [
      "attache",
      0.1
    ],
    [
      "bandage",
      0.1
    ],
    [
      "col",
      0.1
    ],
    [
      "cordage",
      0.1
    ],
    [
      "jabot",
      0.1
    ],
    [
      "liure",
      0.1
    ],
    [
      "regate",
      0.1
    ]
  ],
  "cravater": [
    [
      "habler",
      0.3325
    ],
    [
      "piquer",
      0.3325
    ],
    [
      "voler",
      0.3325
    ]
  ],
  "patte": [
    [
      "main",
      0.1425
    ],
    [
      "griffe",
      0.09
    ],
    [
      "style",
      0.0775
    ],
    [
      "ton",
      0.05
    ],
    [
      "pouvoir",
      0.05
    ],
    [
      "pied",
      0.05
    ],
    [
      "habilete",
      0.05
    ],
    [
      "ecriture",
      0.025
    ],
    [
      "virtuosite",
      0.025
    ],
    [
      "touche",
      0.025
    ],
    [
      "racine",
      0.025
    ],
    [
      "pinceau",
      0.025
    ],
    [
      "pince",
      0.025
    ],
    [
      "maitrise",
      0.025
    ],
    [
      "dependance",
      0.025
    ],
    [
      "chic",
      0.025
    ],
    [
      "bras",
      0.025
    ],
    [
      "adresse",
      0.025
    ],
    [
      "martingale",
      0.0125
    ],
    [
      "patoche",
      0.0125
    ],
    [
      "paturon",
      0.0125
    ],
    [
      "plume",
      0.0125
    ],
    [
      "rouflaquette",
      0.0125
    ],
    [
      "serre",
      0.0125
    ],
    [
      "languette",
      0.0125
    ],
    [
      "jambe",
      0.0125
    ],
    [
      "favori",
      0.0125
    ],
    [
      "doigte",
      0.0125
    ],
    [
      "crochet",
      0.0125
    ],
    [
      "croc",
      0.0125
    ],
    [
      "cachet",
      0.0125
    ],
    [
      "bande",
      0.0125
    ],
    [
      "epaule",
      0.0125
    ]
  ],
  "employe": [
    [
      "user",
      0.11
    ],
    [
      "utiliser",
      0.1025
    ],
    [
      "prendre",
      0.0825
    ],
    [
      "appliquer",
      0.065
    ],
    [
      "pratiquer",
      0.055
    ],
    [
      "consacrer",
      0.045
    ],
    [
      "disposer",
      0.045
    ],
    [
      "mettre",
      0.045
    ],
    [
      "passer",
      0.035
    ],
    [
      "consommer",
      0.035
    ],
    [
      "occuper",
      0.025
    ],
    [
      "engager",
      0.025
    ],
    [
      "donner",
      0.025
    ],
    [
      "consumer",
      0.025
    ],
    [
      "apporter",
      0.025
    ],
    [
      "exercer",
      0.0175
    ],
    [
      "deployer",
      0.0175
    ],
    [
      "depenser",
      0.0175
    ],
    [
      "commettre",
      0.0175
    ],
    [
      "charger",
      0.0175
    ],
    [
      "agir",
      0.0175
    ],
    [
      "adopter",
      0.0175
    ],
    [
      "recourir",
      0.0075
    ],
    [
      "preposer",
      0.0075
    ],
    [
      "profiter",
      0.0075
    ],
    [
      "embaucher",
      0.0075
    ],
    [
      "destiner",
      0.0075
    ],
    [
      "amortir",
      0.0075
    ],
    [
      "recruter",
      0.0075
    ]
  ],
  "rangee": [
    [
      "ordonner",
      0.095
    ],
    [
      "classer",
      0.0875
    ],
    [
      "placer",
      0.075
    ],
    [
      "arranger",
      0.0675
    ],
    [
      "disposer",
      0.0675
    ],
    [
      "caser",
      0.06
    ],
    [
      "distribuer",
      0.045
    ],
    [
      "mettre",
      0.04
    ],
    [
      "contenir",
      0.025
    ],
    [
      "serrer",
      0.025
    ],
    [
      "echelonner",
      0.0175
    ],
    [
      "repartir",
      0.0175
    ],
    [
      "remiser",
      0.0175
    ],
    [
      "remettre",
      0.0175
    ],
    [
      "harmoniser",
      0.0175
    ],
    [
      "garer",
      0.0175
    ],
    [
      "enfermer",
      0.0175
    ],
    [
      "debrouiller",
      0.0175
    ],
    [
      "contraindre",
      0.0175
    ],
    [
      "aligner",
      0.0175
    ],
    [
      "redresser",
      0.0125
    ],
    [
      "situer",
      0.0125
    ],
    [
      "separer",
      0.0125
    ],
    [
      "serier",
      0.0125
    ],
    [
      "plier",
      0.0125
    ],
    [
      "parquer",
      0.0125
    ],
    [
      "faire",
      0.0125
    ],
    [
      "courber",
      0.0125
    ],
    [
      "classifier",
      0.0125
    ],
    [
      "cataloguer",
      0.0125
    ],
    [
      "subjuguer",
      0.005
    ],
    [
      "retirer",
      0.005
    ],
    [
      "resserrer",
      0.005
    ],
    [
      "longer",
      0.005
    ],
    [
      "grouper",
      0.005
    ],
    [
      "entreposer",
      0.005
    ],
    [
      "endiguer",
      0.005
    ],
    [
      "corriger",
      0.005
    ],
    [
      "etiqueter",
      0.005
    ]
  ],
  "range": [
    [
      "ordonner",
      0.095
    ],
    [
      "classer",
      0.0875
    ],
    [
      "placer",
      0.075
    ],
    [
      "arranger",
      0.0675
    ],
    [
      "disposer",
      0.0675
    ],
    [
      "caser",
      0.06
    ],
    [
      "distribuer",
      0.045
    ],
    [
      "mettre",
      0.04
    ],
    [
      "contenir",
      0.025
    ],
    [
      "serrer",
      0.025
    ],
    [
      "echelonner",
      0.0175
    ],
    [
      "repartir",
      0.0175
    ],
    [
      "remiser",
      0.0175
    ],
    [
      "remettre",
      0.0175
    ],
    [
      "harmoniser",
      0.0175
    ],
    [
      "garer",
      0.0175
    ],
    [
      "enfermer",
      0.0175
    ],
    [
      "debrouiller",
      0.0175
    ],
    [
      "contraindre",
      0.0175
    ],
    [
      "aligner",
      0.0175
    ],
    [
      "redresser",
      0.0125
    ],
    [
      "situer",
      0.0125
    ],
    [
      "separer",
      0.0125
    ],
    [
      "serier",
      0.0125
    ],
    [
      "plier",
      0.0125
    ],
    [
      "parquer",
      0.0125
    ],
    [
      "faire",
      0.0125
    ],
    [
      "courber",
      0.0125
    ],
    [
      "classifier",
      0.0125
    ],
    [
      "cataloguer",
      0.0125
    ],
    [
      "subjuguer",
      0.005
    ],
    [
      "retirer",
      0.005
    ],
    [
      "resserrer",
      0.005
    ],
    [
      "longer",
      0.005
    ],
    [
      "grouper",
      0.005
    ],
    [
      "entreposer",
      0.005
    ],
    [
      "endiguer",
      0.005
    ],
    [
      "corriger",
      0.005
    ],
    [
      "etiqueter",
      0.005
    ]
  ],
  "etrique": [
    [
      "diminuer",
      0.4
    ],
    [
      "raccourcir",
      0.2
    ],
    [
      "resserrer",
      0.2
    ],
    [
      "ecourter",
      0.2
    ]
  ],
  "etriquer": [
    [
      "diminuer",
      0.4
    ],
    [
      "raccourcir",
      0.2
    ],
    [
      "resserrer",
      0.2
    ],
    [
      "ecourter",
      0.2
    ]
  ],
  "conforter": [
    [
      "reconforter",
      0.1675
    ],
    [
      "fortifier",
      0.15
    ],
    [
      "remonter",
      0.1125
    ],
    [
      "revigorer",
      0.1125
    ],
    [
      "aider",
      0.075
    ],
    [
      "soutenir",
      0.075
    ],
    [
      "renforcer",
      0.055
    ],
    [
      "augmenter",
      0.055
    ],
    [
      "affermir",
      0.055
    ],
    [
      "consoler",
      0.0375
    ],
    [
      "encourager",
      0.0375
    ],
    [
      "relever",
      0.0375
    ],
    [
      "servir",
      0.0175
    ]
  ],
  "mediocrite": [
    [
      "petitesse",
      0.19
    ],
    [
      "faiblesse",
      0.1375
    ],
    [
      "pauvrete",
      0.1025
    ],
    [
      "bassesse",
      0.0675
    ],
    [
      "modicite",
      0.0675
    ],
    [
      "platitude",
      0.0675
    ],
    [
      "mesquinerie",
      0.05
    ],
    [
      "insuffisance",
      0.05
    ],
    [
      "insignifiance",
      0.05
    ],
    [
      "imperfection",
      0.05
    ],
    [
      "banalite",
      0.0325
    ],
    [
      "exiguite",
      0.0325
    ],
    [
      "deche",
      0.015
    ],
    [
      "incapacite",
      0.015
    ],
    [
      "modestie",
      0.015
    ],
    [
      "mechancete",
      0.015
    ],
    [
      "obscurite",
      0.015
    ]
  ],
  "representant": [
    [
      "negociateur",
      0.09
    ],
    [
      "envoye",
      0.0825
    ],
    [
      "ambassadeur",
      0.0675
    ],
    [
      "agent",
      0.06
    ],
    [
      "intermediaire",
      0.06
    ],
    [
      "mandataire",
      0.045
    ],
    [
      "diplomate",
      0.0325
    ],
    [
      "depute",
      0.0325
    ],
    [
      "placier",
      0.0325
    ],
    [
      "emissaire",
      0.0275
    ],
    [
      "defenseur",
      0.0275
    ],
    [
      "delegue",
      0.0225
    ],
    [
      "vendeur",
      0.0225
    ],
    [
      "voyageur",
      0.015
    ],
    [
      "legat",
      0.015
    ],
    [
      "courtier",
      0.015
    ],
    [
      "responsable",
      0.01
    ],
    [
      "specimen",
      0.01
    ],
    [
      "truchement",
      0.01
    ],
    [
      "tuteur",
      0.01
    ],
    [
      "type",
      0.01
    ],
    [
      "echantillon",
      0.01
    ],
    [
      "plenipotentiaire",
      0.01
    ],
    [
      "commis",
      0.01
    ],
    [
      "exemplaire",
      0.01
    ],
    [
      "mediateur",
      0.01
    ],
    [
      "organe",
      0.01
    ],
    [
      "nonce",
      0.005
    ],
    [
      "placeur",
      0.005
    ],
    [
      "remplacant",
      0.005
    ],
    [
      "resident",
      0.005
    ],
    [
      "substitut",
      0.005
    ],
    [
      "syndic",
      0.005
    ],
    [
      "totem",
      0.005
    ],
    [
      "visiteur",
      0.005
    ],
    [
      "modele",
      0.005
    ],
    [
      "missionnaire",
      0.005
    ],
    [
      "ministre",
      0.005
    ],
    [
      "V.R.P.",
      0.005
    ],
    [
      "avocat",
      0.005
    ],
    [
      "avoue",
      0.005
    ],
    [
      "conseil",
      0.005
    ],
    [
      "consul",
      0.005
    ],
    [
      "correspondant",
      0.005
    ],
    [
      "demarcheur",
      0.005
    ],
    [
      "figurant",
      0.005
    ],
    [
      "individu",
      0.005
    ],
    [
      "elu",
      0.005
    ]
  ],
  "grassouillet": [
    [
      "replet",
      0.14
    ],
    [
      "gras",
      0.115
    ],
    [
      "rondelet",
      0.115
    ],
    [
      "rondouillard",
      0.115
    ],
    [
      "rebondi",
      0.0925
    ],
    [
      "rond",
      0.07
    ],
    [
      "potele",
      0.045
    ],
    [
      "dodu",
      0.045
    ],
    [
      "charnu",
      0.045
    ],
    [
      "adipeux",
      0.045
    ],
    [
      "bedonnant",
      0.0225
    ],
    [
      "boulot",
      0.0225
    ],
    [
      "enrobe",
      0.0225
    ],
    [
      "grasset",
      0.0225
    ],
    [
      "grosset",
      0.0225
    ],
    [
      "poupard",
      0.0225
    ]
  ],
  "cassoulet": [
    [
      "ragout",
      1.0
    ]
  ],
  "mayonnaise": [],
  "comptable": [
    [
      "caissier",
      0.1325
    ],
    [
      "garant",
      0.1325
    ],
    [
      "responsable",
      0.1325
    ],
    [
      "tuteur",
      0.065
    ],
    [
      "tresorier",
      0.065
    ],
    [
      "teneur",
      0.065
    ],
    [
      "receveur",
      0.065
    ],
    [
      "otage",
      0.065
    ],
    [
      "ordonnateur",
      0.065
    ],
    [
      "facturier",
      0.065
    ],
    [
      "agree",
      0.065
    ],
    [
      "econome",
      0.065
    ]
  ],
  "senile": [
    [
      "gateux",
      0.1275
    ],
    [
      "affaibli",
      0.095
    ],
    [
      "caduc",
      0.095
    ],
    [
      "ramolli",
      0.095
    ],
    [
      "use",
      0.095
    ],
    [
      "eteint",
      0.0625
    ],
    [
      "age",
      0.0625
    ],
    [
      "vieux",
      0.0625
    ],
    [
      "fatigue",
      0.0625
    ],
    [
      "deliquescent",
      0.0625
    ],
    [
      "decrepit",
      0.0625
    ],
    [
      "dechu",
      0.03
    ],
    [
      "gaga",
      0.03
    ],
    [
      "impotent",
      0.03
    ]
  ],
  "secretaire": [
    [
      "employe",
      0.1575
    ],
    [
      "scribe",
      0.105
    ],
    [
      "cabinet",
      0.0775
    ],
    [
      "tabellion",
      0.0525
    ],
    [
      "scribouillard",
      0.0525
    ],
    [
      "copiste",
      0.0525
    ],
    [
      "clerc",
      0.0525
    ],
    [
      "bureau",
      0.0525
    ],
    [
      "adjoint",
      0.0525
    ],
    [
      "serpentaire",
      0.025
    ],
    [
      "scriban",
      0.025
    ],
    [
      "redacteur",
      0.025
    ],
    [
      "rapace",
      0.025
    ],
    [
      "dactylo",
      0.025
    ],
    [
      "collaborateur",
      0.025
    ],
    [
      "chancelier",
      0.025
    ],
    [
      "bahut",
      0.025
    ],
    [
      "ecritoire",
      0.025
    ]
  ],
  "discussion": [
    [
      "dispute",
      0.15
    ],
    [
      "querelle",
      0.12
    ],
    [
      "contestation",
      0.0575
    ],
    [
      "altercation",
      0.0525
    ],
    [
      "debat",
      0.0525
    ],
    [
      "chicane",
      0.0475
    ],
    [
      "differend",
      0.0375
    ],
    [
      "bagarre",
      0.0275
    ],
    [
      "grabuge",
      0.02
    ],
    [
      "conversation",
      0.02
    ],
    [
      "conflit",
      0.02
    ],
    [
      "bisbille",
      0.0175
    ],
    [
      "controverse",
      0.0175
    ],
    [
      "demele",
      0.0175
    ],
    [
      "scene",
      0.0175
    ],
    [
      "rixe",
      0.0125
    ],
    [
      "conference",
      0.0125
    ],
    [
      "bataille",
      0.0125
    ],
    [
      "affaire",
      0.0125
    ],
    [
      "noise",
      0.01
    ],
    [
      "litige",
      0.01
    ],
    [
      "examen",
      0.01
    ],
    [
      "desaccord",
      0.01
    ],
    [
      "deliberation",
      0.01
    ],
    [
      "dissension",
      0.01
    ],
    [
      "discorde",
      0.01
    ],
    [
      "difficulte",
      0.01
    ],
    [
      "etude",
      0.0075
    ],
    [
      "seance",
      0.0075
    ],
    [
      "question",
      0.0075
    ],
    [
      "palabre",
      0.0075
    ],
    [
      "explication",
      0.0075
    ],
    [
      "chamaillerie",
      0.0075
    ],
    [
      "objection",
      0.005
    ],
    [
      "negociation",
      0.005
    ],
    [
      "heurt",
      0.005
    ],
    [
      "entretien",
      0.005
    ],
    [
      "desordre",
      0.005
    ],
    [
      "dissertation",
      0.005
    ],
    [
      "dialogue",
      0.005
    ],
    [
      "colloque",
      0.005
    ],
    [
      "chamaille",
      0.005
    ],
    [
      "pilpoul",
      0.0025
    ],
    [
      "polemique",
      0.0025
    ],
    [
      "pourparler",
      0.0025
    ],
    [
      "prise",
      0.0025
    ],
    [
      "riotte",
      0.0025
    ],
    [
      "replique",
      0.0025
    ],
    [
      "tempete",
      0.0025
    ],
    [
      "logomachie",
      0.0025
    ],
    [
      "ergotage",
      0.0025
    ],
    [
      "empoignade",
      0.0025
    ],
    [
      "argutie",
      0.0025
    ],
    [
      "attrapage",
      0.0025
    ],
    [
      "chamaillis",
      0.0025
    ],
    [
      "contention",
      0.0025
    ],
    [
      "criaillerie",
      0.0025
    ],
    [
      "disceptation",
      0.0025
    ],
    [
      "disputation",
      0.0025
    ],
    [
      "dechirement",
      0.0025
    ],
    [
      "vie",
      0.0025
    ]
  ],
  "sterile": [
    [
      "aride",
      0.1025
    ],
    [
      "improductif",
      0.0725
    ],
    [
      "vain",
      0.0725
    ],
    [
      "inutile",
      0.065
    ],
    [
      "infertile",
      0.0575
    ],
    [
      "vide",
      0.0575
    ],
    [
      "pauvre",
      0.0425
    ],
    [
      "ingrat",
      0.0425
    ],
    [
      "infecond",
      0.0425
    ],
    [
      "inefficace",
      0.0425
    ],
    [
      "inculte",
      0.035
    ],
    [
      "infructueux",
      0.035
    ],
    [
      "desert",
      0.0275
    ],
    [
      "desertique",
      0.0275
    ],
    [
      "maigre",
      0.0275
    ],
    [
      "sec",
      0.0275
    ],
    [
      "negatif",
      0.02
    ],
    [
      "nul",
      0.02
    ],
    [
      "impuissant",
      0.02
    ],
    [
      "brehaigne",
      0.0125
    ],
    [
      "futile",
      0.0125
    ],
    [
      "inoperant",
      0.0125
    ],
    [
      "nu",
      0.0125
    ],
    [
      "inhospitalier",
      0.005
    ],
    [
      "mule",
      0.005
    ],
    [
      "oiseux",
      0.005
    ],
    [
      "pouilleux",
      0.005
    ],
    [
      "perilleux",
      0.005
    ],
    [
      "incultivable",
      0.005
    ],
    [
      "desole",
      0.005
    ],
    [
      "desinfecte",
      0.005
    ],
    [
      "desherite",
      0.005
    ],
    [
      "desseche",
      0.005
    ],
    [
      "avorte",
      0.005
    ],
    [
      "aseptique",
      0.005
    ]
  ],
  "cadavre": [
    [
      "mort",
      0.1875
    ],
    [
      "restes",
      0.1875
    ],
    [
      "depouille",
      0.125
    ],
    [
      "reliques",
      0.06
    ],
    [
      "os",
      0.06
    ],
    [
      "momie",
      0.06
    ],
    [
      "macchabee",
      0.06
    ],
    [
      "corps",
      0.06
    ],
    [
      "charogne",
      0.06
    ],
    [
      "assassine",
      0.06
    ]
  ],
  "parachute": [
    [
      "bombarder",
      0.4
    ],
    [
      "catapulter",
      0.2
    ],
    [
      "droper",
      0.2
    ],
    [
      "nommer",
      0.2
    ]
  ],
  "parachuter": [
    [
      "bombarder",
      0.4
    ],
    [
      "catapulter",
      0.2
    ],
    [
      "droper",
      0.2
    ],
    [
      "nommer",
      0.2
    ]
  ],
  "beurrer": [
    [
      "enduire",
      1.0
    ]
  ],
  "beurre": [
    [
      "graisse",
      0.3325
    ],
    [
      "margarine",
      0.3325
    ],
    [
      "oseille",
      0.3325
    ]
  ],
  "salarie": [
    [
      "payer",
      0.4275
    ],
    [
      "appointer",
      0.1425
    ],
    [
      "gager",
      0.1425
    ],
    [
      "retribuer",
      0.1425
    ],
    [
      "solder",
      0.1425
    ]
  ],
  "salarier": [
    [
      "payer",
      0.4275
    ],
    [
      "appointer",
      0.1425
    ],
    [
      "gager",
      0.1425
    ],
    [
      "retribuer",
      0.1425
    ],
    [
      "solder",
      0.1425
    ]
  ],
  "vierge": [
    [
      "Madone",
      0.165
    ],
    [
      "Marie",
      0.165
    ]
  ],
  "effarouche": [
    [
      "affoler",
      0.145
    ],
    [
      "alarmer",
      0.0975
    ],
    [
      "effrayer",
      0.0975
    ],
    [
      "inquieter",
      0.0975
    ],
    [
      "troubler",
      0.0975
    ],
    [
      "terroriser",
      0.0725
    ],
    [
      "epouvanter",
      0.0475
    ],
    [
      "offusquer",
      0.0475
    ],
    [
      "intimider",
      0.0475
    ],
    [
      "effarer",
      0.0475
    ],
    [
      "choquer",
      0.0475
    ],
    [
      "blesser",
      0.0225
    ],
    [
      "rebuter",
      0.0225
    ],
    [
      "epeurer",
      0.0225
    ]
  ],
  "sequestrer": [
    [
      "enfermer",
      0.2125
    ],
    [
      "cloitrer",
      0.1475
    ],
    [
      "renfermer",
      0.1125
    ],
    [
      "claquemurer",
      0.065
    ],
    [
      "emprisonner",
      0.065
    ],
    [
      "isoler",
      0.0475
    ],
    [
      "interner",
      0.0475
    ],
    [
      "claustrer",
      0.0475
    ],
    [
      "murer",
      0.0325
    ],
    [
      "garder",
      0.0325
    ],
    [
      "detenir",
      0.0325
    ],
    [
      "chambrer",
      0.0325
    ],
    [
      "boucler",
      0.0325
    ],
    [
      "barricader",
      0.0325
    ],
    [
      "enterrer",
      0.015
    ],
    [
      "kidnapper",
      0.015
    ],
    [
      "verrouiller",
      0.015
    ]
  ],
  "snober": [
    [
      "becher",
      0.3325
    ],
    [
      "dedaigner",
      0.3325
    ],
    [
      "mepriser",
      0.3325
    ]
  ],
  "beauf": [],
  "embourgeoiser": [
    [
      "banaliser",
      1.0
    ]
  ],
  "embourgeoise": [
    [
      "banaliser",
      1.0
    ]
  ],
  "ouvrier": [
    [
      "artisan",
      0.1325
    ],
    [
      "travailleur",
      0.1325
    ],
    [
      "promoteur",
      0.065
    ],
    [
      "manuel",
      0.065
    ],
    [
      "manoeuvre",
      0.065
    ],
    [
      "journalier",
      0.065
    ],
    [
      "auteur",
      0.065
    ],
    [
      "proletaire",
      0.0325
    ],
    [
      "populaire",
      0.0325
    ],
    [
      "personnel",
      0.0325
    ],
    [
      "mecanicien",
      0.0325
    ],
    [
      "laborieux",
      0.0325
    ],
    [
      "homme",
      0.0325
    ],
    [
      "faconnier",
      0.0325
    ],
    [
      "faiseur",
      0.0325
    ],
    [
      "chambrelan",
      0.0325
    ],
    [
      "artiste",
      0.0325
    ],
    [
      "agent",
      0.0325
    ],
    [
      "salarie",
      0.0325
    ]
  ],
  "engraisser": [
    [
      "grossir",
      0.1725
    ],
    [
      "nourrir",
      0.0675
    ],
    [
      "epaissir",
      0.05
    ],
    [
      "s'alourdir",
      0.05
    ],
    [
      "gorger",
      0.05
    ],
    [
      "forcir",
      0.05
    ],
    [
      "fertiliser",
      0.05
    ],
    [
      "enrichir",
      0.05
    ],
    [
      "ameliorer",
      0.05
    ],
    [
      "elargir",
      0.0325
    ],
    [
      "gaver",
      0.0325
    ],
    [
      "empater",
      0.0325
    ],
    [
      "bouffir",
      0.0325
    ],
    [
      "amender",
      0.0325
    ],
    [
      "alourdir",
      0.0325
    ],
    [
      "s'empater",
      0.015
    ],
    [
      "graisser",
      0.015
    ],
    [
      "fumer",
      0.015
    ],
    [
      "engrener",
      0.015
    ],
    [
      "embuquer",
      0.015
    ],
    [
      "embecquer",
      0.015
    ],
    [
      "bonifier",
      0.015
    ],
    [
      "appater",
      0.015
    ],
    [
      "alimenter",
      0.015
    ]
  ],
  "coiffeur": [
    [
      "perruquier",
      0.22
    ],
    [
      "artiste",
      0.11
    ],
    [
      "barbier",
      0.11
    ],
    [
      "capilliculteur",
      0.11
    ],
    [
      "figaro",
      0.11
    ],
    [
      "merlan",
      0.11
    ],
    [
      "pommadier",
      0.11
    ],
    [
      "testonneur",
      0.11
    ]
  ],
  "campagne": [
    [
      "croisade",
      0.0625
    ],
    [
      "operation",
      0.0625
    ],
    [
      "propriete",
      0.05
    ],
    [
      "offensive",
      0.05
    ],
    [
      "guerre",
      0.05
    ],
    [
      "expedition",
      0.05
    ],
    [
      "domaine",
      0.05
    ],
    [
      "bataille",
      0.05
    ],
    [
      "champ",
      0.0375
    ],
    [
      "terre",
      0.0375
    ],
    [
      "region",
      0.025
    ],
    [
      "propagande",
      0.025
    ],
    [
      "pays",
      0.025
    ],
    [
      "nature",
      0.025
    ],
    [
      "maison",
      0.025
    ],
    [
      "ferme",
      0.025
    ],
    [
      "combat",
      0.025
    ],
    [
      "chateau",
      0.025
    ],
    [
      "bled",
      0.025
    ],
    [
      "pilonnage",
      0.0125
    ],
    [
      "plaine",
      0.0125
    ],
    [
      "prospection",
      0.0125
    ],
    [
      "publicite",
      0.0125
    ],
    [
      "saison",
      0.0125
    ],
    [
      "sillons",
      0.0125
    ],
    [
      "villegiature",
      0.0125
    ],
    [
      "voyage",
      0.0125
    ],
    [
      "paysage",
      0.0125
    ],
    [
      "parade",
      0.0125
    ],
    [
      "moulin",
      0.0125
    ],
    [
      "brousse",
      0.0125
    ],
    [
      "cabale",
      0.0125
    ],
    [
      "cambrousse",
      0.0125
    ],
    [
      "champs",
      0.0125
    ],
    [
      "chartreuse",
      0.0125
    ],
    [
      "cloche",
      0.0125
    ],
    [
      "cottage",
      0.0125
    ],
    [
      "intervention",
      0.0125
    ],
    [
      "equipee",
      0.0125
    ]
  ],
  "crasseux": [
    [
      "avare",
      0.1325
    ],
    [
      "chiche",
      0.1325
    ],
    [
      "degoutant",
      0.1325
    ],
    [
      "malpropre",
      0.1325
    ],
    [
      "sale",
      0.1325
    ],
    [
      "sordide",
      0.1325
    ],
    [
      "pingre",
      0.065
    ],
    [
      "repugnant",
      0.065
    ],
    [
      "souillon",
      0.065
    ]
  ],
  "commere": [
    [
      "bavard",
      0.12
    ],
    [
      "potinier",
      0.12
    ],
    [
      "cancanier",
      0.095
    ],
    [
      "pipelet",
      0.095
    ],
    [
      "jacasse",
      0.0725
    ],
    [
      "concierge",
      0.0725
    ],
    [
      "jaseur",
      0.0475
    ],
    [
      "maritorne",
      0.0225
    ],
    [
      "marraine",
      0.0225
    ],
    [
      "matrone",
      0.0225
    ],
    [
      "medisant",
      0.0225
    ],
    [
      "megere",
      0.0225
    ],
    [
      "pipelette",
      0.0225
    ],
    [
      "indiscret",
      0.0225
    ],
    [
      "gazette",
      0.0225
    ],
    [
      "femme",
      0.0225
    ],
    [
      "cousine",
      0.0225
    ],
    [
      "cousin",
      0.0225
    ],
    [
      "bavarde",
      0.0225
    ],
    [
      "babillard",
      0.0225
    ],
    [
      "animatrice",
      0.0225
    ],
    [
      "virago",
      0.0225
    ]
  ],
  "radin": [
    [
      "avare",
      0.1925
    ],
    [
      "ladre",
      0.1225
    ],
    [
      "pingre",
      0.105
    ],
    [
      "chiche",
      0.0875
    ],
    [
      "rat",
      0.0875
    ],
    [
      "rapiat",
      0.05
    ],
    [
      "lesineur",
      0.05
    ],
    [
      "harpagon",
      0.05
    ],
    [
      "grigou",
      0.05
    ],
    [
      "chien",
      0.05
    ],
    [
      "regardant",
      0.015
    ]
  ],
  "economie": [
    [
      "reserve",
      0.0625
    ],
    [
      "epargne",
      0.0625
    ],
    [
      "ordre",
      0.05
    ],
    [
      "organisation",
      0.04
    ],
    [
      "ordonnance",
      0.04
    ],
    [
      "moderation",
      0.04
    ],
    [
      "disposition",
      0.04
    ],
    [
      "sobriete",
      0.03
    ],
    [
      "restriction",
      0.03
    ],
    [
      "precaution",
      0.03
    ],
    [
      "menage",
      0.03
    ],
    [
      "mesure",
      0.03
    ],
    [
      "gouvernement",
      0.03
    ],
    [
      "frugalite",
      0.03
    ],
    [
      "arrangement",
      0.03
    ],
    [
      "politique",
      0.02
    ],
    [
      "simplicite",
      0.02
    ],
    [
      "soin",
      0.02
    ],
    [
      "structure",
      0.02
    ],
    [
      "temperance",
      0.02
    ],
    [
      "parcimonie",
      0.02
    ],
    [
      "harmonie",
      0.02
    ],
    [
      "gestion",
      0.02
    ],
    [
      "cagnotte",
      0.02
    ],
    [
      "avarice",
      0.02
    ],
    [
      "affaire",
      0.02
    ],
    [
      "administration",
      0.02
    ],
    [
      "mesquinerie",
      0.01
    ],
    [
      "plan",
      0.01
    ],
    [
      "pecule",
      0.01
    ],
    [
      "retenue",
      0.01
    ],
    [
      "thesaurisation",
      0.01
    ],
    [
      "matelas",
      0.01
    ],
    [
      "gain",
      0.01
    ],
    [
      "finance",
      0.01
    ],
    [
      "distribution",
      0.01
    ],
    [
      "compression",
      0.01
    ],
    [
      "boursicot",
      0.01
    ],
    [
      "tontine",
      0.01
    ]
  ],
  "chandelle": [
    [
      "bougie",
      0.2675
    ],
    [
      "lumignon",
      0.1325
    ],
    [
      "luminaire",
      0.065
    ],
    [
      "fusee",
      0.065
    ],
    [
      "flambeau",
      0.065
    ],
    [
      "cierge",
      0.065
    ],
    [
      "camoufle",
      0.065
    ],
    [
      "calbombe",
      0.065
    ],
    [
      "bougeoir",
      0.065
    ],
    [
      "oribus",
      0.065
    ]
  ],
  "cupide": [
    [
      "avide",
      0.28
    ],
    [
      "interesse",
      0.155
    ],
    [
      "rapace",
      0.0925
    ],
    [
      "venal",
      0.0625
    ],
    [
      "mercenaire",
      0.0625
    ],
    [
      "insatiable",
      0.0625
    ],
    [
      "convoiteux",
      0.0625
    ],
    [
      "avare",
      0.0625
    ],
    [
      "ambitieux",
      0.03
    ],
    [
      "envieux",
      0.03
    ],
    [
      "haletant",
      0.03
    ],
    [
      "mercantile",
      0.03
    ],
    [
      "apre",
      0.03
    ]
  ],
  "putride": [
    [
      "malsain",
      0.15
    ],
    [
      "pourri",
      0.15
    ],
    [
      "fetide",
      0.09
    ],
    [
      "infect",
      0.09
    ],
    [
      "pestilentiel",
      0.06
    ],
    [
      "morbide",
      0.06
    ],
    [
      "impur",
      0.06
    ],
    [
      "frelate",
      0.06
    ],
    [
      "faisande",
      0.06
    ],
    [
      "decompose",
      0.06
    ],
    [
      "desagreable",
      0.03
    ],
    [
      "gate",
      0.03
    ],
    [
      "pervers",
      0.03
    ],
    [
      "purulent",
      0.03
    ],
    [
      "putrescent",
      0.03
    ]
  ],
  "inceste": [
    [
      "crime",
      1.0
    ]
  ],
  "pretentieux": [
    [
      "suffisant",
      0.0825
    ],
    [
      "vaniteux",
      0.0825
    ],
    [
      "orgueilleux",
      0.0775
    ],
    [
      "fat",
      0.07
    ],
    [
      "superbe",
      0.055
    ],
    [
      "important",
      0.045
    ],
    [
      "fier",
      0.0425
    ],
    [
      "affecte",
      0.0425
    ],
    [
      "arrogant",
      0.035
    ],
    [
      "outrecuidant",
      0.0325
    ],
    [
      "poseur",
      0.03
    ],
    [
      "avantageux",
      0.0225
    ],
    [
      "sot",
      0.02
    ],
    [
      "precieux",
      0.02
    ],
    [
      "emphatique",
      0.02
    ],
    [
      "craneur",
      0.0175
    ],
    [
      "maniere",
      0.0175
    ],
    [
      "presomptueux",
      0.0175
    ],
    [
      "pedant",
      0.0175
    ],
    [
      "vain",
      0.0175
    ],
    [
      "infatue",
      0.015
    ],
    [
      "guinde",
      0.015
    ],
    [
      "bete",
      0.015
    ],
    [
      "becheur",
      0.015
    ],
    [
      "ampoule",
      0.01
    ],
    [
      "souffle",
      0.01
    ],
    [
      "faraud",
      0.0075
    ],
    [
      "conquerant",
      0.0075
    ],
    [
      "ambitieux",
      0.0075
    ],
    [
      "vide",
      0.005
    ],
    [
      "superieur",
      0.005
    ],
    [
      "sophistique",
      0.005
    ],
    [
      "ronflant",
      0.005
    ],
    [
      "pontifiant",
      0.005
    ],
    [
      "megalomane",
      0.005
    ],
    [
      "minaudier",
      0.005
    ],
    [
      "gourme",
      0.005
    ],
    [
      "insolent",
      0.005
    ],
    [
      "vainqueur",
      0.0025
    ],
    [
      "tapageur",
      0.0025
    ],
    [
      "pretentiard",
      0.0025
    ],
    [
      "moutardier",
      0.0025
    ],
    [
      "inabordable",
      0.0025
    ],
    [
      "immodeste",
      0.0025
    ],
    [
      "freluquet",
      0.0025
    ],
    [
      "faconnier",
      0.0025
    ],
    [
      "bate",
      0.0025
    ],
    [
      "academique",
      0.0025
    ]
  ],
  "connard": [
    [
      "beta",
      0.3325
    ],
    [
      "bete",
      0.3325
    ],
    [
      "ballot",
      0.165
    ],
    [
      "benet",
      0.165
    ]
  ],
  "pub": [
    [
      "bar",
      0.2
    ],
    [
      "brasserie",
      0.2
    ],
    [
      "cafe",
      0.2
    ],
    [
      "publicite",
      0.2
    ]
  ],
  "finance": [
    [
      "argent",
      0.125
    ],
    [
      "budget",
      0.06
    ],
    [
      "ressource",
      0.045
    ],
    [
      "impot",
      0.045
    ],
    [
      "fonds",
      0.045
    ],
    [
      "commerce",
      0.045
    ],
    [
      "capital",
      0.045
    ],
    [
      "caisse",
      0.045
    ],
    [
      "bourse",
      0.045
    ],
    [
      "tresor",
      0.03
    ],
    [
      "recette",
      0.03
    ],
    [
      "fisc",
      0.03
    ],
    [
      "depense",
      0.03
    ],
    [
      "dette",
      0.03
    ],
    [
      "contribution",
      0.03
    ],
    [
      "comptabilite",
      0.03
    ],
    [
      "affaire",
      0.03
    ],
    [
      "inflation",
      0.0125
    ],
    [
      "maltote",
      0.0125
    ],
    [
      "monnaie",
      0.0125
    ],
    [
      "regie",
      0.0125
    ],
    [
      "taxe",
      0.0125
    ],
    [
      "economie",
      0.0125
    ],
    [
      "emprunt",
      0.0125
    ],
    [
      "denier",
      0.0125
    ],
    [
      "credit",
      0.0125
    ],
    [
      "conversion",
      0.0125
    ],
    [
      "capitalisme",
      0.0125
    ],
    [
      "biens",
      0.0125
    ],
    [
      "banque",
      0.0125
    ],
    [
      "amortissement",
      0.0125
    ],
    [
      "affaires",
      0.0125
    ],
    [
      "emission",
      0.0125
    ]
  ],
  "financer": [
    [
      "payer",
      0.1425
    ],
    [
      "casquer",
      0.095
    ],
    [
      "entretenir",
      0.095
    ],
    [
      "verser",
      0.095
    ],
    [
      "sponsoriser",
      0.0475
    ],
    [
      "soutenir",
      0.0475
    ],
    [
      "regler",
      0.0475
    ],
    [
      "fournir",
      0.0475
    ],
    [
      "foncer",
      0.0475
    ],
    [
      "decaisser",
      0.0475
    ],
    [
      "commanditer",
      0.0475
    ],
    [
      "banquer",
      0.0475
    ],
    [
      "arroser",
      0.0475
    ],
    [
      "subventionner",
      0.0475
    ]
  ],
  "content": [
    [
      "heureux",
      0.13
    ],
    [
      "ravi",
      0.1125
    ],
    [
      "rejoui",
      0.0875
    ],
    [
      "joyeux",
      0.0775
    ],
    [
      "satisfait",
      0.0775
    ],
    [
      "radieux",
      0.0675
    ],
    [
      "epanoui",
      0.0425
    ],
    [
      "suffisant",
      0.0325
    ],
    [
      "rieur",
      0.0325
    ],
    [
      "gai",
      0.0325
    ],
    [
      "bienheureux",
      0.0325
    ],
    [
      "enchante",
      0.025
    ],
    [
      "fier",
      0.025
    ],
    [
      "vaniteux",
      0.015
    ],
    [
      "superbe",
      0.015
    ],
    [
      "sot",
      0.015
    ],
    [
      "orgueilleux",
      0.015
    ],
    [
      "fat",
      0.015
    ],
    [
      "beat",
      0.015
    ],
    [
      "aise",
      0.015
    ],
    [
      "soul",
      0.0075
    ],
    [
      "presomptueux",
      0.0075
    ],
    [
      "complaisant",
      0.0075
    ],
    [
      "charme",
      0.0075
    ],
    [
      "avance",
      0.0075
    ],
    [
      "aise",
      0.0075
    ],
    [
      "triomphant",
      0.0075
    ]
  ],
  "medisant": [
    [
      "denigrer",
      0.135
    ],
    [
      "discrediter",
      0.0875
    ],
    [
      "calomnier",
      0.0675
    ],
    [
      "critiquer",
      0.055
    ],
    [
      "debiner",
      0.045
    ],
    [
      "diffamer",
      0.04
    ],
    [
      "jaser",
      0.04
    ],
    [
      "ereinter",
      0.035
    ],
    [
      "vilipender",
      0.035
    ],
    [
      "gloser",
      0.035
    ],
    [
      "clabauder",
      0.035
    ],
    [
      "becher",
      0.03
    ],
    [
      "baver",
      0.025
    ],
    [
      "deblaterer",
      0.025
    ],
    [
      "dechirer",
      0.025
    ],
    [
      "esquinter",
      0.02
    ],
    [
      "dauber",
      0.02
    ],
    [
      "cancaner",
      0.02
    ],
    [
      "attaquer",
      0.02
    ],
    [
      "abimer",
      0.02
    ],
    [
      "decrier",
      0.015
    ],
    [
      "commerer",
      0.015
    ],
    [
      "arranger",
      0.015
    ],
    [
      "nuire",
      0.01
    ],
    [
      "habiller",
      0.01
    ],
    [
      "fabriquer",
      0.01
    ],
    [
      "dire",
      0.01
    ],
    [
      "croasser",
      0.01
    ],
    [
      "coasser",
      0.01
    ],
    [
      "satiriser",
      0.0025
    ],
    [
      "repandre",
      0.0025
    ],
    [
      "ragoter",
      0.0025
    ],
    [
      "potiner",
      0.0025
    ],
    [
      "detracter",
      0.0025
    ],
    [
      "deshabiller",
      0.0025
    ],
    [
      "decauser",
      0.0025
    ],
    [
      "babiller",
      0.0025
    ],
    [
      "taper",
      0.0025
    ]
  ],
  "cultive": [
    [
      "faconner",
      0.105
    ],
    [
      "former",
      0.085
    ],
    [
      "faire",
      0.0625
    ],
    [
      "preparer",
      0.05
    ],
    [
      "eduquer",
      0.045
    ],
    [
      "polir",
      0.045
    ],
    [
      "produire",
      0.04
    ],
    [
      "travailler",
      0.04
    ],
    [
      "exercer",
      0.035
    ],
    [
      "instruire",
      0.035
    ],
    [
      "elever",
      0.03
    ],
    [
      "soigner",
      0.03
    ],
    [
      "pratiquer",
      0.03
    ],
    [
      "ameliorer",
      0.025
    ],
    [
      "s'appliquer",
      0.025
    ],
    [
      "nourrir",
      0.0225
    ],
    [
      "perfectionner",
      0.0175
    ],
    [
      "entretenir",
      0.0175
    ],
    [
      "s'interesser",
      0.0125
    ],
    [
      "s'attacher",
      0.0125
    ],
    [
      "s'adonner",
      0.0125
    ],
    [
      "planter",
      0.0125
    ],
    [
      "menager",
      0.0125
    ],
    [
      "developper",
      0.0125
    ],
    [
      "defricher",
      0.0125
    ],
    [
      "apprendre",
      0.0125
    ],
    [
      "ameublir",
      0.0125
    ],
    [
      "affiner",
      0.0125
    ],
    [
      "semer",
      0.0075
    ],
    [
      "obtenir",
      0.0075
    ],
    [
      "labourer",
      0.0075
    ],
    [
      "frequenter",
      0.0075
    ],
    [
      "conserver",
      0.0075
    ],
    [
      "becher",
      0.0075
    ],
    [
      "biner",
      0.0075
    ],
    [
      "s'instruire",
      0.0025
    ],
    [
      "fertiliser",
      0.0025
    ],
    [
      "exploiter",
      0.0025
    ],
    [
      "essarter",
      0.0025
    ],
    [
      "entendre",
      0.0025
    ],
    [
      "diriger",
      0.0025
    ],
    [
      "choyer",
      0.0025
    ],
    [
      "aerer",
      0.0025
    ]
  ],
  "cultiver": [
    [
      "faconner",
      0.105
    ],
    [
      "former",
      0.085
    ],
    [
      "faire",
      0.0625
    ],
    [
      "preparer",
      0.05
    ],
    [
      "eduquer",
      0.045
    ],
    [
      "polir",
      0.045
    ],
    [
      "produire",
      0.04
    ],
    [
      "travailler",
      0.04
    ],
    [
      "exercer",
      0.035
    ],
    [
      "instruire",
      0.035
    ],
    [
      "elever",
      0.03
    ],
    [
      "soigner",
      0.03
    ],
    [
      "pratiquer",
      0.03
    ],
    [
      "ameliorer",
      0.025
    ],
    [
      "s'appliquer",
      0.025
    ],
    [
      "nourrir",
      0.0225
    ],
    [
      "perfectionner",
      0.0175
    ],
    [
      "entretenir",
      0.0175
    ],
    [
      "s'interesser",
      0.0125
    ],
    [
      "s'attacher",
      0.0125
    ],
    [
      "s'adonner",
      0.0125
    ],
    [
      "planter",
      0.0125
    ],
    [
      "menager",
      0.0125
    ],
    [
      "developper",
      0.0125
    ],
    [
      "defricher",
      0.0125
    ],
    [
      "apprendre",
      0.0125
    ],
    [
      "ameublir",
      0.0125
    ],
    [
      "affiner",
      0.0125
    ],
    [
      "semer",
      0.0075
    ],
    [
      "obtenir",
      0.0075
    ],
    [
      "labourer",
      0.0075
    ],
    [
      "frequenter",
      0.0075
    ],
    [
      "conserver",
      0.0075
    ],
    [
      "becher",
      0.0075
    ],
    [
      "biner",
      0.0075
    ],
    [
      "s'instruire",
      0.0025
    ],
    [
      "fertiliser",
      0.0025
    ],
    [
      "exploiter",
      0.0025
    ],
    [
      "essarter",
      0.0025
    ],
    [
      "entendre",
      0.0025
    ],
    [
      "diriger",
      0.0025
    ],
    [
      "choyer",
      0.0025
    ],
    [
      "aerer",
      0.0025
    ]
  ],
  "monopole": [
    [
      "droit",
      0.1425
    ],
    [
      "exclusivite",
      0.1425
    ],
    [
      "geant",
      0.1425
    ],
    [
      "privilege",
      0.1425
    ],
    [
      "propriete",
      0.1425
    ],
    [
      "prerogative",
      0.1425
    ],
    [
      "trust",
      0.1425
    ]
  ],
  "province": [
    [
      "pays",
      0.1525
    ],
    [
      "region",
      0.1525
    ],
    [
      "etat",
      0.1525
    ],
    [
      "quartier",
      0.075
    ],
    [
      "marche",
      0.075
    ],
    [
      "generalite",
      0.075
    ],
    [
      "gouvernement",
      0.075
    ],
    [
      "contree",
      0.075
    ],
    [
      "circonscription",
      0.075
    ],
    [
      "eparchie",
      0.075
    ]
  ],
  "sudiste": [
    [
      "federe",
      0.5
    ],
    [
      "secessionniste",
      0.5
    ]
  ],
  "abruti": [
    [
      "bete",
      0.135
    ],
    [
      "stupide",
      0.125
    ],
    [
      "sot",
      0.0825
    ],
    [
      "idiot",
      0.0725
    ],
    [
      "imbecile",
      0.0625
    ],
    [
      "ballot",
      0.05
    ],
    [
      "ahuri",
      0.04
    ],
    [
      "balourd",
      0.04
    ],
    [
      "cretin",
      0.04
    ],
    [
      "etourdi",
      0.03
    ],
    [
      "sidere",
      0.03
    ],
    [
      "niais",
      0.03
    ],
    [
      "hebete",
      0.03
    ],
    [
      "fatigue",
      0.03
    ],
    [
      "vaseux",
      0.02
    ],
    [
      "rompu",
      0.02
    ],
    [
      "lourdaud",
      0.02
    ],
    [
      "inintelligent",
      0.02
    ],
    [
      "ignorant",
      0.02
    ],
    [
      "torpide",
      0.01
    ],
    [
      "harasse",
      0.01
    ],
    [
      "fruste",
      0.01
    ],
    [
      "demeure",
      0.01
    ],
    [
      "bovin",
      0.01
    ],
    [
      "animal",
      0.01
    ],
    [
      "absorbe",
      0.01
    ],
    [
      "epate",
      0.01
    ]
  ],
  "abrutir": [
    [
      "abetir",
      0.15
    ],
    [
      "abasourdir",
      0.13
    ],
    [
      "hebeter",
      0.0925
    ],
    [
      "etourdir",
      0.0725
    ],
    [
      "ecraser",
      0.055
    ],
    [
      "stupefier",
      0.055
    ],
    [
      "affaiblir",
      0.055
    ],
    [
      "engourdir",
      0.035
    ],
    [
      "degrader",
      0.035
    ],
    [
      "assourdir",
      0.035
    ],
    [
      "assommer",
      0.035
    ],
    [
      "alterer",
      0.035
    ],
    [
      "ahurir",
      0.035
    ],
    [
      "surcharger",
      0.0175
    ],
    [
      "encrouter",
      0.0175
    ],
    [
      "cretiniser",
      0.0175
    ],
    [
      "choquer",
      0.0175
    ],
    [
      "betifier",
      0.0175
    ],
    [
      "animaliser",
      0.0175
    ],
    [
      "anesthesier",
      0.0175
    ],
    [
      "surmener",
      0.0175
    ]
  ],
  "cuisant": [
    [
      "fricasser",
      0.1025
    ],
    [
      "griller",
      0.0675
    ],
    [
      "mijoter",
      0.0675
    ],
    [
      "rotir",
      0.0675
    ],
    [
      "bruler",
      0.0575
    ],
    [
      "rissoler",
      0.045
    ],
    [
      "preparer",
      0.0325
    ],
    [
      "piquer",
      0.0325
    ],
    [
      "fricoter",
      0.0325
    ],
    [
      "chauffer",
      0.0325
    ],
    [
      "renverser",
      0.0225
    ],
    [
      "murir",
      0.0225
    ],
    [
      "mitonner",
      0.0225
    ],
    [
      "gratter",
      0.0225
    ],
    [
      "faire",
      0.0225
    ],
    [
      "cuisiner",
      0.0225
    ],
    [
      "calciner",
      0.0225
    ],
    [
      "bronzer",
      0.0225
    ],
    [
      "braiser",
      0.0225
    ],
    [
      "bouillir",
      0.0225
    ],
    [
      "boucaner",
      0.0225
    ],
    [
      "frire",
      0.01
    ],
    [
      "frissonner",
      0.01
    ],
    [
      "infuser",
      0.01
    ],
    [
      "recuire",
      0.01
    ],
    [
      "etouffer",
      0.01
    ],
    [
      "flamber",
      0.01
    ],
    [
      "digerer",
      0.01
    ],
    [
      "cramer",
      0.01
    ],
    [
      "carboniser",
      0.01
    ],
    [
      "blondir",
      0.01
    ],
    [
      "biscuiter",
      0.01
    ],
    [
      "attacher",
      0.01
    ],
    [
      "etuver",
      0.01
    ]
  ],
  "disant": [
    [
      "reveler",
      0.0625
    ],
    [
      "declarer",
      0.055
    ],
    [
      "signaler",
      0.0475
    ],
    [
      "indiquer",
      0.0425
    ],
    [
      "montrer",
      0.0425
    ],
    [
      "exprimer",
      0.035
    ],
    [
      "publier",
      0.0325
    ],
    [
      "exposer",
      0.03
    ],
    [
      "annoncer",
      0.0225
    ],
    [
      "raconter",
      0.02
    ],
    [
      "signifier",
      0.02
    ],
    [
      "temoigner",
      0.02
    ],
    [
      "affirmer",
      0.02
    ],
    [
      "donner",
      0.02
    ],
    [
      "prononcer",
      0.0175
    ],
    [
      "communiquer",
      0.0175
    ],
    [
      "manifester",
      0.0175
    ],
    [
      "expliquer",
      0.015
    ],
    [
      "decouvrir",
      0.015
    ],
    [
      "enoncer",
      0.0125
    ],
    [
      "parler",
      0.0125
    ],
    [
      "faire",
      0.0125
    ],
    [
      "debiter",
      0.0125
    ],
    [
      "apprendre",
      0.01
    ],
    [
      "rapporter",
      0.01
    ],
    [
      "crier",
      0.01
    ],
    [
      "porter",
      0.01
    ],
    [
      "assurer",
      0.01
    ],
    [
      "decider",
      0.0075
    ],
    [
      "determiner",
      0.0075
    ],
    [
      "informer",
      0.0075
    ],
    [
      "sortir",
      0.005
    ],
    [
      "repandre",
      0.005
    ],
    [
      "proferer",
      0.005
    ],
    [
      "marquer",
      0.005
    ],
    [
      "divulguer",
      0.005
    ],
    [
      "avertir",
      0.005
    ],
    [
      "trahir",
      0.005
    ],
    [
      "repondre",
      0.005
    ],
    [
      "retracer",
      0.005
    ],
    [
      "lancer",
      0.005
    ],
    [
      "chanter",
      0.005
    ],
    [
      "emettre",
      0.005
    ],
    [
      "soutenir",
      0.005
    ],
    [
      "souffler",
      0.005
    ],
    [
      "sommer",
      0.005
    ],
    [
      "pretendre",
      0.005
    ],
    [
      "ordonner",
      0.005
    ],
    [
      "nommer",
      0.005
    ],
    [
      "jurer",
      0.005
    ],
    [
      "devoiler",
      0.005
    ],
    [
      "demander",
      0.005
    ],
    [
      "certifier",
      0.005
    ],
    [
      "trancher",
      0.0025
    ],
    [
      "solliciter",
      0.0025
    ],
    [
      "revendiquer",
      0.0025
    ],
    [
      "recommander",
      0.0025
    ],
    [
      "conseiller",
      0.0025
    ],
    [
      "commander",
      0.0025
    ],
    [
      "bavarder",
      0.0025
    ],
    [
      "enumerer",
      0.0025
    ],
    [
      "specifier",
      0.0025
    ],
    [
      "requerir",
      0.0025
    ],
    [
      "protester",
      0.0025
    ],
    [
      "propager",
      0.0025
    ],
    [
      "designer",
      0.0025
    ],
    [
      "denoter",
      0.0025
    ],
    [
      "degoiser",
      0.0025
    ],
    [
      "convenir",
      0.0025
    ],
    [
      "conter",
      0.0025
    ],
    [
      "confier",
      0.0025
    ],
    [
      "colporter",
      0.0025
    ],
    [
      "plaire",
      0.0
    ],
    [
      "relater",
      0.0
    ],
    [
      "renseigner",
      0.0
    ],
    [
      "reciter",
      0.0
    ],
    [
      "souhaiter",
      0.0
    ],
    [
      "stipuler",
      0.0
    ],
    [
      "vomir",
      0.0
    ],
    [
      "observer",
      0.0
    ],
    [
      "murmurer",
      0.0
    ],
    [
      "articuler",
      0.0
    ],
    [
      "avouer",
      0.0
    ],
    [
      "balancer",
      0.0
    ],
    [
      "declamer",
      0.0
    ],
    [
      "jaser",
      0.0
    ],
    [
      "lire",
      0.0
    ],
    [
      "lacher",
      0.0
    ],
    [
      "professer",
      0.0
    ],
    [
      "preconiser",
      0.0
    ],
    [
      "prevenir",
      0.0
    ],
    [
      "prevoir",
      0.0
    ],
    [
      "repliquer",
      0.0
    ],
    [
      "tenter",
      0.0
    ],
    [
      "pressentir",
      0.0
    ],
    [
      "persuader",
      0.0
    ],
    [
      "confirmer",
      0.0
    ],
    [
      "enjoindre",
      0.0
    ],
    [
      "formuler",
      0.0
    ],
    [
      "juger",
      0.0
    ],
    [
      "medire",
      0.0
    ],
    [
      "opposer",
      0.0
    ],
    [
      "tomber",
      0.0
    ],
    [
      "s'ecrier",
      0.0
    ],
    [
      "retorquer",
      0.0
    ],
    [
      "narrer",
      0.0
    ],
    [
      "interjecter",
      0.0
    ],
    [
      "enfiler",
      0.0
    ],
    [
      "disserter",
      0.0
    ],
    [
      "chuchoter",
      0.0
    ],
    [
      "ajouter",
      0.0
    ],
    [
      "ebruiter",
      0.0
    ]
  ],
  "fasciste": [
    [
      "facho",
      0.125
    ],
    [
      "factieux",
      0.125
    ],
    [
      "faf",
      0.125
    ],
    [
      "phalangiste",
      0.125
    ],
    [
      "reac",
      0.125
    ],
    [
      "reactionnaire",
      0.125
    ],
    [
      "totalitaire",
      0.125
    ]
  ],
  "justifier": [
    [
      "excuser",
      0.18
    ],
    [
      "autoriser",
      0.055
    ],
    [
      "confirmer",
      0.055
    ],
    [
      "disculper",
      0.055
    ],
    [
      "prouver",
      0.04
    ],
    [
      "legitimer",
      0.04
    ],
    [
      "innocenter",
      0.04
    ],
    [
      "effacer",
      0.04
    ],
    [
      "defendre",
      0.04
    ],
    [
      "decharger",
      0.04
    ],
    [
      "permettre",
      0.0275
    ],
    [
      "motiver",
      0.0275
    ],
    [
      "laver",
      0.0275
    ],
    [
      "expliquer",
      0.0275
    ],
    [
      "exempter",
      0.0275
    ],
    [
      "demontrer",
      0.0275
    ],
    [
      "couvrir",
      0.0275
    ],
    [
      "blanchir",
      0.0275
    ],
    [
      "admettre",
      0.0275
    ],
    [
      "acquitter",
      0.0275
    ],
    [
      "absoudre",
      0.0275
    ],
    [
      "sauver",
      0.0125
    ],
    [
      "fonder",
      0.0125
    ],
    [
      "enteriner",
      0.0125
    ],
    [
      "dedouaner",
      0.0125
    ],
    [
      "comporter",
      0.0125
    ],
    [
      "alleguer",
      0.0125
    ],
    [
      "verifier",
      0.0125
    ]
  ],
  "neo": [],
  "parc": [
    [
      "jardin",
      0.1325
    ],
    [
      "paturage",
      0.065
    ],
    [
      "patis",
      0.065
    ],
    [
      "promenade",
      0.065
    ],
    [
      "prairie",
      0.065
    ],
    [
      "parking",
      0.065
    ],
    [
      "parcage",
      0.065
    ],
    [
      "flotte",
      0.065
    ],
    [
      "enclos",
      0.065
    ],
    [
      "bergerie",
      0.065
    ],
    [
      "bercail",
      0.065
    ],
    [
      "bassin",
      0.065
    ],
    [
      "reserve",
      0.065
    ]
  ],
  "occupation": [
    [
      "travail",
      0.1225
    ],
    [
      "fonction",
      0.0725
    ],
    [
      "besogne",
      0.065
    ],
    [
      "situation",
      0.065
    ],
    [
      "affaire",
      0.0475
    ],
    [
      "soin",
      0.04
    ],
    [
      "mission",
      0.04
    ],
    [
      "emploi",
      0.04
    ],
    [
      "charge",
      0.04
    ],
    [
      "activite",
      0.04
    ],
    [
      "tache",
      0.0325
    ],
    [
      "service",
      0.0325
    ],
    [
      "profession",
      0.0325
    ],
    [
      "metier",
      0.0325
    ],
    [
      "conquete",
      0.0325
    ],
    [
      "affaires",
      0.0225
    ],
    [
      "position",
      0.0225
    ],
    [
      "preoccupation",
      0.015
    ],
    [
      "possession",
      0.015
    ],
    [
      "labeur",
      0.015
    ],
    [
      "job",
      0.015
    ],
    [
      "envahissement",
      0.015
    ],
    [
      "engagement",
      0.015
    ],
    [
      "business",
      0.015
    ],
    [
      "appropriation",
      0.015
    ],
    [
      "ouvrage",
      0.005
    ],
    [
      "loisir",
      0.005
    ],
    [
      "invasion",
      0.005
    ],
    [
      "installation",
      0.005
    ],
    [
      "carriere",
      0.005
    ],
    [
      "assujettissement",
      0.005
    ],
    [
      "apaisement",
      0.005
    ],
    [
      "affairement",
      0.005
    ],
    [
      "prise",
      0.005
    ]
  ],
  "piranha": [],
  "banlieue": [
    [
      "faubourg",
      0.1525
    ],
    [
      "peripherie",
      0.1525
    ],
    [
      "extension",
      0.075
    ],
    [
      "environs",
      0.075
    ],
    [
      "environ",
      0.075
    ],
    [
      "ceinture",
      0.075
    ],
    [
      "alentours",
      0.075
    ],
    [
      "agglomeration",
      0.075
    ]
  ],
  "agressif": [
    [
      "aigre",
      0.085
    ],
    [
      "acerbe",
      0.07
    ],
    [
      "mordant",
      0.07
    ],
    [
      "vif",
      0.07
    ],
    [
      "amer",
      0.06
    ],
    [
      "batailleur",
      0.045
    ],
    [
      "apre",
      0.0375
    ],
    [
      "violent",
      0.0375
    ],
    [
      "mechant",
      0.0375
    ],
    [
      "combatif",
      0.0375
    ],
    [
      "belliqueux",
      0.0375
    ],
    [
      "acide",
      0.03
    ],
    [
      "acrimonieux",
      0.03
    ],
    [
      "ardent",
      0.03
    ],
    [
      "blessant",
      0.03
    ],
    [
      "mauvais",
      0.03
    ],
    [
      "pugnace",
      0.0225
    ],
    [
      "dangereux",
      0.0225
    ],
    [
      "querelleur",
      0.015
    ],
    [
      "provocant",
      0.015
    ],
    [
      "menacant",
      0.015
    ],
    [
      "malveillant",
      0.015
    ],
    [
      "fulminant",
      0.015
    ],
    [
      "colereux",
      0.015
    ],
    [
      "brutal",
      0.015
    ],
    [
      "bagarreur",
      0.015
    ],
    [
      "acere",
      0.015
    ],
    [
      "offensif",
      0.005
    ],
    [
      "fonceur",
      0.005
    ],
    [
      "destructeur",
      0.005
    ],
    [
      "colere",
      0.005
    ],
    [
      "chercheur",
      0.005
    ],
    [
      "cabre",
      0.005
    ],
    [
      "accrocheur",
      0.005
    ],
    [
      "provocateur",
      0.005
    ]
  ],
  "moindre": [
    [
      "inferieur",
      0.22
    ],
    [
      "infime",
      0.165
    ],
    [
      "petit",
      0.165
    ],
    [
      "bas",
      0.11
    ],
    [
      "subalterne",
      0.11
    ],
    [
      "dernier",
      0.055
    ],
    [
      "mineur",
      0.055
    ],
    [
      "nul",
      0.055
    ]
  ],
  "secousse": [
    [
      "agitation",
      0.0925
    ],
    [
      "trouble",
      0.08
    ],
    [
      "soubresaut",
      0.07
    ],
    [
      "convulsion",
      0.06
    ],
    [
      "commotion",
      0.0475
    ],
    [
      "mouvement",
      0.0475
    ],
    [
      "ebranlement",
      0.0425
    ],
    [
      "tremblement",
      0.0425
    ],
    [
      "remous",
      0.0425
    ],
    [
      "bouleversement",
      0.0425
    ],
    [
      "heurt",
      0.0325
    ],
    [
      "orage",
      0.0325
    ],
    [
      "emotion",
      0.0325
    ],
    [
      "frisson",
      0.025
    ],
    [
      "perturbation",
      0.02
    ],
    [
      "choc",
      0.02
    ],
    [
      "cahot",
      0.02
    ],
    [
      "ballottement",
      0.015
    ],
    [
      "oscillation",
      0.015
    ],
    [
      "saccade",
      0.015
    ],
    [
      "saisissement",
      0.015
    ],
    [
      "tressaillement",
      0.015
    ],
    [
      "tourmente",
      0.01
    ],
    [
      "seisme",
      0.01
    ],
    [
      "coup",
      0.01
    ],
    [
      "bousculade",
      0.01
    ],
    [
      "bond",
      0.005
    ],
    [
      "fermentation",
      0.005
    ],
    [
      "roulis",
      0.005
    ],
    [
      "secouee",
      0.005
    ],
    [
      "spasme",
      0.005
    ],
    [
      "tressaut",
      0.005
    ],
    [
      "trepidation",
      0.005
    ]
  ],
  "bougre": [
    [
      "homme",
      0.185
    ],
    [
      "individu",
      0.1275
    ],
    [
      "type",
      0.1275
    ],
    [
      "gaillard",
      0.07
    ],
    [
      "personne",
      0.0575
    ],
    [
      "zebre",
      0.0425
    ],
    [
      "oiseau",
      0.0425
    ],
    [
      "mec",
      0.0425
    ],
    [
      "pistolet",
      0.0275
    ],
    [
      "lascar",
      0.0275
    ],
    [
      "foutre",
      0.0275
    ],
    [
      "fichtre",
      0.0275
    ],
    [
      "drole",
      0.0275
    ],
    [
      "diable",
      0.0275
    ],
    [
      "bete",
      0.0275
    ],
    [
      "bonhomme",
      0.0275
    ],
    [
      "bigre",
      0.0125
    ],
    [
      "luron",
      0.0125
    ],
    [
      "piaf",
      0.0125
    ],
    [
      "quidam",
      0.0125
    ]
  ],
  "depressif": [
    [
      "dissolvant",
      0.2
    ],
    [
      "debilitant",
      0.2
    ],
    [
      "deprimant",
      0.2
    ],
    [
      "amollissant",
      0.1
    ],
    [
      "anemiant",
      0.1
    ],
    [
      "deprime",
      0.1
    ],
    [
      "hypocondriaque",
      0.1
    ]
  ],
  "rate": [
    [
      "manquer",
      0.1775
    ],
    [
      "echouer",
      0.1775
    ],
    [
      "avorter",
      0.1425
    ],
    [
      "louper",
      0.1425
    ],
    [
      "peter",
      0.07
    ],
    [
      "perdre",
      0.07
    ],
    [
      "gacher",
      0.07
    ],
    [
      "foirer",
      0.07
    ],
    [
      "torcher",
      0.035
    ]
  ],
  "greviste": [],
  "slogan": [
    [
      "devise",
      0.25
    ],
    [
      "formule",
      0.25
    ],
    [
      "expression",
      0.125
    ],
    [
      "publicite",
      0.125
    ],
    [
      "reclame",
      0.125
    ]
  ],
  "fouetter": [
    [
      "exciter",
      0.1075
    ],
    [
      "battre",
      0.0725
    ],
    [
      "attiser",
      0.0625
    ],
    [
      "cingler",
      0.0625
    ],
    [
      "aiguillonner",
      0.0525
    ],
    [
      "animer",
      0.0525
    ],
    [
      "fustiger",
      0.0425
    ],
    [
      "stimuler",
      0.035
    ],
    [
      "eperonner",
      0.035
    ],
    [
      "surexciter",
      0.025
    ],
    [
      "soulever",
      0.025
    ],
    [
      "pousser",
      0.025
    ],
    [
      "frapper",
      0.025
    ],
    [
      "flageller",
      0.025
    ],
    [
      "couper",
      0.025
    ],
    [
      "allumer",
      0.025
    ],
    [
      "eveiller",
      0.015
    ],
    [
      "toucher",
      0.015
    ],
    [
      "souffleter",
      0.015
    ],
    [
      "meler",
      0.015
    ],
    [
      "melanger",
      0.015
    ],
    [
      "irriter",
      0.015
    ],
    [
      "fouailler",
      0.015
    ],
    [
      "fesser",
      0.015
    ],
    [
      "critiquer",
      0.015
    ],
    [
      "corriger",
      0.015
    ],
    [
      "censurer",
      0.015
    ],
    [
      "vergeter",
      0.0075
    ],
    [
      "sentir",
      0.0075
    ],
    [
      "sangler",
      0.0075
    ],
    [
      "puer",
      0.0075
    ],
    [
      "poindre",
      0.0075
    ],
    [
      "gifler",
      0.0075
    ],
    [
      "cravacher",
      0.0075
    ],
    [
      "boire",
      0.0075
    ],
    [
      "aiguiser",
      0.0075
    ],
    [
      "emoustiller",
      0.0075
    ]
  ],
  "journaliste": [
    [
      "chroniqueur",
      0.08
    ],
    [
      "ecrivain",
      0.08
    ],
    [
      "reporter",
      0.06
    ],
    [
      "nouvelliste",
      0.06
    ],
    [
      "journaleux",
      0.06
    ],
    [
      "critique",
      0.06
    ],
    [
      "commentateur",
      0.06
    ],
    [
      "redacteur",
      0.04
    ],
    [
      "pamphletaire",
      0.04
    ],
    [
      "gazetier",
      0.04
    ],
    [
      "folliculaire",
      0.04
    ],
    [
      "feuilletoniste",
      0.04
    ],
    [
      "correspondant",
      0.04
    ],
    [
      "polemiste",
      0.02
    ],
    [
      "publiciste",
      0.02
    ],
    [
      "salonnier",
      0.02
    ],
    [
      "speaker",
      0.02
    ],
    [
      "echotier",
      0.02
    ],
    [
      "pigiste",
      0.02
    ],
    [
      "photographe",
      0.02
    ],
    [
      "observateur",
      0.02
    ],
    [
      "informateur",
      0.02
    ],
    [
      "feuilliste",
      0.02
    ],
    [
      "courrieriste",
      0.02
    ],
    [
      "bobardier",
      0.02
    ],
    [
      "editorialiste",
      0.02
    ]
  ],
  "tirage": [
    [
      "difficulte",
      0.18
    ],
    [
      "obstacle",
      0.085
    ],
    [
      "embarras",
      0.0725
    ],
    [
      "ennui",
      0.0625
    ],
    [
      "traverse",
      0.0575
    ],
    [
      "anicroche",
      0.045
    ],
    [
      "accroc",
      0.03
    ],
    [
      "contrariete",
      0.03
    ],
    [
      "empechement",
      0.03
    ],
    [
      "edition",
      0.03
    ],
    [
      "souci",
      0.025
    ],
    [
      "incident",
      0.025
    ],
    [
      "tracas",
      0.02
    ],
    [
      "peine",
      0.015
    ],
    [
      "opposition",
      0.015
    ],
    [
      "impression",
      0.015
    ],
    [
      "histoire",
      0.015
    ],
    [
      "epine",
      0.01
    ],
    [
      "resistance",
      0.01
    ],
    [
      "ronce",
      0.01
    ],
    [
      "reproduction",
      0.01
    ],
    [
      "publication",
      0.01
    ],
    [
      "probleme",
      0.01
    ],
    [
      "cahot",
      0.01
    ],
    [
      "aria",
      0.01
    ],
    [
      "republication",
      0.0025
    ],
    [
      "pepin",
      0.0025
    ],
    [
      "photographie",
      0.0025
    ],
    [
      "os",
      0.0025
    ],
    [
      "objection",
      0.0025
    ],
    [
      "loterie",
      0.0025
    ],
    [
      "reimpression",
      0.0025
    ],
    [
      "tiraillement",
      0.0025
    ],
    [
      "tombola",
      0.0025
    ],
    [
      "touage",
      0.0025
    ],
    [
      "traction",
      0.0025
    ],
    [
      "trefilage",
      0.0025
    ],
    [
      "trefilerie",
      0.0025
    ],
    [
      "etirage",
      0.0025
    ],
    [
      "labeur",
      0.0025
    ],
    [
      "imprimerie",
      0.0025
    ],
    [
      "hic",
      0.0025
    ],
    [
      "chardon",
      0.0025
    ],
    [
      "chemin",
      0.0025
    ],
    [
      "cheveu",
      0.0025
    ],
    [
      "chiendent",
      0.0025
    ],
    [
      "collection",
      0.0025
    ],
    [
      "composition",
      0.0025
    ],
    [
      "conscription",
      0.0025
    ],
    [
      "danger",
      0.0025
    ],
    [
      "devidage",
      0.0025
    ],
    [
      "enclouure",
      0.0025
    ],
    [
      "extraction",
      0.0025
    ],
    [
      "gravure",
      0.0025
    ],
    [
      "halage",
      0.0025
    ],
    [
      "bec",
      0.0025
    ]
  ],
  "menager": [
    [
      "econome",
      0.3325
    ],
    [
      "avare",
      0.165
    ],
    [
      "domestique",
      0.165
    ],
    [
      "soigneux",
      0.165
    ],
    [
      "epargnant",
      0.165
    ]
  ],
  "ecran": [
    [
      "rideau",
      0.13
    ],
    [
      "abri",
      0.1075
    ],
    [
      "obstacle",
      0.085
    ],
    [
      "protection",
      0.085
    ],
    [
      "barricade",
      0.065
    ],
    [
      "tenture",
      0.0425
    ],
    [
      "tablier",
      0.0425
    ],
    [
      "separation",
      0.0425
    ],
    [
      "portiere",
      0.0425
    ],
    [
      "paravent",
      0.0425
    ],
    [
      "voilage",
      0.02
    ],
    [
      "terminal",
      0.02
    ],
    [
      "tapisserie",
      0.02
    ],
    [
      "store",
      0.02
    ],
    [
      "panneau",
      0.02
    ],
    [
      "panka",
      0.02
    ],
    [
      "filtre",
      0.02
    ],
    [
      "cloison",
      0.02
    ],
    [
      "cache",
      0.02
    ],
    [
      "blindage",
      0.02
    ],
    [
      "barrage",
      0.02
    ],
    [
      "eventail",
      0.02
    ]
  ],
  "gober": [
    [
      "avaler",
      0.285
    ],
    [
      "aimer",
      0.1425
    ],
    [
      "croire",
      0.1425
    ],
    [
      "manger",
      0.1425
    ],
    [
      "s'eprendre",
      0.1425
    ],
    [
      "super",
      0.1425
    ]
  ],
  "cogner": [
    [
      "heurter",
      0.1675
    ],
    [
      "battre",
      0.135
    ],
    [
      "frapper",
      0.1
    ],
    [
      "taper",
      0.0875
    ],
    [
      "rosser",
      0.055
    ],
    [
      "rencontrer",
      0.0425
    ],
    [
      "accrocher",
      0.0425
    ],
    [
      "choquer",
      0.0325
    ],
    [
      "puer",
      0.0325
    ],
    [
      "tamponner",
      0.0325
    ],
    [
      "tambouriner",
      0.02
    ],
    [
      "sentir",
      0.02
    ],
    [
      "porter",
      0.02
    ],
    [
      "cocotter",
      0.02
    ],
    [
      "buter",
      0.02
    ],
    [
      "bousculer",
      0.02
    ],
    [
      "bigorner",
      0.02
    ],
    [
      "pilonner",
      0.01
    ],
    [
      "piler",
      0.01
    ],
    [
      "meurtrir",
      0.01
    ],
    [
      "infecter",
      0.01
    ],
    [
      "gourmer",
      0.01
    ],
    [
      "chataigner",
      0.01
    ],
    [
      "brutaliser",
      0.01
    ],
    [
      "boxer",
      0.01
    ],
    [
      "etriller",
      0.01
    ]
  ],
  "association": [
    [
      "societe",
      0.0875
    ],
    [
      "reunion",
      0.0625
    ],
    [
      "union",
      0.0475
    ],
    [
      "groupe",
      0.04
    ],
    [
      "assemblage",
      0.0375
    ],
    [
      "alliance",
      0.035
    ],
    [
      "combinaison",
      0.0275
    ],
    [
      "coalition",
      0.025
    ],
    [
      "groupement",
      0.025
    ],
    [
      "accord",
      0.0225
    ],
    [
      "parti",
      0.02
    ],
    [
      "ligue",
      0.015
    ],
    [
      "communaute",
      0.015
    ],
    [
      "colonie",
      0.015
    ],
    [
      "clan",
      0.015
    ],
    [
      "bande",
      0.015
    ],
    [
      "entente",
      0.015
    ],
    [
      "rassemblement",
      0.015
    ],
    [
      "organisation",
      0.0125
    ],
    [
      "liaison",
      0.0125
    ],
    [
      "composition",
      0.0125
    ],
    [
      "compagnie",
      0.0125
    ],
    [
      "assemblee",
      0.0125
    ],
    [
      "melange",
      0.0125
    ],
    [
      "federation",
      0.0125
    ],
    [
      "agglomeration",
      0.01
    ],
    [
      "cartel",
      0.01
    ],
    [
      "concentration",
      0.01
    ],
    [
      "fusion",
      0.01
    ],
    [
      "syndicat",
      0.01
    ],
    [
      "trust",
      0.01
    ],
    [
      "ordre",
      0.0075
    ],
    [
      "mariage",
      0.0075
    ],
    [
      "corps",
      0.0075
    ],
    [
      "corporation",
      0.0075
    ],
    [
      "congregation",
      0.0075
    ],
    [
      "enchainement",
      0.005
    ],
    [
      "coterie",
      0.005
    ],
    [
      "cooperation",
      0.005
    ],
    [
      "affinite",
      0.005
    ],
    [
      "affiliation",
      0.005
    ],
    [
      "teneur",
      0.005
    ],
    [
      "rapprochement",
      0.005
    ],
    [
      "peuple",
      0.005
    ],
    [
      "nation",
      0.005
    ],
    [
      "connexion",
      0.005
    ],
    [
      "confederation",
      0.005
    ],
    [
      "club",
      0.005
    ],
    [
      "cercle",
      0.005
    ],
    [
      "analogie",
      0.005
    ],
    [
      "agrement",
      0.005
    ],
    [
      "agencement",
      0.005
    ],
    [
      "couplage",
      0.0025
    ],
    [
      "integration",
      0.0025
    ],
    [
      "mutualite",
      0.0025
    ],
    [
      "ressemblance",
      0.0025
    ],
    [
      "secte",
      0.0025
    ],
    [
      "similitude",
      0.0025
    ],
    [
      "tribu",
      0.0025
    ],
    [
      "consortium",
      0.0025
    ],
    [
      "confrerie",
      0.0025
    ],
    [
      "adhesion",
      0.0025
    ],
    [
      "amour",
      0.0025
    ],
    [
      "assortiment",
      0.0025
    ],
    [
      "chaine",
      0.0025
    ],
    [
      "collectivite",
      0.0025
    ],
    [
      "complicite",
      0.0025
    ],
    [
      "complot",
      0.0025
    ],
    [
      "institut",
      0.0025
    ],
    [
      "participation",
      0.0025
    ],
    [
      "solidarite",
      0.0025
    ],
    [
      "suggestion",
      0.0025
    ],
    [
      "synergie",
      0.0025
    ],
    [
      "synthese",
      0.0025
    ],
    [
      "evocation",
      0.0025
    ],
    [
      "incorporation",
      0.0025
    ],
    [
      "hanse",
      0.0025
    ],
    [
      "adjonction",
      0.0025
    ],
    [
      "agregation",
      0.0025
    ],
    [
      "alliage",
      0.0025
    ],
    [
      "amicale",
      0.0025
    ],
    [
      "concert",
      0.0025
    ],
    [
      "conjugaison",
      0.0025
    ],
    [
      "contiguite",
      0.0025
    ],
    [
      "consecution",
      0.0
    ],
    [
      "cooperative",
      0.0
    ],
    [
      "entreprise",
      0.0
    ],
    [
      "guilde",
      0.0
    ],
    [
      "partenariat",
      0.0
    ],
    [
      "patronage",
      0.0
    ],
    [
      "symbiose",
      0.0
    ],
    [
      "complexe",
      0.0
    ],
    [
      "compagnonnage",
      0.0
    ],
    [
      "comite",
      0.0
    ],
    [
      "comice",
      0.0
    ],
    [
      "collaboration",
      0.0
    ],
    [
      "chambre",
      0.0
    ],
    [
      "attraction",
      0.0
    ],
    [
      "attelage",
      0.0
    ],
    [
      "amphictyonie",
      0.0
    ],
    [
      "admission",
      0.0
    ],
    [
      "tontine",
      0.0
    ]
  ],
  "dictateur": [
    [
      "despote",
      0.21
    ],
    [
      "dominateur",
      0.21
    ],
    [
      "tyran",
      0.1575
    ],
    [
      "maitre",
      0.105
    ],
    [
      "fuhrer",
      0.05
    ],
    [
      "duce",
      0.05
    ],
    [
      "cesar",
      0.05
    ],
    [
      "chef",
      0.05
    ],
    [
      "autocrate",
      0.05
    ],
    [
      "oppresseur",
      0.05
    ]
  ],
  "lesbien": [
    [
      "gay",
      0.3325
    ],
    [
      "homosexuel",
      0.3325
    ],
    [
      "saphique",
      0.3325
    ]
  ],
  "refouler": [
    [
      "chasser",
      0.08
    ],
    [
      "contenir",
      0.065
    ],
    [
      "repousser",
      0.0575
    ],
    [
      "reprimer",
      0.0575
    ],
    [
      "rentrer",
      0.05
    ],
    [
      "bannir",
      0.0425
    ],
    [
      "expulser",
      0.0425
    ],
    [
      "rejeter",
      0.0425
    ],
    [
      "retenir",
      0.035
    ],
    [
      "renfermer",
      0.035
    ],
    [
      "dissimuler",
      0.035
    ],
    [
      "concentrer",
      0.0275
    ],
    [
      "exclure",
      0.0275
    ],
    [
      "pousser",
      0.0275
    ],
    [
      "proscrire",
      0.0275
    ],
    [
      "renfoncer",
      0.0275
    ],
    [
      "etouffer",
      0.02
    ],
    [
      "eliminer",
      0.02
    ],
    [
      "ecarter",
      0.02
    ],
    [
      "ravaler",
      0.02
    ],
    [
      "exiler",
      0.02
    ],
    [
      "contraindre",
      0.02
    ],
    [
      "refrener",
      0.0125
    ],
    [
      "reculer",
      0.0125
    ],
    [
      "maitriser",
      0.0125
    ],
    [
      "mater",
      0.0125
    ],
    [
      "bouter",
      0.0125
    ],
    [
      "battre",
      0.0125
    ],
    [
      "balayer",
      0.0125
    ],
    [
      "refluer",
      0.005
    ],
    [
      "reconduire",
      0.005
    ],
    [
      "deloger",
      0.005
    ],
    [
      "comprimer",
      0.005
    ],
    [
      "boycotter",
      0.005
    ],
    [
      "rompre",
      0.005
    ]
  ],
  "refoule": [
    [
      "chasser",
      0.08
    ],
    [
      "contenir",
      0.065
    ],
    [
      "repousser",
      0.0575
    ],
    [
      "reprimer",
      0.0575
    ],
    [
      "rentrer",
      0.05
    ],
    [
      "bannir",
      0.0425
    ],
    [
      "expulser",
      0.0425
    ],
    [
      "rejeter",
      0.0425
    ],
    [
      "retenir",
      0.035
    ],
    [
      "renfermer",
      0.035
    ],
    [
      "dissimuler",
      0.035
    ],
    [
      "concentrer",
      0.0275
    ],
    [
      "exclure",
      0.0275
    ],
    [
      "pousser",
      0.0275
    ],
    [
      "proscrire",
      0.0275
    ],
    [
      "renfoncer",
      0.0275
    ],
    [
      "etouffer",
      0.02
    ],
    [
      "eliminer",
      0.02
    ],
    [
      "ecarter",
      0.02
    ],
    [
      "ravaler",
      0.02
    ],
    [
      "exiler",
      0.02
    ],
    [
      "contraindre",
      0.02
    ],
    [
      "refrener",
      0.0125
    ],
    [
      "reculer",
      0.0125
    ],
    [
      "maitriser",
      0.0125
    ],
    [
      "mater",
      0.0125
    ],
    [
      "bouter",
      0.0125
    ],
    [
      "battre",
      0.0125
    ],
    [
      "balayer",
      0.0125
    ],
    [
      "refluer",
      0.005
    ],
    [
      "reconduire",
      0.005
    ],
    [
      "deloger",
      0.005
    ],
    [
      "comprimer",
      0.005
    ],
    [
      "boycotter",
      0.005
    ],
    [
      "rompre",
      0.005
    ]
  ],
  "feminite": [
    [
      "feminilite",
      0.25
    ],
    [
      "feminisme",
      0.25
    ],
    [
      "feminitude",
      0.25
    ],
    [
      "sexe",
      0.25
    ]
  ],
  "travers": [
    [
      "manie",
      0.1175
    ],
    [
      "tic",
      0.1125
    ],
    [
      "imperfection",
      0.0925
    ],
    [
      "defaut",
      0.0675
    ],
    [
      "vice",
      0.055
    ],
    [
      "faiblesse",
      0.0375
    ],
    [
      "marotte",
      0.03
    ],
    [
      "toquade",
      0.03
    ],
    [
      "maladie",
      0.0225
    ],
    [
      "gout",
      0.0225
    ],
    [
      "faible",
      0.0225
    ],
    [
      "defectuosite",
      0.0225
    ],
    [
      "rage",
      0.0175
    ],
    [
      "infirmite",
      0.0175
    ],
    [
      "habitude",
      0.0175
    ],
    [
      "fureur",
      0.0175
    ],
    [
      "frenesie",
      0.0175
    ],
    [
      "caprice",
      0.0175
    ],
    [
      "tort",
      0.01
    ],
    [
      "tare",
      0.01
    ],
    [
      "tache",
      0.01
    ],
    [
      "ridicule",
      0.01
    ],
    [
      "maniere",
      0.01
    ],
    [
      "demerite",
      0.01
    ],
    [
      "demangeaison",
      0.01
    ],
    [
      "difformite",
      0.01
    ],
    [
      "cote",
      0.01
    ],
    [
      "bizarrerie",
      0.01
    ],
    [
      "loup",
      0.005
    ],
    [
      "malfacon",
      0.005
    ],
    [
      "monomanie",
      0.005
    ],
    [
      "petitesse",
      0.005
    ],
    [
      "prurit",
      0.005
    ],
    [
      "rictus",
      0.005
    ],
    [
      "turlutaine",
      0.005
    ],
    [
      "largeur",
      0.005
    ],
    [
      "lacune",
      0.005
    ],
    [
      "grossierete",
      0.005
    ],
    [
      "grimace",
      0.005
    ],
    [
      "flanc",
      0.005
    ],
    [
      "fievre",
      0.005
    ],
    [
      "fantaisie",
      0.005
    ],
    [
      "dada",
      0.005
    ],
    [
      "biais",
      0.005
    ],
    [
      "epidemie",
      0.005
    ]
  ],
  "sexualite": [
    [
      "genitalite",
      0.3325
    ],
    [
      "libido",
      0.3325
    ],
    [
      "erotisme",
      0.3325
    ]
  ],
  "chariot": [
    [
      "fardier",
      0.1525
    ],
    [
      "camion",
      0.1125
    ],
    [
      "benne",
      0.075
    ],
    [
      "fourgon",
      0.035
    ],
    [
      "fourragere",
      0.035
    ],
    [
      "guimbarde",
      0.035
    ],
    [
      "kibitka",
      0.035
    ],
    [
      "promenette",
      0.035
    ],
    [
      "ribaudequin",
      0.035
    ],
    [
      "triqueballe",
      0.035
    ],
    [
      "diable",
      0.035
    ],
    [
      "charrette",
      0.035
    ],
    [
      "char",
      0.035
    ],
    [
      "caisson",
      0.035
    ],
    [
      "caddie",
      0.035
    ],
    [
      "bruska",
      0.035
    ],
    [
      "briska",
      0.035
    ],
    [
      "binard",
      0.035
    ],
    [
      "berline",
      0.035
    ],
    [
      "bardeur",
      0.035
    ],
    [
      "truck",
      0.035
    ]
  ],
  "arc": [
    [
      "voute",
      0.23
    ],
    [
      "cintre",
      0.1525
    ],
    [
      "arcade",
      0.075
    ],
    [
      "courbe",
      0.075
    ],
    [
      "voussure",
      0.075
    ],
    [
      "rateau",
      0.0375
    ],
    [
      "porte",
      0.0375
    ],
    [
      "cambrure",
      0.0375
    ],
    [
      "berceau",
      0.0375
    ],
    [
      "arcure",
      0.0375
    ],
    [
      "arche",
      0.0375
    ],
    [
      "arceau",
      0.0375
    ],
    [
      "arcature",
      0.0375
    ],
    [
      "voussoir",
      0.0375
    ]
  ],
  "hetero": [],
  "susceptible": [
    [
      "capable",
      0.1225
    ],
    [
      "sourcilleux",
      0.1225
    ],
    [
      "sensible",
      0.075
    ],
    [
      "apte",
      0.06
    ],
    [
      "propre",
      0.045
    ],
    [
      "ombrageux",
      0.045
    ],
    [
      "delicat",
      0.045
    ],
    [
      "colereux",
      0.045
    ],
    [
      "chatouilleux",
      0.045
    ],
    [
      "prompt",
      0.03
    ],
    [
      "pointilleux",
      0.03
    ],
    [
      "irritable",
      0.03
    ],
    [
      "bon",
      0.03
    ],
    [
      "bilieux",
      0.03
    ],
    [
      "vexe",
      0.0125
    ],
    [
      "sujet",
      0.0125
    ],
    [
      "sensitif",
      0.0125
    ],
    [
      "qualifie",
      0.0125
    ],
    [
      "pointu",
      0.0125
    ],
    [
      "passible",
      0.0125
    ],
    [
      "idoine",
      0.0125
    ],
    [
      "herisse",
      0.0125
    ],
    [
      "hypersensible",
      0.0125
    ],
    [
      "excitable",
      0.0125
    ],
    [
      "braque",
      0.0125
    ]
  ],
  "homophobe": [],
  "type": [
    [
      "genre",
      0.0725
    ],
    [
      "homme",
      0.0675
    ],
    [
      "individu",
      0.04
    ],
    [
      "modele",
      0.03
    ],
    [
      "maniere",
      0.025
    ],
    [
      "sorte",
      0.025
    ],
    [
      "espece",
      0.0225
    ],
    [
      "personne",
      0.0225
    ],
    [
      "caractere",
      0.02
    ],
    [
      "mec",
      0.02
    ],
    [
      "tournure",
      0.02
    ],
    [
      "nature",
      0.0175
    ],
    [
      "forme",
      0.0175
    ],
    [
      "figure",
      0.0175
    ],
    [
      "apparence",
      0.015
    ],
    [
      "bougre",
      0.015
    ],
    [
      "exemplaire",
      0.015
    ],
    [
      "style",
      0.015
    ],
    [
      "gaillard",
      0.015
    ],
    [
      "echantillon",
      0.0125
    ],
    [
      "zigoto",
      0.0125
    ],
    [
      "visage",
      0.0125
    ],
    [
      "tenue",
      0.0125
    ],
    [
      "ordre",
      0.0125
    ],
    [
      "aspect",
      0.0125
    ],
    [
      "zebre",
      0.01
    ],
    [
      "specimen",
      0.01
    ],
    [
      "personnage",
      0.01
    ],
    [
      "image",
      0.01
    ],
    [
      "gars",
      0.01
    ],
    [
      "gabarit",
      0.01
    ],
    [
      "comportement",
      0.01
    ],
    [
      "classe",
      0.01
    ],
    [
      "bonhomme",
      0.01
    ],
    [
      "zig",
      0.0075
    ],
    [
      "variete",
      0.0075
    ],
    [
      "original",
      0.0075
    ],
    [
      "ideal",
      0.0075
    ],
    [
      "facon",
      0.0075
    ],
    [
      "categorie",
      0.0075
    ],
    [
      "attitude",
      0.0075
    ],
    [
      "archetype",
      0.0075
    ],
    [
      "phenomene",
      0.005
    ],
    [
      "prototype",
      0.005
    ],
    [
      "symbole",
      0.005
    ],
    [
      "touche",
      0.005
    ],
    [
      "trempe",
      0.005
    ],
    [
      "exemple",
      0.005
    ],
    [
      "division",
      0.005
    ],
    [
      "acabit",
      0.005
    ],
    [
      "bizarre",
      0.005
    ],
    [
      "bete",
      0.005
    ],
    [
      "citoyen",
      0.005
    ],
    [
      "conduite",
      0.005
    ],
    [
      "variante",
      0.005
    ],
    [
      "texte",
      0.005
    ],
    [
      "standard",
      0.005
    ],
    [
      "quidam",
      0.005
    ],
    [
      "norme",
      0.005
    ],
    [
      "lascar",
      0.005
    ],
    [
      "gonze",
      0.005
    ],
    [
      "gazier",
      0.005
    ],
    [
      "degaine",
      0.005
    ],
    [
      "drole",
      0.005
    ],
    [
      "classification",
      0.005
    ],
    [
      "habitant",
      0.0025
    ],
    [
      "luron",
      0.0025
    ],
    [
      "police",
      0.0025
    ],
    [
      "portrait",
      0.0025
    ],
    [
      "representant",
      0.0025
    ],
    [
      "etalon",
      0.0025
    ],
    [
      "guignol",
      0.0025
    ],
    [
      "griffe",
      0.0025
    ],
    [
      "amant",
      0.0025
    ],
    [
      "canon",
      0.0025
    ],
    [
      "frappe",
      0.0025
    ],
    [
      "garcon",
      0.0025
    ],
    [
      "gens",
      0.0025
    ],
    [
      "gnard",
      0.0025
    ],
    [
      "parangon",
      0.0
    ],
    [
      "paroissien",
      0.0
    ],
    [
      "personnification",
      0.0
    ],
    [
      "race",
      0.0
    ],
    [
      "typologie",
      0.0
    ],
    [
      "zigomar",
      0.0
    ],
    [
      "monsieur",
      0.0
    ],
    [
      "here",
      0.0
    ],
    [
      "fonte",
      0.0
    ],
    [
      "farine",
      0.0
    ],
    [
      "famille",
      0.0
    ],
    [
      "croquant",
      0.0
    ],
    [
      "coco",
      0.0
    ],
    [
      "client",
      0.0
    ],
    [
      "asticot",
      0.0
    ],
    [
      "etre",
      0.0
    ]
  ],
  "nation": [
    [
      "pays",
      1.0
    ]
  ],
  "incapable": [
    [
      "incompetent",
      0.0925
    ],
    [
      "ignorant",
      0.0675
    ],
    [
      "mauvais",
      0.0675
    ],
    [
      "nul",
      0.0675
    ],
    [
      "inhabile",
      0.055
    ],
    [
      "insuffisant",
      0.055
    ],
    [
      "maladroit",
      0.045
    ],
    [
      "inapte",
      0.045
    ],
    [
      "impuissant",
      0.045
    ],
    [
      "borne",
      0.0325
    ],
    [
      "imbecile",
      0.0325
    ],
    [
      "inefficace",
      0.0325
    ],
    [
      "inepte",
      0.0325
    ],
    [
      "ringard",
      0.02
    ],
    [
      "nullite",
      0.02
    ],
    [
      "mediocre",
      0.02
    ],
    [
      "mechant",
      0.02
    ],
    [
      "malhabile",
      0.02
    ],
    [
      "inoperant",
      0.02
    ],
    [
      "impropre",
      0.02
    ],
    [
      "velleitaire",
      0.01
    ],
    [
      "vain",
      0.01
    ],
    [
      "obtus",
      0.01
    ],
    [
      "mazette",
      0.01
    ],
    [
      "lavette",
      0.01
    ],
    [
      "ignare",
      0.01
    ],
    [
      "ganache",
      0.01
    ],
    [
      "empeche",
      0.01
    ],
    [
      "zero",
      0.01
    ]
  ],
  "administration": [
    [
      "direction",
      0.135
    ],
    [
      "gouvernement",
      0.135
    ],
    [
      "gestion",
      0.0975
    ],
    [
      "bureau",
      0.06
    ],
    [
      "conduite",
      0.06
    ],
    [
      "service",
      0.035
    ],
    [
      "secretariat",
      0.035
    ],
    [
      "autorite",
      0.035
    ],
    [
      "etat",
      0.0225
    ],
    [
      "economie",
      0.0225
    ],
    [
      "regime",
      0.0225
    ],
    [
      "regie",
      0.0225
    ],
    [
      "pouvoir",
      0.0225
    ],
    [
      "intendance",
      0.0225
    ],
    [
      "chancellerie",
      0.0225
    ],
    [
      "menage",
      0.01
    ],
    [
      "organisme",
      0.01
    ],
    [
      "police",
      0.01
    ],
    [
      "questure",
      0.01
    ],
    [
      "services",
      0.01
    ],
    [
      "siege",
      0.01
    ],
    [
      "tenue",
      0.01
    ],
    [
      "ministeres",
      0.01
    ],
    [
      "manutention",
      0.01
    ],
    [
      "boite",
      0.01
    ],
    [
      "gouvernance",
      0.01
    ],
    [
      "gerance",
      0.01
    ],
    [
      "management",
      0.01
    ],
    [
      "maniement",
      0.01
    ],
    [
      "tutelle",
      0.01
    ]
  ],
  "inaction": [
    [
      "torpeur",
      0.08
    ],
    [
      "engourdissement",
      0.0675
    ],
    [
      "inertie",
      0.06
    ],
    [
      "lethargie",
      0.06
    ],
    [
      "apathie",
      0.055
    ],
    [
      "inactivite",
      0.055
    ],
    [
      "paresse",
      0.0475
    ],
    [
      "stagnation",
      0.04
    ],
    [
      "sommeil",
      0.04
    ],
    [
      "repos",
      0.04
    ],
    [
      "paralysie",
      0.04
    ],
    [
      "assoupissement",
      0.0325
    ],
    [
      "indolence",
      0.0325
    ],
    [
      "oisivete",
      0.0325
    ],
    [
      "desoeuvrement",
      0.025
    ],
    [
      "loisir",
      0.025
    ],
    [
      "vacances",
      0.02
    ],
    [
      "marasme",
      0.02
    ],
    [
      "lenteur",
      0.02
    ],
    [
      "immobilite",
      0.02
    ],
    [
      "vacance",
      0.0125
    ],
    [
      "suspension",
      0.0125
    ],
    [
      "sieste",
      0.0125
    ],
    [
      "faineantise",
      0.0125
    ],
    [
      "conge",
      0.0125
    ],
    [
      "carence",
      0.0125
    ],
    [
      "abstention",
      0.0125
    ],
    [
      "renonciation",
      0.005
    ],
    [
      "ralentissement",
      0.005
    ],
    [
      "passivite",
      0.005
    ],
    [
      "mollesse",
      0.005
    ],
    [
      "inoccupation",
      0.005
    ],
    [
      "inefficacite",
      0.005
    ],
    [
      "farniente",
      0.005
    ],
    [
      "desoccupation",
      0.005
    ],
    [
      "croupissement",
      0.005
    ],
    [
      "chomage",
      0.005
    ],
    [
      "vacations",
      0.005
    ]
  ],
  "vomir": [
    [
      "rejeter",
      0.1025
    ],
    [
      "lancer",
      0.075
    ],
    [
      "cracher",
      0.0625
    ],
    [
      "degorger",
      0.0625
    ],
    [
      "expulser",
      0.0625
    ],
    [
      "degueuler",
      0.05
    ],
    [
      "proferer",
      0.0375
    ],
    [
      "debagouler",
      0.0375
    ],
    [
      "dire",
      0.0375
    ],
    [
      "evacuer",
      0.025
    ],
    [
      "eructer",
      0.025
    ],
    [
      "restituer",
      0.025
    ],
    [
      "rendre",
      0.025
    ],
    [
      "renarder",
      0.025
    ],
    [
      "projeter",
      0.025
    ],
    [
      "fulminer",
      0.025
    ],
    [
      "execrer",
      0.025
    ],
    [
      "degobiller",
      0.025
    ],
    [
      "chasser",
      0.025
    ],
    [
      "abhorrer",
      0.025
    ],
    [
      "honnir",
      0.01
    ],
    [
      "regorger",
      0.01
    ],
    [
      "regurgiter",
      0.01
    ],
    [
      "gerber",
      0.01
    ],
    [
      "expectorer",
      0.01
    ],
    [
      "detester",
      0.01
    ],
    [
      "degurgiter",
      0.01
    ],
    [
      "debecter",
      0.01
    ],
    [
      "abominer",
      0.01
    ],
    [
      "souffler",
      0.01
    ]
  ],
  "mouton": [
    [
      "agneau",
      0.155
    ],
    [
      "brebis",
      0.0775
    ],
    [
      "mouchard",
      0.05
    ],
    [
      "espion",
      0.05
    ],
    [
      "denonciateur",
      0.05
    ],
    [
      "delateur",
      0.05
    ],
    [
      "ovide",
      0.025
    ],
    [
      "ovin",
      0.025
    ],
    [
      "paisible",
      0.025
    ],
    [
      "poussiere",
      0.025
    ],
    [
      "renard",
      0.025
    ],
    [
      "salete",
      0.025
    ],
    [
      "sycophante",
      0.025
    ],
    [
      "vague",
      0.025
    ],
    [
      "ouaille",
      0.025
    ],
    [
      "moutonnier",
      0.025
    ],
    [
      "indicateur",
      0.025
    ],
    [
      "agnelle",
      0.025
    ],
    [
      "antenais",
      0.025
    ],
    [
      "basane",
      0.025
    ],
    [
      "broutart",
      0.025
    ],
    [
      "belier",
      0.025
    ],
    [
      "chaton",
      0.025
    ],
    [
      "chatre",
      0.025
    ],
    [
      "ecume",
      0.025
    ]
  ],
  "pathetique": [
    [
      "touchant",
      0.1425
    ],
    [
      "emouvant",
      0.1425
    ],
    [
      "poignant",
      0.1175
    ],
    [
      "bouleversant",
      0.095
    ],
    [
      "dramatique",
      0.07
    ],
    [
      "tragique",
      0.045
    ],
    [
      "saisissant",
      0.045
    ],
    [
      "impressionnant",
      0.045
    ],
    [
      "empoignant",
      0.045
    ],
    [
      "dechirant",
      0.045
    ],
    [
      "emotion",
      0.0225
    ],
    [
      "eloquent",
      0.0225
    ],
    [
      "eloquence",
      0.0225
    ],
    [
      "vibrant",
      0.0225
    ],
    [
      "prenant",
      0.0225
    ],
    [
      "pathos",
      0.0225
    ],
    [
      "passion",
      0.0225
    ],
    [
      "emu",
      0.0225
    ]
  ],
  "fonction": [
    [
      "emploi",
      0.1
    ],
    [
      "charge",
      0.0875
    ],
    [
      "travail",
      0.055
    ],
    [
      "situation",
      0.0525
    ],
    [
      "metier",
      0.0475
    ],
    [
      "place",
      0.0425
    ],
    [
      "position",
      0.0425
    ],
    [
      "role",
      0.0425
    ],
    [
      "etat",
      0.0375
    ],
    [
      "occupation",
      0.0375
    ],
    [
      "mission",
      0.0375
    ],
    [
      "office",
      0.035
    ],
    [
      "poste",
      0.035
    ],
    [
      "profession",
      0.035
    ],
    [
      "service",
      0.03
    ],
    [
      "rang",
      0.025
    ],
    [
      "devoir",
      0.02
    ],
    [
      "tache",
      0.02
    ],
    [
      "usage",
      0.02
    ],
    [
      "titre",
      0.0175
    ],
    [
      "qualite",
      0.0175
    ],
    [
      "dignite",
      0.0175
    ],
    [
      "activite",
      0.0125
    ],
    [
      "effet",
      0.0125
    ],
    [
      "mandat",
      0.0125
    ],
    [
      "ministere",
      0.0125
    ],
    [
      "sacerdoce",
      0.0125
    ],
    [
      "utilite",
      0.0075
    ],
    [
      "portefeuille",
      0.0075
    ],
    [
      "faculte",
      0.0075
    ],
    [
      "carriere",
      0.0075
    ],
    [
      "relation",
      0.0025
    ],
    [
      "processus",
      0.0025
    ],
    [
      "forme",
      0.0025
    ],
    [
      "correlation",
      0.0025
    ],
    [
      "correspondance",
      0.0025
    ],
    [
      "consequence",
      0.0025
    ],
    [
      "attribution",
      0.0025
    ],
    [
      "sinecure",
      0.0025
    ]
  ],
  "logiciel": [
    [
      "programme",
      0.3325
    ],
    [
      "programmerie",
      0.3325
    ],
    [
      "software",
      0.3325
    ]
  ],
  "technique": [
    [
      "habilete",
      0.11
    ],
    [
      "art",
      0.09
    ],
    [
      "truc",
      0.08
    ],
    [
      "maniere",
      0.07
    ],
    [
      "procede",
      0.07
    ],
    [
      "metier",
      0.06
    ],
    [
      "methode",
      0.06
    ],
    [
      "pratique",
      0.05
    ],
    [
      "faire",
      0.0375
    ],
    [
      "maitrise",
      0.0375
    ],
    [
      "technicien",
      0.03
    ],
    [
      "systeme",
      0.03
    ],
    [
      "facon",
      0.03
    ],
    [
      "artifice",
      0.0175
    ],
    [
      "processus",
      0.0175
    ],
    [
      "virtuosite",
      0.0175
    ],
    [
      "technicite",
      0.0075
    ],
    [
      "technocrate",
      0.0075
    ],
    [
      "technologie",
      0.0075
    ],
    [
      "technologique",
      0.0075
    ],
    [
      "special",
      0.0075
    ],
    [
      "science",
      0.0075
    ],
    [
      "recette",
      0.0075
    ],
    [
      "progres",
      0.0075
    ],
    [
      "professionnel",
      0.0075
    ],
    [
      "facture",
      0.0075
    ],
    [
      "theorie",
      0.0075
    ]
  ],
  "salete": [
    [
      "ordure",
      0.1075
    ],
    [
      "saloperie",
      0.06
    ],
    [
      "crasse",
      0.055
    ],
    [
      "impurete",
      0.055
    ],
    [
      "malproprete",
      0.05
    ],
    [
      "boue",
      0.05
    ],
    [
      "abjection",
      0.05
    ],
    [
      "cochonnerie",
      0.0375
    ],
    [
      "vilenie",
      0.0375
    ],
    [
      "infamie",
      0.0325
    ],
    [
      "vacherie",
      0.0275
    ],
    [
      "tache",
      0.0275
    ],
    [
      "obscenite",
      0.0275
    ],
    [
      "gadoue",
      0.0225
    ],
    [
      "souillure",
      0.0225
    ],
    [
      "vaurien",
      0.0225
    ],
    [
      "salaud",
      0.015
    ],
    [
      "mechancete",
      0.015
    ],
    [
      "immondice",
      0.015
    ],
    [
      "grossierete",
      0.015
    ],
    [
      "vermine",
      0.01
    ],
    [
      "rosserie",
      0.01
    ],
    [
      "propos",
      0.01
    ],
    [
      "poussiere",
      0.01
    ],
    [
      "poison",
      0.01
    ],
    [
      "pacotille",
      0.01
    ],
    [
      "merde",
      0.01
    ],
    [
      "gueuserie",
      0.01
    ],
    [
      "entourloupette",
      0.01
    ],
    [
      "crotte",
      0.01
    ],
    [
      "camelote",
      0.01
    ],
    [
      "pouillerie",
      0.005
    ],
    [
      "rebut",
      0.005
    ],
    [
      "rossignol",
      0.005
    ],
    [
      "sabot",
      0.005
    ],
    [
      "salissure",
      0.005
    ],
    [
      "salope",
      0.005
    ],
    [
      "sordidite",
      0.005
    ],
    [
      "toc",
      0.005
    ],
    [
      "petitesse",
      0.005
    ],
    [
      "patraque",
      0.005
    ],
    [
      "mouton",
      0.005
    ],
    [
      "bauge",
      0.005
    ],
    [
      "canaillerie",
      0.005
    ],
    [
      "charogne",
      0.005
    ],
    [
      "dechet",
      0.005
    ],
    [
      "gachis",
      0.005
    ],
    [
      "incongruite",
      0.005
    ],
    [
      "laideur",
      0.005
    ],
    [
      "macule",
      0.005
    ],
    [
      "truand",
      0.005
    ]
  ],
  "replique": [
    [
      "imitation",
      0.085
    ],
    [
      "reproduction",
      0.085
    ],
    [
      "copie",
      0.0725
    ],
    [
      "double",
      0.06
    ],
    [
      "objection",
      0.06
    ],
    [
      "reponse",
      0.0475
    ],
    [
      "riposte",
      0.0475
    ],
    [
      "representation",
      0.0475
    ],
    [
      "image",
      0.0475
    ],
    [
      "repartie",
      0.035
    ],
    [
      "sosie",
      0.035
    ],
    [
      "retorsion",
      0.0225
    ],
    [
      "reaction",
      0.0225
    ],
    [
      "ressemblance",
      0.0225
    ],
    [
      "portrait",
      0.0225
    ],
    [
      "opposition",
      0.0225
    ],
    [
      "observation",
      0.0225
    ],
    [
      "jumeau",
      0.0225
    ],
    [
      "parade",
      0.01
    ],
    [
      "pareil",
      0.01
    ],
    [
      "pendant",
      0.01
    ],
    [
      "protestation",
      0.01
    ],
    [
      "repetition",
      0.01
    ],
    [
      "faux",
      0.01
    ],
    [
      "exemplaire",
      0.01
    ],
    [
      "duplicata",
      0.01
    ],
    [
      "doublure",
      0.01
    ],
    [
      "discussion",
      0.01
    ],
    [
      "critique",
      0.01
    ],
    [
      "clone",
      0.01
    ],
    [
      "boutade",
      0.01
    ],
    [
      "tirade",
      0.01
    ]
  ],
  "repliquer": [
    [
      "repondre",
      0.3075
    ],
    [
      "dire",
      0.1525
    ],
    [
      "retorquer",
      0.1525
    ],
    [
      "faire",
      0.075
    ],
    [
      "objecter",
      0.075
    ],
    [
      "raisonner",
      0.075
    ],
    [
      "riposter",
      0.075
    ]
  ],
  "systeme": [
    [
      "methode",
      0.07
    ],
    [
      "truc",
      0.065
    ],
    [
      "theorie",
      0.055
    ],
    [
      "doctrine",
      0.05
    ],
    [
      "moyen",
      0.05
    ],
    [
      "regle",
      0.05
    ],
    [
      "philosophie",
      0.035
    ],
    [
      "procede",
      0.03
    ],
    [
      "plan",
      0.03
    ],
    [
      "organisation",
      0.03
    ],
    [
      "ordre",
      0.03
    ],
    [
      "combinaison",
      0.03
    ],
    [
      "tendance",
      0.025
    ],
    [
      "tactique",
      0.025
    ],
    [
      "principe",
      0.025
    ],
    [
      "pensee",
      0.025
    ],
    [
      "opinion",
      0.025
    ],
    [
      "structure",
      0.02
    ],
    [
      "politique",
      0.02
    ],
    [
      "formule",
      0.02
    ],
    [
      "constitution",
      0.02
    ],
    [
      "ecole",
      0.015
    ],
    [
      "technique",
      0.015
    ],
    [
      "regime",
      0.015
    ],
    [
      "recette",
      0.015
    ],
    [
      "norme",
      0.015
    ],
    [
      "institution",
      0.015
    ],
    [
      "ideologie",
      0.015
    ],
    [
      "idees",
      0.015
    ],
    [
      "astuce",
      0.015
    ],
    [
      "these",
      0.01
    ],
    [
      "syntaxe",
      0.01
    ],
    [
      "ressource",
      0.01
    ],
    [
      "maniere",
      0.01
    ],
    [
      "gouvernement",
      0.01
    ],
    [
      "dogme",
      0.01
    ],
    [
      "combine",
      0.01
    ],
    [
      "assemblage",
      0.01
    ],
    [
      "hypothese",
      0.005
    ],
    [
      "hierarchie",
      0.005
    ],
    [
      "explication",
      0.005
    ],
    [
      "enseignement",
      0.005
    ],
    [
      "dogmatisme",
      0.005
    ],
    [
      "arcane",
      0.005
    ],
    [
      "appareil",
      0.005
    ],
    [
      "jeu",
      0.005
    ]
  ],
  "completement": [
    [
      "totalement",
      0.2025
    ],
    [
      "entierement",
      0.155
    ],
    [
      "absolument",
      0.13
    ],
    [
      "parfaitement",
      0.0575
    ],
    [
      "bien",
      0.0475
    ],
    [
      "integralement",
      0.035
    ],
    [
      "royalement",
      0.0225
    ],
    [
      "pleinement",
      0.0225
    ],
    [
      "diametralement",
      0.0225
    ],
    [
      "radicalement",
      0.01
    ],
    [
      "strictement",
      0.01
    ],
    [
      "superbement",
      0.01
    ],
    [
      "tout",
      0.01
    ],
    [
      "unanimement",
      0.01
    ],
    [
      "capitalement",
      0.01
    ],
    [
      "fin",
      0.01
    ],
    [
      "eperdument",
      0.01
    ]
  ],
  "incompetent": [
    [
      "incapable",
      0.22
    ],
    [
      "ignorant",
      0.1375
    ],
    [
      "insuffisant",
      0.11
    ],
    [
      "inapte",
      0.0825
    ],
    [
      "inhabile",
      0.0825
    ],
    [
      "nul",
      0.055
    ],
    [
      "mauvais",
      0.055
    ],
    [
      "inexperimente",
      0.055
    ],
    [
      "impuissant",
      0.055
    ],
    [
      "impropre",
      0.055
    ],
    [
      "ignare",
      0.0275
    ],
    [
      "mechant",
      0.0275
    ],
    [
      "profane",
      0.0275
    ]
  ],
  "secte": [
    [
      "parti",
      0.17
    ],
    [
      "clan",
      0.1125
    ],
    [
      "coterie",
      0.1125
    ],
    [
      "faction",
      0.0975
    ],
    [
      "groupe",
      0.07
    ],
    [
      "chapelle",
      0.055
    ],
    [
      "coalition",
      0.04
    ],
    [
      "cabale",
      0.04
    ],
    [
      "association",
      0.04
    ],
    [
      "eglise",
      0.0275
    ],
    [
      "ecole",
      0.0275
    ],
    [
      "religion",
      0.0275
    ],
    [
      "phalange",
      0.0275
    ],
    [
      "camp",
      0.0275
    ],
    [
      "bande",
      0.0275
    ],
    [
      "brigue",
      0.0125
    ],
    [
      "communion",
      0.0125
    ],
    [
      "heresie",
      0.0125
    ],
    [
      "philosophie",
      0.0125
    ],
    [
      "rassemblement",
      0.0125
    ]
  ],
  "religieux": [
    [
      "moine",
      0.13
    ],
    [
      "congreganiste",
      0.05
    ],
    [
      "pretre",
      0.0425
    ],
    [
      "abbe",
      0.0325
    ],
    [
      "clerc",
      0.0325
    ],
    [
      "frere",
      0.0325
    ],
    [
      "spirituel",
      0.025
    ],
    [
      "monastique",
      0.025
    ],
    [
      "ecclesiastique",
      0.025
    ],
    [
      "devot",
      0.025
    ],
    [
      "croyant",
      0.025
    ],
    [
      "chanoine",
      0.025
    ],
    [
      "recollet",
      0.015
    ],
    [
      "reverend",
      0.015
    ],
    [
      "sacre",
      0.015
    ],
    [
      "surnaturel",
      0.015
    ],
    [
      "thaumaturgique",
      0.015
    ],
    [
      "trappiste",
      0.015
    ],
    [
      "pere",
      0.015
    ],
    [
      "pieux",
      0.015
    ],
    [
      "capucin",
      0.015
    ],
    [
      "cistercien",
      0.015
    ],
    [
      "dominicain",
      0.015
    ],
    [
      "franciscain",
      0.015
    ],
    [
      "monial",
      0.015
    ],
    [
      "mystique",
      0.015
    ],
    [
      "novice",
      0.0075
    ],
    [
      "mariste",
      0.0075
    ],
    [
      "lazariste",
      0.0075
    ],
    [
      "jesuite",
      0.0075
    ],
    [
      "hieratique",
      0.0075
    ],
    [
      "fetichiste",
      0.0075
    ],
    [
      "oblat",
      0.0075
    ],
    [
      "oratorien",
      0.0075
    ],
    [
      "pratiquant",
      0.0075
    ],
    [
      "prieur",
      0.0075
    ],
    [
      "profes",
      0.0075
    ],
    [
      "premontre",
      0.0075
    ],
    [
      "precheur",
      0.0075
    ],
    [
      "theologique",
      0.0075
    ],
    [
      "frocard",
      0.0075
    ],
    [
      "frater",
      0.0075
    ],
    [
      "ermite",
      0.0075
    ],
    [
      "augustin",
      0.0075
    ],
    [
      "barnabite",
      0.0075
    ],
    [
      "bernardin",
      0.0075
    ],
    [
      "benedictin",
      0.0075
    ],
    [
      "carme",
      0.0075
    ],
    [
      "chartreux",
      0.0075
    ],
    [
      "claustral",
      0.0075
    ],
    [
      "cloitrier",
      0.0075
    ],
    [
      "confessionnel",
      0.0075
    ],
    [
      "conventuel",
      0.0075
    ],
    [
      "convers",
      0.0075
    ],
    [
      "cenobite",
      0.0075
    ],
    [
      "devotieux",
      0.0075
    ],
    [
      "anachorete",
      0.0075
    ]
  ],
  "poivrot": [
    [
      "biberon",
      0.18
    ],
    [
      "buveur",
      0.18
    ],
    [
      "ivrogne",
      0.18
    ],
    [
      "soiffard",
      0.18
    ],
    [
      "alcoolique",
      0.09
    ],
    [
      "pochard",
      0.09
    ],
    [
      "poivrier",
      0.09
    ]
  ],
  "banquier": [
    [
      "argentier",
      0.5
    ],
    [
      "financier",
      0.5
    ]
  ],
  "vereux": [
    [
      "malhonnete",
      0.2125
    ],
    [
      "marron",
      0.1425
    ],
    [
      "suspect",
      0.1425
    ],
    [
      "louche",
      0.07
    ],
    [
      "indelicat",
      0.07
    ],
    [
      "improbe",
      0.07
    ],
    [
      "deshonnete",
      0.07
    ],
    [
      "douteux",
      0.07
    ],
    [
      "corrompu",
      0.07
    ],
    [
      "pourri",
      0.07
    ]
  ],
  "pigeon": [
    [
      "ramier",
      0.26
    ],
    [
      "poire",
      0.11
    ],
    [
      "sot",
      0.0725
    ],
    [
      "niais",
      0.0725
    ],
    [
      "naif",
      0.0725
    ],
    [
      "gogo",
      0.0725
    ],
    [
      "tourtereau",
      0.035
    ],
    [
      "tourte",
      0.035
    ],
    [
      "palonne",
      0.035
    ],
    [
      "palombe",
      0.035
    ],
    [
      "goura",
      0.035
    ],
    [
      "dupe",
      0.035
    ],
    [
      "colombe",
      0.035
    ],
    [
      "biset",
      0.035
    ],
    [
      "tourterelle",
      0.035
    ]
  ],
  "hippie": [
    [
      "baba",
      0.3325
    ],
    [
      "beatnik",
      0.3325
    ],
    [
      "drope",
      0.3325
    ]
  ],
  "naivete": [
    [
      "simplicite",
      0.1475
    ],
    [
      "ingenuite",
      0.09
    ],
    [
      "candeur",
      0.0725
    ],
    [
      "betise",
      0.0575
    ],
    [
      "niaiserie",
      0.0575
    ],
    [
      "sottise",
      0.04
    ],
    [
      "sincerite",
      0.04
    ],
    [
      "innocence",
      0.04
    ],
    [
      "ignorance",
      0.04
    ],
    [
      "franchise",
      0.04
    ],
    [
      "credulite",
      0.04
    ],
    [
      "naturel",
      0.0325
    ],
    [
      "purete",
      0.0325
    ],
    [
      "fraicheur",
      0.0225
    ],
    [
      "droiture",
      0.0225
    ],
    [
      "bonte",
      0.0225
    ],
    [
      "anerie",
      0.015
    ],
    [
      "spontaneite",
      0.015
    ],
    [
      "maladresse",
      0.015
    ],
    [
      "jobarderie",
      0.015
    ],
    [
      "inexperience",
      0.015
    ],
    [
      "enfantillage",
      0.015
    ],
    [
      "baliverne",
      0.015
    ],
    [
      "abandon",
      0.015
    ],
    [
      "simplesse",
      0.0075
    ],
    [
      "puerilite",
      0.0075
    ],
    [
      "nigauderie",
      0.0075
    ],
    [
      "bonhomie",
      0.0075
    ],
    [
      "superstition",
      0.0075
    ]
  ],
  "libertin": [
    [
      "debauche",
      0.1425
    ],
    [
      "polisson",
      0.065
    ],
    [
      "licencieux",
      0.0575
    ],
    [
      "devergonde",
      0.0475
    ],
    [
      "immoral",
      0.0475
    ],
    [
      "sensuel",
      0.0475
    ],
    [
      "noceur",
      0.035
    ],
    [
      "vicieux",
      0.0275
    ],
    [
      "vaurien",
      0.0275
    ],
    [
      "lascif",
      0.0275
    ],
    [
      "grivois",
      0.0275
    ],
    [
      "dissolu",
      0.0275
    ],
    [
      "impudique",
      0.0225
    ],
    [
      "leste",
      0.0225
    ],
    [
      "libre",
      0.0225
    ],
    [
      "viveur",
      0.0225
    ],
    [
      "voluptueux",
      0.0175
    ],
    [
      "truand",
      0.0175
    ],
    [
      "sybarite",
      0.0175
    ],
    [
      "graveleux",
      0.0175
    ],
    [
      "deregle",
      0.0175
    ],
    [
      "dissipe",
      0.0175
    ],
    [
      "coquin",
      0.0175
    ],
    [
      "epicurien",
      0.01
    ],
    [
      "egrillard",
      0.01
    ],
    [
      "vagabond",
      0.01
    ],
    [
      "relache",
      0.01
    ],
    [
      "paillard",
      0.01
    ],
    [
      "gaulois",
      0.01
    ],
    [
      "galant",
      0.01
    ],
    [
      "devoye",
      0.01
    ],
    [
      "deprave",
      0.01
    ],
    [
      "bandit",
      0.01
    ],
    [
      "irreligieux",
      0.005
    ],
    [
      "philosophe",
      0.005
    ],
    [
      "roue",
      0.005
    ],
    [
      "incredule",
      0.005
    ],
    [
      "incroyant",
      0.005
    ],
    [
      "impie",
      0.005
    ],
    [
      "esthete",
      0.005
    ],
    [
      "bambocheur",
      0.005
    ],
    [
      "athee",
      0.005
    ],
    [
      "sardanapale",
      0.005
    ]
  ],
  "pseudo": [
    [
      "faux",
      0.5
    ],
    [
      "pretendu",
      0.5
    ]
  ],
  "engage": [
    [
      "pousser",
      0.0875
    ],
    [
      "inciter",
      0.0575
    ],
    [
      "provoquer",
      0.055
    ],
    [
      "exciter",
      0.05
    ],
    [
      "inviter",
      0.05
    ],
    [
      "entrainer",
      0.0425
    ],
    [
      "attirer",
      0.03
    ],
    [
      "appeler",
      0.0275
    ],
    [
      "determiner",
      0.0275
    ],
    [
      "prendre",
      0.025
    ],
    [
      "porter",
      0.025
    ],
    [
      "exhorter",
      0.02
    ],
    [
      "mettre",
      0.02
    ],
    [
      "solliciter",
      0.02
    ],
    [
      "commencer",
      0.0175
    ],
    [
      "presser",
      0.0175
    ],
    [
      "tenir",
      0.015
    ],
    [
      "conseiller",
      0.015
    ],
    [
      "attaquer",
      0.015
    ],
    [
      "attacher",
      0.015
    ],
    [
      "amorcer",
      0.0125
    ],
    [
      "entamer",
      0.0125
    ],
    [
      "lier",
      0.0125
    ],
    [
      "passer",
      0.01
    ],
    [
      "ouvrir",
      0.01
    ],
    [
      "obliger",
      0.01
    ],
    [
      "introduire",
      0.01
    ],
    [
      "entreprendre",
      0.01
    ],
    [
      "encourager",
      0.01
    ],
    [
      "contraindre",
      0.01
    ],
    [
      "retenir",
      0.0075
    ],
    [
      "recruter",
      0.0075
    ],
    [
      "promettre",
      0.0075
    ],
    [
      "enfoncer",
      0.0075
    ],
    [
      "embarquer",
      0.0075
    ],
    [
      "disposer",
      0.0075
    ],
    [
      "astreindre",
      0.0075
    ],
    [
      "arreter",
      0.0075
    ],
    [
      "amener",
      0.0075
    ],
    [
      "ebaucher",
      0.005
    ],
    [
      "risquer",
      0.005
    ],
    [
      "jeter",
      0.005
    ],
    [
      "fourrer",
      0.005
    ],
    [
      "exposer",
      0.005
    ],
    [
      "engrener",
      0.005
    ],
    [
      "employer",
      0.005
    ],
    [
      "convier",
      0.005
    ],
    [
      "glisser",
      0.0025
    ],
    [
      "induire",
      0.0025
    ],
    [
      "livrer",
      0.0025
    ],
    [
      "plonger",
      0.0025
    ],
    [
      "racoler",
      0.0025
    ],
    [
      "gager",
      0.0025
    ],
    [
      "enroler",
      0.0025
    ],
    [
      "enfourner",
      0.0025
    ],
    [
      "enclencher",
      0.0025
    ],
    [
      "enclaver",
      0.0025
    ],
    [
      "embaucher",
      0.0025
    ],
    [
      "couter",
      0.0025
    ],
    [
      "allecher",
      0.0025
    ],
    [
      "impliquer",
      0.0
    ],
    [
      "investir",
      0.0
    ],
    [
      "jurer",
      0.0
    ],
    [
      "marier",
      0.0
    ],
    [
      "recommander",
      0.0
    ],
    [
      "hypothequer",
      0.0
    ],
    [
      "fiancer",
      0.0
    ],
    [
      "enlier",
      0.0
    ],
    [
      "encastrer",
      0.0
    ],
    [
      "embringuer",
      0.0
    ],
    [
      "coincer",
      0.0
    ],
    [
      "aventurer",
      0.0
    ],
    [
      "affrioler",
      0.0
    ],
    [
      "rengager",
      0.0
    ]
  ],
  "engager": [
    [
      "pousser",
      0.0875
    ],
    [
      "inciter",
      0.0575
    ],
    [
      "provoquer",
      0.055
    ],
    [
      "exciter",
      0.05
    ],
    [
      "inviter",
      0.05
    ],
    [
      "entrainer",
      0.0425
    ],
    [
      "attirer",
      0.03
    ],
    [
      "appeler",
      0.0275
    ],
    [
      "determiner",
      0.0275
    ],
    [
      "prendre",
      0.025
    ],
    [
      "porter",
      0.025
    ],
    [
      "exhorter",
      0.02
    ],
    [
      "mettre",
      0.02
    ],
    [
      "solliciter",
      0.02
    ],
    [
      "commencer",
      0.0175
    ],
    [
      "presser",
      0.0175
    ],
    [
      "tenir",
      0.015
    ],
    [
      "conseiller",
      0.015
    ],
    [
      "attaquer",
      0.015
    ],
    [
      "attacher",
      0.015
    ],
    [
      "amorcer",
      0.0125
    ],
    [
      "entamer",
      0.0125
    ],
    [
      "lier",
      0.0125
    ],
    [
      "passer",
      0.01
    ],
    [
      "ouvrir",
      0.01
    ],
    [
      "obliger",
      0.01
    ],
    [
      "introduire",
      0.01
    ],
    [
      "entreprendre",
      0.01
    ],
    [
      "encourager",
      0.01
    ],
    [
      "contraindre",
      0.01
    ],
    [
      "retenir",
      0.0075
    ],
    [
      "recruter",
      0.0075
    ],
    [
      "promettre",
      0.0075
    ],
    [
      "enfoncer",
      0.0075
    ],
    [
      "embarquer",
      0.0075
    ],
    [
      "disposer",
      0.0075
    ],
    [
      "astreindre",
      0.0075
    ],
    [
      "arreter",
      0.0075
    ],
    [
      "amener",
      0.0075
    ],
    [
      "ebaucher",
      0.005
    ],
    [
      "risquer",
      0.005
    ],
    [
      "jeter",
      0.005
    ],
    [
      "fourrer",
      0.005
    ],
    [
      "exposer",
      0.005
    ],
    [
      "engrener",
      0.005
    ],
    [
      "employer",
      0.005
    ],
    [
      "convier",
      0.005
    ],
    [
      "glisser",
      0.0025
    ],
    [
      "induire",
      0.0025
    ],
    [
      "livrer",
      0.0025
    ],
    [
      "plonger",
      0.0025
    ],
    [
      "racoler",
      0.0025
    ],
    [
      "gager",
      0.0025
    ],
    [
      "enroler",
      0.0025
    ],
    [
      "enfourner",
      0.0025
    ],
    [
      "enclencher",
      0.0025
    ],
    [
      "enclaver",
      0.0025
    ],
    [
      "embaucher",
      0.0025
    ],
    [
      "couter",
      0.0025
    ],
    [
      "allecher",
      0.0025
    ],
    [
      "impliquer",
      0.0
    ],
    [
      "investir",
      0.0
    ],
    [
      "jurer",
      0.0
    ],
    [
      "marier",
      0.0
    ],
    [
      "recommander",
      0.0
    ],
    [
      "hypothequer",
      0.0
    ],
    [
      "fiancer",
      0.0
    ],
    [
      "enlier",
      0.0
    ],
    [
      "encastrer",
      0.0
    ],
    [
      "embringuer",
      0.0
    ],
    [
      "coincer",
      0.0
    ],
    [
      "aventurer",
      0.0
    ],
    [
      "affrioler",
      0.0
    ],
    [
      "rengager",
      0.0
    ]
  ],
  "banalite": [
    [
      "platitude",
      0.1325
    ],
    [
      "generalite",
      0.115
    ],
    [
      "cliche",
      0.0975
    ],
    [
      "poncif",
      0.0975
    ],
    [
      "truisme",
      0.0825
    ],
    [
      "pauvrete",
      0.065
    ],
    [
      "topique",
      0.0475
    ],
    [
      "mediocrite",
      0.0325
    ],
    [
      "lapalissade",
      0.0325
    ],
    [
      "insignifiance",
      0.0325
    ],
    [
      "trivialite",
      0.015
    ],
    [
      "stereotype",
      0.015
    ],
    [
      "roture",
      0.015
    ],
    [
      "rengaine",
      0.015
    ],
    [
      "prosaisme",
      0.015
    ],
    [
      "propos",
      0.015
    ],
    [
      "fadeur",
      0.015
    ],
    [
      "facilite",
      0.015
    ],
    [
      "bateau",
      0.015
    ],
    [
      "anonymat",
      0.015
    ],
    [
      "evidence",
      0.015
    ]
  ],
  "demagogue": [
    [
      "charlatan",
      0.3325
    ],
    [
      "democrate",
      0.3325
    ],
    [
      "tribun",
      0.3325
    ]
  ],
  "trachee": [],
  "precher": [
    [
      "catechiser",
      0.0875
    ],
    [
      "proner",
      0.075
    ],
    [
      "sermonner",
      0.075
    ],
    [
      "publier",
      0.05
    ],
    [
      "instruire",
      0.05
    ],
    [
      "endoctriner",
      0.05
    ],
    [
      "vanter",
      0.0375
    ],
    [
      "recommander",
      0.0375
    ],
    [
      "preconiser",
      0.0375
    ],
    [
      "pontifier",
      0.0375
    ],
    [
      "persuader",
      0.0375
    ],
    [
      "louer",
      0.0375
    ],
    [
      "haranguer",
      0.0375
    ],
    [
      "exhorter",
      0.0375
    ],
    [
      "enseigner",
      0.0375
    ],
    [
      "discourir",
      0.0375
    ],
    [
      "conseiller",
      0.0375
    ],
    [
      "propager",
      0.025
    ],
    [
      "moraliser",
      0.025
    ],
    [
      "celebrer",
      0.025
    ],
    [
      "annoncer",
      0.025
    ],
    [
      "convaincre",
      0.01
    ],
    [
      "exalter",
      0.01
    ],
    [
      "palabrer",
      0.01
    ],
    [
      "remontrer",
      0.01
    ],
    [
      "repeter",
      0.01
    ],
    [
      "edifier",
      0.01
    ],
    [
      "evangeliser",
      0.01
    ]
  ],
  "abrege": [
    [
      "diminuer",
      0.1925
    ],
    [
      "reduire",
      0.1925
    ],
    [
      "ecourter",
      0.0825
    ],
    [
      "raccourcir",
      0.0675
    ],
    [
      "amoindrir",
      0.0525
    ],
    [
      "tronquer",
      0.0525
    ],
    [
      "resumer",
      0.04
    ],
    [
      "restreindre",
      0.04
    ],
    [
      "rapetisser",
      0.04
    ],
    [
      "couper",
      0.04
    ],
    [
      "retrancher",
      0.025
    ],
    [
      "resserrer",
      0.025
    ],
    [
      "preciser",
      0.025
    ],
    [
      "alleger",
      0.025
    ],
    [
      "accourcir",
      0.025
    ],
    [
      "condenser",
      0.0125
    ],
    [
      "limiter",
      0.0125
    ],
    [
      "simplifier",
      0.0125
    ],
    [
      "trancher",
      0.0125
    ]
  ],
  "abreger": [
    [
      "diminuer",
      0.1925
    ],
    [
      "reduire",
      0.1925
    ],
    [
      "ecourter",
      0.0825
    ],
    [
      "raccourcir",
      0.0675
    ],
    [
      "amoindrir",
      0.0525
    ],
    [
      "tronquer",
      0.0525
    ],
    [
      "resumer",
      0.04
    ],
    [
      "restreindre",
      0.04
    ],
    [
      "rapetisser",
      0.04
    ],
    [
      "couper",
      0.04
    ],
    [
      "retrancher",
      0.025
    ],
    [
      "resserrer",
      0.025
    ],
    [
      "preciser",
      0.025
    ],
    [
      "alleger",
      0.025
    ],
    [
      "accourcir",
      0.025
    ],
    [
      "condenser",
      0.0125
    ],
    [
      "limiter",
      0.0125
    ],
    [
      "simplifier",
      0.0125
    ],
    [
      "trancher",
      0.0125
    ]
  ],
  "dechet": [
    [
      "debris",
      0.135
    ],
    [
      "rebut",
      0.1075
    ],
    [
      "residu",
      0.1075
    ],
    [
      "rognure",
      0.0675
    ],
    [
      "ordure",
      0.0525
    ],
    [
      "ruine",
      0.04
    ],
    [
      "rogaton",
      0.025
    ],
    [
      "relief",
      0.025
    ],
    [
      "ramas",
      0.025
    ],
    [
      "raclure",
      0.025
    ],
    [
      "perte",
      0.025
    ],
    [
      "lie",
      0.025
    ],
    [
      "lavure",
      0.025
    ],
    [
      "excrement",
      0.025
    ],
    [
      "detritus",
      0.025
    ],
    [
      "chute",
      0.025
    ],
    [
      "rincure",
      0.0125
    ],
    [
      "recrement",
      0.0125
    ],
    [
      "salete",
      0.0125
    ],
    [
      "scorie",
      0.0125
    ],
    [
      "tare",
      0.0125
    ],
    [
      "eclat",
      0.0125
    ],
    [
      "epave",
      0.0125
    ],
    [
      "reliquat",
      0.0125
    ],
    [
      "parcelle",
      0.0125
    ],
    [
      "freinte",
      0.0125
    ],
    [
      "ferraille",
      0.0125
    ],
    [
      "depot",
      0.0125
    ],
    [
      "deperdition",
      0.0125
    ],
    [
      "bris",
      0.0125
    ],
    [
      "bois",
      0.0125
    ],
    [
      "battitures",
      0.0125
    ],
    [
      "epluchure",
      0.0125
    ]
  ],
  "sportif": [
    [
      "athlete",
      0.3325
    ],
    [
      "loyal",
      0.3325
    ],
    [
      "sportsman",
      0.3325
    ]
  ],
  "hooligan": [
    [
      "casseur",
      0.5
    ],
    [
      "vandale",
      0.5
    ]
  ],
  "citadin": [
    [
      "habitant",
      0.4
    ],
    [
      "bourgeois",
      0.2
    ],
    [
      "citoyen",
      0.2
    ],
    [
      "urbain",
      0.2
    ]
  ],
  "bouseux": [
    [
      "paysan",
      0.375
    ],
    [
      "glaiseux",
      0.25
    ],
    [
      "campagnard",
      0.125
    ],
    [
      "pedzouille",
      0.125
    ],
    [
      "terreux",
      0.125
    ]
  ],
  "etable": [
    [
      "abri",
      0.25
    ],
    [
      "ecurie",
      0.0825
    ],
    [
      "porcherie",
      0.0825
    ],
    [
      "hangar",
      0.0825
    ],
    [
      "cheptel",
      0.0825
    ],
    [
      "betail",
      0.0825
    ],
    [
      "bergerie",
      0.0825
    ],
    [
      "bercail",
      0.0825
    ],
    [
      "bouverie",
      0.04
    ],
    [
      "grange",
      0.04
    ],
    [
      "soue",
      0.04
    ],
    [
      "vacherie",
      0.04
    ]
  ],
  "marginal": [
    [
      "secondaire",
      0.1325
    ],
    [
      "subsidiaire",
      0.065
    ],
    [
      "refractaire",
      0.065
    ],
    [
      "paume",
      0.065
    ],
    [
      "parallele",
      0.065
    ],
    [
      "mineur",
      0.065
    ],
    [
      "inadapte",
      0.065
    ],
    [
      "decale",
      0.065
    ],
    [
      "drope",
      0.065
    ],
    [
      "asocial",
      0.065
    ],
    [
      "antisocial",
      0.065
    ],
    [
      "adventice",
      0.065
    ],
    [
      "zonard",
      0.065
    ]
  ],
  "respectable": [
    [
      "digne",
      0.145
    ],
    [
      "honnete",
      0.115
    ],
    [
      "honorable",
      0.085
    ],
    [
      "venerable",
      0.0725
    ],
    [
      "imposant",
      0.0575
    ],
    [
      "noble",
      0.0575
    ],
    [
      "vertueux",
      0.0425
    ],
    [
      "serieux",
      0.0425
    ],
    [
      "meritant",
      0.0425
    ],
    [
      "estimable",
      0.0425
    ],
    [
      "auguste",
      0.0425
    ],
    [
      "sacre",
      0.0275
    ],
    [
      "probe",
      0.0275
    ],
    [
      "parfait",
      0.0275
    ],
    [
      "majestueux",
      0.0275
    ],
    [
      "grave",
      0.0275
    ],
    [
      "considere",
      0.0125
    ],
    [
      "consequent",
      0.0125
    ],
    [
      "coquet",
      0.0125
    ],
    [
      "correct",
      0.0125
    ],
    [
      "prestigieux",
      0.0125
    ],
    [
      "prisable",
      0.0125
    ],
    [
      "rondelet",
      0.0125
    ]
  ],
  "emploi": [
    [
      "fonction",
      0.1575
    ],
    [
      "metier",
      0.075
    ],
    [
      "charge",
      0.0625
    ],
    [
      "travail",
      0.0625
    ],
    [
      "usage",
      0.055
    ],
    [
      "situation",
      0.055
    ],
    [
      "position",
      0.055
    ],
    [
      "place",
      0.055
    ],
    [
      "profession",
      0.04
    ],
    [
      "application",
      0.0325
    ],
    [
      "occupation",
      0.0325
    ],
    [
      "poste",
      0.0325
    ],
    [
      "role",
      0.0325
    ],
    [
      "etat",
      0.0275
    ],
    [
      "utilisation",
      0.0275
    ],
    [
      "service",
      0.0275
    ],
    [
      "office",
      0.0275
    ],
    [
      "affectation",
      0.02
    ],
    [
      "sinecure",
      0.0125
    ],
    [
      "exercice",
      0.0125
    ],
    [
      "destination",
      0.0125
    ],
    [
      "attribution",
      0.0125
    ],
    [
      "adoption",
      0.005
    ],
    [
      "fromage",
      0.005
    ],
    [
      "maniement",
      0.005
    ],
    [
      "ministere",
      0.005
    ],
    [
      "recours",
      0.005
    ]
  ],
  "passable": [
    [
      "acceptable",
      0.16
    ],
    [
      "convenable",
      0.0925
    ],
    [
      "bon",
      0.0825
    ],
    [
      "correct",
      0.075
    ],
    [
      "suffisant",
      0.065
    ],
    [
      "potable",
      0.065
    ],
    [
      "honnete",
      0.045
    ],
    [
      "possible",
      0.045
    ],
    [
      "supportable",
      0.0375
    ],
    [
      "satisfaisant",
      0.0375
    ],
    [
      "mediocre",
      0.0375
    ],
    [
      "moyen",
      0.0375
    ],
    [
      "admissible",
      0.0375
    ],
    [
      "mangeable",
      0.0275
    ],
    [
      "raisonnable",
      0.0275
    ],
    [
      "tolerable",
      0.0275
    ],
    [
      "valable",
      0.0175
    ],
    [
      "buvable",
      0.0175
    ],
    [
      "appreciable",
      0.0075
    ],
    [
      "consommable",
      0.0075
    ],
    [
      "marque",
      0.0075
    ],
    [
      "mettable",
      0.0075
    ],
    [
      "penetrable",
      0.0075
    ]
  ],
  "crapule": [
    [
      "fripouille",
      0.155
    ],
    [
      "bandit",
      0.11
    ],
    [
      "voleur",
      0.1
    ],
    [
      "vaurien",
      0.0875
    ],
    [
      "canaille",
      0.0775
    ],
    [
      "malfaiteur",
      0.065
    ],
    [
      "brigand",
      0.065
    ],
    [
      "truand",
      0.055
    ],
    [
      "vermine",
      0.0325
    ],
    [
      "racaille",
      0.0325
    ],
    [
      "gangster",
      0.0325
    ],
    [
      "forban",
      0.0325
    ],
    [
      "escroc",
      0.0325
    ],
    [
      "filou",
      0.02
    ],
    [
      "vil",
      0.01
    ],
    [
      "vendu",
      0.01
    ],
    [
      "rosse",
      0.01
    ],
    [
      "raclure",
      0.01
    ],
    [
      "ivresse",
      0.01
    ],
    [
      "charogne",
      0.01
    ],
    [
      "arsouille",
      0.01
    ],
    [
      "voyou",
      0.01
    ]
  ],
  "medaille": [
    [
      "decoration",
      0.175
    ],
    [
      "recompense",
      0.175
    ],
    [
      "diplome",
      0.1175
    ],
    [
      "prix",
      0.1175
    ],
    [
      "plaque",
      0.0575
    ],
    [
      "piece",
      0.0575
    ],
    [
      "medaillon",
      0.0575
    ],
    [
      "monnaie",
      0.0575
    ],
    [
      "insigne",
      0.0575
    ],
    [
      "distinction",
      0.0575
    ],
    [
      "trophee",
      0.0575
    ]
  ],
  "cigale": [
    [
      "grappin",
      0.3325
    ],
    [
      "organeau",
      0.3325
    ],
    [
      "poete",
      0.3325
    ]
  ],
  "pheromone": [],
  "compare": [
    [
      "collationner",
      0.1175
    ],
    [
      "examiner",
      0.1175
    ],
    [
      "peser",
      0.095
    ],
    [
      "confronter",
      0.07
    ],
    [
      "opposer",
      0.07
    ],
    [
      "verifier",
      0.07
    ],
    [
      "evaluer",
      0.0475
    ],
    [
      "rapprocher",
      0.0475
    ],
    [
      "conferer",
      0.0475
    ],
    [
      "balancer",
      0.0475
    ],
    [
      "apprecier",
      0.0475
    ],
    [
      "vidimer",
      0.0225
    ],
    [
      "recoler",
      0.0225
    ],
    [
      "mesurer",
      0.0225
    ],
    [
      "assimiler",
      0.0225
    ],
    [
      "analyser",
      0.0225
    ],
    [
      "echantillonner",
      0.0225
    ]
  ],
  "tendresse": [
    [
      "attachement",
      0.0925
    ],
    [
      "affection",
      0.08
    ],
    [
      "amour",
      0.0725
    ],
    [
      "bonte",
      0.055
    ],
    [
      "amabilite",
      0.05
    ],
    [
      "complaisance",
      0.0425
    ],
    [
      "gentillesse",
      0.0425
    ],
    [
      "passion",
      0.0425
    ],
    [
      "coeur",
      0.035
    ],
    [
      "amitie",
      0.035
    ],
    [
      "zele",
      0.03
    ],
    [
      "sensibilite",
      0.03
    ],
    [
      "inclination",
      0.03
    ],
    [
      "devouement",
      0.03
    ],
    [
      "delicatesse",
      0.03
    ],
    [
      "douceur",
      0.03
    ],
    [
      "caresse",
      0.03
    ],
    [
      "sympathie",
      0.0225
    ],
    [
      "sentiment",
      0.0175
    ],
    [
      "galanterie",
      0.0175
    ],
    [
      "devotion",
      0.0175
    ],
    [
      "adoration",
      0.01
    ],
    [
      "chatterie",
      0.01
    ],
    [
      "flamme",
      0.01
    ],
    [
      "idolatrie",
      0.01
    ],
    [
      "penchant",
      0.01
    ],
    [
      "manifestation",
      0.005
    ],
    [
      "predilection",
      0.005
    ],
    [
      "souvenir",
      0.005
    ],
    [
      "tendrete",
      0.005
    ],
    [
      "egards",
      0.005
    ],
    [
      "langueur",
      0.005
    ],
    [
      "feu",
      0.005
    ],
    [
      "effusion",
      0.005
    ],
    [
      "dilection",
      0.005
    ],
    [
      "calinerie",
      0.005
    ],
    [
      "cajolerie",
      0.005
    ],
    [
      "attendrissement",
      0.005
    ],
    [
      "epanchement",
      0.005
    ]
  ],
  "emotion": [
    [
      "agitation",
      0.095
    ],
    [
      "trouble",
      0.07
    ],
    [
      "passion",
      0.0525
    ],
    [
      "emoi",
      0.05
    ],
    [
      "mouvement",
      0.04
    ],
    [
      "exaltation",
      0.0375
    ],
    [
      "inquietude",
      0.0275
    ],
    [
      "excitation",
      0.0275
    ],
    [
      "bouleversement",
      0.0275
    ],
    [
      "enthousiasme",
      0.025
    ],
    [
      "transport",
      0.025
    ],
    [
      "ebranlement",
      0.0225
    ],
    [
      "saisissement",
      0.0225
    ],
    [
      "delire",
      0.0225
    ],
    [
      "commotion",
      0.0225
    ],
    [
      "bouillonnement",
      0.0225
    ],
    [
      "affolement",
      0.02
    ],
    [
      "alarme",
      0.02
    ],
    [
      "fievre",
      0.02
    ],
    [
      "malaise",
      0.02
    ],
    [
      "sensation",
      0.015
    ],
    [
      "secousse",
      0.015
    ],
    [
      "effervescence",
      0.015
    ],
    [
      "affres",
      0.0125
    ],
    [
      "angoisse",
      0.0125
    ],
    [
      "choc",
      0.0125
    ],
    [
      "fureur",
      0.0125
    ],
    [
      "sentiment",
      0.0125
    ],
    [
      "epouvante",
      0.01
    ],
    [
      "transe",
      0.01
    ],
    [
      "frisson",
      0.01
    ],
    [
      "attendrissement",
      0.01
    ],
    [
      "vertige",
      0.0075
    ],
    [
      "sensibilite",
      0.0075
    ],
    [
      "revolte",
      0.0075
    ],
    [
      "ivresse",
      0.0075
    ],
    [
      "inspiration",
      0.0075
    ],
    [
      "desarroi",
      0.0075
    ],
    [
      "affection",
      0.0075
    ],
    [
      "emeute",
      0.005
    ],
    [
      "traumatisme",
      0.005
    ],
    [
      "larme",
      0.005
    ],
    [
      "impression",
      0.005
    ],
    [
      "douleur",
      0.005
    ],
    [
      "crainte",
      0.005
    ],
    [
      "alerte",
      0.005
    ],
    [
      "sedition",
      0.0025
    ],
    [
      "souleur",
      0.0025
    ],
    [
      "scandale",
      0.0025
    ],
    [
      "poesie",
      0.0025
    ],
    [
      "plaisir",
      0.0025
    ],
    [
      "pathetique",
      0.0025
    ],
    [
      "embarras",
      0.0025
    ],
    [
      "coup",
      0.0025
    ],
    [
      "conspiration",
      0.0025
    ],
    [
      "trauma",
      0.0025
    ]
  ],
  "effrayer": [
    [
      "terroriser",
      0.115
    ],
    [
      "epouvanter",
      0.115
    ],
    [
      "affoler",
      0.105
    ],
    [
      "inquieter",
      0.105
    ],
    [
      "alarmer",
      0.075
    ],
    [
      "terrifier",
      0.065
    ],
    [
      "apeurer",
      0.0375
    ],
    [
      "effaroucher",
      0.0375
    ],
    [
      "intimider",
      0.0375
    ],
    [
      "effarer",
      0.0275
    ],
    [
      "angoisser",
      0.0275
    ],
    [
      "agiter",
      0.0275
    ],
    [
      "petrifier",
      0.0175
    ],
    [
      "epeurer",
      0.0175
    ],
    [
      "tourmenter",
      0.0075
    ],
    [
      "menacer",
      0.0075
    ],
    [
      "impressionner",
      0.0075
    ],
    [
      "hypnotiser",
      0.0075
    ],
    [
      "horrifier",
      0.0075
    ],
    [
      "halluciner",
      0.0075
    ],
    [
      "fuir",
      0.0075
    ],
    [
      "transir",
      0.0075
    ]
  ],
  "chaos": [
    [
      "confusion",
      0.1575
    ],
    [
      "desordre",
      0.1275
    ],
    [
      "fatras",
      0.05
    ],
    [
      "melange",
      0.05
    ],
    [
      "imbroglio",
      0.0375
    ],
    [
      "chambardement",
      0.0375
    ],
    [
      "brouillamini",
      0.0325
    ],
    [
      "bouleversement",
      0.0275
    ],
    [
      "trouble",
      0.0275
    ],
    [
      "perturbation",
      0.02
    ],
    [
      "gachis",
      0.02
    ],
    [
      "enchevetrement",
      0.02
    ],
    [
      "embrouillement",
      0.015
    ],
    [
      "incoherence",
      0.01
    ],
    [
      "incohesion",
      0.01
    ],
    [
      "melee",
      0.01
    ],
    [
      "pastis",
      0.01
    ],
    [
      "tumulte",
      0.01
    ],
    [
      "eparpillement",
      0.01
    ],
    [
      "foutoir",
      0.01
    ],
    [
      "desorganisation",
      0.01
    ],
    [
      "anarchie",
      0.01
    ],
    [
      "bazar",
      0.01
    ],
    [
      "bordel",
      0.01
    ],
    [
      "cohue",
      0.01
    ],
    [
      "complication",
      0.01
    ],
    [
      "debacle",
      0.01
    ],
    [
      "zizanie",
      0.005
    ],
    [
      "micmac",
      0.005
    ],
    [
      "marmelade",
      0.005
    ],
    [
      "marasme",
      0.005
    ],
    [
      "discorde",
      0.005
    ],
    [
      "chantier",
      0.005
    ],
    [
      "cataclysme",
      0.005
    ],
    [
      "cafouillis",
      0.005
    ],
    [
      "abime",
      0.005
    ],
    [
      "ecroulement",
      0.005
    ]
  ],
  "honte": [
    [
      "turpitude",
      0.085
    ],
    [
      "ignominie",
      0.0675
    ],
    [
      "infamie",
      0.055
    ],
    [
      "decheance",
      0.045
    ],
    [
      "pudeur",
      0.045
    ],
    [
      "reserve",
      0.0375
    ],
    [
      "indignite",
      0.0375
    ],
    [
      "deshonneur",
      0.0375
    ],
    [
      "bassesse",
      0.0375
    ],
    [
      "abaissement",
      0.0375
    ],
    [
      "fletrissure",
      0.0325
    ],
    [
      "timidite",
      0.0275
    ],
    [
      "humilite",
      0.0275
    ],
    [
      "humiliation",
      0.0275
    ],
    [
      "degradation",
      0.0275
    ],
    [
      "abjection",
      0.0225
    ],
    [
      "affront",
      0.0225
    ],
    [
      "opprobre",
      0.0225
    ],
    [
      "retenue",
      0.0225
    ],
    [
      "respect",
      0.015
    ],
    [
      "modestie",
      0.015
    ],
    [
      "horreur",
      0.015
    ],
    [
      "gene",
      0.015
    ],
    [
      "embarras",
      0.015
    ],
    [
      "confusion",
      0.015
    ],
    [
      "componction",
      0.015
    ],
    [
      "echec",
      0.01
    ],
    [
      "vilenie",
      0.01
    ],
    [
      "tache",
      0.01
    ],
    [
      "repugnance",
      0.01
    ],
    [
      "degout",
      0.01
    ],
    [
      "crainte",
      0.01
    ],
    [
      "contrainte",
      0.01
    ],
    [
      "vergogne",
      0.005
    ],
    [
      "scrupule",
      0.005
    ],
    [
      "scandale",
      0.005
    ],
    [
      "repentir",
      0.005
    ],
    [
      "remords",
      0.005
    ],
    [
      "regret",
      0.005
    ],
    [
      "malaise",
      0.005
    ],
    [
      "insucces",
      0.005
    ],
    [
      "fessee",
      0.005
    ],
    [
      "demerite",
      0.005
    ],
    [
      "dementi",
      0.005
    ],
    [
      "abomination",
      0.005
    ],
    [
      "vitupere",
      0.005
    ]
  ],
  "foirer": [
    [
      "avorter",
      0.18
    ],
    [
      "rater",
      0.18
    ],
    [
      "echouer",
      0.18
    ],
    [
      "derailler",
      0.09
    ],
    [
      "louper",
      0.09
    ],
    [
      "merder",
      0.09
    ],
    [
      "reculer",
      0.09
    ],
    [
      "rompre",
      0.09
    ]
  ],
  "chantier": [
    [
      "affaire",
      0.1425
    ],
    [
      "atelier",
      0.105
    ],
    [
      "bazar",
      0.105
    ],
    [
      "magasin",
      0.105
    ],
    [
      "entrepot",
      0.07
    ],
    [
      "depot",
      0.07
    ],
    [
      "boite",
      0.07
    ],
    [
      "arsenal",
      0.07
    ],
    [
      "agence",
      0.07
    ],
    [
      "chaos",
      0.035
    ],
    [
      "desordre",
      0.035
    ],
    [
      "entassement",
      0.035
    ],
    [
      "fabrique",
      0.035
    ],
    [
      "tin",
      0.035
    ]
  ],
  "janvier": [],
  "aiguiller": [
    [
      "diriger",
      0.375
    ],
    [
      "orienter",
      0.25
    ],
    [
      "canaliser",
      0.125
    ],
    [
      "centrer",
      0.125
    ],
    [
      "guider",
      0.125
    ]
  ],
  "aiguille": [
    [
      "pointe",
      0.1175
    ],
    [
      "sommet",
      0.0975
    ],
    [
      "broche",
      0.0575
    ],
    [
      "dent",
      0.0575
    ],
    [
      "pic",
      0.0575
    ],
    [
      "eperon",
      0.0575
    ],
    [
      "epine",
      0.0375
    ],
    [
      "piquant",
      0.0375
    ],
    [
      "fleche",
      0.0375
    ],
    [
      "comble",
      0.0375
    ],
    [
      "bec",
      0.0375
    ],
    [
      "arete",
      0.0375
    ],
    [
      "aiguillon",
      0.0375
    ],
    [
      "epingle",
      0.0175
    ],
    [
      "tige",
      0.0175
    ],
    [
      "rostre",
      0.0175
    ],
    [
      "piton",
      0.0175
    ],
    [
      "piquoir",
      0.0175
    ],
    [
      "obelisque",
      0.0175
    ],
    [
      "fiche",
      0.0175
    ],
    [
      "colonne",
      0.0175
    ],
    [
      "carrelet",
      0.0175
    ],
    [
      "bifurcation",
      0.0175
    ],
    [
      "alene",
      0.0175
    ],
    [
      "aiguillette",
      0.0175
    ],
    [
      "aiguillage",
      0.0175
    ],
    [
      "epinglette",
      0.0175
    ]
  ],
  "cuit": [
    [
      "fricasser",
      0.1025
    ],
    [
      "griller",
      0.0675
    ],
    [
      "mijoter",
      0.0675
    ],
    [
      "rotir",
      0.0675
    ],
    [
      "bruler",
      0.0575
    ],
    [
      "rissoler",
      0.045
    ],
    [
      "preparer",
      0.0325
    ],
    [
      "piquer",
      0.0325
    ],
    [
      "fricoter",
      0.0325
    ],
    [
      "chauffer",
      0.0325
    ],
    [
      "renverser",
      0.0225
    ],
    [
      "murir",
      0.0225
    ],
    [
      "mitonner",
      0.0225
    ],
    [
      "gratter",
      0.0225
    ],
    [
      "faire",
      0.0225
    ],
    [
      "cuisiner",
      0.0225
    ],
    [
      "calciner",
      0.0225
    ],
    [
      "bronzer",
      0.0225
    ],
    [
      "braiser",
      0.0225
    ],
    [
      "bouillir",
      0.0225
    ],
    [
      "boucaner",
      0.0225
    ],
    [
      "frire",
      0.01
    ],
    [
      "frissonner",
      0.01
    ],
    [
      "infuser",
      0.01
    ],
    [
      "recuire",
      0.01
    ],
    [
      "etouffer",
      0.01
    ],
    [
      "flamber",
      0.01
    ],
    [
      "digerer",
      0.01
    ],
    [
      "cramer",
      0.01
    ],
    [
      "carboniser",
      0.01
    ],
    [
      "blondir",
      0.01
    ],
    [
      "biscuiter",
      0.01
    ],
    [
      "attacher",
      0.01
    ],
    [
      "etuver",
      0.01
    ]
  ],
  "planer": [
    [
      "voler",
      0.215
    ],
    [
      "aplanir",
      0.1425
    ],
    [
      "polir",
      0.1425
    ],
    [
      "unir",
      0.07
    ],
    [
      "survoler",
      0.07
    ],
    [
      "rever",
      0.07
    ],
    [
      "flotter",
      0.07
    ],
    [
      "dresser",
      0.07
    ],
    [
      "voir",
      0.07
    ]
  ],
  "gogo": [
    [
      "naif",
      0.2
    ],
    [
      "jobard",
      0.12
    ],
    [
      "niais",
      0.12
    ],
    [
      "poire",
      0.0775
    ],
    [
      "pigeon",
      0.0775
    ],
    [
      "dupe",
      0.0775
    ],
    [
      "credule",
      0.0775
    ],
    [
      "gobeur",
      0.0375
    ],
    [
      "jocrisse",
      0.0375
    ],
    [
      "micheton",
      0.0375
    ]
  ],
  "guidon": [
    [
      "banniere",
      0.2
    ],
    [
      "drapeau",
      0.2
    ],
    [
      "banderole",
      0.15
    ],
    [
      "enseigne",
      0.1
    ],
    [
      "pavillon",
      0.1
    ],
    [
      "oriflamme",
      0.05
    ],
    [
      "mire",
      0.05
    ],
    [
      "fanion",
      0.05
    ],
    [
      "etendard",
      0.05
    ]
  ],
  "boisson": [
    [
      "alcool",
      0.0775
    ],
    [
      "bibine",
      0.05
    ],
    [
      "liqueur",
      0.05
    ],
    [
      "piquette",
      0.0375
    ],
    [
      "tisane",
      0.025
    ],
    [
      "remontant",
      0.025
    ],
    [
      "philtre",
      0.025
    ],
    [
      "melange",
      0.025
    ],
    [
      "limonade",
      0.025
    ],
    [
      "ivresse",
      0.025
    ],
    [
      "infusion",
      0.025
    ],
    [
      "decoction",
      0.025
    ],
    [
      "digestif",
      0.025
    ],
    [
      "breuvage",
      0.025
    ],
    [
      "bouillon",
      0.025
    ],
    [
      "poire",
      0.01
    ],
    [
      "orangeade",
      0.01
    ],
    [
      "nectar",
      0.01
    ],
    [
      "mixture",
      0.01
    ],
    [
      "mate",
      0.01
    ],
    [
      "liquide",
      0.01
    ],
    [
      "lait",
      0.01
    ],
    [
      "kefir",
      0.01
    ],
    [
      "potion",
      0.01
    ],
    [
      "punch",
      0.01
    ],
    [
      "rafraichissement",
      0.01
    ],
    [
      "emulsion",
      0.01
    ],
    [
      "elixir",
      0.01
    ],
    [
      "vulneraire",
      0.01
    ],
    [
      "vin",
      0.01
    ],
    [
      "the",
      0.01
    ],
    [
      "spiritueux",
      0.01
    ],
    [
      "soda",
      0.01
    ],
    [
      "sirop",
      0.01
    ],
    [
      "kwas",
      0.01
    ],
    [
      "julep",
      0.01
    ],
    [
      "citronnade",
      0.01
    ],
    [
      "cidre",
      0.01
    ],
    [
      "chocolat",
      0.01
    ],
    [
      "chaudeau",
      0.01
    ],
    [
      "cafe",
      0.01
    ],
    [
      "boire",
      0.01
    ],
    [
      "biere",
      0.01
    ],
    [
      "aperitif",
      0.01
    ],
    [
      "cocktail",
      0.01
    ],
    [
      "coco",
      0.01
    ],
    [
      "ivrognerie",
      0.01
    ],
    [
      "hypocras",
      0.01
    ],
    [
      "hydromel",
      0.01
    ],
    [
      "grog",
      0.01
    ],
    [
      "eau",
      0.01
    ],
    [
      "cordial",
      0.01
    ],
    [
      "consommation",
      0.01
    ],
    [
      "alcoolisme",
      0.01
    ]
  ],
  "adopter": [
    [
      "prendre",
      0.0825
    ],
    [
      "suivre",
      0.0825
    ],
    [
      "embrasser",
      0.0725
    ],
    [
      "accepter",
      0.045
    ],
    [
      "emprunter",
      0.045
    ],
    [
      "epouser",
      0.035
    ],
    [
      "utiliser",
      0.035
    ],
    [
      "imiter",
      0.035
    ],
    [
      "choisir",
      0.035
    ],
    [
      "approuver",
      0.035
    ],
    [
      "admettre",
      0.035
    ],
    [
      "acquiescer",
      0.0275
    ],
    [
      "selectionner",
      0.0275
    ],
    [
      "ratifier",
      0.0175
    ],
    [
      "s'attacher",
      0.0175
    ],
    [
      "elire",
      0.0175
    ],
    [
      "pratiquer",
      0.0175
    ],
    [
      "introduire",
      0.0175
    ],
    [
      "affilier",
      0.0175
    ],
    [
      "assimiler",
      0.0175
    ],
    [
      "consentir",
      0.0175
    ],
    [
      "coopter",
      0.0175
    ],
    [
      "employer",
      0.0175
    ],
    [
      "singer",
      0.0075
    ],
    [
      "s'aligner",
      0.0075
    ],
    [
      "ramasser",
      0.0075
    ],
    [
      "preferer",
      0.0075
    ],
    [
      "opter",
      0.0075
    ],
    [
      "enteriner",
      0.0075
    ],
    [
      "composer",
      0.0075
    ],
    [
      "voter",
      0.0075
    ]
  ],
  "serein": [
    [
      "calme",
      0.1825
    ],
    [
      "tranquille",
      0.115
    ],
    [
      "paisible",
      0.095
    ],
    [
      "doux",
      0.085
    ],
    [
      "beau",
      0.0575
    ],
    [
      "placide",
      0.0575
    ],
    [
      "pur",
      0.0375
    ],
    [
      "heureux",
      0.0375
    ],
    [
      "flegmatique",
      0.0275
    ],
    [
      "imperturbable",
      0.0275
    ],
    [
      "limpide",
      0.0275
    ],
    [
      "sage",
      0.0275
    ],
    [
      "quiet",
      0.0175
    ],
    [
      "patient",
      0.0175
    ],
    [
      "pacifique",
      0.0175
    ],
    [
      "olympien",
      0.0175
    ],
    [
      "modere",
      0.0175
    ],
    [
      "clair",
      0.0175
    ],
    [
      "beat",
      0.0175
    ],
    [
      "vapeur",
      0.0075
    ],
    [
      "radieux",
      0.0075
    ],
    [
      "peinard",
      0.0075
    ],
    [
      "immobile",
      0.0075
    ],
    [
      "humidite",
      0.0075
    ],
    [
      "detendu",
      0.0075
    ],
    [
      "alcyonien",
      0.0075
    ],
    [
      "ethere",
      0.0075
    ]
  ],
  "douillet": [
    [
      "doux",
      0.1325
    ],
    [
      "delicat",
      0.1325
    ],
    [
      "mou",
      0.1325
    ],
    [
      "moelleux",
      0.105
    ],
    [
      "tendre",
      0.105
    ],
    [
      "sensible",
      0.0775
    ],
    [
      "effemine",
      0.05
    ],
    [
      "petit",
      0.025
    ],
    [
      "ouate",
      0.025
    ],
    [
      "mollet",
      0.025
    ],
    [
      "mol",
      0.025
    ],
    [
      "impressionnable",
      0.025
    ],
    [
      "fragile",
      0.025
    ],
    [
      "dolent",
      0.025
    ],
    [
      "confortable",
      0.025
    ],
    [
      "chatouilleux",
      0.025
    ],
    [
      "elastique",
      0.025
    ]
  ],
  "pitre": [
    [
      "clown",
      0.135
    ],
    [
      "bouffon",
      0.115
    ],
    [
      "farceur",
      0.0775
    ],
    [
      "turlupin",
      0.0775
    ],
    [
      "baladin",
      0.055
    ],
    [
      "plaisant",
      0.055
    ],
    [
      "saltimbanque",
      0.055
    ],
    [
      "singe",
      0.05
    ],
    [
      "comique",
      0.05
    ],
    [
      "comedien",
      0.035
    ],
    [
      "rigolo",
      0.02
    ],
    [
      "paillasse",
      0.02
    ],
    [
      "matassin",
      0.02
    ],
    [
      "histrion",
      0.02
    ],
    [
      "guignol",
      0.02
    ],
    [
      "gugusse",
      0.02
    ],
    [
      "bateleur",
      0.02
    ],
    [
      "acrobate",
      0.02
    ],
    [
      "zigoto",
      0.0125
    ],
    [
      "polichinelle",
      0.0125
    ],
    [
      "charlot",
      0.0125
    ],
    [
      "auguste",
      0.0125
    ],
    [
      "escamoteur",
      0.005
    ],
    [
      "jocrisse",
      0.005
    ],
    [
      "pasquin",
      0.005
    ],
    [
      "plaisantin",
      0.005
    ],
    [
      "zig",
      0.005
    ],
    [
      "zigomar",
      0.005
    ],
    [
      "zouave",
      0.005
    ]
  ],
  "net": [
    [
      "clair",
      0.0675
    ],
    [
      "franc",
      0.0575
    ],
    [
      "precis",
      0.0475
    ],
    [
      "droit",
      0.0375
    ],
    [
      "sincere",
      0.0375
    ],
    [
      "vrai",
      0.0325
    ],
    [
      "pur",
      0.0325
    ],
    [
      "certain",
      0.0325
    ],
    [
      "categorique",
      0.0325
    ],
    [
      "propre",
      0.03
    ],
    [
      "evident",
      0.0275
    ],
    [
      "juste",
      0.0275
    ],
    [
      "exact",
      0.0275
    ],
    [
      "formel",
      0.0225
    ],
    [
      "honnete",
      0.02
    ],
    [
      "positif",
      0.02
    ],
    [
      "transparent",
      0.02
    ],
    [
      "ferme",
      0.0175
    ],
    [
      "distinct",
      0.0175
    ],
    [
      "intelligible",
      0.015
    ],
    [
      "visible",
      0.0125
    ],
    [
      "regulier",
      0.0125
    ],
    [
      "loyal",
      0.0125
    ],
    [
      "logique",
      0.0125
    ],
    [
      "franchement",
      0.0125
    ],
    [
      "decide",
      0.0125
    ],
    [
      "blanc",
      0.0125
    ],
    [
      "soigne",
      0.0075
    ],
    [
      "resolu",
      0.0075
    ],
    [
      "poli",
      0.0075
    ],
    [
      "objectif",
      0.0075
    ],
    [
      "nu",
      0.0075
    ],
    [
      "nettement",
      0.0075
    ],
    [
      "lumineux",
      0.0075
    ],
    [
      "immacule",
      0.0075
    ],
    [
      "carre",
      0.0075
    ],
    [
      "tranche",
      0.0075
    ],
    [
      "ouvertement",
      0.0075
    ],
    [
      "ordonne",
      0.0075
    ],
    [
      "marque",
      0.0075
    ],
    [
      "intact",
      0.0075
    ],
    [
      "explicite",
      0.0075
    ],
    [
      "depouille",
      0.0075
    ],
    [
      "concis",
      0.0075
    ],
    [
      "brutalement",
      0.0075
    ],
    [
      "vierge",
      0.0025
    ],
    [
      "vide",
      0.0025
    ],
    [
      "sobre",
      0.0025
    ],
    [
      "realiste",
      0.0025
    ],
    [
      "ostensible",
      0.0025
    ],
    [
      "hautement",
      0.0025
    ],
    [
      "expres",
      0.0025
    ],
    [
      "direct",
      0.0025
    ],
    [
      "crument",
      0.0025
    ],
    [
      "cru",
      0.0025
    ],
    [
      "perspicace",
      0.0
    ],
    [
      "propret",
      0.0
    ],
    [
      "publiquement",
      0.0
    ],
    [
      "significatif",
      0.0
    ],
    [
      "specifique",
      0.0
    ],
    [
      "travaille",
      0.0
    ],
    [
      "uni",
      0.0
    ],
    [
      "nettoye",
      0.0
    ],
    [
      "lucide",
      0.0
    ],
    [
      "impeccable",
      0.0
    ],
    [
      "autoritaire",
      0.0
    ],
    [
      "brusquement",
      0.0
    ],
    [
      "caracterise",
      0.0
    ],
    [
      "compris",
      0.0
    ],
    [
      "diaphane",
      0.0
    ],
    [
      "defini",
      0.0
    ],
    [
      "essuye",
      0.0
    ],
    [
      "frais",
      0.0
    ],
    [
      "vigoureux",
      0.0
    ]
  ],
  "virus": [
    [
      "bacille",
      0.125
    ],
    [
      "bacterie",
      0.125
    ],
    [
      "contagion",
      0.125
    ],
    [
      "germe",
      0.125
    ],
    [
      "lubie",
      0.125
    ],
    [
      "microbe",
      0.125
    ],
    [
      "obsession",
      0.125
    ],
    [
      "poison",
      0.125
    ]
  ],
  "article": [
    [
      "chapitre",
      0.0625
    ],
    [
      "partie",
      0.0625
    ],
    [
      "chronique",
      0.0475
    ],
    [
      "matiere",
      0.0475
    ],
    [
      "papier",
      0.0475
    ],
    [
      "titre",
      0.0475
    ],
    [
      "traite",
      0.03
    ],
    [
      "rubrique",
      0.03
    ],
    [
      "reportage",
      0.03
    ],
    [
      "point",
      0.03
    ],
    [
      "objet",
      0.03
    ],
    [
      "copie",
      0.03
    ],
    [
      "question",
      0.015
    ],
    [
      "produit",
      0.015
    ],
    [
      "paragraphe",
      0.015
    ],
    [
      "notice",
      0.015
    ],
    [
      "marchandise",
      0.015
    ],
    [
      "leader",
      0.015
    ],
    [
      "segment",
      0.015
    ],
    [
      "sujet",
      0.015
    ],
    [
      "ustensile",
      0.015
    ],
    [
      "echo",
      0.015
    ],
    [
      "ecrit",
      0.015
    ],
    [
      "ecriture",
      0.015
    ],
    [
      "editorial",
      0.015
    ],
    [
      "etude",
      0.015
    ],
    [
      "jointure",
      0.015
    ],
    [
      "interview",
      0.015
    ],
    [
      "amorce",
      0.015
    ],
    [
      "articulation",
      0.015
    ],
    [
      "articulet",
      0.015
    ],
    [
      "billet",
      0.015
    ],
    [
      "compte",
      0.015
    ],
    [
      "convention",
      0.015
    ],
    [
      "courrier",
      0.015
    ],
    [
      "denree",
      0.015
    ],
    [
      "dissertation",
      0.015
    ],
    [
      "dogme",
      0.015
    ],
    [
      "determinant",
      0.015
    ],
    [
      "entrefilet",
      0.015
    ],
    [
      "essai",
      0.015
    ],
    [
      "feuilleton",
      0.015
    ],
    [
      "alinea",
      0.015
    ]
  ],
  "brader": [
    [
      "vendre",
      0.25
    ],
    [
      "solder",
      0.1875
    ],
    [
      "brocanter",
      0.125
    ],
    [
      "liquider",
      0.125
    ],
    [
      "bazarder",
      0.0625
    ],
    [
      "gacher",
      0.0625
    ],
    [
      "realiser",
      0.0625
    ],
    [
      "sacrifier",
      0.0625
    ],
    [
      "trafiquer",
      0.0625
    ]
  ],
  "promotion": [
    [
      "elevation",
      0.23
    ],
    [
      "avancement",
      0.1525
    ],
    [
      "grade",
      0.115
    ],
    [
      "dignite",
      0.075
    ],
    [
      "nomination",
      0.075
    ],
    [
      "emancipation",
      0.0375
    ],
    [
      "stimulation",
      0.0375
    ],
    [
      "mouvement",
      0.0375
    ],
    [
      "cuvee",
      0.0375
    ],
    [
      "classe",
      0.0375
    ],
    [
      "annee",
      0.0375
    ],
    [
      "amelioration",
      0.0375
    ],
    [
      "accession",
      0.0375
    ],
    [
      "erection",
      0.0375
    ]
  ],
  "seduit": [
    [
      "tromper",
      0.0575
    ],
    [
      "charmer",
      0.0525
    ],
    [
      "gagner",
      0.04
    ],
    [
      "attirer",
      0.0375
    ],
    [
      "captiver",
      0.0375
    ],
    [
      "enjoler",
      0.0375
    ],
    [
      "conquerir",
      0.035
    ],
    [
      "abuser",
      0.035
    ],
    [
      "attraper",
      0.0275
    ],
    [
      "tenter",
      0.0275
    ],
    [
      "fasciner",
      0.0275
    ],
    [
      "prendre",
      0.0225
    ],
    [
      "berner",
      0.0225
    ],
    [
      "amadouer",
      0.02
    ],
    [
      "capter",
      0.02
    ],
    [
      "embobiner",
      0.0175
    ],
    [
      "entortiller",
      0.0175
    ],
    [
      "allecher",
      0.015
    ],
    [
      "envouter",
      0.015
    ],
    [
      "circonvenir",
      0.015
    ],
    [
      "embabouiner",
      0.0125
    ],
    [
      "entrainer",
      0.0125
    ],
    [
      "plaire",
      0.0125
    ],
    [
      "ensorceler",
      0.01
    ],
    [
      "enchanter",
      0.01
    ],
    [
      "corrompre",
      0.01
    ],
    [
      "avoir",
      0.01
    ],
    [
      "amuser",
      0.01
    ],
    [
      "troubler",
      0.01
    ],
    [
      "egarer",
      0.0075
    ],
    [
      "eblouir",
      0.0075
    ],
    [
      "ravir",
      0.0075
    ],
    [
      "perdre",
      0.0075
    ],
    [
      "flatter",
      0.0075
    ],
    [
      "attacher",
      0.0075
    ],
    [
      "affrioler",
      0.0075
    ],
    [
      "subjuguer",
      0.005
    ],
    [
      "pervertir",
      0.005
    ],
    [
      "hypnotiser",
      0.005
    ],
    [
      "empaumer",
      0.005
    ],
    [
      "embobeliner",
      0.005
    ],
    [
      "debaucher",
      0.005
    ],
    [
      "convaincre",
      0.005
    ],
    [
      "briller",
      0.005
    ],
    [
      "amener",
      0.005
    ],
    [
      "faire",
      0.005
    ],
    [
      "passionner",
      0.005
    ],
    [
      "persuader",
      0.005
    ],
    [
      "piper",
      0.005
    ],
    [
      "enflammer",
      0.005
    ],
    [
      "endormir",
      0.005
    ],
    [
      "bluffer",
      0.005
    ],
    [
      "appater",
      0.005
    ],
    [
      "apprivoiser",
      0.005
    ],
    [
      "amorcer",
      0.005
    ],
    [
      "aguicher",
      0.005
    ],
    [
      "deshonorer",
      0.0025
    ],
    [
      "detourner",
      0.0025
    ],
    [
      "emmitonner",
      0.0025
    ],
    [
      "suborner",
      0.0025
    ],
    [
      "decevoir",
      0.0025
    ],
    [
      "coiffer",
      0.0025
    ],
    [
      "acheter",
      0.0025
    ],
    [
      "affriander",
      0.0025
    ],
    [
      "assujettir",
      0.0025
    ],
    [
      "baratiner",
      0.0025
    ],
    [
      "cajoler",
      0.0025
    ],
    [
      "capturer",
      0.0025
    ],
    [
      "jobarder",
      0.0
    ],
    [
      "magnetiser",
      0.0
    ],
    [
      "soudoyer",
      0.0
    ],
    [
      "tomber",
      0.0
    ],
    [
      "vamper",
      0.0
    ],
    [
      "inviter",
      0.0
    ],
    [
      "engluer",
      0.0
    ],
    [
      "blouser",
      0.0
    ],
    [
      "chatoyer",
      0.0
    ],
    [
      "couillonner",
      0.0
    ],
    [
      "deniaiser",
      0.0
    ],
    [
      "emberlucoquer",
      0.0
    ],
    [
      "attraire",
      0.0
    ]
  ],
  "seduire": [
    [
      "tromper",
      0.0575
    ],
    [
      "charmer",
      0.0525
    ],
    [
      "gagner",
      0.04
    ],
    [
      "attirer",
      0.0375
    ],
    [
      "captiver",
      0.0375
    ],
    [
      "enjoler",
      0.0375
    ],
    [
      "conquerir",
      0.035
    ],
    [
      "abuser",
      0.035
    ],
    [
      "attraper",
      0.0275
    ],
    [
      "tenter",
      0.0275
    ],
    [
      "fasciner",
      0.0275
    ],
    [
      "prendre",
      0.0225
    ],
    [
      "berner",
      0.0225
    ],
    [
      "amadouer",
      0.02
    ],
    [
      "capter",
      0.02
    ],
    [
      "embobiner",
      0.0175
    ],
    [
      "entortiller",
      0.0175
    ],
    [
      "allecher",
      0.015
    ],
    [
      "envouter",
      0.015
    ],
    [
      "circonvenir",
      0.015
    ],
    [
      "embabouiner",
      0.0125
    ],
    [
      "entrainer",
      0.0125
    ],
    [
      "plaire",
      0.0125
    ],
    [
      "ensorceler",
      0.01
    ],
    [
      "enchanter",
      0.01
    ],
    [
      "corrompre",
      0.01
    ],
    [
      "avoir",
      0.01
    ],
    [
      "amuser",
      0.01
    ],
    [
      "troubler",
      0.01
    ],
    [
      "egarer",
      0.0075
    ],
    [
      "eblouir",
      0.0075
    ],
    [
      "ravir",
      0.0075
    ],
    [
      "perdre",
      0.0075
    ],
    [
      "flatter",
      0.0075
    ],
    [
      "attacher",
      0.0075
    ],
    [
      "affrioler",
      0.0075
    ],
    [
      "subjuguer",
      0.005
    ],
    [
      "pervertir",
      0.005
    ],
    [
      "hypnotiser",
      0.005
    ],
    [
      "empaumer",
      0.005
    ],
    [
      "embobeliner",
      0.005
    ],
    [
      "debaucher",
      0.005
    ],
    [
      "convaincre",
      0.005
    ],
    [
      "briller",
      0.005
    ],
    [
      "amener",
      0.005
    ],
    [
      "faire",
      0.005
    ],
    [
      "passionner",
      0.005
    ],
    [
      "persuader",
      0.005
    ],
    [
      "piper",
      0.005
    ],
    [
      "enflammer",
      0.005
    ],
    [
      "endormir",
      0.005
    ],
    [
      "bluffer",
      0.005
    ],
    [
      "appater",
      0.005
    ],
    [
      "apprivoiser",
      0.005
    ],
    [
      "amorcer",
      0.005
    ],
    [
      "aguicher",
      0.005
    ],
    [
      "deshonorer",
      0.0025
    ],
    [
      "detourner",
      0.0025
    ],
    [
      "emmitonner",
      0.0025
    ],
    [
      "suborner",
      0.0025
    ],
    [
      "decevoir",
      0.0025
    ],
    [
      "coiffer",
      0.0025
    ],
    [
      "acheter",
      0.0025
    ],
    [
      "affriander",
      0.0025
    ],
    [
      "assujettir",
      0.0025
    ],
    [
      "baratiner",
      0.0025
    ],
    [
      "cajoler",
      0.0025
    ],
    [
      "capturer",
      0.0025
    ],
    [
      "jobarder",
      0.0
    ],
    [
      "magnetiser",
      0.0
    ],
    [
      "soudoyer",
      0.0
    ],
    [
      "tomber",
      0.0
    ],
    [
      "vamper",
      0.0
    ],
    [
      "inviter",
      0.0
    ],
    [
      "engluer",
      0.0
    ],
    [
      "blouser",
      0.0
    ],
    [
      "chatoyer",
      0.0
    ],
    [
      "couillonner",
      0.0
    ],
    [
      "deniaiser",
      0.0
    ],
    [
      "emberlucoquer",
      0.0
    ],
    [
      "attraire",
      0.0
    ]
  ],
  "petoche": [
    [
      "crainte",
      0.2
    ],
    [
      "frousse",
      0.2
    ],
    [
      "trouille",
      0.2
    ],
    [
      "cliche",
      0.1
    ],
    [
      "frayeur",
      0.1
    ],
    [
      "peur",
      0.1
    ],
    [
      "petasse",
      0.1
    ]
  ],
  "puree": [
    [
      "misere",
      0.205
    ],
    [
      "pauvrete",
      0.1475
    ],
    [
      "mouise",
      0.1175
    ],
    [
      "deche",
      0.0875
    ],
    [
      "poisse",
      0.0575
    ],
    [
      "panade",
      0.0575
    ],
    [
      "mouscaille",
      0.0575
    ],
    [
      "debine",
      0.0575
    ],
    [
      "bouillie",
      0.0575
    ],
    [
      "coulis",
      0.0275
    ],
    [
      "creme",
      0.0275
    ],
    [
      "limonade",
      0.0275
    ],
    [
      "mistoufle",
      0.0275
    ],
    [
      "supreme",
      0.0275
    ]
  ],
  "rallumer": [
    [
      "ranimer",
      0.3325
    ],
    [
      "reveiller",
      0.3325
    ],
    [
      "raviver",
      0.11
    ],
    [
      "ressusciter",
      0.11
    ],
    [
      "stimuler",
      0.11
    ]
  ],
  "potos": [],
  "douiller": [
    [
      "casquer",
      0.5
    ],
    [
      "payer",
      0.5
    ]
  ],
  "douille": [
    [
      "argent",
      0.2
    ],
    [
      "cartouche",
      0.2
    ],
    [
      "embouchoir",
      0.2
    ],
    [
      "manchon",
      0.2
    ],
    [
      "etui",
      0.2
    ]
  ],
  "fouille": [
    [
      "perquisition",
      0.25
    ],
    [
      "archeologie",
      0.125
    ],
    [
      "fosse",
      0.125
    ],
    [
      "poche",
      0.125
    ],
    [
      "recherche",
      0.125
    ],
    [
      "tranchee",
      0.125
    ],
    [
      "visite",
      0.125
    ]
  ],
  "fouiller": [
    [
      "sonder",
      0.0975
    ],
    [
      "examiner",
      0.0725
    ],
    [
      "etudier",
      0.0525
    ],
    [
      "creuser",
      0.0475
    ],
    [
      "explorer",
      0.0425
    ],
    [
      "scruter",
      0.0375
    ],
    [
      "travailler",
      0.03
    ],
    [
      "fouir",
      0.03
    ],
    [
      "chercher",
      0.03
    ],
    [
      "approfondir",
      0.03
    ],
    [
      "farfouiller",
      0.0225
    ],
    [
      "fureter",
      0.0225
    ],
    [
      "rechercher",
      0.0225
    ],
    [
      "remuer",
      0.0225
    ],
    [
      "trifouiller",
      0.0225
    ],
    [
      "miner",
      0.0175
    ],
    [
      "inspecter",
      0.0175
    ],
    [
      "battre",
      0.0175
    ],
    [
      "visiter",
      0.0125
    ],
    [
      "soigner",
      0.0125
    ],
    [
      "retourner",
      0.0125
    ],
    [
      "penetrer",
      0.0125
    ],
    [
      "piocher",
      0.0125
    ],
    [
      "interroger",
      0.0125
    ],
    [
      "consulter",
      0.0125
    ],
    [
      "ciseler",
      0.0125
    ],
    [
      "bouleverser",
      0.0125
    ],
    [
      "inventorier",
      0.0075
    ],
    [
      "lecher",
      0.0075
    ],
    [
      "perquisitionner",
      0.0075
    ],
    [
      "polir",
      0.0075
    ],
    [
      "tripatouiller",
      0.0075
    ],
    [
      "tater",
      0.0075
    ],
    [
      "eplucher",
      0.0075
    ],
    [
      "gratter",
      0.0075
    ],
    [
      "fourrager",
      0.0075
    ],
    [
      "affouiller",
      0.0075
    ],
    [
      "anatomiser",
      0.0075
    ],
    [
      "caver",
      0.0075
    ],
    [
      "compulser",
      0.0075
    ],
    [
      "effondrer",
      0.0075
    ],
    [
      "fignoler",
      0.0075
    ],
    [
      "fouiner",
      0.0075
    ],
    [
      "vermiller",
      0.0025
    ],
    [
      "sculpter",
      0.0025
    ],
    [
      "perler",
      0.0025
    ],
    [
      "fourgonner",
      0.0025
    ],
    [
      "fouger",
      0.0025
    ],
    [
      "forer",
      0.0025
    ],
    [
      "depouiller",
      0.0025
    ],
    [
      "barboter",
      0.0025
    ],
    [
      "balayer",
      0.0025
    ],
    [
      "vermillonner",
      0.0025
    ]
  ],
  "festin": [
    [
      "bombance",
      0.095
    ],
    [
      "bringue",
      0.095
    ],
    [
      "bombe",
      0.0825
    ],
    [
      "fete",
      0.06
    ],
    [
      "repas",
      0.055
    ],
    [
      "ripaille",
      0.055
    ],
    [
      "noce",
      0.05
    ],
    [
      "debauche",
      0.05
    ],
    [
      "banquet",
      0.05
    ],
    [
      "agapes",
      0.0375
    ],
    [
      "bamboche",
      0.0375
    ],
    [
      "beuverie",
      0.0375
    ],
    [
      "rejouissance",
      0.0375
    ],
    [
      "gueuleton",
      0.0325
    ],
    [
      "foire",
      0.0275
    ],
    [
      "nouba",
      0.02
    ],
    [
      "regal",
      0.015
    ],
    [
      "ribote",
      0.015
    ],
    [
      "balthazar",
      0.015
    ],
    [
      "lippee",
      0.01
    ],
    [
      "godaille",
      0.01
    ],
    [
      "gala",
      0.01
    ],
    [
      "frairie",
      0.01
    ],
    [
      "bouffe",
      0.01
    ],
    [
      "mangerie",
      0.005
    ],
    [
      "libation",
      0.005
    ],
    [
      "carrousse",
      0.005
    ],
    [
      "bafree",
      0.005
    ],
    [
      "bafre",
      0.005
    ],
    [
      "bosse",
      0.005
    ],
    [
      "biture",
      0.005
    ],
    [
      "bambochade",
      0.005
    ],
    [
      "menu",
      0.005
    ]
  ],
  "trouille": [
    [
      "frousse",
      0.2225
    ],
    [
      "peur",
      0.185
    ],
    [
      "crainte",
      0.1475
    ],
    [
      "frayeur",
      0.11
    ],
    [
      "petoche",
      0.0725
    ],
    [
      "cliche",
      0.0725
    ],
    [
      "colique",
      0.035
    ],
    [
      "effroi",
      0.035
    ],
    [
      "lachete",
      0.035
    ],
    [
      "trac",
      0.035
    ],
    [
      "vesse",
      0.035
    ]
  ],
  "resto": [],
  "pipeau": [
    [
      "chalumeau",
      0.1675
    ],
    [
      "appeau",
      0.1225
    ],
    [
      "flute",
      0.1225
    ],
    [
      "piege",
      0.1225
    ],
    [
      "gluau",
      0.0825
    ],
    [
      "roseau",
      0.04
    ],
    [
      "musette",
      0.04
    ],
    [
      "galoubet",
      0.04
    ],
    [
      "fluteau",
      0.04
    ],
    [
      "flageolet",
      0.04
    ],
    [
      "artifice",
      0.04
    ],
    [
      "appat",
      0.04
    ],
    [
      "appelant",
      0.04
    ],
    [
      "sifflet",
      0.04
    ]
  ],
  "saucer": [
    [
      "arroser",
      0.2
    ],
    [
      "asperger",
      0.2
    ],
    [
      "doucher",
      0.2
    ],
    [
      "mouiller",
      0.2
    ],
    [
      "tremper",
      0.2
    ]
  ],
  "sauce": [
    [
      "accompagnement",
      0.11
    ],
    [
      "assaisonnement",
      0.11
    ],
    [
      "averse",
      0.11
    ],
    [
      "dessin",
      0.11
    ],
    [
      "liaison",
      0.11
    ],
    [
      "pluie",
      0.11
    ],
    [
      "ragout",
      0.11
    ],
    [
      "saucee",
      0.11
    ],
    [
      "vinaigrette",
      0.11
    ]
  ],
  "piscine": [
    [
      "bassin",
      0.3325
    ],
    [
      "bain",
      0.22
    ],
    [
      "baignoire",
      0.11
    ],
    [
      "reservoir",
      0.11
    ],
    [
      "thermes",
      0.11
    ]
  ],
  "buvant": [
    [
      "s'abreuver",
      0.15
    ],
    [
      "absorber",
      0.0475
    ],
    [
      "s'enivrer",
      0.045
    ],
    [
      "pomper",
      0.04
    ],
    [
      "pinter",
      0.03
    ],
    [
      "s'imbiber",
      0.025
    ],
    [
      "recevoir",
      0.025
    ],
    [
      "ingurgiter",
      0.025
    ],
    [
      "avaler",
      0.025
    ],
    [
      "picoler",
      0.0225
    ],
    [
      "prendre",
      0.0225
    ],
    [
      "sucer",
      0.015
    ],
    [
      "souffrir",
      0.015
    ],
    [
      "s'alcooliser",
      0.015
    ],
    [
      "humer",
      0.015
    ],
    [
      "essuyer",
      0.015
    ],
    [
      "entonner",
      0.015
    ],
    [
      "deguster",
      0.015
    ],
    [
      "chopiner",
      0.015
    ],
    [
      "aspirer",
      0.015
    ],
    [
      "siroter",
      0.0125
    ],
    [
      "siffler",
      0.0125
    ],
    [
      "s'ivrogner",
      0.0125
    ],
    [
      "s'impregner",
      0.0125
    ],
    [
      "licher",
      0.0125
    ],
    [
      "lamper",
      0.0125
    ],
    [
      "ivrogner",
      0.0125
    ],
    [
      "endurer",
      0.0125
    ],
    [
      "supporter",
      0.0075
    ],
    [
      "teter",
      0.0075
    ],
    [
      "vider",
      0.0075
    ],
    [
      "ecluser",
      0.0075
    ],
    [
      "eponger",
      0.0075
    ],
    [
      "arroser",
      0.0075
    ],
    [
      "biberonner",
      0.0075
    ],
    [
      "consommer",
      0.0075
    ],
    [
      "respirer",
      0.0075
    ],
    [
      "s'aviner",
      0.0075
    ],
    [
      "savourer",
      0.0025
    ],
    [
      "sabler",
      0.0025
    ],
    [
      "s'inonder",
      0.0025
    ],
    [
      "s'humecter",
      0.0025
    ],
    [
      "rincer",
      0.0025
    ],
    [
      "soiffer",
      0.0025
    ],
    [
      "tolerer",
      0.0025
    ],
    [
      "trinquer",
      0.0025
    ],
    [
      "riboter",
      0.0025
    ],
    [
      "renifler",
      0.0025
    ],
    [
      "abreuver",
      0.0025
    ],
    [
      "bidonner",
      0.0025
    ],
    [
      "boissonner",
      0.0025
    ],
    [
      "buvoter",
      0.0025
    ],
    [
      "depenser",
      0.0025
    ],
    [
      "fouetter",
      0.0025
    ],
    [
      "godailler",
      0.0025
    ],
    [
      "laper",
      0.0025
    ],
    [
      "lichailler",
      0.0025
    ],
    [
      "lipper",
      0.0025
    ],
    [
      "pictancher",
      0.0025
    ],
    [
      "picter",
      0.0025
    ],
    [
      "pictonner",
      0.0025
    ]
  ],
  "panacher": [
    [
      "barioler",
      0.25
    ],
    [
      "melanger",
      0.25
    ],
    [
      "chamarrer",
      0.125
    ],
    [
      "empanacher",
      0.125
    ],
    [
      "mitiger",
      0.125
    ],
    [
      "meler",
      0.125
    ]
  ],
  "panache": [
    [
      "barioler",
      0.25
    ],
    [
      "melanger",
      0.25
    ],
    [
      "chamarrer",
      0.125
    ],
    [
      "empanacher",
      0.125
    ],
    [
      "mitiger",
      0.125
    ],
    [
      "meler",
      0.125
    ]
  ],
  "pervers": [
    [
      "mauvais",
      0.1625
    ],
    [
      "mechant",
      0.0875
    ],
    [
      "diabolique",
      0.0625
    ],
    [
      "pernicieux",
      0.0625
    ],
    [
      "vicieux",
      0.0625
    ],
    [
      "morbide",
      0.05
    ],
    [
      "malfaisant",
      0.05
    ],
    [
      "deprave",
      0.05
    ],
    [
      "debauche",
      0.05
    ],
    [
      "corrompu",
      0.0375
    ],
    [
      "malsain",
      0.0375
    ],
    [
      "satanique",
      0.025
    ],
    [
      "sadique",
      0.025
    ],
    [
      "malveillant",
      0.025
    ],
    [
      "malin",
      0.025
    ],
    [
      "haineux",
      0.025
    ],
    [
      "demoniaque",
      0.025
    ],
    [
      "putride",
      0.0125
    ],
    [
      "obsede",
      0.0125
    ],
    [
      "maniaque",
      0.0125
    ],
    [
      "infernal",
      0.0125
    ],
    [
      "fou",
      0.0125
    ],
    [
      "devoye",
      0.0125
    ],
    [
      "denature",
      0.0125
    ],
    [
      "cochon",
      0.0125
    ],
    [
      "antisocial",
      0.0125
    ],
    [
      "satyre",
      0.0125
    ]
  ],
  "dignite": [
    [
      "honneur",
      0.0925
    ],
    [
      "tenue",
      0.0675
    ],
    [
      "honnetete",
      0.0525
    ],
    [
      "fonction",
      0.0525
    ],
    [
      "fierte",
      0.0525
    ],
    [
      "distinction",
      0.0525
    ],
    [
      "elevation",
      0.04
    ],
    [
      "titre",
      0.04
    ],
    [
      "reserve",
      0.04
    ],
    [
      "rang",
      0.04
    ],
    [
      "noblesse",
      0.04
    ],
    [
      "gravite",
      0.04
    ],
    [
      "grandeur",
      0.04
    ],
    [
      "grade",
      0.04
    ],
    [
      "decence",
      0.04
    ],
    [
      "charge",
      0.04
    ],
    [
      "retenue",
      0.025
    ],
    [
      "promotion",
      0.025
    ],
    [
      "place",
      0.025
    ],
    [
      "honorabilite",
      0.025
    ],
    [
      "sacerdoce",
      0.0125
    ],
    [
      "respectabilite",
      0.0125
    ],
    [
      "preeminence",
      0.0125
    ],
    [
      "majeste",
      0.0125
    ],
    [
      "investiture",
      0.0125
    ],
    [
      "caractere",
      0.0125
    ],
    [
      "serieux",
      0.0125
    ]
  ],
  "hypnotiser": [
    [
      "fasciner",
      0.19
    ],
    [
      "seduire",
      0.19
    ],
    [
      "charmer",
      0.095
    ],
    [
      "tenter",
      0.095
    ],
    [
      "obseder",
      0.0475
    ],
    [
      "obnubiler",
      0.0475
    ],
    [
      "magnetiser",
      0.0475
    ],
    [
      "envouter",
      0.0475
    ],
    [
      "ensorceler",
      0.0475
    ],
    [
      "endormir",
      0.0475
    ],
    [
      "effrayer",
      0.0475
    ],
    [
      "captiver",
      0.0475
    ],
    [
      "eblouir",
      0.0475
    ]
  ],
  "cale": [
    [
      "fixer",
      0.0875
    ],
    [
      "maintenir",
      0.0775
    ],
    [
      "abandonner",
      0.0625
    ],
    [
      "assurer",
      0.0625
    ],
    [
      "ceder",
      0.055
    ],
    [
      "coincer",
      0.0475
    ],
    [
      "bloquer",
      0.0475
    ],
    [
      "arrimer",
      0.0475
    ],
    [
      "arreter",
      0.0375
    ],
    [
      "assujettir",
      0.0375
    ],
    [
      "immobiliser",
      0.0375
    ],
    [
      "rompre",
      0.0375
    ],
    [
      "soutenir",
      0.0375
    ],
    [
      "reculer",
      0.0225
    ],
    [
      "raffermir",
      0.0225
    ],
    [
      "flechir",
      0.0225
    ],
    [
      "appuyer",
      0.0225
    ],
    [
      "etayer",
      0.015
    ],
    [
      "stabiliser",
      0.015
    ],
    [
      "serrer",
      0.015
    ],
    [
      "s'incliner",
      0.015
    ],
    [
      "renoncer",
      0.015
    ],
    [
      "rabattre",
      0.015
    ],
    [
      "flancher",
      0.015
    ],
    [
      "enfoncer",
      0.015
    ],
    [
      "capituler",
      0.015
    ],
    [
      "caner",
      0.015
    ],
    [
      "baisser",
      0.015
    ],
    [
      "ajuster",
      0.0075
    ]
  ],
  "caler": [
    [
      "fixer",
      0.0875
    ],
    [
      "maintenir",
      0.0775
    ],
    [
      "abandonner",
      0.0625
    ],
    [
      "assurer",
      0.0625
    ],
    [
      "ceder",
      0.055
    ],
    [
      "coincer",
      0.0475
    ],
    [
      "bloquer",
      0.0475
    ],
    [
      "arrimer",
      0.0475
    ],
    [
      "arreter",
      0.0375
    ],
    [
      "assujettir",
      0.0375
    ],
    [
      "immobiliser",
      0.0375
    ],
    [
      "rompre",
      0.0375
    ],
    [
      "soutenir",
      0.0375
    ],
    [
      "reculer",
      0.0225
    ],
    [
      "raffermir",
      0.0225
    ],
    [
      "flechir",
      0.0225
    ],
    [
      "appuyer",
      0.0225
    ],
    [
      "etayer",
      0.015
    ],
    [
      "stabiliser",
      0.015
    ],
    [
      "serrer",
      0.015
    ],
    [
      "s'incliner",
      0.015
    ],
    [
      "renoncer",
      0.015
    ],
    [
      "rabattre",
      0.015
    ],
    [
      "flancher",
      0.015
    ],
    [
      "enfoncer",
      0.015
    ],
    [
      "capituler",
      0.015
    ],
    [
      "caner",
      0.015
    ],
    [
      "baisser",
      0.015
    ],
    [
      "ajuster",
      0.0075
    ]
  ],
  "etau": [
    [
      "cercle",
      0.3325
    ],
    [
      "presse",
      0.3325
    ],
    [
      "etreinte",
      0.3325
    ]
  ],
  "resserrer": [
    [
      "diminuer",
      0.09
    ],
    [
      "reduire",
      0.09
    ],
    [
      "serrer",
      0.065
    ],
    [
      "entourer",
      0.0575
    ],
    [
      "restreindre",
      0.0575
    ],
    [
      "contracter",
      0.0475
    ],
    [
      "retrecir",
      0.04
    ],
    [
      "tasser",
      0.0325
    ],
    [
      "presser",
      0.0325
    ],
    [
      "enfermer",
      0.0325
    ],
    [
      "comprimer",
      0.0325
    ],
    [
      "circonscrire",
      0.0325
    ],
    [
      "cerner",
      0.0325
    ],
    [
      "borner",
      0.0325
    ],
    [
      "ramasser",
      0.0225
    ],
    [
      "enserrer",
      0.0225
    ],
    [
      "encercler",
      0.0225
    ],
    [
      "condenser",
      0.0225
    ],
    [
      "etrecir",
      0.015
    ],
    [
      "etrangler",
      0.015
    ],
    [
      "resumer",
      0.015
    ],
    [
      "moderer",
      0.015
    ],
    [
      "encaisser",
      0.015
    ],
    [
      "delimiter",
      0.015
    ],
    [
      "amoindrir",
      0.015
    ],
    [
      "abreger",
      0.015
    ],
    [
      "refermer",
      0.0075
    ],
    [
      "rapprocher",
      0.0075
    ],
    [
      "ranger",
      0.0075
    ],
    [
      "raffermir",
      0.0075
    ],
    [
      "envelopper",
      0.0075
    ],
    [
      "crisper",
      0.0075
    ],
    [
      "constiper",
      0.0075
    ],
    [
      "consolider",
      0.0075
    ],
    [
      "cimenter",
      0.0075
    ],
    [
      "etriquer",
      0.0075
    ]
  ],
  "resserre": [
    [
      "abri",
      0.1725
    ],
    [
      "hangar",
      0.13
    ],
    [
      "magasin",
      0.13
    ],
    [
      "reserve",
      0.085
    ],
    [
      "remise",
      0.085
    ],
    [
      "grange",
      0.085
    ],
    [
      "entrepot",
      0.085
    ],
    [
      "depot",
      0.085
    ],
    [
      "bucher",
      0.0425
    ],
    [
      "depense",
      0.0425
    ],
    [
      "serre",
      0.0425
    ]
  ],
  "hesiter": [
    [
      "tergiverser",
      0.0925
    ],
    [
      "balancer",
      0.0675
    ],
    [
      "atermoyer",
      0.0575
    ],
    [
      "barguigner",
      0.0425
    ],
    [
      "osciller",
      0.0425
    ],
    [
      "flotter",
      0.0325
    ],
    [
      "tituber",
      0.025
    ],
    [
      "temporiser",
      0.025
    ],
    [
      "reculer",
      0.025
    ],
    [
      "marchander",
      0.025
    ],
    [
      "balbutier",
      0.025
    ],
    [
      "vaciller",
      0.015
    ],
    [
      "tortiller",
      0.015
    ],
    [
      "tatillonner",
      0.015
    ],
    [
      "errer",
      0.015
    ],
    [
      "deliberer",
      0.015
    ],
    [
      "attendre",
      0.015
    ],
    [
      "barboter",
      0.015
    ],
    [
      "chanceler",
      0.015
    ],
    [
      "chipoter",
      0.015
    ],
    [
      "douter",
      0.015
    ],
    [
      "anonner",
      0.0075
    ],
    [
      "tatonner",
      0.0075
    ],
    [
      "torpiller",
      0.0075
    ],
    [
      "broncher",
      0.0075
    ],
    [
      "begayer",
      0.0075
    ],
    [
      "consulter",
      0.0075
    ],
    [
      "feindre",
      0.0075
    ],
    [
      "lanterner",
      0.0075
    ],
    [
      "patauger",
      0.0075
    ],
    [
      "resister",
      0.0075
    ]
  ],
  "resister": [
    [
      "s'opposer",
      0.095
    ],
    [
      "protester",
      0.0525
    ],
    [
      "regimber",
      0.035
    ],
    [
      "lutter",
      0.035
    ],
    [
      "refuser",
      0.03
    ],
    [
      "combattre",
      0.025
    ],
    [
      "reagir",
      0.025
    ],
    [
      "s'insurger",
      0.025
    ],
    [
      "tenir",
      0.02
    ],
    [
      "affronter",
      0.02
    ],
    [
      "soutenir",
      0.015
    ],
    [
      "repondre",
      0.015
    ],
    [
      "recalcitrer",
      0.015
    ],
    [
      "contrarier",
      0.015
    ],
    [
      "contester",
      0.015
    ],
    [
      "supporter",
      0.01
    ],
    [
      "trainer",
      0.01
    ],
    [
      "s'obstiner",
      0.01
    ],
    [
      "defier",
      0.01
    ],
    [
      "rechigner",
      0.01
    ],
    [
      "renacler",
      0.01
    ],
    [
      "repousser",
      0.01
    ],
    [
      "rouspeter",
      0.01
    ],
    [
      "souffrir",
      0.0025
    ],
    [
      "subir",
      0.0025
    ],
    [
      "survivre",
      0.0025
    ],
    [
      "s'endurcir",
      0.0025
    ],
    [
      "contrecarrer",
      0.0025
    ],
    [
      "durer",
      0.0025
    ],
    [
      "desobeir",
      0.0025
    ],
    [
      "endurer",
      0.0025
    ],
    [
      "hesiter",
      0.0025
    ],
    [
      "s'empecher",
      0.0025
    ],
    [
      "eviter",
      0.0025
    ]
  ],
  "aveu": [
    [
      "confession",
      0.125
    ],
    [
      "declaration",
      0.125
    ],
    [
      "temoignage",
      0.0825
    ],
    [
      "revelation",
      0.0825
    ],
    [
      "confidence",
      0.0825
    ],
    [
      "approbation",
      0.0825
    ],
    [
      "reconnaissance",
      0.04
    ],
    [
      "permission",
      0.04
    ],
    [
      "peccavi",
      0.04
    ],
    [
      "hommage",
      0.04
    ],
    [
      "consentement",
      0.04
    ],
    [
      "autorisation",
      0.04
    ],
    [
      "agrement",
      0.04
    ],
    [
      "accord",
      0.04
    ],
    [
      "epanchement",
      0.04
    ]
  ],
  "mois": [
    [
      "retribution",
      0.22
    ],
    [
      "traitement",
      0.22
    ],
    [
      "appointements",
      0.11
    ],
    [
      "menstruation",
      0.11
    ],
    [
      "menstrues",
      0.11
    ],
    [
      "mensualite",
      0.11
    ],
    [
      "paie",
      0.11
    ]
  ],
  "facteur": [
    [
      "agent",
      0.1225
    ],
    [
      "cause",
      0.0725
    ],
    [
      "principe",
      0.0725
    ],
    [
      "element",
      0.0475
    ],
    [
      "rapport",
      0.0475
    ],
    [
      "porteur",
      0.0475
    ],
    [
      "messager",
      0.0475
    ],
    [
      "intermediaire",
      0.0475
    ],
    [
      "employe",
      0.0475
    ],
    [
      "auteur",
      0.0475
    ],
    [
      "luthier",
      0.0225
    ],
    [
      "mandataire",
      0.0225
    ],
    [
      "multiplicande",
      0.0225
    ],
    [
      "multiplicateur",
      0.0225
    ],
    [
      "prepose",
      0.0225
    ],
    [
      "quotient",
      0.0225
    ],
    [
      "intervention",
      0.0225
    ],
    [
      "fabricant",
      0.0225
    ],
    [
      "donnee",
      0.0225
    ],
    [
      "diviseur",
      0.0225
    ],
    [
      "commis",
      0.0225
    ],
    [
      "coefficient",
      0.0225
    ],
    [
      "boitier",
      0.0225
    ],
    [
      "assembleur",
      0.0225
    ],
    [
      "accordeur",
      0.0225
    ],
    [
      "telegraphiste",
      0.0225
    ]
  ],
  "carmin": [
    [
      "grenat",
      0.3325
    ],
    [
      "rouge",
      0.3325
    ],
    [
      "vermillon",
      0.3325
    ]
  ],
  "ya": [],
  "marguerite": [
    [
      "bague",
      0.165
    ],
    [
      "bout",
      0.165
    ],
    [
      "cordage",
      0.165
    ],
    [
      "diamant",
      0.165
    ],
    [
      "perle",
      0.165
    ],
    [
      "paquerette",
      0.165
    ]
  ],
  "ie": [],
  "i": [],
  "manuscrit": [
    [
      "copie",
      0.165
    ],
    [
      "papier",
      0.165
    ],
    [
      "texte",
      0.165
    ],
    [
      "ecrit",
      0.165
    ],
    [
      "brouillon",
      0.0825
    ],
    [
      "livre",
      0.0825
    ],
    [
      "original",
      0.0825
    ],
    [
      "papyrus",
      0.0825
    ]
  ],
  "orthographe": [
    [
      "graphie",
      0.5
    ],
    [
      "ecriture",
      0.5
    ]
  ],
  "dyslexie": [
    [
      "alexie",
      1.0
    ]
  ],
  "paraphe": [
    [
      "signature",
      0.3325
    ],
    [
      "marque",
      0.22
    ],
    [
      "apostille",
      0.11
    ],
    [
      "griffe",
      0.11
    ],
    [
      "seing",
      0.11
    ],
    [
      "visa",
      0.11
    ]
  ],
  "parapher": [
    [
      "signer",
      1.0
    ]
  ],
  "sexy": [
    [
      "affriolant",
      0.165
    ],
    [
      "baisant",
      0.165
    ],
    [
      "libidineux",
      0.165
    ],
    [
      "sensuel",
      0.165
    ],
    [
      "seduisant",
      0.165
    ],
    [
      "erotique",
      0.165
    ]
  ],
  "nonne": [
    [
      "religieuse",
      0.3325
    ],
    [
      "soeur",
      0.3025
    ],
    [
      "nonnette",
      0.03
    ],
    [
      "nonnain",
      0.03
    ],
    [
      "mere",
      0.03
    ],
    [
      "moniale",
      0.03
    ],
    [
      "moinesse",
      0.03
    ],
    [
      "fille",
      0.03
    ],
    [
      "dame",
      0.03
    ],
    [
      "congreganiste",
      0.03
    ],
    [
      "carmelite",
      0.03
    ],
    [
      "beguine",
      0.03
    ],
    [
      "novice",
      0.03
    ]
  ],
  "dimanche": [],
  "falaise": [
    [
      "hauteur",
      0.2
    ],
    [
      "belvedere",
      0.1
    ],
    [
      "cote",
      0.1
    ],
    [
      "escarpement",
      0.1
    ],
    [
      "mur",
      0.1
    ],
    [
      "muraille",
      0.1
    ],
    [
      "paroi",
      0.1
    ],
    [
      "promontoire",
      0.1
    ]
  ],
  "hypothese": [
    [
      "principe",
      0.125
    ],
    [
      "supposition",
      0.0775
    ],
    [
      "theorie",
      0.0775
    ],
    [
      "axiome",
      0.0625
    ],
    [
      "prevision",
      0.0625
    ],
    [
      "prejuge",
      0.045
    ],
    [
      "possibilite",
      0.045
    ],
    [
      "idee",
      0.045
    ],
    [
      "demonstration",
      0.045
    ],
    [
      "conjecture",
      0.045
    ],
    [
      "presomption",
      0.03
    ],
    [
      "premisse",
      0.03
    ],
    [
      "proposition",
      0.03
    ],
    [
      "probabilite",
      0.03
    ],
    [
      "postulat",
      0.03
    ],
    [
      "definition",
      0.03
    ],
    [
      "convention",
      0.03
    ],
    [
      "systeme",
      0.015
    ],
    [
      "supputation",
      0.015
    ],
    [
      "rencontre",
      0.015
    ],
    [
      "divination",
      0.015
    ],
    [
      "condition",
      0.015
    ],
    [
      "cas",
      0.015
    ],
    [
      "assomption",
      0.015
    ],
    [
      "eventualite",
      0.015
    ]
  ],
  "tact": [
    [
      "politesse",
      0.06
    ],
    [
      "bienseance",
      0.055
    ],
    [
      "decence",
      0.05
    ],
    [
      "delicatesse",
      0.05
    ],
    [
      "reserve",
      0.0375
    ],
    [
      "retenue",
      0.0375
    ],
    [
      "raison",
      0.0375
    ],
    [
      "convenance",
      0.0375
    ],
    [
      "usage",
      0.0325
    ],
    [
      "habilete",
      0.0325
    ],
    [
      "discretion",
      0.0325
    ],
    [
      "finesse",
      0.0275
    ],
    [
      "sagesse",
      0.0275
    ],
    [
      "sens",
      0.0275
    ],
    [
      "elegance",
      0.0275
    ],
    [
      "education",
      0.02
    ],
    [
      "tenue",
      0.02
    ],
    [
      "moderation",
      0.02
    ],
    [
      "doigte",
      0.02
    ],
    [
      "adresse",
      0.02
    ],
    [
      "sensibilite",
      0.015
    ],
    [
      "pudeur",
      0.015
    ],
    [
      "jugement",
      0.015
    ],
    [
      "entregent",
      0.015
    ],
    [
      "civilite",
      0.015
    ],
    [
      "egards",
      0.01
    ],
    [
      "toucher",
      0.01
    ],
    [
      "intuition",
      0.01
    ],
    [
      "diplomatie",
      0.01
    ],
    [
      "consideration",
      0.01
    ],
    [
      "philosophie",
      0.005
    ],
    [
      "manieres",
      0.005
    ],
    [
      "formes",
      0.005
    ],
    [
      "contact",
      0.005
    ],
    [
      "attouchement",
      0.005
    ],
    [
      "acquis",
      0.005
    ],
    [
      "sobriete",
      0.005
    ]
  ],
  "ebat": [
    [
      "cabriole",
      0.165
    ],
    [
      "caresse",
      0.165
    ],
    [
      "gambade",
      0.165
    ],
    [
      "jeu",
      0.165
    ],
    [
      "ebattement",
      0.165
    ]
  ],
  "enjeu": [
    [
      "mise",
      0.4
    ],
    [
      "cave",
      0.2
    ],
    [
      "pari",
      0.2
    ],
    [
      "poule",
      0.2
    ]
  ],
  "assommer": [
    [
      "fatiguer",
      0.15
    ],
    [
      "ennuyer",
      0.0875
    ],
    [
      "raser",
      0.0575
    ],
    [
      "abattre",
      0.0475
    ],
    [
      "etourdir",
      0.04
    ],
    [
      "empoisonner",
      0.04
    ],
    [
      "barber",
      0.04
    ],
    [
      "aneantir",
      0.04
    ],
    [
      "accabler",
      0.04
    ],
    [
      "tanner",
      0.035
    ],
    [
      "bassiner",
      0.035
    ],
    [
      "battre",
      0.0275
    ],
    [
      "embeter",
      0.0275
    ],
    [
      "tuer",
      0.0275
    ],
    [
      "assassiner",
      0.0225
    ],
    [
      "endormir",
      0.0225
    ],
    [
      "exceder",
      0.0225
    ],
    [
      "lasser",
      0.0175
    ],
    [
      "importuner",
      0.0175
    ],
    [
      "frapper",
      0.0175
    ],
    [
      "abasourdir",
      0.0125
    ],
    [
      "canuler",
      0.0125
    ],
    [
      "etonner",
      0.0125
    ],
    [
      "sonner",
      0.0075
    ],
    [
      "paralyser",
      0.0075
    ],
    [
      "estourbir",
      0.0075
    ],
    [
      "confondre",
      0.0075
    ],
    [
      "anesthesier",
      0.0075
    ],
    [
      "achever",
      0.0075
    ],
    [
      "abrutir",
      0.0075
    ],
    [
      "exasperer",
      0.0025
    ],
    [
      "escagasser",
      0.0025
    ],
    [
      "emmerder",
      0.0025
    ],
    [
      "deprimer",
      0.0025
    ],
    [
      "blesser",
      0.0025
    ],
    [
      "barbifier",
      0.0025
    ],
    [
      "matraquer",
      0.0025
    ]
  ],
  "poste": [
    [
      "charge",
      0.105
    ],
    [
      "fonction",
      0.105
    ],
    [
      "emploi",
      0.065
    ],
    [
      "place",
      0.065
    ],
    [
      "mission",
      0.0525
    ],
    [
      "position",
      0.0525
    ],
    [
      "etape",
      0.04
    ],
    [
      "situation",
      0.04
    ],
    [
      "office",
      0.04
    ],
    [
      "travail",
      0.025
    ],
    [
      "station",
      0.025
    ],
    [
      "messagerie",
      0.025
    ],
    [
      "lieu",
      0.025
    ],
    [
      "courrier",
      0.025
    ],
    [
      "chasse",
      0.025
    ],
    [
      "observatoire",
      0.0125
    ],
    [
      "preside",
      0.0125
    ],
    [
      "radio",
      0.0125
    ],
    [
      "relais",
      0.0125
    ],
    [
      "responsabilite",
      0.0125
    ],
    [
      "recepteur",
      0.0125
    ],
    [
      "sacerdoce",
      0.0125
    ],
    [
      "transport",
      0.0125
    ],
    [
      "mandat",
      0.0125
    ],
    [
      "honneur",
      0.0125
    ],
    [
      "guerite",
      0.0125
    ],
    [
      "P.T.T.",
      0.0125
    ],
    [
      "affectation",
      0.0125
    ],
    [
      "affut",
      0.0125
    ],
    [
      "appareil",
      0.0125
    ],
    [
      "auberge",
      0.0125
    ],
    [
      "cabine",
      0.0125
    ],
    [
      "coche",
      0.0125
    ],
    [
      "vigie",
      0.0125
    ]
  ],
  "surplomber": [
    [
      "dominer",
      0.285
    ],
    [
      "depasser",
      0.1425
    ],
    [
      "surmonter",
      0.1425
    ],
    [
      "avancer",
      0.07
    ],
    [
      "couronner",
      0.07
    ],
    [
      "culminer",
      0.07
    ],
    [
      "deborder",
      0.07
    ],
    [
      "saillir",
      0.07
    ],
    [
      "voir",
      0.07
    ]
  ],
  "reconnu": [
    [
      "decouvrir",
      0.05
    ],
    [
      "admettre",
      0.045
    ],
    [
      "avouer",
      0.045
    ],
    [
      "confesser",
      0.045
    ],
    [
      "discerner",
      0.045
    ],
    [
      "juger",
      0.0375
    ],
    [
      "constater",
      0.0375
    ],
    [
      "accorder",
      0.0325
    ],
    [
      "examiner",
      0.0325
    ],
    [
      "reveler",
      0.0325
    ],
    [
      "eprouver",
      0.0325
    ],
    [
      "trouver",
      0.0275
    ],
    [
      "sonder",
      0.0275
    ],
    [
      "declarer",
      0.0275
    ],
    [
      "distinguer",
      0.0275
    ],
    [
      "convenir",
      0.0275
    ],
    [
      "deviner",
      0.02
    ],
    [
      "verifier",
      0.02
    ],
    [
      "etablir",
      0.015
    ],
    [
      "tater",
      0.015
    ],
    [
      "retrouver",
      0.015
    ],
    [
      "remettre",
      0.015
    ],
    [
      "identifier",
      0.015
    ],
    [
      "explorer",
      0.015
    ],
    [
      "entendre",
      0.015
    ],
    [
      "attribuer",
      0.015
    ],
    [
      "recevoir",
      0.01
    ],
    [
      "nommer",
      0.01
    ],
    [
      "croire",
      0.01
    ],
    [
      "connaitre",
      0.01
    ],
    [
      "conceder",
      0.01
    ],
    [
      "certifier",
      0.01
    ],
    [
      "affirmer",
      0.01
    ],
    [
      "proclamer",
      0.0025
    ],
    [
      "prospecter",
      0.0025
    ],
    [
      "preter",
      0.0025
    ],
    [
      "recompenser",
      0.0025
    ],
    [
      "s'accuser",
      0.0025
    ],
    [
      "subsumer",
      0.0025
    ],
    [
      "visiter",
      0.0025
    ],
    [
      "legitimer",
      0.0025
    ],
    [
      "endosser",
      0.0025
    ],
    [
      "apparaitre",
      0.0025
    ],
    [
      "arraisonner",
      0.0025
    ],
    [
      "assurer",
      0.0025
    ],
    [
      "averer",
      0.0025
    ],
    [
      "battre",
      0.0025
    ],
    [
      "crediter",
      0.0025
    ],
    [
      "diagnostiquer",
      0.0025
    ],
    [
      "differencier",
      0.0025
    ],
    [
      "discriminer",
      0.0025
    ],
    [
      "eclairer",
      0.0025
    ]
  ],
  "saisir": [
    [
      "prendre",
      0.0825
    ],
    [
      "decouvrir",
      0.0525
    ],
    [
      "comprendre",
      0.04
    ],
    [
      "apercevoir",
      0.0375
    ],
    [
      "penetrer",
      0.0375
    ],
    [
      "voir",
      0.0325
    ],
    [
      "reperer",
      0.0325
    ],
    [
      "attraper",
      0.03
    ],
    [
      "percevoir",
      0.0225
    ],
    [
      "trouver",
      0.0225
    ],
    [
      "empoigner",
      0.0225
    ],
    [
      "atteindre",
      0.02
    ],
    [
      "piquer",
      0.02
    ],
    [
      "entendre",
      0.0175
    ],
    [
      "emouvoir",
      0.0175
    ],
    [
      "toucher",
      0.0175
    ],
    [
      "s'emparer",
      0.0175
    ],
    [
      "arreter",
      0.0175
    ],
    [
      "surprendre",
      0.015
    ],
    [
      "remarquer",
      0.015
    ],
    [
      "percer",
      0.015
    ],
    [
      "frapper",
      0.015
    ],
    [
      "accrocher",
      0.015
    ],
    [
      "bouleverser",
      0.0125
    ],
    [
      "deviner",
      0.0125
    ],
    [
      "deceler",
      0.0125
    ],
    [
      "apprehender",
      0.0125
    ],
    [
      "troubler",
      0.01
    ],
    [
      "retenir",
      0.01
    ],
    [
      "impressionner",
      0.01
    ],
    [
      "discerner",
      0.01
    ],
    [
      "concevoir",
      0.01
    ],
    [
      "pincer",
      0.01
    ],
    [
      "ramasser",
      0.01
    ],
    [
      "etonner",
      0.01
    ],
    [
      "reveler",
      0.0075
    ],
    [
      "capturer",
      0.0075
    ],
    [
      "captiver",
      0.0075
    ],
    [
      "epingler",
      0.005
    ],
    [
      "ebranler",
      0.005
    ],
    [
      "tenir",
      0.005
    ],
    [
      "secouer",
      0.005
    ],
    [
      "ravir",
      0.005
    ],
    [
      "executer",
      0.005
    ],
    [
      "dechiffrer",
      0.005
    ],
    [
      "cueillir",
      0.005
    ],
    [
      "realiser",
      0.005
    ],
    [
      "petrifier",
      0.005
    ],
    [
      "interpreter",
      0.005
    ],
    [
      "harponner",
      0.005
    ],
    [
      "agripper",
      0.005
    ],
    [
      "etreindre",
      0.0025
    ],
    [
      "transporter",
      0.0025
    ],
    [
      "supprimer",
      0.0025
    ],
    [
      "serrer",
      0.0025
    ],
    [
      "piger",
      0.0025
    ],
    [
      "occuper",
      0.0025
    ],
    [
      "interdire",
      0.0025
    ],
    [
      "happer",
      0.0025
    ],
    [
      "confisquer",
      0.0025
    ],
    [
      "agrafer",
      0.0025
    ],
    [
      "revolutionner",
      0.0025
    ],
    [
      "s'apercevoir",
      0.0025
    ],
    [
      "suffoquer",
      0.0025
    ],
    [
      "transir",
      0.0025
    ],
    [
      "usurper",
      0.0025
    ],
    [
      "etourdir",
      0.0025
    ],
    [
      "evoquer",
      0.0025
    ],
    [
      "retourner",
      0.0025
    ],
    [
      "prelever",
      0.0025
    ],
    [
      "apprecier",
      0.0025
    ],
    [
      "croquer",
      0.0025
    ],
    [
      "distinguer",
      0.0025
    ],
    [
      "gripper",
      0.0025
    ],
    [
      "impregner",
      0.0025
    ],
    [
      "intercepter",
      0.0025
    ],
    [
      "penser",
      0.0025
    ],
    [
      "solidifier",
      0.0
    ],
    [
      "requisitionner",
      0.0
    ],
    [
      "profiter",
      0.0
    ],
    [
      "pocher",
      0.0
    ],
    [
      "exproprier",
      0.0
    ],
    [
      "deferer",
      0.0
    ],
    [
      "colleter",
      0.0
    ],
    [
      "ceinturer",
      0.0
    ],
    [
      "camper",
      0.0
    ],
    [
      "aveindre",
      0.0
    ],
    [
      "assimiler",
      0.0
    ],
    [
      "electriser",
      0.0
    ]
  ],
  "saisi": [
    [
      "prendre",
      0.0825
    ],
    [
      "decouvrir",
      0.0525
    ],
    [
      "comprendre",
      0.04
    ],
    [
      "apercevoir",
      0.0375
    ],
    [
      "penetrer",
      0.0375
    ],
    [
      "voir",
      0.0325
    ],
    [
      "reperer",
      0.0325
    ],
    [
      "attraper",
      0.03
    ],
    [
      "percevoir",
      0.0225
    ],
    [
      "trouver",
      0.0225
    ],
    [
      "empoigner",
      0.0225
    ],
    [
      "atteindre",
      0.02
    ],
    [
      "piquer",
      0.02
    ],
    [
      "entendre",
      0.0175
    ],
    [
      "emouvoir",
      0.0175
    ],
    [
      "toucher",
      0.0175
    ],
    [
      "s'emparer",
      0.0175
    ],
    [
      "arreter",
      0.0175
    ],
    [
      "surprendre",
      0.015
    ],
    [
      "remarquer",
      0.015
    ],
    [
      "percer",
      0.015
    ],
    [
      "frapper",
      0.015
    ],
    [
      "accrocher",
      0.015
    ],
    [
      "bouleverser",
      0.0125
    ],
    [
      "deviner",
      0.0125
    ],
    [
      "deceler",
      0.0125
    ],
    [
      "apprehender",
      0.0125
    ],
    [
      "troubler",
      0.01
    ],
    [
      "retenir",
      0.01
    ],
    [
      "impressionner",
      0.01
    ],
    [
      "discerner",
      0.01
    ],
    [
      "concevoir",
      0.01
    ],
    [
      "pincer",
      0.01
    ],
    [
      "ramasser",
      0.01
    ],
    [
      "etonner",
      0.01
    ],
    [
      "reveler",
      0.0075
    ],
    [
      "capturer",
      0.0075
    ],
    [
      "captiver",
      0.0075
    ],
    [
      "epingler",
      0.005
    ],
    [
      "ebranler",
      0.005
    ],
    [
      "tenir",
      0.005
    ],
    [
      "secouer",
      0.005
    ],
    [
      "ravir",
      0.005
    ],
    [
      "executer",
      0.005
    ],
    [
      "dechiffrer",
      0.005
    ],
    [
      "cueillir",
      0.005
    ],
    [
      "realiser",
      0.005
    ],
    [
      "petrifier",
      0.005
    ],
    [
      "interpreter",
      0.005
    ],
    [
      "harponner",
      0.005
    ],
    [
      "agripper",
      0.005
    ],
    [
      "etreindre",
      0.0025
    ],
    [
      "transporter",
      0.0025
    ],
    [
      "supprimer",
      0.0025
    ],
    [
      "serrer",
      0.0025
    ],
    [
      "piger",
      0.0025
    ],
    [
      "occuper",
      0.0025
    ],
    [
      "interdire",
      0.0025
    ],
    [
      "happer",
      0.0025
    ],
    [
      "confisquer",
      0.0025
    ],
    [
      "agrafer",
      0.0025
    ],
    [
      "revolutionner",
      0.0025
    ],
    [
      "s'apercevoir",
      0.0025
    ],
    [
      "suffoquer",
      0.0025
    ],
    [
      "transir",
      0.0025
    ],
    [
      "usurper",
      0.0025
    ],
    [
      "etourdir",
      0.0025
    ],
    [
      "evoquer",
      0.0025
    ],
    [
      "retourner",
      0.0025
    ],
    [
      "prelever",
      0.0025
    ],
    [
      "apprecier",
      0.0025
    ],
    [
      "croquer",
      0.0025
    ],
    [
      "distinguer",
      0.0025
    ],
    [
      "gripper",
      0.0025
    ],
    [
      "impregner",
      0.0025
    ],
    [
      "intercepter",
      0.0025
    ],
    [
      "penser",
      0.0025
    ],
    [
      "solidifier",
      0.0
    ],
    [
      "requisitionner",
      0.0
    ],
    [
      "profiter",
      0.0
    ],
    [
      "pocher",
      0.0
    ],
    [
      "exproprier",
      0.0
    ],
    [
      "deferer",
      0.0
    ],
    [
      "colleter",
      0.0
    ],
    [
      "ceinturer",
      0.0
    ],
    [
      "camper",
      0.0
    ],
    [
      "aveindre",
      0.0
    ],
    [
      "assimiler",
      0.0
    ],
    [
      "electriser",
      0.0
    ]
  ],
  "ingenu": [
    [
      "candide",
      0.1625
    ],
    [
      "innocent",
      0.1375
    ],
    [
      "naif",
      0.115
    ],
    [
      "simple",
      0.115
    ],
    [
      "pur",
      0.0925
    ],
    [
      "bon",
      0.0675
    ],
    [
      "vrai",
      0.045
    ],
    [
      "niais",
      0.045
    ],
    [
      "inexperimente",
      0.045
    ],
    [
      "ignorant",
      0.045
    ],
    [
      "blanc",
      0.0225
    ],
    [
      "chaste",
      0.0225
    ],
    [
      "credule",
      0.0225
    ],
    [
      "franc",
      0.0225
    ],
    [
      "simplet",
      0.0225
    ]
  ],
  "profil": [
    [
      "silhouette",
      0.1325
    ],
    [
      "aspect",
      0.1
    ],
    [
      "contour",
      0.1
    ],
    [
      "perspective",
      0.1
    ],
    [
      "semblance",
      0.1
    ],
    [
      "visage",
      0.065
    ],
    [
      "tournure",
      0.065
    ],
    [
      "portrait",
      0.065
    ],
    [
      "ligne",
      0.065
    ],
    [
      "galbe",
      0.065
    ],
    [
      "figure",
      0.065
    ],
    [
      "lineament",
      0.0325
    ],
    [
      "section",
      0.0325
    ]
  ],
  "habitant": [
    [
      "homme",
      0.0825
    ],
    [
      "ressortissant",
      0.05
    ],
    [
      "population",
      0.05
    ],
    [
      "personne",
      0.05
    ],
    [
      "paysan",
      0.05
    ],
    [
      "citoyen",
      0.05
    ],
    [
      "type",
      0.0325
    ],
    [
      "naturel",
      0.0325
    ],
    [
      "nation",
      0.0325
    ],
    [
      "individu",
      0.0325
    ],
    [
      "gens",
      0.0325
    ],
    [
      "contadin",
      0.0325
    ],
    [
      "citadin",
      0.0325
    ],
    [
      "campagnard",
      0.0325
    ],
    [
      "insulaire",
      0.015
    ],
    [
      "montagnard",
      0.015
    ],
    [
      "natif",
      0.015
    ],
    [
      "occupant",
      0.015
    ],
    [
      "peuple",
      0.015
    ],
    [
      "peuplement",
      0.015
    ],
    [
      "residant",
      0.015
    ],
    [
      "resident",
      0.015
    ],
    [
      "sujet",
      0.015
    ],
    [
      "villageois",
      0.015
    ],
    [
      "indigene",
      0.015
    ],
    [
      "hote",
      0.015
    ],
    [
      "aborigene",
      0.015
    ],
    [
      "autochtone",
      0.015
    ],
    [
      "banlieusard",
      0.015
    ],
    [
      "bourgeois",
      0.015
    ],
    [
      "cultivateur",
      0.015
    ],
    [
      "demeurant",
      0.015
    ],
    [
      "demographie",
      0.015
    ],
    [
      "faubourien",
      0.015
    ],
    [
      "faune",
      0.015
    ],
    [
      "fermier",
      0.015
    ],
    [
      "ame",
      0.015
    ]
  ],
  "nombril": [
    [
      "centre",
      0.5
    ],
    [
      "ombilic",
      0.25
    ],
    [
      "sein",
      0.25
    ]
  ],
  "puiser": [
    [
      "tirer",
      0.2725
    ],
    [
      "emprunter",
      0.18
    ],
    [
      "baqueter",
      0.09
    ],
    [
      "degager",
      0.09
    ],
    [
      "glaner",
      0.09
    ],
    [
      "pomper",
      0.09
    ],
    [
      "prendre",
      0.09
    ],
    [
      "pucher",
      0.09
    ]
  ],
  "encre": [
    [
      "ponce",
      0.5
    ],
    [
      "sepia",
      0.5
    ]
  ],
  "encrer": [
    [
      "enduire",
      1.0
    ]
  ],
  "miennes": [],
  "dicter": [
    [
      "commander",
      0.185
    ],
    [
      "disposer",
      0.11
    ],
    [
      "inspirer",
      0.11
    ],
    [
      "ordonner",
      0.11
    ],
    [
      "provoquer",
      0.0725
    ],
    [
      "prescrire",
      0.0725
    ],
    [
      "imposer",
      0.0725
    ],
    [
      "decider",
      0.0725
    ],
    [
      "conditionner",
      0.035
    ],
    [
      "enjoindre",
      0.035
    ],
    [
      "regler",
      0.035
    ],
    [
      "souffler",
      0.035
    ],
    [
      "suggerer",
      0.035
    ]
  ],
  "cruche": [
    [
      "bete",
      0.1525
    ],
    [
      "ballot",
      0.125
    ],
    [
      "sot",
      0.1025
    ],
    [
      "ane",
      0.075
    ],
    [
      "stupide",
      0.0625
    ],
    [
      "beta",
      0.0625
    ],
    [
      "balourd",
      0.0625
    ],
    [
      "niais",
      0.055
    ],
    [
      "buse",
      0.0325
    ],
    [
      "cornichon",
      0.0325
    ],
    [
      "idiot",
      0.0275
    ],
    [
      "imbecile",
      0.0275
    ],
    [
      "lourdaud",
      0.0275
    ],
    [
      "cruchon",
      0.02
    ],
    [
      "butor",
      0.0125
    ],
    [
      "becasse",
      0.0125
    ],
    [
      "buche",
      0.0125
    ],
    [
      "dadais",
      0.0125
    ],
    [
      "pot",
      0.0125
    ],
    [
      "pichet",
      0.005
    ],
    [
      "jacqueline",
      0.005
    ],
    [
      "cruchee",
      0.005
    ],
    [
      "cruchette",
      0.005
    ],
    [
      "buire",
      0.005
    ],
    [
      "bue",
      0.005
    ],
    [
      "bouillotte",
      0.005
    ],
    [
      "vase",
      0.005
    ]
  ],
  "craqueler": [
    [
      "fendre",
      0.4
    ],
    [
      "casser",
      0.2
    ],
    [
      "crevasser",
      0.2
    ],
    [
      "gercer",
      0.2
    ]
  ],
  "craquele": [
    [
      "fendre",
      0.4
    ],
    [
      "casser",
      0.2
    ],
    [
      "crevasser",
      0.2
    ],
    [
      "gercer",
      0.2
    ]
  ],
  "dessecher": [
    [
      "secher",
      0.08
    ],
    [
      "epuiser",
      0.08
    ],
    [
      "bruler",
      0.06
    ],
    [
      "racornir",
      0.05
    ],
    [
      "assecher",
      0.05
    ],
    [
      "alterer",
      0.05
    ],
    [
      "appauvrir",
      0.04
    ],
    [
      "consumer",
      0.04
    ],
    [
      "griller",
      0.04
    ],
    [
      "tarir",
      0.03
    ],
    [
      "steriliser",
      0.03
    ],
    [
      "detruire",
      0.03
    ],
    [
      "bronzer",
      0.03
    ],
    [
      "boucaner",
      0.03
    ],
    [
      "etuver",
      0.0175
    ],
    [
      "vider",
      0.0175
    ],
    [
      "rotir",
      0.0175
    ],
    [
      "haler",
      0.0175
    ],
    [
      "gresiller",
      0.0175
    ],
    [
      "fletrir",
      0.0175
    ],
    [
      "extenuer",
      0.0175
    ],
    [
      "endurcir",
      0.0175
    ],
    [
      "amaigrir",
      0.0175
    ],
    [
      "assoiffer",
      0.0175
    ],
    [
      "calciner",
      0.0175
    ],
    [
      "drainer",
      0.0175
    ],
    [
      "deshydrater",
      0.0175
    ],
    [
      "devorer",
      0.0175
    ],
    [
      "scleroser",
      0.0075
    ],
    [
      "retrecir",
      0.0075
    ],
    [
      "momifier",
      0.0075
    ],
    [
      "faner",
      0.0075
    ],
    [
      "decharner",
      0.0075
    ],
    [
      "brouir",
      0.0075
    ],
    [
      "assainir",
      0.0075
    ],
    [
      "ebarouir",
      0.0075
    ]
  ],
  "liesse": [
    [
      "allegresse",
      0.165
    ],
    [
      "gaiete",
      0.165
    ],
    [
      "joie",
      0.165
    ],
    [
      "jubilation",
      0.165
    ],
    [
      "rejouissance",
      0.165
    ],
    [
      "bombance",
      0.0825
    ],
    [
      "exultation",
      0.0825
    ]
  ],
  "tordu": [
    [
      "deformer",
      0.09
    ],
    [
      "courber",
      0.065
    ],
    [
      "fausser",
      0.065
    ],
    [
      "gauchir",
      0.065
    ],
    [
      "tortiller",
      0.065
    ],
    [
      "tourner",
      0.065
    ],
    [
      "forcer",
      0.0525
    ],
    [
      "contourner",
      0.0375
    ],
    [
      "denaturer",
      0.0375
    ],
    [
      "tresser",
      0.025
    ],
    [
      "plier",
      0.025
    ],
    [
      "fouler",
      0.025
    ],
    [
      "detourner",
      0.025
    ],
    [
      "cintrer",
      0.025
    ],
    [
      "bistourner",
      0.025
    ],
    [
      "alterer",
      0.025
    ],
    [
      "manger",
      0.0125
    ],
    [
      "mouliner",
      0.0125
    ],
    [
      "ployer",
      0.0125
    ],
    [
      "retordre",
      0.0125
    ],
    [
      "tirebouchonner",
      0.0125
    ],
    [
      "torcher",
      0.0125
    ],
    [
      "torsader",
      0.0125
    ],
    [
      "tortillonner",
      0.0125
    ],
    [
      "mailler",
      0.0125
    ],
    [
      "luxer",
      0.0125
    ],
    [
      "filer",
      0.0125
    ],
    [
      "bouchonner",
      0.0125
    ],
    [
      "boudiner",
      0.0125
    ],
    [
      "coller",
      0.0125
    ],
    [
      "commettre",
      0.0125
    ],
    [
      "cordeler",
      0.0125
    ],
    [
      "cabler",
      0.0125
    ],
    [
      "distordre",
      0.0125
    ],
    [
      "entortiller",
      0.0125
    ],
    [
      "tourniller",
      0.0125
    ]
  ],
  "tiennes": [
    [
      "retenir",
      0.07
    ],
    [
      "contenir",
      0.035
    ],
    [
      "fixer",
      0.0325
    ],
    [
      "prendre",
      0.0325
    ],
    [
      "attacher",
      0.0325
    ],
    [
      "maintenir",
      0.025
    ],
    [
      "arreter",
      0.0225
    ],
    [
      "enchainer",
      0.02
    ],
    [
      "demeurer",
      0.02
    ],
    [
      "assujettir",
      0.02
    ],
    [
      "durer",
      0.0175
    ],
    [
      "observer",
      0.0175
    ],
    [
      "soutenir",
      0.0175
    ],
    [
      "occuper",
      0.015
    ],
    [
      "garder",
      0.015
    ],
    [
      "continuer",
      0.015
    ],
    [
      "avoir",
      0.0125
    ],
    [
      "embrasser",
      0.0125
    ],
    [
      "suivre",
      0.0125
    ],
    [
      "rester",
      0.0125
    ],
    [
      "mettre",
      0.0125
    ],
    [
      "immobiliser",
      0.0125
    ],
    [
      "faire",
      0.0125
    ],
    [
      "contraindre",
      0.0125
    ],
    [
      "appuyer",
      0.0125
    ],
    [
      "s'etendre",
      0.01
    ],
    [
      "posseder",
      0.01
    ],
    [
      "emprisonner",
      0.01
    ],
    [
      "coller",
      0.01
    ],
    [
      "brider",
      0.01
    ],
    [
      "trainer",
      0.0075
    ],
    [
      "pratiquer",
      0.0075
    ],
    [
      "porter",
      0.0075
    ],
    [
      "freiner",
      0.0075
    ],
    [
      "executer",
      0.0075
    ],
    [
      "engager",
      0.0075
    ],
    [
      "empecher",
      0.0075
    ],
    [
      "detenir",
      0.0075
    ],
    [
      "conserver",
      0.0075
    ],
    [
      "coincer",
      0.0075
    ],
    [
      "renfermer",
      0.0075
    ],
    [
      "perseverer",
      0.0075
    ],
    [
      "persister",
      0.0075
    ],
    [
      "endiguer",
      0.0075
    ],
    [
      "consigner",
      0.0075
    ],
    [
      "adherer",
      0.0075
    ],
    [
      "supporter",
      0.005
    ],
    [
      "subsister",
      0.005
    ],
    [
      "saisir",
      0.005
    ],
    [
      "s'attacher",
      0.005
    ],
    [
      "mener",
      0.005
    ],
    [
      "maitriser",
      0.005
    ],
    [
      "loger",
      0.005
    ],
    [
      "lier",
      0.005
    ],
    [
      "diriger",
      0.005
    ],
    [
      "recevoir",
      0.005
    ],
    [
      "remplir",
      0.005
    ],
    [
      "respecter",
      0.005
    ],
    [
      "resister",
      0.005
    ],
    [
      "moderer",
      0.005
    ],
    [
      "gouverner",
      0.005
    ],
    [
      "accomplir",
      0.005
    ],
    [
      "accrocher",
      0.005
    ],
    [
      "astreindre",
      0.005
    ],
    [
      "comprimer",
      0.005
    ],
    [
      "entrer",
      0.005
    ],
    [
      "venir",
      0.0025
    ],
    [
      "s'obstiner",
      0.0025
    ],
    [
      "resulter",
      0.0025
    ],
    [
      "ressortir",
      0.0025
    ],
    [
      "rendre",
      0.0025
    ],
    [
      "participer",
      0.0025
    ],
    [
      "manier",
      0.0025
    ],
    [
      "dependre",
      0.0025
    ],
    [
      "defendre",
      0.0025
    ],
    [
      "amarrer",
      0.0025
    ],
    [
      "absorber",
      0.0025
    ],
    [
      "resider",
      0.0025
    ],
    [
      "s'acquitter",
      0.0025
    ],
    [
      "s'etaler",
      0.0025
    ],
    [
      "satisfaire",
      0.0025
    ],
    [
      "surveiller",
      0.0025
    ],
    [
      "etreindre",
      0.0025
    ],
    [
      "ralentir",
      0.0025
    ],
    [
      "provenir",
      0.0025
    ],
    [
      "jouer",
      0.0025
    ],
    [
      "accaparer",
      0.0025
    ],
    [
      "administrer",
      0.0025
    ],
    [
      "clouer",
      0.0025
    ],
    [
      "comporter",
      0.0025
    ],
    [
      "discuter",
      0.0025
    ],
    [
      "exercer",
      0.0025
    ],
    [
      "jauger",
      0.0025
    ],
    [
      "s'etirer",
      0.0
    ],
    [
      "recouvrir",
      0.0
    ],
    [
      "naviguer",
      0.0
    ],
    [
      "gerer",
      0.0
    ],
    [
      "envisager",
      0.0
    ],
    [
      "effectuer",
      0.0
    ],
    [
      "deliberer",
      0.0
    ],
    [
      "appartenir",
      0.0
    ],
    [
      "agripper",
      0.0
    ]
  ],
  "miette": [
    [
      "morceau",
      0.18
    ],
    [
      "brin",
      0.1125
    ],
    [
      "fragment",
      0.1125
    ],
    [
      "parcelle",
      0.1125
    ],
    [
      "bribe",
      0.0675
    ],
    [
      "debris",
      0.0675
    ],
    [
      "peu",
      0.0675
    ],
    [
      "once",
      0.045
    ],
    [
      "brisure",
      0.045
    ],
    [
      "bout",
      0.045
    ],
    [
      "atome",
      0.045
    ],
    [
      "gramme",
      0.0225
    ],
    [
      "mie",
      0.0225
    ],
    [
      "piece",
      0.0225
    ],
    [
      "rognure",
      0.0225
    ]
  ],
  "ruche": [
    [
      "affluence",
      0.125
    ],
    [
      "agglomeration",
      0.125
    ],
    [
      "bande",
      0.125
    ],
    [
      "bouillon",
      0.125
    ],
    [
      "colonie",
      0.125
    ],
    [
      "fourmiliere",
      0.125
    ],
    [
      "nasse",
      0.125
    ],
    [
      "ruche",
      0.125
    ]
  ],
  "barrage": [
    [
      "barricade",
      0.11
    ],
    [
      "obstacle",
      0.11
    ],
    [
      "barriere",
      0.08
    ],
    [
      "digue",
      0.0675
    ],
    [
      "fermeture",
      0.0675
    ],
    [
      "ecluse",
      0.04
    ],
    [
      "resistance",
      0.04
    ],
    [
      "obstruction",
      0.04
    ],
    [
      "arret",
      0.04
    ],
    [
      "retenue",
      0.025
    ],
    [
      "levee",
      0.025
    ],
    [
      "jetee",
      0.025
    ],
    [
      "cloture",
      0.025
    ],
    [
      "blocage",
      0.025
    ],
    [
      "batardeau",
      0.025
    ],
    [
      "hausse",
      0.0125
    ],
    [
      "manifestation",
      0.0125
    ],
    [
      "opposition",
      0.0125
    ],
    [
      "pertuis",
      0.0125
    ],
    [
      "reservoir",
      0.0125
    ],
    [
      "vanne",
      0.0125
    ],
    [
      "fermette",
      0.0125
    ],
    [
      "estacade",
      0.0125
    ],
    [
      "defense",
      0.0125
    ],
    [
      "duit",
      0.0125
    ],
    [
      "cordon",
      0.0125
    ],
    [
      "champ",
      0.0125
    ],
    [
      "centrale",
      0.0125
    ],
    [
      "bouchon",
      0.0125
    ],
    [
      "borne",
      0.0125
    ],
    [
      "bombardement",
      0.0125
    ],
    [
      "ecran",
      0.0125
    ]
  ],
  "dechainer": [
    [
      "exciter",
      0.1825
    ],
    [
      "enflammer",
      0.095
    ],
    [
      "animer",
      0.075
    ],
    [
      "provoquer",
      0.075
    ],
    [
      "soulever",
      0.075
    ],
    [
      "allumer",
      0.0475
    ],
    [
      "attiser",
      0.0475
    ],
    [
      "exalter",
      0.0475
    ],
    [
      "irriter",
      0.0375
    ],
    [
      "entrainer",
      0.0375
    ],
    [
      "galvaniser",
      0.0275
    ],
    [
      "susciter",
      0.0275
    ],
    [
      "surexciter",
      0.0175
    ],
    [
      "surchauffer",
      0.0175
    ],
    [
      "occasionner",
      0.0175
    ],
    [
      "inciter",
      0.0175
    ],
    [
      "desenchainer",
      0.0175
    ],
    [
      "declencher",
      0.0175
    ],
    [
      "armer",
      0.0175
    ],
    [
      "ameuter",
      0.0175
    ],
    [
      "liberer",
      0.0075
    ],
    [
      "fomenter",
      0.0075
    ],
    [
      "detacher",
      0.0075
    ],
    [
      "deferrer",
      0.0075
    ],
    [
      "debrider",
      0.0075
    ],
    [
      "souffler",
      0.0075
    ]
  ],
  "moto": [
    [
      "machine",
      0.25
    ],
    [
      "becane",
      0.125
    ],
    [
      "engin",
      0.125
    ],
    [
      "meule",
      0.125
    ],
    [
      "motocycle",
      0.125
    ],
    [
      "motocyclette",
      0.125
    ],
    [
      "motocyclisme",
      0.125
    ]
  ],
  "liberer": [
    [
      "degager",
      0.1225
    ],
    [
      "debarrasser",
      0.0775
    ],
    [
      "decharger",
      0.0775
    ],
    [
      "delivrer",
      0.07
    ],
    [
      "affranchir",
      0.065
    ],
    [
      "dispenser",
      0.045
    ],
    [
      "defaire",
      0.0375
    ],
    [
      "delier",
      0.0375
    ],
    [
      "detacher",
      0.0375
    ],
    [
      "evacuer",
      0.025
    ],
    [
      "soulager",
      0.025
    ],
    [
      "quitter",
      0.025
    ],
    [
      "exonerer",
      0.025
    ],
    [
      "exempter",
      0.025
    ],
    [
      "eviter",
      0.0175
    ],
    [
      "epancher",
      0.0175
    ],
    [
      "soustraire",
      0.0175
    ],
    [
      "sortir",
      0.0175
    ],
    [
      "reveler",
      0.0175
    ],
    [
      "relaxer",
      0.0125
    ],
    [
      "nettoyer",
      0.0125
    ],
    [
      "deteler",
      0.0125
    ],
    [
      "desenchainer",
      0.0125
    ],
    [
      "depetrer",
      0.0125
    ],
    [
      "deblayer",
      0.0125
    ],
    [
      "acquitter",
      0.0125
    ],
    [
      "racheter",
      0.005
    ],
    [
      "relever",
      0.005
    ],
    [
      "relacher",
      0.005
    ],
    [
      "redimer",
      0.005
    ],
    [
      "trahir",
      0.005
    ],
    [
      "elargir",
      0.005
    ],
    [
      "desengager",
      0.005
    ],
    [
      "desencombrer",
      0.005
    ],
    [
      "demobiliser",
      0.005
    ],
    [
      "dechainer",
      0.005
    ],
    [
      "deceler",
      0.005
    ],
    [
      "deboucler",
      0.005
    ],
    [
      "debonder",
      0.005
    ],
    [
      "debloquer",
      0.005
    ],
    [
      "emanciper",
      0.005
    ]
  ],
  "arene": [
    [
      "carriere",
      0.16
    ],
    [
      "cirque",
      0.12
    ],
    [
      "enceinte",
      0.12
    ],
    [
      "lice",
      0.12
    ],
    [
      "amphitheatre",
      0.0775
    ],
    [
      "sable",
      0.0775
    ],
    [
      "sablon",
      0.0375
    ],
    [
      "hippodrome",
      0.0375
    ],
    [
      "gravier",
      0.0375
    ],
    [
      "course",
      0.0375
    ],
    [
      "champ",
      0.0375
    ],
    [
      "calcul",
      0.0375
    ],
    [
      "theatre",
      0.0375
    ]
  ],
  "eclair": [
    [
      "fulguration",
      0.11
    ],
    [
      "illumination",
      0.11
    ],
    [
      "lueur",
      0.11
    ],
    [
      "lumiere",
      0.11
    ],
    [
      "etincelle",
      0.11
    ],
    [
      "trait",
      0.055
    ],
    [
      "tonnerre",
      0.055
    ],
    [
      "revelation",
      0.055
    ],
    [
      "patisserie",
      0.055
    ],
    [
      "foudre",
      0.055
    ],
    [
      "flash",
      0.055
    ],
    [
      "flamme",
      0.055
    ],
    [
      "eclat",
      0.055
    ]
  ],
  "tonnerre": [
    [
      "foudre",
      0.2075
    ],
    [
      "fulguration",
      0.1225
    ],
    [
      "tempete",
      0.0825
    ],
    [
      "orage",
      0.0825
    ],
    [
      "grondement",
      0.0825
    ],
    [
      "fracas",
      0.0825
    ],
    [
      "feu",
      0.0825
    ],
    [
      "roulement",
      0.04
    ],
    [
      "eclair",
      0.04
    ],
    [
      "epart",
      0.04
    ]
  ],
  "contact": [
    [
      "liaison",
      0.0825
    ],
    [
      "frequentation",
      0.0675
    ],
    [
      "jonction",
      0.0675
    ],
    [
      "rencontre",
      0.0675
    ],
    [
      "reunion",
      0.05
    ],
    [
      "rapprochement",
      0.05
    ],
    [
      "rapport",
      0.05
    ],
    [
      "contiguite",
      0.05
    ],
    [
      "caresse",
      0.05
    ],
    [
      "approche",
      0.05
    ],
    [
      "relation",
      0.0325
    ],
    [
      "proximite",
      0.0325
    ],
    [
      "intimite",
      0.0325
    ],
    [
      "familiarite",
      0.0325
    ],
    [
      "attouchement",
      0.0325
    ],
    [
      "adherence",
      0.0325
    ],
    [
      "tact",
      0.015
    ],
    [
      "preliminaire",
      0.015
    ],
    [
      "joint",
      0.015
    ],
    [
      "influence",
      0.015
    ],
    [
      "heurt",
      0.015
    ],
    [
      "effleurement",
      0.015
    ],
    [
      "coudoiement",
      0.015
    ],
    [
      "communication",
      0.015
    ],
    [
      "branchement",
      0.015
    ],
    [
      "baiser",
      0.015
    ],
    [
      "allumage",
      0.015
    ],
    [
      "toucher",
      0.015
    ]
  ],
  "amer": [
    [
      "aigre",
      0.0875
    ],
    [
      "acerbe",
      0.07
    ],
    [
      "desagreable",
      0.0475
    ],
    [
      "mordant",
      0.04
    ],
    [
      "acrimonieux",
      0.0375
    ],
    [
      "dur",
      0.0375
    ],
    [
      "penible",
      0.0375
    ],
    [
      "vif",
      0.0375
    ],
    [
      "apre",
      0.035
    ],
    [
      "cruel",
      0.0325
    ],
    [
      "mauvais",
      0.0325
    ],
    [
      "acide",
      0.03
    ],
    [
      "piquant",
      0.0275
    ],
    [
      "mechant",
      0.025
    ],
    [
      "rude",
      0.025
    ],
    [
      "tendu",
      0.025
    ],
    [
      "hargneux",
      0.0225
    ],
    [
      "blessant",
      0.0225
    ],
    [
      "acariatre",
      0.02
    ],
    [
      "triste",
      0.02
    ],
    [
      "agressif",
      0.0175
    ],
    [
      "douloureux",
      0.0175
    ],
    [
      "acre",
      0.015
    ],
    [
      "cuisant",
      0.015
    ],
    [
      "caustique",
      0.015
    ],
    [
      "affligeant",
      0.015
    ],
    [
      "deplaisant",
      0.01
    ],
    [
      "irritant",
      0.0075
    ],
    [
      "maussade",
      0.0075
    ],
    [
      "severe",
      0.0075
    ],
    [
      "torturant",
      0.0075
    ],
    [
      "sarcastique",
      0.005
    ],
    [
      "morose",
      0.005
    ],
    [
      "fort",
      0.005
    ],
    [
      "fielleux",
      0.005
    ],
    [
      "decourageant",
      0.005
    ],
    [
      "ecoeurant",
      0.0025
    ],
    [
      "sombre",
      0.0025
    ],
    [
      "saumatre",
      0.0025
    ],
    [
      "offensant",
      0.0025
    ],
    [
      "melancolique",
      0.0025
    ],
    [
      "ingrat",
      0.0025
    ],
    [
      "attristant",
      0.0025
    ],
    [
      "ginguet",
      0.0
    ],
    [
      "grincant",
      0.0
    ],
    [
      "humiliant",
      0.0
    ],
    [
      "ironique",
      0.0
    ],
    [
      "marque",
      0.0
    ],
    [
      "repere",
      0.0
    ],
    [
      "solitaire",
      0.0
    ],
    [
      "fiel",
      0.0
    ],
    [
      "desolant",
      0.0
    ],
    [
      "aigri",
      0.0
    ],
    [
      "amarescent",
      0.0
    ],
    [
      "amaro",
      0.0
    ],
    [
      "amerin",
      0.0
    ],
    [
      "aperitif",
      0.0
    ],
    [
      "bile",
      0.0
    ],
    [
      "bitter",
      0.0
    ],
    [
      "decevant",
      0.0
    ],
    [
      "taciturne",
      0.0
    ]
  ],
  "reclamer": [
    [
      "demander",
      0.115
    ],
    [
      "requerir",
      0.085
    ],
    [
      "appeler",
      0.0625
    ],
    [
      "crier",
      0.0575
    ],
    [
      "exiger",
      0.0575
    ],
    [
      "revendiquer",
      0.0575
    ],
    [
      "protester",
      0.05
    ],
    [
      "solliciter",
      0.045
    ],
    [
      "vouloir",
      0.04
    ],
    [
      "prier",
      0.035
    ],
    [
      "souhaiter",
      0.0275
    ],
    [
      "implorer",
      0.0275
    ],
    [
      "commander",
      0.0275
    ],
    [
      "rouspeter",
      0.0225
    ],
    [
      "supplier",
      0.0225
    ],
    [
      "prescrire",
      0.015
    ],
    [
      "necessiter",
      0.015
    ],
    [
      "interpeller",
      0.015
    ],
    [
      "gemir",
      0.015
    ],
    [
      "recriminer",
      0.01
    ],
    [
      "raler",
      0.01
    ],
    [
      "recommander",
      0.01
    ],
    [
      "meriter",
      0.01
    ],
    [
      "contester",
      0.01
    ],
    [
      "queter",
      0.005
    ],
    [
      "redemander",
      0.005
    ],
    [
      "repeter",
      0.005
    ],
    [
      "s'insurger",
      0.005
    ],
    [
      "supposer",
      0.005
    ],
    [
      "quemander",
      0.005
    ],
    [
      "pretendre",
      0.005
    ],
    [
      "invoquer",
      0.005
    ],
    [
      "interceder",
      0.005
    ],
    [
      "bisser",
      0.005
    ],
    [
      "aimer",
      0.005
    ],
    [
      "aboyer",
      0.005
    ],
    [
      "tempeter",
      0.005
    ]
  ],
  "soldat": [
    [
      "cavalier",
      0.0425
    ],
    [
      "soudard",
      0.0425
    ],
    [
      "combattant",
      0.03
    ],
    [
      "defenseur",
      0.03
    ],
    [
      "fantassin",
      0.03
    ],
    [
      "sentinelle",
      0.0225
    ],
    [
      "partisan",
      0.0225
    ],
    [
      "homme",
      0.0225
    ],
    [
      "briscard",
      0.0225
    ],
    [
      "bidasse",
      0.0225
    ],
    [
      "zouave",
      0.015
    ],
    [
      "troufion",
      0.015
    ],
    [
      "poilu",
      0.015
    ],
    [
      "pierrot",
      0.015
    ],
    [
      "militaire",
      0.015
    ],
    [
      "guerrier",
      0.015
    ],
    [
      "garde",
      0.015
    ],
    [
      "bleu",
      0.015
    ],
    [
      "ordonnance",
      0.01
    ],
    [
      "pioupiou",
      0.01
    ],
    [
      "piquier",
      0.01
    ],
    [
      "planton",
      0.01
    ],
    [
      "recrue",
      0.01
    ],
    [
      "reitre",
      0.01
    ],
    [
      "spahi",
      0.01
    ],
    [
      "tourlourou",
      0.01
    ],
    [
      "troupier",
      0.01
    ],
    [
      "veteran",
      0.01
    ],
    [
      "mercenaire",
      0.01
    ],
    [
      "maquisard",
      0.01
    ],
    [
      "biffin",
      0.01
    ],
    [
      "bras",
      0.01
    ],
    [
      "champion",
      0.01
    ],
    [
      "conscrit",
      0.01
    ],
    [
      "engage",
      0.01
    ],
    [
      "factionnaire",
      0.01
    ],
    [
      "grenadier",
      0.01
    ],
    [
      "guerillero",
      0.01
    ],
    [
      "mamelouk",
      0.01
    ],
    [
      "parachutiste",
      0.005
    ],
    [
      "patrouilleur",
      0.005
    ],
    [
      "pertuisanier",
      0.005
    ],
    [
      "pionnier",
      0.005
    ],
    [
      "papalin",
      0.005
    ],
    [
      "pandour",
      0.005
    ],
    [
      "palikare",
      0.005
    ],
    [
      "mehariste",
      0.005
    ],
    [
      "marin",
      0.005
    ],
    [
      "legionnaire",
      0.005
    ],
    [
      "pourvoyeur",
      0.005
    ],
    [
      "requisitionnaire",
      0.005
    ],
    [
      "resistant",
      0.005
    ],
    [
      "tringlot",
      0.005
    ],
    [
      "tommy",
      0.005
    ],
    [
      "tireur",
      0.005
    ],
    [
      "tirailleur",
      0.005
    ],
    [
      "territorial",
      0.005
    ],
    [
      "spadassin",
      0.005
    ],
    [
      "soudrille",
      0.005
    ],
    [
      "soldatesque",
      0.005
    ],
    [
      "serviteur",
      0.005
    ],
    [
      "sapeur",
      0.005
    ],
    [
      "janissaire",
      0.005
    ],
    [
      "jalonneur",
      0.005
    ],
    [
      "conquerant",
      0.005
    ],
    [
      "cipaye",
      0.005
    ],
    [
      "carabinier",
      0.005
    ],
    [
      "brancardier",
      0.005
    ],
    [
      "bleusaille",
      0.005
    ],
    [
      "aviateur",
      0.005
    ],
    [
      "artilleur",
      0.005
    ],
    [
      "arquebusier",
      0.005
    ],
    [
      "archer",
      0.005
    ],
    [
      "arbaletrier",
      0.005
    ],
    [
      "drille",
      0.005
    ],
    [
      "demineur",
      0.005
    ],
    [
      "guide",
      0.005
    ],
    [
      "guetteur",
      0.005
    ],
    [
      "grognard",
      0.005
    ],
    [
      "griveton",
      0.005
    ],
    [
      "goumier",
      0.005
    ],
    [
      "gazier",
      0.005
    ],
    [
      "fusilier",
      0.005
    ],
    [
      "evzone",
      0.005
    ],
    [
      "estafette",
      0.005
    ],
    [
      "appele",
      0.005
    ]
  ],
  "confier": [
    [
      "donner",
      0.0975
    ],
    [
      "reveler",
      0.0975
    ],
    [
      "communiquer",
      0.08
    ],
    [
      "livrer",
      0.065
    ],
    [
      "decouvrir",
      0.065
    ],
    [
      "declarer",
      0.065
    ],
    [
      "dire",
      0.065
    ],
    [
      "remettre",
      0.0475
    ],
    [
      "signaler",
      0.0325
    ],
    [
      "laisser",
      0.0325
    ],
    [
      "deposer",
      0.0325
    ],
    [
      "deleguer",
      0.0325
    ],
    [
      "commettre",
      0.0325
    ],
    [
      "avouer",
      0.0325
    ],
    [
      "abandonner",
      0.0325
    ],
    [
      "souffler",
      0.015
    ],
    [
      "preter",
      0.015
    ],
    [
      "preposer",
      0.015
    ],
    [
      "mandater",
      0.015
    ],
    [
      "fier",
      0.015
    ],
    [
      "departir",
      0.015
    ],
    [
      "conferer",
      0.015
    ],
    [
      "confesser",
      0.015
    ],
    [
      "epancher",
      0.015
    ]
  ],
  "inavoue": [
    [
      "cache",
      0.3325
    ],
    [
      "obscur",
      0.3325
    ],
    [
      "secret",
      0.3325
    ]
  ],
  "pneu": [
    [
      "telegramme",
      0.2
    ],
    [
      "cable",
      0.15
    ],
    [
      "pneumatique",
      0.15
    ],
    [
      "bleu",
      0.1
    ],
    [
      "depeche",
      0.1
    ],
    [
      "expres",
      0.0475
    ],
    [
      "carte",
      0.0475
    ],
    [
      "boyau",
      0.0475
    ],
    [
      "boudin",
      0.0475
    ],
    [
      "bandage",
      0.0475
    ],
    [
      "tube",
      0.0475
    ]
  ],
  "economiser": [
    [
      "lesiner",
      0.105
    ],
    [
      "thesauriser",
      0.105
    ],
    [
      "epargner",
      0.0875
    ],
    [
      "liarder",
      0.07
    ],
    [
      "marchander",
      0.07
    ],
    [
      "plaindre",
      0.05
    ],
    [
      "menager",
      0.05
    ],
    [
      "garder",
      0.05
    ],
    [
      "entasser",
      0.05
    ],
    [
      "amasser",
      0.05
    ],
    [
      "reserver",
      0.0325
    ],
    [
      "regarder",
      0.0325
    ],
    [
      "reduire",
      0.015
    ],
    [
      "regretter",
      0.015
    ],
    [
      "regratter",
      0.015
    ],
    [
      "gratter",
      0.015
    ],
    [
      "gagner",
      0.015
    ],
    [
      "emmagasiner",
      0.015
    ],
    [
      "conserver",
      0.015
    ],
    [
      "boursicoter",
      0.015
    ],
    [
      "serrer",
      0.015
    ]
  ],
  "chaussette": [
    [
      "bas",
      0.25
    ],
    [
      "chausse",
      0.165
    ],
    [
      "chaussure",
      0.0825
    ],
    [
      "filtre",
      0.0825
    ],
    [
      "jarretiere",
      0.0825
    ],
    [
      "socquette",
      0.0825
    ]
  ],
  "bicher": [
    [
      "aller",
      0.2
    ],
    [
      "gazer",
      0.2
    ],
    [
      "marcher",
      0.2
    ],
    [
      "coller",
      0.1
    ],
    [
      "rouler",
      0.1
    ]
  ],
  "biche": [
    [
      "bichette",
      0.285
    ],
    [
      "bibiche",
      0.1425
    ],
    [
      "biquette",
      0.1425
    ],
    [
      "cerf",
      0.1425
    ]
  ],
  "empailler": [
    [
      "bourrer",
      0.25
    ],
    [
      "canner",
      0.25
    ],
    [
      "naturaliser",
      0.25
    ],
    [
      "rempailler",
      0.25
    ]
  ],
  "empaille": [
    [
      "bourrer",
      0.25
    ],
    [
      "canner",
      0.25
    ],
    [
      "naturaliser",
      0.25
    ],
    [
      "rempailler",
      0.25
    ]
  ],
  "alloc": [],
  "horoscope": [
    [
      "divination",
      0.25
    ],
    [
      "magie",
      0.165
    ],
    [
      "prediction",
      0.165
    ],
    [
      "astrologie",
      0.0825
    ],
    [
      "destin",
      0.0825
    ],
    [
      "genethliologie",
      0.0825
    ],
    [
      "sorcellerie",
      0.0825
    ]
  ],
  "nourrir": [
    [
      "alimenter",
      0.08
    ],
    [
      "entretenir",
      0.07
    ],
    [
      "preparer",
      0.0525
    ],
    [
      "cultiver",
      0.0425
    ],
    [
      "former",
      0.0425
    ],
    [
      "soigner",
      0.0425
    ],
    [
      "elever",
      0.0325
    ],
    [
      "eduquer",
      0.0325
    ],
    [
      "gorger",
      0.0325
    ],
    [
      "exciter",
      0.0325
    ],
    [
      "engraisser",
      0.0325
    ],
    [
      "soutenir",
      0.025
    ],
    [
      "restaurer",
      0.025
    ],
    [
      "repaitre",
      0.025
    ],
    [
      "instruire",
      0.025
    ],
    [
      "faconner",
      0.025
    ],
    [
      "concevoir",
      0.025
    ],
    [
      "choyer",
      0.025
    ],
    [
      "rassasier",
      0.015
    ],
    [
      "grossir",
      0.015
    ],
    [
      "gaver",
      0.015
    ],
    [
      "fomenter",
      0.015
    ],
    [
      "embecquer",
      0.015
    ],
    [
      "couver",
      0.015
    ],
    [
      "combiner",
      0.015
    ],
    [
      "caresser",
      0.015
    ],
    [
      "allaiter",
      0.015
    ],
    [
      "ravitailler",
      0.0075
    ],
    [
      "regaler",
      0.0075
    ],
    [
      "sustenter",
      0.0075
    ],
    [
      "tramer",
      0.0075
    ],
    [
      "vivifier",
      0.0075
    ],
    [
      "echafauder",
      0.0075
    ],
    [
      "petrir",
      0.0075
    ],
    [
      "paitre",
      0.0075
    ],
    [
      "ourdir",
      0.0075
    ],
    [
      "engaver",
      0.0075
    ],
    [
      "enfler",
      0.0075
    ],
    [
      "empater",
      0.0075
    ],
    [
      "approvisionner",
      0.0075
    ],
    [
      "amplifier",
      0.0075
    ],
    [
      "agrainer",
      0.0075
    ],
    [
      "abecquer",
      0.0075
    ],
    [
      "etoffer",
      0.0075
    ]
  ],
  "muscler": [
    [
      "renforcer",
      1.0
    ]
  ],
  "muscle": [
    [
      "renforcer",
      1.0
    ]
  ],
  "rameur": [
    [
      "nageur",
      1.0
    ]
  ],
  "achat": [
    [
      "acquisition",
      0.125
    ],
    [
      "corruption",
      0.125
    ],
    [
      "emplette",
      0.125
    ],
    [
      "soudoiement",
      0.0625
    ],
    [
      "marche",
      0.0625
    ],
    [
      "depravation",
      0.0625
    ],
    [
      "course",
      0.0625
    ],
    [
      "conquet",
      0.0625
    ],
    [
      "commerce",
      0.0625
    ],
    [
      "commande",
      0.0625
    ],
    [
      "adjudication",
      0.0625
    ],
    [
      "acquet",
      0.0625
    ],
    [
      "subornation",
      0.0625
    ]
  ],
  "borner": [
    [
      "limiter",
      0.13
    ],
    [
      "restreindre",
      0.0775
    ],
    [
      "arreter",
      0.0675
    ],
    [
      "circonscrire",
      0.0675
    ],
    [
      "entourer",
      0.0475
    ],
    [
      "renfermer",
      0.0475
    ],
    [
      "resserrer",
      0.0375
    ],
    [
      "fermer",
      0.0375
    ],
    [
      "delimiter",
      0.0375
    ],
    [
      "reduire",
      0.03
    ],
    [
      "moderer",
      0.03
    ],
    [
      "marquer",
      0.03
    ],
    [
      "contenir",
      0.03
    ],
    [
      "boucher",
      0.03
    ],
    [
      "barrer",
      0.03
    ],
    [
      "toucher",
      0.0175
    ],
    [
      "terminer",
      0.0175
    ],
    [
      "separer",
      0.0175
    ],
    [
      "retrecir",
      0.0175
    ],
    [
      "intercepter",
      0.0175
    ],
    [
      "cercler",
      0.0175
    ],
    [
      "border",
      0.0175
    ],
    [
      "reperer",
      0.0075
    ],
    [
      "piqueter",
      0.0075
    ],
    [
      "localiser",
      0.0075
    ],
    [
      "circonvenir",
      0.0075
    ],
    [
      "cadastrer",
      0.0075
    ],
    [
      "aborner",
      0.0075
    ],
    [
      "temperer",
      0.0075
    ]
  ],
  "borne": [
    [
      "limite",
      0.1325
    ],
    [
      "extremite",
      0.065
    ],
    [
      "terme",
      0.065
    ],
    [
      "separation",
      0.05
    ],
    [
      "obstacle",
      0.05
    ],
    [
      "frontiere",
      0.05
    ],
    [
      "barriere",
      0.05
    ],
    [
      "stele",
      0.0325
    ],
    [
      "mesure",
      0.0325
    ],
    [
      "marque",
      0.0325
    ],
    [
      "frein",
      0.0325
    ],
    [
      "fin",
      0.0325
    ],
    [
      "colonne",
      0.0325
    ],
    [
      "capacite",
      0.0325
    ],
    [
      "but",
      0.0325
    ],
    [
      "extreme",
      0.015
    ],
    [
      "jalon",
      0.015
    ],
    [
      "kilometre",
      0.015
    ],
    [
      "meta",
      0.015
    ],
    [
      "pierre",
      0.015
    ],
    [
      "pole",
      0.015
    ],
    [
      "confins",
      0.015
    ],
    [
      "canape",
      0.015
    ],
    [
      "canalisation",
      0.015
    ],
    [
      "cadre",
      0.015
    ],
    [
      "bouteroue",
      0.015
    ],
    [
      "bollard",
      0.015
    ],
    [
      "bitte",
      0.015
    ],
    [
      "barrage",
      0.015
    ],
    [
      "etendue",
      0.015
    ]
  ],
  "dedicace": [
    [
      "dedier",
      0.5
    ],
    [
      "inaugurer",
      0.5
    ]
  ],
  "dedicacer": [
    [
      "dedier",
      0.5
    ],
    [
      "inaugurer",
      0.5
    ]
  ],
  "cheque": [],
  "relancer": [
    [
      "poursuivre",
      0.1875
    ],
    [
      "chasser",
      0.125
    ],
    [
      "courir",
      0.125
    ],
    [
      "importuner",
      0.125
    ],
    [
      "renvoyer",
      0.0625
    ],
    [
      "rencherir",
      0.0625
    ],
    [
      "rejeter",
      0.0625
    ],
    [
      "obseder",
      0.0625
    ],
    [
      "harceler",
      0.0625
    ],
    [
      "assieger",
      0.0625
    ],
    [
      "tancer",
      0.0625
    ]
  ],
  "relance": [
    [
      "boom",
      0.5
    ]
  ],
  "cantine": [
    [
      "caisse",
      0.105
    ],
    [
      "cambuse",
      0.0775
    ],
    [
      "refectoire",
      0.0775
    ],
    [
      "restaurant",
      0.0525
    ],
    [
      "popote",
      0.0525
    ],
    [
      "mess",
      0.0525
    ],
    [
      "malle",
      0.0525
    ],
    [
      "cuisine",
      0.0525
    ],
    [
      "coffre",
      0.0525
    ],
    [
      "cabaret",
      0.0525
    ],
    [
      "buffet",
      0.0525
    ],
    [
      "ballot",
      0.0525
    ],
    [
      "bagage",
      0.0525
    ],
    [
      "portemanteau",
      0.025
    ],
    [
      "gamelle",
      0.025
    ],
    [
      "cantoche",
      0.025
    ],
    [
      "buvette",
      0.025
    ],
    [
      "barda",
      0.025
    ],
    [
      "balle",
      0.025
    ],
    [
      "roulante",
      0.025
    ]
  ],
  "gemeau": [
    [
      "jumeau",
      0.3075
    ],
    [
      "double",
      0.23
    ],
    [
      "sosie",
      0.1525
    ],
    [
      "besson",
      0.075
    ],
    [
      "doublon",
      0.075
    ],
    [
      "menechme",
      0.075
    ],
    [
      "pareil",
      0.075
    ]
  ],
  "feuilleton": [
    [
      "chronique",
      0.1525
    ],
    [
      "conte",
      0.1525
    ],
    [
      "nouvelle",
      0.1525
    ],
    [
      "roman",
      0.1525
    ],
    [
      "histoire",
      0.115
    ],
    [
      "rubrique",
      0.075
    ],
    [
      "anecdote",
      0.075
    ],
    [
      "article",
      0.0375
    ],
    [
      "dramatique",
      0.0375
    ],
    [
      "livraison",
      0.0375
    ]
  ],
  "clinique": [
    [
      "hopital",
      0.4275
    ],
    [
      "diagnostique",
      0.1425
    ],
    [
      "maison",
      0.1425
    ],
    [
      "polyclinique",
      0.1425
    ]
  ],
  "olivier": [],
  "cardiologue": [
    [
      "cardiographe",
      0.5
    ],
    [
      "medecin",
      0.5
    ]
  ],
  "garer": [
    [
      "ranger",
      0.2725
    ],
    [
      "abriter",
      0.18
    ],
    [
      "entreposer",
      0.09
    ],
    [
      "parquer",
      0.09
    ],
    [
      "preserver",
      0.09
    ],
    [
      "ramasser",
      0.09
    ],
    [
      "remiser",
      0.09
    ],
    [
      "stationner",
      0.09
    ]
  ],
  "transparent": [
    [
      "clair",
      0.155
    ],
    [
      "intelligible",
      0.1175
    ],
    [
      "limpide",
      0.0575
    ],
    [
      "net",
      0.0575
    ],
    [
      "comprehensible",
      0.05
    ],
    [
      "facile",
      0.0425
    ],
    [
      "translucide",
      0.0425
    ],
    [
      "visible",
      0.035
    ],
    [
      "lumineux",
      0.035
    ],
    [
      "diaphane",
      0.035
    ],
    [
      "distinct",
      0.0275
    ],
    [
      "leger",
      0.0275
    ],
    [
      "pur",
      0.0275
    ],
    [
      "simple",
      0.0275
    ],
    [
      "evident",
      0.02
    ],
    [
      "penetrable",
      0.02
    ],
    [
      "cristallin",
      0.02
    ],
    [
      "accessible",
      0.02
    ],
    [
      "concis",
      0.0125
    ],
    [
      "manifeste",
      0.0125
    ],
    [
      "precis",
      0.0125
    ],
    [
      "vitre",
      0.0125
    ],
    [
      "opalescent",
      0.005
    ],
    [
      "pellucide",
      0.005
    ],
    [
      "permeable",
      0.005
    ],
    [
      "tableau",
      0.005
    ],
    [
      "vaporeux",
      0.005
    ],
    [
      "mince",
      0.005
    ],
    [
      "liquide",
      0.005
    ],
    [
      "hyalin",
      0.005
    ],
    [
      "dechiffrable",
      0.005
    ],
    [
      "diapositive",
      0.005
    ],
    [
      "concevable",
      0.005
    ],
    [
      "vitreux",
      0.005
    ]
  ],
  "service": [
    [
      "aide",
      0.1175
    ],
    [
      "secours",
      0.0525
    ],
    [
      "soutien",
      0.045
    ],
    [
      "appui",
      0.0425
    ],
    [
      "faveur",
      0.03
    ],
    [
      "grace",
      0.0275
    ],
    [
      "protection",
      0.0225
    ],
    [
      "charge",
      0.0225
    ],
    [
      "bienfait",
      0.0225
    ],
    [
      "bien",
      0.0225
    ],
    [
      "soulagement",
      0.02
    ],
    [
      "soin",
      0.02
    ],
    [
      "office",
      0.02
    ],
    [
      "fonction",
      0.02
    ],
    [
      "devoir",
      0.02
    ],
    [
      "complaisance",
      0.02
    ],
    [
      "bureau",
      0.02
    ],
    [
      "assistance",
      0.0175
    ],
    [
      "travail",
      0.0125
    ],
    [
      "subvention",
      0.0125
    ],
    [
      "concours",
      0.0125
    ],
    [
      "charite",
      0.0125
    ],
    [
      "rescousse",
      0.01
    ],
    [
      "piece",
      0.01
    ],
    [
      "piston",
      0.01
    ],
    [
      "occupation",
      0.01
    ],
    [
      "intervention",
      0.01
    ],
    [
      "emploi",
      0.01
    ],
    [
      "benefice",
      0.01
    ],
    [
      "amitie",
      0.01
    ],
    [
      "patronage",
      0.0075
    ],
    [
      "pret",
      0.0075
    ],
    [
      "subside",
      0.0075
    ],
    [
      "usage",
      0.0075
    ],
    [
      "utilite",
      0.0075
    ],
    [
      "organisme",
      0.0075
    ],
    [
      "organisation",
      0.0075
    ],
    [
      "garde",
      0.0075
    ],
    [
      "administration",
      0.0075
    ],
    [
      "amabilite",
      0.0075
    ],
    [
      "corvee",
      0.0075
    ],
    [
      "disposition",
      0.0075
    ],
    [
      "encouragement",
      0.0075
    ],
    [
      "plaisir",
      0.005
    ],
    [
      "participation",
      0.005
    ],
    [
      "domestique",
      0.005
    ],
    [
      "direction",
      0.005
    ],
    [
      "cooperation",
      0.005
    ],
    [
      "contribution",
      0.005
    ],
    [
      "conseil",
      0.005
    ],
    [
      "plat",
      0.0025
    ],
    [
      "permanence",
      0.0025
    ],
    [
      "organe",
      0.0025
    ],
    [
      "obligeance",
      0.0025
    ],
    [
      "messe",
      0.0025
    ],
    [
      "pourboire",
      0.0025
    ],
    [
      "quart",
      0.0025
    ],
    [
      "renfort",
      0.0025
    ],
    [
      "regiment",
      0.0025
    ],
    [
      "secretariat",
      0.0025
    ],
    [
      "servante",
      0.0025
    ],
    [
      "serviteur",
      0.0025
    ],
    [
      "servitude",
      0.0025
    ],
    [
      "liturgie",
      0.0025
    ],
    [
      "funerailles",
      0.0025
    ],
    [
      "avance",
      0.0025
    ],
    [
      "culte",
      0.0025
    ],
    [
      "ceremonie",
      0.0025
    ],
    [
      "desserte",
      0.0025
    ],
    [
      "domesticite",
      0.0025
    ],
    [
      "depannage",
      0.0025
    ],
    [
      "departement",
      0.0025
    ],
    [
      "entraide",
      0.0025
    ],
    [
      "assortiment",
      0.0025
    ]
  ],
  "vanille": [],
  "pleurant": [
    [
      "larmoyant",
      0.3325
    ],
    [
      "pleurard",
      0.3325
    ],
    [
      "pleureur",
      0.3325
    ]
  ],
  "ficus": [],
  "calendrier": [
    [
      "agenda",
      0.165
    ],
    [
      "almanach",
      0.11
    ],
    [
      "tableau",
      0.055
    ],
    [
      "table",
      0.055
    ],
    [
      "saison",
      0.055
    ],
    [
      "programme",
      0.055
    ],
    [
      "planning",
      0.055
    ],
    [
      "ordo",
      0.055
    ],
    [
      "menologe",
      0.055
    ],
    [
      "martyrologe",
      0.055
    ],
    [
      "comput",
      0.055
    ],
    [
      "chronologie",
      0.055
    ],
    [
      "bref",
      0.055
    ],
    [
      "annuaire",
      0.055
    ],
    [
      "ephemerides",
      0.055
    ]
  ],
  "integrale": [
    [
      "complet",
      0.22
    ],
    [
      "entier",
      0.165
    ],
    [
      "total",
      0.165
    ],
    [
      "plein",
      0.11
    ],
    [
      "plenier",
      0.055
    ],
    [
      "integrant",
      0.055
    ],
    [
      "global",
      0.055
    ],
    [
      "absolu",
      0.055
    ],
    [
      "tout",
      0.055
    ]
  ],
  "ceinturer": [
    [
      "entourer",
      0.175
    ],
    [
      "enserrer",
      0.14
    ],
    [
      "ceindre",
      0.105
    ],
    [
      "encercler",
      0.105
    ],
    [
      "etreindre",
      0.0875
    ],
    [
      "enlacer",
      0.07
    ],
    [
      "cerner",
      0.0525
    ],
    [
      "embrasser",
      0.0525
    ],
    [
      "prendre",
      0.035
    ],
    [
      "envelopper",
      0.035
    ],
    [
      "enclore",
      0.035
    ],
    [
      "enceindre",
      0.035
    ],
    [
      "cercler",
      0.0175
    ],
    [
      "enrouler",
      0.0175
    ],
    [
      "fortifier",
      0.0175
    ],
    [
      "saisir",
      0.0175
    ]
  ],
  "ceinture": [
    [
      "bande",
      0.135
    ],
    [
      "tour",
      0.045
    ],
    [
      "entourage",
      0.045
    ],
    [
      "enceinte",
      0.045
    ],
    [
      "corset",
      0.045
    ],
    [
      "cordon",
      0.045
    ],
    [
      "cloture",
      0.045
    ],
    [
      "baudrier",
      0.045
    ],
    [
      "bandage",
      0.045
    ],
    [
      "encadrement",
      0.02
    ],
    [
      "frette",
      0.02
    ],
    [
      "gaine",
      0.02
    ],
    [
      "obi",
      0.02
    ],
    [
      "pourtour",
      0.02
    ],
    [
      "prise",
      0.02
    ],
    [
      "sangle",
      0.02
    ],
    [
      "soutien",
      0.02
    ],
    [
      "taille",
      0.02
    ],
    [
      "zone",
      0.02
    ],
    [
      "cordeliere",
      0.02
    ],
    [
      "ceste",
      0.02
    ],
    [
      "autour",
      0.02
    ],
    [
      "bandelette",
      0.02
    ],
    [
      "banlieue",
      0.02
    ],
    [
      "bassin",
      0.02
    ],
    [
      "bauquiere",
      0.02
    ],
    [
      "bretelle",
      0.02
    ],
    [
      "buffleterie",
      0.02
    ],
    [
      "ceintre",
      0.02
    ],
    [
      "ceinturon",
      0.02
    ],
    [
      "echarpe",
      0.02
    ]
  ],
  "cagnotte": [
    [
      "boite",
      0.1425
    ],
    [
      "caisse",
      0.1425
    ],
    [
      "bourse",
      0.105
    ],
    [
      "cassette",
      0.105
    ],
    [
      "tirelire",
      0.105
    ],
    [
      "economie",
      0.07
    ],
    [
      "tontine",
      0.07
    ],
    [
      "fonds",
      0.07
    ],
    [
      "coffret",
      0.07
    ],
    [
      "corbeille",
      0.035
    ],
    [
      "somme",
      0.035
    ]
  ],
  "cadeau": [
    [
      "don",
      0.2175
    ],
    [
      "gratification",
      0.125
    ],
    [
      "liberalite",
      0.09
    ],
    [
      "bienfait",
      0.055
    ],
    [
      "faveur",
      0.055
    ],
    [
      "present",
      0.045
    ],
    [
      "pourboire",
      0.045
    ],
    [
      "largesse",
      0.045
    ],
    [
      "gracieusete",
      0.045
    ],
    [
      "piece",
      0.0225
    ],
    [
      "offrande",
      0.0225
    ],
    [
      "donation",
      0.0225
    ],
    [
      "avantage",
      0.0225
    ],
    [
      "etrenne",
      0.01
    ],
    [
      "surprise",
      0.01
    ],
    [
      "souvenir",
      0.01
    ],
    [
      "remise",
      0.01
    ],
    [
      "prix",
      0.01
    ],
    [
      "gratis",
      0.01
    ],
    [
      "envoi",
      0.01
    ],
    [
      "dot",
      0.01
    ],
    [
      "donnee",
      0.01
    ],
    [
      "corbeille",
      0.01
    ],
    [
      "bouquet",
      0.01
    ],
    [
      "bakchich",
      0.01
    ],
    [
      "aide",
      0.01
    ],
    [
      "etrennes",
      0.01
    ]
  ],
  "compteur": [
    [
      "boulier",
      0.11
    ],
    [
      "calculateur",
      0.11
    ],
    [
      "detecteur",
      0.11
    ],
    [
      "enregistreur",
      0.11
    ],
    [
      "gazometre",
      0.11
    ],
    [
      "indicateur",
      0.11
    ],
    [
      "montre",
      0.11
    ],
    [
      "parcmetre",
      0.11
    ],
    [
      "taximetre",
      0.11
    ]
  ],
  "basse": [
    [
      "vil",
      0.0475
    ],
    [
      "abject",
      0.0475
    ],
    [
      "ignoble",
      0.0475
    ],
    [
      "infame",
      0.0375
    ],
    [
      "honteux",
      0.0325
    ],
    [
      "petit",
      0.0325
    ],
    [
      "impur",
      0.0325
    ],
    [
      "mediocre",
      0.03
    ],
    [
      "indigne",
      0.0275
    ],
    [
      "insignifiant",
      0.0275
    ],
    [
      "obscene",
      0.0275
    ],
    [
      "sordide",
      0.0275
    ],
    [
      "vulgaire",
      0.025
    ],
    [
      "degoutant",
      0.025
    ],
    [
      "commun",
      0.0225
    ],
    [
      "grossier",
      0.02
    ],
    [
      "immoral",
      0.02
    ],
    [
      "trivial",
      0.0175
    ],
    [
      "plat",
      0.0175
    ],
    [
      "ordinaire",
      0.0175
    ],
    [
      "mesquin",
      0.0175
    ],
    [
      "mauvais",
      0.0175
    ],
    [
      "base",
      0.015
    ],
    [
      "odieux",
      0.01
    ],
    [
      "malpropre",
      0.01
    ],
    [
      "laid",
      0.01
    ],
    [
      "avilissant",
      0.01
    ],
    [
      "vicieux",
      0.01
    ],
    [
      "inqualifiable",
      0.01
    ],
    [
      "inferieur",
      0.01
    ],
    [
      "infime",
      0.01
    ],
    [
      "humble",
      0.01
    ],
    [
      "faible",
      0.01
    ],
    [
      "deprave",
      0.01
    ],
    [
      "corrompu",
      0.01
    ],
    [
      "servile",
      0.0075
    ],
    [
      "meprisable",
      0.0075
    ],
    [
      "mechant",
      0.0075
    ],
    [
      "subalterne",
      0.005
    ],
    [
      "prosaique",
      0.005
    ],
    [
      "profond",
      0.005
    ],
    [
      "populacier",
      0.005
    ],
    [
      "licencieux",
      0.005
    ],
    [
      "innommable",
      0.005
    ],
    [
      "fondement",
      0.005
    ],
    [
      "crapuleux",
      0.005
    ],
    [
      "avili",
      0.005
    ],
    [
      "sombre",
      0.0025
    ],
    [
      "roturier",
      0.0025
    ],
    [
      "modique",
      0.0025
    ],
    [
      "minuscule",
      0.0025
    ],
    [
      "lache",
      0.0025
    ],
    [
      "grivois",
      0.0025
    ],
    [
      "grave",
      0.0025
    ],
    [
      "degradant",
      0.0025
    ],
    [
      "chaussette",
      0.0025
    ],
    [
      "baisse",
      0.0025
    ],
    [
      "assise",
      0.0025
    ],
    [
      "pornographique",
      0.0025
    ],
    [
      "rampant",
      0.0025
    ],
    [
      "salope",
      0.0025
    ],
    [
      "socle",
      0.0025
    ],
    [
      "soubassement",
      0.0025
    ],
    [
      "support",
      0.0025
    ],
    [
      "tombe",
      0.0025
    ],
    [
      "ecrase",
      0.0025
    ],
    [
      "populaire",
      0.0025
    ],
    [
      "poissard",
      0.0025
    ],
    [
      "bouche",
      0.0025
    ],
    [
      "boueux",
      0.0025
    ],
    [
      "brutal",
      0.0025
    ],
    [
      "chausse",
      0.0025
    ],
    [
      "fond",
      0.0025
    ],
    [
      "incline",
      0.0025
    ],
    [
      "libre",
      0.0025
    ],
    [
      "moindre",
      0.0025
    ],
    [
      "pied",
      0.0
    ],
    [
      "pendant",
      0.0
    ],
    [
      "nadir",
      0.0
    ],
    [
      "modere",
      0.0
    ],
    [
      "porno",
      0.0
    ],
    [
      "rabattu",
      0.0
    ],
    [
      "racine",
      0.0
    ],
    [
      "ravili",
      0.0
    ],
    [
      "tenebreux",
      0.0
    ],
    [
      "venal",
      0.0
    ],
    [
      "mal",
      0.0
    ],
    [
      "caverneux",
      0.0
    ],
    [
      "chaussure",
      0.0
    ],
    [
      "collant",
      0.0
    ],
    [
      "court",
      0.0
    ],
    [
      "dessous",
      0.0
    ],
    [
      "deferent",
      0.0
    ],
    [
      "embase",
      0.0
    ],
    [
      "enfonce",
      0.0
    ],
    [
      "fondation",
      0.0
    ],
    [
      "inaudible",
      0.0
    ],
    [
      "infamant",
      0.0
    ],
    [
      "bout",
      0.0
    ]
  ],
  "electrique": [
    [
      "surexcite",
      0.5
    ],
    [
      "survolte",
      0.5
    ]
  ],
  "jaillir": [
    [
      "sortir",
      0.115
    ],
    [
      "fuser",
      0.0825
    ],
    [
      "partir",
      0.0725
    ],
    [
      "sourdre",
      0.055
    ],
    [
      "s'elancer",
      0.055
    ],
    [
      "s'echapper",
      0.055
    ],
    [
      "gicler",
      0.04
    ],
    [
      "eclater",
      0.04
    ],
    [
      "emerger",
      0.04
    ],
    [
      "emaner",
      0.0325
    ],
    [
      "surgir",
      0.0325
    ],
    [
      "paraitre",
      0.0325
    ],
    [
      "couler",
      0.0325
    ],
    [
      "apparaitre",
      0.0225
    ],
    [
      "bondir",
      0.0225
    ],
    [
      "s'elever",
      0.0225
    ],
    [
      "saillir",
      0.015
    ],
    [
      "rejaillir",
      0.015
    ],
    [
      "pointer",
      0.015
    ],
    [
      "petiller",
      0.0075
    ],
    [
      "s'exhaler",
      0.0075
    ]
  ],
  "temperer": [
    [
      "moderer",
      0.145
    ],
    [
      "attenuer",
      0.105
    ],
    [
      "adoucir",
      0.09
    ],
    [
      "diminuer",
      0.0825
    ],
    [
      "eteindre",
      0.04
    ],
    [
      "affaiblir",
      0.035
    ],
    [
      "arreter",
      0.03
    ],
    [
      "amortir",
      0.025
    ],
    [
      "calmer",
      0.025
    ],
    [
      "mesurer",
      0.025
    ],
    [
      "emousser",
      0.0225
    ],
    [
      "edulcorer",
      0.0225
    ],
    [
      "freiner",
      0.0225
    ],
    [
      "estomper",
      0.0225
    ],
    [
      "contenir",
      0.0225
    ],
    [
      "affadir",
      0.0175
    ],
    [
      "apaiser",
      0.0175
    ],
    [
      "couper",
      0.0175
    ],
    [
      "mitiger",
      0.0175
    ],
    [
      "ralentir",
      0.0175
    ],
    [
      "regler",
      0.0125
    ],
    [
      "limiter",
      0.0125
    ],
    [
      "corriger",
      0.0125
    ],
    [
      "attiedir",
      0.0125
    ],
    [
      "tiedir",
      0.0075
    ],
    [
      "soulager",
      0.0075
    ],
    [
      "reprimer",
      0.0075
    ],
    [
      "rechauffer",
      0.0075
    ],
    [
      "relacher",
      0.0075
    ],
    [
      "pallier",
      0.0075
    ],
    [
      "nuancer",
      0.0075
    ],
    [
      "lenifier",
      0.0075
    ],
    [
      "assouplir",
      0.0075
    ],
    [
      "assagir",
      0.0075
    ],
    [
      "relativiser",
      0.0025
    ],
    [
      "rafraichir",
      0.0025
    ],
    [
      "normaliser",
      0.0025
    ],
    [
      "meler",
      0.0025
    ],
    [
      "chambrer",
      0.0025
    ],
    [
      "borner",
      0.0025
    ],
    [
      "tamiser",
      0.0025
    ]
  ],
  "vital": [
    [
      "essentiel",
      0.155
    ],
    [
      "primordial",
      0.1325
    ],
    [
      "principal",
      0.1325
    ],
    [
      "fondamental",
      0.11
    ],
    [
      "premier",
      0.0875
    ],
    [
      "important",
      0.0875
    ],
    [
      "capital",
      0.065
    ],
    [
      "indispensable",
      0.0425
    ],
    [
      "vivant",
      0.02
    ],
    [
      "substantiel",
      0.02
    ],
    [
      "profond",
      0.02
    ],
    [
      "maitre",
      0.02
    ],
    [
      "inevitable",
      0.02
    ],
    [
      "crucial",
      0.02
    ],
    [
      "biotique",
      0.02
    ],
    [
      "elementaire",
      0.02
    ]
  ],
  "quiproquo": [
    [
      "confusion",
      0.1425
    ],
    [
      "erreur",
      0.105
    ],
    [
      "imbroglio",
      0.105
    ],
    [
      "malentendu",
      0.105
    ],
    [
      "meprise",
      0.105
    ],
    [
      "betise",
      0.07
    ],
    [
      "bevue",
      0.07
    ],
    [
      "maldonne",
      0.035
    ],
    [
      "intrigue",
      0.035
    ],
    [
      "gaffe",
      0.035
    ],
    [
      "brouillamini",
      0.035
    ],
    [
      "equivoque",
      0.035
    ]
  ],
  "idealiste": [
    [
      "reveur",
      0.25
    ],
    [
      "chimerique",
      0.1875
    ],
    [
      "romantique",
      0.125
    ],
    [
      "speculatif",
      0.0625
    ],
    [
      "poete",
      0.0625
    ],
    [
      "platonique",
      0.0625
    ],
    [
      "platonicien",
      0.0625
    ],
    [
      "illumine",
      0.0625
    ],
    [
      "ideologue",
      0.0625
    ],
    [
      "utopique",
      0.0625
    ]
  ],
  "realiser": [
    [
      "faire",
      0.1
    ],
    [
      "accomplir",
      0.09
    ],
    [
      "executer",
      0.08
    ],
    [
      "pratiquer",
      0.0525
    ],
    [
      "voir",
      0.045
    ],
    [
      "saisir",
      0.035
    ],
    [
      "remplir",
      0.035
    ],
    [
      "penetrer",
      0.025
    ],
    [
      "proceder",
      0.025
    ],
    [
      "entendre",
      0.025
    ],
    [
      "effectuer",
      0.025
    ],
    [
      "creer",
      0.025
    ],
    [
      "consommer",
      0.025
    ],
    [
      "concevoir",
      0.025
    ],
    [
      "atteindre",
      0.025
    ],
    [
      "monter",
      0.0175
    ],
    [
      "operer",
      0.0175
    ],
    [
      "vendre",
      0.0175
    ],
    [
      "eprouver",
      0.0175
    ],
    [
      "materialiser",
      0.0175
    ],
    [
      "fabriquer",
      0.0175
    ],
    [
      "couronner",
      0.0175
    ],
    [
      "comprendre",
      0.0175
    ],
    [
      "commettre",
      0.0175
    ],
    [
      "appliquer",
      0.0175
    ],
    [
      "achever",
      0.0175
    ],
    [
      "liquider",
      0.0075
    ],
    [
      "personnifier",
      0.0075
    ],
    [
      "convertir",
      0.0075
    ],
    [
      "concretiser",
      0.0075
    ],
    [
      "combler",
      0.0075
    ],
    [
      "brader",
      0.0075
    ],
    [
      "agir",
      0.0075
    ],
    [
      "actualiser",
      0.0075
    ],
    [
      "accoucher",
      0.0075
    ],
    [
      "solder",
      0.0075
    ]
  ],
  "sagesse": [
    [
      "retenue",
      0.0925
    ],
    [
      "circonspection",
      0.0775
    ],
    [
      "reserve",
      0.065
    ],
    [
      "prudence",
      0.05
    ],
    [
      "raison",
      0.05
    ],
    [
      "ponderation",
      0.0425
    ],
    [
      "moderation",
      0.0425
    ],
    [
      "mesure",
      0.035
    ],
    [
      "sens",
      0.035
    ],
    [
      "tact",
      0.035
    ],
    [
      "sobriete",
      0.0275
    ],
    [
      "discretion",
      0.0275
    ],
    [
      "calme",
      0.0275
    ],
    [
      "vertu",
      0.02
    ],
    [
      "tenue",
      0.02
    ],
    [
      "pudeur",
      0.02
    ],
    [
      "gravite",
      0.02
    ],
    [
      "decence",
      0.02
    ],
    [
      "discernement",
      0.02
    ],
    [
      "connaissance",
      0.02
    ],
    [
      "usage",
      0.0125
    ],
    [
      "serenite",
      0.0125
    ],
    [
      "science",
      0.0125
    ],
    [
      "savoir",
      0.0125
    ],
    [
      "sapience",
      0.0125
    ],
    [
      "philosophie",
      0.0125
    ],
    [
      "humanisme",
      0.0125
    ],
    [
      "experience",
      0.0125
    ],
    [
      "continence",
      0.0125
    ],
    [
      "chastete",
      0.0125
    ],
    [
      "prud'homie",
      0.005
    ],
    [
      "prevoyance",
      0.005
    ],
    [
      "tranquillite",
      0.005
    ],
    [
      "politique",
      0.005
    ],
    [
      "paix",
      0.005
    ],
    [
      "obeissance",
      0.005
    ],
    [
      "maturite",
      0.005
    ],
    [
      "honnetete",
      0.005
    ],
    [
      "docilite",
      0.005
    ],
    [
      "verite",
      0.005
    ]
  ],
  "assurance": [
    [
      "courage",
      0.0625
    ],
    [
      "audace",
      0.055
    ],
    [
      "hardiesse",
      0.05
    ],
    [
      "garantie",
      0.0375
    ],
    [
      "fermete",
      0.0325
    ],
    [
      "aplomb",
      0.0325
    ],
    [
      "cran",
      0.0275
    ],
    [
      "temerite",
      0.025
    ],
    [
      "surete",
      0.025
    ],
    [
      "promesse",
      0.025
    ],
    [
      "decision",
      0.025
    ],
    [
      "confiance",
      0.025
    ],
    [
      "solidite",
      0.02
    ],
    [
      "gage",
      0.02
    ],
    [
      "culot",
      0.02
    ],
    [
      "conviction",
      0.02
    ],
    [
      "certitude",
      0.02
    ],
    [
      "affirmation",
      0.02
    ],
    [
      "toupet",
      0.015
    ],
    [
      "securite",
      0.015
    ],
    [
      "foi",
      0.015
    ],
    [
      "esperance",
      0.015
    ],
    [
      "cranerie",
      0.015
    ],
    [
      "confirmation",
      0.015
    ],
    [
      "caution",
      0.015
    ],
    [
      "caractere",
      0.015
    ],
    [
      "bravoure",
      0.015
    ],
    [
      "attestation",
      0.015
    ],
    [
      "abri",
      0.015
    ],
    [
      "tranquillite",
      0.0125
    ],
    [
      "preuve",
      0.0125
    ],
    [
      "parole",
      0.0125
    ],
    [
      "expression",
      0.0125
    ],
    [
      "engagement",
      0.0125
    ],
    [
      "declaration",
      0.0125
    ],
    [
      "certificat",
      0.0125
    ],
    [
      "calme",
      0.0125
    ],
    [
      "affermissement",
      0.0125
    ],
    [
      "sauvegarde",
      0.0075
    ],
    [
      "police",
      0.0075
    ],
    [
      "garant",
      0.0075
    ],
    [
      "contrat",
      0.0075
    ],
    [
      "contenance",
      0.0075
    ],
    [
      "ancrage",
      0.0075
    ],
    [
      "aisance",
      0.0075
    ],
    [
      "repos",
      0.0025
    ],
    [
      "quietude",
      0.0025
    ],
    [
      "protestation",
      0.0025
    ],
    [
      "persuasion",
      0.0025
    ],
    [
      "mutualite",
      0.0025
    ],
    [
      "espoir",
      0.0025
    ],
    [
      "corde",
      0.0025
    ],
    [
      "certification",
      0.0025
    ],
    [
      "assurement",
      0.0025
    ],
    [
      "assurage",
      0.0025
    ],
    [
      "aise",
      0.0025
    ],
    [
      "tete",
      0.0025
    ]
  ],
  "bonte": [
    [
      "bienveillance",
      0.0775
    ],
    [
      "amabilite",
      0.0575
    ],
    [
      "indulgence",
      0.0525
    ],
    [
      "grace",
      0.04
    ],
    [
      "gentillesse",
      0.04
    ],
    [
      "douceur",
      0.04
    ],
    [
      "generosite",
      0.035
    ],
    [
      "humanite",
      0.0325
    ],
    [
      "charite",
      0.0275
    ],
    [
      "facilite",
      0.0225
    ],
    [
      "complaisance",
      0.0225
    ],
    [
      "affabilite",
      0.0225
    ],
    [
      "amitie",
      0.02
    ],
    [
      "delicatesse",
      0.0175
    ],
    [
      "tendresse",
      0.0175
    ],
    [
      "bien",
      0.015
    ],
    [
      "bonhomie",
      0.015
    ],
    [
      "qualite",
      0.015
    ],
    [
      "pitie",
      0.015
    ],
    [
      "mansuetude",
      0.015
    ],
    [
      "faveur",
      0.015
    ],
    [
      "valeur",
      0.01
    ],
    [
      "honnetete",
      0.01
    ],
    [
      "benignite",
      0.01
    ],
    [
      "bienfaisance",
      0.01
    ],
    [
      "beaute",
      0.01
    ],
    [
      "altruisme",
      0.01
    ],
    [
      "agrement",
      0.01
    ],
    [
      "simplicite",
      0.01
    ],
    [
      "propriete",
      0.01
    ],
    [
      "obligeance",
      0.01
    ],
    [
      "utilite",
      0.0075
    ],
    [
      "tolerance",
      0.0075
    ],
    [
      "sociabilite",
      0.0075
    ],
    [
      "sensibilite",
      0.0075
    ],
    [
      "misericorde",
      0.0075
    ],
    [
      "interet",
      0.0075
    ],
    [
      "grandeur",
      0.0075
    ],
    [
      "gracieusete",
      0.0075
    ],
    [
      "force",
      0.0075
    ],
    [
      "convenance",
      0.0075
    ],
    [
      "clemence",
      0.0075
    ],
    [
      "avantage",
      0.0075
    ],
    [
      "affection",
      0.0075
    ],
    [
      "naivete",
      0.005
    ],
    [
      "perfection",
      0.005
    ],
    [
      "philanthropie",
      0.005
    ],
    [
      "ame",
      0.005
    ],
    [
      "magnanimite",
      0.005
    ],
    [
      "excellence",
      0.005
    ],
    [
      "exactitude",
      0.005
    ],
    [
      "candeur",
      0.005
    ],
    [
      "caresse",
      0.005
    ],
    [
      "debonnairete",
      0.005
    ],
    [
      "desinteressement",
      0.005
    ],
    [
      "devouement",
      0.005
    ],
    [
      "verite",
      0.0025
    ],
    [
      "serviabilite",
      0.0025
    ],
    [
      "justice",
      0.0025
    ],
    [
      "credulite",
      0.0025
    ],
    [
      "cordialite",
      0.0025
    ],
    [
      "comprehension",
      0.0025
    ],
    [
      "compassion",
      0.0025
    ],
    [
      "abnegation",
      0.0025
    ],
    [
      "prodigalite",
      0.0
    ],
    [
      "innocence",
      0.0
    ],
    [
      "ingenuite",
      0.0
    ],
    [
      "congruite",
      0.0
    ],
    [
      "betise",
      0.0
    ],
    [
      "bonasserie",
      0.0
    ],
    [
      "bon",
      0.0
    ],
    [
      "accueil",
      0.0
    ],
    [
      "providence",
      0.0
    ]
  ],
  "man": [],
  "superman": [
    [
      "surhomme",
      0.5
    ]
  ],
  "magazine": [
    [
      "revue",
      0.2925
    ],
    [
      "journal",
      0.235
    ],
    [
      "bulletin",
      0.1175
    ],
    [
      "periodique",
      0.1175
    ],
    [
      "hebdomadaire",
      0.0575
    ],
    [
      "illustre",
      0.0575
    ],
    [
      "magasin",
      0.0575
    ],
    [
      "presse",
      0.0575
    ]
  ],
  "science": [
    [
      "savoir",
      0.12
    ],
    [
      "capacite",
      0.1025
    ],
    [
      "habilete",
      0.1025
    ],
    [
      "art",
      0.085
    ],
    [
      "competence",
      0.0675
    ],
    [
      "instruction",
      0.05
    ],
    [
      "experience",
      0.05
    ],
    [
      "connaissance",
      0.05
    ],
    [
      "bagage",
      0.05
    ],
    [
      "adresse",
      0.05
    ],
    [
      "erudition",
      0.0325
    ],
    [
      "secret",
      0.0325
    ],
    [
      "sagesse",
      0.0325
    ],
    [
      "profondeur",
      0.0325
    ],
    [
      "connaissances",
      0.015
    ],
    [
      "culture",
      0.015
    ],
    [
      "discipline",
      0.015
    ],
    [
      "omniscience",
      0.015
    ],
    [
      "technique",
      0.015
    ],
    [
      "verite",
      0.015
    ],
    [
      "etude",
      0.015
    ]
  ],
  "infus": [
    [
      "infuse",
      0.165
    ],
    [
      "inne",
      0.165
    ],
    [
      "natif",
      0.165
    ],
    [
      "naturel",
      0.165
    ],
    [
      "originaire",
      0.165
    ],
    [
      "repandu",
      0.165
    ]
  ],
  "infuser": [
    [
      "insuffler",
      0.185
    ],
    [
      "inoculer",
      0.1625
    ],
    [
      "inspirer",
      0.0925
    ],
    [
      "communiquer",
      0.0675
    ],
    [
      "impregner",
      0.0675
    ],
    [
      "transfuser",
      0.0675
    ],
    [
      "verser",
      0.045
    ],
    [
      "tremper",
      0.045
    ],
    [
      "transmettre",
      0.045
    ],
    [
      "introduire",
      0.045
    ],
    [
      "instiller",
      0.045
    ],
    [
      "animer",
      0.045
    ],
    [
      "cuire",
      0.0225
    ],
    [
      "injecter",
      0.0225
    ],
    [
      "macerer",
      0.0225
    ]
  ],
  "carrure": [
    [
      "stature",
      0.1725
    ],
    [
      "envergure",
      0.13
    ],
    [
      "valeur",
      0.085
    ],
    [
      "taille",
      0.085
    ],
    [
      "gabarit",
      0.085
    ],
    [
      "franchise",
      0.085
    ],
    [
      "classe",
      0.085
    ],
    [
      "carre",
      0.0425
    ],
    [
      "droiture",
      0.0425
    ],
    [
      "largeur",
      0.0425
    ],
    [
      "loyaute",
      0.0425
    ],
    [
      "nettete",
      0.0425
    ],
    [
      "poitrine",
      0.0425
    ]
  ],
  "ferveur": [
    [
      "fanatisme",
      0.1075
    ],
    [
      "enthousiasme",
      0.0925
    ],
    [
      "ardeur",
      0.08
    ],
    [
      "chaleur",
      0.08
    ],
    [
      "engouement",
      0.065
    ],
    [
      "adoration",
      0.065
    ],
    [
      "amour",
      0.0525
    ],
    [
      "bouillonnement",
      0.0525
    ],
    [
      "flamme",
      0.0525
    ],
    [
      "zele",
      0.04
    ],
    [
      "religion",
      0.04
    ],
    [
      "piete",
      0.04
    ],
    [
      "emballement",
      0.04
    ],
    [
      "devotion",
      0.04
    ],
    [
      "exaltation",
      0.025
    ],
    [
      "elan",
      0.025
    ],
    [
      "mode",
      0.0125
    ],
    [
      "force",
      0.0125
    ],
    [
      "faveur",
      0.0125
    ],
    [
      "enchantement",
      0.0125
    ],
    [
      "effusion",
      0.0125
    ],
    [
      "communion",
      0.0125
    ],
    [
      "recueillement",
      0.0125
    ]
  ],
  "commun": [
    [
      "vulgaire",
      0.09
    ],
    [
      "ordinaire",
      0.0675
    ],
    [
      "trivial",
      0.06
    ],
    [
      "banal",
      0.055
    ],
    [
      "courant",
      0.045
    ],
    [
      "bas",
      0.04
    ],
    [
      "mediocre",
      0.03
    ],
    [
      "peuple",
      0.0275
    ],
    [
      "prosaique",
      0.025
    ],
    [
      "populaire",
      0.025
    ],
    [
      "general",
      0.025
    ],
    [
      "grossier",
      0.0225
    ],
    [
      "plat",
      0.0225
    ],
    [
      "public",
      0.0225
    ],
    [
      "quelconque",
      0.0225
    ],
    [
      "populacier",
      0.0175
    ],
    [
      "habituel",
      0.0175
    ],
    [
      "foule",
      0.0175
    ],
    [
      "vil",
      0.015
    ],
    [
      "moyen",
      0.015
    ],
    [
      "masse",
      0.015
    ],
    [
      "connu",
      0.015
    ],
    [
      "bourgeois",
      0.015
    ],
    [
      "canaille",
      0.0125
    ],
    [
      "collectif",
      0.0125
    ],
    [
      "populace",
      0.0125
    ],
    [
      "repandu",
      0.0075
    ],
    [
      "semblable",
      0.0075
    ],
    [
      "usite",
      0.0075
    ],
    [
      "usuel",
      0.0075
    ],
    [
      "roturier",
      0.0075
    ],
    [
      "rebattu",
      0.0075
    ],
    [
      "poissard",
      0.0075
    ],
    [
      "gros",
      0.0075
    ],
    [
      "familier",
      0.0075
    ],
    [
      "contigu",
      0.0075
    ],
    [
      "mitoyen",
      0.005
    ],
    [
      "pauvre",
      0.005
    ],
    [
      "unanime",
      0.005
    ],
    [
      "universel",
      0.005
    ],
    [
      "identique",
      0.005
    ],
    [
      "frequent",
      0.005
    ],
    [
      "ensemble",
      0.005
    ],
    [
      "comparable",
      0.005
    ],
    [
      "analogique",
      0.005
    ],
    [
      "abondant",
      0.005
    ],
    [
      "prolo",
      0.0025
    ],
    [
      "popu",
      0.0025
    ],
    [
      "partage",
      0.0025
    ],
    [
      "naturel",
      0.0025
    ],
    [
      "meme",
      0.0025
    ],
    [
      "roture",
      0.0025
    ],
    [
      "services",
      0.0025
    ],
    [
      "simultane",
      0.0025
    ],
    [
      "standard",
      0.0025
    ],
    [
      "use",
      0.0025
    ],
    [
      "utilitaire",
      0.0025
    ],
    [
      "monde",
      0.0025
    ],
    [
      "materiel",
      0.0025
    ],
    [
      "marchand",
      0.0025
    ],
    [
      "accoutume",
      0.0025
    ],
    [
      "aile",
      0.0025
    ],
    [
      "appellatif",
      0.0025
    ],
    [
      "communal",
      0.0025
    ],
    [
      "d'ensemble",
      0.0025
    ],
    [
      "debarras",
      0.0025
    ],
    [
      "democratique",
      0.0025
    ],
    [
      "generalite",
      0.0025
    ],
    [
      "generique",
      0.0025
    ],
    [
      "indivis",
      0.0025
    ],
    [
      "inferieur",
      0.0025
    ],
    [
      "inelegant",
      0.0025
    ],
    [
      "epicier",
      0.0025
    ]
  ],
  "millenaire": [
    [
      "antique",
      0.23
    ],
    [
      "seculaire",
      0.23
    ],
    [
      "immemorial",
      0.1525
    ],
    [
      "vieux",
      0.1525
    ],
    [
      "ancestral",
      0.075
    ],
    [
      "antediluvien",
      0.075
    ],
    [
      "recule",
      0.075
    ]
  ],
  "dizaine": [
    [
      "decade",
      1.0
    ]
  ],
  "chargement": [
    [
      "bagage",
      0.1
    ],
    [
      "charge",
      0.1
    ],
    [
      "fret",
      0.1
    ],
    [
      "bourrage",
      0.065
    ],
    [
      "cargaison",
      0.065
    ],
    [
      "fardeau",
      0.065
    ],
    [
      "embarquement",
      0.0325
    ],
    [
      "expedition",
      0.0325
    ],
    [
      "garnissage",
      0.0325
    ],
    [
      "manutention",
      0.0325
    ],
    [
      "poids",
      0.0325
    ],
    [
      "provision",
      0.0325
    ],
    [
      "contenu",
      0.0325
    ],
    [
      "charroi",
      0.0325
    ],
    [
      "barda",
      0.0325
    ],
    [
      "ballot",
      0.0325
    ],
    [
      "attirail",
      0.0325
    ],
    [
      "arrimage",
      0.0325
    ],
    [
      "appontement",
      0.0325
    ],
    [
      "affretement",
      0.0325
    ],
    [
      "remplissage",
      0.0325
    ]
  ],
  "ane": [
    [
      "bete",
      0.13
    ],
    [
      "sot",
      0.095
    ],
    [
      "ballot",
      0.07
    ],
    [
      "stupide",
      0.07
    ],
    [
      "cruche",
      0.065
    ],
    [
      "balourd",
      0.0525
    ],
    [
      "baudet",
      0.0475
    ],
    [
      "beta",
      0.04
    ],
    [
      "niais",
      0.035
    ],
    [
      "bourrique",
      0.035
    ],
    [
      "bourricot",
      0.0275
    ],
    [
      "ignorant",
      0.0275
    ],
    [
      "imbecile",
      0.0275
    ],
    [
      "buse",
      0.0225
    ],
    [
      "idiot",
      0.0225
    ],
    [
      "lourdaud",
      0.0225
    ],
    [
      "mulet",
      0.0225
    ],
    [
      "mule",
      0.015
    ],
    [
      "cretin",
      0.015
    ],
    [
      "butor",
      0.01
    ],
    [
      "bourriquet",
      0.01
    ],
    [
      "benet",
      0.01
    ],
    [
      "aliboron",
      0.01
    ],
    [
      "anichon",
      0.005
    ],
    [
      "anesse",
      0.005
    ],
    [
      "roussin",
      0.005
    ],
    [
      "peccata",
      0.005
    ],
    [
      "monture",
      0.005
    ],
    [
      "grison",
      0.005
    ],
    [
      "bardot",
      0.005
    ],
    [
      "aze",
      0.005
    ],
    [
      "anon",
      0.005
    ]
  ],
  "climat": [
    [
      "temps",
      0.165
    ],
    [
      "atmosphere",
      0.1325
    ],
    [
      "air",
      0.1
    ],
    [
      "pays",
      0.1
    ],
    [
      "milieu",
      0.065
    ],
    [
      "ciel",
      0.065
    ],
    [
      "ambiance",
      0.065
    ],
    [
      "temperature",
      0.0325
    ],
    [
      "regime",
      0.0325
    ],
    [
      "rivage",
      0.0325
    ],
    [
      "mesoclimat",
      0.0325
    ],
    [
      "microclimat",
      0.0325
    ],
    [
      "environnement",
      0.0325
    ],
    [
      "contree",
      0.0325
    ],
    [
      "circonstance",
      0.0325
    ],
    [
      "eclairage",
      0.0325
    ]
  ],
  "tube": [
    [
      "conduit",
      0.085
    ],
    [
      "conduite",
      0.085
    ],
    [
      "canal",
      0.0625
    ],
    [
      "tuyau",
      0.0625
    ],
    [
      "pipeline",
      0.0425
    ],
    [
      "drain",
      0.0425
    ],
    [
      "canalisation",
      0.0425
    ],
    [
      "boyau",
      0.0425
    ],
    [
      "rengaine",
      0.02
    ],
    [
      "sarbacane",
      0.02
    ],
    [
      "siphon",
      0.02
    ],
    [
      "sonde",
      0.02
    ],
    [
      "succes",
      0.02
    ],
    [
      "tubette",
      0.02
    ],
    [
      "tubule",
      0.02
    ],
    [
      "telephone",
      0.02
    ],
    [
      "pneu",
      0.02
    ],
    [
      "pipette",
      0.02
    ],
    [
      "baguette",
      0.02
    ],
    [
      "canon",
      0.02
    ],
    [
      "canonniere",
      0.02
    ],
    [
      "canule",
      0.02
    ],
    [
      "claque",
      0.02
    ],
    [
      "cylindre",
      0.02
    ],
    [
      "gibus",
      0.02
    ],
    [
      "vaisseau",
      0.02
    ]
  ],
  "dejeuner": [
    [
      "repas",
      0.3625
    ],
    [
      "diner",
      0.18
    ],
    [
      "lunch",
      0.09
    ],
    [
      "manger",
      0.09
    ],
    [
      "reception",
      0.09
    ]
  ],
  "laitier": [
    [
      "beurrier",
      0.25
    ],
    [
      "bouillie",
      0.25
    ],
    [
      "cremier",
      0.25
    ],
    [
      "scorie",
      0.25
    ]
  ],
  "bille": [
    [
      "binette",
      0.105
    ],
    [
      "figure",
      0.105
    ],
    [
      "visage",
      0.105
    ],
    [
      "tete",
      0.075
    ],
    [
      "physionomie",
      0.06
    ],
    [
      "bouille",
      0.06
    ],
    [
      "air",
      0.06
    ],
    [
      "billot",
      0.0425
    ],
    [
      "troncon",
      0.0425
    ],
    [
      "morceau",
      0.03
    ],
    [
      "bois",
      0.03
    ],
    [
      "bloc",
      0.03
    ],
    [
      "balle",
      0.03
    ],
    [
      "aspect",
      0.03
    ],
    [
      "oeil",
      0.0125
    ],
    [
      "expression",
      0.0125
    ],
    [
      "chocolat",
      0.0125
    ],
    [
      "calot",
      0.0125
    ],
    [
      "buche",
      0.0125
    ],
    [
      "boule",
      0.0125
    ],
    [
      "bobine",
      0.0125
    ],
    [
      "billon",
      0.0125
    ],
    [
      "billette",
      0.0125
    ],
    [
      "barre",
      0.0125
    ],
    [
      "allure",
      0.0125
    ],
    [
      "agate",
      0.0125
    ],
    [
      "tronc",
      0.0125
    ]
  ],
  "aveugle": [
    [
      "absolu",
      0.0825
    ],
    [
      "occulte",
      0.0825
    ],
    [
      "obscur",
      0.0825
    ],
    [
      "invisible",
      0.0825
    ],
    [
      "ferme",
      0.0825
    ],
    [
      "fanatique",
      0.0825
    ],
    [
      "entier",
      0.0825
    ],
    [
      "cecite",
      0.0825
    ],
    [
      "anophtalme",
      0.0825
    ],
    [
      "amaurose",
      0.0825
    ],
    [
      "total",
      0.0825
    ]
  ],
  "aveugler": [
    [
      "boucher",
      0.1525
    ],
    [
      "cacher",
      0.115
    ],
    [
      "eblouir",
      0.075
    ],
    [
      "troubler",
      0.075
    ],
    [
      "offusquer",
      0.075
    ],
    [
      "murer",
      0.075
    ],
    [
      "calfater",
      0.075
    ],
    [
      "etancher",
      0.0375
    ],
    [
      "egarer",
      0.0375
    ],
    [
      "voiler",
      0.0375
    ],
    [
      "obturer",
      0.0375
    ],
    [
      "obstruer",
      0.0375
    ],
    [
      "colmater",
      0.0375
    ],
    [
      "briller",
      0.0375
    ],
    [
      "affoler",
      0.0375
    ],
    [
      "etouper",
      0.0375
    ]
  ],
  "camoufler": [
    [
      "dissimuler",
      0.1725
    ],
    [
      "cacher",
      0.12
    ],
    [
      "masquer",
      0.12
    ],
    [
      "deguiser",
      0.1025
    ],
    [
      "voiler",
      0.0675
    ],
    [
      "travestir",
      0.05
    ],
    [
      "recouvrir",
      0.05
    ],
    [
      "couvrir",
      0.05
    ],
    [
      "murer",
      0.0325
    ],
    [
      "habiller",
      0.0325
    ],
    [
      "escamoter",
      0.0325
    ],
    [
      "envelopper",
      0.0325
    ],
    [
      "derober",
      0.0325
    ],
    [
      "celer",
      0.0325
    ],
    [
      "embusquer",
      0.015
    ],
    [
      "maquiller",
      0.015
    ],
    [
      "renfermer",
      0.015
    ]
  ],
  "laideur": [
    [
      "abjection",
      0.125
    ],
    [
      "infamie",
      0.125
    ],
    [
      "bassesse",
      0.1
    ],
    [
      "turpitude",
      0.1
    ],
    [
      "vilenie",
      0.075
    ],
    [
      "vice",
      0.05
    ],
    [
      "misere",
      0.05
    ],
    [
      "ignominie",
      0.05
    ],
    [
      "horreur",
      0.05
    ],
    [
      "hideur",
      0.05
    ],
    [
      "disgrace",
      0.05
    ],
    [
      "difformite",
      0.05
    ],
    [
      "malhonnetete",
      0.025
    ],
    [
      "mochete",
      0.025
    ],
    [
      "salete",
      0.025
    ],
    [
      "tristesse",
      0.025
    ],
    [
      "verrue",
      0.025
    ]
  ],
  "ignorance": [
    [
      "betise",
      0.0925
    ],
    [
      "sottise",
      0.0575
    ],
    [
      "naivete",
      0.0575
    ],
    [
      "maladresse",
      0.0575
    ],
    [
      "inexperience",
      0.0575
    ],
    [
      "incapacite",
      0.0575
    ],
    [
      "imbecillite",
      0.0575
    ],
    [
      "imperitie",
      0.045
    ],
    [
      "incompetence",
      0.045
    ],
    [
      "insuffisance",
      0.045
    ],
    [
      "anerie",
      0.045
    ],
    [
      "simplicite",
      0.035
    ],
    [
      "nullite",
      0.035
    ],
    [
      "faute",
      0.0225
    ],
    [
      "inconscience",
      0.0225
    ],
    [
      "ingenuite",
      0.0225
    ],
    [
      "inconnaissance",
      0.01
    ],
    [
      "inconsequence",
      0.01
    ],
    [
      "inculture",
      0.01
    ],
    [
      "innocence",
      0.01
    ],
    [
      "inscience",
      0.01
    ],
    [
      "lacune",
      0.01
    ],
    [
      "meconnaissance",
      0.01
    ],
    [
      "nescience",
      0.01
    ],
    [
      "impuissance",
      0.01
    ],
    [
      "ilotisme",
      0.01
    ],
    [
      "idiotisme",
      0.01
    ],
    [
      "abrutissement",
      0.01
    ],
    [
      "analphabetisme",
      0.01
    ],
    [
      "aveuglement",
      0.01
    ],
    [
      "balourdise",
      0.01
    ],
    [
      "barbarie",
      0.01
    ],
    [
      "bejaune",
      0.01
    ],
    [
      "candeur",
      0.01
    ],
    [
      "crasse",
      0.01
    ],
    [
      "obscurantisme",
      0.01
    ]
  ],
  "fatalite": [
    [
      "malheur",
      0.135
    ],
    [
      "tribulation",
      0.1175
    ],
    [
      "malchance",
      0.0975
    ],
    [
      "sort",
      0.0975
    ],
    [
      "adversite",
      0.0775
    ],
    [
      "destin",
      0.0775
    ],
    [
      "hasard",
      0.0775
    ],
    [
      "calamite",
      0.0575
    ],
    [
      "malediction",
      0.0375
    ],
    [
      "destinee",
      0.0375
    ],
    [
      "catastrophe",
      0.0375
    ],
    [
      "desastre",
      0.0175
    ],
    [
      "fatum",
      0.0175
    ],
    [
      "fortune",
      0.0175
    ],
    [
      "irrevocable",
      0.0175
    ],
    [
      "letalite",
      0.0175
    ],
    [
      "necessite",
      0.0175
    ],
    [
      "eventualite",
      0.0175
    ]
  ],
  "rebellion": [
    [
      "revolte",
      0.17
    ],
    [
      "soulevement",
      0.0925
    ],
    [
      "resistance",
      0.0825
    ],
    [
      "sedition",
      0.075
    ],
    [
      "insurrection",
      0.065
    ],
    [
      "opposition",
      0.055
    ],
    [
      "mutinerie",
      0.055
    ],
    [
      "indiscipline",
      0.055
    ],
    [
      "desobeissance",
      0.055
    ],
    [
      "insoumission",
      0.045
    ],
    [
      "faction",
      0.0375
    ],
    [
      "emeute",
      0.0275
    ],
    [
      "insubordination",
      0.0275
    ],
    [
      "dissidence",
      0.0275
    ],
    [
      "contestation",
      0.0275
    ],
    [
      "protestation",
      0.0175
    ],
    [
      "refus",
      0.0175
    ],
    [
      "guerilla",
      0.0075
    ],
    [
      "indocilite",
      0.0075
    ],
    [
      "maquis",
      0.0075
    ],
    [
      "pronunciamiento",
      0.0075
    ],
    [
      "revolution",
      0.0075
    ]
  ],
  "fixe": [
    [
      "stable",
      0.1075
    ],
    [
      "immuable",
      0.1025
    ],
    [
      "ferme",
      0.0875
    ],
    [
      "invariable",
      0.0775
    ],
    [
      "constant",
      0.0725
    ],
    [
      "inebranlable",
      0.05
    ],
    [
      "immobile",
      0.05
    ],
    [
      "determine",
      0.045
    ],
    [
      "arrete",
      0.035
    ],
    [
      "solide",
      0.03
    ],
    [
      "permanent",
      0.03
    ],
    [
      "certain",
      0.025
    ],
    [
      "inalterable",
      0.02
    ],
    [
      "precis",
      0.02
    ],
    [
      "regulier",
      0.02
    ],
    [
      "sedentaire",
      0.0125
    ],
    [
      "stationnaire",
      0.0125
    ],
    [
      "perseverant",
      0.0125
    ],
    [
      "persistant",
      0.0125
    ],
    [
      "irrevocable",
      0.0125
    ],
    [
      "definitif",
      0.0125
    ],
    [
      "continu",
      0.0125
    ],
    [
      "salaire",
      0.01
    ],
    [
      "retribution",
      0.01
    ],
    [
      "regle",
      0.01
    ],
    [
      "irrefragable",
      0.01
    ],
    [
      "defini",
      0.01
    ],
    [
      "attache",
      0.01
    ],
    [
      "shoot",
      0.0025
    ],
    [
      "mensualite",
      0.0025
    ],
    [
      "independant",
      0.0025
    ],
    [
      "fige",
      0.0025
    ],
    [
      "double",
      0.0025
    ],
    [
      "dormant",
      0.0025
    ],
    [
      "atone",
      0.0025
    ],
    [
      "appointements",
      0.0025
    ],
    [
      "etale",
      0.0025
    ]
  ],
  "piper": [
    [
      "attraper",
      0.1425
    ],
    [
      "tromper",
      0.1175
    ],
    [
      "prendre",
      0.095
    ],
    [
      "abuser",
      0.07
    ],
    [
      "berner",
      0.07
    ],
    [
      "seduire",
      0.07
    ],
    [
      "voler",
      0.0475
    ],
    [
      "piquer",
      0.0475
    ],
    [
      "crier",
      0.0475
    ],
    [
      "egarer",
      0.0225
    ],
    [
      "truquer",
      0.0225
    ],
    [
      "tricher",
      0.0225
    ],
    [
      "pepier",
      0.0225
    ],
    [
      "pincer",
      0.0225
    ],
    [
      "piauler",
      0.0225
    ],
    [
      "leurrer",
      0.0225
    ],
    [
      "glousser",
      0.0225
    ],
    [
      "frouer",
      0.0225
    ],
    [
      "derober",
      0.0225
    ],
    [
      "apprehender",
      0.0225
    ],
    [
      "epingler",
      0.0225
    ]
  ],
  "soumission": [
    [
      "asservissement",
      0.1025
    ],
    [
      "obeissance",
      0.0825
    ],
    [
      "servitude",
      0.0825
    ],
    [
      "dependance",
      0.0725
    ],
    [
      "subordination",
      0.0725
    ],
    [
      "assujettissement",
      0.055
    ],
    [
      "obedience",
      0.045
    ],
    [
      "sujetion",
      0.045
    ],
    [
      "vassalite",
      0.0275
    ],
    [
      "servilite",
      0.0275
    ],
    [
      "reduction",
      0.0275
    ],
    [
      "docilite",
      0.0275
    ],
    [
      "allegeance",
      0.0275
    ],
    [
      "abaissement",
      0.0275
    ],
    [
      "resignation",
      0.0175
    ],
    [
      "proposition",
      0.0175
    ],
    [
      "joug",
      0.0175
    ],
    [
      "humilite",
      0.0175
    ],
    [
      "discipline",
      0.0175
    ],
    [
      "conquete",
      0.0175
    ],
    [
      "acceptation",
      0.0175
    ],
    [
      "infeodation",
      0.0075
    ],
    [
      "marche",
      0.0075
    ],
    [
      "merci",
      0.0075
    ],
    [
      "observance",
      0.0075
    ],
    [
      "offre",
      0.0075
    ],
    [
      "pacification",
      0.0075
    ],
    [
      "hommage",
      0.0075
    ],
    [
      "fidelite",
      0.0075
    ],
    [
      "esclavage",
      0.0075
    ],
    [
      "conformite",
      0.0075
    ],
    [
      "apprivoisement",
      0.0075
    ],
    [
      "adjudication",
      0.0075
    ],
    [
      "acquiescement",
      0.0075
    ],
    [
      "abandon",
      0.0075
    ],
    [
      "souplesse",
      0.0075
    ]
  ],
  "abandon": [
    [
      "renoncement",
      0.0475
    ],
    [
      "delaissement",
      0.0325
    ],
    [
      "renonciation",
      0.0325
    ],
    [
      "cession",
      0.0275
    ],
    [
      "resignation",
      0.0275
    ],
    [
      "negligence",
      0.0225
    ],
    [
      "demission",
      0.0225
    ],
    [
      "capitulation",
      0.02
    ],
    [
      "desertion",
      0.02
    ],
    [
      "simplicite",
      0.015
    ],
    [
      "mollesse",
      0.015
    ],
    [
      "lachage",
      0.015
    ],
    [
      "franchise",
      0.015
    ],
    [
      "confiance",
      0.015
    ],
    [
      "sacrifice",
      0.0125
    ],
    [
      "rupture",
      0.0125
    ],
    [
      "reniement",
      0.0125
    ],
    [
      "liberte",
      0.0125
    ],
    [
      "intimite",
      0.0125
    ],
    [
      "detachement",
      0.0125
    ],
    [
      "desinvolture",
      0.0125
    ],
    [
      "don",
      0.0125
    ],
    [
      "abdication",
      0.0125
    ],
    [
      "apostasie",
      0.0125
    ],
    [
      "arret",
      0.0125
    ],
    [
      "cessation",
      0.0125
    ],
    [
      "changement",
      0.0125
    ],
    [
      "dessaisissement",
      0.0125
    ],
    [
      "plaquage",
      0.0075
    ],
    [
      "rejet",
      0.0075
    ],
    [
      "relachement",
      0.0075
    ],
    [
      "retrait",
      0.0075
    ],
    [
      "retraite",
      0.0075
    ],
    [
      "solitude",
      0.0075
    ],
    [
      "suppression",
      0.0075
    ],
    [
      "separation",
      0.0075
    ],
    [
      "treve",
      0.0075
    ],
    [
      "evacuation",
      0.0075
    ],
    [
      "nonchalance",
      0.0075
    ],
    [
      "isolement",
      0.0075
    ],
    [
      "insouciance",
      0.0075
    ],
    [
      "abjuration",
      0.0075
    ],
    [
      "abnegation",
      0.0075
    ],
    [
      "concession",
      0.0075
    ],
    [
      "desinteressement",
      0.0075
    ],
    [
      "desistement",
      0.0075
    ],
    [
      "detente",
      0.0075
    ],
    [
      "exode",
      0.0075
    ],
    [
      "expansion",
      0.0075
    ],
    [
      "familiarite",
      0.0075
    ],
    [
      "fuite",
      0.0075
    ],
    [
      "incurie",
      0.0075
    ],
    [
      "naivete",
      0.005
    ],
    [
      "naturel",
      0.005
    ],
    [
      "largage",
      0.005
    ],
    [
      "inconstance",
      0.005
    ],
    [
      "omission",
      0.005
    ],
    [
      "ouverture",
      0.005
    ],
    [
      "retractation",
      0.005
    ],
    [
      "suspension",
      0.005
    ],
    [
      "vide",
      0.005
    ],
    [
      "epanchement",
      0.005
    ],
    [
      "generosite",
      0.005
    ],
    [
      "flechissement",
      0.005
    ],
    [
      "faiblesse",
      0.005
    ],
    [
      "abandonnement",
      0.005
    ],
    [
      "alanguissement",
      0.005
    ],
    [
      "armistice",
      0.005
    ],
    [
      "bannissement",
      0.005
    ],
    [
      "confidence",
      0.005
    ],
    [
      "donation",
      0.005
    ],
    [
      "defaite",
      0.005
    ],
    [
      "defection",
      0.005
    ],
    [
      "desappropriation",
      0.005
    ],
    [
      "devetissement",
      0.005
    ],
    [
      "oubli",
      0.0025
    ],
    [
      "passation",
      0.0025
    ],
    [
      "placage",
      0.0025
    ],
    [
      "reculade",
      0.0025
    ],
    [
      "reddition",
      0.0025
    ],
    [
      "soumission",
      0.0025
    ],
    [
      "securite",
      0.0025
    ],
    [
      "inoccupation",
      0.0025
    ],
    [
      "infidelite",
      0.0025
    ],
    [
      "forfait",
      0.0025
    ],
    [
      "alienation",
      0.0025
    ],
    [
      "deguerpissement",
      0.0025
    ],
    [
      "depot",
      0.0025
    ],
    [
      "dereliction",
      0.0025
    ],
    [
      "desordre",
      0.0025
    ],
    [
      "enterrement",
      0.0025
    ],
    [
      "exposition",
      0.0025
    ],
    [
      "fatalisme",
      0.0025
    ],
    [
      "elimination",
      0.0025
    ]
  ],
  "resigner": [
    [
      "abandonner",
      0.175
    ],
    [
      "abdiquer",
      0.175
    ],
    [
      "renoncer",
      0.175
    ],
    [
      "deposer",
      0.1175
    ],
    [
      "quitter",
      0.1175
    ],
    [
      "demissionner",
      0.0575
    ]
  ],
  "programmer": [
    [
      "planifier",
      0.4
    ],
    [
      "ceduler",
      0.2
    ],
    [
      "organiser",
      0.2
    ],
    [
      "parametrer",
      0.2
    ]
  ],
  "programme": [
    [
      "plan",
      0.1125
    ],
    [
      "affiche",
      0.085
    ],
    [
      "annonce",
      0.085
    ],
    [
      "dessein",
      0.085
    ],
    [
      "projet",
      0.085
    ],
    [
      "planning",
      0.055
    ],
    [
      "proclamation",
      0.025
    ],
    [
      "prospectus",
      0.025
    ],
    [
      "resolution",
      0.025
    ],
    [
      "sequence",
      0.025
    ],
    [
      "travail",
      0.025
    ],
    [
      "ecriteau",
      0.025
    ],
    [
      "planification",
      0.025
    ],
    [
      "objectif",
      0.025
    ],
    [
      "menu",
      0.025
    ],
    [
      "logiciel",
      0.025
    ],
    [
      "horaire",
      0.025
    ],
    [
      "catalogue",
      0.025
    ],
    [
      "calendrier",
      0.025
    ],
    [
      "emission",
      0.025
    ]
  ],
  "genial": [
    [
      "beau",
      0.125
    ],
    [
      "extraordinaire",
      0.0925
    ],
    [
      "grand",
      0.0925
    ],
    [
      "etonnant",
      0.065
    ],
    [
      "superieur",
      0.065
    ],
    [
      "formidable",
      0.065
    ],
    [
      "bon",
      0.065
    ],
    [
      "fabuleux",
      0.05
    ],
    [
      "fort",
      0.05
    ],
    [
      "sensationnel",
      0.05
    ],
    [
      "supreme",
      0.04
    ],
    [
      "extra",
      0.0325
    ],
    [
      "magistral",
      0.0225
    ],
    [
      "astucieux",
      0.015
    ],
    [
      "prodigieux",
      0.015
    ],
    [
      "intelligent",
      0.015
    ],
    [
      "ingenieux",
      0.015
    ],
    [
      "fantastique",
      0.015
    ],
    [
      "divin",
      0.015
    ],
    [
      "chouette",
      0.015
    ],
    [
      "bonard",
      0.015
    ],
    [
      "lumineux",
      0.0075
    ],
    [
      "original",
      0.0075
    ],
    [
      "super",
      0.0075
    ],
    [
      "talentueux",
      0.0075
    ]
  ],
  "flou": [
    [
      "vague",
      0.17
    ],
    [
      "confus",
      0.075
    ],
    [
      "nebuleux",
      0.07
    ],
    [
      "incertain",
      0.06
    ],
    [
      "timide",
      0.06
    ],
    [
      "indecis",
      0.0525
    ],
    [
      "obscur",
      0.0525
    ],
    [
      "vaporeux",
      0.0425
    ],
    [
      "indistinct",
      0.0375
    ],
    [
      "flottant",
      0.0375
    ],
    [
      "trouble",
      0.0325
    ],
    [
      "brumeux",
      0.025
    ],
    [
      "indetermine",
      0.025
    ],
    [
      "imprecis",
      0.02
    ],
    [
      "tenebreux",
      0.015
    ],
    [
      "nuageux",
      0.015
    ],
    [
      "mou",
      0.015
    ],
    [
      "lache",
      0.015
    ],
    [
      "libre",
      0.015
    ],
    [
      "fumeux",
      0.015
    ],
    [
      "voile",
      0.01
    ],
    [
      "sibyllin",
      0.01
    ],
    [
      "leger",
      0.01
    ],
    [
      "large",
      0.01
    ],
    [
      "indefini",
      0.01
    ],
    [
      "indecision",
      0.01
    ],
    [
      "imprecision",
      0.01
    ],
    [
      "hesitant",
      0.01
    ],
    [
      "indistinction",
      0.005
    ],
    [
      "fondu",
      0.005
    ],
    [
      "fluide",
      0.005
    ],
    [
      "efface",
      0.005
    ],
    [
      "brouille",
      0.005
    ],
    [
      "brouillardeux",
      0.005
    ],
    [
      "indeterminable",
      0.005
    ]
  ],
  "soupirer": [
    [
      "desirer",
      0.1375
    ],
    [
      "rever",
      0.1375
    ],
    [
      "souhaiter",
      0.1375
    ],
    [
      "vouloir",
      0.1375
    ],
    [
      "aspirer",
      0.0825
    ],
    [
      "convoiter",
      0.0825
    ],
    [
      "pretendre",
      0.055
    ],
    [
      "lorgner",
      0.055
    ],
    [
      "beer",
      0.0275
    ],
    [
      "deplorer",
      0.0275
    ],
    [
      "envier",
      0.0275
    ],
    [
      "pleurer",
      0.0275
    ],
    [
      "respirer",
      0.0275
    ]
  ],
  "cime": [
    [
      "sommet",
      0.2425
    ],
    [
      "faite",
      0.12
    ],
    [
      "haut",
      0.12
    ],
    [
      "pointe",
      0.12
    ],
    [
      "comble",
      0.09
    ],
    [
      "pinacle",
      0.06
    ],
    [
      "tete",
      0.03
    ],
    [
      "summum",
      0.03
    ],
    [
      "sommite",
      0.03
    ],
    [
      "pic",
      0.03
    ],
    [
      "extremite",
      0.03
    ],
    [
      "culmen",
      0.03
    ],
    [
      "crete",
      0.03
    ],
    [
      "zenith",
      0.03
    ]
  ],
  "racine": [
    [
      "origine",
      0.1125
    ],
    [
      "source",
      0.085
    ],
    [
      "fondement",
      0.075
    ],
    [
      "principe",
      0.06
    ],
    [
      "souche",
      0.0475
    ],
    [
      "commencement",
      0.0475
    ],
    [
      "base",
      0.0475
    ],
    [
      "germe",
      0.0375
    ],
    [
      "pied",
      0.0375
    ],
    [
      "tige",
      0.0225
    ],
    [
      "seuil",
      0.0225
    ],
    [
      "patte",
      0.0225
    ],
    [
      "naissance",
      0.0225
    ],
    [
      "bulbe",
      0.0225
    ],
    [
      "attache",
      0.0225
    ],
    [
      "oignon",
      0.01
    ],
    [
      "pivot",
      0.01
    ],
    [
      "provenance",
      0.01
    ],
    [
      "radical",
      0.01
    ],
    [
      "radicelle",
      0.01
    ],
    [
      "radicule",
      0.01
    ],
    [
      "rhizome",
      0.01
    ],
    [
      "solution",
      0.01
    ],
    [
      "stolon",
      0.01
    ],
    [
      "semanteme",
      0.01
    ],
    [
      "tubercule",
      0.01
    ],
    [
      "moneme",
      0.01
    ],
    [
      "lien",
      0.01
    ],
    [
      "assise",
      0.01
    ],
    [
      "attachement",
      0.01
    ],
    [
      "bas",
      0.01
    ],
    [
      "caieu",
      0.01
    ],
    [
      "chevelu",
      0.01
    ],
    [
      "estoc",
      0.01
    ],
    [
      "ferment",
      0.01
    ],
    [
      "florence",
      0.01
    ],
    [
      "formant",
      0.01
    ],
    [
      "griffe",
      0.01
    ],
    [
      "lexeme",
      0.01
    ],
    [
      "etymologie",
      0.01
    ]
  ],
  "pente": [
    [
      "penchant",
      0.1825
    ],
    [
      "inclination",
      0.09
    ],
    [
      "cote",
      0.06
    ],
    [
      "inclinaison",
      0.06
    ],
    [
      "versant",
      0.06
    ],
    [
      "rampe",
      0.045
    ],
    [
      "declivite",
      0.045
    ],
    [
      "talus",
      0.03
    ],
    [
      "propension",
      0.03
    ],
    [
      "montee",
      0.03
    ],
    [
      "instinct",
      0.03
    ],
    [
      "faiblesse",
      0.03
    ],
    [
      "faible",
      0.03
    ],
    [
      "cote",
      0.03
    ],
    [
      "loi",
      0.0125
    ],
    [
      "obliquite",
      0.0125
    ],
    [
      "pan",
      0.0125
    ],
    [
      "raidillon",
      0.0125
    ],
    [
      "tendance",
      0.0125
    ],
    [
      "thalweg",
      0.0125
    ],
    [
      "grimpette",
      0.0125
    ],
    [
      "glacis",
      0.0125
    ],
    [
      "escarpement",
      0.0125
    ],
    [
      "entrainement",
      0.0125
    ],
    [
      "devers",
      0.0125
    ],
    [
      "declive",
      0.0125
    ],
    [
      "decadence",
      0.0125
    ],
    [
      "descente",
      0.0125
    ],
    [
      "abrupt",
      0.0125
    ],
    [
      "vocation",
      0.0125
    ]
  ],
  "vaciller": [
    [
      "osciller",
      0.125
    ],
    [
      "chanceler",
      0.1
    ],
    [
      "tituber",
      0.1
    ],
    [
      "trembler",
      0.0825
    ],
    [
      "remuer",
      0.0675
    ],
    [
      "tanguer",
      0.0675
    ],
    [
      "branler",
      0.05
    ],
    [
      "balancer",
      0.0325
    ],
    [
      "clignoter",
      0.0325
    ],
    [
      "flotter",
      0.0325
    ],
    [
      "scintiller",
      0.0325
    ],
    [
      "trebucher",
      0.025
    ],
    [
      "trembloter",
      0.025
    ],
    [
      "papilloter",
      0.025
    ],
    [
      "frissonner",
      0.025
    ],
    [
      "cligner",
      0.025
    ],
    [
      "palpiter",
      0.015
    ],
    [
      "hesiter",
      0.015
    ],
    [
      "faiblir",
      0.015
    ],
    [
      "chavirer",
      0.015
    ],
    [
      "flageoler",
      0.0075
    ],
    [
      "flechir",
      0.0075
    ],
    [
      "luire",
      0.0075
    ],
    [
      "s'affaiblir",
      0.0075
    ],
    [
      "tressauter",
      0.0075
    ],
    [
      "zigzaguer",
      0.0075
    ]
  ],
  "ecorcher": [
    [
      "depouiller",
      0.0925
    ],
    [
      "estamper",
      0.0925
    ],
    [
      "dechirer",
      0.085
    ],
    [
      "blesser",
      0.055
    ],
    [
      "egratigner",
      0.055
    ],
    [
      "erafler",
      0.045
    ],
    [
      "egorger",
      0.045
    ],
    [
      "voler",
      0.045
    ],
    [
      "exploiter",
      0.045
    ],
    [
      "demunir",
      0.045
    ],
    [
      "ranconner",
      0.035
    ],
    [
      "etrangler",
      0.035
    ],
    [
      "etriller",
      0.035
    ],
    [
      "labourer",
      0.0275
    ],
    [
      "griffer",
      0.0275
    ],
    [
      "couper",
      0.0275
    ],
    [
      "offenser",
      0.0175
    ],
    [
      "matraquer",
      0.0175
    ],
    [
      "estropier",
      0.0175
    ],
    [
      "arracher",
      0.0175
    ],
    [
      "triturer",
      0.0075
    ],
    [
      "peler",
      0.0075
    ],
    [
      "parler",
      0.0075
    ],
    [
      "heurter",
      0.0075
    ],
    [
      "excorier",
      0.0075
    ],
    [
      "endommager",
      0.0075
    ],
    [
      "effleurer",
      0.0075
    ],
    [
      "deshabiller",
      0.0075
    ],
    [
      "depiauter",
      0.0075
    ],
    [
      "deformer",
      0.0075
    ],
    [
      "choquer",
      0.0075
    ],
    [
      "erailler",
      0.0075
    ]
  ],
  "ecorche": [
    [
      "depouiller",
      0.0925
    ],
    [
      "estamper",
      0.0925
    ],
    [
      "dechirer",
      0.085
    ],
    [
      "blesser",
      0.055
    ],
    [
      "egratigner",
      0.055
    ],
    [
      "erafler",
      0.045
    ],
    [
      "egorger",
      0.045
    ],
    [
      "voler",
      0.045
    ],
    [
      "exploiter",
      0.045
    ],
    [
      "demunir",
      0.045
    ],
    [
      "ranconner",
      0.035
    ],
    [
      "etrangler",
      0.035
    ],
    [
      "etriller",
      0.035
    ],
    [
      "labourer",
      0.0275
    ],
    [
      "griffer",
      0.0275
    ],
    [
      "couper",
      0.0275
    ],
    [
      "offenser",
      0.0175
    ],
    [
      "matraquer",
      0.0175
    ],
    [
      "estropier",
      0.0175
    ],
    [
      "arracher",
      0.0175
    ],
    [
      "triturer",
      0.0075
    ],
    [
      "peler",
      0.0075
    ],
    [
      "parler",
      0.0075
    ],
    [
      "heurter",
      0.0075
    ],
    [
      "excorier",
      0.0075
    ],
    [
      "endommager",
      0.0075
    ],
    [
      "effleurer",
      0.0075
    ],
    [
      "deshabiller",
      0.0075
    ],
    [
      "depiauter",
      0.0075
    ],
    [
      "deformer",
      0.0075
    ],
    [
      "choquer",
      0.0075
    ],
    [
      "erailler",
      0.0075
    ]
  ],
  "refleter": [
    [
      "exprimer",
      0.12
    ],
    [
      "marquer",
      0.09
    ],
    [
      "representer",
      0.09
    ],
    [
      "repeter",
      0.09
    ],
    [
      "reverberer",
      0.06
    ],
    [
      "repercuter",
      0.06
    ],
    [
      "reflechir",
      0.06
    ],
    [
      "revetir",
      0.06
    ],
    [
      "reproduire",
      0.06
    ],
    [
      "renvoyer",
      0.06
    ],
    [
      "indiquer",
      0.06
    ],
    [
      "incarner",
      0.06
    ],
    [
      "briller",
      0.06
    ],
    [
      "traduire",
      0.06
    ]
  ],
  "lezard": [
    [
      "faineant",
      0.2
    ],
    [
      "paresseux",
      0.2
    ],
    [
      "peau",
      0.2
    ],
    [
      "reptile",
      0.2
    ],
    [
      "rossard",
      0.2
    ]
  ],
  "lezarder": [
    [
      "fendre",
      0.22
    ],
    [
      "fissurer",
      0.22
    ],
    [
      "crevasser",
      0.11
    ],
    [
      "disjoindre",
      0.11
    ],
    [
      "gercer",
      0.11
    ],
    [
      "paresser",
      0.11
    ]
  ],
  "minot": [
    [
      "enfant",
      0.5
    ],
    [
      "minouche",
      0.5
    ]
  ],
  "marchand": [
    [
      "commercant",
      0.2025
    ],
    [
      "camelot",
      0.0675
    ],
    [
      "negociant",
      0.0675
    ],
    [
      "trafiquant",
      0.0675
    ],
    [
      "vendeur",
      0.0675
    ],
    [
      "mercanti",
      0.0425
    ],
    [
      "detaillant",
      0.0425
    ],
    [
      "debitant",
      0.0425
    ],
    [
      "boutiquier",
      0.0425
    ],
    [
      "revendeur",
      0.02
    ],
    [
      "mercantile",
      0.02
    ],
    [
      "margoulin",
      0.02
    ],
    [
      "grossiste",
      0.02
    ],
    [
      "fournisseur",
      0.02
    ],
    [
      "commun",
      0.02
    ],
    [
      "colporteur",
      0.02
    ],
    [
      "chineur",
      0.02
    ],
    [
      "charlatan",
      0.02
    ],
    [
      "chand",
      0.02
    ],
    [
      "bourgeois",
      0.02
    ],
    [
      "acquereur",
      0.02
    ],
    [
      "acheteur",
      0.02
    ],
    [
      "epicier",
      0.02
    ]
  ],
  "caramel": [
    [
      "bonbon",
      0.5
    ],
    [
      "toffee",
      0.5
    ]
  ],
  "remarcher": [],
  "bouffant": [
    [
      "ballonne",
      0.125
    ],
    [
      "fronce",
      0.125
    ],
    [
      "gonflant",
      0.125
    ],
    [
      "gonfle",
      0.125
    ],
    [
      "herisse",
      0.125
    ],
    [
      "renfle",
      0.125
    ],
    [
      "souffle",
      0.125
    ],
    [
      "tumefie",
      0.125
    ]
  ],
  "godasse": [
    [
      "chaussure",
      0.285
    ],
    [
      "soulier",
      0.285
    ],
    [
      "croquenot",
      0.1425
    ],
    [
      "godillot",
      0.1425
    ]
  ],
  "goder": [
    [
      "grigner",
      0.285
    ],
    [
      "pocher",
      0.285
    ],
    [
      "bomber",
      0.1425
    ],
    [
      "godailler",
      0.1425
    ],
    [
      "grimacer",
      0.1425
    ]
  ],
  "antan": [],
  "barge": [
    [
      "bateau",
      0.23
    ],
    [
      "chaloupe",
      0.23
    ],
    [
      "barque",
      0.1525
    ],
    [
      "berge",
      0.075
    ],
    [
      "becasse",
      0.075
    ],
    [
      "belandre",
      0.075
    ],
    [
      "meule",
      0.075
    ],
    [
      "peniche",
      0.075
    ]
  ],
  "priant": [
    [
      "orant",
      0.5
    ],
    [
      "suppliant",
      0.5
    ]
  ],
  "superficiel": [
    [
      "leger",
      0.1325
    ],
    [
      "vain",
      0.105
    ],
    [
      "formel",
      0.08
    ],
    [
      "sommaire",
      0.08
    ],
    [
      "pueril",
      0.0525
    ],
    [
      "illusoire",
      0.0525
    ],
    [
      "futile",
      0.0525
    ],
    [
      "frivole",
      0.0525
    ],
    [
      "exterieur",
      0.0525
    ],
    [
      "apparent",
      0.0525
    ],
    [
      "vide",
      0.025
    ],
    [
      "trompeur",
      0.025
    ],
    [
      "specieux",
      0.025
    ],
    [
      "simpliste",
      0.025
    ],
    [
      "postiche",
      0.025
    ],
    [
      "plaque",
      0.025
    ],
    [
      "incomplet",
      0.025
    ],
    [
      "distrait",
      0.025
    ],
    [
      "benin",
      0.025
    ],
    [
      "epidermique",
      0.025
    ]
  ],
  "eleve": [
    [
      "hausser",
      0.0675
    ],
    [
      "augmenter",
      0.055
    ],
    [
      "monter",
      0.0525
    ],
    [
      "exalter",
      0.0425
    ],
    [
      "relever",
      0.0425
    ],
    [
      "soulever",
      0.0325
    ],
    [
      "rehausser",
      0.0275
    ],
    [
      "dresser",
      0.025
    ],
    [
      "porter",
      0.025
    ],
    [
      "pousser",
      0.025
    ],
    [
      "faire",
      0.025
    ],
    [
      "former",
      0.0225
    ],
    [
      "lever",
      0.0225
    ],
    [
      "etablir",
      0.0175
    ],
    [
      "exhausser",
      0.0175
    ],
    [
      "creer",
      0.0175
    ],
    [
      "construire",
      0.0175
    ],
    [
      "agrandir",
      0.0175
    ],
    [
      "eduquer",
      0.015
    ],
    [
      "surelever",
      0.015
    ],
    [
      "instruire",
      0.015
    ],
    [
      "grandir",
      0.015
    ],
    [
      "faconner",
      0.015
    ],
    [
      "accroitre",
      0.015
    ],
    [
      "batir",
      0.0125
    ],
    [
      "conduire",
      0.0125
    ],
    [
      "ennoblir",
      0.0125
    ],
    [
      "eriger",
      0.0125
    ],
    [
      "edifier",
      0.0125
    ],
    [
      "remonter",
      0.0125
    ],
    [
      "louer",
      0.0125
    ],
    [
      "cultiver",
      0.0125
    ],
    [
      "fortifier",
      0.01
    ],
    [
      "hisser",
      0.01
    ],
    [
      "jeter",
      0.01
    ],
    [
      "surhausser",
      0.01
    ],
    [
      "transporter",
      0.01
    ],
    [
      "revaloriser",
      0.0075
    ],
    [
      "promouvoir",
      0.0075
    ],
    [
      "planter",
      0.0075
    ],
    [
      "nourrir",
      0.0075
    ],
    [
      "glorifier",
      0.0075
    ],
    [
      "vanter",
      0.005
    ],
    [
      "soigner",
      0.005
    ],
    [
      "placer",
      0.005
    ],
    [
      "fonder",
      0.005
    ],
    [
      "catapulter",
      0.005
    ],
    [
      "intensifier",
      0.0025
    ],
    [
      "magnifier",
      0.0025
    ],
    [
      "orner",
      0.0025
    ],
    [
      "proner",
      0.0025
    ],
    [
      "styler",
      0.0025
    ],
    [
      "susciter",
      0.0025
    ],
    [
      "gouverner",
      0.0025
    ],
    [
      "entretenir",
      0.0025
    ],
    [
      "accentuer",
      0.0025
    ],
    [
      "affiner",
      0.0025
    ],
    [
      "arborer",
      0.0025
    ],
    [
      "bombarder",
      0.0025
    ],
    [
      "braquer",
      0.0025
    ],
    [
      "diviniser",
      0.0025
    ],
    [
      "enlever",
      0.0025
    ],
    [
      "majorer",
      0.0
    ],
    [
      "maconner",
      0.0
    ],
    [
      "modeler",
      0.0
    ],
    [
      "opposer",
      0.0
    ],
    [
      "poetiser",
      0.0
    ],
    [
      "guinder",
      0.0
    ],
    [
      "deifier",
      0.0
    ],
    [
      "discipliner",
      0.0
    ],
    [
      "civiliser",
      0.0
    ],
    [
      "brandir",
      0.0
    ],
    [
      "anoblir",
      0.0
    ],
    [
      "amasser",
      0.0
    ],
    [
      "allaiter",
      0.0
    ],
    [
      "sublimer",
      0.0
    ]
  ],
  "existant": [
    [
      "reel",
      0.2
    ],
    [
      "actuel",
      0.1325
    ],
    [
      "positif",
      0.1325
    ],
    [
      "present",
      0.1325
    ],
    [
      "tangible",
      0.1325
    ],
    [
      "vrai",
      0.1325
    ],
    [
      "sincere",
      0.065
    ],
    [
      "vivant",
      0.065
    ]
  ],
  "conceptuel": [
    [
      "ideel",
      0.2
    ],
    [
      "intellectuel",
      0.2
    ],
    [
      "notionnel",
      0.2
    ],
    [
      "speculatif",
      0.2
    ],
    [
      "theorique",
      0.2
    ]
  ],
  "cruel": [
    [
      "dur",
      0.0825
    ],
    [
      "mauvais",
      0.0675
    ],
    [
      "penible",
      0.05
    ],
    [
      "feroce",
      0.045
    ],
    [
      "terrible",
      0.045
    ],
    [
      "tendu",
      0.03
    ],
    [
      "inhumain",
      0.03
    ],
    [
      "implacable",
      0.03
    ],
    [
      "atroce",
      0.03
    ],
    [
      "triste",
      0.0275
    ],
    [
      "rude",
      0.0275
    ],
    [
      "severe",
      0.0275
    ],
    [
      "sauvage",
      0.02
    ],
    [
      "violent",
      0.02
    ],
    [
      "barbare",
      0.02
    ],
    [
      "douloureux",
      0.02
    ],
    [
      "amer",
      0.0175
    ],
    [
      "farouche",
      0.0175
    ],
    [
      "apre",
      0.0175
    ],
    [
      "cuisant",
      0.0175
    ],
    [
      "mechant",
      0.015
    ],
    [
      "affligeant",
      0.015
    ],
    [
      "affreux",
      0.015
    ],
    [
      "brutal",
      0.015
    ],
    [
      "impitoyable",
      0.0125
    ],
    [
      "poignant",
      0.0125
    ],
    [
      "epouvantable",
      0.0125
    ],
    [
      "torturant",
      0.0125
    ],
    [
      "rigide",
      0.0125
    ],
    [
      "dechirant",
      0.01
    ],
    [
      "inflexible",
      0.01
    ],
    [
      "sanguinaire",
      0.0075
    ],
    [
      "malheureux",
      0.0075
    ],
    [
      "insupportable",
      0.0075
    ],
    [
      "rigoureux",
      0.0075
    ],
    [
      "navrant",
      0.0075
    ],
    [
      "miserable",
      0.0075
    ],
    [
      "intolerable",
      0.0075
    ],
    [
      "insensible",
      0.0075
    ],
    [
      "horrible",
      0.0075
    ],
    [
      "grave",
      0.0075
    ],
    [
      "deplorable",
      0.0075
    ],
    [
      "ennuyeux",
      0.005
    ],
    [
      "inexorable",
      0.005
    ],
    [
      "tragique",
      0.005
    ],
    [
      "sanglant",
      0.005
    ],
    [
      "mortel",
      0.005
    ],
    [
      "facheux",
      0.005
    ],
    [
      "aigu",
      0.005
    ],
    [
      "abominable",
      0.005
    ],
    [
      "tortionnaire",
      0.0025
    ],
    [
      "sadique",
      0.0025
    ],
    [
      "intolerant",
      0.0025
    ],
    [
      "ingrat",
      0.0025
    ],
    [
      "indigne",
      0.0025
    ],
    [
      "hostile",
      0.0025
    ],
    [
      "denature",
      0.0025
    ],
    [
      "tyrannique",
      0.0
    ],
    [
      "forcene",
      0.0
    ],
    [
      "cinglant",
      0.0
    ],
    [
      "acharne",
      0.0
    ],
    [
      "maupiteux",
      0.0
    ],
    [
      "malfaisant",
      0.0
    ],
    [
      "indifferent",
      0.0
    ],
    [
      "furibond",
      0.0
    ],
    [
      "exterminateur",
      0.0
    ],
    [
      "draconien",
      0.0
    ],
    [
      "carnassier",
      0.0
    ],
    [
      "cannibale",
      0.0
    ],
    [
      "persecuteur",
      0.0
    ]
  ],
  "camera": [
    [
      "appareil",
      1.0
    ]
  ],
  "indien": [
    [
      "amerindien",
      0.25
    ],
    [
      "hindou",
      0.25
    ],
    [
      "indique",
      0.25
    ],
    [
      "individu",
      0.25
    ]
  ],
  "aquarelle": [
    [
      "dessin",
      0.2
    ],
    [
      "gouache",
      0.2
    ],
    [
      "image",
      0.2
    ],
    [
      "lavis",
      0.2
    ],
    [
      "peinture",
      0.2
    ]
  ],
  "lorsque": [
    [
      "quand",
      0.3325
    ]
  ],
  "fecond": [
    [
      "fertile",
      0.185
    ],
    [
      "abondant",
      0.1475
    ],
    [
      "genereux",
      0.0925
    ],
    [
      "productif",
      0.0725
    ],
    [
      "gras",
      0.055
    ],
    [
      "riche",
      0.035
    ],
    [
      "prolifique",
      0.035
    ],
    [
      "inepuisable",
      0.035
    ],
    [
      "inventif",
      0.035
    ],
    [
      "fructueux",
      0.035
    ],
    [
      "createur",
      0.035
    ],
    [
      "surabondant",
      0.0175
    ],
    [
      "producteur",
      0.0175
    ],
    [
      "prodigue",
      0.0175
    ],
    [
      "pondeur",
      0.0175
    ],
    [
      "plantureux",
      0.0175
    ],
    [
      "intarissable",
      0.0175
    ],
    [
      "imaginatif",
      0.0175
    ],
    [
      "gros",
      0.0175
    ],
    [
      "fecondant",
      0.0175
    ],
    [
      "fructifiant",
      0.0175
    ],
    [
      "fertilisant",
      0.0175
    ],
    [
      "ubereux",
      0.0175
    ]
  ],
  "feconder": [
    [
      "fertiliser",
      0.285
    ],
    [
      "concevoir",
      0.1425
    ],
    [
      "enrichir",
      0.1425
    ],
    [
      "ensemencer",
      0.1425
    ],
    [
      "impregner",
      0.1425
    ],
    [
      "reproduire",
      0.1425
    ]
  ],
  "immobile": [
    [
      "fige",
      0.07
    ],
    [
      "fixe",
      0.065
    ],
    [
      "immuable",
      0.0525
    ],
    [
      "inerte",
      0.045
    ],
    [
      "impassible",
      0.04
    ],
    [
      "stationnaire",
      0.03
    ],
    [
      "stable",
      0.03
    ],
    [
      "paralyse",
      0.03
    ],
    [
      "insensible",
      0.03
    ],
    [
      "ferme",
      0.03
    ],
    [
      "calme",
      0.03
    ],
    [
      "stagnant",
      0.025
    ],
    [
      "inactif",
      0.025
    ],
    [
      "gele",
      0.025
    ],
    [
      "tranquille",
      0.0175
    ],
    [
      "stupefait",
      0.0175
    ],
    [
      "petrifie",
      0.0175
    ],
    [
      "inebranlable",
      0.0175
    ],
    [
      "invariable",
      0.0175
    ],
    [
      "interdit",
      0.0175
    ],
    [
      "glace",
      0.0175
    ],
    [
      "engourdi",
      0.0175
    ],
    [
      "dormant",
      0.0175
    ],
    [
      "etale",
      0.0125
    ],
    [
      "sedentaire",
      0.0125
    ],
    [
      "stupide",
      0.0125
    ],
    [
      "sidere",
      0.0125
    ],
    [
      "passif",
      0.0125
    ],
    [
      "meduse",
      0.0125
    ],
    [
      "interloque",
      0.0125
    ],
    [
      "inanime",
      0.0125
    ],
    [
      "atone",
      0.0125
    ],
    [
      "arrete",
      0.0125
    ],
    [
      "serein",
      0.005
    ],
    [
      "sclerose",
      0.005
    ],
    [
      "rive",
      0.005
    ],
    [
      "plante",
      0.005
    ],
    [
      "statique",
      0.005
    ],
    [
      "stoppe",
      0.005
    ],
    [
      "stupefie",
      0.005
    ],
    [
      "stereotype",
      0.005
    ],
    [
      "visse",
      0.005
    ],
    [
      "paisible",
      0.005
    ],
    [
      "immobilise",
      0.005
    ],
    [
      "cale",
      0.005
    ],
    [
      "cloue",
      0.005
    ],
    [
      "croupi",
      0.005
    ],
    [
      "croupissant",
      0.005
    ],
    [
      "dormante",
      0.005
    ],
    [
      "gisant",
      0.005
    ],
    [
      "grippe",
      0.005
    ],
    [
      "hieratique",
      0.005
    ]
  ],
  "fonder": [
    [
      "etablir",
      0.175
    ],
    [
      "creer",
      0.0825
    ],
    [
      "constituer",
      0.075
    ],
    [
      "asseoir",
      0.07
    ],
    [
      "batir",
      0.0625
    ],
    [
      "construire",
      0.055
    ],
    [
      "former",
      0.04
    ],
    [
      "instituer",
      0.04
    ],
    [
      "placer",
      0.035
    ],
    [
      "baser",
      0.035
    ],
    [
      "appuyer",
      0.0275
    ],
    [
      "organiser",
      0.0275
    ],
    [
      "poser",
      0.0275
    ],
    [
      "edifier",
      0.0275
    ],
    [
      "eriger",
      0.0275
    ],
    [
      "elever",
      0.02
    ],
    [
      "mettre",
      0.02
    ],
    [
      "echafauder",
      0.0125
    ],
    [
      "tabler",
      0.0125
    ],
    [
      "reposer",
      0.0125
    ],
    [
      "motiver",
      0.0125
    ],
    [
      "commencer",
      0.0125
    ],
    [
      "assurer",
      0.0125
    ],
    [
      "lancer",
      0.005
    ],
    [
      "justifier",
      0.005
    ],
    [
      "instaurer",
      0.005
    ],
    [
      "forger",
      0.005
    ],
    [
      "enter",
      0.005
    ],
    [
      "engendrer",
      0.005
    ],
    [
      "compter",
      0.005
    ],
    [
      "affermir",
      0.005
    ],
    [
      "ouvrir",
      0.005
    ]
  ],
  "fonde": [
    [
      "etablir",
      0.175
    ],
    [
      "creer",
      0.0825
    ],
    [
      "constituer",
      0.075
    ],
    [
      "asseoir",
      0.07
    ],
    [
      "batir",
      0.0625
    ],
    [
      "construire",
      0.055
    ],
    [
      "former",
      0.04
    ],
    [
      "instituer",
      0.04
    ],
    [
      "placer",
      0.035
    ],
    [
      "baser",
      0.035
    ],
    [
      "appuyer",
      0.0275
    ],
    [
      "organiser",
      0.0275
    ],
    [
      "poser",
      0.0275
    ],
    [
      "edifier",
      0.0275
    ],
    [
      "eriger",
      0.0275
    ],
    [
      "elever",
      0.02
    ],
    [
      "mettre",
      0.02
    ],
    [
      "echafauder",
      0.0125
    ],
    [
      "tabler",
      0.0125
    ],
    [
      "reposer",
      0.0125
    ],
    [
      "motiver",
      0.0125
    ],
    [
      "commencer",
      0.0125
    ],
    [
      "assurer",
      0.0125
    ],
    [
      "lancer",
      0.005
    ],
    [
      "justifier",
      0.005
    ],
    [
      "instaurer",
      0.005
    ],
    [
      "forger",
      0.005
    ],
    [
      "enter",
      0.005
    ],
    [
      "engendrer",
      0.005
    ],
    [
      "compter",
      0.005
    ],
    [
      "affermir",
      0.005
    ],
    [
      "ouvrir",
      0.005
    ]
  ],
  "devancer": [
    [
      "surpasser",
      0.1175
    ],
    [
      "depasser",
      0.1075
    ],
    [
      "distancer",
      0.0775
    ],
    [
      "passer",
      0.0775
    ],
    [
      "preceder",
      0.0575
    ],
    [
      "surclasser",
      0.0575
    ],
    [
      "prevenir",
      0.0475
    ],
    [
      "enfoncer",
      0.0475
    ],
    [
      "surmonter",
      0.0375
    ],
    [
      "l'emporter",
      0.0275
    ],
    [
      "escompter",
      0.0275
    ],
    [
      "battre",
      0.0275
    ],
    [
      "avancer",
      0.0275
    ],
    [
      "anticiper",
      0.0275
    ],
    [
      "aller",
      0.0275
    ],
    [
      "eviter",
      0.0175
    ],
    [
      "primer",
      0.0175
    ],
    [
      "griller",
      0.0175
    ],
    [
      "gratter",
      0.0175
    ],
    [
      "arriver",
      0.0075
    ],
    [
      "emporter",
      0.0075
    ],
    [
      "prevoir",
      0.0075
    ],
    [
      "semer",
      0.0075
    ]
  ],
  "essouffle": [
    [
      "oppresser",
      0.5
    ],
    [
      "suffoquer",
      0.5
    ]
  ],
  "essouffler": [
    [
      "oppresser",
      0.5
    ],
    [
      "suffoquer",
      0.5
    ]
  ],
  "preceder": [
    [
      "devancer",
      0.23
    ],
    [
      "passer",
      0.115
    ],
    [
      "prevenir",
      0.075
    ],
    [
      "distancer",
      0.075
    ],
    [
      "annoncer",
      0.075
    ],
    [
      "amener",
      0.075
    ],
    [
      "aller",
      0.075
    ],
    [
      "depasser",
      0.0375
    ],
    [
      "diriger",
      0.0375
    ],
    [
      "arriver",
      0.0375
    ],
    [
      "appeler",
      0.0375
    ],
    [
      "preluder",
      0.0375
    ]
  ],
  "desinvolture": [
    [
      "liberte",
      0.09
    ],
    [
      "impertinence",
      0.0775
    ],
    [
      "impudence",
      0.0675
    ],
    [
      "hardiesse",
      0.055
    ],
    [
      "facilite",
      0.055
    ],
    [
      "effronterie",
      0.055
    ],
    [
      "aisance",
      0.055
    ],
    [
      "abandon",
      0.045
    ],
    [
      "inconvenance",
      0.045
    ],
    [
      "legerete",
      0.0325
    ],
    [
      "irreverence",
      0.0325
    ],
    [
      "incorrection",
      0.0325
    ],
    [
      "impolitesse",
      0.0325
    ],
    [
      "grossierete",
      0.0325
    ],
    [
      "familiarite",
      0.0325
    ],
    [
      "toupet",
      0.02
    ],
    [
      "indifference",
      0.02
    ],
    [
      "detachement",
      0.02
    ],
    [
      "privaute",
      0.01
    ],
    [
      "negligence",
      0.01
    ],
    [
      "inelegance",
      0.01
    ],
    [
      "grace",
      0.01
    ],
    [
      "desinvolte",
      0.01
    ],
    [
      "decontraction",
      0.01
    ],
    [
      "chic",
      0.01
    ],
    [
      "brio",
      0.01
    ],
    [
      "arrogance",
      0.01
    ],
    [
      "aplomb",
      0.01
    ]
  ],
  "fige": [
    [
      "geler",
      0.1325
    ],
    [
      "petrifier",
      0.11
    ],
    [
      "immobiliser",
      0.0775
    ],
    [
      "prendre",
      0.0775
    ],
    [
      "caillebotter",
      0.065
    ],
    [
      "solidifier",
      0.055
    ],
    [
      "paralyser",
      0.055
    ],
    [
      "coaguler",
      0.055
    ],
    [
      "clouer",
      0.0425
    ],
    [
      "fixer",
      0.0425
    ],
    [
      "glacer",
      0.0425
    ],
    [
      "congeler",
      0.0325
    ],
    [
      "epaissir",
      0.02
    ],
    [
      "tetaniser",
      0.02
    ],
    [
      "transir",
      0.02
    ],
    [
      "suspendre",
      0.02
    ],
    [
      "statufier",
      0.02
    ],
    [
      "raidir",
      0.01
    ],
    [
      "condenser",
      0.01
    ],
    [
      "cailler",
      0.01
    ],
    [
      "stabiliser",
      0.01
    ]
  ],
  "figer": [
    [
      "geler",
      0.1325
    ],
    [
      "petrifier",
      0.11
    ],
    [
      "immobiliser",
      0.0775
    ],
    [
      "prendre",
      0.0775
    ],
    [
      "caillebotter",
      0.065
    ],
    [
      "solidifier",
      0.055
    ],
    [
      "paralyser",
      0.055
    ],
    [
      "coaguler",
      0.055
    ],
    [
      "clouer",
      0.0425
    ],
    [
      "fixer",
      0.0425
    ],
    [
      "glacer",
      0.0425
    ],
    [
      "congeler",
      0.0325
    ],
    [
      "epaissir",
      0.02
    ],
    [
      "tetaniser",
      0.02
    ],
    [
      "transir",
      0.02
    ],
    [
      "suspendre",
      0.02
    ],
    [
      "statufier",
      0.02
    ],
    [
      "raidir",
      0.01
    ],
    [
      "condenser",
      0.01
    ],
    [
      "cailler",
      0.01
    ],
    [
      "stabiliser",
      0.01
    ]
  ],
  "ambiguite": [
    [
      "incertitude",
      0.1875
    ],
    [
      "equivoque",
      0.1875
    ],
    [
      "amphibologie",
      0.125
    ],
    [
      "obscurite",
      0.125
    ],
    [
      "bivalence",
      0.06
    ],
    [
      "ambivalence",
      0.06
    ],
    [
      "ambages",
      0.06
    ],
    [
      "enigme",
      0.06
    ]
  ],
  "asexue": [
    [
      "agame",
      0.3325
    ],
    [
      "asexuel",
      0.3325
    ],
    [
      "insexue",
      0.3325
    ]
  ],
  "exagerer": [
    [
      "grossir",
      0.1075
    ],
    [
      "rencherir",
      0.1
    ],
    [
      "amplifier",
      0.09
    ],
    [
      "augmenter",
      0.0725
    ],
    [
      "surfaire",
      0.0425
    ],
    [
      "enfler",
      0.04
    ],
    [
      "forcer",
      0.0325
    ],
    [
      "pousser",
      0.03
    ],
    [
      "outrer",
      0.03
    ],
    [
      "grandir",
      0.03
    ],
    [
      "charger",
      0.0275
    ],
    [
      "gonfler",
      0.0275
    ],
    [
      "habler",
      0.02
    ],
    [
      "romancer",
      0.0175
    ],
    [
      "majorer",
      0.0175
    ],
    [
      "developper",
      0.0175
    ],
    [
      "broder",
      0.0175
    ],
    [
      "bluffer",
      0.0175
    ],
    [
      "ajouter",
      0.0175
    ],
    [
      "agrandir",
      0.015
    ],
    [
      "dramatiser",
      0.015
    ],
    [
      "charrier",
      0.0125
    ],
    [
      "bourrer",
      0.0125
    ],
    [
      "accentuer",
      0.0125
    ],
    [
      "abuser",
      0.0125
    ],
    [
      "galejer",
      0.0075
    ],
    [
      "depasser",
      0.0075
    ],
    [
      "attiger",
      0.0075
    ],
    [
      "aggraver",
      0.0075
    ],
    [
      "rajouter",
      0.005
    ],
    [
      "multiplier",
      0.005
    ],
    [
      "blaguer",
      0.005
    ],
    [
      "accuser",
      0.005
    ],
    [
      "inventer",
      0.0025
    ],
    [
      "masser",
      0.0025
    ],
    [
      "mesuser",
      0.0025
    ],
    [
      "remettre",
      0.0025
    ],
    [
      "gasconner",
      0.0025
    ],
    [
      "franchir",
      0.0025
    ],
    [
      "cherrer",
      0.0025
    ],
    [
      "chariboter",
      0.0025
    ],
    [
      "appuyer",
      0.0025
    ],
    [
      "surestimer",
      0.0025
    ]
  ],
  "repassage": [
    [
      "affilage",
      0.25
    ],
    [
      "affutage",
      0.25
    ],
    [
      "aiguisage",
      0.25
    ],
    [
      "blanchissage",
      0.25
    ]
  ],
  "repose": [
    [
      "appuyer",
      0.115
    ],
    [
      "poser",
      0.085
    ],
    [
      "etablir",
      0.055
    ],
    [
      "s'appuyer",
      0.055
    ],
    [
      "rouler",
      0.055
    ],
    [
      "porter",
      0.055
    ],
    [
      "fonder",
      0.055
    ],
    [
      "deposer",
      0.055
    ],
    [
      "sommeiller",
      0.0275
    ],
    [
      "somnoler",
      0.0275
    ],
    [
      "resider",
      0.0275
    ],
    [
      "remettre",
      0.0275
    ],
    [
      "rasseoir",
      0.0275
    ],
    [
      "detendre",
      0.0275
    ],
    [
      "dependre",
      0.0275
    ],
    [
      "delasser",
      0.0275
    ],
    [
      "dormir",
      0.0275
    ],
    [
      "consister",
      0.0275
    ],
    [
      "baser",
      0.0275
    ],
    [
      "etanconner",
      0.0275
    ]
  ],
  "assurer": [
    [
      "affirmer",
      0.075
    ],
    [
      "fixer",
      0.06
    ],
    [
      "soutenir",
      0.0525
    ],
    [
      "arrimer",
      0.045
    ],
    [
      "certifier",
      0.045
    ],
    [
      "maintenir",
      0.04
    ],
    [
      "temoigner",
      0.035
    ],
    [
      "garantir",
      0.03
    ],
    [
      "declarer",
      0.0275
    ],
    [
      "dire",
      0.0275
    ],
    [
      "consolider",
      0.0275
    ],
    [
      "assujettir",
      0.0275
    ],
    [
      "attacher",
      0.025
    ],
    [
      "proteger",
      0.025
    ],
    [
      "repondre",
      0.0225
    ],
    [
      "jurer",
      0.0225
    ],
    [
      "fortifier",
      0.0225
    ],
    [
      "confirmer",
      0.0225
    ],
    [
      "affermir",
      0.0225
    ],
    [
      "arreter",
      0.0175
    ],
    [
      "caler",
      0.0175
    ],
    [
      "immobiliser",
      0.0175
    ],
    [
      "renforcer",
      0.0175
    ],
    [
      "retenir",
      0.0175
    ],
    [
      "raffermir",
      0.015
    ],
    [
      "defendre",
      0.015
    ],
    [
      "coincer",
      0.015
    ],
    [
      "attester",
      0.01
    ],
    [
      "promettre",
      0.01
    ],
    [
      "pretendre",
      0.01
    ],
    [
      "procurer",
      0.0075
    ],
    [
      "prendre",
      0.0075
    ],
    [
      "pourvoir",
      0.0075
    ],
    [
      "donner",
      0.0075
    ],
    [
      "etayer",
      0.0075
    ],
    [
      "preserver",
      0.0075
    ],
    [
      "protester",
      0.0075
    ],
    [
      "persuader",
      0.0075
    ],
    [
      "asseoir",
      0.0075
    ],
    [
      "amarrer",
      0.0075
    ],
    [
      "veiller",
      0.0025
    ],
    [
      "signaler",
      0.0025
    ],
    [
      "sauvegarder",
      0.0025
    ],
    [
      "fonder",
      0.0025
    ],
    [
      "approvisionner",
      0.0025
    ],
    [
      "accorer",
      0.0025
    ],
    [
      "menager",
      0.0
    ],
    [
      "parier",
      0.0
    ],
    [
      "proner",
      0.0
    ],
    [
      "ravitailler",
      0.0
    ],
    [
      "reconnaitre",
      0.0
    ],
    [
      "tranquilliser",
      0.0
    ],
    [
      "emprisonner",
      0.0
    ],
    [
      "convaincre",
      0.0
    ],
    [
      "constituer",
      0.0
    ],
    [
      "boutonner",
      0.0
    ],
    [
      "boulonner",
      0.0
    ],
    [
      "assumer",
      0.0
    ],
    [
      "arborer",
      0.0
    ],
    [
      "valoir",
      0.0
    ]
  ],
  "maquillage": [
    [
      "falsification",
      0.1875
    ],
    [
      "alteration",
      0.125
    ],
    [
      "fard",
      0.125
    ],
    [
      "tripotage",
      0.125
    ],
    [
      "mutilation",
      0.06
    ],
    [
      "maquignonnage",
      0.06
    ],
    [
      "grimage",
      0.06
    ],
    [
      "grimace",
      0.06
    ],
    [
      "fardage",
      0.06
    ],
    [
      "camouflage",
      0.06
    ],
    [
      "truquage",
      0.06
    ]
  ],
  "masturber": [],
  "reconforter": [
    [
      "revigorer",
      0.1175
    ],
    [
      "remonter",
      0.08
    ],
    [
      "ranimer",
      0.0775
    ],
    [
      "fortifier",
      0.05
    ],
    [
      "restaurer",
      0.045
    ],
    [
      "revivifier",
      0.045
    ],
    [
      "soutenir",
      0.045
    ],
    [
      "stimuler",
      0.0425
    ],
    [
      "vivifier",
      0.035
    ],
    [
      "ravigoter",
      0.0325
    ],
    [
      "conforter",
      0.03
    ],
    [
      "reveiller",
      0.03
    ],
    [
      "encourager",
      0.025
    ],
    [
      "exciter",
      0.025
    ],
    [
      "relever",
      0.0225
    ],
    [
      "retaper",
      0.0225
    ],
    [
      "retablir",
      0.0225
    ],
    [
      "reparer",
      0.02
    ],
    [
      "remettre",
      0.02
    ],
    [
      "ragaillardir",
      0.02
    ],
    [
      "aider",
      0.02
    ],
    [
      "rafraichir",
      0.015
    ],
    [
      "raviver",
      0.015
    ],
    [
      "ressusciter",
      0.015
    ],
    [
      "refaire",
      0.0125
    ],
    [
      "requinquer",
      0.0125
    ],
    [
      "servir",
      0.01
    ],
    [
      "consoler",
      0.01
    ],
    [
      "affermir",
      0.01
    ],
    [
      "assister",
      0.005
    ],
    [
      "renforcer",
      0.005
    ],
    [
      "rechauffer",
      0.005
    ],
    [
      "soulager",
      0.005
    ],
    [
      "enhardir",
      0.0025
    ],
    [
      "rambiner",
      0.0025
    ],
    [
      "sustenter",
      0.0025
    ]
  ],
  "larguer": [
    [
      "abandonner",
      0.15
    ],
    [
      "balancer",
      0.15
    ],
    [
      "lacher",
      0.15
    ],
    [
      "jeter",
      0.12
    ],
    [
      "lancer",
      0.09
    ],
    [
      "vider",
      0.06
    ],
    [
      "plaquer",
      0.06
    ],
    [
      "filer",
      0.06
    ],
    [
      "droper",
      0.03
    ],
    [
      "deferler",
      0.03
    ],
    [
      "detacher",
      0.03
    ],
    [
      "lourder",
      0.03
    ],
    [
      "renvoyer",
      0.03
    ]
  ],
  "confetti": [],
  "amigo": [],
  "crotte": [
    [
      "boue",
      0.1325
    ],
    [
      "excrement",
      0.0775
    ],
    [
      "gadoue",
      0.0775
    ],
    [
      "merde",
      0.0775
    ],
    [
      "misere",
      0.0775
    ],
    [
      "zut",
      0.0525
    ],
    [
      "salete",
      0.0525
    ],
    [
      "fange",
      0.0525
    ],
    [
      "crasse",
      0.0525
    ],
    [
      "truffe",
      0.025
    ],
    [
      "sentinelle",
      0.025
    ],
    [
      "pauvrete",
      0.025
    ],
    [
      "noix",
      0.025
    ],
    [
      "noisette",
      0.025
    ],
    [
      "limon",
      0.025
    ],
    [
      "flute",
      0.025
    ],
    [
      "crottin",
      0.025
    ],
    [
      "coquille",
      0.025
    ],
    [
      "chocolat",
      0.025
    ],
    [
      "caque",
      0.025
    ],
    [
      "biquette",
      0.025
    ],
    [
      "etron",
      0.025
    ]
  ],
  "initial": [
    [
      "premier",
      0.125
    ],
    [
      "primitif",
      0.125
    ],
    [
      "elementaire",
      0.125
    ],
    [
      "originaire",
      0.1
    ],
    [
      "primaire",
      0.075
    ],
    [
      "naturel",
      0.075
    ],
    [
      "inne",
      0.075
    ],
    [
      "fondamental",
      0.075
    ],
    [
      "originel",
      0.05
    ],
    [
      "primordial",
      0.05
    ],
    [
      "commencant",
      0.025
    ],
    [
      "debutant",
      0.025
    ],
    [
      "original",
      0.025
    ],
    [
      "rudimentaire",
      0.025
    ],
    [
      "sigle",
      0.025
    ]
  ],
  "massage": [
    [
      "friction",
      0.4
    ],
    [
      "bouchonnage",
      0.2
    ],
    [
      "remede",
      0.2
    ],
    [
      "sismotherapie",
      0.2
    ]
  ],
  "tibetain": [],
  "vexer": [
    [
      "blesser",
      0.12
    ],
    [
      "froisser",
      0.1075
    ],
    [
      "deplaire",
      0.0725
    ],
    [
      "offenser",
      0.0725
    ],
    [
      "desobliger",
      0.06
    ],
    [
      "choquer",
      0.06
    ],
    [
      "indisposer",
      0.0475
    ],
    [
      "piquer",
      0.0475
    ],
    [
      "offusquer",
      0.035
    ],
    [
      "mortifier",
      0.035
    ],
    [
      "molester",
      0.035
    ],
    [
      "heurter",
      0.035
    ],
    [
      "contrarier",
      0.035
    ],
    [
      "tourmenter",
      0.0225
    ],
    [
      "moucher",
      0.0225
    ],
    [
      "inquieter",
      0.0225
    ],
    [
      "humilier",
      0.0225
    ],
    [
      "depiter",
      0.0225
    ],
    [
      "cingler",
      0.0225
    ],
    [
      "brimer",
      0.0225
    ],
    [
      "aigrir",
      0.01
    ]
  ],
  "vexant": [
    [
      "blessant",
      0.1775
    ],
    [
      "desagreable",
      0.1275
    ],
    [
      "agacant",
      0.1025
    ],
    [
      "outrageant",
      0.075
    ],
    [
      "enervant",
      0.05
    ],
    [
      "offensant",
      0.05
    ],
    [
      "mortifiant",
      0.05
    ],
    [
      "irritant",
      0.05
    ],
    [
      "exasperant",
      0.05
    ],
    [
      "desobligeant",
      0.05
    ],
    [
      "contrariant",
      0.05
    ],
    [
      "cinglant",
      0.025
    ],
    [
      "froissant",
      0.025
    ],
    [
      "horripilant",
      0.025
    ],
    [
      "humiliant",
      0.025
    ],
    [
      "piquant",
      0.025
    ],
    [
      "rageant",
      0.025
    ]
  ],
  "interesser": [
    [
      "toucher",
      0.1025
    ],
    [
      "concerner",
      0.0775
    ],
    [
      "emouvoir",
      0.05
    ],
    [
      "regarder",
      0.05
    ],
    [
      "piquer",
      0.05
    ],
    [
      "gagner",
      0.05
    ],
    [
      "captiver",
      0.05
    ],
    [
      "attacher",
      0.05
    ],
    [
      "aller",
      0.05
    ],
    [
      "blesser",
      0.0375
    ],
    [
      "viser",
      0.0375
    ],
    [
      "s'appliquer",
      0.025
    ],
    [
      "s'adresser",
      0.025
    ],
    [
      "plaire",
      0.025
    ],
    [
      "passionner",
      0.025
    ],
    [
      "occuper",
      0.025
    ],
    [
      "affecter",
      0.025
    ],
    [
      "suivre",
      0.0125
    ],
    [
      "leser",
      0.0125
    ],
    [
      "intriguer",
      0.0125
    ],
    [
      "importer",
      0.0125
    ],
    [
      "desirer",
      0.0125
    ],
    [
      "chaloir",
      0.0125
    ],
    [
      "attendrir",
      0.0125
    ],
    [
      "associer",
      0.0125
    ],
    [
      "animer",
      0.0125
    ],
    [
      "amuser",
      0.0125
    ],
    [
      "valoir",
      0.0125
    ]
  ],
  "considerer": [
    [
      "estimer",
      0.1025
    ],
    [
      "examiner",
      0.085
    ],
    [
      "regarder",
      0.085
    ],
    [
      "penser",
      0.065
    ],
    [
      "voir",
      0.0575
    ],
    [
      "juger",
      0.05
    ],
    [
      "prendre",
      0.0325
    ],
    [
      "peser",
      0.0325
    ],
    [
      "compter",
      0.0325
    ],
    [
      "apprecier",
      0.03
    ],
    [
      "etudier",
      0.03
    ],
    [
      "envisager",
      0.0275
    ],
    [
      "croire",
      0.0225
    ],
    [
      "reputer",
      0.02
    ],
    [
      "reflechir",
      0.02
    ],
    [
      "observer",
      0.02
    ],
    [
      "contempler",
      0.015
    ],
    [
      "traiter",
      0.015
    ],
    [
      "trouver",
      0.0125
    ],
    [
      "s'attacher",
      0.0125
    ],
    [
      "connaitre",
      0.0125
    ],
    [
      "ecouter",
      0.01
    ],
    [
      "venerer",
      0.01
    ],
    [
      "sonder",
      0.01
    ],
    [
      "honorer",
      0.01
    ],
    [
      "analyser",
      0.01
    ],
    [
      "tourner",
      0.005
    ],
    [
      "songer",
      0.005
    ],
    [
      "respecter",
      0.005
    ],
    [
      "mettre",
      0.005
    ],
    [
      "discuter",
      0.005
    ],
    [
      "approfondir",
      0.005
    ],
    [
      "admirer",
      0.005
    ],
    [
      "reverer",
      0.0025
    ],
    [
      "repenser",
      0.0025
    ],
    [
      "entrer",
      0.0025
    ],
    [
      "balancer",
      0.0025
    ],
    [
      "toiser",
      0.0025
    ]
  ],
  "remis": [
    [
      "donner",
      0.035
    ],
    [
      "retarder",
      0.035
    ],
    [
      "renvoyer",
      0.0325
    ],
    [
      "retablir",
      0.03
    ],
    [
      "differer",
      0.0275
    ],
    [
      "reculer",
      0.0275
    ],
    [
      "repousser",
      0.0225
    ],
    [
      "abandonner",
      0.0225
    ],
    [
      "ramener",
      0.0225
    ],
    [
      "rendre",
      0.0225
    ],
    [
      "temporiser",
      0.0175
    ],
    [
      "remonter",
      0.0175
    ],
    [
      "rapporter",
      0.0175
    ],
    [
      "mettre",
      0.0175
    ],
    [
      "transmettre",
      0.0175
    ],
    [
      "restaurer",
      0.0175
    ],
    [
      "relever",
      0.0175
    ],
    [
      "redonner",
      0.0175
    ],
    [
      "laisser",
      0.0175
    ],
    [
      "ajourner",
      0.0175
    ],
    [
      "surseoir",
      0.0125
    ],
    [
      "reconforter",
      0.0125
    ],
    [
      "revigorer",
      0.0125
    ],
    [
      "reporter",
      0.0125
    ],
    [
      "proroger",
      0.0125
    ],
    [
      "transporter",
      0.01
    ],
    [
      "retourner",
      0.01
    ],
    [
      "restituer",
      0.01
    ],
    [
      "refaire",
      0.01
    ],
    [
      "rapprocher",
      0.01
    ],
    [
      "raccommoder",
      0.01
    ],
    [
      "deposer",
      0.01
    ],
    [
      "accorder",
      0.01
    ],
    [
      "retroceder",
      0.0075
    ],
    [
      "retaper",
      0.0075
    ],
    [
      "ressusciter",
      0.0075
    ],
    [
      "passer",
      0.0075
    ],
    [
      "livrer",
      0.0075
    ],
    [
      "atermoyer",
      0.0075
    ],
    [
      "ranger",
      0.005
    ],
    [
      "reconnaitre",
      0.005
    ],
    [
      "renoncer",
      0.005
    ],
    [
      "repasser",
      0.005
    ],
    [
      "requinquer",
      0.005
    ],
    [
      "retrouver",
      0.005
    ],
    [
      "reduire",
      0.005
    ],
    [
      "suspendre",
      0.005
    ],
    [
      "rabibocher",
      0.005
    ],
    [
      "pardonner",
      0.005
    ],
    [
      "abolir",
      0.005
    ],
    [
      "attendre",
      0.005
    ],
    [
      "confier",
      0.005
    ],
    [
      "consigner",
      0.005
    ],
    [
      "excuser",
      0.005
    ],
    [
      "guerir",
      0.005
    ],
    [
      "leguer",
      0.005
    ],
    [
      "remiser",
      0.0025
    ],
    [
      "remmener",
      0.0025
    ],
    [
      "remplacer",
      0.0025
    ],
    [
      "rentrer",
      0.0025
    ],
    [
      "replacer",
      0.0025
    ],
    [
      "reintegrer",
      0.0025
    ],
    [
      "tarder",
      0.0025
    ],
    [
      "eloigner",
      0.0025
    ],
    [
      "redresser",
      0.0025
    ],
    [
      "reconduire",
      0.0025
    ],
    [
      "ravigoter",
      0.0025
    ],
    [
      "absoudre",
      0.0025
    ],
    [
      "allonger",
      0.0025
    ],
    [
      "amnistier",
      0.0025
    ],
    [
      "commettre",
      0.0025
    ],
    [
      "concilier",
      0.0025
    ],
    [
      "delivrer",
      0.0025
    ],
    [
      "lanterner",
      0.0025
    ],
    [
      "payer",
      0.0025
    ],
    [
      "rajouter",
      0.0025
    ],
    [
      "rembarrer",
      0.0
    ],
    [
      "remboiter",
      0.0
    ],
    [
      "remener",
      0.0
    ],
    [
      "reposer",
      0.0
    ],
    [
      "reendosser",
      0.0
    ],
    [
      "reunir",
      0.0
    ],
    [
      "recommencer",
      0.0
    ],
    [
      "rebouter",
      0.0
    ],
    [
      "rapatrier",
      0.0
    ],
    [
      "adjuger",
      0.0
    ],
    [
      "alleger",
      0.0
    ],
    [
      "exagerer",
      0.0
    ],
    [
      "identifier",
      0.0
    ],
    [
      "poster",
      0.0
    ],
    [
      "rabrouer",
      0.0
    ],
    [
      "rapapilloter",
      0.0
    ],
    [
      "tranquilliser",
      0.0
    ]
  ],
  "autoroute": [
    [
      "autopiste",
      0.2
    ],
    [
      "autostrade",
      0.2
    ],
    [
      "penetrante",
      0.2
    ],
    [
      "route",
      0.2
    ],
    [
      "voie",
      0.2
    ]
  ],
  "best": [],
  "bague": [
    [
      "anneau",
      0.235
    ],
    [
      "bracelet",
      0.1
    ],
    [
      "diamant",
      0.1
    ],
    [
      "cercle",
      0.065
    ],
    [
      "solitaire",
      0.065
    ],
    [
      "coussinet",
      0.0325
    ],
    [
      "jonc",
      0.0325
    ],
    [
      "manchon",
      0.0325
    ],
    [
      "marguerite",
      0.0325
    ],
    [
      "marquise",
      0.0325
    ],
    [
      "collier",
      0.0325
    ],
    [
      "chevaliere",
      0.0325
    ],
    [
      "brillant",
      0.0325
    ],
    [
      "bagouse",
      0.0325
    ],
    [
      "bagage",
      0.0325
    ],
    [
      "annelure",
      0.0325
    ],
    [
      "alliance",
      0.0325
    ],
    [
      "semaine",
      0.0325
    ]
  ],
  "baguer": [
    [
      "faufiler",
      0.25
    ],
    [
      "marquer",
      0.25
    ],
    [
      "ecorcer",
      0.25
    ],
    [
      "etiqueter",
      0.25
    ]
  ],
  "lacte": [
    [
      "blanc",
      0.25
    ],
    [
      "blanchatre",
      0.25
    ],
    [
      "lactescent",
      0.25
    ],
    [
      "laiteux",
      0.25
    ]
  ],
  "soutenir": [
    [
      "appuyer",
      0.08
    ],
    [
      "aider",
      0.04
    ],
    [
      "fortifier",
      0.04
    ],
    [
      "assurer",
      0.0375
    ],
    [
      "etayer",
      0.0325
    ],
    [
      "maintenir",
      0.03
    ],
    [
      "proteger",
      0.03
    ],
    [
      "reconforter",
      0.025
    ],
    [
      "affirmer",
      0.0225
    ],
    [
      "encourager",
      0.0225
    ],
    [
      "servir",
      0.0225
    ],
    [
      "confirmer",
      0.02
    ],
    [
      "tenir",
      0.02
    ],
    [
      "remonter",
      0.02
    ],
    [
      "ranimer",
      0.02
    ],
    [
      "defendre",
      0.02
    ],
    [
      "consolider",
      0.0175
    ],
    [
      "stimuler",
      0.0175
    ],
    [
      "epauler",
      0.0175
    ],
    [
      "exciter",
      0.015
    ],
    [
      "temoigner",
      0.0125
    ],
    [
      "supporter",
      0.0125
    ],
    [
      "suivre",
      0.0125
    ],
    [
      "revigorer",
      0.0125
    ],
    [
      "porter",
      0.0125
    ],
    [
      "fixer",
      0.0125
    ],
    [
      "garantir",
      0.0125
    ],
    [
      "favoriser",
      0.0125
    ],
    [
      "certifier",
      0.0125
    ],
    [
      "assister",
      0.01
    ],
    [
      "continuer",
      0.01
    ],
    [
      "dire",
      0.01
    ],
    [
      "raffermir",
      0.01
    ],
    [
      "restaurer",
      0.01
    ],
    [
      "reveiller",
      0.0075
    ],
    [
      "poser",
      0.0075
    ],
    [
      "caler",
      0.0075
    ],
    [
      "pretendre",
      0.005
    ],
    [
      "patronner",
      0.005
    ],
    [
      "jurer",
      0.005
    ],
    [
      "entretenir",
      0.005
    ],
    [
      "corroborer",
      0.005
    ],
    [
      "conforter",
      0.005
    ],
    [
      "attiser",
      0.005
    ],
    [
      "rehausser",
      0.0025
    ],
    [
      "reparer",
      0.0025
    ],
    [
      "repondre",
      0.0025
    ],
    [
      "resister",
      0.0025
    ],
    [
      "seconder",
      0.0025
    ],
    [
      "secourir",
      0.0025
    ],
    [
      "souffrir",
      0.0025
    ],
    [
      "subir",
      0.0025
    ],
    [
      "suppleer",
      0.0025
    ],
    [
      "professer",
      0.0025
    ],
    [
      "poursuivre",
      0.0025
    ],
    [
      "pistonner",
      0.0025
    ],
    [
      "aiguillonner",
      0.0025
    ],
    [
      "arrimer",
      0.0025
    ],
    [
      "attester",
      0.0025
    ],
    [
      "avancer",
      0.0025
    ],
    [
      "discuter",
      0.0025
    ],
    [
      "nourrir",
      0.0025
    ],
    [
      "participer",
      0.0025
    ],
    [
      "persister",
      0.0025
    ],
    [
      "perseverer",
      0.0025
    ],
    [
      "parrainer",
      0.0025
    ],
    [
      "promouvoir",
      0.0025
    ],
    [
      "recevoir",
      0.0025
    ],
    [
      "repecher",
      0.0025
    ],
    [
      "rechauffer",
      0.0025
    ],
    [
      "sustenter",
      0.0025
    ],
    [
      "ecrire",
      0.0025
    ],
    [
      "etanconner",
      0.0025
    ],
    [
      "accoter",
      0.0025
    ],
    [
      "adosser",
      0.0025
    ],
    [
      "alimenter",
      0.0025
    ],
    [
      "argumenter",
      0.0025
    ],
    [
      "armer",
      0.0025
    ],
    [
      "cautionner",
      0.0025
    ],
    [
      "disputer",
      0.0025
    ],
    [
      "mener",
      0.0
    ],
    [
      "plaider",
      0.0
    ],
    [
      "s'opiniatrer",
      0.0
    ],
    [
      "financer",
      0.0
    ],
    [
      "accorer",
      0.0
    ],
    [
      "allumer",
      0.0
    ],
    [
      "boiser",
      0.0
    ],
    [
      "charpenter",
      0.0
    ],
    [
      "consoler",
      0.0
    ],
    [
      "contrebouter",
      0.0
    ],
    [
      "empatter",
      0.0
    ],
    [
      "endurer",
      0.0
    ],
    [
      "enseigner",
      0.0
    ],
    [
      "epouser",
      0.0
    ]
  ],
  "degoute": [
    [
      "fatiguer",
      0.1125
    ],
    [
      "rebuter",
      0.0975
    ],
    [
      "ecoeurer",
      0.0825
    ],
    [
      "decourager",
      0.07
    ],
    [
      "detourner",
      0.055
    ],
    [
      "ennuyer",
      0.055
    ],
    [
      "lasser",
      0.055
    ],
    [
      "eloigner",
      0.04
    ],
    [
      "repugner",
      0.04
    ],
    [
      "repousser",
      0.04
    ],
    [
      "deplaire",
      0.04
    ],
    [
      "revolter",
      0.0275
    ],
    [
      "facher",
      0.0275
    ],
    [
      "desabuser",
      0.0275
    ],
    [
      "dissuader",
      0.0275
    ],
    [
      "blaser",
      0.0275
    ],
    [
      "affadir",
      0.0275
    ],
    [
      "saturer",
      0.0125
    ],
    [
      "revulser",
      0.0125
    ],
    [
      "peser",
      0.0125
    ],
    [
      "desenchanter",
      0.0125
    ],
    [
      "desaffectionner",
      0.0125
    ],
    [
      "demoraliser",
      0.0125
    ],
    [
      "debecter",
      0.0125
    ]
  ],
  "fuite": [
    [
      "echappatoire",
      0.0525
    ],
    [
      "debandade",
      0.045
    ],
    [
      "derobade",
      0.045
    ],
    [
      "retraite",
      0.045
    ],
    [
      "subterfuge",
      0.045
    ],
    [
      "defaite",
      0.0375
    ],
    [
      "evasion",
      0.03
    ],
    [
      "pirouette",
      0.03
    ],
    [
      "perte",
      0.03
    ],
    [
      "deroute",
      0.03
    ],
    [
      "disparition",
      0.03
    ],
    [
      "tergiversation",
      0.0225
    ],
    [
      "fugue",
      0.0225
    ],
    [
      "exode",
      0.0225
    ],
    [
      "detour",
      0.0225
    ],
    [
      "abandon",
      0.0225
    ],
    [
      "emigration",
      0.015
    ],
    [
      "eloignement",
      0.015
    ],
    [
      "echappee",
      0.015
    ],
    [
      "trou",
      0.015
    ],
    [
      "fente",
      0.015
    ],
    [
      "excuse",
      0.015
    ],
    [
      "course",
      0.015
    ],
    [
      "dispersion",
      0.015
    ],
    [
      "debacle",
      0.015
    ],
    [
      "escapade",
      0.015
    ],
    [
      "esquive",
      0.015
    ],
    [
      "panique",
      0.0075
    ],
    [
      "pantalonnade",
      0.0075
    ],
    [
      "passage",
      0.0075
    ],
    [
      "quille",
      0.0075
    ],
    [
      "refuge",
      0.0075
    ],
    [
      "refuite",
      0.0075
    ],
    [
      "tachypsychie",
      0.0075
    ],
    [
      "vol",
      0.0075
    ],
    [
      "echappement",
      0.0075
    ],
    [
      "ecoulement",
      0.0075
    ],
    [
      "migration",
      0.0075
    ],
    [
      "mentisme",
      0.0075
    ],
    [
      "indiscretion",
      0.0075
    ],
    [
      "biais",
      0.0075
    ],
    [
      "cours",
      0.0075
    ],
    [
      "deperdition",
      0.0075
    ],
    [
      "envol",
      0.0075
    ],
    [
      "escampette",
      0.0075
    ],
    [
      "escobarderie",
      0.0075
    ],
    [
      "expatriation",
      0.0075
    ],
    [
      "fissure",
      0.0075
    ],
    [
      "fugacite",
      0.0075
    ],
    [
      "fugitif",
      0.0075
    ],
    [
      "evanouissement",
      0.0075
    ]
  ],
  "ecluser": [
    [
      "barrer",
      0.135
    ],
    [
      "fermer",
      0.135
    ],
    [
      "arreter",
      0.09
    ],
    [
      "boire",
      0.09
    ],
    [
      "clore",
      0.09
    ],
    [
      "s'abreuver",
      0.09
    ],
    [
      "sasser",
      0.045
    ],
    [
      "retenir",
      0.045
    ],
    [
      "pomper",
      0.045
    ],
    [
      "obstruer",
      0.045
    ],
    [
      "murer",
      0.045
    ],
    [
      "entonner",
      0.045
    ],
    [
      "enclaver",
      0.045
    ],
    [
      "ecoper",
      0.045
    ]
  ],
  "ecluse": [
    [
      "barrage",
      0.23
    ],
    [
      "vanne",
      0.23
    ],
    [
      "fermeture",
      0.1525
    ],
    [
      "batardeau",
      0.075
    ],
    [
      "bonde",
      0.075
    ],
    [
      "cataracte",
      0.075
    ],
    [
      "obstacle",
      0.075
    ],
    [
      "portereau",
      0.075
    ]
  ],
  "lisser": [
    [
      "lustrer",
      0.1875
    ],
    [
      "polir",
      0.125
    ],
    [
      "vernir",
      0.06
    ],
    [
      "unir",
      0.06
    ],
    [
      "repasser",
      0.06
    ],
    [
      "rabattre",
      0.06
    ],
    [
      "pommader",
      0.06
    ],
    [
      "deplisser",
      0.06
    ],
    [
      "defroisser",
      0.06
    ],
    [
      "defriper",
      0.06
    ],
    [
      "calandrer",
      0.06
    ],
    [
      "aplanir",
      0.06
    ],
    [
      "egaliser",
      0.06
    ]
  ],
  "lisse": [
    [
      "lustrer",
      0.1875
    ],
    [
      "polir",
      0.125
    ],
    [
      "vernir",
      0.06
    ],
    [
      "unir",
      0.06
    ],
    [
      "repasser",
      0.06
    ],
    [
      "rabattre",
      0.06
    ],
    [
      "pommader",
      0.06
    ],
    [
      "deplisser",
      0.06
    ],
    [
      "defroisser",
      0.06
    ],
    [
      "defriper",
      0.06
    ],
    [
      "calandrer",
      0.06
    ],
    [
      "aplanir",
      0.06
    ],
    [
      "egaliser",
      0.06
    ]
  ],
  "versus": [],
  "mienne": [],
  "texte": [
    [
      "teneur",
      0.0675
    ],
    [
      "document",
      0.05
    ],
    [
      "original",
      0.05
    ],
    [
      "type",
      0.05
    ],
    [
      "matiere",
      0.0325
    ],
    [
      "passage",
      0.0325
    ],
    [
      "redaction",
      0.0325
    ],
    [
      "sujet",
      0.0325
    ],
    [
      "variante",
      0.0325
    ],
    [
      "enonce",
      0.0325
    ],
    [
      "manuscrit",
      0.0325
    ],
    [
      "libelle",
      0.0325
    ],
    [
      "acte",
      0.0325
    ],
    [
      "citation",
      0.0325
    ],
    [
      "contenu",
      0.0325
    ],
    [
      "copie",
      0.0325
    ],
    [
      "formule",
      0.0325
    ],
    [
      "fragment",
      0.0325
    ],
    [
      "morceau",
      0.015
    ],
    [
      "paroles",
      0.015
    ],
    [
      "polycopie",
      0.015
    ],
    [
      "recension",
      0.015
    ],
    [
      "redige",
      0.015
    ],
    [
      "scenario",
      0.015
    ],
    [
      "source",
      0.015
    ],
    [
      "synopsis",
      0.015
    ],
    [
      "livret",
      0.015
    ],
    [
      "lecon",
      0.015
    ],
    [
      "arrete",
      0.015
    ],
    [
      "caractere",
      0.015
    ],
    [
      "conducteur",
      0.015
    ],
    [
      "contexte",
      0.015
    ],
    [
      "dactylogramme",
      0.015
    ],
    [
      "decoupage",
      0.015
    ],
    [
      "exegese",
      0.015
    ],
    [
      "hermeneutique",
      0.015
    ],
    [
      "tapuscrit",
      0.015
    ]
  ],
  "celebrer": [
    [
      "louer",
      0.1325
    ],
    [
      "feter",
      0.095
    ],
    [
      "exalter",
      0.0725
    ],
    [
      "glorifier",
      0.0725
    ],
    [
      "vanter",
      0.0475
    ],
    [
      "publier",
      0.0475
    ],
    [
      "magnifier",
      0.0475
    ],
    [
      "honorer",
      0.0475
    ],
    [
      "chanter",
      0.035
    ],
    [
      "encenser",
      0.035
    ],
    [
      "faire",
      0.035
    ],
    [
      "proner",
      0.035
    ],
    [
      "reverer",
      0.035
    ],
    [
      "respecter",
      0.0225
    ],
    [
      "precher",
      0.0225
    ],
    [
      "proceder",
      0.0225
    ],
    [
      "entonner",
      0.0225
    ],
    [
      "sanctifier",
      0.01
    ],
    [
      "preconiser",
      0.01
    ],
    [
      "officier",
      0.01
    ],
    [
      "marquer",
      0.01
    ],
    [
      "commemorer",
      0.01
    ],
    [
      "chomer",
      0.01
    ],
    [
      "blasonner",
      0.01
    ],
    [
      "admirer",
      0.01
    ],
    [
      "solenniser",
      0.01
    ]
  ],
  "celebre": [
    [
      "illustre",
      0.1925
    ],
    [
      "fameux",
      0.105
    ],
    [
      "glorieux",
      0.07
    ],
    [
      "connu",
      0.0625
    ],
    [
      "repute",
      0.0625
    ],
    [
      "renomme",
      0.055
    ],
    [
      "retentissant",
      0.0475
    ],
    [
      "marquant",
      0.0475
    ],
    [
      "important",
      0.0425
    ],
    [
      "memorable",
      0.0425
    ],
    [
      "eminent",
      0.035
    ],
    [
      "eclatant",
      0.0275
    ],
    [
      "brillant",
      0.0275
    ],
    [
      "proverbial",
      0.02
    ],
    [
      "populaire",
      0.02
    ],
    [
      "notoire",
      0.02
    ],
    [
      "legendaire",
      0.02
    ],
    [
      "inoubliable",
      0.02
    ],
    [
      "distingue",
      0.02
    ],
    [
      "historique",
      0.0125
    ],
    [
      "immortel",
      0.0125
    ],
    [
      "public",
      0.0125
    ]
  ],
  "parenthese": [
    [
      "digression",
      0.3325
    ],
    [
      "ponctuation",
      0.3325
    ]
  ],
  "reussi": [
    [
      "impeccable",
      0.165
    ],
    [
      "parfait",
      0.165
    ],
    [
      "soigne",
      0.165
    ],
    [
      "heureux",
      0.0825
    ],
    [
      "joli",
      0.0825
    ],
    [
      "remarquable",
      0.0825
    ],
    [
      "sensationnel",
      0.0825
    ],
    [
      "travaille",
      0.0825
    ]
  ],
  "reussir": [
    [
      "gagner",
      0.0875
    ],
    [
      "marcher",
      0.0775
    ],
    [
      "arriver",
      0.0675
    ],
    [
      "parvenir",
      0.0675
    ],
    [
      "prendre",
      0.0575
    ],
    [
      "aboutir",
      0.0475
    ],
    [
      "avancer",
      0.0475
    ],
    [
      "venir",
      0.0375
    ],
    [
      "prosperer",
      0.0375
    ],
    [
      "percer",
      0.0375
    ],
    [
      "faire",
      0.0275
    ],
    [
      "fleurir",
      0.0275
    ],
    [
      "monter",
      0.0275
    ],
    [
      "triompher",
      0.0175
    ],
    [
      "s'implanter",
      0.0175
    ],
    [
      "s'acclimater",
      0.0175
    ],
    [
      "pousser",
      0.0175
    ],
    [
      "briller",
      0.0175
    ],
    [
      "achever",
      0.0175
    ],
    [
      "plaire",
      0.0075
    ],
    [
      "s'accomplir",
      0.0075
    ],
    [
      "s'elever",
      0.0075
    ],
    [
      "trouver",
      0.0075
    ],
    [
      "fructifier",
      0.0075
    ]
  ],
  "parano": [
    [
      "paranoia",
      0.5
    ],
    [
      "paranoiaque",
      0.5
    ]
  ],
  "caverne": [
    [
      "grotte",
      0.1775
    ],
    [
      "repaire",
      0.0875
    ],
    [
      "taniere",
      0.0875
    ],
    [
      "trou",
      0.0875
    ],
    [
      "excavation",
      0.07
    ],
    [
      "terrier",
      0.0525
    ],
    [
      "souterrain",
      0.0525
    ],
    [
      "retraite",
      0.0525
    ],
    [
      "antre",
      0.0525
    ],
    [
      "renfoncement",
      0.035
    ],
    [
      "refuge",
      0.035
    ],
    [
      "gite",
      0.035
    ],
    [
      "cavite",
      0.035
    ],
    [
      "cave",
      0.035
    ],
    [
      "balme",
      0.0175
    ],
    [
      "baume",
      0.0175
    ],
    [
      "spelonque",
      0.0175
    ],
    [
      "tuberculose",
      0.0175
    ]
  ],
  "flambant": [
    [
      "brillant",
      0.165
    ],
    [
      "rutilant",
      0.1025
    ],
    [
      "etincelant",
      0.1025
    ],
    [
      "ardent",
      0.0825
    ],
    [
      "flamboyant",
      0.0825
    ],
    [
      "eclatant",
      0.0825
    ],
    [
      "brulant",
      0.0625
    ],
    [
      "resplendissant",
      0.04
    ],
    [
      "reluisant",
      0.04
    ],
    [
      "incandescent",
      0.04
    ],
    [
      "superbe",
      0.02
    ],
    [
      "scintillant",
      0.02
    ],
    [
      "pimpant",
      0.02
    ],
    [
      "fulgurant",
      0.02
    ],
    [
      "coruscant",
      0.02
    ],
    [
      "chic",
      0.02
    ],
    [
      "brasillant",
      0.02
    ],
    [
      "bouillant",
      0.02
    ],
    [
      "elegant",
      0.02
    ]
  ],
  "speed": [
    [
      "L.S.D.",
      1.0
    ]
  ],
  "libre": [
    [
      "leste",
      0.0675
    ],
    [
      "licencieux",
      0.065
    ],
    [
      "egrillard",
      0.0625
    ],
    [
      "graveleux",
      0.05
    ],
    [
      "grivois",
      0.05
    ],
    [
      "obscene",
      0.035
    ],
    [
      "gaulois",
      0.035
    ],
    [
      "cru",
      0.0325
    ],
    [
      "ose",
      0.03
    ],
    [
      "gaillard",
      0.0275
    ],
    [
      "polisson",
      0.025
    ],
    [
      "degage",
      0.025
    ],
    [
      "aise",
      0.0225
    ],
    [
      "desinvolte",
      0.02
    ],
    [
      "leger",
      0.02
    ],
    [
      "vert",
      0.015
    ],
    [
      "grossier",
      0.015
    ],
    [
      "hardi",
      0.015
    ],
    [
      "inconvenant",
      0.015
    ],
    [
      "vide",
      0.01
    ],
    [
      "relache",
      0.01
    ],
    [
      "ouvert",
      0.01
    ],
    [
      "independant",
      0.01
    ],
    [
      "familier",
      0.01
    ],
    [
      "deshonnete",
      0.01
    ],
    [
      "cavalier",
      0.01
    ],
    [
      "epice",
      0.01
    ],
    [
      "franc",
      0.01
    ],
    [
      "facile",
      0.01
    ],
    [
      "badin",
      0.01
    ],
    [
      "emancipe",
      0.0075
    ],
    [
      "vague",
      0.0075
    ],
    [
      "spontane",
      0.0075
    ],
    [
      "libertin",
      0.0075
    ],
    [
      "guilleret",
      0.0075
    ],
    [
      "gras",
      0.0075
    ],
    [
      "gai",
      0.0075
    ],
    [
      "exempt",
      0.0075
    ],
    [
      "decontracte",
      0.0075
    ],
    [
      "large",
      0.005
    ],
    [
      "libere",
      0.005
    ],
    [
      "malseant",
      0.005
    ],
    [
      "permis",
      0.005
    ],
    [
      "raide",
      0.005
    ],
    [
      "inoccupe",
      0.005
    ],
    [
      "flou",
      0.005
    ],
    [
      "delibere",
      0.005
    ],
    [
      "debraille",
      0.005
    ],
    [
      "disponible",
      0.005
    ],
    [
      "dessale",
      0.005
    ],
    [
      "autorise",
      0.005
    ],
    [
      "folichon",
      0.0025
    ],
    [
      "poivre",
      0.0025
    ],
    [
      "rabelaisien",
      0.0025
    ],
    [
      "vacant",
      0.0025
    ],
    [
      "degourdi",
      0.0025
    ],
    [
      "decollete",
      0.0025
    ],
    [
      "deboutonne",
      0.0025
    ],
    [
      "coquin",
      0.0025
    ],
    [
      "commode",
      0.0025
    ],
    [
      "bas",
      0.0025
    ],
    [
      "autonome",
      0.0025
    ],
    [
      "affranchi",
      0.0025
    ],
    [
      "prive",
      0.0
    ],
    [
      "quitte",
      0.0
    ],
    [
      "souverain",
      0.0
    ],
    [
      "tolere",
      0.0
    ],
    [
      "volontaire",
      0.0
    ],
    [
      "epicurien",
      0.0
    ],
    [
      "informel",
      0.0
    ],
    [
      "inconditionne",
      0.0
    ],
    [
      "gratuit",
      0.0
    ],
    [
      "flottant",
      0.0
    ],
    [
      "desert",
      0.0
    ],
    [
      "delie",
      0.0
    ],
    [
      "celibataire",
      0.0
    ],
    [
      "buissonnier",
      0.0
    ],
    [
      "amoral",
      0.0
    ],
    [
      "evade",
      0.0
    ]
  ],
  "corsage": [
    [
      "blouse",
      0.1475
    ],
    [
      "camisole",
      0.1475
    ],
    [
      "brassiere",
      0.11
    ],
    [
      "chemisette",
      0.0725
    ],
    [
      "corset",
      0.035
    ],
    [
      "guimpe",
      0.035
    ],
    [
      "haut",
      0.035
    ],
    [
      "jersey",
      0.035
    ],
    [
      "poitrine",
      0.035
    ],
    [
      "chemisier",
      0.035
    ],
    [
      "casaquin",
      0.035
    ],
    [
      "casaque",
      0.035
    ],
    [
      "caraco",
      0.035
    ],
    [
      "canezou",
      0.035
    ],
    [
      "buste",
      0.035
    ],
    [
      "basquine",
      0.035
    ],
    [
      "torse",
      0.035
    ]
  ],
  "routine": [
    [
      "habitude",
      0.16
    ],
    [
      "usage",
      0.095
    ],
    [
      "accoutumance",
      0.0625
    ],
    [
      "errements",
      0.0625
    ],
    [
      "experience",
      0.0625
    ],
    [
      "pratique",
      0.0625
    ],
    [
      "rite",
      0.03
    ],
    [
      "ronron",
      0.03
    ],
    [
      "tradition",
      0.03
    ],
    [
      "traditionalisme",
      0.03
    ],
    [
      "train",
      0.03
    ],
    [
      "pragmatisme",
      0.03
    ],
    [
      "poncif",
      0.03
    ],
    [
      "orniere",
      0.03
    ],
    [
      "misoneisme",
      0.03
    ],
    [
      "manie",
      0.03
    ],
    [
      "irreflexion",
      0.03
    ],
    [
      "empirisme",
      0.03
    ],
    [
      "chemin",
      0.03
    ]
  ],
  "vitamine": [],
  "direct": [
    [
      "franc",
      0.22
    ],
    [
      "droit",
      0.11
    ],
    [
      "simple",
      0.0825
    ],
    [
      "spontane",
      0.055
    ],
    [
      "ouvert",
      0.055
    ],
    [
      "net",
      0.055
    ],
    [
      "carre",
      0.055
    ],
    [
      "brutal",
      0.055
    ],
    [
      "abrupt",
      0.055
    ],
    [
      "rectiligne",
      0.0275
    ],
    [
      "prochain",
      0.0275
    ],
    [
      "naturel",
      0.0275
    ],
    [
      "immediat",
      0.0275
    ],
    [
      "determine",
      0.0275
    ],
    [
      "categorique",
      0.0275
    ],
    [
      "rond",
      0.0275
    ]
  ],
  "presider": [
    [
      "conduire",
      0.1675
    ],
    [
      "diriger",
      0.1675
    ],
    [
      "gouverner",
      0.11
    ],
    [
      "surveiller",
      0.11
    ],
    [
      "troner",
      0.11
    ],
    [
      "sieger",
      0.055
    ],
    [
      "regler",
      0.055
    ],
    [
      "pontifier",
      0.055
    ],
    [
      "gerer",
      0.055
    ],
    [
      "veiller",
      0.055
    ]
  ],
  "president": [
    [
      "chef",
      0.3
    ],
    [
      "directeur",
      0.2
    ],
    [
      "P.D.G.",
      0.1
    ],
    [
      "doyen",
      0.1
    ],
    [
      "gouvernant",
      0.1
    ],
    [
      "magistrat",
      0.1
    ],
    [
      "tuteur",
      0.1
    ]
  ],
  "confiner": [
    [
      "enfermer",
      0.3325
    ],
    [
      "boucler",
      0.165
    ],
    [
      "isoler",
      0.165
    ],
    [
      "releguer",
      0.165
    ],
    [
      "renfermer",
      0.165
    ]
  ],
  "confine": [
    [
      "enfermer",
      0.3325
    ],
    [
      "boucler",
      0.165
    ],
    [
      "isoler",
      0.165
    ],
    [
      "releguer",
      0.165
    ],
    [
      "renfermer",
      0.165
    ]
  ],
  "salsa": [],
  "clef": [
    [
      "rossignol",
      0.085
    ],
    [
      "manette",
      0.04
    ],
    [
      "passe",
      0.04
    ],
    [
      "principal",
      0.04
    ],
    [
      "resolution",
      0.04
    ],
    [
      "sens",
      0.04
    ],
    [
      "signification",
      0.04
    ],
    [
      "solution",
      0.04
    ],
    [
      "introduction",
      0.04
    ],
    [
      "explication",
      0.04
    ],
    [
      "accordoir",
      0.04
    ],
    [
      "broche",
      0.04
    ],
    [
      "campos",
      0.04
    ],
    [
      "capital",
      0.04
    ],
    [
      "carouble",
      0.04
    ],
    [
      "claveau",
      0.04
    ],
    [
      "crochet",
      0.04
    ],
    [
      "denouement",
      0.04
    ],
    [
      "verrou",
      0.04
    ]
  ],
  "creatif": [
    [
      "innovant",
      0.5
    ],
    [
      "inventif",
      0.5
    ]
  ],
  "actif": [
    [
      "vif",
      0.1125
    ],
    [
      "ardent",
      0.0675
    ],
    [
      "prompt",
      0.0675
    ],
    [
      "agissant",
      0.06
    ],
    [
      "vivant",
      0.05
    ],
    [
      "fringant",
      0.0425
    ],
    [
      "rapide",
      0.0375
    ],
    [
      "fort",
      0.0375
    ],
    [
      "dynamique",
      0.0375
    ],
    [
      "zele",
      0.03
    ],
    [
      "energique",
      0.03
    ],
    [
      "eveille",
      0.0225
    ],
    [
      "travailleur",
      0.0225
    ],
    [
      "semillant",
      0.0225
    ],
    [
      "remuant",
      0.0225
    ],
    [
      "efficace",
      0.0225
    ],
    [
      "diligent",
      0.0225
    ],
    [
      "violent",
      0.0175
    ],
    [
      "vaillant",
      0.0175
    ],
    [
      "turbulent",
      0.0175
    ],
    [
      "infatigable",
      0.0175
    ],
    [
      "allant",
      0.0175
    ],
    [
      "laborieux",
      0.01
    ],
    [
      "expeditif",
      0.01
    ],
    [
      "entreprenant",
      0.01
    ],
    [
      "bouillonnant",
      0.01
    ],
    [
      "batailleur",
      0.01
    ],
    [
      "allegre",
      0.01
    ],
    [
      "juvenile",
      0.005
    ],
    [
      "manifeste",
      0.005
    ],
    [
      "militant",
      0.005
    ],
    [
      "occupe",
      0.005
    ],
    [
      "operant",
      0.005
    ],
    [
      "productif",
      0.005
    ],
    [
      "radioactif",
      0.005
    ],
    [
      "resolutif",
      0.005
    ],
    [
      "influent",
      0.005
    ],
    [
      "increvable",
      0.005
    ],
    [
      "florissant",
      0.005
    ],
    [
      "affaire",
      0.005
    ],
    [
      "avoir",
      0.005
    ],
    [
      "benefice",
      0.005
    ],
    [
      "caisse",
      0.005
    ],
    [
      "commercant",
      0.005
    ],
    [
      "credit",
      0.005
    ],
    [
      "debordant",
      0.005
    ],
    [
      "efficient",
      0.005
    ],
    [
      "soudain",
      0.005
    ]
  ],
  "confinement": [
    [
      "reclusion",
      1.0
    ]
  ],
  "initiale": [
    [
      "premier",
      0.125
    ],
    [
      "primitif",
      0.125
    ],
    [
      "elementaire",
      0.125
    ],
    [
      "originaire",
      0.1
    ],
    [
      "primaire",
      0.075
    ],
    [
      "naturel",
      0.075
    ],
    [
      "inne",
      0.075
    ],
    [
      "fondamental",
      0.075
    ],
    [
      "originel",
      0.05
    ],
    [
      "primordial",
      0.05
    ],
    [
      "commencant",
      0.025
    ],
    [
      "debutant",
      0.025
    ],
    [
      "original",
      0.025
    ],
    [
      "rudimentaire",
      0.025
    ],
    [
      "sigle",
      0.025
    ]
  ],
  "dirige": [
    [
      "conduire",
      0.1175
    ],
    [
      "gouverner",
      0.08
    ],
    [
      "mener",
      0.0625
    ],
    [
      "commander",
      0.0475
    ],
    [
      "guider",
      0.0475
    ],
    [
      "regler",
      0.03
    ],
    [
      "regir",
      0.03
    ],
    [
      "pousser",
      0.03
    ],
    [
      "conseiller",
      0.0275
    ],
    [
      "orienter",
      0.0275
    ],
    [
      "porter",
      0.0275
    ],
    [
      "regenter",
      0.0225
    ],
    [
      "manier",
      0.0225
    ],
    [
      "inspirer",
      0.0225
    ],
    [
      "entrainer",
      0.0225
    ],
    [
      "determiner",
      0.0225
    ],
    [
      "administrer",
      0.0225
    ],
    [
      "appliquer",
      0.015
    ],
    [
      "manoeuvrer",
      0.015
    ],
    [
      "piloter",
      0.015
    ],
    [
      "tenir",
      0.015
    ],
    [
      "tourner",
      0.0125
    ],
    [
      "dominer",
      0.0125
    ],
    [
      "concentrer",
      0.0125
    ],
    [
      "canaliser",
      0.0125
    ],
    [
      "presider",
      0.01
    ],
    [
      "presenter",
      0.01
    ],
    [
      "pointer",
      0.01
    ],
    [
      "organiser",
      0.01
    ],
    [
      "ordonner",
      0.01
    ],
    [
      "incliner",
      0.01
    ],
    [
      "gerer",
      0.01
    ],
    [
      "centrer",
      0.01
    ],
    [
      "aiguiller",
      0.01
    ],
    [
      "etendre",
      0.005
    ],
    [
      "rapporter",
      0.005
    ],
    [
      "planifier",
      0.005
    ],
    [
      "naviguer",
      0.005
    ],
    [
      "maitriser",
      0.005
    ],
    [
      "chaperonner",
      0.005
    ],
    [
      "braquer",
      0.005
    ],
    [
      "attacher",
      0.005
    ],
    [
      "animer",
      0.005
    ],
    [
      "acheminer",
      0.005
    ],
    [
      "superviser",
      0.0025
    ],
    [
      "preceder",
      0.0025
    ],
    [
      "focaliser",
      0.0025
    ],
    [
      "expedier",
      0.0025
    ],
    [
      "emmener",
      0.0025
    ],
    [
      "cultiver",
      0.0025
    ],
    [
      "converger",
      0.0025
    ],
    [
      "barrer",
      0.0025
    ],
    [
      "tailler",
      0.0025
    ]
  ],
  "stop": [
    [
      "barriere",
      0.3325
    ],
    [
      "halte",
      0.3325
    ]
  ],
  "sensualite": [
    [
      "plaisir",
      0.15
    ],
    [
      "lascivete",
      0.0775
    ],
    [
      "luxure",
      0.0775
    ],
    [
      "concupiscence",
      0.0675
    ],
    [
      "volupte",
      0.0675
    ],
    [
      "sens",
      0.06
    ],
    [
      "jouissance",
      0.0475
    ],
    [
      "stupre",
      0.0475
    ],
    [
      "salacite",
      0.0375
    ],
    [
      "libido",
      0.03
    ],
    [
      "lubricite",
      0.03
    ],
    [
      "erotisme",
      0.0175
    ],
    [
      "satisfaction",
      0.0175
    ],
    [
      "libertinage",
      0.0175
    ],
    [
      "impurete",
      0.0175
    ],
    [
      "hedonisme",
      0.0175
    ],
    [
      "felicite",
      0.0175
    ],
    [
      "desir",
      0.0175
    ],
    [
      "delice",
      0.0175
    ],
    [
      "contentement",
      0.0175
    ],
    [
      "chair",
      0.0175
    ],
    [
      "ebats",
      0.0075
    ],
    [
      "temperament",
      0.0075
    ],
    [
      "sybaritisme",
      0.0075
    ],
    [
      "sensualisme",
      0.0075
    ],
    [
      "delectation",
      0.0075
    ],
    [
      "epicurisme",
      0.0075
    ]
  ],
  "affaiblir": [
    [
      "diminuer",
      0.1
    ],
    [
      "detruire",
      0.0625
    ],
    [
      "attenuer",
      0.0425
    ],
    [
      "adoucir",
      0.04
    ],
    [
      "abattre",
      0.0375
    ],
    [
      "epuiser",
      0.0325
    ],
    [
      "fatiguer",
      0.0275
    ],
    [
      "reduire",
      0.025
    ],
    [
      "ruiner",
      0.025
    ],
    [
      "miner",
      0.025
    ],
    [
      "briser",
      0.025
    ],
    [
      "alterer",
      0.025
    ],
    [
      "emousser",
      0.0225
    ],
    [
      "abaisser",
      0.02
    ],
    [
      "affadir",
      0.0175
    ],
    [
      "enerver",
      0.015
    ],
    [
      "temperer",
      0.015
    ],
    [
      "moderer",
      0.015
    ],
    [
      "amollir",
      0.015
    ],
    [
      "user",
      0.0125
    ],
    [
      "saper",
      0.0125
    ],
    [
      "deprimer",
      0.0125
    ],
    [
      "consumer",
      0.0125
    ],
    [
      "amoindrir",
      0.0125
    ],
    [
      "abatardir",
      0.0125
    ],
    [
      "eteindre",
      0.0125
    ],
    [
      "ebranler",
      0.0125
    ],
    [
      "casser",
      0.0125
    ],
    [
      "amortir",
      0.0125
    ],
    [
      "debiliter",
      0.01
    ],
    [
      "extenuer",
      0.01
    ],
    [
      "infirmer",
      0.01
    ],
    [
      "etouffer",
      0.0075
    ],
    [
      "etioler",
      0.0075
    ],
    [
      "emasculer",
      0.0075
    ],
    [
      "flechir",
      0.0075
    ],
    [
      "appauvrir",
      0.0075
    ],
    [
      "alanguir",
      0.0075
    ],
    [
      "decourager",
      0.005
    ],
    [
      "defaire",
      0.005
    ],
    [
      "effeminer",
      0.005
    ],
    [
      "frelater",
      0.005
    ],
    [
      "rabaisser",
      0.005
    ],
    [
      "rabattre",
      0.005
    ],
    [
      "ereinter",
      0.005
    ],
    [
      "corrompre",
      0.005
    ],
    [
      "calmer",
      0.005
    ],
    [
      "abrutir",
      0.005
    ],
    [
      "affaisser",
      0.005
    ],
    [
      "anemier",
      0.005
    ],
    [
      "assourdir",
      0.005
    ],
    [
      "atrophier",
      0.005
    ],
    [
      "atteindre",
      0.005
    ],
    [
      "attendrir",
      0.005
    ],
    [
      "mitiger",
      0.0025
    ],
    [
      "raccourcir",
      0.0025
    ],
    [
      "relacher",
      0.0025
    ],
    [
      "edulcorer",
      0.0025
    ],
    [
      "eroder",
      0.0025
    ],
    [
      "etendre",
      0.0025
    ],
    [
      "effacer",
      0.0025
    ],
    [
      "delabrer",
      0.0025
    ],
    [
      "deforcer",
      0.0025
    ],
    [
      "abetir",
      0.0025
    ],
    [
      "avachir",
      0.0025
    ],
    [
      "aveulir",
      0.0025
    ],
    [
      "blaser",
      0.0025
    ],
    [
      "diluer",
      0.0025
    ],
    [
      "nuire",
      0.0
    ],
    [
      "fragiliser",
      0.0
    ],
    [
      "devaster",
      0.0
    ],
    [
      "detremper",
      0.0
    ],
    [
      "attiedir",
      0.0
    ],
    [
      "amenuiser",
      0.0
    ],
    [
      "affecter",
      0.0
    ],
    [
      "elimer",
      0.0
    ]
  ],
  "apparemment": [
    [
      "vraisemblablement",
      0.1675
    ],
    [
      "superficiellement",
      0.0825
    ],
    [
      "probablement",
      0.0825
    ],
    [
      "exterieurement",
      0.0825
    ],
    [
      "censement",
      0.0825
    ],
    [
      "visiblement",
      0.0825
    ]
  ],
  "aborder": [
    [
      "toucher",
      0.105
    ],
    [
      "accoster",
      0.0825
    ],
    [
      "arriver",
      0.0825
    ],
    [
      "parvenir",
      0.0625
    ],
    [
      "venir",
      0.05
    ],
    [
      "joindre",
      0.05
    ],
    [
      "effleurer",
      0.05
    ],
    [
      "atteindre",
      0.05
    ],
    [
      "approcher",
      0.05
    ],
    [
      "acceder",
      0.04
    ],
    [
      "attaquer",
      0.04
    ],
    [
      "gagner",
      0.04
    ],
    [
      "traiter",
      0.04
    ],
    [
      "rallier",
      0.02
    ],
    [
      "entamer",
      0.02
    ],
    [
      "arreter",
      0.02
    ],
    [
      "racoler",
      0.01
    ],
    [
      "negocier",
      0.01
    ],
    [
      "entrer",
      0.01
    ],
    [
      "descendre",
      0.01
    ],
    [
      "arraisonner",
      0.01
    ],
    [
      "apponter",
      0.01
    ],
    [
      "affronter",
      0.01
    ],
    [
      "accrocher",
      0.01
    ],
    [
      "evoquer",
      0.01
    ]
  ],
  "acquerir": [
    [
      "obtenir",
      0.145
    ],
    [
      "gagner",
      0.1125
    ],
    [
      "prendre",
      0.1025
    ],
    [
      "conquerir",
      0.0825
    ],
    [
      "remporter",
      0.07
    ],
    [
      "avoir",
      0.05
    ],
    [
      "recueillir",
      0.04
    ],
    [
      "recevoir",
      0.04
    ],
    [
      "attirer",
      0.03
    ],
    [
      "capter",
      0.03
    ],
    [
      "emporter",
      0.03
    ],
    [
      "valoir",
      0.02
    ],
    [
      "trouver",
      0.02
    ],
    [
      "s'ameliorer",
      0.02
    ],
    [
      "rapporter",
      0.02
    ],
    [
      "assimiler",
      0.02
    ],
    [
      "s'impregner",
      0.0075
    ],
    [
      "heriter",
      0.0075
    ],
    [
      "forcer",
      0.0075
    ],
    [
      "decouvrir",
      0.0075
    ],
    [
      "contracter",
      0.0075
    ],
    [
      "concilier",
      0.0075
    ],
    [
      "acheter",
      0.0075
    ]
  ],
  "acquis": [
    [
      "savoir",
      0.15
    ],
    [
      "bagage",
      0.1
    ],
    [
      "connaissance",
      0.1
    ],
    [
      "transmis",
      0.05
    ],
    [
      "tact",
      0.05
    ],
    [
      "experience",
      0.05
    ],
    [
      "devoue",
      0.05
    ],
    [
      "devolu",
      0.05
    ],
    [
      "convaincu",
      0.05
    ],
    [
      "conquete",
      0.05
    ],
    [
      "connaissances",
      0.05
    ],
    [
      "capital",
      0.05
    ],
    [
      "ballot",
      0.05
    ],
    [
      "attache",
      0.05
    ],
    [
      "etabli",
      0.05
    ]
  ],
  "statut": [
    [
      "reglement",
      0.22
    ],
    [
      "loi",
      0.0925
    ],
    [
      "regle",
      0.0925
    ],
    [
      "convention",
      0.0725
    ],
    [
      "ordonnance",
      0.05
    ],
    [
      "protocole",
      0.04
    ],
    [
      "constitution",
      0.04
    ],
    [
      "condition",
      0.03
    ],
    [
      "prescription",
      0.03
    ],
    [
      "etat",
      0.03
    ],
    [
      "edit",
      0.02
    ],
    [
      "observance",
      0.02
    ],
    [
      "forme",
      0.02
    ],
    [
      "decret",
      0.02
    ],
    [
      "code",
      0.02
    ],
    [
      "arrangement",
      0.02
    ],
    [
      "accord",
      0.02
    ],
    [
      "role",
      0.01
    ],
    [
      "reglementation",
      0.01
    ],
    [
      "rang",
      0.01
    ],
    [
      "mandement",
      0.01
    ],
    [
      "institution",
      0.01
    ],
    [
      "discipline",
      0.01
    ],
    [
      "consigne",
      0.01
    ],
    [
      "concordat",
      0.01
    ],
    [
      "charte",
      0.01
    ],
    [
      "canon",
      0.01
    ],
    [
      "arrete",
      0.01
    ],
    [
      "arbitrage",
      0.01
    ],
    [
      "allegeance",
      0.01
    ],
    [
      "situation",
      0.01
    ]
  ],
  "couvert": [
    [
      "sombre",
      0.0625
    ],
    [
      "defendu",
      0.05
    ],
    [
      "revetu",
      0.05
    ],
    [
      "tenebreux",
      0.0375
    ],
    [
      "pretexte",
      0.0375
    ],
    [
      "obscur",
      0.0375
    ],
    [
      "nebuleux",
      0.0375
    ],
    [
      "manteau",
      0.0375
    ],
    [
      "charge",
      0.0375
    ],
    [
      "brumeux",
      0.0375
    ],
    [
      "abri",
      0.0375
    ],
    [
      "vetu",
      0.025
    ],
    [
      "protege",
      0.025
    ],
    [
      "plein",
      0.025
    ],
    [
      "ombre",
      0.025
    ],
    [
      "nuageux",
      0.025
    ],
    [
      "herisse",
      0.025
    ],
    [
      "couverture",
      0.025
    ],
    [
      "comble",
      0.025
    ],
    [
      "bouche",
      0.025
    ],
    [
      "menagere",
      0.0125
    ],
    [
      "nappe",
      0.0125
    ],
    [
      "noir",
      0.0125
    ],
    [
      "ombrage",
      0.0125
    ],
    [
      "ombrage",
      0.0125
    ],
    [
      "platre",
      0.0125
    ],
    [
      "preau",
      0.0125
    ],
    [
      "preserve",
      0.0125
    ],
    [
      "sauvegarde",
      0.0125
    ],
    [
      "voile",
      0.0125
    ],
    [
      "morne",
      0.0125
    ],
    [
      "maison",
      0.0125
    ],
    [
      "amorti",
      0.0125
    ],
    [
      "assiette",
      0.0125
    ],
    [
      "coiffe",
      0.0125
    ],
    [
      "cuiller",
      0.0125
    ],
    [
      "enveloppe",
      0.0125
    ],
    [
      "fourchette",
      0.0125
    ],
    [
      "garanti",
      0.0125
    ],
    [
      "gite",
      0.0125
    ],
    [
      "habille",
      0.0125
    ],
    [
      "abrite",
      0.0125
    ]
  ],
  "office": [
    [
      "fonction",
      0.1125
    ],
    [
      "service",
      0.0975
    ],
    [
      "charge",
      0.0825
    ],
    [
      "emploi",
      0.055
    ],
    [
      "tache",
      0.04
    ],
    [
      "poste",
      0.04
    ],
    [
      "mission",
      0.04
    ],
    [
      "intervention",
      0.04
    ],
    [
      "bureau",
      0.04
    ],
    [
      "station",
      0.0275
    ],
    [
      "place",
      0.0275
    ],
    [
      "mediation",
      0.0275
    ],
    [
      "ministere",
      0.0275
    ],
    [
      "messe",
      0.0275
    ],
    [
      "guichet",
      0.0275
    ],
    [
      "devoir",
      0.0275
    ],
    [
      "aide",
      0.0275
    ],
    [
      "depense",
      0.0125
    ],
    [
      "funerailles",
      0.0125
    ],
    [
      "kitchenette",
      0.0125
    ],
    [
      "liturgie",
      0.0125
    ],
    [
      "metier",
      0.0125
    ],
    [
      "organisme",
      0.0125
    ],
    [
      "ceremonie",
      0.0125
    ],
    [
      "culte",
      0.0125
    ],
    [
      "cuisine",
      0.0125
    ],
    [
      "breviaire",
      0.0125
    ],
    [
      "bienfait",
      0.0125
    ],
    [
      "besogne",
      0.0125
    ],
    [
      "arbitrage",
      0.0125
    ],
    [
      "agence",
      0.0125
    ],
    [
      "salut",
      0.0125
    ]
  ],
  "melee": [
    [
      "melanger",
      0.2175
    ],
    [
      "reunir",
      0.06
    ],
    [
      "unir",
      0.045
    ],
    [
      "amalgamer",
      0.04
    ],
    [
      "fusionner",
      0.04
    ],
    [
      "combiner",
      0.0325
    ],
    [
      "associer",
      0.0325
    ],
    [
      "joindre",
      0.025
    ],
    [
      "incorporer",
      0.025
    ],
    [
      "entrelacer",
      0.025
    ],
    [
      "couper",
      0.025
    ],
    [
      "confondre",
      0.025
    ],
    [
      "battre",
      0.025
    ],
    [
      "touiller",
      0.02
    ],
    [
      "entremeler",
      0.02
    ],
    [
      "enchevetrer",
      0.02
    ],
    [
      "croiser",
      0.02
    ],
    [
      "brouiller",
      0.02
    ],
    [
      "matiner",
      0.0125
    ],
    [
      "marier",
      0.0125
    ],
    [
      "fouetter",
      0.0125
    ],
    [
      "fondre",
      0.0125
    ],
    [
      "emmeler",
      0.0125
    ],
    [
      "embrouiller",
      0.0125
    ],
    [
      "comprendre",
      0.0125
    ],
    [
      "brasser",
      0.0125
    ],
    [
      "allier",
      0.0125
    ],
    [
      "agiter",
      0.0125
    ],
    [
      "agglomerer",
      0.0125
    ],
    [
      "accoupler",
      0.0125
    ],
    [
      "mixtionner",
      0.005
    ],
    [
      "mouiller",
      0.005
    ],
    [
      "panacher",
      0.005
    ],
    [
      "saupoudrer",
      0.005
    ],
    [
      "temperer",
      0.005
    ],
    [
      "manipuler",
      0.005
    ],
    [
      "malaxer",
      0.005
    ],
    [
      "impliquer",
      0.005
    ],
    [
      "ficher",
      0.005
    ],
    [
      "fatiguer",
      0.005
    ],
    [
      "doser",
      0.005
    ],
    [
      "agglutiner",
      0.005
    ],
    [
      "unifier",
      0.005
    ]
  ],
  "realiste": [
    [
      "positif",
      0.145
    ],
    [
      "pratique",
      0.1175
    ],
    [
      "utilitaire",
      0.0575
    ],
    [
      "pragmatique",
      0.0575
    ],
    [
      "net",
      0.0575
    ],
    [
      "naturaliste",
      0.0575
    ],
    [
      "materiel",
      0.0575
    ],
    [
      "materialiste",
      0.0575
    ],
    [
      "cru",
      0.0575
    ],
    [
      "concret",
      0.0275
    ],
    [
      "descriptif",
      0.0275
    ],
    [
      "opportuniste",
      0.0275
    ],
    [
      "peintre",
      0.0275
    ],
    [
      "pragmatiste",
      0.0275
    ],
    [
      "veriste",
      0.0275
    ]
  ],
  "debouler": [
    [
      "tomber",
      0.165
    ],
    [
      "degringoler",
      0.1225
    ],
    [
      "s'elancer",
      0.0825
    ],
    [
      "fuser",
      0.0825
    ],
    [
      "devaler",
      0.0825
    ],
    [
      "descendre",
      0.0825
    ],
    [
      "bouler",
      0.04
    ],
    [
      "debarouler",
      0.04
    ],
    [
      "deguerpir",
      0.04
    ],
    [
      "rouler",
      0.04
    ],
    [
      "surgir",
      0.04
    ]
  ],
  "boiter": [
    [
      "claudiquer",
      0.1
    ],
    [
      "clopiner",
      0.1
    ],
    [
      "osciller",
      0.1
    ],
    [
      "feindre",
      0.05
    ],
    [
      "clocher",
      0.05
    ],
    [
      "bequiller",
      0.05
    ],
    [
      "bringuebaler",
      0.05
    ],
    [
      "brimbaler",
      0.05
    ],
    [
      "branler",
      0.05
    ],
    [
      "boitiller",
      0.05
    ]
  ],
  "massif": [
    [
      "gros",
      0.1225
    ],
    [
      "epais",
      0.1075
    ],
    [
      "lourd",
      0.095
    ],
    [
      "fort",
      0.0875
    ],
    [
      "important",
      0.05
    ],
    [
      "trapu",
      0.05
    ],
    [
      "puissant",
      0.035
    ],
    [
      "pesant",
      0.035
    ],
    [
      "mastoc",
      0.035
    ],
    [
      "corpulent",
      0.035
    ],
    [
      "grossier",
      0.0275
    ],
    [
      "touffu",
      0.0275
    ],
    [
      "ramasse",
      0.02
    ],
    [
      "imposant",
      0.02
    ],
    [
      "volumineux",
      0.0125
    ],
    [
      "rable",
      0.0125
    ],
    [
      "plein",
      0.0125
    ],
    [
      "lourdaud",
      0.0125
    ],
    [
      "futaie",
      0.0125
    ],
    [
      "fourre",
      0.0125
    ],
    [
      "compact",
      0.0125
    ],
    [
      "carre",
      0.0125
    ],
    [
      "bois",
      0.0125
    ],
    [
      "mont",
      0.005
    ],
    [
      "nombrable",
      0.005
    ],
    [
      "obese",
      0.005
    ],
    [
      "opulent",
      0.005
    ],
    [
      "parterre",
      0.005
    ],
    [
      "planche",
      0.005
    ],
    [
      "materiel",
      0.005
    ],
    [
      "impressionnant",
      0.005
    ],
    [
      "fruste",
      0.005
    ],
    [
      "dalle",
      0.005
    ],
    [
      "corbeille",
      0.005
    ],
    [
      "butee",
      0.005
    ],
    [
      "bosquet",
      0.005
    ],
    [
      "boqueteau",
      0.005
    ],
    [
      "aire",
      0.005
    ]
  ],
  "quasiment": [
    [
      "pratiquement",
      0.3325
    ],
    [
      "presque",
      0.3325
    ],
    [
      "quasi",
      0.3325
    ]
  ],
  "civilise": [
    [
      "adoucir",
      0.1375
    ],
    [
      "polir",
      0.1375
    ],
    [
      "faconner",
      0.11
    ],
    [
      "eduquer",
      0.11
    ],
    [
      "policer",
      0.0825
    ],
    [
      "humaniser",
      0.0825
    ],
    [
      "apprivoiser",
      0.0825
    ],
    [
      "affiner",
      0.055
    ],
    [
      "ameliorer",
      0.055
    ],
    [
      "corriger",
      0.055
    ],
    [
      "degrossir",
      0.055
    ],
    [
      "elever",
      0.0275
    ]
  ],
  "civiliser": [
    [
      "adoucir",
      0.1375
    ],
    [
      "polir",
      0.1375
    ],
    [
      "faconner",
      0.11
    ],
    [
      "eduquer",
      0.11
    ],
    [
      "policer",
      0.0825
    ],
    [
      "humaniser",
      0.0825
    ],
    [
      "apprivoiser",
      0.0825
    ],
    [
      "affiner",
      0.055
    ],
    [
      "ameliorer",
      0.055
    ],
    [
      "corriger",
      0.055
    ],
    [
      "degrossir",
      0.055
    ],
    [
      "elever",
      0.0275
    ]
  ],
  "proces": [
    [
      "contestation",
      0.0875
    ],
    [
      "procedure",
      0.0875
    ],
    [
      "action",
      0.065
    ],
    [
      "affaire",
      0.065
    ],
    [
      "cause",
      0.065
    ],
    [
      "chicane",
      0.065
    ],
    [
      "dispute",
      0.065
    ],
    [
      "litige",
      0.065
    ],
    [
      "processus",
      0.0425
    ],
    [
      "instance",
      0.0425
    ],
    [
      "developpement",
      0.0425
    ],
    [
      "procillon",
      0.02
    ],
    [
      "poursuite",
      0.02
    ],
    [
      "plaid",
      0.02
    ],
    [
      "marche",
      0.02
    ],
    [
      "litispendance",
      0.02
    ],
    [
      "debat",
      0.02
    ],
    [
      "cours",
      0.02
    ],
    [
      "condamnation",
      0.02
    ],
    [
      "cas",
      0.02
    ],
    [
      "blame",
      0.02
    ],
    [
      "avancement",
      0.02
    ],
    [
      "audience",
      0.02
    ],
    [
      "progres",
      0.02
    ]
  ],
  "micro": [
    [
      "microphone",
      0.5
    ],
    [
      "perche",
      0.5
    ]
  ],
  "sieste": [
    [
      "sommeil",
      0.295
    ],
    [
      "inaction",
      0.1175
    ],
    [
      "repos",
      0.1175
    ],
    [
      "roupillon",
      0.1175
    ],
    [
      "roupillette",
      0.0575
    ],
    [
      "ronflette",
      0.0575
    ],
    [
      "meridienne",
      0.0575
    ],
    [
      "dodo",
      0.0575
    ],
    [
      "assoupissement",
      0.0575
    ],
    [
      "somme",
      0.0575
    ]
  ],
  "deni": [
    [
      "denegation",
      0.4
    ],
    [
      "dementi",
      0.2
    ],
    [
      "refus",
      0.2
    ],
    [
      "scotomisation",
      0.2
    ]
  ],
  "grossesse": [
    [
      "gestation",
      0.25
    ],
    [
      "gravidisme",
      0.25
    ],
    [
      "gravidite",
      0.25
    ],
    [
      "maternite",
      0.25
    ]
  ],
  "adolescence": [
    [
      "jeunesse",
      0.25
    ],
    [
      "teenagers",
      0.0825
    ],
    [
      "seuil",
      0.0825
    ],
    [
      "puberte",
      0.0825
    ],
    [
      "jeunes",
      0.0825
    ],
    [
      "enfance",
      0.0825
    ],
    [
      "commencement",
      0.0825
    ]
  ],
  "secretement": [
    [
      "discretement",
      0.09
    ],
    [
      "furtivement",
      0.09
    ],
    [
      "subrepticement",
      0.045
    ],
    [
      "clandestinement",
      0.045
    ],
    [
      "obscurement",
      0.03
    ],
    [
      "incognito",
      0.03
    ],
    [
      "sourdement",
      0.0125
    ],
    [
      "interieurement",
      0.0125
    ],
    [
      "doucement",
      0.0125
    ],
    [
      "confidentiellement",
      0.0125
    ],
    [
      "esoteriquement",
      0.0125
    ]
  ],
  "sereinement": [
    [
      "calmement",
      0.285
    ],
    [
      "tranquillement",
      0.285
    ],
    [
      "froidement",
      0.1425
    ],
    [
      "paisiblement",
      0.1425
    ],
    [
      "placidement",
      0.1425
    ]
  ],
  "escale": [
    [
      "relache",
      0.2725
    ],
    [
      "arret",
      0.18
    ],
    [
      "halte",
      0.18
    ],
    [
      "port",
      0.09
    ],
    [
      "echelle",
      0.09
    ],
    [
      "etape",
      0.09
    ]
  ],
  "emprunt": [
    [
      "imitation",
      0.25
    ],
    [
      "calque",
      0.165
    ],
    [
      "plagiat",
      0.165
    ],
    [
      "adoption",
      0.0825
    ],
    [
      "copie",
      0.0825
    ],
    [
      "dette",
      0.0825
    ],
    [
      "demarquage",
      0.0825
    ],
    [
      "finance",
      0.0825
    ]
  ],
  "pelerin": [
    [
      "excursionniste",
      0.1525
    ],
    [
      "touriste",
      0.1525
    ],
    [
      "voyageur",
      0.1525
    ],
    [
      "peregrin",
      0.075
    ],
    [
      "penitent",
      0.075
    ],
    [
      "individu",
      0.075
    ],
    [
      "homme",
      0.075
    ],
    [
      "fidele",
      0.075
    ],
    [
      "devot",
      0.075
    ],
    [
      "visiteur",
      0.075
    ]
  ],
  "alerter": [
    [
      "avertir",
      0.2275
    ],
    [
      "informer",
      0.1825
    ],
    [
      "prevenir",
      0.135
    ],
    [
      "renseigner",
      0.0425
    ],
    [
      "inquieter",
      0.0425
    ],
    [
      "aviser",
      0.0425
    ],
    [
      "alarmer",
      0.0425
    ],
    [
      "signaler",
      0.0425
    ]
  ],
  "surnomme": [
    [
      "qualifier",
      0.3325
    ],
    [
      "affubler",
      0.165
    ],
    [
      "appeler",
      0.165
    ],
    [
      "baptiser",
      0.165
    ],
    [
      "nommer",
      0.165
    ]
  ],
  "surnommer": [
    [
      "qualifier",
      0.3325
    ],
    [
      "affubler",
      0.165
    ],
    [
      "appeler",
      0.165
    ],
    [
      "baptiser",
      0.165
    ],
    [
      "nommer",
      0.165
    ]
  ],
  "cuite": [
    [
      "fricasser",
      0.1025
    ],
    [
      "griller",
      0.0675
    ],
    [
      "mijoter",
      0.0675
    ],
    [
      "rotir",
      0.0675
    ],
    [
      "bruler",
      0.0575
    ],
    [
      "rissoler",
      0.045
    ],
    [
      "preparer",
      0.0325
    ],
    [
      "piquer",
      0.0325
    ],
    [
      "fricoter",
      0.0325
    ],
    [
      "chauffer",
      0.0325
    ],
    [
      "renverser",
      0.0225
    ],
    [
      "murir",
      0.0225
    ],
    [
      "mitonner",
      0.0225
    ],
    [
      "gratter",
      0.0225
    ],
    [
      "faire",
      0.0225
    ],
    [
      "cuisiner",
      0.0225
    ],
    [
      "calciner",
      0.0225
    ],
    [
      "bronzer",
      0.0225
    ],
    [
      "braiser",
      0.0225
    ],
    [
      "bouillir",
      0.0225
    ],
    [
      "boucaner",
      0.0225
    ],
    [
      "frire",
      0.01
    ],
    [
      "frissonner",
      0.01
    ],
    [
      "infuser",
      0.01
    ],
    [
      "recuire",
      0.01
    ],
    [
      "etouffer",
      0.01
    ],
    [
      "flamber",
      0.01
    ],
    [
      "digerer",
      0.01
    ],
    [
      "cramer",
      0.01
    ],
    [
      "carboniser",
      0.01
    ],
    [
      "blondir",
      0.01
    ],
    [
      "biscuiter",
      0.01
    ],
    [
      "attacher",
      0.01
    ],
    [
      "etuver",
      0.01
    ]
  ],
  "roubignoles": [],
  "clip": [
    [
      "agrafe",
      0.25
    ],
    [
      "attache",
      0.25
    ],
    [
      "boucle",
      0.125
    ],
    [
      "film",
      0.125
    ],
    [
      "videoclip",
      0.125
    ],
    [
      "epingle",
      0.125
    ]
  ],
  "guignol": [
    [
      "clown",
      0.1075
    ],
    [
      "pantin",
      0.1075
    ],
    [
      "polichinelle",
      0.1075
    ],
    [
      "charlot",
      0.065
    ],
    [
      "homme",
      0.065
    ],
    [
      "pitre",
      0.065
    ],
    [
      "type",
      0.0425
    ],
    [
      "saltimbanque",
      0.0425
    ],
    [
      "rigolo",
      0.0425
    ],
    [
      "pierrot",
      0.0425
    ],
    [
      "marionnette",
      0.0425
    ],
    [
      "gus",
      0.0425
    ],
    [
      "fantoche",
      0.0425
    ],
    [
      "gendarme",
      0.02
    ],
    [
      "castelet",
      0.02
    ],
    [
      "bete",
      0.02
    ],
    [
      "bonhomme",
      0.02
    ],
    [
      "arlequin",
      0.02
    ],
    [
      "amant",
      0.02
    ],
    [
      "agent",
      0.02
    ],
    [
      "gnafron",
      0.02
    ]
  ],
  "cogne": [
    [
      "agent",
      0.2725
    ],
    [
      "policier",
      0.2725
    ],
    [
      "bourre",
      0.09
    ],
    [
      "cognerie",
      0.09
    ],
    [
      "flic",
      0.09
    ],
    [
      "gendarme",
      0.09
    ],
    [
      "rousse",
      0.09
    ]
  ],
  "surprendre": [
    [
      "etonner",
      0.0675
    ],
    [
      "saisir",
      0.0575
    ],
    [
      "prendre",
      0.0475
    ],
    [
      "attraper",
      0.04
    ],
    [
      "decouvrir",
      0.04
    ],
    [
      "ebahir",
      0.035
    ],
    [
      "stupefier",
      0.035
    ],
    [
      "piquer",
      0.035
    ],
    [
      "confondre",
      0.03
    ],
    [
      "tromper",
      0.025
    ],
    [
      "obtenir",
      0.025
    ],
    [
      "deconcerter",
      0.025
    ],
    [
      "apercevoir",
      0.025
    ],
    [
      "ahurir",
      0.025
    ],
    [
      "abuser",
      0.025
    ],
    [
      "trouver",
      0.02
    ],
    [
      "soutirer",
      0.02
    ],
    [
      "renverser",
      0.02
    ],
    [
      "pincer",
      0.02
    ],
    [
      "frapper",
      0.02
    ],
    [
      "capter",
      0.02
    ],
    [
      "abasourdir",
      0.02
    ],
    [
      "eblouir",
      0.015
    ],
    [
      "voir",
      0.015
    ],
    [
      "remarquer",
      0.015
    ],
    [
      "extorquer",
      0.015
    ],
    [
      "derouter",
      0.015
    ],
    [
      "depister",
      0.015
    ],
    [
      "deceler",
      0.015
    ],
    [
      "attaquer",
      0.015
    ],
    [
      "arracher",
      0.015
    ],
    [
      "epater",
      0.01
    ],
    [
      "leurrer",
      0.01
    ],
    [
      "intercepter",
      0.01
    ],
    [
      "fondre",
      0.01
    ],
    [
      "derober",
      0.01
    ],
    [
      "duper",
      0.01
    ],
    [
      "discerner",
      0.01
    ],
    [
      "consterner",
      0.01
    ],
    [
      "choper",
      0.01
    ],
    [
      "s'apercevoir",
      0.005
    ],
    [
      "estomaquer",
      0.005
    ],
    [
      "embarrasser",
      0.005
    ],
    [
      "decevoir",
      0.005
    ],
    [
      "coincer",
      0.005
    ],
    [
      "circonvenir",
      0.005
    ],
    [
      "berner",
      0.005
    ],
    [
      "arriver",
      0.005
    ],
    [
      "ebouriffer",
      0.005
    ]
  ],
  "surpris": [
    [
      "etonner",
      0.0675
    ],
    [
      "saisir",
      0.0575
    ],
    [
      "prendre",
      0.0475
    ],
    [
      "attraper",
      0.04
    ],
    [
      "decouvrir",
      0.04
    ],
    [
      "ebahir",
      0.035
    ],
    [
      "stupefier",
      0.035
    ],
    [
      "piquer",
      0.035
    ],
    [
      "confondre",
      0.03
    ],
    [
      "tromper",
      0.025
    ],
    [
      "obtenir",
      0.025
    ],
    [
      "deconcerter",
      0.025
    ],
    [
      "apercevoir",
      0.025
    ],
    [
      "ahurir",
      0.025
    ],
    [
      "abuser",
      0.025
    ],
    [
      "trouver",
      0.02
    ],
    [
      "soutirer",
      0.02
    ],
    [
      "renverser",
      0.02
    ],
    [
      "pincer",
      0.02
    ],
    [
      "frapper",
      0.02
    ],
    [
      "capter",
      0.02
    ],
    [
      "abasourdir",
      0.02
    ],
    [
      "eblouir",
      0.015
    ],
    [
      "voir",
      0.015
    ],
    [
      "remarquer",
      0.015
    ],
    [
      "extorquer",
      0.015
    ],
    [
      "derouter",
      0.015
    ],
    [
      "depister",
      0.015
    ],
    [
      "deceler",
      0.015
    ],
    [
      "attaquer",
      0.015
    ],
    [
      "arracher",
      0.015
    ],
    [
      "epater",
      0.01
    ],
    [
      "leurrer",
      0.01
    ],
    [
      "intercepter",
      0.01
    ],
    [
      "fondre",
      0.01
    ],
    [
      "derober",
      0.01
    ],
    [
      "duper",
      0.01
    ],
    [
      "discerner",
      0.01
    ],
    [
      "consterner",
      0.01
    ],
    [
      "choper",
      0.01
    ],
    [
      "s'apercevoir",
      0.005
    ],
    [
      "estomaquer",
      0.005
    ],
    [
      "embarrasser",
      0.005
    ],
    [
      "decevoir",
      0.005
    ],
    [
      "coincer",
      0.005
    ],
    [
      "circonvenir",
      0.005
    ],
    [
      "berner",
      0.005
    ],
    [
      "arriver",
      0.005
    ],
    [
      "ebouriffer",
      0.005
    ]
  ],
  "sevrer": [
    [
      "priver",
      0.165
    ],
    [
      "frustrer",
      0.1475
    ],
    [
      "enlever",
      0.1275
    ],
    [
      "depouiller",
      0.11
    ],
    [
      "spolier",
      0.0925
    ],
    [
      "oter",
      0.0725
    ],
    [
      "voler",
      0.055
    ],
    [
      "deposseder",
      0.055
    ],
    [
      "demunir",
      0.035
    ],
    [
      "ravir",
      0.035
    ],
    [
      "appauvrir",
      0.0175
    ],
    [
      "desheriter",
      0.0175
    ],
    [
      "empecher",
      0.0175
    ],
    [
      "interdire",
      0.0175
    ],
    [
      "separer",
      0.0175
    ]
  ],
  "pieux": [
    [
      "baton",
      0.165
    ],
    [
      "piquet",
      0.11
    ],
    [
      "plumard",
      0.11
    ],
    [
      "echalas",
      0.055
    ],
    [
      "rame",
      0.055
    ],
    [
      "poteau",
      0.055
    ],
    [
      "portefeuille",
      0.055
    ],
    [
      "pilotis",
      0.055
    ],
    [
      "pilot",
      0.055
    ],
    [
      "palis",
      0.055
    ],
    [
      "pal",
      0.055
    ],
    [
      "lit",
      0.055
    ],
    [
      "fiche",
      0.055
    ],
    [
      "epieu",
      0.055
    ]
  ],
  "vriller": [
    [
      "percer",
      0.25
    ],
    [
      "tarauder",
      0.25
    ],
    [
      "transpercer",
      0.25
    ]
  ],
  "vrille": [
    [
      "foret",
      0.1675
    ],
    [
      "perceuse",
      0.1675
    ],
    [
      "tariere",
      0.0825
    ],
    [
      "percerette",
      0.0825
    ],
    [
      "meche",
      0.0825
    ],
    [
      "griffe",
      0.0825
    ],
    [
      "filament",
      0.0825
    ],
    [
      "cirre",
      0.0825
    ],
    [
      "attache",
      0.0825
    ]
  ],
  "casquette": [
    [
      "coiffure",
      0.22
    ],
    [
      "bombe",
      0.11
    ],
    [
      "bache",
      0.11
    ],
    [
      "chapeau",
      0.11
    ],
    [
      "gapette",
      0.11
    ],
    [
      "kepi",
      0.11
    ],
    [
      "tampon",
      0.11
    ]
  ],
  "philosophe": [
    [
      "calme",
      0.095
    ],
    [
      "impassible",
      0.095
    ],
    [
      "sage",
      0.07
    ],
    [
      "tranquille",
      0.07
    ],
    [
      "theoricien",
      0.045
    ],
    [
      "stoique",
      0.045
    ],
    [
      "savant",
      0.045
    ],
    [
      "penseur",
      0.045
    ],
    [
      "insouciant",
      0.045
    ],
    [
      "optimiste",
      0.0225
    ],
    [
      "philosophique",
      0.0225
    ],
    [
      "peripateticien",
      0.0225
    ],
    [
      "retire",
      0.0225
    ],
    [
      "reflechi",
      0.0225
    ],
    [
      "resigne",
      0.0225
    ],
    [
      "satisfait",
      0.0225
    ],
    [
      "metaphysicien",
      0.0225
    ],
    [
      "leger",
      0.0225
    ],
    [
      "libertin",
      0.0225
    ],
    [
      "indulgent",
      0.0225
    ],
    [
      "impavide",
      0.0225
    ],
    [
      "ferme",
      0.0225
    ],
    [
      "encyclopediste",
      0.0225
    ],
    [
      "contemplateur",
      0.0225
    ],
    [
      "alchimiste",
      0.0225
    ],
    [
      "serieux",
      0.0225
    ]
  ],
  "philosopher": [
    [
      "raisonner",
      0.3325
    ],
    [
      "discuter",
      0.1325
    ],
    [
      "mediter",
      0.1325
    ],
    [
      "cogiter",
      0.065
    ],
    [
      "disputer",
      0.065
    ],
    [
      "disserter",
      0.065
    ],
    [
      "ratiociner",
      0.065
    ],
    [
      "speculer",
      0.065
    ],
    [
      "etudier",
      0.065
    ]
  ],
  "musicien": [
    [
      "chanteur",
      0.165
    ],
    [
      "virtuose",
      0.1175
    ],
    [
      "executant",
      0.07
    ],
    [
      "soliste",
      0.0475
    ],
    [
      "maestro",
      0.0475
    ],
    [
      "artiste",
      0.0475
    ],
    [
      "massacreur",
      0.0225
    ],
    [
      "maitrise",
      0.0225
    ],
    [
      "musical",
      0.0225
    ],
    [
      "musicastre",
      0.0225
    ],
    [
      "musicot",
      0.0225
    ],
    [
      "melomane",
      0.0225
    ],
    [
      "tambour",
      0.0225
    ],
    [
      "troubadour",
      0.0225
    ],
    [
      "joueur",
      0.0225
    ],
    [
      "interprete",
      0.0225
    ],
    [
      "instrumentiste",
      0.0225
    ],
    [
      "amphion",
      0.0225
    ],
    [
      "choriste",
      0.0225
    ],
    [
      "clique",
      0.0225
    ],
    [
      "compositeur",
      0.0225
    ],
    [
      "concertiste",
      0.0225
    ],
    [
      "coryphee",
      0.0225
    ],
    [
      "fanfare",
      0.0225
    ],
    [
      "violoniste",
      0.0225
    ]
  ],
  "badaud": [
    [
      "flaneur",
      0.165
    ],
    [
      "niais",
      0.11
    ],
    [
      "sot",
      0.055
    ],
    [
      "rodeur",
      0.055
    ],
    [
      "promeneur",
      0.055
    ],
    [
      "oisif",
      0.055
    ],
    [
      "nigaud",
      0.055
    ],
    [
      "curieux",
      0.055
    ],
    [
      "credule",
      0.055
    ],
    [
      "bete",
      0.055
    ],
    [
      "badin",
      0.055
    ],
    [
      "stupide",
      0.055
    ]
  ],
  "hymne": [
    [
      "chant",
      0.1375
    ],
    [
      "cantique",
      0.11
    ],
    [
      "poeme",
      0.11
    ],
    [
      "symphonie",
      0.055
    ],
    [
      "psaume",
      0.055
    ],
    [
      "prose",
      0.055
    ],
    [
      "musique",
      0.055
    ],
    [
      "harmonie",
      0.055
    ],
    [
      "concert",
      0.055
    ],
    [
      "choral",
      0.055
    ],
    [
      "choeur",
      0.055
    ],
    [
      "stance",
      0.0275
    ],
    [
      "pean",
      0.0275
    ],
    [
      "ode",
      0.0275
    ],
    [
      "marche",
      0.0275
    ],
    [
      "antienne",
      0.0275
    ],
    [
      "air",
      0.0275
    ],
    [
      "sequence",
      0.0275
    ]
  ],
  "eprendre": [
    [
      "allumer",
      0.3325
    ],
    [
      "embraser",
      0.3325
    ],
    [
      "epoindre",
      0.3325
    ]
  ],
  "epris": [
    [
      "amoureux",
      0.1825
    ],
    [
      "passionne",
      0.135
    ],
    [
      "fou",
      0.09
    ],
    [
      "feru",
      0.09
    ],
    [
      "infatue",
      0.09
    ],
    [
      "seduit",
      0.045
    ],
    [
      "pris",
      0.045
    ],
    [
      "polarise",
      0.045
    ],
    [
      "entiche",
      0.045
    ],
    [
      "emballe",
      0.045
    ],
    [
      "chipe",
      0.045
    ],
    [
      "avide",
      0.045
    ],
    [
      "assote",
      0.045
    ],
    [
      "toque",
      0.045
    ]
  ],
  "cite": [
    [
      "appeler",
      0.0975
    ],
    [
      "mentionner",
      0.0675
    ],
    [
      "evoquer",
      0.0575
    ],
    [
      "signaler",
      0.0575
    ],
    [
      "designer",
      0.0575
    ],
    [
      "assigner",
      0.0575
    ],
    [
      "alleguer",
      0.0475
    ],
    [
      "indiquer",
      0.0475
    ],
    [
      "nommer",
      0.0475
    ],
    [
      "traduire",
      0.0375
    ],
    [
      "signifier",
      0.0375
    ],
    [
      "rapporter",
      0.0375
    ],
    [
      "convoquer",
      0.0375
    ],
    [
      "accuser",
      0.0275
    ],
    [
      "invoquer",
      0.0275
    ],
    [
      "sommer",
      0.0175
    ],
    [
      "rappeler",
      0.0175
    ],
    [
      "produire",
      0.0175
    ],
    [
      "mander",
      0.0175
    ],
    [
      "deferer",
      0.0175
    ],
    [
      "apporter",
      0.0175
    ],
    [
      "viser",
      0.0075
    ],
    [
      "recompenser",
      0.0075
    ],
    [
      "noter",
      0.0075
    ],
    [
      "intimer",
      0.0075
    ],
    [
      "consigner",
      0.0075
    ],
    [
      "avancer",
      0.0075
    ],
    [
      "ajourner",
      0.0075
    ],
    [
      "enumerer",
      0.0075
    ]
  ],
  "citer": [
    [
      "appeler",
      0.0975
    ],
    [
      "mentionner",
      0.0675
    ],
    [
      "evoquer",
      0.0575
    ],
    [
      "signaler",
      0.0575
    ],
    [
      "designer",
      0.0575
    ],
    [
      "assigner",
      0.0575
    ],
    [
      "alleguer",
      0.0475
    ],
    [
      "indiquer",
      0.0475
    ],
    [
      "nommer",
      0.0475
    ],
    [
      "traduire",
      0.0375
    ],
    [
      "signifier",
      0.0375
    ],
    [
      "rapporter",
      0.0375
    ],
    [
      "convoquer",
      0.0375
    ],
    [
      "accuser",
      0.0275
    ],
    [
      "invoquer",
      0.0275
    ],
    [
      "sommer",
      0.0175
    ],
    [
      "rappeler",
      0.0175
    ],
    [
      "produire",
      0.0175
    ],
    [
      "mander",
      0.0175
    ],
    [
      "deferer",
      0.0175
    ],
    [
      "apporter",
      0.0175
    ],
    [
      "viser",
      0.0075
    ],
    [
      "recompenser",
      0.0075
    ],
    [
      "noter",
      0.0075
    ],
    [
      "intimer",
      0.0075
    ],
    [
      "consigner",
      0.0075
    ],
    [
      "avancer",
      0.0075
    ],
    [
      "ajourner",
      0.0075
    ],
    [
      "enumerer",
      0.0075
    ]
  ],
  "couver": [
    [
      "choyer",
      0.1675
    ],
    [
      "dorloter",
      0.11
    ],
    [
      "soigner",
      0.11
    ],
    [
      "chouchouter",
      0.0725
    ],
    [
      "mignoter",
      0.0725
    ],
    [
      "gater",
      0.055
    ],
    [
      "cajoler",
      0.055
    ],
    [
      "preparer",
      0.035
    ],
    [
      "nourrir",
      0.035
    ],
    [
      "menager",
      0.035
    ],
    [
      "caliner",
      0.035
    ],
    [
      "materner",
      0.0175
    ],
    [
      "incuber",
      0.0175
    ],
    [
      "entretenir",
      0.0175
    ],
    [
      "devorer",
      0.0175
    ],
    [
      "cuver",
      0.0175
    ],
    [
      "bruler",
      0.0175
    ],
    [
      "bichonner",
      0.0175
    ],
    [
      "proteger",
      0.0175
    ]
  ],
  "marinier": [
    [
      "batelier",
      0.3325
    ],
    [
      "maistrance",
      0.3325
    ],
    [
      "marin",
      0.3325
    ]
  ],
  "gueux": [
    [
      "misereux",
      0.115
    ],
    [
      "pauvre",
      0.115
    ],
    [
      "miserable",
      0.1025
    ],
    [
      "necessiteux",
      0.085
    ],
    [
      "mendiant",
      0.0475
    ],
    [
      "besogneux",
      0.04
    ],
    [
      "clochard",
      0.04
    ],
    [
      "indigent",
      0.04
    ],
    [
      "vagabond",
      0.04
    ],
    [
      "truand",
      0.03
    ],
    [
      "jacques",
      0.0225
    ],
    [
      "pouilleux",
      0.0175
    ],
    [
      "miteux",
      0.0175
    ],
    [
      "malheureux",
      0.0175
    ],
    [
      "coquin",
      0.0175
    ],
    [
      "afflige",
      0.0175
    ],
    [
      "trimardeur",
      0.01
    ],
    [
      "paria",
      0.01
    ],
    [
      "mendigot",
      0.01
    ],
    [
      "chemineau",
      0.01
    ],
    [
      "sabouleux",
      0.005
    ],
    [
      "malandrin",
      0.005
    ],
    [
      "gueusard",
      0.005
    ],
    [
      "gueusaille",
      0.005
    ],
    [
      "galvaudeux",
      0.005
    ],
    [
      "fripon",
      0.005
    ],
    [
      "disetteux",
      0.005
    ],
    [
      "cloporte",
      0.005
    ],
    [
      "clodo",
      0.005
    ],
    [
      "belitre",
      0.005
    ]
  ],
  "bavarder": [
    [
      "jaboter",
      0.1525
    ],
    [
      "parler",
      0.09
    ],
    [
      "jaser",
      0.0725
    ],
    [
      "causer",
      0.0525
    ],
    [
      "babiller",
      0.0475
    ],
    [
      "jacasser",
      0.0475
    ],
    [
      "papoter",
      0.0425
    ],
    [
      "cancaner",
      0.0425
    ],
    [
      "palabrer",
      0.035
    ],
    [
      "caqueter",
      0.03
    ],
    [
      "bavasser",
      0.025
    ],
    [
      "commerer",
      0.025
    ],
    [
      "discourir",
      0.025
    ],
    [
      "parloter",
      0.025
    ],
    [
      "debiter",
      0.02
    ],
    [
      "dire",
      0.02
    ],
    [
      "degoiser",
      0.0175
    ],
    [
      "publier",
      0.0175
    ],
    [
      "raconter",
      0.0175
    ],
    [
      "potiner",
      0.0125
    ],
    [
      "jaspiner",
      0.0125
    ],
    [
      "deblaterer",
      0.0125
    ],
    [
      "clabauder",
      0.0125
    ],
    [
      "s'entretenir",
      0.0075
    ],
    [
      "repandre",
      0.0075
    ],
    [
      "jacter",
      0.0075
    ],
    [
      "debiner",
      0.0075
    ],
    [
      "discuter",
      0.0075
    ],
    [
      "converser",
      0.0075
    ],
    [
      "colporter",
      0.0075
    ],
    [
      "coasser",
      0.0075
    ],
    [
      "cailleter",
      0.0075
    ],
    [
      "baver",
      0.0075
    ],
    [
      "jaspiller",
      0.0025
    ],
    [
      "lantiponner",
      0.0025
    ],
    [
      "s'abandonner",
      0.0025
    ],
    [
      "verbiager",
      0.0025
    ],
    [
      "jabouiner",
      0.0025
    ],
    [
      "deviser",
      0.0025
    ],
    [
      "broder",
      0.0025
    ],
    [
      "bonimenter",
      0.0025
    ],
    [
      "blaguer",
      0.0025
    ],
    [
      "baratiner",
      0.0025
    ],
    [
      "bagouler",
      0.0025
    ],
    [
      "echanger",
      0.0025
    ]
  ],
  "eclatant": [
    [
      "brillant",
      0.1125
    ],
    [
      "etincelant",
      0.045
    ],
    [
      "beau",
      0.0425
    ],
    [
      "eblouissant",
      0.035
    ],
    [
      "vif",
      0.0325
    ],
    [
      "splendide",
      0.0325
    ],
    [
      "fort",
      0.0325
    ],
    [
      "lumineux",
      0.03
    ],
    [
      "evident",
      0.025
    ],
    [
      "retentissant",
      0.025
    ],
    [
      "remarquable",
      0.025
    ],
    [
      "glorieux",
      0.025
    ],
    [
      "clair",
      0.025
    ],
    [
      "resplendissant",
      0.0225
    ],
    [
      "radieux",
      0.02
    ],
    [
      "rutilant",
      0.02
    ],
    [
      "haut",
      0.0175
    ],
    [
      "flamboyant",
      0.0175
    ],
    [
      "tonitruant",
      0.0125
    ],
    [
      "sonore",
      0.0125
    ],
    [
      "percant",
      0.0125
    ],
    [
      "manifeste",
      0.0125
    ],
    [
      "magnifique",
      0.0125
    ],
    [
      "ardent",
      0.0125
    ],
    [
      "violent",
      0.01
    ],
    [
      "prestigieux",
      0.01
    ],
    [
      "limpide",
      0.01
    ],
    [
      "illustre",
      0.01
    ],
    [
      "fulgurant",
      0.01
    ],
    [
      "distingue",
      0.01
    ],
    [
      "bruyant",
      0.01
    ],
    [
      "aigu",
      0.01
    ],
    [
      "tapageur",
      0.0075
    ],
    [
      "somptueux",
      0.0075
    ],
    [
      "resonnant",
      0.0075
    ],
    [
      "riche",
      0.0075
    ],
    [
      "releve",
      0.0075
    ],
    [
      "rayonnant",
      0.0075
    ],
    [
      "notoire",
      0.0075
    ],
    [
      "flambant",
      0.0075
    ],
    [
      "flagrant",
      0.0075
    ],
    [
      "celebre",
      0.0075
    ],
    [
      "aveuglant",
      0.0075
    ],
    [
      "voyant",
      0.005
    ],
    [
      "signale",
      0.005
    ],
    [
      "poli",
      0.005
    ],
    [
      "notable",
      0.005
    ],
    [
      "indiscutable",
      0.005
    ],
    [
      "frappant",
      0.005
    ],
    [
      "fastueux",
      0.005
    ],
    [
      "colore",
      0.005
    ],
    [
      "vibrant",
      0.0025
    ],
    [
      "triomphal",
      0.0025
    ],
    [
      "strident",
      0.0025
    ],
    [
      "plein",
      0.0025
    ],
    [
      "irrecusable",
      0.0025
    ],
    [
      "fracassant",
      0.0025
    ],
    [
      "florissant",
      0.0025
    ],
    [
      "cru",
      0.0025
    ],
    [
      "authentique",
      0.0025
    ],
    [
      "tonnant",
      0.0
    ],
    [
      "sifflant",
      0.0
    ],
    [
      "reluisant",
      0.0
    ],
    [
      "nitescent",
      0.0
    ],
    [
      "miroitant",
      0.0
    ],
    [
      "luxueux",
      0.0
    ],
    [
      "insigne",
      0.0
    ],
    [
      "frais",
      0.0
    ],
    [
      "triomphant",
      0.0
    ]
  ],
  "distrait": [
    [
      "detourner",
      0.085
    ],
    [
      "enlever",
      0.085
    ],
    [
      "divertir",
      0.06
    ],
    [
      "detacher",
      0.06
    ],
    [
      "eloigner",
      0.0475
    ],
    [
      "egayer",
      0.0475
    ],
    [
      "separer",
      0.0475
    ],
    [
      "soustraire",
      0.0475
    ],
    [
      "amuser",
      0.0475
    ],
    [
      "desennuyer",
      0.035
    ],
    [
      "retrancher",
      0.035
    ],
    [
      "voler",
      0.0225
    ],
    [
      "prelever",
      0.0225
    ],
    [
      "occuper",
      0.0225
    ],
    [
      "extraire",
      0.0225
    ],
    [
      "derober",
      0.0225
    ],
    [
      "derider",
      0.0225
    ],
    [
      "deranger",
      0.0225
    ],
    [
      "delasser",
      0.0225
    ],
    [
      "debaucher",
      0.0225
    ],
    [
      "dissiper",
      0.0225
    ],
    [
      "changer",
      0.0225
    ],
    [
      "recreer",
      0.01
    ],
    [
      "piller",
      0.01
    ],
    [
      "demembrer",
      0.01
    ],
    [
      "dissuader",
      0.01
    ],
    [
      "consoler",
      0.01
    ],
    [
      "baguenauder",
      0.01
    ],
    [
      "aerer",
      0.01
    ],
    [
      "etourdir",
      0.01
    ]
  ],
  "distraire": [
    [
      "detourner",
      0.085
    ],
    [
      "enlever",
      0.085
    ],
    [
      "divertir",
      0.06
    ],
    [
      "detacher",
      0.06
    ],
    [
      "eloigner",
      0.0475
    ],
    [
      "egayer",
      0.0475
    ],
    [
      "separer",
      0.0475
    ],
    [
      "soustraire",
      0.0475
    ],
    [
      "amuser",
      0.0475
    ],
    [
      "desennuyer",
      0.035
    ],
    [
      "retrancher",
      0.035
    ],
    [
      "voler",
      0.0225
    ],
    [
      "prelever",
      0.0225
    ],
    [
      "occuper",
      0.0225
    ],
    [
      "extraire",
      0.0225
    ],
    [
      "derober",
      0.0225
    ],
    [
      "derider",
      0.0225
    ],
    [
      "deranger",
      0.0225
    ],
    [
      "delasser",
      0.0225
    ],
    [
      "debaucher",
      0.0225
    ],
    [
      "dissiper",
      0.0225
    ],
    [
      "changer",
      0.0225
    ],
    [
      "recreer",
      0.01
    ],
    [
      "piller",
      0.01
    ],
    [
      "demembrer",
      0.01
    ],
    [
      "dissuader",
      0.01
    ],
    [
      "consoler",
      0.01
    ],
    [
      "baguenauder",
      0.01
    ],
    [
      "aerer",
      0.01
    ],
    [
      "etourdir",
      0.01
    ]
  ],
  "grenouille": [
    [
      "raine",
      0.25
    ],
    [
      "rainette",
      0.25
    ],
    [
      "roussette",
      0.25
    ],
    [
      "tirelire",
      0.25
    ]
  ],
  "huit": [
    [
      "huitain",
      0.3325
    ],
    [
      "huitante",
      0.3325
    ],
    [
      "huitieme",
      0.3325
    ]
  ],
  "debilite": [
    [
      "affaiblir",
      0.355
    ],
    [
      "anemier",
      0.1425
    ],
    [
      "effeminer",
      0.1425
    ],
    [
      "affaisser",
      0.07
    ],
    [
      "casser",
      0.07
    ],
    [
      "ramollir",
      0.07
    ],
    [
      "epuiser",
      0.07
    ],
    [
      "etioler",
      0.07
    ]
  ],
  "debiliter": [
    [
      "affaiblir",
      0.355
    ],
    [
      "anemier",
      0.1425
    ],
    [
      "effeminer",
      0.1425
    ],
    [
      "affaisser",
      0.07
    ],
    [
      "casser",
      0.07
    ],
    [
      "ramollir",
      0.07
    ],
    [
      "epuiser",
      0.07
    ],
    [
      "etioler",
      0.07
    ]
  ],
  "quiconque": [
    [
      "personne",
      0.25
    ],
    [
      "tout",
      0.25
    ]
  ],
  "complet": [
    [
      "parfait",
      0.1075
    ],
    [
      "absolu",
      0.1
    ],
    [
      "entier",
      0.1
    ],
    [
      "total",
      0.0825
    ],
    [
      "franc",
      0.0525
    ],
    [
      "acheve",
      0.045
    ],
    [
      "plein",
      0.0375
    ],
    [
      "pur",
      0.0375
    ],
    [
      "integral",
      0.03
    ],
    [
      "bon",
      0.03
    ],
    [
      "accompli",
      0.0225
    ],
    [
      "ideal",
      0.0225
    ],
    [
      "profond",
      0.0225
    ],
    [
      "unanime",
      0.015
    ],
    [
      "radical",
      0.015
    ],
    [
      "intact",
      0.015
    ],
    [
      "fieffe",
      0.015
    ],
    [
      "exhaustif",
      0.015
    ],
    [
      "exact",
      0.015
    ],
    [
      "costume",
      0.015
    ],
    [
      "consomme",
      0.015
    ],
    [
      "comble",
      0.015
    ],
    [
      "bourre",
      0.015
    ],
    [
      "bonde",
      0.015
    ],
    [
      "rempli",
      0.005
    ],
    [
      "revolu",
      0.005
    ],
    [
      "surcharge",
      0.005
    ],
    [
      "termine",
      0.005
    ],
    [
      "tout",
      0.005
    ],
    [
      "universel",
      0.005
    ],
    [
      "plenier",
      0.005
    ],
    [
      "intime",
      0.005
    ],
    [
      "intense",
      0.005
    ],
    [
      "global",
      0.005
    ],
    [
      "comprehensif",
      0.005
    ],
    [
      "complete",
      0.005
    ],
    [
      "clos",
      0.005
    ],
    [
      "adequat",
      0.005
    ],
    [
      "vetement",
      0.005
    ]
  ],
  "van": [
    [
      "batteuse",
      0.2
    ],
    [
      "camionnette",
      0.2
    ],
    [
      "crible",
      0.2
    ],
    [
      "fourgon",
      0.2
    ],
    [
      "tamis",
      0.2
    ]
  ],
  "fan": [
    [
      "adulateur",
      0.3325
    ],
    [
      "fana",
      0.3325
    ],
    [
      "groupie",
      0.3325
    ]
  ],
  "invisible": [
    [
      "imperceptible",
      0.1925
    ],
    [
      "insaisissable",
      0.16
    ],
    [
      "indiscernable",
      0.095
    ],
    [
      "mysterieux",
      0.095
    ],
    [
      "secret",
      0.095
    ],
    [
      "insensible",
      0.0625
    ],
    [
      "indistinct",
      0.0625
    ],
    [
      "inapparent",
      0.0625
    ],
    [
      "aveugle",
      0.03
    ],
    [
      "indecelable",
      0.03
    ],
    [
      "introuvable",
      0.03
    ],
    [
      "petit",
      0.03
    ],
    [
      "voile",
      0.03
    ]
  ],
  "derange": [
    [
      "troubler",
      0.1225
    ],
    [
      "bouleverser",
      0.08
    ],
    [
      "brouiller",
      0.0625
    ],
    [
      "alterer",
      0.04
    ],
    [
      "perturber",
      0.04
    ],
    [
      "changer",
      0.035
    ],
    [
      "detraquer",
      0.03
    ],
    [
      "pervertir",
      0.025
    ],
    [
      "embarrasser",
      0.025
    ],
    [
      "deregler",
      0.025
    ],
    [
      "deplacer",
      0.025
    ],
    [
      "defaire",
      0.025
    ],
    [
      "embrouiller",
      0.0225
    ],
    [
      "gener",
      0.0225
    ],
    [
      "remuer",
      0.0225
    ],
    [
      "rompre",
      0.0175
    ],
    [
      "detourner",
      0.0175
    ],
    [
      "emouvoir",
      0.0125
    ],
    [
      "toucher",
      0.0125
    ],
    [
      "interrompre",
      0.0125
    ],
    [
      "desorganiser",
      0.0125
    ],
    [
      "desajuster",
      0.0125
    ],
    [
      "disloquer",
      0.0125
    ],
    [
      "contrarier",
      0.0125
    ],
    [
      "chambouler",
      0.0125
    ],
    [
      "chambarder",
      0.0125
    ],
    [
      "desequilibrer",
      0.0075
    ],
    [
      "devoyer",
      0.0075
    ],
    [
      "embarbouiller",
      0.0075
    ],
    [
      "gater",
      0.0075
    ],
    [
      "importuner",
      0.0075
    ],
    [
      "incommoder",
      0.0075
    ],
    [
      "transporter",
      0.0075
    ],
    [
      "destabiliser",
      0.0075
    ],
    [
      "demenager",
      0.0075
    ],
    [
      "demolir",
      0.0075
    ],
    [
      "bousculer",
      0.0075
    ],
    [
      "distraire",
      0.0075
    ],
    [
      "debaucher",
      0.0075
    ],
    [
      "declasser",
      0.0075
    ],
    [
      "decoiffer",
      0.0075
    ],
    [
      "deconcerter",
      0.0075
    ],
    [
      "deglinguer",
      0.0075
    ],
    [
      "farfouiller",
      0.0025
    ],
    [
      "ennuyer",
      0.0025
    ],
    [
      "desaxer",
      0.0025
    ],
    [
      "desassortir",
      0.0025
    ],
    [
      "desassembler",
      0.0025
    ],
    [
      "depeigner",
      0.0025
    ],
    [
      "couper",
      0.0025
    ],
    [
      "contrecarrer",
      0.0025
    ],
    [
      "bouger",
      0.0025
    ],
    [
      "aliener",
      0.0025
    ],
    [
      "affoler",
      0.0025
    ],
    [
      "intervertir",
      0.0025
    ]
  ],
  "petasse": [
    [
      "crainte",
      0.25
    ],
    [
      "pouffiasse",
      0.25
    ],
    [
      "prostituee",
      0.25
    ],
    [
      "petoche",
      0.25
    ]
  ],
  "etage": [
    [
      "niveau",
      0.1425
    ],
    [
      "classe",
      0.1125
    ],
    [
      "degre",
      0.1125
    ],
    [
      "echelon",
      0.085
    ],
    [
      "rang",
      0.085
    ],
    [
      "palier",
      0.085
    ],
    [
      "categorie",
      0.085
    ],
    [
      "stade",
      0.055
    ],
    [
      "origine",
      0.0275
    ],
    [
      "hauteur",
      0.0275
    ],
    [
      "gradin",
      0.0275
    ],
    [
      "genre",
      0.0275
    ],
    [
      "division",
      0.0275
    ],
    [
      "couche",
      0.0275
    ],
    [
      "carre",
      0.0275
    ]
  ],
  "etager": [
    [
      "hierarchiser",
      0.5
    ],
    [
      "superposer",
      0.25
    ],
    [
      "echelonner",
      0.25
    ]
  ],
  "consentir": [
    [
      "accepter",
      0.1025
    ],
    [
      "acquiescer",
      0.0875
    ],
    [
      "admettre",
      0.0725
    ],
    [
      "approuver",
      0.055
    ],
    [
      "permettre",
      0.055
    ],
    [
      "accorder",
      0.045
    ],
    [
      "ceder",
      0.045
    ],
    [
      "tolerer",
      0.03
    ],
    [
      "autoriser",
      0.03
    ],
    [
      "donner",
      0.025
    ],
    [
      "condescendre",
      0.02
    ],
    [
      "souscrire",
      0.015
    ],
    [
      "laisser",
      0.015
    ],
    [
      "daigner",
      0.015
    ],
    [
      "acceder",
      0.015
    ],
    [
      "octroyer",
      0.01
    ],
    [
      "avouer",
      0.01
    ],
    [
      "adopter",
      0.01
    ],
    [
      "adherer",
      0.01
    ],
    [
      "s'abandonner",
      0.0025
    ],
    [
      "opiner",
      0.0025
    ],
    [
      "marcher",
      0.0025
    ],
    [
      "entendre",
      0.0025
    ],
    [
      "assentir",
      0.0025
    ],
    [
      "applaudir",
      0.0025
    ],
    [
      "toper",
      0.0025
    ]
  ],
  "consentant": [
    [
      "approbateur",
      0.3325
    ],
    [
      "resigne",
      0.3325
    ],
    [
      "volontaire",
      0.3325
    ]
  ],
  "spiral": [],
  "spirale": [
    [
      "courbe",
      0.2
    ],
    [
      "helice",
      0.2
    ],
    [
      "colimacon",
      0.0975
    ],
    [
      "habitacle",
      0.0975
    ],
    [
      "revolution",
      0.0975
    ],
    [
      "torsade",
      0.0975
    ],
    [
      "vis",
      0.0975
    ],
    [
      "vortex",
      0.0975
    ]
  ],
  "visiter": [
    [
      "examiner",
      0.095
    ],
    [
      "explorer",
      0.095
    ],
    [
      "parcourir",
      0.075
    ],
    [
      "voir",
      0.075
    ],
    [
      "sonder",
      0.055
    ],
    [
      "prospecter",
      0.055
    ],
    [
      "pratiquer",
      0.055
    ],
    [
      "inspecter",
      0.055
    ],
    [
      "frequenter",
      0.055
    ],
    [
      "fouiller",
      0.055
    ],
    [
      "faire",
      0.055
    ],
    [
      "courir",
      0.055
    ],
    [
      "voyager",
      0.0375
    ],
    [
      "penetrer",
      0.0375
    ],
    [
      "hanter",
      0.0375
    ],
    [
      "perquisitionner",
      0.0175
    ],
    [
      "reconnaitre",
      0.0175
    ],
    [
      "saluer",
      0.0175
    ],
    [
      "sillonner",
      0.0175
    ]
  ],
  "visite": [
    [
      "examen",
      0.12
    ],
    [
      "descente",
      0.0725
    ],
    [
      "voyage",
      0.0725
    ],
    [
      "transport",
      0.0475
    ],
    [
      "tour",
      0.0475
    ],
    [
      "ronde",
      0.0475
    ],
    [
      "perquisition",
      0.0475
    ],
    [
      "inspection",
      0.0475
    ],
    [
      "incursion",
      0.0475
    ],
    [
      "excursion",
      0.0475
    ],
    [
      "fouille",
      0.0225
    ],
    [
      "rencontre",
      0.0225
    ],
    [
      "reception",
      0.0225
    ],
    [
      "tournee",
      0.0225
    ],
    [
      "visitation",
      0.0225
    ],
    [
      "expertise",
      0.0225
    ],
    [
      "exercice",
      0.0225
    ],
    [
      "entrevue",
      0.0225
    ],
    [
      "demarche",
      0.0225
    ],
    [
      "controle",
      0.0225
    ],
    [
      "consultation",
      0.0225
    ],
    [
      "audience",
      0.0225
    ],
    [
      "assiduite",
      0.0225
    ],
    [
      "arraisonnement",
      0.0225
    ],
    [
      "visiteur",
      0.0225
    ]
  ],
  "false": [],
  "fausses": [
    [
      "alterer",
      0.13
    ],
    [
      "deformer",
      0.0875
    ],
    [
      "denaturer",
      0.0875
    ],
    [
      "frelater",
      0.07
    ],
    [
      "deguiser",
      0.0475
    ],
    [
      "corrompre",
      0.0425
    ],
    [
      "degrader",
      0.035
    ],
    [
      "maquiller",
      0.035
    ],
    [
      "gater",
      0.03
    ],
    [
      "defigurer",
      0.03
    ],
    [
      "falsifier",
      0.025
    ],
    [
      "travestir",
      0.025
    ],
    [
      "tordre",
      0.02
    ],
    [
      "pervertir",
      0.02
    ],
    [
      "deteriorer",
      0.02
    ],
    [
      "depraver",
      0.02
    ],
    [
      "changer",
      0.02
    ],
    [
      "truquer",
      0.0175
    ],
    [
      "gauchir",
      0.0175
    ],
    [
      "forcer",
      0.0175
    ],
    [
      "farder",
      0.0175
    ],
    [
      "detraquer",
      0.0175
    ],
    [
      "courber",
      0.0125
    ],
    [
      "manquer",
      0.0125
    ],
    [
      "violer",
      0.0125
    ],
    [
      "transformer",
      0.0075
    ],
    [
      "trahir",
      0.0075
    ],
    [
      "perdre",
      0.0075
    ],
    [
      "fouler",
      0.0075
    ],
    [
      "disloquer",
      0.0075
    ],
    [
      "bosseler",
      0.0075
    ],
    [
      "adulterer",
      0.0075
    ],
    [
      "tourmenter",
      0.0025
    ],
    [
      "plier",
      0.0025
    ],
    [
      "enfreindre",
      0.0025
    ],
    [
      "demancher",
      0.0025
    ],
    [
      "dejeter",
      0.0025
    ],
    [
      "calomnier",
      0.0025
    ],
    [
      "bossuer",
      0.0025
    ],
    [
      "tronquer",
      0.0025
    ]
  ],
  "assise": [
    [
      "fonder",
      0.1225
    ],
    [
      "etablir",
      0.1225
    ],
    [
      "mettre",
      0.0725
    ],
    [
      "fixer",
      0.06
    ],
    [
      "poser",
      0.06
    ],
    [
      "batir",
      0.0475
    ],
    [
      "appuyer",
      0.0475
    ],
    [
      "affermir",
      0.0475
    ],
    [
      "assurer",
      0.035
    ],
    [
      "consacrer",
      0.035
    ],
    [
      "constituer",
      0.035
    ],
    [
      "placer",
      0.035
    ],
    [
      "ebahir",
      0.0225
    ],
    [
      "stupefier",
      0.0225
    ],
    [
      "consolider",
      0.0225
    ],
    [
      "camper",
      0.0225
    ],
    [
      "baser",
      0.0225
    ],
    [
      "situer",
      0.01
    ],
    [
      "reunir",
      0.01
    ],
    [
      "renverser",
      0.01
    ],
    [
      "rasseoir",
      0.01
    ],
    [
      "motiver",
      0.01
    ],
    [
      "inviter",
      0.01
    ],
    [
      "installer",
      0.01
    ],
    [
      "estomaquer",
      0.01
    ],
    [
      "decontenancer",
      0.01
    ],
    [
      "attabler",
      0.01
    ],
    [
      "epater",
      0.01
    ]
  ],
  "pole": [
    [
      "extremite",
      0.3
    ],
    [
      "sommet",
      0.2
    ],
    [
      "axe",
      0.1
    ],
    [
      "borne",
      0.1
    ],
    [
      "bout",
      0.1
    ],
    [
      "calotte",
      0.1
    ],
    [
      "oppose",
      0.1
    ]
  ],
  "hai": [
    [
      "abhorrer",
      0.1875
    ],
    [
      "detester",
      0.155
    ],
    [
      "abominer",
      0.125
    ],
    [
      "execrer",
      0.0925
    ],
    [
      "honnir",
      0.03
    ],
    [
      "maudire",
      0.03
    ],
    [
      "repugner",
      0.03
    ],
    [
      "sentir",
      0.03
    ],
    [
      "fuir",
      0.03
    ],
    [
      "envier",
      0.03
    ],
    [
      "souffrir",
      0.03
    ]
  ],
  "remplier": [],
  "egarer": [
    [
      "perdre",
      0.135
    ],
    [
      "derouter",
      0.11
    ],
    [
      "desorienter",
      0.085
    ],
    [
      "troubler",
      0.085
    ],
    [
      "seduire",
      0.06
    ],
    [
      "devoyer",
      0.06
    ],
    [
      "detourner",
      0.06
    ],
    [
      "aliener",
      0.035
    ],
    [
      "devier",
      0.035
    ],
    [
      "fourvoyer",
      0.035
    ],
    [
      "pervertir",
      0.035
    ],
    [
      "eloigner",
      0.0225
    ],
    [
      "ecarter",
      0.0225
    ],
    [
      "desaxer",
      0.0225
    ],
    [
      "depister",
      0.0225
    ],
    [
      "affoler",
      0.0225
    ],
    [
      "transporter",
      0.01
    ],
    [
      "revolutionner",
      0.01
    ],
    [
      "piper",
      0.01
    ],
    [
      "paumer",
      0.01
    ],
    [
      "fasciner",
      0.01
    ],
    [
      "berner",
      0.01
    ],
    [
      "aveugler",
      0.01
    ],
    [
      "adirer",
      0.01
    ],
    [
      "abuser",
      0.01
    ],
    [
      "tromper",
      0.01
    ]
  ],
  "retoucher": [
    [
      "corriger",
      0.23
    ],
    [
      "revoir",
      0.1875
    ],
    [
      "ameliorer",
      0.0825
    ],
    [
      "chatier",
      0.0825
    ],
    [
      "remanier",
      0.0825
    ],
    [
      "reviser",
      0.0825
    ],
    [
      "reprendre",
      0.0625
    ],
    [
      "arranger",
      0.04
    ],
    [
      "rectifier",
      0.04
    ],
    [
      "perfectionner",
      0.02
    ],
    [
      "recouper",
      0.02
    ],
    [
      "refondre",
      0.02
    ]
  ],
  "retouche": [
    [
      "amelioration",
      0.285
    ],
    [
      "correction",
      0.285
    ],
    [
      "perfectionnement",
      0.1425
    ],
    [
      "reprise",
      0.1425
    ],
    [
      "revision",
      0.1425
    ]
  ],
  "auquel": [],
  "jure": [
    [
      "affirmer",
      0.1075
    ],
    [
      "assurer",
      0.0975
    ],
    [
      "certifier",
      0.065
    ],
    [
      "dire",
      0.065
    ],
    [
      "trancher",
      0.065
    ],
    [
      "declarer",
      0.0525
    ],
    [
      "promettre",
      0.0525
    ],
    [
      "temoigner",
      0.0425
    ],
    [
      "soutenir",
      0.0425
    ],
    [
      "decider",
      0.0325
    ],
    [
      "garantir",
      0.0325
    ],
    [
      "pretendre",
      0.0325
    ],
    [
      "tempeter",
      0.02
    ],
    [
      "pester",
      0.02
    ],
    [
      "hurler",
      0.02
    ],
    [
      "detonner",
      0.02
    ],
    [
      "crier",
      0.02
    ],
    [
      "blasphemer",
      0.02
    ],
    [
      "attester",
      0.02
    ],
    [
      "nuire",
      0.01
    ],
    [
      "outrager",
      0.01
    ],
    [
      "resoudre",
      0.01
    ],
    [
      "s'engager",
      0.01
    ],
    [
      "engager",
      0.01
    ],
    [
      "detester",
      0.01
    ],
    [
      "decreter",
      0.01
    ],
    [
      "dissoner",
      0.01
    ],
    [
      "croire",
      0.01
    ],
    [
      "contraster",
      0.01
    ],
    [
      "sacrer",
      0.01
    ]
  ],
  "enerver": [
    [
      "agacer",
      0.11
    ],
    [
      "turlupiner",
      0.1
    ],
    [
      "irriter",
      0.09
    ],
    [
      "affaiblir",
      0.0725
    ],
    [
      "fatiguer",
      0.0725
    ],
    [
      "exasperer",
      0.0525
    ],
    [
      "exciter",
      0.045
    ],
    [
      "tourmenter",
      0.035
    ],
    [
      "exceder",
      0.035
    ],
    [
      "ennuyer",
      0.035
    ],
    [
      "amollir",
      0.025
    ],
    [
      "horripiler",
      0.025
    ],
    [
      "impatienter",
      0.025
    ],
    [
      "emousser",
      0.0175
    ],
    [
      "tracasser",
      0.0175
    ],
    [
      "obseder",
      0.0175
    ],
    [
      "indisposer",
      0.0175
    ],
    [
      "crisper",
      0.0175
    ],
    [
      "blaser",
      0.0175
    ],
    [
      "asticoter",
      0.0175
    ],
    [
      "alanguir",
      0.0175
    ],
    [
      "affadir",
      0.0175
    ],
    [
      "echauffer",
      0.0075
    ],
    [
      "surexciter",
      0.0075
    ],
    [
      "effeminer",
      0.0075
    ],
    [
      "deprimer",
      0.0075
    ],
    [
      "aveulir",
      0.0075
    ],
    [
      "emasculer",
      0.0075
    ]
  ],
  "orphelin": [
    [
      "abandonne",
      0.2
    ],
    [
      "frustre",
      0.2
    ],
    [
      "prive",
      0.2
    ],
    [
      "pupille",
      0.2
    ],
    [
      "seul",
      0.2
    ]
  ],
  "bain": [
    [
      "ablution",
      0.1275
    ],
    [
      "douche",
      0.1025
    ],
    [
      "piscine",
      0.05
    ],
    [
      "lotion",
      0.05
    ],
    [
      "lavage",
      0.05
    ],
    [
      "bassin",
      0.05
    ],
    [
      "baignoire",
      0.05
    ],
    [
      "affusion",
      0.05
    ],
    [
      "immersion",
      0.025
    ],
    [
      "remede",
      0.025
    ],
    [
      "riviere",
      0.025
    ],
    [
      "sauna",
      0.025
    ],
    [
      "thermes",
      0.025
    ],
    [
      "toilette",
      0.025
    ],
    [
      "trempette",
      0.025
    ],
    [
      "illutation",
      0.025
    ],
    [
      "hydrotherapie",
      0.025
    ],
    [
      "hammam",
      0.025
    ],
    [
      "eau",
      0.025
    ],
    [
      "conche",
      0.025
    ],
    [
      "caresse",
      0.025
    ],
    [
      "caldarium",
      0.025
    ],
    [
      "bapteme",
      0.025
    ],
    [
      "baignade",
      0.025
    ],
    [
      "arrosage",
      0.025
    ],
    [
      "tub",
      0.025
    ]
  ],
  "scolaire": [
    [
      "didactique",
      0.3325
    ],
    [
      "pedagogique",
      0.3325
    ],
    [
      "ecolier",
      0.3325
    ]
  ],
  "cake": [
    [
      "patisserie",
      0.5
    ]
  ],
  "coulis": [
    [
      "bisque",
      0.3325
    ],
    [
      "bouillie",
      0.3325
    ],
    [
      "puree",
      0.3325
    ]
  ],
  "repasser": [
    [
      "revoir",
      0.075
    ],
    [
      "repeter",
      0.065
    ],
    [
      "examiner",
      0.0425
    ],
    [
      "ressasser",
      0.0425
    ],
    [
      "reviser",
      0.0425
    ],
    [
      "etudier",
      0.0425
    ],
    [
      "evoquer",
      0.03
    ],
    [
      "verifier",
      0.03
    ],
    [
      "ruminer",
      0.03
    ],
    [
      "retourner",
      0.03
    ],
    [
      "remettre",
      0.03
    ],
    [
      "rapporter",
      0.03
    ],
    [
      "apprendre",
      0.03
    ],
    [
      "voler",
      0.02
    ],
    [
      "retroceder",
      0.02
    ],
    [
      "revivre",
      0.02
    ],
    [
      "retracer",
      0.02
    ],
    [
      "repenser",
      0.02
    ],
    [
      "rememorer",
      0.02
    ],
    [
      "remacher",
      0.02
    ],
    [
      "potasser",
      0.02
    ],
    [
      "aiguiser",
      0.02
    ],
    [
      "affiler",
      0.02
    ],
    [
      "relire",
      0.01
    ],
    [
      "retraverser",
      0.01
    ],
    [
      "revenir",
      0.01
    ],
    [
      "recoler",
      0.01
    ],
    [
      "tromper",
      0.01
    ],
    [
      "emorfiler",
      0.01
    ],
    [
      "refiler",
      0.01
    ],
    [
      "redonner",
      0.01
    ],
    [
      "rectifier",
      0.01
    ],
    [
      "affuter",
      0.01
    ],
    [
      "bucher",
      0.01
    ],
    [
      "contrepasser",
      0.01
    ],
    [
      "defriper",
      0.01
    ],
    [
      "defroisser",
      0.01
    ],
    [
      "deplisser",
      0.01
    ],
    [
      "flamber",
      0.01
    ],
    [
      "lisser",
      0.01
    ],
    [
      "emoudre",
      0.01
    ]
  ],
  "pli": [
    [
      "repli",
      0.195
    ],
    [
      "plissement",
      0.04
    ],
    [
      "recoin",
      0.03
    ],
    [
      "penchant",
      0.03
    ],
    [
      "message",
      0.03
    ],
    [
      "fronce",
      0.03
    ],
    [
      "thalweg",
      0.02
    ],
    [
      "sinuosite",
      0.02
    ],
    [
      "ride",
      0.02
    ],
    [
      "pince",
      0.02
    ],
    [
      "missive",
      0.02
    ],
    [
      "lettre",
      0.02
    ],
    [
      "habitude",
      0.02
    ],
    [
      "griffe",
      0.02
    ],
    [
      "depeche",
      0.02
    ],
    [
      "billet",
      0.02
    ],
    [
      "propension",
      0.01
    ],
    [
      "poche",
      0.01
    ],
    [
      "pliure",
      0.01
    ],
    [
      "ourlet",
      0.01
    ],
    [
      "oreille",
      0.01
    ],
    [
      "mot",
      0.01
    ],
    [
      "levee",
      0.01
    ],
    [
      "gout",
      0.01
    ],
    [
      "godron",
      0.01
    ],
    [
      "rabat",
      0.01
    ],
    [
      "releve",
      0.01
    ],
    [
      "rempli",
      0.01
    ],
    [
      "eminence",
      0.01
    ],
    [
      "telegramme",
      0.01
    ],
    [
      "troussis",
      0.01
    ],
    [
      "synclinal",
      0.01
    ],
    [
      "sinus",
      0.01
    ],
    [
      "sillon",
      0.01
    ],
    [
      "secret",
      0.01
    ],
    [
      "saignee",
      0.01
    ],
    [
      "retroussis",
      0.01
    ],
    [
      "godet",
      0.01
    ],
    [
      "godage",
      0.01
    ],
    [
      "corne",
      0.01
    ],
    [
      "compartiment",
      0.01
    ],
    [
      "commissure",
      0.01
    ],
    [
      "cachet",
      0.01
    ],
    [
      "bourrelet",
      0.01
    ],
    [
      "bouillon",
      0.01
    ],
    [
      "arete",
      0.01
    ],
    [
      "anticlinal",
      0.01
    ],
    [
      "accoutumance",
      0.01
    ],
    [
      "couture",
      0.01
    ],
    [
      "cuvette",
      0.01
    ],
    [
      "froncis",
      0.01
    ],
    [
      "froncement",
      0.01
    ],
    [
      "froissure",
      0.01
    ],
    [
      "feuillet",
      0.01
    ],
    [
      "fanon",
      0.01
    ],
    [
      "empreinte",
      0.01
    ],
    [
      "dome",
      0.01
    ],
    [
      "depression",
      0.01
    ],
    [
      "drape",
      0.01
    ],
    [
      "accident",
      0.01
    ]
  ],
  "voyant": [
    [
      "examiner",
      0.0425
    ],
    [
      "apercevoir",
      0.04
    ],
    [
      "comprendre",
      0.04
    ],
    [
      "decouvrir",
      0.04
    ],
    [
      "concevoir",
      0.0375
    ],
    [
      "saisir",
      0.035
    ],
    [
      "connaitre",
      0.035
    ],
    [
      "entendre",
      0.03
    ],
    [
      "regarder",
      0.03
    ],
    [
      "penser",
      0.03
    ],
    [
      "considerer",
      0.0275
    ],
    [
      "remarquer",
      0.0225
    ],
    [
      "juger",
      0.0225
    ],
    [
      "imaginer",
      0.0225
    ],
    [
      "percevoir",
      0.02
    ],
    [
      "observer",
      0.02
    ],
    [
      "penetrer",
      0.02
    ],
    [
      "trouver",
      0.0175
    ],
    [
      "verifier",
      0.0175
    ],
    [
      "discerner",
      0.015
    ],
    [
      "constater",
      0.015
    ],
    [
      "experimenter",
      0.015
    ],
    [
      "pratiquer",
      0.015
    ],
    [
      "eprouver",
      0.015
    ],
    [
      "etudier",
      0.0125
    ],
    [
      "reperer",
      0.0125
    ],
    [
      "controler",
      0.0125
    ],
    [
      "apprecier",
      0.0125
    ],
    [
      "estimer",
      0.01
    ],
    [
      "frequenter",
      0.01
    ],
    [
      "suivre",
      0.01
    ],
    [
      "s'apercevoir",
      0.0075
    ],
    [
      "percer",
      0.0075
    ],
    [
      "envisager",
      0.0075
    ],
    [
      "embrasser",
      0.0075
    ],
    [
      "distinguer",
      0.0075
    ],
    [
      "reflechir",
      0.005
    ],
    [
      "realiser",
      0.005
    ],
    [
      "peser",
      0.005
    ],
    [
      "noter",
      0.005
    ],
    [
      "entrevoir",
      0.005
    ],
    [
      "contempler",
      0.005
    ],
    [
      "aviser",
      0.005
    ],
    [
      "assister",
      0.005
    ],
    [
      "visiter",
      0.005
    ],
    [
      "viser",
      0.005
    ],
    [
      "veiller",
      0.005
    ],
    [
      "rencontrer",
      0.005
    ],
    [
      "inspecter",
      0.005
    ],
    [
      "frayer",
      0.005
    ],
    [
      "analyser",
      0.005
    ],
    [
      "subir",
      0.0025
    ],
    [
      "surprendre",
      0.0025
    ],
    [
      "zieuter",
      0.0025
    ],
    [
      "ecouter",
      0.0025
    ],
    [
      "savoir",
      0.0025
    ],
    [
      "admettre",
      0.0025
    ],
    [
      "lire",
      0.0025
    ],
    [
      "prevoir",
      0.0025
    ],
    [
      "recoler",
      0.0025
    ],
    [
      "s'assurer",
      0.0025
    ],
    [
      "s'enquerir",
      0.0025
    ],
    [
      "s'accointer",
      0.0025
    ],
    [
      "revoir",
      0.0025
    ],
    [
      "jauger",
      0.0025
    ],
    [
      "inventorier",
      0.0025
    ],
    [
      "donner",
      0.0025
    ],
    [
      "dominer",
      0.0025
    ],
    [
      "croiser",
      0.0025
    ],
    [
      "surplomber",
      0.0
    ],
    [
      "survenir",
      0.0
    ],
    [
      "visionner",
      0.0
    ],
    [
      "visualiser",
      0.0
    ],
    [
      "voisiner",
      0.0
    ],
    [
      "voyager",
      0.0
    ],
    [
      "s'informer",
      0.0
    ],
    [
      "s'imaginer",
      0.0
    ],
    [
      "planer",
      0.0
    ],
    [
      "mater",
      0.0
    ],
    [
      "loucher",
      0.0
    ],
    [
      "contacter",
      0.0
    ],
    [
      "commercer",
      0.0
    ]
  ],
  "brume": [
    [
      "brouillard",
      0.195
    ],
    [
      "nuage",
      0.1075
    ],
    [
      "vapeur",
      0.1075
    ],
    [
      "brumaille",
      0.085
    ],
    [
      "obscurite",
      0.085
    ],
    [
      "buee",
      0.065
    ],
    [
      "ombre",
      0.065
    ],
    [
      "nebulosite",
      0.0425
    ],
    [
      "melancolie",
      0.0425
    ],
    [
      "fumee",
      0.0425
    ],
    [
      "brumasse",
      0.02
    ],
    [
      "condensation",
      0.02
    ],
    [
      "frimas",
      0.02
    ],
    [
      "humidite",
      0.02
    ],
    [
      "incertitude",
      0.02
    ],
    [
      "temps",
      0.02
    ],
    [
      "tenebres",
      0.02
    ]
  ],
  "tain": [],
  "ecouteur": [
    [
      "auditeur",
      0.2
    ],
    [
      "bigorneau",
      0.2
    ],
    [
      "fureteur",
      0.2
    ],
    [
      "indiscret",
      0.2
    ],
    [
      "recepteur",
      0.2
    ]
  ],
  "emmele": [
    [
      "embrouiller",
      0.19
    ],
    [
      "brouiller",
      0.1425
    ],
    [
      "compliquer",
      0.1425
    ],
    [
      "enchevetrer",
      0.1425
    ],
    [
      "meler",
      0.095
    ],
    [
      "melanger",
      0.095
    ],
    [
      "emberlificoter",
      0.0475
    ],
    [
      "entremeler",
      0.0475
    ],
    [
      "obscurcir",
      0.0475
    ]
  ],
  "chiant": [
    [
      "defequer",
      0.2125
    ],
    [
      "faire",
      0.1425
    ],
    [
      "evacuer",
      0.1425
    ],
    [
      "debourrer",
      0.07
    ],
    [
      "crotter",
      0.07
    ],
    [
      "caquer",
      0.07
    ],
    [
      "bouser",
      0.07
    ],
    [
      "barder",
      0.07
    ],
    [
      "tartir",
      0.07
    ]
  ],
  "buee": [
    [
      "embuer",
      0.3325
    ],
    [
      "lessiver",
      0.3325
    ],
    [
      "s'embuer",
      0.3325
    ]
  ],
  "centrer": [
    [
      "diriger",
      0.25
    ],
    [
      "regler",
      0.1675
    ],
    [
      "aiguiller",
      0.0825
    ],
    [
      "ajuster",
      0.0825
    ],
    [
      "arrimer",
      0.0825
    ],
    [
      "axer",
      0.0825
    ],
    [
      "cadrer",
      0.0825
    ],
    [
      "determiner",
      0.0825
    ]
  ],
  "rouleau": [
    [
      "cylindre",
      0.2
    ],
    [
      "torsade",
      0.065
    ],
    [
      "role",
      0.065
    ],
    [
      "enrouleur",
      0.065
    ],
    [
      "croskill",
      0.065
    ],
    [
      "coiffure",
      0.065
    ],
    [
      "baton",
      0.065
    ],
    [
      "bobine",
      0.065
    ],
    [
      "bigoudi",
      0.065
    ],
    [
      "bande",
      0.065
    ],
    [
      "vague",
      0.065
    ]
  ],
  "flecher": [
    [
      "baliser",
      1.0
    ]
  ],
  "ebloui": [
    [
      "impressionner",
      0.1025
    ],
    [
      "fasciner",
      0.08
    ],
    [
      "epater",
      0.0675
    ],
    [
      "etonner",
      0.0675
    ],
    [
      "briller",
      0.055
    ],
    [
      "frapper",
      0.055
    ],
    [
      "imposer",
      0.055
    ],
    [
      "seduire",
      0.055
    ],
    [
      "troubler",
      0.045
    ],
    [
      "charmer",
      0.045
    ],
    [
      "abuser",
      0.0325
    ],
    [
      "bluffer",
      0.0325
    ],
    [
      "surprendre",
      0.0325
    ],
    [
      "tromper",
      0.0325
    ],
    [
      "emerveiller",
      0.02
    ],
    [
      "offusquer",
      0.02
    ],
    [
      "enchanter",
      0.02
    ],
    [
      "blesser",
      0.02
    ],
    [
      "aveugler",
      0.02
    ],
    [
      "ebahir",
      0.01
    ],
    [
      "resplendir",
      0.01
    ],
    [
      "reluire",
      0.01
    ],
    [
      "luire",
      0.01
    ],
    [
      "illusionner",
      0.01
    ],
    [
      "hypnotiser",
      0.01
    ],
    [
      "enorgueillir",
      0.01
    ],
    [
      "etourdir",
      0.01
    ]
  ],
  "eblouir": [
    [
      "impressionner",
      0.1025
    ],
    [
      "fasciner",
      0.08
    ],
    [
      "epater",
      0.0675
    ],
    [
      "etonner",
      0.0675
    ],
    [
      "briller",
      0.055
    ],
    [
      "frapper",
      0.055
    ],
    [
      "imposer",
      0.055
    ],
    [
      "seduire",
      0.055
    ],
    [
      "troubler",
      0.045
    ],
    [
      "charmer",
      0.045
    ],
    [
      "abuser",
      0.0325
    ],
    [
      "bluffer",
      0.0325
    ],
    [
      "surprendre",
      0.0325
    ],
    [
      "tromper",
      0.0325
    ],
    [
      "emerveiller",
      0.02
    ],
    [
      "offusquer",
      0.02
    ],
    [
      "enchanter",
      0.02
    ],
    [
      "blesser",
      0.02
    ],
    [
      "aveugler",
      0.02
    ],
    [
      "ebahir",
      0.01
    ],
    [
      "resplendir",
      0.01
    ],
    [
      "reluire",
      0.01
    ],
    [
      "luire",
      0.01
    ],
    [
      "illusionner",
      0.01
    ],
    [
      "hypnotiser",
      0.01
    ],
    [
      "enorgueillir",
      0.01
    ],
    [
      "etourdir",
      0.01
    ]
  ],
  "levee": [
    [
      "soulever",
      0.065
    ],
    [
      "supprimer",
      0.0575
    ],
    [
      "enlever",
      0.0525
    ],
    [
      "elever",
      0.0525
    ],
    [
      "hausser",
      0.0475
    ],
    [
      "oter",
      0.0425
    ],
    [
      "relever",
      0.0425
    ],
    [
      "monter",
      0.035
    ],
    [
      "couper",
      0.03
    ],
    [
      "faire",
      0.03
    ],
    [
      "dresser",
      0.025
    ],
    [
      "assembler",
      0.025
    ],
    [
      "tirer",
      0.02
    ],
    [
      "retrancher",
      0.02
    ],
    [
      "hisser",
      0.02
    ],
    [
      "augmenter",
      0.02
    ],
    [
      "amasser",
      0.02
    ],
    [
      "abolir",
      0.02
    ],
    [
      "trousser",
      0.015
    ],
    [
      "retirer",
      0.015
    ],
    [
      "redresser",
      0.015
    ],
    [
      "recueillir",
      0.015
    ],
    [
      "prelever",
      0.015
    ],
    [
      "pousser",
      0.015
    ],
    [
      "gonfler",
      0.015
    ],
    [
      "effacer",
      0.015
    ],
    [
      "aneantir",
      0.015
    ],
    [
      "ecarter",
      0.01
    ],
    [
      "terminer",
      0.01
    ],
    [
      "rehausser",
      0.01
    ],
    [
      "percevoir",
      0.01
    ],
    [
      "mobiliser",
      0.01
    ],
    [
      "haler",
      0.01
    ],
    [
      "aplanir",
      0.01
    ],
    [
      "accumuler",
      0.01
    ],
    [
      "fermenter",
      0.005
    ],
    [
      "guinder",
      0.005
    ],
    [
      "recruter",
      0.005
    ],
    [
      "retenir",
      0.005
    ],
    [
      "retrousser",
      0.005
    ],
    [
      "exhausser",
      0.005
    ],
    [
      "enroler",
      0.005
    ],
    [
      "decouper",
      0.005
    ],
    [
      "draguer",
      0.005
    ],
    [
      "dessiner",
      0.005
    ],
    [
      "braconner",
      0.005
    ],
    [
      "bouger",
      0.005
    ],
    [
      "armer",
      0.005
    ],
    [
      "ruiner",
      0.005
    ]
  ],
  "rejouir": [
    [
      "egayer",
      0.15
    ],
    [
      "amuser",
      0.12
    ],
    [
      "plaire",
      0.09
    ],
    [
      "regaler",
      0.06
    ],
    [
      "ravir",
      0.06
    ],
    [
      "enchanter",
      0.06
    ],
    [
      "derider",
      0.06
    ],
    [
      "delecter",
      0.06
    ],
    [
      "charmer",
      0.06
    ],
    [
      "epanouir",
      0.03
    ],
    [
      "ebaudir",
      0.03
    ],
    [
      "illuminer",
      0.03
    ],
    [
      "ensoleiller",
      0.03
    ],
    [
      "desopiler",
      0.03
    ],
    [
      "divertir",
      0.03
    ],
    [
      "contenter",
      0.03
    ]
  ],
  "rejoui": [
    [
      "joyeux",
      0.165
    ],
    [
      "rieur",
      0.14
    ],
    [
      "content",
      0.1175
    ],
    [
      "gai",
      0.105
    ],
    [
      "epanoui",
      0.08
    ],
    [
      "radieux",
      0.07
    ],
    [
      "heureux",
      0.0575
    ],
    [
      "ravi",
      0.0575
    ],
    [
      "riant",
      0.035
    ],
    [
      "hilare",
      0.035
    ],
    [
      "enjoue",
      0.0225
    ],
    [
      "jovial",
      0.0225
    ],
    [
      "satisfait",
      0.01
    ],
    [
      "guilleret",
      0.01
    ]
  ],
  "arrimer": [
    [
      "fixer",
      0.185
    ],
    [
      "attacher",
      0.1
    ],
    [
      "assurer",
      0.07
    ],
    [
      "immobiliser",
      0.0575
    ],
    [
      "assujettir",
      0.045
    ],
    [
      "river",
      0.0375
    ],
    [
      "arreter",
      0.0325
    ],
    [
      "maintenir",
      0.03
    ],
    [
      "retenir",
      0.03
    ],
    [
      "assembler",
      0.025
    ],
    [
      "mettre",
      0.0225
    ],
    [
      "ficher",
      0.0225
    ],
    [
      "consolider",
      0.0225
    ],
    [
      "caler",
      0.0225
    ],
    [
      "ancrer",
      0.0175
    ],
    [
      "coller",
      0.0175
    ],
    [
      "planter",
      0.0175
    ],
    [
      "visser",
      0.015
    ],
    [
      "coincer",
      0.015
    ],
    [
      "clouer",
      0.015
    ],
    [
      "boulonner",
      0.015
    ],
    [
      "amarrer",
      0.015
    ],
    [
      "accrocher",
      0.015
    ],
    [
      "soutenir",
      0.01
    ],
    [
      "introduire",
      0.01
    ],
    [
      "implanter",
      0.01
    ],
    [
      "affermir",
      0.01
    ],
    [
      "suspendre",
      0.0075
    ],
    [
      "sceller",
      0.0075
    ],
    [
      "preparer",
      0.0075
    ],
    [
      "nouer",
      0.0075
    ],
    [
      "enfoncer",
      0.0075
    ],
    [
      "enclaver",
      0.0075
    ],
    [
      "cramponner",
      0.0075
    ],
    [
      "arranger",
      0.0075
    ],
    [
      "accorer",
      0.0075
    ],
    [
      "pendre",
      0.0025
    ],
    [
      "enraciner",
      0.0025
    ],
    [
      "charger",
      0.0025
    ],
    [
      "centrer",
      0.0025
    ],
    [
      "riveter",
      0.0025
    ]
  ],
  "firmament": [
    [
      "ciel",
      0.4275
    ],
    [
      "azur",
      0.1425
    ],
    [
      "cieux",
      0.1425
    ],
    [
      "empyree",
      0.1425
    ],
    [
      "nue",
      0.1425
    ]
  ],
  "jersey": [
    [
      "bonneterie",
      0.5
    ],
    [
      "corsage",
      0.5
    ]
  ],
  "frimer": [
    [
      "craner",
      0.5
    ],
    [
      "fanfaronner",
      0.25
    ]
  ],
  "frime": [
    [
      "feinte",
      0.1475
    ],
    [
      "comedie",
      0.11
    ],
    [
      "grimace",
      0.11
    ],
    [
      "mensonge",
      0.11
    ],
    [
      "simulation",
      0.11
    ],
    [
      "blague",
      0.0725
    ],
    [
      "singeries",
      0.035
    ],
    [
      "simulacre",
      0.035
    ],
    [
      "simagrees",
      0.035
    ],
    [
      "fumisterie",
      0.035
    ],
    [
      "frimousse",
      0.035
    ],
    [
      "frimant",
      0.035
    ],
    [
      "esbroufe",
      0.035
    ],
    [
      "degaine",
      0.035
    ],
    [
      "epate",
      0.035
    ]
  ],
  "tremail": [],
  "juillet": [
    [
      "messidor",
      0.5
    ],
    [
      "thermidor",
      0.5
    ]
  ],
  "goemon": [
    [
      "algue",
      0.3325
    ],
    [
      "fucus",
      0.3325
    ],
    [
      "varech",
      0.3325
    ]
  ],
  "necropole": [
    [
      "cimetiere",
      0.3825
    ],
    [
      "ossuaire",
      0.1525
    ],
    [
      "catacombe",
      0.075
    ],
    [
      "charnier",
      0.075
    ],
    [
      "columbarium",
      0.075
    ],
    [
      "crypte",
      0.075
    ],
    [
      "sepulture",
      0.075
    ]
  ],
  "flanelle": [
    [
      "blazer",
      1.0
    ]
  ],
  "sprint": [
    [
      "emballage",
      0.2
    ],
    [
      "enlevage",
      0.2
    ],
    [
      "finish",
      0.2
    ],
    [
      "pointe",
      0.2
    ],
    [
      "rush",
      0.2
    ]
  ],
  "gagne": [
    [
      "prendre",
      0.0625
    ],
    [
      "conquerir",
      0.055
    ],
    [
      "attraper",
      0.0375
    ],
    [
      "toucher",
      0.0375
    ],
    [
      "seduire",
      0.0275
    ],
    [
      "obtenir",
      0.0275
    ],
    [
      "ramasser",
      0.025
    ],
    [
      "aller",
      0.02
    ],
    [
      "enlever",
      0.02
    ],
    [
      "remporter",
      0.0175
    ],
    [
      "recevoir",
      0.0175
    ],
    [
      "captiver",
      0.0175
    ],
    [
      "capter",
      0.0175
    ],
    [
      "atteindre",
      0.0175
    ],
    [
      "recolter",
      0.0175
    ],
    [
      "s'emparer",
      0.015
    ],
    [
      "recueillir",
      0.015
    ],
    [
      "piquer",
      0.015
    ],
    [
      "forcer",
      0.015
    ],
    [
      "encaisser",
      0.015
    ],
    [
      "attirer",
      0.015
    ],
    [
      "acquerir",
      0.0125
    ],
    [
      "tirer",
      0.0125
    ],
    [
      "vaincre",
      0.0125
    ],
    [
      "emporter",
      0.0125
    ],
    [
      "arriver",
      0.01
    ],
    [
      "faire",
      0.01
    ],
    [
      "reussir",
      0.01
    ],
    [
      "retirer",
      0.01
    ],
    [
      "profiter",
      0.01
    ],
    [
      "amadouer",
      0.01
    ],
    [
      "charmer",
      0.0075
    ],
    [
      "envahir",
      0.0075
    ],
    [
      "percevoir",
      0.0075
    ],
    [
      "plaire",
      0.0075
    ],
    [
      "triompher",
      0.0075
    ],
    [
      "penetrer",
      0.0075
    ],
    [
      "marcher",
      0.0075
    ],
    [
      "empocher",
      0.0075
    ],
    [
      "avancer",
      0.0075
    ],
    [
      "amener",
      0.0075
    ],
    [
      "s'etendre",
      0.005
    ],
    [
      "rallier",
      0.005
    ],
    [
      "progresser",
      0.005
    ],
    [
      "persuader",
      0.005
    ],
    [
      "parvenir",
      0.005
    ],
    [
      "joindre",
      0.005
    ],
    [
      "gratter",
      0.005
    ],
    [
      "augmenter",
      0.005
    ],
    [
      "circonvenir",
      0.005
    ],
    [
      "convaincre",
      0.005
    ],
    [
      "convertir",
      0.005
    ],
    [
      "croitre",
      0.005
    ],
    [
      "subjuguer",
      0.0025
    ],
    [
      "s'attacher",
      0.0025
    ],
    [
      "rapporter",
      0.0025
    ],
    [
      "interesser",
      0.0025
    ],
    [
      "grandir",
      0.0025
    ],
    [
      "fleurir",
      0.0025
    ],
    [
      "distancer",
      0.0025
    ],
    [
      "aborder",
      0.0025
    ],
    [
      "s'attirer",
      0.0025
    ],
    [
      "s'enrichir",
      0.0025
    ],
    [
      "tenter",
      0.0025
    ],
    [
      "retrouver",
      0.0025
    ],
    [
      "rejoindre",
      0.0025
    ],
    [
      "flechir",
      0.0025
    ],
    [
      "acceder",
      0.0025
    ],
    [
      "apprivoiser",
      0.0025
    ],
    [
      "chiper",
      0.0025
    ],
    [
      "contracter",
      0.0025
    ],
    [
      "decrocher",
      0.0025
    ],
    [
      "empieter",
      0.0025
    ],
    [
      "primer",
      0.0
    ],
    [
      "rafler",
      0.0
    ],
    [
      "s'ameliorer",
      0.0
    ],
    [
      "s'assurer",
      0.0
    ],
    [
      "surclasser",
      0.0
    ],
    [
      "l'emporter",
      0.0
    ],
    [
      "grappiller",
      0.0
    ],
    [
      "envouter",
      0.0
    ],
    [
      "allecher",
      0.0
    ],
    [
      "assujettir",
      0.0
    ],
    [
      "battre",
      0.0
    ],
    [
      "beneficier",
      0.0
    ],
    [
      "corrompre",
      0.0
    ],
    [
      "endoctriner",
      0.0
    ],
    [
      "s'apprecier",
      0.0
    ],
    [
      "s'assujettir",
      0.0
    ],
    [
      "suborner",
      0.0
    ],
    [
      "palper",
      0.0
    ],
    [
      "meriter",
      0.0
    ],
    [
      "moissonner",
      0.0
    ],
    [
      "envelopper",
      0.0
    ],
    [
      "communiquer",
      0.0
    ],
    [
      "appater",
      0.0
    ],
    [
      "amorcer",
      0.0
    ],
    [
      "affurer",
      0.0
    ],
    [
      "economiser",
      0.0
    ]
  ],
  "bave": [
    [
      "glaire",
      0.2
    ],
    [
      "mucus",
      0.2
    ],
    [
      "salive",
      0.2
    ],
    [
      "venin",
      0.2
    ],
    [
      "ecume",
      0.2
    ]
  ],
  "baver": [
    [
      "diffamer",
      0.105
    ],
    [
      "discrediter",
      0.105
    ],
    [
      "denigrer",
      0.105
    ],
    [
      "medire",
      0.0875
    ],
    [
      "calomnier",
      0.07
    ],
    [
      "salir",
      0.07
    ],
    [
      "vilipender",
      0.0525
    ],
    [
      "deblaterer",
      0.0525
    ],
    [
      "bavasser",
      0.0525
    ],
    [
      "bavarder",
      0.035
    ],
    [
      "souiller",
      0.035
    ],
    [
      "saliver",
      0.0175
    ],
    [
      "postillonner",
      0.0175
    ],
    [
      "nuire",
      0.0175
    ],
    [
      "mouiller",
      0.0175
    ],
    [
      "juter",
      0.0175
    ],
    [
      "jaboter",
      0.0175
    ],
    [
      "deteindre",
      0.0175
    ],
    [
      "degouliner",
      0.0175
    ],
    [
      "couler",
      0.0175
    ],
    [
      "becher",
      0.0175
    ],
    [
      "bavoter",
      0.0175
    ],
    [
      "bavocher",
      0.0175
    ],
    [
      "ecumer",
      0.0175
    ]
  ],
  "roc": [
    [
      "pierre",
      0.3325
    ],
    [
      "roche",
      0.3325
    ],
    [
      "caillou",
      0.165
    ],
    [
      "rocher",
      0.165
    ]
  ],
  "conquerir": [
    [
      "gagner",
      0.13
    ],
    [
      "seduire",
      0.0675
    ],
    [
      "prendre",
      0.06
    ],
    [
      "captiver",
      0.0575
    ],
    [
      "attirer",
      0.04
    ],
    [
      "charmer",
      0.04
    ],
    [
      "forcer",
      0.04
    ],
    [
      "obtenir",
      0.04
    ],
    [
      "remporter",
      0.035
    ],
    [
      "emporter",
      0.035
    ],
    [
      "capter",
      0.035
    ],
    [
      "attraper",
      0.0325
    ],
    [
      "enlever",
      0.0275
    ],
    [
      "vaincre",
      0.025
    ],
    [
      "subjuguer",
      0.025
    ],
    [
      "s'emparer",
      0.025
    ],
    [
      "avoir",
      0.025
    ],
    [
      "acquerir",
      0.025
    ],
    [
      "assujettir",
      0.02
    ],
    [
      "entrainer",
      0.02
    ],
    [
      "enjoler",
      0.015
    ],
    [
      "amener",
      0.015
    ],
    [
      "dominer",
      0.0125
    ],
    [
      "triompher",
      0.0075
    ],
    [
      "soumettre",
      0.0075
    ],
    [
      "fixer",
      0.0075
    ],
    [
      "envouter",
      0.0075
    ],
    [
      "envahir",
      0.0075
    ],
    [
      "apprivoiser",
      0.0075
    ],
    [
      "rallier",
      0.005
    ],
    [
      "plaire",
      0.005
    ],
    [
      "entortiller",
      0.005
    ],
    [
      "ensorceler",
      0.005
    ],
    [
      "enchanter",
      0.005
    ],
    [
      "convertir",
      0.005
    ],
    [
      "s'attacher",
      0.0025
    ],
    [
      "s'assujettir",
      0.0025
    ],
    [
      "rapporter",
      0.0025
    ],
    [
      "empaumer",
      0.0025
    ],
    [
      "coloniser",
      0.0025
    ],
    [
      "tomber",
      0.0025
    ]
  ],
  "conquis": [
    [
      "apprivoise",
      0.5
    ],
    [
      "soumis",
      0.5
    ]
  ],
  "paleur": [
    [
      "douceur",
      0.1825
    ],
    [
      "fadeur",
      0.1825
    ],
    [
      "anemie",
      0.09
    ],
    [
      "blancheur",
      0.09
    ],
    [
      "insipidite",
      0.09
    ],
    [
      "lividite",
      0.09
    ],
    [
      "lueur",
      0.09
    ],
    [
      "moderation",
      0.09
    ],
    [
      "tiedeur",
      0.09
    ]
  ],
  "rescousse": [
    [
      "soutien",
      0.1725
    ],
    [
      "appui",
      0.1525
    ],
    [
      "aide",
      0.1325
    ],
    [
      "secours",
      0.115
    ],
    [
      "concours",
      0.095
    ],
    [
      "service",
      0.075
    ],
    [
      "assistance",
      0.0575
    ],
    [
      "soulagement",
      0.0375
    ],
    [
      "support",
      0.0175
    ],
    [
      "intervention",
      0.0175
    ],
    [
      "defense",
      0.0175
    ],
    [
      "collaboration",
      0.0175
    ],
    [
      "appoint",
      0.0175
    ],
    [
      "egide",
      0.0175
    ]
  ],
  "squale": [
    [
      "requin",
      1.0
    ]
  ],
  "fjord": [
    [
      "defile",
      0.3325
    ],
    [
      "golfe",
      0.3325
    ],
    [
      "loch",
      0.3325
    ]
  ],
  "cor": [
    [
      "corne",
      0.1525
    ],
    [
      "callosite",
      0.065
    ],
    [
      "durillon",
      0.065
    ],
    [
      "endurcissement",
      0.065
    ],
    [
      "oignon",
      0.065
    ],
    [
      "ramure",
      0.065
    ],
    [
      "induration",
      0.0425
    ],
    [
      "cornet",
      0.0425
    ],
    [
      "cal",
      0.0425
    ],
    [
      "branche",
      0.0425
    ],
    [
      "bois",
      0.0425
    ],
    [
      "andouiller",
      0.0425
    ],
    [
      "tylose",
      0.02
    ],
    [
      "trompe",
      0.02
    ],
    [
      "rameau",
      0.02
    ],
    [
      "perche",
      0.02
    ],
    [
      "olifant",
      0.02
    ],
    [
      "cuivre",
      0.02
    ],
    [
      "corniste",
      0.02
    ],
    [
      "bouquin",
      0.02
    ],
    [
      "agacin",
      0.02
    ],
    [
      "epoi",
      0.02
    ]
  ],
  "camarade": [
    [
      "compagnon",
      0.155
    ],
    [
      "ami",
      0.115
    ],
    [
      "acolyte",
      0.09
    ],
    [
      "copain",
      0.075
    ],
    [
      "associe",
      0.0625
    ],
    [
      "partenaire",
      0.0625
    ],
    [
      "compere",
      0.05
    ],
    [
      "collegue",
      0.0375
    ],
    [
      "confrere",
      0.0375
    ],
    [
      "frere",
      0.0375
    ],
    [
      "egal",
      0.025
    ],
    [
      "pote",
      0.025
    ],
    [
      "cousin",
      0.025
    ],
    [
      "condisciple",
      0.025
    ],
    [
      "allie",
      0.025
    ],
    [
      "poteau",
      0.01
    ],
    [
      "labadens",
      0.01
    ],
    [
      "connaissance",
      0.01
    ],
    [
      "compagne",
      0.01
    ],
    [
      "camaro",
      0.01
    ],
    [
      "camarluche",
      0.01
    ],
    [
      "aminche",
      0.01
    ],
    [
      "affilie",
      0.01
    ],
    [
      "adherent",
      0.01
    ],
    [
      "zig",
      0.01
    ]
  ],
  "salant": [
    [
      "assaisonner",
      0.2
    ],
    [
      "depouiller",
      0.2
    ],
    [
      "punir",
      0.2
    ],
    [
      "sabrer",
      0.2
    ],
    [
      "saupoudrer",
      0.2
    ]
  ],
  "poivrer": [
    [
      "assaisonner",
      0.25
    ],
    [
      "fusiller",
      0.25
    ],
    [
      "plomber",
      0.25
    ],
    [
      "veroler",
      0.25
    ]
  ],
  "poivre": [
    [
      "assaisonner",
      0.25
    ],
    [
      "fusiller",
      0.25
    ],
    [
      "plomber",
      0.25
    ],
    [
      "veroler",
      0.25
    ]
  ],
  "gercure": [
    [
      "fente",
      0.25
    ],
    [
      "crevasse",
      0.165
    ],
    [
      "craquelure",
      0.0825
    ],
    [
      "fissure",
      0.0825
    ],
    [
      "lezarde",
      0.0825
    ],
    [
      "rhagade",
      0.04
    ],
    [
      "gelivure",
      0.04
    ],
    [
      "gelure",
      0.04
    ],
    [
      "felure",
      0.04
    ],
    [
      "fendillement",
      0.04
    ],
    [
      "excoriation",
      0.04
    ],
    [
      "entaille",
      0.04
    ],
    [
      "ride",
      0.04
    ]
  ],
  "desordre": [
    [
      "confusion",
      0.065
    ],
    [
      "trouble",
      0.055
    ],
    [
      "chaos",
      0.0375
    ],
    [
      "agitation",
      0.035
    ],
    [
      "perturbation",
      0.03
    ],
    [
      "bouleversement",
      0.0275
    ],
    [
      "chahut",
      0.025
    ],
    [
      "derangement",
      0.025
    ],
    [
      "bordel",
      0.02
    ],
    [
      "chambardement",
      0.02
    ],
    [
      "fatras",
      0.02
    ],
    [
      "tapage",
      0.02
    ],
    [
      "bazar",
      0.0175
    ],
    [
      "fouillis",
      0.0175
    ],
    [
      "melange",
      0.015
    ],
    [
      "tumulte",
      0.015
    ],
    [
      "vacarme",
      0.015
    ],
    [
      "debauche",
      0.0125
    ],
    [
      "enchevetrement",
      0.0125
    ],
    [
      "tintamarre",
      0.0125
    ],
    [
      "desorganisation",
      0.01
    ],
    [
      "dereglement",
      0.01
    ],
    [
      "bastringue",
      0.01
    ],
    [
      "revolution",
      0.0075
    ],
    [
      "renversement",
      0.0075
    ],
    [
      "pagaille",
      0.0075
    ],
    [
      "imbroglio",
      0.0075
    ],
    [
      "gachis",
      0.0075
    ],
    [
      "effervescence",
      0.0075
    ],
    [
      "desarroi",
      0.0075
    ],
    [
      "affolement",
      0.0075
    ],
    [
      "emeute",
      0.0075
    ],
    [
      "egarement",
      0.0075
    ],
    [
      "revolte",
      0.0075
    ],
    [
      "mouvement",
      0.0075
    ],
    [
      "grabuge",
      0.0075
    ],
    [
      "capharnaum",
      0.0075
    ],
    [
      "deroute",
      0.005
    ],
    [
      "foutoir",
      0.005
    ],
    [
      "galimatias",
      0.005
    ],
    [
      "incoherence",
      0.005
    ],
    [
      "querelle",
      0.005
    ],
    [
      "soulevement",
      0.005
    ],
    [
      "debandade",
      0.005
    ],
    [
      "dissolution",
      0.005
    ],
    [
      "chambard",
      0.005
    ],
    [
      "alteration",
      0.005
    ],
    [
      "anarchie",
      0.005
    ],
    [
      "boucan",
      0.005
    ],
    [
      "bousculade",
      0.005
    ],
    [
      "brouillamini",
      0.005
    ],
    [
      "merdier",
      0.0025
    ],
    [
      "panique",
      0.0025
    ],
    [
      "pastis",
      0.0025
    ],
    [
      "remous",
      0.0025
    ],
    [
      "scandale",
      0.0025
    ],
    [
      "turpitude",
      0.0025
    ],
    [
      "eparpillement",
      0.0025
    ],
    [
      "licence",
      0.0025
    ],
    [
      "barnum",
      0.0025
    ],
    [
      "cacophonie",
      0.0025
    ],
    [
      "dissipation",
      0.0025
    ],
    [
      "divagation",
      0.0025
    ],
    [
      "desintegration",
      0.0025
    ],
    [
      "embrouillement",
      0.0025
    ],
    [
      "encombrement",
      0.0025
    ],
    [
      "fievre",
      0.0025
    ],
    [
      "fourbi",
      0.0025
    ],
    [
      "inconduite",
      0.0025
    ],
    [
      "indiscipline",
      0.0025
    ],
    [
      "inversion",
      0.0025
    ],
    [
      "irregularite",
      0.0025
    ],
    [
      "ruee",
      0.0025
    ],
    [
      "tortillage",
      0.0025
    ],
    [
      "enfer",
      0.0025
    ],
    [
      "detraquement",
      0.0025
    ],
    [
      "desagregation",
      0.0025
    ],
    [
      "bacchanale",
      0.0025
    ],
    [
      "bagarre",
      0.0025
    ],
    [
      "cataclysme",
      0.0025
    ],
    [
      "chabanais",
      0.0025
    ],
    [
      "cohue",
      0.0025
    ],
    [
      "discussion",
      0.0025
    ],
    [
      "dissension",
      0.0025
    ],
    [
      "degat",
      0.0025
    ],
    [
      "embrasement",
      0.0
    ],
    [
      "entropie",
      0.0
    ],
    [
      "flottement",
      0.0
    ],
    [
      "gabegie",
      0.0
    ],
    [
      "inordination",
      0.0
    ],
    [
      "lesion",
      0.0
    ],
    [
      "medrano",
      0.0
    ],
    [
      "pandemonium",
      0.0
    ],
    [
      "petaudiere",
      0.0
    ],
    [
      "salade",
      0.0
    ],
    [
      "deraillement",
      0.0
    ],
    [
      "decousu",
      0.0
    ],
    [
      "debraille",
      0.0
    ],
    [
      "abandon",
      0.0
    ],
    [
      "abus",
      0.0
    ],
    [
      "binz",
      0.0
    ],
    [
      "brouillement",
      0.0
    ],
    [
      "chamboulement",
      0.0
    ],
    [
      "chantier",
      0.0
    ],
    [
      "chenil",
      0.0
    ],
    [
      "chienlit",
      0.0
    ],
    [
      "chierie",
      0.0
    ],
    [
      "commotion",
      0.0
    ],
    [
      "souk",
      0.0
    ]
  ],
  "vitrail": [
    [
      "panneau",
      0.25
    ],
    [
      "rosace",
      0.25
    ],
    [
      "rose",
      0.25
    ],
    [
      "verriere",
      0.25
    ]
  ],
  "coquillage": [
    [
      "bigorneau",
      0.0475
    ],
    [
      "jambonneau",
      0.0475
    ],
    [
      "moule",
      0.0475
    ],
    [
      "palourde",
      0.0475
    ],
    [
      "pinne",
      0.0475
    ],
    [
      "porcelaine",
      0.0475
    ],
    [
      "praire",
      0.0475
    ],
    [
      "solen",
      0.0475
    ],
    [
      "triton",
      0.0475
    ],
    [
      "huitre",
      0.0475
    ],
    [
      "habitacle",
      0.0475
    ],
    [
      "buccin",
      0.0475
    ],
    [
      "clam",
      0.0475
    ],
    [
      "clovisse",
      0.0475
    ],
    [
      "coque",
      0.0475
    ],
    [
      "coquille",
      0.0475
    ],
    [
      "couteau",
      0.0475
    ],
    [
      "cypree",
      0.0475
    ],
    [
      "cone",
      0.0475
    ],
    [
      "trompette",
      0.0475
    ]
  ],
  "figurant": [
    [
      "utilite",
      0.1525
    ],
    [
      "representant",
      0.075
    ],
    [
      "girl",
      0.075
    ],
    [
      "figuratif",
      0.075
    ],
    [
      "doublure",
      0.075
    ],
    [
      "comparse",
      0.075
    ],
    [
      "choriste",
      0.075
    ],
    [
      "bobineur",
      0.075
    ],
    [
      "acteur",
      0.075
    ]
  ],
  "sunlight": [
    [
      "projecteur",
      1.0
    ]
  ],
  "liquide": [
    [
      "coulant",
      0.105
    ],
    [
      "fluide",
      0.105
    ],
    [
      "liqueur",
      0.105
    ],
    [
      "lymphe",
      0.105
    ],
    [
      "liquefie",
      0.0525
    ],
    [
      "liquidite",
      0.0525
    ],
    [
      "inconsistant",
      0.0525
    ],
    [
      "humide",
      0.0525
    ],
    [
      "humeur",
      0.0525
    ],
    [
      "especes",
      0.0525
    ],
    [
      "cristallin",
      0.0525
    ],
    [
      "boisson",
      0.0525
    ],
    [
      "baveux",
      0.0525
    ],
    [
      "aquosite",
      0.0525
    ],
    [
      "transparent",
      0.0525
    ]
  ],
  "liquider": [
    [
      "aneantir",
      0.0725
    ],
    [
      "detruire",
      0.0575
    ],
    [
      "supprimer",
      0.0575
    ],
    [
      "vider",
      0.0575
    ],
    [
      "tuer",
      0.045
    ],
    [
      "vendre",
      0.0375
    ],
    [
      "solder",
      0.0375
    ],
    [
      "balayer",
      0.0375
    ],
    [
      "epuiser",
      0.0325
    ],
    [
      "renvoyer",
      0.0325
    ],
    [
      "congedier",
      0.0325
    ],
    [
      "bazarder",
      0.0325
    ],
    [
      "nettoyer",
      0.025
    ],
    [
      "abolir",
      0.025
    ],
    [
      "abattre",
      0.025
    ],
    [
      "abandonner",
      0.025
    ],
    [
      "eteindre",
      0.0175
    ],
    [
      "ecouler",
      0.0175
    ],
    [
      "torcher",
      0.0175
    ],
    [
      "remercier",
      0.0175
    ],
    [
      "demolir",
      0.0175
    ],
    [
      "absorber",
      0.0175
    ],
    [
      "terminer",
      0.01
    ],
    [
      "regler",
      0.01
    ],
    [
      "limoger",
      0.01
    ],
    [
      "jeter",
      0.01
    ],
    [
      "exterminer",
      0.01
    ],
    [
      "brader",
      0.01
    ],
    [
      "annuler",
      0.01
    ],
    [
      "acquitter",
      0.01
    ],
    [
      "zigouiller",
      0.005
    ],
    [
      "trousser",
      0.005
    ],
    [
      "realiser",
      0.005
    ],
    [
      "plaquer",
      0.005
    ],
    [
      "placer",
      0.005
    ],
    [
      "payer",
      0.005
    ],
    [
      "licencier",
      0.005
    ],
    [
      "debarquer",
      0.005
    ],
    [
      "bacler",
      0.005
    ],
    [
      "brocanter",
      0.005
    ],
    [
      "evacuer",
      0.005
    ]
  ],
  "castagnette": [],
  "livide": [
    [
      "plombe",
      0.1375
    ],
    [
      "terreux",
      0.1375
    ],
    [
      "blafard",
      0.105
    ],
    [
      "bleme",
      0.09
    ],
    [
      "pale",
      0.075
    ],
    [
      "verdatre",
      0.045
    ],
    [
      "cadaverique",
      0.045
    ],
    [
      "vitreux",
      0.03
    ],
    [
      "poussiereux",
      0.03
    ],
    [
      "olivatre",
      0.03
    ],
    [
      "gris",
      0.03
    ],
    [
      "exsangue",
      0.03
    ],
    [
      "cireux",
      0.03
    ],
    [
      "bleuatre",
      0.03
    ],
    [
      "bleu",
      0.03
    ],
    [
      "have",
      0.0125
    ],
    [
      "glauque",
      0.0125
    ],
    [
      "cyanose",
      0.0125
    ],
    [
      "cadavereux",
      0.0125
    ],
    [
      "blemissant",
      0.0125
    ],
    [
      "blanchatre",
      0.0125
    ],
    [
      "blanc",
      0.0125
    ],
    [
      "jaunatre",
      0.0125
    ]
  ],
  "vocation": [
    [
      "penchant",
      0.12
    ],
    [
      "disposition",
      0.1
    ],
    [
      "talent",
      0.1
    ],
    [
      "inclination",
      0.08
    ],
    [
      "mission",
      0.08
    ],
    [
      "genie",
      0.06
    ],
    [
      "gout",
      0.06
    ],
    [
      "capacite",
      0.06
    ],
    [
      "aptitude",
      0.06
    ],
    [
      "but",
      0.04
    ],
    [
      "role",
      0.02
    ],
    [
      "predestination",
      0.02
    ],
    [
      "pente",
      0.02
    ],
    [
      "passion",
      0.02
    ],
    [
      "objectif",
      0.02
    ],
    [
      "faculte",
      0.02
    ],
    [
      "destinee",
      0.02
    ],
    [
      "destination",
      0.02
    ],
    [
      "appel",
      0.02
    ],
    [
      "affection",
      0.02
    ],
    [
      "sacerdoce",
      0.02
    ]
  ],
  "parure": [
    [
      "ajustement",
      0.1225
    ],
    [
      "ornement",
      0.1225
    ],
    [
      "atours",
      0.0725
    ],
    [
      "mise",
      0.0725
    ],
    [
      "vetements",
      0.0475
    ],
    [
      "toilette",
      0.0475
    ],
    [
      "ornementation",
      0.0475
    ],
    [
      "garniture",
      0.0475
    ],
    [
      "falbala",
      0.0475
    ],
    [
      "decoration",
      0.0475
    ],
    [
      "affiquet",
      0.0475
    ],
    [
      "rognure",
      0.0225
    ],
    [
      "rayonnement",
      0.0225
    ],
    [
      "parement",
      0.0225
    ],
    [
      "joyau",
      0.0225
    ],
    [
      "habit",
      0.0225
    ],
    [
      "glorification",
      0.0225
    ],
    [
      "frivolite",
      0.0225
    ],
    [
      "embellissement",
      0.0225
    ],
    [
      "culotte",
      0.0225
    ],
    [
      "chemise",
      0.0225
    ],
    [
      "eclat",
      0.0225
    ]
  ],
  "pressentir": [
    [
      "deviner",
      0.1175
    ],
    [
      "prevoir",
      0.1075
    ],
    [
      "flairer",
      0.0625
    ],
    [
      "soupconner",
      0.0525
    ],
    [
      "sentir",
      0.045
    ],
    [
      "penetrer",
      0.045
    ],
    [
      "presumer",
      0.045
    ],
    [
      "presager",
      0.045
    ],
    [
      "entrevoir",
      0.045
    ],
    [
      "conjecturer",
      0.035
    ],
    [
      "percevoir",
      0.035
    ],
    [
      "subodorer",
      0.035
    ],
    [
      "s'attendre",
      0.025
    ],
    [
      "reperer",
      0.025
    ],
    [
      "percer",
      0.025
    ],
    [
      "esperer",
      0.025
    ],
    [
      "craindre",
      0.025
    ],
    [
      "augurer",
      0.025
    ],
    [
      "attendre",
      0.025
    ],
    [
      "sonder",
      0.0175
    ],
    [
      "dire",
      0.0175
    ],
    [
      "apprehender",
      0.0175
    ],
    [
      "annoncer",
      0.0175
    ],
    [
      "douter",
      0.0075
    ],
    [
      "interroger",
      0.0075
    ],
    [
      "renifler",
      0.0075
    ],
    [
      "tater",
      0.0075
    ]
  ],
  "globule": [
    [
      "grain",
      0.22
    ],
    [
      "pilule",
      0.22
    ],
    [
      "boulette",
      0.11
    ],
    [
      "bulle",
      0.11
    ],
    [
      "cellule",
      0.11
    ],
    [
      "globe",
      0.11
    ],
    [
      "goutte",
      0.11
    ]
  ],
  "mathematique": [
    [
      "exact",
      0.11
    ],
    [
      "calcul",
      0.0825
    ],
    [
      "logique",
      0.0825
    ],
    [
      "precis",
      0.0825
    ],
    [
      "rigoureux",
      0.0825
    ],
    [
      "vrai",
      0.055
    ],
    [
      "solide",
      0.055
    ],
    [
      "certain",
      0.055
    ],
    [
      "analyse",
      0.055
    ],
    [
      "statistique",
      0.0275
    ],
    [
      "probabilite",
      0.0275
    ],
    [
      "mecanique",
      0.0275
    ],
    [
      "geometrique",
      0.0275
    ],
    [
      "geometrie",
      0.0275
    ],
    [
      "deductif",
      0.0275
    ],
    [
      "automatique",
      0.0275
    ],
    [
      "arithmetique",
      0.0275
    ],
    [
      "algebrique",
      0.0275
    ],
    [
      "algebre",
      0.0275
    ],
    [
      "algorithmique",
      0.0275
    ],
    [
      "topologie",
      0.0275
    ]
  ],
  "etaler": [
    [
      "montrer",
      0.0825
    ],
    [
      "reveler",
      0.0825
    ],
    [
      "afficher",
      0.0725
    ],
    [
      "exposer",
      0.06
    ],
    [
      "etendre",
      0.0475
    ],
    [
      "developper",
      0.0375
    ],
    [
      "deployer",
      0.0375
    ],
    [
      "exhiber",
      0.035
    ],
    [
      "decouvrir",
      0.03
    ],
    [
      "repandre",
      0.03
    ],
    [
      "paraitre",
      0.025
    ],
    [
      "enduire",
      0.025
    ],
    [
      "appliquer",
      0.025
    ],
    [
      "mettre",
      0.02
    ],
    [
      "publier",
      0.02
    ],
    [
      "semer",
      0.0175
    ],
    [
      "presenter",
      0.0175
    ],
    [
      "exprimer",
      0.0175
    ],
    [
      "eparpiller",
      0.0125
    ],
    [
      "raconter",
      0.0125
    ],
    [
      "poser",
      0.0125
    ],
    [
      "passer",
      0.0125
    ],
    [
      "devoiler",
      0.0125
    ],
    [
      "derouler",
      0.0125
    ],
    [
      "delayer",
      0.0125
    ],
    [
      "couvrir",
      0.0125
    ],
    [
      "offrir",
      0.0075
    ],
    [
      "plaquer",
      0.0075
    ],
    [
      "repartir",
      0.0075
    ],
    [
      "tartiner",
      0.0075
    ],
    [
      "etirer",
      0.0075
    ],
    [
      "deshabiller",
      0.0075
    ],
    [
      "deplier",
      0.0075
    ],
    [
      "abattre",
      0.0075
    ],
    [
      "barbouiller",
      0.0075
    ],
    [
      "coucher",
      0.0075
    ],
    [
      "deballer",
      0.0075
    ],
    [
      "demasquer",
      0.0075
    ],
    [
      "epanouir",
      0.0025
    ],
    [
      "epandre",
      0.0025
    ],
    [
      "echelonner",
      0.0025
    ],
    [
      "paonner",
      0.0025
    ],
    [
      "disseminer",
      0.0025
    ],
    [
      "briller",
      0.0025
    ],
    [
      "badigeonner",
      0.0025
    ],
    [
      "arborer",
      0.0025
    ],
    [
      "epartir",
      0.0025
    ]
  ],
  "etale": [
    [
      "immobile",
      0.4
    ],
    [
      "calme",
      0.2
    ],
    [
      "fixe",
      0.2
    ],
    [
      "stationnaire",
      0.2
    ]
  ],
  "fla": [],
  "mendiant": [
    [
      "gueux",
      0.145
    ],
    [
      "clochard",
      0.1075
    ],
    [
      "miserable",
      0.09
    ],
    [
      "pauvre",
      0.09
    ],
    [
      "vagabond",
      0.09
    ],
    [
      "truand",
      0.0725
    ],
    [
      "mendigot",
      0.0525
    ],
    [
      "necessiteux",
      0.0525
    ],
    [
      "trimardeur",
      0.035
    ],
    [
      "misereux",
      0.035
    ],
    [
      "cloche",
      0.035
    ],
    [
      "chemineau",
      0.035
    ],
    [
      "sabouleux",
      0.0175
    ],
    [
      "quemandeur",
      0.0175
    ],
    [
      "pilon",
      0.0175
    ],
    [
      "parasite",
      0.0175
    ],
    [
      "indigent",
      0.0175
    ],
    [
      "gredin",
      0.0175
    ],
    [
      "suppliant",
      0.0175
    ]
  ],
  "mendier": [
    [
      "solliciter",
      0.25
    ],
    [
      "revendiquer",
      0.0825
    ],
    [
      "queter",
      0.0825
    ],
    [
      "quemander",
      0.0825
    ],
    [
      "mendigoter",
      0.0825
    ],
    [
      "implorer",
      0.0825
    ],
    [
      "gueuser",
      0.0825
    ],
    [
      "demander",
      0.0825
    ],
    [
      "truander",
      0.0825
    ]
  ],
  "anatheme": [
    [
      "blame",
      0.1425
    ],
    [
      "condamnation",
      0.1425
    ],
    [
      "interdit",
      0.1425
    ],
    [
      "malediction",
      0.1425
    ],
    [
      "reprouve",
      0.0925
    ],
    [
      "excommunication",
      0.0925
    ],
    [
      "aggrave",
      0.045
    ],
    [
      "excommunie",
      0.045
    ],
    [
      "imprecation",
      0.045
    ],
    [
      "opprobre",
      0.045
    ],
    [
      "reprobation",
      0.045
    ]
  ],
  "theoreme": [
    [
      "axiome",
      0.25
    ],
    [
      "demonstration",
      0.25
    ],
    [
      "proposition",
      0.25
    ],
    [
      "affirmation",
      0.125
    ],
    [
      "verite",
      0.125
    ]
  ],
  "roux": [
    [
      "rouge",
      0.1525
    ],
    [
      "rouquin",
      0.1525
    ],
    [
      "roussatre",
      0.115
    ],
    [
      "fauve",
      0.075
    ],
    [
      "rouille",
      0.0375
    ],
    [
      "rouquemoute",
      0.0375
    ],
    [
      "rousseau",
      0.0375
    ],
    [
      "rubigineux",
      0.0375
    ],
    [
      "orange",
      0.0375
    ],
    [
      "carotte",
      0.0375
    ],
    [
      "blond",
      0.0375
    ],
    [
      "baillet",
      0.0375
    ],
    [
      "auburn",
      0.0375
    ],
    [
      "alezan",
      0.0375
    ],
    [
      "rutilant",
      0.0375
    ]
  ],
  "beler": [
    [
      "crier",
      0.25
    ],
    [
      "brailler",
      0.105
    ],
    [
      "criailler",
      0.105
    ],
    [
      "gemir",
      0.105
    ],
    [
      "piailler",
      0.035
    ],
    [
      "jeremier",
      0.035
    ],
    [
      "geindre",
      0.035
    ],
    [
      "chevroter",
      0.035
    ],
    [
      "begueter",
      0.035
    ],
    [
      "bramer",
      0.035
    ],
    [
      "braire",
      0.035
    ],
    [
      "appeler",
      0.035
    ],
    [
      "rouspeter",
      0.035
    ]
  ],
  "berger": [
    [
      "pasteur",
      0.12
    ],
    [
      "bouvier",
      0.08
    ],
    [
      "conducteur",
      0.08
    ],
    [
      "chef",
      0.06
    ],
    [
      "gardien",
      0.06
    ],
    [
      "pastoureau",
      0.04
    ],
    [
      "guide",
      0.04
    ],
    [
      "gardeur",
      0.04
    ],
    [
      "souverain",
      0.02
    ],
    [
      "patre",
      0.02
    ],
    [
      "porcher",
      0.02
    ],
    [
      "pastour",
      0.02
    ],
    [
      "parqueur",
      0.02
    ],
    [
      "muletier",
      0.02
    ],
    [
      "leader",
      0.02
    ],
    [
      "gaucho",
      0.02
    ],
    [
      "gardian",
      0.02
    ],
    [
      "chien",
      0.02
    ],
    [
      "chevrier",
      0.02
    ],
    [
      "bergerot",
      0.02
    ],
    [
      "bergeronnette",
      0.02
    ],
    [
      "bergerette",
      0.02
    ],
    [
      "amant",
      0.02
    ],
    [
      "anier",
      0.02
    ]
  ],
  "imprevu": [
    [
      "inattendu",
      0.1575
    ],
    [
      "inespere",
      0.105
    ],
    [
      "surprenant",
      0.105
    ],
    [
      "inopine",
      0.09
    ],
    [
      "brusque",
      0.0525
    ],
    [
      "extraordinaire",
      0.0525
    ],
    [
      "etonnant",
      0.0375
    ],
    [
      "subit",
      0.0375
    ],
    [
      "sensationnel",
      0.0375
    ],
    [
      "imprevisible",
      0.0375
    ],
    [
      "fortuit",
      0.0375
    ],
    [
      "deroutant",
      0.0375
    ],
    [
      "soudain",
      0.025
    ],
    [
      "deconcertant",
      0.025
    ],
    [
      "accidentel",
      0.025
    ],
    [
      "supplementaire",
      0.0125
    ],
    [
      "intempestif",
      0.0125
    ],
    [
      "insoupconne",
      0.0125
    ],
    [
      "incertain",
      0.0125
    ],
    [
      "hasard",
      0.0125
    ],
    [
      "fantaisie",
      0.0125
    ],
    [
      "alea",
      0.0125
    ],
    [
      "accidente",
      0.0125
    ],
    [
      "survenant",
      0.0125
    ]
  ],
  "papillon": [
    [
      "contravention",
      0.25
    ],
    [
      "lepidoptere",
      0.25
    ],
    [
      "prospectus",
      0.25
    ],
    [
      "tract",
      0.25
    ]
  ],
  "envolee": [
    [
      "introuvable",
      0.3325
    ],
    [
      "perdu",
      0.3325
    ],
    [
      "evanoui",
      0.3325
    ]
  ],
  "perir": [
    [
      "disparaitre",
      0.135
    ],
    [
      "mourir",
      0.0825
    ],
    [
      "s'ecrouler",
      0.0825
    ],
    [
      "s'eteindre",
      0.0825
    ],
    [
      "tomber",
      0.075
    ],
    [
      "s'evanouir",
      0.0675
    ],
    [
      "s'aneantir",
      0.06
    ],
    [
      "expirer",
      0.045
    ],
    [
      "sombrer",
      0.045
    ],
    [
      "perdre",
      0.0375
    ],
    [
      "finir",
      0.0375
    ],
    [
      "succomber",
      0.03
    ],
    [
      "trepasser",
      0.03
    ],
    [
      "crouler",
      0.0225
    ],
    [
      "deceder",
      0.015
    ],
    [
      "defunter",
      0.0075
    ]
  ],
  "peri": [
    [
      "genie",
      1.0
    ]
  ],
  "homo": [
    [
      "homosexuel",
      1.0
    ]
  ],
  "sexuel": [
    [
      "amoureux",
      0.11
    ],
    [
      "charnel",
      0.11
    ],
    [
      "genital",
      0.11
    ],
    [
      "genesique",
      0.11
    ],
    [
      "intime",
      0.11
    ],
    [
      "libidinal",
      0.11
    ],
    [
      "physique",
      0.11
    ],
    [
      "venerien",
      0.11
    ],
    [
      "erotique",
      0.11
    ]
  ],
  "terroriste": [
    [
      "boutefeu",
      0.3325
    ],
    [
      "revolutionnaire",
      0.3325
    ],
    [
      "seditieux",
      0.3325
    ]
  ],
  "barbu": [
    [
      "herisse",
      0.3325
    ],
    [
      "poilu",
      0.3325
    ],
    [
      "velu",
      0.3325
    ]
  ],
  "baller": [
    [
      "balancer",
      0.2125
    ],
    [
      "tanguer",
      0.2125
    ],
    [
      "danser",
      0.1425
    ],
    [
      "osciller",
      0.1425
    ],
    [
      "ballotter",
      0.07
    ],
    [
      "dodeliner",
      0.07
    ],
    [
      "giguer",
      0.07
    ],
    [
      "pendre",
      0.07
    ]
  ],
  "ballant": [
    [
      "oscillant",
      0.285
    ],
    [
      "balancement",
      0.1425
    ],
    [
      "balancant",
      0.1425
    ],
    [
      "brimbalant",
      0.1425
    ],
    [
      "oscillation",
      0.1425
    ],
    [
      "pendant",
      0.1425
    ]
  ],
  "marron": [
    [
      "coup",
      0.095
    ],
    [
      "vereux",
      0.095
    ],
    [
      "kaki",
      0.0475
    ],
    [
      "macaron",
      0.0475
    ],
    [
      "malhonnete",
      0.0475
    ],
    [
      "negre",
      0.0475
    ],
    [
      "petard",
      0.0475
    ],
    [
      "sauvage",
      0.0475
    ],
    [
      "suspect",
      0.0475
    ],
    [
      "irregulier",
      0.0475
    ],
    [
      "havane",
      0.0475
    ],
    [
      "grumeau",
      0.0475
    ],
    [
      "clandestin",
      0.0475
    ],
    [
      "chataigne",
      0.0475
    ],
    [
      "castagne",
      0.0475
    ],
    [
      "brun",
      0.0475
    ],
    [
      "bronze",
      0.0475
    ],
    [
      "beigne",
      0.0475
    ],
    [
      "torgnole",
      0.0475
    ]
  ],
  "anal": [
    [
      "rectal",
      1.0
    ]
  ],
  "rencard": [],
  "connexion": [
    [
      "liaison",
      0.21
    ],
    [
      "rapport",
      0.1575
    ],
    [
      "affinite",
      0.085
    ],
    [
      "alliance",
      0.07
    ],
    [
      "association",
      0.07
    ],
    [
      "union",
      0.07
    ],
    [
      "ressemblance",
      0.0525
    ],
    [
      "relation",
      0.0525
    ],
    [
      "coherence",
      0.0525
    ],
    [
      "analogie",
      0.0525
    ],
    [
      "cohesion",
      0.0325
    ],
    [
      "connexite",
      0.0325
    ],
    [
      "enchainement",
      0.0325
    ],
    [
      "cablage",
      0.015
    ]
  ],
  "surfer": [
    [
      "naviguer",
      1.0
    ]
  ],
  "break": [
    [
      "commercial",
      0.3325
    ],
    [
      "interruption",
      0.3325
    ]
  ],
  "consulter": [
    [
      "examiner",
      0.135
    ],
    [
      "chercher",
      0.065
    ],
    [
      "interroger",
      0.065
    ],
    [
      "sonder",
      0.065
    ],
    [
      "suivre",
      0.0475
    ],
    [
      "fouiller",
      0.0475
    ],
    [
      "compulser",
      0.0475
    ],
    [
      "regarder",
      0.0325
    ],
    [
      "lire",
      0.0325
    ],
    [
      "feuilleter",
      0.0325
    ],
    [
      "depouiller",
      0.0325
    ],
    [
      "discuter",
      0.0325
    ],
    [
      "demander",
      0.0325
    ],
    [
      "conferer",
      0.0325
    ],
    [
      "balancer",
      0.0325
    ],
    [
      "tergiverser",
      0.015
    ],
    [
      "s'informer",
      0.015
    ],
    [
      "s'entendre",
      0.015
    ],
    [
      "referer",
      0.015
    ],
    [
      "reflechir",
      0.015
    ],
    [
      "questionner",
      0.015
    ],
    [
      "parler",
      0.015
    ],
    [
      "hesiter",
      0.015
    ],
    [
      "ecouter",
      0.015
    ]
  ],
  "particulier": [
    [
      "special",
      0.1075
    ],
    [
      "original",
      0.0775
    ],
    [
      "caracteristique",
      0.07
    ],
    [
      "personnel",
      0.07
    ],
    [
      "propre",
      0.06
    ],
    [
      "specifique",
      0.0525
    ],
    [
      "singulier",
      0.0525
    ],
    [
      "extraordinaire",
      0.0475
    ],
    [
      "individuel",
      0.0475
    ],
    [
      "etonnant",
      0.04
    ],
    [
      "remarquable",
      0.035
    ],
    [
      "distinct",
      0.035
    ],
    [
      "typique",
      0.0275
    ],
    [
      "distinctif",
      0.0225
    ],
    [
      "notable",
      0.015
    ],
    [
      "sensationnel",
      0.015
    ],
    [
      "saisissant",
      0.01
    ],
    [
      "signale",
      0.01
    ],
    [
      "separe",
      0.01
    ],
    [
      "truculent",
      0.01
    ],
    [
      "revelateur",
      0.01
    ],
    [
      "quidam",
      0.01
    ],
    [
      "precis",
      0.01
    ],
    [
      "exclusif",
      0.01
    ],
    [
      "individu",
      0.01
    ],
    [
      "isole",
      0.01
    ],
    [
      "marque",
      0.01
    ],
    [
      "prive",
      0.01
    ],
    [
      "sieur",
      0.005
    ],
    [
      "respectif",
      0.005
    ],
    [
      "prodigieux",
      0.005
    ],
    [
      "personne",
      0.005
    ],
    [
      "irregulier",
      0.005
    ],
    [
      "intime",
      0.005
    ],
    [
      "homme",
      0.005
    ],
    [
      "extreme",
      0.005
    ],
    [
      "subjectif",
      0.005
    ]
  ],
  "bahut": [
    [
      "armoire",
      0.0875
    ],
    [
      "boite",
      0.0875
    ],
    [
      "buffet",
      0.0875
    ],
    [
      "cabinet",
      0.0875
    ],
    [
      "coffre",
      0.0875
    ],
    [
      "commode",
      0.065
    ],
    [
      "ecole",
      0.0425
    ],
    [
      "vaisselier",
      0.0425
    ],
    [
      "semainier",
      0.0425
    ],
    [
      "lycee",
      0.0425
    ],
    [
      "bonnetiere",
      0.0425
    ],
    [
      "bazar",
      0.0425
    ],
    [
      "taxi",
      0.02
    ],
    [
      "secretaire",
      0.02
    ],
    [
      "maie",
      0.02
    ],
    [
      "huche",
      0.02
    ],
    [
      "dressoir",
      0.02
    ],
    [
      "college",
      0.02
    ],
    [
      "camion",
      0.02
    ],
    [
      "boutique",
      0.02
    ],
    [
      "assise",
      0.02
    ]
  ],
  "expose": [
    [
      "reveler",
      0.115
    ],
    [
      "montrer",
      0.1
    ],
    [
      "exprimer",
      0.045
    ],
    [
      "donner",
      0.045
    ],
    [
      "presenter",
      0.045
    ],
    [
      "dire",
      0.0425
    ],
    [
      "raconter",
      0.035
    ],
    [
      "afficher",
      0.0275
    ],
    [
      "declarer",
      0.0275
    ],
    [
      "signifier",
      0.0275
    ],
    [
      "indiquer",
      0.025
    ],
    [
      "representer",
      0.025
    ],
    [
      "signaler",
      0.025
    ],
    [
      "annoncer",
      0.0225
    ],
    [
      "publier",
      0.0225
    ],
    [
      "expliquer",
      0.02
    ],
    [
      "etaler",
      0.0175
    ],
    [
      "decouvrir",
      0.015
    ],
    [
      "communiquer",
      0.015
    ],
    [
      "former",
      0.015
    ],
    [
      "developper",
      0.0125
    ],
    [
      "produire",
      0.0125
    ],
    [
      "retracer",
      0.0125
    ],
    [
      "enoncer",
      0.0125
    ],
    [
      "decrire",
      0.01
    ],
    [
      "rapporter",
      0.01
    ],
    [
      "peindre",
      0.01
    ],
    [
      "offrir",
      0.01
    ],
    [
      "livrer",
      0.01
    ],
    [
      "ecrire",
      0.0075
    ],
    [
      "exhiber",
      0.0075
    ],
    [
      "conter",
      0.005
    ],
    [
      "disposer",
      0.005
    ],
    [
      "traiter",
      0.005
    ],
    [
      "tourner",
      0.005
    ],
    [
      "risquer",
      0.005
    ],
    [
      "proposer",
      0.005
    ],
    [
      "fournir",
      0.005
    ],
    [
      "deployer",
      0.005
    ],
    [
      "arranger",
      0.005
    ],
    [
      "soumettre",
      0.0025
    ],
    [
      "placer",
      0.0025
    ],
    [
      "jouer",
      0.0025
    ],
    [
      "instruire",
      0.0025
    ],
    [
      "hasarder",
      0.0025
    ],
    [
      "engager",
      0.0025
    ],
    [
      "detailler",
      0.0025
    ],
    [
      "depeindre",
      0.0025
    ],
    [
      "compromettre",
      0.0025
    ],
    [
      "aventurer",
      0.0025
    ],
    [
      "relater",
      0.0
    ],
    [
      "prodiguer",
      0.0
    ],
    [
      "narrer",
      0.0
    ],
    [
      "formuler",
      0.0
    ],
    [
      "derouler",
      0.0
    ],
    [
      "deduire",
      0.0
    ],
    [
      "commenter",
      0.0
    ],
    [
      "brandir",
      0.0
    ],
    [
      "orienter",
      0.0
    ],
    [
      "impressionner",
      0.0
    ],
    [
      "commettre",
      0.0
    ],
    [
      "circonstancier",
      0.0
    ],
    [
      "abandonner",
      0.0
    ],
    [
      "situer",
      0.0
    ]
  ],
  "exposer": [
    [
      "reveler",
      0.115
    ],
    [
      "montrer",
      0.1
    ],
    [
      "exprimer",
      0.045
    ],
    [
      "donner",
      0.045
    ],
    [
      "presenter",
      0.045
    ],
    [
      "dire",
      0.0425
    ],
    [
      "raconter",
      0.035
    ],
    [
      "afficher",
      0.0275
    ],
    [
      "declarer",
      0.0275
    ],
    [
      "signifier",
      0.0275
    ],
    [
      "indiquer",
      0.025
    ],
    [
      "representer",
      0.025
    ],
    [
      "signaler",
      0.025
    ],
    [
      "annoncer",
      0.0225
    ],
    [
      "publier",
      0.0225
    ],
    [
      "expliquer",
      0.02
    ],
    [
      "etaler",
      0.0175
    ],
    [
      "decouvrir",
      0.015
    ],
    [
      "communiquer",
      0.015
    ],
    [
      "former",
      0.015
    ],
    [
      "developper",
      0.0125
    ],
    [
      "produire",
      0.0125
    ],
    [
      "retracer",
      0.0125
    ],
    [
      "enoncer",
      0.0125
    ],
    [
      "decrire",
      0.01
    ],
    [
      "rapporter",
      0.01
    ],
    [
      "peindre",
      0.01
    ],
    [
      "offrir",
      0.01
    ],
    [
      "livrer",
      0.01
    ],
    [
      "ecrire",
      0.0075
    ],
    [
      "exhiber",
      0.0075
    ],
    [
      "conter",
      0.005
    ],
    [
      "disposer",
      0.005
    ],
    [
      "traiter",
      0.005
    ],
    [
      "tourner",
      0.005
    ],
    [
      "risquer",
      0.005
    ],
    [
      "proposer",
      0.005
    ],
    [
      "fournir",
      0.005
    ],
    [
      "deployer",
      0.005
    ],
    [
      "arranger",
      0.005
    ],
    [
      "soumettre",
      0.0025
    ],
    [
      "placer",
      0.0025
    ],
    [
      "jouer",
      0.0025
    ],
    [
      "instruire",
      0.0025
    ],
    [
      "hasarder",
      0.0025
    ],
    [
      "engager",
      0.0025
    ],
    [
      "detailler",
      0.0025
    ],
    [
      "depeindre",
      0.0025
    ],
    [
      "compromettre",
      0.0025
    ],
    [
      "aventurer",
      0.0025
    ],
    [
      "relater",
      0.0
    ],
    [
      "prodiguer",
      0.0
    ],
    [
      "narrer",
      0.0
    ],
    [
      "formuler",
      0.0
    ],
    [
      "derouler",
      0.0
    ],
    [
      "deduire",
      0.0
    ],
    [
      "commenter",
      0.0
    ],
    [
      "brandir",
      0.0
    ],
    [
      "orienter",
      0.0
    ],
    [
      "impressionner",
      0.0
    ],
    [
      "commettre",
      0.0
    ],
    [
      "circonstancier",
      0.0
    ],
    [
      "abandonner",
      0.0
    ],
    [
      "situer",
      0.0
    ]
  ],
  "gauler": [
    [
      "agiter",
      0.25
    ],
    [
      "secouer",
      0.25
    ],
    [
      "battre",
      0.125
    ],
    [
      "chabler",
      0.125
    ],
    [
      "ebranler",
      0.125
    ]
  ],
  "verge": [
    [
      "queue",
      0.155
    ],
    [
      "penis",
      0.13
    ],
    [
      "sexe",
      0.1025
    ],
    [
      "bite",
      0.075
    ],
    [
      "baton",
      0.075
    ],
    [
      "tige",
      0.05
    ],
    [
      "phallus",
      0.05
    ],
    [
      "manche",
      0.05
    ],
    [
      "tringle",
      0.025
    ],
    [
      "schlague",
      0.025
    ],
    [
      "quequette",
      0.025
    ],
    [
      "priape",
      0.025
    ],
    [
      "pine",
      0.025
    ],
    [
      "insigne",
      0.025
    ],
    [
      "fleau",
      0.025
    ],
    [
      "braquemart",
      0.025
    ],
    [
      "biroute",
      0.025
    ],
    [
      "baguette",
      0.025
    ],
    [
      "vit",
      0.025
    ]
  ],
  "nuls": [
    [
      "faible",
      0.055
    ],
    [
      "insignifiant",
      0.0475
    ],
    [
      "vide",
      0.0475
    ],
    [
      "zero",
      0.0475
    ],
    [
      "incapable",
      0.04
    ],
    [
      "mauvais",
      0.04
    ],
    [
      "nullite",
      0.0325
    ],
    [
      "mechant",
      0.0325
    ],
    [
      "inutile",
      0.0325
    ],
    [
      "bete",
      0.0325
    ],
    [
      "stupide",
      0.0275
    ],
    [
      "insuffisant",
      0.0275
    ],
    [
      "inefficace",
      0.0275
    ],
    [
      "inconsistant",
      0.0275
    ],
    [
      "ignorant",
      0.0275
    ],
    [
      "sterile",
      0.02
    ],
    [
      "sot",
      0.02
    ],
    [
      "plat",
      0.02
    ],
    [
      "inexistant",
      0.02
    ],
    [
      "idiot",
      0.02
    ],
    [
      "caduc",
      0.02
    ],
    [
      "annule",
      0.02
    ],
    [
      "negatif",
      0.0125
    ],
    [
      "neant",
      0.0125
    ],
    [
      "nullard",
      0.0125
    ],
    [
      "minable",
      0.0125
    ],
    [
      "lamentable",
      0.0125
    ],
    [
      "inintelligent",
      0.0125
    ],
    [
      "infime",
      0.0125
    ],
    [
      "inepte",
      0.0125
    ],
    [
      "incompetent",
      0.0125
    ],
    [
      "falot",
      0.0125
    ],
    [
      "cancre",
      0.0125
    ],
    [
      "bouche",
      0.0125
    ],
    [
      "personne",
      0.005
    ],
    [
      "prescrit",
      0.005
    ],
    [
      "perime",
      0.005
    ],
    [
      "rien",
      0.005
    ],
    [
      "moindre",
      0.005
    ],
    [
      "invalide",
      0.005
    ],
    [
      "invalide",
      0.005
    ],
    [
      "ignare",
      0.005
    ],
    [
      "crasse",
      0.005
    ],
    [
      "aucun",
      0.005
    ],
    [
      "aboli",
      0.005
    ],
    [
      "suranne",
      0.005
    ]
  ],
  "chignon": [
    [
      "coiffure",
      0.25
    ],
    [
      "nuque",
      0.25
    ],
    [
      "torsade",
      0.25
    ],
    [
      "touffe",
      0.25
    ]
  ],
  "beat": [
    [
      "beatnik",
      1.0
    ]
  ],
  "informaticien": [
    [
      "analyste",
      0.5
    ],
    [
      "programmeur",
      0.5
    ]
  ],
  "forfait": [
    [
      "faillir",
      0.25
    ],
    [
      "forligner",
      0.25
    ],
    [
      "manquer",
      0.25
    ],
    [
      "pecher",
      0.25
    ]
  ],
  "fi": [
    [
      "pouah",
      1.0
    ]
  ],
  "modem": [
    [
      "demodulateur",
      1.0
    ]
  ],
  "chauffer": [
    [
      "enflammer",
      0.07
    ],
    [
      "exciter",
      0.0625
    ],
    [
      "bruler",
      0.0525
    ],
    [
      "exalter",
      0.0525
    ],
    [
      "voler",
      0.045
    ],
    [
      "prendre",
      0.045
    ],
    [
      "embraser",
      0.045
    ],
    [
      "attiser",
      0.045
    ],
    [
      "rechauffer",
      0.035
    ],
    [
      "stimuler",
      0.025
    ],
    [
      "faucher",
      0.025
    ],
    [
      "derober",
      0.025
    ],
    [
      "cuire",
      0.025
    ],
    [
      "choper",
      0.025
    ],
    [
      "chiper",
      0.025
    ],
    [
      "bassiner",
      0.025
    ],
    [
      "etuver",
      0.0175
    ],
    [
      "echauffer",
      0.0175
    ],
    [
      "tiedir",
      0.0175
    ],
    [
      "s'echauffer",
      0.0175
    ],
    [
      "rotir",
      0.0175
    ],
    [
      "griller",
      0.0175
    ],
    [
      "fomenter",
      0.0175
    ],
    [
      "calciner",
      0.0175
    ],
    [
      "attraper",
      0.0175
    ],
    [
      "fermenter",
      0.0075
    ],
    [
      "grincher",
      0.0075
    ],
    [
      "presser",
      0.0075
    ],
    [
      "riffauder",
      0.0075
    ],
    [
      "reviser",
      0.0075
    ],
    [
      "subtiliser",
      0.0075
    ],
    [
      "surchauffer",
      0.0075
    ],
    [
      "encourager",
      0.0075
    ],
    [
      "degourdir",
      0.0075
    ],
    [
      "attiedir",
      0.0075
    ],
    [
      "attremper",
      0.0075
    ],
    [
      "bachoter",
      0.0075
    ],
    [
      "barboter",
      0.0075
    ],
    [
      "barder",
      0.0075
    ],
    [
      "bleuir",
      0.0075
    ],
    [
      "braiser",
      0.0075
    ],
    [
      "chouraver",
      0.0075
    ],
    [
      "coincer",
      0.0075
    ]
  ],
  "chauffe": [
    [
      "calefaction",
      0.3325
    ],
    [
      "chauffage",
      0.3325
    ],
    [
      "feu",
      0.3325
    ]
  ],
  "organiser": [
    [
      "arranger",
      0.0925
    ],
    [
      "disposer",
      0.07
    ],
    [
      "ordonner",
      0.0675
    ],
    [
      "construire",
      0.055
    ],
    [
      "combiner",
      0.05
    ],
    [
      "composer",
      0.05
    ],
    [
      "preparer",
      0.04
    ],
    [
      "constituer",
      0.04
    ],
    [
      "agencer",
      0.04
    ],
    [
      "former",
      0.0375
    ],
    [
      "amenager",
      0.035
    ],
    [
      "harmoniser",
      0.0325
    ],
    [
      "etablir",
      0.0325
    ],
    [
      "creer",
      0.025
    ],
    [
      "distribuer",
      0.0225
    ],
    [
      "monter",
      0.0225
    ],
    [
      "planifier",
      0.0175
    ],
    [
      "regler",
      0.0175
    ],
    [
      "edifier",
      0.015
    ],
    [
      "elaborer",
      0.015
    ],
    [
      "structurer",
      0.0125
    ],
    [
      "installer",
      0.0125
    ],
    [
      "fonder",
      0.0125
    ],
    [
      "ordonnancer",
      0.0075
    ],
    [
      "hierarchiser",
      0.0075
    ],
    [
      "diriger",
      0.0075
    ],
    [
      "coordonner",
      0.0075
    ],
    [
      "classer",
      0.0075
    ],
    [
      "ajuster",
      0.0075
    ],
    [
      "administrer",
      0.0075
    ],
    [
      "tramer",
      0.005
    ],
    [
      "prevoir",
      0.005
    ],
    [
      "orchestrer",
      0.005
    ],
    [
      "menager",
      0.005
    ],
    [
      "instituer",
      0.005
    ],
    [
      "discipliner",
      0.005
    ],
    [
      "articuler",
      0.005
    ],
    [
      "appreter",
      0.005
    ],
    [
      "syndiquer",
      0.0025
    ],
    [
      "reorganiser",
      0.0025
    ],
    [
      "programmer",
      0.0025
    ],
    [
      "politiser",
      0.0025
    ],
    [
      "policer",
      0.0025
    ],
    [
      "minuter",
      0.0025
    ],
    [
      "instaurer",
      0.0025
    ],
    [
      "encadrer",
      0.0025
    ],
    [
      "concerter",
      0.0025
    ],
    [
      "equiper",
      0.0025
    ]
  ],
  "egoiste": [
    [
      "personnel",
      0.12
    ],
    [
      "exclusif",
      0.0775
    ],
    [
      "sec",
      0.0775
    ],
    [
      "egocentrique",
      0.0775
    ],
    [
      "mufle",
      0.0375
    ],
    [
      "narcissique",
      0.0375
    ],
    [
      "egocentriste",
      0.0375
    ],
    [
      "interesse",
      0.0375
    ],
    [
      "insensible",
      0.0375
    ],
    [
      "ingrat",
      0.0375
    ],
    [
      "individualiste",
      0.0375
    ],
    [
      "indifferent",
      0.0375
    ],
    [
      "entier",
      0.0375
    ],
    [
      "bourgeois",
      0.0375
    ],
    [
      "avare",
      0.0375
    ],
    [
      "autolatre",
      0.0375
    ],
    [
      "egotiste",
      0.0375
    ]
  ],
  "insister": [
    [
      "appuyer",
      0.1125
    ],
    [
      "continuer",
      0.085
    ],
    [
      "prier",
      0.085
    ],
    [
      "supplier",
      0.085
    ],
    [
      "souligner",
      0.055
    ],
    [
      "s'obstiner",
      0.055
    ],
    [
      "recommander",
      0.055
    ],
    [
      "presser",
      0.055
    ],
    [
      "perseverer",
      0.055
    ],
    [
      "demander",
      0.055
    ],
    [
      "accentuer",
      0.055
    ],
    [
      "s'appesantir",
      0.0275
    ],
    [
      "s'acharner",
      0.0275
    ],
    [
      "repeter",
      0.0275
    ],
    [
      "revendiquer",
      0.0275
    ],
    [
      "ponctuer",
      0.0275
    ],
    [
      "persister",
      0.0275
    ],
    [
      "s'etendre",
      0.0275
    ]
  ],
  "pagaille": [
    [
      "desordre",
      0.26
    ],
    [
      "agitation",
      0.085
    ],
    [
      "bordel",
      0.085
    ],
    [
      "gachis",
      0.085
    ],
    [
      "merde",
      0.0425
    ],
    [
      "gabegie",
      0.0425
    ],
    [
      "chienlit",
      0.0425
    ],
    [
      "cafouillis",
      0.0425
    ],
    [
      "cafouillage",
      0.0425
    ],
    [
      "brouillamini",
      0.0425
    ],
    [
      "anarchie",
      0.0425
    ],
    [
      "affluence",
      0.0425
    ],
    [
      "precipitation",
      0.0425
    ]
  ],
  "roseau": [
    [
      "arundo",
      0.125
    ],
    [
      "calame",
      0.125
    ],
    [
      "canne",
      0.125
    ],
    [
      "chalumeau",
      0.125
    ],
    [
      "massette",
      0.125
    ],
    [
      "mirliton",
      0.125
    ],
    [
      "phragmite",
      0.125
    ],
    [
      "pipeau",
      0.125
    ]
  ],
  "marais": [
    [
      "marecage",
      0.1475
    ],
    [
      "boue",
      0.0875
    ],
    [
      "cloaque",
      0.0875
    ],
    [
      "bassesse",
      0.0575
    ],
    [
      "etang",
      0.0575
    ],
    [
      "lac",
      0.0275
    ],
    [
      "mare",
      0.0275
    ],
    [
      "maremme",
      0.0275
    ],
    [
      "marigot",
      0.0275
    ],
    [
      "palud",
      0.0275
    ],
    [
      "palus",
      0.0275
    ],
    [
      "jardinage",
      0.0275
    ],
    [
      "jardin",
      0.0275
    ],
    [
      "hortillonnage",
      0.0275
    ],
    [
      "fange",
      0.0275
    ],
    [
      "fagne",
      0.0275
    ],
    [
      "culture",
      0.0275
    ],
    [
      "claire",
      0.0275
    ],
    [
      "bourbier",
      0.0275
    ],
    [
      "polder",
      0.0275
    ]
  ],
  "calamite": [
    [
      "malheur",
      0.1575
    ],
    [
      "tribulation",
      0.115
    ],
    [
      "affliction",
      0.0775
    ],
    [
      "chagrin",
      0.0675
    ],
    [
      "catastrophe",
      0.0625
    ],
    [
      "epreuve",
      0.04
    ],
    [
      "detresse",
      0.03
    ],
    [
      "mal",
      0.03
    ],
    [
      "tristesse",
      0.03
    ],
    [
      "deception",
      0.025
    ],
    [
      "deuil",
      0.025
    ],
    [
      "cataclysme",
      0.025
    ],
    [
      "adversite",
      0.025
    ],
    [
      "accident",
      0.02
    ],
    [
      "desolation",
      0.02
    ],
    [
      "infortune",
      0.02
    ],
    [
      "evenement",
      0.015
    ],
    [
      "echec",
      0.015
    ],
    [
      "misere",
      0.015
    ],
    [
      "malediction",
      0.015
    ],
    [
      "fleau",
      0.015
    ],
    [
      "fatalite",
      0.015
    ],
    [
      "desastre",
      0.015
    ],
    [
      "deboire",
      0.015
    ],
    [
      "contrariete",
      0.015
    ],
    [
      "tourmente",
      0.0075
    ],
    [
      "orage",
      0.0075
    ],
    [
      "insucces",
      0.0075
    ],
    [
      "deveine",
      0.0075
    ],
    [
      "disgrace",
      0.0075
    ],
    [
      "dommage",
      0.0025
    ],
    [
      "guignon",
      0.0025
    ],
    [
      "punition",
      0.0025
    ]
  ],
  "calamiter": [
    [
      "abattre",
      0.5
    ],
    [
      "catastropher",
      0.5
    ]
  ],
  "parfume": [
    [
      "exhaler",
      0.23
    ],
    [
      "repandre",
      0.1525
    ],
    [
      "oindre",
      0.075
    ],
    [
      "odorer",
      0.075
    ],
    [
      "impregner",
      0.075
    ],
    [
      "fleurer",
      0.075
    ],
    [
      "embaumer",
      0.075
    ],
    [
      "degager",
      0.075
    ],
    [
      "aromatiser",
      0.075
    ],
    [
      "remplir",
      0.075
    ]
  ],
  "parfumer": [
    [
      "exhaler",
      0.23
    ],
    [
      "repandre",
      0.1525
    ],
    [
      "oindre",
      0.075
    ],
    [
      "odorer",
      0.075
    ],
    [
      "impregner",
      0.075
    ],
    [
      "fleurer",
      0.075
    ],
    [
      "embaumer",
      0.075
    ],
    [
      "degager",
      0.075
    ],
    [
      "aromatiser",
      0.075
    ],
    [
      "remplir",
      0.075
    ]
  ],
  "carnaval": [
    [
      "deguisement",
      0.1425
    ],
    [
      "mascarade",
      0.1425
    ],
    [
      "masque",
      0.095
    ],
    [
      "travestissement",
      0.0475
    ],
    [
      "grotesque",
      0.0475
    ],
    [
      "defile",
      0.0475
    ],
    [
      "domino",
      0.0475
    ],
    [
      "divertissement",
      0.0475
    ],
    [
      "chienlit",
      0.0475
    ],
    [
      "chicard",
      0.0475
    ],
    [
      "cavalcade",
      0.0475
    ],
    [
      "amusement",
      0.0475
    ],
    [
      "veglione",
      0.0475
    ]
  ],
  "eponge": [
    [
      "biberon",
      0.2
    ],
    [
      "chassis",
      0.2
    ],
    [
      "ivrogne",
      0.2
    ],
    [
      "spongiaire",
      0.2
    ],
    [
      "tumeur",
      0.2
    ]
  ],
  "fendre": [
    [
      "couper",
      0.115
    ],
    [
      "diviser",
      0.075
    ],
    [
      "dechirer",
      0.065
    ],
    [
      "fissurer",
      0.0575
    ],
    [
      "rompre",
      0.0575
    ],
    [
      "separer",
      0.0575
    ],
    [
      "trancher",
      0.0475
    ],
    [
      "ouvrir",
      0.04
    ],
    [
      "disjoindre",
      0.04
    ],
    [
      "casser",
      0.04
    ],
    [
      "crevasser",
      0.0325
    ],
    [
      "fendiller",
      0.0325
    ],
    [
      "gercer",
      0.0325
    ],
    [
      "percer",
      0.0325
    ],
    [
      "traverser",
      0.0325
    ],
    [
      "tailler",
      0.0225
    ],
    [
      "briser",
      0.0225
    ],
    [
      "ecarter",
      0.015
    ],
    [
      "sillonner",
      0.015
    ],
    [
      "sectionner",
      0.015
    ],
    [
      "lezarder",
      0.015
    ],
    [
      "hacher",
      0.015
    ],
    [
      "feler",
      0.015
    ],
    [
      "entrouvrir",
      0.015
    ],
    [
      "craqueler",
      0.015
    ],
    [
      "cliver",
      0.015
    ],
    [
      "crever",
      0.005
    ],
    [
      "naviguer",
      0.005
    ],
    [
      "penetrer",
      0.005
    ],
    [
      "scier",
      0.005
    ]
  ],
  "regal": [
    [
      "plaisir",
      0.1275
    ],
    [
      "rejouissance",
      0.1275
    ],
    [
      "delice",
      0.1025
    ],
    [
      "fete",
      0.1025
    ],
    [
      "festin",
      0.075
    ],
    [
      "repas",
      0.075
    ],
    [
      "volupte",
      0.05
    ],
    [
      "jouissance",
      0.05
    ],
    [
      "joie",
      0.05
    ],
    [
      "delectation",
      0.05
    ],
    [
      "divertissement",
      0.05
    ],
    [
      "collation",
      0.025
    ],
    [
      "dessert",
      0.025
    ],
    [
      "festival",
      0.025
    ],
    [
      "friandise",
      0.025
    ],
    [
      "menu",
      0.025
    ]
  ],
  "ecailler": [
    [
      "poissonnier",
      1.0
    ]
  ],
  "extase": [
    [
      "exaltation",
      0.1075
    ],
    [
      "enthousiasme",
      0.08
    ],
    [
      "ivresse",
      0.0675
    ],
    [
      "joie",
      0.0675
    ],
    [
      "ravissement",
      0.0675
    ],
    [
      "transport",
      0.0675
    ],
    [
      "enivrement",
      0.0525
    ],
    [
      "beatitude",
      0.0525
    ],
    [
      "bonheur",
      0.0525
    ],
    [
      "admiration",
      0.04
    ],
    [
      "vertige",
      0.025
    ],
    [
      "mysticisme",
      0.025
    ],
    [
      "griserie",
      0.025
    ],
    [
      "felicite",
      0.025
    ],
    [
      "euphorie",
      0.025
    ],
    [
      "anagogie",
      0.025
    ],
    [
      "veneration",
      0.0125
    ],
    [
      "vision",
      0.0125
    ],
    [
      "transe",
      0.0125
    ],
    [
      "sublimation",
      0.0125
    ],
    [
      "profondeur",
      0.0125
    ],
    [
      "nevrose",
      0.0125
    ],
    [
      "levitation",
      0.0125
    ],
    [
      "hysterie",
      0.0125
    ],
    [
      "contemplation",
      0.0125
    ],
    [
      "catalepsie",
      0.0125
    ],
    [
      "calme",
      0.0125
    ],
    [
      "adoration",
      0.0125
    ],
    [
      "emerveillement",
      0.0125
    ]
  ],
  "cannibale": [
    [
      "anthropophage",
      0.25
    ],
    [
      "sauvage",
      0.25
    ],
    [
      "barbare",
      0.125
    ],
    [
      "cruel",
      0.125
    ],
    [
      "feroce",
      0.125
    ],
    [
      "ogre",
      0.125
    ]
  ],
  "bouillon": [
    [
      "potage",
      0.08
    ],
    [
      "bouillonnement",
      0.06
    ],
    [
      "restaurant",
      0.06
    ],
    [
      "tisane",
      0.04
    ],
    [
      "soupe",
      0.04
    ],
    [
      "popote",
      0.04
    ],
    [
      "gargote",
      0.04
    ],
    [
      "effervescence",
      0.04
    ],
    [
      "chaudeau",
      0.04
    ],
    [
      "brouet",
      0.04
    ],
    [
      "boisson",
      0.04
    ],
    [
      "invendable",
      0.0175
    ],
    [
      "lavure",
      0.0175
    ],
    [
      "panade",
      0.0175
    ],
    [
      "pli",
      0.0175
    ],
    [
      "remous",
      0.0175
    ],
    [
      "remede",
      0.0175
    ],
    [
      "ruche",
      0.0175
    ],
    [
      "flot",
      0.0175
    ],
    [
      "embarras",
      0.0175
    ],
    [
      "bide",
      0.0175
    ],
    [
      "bidon",
      0.0175
    ],
    [
      "brasserie",
      0.0175
    ],
    [
      "bulle",
      0.0175
    ],
    [
      "chaudree",
      0.0175
    ],
    [
      "concentre",
      0.0175
    ],
    [
      "consomme",
      0.0175
    ],
    [
      "crise",
      0.0175
    ],
    [
      "transport",
      0.0175
    ]
  ],
  "souper": [
    [
      "repas",
      0.375
    ],
    [
      "diner",
      0.25
    ],
    [
      "collation",
      0.125
    ],
    [
      "reveillon",
      0.125
    ]
  ],
  "soupe": [
    [
      "cuisine",
      0.1775
    ],
    [
      "mets",
      0.1425
    ],
    [
      "nourriture",
      0.105
    ],
    [
      "repas",
      0.105
    ],
    [
      "popote",
      0.07
    ],
    [
      "brouet",
      0.07
    ],
    [
      "bouillon",
      0.07
    ],
    [
      "rata",
      0.035
    ],
    [
      "patee",
      0.035
    ],
    [
      "potage",
      0.035
    ],
    [
      "garbure",
      0.035
    ],
    [
      "croute",
      0.035
    ],
    [
      "ratatouille",
      0.035
    ]
  ],
  "marmiton": [
    [
      "cuisinier",
      0.1825
    ],
    [
      "casserolier",
      0.09
    ],
    [
      "galopin",
      0.09
    ],
    [
      "gamin",
      0.09
    ],
    [
      "tournebroche",
      0.09
    ]
  ],
  "tambouille": [
    [
      "cuisine",
      0.22
    ],
    [
      "nourriture",
      0.22
    ],
    [
      "ratatouille",
      0.22
    ],
    [
      "fripe",
      0.11
    ],
    [
      "mangeaille",
      0.11
    ],
    [
      "ragout",
      0.11
    ]
  ],
  "hamecon": [
    [
      "piege",
      0.285
    ],
    [
      "amorce",
      0.1425
    ],
    [
      "appat",
      0.1425
    ],
    [
      "filet",
      0.1425
    ],
    [
      "leurre",
      0.1425
    ],
    [
      "nasse",
      0.1425
    ]
  ],
  "esturgeon": [
    [
      "ganoide",
      1.0
    ]
  ],
  "raie": [
    [
      "rayure",
      0.1925
    ],
    [
      "ligne",
      0.095
    ],
    [
      "sillon",
      0.095
    ],
    [
      "strie",
      0.095
    ],
    [
      "zebrure",
      0.0625
    ],
    [
      "trait",
      0.0625
    ],
    [
      "ride",
      0.0625
    ],
    [
      "rainure",
      0.0625
    ],
    [
      "barre",
      0.0625
    ],
    [
      "bande",
      0.0625
    ],
    [
      "entaille",
      0.03
    ],
    [
      "hachure",
      0.03
    ],
    [
      "rai",
      0.03
    ],
    [
      "vergeture",
      0.03
    ]
  ],
  "dynamiter": [],
  "dynamite": [
    [
      "explosif",
      1.0
    ]
  ],
  "carpe": [
    [
      "carpeau",
      0.3325
    ],
    [
      "carpien",
      0.3325
    ],
    [
      "carpillon",
      0.3325
    ]
  ],
  "harpe": [
    [
      "harpon",
      0.25
    ],
    [
      "herpe",
      0.25
    ],
    [
      "lyre",
      0.25
    ],
    [
      "poesie",
      0.25
    ]
  ],
  "rascasse": [
    [
      "scorpene",
      1.0
    ]
  ],
  "maquereau": [
    [
      "souteneur",
      0.24
    ],
    [
      "barbillon",
      0.08
    ],
    [
      "proxenete",
      0.0525
    ],
    [
      "poisson",
      0.0525
    ],
    [
      "poisse",
      0.0525
    ],
    [
      "mec",
      0.0525
    ],
    [
      "marlou",
      0.0525
    ],
    [
      "hareng",
      0.025
    ],
    [
      "mac",
      0.025
    ],
    [
      "marle",
      0.025
    ],
    [
      "protecteur",
      0.025
    ],
    [
      "taulier",
      0.025
    ],
    [
      "truand",
      0.025
    ],
    [
      "fripouille",
      0.025
    ],
    [
      "entremetteur",
      0.025
    ],
    [
      "brochet",
      0.025
    ],
    [
      "barbiquet",
      0.025
    ],
    [
      "barbichon",
      0.025
    ],
    [
      "barbeau",
      0.025
    ],
    [
      "amant",
      0.025
    ],
    [
      "alphonse",
      0.025
    ],
    [
      "vaurien",
      0.025
    ]
  ],
  "turbo": [],
  "bongo": [],
  "gardon": [
    [
      "able",
      1.0
    ]
  ],
  "sole": [
    [
      "boisage",
      0.5
    ],
    [
      "plie",
      0.5
    ]
  ],
  "sprat": [],
  "doudou": [],
  "sardine": [
    [
      "anchois",
      0.25
    ],
    [
      "galon",
      0.25
    ],
    [
      "rossinante",
      0.25
    ]
  ],
  "jazz": [],
  "clam": [
    [
      "coquillage",
      1.0
    ]
  ],
  "jam": [],
  "limace": [
    [
      "chemise",
      0.25
    ],
    [
      "limacon",
      0.25
    ],
    [
      "liquette",
      0.25
    ],
    [
      "loche",
      0.25
    ]
  ],
  "bigorneau": [
    [
      "bigophone",
      0.1425
    ],
    [
      "bigorne",
      0.1425
    ],
    [
      "coquillage",
      0.1425
    ],
    [
      "littorine",
      0.1425
    ],
    [
      "telephone",
      0.1425
    ],
    [
      "vignot",
      0.1425
    ],
    [
      "ecouteur",
      0.1425
    ]
  ],
  "frenetique": [
    [
      "enrage",
      0.065
    ],
    [
      "exalte",
      0.065
    ],
    [
      "passionne",
      0.06
    ],
    [
      "fougueux",
      0.0575
    ],
    [
      "furieux",
      0.0525
    ],
    [
      "bouillonnant",
      0.05
    ],
    [
      "ardent",
      0.0475
    ],
    [
      "fou",
      0.0475
    ],
    [
      "impetueux",
      0.04
    ],
    [
      "violent",
      0.04
    ],
    [
      "dechaine",
      0.0375
    ],
    [
      "effrene",
      0.0275
    ],
    [
      "excite",
      0.0275
    ],
    [
      "vif",
      0.025
    ],
    [
      "endiable",
      0.0225
    ],
    [
      "eperdu",
      0.0175
    ],
    [
      "febrile",
      0.0175
    ],
    [
      "forcene",
      0.0175
    ],
    [
      "fanatique",
      0.0175
    ],
    [
      "enthousiaste",
      0.0175
    ],
    [
      "delirant",
      0.0175
    ],
    [
      "vehement",
      0.015
    ],
    [
      "fievreux",
      0.015
    ],
    [
      "chaud",
      0.015
    ],
    [
      "debride",
      0.0125
    ],
    [
      "explosif",
      0.0125
    ],
    [
      "insense",
      0.0125
    ],
    [
      "surexcite",
      0.0125
    ],
    [
      "effervescent",
      0.01
    ],
    [
      "survolte",
      0.0075
    ],
    [
      "tumultueux",
      0.0075
    ],
    [
      "echevele",
      0.0075
    ],
    [
      "debordant",
      0.0075
    ],
    [
      "bouillant",
      0.0075
    ],
    [
      "agite",
      0.0075
    ],
    [
      "acharne",
      0.0075
    ],
    [
      "dement",
      0.005
    ],
    [
      "intense",
      0.005
    ],
    [
      "surchauffe",
      0.005
    ],
    [
      "triomphal",
      0.0025
    ],
    [
      "sectaire",
      0.0025
    ],
    [
      "maniaque",
      0.0025
    ],
    [
      "intolerant",
      0.0025
    ],
    [
      "devorant",
      0.0025
    ],
    [
      "devergonde",
      0.0025
    ],
    [
      "hysterique",
      0.0
    ],
    [
      "apre",
      0.0
    ]
  ],
  "insense": [
    [
      "fou",
      0.135
    ],
    [
      "extravagant",
      0.0725
    ],
    [
      "deraisonnable",
      0.0675
    ],
    [
      "absurde",
      0.065
    ],
    [
      "saugrenu",
      0.0275
    ],
    [
      "sot",
      0.025
    ],
    [
      "toque",
      0.025
    ],
    [
      "bizarre",
      0.0225
    ],
    [
      "effrene",
      0.0225
    ],
    [
      "demesure",
      0.0225
    ],
    [
      "exagere",
      0.02
    ],
    [
      "stupide",
      0.02
    ],
    [
      "aliene",
      0.0175
    ],
    [
      "excessif",
      0.0175
    ],
    [
      "fantastique",
      0.0175
    ],
    [
      "loufoque",
      0.0175
    ],
    [
      "inconsequent",
      0.015
    ],
    [
      "desequilibre",
      0.015
    ],
    [
      "dement",
      0.015
    ],
    [
      "aberrant",
      0.015
    ],
    [
      "biscornu",
      0.0125
    ],
    [
      "ridicule",
      0.0125
    ],
    [
      "timbre",
      0.0125
    ],
    [
      "irrationnel",
      0.0125
    ],
    [
      "incoherent",
      0.0125
    ],
    [
      "frenetique",
      0.0125
    ],
    [
      "delirant",
      0.0125
    ],
    [
      "deregle",
      0.01
    ],
    [
      "fabuleux",
      0.01
    ],
    [
      "idiot",
      0.01
    ],
    [
      "irreflechi",
      0.0075
    ],
    [
      "monstrueux",
      0.0075
    ],
    [
      "pique",
      0.0075
    ],
    [
      "ecervele",
      0.0075
    ],
    [
      "inepte",
      0.0075
    ],
    [
      "inconscient",
      0.0075
    ],
    [
      "impossible",
      0.0075
    ],
    [
      "farfelu",
      0.0075
    ],
    [
      "detraque",
      0.0075
    ],
    [
      "bete",
      0.0075
    ],
    [
      "echevele",
      0.005
    ],
    [
      "enrage",
      0.005
    ],
    [
      "dingue",
      0.005
    ],
    [
      "cingle",
      0.005
    ],
    [
      "astronomique",
      0.005
    ],
    [
      "insane",
      0.005
    ],
    [
      "indescriptible",
      0.005
    ],
    [
      "imprudent",
      0.005
    ],
    [
      "feroce",
      0.005
    ],
    [
      "forcene",
      0.005
    ],
    [
      "faux",
      0.005
    ],
    [
      "maboul",
      0.0025
    ],
    [
      "immodere",
      0.0025
    ],
    [
      "immense",
      0.0025
    ],
    [
      "fele",
      0.0025
    ],
    [
      "tumultueux",
      0.0
    ],
    [
      "irraisonnable",
      0.0
    ],
    [
      "informe",
      0.0
    ],
    [
      "indicible",
      0.0
    ],
    [
      "impensable",
      0.0
    ],
    [
      "ahurissant",
      0.0
    ],
    [
      "affole",
      0.0
    ],
    [
      "temeraire",
      0.0
    ]
  ],
  "tombee": [
    [
      "disparaitre",
      0.0325
    ],
    [
      "s'ecrouler",
      0.0325
    ],
    [
      "baisser",
      0.0275
    ],
    [
      "passer",
      0.0275
    ],
    [
      "diminuer",
      0.0275
    ],
    [
      "mourir",
      0.025
    ],
    [
      "ceder",
      0.0225
    ],
    [
      "s'evanouir",
      0.02
    ],
    [
      "s'affaisser",
      0.02
    ],
    [
      "degringoler",
      0.02
    ],
    [
      "decliner",
      0.02
    ],
    [
      "descendre",
      0.02
    ],
    [
      "s'effondrer",
      0.02
    ],
    [
      "s'eteindre",
      0.0175
    ],
    [
      "finir",
      0.0175
    ],
    [
      "dechoir",
      0.0175
    ],
    [
      "arriver",
      0.0175
    ],
    [
      "cesser",
      0.015
    ],
    [
      "s'enfoncer",
      0.015
    ],
    [
      "couler",
      0.015
    ],
    [
      "venir",
      0.0125
    ],
    [
      "s'affaiblir",
      0.0125
    ],
    [
      "s'abattre",
      0.0125
    ],
    [
      "perir",
      0.0125
    ],
    [
      "abandonner",
      0.0125
    ],
    [
      "faiblir",
      0.01
    ],
    [
      "sortir",
      0.01
    ],
    [
      "survenir",
      0.01
    ],
    [
      "s'abaisser",
      0.01
    ],
    [
      "crouler",
      0.01
    ],
    [
      "chuter",
      0.01
    ],
    [
      "aboutir",
      0.01
    ],
    [
      "s'aneantir",
      0.0075
    ],
    [
      "s'affaler",
      0.0075
    ],
    [
      "glisser",
      0.0075
    ],
    [
      "decroitre",
      0.0075
    ],
    [
      "aller",
      0.0075
    ],
    [
      "surgir",
      0.005
    ],
    [
      "s'abimer",
      0.005
    ],
    [
      "quitter",
      0.005
    ],
    [
      "manquer",
      0.005
    ],
    [
      "advenir",
      0.005
    ],
    [
      "ecraser",
      0.005
    ],
    [
      "succomber",
      0.005
    ],
    [
      "s'etaler",
      0.005
    ],
    [
      "rouler",
      0.005
    ],
    [
      "culbuter",
      0.005
    ],
    [
      "sauter",
      0.005
    ],
    [
      "trebucher",
      0.005
    ],
    [
      "echouer",
      0.005
    ],
    [
      "s'elancer",
      0.005
    ],
    [
      "s'aplatir",
      0.005
    ],
    [
      "fuser",
      0.005
    ],
    [
      "choir",
      0.005
    ],
    [
      "debouler",
      0.005
    ],
    [
      "defaillir",
      0.005
    ],
    [
      "degenerer",
      0.005
    ],
    [
      "faillir",
      0.005
    ],
    [
      "s'apaiser",
      0.0025
    ],
    [
      "s'avilir",
      0.0025
    ],
    [
      "s'envoler",
      0.0025
    ],
    [
      "echapper",
      0.0025
    ],
    [
      "s'accomplir",
      0.0025
    ],
    [
      "retomber",
      0.0025
    ],
    [
      "renverser",
      0.0025
    ],
    [
      "avoir",
      0.0025
    ],
    [
      "capituler",
      0.0025
    ],
    [
      "casser",
      0.0025
    ],
    [
      "devenir",
      0.0025
    ],
    [
      "deboucher",
      0.0025
    ],
    [
      "mollir",
      0.0025
    ],
    [
      "peser",
      0.0025
    ],
    [
      "pericliter",
      0.0025
    ],
    [
      "s'allonger",
      0.0
    ],
    [
      "s'offrir",
      0.0
    ],
    [
      "s'operer",
      0.0
    ],
    [
      "trainer",
      0.0
    ],
    [
      "verser",
      0.0
    ],
    [
      "echoir",
      0.0
    ],
    [
      "s'abatardir",
      0.0
    ],
    [
      "pecher",
      0.0
    ],
    [
      "pleuvoir",
      0.0
    ],
    [
      "basculer",
      0.0
    ],
    [
      "bouler",
      0.0
    ],
    [
      "devaler",
      0.0
    ],
    [
      "intervenir",
      0.0
    ],
    [
      "l'emporter",
      0.0
    ],
    [
      "pendiller",
      0.0
    ],
    [
      "pendre",
      0.0
    ],
    [
      "piquer",
      0.0
    ],
    [
      "seduire",
      0.0
    ],
    [
      "terrasser",
      0.0
    ],
    [
      "valdinguer",
      0.0
    ],
    [
      "ebouler",
      0.0
    ],
    [
      "s'attenuer",
      0.0
    ],
    [
      "s'amoindrir",
      0.0
    ],
    [
      "conquerir",
      0.0
    ],
    [
      "dinguer",
      0.0
    ],
    [
      "dire",
      0.0
    ],
    [
      "degoutter",
      0.0
    ],
    [
      "effondrer",
      0.0
    ],
    [
      "rejoindre",
      0.0
    ],
    [
      "retrograder",
      0.0
    ],
    [
      "s'amener",
      0.0
    ]
  ],
  "royale": [
    [
      "splendide",
      0.1375
    ],
    [
      "souverain",
      0.09
    ],
    [
      "somptueux",
      0.09
    ],
    [
      "princier",
      0.09
    ],
    [
      "parfait",
      0.09
    ],
    [
      "magnifique",
      0.09
    ],
    [
      "luxueux",
      0.09
    ],
    [
      "fastueux",
      0.09
    ],
    [
      "grandiose",
      0.045
    ],
    [
      "imposant",
      0.045
    ],
    [
      "monarchique",
      0.045
    ],
    [
      "regalien",
      0.045
    ],
    [
      "triomphant",
      0.045
    ]
  ],
  "regaler": [
    [
      "charmer",
      0.095
    ],
    [
      "egaliser",
      0.095
    ],
    [
      "traiter",
      0.095
    ],
    [
      "rejouir",
      0.095
    ],
    [
      "inviter",
      0.095
    ],
    [
      "feter",
      0.095
    ],
    [
      "nourrir",
      0.0475
    ],
    [
      "maltraiter",
      0.0475
    ],
    [
      "malmener",
      0.0475
    ],
    [
      "festoyer",
      0.0475
    ],
    [
      "delecter",
      0.0475
    ],
    [
      "aplanir",
      0.0475
    ],
    [
      "amuser",
      0.0475
    ],
    [
      "payer",
      0.0475
    ]
  ],
  "regale": [
    [
      "charmer",
      0.095
    ],
    [
      "egaliser",
      0.095
    ],
    [
      "traiter",
      0.095
    ],
    [
      "rejouir",
      0.095
    ],
    [
      "inviter",
      0.095
    ],
    [
      "feter",
      0.095
    ],
    [
      "nourrir",
      0.0475
    ],
    [
      "maltraiter",
      0.0475
    ],
    [
      "malmener",
      0.0475
    ],
    [
      "festoyer",
      0.0475
    ],
    [
      "delecter",
      0.0475
    ],
    [
      "aplanir",
      0.0475
    ],
    [
      "amuser",
      0.0475
    ],
    [
      "payer",
      0.0475
    ]
  ],
  "chips": [
    [
      "croustille",
      1.0
    ]
  ],
  "synchroniser": [
    [
      "concorder",
      0.3325
    ],
    [
      "correspondre",
      0.3325
    ]
  ],
  "evider": [
    [
      "chantourner",
      0.18
    ],
    [
      "decouper",
      0.18
    ],
    [
      "tailler",
      0.18
    ],
    [
      "echancrer",
      0.18
    ],
    [
      "creuser",
      0.09
    ],
    [
      "cureter",
      0.09
    ],
    [
      "diminuer",
      0.09
    ]
  ],
  "evident": [
    [
      "certain",
      0.115
    ],
    [
      "manifeste",
      0.075
    ],
    [
      "incontestable",
      0.0575
    ],
    [
      "clair",
      0.0525
    ],
    [
      "indubitable",
      0.04
    ],
    [
      "positif",
      0.0375
    ],
    [
      "authentique",
      0.035
    ],
    [
      "notoire",
      0.035
    ],
    [
      "indeniable",
      0.0275
    ],
    [
      "vrai",
      0.0275
    ],
    [
      "formel",
      0.025
    ],
    [
      "indiscutable",
      0.025
    ],
    [
      "flagrant",
      0.0225
    ],
    [
      "patent",
      0.0225
    ],
    [
      "sur",
      0.0225
    ],
    [
      "reel",
      0.0225
    ],
    [
      "irrefragable",
      0.0225
    ],
    [
      "net",
      0.0175
    ],
    [
      "officiel",
      0.0175
    ],
    [
      "sincere",
      0.0175
    ],
    [
      "visible",
      0.0175
    ],
    [
      "eclatant",
      0.0175
    ],
    [
      "tangible",
      0.0175
    ],
    [
      "avere",
      0.0175
    ],
    [
      "assure",
      0.015
    ],
    [
      "sensible",
      0.015
    ],
    [
      "irrecusable",
      0.01
    ],
    [
      "ouvert",
      0.01
    ],
    [
      "palpable",
      0.0075
    ],
    [
      "intelligible",
      0.0075
    ],
    [
      "categorique",
      0.0075
    ],
    [
      "frappant",
      0.005
    ],
    [
      "limpide",
      0.005
    ],
    [
      "perceptible",
      0.005
    ],
    [
      "public",
      0.005
    ],
    [
      "veridique",
      0.005
    ],
    [
      "voyant",
      0.0025
    ],
    [
      "transparent",
      0.0025
    ],
    [
      "probant",
      0.0025
    ],
    [
      "irrefutable",
      0.0025
    ],
    [
      "decide",
      0.0025
    ],
    [
      "comprehensible",
      0.0025
    ],
    [
      "apparent",
      0.0025
    ],
    [
      "tranquille",
      0.0025
    ],
    [
      "irresistible",
      0.0025
    ],
    [
      "intuitif",
      0.0025
    ],
    [
      "infaillible",
      0.0025
    ],
    [
      "indemontrable",
      0.0025
    ],
    [
      "criant",
      0.0025
    ],
    [
      "constant",
      0.0025
    ],
    [
      "connu",
      0.0025
    ],
    [
      "prouve",
      0.0
    ],
    [
      "force",
      0.0
    ],
    [
      "criailleur",
      0.0
    ],
    [
      "corollaire",
      0.0
    ],
    [
      "conscient",
      0.0
    ],
    [
      "axiomatique",
      0.0
    ],
    [
      "apert",
      0.0
    ],
    [
      "saillant",
      0.0
    ]
  ],
  "epouser": [
    [
      "embrasser",
      0.2125
    ],
    [
      "adopter",
      0.1425
    ],
    [
      "suivre",
      0.105
    ],
    [
      "partager",
      0.035
    ],
    [
      "s'allier",
      0.035
    ],
    [
      "s'attacher",
      0.035
    ],
    [
      "s'unir",
      0.035
    ],
    [
      "mouler",
      0.035
    ],
    [
      "marier",
      0.035
    ],
    [
      "imiter",
      0.035
    ],
    [
      "entrer",
      0.035
    ],
    [
      "convoler",
      0.035
    ],
    [
      "choisir",
      0.035
    ],
    [
      "chausser",
      0.035
    ],
    [
      "soutenir",
      0.035
    ]
  ],
  "silhouette": [
    [
      "forme",
      0.15
    ],
    [
      "allure",
      0.105
    ],
    [
      "contour",
      0.085
    ],
    [
      "ligne",
      0.085
    ],
    [
      "port",
      0.085
    ],
    [
      "profil",
      0.085
    ],
    [
      "aspect",
      0.0625
    ],
    [
      "dessin",
      0.0625
    ],
    [
      "portrait",
      0.04
    ],
    [
      "perspective",
      0.04
    ],
    [
      "galbe",
      0.04
    ],
    [
      "anatomie",
      0.02
    ],
    [
      "but",
      0.02
    ],
    [
      "caricature",
      0.02
    ],
    [
      "degaine",
      0.02
    ],
    [
      "gabarit",
      0.02
    ],
    [
      "ombre",
      0.02
    ],
    [
      "trace",
      0.02
    ]
  ],
  "silhouetter": [],
  "aigu": [
    [
      "percant",
      0.09
    ],
    [
      "vif",
      0.0875
    ],
    [
      "penetrant",
      0.0775
    ],
    [
      "piquant",
      0.0525
    ],
    [
      "aigre",
      0.045
    ],
    [
      "acere",
      0.0425
    ],
    [
      "tranchant",
      0.0425
    ],
    [
      "fort",
      0.0375
    ],
    [
      "cuisant",
      0.035
    ],
    [
      "pointu",
      0.03
    ],
    [
      "violent",
      0.025
    ],
    [
      "affile",
      0.0225
    ],
    [
      "fin",
      0.0225
    ],
    [
      "intelligent",
      0.0225
    ],
    [
      "mordant",
      0.0175
    ],
    [
      "eclatant",
      0.015
    ],
    [
      "strident",
      0.015
    ],
    [
      "incisif",
      0.015
    ],
    [
      "dechirant",
      0.015
    ],
    [
      "coupant",
      0.015
    ],
    [
      "subtil",
      0.0125
    ],
    [
      "profond",
      0.0125
    ],
    [
      "poignant",
      0.0125
    ],
    [
      "delie",
      0.0125
    ],
    [
      "cruel",
      0.0125
    ],
    [
      "criard",
      0.0125
    ],
    [
      "clair",
      0.0125
    ],
    [
      "aiguise",
      0.0125
    ],
    [
      "torturant",
      0.0075
    ],
    [
      "prompt",
      0.0075
    ],
    [
      "lucide",
      0.0075
    ],
    [
      "lancinant",
      0.0075
    ],
    [
      "haut",
      0.0075
    ],
    [
      "effile",
      0.0075
    ],
    [
      "affute",
      0.0075
    ],
    [
      "eleve",
      0.005
    ],
    [
      "sifflant",
      0.005
    ],
    [
      "ouvert",
      0.005
    ],
    [
      "intolerable",
      0.005
    ],
    [
      "lanceole",
      0.0025
    ],
    [
      "mobile",
      0.0025
    ],
    [
      "nasillard",
      0.0025
    ],
    [
      "saillant",
      0.0025
    ],
    [
      "scrutateur",
      0.0025
    ],
    [
      "subule",
      0.0025
    ],
    [
      "suraigu",
      0.0025
    ],
    [
      "emorfile",
      0.0025
    ],
    [
      "grincant",
      0.0025
    ],
    [
      "glapissant",
      0.0025
    ],
    [
      "aciculaire",
      0.0025
    ],
    [
      "aculeiforme",
      0.0025
    ],
    [
      "acumine",
      0.0025
    ],
    [
      "analytique",
      0.0025
    ],
    [
      "anguleux",
      0.0025
    ],
    [
      "doue",
      0.0025
    ],
    [
      "exaspere",
      0.0025
    ],
    [
      "flute",
      0.0025
    ],
    [
      "emoulu",
      0.0025
    ]
  ],
  "rapprocher": [
    [
      "joindre",
      0.1125
    ],
    [
      "reunir",
      0.09
    ],
    [
      "unir",
      0.075
    ],
    [
      "assembler",
      0.0625
    ],
    [
      "associer",
      0.055
    ],
    [
      "accorder",
      0.055
    ],
    [
      "allier",
      0.04
    ],
    [
      "concilier",
      0.04
    ],
    [
      "lier",
      0.04
    ],
    [
      "raccommoder",
      0.04
    ],
    [
      "remettre",
      0.0325
    ],
    [
      "accoler",
      0.0325
    ],
    [
      "adjoindre",
      0.0275
    ],
    [
      "juxtaposer",
      0.0275
    ],
    [
      "reconcilier",
      0.0275
    ],
    [
      "fusionner",
      0.02
    ],
    [
      "rabibocher",
      0.0125
    ],
    [
      "rapatrier",
      0.0125
    ],
    [
      "rapporter",
      0.0125
    ],
    [
      "serrer",
      0.0125
    ],
    [
      "melanger",
      0.0125
    ],
    [
      "comparer",
      0.0125
    ],
    [
      "avancer",
      0.0125
    ],
    [
      "assimiler",
      0.0125
    ],
    [
      "approcher",
      0.0125
    ],
    [
      "amalgamer",
      0.0125
    ],
    [
      "rejoindre",
      0.005
    ],
    [
      "raccourcir",
      0.005
    ],
    [
      "presser",
      0.005
    ],
    [
      "grouper",
      0.005
    ],
    [
      "attirer",
      0.005
    ],
    [
      "apparenter",
      0.005
    ],
    [
      "aboucher",
      0.005
    ],
    [
      "resserrer",
      0.005
    ]
  ],
  "national": [
    [
      "domestique",
      0.5
    ],
    [
      "public",
      0.5
    ]
  ],
  "nationale": [
    [
      "domestique",
      0.5
    ],
    [
      "public",
      0.5
    ]
  ],
  "escadrille": [
    [
      "escadre",
      0.25
    ],
    [
      "flottille",
      0.25
    ],
    [
      "groupe",
      0.25
    ],
    [
      "unite",
      0.25
    ]
  ],
  "dominer": [
    [
      "dompter",
      0.0775
    ],
    [
      "maitriser",
      0.0725
    ],
    [
      "assujettir",
      0.045
    ],
    [
      "triompher",
      0.045
    ],
    [
      "commander",
      0.04
    ],
    [
      "surmonter",
      0.0375
    ],
    [
      "regner",
      0.0325
    ],
    [
      "vaincre",
      0.0275
    ],
    [
      "regir",
      0.0275
    ],
    [
      "l'emporter",
      0.0275
    ],
    [
      "gouverner",
      0.0275
    ],
    [
      "enchainer",
      0.0275
    ],
    [
      "surpasser",
      0.025
    ],
    [
      "soumettre",
      0.025
    ],
    [
      "regler",
      0.025
    ],
    [
      "forcer",
      0.025
    ],
    [
      "asservir",
      0.02
    ],
    [
      "controler",
      0.02
    ],
    [
      "disposer",
      0.02
    ],
    [
      "surplomber",
      0.015
    ],
    [
      "tyranniser",
      0.015
    ],
    [
      "ecraser",
      0.015
    ],
    [
      "etouffer",
      0.015
    ],
    [
      "subjuguer",
      0.015
    ],
    [
      "regenter",
      0.015
    ],
    [
      "prevaloir",
      0.015
    ],
    [
      "primer",
      0.015
    ],
    [
      "diriger",
      0.015
    ],
    [
      "contenir",
      0.015
    ],
    [
      "conquerir",
      0.015
    ],
    [
      "mener",
      0.0125
    ],
    [
      "discipliner",
      0.0125
    ],
    [
      "couvrir",
      0.0125
    ],
    [
      "voir",
      0.0075
    ],
    [
      "predominer",
      0.0075
    ],
    [
      "posseder",
      0.0075
    ],
    [
      "manier",
      0.0075
    ],
    [
      "depasser",
      0.0075
    ],
    [
      "dresser",
      0.0075
    ],
    [
      "couronner",
      0.0075
    ],
    [
      "courber",
      0.0075
    ],
    [
      "s'imposer",
      0.0025
    ],
    [
      "leguer",
      0.0025
    ],
    [
      "envouter",
      0.0025
    ],
    [
      "culminer",
      0.0025
    ],
    [
      "acculer",
      0.0025
    ]
  ],
  "demarcher": [],
  "demarche": [
    [
      "allure",
      0.1125
    ],
    [
      "air",
      0.0675
    ],
    [
      "maintien",
      0.055
    ],
    [
      "comportement",
      0.05
    ],
    [
      "port",
      0.05
    ],
    [
      "marche",
      0.045
    ],
    [
      "attitude",
      0.045
    ],
    [
      "action",
      0.0375
    ],
    [
      "contenance",
      0.0375
    ],
    [
      "tournure",
      0.0375
    ],
    [
      "tenue",
      0.0275
    ],
    [
      "mouvement",
      0.0275
    ],
    [
      "degaine",
      0.0275
    ],
    [
      "demande",
      0.0275
    ],
    [
      "avance",
      0.0275
    ],
    [
      "aspect",
      0.0225
    ],
    [
      "conduite",
      0.0225
    ],
    [
      "forme",
      0.0225
    ],
    [
      "intrigue",
      0.0225
    ],
    [
      "touche",
      0.015
    ],
    [
      "requete",
      0.015
    ],
    [
      "prestance",
      0.015
    ],
    [
      "pas",
      0.015
    ],
    [
      "course",
      0.015
    ],
    [
      "truc",
      0.01
    ],
    [
      "sollicitation",
      0.01
    ],
    [
      "poursuite",
      0.01
    ],
    [
      "methode",
      0.01
    ],
    [
      "cheminement",
      0.01
    ],
    [
      "agissements",
      0.01
    ],
    [
      "mine",
      0.005
    ],
    [
      "offre",
      0.005
    ],
    [
      "revendication",
      0.005
    ],
    [
      "supplication",
      0.005
    ],
    [
      "tentative",
      0.005
    ],
    [
      "tractation",
      0.005
    ],
    [
      "formalite",
      0.005
    ],
    [
      "deplacement",
      0.005
    ],
    [
      "complaisance",
      0.005
    ],
    [
      "combinaison",
      0.005
    ],
    [
      "brigue",
      0.005
    ],
    [
      "bassesse",
      0.005
    ],
    [
      "approche",
      0.005
    ],
    [
      "acte",
      0.005
    ],
    [
      "visite",
      0.005
    ]
  ],
  "hirondeau": [],
  "fantasmer": [
    [
      "halluciner",
      1.0
    ]
  ],
  "fantasme": [
    [
      "illusion",
      0.1725
    ],
    [
      "vision",
      0.1725
    ],
    [
      "hallucination",
      0.1375
    ],
    [
      "phantasme",
      0.1025
    ],
    [
      "fantome",
      0.1025
    ],
    [
      "chimere",
      0.1025
    ],
    [
      "fantasmagorie",
      0.0675
    ],
    [
      "ombre",
      0.0675
    ],
    [
      "image",
      0.0325
    ],
    [
      "songe",
      0.0325
    ]
  ],
  "soufflant": [
    [
      "stupefiant",
      0.18
    ],
    [
      "etonnant",
      0.18
    ],
    [
      "ahurissant",
      0.09
    ],
    [
      "browning",
      0.09
    ],
    [
      "effarant",
      0.09
    ],
    [
      "formidable",
      0.09
    ],
    [
      "pistolet",
      0.09
    ],
    [
      "revolver",
      0.09
    ],
    [
      "epoustouflant",
      0.09
    ]
  ],
  "trompette": [
    [
      "publier",
      0.25
    ],
    [
      "proclamer",
      0.15
    ],
    [
      "corner",
      0.1
    ],
    [
      "clamer",
      0.1
    ],
    [
      "claironner",
      0.1
    ],
    [
      "carillonner",
      0.1
    ],
    [
      "colporter",
      0.0475
    ],
    [
      "divulguer",
      0.0475
    ],
    [
      "emboucher",
      0.0475
    ],
    [
      "glatir",
      0.0475
    ]
  ],
  "achever": [
    [
      "terminer",
      0.115
    ],
    [
      "finir",
      0.1075
    ],
    [
      "parachever",
      0.065
    ],
    [
      "accomplir",
      0.0575
    ],
    [
      "executer",
      0.05
    ],
    [
      "couronner",
      0.0425
    ],
    [
      "parfaire",
      0.0425
    ],
    [
      "tuer",
      0.035
    ],
    [
      "consommer",
      0.035
    ],
    [
      "conclure",
      0.035
    ],
    [
      "completer",
      0.035
    ],
    [
      "abattre",
      0.035
    ],
    [
      "expedier",
      0.0275
    ],
    [
      "ruiner",
      0.02
    ],
    [
      "clore",
      0.02
    ],
    [
      "aneantir",
      0.02
    ],
    [
      "aboutir",
      0.02
    ],
    [
      "reussir",
      0.0125
    ],
    [
      "realiser",
      0.0125
    ],
    [
      "raser",
      0.0125
    ],
    [
      "conduire",
      0.0125
    ],
    [
      "cesser",
      0.0125
    ],
    [
      "assommer",
      0.0125
    ],
    [
      "ameliorer",
      0.0125
    ],
    [
      "perfectionner",
      0.005
    ],
    [
      "finaliser",
      0.005
    ],
    [
      "estoquer",
      0.005
    ],
    [
      "complementer",
      0.005
    ],
    [
      "cloturer",
      0.005
    ],
    [
      "boucler",
      0.005
    ],
    [
      "aiguiser",
      0.005
    ],
    [
      "etre",
      0.005
    ]
  ],
  "espace": [
    [
      "distance",
      0.0625
    ],
    [
      "domaine",
      0.055
    ],
    [
      "sphere",
      0.055
    ],
    [
      "etendue",
      0.055
    ],
    [
      "intervalle",
      0.0475
    ],
    [
      "aire",
      0.0375
    ],
    [
      "ecart",
      0.03
    ],
    [
      "surface",
      0.03
    ],
    [
      "fente",
      0.03
    ],
    [
      "ciel",
      0.03
    ],
    [
      "air",
      0.03
    ],
    [
      "zone",
      0.0225
    ],
    [
      "vide",
      0.0225
    ],
    [
      "univers",
      0.0225
    ],
    [
      "temps",
      0.0225
    ],
    [
      "region",
      0.0225
    ],
    [
      "milieu",
      0.0225
    ],
    [
      "lieu",
      0.0225
    ],
    [
      "interstice",
      0.0225
    ],
    [
      "atmosphere",
      0.0225
    ],
    [
      "place",
      0.015
    ],
    [
      "superficie",
      0.015
    ],
    [
      "trajet",
      0.015
    ],
    [
      "ecartement",
      0.015
    ],
    [
      "eloignement",
      0.015
    ],
    [
      "ether",
      0.015
    ],
    [
      "marge",
      0.015
    ],
    [
      "lacune",
      0.015
    ],
    [
      "blanc",
      0.015
    ],
    [
      "champ",
      0.015
    ],
    [
      "course",
      0.015
    ],
    [
      "hiatus",
      0.015
    ],
    [
      "immensite",
      0.015
    ],
    [
      "infini",
      0.015
    ],
    [
      "portion",
      0.005
    ],
    [
      "laps",
      0.005
    ],
    [
      "interligne",
      0.005
    ],
    [
      "espacement",
      0.005
    ],
    [
      "duree",
      0.005
    ],
    [
      "cosmos",
      0.005
    ],
    [
      "continuum",
      0.005
    ],
    [
      "caractere",
      0.005
    ],
    [
      "alinea",
      0.005
    ],
    [
      "trajectoire",
      0.005
    ]
  ],
  "espacer": [
    [
      "ecarter",
      0.3325
    ],
    [
      "distancer",
      0.165
    ],
    [
      "detacher",
      0.165
    ],
    [
      "separer",
      0.165
    ],
    [
      "echelonner",
      0.165
    ]
  ],
  "courber": [
    [
      "plier",
      0.1125
    ],
    [
      "soumettre",
      0.0525
    ],
    [
      "gauchir",
      0.0475
    ],
    [
      "flechir",
      0.0475
    ],
    [
      "cambrer",
      0.0475
    ],
    [
      "abaisser",
      0.0475
    ],
    [
      "incliner",
      0.04
    ],
    [
      "assujettir",
      0.035
    ],
    [
      "tordre",
      0.03
    ],
    [
      "ployer",
      0.03
    ],
    [
      "inflechir",
      0.03
    ],
    [
      "enchainer",
      0.03
    ],
    [
      "subjuguer",
      0.0225
    ],
    [
      "opprimer",
      0.0225
    ],
    [
      "deformer",
      0.0225
    ],
    [
      "bomber",
      0.0225
    ],
    [
      "arquer",
      0.0225
    ],
    [
      "pencher",
      0.0175
    ],
    [
      "fausser",
      0.0175
    ],
    [
      "contourner",
      0.0175
    ],
    [
      "cintrer",
      0.0175
    ],
    [
      "baisser",
      0.0175
    ],
    [
      "asservir",
      0.0175
    ],
    [
      "arrondir",
      0.0175
    ],
    [
      "tyranniser",
      0.01
    ],
    [
      "recourber",
      0.01
    ],
    [
      "ranger",
      0.01
    ],
    [
      "rabaisser",
      0.01
    ],
    [
      "humilier",
      0.01
    ],
    [
      "gondoler",
      0.01
    ],
    [
      "dejeter",
      0.01
    ],
    [
      "dompter",
      0.01
    ],
    [
      "dominer",
      0.01
    ],
    [
      "busquer",
      0.01
    ],
    [
      "subir",
      0.005
    ],
    [
      "supporter",
      0.005
    ],
    [
      "secher",
      0.005
    ],
    [
      "replier",
      0.005
    ],
    [
      "incurver",
      0.005
    ],
    [
      "emboutir",
      0.005
    ],
    [
      "couder",
      0.005
    ],
    [
      "coucher",
      0.005
    ],
    [
      "cercler",
      0.005
    ],
    [
      "affaisser",
      0.005
    ],
    [
      "vouter",
      0.005
    ]
  ],
  "teste": [
    [
      "verifier",
      0.25
    ],
    [
      "essayer",
      0.125
    ],
    [
      "experimenter",
      0.125
    ],
    [
      "interviewer",
      0.125
    ],
    [
      "questionner",
      0.125
    ],
    [
      "recoler",
      0.125
    ],
    [
      "testamenter",
      0.125
    ]
  ],
  "full": [],
  "evaporer": [
    [
      "s'envoler",
      0.125
    ],
    [
      "s'eclipser",
      0.125
    ],
    [
      "s'exprimer",
      0.0625
    ],
    [
      "s'exhaler",
      0.0625
    ],
    [
      "repandre",
      0.0625
    ],
    [
      "exhaler",
      0.0625
    ],
    [
      "dissiper",
      0.0625
    ],
    [
      "vaporiser",
      0.0625
    ]
  ],
  "proposition": [
    [
      "affirmation",
      0.0875
    ],
    [
      "demonstration",
      0.0775
    ],
    [
      "principe",
      0.065
    ],
    [
      "axiome",
      0.055
    ],
    [
      "maxime",
      0.0425
    ],
    [
      "precepte",
      0.0425
    ],
    [
      "resolution",
      0.0425
    ],
    [
      "projet",
      0.0325
    ],
    [
      "offre",
      0.0325
    ],
    [
      "expression",
      0.0325
    ],
    [
      "declaration",
      0.0325
    ],
    [
      "conseil",
      0.0325
    ],
    [
      "enonciation",
      0.02
    ],
    [
      "theoreme",
      0.02
    ],
    [
      "soumission",
      0.02
    ],
    [
      "premisse",
      0.02
    ],
    [
      "promesse",
      0.02
    ],
    [
      "hypothese",
      0.02
    ],
    [
      "dessein",
      0.02
    ],
    [
      "conclusion",
      0.02
    ],
    [
      "aphorisme",
      0.02
    ],
    [
      "allegation",
      0.02
    ],
    [
      "negation",
      0.01
    ],
    [
      "ouverture",
      0.01
    ],
    [
      "paradoxe",
      0.01
    ],
    [
      "phrase",
      0.01
    ],
    [
      "postulat",
      0.01
    ],
    [
      "suggestion",
      0.01
    ],
    [
      "these",
      0.01
    ],
    [
      "motion",
      0.01
    ],
    [
      "marche",
      0.01
    ],
    [
      "loi",
      0.01
    ],
    [
      "jugement",
      0.01
    ],
    [
      "intention",
      0.01
    ],
    [
      "initiative",
      0.01
    ],
    [
      "corollaire",
      0.01
    ],
    [
      "conversion",
      0.01
    ],
    [
      "avance",
      0.01
    ],
    [
      "assertion",
      0.01
    ],
    [
      "ultimatum",
      0.01
    ]
  ],
  "inexistant": [
    [
      "insignifiant",
      0.0875
    ],
    [
      "irreel",
      0.0875
    ],
    [
      "nul",
      0.0875
    ],
    [
      "zero",
      0.0575
    ],
    [
      "pietre",
      0.0575
    ],
    [
      "imaginaire",
      0.0575
    ],
    [
      "illusoire",
      0.0575
    ],
    [
      "fictif",
      0.0575
    ],
    [
      "fantome",
      0.0575
    ],
    [
      "absent",
      0.0575
    ],
    [
      "negligeable",
      0.0275
    ],
    [
      "negatif",
      0.0275
    ],
    [
      "neant",
      0.0275
    ],
    [
      "immateriel",
      0.0275
    ],
    [
      "fantoche",
      0.0275
    ],
    [
      "deplorable",
      0.0275
    ],
    [
      "chimerique",
      0.0275
    ],
    [
      "negligent",
      0.0275
    ]
  ],
  "morfler": [],
  "raide": [
    [
      "dur",
      0.1
    ],
    [
      "rigide",
      0.0625
    ],
    [
      "rude",
      0.0625
    ],
    [
      "severe",
      0.0425
    ],
    [
      "abrupt",
      0.0375
    ],
    [
      "sec",
      0.0375
    ],
    [
      "strict",
      0.025
    ],
    [
      "sale",
      0.025
    ],
    [
      "fort",
      0.025
    ],
    [
      "cru",
      0.025
    ],
    [
      "austere",
      0.025
    ],
    [
      "compasse",
      0.02
    ],
    [
      "escarpe",
      0.02
    ],
    [
      "grave",
      0.02
    ],
    [
      "inflexible",
      0.02
    ],
    [
      "implacable",
      0.0175
    ],
    [
      "ferme",
      0.0175
    ],
    [
      "autoritaire",
      0.0175
    ],
    [
      "vert",
      0.015
    ],
    [
      "rigoureux",
      0.015
    ],
    [
      "ose",
      0.015
    ],
    [
      "licencieux",
      0.015
    ],
    [
      "guinde",
      0.015
    ],
    [
      "empese",
      0.015
    ],
    [
      "bourru",
      0.015
    ],
    [
      "tendu",
      0.0125
    ],
    [
      "intransigeant",
      0.0125
    ],
    [
      "intraitable",
      0.0125
    ],
    [
      "grivois",
      0.0125
    ],
    [
      "exagere",
      0.0125
    ],
    [
      "difficile",
      0.0125
    ],
    [
      "brusque",
      0.0125
    ],
    [
      "ardu",
      0.0125
    ],
    [
      "aigre",
      0.0125
    ],
    [
      "affecte",
      0.0125
    ],
    [
      "rapide",
      0.0075
    ],
    [
      "perclus",
      0.0075
    ],
    [
      "libre",
      0.0075
    ],
    [
      "gourme",
      0.0075
    ],
    [
      "excessif",
      0.0075
    ],
    [
      "engourdi",
      0.0075
    ],
    [
      "solennel",
      0.005
    ],
    [
      "roide",
      0.005
    ],
    [
      "desargente",
      0.005
    ],
    [
      "droit",
      0.005
    ],
    [
      "croustillant",
      0.005
    ],
    [
      "begueule",
      0.005
    ],
    [
      "malade",
      0.0025
    ],
    [
      "montant",
      0.0025
    ],
    [
      "montueux",
      0.0025
    ],
    [
      "petrifie",
      0.0025
    ],
    [
      "raidement",
      0.0025
    ],
    [
      "rapeux",
      0.0025
    ],
    [
      "sac",
      0.0025
    ],
    [
      "vite",
      0.0025
    ],
    [
      "herisse",
      0.0025
    ],
    [
      "hardi",
      0.0025
    ],
    [
      "abusif",
      0.0025
    ],
    [
      "aigrelet",
      0.0025
    ],
    [
      "alcoolise",
      0.0025
    ],
    [
      "ankylose",
      0.0025
    ],
    [
      "cochon",
      0.0025
    ],
    [
      "contracte",
      0.0025
    ],
    [
      "empote",
      0.0025
    ],
    [
      "engonce",
      0.0025
    ],
    [
      "fige",
      0.0025
    ]
  ],
  "glissant": [
    [
      "secret",
      0.1875
    ],
    [
      "fuyant",
      0.125
    ],
    [
      "insaisissable",
      0.125
    ],
    [
      "instable",
      0.125
    ],
    [
      "mysterieux",
      0.06
    ],
    [
      "incertain",
      0.06
    ],
    [
      "gras",
      0.06
    ],
    [
      "furtif",
      0.06
    ],
    [
      "dangereux",
      0.06
    ],
    [
      "brulant",
      0.06
    ],
    [
      "precaire",
      0.06
    ]
  ],
  "vapeur": [
    [
      "fumee",
      0.1375
    ],
    [
      "brume",
      0.085
    ],
    [
      "emanation",
      0.085
    ],
    [
      "esprit",
      0.0675
    ],
    [
      "nuage",
      0.0675
    ],
    [
      "mofette",
      0.05
    ],
    [
      "exhalaison",
      0.05
    ],
    [
      "brouillard",
      0.05
    ],
    [
      "ame",
      0.0325
    ],
    [
      "nebulosite",
      0.0325
    ],
    [
      "nuee",
      0.0325
    ],
    [
      "humidite",
      0.0325
    ],
    [
      "fluide",
      0.0325
    ],
    [
      "buee",
      0.0325
    ],
    [
      "steamer",
      0.015
    ],
    [
      "serein",
      0.015
    ],
    [
      "neant",
      0.015
    ],
    [
      "humeur",
      0.015
    ],
    [
      "griserie",
      0.015
    ],
    [
      "gaz",
      0.015
    ],
    [
      "fumerolle",
      0.015
    ],
    [
      "bouffee",
      0.015
    ],
    [
      "bateau",
      0.015
    ],
    [
      "alcoolat",
      0.015
    ],
    [
      "vanite",
      0.015
    ]
  ],
  "aneantir": [
    [
      "detruire",
      0.095
    ],
    [
      "abattre",
      0.0725
    ],
    [
      "briser",
      0.05
    ],
    [
      "ruiner",
      0.05
    ],
    [
      "supprimer",
      0.045
    ],
    [
      "epuiser",
      0.0375
    ],
    [
      "ecraser",
      0.035
    ],
    [
      "fatiguer",
      0.0325
    ],
    [
      "tuer",
      0.0275
    ],
    [
      "accabler",
      0.025
    ],
    [
      "demolir",
      0.0225
    ],
    [
      "abolir",
      0.02
    ],
    [
      "ereinter",
      0.0175
    ],
    [
      "annihiler",
      0.0175
    ],
    [
      "foudroyer",
      0.0175
    ],
    [
      "renverser",
      0.015
    ],
    [
      "broyer",
      0.015
    ],
    [
      "vider",
      0.0125
    ],
    [
      "liquider",
      0.0125
    ],
    [
      "extenuer",
      0.0125
    ],
    [
      "balayer",
      0.0125
    ],
    [
      "etouffer",
      0.01
    ],
    [
      "vaincre",
      0.01
    ],
    [
      "rompre",
      0.01
    ],
    [
      "engloutir",
      0.01
    ],
    [
      "dissiper",
      0.01
    ],
    [
      "annuler",
      0.01
    ],
    [
      "assommer",
      0.01
    ],
    [
      "terrasser",
      0.01
    ],
    [
      "enlever",
      0.0075
    ],
    [
      "dissoudre",
      0.0075
    ],
    [
      "consumer",
      0.0075
    ],
    [
      "confondre",
      0.0075
    ],
    [
      "absorber",
      0.0075
    ],
    [
      "pulveriser",
      0.005
    ],
    [
      "emporter",
      0.005
    ],
    [
      "battre",
      0.005
    ],
    [
      "aplatir",
      0.005
    ],
    [
      "eteindre",
      0.005
    ],
    [
      "resilier",
      0.005
    ],
    [
      "paralyser",
      0.005
    ],
    [
      "gacher",
      0.005
    ],
    [
      "faucher",
      0.005
    ],
    [
      "exterminer",
      0.005
    ],
    [
      "exceder",
      0.005
    ],
    [
      "devorer",
      0.005
    ],
    [
      "demanteler",
      0.005
    ],
    [
      "tarir",
      0.0025
    ],
    [
      "harasser",
      0.0025
    ],
    [
      "abimer",
      0.0025
    ],
    [
      "ecrabouiller",
      0.0025
    ],
    [
      "triompher",
      0.0025
    ],
    [
      "surmener",
      0.0025
    ],
    [
      "submerger",
      0.0025
    ],
    [
      "saper",
      0.0025
    ],
    [
      "lever",
      0.0025
    ],
    [
      "fondre",
      0.0025
    ],
    [
      "finir",
      0.0025
    ],
    [
      "enterrer",
      0.0025
    ],
    [
      "consterner",
      0.0025
    ],
    [
      "atterrer",
      0.0025
    ],
    [
      "achever",
      0.0025
    ],
    [
      "refuter",
      0.0
    ],
    [
      "precipiter",
      0.0
    ],
    [
      "pomper",
      0.0
    ],
    [
      "neutraliser",
      0.0
    ],
    [
      "extirper",
      0.0
    ],
    [
      "demoraliser",
      0.0
    ],
    [
      "abroger",
      0.0
    ],
    [
      "ravager",
      0.0
    ],
    [
      "neantiser",
      0.0
    ],
    [
      "laminer",
      0.0
    ],
    [
      "effeuiller",
      0.0
    ],
    [
      "desintegrer",
      0.0
    ],
    [
      "decimer",
      0.0
    ],
    [
      "abaisser",
      0.0
    ],
    [
      "ecoeurer",
      0.0
    ]
  ],
  "dortoir": [
    [
      "chambre",
      0.3325
    ],
    [
      "chambree",
      0.3325
    ],
    [
      "dormitorium",
      0.3325
    ]
  ],
  "gare": [
    [
      "arret",
      0.18
    ],
    [
      "halte",
      0.18
    ],
    [
      "station",
      0.18
    ],
    [
      "abri",
      0.09
    ],
    [
      "attention",
      0.09
    ],
    [
      "aerogare",
      0.09
    ],
    [
      "depot",
      0.09
    ],
    [
      "embarcadere",
      0.09
    ]
  ],
  "rocher": [
    [
      "roche",
      0.2325
    ],
    [
      "ecueil",
      0.1525
    ],
    [
      "varappe",
      0.075
    ],
    [
      "roc",
      0.075
    ],
    [
      "pierre",
      0.075
    ],
    [
      "congolais",
      0.075
    ],
    [
      "brisant",
      0.075
    ],
    [
      "bloc",
      0.075
    ],
    [
      "banc",
      0.075
    ],
    [
      "etoc",
      0.075
    ]
  ],
  "accroche": [
    [
      "accroc",
      0.3325
    ],
    [
      "accrochage",
      0.3325
    ],
    [
      "difficulte",
      0.3325
    ]
  ],
  "accrocher": [
    [
      "prendre",
      0.095
    ],
    [
      "retenir",
      0.0625
    ],
    [
      "attacher",
      0.0575
    ],
    [
      "saisir",
      0.0575
    ],
    [
      "arreter",
      0.0475
    ],
    [
      "attraper",
      0.0475
    ],
    [
      "fixer",
      0.0475
    ],
    [
      "heurter",
      0.035
    ],
    [
      "agrafer",
      0.035
    ],
    [
      "suspendre",
      0.03
    ],
    [
      "tenir",
      0.02
    ],
    [
      "obtenir",
      0.02
    ],
    [
      "empoigner",
      0.02
    ],
    [
      "cramponner",
      0.02
    ],
    [
      "cogner",
      0.02
    ],
    [
      "capturer",
      0.02
    ],
    [
      "capter",
      0.02
    ],
    [
      "arrimer",
      0.02
    ],
    [
      "agripper",
      0.02
    ],
    [
      "epingler",
      0.015
    ],
    [
      "soutirer",
      0.015
    ],
    [
      "remporter",
      0.015
    ],
    [
      "pendre",
      0.015
    ],
    [
      "immobiliser",
      0.015
    ],
    [
      "harponner",
      0.015
    ],
    [
      "enlever",
      0.015
    ],
    [
      "accoster",
      0.015
    ],
    [
      "telescoper",
      0.01
    ],
    [
      "tamponner",
      0.01
    ],
    [
      "rencontrer",
      0.01
    ],
    [
      "pendiller",
      0.01
    ],
    [
      "importuner",
      0.01
    ],
    [
      "ferrer",
      0.01
    ],
    [
      "crocher",
      0.01
    ],
    [
      "bousculer",
      0.01
    ],
    [
      "bigorner",
      0.01
    ],
    [
      "extorquer",
      0.0025
    ],
    [
      "gratter",
      0.0025
    ],
    [
      "percher",
      0.0025
    ],
    [
      "rattacher",
      0.0025
    ],
    [
      "renverser",
      0.0025
    ],
    [
      "deplacer",
      0.0025
    ],
    [
      "dechirer",
      0.0025
    ],
    [
      "crocheter",
      0.0025
    ],
    [
      "appendre",
      0.0025
    ],
    [
      "accidenter",
      0.0025
    ],
    [
      "aborder",
      0.0025
    ],
    [
      "retarder",
      0.0025
    ]
  ],
  "priver": [
    [
      "depouiller",
      0.115
    ],
    [
      "enlever",
      0.1025
    ],
    [
      "frustrer",
      0.1025
    ],
    [
      "sevrer",
      0.1025
    ],
    [
      "oter",
      0.0675
    ],
    [
      "spolier",
      0.0575
    ],
    [
      "destituer",
      0.045
    ],
    [
      "deposseder",
      0.045
    ],
    [
      "retirer",
      0.045
    ],
    [
      "voler",
      0.0325
    ],
    [
      "revoquer",
      0.0325
    ],
    [
      "ravir",
      0.0325
    ],
    [
      "interdire",
      0.0325
    ],
    [
      "demunir",
      0.0225
    ],
    [
      "empecher",
      0.0225
    ],
    [
      "supprimer",
      0.0225
    ],
    [
      "detroner",
      0.01
    ],
    [
      "desheriter",
      0.01
    ],
    [
      "denuer",
      0.01
    ],
    [
      "brimer",
      0.01
    ],
    [
      "assujettir",
      0.01
    ],
    [
      "asservir",
      0.01
    ],
    [
      "apprivoiser",
      0.01
    ],
    [
      "appauvrir",
      0.01
    ],
    [
      "frauder",
      0.01
    ]
  ],
  "prive": [
    [
      "depouiller",
      0.115
    ],
    [
      "enlever",
      0.1025
    ],
    [
      "frustrer",
      0.1025
    ],
    [
      "sevrer",
      0.1025
    ],
    [
      "oter",
      0.0675
    ],
    [
      "spolier",
      0.0575
    ],
    [
      "destituer",
      0.045
    ],
    [
      "deposseder",
      0.045
    ],
    [
      "retirer",
      0.045
    ],
    [
      "voler",
      0.0325
    ],
    [
      "revoquer",
      0.0325
    ],
    [
      "ravir",
      0.0325
    ],
    [
      "interdire",
      0.0325
    ],
    [
      "demunir",
      0.0225
    ],
    [
      "empecher",
      0.0225
    ],
    [
      "supprimer",
      0.0225
    ],
    [
      "detroner",
      0.01
    ],
    [
      "desheriter",
      0.01
    ],
    [
      "denuer",
      0.01
    ],
    [
      "brimer",
      0.01
    ],
    [
      "assujettir",
      0.01
    ],
    [
      "asservir",
      0.01
    ],
    [
      "apprivoiser",
      0.01
    ],
    [
      "appauvrir",
      0.01
    ],
    [
      "frauder",
      0.01
    ]
  ],
  "ecoutant": [
    [
      "auditeur",
      1.0
    ]
  ],
  "barricade": [
    [
      "barrage",
      0.1575
    ],
    [
      "barriere",
      0.1375
    ],
    [
      "obstacle",
      0.1175
    ],
    [
      "abri",
      0.0975
    ],
    [
      "fermeture",
      0.0975
    ],
    [
      "arret",
      0.0775
    ],
    [
      "digue",
      0.0775
    ],
    [
      "ecran",
      0.0575
    ],
    [
      "cloture",
      0.0375
    ],
    [
      "obstruction",
      0.0375
    ],
    [
      "separation",
      0.0375
    ],
    [
      "empechement",
      0.0175
    ],
    [
      "retenue",
      0.0175
    ],
    [
      "retranchement",
      0.0175
    ]
  ],
  "barricader": [
    [
      "barrer",
      0.1825
    ],
    [
      "fermer",
      0.1625
    ],
    [
      "enfermer",
      0.06
    ],
    [
      "clore",
      0.06
    ],
    [
      "boucher",
      0.06
    ],
    [
      "bloquer",
      0.06
    ],
    [
      "arreter",
      0.06
    ],
    [
      "sequestrer",
      0.04
    ],
    [
      "retenir",
      0.04
    ],
    [
      "obstruer",
      0.04
    ],
    [
      "garder",
      0.04
    ],
    [
      "endiguer",
      0.04
    ],
    [
      "condamner",
      0.04
    ],
    [
      "bacler",
      0.02
    ],
    [
      "claustrer",
      0.02
    ],
    [
      "cloturer",
      0.02
    ],
    [
      "colmater",
      0.02
    ]
  ],
  "effluve": [
    [
      "emanation",
      0.2075
    ],
    [
      "exhalaison",
      0.1625
    ],
    [
      "odeur",
      0.115
    ],
    [
      "fumet",
      0.0925
    ],
    [
      "senteur",
      0.0675
    ],
    [
      "relent",
      0.045
    ],
    [
      "parfum",
      0.045
    ],
    [
      "miasme",
      0.045
    ],
    [
      "haleine",
      0.045
    ],
    [
      "effluence",
      0.045
    ],
    [
      "arome",
      0.0225
    ],
    [
      "degagement",
      0.0225
    ],
    [
      "fluide",
      0.0225
    ],
    [
      "gout",
      0.0225
    ],
    [
      "souffle",
      0.0225
    ]
  ],
  "muette": [
    [
      "silencieux",
      0.3325
    ],
    [
      "coi",
      0.11
    ],
    [
      "discret",
      0.11
    ],
    [
      "interdit",
      0.11
    ],
    [
      "interloque",
      0.11
    ],
    [
      "taciturne",
      0.11
    ]
  ],
  "muet": [
    [
      "silencieux",
      0.3325
    ],
    [
      "coi",
      0.11
    ],
    [
      "discret",
      0.11
    ],
    [
      "interdit",
      0.11
    ],
    [
      "interloque",
      0.11
    ],
    [
      "taciturne",
      0.11
    ]
  ],
  "kilometre": [
    [
      "borne",
      1.0
    ]
  ],
  "patrie": [
    [
      "pays",
      0.2225
    ],
    [
      "foyer",
      0.11
    ],
    [
      "nation",
      0.11
    ],
    [
      "etat",
      0.11
    ],
    [
      "sol",
      0.055
    ],
    [
      "metropole",
      0.055
    ],
    [
      "mere",
      0.055
    ],
    [
      "milieu",
      0.055
    ],
    [
      "famille",
      0.055
    ],
    [
      "communaute",
      0.055
    ],
    [
      "cite",
      0.055
    ],
    [
      "terre",
      0.055
    ]
  ],
  "humilite": [
    [
      "bassesse",
      0.085
    ],
    [
      "honte",
      0.085
    ],
    [
      "servilite",
      0.085
    ],
    [
      "abaissement",
      0.0675
    ],
    [
      "modestie",
      0.0675
    ],
    [
      "reserve",
      0.05
    ],
    [
      "platitude",
      0.05
    ],
    [
      "petitesse",
      0.05
    ],
    [
      "effacement",
      0.05
    ],
    [
      "deference",
      0.05
    ],
    [
      "timidite",
      0.0325
    ],
    [
      "soumission",
      0.0325
    ],
    [
      "respect",
      0.0325
    ],
    [
      "ombre",
      0.0325
    ],
    [
      "obsequiosite",
      0.0325
    ],
    [
      "obscurite",
      0.0325
    ],
    [
      "asservissement",
      0.0325
    ],
    [
      "aneantissement",
      0.0325
    ],
    [
      "abnegation",
      0.015
    ],
    [
      "componction",
      0.015
    ],
    [
      "douceur",
      0.015
    ],
    [
      "humiliation",
      0.015
    ],
    [
      "simplicite",
      0.015
    ]
  ],
  "resolution": [
    [
      "volonte",
      0.07
    ],
    [
      "fermete",
      0.05
    ],
    [
      "decision",
      0.0475
    ],
    [
      "energie",
      0.0475
    ],
    [
      "courage",
      0.0375
    ],
    [
      "fin",
      0.035
    ],
    [
      "dessein",
      0.0325
    ],
    [
      "determination",
      0.0275
    ],
    [
      "caractere",
      0.025
    ],
    [
      "intention",
      0.025
    ],
    [
      "solution",
      0.0225
    ],
    [
      "ressort",
      0.02
    ],
    [
      "denouement",
      0.02
    ],
    [
      "annulation",
      0.02
    ],
    [
      "conclusion",
      0.0175
    ],
    [
      "tenacite",
      0.015
    ],
    [
      "solidite",
      0.015
    ],
    [
      "propos",
      0.015
    ],
    [
      "destruction",
      0.015
    ],
    [
      "but",
      0.015
    ],
    [
      "parti",
      0.0125
    ],
    [
      "hardiesse",
      0.0125
    ],
    [
      "desir",
      0.0125
    ],
    [
      "dissolution",
      0.0125
    ],
    [
      "audace",
      0.0125
    ],
    [
      "achevement",
      0.0125
    ],
    [
      "terme",
      0.01
    ],
    [
      "proposition",
      0.01
    ],
    [
      "projet",
      0.01
    ],
    [
      "opiniatrete",
      0.01
    ],
    [
      "division",
      0.01
    ],
    [
      "disposition",
      0.01
    ],
    [
      "cran",
      0.01
    ],
    [
      "convention",
      0.01
    ],
    [
      "abolition",
      0.01
    ],
    [
      "renvoi",
      0.0075
    ],
    [
      "resiliation",
      0.0075
    ],
    [
      "resultat",
      0.0075
    ],
    [
      "separation",
      0.0075
    ],
    [
      "traite",
      0.0075
    ],
    [
      "temerite",
      0.0075
    ],
    [
      "queue",
      0.0075
    ],
    [
      "obstination",
      0.0075
    ],
    [
      "bout",
      0.0075
    ],
    [
      "conseil",
      0.0075
    ],
    [
      "constance",
      0.0075
    ],
    [
      "disparition",
      0.0075
    ],
    [
      "decomposition",
      0.0075
    ],
    [
      "entetement",
      0.0075
    ],
    [
      "vouloir",
      0.005
    ],
    [
      "situation",
      0.005
    ],
    [
      "revocation",
      0.005
    ],
    [
      "rescision",
      0.005
    ],
    [
      "position",
      0.005
    ],
    [
      "initiative",
      0.005
    ],
    [
      "extremite",
      0.005
    ],
    [
      "exigence",
      0.005
    ],
    [
      "distinction",
      0.005
    ],
    [
      "diminution",
      0.005
    ],
    [
      "coda",
      0.005
    ],
    [
      "redhibition",
      0.0025
    ],
    [
      "reduction",
      0.0025
    ],
    [
      "resolvance",
      0.0025
    ],
    [
      "resorption",
      0.0025
    ],
    [
      "souhait",
      0.0025
    ],
    [
      "transformation",
      0.0025
    ],
    [
      "voeu",
      0.0025
    ],
    [
      "volition",
      0.0025
    ],
    [
      "relachement",
      0.0025
    ],
    [
      "protocole",
      0.0025
    ],
    [
      "analyse",
      0.0025
    ],
    [
      "choix",
      0.0025
    ],
    [
      "clef",
      0.0025
    ],
    [
      "discrimination",
      0.0025
    ],
    [
      "deliberation",
      0.0025
    ],
    [
      "operation",
      0.0025
    ],
    [
      "pacte",
      0.0025
    ],
    [
      "programme",
      0.0025
    ],
    [
      "epilogue",
      0.0025
    ]
  ],
  "glisse": [
    [
      "glissement",
      1.0
    ]
  ],
  "divan": [
    [
      "canape",
      0.25
    ],
    [
      "sofa",
      0.25
    ],
    [
      "assemblee",
      0.125
    ],
    [
      "conseil",
      0.125
    ],
    [
      "lit",
      0.125
    ],
    [
      "siege",
      0.125
    ]
  ],
  "cuisse": [
    [
      "cuissot",
      0.125
    ],
    [
      "gigot",
      0.125
    ],
    [
      "gigue",
      0.125
    ],
    [
      "jambe",
      0.125
    ],
    [
      "pilon",
      0.0625
    ],
    [
      "jambon",
      0.0625
    ],
    [
      "fesse",
      0.0625
    ],
    [
      "culotte",
      0.0625
    ],
    [
      "cul",
      0.0625
    ],
    [
      "cuisseau",
      0.0625
    ],
    [
      "baron",
      0.0625
    ],
    [
      "quasi",
      0.0625
    ]
  ],
  "soupcon": [
    [
      "ombre",
      0.1325
    ],
    [
      "grain",
      0.0825
    ],
    [
      "peu",
      0.0825
    ],
    [
      "idee",
      0.065
    ],
    [
      "pointe",
      0.065
    ],
    [
      "goutte",
      0.0475
    ],
    [
      "defiance",
      0.0475
    ],
    [
      "doute",
      0.0475
    ],
    [
      "apparence",
      0.0475
    ],
    [
      "teinte",
      0.0325
    ],
    [
      "semblant",
      0.0325
    ],
    [
      "parcelle",
      0.0325
    ],
    [
      "opinion",
      0.0325
    ],
    [
      "ombrage",
      0.0325
    ],
    [
      "nuance",
      0.0325
    ],
    [
      "mefiance",
      0.0325
    ],
    [
      "larme",
      0.0325
    ],
    [
      "suspicion",
      0.015
    ],
    [
      "simulacre",
      0.015
    ],
    [
      "nuage",
      0.015
    ],
    [
      "croyance",
      0.015
    ],
    [
      "crainte",
      0.015
    ],
    [
      "conjecture",
      0.015
    ]
  ],
  "sophistiquer": [
    [
      "alterer",
      0.1525
    ],
    [
      "corrompre",
      0.1525
    ],
    [
      "denaturer",
      0.1525
    ],
    [
      "frelater",
      0.1525
    ],
    [
      "falsifier",
      0.075
    ],
    [
      "gater",
      0.075
    ],
    [
      "quintessencier",
      0.075
    ],
    [
      "raisonner",
      0.075
    ],
    [
      "subtiliser",
      0.075
    ]
  ],
  "sophistique": [
    [
      "alterer",
      0.1525
    ],
    [
      "corrompre",
      0.1525
    ],
    [
      "denaturer",
      0.1525
    ],
    [
      "frelater",
      0.1525
    ],
    [
      "falsifier",
      0.075
    ],
    [
      "gater",
      0.075
    ],
    [
      "quintessencier",
      0.075
    ],
    [
      "raisonner",
      0.075
    ],
    [
      "subtiliser",
      0.075
    ]
  ],
  "college": [
    [
      "ecole",
      0.17
    ],
    [
      "lycee",
      0.145
    ],
    [
      "boite",
      0.0975
    ],
    [
      "institut",
      0.0725
    ],
    [
      "institution",
      0.0725
    ],
    [
      "pension",
      0.0475
    ],
    [
      "gymnase",
      0.0475
    ],
    [
      "corps",
      0.0475
    ],
    [
      "academie",
      0.0475
    ],
    [
      "prison",
      0.0225
    ],
    [
      "faculte",
      0.0225
    ],
    [
      "corporation",
      0.0225
    ],
    [
      "compagnie",
      0.0225
    ],
    [
      "chapitre",
      0.0225
    ],
    [
      "bureau",
      0.0225
    ],
    [
      "bahut",
      0.0225
    ],
    [
      "universite",
      0.0225
    ]
  ],
  "collegue": [
    [
      "associe",
      0.1925
    ],
    [
      "confrere",
      0.16
    ],
    [
      "acolyte",
      0.1275
    ],
    [
      "compagnon",
      0.1275
    ],
    [
      "camarade",
      0.095
    ],
    [
      "adjoint",
      0.095
    ],
    [
      "partenaire",
      0.0625
    ],
    [
      "collaborateur",
      0.03
    ],
    [
      "consoeur",
      0.03
    ],
    [
      "societaire",
      0.03
    ],
    [
      "egal",
      0.03
    ]
  ],
  "lope": [
    [
      "truqueur",
      1.0
    ]
  ],
  "manege": [
    [
      "intrigue",
      0.1125
    ],
    [
      "tripotage",
      0.09
    ],
    [
      "machination",
      0.0675
    ],
    [
      "ruse",
      0.0675
    ],
    [
      "menees",
      0.06
    ],
    [
      "manigance",
      0.06
    ],
    [
      "artifice",
      0.06
    ],
    [
      "astuce",
      0.0525
    ],
    [
      "complot",
      0.045
    ],
    [
      "trame",
      0.0375
    ],
    [
      "machiavelisme",
      0.0375
    ],
    [
      "agissements",
      0.0375
    ],
    [
      "combinaison",
      0.03
    ],
    [
      "detour",
      0.02
    ],
    [
      "feinte",
      0.02
    ],
    [
      "hypocrisie",
      0.02
    ],
    [
      "rouerie",
      0.0125
    ],
    [
      "politique",
      0.0125
    ],
    [
      "micmac",
      0.0125
    ],
    [
      "jeu",
      0.0125
    ],
    [
      "tripatouillage",
      0.005
    ],
    [
      "subterfuge",
      0.005
    ],
    [
      "roublardise",
      0.005
    ],
    [
      "reprise",
      0.005
    ],
    [
      "plan",
      0.005
    ],
    [
      "manoeuvres",
      0.005
    ],
    [
      "dressage",
      0.005
    ],
    [
      "comportement",
      0.005
    ],
    [
      "carrousel",
      0.005
    ],
    [
      "carriere",
      0.005
    ],
    [
      "agacerie",
      0.005
    ],
    [
      "equitation",
      0.005
    ]
  ],
  "dixieme": [
    [
      "decadi",
      0.3325
    ],
    [
      "decime",
      0.3325
    ],
    [
      "dime",
      0.3325
    ]
  ],
  "carnet": [
    [
      "registre",
      0.14
    ],
    [
      "cahier",
      0.1175
    ],
    [
      "calepin",
      0.1175
    ],
    [
      "agenda",
      0.0675
    ],
    [
      "livre",
      0.0675
    ],
    [
      "memento",
      0.0675
    ],
    [
      "memoire",
      0.0675
    ],
    [
      "repertoire",
      0.0675
    ],
    [
      "journal",
      0.045
    ],
    [
      "almanach",
      0.045
    ],
    [
      "album",
      0.0225
    ],
    [
      "bulletin",
      0.0225
    ],
    [
      "chequier",
      0.0225
    ],
    [
      "livret",
      0.0225
    ],
    [
      "memorandum",
      0.0225
    ],
    [
      "notes",
      0.0225
    ],
    [
      "triptyque",
      0.0225
    ],
    [
      "echeancier",
      0.0225
    ]
  ],
  "pissenlit": [],
  "allonger": [
    [
      "etendre",
      0.1025
    ],
    [
      "augmenter",
      0.0725
    ],
    [
      "prolonger",
      0.055
    ],
    [
      "rallonger",
      0.05
    ],
    [
      "developper",
      0.045
    ],
    [
      "pousser",
      0.04
    ],
    [
      "porter",
      0.035
    ],
    [
      "accroitre",
      0.0325
    ],
    [
      "donner",
      0.0325
    ],
    [
      "ficher",
      0.0275
    ],
    [
      "lancer",
      0.0275
    ],
    [
      "etirer",
      0.0275
    ],
    [
      "tirer",
      0.0225
    ],
    [
      "tendre",
      0.0225
    ],
    [
      "proroger",
      0.0225
    ],
    [
      "grandir",
      0.0175
    ],
    [
      "flanquer",
      0.0175
    ],
    [
      "envoyer",
      0.0175
    ],
    [
      "coller",
      0.0175
    ],
    [
      "agrandir",
      0.0175
    ],
    [
      "eterniser",
      0.0125
    ],
    [
      "foutre",
      0.0125
    ],
    [
      "deployer",
      0.0125
    ],
    [
      "distendre",
      0.0125
    ],
    [
      "continuer",
      0.0125
    ],
    [
      "avancer",
      0.0125
    ],
    [
      "ajouter",
      0.0125
    ],
    [
      "aggraver",
      0.0125
    ],
    [
      "temporiser",
      0.0075
    ],
    [
      "retarder",
      0.0075
    ],
    [
      "repousser",
      0.0075
    ],
    [
      "remettre",
      0.0075
    ],
    [
      "perpetuer",
      0.0075
    ],
    [
      "payer",
      0.0075
    ],
    [
      "fourrer",
      0.0075
    ],
    [
      "croitre",
      0.0075
    ],
    [
      "coucher",
      0.0075
    ],
    [
      "assener",
      0.0075
    ],
    [
      "additionner",
      0.0075
    ],
    [
      "tuer",
      0.0025
    ],
    [
      "eclaircir",
      0.0025
    ],
    [
      "miser",
      0.0025
    ],
    [
      "detirer",
      0.0025
    ],
    [
      "diluer",
      0.0025
    ],
    [
      "baptiser",
      0.0025
    ],
    [
      "affiner",
      0.0025
    ],
    [
      "affiler",
      0.0025
    ],
    [
      "elonger",
      0.0025
    ]
  ],
  "allonge": [
    [
      "ajoutage",
      0.15
    ],
    [
      "rallonge",
      0.15
    ],
    [
      "ajouture",
      0.1
    ],
    [
      "allongement",
      0.1
    ],
    [
      "supplement",
      0.1
    ],
    [
      "punch",
      0.05
    ],
    [
      "poing",
      0.05
    ],
    [
      "garde",
      0.05
    ],
    [
      "frappe",
      0.05
    ],
    [
      "bras",
      0.05
    ],
    [
      "attaque",
      0.05
    ],
    [
      "adjonction",
      0.05
    ],
    [
      "riposte",
      0.05
    ]
  ],
  "cheminer": [
    [
      "marcher",
      0.2075
    ],
    [
      "aller",
      0.165
    ],
    [
      "s'acheminer",
      0.0825
    ],
    [
      "progresser",
      0.0825
    ],
    [
      "avancer",
      0.0825
    ],
    [
      "s'allonger",
      0.04
    ],
    [
      "trimer",
      0.04
    ]
  ],
  "cheminee": [
    [
      "marcher",
      0.2075
    ],
    [
      "aller",
      0.165
    ],
    [
      "s'acheminer",
      0.0825
    ],
    [
      "progresser",
      0.0825
    ],
    [
      "avancer",
      0.0825
    ],
    [
      "s'allonger",
      0.04
    ],
    [
      "trimer",
      0.04
    ]
  ],
  "assombrir": [
    [
      "obscurcir",
      0.1425
    ],
    [
      "attrister",
      0.07
    ],
    [
      "brunir",
      0.07
    ],
    [
      "chagriner",
      0.07
    ],
    [
      "navrer",
      0.07
    ],
    [
      "peiner",
      0.07
    ],
    [
      "peser",
      0.07
    ],
    [
      "ennuyer",
      0.0475
    ],
    [
      "basaner",
      0.0475
    ],
    [
      "approfondir",
      0.0475
    ],
    [
      "affliger",
      0.0475
    ],
    [
      "rembrunir",
      0.0225
    ],
    [
      "noircir",
      0.0225
    ],
    [
      "menacer",
      0.0225
    ],
    [
      "foncer",
      0.0225
    ],
    [
      "entenebrer",
      0.0225
    ],
    [
      "embrunir",
      0.0225
    ],
    [
      "embrumer",
      0.0225
    ],
    [
      "bistrer",
      0.0225
    ],
    [
      "aigrir",
      0.0225
    ],
    [
      "eteindre",
      0.0225
    ]
  ],
  "detendre": [
    [
      "apaiser",
      0.12
    ],
    [
      "relacher",
      0.12
    ],
    [
      "calmer",
      0.08
    ],
    [
      "delasser",
      0.08
    ],
    [
      "lacher",
      0.08
    ],
    [
      "detirer",
      0.04
    ],
    [
      "relaxer",
      0.04
    ],
    [
      "reposer",
      0.04
    ],
    [
      "soulager",
      0.04
    ],
    [
      "egayer",
      0.04
    ],
    [
      "desenerver",
      0.04
    ],
    [
      "decrisper",
      0.04
    ],
    [
      "decontracter",
      0.04
    ],
    [
      "decompresser",
      0.04
    ],
    [
      "debander",
      0.04
    ],
    [
      "ameliorer",
      0.04
    ],
    [
      "alanguir",
      0.04
    ],
    [
      "etendre",
      0.04
    ]
  ],
  "arrogant": [
    [
      "fier",
      0.0925
    ],
    [
      "orgueilleux",
      0.0875
    ],
    [
      "hautain",
      0.06
    ],
    [
      "insolent",
      0.06
    ],
    [
      "superbe",
      0.0575
    ],
    [
      "pretentieux",
      0.0525
    ],
    [
      "suffisant",
      0.0525
    ],
    [
      "outrecuidant",
      0.0475
    ],
    [
      "fat",
      0.0475
    ],
    [
      "dedaigneux",
      0.0425
    ],
    [
      "impertinent",
      0.03
    ],
    [
      "vaniteux",
      0.03
    ],
    [
      "hardi",
      0.025
    ],
    [
      "rencheri",
      0.025
    ],
    [
      "rogue",
      0.025
    ],
    [
      "superieur",
      0.025
    ],
    [
      "important",
      0.02
    ],
    [
      "haut",
      0.02
    ],
    [
      "audacieux",
      0.02
    ],
    [
      "becheur",
      0.015
    ],
    [
      "meprisant",
      0.015
    ],
    [
      "presomptueux",
      0.015
    ],
    [
      "sot",
      0.015
    ],
    [
      "cavalier",
      0.0125
    ],
    [
      "inabordable",
      0.0075
    ],
    [
      "impudent",
      0.0075
    ],
    [
      "condescendant",
      0.0075
    ],
    [
      "blessant",
      0.0075
    ],
    [
      "altier",
      0.0025
    ],
    [
      "desinvolte",
      0.0025
    ],
    [
      "faraud",
      0.0025
    ],
    [
      "insultant",
      0.0025
    ],
    [
      "provocant",
      0.0025
    ],
    [
      "sourcilleux",
      0.0025
    ]
  ],
  "demenager": [
    [
      "deloger",
      0.1075
    ],
    [
      "partir",
      0.1075
    ],
    [
      "deplacer",
      0.07
    ],
    [
      "quitter",
      0.07
    ],
    [
      "vider",
      0.07
    ],
    [
      "enlever",
      0.0525
    ],
    [
      "deguerpir",
      0.0525
    ],
    [
      "changer",
      0.0525
    ],
    [
      "abandonner",
      0.0525
    ],
    [
      "transporter",
      0.035
    ],
    [
      "radoter",
      0.035
    ],
    [
      "deranger",
      0.035
    ],
    [
      "deraisonner",
      0.035
    ],
    [
      "divaguer",
      0.035
    ],
    [
      "filer",
      0.015
    ],
    [
      "extravaguer",
      0.015
    ],
    [
      "derailler",
      0.015
    ],
    [
      "demeubler",
      0.015
    ],
    [
      "degarnir",
      0.015
    ],
    [
      "chasser",
      0.015
    ]
  ],
  "bricolage": [
    [
      "alteration",
      0.2
    ],
    [
      "bricole",
      0.2
    ],
    [
      "commerce",
      0.2
    ],
    [
      "trafic",
      0.2
    ],
    [
      "travail",
      0.2
    ]
  ],
  "racolage": [
    [
      "retape",
      0.25
    ],
    [
      "embauchage",
      0.125
    ],
    [
      "enrolement",
      0.125
    ],
    [
      "prostitution",
      0.125
    ],
    [
      "rabattage",
      0.125
    ],
    [
      "raccrochage",
      0.125
    ],
    [
      "recrutement",
      0.125
    ]
  ],
  "ferment": [
    [
      "germe",
      0.165
    ],
    [
      "cause",
      0.1175
    ],
    [
      "origine",
      0.1175
    ],
    [
      "source",
      0.095
    ],
    [
      "principe",
      0.07
    ],
    [
      "semence",
      0.0475
    ],
    [
      "levure",
      0.0475
    ],
    [
      "levain",
      0.0475
    ],
    [
      "racine",
      0.0225
    ],
    [
      "mere",
      0.0225
    ],
    [
      "moisissure",
      0.0225
    ],
    [
      "microcoque",
      0.0225
    ],
    [
      "microbe",
      0.0225
    ],
    [
      "enzyme",
      0.0225
    ],
    [
      "diastase",
      0.0225
    ],
    [
      "brandon",
      0.0225
    ],
    [
      "bacterie",
      0.0225
    ],
    [
      "bacille",
      0.0225
    ],
    [
      "agent",
      0.0225
    ],
    [
      "zymase",
      0.0225
    ]
  ],
  "recre": [],
  "maternite": [
    [
      "procreation",
      0.25
    ],
    [
      "enfantement",
      0.125
    ],
    [
      "engendrement",
      0.125
    ],
    [
      "generation",
      0.125
    ],
    [
      "portrait",
      0.06
    ],
    [
      "peinture",
      0.06
    ],
    [
      "hopital",
      0.06
    ],
    [
      "grossesse",
      0.06
    ],
    [
      "accouchement",
      0.06
    ],
    [
      "reproduction",
      0.06
    ]
  ],
  "profondeur": [
    [
      "grandeur",
      0.0725
    ],
    [
      "dimension",
      0.06
    ],
    [
      "force",
      0.0525
    ],
    [
      "fond",
      0.0475
    ],
    [
      "etendue",
      0.04
    ],
    [
      "puissance",
      0.035
    ],
    [
      "violence",
      0.03
    ],
    [
      "solidite",
      0.03
    ],
    [
      "secret",
      0.03
    ],
    [
      "capacite",
      0.03
    ],
    [
      "elevation",
      0.0225
    ],
    [
      "vivacite",
      0.0225
    ],
    [
      "vigueur",
      0.0225
    ],
    [
      "intensite",
      0.0225
    ],
    [
      "intelligence",
      0.0225
    ],
    [
      "fermete",
      0.0225
    ],
    [
      "distance",
      0.0225
    ],
    [
      "constance",
      0.0225
    ],
    [
      "abime",
      0.0225
    ],
    [
      "largeur",
      0.0175
    ],
    [
      "immensite",
      0.0175
    ],
    [
      "beaute",
      0.0175
    ],
    [
      "acuite",
      0.0175
    ],
    [
      "epaisseur",
      0.01
    ],
    [
      "stabilite",
      0.01
    ],
    [
      "science",
      0.01
    ],
    [
      "penetration",
      0.01
    ],
    [
      "perspective",
      0.01
    ],
    [
      "mystere",
      0.01
    ],
    [
      "lointain",
      0.01
    ],
    [
      "interieur",
      0.01
    ],
    [
      "abysse",
      0.01
    ],
    [
      "ardeur",
      0.01
    ],
    [
      "creux",
      0.01
    ],
    [
      "enfoncement",
      0.01
    ],
    [
      "hauteur",
      0.01
    ],
    [
      "importance",
      0.01
    ],
    [
      "mesure",
      0.005
    ],
    [
      "permanence",
      0.005
    ],
    [
      "perspicacite",
      0.005
    ],
    [
      "plenitude",
      0.005
    ],
    [
      "richesse",
      0.005
    ],
    [
      "sagacite",
      0.005
    ],
    [
      "trefonds",
      0.005
    ],
    [
      "longueur",
      0.005
    ],
    [
      "interiorite",
      0.005
    ],
    [
      "intimite",
      0.005
    ],
    [
      "impenetrabilite",
      0.005
    ],
    [
      "fidelite",
      0.005
    ],
    [
      "extremite",
      0.005
    ],
    [
      "extase",
      0.005
    ],
    [
      "difficulte",
      0.005
    ],
    [
      "authenticite",
      0.005
    ],
    [
      "abstraction",
      0.005
    ],
    [
      "esoterisme",
      0.005
    ]
  ],
  "monteur": [
    [
      "assembleur",
      1.0
    ]
  ],
  "cherubin": [
    [
      "enfant",
      0.4
    ],
    [
      "ange",
      0.2
    ],
    [
      "angelot",
      0.2
    ],
    [
      "bambin",
      0.2
    ]
  ],
  "megalo": [],
  "afficher": [
    [
      "montrer",
      0.1425
    ],
    [
      "reveler",
      0.1275
    ],
    [
      "manifester",
      0.0525
    ],
    [
      "exposer",
      0.045
    ],
    [
      "temoigner",
      0.0375
    ],
    [
      "marquer",
      0.0375
    ],
    [
      "indiquer",
      0.0375
    ],
    [
      "declarer",
      0.0375
    ],
    [
      "etaler",
      0.035
    ],
    [
      "presenter",
      0.0325
    ],
    [
      "exprimer",
      0.0275
    ],
    [
      "signifier",
      0.0225
    ],
    [
      "exhiber",
      0.0225
    ],
    [
      "deployer",
      0.0225
    ],
    [
      "annoncer",
      0.02
    ],
    [
      "prouver",
      0.02
    ],
    [
      "porter",
      0.0175
    ],
    [
      "publier",
      0.0175
    ],
    [
      "decouvrir",
      0.015
    ],
    [
      "paraitre",
      0.015
    ],
    [
      "produire",
      0.0125
    ],
    [
      "attester",
      0.0125
    ],
    [
      "affecter",
      0.0125
    ],
    [
      "affirmer",
      0.01
    ],
    [
      "developper",
      0.01
    ],
    [
      "representer",
      0.01
    ],
    [
      "prodiguer",
      0.01
    ],
    [
      "offrir",
      0.0075
    ],
    [
      "mettre",
      0.0075
    ],
    [
      "inscrire",
      0.0075
    ],
    [
      "devoiler",
      0.0075
    ],
    [
      "demontrer",
      0.0075
    ],
    [
      "simuler",
      0.005
    ],
    [
      "respirer",
      0.005
    ],
    [
      "accuser",
      0.0025
    ],
    [
      "arborer",
      0.0025
    ],
    [
      "decrire",
      0.0025
    ],
    [
      "exterioriser",
      0.0025
    ],
    [
      "visualiser",
      0.0
    ],
    [
      "placarder",
      0.0
    ],
    [
      "denuder",
      0.0
    ],
    [
      "deballer",
      0.0
    ],
    [
      "accentuer",
      0.0
    ],
    [
      "evoquer",
      0.0
    ]
  ],
  "frequentation": [
    [
      "liaison",
      0.105
    ],
    [
      "relation",
      0.0925
    ],
    [
      "commerce",
      0.07
    ],
    [
      "rapport",
      0.0575
    ],
    [
      "accointance",
      0.045
    ],
    [
      "contact",
      0.045
    ],
    [
      "intimite",
      0.045
    ],
    [
      "pratique",
      0.045
    ],
    [
      "usage",
      0.035
    ],
    [
      "experience",
      0.035
    ],
    [
      "connaissance",
      0.035
    ],
    [
      "societe",
      0.0225
    ],
    [
      "lien",
      0.0225
    ],
    [
      "habitude",
      0.0225
    ],
    [
      "familiarite",
      0.0225
    ],
    [
      "correspondance",
      0.0225
    ],
    [
      "communication",
      0.0225
    ],
    [
      "attache",
      0.0225
    ],
    [
      "approche",
      0.0225
    ],
    [
      "amour",
      0.0225
    ],
    [
      "accointage",
      0.0225
    ],
    [
      "entourage",
      0.01
    ],
    [
      "exactitude",
      0.01
    ],
    [
      "frottement",
      0.01
    ],
    [
      "ponctualite",
      0.01
    ],
    [
      "compagnie",
      0.01
    ],
    [
      "beguin",
      0.01
    ],
    [
      "assiduite",
      0.01
    ],
    [
      "amourette",
      0.01
    ],
    [
      "abord",
      0.01
    ],
    [
      "regularite",
      0.01
    ]
  ],
  "resultat": [
    [
      "consequence",
      0.0775
    ],
    [
      "effet",
      0.0775
    ],
    [
      "fin",
      0.0775
    ],
    [
      "fruit",
      0.07
    ],
    [
      "conclusion",
      0.0525
    ],
    [
      "solution",
      0.0525
    ],
    [
      "suite",
      0.0525
    ],
    [
      "produit",
      0.0375
    ],
    [
      "denouement",
      0.0375
    ],
    [
      "achevement",
      0.0375
    ],
    [
      "aboutissement",
      0.0375
    ],
    [
      "issue",
      0.03
    ],
    [
      "evenement",
      0.03
    ],
    [
      "resolution",
      0.0225
    ],
    [
      "reste",
      0.0225
    ],
    [
      "marque",
      0.0225
    ],
    [
      "but",
      0.0225
    ],
    [
      "terminaison",
      0.015
    ],
    [
      "succes",
      0.015
    ],
    [
      "reponse",
      0.015
    ],
    [
      "contrecoup",
      0.015
    ],
    [
      "benefice",
      0.015
    ],
    [
      "accident",
      0.015
    ],
    [
      "quotient",
      0.005
    ],
    [
      "rancon",
      0.005
    ],
    [
      "resultante",
      0.005
    ],
    [
      "reussite",
      0.005
    ],
    [
      "score",
      0.005
    ],
    [
      "somme",
      0.005
    ],
    [
      "production",
      0.005
    ],
    [
      "portee",
      0.005
    ],
    [
      "fils",
      0.005
    ],
    [
      "fille",
      0.005
    ],
    [
      "decision",
      0.005
    ],
    [
      "conquete",
      0.005
    ],
    [
      "bilan",
      0.005
    ],
    [
      "accompagnement",
      0.005
    ],
    [
      "aboutissant",
      0.005
    ],
    [
      "total",
      0.005
    ]
  ],
  "avide": [
    [
      "cupide",
      0.0925
    ],
    [
      "insatiable",
      0.07
    ],
    [
      "ardent",
      0.06
    ],
    [
      "interesse",
      0.06
    ],
    [
      "vorace",
      0.06
    ],
    [
      "rapace",
      0.05
    ],
    [
      "passionne",
      0.05
    ],
    [
      "affame",
      0.05
    ],
    [
      "amoureux",
      0.04
    ],
    [
      "convoiteux",
      0.04
    ],
    [
      "desireux",
      0.04
    ],
    [
      "apre",
      0.03
    ],
    [
      "impatient",
      0.03
    ],
    [
      "haletant",
      0.03
    ],
    [
      "gourmand",
      0.03
    ],
    [
      "assoiffe",
      0.03
    ],
    [
      "altere",
      0.03
    ],
    [
      "glouton",
      0.02
    ],
    [
      "envieux",
      0.02
    ],
    [
      "devorant",
      0.02
    ],
    [
      "curieux",
      0.02
    ],
    [
      "avare",
      0.02
    ],
    [
      "mercenaire",
      0.0075
    ],
    [
      "goulu",
      0.0075
    ],
    [
      "friand",
      0.0075
    ],
    [
      "empresse",
      0.0075
    ],
    [
      "concupiscent",
      0.0075
    ],
    [
      "beant",
      0.0075
    ],
    [
      "anxieux",
      0.0075
    ],
    [
      "epris",
      0.0075
    ]
  ],
  "pyramide": [
    [
      "amas",
      0.25
    ],
    [
      "entassement",
      0.25
    ],
    [
      "tetraedre",
      0.25
    ],
    [
      "echafaudage",
      0.25
    ]
  ],
  "banal": [
    [
      "quelconque",
      0.105
    ],
    [
      "insignifiant",
      0.095
    ],
    [
      "commun",
      0.085
    ],
    [
      "ordinaire",
      0.08
    ],
    [
      "plat",
      0.06
    ],
    [
      "fade",
      0.055
    ],
    [
      "vulgaire",
      0.0475
    ],
    [
      "mediocre",
      0.045
    ],
    [
      "courant",
      0.035
    ],
    [
      "vil",
      0.0275
    ],
    [
      "trivial",
      0.0275
    ],
    [
      "anodin",
      0.0225
    ],
    [
      "insipide",
      0.0225
    ],
    [
      "rebattu",
      0.0175
    ],
    [
      "prosaique",
      0.0175
    ],
    [
      "petit",
      0.0175
    ],
    [
      "conventionnel",
      0.0175
    ],
    [
      "use",
      0.0125
    ],
    [
      "pauvre",
      0.0125
    ],
    [
      "neutre",
      0.0125
    ],
    [
      "moyen",
      0.0125
    ],
    [
      "ininteressant",
      0.0125
    ],
    [
      "indifferent",
      0.0125
    ],
    [
      "habituel",
      0.0125
    ],
    [
      "usuel",
      0.0075
    ],
    [
      "usage",
      0.0075
    ],
    [
      "rampant",
      0.0075
    ],
    [
      "facile",
      0.0075
    ],
    [
      "classique",
      0.0075
    ],
    [
      "quotidien",
      0.0025
    ],
    [
      "public",
      0.0025
    ],
    [
      "prudhommesque",
      0.0025
    ],
    [
      "impersonnel",
      0.0025
    ],
    [
      "efface",
      0.0025
    ],
    [
      "convenu",
      0.0025
    ],
    [
      "communal",
      0.0025
    ],
    [
      "battu",
      0.0025
    ],
    [
      "bateau",
      0.0025
    ],
    [
      "vieux",
      0.0025
    ]
  ],
  "denouement": [
    [
      "fin",
      0.185
    ],
    [
      "resolution",
      0.0975
    ],
    [
      "solution",
      0.0975
    ],
    [
      "conclusion",
      0.085
    ],
    [
      "terminaison",
      0.0725
    ],
    [
      "achevement",
      0.06
    ],
    [
      "bout",
      0.06
    ],
    [
      "resultat",
      0.06
    ],
    [
      "queue",
      0.0475
    ],
    [
      "extremite",
      0.0475
    ],
    [
      "issue",
      0.035
    ],
    [
      "terme",
      0.035
    ],
    [
      "evenement",
      0.0225
    ],
    [
      "sort",
      0.01
    ],
    [
      "peripetie",
      0.01
    ],
    [
      "fruit",
      0.01
    ],
    [
      "clef",
      0.01
    ],
    [
      "catastrophe",
      0.01
    ],
    [
      "epilogue",
      0.01
    ]
  ],
  "funeste": [
    [
      "mauvais",
      0.1025
    ],
    [
      "triste",
      0.08
    ],
    [
      "malheureux",
      0.0725
    ],
    [
      "nefaste",
      0.06
    ],
    [
      "pernicieux",
      0.0425
    ],
    [
      "dangereux",
      0.0375
    ],
    [
      "deplorable",
      0.0375
    ],
    [
      "sinistre",
      0.0375
    ],
    [
      "pitoyable",
      0.035
    ],
    [
      "nuisible",
      0.035
    ],
    [
      "fatal",
      0.0275
    ],
    [
      "facheux",
      0.0275
    ],
    [
      "lamentable",
      0.0275
    ],
    [
      "penible",
      0.0275
    ],
    [
      "desastreux",
      0.0225
    ],
    [
      "grave",
      0.0225
    ],
    [
      "mortel",
      0.02
    ],
    [
      "dommageable",
      0.02
    ],
    [
      "catastrophique",
      0.02
    ],
    [
      "affligeant",
      0.02
    ],
    [
      "prejudiciable",
      0.015
    ],
    [
      "navrant",
      0.015
    ],
    [
      "miserable",
      0.015
    ],
    [
      "calamiteux",
      0.015
    ],
    [
      "douloureux",
      0.0125
    ],
    [
      "desolant",
      0.0125
    ],
    [
      "nocif",
      0.0125
    ],
    [
      "sombre",
      0.0125
    ],
    [
      "lugubre",
      0.01
    ],
    [
      "contraire",
      0.01
    ],
    [
      "violent",
      0.005
    ],
    [
      "torturant",
      0.005
    ],
    [
      "regrettable",
      0.005
    ],
    [
      "meurtrier",
      0.005
    ],
    [
      "malsain",
      0.005
    ],
    [
      "funebre",
      0.005
    ],
    [
      "defavorable",
      0.005
    ],
    [
      "irreparable",
      0.0025
    ],
    [
      "tragique",
      0.0025
    ]
  ],
  "sot": [
    [
      "bete",
      0.12
    ],
    [
      "ballot",
      0.0625
    ],
    [
      "stupide",
      0.0575
    ],
    [
      "niais",
      0.055
    ],
    [
      "idiot",
      0.04
    ],
    [
      "beta",
      0.035
    ],
    [
      "imbecile",
      0.035
    ],
    [
      "absurde",
      0.025
    ],
    [
      "deconcerte",
      0.025
    ],
    [
      "balourd",
      0.0175
    ],
    [
      "ane",
      0.015
    ],
    [
      "cruche",
      0.015
    ],
    [
      "fat",
      0.015
    ],
    [
      "penaud",
      0.0125
    ],
    [
      "insense",
      0.0125
    ],
    [
      "gourde",
      0.0125
    ],
    [
      "confus",
      0.0125
    ],
    [
      "cretin",
      0.0125
    ],
    [
      "cornichon",
      0.0125
    ],
    [
      "deraisonnable",
      0.0125
    ],
    [
      "nigaud",
      0.01
    ],
    [
      "interdit",
      0.01
    ],
    [
      "inepte",
      0.01
    ],
    [
      "fou",
      0.01
    ],
    [
      "maladroit",
      0.01
    ],
    [
      "surpris",
      0.01
    ],
    [
      "buse",
      0.0075
    ],
    [
      "benet",
      0.0075
    ],
    [
      "abruti",
      0.0075
    ],
    [
      "deconfit",
      0.0075
    ],
    [
      "decontenance",
      0.0075
    ],
    [
      "ignorant",
      0.0075
    ],
    [
      "inintelligent",
      0.0075
    ],
    [
      "suffisant",
      0.0075
    ],
    [
      "pretentieux",
      0.005
    ],
    [
      "inconsequent",
      0.005
    ],
    [
      "incoherent",
      0.005
    ],
    [
      "godiche",
      0.005
    ],
    [
      "etourdi",
      0.005
    ],
    [
      "vaniteux",
      0.005
    ],
    [
      "quinaud",
      0.005
    ],
    [
      "orgueilleux",
      0.005
    ],
    [
      "malavise",
      0.005
    ],
    [
      "honteux",
      0.005
    ],
    [
      "dadais",
      0.005
    ],
    [
      "irrationnel",
      0.005
    ],
    [
      "extravagant",
      0.005
    ],
    [
      "corniaud",
      0.005
    ],
    [
      "andouille",
      0.005
    ],
    [
      "vain",
      0.0025
    ],
    [
      "trouble",
      0.0025
    ],
    [
      "saugrenu",
      0.0025
    ],
    [
      "ridicule",
      0.0025
    ],
    [
      "pantois",
      0.0025
    ],
    [
      "lourd",
      0.0025
    ],
    [
      "illogique",
      0.0025
    ],
    [
      "desoriente",
      0.0025
    ],
    [
      "arrogant",
      0.0025
    ],
    [
      "borne",
      0.0025
    ],
    [
      "con",
      0.0025
    ],
    [
      "confondu",
      0.0025
    ],
    [
      "desempare",
      0.0025
    ],
    [
      "etonne",
      0.0025
    ],
    [
      "satisfait",
      0.0025
    ],
    [
      "nul",
      0.0025
    ],
    [
      "jocrisse",
      0.0025
    ],
    [
      "infatue",
      0.0025
    ],
    [
      "ganache",
      0.0025
    ],
    [
      "deroute",
      0.0025
    ],
    [
      "demonte",
      0.0025
    ],
    [
      "couillon",
      0.0025
    ],
    [
      "bejaune",
      0.0025
    ],
    [
      "butor",
      0.0025
    ],
    [
      "pigeon",
      0.0
    ],
    [
      "panouille",
      0.0
    ],
    [
      "moule",
      0.0
    ],
    [
      "loufoque",
      0.0
    ],
    [
      "plat",
      0.0
    ],
    [
      "poire",
      0.0
    ],
    [
      "poseur",
      0.0
    ],
    [
      "pedant",
      0.0
    ],
    [
      "risible",
      0.0
    ],
    [
      "tourte",
      0.0
    ],
    [
      "irreverencieux",
      0.0
    ],
    [
      "incongru",
      0.0
    ],
    [
      "impertinent",
      0.0
    ],
    [
      "avantageux",
      0.0
    ],
    [
      "baudet",
      0.0
    ],
    [
      "bourrique",
      0.0
    ],
    [
      "content",
      0.0
    ],
    [
      "cruchon",
      0.0
    ],
    [
      "fanfaron",
      0.0
    ],
    [
      "facheux",
      0.0
    ],
    [
      "gourdiflot",
      0.0
    ],
    [
      "gene",
      0.0
    ],
    [
      "inquiet",
      0.0
    ],
    [
      "gourde",
      0.0
    ],
    [
      "fourneau",
      0.0
    ],
    [
      "fierot",
      0.0
    ],
    [
      "plastron",
      0.0
    ],
    [
      "pecore",
      0.0
    ],
    [
      "rodomont",
      0.0
    ],
    [
      "serin",
      0.0
    ],
    [
      "sosot",
      0.0
    ],
    [
      "enfantin",
      0.0
    ],
    [
      "desarconne",
      0.0
    ],
    [
      "affligeant",
      0.0
    ],
    [
      "badaud",
      0.0
    ],
    [
      "balluche",
      0.0
    ],
    [
      "balluchon",
      0.0
    ],
    [
      "bedole",
      0.0
    ],
    [
      "betasse",
      0.0
    ],
    [
      "claude",
      0.0
    ],
    [
      "dedaigneux",
      0.0
    ],
    [
      "defait",
      0.0
    ],
    [
      "deferre",
      0.0
    ],
    [
      "depayse",
      0.0
    ]
  ],
  "maigre": [
    [
      "pauvre",
      0.095
    ],
    [
      "petit",
      0.06
    ],
    [
      "faible",
      0.0425
    ],
    [
      "mince",
      0.0425
    ],
    [
      "mesquin",
      0.04
    ],
    [
      "decharne",
      0.0325
    ],
    [
      "chetif",
      0.0275
    ],
    [
      "mediocre",
      0.0225
    ],
    [
      "etique",
      0.0225
    ],
    [
      "emacie",
      0.02
    ],
    [
      "sec",
      0.02
    ],
    [
      "pietre",
      0.02
    ],
    [
      "grele",
      0.02
    ],
    [
      "fluet",
      0.02
    ],
    [
      "squelettique",
      0.0175
    ],
    [
      "etroit",
      0.015
    ],
    [
      "reduit",
      0.015
    ],
    [
      "modeste",
      0.015
    ],
    [
      "maigri",
      0.015
    ],
    [
      "juste",
      0.015
    ],
    [
      "insuffisant",
      0.015
    ],
    [
      "gringalet",
      0.015
    ],
    [
      "delicat",
      0.015
    ],
    [
      "court",
      0.015
    ],
    [
      "aride",
      0.015
    ],
    [
      "etrique",
      0.0125
    ],
    [
      "svelte",
      0.0125
    ],
    [
      "riquiqui",
      0.0125
    ],
    [
      "parcimonieux",
      0.0125
    ],
    [
      "minable",
      0.0125
    ],
    [
      "miserable",
      0.01
    ],
    [
      "jeune",
      0.01
    ],
    [
      "amaigri",
      0.01
    ],
    [
      "sterile",
      0.0075
    ],
    [
      "rachitique",
      0.0075
    ],
    [
      "mechant",
      0.0075
    ],
    [
      "fin",
      0.0075
    ],
    [
      "efflanque",
      0.0075
    ],
    [
      "defait",
      0.0075
    ],
    [
      "chiche",
      0.0075
    ],
    [
      "secot",
      0.005
    ],
    [
      "squelette",
      0.005
    ],
    [
      "rabougri",
      0.005
    ],
    [
      "moyen",
      0.005
    ],
    [
      "modique",
      0.005
    ],
    [
      "maigrelet",
      0.005
    ],
    [
      "improductif",
      0.005
    ],
    [
      "have",
      0.005
    ],
    [
      "fusele",
      0.005
    ],
    [
      "desseche",
      0.005
    ],
    [
      "amenuise",
      0.005
    ],
    [
      "maigriot",
      0.0025
    ],
    [
      "ridicule",
      0.0025
    ],
    [
      "succinct",
      0.0025
    ],
    [
      "tire",
      0.0025
    ],
    [
      "maigrichon",
      0.0025
    ],
    [
      "ingrat",
      0.0025
    ],
    [
      "infertile",
      0.0025
    ],
    [
      "famelique",
      0.0025
    ],
    [
      "debile",
      0.0025
    ],
    [
      "cave",
      0.0025
    ],
    [
      "maigret",
      0.0
    ],
    [
      "infecond",
      0.0
    ],
    [
      "haridelle",
      0.0
    ],
    [
      "frugal",
      0.0
    ],
    [
      "momie",
      0.0
    ],
    [
      "osseux",
      0.0
    ],
    [
      "sciene",
      0.0
    ],
    [
      "spectre",
      0.0
    ],
    [
      "echalas",
      0.0
    ],
    [
      "echassier",
      0.0
    ],
    [
      "ecreme",
      0.0
    ],
    [
      "filiforme",
      0.0
    ],
    [
      "fantome",
      0.0
    ],
    [
      "aminci",
      0.0
    ],
    [
      "cachectique",
      0.0
    ],
    [
      "carcan",
      0.0
    ],
    [
      "carcasse",
      0.0
    ],
    [
      "clairseme",
      0.0
    ],
    [
      "cousu",
      0.0
    ],
    [
      "creuse",
      0.0
    ],
    [
      "creux",
      0.0
    ],
    [
      "diaphane",
      0.0
    ],
    [
      "debit",
      0.0
    ],
    [
      "decave",
      0.0
    ],
    [
      "decolle",
      0.0
    ],
    [
      "desosse",
      0.0
    ],
    [
      "abstinence",
      0.0
    ]
  ],
  "resume": [
    [
      "reduire",
      0.2125
    ],
    [
      "abreger",
      0.105
    ],
    [
      "condenser",
      0.105
    ],
    [
      "resserrer",
      0.07
    ],
    [
      "ramasser",
      0.07
    ],
    [
      "preciser",
      0.07
    ],
    [
      "diminuer",
      0.07
    ],
    [
      "analyser",
      0.07
    ],
    [
      "extraire",
      0.035
    ],
    [
      "reprendre",
      0.035
    ],
    [
      "recapituler",
      0.035
    ],
    [
      "schematiser",
      0.035
    ],
    [
      "synthetiser",
      0.035
    ],
    [
      "ecourter",
      0.035
    ]
  ],
  "soupir": [
    [
      "plainte",
      0.2
    ],
    [
      "souffle",
      0.2
    ],
    [
      "bruit",
      0.1
    ],
    [
      "esprit",
      0.1
    ],
    [
      "gemissement",
      0.1
    ],
    [
      "regret",
      0.1
    ],
    [
      "sanglot",
      0.1
    ],
    [
      "silence",
      0.1
    ]
  ],
  "sentence": [
    [
      "pensee",
      0.125
    ],
    [
      "maxime",
      0.0975
    ],
    [
      "parole",
      0.08
    ],
    [
      "aphorisme",
      0.0625
    ],
    [
      "dicton",
      0.0625
    ],
    [
      "apophtegme",
      0.0525
    ],
    [
      "jugement",
      0.0525
    ],
    [
      "decision",
      0.045
    ],
    [
      "proverbe",
      0.035
    ],
    [
      "formule",
      0.035
    ],
    [
      "adage",
      0.035
    ],
    [
      "devise",
      0.025
    ],
    [
      "expression",
      0.025
    ],
    [
      "phrase",
      0.025
    ],
    [
      "propos",
      0.025
    ],
    [
      "verite",
      0.0175
    ],
    [
      "precepte",
      0.0175
    ],
    [
      "mot",
      0.0175
    ],
    [
      "decret",
      0.0175
    ],
    [
      "dit",
      0.0175
    ],
    [
      "axiome",
      0.0175
    ],
    [
      "arret",
      0.0175
    ],
    [
      "remarque",
      0.0075
    ],
    [
      "ordonnance",
      0.0075
    ],
    [
      "ordalie",
      0.0075
    ],
    [
      "moralite",
      0.0075
    ],
    [
      "esquisse",
      0.0075
    ],
    [
      "condamnation",
      0.0075
    ],
    [
      "brocard",
      0.0075
    ],
    [
      "verdict",
      0.0075
    ]
  ],
  "nouer": [
    [
      "attacher",
      0.1225
    ],
    [
      "fixer",
      0.0725
    ],
    [
      "joindre",
      0.0725
    ],
    [
      "lier",
      0.0725
    ],
    [
      "tresser",
      0.0725
    ],
    [
      "etablir",
      0.0475
    ],
    [
      "tisser",
      0.0475
    ],
    [
      "preparer",
      0.0475
    ],
    [
      "monter",
      0.0475
    ],
    [
      "entrelacer",
      0.0475
    ],
    [
      "entortiller",
      0.0475
    ],
    [
      "combiner",
      0.0475
    ],
    [
      "arrimer",
      0.0475
    ],
    [
      "ourdir",
      0.0225
    ],
    [
      "manigancer",
      0.0225
    ],
    [
      "machiner",
      0.0225
    ],
    [
      "lacer",
      0.0225
    ],
    [
      "fermer",
      0.0225
    ],
    [
      "envelopper",
      0.0225
    ],
    [
      "contracter",
      0.0225
    ],
    [
      "tramer",
      0.0225
    ]
  ],
  "fard": [
    [
      "artifice",
      0.1
    ],
    [
      "feinte",
      0.1
    ],
    [
      "deguisement",
      0.075
    ],
    [
      "peinture",
      0.075
    ],
    [
      "mensonge",
      0.05
    ],
    [
      "maquillage",
      0.05
    ],
    [
      "grimace",
      0.05
    ],
    [
      "exterieur",
      0.05
    ],
    [
      "dissimulation",
      0.05
    ],
    [
      "couleur",
      0.05
    ],
    [
      "rougeur",
      0.025
    ],
    [
      "rouge",
      0.025
    ],
    [
      "poudre",
      0.025
    ],
    [
      "ornement",
      0.025
    ],
    [
      "grimage",
      0.025
    ],
    [
      "faux",
      0.025
    ],
    [
      "cosmetique",
      0.025
    ],
    [
      "brillant",
      0.025
    ],
    [
      "barbouillage",
      0.025
    ],
    [
      "badigeon",
      0.025
    ],
    [
      "art",
      0.025
    ]
  ],
  "serment": [
    [
      "engagement",
      0.2225
    ],
    [
      "promesse",
      0.2225
    ],
    [
      "jurement",
      0.11
    ],
    [
      "protestation",
      0.055
    ],
    [
      "parole",
      0.055
    ],
    [
      "obligation",
      0.055
    ],
    [
      "juron",
      0.055
    ],
    [
      "imprecation",
      0.055
    ],
    [
      "foi",
      0.055
    ],
    [
      "caution",
      0.055
    ],
    [
      "voeu",
      0.055
    ]
  ],
  "maquiller": [
    [
      "alterer",
      0.0975
    ],
    [
      "farder",
      0.0875
    ],
    [
      "deguiser",
      0.0775
    ],
    [
      "fausser",
      0.0775
    ],
    [
      "travestir",
      0.0775
    ],
    [
      "falsifier",
      0.0675
    ],
    [
      "frelater",
      0.0575
    ],
    [
      "truquer",
      0.0575
    ],
    [
      "denaturer",
      0.0475
    ],
    [
      "deformer",
      0.0475
    ],
    [
      "masquer",
      0.0375
    ],
    [
      "dissimuler",
      0.0275
    ],
    [
      "tripatouiller",
      0.0175
    ],
    [
      "tricher",
      0.0175
    ],
    [
      "trafiquer",
      0.0175
    ],
    [
      "peindre",
      0.0175
    ],
    [
      "mutiler",
      0.0175
    ],
    [
      "interpoler",
      0.0175
    ],
    [
      "faire",
      0.0175
    ],
    [
      "fabriquer",
      0.0175
    ],
    [
      "ouater",
      0.0075
    ],
    [
      "ombrer",
      0.0075
    ],
    [
      "grimer",
      0.0075
    ],
    [
      "foutre",
      0.0075
    ],
    [
      "ficher",
      0.0075
    ],
    [
      "camoufler",
      0.0075
    ],
    [
      "revetir",
      0.0075
    ]
  ],
  "chouette": [
    [
      "beau",
      0.2075
    ],
    [
      "agreable",
      0.115
    ],
    [
      "chic",
      0.0925
    ],
    [
      "bath",
      0.0675
    ],
    [
      "elegant",
      0.0675
    ],
    [
      "rapace",
      0.045
    ],
    [
      "joli",
      0.045
    ],
    [
      "hulotte",
      0.045
    ],
    [
      "genial",
      0.045
    ],
    [
      "sympa",
      0.0225
    ],
    [
      "strix",
      0.0225
    ],
    [
      "rupin",
      0.0225
    ],
    [
      "pessimiste",
      0.0225
    ],
    [
      "harfang",
      0.0225
    ],
    [
      "effraie",
      0.0225
    ],
    [
      "brave",
      0.0225
    ],
    [
      "bonard",
      0.0225
    ],
    [
      "epatant",
      0.0225
    ]
  ],
  "galerie": [
    [
      "balcon",
      0.0625
    ],
    [
      "passage",
      0.0625
    ],
    [
      "public",
      0.05
    ],
    [
      "mine",
      0.04
    ],
    [
      "spectateur",
      0.03
    ],
    [
      "salle",
      0.03
    ],
    [
      "boyau",
      0.03
    ],
    [
      "auditoire",
      0.03
    ],
    [
      "abri",
      0.03
    ],
    [
      "peristyle",
      0.02
    ],
    [
      "rue",
      0.02
    ],
    [
      "sape",
      0.02
    ],
    [
      "souterrain",
      0.02
    ],
    [
      "tunnel",
      0.02
    ],
    [
      "vestibule",
      0.02
    ],
    [
      "veranda",
      0.02
    ],
    [
      "promenade",
      0.02
    ],
    [
      "poulailler",
      0.02
    ],
    [
      "auvent",
      0.02
    ],
    [
      "colonne",
      0.02
    ],
    [
      "corbeille",
      0.02
    ],
    [
      "corridor",
      0.02
    ],
    [
      "mezzanine",
      0.02
    ],
    [
      "parterre",
      0.02
    ],
    [
      "pinacotheque",
      0.0075
    ],
    [
      "piece",
      0.0075
    ],
    [
      "portique",
      0.0075
    ],
    [
      "promenoir",
      0.0075
    ],
    [
      "spectateurs",
      0.0075
    ],
    [
      "taille",
      0.0075
    ],
    [
      "triforium",
      0.0075
    ],
    [
      "temoin",
      0.0075
    ],
    [
      "xyste",
      0.0075
    ],
    [
      "paradis",
      0.0075
    ],
    [
      "musee",
      0.0075
    ],
    [
      "monde",
      0.0075
    ],
    [
      "assistance",
      0.0075
    ],
    [
      "bazar",
      0.0075
    ],
    [
      "bovette",
      0.0075
    ],
    [
      "bure",
      0.0075
    ],
    [
      "cavite",
      0.0075
    ],
    [
      "collection",
      0.0075
    ],
    [
      "couloir",
      0.0075
    ],
    [
      "coursiere",
      0.0075
    ],
    [
      "descenderie",
      0.0075
    ],
    [
      "exposition",
      0.0075
    ],
    [
      "gens",
      0.0075
    ],
    [
      "loggia",
      0.0075
    ],
    [
      "araignee",
      0.0075
    ]
  ],
  "farfouiller": [
    [
      "bouleverser",
      0.145
    ],
    [
      "fouiller",
      0.145
    ],
    [
      "trifouiller",
      0.1175
    ],
    [
      "fureter",
      0.0875
    ],
    [
      "tripatouiller",
      0.0875
    ],
    [
      "fourrager",
      0.0575
    ],
    [
      "retourner",
      0.0275
    ],
    [
      "fourgonner",
      0.0275
    ],
    [
      "fouiner",
      0.0275
    ],
    [
      "ficher",
      0.0275
    ],
    [
      "fabriquer",
      0.0275
    ],
    [
      "deranger",
      0.0275
    ],
    [
      "chercher",
      0.0275
    ],
    [
      "brouiller",
      0.0275
    ],
    [
      "tripoter",
      0.0275
    ]
  ],
  "rhume": [
    [
      "catarrhe",
      0.1525
    ],
    [
      "coryza",
      0.1525
    ],
    [
      "grippe",
      0.1525
    ],
    [
      "refroidissement",
      0.1525
    ],
    [
      "enchifrenement",
      0.075
    ],
    [
      "froid",
      0.075
    ],
    [
      "rhinite",
      0.075
    ],
    [
      "toux",
      0.075
    ]
  ],
  "chiens": [
    [
      "charme",
      0.05
    ],
    [
      "elegance",
      0.0375
    ],
    [
      "radin",
      0.0375
    ],
    [
      "gardien",
      0.0375
    ],
    [
      "chic",
      0.0375
    ],
    [
      "avare",
      0.0375
    ],
    [
      "valet",
      0.025
    ],
    [
      "rat",
      0.025
    ],
    [
      "policier",
      0.025
    ],
    [
      "pingre",
      0.025
    ],
    [
      "ladre",
      0.025
    ],
    [
      "chiche",
      0.025
    ],
    [
      "cerbere",
      0.025
    ],
    [
      "canide",
      0.025
    ],
    [
      "appas",
      0.025
    ],
    [
      "lycaon",
      0.01
    ],
    [
      "limier",
      0.01
    ],
    [
      "lice",
      0.01
    ],
    [
      "larbin",
      0.01
    ],
    [
      "laquais",
      0.01
    ],
    [
      "lamie",
      0.01
    ],
    [
      "impitoyable",
      0.01
    ],
    [
      "houret",
      0.01
    ],
    [
      "molosse",
      0.01
    ],
    [
      "montant",
      0.01
    ],
    [
      "otocyon",
      0.01
    ],
    [
      "vautre",
      0.01
    ],
    [
      "toutou",
      0.01
    ],
    [
      "talon",
      0.01
    ],
    [
      "roquet",
      0.01
    ],
    [
      "rapiat",
      0.01
    ],
    [
      "piment",
      0.01
    ],
    [
      "pattu",
      0.01
    ],
    [
      "pataud",
      0.01
    ],
    [
      "grigou",
      0.01
    ],
    [
      "garde",
      0.01
    ],
    [
      "esclave",
      0.01
    ],
    [
      "canin",
      0.01
    ],
    [
      "caniche",
      0.01
    ],
    [
      "canaille",
      0.01
    ],
    [
      "caberu",
      0.01
    ],
    [
      "cabot",
      0.01
    ],
    [
      "berger",
      0.01
    ],
    [
      "barre",
      0.01
    ],
    [
      "attrait",
      0.01
    ],
    [
      "chienchien",
      0.01
    ],
    [
      "chienne",
      0.01
    ],
    [
      "cyon",
      0.01
    ],
    [
      "corniaud",
      0.01
    ],
    [
      "coriace",
      0.01
    ],
    [
      "clebard",
      0.01
    ],
    [
      "clebs",
      0.01
    ],
    [
      "classe",
      0.01
    ],
    [
      "clabaud",
      0.01
    ],
    [
      "chiot",
      0.01
    ],
    [
      "allure",
      0.01
    ]
  ],
  "blanchir": [
    [
      "laver",
      0.0975
    ],
    [
      "disculper",
      0.0625
    ],
    [
      "innocenter",
      0.0625
    ],
    [
      "nettoyer",
      0.0625
    ],
    [
      "echauder",
      0.0475
    ],
    [
      "recurer",
      0.0475
    ],
    [
      "frotter",
      0.0475
    ],
    [
      "excuser",
      0.0475
    ],
    [
      "eclaircir",
      0.03
    ],
    [
      "palir",
      0.03
    ],
    [
      "justifier",
      0.03
    ],
    [
      "enduire",
      0.03
    ],
    [
      "decharger",
      0.03
    ],
    [
      "chauler",
      0.03
    ],
    [
      "limer",
      0.015
    ],
    [
      "meuler",
      0.015
    ],
    [
      "platiner",
      0.015
    ],
    [
      "raboter",
      0.015
    ],
    [
      "rehabiliter",
      0.015
    ],
    [
      "savonner",
      0.015
    ],
    [
      "terrer",
      0.015
    ],
    [
      "vieillir",
      0.015
    ],
    [
      "lessiver",
      0.015
    ],
    [
      "herber",
      0.015
    ],
    [
      "acquitter",
      0.015
    ],
    [
      "azurer",
      0.015
    ],
    [
      "blanchoyer",
      0.015
    ],
    [
      "blemir",
      0.015
    ],
    [
      "decolorer",
      0.015
    ],
    [
      "degrossir",
      0.015
    ],
    [
      "dejaunir",
      0.015
    ],
    [
      "desinculper",
      0.015
    ],
    [
      "enfariner",
      0.015
    ],
    [
      "ebouillanter",
      0.015
    ]
  ],
  "blanchi": [
    [
      "lave",
      0.4
    ],
    [
      "blanc",
      0.2
    ],
    [
      "decolore",
      0.2
    ],
    [
      "propre",
      0.2
    ]
  ],
  "fourbu": [
    [
      "rompu",
      0.12
    ],
    [
      "harasse",
      0.105
    ],
    [
      "fatigue",
      0.1
    ],
    [
      "rendu",
      0.0775
    ],
    [
      "recru",
      0.0775
    ],
    [
      "extenue",
      0.0775
    ],
    [
      "vanne",
      0.07
    ],
    [
      "las",
      0.055
    ],
    [
      "epuise",
      0.0425
    ],
    [
      "ereinte",
      0.0425
    ],
    [
      "moulu",
      0.035
    ],
    [
      "brise",
      0.035
    ],
    [
      "aneanti",
      0.0275
    ],
    [
      "flapi",
      0.0275
    ],
    [
      "lessive",
      0.02
    ],
    [
      "vide",
      0.02
    ],
    [
      "claque",
      0.0125
    ],
    [
      "esquinte",
      0.0125
    ],
    [
      "echine",
      0.0125
    ],
    [
      "creve",
      0.005
    ]
  ],
  "peinard": [
    [
      "calme",
      0.25
    ],
    [
      "paisible",
      0.125
    ],
    [
      "prudent",
      0.125
    ],
    [
      "pepere",
      0.125
    ],
    [
      "serein",
      0.125
    ],
    [
      "tranquille",
      0.125
    ],
    [
      "vieillard",
      0.125
    ]
  ],
  "flouer": [
    [
      "rouler",
      0.1775
    ],
    [
      "tromper",
      0.1275
    ],
    [
      "duper",
      0.1125
    ],
    [
      "berner",
      0.095
    ],
    [
      "gruger",
      0.08
    ],
    [
      "voler",
      0.0625
    ],
    [
      "refaire",
      0.0625
    ],
    [
      "mystifier",
      0.0625
    ],
    [
      "escroquer",
      0.0625
    ],
    [
      "amuser",
      0.03
    ],
    [
      "jouer",
      0.03
    ],
    [
      "leurrer",
      0.03
    ],
    [
      "posseder",
      0.03
    ],
    [
      "brimer",
      0.015
    ]
  ],
  "voleur": [
    [
      "bandit",
      0.095
    ],
    [
      "fripouille",
      0.07
    ],
    [
      "brigand",
      0.065
    ],
    [
      "fripon",
      0.06
    ],
    [
      "filou",
      0.05
    ],
    [
      "vaurien",
      0.0475
    ],
    [
      "escroc",
      0.0425
    ],
    [
      "malfaiteur",
      0.04
    ],
    [
      "pirate",
      0.0325
    ],
    [
      "forban",
      0.0325
    ],
    [
      "truand",
      0.025
    ],
    [
      "crapule",
      0.0225
    ],
    [
      "canaille",
      0.02
    ],
    [
      "coquin",
      0.02
    ],
    [
      "pillard",
      0.02
    ],
    [
      "scelerat",
      0.02
    ],
    [
      "terreur",
      0.015
    ],
    [
      "malandrin",
      0.015
    ],
    [
      "plagiaire",
      0.0125
    ],
    [
      "larron",
      0.0125
    ],
    [
      "gangster",
      0.0125
    ],
    [
      "corsaire",
      0.0125
    ],
    [
      "cambrioleur",
      0.0125
    ],
    [
      "aigrefin",
      0.0125
    ],
    [
      "requin",
      0.01
    ],
    [
      "maraudeur",
      0.01
    ],
    [
      "malhonnete",
      0.01
    ],
    [
      "flibustier",
      0.01
    ],
    [
      "detrousseur",
      0.01
    ],
    [
      "chenapan",
      0.01
    ],
    [
      "rapineur",
      0.0075
    ],
    [
      "tricheur",
      0.0075
    ],
    [
      "ravisseur",
      0.005
    ],
    [
      "pickpocket",
      0.005
    ],
    [
      "maraud",
      0.005
    ],
    [
      "fraudeur",
      0.005
    ],
    [
      "devaliseur",
      0.005
    ],
    [
      "casseur",
      0.005
    ],
    [
      "leveur",
      0.0025
    ],
    [
      "kidnappeur",
      0.0025
    ],
    [
      "griveleur",
      0.0025
    ],
    [
      "flibuste",
      0.0025
    ],
    [
      "escogriffe",
      0.0025
    ],
    [
      "pipeur",
      0.0025
    ],
    [
      "piqueur",
      0.0025
    ],
    [
      "rapace",
      0.0025
    ],
    [
      "resquilleur",
      0.0025
    ],
    [
      "spoliateur",
      0.0025
    ],
    [
      "tripoteur",
      0.0025
    ],
    [
      "escarpe",
      0.0025
    ],
    [
      "escamoteur",
      0.0025
    ],
    [
      "derobeur",
      0.0025
    ],
    [
      "barboteur",
      0.0025
    ],
    [
      "bonneteur",
      0.0025
    ],
    [
      "briseur",
      0.0025
    ],
    [
      "carambouilleur",
      0.0025
    ],
    [
      "chapardeur",
      0.0025
    ],
    [
      "chouraveur",
      0.0025
    ],
    [
      "clephte",
      0.0025
    ],
    [
      "cleptomane",
      0.0025
    ],
    [
      "compilateur",
      0.0025
    ],
    [
      "concussionnaire",
      0.0025
    ],
    [
      "copieur",
      0.0025
    ],
    [
      "depredataire",
      0.0025
    ]
  ],
  "enfiler": [
    [
      "prendre",
      0.1025
    ],
    [
      "mettre",
      0.08
    ],
    [
      "engloutir",
      0.06
    ],
    [
      "ingurgiter",
      0.06
    ],
    [
      "passer",
      0.06
    ],
    [
      "percer",
      0.06
    ],
    [
      "tromper",
      0.04
    ],
    [
      "transpercer",
      0.04
    ],
    [
      "posseder",
      0.04
    ],
    [
      "entrer",
      0.04
    ],
    [
      "endosser",
      0.04
    ],
    [
      "abuser",
      0.04
    ],
    [
      "foutre",
      0.0175
    ],
    [
      "revetir",
      0.0175
    ],
    [
      "rouler",
      0.0175
    ],
    [
      "s'engager",
      0.0175
    ],
    [
      "siffler",
      0.0175
    ],
    [
      "suivre",
      0.0175
    ],
    [
      "entonner",
      0.0175
    ],
    [
      "enjoler",
      0.0175
    ],
    [
      "engouffrer",
      0.0175
    ],
    [
      "enferrer",
      0.0175
    ],
    [
      "empaler",
      0.0175
    ],
    [
      "embrocher",
      0.0175
    ],
    [
      "debiter",
      0.0175
    ],
    [
      "dire",
      0.0175
    ],
    [
      "chausser",
      0.0175
    ],
    [
      "vetir",
      0.0175
    ]
  ],
  "gant": [
    [
      "manicle",
      0.285
    ],
    [
      "chistera",
      0.1425
    ],
    [
      "gantelet",
      0.1425
    ],
    [
      "mitaine",
      0.1425
    ],
    [
      "moufle",
      0.1425
    ],
    [
      "paumelle",
      0.1425
    ]
  ],
  "gagnant": [
    [
      "vainqueur",
      0.285
    ],
    [
      "champion",
      0.1425
    ],
    [
      "sortant",
      0.1425
    ],
    [
      "triomphant",
      0.1425
    ],
    [
      "triomphateur",
      0.1425
    ],
    [
      "victorieux",
      0.1425
    ]
  ],
  "lamper": [
    [
      "boire",
      0.175
    ],
    [
      "entonner",
      0.175
    ],
    [
      "ingurgiter",
      0.1175
    ],
    [
      "s'enfiler",
      0.1175
    ],
    [
      "s'envoyer",
      0.1175
    ],
    [
      "siffler",
      0.1175
    ],
    [
      "entourer",
      0.0575
    ],
    [
      "finir",
      0.0575
    ],
    [
      "s'abreuver",
      0.0575
    ]
  ],
  "lampe": [
    [
      "feu",
      0.15
    ],
    [
      "lumiere",
      0.15
    ],
    [
      "flambeau",
      0.1
    ],
    [
      "luminaire",
      0.1
    ],
    [
      "eclairage",
      0.1
    ],
    [
      "suspension",
      0.05
    ],
    [
      "rechaud",
      0.05
    ],
    [
      "quinquet",
      0.05
    ],
    [
      "lumignon",
      0.05
    ],
    [
      "lanterne",
      0.05
    ],
    [
      "calbombe",
      0.05
    ],
    [
      "ampoule",
      0.05
    ],
    [
      "eolipile",
      0.05
    ]
  ],
  "desservir": [
    [
      "nuire",
      0.1375
    ],
    [
      "desavantager",
      0.09
    ],
    [
      "gener",
      0.09
    ],
    [
      "communiquer",
      0.0675
    ],
    [
      "contrarier",
      0.0675
    ],
    [
      "relier",
      0.045
    ],
    [
      "handicaper",
      0.045
    ],
    [
      "defavoriser",
      0.045
    ],
    [
      "leser",
      0.02
    ],
    [
      "mouiller",
      0.02
    ],
    [
      "passer",
      0.02
    ],
    [
      "prejudicier",
      0.02
    ],
    [
      "reunir",
      0.02
    ],
    [
      "s'arreter",
      0.02
    ],
    [
      "unir",
      0.02
    ],
    [
      "entraver",
      0.02
    ],
    [
      "enlever",
      0.02
    ],
    [
      "desobliger",
      0.02
    ],
    [
      "debarrasser",
      0.02
    ],
    [
      "contrecarrer",
      0.02
    ],
    [
      "commander",
      0.02
    ],
    [
      "aller",
      0.02
    ],
    [
      "aboutir",
      0.02
    ],
    [
      "oter",
      0.02
    ]
  ],
  "dessert": [
    [
      "couronnement",
      0.25
    ],
    [
      "entremets",
      0.25
    ],
    [
      "fin",
      0.25
    ],
    [
      "regal",
      0.25
    ]
  ],
  "restaurer": [
    [
      "reparer",
      0.1075
    ],
    [
      "retablir",
      0.09
    ],
    [
      "reconforter",
      0.08
    ],
    [
      "remonter",
      0.075
    ],
    [
      "revigorer",
      0.07
    ],
    [
      "refaire",
      0.065
    ],
    [
      "retaper",
      0.0575
    ],
    [
      "remettre",
      0.0375
    ],
    [
      "soutenir",
      0.0325
    ],
    [
      "relever",
      0.025
    ],
    [
      "fortifier",
      0.025
    ],
    [
      "arranger",
      0.025
    ],
    [
      "raccommoder",
      0.02
    ],
    [
      "rafraichir",
      0.02
    ],
    [
      "requinquer",
      0.02
    ],
    [
      "ressusciter",
      0.02
    ],
    [
      "renover",
      0.015
    ],
    [
      "reconstituer",
      0.015
    ],
    [
      "recomposer",
      0.015
    ],
    [
      "nourrir",
      0.015
    ],
    [
      "ameliorer",
      0.015
    ],
    [
      "sustenter",
      0.01
    ],
    [
      "reedifier",
      0.01
    ],
    [
      "rhabiller",
      0.01
    ],
    [
      "ramener",
      0.01
    ],
    [
      "entretenir",
      0.01
    ],
    [
      "bricoler",
      0.01
    ],
    [
      "alimenter",
      0.01
    ],
    [
      "rehabiliter",
      0.005
    ],
    [
      "repriser",
      0.005
    ],
    [
      "rentoiler",
      0.005
    ],
    [
      "recrepir",
      0.005
    ],
    [
      "rassasier",
      0.005
    ],
    [
      "proteger",
      0.005
    ],
    [
      "repeter",
      0.005
    ]
  ],
  "restaurant": [
    [
      "cabaret",
      0.16
    ],
    [
      "cafe",
      0.1025
    ],
    [
      "brasserie",
      0.0725
    ],
    [
      "taverne",
      0.0725
    ],
    [
      "gargote",
      0.0575
    ],
    [
      "buvette",
      0.0575
    ],
    [
      "auberge",
      0.0425
    ],
    [
      "bouillon",
      0.0425
    ],
    [
      "buffet",
      0.0425
    ],
    [
      "popote",
      0.0275
    ],
    [
      "hotellerie",
      0.0275
    ],
    [
      "cantine",
      0.0275
    ],
    [
      "bistrot",
      0.0275
    ],
    [
      "self",
      0.0125
    ],
    [
      "rotisserie",
      0.0125
    ],
    [
      "refectoire",
      0.0125
    ],
    [
      "restoroute",
      0.0125
    ],
    [
      "restauration",
      0.0125
    ],
    [
      "relais",
      0.0125
    ],
    [
      "mess",
      0.0125
    ],
    [
      "guinguette",
      0.0125
    ],
    [
      "grillade",
      0.0125
    ],
    [
      "cremerie",
      0.0125
    ],
    [
      "cordial",
      0.0125
    ],
    [
      "tonique",
      0.0125
    ]
  ],
  "baklava": [],
  "divers": [
    [
      "varie",
      0.125
    ],
    [
      "changeant",
      0.11
    ],
    [
      "dissemblable",
      0.0825
    ],
    [
      "ondoyant",
      0.0825
    ],
    [
      "plusieurs",
      0.055
    ],
    [
      "versatile",
      0.04
    ],
    [
      "multiple",
      0.04
    ],
    [
      "inegal",
      0.04
    ],
    [
      "heterogene",
      0.04
    ],
    [
      "disparate",
      0.04
    ],
    [
      "separe",
      0.0275
    ],
    [
      "fugace",
      0.0275
    ],
    [
      "composite",
      0.0275
    ],
    [
      "bigarre",
      0.0275
    ],
    [
      "souple",
      0.0125
    ],
    [
      "quelques",
      0.0125
    ],
    [
      "quelconque",
      0.0125
    ],
    [
      "pluriel",
      0.0125
    ],
    [
      "multiples",
      0.0125
    ],
    [
      "multiforme",
      0.0125
    ],
    [
      "mouvant",
      0.0125
    ],
    [
      "inconstant",
      0.0125
    ],
    [
      "heteroclite",
      0.0125
    ],
    [
      "diversiforme",
      0.0125
    ],
    [
      "distinct",
      0.0125
    ],
    [
      "differents",
      0.0125
    ],
    [
      "d'aucuns",
      0.0125
    ],
    [
      "certains",
      0.0125
    ],
    [
      "bariole",
      0.0125
    ],
    [
      "eclectique",
      0.0125
    ]
  ],
  "colonne": [
    [
      "soutien",
      0.0775
    ],
    [
      "appui",
      0.065
    ],
    [
      "pilastre",
      0.0525
    ],
    [
      "pilier",
      0.0525
    ],
    [
      "troupe",
      0.0525
    ],
    [
      "support",
      0.0375
    ],
    [
      "cortege",
      0.0375
    ],
    [
      "soutenement",
      0.025
    ],
    [
      "peristyle",
      0.025
    ],
    [
      "pylone",
      0.025
    ],
    [
      "portique",
      0.025
    ],
    [
      "galerie",
      0.025
    ],
    [
      "conduite",
      0.025
    ],
    [
      "canalisation",
      0.025
    ],
    [
      "borne",
      0.025
    ],
    [
      "orgue",
      0.0125
    ],
    [
      "obelisque",
      0.0125
    ],
    [
      "montant",
      0.0125
    ],
    [
      "gerbe",
      0.0125
    ],
    [
      "fut",
      0.0125
    ],
    [
      "file",
      0.0125
    ],
    [
      "poteau",
      0.0125
    ],
    [
      "propylee",
      0.0125
    ],
    [
      "rachis",
      0.0125
    ],
    [
      "renfort",
      0.0125
    ],
    [
      "section",
      0.0125
    ],
    [
      "stele",
      0.0125
    ],
    [
      "telamon",
      0.0125
    ],
    [
      "escouade",
      0.0125
    ],
    [
      "defile",
      0.0125
    ],
    [
      "dosseret",
      0.0125
    ],
    [
      "arcature",
      0.0125
    ],
    [
      "atlante",
      0.0125
    ],
    [
      "balcon",
      0.0125
    ],
    [
      "balustrade",
      0.0125
    ],
    [
      "cariatide",
      0.0125
    ],
    [
      "chapelet",
      0.0125
    ],
    [
      "cippe",
      0.0125
    ],
    [
      "cohorte",
      0.0125
    ],
    [
      "colonnade",
      0.0125
    ],
    [
      "colonnette",
      0.0125
    ],
    [
      "commando",
      0.0125
    ],
    [
      "contrefort",
      0.0125
    ],
    [
      "cylindre",
      0.0125
    ],
    [
      "aiguille",
      0.0125
    ]
  ],
  "lapin": [
    [
      "biquet",
      0.165
    ],
    [
      "bouquet",
      0.165
    ],
    [
      "bouquin",
      0.165
    ],
    [
      "gaillard",
      0.165
    ],
    [
      "gibier",
      0.165
    ],
    [
      "homme",
      0.165
    ]
  ],
  "machoire": [
    [
      "bouche",
      0.1175
    ],
    [
      "denture",
      0.1175
    ],
    [
      "mandibule",
      0.1175
    ],
    [
      "ratelier",
      0.0575
    ],
    [
      "poupee",
      0.0575
    ],
    [
      "maxille",
      0.0575
    ],
    [
      "maxillaire",
      0.0575
    ],
    [
      "masseter",
      0.0575
    ],
    [
      "margoulette",
      0.0575
    ],
    [
      "ganache",
      0.0575
    ],
    [
      "dentition",
      0.0575
    ],
    [
      "clavier",
      0.0575
    ],
    [
      "bete",
      0.0575
    ]
  ],
  "hagard": [
    [
      "hallucine",
      0.2175
    ],
    [
      "affole",
      0.1625
    ],
    [
      "fou",
      0.08
    ],
    [
      "trouble",
      0.08
    ],
    [
      "epouvante",
      0.0525
    ],
    [
      "egare",
      0.0525
    ],
    [
      "fievreux",
      0.0525
    ],
    [
      "effare",
      0.0525
    ],
    [
      "terrifie",
      0.025
    ],
    [
      "sauvage",
      0.025
    ],
    [
      "saisi",
      0.025
    ],
    [
      "horrifie",
      0.025
    ],
    [
      "effraye",
      0.025
    ],
    [
      "dement",
      0.025
    ],
    [
      "delirant",
      0.025
    ],
    [
      "absent",
      0.025
    ],
    [
      "terrorise",
      0.025
    ]
  ],
  "garantir": [
    [
      "proteger",
      0.095
    ],
    [
      "assurer",
      0.0725
    ],
    [
      "affirmer",
      0.065
    ],
    [
      "preserver",
      0.0525
    ],
    [
      "defendre",
      0.0475
    ],
    [
      "soutenir",
      0.0425
    ],
    [
      "confirmer",
      0.0425
    ],
    [
      "certifier",
      0.035
    ],
    [
      "renforcer",
      0.035
    ],
    [
      "garder",
      0.0275
    ],
    [
      "temoigner",
      0.0225
    ],
    [
      "sauver",
      0.0225
    ],
    [
      "sauvegarder",
      0.0225
    ],
    [
      "montrer",
      0.0225
    ],
    [
      "couvrir",
      0.0225
    ],
    [
      "cautionner",
      0.0225
    ],
    [
      "attester",
      0.0225
    ],
    [
      "etablir",
      0.0175
    ],
    [
      "repondre",
      0.0175
    ],
    [
      "promettre",
      0.0175
    ],
    [
      "jurer",
      0.0175
    ],
    [
      "donner",
      0.0175
    ],
    [
      "affermir",
      0.0175
    ],
    [
      "epargner",
      0.01
    ],
    [
      "reserver",
      0.01
    ],
    [
      "pretendre",
      0.01
    ],
    [
      "premunir",
      0.01
    ],
    [
      "introduire",
      0.01
    ],
    [
      "immuniser",
      0.01
    ],
    [
      "exempter",
      0.01
    ],
    [
      "demontrer",
      0.01
    ],
    [
      "corroborer",
      0.01
    ],
    [
      "conserver",
      0.01
    ],
    [
      "chaperonner",
      0.01
    ],
    [
      "abriter",
      0.01
    ],
    [
      "precautionner",
      0.005
    ],
    [
      "parer",
      0.005
    ],
    [
      "gager",
      0.005
    ],
    [
      "estampiller",
      0.005
    ],
    [
      "avaliser",
      0.005
    ],
    [
      "authentifier",
      0.005
    ],
    [
      "qualifier",
      0.005
    ]
  ],
  "garanti": [
    [
      "proteger",
      0.095
    ],
    [
      "assurer",
      0.0725
    ],
    [
      "affirmer",
      0.065
    ],
    [
      "preserver",
      0.0525
    ],
    [
      "defendre",
      0.0475
    ],
    [
      "soutenir",
      0.0425
    ],
    [
      "confirmer",
      0.0425
    ],
    [
      "certifier",
      0.035
    ],
    [
      "renforcer",
      0.035
    ],
    [
      "garder",
      0.0275
    ],
    [
      "temoigner",
      0.0225
    ],
    [
      "sauver",
      0.0225
    ],
    [
      "sauvegarder",
      0.0225
    ],
    [
      "montrer",
      0.0225
    ],
    [
      "couvrir",
      0.0225
    ],
    [
      "cautionner",
      0.0225
    ],
    [
      "attester",
      0.0225
    ],
    [
      "etablir",
      0.0175
    ],
    [
      "repondre",
      0.0175
    ],
    [
      "promettre",
      0.0175
    ],
    [
      "jurer",
      0.0175
    ],
    [
      "donner",
      0.0175
    ],
    [
      "affermir",
      0.0175
    ],
    [
      "epargner",
      0.01
    ],
    [
      "reserver",
      0.01
    ],
    [
      "pretendre",
      0.01
    ],
    [
      "premunir",
      0.01
    ],
    [
      "introduire",
      0.01
    ],
    [
      "immuniser",
      0.01
    ],
    [
      "exempter",
      0.01
    ],
    [
      "demontrer",
      0.01
    ],
    [
      "corroborer",
      0.01
    ],
    [
      "conserver",
      0.01
    ],
    [
      "chaperonner",
      0.01
    ],
    [
      "abriter",
      0.01
    ],
    [
      "precautionner",
      0.005
    ],
    [
      "parer",
      0.005
    ],
    [
      "gager",
      0.005
    ],
    [
      "estampiller",
      0.005
    ],
    [
      "avaliser",
      0.005
    ],
    [
      "authentifier",
      0.005
    ],
    [
      "qualifier",
      0.005
    ]
  ],
  "diplomer": [],
  "voeu": [
    [
      "desir",
      0.2
    ],
    [
      "souhait",
      0.2
    ],
    [
      "soif",
      0.1
    ],
    [
      "volonte",
      0.1
    ],
    [
      "demande",
      0.065
    ],
    [
      "revendication",
      0.065
    ],
    [
      "resolution",
      0.0325
    ],
    [
      "promesse",
      0.0325
    ],
    [
      "profession",
      0.0325
    ],
    [
      "engagement",
      0.0325
    ],
    [
      "benediction",
      0.0325
    ],
    [
      "avis",
      0.0325
    ],
    [
      "ambition",
      0.0325
    ],
    [
      "serment",
      0.0325
    ]
  ],
  "souhait": [
    [
      "desir",
      0.23
    ],
    [
      "soif",
      0.17
    ],
    [
      "voeu",
      0.085
    ],
    [
      "ambition",
      0.055
    ],
    [
      "convoitise",
      0.055
    ],
    [
      "volonte",
      0.055
    ],
    [
      "revendication",
      0.04
    ],
    [
      "envie",
      0.04
    ],
    [
      "demande",
      0.04
    ],
    [
      "appetit",
      0.04
    ],
    [
      "faim",
      0.0275
    ],
    [
      "desiderata",
      0.0275
    ],
    [
      "caprice",
      0.0275
    ],
    [
      "aspiration",
      0.0275
    ],
    [
      "attente",
      0.0125
    ],
    [
      "optation",
      0.0125
    ],
    [
      "resolution",
      0.0125
    ],
    [
      "reve",
      0.0125
    ]
  ],
  "pioche": [
    [
      "bigot",
      0.1425
    ],
    [
      "houe",
      0.1425
    ],
    [
      "pic",
      0.1425
    ],
    [
      "piochage",
      0.1425
    ],
    [
      "piochon",
      0.1425
    ],
    [
      "piolet",
      0.1425
    ],
    [
      "piemontaise",
      0.1425
    ]
  ],
  "piocher": [
    [
      "travailler",
      0.165
    ],
    [
      "etudier",
      0.11
    ],
    [
      "bucher",
      0.0825
    ],
    [
      "creuser",
      0.0825
    ],
    [
      "fouiller",
      0.0825
    ],
    [
      "preparer",
      0.055
    ],
    [
      "potasser",
      0.055
    ],
    [
      "labourer",
      0.055
    ],
    [
      "faire",
      0.055
    ],
    [
      "chiader",
      0.055
    ],
    [
      "besogner",
      0.0275
    ],
    [
      "bosser",
      0.0275
    ],
    [
      "boulonner",
      0.0275
    ],
    [
      "fouir",
      0.0275
    ],
    [
      "peiner",
      0.0275
    ],
    [
      "prendre",
      0.0275
    ],
    [
      "s'instruire",
      0.0275
    ]
  ],
  "monceau": [
    [
      "tas",
      0.17
    ],
    [
      "amas",
      0.1275
    ],
    [
      "amoncellement",
      0.1175
    ],
    [
      "accumulation",
      0.085
    ],
    [
      "entassement",
      0.085
    ],
    [
      "montagne",
      0.0725
    ],
    [
      "pile",
      0.0525
    ],
    [
      "masse",
      0.04
    ],
    [
      "fatras",
      0.04
    ],
    [
      "assemblage",
      0.04
    ],
    [
      "empilement",
      0.03
    ],
    [
      "quantite",
      0.03
    ],
    [
      "monticule",
      0.02
    ],
    [
      "paquet",
      0.02
    ],
    [
      "echafaudage",
      0.01
    ],
    [
      "ramassis",
      0.01
    ],
    [
      "mont",
      0.01
    ],
    [
      "empilage",
      0.01
    ],
    [
      "ecroulement",
      0.01
    ]
  ],
  "quintal": [
    [
      "poids",
      1.0
    ]
  ],
  "cartouche": [
    [
      "charge",
      0.1475
    ],
    [
      "encadrement",
      0.0725
    ],
    [
      "explosif",
      0.0725
    ],
    [
      "projectile",
      0.0725
    ],
    [
      "douille",
      0.035
    ],
    [
      "enroulement",
      0.035
    ],
    [
      "gargousse",
      0.035
    ],
    [
      "mandrin",
      0.035
    ],
    [
      "mine",
      0.035
    ],
    [
      "petard",
      0.035
    ],
    [
      "recharge",
      0.035
    ],
    [
      "dessin",
      0.035
    ],
    [
      "cylindre",
      0.035
    ],
    [
      "chargette",
      0.035
    ],
    [
      "cartouchiere",
      0.035
    ],
    [
      "cartel",
      0.035
    ],
    [
      "cadre",
      0.035
    ],
    [
      "boite",
      0.035
    ],
    [
      "bourre",
      0.035
    ],
    [
      "blason",
      0.035
    ],
    [
      "balle",
      0.035
    ],
    [
      "sertisseur",
      0.035
    ]
  ],
  "espagnol": [
    [
      "castillan",
      0.25
    ],
    [
      "hispanique",
      0.25
    ],
    [
      "iberique",
      0.25
    ],
    [
      "transpyreneen",
      0.25
    ]
  ],
  "tourisme": [
    [
      "camping",
      0.25
    ],
    [
      "caravaning",
      0.25
    ],
    [
      "cyclotourisme",
      0.25
    ],
    [
      "voyage",
      0.25
    ]
  ],
  "dose": [
    [
      "mesure",
      0.1675
    ],
    [
      "quantite",
      0.1675
    ],
    [
      "proportion",
      0.11
    ],
    [
      "ration",
      0.11
    ],
    [
      "provision",
      0.055
    ],
    [
      "prise",
      0.055
    ],
    [
      "posologie",
      0.055
    ],
    [
      "portion",
      0.055
    ],
    [
      "pointe",
      0.055
    ],
    [
      "partie",
      0.055
    ],
    [
      "couche",
      0.055
    ],
    [
      "taux",
      0.055
    ]
  ],
  "doser": [
    [
      "mesurer",
      0.2725
    ],
    [
      "melanger",
      0.18
    ],
    [
      "proportionner",
      0.18
    ],
    [
      "combiner",
      0.09
    ],
    [
      "distribuer",
      0.09
    ],
    [
      "meler",
      0.09
    ],
    [
      "regler",
      0.09
    ]
  ],
  "determine": [
    [
      "entrainer",
      0.0625
    ],
    [
      "provoquer",
      0.0625
    ],
    [
      "pousser",
      0.06
    ],
    [
      "susciter",
      0.035
    ],
    [
      "occasionner",
      0.0325
    ],
    [
      "exciter",
      0.0325
    ],
    [
      "causer",
      0.03
    ],
    [
      "produire",
      0.0275
    ],
    [
      "soulever",
      0.0275
    ],
    [
      "appeler",
      0.025
    ],
    [
      "inciter",
      0.0225
    ],
    [
      "decider",
      0.0225
    ],
    [
      "donner",
      0.0225
    ],
    [
      "fixer",
      0.0225
    ],
    [
      "engager",
      0.02
    ],
    [
      "faire",
      0.02
    ],
    [
      "porter",
      0.02
    ],
    [
      "conduire",
      0.0175
    ],
    [
      "etablir",
      0.0175
    ],
    [
      "indiquer",
      0.0175
    ],
    [
      "creer",
      0.0175
    ],
    [
      "amener",
      0.015
    ],
    [
      "dire",
      0.015
    ],
    [
      "marquer",
      0.0125
    ],
    [
      "former",
      0.0125
    ],
    [
      "engendrer",
      0.0125
    ],
    [
      "conseiller",
      0.0125
    ],
    [
      "trancher",
      0.01
    ],
    [
      "inspirer",
      0.01
    ],
    [
      "designer",
      0.01
    ],
    [
      "diriger",
      0.01
    ],
    [
      "apporter",
      0.01
    ],
    [
      "assigner",
      0.01
    ],
    [
      "persuader",
      0.01
    ],
    [
      "solliciter",
      0.01
    ],
    [
      "resoudre",
      0.0075
    ],
    [
      "peser",
      0.0075
    ],
    [
      "delimiter",
      0.0075
    ],
    [
      "disposer",
      0.0075
    ],
    [
      "arreter",
      0.0075
    ],
    [
      "motiver",
      0.005
    ],
    [
      "juger",
      0.005
    ],
    [
      "exhorter",
      0.005
    ],
    [
      "encourager",
      0.005
    ],
    [
      "definir",
      0.005
    ],
    [
      "evaluer",
      0.0025
    ],
    [
      "specifier",
      0.0025
    ],
    [
      "qualifier",
      0.0025
    ],
    [
      "predestiner",
      0.0025
    ],
    [
      "preciser",
      0.0025
    ],
    [
      "necessiter",
      0.0025
    ],
    [
      "mesurer",
      0.0025
    ],
    [
      "limiter",
      0.0025
    ],
    [
      "guider",
      0.0025
    ],
    [
      "caracteriser",
      0.0025
    ],
    [
      "calculer",
      0.0025
    ],
    [
      "regir",
      0.0025
    ],
    [
      "localiser",
      0.0025
    ],
    [
      "estimer",
      0.0025
    ],
    [
      "declencher",
      0.0025
    ],
    [
      "classer",
      0.0025
    ],
    [
      "choisir",
      0.0025
    ],
    [
      "apprecier",
      0.0025
    ],
    [
      "rechercher",
      0.0
    ],
    [
      "predeterminer",
      0.0
    ],
    [
      "positionner",
      0.0
    ],
    [
      "identifier",
      0.0
    ],
    [
      "diagnostiquer",
      0.0
    ],
    [
      "conditionner",
      0.0
    ],
    [
      "cibler",
      0.0
    ],
    [
      "centrer",
      0.0
    ]
  ],
  "determiner": [
    [
      "entrainer",
      0.0625
    ],
    [
      "provoquer",
      0.0625
    ],
    [
      "pousser",
      0.06
    ],
    [
      "susciter",
      0.035
    ],
    [
      "occasionner",
      0.0325
    ],
    [
      "exciter",
      0.0325
    ],
    [
      "causer",
      0.03
    ],
    [
      "produire",
      0.0275
    ],
    [
      "soulever",
      0.0275
    ],
    [
      "appeler",
      0.025
    ],
    [
      "inciter",
      0.0225
    ],
    [
      "decider",
      0.0225
    ],
    [
      "donner",
      0.0225
    ],
    [
      "fixer",
      0.0225
    ],
    [
      "engager",
      0.02
    ],
    [
      "faire",
      0.02
    ],
    [
      "porter",
      0.02
    ],
    [
      "conduire",
      0.0175
    ],
    [
      "etablir",
      0.0175
    ],
    [
      "indiquer",
      0.0175
    ],
    [
      "creer",
      0.0175
    ],
    [
      "amener",
      0.015
    ],
    [
      "dire",
      0.015
    ],
    [
      "marquer",
      0.0125
    ],
    [
      "former",
      0.0125
    ],
    [
      "engendrer",
      0.0125
    ],
    [
      "conseiller",
      0.0125
    ],
    [
      "trancher",
      0.01
    ],
    [
      "inspirer",
      0.01
    ],
    [
      "designer",
      0.01
    ],
    [
      "diriger",
      0.01
    ],
    [
      "apporter",
      0.01
    ],
    [
      "assigner",
      0.01
    ],
    [
      "persuader",
      0.01
    ],
    [
      "solliciter",
      0.01
    ],
    [
      "resoudre",
      0.0075
    ],
    [
      "peser",
      0.0075
    ],
    [
      "delimiter",
      0.0075
    ],
    [
      "disposer",
      0.0075
    ],
    [
      "arreter",
      0.0075
    ],
    [
      "motiver",
      0.005
    ],
    [
      "juger",
      0.005
    ],
    [
      "exhorter",
      0.005
    ],
    [
      "encourager",
      0.005
    ],
    [
      "definir",
      0.005
    ],
    [
      "evaluer",
      0.0025
    ],
    [
      "specifier",
      0.0025
    ],
    [
      "qualifier",
      0.0025
    ],
    [
      "predestiner",
      0.0025
    ],
    [
      "preciser",
      0.0025
    ],
    [
      "necessiter",
      0.0025
    ],
    [
      "mesurer",
      0.0025
    ],
    [
      "limiter",
      0.0025
    ],
    [
      "guider",
      0.0025
    ],
    [
      "caracteriser",
      0.0025
    ],
    [
      "calculer",
      0.0025
    ],
    [
      "regir",
      0.0025
    ],
    [
      "localiser",
      0.0025
    ],
    [
      "estimer",
      0.0025
    ],
    [
      "declencher",
      0.0025
    ],
    [
      "classer",
      0.0025
    ],
    [
      "choisir",
      0.0025
    ],
    [
      "apprecier",
      0.0025
    ],
    [
      "rechercher",
      0.0
    ],
    [
      "predeterminer",
      0.0
    ],
    [
      "positionner",
      0.0
    ],
    [
      "identifier",
      0.0
    ],
    [
      "diagnostiquer",
      0.0
    ],
    [
      "conditionner",
      0.0
    ],
    [
      "cibler",
      0.0
    ],
    [
      "centrer",
      0.0
    ]
  ],
  "choper": [
    [
      "chiper",
      0.14
    ],
    [
      "prendre",
      0.1275
    ],
    [
      "derober",
      0.115
    ],
    [
      "piquer",
      0.1025
    ],
    [
      "voler",
      0.0925
    ],
    [
      "attraper",
      0.08
    ],
    [
      "faucher",
      0.08
    ],
    [
      "subtiliser",
      0.0325
    ],
    [
      "chauffer",
      0.0325
    ],
    [
      "barboter",
      0.0325
    ],
    [
      "agrafer",
      0.0225
    ],
    [
      "harponner",
      0.0225
    ],
    [
      "pincer",
      0.0225
    ],
    [
      "soustraire",
      0.0225
    ],
    [
      "surprendre",
      0.0225
    ],
    [
      "epingler",
      0.0225
    ],
    [
      "faire",
      0.01
    ]
  ],
  "couguar": [
    [
      "jaguar",
      0.5
    ],
    [
      "puma",
      0.5
    ]
  ],
  "salami": [],
  "cornet": [
    [
      "trompette",
      0.175
    ],
    [
      "trompe",
      0.1175
    ],
    [
      "cuivre",
      0.1175
    ],
    [
      "corne",
      0.1175
    ],
    [
      "cor",
      0.1175
    ],
    [
      "bugle",
      0.1175
    ],
    [
      "huchet",
      0.0575
    ],
    [
      "patisserie",
      0.0575
    ]
  ],
  "moule": [
    [
      "broyer",
      0.17
    ],
    [
      "ecraser",
      0.17
    ],
    [
      "pulveriser",
      0.145
    ],
    [
      "briser",
      0.0975
    ],
    [
      "triturer",
      0.0975
    ],
    [
      "piler",
      0.0725
    ],
    [
      "battre",
      0.0725
    ],
    [
      "concasser",
      0.0475
    ],
    [
      "fatiguer",
      0.0225
    ],
    [
      "pondre",
      0.0225
    ],
    [
      "egruger",
      0.0225
    ]
  ],
  "abdos": [],
  "gras": [
    [
      "gros",
      0.085
    ],
    [
      "rebondi",
      0.0625
    ],
    [
      "replet",
      0.06
    ],
    [
      "abondant",
      0.045
    ],
    [
      "fort",
      0.03
    ],
    [
      "obscene",
      0.03
    ],
    [
      "plein",
      0.03
    ],
    [
      "charnu",
      0.0275
    ],
    [
      "riche",
      0.025
    ],
    [
      "grossier",
      0.0225
    ],
    [
      "epais",
      0.0225
    ],
    [
      "genereux",
      0.0175
    ],
    [
      "rond",
      0.0175
    ],
    [
      "potele",
      0.0175
    ],
    [
      "ordurier",
      0.0175
    ],
    [
      "graveleux",
      0.0175
    ],
    [
      "degoutant",
      0.0175
    ],
    [
      "adipeux",
      0.0175
    ],
    [
      "egrillard",
      0.0125
    ],
    [
      "sale",
      0.0125
    ],
    [
      "rondelet",
      0.0125
    ],
    [
      "plantureux",
      0.0125
    ],
    [
      "opulent",
      0.0125
    ],
    [
      "licencieux",
      0.0125
    ],
    [
      "grivois",
      0.0125
    ],
    [
      "grassouillet",
      0.0125
    ],
    [
      "gaulois",
      0.0125
    ],
    [
      "fertile",
      0.0125
    ],
    [
      "dodu",
      0.0125
    ],
    [
      "visqueux",
      0.01
    ],
    [
      "sale",
      0.01
    ],
    [
      "repugnant",
      0.01
    ],
    [
      "obese",
      0.01
    ],
    [
      "libre",
      0.01
    ],
    [
      "graisseux",
      0.01
    ],
    [
      "empate",
      0.01
    ],
    [
      "corpulent",
      0.01
    ],
    [
      "beau",
      0.01
    ],
    [
      "rondouillard",
      0.0075
    ],
    [
      "pateux",
      0.0075
    ],
    [
      "poupard",
      0.0075
    ],
    [
      "porc",
      0.0075
    ],
    [
      "poisseux",
      0.0075
    ],
    [
      "onctueux",
      0.0075
    ],
    [
      "fecond",
      0.0075
    ],
    [
      "boulot",
      0.0075
    ],
    [
      "bouffi",
      0.0075
    ],
    [
      "vaste",
      0.005
    ],
    [
      "polisson",
      0.005
    ],
    [
      "pansu",
      0.005
    ],
    [
      "leste",
      0.005
    ],
    [
      "huileux",
      0.005
    ],
    [
      "gluant",
      0.005
    ],
    [
      "arrondi",
      0.005
    ],
    [
      "ample",
      0.005
    ],
    [
      "malsonnant",
      0.0
    ],
    [
      "moelleux",
      0.0
    ],
    [
      "productif",
      0.0
    ],
    [
      "rabelaisien",
      0.0
    ],
    [
      "suiffeux",
      0.0
    ],
    [
      "suintant",
      0.0
    ],
    [
      "lard",
      0.0
    ],
    [
      "grasset",
      0.0
    ],
    [
      "graisse",
      0.0
    ],
    [
      "glissant",
      0.0
    ],
    [
      "farfelu",
      0.0
    ],
    [
      "boursoufle",
      0.0
    ],
    [
      "amiteux",
      0.0
    ],
    [
      "ventru",
      0.0
    ]
  ],
  "rigolo": [
    [
      "comique",
      0.14
    ],
    [
      "amusant",
      0.1025
    ],
    [
      "drole",
      0.1025
    ],
    [
      "bouffon",
      0.065
    ],
    [
      "risible",
      0.065
    ],
    [
      "tordant",
      0.065
    ],
    [
      "plaisant",
      0.055
    ],
    [
      "turlupin",
      0.035
    ],
    [
      "ridicule",
      0.035
    ],
    [
      "marrant",
      0.035
    ],
    [
      "bidonnant",
      0.035
    ],
    [
      "cocasse",
      0.0275
    ],
    [
      "desopilant",
      0.0275
    ],
    [
      "pitre",
      0.0275
    ],
    [
      "roulant",
      0.0175
    ],
    [
      "pantin",
      0.0175
    ],
    [
      "guignol",
      0.0175
    ],
    [
      "gai",
      0.0175
    ],
    [
      "singe",
      0.0075
    ],
    [
      "rigolard",
      0.0075
    ],
    [
      "revolver",
      0.0075
    ],
    [
      "poilant",
      0.0075
    ],
    [
      "pistolet",
      0.0075
    ],
    [
      "facetieux",
      0.0075
    ],
    [
      "charlot",
      0.0075
    ],
    [
      "badin",
      0.0075
    ]
  ],
  "chipolata": [
    [
      "ragout",
      0.5
    ],
    [
      "saucisse",
      0.5
    ]
  ],
  "revu": [
    [
      "corriger",
      0.1175
    ],
    [
      "reviser",
      0.11
    ],
    [
      "retoucher",
      0.075
    ],
    [
      "repasser",
      0.0575
    ],
    [
      "chatier",
      0.05
    ],
    [
      "verifier",
      0.04
    ],
    [
      "reprendre",
      0.04
    ],
    [
      "ameliorer",
      0.0325
    ],
    [
      "rectifier",
      0.0325
    ],
    [
      "repeter",
      0.025
    ],
    [
      "reformer",
      0.025
    ],
    [
      "revivre",
      0.025
    ],
    [
      "repenser",
      0.025
    ],
    [
      "remanier",
      0.025
    ],
    [
      "polir",
      0.025
    ],
    [
      "parfaire",
      0.025
    ],
    [
      "voir",
      0.015
    ],
    [
      "recoler",
      0.015
    ],
    [
      "revisiter",
      0.015
    ],
    [
      "raboter",
      0.015
    ],
    [
      "examiner",
      0.015
    ],
    [
      "retrouver",
      0.0075
    ],
    [
      "reconsiderer",
      0.0075
    ],
    [
      "ravauder",
      0.0075
    ],
    [
      "rapiecer",
      0.0075
    ],
    [
      "rapetasser",
      0.0075
    ],
    [
      "raccommoder",
      0.0075
    ],
    [
      "limer",
      0.0075
    ],
    [
      "fatiguer",
      0.0075
    ],
    [
      "songer",
      0.0075
    ]
  ],
  "faubourg": [
    [
      "banlieue",
      0.25
    ],
    [
      "peripherie",
      0.25
    ],
    [
      "zone",
      0.25
    ],
    [
      "agglomeration",
      0.125
    ],
    [
      "quartier",
      0.125
    ]
  ],
  "flonflon": [
    [
      "chanson",
      0.5
    ],
    [
      "musique",
      0.5
    ]
  ],
  "valser": [
    [
      "valdinguer",
      0.285
    ],
    [
      "balancer",
      0.1425
    ],
    [
      "cabrioler",
      0.1425
    ],
    [
      "danser",
      0.1425
    ],
    [
      "dinguer",
      0.1425
    ]
  ],
  "valse": [
    [
      "danse",
      0.3075
    ],
    [
      "torgnole",
      0.075
    ],
    [
      "roulee",
      0.075
    ],
    [
      "remous",
      0.075
    ],
    [
      "raclee",
      0.075
    ],
    [
      "mouvement",
      0.075
    ],
    [
      "mazurka",
      0.075
    ],
    [
      "boston",
      0.075
    ],
    [
      "bal",
      0.075
    ],
    [
      "volee",
      0.075
    ]
  ],
  "musette": [
    [
      "sacoche",
      0.1425
    ],
    [
      "gibeciere",
      0.095
    ],
    [
      "pipeau",
      0.0475
    ],
    [
      "musaraigne",
      0.0475
    ],
    [
      "mangeoire",
      0.0475
    ],
    [
      "loure",
      0.0475
    ],
    [
      "hautbois",
      0.0475
    ],
    [
      "guinguette",
      0.0475
    ],
    [
      "cornemuse",
      0.0475
    ],
    [
      "cartouchiere",
      0.0475
    ],
    [
      "cartable",
      0.0475
    ],
    [
      "carnassiere",
      0.0475
    ],
    [
      "cabrette",
      0.0475
    ],
    [
      "bombarde",
      0.0475
    ],
    [
      "biniou",
      0.0475
    ],
    [
      "bastringue",
      0.0475
    ],
    [
      "bal",
      0.0475
    ],
    [
      "sachet",
      0.0475
    ]
  ],
  "redire": [
    [
      "repeter",
      0.2
    ],
    [
      "raconter",
      0.125
    ],
    [
      "seriner",
      0.1
    ],
    [
      "rabacher",
      0.075
    ],
    [
      "ressasser",
      0.075
    ],
    [
      "rememorer",
      0.05
    ],
    [
      "rapporter",
      0.05
    ],
    [
      "rappeler",
      0.05
    ],
    [
      "chanter",
      0.05
    ],
    [
      "reprendre",
      0.025
    ],
    [
      "reciter",
      0.025
    ],
    [
      "recriminer",
      0.025
    ],
    [
      "reiterer",
      0.025
    ],
    [
      "reveler",
      0.025
    ],
    [
      "epiloguer",
      0.025
    ]
  ],
  "basket": [
    [
      "chaussure",
      1.0
    ]
  ],
  "crayon": [
    [
      "dessin",
      0.1425
    ],
    [
      "esquisse",
      0.105
    ],
    [
      "peinture",
      0.105
    ],
    [
      "ebauche",
      0.105
    ],
    [
      "portrait",
      0.07
    ],
    [
      "pochade",
      0.07
    ],
    [
      "fusain",
      0.07
    ],
    [
      "croquis",
      0.07
    ],
    [
      "canevas",
      0.07
    ],
    [
      "charbon",
      0.035
    ],
    [
      "pastel",
      0.035
    ],
    [
      "plan",
      0.035
    ],
    [
      "sanguine",
      0.035
    ],
    [
      "stylo",
      0.035
    ]
  ],
  "rembobiner": [
    [
      "bobiner",
      1.0
    ]
  ],
  "lesquels": [
    [
      "dont",
      0.3325
    ],
    [
      "qui",
      0.3325
    ],
    [
      "quoi",
      0.3325
    ]
  ],
  "survet": [],
  "houppette": [
    [
      "houppe",
      0.3325
    ],
    [
      "flocon",
      0.165
    ],
    [
      "plumet",
      0.165
    ],
    [
      "toupet",
      0.165
    ],
    [
      "toupillon",
      0.165
    ]
  ],
  "loft": [
    [
      "appartement",
      1.0
    ]
  ],
  "mensuel": [
    [
      "revue",
      1.0
    ]
  ],
  "kerosene": [
    [
      "carburant",
      0.5
    ],
    [
      "petrole",
      0.5
    ]
  ],
  "jet": [
    [
      "jaillissement",
      0.0725
    ],
    [
      "rejeton",
      0.0725
    ],
    [
      "geyser",
      0.0525
    ],
    [
      "projection",
      0.0525
    ],
    [
      "rejet",
      0.035
    ],
    [
      "scion",
      0.035
    ],
    [
      "surgeon",
      0.035
    ],
    [
      "trait",
      0.035
    ],
    [
      "emission",
      0.035
    ],
    [
      "eruption",
      0.035
    ],
    [
      "rayon",
      0.035
    ],
    [
      "pousse",
      0.035
    ],
    [
      "lancement",
      0.035
    ],
    [
      "bourgeon",
      0.035
    ],
    [
      "drageon",
      0.035
    ],
    [
      "flux",
      0.035
    ],
    [
      "fusee",
      0.035
    ],
    [
      "gerbe",
      0.035
    ],
    [
      "giclee",
      0.035
    ],
    [
      "ebauche",
      0.0175
    ],
    [
      "trajectoire",
      0.0175
    ],
    [
      "ruissellement",
      0.0175
    ],
    [
      "rayonnement",
      0.0175
    ],
    [
      "propulsion",
      0.0175
    ],
    [
      "lancer",
      0.0175
    ],
    [
      "jete",
      0.0175
    ],
    [
      "flot",
      0.0175
    ],
    [
      "coup",
      0.0175
    ],
    [
      "avion",
      0.0175
    ],
    [
      "ejaculation",
      0.0175
    ]
  ],
  "lingot": [
    [
      "barre",
      0.165
    ],
    [
      "billette",
      0.165
    ],
    [
      "cadrat",
      0.165
    ],
    [
      "gueuse",
      0.165
    ],
    [
      "morceau",
      0.165
    ],
    [
      "pain",
      0.165
    ]
  ],
  "dilemme": [
    [
      "alternative",
      0.25
    ],
    [
      "choix",
      0.25
    ],
    [
      "option",
      0.25
    ],
    [
      "raisonnement",
      0.25
    ]
  ],
  "spa": [],
  "caviar": [
    [
      "beluga",
      1.0
    ]
  ],
  "garage": [
    [
      "remise",
      0.25
    ],
    [
      "abri",
      0.165
    ],
    [
      "box",
      0.0825
    ],
    [
      "depot",
      0.0825
    ],
    [
      "hangar",
      0.0825
    ],
    [
      "parcage",
      0.0825
    ],
    [
      "parking",
      0.0825
    ],
    [
      "remisage",
      0.0825
    ],
    [
      "evitement",
      0.0825
    ]
  ],
  "soulager": [
    [
      "calmer",
      0.0875
    ],
    [
      "apaiser",
      0.08
    ],
    [
      "adoucir",
      0.065
    ],
    [
      "diminuer",
      0.065
    ],
    [
      "decharger",
      0.0575
    ],
    [
      "alleger",
      0.0575
    ],
    [
      "consoler",
      0.05
    ],
    [
      "endormir",
      0.0425
    ],
    [
      "attenuer",
      0.035
    ],
    [
      "debarrasser",
      0.035
    ],
    [
      "liberer",
      0.0275
    ],
    [
      "guerir",
      0.0275
    ],
    [
      "epancher",
      0.02
    ],
    [
      "delivrer",
      0.02
    ],
    [
      "delester",
      0.02
    ],
    [
      "bercer",
      0.02
    ],
    [
      "aider",
      0.02
    ],
    [
      "oter",
      0.0125
    ],
    [
      "etourdir",
      0.0125
    ],
    [
      "voler",
      0.0125
    ],
    [
      "temperer",
      0.0125
    ],
    [
      "servir",
      0.0125
    ],
    [
      "reconforter",
      0.0125
    ],
    [
      "exonerer",
      0.0125
    ],
    [
      "degrever",
      0.0125
    ],
    [
      "degonfler",
      0.0125
    ],
    [
      "cicatriser",
      0.0125
    ],
    [
      "assister",
      0.0125
    ],
    [
      "insensibiliser",
      0.005
    ],
    [
      "mitiger",
      0.005
    ],
    [
      "remedier",
      0.005
    ],
    [
      "satisfaire",
      0.005
    ],
    [
      "devaliser",
      0.005
    ],
    [
      "detendre",
      0.005
    ],
    [
      "desalterer",
      0.005
    ],
    [
      "debonder",
      0.005
    ],
    [
      "apporter",
      0.005
    ],
    [
      "amoindrir",
      0.005
    ],
    [
      "secourir",
      0.005
    ]
  ],
  "noue": [
    [
      "attacher",
      0.1225
    ],
    [
      "fixer",
      0.0725
    ],
    [
      "joindre",
      0.0725
    ],
    [
      "lier",
      0.0725
    ],
    [
      "tresser",
      0.0725
    ],
    [
      "etablir",
      0.0475
    ],
    [
      "tisser",
      0.0475
    ],
    [
      "preparer",
      0.0475
    ],
    [
      "monter",
      0.0475
    ],
    [
      "entrelacer",
      0.0475
    ],
    [
      "entortiller",
      0.0475
    ],
    [
      "combiner",
      0.0475
    ],
    [
      "arrimer",
      0.0475
    ],
    [
      "ourdir",
      0.0225
    ],
    [
      "manigancer",
      0.0225
    ],
    [
      "machiner",
      0.0225
    ],
    [
      "lacer",
      0.0225
    ],
    [
      "fermer",
      0.0225
    ],
    [
      "envelopper",
      0.0225
    ],
    [
      "contracter",
      0.0225
    ],
    [
      "tramer",
      0.0225
    ]
  ],
  "insolence": [
    [
      "impertinence",
      0.08
    ],
    [
      "arrogance",
      0.07
    ],
    [
      "audace",
      0.07
    ],
    [
      "impudence",
      0.07
    ],
    [
      "inconvenance",
      0.07
    ],
    [
      "effronterie",
      0.06
    ],
    [
      "irreverence",
      0.05
    ],
    [
      "hardiesse",
      0.05
    ],
    [
      "grossierete",
      0.05
    ],
    [
      "morgue",
      0.04
    ],
    [
      "outrecuidance",
      0.04
    ],
    [
      "superbe",
      0.03
    ],
    [
      "orgueil",
      0.03
    ],
    [
      "injure",
      0.03
    ],
    [
      "incorrection",
      0.03
    ],
    [
      "impolitesse",
      0.03
    ],
    [
      "affront",
      0.03
    ],
    [
      "temerite",
      0.02
    ],
    [
      "offense",
      0.02
    ],
    [
      "insulte",
      0.02
    ],
    [
      "incongruite",
      0.02
    ],
    [
      "hauteur",
      0.02
    ],
    [
      "cynisme",
      0.01
    ],
    [
      "dedain",
      0.01
    ],
    [
      "irrespect",
      0.01
    ],
    [
      "suffisance",
      0.01
    ]
  ],
  "troubler": [
    [
      "bouleverser",
      0.075
    ],
    [
      "emouvoir",
      0.0475
    ],
    [
      "deranger",
      0.0425
    ],
    [
      "agiter",
      0.04
    ],
    [
      "remuer",
      0.035
    ],
    [
      "embarrasser",
      0.0275
    ],
    [
      "deconcerter",
      0.0275
    ],
    [
      "brouiller",
      0.025
    ],
    [
      "inquieter",
      0.025
    ],
    [
      "toucher",
      0.025
    ],
    [
      "ebranler",
      0.02
    ],
    [
      "perturber",
      0.02
    ],
    [
      "impressionner",
      0.02
    ],
    [
      "frapper",
      0.0175
    ],
    [
      "secouer",
      0.0175
    ],
    [
      "tourmenter",
      0.0175
    ],
    [
      "affoler",
      0.0175
    ],
    [
      "confondre",
      0.015
    ],
    [
      "atteindre",
      0.015
    ],
    [
      "alterer",
      0.015
    ],
    [
      "etonner",
      0.0125
    ],
    [
      "renverser",
      0.0125
    ],
    [
      "embrouiller",
      0.0125
    ],
    [
      "derouter",
      0.0125
    ],
    [
      "travailler",
      0.01
    ],
    [
      "saisir",
      0.01
    ],
    [
      "revolutionner",
      0.01
    ],
    [
      "gener",
      0.01
    ],
    [
      "desorienter",
      0.01
    ],
    [
      "chagriner",
      0.01
    ],
    [
      "egarer",
      0.01
    ],
    [
      "pervertir",
      0.01
    ],
    [
      "exciter",
      0.01
    ],
    [
      "detruire",
      0.01
    ],
    [
      "contrarier",
      0.01
    ],
    [
      "seduire",
      0.0075
    ],
    [
      "intimider",
      0.0075
    ],
    [
      "detraquer",
      0.0075
    ],
    [
      "bousculer",
      0.0075
    ],
    [
      "alarmer",
      0.0075
    ],
    [
      "affecter",
      0.0075
    ],
    [
      "retourner",
      0.0075
    ],
    [
      "offusquer",
      0.0075
    ],
    [
      "fasciner",
      0.0075
    ],
    [
      "desorganiser",
      0.0075
    ],
    [
      "deregler",
      0.0075
    ],
    [
      "demonter",
      0.0075
    ],
    [
      "corrompre",
      0.0075
    ],
    [
      "eblouir",
      0.005
    ],
    [
      "touiller",
      0.005
    ],
    [
      "preoccuper",
      0.005
    ],
    [
      "gater",
      0.005
    ],
    [
      "effaroucher",
      0.005
    ],
    [
      "destabiliser",
      0.005
    ],
    [
      "affliger",
      0.005
    ],
    [
      "turlupiner",
      0.0025
    ],
    [
      "offenser",
      0.0025
    ],
    [
      "obscurcir",
      0.0025
    ],
    [
      "melanger",
      0.0025
    ],
    [
      "interdire",
      0.0025
    ],
    [
      "incommoder",
      0.0025
    ],
    [
      "enfievrer",
      0.0025
    ],
    [
      "desarconner",
      0.0025
    ],
    [
      "ahurir",
      0.0025
    ],
    [
      "accidenter",
      0.0025
    ],
    [
      "enivrer",
      0.0025
    ],
    [
      "envouter",
      0.0025
    ],
    [
      "glacer",
      0.0025
    ],
    [
      "interrompre",
      0.0025
    ],
    [
      "rompre",
      0.0025
    ],
    [
      "empoisonner",
      0.0025
    ],
    [
      "effarer",
      0.0025
    ],
    [
      "affrioler",
      0.0025
    ],
    [
      "aliener",
      0.0025
    ],
    [
      "aveugler",
      0.0025
    ],
    [
      "bouiller",
      0.0025
    ],
    [
      "bouler",
      0.0025
    ],
    [
      "decomposer",
      0.0025
    ],
    [
      "rabouiller",
      0.0
    ],
    [
      "intriguer",
      0.0
    ],
    [
      "ensorceler",
      0.0
    ],
    [
      "embrumer",
      0.0
    ],
    [
      "desagencer",
      0.0
    ],
    [
      "attendrir",
      0.0
    ],
    [
      "assieger",
      0.0
    ],
    [
      "abasourdir",
      0.0
    ],
    [
      "subvertir",
      0.0
    ]
  ],
  "trouble": [
    [
      "agitation",
      0.0775
    ],
    [
      "desordre",
      0.04
    ],
    [
      "emotion",
      0.0275
    ],
    [
      "bouleversement",
      0.025
    ],
    [
      "derangement",
      0.0225
    ],
    [
      "effervescence",
      0.0225
    ],
    [
      "perturbation",
      0.0225
    ],
    [
      "mouvement",
      0.0225
    ],
    [
      "affolement",
      0.02
    ],
    [
      "malaise",
      0.0175
    ],
    [
      "revolte",
      0.0175
    ],
    [
      "egarement",
      0.0175
    ],
    [
      "secousse",
      0.0175
    ],
    [
      "confusion",
      0.015
    ],
    [
      "orage",
      0.015
    ],
    [
      "obscur",
      0.015
    ],
    [
      "nebuleux",
      0.015
    ],
    [
      "convulsion",
      0.0125
    ],
    [
      "tourmente",
      0.0125
    ],
    [
      "vague",
      0.0125
    ],
    [
      "etourdissement",
      0.0125
    ],
    [
      "ebranlement",
      0.01
    ],
    [
      "soulevement",
      0.01
    ],
    [
      "revolution",
      0.01
    ],
    [
      "folie",
      0.01
    ],
    [
      "fievre",
      0.01
    ],
    [
      "excitation",
      0.01
    ],
    [
      "desarroi",
      0.01
    ],
    [
      "vertige",
      0.01
    ],
    [
      "tenebreux",
      0.01
    ],
    [
      "tempete",
      0.01
    ],
    [
      "discorde",
      0.01
    ],
    [
      "emeute",
      0.0075
    ],
    [
      "tumulte",
      0.0075
    ],
    [
      "sibyllin",
      0.0075
    ],
    [
      "maladie",
      0.0075
    ],
    [
      "inquietude",
      0.0075
    ],
    [
      "fermentation",
      0.0075
    ],
    [
      "confus",
      0.0075
    ],
    [
      "emoi",
      0.0075
    ],
    [
      "tension",
      0.0075
    ],
    [
      "remous",
      0.0075
    ],
    [
      "passion",
      0.0075
    ],
    [
      "mesintelligence",
      0.0075
    ],
    [
      "embarras",
      0.0075
    ],
    [
      "crise",
      0.0075
    ],
    [
      "commotion",
      0.0075
    ],
    [
      "timide",
      0.005
    ],
    [
      "flou",
      0.005
    ],
    [
      "desaccord",
      0.005
    ],
    [
      "alteration",
      0.005
    ],
    [
      "affection",
      0.005
    ],
    [
      "eblouissement",
      0.005
    ],
    [
      "renversement",
      0.005
    ],
    [
      "dereglement",
      0.005
    ],
    [
      "delire",
      0.005
    ],
    [
      "douteux",
      0.005
    ],
    [
      "dispute",
      0.005
    ],
    [
      "chaos",
      0.005
    ],
    [
      "brouille",
      0.005
    ],
    [
      "alienation",
      0.005
    ],
    [
      "turbulence",
      0.0025
    ],
    [
      "tracas",
      0.0025
    ],
    [
      "soubresaut",
      0.0025
    ],
    [
      "insurrection",
      0.0025
    ],
    [
      "indecision",
      0.0025
    ],
    [
      "embrouille",
      0.0025
    ],
    [
      "effarement",
      0.0025
    ],
    [
      "desequilibre",
      0.0025
    ],
    [
      "dissension",
      0.0025
    ],
    [
      "brouillerie",
      0.0025
    ],
    [
      "aveuglement",
      0.0025
    ],
    [
      "indecis",
      0.0025
    ],
    [
      "louche",
      0.0025
    ],
    [
      "nuage",
      0.0025
    ],
    [
      "zizanie",
      0.0025
    ],
    [
      "ebullition",
      0.0025
    ],
    [
      "indistinct",
      0.0025
    ],
    [
      "fumeux",
      0.0025
    ],
    [
      "faction",
      0.0025
    ],
    [
      "embrasement",
      0.0025
    ],
    [
      "desorganisation",
      0.0025
    ],
    [
      "decomposition",
      0.0025
    ],
    [
      "dechirement",
      0.0025
    ],
    [
      "nuageux",
      0.0
    ],
    [
      "melancolie",
      0.0
    ],
    [
      "mutinerie",
      0.0
    ],
    [
      "lesion",
      0.0
    ],
    [
      "inextricable",
      0.0
    ],
    [
      "indisposition",
      0.0
    ],
    [
      "nevrose",
      0.0
    ],
    [
      "ouragan",
      0.0
    ],
    [
      "peur",
      0.0
    ],
    [
      "remuement",
      0.0
    ],
    [
      "syncope",
      0.0
    ],
    [
      "vapeurs",
      0.0
    ],
    [
      "vaseux",
      0.0
    ],
    [
      "evanouissement",
      0.0
    ],
    [
      "gene",
      0.0
    ],
    [
      "fascination",
      0.0
    ],
    [
      "aberration",
      0.0
    ],
    [
      "anarchie",
      0.0
    ],
    [
      "atteinte",
      0.0
    ],
    [
      "barouf",
      0.0
    ],
    [
      "bouderie",
      0.0
    ],
    [
      "boueux",
      0.0
    ],
    [
      "bourbeux",
      0.0
    ],
    [
      "bruit",
      0.0
    ],
    [
      "fangeux",
      0.0
    ],
    [
      "enivrement",
      0.0
    ],
    [
      "effroi",
      0.0
    ],
    [
      "detresse",
      0.0
    ],
    [
      "complique",
      0.0
    ],
    [
      "brumeux",
      0.0
    ],
    [
      "indefini",
      0.0
    ],
    [
      "inquietant",
      0.0
    ],
    [
      "limoneux",
      0.0
    ],
    [
      "manifestation",
      0.0
    ],
    [
      "opaque",
      0.0
    ],
    [
      "perplexite",
      0.0
    ],
    [
      "peripetie",
      0.0
    ],
    [
      "suspect",
      0.0
    ],
    [
      "indebrouillable",
      0.0
    ],
    [
      "impur",
      0.0
    ],
    [
      "ahurissement",
      0.0
    ],
    [
      "attendrissement",
      0.0
    ],
    [
      "bisbille",
      0.0
    ],
    [
      "complexe",
      0.0
    ],
    [
      "dissentiment",
      0.0
    ],
    [
      "effarouchement",
      0.0
    ],
    [
      "frousse",
      0.0
    ],
    [
      "terne",
      0.0
    ]
  ],
  "innocence": [
    [
      "candeur",
      0.1875
    ],
    [
      "ingenuite",
      0.155
    ],
    [
      "naivete",
      0.155
    ],
    [
      "simplicite",
      0.125
    ],
    [
      "purete",
      0.0925
    ],
    [
      "credulite",
      0.06
    ],
    [
      "niaiserie",
      0.03
    ],
    [
      "innocuite",
      0.03
    ],
    [
      "ignorance",
      0.03
    ],
    [
      "fraicheur",
      0.03
    ],
    [
      "bonte",
      0.03
    ],
    [
      "blancheur",
      0.03
    ],
    [
      "virginite",
      0.03
    ]
  ],
  "mele": [
    [
      "melanger",
      0.2175
    ],
    [
      "reunir",
      0.06
    ],
    [
      "unir",
      0.045
    ],
    [
      "amalgamer",
      0.04
    ],
    [
      "fusionner",
      0.04
    ],
    [
      "combiner",
      0.0325
    ],
    [
      "associer",
      0.0325
    ],
    [
      "joindre",
      0.025
    ],
    [
      "incorporer",
      0.025
    ],
    [
      "entrelacer",
      0.025
    ],
    [
      "couper",
      0.025
    ],
    [
      "confondre",
      0.025
    ],
    [
      "battre",
      0.025
    ],
    [
      "touiller",
      0.02
    ],
    [
      "entremeler",
      0.02
    ],
    [
      "enchevetrer",
      0.02
    ],
    [
      "croiser",
      0.02
    ],
    [
      "brouiller",
      0.02
    ],
    [
      "matiner",
      0.0125
    ],
    [
      "marier",
      0.0125
    ],
    [
      "fouetter",
      0.0125
    ],
    [
      "fondre",
      0.0125
    ],
    [
      "emmeler",
      0.0125
    ],
    [
      "embrouiller",
      0.0125
    ],
    [
      "comprendre",
      0.0125
    ],
    [
      "brasser",
      0.0125
    ],
    [
      "allier",
      0.0125
    ],
    [
      "agiter",
      0.0125
    ],
    [
      "agglomerer",
      0.0125
    ],
    [
      "accoupler",
      0.0125
    ],
    [
      "mixtionner",
      0.005
    ],
    [
      "mouiller",
      0.005
    ],
    [
      "panacher",
      0.005
    ],
    [
      "saupoudrer",
      0.005
    ],
    [
      "temperer",
      0.005
    ],
    [
      "manipuler",
      0.005
    ],
    [
      "malaxer",
      0.005
    ],
    [
      "impliquer",
      0.005
    ],
    [
      "ficher",
      0.005
    ],
    [
      "fatiguer",
      0.005
    ],
    [
      "doser",
      0.005
    ],
    [
      "agglutiner",
      0.005
    ],
    [
      "unifier",
      0.005
    ]
  ],
  "gener": [
    [
      "contrarier",
      0.0625
    ],
    [
      "entraver",
      0.06
    ],
    [
      "embarrasser",
      0.055
    ],
    [
      "freiner",
      0.05
    ],
    [
      "empecher",
      0.045
    ],
    [
      "chagriner",
      0.0375
    ],
    [
      "troubler",
      0.0325
    ],
    [
      "tourmenter",
      0.0325
    ],
    [
      "serrer",
      0.0325
    ],
    [
      "paralyser",
      0.0325
    ],
    [
      "importuner",
      0.0325
    ],
    [
      "ennuyer",
      0.0325
    ],
    [
      "comprimer",
      0.0325
    ],
    [
      "nuire",
      0.025
    ],
    [
      "brider",
      0.025
    ],
    [
      "contraindre",
      0.02
    ],
    [
      "deranger",
      0.02
    ],
    [
      "navrer",
      0.02
    ],
    [
      "torturer",
      0.015
    ],
    [
      "ralentir",
      0.015
    ],
    [
      "obstruer",
      0.015
    ],
    [
      "incommoder",
      0.015
    ],
    [
      "desservir",
      0.015
    ],
    [
      "etouffer",
      0.01
    ],
    [
      "peser",
      0.01
    ],
    [
      "oppresser",
      0.01
    ],
    [
      "intimider",
      0.01
    ],
    [
      "enrayer",
      0.01
    ],
    [
      "deplaire",
      0.01
    ],
    [
      "contrecarrer",
      0.01
    ],
    [
      "atteler",
      0.01
    ],
    [
      "travailler",
      0.0075
    ],
    [
      "restreindre",
      0.0075
    ],
    [
      "opprimer",
      0.0075
    ],
    [
      "limiter",
      0.0075
    ],
    [
      "indisposer",
      0.0075
    ],
    [
      "harceler",
      0.0075
    ],
    [
      "encombrer",
      0.0075
    ],
    [
      "desavantager",
      0.0075
    ],
    [
      "affecter",
      0.0075
    ],
    [
      "retarder",
      0.0025
    ],
    [
      "sangler",
      0.0025
    ],
    [
      "supplicier",
      0.0025
    ],
    [
      "handicaper",
      0.0025
    ],
    [
      "gehenner",
      0.0025
    ],
    [
      "geler",
      0.0025
    ],
    [
      "engoncer",
      0.0025
    ],
    [
      "empetrer",
      0.0025
    ],
    [
      "embouteiller",
      0.0025
    ],
    [
      "angoisser",
      0.0025
    ],
    [
      "traverser",
      0.0025
    ]
  ],
  "rebeller": [
    [
      "resister",
      0.1175
    ],
    [
      "s'opposer",
      0.0975
    ],
    [
      "s'insurger",
      0.075
    ],
    [
      "refuser",
      0.0525
    ],
    [
      "regimber",
      0.0525
    ],
    [
      "reagir",
      0.0425
    ],
    [
      "protester",
      0.0325
    ],
    [
      "desobeir",
      0.02
    ],
    [
      "braver",
      0.01
    ],
    [
      "remuer",
      0.01
    ],
    [
      "transgresser",
      0.01
    ]
  ],
  "rebelle": [
    [
      "insoumis",
      0.1175
    ],
    [
      "recalcitrant",
      0.0925
    ],
    [
      "seditieux",
      0.085
    ],
    [
      "revolte",
      0.075
    ],
    [
      "refractaire",
      0.0575
    ],
    [
      "desobeissant",
      0.05
    ],
    [
      "resistant",
      0.0425
    ],
    [
      "indocile",
      0.0425
    ],
    [
      "factieux",
      0.0325
    ],
    [
      "retif",
      0.0325
    ],
    [
      "revolutionnaire",
      0.025
    ],
    [
      "opiniatre",
      0.025
    ],
    [
      "mutin",
      0.025
    ],
    [
      "indiscipline",
      0.025
    ],
    [
      "frondeur",
      0.025
    ],
    [
      "dissident",
      0.025
    ],
    [
      "contestataire",
      0.025
    ],
    [
      "sourd",
      0.015
    ],
    [
      "oppose",
      0.015
    ],
    [
      "maquisard",
      0.015
    ],
    [
      "insurge",
      0.015
    ],
    [
      "insubordonne",
      0.015
    ],
    [
      "ferme",
      0.015
    ],
    [
      "insurrectionnel",
      0.0075
    ],
    [
      "insensible",
      0.0075
    ],
    [
      "infranchissable",
      0.0075
    ],
    [
      "indisciplinable",
      0.0075
    ],
    [
      "impropre",
      0.0075
    ],
    [
      "impermeable",
      0.0075
    ],
    [
      "guerillero",
      0.0075
    ],
    [
      "discordant",
      0.0075
    ],
    [
      "tenace",
      0.0075
    ]
  ],
  "ghetto": [
    [
      "juiverie",
      0.3325
    ],
    [
      "mellah",
      0.3325
    ],
    [
      "quartier",
      0.3325
    ]
  ],
  "conflit": [
    [
      "dispute",
      0.115
    ],
    [
      "opposition",
      0.0925
    ],
    [
      "lutte",
      0.065
    ],
    [
      "contestation",
      0.0575
    ],
    [
      "desaccord",
      0.0575
    ],
    [
      "querelle",
      0.0525
    ],
    [
      "combat",
      0.0475
    ],
    [
      "guerre",
      0.0425
    ],
    [
      "heurt",
      0.04
    ],
    [
      "difficulte",
      0.03
    ],
    [
      "discussion",
      0.03
    ],
    [
      "dissension",
      0.03
    ],
    [
      "chicane",
      0.025
    ],
    [
      "contradiction",
      0.025
    ],
    [
      "divergence",
      0.025
    ],
    [
      "choc",
      0.02
    ],
    [
      "bataille",
      0.02
    ],
    [
      "antagonisme",
      0.02
    ],
    [
      "affrontement",
      0.02
    ],
    [
      "differend",
      0.0175
    ],
    [
      "discorde",
      0.0175
    ],
    [
      "tiraillement",
      0.0125
    ],
    [
      "debat",
      0.0125
    ],
    [
      "divorce",
      0.0125
    ],
    [
      "belligerance",
      0.0125
    ],
    [
      "rivalite",
      0.0075
    ],
    [
      "dissonance",
      0.0075
    ],
    [
      "competition",
      0.0075
    ],
    [
      "collision",
      0.0075
    ],
    [
      "tiraillerie",
      0.0025
    ],
    [
      "litige",
      0.0025
    ],
    [
      "hostilites",
      0.0025
    ],
    [
      "froissement",
      0.0025
    ],
    [
      "dissentiment",
      0.0025
    ],
    [
      "conflagration",
      0.0025
    ],
    [
      "clash",
      0.0025
    ]
  ],
  "tableau": [
    [
      "peinture",
      0.07
    ],
    [
      "image",
      0.0675
    ],
    [
      "liste",
      0.055
    ],
    [
      "catalogue",
      0.05
    ],
    [
      "representation",
      0.05
    ],
    [
      "repertoire",
      0.0425
    ],
    [
      "vue",
      0.0425
    ],
    [
      "etat",
      0.0325
    ],
    [
      "table",
      0.0325
    ],
    [
      "spectacle",
      0.0325
    ],
    [
      "figure",
      0.0325
    ],
    [
      "description",
      0.0275
    ],
    [
      "inventaire",
      0.0275
    ],
    [
      "panorama",
      0.0275
    ],
    [
      "vision",
      0.02
    ],
    [
      "paysage",
      0.02
    ],
    [
      "denombrement",
      0.02
    ],
    [
      "enumeration",
      0.015
    ],
    [
      "tablette",
      0.015
    ],
    [
      "scene",
      0.015
    ],
    [
      "role",
      0.015
    ],
    [
      "recit",
      0.015
    ],
    [
      "esquisse",
      0.015
    ],
    [
      "allegorie",
      0.015
    ],
    [
      "site",
      0.01
    ],
    [
      "releve",
      0.01
    ],
    [
      "portrait",
      0.01
    ],
    [
      "polyptyque",
      0.01
    ],
    [
      "pochade",
      0.01
    ],
    [
      "graphique",
      0.01
    ],
    [
      "feerie",
      0.01
    ],
    [
      "diptyque",
      0.01
    ],
    [
      "canevas",
      0.01
    ],
    [
      "cadre",
      0.01
    ],
    [
      "aspect",
      0.01
    ],
    [
      "panneau",
      0.0025
    ],
    [
      "nu",
      0.0025
    ],
    [
      "nomenclature",
      0.0025
    ],
    [
      "navet",
      0.0025
    ],
    [
      "tableautin",
      0.0025
    ],
    [
      "tablier",
      0.0025
    ],
    [
      "tarif",
      0.0025
    ],
    [
      "toile",
      0.0025
    ],
    [
      "transparent",
      0.0025
    ],
    [
      "triptyque",
      0.0025
    ],
    [
      "narration",
      0.0025
    ],
    [
      "bilan",
      0.0025
    ],
    [
      "calendrier",
      0.0025
    ],
    [
      "canon",
      0.0025
    ],
    [
      "croute",
      0.0025
    ],
    [
      "diorama",
      0.0025
    ],
    [
      "fresque",
      0.0025
    ],
    [
      "index",
      0.0025
    ],
    [
      "medaillon",
      0.0025
    ],
    [
      "memoire",
      0.0025
    ]
  ],
  "decu": [
    [
      "tromper",
      0.125
    ],
    [
      "abuser",
      0.0775
    ],
    [
      "berner",
      0.0775
    ],
    [
      "desappointer",
      0.0775
    ],
    [
      "chagriner",
      0.06
    ],
    [
      "navrer",
      0.06
    ],
    [
      "desoler",
      0.045
    ],
    [
      "attraper",
      0.045
    ],
    [
      "trahir",
      0.03
    ],
    [
      "seduire",
      0.03
    ],
    [
      "leurrer",
      0.03
    ],
    [
      "frustrer",
      0.03
    ],
    [
      "ennuyer",
      0.03
    ],
    [
      "desillusionner",
      0.03
    ],
    [
      "desenchanter",
      0.03
    ],
    [
      "depiter",
      0.03
    ],
    [
      "defriser",
      0.03
    ],
    [
      "duper",
      0.03
    ],
    [
      "amuser",
      0.03
    ],
    [
      "surprendre",
      0.015
    ],
    [
      "detruire",
      0.015
    ],
    [
      "desesperer",
      0.015
    ],
    [
      "dementir",
      0.015
    ],
    [
      "echauder",
      0.015
    ]
  ],
  "secheresse": [
    [
      "durete",
      0.1425
    ],
    [
      "froideur",
      0.1125
    ],
    [
      "insensibilite",
      0.1125
    ],
    [
      "rudesse",
      0.055
    ],
    [
      "rigidite",
      0.055
    ],
    [
      "indifference",
      0.055
    ],
    [
      "brusquerie",
      0.055
    ],
    [
      "brievete",
      0.055
    ],
    [
      "austerite",
      0.055
    ],
    [
      "aridite",
      0.055
    ],
    [
      "sterilite",
      0.0275
    ],
    [
      "siccite",
      0.0275
    ],
    [
      "pauvrete",
      0.0275
    ],
    [
      "morgue",
      0.0275
    ],
    [
      "dessechement",
      0.0275
    ],
    [
      "concision",
      0.0275
    ],
    [
      "anhydrie",
      0.0275
    ],
    [
      "egoisme",
      0.0275
    ]
  ],
  "baratin": [
    [
      "boniment",
      0.1975
    ],
    [
      "bagou",
      0.1175
    ],
    [
      "bavardage",
      0.0775
    ],
    [
      "blablabla",
      0.0775
    ],
    [
      "bluff",
      0.0575
    ],
    [
      "laius",
      0.0575
    ],
    [
      "propos",
      0.0375
    ],
    [
      "hablerie",
      0.0375
    ],
    [
      "faconde",
      0.0375
    ],
    [
      "conte",
      0.0375
    ],
    [
      "abattage",
      0.0375
    ],
    [
      "speech",
      0.0175
    ],
    [
      "platine",
      0.0175
    ],
    [
      "parlote",
      0.0175
    ],
    [
      "fable",
      0.0175
    ],
    [
      "charme",
      0.0175
    ],
    [
      "betise",
      0.0175
    ],
    [
      "brio",
      0.0175
    ],
    [
      "bourrage",
      0.0175
    ],
    [
      "topo",
      0.0175
    ]
  ],
  "arrache": [
    [
      "enlever",
      0.0975
    ],
    [
      "oter",
      0.055
    ],
    [
      "retirer",
      0.0475
    ],
    [
      "prendre",
      0.04
    ],
    [
      "separer",
      0.0325
    ],
    [
      "detacher",
      0.0325
    ],
    [
      "deraciner",
      0.0325
    ],
    [
      "couper",
      0.0325
    ],
    [
      "extirper",
      0.0275
    ],
    [
      "extraire",
      0.0275
    ],
    [
      "tirer",
      0.0275
    ],
    [
      "eloigner",
      0.025
    ],
    [
      "soustraire",
      0.025
    ],
    [
      "obtenir",
      0.025
    ],
    [
      "depouiller",
      0.025
    ],
    [
      "chasser",
      0.025
    ],
    [
      "ecarter",
      0.02
    ],
    [
      "soutirer",
      0.02
    ],
    [
      "emporter",
      0.02
    ],
    [
      "detourner",
      0.02
    ],
    [
      "debarrasser",
      0.02
    ],
    [
      "dechirer",
      0.0175
    ],
    [
      "sortir",
      0.0125
    ],
    [
      "sarcler",
      0.0125
    ],
    [
      "rompre",
      0.0125
    ],
    [
      "nettoyer",
      0.0125
    ],
    [
      "forcer",
      0.0125
    ],
    [
      "extorquer",
      0.0125
    ],
    [
      "decouvrir",
      0.0125
    ],
    [
      "surprendre",
      0.01
    ],
    [
      "preserver",
      0.01
    ],
    [
      "exiler",
      0.01
    ],
    [
      "bannir",
      0.01
    ],
    [
      "ecorcher",
      0.005
    ],
    [
      "sauver",
      0.005
    ],
    [
      "remporter",
      0.005
    ],
    [
      "ravir",
      0.005
    ],
    [
      "plumer",
      0.005
    ],
    [
      "expulser",
      0.005
    ],
    [
      "essarter",
      0.005
    ],
    [
      "effeuiller",
      0.005
    ],
    [
      "chaumer",
      0.005
    ],
    [
      "demunir",
      0.005
    ],
    [
      "desoler",
      0.005
    ],
    [
      "deterrer",
      0.005
    ],
    [
      "devoiler",
      0.005
    ],
    [
      "epiler",
      0.0025
    ],
    [
      "recolter",
      0.0025
    ],
    [
      "lacerer",
      0.0025
    ],
    [
      "essoucher",
      0.0025
    ],
    [
      "desesperer",
      0.0025
    ],
    [
      "deplanter",
      0.0025
    ],
    [
      "depiler",
      0.0025
    ],
    [
      "demasquer",
      0.0025
    ],
    [
      "defricher",
      0.0025
    ],
    [
      "dechaumer",
      0.0025
    ],
    [
      "debroussailler",
      0.0025
    ],
    [
      "etraper",
      0.0025
    ]
  ],
  "cravacher": [
    [
      "battre",
      0.25
    ],
    [
      "cingler",
      0.125
    ],
    [
      "flageller",
      0.125
    ],
    [
      "fouailler",
      0.125
    ],
    [
      "fouetter",
      0.125
    ],
    [
      "fustiger",
      0.125
    ],
    [
      "houssiner",
      0.125
    ]
  ],
  "empocher": [
    [
      "encaisser",
      0.21
    ],
    [
      "gagner",
      0.18
    ],
    [
      "recevoir",
      0.12
    ],
    [
      "toucher",
      0.12
    ],
    [
      "ramasser",
      0.09
    ],
    [
      "recolter",
      0.06
    ],
    [
      "percevoir",
      0.06
    ],
    [
      "attraper",
      0.06
    ],
    [
      "essuyer",
      0.0275
    ],
    [
      "palper",
      0.0275
    ],
    [
      "s'approprier",
      0.0275
    ]
  ],
  "distribuer": [
    [
      "repartir",
      0.11
    ],
    [
      "ordonner",
      0.0675
    ],
    [
      "donner",
      0.0625
    ],
    [
      "classer",
      0.0525
    ],
    [
      "attribuer",
      0.0475
    ],
    [
      "repandre",
      0.04
    ],
    [
      "organiser",
      0.035
    ],
    [
      "partager",
      0.035
    ],
    [
      "ranger",
      0.035
    ],
    [
      "disposer",
      0.03
    ],
    [
      "diviser",
      0.025
    ],
    [
      "dispenser",
      0.025
    ],
    [
      "arranger",
      0.025
    ],
    [
      "jeter",
      0.02
    ],
    [
      "hierarchiser",
      0.02
    ],
    [
      "disperser",
      0.02
    ],
    [
      "conduire",
      0.02
    ],
    [
      "assigner",
      0.02
    ],
    [
      "eparpiller",
      0.015
    ],
    [
      "echelonner",
      0.015
    ],
    [
      "octroyer",
      0.015
    ],
    [
      "impartir",
      0.015
    ],
    [
      "departir",
      0.015
    ],
    [
      "allouer",
      0.015
    ],
    [
      "agencer",
      0.015
    ],
    [
      "administrer",
      0.015
    ],
    [
      "semer",
      0.01
    ],
    [
      "prodiguer",
      0.01
    ],
    [
      "mesurer",
      0.01
    ],
    [
      "gratifier",
      0.01
    ],
    [
      "decerner",
      0.01
    ],
    [
      "coordonner",
      0.01
    ],
    [
      "classifier",
      0.01
    ],
    [
      "caser",
      0.01
    ],
    [
      "amenager",
      0.01
    ],
    [
      "aliener",
      0.01
    ],
    [
      "disseminer",
      0.0025
    ],
    [
      "distinguer",
      0.0025
    ],
    [
      "doser",
      0.0025
    ],
    [
      "ordonnancer",
      0.0025
    ],
    [
      "diffuser",
      0.0025
    ],
    [
      "conditionner",
      0.0025
    ],
    [
      "categoriser",
      0.0025
    ],
    [
      "canaliser",
      0.0025
    ],
    [
      "arroser",
      0.0025
    ],
    [
      "amener",
      0.0025
    ],
    [
      "allotir",
      0.0025
    ],
    [
      "servir",
      0.0025
    ]
  ],
  "patibulaire": [
    [
      "inquietant",
      0.3325
    ],
    [
      "menacant",
      0.3325
    ],
    [
      "sinistre",
      0.3325
    ]
  ],
  "comparaitre": [
    [
      "comparoir",
      0.2
    ],
    [
      "paraitre",
      0.2
    ],
    [
      "temoigner",
      0.2
    ]
  ],
  "goudron": [
    [
      "bitume",
      0.2
    ],
    [
      "macadam",
      0.2
    ],
    [
      "asphalte",
      0.1
    ],
    [
      "brai",
      0.1
    ],
    [
      "coaltar",
      0.1
    ],
    [
      "combustible",
      0.1
    ],
    [
      "poix",
      0.1
    ],
    [
      "tarmacadam",
      0.1
    ]
  ],
  "matiere": [
    [
      "sujet",
      0.1
    ],
    [
      "objet",
      0.0625
    ],
    [
      "cause",
      0.055
    ],
    [
      "fond",
      0.055
    ],
    [
      "substance",
      0.05
    ],
    [
      "theme",
      0.05
    ],
    [
      "lieu",
      0.0425
    ],
    [
      "point",
      0.0425
    ],
    [
      "terrain",
      0.0375
    ],
    [
      "occasion",
      0.0375
    ],
    [
      "chapitre",
      0.0375
    ],
    [
      "fondement",
      0.03
    ],
    [
      "partie",
      0.03
    ],
    [
      "secteur",
      0.03
    ],
    [
      "champ",
      0.025
    ],
    [
      "element",
      0.0175
    ],
    [
      "motif",
      0.0175
    ],
    [
      "materiau",
      0.0175
    ],
    [
      "fable",
      0.0175
    ],
    [
      "domaine",
      0.0175
    ],
    [
      "article",
      0.0175
    ],
    [
      "etoffe",
      0.0125
    ],
    [
      "texte",
      0.0125
    ],
    [
      "rencontre",
      0.0125
    ],
    [
      "question",
      0.0125
    ],
    [
      "pretexte",
      0.0125
    ],
    [
      "propos",
      0.0125
    ],
    [
      "enseignement",
      0.0125
    ],
    [
      "corps",
      0.0125
    ],
    [
      "contenu",
      0.0125
    ],
    [
      "cas",
      0.0125
    ],
    [
      "base",
      0.0125
    ],
    [
      "solide",
      0.005
    ],
    [
      "metal",
      0.005
    ],
    [
      "materiel",
      0.005
    ],
    [
      "discipline",
      0.005
    ],
    [
      "chef",
      0.005
    ],
    [
      "trame",
      0.005
    ]
  ],
  "griser": [
    [
      "enivrer",
      0.12
    ],
    [
      "exciter",
      0.12
    ],
    [
      "etourdir",
      0.12
    ],
    [
      "enflammer",
      0.09
    ],
    [
      "enthousiasmer",
      0.09
    ],
    [
      "souler",
      0.06
    ],
    [
      "exalter",
      0.06
    ],
    [
      "charmer",
      0.06
    ],
    [
      "emballer",
      0.03
    ],
    [
      "ensorceler",
      0.03
    ],
    [
      "taper",
      0.03
    ],
    [
      "electriser",
      0.03
    ],
    [
      "emoustiller",
      0.03
    ]
  ],
  "acquisition": [
    [
      "achat",
      0.1525
    ],
    [
      "appropriation",
      0.1525
    ],
    [
      "possession",
      0.1525
    ],
    [
      "emplette",
      0.075
    ],
    [
      "conquet",
      0.075
    ],
    [
      "connaissance",
      0.075
    ],
    [
      "assimilation",
      0.075
    ],
    [
      "apprentissage",
      0.075
    ],
    [
      "acquet",
      0.075
    ],
    [
      "enrichissement",
      0.075
    ]
  ],
  "consecration": [
    [
      "confirmation",
      0.105
    ],
    [
      "inauguration",
      0.105
    ],
    [
      "bapteme",
      0.07
    ],
    [
      "benediction",
      0.07
    ],
    [
      "gloire",
      0.07
    ],
    [
      "triomphe",
      0.07
    ],
    [
      "ratification",
      0.035
    ],
    [
      "sacre",
      0.035
    ],
    [
      "sanctification",
      0.035
    ],
    [
      "sanction",
      0.035
    ],
    [
      "validation",
      0.035
    ],
    [
      "onction",
      0.035
    ],
    [
      "impanation",
      0.035
    ],
    [
      "illustration",
      0.035
    ],
    [
      "eucharistie",
      0.035
    ],
    [
      "espece",
      0.035
    ],
    [
      "devouement",
      0.035
    ],
    [
      "dedicace",
      0.035
    ],
    [
      "apotheose",
      0.035
    ],
    [
      "victoire",
      0.035
    ]
  ],
  "fee": [
    [
      "genie",
      0.285
    ],
    [
      "deesse",
      0.1425
    ],
    [
      "esprit",
      0.1425
    ],
    [
      "korrigan",
      0.1425
    ],
    [
      "magicienne",
      0.1425
    ],
    [
      "sorciere",
      0.1425
    ]
  ],
  "action": [
    [
      "acte",
      0.0375
    ],
    [
      "affaire",
      0.0375
    ],
    [
      "ardeur",
      0.0275
    ],
    [
      "attaque",
      0.0275
    ],
    [
      "force",
      0.0275
    ],
    [
      "travail",
      0.0225
    ],
    [
      "mouvement",
      0.0225
    ],
    [
      "effet",
      0.0225
    ],
    [
      "chaleur",
      0.02
    ],
    [
      "exploit",
      0.02
    ],
    [
      "fait",
      0.02
    ],
    [
      "feu",
      0.0175
    ],
    [
      "entreprise",
      0.0175
    ],
    [
      "demarche",
      0.0175
    ],
    [
      "conduite",
      0.0175
    ],
    [
      "choc",
      0.0175
    ],
    [
      "activite",
      0.0175
    ],
    [
      "energie",
      0.015
    ],
    [
      "trait",
      0.015
    ],
    [
      "pratique",
      0.015
    ],
    [
      "operation",
      0.015
    ],
    [
      "oeuvre",
      0.015
    ],
    [
      "effort",
      0.015
    ],
    [
      "evenement",
      0.0125
    ],
    [
      "valeur",
      0.0125
    ],
    [
      "realisation",
      0.0125
    ],
    [
      "poursuite",
      0.0125
    ],
    [
      "intrigue",
      0.0125
    ],
    [
      "influence",
      0.0125
    ],
    [
      "geste",
      0.0125
    ],
    [
      "execution",
      0.0125
    ],
    [
      "demande",
      0.0125
    ],
    [
      "comportement",
      0.0125
    ],
    [
      "vie",
      0.01
    ],
    [
      "manoeuvre",
      0.01
    ],
    [
      "lutte",
      0.01
    ],
    [
      "instance",
      0.01
    ],
    [
      "enthousiasme",
      0.01
    ],
    [
      "efficacite",
      0.01
    ],
    [
      "coup",
      0.01
    ],
    [
      "combat",
      0.01
    ],
    [
      "bataille",
      0.01
    ],
    [
      "intervention",
      0.005
    ],
    [
      "pression",
      0.005
    ],
    [
      "proces",
      0.005
    ],
    [
      "rapport",
      0.005
    ],
    [
      "recours",
      0.005
    ],
    [
      "requete",
      0.005
    ],
    [
      "revolte",
      0.005
    ],
    [
      "soulevement",
      0.005
    ],
    [
      "vehemence",
      0.005
    ],
    [
      "initiative",
      0.005
    ],
    [
      "fonctionnement",
      0.005
    ],
    [
      "excitation",
      0.005
    ],
    [
      "accusation",
      0.005
    ],
    [
      "agissements",
      0.005
    ],
    [
      "animation",
      0.005
    ],
    [
      "cause",
      0.005
    ],
    [
      "contenance",
      0.005
    ],
    [
      "discours",
      0.005
    ],
    [
      "decision",
      0.005
    ],
    [
      "developpement",
      0.005
    ],
    [
      "engagement",
      0.005
    ],
    [
      "part",
      0.0025
    ],
    [
      "politique",
      0.0025
    ],
    [
      "portee",
      0.0025
    ],
    [
      "procedure",
      0.0025
    ],
    [
      "prouesse",
      0.0025
    ],
    [
      "reaction",
      0.0025
    ],
    [
      "titre",
      0.0025
    ],
    [
      "main",
      0.0025
    ],
    [
      "jeu",
      0.0025
    ],
    [
      "agent",
      0.0025
    ],
    [
      "agression",
      0.0025
    ],
    [
      "assignation",
      0.0025
    ],
    [
      "cas",
      0.0025
    ],
    [
      "impression",
      0.0025
    ],
    [
      "scenario",
      0.0
    ],
    [
      "refere",
      0.0
    ],
    [
      "peripetie",
      0.0
    ],
    [
      "pourvoi",
      0.0
    ],
    [
      "plainte",
      0.0
    ],
    [
      "plaidoirie",
      0.0
    ],
    [
      "mission",
      0.0
    ],
    [
      "induction",
      0.0
    ],
    [
      "faire",
      0.0
    ],
    [
      "chose",
      0.0
    ],
    [
      "brio",
      0.0
    ],
    [
      "sermon",
      0.0
    ]
  ],
  "ballade": [
    [
      "poeme",
      0.25
    ],
    [
      "chanson",
      0.165
    ],
    [
      "chant",
      0.165
    ],
    [
      "fete",
      0.0825
    ],
    [
      "lied",
      0.0825
    ],
    [
      "refrain",
      0.0825
    ],
    [
      "rotrouenge",
      0.0825
    ],
    [
      "virelai",
      0.0825
    ]
  ],
  "titre": [
    [
      "billet",
      0.055
    ],
    [
      "qualite",
      0.055
    ],
    [
      "valeur",
      0.055
    ],
    [
      "acte",
      0.0475
    ],
    [
      "diplome",
      0.04
    ],
    [
      "certificat",
      0.04
    ],
    [
      "papier",
      0.0325
    ],
    [
      "piece",
      0.0325
    ],
    [
      "rang",
      0.0325
    ],
    [
      "loi",
      0.0275
    ],
    [
      "fonction",
      0.0275
    ],
    [
      "brevet",
      0.0275
    ],
    [
      "qualification",
      0.02
    ],
    [
      "partie",
      0.02
    ],
    [
      "obligation",
      0.02
    ],
    [
      "nom",
      0.02
    ],
    [
      "grade",
      0.02
    ],
    [
      "effet",
      0.02
    ],
    [
      "droit",
      0.02
    ],
    [
      "article",
      0.02
    ],
    [
      "bon",
      0.02
    ],
    [
      "caractere",
      0.02
    ],
    [
      "degre",
      0.02
    ],
    [
      "dignite",
      0.02
    ],
    [
      "reconnaissance",
      0.0125
    ],
    [
      "portefeuille",
      0.0125
    ],
    [
      "poids",
      0.0125
    ],
    [
      "patente",
      0.0125
    ],
    [
      "designation",
      0.0125
    ],
    [
      "document",
      0.0125
    ],
    [
      "aloi",
      0.0125
    ],
    [
      "action",
      0.0125
    ],
    [
      "intitule",
      0.005
    ],
    [
      "manchette",
      0.005
    ],
    [
      "parchemin",
      0.005
    ],
    [
      "particularite",
      0.005
    ],
    [
      "propriete",
      0.005
    ],
    [
      "raison",
      0.005
    ],
    [
      "rubrique",
      0.005
    ],
    [
      "specification",
      0.005
    ],
    [
      "teneur",
      0.005
    ],
    [
      "titrage",
      0.005
    ],
    [
      "intitulation",
      0.005
    ],
    [
      "instrument",
      0.005
    ],
    [
      "appellation",
      0.005
    ],
    [
      "blason",
      0.005
    ],
    [
      "carte",
      0.005
    ],
    [
      "chapitre",
      0.005
    ],
    [
      "charte",
      0.005
    ],
    [
      "commission",
      0.005
    ],
    [
      "cedule",
      0.005
    ],
    [
      "frontispice",
      0.005
    ],
    [
      "inscription",
      0.005
    ],
    [
      "warrant",
      0.005
    ]
  ],
  "titrer": [],
  "grade": [
    [
      "rang",
      0.1775
    ],
    [
      "degre",
      0.1425
    ],
    [
      "classe",
      0.105
    ],
    [
      "dignite",
      0.105
    ],
    [
      "promotion",
      0.105
    ],
    [
      "titre",
      0.105
    ],
    [
      "indice",
      0.035
    ],
    [
      "honneur",
      0.035
    ],
    [
      "gradation",
      0.035
    ],
    [
      "diplome",
      0.035
    ],
    [
      "categorie",
      0.035
    ],
    [
      "avancement",
      0.035
    ],
    [
      "echelon",
      0.035
    ]
  ],
  "drague": [
    [
      "chaland",
      0.11
    ],
    [
      "dragage",
      0.11
    ],
    [
      "draguette",
      0.11
    ],
    [
      "dragueur",
      0.11
    ],
    [
      "drainette",
      0.11
    ],
    [
      "excavateur",
      0.11
    ],
    [
      "refouleur",
      0.11
    ]
  ],
  "rigolade": [
    [
      "amusement",
      0.13
    ],
    [
      "bagatelle",
      0.13
    ],
    [
      "plaisanterie",
      0.085
    ],
    [
      "joie",
      0.085
    ],
    [
      "facetie",
      0.085
    ],
    [
      "fable",
      0.085
    ],
    [
      "blague",
      0.085
    ],
    [
      "baliverne",
      0.085
    ],
    [
      "bouffonnerie",
      0.0425
    ],
    [
      "divertissement",
      0.0425
    ],
    [
      "foutaise",
      0.0425
    ],
    [
      "marrade",
      0.0425
    ],
    [
      "rire",
      0.0425
    ]
  ],
  "flambeur": [
    [
      "bruleur",
      1.0
    ]
  ],
  "gadget": [
    [
      "appareil",
      0.5
    ],
    [
      "gimmick",
      0.5
    ]
  ],
  "choc": [
    [
      "coup",
      0.0625
    ],
    [
      "heurt",
      0.055
    ],
    [
      "combat",
      0.05
    ],
    [
      "lutte",
      0.05
    ],
    [
      "attaque",
      0.045
    ],
    [
      "rencontre",
      0.0375
    ],
    [
      "bataille",
      0.0375
    ],
    [
      "collision",
      0.0325
    ],
    [
      "commotion",
      0.0325
    ],
    [
      "echauffouree",
      0.0325
    ],
    [
      "engagement",
      0.03
    ],
    [
      "effet",
      0.03
    ],
    [
      "affrontement",
      0.03
    ],
    [
      "action",
      0.03
    ],
    [
      "accrochage",
      0.03
    ],
    [
      "accident",
      0.03
    ],
    [
      "affaire",
      0.025
    ],
    [
      "emotion",
      0.02
    ],
    [
      "ebranlement",
      0.02
    ],
    [
      "opposition",
      0.02
    ],
    [
      "conflit",
      0.02
    ],
    [
      "secousse",
      0.015
    ],
    [
      "saisissement",
      0.01
    ],
    [
      "reaction",
      0.01
    ],
    [
      "offensive",
      0.01
    ],
    [
      "melee",
      0.01
    ],
    [
      "impact",
      0.01
    ],
    [
      "blessure",
      0.01
    ],
    [
      "atteinte",
      0.01
    ],
    [
      "assaut",
      0.01
    ],
    [
      "traumatisme",
      0.0075
    ],
    [
      "tamponnement",
      0.0075
    ],
    [
      "sensation",
      0.0075
    ],
    [
      "scandale",
      0.0075
    ],
    [
      "explosion",
      0.0075
    ],
    [
      "contrecoup",
      0.0075
    ],
    [
      "charge",
      0.0075
    ],
    [
      "antagonisme",
      0.0075
    ],
    [
      "abordage",
      0.0075
    ],
    [
      "revers",
      0.0025
    ],
    [
      "repercussion",
      0.0025
    ],
    [
      "stress",
      0.0025
    ],
    [
      "telescopage",
      0.0025
    ],
    [
      "vicissitude",
      0.0025
    ],
    [
      "projection",
      0.0025
    ],
    [
      "percussion",
      0.0025
    ],
    [
      "jete",
      0.0025
    ],
    [
      "frappement",
      0.0025
    ],
    [
      "carambolage",
      0.0025
    ],
    [
      "canot",
      0.0025
    ],
    [
      "bouleversement",
      0.0025
    ],
    [
      "etourdissement",
      0.0025
    ]
  ],
  "nageoire": [
    [
      "aileron",
      1.0
    ]
  ],
  "frayeur": [
    [
      "peur",
      0.1175
    ],
    [
      "effroi",
      0.0975
    ],
    [
      "alarme",
      0.085
    ],
    [
      "epouvante",
      0.0775
    ],
    [
      "frousse",
      0.0775
    ],
    [
      "crainte",
      0.0775
    ],
    [
      "inquietude",
      0.065
    ],
    [
      "terreur",
      0.065
    ],
    [
      "angoisse",
      0.0375
    ],
    [
      "transe",
      0.0325
    ],
    [
      "horreur",
      0.025
    ],
    [
      "apprehension",
      0.025
    ],
    [
      "affres",
      0.025
    ],
    [
      "trouille",
      0.0175
    ],
    [
      "panique",
      0.0175
    ],
    [
      "anxiete",
      0.0175
    ],
    [
      "alerte",
      0.0175
    ],
    [
      "affolement",
      0.0175
    ],
    [
      "phobie",
      0.0125
    ],
    [
      "trac",
      0.0125
    ],
    [
      "consternation",
      0.005
    ],
    [
      "petoche",
      0.005
    ],
    [
      "tremblement",
      0.005
    ],
    [
      "epouvantement",
      0.005
    ]
  ],
  "sirene": [
    [
      "alarme",
      0.2
    ],
    [
      "magicienne",
      0.2
    ],
    [
      "prostituee",
      0.2
    ],
    [
      "siren",
      0.2
    ],
    [
      "sorciere",
      0.2
    ]
  ],
  "emoi": [
    [
      "emotion",
      0.1425
    ],
    [
      "agitation",
      0.0925
    ],
    [
      "inquietude",
      0.0925
    ],
    [
      "tourment",
      0.0575
    ],
    [
      "trouble",
      0.0575
    ],
    [
      "alarme",
      0.05
    ],
    [
      "bouleversement",
      0.05
    ],
    [
      "tracas",
      0.04
    ],
    [
      "souci",
      0.04
    ],
    [
      "affres",
      0.0325
    ],
    [
      "crainte",
      0.0325
    ],
    [
      "ebranlement",
      0.025
    ],
    [
      "sensation",
      0.025
    ],
    [
      "saisissement",
      0.025
    ],
    [
      "excitation",
      0.025
    ],
    [
      "effervescence",
      0.025
    ],
    [
      "commotion",
      0.025
    ],
    [
      "surexcitation",
      0.015
    ],
    [
      "sentiment",
      0.015
    ],
    [
      "mouvement",
      0.015
    ],
    [
      "ennui",
      0.015
    ],
    [
      "alerte",
      0.015
    ],
    [
      "attendrissement",
      0.0075
    ],
    [
      "contrariete",
      0.0075
    ],
    [
      "frisson",
      0.0075
    ],
    [
      "timidite",
      0.0075
    ]
  ],
  "troublant": [
    [
      "seduisant",
      0.09
    ],
    [
      "excitant",
      0.08
    ],
    [
      "etonnant",
      0.045
    ],
    [
      "seducteur",
      0.045
    ],
    [
      "inquietant",
      0.045
    ],
    [
      "impressionnant",
      0.045
    ],
    [
      "enjoleur",
      0.045
    ],
    [
      "affriolant",
      0.045
    ],
    [
      "emouvant",
      0.0325
    ],
    [
      "touchant",
      0.0325
    ],
    [
      "sensationnel",
      0.0325
    ],
    [
      "saisissant",
      0.0325
    ],
    [
      "ensorcelant",
      0.0325
    ],
    [
      "enivrant",
      0.0325
    ],
    [
      "deroutant",
      0.0325
    ],
    [
      "deconcertant",
      0.0325
    ],
    [
      "charmeur",
      0.0325
    ],
    [
      "aguichant",
      0.0325
    ],
    [
      "affolant",
      0.0325
    ],
    [
      "galant",
      0.0225
    ],
    [
      "frappant",
      0.0225
    ],
    [
      "fascinant",
      0.0225
    ],
    [
      "bouleversant",
      0.0225
    ],
    [
      "perturbant",
      0.01
    ],
    [
      "louche",
      0.01
    ],
    [
      "ensorceleur",
      0.01
    ],
    [
      "embarrassant",
      0.01
    ],
    [
      "derangeant",
      0.01
    ],
    [
      "capiteux",
      0.01
    ],
    [
      "agitant",
      0.01
    ],
    [
      "provocant",
      0.01
    ]
  ],
  "carrefour": [
    [
      "croisement",
      0.155
    ],
    [
      "fourche",
      0.1075
    ],
    [
      "jonction",
      0.1075
    ],
    [
      "croisee",
      0.0925
    ],
    [
      "embranchement",
      0.0925
    ],
    [
      "intersection",
      0.06
    ],
    [
      "entrecroisement",
      0.06
    ],
    [
      "bifurcation",
      0.06
    ],
    [
      "etoile",
      0.045
    ],
    [
      "reunion",
      0.03
    ],
    [
      "branchement",
      0.03
    ],
    [
      "bivoie",
      0.015
    ],
    [
      "confluent",
      0.015
    ],
    [
      "symposium",
      0.015
    ],
    [
      "echangeur",
      0.015
    ]
  ],
  "batir": [
    [
      "construire",
      0.1325
    ],
    [
      "creer",
      0.09
    ],
    [
      "etablir",
      0.09
    ],
    [
      "faire",
      0.0725
    ],
    [
      "former",
      0.0575
    ],
    [
      "composer",
      0.05
    ],
    [
      "fonder",
      0.05
    ],
    [
      "monter",
      0.045
    ],
    [
      "constituer",
      0.045
    ],
    [
      "edifier",
      0.04
    ],
    [
      "elever",
      0.04
    ],
    [
      "fabriquer",
      0.0325
    ],
    [
      "agencer",
      0.0275
    ],
    [
      "echafauder",
      0.0275
    ],
    [
      "asseoir",
      0.0225
    ],
    [
      "assembler",
      0.0225
    ],
    [
      "ajuster",
      0.0225
    ],
    [
      "faconner",
      0.015
    ],
    [
      "inventer",
      0.015
    ],
    [
      "baser",
      0.01
    ],
    [
      "coudre",
      0.01
    ],
    [
      "faufiler",
      0.01
    ],
    [
      "poser",
      0.005
    ],
    [
      "maconner",
      0.005
    ],
    [
      "greffer",
      0.005
    ],
    [
      "empointer",
      0.005
    ],
    [
      "consacrer",
      0.005
    ],
    [
      "bousiller",
      0.005
    ],
    [
      "architecturer",
      0.005
    ],
    [
      "eriger",
      0.005
    ]
  ],
  "roman": [
    [
      "conte",
      0.1375
    ],
    [
      "histoire",
      0.0925
    ],
    [
      "recit",
      0.0925
    ],
    [
      "fable",
      0.0675
    ],
    [
      "mensonge",
      0.0675
    ],
    [
      "nouvelle",
      0.045
    ],
    [
      "invention",
      0.045
    ],
    [
      "bateau",
      0.045
    ],
    [
      "chronique",
      0.03
    ],
    [
      "feuilleton",
      0.03
    ],
    [
      "narration",
      0.03
    ],
    [
      "ragot",
      0.0225
    ],
    [
      "mythe",
      0.0225
    ],
    [
      "craque",
      0.0225
    ],
    [
      "chanson",
      0.0225
    ],
    [
      "bobard",
      0.0225
    ],
    [
      "affabulation",
      0.0225
    ],
    [
      "utopie",
      0.015
    ],
    [
      "racontar",
      0.015
    ],
    [
      "hablerie",
      0.015
    ],
    [
      "farce",
      0.015
    ],
    [
      "chimere",
      0.015
    ],
    [
      "bourde",
      0.015
    ],
    [
      "romanesque",
      0.005
    ],
    [
      "romance",
      0.005
    ],
    [
      "polar",
      0.005
    ],
    [
      "litterature",
      0.005
    ],
    [
      "latin",
      0.005
    ],
    [
      "journal",
      0.005
    ],
    [
      "invraisemblance",
      0.005
    ],
    [
      "colle",
      0.005
    ],
    [
      "cancan",
      0.005
    ],
    [
      "salade",
      0.005
    ]
  ],
  "fredonner": [
    [
      "chanter",
      0.23
    ],
    [
      "murmurer",
      0.23
    ],
    [
      "bourdonner",
      0.1525
    ],
    [
      "gringotter",
      0.1525
    ],
    [
      "bruire",
      0.075
    ],
    [
      "chantonner",
      0.075
    ],
    [
      "ronfler",
      0.075
    ]
  ],
  "constellation": [
    [
      "astre",
      0.25
    ],
    [
      "asterisme",
      0.25
    ],
    [
      "groupe",
      0.25
    ],
    [
      "pleiade",
      0.25
    ]
  ],
  "membre": [
    [
      "adherent",
      0.1725
    ],
    [
      "affilie",
      0.1125
    ],
    [
      "adepte",
      0.085
    ],
    [
      "associe",
      0.085
    ],
    [
      "partisan",
      0.085
    ],
    [
      "organe",
      0.0275
    ],
    [
      "partie",
      0.0275
    ],
    [
      "ramification",
      0.0275
    ],
    [
      "recrue",
      0.0275
    ],
    [
      "societaire",
      0.0275
    ],
    [
      "soutien",
      0.0275
    ],
    [
      "morceau",
      0.0275
    ],
    [
      "jambe",
      0.0275
    ],
    [
      "inscrit",
      0.0275
    ],
    [
      "federe",
      0.0275
    ],
    [
      "division",
      0.0275
    ],
    [
      "cotisant",
      0.0275
    ],
    [
      "correspondant",
      0.0275
    ],
    [
      "bras",
      0.0275
    ],
    [
      "actionnaire",
      0.0275
    ],
    [
      "sympathisant",
      0.0275
    ]
  ],
  "flamboyant": [
    [
      "brillant",
      0.1675
    ],
    [
      "rutilant",
      0.13
    ],
    [
      "eclatant",
      0.13
    ],
    [
      "lumineux",
      0.0925
    ],
    [
      "etincelant",
      0.0925
    ],
    [
      "ardent",
      0.075
    ],
    [
      "flambant",
      0.075
    ],
    [
      "resplendissant",
      0.055
    ],
    [
      "radieux",
      0.0375
    ],
    [
      "eblouissant",
      0.0375
    ],
    [
      "brasillant",
      0.0175
    ],
    [
      "brulant",
      0.0175
    ],
    [
      "medieval",
      0.0175
    ],
    [
      "petillant",
      0.0175
    ],
    [
      "rouge",
      0.0175
    ]
  ],
  "bravo": [
    [
      "acclamation",
      0.095
    ],
    [
      "applaudissement",
      0.095
    ],
    [
      "ovation",
      0.095
    ],
    [
      "tueur",
      0.0625
    ],
    [
      "parfait",
      0.0625
    ],
    [
      "meurtrier",
      0.0625
    ],
    [
      "hourra",
      0.0625
    ],
    [
      "felicitation",
      0.0625
    ],
    [
      "bis",
      0.0625
    ],
    [
      "vivat",
      0.03
    ],
    [
      "spadassin",
      0.03
    ],
    [
      "sicaire",
      0.03
    ],
    [
      "encore",
      0.03
    ],
    [
      "bravache",
      0.03
    ],
    [
      "bien",
      0.03
    ],
    [
      "battement",
      0.03
    ],
    [
      "assassin",
      0.03
    ],
    [
      "vive",
      0.03
    ]
  ],
  "amicale": [
    [
      "cordial",
      0.1925
    ],
    [
      "sympathique",
      0.1275
    ],
    [
      "affectueux",
      0.095
    ],
    [
      "ami",
      0.095
    ],
    [
      "bienveillant",
      0.095
    ],
    [
      "chaleureux",
      0.095
    ],
    [
      "fraternel",
      0.0625
    ],
    [
      "familier",
      0.0625
    ],
    [
      "amoureux",
      0.03
    ],
    [
      "complaisant",
      0.03
    ],
    [
      "convivial",
      0.03
    ],
    [
      "intime",
      0.03
    ],
    [
      "propice",
      0.03
    ]
  ],
  "amical": [
    [
      "cordial",
      0.1925
    ],
    [
      "sympathique",
      0.1275
    ],
    [
      "affectueux",
      0.095
    ],
    [
      "ami",
      0.095
    ],
    [
      "bienveillant",
      0.095
    ],
    [
      "chaleureux",
      0.095
    ],
    [
      "fraternel",
      0.0625
    ],
    [
      "familier",
      0.0625
    ],
    [
      "amoureux",
      0.03
    ],
    [
      "complaisant",
      0.03
    ],
    [
      "convivial",
      0.03
    ],
    [
      "intime",
      0.03
    ],
    [
      "propice",
      0.03
    ]
  ],
  "clamer": [
    [
      "crier",
      0.2175
    ],
    [
      "proclamer",
      0.13
    ],
    [
      "publier",
      0.13
    ],
    [
      "trompeter",
      0.085
    ],
    [
      "tonner",
      0.0425
    ],
    [
      "tambouriner",
      0.0425
    ],
    [
      "s'egosiller",
      0.0425
    ],
    [
      "s'ecrier",
      0.0425
    ],
    [
      "orchestrer",
      0.0425
    ],
    [
      "hurler",
      0.0425
    ],
    [
      "declamer",
      0.0425
    ],
    [
      "corner",
      0.0425
    ],
    [
      "annoncer",
      0.0425
    ],
    [
      "vociferer",
      0.0425
    ]
  ],
  "impossible": [
    [
      "difficile",
      0.0675
    ],
    [
      "incroyable",
      0.05
    ],
    [
      "impraticable",
      0.045
    ],
    [
      "insupportable",
      0.045
    ],
    [
      "invivable",
      0.04
    ],
    [
      "inadmissible",
      0.035
    ],
    [
      "extravagant",
      0.03
    ],
    [
      "bizarre",
      0.03
    ],
    [
      "absurde",
      0.03
    ],
    [
      "penible",
      0.025
    ],
    [
      "invraisemblable",
      0.025
    ],
    [
      "intraitable",
      0.025
    ],
    [
      "insociable",
      0.025
    ],
    [
      "insense",
      0.025
    ],
    [
      "inconcevable",
      0.025
    ],
    [
      "inabordable",
      0.025
    ],
    [
      "fou",
      0.025
    ],
    [
      "chimerique",
      0.025
    ],
    [
      "rocambolesque",
      0.02
    ],
    [
      "ridicule",
      0.02
    ],
    [
      "intolerable",
      0.02
    ],
    [
      "inaccessible",
      0.02
    ],
    [
      "dur",
      0.02
    ],
    [
      "acariatre",
      0.02
    ],
    [
      "reveche",
      0.015
    ],
    [
      "irrealisable",
      0.015
    ],
    [
      "insoutenable",
      0.015
    ],
    [
      "imaginaire",
      0.015
    ],
    [
      "illusoire",
      0.015
    ],
    [
      "ideal",
      0.015
    ],
    [
      "contradictoire",
      0.015
    ],
    [
      "vain",
      0.01
    ],
    [
      "utopique",
      0.01
    ],
    [
      "intenable",
      0.01
    ],
    [
      "inimaginable",
      0.01
    ],
    [
      "infaisable",
      0.01
    ],
    [
      "incompatible",
      0.01
    ],
    [
      "impensable",
      0.01
    ],
    [
      "odieux",
      0.005
    ],
    [
      "malcommode",
      0.005
    ],
    [
      "irrecevable",
      0.005
    ],
    [
      "insurmontable",
      0.005
    ],
    [
      "insoluble",
      0.005
    ],
    [
      "inoui",
      0.005
    ],
    [
      "inexecutable",
      0.005
    ],
    [
      "inextricable",
      0.005
    ],
    [
      "inexcusable",
      0.005
    ],
    [
      "indu",
      0.005
    ],
    [
      "inconciliable",
      0.005
    ],
    [
      "inapplicable",
      0.005
    ],
    [
      "immateriel",
      0.005
    ],
    [
      "epineux",
      0.005
    ]
  ],
  "azur": [
    [
      "bleu",
      0.215
    ],
    [
      "ciel",
      0.1725
    ],
    [
      "azure",
      0.085
    ],
    [
      "smalt",
      0.0425
    ],
    [
      "safre",
      0.0425
    ],
    [
      "firmament",
      0.0425
    ],
    [
      "cerule",
      0.0425
    ],
    [
      "azureen",
      0.0425
    ],
    [
      "azurin",
      0.0425
    ],
    [
      "azurement",
      0.0425
    ],
    [
      "atmosphere",
      0.0425
    ],
    [
      "air",
      0.0425
    ],
    [
      "ether",
      0.0425
    ]
  ],
  "retablir": [
    [
      "restaurer",
      0.0975
    ],
    [
      "refaire",
      0.0925
    ],
    [
      "relever",
      0.08
    ],
    [
      "remettre",
      0.07
    ],
    [
      "remonter",
      0.0575
    ],
    [
      "revigorer",
      0.05
    ],
    [
      "ressusciter",
      0.045
    ],
    [
      "reparer",
      0.045
    ],
    [
      "reconforter",
      0.04
    ],
    [
      "reconstituer",
      0.035
    ],
    [
      "arranger",
      0.0275
    ],
    [
      "ranimer",
      0.0275
    ],
    [
      "recomposer",
      0.0275
    ],
    [
      "revivifier",
      0.0225
    ],
    [
      "reedifier",
      0.0225
    ],
    [
      "repeter",
      0.015
    ],
    [
      "restituer",
      0.015
    ],
    [
      "renouveler",
      0.015
    ],
    [
      "redresser",
      0.015
    ],
    [
      "redonner",
      0.015
    ],
    [
      "reconstruire",
      0.015
    ],
    [
      "ramener",
      0.015
    ],
    [
      "rajuster",
      0.015
    ],
    [
      "guerir",
      0.015
    ],
    [
      "retremper",
      0.01
    ],
    [
      "rectifier",
      0.01
    ],
    [
      "ameliorer",
      0.01
    ],
    [
      "reintegrer",
      0.005
    ],
    [
      "reinstaller",
      0.005
    ],
    [
      "rehabiliter",
      0.005
    ],
    [
      "refectionner",
      0.005
    ],
    [
      "requinquer",
      0.005
    ],
    [
      "replacer",
      0.005
    ],
    [
      "sauver",
      0.005
    ]
  ],
  "miraculeux": [
    [
      "extraordinaire",
      0.1525
    ],
    [
      "merveilleux",
      0.1525
    ],
    [
      "prodigieux",
      0.1525
    ],
    [
      "fabuleux",
      0.115
    ],
    [
      "fantastique",
      0.115
    ],
    [
      "etonnant",
      0.075
    ],
    [
      "surnaturel",
      0.075
    ],
    [
      "prestigieux",
      0.0375
    ],
    [
      "sensationnel",
      0.0375
    ],
    [
      "thaumaturge",
      0.0375
    ],
    [
      "thaumaturgique",
      0.0375
    ]
  ],
  "devon": [
    [
      "appat",
      0.5
    ],
    [
      "esche",
      0.5
    ]
  ],
  "miracle": [
    [
      "prodige",
      0.285
    ],
    [
      "merveille",
      0.1425
    ],
    [
      "mystere",
      0.1425
    ],
    [
      "phenomene",
      0.1425
    ],
    [
      "signe",
      0.1425
    ],
    [
      "theatre",
      0.1425
    ]
  ],
  "abnegation": [
    [
      "desinteressement",
      0.16
    ],
    [
      "renoncement",
      0.1125
    ],
    [
      "generosite",
      0.09
    ],
    [
      "resignation",
      0.09
    ],
    [
      "abandon",
      0.0675
    ],
    [
      "altruisme",
      0.0675
    ],
    [
      "devouement",
      0.0675
    ],
    [
      "sacrifice",
      0.0675
    ],
    [
      "detachement",
      0.0425
    ],
    [
      "bonte",
      0.0425
    ],
    [
      "acceptation",
      0.02
    ],
    [
      "austerite",
      0.02
    ],
    [
      "fanatisme",
      0.02
    ],
    [
      "holocauste",
      0.02
    ],
    [
      "humilite",
      0.02
    ],
    [
      "zele",
      0.02
    ]
  ],
  "perdurer": [
    [
      "subsister",
      0.4
    ],
    [
      "persister",
      0.2
    ]
  ],
  "transmettre": [
    [
      "donner",
      0.115
    ],
    [
      "transporter",
      0.075
    ],
    [
      "communiquer",
      0.065
    ],
    [
      "passer",
      0.065
    ],
    [
      "remettre",
      0.0575
    ],
    [
      "ceder",
      0.05
    ],
    [
      "transferer",
      0.04
    ],
    [
      "envoyer",
      0.0325
    ],
    [
      "laisser",
      0.0325
    ],
    [
      "renvoyer",
      0.025
    ],
    [
      "leguer",
      0.025
    ],
    [
      "inoculer",
      0.025
    ],
    [
      "deleguer",
      0.025
    ],
    [
      "diffuser",
      0.025
    ],
    [
      "aliener",
      0.025
    ],
    [
      "vehiculer",
      0.015
    ],
    [
      "transfuser",
      0.015
    ],
    [
      "signifier",
      0.015
    ],
    [
      "reverberer",
      0.015
    ],
    [
      "retroceder",
      0.015
    ],
    [
      "propager",
      0.015
    ],
    [
      "infuser",
      0.015
    ],
    [
      "imprimer",
      0.0075
    ],
    [
      "notifier",
      0.0075
    ],
    [
      "negocier",
      0.0075
    ],
    [
      "perpetuer",
      0.0075
    ],
    [
      "retransmettre",
      0.0075
    ],
    [
      "repercuter",
      0.0075
    ],
    [
      "telegraphier",
      0.0075
    ],
    [
      "immortaliser",
      0.0075
    ],
    [
      "imiter",
      0.0075
    ],
    [
      "fournir",
      0.0075
    ],
    [
      "contaminer",
      0.0075
    ],
    [
      "conduire",
      0.0075
    ],
    [
      "conceder",
      0.0075
    ],
    [
      "apprendre",
      0.0075
    ],
    [
      "adresser",
      0.0075
    ],
    [
      "temoigner",
      0.0075
    ]
  ],
  "activer": [
    [
      "pousser",
      0.13
    ],
    [
      "precipiter",
      0.1
    ],
    [
      "accelerer",
      0.085
    ],
    [
      "exciter",
      0.085
    ],
    [
      "presser",
      0.085
    ],
    [
      "stimuler",
      0.0725
    ],
    [
      "brusquer",
      0.0725
    ],
    [
      "animer",
      0.0725
    ],
    [
      "hater",
      0.0575
    ],
    [
      "bousculer",
      0.0425
    ],
    [
      "attiser",
      0.0425
    ],
    [
      "avancer",
      0.0275
    ],
    [
      "tisonner",
      0.0125
    ],
    [
      "talonner",
      0.0125
    ],
    [
      "souffler",
      0.0125
    ],
    [
      "depecher",
      0.0125
    ],
    [
      "dynamiser",
      0.0125
    ],
    [
      "diligenter",
      0.0125
    ],
    [
      "aviver",
      0.0125
    ],
    [
      "vivifier",
      0.0125
    ]
  ],
  "admirer": [
    [
      "aimer",
      0.08
    ],
    [
      "exalter",
      0.065
    ],
    [
      "venerer",
      0.065
    ],
    [
      "s'exclamer",
      0.0475
    ],
    [
      "s'enthousiasmer",
      0.0475
    ],
    [
      "regarder",
      0.0475
    ],
    [
      "louer",
      0.0475
    ],
    [
      "gouter",
      0.0475
    ],
    [
      "apprecier",
      0.0475
    ],
    [
      "adorer",
      0.0475
    ],
    [
      "s'emerveiller",
      0.0325
    ],
    [
      "s'extasier",
      0.0325
    ],
    [
      "contempler",
      0.0325
    ],
    [
      "considerer",
      0.0325
    ],
    [
      "applaudir",
      0.0325
    ],
    [
      "zieuter",
      0.015
    ],
    [
      "s'etonner",
      0.015
    ],
    [
      "s'engouer",
      0.015
    ],
    [
      "s'emballer",
      0.015
    ],
    [
      "s'agenouiller",
      0.015
    ],
    [
      "louanger",
      0.015
    ],
    [
      "celebrer",
      0.015
    ],
    [
      "constater",
      0.015
    ],
    [
      "beer",
      0.015
    ]
  ],
  "maladroit": [
    [
      "gauche",
      0.1075
    ],
    [
      "balourd",
      0.1025
    ],
    [
      "sot",
      0.0725
    ],
    [
      "lourd",
      0.0425
    ],
    [
      "godiche",
      0.0425
    ],
    [
      "ballot",
      0.0425
    ],
    [
      "gourde",
      0.035
    ],
    [
      "inhabile",
      0.035
    ],
    [
      "malhabile",
      0.0275
    ],
    [
      "lourdaud",
      0.0275
    ],
    [
      "incapable",
      0.0275
    ],
    [
      "grossier",
      0.0275
    ],
    [
      "emprunte",
      0.0275
    ],
    [
      "empote",
      0.0275
    ],
    [
      "butor",
      0.02
    ],
    [
      "inexperimente",
      0.02
    ],
    [
      "malavise",
      0.02
    ],
    [
      "etourdi",
      0.0125
    ],
    [
      "mauvais",
      0.0125
    ],
    [
      "irreverencieux",
      0.0125
    ],
    [
      "gaffeur",
      0.0125
    ],
    [
      "faux",
      0.0125
    ],
    [
      "empaille",
      0.0125
    ],
    [
      "malitorne",
      0.005
    ],
    [
      "manchot",
      0.005
    ],
    [
      "massacreur",
      0.005
    ],
    [
      "mazette",
      0.005
    ],
    [
      "novice",
      0.005
    ],
    [
      "pataud",
      0.005
    ],
    [
      "sabot",
      0.005
    ],
    [
      "saboteur",
      0.005
    ],
    [
      "sabreur",
      0.005
    ],
    [
      "savate",
      0.005
    ],
    [
      "savetier",
      0.005
    ],
    [
      "temeraire",
      0.005
    ],
    [
      "maladresse",
      0.005
    ],
    [
      "jocrisse",
      0.005
    ],
    [
      "cartonnier",
      0.005
    ],
    [
      "couenne",
      0.005
    ],
    [
      "disproportionne",
      0.005
    ],
    [
      "gnaf",
      0.005
    ],
    [
      "godichon",
      0.005
    ],
    [
      "impolitique",
      0.005
    ],
    [
      "imprudent",
      0.005
    ],
    [
      "inapte",
      0.005
    ],
    [
      "inaptitude",
      0.005
    ],
    [
      "inconsidere",
      0.005
    ],
    [
      "inexerce",
      0.005
    ],
    [
      "andouille",
      0.005
    ]
  ],
  "illico": [
    [
      "aussitot",
      0.1575
    ],
    [
      "immediatement",
      0.1575
    ],
    [
      "soudain",
      0.1575
    ],
    [
      "promptement",
      0.105
    ],
    [
      "presto",
      0.0525
    ],
    [
      "d'emblee",
      0.0525
    ]
  ],
  "presto": [
    [
      "vite",
      0.235
    ],
    [
      "promptement",
      0.175
    ],
    [
      "illico",
      0.0575
    ],
    [
      "prestement",
      0.0575
    ],
    [
      "rapidement",
      0.0575
    ]
  ],
  "peintre": [
    [
      "barbouilleur",
      0.085
    ],
    [
      "enlumineur",
      0.055
    ],
    [
      "naif",
      0.0275
    ],
    [
      "orientaliste",
      0.0275
    ],
    [
      "pastelliste",
      0.0275
    ],
    [
      "paysagiste",
      0.0275
    ],
    [
      "pointilliste",
      0.0275
    ],
    [
      "pompier",
      0.0275
    ],
    [
      "portraitiste",
      0.0275
    ],
    [
      "preraphaelite",
      0.0275
    ],
    [
      "rapin",
      0.0275
    ],
    [
      "romantique",
      0.0275
    ],
    [
      "realiste",
      0.0275
    ],
    [
      "surrealiste",
      0.0275
    ],
    [
      "symboliste",
      0.0275
    ],
    [
      "naturaliste",
      0.0275
    ],
    [
      "nabi",
      0.0275
    ],
    [
      "animalier",
      0.0275
    ],
    [
      "aquarelliste",
      0.0275
    ],
    [
      "artiste",
      0.0275
    ],
    [
      "badigeonneur",
      0.0275
    ],
    [
      "classique",
      0.0275
    ],
    [
      "coloriste",
      0.0275
    ],
    [
      "cubiste",
      0.0275
    ],
    [
      "enduiseur",
      0.0275
    ],
    [
      "expressionniste",
      0.0275
    ],
    [
      "fauviste",
      0.0275
    ],
    [
      "fresquiste",
      0.0275
    ],
    [
      "illustrateur",
      0.0275
    ],
    [
      "impressionniste",
      0.0275
    ],
    [
      "miniaturiste",
      0.0275
    ],
    [
      "tachiste",
      0.0275
    ]
  ],
  "ambition": [
    [
      "desir",
      0.1325
    ],
    [
      "soif",
      0.0875
    ],
    [
      "convoitise",
      0.0775
    ],
    [
      "avidite",
      0.065
    ],
    [
      "appetit",
      0.055
    ],
    [
      "dessein",
      0.055
    ],
    [
      "visee",
      0.0425
    ],
    [
      "souhait",
      0.0425
    ],
    [
      "faim",
      0.0425
    ],
    [
      "but",
      0.0425
    ],
    [
      "aspiration",
      0.0325
    ],
    [
      "pretention",
      0.0325
    ],
    [
      "reve",
      0.02
    ],
    [
      "passion",
      0.02
    ],
    [
      "orgueil",
      0.02
    ],
    [
      "fin",
      0.02
    ],
    [
      "cupidite",
      0.02
    ],
    [
      "voeu",
      0.01
    ],
    [
      "recherche",
      0.01
    ],
    [
      "rapacite",
      0.01
    ],
    [
      "quete",
      0.01
    ],
    [
      "presomption",
      0.01
    ],
    [
      "projet",
      0.01
    ],
    [
      "objet",
      0.01
    ],
    [
      "megalomanie",
      0.01
    ],
    [
      "mobile",
      0.01
    ],
    [
      "ideal",
      0.01
    ],
    [
      "fringale",
      0.01
    ],
    [
      "brigue",
      0.01
    ],
    [
      "arrivisme",
      0.01
    ],
    [
      "ardeur",
      0.01
    ],
    [
      "vue",
      0.01
    ]
  ],
  "revolution": [
    [
      "trouble",
      0.06
    ],
    [
      "bouleversement",
      0.055
    ],
    [
      "revolte",
      0.055
    ],
    [
      "agitation",
      0.0475
    ],
    [
      "changement",
      0.0475
    ],
    [
      "emeute",
      0.0425
    ],
    [
      "tour",
      0.0425
    ],
    [
      "renversement",
      0.0425
    ],
    [
      "desordre",
      0.035
    ],
    [
      "soulevement",
      0.035
    ],
    [
      "transformation",
      0.0225
    ],
    [
      "rotation",
      0.0225
    ],
    [
      "insurrection",
      0.0225
    ],
    [
      "faction",
      0.0225
    ],
    [
      "cercle",
      0.0225
    ],
    [
      "cataclysme",
      0.0225
    ],
    [
      "evolution",
      0.0175
    ],
    [
      "volte",
      0.0175
    ],
    [
      "tourmente",
      0.0175
    ],
    [
      "mutinerie",
      0.0175
    ],
    [
      "guerre",
      0.0175
    ],
    [
      "giration",
      0.0175
    ],
    [
      "effervescence",
      0.0175
    ],
    [
      "convulsion",
      0.0175
    ],
    [
      "chambardement",
      0.0175
    ],
    [
      "innovation",
      0.01
    ],
    [
      "nouveaute",
      0.01
    ],
    [
      "revirement",
      0.01
    ],
    [
      "subversion",
      0.01
    ],
    [
      "violence",
      0.01
    ],
    [
      "incendie",
      0.01
    ],
    [
      "feu",
      0.01
    ],
    [
      "circuit",
      0.01
    ],
    [
      "conflagration",
      0.01
    ],
    [
      "conversion",
      0.01
    ],
    [
      "courbe",
      0.01
    ],
    [
      "spirale",
      0.005
    ],
    [
      "soubresaut",
      0.005
    ],
    [
      "rebellion",
      0.005
    ],
    [
      "novation",
      0.005
    ],
    [
      "mutation",
      0.005
    ],
    [
      "marche",
      0.005
    ],
    [
      "gravitation",
      0.005
    ],
    [
      "cycle",
      0.005
    ],
    [
      "circulation",
      0.005
    ],
    [
      "chamboulement",
      0.005
    ],
    [
      "ebullition",
      0.005
    ]
  ],
  "illusion": [
    [
      "chimere",
      0.0725
    ],
    [
      "mirage",
      0.0575
    ],
    [
      "reve",
      0.0575
    ],
    [
      "tromperie",
      0.0475
    ],
    [
      "vision",
      0.0475
    ],
    [
      "mensonge",
      0.0425
    ],
    [
      "reverie",
      0.0325
    ],
    [
      "idee",
      0.0325
    ],
    [
      "erreur",
      0.0325
    ],
    [
      "fantome",
      0.0275
    ],
    [
      "image",
      0.0275
    ],
    [
      "ombre",
      0.0275
    ],
    [
      "songe",
      0.0275
    ],
    [
      "fantasme",
      0.0225
    ],
    [
      "imagination",
      0.0225
    ],
    [
      "leurre",
      0.0175
    ],
    [
      "hallucination",
      0.0175
    ],
    [
      "fiction",
      0.0175
    ],
    [
      "vanite",
      0.0125
    ],
    [
      "utopie",
      0.0125
    ],
    [
      "simulation",
      0.0125
    ],
    [
      "mythe",
      0.0125
    ],
    [
      "magie",
      0.0125
    ],
    [
      "irrealite",
      0.0125
    ],
    [
      "imposture",
      0.0125
    ],
    [
      "fantasmagorie",
      0.0125
    ],
    [
      "duperie",
      0.0125
    ],
    [
      "semblant",
      0.0075
    ],
    [
      "reflet",
      0.0075
    ],
    [
      "prestidigitation",
      0.0075
    ],
    [
      "neant",
      0.0075
    ],
    [
      "irreel",
      0.0075
    ],
    [
      "impossibilite",
      0.0075
    ],
    [
      "illusionnisme",
      0.0075
    ],
    [
      "fumee",
      0.0075
    ],
    [
      "faux",
      0.0075
    ],
    [
      "carotte",
      0.0075
    ],
    [
      "feerie",
      0.0025
    ],
    [
      "hochet",
      0.0025
    ],
    [
      "manipulation",
      0.0025
    ],
    [
      "pareidolie",
      0.0025
    ],
    [
      "pensee",
      0.0025
    ],
    [
      "prestige",
      0.0025
    ],
    [
      "fantaisie",
      0.0025
    ],
    [
      "esperance",
      0.0025
    ],
    [
      "enchantement",
      0.0025
    ],
    [
      "charme",
      0.0025
    ],
    [
      "caresse",
      0.0025
    ],
    [
      "baudruche",
      0.0025
    ],
    [
      "aveuglement",
      0.0025
    ],
    [
      "amusement",
      0.0025
    ],
    [
      "aberration",
      0.0025
    ]
  ],
  "beton": [
    [
      "agglomere",
      0.3325
    ],
    [
      "ciment",
      0.3325
    ],
    [
      "mortier",
      0.3325
    ]
  ],
  "television": [
    [
      "T.V.",
      0.2
    ],
    [
      "tele",
      0.2
    ],
    [
      "telecommunication",
      0.2
    ],
    [
      "televiseur",
      0.2
    ]
  ],
  "negation": [
    [
      "contradiction",
      0.1425
    ],
    [
      "contraire",
      0.095
    ],
    [
      "contrepartie",
      0.095
    ],
    [
      "denegation",
      0.095
    ],
    [
      "refus",
      0.095
    ],
    [
      "proposition",
      0.0475
    ],
    [
      "negative",
      0.0475
    ],
    [
      "nihilisme",
      0.0475
    ],
    [
      "mepris",
      0.0475
    ],
    [
      "condamnation",
      0.0475
    ],
    [
      "antithese",
      0.0475
    ],
    [
      "annulation",
      0.0475
    ],
    [
      "refutation",
      0.0475
    ]
  ],
  "punition": [
    [
      "chatiment",
      0.1025
    ],
    [
      "peine",
      0.0825
    ],
    [
      "correction",
      0.0725
    ],
    [
      "sanction",
      0.04
    ],
    [
      "fouet",
      0.04
    ],
    [
      "condamnation",
      0.04
    ],
    [
      "coup",
      0.03
    ],
    [
      "schlague",
      0.03
    ],
    [
      "represailles",
      0.02
    ],
    [
      "retenue",
      0.02
    ],
    [
      "revanche",
      0.02
    ],
    [
      "repression",
      0.02
    ],
    [
      "supplice",
      0.02
    ],
    [
      "torture",
      0.02
    ],
    [
      "vengeance",
      0.02
    ],
    [
      "question",
      0.02
    ],
    [
      "penitence",
      0.02
    ],
    [
      "arret",
      0.02
    ],
    [
      "blame",
      0.02
    ],
    [
      "colle",
      0.02
    ],
    [
      "emprisonnement",
      0.02
    ],
    [
      "expiation",
      0.02
    ],
    [
      "fessee",
      0.02
    ],
    [
      "penalite",
      0.02
    ],
    [
      "knout",
      0.0075
    ],
    [
      "lecon",
      0.0075
    ],
    [
      "lignes",
      0.0075
    ],
    [
      "martinet",
      0.0075
    ],
    [
      "pensum",
      0.0075
    ],
    [
      "piquet",
      0.0075
    ],
    [
      "prison",
      0.0075
    ],
    [
      "privation",
      0.0075
    ],
    [
      "penalisation",
      0.0075
    ],
    [
      "reprobation",
      0.0075
    ],
    [
      "internement",
      0.0075
    ],
    [
      "gifle",
      0.0075
    ],
    [
      "calamite",
      0.0075
    ],
    [
      "coin",
      0.0075
    ],
    [
      "consigne",
      0.0075
    ],
    [
      "fleau",
      0.0075
    ],
    [
      "fustigation",
      0.0075
    ],
    [
      "gage",
      0.0075
    ],
    [
      "garcette",
      0.0075
    ],
    [
      "talion",
      0.0075
    ]
  ],
  "lequel": [
    [
      "dont",
      0.3325
    ],
    [
      "qui",
      0.3325
    ],
    [
      "quoi",
      0.3325
    ]
  ],
  "chiffon": [
    [
      "loque",
      0.125
    ],
    [
      "guenille",
      0.0925
    ],
    [
      "haillon",
      0.06
    ],
    [
      "lambeau",
      0.06
    ],
    [
      "serpilliere",
      0.06
    ],
    [
      "morceau",
      0.03
    ],
    [
      "nippes",
      0.03
    ],
    [
      "paille",
      0.03
    ],
    [
      "papier",
      0.03
    ],
    [
      "peille",
      0.03
    ],
    [
      "pilot",
      0.03
    ],
    [
      "souquenille",
      0.03
    ],
    [
      "toilette",
      0.03
    ],
    [
      "linge",
      0.03
    ],
    [
      "fripe",
      0.03
    ],
    [
      "bagatelle",
      0.03
    ],
    [
      "bourre",
      0.03
    ],
    [
      "charpie",
      0.03
    ],
    [
      "chiffe",
      0.03
    ],
    [
      "drapeau",
      0.03
    ],
    [
      "drille",
      0.03
    ],
    [
      "defroque",
      0.03
    ],
    [
      "enfant",
      0.03
    ],
    [
      "torchon",
      0.03
    ]
  ],
  "ja": [
    [
      "certes",
      0.5
    ],
    [
      "deja",
      0.5
    ]
  ],
  "respecter": [
    [
      "honorer",
      0.1425
    ],
    [
      "reverer",
      0.1425
    ],
    [
      "observer",
      0.095
    ],
    [
      "tenir",
      0.0625
    ],
    [
      "garder",
      0.0475
    ],
    [
      "adorer",
      0.0475
    ],
    [
      "venerer",
      0.03
    ],
    [
      "suivre",
      0.03
    ],
    [
      "satisfaire",
      0.03
    ],
    [
      "obeir",
      0.03
    ],
    [
      "glorifier",
      0.03
    ],
    [
      "celebrer",
      0.03
    ],
    [
      "considerer",
      0.03
    ],
    [
      "conserver",
      0.03
    ],
    [
      "saluer",
      0.015
    ],
    [
      "remplir",
      0.015
    ],
    [
      "menager",
      0.015
    ],
    [
      "magnifier",
      0.015
    ],
    [
      "estimer",
      0.015
    ],
    [
      "epargner",
      0.015
    ]
  ],
  "ber": [
    [
      "berceau",
      0.5
    ],
    [
      "colombier",
      0.5
    ]
  ],
  "secouer": [
    [
      "bouleverser",
      0.0725
    ],
    [
      "agiter",
      0.0675
    ],
    [
      "emouvoir",
      0.065
    ],
    [
      "remuer",
      0.055
    ],
    [
      "ebranler",
      0.05
    ],
    [
      "troubler",
      0.0375
    ],
    [
      "retourner",
      0.0325
    ],
    [
      "impressionner",
      0.0325
    ],
    [
      "houspiller",
      0.0325
    ],
    [
      "battre",
      0.0275
    ],
    [
      "frapper",
      0.0275
    ],
    [
      "revolutionner",
      0.0275
    ],
    [
      "bousculer",
      0.0225
    ],
    [
      "tourmenter",
      0.0175
    ],
    [
      "rudoyer",
      0.0175
    ],
    [
      "commotionner",
      0.0175
    ],
    [
      "ballotter",
      0.0175
    ],
    [
      "emotionner",
      0.015
    ],
    [
      "saisir",
      0.015
    ],
    [
      "maltraiter",
      0.015
    ],
    [
      "malmener",
      0.015
    ],
    [
      "inquieter",
      0.015
    ],
    [
      "empoigner",
      0.015
    ],
    [
      "balancer",
      0.015
    ],
    [
      "tancer",
      0.0125
    ],
    [
      "sermonner",
      0.0125
    ],
    [
      "reprimander",
      0.0125
    ],
    [
      "harceler",
      0.0125
    ],
    [
      "gourmander",
      0.0125
    ],
    [
      "cahoter",
      0.0125
    ],
    [
      "branler",
      0.0125
    ],
    [
      "traumatiser",
      0.0075
    ],
    [
      "perturber",
      0.0075
    ],
    [
      "gronder",
      0.0075
    ],
    [
      "engueuler",
      0.0075
    ],
    [
      "choquer",
      0.0075
    ],
    [
      "chavirer",
      0.0075
    ],
    [
      "brimbaler",
      0.0075
    ],
    [
      "attraper",
      0.0075
    ],
    [
      "admonester",
      0.0075
    ],
    [
      "sabouler",
      0.005
    ],
    [
      "mouvoir",
      0.005
    ],
    [
      "locher",
      0.005
    ],
    [
      "gauler",
      0.005
    ],
    [
      "chahuter",
      0.005
    ],
    [
      "brusquer",
      0.005
    ],
    [
      "talonner",
      0.0025
    ],
    [
      "reveiller",
      0.0025
    ],
    [
      "morigener",
      0.0025
    ],
    [
      "lancer",
      0.0025
    ],
    [
      "jouer",
      0.0025
    ],
    [
      "hocher",
      0.0025
    ],
    [
      "convulser",
      0.0025
    ],
    [
      "tremousser",
      0.0025
    ]
  ],
  "errer": [
    [
      "roder",
      0.1175
    ],
    [
      "flaner",
      0.0875
    ],
    [
      "trainer",
      0.07
    ],
    [
      "vagabonder",
      0.07
    ],
    [
      "marcher",
      0.065
    ],
    [
      "vaguer",
      0.04
    ],
    [
      "aller",
      0.035
    ],
    [
      "deambuler",
      0.035
    ],
    [
      "trainasser",
      0.0275
    ],
    [
      "voyager",
      0.0275
    ],
    [
      "vadrouiller",
      0.0225
    ],
    [
      "s'egarer",
      0.0225
    ],
    [
      "courir",
      0.0225
    ],
    [
      "divaguer",
      0.0175
    ],
    [
      "musarder",
      0.0175
    ],
    [
      "tournailler",
      0.01
    ],
    [
      "tournoyer",
      0.01
    ],
    [
      "troler",
      0.01
    ],
    [
      "s'abuser",
      0.01
    ],
    [
      "passer",
      0.01
    ],
    [
      "hesiter",
      0.01
    ],
    [
      "flotter",
      0.01
    ],
    [
      "tergiverser",
      0.005
    ],
    [
      "tourniquer",
      0.005
    ],
    [
      "rodailler",
      0.005
    ],
    [
      "rouler",
      0.005
    ],
    [
      "polissonner",
      0.005
    ],
    [
      "galvauder",
      0.005
    ],
    [
      "badauder",
      0.005
    ],
    [
      "trimarder",
      0.005
    ]
  ],
  "racketter": [
    [
      "ranconner",
      0.5
    ]
  ],
  "wagon": [
    [
      "benne",
      0.125
    ],
    [
      "citerne",
      0.125
    ],
    [
      "fourgon",
      0.125
    ],
    [
      "plateau",
      0.125
    ],
    [
      "tender",
      0.125
    ],
    [
      "tombereau",
      0.125
    ],
    [
      "truck",
      0.125
    ],
    [
      "voiture",
      0.125
    ]
  ],
  "detourne": [
    [
      "soustraire",
      0.065
    ],
    [
      "voler",
      0.045
    ],
    [
      "eloigner",
      0.045
    ],
    [
      "derober",
      0.0375
    ],
    [
      "enlever",
      0.0375
    ],
    [
      "eviter",
      0.035
    ],
    [
      "ecarter",
      0.035
    ],
    [
      "distraire",
      0.035
    ],
    [
      "arracher",
      0.0275
    ],
    [
      "perdre",
      0.0275
    ],
    [
      "tourner",
      0.0275
    ],
    [
      "egarer",
      0.025
    ],
    [
      "detacher",
      0.025
    ],
    [
      "derouter",
      0.025
    ],
    [
      "dissuader",
      0.025
    ],
    [
      "s'approprier",
      0.0175
    ],
    [
      "prevenir",
      0.0175
    ],
    [
      "forcer",
      0.0175
    ],
    [
      "empecher",
      0.0175
    ],
    [
      "devier",
      0.0175
    ],
    [
      "deranger",
      0.0175
    ],
    [
      "degouter",
      0.0175
    ],
    [
      "preserver",
      0.0125
    ],
    [
      "piller",
      0.0125
    ],
    [
      "parer",
      0.0125
    ],
    [
      "extorquer",
      0.0125
    ],
    [
      "esquiver",
      0.0125
    ],
    [
      "escroquer",
      0.0125
    ],
    [
      "devoyer",
      0.0125
    ],
    [
      "deplacer",
      0.0125
    ],
    [
      "denaturer",
      0.0125
    ],
    [
      "conjurer",
      0.0125
    ],
    [
      "alterer",
      0.0125
    ],
    [
      "obliquer",
      0.0075
    ],
    [
      "rabattre",
      0.0075
    ],
    [
      "seduire",
      0.0075
    ],
    [
      "tordre",
      0.0075
    ],
    [
      "eluder",
      0.0075
    ],
    [
      "negliger",
      0.0075
    ],
    [
      "desaffectionner",
      0.0075
    ],
    [
      "abandonner",
      0.0075
    ],
    [
      "corrompre",
      0.0075
    ],
    [
      "debaucher",
      0.0075
    ],
    [
      "decourager",
      0.0075
    ],
    [
      "deriver",
      0.0075
    ],
    [
      "solliciter",
      0.0025
    ],
    [
      "s'egarer",
      0.0025
    ],
    [
      "fourvoyer",
      0.0025
    ],
    [
      "filouter",
      0.0025
    ],
    [
      "desabuser",
      0.0025
    ],
    [
      "depreder",
      0.0025
    ],
    [
      "deconseiller",
      0.0025
    ],
    [
      "divertir",
      0.0025
    ],
    [
      "dilapider",
      0.0025
    ],
    [
      "confisquer",
      0.0025
    ],
    [
      "torturer",
      0.0025
    ]
  ],
  "detourner": [
    [
      "soustraire",
      0.065
    ],
    [
      "voler",
      0.045
    ],
    [
      "eloigner",
      0.045
    ],
    [
      "derober",
      0.0375
    ],
    [
      "enlever",
      0.0375
    ],
    [
      "eviter",
      0.035
    ],
    [
      "ecarter",
      0.035
    ],
    [
      "distraire",
      0.035
    ],
    [
      "arracher",
      0.0275
    ],
    [
      "perdre",
      0.0275
    ],
    [
      "tourner",
      0.0275
    ],
    [
      "egarer",
      0.025
    ],
    [
      "detacher",
      0.025
    ],
    [
      "derouter",
      0.025
    ],
    [
      "dissuader",
      0.025
    ],
    [
      "s'approprier",
      0.0175
    ],
    [
      "prevenir",
      0.0175
    ],
    [
      "forcer",
      0.0175
    ],
    [
      "empecher",
      0.0175
    ],
    [
      "devier",
      0.0175
    ],
    [
      "deranger",
      0.0175
    ],
    [
      "degouter",
      0.0175
    ],
    [
      "preserver",
      0.0125
    ],
    [
      "piller",
      0.0125
    ],
    [
      "parer",
      0.0125
    ],
    [
      "extorquer",
      0.0125
    ],
    [
      "esquiver",
      0.0125
    ],
    [
      "escroquer",
      0.0125
    ],
    [
      "devoyer",
      0.0125
    ],
    [
      "deplacer",
      0.0125
    ],
    [
      "denaturer",
      0.0125
    ],
    [
      "conjurer",
      0.0125
    ],
    [
      "alterer",
      0.0125
    ],
    [
      "obliquer",
      0.0075
    ],
    [
      "rabattre",
      0.0075
    ],
    [
      "seduire",
      0.0075
    ],
    [
      "tordre",
      0.0075
    ],
    [
      "eluder",
      0.0075
    ],
    [
      "negliger",
      0.0075
    ],
    [
      "desaffectionner",
      0.0075
    ],
    [
      "abandonner",
      0.0075
    ],
    [
      "corrompre",
      0.0075
    ],
    [
      "debaucher",
      0.0075
    ],
    [
      "decourager",
      0.0075
    ],
    [
      "deriver",
      0.0075
    ],
    [
      "solliciter",
      0.0025
    ],
    [
      "s'egarer",
      0.0025
    ],
    [
      "fourvoyer",
      0.0025
    ],
    [
      "filouter",
      0.0025
    ],
    [
      "desabuser",
      0.0025
    ],
    [
      "depreder",
      0.0025
    ],
    [
      "deconseiller",
      0.0025
    ],
    [
      "divertir",
      0.0025
    ],
    [
      "dilapider",
      0.0025
    ],
    [
      "confisquer",
      0.0025
    ],
    [
      "torturer",
      0.0025
    ]
  ],
  "lachete": [
    [
      "peur",
      0.1025
    ],
    [
      "bassesse",
      0.0725
    ],
    [
      "frousse",
      0.0725
    ],
    [
      "faiblesse",
      0.06
    ],
    [
      "pleutrerie",
      0.06
    ],
    [
      "vilenie",
      0.0425
    ],
    [
      "veulerie",
      0.0425
    ],
    [
      "trahison",
      0.0425
    ],
    [
      "pusillanimite",
      0.0425
    ],
    [
      "mollesse",
      0.0425
    ],
    [
      "demission",
      0.0425
    ],
    [
      "couardise",
      0.0425
    ],
    [
      "poltronnerie",
      0.03
    ],
    [
      "platitude",
      0.03
    ],
    [
      "paresse",
      0.03
    ],
    [
      "indignite",
      0.03
    ],
    [
      "foire",
      0.03
    ],
    [
      "cacade",
      0.03
    ],
    [
      "abjection",
      0.03
    ],
    [
      "terreur",
      0.0125
    ],
    [
      "inertie",
      0.0125
    ],
    [
      "ignominie",
      0.0125
    ],
    [
      "delaissement",
      0.0125
    ],
    [
      "agenouillement",
      0.0125
    ],
    [
      "abdication",
      0.0125
    ],
    [
      "trouille",
      0.0125
    ]
  ],
  "racheter": [
    [
      "reparer",
      0.225
    ],
    [
      "compenser",
      0.16
    ],
    [
      "couvrir",
      0.095
    ],
    [
      "suppleer",
      0.0625
    ],
    [
      "payer",
      0.0625
    ],
    [
      "expier",
      0.0625
    ],
    [
      "sauver",
      0.03
    ],
    [
      "rattraper",
      0.03
    ],
    [
      "raccorder",
      0.03
    ],
    [
      "liberer",
      0.03
    ],
    [
      "effacer",
      0.03
    ],
    [
      "delivrer",
      0.03
    ],
    [
      "corriger",
      0.03
    ],
    [
      "contrebalancer",
      0.03
    ],
    [
      "affranchir",
      0.03
    ]
  ],
  "jete": [
    [
      "lancer",
      0.07
    ],
    [
      "pousser",
      0.045
    ],
    [
      "repandre",
      0.04
    ],
    [
      "abandonner",
      0.035
    ],
    [
      "flanquer",
      0.035
    ],
    [
      "rejeter",
      0.0325
    ],
    [
      "balancer",
      0.0325
    ],
    [
      "mettre",
      0.0275
    ],
    [
      "lacher",
      0.0225
    ],
    [
      "ficher",
      0.0225
    ],
    [
      "envoyer",
      0.0225
    ],
    [
      "entrainer",
      0.0225
    ],
    [
      "conduire",
      0.0225
    ],
    [
      "emettre",
      0.02
    ],
    [
      "elever",
      0.02
    ],
    [
      "semer",
      0.02
    ],
    [
      "repousser",
      0.02
    ],
    [
      "dresser",
      0.02
    ],
    [
      "adresser",
      0.02
    ],
    [
      "eparpiller",
      0.015
    ],
    [
      "ejecter",
      0.015
    ],
    [
      "repartir",
      0.015
    ],
    [
      "projeter",
      0.015
    ],
    [
      "poser",
      0.015
    ],
    [
      "larguer",
      0.015
    ],
    [
      "foutre",
      0.015
    ],
    [
      "distribuer",
      0.015
    ],
    [
      "riposter",
      0.01
    ],
    [
      "verser",
      0.01
    ],
    [
      "epandre",
      0.01
    ],
    [
      "precipiter",
      0.01
    ],
    [
      "provoquer",
      0.01
    ],
    [
      "prodiguer",
      0.01
    ],
    [
      "plonger",
      0.01
    ],
    [
      "engager",
      0.01
    ],
    [
      "detruire",
      0.01
    ],
    [
      "bombarder",
      0.01
    ],
    [
      "bazarder",
      0.01
    ],
    [
      "glisser",
      0.0075
    ],
    [
      "liquider",
      0.0075
    ],
    [
      "proferer",
      0.0075
    ],
    [
      "releguer",
      0.0075
    ],
    [
      "eriger",
      0.0075
    ],
    [
      "deverser",
      0.0075
    ],
    [
      "disperser",
      0.0075
    ],
    [
      "catapulter",
      0.0075
    ],
    [
      "communiquer",
      0.0075
    ],
    [
      "construire",
      0.0075
    ],
    [
      "darder",
      0.0075
    ],
    [
      "descendre",
      0.0075
    ],
    [
      "edifier",
      0.0025
    ],
    [
      "retorquer",
      0.0025
    ],
    [
      "parsemer",
      0.0025
    ],
    [
      "insuffler",
      0.0025
    ],
    [
      "insinuer",
      0.0025
    ],
    [
      "imprimer",
      0.0025
    ],
    [
      "drosser",
      0.0025
    ],
    [
      "dispenser",
      0.0025
    ],
    [
      "causer",
      0.0025
    ],
    [
      "balanstiquer",
      0.0025
    ],
    [
      "ejaculer",
      0.0025
    ]
  ],
  "identifier": [
    [
      "reconnaitre",
      0.2525
    ],
    [
      "retrouver",
      0.0825
    ],
    [
      "remettre",
      0.0825
    ],
    [
      "immatriculer",
      0.0825
    ],
    [
      "essayer",
      0.0825
    ],
    [
      "determiner",
      0.0825
    ],
    [
      "discerner",
      0.0825
    ],
    [
      "confondre",
      0.0825
    ],
    [
      "assimiler",
      0.0825
    ]
  ],
  "serveur": [
    [
      "barman",
      0.2
    ],
    [
      "domestique",
      0.2
    ],
    [
      "garcon",
      0.2
    ],
    [
      "servant",
      0.2
    ],
    [
      "serviteur",
      0.2
    ]
  ],
  "serviette": [
    [
      "cartable",
      0.2
    ],
    [
      "portefeuille",
      0.2
    ],
    [
      "mallette",
      0.1
    ],
    [
      "sacoche",
      0.1
    ]
  ],
  "ressenti": [
    [
      "eprouver",
      0.2125
    ],
    [
      "connaitre",
      0.1425
    ],
    [
      "sentir",
      0.1425
    ],
    [
      "subir",
      0.1425
    ],
    [
      "endurer",
      0.07
    ],
    [
      "souffrir",
      0.07
    ],
    [
      "gouter",
      0.035
    ],
    [
      "discerner",
      0.035
    ],
    [
      "concevoir",
      0.035
    ],
    [
      "avoir",
      0.035
    ],
    [
      "pleurer",
      0.035
    ]
  ],
  "imaginant": [
    [
      "penser",
      0.1075
    ],
    [
      "concevoir",
      0.0625
    ],
    [
      "inventer",
      0.0575
    ],
    [
      "voir",
      0.0575
    ],
    [
      "trouver",
      0.0425
    ],
    [
      "croire",
      0.0425
    ],
    [
      "construire",
      0.0375
    ],
    [
      "supposer",
      0.03
    ],
    [
      "juger",
      0.03
    ],
    [
      "forger",
      0.03
    ],
    [
      "composer",
      0.03
    ],
    [
      "prevoir",
      0.025
    ],
    [
      "creer",
      0.025
    ],
    [
      "conjecturer",
      0.025
    ],
    [
      "decouvrir",
      0.0225
    ],
    [
      "soupconner",
      0.0175
    ],
    [
      "songer",
      0.0175
    ],
    [
      "s'attendre",
      0.0175
    ],
    [
      "former",
      0.0175
    ],
    [
      "fabriquer",
      0.0175
    ],
    [
      "deviner",
      0.0175
    ],
    [
      "comprendre",
      0.0175
    ],
    [
      "combiner",
      0.0175
    ],
    [
      "envisager",
      0.0125
    ],
    [
      "admettre",
      0.0125
    ],
    [
      "rever",
      0.01
    ],
    [
      "s'aviser",
      0.01
    ],
    [
      "s'imaginer",
      0.01
    ],
    [
      "evoquer",
      0.01
    ],
    [
      "savoir",
      0.005
    ],
    [
      "feindre",
      0.005
    ],
    [
      "chercher",
      0.005
    ],
    [
      "attendre",
      0.005
    ],
    [
      "pecher",
      0.0025
    ],
    [
      "manigancer",
      0.0025
    ],
    [
      "machiner",
      0.0025
    ],
    [
      "improviser",
      0.0025
    ],
    [
      "gamberger",
      0.0025
    ],
    [
      "figurer",
      0.0025
    ],
    [
      "anticiper",
      0.0025
    ],
    [
      "visualiser",
      0.0025
    ]
  ],
  "cervelle": [
    [
      "tete",
      0.2725
    ],
    [
      "cerveau",
      0.18
    ],
    [
      "crane",
      0.18
    ],
    [
      "bourrichon",
      0.09
    ],
    [
      "cervelet",
      0.09
    ],
    [
      "entendement",
      0.09
    ],
    [
      "esprit",
      0.09
    ]
  ],
  "douloureux": [
    [
      "penible",
      0.1325
    ],
    [
      "tendu",
      0.07
    ],
    [
      "torturant",
      0.07
    ],
    [
      "triste",
      0.07
    ],
    [
      "cruel",
      0.06
    ],
    [
      "navrant",
      0.06
    ],
    [
      "affligeant",
      0.0525
    ],
    [
      "cuisant",
      0.035
    ],
    [
      "poignant",
      0.035
    ],
    [
      "amer",
      0.0325
    ],
    [
      "dur",
      0.0325
    ],
    [
      "violent",
      0.0275
    ],
    [
      "lamentable",
      0.0275
    ],
    [
      "desolant",
      0.0225
    ],
    [
      "vif",
      0.02
    ],
    [
      "lourd",
      0.02
    ],
    [
      "dechirant",
      0.02
    ],
    [
      "attristant",
      0.02
    ],
    [
      "funeste",
      0.015
    ],
    [
      "piteux",
      0.015
    ],
    [
      "piquant",
      0.01
    ],
    [
      "intolerable",
      0.01
    ],
    [
      "desagreable",
      0.01
    ],
    [
      "atroce",
      0.01
    ],
    [
      "sensible",
      0.0075
    ],
    [
      "pitoyable",
      0.0075
    ],
    [
      "pesant",
      0.0075
    ],
    [
      "lancinant",
      0.0075
    ],
    [
      "dolent",
      0.0075
    ],
    [
      "difficile",
      0.0075
    ],
    [
      "chagrin",
      0.0075
    ],
    [
      "tourmentant",
      0.0025
    ],
    [
      "souffreteux",
      0.0025
    ],
    [
      "souffrant",
      0.0025
    ],
    [
      "navre",
      0.0025
    ],
    [
      "endolori",
      0.0025
    ],
    [
      "crucifiant",
      0.0025
    ],
    [
      "anxieux",
      0.0025
    ],
    [
      "angoissant",
      0.0025
    ],
    [
      "eprouvant",
      0.0025
    ]
  ],
  "terrifier": [
    [
      "epouvanter",
      0.195
    ],
    [
      "effrayer",
      0.17
    ],
    [
      "terroriser",
      0.145
    ],
    [
      "affoler",
      0.12
    ],
    [
      "alarmer",
      0.0725
    ],
    [
      "inquieter",
      0.0725
    ],
    [
      "petrifier",
      0.0475
    ],
    [
      "effarer",
      0.0475
    ],
    [
      "agiter",
      0.0225
    ],
    [
      "apeurer",
      0.0225
    ],
    [
      "atterrer",
      0.0225
    ],
    [
      "horrifier",
      0.0225
    ],
    [
      "transir",
      0.0225
    ]
  ],
  "terrifie": [
    [
      "epouvanter",
      0.195
    ],
    [
      "effrayer",
      0.17
    ],
    [
      "terroriser",
      0.145
    ],
    [
      "affoler",
      0.12
    ],
    [
      "alarmer",
      0.0725
    ],
    [
      "inquieter",
      0.0725
    ],
    [
      "petrifier",
      0.0475
    ],
    [
      "effarer",
      0.0475
    ],
    [
      "agiter",
      0.0225
    ],
    [
      "apeurer",
      0.0225
    ],
    [
      "atterrer",
      0.0225
    ],
    [
      "horrifier",
      0.0225
    ],
    [
      "transir",
      0.0225
    ]
  ],
  "tempe": [
    [
      "templet",
      1.0
    ]
  ],
  "verifier": [
    [
      "examiner",
      0.1375
    ],
    [
      "voir",
      0.0975
    ],
    [
      "controler",
      0.08
    ],
    [
      "experimenter",
      0.0625
    ],
    [
      "recoler",
      0.0625
    ],
    [
      "eprouver",
      0.0475
    ],
    [
      "revoir",
      0.04
    ],
    [
      "constater",
      0.04
    ],
    [
      "analyser",
      0.03
    ],
    [
      "essayer",
      0.03
    ],
    [
      "juger",
      0.03
    ],
    [
      "reconnaitre",
      0.03
    ],
    [
      "s'assurer",
      0.0225
    ],
    [
      "repasser",
      0.0225
    ],
    [
      "prouver",
      0.0225
    ],
    [
      "comparer",
      0.0225
    ],
    [
      "collationner",
      0.0225
    ],
    [
      "tester",
      0.015
    ],
    [
      "tamiser",
      0.015
    ],
    [
      "reviser",
      0.015
    ],
    [
      "inspecter",
      0.015
    ],
    [
      "confirmer",
      0.015
    ],
    [
      "surveiller",
      0.005
    ],
    [
      "rechercher",
      0.005
    ],
    [
      "pointer",
      0.005
    ],
    [
      "justifier",
      0.005
    ],
    [
      "filtrer",
      0.005
    ],
    [
      "expertiser",
      0.005
    ],
    [
      "corroborer",
      0.005
    ],
    [
      "averer",
      0.005
    ],
    [
      "auditer",
      0.005
    ],
    [
      "apurer",
      0.005
    ],
    [
      "etalonner",
      0.005
    ]
  ],
  "coiffe": [
    [
      "couvrir",
      0.1425
    ],
    [
      "tromper",
      0.07
    ],
    [
      "tenter",
      0.07
    ],
    [
      "seduire",
      0.07
    ],
    [
      "recouvrir",
      0.07
    ],
    [
      "peigner",
      0.07
    ],
    [
      "couronner",
      0.07
    ],
    [
      "capuchonner",
      0.07
    ],
    [
      "surmonter",
      0.035
    ],
    [
      "encapuchonner",
      0.035
    ],
    [
      "embeguiner",
      0.035
    ],
    [
      "demeler",
      0.035
    ],
    [
      "cocufier",
      0.035
    ],
    [
      "chapeauter",
      0.035
    ],
    [
      "casquer",
      0.035
    ],
    [
      "capeler",
      0.035
    ],
    [
      "arranger",
      0.035
    ],
    [
      "tapisser",
      0.035
    ]
  ],
  "coiffer": [
    [
      "couvrir",
      0.1425
    ],
    [
      "tromper",
      0.07
    ],
    [
      "tenter",
      0.07
    ],
    [
      "seduire",
      0.07
    ],
    [
      "recouvrir",
      0.07
    ],
    [
      "peigner",
      0.07
    ],
    [
      "couronner",
      0.07
    ],
    [
      "capuchonner",
      0.07
    ],
    [
      "surmonter",
      0.035
    ],
    [
      "encapuchonner",
      0.035
    ],
    [
      "embeguiner",
      0.035
    ],
    [
      "demeler",
      0.035
    ],
    [
      "cocufier",
      0.035
    ],
    [
      "chapeauter",
      0.035
    ],
    [
      "casquer",
      0.035
    ],
    [
      "capeler",
      0.035
    ],
    [
      "arranger",
      0.035
    ],
    [
      "tapisser",
      0.035
    ]
  ],
  "vitrine": [
    [
      "etalage",
      0.265
    ],
    [
      "devanture",
      0.1325
    ],
    [
      "montre",
      0.1325
    ],
    [
      "vitre",
      0.1325
    ],
    [
      "eventaire",
      0.1325
    ],
    [
      "bazar",
      0.065
    ],
    [
      "boutique",
      0.065
    ],
    [
      "collection",
      0.065
    ]
  ],
  "stress": [
    [
      "agression",
      0.25
    ],
    [
      "angoisse",
      0.25
    ],
    [
      "choc",
      0.25
    ],
    [
      "tension",
      0.25
    ]
  ],
  "planquer": [
    [
      "cacher",
      0.3325
    ],
    [
      "embusquer",
      0.3325
    ],
    [
      "thesauriser",
      0.3325
    ]
  ],
  "planque": [
    [
      "cacher",
      0.3325
    ],
    [
      "embusquer",
      0.3325
    ],
    [
      "thesauriser",
      0.3325
    ]
  ],
  "conde": [
    [
      "agent",
      0.22
    ],
    [
      "cafard",
      0.22
    ],
    [
      "espion",
      0.22
    ],
    [
      "flic",
      0.22
    ],
    [
      "tuyau",
      0.11
    ]
  ],
  "abimer": [
    [
      "demolir",
      0.0675
    ],
    [
      "deteriorer",
      0.065
    ],
    [
      "degrader",
      0.065
    ],
    [
      "gater",
      0.065
    ],
    [
      "esquinter",
      0.06
    ],
    [
      "bousiller",
      0.0425
    ],
    [
      "detruire",
      0.0425
    ],
    [
      "ruiner",
      0.04
    ],
    [
      "alterer",
      0.03
    ],
    [
      "casser",
      0.025
    ],
    [
      "massacrer",
      0.025
    ],
    [
      "endommager",
      0.0225
    ],
    [
      "ereinter",
      0.0225
    ],
    [
      "detraquer",
      0.02
    ],
    [
      "salir",
      0.0175
    ],
    [
      "maltraiter",
      0.0175
    ],
    [
      "gacher",
      0.0175
    ],
    [
      "demanteler",
      0.0175
    ],
    [
      "corrompre",
      0.0175
    ],
    [
      "accidenter",
      0.0175
    ],
    [
      "blesser",
      0.015
    ],
    [
      "critiquer",
      0.015
    ],
    [
      "saccager",
      0.015
    ],
    [
      "souiller",
      0.0125
    ],
    [
      "saboter",
      0.01
    ],
    [
      "deprecier",
      0.01
    ],
    [
      "delabrer",
      0.01
    ],
    [
      "defigurer",
      0.01
    ],
    [
      "amocher",
      0.01
    ],
    [
      "torcher",
      0.0075
    ],
    [
      "ternir",
      0.0075
    ],
    [
      "medire",
      0.0075
    ],
    [
      "estropier",
      0.0075
    ],
    [
      "engloutir",
      0.0075
    ],
    [
      "carier",
      0.0075
    ],
    [
      "arranger",
      0.0075
    ],
    [
      "aneantir",
      0.0075
    ],
    [
      "ebrecher",
      0.005
    ],
    [
      "pourrir",
      0.005
    ],
    [
      "deshonorer",
      0.005
    ],
    [
      "debiner",
      0.005
    ],
    [
      "compromettre",
      0.005
    ],
    [
      "bigorner",
      0.005
    ],
    [
      "tacher",
      0.0025
    ],
    [
      "saloper",
      0.0025
    ],
    [
      "rudoyer",
      0.0025
    ],
    [
      "manquer",
      0.0025
    ],
    [
      "infecter",
      0.0025
    ],
    [
      "fusiller",
      0.0025
    ],
    [
      "ensevelir",
      0.0025
    ],
    [
      "deglinguer",
      0.0025
    ],
    [
      "cochonner",
      0.0025
    ],
    [
      "calomnier",
      0.0025
    ],
    [
      "savater",
      0.0
    ],
    [
      "plonger",
      0.0
    ],
    [
      "engouffrer",
      0.0
    ],
    [
      "bosseler",
      0.0
    ],
    [
      "attiger",
      0.0
    ],
    [
      "user",
      0.0
    ]
  ],
  "deteste": [
    [
      "abhorrer",
      0.16
    ],
    [
      "abominer",
      0.16
    ],
    [
      "hair",
      0.16
    ],
    [
      "execrer",
      0.1275
    ],
    [
      "maudire",
      0.095
    ],
    [
      "pester",
      0.0625
    ],
    [
      "repugner",
      0.03
    ],
    [
      "reprouver",
      0.03
    ],
    [
      "jurer",
      0.03
    ],
    [
      "vomir",
      0.03
    ]
  ],
  "gifler": [
    [
      "souffleter",
      0.2275
    ],
    [
      "battre",
      0.135
    ],
    [
      "talocher",
      0.135
    ],
    [
      "humilier",
      0.09
    ],
    [
      "talmouser",
      0.045
    ],
    [
      "mornifler",
      0.045
    ],
    [
      "fouetter",
      0.045
    ],
    [
      "doucher",
      0.045
    ],
    [
      "confirmer",
      0.045
    ],
    [
      "claquer",
      0.045
    ],
    [
      "cingler",
      0.045
    ],
    [
      "calotter",
      0.045
    ],
    [
      "taper",
      0.045
    ]
  ],
  "instinct": [
    [
      "tendance",
      0.1175
    ],
    [
      "inclination",
      0.07
    ],
    [
      "penchant",
      0.07
    ],
    [
      "sentiment",
      0.07
    ],
    [
      "talent",
      0.07
    ],
    [
      "sens",
      0.0575
    ],
    [
      "intuition",
      0.0575
    ],
    [
      "disposition",
      0.0575
    ],
    [
      "aptitude",
      0.0575
    ],
    [
      "propension",
      0.035
    ],
    [
      "inspiration",
      0.035
    ],
    [
      "genie",
      0.035
    ],
    [
      "concupiscence",
      0.035
    ],
    [
      "pressentiment",
      0.0225
    ],
    [
      "pente",
      0.0225
    ],
    [
      "impulsion",
      0.0225
    ],
    [
      "don",
      0.0225
    ],
    [
      "coeur",
      0.0225
    ],
    [
      "appetit",
      0.0225
    ],
    [
      "appetence",
      0.0225
    ],
    [
      "finalite",
      0.01
    ],
    [
      "loi",
      0.01
    ],
    [
      "prescience",
      0.01
    ],
    [
      "premonition",
      0.01
    ],
    [
      "pulsion",
      0.01
    ]
  ],
  "annoncer": [
    [
      "reveler",
      0.09
    ],
    [
      "signaler",
      0.0825
    ],
    [
      "indiquer",
      0.0725
    ],
    [
      "montrer",
      0.06
    ],
    [
      "signifier",
      0.05
    ],
    [
      "declarer",
      0.045
    ],
    [
      "dire",
      0.04
    ],
    [
      "apprendre",
      0.0325
    ],
    [
      "avertir",
      0.0325
    ],
    [
      "publier",
      0.03
    ],
    [
      "manifester",
      0.03
    ],
    [
      "informer",
      0.03
    ],
    [
      "exposer",
      0.03
    ],
    [
      "communiquer",
      0.03
    ],
    [
      "expliquer",
      0.02
    ],
    [
      "instruire",
      0.02
    ],
    [
      "denoncer",
      0.0175
    ],
    [
      "notifier",
      0.015
    ],
    [
      "afficher",
      0.015
    ],
    [
      "presager",
      0.0125
    ],
    [
      "marquer",
      0.0125
    ],
    [
      "presenter",
      0.0075
    ],
    [
      "prevenir",
      0.0075
    ],
    [
      "divulguer",
      0.0075
    ],
    [
      "crier",
      0.0075
    ],
    [
      "aviser",
      0.0075
    ],
    [
      "proclamer",
      0.005
    ],
    [
      "prouver",
      0.005
    ],
    [
      "preparer",
      0.0025
    ],
    [
      "preluder",
      0.0025
    ],
    [
      "promettre",
      0.0025
    ],
    [
      "denoter",
      0.0025
    ],
    [
      "augurer",
      0.0025
    ],
    [
      "attester",
      0.0025
    ],
    [
      "precher",
      0.0025
    ],
    [
      "predire",
      0.0025
    ],
    [
      "preceder",
      0.0025
    ],
    [
      "pronostiquer",
      0.0025
    ],
    [
      "pressentir",
      0.0025
    ],
    [
      "deceler",
      0.0025
    ],
    [
      "prefigurer",
      0.0
    ],
    [
      "prophetiser",
      0.0
    ],
    [
      "clamer",
      0.0
    ],
    [
      "claironner",
      0.0
    ],
    [
      "apporter",
      0.0
    ]
  ],
  "recemment": [
    [
      "fraichement",
      0.18
    ],
    [
      "nouvellement",
      0.18
    ],
    [
      "dernierement",
      0.09
    ],
    [
      "frais",
      0.09
    ],
    [
      "hier",
      0.09
    ],
    [
      "naguere",
      0.09
    ]
  ],
  "anodin": [
    [
      "insignifiant",
      0.1925
    ],
    [
      "quelconque",
      0.0825
    ],
    [
      "terne",
      0.0825
    ],
    [
      "leger",
      0.0725
    ],
    [
      "fade",
      0.06
    ],
    [
      "banal",
      0.06
    ],
    [
      "benin",
      0.0475
    ],
    [
      "falot",
      0.0475
    ],
    [
      "petit",
      0.035
    ],
    [
      "insipide",
      0.035
    ],
    [
      "indifferent",
      0.035
    ],
    [
      "efface",
      0.035
    ],
    [
      "doux",
      0.035
    ],
    [
      "calmant",
      0.0225
    ],
    [
      "inoffensif",
      0.0225
    ],
    [
      "sedatif",
      0.0225
    ],
    [
      "veniel",
      0.0225
    ],
    [
      "inefficace",
      0.01
    ],
    [
      "inactif",
      0.01
    ],
    [
      "futile",
      0.01
    ],
    [
      "apaisant",
      0.01
    ],
    [
      "antalgique",
      0.01
    ],
    [
      "inoperant",
      0.01
    ]
  ],
  "chialer": [
    [
      "pleurer",
      0.5
    ],
    [
      "sangloter",
      0.5
    ]
  ],
  "exprimer": [
    [
      "reveler",
      0.0825
    ],
    [
      "montrer",
      0.0725
    ],
    [
      "dire",
      0.07
    ],
    [
      "exposer",
      0.065
    ],
    [
      "signifier",
      0.0625
    ],
    [
      "manifester",
      0.05
    ],
    [
      "declarer",
      0.0425
    ],
    [
      "signaler",
      0.03
    ],
    [
      "publier",
      0.0275
    ],
    [
      "enoncer",
      0.0275
    ],
    [
      "afficher",
      0.025
    ],
    [
      "rendre",
      0.0225
    ],
    [
      "temoigner",
      0.0225
    ],
    [
      "prononcer",
      0.0225
    ],
    [
      "expliquer",
      0.0225
    ],
    [
      "donner",
      0.02
    ],
    [
      "affirmer",
      0.0175
    ],
    [
      "raconter",
      0.0175
    ],
    [
      "representer",
      0.0175
    ],
    [
      "emettre",
      0.0175
    ],
    [
      "marquer",
      0.015
    ],
    [
      "porter",
      0.015
    ],
    [
      "decouvrir",
      0.0125
    ],
    [
      "traduire",
      0.0125
    ],
    [
      "exhaler",
      0.01
    ],
    [
      "peindre",
      0.01
    ],
    [
      "proferer",
      0.01
    ],
    [
      "ecrire",
      0.0075
    ],
    [
      "former",
      0.0075
    ],
    [
      "exterioriser",
      0.0075
    ],
    [
      "crier",
      0.0075
    ],
    [
      "formuler",
      0.0075
    ],
    [
      "refleter",
      0.0075
    ],
    [
      "etaler",
      0.0075
    ],
    [
      "epancher",
      0.005
    ],
    [
      "tirer",
      0.005
    ],
    [
      "repeter",
      0.005
    ],
    [
      "figurer",
      0.005
    ],
    [
      "articuler",
      0.005
    ],
    [
      "symboliser",
      0.0025
    ],
    [
      "specifier",
      0.0025
    ],
    [
      "respirer",
      0.0025
    ],
    [
      "preciser",
      0.0025
    ],
    [
      "presser",
      0.0025
    ],
    [
      "extraire",
      0.0025
    ],
    [
      "decharger",
      0.0025
    ],
    [
      "conter",
      0.0025
    ],
    [
      "attraper",
      0.0025
    ],
    [
      "tourner",
      0.0
    ],
    [
      "sucer",
      0.0
    ],
    [
      "souhaiter",
      0.0
    ],
    [
      "objectiver",
      0.0
    ],
    [
      "exsuder",
      0.0
    ],
    [
      "epreindre",
      0.0
    ]
  ],
  "chausse": [
    [
      "embrasser",
      0.2
    ],
    [
      "adherer",
      0.0975
    ],
    [
      "botter",
      0.0975
    ],
    [
      "buter",
      0.0975
    ],
    [
      "enchausser",
      0.0975
    ],
    [
      "enfiler",
      0.0975
    ],
    [
      "ferrer",
      0.0975
    ],
    [
      "mettre",
      0.0975
    ],
    [
      "epouser",
      0.0975
    ]
  ],
  "chaussee": [
    [
      "embrasser",
      0.2
    ],
    [
      "adherer",
      0.0975
    ],
    [
      "botter",
      0.0975
    ],
    [
      "buter",
      0.0975
    ],
    [
      "enchausser",
      0.0975
    ],
    [
      "enfiler",
      0.0975
    ],
    [
      "ferrer",
      0.0975
    ],
    [
      "mettre",
      0.0975
    ],
    [
      "epouser",
      0.0975
    ]
  ],
  "chausser": [
    [
      "embrasser",
      0.2
    ],
    [
      "adherer",
      0.0975
    ],
    [
      "botter",
      0.0975
    ],
    [
      "buter",
      0.0975
    ],
    [
      "enchausser",
      0.0975
    ],
    [
      "enfiler",
      0.0975
    ],
    [
      "ferrer",
      0.0975
    ],
    [
      "mettre",
      0.0975
    ],
    [
      "epouser",
      0.0975
    ]
  ],
  "mander": [
    [
      "signifier",
      0.125
    ],
    [
      "appeler",
      0.1
    ],
    [
      "ecrire",
      0.075
    ],
    [
      "notifier",
      0.075
    ],
    [
      "marquer",
      0.075
    ],
    [
      "demander",
      0.075
    ],
    [
      "requerir",
      0.0475
    ],
    [
      "ordonner",
      0.0475
    ],
    [
      "informer",
      0.0475
    ],
    [
      "convoquer",
      0.0475
    ],
    [
      "convier",
      0.0475
    ],
    [
      "communiquer",
      0.0475
    ],
    [
      "citer",
      0.0475
    ],
    [
      "assigner",
      0.0475
    ],
    [
      "revendiquer",
      0.0225
    ]
  ],
  "mande": [
    [
      "signifier",
      0.125
    ],
    [
      "appeler",
      0.1
    ],
    [
      "ecrire",
      0.075
    ],
    [
      "notifier",
      0.075
    ],
    [
      "marquer",
      0.075
    ],
    [
      "demander",
      0.075
    ],
    [
      "requerir",
      0.0475
    ],
    [
      "ordonner",
      0.0475
    ],
    [
      "informer",
      0.0475
    ],
    [
      "convoquer",
      0.0475
    ],
    [
      "convier",
      0.0475
    ],
    [
      "communiquer",
      0.0475
    ],
    [
      "citer",
      0.0475
    ],
    [
      "assigner",
      0.0475
    ],
    [
      "revendiquer",
      0.0225
    ]
  ],
  "affirmatif": [
    [
      "categorique",
      0.2
    ],
    [
      "certain",
      0.1325
    ],
    [
      "decisif",
      0.1325
    ],
    [
      "positif",
      0.1325
    ],
    [
      "peremptoire",
      0.1325
    ],
    [
      "approbateur",
      0.065
    ],
    [
      "assertif",
      0.065
    ],
    [
      "ferme",
      0.065
    ],
    [
      "tranchant",
      0.065
    ]
  ],
  "affirmative": [
    [
      "categorique",
      0.2
    ],
    [
      "certain",
      0.1325
    ],
    [
      "decisif",
      0.1325
    ],
    [
      "positif",
      0.1325
    ],
    [
      "peremptoire",
      0.1325
    ],
    [
      "approbateur",
      0.065
    ],
    [
      "assertif",
      0.065
    ],
    [
      "ferme",
      0.065
    ],
    [
      "tranchant",
      0.065
    ]
  ],
  "alleger": [
    [
      "diminuer",
      0.1575
    ],
    [
      "soulager",
      0.115
    ],
    [
      "reduire",
      0.07
    ],
    [
      "oter",
      0.07
    ],
    [
      "attenuer",
      0.0575
    ],
    [
      "decharger",
      0.0575
    ],
    [
      "debarrasser",
      0.04
    ],
    [
      "amputer",
      0.04
    ],
    [
      "amoindrir",
      0.04
    ],
    [
      "amenuiser",
      0.04
    ],
    [
      "adoucir",
      0.04
    ],
    [
      "retirer",
      0.0275
    ],
    [
      "delester",
      0.0275
    ],
    [
      "abreger",
      0.0275
    ],
    [
      "voler",
      0.0125
    ],
    [
      "remettre",
      0.0125
    ],
    [
      "degrever",
      0.0125
    ],
    [
      "consoler",
      0.0125
    ],
    [
      "calmer",
      0.0125
    ],
    [
      "aerer",
      0.0125
    ],
    [
      "apaiser",
      0.0125
    ],
    [
      "ameliorer",
      0.0125
    ],
    [
      "allegir",
      0.0125
    ],
    [
      "alester",
      0.0125
    ],
    [
      "aider",
      0.0125
    ],
    [
      "ecourter",
      0.0125
    ]
  ],
  "averse": [
    [
      "pluie",
      0.2
    ],
    [
      "grain",
      0.1
    ],
    [
      "saucee",
      0.065
    ],
    [
      "quantite",
      0.065
    ],
    [
      "ondee",
      0.065
    ],
    [
      "grele",
      0.065
    ],
    [
      "flot",
      0.065
    ],
    [
      "deluge",
      0.065
    ],
    [
      "avalanche",
      0.065
    ],
    [
      "radee",
      0.0325
    ],
    [
      "multitude",
      0.0325
    ],
    [
      "giboulee",
      0.0325
    ],
    [
      "douche",
      0.0325
    ],
    [
      "avrillee",
      0.0325
    ],
    [
      "allevasse",
      0.0325
    ],
    [
      "sauce",
      0.0325
    ]
  ],
  "gouttiere": [
    [
      "canal",
      0.18
    ],
    [
      "cheneau",
      0.18
    ],
    [
      "accrochage",
      0.09
    ],
    [
      "chenal",
      0.09
    ],
    [
      "conduit",
      0.09
    ],
    [
      "coulisse",
      0.09
    ],
    [
      "tranche",
      0.09
    ],
    [
      "eclisse",
      0.09
    ],
    [
      "egout",
      0.09
    ]
  ],
  "sauveur": [
    [
      "Christ",
      0.5
    ],
    [
      "Dieu",
      0.5
    ]
  ],
  "inverse": [
    [
      "oppose",
      0.24
    ],
    [
      "contraire",
      0.2
    ],
    [
      "contrepartie",
      0.12
    ],
    [
      "antithese",
      0.0775
    ],
    [
      "symetrique",
      0.0775
    ],
    [
      "renverse",
      0.0375
    ],
    [
      "inversible",
      0.0375
    ],
    [
      "envers",
      0.0375
    ],
    [
      "antipode",
      0.0375
    ],
    [
      "reciproque",
      0.0375
    ]
  ],
  "inverser": [
    [
      "intervertir",
      0.23
    ],
    [
      "transposer",
      0.23
    ],
    [
      "changer",
      0.1525
    ],
    [
      "renverser",
      0.1525
    ],
    [
      "deplacer",
      0.075
    ],
    [
      "invertir",
      0.075
    ],
    [
      "permuter",
      0.075
    ]
  ],
  "bombarder": [
    [
      "battre",
      0.075
    ],
    [
      "catapulter",
      0.075
    ],
    [
      "canonner",
      0.06
    ],
    [
      "ecraser",
      0.05
    ],
    [
      "presser",
      0.05
    ],
    [
      "attaquer",
      0.05
    ],
    [
      "assaillir",
      0.05
    ],
    [
      "accabler",
      0.05
    ],
    [
      "tirer",
      0.0375
    ],
    [
      "promouvoir",
      0.0375
    ],
    [
      "pilonner",
      0.0375
    ],
    [
      "lancer",
      0.0375
    ],
    [
      "jeter",
      0.0375
    ],
    [
      "detruire",
      0.0375
    ],
    [
      "assieger",
      0.0375
    ],
    [
      "elever",
      0.0225
    ],
    [
      "parachuter",
      0.0225
    ],
    [
      "nommer",
      0.0225
    ],
    [
      "mitrailler",
      0.0225
    ],
    [
      "foudroyer",
      0.0225
    ],
    [
      "cribler",
      0.0225
    ],
    [
      "canarder",
      0.0225
    ],
    [
      "propulser",
      0.01
    ],
    [
      "obseder",
      0.01
    ],
    [
      "matraquer",
      0.01
    ],
    [
      "marmiter",
      0.01
    ],
    [
      "improviser",
      0.01
    ],
    [
      "arroser",
      0.01
    ],
    [
      "sacrer",
      0.01
    ]
  ],
  "daltonien": [
    [
      "dichromate",
      1.0
    ]
  ],
  "tole": [
    [
      "taule",
      0.2675
    ],
    [
      "prison",
      0.2
    ],
    [
      "cabane",
      0.1325
    ],
    [
      "habitation",
      0.1325
    ],
    [
      "cellule",
      0.065
    ],
    [
      "emprisonnement",
      0.065
    ],
    [
      "piece",
      0.065
    ],
    [
      "tole",
      0.065
    ]
  ],
  "hermetique": [
    [
      "impenetrable",
      0.105
    ],
    [
      "obscur",
      0.105
    ],
    [
      "nebuleux",
      0.09
    ],
    [
      "sibyllin",
      0.09
    ],
    [
      "tenebreux",
      0.09
    ],
    [
      "enigmatique",
      0.0675
    ],
    [
      "esoterique",
      0.0525
    ],
    [
      "mysterieux",
      0.0525
    ],
    [
      "abscons",
      0.0525
    ],
    [
      "cache",
      0.045
    ],
    [
      "secret",
      0.045
    ],
    [
      "difficile",
      0.0375
    ],
    [
      "cabalistique",
      0.0375
    ],
    [
      "incomprehensible",
      0.03
    ],
    [
      "inintelligible",
      0.03
    ],
    [
      "impermeable",
      0.015
    ],
    [
      "occulte",
      0.0075
    ],
    [
      "irrevele",
      0.0075
    ],
    [
      "ferme",
      0.0075
    ],
    [
      "cryptographique",
      0.0075
    ],
    [
      "clos",
      0.0075
    ],
    [
      "abstrait",
      0.0075
    ],
    [
      "etanche",
      0.0075
    ]
  ],
  "tolerer": [
    [
      "permettre",
      0.1475
    ],
    [
      "autoriser",
      0.1025
    ],
    [
      "admettre",
      0.0875
    ],
    [
      "accepter",
      0.065
    ],
    [
      "souffrir",
      0.065
    ],
    [
      "supporter",
      0.0575
    ],
    [
      "passer",
      0.0575
    ],
    [
      "accorder",
      0.0425
    ],
    [
      "consentir",
      0.0425
    ],
    [
      "donner",
      0.0425
    ],
    [
      "laisser",
      0.0275
    ],
    [
      "endurer",
      0.0275
    ],
    [
      "conceder",
      0.0275
    ],
    [
      "acquiescer",
      0.0275
    ],
    [
      "digerer",
      0.02
    ],
    [
      "subir",
      0.0125
    ],
    [
      "pardonner",
      0.0125
    ],
    [
      "dispenser",
      0.0125
    ],
    [
      "daigner",
      0.0125
    ],
    [
      "avaler",
      0.0125
    ],
    [
      "approuver",
      0.0125
    ],
    [
      "agreer",
      0.0125
    ],
    [
      "boire",
      0.005
    ],
    [
      "comporter",
      0.005
    ],
    [
      "excuser",
      0.005
    ],
    [
      "habiliter",
      0.005
    ]
  ],
  "colleur": [
    [
      "collant",
      0.5
    ],
    [
      "examinateur",
      0.5
    ]
  ],
  "etiquette": [
    [
      "classer",
      0.1725
    ],
    [
      "marquer",
      0.13
    ],
    [
      "noter",
      0.085
    ],
    [
      "nommer",
      0.085
    ],
    [
      "juger",
      0.085
    ],
    [
      "indiquer",
      0.085
    ],
    [
      "denommer",
      0.085
    ],
    [
      "cataloguer",
      0.085
    ],
    [
      "baguer",
      0.0425
    ],
    [
      "qualifier",
      0.0425
    ],
    [
      "ranger",
      0.0425
    ],
    [
      "referencer",
      0.0425
    ]
  ],
  "etiqueter": [
    [
      "classer",
      0.1725
    ],
    [
      "marquer",
      0.13
    ],
    [
      "noter",
      0.085
    ],
    [
      "nommer",
      0.085
    ],
    [
      "juger",
      0.085
    ],
    [
      "indiquer",
      0.085
    ],
    [
      "denommer",
      0.085
    ],
    [
      "cataloguer",
      0.085
    ],
    [
      "baguer",
      0.0425
    ],
    [
      "qualifier",
      0.0425
    ],
    [
      "ranger",
      0.0425
    ],
    [
      "referencer",
      0.0425
    ]
  ],
  "tigre": [
    [
      "chacal",
      0.5
    ],
    [
      "fauve",
      0.5
    ]
  ],
  "glacial": [
    [
      "froid",
      0.215
    ],
    [
      "glace",
      0.0775
    ],
    [
      "insensible",
      0.0775
    ],
    [
      "dur",
      0.0675
    ],
    [
      "impassible",
      0.0675
    ],
    [
      "rude",
      0.055
    ],
    [
      "sec",
      0.0425
    ],
    [
      "aigre",
      0.0425
    ],
    [
      "grand",
      0.0325
    ],
    [
      "terrible",
      0.0325
    ],
    [
      "refrigerant",
      0.02
    ],
    [
      "rigoureux",
      0.02
    ],
    [
      "polaire",
      0.02
    ],
    [
      "marmoreen",
      0.02
    ],
    [
      "intense",
      0.02
    ],
    [
      "glacant",
      0.02
    ],
    [
      "saisissant",
      0.01
    ],
    [
      "inhospitalier",
      0.01
    ],
    [
      "imperturbable",
      0.01
    ],
    [
      "hivernal",
      0.01
    ],
    [
      "hautain",
      0.01
    ],
    [
      "gele",
      0.01
    ],
    [
      "extreme",
      0.01
    ],
    [
      "algide",
      0.01
    ],
    [
      "acide",
      0.01
    ],
    [
      "siberien",
      0.01
    ]
  ],
  "polaire": [
    [
      "froid",
      0.175
    ],
    [
      "aride",
      0.1175
    ],
    [
      "glacial",
      0.1175
    ],
    [
      "nu",
      0.1175
    ],
    [
      "refrigerant",
      0.0575
    ],
    [
      "pele",
      0.0575
    ],
    [
      "lunaire",
      0.0575
    ],
    [
      "hyperboreen",
      0.0575
    ],
    [
      "glacant",
      0.0575
    ],
    [
      "desole",
      0.0575
    ],
    [
      "arctique",
      0.0575
    ],
    [
      "septentrional",
      0.0575
    ]
  ],
  "colere": [
    [
      "irritation",
      0.065
    ],
    [
      "colereux",
      0.06
    ],
    [
      "emportement",
      0.0475
    ],
    [
      "humeur",
      0.035
    ],
    [
      "mecontentement",
      0.035
    ],
    [
      "violence",
      0.0325
    ],
    [
      "fureur",
      0.0325
    ],
    [
      "feu",
      0.0325
    ],
    [
      "excitation",
      0.0325
    ],
    [
      "aigreur",
      0.0325
    ],
    [
      "depit",
      0.0275
    ],
    [
      "exasperation",
      0.0275
    ],
    [
      "irritabilite",
      0.0225
    ],
    [
      "chagrin",
      0.0225
    ],
    [
      "bile",
      0.0225
    ],
    [
      "agitation",
      0.0225
    ],
    [
      "courroux",
      0.0175
    ],
    [
      "impatience",
      0.0175
    ],
    [
      "ressentiment",
      0.0175
    ],
    [
      "irritable",
      0.0125
    ],
    [
      "rageur",
      0.0125
    ],
    [
      "rogne",
      0.0125
    ],
    [
      "surexcitation",
      0.0125
    ],
    [
      "erethisme",
      0.0125
    ],
    [
      "irascible",
      0.0125
    ],
    [
      "hargneux",
      0.0125
    ],
    [
      "haine",
      0.0125
    ],
    [
      "facherie",
      0.0125
    ],
    [
      "furieux",
      0.0125
    ],
    [
      "furie",
      0.0125
    ],
    [
      "effervescence",
      0.0125
    ],
    [
      "fulminant",
      0.0075
    ],
    [
      "hargne",
      0.0075
    ],
    [
      "impatient",
      0.0075
    ],
    [
      "irascibilite",
      0.0075
    ],
    [
      "irrite",
      0.0075
    ],
    [
      "rage",
      0.0075
    ],
    [
      "vengeance",
      0.0075
    ],
    [
      "exaspere",
      0.0075
    ],
    [
      "courrouce",
      0.0075
    ],
    [
      "agressivite",
      0.0075
    ],
    [
      "animosite",
      0.0075
    ],
    [
      "atrabilaire",
      0.0075
    ],
    [
      "atrabile",
      0.0075
    ],
    [
      "bilieux",
      0.0075
    ],
    [
      "bourrasque",
      0.0075
    ],
    [
      "colerique",
      0.0075
    ],
    [
      "tempete",
      0.0025
    ],
    [
      "susceptibilite",
      0.0025
    ],
    [
      "represailles",
      0.0025
    ],
    [
      "peche",
      0.0025
    ],
    [
      "monte",
      0.0025
    ],
    [
      "ire",
      0.0025
    ],
    [
      "indignation",
      0.0025
    ],
    [
      "foudre",
      0.0025
    ],
    [
      "crise",
      0.0025
    ],
    [
      "agressif",
      0.0025
    ],
    [
      "agite",
      0.0025
    ],
    [
      "ebullition",
      0.0025
    ]
  ],
  "conseiller": [
    [
      "guide",
      0.24
    ],
    [
      "inspirateur",
      0.1175
    ],
    [
      "conseil",
      0.0775
    ],
    [
      "directeur",
      0.0775
    ],
    [
      "instigateur",
      0.0775
    ],
    [
      "mentor",
      0.0775
    ],
    [
      "legiste",
      0.0375
    ],
    [
      "instructeur",
      0.0375
    ],
    [
      "fabrique",
      0.0375
    ],
    [
      "conseilleur",
      0.0375
    ],
    [
      "conducteur",
      0.0375
    ],
    [
      "boussole",
      0.0375
    ],
    [
      "agree",
      0.0375
    ],
    [
      "pygmalion",
      0.0375
    ]
  ],
  "orientation": [
    [
      "tendance",
      0.115
    ],
    [
      "disposition",
      0.095
    ],
    [
      "position",
      0.095
    ],
    [
      "direction",
      0.0775
    ],
    [
      "situation",
      0.0775
    ],
    [
      "tournure",
      0.0575
    ],
    [
      "sens",
      0.0575
    ],
    [
      "point",
      0.0575
    ],
    [
      "ligne",
      0.0575
    ],
    [
      "attitude",
      0.0575
    ],
    [
      "aspect",
      0.0575
    ],
    [
      "inflechissement",
      0.0175
    ],
    [
      "inclination",
      0.0175
    ],
    [
      "finalite",
      0.0175
    ],
    [
      "exposition",
      0.0175
    ],
    [
      "engagement",
      0.0175
    ],
    [
      "branchement",
      0.0175
    ],
    [
      "bifurcation",
      0.0175
    ],
    [
      "axe",
      0.0175
    ],
    [
      "aiguillage",
      0.0175
    ],
    [
      "orientement",
      0.0175
    ]
  ],
  "rotation": [
    [
      "tour",
      0.2
    ],
    [
      "revolution",
      0.16
    ],
    [
      "alternance",
      0.0775
    ],
    [
      "cercle",
      0.0775
    ],
    [
      "giration",
      0.0775
    ],
    [
      "volte",
      0.0775
    ],
    [
      "soleil",
      0.0375
    ],
    [
      "roulement",
      0.0375
    ],
    [
      "pronation",
      0.0375
    ],
    [
      "cycle",
      0.0375
    ],
    [
      "conversion",
      0.0375
    ],
    [
      "circumduction",
      0.0375
    ],
    [
      "alternat",
      0.0375
    ],
    [
      "turnover",
      0.0375
    ]
  ],
  "centre": [
    [
      "coeur",
      0.095
    ],
    [
      "sein",
      0.0825
    ],
    [
      "ame",
      0.0625
    ],
    [
      "point",
      0.04
    ],
    [
      "pivot",
      0.04
    ],
    [
      "base",
      0.04
    ],
    [
      "agglomeration",
      0.04
    ],
    [
      "ville",
      0.03
    ],
    [
      "principe",
      0.03
    ],
    [
      "principal",
      0.03
    ],
    [
      "milieu",
      0.03
    ],
    [
      "foyer",
      0.03
    ],
    [
      "fondement",
      0.03
    ],
    [
      "axe",
      0.03
    ],
    [
      "source",
      0.02
    ],
    [
      "noyau",
      0.02
    ],
    [
      "nombril",
      0.02
    ],
    [
      "noeud",
      0.02
    ],
    [
      "cheville",
      0.02
    ],
    [
      "cerveau",
      0.02
    ],
    [
      "capitale",
      0.02
    ],
    [
      "animateur",
      0.02
    ],
    [
      "mitan",
      0.0075
    ],
    [
      "metacentre",
      0.0075
    ],
    [
      "metropole",
      0.0075
    ],
    [
      "ombilic",
      0.0075
    ],
    [
      "organe",
      0.0075
    ],
    [
      "promoteur",
      0.0075
    ],
    [
      "siege",
      0.0075
    ],
    [
      "ecole",
      0.0075
    ],
    [
      "institut",
      0.0075
    ],
    [
      "centrisme",
      0.0075
    ],
    [
      "centrum",
      0.0075
    ],
    [
      "citadelle",
      0.0075
    ],
    [
      "cite",
      0.0075
    ],
    [
      "commune",
      0.0075
    ],
    [
      "fort",
      0.0075
    ],
    [
      "egocentrisme",
      0.0075
    ]
  ],
  "retention": [
    [
      "stase",
      0.285
    ],
    [
      "arret",
      0.1425
    ],
    [
      "infiltration",
      0.1425
    ],
    [
      "ischurie",
      0.1425
    ],
    [
      "memorisation",
      0.1425
    ],
    [
      "oedeme",
      0.1425
    ]
  ],
  "instable": [
    [
      "mobile",
      0.095
    ],
    [
      "changeant",
      0.065
    ],
    [
      "fragile",
      0.0625
    ],
    [
      "inconstant",
      0.05
    ],
    [
      "versatile",
      0.0425
    ],
    [
      "fugace",
      0.0425
    ],
    [
      "flottant",
      0.0425
    ],
    [
      "ondoyant",
      0.04
    ],
    [
      "variable",
      0.04
    ],
    [
      "mouvant",
      0.0375
    ],
    [
      "incertain",
      0.0325
    ],
    [
      "precaire",
      0.03
    ],
    [
      "fugitif",
      0.03
    ],
    [
      "volage",
      0.025
    ],
    [
      "faible",
      0.0225
    ],
    [
      "fuyant",
      0.02
    ],
    [
      "errant",
      0.02
    ],
    [
      "chancelant",
      0.02
    ],
    [
      "capricieux",
      0.02
    ],
    [
      "velleitaire",
      0.015
    ],
    [
      "vagabond",
      0.0125
    ],
    [
      "remuant",
      0.0125
    ],
    [
      "perissable",
      0.0125
    ],
    [
      "leger",
      0.0125
    ],
    [
      "fluctuant",
      0.0125
    ],
    [
      "branlant",
      0.0125
    ],
    [
      "boiteux",
      0.0125
    ],
    [
      "ambulant",
      0.0125
    ],
    [
      "agite",
      0.0125
    ],
    [
      "nomade",
      0.0075
    ],
    [
      "inegal",
      0.0075
    ],
    [
      "alterable",
      0.0075
    ],
    [
      "volatil",
      0.005
    ],
    [
      "turbulent",
      0.005
    ],
    [
      "tordu",
      0.005
    ],
    [
      "quinteux",
      0.005
    ],
    [
      "papillotant",
      0.005
    ],
    [
      "glissant",
      0.005
    ],
    [
      "bancal",
      0.005
    ],
    [
      "lunatique",
      0.0025
    ],
    [
      "fluide",
      0.0025
    ],
    [
      "detraque",
      0.0025
    ],
    [
      "desequilibre",
      0.0025
    ],
    [
      "delabre",
      0.0025
    ],
    [
      "brouillon",
      0.0025
    ],
    [
      "boheme",
      0.0025
    ],
    [
      "papillonnant",
      0.0025
    ]
  ],
  "humanoide": [],
  "plane": [
    [
      "dessin",
      0.055
    ],
    [
      "projet",
      0.0525
    ],
    [
      "canevas",
      0.0425
    ],
    [
      "esquisse",
      0.0425
    ],
    [
      "schema",
      0.0425
    ],
    [
      "ebauche",
      0.03
    ],
    [
      "dessein",
      0.03
    ],
    [
      "croquis",
      0.03
    ],
    [
      "combinaison",
      0.0275
    ],
    [
      "idee",
      0.0275
    ],
    [
      "disposition",
      0.0225
    ],
    [
      "organisation",
      0.0225
    ],
    [
      "representation",
      0.02
    ],
    [
      "calcul",
      0.02
    ],
    [
      "image",
      0.0175
    ],
    [
      "modele",
      0.0175
    ],
    [
      "ordre",
      0.0175
    ],
    [
      "structure",
      0.0175
    ],
    [
      "systeme",
      0.0175
    ],
    [
      "pensee",
      0.015
    ],
    [
      "methode",
      0.015
    ],
    [
      "intention",
      0.015
    ],
    [
      "carton",
      0.015
    ],
    [
      "carcasse",
      0.015
    ],
    [
      "squelette",
      0.01
    ],
    [
      "programme",
      0.01
    ],
    [
      "moyen",
      0.01
    ],
    [
      "ligne",
      0.01
    ],
    [
      "entreprise",
      0.01
    ],
    [
      "travail",
      0.0075
    ],
    [
      "topographie",
      0.0075
    ],
    [
      "resume",
      0.0075
    ],
    [
      "planning",
      0.0075
    ],
    [
      "niveau",
      0.0075
    ],
    [
      "division",
      0.0075
    ],
    [
      "charpente",
      0.0075
    ],
    [
      "cartographie",
      0.0075
    ],
    [
      "carte",
      0.0075
    ],
    [
      "cadre",
      0.0075
    ],
    [
      "architecture",
      0.0075
    ],
    [
      "releve",
      0.005
    ],
    [
      "preparation",
      0.005
    ],
    [
      "plat",
      0.005
    ],
    [
      "perspective",
      0.005
    ],
    [
      "scheme",
      0.005
    ],
    [
      "scenario",
      0.005
    ],
    [
      "sommaire",
      0.005
    ],
    [
      "tactique",
      0.005
    ],
    [
      "uni",
      0.005
    ],
    [
      "elevation",
      0.005
    ],
    [
      "ordonnance",
      0.005
    ],
    [
      "maquette",
      0.005
    ],
    [
      "leve",
      0.005
    ],
    [
      "aile",
      0.005
    ],
    [
      "base",
      0.005
    ],
    [
      "batterie",
      0.005
    ],
    [
      "but",
      0.005
    ],
    [
      "coupe",
      0.005
    ],
    [
      "diagramme",
      0.005
    ],
    [
      "extrait",
      0.005
    ],
    [
      "figuration",
      0.005
    ],
    [
      "fond",
      0.005
    ],
    [
      "nivele",
      0.0
    ],
    [
      "plain",
      0.0
    ],
    [
      "planification",
      0.0
    ],
    [
      "strategie",
      0.0
    ],
    [
      "surface",
      0.0
    ],
    [
      "trace",
      0.0
    ],
    [
      "voilure",
      0.0
    ],
    [
      "economie",
      0.0
    ],
    [
      "egal",
      0.0
    ],
    [
      "manege",
      0.0
    ],
    [
      "itineraire",
      0.0
    ],
    [
      "idees",
      0.0
    ],
    [
      "abrege",
      0.0
    ],
    [
      "aplani",
      0.0
    ],
    [
      "brouillon",
      0.0
    ],
    [
      "budget",
      0.0
    ],
    [
      "crayon",
      0.0
    ],
    [
      "empennage",
      0.0
    ],
    [
      "guide",
      0.0
    ],
    [
      "hauteur",
      0.0
    ],
    [
      "ichnographie",
      0.0
    ],
    [
      "epure",
      0.0
    ]
  ],
  "plan": [
    [
      "dessin",
      0.055
    ],
    [
      "projet",
      0.0525
    ],
    [
      "canevas",
      0.0425
    ],
    [
      "esquisse",
      0.0425
    ],
    [
      "schema",
      0.0425
    ],
    [
      "ebauche",
      0.03
    ],
    [
      "dessein",
      0.03
    ],
    [
      "croquis",
      0.03
    ],
    [
      "combinaison",
      0.0275
    ],
    [
      "idee",
      0.0275
    ],
    [
      "disposition",
      0.0225
    ],
    [
      "organisation",
      0.0225
    ],
    [
      "representation",
      0.02
    ],
    [
      "calcul",
      0.02
    ],
    [
      "image",
      0.0175
    ],
    [
      "modele",
      0.0175
    ],
    [
      "ordre",
      0.0175
    ],
    [
      "structure",
      0.0175
    ],
    [
      "systeme",
      0.0175
    ],
    [
      "pensee",
      0.015
    ],
    [
      "methode",
      0.015
    ],
    [
      "intention",
      0.015
    ],
    [
      "carton",
      0.015
    ],
    [
      "carcasse",
      0.015
    ],
    [
      "squelette",
      0.01
    ],
    [
      "programme",
      0.01
    ],
    [
      "moyen",
      0.01
    ],
    [
      "ligne",
      0.01
    ],
    [
      "entreprise",
      0.01
    ],
    [
      "travail",
      0.0075
    ],
    [
      "topographie",
      0.0075
    ],
    [
      "resume",
      0.0075
    ],
    [
      "planning",
      0.0075
    ],
    [
      "niveau",
      0.0075
    ],
    [
      "division",
      0.0075
    ],
    [
      "charpente",
      0.0075
    ],
    [
      "cartographie",
      0.0075
    ],
    [
      "carte",
      0.0075
    ],
    [
      "cadre",
      0.0075
    ],
    [
      "architecture",
      0.0075
    ],
    [
      "releve",
      0.005
    ],
    [
      "preparation",
      0.005
    ],
    [
      "plat",
      0.005
    ],
    [
      "perspective",
      0.005
    ],
    [
      "scheme",
      0.005
    ],
    [
      "scenario",
      0.005
    ],
    [
      "sommaire",
      0.005
    ],
    [
      "tactique",
      0.005
    ],
    [
      "uni",
      0.005
    ],
    [
      "elevation",
      0.005
    ],
    [
      "ordonnance",
      0.005
    ],
    [
      "maquette",
      0.005
    ],
    [
      "leve",
      0.005
    ],
    [
      "aile",
      0.005
    ],
    [
      "base",
      0.005
    ],
    [
      "batterie",
      0.005
    ],
    [
      "but",
      0.005
    ],
    [
      "coupe",
      0.005
    ],
    [
      "diagramme",
      0.005
    ],
    [
      "extrait",
      0.005
    ],
    [
      "figuration",
      0.005
    ],
    [
      "fond",
      0.005
    ],
    [
      "nivele",
      0.0
    ],
    [
      "plain",
      0.0
    ],
    [
      "planification",
      0.0
    ],
    [
      "strategie",
      0.0
    ],
    [
      "surface",
      0.0
    ],
    [
      "trace",
      0.0
    ],
    [
      "voilure",
      0.0
    ],
    [
      "economie",
      0.0
    ],
    [
      "egal",
      0.0
    ],
    [
      "manege",
      0.0
    ],
    [
      "itineraire",
      0.0
    ],
    [
      "idees",
      0.0
    ],
    [
      "abrege",
      0.0
    ],
    [
      "aplani",
      0.0
    ],
    [
      "brouillon",
      0.0
    ],
    [
      "budget",
      0.0
    ],
    [
      "crayon",
      0.0
    ],
    [
      "empennage",
      0.0
    ],
    [
      "guide",
      0.0
    ],
    [
      "hauteur",
      0.0
    ],
    [
      "ichnographie",
      0.0
    ],
    [
      "epure",
      0.0
    ]
  ],
  "sabrer": [
    [
      "barrer",
      0.1
    ],
    [
      "bacler",
      0.1
    ],
    [
      "biffer",
      0.075
    ],
    [
      "congedier",
      0.075
    ],
    [
      "effacer",
      0.075
    ],
    [
      "vider",
      0.05
    ],
    [
      "taillader",
      0.05
    ],
    [
      "rayer",
      0.05
    ],
    [
      "radier",
      0.05
    ],
    [
      "expedier",
      0.05
    ],
    [
      "censurer",
      0.05
    ],
    [
      "caviarder",
      0.05
    ],
    [
      "saler",
      0.025
    ],
    [
      "raviner",
      0.025
    ],
    [
      "raturer",
      0.025
    ],
    [
      "limoger",
      0.025
    ],
    [
      "gacher",
      0.025
    ],
    [
      "brocher",
      0.025
    ],
    [
      "bousiller",
      0.025
    ],
    [
      "balancer",
      0.025
    ],
    [
      "saquer",
      0.025
    ]
  ],
  "sabre": [
    [
      "epee",
      0.3325
    ],
    [
      "cimeterre",
      0.165
    ],
    [
      "flamberge",
      0.165
    ],
    [
      "rasoir",
      0.165
    ],
    [
      "scramasaxe",
      0.165
    ]
  ],
  "inspirer": [
    [
      "animer",
      0.085
    ],
    [
      "pousser",
      0.085
    ],
    [
      "provoquer",
      0.055
    ],
    [
      "conduire",
      0.05
    ],
    [
      "insuffler",
      0.0375
    ],
    [
      "diriger",
      0.0325
    ],
    [
      "determiner",
      0.0325
    ],
    [
      "souffler",
      0.0275
    ],
    [
      "enflammer",
      0.0275
    ],
    [
      "communiquer",
      0.0275
    ],
    [
      "agir",
      0.0225
    ],
    [
      "conseiller",
      0.0225
    ],
    [
      "mener",
      0.0225
    ],
    [
      "infuser",
      0.0175
    ],
    [
      "inoculer",
      0.0175
    ],
    [
      "insinuer",
      0.0175
    ],
    [
      "suggerer",
      0.0175
    ],
    [
      "susciter",
      0.0175
    ],
    [
      "guider",
      0.0175
    ],
    [
      "encourager",
      0.0175
    ],
    [
      "aiguillonner",
      0.0175
    ],
    [
      "allumer",
      0.0175
    ],
    [
      "aspirer",
      0.0175
    ],
    [
      "commander",
      0.0175
    ],
    [
      "donner",
      0.0175
    ],
    [
      "persuader",
      0.0125
    ],
    [
      "introduire",
      0.0125
    ],
    [
      "instiller",
      0.0125
    ],
    [
      "influencer",
      0.0125
    ],
    [
      "incliner",
      0.0125
    ],
    [
      "imprimer",
      0.0125
    ],
    [
      "imposer",
      0.0125
    ],
    [
      "dicter",
      0.0125
    ],
    [
      "causer",
      0.0125
    ],
    [
      "vivifier",
      0.0075
    ],
    [
      "respirer",
      0.0075
    ],
    [
      "instiguer",
      0.0075
    ],
    [
      "inhaler",
      0.0075
    ],
    [
      "forcer",
      0.0075
    ],
    [
      "aviver",
      0.0075
    ],
    [
      "avaler",
      0.0025
    ],
    [
      "enfievrer",
      0.0025
    ],
    [
      "engendrer",
      0.0025
    ],
    [
      "inflechir",
      0.0025
    ],
    [
      "priser",
      0.0025
    ],
    [
      "emoustiller",
      0.0025
    ]
  ],
  "entraver": [
    [
      "gener",
      0.1325
    ],
    [
      "empecher",
      0.095
    ],
    [
      "freiner",
      0.095
    ],
    [
      "paralyser",
      0.095
    ],
    [
      "arreter",
      0.065
    ],
    [
      "ralentir",
      0.055
    ],
    [
      "embarrasser",
      0.055
    ],
    [
      "brider",
      0.0475
    ],
    [
      "contrarier",
      0.0475
    ],
    [
      "enrayer",
      0.0475
    ],
    [
      "nuire",
      0.0475
    ],
    [
      "s'opposer",
      0.0375
    ],
    [
      "endiguer",
      0.0375
    ],
    [
      "attacher",
      0.0175
    ],
    [
      "contraindre",
      0.0175
    ],
    [
      "obstruer",
      0.0175
    ],
    [
      "retarder",
      0.0175
    ],
    [
      "piger",
      0.0075
    ],
    [
      "empetrer",
      0.0075
    ],
    [
      "dejouer",
      0.0075
    ],
    [
      "desservir",
      0.0075
    ],
    [
      "apercevoir",
      0.0075
    ]
  ],
  "robot": [
    [
      "automate",
      0.3325
    ],
    [
      "machine",
      0.3325
    ],
    [
      "androide",
      0.165
    ],
    [
      "appareil",
      0.165
    ]
  ],
  "casino": [
    [
      "cassine",
      0.3325
    ],
    [
      "kursaal",
      0.3325
    ],
    [
      "palais",
      0.3325
    ]
  ],
  "battue": [
    [
      "frapper",
      0.055
    ],
    [
      "rosser",
      0.03
    ],
    [
      "remuer",
      0.025
    ],
    [
      "ecraser",
      0.025
    ],
    [
      "maltraiter",
      0.0225
    ],
    [
      "vaincre",
      0.02
    ],
    [
      "blesser",
      0.0175
    ],
    [
      "triompher",
      0.0175
    ],
    [
      "ereinter",
      0.0175
    ],
    [
      "corriger",
      0.015
    ],
    [
      "etriller",
      0.0125
    ],
    [
      "cogner",
      0.0125
    ],
    [
      "agiter",
      0.0125
    ],
    [
      "attaquer",
      0.0125
    ],
    [
      "briser",
      0.0125
    ],
    [
      "malmener",
      0.0125
    ],
    [
      "rudoyer",
      0.0125
    ],
    [
      "taper",
      0.0125
    ],
    [
      "travailler",
      0.0125
    ],
    [
      "touiller",
      0.0125
    ],
    [
      "fatiguer",
      0.0125
    ],
    [
      "enfoncer",
      0.0125
    ],
    [
      "secouer",
      0.01
    ],
    [
      "fustiger",
      0.01
    ],
    [
      "frotter",
      0.01
    ],
    [
      "cingler",
      0.01
    ],
    [
      "casser",
      0.01
    ],
    [
      "brutaliser",
      0.01
    ],
    [
      "broyer",
      0.01
    ],
    [
      "fouetter",
      0.0075
    ],
    [
      "fesser",
      0.0075
    ],
    [
      "bigorner",
      0.0075
    ],
    [
      "heurter",
      0.0075
    ],
    [
      "nettoyer",
      0.0075
    ],
    [
      "piler",
      0.0075
    ],
    [
      "houspiller",
      0.005
    ],
    [
      "meurtrir",
      0.005
    ],
    [
      "pilonner",
      0.005
    ],
    [
      "pulveriser",
      0.005
    ],
    [
      "rouler",
      0.005
    ],
    [
      "souffleter",
      0.005
    ],
    [
      "demolir",
      0.005
    ],
    [
      "chatier",
      0.005
    ],
    [
      "aneantir",
      0.005
    ],
    [
      "arranger",
      0.005
    ],
    [
      "assommer",
      0.005
    ],
    [
      "bombarder",
      0.005
    ],
    [
      "bousculer",
      0.005
    ],
    [
      "brasser",
      0.005
    ],
    [
      "brosser",
      0.005
    ],
    [
      "tourner",
      0.005
    ],
    [
      "surpasser",
      0.005
    ],
    [
      "surclasser",
      0.005
    ],
    [
      "recurer",
      0.005
    ],
    [
      "osciller",
      0.005
    ],
    [
      "matraquer",
      0.005
    ],
    [
      "lutter",
      0.005
    ],
    [
      "flageller",
      0.005
    ],
    [
      "faconner",
      0.005
    ],
    [
      "defaire",
      0.005
    ],
    [
      "l'emporter",
      0.0025
    ],
    [
      "melanger",
      0.0025
    ],
    [
      "meler",
      0.0025
    ],
    [
      "soigner",
      0.0025
    ],
    [
      "tambouriner",
      0.0025
    ],
    [
      "fouiller",
      0.0025
    ],
    [
      "culbuter",
      0.0025
    ],
    [
      "combattre",
      0.0025
    ],
    [
      "ballotter",
      0.0025
    ],
    [
      "bastonner",
      0.0025
    ],
    [
      "bouler",
      0.0025
    ],
    [
      "claquer",
      0.0025
    ],
    [
      "marteler",
      0.0025
    ],
    [
      "moudre",
      0.0025
    ],
    [
      "punir",
      0.0025
    ],
    [
      "tabasser",
      0.0025
    ],
    [
      "echarper",
      0.0025
    ],
    [
      "echiner",
      0.0025
    ],
    [
      "eliminer",
      0.0025
    ],
    [
      "marquer",
      0.0025
    ],
    [
      "lyncher",
      0.0025
    ],
    [
      "gifler",
      0.0025
    ],
    [
      "astiquer",
      0.0025
    ],
    [
      "bouiller",
      0.0025
    ],
    [
      "cribler",
      0.0025
    ],
    [
      "devancer",
      0.0025
    ],
    [
      "depasser",
      0.0025
    ],
    [
      "derouiller",
      0.0025
    ],
    [
      "explorer",
      0.0025
    ],
    [
      "flotter",
      0.0025
    ],
    [
      "forger",
      0.0025
    ],
    [
      "refouler",
      0.0
    ],
    [
      "parcourir",
      0.0
    ],
    [
      "palpiter",
      0.0
    ],
    [
      "houssiner",
      0.0
    ],
    [
      "gratifier",
      0.0
    ],
    [
      "gagner",
      0.0
    ],
    [
      "s'escrimer",
      0.0
    ],
    [
      "sangler",
      0.0
    ],
    [
      "epousseter",
      0.0
    ],
    [
      "vanner",
      0.0
    ],
    [
      "torcher",
      0.0
    ],
    [
      "tanner",
      0.0
    ],
    [
      "tamponner",
      0.0
    ],
    [
      "talocher",
      0.0
    ],
    [
      "frictionner",
      0.0
    ],
    [
      "boxer",
      0.0
    ],
    [
      "bouter",
      0.0
    ],
    [
      "bourrer",
      0.0
    ],
    [
      "batailler",
      0.0
    ],
    [
      "avoir",
      0.0
    ],
    [
      "avoiner",
      0.0
    ],
    [
      "assaisonner",
      0.0
    ],
    [
      "assaillir",
      0.0
    ],
    [
      "brandiller",
      0.0
    ],
    [
      "brouiller",
      0.0
    ],
    [
      "bucher",
      0.0
    ],
    [
      "fonctionner",
      0.0
    ],
    [
      "faseyer",
      0.0
    ],
    [
      "dauber",
      0.0
    ],
    [
      "cravacher",
      0.0
    ],
    [
      "cligner",
      0.0
    ],
    [
      "canonner",
      0.0
    ],
    [
      "rechercher",
      0.0
    ],
    [
      "ralinguer",
      0.0
    ],
    [
      "rabouiller",
      0.0
    ],
    [
      "rabattre",
      0.0
    ],
    [
      "locher",
      0.0
    ],
    [
      "gourmer",
      0.0
    ],
    [
      "gauler",
      0.0
    ],
    [
      "fouler",
      0.0
    ],
    [
      "fouailler",
      0.0
    ],
    [
      "reconnaitre",
      0.0
    ],
    [
      "s'acharner",
      0.0
    ],
    [
      "tisaner",
      0.0
    ],
    [
      "testonner",
      0.0
    ],
    [
      "tatouiller",
      0.0
    ],
    [
      "tarauder",
      0.0
    ],
    [
      "talmouser",
      0.0
    ],
    [
      "sevir",
      0.0
    ],
    [
      "sonner",
      0.0
    ],
    [
      "sabouler",
      0.0
    ],
    [
      "triquer",
      0.0
    ],
    [
      "batonner",
      0.0
    ],
    [
      "bringuebaler",
      0.0
    ],
    [
      "bourrader",
      0.0
    ],
    [
      "botter",
      0.0
    ],
    [
      "blackbouler",
      0.0
    ],
    [
      "baratter",
      0.0
    ],
    [
      "attiger",
      0.0
    ],
    [
      "cabosser",
      0.0
    ],
    [
      "calotter",
      0.0
    ],
    [
      "estourbir",
      0.0
    ],
    [
      "depoussierer",
      0.0
    ],
    [
      "depiquer",
      0.0
    ],
    [
      "debattre",
      0.0
    ],
    [
      "disperser",
      0.0
    ],
    [
      "damer",
      0.0
    ],
    [
      "clignoter",
      0.0
    ],
    [
      "carder",
      0.0
    ],
    [
      "arpenter",
      0.0
    ]
  ],
  "desincarner": [],
  "desincarne": [
    [
      "platonique",
      1.0
    ]
  ],
  "ecarlate": [
    [
      "rouge",
      0.3075
    ],
    [
      "grenat",
      0.23
    ],
    [
      "cramoisi",
      0.1525
    ],
    [
      "ponceau",
      0.075
    ],
    [
      "pourpre",
      0.075
    ],
    [
      "rutilant",
      0.075
    ],
    [
      "vermillon",
      0.075
    ]
  ],
  "carrelage": [
    [
      "pave",
      0.2725
    ],
    [
      "carreau",
      0.18
    ],
    [
      "dallage",
      0.18
    ],
    [
      "faience",
      0.09
    ],
    [
      "mosaique",
      0.09
    ],
    [
      "pavage",
      0.09
    ],
    [
      "pavement",
      0.09
    ]
  ],
  "oppressant": [
    [
      "accablant",
      0.2
    ],
    [
      "lourd",
      0.15
    ],
    [
      "pesant",
      0.1
    ],
    [
      "ecrasant",
      0.1
    ],
    [
      "etouffant",
      0.1
    ],
    [
      "suffocant",
      0.0475
    ],
    [
      "stressant",
      0.0475
    ],
    [
      "poignant",
      0.0475
    ],
    [
      "opprimant",
      0.0475
    ],
    [
      "oppressif",
      0.0475
    ],
    [
      "angoissant",
      0.0475
    ],
    [
      "torpide",
      0.0475
    ]
  ],
  "oppresser": [
    [
      "serrer",
      0.1225
    ],
    [
      "etouffer",
      0.1225
    ],
    [
      "peser",
      0.09
    ],
    [
      "presser",
      0.09
    ],
    [
      "ecraser",
      0.09
    ],
    [
      "accabler",
      0.06
    ],
    [
      "etreindre",
      0.06
    ],
    [
      "etrangler",
      0.045
    ],
    [
      "suffoquer",
      0.045
    ],
    [
      "opprimer",
      0.045
    ],
    [
      "gener",
      0.045
    ],
    [
      "charger",
      0.03
    ],
    [
      "prendre",
      0.03
    ],
    [
      "tourmenter",
      0.03
    ],
    [
      "grever",
      0.015
    ],
    [
      "essouffler",
      0.015
    ],
    [
      "chagriner",
      0.015
    ],
    [
      "angoisser",
      0.015
    ],
    [
      "navrer",
      0.015
    ]
  ],
  "horloger": [],
  "refugie": [
    [
      "apatride",
      0.125
    ],
    [
      "asile",
      0.125
    ],
    [
      "deplace",
      0.125
    ],
    [
      "exile",
      0.125
    ],
    [
      "expatrie",
      0.125
    ],
    [
      "protestant",
      0.125
    ],
    [
      "emigre",
      0.125
    ],
    [
      "etranger",
      0.125
    ]
  ],
  "refugier": [],
  "maitrise": [
    [
      "habilete",
      0.1
    ],
    [
      "autorite",
      0.06
    ],
    [
      "domination",
      0.06
    ],
    [
      "empire",
      0.0525
    ],
    [
      "pouvoir",
      0.0525
    ],
    [
      "virtuosite",
      0.0375
    ],
    [
      "hegemonie",
      0.0375
    ],
    [
      "art",
      0.0375
    ],
    [
      "adresse",
      0.0375
    ],
    [
      "superiorite",
      0.0325
    ],
    [
      "technique",
      0.025
    ],
    [
      "suprematie",
      0.025
    ],
    [
      "preponderance",
      0.025
    ],
    [
      "controle",
      0.025
    ],
    [
      "calme",
      0.025
    ],
    [
      "metier",
      0.0175
    ],
    [
      "maestria",
      0.0175
    ],
    [
      "chic",
      0.0175
    ],
    [
      "manecanterie",
      0.0125
    ],
    [
      "patte",
      0.0125
    ],
    [
      "possession",
      0.0125
    ],
    [
      "sceptre",
      0.0125
    ],
    [
      "souverainete",
      0.0125
    ],
    [
      "eloquence",
      0.0125
    ],
    [
      "intelligence",
      0.0125
    ],
    [
      "imperturbabilite",
      0.0125
    ],
    [
      "brio",
      0.0125
    ],
    [
      "domestication",
      0.0125
    ],
    [
      "fermete",
      0.0125
    ],
    [
      "flegme",
      0.0125
    ],
    [
      "gouvernement",
      0.0125
    ],
    [
      "impassibilite",
      0.0125
    ],
    [
      "retenue",
      0.005
    ],
    [
      "psallette",
      0.005
    ],
    [
      "musicien",
      0.005
    ],
    [
      "corporation",
      0.005
    ],
    [
      "chantrerie",
      0.005
    ],
    [
      "asservissement",
      0.005
    ],
    [
      "reserve",
      0.005
    ]
  ],
  "maitriser": [
    [
      "dompter",
      0.14
    ],
    [
      "dominer",
      0.0875
    ],
    [
      "mater",
      0.0825
    ],
    [
      "contenir",
      0.055
    ],
    [
      "soumettre",
      0.045
    ],
    [
      "assujettir",
      0.04
    ],
    [
      "regner",
      0.04
    ],
    [
      "reprimer",
      0.04
    ],
    [
      "enchainer",
      0.035
    ],
    [
      "commander",
      0.035
    ],
    [
      "asservir",
      0.035
    ],
    [
      "vaincre",
      0.03
    ],
    [
      "retenir",
      0.025
    ],
    [
      "tenir",
      0.025
    ],
    [
      "triompher",
      0.025
    ],
    [
      "surmonter",
      0.02
    ],
    [
      "reduire",
      0.02
    ],
    [
      "controler",
      0.02
    ],
    [
      "captiver",
      0.02
    ],
    [
      "brider",
      0.02
    ],
    [
      "gouverner",
      0.015
    ],
    [
      "juguler",
      0.015
    ],
    [
      "regler",
      0.015
    ],
    [
      "stopper",
      0.0075
    ],
    [
      "refouler",
      0.0075
    ],
    [
      "posseder",
      0.0075
    ],
    [
      "enrayer",
      0.0075
    ],
    [
      "discipliner",
      0.0075
    ],
    [
      "diriger",
      0.0075
    ],
    [
      "combattre",
      0.0075
    ],
    [
      "calmer",
      0.0075
    ],
    [
      "domestiquer",
      0.0025
    ],
    [
      "fasciner",
      0.0025
    ],
    [
      "terrasser",
      0.0025
    ]
  ],
  "symetrie": [
    [
      "harmonie",
      0.25
    ],
    [
      "accord",
      0.1075
    ],
    [
      "proportion",
      0.1075
    ],
    [
      "equilibre",
      0.1075
    ],
    [
      "regularite",
      0.07
    ],
    [
      "correspondance",
      0.07
    ],
    [
      "concordance",
      0.07
    ],
    [
      "balancement",
      0.035
    ],
    [
      "beaute",
      0.035
    ],
    [
      "opposition",
      0.035
    ],
    [
      "ordre",
      0.035
    ],
    [
      "pendant",
      0.035
    ],
    [
      "ressemblance",
      0.035
    ]
  ],
  "debris": [
    [
      "morceau",
      0.0625
    ],
    [
      "reste",
      0.0625
    ],
    [
      "rognure",
      0.0625
    ],
    [
      "fragment",
      0.0575
    ],
    [
      "dechet",
      0.0475
    ],
    [
      "rebut",
      0.0425
    ],
    [
      "residu",
      0.0425
    ],
    [
      "detritus",
      0.0375
    ],
    [
      "bribe",
      0.0375
    ],
    [
      "decombres",
      0.0325
    ],
    [
      "ruine",
      0.0325
    ],
    [
      "rogaton",
      0.0275
    ],
    [
      "epave",
      0.0275
    ],
    [
      "deblai",
      0.0225
    ],
    [
      "piece",
      0.0225
    ],
    [
      "relief",
      0.0225
    ],
    [
      "ordure",
      0.0175
    ],
    [
      "gravats",
      0.0175
    ],
    [
      "eclat",
      0.0125
    ],
    [
      "poussiere",
      0.0125
    ],
    [
      "platras",
      0.0125
    ],
    [
      "os",
      0.0125
    ],
    [
      "miette",
      0.0125
    ],
    [
      "lambeau",
      0.0125
    ],
    [
      "balayure",
      0.0125
    ],
    [
      "loque",
      0.0075
    ],
    [
      "ossement",
      0.0075
    ],
    [
      "ramas",
      0.0075
    ],
    [
      "relique",
      0.0075
    ],
    [
      "ruines",
      0.0075
    ],
    [
      "tesson",
      0.0075
    ],
    [
      "vieillard",
      0.0075
    ],
    [
      "limaille",
      0.0075
    ],
    [
      "gadoue",
      0.0075
    ],
    [
      "amas",
      0.0075
    ],
    [
      "bout",
      0.0075
    ],
    [
      "bris",
      0.0075
    ],
    [
      "cendre",
      0.0075
    ],
    [
      "decharge",
      0.0075
    ],
    [
      "demolitions",
      0.0075
    ],
    [
      "ferraille",
      0.0075
    ],
    [
      "sciure",
      0.0025
    ],
    [
      "fossile",
      0.0025
    ],
    [
      "fondrilles",
      0.0025
    ],
    [
      "falun",
      0.0025
    ],
    [
      "effondrilles",
      0.0025
    ],
    [
      "detriments",
      0.0025
    ],
    [
      "defet",
      0.0025
    ],
    [
      "copeau",
      0.0025
    ],
    [
      "compost",
      0.0025
    ],
    [
      "chicot",
      0.0025
    ],
    [
      "cassure",
      0.0025
    ],
    [
      "carcasse",
      0.0025
    ],
    [
      "blocage",
      0.0025
    ],
    [
      "vestige",
      0.0025
    ]
  ],
  "etriper": [
    [
      "saigner",
      0.285
    ],
    [
      "agresser",
      0.1425
    ],
    [
      "decoudre",
      0.1425
    ],
    [
      "tuer",
      0.1425
    ],
    [
      "vider",
      0.1425
    ],
    [
      "eventrer",
      0.1425
    ]
  ],
  "aigrir": [
    [
      "exciter",
      0.095
    ],
    [
      "attiser",
      0.0775
    ],
    [
      "irriter",
      0.0775
    ],
    [
      "envenimer",
      0.0625
    ],
    [
      "facher",
      0.0625
    ],
    [
      "piquer",
      0.0625
    ],
    [
      "indisposer",
      0.0475
    ],
    [
      "froisser",
      0.0475
    ],
    [
      "exasperer",
      0.0475
    ],
    [
      "alterer",
      0.0475
    ],
    [
      "ulcerer",
      0.03
    ],
    [
      "passer",
      0.03
    ],
    [
      "gater",
      0.03
    ],
    [
      "brouiller",
      0.03
    ],
    [
      "aviver",
      0.03
    ],
    [
      "aggraver",
      0.03
    ],
    [
      "travailler",
      0.015
    ],
    [
      "tourner",
      0.015
    ],
    [
      "surir",
      0.015
    ],
    [
      "frelater",
      0.015
    ],
    [
      "enfieller",
      0.015
    ],
    [
      "empirer",
      0.015
    ],
    [
      "corrompre",
      0.015
    ],
    [
      "assombrir",
      0.015
    ],
    [
      "vexer",
      0.015
    ]
  ],
  "aigri": [
    [
      "aigre",
      0.1325
    ],
    [
      "corrompu",
      0.1325
    ],
    [
      "tourne",
      0.1325
    ],
    [
      "gate",
      0.065
    ],
    [
      "furieux",
      0.065
    ],
    [
      "desenchante",
      0.065
    ],
    [
      "desabuse",
      0.065
    ],
    [
      "degoute",
      0.065
    ],
    [
      "becheur",
      0.065
    ],
    [
      "amer",
      0.065
    ],
    [
      "acrimonieux",
      0.065
    ],
    [
      "irrite",
      0.065
    ]
  ],
  "fatalement": [
    [
      "infailliblement",
      0.1425
    ],
    [
      "ineluctablement",
      0.1425
    ],
    [
      "inevitablement",
      0.1425
    ],
    [
      "necessairement",
      0.1425
    ],
    [
      "surement",
      0.1425
    ],
    [
      "certainement",
      0.07
    ],
    [
      "directement",
      0.07
    ],
    [
      "forcement",
      0.07
    ],
    [
      "obligatoirement",
      0.07
    ]
  ],
  "mourant": [
    [
      "mort",
      0.0775
    ],
    [
      "eteint",
      0.0575
    ],
    [
      "perdu",
      0.0575
    ],
    [
      "lassant",
      0.0575
    ],
    [
      "ennuyeux",
      0.0575
    ],
    [
      "assommant",
      0.0575
    ],
    [
      "transi",
      0.0375
    ],
    [
      "passe",
      0.0375
    ],
    [
      "languissant",
      0.0375
    ],
    [
      "languide",
      0.0375
    ],
    [
      "faible",
      0.0375
    ],
    [
      "expirant",
      0.0375
    ],
    [
      "declinant",
      0.0375
    ],
    [
      "agonisant",
      0.0375
    ],
    [
      "langoureux",
      0.0175
    ],
    [
      "moribond",
      0.0175
    ],
    [
      "mortel",
      0.0175
    ],
    [
      "periclitant",
      0.0175
    ],
    [
      "tuant",
      0.0175
    ],
    [
      "fondu",
      0.0175
    ],
    [
      "fichu",
      0.0175
    ],
    [
      "fastidieux",
      0.0175
    ],
    [
      "faiblissant",
      0.0175
    ],
    [
      "deliquescent",
      0.0175
    ],
    [
      "decolore",
      0.0175
    ],
    [
      "assourdi",
      0.0175
    ],
    [
      "alangui",
      0.0175
    ],
    [
      "affaibli",
      0.0175
    ],
    [
      "evanescent",
      0.0175
    ]
  ],
  "ermite": [
    [
      "solitaire",
      0.2125
    ],
    [
      "anachorete",
      0.1425
    ],
    [
      "moine",
      0.1425
    ],
    [
      "sauvage",
      0.07
    ],
    [
      "religieux",
      0.07
    ],
    [
      "reclus",
      0.07
    ],
    [
      "misanthrope",
      0.07
    ],
    [
      "isole",
      0.07
    ],
    [
      "ascete",
      0.07
    ]
  ],
  "decrire": [
    [
      "exposer",
      0.1225
    ],
    [
      "raconter",
      0.1225
    ],
    [
      "montrer",
      0.11
    ],
    [
      "representer",
      0.11
    ],
    [
      "retracer",
      0.095
    ],
    [
      "peindre",
      0.08
    ],
    [
      "reveler",
      0.0675
    ],
    [
      "depeindre",
      0.055
    ],
    [
      "evoquer",
      0.025
    ],
    [
      "tracer",
      0.025
    ],
    [
      "signaler",
      0.025
    ],
    [
      "expliquer",
      0.025
    ],
    [
      "conter",
      0.025
    ],
    [
      "afficher",
      0.025
    ],
    [
      "brosser",
      0.0125
    ],
    [
      "camper",
      0.0125
    ],
    [
      "detailler",
      0.0125
    ],
    [
      "modeliser",
      0.0125
    ],
    [
      "narrer",
      0.0125
    ]
  ],
  "decri": [
    [
      "disgrace",
      0.22
    ],
    [
      "decheance",
      0.22
    ],
    [
      "discredit",
      0.11
    ],
    [
      "defaveur",
      0.11
    ],
    [
      "depreciation",
      0.11
    ],
    [
      "fletrissure",
      0.11
    ],
    [
      "noircissement",
      0.11
    ]
  ],
  "petrir": [
    [
      "faconner",
      0.0975
    ],
    [
      "former",
      0.065
    ],
    [
      "malaxer",
      0.065
    ],
    [
      "manier",
      0.065
    ],
    [
      "remuer",
      0.0475
    ],
    [
      "modeler",
      0.0475
    ],
    [
      "masser",
      0.0475
    ],
    [
      "manipuler",
      0.0475
    ],
    [
      "forger",
      0.0475
    ],
    [
      "brasser",
      0.0475
    ],
    [
      "assouplir",
      0.0475
    ],
    [
      "ecraser",
      0.0325
    ],
    [
      "triturer",
      0.0325
    ],
    [
      "tripoter",
      0.0325
    ],
    [
      "travailler",
      0.0325
    ],
    [
      "presser",
      0.0325
    ],
    [
      "melanger",
      0.0325
    ],
    [
      "corroyer",
      0.0325
    ],
    [
      "broyer",
      0.0325
    ],
    [
      "transformer",
      0.015
    ],
    [
      "nourrir",
      0.015
    ],
    [
      "mouler",
      0.015
    ],
    [
      "gacher",
      0.015
    ],
    [
      "fraser",
      0.015
    ],
    [
      "fraiser",
      0.015
    ],
    [
      "eduquer",
      0.015
    ]
  ],
  "petri": [
    [
      "plein",
      0.2075
    ],
    [
      "rempli",
      0.165
    ],
    [
      "penetre",
      0.0825
    ],
    [
      "peuple",
      0.04
    ],
    [
      "melange",
      0.04
    ],
    [
      "modele",
      0.04
    ],
    [
      "malaxe",
      0.04
    ],
    [
      "imbu",
      0.04
    ],
    [
      "gorge",
      0.04
    ],
    [
      "gonfle",
      0.04
    ],
    [
      "foule",
      0.04
    ],
    [
      "faconne",
      0.04
    ],
    [
      "empreint",
      0.04
    ],
    [
      "broye",
      0.04
    ],
    [
      "bouffi",
      0.04
    ],
    [
      "riche",
      0.04
    ]
  ],
  "modernite": [
    [
      "contemporaneite",
      0.5
    ],
    [
      "modernisme",
      0.5
    ]
  ],
  "crime": [
    [
      "faute",
      0.1225
    ],
    [
      "attentat",
      0.0725
    ],
    [
      "peche",
      0.0725
    ],
    [
      "delit",
      0.06
    ],
    [
      "forfait",
      0.06
    ],
    [
      "assassinat",
      0.0475
    ],
    [
      "turpitude",
      0.035
    ],
    [
      "mal",
      0.035
    ],
    [
      "infraction",
      0.035
    ],
    [
      "forfaiture",
      0.035
    ],
    [
      "viol",
      0.0225
    ],
    [
      "trahison",
      0.0225
    ],
    [
      "stupre",
      0.0225
    ],
    [
      "peine",
      0.0225
    ],
    [
      "meurtre",
      0.0225
    ],
    [
      "iniquite",
      0.0225
    ],
    [
      "indignite",
      0.0225
    ],
    [
      "horreur",
      0.0225
    ],
    [
      "homicide",
      0.0225
    ],
    [
      "brigandage",
      0.0225
    ],
    [
      "mefait",
      0.01
    ],
    [
      "parricide",
      0.01
    ],
    [
      "sacrilege",
      0.01
    ],
    [
      "souillure",
      0.01
    ],
    [
      "tache",
      0.01
    ],
    [
      "inceste",
      0.01
    ],
    [
      "fraude",
      0.01
    ],
    [
      "espionnage",
      0.01
    ],
    [
      "empoisonnement",
      0.01
    ],
    [
      "complot",
      0.01
    ],
    [
      "cas",
      0.01
    ],
    [
      "atrocite",
      0.01
    ],
    [
      "vol",
      0.01
    ]
  ],
  "griffe": [
    [
      "dechirer",
      0.2
    ],
    [
      "ecorcher",
      0.15
    ],
    [
      "egratigner",
      0.15
    ],
    [
      "erafler",
      0.15
    ],
    [
      "balafrer",
      0.0975
    ],
    [
      "labourer",
      0.0975
    ],
    [
      "agrafer",
      0.0475
    ],
    [
      "agripper",
      0.0475
    ],
    [
      "excorier",
      0.0475
    ]
  ],
  "griffer": [
    [
      "dechirer",
      0.2
    ],
    [
      "ecorcher",
      0.15
    ],
    [
      "egratigner",
      0.15
    ],
    [
      "erafler",
      0.15
    ],
    [
      "balafrer",
      0.0975
    ],
    [
      "labourer",
      0.0975
    ],
    [
      "agrafer",
      0.0475
    ],
    [
      "agripper",
      0.0475
    ],
    [
      "excorier",
      0.0475
    ]
  ],
  "defectueux": [
    [
      "mauvais",
      0.2
    ],
    [
      "imparfait",
      0.165
    ],
    [
      "insuffisant",
      0.1325
    ],
    [
      "vicieux",
      0.065
    ],
    [
      "incomplet",
      0.065
    ],
    [
      "fautif",
      0.065
    ],
    [
      "mechant",
      0.0325
    ],
    [
      "manque",
      0.0325
    ],
    [
      "labile",
      0.0325
    ],
    [
      "incorrect",
      0.0325
    ],
    [
      "gate",
      0.0325
    ],
    [
      "faiblard",
      0.0325
    ],
    [
      "deficient",
      0.0325
    ],
    [
      "boiteux",
      0.0325
    ],
    [
      "rate",
      0.0325
    ]
  ],
  "bonjour": [
    [
      "salut",
      0.3325
    ],
    [
      "adieu",
      0.165
    ],
    [
      "bienvenue",
      0.165
    ],
    [
      "bonsoir",
      0.165
    ]
  ],
  "ruelle": [
    [
      "cabinet",
      0.22
    ],
    [
      "rue",
      0.22
    ],
    [
      "alcove",
      0.11
    ],
    [
      "allee",
      0.11
    ],
    [
      "salon",
      0.11
    ],
    [
      "venelle",
      0.11
    ],
    [
      "voie",
      0.11
    ]
  ],
  "chanceler": [
    [
      "tituber",
      0.145
    ],
    [
      "vaciller",
      0.125
    ],
    [
      "osciller",
      0.0725
    ],
    [
      "flechir",
      0.06
    ],
    [
      "mollir",
      0.06
    ],
    [
      "faiblir",
      0.05
    ],
    [
      "trebucher",
      0.05
    ],
    [
      "trembler",
      0.04
    ],
    [
      "tanguer",
      0.04
    ],
    [
      "remuer",
      0.04
    ],
    [
      "broncher",
      0.03
    ],
    [
      "chavirer",
      0.03
    ],
    [
      "pencher",
      0.02
    ],
    [
      "hesiter",
      0.02
    ],
    [
      "glisser",
      0.02
    ],
    [
      "flotter",
      0.02
    ],
    [
      "flageoler",
      0.02
    ],
    [
      "branler",
      0.02
    ],
    [
      "s'etonner",
      0.01
    ],
    [
      "s'amollir",
      0.01
    ],
    [
      "plier",
      0.01
    ],
    [
      "defaillir",
      0.01
    ],
    [
      "chopper",
      0.01
    ],
    [
      "buter",
      0.01
    ],
    [
      "basculer",
      0.01
    ],
    [
      "zigzaguer",
      0.01
    ]
  ],
  "portant": [
    [
      "anse",
      0.25
    ],
    [
      "montant",
      0.25
    ],
    [
      "poignee",
      0.25
    ],
    [
      "sustentateur",
      0.25
    ]
  ],
  "tunnel": [
    [
      "galerie",
      0.18
    ],
    [
      "passage",
      0.18
    ],
    [
      "corridor",
      0.09
    ],
    [
      "percement",
      0.09
    ],
    [
      "percee",
      0.09
    ],
    [
      "purgatoire",
      0.09
    ],
    [
      "souterrain",
      0.09
    ],
    [
      "trouee",
      0.09
    ]
  ],
  "percepteur": [
    [
      "collecteur",
      0.5
    ],
    [
      "fisc",
      0.5
    ]
  ],
  "jaquette": [
    [
      "casaque",
      0.2
    ],
    [
      "couverture",
      0.2
    ],
    [
      "habit",
      0.2
    ],
    [
      "jaque",
      0.2
    ],
    [
      "veste",
      0.2
    ]
  ],
  "vetir": [
    [
      "habiller",
      0.17
    ],
    [
      "accoutrer",
      0.1325
    ],
    [
      "fringuer",
      0.1325
    ],
    [
      "deguiser",
      0.075
    ],
    [
      "affubler",
      0.055
    ],
    [
      "couvrir",
      0.055
    ],
    [
      "revetir",
      0.055
    ],
    [
      "harnacher",
      0.035
    ],
    [
      "fagoter",
      0.035
    ],
    [
      "caparaconner",
      0.035
    ],
    [
      "ajuster",
      0.035
    ],
    [
      "nipper",
      0.0175
    ],
    [
      "mettre",
      0.0175
    ],
    [
      "frusquer",
      0.0175
    ],
    [
      "ficeler",
      0.0175
    ],
    [
      "enfiler",
      0.0175
    ],
    [
      "endosser",
      0.0175
    ],
    [
      "costumer",
      0.0175
    ],
    [
      "appreter",
      0.0175
    ],
    [
      "passer",
      0.0175
    ]
  ],
  "chansonnette": [],
  "hostile": [
    [
      "oppose",
      0.0875
    ],
    [
      "contraire",
      0.0725
    ],
    [
      "inhospitalier",
      0.0575
    ],
    [
      "mauvais",
      0.0575
    ],
    [
      "malveillant",
      0.0425
    ],
    [
      "inamical",
      0.0425
    ],
    [
      "froid",
      0.0425
    ],
    [
      "farouche",
      0.0425
    ],
    [
      "ennemi",
      0.0425
    ],
    [
      "desagreable",
      0.0425
    ],
    [
      "defavorable",
      0.0425
    ],
    [
      "cruel",
      0.0425
    ],
    [
      "nefaste",
      0.0275
    ],
    [
      "nuisible",
      0.0275
    ],
    [
      "menacant",
      0.0275
    ],
    [
      "inhumain",
      0.0275
    ],
    [
      "ingrat",
      0.0275
    ],
    [
      "antagoniste",
      0.0275
    ],
    [
      "antagonique",
      0.0275
    ],
    [
      "adverse",
      0.0275
    ],
    [
      "glace",
      0.0125
    ],
    [
      "ferme",
      0.0125
    ],
    [
      "defensif",
      0.0125
    ],
    [
      "divise",
      0.0125
    ],
    [
      "belliqueux",
      0.0125
    ],
    [
      "attentatoire",
      0.0125
    ],
    [
      "alarmant",
      0.0125
    ],
    [
      "indispose",
      0.0125
    ]
  ],
  "costard": [
    [
      "costume",
      0.5
    ],
    [
      "vetement",
      0.5
    ]
  ],
  "uniforme": [
    [
      "monotone",
      0.11
    ],
    [
      "regulier",
      0.0775
    ],
    [
      "morne",
      0.0625
    ],
    [
      "uni",
      0.0625
    ],
    [
      "egal",
      0.0625
    ],
    [
      "unique",
      0.0475
    ],
    [
      "simple",
      0.0475
    ],
    [
      "plat",
      0.0475
    ],
    [
      "identique",
      0.0475
    ],
    [
      "homogene",
      0.0475
    ],
    [
      "semblable",
      0.03
    ],
    [
      "pareil",
      0.03
    ],
    [
      "meme",
      0.03
    ],
    [
      "monocorde",
      0.03
    ],
    [
      "harnais",
      0.03
    ],
    [
      "droit",
      0.03
    ],
    [
      "accoutrement",
      0.03
    ],
    [
      "univoque",
      0.015
    ],
    [
      "triste",
      0.015
    ],
    [
      "regle",
      0.015
    ],
    [
      "psalmodique",
      0.015
    ],
    [
      "insipide",
      0.015
    ],
    [
      "habit",
      0.015
    ],
    [
      "continu",
      0.015
    ],
    [
      "armee",
      0.015
    ],
    [
      "analogue",
      0.015
    ],
    [
      "vetements",
      0.015
    ]
  ],
  "gendre": [],
  "espion": [
    [
      "mouchard",
      0.1225
    ],
    [
      "denonciateur",
      0.1075
    ],
    [
      "delateur",
      0.08
    ],
    [
      "indicateur",
      0.08
    ],
    [
      "policier",
      0.08
    ],
    [
      "cafard",
      0.04
    ],
    [
      "agent",
      0.04
    ],
    [
      "emissaire",
      0.025
    ],
    [
      "traitre",
      0.025
    ],
    [
      "sycophante",
      0.025
    ],
    [
      "surveillant",
      0.025
    ],
    [
      "rapporteur",
      0.025
    ],
    [
      "mouton",
      0.025
    ],
    [
      "mouche",
      0.025
    ],
    [
      "conde",
      0.025
    ],
    [
      "argus",
      0.025
    ],
    [
      "accusateur",
      0.025
    ],
    [
      "indiscret",
      0.0125
    ],
    [
      "limier",
      0.0125
    ],
    [
      "roussi",
      0.0125
    ],
    [
      "roussin",
      0.0125
    ],
    [
      "taupe",
      0.0125
    ],
    [
      "indic",
      0.0125
    ],
    [
      "fureteur",
      0.0125
    ],
    [
      "casserole",
      0.0125
    ],
    [
      "barbouze",
      0.0125
    ],
    [
      "affide",
      0.0125
    ],
    [
      "epieur",
      0.0125
    ]
  ],
  "empoisonner": [
    [
      "fatiguer",
      0.0825
    ],
    [
      "barber",
      0.075
    ],
    [
      "ennuyer",
      0.075
    ],
    [
      "embeter",
      0.0675
    ],
    [
      "assommer",
      0.06
    ],
    [
      "raser",
      0.06
    ],
    [
      "infecter",
      0.045
    ],
    [
      "tanner",
      0.0375
    ],
    [
      "gater",
      0.0375
    ],
    [
      "enquiquiner",
      0.0375
    ],
    [
      "corrompre",
      0.0375
    ],
    [
      "empester",
      0.0275
    ],
    [
      "pervertir",
      0.0275
    ],
    [
      "gangrener",
      0.0225
    ],
    [
      "emmerder",
      0.0225
    ],
    [
      "bassiner",
      0.0225
    ],
    [
      "troubler",
      0.0125
    ],
    [
      "puer",
      0.0125
    ],
    [
      "incommoder",
      0.0125
    ],
    [
      "harceler",
      0.0125
    ],
    [
      "escagasser",
      0.0125
    ],
    [
      "envenimer",
      0.0125
    ],
    [
      "endormir",
      0.0125
    ],
    [
      "empuantir",
      0.0125
    ],
    [
      "embarrasser",
      0.0125
    ],
    [
      "denaturer",
      0.0125
    ],
    [
      "alterer",
      0.0125
    ],
    [
      "ensemencer",
      0.005
    ],
    [
      "infester",
      0.005
    ],
    [
      "intoxiquer",
      0.005
    ],
    [
      "sentir",
      0.005
    ],
    [
      "enfieller",
      0.005
    ],
    [
      "denigrer",
      0.005
    ],
    [
      "contaminer",
      0.005
    ],
    [
      "cavaler",
      0.005
    ],
    [
      "canuler",
      0.005
    ],
    [
      "barbifier",
      0.005
    ],
    [
      "tuer",
      0.005
    ]
  ],
  "illusionner": [
    [
      "bercer",
      0.3325
    ],
    [
      "eblouir",
      0.3325
    ],
    [
      "epater",
      0.3325
    ]
  ],
  "emprisonner": [
    [
      "enfermer",
      0.1175
    ],
    [
      "renfermer",
      0.08
    ],
    [
      "entourer",
      0.06
    ],
    [
      "cerner",
      0.055
    ],
    [
      "tenir",
      0.035
    ],
    [
      "retenir",
      0.035
    ],
    [
      "coffrer",
      0.035
    ],
    [
      "boucler",
      0.0325
    ],
    [
      "envelopper",
      0.0325
    ],
    [
      "interner",
      0.0275
    ],
    [
      "enserrer",
      0.0275
    ],
    [
      "arreter",
      0.0225
    ],
    [
      "contenir",
      0.0225
    ],
    [
      "incarcerer",
      0.0225
    ],
    [
      "investir",
      0.0225
    ],
    [
      "environner",
      0.0175
    ],
    [
      "serrer",
      0.0175
    ],
    [
      "sequestrer",
      0.0175
    ],
    [
      "ecrouer",
      0.0175
    ],
    [
      "enchainer",
      0.0175
    ],
    [
      "emmailloter",
      0.0175
    ],
    [
      "emballer",
      0.0175
    ],
    [
      "detenir",
      0.0175
    ],
    [
      "claquemurer",
      0.0175
    ],
    [
      "assieger",
      0.0175
    ],
    [
      "ligoter",
      0.0125
    ],
    [
      "garrotter",
      0.0125
    ],
    [
      "consigner",
      0.0125
    ],
    [
      "cloitrer",
      0.0125
    ],
    [
      "museler",
      0.0075
    ],
    [
      "ficeler",
      0.0075
    ],
    [
      "comprimer",
      0.0075
    ],
    [
      "cadenasser",
      0.0075
    ],
    [
      "parquer",
      0.0025
    ],
    [
      "encelluler",
      0.0025
    ],
    [
      "encager",
      0.0025
    ],
    [
      "emmurer",
      0.0025
    ],
    [
      "embastiller",
      0.0025
    ],
    [
      "embarquer",
      0.0025
    ],
    [
      "claustrer",
      0.0025
    ],
    [
      "assurer",
      0.0025
    ],
    [
      "reclure",
      0.0025
    ]
  ],
  "papillonner": [
    [
      "voltiger",
      0.15
    ],
    [
      "batifoler",
      0.1
    ],
    [
      "changer",
      0.1
    ],
    [
      "marivauder",
      0.1
    ],
    [
      "voler",
      0.0475
    ],
    [
      "s'eparpiller",
      0.0475
    ],
    [
      "s'agiter",
      0.0475
    ],
    [
      "roucouler",
      0.0475
    ],
    [
      "glisser",
      0.0475
    ],
    [
      "folatrer",
      0.0475
    ],
    [
      "flirter",
      0.0475
    ],
    [
      "voleter",
      0.0475
    ]
  ],
  "resquiller": [
    [
      "frauder",
      0.1425
    ],
    [
      "s'introduire",
      0.1425
    ],
    [
      "tricher",
      0.1425
    ],
    [
      "tromper",
      0.1425
    ],
    [
      "ecornifler",
      0.1425
    ]
  ],
  "oncle": [
    [
      "parent",
      0.5
    ],
    [
      "tonton",
      0.5
    ]
  ],
  "infime": [
    [
      "insignifiant",
      0.155
    ],
    [
      "petit",
      0.1375
    ],
    [
      "minime",
      0.0625
    ],
    [
      "negligeable",
      0.0625
    ],
    [
      "bas",
      0.055
    ],
    [
      "leger",
      0.045
    ],
    [
      "imperceptible",
      0.045
    ],
    [
      "mince",
      0.035
    ],
    [
      "minuscule",
      0.035
    ],
    [
      "miserable",
      0.035
    ],
    [
      "modique",
      0.035
    ],
    [
      "mechant",
      0.035
    ],
    [
      "meprisable",
      0.0275
    ],
    [
      "moindre",
      0.0275
    ],
    [
      "derisoire",
      0.0275
    ],
    [
      "sommaire",
      0.0175
    ],
    [
      "ridicule",
      0.0175
    ],
    [
      "nul",
      0.0175
    ],
    [
      "microscopique",
      0.0175
    ],
    [
      "inferieur",
      0.0175
    ],
    [
      "infinitesimal",
      0.0175
    ],
    [
      "inaudible",
      0.0175
    ],
    [
      "dernier",
      0.0075
    ],
    [
      "menu",
      0.0075
    ],
    [
      "parcimonieux",
      0.0075
    ],
    [
      "elementaire",
      0.0075
    ]
  ],
  "latin": [
    [
      "romain",
      0.5
    ],
    [
      "roman",
      0.5
    ]
  ],
  "vaurien": [
    [
      "fripouille",
      0.14
    ],
    [
      "truand",
      0.1
    ],
    [
      "bandit",
      0.0725
    ],
    [
      "coquin",
      0.0525
    ],
    [
      "brigand",
      0.0475
    ],
    [
      "voleur",
      0.0425
    ],
    [
      "chenapan",
      0.0375
    ],
    [
      "gredin",
      0.0375
    ],
    [
      "canaille",
      0.035
    ],
    [
      "fripon",
      0.025
    ],
    [
      "forban",
      0.0225
    ],
    [
      "garnement",
      0.0225
    ],
    [
      "malfaiteur",
      0.0225
    ],
    [
      "voyou",
      0.0225
    ],
    [
      "polisson",
      0.02
    ],
    [
      "scelerat",
      0.0175
    ],
    [
      "debauche",
      0.0175
    ],
    [
      "crapule",
      0.0175
    ],
    [
      "terreur",
      0.0125
    ],
    [
      "galopin",
      0.01
    ],
    [
      "libertin",
      0.01
    ],
    [
      "malandrin",
      0.01
    ],
    [
      "sacripant",
      0.01
    ],
    [
      "vermine",
      0.0075
    ],
    [
      "salete",
      0.0075
    ],
    [
      "galapiat",
      0.0075
    ],
    [
      "rosse",
      0.005
    ],
    [
      "rossard",
      0.005
    ],
    [
      "pendard",
      0.005
    ],
    [
      "gamin",
      0.005
    ],
    [
      "escroc",
      0.005
    ],
    [
      "devoye",
      0.005
    ],
    [
      "drole",
      0.005
    ],
    [
      "arsouille",
      0.005
    ],
    [
      "vicieux",
      0.0025
    ],
    [
      "saloperie",
      0.0025
    ],
    [
      "salaud",
      0.0025
    ],
    [
      "malhonnete",
      0.0025
    ],
    [
      "gouape",
      0.0025
    ],
    [
      "faineant",
      0.0025
    ],
    [
      "aventurier",
      0.0025
    ],
    [
      "nervi",
      0.0
    ],
    [
      "poisse",
      0.0
    ],
    [
      "ribaud",
      0.0
    ],
    [
      "saligaud",
      0.0
    ],
    [
      "maquereau",
      0.0
    ],
    [
      "individu",
      0.0
    ],
    [
      "gouspin",
      0.0
    ],
    [
      "galvaudeux",
      0.0
    ],
    [
      "frappe",
      0.0
    ],
    [
      "corsaire",
      0.0
    ]
  ],
  "cheville": [
    [
      "attache",
      0.0625
    ],
    [
      "remplissage",
      0.0625
    ],
    [
      "tige",
      0.0425
    ],
    [
      "superfluite",
      0.0425
    ],
    [
      "redondance",
      0.0425
    ],
    [
      "principal",
      0.0425
    ],
    [
      "pleonasme",
      0.0425
    ],
    [
      "clou",
      0.0425
    ],
    [
      "centre",
      0.0425
    ],
    [
      "broche",
      0.0425
    ],
    [
      "axe",
      0.0425
    ],
    [
      "goujon",
      0.02
    ],
    [
      "goupille",
      0.02
    ],
    [
      "gournable",
      0.02
    ],
    [
      "inutilite",
      0.02
    ],
    [
      "nable",
      0.02
    ],
    [
      "pivot",
      0.02
    ],
    [
      "pene",
      0.02
    ],
    [
      "taquet",
      0.02
    ],
    [
      "tautologie",
      0.02
    ],
    [
      "trenail",
      0.02
    ],
    [
      "fiche",
      0.02
    ],
    [
      "fenton",
      0.02
    ],
    [
      "fausset",
      0.02
    ],
    [
      "amarrage",
      0.02
    ],
    [
      "articulation",
      0.02
    ],
    [
      "boulon",
      0.02
    ],
    [
      "bourre",
      0.02
    ],
    [
      "cabillot",
      0.02
    ],
    [
      "clavette",
      0.02
    ],
    [
      "contravention",
      0.02
    ],
    [
      "enture",
      0.02
    ],
    [
      "esse",
      0.02
    ],
    [
      "epite",
      0.02
    ]
  ],
  "impasse": [
    [
      "embarras",
      0.15
    ],
    [
      "bourbier",
      0.0975
    ],
    [
      "danger",
      0.0975
    ],
    [
      "difficulte",
      0.0975
    ],
    [
      "traverse",
      0.0975
    ],
    [
      "voie",
      0.0475
    ],
    [
      "rue",
      0.0475
    ],
    [
      "obstacle",
      0.0475
    ],
    [
      "accul",
      0.0475
    ]
  ],
  "acier": [
    [
      "fer",
      0.5
    ],
    [
      "bronze",
      0.25
    ],
    [
      "poignard",
      0.25
    ]
  ],
  "mutiler": [
    [
      "couper",
      0.13
    ],
    [
      "diminuer",
      0.09
    ],
    [
      "alterer",
      0.0625
    ],
    [
      "tronquer",
      0.0625
    ],
    [
      "degrader",
      0.055
    ],
    [
      "retrancher",
      0.035
    ],
    [
      "estropier",
      0.035
    ],
    [
      "deformer",
      0.035
    ],
    [
      "chatrer",
      0.035
    ],
    [
      "blesser",
      0.035
    ],
    [
      "ebrecher",
      0.0275
    ],
    [
      "tailler",
      0.0275
    ],
    [
      "denaturer",
      0.0275
    ],
    [
      "casser",
      0.0275
    ],
    [
      "amputer",
      0.0275
    ],
    [
      "emasculer",
      0.0175
    ],
    [
      "echarper",
      0.0175
    ],
    [
      "rogner",
      0.0175
    ],
    [
      "raccourcir",
      0.0175
    ],
    [
      "massacrer",
      0.0175
    ],
    [
      "maquiller",
      0.0175
    ],
    [
      "falsifier",
      0.0175
    ],
    [
      "expurger",
      0.0175
    ],
    [
      "deteriorer",
      0.0175
    ],
    [
      "briser",
      0.0175
    ],
    [
      "amoindrir",
      0.0175
    ],
    [
      "truquer",
      0.0075
    ],
    [
      "steriliser",
      0.0075
    ],
    [
      "leser",
      0.0075
    ],
    [
      "essoriller",
      0.0075
    ],
    [
      "deshonorer",
      0.0075
    ],
    [
      "circoncire",
      0.0075
    ],
    [
      "eborgner",
      0.0075
    ]
  ],
  "fol": [
    [
      "insense",
      0.0575
    ],
    [
      "toque",
      0.04
    ],
    [
      "extravagant",
      0.0375
    ],
    [
      "aliene",
      0.03
    ],
    [
      "pique",
      0.0275
    ],
    [
      "cingle",
      0.0275
    ],
    [
      "timbre",
      0.025
    ],
    [
      "bizarre",
      0.025
    ],
    [
      "deraisonnable",
      0.0225
    ],
    [
      "passionne",
      0.02
    ],
    [
      "frenetique",
      0.02
    ],
    [
      "excessif",
      0.02
    ],
    [
      "enrage",
      0.0175
    ],
    [
      "furieux",
      0.0175
    ],
    [
      "violent",
      0.0175
    ],
    [
      "extraordinaire",
      0.015
    ],
    [
      "fabuleux",
      0.015
    ],
    [
      "effrene",
      0.015
    ],
    [
      "absurde",
      0.015
    ],
    [
      "farfelu",
      0.015
    ],
    [
      "fantastique",
      0.0125
    ],
    [
      "desequilibre",
      0.0125
    ],
    [
      "dement",
      0.01
    ],
    [
      "detraque",
      0.01
    ],
    [
      "fanatique",
      0.01
    ],
    [
      "saugrenu",
      0.01
    ],
    [
      "eperdu",
      0.01
    ],
    [
      "exalte",
      0.01
    ],
    [
      "delirant",
      0.01
    ],
    [
      "dingue",
      0.01
    ],
    [
      "tape",
      0.0075
    ],
    [
      "sot",
      0.0075
    ],
    [
      "prodigieux",
      0.0075
    ],
    [
      "malade",
      0.0075
    ],
    [
      "loufoque",
      0.0075
    ],
    [
      "forcene",
      0.0075
    ],
    [
      "braque",
      0.0075
    ],
    [
      "exagere",
      0.0075
    ],
    [
      "extreme",
      0.0075
    ],
    [
      "fantasque",
      0.0075
    ],
    [
      "terrible",
      0.0075
    ],
    [
      "maniaque",
      0.005
    ],
    [
      "deregle",
      0.005
    ],
    [
      "derange",
      0.005
    ],
    [
      "enorme",
      0.005
    ],
    [
      "stupide",
      0.005
    ],
    [
      "ivre",
      0.005
    ],
    [
      "debride",
      0.005
    ],
    [
      "biscornu",
      0.005
    ],
    [
      "amoureux",
      0.005
    ],
    [
      "abracadabrant",
      0.005
    ],
    [
      "etourdi",
      0.005
    ],
    [
      "energumene",
      0.005
    ],
    [
      "vif",
      0.005
    ],
    [
      "incroyable",
      0.005
    ],
    [
      "inconsequent",
      0.005
    ],
    [
      "fele",
      0.005
    ],
    [
      "folatre",
      0.005
    ],
    [
      "dingo",
      0.005
    ],
    [
      "capricieux",
      0.005
    ],
    [
      "aberrant",
      0.005
    ],
    [
      "evapore",
      0.0025
    ],
    [
      "ecervele",
      0.0025
    ],
    [
      "idiot",
      0.0025
    ],
    [
      "excentrique",
      0.0025
    ],
    [
      "desordonne",
      0.0025
    ],
    [
      "branquignol",
      0.0025
    ],
    [
      "affole",
      0.0025
    ],
    [
      "transporte",
      0.0025
    ],
    [
      "tordu",
      0.0025
    ],
    [
      "sonne",
      0.0025
    ],
    [
      "irrationnel",
      0.0025
    ],
    [
      "impossible",
      0.0025
    ],
    [
      "hallucine",
      0.0025
    ],
    [
      "gai",
      0.0025
    ],
    [
      "anormal",
      0.0025
    ],
    [
      "barjo",
      0.0025
    ],
    [
      "foufou",
      0.0025
    ],
    [
      "frappe",
      0.0025
    ],
    [
      "feroce",
      0.0025
    ],
    [
      "sinoque",
      0.0025
    ],
    [
      "petulant",
      0.0025
    ],
    [
      "nevrose",
      0.0025
    ],
    [
      "mordu",
      0.0025
    ],
    [
      "maboul",
      0.0025
    ],
    [
      "immense",
      0.0025
    ],
    [
      "gigantesque",
      0.0025
    ],
    [
      "feru",
      0.0025
    ],
    [
      "explosif",
      0.0025
    ],
    [
      "exorbitant",
      0.0025
    ],
    [
      "espiegle",
      0.0025
    ],
    [
      "givre",
      0.0
    ],
    [
      "hagard",
      0.0
    ],
    [
      "imbecile",
      0.0
    ],
    [
      "inconscient",
      0.0
    ],
    [
      "jete",
      0.0
    ],
    [
      "siphonne",
      0.0
    ],
    [
      "turbulent",
      0.0
    ],
    [
      "egare",
      0.0
    ],
    [
      "fondu",
      0.0
    ],
    [
      "faux",
      0.0
    ],
    [
      "astronomique",
      0.0
    ],
    [
      "badin",
      0.0
    ],
    [
      "bouffon",
      0.0
    ],
    [
      "chimerique",
      0.0
    ],
    [
      "diable",
      0.0
    ],
    [
      "desaxe",
      0.0
    ],
    [
      "faramineux",
      0.0
    ],
    [
      "fatigue",
      0.0
    ],
    [
      "paranoiaque",
      0.0
    ],
    [
      "originalite",
      0.0
    ],
    [
      "obsede",
      0.0
    ],
    [
      "lunatique",
      0.0
    ],
    [
      "irresistible",
      0.0
    ],
    [
      "insane",
      0.0
    ],
    [
      "psychopathe",
      0.0
    ],
    [
      "psychose",
      0.0
    ],
    [
      "risible",
      0.0
    ],
    [
      "risque",
      0.0
    ],
    [
      "schizophrene",
      0.0
    ],
    [
      "vertigineux",
      0.0
    ],
    [
      "epris",
      0.0
    ],
    [
      "etourneau",
      0.0
    ],
    [
      "infatue",
      0.0
    ],
    [
      "inextinguible",
      0.0
    ],
    [
      "bouleverse",
      0.0
    ],
    [
      "brindezingue",
      0.0
    ],
    [
      "cintre",
      0.0
    ],
    [
      "cretin",
      0.0
    ],
    [
      "dangereux",
      0.0
    ],
    [
      "desespere",
      0.0
    ],
    [
      "devergonde",
      0.0
    ],
    [
      "enjoue",
      0.0
    ],
    [
      "homerique",
      0.0
    ],
    [
      "hasardeux",
      0.0
    ],
    [
      "friand",
      0.0
    ],
    [
      "follet",
      0.0
    ],
    [
      "fada",
      0.0
    ],
    [
      "entiche",
      0.0
    ],
    [
      "melancolique",
      0.0
    ],
    [
      "marteau",
      0.0
    ],
    [
      "louftingue",
      0.0
    ],
    [
      "louf",
      0.0
    ],
    [
      "joyeux",
      0.0
    ],
    [
      "obsessionnel",
      0.0
    ],
    [
      "paraphrenique",
      0.0
    ],
    [
      "pervers",
      0.0
    ],
    [
      "phobique",
      0.0
    ],
    [
      "pete",
      0.0
    ],
    [
      "tordant",
      0.0
    ],
    [
      "zinzin",
      0.0
    ],
    [
      "jobard",
      0.0
    ],
    [
      "irrepressible",
      0.0
    ],
    [
      "irraisonnable",
      0.0
    ],
    [
      "azimute",
      0.0
    ],
    [
      "branque",
      0.0
    ],
    [
      "diablotin",
      0.0
    ],
    [
      "desembraye",
      0.0
    ],
    [
      "engoue",
      0.0
    ],
    [
      "enivre",
      0.0
    ],
    [
      "fayard",
      0.0
    ],
    [
      "folingue",
      0.0
    ],
    [
      "hasarde",
      0.0
    ],
    [
      "hysterique",
      0.0
    ],
    [
      "hetre",
      0.0
    ],
    [
      "idolatre",
      0.0
    ],
    [
      "incoercible",
      0.0
    ],
    [
      "interne",
      0.0
    ],
    [
      "atteint",
      0.0
    ]
  ],
  "envol": [
    [
      "envolee",
      0.12
    ],
    [
      "essor",
      0.12
    ],
    [
      "vol",
      0.12
    ],
    [
      "elan",
      0.12
    ],
    [
      "elevation",
      0.08
    ],
    [
      "volee",
      0.08
    ],
    [
      "montee",
      0.08
    ],
    [
      "decollage",
      0.08
    ],
    [
      "cendre",
      0.04
    ],
    [
      "depart",
      0.04
    ],
    [
      "envolement",
      0.04
    ],
    [
      "fuite",
      0.04
    ],
    [
      "poussiere",
      0.04
    ]
  ],
  "meubler": [
    [
      "agencer",
      0.125
    ],
    [
      "enrichir",
      0.125
    ],
    [
      "fournir",
      0.125
    ],
    [
      "nantir",
      0.125
    ],
    [
      "occuper",
      0.125
    ],
    [
      "orner",
      0.125
    ],
    [
      "remplir",
      0.125
    ],
    [
      "etoffer",
      0.125
    ]
  ],
  "meuble": [
    [
      "agencer",
      0.125
    ],
    [
      "enrichir",
      0.125
    ],
    [
      "fournir",
      0.125
    ],
    [
      "nantir",
      0.125
    ],
    [
      "occuper",
      0.125
    ],
    [
      "orner",
      0.125
    ],
    [
      "remplir",
      0.125
    ],
    [
      "etoffer",
      0.125
    ]
  ],
  "berceau": [
    [
      "tonnelle",
      0.0875
    ],
    [
      "commencement",
      0.065
    ],
    [
      "debut",
      0.065
    ],
    [
      "seuil",
      0.0425
    ],
    [
      "origine",
      0.0425
    ],
    [
      "lieu",
      0.0425
    ],
    [
      "gloriette",
      0.0425
    ],
    [
      "endroit",
      0.0425
    ],
    [
      "balbutiement",
      0.0425
    ],
    [
      "creche",
      0.02
    ],
    [
      "feuillage",
      0.02
    ],
    [
      "lit",
      0.02
    ],
    [
      "moise",
      0.02
    ],
    [
      "nacelle",
      0.02
    ],
    [
      "naissance",
      0.02
    ],
    [
      "panier",
      0.02
    ],
    [
      "pergola",
      0.02
    ],
    [
      "place",
      0.02
    ],
    [
      "treillage",
      0.02
    ],
    [
      "couffin",
      0.02
    ],
    [
      "ciseau",
      0.02
    ],
    [
      "arc",
      0.02
    ],
    [
      "barcelonnette",
      0.02
    ],
    [
      "ber",
      0.02
    ],
    [
      "berceuse",
      0.02
    ],
    [
      "biberon",
      0.02
    ],
    [
      "brandebourg",
      0.02
    ],
    [
      "begaiement",
      0.02
    ],
    [
      "cabinet",
      0.02
    ],
    [
      "charmille",
      0.02
    ],
    [
      "cintre",
      0.02
    ],
    [
      "voute",
      0.02
    ]
  ],
  "claire": [
    [
      "evident",
      0.0675
    ],
    [
      "net",
      0.0575
    ],
    [
      "transparent",
      0.0475
    ],
    [
      "limpide",
      0.04
    ],
    [
      "intelligible",
      0.0375
    ],
    [
      "certain",
      0.0375
    ],
    [
      "manifeste",
      0.035
    ],
    [
      "sensible",
      0.03
    ],
    [
      "lumineux",
      0.0275
    ],
    [
      "visible",
      0.0275
    ],
    [
      "pur",
      0.025
    ],
    [
      "franc",
      0.025
    ],
    [
      "distinct",
      0.0225
    ],
    [
      "sincere",
      0.0225
    ],
    [
      "eclatant",
      0.0225
    ],
    [
      "formel",
      0.02
    ],
    [
      "ouvert",
      0.02
    ],
    [
      "precis",
      0.02
    ],
    [
      "vif",
      0.0175
    ],
    [
      "penetrant",
      0.0175
    ],
    [
      "lucide",
      0.0175
    ],
    [
      "comprehensible",
      0.0175
    ],
    [
      "simple",
      0.015
    ],
    [
      "sur",
      0.0125
    ],
    [
      "perceptible",
      0.0125
    ],
    [
      "facile",
      0.0125
    ],
    [
      "categorique",
      0.0125
    ],
    [
      "brillant",
      0.0125
    ],
    [
      "beau",
      0.0125
    ],
    [
      "etincelant",
      0.01
    ],
    [
      "perspicace",
      0.01
    ],
    [
      "leger",
      0.01
    ],
    [
      "poli",
      0.0075
    ],
    [
      "notoire",
      0.0075
    ],
    [
      "diaphane",
      0.0075
    ],
    [
      "apparent",
      0.0075
    ],
    [
      "aigu",
      0.0075
    ],
    [
      "translucide",
      0.005
    ],
    [
      "significatif",
      0.005
    ],
    [
      "pale",
      0.005
    ],
    [
      "luisant",
      0.005
    ],
    [
      "irrecusable",
      0.005
    ],
    [
      "gai",
      0.005
    ],
    [
      "doux",
      0.005
    ],
    [
      "cristallin",
      0.005
    ],
    [
      "clairvoyant",
      0.005
    ],
    [
      "blanc",
      0.005
    ],
    [
      "aise",
      0.005
    ],
    [
      "printanier",
      0.0025
    ],
    [
      "propre",
      0.0025
    ],
    [
      "penetrable",
      0.0025
    ],
    [
      "serein",
      0.0025
    ],
    [
      "eclaire",
      0.0025
    ],
    [
      "palpable",
      0.0025
    ],
    [
      "nettement",
      0.0025
    ],
    [
      "franchement",
      0.0025
    ],
    [
      "fluide",
      0.0025
    ],
    [
      "explicite",
      0.0025
    ],
    [
      "delie",
      0.0025
    ],
    [
      "droit",
      0.0025
    ],
    [
      "conscient",
      0.0025
    ],
    [
      "clairseme",
      0.0
    ],
    [
      "expres",
      0.0
    ],
    [
      "filasse",
      0.0
    ],
    [
      "rare",
      0.0
    ],
    [
      "sagace",
      0.0
    ],
    [
      "clairiere",
      0.0
    ],
    [
      "clairet",
      0.0
    ],
    [
      "clairement",
      0.0
    ],
    [
      "cartesien",
      0.0
    ],
    [
      "aere",
      0.0
    ],
    [
      "argentin",
      0.0
    ],
    [
      "apert",
      0.0
    ]
  ],
  "envoutement": [
    [
      "charme",
      0.16
    ],
    [
      "fascination",
      0.16
    ],
    [
      "magie",
      0.0875
    ],
    [
      "enchantement",
      0.07
    ],
    [
      "ensorcellement",
      0.07
    ],
    [
      "seduction",
      0.07
    ],
    [
      "hypnose",
      0.0525
    ],
    [
      "sorcellerie",
      0.0525
    ],
    [
      "sortilege",
      0.035
    ],
    [
      "prestige",
      0.035
    ],
    [
      "magnetisme",
      0.035
    ],
    [
      "subjugation",
      0.0175
    ],
    [
      "poesie",
      0.0175
    ],
    [
      "passion",
      0.0175
    ],
    [
      "malefice",
      0.0175
    ],
    [
      "incantation",
      0.0175
    ],
    [
      "domination",
      0.0175
    ],
    [
      "blandice",
      0.0175
    ],
    [
      "aimant",
      0.0175
    ],
    [
      "suggestion",
      0.0175
    ]
  ],
  "exulter": [
    [
      "jubiler",
      0.3075
    ],
    [
      "delirer",
      0.1525
    ],
    [
      "deborder",
      0.075
    ],
    [
      "triompher",
      0.075
    ]
  ],
  "cannele": [
    [
      "friser",
      1.0
    ]
  ],
  "etendre": [
    [
      "allonger",
      0.0675
    ],
    [
      "augmenter",
      0.06
    ],
    [
      "developper",
      0.045
    ],
    [
      "accroitre",
      0.0425
    ],
    [
      "etaler",
      0.0325
    ],
    [
      "rallonger",
      0.03
    ],
    [
      "deployer",
      0.03
    ],
    [
      "appliquer",
      0.03
    ],
    [
      "agrandir",
      0.03
    ],
    [
      "grossir",
      0.0225
    ],
    [
      "mettre",
      0.0225
    ],
    [
      "ouvrir",
      0.0225
    ],
    [
      "etirer",
      0.0225
    ],
    [
      "pousser",
      0.02
    ],
    [
      "porter",
      0.02
    ],
    [
      "coucher",
      0.02
    ],
    [
      "amplifier",
      0.02
    ],
    [
      "ajouter",
      0.02
    ],
    [
      "abattre",
      0.02
    ],
    [
      "couper",
      0.0175
    ],
    [
      "couvrir",
      0.0175
    ],
    [
      "repandre",
      0.0175
    ],
    [
      "tapisser",
      0.015
    ],
    [
      "semer",
      0.015
    ],
    [
      "diluer",
      0.015
    ],
    [
      "tirer",
      0.01
    ],
    [
      "tendre",
      0.01
    ],
    [
      "poser",
      0.01
    ],
    [
      "delayer",
      0.01
    ],
    [
      "coller",
      0.01
    ],
    [
      "aggraver",
      0.01
    ],
    [
      "additionner",
      0.01
    ],
    [
      "elargir",
      0.0075
    ],
    [
      "repousser",
      0.0075
    ],
    [
      "renverser",
      0.0075
    ],
    [
      "propager",
      0.0075
    ],
    [
      "prolonger",
      0.0075
    ],
    [
      "placer",
      0.0075
    ],
    [
      "parsemer",
      0.0075
    ],
    [
      "paraphraser",
      0.0075
    ],
    [
      "enduire",
      0.0075
    ],
    [
      "baptiser",
      0.0075
    ],
    [
      "recouvrir",
      0.005
    ],
    [
      "refuser",
      0.005
    ],
    [
      "terrasser",
      0.005
    ],
    [
      "tuer",
      0.005
    ],
    [
      "eclaircir",
      0.005
    ],
    [
      "epanouir",
      0.005
    ],
    [
      "melanger",
      0.005
    ],
    [
      "multiplier",
      0.005
    ],
    [
      "affaiblir",
      0.005
    ],
    [
      "culbuter",
      0.005
    ],
    [
      "diriger",
      0.005
    ],
    [
      "deplier",
      0.005
    ],
    [
      "detirer",
      0.005
    ],
    [
      "enrichir",
      0.005
    ],
    [
      "eparpiller",
      0.0025
    ],
    [
      "tamponner",
      0.0025
    ],
    [
      "mouiller",
      0.0025
    ],
    [
      "generaliser",
      0.0025
    ],
    [
      "detendre",
      0.0025
    ],
    [
      "derouler",
      0.0025
    ],
    [
      "continuer",
      0.0025
    ],
    [
      "arrondir",
      0.0025
    ],
    [
      "aliter",
      0.0025
    ],
    [
      "eployer",
      0.0025
    ]
  ],
  "etendue": [
    [
      "allonger",
      0.0675
    ],
    [
      "augmenter",
      0.06
    ],
    [
      "developper",
      0.045
    ],
    [
      "accroitre",
      0.0425
    ],
    [
      "etaler",
      0.0325
    ],
    [
      "rallonger",
      0.03
    ],
    [
      "deployer",
      0.03
    ],
    [
      "appliquer",
      0.03
    ],
    [
      "agrandir",
      0.03
    ],
    [
      "grossir",
      0.0225
    ],
    [
      "mettre",
      0.0225
    ],
    [
      "ouvrir",
      0.0225
    ],
    [
      "etirer",
      0.0225
    ],
    [
      "pousser",
      0.02
    ],
    [
      "porter",
      0.02
    ],
    [
      "coucher",
      0.02
    ],
    [
      "amplifier",
      0.02
    ],
    [
      "ajouter",
      0.02
    ],
    [
      "abattre",
      0.02
    ],
    [
      "couper",
      0.0175
    ],
    [
      "couvrir",
      0.0175
    ],
    [
      "repandre",
      0.0175
    ],
    [
      "tapisser",
      0.015
    ],
    [
      "semer",
      0.015
    ],
    [
      "diluer",
      0.015
    ],
    [
      "tirer",
      0.01
    ],
    [
      "tendre",
      0.01
    ],
    [
      "poser",
      0.01
    ],
    [
      "delayer",
      0.01
    ],
    [
      "coller",
      0.01
    ],
    [
      "aggraver",
      0.01
    ],
    [
      "additionner",
      0.01
    ],
    [
      "elargir",
      0.0075
    ],
    [
      "repousser",
      0.0075
    ],
    [
      "renverser",
      0.0075
    ],
    [
      "propager",
      0.0075
    ],
    [
      "prolonger",
      0.0075
    ],
    [
      "placer",
      0.0075
    ],
    [
      "parsemer",
      0.0075
    ],
    [
      "paraphraser",
      0.0075
    ],
    [
      "enduire",
      0.0075
    ],
    [
      "baptiser",
      0.0075
    ],
    [
      "recouvrir",
      0.005
    ],
    [
      "refuser",
      0.005
    ],
    [
      "terrasser",
      0.005
    ],
    [
      "tuer",
      0.005
    ],
    [
      "eclaircir",
      0.005
    ],
    [
      "epanouir",
      0.005
    ],
    [
      "melanger",
      0.005
    ],
    [
      "multiplier",
      0.005
    ],
    [
      "affaiblir",
      0.005
    ],
    [
      "culbuter",
      0.005
    ],
    [
      "diriger",
      0.005
    ],
    [
      "deplier",
      0.005
    ],
    [
      "detirer",
      0.005
    ],
    [
      "enrichir",
      0.005
    ],
    [
      "eparpiller",
      0.0025
    ],
    [
      "tamponner",
      0.0025
    ],
    [
      "mouiller",
      0.0025
    ],
    [
      "generaliser",
      0.0025
    ],
    [
      "detendre",
      0.0025
    ],
    [
      "derouler",
      0.0025
    ],
    [
      "continuer",
      0.0025
    ],
    [
      "arrondir",
      0.0025
    ],
    [
      "aliter",
      0.0025
    ],
    [
      "eployer",
      0.0025
    ]
  ],
  "vignoble": [
    [
      "vigne",
      0.4
    ],
    [
      "clos",
      0.2
    ],
    [
      "coteau",
      0.2
    ],
    [
      "plantation",
      0.2
    ]
  ],
  "hublot": [
    [
      "fenetre",
      0.5
    ],
    [
      "ouverture",
      0.5
    ]
  ],
  "galet": [
    [
      "pierre",
      0.285
    ],
    [
      "roche",
      0.285
    ],
    [
      "caillou",
      0.1425
    ],
    [
      "pave",
      0.1425
    ],
    [
      "roulette",
      0.1425
    ]
  ],
  "trajet": [
    [
      "chemin",
      0.1225
    ],
    [
      "parcours",
      0.1225
    ],
    [
      "course",
      0.1
    ],
    [
      "route",
      0.0775
    ],
    [
      "itineraire",
      0.065
    ],
    [
      "marche",
      0.055
    ],
    [
      "circuit",
      0.0425
    ],
    [
      "tour",
      0.0425
    ],
    [
      "voyage",
      0.0425
    ],
    [
      "etape",
      0.0325
    ],
    [
      "voie",
      0.0325
    ],
    [
      "trajectoire",
      0.0325
    ],
    [
      "distance",
      0.0325
    ],
    [
      "direction",
      0.0325
    ],
    [
      "trotte",
      0.02
    ],
    [
      "traite",
      0.02
    ],
    [
      "mouvement",
      0.02
    ],
    [
      "espace",
      0.02
    ],
    [
      "cheminement",
      0.02
    ],
    [
      "ruban",
      0.01
    ],
    [
      "trace",
      0.01
    ],
    [
      "traversee",
      0.01
    ]
  ],
  "coffret": [
    [
      "boite",
      0.27
    ],
    [
      "ecrin",
      0.115
    ],
    [
      "coffre",
      0.075
    ],
    [
      "cassette",
      0.075
    ],
    [
      "caisse",
      0.075
    ],
    [
      "cagnotte",
      0.075
    ],
    [
      "baguier",
      0.075
    ],
    [
      "album",
      0.0375
    ],
    [
      "bonbonniere",
      0.0375
    ],
    [
      "cadenas",
      0.0375
    ],
    [
      "kit",
      0.0375
    ],
    [
      "reliquaire",
      0.0375
    ]
  ],
  "quoique": [
    [
      "pour",
      0.2
    ],
    [
      "tout",
      0.2
    ]
  ],
  "recoin": [
    [
      "repli",
      0.265
    ],
    [
      "pli",
      0.2
    ],
    [
      "coin",
      0.1325
    ],
    [
      "secret",
      0.1325
    ],
    [
      "compartiment",
      0.065
    ],
    [
      "racoin",
      0.065
    ],
    [
      "sinuosite",
      0.065
    ],
    [
      "trefonds",
      0.065
    ]
  ],
  "filet": [
    [
      "piege",
      0.0675
    ],
    [
      "balance",
      0.035
    ],
    [
      "carrelet",
      0.0275
    ],
    [
      "passement",
      0.0275
    ],
    [
      "senne",
      0.0275
    ],
    [
      "epuisette",
      0.0275
    ],
    [
      "truble",
      0.0225
    ],
    [
      "resille",
      0.0225
    ],
    [
      "reseau",
      0.0225
    ],
    [
      "nasse",
      0.0225
    ],
    [
      "chalut",
      0.0225
    ],
    [
      "lacs",
      0.0125
    ],
    [
      "listel",
      0.0125
    ],
    [
      "poche",
      0.0125
    ],
    [
      "pochette",
      0.0125
    ],
    [
      "puche",
      0.0125
    ],
    [
      "rets",
      0.0125
    ],
    [
      "reticule",
      0.0125
    ],
    [
      "souriciere",
      0.0125
    ],
    [
      "tirasse",
      0.0125
    ],
    [
      "haveneau",
      0.0125
    ],
    [
      "hallier",
      0.0125
    ],
    [
      "bolier",
      0.0125
    ],
    [
      "bourraque",
      0.0125
    ],
    [
      "braie",
      0.0125
    ],
    [
      "carre",
      0.0125
    ],
    [
      "coiffure",
      0.0125
    ],
    [
      "crevettier",
      0.0125
    ],
    [
      "embuscade",
      0.0125
    ],
    [
      "embuche",
      0.0125
    ],
    [
      "fil",
      0.0125
    ],
    [
      "pantiere",
      0.005
    ],
    [
      "peu",
      0.005
    ],
    [
      "picot",
      0.005
    ],
    [
      "pousseux",
      0.005
    ],
    [
      "panneau",
      0.005
    ],
    [
      "magret",
      0.005
    ],
    [
      "langoustier",
      0.005
    ],
    [
      "lacis",
      0.005
    ],
    [
      "lacet",
      0.005
    ],
    [
      "hamecon",
      0.005
    ],
    [
      "guepier",
      0.005
    ],
    [
      "ridee",
      0.005
    ],
    [
      "rissole",
      0.005
    ],
    [
      "epervier",
      0.005
    ],
    [
      "echiquier",
      0.005
    ],
    [
      "verveux",
      0.005
    ],
    [
      "vannet",
      0.005
    ],
    [
      "traineau",
      0.005
    ],
    [
      "traine",
      0.005
    ],
    [
      "trainasse",
      0.005
    ],
    [
      "tramail",
      0.005
    ],
    [
      "tournedos",
      0.005
    ],
    [
      "thonaire",
      0.005
    ],
    [
      "supreme",
      0.005
    ],
    [
      "sardinier",
      0.005
    ],
    [
      "guideau",
      0.005
    ],
    [
      "goutte",
      0.005
    ],
    [
      "but",
      0.005
    ],
    [
      "broderie",
      0.005
    ],
    [
      "bouterolle",
      0.005
    ],
    [
      "boulier",
      0.005
    ],
    [
      "bolinche",
      0.005
    ],
    [
      "blanc",
      0.005
    ],
    [
      "bastude",
      0.005
    ],
    [
      "bastingue",
      0.005
    ],
    [
      "araignee",
      0.005
    ],
    [
      "annelet",
      0.005
    ],
    [
      "aiguillette",
      0.005
    ],
    [
      "caudrette",
      0.005
    ],
    [
      "cerceau",
      0.005
    ],
    [
      "goujonnier",
      0.005
    ],
    [
      "gabare",
      0.005
    ],
    [
      "folle",
      0.005
    ],
    [
      "filoche",
      0.005
    ],
    [
      "filiere",
      0.005
    ],
    [
      "filetage",
      0.005
    ],
    [
      "fibre",
      0.005
    ],
    [
      "drege",
      0.005
    ],
    [
      "dentelle",
      0.005
    ],
    [
      "combriere",
      0.005
    ],
    [
      "chateaubriand",
      0.005
    ],
    [
      "ableret",
      0.005
    ]
  ],
  "conte": [
    [
      "histoire",
      0.0975
    ],
    [
      "roman",
      0.08
    ],
    [
      "fable",
      0.075
    ],
    [
      "recit",
      0.0575
    ],
    [
      "mensonge",
      0.0525
    ],
    [
      "bateau",
      0.0475
    ],
    [
      "nouvelle",
      0.04
    ],
    [
      "chanson",
      0.04
    ],
    [
      "anecdote",
      0.035
    ],
    [
      "blague",
      0.035
    ],
    [
      "boniment",
      0.035
    ],
    [
      "sornette",
      0.03
    ],
    [
      "craque",
      0.03
    ],
    [
      "bruit",
      0.03
    ],
    [
      "bobard",
      0.025
    ],
    [
      "bourde",
      0.025
    ],
    [
      "invention",
      0.02
    ],
    [
      "narration",
      0.02
    ],
    [
      "feuilleton",
      0.015
    ],
    [
      "hablerie",
      0.015
    ],
    [
      "racontar",
      0.015
    ],
    [
      "ragot",
      0.0125
    ],
    [
      "calembredaine",
      0.0125
    ],
    [
      "baliverne",
      0.0125
    ],
    [
      "rapport",
      0.0075
    ],
    [
      "radotage",
      0.0075
    ],
    [
      "legende",
      0.0075
    ],
    [
      "historiette",
      0.0075
    ],
    [
      "fiction",
      0.0075
    ],
    [
      "fadaise",
      0.0075
    ],
    [
      "description",
      0.0075
    ],
    [
      "cancan",
      0.0075
    ],
    [
      "baratin",
      0.0075
    ],
    [
      "allegorie",
      0.0075
    ],
    [
      "rodomontade",
      0.0025
    ],
    [
      "imagination",
      0.0025
    ],
    [
      "fagot",
      0.0025
    ],
    [
      "fabliau",
      0.0025
    ],
    [
      "colle",
      0.0025
    ],
    [
      "canard",
      0.0025
    ],
    [
      "bourbe",
      0.0025
    ],
    [
      "epopee",
      0.0025
    ]
  ],
  "inapercu": [],
  "recouvrir": [
    [
      "couvrir",
      0.1625
    ],
    [
      "tapisser",
      0.08
    ],
    [
      "envelopper",
      0.055
    ],
    [
      "masquer",
      0.055
    ],
    [
      "garnir",
      0.0475
    ],
    [
      "revetir",
      0.04
    ],
    [
      "s'etendre",
      0.03
    ],
    [
      "deguiser",
      0.03
    ],
    [
      "cacher",
      0.03
    ],
    [
      "submerger",
      0.0225
    ],
    [
      "parsemer",
      0.0225
    ],
    [
      "inonder",
      0.0225
    ],
    [
      "enduire",
      0.0225
    ],
    [
      "embrasser",
      0.0225
    ],
    [
      "dissimuler",
      0.0225
    ],
    [
      "camoufler",
      0.0225
    ],
    [
      "etoffer",
      0.015
    ],
    [
      "etendre",
      0.015
    ],
    [
      "poudrer",
      0.015
    ],
    [
      "joncher",
      0.015
    ],
    [
      "habiller",
      0.015
    ],
    [
      "ensevelir",
      0.015
    ],
    [
      "enrober",
      0.015
    ],
    [
      "coiffer",
      0.015
    ],
    [
      "charger",
      0.015
    ],
    [
      "barder",
      0.015
    ],
    [
      "appliquer",
      0.015
    ],
    [
      "s'appliquer",
      0.005
    ],
    [
      "superposer",
      0.005
    ],
    [
      "tenir",
      0.005
    ],
    [
      "terrer",
      0.005
    ],
    [
      "paver",
      0.005
    ],
    [
      "escamoter",
      0.005
    ],
    [
      "chevaucher",
      0.005
    ],
    [
      "capuchonner",
      0.005
    ],
    [
      "bacher",
      0.005
    ],
    [
      "badigeonner",
      0.005
    ],
    [
      "voiler",
      0.005
    ]
  ],
  "recouvrer": [
    [
      "recuperer",
      0.1925
    ],
    [
      "rattraper",
      0.115
    ],
    [
      "reprendre",
      0.115
    ],
    [
      "retrouver",
      0.115
    ],
    [
      "regagner",
      0.075
    ],
    [
      "ressaisir",
      0.075
    ],
    [
      "reconquerir",
      0.0375
    ],
    [
      "recevoir",
      0.0375
    ],
    [
      "ravoir",
      0.0375
    ],
    [
      "rappeler",
      0.0375
    ],
    [
      "percevoir",
      0.0375
    ],
    [
      "encaisser",
      0.0375
    ],
    [
      "toucher",
      0.0375
    ]
  ],
  "charade": [
    [
      "devinette",
      0.2
    ],
    [
      "rebus",
      0.2
    ],
    [
      "enigme",
      0.2
    ],
    [
      "logogriphe",
      0.1
    ],
    [
      "question",
      0.1
    ],
    [
      "saynete",
      0.1
    ]
  ],
  "verger": [
    [
      "jardin",
      0.375
    ],
    [
      "plantation",
      0.25
    ],
    [
      "champ",
      0.125
    ],
    [
      "fruitier",
      0.125
    ],
    [
      "ouche",
      0.125
    ]
  ],
  "faillir": [
    [
      "manquer",
      0.235
    ],
    [
      "pecher",
      0.1175
    ],
    [
      "tomber",
      0.0925
    ],
    [
      "penser",
      0.045
    ],
    [
      "chuter",
      0.045
    ],
    [
      "broncher",
      0.045
    ],
    [
      "s'esquiver",
      0.0225
    ],
    [
      "s'abuser",
      0.0225
    ],
    [
      "s'abandonner",
      0.0225
    ],
    [
      "oublier",
      0.0225
    ],
    [
      "forfaire",
      0.0225
    ],
    [
      "fauter",
      0.0225
    ],
    [
      "faiblir",
      0.0225
    ],
    [
      "defaillir",
      0.0225
    ],
    [
      "croire",
      0.0225
    ],
    [
      "choir",
      0.0225
    ]
  ],
  "failli": [
    [
      "insolvable",
      1.0
    ]
  ],
  "marinade": [],
  "apprivoiser": [
    [
      "adoucir",
      0.0925
    ],
    [
      "polir",
      0.0775
    ],
    [
      "dresser",
      0.06
    ],
    [
      "faconner",
      0.06
    ],
    [
      "eduquer",
      0.045
    ],
    [
      "seduire",
      0.045
    ],
    [
      "styler",
      0.045
    ],
    [
      "soumettre",
      0.045
    ],
    [
      "habituer",
      0.045
    ],
    [
      "gagner",
      0.045
    ],
    [
      "conquerir",
      0.045
    ],
    [
      "civiliser",
      0.045
    ],
    [
      "charmer",
      0.045
    ],
    [
      "assouplir",
      0.045
    ],
    [
      "prendre",
      0.03
    ],
    [
      "familiariser",
      0.03
    ],
    [
      "dompter",
      0.03
    ],
    [
      "domestiquer",
      0.03
    ],
    [
      "amadouer",
      0.03
    ],
    [
      "acclimater",
      0.0125
    ],
    [
      "affaiter",
      0.0125
    ],
    [
      "defiger",
      0.0125
    ],
    [
      "humaniser",
      0.0125
    ],
    [
      "priver",
      0.0125
    ],
    [
      "tranquilliser",
      0.0125
    ]
  ],
  "curer": [
    [
      "nettoyer",
      0.3075
    ],
    [
      "draguer",
      0.1525
    ],
    [
      "recurer",
      0.1525
    ],
    [
      "debourber",
      0.075
    ],
    [
      "devaser",
      0.075
    ],
    [
      "purger",
      0.075
    ],
    [
      "racler",
      0.075
    ],
    [
      "ecurer",
      0.075
    ]
  ],
  "cure": [
    [
      "nettoyer",
      0.3075
    ],
    [
      "draguer",
      0.1525
    ],
    [
      "recurer",
      0.1525
    ],
    [
      "debourber",
      0.075
    ],
    [
      "devaser",
      0.075
    ],
    [
      "purger",
      0.075
    ],
    [
      "racler",
      0.075
    ],
    [
      "ecurer",
      0.075
    ]
  ],
  "eclaircir": [
    [
      "debrouiller",
      0.0925
    ],
    [
      "eclairer",
      0.0625
    ],
    [
      "degager",
      0.0575
    ],
    [
      "expliquer",
      0.0575
    ],
    [
      "illustrer",
      0.0575
    ],
    [
      "elucider",
      0.0425
    ],
    [
      "demeler",
      0.0425
    ],
    [
      "degrossir",
      0.0425
    ],
    [
      "developper",
      0.035
    ],
    [
      "balayer",
      0.0275
    ],
    [
      "clarifier",
      0.0275
    ],
    [
      "renseigner",
      0.02
    ],
    [
      "polir",
      0.02
    ],
    [
      "nettoyer",
      0.02
    ],
    [
      "instruire",
      0.02
    ],
    [
      "denouer",
      0.02
    ],
    [
      "defricher",
      0.02
    ],
    [
      "debroussailler",
      0.02
    ],
    [
      "diminuer",
      0.02
    ],
    [
      "etendre",
      0.0125
    ],
    [
      "elaguer",
      0.0125
    ],
    [
      "edifier",
      0.0125
    ],
    [
      "tailler",
      0.0125
    ],
    [
      "paraphraser",
      0.0125
    ],
    [
      "demystifier",
      0.0125
    ],
    [
      "dechiffrer",
      0.0125
    ],
    [
      "decanter",
      0.0125
    ],
    [
      "distinguer",
      0.0125
    ],
    [
      "blanchir",
      0.0125
    ],
    [
      "devider",
      0.005
    ],
    [
      "fluidifier",
      0.005
    ],
    [
      "illuminer",
      0.005
    ],
    [
      "informer",
      0.005
    ],
    [
      "relacher",
      0.005
    ],
    [
      "desepaissir",
      0.005
    ],
    [
      "desherber",
      0.005
    ],
    [
      "desembrouiller",
      0.005
    ],
    [
      "affadir",
      0.005
    ],
    [
      "allonger",
      0.005
    ],
    [
      "aerer",
      0.005
    ],
    [
      "clairsemer",
      0.005
    ],
    [
      "dissiper",
      0.005
    ],
    [
      "delaver",
      0.005
    ],
    [
      "demontrer",
      0.005
    ],
    [
      "depeupler",
      0.005
    ],
    [
      "enoncer",
      0.005
    ]
  ],
  "papy": [],
  "e": [],
  "bonus": [
    [
      "gratification",
      0.5
    ],
    [
      "prime",
      0.5
    ]
  ],
  "fra": [],
  "frangipane": [],
  "mademoiselle": [
    [
      "princesse",
      1.0
    ]
  ],
  "gastronomie": [
    [
      "cuisine",
      0.3625
    ],
    [
      "alimentation",
      0.09
    ],
    [
      "chere",
      0.09
    ],
    [
      "gastrologie",
      0.09
    ],
    [
      "gourmandise",
      0.09
    ],
    [
      "table",
      0.09
    ]
  ],
  "presenter": [
    [
      "exposer",
      0.105
    ],
    [
      "montrer",
      0.095
    ],
    [
      "reveler",
      0.0825
    ],
    [
      "donner",
      0.065
    ],
    [
      "offrir",
      0.055
    ],
    [
      "afficher",
      0.0475
    ],
    [
      "produire",
      0.0475
    ],
    [
      "former",
      0.03
    ],
    [
      "representer",
      0.0225
    ],
    [
      "avancer",
      0.02
    ],
    [
      "exhiber",
      0.02
    ],
    [
      "marquer",
      0.02
    ],
    [
      "porter",
      0.02
    ],
    [
      "proposer",
      0.02
    ],
    [
      "annoncer",
      0.0175
    ],
    [
      "arranger",
      0.0125
    ],
    [
      "disposer",
      0.0125
    ],
    [
      "publier",
      0.0125
    ],
    [
      "soumettre",
      0.0125
    ],
    [
      "enoncer",
      0.0125
    ],
    [
      "etaler",
      0.01
    ],
    [
      "dessiner",
      0.01
    ],
    [
      "avoir",
      0.01
    ],
    [
      "emettre",
      0.0075
    ],
    [
      "tourner",
      0.0075
    ],
    [
      "mener",
      0.0075
    ],
    [
      "introduire",
      0.0075
    ],
    [
      "fournir",
      0.0075
    ],
    [
      "developper",
      0.0075
    ],
    [
      "diriger",
      0.0075
    ],
    [
      "constituer",
      0.0075
    ],
    [
      "compter",
      0.0075
    ],
    [
      "aligner",
      0.0075
    ],
    [
      "affecter",
      0.0075
    ],
    [
      "adresser",
      0.0075
    ],
    [
      "tendre",
      0.005
    ],
    [
      "servir",
      0.005
    ],
    [
      "respirer",
      0.005
    ],
    [
      "contenir",
      0.005
    ],
    [
      "amener",
      0.005
    ],
    [
      "recommander",
      0.0025
    ],
    [
      "deposer",
      0.0025
    ],
    [
      "demander",
      0.0025
    ],
    [
      "commenter",
      0.0025
    ],
    [
      "accrediter",
      0.0025
    ],
    [
      "s'opposer",
      0.0025
    ]
  ],
  "diner": [
    [
      "repas",
      0.25
    ],
    [
      "dejeuner",
      0.165
    ],
    [
      "souper",
      0.165
    ],
    [
      "dinette",
      0.0825
    ],
    [
      "dinee",
      0.0825
    ],
    [
      "manger",
      0.0825
    ],
    [
      "reception",
      0.0825
    ]
  ],
  "bavette": [
    [
      "bavoir",
      0.5
    ],
    [
      "conversation",
      0.5
    ]
  ],
  "oeuvre": [
    [
      "travail",
      0.1275
    ],
    [
      "ouvrage",
      0.115
    ],
    [
      "action",
      0.075
    ],
    [
      "besogne",
      0.05
    ],
    [
      "entreprise",
      0.05
    ],
    [
      "production",
      0.05
    ],
    [
      "tache",
      0.05
    ],
    [
      "creation",
      0.0375
    ],
    [
      "batiment",
      0.0375
    ],
    [
      "affaire",
      0.0375
    ],
    [
      "acte",
      0.0375
    ],
    [
      "edifice",
      0.025
    ],
    [
      "ecrit",
      0.025
    ],
    [
      "realisation",
      0.025
    ],
    [
      "poeme",
      0.025
    ],
    [
      "mission",
      0.025
    ],
    [
      "geste",
      0.025
    ],
    [
      "conception",
      0.025
    ],
    [
      "opus",
      0.0125
    ],
    [
      "maconnerie",
      0.0125
    ],
    [
      "main",
      0.0125
    ],
    [
      "livre",
      0.0125
    ],
    [
      "labeur",
      0.0125
    ],
    [
      "devoir",
      0.0125
    ],
    [
      "dessin",
      0.0125
    ],
    [
      "bienfaisance",
      0.0125
    ],
    [
      "assistance",
      0.0125
    ],
    [
      "allegorie",
      0.0125
    ],
    [
      "theatre",
      0.0125
    ]
  ],
  "oeuvrer": [
    [
      "travailler",
      0.3325
    ],
    [
      "agir",
      0.165
    ],
    [
      "fabriquer",
      0.165
    ],
    [
      "fonctionner",
      0.165
    ],
    [
      "ouvrer",
      0.165
    ]
  ],
  "connaisseur": [
    [
      "expert",
      0.18
    ],
    [
      "competent",
      0.135
    ],
    [
      "gourmet",
      0.135
    ],
    [
      "amateur",
      0.09
    ],
    [
      "experimente",
      0.09
    ],
    [
      "raffine",
      0.045
    ],
    [
      "ferre",
      0.045
    ],
    [
      "entendu",
      0.045
    ],
    [
      "dilettante",
      0.045
    ],
    [
      "appreciateur",
      0.045
    ],
    [
      "admirateur",
      0.045
    ],
    [
      "verse",
      0.045
    ]
  ],
  "selle": [
    [
      "siege",
      0.25
    ],
    [
      "misericorde",
      0.0825
    ],
    [
      "harnachement",
      0.0825
    ],
    [
      "excrement",
      0.0825
    ],
    [
      "chaise",
      0.0825
    ],
    [
      "cacolet",
      0.0825
    ],
    [
      "bat",
      0.0825
    ],
    [
      "brele",
      0.0825
    ],
    [
      "trepied",
      0.0825
    ]
  ],
  "seller": [
    [
      "atteler",
      1.0
    ]
  ],
  "menu": [
    [
      "mince",
      0.1
    ],
    [
      "leger",
      0.09
    ],
    [
      "grele",
      0.0825
    ],
    [
      "tenu",
      0.0825
    ],
    [
      "delicat",
      0.055
    ],
    [
      "svelte",
      0.0425
    ],
    [
      "fragile",
      0.0425
    ],
    [
      "delie",
      0.0375
    ],
    [
      "repas",
      0.0325
    ],
    [
      "petit",
      0.0325
    ],
    [
      "fluet",
      0.0325
    ],
    [
      "fin",
      0.0325
    ],
    [
      "cuisine",
      0.0325
    ],
    [
      "faible",
      0.0275
    ],
    [
      "frele",
      0.0275
    ],
    [
      "gracile",
      0.0275
    ],
    [
      "insignifiant",
      0.02
    ],
    [
      "ordinaire",
      0.02
    ],
    [
      "negligeable",
      0.015
    ],
    [
      "fusele",
      0.015
    ],
    [
      "chere",
      0.015
    ],
    [
      "alimentation",
      0.01
    ],
    [
      "mets",
      0.01
    ],
    [
      "mievre",
      0.01
    ],
    [
      "programme",
      0.005
    ],
    [
      "rabougri",
      0.005
    ],
    [
      "regal",
      0.005
    ],
    [
      "subtil",
      0.005
    ],
    [
      "table",
      0.005
    ],
    [
      "popote",
      0.005
    ],
    [
      "infime",
      0.005
    ],
    [
      "futile",
      0.005
    ],
    [
      "follet",
      0.005
    ],
    [
      "festin",
      0.005
    ],
    [
      "carte",
      0.005
    ],
    [
      "amenuise",
      0.005
    ],
    [
      "tarif",
      0.005
    ]
  ],
  "minet": [
    [
      "chat",
      0.235
    ],
    [
      "adolescent",
      0.1175
    ],
    [
      "galant",
      0.1175
    ],
    [
      "mimi",
      0.1175
    ],
    [
      "minon",
      0.1175
    ],
    [
      "minou",
      0.0575
    ],
    [
      "biquet",
      0.0575
    ],
    [
      "amant",
      0.0575
    ],
    [
      "mistigri",
      0.0575
    ]
  ],
  "pari": [
    [
      "P.M.U.",
      0.3325
    ],
    [
      "enjeu",
      0.3325
    ],
    [
      "gageure",
      0.3325
    ]
  ],
  "creper": [
    [
      "friser",
      0.5
    ],
    [
      "moutonner",
      0.5
    ]
  ],
  "crepe": [
    [
      "blinis",
      0.11
    ],
    [
      "brassage",
      0.11
    ],
    [
      "brassard",
      0.11
    ],
    [
      "coiffure",
      0.11
    ],
    [
      "matefaim",
      0.11
    ],
    [
      "pannequet",
      0.11
    ],
    [
      "soie",
      0.11
    ],
    [
      "touffe",
      0.11
    ],
    [
      "voile",
      0.11
    ]
  ],
  "flambee": [
    [
      "bruler",
      0.14
    ],
    [
      "flamboyer",
      0.07
    ],
    [
      "voler",
      0.07
    ],
    [
      "etinceler",
      0.045
    ],
    [
      "refaire",
      0.045
    ],
    [
      "perdre",
      0.045
    ],
    [
      "luire",
      0.045
    ],
    [
      "griller",
      0.045
    ],
    [
      "dilapider",
      0.045
    ],
    [
      "briller",
      0.045
    ],
    [
      "rayonner",
      0.0225
    ],
    [
      "repasser",
      0.0225
    ],
    [
      "ruiner",
      0.0225
    ],
    [
      "s'embraser",
      0.0225
    ],
    [
      "s'enflammer",
      0.0225
    ],
    [
      "scintiller",
      0.0225
    ],
    [
      "steriliser",
      0.0225
    ],
    [
      "jouer",
      0.0225
    ],
    [
      "gazer",
      0.0225
    ],
    [
      "depenser",
      0.0225
    ],
    [
      "cuire",
      0.0225
    ],
    [
      "cramer",
      0.0225
    ],
    [
      "ardre",
      0.0225
    ],
    [
      "ardoir",
      0.0225
    ],
    [
      "arder",
      0.0225
    ],
    [
      "tondre",
      0.0225
    ]
  ],
  "sifflet": [
    [
      "appeau",
      0.1175
    ],
    [
      "appel",
      0.1175
    ],
    [
      "signal",
      0.0575
    ],
    [
      "sifflement",
      0.0575
    ],
    [
      "serinette",
      0.0575
    ],
    [
      "pipeau",
      0.0575
    ],
    [
      "huee",
      0.0575
    ],
    [
      "huchet",
      0.0575
    ],
    [
      "gosier",
      0.0575
    ],
    [
      "gorge",
      0.0575
    ],
    [
      "charivari",
      0.0575
    ],
    [
      "chahut",
      0.0575
    ],
    [
      "arbitre",
      0.0575
    ],
    [
      "tolle",
      0.0575
    ]
  ],
  "cafard": [
    [
      "melancolie",
      0.0775
    ],
    [
      "tristesse",
      0.0775
    ],
    [
      "hypocrite",
      0.065
    ],
    [
      "tartufe",
      0.0525
    ],
    [
      "spleen",
      0.0475
    ],
    [
      "cagot",
      0.04
    ],
    [
      "ennui",
      0.035
    ],
    [
      "sournois",
      0.0275
    ],
    [
      "fourbe",
      0.0275
    ],
    [
      "devot",
      0.0275
    ],
    [
      "depression",
      0.0275
    ],
    [
      "denonciateur",
      0.0275
    ],
    [
      "bourdon",
      0.0275
    ],
    [
      "patelin",
      0.0225
    ],
    [
      "neurasthenie",
      0.0225
    ],
    [
      "mouchard",
      0.0225
    ],
    [
      "chagrin",
      0.0225
    ],
    [
      "bigot",
      0.0225
    ],
    [
      "rapporteur",
      0.015
    ],
    [
      "peine",
      0.015
    ],
    [
      "espion",
      0.015
    ],
    [
      "delateur",
      0.015
    ],
    [
      "decouragement",
      0.015
    ],
    [
      "benoit",
      0.015
    ],
    [
      "pharisien",
      0.01
    ],
    [
      "perfide",
      0.01
    ],
    [
      "nostalgie",
      0.01
    ],
    [
      "imposteur",
      0.01
    ],
    [
      "flic",
      0.01
    ],
    [
      "deprime",
      0.01
    ],
    [
      "conde",
      0.01
    ],
    [
      "chafouin",
      0.01
    ],
    [
      "cafeteur",
      0.01
    ],
    [
      "cuistre",
      0.005
    ],
    [
      "desesperance",
      0.005
    ],
    [
      "mouche",
      0.005
    ],
    [
      "pieux",
      0.005
    ],
    [
      "capon",
      0.005
    ],
    [
      "cancrelat",
      0.005
    ],
    [
      "cafardeux",
      0.005
    ],
    [
      "cafardeur",
      0.005
    ],
    [
      "bondieusard",
      0.005
    ],
    [
      "blues",
      0.005
    ],
    [
      "blatte",
      0.005
    ],
    [
      "poulet",
      0.005
    ]
  ],
  "jongler": [
    [
      "jouer",
      0.3325
    ],
    [
      "mepriser",
      0.3325
    ]
  ],
  "chandelier": [
    [
      "torchere",
      0.3675
    ],
    [
      "flambeau",
      0.105
    ],
    [
      "torche",
      0.0525
    ],
    [
      "souteneur",
      0.0525
    ],
    [
      "martinet",
      0.0525
    ],
    [
      "lustre",
      0.0525
    ],
    [
      "girandole",
      0.0525
    ],
    [
      "candelabre",
      0.0525
    ],
    [
      "bras",
      0.0525
    ],
    [
      "bougeoir",
      0.0525
    ],
    [
      "applique",
      0.0525
    ],
    [
      "etai",
      0.0525
    ]
  ],
  "tradition": [
    [
      "pratique",
      0.1275
    ],
    [
      "rite",
      0.1275
    ],
    [
      "coutume",
      0.095
    ],
    [
      "habitude",
      0.095
    ],
    [
      "usage",
      0.095
    ],
    [
      "observance",
      0.03
    ],
    [
      "passe",
      0.03
    ],
    [
      "rituel",
      0.03
    ],
    [
      "routine",
      0.03
    ],
    [
      "survivance",
      0.03
    ],
    [
      "memoire",
      0.03
    ],
    [
      "mythe",
      0.03
    ],
    [
      "mode",
      0.03
    ],
    [
      "legende",
      0.03
    ],
    [
      "heritage",
      0.03
    ],
    [
      "folklore",
      0.03
    ],
    [
      "croyance",
      0.03
    ],
    [
      "transmission",
      0.03
    ]
  ],
  "sauton": [
    [
      "bourdon",
      1.0
    ]
  ],
  "tristounet": [],
  "supplice": [
    [
      "torture",
      0.115
    ],
    [
      "tourment",
      0.105
    ],
    [
      "peine",
      0.0975
    ],
    [
      "douleur",
      0.08
    ],
    [
      "affliction",
      0.065
    ],
    [
      "mal",
      0.0475
    ],
    [
      "martyre",
      0.04
    ],
    [
      "inquietude",
      0.04
    ],
    [
      "croix",
      0.04
    ],
    [
      "angoisse",
      0.04
    ],
    [
      "calvaire",
      0.0325
    ],
    [
      "souffrance",
      0.0325
    ],
    [
      "gehenne",
      0.0225
    ],
    [
      "punition",
      0.015
    ],
    [
      "question",
      0.015
    ],
    [
      "souci",
      0.015
    ],
    [
      "transe",
      0.015
    ],
    [
      "gene",
      0.015
    ],
    [
      "dechirement",
      0.015
    ],
    [
      "damnation",
      0.015
    ],
    [
      "chatiment",
      0.015
    ],
    [
      "affres",
      0.015
    ],
    [
      "mort",
      0.0075
    ],
    [
      "impatience",
      0.0075
    ],
    [
      "execution",
      0.0075
    ],
    [
      "crucifiement",
      0.0075
    ],
    [
      "bourreau",
      0.0075
    ],
    [
      "billot",
      0.0075
    ],
    [
      "persecution",
      0.0075
    ]
  ],
  "domestiquer": [
    [
      "dompter",
      0.23
    ],
    [
      "apprivoiser",
      0.1525
    ],
    [
      "soumettre",
      0.1525
    ],
    [
      "asservir",
      0.075
    ],
    [
      "assujettir",
      0.075
    ],
    [
      "avilir",
      0.075
    ],
    [
      "dresser",
      0.075
    ],
    [
      "enchainer",
      0.075
    ],
    [
      "maitriser",
      0.075
    ]
  ],
  "domestique": [
    [
      "serviteur",
      0.115
    ],
    [
      "domesticite",
      0.045
    ],
    [
      "interieur",
      0.045
    ],
    [
      "maison",
      0.045
    ],
    [
      "servante",
      0.045
    ],
    [
      "valet",
      0.0325
    ],
    [
      "personnel",
      0.0325
    ],
    [
      "familier",
      0.0325
    ],
    [
      "esclave",
      0.0325
    ],
    [
      "suite",
      0.0225
    ],
    [
      "service",
      0.0225
    ],
    [
      "prive",
      0.0225
    ],
    [
      "page",
      0.0225
    ],
    [
      "intime",
      0.0225
    ],
    [
      "gouvernante",
      0.0225
    ],
    [
      "foyer",
      0.0225
    ],
    [
      "familial",
      0.0225
    ],
    [
      "chambellan",
      0.0225
    ],
    [
      "bonne",
      0.0225
    ],
    [
      "apprivoise",
      0.0225
    ],
    [
      "menager",
      0.01
    ],
    [
      "menage",
      0.01
    ],
    [
      "livree",
      0.01
    ],
    [
      "larbin",
      0.01
    ],
    [
      "laquais",
      0.01
    ],
    [
      "national",
      0.01
    ],
    [
      "officier",
      0.01
    ],
    [
      "serveur",
      0.01
    ],
    [
      "subordonne",
      0.01
    ],
    [
      "train",
      0.01
    ],
    [
      "valetaille",
      0.01
    ],
    [
      "echanson",
      0.01
    ],
    [
      "ecuyer",
      0.01
    ],
    [
      "intestin",
      0.01
    ],
    [
      "intendant",
      0.01
    ],
    [
      "bonniche",
      0.01
    ],
    [
      "bouteiller",
      0.01
    ],
    [
      "boy",
      0.01
    ],
    [
      "camerier",
      0.01
    ],
    [
      "cameriste",
      0.01
    ],
    [
      "chambrier",
      0.01
    ],
    [
      "chambriere",
      0.01
    ],
    [
      "chasseur",
      0.01
    ],
    [
      "duegne",
      0.01
    ],
    [
      "inferieur",
      0.01
    ],
    [
      "attache",
      0.01
    ]
  ],
  "labeur": [
    [
      "travail",
      0.235
    ],
    [
      "besogne",
      0.1175
    ],
    [
      "peine",
      0.1175
    ],
    [
      "tache",
      0.1175
    ],
    [
      "ouvrage",
      0.0575
    ],
    [
      "occupation",
      0.0575
    ],
    [
      "effort",
      0.0575
    ],
    [
      "difficulte",
      0.0575
    ],
    [
      "activite",
      0.0575
    ],
    [
      "corvee",
      0.0275
    ],
    [
      "fatigue",
      0.0275
    ],
    [
      "oeuvre",
      0.0275
    ],
    [
      "tirage",
      0.0275
    ]
  ],
  "archive": [
    [
      "classer",
      0.5
    ],
    [
      "enregistrer",
      0.5
    ]
  ],
  "archiver": [
    [
      "classer",
      0.5
    ],
    [
      "enregistrer",
      0.5
    ]
  ],
  "api": [],
  "boum": [
    [
      "bal",
      0.1525
    ],
    [
      "surboum",
      0.1525
    ],
    [
      "succes",
      0.075
    ],
    [
      "fete",
      0.075
    ],
    [
      "crac",
      0.075
    ],
    [
      "boom",
      0.075
    ],
    [
      "badaboum",
      0.075
    ],
    [
      "activite",
      0.075
    ],
    [
      "surpatte",
      0.075
    ]
  ],
  "empeser": [
    [
      "amidonner",
      1.0
    ]
  ],
  "empese": [
    [
      "amidonner",
      1.0
    ]
  ],
  "corbeille": [
    [
      "panier",
      0.1025
    ],
    [
      "planche",
      0.0675
    ],
    [
      "parterre",
      0.0675
    ],
    [
      "parquet",
      0.0675
    ],
    [
      "manne",
      0.0675
    ],
    [
      "galerie",
      0.0675
    ],
    [
      "bourse",
      0.0675
    ],
    [
      "vannerie",
      0.0325
    ],
    [
      "sultan",
      0.0325
    ],
    [
      "moise",
      0.0325
    ],
    [
      "mezzanine",
      0.0325
    ],
    [
      "massif",
      0.0325
    ],
    [
      "faisselle",
      0.0325
    ],
    [
      "ciste",
      0.0325
    ],
    [
      "carre",
      0.0325
    ],
    [
      "cagnotte",
      0.0325
    ],
    [
      "cadeau",
      0.0325
    ],
    [
      "bannette",
      0.0325
    ],
    [
      "balcon",
      0.0325
    ],
    [
      "eventaire",
      0.0325
    ]
  ],
  "specialite": [
    [
      "domaine",
      0.11
    ],
    [
      "partie",
      0.11
    ],
    [
      "profession",
      0.11
    ],
    [
      "departement",
      0.0825
    ],
    [
      "sphere",
      0.055
    ],
    [
      "qualite",
      0.055
    ],
    [
      "metier",
      0.055
    ],
    [
      "division",
      0.055
    ],
    [
      "champ",
      0.055
    ],
    [
      "branche",
      0.055
    ],
    [
      "remede",
      0.0275
    ],
    [
      "plat",
      0.0275
    ],
    [
      "particularite",
      0.0275
    ],
    [
      "oignons",
      0.0275
    ],
    [
      "medicament",
      0.0275
    ],
    [
      "mets",
      0.0275
    ],
    [
      "fief",
      0.0275
    ],
    [
      "discipline",
      0.0275
    ],
    [
      "travail",
      0.0275
    ]
  ],
  "torchon": [
    [
      "chiffon",
      0.11
    ],
    [
      "discorde",
      0.11
    ],
    [
      "serpilliere",
      0.11
    ],
    [
      "servante",
      0.11
    ],
    [
      "torche",
      0.11
    ],
    [
      "torchette",
      0.11
    ],
    [
      "torchis",
      0.11
    ]
  ],
  "pimpon": [],
  "sauve": [
    [
      "excepte",
      0.15
    ],
    [
      "hormis",
      0.075
    ],
    [
      "hors",
      0.075
    ],
    [
      "rescape",
      0.075
    ],
    [
      "survivant",
      0.0475
    ],
    [
      "sauve",
      0.0475
    ],
    [
      "indemne",
      0.0475
    ],
    [
      "bon",
      0.0475
    ],
    [
      "sinon",
      0.0225
    ],
    [
      "si",
      0.0225
    ],
    [
      "sain",
      0.0225
    ],
    [
      "preserve",
      0.0225
    ],
    [
      "moins",
      0.0225
    ],
    [
      "intact",
      0.0225
    ],
    [
      "fors",
      0.0225
    ],
    [
      "ote",
      0.0225
    ]
  ],
  "mignonnet": [
    [
      "gentillet",
      0.5
    ],
    [
      "mimi",
      0.5
    ]
  ],
  "mignonnette": [
    [
      "gentillet",
      0.5
    ],
    [
      "mimi",
      0.5
    ]
  ],
  "requete": [
    [
      "demande",
      0.1775
    ],
    [
      "sollicitation",
      0.1
    ],
    [
      "supplication",
      0.1
    ],
    [
      "revendication",
      0.09
    ],
    [
      "priere",
      0.065
    ],
    [
      "appel",
      0.0575
    ],
    [
      "petition",
      0.05
    ],
    [
      "recours",
      0.04
    ],
    [
      "instance",
      0.0325
    ],
    [
      "pourvoi",
      0.0325
    ],
    [
      "supplique",
      0.025
    ],
    [
      "reclamation",
      0.025
    ],
    [
      "imploration",
      0.025
    ],
    [
      "demarche",
      0.025
    ],
    [
      "action",
      0.025
    ],
    [
      "objurgation",
      0.015
    ],
    [
      "placet",
      0.015
    ],
    [
      "quete",
      0.015
    ],
    [
      "requisitoire",
      0.0075
    ],
    [
      "requisition",
      0.0075
    ],
    [
      "pretention",
      0.0075
    ],
    [
      "invocation",
      0.0075
    ],
    [
      "invitation",
      0.0075
    ],
    [
      "doleance",
      0.0075
    ],
    [
      "cassation",
      0.0075
    ],
    [
      "voeux",
      0.0075
    ]
  ],
  "egayer": [
    [
      "amuser",
      0.09
    ],
    [
      "rejouir",
      0.09
    ],
    [
      "distraire",
      0.0725
    ],
    [
      "divertir",
      0.0725
    ],
    [
      "derider",
      0.0525
    ],
    [
      "parer",
      0.035
    ],
    [
      "orner",
      0.035
    ],
    [
      "imager",
      0.035
    ],
    [
      "garnir",
      0.035
    ],
    [
      "enjoliver",
      0.035
    ],
    [
      "embellir",
      0.035
    ],
    [
      "desennuyer",
      0.035
    ],
    [
      "delasser",
      0.035
    ],
    [
      "consoler",
      0.035
    ],
    [
      "recreer",
      0.0175
    ],
    [
      "solacier",
      0.0175
    ],
    [
      "tailler",
      0.0175
    ],
    [
      "ebaudir",
      0.0175
    ],
    [
      "elaguer",
      0.0175
    ],
    [
      "emonder",
      0.0175
    ],
    [
      "ornementer",
      0.0175
    ],
    [
      "detendre",
      0.0175
    ],
    [
      "desopiler",
      0.0175
    ],
    [
      "delecter",
      0.0175
    ],
    [
      "decorer",
      0.0175
    ],
    [
      "dechagriner",
      0.0175
    ],
    [
      "animer",
      0.0175
    ],
    [
      "agrementer",
      0.0175
    ]
  ],
  "retraite": [
    [
      "contracter",
      0.3325
    ],
    [
      "retirer",
      0.3325
    ],
    [
      "oter",
      0.3325
    ]
  ],
  "demener": [],
  "tourtereau": [
    [
      "amant",
      0.25
    ],
    [
      "amoureux",
      0.25
    ],
    [
      "pigeon",
      0.25
    ],
    [
      "ramier",
      0.25
    ]
  ],
  "grimace": [
    [
      "singerie",
      0.0975
    ],
    [
      "comedie",
      0.085
    ],
    [
      "affectation",
      0.0725
    ],
    [
      "hypocrisie",
      0.0725
    ],
    [
      "feinte",
      0.0675
    ],
    [
      "simagrees",
      0.0425
    ],
    [
      "simulation",
      0.0425
    ],
    [
      "simagree",
      0.035
    ],
    [
      "tartuferie",
      0.035
    ],
    [
      "momerie",
      0.0275
    ],
    [
      "chichi",
      0.0225
    ],
    [
      "contorsion",
      0.0225
    ],
    [
      "froncement",
      0.0225
    ],
    [
      "minauderie",
      0.0225
    ],
    [
      "pantalonnade",
      0.0225
    ],
    [
      "sournoiserie",
      0.0175
    ],
    [
      "singeries",
      0.0175
    ],
    [
      "rictus",
      0.0175
    ],
    [
      "mine",
      0.0175
    ],
    [
      "jonglerie",
      0.0175
    ],
    [
      "frime",
      0.0175
    ],
    [
      "dissimulation",
      0.0175
    ],
    [
      "affeterie",
      0.0175
    ],
    [
      "manieres",
      0.01
    ],
    [
      "fard",
      0.01
    ],
    [
      "deformation",
      0.01
    ],
    [
      "caricature",
      0.01
    ],
    [
      "lippe",
      0.005
    ],
    [
      "maquillage",
      0.005
    ],
    [
      "mimique",
      0.005
    ],
    [
      "moue",
      0.005
    ],
    [
      "nique",
      0.005
    ],
    [
      "pitrerie",
      0.005
    ],
    [
      "tic",
      0.005
    ],
    [
      "grime",
      0.005
    ],
    [
      "facon",
      0.005
    ],
    [
      "ceremonie",
      0.005
    ],
    [
      "convulsion",
      0.005
    ],
    [
      "cirque",
      0.005
    ],
    [
      "cabriole",
      0.005
    ],
    [
      "baboue",
      0.005
    ],
    [
      "travers",
      0.005
    ]
  ],
  "grimacer": [
    [
      "goder",
      0.2
    ],
    [
      "grigner",
      0.2
    ],
    [
      "minauder",
      0.2
    ],
    [
      "pocher",
      0.2
    ]
  ],
  "escarpolette": [
    [
      "balancelle",
      0.5
    ],
    [
      "balancoire",
      0.5
    ]
  ],
  "pandemie": [
    [
      "endemie",
      0.5
    ],
    [
      "epidemie",
      0.5
    ]
  ],
  "mondiale": [
    [
      "planetaire",
      0.285
    ],
    [
      "universel",
      0.285
    ],
    [
      "cosmique",
      0.1425
    ],
    [
      "international",
      0.1425
    ],
    [
      "terrestre",
      0.1425
    ]
  ],
  "mondial": [
    [
      "planetaire",
      0.285
    ],
    [
      "universel",
      0.285
    ],
    [
      "cosmique",
      0.1425
    ],
    [
      "international",
      0.1425
    ],
    [
      "terrestre",
      0.1425
    ]
  ],
  "irreprochable": [
    [
      "honnete",
      0.1675
    ],
    [
      "moral",
      0.0825
    ],
    [
      "parfait",
      0.0825
    ],
    [
      "regulier",
      0.0625
    ],
    [
      "probe",
      0.0625
    ],
    [
      "juste",
      0.0625
    ],
    [
      "inattaquable",
      0.0625
    ],
    [
      "accompli",
      0.0625
    ],
    [
      "modele",
      0.04
    ],
    [
      "irreprehensible",
      0.04
    ],
    [
      "impeccable",
      0.04
    ],
    [
      "exemplaire",
      0.04
    ],
    [
      "droit",
      0.04
    ],
    [
      "correct",
      0.04
    ],
    [
      "indiscutable",
      0.02
    ],
    [
      "innocent",
      0.02
    ],
    [
      "vertueux",
      0.02
    ]
  ],
  "gel": [
    [
      "gelee",
      0.25
    ],
    [
      "givre",
      0.25
    ],
    [
      "glace",
      0.25
    ],
    [
      "immobilisation",
      0.25
    ]
  ],
  "visqueux": [
    [
      "gluant",
      0.0975
    ],
    [
      "gras",
      0.0775
    ],
    [
      "pateux",
      0.0775
    ],
    [
      "poisseux",
      0.0575
    ],
    [
      "patelin",
      0.0575
    ],
    [
      "hypocrite",
      0.0575
    ],
    [
      "collant",
      0.0575
    ],
    [
      "epais",
      0.0375
    ],
    [
      "tartufe",
      0.0375
    ],
    [
      "sirupeux",
      0.0375
    ],
    [
      "repugnant",
      0.0375
    ],
    [
      "papelard",
      0.0375
    ],
    [
      "doucereux",
      0.0375
    ],
    [
      "adherent",
      0.0375
    ],
    [
      "mucilagineux",
      0.0175
    ],
    [
      "mou",
      0.0175
    ],
    [
      "huileux",
      0.0175
    ],
    [
      "graisseux",
      0.0175
    ],
    [
      "gommeux",
      0.0175
    ],
    [
      "glutineux",
      0.0175
    ],
    [
      "glaireux",
      0.0175
    ],
    [
      "fourbe",
      0.0175
    ],
    [
      "consistant",
      0.0175
    ],
    [
      "chassieux",
      0.0175
    ],
    [
      "abject",
      0.0175
    ],
    [
      "tenace",
      0.0175
    ]
  ],
  "eternuer": [
    [
      "s'ebrouer",
      0.5
    ],
    [
      "tousser",
      0.5
    ]
  ],
  "rentre": [
    [
      "refouler",
      0.07
    ],
    [
      "dissimuler",
      0.06
    ],
    [
      "entrer",
      0.06
    ],
    [
      "penetrer",
      0.06
    ],
    [
      "regagner",
      0.04
    ],
    [
      "contenir",
      0.04
    ],
    [
      "etouffer",
      0.03
    ],
    [
      "revenir",
      0.03
    ],
    [
      "retrouver",
      0.03
    ],
    [
      "retourner",
      0.03
    ],
    [
      "retenir",
      0.03
    ],
    [
      "renfoncer",
      0.03
    ],
    [
      "rallier",
      0.03
    ],
    [
      "concentrer",
      0.03
    ],
    [
      "cacher",
      0.03
    ],
    [
      "reprimer",
      0.0175
    ],
    [
      "s'enfoncer",
      0.0175
    ],
    [
      "s'engager",
      0.0175
    ],
    [
      "s'insinuer",
      0.0175
    ],
    [
      "s'introduire",
      0.0175
    ],
    [
      "taire",
      0.0175
    ],
    [
      "reintegrer",
      0.0175
    ],
    [
      "remettre",
      0.0175
    ],
    [
      "rejoindre",
      0.0175
    ],
    [
      "avaler",
      0.0175
    ],
    [
      "devorer",
      0.0175
    ],
    [
      "escamoter",
      0.0175
    ],
    [
      "introduire",
      0.0175
    ],
    [
      "percuter",
      0.0175
    ],
    [
      "ravaler",
      0.0175
    ],
    [
      "tamponner",
      0.0075
    ],
    [
      "retracter",
      0.0075
    ],
    [
      "rengainer",
      0.0075
    ],
    [
      "refrener",
      0.0075
    ],
    [
      "reconquerir",
      0.0075
    ],
    [
      "emboutir",
      0.0075
    ],
    [
      "creuser",
      0.0075
    ],
    [
      "telescoper",
      0.0075
    ]
  ],
  "gaffe": [
    [
      "bevue",
      0.1175
    ],
    [
      "betise",
      0.1025
    ],
    [
      "impair",
      0.0875
    ],
    [
      "maladresse",
      0.0875
    ],
    [
      "faute",
      0.0725
    ],
    [
      "erreur",
      0.0575
    ],
    [
      "bourde",
      0.0425
    ],
    [
      "blague",
      0.0425
    ],
    [
      "balourdise",
      0.0425
    ],
    [
      "sottise",
      0.0275
    ],
    [
      "perche",
      0.0275
    ],
    [
      "meprise",
      0.0275
    ],
    [
      "legerete",
      0.0275
    ],
    [
      "gaucherie",
      0.0275
    ],
    [
      "distraction",
      0.0275
    ],
    [
      "boulette",
      0.0275
    ],
    [
      "quiproquo",
      0.0125
    ],
    [
      "maton",
      0.0125
    ],
    [
      "gardien",
      0.0125
    ],
    [
      "croc",
      0.0125
    ],
    [
      "crevee",
      0.0125
    ],
    [
      "baton",
      0.0125
    ],
    [
      "attention",
      0.0125
    ],
    [
      "enormite",
      0.0125
    ]
  ],
  "gaffer": [],
  "amende": [
    [
      "contravention",
      0.2
    ],
    [
      "astreinte",
      0.0975
    ],
    [
      "contrainte",
      0.0975
    ],
    [
      "contredanse",
      0.0975
    ],
    [
      "gage",
      0.0975
    ],
    [
      "racket",
      0.0975
    ],
    [
      "sanction",
      0.0975
    ]
  ],
  "amender": [
    [
      "ameliorer",
      0.1825
    ],
    [
      "corriger",
      0.165
    ],
    [
      "reformer",
      0.1325
    ],
    [
      "rectifier",
      0.05
    ],
    [
      "reviser",
      0.0325
    ],
    [
      "regenerer",
      0.0325
    ],
    [
      "redresser",
      0.0325
    ],
    [
      "preparer",
      0.0325
    ],
    [
      "perfectionner",
      0.0325
    ],
    [
      "fumer",
      0.0325
    ],
    [
      "fertiliser",
      0.0325
    ],
    [
      "engraisser",
      0.0325
    ],
    [
      "changer",
      0.0325
    ],
    [
      "bonifier",
      0.0325
    ],
    [
      "ameublir",
      0.0325
    ],
    [
      "platrer",
      0.015
    ],
    [
      "marner",
      0.015
    ],
    [
      "glaiser",
      0.015
    ],
    [
      "chauler",
      0.015
    ],
    [
      "assouplir",
      0.015
    ],
    [
      "emender",
      0.015
    ]
  ],
  "crecher": [
    [
      "habiter",
      0.3325
    ],
    [
      "demeurer",
      0.165
    ],
    [
      "loger",
      0.165
    ],
    [
      "sejourner",
      0.165
    ]
  ],
  "creche": [
    [
      "nursery",
      0.1875
    ],
    [
      "chambre",
      0.125
    ],
    [
      "mangeoire",
      0.125
    ],
    [
      "pouponniere",
      0.0625
    ],
    [
      "piece",
      0.0625
    ],
    [
      "hotel",
      0.0625
    ],
    [
      "hopital",
      0.0625
    ],
    [
      "garderie",
      0.0625
    ],
    [
      "casbah",
      0.0625
    ],
    [
      "berceau",
      0.0625
    ],
    [
      "auge",
      0.0625
    ],
    [
      "ratelier",
      0.0625
    ]
  ],
  "neveu": [],
  "vache": [
    [
      "mauvais",
      0.1325
    ],
    [
      "mechant",
      0.105
    ],
    [
      "rosse",
      0.105
    ],
    [
      "dur",
      0.08
    ],
    [
      "severe",
      0.0525
    ],
    [
      "salaud",
      0.0525
    ],
    [
      "chameau",
      0.0525
    ],
    [
      "bete",
      0.0525
    ],
    [
      "vacherie",
      0.025
    ],
    [
      "vachard",
      0.025
    ],
    [
      "taure",
      0.025
    ],
    [
      "policier",
      0.025
    ],
    [
      "moche",
      0.025
    ],
    [
      "merde",
      0.025
    ],
    [
      "hirondelle",
      0.025
    ],
    [
      "genisse",
      0.025
    ],
    [
      "difficile",
      0.025
    ],
    [
      "carne",
      0.025
    ],
    [
      "boeuf",
      0.025
    ],
    [
      "agent",
      0.025
    ],
    [
      "vachette",
      0.025
    ]
  ],
  "brebis": [
    [
      "mouton",
      0.3325
    ],
    [
      "agneau",
      0.11
    ],
    [
      "agnelle",
      0.11
    ],
    [
      "antenaise",
      0.11
    ],
    [
      "fille",
      0.11
    ],
    [
      "ouaille",
      0.11
    ],
    [
      "vacive",
      0.11
    ]
  ],
  "sensation": [
    [
      "sentiment",
      0.125
    ],
    [
      "saisissement",
      0.1075
    ],
    [
      "emotion",
      0.1075
    ],
    [
      "impression",
      0.09
    ],
    [
      "surprise",
      0.09
    ],
    [
      "etonnement",
      0.0525
    ],
    [
      "emoi",
      0.0525
    ],
    [
      "effet",
      0.0525
    ],
    [
      "commotion",
      0.0525
    ],
    [
      "sens",
      0.035
    ],
    [
      "perception",
      0.035
    ],
    [
      "choc",
      0.035
    ],
    [
      "admiration",
      0.0175
    ],
    [
      "excitation",
      0.0175
    ],
    [
      "intuition",
      0.0175
    ],
    [
      "merveille",
      0.0175
    ],
    [
      "petard",
      0.0175
    ],
    [
      "sensibilite",
      0.0175
    ]
  ],
  "potentiellement": [
    [
      "virtuellement",
      1.0
    ]
  ],
  "apero": [
    [
      "aperitif",
      1.0
    ]
  ],
  "aerer": [
    [
      "degager",
      0.1425
    ],
    [
      "faconner",
      0.095
    ],
    [
      "purifier",
      0.095
    ],
    [
      "sortir",
      0.095
    ],
    [
      "eclaircir",
      0.0475
    ],
    [
      "ventiler",
      0.0475
    ],
    [
      "promener",
      0.0475
    ],
    [
      "ouvrir",
      0.0475
    ],
    [
      "degourdir",
      0.0475
    ],
    [
      "distraire",
      0.0475
    ],
    [
      "cultiver",
      0.0475
    ],
    [
      "biner",
      0.0475
    ],
    [
      "assainir",
      0.0475
    ],
    [
      "alleger",
      0.0475
    ],
    [
      "eventer",
      0.0475
    ]
  ],
  "aere": [
    [
      "degager",
      0.1425
    ],
    [
      "faconner",
      0.095
    ],
    [
      "purifier",
      0.095
    ],
    [
      "sortir",
      0.095
    ],
    [
      "eclaircir",
      0.0475
    ],
    [
      "ventiler",
      0.0475
    ],
    [
      "promener",
      0.0475
    ],
    [
      "ouvrir",
      0.0475
    ],
    [
      "degourdir",
      0.0475
    ],
    [
      "distraire",
      0.0475
    ],
    [
      "cultiver",
      0.0475
    ],
    [
      "biner",
      0.0475
    ],
    [
      "assainir",
      0.0475
    ],
    [
      "alleger",
      0.0475
    ],
    [
      "eventer",
      0.0475
    ]
  ],
  "rassurer": [
    [
      "apaiser",
      0.2625
    ],
    [
      "calmer",
      0.21
    ],
    [
      "rasserener",
      0.1575
    ],
    [
      "tranquilliser",
      0.105
    ],
    [
      "amadouer",
      0.0525
    ],
    [
      "anesthesier",
      0.0525
    ],
    [
      "consoler",
      0.0525
    ],
    [
      "rasseoir",
      0.0525
    ],
    [
      "securiser",
      0.0525
    ]
  ],
  "dindon": [
    [
      "bete",
      0.3325
    ],
    [
      "coq",
      0.3325
    ],
    [
      "niais",
      0.3325
    ]
  ],
  "regulierement": [
    [
      "assidument",
      0.09
    ],
    [
      "habituellement",
      0.09
    ],
    [
      "legalement",
      0.09
    ],
    [
      "reglementairement",
      0.045
    ],
    [
      "reglement",
      0.045
    ],
    [
      "systematiquement",
      0.045
    ],
    [
      "uniformement",
      0.045
    ],
    [
      "uniment",
      0.045
    ],
    [
      "valablement",
      0.045
    ],
    [
      "periodiquement",
      0.045
    ],
    [
      "ponctuellement",
      0.045
    ],
    [
      "normalement",
      0.045
    ],
    [
      "methodiquement",
      0.045
    ],
    [
      "licitement",
      0.045
    ],
    [
      "immanquablement",
      0.045
    ],
    [
      "fidelement",
      0.045
    ],
    [
      "exactement",
      0.045
    ],
    [
      "constamment",
      0.045
    ],
    [
      "egalement",
      0.045
    ]
  ],
  "rassembler": [
    [
      "reunir",
      0.1675
    ],
    [
      "assembler",
      0.12
    ],
    [
      "grouper",
      0.0925
    ],
    [
      "amasser",
      0.055
    ],
    [
      "concentrer",
      0.045
    ],
    [
      "associer",
      0.04
    ],
    [
      "ramasser",
      0.035
    ],
    [
      "unir",
      0.035
    ],
    [
      "rallier",
      0.03
    ],
    [
      "ameuter",
      0.03
    ],
    [
      "accumuler",
      0.025
    ],
    [
      "joindre",
      0.025
    ],
    [
      "masser",
      0.025
    ],
    [
      "regrouper",
      0.025
    ],
    [
      "liguer",
      0.02
    ],
    [
      "coaliser",
      0.02
    ],
    [
      "attrouper",
      0.02
    ],
    [
      "agglomerer",
      0.02
    ],
    [
      "canaliser",
      0.015
    ],
    [
      "federer",
      0.015
    ],
    [
      "recueillir",
      0.015
    ],
    [
      "relier",
      0.0075
    ],
    [
      "collectionner",
      0.0075
    ],
    [
      "centraliser",
      0.0075
    ],
    [
      "capter",
      0.0075
    ],
    [
      "bloquer",
      0.0075
    ],
    [
      "accorder",
      0.0025
    ],
    [
      "collecter",
      0.0025
    ],
    [
      "fusionner",
      0.0025
    ],
    [
      "juxtaposer",
      0.0025
    ],
    [
      "remonter",
      0.0025
    ],
    [
      "totaliser",
      0.0025
    ]
  ],
  "regroupement": [
    [
      "groupement",
      0.3325
    ],
    [
      "rassemblement",
      0.22
    ],
    [
      "agrandissement",
      0.11
    ],
    [
      "concentration",
      0.11
    ],
    [
      "ralliement",
      0.11
    ],
    [
      "reunion",
      0.11
    ]
  ],
  "officiel": [
    [
      "certain",
      0.1125
    ],
    [
      "evident",
      0.105
    ],
    [
      "notoire",
      0.085
    ],
    [
      "manifeste",
      0.075
    ],
    [
      "public",
      0.065
    ],
    [
      "authentique",
      0.055
    ],
    [
      "formel",
      0.055
    ],
    [
      "solennel",
      0.0475
    ],
    [
      "avere",
      0.0375
    ],
    [
      "patent",
      0.0275
    ],
    [
      "reel",
      0.0275
    ],
    [
      "traditionnel",
      0.0175
    ],
    [
      "rituel",
      0.0175
    ],
    [
      "reconnu",
      0.0175
    ],
    [
      "protocolaire",
      0.0175
    ],
    [
      "conventionnel",
      0.0175
    ],
    [
      "consacre",
      0.0175
    ],
    [
      "connu",
      0.0175
    ],
    [
      "autorise",
      0.0175
    ],
    [
      "admis",
      0.0175
    ],
    [
      "administratif",
      0.0175
    ],
    [
      "flagrant",
      0.0075
    ],
    [
      "gouvernemental",
      0.0075
    ],
    [
      "ministeriel",
      0.0075
    ],
    [
      "presume",
      0.0075
    ],
    [
      "reglementaire",
      0.0075
    ],
    [
      "exterieur",
      0.0075
    ],
    [
      "confirme",
      0.0075
    ],
    [
      "certifie",
      0.0075
    ],
    [
      "autorite",
      0.0075
    ],
    [
      "authentifie",
      0.0075
    ],
    [
      "accredite",
      0.0075
    ],
    [
      "usuel",
      0.0075
    ]
  ],
  "barquette": [
    [
      "barque",
      0.3325
    ],
    [
      "panier",
      0.3325
    ],
    [
      "tartelette",
      0.3325
    ]
  ],
  "grec": [
    [
      "athenien",
      0.25
    ],
    [
      "baron",
      0.25
    ],
    [
      "hellene",
      0.25
    ],
    [
      "hellenique",
      0.25
    ]
  ],
  "competition": [
    [
      "combat",
      0.1175
    ],
    [
      "bataille",
      0.0925
    ],
    [
      "lutte",
      0.0925
    ],
    [
      "match",
      0.08
    ],
    [
      "rivalite",
      0.08
    ],
    [
      "rencontre",
      0.0575
    ],
    [
      "tournoi",
      0.045
    ],
    [
      "course",
      0.045
    ],
    [
      "concours",
      0.045
    ],
    [
      "affrontement",
      0.045
    ],
    [
      "epreuve",
      0.035
    ],
    [
      "emulation",
      0.035
    ],
    [
      "duel",
      0.035
    ],
    [
      "concurrence",
      0.035
    ],
    [
      "conflit",
      0.0225
    ],
    [
      "coupe",
      0.0225
    ],
    [
      "criterium",
      0.0225
    ],
    [
      "partie",
      0.01
    ],
    [
      "open",
      0.01
    ],
    [
      "omnium",
      0.01
    ],
    [
      "championnat",
      0.01
    ],
    [
      "challenge",
      0.01
    ],
    [
      "poule",
      0.01
    ]
  ],
  "poulet": [
    [
      "poule",
      0.105
    ],
    [
      "agent",
      0.08
    ],
    [
      "policier",
      0.08
    ],
    [
      "poulot",
      0.0525
    ],
    [
      "poulaille",
      0.0525
    ],
    [
      "poulaga",
      0.0525
    ],
    [
      "missive",
      0.0525
    ],
    [
      "lettre",
      0.0525
    ],
    [
      "flic",
      0.0525
    ],
    [
      "coq",
      0.0525
    ],
    [
      "bafouille",
      0.0525
    ],
    [
      "poussin",
      0.025
    ],
    [
      "poulette",
      0.025
    ],
    [
      "poularde",
      0.025
    ],
    [
      "perdreau",
      0.025
    ],
    [
      "lardu",
      0.025
    ],
    [
      "coquelet",
      0.025
    ],
    [
      "chapon",
      0.025
    ],
    [
      "cafard",
      0.025
    ],
    [
      "biquet",
      0.025
    ],
    [
      "billet",
      0.025
    ],
    [
      "babillarde",
      0.025
    ],
    [
      "quiqui",
      0.025
    ]
  ],
  "veau": [
    [
      "boeuf",
      0.18
    ],
    [
      "niais",
      0.18
    ],
    [
      "bouveau",
      0.09
    ],
    [
      "bouvillon",
      0.09
    ],
    [
      "broutart",
      0.09
    ],
    [
      "bete",
      0.09
    ],
    [
      "indolent",
      0.09
    ],
    [
      "paresseux",
      0.09
    ]
  ],
  "surprise": [
    [
      "etonner",
      0.0675
    ],
    [
      "saisir",
      0.0575
    ],
    [
      "prendre",
      0.0475
    ],
    [
      "attraper",
      0.04
    ],
    [
      "decouvrir",
      0.04
    ],
    [
      "ebahir",
      0.035
    ],
    [
      "stupefier",
      0.035
    ],
    [
      "piquer",
      0.035
    ],
    [
      "confondre",
      0.03
    ],
    [
      "tromper",
      0.025
    ],
    [
      "obtenir",
      0.025
    ],
    [
      "deconcerter",
      0.025
    ],
    [
      "apercevoir",
      0.025
    ],
    [
      "ahurir",
      0.025
    ],
    [
      "abuser",
      0.025
    ],
    [
      "trouver",
      0.02
    ],
    [
      "soutirer",
      0.02
    ],
    [
      "renverser",
      0.02
    ],
    [
      "pincer",
      0.02
    ],
    [
      "frapper",
      0.02
    ],
    [
      "capter",
      0.02
    ],
    [
      "abasourdir",
      0.02
    ],
    [
      "eblouir",
      0.015
    ],
    [
      "voir",
      0.015
    ],
    [
      "remarquer",
      0.015
    ],
    [
      "extorquer",
      0.015
    ],
    [
      "derouter",
      0.015
    ],
    [
      "depister",
      0.015
    ],
    [
      "deceler",
      0.015
    ],
    [
      "attaquer",
      0.015
    ],
    [
      "arracher",
      0.015
    ],
    [
      "epater",
      0.01
    ],
    [
      "leurrer",
      0.01
    ],
    [
      "intercepter",
      0.01
    ],
    [
      "fondre",
      0.01
    ],
    [
      "derober",
      0.01
    ],
    [
      "duper",
      0.01
    ],
    [
      "discerner",
      0.01
    ],
    [
      "consterner",
      0.01
    ],
    [
      "choper",
      0.01
    ],
    [
      "s'apercevoir",
      0.005
    ],
    [
      "estomaquer",
      0.005
    ],
    [
      "embarrasser",
      0.005
    ],
    [
      "decevoir",
      0.005
    ],
    [
      "coincer",
      0.005
    ],
    [
      "circonvenir",
      0.005
    ],
    [
      "berner",
      0.005
    ],
    [
      "arriver",
      0.005
    ],
    [
      "ebouriffer",
      0.005
    ]
  ],
  "epice": [
    [
      "assaisonnement",
      0.5
    ],
    [
      "aromate",
      0.165
    ],
    [
      "condiment",
      0.165
    ],
    [
      "ingredient",
      0.165
    ]
  ],
  "epicer": [
    [
      "assaisonner",
      0.3325
    ],
    [
      "pimenter",
      0.3325
    ],
    [
      "relever",
      0.3325
    ]
  ],
  "harissa": [],
  "essence": [
    [
      "substance",
      0.0875
    ],
    [
      "esprit",
      0.0725
    ],
    [
      "nature",
      0.0725
    ],
    [
      "etre",
      0.0575
    ],
    [
      "parfum",
      0.0575
    ],
    [
      "fond",
      0.0575
    ],
    [
      "baume",
      0.0575
    ],
    [
      "caractere",
      0.0425
    ],
    [
      "extrait",
      0.0425
    ],
    [
      "ame",
      0.0425
    ],
    [
      "quintessence",
      0.0275
    ],
    [
      "principe",
      0.0275
    ],
    [
      "huile",
      0.0275
    ],
    [
      "entite",
      0.0275
    ],
    [
      "combustible",
      0.0275
    ],
    [
      "arome",
      0.0275
    ],
    [
      "propriete",
      0.0125
    ],
    [
      "presence",
      0.0125
    ],
    [
      "qualite",
      0.0125
    ],
    [
      "quiddite",
      0.0125
    ],
    [
      "souche",
      0.0125
    ],
    [
      "substrat",
      0.0125
    ],
    [
      "propre",
      0.0125
    ],
    [
      "moelle",
      0.0125
    ],
    [
      "essentiel",
      0.0125
    ],
    [
      "carburant",
      0.0125
    ],
    [
      "bois",
      0.0125
    ],
    [
      "aromate",
      0.0125
    ],
    [
      "alcoolat",
      0.0125
    ],
    [
      "elixir",
      0.0125
    ]
  ],
  "tomate": [
    [
      "rouge",
      0.5
    ]
  ],
  "caprice": [
    [
      "toquade",
      0.125
    ],
    [
      "fantaisie",
      0.085
    ],
    [
      "humeur",
      0.045
    ],
    [
      "amour",
      0.035
    ],
    [
      "folie",
      0.0325
    ],
    [
      "bizarrerie",
      0.03
    ],
    [
      "desir",
      0.03
    ],
    [
      "manie",
      0.025
    ],
    [
      "extravagance",
      0.0225
    ],
    [
      "boutade",
      0.0225
    ],
    [
      "amourette",
      0.0225
    ],
    [
      "changement",
      0.0175
    ],
    [
      "flirt",
      0.0175
    ],
    [
      "gout",
      0.0175
    ],
    [
      "lubie",
      0.0175
    ],
    [
      "passade",
      0.0175
    ],
    [
      "volonte",
      0.015
    ],
    [
      "soif",
      0.015
    ],
    [
      "passion",
      0.015
    ],
    [
      "mouvement",
      0.015
    ],
    [
      "envie",
      0.015
    ],
    [
      "irregularite",
      0.0125
    ],
    [
      "foucade",
      0.0125
    ],
    [
      "excentricite",
      0.0125
    ],
    [
      "beguin",
      0.0125
    ],
    [
      "bagatelle",
      0.0125
    ],
    [
      "variation",
      0.01
    ],
    [
      "singularite",
      0.01
    ],
    [
      "originalite",
      0.01
    ],
    [
      "legerete",
      0.01
    ],
    [
      "instabilite",
      0.01
    ],
    [
      "frivolite",
      0.01
    ],
    [
      "travers",
      0.0075
    ],
    [
      "tic",
      0.0075
    ],
    [
      "saute",
      0.0075
    ],
    [
      "marotte",
      0.0075
    ],
    [
      "inconstance",
      0.0075
    ],
    [
      "incartade",
      0.0075
    ],
    [
      "impatience",
      0.0075
    ],
    [
      "gre",
      0.0075
    ],
    [
      "futilite",
      0.0075
    ],
    [
      "fredaine",
      0.0075
    ],
    [
      "enfantillage",
      0.0075
    ],
    [
      "dada",
      0.0075
    ],
    [
      "saillie",
      0.005
    ],
    [
      "simagree",
      0.005
    ],
    [
      "souhait",
      0.005
    ],
    [
      "versatilite",
      0.005
    ],
    [
      "vertige",
      0.005
    ],
    [
      "vertigo",
      0.005
    ],
    [
      "etrangete",
      0.005
    ],
    [
      "quinte",
      0.005
    ],
    [
      "plaisir",
      0.005
    ],
    [
      "mobilite",
      0.005
    ],
    [
      "acces",
      0.005
    ],
    [
      "babiole",
      0.005
    ],
    [
      "bluette",
      0.005
    ],
    [
      "bricole",
      0.005
    ],
    [
      "frasque",
      0.005
    ],
    [
      "inconsequence",
      0.005
    ],
    [
      "escapade",
      0.0025
    ],
    [
      "fougasse",
      0.0025
    ],
    [
      "idylle",
      0.0025
    ],
    [
      "lune",
      0.0025
    ],
    [
      "passionnette",
      0.0025
    ],
    [
      "primesaut",
      0.0025
    ],
    [
      "pepin",
      0.0025
    ],
    [
      "decision",
      0.0025
    ],
    [
      "comedie",
      0.0025
    ],
    [
      "chimere",
      0.0025
    ],
    [
      "capriccio",
      0.0025
    ],
    [
      "breloque",
      0.0025
    ],
    [
      "bibelot",
      0.0025
    ],
    [
      "batifolage",
      0.0025
    ],
    [
      "aventure",
      0.0025
    ],
    [
      "arbitraire",
      0.0025
    ]
  ],
  "glissement": [
    [
      "chute",
      0.2
    ],
    [
      "affaissement",
      0.1
    ],
    [
      "changement",
      0.1
    ],
    [
      "derapage",
      0.1
    ],
    [
      "glissade",
      0.1
    ],
    [
      "glisse",
      0.1
    ],
    [
      "modification",
      0.1
    ],
    [
      "eboulement",
      0.1
    ],
    [
      "evolution",
      0.1
    ]
  ],
  "bim": [
    [
      "bing",
      1.0
    ]
  ],
  "maillot": [
    [
      "chandail",
      0.125
    ],
    [
      "tricot",
      0.125
    ],
    [
      "slip",
      0.0625
    ],
    [
      "monokini",
      0.0625
    ],
    [
      "lange",
      0.0625
    ],
    [
      "gilet",
      0.0625
    ],
    [
      "debardeur",
      0.0625
    ],
    [
      "couche",
      0.0625
    ],
    [
      "collant",
      0.0625
    ],
    [
      "calecon",
      0.0625
    ],
    [
      "bikini",
      0.0625
    ]
  ],
  "savane": [
    [
      "herbe",
      0.5
    ],
    [
      "prairie",
      0.5
    ]
  ],
  "charbonner": [
    [
      "bruler",
      0.11
    ],
    [
      "calciner",
      0.11
    ],
    [
      "carboniser",
      0.11
    ],
    [
      "dessiner",
      0.11
    ],
    [
      "maculer",
      0.11
    ],
    [
      "noircir",
      0.11
    ],
    [
      "salir",
      0.11
    ],
    [
      "souiller",
      0.11
    ],
    [
      "tacher",
      0.11
    ]
  ],
  "inquietant": [
    [
      "sinistre",
      0.095
    ],
    [
      "alarmant",
      0.07
    ],
    [
      "effrayant",
      0.07
    ],
    [
      "grave",
      0.0625
    ],
    [
      "mauvais",
      0.055
    ],
    [
      "sombre",
      0.0475
    ],
    [
      "angoissant",
      0.0375
    ],
    [
      "menacant",
      0.0375
    ],
    [
      "troublant",
      0.03
    ],
    [
      "terrifiant",
      0.03
    ],
    [
      "redoutable",
      0.03
    ],
    [
      "louche",
      0.03
    ],
    [
      "epouvantable",
      0.0225
    ],
    [
      "tragique",
      0.0225
    ],
    [
      "serieux",
      0.0225
    ],
    [
      "preoccupant",
      0.0225
    ],
    [
      "pessimiste",
      0.0225
    ],
    [
      "facheux",
      0.0225
    ],
    [
      "embarrassant",
      0.0225
    ],
    [
      "deconcertant",
      0.0225
    ],
    [
      "difficile",
      0.0225
    ],
    [
      "etrange",
      0.015
    ],
    [
      "deroutant",
      0.015
    ],
    [
      "bizarre",
      0.015
    ],
    [
      "affolant",
      0.015
    ],
    [
      "vilain",
      0.005
    ],
    [
      "tumultueux",
      0.005
    ],
    [
      "trouble",
      0.005
    ],
    [
      "trouble",
      0.005
    ],
    [
      "patibulaire",
      0.005
    ],
    [
      "lugubre",
      0.005
    ],
    [
      "intimidant",
      0.005
    ],
    [
      "fulminant",
      0.005
    ],
    [
      "ennuyeux",
      0.005
    ],
    [
      "effarouchant",
      0.005
    ],
    [
      "effarant",
      0.005
    ],
    [
      "comminatoire",
      0.005
    ],
    [
      "atterrant",
      0.005
    ],
    [
      "alarmiste",
      0.005
    ],
    [
      "agitant",
      0.005
    ],
    [
      "equivoque",
      0.005
    ]
  ],
  "pepite": [],
  "chrome": [
    [
      "galvaniser",
      0.3325
    ],
    [
      "metalliser",
      0.3325
    ],
    [
      "tanner",
      0.3325
    ]
  ],
  "doubler": [
    [
      "augmenter",
      0.135
    ],
    [
      "multiplier",
      0.0875
    ],
    [
      "passer",
      0.0875
    ],
    [
      "fourrer",
      0.0675
    ],
    [
      "garnir",
      0.0675
    ],
    [
      "redoubler",
      0.0675
    ],
    [
      "ouater",
      0.0425
    ],
    [
      "monter",
      0.0425
    ],
    [
      "franchir",
      0.0425
    ],
    [
      "depasser",
      0.0425
    ],
    [
      "remplacer",
      0.02
    ],
    [
      "recommencer",
      0.02
    ],
    [
      "plisser",
      0.02
    ],
    [
      "plier",
      0.02
    ],
    [
      "parer",
      0.02
    ],
    [
      "ouatiner",
      0.02
    ],
    [
      "intensifier",
      0.02
    ],
    [
      "griller",
      0.02
    ],
    [
      "gratter",
      0.02
    ],
    [
      "decupler",
      0.02
    ],
    [
      "centupler",
      0.02
    ],
    [
      "capitonner",
      0.02
    ],
    [
      "accelerer",
      0.02
    ],
    [
      "tourner",
      0.02
    ]
  ],
  "double": [
    [
      "copie",
      0.0825
    ],
    [
      "reproduction",
      0.0625
    ],
    [
      "jumeau",
      0.05
    ],
    [
      "replique",
      0.05
    ],
    [
      "faux",
      0.04
    ],
    [
      "imitation",
      0.03
    ],
    [
      "gemeau",
      0.03
    ],
    [
      "ectoplasme",
      0.03
    ],
    [
      "duplicata",
      0.03
    ],
    [
      "ambigu",
      0.03
    ],
    [
      "equivoque",
      0.02
    ],
    [
      "ame",
      0.02
    ],
    [
      "spectre",
      0.02
    ],
    [
      "sournois",
      0.02
    ],
    [
      "sosie",
      0.02
    ],
    [
      "repetition",
      0.02
    ],
    [
      "revenant",
      0.02
    ],
    [
      "parfait",
      0.02
    ],
    [
      "ombre",
      0.02
    ],
    [
      "ampliation",
      0.02
    ],
    [
      "deux",
      0.02
    ],
    [
      "doublon",
      0.02
    ],
    [
      "fantome",
      0.02
    ],
    [
      "gemine",
      0.02
    ],
    [
      "hypocrite",
      0.02
    ],
    [
      "jumele",
      0.0075
    ],
    [
      "photocopie",
      0.0075
    ],
    [
      "renforce",
      0.0075
    ],
    [
      "replie",
      0.0075
    ],
    [
      "superieur",
      0.0075
    ],
    [
      "transcription",
      0.0075
    ],
    [
      "triple",
      0.0075
    ],
    [
      "trompeur",
      0.0075
    ],
    [
      "expedition",
      0.0075
    ],
    [
      "duplicite",
      0.0075
    ],
    [
      "dissimule",
      0.0075
    ],
    [
      "amphibie",
      0.0075
    ],
    [
      "amphibologique",
      0.0075
    ],
    [
      "besson",
      0.0075
    ],
    [
      "complexe",
      0.0075
    ],
    [
      "contrepartie",
      0.0075
    ],
    [
      "couple",
      0.0075
    ]
  ],
  "maire": [
    [
      "chef",
      0.285
    ],
    [
      "magistrat",
      0.285
    ],
    [
      "officier",
      0.1425
    ],
    [
      "syndic",
      0.1425
    ],
    [
      "edile",
      0.1425
    ]
  ],
  "aurore": [
    [
      "commencement",
      0.1625
    ],
    [
      "seuil",
      0.1625
    ],
    [
      "aube",
      0.1275
    ],
    [
      "debut",
      0.1275
    ],
    [
      "naissance",
      0.0525
    ],
    [
      "origine",
      0.0525
    ],
    [
      "ebauche",
      0.035
    ],
    [
      "matin",
      0.035
    ],
    [
      "enfance",
      0.035
    ],
    [
      "orient",
      0.0175
    ],
    [
      "lueur",
      0.0175
    ],
    [
      "levant",
      0.0175
    ],
    [
      "est",
      0.0175
    ],
    [
      "esquisse",
      0.0175
    ],
    [
      "balbutiement",
      0.0175
    ],
    [
      "avril",
      0.0175
    ],
    [
      "arrivee",
      0.0175
    ],
    [
      "premices",
      0.0175
    ]
  ],
  "epanoui": [
    [
      "joyeux",
      0.14
    ],
    [
      "rejoui",
      0.14
    ],
    [
      "content",
      0.1
    ],
    [
      "rieur",
      0.1
    ],
    [
      "ravi",
      0.08
    ],
    [
      "radieux",
      0.08
    ],
    [
      "gai",
      0.08
    ],
    [
      "hilare",
      0.0575
    ],
    [
      "riant",
      0.0375
    ],
    [
      "vaste",
      0.0175
    ],
    [
      "rayonnant",
      0.0175
    ],
    [
      "ouvert",
      0.0175
    ],
    [
      "jovial",
      0.0175
    ],
    [
      "gros",
      0.0175
    ],
    [
      "developpe",
      0.0175
    ],
    [
      "beat",
      0.0175
    ],
    [
      "ample",
      0.0175
    ],
    [
      "eclos",
      0.0175
    ]
  ],
  "austere": [
    [
      "severe",
      0.1375
    ],
    [
      "rude",
      0.0975
    ],
    [
      "dur",
      0.0775
    ],
    [
      "rigide",
      0.0675
    ],
    [
      "ascetique",
      0.0625
    ],
    [
      "sec",
      0.0525
    ],
    [
      "rigoureux",
      0.0425
    ],
    [
      "raide",
      0.0375
    ],
    [
      "apre",
      0.0325
    ],
    [
      "aigre",
      0.0225
    ],
    [
      "grave",
      0.0225
    ],
    [
      "simple",
      0.0225
    ],
    [
      "sobre",
      0.0225
    ],
    [
      "stoique",
      0.0175
    ],
    [
      "spartiate",
      0.0175
    ],
    [
      "rigoriste",
      0.0175
    ],
    [
      "puritain",
      0.0175
    ],
    [
      "prude",
      0.0175
    ],
    [
      "begueule",
      0.0175
    ],
    [
      "bourru",
      0.0175
    ],
    [
      "abrupt",
      0.0175
    ],
    [
      "serieux",
      0.0125
    ],
    [
      "range",
      0.0125
    ],
    [
      "monacal",
      0.0125
    ],
    [
      "froid",
      0.0125
    ],
    [
      "triste",
      0.0075
    ],
    [
      "nu",
      0.0075
    ],
    [
      "janseniste",
      0.0075
    ],
    [
      "frugal",
      0.0075
    ],
    [
      "farouche",
      0.0075
    ],
    [
      "decent",
      0.0075
    ],
    [
      "ascete",
      0.0025
    ],
    [
      "astringent",
      0.0025
    ],
    [
      "stoicien",
      0.0025
    ]
  ],
  "liberal": [
    [
      "large",
      0.225
    ],
    [
      "genereux",
      0.0825
    ],
    [
      "ouvert",
      0.0825
    ],
    [
      "tolerant",
      0.0825
    ],
    [
      "philanthrope",
      0.055
    ],
    [
      "laxiste",
      0.055
    ],
    [
      "latitudinaire",
      0.055
    ],
    [
      "coulant",
      0.055
    ],
    [
      "comprehensif",
      0.055
    ],
    [
      "whig",
      0.025
    ],
    [
      "voltairien",
      0.025
    ],
    [
      "prodigue",
      0.025
    ],
    [
      "munificent",
      0.025
    ],
    [
      "lache",
      0.025
    ],
    [
      "capitaliste",
      0.025
    ],
    [
      "aumonier",
      0.025
    ],
    [
      "antiprotectionniste",
      0.025
    ],
    [
      "elastique",
      0.025
    ]
  ],
  "centriste": [
    [
      "modere",
      1.0
    ]
  ],
  "egaler": [
    [
      "equivaloir",
      0.1475
    ],
    [
      "rivaliser",
      0.11
    ],
    [
      "egaliser",
      0.11
    ],
    [
      "equilibrer",
      0.0725
    ],
    [
      "contrebalancer",
      0.0725
    ],
    [
      "approcher",
      0.0725
    ],
    [
      "valoir",
      0.035
    ],
    [
      "parvenir",
      0.035
    ],
    [
      "niveler",
      0.035
    ],
    [
      "faire",
      0.035
    ],
    [
      "disputer",
      0.035
    ],
    [
      "correspondre",
      0.035
    ],
    [
      "compenser",
      0.035
    ],
    [
      "balancer",
      0.035
    ],
    [
      "atteindre",
      0.035
    ],
    [
      "assimiler",
      0.035
    ],
    [
      "equipoller",
      0.035
    ]
  ],
  "magot": [
    [
      "singe",
      0.1075
    ],
    [
      "epargne",
      0.1075
    ],
    [
      "economies",
      0.07
    ],
    [
      "vilain",
      0.07
    ],
    [
      "pecule",
      0.07
    ],
    [
      "macaque",
      0.07
    ],
    [
      "crapoussin",
      0.07
    ],
    [
      "tresor",
      0.035
    ],
    [
      "statuette",
      0.035
    ],
    [
      "sapajou",
      0.035
    ],
    [
      "poussah",
      0.035
    ],
    [
      "nain",
      0.035
    ],
    [
      "monstre",
      0.035
    ],
    [
      "laid",
      0.035
    ],
    [
      "crapaud",
      0.035
    ],
    [
      "boursicot",
      0.035
    ],
    [
      "avorton",
      0.035
    ],
    [
      "econocroques",
      0.035
    ]
  ],
  "surprenant": [
    [
      "extraordinaire",
      0.1275
    ],
    [
      "etonnant",
      0.1175
    ],
    [
      "sensationnel",
      0.0875
    ],
    [
      "fantastique",
      0.05
    ],
    [
      "bizarre",
      0.04
    ],
    [
      "etrange",
      0.0325
    ],
    [
      "prodigieux",
      0.0325
    ],
    [
      "incroyable",
      0.0325
    ],
    [
      "inoui",
      0.0325
    ],
    [
      "formidable",
      0.0225
    ],
    [
      "stupefiant",
      0.0225
    ],
    [
      "singulier",
      0.02
    ],
    [
      "epatant",
      0.02
    ],
    [
      "invraisemblable",
      0.02
    ],
    [
      "inattendu",
      0.02
    ],
    [
      "exceptionnel",
      0.0175
    ],
    [
      "fabuleux",
      0.0175
    ],
    [
      "merveilleux",
      0.0175
    ],
    [
      "original",
      0.0175
    ],
    [
      "impressionnant",
      0.0125
    ],
    [
      "curieux",
      0.0125
    ],
    [
      "ahurissant",
      0.0125
    ],
    [
      "renversant",
      0.01
    ],
    [
      "phenomenal",
      0.01
    ],
    [
      "paradoxal",
      0.01
    ],
    [
      "insolite",
      0.01
    ],
    [
      "imprevu",
      0.01
    ],
    [
      "deconcertant",
      0.01
    ],
    [
      "abracadabrant",
      0.01
    ],
    [
      "anormal",
      0.01
    ],
    [
      "etourdissant",
      0.0075
    ],
    [
      "epoustouflant",
      0.0075
    ],
    [
      "remarquable",
      0.0075
    ],
    [
      "inconcevable",
      0.0075
    ],
    [
      "deroutant",
      0.0075
    ],
    [
      "drole",
      0.005
    ],
    [
      "inespere",
      0.005
    ],
    [
      "inopine",
      0.005
    ],
    [
      "saisissant",
      0.0025
    ],
    [
      "nouveau",
      0.0025
    ],
    [
      "fantasque",
      0.0025
    ],
    [
      "brusque",
      0.0025
    ],
    [
      "capricieux",
      0.0025
    ],
    [
      "grand",
      0.0025
    ],
    [
      "mirifique",
      0.0025
    ],
    [
      "super",
      0.0
    ],
    [
      "rapide",
      0.0
    ],
    [
      "magique",
      0.0
    ],
    [
      "brusque",
      0.0
    ],
    [
      "boeuf",
      0.0
    ],
    [
      "epoilant",
      0.0
    ]
  ],
  "dynamique": [
    [
      "actif",
      0.2325
    ],
    [
      "entreprenant",
      0.115
    ],
    [
      "vivant",
      0.115
    ],
    [
      "ardent",
      0.075
    ],
    [
      "energique",
      0.0375
    ],
    [
      "vaillant",
      0.0375
    ],
    [
      "remuant",
      0.0375
    ],
    [
      "proactif",
      0.0375
    ],
    [
      "physique",
      0.0375
    ],
    [
      "industrieux",
      0.0375
    ],
    [
      "dynamisation",
      0.0375
    ],
    [
      "dispos",
      0.0375
    ],
    [
      "balistique",
      0.0375
    ],
    [
      "allant",
      0.0375
    ],
    [
      "acceleration",
      0.0375
    ],
    [
      "evolution",
      0.0375
    ]
  ],
  "italique": [
    [
      "italien",
      0.3325
    ],
    [
      "italiote",
      0.3325
    ],
    [
      "osque",
      0.3325
    ]
  ],
  "psychiatrique": [],
  "bouchon": [
    [
      "fermeture",
      0.1025
    ],
    [
      "cabaret",
      0.075
    ],
    [
      "cafe",
      0.075
    ],
    [
      "tapon",
      0.05
    ],
    [
      "tampon",
      0.05
    ],
    [
      "encombrement",
      0.05
    ],
    [
      "embouteillage",
      0.05
    ],
    [
      "buvette",
      0.05
    ],
    [
      "bonde",
      0.05
    ],
    [
      "estaminet",
      0.0225
    ],
    [
      "fille",
      0.0225
    ],
    [
      "flotteur",
      0.0225
    ],
    [
      "gargote",
      0.0225
    ],
    [
      "paquet",
      0.0225
    ],
    [
      "ralentissement",
      0.0225
    ],
    [
      "tape",
      0.0225
    ],
    [
      "enseigne",
      0.0225
    ],
    [
      "engorgement",
      0.0225
    ],
    [
      "capuchon",
      0.0225
    ],
    [
      "capsule",
      0.0225
    ],
    [
      "bouchage",
      0.0225
    ],
    [
      "botte",
      0.0225
    ],
    [
      "bondon",
      0.0225
    ],
    [
      "barrage",
      0.0225
    ],
    [
      "afflux",
      0.0225
    ],
    [
      "troquet",
      0.0225
    ]
  ],
  "media": [
    [
      "information",
      0.3325
    ],
    [
      "support",
      0.3325
    ]
  ],
  "chantage": [
    [
      "bluff",
      0.1
    ],
    [
      "escroquerie",
      0.1
    ],
    [
      "intimidation",
      0.1
    ],
    [
      "tromperie",
      0.1
    ],
    [
      "truanderie",
      0.05
    ],
    [
      "surenchere",
      0.05
    ],
    [
      "revelation",
      0.05
    ],
    [
      "racket",
      0.05
    ],
    [
      "prelevement",
      0.05
    ],
    [
      "pression",
      0.05
    ],
    [
      "menace",
      0.05
    ],
    [
      "friponnerie",
      0.05
    ],
    [
      "filouterie",
      0.05
    ],
    [
      "extorsion",
      0.05
    ],
    [
      "duperie",
      0.05
    ],
    [
      "vol",
      0.05
    ]
  ],
  "heureusement": [
    [
      "bien",
      0.2325
    ],
    [
      "avantageusement",
      0.1525
    ],
    [
      "favorablement",
      0.1525
    ],
    [
      "harmonieusement",
      0.075
    ],
    [
      "idealement",
      0.075
    ],
    [
      "prosperement",
      0.075
    ],
    [
      "victorieusement",
      0.075
    ],
    [
      "elegamment",
      0.075
    ]
  ],
  "balafre": [
    [
      "blesser",
      0.1625
    ],
    [
      "couper",
      0.1625
    ],
    [
      "taillader",
      0.1425
    ],
    [
      "dechirer",
      0.12
    ],
    [
      "entailler",
      0.06
    ],
    [
      "labourer",
      0.06
    ],
    [
      "erafler",
      0.04
    ],
    [
      "echarper",
      0.04
    ],
    [
      "tailler",
      0.04
    ],
    [
      "griffer",
      0.04
    ],
    [
      "entamer",
      0.04
    ],
    [
      "barrer",
      0.04
    ],
    [
      "biffer",
      0.02
    ],
    [
      "couturer",
      0.02
    ]
  ],
  "balafrer": [
    [
      "blesser",
      0.1625
    ],
    [
      "couper",
      0.1625
    ],
    [
      "taillader",
      0.1425
    ],
    [
      "dechirer",
      0.12
    ],
    [
      "entailler",
      0.06
    ],
    [
      "labourer",
      0.06
    ],
    [
      "erafler",
      0.04
    ],
    [
      "echarper",
      0.04
    ],
    [
      "tailler",
      0.04
    ],
    [
      "griffer",
      0.04
    ],
    [
      "entamer",
      0.04
    ],
    [
      "barrer",
      0.04
    ],
    [
      "biffer",
      0.02
    ],
    [
      "couturer",
      0.02
    ]
  ],
  "fromage": [
    [
      "sinecure",
      0.25
    ],
    [
      "caseine",
      0.125
    ],
    [
      "emploi",
      0.125
    ],
    [
      "filon",
      0.125
    ],
    [
      "fromegi",
      0.125
    ],
    [
      "frometon",
      0.125
    ],
    [
      "gateau",
      0.125
    ]
  ],
  "match": [
    [
      "competition",
      0.335
    ],
    [
      "rencontre",
      0.1425
    ],
    [
      "epreuve",
      0.1425
    ],
    [
      "combat",
      0.0925
    ],
    [
      "concours",
      0.0925
    ],
    [
      "tournoi",
      0.0925
    ],
    [
      "challenge",
      0.045
    ],
    [
      "criterium",
      0.045
    ]
  ],
  "tuner": [
    [
      "radio",
      1.0
    ]
  ],
  "contrat": [
    [
      "convention",
      0.1525
    ],
    [
      "traite",
      0.115
    ],
    [
      "engagement",
      0.0875
    ],
    [
      "accord",
      0.075
    ],
    [
      "transaction",
      0.0625
    ],
    [
      "marche",
      0.05
    ],
    [
      "promesse",
      0.0375
    ],
    [
      "pacte",
      0.025
    ],
    [
      "obligation",
      0.025
    ],
    [
      "depot",
      0.025
    ],
    [
      "compromis",
      0.025
    ],
    [
      "bail",
      0.025
    ],
    [
      "assurance",
      0.025
    ],
    [
      "alliance",
      0.025
    ],
    [
      "acte",
      0.025
    ],
    [
      "mandat",
      0.0125
    ],
    [
      "nantissement",
      0.0125
    ],
    [
      "police",
      0.0125
    ],
    [
      "pret",
      0.0125
    ],
    [
      "societe",
      0.0125
    ],
    [
      "vente",
      0.0125
    ],
    [
      "louage",
      0.0125
    ],
    [
      "instrument",
      0.0125
    ],
    [
      "forfait",
      0.0125
    ],
    [
      "donation",
      0.0125
    ],
    [
      "document",
      0.0125
    ],
    [
      "concordat",
      0.0125
    ],
    [
      "concession",
      0.0125
    ],
    [
      "cautionnement",
      0.0125
    ],
    [
      "affretement",
      0.0125
    ],
    [
      "echange",
      0.0125
    ]
  ],
  "deverser": [
    [
      "repandre",
      0.12
    ],
    [
      "epancher",
      0.12
    ],
    [
      "degorger",
      0.09
    ],
    [
      "epandre",
      0.09
    ],
    [
      "evacuer",
      0.06
    ],
    [
      "verser",
      0.06
    ],
    [
      "s'ecouler",
      0.06
    ],
    [
      "jeter",
      0.06
    ],
    [
      "decharger",
      0.06
    ],
    [
      "pencher",
      0.03
    ],
    [
      "lacher",
      0.03
    ],
    [
      "incliner",
      0.03
    ],
    [
      "exhaler",
      0.03
    ],
    [
      "debarquer",
      0.03
    ],
    [
      "affluer",
      0.03
    ]
  ],
  "preuve": [
    [
      "temoignage",
      0.205
    ],
    [
      "justification",
      0.0825
    ],
    [
      "marque",
      0.0675
    ],
    [
      "signe",
      0.0525
    ],
    [
      "indice",
      0.0525
    ],
    [
      "demonstration",
      0.0525
    ],
    [
      "certificat",
      0.03
    ],
    [
      "gage",
      0.03
    ],
    [
      "critere",
      0.0225
    ],
    [
      "confirmation",
      0.0225
    ],
    [
      "assurance",
      0.0225
    ],
    [
      "argument",
      0.0225
    ],
    [
      "affirmation",
      0.0225
    ],
    [
      "etablissement",
      0.015
    ],
    [
      "echantillon",
      0.015
    ],
    [
      "temoin",
      0.015
    ],
    [
      "trace",
      0.015
    ],
    [
      "piece",
      0.015
    ],
    [
      "motif",
      0.015
    ],
    [
      "indication",
      0.015
    ],
    [
      "illustration",
      0.015
    ],
    [
      "exemple",
      0.015
    ],
    [
      "caution",
      0.015
    ],
    [
      "charge",
      0.015
    ],
    [
      "constatation",
      0.015
    ],
    [
      "conviction",
      0.015
    ],
    [
      "document",
      0.015
    ],
    [
      "empreinte",
      0.015
    ],
    [
      "raisonnement",
      0.0075
    ],
    [
      "ordalie",
      0.0075
    ],
    [
      "fondement",
      0.0075
    ],
    [
      "fait",
      0.0075
    ],
    [
      "enseigne",
      0.0075
    ],
    [
      "criterium",
      0.0075
    ],
    [
      "evidence",
      0.0075
    ]
  ],
  "gentillesse": [
    [
      "amabilite",
      0.1475
    ],
    [
      "bonte",
      0.0775
    ],
    [
      "affabilite",
      0.06
    ],
    [
      "complaisance",
      0.055
    ],
    [
      "delicatesse",
      0.055
    ],
    [
      "prevenance",
      0.0475
    ],
    [
      "galanterie",
      0.0475
    ],
    [
      "douceur",
      0.0475
    ],
    [
      "obligeance",
      0.0425
    ],
    [
      "bienveillance",
      0.035
    ],
    [
      "grace",
      0.0325
    ],
    [
      "tendresse",
      0.0275
    ],
    [
      "gracieusete",
      0.0275
    ],
    [
      "attention",
      0.0275
    ],
    [
      "civilite",
      0.0175
    ],
    [
      "empressement",
      0.0175
    ],
    [
      "amenite",
      0.015
    ],
    [
      "caresse",
      0.015
    ],
    [
      "indulgence",
      0.015
    ],
    [
      "sensibilite",
      0.015
    ],
    [
      "egards",
      0.01
    ],
    [
      "plaisanterie",
      0.01
    ],
    [
      "mignardise",
      0.01
    ],
    [
      "honnetete",
      0.01
    ],
    [
      "serviabilite",
      0.0075
    ],
    [
      "mignonnerie",
      0.0075
    ],
    [
      "generosite",
      0.0075
    ],
    [
      "finesse",
      0.0075
    ],
    [
      "condescendance",
      0.0075
    ],
    [
      "bonhomie",
      0.0075
    ],
    [
      "bagatelle",
      0.0075
    ],
    [
      "accortise",
      0.0075
    ],
    [
      "noblesse",
      0.0025
    ],
    [
      "liant",
      0.0025
    ],
    [
      "joliesse",
      0.0025
    ],
    [
      "compliment",
      0.0025
    ],
    [
      "tour",
      0.0025
    ]
  ],
  "vieillesse": [
    [
      "senescence",
      0.1575
    ],
    [
      "decadence",
      0.0775
    ],
    [
      "declin",
      0.0775
    ],
    [
      "decrepitude",
      0.0775
    ],
    [
      "vieillissement",
      0.0525
    ],
    [
      "vieillerie",
      0.0525
    ],
    [
      "senilite",
      0.0525
    ],
    [
      "caducite",
      0.0525
    ],
    [
      "anciennete",
      0.0525
    ],
    [
      "vetuste",
      0.025
    ],
    [
      "longevite",
      0.025
    ],
    [
      "hiver",
      0.025
    ],
    [
      "desuetude",
      0.025
    ],
    [
      "crepuscule",
      0.025
    ],
    [
      "antiquite",
      0.025
    ],
    [
      "affaiblissement",
      0.025
    ],
    [
      "abaissement",
      0.025
    ],
    [
      "age",
      0.025
    ]
  ],
  "sensible": [
    [
      "clair",
      0.0575
    ],
    [
      "bon",
      0.045
    ],
    [
      "tendre",
      0.04
    ],
    [
      "accessible",
      0.0375
    ],
    [
      "intelligible",
      0.0375
    ],
    [
      "perceptible",
      0.0375
    ],
    [
      "visible",
      0.0375
    ],
    [
      "evident",
      0.0375
    ],
    [
      "delicat",
      0.0275
    ],
    [
      "comprehensible",
      0.0275
    ],
    [
      "humain",
      0.0225
    ],
    [
      "impressionnable",
      0.0225
    ],
    [
      "manifeste",
      0.0225
    ],
    [
      "tangible",
      0.02
    ],
    [
      "susceptible",
      0.02
    ],
    [
      "sentimental",
      0.02
    ],
    [
      "romanesque",
      0.02
    ],
    [
      "penetrable",
      0.02
    ],
    [
      "ouvert",
      0.02
    ],
    [
      "materiel",
      0.02
    ],
    [
      "emotif",
      0.015
    ],
    [
      "sensitif",
      0.015
    ],
    [
      "distinct",
      0.015
    ],
    [
      "apparent",
      0.015
    ],
    [
      "amoureux",
      0.015
    ],
    [
      "aimable",
      0.015
    ],
    [
      "affectueux",
      0.015
    ],
    [
      "vulnerable",
      0.01
    ],
    [
      "vif",
      0.01
    ],
    [
      "sourcilleux",
      0.01
    ],
    [
      "palpable",
      0.01
    ],
    [
      "important",
      0.01
    ],
    [
      "hypersensible",
      0.01
    ],
    [
      "douillet",
      0.01
    ],
    [
      "concret",
      0.01
    ],
    [
      "charitable",
      0.01
    ],
    [
      "nerveux",
      0.0075
    ],
    [
      "permeable",
      0.0075
    ],
    [
      "physique",
      0.0075
    ],
    [
      "receptif",
      0.0075
    ],
    [
      "saisissable",
      0.0075
    ],
    [
      "emotionnable",
      0.0075
    ],
    [
      "limpide",
      0.0075
    ],
    [
      "fragile",
      0.0075
    ],
    [
      "affectif",
      0.0075
    ],
    [
      "appreciable",
      0.0075
    ],
    [
      "charnel",
      0.0075
    ],
    [
      "chatouilleux",
      0.0075
    ],
    [
      "compatissant",
      0.0075
    ],
    [
      "douloureux",
      0.0075
    ],
    [
      "nevralgique",
      0.0025
    ],
    [
      "passible",
      0.0025
    ],
    [
      "phenomenal",
      0.0025
    ],
    [
      "poetique",
      0.0025
    ],
    [
      "penible",
      0.0025
    ],
    [
      "romantique",
      0.0025
    ],
    [
      "sensitive",
      0.0025
    ],
    [
      "sensoriel",
      0.0025
    ],
    [
      "notable",
      0.0025
    ],
    [
      "lumineux",
      0.0025
    ],
    [
      "genereux",
      0.0025
    ],
    [
      "affecte",
      0.0025
    ],
    [
      "aimant",
      0.0025
    ],
    [
      "allergique",
      0.0025
    ],
    [
      "altruiste",
      0.0025
    ],
    [
      "attache",
      0.0025
    ],
    [
      "braque",
      0.0025
    ],
    [
      "contingent",
      0.0025
    ],
    [
      "fin",
      0.0025
    ],
    [
      "touche",
      0.0025
    ]
  ],
  "ordure": [
    [
      "salete",
      0.1075
    ],
    [
      "boue",
      0.08
    ],
    [
      "gadoue",
      0.055
    ],
    [
      "excrement",
      0.045
    ],
    [
      "obscenite",
      0.04
    ],
    [
      "impurete",
      0.04
    ],
    [
      "immondice",
      0.04
    ],
    [
      "grossierete",
      0.04
    ],
    [
      "abjection",
      0.0325
    ],
    [
      "malproprete",
      0.0325
    ],
    [
      "residu",
      0.0225
    ],
    [
      "rebut",
      0.0225
    ],
    [
      "fange",
      0.0225
    ],
    [
      "detritus",
      0.0225
    ],
    [
      "dechet",
      0.0225
    ],
    [
      "debris",
      0.0225
    ],
    [
      "cochonnerie",
      0.0225
    ],
    [
      "voirie",
      0.015
    ],
    [
      "turpitude",
      0.015
    ],
    [
      "tache",
      0.015
    ],
    [
      "souillure",
      0.015
    ],
    [
      "merde",
      0.015
    ],
    [
      "gachis",
      0.015
    ],
    [
      "crasse",
      0.015
    ],
    [
      "balayure",
      0.015
    ],
    [
      "saloperie",
      0.01
    ],
    [
      "salaud",
      0.01
    ],
    [
      "poussiere",
      0.01
    ],
    [
      "grivoiserie",
      0.01
    ],
    [
      "fumier",
      0.01
    ],
    [
      "margouillis",
      0.005
    ],
    [
      "nettoyure",
      0.005
    ],
    [
      "pourriture",
      0.005
    ],
    [
      "salissure",
      0.005
    ],
    [
      "salope",
      0.005
    ],
    [
      "sanie",
      0.005
    ],
    [
      "scorie",
      0.005
    ],
    [
      "trivialite",
      0.005
    ],
    [
      "vidange",
      0.005
    ],
    [
      "vidure",
      0.005
    ],
    [
      "injure",
      0.005
    ],
    [
      "incongruite",
      0.005
    ],
    [
      "bourre",
      0.005
    ],
    [
      "bourrier",
      0.005
    ],
    [
      "caca",
      0.005
    ],
    [
      "chiure",
      0.005
    ],
    [
      "cochon",
      0.005
    ],
    [
      "crevure",
      0.005
    ],
    [
      "debauche",
      0.005
    ],
    [
      "fiente",
      0.005
    ],
    [
      "gravelure",
      0.005
    ],
    [
      "gringuenaude",
      0.005
    ],
    [
      "vouerie",
      0.005
    ]
  ],
  "desuni": [
    [
      "brouille",
      0.3325
    ],
    [
      "disjoint",
      0.3325
    ],
    [
      "desaccorde",
      0.3325
    ]
  ],
  "desunir": [
    [
      "diviser",
      0.215
    ],
    [
      "separer",
      0.1375
    ],
    [
      "disjoindre",
      0.125
    ],
    [
      "disloquer",
      0.0625
    ],
    [
      "desassembler",
      0.05
    ],
    [
      "ecarter",
      0.05
    ],
    [
      "sectionner",
      0.0375
    ],
    [
      "rompre",
      0.0375
    ],
    [
      "dissocier",
      0.0375
    ],
    [
      "scinder",
      0.025
    ],
    [
      "desagreger",
      0.025
    ],
    [
      "desaccorder",
      0.025
    ],
    [
      "dechirer",
      0.025
    ],
    [
      "disperser",
      0.025
    ],
    [
      "brouiller",
      0.025
    ],
    [
      "saillir",
      0.0125
    ],
    [
      "detacher",
      0.0125
    ],
    [
      "desolidariser",
      0.0125
    ],
    [
      "demonter",
      0.0125
    ],
    [
      "demancher",
      0.0125
    ],
    [
      "subdiviser",
      0.0125
    ]
  ],
  "malentendu": [
    [
      "desaccord",
      0.1375
    ],
    [
      "mesentente",
      0.1175
    ],
    [
      "dispute",
      0.0975
    ],
    [
      "dissension",
      0.0775
    ],
    [
      "quiproquo",
      0.0575
    ],
    [
      "heurt",
      0.0575
    ],
    [
      "confusion",
      0.0575
    ],
    [
      "meprise",
      0.0375
    ],
    [
      "erreur",
      0.0375
    ],
    [
      "divergence",
      0.0375
    ],
    [
      "differend",
      0.0375
    ],
    [
      "brouille",
      0.0375
    ],
    [
      "bouderie",
      0.0375
    ],
    [
      "bisbille",
      0.0375
    ],
    [
      "dissentiment",
      0.0175
    ],
    [
      "friction",
      0.0175
    ],
    [
      "imbroglio",
      0.0175
    ],
    [
      "mecompte",
      0.0175
    ],
    [
      "equivoque",
      0.0175
    ]
  ],
  "embraser": [
    [
      "enflammer",
      0.17
    ],
    [
      "bruler",
      0.13
    ],
    [
      "exciter",
      0.09
    ],
    [
      "consumer",
      0.07
    ],
    [
      "exalter",
      0.06
    ],
    [
      "enfievrer",
      0.05
    ],
    [
      "chauffer",
      0.05
    ],
    [
      "allumer",
      0.05
    ],
    [
      "echauffer",
      0.04
    ],
    [
      "incendier",
      0.04
    ],
    [
      "enthousiasmer",
      0.04
    ],
    [
      "attiser",
      0.04
    ],
    [
      "passionner",
      0.02
    ],
    [
      "devorer",
      0.02
    ],
    [
      "detruire",
      0.02
    ],
    [
      "calciner",
      0.02
    ],
    [
      "agiter",
      0.01
    ],
    [
      "illuminer",
      0.01
    ],
    [
      "ravager",
      0.01
    ],
    [
      "surchauffer",
      0.01
    ],
    [
      "eclairer",
      0.01
    ],
    [
      "eprendre",
      0.01
    ]
  ],
  "flamboyer": [
    [
      "briller",
      0.135
    ],
    [
      "luire",
      0.125
    ],
    [
      "resplendir",
      0.125
    ],
    [
      "etinceler",
      0.115
    ],
    [
      "reluire",
      0.095
    ],
    [
      "rayonner",
      0.0875
    ],
    [
      "fulgurer",
      0.0575
    ],
    [
      "scintiller",
      0.0475
    ],
    [
      "rutiler",
      0.0375
    ],
    [
      "eclater",
      0.0275
    ],
    [
      "petiller",
      0.0275
    ],
    [
      "flamber",
      0.0275
    ],
    [
      "bruler",
      0.0175
    ],
    [
      "miroiter",
      0.0175
    ],
    [
      "brasiller",
      0.0075
    ],
    [
      "s'etoiler",
      0.0075
    ],
    [
      "eclairer",
      0.0075
    ]
  ],
  "aine": [
    [
      "ancien",
      0.2
    ],
    [
      "ancetre",
      0.12
    ],
    [
      "vieux",
      0.12
    ],
    [
      "age",
      0.0775
    ],
    [
      "premier",
      0.0775
    ],
    [
      "grand",
      0.0775
    ],
    [
      "fils",
      0.0775
    ],
    [
      "aieul",
      0.0375
    ],
    [
      "devancier",
      0.0375
    ],
    [
      "doyen",
      0.0375
    ],
    [
      "heritier",
      0.0375
    ],
    [
      "predecesseur",
      0.0375
    ]
  ],
  "soule": [
    [
      "ivre",
      0.1975
    ],
    [
      "rassasie",
      0.115
    ],
    [
      "repu",
      0.0975
    ],
    [
      "plein",
      0.08
    ],
    [
      "bourre",
      0.0475
    ],
    [
      "gave",
      0.0475
    ],
    [
      "sature",
      0.0475
    ],
    [
      "grise",
      0.0325
    ],
    [
      "gris",
      0.0325
    ],
    [
      "enivre",
      0.0325
    ],
    [
      "sursature",
      0.015
    ],
    [
      "schlass",
      0.015
    ],
    [
      "rond",
      0.015
    ],
    [
      "pompette",
      0.015
    ],
    [
      "pinte",
      0.015
    ],
    [
      "paf",
      0.015
    ],
    [
      "mur",
      0.015
    ],
    [
      "gorge",
      0.015
    ],
    [
      "degoute",
      0.015
    ],
    [
      "cuit",
      0.015
    ],
    [
      "content",
      0.015
    ],
    [
      "blinde",
      0.015
    ],
    [
      "assouvi",
      0.015
    ],
    [
      "etourdi",
      0.015
    ]
  ],
  "saillie": [
    [
      "trait",
      0.075
    ],
    [
      "pointe",
      0.0675
    ],
    [
      "boutade",
      0.06
    ],
    [
      "bosse",
      0.045
    ],
    [
      "eminence",
      0.03
    ],
    [
      "proeminence",
      0.03
    ],
    [
      "protuberance",
      0.03
    ],
    [
      "angle",
      0.03
    ],
    [
      "eperon",
      0.0225
    ],
    [
      "rosserie",
      0.0225
    ],
    [
      "promontoire",
      0.0225
    ],
    [
      "plaisanterie",
      0.0225
    ],
    [
      "mot",
      0.0225
    ],
    [
      "irregularite",
      0.0225
    ],
    [
      "avancee",
      0.0225
    ],
    [
      "avance",
      0.0225
    ],
    [
      "asperite",
      0.0225
    ],
    [
      "arete",
      0.0225
    ],
    [
      "encorbellement",
      0.0125
    ],
    [
      "monte",
      0.0125
    ],
    [
      "relief",
      0.0125
    ],
    [
      "repartie",
      0.0125
    ],
    [
      "ressaut",
      0.0125
    ],
    [
      "saut",
      0.0125
    ],
    [
      "elan",
      0.0125
    ],
    [
      "dent",
      0.0125
    ],
    [
      "crete",
      0.0125
    ],
    [
      "console",
      0.0125
    ],
    [
      "apophyse",
      0.0125
    ],
    [
      "avancement",
      0.0125
    ],
    [
      "balcon",
      0.0125
    ],
    [
      "bec",
      0.0125
    ],
    [
      "brocard",
      0.0125
    ],
    [
      "caprice",
      0.0125
    ],
    [
      "nervure",
      0.005
    ],
    [
      "poche",
      0.005
    ],
    [
      "processus",
      0.005
    ],
    [
      "redan",
      0.005
    ],
    [
      "reproduction",
      0.005
    ],
    [
      "saccade",
      0.005
    ],
    [
      "toquade",
      0.005
    ],
    [
      "tournant",
      0.005
    ],
    [
      "moulure",
      0.005
    ],
    [
      "gibbosite",
      0.005
    ],
    [
      "ergot",
      0.005
    ],
    [
      "accouplement",
      0.005
    ],
    [
      "affleurement",
      0.005
    ],
    [
      "bossage",
      0.005
    ],
    [
      "bourrelet",
      0.005
    ],
    [
      "corne",
      0.005
    ],
    [
      "corniche",
      0.005
    ],
    [
      "coude",
      0.005
    ],
    [
      "cote",
      0.005
    ],
    [
      "tubercule",
      0.005
    ]
  ],
  "saillir": [
    [
      "depasser",
      0.11
    ],
    [
      "avancer",
      0.0825
    ],
    [
      "deborder",
      0.0825
    ],
    [
      "partir",
      0.0825
    ],
    [
      "ressortir",
      0.0825
    ],
    [
      "sortir",
      0.0825
    ],
    [
      "s'elancer",
      0.055
    ],
    [
      "s'accoupler",
      0.055
    ],
    [
      "jaillir",
      0.055
    ],
    [
      "couvrir",
      0.055
    ],
    [
      "servir",
      0.0275
    ],
    [
      "sauter",
      0.0275
    ],
    [
      "s'avancer",
      0.0275
    ],
    [
      "monter",
      0.0275
    ],
    [
      "desunir",
      0.0275
    ],
    [
      "coupler",
      0.0275
    ],
    [
      "bomber",
      0.0275
    ],
    [
      "surplomber",
      0.0275
    ]
  ],
  "cierge": [
    [
      "bougie",
      0.25
    ],
    [
      "chandelle",
      0.25
    ],
    [
      "flambeau",
      0.25
    ],
    [
      "luminaire",
      0.25
    ]
  ],
  "divaguer": [
    [
      "deraisonner",
      0.1275
    ],
    [
      "derailler",
      0.085
    ],
    [
      "extravaguer",
      0.085
    ],
    [
      "s'egarer",
      0.0625
    ],
    [
      "radoter",
      0.0625
    ],
    [
      "errer",
      0.0625
    ],
    [
      "delirer",
      0.0625
    ],
    [
      "vaguer",
      0.04
    ],
    [
      "vagabonder",
      0.04
    ],
    [
      "s'ebattre",
      0.04
    ],
    [
      "roder",
      0.04
    ],
    [
      "rever",
      0.04
    ],
    [
      "demenager",
      0.04
    ],
    [
      "debloquer",
      0.02
    ],
    [
      "folatrer",
      0.02
    ]
  ],
  "carotte": [
    [
      "tromperie",
      0.18
    ],
    [
      "artifice",
      0.08
    ],
    [
      "duperie",
      0.08
    ],
    [
      "escroquerie",
      0.06
    ],
    [
      "leurre",
      0.06
    ],
    [
      "ruse",
      0.06
    ],
    [
      "truc",
      0.06
    ],
    [
      "vol",
      0.06
    ],
    [
      "mensonge",
      0.04
    ],
    [
      "illusion",
      0.04
    ],
    [
      "astuce",
      0.04
    ],
    [
      "roux",
      0.0175
    ],
    [
      "rouge",
      0.0175
    ],
    [
      "resquille",
      0.0175
    ],
    [
      "prelevement",
      0.0175
    ],
    [
      "piperie",
      0.0175
    ],
    [
      "filouterie",
      0.0175
    ],
    [
      "ficelle",
      0.0175
    ],
    [
      "exploitation",
      0.0175
    ],
    [
      "enseigne",
      0.0175
    ],
    [
      "chique",
      0.0175
    ],
    [
      "carottage",
      0.0175
    ],
    [
      "echantillon",
      0.0175
    ]
  ],
  "teigne": [
    [
      "gale",
      0.1325
    ],
    [
      "mechant",
      0.1325
    ],
    [
      "teigneux",
      0.065
    ],
    [
      "rosse",
      0.065
    ],
    [
      "pelade",
      0.065
    ],
    [
      "mite",
      0.065
    ],
    [
      "microsporie",
      0.065
    ],
    [
      "masque",
      0.065
    ],
    [
      "hargneuse",
      0.065
    ],
    [
      "gerce",
      0.065
    ],
    [
      "gallerie",
      0.065
    ],
    [
      "dermatomycose",
      0.065
    ],
    [
      "verole",
      0.065
    ]
  ],
  "manteau": [
    [
      "masque",
      0.055
    ],
    [
      "couverture",
      0.0425
    ],
    [
      "impermeable",
      0.0425
    ],
    [
      "voile",
      0.0425
    ],
    [
      "vetement",
      0.0425
    ],
    [
      "pelerine",
      0.0325
    ],
    [
      "pretexte",
      0.0325
    ],
    [
      "houppelande",
      0.0325
    ],
    [
      "habit",
      0.0325
    ],
    [
      "enveloppe",
      0.0325
    ],
    [
      "couvert",
      0.0325
    ],
    [
      "cape",
      0.0325
    ],
    [
      "abri",
      0.0325
    ],
    [
      "semblant",
      0.02
    ],
    [
      "pelisse",
      0.02
    ],
    [
      "pardessus",
      0.02
    ],
    [
      "mante",
      0.02
    ],
    [
      "capote",
      0.02
    ],
    [
      "plaid",
      0.01
    ],
    [
      "pelage",
      0.01
    ],
    [
      "pardosse",
      0.01
    ],
    [
      "pallium",
      0.01
    ],
    [
      "paletot",
      0.01
    ],
    [
      "mantelure",
      0.01
    ],
    [
      "manteline",
      0.01
    ],
    [
      "mantelet",
      0.01
    ],
    [
      "plumage",
      0.01
    ],
    [
      "poncho",
      0.01
    ],
    [
      "raglan",
      0.01
    ],
    [
      "waterproof",
      0.01
    ],
    [
      "ulster",
      0.01
    ],
    [
      "toge",
      0.01
    ],
    [
      "tabard",
      0.01
    ],
    [
      "saie",
      0.01
    ],
    [
      "rotonde",
      0.01
    ],
    [
      "redingote",
      0.01
    ],
    [
      "mandille",
      0.01
    ],
    [
      "mackintosh",
      0.01
    ],
    [
      "casaque",
      0.01
    ],
    [
      "cagoule",
      0.01
    ],
    [
      "caban",
      0.01
    ],
    [
      "burnous",
      0.01
    ],
    [
      "balandran",
      0.01
    ],
    [
      "chape",
      0.01
    ],
    [
      "chasuble",
      0.01
    ],
    [
      "macfarlane",
      0.01
    ],
    [
      "limousine",
      0.01
    ],
    [
      "himation",
      0.01
    ],
    [
      "gaze",
      0.01
    ],
    [
      "gabardine",
      0.01
    ],
    [
      "douillette",
      0.01
    ],
    [
      "cuir",
      0.01
    ],
    [
      "chlamyde",
      0.01
    ],
    [
      "asthenosphere",
      0.01
    ]
  ],
  "glissade": [
    [
      "chute",
      0.18
    ],
    [
      "faute",
      0.18
    ],
    [
      "faiblesse",
      0.09
    ],
    [
      "glissement",
      0.09
    ],
    [
      "glissoire",
      0.09
    ],
    [
      "glisse",
      0.09
    ],
    [
      "ramasse",
      0.09
    ]
  ],
  "egorger": [
    [
      "tuer",
      0.1825
    ],
    [
      "depouiller",
      0.0825
    ],
    [
      "etrangler",
      0.0825
    ],
    [
      "ecorcher",
      0.0675
    ],
    [
      "ruiner",
      0.055
    ],
    [
      "estamper",
      0.055
    ],
    [
      "abattre",
      0.055
    ],
    [
      "assassiner",
      0.04
    ],
    [
      "couper",
      0.04
    ],
    [
      "poignarder",
      0.04
    ],
    [
      "ranconner",
      0.04
    ],
    [
      "saigner",
      0.04
    ],
    [
      "ereinter",
      0.0275
    ],
    [
      "tondre",
      0.0275
    ],
    [
      "exploiter",
      0.0275
    ],
    [
      "zigouiller",
      0.0125
    ],
    [
      "suriner",
      0.0125
    ],
    [
      "sacrifier",
      0.0125
    ],
    [
      "plumer",
      0.0125
    ],
    [
      "occire",
      0.0125
    ],
    [
      "massacrer",
      0.0125
    ],
    [
      "juguler",
      0.0125
    ],
    [
      "denigrer",
      0.0125
    ],
    [
      "egorgiller",
      0.0125
    ]
  ],
  "consomme": [
    [
      "user",
      0.0925
    ],
    [
      "consumer",
      0.0725
    ],
    [
      "manger",
      0.0725
    ],
    [
      "accomplir",
      0.06
    ],
    [
      "achever",
      0.05
    ],
    [
      "prendre",
      0.04
    ],
    [
      "finir",
      0.04
    ],
    [
      "employer",
      0.04
    ],
    [
      "depenser",
      0.04
    ],
    [
      "couronner",
      0.04
    ],
    [
      "absorber",
      0.04
    ],
    [
      "epuiser",
      0.03
    ],
    [
      "terminer",
      0.03
    ],
    [
      "realiser",
      0.03
    ],
    [
      "pratiquer",
      0.03
    ],
    [
      "parachever",
      0.03
    ],
    [
      "commettre",
      0.03
    ],
    [
      "bruler",
      0.03
    ],
    [
      "vivre",
      0.02
    ],
    [
      "utiliser",
      0.02
    ],
    [
      "parfaire",
      0.02
    ],
    [
      "detruire",
      0.02
    ],
    [
      "boire",
      0.02
    ],
    [
      "boucler",
      0.01
    ],
    [
      "bouffer",
      0.01
    ],
    [
      "completer",
      0.01
    ],
    [
      "perpetrer",
      0.01
    ],
    [
      "taper",
      0.01
    ]
  ],
  "habitue": [
    [
      "styler",
      0.1675
    ],
    [
      "dresser",
      0.08
    ],
    [
      "faconner",
      0.07
    ],
    [
      "familiariser",
      0.07
    ],
    [
      "exercer",
      0.07
    ],
    [
      "accoutumer",
      0.07
    ],
    [
      "instruire",
      0.0625
    ],
    [
      "former",
      0.055
    ],
    [
      "faire",
      0.0475
    ],
    [
      "plier",
      0.0475
    ],
    [
      "rompre",
      0.0375
    ],
    [
      "entrainer",
      0.0375
    ],
    [
      "acclimater",
      0.03
    ],
    [
      "eduquer",
      0.03
    ],
    [
      "apprivoiser",
      0.0225
    ],
    [
      "imiter",
      0.015
    ],
    [
      "endurcir",
      0.015
    ],
    [
      "apprendre",
      0.015
    ],
    [
      "adapter",
      0.015
    ]
  ],
  "habituer": [
    [
      "styler",
      0.1675
    ],
    [
      "dresser",
      0.08
    ],
    [
      "faconner",
      0.07
    ],
    [
      "familiariser",
      0.07
    ],
    [
      "exercer",
      0.07
    ],
    [
      "accoutumer",
      0.07
    ],
    [
      "instruire",
      0.0625
    ],
    [
      "former",
      0.055
    ],
    [
      "faire",
      0.0475
    ],
    [
      "plier",
      0.0475
    ],
    [
      "rompre",
      0.0375
    ],
    [
      "entrainer",
      0.0375
    ],
    [
      "acclimater",
      0.03
    ],
    [
      "eduquer",
      0.03
    ],
    [
      "apprivoiser",
      0.0225
    ],
    [
      "imiter",
      0.015
    ],
    [
      "endurcir",
      0.015
    ],
    [
      "apprendre",
      0.015
    ],
    [
      "adapter",
      0.015
    ]
  ],
  "emerveiller": [
    [
      "charmer",
      0.2125
    ],
    [
      "enchanter",
      0.1425
    ],
    [
      "fasciner",
      0.1425
    ],
    [
      "ravir",
      0.1425
    ],
    [
      "eblouir",
      0.1425
    ],
    [
      "subjuguer",
      0.07
    ],
    [
      "transporter",
      0.07
    ],
    [
      "etonner",
      0.07
    ]
  ],
  "gelee": [
    [
      "figer",
      0.1175
    ],
    [
      "prendre",
      0.0975
    ],
    [
      "coaguler",
      0.0675
    ],
    [
      "caillebotter",
      0.0575
    ],
    [
      "glacer",
      0.0575
    ],
    [
      "paralyser",
      0.0475
    ],
    [
      "immobiliser",
      0.0475
    ],
    [
      "congeler",
      0.0375
    ],
    [
      "solidifier",
      0.0275
    ],
    [
      "petrifier",
      0.0275
    ],
    [
      "cailler",
      0.0275
    ],
    [
      "arreter",
      0.0275
    ],
    [
      "suspendre",
      0.0175
    ],
    [
      "refroidir",
      0.0175
    ],
    [
      "intimider",
      0.0175
    ],
    [
      "grelotter",
      0.0175
    ],
    [
      "frigorifier",
      0.0175
    ],
    [
      "bloquer",
      0.0175
    ],
    [
      "transir",
      0.0075
    ],
    [
      "refrigerer",
      0.0075
    ],
    [
      "gener",
      0.0075
    ],
    [
      "griller",
      0.0075
    ],
    [
      "givrer",
      0.0075
    ],
    [
      "frapper",
      0.0075
    ],
    [
      "endurcir",
      0.0075
    ]
  ],
  "geler": [
    [
      "figer",
      0.1175
    ],
    [
      "prendre",
      0.0975
    ],
    [
      "coaguler",
      0.0675
    ],
    [
      "caillebotter",
      0.0575
    ],
    [
      "glacer",
      0.0575
    ],
    [
      "paralyser",
      0.0475
    ],
    [
      "immobiliser",
      0.0475
    ],
    [
      "congeler",
      0.0375
    ],
    [
      "solidifier",
      0.0275
    ],
    [
      "petrifier",
      0.0275
    ],
    [
      "cailler",
      0.0275
    ],
    [
      "arreter",
      0.0275
    ],
    [
      "suspendre",
      0.0175
    ],
    [
      "refroidir",
      0.0175
    ],
    [
      "intimider",
      0.0175
    ],
    [
      "grelotter",
      0.0175
    ],
    [
      "frigorifier",
      0.0175
    ],
    [
      "bloquer",
      0.0175
    ],
    [
      "transir",
      0.0075
    ],
    [
      "refrigerer",
      0.0075
    ],
    [
      "gener",
      0.0075
    ],
    [
      "griller",
      0.0075
    ],
    [
      "givrer",
      0.0075
    ],
    [
      "frapper",
      0.0075
    ],
    [
      "endurcir",
      0.0075
    ]
  ],
  "insolent": [
    [
      "impertinent",
      0.0925
    ],
    [
      "impoli",
      0.075
    ],
    [
      "inconvenant",
      0.07
    ],
    [
      "arrogant",
      0.0625
    ],
    [
      "audacieux",
      0.0575
    ],
    [
      "impudent",
      0.0525
    ],
    [
      "blessant",
      0.0425
    ],
    [
      "deplace",
      0.0425
    ],
    [
      "irreverencieux",
      0.0425
    ],
    [
      "hardi",
      0.035
    ],
    [
      "grossier",
      0.035
    ],
    [
      "effronte",
      0.035
    ],
    [
      "incorrect",
      0.03
    ],
    [
      "cavalier",
      0.025
    ],
    [
      "outrecuidant",
      0.02
    ],
    [
      "insultant",
      0.02
    ],
    [
      "fier",
      0.02
    ],
    [
      "injurieux",
      0.015
    ],
    [
      "orgueilleux",
      0.015
    ],
    [
      "rogue",
      0.0125
    ],
    [
      "irrespectueux",
      0.0125
    ],
    [
      "indecent",
      0.0125
    ],
    [
      "incongru",
      0.0125
    ],
    [
      "hautain",
      0.0125
    ],
    [
      "fat",
      0.0125
    ],
    [
      "tranchant",
      0.0075
    ],
    [
      "suffisant",
      0.0075
    ],
    [
      "pretentieux",
      0.0075
    ],
    [
      "provocant",
      0.0075
    ],
    [
      "inoui",
      0.0075
    ],
    [
      "extraordinaire",
      0.0075
    ],
    [
      "dedaigneux",
      0.0075
    ],
    [
      "cynique",
      0.0075
    ],
    [
      "cassant",
      0.0075
    ],
    [
      "vaniteux",
      0.0025
    ],
    [
      "rencheri",
      0.0025
    ],
    [
      "inimaginable",
      0.0025
    ],
    [
      "incroyable",
      0.0025
    ],
    [
      "desagreable",
      0.0025
    ],
    [
      "culotte",
      0.0025
    ],
    [
      "epoustouflant",
      0.0025
    ]
  ],
  "agrandir": [
    [
      "augmenter",
      0.17
    ],
    [
      "grossir",
      0.105
    ],
    [
      "accroitre",
      0.085
    ],
    [
      "amplifier",
      0.07
    ],
    [
      "etendre",
      0.05
    ],
    [
      "developper",
      0.045
    ],
    [
      "hausser",
      0.045
    ],
    [
      "elever",
      0.045
    ],
    [
      "grandir",
      0.04
    ],
    [
      "ajouter",
      0.03
    ],
    [
      "enfler",
      0.03
    ],
    [
      "exagerer",
      0.025
    ],
    [
      "fortifier",
      0.025
    ],
    [
      "gonfler",
      0.025
    ],
    [
      "elargir",
      0.025
    ],
    [
      "renforcer",
      0.0175
    ],
    [
      "multiplier",
      0.0175
    ],
    [
      "allonger",
      0.0175
    ],
    [
      "dilater",
      0.015
    ],
    [
      "exhausser",
      0.015
    ],
    [
      "surelever",
      0.0075
    ],
    [
      "porter",
      0.0075
    ],
    [
      "enrichir",
      0.0075
    ],
    [
      "ennoblir",
      0.0075
    ],
    [
      "arrondir",
      0.0075
    ],
    [
      "transformer",
      0.0025
    ],
    [
      "regrouper",
      0.0025
    ],
    [
      "paraphraser",
      0.0025
    ],
    [
      "honorer",
      0.0025
    ],
    [
      "grouper",
      0.0025
    ],
    [
      "detailler",
      0.0025
    ],
    [
      "centupler",
      0.0025
    ],
    [
      "annexer",
      0.0025
    ],
    [
      "evaser",
      0.0025
    ]
  ],
  "ecolier": [
    [
      "eleve",
      0.2
    ],
    [
      "apprenti",
      0.1325
    ],
    [
      "debutant",
      0.1325
    ],
    [
      "novice",
      0.1325
    ],
    [
      "scolaire",
      0.065
    ],
    [
      "neophyte",
      0.065
    ],
    [
      "disciple",
      0.065
    ],
    [
      "collegien",
      0.065
    ],
    [
      "bleu",
      0.065
    ],
    [
      "etudiant",
      0.065
    ]
  ],
  "anglais": [
    [
      "angliche",
      0.2
    ],
    [
      "britannique",
      0.2
    ],
    [
      "british",
      0.2
    ],
    [
      "menstruation",
      0.2
    ],
    [
      "menstrues",
      0.2
    ]
  ],
  "angler": [],
  "foudroyer": [
    [
      "aneantir",
      0.1225
    ],
    [
      "abattre",
      0.1125
    ],
    [
      "detruire",
      0.0775
    ],
    [
      "ecraser",
      0.0775
    ],
    [
      "renverser",
      0.06
    ],
    [
      "etonner",
      0.0525
    ],
    [
      "accabler",
      0.0525
    ],
    [
      "briser",
      0.0425
    ],
    [
      "confondre",
      0.0425
    ],
    [
      "ruiner",
      0.0325
    ],
    [
      "vaincre",
      0.0325
    ],
    [
      "tuer",
      0.025
    ],
    [
      "terrasser",
      0.025
    ],
    [
      "stupefier",
      0.025
    ],
    [
      "frapper",
      0.025
    ],
    [
      "faucher",
      0.025
    ],
    [
      "siderer",
      0.015
    ],
    [
      "petrifier",
      0.015
    ],
    [
      "interdire",
      0.015
    ],
    [
      "bombarder",
      0.015
    ],
    [
      "annihiler",
      0.015
    ],
    [
      "punir",
      0.0075
    ],
    [
      "pulveriser",
      0.0075
    ],
    [
      "fusiller",
      0.0075
    ],
    [
      "fulminer",
      0.0075
    ],
    [
      "chatier",
      0.0075
    ],
    [
      "stigmatiser",
      0.0075
    ]
  ],
  "crepuscule": [
    [
      "declin",
      0.15
    ],
    [
      "soir",
      0.15
    ],
    [
      "couchant",
      0.09
    ],
    [
      "decadence",
      0.09
    ],
    [
      "fin",
      0.06
    ],
    [
      "coucher",
      0.06
    ],
    [
      "brune",
      0.06
    ],
    [
      "tombee",
      0.03
    ],
    [
      "agonie",
      0.03
    ],
    [
      "vieillesse",
      0.03
    ]
  ],
  "explorer": [
    [
      "examiner",
      0.165
    ],
    [
      "sonder",
      0.1275
    ],
    [
      "fouiller",
      0.115
    ],
    [
      "etudier",
      0.0875
    ],
    [
      "scruter",
      0.075
    ],
    [
      "visiter",
      0.0625
    ],
    [
      "inspecter",
      0.05
    ],
    [
      "tater",
      0.0375
    ],
    [
      "reconnaitre",
      0.0375
    ],
    [
      "prospecter",
      0.0375
    ],
    [
      "parcourir",
      0.0375
    ],
    [
      "chercher",
      0.0375
    ],
    [
      "battre",
      0.0375
    ],
    [
      "approfondir",
      0.01
    ],
    [
      "ausculter",
      0.01
    ],
    [
      "fureter",
      0.01
    ],
    [
      "inventorier",
      0.01
    ],
    [
      "observer",
      0.01
    ],
    [
      "perquisitionner",
      0.01
    ]
  ],
  "subconscient": [
    [
      "inconscient",
      0.165
    ],
    [
      "intimite",
      0.165
    ],
    [
      "interiorite",
      0.165
    ],
    [
      "profondeurs",
      0.165
    ],
    [
      "preconscient",
      0.165
    ],
    [
      "subliminal",
      0.165
    ]
  ],
  "antiquite": [
    [
      "vieillerie",
      0.2675
    ],
    [
      "anciennete",
      0.2
    ],
    [
      "vieillesse",
      0.065
    ],
    [
      "patine",
      0.065
    ],
    [
      "brocante",
      0.065
    ],
    [
      "archeologie",
      0.065
    ],
    [
      "antiquaillerie",
      0.065
    ],
    [
      "antiquaille",
      0.065
    ],
    [
      "vetuste",
      0.065
    ]
  ],
  "retrouvaille": [],
  "bourrasque": [
    [
      "tempete",
      0.1675
    ],
    [
      "tornade",
      0.1225
    ],
    [
      "typhon",
      0.11
    ],
    [
      "rafale",
      0.0875
    ],
    [
      "ouragan",
      0.0775
    ],
    [
      "vent",
      0.055
    ],
    [
      "trombe",
      0.055
    ],
    [
      "tourbillon",
      0.055
    ],
    [
      "orage",
      0.0425
    ],
    [
      "tourmente",
      0.0325
    ],
    [
      "cyclone",
      0.0325
    ],
    [
      "agitation",
      0.0325
    ],
    [
      "colere",
      0.02
    ],
    [
      "risee",
      0.01
    ],
    [
      "humeur",
      0.01
    ],
    [
      "grain",
      0.01
    ],
    [
      "acces",
      0.01
    ],
    [
      "simoun",
      0.01
    ]
  ],
  "ambitionner": [
    [
      "desirer",
      0.135
    ],
    [
      "briguer",
      0.1075
    ],
    [
      "viser",
      0.1075
    ],
    [
      "vouloir",
      0.1075
    ],
    [
      "pretendre",
      0.08
    ],
    [
      "rever",
      0.08
    ],
    [
      "aspirer",
      0.0675
    ],
    [
      "souhaiter",
      0.0675
    ],
    [
      "rechercher",
      0.0525
    ],
    [
      "convoiter",
      0.0525
    ],
    [
      "poursuivre",
      0.04
    ],
    [
      "projeter",
      0.025
    ],
    [
      "caresser",
      0.0125
    ],
    [
      "queter",
      0.0125
    ]
  ],
  "lyceen": [
    [
      "collegien",
      0.3325
    ],
    [
      "potache",
      0.3325
    ],
    [
      "eleve",
      0.3325
    ]
  ],
  "stupefiant": [
    [
      "etonnant",
      0.1125
    ],
    [
      "extraordinaire",
      0.1
    ],
    [
      "sensationnel",
      0.0875
    ],
    [
      "inoui",
      0.08
    ],
    [
      "fantastique",
      0.0725
    ],
    [
      "formidable",
      0.0525
    ],
    [
      "surprenant",
      0.0425
    ],
    [
      "incroyable",
      0.04
    ],
    [
      "ahurissant",
      0.0375
    ],
    [
      "invraisemblable",
      0.03
    ],
    [
      "enorme",
      0.0275
    ],
    [
      "phenomenal",
      0.025
    ],
    [
      "renversant",
      0.025
    ],
    [
      "effarant",
      0.0225
    ],
    [
      "fabuleux",
      0.0225
    ],
    [
      "epoustouflant",
      0.02
    ],
    [
      "extravagant",
      0.02
    ],
    [
      "abracadabrant",
      0.0175
    ],
    [
      "beau",
      0.0125
    ],
    [
      "epatant",
      0.01
    ],
    [
      "unique",
      0.01
    ],
    [
      "suffocant",
      0.01
    ],
    [
      "fort",
      0.01
    ],
    [
      "faramineux",
      0.01
    ],
    [
      "inconcevable",
      0.0075
    ],
    [
      "terrible",
      0.0075
    ],
    [
      "soufflant",
      0.005
    ],
    [
      "siderant",
      0.005
    ],
    [
      "effrayant",
      0.005
    ],
    [
      "deconcertant",
      0.005
    ],
    [
      "confondant",
      0.005
    ],
    [
      "ebahissant",
      0.0025
    ],
    [
      "saisissant",
      0.0025
    ],
    [
      "paradoxal",
      0.0025
    ],
    [
      "narcotique",
      0.0025
    ],
    [
      "insoupconne",
      0.0025
    ],
    [
      "imposant",
      0.0025
    ],
    [
      "drogue",
      0.0025
    ],
    [
      "anesthesique",
      0.0025
    ],
    [
      "ebaubissant",
      0.0025
    ]
  ],
  "colore": [
    [
      "orner",
      0.0875
    ],
    [
      "teindre",
      0.0875
    ],
    [
      "farder",
      0.075
    ],
    [
      "embellir",
      0.05
    ],
    [
      "marquer",
      0.05
    ],
    [
      "peindre",
      0.05
    ],
    [
      "rehausser",
      0.05
    ],
    [
      "parer",
      0.0375
    ],
    [
      "impregner",
      0.0375
    ],
    [
      "imager",
      0.0375
    ],
    [
      "colorier",
      0.0375
    ],
    [
      "teinter",
      0.0225
    ],
    [
      "revetir",
      0.0225
    ],
    [
      "relever",
      0.0225
    ],
    [
      "peinturlurer",
      0.0225
    ],
    [
      "enluminer",
      0.0225
    ],
    [
      "barioler",
      0.0225
    ],
    [
      "aviver",
      0.0225
    ],
    [
      "animer",
      0.0225
    ],
    [
      "mordorer",
      0.01
    ],
    [
      "nitrater",
      0.01
    ],
    [
      "nuancer",
      0.01
    ],
    [
      "penetrer",
      0.01
    ],
    [
      "rosir",
      0.01
    ],
    [
      "rougir",
      0.01
    ],
    [
      "jaunir",
      0.01
    ],
    [
      "empreindre",
      0.01
    ],
    [
      "deguiser",
      0.01
    ],
    [
      "cendrer",
      0.01
    ],
    [
      "brunir",
      0.01
    ],
    [
      "bleuir",
      0.01
    ],
    [
      "bigarrer",
      0.01
    ],
    [
      "barbouiller",
      0.01
    ],
    [
      "accompagner",
      0.01
    ],
    [
      "verdir",
      0.01
    ]
  ],
  "colorer": [
    [
      "orner",
      0.0875
    ],
    [
      "teindre",
      0.0875
    ],
    [
      "farder",
      0.075
    ],
    [
      "embellir",
      0.05
    ],
    [
      "marquer",
      0.05
    ],
    [
      "peindre",
      0.05
    ],
    [
      "rehausser",
      0.05
    ],
    [
      "parer",
      0.0375
    ],
    [
      "impregner",
      0.0375
    ],
    [
      "imager",
      0.0375
    ],
    [
      "colorier",
      0.0375
    ],
    [
      "teinter",
      0.0225
    ],
    [
      "revetir",
      0.0225
    ],
    [
      "relever",
      0.0225
    ],
    [
      "peinturlurer",
      0.0225
    ],
    [
      "enluminer",
      0.0225
    ],
    [
      "barioler",
      0.0225
    ],
    [
      "aviver",
      0.0225
    ],
    [
      "animer",
      0.0225
    ],
    [
      "mordorer",
      0.01
    ],
    [
      "nitrater",
      0.01
    ],
    [
      "nuancer",
      0.01
    ],
    [
      "penetrer",
      0.01
    ],
    [
      "rosir",
      0.01
    ],
    [
      "rougir",
      0.01
    ],
    [
      "jaunir",
      0.01
    ],
    [
      "empreindre",
      0.01
    ],
    [
      "deguiser",
      0.01
    ],
    [
      "cendrer",
      0.01
    ],
    [
      "brunir",
      0.01
    ],
    [
      "bleuir",
      0.01
    ],
    [
      "bigarrer",
      0.01
    ],
    [
      "barbouiller",
      0.01
    ],
    [
      "accompagner",
      0.01
    ],
    [
      "verdir",
      0.01
    ]
  ],
  "decrier": [
    [
      "discrediter",
      0.175
    ],
    [
      "denigrer",
      0.16
    ],
    [
      "deprecier",
      0.1175
    ],
    [
      "vilipender",
      0.0875
    ],
    [
      "diffamer",
      0.0725
    ],
    [
      "noircir",
      0.0425
    ],
    [
      "medire",
      0.0425
    ],
    [
      "deshonorer",
      0.0425
    ],
    [
      "deconsiderer",
      0.0425
    ],
    [
      "critiquer",
      0.0425
    ],
    [
      "calomnier",
      0.0275
    ],
    [
      "decrediter",
      0.0275
    ],
    [
      "mepriser",
      0.0275
    ],
    [
      "perdre",
      0.0125
    ]
  ],
  "decrie": [
    [
      "discrediter",
      0.175
    ],
    [
      "denigrer",
      0.16
    ],
    [
      "deprecier",
      0.1175
    ],
    [
      "vilipender",
      0.0875
    ],
    [
      "diffamer",
      0.0725
    ],
    [
      "noircir",
      0.0425
    ],
    [
      "medire",
      0.0425
    ],
    [
      "deshonorer",
      0.0425
    ],
    [
      "deconsiderer",
      0.0425
    ],
    [
      "critiquer",
      0.0425
    ],
    [
      "calomnier",
      0.0275
    ],
    [
      "decrediter",
      0.0275
    ],
    [
      "mepriser",
      0.0275
    ],
    [
      "perdre",
      0.0125
    ]
  ],
  "outrager": [
    [
      "blesser",
      0.22
    ],
    [
      "offenser",
      0.185
    ],
    [
      "injurier",
      0.11
    ],
    [
      "insulter",
      0.11
    ],
    [
      "blasphemer",
      0.0725
    ],
    [
      "souffleter",
      0.035
    ],
    [
      "piquer",
      0.035
    ],
    [
      "mortifier",
      0.035
    ],
    [
      "jurer",
      0.035
    ],
    [
      "dechirer",
      0.035
    ],
    [
      "bafouer",
      0.035
    ],
    [
      "violer",
      0.035
    ]
  ],
  "masculin": [
    [
      "male",
      0.5
    ],
    [
      "hommasse",
      0.165
    ],
    [
      "homme",
      0.165
    ],
    [
      "viril",
      0.165
    ]
  ],
  "feminin": [
    [
      "effemine",
      0.5
    ],
    [
      "femelle",
      0.5
    ]
  ],
  "conquistador": [
    [
      "aventurier",
      0.5
    ],
    [
      "conquerant",
      0.5
    ]
  ],
  "devetir": [
    [
      "denuder",
      0.2
    ],
    [
      "deshabiller",
      0.2
    ],
    [
      "defrusquer",
      0.1
    ],
    [
      "demunir",
      0.1
    ],
    [
      "depouiller",
      0.1
    ],
    [
      "desaffubler",
      0.1
    ],
    [
      "devoiler",
      0.1
    ],
    [
      "reveler",
      0.1
    ]
  ],
  "contrefacon": [
    [
      "imitation",
      0.2125
    ],
    [
      "faux",
      0.105
    ],
    [
      "plagiat",
      0.07
    ],
    [
      "pastiche",
      0.07
    ],
    [
      "parodie",
      0.07
    ],
    [
      "copie",
      0.07
    ],
    [
      "alteration",
      0.07
    ],
    [
      "truquage",
      0.035
    ],
    [
      "inexactitude",
      0.035
    ],
    [
      "fraude",
      0.035
    ],
    [
      "falsification",
      0.035
    ],
    [
      "demarquage",
      0.035
    ],
    [
      "contrefaction",
      0.035
    ],
    [
      "caricature",
      0.035
    ],
    [
      "vol",
      0.035
    ]
  ],
  "sorcier": [
    [
      "magicien",
      0.19
    ],
    [
      "enchanteur",
      0.075
    ],
    [
      "mage",
      0.075
    ],
    [
      "charlatan",
      0.055
    ],
    [
      "charmeur",
      0.055
    ],
    [
      "ensorceleur",
      0.055
    ],
    [
      "marabout",
      0.055
    ],
    [
      "thaumaturge",
      0.0375
    ],
    [
      "necromant",
      0.0375
    ],
    [
      "necromancien",
      0.0375
    ],
    [
      "devin",
      0.0375
    ],
    [
      "surnaturel",
      0.0175
    ],
    [
      "psychopompe",
      0.0175
    ],
    [
      "invocateur",
      0.0175
    ],
    [
      "incantateur",
      0.0175
    ],
    [
      "guerisseur",
      0.0175
    ],
    [
      "feticheur",
      0.0175
    ],
    [
      "exorciste",
      0.0175
    ],
    [
      "envouteur",
      0.0175
    ],
    [
      "difficile",
      0.0175
    ],
    [
      "complique",
      0.0175
    ],
    [
      "chaman",
      0.0175
    ],
    [
      "captivant",
      0.0175
    ],
    [
      "astrologue",
      0.0175
    ],
    [
      "alchimiste",
      0.0175
    ],
    [
      "thaumaturgique",
      0.0175
    ]
  ],
  "coquille": [
    [
      "habitacle",
      0.115
    ],
    [
      "coque",
      0.085
    ],
    [
      "ecaille",
      0.0575
    ],
    [
      "test",
      0.0575
    ],
    [
      "faute",
      0.0575
    ],
    [
      "erreur",
      0.0575
    ],
    [
      "enveloppe",
      0.0575
    ],
    [
      "cocon",
      0.0575
    ],
    [
      "carapace",
      0.0575
    ],
    [
      "abri",
      0.0575
    ],
    [
      "limacon",
      0.0275
    ],
    [
      "lapsus",
      0.0275
    ],
    [
      "isolant",
      0.0275
    ],
    [
      "enroulement",
      0.0275
    ],
    [
      "crotte",
      0.0275
    ],
    [
      "coquatre",
      0.0275
    ],
    [
      "coquillage",
      0.0275
    ],
    [
      "conque",
      0.0275
    ],
    [
      "conche",
      0.0275
    ],
    [
      "bevue",
      0.0275
    ],
    [
      "boursouflure",
      0.0275
    ],
    [
      "oeuf",
      0.0275
    ]
  ],
  "execrable": [
    [
      "horrible",
      0.11
    ],
    [
      "odieux",
      0.11
    ],
    [
      "abominable",
      0.1
    ],
    [
      "affreux",
      0.1
    ],
    [
      "detestable",
      0.0825
    ],
    [
      "repoussant",
      0.0725
    ],
    [
      "mauvais",
      0.0725
    ],
    [
      "repugnant",
      0.0625
    ],
    [
      "infect",
      0.055
    ],
    [
      "monstrueux",
      0.035
    ],
    [
      "haissable",
      0.035
    ],
    [
      "degoutant",
      0.035
    ],
    [
      "hideux",
      0.0275
    ],
    [
      "epouvantable",
      0.0275
    ],
    [
      "imbuvable",
      0.0175
    ],
    [
      "deplorable",
      0.0075
    ],
    [
      "indigne",
      0.0075
    ],
    [
      "infernal",
      0.0075
    ],
    [
      "maudit",
      0.0075
    ]
  ],
  "acre": [
    [
      "arpent",
      1.0
    ]
  ],
  "agile": [
    [
      "vif",
      0.13
    ],
    [
      "alerte",
      0.07
    ],
    [
      "fringant",
      0.07
    ],
    [
      "prompt",
      0.065
    ],
    [
      "leste",
      0.0625
    ],
    [
      "dispos",
      0.0525
    ],
    [
      "preste",
      0.0525
    ],
    [
      "eveille",
      0.0475
    ],
    [
      "ardent",
      0.0425
    ],
    [
      "leger",
      0.0425
    ],
    [
      "semillant",
      0.0375
    ],
    [
      "delie",
      0.0325
    ],
    [
      "souple",
      0.0325
    ],
    [
      "habile",
      0.0275
    ],
    [
      "turbulent",
      0.0225
    ],
    [
      "remuant",
      0.0225
    ],
    [
      "rapide",
      0.0225
    ],
    [
      "adroit",
      0.0175
    ],
    [
      "allegre",
      0.0175
    ],
    [
      "aise",
      0.0125
    ],
    [
      "mobile",
      0.0125
    ],
    [
      "vite",
      0.0125
    ],
    [
      "elegant",
      0.0125
    ],
    [
      "elastique",
      0.0075
    ],
    [
      "petillant",
      0.0075
    ],
    [
      "ingambe",
      0.0075
    ],
    [
      "fretillant",
      0.0075
    ],
    [
      "decouple",
      0.0025
    ],
    [
      "felin",
      0.0025
    ],
    [
      "gracieux",
      0.0025
    ],
    [
      "veloce",
      0.0025
    ]
  ],
  "contaminer": [
    [
      "infecter",
      0.1775
    ],
    [
      "empester",
      0.105
    ],
    [
      "polluer",
      0.105
    ],
    [
      "souiller",
      0.105
    ],
    [
      "tacher",
      0.07
    ],
    [
      "salir",
      0.07
    ],
    [
      "pourrir",
      0.07
    ],
    [
      "fletrir",
      0.07
    ],
    [
      "contagionner",
      0.07
    ],
    [
      "empoisonner",
      0.035
    ],
    [
      "entacher",
      0.035
    ],
    [
      "influencer",
      0.035
    ],
    [
      "transmettre",
      0.035
    ]
  ],
  "crochet": [
    [
      "boucle",
      0.0975
    ],
    [
      "attache",
      0.0725
    ],
    [
      "crampon",
      0.0725
    ],
    [
      "croc",
      0.0725
    ],
    [
      "detour",
      0.0725
    ],
    [
      "fermoir",
      0.0475
    ],
    [
      "agrafe",
      0.0475
    ],
    [
      "harpon",
      0.0225
    ],
    [
      "patte",
      0.0225
    ],
    [
      "patere",
      0.0225
    ],
    [
      "pendoir",
      0.0225
    ],
    [
      "piton",
      0.0225
    ],
    [
      "ponctuation",
      0.0225
    ],
    [
      "rossignol",
      0.0225
    ],
    [
      "uppercut",
      0.0225
    ],
    [
      "grappin",
      0.0225
    ],
    [
      "fermeture",
      0.0225
    ],
    [
      "accrochage",
      0.0225
    ],
    [
      "canine",
      0.0225
    ],
    [
      "clef",
      0.0225
    ],
    [
      "dent",
      0.0225
    ],
    [
      "declic",
      0.0225
    ],
    [
      "depens",
      0.0225
    ],
    [
      "deviation",
      0.0225
    ],
    [
      "esse",
      0.0225
    ],
    [
      "zigzag",
      0.0225
    ]
  ],
  "pianiste": [],
  "interpreter": [
    [
      "dechiffrer",
      0.095
    ],
    [
      "jouer",
      0.0775
    ],
    [
      "comprendre",
      0.0625
    ],
    [
      "expliquer",
      0.0625
    ],
    [
      "faire",
      0.0625
    ],
    [
      "saisir",
      0.0625
    ],
    [
      "traduire",
      0.0625
    ],
    [
      "representer",
      0.0475
    ],
    [
      "penetrer",
      0.0475
    ],
    [
      "prendre",
      0.0475
    ],
    [
      "deviner",
      0.0475
    ],
    [
      "tourner",
      0.03
    ],
    [
      "lire",
      0.03
    ],
    [
      "illustrer",
      0.03
    ],
    [
      "gloser",
      0.03
    ],
    [
      "executer",
      0.03
    ],
    [
      "commenter",
      0.03
    ],
    [
      "translater",
      0.015
    ],
    [
      "torturer",
      0.015
    ],
    [
      "tirer",
      0.015
    ],
    [
      "styliser",
      0.015
    ],
    [
      "incarner",
      0.015
    ],
    [
      "entendre",
      0.015
    ],
    [
      "creer",
      0.015
    ],
    [
      "elucider",
      0.015
    ]
  ],
  "cabosser": [
    [
      "blesser",
      0.18
    ],
    [
      "bosseler",
      0.18
    ],
    [
      "meurtrir",
      0.18
    ],
    [
      "accidenter",
      0.09
    ],
    [
      "battre",
      0.09
    ],
    [
      "bossuer",
      0.09
    ],
    [
      "contusionner",
      0.09
    ],
    [
      "deformer",
      0.09
    ]
  ],
  "infecte": [
    [
      "corrompre",
      0.135
    ],
    [
      "gater",
      0.135
    ],
    [
      "empester",
      0.095
    ],
    [
      "empoisonner",
      0.08
    ],
    [
      "gangrener",
      0.08
    ],
    [
      "pourrir",
      0.0675
    ],
    [
      "contaminer",
      0.0675
    ],
    [
      "polluer",
      0.0525
    ],
    [
      "souiller",
      0.0525
    ],
    [
      "puer",
      0.025
    ],
    [
      "pervertir",
      0.025
    ],
    [
      "carier",
      0.025
    ],
    [
      "abimer",
      0.025
    ],
    [
      "intoxiquer",
      0.0125
    ],
    [
      "envenimer",
      0.0125
    ],
    [
      "empuantir",
      0.0125
    ],
    [
      "contagionner",
      0.0125
    ],
    [
      "cogner",
      0.0125
    ],
    [
      "cocotter",
      0.0125
    ],
    [
      "mephitiser",
      0.0125
    ]
  ],
  "infecter": [
    [
      "corrompre",
      0.135
    ],
    [
      "gater",
      0.135
    ],
    [
      "empester",
      0.095
    ],
    [
      "empoisonner",
      0.08
    ],
    [
      "gangrener",
      0.08
    ],
    [
      "pourrir",
      0.0675
    ],
    [
      "contaminer",
      0.0675
    ],
    [
      "polluer",
      0.0525
    ],
    [
      "souiller",
      0.0525
    ],
    [
      "puer",
      0.025
    ],
    [
      "pervertir",
      0.025
    ],
    [
      "carier",
      0.025
    ],
    [
      "abimer",
      0.025
    ],
    [
      "intoxiquer",
      0.0125
    ],
    [
      "envenimer",
      0.0125
    ],
    [
      "empuantir",
      0.0125
    ],
    [
      "contagionner",
      0.0125
    ],
    [
      "cogner",
      0.0125
    ],
    [
      "cocotter",
      0.0125
    ],
    [
      "mephitiser",
      0.0125
    ]
  ],
  "orteil": [],
  "goitre": [
    [
      "tumeur",
      1.0
    ]
  ],
  "gondoler": [
    [
      "gauchir",
      0.1425
    ],
    [
      "bomber",
      0.095
    ],
    [
      "courber",
      0.095
    ],
    [
      "gonfler",
      0.095
    ],
    [
      "onduler",
      0.095
    ],
    [
      "travailler",
      0.095
    ],
    [
      "plisser",
      0.0475
    ],
    [
      "jouer",
      0.0475
    ]
  ],
  "repoussant": [
    [
      "repugnant",
      0.1025
    ],
    [
      "horrible",
      0.0925
    ],
    [
      "affreux",
      0.0775
    ],
    [
      "degoutant",
      0.0775
    ],
    [
      "ignoble",
      0.0675
    ],
    [
      "abject",
      0.055
    ],
    [
      "infect",
      0.0525
    ],
    [
      "laid",
      0.0475
    ],
    [
      "odieux",
      0.045
    ],
    [
      "hideux",
      0.045
    ],
    [
      "abominable",
      0.0375
    ],
    [
      "nauseabond",
      0.03
    ],
    [
      "execrable",
      0.0275
    ],
    [
      "ecoeurant",
      0.0275
    ],
    [
      "monstrueux",
      0.0225
    ],
    [
      "desagreable",
      0.02
    ],
    [
      "atroce",
      0.02
    ],
    [
      "puant",
      0.015
    ],
    [
      "rebutant",
      0.015
    ],
    [
      "fetide",
      0.0125
    ],
    [
      "haissable",
      0.0125
    ],
    [
      "vil",
      0.0125
    ],
    [
      "degueulasse",
      0.01
    ],
    [
      "repulsif",
      0.01
    ],
    [
      "impur",
      0.005
    ],
    [
      "effrayant",
      0.005
    ],
    [
      "antipathique",
      0.0025
    ],
    [
      "difforme",
      0.0025
    ],
    [
      "effroyable",
      0.0025
    ],
    [
      "ord",
      0.0025
    ],
    [
      "poisseux",
      0.0025
    ],
    [
      "rebarbatif",
      0.0025
    ]
  ],
  "repousser": [
    [
      "rejeter",
      0.085
    ],
    [
      "chasser",
      0.0725
    ],
    [
      "refuser",
      0.055
    ],
    [
      "renvoyer",
      0.05
    ],
    [
      "eloigner",
      0.045
    ],
    [
      "exclure",
      0.0375
    ],
    [
      "eliminer",
      0.0375
    ],
    [
      "ecarter",
      0.03
    ],
    [
      "pousser",
      0.0275
    ],
    [
      "remettre",
      0.025
    ],
    [
      "expulser",
      0.0225
    ],
    [
      "bannir",
      0.02
    ],
    [
      "reculer",
      0.02
    ],
    [
      "refouler",
      0.02
    ],
    [
      "s'opposer",
      0.0175
    ],
    [
      "abandonner",
      0.015
    ],
    [
      "evincer",
      0.015
    ],
    [
      "rembarrer",
      0.0125
    ],
    [
      "rebuter",
      0.0125
    ],
    [
      "jeter",
      0.0125
    ],
    [
      "balayer",
      0.0125
    ],
    [
      "ajourner",
      0.0125
    ],
    [
      "econduire",
      0.01
    ],
    [
      "repugner",
      0.01
    ],
    [
      "retarder",
      0.01
    ],
    [
      "reconduire",
      0.01
    ],
    [
      "rabrouer",
      0.01
    ],
    [
      "proscrire",
      0.01
    ],
    [
      "detruire",
      0.01
    ],
    [
      "differer",
      0.01
    ],
    [
      "proroger",
      0.0075
    ],
    [
      "revenir",
      0.0075
    ],
    [
      "recuser",
      0.0075
    ],
    [
      "refuter",
      0.0075
    ],
    [
      "repudier",
      0.0075
    ],
    [
      "temporiser",
      0.0075
    ],
    [
      "etendre",
      0.0075
    ],
    [
      "excommunier",
      0.0075
    ],
    [
      "bousculer",
      0.0075
    ],
    [
      "culbuter",
      0.0075
    ],
    [
      "dissiper",
      0.0075
    ],
    [
      "debouter",
      0.0075
    ],
    [
      "decliner",
      0.0075
    ],
    [
      "degouter",
      0.0075
    ],
    [
      "remplacer",
      0.0025
    ],
    [
      "reporter",
      0.0025
    ],
    [
      "riposter",
      0.0025
    ],
    [
      "resister",
      0.0025
    ],
    [
      "supplanter",
      0.0025
    ],
    [
      "suspendre",
      0.0025
    ],
    [
      "ejecter",
      0.0025
    ],
    [
      "rabattre",
      0.0025
    ],
    [
      "ostraciser",
      0.0025
    ],
    [
      "objecter",
      0.0025
    ],
    [
      "allonger",
      0.0025
    ],
    [
      "blackbouler",
      0.0025
    ],
    [
      "bouter",
      0.0025
    ],
    [
      "contrarier",
      0.0025
    ],
    [
      "dedaigner",
      0.0025
    ],
    [
      "deplaire",
      0.0025
    ],
    [
      "moucher",
      0.0025
    ],
    [
      "rechasser",
      0.0
    ],
    [
      "remiser",
      0.0
    ],
    [
      "remonter",
      0.0
    ],
    [
      "remoucher",
      0.0
    ],
    [
      "renaitre",
      0.0
    ],
    [
      "rencogner",
      0.0
    ],
    [
      "rebuffer",
      0.0
    ],
    [
      "mepriser",
      0.0
    ],
    [
      "execrer",
      0.0
    ],
    [
      "emballer",
      0.0
    ],
    [
      "bouler",
      0.0
    ],
    [
      "ecoeurer",
      0.0
    ]
  ],
  "brigand": [
    [
      "bandit",
      0.145
    ],
    [
      "voleur",
      0.11
    ],
    [
      "fripouille",
      0.0925
    ],
    [
      "vaurien",
      0.0875
    ],
    [
      "malfaiteur",
      0.0575
    ],
    [
      "truand",
      0.0575
    ],
    [
      "terreur",
      0.0375
    ],
    [
      "forban",
      0.0375
    ],
    [
      "canaille",
      0.0375
    ],
    [
      "malandrin",
      0.035
    ],
    [
      "gredin",
      0.03
    ],
    [
      "scelerat",
      0.03
    ],
    [
      "crapule",
      0.025
    ],
    [
      "gangster",
      0.02
    ],
    [
      "fripon",
      0.02
    ],
    [
      "coquin",
      0.02
    ],
    [
      "chenapan",
      0.0175
    ],
    [
      "pirate",
      0.0175
    ],
    [
      "criminel",
      0.0125
    ],
    [
      "pillard",
      0.0125
    ],
    [
      "routier",
      0.0125
    ],
    [
      "sacripant",
      0.0125
    ],
    [
      "requin",
      0.0075
    ],
    [
      "detrousseur",
      0.0075
    ],
    [
      "assassin",
      0.0025
    ],
    [
      "barbet",
      0.0025
    ],
    [
      "chauffeur",
      0.0025
    ],
    [
      "clephte",
      0.0025
    ],
    [
      "vandale",
      0.0025
    ]
  ],
  "fleuriste": [
    [
      "bouquetier",
      0.3325
    ],
    [
      "bouquetiere",
      0.3325
    ],
    [
      "horticulteur",
      0.3325
    ]
  ],
  "mimer": [
    [
      "imiter",
      0.1475
    ],
    [
      "simuler",
      0.1475
    ],
    [
      "singer",
      0.11
    ],
    [
      "reproduire",
      0.11
    ],
    [
      "copier",
      0.11
    ],
    [
      "contrefaire",
      0.11
    ],
    [
      "jouer",
      0.0725
    ],
    [
      "pasticher",
      0.0725
    ],
    [
      "pantomimer",
      0.035
    ],
    [
      "parodier",
      0.035
    ],
    [
      "representer",
      0.035
    ]
  ],
  "mime": [
    [
      "geste",
      0.1225
    ],
    [
      "expression",
      0.0975
    ],
    [
      "maniere",
      0.0725
    ],
    [
      "pantomime",
      0.0725
    ],
    [
      "singerie",
      0.0475
    ],
    [
      "signe",
      0.0475
    ],
    [
      "mimique",
      0.0475
    ],
    [
      "imitation",
      0.0475
    ],
    [
      "contorsion",
      0.0475
    ],
    [
      "comedien",
      0.0475
    ],
    [
      "comique",
      0.0475
    ],
    [
      "attitude",
      0.0475
    ],
    [
      "acteur",
      0.0475
    ],
    [
      "imitateur",
      0.0225
    ],
    [
      "gesticulation",
      0.0225
    ],
    [
      "contrefaiseur",
      0.0225
    ],
    [
      "clown",
      0.0225
    ],
    [
      "archimime",
      0.0225
    ],
    [
      "mimetisme",
      0.0225
    ]
  ],
  "tricoter": [],
  "recoudre": [
    [
      "coudre",
      0.3325
    ],
    [
      "raccommoder",
      0.3325
    ],
    [
      "reparer",
      0.165
    ],
    [
      "suturer",
      0.165
    ]
  ],
  "collectionner": [
    [
      "reunir",
      0.19
    ],
    [
      "accumuler",
      0.1425
    ],
    [
      "amasser",
      0.1425
    ],
    [
      "assembler",
      0.1425
    ],
    [
      "rassembler",
      0.095
    ],
    [
      "ramasser",
      0.095
    ],
    [
      "bibeloter",
      0.0475
    ],
    [
      "colliger",
      0.0475
    ],
    [
      "entasser",
      0.0475
    ],
    [
      "grouper",
      0.0475
    ]
  ],
  "licorne": [],
  "poesie": [
    [
      "poeme",
      0.2025
    ],
    [
      "vers",
      0.0625
    ],
    [
      "inspiration",
      0.045
    ],
    [
      "versification",
      0.03
    ],
    [
      "piece",
      0.03
    ],
    [
      "metrique",
      0.03
    ],
    [
      "muse",
      0.03
    ],
    [
      "mesure",
      0.03
    ],
    [
      "lyre",
      0.03
    ],
    [
      "grace",
      0.03
    ],
    [
      "charme",
      0.03
    ],
    [
      "chant",
      0.03
    ],
    [
      "beaute",
      0.03
    ],
    [
      "prosodie",
      0.015
    ],
    [
      "priapee",
      0.015
    ],
    [
      "pantoum",
      0.015
    ],
    [
      "musique",
      0.015
    ],
    [
      "rythme",
      0.015
    ],
    [
      "septain",
      0.015
    ],
    [
      "sizain",
      0.015
    ],
    [
      "sonnet",
      0.015
    ],
    [
      "triolet",
      0.015
    ],
    [
      "trompette",
      0.015
    ],
    [
      "macaronee",
      0.015
    ],
    [
      "lyrisme",
      0.015
    ],
    [
      "litterature",
      0.015
    ],
    [
      "Parnasse",
      0.015
    ],
    [
      "acrostiche",
      0.015
    ],
    [
      "art",
      0.015
    ],
    [
      "cadence",
      0.015
    ],
    [
      "dizain",
      0.015
    ],
    [
      "douzain",
      0.015
    ],
    [
      "envoutement",
      0.015
    ],
    [
      "flute",
      0.015
    ],
    [
      "harpe",
      0.015
    ],
    [
      "huitain",
      0.015
    ],
    [
      "emotion",
      0.015
    ]
  ],
  "lanterne": [
    [
      "feu",
      0.125
    ],
    [
      "chanson",
      0.0825
    ],
    [
      "fanal",
      0.0825
    ],
    [
      "lumiere",
      0.0825
    ],
    [
      "phare",
      0.0825
    ],
    [
      "lanternerie",
      0.04
    ],
    [
      "potence",
      0.04
    ],
    [
      "reverbere",
      0.04
    ],
    [
      "tourelle",
      0.04
    ],
    [
      "trainard",
      0.04
    ],
    [
      "lampion",
      0.04
    ],
    [
      "lampe",
      0.04
    ],
    [
      "falot",
      0.04
    ],
    [
      "dernier",
      0.04
    ],
    [
      "campanile",
      0.04
    ],
    [
      "calembredaine",
      0.04
    ],
    [
      "bagatelle",
      0.04
    ],
    [
      "veilleuse",
      0.04
    ]
  ],
  "brave": [
    [
      "bon",
      0.135
    ],
    [
      "courageux",
      0.065
    ],
    [
      "genereux",
      0.065
    ],
    [
      "intrepide",
      0.0525
    ],
    [
      "beau",
      0.045
    ],
    [
      "bonhomme",
      0.045
    ],
    [
      "gentil",
      0.035
    ],
    [
      "hardi",
      0.0275
    ],
    [
      "chic",
      0.0275
    ],
    [
      "audacieux",
      0.0275
    ],
    [
      "aimable",
      0.0275
    ],
    [
      "vaillant",
      0.0225
    ],
    [
      "simple",
      0.0225
    ],
    [
      "obligeant",
      0.0225
    ],
    [
      "heroique",
      0.0225
    ],
    [
      "debonnaire",
      0.0225
    ],
    [
      "bienveillant",
      0.0225
    ],
    [
      "elegant",
      0.0175
    ],
    [
      "resolu",
      0.0175
    ],
    [
      "preux",
      0.0175
    ],
    [
      "heros",
      0.0175
    ],
    [
      "franc",
      0.0175
    ],
    [
      "devoue",
      0.0175
    ],
    [
      "decide",
      0.0175
    ],
    [
      "distingue",
      0.0175
    ],
    [
      "bonasse",
      0.0175
    ],
    [
      "valeureux",
      0.01
    ],
    [
      "serviable",
      0.01
    ],
    [
      "lion",
      0.01
    ],
    [
      "honnete",
      0.01
    ],
    [
      "facile",
      0.01
    ],
    [
      "excellent",
      0.01
    ],
    [
      "altruiste",
      0.01
    ],
    [
      "tueur",
      0.005
    ],
    [
      "secourable",
      0.005
    ],
    [
      "paladin",
      0.005
    ],
    [
      "invincible",
      0.005
    ],
    [
      "fanfaron",
      0.005
    ],
    [
      "crane",
      0.005
    ],
    [
      "chouette",
      0.005
    ],
    [
      "boniface",
      0.005
    ],
    [
      "temeraire",
      0.005
    ]
  ],
  "braver": [
    [
      "narguer",
      0.175
    ],
    [
      "affronter",
      0.0925
    ],
    [
      "defier",
      0.0825
    ],
    [
      "attaquer",
      0.0725
    ],
    [
      "mepriser",
      0.0725
    ],
    [
      "s'opposer",
      0.06
    ],
    [
      "provoquer",
      0.04
    ],
    [
      "risquer",
      0.03
    ],
    [
      "s'attaquer",
      0.03
    ],
    [
      "offenser",
      0.02
    ],
    [
      "menacer",
      0.02
    ],
    [
      "insulter",
      0.02
    ],
    [
      "dedaigner",
      0.02
    ],
    [
      "combattre",
      0.02
    ],
    [
      "rencontrer",
      0.0075
    ],
    [
      "s'asseoir",
      0.0075
    ],
    [
      "s'exposer",
      0.0075
    ],
    [
      "morguer",
      0.0075
    ],
    [
      "harceler",
      0.0075
    ],
    [
      "fouler",
      0.0075
    ],
    [
      "craner",
      0.0075
    ],
    [
      "violer",
      0.0075
    ]
  ],
  "coule": [
    [
      "passer",
      0.045
    ],
    [
      "s'ecouler",
      0.0375
    ],
    [
      "suinter",
      0.0375
    ],
    [
      "s'enfoncer",
      0.035
    ],
    [
      "fuir",
      0.0325
    ],
    [
      "courir",
      0.0275
    ],
    [
      "sortir",
      0.0275
    ],
    [
      "tomber",
      0.0275
    ],
    [
      "sombrer",
      0.025
    ],
    [
      "glisser",
      0.025
    ],
    [
      "degouliner",
      0.025
    ],
    [
      "s'echapper",
      0.025
    ],
    [
      "transpirer",
      0.0175
    ],
    [
      "ruisseler",
      0.015
    ],
    [
      "perdre",
      0.015
    ],
    [
      "degoutter",
      0.015
    ],
    [
      "decouler",
      0.015
    ],
    [
      "emaner",
      0.0125
    ],
    [
      "sourdre",
      0.0125
    ],
    [
      "s'enfuir",
      0.0125
    ],
    [
      "filtrer",
      0.0125
    ],
    [
      "filer",
      0.0125
    ],
    [
      "circuler",
      0.0125
    ],
    [
      "echouer",
      0.0125
    ],
    [
      "verser",
      0.0125
    ],
    [
      "traverser",
      0.0125
    ],
    [
      "s'abimer",
      0.0125
    ],
    [
      "ruiner",
      0.0075
    ],
    [
      "rouler",
      0.0075
    ],
    [
      "jaillir",
      0.0075
    ],
    [
      "fondre",
      0.0075
    ],
    [
      "exsuder",
      0.0075
    ],
    [
      "descendre",
      0.0075
    ],
    [
      "emettre",
      0.005
    ],
    [
      "torpiller",
      0.005
    ],
    [
      "tirer",
      0.005
    ],
    [
      "suer",
      0.005
    ],
    [
      "soutirer",
      0.005
    ],
    [
      "s'engouffrer",
      0.005
    ],
    [
      "introduire",
      0.005
    ],
    [
      "affluer",
      0.005
    ],
    [
      "baigner",
      0.005
    ],
    [
      "chavirer",
      0.005
    ],
    [
      "enfoncer",
      0.005
    ],
    [
      "fluer",
      0.005
    ],
    [
      "pisser",
      0.0025
    ],
    [
      "pleuvoir",
      0.0025
    ],
    [
      "s'engloutir",
      0.0025
    ],
    [
      "s'epancher",
      0.0025
    ],
    [
      "transvaser",
      0.0025
    ],
    [
      "vivre",
      0.0025
    ],
    [
      "instiller",
      0.0025
    ],
    [
      "insinuer",
      0.0025
    ],
    [
      "immerger",
      0.0025
    ],
    [
      "arroser",
      0.0025
    ],
    [
      "clarifier",
      0.0025
    ],
    [
      "deborder",
      0.0025
    ],
    [
      "demolir",
      0.0025
    ],
    [
      "engloutir",
      0.0025
    ],
    [
      "extravaser",
      0.0025
    ],
    [
      "gicler",
      0.0025
    ],
    [
      "goutter",
      0.0025
    ],
    [
      "ratiboiser",
      0.0
    ],
    [
      "refluer",
      0.0
    ],
    [
      "rejaillir",
      0.0
    ],
    [
      "risquer",
      0.0
    ],
    [
      "s'immerger",
      0.0
    ],
    [
      "s'egoutter",
      0.0
    ],
    [
      "saborder",
      0.0
    ],
    [
      "saboter",
      0.0
    ],
    [
      "sancir",
      0.0
    ],
    [
      "pleurer",
      0.0
    ],
    [
      "murmurer",
      0.0
    ],
    [
      "avorter",
      0.0
    ],
    [
      "baver",
      0.0
    ],
    [
      "clicher",
      0.0
    ],
    [
      "confluer",
      0.0
    ],
    [
      "coulisser",
      0.0
    ],
    [
      "delayer",
      0.0
    ],
    [
      "devaloriser",
      0.0
    ],
    [
      "lier",
      0.0
    ],
    [
      "mouler",
      0.0
    ]
  ],
  "seve": [
    [
      "vigueur",
      0.1925
    ],
    [
      "force",
      0.165
    ],
    [
      "energie",
      0.1375
    ],
    [
      "vitalite",
      0.055
    ],
    [
      "vie",
      0.055
    ],
    [
      "robustesse",
      0.055
    ],
    [
      "puissance",
      0.055
    ],
    [
      "fermete",
      0.055
    ],
    [
      "dynamisme",
      0.055
    ],
    [
      "activite",
      0.0275
    ],
    [
      "lymphe",
      0.0275
    ],
    [
      "pleur",
      0.0275
    ],
    [
      "sang",
      0.0275
    ],
    [
      "suc",
      0.0275
    ],
    [
      "verdeur",
      0.0275
    ]
  ],
  "fumiste": [
    [
      "farceur",
      0.235
    ],
    [
      "plaisantin",
      0.175
    ],
    [
      "mystificateur",
      0.1175
    ],
    [
      "plaisant",
      0.1175
    ],
    [
      "imposteur",
      0.0575
    ],
    [
      "fantaisiste",
      0.0575
    ],
    [
      "blagueur",
      0.0575
    ],
    [
      "amateur",
      0.0575
    ],
    [
      "trompeur",
      0.0575
    ]
  ],
  "affreusement": [
    [
      "horriblement",
      0.2425
    ],
    [
      "atrocement",
      0.12
    ],
    [
      "effroyablement",
      0.0975
    ],
    [
      "abominablement",
      0.0725
    ],
    [
      "epouvantablement",
      0.0475
    ],
    [
      "odieusement",
      0.0475
    ],
    [
      "monstrueusement",
      0.0475
    ],
    [
      "laidement",
      0.0475
    ],
    [
      "ignoblement",
      0.0475
    ],
    [
      "hideusement",
      0.0475
    ],
    [
      "extremement",
      0.0475
    ],
    [
      "excessivement",
      0.0475
    ],
    [
      "cruellement",
      0.0475
    ],
    [
      "tragiquement",
      0.0225
    ]
  ],
  "optimiste": [
    [
      "heureux",
      0.25
    ],
    [
      "insouciant",
      0.25
    ],
    [
      "philosophe",
      0.25
    ],
    [
      "presomptueux",
      0.25
    ]
  ],
  "chiffrer": [
    [
      "evaluer",
      0.23
    ],
    [
      "supputer",
      0.075
    ],
    [
      "quantifier",
      0.075
    ],
    [
      "numeroter",
      0.075
    ],
    [
      "digitaliser",
      0.075
    ],
    [
      "cuber",
      0.075
    ],
    [
      "crypter",
      0.075
    ],
    [
      "compter",
      0.075
    ],
    [
      "coder",
      0.075
    ],
    [
      "calculer",
      0.075
    ],
    [
      "transcrire",
      0.075
    ]
  ],
  "chiffre": [
    [
      "caractere",
      0.1075
    ],
    [
      "marque",
      0.1075
    ],
    [
      "signe",
      0.1075
    ],
    [
      "symbole",
      0.08
    ],
    [
      "total",
      0.0525
    ],
    [
      "nombre",
      0.0525
    ],
    [
      "montant",
      0.0525
    ],
    [
      "calcul",
      0.0525
    ],
    [
      "cachet",
      0.0525
    ],
    [
      "somme",
      0.025
    ],
    [
      "monogramme",
      0.025
    ],
    [
      "initiales",
      0.025
    ],
    [
      "indice",
      0.025
    ],
    [
      "grille",
      0.025
    ],
    [
      "figure",
      0.025
    ],
    [
      "dechiffrement",
      0.025
    ],
    [
      "combinaison",
      0.025
    ],
    [
      "code",
      0.025
    ],
    [
      "chiffrement",
      0.025
    ],
    [
      "arithmetique",
      0.025
    ],
    [
      "taux",
      0.025
    ]
  ],
  "horloge": [
    [
      "pendule",
      0.25
    ],
    [
      "coucou",
      0.0975
    ],
    [
      "reveil",
      0.0475
    ],
    [
      "regulateur",
      0.0475
    ],
    [
      "jaquemart",
      0.0475
    ],
    [
      "gnomon",
      0.0475
    ],
    [
      "comtoise",
      0.0475
    ],
    [
      "clepsydre",
      0.0475
    ],
    [
      "chronometre",
      0.0475
    ],
    [
      "cartel",
      0.0475
    ],
    [
      "carillon",
      0.0475
    ],
    [
      "cadran",
      0.0475
    ],
    [
      "sablier",
      0.0475
    ]
  ],
  "cocotte": [
    [
      "poule",
      0.1425
    ],
    [
      "prostituee",
      0.1425
    ],
    [
      "marmite",
      0.07
    ],
    [
      "courtisane",
      0.07
    ],
    [
      "casserole",
      0.07
    ],
    [
      "amante",
      0.07
    ],
    [
      "poulette",
      0.035
    ],
    [
      "coco",
      0.035
    ],
    [
      "caille",
      0.035
    ],
    [
      "braisiere",
      0.035
    ],
    [
      "biquette",
      0.035
    ],
    [
      "autocuiseur",
      0.035
    ],
    [
      "putain",
      0.035
    ]
  ],
  "bati": [
    [
      "armature",
      0.085
    ],
    [
      "carcasse",
      0.085
    ],
    [
      "charpente",
      0.085
    ],
    [
      "constitue",
      0.085
    ],
    [
      "fait",
      0.085
    ],
    [
      "organise",
      0.055
    ],
    [
      "foutu",
      0.055
    ],
    [
      "decouple",
      0.055
    ],
    [
      "charpente",
      0.055
    ],
    [
      "support",
      0.0275
    ],
    [
      "fichu",
      0.0275
    ],
    [
      "faufilure",
      0.0275
    ],
    [
      "faufil",
      0.0275
    ],
    [
      "conforme",
      0.0275
    ],
    [
      "chassis",
      0.0275
    ],
    [
      "carrosserie",
      0.0275
    ],
    [
      "cadre",
      0.0275
    ],
    [
      "assemblage",
      0.0275
    ],
    [
      "taille",
      0.0275
    ]
  ],
  "opalin": [
    [
      "blanc",
      0.23
    ],
    [
      "blanchatre",
      0.23
    ],
    [
      "iridescent",
      0.075
    ],
    [
      "irise",
      0.075
    ],
    [
      "ivoirin",
      0.075
    ],
    [
      "laiteux",
      0.075
    ],
    [
      "nacre",
      0.075
    ],
    [
      "opalescent",
      0.075
    ],
    [
      "pale",
      0.075
    ]
  ],
  "ruban": [
    [
      "bande",
      0.095
    ],
    [
      "cordon",
      0.095
    ],
    [
      "galon",
      0.0775
    ],
    [
      "passement",
      0.0575
    ],
    [
      "jarretelle",
      0.0375
    ],
    [
      "insigne",
      0.0375
    ],
    [
      "decoration",
      0.0375
    ],
    [
      "cordonnet",
      0.0375
    ],
    [
      "coque",
      0.0375
    ],
    [
      "coiffure",
      0.0375
    ],
    [
      "bouffette",
      0.0375
    ],
    [
      "attache",
      0.0375
    ],
    [
      "ganse",
      0.0175
    ],
    [
      "lisere",
      0.0175
    ],
    [
      "passementerie",
      0.0175
    ],
    [
      "rosette",
      0.0175
    ],
    [
      "route",
      0.0175
    ],
    [
      "trajet",
      0.0175
    ],
    [
      "trottoir",
      0.0175
    ],
    [
      "faveur",
      0.0175
    ],
    [
      "cocarde",
      0.0175
    ],
    [
      "barre",
      0.0175
    ],
    [
      "bavolet",
      0.0175
    ],
    [
      "bobine",
      0.0175
    ],
    [
      "bourdalou",
      0.0175
    ],
    [
      "brassard",
      0.0175
    ],
    [
      "catogan",
      0.0175
    ],
    [
      "chemin",
      0.0175
    ],
    [
      "chou",
      0.0175
    ],
    [
      "virginite",
      0.0175
    ]
  ],
  "grotte": [
    [
      "caverne",
      0.1775
    ],
    [
      "excavation",
      0.105
    ],
    [
      "souterrain",
      0.0875
    ],
    [
      "trou",
      0.0875
    ],
    [
      "cavite",
      0.07
    ],
    [
      "taniere",
      0.0525
    ],
    [
      "repaire",
      0.0525
    ],
    [
      "renfoncement",
      0.0525
    ],
    [
      "antre",
      0.0525
    ],
    [
      "terrier",
      0.035
    ],
    [
      "retraite",
      0.035
    ],
    [
      "crypte",
      0.035
    ],
    [
      "cave",
      0.035
    ],
    [
      "catacombe",
      0.035
    ],
    [
      "baume",
      0.0175
    ],
    [
      "refuge",
      0.0175
    ],
    [
      "rocaille",
      0.0175
    ]
  ],
  "sabot": [
    [
      "chaussure",
      0.18
    ],
    [
      "patin",
      0.18
    ],
    [
      "soulier",
      0.18
    ],
    [
      "galoche",
      0.09
    ],
    [
      "maladroit",
      0.09
    ],
    [
      "salete",
      0.09
    ],
    [
      "socque",
      0.09
    ],
    [
      "toupie",
      0.09
    ]
  ],
  "evoluer": [
    [
      "changer",
      0.13
    ],
    [
      "marcher",
      0.0925
    ],
    [
      "passer",
      0.0925
    ],
    [
      "tourner",
      0.055
    ],
    [
      "glisser",
      0.055
    ],
    [
      "aller",
      0.055
    ],
    [
      "progresser",
      0.035
    ],
    [
      "naviguer",
      0.035
    ],
    [
      "deambuler",
      0.035
    ],
    [
      "devenir",
      0.035
    ],
    [
      "varier",
      0.0175
    ],
    [
      "manoeuvrer",
      0.0175
    ],
    [
      "innover",
      0.0175
    ],
    [
      "virevolter",
      0.0175
    ]
  ],
  "glacier": [
    [
      "langue",
      0.2
    ],
    [
      "miroitier",
      0.2
    ],
    [
      "neve",
      0.2
    ],
    [
      "serac",
      0.2
    ]
  ],
  "percher": [
    [
      "demeurer",
      0.095
    ],
    [
      "jucher",
      0.095
    ],
    [
      "loger",
      0.095
    ],
    [
      "nicher",
      0.095
    ],
    [
      "placer",
      0.095
    ],
    [
      "resider",
      0.045
    ],
    [
      "poser",
      0.045
    ],
    [
      "habiter",
      0.045
    ],
    [
      "brancher",
      0.045
    ],
    [
      "accrocher",
      0.045
    ],
    [
      "suspendre",
      0.045
    ]
  ],
  "ozone": [],
  "etui": [
    [
      "boite",
      0.165
    ],
    [
      "enveloppe",
      0.165
    ],
    [
      "trousse",
      0.125
    ],
    [
      "emballage",
      0.0825
    ],
    [
      "necessaire",
      0.0825
    ],
    [
      "ecrin",
      0.0825
    ],
    [
      "housse",
      0.04
    ],
    [
      "gaine",
      0.04
    ],
    [
      "fourreau",
      0.04
    ],
    [
      "douille",
      0.04
    ],
    [
      "boitier",
      0.04
    ],
    [
      "botte",
      0.04
    ],
    [
      "portefeuille",
      0.04
    ]
  ],
  "penien": [
    [
      "phallique",
      1.0
    ]
  ],
  "reportage": [
    [
      "article",
      0.3325
    ],
    [
      "chronique",
      0.3325
    ],
    [
      "correspondance",
      0.165
    ],
    [
      "interview",
      0.165
    ]
  ],
  "bol": [
    [
      "pot",
      0.2
    ],
    [
      "jatte",
      0.1325
    ],
    [
      "cul",
      0.1
    ],
    [
      "veine",
      0.065
    ],
    [
      "recipient",
      0.065
    ],
    [
      "fessier",
      0.065
    ],
    [
      "anus",
      0.065
    ],
    [
      "tasse",
      0.0325
    ],
    [
      "pilule",
      0.0325
    ],
    [
      "ocre",
      0.0325
    ],
    [
      "faience",
      0.0325
    ],
    [
      "coupe",
      0.0325
    ],
    [
      "bolee",
      0.0325
    ],
    [
      "bolaire",
      0.0325
    ],
    [
      "bock",
      0.0325
    ],
    [
      "electuaire",
      0.0325
    ]
  ],
  "gotha": [
    [
      "almanach",
      0.5
    ],
    [
      "annuaire",
      0.5
    ]
  ],
  "beta": [
    [
      "bete",
      0.195
    ],
    [
      "sot",
      0.11
    ],
    [
      "ballot",
      0.0925
    ],
    [
      "niais",
      0.09
    ],
    [
      "nigaud",
      0.0475
    ],
    [
      "benet",
      0.035
    ],
    [
      "balourd",
      0.0325
    ],
    [
      "gourde",
      0.0275
    ],
    [
      "gauche",
      0.0275
    ],
    [
      "cruche",
      0.0275
    ],
    [
      "godiche",
      0.02
    ],
    [
      "idiot",
      0.02
    ],
    [
      "ane",
      0.02
    ],
    [
      "cornichon",
      0.0175
    ],
    [
      "dadais",
      0.015
    ],
    [
      "empote",
      0.0125
    ],
    [
      "lourdaud",
      0.0125
    ],
    [
      "buse",
      0.0075
    ],
    [
      "becasse",
      0.0075
    ],
    [
      "corniaud",
      0.0075
    ],
    [
      "nouille",
      0.0075
    ],
    [
      "godichon",
      0.005
    ],
    [
      "gourdiflot",
      0.005
    ],
    [
      "inepte",
      0.005
    ],
    [
      "innocent",
      0.005
    ],
    [
      "jocrisse",
      0.005
    ],
    [
      "moule",
      0.005
    ],
    [
      "cruchon",
      0.005
    ],
    [
      "couillon",
      0.005
    ],
    [
      "andouille",
      0.005
    ],
    [
      "baudet",
      0.005
    ],
    [
      "bourrique",
      0.005
    ],
    [
      "betasse",
      0.005
    ],
    [
      "con",
      0.005
    ],
    [
      "connard",
      0.005
    ],
    [
      "patate",
      0.0025
    ],
    [
      "panouille",
      0.0025
    ],
    [
      "niquedouille",
      0.0025
    ],
    [
      "lourdingue",
      0.0025
    ],
    [
      "jobard",
      0.0025
    ],
    [
      "fruste",
      0.0025
    ],
    [
      "finassaud",
      0.0025
    ],
    [
      "betassot",
      0.0025
    ],
    [
      "becassot",
      0.0025
    ],
    [
      "bebete",
      0.0025
    ],
    [
      "bourricot",
      0.0025
    ],
    [
      "balluchon",
      0.0025
    ],
    [
      "balluche",
      0.0025
    ],
    [
      "serin",
      0.0025
    ]
  ],
  "moderniser": [
    [
      "renover",
      0.2725
    ],
    [
      "rajeunir",
      0.18
    ],
    [
      "transformer",
      0.18
    ],
    [
      "actualiser",
      0.09
    ],
    [
      "adapter",
      0.09
    ],
    [
      "reformer",
      0.09
    ],
    [
      "reparer",
      0.09
    ]
  ],
  "terrier": [
    [
      "repaire",
      0.15
    ],
    [
      "taniere",
      0.15
    ],
    [
      "abri",
      0.12
    ],
    [
      "cache",
      0.09
    ],
    [
      "caverne",
      0.09
    ],
    [
      "trou",
      0.09
    ],
    [
      "gite",
      0.06
    ],
    [
      "grotte",
      0.06
    ],
    [
      "airedale",
      0.03
    ],
    [
      "cachette",
      0.03
    ],
    [
      "rabouillere",
      0.03
    ],
    [
      "souterrain",
      0.03
    ]
  ],
  "insecte": [
    [
      "bestiole",
      0.5
    ],
    [
      "hexapode",
      0.5
    ]
  ],
  "mammifere": [
    [
      "placentaire",
      0.5
    ],
    [
      "tetrapode",
      0.5
    ]
  ],
  "definir": [
    [
      "determiner",
      0.1675
    ],
    [
      "fixer",
      0.1675
    ],
    [
      "indiquer",
      0.125
    ],
    [
      "preciser",
      0.125
    ],
    [
      "delimiter",
      0.0825
    ],
    [
      "specifier",
      0.0825
    ],
    [
      "predefinir",
      0.04
    ],
    [
      "expliquer",
      0.04
    ],
    [
      "decider",
      0.04
    ],
    [
      "circonscrire",
      0.04
    ],
    [
      "caracteriser",
      0.04
    ],
    [
      "trancher",
      0.04
    ]
  ],
  "delegue": [
    [
      "commettre",
      0.16
    ],
    [
      "transmettre",
      0.12
    ],
    [
      "preposer",
      0.08
    ],
    [
      "mandater",
      0.08
    ],
    [
      "leguer",
      0.08
    ],
    [
      "envoyer",
      0.08
    ],
    [
      "depecher",
      0.08
    ],
    [
      "deputer",
      0.08
    ],
    [
      "confier",
      0.08
    ],
    [
      "charger",
      0.04
    ],
    [
      "designer",
      0.04
    ],
    [
      "detacher",
      0.04
    ],
    [
      "transferer",
      0.04
    ]
  ],
  "deleguer": [
    [
      "commettre",
      0.16
    ],
    [
      "transmettre",
      0.12
    ],
    [
      "preposer",
      0.08
    ],
    [
      "mandater",
      0.08
    ],
    [
      "leguer",
      0.08
    ],
    [
      "envoyer",
      0.08
    ],
    [
      "depecher",
      0.08
    ],
    [
      "deputer",
      0.08
    ],
    [
      "confier",
      0.08
    ],
    [
      "charger",
      0.04
    ],
    [
      "designer",
      0.04
    ],
    [
      "detacher",
      0.04
    ],
    [
      "transferer",
      0.04
    ]
  ],
  "euphemisme": [
    [
      "antiphrase",
      0.1675
    ],
    [
      "contreverite",
      0.1675
    ],
    [
      "litote",
      0.1675
    ],
    [
      "adoucissement",
      0.0825
    ],
    [
      "expression",
      0.0825
    ],
    [
      "mensonge",
      0.0825
    ],
    [
      "pudeur",
      0.0825
    ],
    [
      "periphrase",
      0.0825
    ]
  ],
  "culture": [
    [
      "instruction",
      0.1225
    ],
    [
      "savoir",
      0.1025
    ],
    [
      "plantation",
      0.0825
    ],
    [
      "bagage",
      0.06
    ],
    [
      "jardinage",
      0.06
    ],
    [
      "erudition",
      0.04
    ],
    [
      "education",
      0.04
    ],
    [
      "societe",
      0.04
    ],
    [
      "humanisme",
      0.04
    ],
    [
      "formation",
      0.04
    ],
    [
      "connaissance",
      0.04
    ],
    [
      "colonie",
      0.04
    ],
    [
      "civilisation",
      0.04
    ],
    [
      "science",
      0.0175
    ],
    [
      "marais",
      0.0175
    ],
    [
      "lettres",
      0.0175
    ],
    [
      "lecture",
      0.0175
    ],
    [
      "finesse",
      0.0175
    ],
    [
      "exploitation",
      0.0175
    ],
    [
      "esprit",
      0.0175
    ],
    [
      "champ",
      0.0175
    ],
    [
      "ameublissement",
      0.0175
    ],
    [
      "amendement",
      0.0175
    ],
    [
      "agriculture",
      0.0175
    ],
    [
      "vegetation",
      0.0175
    ]
  ],
  "helico": [
    [
      "helicoptere",
      1.0
    ]
  ],
  "police": [
    [
      "ordre",
      0.12
    ],
    [
      "type",
      0.08
    ],
    [
      "surete",
      0.08
    ],
    [
      "securite",
      0.08
    ],
    [
      "gouvernement",
      0.08
    ],
    [
      "assurance",
      0.08
    ],
    [
      "poulaille",
      0.04
    ],
    [
      "politique",
      0.04
    ],
    [
      "milice",
      0.04
    ],
    [
      "marechaussee",
      0.04
    ],
    [
      "justice",
      0.04
    ],
    [
      "fonte",
      0.04
    ],
    [
      "discipline",
      0.04
    ],
    [
      "contrat",
      0.04
    ],
    [
      "administration",
      0.04
    ],
    [
      "rousse",
      0.04
    ]
  ],
  "policer": [
    [
      "civiliser",
      0.165
    ],
    [
      "polir",
      0.165
    ],
    [
      "adoucir",
      0.11
    ],
    [
      "former",
      0.11
    ],
    [
      "eduquer",
      0.11
    ],
    [
      "regir",
      0.055
    ],
    [
      "raffiner",
      0.055
    ],
    [
      "organiser",
      0.055
    ],
    [
      "humaniser",
      0.055
    ],
    [
      "corriger",
      0.055
    ],
    [
      "reglementer",
      0.055
    ]
  ],
  "jaguar": [
    [
      "couguar",
      0.5
    ],
    [
      "panthere",
      0.5
    ]
  ],
  "arbuste": [
    [
      "arbre",
      0.25
    ],
    [
      "arbrisseau",
      0.25
    ],
    [
      "broussaille",
      0.25
    ],
    [
      "plante",
      0.25
    ]
  ],
  "penis": [
    [
      "verge",
      0.2075
    ],
    [
      "sexe",
      0.1675
    ],
    [
      "queue",
      0.1225
    ],
    [
      "bite",
      0.0825
    ],
    [
      "phallus",
      0.0825
    ],
    [
      "zizi",
      0.04
    ],
    [
      "outil",
      0.04
    ],
    [
      "organe",
      0.04
    ],
    [
      "ithyphalle",
      0.04
    ],
    [
      "biroute",
      0.04
    ],
    [
      "asperge",
      0.04
    ],
    [
      "zob",
      0.04
    ]
  ],
  "buche": [
    [
      "bois",
      0.135
    ],
    [
      "bete",
      0.11
    ],
    [
      "ballot",
      0.08
    ],
    [
      "billot",
      0.08
    ],
    [
      "rondin",
      0.0525
    ],
    [
      "cruche",
      0.0525
    ],
    [
      "cornichon",
      0.0525
    ],
    [
      "baton",
      0.0525
    ],
    [
      "tronce",
      0.025
    ],
    [
      "souche",
      0.025
    ],
    [
      "lourdaud",
      0.025
    ],
    [
      "gourde",
      0.025
    ],
    [
      "chute",
      0.025
    ],
    [
      "charbonnette",
      0.025
    ],
    [
      "buchette",
      0.025
    ],
    [
      "briquette",
      0.025
    ],
    [
      "branche",
      0.025
    ],
    [
      "boulet",
      0.025
    ],
    [
      "bille",
      0.025
    ],
    [
      "balourd",
      0.025
    ],
    [
      "accident",
      0.025
    ],
    [
      "tronche",
      0.025
    ]
  ],
  "bucher": [
    [
      "feu",
      0.2725
    ],
    [
      "appentis",
      0.09
    ],
    [
      "autodafe",
      0.09
    ],
    [
      "bois",
      0.09
    ],
    [
      "brulement",
      0.09
    ],
    [
      "cave",
      0.09
    ],
    [
      "condamnation",
      0.09
    ],
    [
      "flamme",
      0.09
    ],
    [
      "resserre",
      0.09
    ]
  ],
  "perruche": [
    [
      "artimon",
      0.5
    ],
    [
      "pimbeche",
      0.5
    ]
  ],
  "deluge": [
    [
      "debordement",
      0.0975
    ],
    [
      "flot",
      0.0975
    ],
    [
      "affluence",
      0.0875
    ],
    [
      "avalanche",
      0.0875
    ],
    [
      "multitude",
      0.0875
    ],
    [
      "pluie",
      0.08
    ],
    [
      "abondance",
      0.07
    ],
    [
      "quantite",
      0.06
    ],
    [
      "inondation",
      0.0525
    ],
    [
      "profusion",
      0.0425
    ],
    [
      "cataracte",
      0.025
    ],
    [
      "torrent",
      0.025
    ],
    [
      "mer",
      0.0175
    ],
    [
      "luxe",
      0.0175
    ],
    [
      "grele",
      0.0175
    ],
    [
      "bordee",
      0.0175
    ],
    [
      "averse",
      0.0175
    ],
    [
      "surcharge",
      0.0075
    ],
    [
      "proliferation",
      0.0075
    ],
    [
      "potee",
      0.0075
    ],
    [
      "orage",
      0.0075
    ],
    [
      "ocean",
      0.0075
    ],
    [
      "incursion",
      0.0075
    ],
    [
      "flux",
      0.0075
    ],
    [
      "deferlement",
      0.0075
    ],
    [
      "cataclysme",
      0.0075
    ]
  ],
  "insu": [
    [
      "inconnu",
      1.0
    ]
  ],
  "brutal": [
    [
      "dur",
      0.0875
    ],
    [
      "rude",
      0.0775
    ],
    [
      "violent",
      0.07
    ],
    [
      "grossier",
      0.0475
    ],
    [
      "cru",
      0.0475
    ],
    [
      "brusque",
      0.0475
    ],
    [
      "bourru",
      0.0475
    ],
    [
      "cruel",
      0.0425
    ],
    [
      "terrible",
      0.035
    ],
    [
      "vif",
      0.035
    ],
    [
      "mauvais",
      0.03
    ],
    [
      "apre",
      0.0275
    ],
    [
      "severe",
      0.0275
    ],
    [
      "abrupt",
      0.0275
    ],
    [
      "barbare",
      0.0225
    ],
    [
      "rapide",
      0.0225
    ],
    [
      "sec",
      0.0225
    ],
    [
      "fort",
      0.0175
    ],
    [
      "feroce",
      0.0175
    ],
    [
      "mechant",
      0.015
    ],
    [
      "implacable",
      0.015
    ],
    [
      "brut",
      0.015
    ],
    [
      "bestial",
      0.015
    ],
    [
      "subit",
      0.01
    ],
    [
      "franc",
      0.01
    ],
    [
      "choquant",
      0.01
    ],
    [
      "bref",
      0.01
    ],
    [
      "vert",
      0.005
    ],
    [
      "instantane",
      0.005
    ],
    [
      "impoli",
      0.005
    ],
    [
      "foudroyant",
      0.005
    ],
    [
      "entier",
      0.005
    ],
    [
      "emporte",
      0.005
    ],
    [
      "direct",
      0.005
    ],
    [
      "agressif",
      0.005
    ],
    [
      "animal",
      0.005
    ],
    [
      "bas",
      0.005
    ],
    [
      "brute",
      0.005
    ],
    [
      "cinglant",
      0.005
    ],
    [
      "muscle",
      0.0025
    ],
    [
      "mufle",
      0.0025
    ],
    [
      "materiel",
      0.0025
    ],
    [
      "irascible",
      0.0025
    ],
    [
      "inabordable",
      0.0025
    ],
    [
      "cynique",
      0.0025
    ],
    [
      "carabine",
      0.0025
    ],
    [
      "accidentel",
      0.0025
    ]
  ],
  "demoder": [],
  "demode": [
    [
      "suranne",
      0.12
    ],
    [
      "vieux",
      0.11
    ],
    [
      "desuet",
      0.0975
    ],
    [
      "antique",
      0.0625
    ],
    [
      "perime",
      0.0625
    ],
    [
      "vieillot",
      0.06
    ],
    [
      "vieilli",
      0.045
    ],
    [
      "vetuste",
      0.045
    ],
    [
      "archaique",
      0.0425
    ],
    [
      "ancien",
      0.0375
    ],
    [
      "arriere",
      0.0375
    ],
    [
      "use",
      0.0375
    ],
    [
      "depasse",
      0.025
    ],
    [
      "rococo",
      0.025
    ],
    [
      "caduc",
      0.02
    ],
    [
      "passe",
      0.02
    ],
    [
      "attarde",
      0.0175
    ],
    [
      "anachronique",
      0.0175
    ],
    [
      "poussiereux",
      0.0125
    ],
    [
      "antediluvien",
      0.01
    ],
    [
      "fossile",
      0.01
    ],
    [
      "usage",
      0.0075
    ],
    [
      "vieillissant",
      0.0075
    ],
    [
      "age",
      0.0075
    ],
    [
      "retarde",
      0.005
    ],
    [
      "amorti",
      0.005
    ],
    [
      "academique",
      0.0025
    ],
    [
      "obsolete",
      0.0025
    ],
    [
      "prehistorique",
      0.0025
    ],
    [
      "reactionnaire",
      0.0025
    ],
    [
      "retro",
      0.0025
    ],
    [
      "traditionaliste",
      0.0025
    ]
  ],
  "bottine": [
    [
      "botte",
      0.2375
    ],
    [
      "chaussure",
      0.2375
    ],
    [
      "bottillon",
      0.1425
    ],
    [
      "brodequin",
      0.095
    ],
    [
      "soulier",
      0.095
    ],
    [
      "boots",
      0.0475
    ]
  ],
  "bouter": [
    [
      "battre",
      0.1325
    ],
    [
      "bousculer",
      0.1325
    ],
    [
      "chasser",
      0.1325
    ],
    [
      "pousser",
      0.1325
    ],
    [
      "refouler",
      0.1325
    ],
    [
      "repousser",
      0.1325
    ],
    [
      "allumer",
      0.065
    ],
    [
      "mettre",
      0.065
    ],
    [
      "placer",
      0.065
    ]
  ],
  "bouton": [
    [
      "pustule",
      0.15
    ],
    [
      "tumeur",
      0.09
    ],
    [
      "ampoule",
      0.06
    ],
    [
      "bourgeon",
      0.06
    ],
    [
      "vesicule",
      0.06
    ],
    [
      "interrupteur",
      0.03
    ],
    [
      "loquet",
      0.03
    ],
    [
      "mamelon",
      0.03
    ],
    [
      "oeil",
      0.03
    ],
    [
      "poignee",
      0.03
    ],
    [
      "pression",
      0.03
    ],
    [
      "scrofule",
      0.03
    ],
    [
      "urtication",
      0.03
    ],
    [
      "furoncle",
      0.03
    ],
    [
      "excoriation",
      0.03
    ],
    [
      "acne",
      0.03
    ],
    [
      "attache",
      0.03
    ],
    [
      "bube",
      0.03
    ],
    [
      "chancre",
      0.03
    ],
    [
      "clitoris",
      0.03
    ],
    [
      "commutateur",
      0.03
    ],
    [
      "dose",
      0.03
    ],
    [
      "verole",
      0.03
    ]
  ],
  "cloche": [
    [
      "clochette",
      0.085
    ],
    [
      "sonnette",
      0.07
    ],
    [
      "clochard",
      0.055
    ],
    [
      "vagabond",
      0.0425
    ],
    [
      "sonnailles",
      0.0425
    ],
    [
      "grelot",
      0.0425
    ],
    [
      "appel",
      0.0425
    ],
    [
      "timbre",
      0.0275
    ],
    [
      "sonnerie",
      0.0275
    ],
    [
      "sonnaille",
      0.0275
    ],
    [
      "protection",
      0.0275
    ],
    [
      "mendiant",
      0.0275
    ],
    [
      "idiot",
      0.0275
    ],
    [
      "couvercle",
      0.0275
    ],
    [
      "clodo",
      0.0275
    ],
    [
      "clarine",
      0.0275
    ],
    [
      "chapeau",
      0.0275
    ],
    [
      "campane",
      0.0275
    ],
    [
      "bete",
      0.0275
    ],
    [
      "abri",
      0.0275
    ],
    [
      "clopinard",
      0.0125
    ],
    [
      "cloque",
      0.0125
    ],
    [
      "jacques",
      0.0125
    ],
    [
      "miserable",
      0.0125
    ],
    [
      "niais",
      0.0125
    ],
    [
      "signal",
      0.0125
    ],
    [
      "tarte",
      0.0125
    ],
    [
      "carillon",
      0.0125
    ],
    [
      "campagne",
      0.0125
    ],
    [
      "caisson",
      0.0125
    ],
    [
      "beliere",
      0.0125
    ],
    [
      "bronze",
      0.0125
    ],
    [
      "boursouflure",
      0.0125
    ],
    [
      "bourdon",
      0.0125
    ],
    [
      "beffroi",
      0.0125
    ],
    [
      "ampoule",
      0.0125
    ],
    [
      "airain",
      0.0125
    ],
    [
      "truand",
      0.0125
    ]
  ],
  "gigue": [
    [
      "cuisse",
      0.22
    ],
    [
      "gigot",
      0.22
    ],
    [
      "bringue",
      0.11
    ],
    [
      "cuissot",
      0.11
    ],
    [
      "danse",
      0.11
    ],
    [
      "geant",
      0.11
    ],
    [
      "jambe",
      0.11
    ]
  ],
  "natte": [
    [
      "coiffure",
      0.1425
    ],
    [
      "tapis",
      0.1425
    ],
    [
      "torsade",
      0.1425
    ],
    [
      "paillet",
      0.07
    ],
    [
      "paillasson",
      0.07
    ],
    [
      "natte",
      0.07
    ],
    [
      "nattier",
      0.07
    ],
    [
      "macaron",
      0.07
    ],
    [
      "lit",
      0.07
    ],
    [
      "garniture",
      0.07
    ],
    [
      "tresse",
      0.07
    ]
  ],
  "daigner": [
    [
      "accepter",
      0.1775
    ],
    [
      "acquiescer",
      0.105
    ],
    [
      "admettre",
      0.105
    ],
    [
      "consentir",
      0.105
    ],
    [
      "permettre",
      0.105
    ],
    [
      "tolerer",
      0.07
    ],
    [
      "condescendre",
      0.07
    ],
    [
      "autoriser",
      0.07
    ],
    [
      "agreer",
      0.035
    ],
    [
      "s'abaisser",
      0.035
    ],
    [
      "vouloir",
      0.035
    ]
  ],
  "variation": [
    [
      "changement",
      0.24
    ],
    [
      "oscillation",
      0.0725
    ],
    [
      "fluctuation",
      0.0625
    ],
    [
      "retour",
      0.0625
    ],
    [
      "mouvement",
      0.0525
    ],
    [
      "evolution",
      0.035
    ],
    [
      "saute",
      0.035
    ],
    [
      "instabilite",
      0.035
    ],
    [
      "difference",
      0.035
    ],
    [
      "caprice",
      0.035
    ],
    [
      "inegalite",
      0.025
    ],
    [
      "modification",
      0.025
    ],
    [
      "transformation",
      0.025
    ],
    [
      "vicissitude",
      0.025
    ],
    [
      "ecart",
      0.0175
    ],
    [
      "toquade",
      0.0175
    ],
    [
      "revirement",
      0.0175
    ],
    [
      "remous",
      0.0175
    ],
    [
      "amplitude",
      0.0175
    ],
    [
      "alternative",
      0.0175
    ],
    [
      "alternance",
      0.0175
    ],
    [
      "repetition",
      0.0075
    ],
    [
      "retournement",
      0.0075
    ],
    [
      "nutation",
      0.0075
    ],
    [
      "mutation",
      0.0075
    ],
    [
      "innovation",
      0.0075
    ],
    [
      "deviation",
      0.0075
    ],
    [
      "chant",
      0.0075
    ],
    [
      "bifurcation",
      0.0075
    ],
    [
      "variete",
      0.0075
    ]
  ],
  "assembler": [
    [
      "reunir",
      0.105
    ],
    [
      "joindre",
      0.0775
    ],
    [
      "unir",
      0.065
    ],
    [
      "attacher",
      0.04
    ],
    [
      "associer",
      0.0375
    ],
    [
      "combiner",
      0.0375
    ],
    [
      "rassembler",
      0.0325
    ],
    [
      "lier",
      0.0275
    ],
    [
      "accorder",
      0.0225
    ],
    [
      "amasser",
      0.02
    ],
    [
      "fusionner",
      0.02
    ],
    [
      "grouper",
      0.0175
    ],
    [
      "allier",
      0.0175
    ],
    [
      "ajuster",
      0.0175
    ],
    [
      "accoupler",
      0.015
    ],
    [
      "adapter",
      0.015
    ],
    [
      "assortir",
      0.015
    ],
    [
      "relier",
      0.0125
    ],
    [
      "melanger",
      0.0125
    ],
    [
      "fixer",
      0.0125
    ],
    [
      "arranger",
      0.0125
    ],
    [
      "agglomerer",
      0.0125
    ],
    [
      "rapprocher",
      0.01
    ],
    [
      "river",
      0.01
    ],
    [
      "harmoniser",
      0.01
    ],
    [
      "disposer",
      0.01
    ],
    [
      "appareiller",
      0.01
    ],
    [
      "accoler",
      0.01
    ],
    [
      "monter",
      0.0075
    ],
    [
      "marier",
      0.0075
    ],
    [
      "arrimer",
      0.0075
    ],
    [
      "accumuler",
      0.0075
    ],
    [
      "composer",
      0.0075
    ],
    [
      "concentrer",
      0.0075
    ],
    [
      "ramasser",
      0.0075
    ],
    [
      "visser",
      0.005
    ],
    [
      "lever",
      0.005
    ],
    [
      "juxtaposer",
      0.005
    ],
    [
      "entasser",
      0.005
    ],
    [
      "coller",
      0.005
    ],
    [
      "aboucher",
      0.005
    ],
    [
      "souder",
      0.005
    ],
    [
      "serrer",
      0.005
    ],
    [
      "masser",
      0.005
    ],
    [
      "former",
      0.005
    ],
    [
      "emboiter",
      0.005
    ],
    [
      "construire",
      0.005
    ],
    [
      "conglomerer",
      0.005
    ],
    [
      "batir",
      0.005
    ],
    [
      "appliquer",
      0.005
    ],
    [
      "agreger",
      0.005
    ],
    [
      "sertir",
      0.0025
    ],
    [
      "recueillir",
      0.0025
    ],
    [
      "rallier",
      0.0025
    ],
    [
      "raccorder",
      0.0025
    ],
    [
      "enchasser",
      0.0025
    ],
    [
      "coudre",
      0.0025
    ],
    [
      "collectionner",
      0.0025
    ],
    [
      "boulonner",
      0.0025
    ],
    [
      "agrafer",
      0.0025
    ],
    [
      "goupiller",
      0.0
    ],
    [
      "jointoyer",
      0.0
    ],
    [
      "maintenir",
      0.0
    ],
    [
      "mobiliser",
      0.0
    ],
    [
      "sceller",
      0.0
    ],
    [
      "tresser",
      0.0
    ],
    [
      "federer",
      0.0
    ],
    [
      "enter",
      0.0
    ],
    [
      "embrever",
      0.0
    ],
    [
      "articuler",
      0.0
    ],
    [
      "attrouper",
      0.0
    ],
    [
      "botteler",
      0.0
    ],
    [
      "cheviller",
      0.0
    ],
    [
      "coordonner",
      0.0
    ],
    [
      "coupler",
      0.0
    ],
    [
      "empatter",
      0.0
    ],
    [
      "encastrer",
      0.0
    ],
    [
      "enchevetrer",
      0.0
    ],
    [
      "goujonner",
      0.0
    ],
    [
      "geminer",
      0.0
    ],
    [
      "riveter",
      0.0
    ],
    [
      "emmortaiser",
      0.0
    ],
    [
      "convoquer",
      0.0
    ],
    [
      "conglober",
      0.0
    ],
    [
      "collecter",
      0.0
    ],
    [
      "clouer",
      0.0
    ],
    [
      "claveter",
      0.0
    ],
    [
      "brocher",
      0.0
    ],
    [
      "abouter",
      0.0
    ],
    [
      "totaliser",
      0.0
    ]
  ],
  "pirate": [
    [
      "voleur",
      0.145
    ],
    [
      "bandit",
      0.1125
    ],
    [
      "corsaire",
      0.1
    ],
    [
      "forban",
      0.09
    ],
    [
      "flibustier",
      0.065
    ],
    [
      "escroc",
      0.065
    ],
    [
      "pillard",
      0.055
    ],
    [
      "brigand",
      0.0425
    ],
    [
      "fripon",
      0.0425
    ],
    [
      "fripouille",
      0.0425
    ],
    [
      "ecumeur",
      0.0325
    ],
    [
      "requin",
      0.0325
    ],
    [
      "filou",
      0.0325
    ],
    [
      "boucanier",
      0.02
    ],
    [
      "plagiaire",
      0.02
    ],
    [
      "vautour",
      0.01
    ],
    [
      "terreur",
      0.01
    ],
    [
      "marin",
      0.01
    ],
    [
      "intrigant",
      0.01
    ],
    [
      "aigrefin",
      0.01
    ]
  ],
  "asteroide": [
    [
      "meteore",
      0.22
    ],
    [
      "astre",
      0.11
    ],
    [
      "astroide",
      0.11
    ],
    [
      "asteride",
      0.11
    ],
    [
      "aerolithe",
      0.11
    ],
    [
      "bolide",
      0.11
    ],
    [
      "planetoide",
      0.11
    ]
  ],
  "mari": [
    [
      "epoux",
      0.5
    ],
    [
      "conjoint",
      0.25
    ],
    [
      "homme",
      0.25
    ]
  ],
  "ether": [
    [
      "air",
      0.2
    ],
    [
      "ciel",
      0.2
    ],
    [
      "atmosphere",
      0.1325
    ],
    [
      "espace",
      0.1325
    ],
    [
      "azur",
      0.065
    ],
    [
      "collodion",
      0.065
    ],
    [
      "ester",
      0.065
    ],
    [
      "infini",
      0.065
    ],
    [
      "ame",
      0.065
    ]
  ],
  "vaisseau": [
    [
      "bateau",
      0.1575
    ],
    [
      "contenant",
      0.105
    ],
    [
      "navire",
      0.105
    ],
    [
      "vase",
      0.105
    ],
    [
      "vaisselle",
      0.0525
    ],
    [
      "tube",
      0.0525
    ],
    [
      "recipient",
      0.0525
    ],
    [
      "nef",
      0.0525
    ],
    [
      "coupe",
      0.0525
    ],
    [
      "caravelle",
      0.0525
    ],
    [
      "capillaire",
      0.0525
    ],
    [
      "batiment",
      0.0525
    ],
    [
      "artere",
      0.0525
    ],
    [
      "veine",
      0.0525
    ]
  ],
  "spatial": [
    [
      "aerospatial",
      0.3325
    ],
    [
      "cosmique",
      0.3325
    ],
    [
      "geographique",
      0.3325
    ]
  ],
  "comete": [
    [
      "astre",
      0.25
    ],
    [
      "brancard",
      0.25
    ],
    [
      "meteore",
      0.25
    ],
    [
      "vagabond",
      0.25
    ]
  ],
  "overdose": [
    [
      "surdosage",
      1.0
    ]
  ],
  "ployer": [
    [
      "plier",
      0.2025
    ],
    [
      "flechir",
      0.15
    ],
    [
      "ceder",
      0.08
    ],
    [
      "courber",
      0.0675
    ],
    [
      "s'incliner",
      0.0525
    ],
    [
      "soumettre",
      0.04
    ],
    [
      "incliner",
      0.04
    ],
    [
      "capituler",
      0.04
    ],
    [
      "succomber",
      0.025
    ],
    [
      "s'inflechir",
      0.025
    ],
    [
      "inflechir",
      0.025
    ],
    [
      "flancher",
      0.025
    ],
    [
      "faiblir",
      0.025
    ],
    [
      "accoutumer",
      0.025
    ],
    [
      "subordonner",
      0.0125
    ],
    [
      "s'humilier",
      0.0125
    ],
    [
      "s'affaisser",
      0.0125
    ],
    [
      "refluer",
      0.0125
    ],
    [
      "obeir",
      0.0125
    ],
    [
      "casser",
      0.0125
    ],
    [
      "cambrer",
      0.0125
    ],
    [
      "assujettir",
      0.0125
    ],
    [
      "adapter",
      0.0125
    ],
    [
      "tordre",
      0.0125
    ]
  ],
  "fardeau": [
    [
      "charge",
      0.1325
    ],
    [
      "poids",
      0.1325
    ],
    [
      "bat",
      0.0775
    ],
    [
      "faix",
      0.0775
    ],
    [
      "tourment",
      0.0775
    ],
    [
      "souci",
      0.05
    ],
    [
      "joug",
      0.05
    ],
    [
      "fret",
      0.05
    ],
    [
      "croix",
      0.05
    ],
    [
      "colis",
      0.05
    ],
    [
      "chargement",
      0.05
    ],
    [
      "boulet",
      0.05
    ],
    [
      "bagage",
      0.05
    ],
    [
      "ennui",
      0.025
    ],
    [
      "subordination",
      0.025
    ],
    [
      "surcharge",
      0.025
    ]
  ],
  "preambule": [
    [
      "introduction",
      0.11
    ],
    [
      "preface",
      0.11
    ],
    [
      "commencement",
      0.0975
    ],
    [
      "exorde",
      0.0675
    ],
    [
      "prelude",
      0.0675
    ],
    [
      "seuil",
      0.0675
    ],
    [
      "preliminaires",
      0.055
    ],
    [
      "prologue",
      0.055
    ],
    [
      "debut",
      0.055
    ],
    [
      "premices",
      0.04
    ],
    [
      "ebauche",
      0.0275
    ],
    [
      "preparation",
      0.0275
    ],
    [
      "prolegomenes",
      0.0275
    ],
    [
      "entree",
      0.0275
    ],
    [
      "prodrome",
      0.0125
    ],
    [
      "notice",
      0.0125
    ],
    [
      "liminaire",
      0.0125
    ],
    [
      "exposition",
      0.0125
    ],
    [
      "avis",
      0.0125
    ],
    [
      "avertissement",
      0.0125
    ],
    [
      "prealable",
      0.0125
    ]
  ],
  "basculer": [
    [
      "culbuter",
      0.21
    ],
    [
      "chavirer",
      0.1575
    ],
    [
      "renverser",
      0.105
    ],
    [
      "tomber",
      0.105
    ],
    [
      "verser",
      0.105
    ],
    [
      "pousser",
      0.0525
    ],
    [
      "chuter",
      0.0525
    ],
    [
      "chanceler",
      0.0525
    ],
    [
      "capoter",
      0.0525
    ],
    [
      "tituber",
      0.0525
    ]
  ],
  "bascule": [
    [
      "balance",
      0.1425
    ],
    [
      "balancement",
      0.095
    ],
    [
      "changement",
      0.095
    ],
    [
      "chute",
      0.095
    ],
    [
      "renversement",
      0.095
    ],
    [
      "romaine",
      0.0475
    ],
    [
      "retournement",
      0.0475
    ],
    [
      "guillotine",
      0.0475
    ],
    [
      "culbute",
      0.0475
    ],
    [
      "capotage",
      0.0475
    ],
    [
      "branloire",
      0.0475
    ],
    [
      "balancoire",
      0.0475
    ],
    [
      "tonneau",
      0.0475
    ]
  ],
  "senti": [
    [
      "percevoir",
      0.0575
    ],
    [
      "connaitre",
      0.0525
    ],
    [
      "puer",
      0.0525
    ],
    [
      "apercevoir",
      0.05
    ],
    [
      "deviner",
      0.045
    ],
    [
      "decouvrir",
      0.045
    ],
    [
      "flairer",
      0.045
    ],
    [
      "eprouver",
      0.0325
    ],
    [
      "exhaler",
      0.0325
    ],
    [
      "entendre",
      0.0325
    ],
    [
      "comprendre",
      0.0325
    ],
    [
      "discerner",
      0.0275
    ],
    [
      "penetrer",
      0.0275
    ],
    [
      "reveler",
      0.025
    ],
    [
      "remarquer",
      0.025
    ],
    [
      "pressentir",
      0.02
    ],
    [
      "subodorer",
      0.015
    ],
    [
      "subir",
      0.015
    ],
    [
      "souffrir",
      0.015
    ],
    [
      "ressentir",
      0.015
    ],
    [
      "respirer",
      0.015
    ],
    [
      "recevoir",
      0.015
    ],
    [
      "constater",
      0.015
    ],
    [
      "apprecier",
      0.015
    ],
    [
      "eventer",
      0.01
    ],
    [
      "renifler",
      0.01
    ],
    [
      "gouter",
      0.01
    ],
    [
      "empester",
      0.01
    ],
    [
      "degager",
      0.01
    ],
    [
      "trouver",
      0.0075
    ],
    [
      "suinter",
      0.0075
    ],
    [
      "schlinguer",
      0.0075
    ],
    [
      "odorer",
      0.0075
    ],
    [
      "halener",
      0.0075
    ],
    [
      "fleurer",
      0.0075
    ],
    [
      "encaisser",
      0.0075
    ],
    [
      "empuantir",
      0.0075
    ],
    [
      "cogner",
      0.0075
    ],
    [
      "cocotter",
      0.0075
    ],
    [
      "apparaitre",
      0.0075
    ],
    [
      "pifer",
      0.0025
    ],
    [
      "prevoir",
      0.0025
    ],
    [
      "savourer",
      0.0025
    ],
    [
      "soupconner",
      0.0025
    ],
    [
      "suer",
      0.0025
    ],
    [
      "taper",
      0.0025
    ],
    [
      "trahir",
      0.0025
    ],
    [
      "trouilloter",
      0.0025
    ],
    [
      "paraitre",
      0.0025
    ],
    [
      "musser",
      0.0025
    ],
    [
      "blairer",
      0.0025
    ],
    [
      "denoncer",
      0.0025
    ],
    [
      "embaumer",
      0.0025
    ],
    [
      "empoisonner",
      0.0025
    ],
    [
      "fouetter",
      0.0025
    ],
    [
      "gazouiller",
      0.0025
    ],
    [
      "hair",
      0.0025
    ],
    [
      "humer",
      0.0025
    ],
    [
      "indiquer",
      0.0025
    ]
  ],
  "repetition": [
    [
      "recommencement",
      0.0575
    ],
    [
      "reiteration",
      0.0375
    ],
    [
      "retour",
      0.0375
    ],
    [
      "reprise",
      0.0375
    ],
    [
      "renouvellement",
      0.0375
    ],
    [
      "rengaine",
      0.0375
    ],
    [
      "rabachage",
      0.0375
    ],
    [
      "pleonasme",
      0.0375
    ],
    [
      "tautologie",
      0.0275
    ],
    [
      "ritournelle",
      0.0275
    ],
    [
      "reproduction",
      0.0275
    ],
    [
      "refrain",
      0.0275
    ],
    [
      "redite",
      0.0275
    ],
    [
      "frequence",
      0.0275
    ],
    [
      "echo",
      0.0175
    ],
    [
      "recurrence",
      0.0175
    ],
    [
      "recidive",
      0.0175
    ],
    [
      "resucee",
      0.0175
    ],
    [
      "redoublement",
      0.0175
    ],
    [
      "redondance",
      0.0175
    ],
    [
      "periode",
      0.0175
    ],
    [
      "imitation",
      0.0175
    ],
    [
      "double",
      0.0175
    ],
    [
      "cours",
      0.0175
    ],
    [
      "copie",
      0.0175
    ],
    [
      "antienne",
      0.0175
    ],
    [
      "alliteration",
      0.0175
    ],
    [
      "rechute",
      0.0075
    ],
    [
      "radotage",
      0.0075
    ],
    [
      "rabacherie",
      0.0075
    ],
    [
      "perissologie",
      0.0075
    ],
    [
      "psittacisme",
      0.0075
    ],
    [
      "reduplication",
      0.0075
    ],
    [
      "replique",
      0.0075
    ],
    [
      "revision",
      0.0075
    ],
    [
      "scie",
      0.0075
    ],
    [
      "variation",
      0.0075
    ],
    [
      "epistrophe",
      0.0075
    ],
    [
      "etude",
      0.0075
    ],
    [
      "paronomase",
      0.0075
    ],
    [
      "metabole",
      0.0075
    ],
    [
      "marche",
      0.0075
    ],
    [
      "anaphore",
      0.0075
    ],
    [
      "antanaclase",
      0.0075
    ],
    [
      "assonance",
      0.0075
    ],
    [
      "battologie",
      0.0075
    ],
    [
      "cadence",
      0.0075
    ],
    [
      "complexion",
      0.0075
    ],
    [
      "cycle",
      0.0075
    ],
    [
      "doublon",
      0.0075
    ],
    [
      "homeoteleute",
      0.0075
    ],
    [
      "leitmotiv",
      0.0075
    ],
    [
      "lecon",
      0.0075
    ],
    [
      "accumulation",
      0.0075
    ]
  ],
  "etreindre": [
    [
      "serrer",
      0.125
    ],
    [
      "embrasser",
      0.1
    ],
    [
      "entourer",
      0.0875
    ],
    [
      "prendre",
      0.0875
    ],
    [
      "enserrer",
      0.075
    ],
    [
      "presser",
      0.06
    ],
    [
      "enlacer",
      0.06
    ],
    [
      "ceinturer",
      0.06
    ],
    [
      "oppresser",
      0.05
    ],
    [
      "saisir",
      0.035
    ],
    [
      "retenir",
      0.035
    ],
    [
      "encercler",
      0.035
    ],
    [
      "accabler",
      0.025
    ],
    [
      "caresser",
      0.025
    ],
    [
      "tenir",
      0.025
    ],
    [
      "etouffer",
      0.025
    ],
    [
      "poindre",
      0.01
    ],
    [
      "empoigner",
      0.01
    ],
    [
      "dechirer",
      0.01
    ],
    [
      "cerner",
      0.01
    ],
    [
      "accoler",
      0.01
    ],
    [
      "tenailler",
      0.01
    ]
  ],
  "vaste": [
    [
      "grand",
      0.1475
    ],
    [
      "gros",
      0.11
    ],
    [
      "abondant",
      0.0775
    ],
    [
      "ample",
      0.0725
    ],
    [
      "fort",
      0.0725
    ],
    [
      "large",
      0.0725
    ],
    [
      "considerable",
      0.0525
    ],
    [
      "important",
      0.0475
    ],
    [
      "immense",
      0.0425
    ],
    [
      "etendu",
      0.035
    ],
    [
      "enorme",
      0.03
    ],
    [
      "volumineux",
      0.02
    ],
    [
      "spacieux",
      0.02
    ],
    [
      "nombreux",
      0.02
    ],
    [
      "long",
      0.02
    ],
    [
      "genereux",
      0.02
    ],
    [
      "copieux",
      0.02
    ],
    [
      "imposant",
      0.015
    ],
    [
      "eleve",
      0.015
    ],
    [
      "incommensurable",
      0.01
    ],
    [
      "gras",
      0.01
    ],
    [
      "gigantesque",
      0.01
    ],
    [
      "developpe",
      0.01
    ],
    [
      "comprehensif",
      0.0025
    ],
    [
      "demesure",
      0.0025
    ],
    [
      "plein",
      0.0025
    ],
    [
      "epanoui",
      0.0025
    ]
  ],
  "cerf": [
    [
      "brocard",
      0.095
    ],
    [
      "chevreuil",
      0.095
    ],
    [
      "elan",
      0.095
    ],
    [
      "massacre",
      0.0475
    ],
    [
      "muntjac",
      0.0475
    ],
    [
      "male",
      0.0475
    ],
    [
      "orignal",
      0.0475
    ],
    [
      "sica",
      0.0475
    ],
    [
      "wapiti",
      0.0475
    ],
    [
      "here",
      0.0475
    ],
    [
      "gibier",
      0.0475
    ],
    [
      "faon",
      0.0475
    ],
    [
      "daguet",
      0.0475
    ],
    [
      "cimier",
      0.0475
    ],
    [
      "biche",
      0.0475
    ],
    [
      "axis",
      0.0475
    ],
    [
      "elaphe",
      0.0475
    ]
  ],
  "courante": [
    [
      "ordinaire",
      0.125
    ],
    [
      "commun",
      0.0875
    ],
    [
      "habituel",
      0.075
    ],
    [
      "banal",
      0.0425
    ],
    [
      "cours",
      0.0425
    ],
    [
      "vulgaire",
      0.0375
    ],
    [
      "mouvement",
      0.0375
    ],
    [
      "simple",
      0.025
    ],
    [
      "quotidien",
      0.025
    ],
    [
      "quelconque",
      0.025
    ],
    [
      "moyen",
      0.025
    ],
    [
      "flot",
      0.025
    ],
    [
      "familier",
      0.025
    ],
    [
      "usuel",
      0.0175
    ],
    [
      "usite",
      0.0175
    ],
    [
      "trivial",
      0.0175
    ],
    [
      "normal",
      0.0175
    ],
    [
      "marche",
      0.0175
    ],
    [
      "frequent",
      0.0175
    ],
    [
      "fil",
      0.0175
    ],
    [
      "facile",
      0.0175
    ],
    [
      "connu",
      0.0175
    ],
    [
      "classique",
      0.0175
    ],
    [
      "vent",
      0.0125
    ],
    [
      "torrent",
      0.0125
    ],
    [
      "succession",
      0.0125
    ],
    [
      "repandu",
      0.0125
    ],
    [
      "progression",
      0.0125
    ],
    [
      "force",
      0.0125
    ],
    [
      "accoutume",
      0.0125
    ],
    [
      "progres",
      0.005
    ],
    [
      "present",
      0.005
    ],
    [
      "souffle",
      0.005
    ],
    [
      "standard",
      0.005
    ],
    [
      "train",
      0.005
    ],
    [
      "vernaculaire",
      0.005
    ],
    [
      "electricite",
      0.005
    ],
    [
      "emigration",
      0.005
    ],
    [
      "immigration",
      0.005
    ],
    [
      "general",
      0.005
    ],
    [
      "fluide",
      0.005
    ],
    [
      "abondant",
      0.005
    ],
    [
      "actuel",
      0.005
    ],
    [
      "chenal",
      0.005
    ],
    [
      "circulation",
      0.005
    ],
    [
      "corde",
      0.005
    ],
    [
      "entrainement",
      0.005
    ],
    [
      "evolution",
      0.005
    ]
  ],
  "sevir": [
    [
      "punir",
      0.2625
    ],
    [
      "chatier",
      0.13
    ],
    [
      "corriger",
      0.0875
    ],
    [
      "condamner",
      0.065
    ],
    [
      "frapper",
      0.065
    ],
    [
      "sanctionner",
      0.065
    ],
    [
      "venger",
      0.0425
    ],
    [
      "reprimer",
      0.0425
    ],
    [
      "fletrir",
      0.02
    ],
    [
      "consigner",
      0.02
    ],
    [
      "coller",
      0.02
    ],
    [
      "battre",
      0.02
    ],
    [
      "agir",
      0.02
    ]
  ],
  "consoler": [
    [
      "apaiser",
      0.1325
    ],
    [
      "calmer",
      0.1125
    ],
    [
      "adoucir",
      0.1025
    ],
    [
      "bercer",
      0.08
    ],
    [
      "soulager",
      0.07
    ],
    [
      "endormir",
      0.05
    ],
    [
      "reconforter",
      0.03
    ],
    [
      "attenuer",
      0.03
    ],
    [
      "egayer",
      0.02
    ],
    [
      "tromper",
      0.02
    ],
    [
      "revigorer",
      0.02
    ],
    [
      "remonter",
      0.02
    ],
    [
      "relever",
      0.02
    ],
    [
      "rasserener",
      0.02
    ],
    [
      "guerir",
      0.02
    ],
    [
      "flatter",
      0.02
    ],
    [
      "assoupir",
      0.02
    ],
    [
      "charmer",
      0.02
    ],
    [
      "cicatriser",
      0.02
    ],
    [
      "conforter",
      0.02
    ],
    [
      "diminuer",
      0.02
    ],
    [
      "soutenir",
      0.01
    ],
    [
      "solacier",
      0.01
    ],
    [
      "rassurer",
      0.01
    ],
    [
      "derider",
      0.01
    ],
    [
      "distraire",
      0.01
    ],
    [
      "compenser",
      0.01
    ],
    [
      "benir",
      0.01
    ],
    [
      "alleger",
      0.01
    ]
  ],
  "punir": [
    [
      "sevir",
      0.1675
    ],
    [
      "chatier",
      0.125
    ],
    [
      "corriger",
      0.125
    ],
    [
      "frapper",
      0.0825
    ],
    [
      "condamner",
      0.055
    ],
    [
      "venger",
      0.04
    ],
    [
      "sanctionner",
      0.04
    ],
    [
      "battre",
      0.04
    ],
    [
      "reprimer",
      0.0275
    ],
    [
      "redresser",
      0.0275
    ],
    [
      "fletrir",
      0.0275
    ],
    [
      "blamer",
      0.0275
    ],
    [
      "penaliser",
      0.0125
    ],
    [
      "payer",
      0.0125
    ],
    [
      "gratifier",
      0.0125
    ],
    [
      "foudroyer",
      0.0125
    ],
    [
      "fesser",
      0.0125
    ],
    [
      "consigner",
      0.0125
    ],
    [
      "coller",
      0.0125
    ],
    [
      "censurer",
      0.0125
    ],
    [
      "saler",
      0.0125
    ]
  ],
  "sienne": [
    [
      "leur",
      1.0
    ]
  ],
  "baladeur": [
    [
      "ambulant",
      0.2
    ],
    [
      "flaneur",
      0.2
    ],
    [
      "promeneur",
      0.2
    ],
    [
      "tripoteur",
      0.2
    ],
    [
      "walkman",
      0.2
    ]
  ],
  "presente": [
    [
      "don",
      0.1375
    ],
    [
      "cadeau",
      0.1075
    ],
    [
      "actuel",
      0.08
    ],
    [
      "vivant",
      0.0525
    ],
    [
      "largesse",
      0.0525
    ],
    [
      "gratification",
      0.0525
    ],
    [
      "existant",
      0.0525
    ],
    [
      "bienfait",
      0.0525
    ],
    [
      "vivace",
      0.025
    ],
    [
      "temoin",
      0.025
    ],
    [
      "temps",
      0.025
    ],
    [
      "realite",
      0.025
    ],
    [
      "omnipresent",
      0.025
    ],
    [
      "offrande",
      0.025
    ],
    [
      "moderne",
      0.025
    ],
    [
      "manifeste",
      0.025
    ],
    [
      "immediat",
      0.025
    ],
    [
      "courant",
      0.025
    ],
    [
      "contemporain",
      0.025
    ],
    [
      "bien",
      0.025
    ],
    [
      "assistant",
      0.025
    ],
    [
      "actualite",
      0.025
    ],
    [
      "etrenne",
      0.025
    ]
  ],
  "gai": [
    [
      "plaisant",
      0.0725
    ],
    [
      "amusant",
      0.0425
    ],
    [
      "joyeux",
      0.0425
    ],
    [
      "rejoui",
      0.0375
    ],
    [
      "rieur",
      0.0375
    ],
    [
      "folatre",
      0.0375
    ],
    [
      "enjoue",
      0.0375
    ],
    [
      "badin",
      0.0325
    ],
    [
      "gaillard",
      0.03
    ],
    [
      "drole",
      0.03
    ],
    [
      "beau",
      0.03
    ],
    [
      "agreable",
      0.03
    ],
    [
      "espiegle",
      0.025
    ],
    [
      "guilleret",
      0.025
    ],
    [
      "vif",
      0.0225
    ],
    [
      "riant",
      0.02
    ],
    [
      "heureux",
      0.02
    ],
    [
      "bon",
      0.02
    ],
    [
      "charmant",
      0.015
    ],
    [
      "fou",
      0.015
    ],
    [
      "luron",
      0.015
    ],
    [
      "eveille",
      0.015
    ],
    [
      "epanoui",
      0.0125
    ],
    [
      "rejouissant",
      0.0125
    ],
    [
      "libre",
      0.0125
    ],
    [
      "ivre",
      0.0125
    ],
    [
      "folichon",
      0.0125
    ],
    [
      "content",
      0.0125
    ],
    [
      "comique",
      0.0125
    ],
    [
      "egayant",
      0.0075
    ],
    [
      "semillant",
      0.0075
    ],
    [
      "leste",
      0.0075
    ],
    [
      "jovial",
      0.0075
    ],
    [
      "euphorique",
      0.0075
    ],
    [
      "divertissant",
      0.0075
    ],
    [
      "clair",
      0.0075
    ],
    [
      "allegre",
      0.0075
    ],
    [
      "egrillard",
      0.005
    ],
    [
      "souriant",
      0.005
    ],
    [
      "rigolo",
      0.005
    ],
    [
      "ravi",
      0.005
    ],
    [
      "printanier",
      0.005
    ],
    [
      "mutin",
      0.005
    ],
    [
      "lumineux",
      0.005
    ],
    [
      "hilare",
      0.005
    ],
    [
      "ensoleille",
      0.005
    ],
    [
      "enchanteur",
      0.005
    ],
    [
      "juvenile",
      0.0025
    ],
    [
      "parti",
      0.0025
    ],
    [
      "rigoleur",
      0.0025
    ],
    [
      "emerillonne",
      0.0025
    ],
    [
      "emoustillant",
      0.0025
    ],
    [
      "emoustille",
      0.0025
    ],
    [
      "emu",
      0.0025
    ],
    [
      "gris",
      0.0025
    ],
    [
      "gay",
      0.0025
    ],
    [
      "festif",
      0.0025
    ],
    [
      "exhilarant",
      0.0025
    ],
    [
      "enthousiaste",
      0.0025
    ],
    [
      "encourageant",
      0.0025
    ],
    [
      "drille",
      0.0025
    ],
    [
      "anime",
      0.0025
    ],
    [
      "emeche",
      0.0025
    ]
  ],
  "chic": [
    [
      "beau",
      0.0875
    ],
    [
      "elegance",
      0.0575
    ],
    [
      "elegant",
      0.0575
    ],
    [
      "habilete",
      0.0425
    ],
    [
      "adresse",
      0.0375
    ],
    [
      "agreable",
      0.0325
    ],
    [
      "bon",
      0.0325
    ],
    [
      "talent",
      0.0275
    ],
    [
      "style",
      0.0275
    ],
    [
      "gentil",
      0.0275
    ],
    [
      "distinction",
      0.0275
    ],
    [
      "aimable",
      0.0275
    ],
    [
      "distingue",
      0.0225
    ],
    [
      "classe",
      0.0225
    ],
    [
      "brave",
      0.0225
    ],
    [
      "aisance",
      0.0225
    ],
    [
      "virtuosite",
      0.0175
    ],
    [
      "select",
      0.0175
    ],
    [
      "propre",
      0.0175
    ],
    [
      "pimpant",
      0.0175
    ],
    [
      "coquet",
      0.0175
    ],
    [
      "chouette",
      0.0175
    ],
    [
      "caractere",
      0.0175
    ],
    [
      "bien",
      0.0175
    ],
    [
      "bath",
      0.0175
    ],
    [
      "art",
      0.0175
    ],
    [
      "maitrise",
      0.0125
    ],
    [
      "dexterite",
      0.0125
    ],
    [
      "chien",
      0.0125
    ],
    [
      "allure",
      0.0125
    ],
    [
      "epatant",
      0.0075
    ],
    [
      "tournure",
      0.0075
    ],
    [
      "raffinement",
      0.0075
    ],
    [
      "patte",
      0.0075
    ],
    [
      "maestria",
      0.0075
    ],
    [
      "formidable",
      0.0075
    ],
    [
      "charme",
      0.0075
    ],
    [
      "joliesse",
      0.0025
    ],
    [
      "mode",
      0.0025
    ],
    [
      "obligeant",
      0.0025
    ],
    [
      "originalite",
      0.0025
    ],
    [
      "race",
      0.0025
    ],
    [
      "smart",
      0.0025
    ],
    [
      "snob",
      0.0025
    ],
    [
      "in",
      0.0025
    ],
    [
      "habille",
      0.0025
    ],
    [
      "flambant",
      0.0025
    ],
    [
      "desinvolture",
      0.0025
    ],
    [
      "coquetterie",
      0.0025
    ],
    [
      "class",
      0.0025
    ],
    [
      "choisi",
      0.0025
    ],
    [
      "allure",
      0.0025
    ],
    [
      "abattage",
      0.0025
    ],
    [
      "urf",
      0.0025
    ]
  ],
  "entrainant": [
    [
      "convaincant",
      0.3325
    ],
    [
      "excitant",
      0.165
    ],
    [
      "irresistible",
      0.165
    ],
    [
      "vehement",
      0.165
    ],
    [
      "eloquent",
      0.165
    ]
  ],
  "maudit": [
    [
      "fulminer",
      0.11
    ],
    [
      "tempeter",
      0.065
    ],
    [
      "reprouver",
      0.065
    ],
    [
      "rejeter",
      0.065
    ],
    [
      "pester",
      0.065
    ],
    [
      "injurier",
      0.065
    ],
    [
      "detester",
      0.065
    ],
    [
      "tonner",
      0.0425
    ],
    [
      "s'indigner",
      0.0425
    ],
    [
      "execrer",
      0.0425
    ],
    [
      "excommunier",
      0.0425
    ],
    [
      "condamner",
      0.0425
    ],
    [
      "blamer",
      0.0425
    ],
    [
      "anathematiser",
      0.0425
    ],
    [
      "s'emporter",
      0.02
    ],
    [
      "hair",
      0.02
    ],
    [
      "fletrir",
      0.02
    ],
    [
      "blasphemer",
      0.02
    ],
    [
      "agonir",
      0.02
    ],
    [
      "abominer",
      0.02
    ],
    [
      "abhorrer",
      0.02
    ]
  ],
  "posterite": [
    [
      "race",
      0.19
    ],
    [
      "progeniture",
      0.135
    ],
    [
      "descendance",
      0.1075
    ],
    [
      "famille",
      0.08
    ],
    [
      "suite",
      0.0525
    ],
    [
      "lignee",
      0.0525
    ],
    [
      "futur",
      0.0525
    ],
    [
      "renommee",
      0.025
    ],
    [
      "rejetons",
      0.025
    ],
    [
      "memoire",
      0.025
    ],
    [
      "immortalite",
      0.025
    ],
    [
      "heritiers",
      0.025
    ],
    [
      "generation",
      0.025
    ],
    [
      "fils",
      0.025
    ],
    [
      "enfants",
      0.025
    ],
    [
      "descendants",
      0.025
    ],
    [
      "consanguinite",
      0.025
    ],
    [
      "avenir",
      0.025
    ],
    [
      "successeurs",
      0.025
    ]
  ],
  "pede": [
    [
      "pederaste",
      1.0
    ]
  ],
  "aureoler": [
    [
      "couronner",
      0.165
    ],
    [
      "entourer",
      0.165
    ],
    [
      "nimber",
      0.165
    ],
    [
      "parer",
      0.165
    ],
    [
      "ceindre",
      0.0825
    ],
    [
      "glorifier",
      0.0825
    ],
    [
      "liserer",
      0.0825
    ],
    [
      "magnifier",
      0.0825
    ]
  ],
  "aureole": [
    [
      "halo",
      0.2075
    ],
    [
      "nimbe",
      0.165
    ],
    [
      "aura",
      0.125
    ],
    [
      "cercle",
      0.0825
    ],
    [
      "gloire",
      0.0825
    ],
    [
      "emanation",
      0.0825
    ],
    [
      "prestige",
      0.04
    ],
    [
      "mandorle",
      0.04
    ],
    [
      "couronne",
      0.04
    ],
    [
      "cerne",
      0.04
    ],
    [
      "atmosphere",
      0.04
    ],
    [
      "eclat",
      0.04
    ]
  ],
  "berline": [
    [
      "benne",
      0.18
    ],
    [
      "voiture",
      0.18
    ],
    [
      "auto",
      0.09
    ],
    [
      "automobile",
      0.09
    ],
    [
      "chariot",
      0.09
    ],
    [
      "coach",
      0.09
    ],
    [
      "coche",
      0.09
    ],
    [
      "wagonnet",
      0.09
    ]
  ],
  "monarque": [
    [
      "roi",
      0.295
    ],
    [
      "chef",
      0.11
    ],
    [
      "empereur",
      0.11
    ],
    [
      "souverain",
      0.11
    ],
    [
      "prince",
      0.0725
    ],
    [
      "potentat",
      0.0725
    ],
    [
      "couronne",
      0.0725
    ],
    [
      "autocrate",
      0.035
    ],
    [
      "cesar",
      0.035
    ],
    [
      "dynaste",
      0.035
    ],
    [
      "gouvernant",
      0.035
    ]
  ],
  "envieux": [
    [
      "avide",
      0.165
    ],
    [
      "convoiteux",
      0.165
    ],
    [
      "desireux",
      0.165
    ],
    [
      "jaloux",
      0.165
    ],
    [
      "zoile",
      0.165
    ],
    [
      "baveux",
      0.0825
    ],
    [
      "cupide",
      0.0825
    ]
  ],
  "scelerat": [
    [
      "bandit",
      0.09
    ],
    [
      "fripouille",
      0.06
    ],
    [
      "truand",
      0.06
    ],
    [
      "vaurien",
      0.06
    ],
    [
      "voleur",
      0.06
    ],
    [
      "malfaiteur",
      0.0525
    ],
    [
      "canaille",
      0.0525
    ],
    [
      "brigand",
      0.0525
    ],
    [
      "coquin",
      0.045
    ],
    [
      "mechant",
      0.045
    ],
    [
      "fripon",
      0.0375
    ],
    [
      "gredin",
      0.0375
    ],
    [
      "perfide",
      0.03
    ],
    [
      "miserable",
      0.03
    ],
    [
      "mauvais",
      0.03
    ],
    [
      "filou",
      0.03
    ],
    [
      "criminel",
      0.03
    ],
    [
      "malandrin",
      0.0225
    ],
    [
      "meurtrier",
      0.0225
    ],
    [
      "vermine",
      0.015
    ],
    [
      "larron",
      0.015
    ],
    [
      "injuste",
      0.015
    ],
    [
      "felon",
      0.015
    ],
    [
      "deloyal",
      0.015
    ],
    [
      "monstre",
      0.005
    ],
    [
      "machiavelique",
      0.005
    ],
    [
      "infame",
      0.005
    ],
    [
      "infidele",
      0.005
    ],
    [
      "homicide",
      0.005
    ],
    [
      "garnement",
      0.005
    ],
    [
      "partial",
      0.005
    ]
  ],
  "peage": [
    [
      "taxe",
      1.0
    ]
  ],
  "hennir": [
    [
      "bramer",
      0.25
    ],
    [
      "hurler",
      0.25
    ],
    [
      "mugir",
      0.25
    ],
    [
      "rugir",
      0.25
    ]
  ],
  "opposer": [
    [
      "alleguer",
      0.0625
    ],
    [
      "comparer",
      0.0625
    ],
    [
      "dresser",
      0.0625
    ],
    [
      "pretexter",
      0.0625
    ],
    [
      "repondre",
      0.0625
    ],
    [
      "mettre",
      0.04
    ],
    [
      "objecter",
      0.04
    ],
    [
      "refuter",
      0.04
    ],
    [
      "invoquer",
      0.04
    ],
    [
      "exciter",
      0.04
    ],
    [
      "dire",
      0.04
    ],
    [
      "contredire",
      0.04
    ],
    [
      "braquer",
      0.04
    ],
    [
      "balancer",
      0.04
    ],
    [
      "diviser",
      0.02
    ],
    [
      "desaccorder",
      0.02
    ],
    [
      "endiguer",
      0.02
    ],
    [
      "separer",
      0.02
    ],
    [
      "dissocier",
      0.02
    ],
    [
      "confronter",
      0.02
    ],
    [
      "avancer",
      0.02
    ],
    [
      "armer",
      0.02
    ],
    [
      "agir",
      0.02
    ],
    [
      "affronter",
      0.02
    ],
    [
      "adosser",
      0.02
    ],
    [
      "elever",
      0.02
    ]
  ],
  "soulier": [
    [
      "chaussure",
      0.31
    ],
    [
      "godillot",
      0.0625
    ],
    [
      "brodequin",
      0.05
    ],
    [
      "chausson",
      0.0375
    ],
    [
      "socque",
      0.025
    ],
    [
      "sabot",
      0.025
    ],
    [
      "peniche",
      0.025
    ],
    [
      "patin",
      0.025
    ],
    [
      "pantoufle",
      0.025
    ],
    [
      "godasse",
      0.025
    ],
    [
      "galoche",
      0.025
    ],
    [
      "croquenot",
      0.025
    ],
    [
      "bottine",
      0.025
    ],
    [
      "botte",
      0.025
    ],
    [
      "babouche",
      0.025
    ],
    [
      "ribouis",
      0.01
    ],
    [
      "richelieu",
      0.01
    ],
    [
      "sandale",
      0.01
    ],
    [
      "savate",
      0.01
    ],
    [
      "sorlot",
      0.01
    ],
    [
      "spartiate",
      0.01
    ],
    [
      "tatane",
      0.01
    ],
    [
      "pompe",
      0.01
    ],
    [
      "mule",
      0.01
    ],
    [
      "bateau",
      0.01
    ],
    [
      "clape",
      0.01
    ],
    [
      "clapette",
      0.01
    ],
    [
      "cothurne",
      0.01
    ],
    [
      "escarpin",
      0.01
    ],
    [
      "espadrille",
      0.01
    ],
    [
      "grolle",
      0.01
    ],
    [
      "mocassin",
      0.01
    ]
  ],
  "usurier": [
    [
      "avare",
      0.215
    ],
    [
      "agioteur",
      0.1425
    ],
    [
      "rapace",
      0.07
    ],
    [
      "preteur",
      0.07
    ],
    [
      "profiteur",
      0.07
    ],
    [
      "affameur",
      0.07
    ],
    [
      "Shylock",
      0.07
    ],
    [
      "Gobseck",
      0.07
    ],
    [
      "vautour",
      0.07
    ]
  ],
  "muse": [
    [
      "inspiration",
      0.125
    ],
    [
      "lyre",
      0.125
    ],
    [
      "poesie",
      0.125
    ],
    [
      "luth",
      0.0625
    ],
    [
      "inspiratrice",
      0.0625
    ],
    [
      "guide",
      0.0625
    ],
    [
      "fille",
      0.0625
    ],
    [
      "femme",
      0.0625
    ],
    [
      "enthousiasme",
      0.0625
    ],
    [
      "deesse",
      0.0625
    ],
    [
      "apollon",
      0.0625
    ],
    [
      "amante",
      0.0625
    ],
    [
      "phebus",
      0.0625
    ]
  ],
  "muser": [
    [
      "flaner",
      0.2075
    ],
    [
      "musarder",
      0.1875
    ],
    [
      "trainer",
      0.165
    ],
    [
      "baguenauder",
      0.1025
    ],
    [
      "s'amuser",
      0.0625
    ],
    [
      "lanterner",
      0.0625
    ],
    [
      "lambiner",
      0.0625
    ],
    [
      "badauder",
      0.02
    ],
    [
      "faineanter",
      0.02
    ],
    [
      "s'attarder",
      0.02
    ]
  ],
  "agreable": [
    [
      "aimable",
      0.0725
    ],
    [
      "beau",
      0.0675
    ],
    [
      "charmant",
      0.0625
    ],
    [
      "gracieux",
      0.0625
    ],
    [
      "doux",
      0.045
    ],
    [
      "bon",
      0.0425
    ],
    [
      "joli",
      0.0375
    ],
    [
      "plaisant",
      0.0375
    ],
    [
      "seduisant",
      0.0275
    ],
    [
      "delicat",
      0.025
    ],
    [
      "exquis",
      0.02
    ],
    [
      "engageant",
      0.02
    ],
    [
      "attrayant",
      0.02
    ],
    [
      "gentil",
      0.02
    ],
    [
      "enchanteur",
      0.0175
    ],
    [
      "attirant",
      0.015
    ],
    [
      "amene",
      0.015
    ],
    [
      "affable",
      0.015
    ],
    [
      "ravissant",
      0.015
    ],
    [
      "delicieux",
      0.0125
    ],
    [
      "elegant",
      0.0125
    ],
    [
      "bien",
      0.0125
    ],
    [
      "heureux",
      0.01
    ],
    [
      "sympathique",
      0.01
    ],
    [
      "galant",
      0.01
    ],
    [
      "avenant",
      0.01
    ],
    [
      "gai",
      0.01
    ],
    [
      "suave",
      0.0075
    ],
    [
      "commode",
      0.0075
    ],
    [
      "amusant",
      0.0075
    ],
    [
      "sociable",
      0.005
    ],
    [
      "riant",
      0.005
    ],
    [
      "harmonieux",
      0.005
    ],
    [
      "facile",
      0.005
    ],
    [
      "distingue",
      0.005
    ],
    [
      "chic",
      0.005
    ],
    [
      "accueillant",
      0.005
    ],
    [
      "accommodant",
      0.005
    ],
    [
      "savoureux",
      0.005
    ],
    [
      "prevenant",
      0.005
    ],
    [
      "favorable",
      0.005
    ],
    [
      "fascinant",
      0.005
    ],
    [
      "excitant",
      0.005
    ],
    [
      "bath",
      0.005
    ],
    [
      "succulent",
      0.005
    ],
    [
      "piquant",
      0.005
    ],
    [
      "friand",
      0.005
    ],
    [
      "convenable",
      0.005
    ],
    [
      "confortable",
      0.005
    ],
    [
      "chouette",
      0.005
    ],
    [
      "captivant",
      0.005
    ],
    [
      "appetissant",
      0.005
    ],
    [
      "vivable",
      0.0025
    ],
    [
      "leger",
      0.0025
    ],
    [
      "joyeux",
      0.0025
    ],
    [
      "enivrant",
      0.0025
    ],
    [
      "empresse",
      0.0025
    ],
    [
      "affriolant",
      0.0025
    ],
    [
      "voluptueux",
      0.0025
    ],
    [
      "moelleux",
      0.0025
    ],
    [
      "fameux",
      0.0025
    ],
    [
      "delectable",
      0.0025
    ],
    [
      "cordial",
      0.0025
    ],
    [
      "select",
      0.0
    ],
    [
      "sympa",
      0.0
    ],
    [
      "subtil",
      0.0
    ],
    [
      "rejouissant",
      0.0
    ],
    [
      "ragoutant",
      0.0
    ],
    [
      "melodieux",
      0.0
    ],
    [
      "flatteur",
      0.0
    ],
    [
      "coulant",
      0.0
    ],
    [
      "bienseant",
      0.0
    ],
    [
      "attachant",
      0.0
    ],
    [
      "accort",
      0.0
    ],
    [
      "embaumant",
      0.0
    ],
    [
      "euphorique",
      0.0
    ],
    [
      "gourmand",
      0.0
    ],
    [
      "recreatif",
      0.0
    ],
    [
      "dore",
      0.0
    ],
    [
      "cher",
      0.0
    ],
    [
      "capiteux",
      0.0
    ],
    [
      "aromatique",
      0.0
    ],
    [
      "accorte",
      0.0
    ],
    [
      "splendide",
      0.0
    ]
  ],
  "dommage": [
    [
      "tort",
      0.1425
    ],
    [
      "degat",
      0.1025
    ],
    [
      "ravage",
      0.1025
    ],
    [
      "degradation",
      0.055
    ],
    [
      "prejudice",
      0.055
    ],
    [
      "casse",
      0.0375
    ],
    [
      "atteinte",
      0.0375
    ],
    [
      "mal",
      0.03
    ],
    [
      "perte",
      0.03
    ],
    [
      "ennui",
      0.0225
    ],
    [
      "deterioration",
      0.0225
    ],
    [
      "depredation",
      0.0225
    ],
    [
      "coup",
      0.0225
    ],
    [
      "avarie",
      0.0225
    ],
    [
      "sinistre",
      0.015
    ],
    [
      "regrettable",
      0.015
    ],
    [
      "outrage",
      0.015
    ],
    [
      "nuisance",
      0.015
    ],
    [
      "mefait",
      0.015
    ],
    [
      "injustice",
      0.015
    ],
    [
      "injure",
      0.015
    ],
    [
      "endommagement",
      0.015
    ],
    [
      "desavantage",
      0.015
    ],
    [
      "destruction",
      0.015
    ],
    [
      "interet",
      0.0075
    ],
    [
      "lesion",
      0.0075
    ],
    [
      "ribordage",
      0.0075
    ],
    [
      "sevices",
      0.0075
    ],
    [
      "grief",
      0.0075
    ],
    [
      "grabuge",
      0.0075
    ],
    [
      "entorse",
      0.0075
    ],
    [
      "detriment",
      0.0075
    ],
    [
      "dam",
      0.0075
    ],
    [
      "calamite",
      0.0075
    ],
    [
      "bete",
      0.0075
    ],
    [
      "breche",
      0.0075
    ],
    [
      "vimaire",
      0.0075
    ]
  ],
  "sexiste": [
    [
      "misogyne",
      1.0
    ]
  ],
  "spaghetti": [
    [
      "pates",
      1.0
    ]
  ],
  "concombre": [
    [
      "courge",
      0.4275
    ],
    [
      "coloquinte",
      0.1425
    ],
    [
      "cornichon",
      0.1425
    ],
    [
      "cucurbitacee",
      0.1425
    ],
    [
      "zuchette",
      0.1425
    ]
  ],
  "legume": [
    [
      "gousse",
      0.1425
    ],
    [
      "huile",
      0.1425
    ],
    [
      "notabilite",
      0.1425
    ],
    [
      "personnage",
      0.1425
    ],
    [
      "personnalite",
      0.1425
    ],
    [
      "sommite",
      0.1425
    ]
  ],
  "apesanteur": [
    [
      "agravitation",
      0.5
    ],
    [
      "imponderabilite",
      0.5
    ]
  ],
  "nuancer": [
    [
      "bigarrer",
      0.1525
    ],
    [
      "varier",
      0.06
    ],
    [
      "temperer",
      0.06
    ],
    [
      "nuer",
      0.06
    ],
    [
      "moderer",
      0.06
    ],
    [
      "fondre",
      0.06
    ],
    [
      "chamarrer",
      0.06
    ],
    [
      "barioler",
      0.06
    ],
    [
      "attenuer",
      0.06
    ],
    [
      "noyer",
      0.03
    ],
    [
      "moduler",
      0.03
    ],
    [
      "mesurer",
      0.03
    ],
    [
      "graduer",
      0.03
    ],
    [
      "degrader",
      0.03
    ],
    [
      "diversifier",
      0.03
    ],
    [
      "diaprer",
      0.03
    ],
    [
      "corriger",
      0.03
    ],
    [
      "colorer",
      0.03
    ],
    [
      "chanter",
      0.03
    ],
    [
      "assortir",
      0.03
    ],
    [
      "ponderer",
      0.03
    ]
  ],
  "nuance": [
    [
      "grain",
      0.15
    ],
    [
      "teinte",
      0.12
    ],
    [
      "difference",
      0.09
    ],
    [
      "pointe",
      0.09
    ],
    [
      "ton",
      0.06
    ],
    [
      "soupcon",
      0.06
    ],
    [
      "dissemblance",
      0.06
    ],
    [
      "brin",
      0.06
    ],
    [
      "touche",
      0.03
    ],
    [
      "tonalite",
      0.03
    ],
    [
      "tendance",
      0.03
    ],
    [
      "once",
      0.03
    ],
    [
      "gradation",
      0.03
    ],
    [
      "distance",
      0.03
    ],
    [
      "degre",
      0.03
    ],
    [
      "couleur",
      0.03
    ],
    [
      "bemol",
      0.03
    ],
    [
      "variete",
      0.03
    ]
  ],
  "neanmoins": [
    [
      "cependant",
      0.31
    ],
    [
      "toutefois",
      0.0675
    ],
    [
      "toujours",
      0.0675
    ],
    [
      "seulement",
      0.0675
    ],
    [
      "pourtant",
      0.0675
    ],
    [
      "nonobstant",
      0.0325
    ],
    [
      "meme",
      0.0325
    ],
    [
      "mais",
      0.0325
    ]
  ],
  "tutoyer": [],
  "bouder": [
    [
      "grogner",
      0.11
    ],
    [
      "rechigner",
      0.11
    ],
    [
      "repugner",
      0.11
    ],
    [
      "raler",
      0.055
    ],
    [
      "renacler",
      0.055
    ],
    [
      "refuser",
      0.055
    ],
    [
      "facher",
      0.055
    ]
  ],
  "alimenter": [
    [
      "nourrir",
      0.205
    ],
    [
      "entretenir",
      0.1125
    ],
    [
      "approvisionner",
      0.09
    ],
    [
      "fournir",
      0.0675
    ],
    [
      "pourvoir",
      0.0675
    ],
    [
      "soutenir",
      0.045
    ],
    [
      "restaurer",
      0.045
    ],
    [
      "repaitre",
      0.045
    ],
    [
      "ravitailler",
      0.045
    ],
    [
      "gorger",
      0.045
    ],
    [
      "repeupler",
      0.02
    ],
    [
      "provisionner",
      0.02
    ],
    [
      "fomenter",
      0.02
    ],
    [
      "engraisser",
      0.02
    ],
    [
      "defrayer",
      0.02
    ],
    [
      "allaiter",
      0.02
    ],
    [
      "agrainer",
      0.02
    ],
    [
      "affourager",
      0.02
    ],
    [
      "sustenter",
      0.02
    ]
  ],
  "reduire": [
    [
      "diminuer",
      0.125
    ],
    [
      "abreger",
      0.04
    ],
    [
      "attenuer",
      0.04
    ],
    [
      "affaiblir",
      0.0325
    ],
    [
      "dompter",
      0.0325
    ],
    [
      "restreindre",
      0.03
    ],
    [
      "resserrer",
      0.03
    ],
    [
      "amoindrir",
      0.03
    ],
    [
      "abaisser",
      0.03
    ],
    [
      "adoucir",
      0.0175
    ],
    [
      "soumettre",
      0.015
    ],
    [
      "resumer",
      0.015
    ],
    [
      "rapetisser",
      0.015
    ],
    [
      "raccourcir",
      0.015
    ],
    [
      "rabattre",
      0.015
    ],
    [
      "rabaisser",
      0.015
    ],
    [
      "moderer",
      0.015
    ],
    [
      "mater",
      0.015
    ],
    [
      "forcer",
      0.015
    ],
    [
      "abattre",
      0.015
    ],
    [
      "ecourter",
      0.0125
    ],
    [
      "vaincre",
      0.0125
    ],
    [
      "contraindre",
      0.0125
    ],
    [
      "condenser",
      0.0125
    ],
    [
      "briser",
      0.0125
    ],
    [
      "assujettir",
      0.0125
    ],
    [
      "alleger",
      0.0125
    ],
    [
      "triompher",
      0.01
    ],
    [
      "obliger",
      0.01
    ],
    [
      "maitriser",
      0.01
    ],
    [
      "limiter",
      0.01
    ],
    [
      "contracter",
      0.01
    ],
    [
      "comprimer",
      0.01
    ],
    [
      "baisser",
      0.01
    ],
    [
      "astreindre",
      0.01
    ],
    [
      "amenuiser",
      0.01
    ],
    [
      "terrasser",
      0.0075
    ],
    [
      "remettre",
      0.0075
    ],
    [
      "ramener",
      0.0075
    ],
    [
      "ramasser",
      0.0075
    ],
    [
      "preciser",
      0.0075
    ],
    [
      "concentrer",
      0.0075
    ],
    [
      "borner",
      0.0075
    ],
    [
      "mettre",
      0.005
    ],
    [
      "minimiser",
      0.005
    ],
    [
      "museler",
      0.005
    ],
    [
      "pulveriser",
      0.005
    ],
    [
      "renfermer",
      0.005
    ],
    [
      "surmonter",
      0.005
    ],
    [
      "tasser",
      0.005
    ],
    [
      "tronquer",
      0.005
    ],
    [
      "inferioriser",
      0.005
    ],
    [
      "fondre",
      0.005
    ],
    [
      "acculer",
      0.005
    ],
    [
      "affadir",
      0.005
    ],
    [
      "amortir",
      0.005
    ],
    [
      "analyser",
      0.005
    ],
    [
      "condamner",
      0.005
    ],
    [
      "conduire",
      0.005
    ],
    [
      "confondre",
      0.005
    ],
    [
      "extenuer",
      0.005
    ],
    [
      "rationner",
      0.0025
    ],
    [
      "rattraper",
      0.0025
    ],
    [
      "simplifier",
      0.0025
    ],
    [
      "subjuguer",
      0.0025
    ],
    [
      "transformer",
      0.0025
    ],
    [
      "ebouillir",
      0.0025
    ],
    [
      "economiser",
      0.0025
    ],
    [
      "rarefier",
      0.0025
    ],
    [
      "necessiter",
      0.0025
    ],
    [
      "minimer",
      0.0025
    ],
    [
      "desoxygener",
      0.0025
    ],
    [
      "desoxyder",
      0.0025
    ],
    [
      "defalquer",
      0.0025
    ],
    [
      "decomposer",
      0.0025
    ],
    [
      "distiller",
      0.0025
    ],
    [
      "changer",
      0.0025
    ],
    [
      "accourcir",
      0.0025
    ],
    [
      "ecorner",
      0.0025
    ]
  ],
  "toquade": [
    [
      "caprice",
      0.165
    ],
    [
      "folie",
      0.06
    ],
    [
      "fantaisie",
      0.0575
    ],
    [
      "manie",
      0.0575
    ],
    [
      "passion",
      0.0325
    ],
    [
      "humeur",
      0.0325
    ],
    [
      "amour",
      0.03
    ],
    [
      "extravagance",
      0.03
    ],
    [
      "marotte",
      0.03
    ],
    [
      "boutade",
      0.0275
    ],
    [
      "lubie",
      0.0225
    ],
    [
      "bizarrerie",
      0.0225
    ],
    [
      "passade",
      0.02
    ],
    [
      "travers",
      0.015
    ],
    [
      "tic",
      0.015
    ],
    [
      "dada",
      0.015
    ],
    [
      "changement",
      0.015
    ],
    [
      "amourette",
      0.015
    ],
    [
      "alienation",
      0.015
    ],
    [
      "mouvement",
      0.0125
    ],
    [
      "frenesie",
      0.0125
    ],
    [
      "foucade",
      0.0125
    ],
    [
      "beguin",
      0.0125
    ],
    [
      "instabilite",
      0.01
    ],
    [
      "incartade",
      0.01
    ],
    [
      "flirt",
      0.01
    ],
    [
      "delire",
      0.01
    ],
    [
      "mobilite",
      0.005
    ],
    [
      "monomanie",
      0.005
    ],
    [
      "obsession",
      0.005
    ],
    [
      "quinte",
      0.005
    ],
    [
      "variation",
      0.005
    ],
    [
      "versatilite",
      0.005
    ],
    [
      "violon",
      0.005
    ],
    [
      "volonte",
      0.005
    ],
    [
      "egarement",
      0.005
    ],
    [
      "legerete",
      0.005
    ],
    [
      "inconsequence",
      0.005
    ],
    [
      "inconstance",
      0.005
    ],
    [
      "acces",
      0.005
    ],
    [
      "chimere",
      0.005
    ],
    [
      "demence",
      0.005
    ],
    [
      "engouement",
      0.005
    ],
    [
      "envie",
      0.005
    ],
    [
      "frasque",
      0.005
    ],
    [
      "fredaine",
      0.005
    ],
    [
      "inclination",
      0.005
    ],
    [
      "impatience",
      0.0025
    ],
    [
      "lune",
      0.0025
    ],
    [
      "pepin",
      0.0025
    ],
    [
      "saillie",
      0.0025
    ],
    [
      "singularite",
      0.0025
    ],
    [
      "idylle",
      0.0025
    ],
    [
      "hantise",
      0.0025
    ],
    [
      "gre",
      0.0025
    ],
    [
      "furie",
      0.0025
    ],
    [
      "escapade",
      0.0025
    ],
    [
      "entichement",
      0.0025
    ],
    [
      "bluette",
      0.0025
    ],
    [
      "aventure",
      0.0025
    ],
    [
      "turlutaine",
      0.0025
    ]
  ],
  "bouilli": [
    [
      "cuit",
      0.25
    ],
    [
      "ramolli",
      0.25
    ],
    [
      "sterilise",
      0.25
    ]
  ],
  "bouillie": [
    [
      "cuit",
      0.25
    ],
    [
      "ramolli",
      0.25
    ],
    [
      "sterilise",
      0.25
    ]
  ],
  "froisser": [
    [
      "blesser",
      0.075
    ],
    [
      "piquer",
      0.075
    ],
    [
      "vexer",
      0.0625
    ],
    [
      "offenser",
      0.055
    ],
    [
      "ecraser",
      0.055
    ],
    [
      "choquer",
      0.0475
    ],
    [
      "indisposer",
      0.04
    ],
    [
      "facher",
      0.04
    ],
    [
      "desobliger",
      0.04
    ],
    [
      "chiffonner",
      0.04
    ],
    [
      "deplaire",
      0.0275
    ],
    [
      "meurtrir",
      0.0275
    ],
    [
      "ulcerer",
      0.0275
    ],
    [
      "presser",
      0.02
    ],
    [
      "poindre",
      0.02
    ],
    [
      "heurter",
      0.02
    ],
    [
      "friper",
      0.02
    ],
    [
      "fouler",
      0.02
    ],
    [
      "broyer",
      0.02
    ],
    [
      "aplatir",
      0.02
    ],
    [
      "aigrir",
      0.02
    ],
    [
      "affliger",
      0.02
    ],
    [
      "emouvoir",
      0.0125
    ],
    [
      "offusquer",
      0.0125
    ],
    [
      "mortifier",
      0.0125
    ],
    [
      "frotter",
      0.0125
    ],
    [
      "depiter",
      0.0125
    ],
    [
      "comprimer",
      0.0125
    ],
    [
      "bouchonner",
      0.0125
    ],
    [
      "bigorner",
      0.0125
    ],
    [
      "egratigner",
      0.005
    ],
    [
      "ecrabouiller",
      0.005
    ],
    [
      "serrer",
      0.005
    ],
    [
      "plisser",
      0.005
    ],
    [
      "pietiner",
      0.005
    ],
    [
      "fletrir",
      0.005
    ],
    [
      "contusionner",
      0.005
    ],
    [
      "claquer",
      0.005
    ],
    [
      "astiquer",
      0.005
    ]
  ],
  "vanite": [
    [
      "orgueil",
      0.0825
    ],
    [
      "fumee",
      0.0725
    ],
    [
      "neant",
      0.0725
    ],
    [
      "pretention",
      0.0725
    ],
    [
      "superbe",
      0.0625
    ],
    [
      "suffisance",
      0.045
    ],
    [
      "futilite",
      0.0375
    ],
    [
      "infatuation",
      0.0375
    ],
    [
      "presomption",
      0.0275
    ],
    [
      "outrecuidance",
      0.0275
    ],
    [
      "fierte",
      0.0275
    ],
    [
      "fatuite",
      0.0275
    ],
    [
      "bouffissure",
      0.02
    ],
    [
      "frivolite",
      0.02
    ],
    [
      "vanterie",
      0.015
    ],
    [
      "sottise",
      0.015
    ],
    [
      "ostentation",
      0.015
    ],
    [
      "jactance",
      0.015
    ],
    [
      "inconsistance",
      0.015
    ],
    [
      "inanite",
      0.015
    ],
    [
      "illusion",
      0.015
    ],
    [
      "fragilite",
      0.015
    ],
    [
      "baudruche",
      0.015
    ],
    [
      "egoisme",
      0.01
    ],
    [
      "egotisme",
      0.01
    ],
    [
      "pompe",
      0.01
    ],
    [
      "mensonge",
      0.01
    ],
    [
      "inutilite",
      0.01
    ],
    [
      "insignifiance",
      0.01
    ],
    [
      "importance",
      0.01
    ],
    [
      "gloriole",
      0.01
    ],
    [
      "erreur",
      0.01
    ],
    [
      "inefficacite",
      0.005
    ],
    [
      "morgue",
      0.005
    ],
    [
      "puerilite",
      0.005
    ],
    [
      "soif",
      0.005
    ],
    [
      "vapeur",
      0.005
    ],
    [
      "vent",
      0.005
    ],
    [
      "enflure",
      0.005
    ],
    [
      "desir",
      0.005
    ],
    [
      "cranerie",
      0.005
    ],
    [
      "complaisance",
      0.005
    ],
    [
      "chimere",
      0.005
    ],
    [
      "caducite",
      0.005
    ],
    [
      "boursouflure",
      0.005
    ],
    [
      "autosatisfaction",
      0.005
    ],
    [
      "approbativite",
      0.005
    ],
    [
      "vide",
      0.005
    ]
  ],
  "narguer": [
    [
      "braver",
      0.3225
    ],
    [
      "affronter",
      0.095
    ],
    [
      "defier",
      0.075
    ],
    [
      "s'opposer",
      0.075
    ],
    [
      "provoquer",
      0.0375
    ],
    [
      "mepriser",
      0.0375
    ],
    [
      "attaquer",
      0.0375
    ],
    [
      "rencontrer",
      0.0175
    ],
    [
      "offenser",
      0.0175
    ],
    [
      "morguer",
      0.0175
    ],
    [
      "menacer",
      0.0175
    ],
    [
      "rire",
      0.0175
    ]
  ],
  "fragilite": [
    [
      "faiblesse",
      0.1575
    ],
    [
      "inconsistance",
      0.105
    ],
    [
      "precarite",
      0.105
    ],
    [
      "caducite",
      0.0775
    ],
    [
      "debilite",
      0.0775
    ],
    [
      "incertitude",
      0.0775
    ],
    [
      "neant",
      0.0775
    ],
    [
      "vanite",
      0.0775
    ],
    [
      "deficience",
      0.05
    ],
    [
      "baudruche",
      0.025
    ],
    [
      "delicatesse",
      0.025
    ],
    [
      "faillibilite",
      0.025
    ],
    [
      "fumee",
      0.025
    ],
    [
      "inconstance",
      0.025
    ],
    [
      "instabilite",
      0.025
    ],
    [
      "vulnerabilite",
      0.025
    ]
  ],
  "indonesien": [
    [
      "malais",
      1.0
    ]
  ],
  "brunissoir": [
    [
      "polissoir",
      1.0
    ]
  ],
  "sovietique": [
    [
      "bolchevik",
      0.3325
    ],
    [
      "russe",
      0.3325
    ],
    [
      "socialiste",
      0.3325
    ]
  ],
  "oie": [
    [
      "bete",
      0.375
    ],
    [
      "becasse",
      0.25
    ],
    [
      "becassine",
      0.125
    ],
    [
      "niais",
      0.125
    ],
    [
      "pecore",
      0.125
    ]
  ],
  "ouir": [
    [
      "ecouter",
      0.4
    ],
    [
      "entendre",
      0.2
    ],
    [
      "percevoir",
      0.2
    ]
  ],
  "imparfait": [
    [
      "insuffisant",
      0.0675
    ],
    [
      "mauvais",
      0.0675
    ],
    [
      "defectueux",
      0.0475
    ],
    [
      "incomplet",
      0.0475
    ],
    [
      "informe",
      0.0475
    ],
    [
      "rudimentaire",
      0.0475
    ],
    [
      "grossier",
      0.0375
    ],
    [
      "elementaire",
      0.03
    ],
    [
      "ebauche",
      0.03
    ],
    [
      "indigent",
      0.03
    ],
    [
      "inacheve",
      0.03
    ],
    [
      "imprecis",
      0.03
    ],
    [
      "fautif",
      0.03
    ],
    [
      "deficient",
      0.03
    ],
    [
      "brut",
      0.03
    ],
    [
      "boiteux",
      0.03
    ],
    [
      "attaquable",
      0.03
    ],
    [
      "sommaire",
      0.0175
    ],
    [
      "timide",
      0.0175
    ],
    [
      "vague",
      0.0175
    ],
    [
      "vulnerable",
      0.0175
    ],
    [
      "rate",
      0.0175
    ],
    [
      "manque",
      0.0175
    ],
    [
      "inexact",
      0.0175
    ],
    [
      "difforme",
      0.0175
    ],
    [
      "critiquable",
      0.0175
    ],
    [
      "approximatif",
      0.0175
    ],
    [
      "mediocre",
      0.0075
    ],
    [
      "neglige",
      0.0075
    ],
    [
      "preterit",
      0.0075
    ],
    [
      "restreint",
      0.0075
    ],
    [
      "tronque",
      0.0075
    ],
    [
      "loupe",
      0.0075
    ],
    [
      "lacunaire",
      0.0075
    ],
    [
      "inegal",
      0.0075
    ],
    [
      "inabouti",
      0.0075
    ],
    [
      "fragmentaire",
      0.0075
    ],
    [
      "embryonnaire",
      0.0075
    ],
    [
      "discutable",
      0.0075
    ],
    [
      "avorte",
      0.0075
    ],
    [
      "vicieux",
      0.0075
    ]
  ],
  "vegetarien": [
    [
      "herbivore",
      0.285
    ],
    [
      "frugivore",
      0.1425
    ],
    [
      "fruitarien",
      0.1425
    ],
    [
      "legumiste",
      0.1425
    ],
    [
      "phytophage",
      0.1425
    ],
    [
      "vegetalien",
      0.1425
    ]
  ],
  "americain": [
    [
      "amerloc",
      0.25
    ],
    [
      "U.S.",
      0.125
    ],
    [
      "ricain",
      0.125
    ],
    [
      "yankee",
      0.125
    ]
  ],
  "vietnamien": [
    [
      "annamite",
      0.5
    ],
    [
      "cochinchinois",
      0.5
    ]
  ],
  "milliard": [],
  "martien": [],
  "chorale": [
    [
      "hymne",
      0.5
    ],
    [
      "chant",
      0.25
    ],
    [
      "choeur",
      0.25
    ]
  ],
  "choral": [
    [
      "hymne",
      0.5
    ],
    [
      "chant",
      0.25
    ],
    [
      "choeur",
      0.25
    ]
  ],
  "orgue": [
    [
      "colonne",
      0.2
    ],
    [
      "harmonium",
      0.2
    ],
    [
      "herse",
      0.2
    ],
    [
      "organe",
      0.2
    ],
    [
      "serinette",
      0.2
    ]
  ],
  "colombe": [
    [
      "fille",
      0.25
    ],
    [
      "pigeon",
      0.25
    ],
    [
      "rabot",
      0.25
    ],
    [
      "ramier",
      0.25
    ]
  ],
  "caner": [
    [
      "abandonner",
      0.1675
    ],
    [
      "caler",
      0.11
    ],
    [
      "ceder",
      0.11
    ],
    [
      "flancher",
      0.11
    ],
    [
      "rompre",
      0.11
    ],
    [
      "s'incliner",
      0.055
    ],
    [
      "reculer",
      0.055
    ],
    [
      "mourir",
      0.055
    ],
    [
      "decaniller",
      0.055
    ],
    [
      "caleter",
      0.055
    ]
  ],
  "raccrocher": [
    [
      "abandonner",
      0.1425
    ],
    [
      "accoster",
      0.1425
    ],
    [
      "plaquer",
      0.1425
    ],
    [
      "racoler",
      0.1425
    ],
    [
      "rapporter",
      0.1425
    ],
    [
      "ressaisir",
      0.1425
    ]
  ],
  "liane": [
    [
      "plante",
      1.0
    ]
  ],
  "tresse": [
    [
      "passement",
      0.1425
    ],
    [
      "coiffure",
      0.095
    ],
    [
      "cordon",
      0.095
    ],
    [
      "galon",
      0.095
    ],
    [
      "torsade",
      0.095
    ],
    [
      "soutache",
      0.0475
    ],
    [
      "passementerie",
      0.0475
    ],
    [
      "natte",
      0.0475
    ],
    [
      "garcette",
      0.0475
    ],
    [
      "couette",
      0.0475
    ],
    [
      "cadenette",
      0.0475
    ],
    [
      "bourdalou",
      0.0475
    ],
    [
      "baderne",
      0.0475
    ],
    [
      "attache",
      0.0475
    ],
    [
      "tricot",
      0.0475
    ]
  ],
  "detresse": [
    [
      "chagrin",
      0.085
    ],
    [
      "affliction",
      0.075
    ],
    [
      "malheur",
      0.075
    ],
    [
      "misere",
      0.075
    ],
    [
      "tribulation",
      0.0675
    ],
    [
      "douleur",
      0.0575
    ],
    [
      "calamite",
      0.0575
    ],
    [
      "peine",
      0.0475
    ],
    [
      "angoisse",
      0.0375
    ],
    [
      "crise",
      0.0375
    ],
    [
      "pauvrete",
      0.0275
    ],
    [
      "indigence",
      0.0275
    ],
    [
      "desolation",
      0.0275
    ],
    [
      "desespoir",
      0.0275
    ],
    [
      "denuement",
      0.0275
    ],
    [
      "danger",
      0.0275
    ],
    [
      "trouble",
      0.0175
    ],
    [
      "poisse",
      0.0175
    ],
    [
      "infortune",
      0.0175
    ],
    [
      "desarroi",
      0.0175
    ],
    [
      "catastrophe",
      0.0175
    ],
    [
      "adversite",
      0.0175
    ],
    [
      "perdition",
      0.0075
    ],
    [
      "necessite",
      0.0075
    ],
    [
      "famine",
      0.0075
    ],
    [
      "desesperance",
      0.0075
    ],
    [
      "disgrace",
      0.0075
    ],
    [
      "berne",
      0.0075
    ],
    [
      "agonie",
      0.0075
    ],
    [
      "S.O.S.",
      0.0075
    ],
    [
      "peril",
      0.0075
    ]
  ],
  "recoller": [],
  "embrouiller": [
    [
      "brouiller",
      0.155
    ],
    [
      "troubler",
      0.1175
    ],
    [
      "embarrasser",
      0.09
    ],
    [
      "compliquer",
      0.065
    ],
    [
      "deranger",
      0.065
    ],
    [
      "melanger",
      0.05
    ],
    [
      "emmeler",
      0.05
    ],
    [
      "emberlificoter",
      0.05
    ],
    [
      "enchevetrer",
      0.0375
    ],
    [
      "embarbouiller",
      0.0375
    ],
    [
      "desorienter",
      0.0375
    ],
    [
      "deconcerter",
      0.0375
    ],
    [
      "confondre",
      0.0375
    ],
    [
      "embourber",
      0.025
    ],
    [
      "meler",
      0.025
    ],
    [
      "obscurcir",
      0.025
    ],
    [
      "entortiller",
      0.0125
    ],
    [
      "perturber",
      0.0125
    ]
  ],
  "embrouille": [
    [
      "imbroglio",
      0.4275
    ],
    [
      "brouillamini",
      0.1425
    ],
    [
      "embrouillamini",
      0.1425
    ],
    [
      "emmele",
      0.1425
    ],
    [
      "intrigue",
      0.1425
    ]
  ],
  "vadrouiller": [
    [
      "errer",
      0.165
    ],
    [
      "flaner",
      0.165
    ],
    [
      "vagabonder",
      0.165
    ],
    [
      "roder",
      0.125
    ],
    [
      "trainer",
      0.125
    ],
    [
      "marcher",
      0.0825
    ],
    [
      "trainasser",
      0.0825
    ],
    [
      "deambuler",
      0.04
    ],
    [
      "musarder",
      0.04
    ]
  ],
  "vadrouille": [
    [
      "balade",
      0.165
    ],
    [
      "balai",
      0.165
    ],
    [
      "fauber",
      0.165
    ],
    [
      "flanerie",
      0.165
    ],
    [
      "promenade",
      0.165
    ],
    [
      "tour",
      0.165
    ]
  ],
  "confondu": [
    [
      "deconcerter",
      0.09
    ],
    [
      "etonner",
      0.08
    ],
    [
      "derouter",
      0.055
    ],
    [
      "troubler",
      0.05
    ],
    [
      "accabler",
      0.045
    ],
    [
      "interloquer",
      0.04
    ],
    [
      "demonter",
      0.04
    ],
    [
      "abattre",
      0.04
    ],
    [
      "stupefier",
      0.035
    ],
    [
      "renverser",
      0.035
    ],
    [
      "aneantir",
      0.035
    ],
    [
      "ahurir",
      0.035
    ],
    [
      "surprendre",
      0.03
    ],
    [
      "melanger",
      0.025
    ],
    [
      "foudroyer",
      0.025
    ],
    [
      "fondre",
      0.025
    ],
    [
      "desorienter",
      0.025
    ],
    [
      "decontenancer",
      0.025
    ],
    [
      "meler",
      0.0175
    ],
    [
      "vaincre",
      0.0175
    ],
    [
      "interdire",
      0.0125
    ],
    [
      "embrouiller",
      0.0125
    ],
    [
      "desarconner",
      0.0125
    ],
    [
      "consterner",
      0.0125
    ],
    [
      "atterrer",
      0.0125
    ],
    [
      "amalgamer",
      0.0125
    ],
    [
      "unir",
      0.0075
    ],
    [
      "reunir",
      0.0075
    ],
    [
      "reduire",
      0.0075
    ],
    [
      "fusionner",
      0.0075
    ],
    [
      "brouiller",
      0.0075
    ],
    [
      "assommer",
      0.0075
    ],
    [
      "assimiler",
      0.0075
    ],
    [
      "aplatir",
      0.0075
    ],
    [
      "refuter",
      0.0025
    ],
    [
      "identifier",
      0.0025
    ],
    [
      "humilier",
      0.0025
    ],
    [
      "entrelacer",
      0.0025
    ],
    [
      "depasser",
      0.0025
    ],
    [
      "demasquer",
      0.0025
    ],
    [
      "dejouer",
      0.0025
    ],
    [
      "convaincre",
      0.0025
    ],
    [
      "catastropher",
      0.0025
    ],
    [
      "associer",
      0.0025
    ]
  ],
  "solidaire": [
    [
      "associe",
      0.1425
    ],
    [
      "dependant",
      0.1425
    ],
    [
      "engage",
      0.1425
    ],
    [
      "joint",
      0.1425
    ],
    [
      "lie",
      0.1425
    ],
    [
      "responsable",
      0.1425
    ],
    [
      "uni",
      0.1425
    ]
  ],
  "virevolter": [
    [
      "tourner",
      0.2725
    ],
    [
      "pivoter",
      0.135
    ],
    [
      "tournoyer",
      0.135
    ],
    [
      "pirouetter",
      0.09
    ],
    [
      "virer",
      0.09
    ],
    [
      "volter",
      0.045
    ],
    [
      "virevousser",
      0.045
    ],
    [
      "tourbillonner",
      0.045
    ],
    [
      "s'enrouler",
      0.045
    ],
    [
      "graviter",
      0.045
    ],
    [
      "evoluer",
      0.045
    ]
  ],
  "ballet": [
    [
      "danse",
      0.3
    ],
    [
      "spectacle",
      0.2
    ],
    [
      "activite",
      0.1
    ],
    [
      "choeur",
      0.1
    ],
    [
      "choregraphie",
      0.1
    ],
    [
      "divertissement",
      0.1
    ],
    [
      "mascarade",
      0.1
    ]
  ],
  "lent": [
    [
      "mou",
      0.1025
    ],
    [
      "nonchalant",
      0.08
    ],
    [
      "paresseux",
      0.08
    ],
    [
      "indolent",
      0.0675
    ],
    [
      "lourd",
      0.0575
    ],
    [
      "engourdi",
      0.045
    ],
    [
      "lourdaud",
      0.035
    ],
    [
      "lambin",
      0.035
    ],
    [
      "inerte",
      0.035
    ],
    [
      "endormi",
      0.035
    ],
    [
      "cagnard",
      0.035
    ],
    [
      "apathique",
      0.035
    ],
    [
      "trainard",
      0.0225
    ],
    [
      "pesant",
      0.0225
    ],
    [
      "gnangnan",
      0.0225
    ],
    [
      "flaneur",
      0.0225
    ],
    [
      "balourd",
      0.0225
    ],
    [
      "epais",
      0.0125
    ],
    [
      "penible",
      0.0125
    ],
    [
      "pose",
      0.0125
    ],
    [
      "mollasse",
      0.0125
    ],
    [
      "indecis",
      0.0125
    ],
    [
      "flegmatique",
      0.0125
    ],
    [
      "beotien",
      0.0125
    ],
    [
      "pataud",
      0.005
    ],
    [
      "retardataire",
      0.005
    ],
    [
      "stagnant",
      0.005
    ],
    [
      "tardif",
      0.005
    ],
    [
      "temporisateur",
      0.005
    ],
    [
      "tranquille",
      0.005
    ],
    [
      "trainant",
      0.005
    ],
    [
      "musard",
      0.005
    ],
    [
      "mesure",
      0.005
    ],
    [
      "long",
      0.005
    ],
    [
      "irresolu",
      0.005
    ],
    [
      "flemmard",
      0.005
    ],
    [
      "difficile",
      0.005
    ],
    [
      "calme",
      0.005
    ],
    [
      "arriere",
      0.005
    ],
    [
      "alangui",
      0.005
    ],
    [
      "traineur",
      0.005
    ]
  ],
  "lente": [
    [
      "mou",
      0.1025
    ],
    [
      "nonchalant",
      0.08
    ],
    [
      "paresseux",
      0.08
    ],
    [
      "indolent",
      0.0675
    ],
    [
      "lourd",
      0.0575
    ],
    [
      "engourdi",
      0.045
    ],
    [
      "lourdaud",
      0.035
    ],
    [
      "lambin",
      0.035
    ],
    [
      "inerte",
      0.035
    ],
    [
      "endormi",
      0.035
    ],
    [
      "cagnard",
      0.035
    ],
    [
      "apathique",
      0.035
    ],
    [
      "trainard",
      0.0225
    ],
    [
      "pesant",
      0.0225
    ],
    [
      "gnangnan",
      0.0225
    ],
    [
      "flaneur",
      0.0225
    ],
    [
      "balourd",
      0.0225
    ],
    [
      "epais",
      0.0125
    ],
    [
      "penible",
      0.0125
    ],
    [
      "pose",
      0.0125
    ],
    [
      "mollasse",
      0.0125
    ],
    [
      "indecis",
      0.0125
    ],
    [
      "flegmatique",
      0.0125
    ],
    [
      "beotien",
      0.0125
    ],
    [
      "pataud",
      0.005
    ],
    [
      "retardataire",
      0.005
    ],
    [
      "stagnant",
      0.005
    ],
    [
      "tardif",
      0.005
    ],
    [
      "temporisateur",
      0.005
    ],
    [
      "tranquille",
      0.005
    ],
    [
      "trainant",
      0.005
    ],
    [
      "musard",
      0.005
    ],
    [
      "mesure",
      0.005
    ],
    [
      "long",
      0.005
    ],
    [
      "irresolu",
      0.005
    ],
    [
      "flemmard",
      0.005
    ],
    [
      "difficile",
      0.005
    ],
    [
      "calme",
      0.005
    ],
    [
      "arriere",
      0.005
    ],
    [
      "alangui",
      0.005
    ],
    [
      "traineur",
      0.005
    ]
  ],
  "desenchanter": [
    [
      "desappointer",
      0.25
    ],
    [
      "decevoir",
      0.165
    ],
    [
      "desillusionner",
      0.165
    ],
    [
      "chagriner",
      0.0825
    ],
    [
      "decourager",
      0.0825
    ],
    [
      "degouter",
      0.0825
    ],
    [
      "degriser",
      0.0825
    ],
    [
      "navrer",
      0.0825
    ]
  ],
  "desenchante": [
    [
      "desappointer",
      0.25
    ],
    [
      "decevoir",
      0.165
    ],
    [
      "desillusionner",
      0.165
    ],
    [
      "chagriner",
      0.0825
    ],
    [
      "decourager",
      0.0825
    ],
    [
      "degouter",
      0.0825
    ],
    [
      "degriser",
      0.0825
    ],
    [
      "navrer",
      0.0825
    ]
  ],
  "saint": [
    [
      "sacre",
      0.1625
    ],
    [
      "venerable",
      0.11
    ],
    [
      "beau",
      0.08
    ],
    [
      "bienheureux",
      0.08
    ],
    [
      "glorieux",
      0.08
    ],
    [
      "elu",
      0.0525
    ],
    [
      "marabout",
      0.0525
    ],
    [
      "sauve",
      0.025
    ],
    [
      "sanctuaire",
      0.025
    ],
    [
      "pur",
      0.025
    ],
    [
      "pieux",
      0.025
    ],
    [
      "martyr",
      0.025
    ],
    [
      "intangible",
      0.025
    ],
    [
      "celicole",
      0.025
    ],
    [
      "consacre",
      0.025
    ],
    [
      "beat",
      0.025
    ],
    [
      "auguste",
      0.025
    ],
    [
      "apotre",
      0.025
    ],
    [
      "angelique",
      0.025
    ],
    [
      "vertueux",
      0.025
    ]
  ],
  "bercer": [
    [
      "consoler",
      0.0825
    ],
    [
      "tromper",
      0.0825
    ],
    [
      "endormir",
      0.0725
    ],
    [
      "apaiser",
      0.0625
    ],
    [
      "leurrer",
      0.0525
    ],
    [
      "calmer",
      0.0525
    ],
    [
      "amuser",
      0.0525
    ],
    [
      "adoucir",
      0.0525
    ],
    [
      "enjoler",
      0.04
    ],
    [
      "flatter",
      0.04
    ],
    [
      "soulager",
      0.03
    ],
    [
      "remuer",
      0.03
    ],
    [
      "charmer",
      0.03
    ],
    [
      "berner",
      0.03
    ],
    [
      "balancer",
      0.03
    ],
    [
      "assoupir",
      0.03
    ],
    [
      "abuser",
      0.03
    ],
    [
      "etourdir",
      0.02
    ],
    [
      "onduler",
      0.02
    ],
    [
      "mystifier",
      0.02
    ],
    [
      "caresser",
      0.02
    ],
    [
      "attenuer",
      0.02
    ],
    [
      "agiter",
      0.01
    ],
    [
      "dodeliner",
      0.01
    ],
    [
      "emporter",
      0.01
    ],
    [
      "illusionner",
      0.01
    ],
    [
      "ondoyer",
      0.01
    ],
    [
      "partager",
      0.01
    ],
    [
      "rythmer",
      0.01
    ]
  ],
  "femelle": [
    [
      "femme",
      0.25
    ],
    [
      "fleur",
      0.25
    ],
    [
      "feminin",
      0.25
    ],
    [
      "mere",
      0.25
    ]
  ],
  "complice": [
    [
      "associe",
      0.15
    ],
    [
      "partenaire",
      0.1325
    ],
    [
      "acolyte",
      0.1
    ],
    [
      "aide",
      0.0825
    ],
    [
      "compere",
      0.065
    ],
    [
      "compagnon",
      0.05
    ],
    [
      "allie",
      0.05
    ],
    [
      "affide",
      0.05
    ],
    [
      "copain",
      0.0325
    ],
    [
      "auxiliaire",
      0.0325
    ],
    [
      "affilie",
      0.0325
    ],
    [
      "receleur",
      0.015
    ],
    [
      "fauteur",
      0.015
    ],
    [
      "entendu",
      0.015
    ],
    [
      "cooperateur",
      0.015
    ],
    [
      "consort",
      0.015
    ],
    [
      "comparse",
      0.015
    ],
    [
      "coaccuse",
      0.015
    ],
    [
      "affranchi",
      0.015
    ],
    [
      "adherent",
      0.015
    ],
    [
      "suppot",
      0.015
    ]
  ],
  "paupiere": [],
  "cense": [
    [
      "repute",
      0.235
    ],
    [
      "presume",
      0.175
    ],
    [
      "suppose",
      0.175
    ],
    [
      "admis",
      0.0575
    ],
    [
      "considere",
      0.0575
    ],
    [
      "estime",
      0.0575
    ]
  ],
  "cligner": [
    [
      "clignoter",
      0.19
    ],
    [
      "papilloter",
      0.1425
    ],
    [
      "remuer",
      0.1425
    ],
    [
      "vaciller",
      0.1425
    ],
    [
      "ciller",
      0.095
    ],
    [
      "battre",
      0.095
    ],
    [
      "broncher",
      0.045
    ],
    [
      "friser",
      0.045
    ],
    [
      "scintiller",
      0.045
    ],
    [
      "trembloter",
      0.045
    ]
  ],
  "bracelet": [
    [
      "anneau",
      0.2275
    ],
    [
      "chaine",
      0.18
    ],
    [
      "bague",
      0.135
    ],
    [
      "cercle",
      0.09
    ],
    [
      "menottes",
      0.045
    ],
    [
      "jonc",
      0.045
    ],
    [
      "gourmette",
      0.045
    ],
    [
      "chainette",
      0.045
    ],
    [
      "bijou",
      0.045
    ],
    [
      "armille",
      0.045
    ],
    [
      "annelure",
      0.045
    ],
    [
      "psellion",
      0.045
    ]
  ],
  "ennuyeux": [
    [
      "importun",
      0.065
    ],
    [
      "desagreable",
      0.0575
    ],
    [
      "penible",
      0.0575
    ],
    [
      "assommant",
      0.0475
    ],
    [
      "fatigant",
      0.0475
    ],
    [
      "facheux",
      0.045
    ],
    [
      "embetant",
      0.0425
    ],
    [
      "raseur",
      0.0325
    ],
    [
      "fastidieux",
      0.0325
    ],
    [
      "somnifere",
      0.025
    ],
    [
      "insupportable",
      0.025
    ],
    [
      "barbant",
      0.0225
    ],
    [
      "sempiternel",
      0.0225
    ],
    [
      "accablant",
      0.0175
    ],
    [
      "desolant",
      0.015
    ],
    [
      "genant",
      0.015
    ],
    [
      "intolerable",
      0.015
    ],
    [
      "triste",
      0.015
    ],
    [
      "tendu",
      0.015
    ],
    [
      "rasant",
      0.015
    ],
    [
      "endormant",
      0.015
    ],
    [
      "empoisonnant",
      0.015
    ],
    [
      "affligeant",
      0.0125
    ],
    [
      "deplaisant",
      0.0125
    ],
    [
      "embarrassant",
      0.0125
    ],
    [
      "lassant",
      0.0125
    ],
    [
      "mortel",
      0.0125
    ],
    [
      "tuant",
      0.0125
    ],
    [
      "emmerdant",
      0.01
    ],
    [
      "degoutant",
      0.01
    ],
    [
      "pesant",
      0.01
    ],
    [
      "terne",
      0.0075
    ],
    [
      "insipide",
      0.0075
    ],
    [
      "enquiquinant",
      0.0075
    ],
    [
      "encombrant",
      0.0075
    ],
    [
      "enervant",
      0.005
    ],
    [
      "rebutant",
      0.005
    ],
    [
      "monotone",
      0.005
    ],
    [
      "fade",
      0.005
    ],
    [
      "difficile",
      0.005
    ],
    [
      "cruel",
      0.005
    ],
    [
      "contrariant",
      0.005
    ],
    [
      "incommode",
      0.005
    ],
    [
      "maussade",
      0.005
    ],
    [
      "eternel",
      0.0025
    ],
    [
      "suant",
      0.0025
    ],
    [
      "mourant",
      0.0025
    ],
    [
      "malplaisant",
      0.0025
    ],
    [
      "froid",
      0.0025
    ],
    [
      "affreux",
      0.0025
    ],
    [
      "long",
      0.0025
    ],
    [
      "narcotique",
      0.0025
    ],
    [
      "obsedant",
      0.0025
    ],
    [
      "saumatre",
      0.0025
    ],
    [
      "soporifique",
      0.0025
    ],
    [
      "sepulcral",
      0.0025
    ],
    [
      "tannant",
      0.0025
    ],
    [
      "ecoeurant",
      0.0025
    ],
    [
      "lancinant",
      0.0025
    ],
    [
      "enquiquineur",
      0.0025
    ],
    [
      "academique",
      0.0025
    ],
    [
      "assoupissant",
      0.0025
    ],
    [
      "bete",
      0.0025
    ],
    [
      "chiant",
      0.0025
    ],
    [
      "contraignant",
      0.0025
    ],
    [
      "emmerdeur",
      0.0025
    ],
    [
      "endormeur",
      0.0025
    ],
    [
      "ennuyant",
      0.0025
    ],
    [
      "desoeuvre",
      0.0
    ],
    [
      "inquietant",
      0.0
    ],
    [
      "malencontreux",
      0.0
    ],
    [
      "preoccupant",
      0.0
    ],
    [
      "sciant",
      0.0
    ],
    [
      "souciant",
      0.0
    ],
    [
      "desavantageux",
      0.0
    ],
    [
      "cramponnant",
      0.0
    ],
    [
      "crampon",
      0.0
    ],
    [
      "collant",
      0.0
    ],
    [
      "canule",
      0.0
    ],
    [
      "canulant",
      0.0
    ],
    [
      "bassin",
      0.0
    ],
    [
      "barbifiant",
      0.0
    ],
    [
      "barbe",
      0.0
    ],
    [
      "soulant",
      0.0
    ]
  ],
  "courtois": [
    [
      "poli",
      0.16
    ],
    [
      "gracieux",
      0.1225
    ],
    [
      "delicat",
      0.0925
    ],
    [
      "affable",
      0.0825
    ],
    [
      "aimable",
      0.075
    ],
    [
      "galant",
      0.065
    ],
    [
      "honnete",
      0.055
    ],
    [
      "prevenant",
      0.045
    ],
    [
      "distingue",
      0.045
    ],
    [
      "amene",
      0.045
    ],
    [
      "avenant",
      0.0375
    ],
    [
      "civil",
      0.0375
    ],
    [
      "sociable",
      0.0275
    ],
    [
      "elegant",
      0.0275
    ],
    [
      "correct",
      0.0175
    ],
    [
      "bienseant",
      0.0175
    ],
    [
      "abordable",
      0.0075
    ],
    [
      "deferent",
      0.0075
    ],
    [
      "raffine",
      0.0075
    ]
  ],
  "bourre": [
    [
      "remplir",
      0.085
    ],
    [
      "combler",
      0.065
    ],
    [
      "garnir",
      0.065
    ],
    [
      "gorger",
      0.055
    ],
    [
      "emplir",
      0.045
    ],
    [
      "enfoncer",
      0.045
    ],
    [
      "truffer",
      0.0375
    ],
    [
      "exagerer",
      0.0375
    ],
    [
      "charger",
      0.0375
    ],
    [
      "rembourrer",
      0.0275
    ],
    [
      "pousser",
      0.0275
    ],
    [
      "empiler",
      0.0275
    ],
    [
      "capitonner",
      0.0275
    ],
    [
      "bonder",
      0.0275
    ],
    [
      "accabler",
      0.0275
    ],
    [
      "abreuver",
      0.0275
    ],
    [
      "rassasier",
      0.0175
    ],
    [
      "gonfler",
      0.0175
    ],
    [
      "gaver",
      0.0175
    ],
    [
      "fourrer",
      0.0175
    ],
    [
      "embourrer",
      0.0175
    ],
    [
      "bluffer",
      0.0175
    ],
    [
      "battre",
      0.0175
    ],
    [
      "apprendre",
      0.0175
    ],
    [
      "matelasser",
      0.0075
    ],
    [
      "mentir",
      0.0075
    ],
    [
      "orner",
      0.0075
    ],
    [
      "persuader",
      0.0075
    ],
    [
      "posseder",
      0.0075
    ],
    [
      "rudoyer",
      0.0075
    ],
    [
      "maltraiter",
      0.0075
    ],
    [
      "gouger",
      0.0075
    ],
    [
      "farcir",
      0.0075
    ],
    [
      "endormir",
      0.0075
    ],
    [
      "empiffrer",
      0.0075
    ],
    [
      "empailler",
      0.0075
    ],
    [
      "cotonner",
      0.0075
    ],
    [
      "bonimenter",
      0.0075
    ],
    [
      "baratiner",
      0.0075
    ],
    [
      "approvisionner",
      0.0075
    ],
    [
      "tasser",
      0.0075
    ]
  ],
  "bourrer": [
    [
      "remplir",
      0.085
    ],
    [
      "combler",
      0.065
    ],
    [
      "garnir",
      0.065
    ],
    [
      "gorger",
      0.055
    ],
    [
      "emplir",
      0.045
    ],
    [
      "enfoncer",
      0.045
    ],
    [
      "truffer",
      0.0375
    ],
    [
      "exagerer",
      0.0375
    ],
    [
      "charger",
      0.0375
    ],
    [
      "rembourrer",
      0.0275
    ],
    [
      "pousser",
      0.0275
    ],
    [
      "empiler",
      0.0275
    ],
    [
      "capitonner",
      0.0275
    ],
    [
      "bonder",
      0.0275
    ],
    [
      "accabler",
      0.0275
    ],
    [
      "abreuver",
      0.0275
    ],
    [
      "rassasier",
      0.0175
    ],
    [
      "gonfler",
      0.0175
    ],
    [
      "gaver",
      0.0175
    ],
    [
      "fourrer",
      0.0175
    ],
    [
      "embourrer",
      0.0175
    ],
    [
      "bluffer",
      0.0175
    ],
    [
      "battre",
      0.0175
    ],
    [
      "apprendre",
      0.0175
    ],
    [
      "matelasser",
      0.0075
    ],
    [
      "mentir",
      0.0075
    ],
    [
      "orner",
      0.0075
    ],
    [
      "persuader",
      0.0075
    ],
    [
      "posseder",
      0.0075
    ],
    [
      "rudoyer",
      0.0075
    ],
    [
      "maltraiter",
      0.0075
    ],
    [
      "gouger",
      0.0075
    ],
    [
      "farcir",
      0.0075
    ],
    [
      "endormir",
      0.0075
    ],
    [
      "empiffrer",
      0.0075
    ],
    [
      "empailler",
      0.0075
    ],
    [
      "cotonner",
      0.0075
    ],
    [
      "bonimenter",
      0.0075
    ],
    [
      "baratiner",
      0.0075
    ],
    [
      "approvisionner",
      0.0075
    ],
    [
      "tasser",
      0.0075
    ]
  ],
  "anneau": [
    [
      "bague",
      0.0825
    ],
    [
      "attache",
      0.0725
    ],
    [
      "chaine",
      0.0725
    ],
    [
      "boucle",
      0.06
    ],
    [
      "bracelet",
      0.06
    ],
    [
      "cercle",
      0.06
    ],
    [
      "frette",
      0.035
    ],
    [
      "noeud",
      0.0225
    ],
    [
      "maille",
      0.0225
    ],
    [
      "collier",
      0.0225
    ],
    [
      "ansette",
      0.0225
    ],
    [
      "alliance",
      0.0225
    ],
    [
      "mouchette",
      0.01
    ],
    [
      "morne",
      0.01
    ],
    [
      "moraillon",
      0.01
    ],
    [
      "moraille",
      0.01
    ],
    [
      "manille",
      0.01
    ],
    [
      "manchon",
      0.01
    ],
    [
      "maillon",
      0.01
    ],
    [
      "jonc",
      0.01
    ],
    [
      "mousqueton",
      0.01
    ],
    [
      "organeau",
      0.01
    ],
    [
      "virole",
      0.01
    ],
    [
      "vervelle",
      0.01
    ],
    [
      "verterelle",
      0.01
    ],
    [
      "torde",
      0.01
    ],
    [
      "tirefond",
      0.01
    ],
    [
      "somite",
      0.01
    ],
    [
      "rond",
      0.01
    ],
    [
      "psellion",
      0.01
    ],
    [
      "frison",
      0.01
    ],
    [
      "fibule",
      0.01
    ],
    [
      "anglaise",
      0.01
    ],
    [
      "annelet",
      0.01
    ],
    [
      "annelure",
      0.01
    ],
    [
      "anse",
      0.01
    ],
    [
      "bouclette",
      0.01
    ],
    [
      "bride",
      0.01
    ],
    [
      "beliere",
      0.01
    ],
    [
      "capucine",
      0.01
    ],
    [
      "cerne",
      0.01
    ],
    [
      "chainon",
      0.01
    ],
    [
      "chevaliere",
      0.01
    ],
    [
      "cirre",
      0.01
    ],
    [
      "clavier",
      0.01
    ],
    [
      "coulant",
      0.01
    ],
    [
      "couronne",
      0.01
    ],
    [
      "erse",
      0.01
    ],
    [
      "estrope",
      0.01
    ],
    [
      "agres",
      0.01
    ]
  ],
  "mamie": [
    [
      "meme",
      0.165
    ]
  ],
  "macaque": [
    [
      "magot",
      0.3325
    ],
    [
      "singe",
      0.3325
    ],
    [
      "guenon",
      0.165
    ],
    [
      "vilain",
      0.165
    ]
  ],
  "tactile": [
    [
      "palpable",
      1.0
    ]
  ],
  "suc": [
    [
      "quintessence",
      0.165
    ],
    [
      "substance",
      0.165
    ],
    [
      "seve",
      0.0825
    ],
    [
      "nourriture",
      0.0825
    ],
    [
      "mucosite",
      0.0825
    ],
    [
      "jus",
      0.0825
    ],
    [
      "eau",
      0.0825
    ],
    [
      "chyle",
      0.0825
    ],
    [
      "elixir",
      0.0825
    ]
  ],
  "prepuce": [],
  "venue": [
    [
      "provenir",
      0.055
    ],
    [
      "sortir",
      0.055
    ],
    [
      "arriver",
      0.0525
    ],
    [
      "decouler",
      0.04
    ],
    [
      "proceder",
      0.04
    ],
    [
      "tomber",
      0.04
    ],
    [
      "naitre",
      0.035
    ],
    [
      "surgir",
      0.0325
    ],
    [
      "suivre",
      0.0325
    ],
    [
      "resulter",
      0.0275
    ],
    [
      "apparaitre",
      0.025
    ],
    [
      "avancer",
      0.025
    ],
    [
      "marcher",
      0.025
    ],
    [
      "emaner",
      0.02
    ],
    [
      "passer",
      0.02
    ],
    [
      "partir",
      0.02
    ],
    [
      "descendre",
      0.02
    ],
    [
      "approcher",
      0.02
    ],
    [
      "survenir",
      0.0175
    ],
    [
      "pousser",
      0.0175
    ],
    [
      "aborder",
      0.0175
    ],
    [
      "reussir",
      0.0125
    ],
    [
      "parvenir",
      0.0125
    ],
    [
      "deriver",
      0.0125
    ],
    [
      "tenir",
      0.01
    ],
    [
      "s'avancer",
      0.01
    ],
    [
      "s'approcher",
      0.01
    ],
    [
      "s'amener",
      0.01
    ],
    [
      "s'abouler",
      0.01
    ],
    [
      "remonter",
      0.01
    ],
    [
      "pointer",
      0.01
    ],
    [
      "entrer",
      0.01
    ],
    [
      "dependre",
      0.01
    ],
    [
      "s'offrir",
      0.005
    ],
    [
      "rappliquer",
      0.005
    ],
    [
      "radiner",
      0.005
    ],
    [
      "grandir",
      0.005
    ],
    [
      "debarquer",
      0.005
    ],
    [
      "croitre",
      0.005
    ],
    [
      "aboutir",
      0.005
    ],
    [
      "succeder",
      0.0025
    ],
    [
      "echoir",
      0.0025
    ],
    [
      "s'aviser",
      0.0025
    ],
    [
      "intervenir",
      0.0025
    ],
    [
      "dater",
      0.0025
    ]
  ],
  "disposer": [
    [
      "arranger",
      0.1
    ],
    [
      "organiser",
      0.0425
    ],
    [
      "harmoniser",
      0.04
    ],
    [
      "ordonner",
      0.04
    ],
    [
      "agencer",
      0.0375
    ],
    [
      "combiner",
      0.0325
    ],
    [
      "placer",
      0.0325
    ],
    [
      "preparer",
      0.0275
    ],
    [
      "monter",
      0.025
    ],
    [
      "accorder",
      0.025
    ],
    [
      "ajuster",
      0.0225
    ],
    [
      "mettre",
      0.0225
    ],
    [
      "amenager",
      0.02
    ],
    [
      "installer",
      0.02
    ],
    [
      "regler",
      0.02
    ],
    [
      "etablir",
      0.0175
    ],
    [
      "ranger",
      0.0175
    ],
    [
      "dresser",
      0.0175
    ],
    [
      "composer",
      0.0175
    ],
    [
      "adapter",
      0.0175
    ],
    [
      "assembler",
      0.015
    ],
    [
      "prendre",
      0.015
    ],
    [
      "accommoder",
      0.0125
    ],
    [
      "decider",
      0.0125
    ],
    [
      "distribuer",
      0.01
    ],
    [
      "construire",
      0.01
    ],
    [
      "constituer",
      0.01
    ],
    [
      "avoir",
      0.01
    ],
    [
      "presenter",
      0.0075
    ],
    [
      "faconner",
      0.0075
    ],
    [
      "exposer",
      0.0075
    ],
    [
      "employer",
      0.0075
    ],
    [
      "determiner",
      0.0075
    ],
    [
      "dominer",
      0.0075
    ],
    [
      "commander",
      0.0075
    ],
    [
      "caser",
      0.0075
    ],
    [
      "appreter",
      0.0075
    ],
    [
      "appareiller",
      0.0075
    ],
    [
      "aligner",
      0.0075
    ],
    [
      "user",
      0.0075
    ],
    [
      "tourner",
      0.0075
    ],
    [
      "situer",
      0.0075
    ],
    [
      "regir",
      0.0075
    ],
    [
      "posseder",
      0.0075
    ],
    [
      "poser",
      0.0075
    ],
    [
      "engager",
      0.0075
    ],
    [
      "utiliser",
      0.005
    ],
    [
      "provoquer",
      0.005
    ],
    [
      "pousser",
      0.005
    ],
    [
      "occuper",
      0.005
    ],
    [
      "manier",
      0.005
    ],
    [
      "decreter",
      0.005
    ],
    [
      "dicter",
      0.005
    ],
    [
      "couvrir",
      0.005
    ],
    [
      "coordonner",
      0.005
    ],
    [
      "charger",
      0.005
    ],
    [
      "repartir",
      0.0025
    ],
    [
      "tendre",
      0.0025
    ],
    [
      "trancher",
      0.0025
    ],
    [
      "ebaucher",
      0.0025
    ],
    [
      "predisposer",
      0.0025
    ],
    [
      "prescrire",
      0.0025
    ],
    [
      "orner",
      0.0025
    ],
    [
      "assortir",
      0.0025
    ],
    [
      "detenir",
      0.0025
    ],
    [
      "inciter",
      0.0025
    ],
    [
      "jouir",
      0.0025
    ],
    [
      "orienter",
      0.0025
    ],
    [
      "aliener",
      0.0
    ],
    [
      "aposter",
      0.0
    ],
    [
      "ceindre",
      0.0
    ],
    [
      "encourager",
      0.0
    ]
  ],
  "dispose": [
    [
      "arranger",
      0.1
    ],
    [
      "organiser",
      0.0425
    ],
    [
      "harmoniser",
      0.04
    ],
    [
      "ordonner",
      0.04
    ],
    [
      "agencer",
      0.0375
    ],
    [
      "combiner",
      0.0325
    ],
    [
      "placer",
      0.0325
    ],
    [
      "preparer",
      0.0275
    ],
    [
      "monter",
      0.025
    ],
    [
      "accorder",
      0.025
    ],
    [
      "ajuster",
      0.0225
    ],
    [
      "mettre",
      0.0225
    ],
    [
      "amenager",
      0.02
    ],
    [
      "installer",
      0.02
    ],
    [
      "regler",
      0.02
    ],
    [
      "etablir",
      0.0175
    ],
    [
      "ranger",
      0.0175
    ],
    [
      "dresser",
      0.0175
    ],
    [
      "composer",
      0.0175
    ],
    [
      "adapter",
      0.0175
    ],
    [
      "assembler",
      0.015
    ],
    [
      "prendre",
      0.015
    ],
    [
      "accommoder",
      0.0125
    ],
    [
      "decider",
      0.0125
    ],
    [
      "distribuer",
      0.01
    ],
    [
      "construire",
      0.01
    ],
    [
      "constituer",
      0.01
    ],
    [
      "avoir",
      0.01
    ],
    [
      "presenter",
      0.0075
    ],
    [
      "faconner",
      0.0075
    ],
    [
      "exposer",
      0.0075
    ],
    [
      "employer",
      0.0075
    ],
    [
      "determiner",
      0.0075
    ],
    [
      "dominer",
      0.0075
    ],
    [
      "commander",
      0.0075
    ],
    [
      "caser",
      0.0075
    ],
    [
      "appreter",
      0.0075
    ],
    [
      "appareiller",
      0.0075
    ],
    [
      "aligner",
      0.0075
    ],
    [
      "user",
      0.0075
    ],
    [
      "tourner",
      0.0075
    ],
    [
      "situer",
      0.0075
    ],
    [
      "regir",
      0.0075
    ],
    [
      "posseder",
      0.0075
    ],
    [
      "poser",
      0.0075
    ],
    [
      "engager",
      0.0075
    ],
    [
      "utiliser",
      0.005
    ],
    [
      "provoquer",
      0.005
    ],
    [
      "pousser",
      0.005
    ],
    [
      "occuper",
      0.005
    ],
    [
      "manier",
      0.005
    ],
    [
      "decreter",
      0.005
    ],
    [
      "dicter",
      0.005
    ],
    [
      "couvrir",
      0.005
    ],
    [
      "coordonner",
      0.005
    ],
    [
      "charger",
      0.005
    ],
    [
      "repartir",
      0.0025
    ],
    [
      "tendre",
      0.0025
    ],
    [
      "trancher",
      0.0025
    ],
    [
      "ebaucher",
      0.0025
    ],
    [
      "predisposer",
      0.0025
    ],
    [
      "prescrire",
      0.0025
    ],
    [
      "orner",
      0.0025
    ],
    [
      "assortir",
      0.0025
    ],
    [
      "detenir",
      0.0025
    ],
    [
      "inciter",
      0.0025
    ],
    [
      "jouir",
      0.0025
    ],
    [
      "orienter",
      0.0025
    ],
    [
      "aliener",
      0.0
    ],
    [
      "aposter",
      0.0
    ],
    [
      "ceindre",
      0.0
    ],
    [
      "encourager",
      0.0
    ]
  ],
  "pisse": [
    [
      "urine",
      0.4
    ],
    [
      "eau",
      0.2
    ],
    [
      "pipi",
      0.2
    ],
    [
      "pissat",
      0.2
    ]
  ],
  "recipient": [
    [
      "pot",
      0.15
    ],
    [
      "vase",
      0.125
    ],
    [
      "contenant",
      0.1
    ],
    [
      "ustensile",
      0.0475
    ],
    [
      "hanap",
      0.0475
    ],
    [
      "boite",
      0.0475
    ],
    [
      "bol",
      0.0475
    ],
    [
      "bassin",
      0.0475
    ],
    [
      "vaisseau",
      0.0225
    ],
    [
      "seau",
      0.0225
    ],
    [
      "sac",
      0.0225
    ],
    [
      "receptacle",
      0.0225
    ],
    [
      "quart",
      0.0225
    ],
    [
      "moque",
      0.0225
    ],
    [
      "matras",
      0.0225
    ],
    [
      "jatte",
      0.0225
    ],
    [
      "casse",
      0.0225
    ],
    [
      "bouille",
      0.0225
    ],
    [
      "bocal",
      0.0225
    ],
    [
      "beurrier",
      0.0225
    ],
    [
      "benne",
      0.0225
    ],
    [
      "baquet",
      0.0225
    ],
    [
      "verre",
      0.0225
    ]
  ],
  "reel": [
    [
      "vrai",
      0.135
    ],
    [
      "tangible",
      0.1075
    ],
    [
      "certain",
      0.1
    ],
    [
      "authentique",
      0.0725
    ],
    [
      "positif",
      0.05
    ],
    [
      "sincere",
      0.0475
    ],
    [
      "evident",
      0.04
    ],
    [
      "incontestable",
      0.04
    ],
    [
      "exact",
      0.035
    ],
    [
      "sur",
      0.03
    ],
    [
      "veritable",
      0.03
    ],
    [
      "veridique",
      0.025
    ],
    [
      "indubitable",
      0.02
    ],
    [
      "manifeste",
      0.0175
    ],
    [
      "solide",
      0.0175
    ],
    [
      "assure",
      0.015
    ],
    [
      "juste",
      0.015
    ],
    [
      "etabli",
      0.015
    ],
    [
      "patent",
      0.0125
    ],
    [
      "fonde",
      0.0125
    ],
    [
      "effectif",
      0.0125
    ],
    [
      "concret",
      0.0125
    ],
    [
      "palpable",
      0.0075
    ],
    [
      "officiel",
      0.0075
    ],
    [
      "objectif",
      0.0075
    ],
    [
      "existant",
      0.0075
    ],
    [
      "verite",
      0.005
    ],
    [
      "visible",
      0.005
    ],
    [
      "serieux",
      0.005
    ],
    [
      "realite",
      0.005
    ],
    [
      "indiscutable",
      0.005
    ],
    [
      "historique",
      0.005
    ],
    [
      "admis",
      0.005
    ],
    [
      "actuel",
      0.005
    ],
    [
      "realise",
      0.0025
    ],
    [
      "recu",
      0.0025
    ],
    [
      "physique",
      0.0025
    ],
    [
      "litteral",
      0.0025
    ],
    [
      "intrinseque",
      0.0025
    ],
    [
      "inconteste",
      0.0025
    ],
    [
      "fait",
      0.0025
    ],
    [
      "factuel",
      0.0025
    ],
    [
      "demontre",
      0.0025
    ],
    [
      "vecu",
      0.0025
    ]
  ],
  "chibre": [],
  "tremper": [
    [
      "mouiller",
      0.1
    ],
    [
      "imbiber",
      0.075
    ],
    [
      "baigner",
      0.0675
    ],
    [
      "arroser",
      0.0575
    ],
    [
      "humecter",
      0.0575
    ],
    [
      "impregner",
      0.0575
    ],
    [
      "endurcir",
      0.04
    ],
    [
      "penetrer",
      0.0325
    ],
    [
      "inonder",
      0.0325
    ],
    [
      "fortifier",
      0.0325
    ],
    [
      "cuirasser",
      0.0325
    ],
    [
      "asperger",
      0.0325
    ],
    [
      "affermir",
      0.0225
    ],
    [
      "infuser",
      0.015
    ],
    [
      "macerer",
      0.015
    ],
    [
      "noyer",
      0.015
    ],
    [
      "plonger",
      0.015
    ],
    [
      "renforcer",
      0.015
    ],
    [
      "transpercer",
      0.015
    ],
    [
      "imboire",
      0.015
    ],
    [
      "emboire",
      0.015
    ],
    [
      "detremper",
      0.015
    ],
    [
      "aguerrir",
      0.015
    ],
    [
      "blinder",
      0.015
    ],
    [
      "couper",
      0.015
    ],
    [
      "doucher",
      0.015
    ],
    [
      "durcir",
      0.015
    ],
    [
      "delaver",
      0.015
    ],
    [
      "saucer",
      0.0075
    ],
    [
      "rincer",
      0.0075
    ],
    [
      "retremper",
      0.0075
    ],
    [
      "percer",
      0.0075
    ],
    [
      "participer",
      0.0075
    ],
    [
      "melanger",
      0.0075
    ],
    [
      "mariner",
      0.0075
    ],
    [
      "fricoter",
      0.0075
    ],
    [
      "faconner",
      0.0075
    ],
    [
      "barboter",
      0.0075
    ]
  ],
  "trempe": [
    [
      "caractere",
      0.0925
    ],
    [
      "volee",
      0.0825
    ],
    [
      "rossee",
      0.07
    ],
    [
      "raclee",
      0.07
    ],
    [
      "pile",
      0.07
    ],
    [
      "nature",
      0.07
    ],
    [
      "type",
      0.045
    ],
    [
      "valeur",
      0.035
    ],
    [
      "sorte",
      0.035
    ],
    [
      "roulee",
      0.035
    ],
    [
      "qualite",
      0.035
    ],
    [
      "piquette",
      0.035
    ],
    [
      "coup",
      0.035
    ],
    [
      "ame",
      0.0225
    ],
    [
      "torgnole",
      0.0225
    ],
    [
      "style",
      0.0225
    ],
    [
      "peignee",
      0.0225
    ],
    [
      "frottee",
      0.0225
    ],
    [
      "degelee",
      0.0225
    ],
    [
      "acabit",
      0.0225
    ],
    [
      "temperament",
      0.01
    ],
    [
      "saucee",
      0.01
    ],
    [
      "reverdissage",
      0.01
    ],
    [
      "naturel",
      0.01
    ],
    [
      "mouille",
      0.01
    ],
    [
      "endurance",
      0.01
    ],
    [
      "cementation",
      0.01
    ],
    [
      "chaleur",
      0.01
    ],
    [
      "trempee",
      0.01
    ]
  ],
  "concocter": [
    [
      "preparer",
      0.3325
    ],
    [
      "echafauder",
      0.3325
    ],
    [
      "elaborer",
      0.3325
    ]
  ],
  "risotto": [],
  "pratique": [
    [
      "usage",
      0.06
    ],
    [
      "experience",
      0.05
    ],
    [
      "habitude",
      0.035
    ],
    [
      "action",
      0.03
    ],
    [
      "technique",
      0.025
    ],
    [
      "mode",
      0.025
    ],
    [
      "facile",
      0.025
    ],
    [
      "positif",
      0.0175
    ],
    [
      "procede",
      0.0175
    ],
    [
      "rite",
      0.0175
    ],
    [
      "realiste",
      0.0175
    ],
    [
      "tradition",
      0.0175
    ],
    [
      "truc",
      0.0175
    ],
    [
      "metier",
      0.0175
    ],
    [
      "methode",
      0.0175
    ],
    [
      "client",
      0.0175
    ],
    [
      "conduite",
      0.0175
    ],
    [
      "coutume",
      0.0175
    ],
    [
      "execution",
      0.0175
    ],
    [
      "frequentation",
      0.0175
    ],
    [
      "habilete",
      0.0175
    ],
    [
      "realisation",
      0.0125
    ],
    [
      "ordinaire",
      0.0125
    ],
    [
      "materiel",
      0.0125
    ],
    [
      "fidele",
      0.0125
    ],
    [
      "faire",
      0.0125
    ],
    [
      "connaissance",
      0.0125
    ],
    [
      "commode",
      0.0125
    ],
    [
      "application",
      0.0125
    ],
    [
      "possible",
      0.0075
    ],
    [
      "pragmatique",
      0.0075
    ],
    [
      "praticable",
      0.0075
    ],
    [
      "procedure",
      0.0075
    ],
    [
      "routine",
      0.0075
    ],
    [
      "utile",
      0.0075
    ],
    [
      "utilisable",
      0.0075
    ],
    [
      "utilitaire",
      0.0075
    ],
    [
      "moeurs",
      0.0075
    ],
    [
      "materialiste",
      0.0075
    ],
    [
      "fait",
      0.0075
    ],
    [
      "acte",
      0.0075
    ],
    [
      "apprentissage",
      0.0075
    ],
    [
      "chaland",
      0.0075
    ],
    [
      "clientele",
      0.0075
    ],
    [
      "culte",
      0.0075
    ],
    [
      "ergonomique",
      0.0075
    ],
    [
      "exercice",
      0.0075
    ],
    [
      "experimentation",
      0.0075
    ],
    [
      "paroissien",
      0.0025
    ],
    [
      "ouaille",
      0.0025
    ],
    [
      "observance",
      0.0025
    ],
    [
      "normatif",
      0.0025
    ],
    [
      "maniable",
      0.0025
    ],
    [
      "logeable",
      0.0025
    ],
    [
      "ingenieux",
      0.0025
    ],
    [
      "habitue",
      0.0025
    ],
    [
      "perfectionnement",
      0.0025
    ],
    [
      "possession",
      0.0025
    ],
    [
      "pratiquant",
      0.0025
    ],
    [
      "vogue",
      0.0025
    ],
    [
      "savoir",
      0.0025
    ],
    [
      "realisable",
      0.0025
    ],
    [
      "religion",
      0.0025
    ],
    [
      "profitable",
      0.0025
    ],
    [
      "praxis",
      0.0025
    ],
    [
      "praxique",
      0.0025
    ],
    [
      "fonctionnel",
      0.0025
    ],
    [
      "familiarite",
      0.0025
    ],
    [
      "assistance",
      0.0025
    ],
    [
      "applicable",
      0.0025
    ],
    [
      "aise",
      0.0025
    ],
    [
      "agissements",
      0.0025
    ],
    [
      "adapte",
      0.0025
    ],
    [
      "acquereur",
      0.0025
    ],
    [
      "acheteur",
      0.0025
    ],
    [
      "achalandage",
      0.0025
    ],
    [
      "astucieux",
      0.0025
    ],
    [
      "commerce",
      0.0025
    ],
    [
      "familiarisation",
      0.0025
    ],
    [
      "faisable",
      0.0025
    ],
    [
      "executable",
      0.0025
    ],
    [
      "experimental",
      0.0025
    ],
    [
      "empirique",
      0.0025
    ],
    [
      "efficace",
      0.0025
    ],
    [
      "devotion",
      0.0025
    ],
    [
      "concret",
      0.0025
    ],
    [
      "accomplissement",
      0.0025
    ]
  ],
  "pratiquer": [
    [
      "faire",
      0.0775
    ],
    [
      "user",
      0.0675
    ],
    [
      "voir",
      0.05
    ],
    [
      "executer",
      0.04
    ],
    [
      "frequenter",
      0.04
    ],
    [
      "tenir",
      0.035
    ],
    [
      "suivre",
      0.035
    ],
    [
      "exercer",
      0.035
    ],
    [
      "cultiver",
      0.035
    ],
    [
      "realiser",
      0.03
    ],
    [
      "frayer",
      0.03
    ],
    [
      "employer",
      0.03
    ],
    [
      "utiliser",
      0.025
    ],
    [
      "s'adonner",
      0.025
    ],
    [
      "observer",
      0.025
    ],
    [
      "jouer",
      0.025
    ],
    [
      "accomplir",
      0.025
    ],
    [
      "eprouver",
      0.0175
    ],
    [
      "vivre",
      0.0175
    ],
    [
      "s'appliquer",
      0.0175
    ],
    [
      "manier",
      0.0175
    ],
    [
      "effectuer",
      0.0175
    ],
    [
      "appliquer",
      0.0175
    ],
    [
      "visiter",
      0.015
    ],
    [
      "proceder",
      0.015
    ],
    [
      "menager",
      0.015
    ],
    [
      "hanter",
      0.015
    ],
    [
      "experimenter",
      0.015
    ],
    [
      "entendre",
      0.015
    ],
    [
      "consommer",
      0.015
    ],
    [
      "etablir",
      0.0075
    ],
    [
      "s'interesser",
      0.0075
    ],
    [
      "percer",
      0.0075
    ],
    [
      "garder",
      0.0075
    ],
    [
      "connaitre",
      0.0075
    ],
    [
      "adopter",
      0.0075
    ],
    [
      "recourir",
      0.0025
    ],
    [
      "professer",
      0.0025
    ],
    [
      "parler",
      0.0025
    ],
    [
      "ouvrir",
      0.0025
    ],
    [
      "operer",
      0.0025
    ],
    [
      "s'entrainer",
      0.0025
    ]
  ],
  "coince": [
    [
      "fixer",
      0.15
    ],
    [
      "retenir",
      0.11
    ],
    [
      "prendre",
      0.0775
    ],
    [
      "tenir",
      0.0675
    ],
    [
      "maintenir",
      0.0675
    ],
    [
      "immobiliser",
      0.0675
    ],
    [
      "assurer",
      0.0575
    ],
    [
      "caler",
      0.0575
    ],
    [
      "assujettir",
      0.0475
    ],
    [
      "bloquer",
      0.0475
    ],
    [
      "serrer",
      0.0375
    ],
    [
      "arrimer",
      0.0375
    ],
    [
      "rencogner",
      0.0175
    ],
    [
      "piquer",
      0.0175
    ],
    [
      "pincer",
      0.0175
    ],
    [
      "comprimer",
      0.0175
    ],
    [
      "acculer",
      0.0175
    ],
    [
      "chauffer",
      0.0075
    ],
    [
      "engager",
      0.0075
    ],
    [
      "envahir",
      0.0075
    ],
    [
      "raffermir",
      0.0075
    ],
    [
      "surprendre",
      0.0075
    ]
  ],
  "coincer": [
    [
      "fixer",
      0.15
    ],
    [
      "retenir",
      0.11
    ],
    [
      "prendre",
      0.0775
    ],
    [
      "tenir",
      0.0675
    ],
    [
      "maintenir",
      0.0675
    ],
    [
      "immobiliser",
      0.0675
    ],
    [
      "assurer",
      0.0575
    ],
    [
      "caler",
      0.0575
    ],
    [
      "assujettir",
      0.0475
    ],
    [
      "bloquer",
      0.0475
    ],
    [
      "serrer",
      0.0375
    ],
    [
      "arrimer",
      0.0375
    ],
    [
      "rencogner",
      0.0175
    ],
    [
      "piquer",
      0.0175
    ],
    [
      "pincer",
      0.0175
    ],
    [
      "comprimer",
      0.0175
    ],
    [
      "acculer",
      0.0175
    ],
    [
      "chauffer",
      0.0075
    ],
    [
      "engager",
      0.0075
    ],
    [
      "envahir",
      0.0075
    ],
    [
      "raffermir",
      0.0075
    ],
    [
      "surprendre",
      0.0075
    ]
  ],
  "decision": [
    [
      "resolution",
      0.0875
    ],
    [
      "courage",
      0.0725
    ],
    [
      "volonte",
      0.0575
    ],
    [
      "energie",
      0.0575
    ],
    [
      "fermete",
      0.0525
    ],
    [
      "decret",
      0.0425
    ],
    [
      "determination",
      0.0375
    ],
    [
      "audace",
      0.0325
    ],
    [
      "hardiesse",
      0.0325
    ],
    [
      "reglement",
      0.0275
    ],
    [
      "ressort",
      0.0275
    ],
    [
      "jugement",
      0.0275
    ],
    [
      "cran",
      0.0275
    ],
    [
      "assurance",
      0.0275
    ],
    [
      "arret",
      0.0275
    ],
    [
      "temerite",
      0.0225
    ],
    [
      "sentence",
      0.0225
    ],
    [
      "dessein",
      0.0225
    ],
    [
      "caractere",
      0.0225
    ],
    [
      "arrete",
      0.0225
    ],
    [
      "disposition",
      0.0175
    ],
    [
      "prescription",
      0.0175
    ],
    [
      "solution",
      0.0125
    ],
    [
      "propos",
      0.0125
    ],
    [
      "parti",
      0.0125
    ],
    [
      "ordonnance",
      0.0125
    ],
    [
      "action",
      0.0125
    ],
    [
      "acte",
      0.0125
    ],
    [
      "intention",
      0.0075
    ],
    [
      "initiative",
      0.0075
    ],
    [
      "conclusion",
      0.0075
    ],
    [
      "choix",
      0.0075
    ],
    [
      "bras",
      0.0075
    ],
    [
      "autorite",
      0.0075
    ],
    [
      "arbitrage",
      0.0075
    ],
    [
      "verdict",
      0.0025
    ],
    [
      "resultat",
      0.0025
    ],
    [
      "oukase",
      0.0025
    ],
    [
      "homologation",
      0.0025
    ],
    [
      "condamnation",
      0.0025
    ],
    [
      "caprice",
      0.0025
    ],
    [
      "canon",
      0.0025
    ],
    [
      "attitude",
      0.0025
    ],
    [
      "edit",
      0.0025
    ]
  ],
  "transporte": [
    [
      "exciter",
      0.07
    ],
    [
      "entrainer",
      0.045
    ],
    [
      "enflammer",
      0.0425
    ],
    [
      "conduire",
      0.0375
    ],
    [
      "exalter",
      0.0375
    ],
    [
      "porter",
      0.0375
    ],
    [
      "enlever",
      0.0325
    ],
    [
      "soulever",
      0.0325
    ],
    [
      "enthousiasmer",
      0.03
    ],
    [
      "ravir",
      0.0225
    ],
    [
      "transmettre",
      0.0225
    ],
    [
      "electriser",
      0.0225
    ],
    [
      "deplacer",
      0.02
    ],
    [
      "enfievrer",
      0.02
    ],
    [
      "mener",
      0.02
    ],
    [
      "trainer",
      0.0175
    ],
    [
      "envoyer",
      0.0175
    ],
    [
      "emporter",
      0.0175
    ],
    [
      "amener",
      0.0175
    ],
    [
      "passer",
      0.015
    ],
    [
      "galvaniser",
      0.015
    ],
    [
      "charrier",
      0.015
    ],
    [
      "charmer",
      0.015
    ],
    [
      "apporter",
      0.015
    ],
    [
      "elever",
      0.01
    ],
    [
      "renvoyer",
      0.01
    ],
    [
      "remettre",
      0.01
    ],
    [
      "introduire",
      0.01
    ],
    [
      "enivrer",
      0.01
    ],
    [
      "emmener",
      0.01
    ],
    [
      "emballer",
      0.01
    ],
    [
      "animer",
      0.01
    ],
    [
      "echauffer",
      0.01
    ],
    [
      "vehiculer",
      0.01
    ],
    [
      "transferer",
      0.01
    ],
    [
      "promener",
      0.01
    ],
    [
      "importer",
      0.01
    ],
    [
      "bouleverser",
      0.01
    ],
    [
      "agiter",
      0.01
    ],
    [
      "voiturer",
      0.005
    ],
    [
      "trimballer",
      0.005
    ],
    [
      "transposer",
      0.005
    ],
    [
      "transplanter",
      0.005
    ],
    [
      "saisir",
      0.005
    ],
    [
      "rouler",
      0.005
    ],
    [
      "reporter",
      0.005
    ],
    [
      "passionner",
      0.005
    ],
    [
      "expedier",
      0.005
    ],
    [
      "acheminer",
      0.005
    ],
    [
      "livrer",
      0.005
    ],
    [
      "manipuler",
      0.005
    ],
    [
      "repandre",
      0.005
    ],
    [
      "transiter",
      0.005
    ],
    [
      "implanter",
      0.005
    ],
    [
      "exporter",
      0.005
    ],
    [
      "deranger",
      0.005
    ],
    [
      "deporter",
      0.005
    ],
    [
      "demenager",
      0.005
    ],
    [
      "descendre",
      0.005
    ],
    [
      "engouer",
      0.0
    ],
    [
      "negocier",
      0.0
    ],
    [
      "releguer",
      0.0
    ],
    [
      "surexciter",
      0.0
    ],
    [
      "transbahuter",
      0.0
    ],
    [
      "transborder",
      0.0
    ],
    [
      "translater",
      0.0
    ],
    [
      "egarer",
      0.0
    ],
    [
      "emprunter",
      0.0
    ],
    [
      "colporter",
      0.0
    ],
    [
      "adapter",
      0.0
    ],
    [
      "ailer",
      0.0
    ],
    [
      "bannir",
      0.0
    ],
    [
      "camionner",
      0.0
    ],
    [
      "carrosser",
      0.0
    ],
    [
      "chambouler",
      0.0
    ],
    [
      "charroyer",
      0.0
    ],
    [
      "chavirer",
      0.0
    ],
    [
      "emerveiller",
      0.0
    ]
  ],
  "transporter": [
    [
      "exciter",
      0.07
    ],
    [
      "entrainer",
      0.045
    ],
    [
      "enflammer",
      0.0425
    ],
    [
      "conduire",
      0.0375
    ],
    [
      "exalter",
      0.0375
    ],
    [
      "porter",
      0.0375
    ],
    [
      "enlever",
      0.0325
    ],
    [
      "soulever",
      0.0325
    ],
    [
      "enthousiasmer",
      0.03
    ],
    [
      "ravir",
      0.0225
    ],
    [
      "transmettre",
      0.0225
    ],
    [
      "electriser",
      0.0225
    ],
    [
      "deplacer",
      0.02
    ],
    [
      "enfievrer",
      0.02
    ],
    [
      "mener",
      0.02
    ],
    [
      "trainer",
      0.0175
    ],
    [
      "envoyer",
      0.0175
    ],
    [
      "emporter",
      0.0175
    ],
    [
      "amener",
      0.0175
    ],
    [
      "passer",
      0.015
    ],
    [
      "galvaniser",
      0.015
    ],
    [
      "charrier",
      0.015
    ],
    [
      "charmer",
      0.015
    ],
    [
      "apporter",
      0.015
    ],
    [
      "elever",
      0.01
    ],
    [
      "renvoyer",
      0.01
    ],
    [
      "remettre",
      0.01
    ],
    [
      "introduire",
      0.01
    ],
    [
      "enivrer",
      0.01
    ],
    [
      "emmener",
      0.01
    ],
    [
      "emballer",
      0.01
    ],
    [
      "animer",
      0.01
    ],
    [
      "echauffer",
      0.01
    ],
    [
      "vehiculer",
      0.01
    ],
    [
      "transferer",
      0.01
    ],
    [
      "promener",
      0.01
    ],
    [
      "importer",
      0.01
    ],
    [
      "bouleverser",
      0.01
    ],
    [
      "agiter",
      0.01
    ],
    [
      "voiturer",
      0.005
    ],
    [
      "trimballer",
      0.005
    ],
    [
      "transposer",
      0.005
    ],
    [
      "transplanter",
      0.005
    ],
    [
      "saisir",
      0.005
    ],
    [
      "rouler",
      0.005
    ],
    [
      "reporter",
      0.005
    ],
    [
      "passionner",
      0.005
    ],
    [
      "expedier",
      0.005
    ],
    [
      "acheminer",
      0.005
    ],
    [
      "livrer",
      0.005
    ],
    [
      "manipuler",
      0.005
    ],
    [
      "repandre",
      0.005
    ],
    [
      "transiter",
      0.005
    ],
    [
      "implanter",
      0.005
    ],
    [
      "exporter",
      0.005
    ],
    [
      "deranger",
      0.005
    ],
    [
      "deporter",
      0.005
    ],
    [
      "demenager",
      0.005
    ],
    [
      "descendre",
      0.005
    ],
    [
      "engouer",
      0.0
    ],
    [
      "negocier",
      0.0
    ],
    [
      "releguer",
      0.0
    ],
    [
      "surexciter",
      0.0
    ],
    [
      "transbahuter",
      0.0
    ],
    [
      "transborder",
      0.0
    ],
    [
      "translater",
      0.0
    ],
    [
      "egarer",
      0.0
    ],
    [
      "emprunter",
      0.0
    ],
    [
      "colporter",
      0.0
    ],
    [
      "adapter",
      0.0
    ],
    [
      "ailer",
      0.0
    ],
    [
      "bannir",
      0.0
    ],
    [
      "camionner",
      0.0
    ],
    [
      "carrosser",
      0.0
    ],
    [
      "chambouler",
      0.0
    ],
    [
      "charroyer",
      0.0
    ],
    [
      "chavirer",
      0.0
    ],
    [
      "emerveiller",
      0.0
    ]
  ],
  "flocon": [
    [
      "houppe",
      0.375
    ],
    [
      "caillot",
      0.125
    ],
    [
      "floche",
      0.125
    ],
    [
      "houppette",
      0.125
    ],
    [
      "mousse",
      0.125
    ],
    [
      "touffe",
      0.125
    ]
  ],
  "mai": [],
  "encrage": [],
  "cahot": [
    [
      "obstacle",
      0.085
    ],
    [
      "secousse",
      0.085
    ],
    [
      "soubresaut",
      0.085
    ],
    [
      "traverse",
      0.065
    ],
    [
      "difficulte",
      0.065
    ],
    [
      "bond",
      0.065
    ],
    [
      "tirage",
      0.0425
    ],
    [
      "mouvement",
      0.0425
    ],
    [
      "heurt",
      0.0425
    ],
    [
      "contrariete",
      0.0425
    ],
    [
      "caillou",
      0.0425
    ],
    [
      "ballottement",
      0.0425
    ],
    [
      "anicroche",
      0.0425
    ],
    [
      "accroc",
      0.0425
    ],
    [
      "saut",
      0.02
    ],
    [
      "ressaut",
      0.02
    ],
    [
      "peripetie",
      0.02
    ],
    [
      "inegalite",
      0.02
    ],
    [
      "cahotement",
      0.02
    ],
    [
      "vicissitude",
      0.02
    ]
  ],
  "encaisse": [
    [
      "caisse",
      0.5
    ],
    [
      "compte",
      0.5
    ]
  ],
  "symptome": [
    [
      "signe",
      0.18
    ],
    [
      "marque",
      0.135
    ],
    [
      "presage",
      0.135
    ],
    [
      "indice",
      0.09
    ],
    [
      "prodrome",
      0.09
    ],
    [
      "signal",
      0.09
    ],
    [
      "stigmate",
      0.045
    ],
    [
      "manifestation",
      0.045
    ],
    [
      "diagnostique",
      0.045
    ],
    [
      "syndrome",
      0.045
    ]
  ],
  "four": [
    [
      "barbecue",
      0.08
    ],
    [
      "etuve",
      0.08
    ],
    [
      "echec",
      0.08
    ],
    [
      "insucces",
      0.08
    ],
    [
      "fourneau",
      0.08
    ],
    [
      "fournaise",
      0.08
    ],
    [
      "fiasco",
      0.08
    ],
    [
      "faillite",
      0.08
    ],
    [
      "bide",
      0.08
    ],
    [
      "flop",
      0.04
    ],
    [
      "desastre",
      0.04
    ],
    [
      "chute",
      0.04
    ],
    [
      "brasero",
      0.04
    ],
    [
      "bidon",
      0.04
    ],
    [
      "autoclave",
      0.04
    ],
    [
      "roustissure",
      0.04
    ]
  ],
  "tentation": [
    [
      "attrait",
      0.15
    ],
    [
      "desir",
      0.15
    ],
    [
      "appel",
      0.0975
    ],
    [
      "soif",
      0.0975
    ],
    [
      "passion",
      0.0475
    ],
    [
      "obsession",
      0.0475
    ],
    [
      "envie",
      0.0475
    ],
    [
      "chair",
      0.0475
    ],
    [
      "blandice",
      0.0475
    ],
    [
      "besoin",
      0.0475
    ],
    [
      "appat",
      0.0475
    ],
    [
      "allechement",
      0.0475
    ],
    [
      "aiguillon",
      0.0475
    ],
    [
      "sollicitation",
      0.0475
    ]
  ],
  "nefaste": [
    [
      "mauvais",
      0.1475
    ],
    [
      "nuisible",
      0.115
    ],
    [
      "funeste",
      0.1025
    ],
    [
      "pernicieux",
      0.0975
    ],
    [
      "dangereux",
      0.055
    ],
    [
      "nocif",
      0.0425
    ],
    [
      "defavorable",
      0.0425
    ],
    [
      "dommageable",
      0.0425
    ],
    [
      "contraire",
      0.035
    ],
    [
      "fatal",
      0.035
    ],
    [
      "malheureux",
      0.03
    ],
    [
      "malefique",
      0.03
    ],
    [
      "prejudiciable",
      0.03
    ],
    [
      "facheux",
      0.0225
    ],
    [
      "malsain",
      0.0175
    ],
    [
      "ennemi",
      0.0175
    ],
    [
      "redoutable",
      0.01
    ],
    [
      "mortel",
      0.01
    ],
    [
      "hostile",
      0.01
    ],
    [
      "horrible",
      0.01
    ],
    [
      "desastreux",
      0.01
    ],
    [
      "deplorable",
      0.01
    ],
    [
      "deletere",
      0.01
    ],
    [
      "destructeur",
      0.01
    ],
    [
      "abominable",
      0.005
    ],
    [
      "atroce",
      0.005
    ],
    [
      "irreparable",
      0.005
    ],
    [
      "monstrueux",
      0.005
    ]
  ],
  "fugu": [
    [
      "tetrodon",
      1.0
    ]
  ],
  "investigation": [
    [
      "recherche",
      0.22
    ],
    [
      "examen",
      0.1475
    ],
    [
      "enquete",
      0.11
    ],
    [
      "reconnaissance",
      0.11
    ],
    [
      "observation",
      0.0725
    ],
    [
      "perquisition",
      0.0725
    ],
    [
      "palpation",
      0.035
    ],
    [
      "information",
      0.035
    ],
    [
      "expertise",
      0.035
    ],
    [
      "demonstration",
      0.035
    ],
    [
      "disquisition",
      0.035
    ],
    [
      "chevauchee",
      0.035
    ],
    [
      "toucher",
      0.035
    ]
  ],
  "excitation": [
    [
      "exaltation",
      0.0925
    ],
    [
      "agitation",
      0.08
    ],
    [
      "effervescence",
      0.06
    ],
    [
      "fievre",
      0.0575
    ],
    [
      "bouillonnement",
      0.0525
    ],
    [
      "ardeur",
      0.045
    ],
    [
      "surexcitation",
      0.045
    ],
    [
      "passion",
      0.0375
    ],
    [
      "enthousiasme",
      0.03
    ],
    [
      "frenesie",
      0.025
    ],
    [
      "transport",
      0.0225
    ],
    [
      "delire",
      0.0225
    ],
    [
      "chaleur",
      0.02
    ],
    [
      "feu",
      0.02
    ],
    [
      "irritation",
      0.02
    ],
    [
      "emotion",
      0.0175
    ],
    [
      "trouble",
      0.0175
    ],
    [
      "nervosite",
      0.0175
    ],
    [
      "animation",
      0.015
    ],
    [
      "fermentation",
      0.015
    ],
    [
      "erethisme",
      0.015
    ],
    [
      "flamme",
      0.015
    ],
    [
      "echauffement",
      0.015
    ],
    [
      "ivresse",
      0.0125
    ],
    [
      "colere",
      0.0125
    ],
    [
      "embrasement",
      0.01
    ],
    [
      "incitation",
      0.01
    ],
    [
      "impulsion",
      0.0075
    ],
    [
      "transe",
      0.0075
    ],
    [
      "enervement",
      0.0075
    ],
    [
      "turbulence",
      0.0075
    ],
    [
      "febrilite",
      0.0075
    ],
    [
      "exasperation",
      0.0075
    ],
    [
      "enivrement",
      0.0075
    ],
    [
      "appel",
      0.0075
    ],
    [
      "emoi",
      0.005
    ],
    [
      "ebullition",
      0.005
    ],
    [
      "stimulation",
      0.005
    ],
    [
      "griserie",
      0.005
    ],
    [
      "exhortation",
      0.005
    ],
    [
      "action",
      0.005
    ],
    [
      "emulation",
      0.0025
    ],
    [
      "sollicitation",
      0.0025
    ],
    [
      "ravissement",
      0.0025
    ],
    [
      "provocation",
      0.0025
    ],
    [
      "invitation",
      0.0025
    ],
    [
      "instigation",
      0.0025
    ],
    [
      "entrainement",
      0.0025
    ],
    [
      "faction",
      0.0
    ],
    [
      "fomentation",
      0.0
    ],
    [
      "fumee",
      0.0
    ],
    [
      "induction",
      0.0
    ],
    [
      "sensation",
      0.0
    ],
    [
      "stimulus",
      0.0
    ],
    [
      "exacerbation",
      0.0
    ],
    [
      "euphorie",
      0.0
    ],
    [
      "enfievrement",
      0.0
    ],
    [
      "encouragement",
      0.0
    ],
    [
      "chatouillement",
      0.0
    ],
    [
      "attisement",
      0.0
    ],
    [
      "aigreur",
      0.0
    ],
    [
      "acharnement",
      0.0
    ],
    [
      "tarentule",
      0.0
    ]
  ],
  "palpable": [
    [
      "tangible",
      0.175
    ],
    [
      "manifeste",
      0.15
    ],
    [
      "evident",
      0.125
    ],
    [
      "sensible",
      0.075
    ],
    [
      "reel",
      0.075
    ],
    [
      "positif",
      0.075
    ],
    [
      "concret",
      0.075
    ],
    [
      "certain",
      0.075
    ],
    [
      "clair",
      0.05
    ],
    [
      "materiel",
      0.05
    ],
    [
      "exterieur",
      0.025
    ],
    [
      "patent",
      0.025
    ],
    [
      "tactile",
      0.025
    ]
  ],
  "engin": [
    [
      "instrument",
      0.1775
    ],
    [
      "machine",
      0.155
    ],
    [
      "appareil",
      0.11
    ],
    [
      "outil",
      0.0875
    ],
    [
      "truc",
      0.0875
    ],
    [
      "machin",
      0.065
    ],
    [
      "ustensile",
      0.0425
    ],
    [
      "moyen",
      0.0425
    ],
    [
      "bidule",
      0.0425
    ],
    [
      "agres",
      0.02
    ],
    [
      "astronef",
      0.02
    ],
    [
      "bombe",
      0.02
    ],
    [
      "ingeniosite",
      0.02
    ],
    [
      "mine",
      0.02
    ],
    [
      "missile",
      0.02
    ],
    [
      "moteur",
      0.02
    ],
    [
      "moto",
      0.02
    ]
  ],
  "bled": [
    [
      "trou",
      0.16
    ],
    [
      "coin",
      0.12
    ],
    [
      "patelin",
      0.12
    ],
    [
      "pays",
      0.12
    ],
    [
      "solitude",
      0.0775
    ],
    [
      "region",
      0.0775
    ],
    [
      "desert",
      0.0775
    ],
    [
      "campagne",
      0.0775
    ],
    [
      "cambrousse",
      0.0775
    ],
    [
      "brousse",
      0.0375
    ],
    [
      "village",
      0.0375
    ]
  ],
  "urne": [
    [
      "ascidie",
      0.25
    ],
    [
      "capsule",
      0.25
    ],
    [
      "jarre",
      0.25
    ],
    [
      "vase",
      0.25
    ]
  ],
  "spi": [],
  "piaule": [
    [
      "chambre",
      0.2625
    ],
    [
      "cambuse",
      0.1575
    ],
    [
      "taule",
      0.1575
    ],
    [
      "carree",
      0.1025
    ],
    [
      "casbah",
      0.1025
    ],
    [
      "gourbi",
      0.1025
    ],
    [
      "piece",
      0.1025
    ]
  ],
  "bio": [],
  "symbiose": [
    [
      "association",
      0.3325
    ],
    [
      "union",
      0.3325
    ],
    [
      "vie",
      0.3325
    ]
  ],
  "boucle": [
    [
      "attache",
      0.105
    ],
    [
      "anneau",
      0.0725
    ],
    [
      "agrafe",
      0.0575
    ],
    [
      "crochet",
      0.0575
    ],
    [
      "fermoir",
      0.0575
    ],
    [
      "noeud",
      0.045
    ],
    [
      "frison",
      0.045
    ],
    [
      "frisette",
      0.045
    ],
    [
      "anglaise",
      0.045
    ],
    [
      "meche",
      0.0275
    ],
    [
      "fibule",
      0.0275
    ],
    [
      "detour",
      0.0275
    ],
    [
      "coiffure",
      0.0275
    ],
    [
      "bouclette",
      0.0275
    ],
    [
      "fermeture",
      0.0125
    ],
    [
      "frisure",
      0.0125
    ],
    [
      "laguis",
      0.0125
    ],
    [
      "looping",
      0.0125
    ],
    [
      "maille",
      0.0125
    ],
    [
      "meandre",
      0.0125
    ],
    [
      "oeil",
      0.0125
    ],
    [
      "pendant",
      0.0125
    ],
    [
      "fermail",
      0.0125
    ],
    [
      "dormeuse",
      0.0125
    ],
    [
      "ardillon",
      0.0125
    ],
    [
      "bijou",
      0.0125
    ],
    [
      "boudin",
      0.0125
    ],
    [
      "chichi",
      0.0125
    ],
    [
      "clip",
      0.0125
    ],
    [
      "courbe",
      0.0125
    ],
    [
      "cran",
      0.0125
    ],
    [
      "cycle",
      0.0125
    ],
    [
      "pendeloque",
      0.0125
    ]
  ],
  "alcoolisme": [
    [
      "ivresse",
      0.2675
    ],
    [
      "ivrognerie",
      0.2675
    ],
    [
      "absinthisme",
      0.065
    ],
    [
      "alcoolomanie",
      0.065
    ],
    [
      "boisson",
      0.065
    ],
    [
      "dipsomanie",
      0.065
    ],
    [
      "oenilisme",
      0.065
    ],
    [
      "soulographie",
      0.065
    ],
    [
      "ethylisme",
      0.065
    ]
  ],
  "libido": [
    [
      "concupiscence",
      0.285
    ],
    [
      "desir",
      0.1425
    ],
    [
      "sens",
      0.1425
    ],
    [
      "sensualite",
      0.1425
    ],
    [
      "chaleur",
      0.095
    ],
    [
      "chair",
      0.045
    ],
    [
      "envie",
      0.045
    ],
    [
      "plaisir",
      0.045
    ],
    [
      "sexualite",
      0.045
    ]
  ],
  "arbitrer": [
    [
      "juger",
      0.25
    ],
    [
      "trancher",
      0.0825
    ],
    [
      "estimer",
      0.0825
    ],
    [
      "departager",
      0.0825
    ],
    [
      "decider",
      0.0825
    ],
    [
      "concilier",
      0.0825
    ],
    [
      "arranger",
      0.0825
    ],
    [
      "accorder",
      0.0825
    ],
    [
      "accommoder",
      0.0825
    ],
    [
      "evaluer",
      0.0825
    ]
  ],
  "arbitre": [
    [
      "expert",
      0.11
    ],
    [
      "juge",
      0.11
    ],
    [
      "maitre",
      0.11
    ],
    [
      "mediateur",
      0.11
    ],
    [
      "negociateur",
      0.11
    ],
    [
      "syndic",
      0.055
    ],
    [
      "souverain",
      0.055
    ],
    [
      "sifflet",
      0.055
    ],
    [
      "departiteur",
      0.055
    ],
    [
      "conciliateur",
      0.055
    ],
    [
      "appreciateur",
      0.055
    ],
    [
      "tiers",
      0.055
    ]
  ],
  "ecchymose": [
    [
      "bleu",
      0.2375
    ],
    [
      "meurtrissure",
      0.1425
    ],
    [
      "blessure",
      0.095
    ],
    [
      "coup",
      0.095
    ],
    [
      "hematome",
      0.095
    ],
    [
      "pincon",
      0.045
    ],
    [
      "hemorragie",
      0.045
    ],
    [
      "extravasation",
      0.045
    ],
    [
      "contusion",
      0.045
    ],
    [
      "beigne",
      0.045
    ],
    [
      "tache",
      0.045
    ]
  ],
  "esquimau": [
    [
      "glace",
      1.0
    ]
  ],
  "guimauve": [],
  "incompris": [
    [
      "meconnu",
      1.0
    ]
  ],
  "ski": [],
  "perche": [
    [
      "baton",
      0.085
    ],
    [
      "echalas",
      0.0575
    ],
    [
      "tuteur",
      0.0575
    ],
    [
      "geant",
      0.0575
    ],
    [
      "grand",
      0.0575
    ],
    [
      "gaule",
      0.0575
    ],
    [
      "gaffe",
      0.0575
    ],
    [
      "juchoir",
      0.0275
    ],
    [
      "latte",
      0.0275
    ],
    [
      "micro",
      0.0275
    ],
    [
      "perchis",
      0.0275
    ],
    [
      "perchoir",
      0.0275
    ],
    [
      "rame",
      0.0275
    ],
    [
      "rouable",
      0.0275
    ],
    [
      "serran",
      0.0275
    ],
    [
      "houssine",
      0.0275
    ],
    [
      "gremille",
      0.0275
    ],
    [
      "girafe",
      0.0275
    ],
    [
      "age",
      0.0275
    ],
    [
      "anabas",
      0.0275
    ],
    [
      "balise",
      0.0275
    ],
    [
      "bouille",
      0.0275
    ],
    [
      "cor",
      0.0275
    ],
    [
      "corne",
      0.0275
    ],
    [
      "croc",
      0.0275
    ],
    [
      "ecoperche",
      0.0275
    ]
  ],
  "teleski": [
    [
      "remontee",
      0.165
    ],
    [
      "telesiege",
      0.165
    ]
  ],
  "optimum": [
    [
      "optimal",
      1.0
    ]
  ],
  "combi": [],
  "godiller": [
    [
      "ramer",
      1.0
    ]
  ],
  "godille": [
    [
      "aviron",
      0.5
    ],
    [
      "rame",
      0.5
    ]
  ],
  "bis": [
    [
      "bistre",
      0.2625
    ],
    [
      "beige",
      0.1575
    ],
    [
      "brun",
      0.105
    ],
    [
      "gris",
      0.105
    ],
    [
      "jaunatre",
      0.105
    ],
    [
      "basane",
      0.05
    ],
    [
      "bistre",
      0.05
    ],
    [
      "brunatre",
      0.05
    ]
  ],
  "saucisson": [
    [
      "charcuterie",
      0.3325
    ],
    [
      "andouille",
      0.11
    ],
    [
      "boudin",
      0.11
    ],
    [
      "cervelas",
      0.11
    ],
    [
      "sauciflard",
      0.11
    ],
    [
      "sifflard",
      0.11
    ]
  ],
  "terrasse": [
    [
      "belvedere",
      0.11
    ],
    [
      "comble",
      0.11
    ],
    [
      "esplanade",
      0.11
    ],
    [
      "promenade",
      0.11
    ],
    [
      "terrassement",
      0.11
    ],
    [
      "toit",
      0.11
    ],
    [
      "vire",
      0.11
    ]
  ],
  "terrasser": [
    [
      "abattre",
      0.17
    ],
    [
      "renverser",
      0.1125
    ],
    [
      "aneantir",
      0.09
    ],
    [
      "vaincre",
      0.0775
    ],
    [
      "ecraser",
      0.0775
    ],
    [
      "culbuter",
      0.055
    ],
    [
      "accabler",
      0.045
    ],
    [
      "triompher",
      0.045
    ],
    [
      "reduire",
      0.0325
    ],
    [
      "mater",
      0.0325
    ],
    [
      "foudroyer",
      0.0325
    ],
    [
      "dompter",
      0.0325
    ],
    [
      "etendre",
      0.0225
    ],
    [
      "faucher",
      0.0225
    ],
    [
      "demolir",
      0.0225
    ],
    [
      "coucher",
      0.0225
    ],
    [
      "consterner",
      0.0225
    ],
    [
      "atterrer",
      0.01
    ],
    [
      "creuser",
      0.01
    ],
    [
      "maitriser",
      0.01
    ],
    [
      "museler",
      0.01
    ],
    [
      "tomber",
      0.01
    ]
  ],
  "crevasse": [
    [
      "fente",
      0.215
    ],
    [
      "faille",
      0.0975
    ],
    [
      "cavite",
      0.0775
    ],
    [
      "fissure",
      0.0775
    ],
    [
      "gercure",
      0.0775
    ],
    [
      "trou",
      0.0575
    ],
    [
      "entaille",
      0.0575
    ],
    [
      "dechirure",
      0.0575
    ],
    [
      "rainure",
      0.0375
    ],
    [
      "lezarde",
      0.0375
    ],
    [
      "cassure",
      0.0375
    ],
    [
      "anfractuosite",
      0.0375
    ],
    [
      "craquelure",
      0.0175
    ],
    [
      "engelure",
      0.0175
    ],
    [
      "fondriere",
      0.0175
    ],
    [
      "precipice",
      0.0175
    ],
    [
      "renfoncement",
      0.0175
    ],
    [
      "rhagade",
      0.0175
    ]
  ],
  "ecrevisse": [
    [
      "homard",
      0.3325
    ],
    [
      "rouge",
      0.3325
    ],
    [
      "tenaille",
      0.3325
    ]
  ],
  "altitude": [
    [
      "cote",
      0.2
    ],
    [
      "haut",
      0.2
    ],
    [
      "hauteur",
      0.2
    ],
    [
      "plafond",
      0.2
    ],
    [
      "elevation",
      0.2
    ]
  ],
  "poudreux": [
    [
      "cendreux",
      0.25
    ],
    [
      "poussiereux",
      0.25
    ],
    [
      "pulverulent",
      0.25
    ],
    [
      "sablonneux",
      0.25
    ]
  ],
  "chamois": [
    [
      "cuir",
      0.2
    ],
    [
      "isard",
      0.2
    ],
    [
      "jaune",
      0.2
    ],
    [
      "kaki",
      0.2
    ],
    [
      "peau",
      0.2
    ]
  ],
  "parallele": [
    [
      "analogue",
      0.11
    ],
    [
      "semblable",
      0.11
    ],
    [
      "comparable",
      0.0725
    ],
    [
      "comparaison",
      0.0725
    ],
    [
      "pareil",
      0.0725
    ],
    [
      "rapprochement",
      0.0725
    ],
    [
      "marginal",
      0.035
    ],
    [
      "occulte",
      0.035
    ],
    [
      "proche",
      0.035
    ],
    [
      "recoupement",
      0.035
    ],
    [
      "tranchee",
      0.035
    ],
    [
      "illegal",
      0.035
    ],
    [
      "homogene",
      0.035
    ],
    [
      "fosse",
      0.035
    ],
    [
      "derivation",
      0.035
    ],
    [
      "clandestin",
      0.035
    ],
    [
      "cercle",
      0.035
    ],
    [
      "assimilation",
      0.035
    ],
    [
      "tropique",
      0.035
    ]
  ],
  "telesiege": [
    [
      "remontee",
      0.25
    ],
    [
      "telebenne",
      0.25
    ],
    [
      "teleferique",
      0.25
    ],
    [
      "teleski",
      0.25
    ]
  ],
  "ample": [
    [
      "gros",
      0.13
    ],
    [
      "vaste",
      0.13
    ],
    [
      "grand",
      0.0925
    ],
    [
      "abondant",
      0.0825
    ],
    [
      "large",
      0.0725
    ],
    [
      "fort",
      0.0725
    ],
    [
      "plein",
      0.045
    ],
    [
      "riche",
      0.045
    ],
    [
      "spacieux",
      0.035
    ],
    [
      "etendu",
      0.035
    ],
    [
      "retentissant",
      0.0275
    ],
    [
      "immense",
      0.0275
    ],
    [
      "considerable",
      0.0275
    ],
    [
      "volumineux",
      0.0175
    ],
    [
      "sonore",
      0.0175
    ],
    [
      "resonnant",
      0.0175
    ],
    [
      "gras",
      0.0175
    ],
    [
      "developpe",
      0.0175
    ],
    [
      "copieux",
      0.0175
    ],
    [
      "majestueux",
      0.0075
    ],
    [
      "tonitruant",
      0.0075
    ],
    [
      "eleve",
      0.0075
    ],
    [
      "epanoui",
      0.0075
    ],
    [
      "etoffe",
      0.0075
    ]
  ],
  "connaissance": [
    [
      "intelligence",
      0.1025
    ],
    [
      "savoir",
      0.0525
    ],
    [
      "conception",
      0.0475
    ],
    [
      "idee",
      0.0425
    ],
    [
      "notion",
      0.0425
    ],
    [
      "entendement",
      0.0375
    ],
    [
      "raison",
      0.0325
    ],
    [
      "comprehension",
      0.0325
    ],
    [
      "clarte",
      0.025
    ],
    [
      "experience",
      0.025
    ],
    [
      "usage",
      0.02
    ],
    [
      "perception",
      0.02
    ],
    [
      "lucidite",
      0.02
    ],
    [
      "imagination",
      0.02
    ],
    [
      "discernement",
      0.02
    ],
    [
      "conscience",
      0.02
    ],
    [
      "bagage",
      0.02
    ],
    [
      "sentiment",
      0.015
    ],
    [
      "science",
      0.015
    ],
    [
      "sagesse",
      0.015
    ],
    [
      "penetration",
      0.015
    ],
    [
      "pratique",
      0.015
    ],
    [
      "lumiere",
      0.015
    ],
    [
      "frequentation",
      0.015
    ],
    [
      "faculte",
      0.015
    ],
    [
      "competence",
      0.015
    ],
    [
      "intuition",
      0.01
    ],
    [
      "liaison",
      0.01
    ],
    [
      "possession",
      0.01
    ],
    [
      "prescience",
      0.01
    ],
    [
      "relation",
      0.01
    ],
    [
      "education",
      0.01
    ],
    [
      "intellect",
      0.01
    ],
    [
      "instruction",
      0.01
    ],
    [
      "culture",
      0.01
    ],
    [
      "accointage",
      0.01
    ],
    [
      "accointance",
      0.01
    ],
    [
      "acquis",
      0.01
    ],
    [
      "ami",
      0.01
    ],
    [
      "ballot",
      0.01
    ],
    [
      "cognition",
      0.01
    ],
    [
      "prevision",
      0.005
    ],
    [
      "representation",
      0.005
    ],
    [
      "ressource",
      0.005
    ],
    [
      "teinture",
      0.005
    ],
    [
      "trace",
      0.005
    ],
    [
      "element",
      0.005
    ],
    [
      "intellection",
      0.005
    ],
    [
      "certitude",
      0.005
    ],
    [
      "camarade",
      0.005
    ],
    [
      "apprehension",
      0.005
    ],
    [
      "apercu",
      0.005
    ],
    [
      "amante",
      0.005
    ],
    [
      "acquisition",
      0.005
    ],
    [
      "acolyte",
      0.005
    ],
    [
      "erudition",
      0.005
    ]
  ],
  "bolee": [
    [
      "bol",
      0.5
    ],
    [
      "jatte",
      0.5
    ]
  ],
  "loisir": [
    [
      "delassement",
      0.0675
    ],
    [
      "inaction",
      0.0675
    ],
    [
      "repos",
      0.0675
    ],
    [
      "recreation",
      0.0675
    ],
    [
      "vacances",
      0.05
    ],
    [
      "permission",
      0.05
    ],
    [
      "detente",
      0.05
    ],
    [
      "divertissement",
      0.05
    ],
    [
      "distraction",
      0.05
    ],
    [
      "amusement",
      0.05
    ],
    [
      "possibilite",
      0.0325
    ],
    [
      "plaisir",
      0.0325
    ],
    [
      "oisivete",
      0.0325
    ],
    [
      "liberte",
      0.0325
    ],
    [
      "desoeuvrement",
      0.0325
    ],
    [
      "conge",
      0.0325
    ],
    [
      "temps",
      0.015
    ],
    [
      "plaisance",
      0.015
    ],
    [
      "pause",
      0.015
    ],
    [
      "occupation",
      0.015
    ],
    [
      "occasion",
      0.015
    ],
    [
      "licence",
      0.015
    ],
    [
      "latitude",
      0.015
    ],
    [
      "farniente",
      0.015
    ],
    [
      "desoccupation",
      0.015
    ]
  ],
  "bater": [],
  "dragueur": [
    [
      "cavaleur",
      0.25
    ],
    [
      "drague",
      0.25
    ],
    [
      "pisteur",
      0.25
    ],
    [
      "revoyeur",
      0.25
    ]
  ],
  "tchatche": [],
  "tchatcher": [],
  "dormant": [
    [
      "cache",
      0.1
    ],
    [
      "stagnant",
      0.1
    ],
    [
      "somnolent",
      0.1
    ],
    [
      "occulte",
      0.1
    ],
    [
      "mort",
      0.1
    ],
    [
      "inerte",
      0.1
    ],
    [
      "immobile",
      0.1
    ],
    [
      "endormi",
      0.065
    ],
    [
      "latent",
      0.065
    ],
    [
      "tranquille",
      0.065
    ],
    [
      "enfoui",
      0.0325
    ],
    [
      "fixe",
      0.0325
    ],
    [
      "souterrain",
      0.0325
    ]
  ],
  "trottoir": [
    [
      "bitume",
      0.1325
    ],
    [
      "macadam",
      0.1325
    ],
    [
      "pave",
      0.1325
    ],
    [
      "quai",
      0.1325
    ],
    [
      "rue",
      0.1325
    ],
    [
      "prostitution",
      0.065
    ],
    [
      "accotement",
      0.065
    ],
    [
      "ruban",
      0.065
    ]
  ],
  "junkie": [],
  "ambulance": [
    [
      "infirmerie",
      0.285
    ],
    [
      "antenne",
      0.1425
    ],
    [
      "autochir",
      0.1425
    ],
    [
      "hopital",
      0.1425
    ]
  ],
  "casbah": [
    [
      "piaule",
      0.285
    ],
    [
      "taule",
      0.285
    ],
    [
      "creche",
      0.1425
    ],
    [
      "gourbi",
      0.1425
    ],
    [
      "turne",
      0.1425
    ]
  ],
  "prophete": [
    [
      "devin",
      0.1725
    ],
    [
      "visionnaire",
      0.1375
    ],
    [
      "annonciateur",
      0.1025
    ],
    [
      "voyant",
      0.1025
    ],
    [
      "vaticinateur",
      0.0675
    ],
    [
      "oracle",
      0.0675
    ],
    [
      "messager",
      0.0675
    ],
    [
      "inspire",
      0.0675
    ],
    [
      "augure",
      0.0325
    ],
    [
      "cerveau",
      0.0325
    ],
    [
      "heraut",
      0.0325
    ],
    [
      "nabi",
      0.0325
    ],
    [
      "poete",
      0.0325
    ],
    [
      "precurseur",
      0.0325
    ]
  ],
  "chorus": [
    [
      "approbation",
      0.25
    ],
    [
      "choeur",
      0.25
    ],
    [
      "concert",
      0.25
    ],
    [
      "improvisation",
      0.25
    ]
  ],
  "cavale": [
    [
      "jument",
      0.3325
    ],
    [
      "cheval",
      0.22
    ],
    [
      "haquenee",
      0.11
    ],
    [
      "pouliche",
      0.11
    ],
    [
      "pouliniere",
      0.11
    ],
    [
      "evasion",
      0.11
    ]
  ],
  "cavaler": [
    [
      "courir",
      0.2125
    ],
    [
      "fuir",
      0.2125
    ],
    [
      "detaler",
      0.1425
    ],
    [
      "decamper",
      0.07
    ],
    [
      "empoisonner",
      0.07
    ],
    [
      "galoper",
      0.07
    ],
    [
      "pedaler",
      0.07
    ],
    [
      "raser",
      0.07
    ],
    [
      "s'evader",
      0.07
    ]
  ],
  "automatique": [
    [
      "involontaire",
      0.1725
    ],
    [
      "instinctif",
      0.085
    ],
    [
      "machinal",
      0.085
    ],
    [
      "mecanique",
      0.085
    ],
    [
      "reflexe",
      0.0575
    ],
    [
      "irreflechi",
      0.0575
    ],
    [
      "inconscient",
      0.0575
    ],
    [
      "systematique",
      0.0275
    ],
    [
      "stereotype",
      0.0275
    ],
    [
      "spontane",
      0.0275
    ],
    [
      "programme",
      0.0275
    ],
    [
      "passif",
      0.0275
    ],
    [
      "mathematique",
      0.0275
    ],
    [
      "informatise",
      0.0275
    ],
    [
      "informatique",
      0.0275
    ],
    [
      "force",
      0.0275
    ],
    [
      "cybernetique",
      0.0275
    ],
    [
      "convulsif",
      0.0275
    ],
    [
      "browning",
      0.0275
    ],
    [
      "automatisme",
      0.0275
    ],
    [
      "sur",
      0.0275
    ]
  ],
  "carreau": [
    [
      "carrelage",
      0.06
    ],
    [
      "vitre",
      0.06
    ],
    [
      "trait",
      0.06
    ],
    [
      "pave",
      0.06
    ],
    [
      "fenetre",
      0.06
    ],
    [
      "faience",
      0.06
    ],
    [
      "carrelet",
      0.06
    ],
    [
      "foudre",
      0.0275
    ],
    [
      "glace",
      0.0275
    ],
    [
      "haste",
      0.0275
    ],
    [
      "lime",
      0.0275
    ],
    [
      "lunettes",
      0.0275
    ],
    [
      "monocle",
      0.0275
    ],
    [
      "panneau",
      0.0275
    ],
    [
      "verre",
      0.0275
    ],
    [
      "fleche",
      0.0275
    ],
    [
      "dessin",
      0.0275
    ],
    [
      "azulejo",
      0.0275
    ],
    [
      "briquage",
      0.0275
    ],
    [
      "carrelette",
      0.0275
    ],
    [
      "carroyage",
      0.0275
    ],
    [
      "carre",
      0.0275
    ],
    [
      "coussin",
      0.0275
    ],
    [
      "croisee",
      0.0275
    ],
    [
      "dalle",
      0.0275
    ],
    [
      "zellige",
      0.0275
    ]
  ],
  "thermique": [
    [
      "calorifique",
      0.2
    ],
    [
      "chaud",
      0.2
    ],
    [
      "geothermique",
      0.2
    ],
    [
      "thermodynamique",
      0.2
    ],
    [
      "thermogene",
      0.2
    ]
  ],
  "accoudoir": [
    [
      "appui",
      0.285
    ],
    [
      "accotoir",
      0.1425
    ],
    [
      "balcon",
      0.1425
    ],
    [
      "balustrade",
      0.1425
    ],
    [
      "bras",
      0.1425
    ]
  ],
  "rangement": [
    [
      "classement",
      0.175
    ],
    [
      "disposition",
      0.175
    ],
    [
      "ordre",
      0.175
    ],
    [
      "arrangement",
      0.1175
    ],
    [
      "distribution",
      0.1175
    ],
    [
      "alignement",
      0.0575
    ],
    [
      "placement",
      0.0575
    ],
    [
      "rayage",
      0.0575
    ],
    [
      "repartition",
      0.0575
    ]
  ],
  "sieger": [
    [
      "resider",
      0.25
    ],
    [
      "demeurer",
      0.165
    ],
    [
      "gesir",
      0.0825
    ],
    [
      "giter",
      0.0825
    ],
    [
      "habiter",
      0.0825
    ],
    [
      "presider",
      0.0825
    ],
    [
      "seoir",
      0.0825
    ],
    [
      "troner",
      0.0825
    ]
  ],
  "siege": [
    [
      "canape",
      0.0525
    ],
    [
      "sofa",
      0.0525
    ],
    [
      "tabouret",
      0.0375
    ],
    [
      "stalle",
      0.0375
    ],
    [
      "selle",
      0.0375
    ],
    [
      "misericorde",
      0.0375
    ],
    [
      "fauteuil",
      0.0375
    ],
    [
      "banquette",
      0.0375
    ],
    [
      "tribunal",
      0.025
    ],
    [
      "place",
      0.025
    ],
    [
      "investissement",
      0.025
    ],
    [
      "fondement",
      0.025
    ],
    [
      "fessier",
      0.025
    ],
    [
      "derriere",
      0.025
    ],
    [
      "pouf",
      0.0125
    ],
    [
      "poliorcetique",
      0.0125
    ],
    [
      "pliant",
      0.0125
    ],
    [
      "permanence",
      0.0125
    ],
    [
      "lunette",
      0.0125
    ],
    [
      "juridiction",
      0.0125
    ],
    [
      "fesses",
      0.0125
    ],
    [
      "fesse",
      0.0125
    ],
    [
      "trone",
      0.0125
    ],
    [
      "trepied",
      0.0125
    ],
    [
      "strapontin",
      0.0125
    ],
    [
      "sellette",
      0.0125
    ],
    [
      "residence",
      0.0125
    ],
    [
      "recamier",
      0.0125
    ],
    [
      "escabelle",
      0.0125
    ],
    [
      "escabeau",
      0.0125
    ],
    [
      "attaque",
      0.0125
    ],
    [
      "banc",
      0.0125
    ],
    [
      "base",
      0.0125
    ],
    [
      "berceuse",
      0.0125
    ],
    [
      "bergere",
      0.0125
    ],
    [
      "blocus",
      0.0125
    ],
    [
      "boudeuse",
      0.0125
    ],
    [
      "causeuse",
      0.0125
    ],
    [
      "centre",
      0.0125
    ],
    [
      "chaire",
      0.0125
    ],
    [
      "chaise",
      0.0125
    ],
    [
      "comite",
      0.0125
    ],
    [
      "direction",
      0.0125
    ],
    [
      "divan",
      0.0125
    ],
    [
      "domicile",
      0.0125
    ],
    [
      "encerclement",
      0.0125
    ],
    [
      "administration",
      0.0125
    ]
  ],
  "chauffant": [
    [
      "enflammer",
      0.07
    ],
    [
      "exciter",
      0.0625
    ],
    [
      "bruler",
      0.0525
    ],
    [
      "exalter",
      0.0525
    ],
    [
      "voler",
      0.045
    ],
    [
      "prendre",
      0.045
    ],
    [
      "embraser",
      0.045
    ],
    [
      "attiser",
      0.045
    ],
    [
      "rechauffer",
      0.035
    ],
    [
      "stimuler",
      0.025
    ],
    [
      "faucher",
      0.025
    ],
    [
      "derober",
      0.025
    ],
    [
      "cuire",
      0.025
    ],
    [
      "choper",
      0.025
    ],
    [
      "chiper",
      0.025
    ],
    [
      "bassiner",
      0.025
    ],
    [
      "etuver",
      0.0175
    ],
    [
      "echauffer",
      0.0175
    ],
    [
      "tiedir",
      0.0175
    ],
    [
      "s'echauffer",
      0.0175
    ],
    [
      "rotir",
      0.0175
    ],
    [
      "griller",
      0.0175
    ],
    [
      "fomenter",
      0.0175
    ],
    [
      "calciner",
      0.0175
    ],
    [
      "attraper",
      0.0175
    ],
    [
      "fermenter",
      0.0075
    ],
    [
      "grincher",
      0.0075
    ],
    [
      "presser",
      0.0075
    ],
    [
      "riffauder",
      0.0075
    ],
    [
      "reviser",
      0.0075
    ],
    [
      "subtiliser",
      0.0075
    ],
    [
      "surchauffer",
      0.0075
    ],
    [
      "encourager",
      0.0075
    ],
    [
      "degourdir",
      0.0075
    ],
    [
      "attiedir",
      0.0075
    ],
    [
      "attremper",
      0.0075
    ],
    [
      "bachoter",
      0.0075
    ],
    [
      "barboter",
      0.0075
    ],
    [
      "barder",
      0.0075
    ],
    [
      "bleuir",
      0.0075
    ],
    [
      "braiser",
      0.0075
    ],
    [
      "chouraver",
      0.0075
    ],
    [
      "coincer",
      0.0075
    ]
  ],
  "clignotant": [
    [
      "papillotant",
      0.25
    ],
    [
      "vacillant",
      0.1675
    ],
    [
      "balise",
      0.0825
    ],
    [
      "clignant",
      0.0825
    ],
    [
      "clignoteur",
      0.0825
    ],
    [
      "intermittent",
      0.0825
    ],
    [
      "nictitant",
      0.0825
    ],
    [
      "scintillant",
      0.0825
    ],
    [
      "tremblotant",
      0.0825
    ]
  ],
  "equipement": [
    [
      "attirail",
      0.1325
    ],
    [
      "bagage",
      0.0875
    ],
    [
      "materiel",
      0.0875
    ],
    [
      "equipage",
      0.0875
    ],
    [
      "armement",
      0.065
    ],
    [
      "barda",
      0.065
    ],
    [
      "fourbi",
      0.065
    ],
    [
      "vetement",
      0.0425
    ],
    [
      "mobilier",
      0.0425
    ],
    [
      "harnachement",
      0.0425
    ],
    [
      "fourniment",
      0.0425
    ],
    [
      "ballot",
      0.0425
    ],
    [
      "organe",
      0.02
    ],
    [
      "instrumentation",
      0.02
    ],
    [
      "installation",
      0.02
    ],
    [
      "bataclan",
      0.02
    ],
    [
      "arme",
      0.02
    ],
    [
      "amenagement",
      0.02
    ],
    [
      "outillage",
      0.02
    ]
  ],
  "bridge": [
    [
      "reception",
      0.5
    ],
    [
      "whist",
      0.5
    ]
  ],
  "option": [
    [
      "choix",
      0.4
    ],
    [
      "alternative",
      0.1
    ],
    [
      "dilemme",
      0.1
    ],
    [
      "determination",
      0.1
    ],
    [
      "precommande",
      0.1
    ],
    [
      "preference",
      0.1
    ],
    [
      "election",
      0.1
    ]
  ],
  "opter": [
    [
      "choisir",
      0.23
    ],
    [
      "preferer",
      0.1525
    ],
    [
      "selectionner",
      0.1525
    ],
    [
      "adopter",
      0.075
    ],
    [
      "pencher",
      0.075
    ],
    [
      "elire",
      0.075
    ]
  ],
  "retro": [
    [
      "arriere",
      0.2
    ],
    [
      "demode",
      0.2
    ],
    [
      "desuet",
      0.2
    ],
    [
      "kitsch",
      0.2
    ],
    [
      "retroviseur",
      0.2
    ]
  ],
  "accelerer": [
    [
      "precipiter",
      0.125
    ],
    [
      "brusquer",
      0.1025
    ],
    [
      "pousser",
      0.0925
    ],
    [
      "hater",
      0.08
    ],
    [
      "activer",
      0.0675
    ],
    [
      "presser",
      0.0675
    ],
    [
      "forcer",
      0.055
    ],
    [
      "avancer",
      0.045
    ],
    [
      "augmenter",
      0.045
    ],
    [
      "trousser",
      0.0225
    ],
    [
      "stimuler",
      0.0225
    ],
    [
      "expedier",
      0.0225
    ],
    [
      "depecher",
      0.0225
    ],
    [
      "courir",
      0.0225
    ],
    [
      "s'empresser",
      0.01
    ],
    [
      "doubler",
      0.01
    ],
    [
      "accroitre",
      0.01
    ]
  ],
  "gobelet": [
    [
      "coupe",
      0.1325
    ],
    [
      "godet",
      0.1325
    ],
    [
      "timbale",
      0.1325
    ],
    [
      "verre",
      0.1325
    ],
    [
      "tasse",
      0.065
    ],
    [
      "shaker",
      0.065
    ],
    [
      "quart",
      0.065
    ],
    [
      "hypocrite",
      0.065
    ],
    [
      "fourbe",
      0.065
    ],
    [
      "chope",
      0.065
    ],
    [
      "vase",
      0.065
    ]
  ],
  "mate": [
    [
      "maitriser",
      0.1075
    ],
    [
      "dompter",
      0.1
    ],
    [
      "reprimer",
      0.08
    ],
    [
      "museler",
      0.0525
    ],
    [
      "soumettre",
      0.045
    ],
    [
      "etouffer",
      0.04
    ],
    [
      "reduire",
      0.04
    ],
    [
      "regarder",
      0.04
    ],
    [
      "asservir",
      0.0325
    ],
    [
      "juguler",
      0.0325
    ],
    [
      "vaincre",
      0.0325
    ],
    [
      "triompher",
      0.025
    ],
    [
      "viser",
      0.02
    ],
    [
      "terrasser",
      0.02
    ],
    [
      "regner",
      0.02
    ],
    [
      "humilier",
      0.02
    ],
    [
      "calmer",
      0.02
    ],
    [
      "brider",
      0.02
    ],
    [
      "arreter",
      0.02
    ],
    [
      "etrangler",
      0.0125
    ],
    [
      "surmonter",
      0.0125
    ],
    [
      "stopper",
      0.0125
    ],
    [
      "reluquer",
      0.0125
    ],
    [
      "refouler",
      0.0125
    ],
    [
      "mortifier",
      0.0125
    ],
    [
      "mirer",
      0.0125
    ],
    [
      "lorgner",
      0.0125
    ],
    [
      "commander",
      0.0125
    ],
    [
      "chatier",
      0.0125
    ],
    [
      "bigler",
      0.0125
    ],
    [
      "aplatir",
      0.0125
    ],
    [
      "abattre",
      0.0125
    ],
    [
      "rechasser",
      0.005
    ],
    [
      "moucher",
      0.005
    ],
    [
      "matir",
      0.005
    ],
    [
      "macerer",
      0.005
    ],
    [
      "depolir",
      0.005
    ],
    [
      "dresser",
      0.005
    ],
    [
      "voir",
      0.005
    ]
  ],
  "antenne": [
    [
      "ambulance",
      0.25
    ],
    [
      "aerien",
      0.25
    ],
    [
      "bretelle",
      0.25
    ],
    [
      "emetteur",
      0.25
    ]
  ],
  "acclimater": [
    [
      "styler",
      0.2075
    ],
    [
      "habituer",
      0.165
    ],
    [
      "familiariser",
      0.125
    ],
    [
      "accoutumer",
      0.0825
    ],
    [
      "initier",
      0.0825
    ],
    [
      "introduire",
      0.0825
    ],
    [
      "naturaliser",
      0.04
    ],
    [
      "importer",
      0.04
    ],
    [
      "entrainer",
      0.04
    ],
    [
      "apprivoiser",
      0.04
    ],
    [
      "adapter",
      0.04
    ],
    [
      "transplanter",
      0.04
    ]
  ],
  "fascine": [
    [
      "bois",
      0.25
    ],
    [
      "claie",
      0.25
    ],
    [
      "fagot",
      0.25
    ],
    [
      "gabion",
      0.25
    ]
  ],
  "fasciner": [
    [
      "seduire",
      0.145
    ],
    [
      "charmer",
      0.1175
    ],
    [
      "captiver",
      0.0725
    ],
    [
      "eblouir",
      0.0625
    ],
    [
      "enchanter",
      0.055
    ],
    [
      "troubler",
      0.045
    ],
    [
      "subjuguer",
      0.045
    ],
    [
      "ravir",
      0.045
    ],
    [
      "briller",
      0.035
    ],
    [
      "enivrer",
      0.035
    ],
    [
      "ensorceler",
      0.035
    ],
    [
      "hypnotiser",
      0.035
    ],
    [
      "impressionner",
      0.035
    ],
    [
      "tenter",
      0.0275
    ],
    [
      "plaire",
      0.0275
    ],
    [
      "envouter",
      0.0275
    ],
    [
      "attirer",
      0.0175
    ],
    [
      "parler",
      0.0175
    ],
    [
      "passionner",
      0.0175
    ],
    [
      "emerveiller",
      0.0175
    ],
    [
      "s'emparer",
      0.0075
    ],
    [
      "maitriser",
      0.0075
    ],
    [
      "magnetiser",
      0.0075
    ],
    [
      "enteter",
      0.0075
    ],
    [
      "endormir",
      0.0075
    ],
    [
      "appeler",
      0.0075
    ],
    [
      "egarer",
      0.0075
    ]
  ],
  "poignarder": [
    [
      "tuer",
      0.225
    ],
    [
      "egorger",
      0.135
    ],
    [
      "assassiner",
      0.09
    ],
    [
      "frapper",
      0.09
    ],
    [
      "meurtrir",
      0.09
    ],
    [
      "suriner",
      0.09
    ],
    [
      "larder",
      0.045
    ],
    [
      "exasperer",
      0.045
    ],
    [
      "darder",
      0.045
    ],
    [
      "chouriner",
      0.045
    ],
    [
      "blesser",
      0.045
    ],
    [
      "saigner",
      0.045
    ]
  ],
  "enivrer": [
    [
      "exciter",
      0.1125
    ],
    [
      "enflammer",
      0.085
    ],
    [
      "enthousiasmer",
      0.085
    ],
    [
      "transporter",
      0.07
    ],
    [
      "griser",
      0.055
    ],
    [
      "fasciner",
      0.055
    ],
    [
      "exalter",
      0.055
    ],
    [
      "charmer",
      0.055
    ],
    [
      "ravir",
      0.0425
    ],
    [
      "electriser",
      0.0425
    ],
    [
      "etourdir",
      0.0425
    ],
    [
      "troubler",
      0.0275
    ],
    [
      "souler",
      0.0275
    ],
    [
      "passionner",
      0.0275
    ],
    [
      "enteter",
      0.0275
    ],
    [
      "enfievrer",
      0.0275
    ],
    [
      "anesthesier",
      0.0125
    ],
    [
      "enorgueillir",
      0.0125
    ],
    [
      "remplir",
      0.0125
    ],
    [
      "retamer",
      0.0125
    ],
    [
      "soulever",
      0.0125
    ],
    [
      "taper",
      0.0125
    ],
    [
      "emecher",
      0.0125
    ]
  ],
  "poison": [
    [
      "harpie",
      0.05
    ],
    [
      "mechant",
      0.05
    ],
    [
      "megere",
      0.05
    ],
    [
      "salete",
      0.05
    ],
    [
      "vipere",
      0.05
    ],
    [
      "peste",
      0.025
    ],
    [
      "narcotique",
      0.025
    ],
    [
      "impurete",
      0.025
    ],
    [
      "importun",
      0.025
    ],
    [
      "saloperie",
      0.025
    ],
    [
      "strychnine",
      0.025
    ],
    [
      "toxine",
      0.025
    ],
    [
      "toxique",
      0.025
    ],
    [
      "venin",
      0.025
    ],
    [
      "virago",
      0.025
    ],
    [
      "virus",
      0.025
    ],
    [
      "horreur",
      0.025
    ],
    [
      "gobbe",
      0.025
    ],
    [
      "aconitine",
      0.025
    ],
    [
      "alcaloide",
      0.025
    ],
    [
      "appret",
      0.025
    ],
    [
      "appat",
      0.025
    ],
    [
      "arsenic",
      0.025
    ],
    [
      "catalyseur",
      0.025
    ],
    [
      "cholera",
      0.025
    ],
    [
      "cigue",
      0.025
    ],
    [
      "curare",
      0.025
    ],
    [
      "empoisonneur",
      0.025
    ],
    [
      "venefice",
      0.025
    ]
  ],
  "pulsion": [
    [
      "amour",
      0.285
    ],
    [
      "tendance",
      0.285
    ],
    [
      "besoin",
      0.1425
    ],
    [
      "instinct",
      0.1425
    ],
    [
      "eros",
      0.1425
    ]
  ],
  "fleau": [
    [
      "calamite",
      0.11
    ],
    [
      "catastrophe",
      0.0725
    ],
    [
      "lepre",
      0.0725
    ],
    [
      "malheur",
      0.0725
    ],
    [
      "tribulation",
      0.0725
    ],
    [
      "plombee",
      0.035
    ],
    [
      "plommee",
      0.035
    ],
    [
      "punition",
      0.035
    ],
    [
      "romaine",
      0.035
    ],
    [
      "traversant",
      0.035
    ],
    [
      "traversin",
      0.035
    ],
    [
      "plaie",
      0.035
    ],
    [
      "peste",
      0.035
    ],
    [
      "malediction",
      0.035
    ],
    [
      "joug",
      0.035
    ],
    [
      "importun",
      0.035
    ],
    [
      "desastre",
      0.035
    ],
    [
      "chancre",
      0.035
    ],
    [
      "cataclysme",
      0.035
    ],
    [
      "battoir",
      0.035
    ],
    [
      "verge",
      0.035
    ]
  ],
  "boomer": [],
  "expression": [
    [
      "air",
      0.06
    ],
    [
      "tournure",
      0.06
    ],
    [
      "figure",
      0.05
    ],
    [
      "caractere",
      0.045
    ],
    [
      "genre",
      0.045
    ],
    [
      "visage",
      0.0375
    ],
    [
      "forme",
      0.0325
    ],
    [
      "maniere",
      0.03
    ],
    [
      "trait",
      0.0275
    ],
    [
      "ton",
      0.0275
    ],
    [
      "style",
      0.0275
    ],
    [
      "physionomie",
      0.0275
    ],
    [
      "image",
      0.0275
    ],
    [
      "formule",
      0.0275
    ],
    [
      "parole",
      0.0225
    ],
    [
      "signe",
      0.0225
    ],
    [
      "phrase",
      0.02
    ],
    [
      "manifestation",
      0.02
    ],
    [
      "affirmation",
      0.015
    ],
    [
      "locution",
      0.015
    ],
    [
      "symbole",
      0.015
    ],
    [
      "tour",
      0.015
    ],
    [
      "elocution",
      0.015
    ],
    [
      "enonciation",
      0.0125
    ],
    [
      "touche",
      0.0125
    ],
    [
      "terme",
      0.0125
    ],
    [
      "mime",
      0.0125
    ],
    [
      "attitude",
      0.0125
    ],
    [
      "enonce",
      0.0075
    ],
    [
      "sentence",
      0.0075
    ],
    [
      "proposition",
      0.0075
    ],
    [
      "mot",
      0.0075
    ],
    [
      "mimique",
      0.0075
    ],
    [
      "langue",
      0.0075
    ],
    [
      "incarnation",
      0.0075
    ],
    [
      "demonstration",
      0.0075
    ],
    [
      "comportement",
      0.0075
    ],
    [
      "assurance",
      0.0075
    ],
    [
      "echo",
      0.005
    ],
    [
      "tonalite",
      0.005
    ],
    [
      "metaphore",
      0.005
    ],
    [
      "mine",
      0.005
    ],
    [
      "masque",
      0.005
    ],
    [
      "communication",
      0.005
    ],
    [
      "cliche",
      0.005
    ],
    [
      "personnification",
      0.0025
    ],
    [
      "pointe",
      0.0025
    ],
    [
      "slogan",
      0.0025
    ],
    [
      "traduction",
      0.0025
    ],
    [
      "trope",
      0.0025
    ],
    [
      "vie",
      0.0025
    ],
    [
      "vocabulaire",
      0.0025
    ],
    [
      "voix",
      0.0025
    ],
    [
      "eloquence",
      0.0025
    ],
    [
      "mobilite",
      0.0025
    ],
    [
      "idiotisme",
      0.0025
    ],
    [
      "animation",
      0.0025
    ],
    [
      "bille",
      0.0025
    ],
    [
      "binette",
      0.0025
    ],
    [
      "construction",
      0.0025
    ],
    [
      "euphemisme",
      0.0025
    ],
    [
      "extraction",
      0.0025
    ],
    [
      "exteriorisation",
      0.0025
    ],
    [
      "genie",
      0.0025
    ],
    [
      "hommage",
      0.0025
    ],
    [
      "emanation",
      0.0025
    ]
  ],
  "web": [],
  "bouquin": [
    [
      "bouquet",
      0.1425
    ],
    [
      "lievre",
      0.1425
    ],
    [
      "male",
      0.1425
    ],
    [
      "recueil",
      0.07
    ],
    [
      "livre",
      0.07
    ],
    [
      "lapin",
      0.07
    ],
    [
      "embouchure",
      0.07
    ],
    [
      "corne",
      0.07
    ],
    [
      "cor",
      0.07
    ],
    [
      "bouc",
      0.07
    ],
    [
      "satyre",
      0.07
    ]
  ],
  "allergique": [
    [
      "anaphylactique",
      0.3325
    ],
    [
      "sensibilise",
      0.3325
    ],
    [
      "sensible",
      0.3325
    ]
  ],
  "gluten": [
    [
      "gliadine",
      1.0
    ]
  ],
  "kiki": [
    [
      "gorge",
      0.25
    ],
    [
      "gosier",
      0.25
    ],
    [
      "gavion",
      0.125
    ],
    [
      "quiqui",
      0.125
    ]
  ],
  "moeurs": [
    [
      "caractere",
      0.115
    ],
    [
      "mode",
      0.115
    ],
    [
      "usage",
      0.075
    ],
    [
      "pratique",
      0.075
    ],
    [
      "naturel",
      0.075
    ],
    [
      "moralite",
      0.075
    ],
    [
      "mentalite",
      0.075
    ],
    [
      "vie",
      0.0375
    ],
    [
      "usages",
      0.0375
    ],
    [
      "psychologie",
      0.0375
    ],
    [
      "principes",
      0.0375
    ],
    [
      "morale",
      0.0375
    ],
    [
      "habitudes",
      0.0375
    ],
    [
      "coutume",
      0.0375
    ],
    [
      "conduite",
      0.0375
    ],
    [
      "education",
      0.0375
    ]
  ],
  "victime": [
    [
      "tue",
      0.0825
    ],
    [
      "mort",
      0.0825
    ],
    [
      "martyr",
      0.0825
    ],
    [
      "jouet",
      0.0825
    ],
    [
      "decede",
      0.0825
    ],
    [
      "plastron",
      0.04
    ],
    [
      "persecute",
      0.04
    ],
    [
      "hostie",
      0.04
    ],
    [
      "defunt",
      0.04
    ],
    [
      "assassine",
      0.04
    ],
    [
      "proie",
      0.04
    ]
  ],
  "hanneton": [
    [
      "escarbot",
      0.5
    ],
    [
      "etourdi",
      0.5
    ]
  ],
  "labour": [
    [
      "champ",
      0.2
    ],
    [
      "ameublissement",
      0.1
    ],
    [
      "defoncage",
      0.1
    ],
    [
      "facon",
      0.1
    ],
    [
      "gueret",
      0.1
    ],
    [
      "labourage",
      0.1
    ],
    [
      "parage",
      0.1
    ],
    [
      "serfouissage",
      0.1
    ],
    [
      "terre",
      0.1
    ]
  ],
  "clore": [
    [
      "fermer",
      0.16
    ],
    [
      "entourer",
      0.075
    ],
    [
      "enceindre",
      0.0625
    ],
    [
      "enclore",
      0.0625
    ],
    [
      "finir",
      0.0625
    ],
    [
      "terminer",
      0.0625
    ],
    [
      "enfermer",
      0.0525
    ],
    [
      "cloturer",
      0.0525
    ],
    [
      "arreter",
      0.0525
    ],
    [
      "barrer",
      0.0425
    ],
    [
      "murer",
      0.03
    ],
    [
      "ceindre",
      0.03
    ],
    [
      "boucher",
      0.03
    ],
    [
      "barricader",
      0.03
    ],
    [
      "achever",
      0.03
    ],
    [
      "cadenasser",
      0.02
    ],
    [
      "capsuler",
      0.02
    ],
    [
      "cercler",
      0.02
    ],
    [
      "conclure",
      0.02
    ],
    [
      "ecluser",
      0.02
    ],
    [
      "cacheter",
      0.01
    ]
  ],
  "clos": [
    [
      "fermer",
      0.16
    ],
    [
      "entourer",
      0.075
    ],
    [
      "enceindre",
      0.0625
    ],
    [
      "enclore",
      0.0625
    ],
    [
      "finir",
      0.0625
    ],
    [
      "terminer",
      0.0625
    ],
    [
      "enfermer",
      0.0525
    ],
    [
      "cloturer",
      0.0525
    ],
    [
      "arreter",
      0.0525
    ],
    [
      "barrer",
      0.0425
    ],
    [
      "murer",
      0.03
    ],
    [
      "ceindre",
      0.03
    ],
    [
      "boucher",
      0.03
    ],
    [
      "barricader",
      0.03
    ],
    [
      "achever",
      0.03
    ],
    [
      "cadenasser",
      0.02
    ],
    [
      "capsuler",
      0.02
    ],
    [
      "cercler",
      0.02
    ],
    [
      "conclure",
      0.02
    ],
    [
      "ecluser",
      0.02
    ],
    [
      "cacheter",
      0.01
    ]
  ],
  "rateau": [
    [
      "arc",
      0.25
    ],
    [
      "peigne",
      0.25
    ],
    [
      "racle",
      0.25
    ],
    [
      "rouable",
      0.25
    ]
  ],
  "hiverner": [
    [
      "hiberner",
      1.0
    ]
  ],
  "cabane": [
    [
      "baraque",
      0.0975
    ],
    [
      "maison",
      0.0925
    ],
    [
      "hutte",
      0.085
    ],
    [
      "habitation",
      0.0575
    ],
    [
      "bicoque",
      0.0575
    ],
    [
      "abri",
      0.0575
    ],
    [
      "case",
      0.0525
    ],
    [
      "maisonnette",
      0.0525
    ],
    [
      "cahute",
      0.0375
    ],
    [
      "loge",
      0.0375
    ],
    [
      "reduit",
      0.0375
    ],
    [
      "gourbi",
      0.0325
    ],
    [
      "cagibi",
      0.025
    ],
    [
      "chaumiere",
      0.0175
    ],
    [
      "chalet",
      0.0175
    ],
    [
      "cambuse",
      0.0175
    ],
    [
      "cagna",
      0.0175
    ],
    [
      "appentis",
      0.0175
    ],
    [
      "edicule",
      0.01
    ],
    [
      "tole",
      0.01
    ],
    [
      "remise",
      0.01
    ],
    [
      "prison",
      0.01
    ],
    [
      "masure",
      0.01
    ],
    [
      "gloriette",
      0.01
    ],
    [
      "cabanon",
      0.01
    ],
    [
      "buron",
      0.01
    ],
    [
      "wigwam",
      0.005
    ],
    [
      "sucrerie",
      0.005
    ],
    [
      "paillote",
      0.005
    ],
    [
      "logette",
      0.005
    ],
    [
      "gabionnade",
      0.005
    ],
    [
      "chaumine",
      0.005
    ],
    [
      "chaume",
      0.005
    ],
    [
      "cassine",
      0.005
    ],
    [
      "carbet",
      0.005
    ],
    [
      "bateau",
      0.005
    ],
    [
      "affut",
      0.005
    ],
    [
      "yourte",
      0.005
    ]
  ],
  "composer": [
    [
      "construire",
      0.08
    ],
    [
      "faire",
      0.0775
    ],
    [
      "former",
      0.07
    ],
    [
      "arranger",
      0.0525
    ],
    [
      "creer",
      0.0425
    ],
    [
      "elaborer",
      0.0425
    ],
    [
      "organiser",
      0.04
    ],
    [
      "preparer",
      0.0375
    ],
    [
      "faconner",
      0.035
    ],
    [
      "produire",
      0.035
    ],
    [
      "combiner",
      0.0325
    ],
    [
      "constituer",
      0.025
    ],
    [
      "disposer",
      0.0225
    ],
    [
      "batir",
      0.02
    ],
    [
      "ecrire",
      0.02
    ],
    [
      "transiger",
      0.02
    ],
    [
      "imaginer",
      0.02
    ],
    [
      "inventer",
      0.0175
    ],
    [
      "assembler",
      0.015
    ],
    [
      "concevoir",
      0.015
    ],
    [
      "forger",
      0.015
    ],
    [
      "travailler",
      0.015
    ],
    [
      "edifier",
      0.015
    ],
    [
      "traiter",
      0.01
    ],
    [
      "harmoniser",
      0.01
    ],
    [
      "ajuster",
      0.01
    ],
    [
      "agencer",
      0.01
    ],
    [
      "appreter",
      0.0075
    ],
    [
      "donner",
      0.0075
    ],
    [
      "s'entendre",
      0.005
    ],
    [
      "s'accorder",
      0.005
    ],
    [
      "polir",
      0.005
    ],
    [
      "ordonner",
      0.005
    ],
    [
      "confectionner",
      0.005
    ],
    [
      "affecter",
      0.005
    ],
    [
      "pactiser",
      0.0025
    ],
    [
      "parlementer",
      0.0025
    ],
    [
      "romancer",
      0.0025
    ],
    [
      "s'accommoder",
      0.0025
    ],
    [
      "sculpter",
      0.0025
    ],
    [
      "elucubrer",
      0.0025
    ],
    [
      "etudier",
      0.0025
    ],
    [
      "negocier",
      0.0025
    ],
    [
      "imiter",
      0.0025
    ],
    [
      "emprunter",
      0.0025
    ],
    [
      "accoucher",
      0.0025
    ],
    [
      "associer",
      0.0025
    ],
    [
      "capituler",
      0.0025
    ],
    [
      "charpenter",
      0.0025
    ],
    [
      "ciseler",
      0.0025
    ],
    [
      "ceder",
      0.0025
    ],
    [
      "deguiser",
      0.0025
    ],
    [
      "rediger",
      0.0
    ],
    [
      "rimer",
      0.0
    ],
    [
      "pondre",
      0.0
    ],
    [
      "ordonnancer",
      0.0
    ],
    [
      "melanger",
      0.0
    ],
    [
      "imprimer",
      0.0
    ],
    [
      "faufiler",
      0.0
    ],
    [
      "faiblir",
      0.0
    ],
    [
      "conceder",
      0.0
    ],
    [
      "biaiser",
      0.0
    ],
    [
      "adopter",
      0.0
    ],
    [
      "tergiverser",
      0.0
    ]
  ],
  "rouiller": [
    [
      "alterer",
      0.075
    ],
    [
      "s'etioler",
      0.075
    ],
    [
      "s'emousser",
      0.075
    ],
    [
      "s'engourdir",
      0.075
    ],
    [
      "s'encrouter",
      0.075
    ],
    [
      "s'ankyloser",
      0.075
    ],
    [
      "roussir",
      0.075
    ],
    [
      "ronger",
      0.075
    ],
    [
      "paralyser",
      0.075
    ],
    [
      "oxyder",
      0.075
    ],
    [
      "engourdir",
      0.075
    ],
    [
      "ankyloser",
      0.075
    ],
    [
      "emousser",
      0.075
    ]
  ],
  "araignee": [
    [
      "acarien",
      0.165
    ],
    [
      "araneide",
      0.165
    ],
    [
      "carrelet",
      0.165
    ],
    [
      "coussinet",
      0.165
    ],
    [
      "filet",
      0.165
    ],
    [
      "galerie",
      0.165
    ]
  ],
  "ruisseau": [
    [
      "rigole",
      0.1825
    ],
    [
      "riviere",
      0.135
    ],
    [
      "fleuve",
      0.09
    ],
    [
      "ru",
      0.045
    ],
    [
      "goulotte",
      0.045
    ],
    [
      "gave",
      0.045
    ],
    [
      "fumier",
      0.045
    ],
    [
      "fosse",
      0.045
    ],
    [
      "flot",
      0.045
    ],
    [
      "cassis",
      0.045
    ],
    [
      "caniveau",
      0.045
    ],
    [
      "boue",
      0.045
    ],
    [
      "rue",
      0.045
    ]
  ],
  "aligne": [
    [
      "disposer",
      0.095
    ],
    [
      "arranger",
      0.0775
    ],
    [
      "donner",
      0.0775
    ],
    [
      "tracer",
      0.055
    ],
    [
      "regler",
      0.055
    ],
    [
      "ranger",
      0.055
    ],
    [
      "presenter",
      0.055
    ],
    [
      "payer",
      0.055
    ],
    [
      "avancer",
      0.055
    ],
    [
      "uniformiser",
      0.0375
    ],
    [
      "standardiser",
      0.0375
    ],
    [
      "normaliser",
      0.0375
    ],
    [
      "niveler",
      0.0375
    ],
    [
      "dresser",
      0.0375
    ],
    [
      "accorder",
      0.0375
    ],
    [
      "fournir",
      0.0175
    ],
    [
      "debourser",
      0.0175
    ],
    [
      "commencer",
      0.0175
    ],
    [
      "caser",
      0.0175
    ],
    [
      "ajuster",
      0.0175
    ],
    [
      "affronter",
      0.0175
    ],
    [
      "adosser",
      0.0175
    ],
    [
      "piqueter",
      0.0175
    ]
  ],
  "aligner": [
    [
      "disposer",
      0.095
    ],
    [
      "arranger",
      0.0775
    ],
    [
      "donner",
      0.0775
    ],
    [
      "tracer",
      0.055
    ],
    [
      "regler",
      0.055
    ],
    [
      "ranger",
      0.055
    ],
    [
      "presenter",
      0.055
    ],
    [
      "payer",
      0.055
    ],
    [
      "avancer",
      0.055
    ],
    [
      "uniformiser",
      0.0375
    ],
    [
      "standardiser",
      0.0375
    ],
    [
      "normaliser",
      0.0375
    ],
    [
      "niveler",
      0.0375
    ],
    [
      "dresser",
      0.0375
    ],
    [
      "accorder",
      0.0375
    ],
    [
      "fournir",
      0.0175
    ],
    [
      "debourser",
      0.0175
    ],
    [
      "commencer",
      0.0175
    ],
    [
      "caser",
      0.0175
    ],
    [
      "ajuster",
      0.0175
    ],
    [
      "affronter",
      0.0175
    ],
    [
      "adosser",
      0.0175
    ],
    [
      "piqueter",
      0.0175
    ]
  ],
  "vecu": [
    [
      "demeurer",
      0.105
    ],
    [
      "habiter",
      0.0575
    ],
    [
      "rester",
      0.0575
    ],
    [
      "subsister",
      0.0575
    ],
    [
      "passer",
      0.045
    ],
    [
      "pratiquer",
      0.045
    ],
    [
      "etre",
      0.045
    ],
    [
      "sejourner",
      0.035
    ],
    [
      "pourrir",
      0.035
    ],
    [
      "exister",
      0.035
    ],
    [
      "eprouver",
      0.0225
    ],
    [
      "subir",
      0.0225
    ],
    [
      "resider",
      0.0225
    ],
    [
      "loger",
      0.0225
    ],
    [
      "frequenter",
      0.0225
    ],
    [
      "experimenter",
      0.0225
    ],
    [
      "durer",
      0.0225
    ],
    [
      "croupir",
      0.0225
    ],
    [
      "couler",
      0.0225
    ],
    [
      "consommer",
      0.0225
    ],
    [
      "appliquer",
      0.0225
    ],
    [
      "supporter",
      0.01
    ],
    [
      "surnager",
      0.01
    ],
    [
      "traverser",
      0.01
    ],
    [
      "trainer",
      0.01
    ],
    [
      "vegeter",
      0.01
    ],
    [
      "s'endormir",
      0.01
    ],
    [
      "respirer",
      0.01
    ],
    [
      "cohabiter",
      0.01
    ],
    [
      "agir",
      0.01
    ]
  ],
  "noce": [
    [
      "bringue",
      0.1325
    ],
    [
      "bombe",
      0.1
    ],
    [
      "festin",
      0.1
    ],
    [
      "debauche",
      0.0875
    ],
    [
      "fete",
      0.0875
    ],
    [
      "nouba",
      0.065
    ],
    [
      "bombance",
      0.065
    ],
    [
      "beuverie",
      0.055
    ],
    [
      "foire",
      0.055
    ],
    [
      "bamboche",
      0.0425
    ],
    [
      "ribote",
      0.0425
    ],
    [
      "orgie",
      0.02
    ],
    [
      "mariage",
      0.02
    ],
    [
      "rejouissance",
      0.01
    ],
    [
      "java",
      0.01
    ],
    [
      "hymen",
      0.01
    ],
    [
      "goguette",
      0.01
    ],
    [
      "gaudriole",
      0.01
    ],
    [
      "galvaudage",
      0.01
    ],
    [
      "fiesta",
      0.01
    ],
    [
      "exces",
      0.01
    ],
    [
      "baloche",
      0.01
    ],
    [
      "epousailles",
      0.01
    ]
  ],
  "militer": [
    [
      "batailler",
      0.25
    ],
    [
      "favoriser",
      0.25
    ],
    [
      "lutter",
      0.25
    ],
    [
      "plaider",
      0.25
    ]
  ],
  "tract": [
    [
      "prospectus",
      0.235
    ],
    [
      "affiche",
      0.1175
    ],
    [
      "brochure",
      0.1175
    ],
    [
      "feuille",
      0.1175
    ],
    [
      "papillon",
      0.0575
    ],
    [
      "papier",
      0.0575
    ],
    [
      "pamphlet",
      0.0575
    ],
    [
      "libelle",
      0.0575
    ],
    [
      "annonce",
      0.0575
    ],
    [
      "affichette",
      0.0575
    ],
    [
      "vignette",
      0.0575
    ]
  ],
  "banderole": [
    [
      "banniere",
      0.2275
    ],
    [
      "drapeau",
      0.2275
    ],
    [
      "guidon",
      0.135
    ],
    [
      "fanion",
      0.09
    ],
    [
      "flamme",
      0.09
    ],
    [
      "oriflamme",
      0.09
    ],
    [
      "bande",
      0.0425
    ],
    [
      "calicot",
      0.0425
    ],
    [
      "pavillon",
      0.0425
    ]
  ],
  "gospel": [],
  "avocat": [
    [
      "defenseur",
      0.3
    ],
    [
      "defense",
      0.0975
    ],
    [
      "serviteur",
      0.0475
    ],
    [
      "representant",
      0.0475
    ],
    [
      "pie",
      0.0475
    ],
    [
      "orateur",
      0.0475
    ],
    [
      "magistrat",
      0.0475
    ],
    [
      "intercesseur",
      0.0475
    ],
    [
      "champion",
      0.0475
    ],
    [
      "barreau",
      0.0475
    ],
    [
      "apotre",
      0.0475
    ],
    [
      "apologiste",
      0.0475
    ],
    [
      "agree",
      0.0475
    ],
    [
      "tenant",
      0.0475
    ]
  ],
  "pharmacien": [
    [
      "apothicaire",
      0.3325
    ],
    [
      "pharmacopole",
      0.3325
    ],
    [
      "potard",
      0.3325
    ]
  ],
  "libere": [
    [
      "degager",
      0.1225
    ],
    [
      "debarrasser",
      0.0775
    ],
    [
      "decharger",
      0.0775
    ],
    [
      "delivrer",
      0.07
    ],
    [
      "affranchir",
      0.065
    ],
    [
      "dispenser",
      0.045
    ],
    [
      "defaire",
      0.0375
    ],
    [
      "delier",
      0.0375
    ],
    [
      "detacher",
      0.0375
    ],
    [
      "evacuer",
      0.025
    ],
    [
      "soulager",
      0.025
    ],
    [
      "quitter",
      0.025
    ],
    [
      "exonerer",
      0.025
    ],
    [
      "exempter",
      0.025
    ],
    [
      "eviter",
      0.0175
    ],
    [
      "epancher",
      0.0175
    ],
    [
      "soustraire",
      0.0175
    ],
    [
      "sortir",
      0.0175
    ],
    [
      "reveler",
      0.0175
    ],
    [
      "relaxer",
      0.0125
    ],
    [
      "nettoyer",
      0.0125
    ],
    [
      "deteler",
      0.0125
    ],
    [
      "desenchainer",
      0.0125
    ],
    [
      "depetrer",
      0.0125
    ],
    [
      "deblayer",
      0.0125
    ],
    [
      "acquitter",
      0.0125
    ],
    [
      "racheter",
      0.005
    ],
    [
      "relever",
      0.005
    ],
    [
      "relacher",
      0.005
    ],
    [
      "redimer",
      0.005
    ],
    [
      "trahir",
      0.005
    ],
    [
      "elargir",
      0.005
    ],
    [
      "desengager",
      0.005
    ],
    [
      "desencombrer",
      0.005
    ],
    [
      "demobiliser",
      0.005
    ],
    [
      "dechainer",
      0.005
    ],
    [
      "deceler",
      0.005
    ],
    [
      "deboucler",
      0.005
    ],
    [
      "debonder",
      0.005
    ],
    [
      "debloquer",
      0.005
    ],
    [
      "emanciper",
      0.005
    ]
  ],
  "gardenal": [],
  "docile": [
    [
      "malleable",
      0.135
    ],
    [
      "maniable",
      0.135
    ],
    [
      "obeissant",
      0.09
    ],
    [
      "soumis",
      0.09
    ],
    [
      "souple",
      0.09
    ],
    [
      "influencable",
      0.06
    ],
    [
      "flexible",
      0.06
    ],
    [
      "doux",
      0.045
    ],
    [
      "pliant",
      0.045
    ],
    [
      "sage",
      0.03
    ],
    [
      "manoeuvrable",
      0.03
    ],
    [
      "humble",
      0.03
    ],
    [
      "facile",
      0.03
    ],
    [
      "pliable",
      0.0125
    ],
    [
      "permeable",
      0.0125
    ],
    [
      "passif",
      0.0125
    ],
    [
      "manipulable",
      0.0125
    ],
    [
      "gregaire",
      0.0125
    ],
    [
      "discipline",
      0.0125
    ],
    [
      "disciplinable",
      0.0125
    ],
    [
      "respectueux",
      0.0125
    ]
  ],
  "idylle": [
    [
      "amourette",
      0.1525
    ],
    [
      "bucolique",
      0.1525
    ],
    [
      "flirt",
      0.1525
    ],
    [
      "eglogue",
      0.1525
    ],
    [
      "caprice",
      0.075
    ],
    [
      "intrigue",
      0.075
    ],
    [
      "pastorale",
      0.075
    ],
    [
      "poeme",
      0.075
    ],
    [
      "toquade",
      0.075
    ]
  ],
  "irreel": [
    [
      "imaginaire",
      0.2025
    ],
    [
      "chimerique",
      0.1075
    ],
    [
      "fabuleux",
      0.0925
    ],
    [
      "illusoire",
      0.0925
    ],
    [
      "mythique",
      0.0775
    ],
    [
      "fantastique",
      0.0625
    ],
    [
      "fantasmagorique",
      0.0625
    ],
    [
      "inexistant",
      0.045
    ],
    [
      "illusion",
      0.03
    ],
    [
      "fictif",
      0.03
    ],
    [
      "fantome",
      0.03
    ],
    [
      "fantomatique",
      0.03
    ],
    [
      "vain",
      0.015
    ],
    [
      "mysterieux",
      0.015
    ],
    [
      "irrealite",
      0.015
    ],
    [
      "irrealisable",
      0.015
    ],
    [
      "feerique",
      0.015
    ],
    [
      "aerien",
      0.015
    ],
    [
      "abstrait",
      0.015
    ],
    [
      "ethere",
      0.015
    ]
  ],
  "lubie": [
    [
      "caprice",
      0.1875
    ],
    [
      "toquade",
      0.1875
    ],
    [
      "fantaisie",
      0.1075
    ],
    [
      "folie",
      0.08
    ],
    [
      "humeur",
      0.08
    ],
    [
      "foucade",
      0.0525
    ],
    [
      "extravagance",
      0.0525
    ],
    [
      "dada",
      0.0525
    ],
    [
      "boutade",
      0.0525
    ],
    [
      "bateau",
      0.025
    ],
    [
      "envie",
      0.025
    ],
    [
      "virus",
      0.025
    ]
  ],
  "hisser": [
    [
      "elever",
      0.1775
    ],
    [
      "lever",
      0.1425
    ],
    [
      "hausser",
      0.1075
    ],
    [
      "monter",
      0.1075
    ],
    [
      "porter",
      0.1075
    ],
    [
      "soulever",
      0.1075
    ],
    [
      "trevirer",
      0.035
    ],
    [
      "haler",
      0.035
    ],
    [
      "guinder",
      0.035
    ],
    [
      "envoyer",
      0.035
    ],
    [
      "enlever",
      0.035
    ],
    [
      "arborer",
      0.035
    ],
    [
      "etarquer",
      0.035
    ]
  ],
  "chimere": [
    [
      "illusion",
      0.105
    ],
    [
      "imagination",
      0.0975
    ],
    [
      "reverie",
      0.0725
    ],
    [
      "reve",
      0.065
    ],
    [
      "songe",
      0.0575
    ],
    [
      "utopie",
      0.0575
    ],
    [
      "vision",
      0.0525
    ],
    [
      "fantaisie",
      0.045
    ],
    [
      "mirage",
      0.0375
    ],
    [
      "billevesee",
      0.0325
    ],
    [
      "fantome",
      0.0325
    ],
    [
      "abstraction",
      0.025
    ],
    [
      "fiction",
      0.025
    ],
    [
      "folie",
      0.025
    ],
    [
      "idee",
      0.025
    ],
    [
      "invention",
      0.025
    ],
    [
      "irrealite",
      0.0175
    ],
    [
      "hallucination",
      0.0175
    ],
    [
      "fantasme",
      0.0175
    ],
    [
      "toquade",
      0.0125
    ],
    [
      "songerie",
      0.0125
    ],
    [
      "roman",
      0.0125
    ],
    [
      "ombre",
      0.0125
    ],
    [
      "impossibilite",
      0.0125
    ],
    [
      "revasserie",
      0.005
    ],
    [
      "recit",
      0.005
    ],
    [
      "phraseologie",
      0.005
    ],
    [
      "neant",
      0.005
    ],
    [
      "monstre",
      0.005
    ],
    [
      "fumee",
      0.005
    ],
    [
      "dragon",
      0.005
    ],
    [
      "caprice",
      0.005
    ],
    [
      "vanite",
      0.005
    ]
  ],
  "freiner": [
    [
      "arreter",
      0.1075
    ],
    [
      "paralyser",
      0.0675
    ],
    [
      "endiguer",
      0.0625
    ],
    [
      "retenir",
      0.0625
    ],
    [
      "gener",
      0.0575
    ],
    [
      "moderer",
      0.0525
    ],
    [
      "refrener",
      0.0475
    ],
    [
      "entraver",
      0.0475
    ],
    [
      "ralentir",
      0.0425
    ],
    [
      "enrayer",
      0.0375
    ],
    [
      "bloquer",
      0.0325
    ],
    [
      "brider",
      0.0325
    ],
    [
      "tenir",
      0.0325
    ],
    [
      "temperer",
      0.0225
    ],
    [
      "stopper",
      0.0225
    ],
    [
      "juguler",
      0.0225
    ],
    [
      "diminuer",
      0.0225
    ],
    [
      "contraindre",
      0.0225
    ],
    [
      "eteindre",
      0.0175
    ],
    [
      "serrer",
      0.0175
    ],
    [
      "limiter",
      0.0175
    ],
    [
      "immobiliser",
      0.0175
    ],
    [
      "circonscrire",
      0.0125
    ],
    [
      "nuire",
      0.0125
    ],
    [
      "retarder",
      0.0075
    ],
    [
      "obstruer",
      0.0075
    ],
    [
      "gouverner",
      0.0075
    ],
    [
      "contrarier",
      0.0075
    ],
    [
      "atteler",
      0.0075
    ],
    [
      "amortir",
      0.0025
    ],
    [
      "concentrer",
      0.0025
    ],
    [
      "inhiber",
      0.0025
    ],
    [
      "refroidir",
      0.0025
    ]
  ],
  "coulisse": [
    [
      "secret",
      0.2
    ],
    [
      "bourse",
      0.0975
    ],
    [
      "coin",
      0.0975
    ],
    [
      "couette",
      0.0975
    ],
    [
      "dessous",
      0.0975
    ],
    [
      "glissiere",
      0.0975
    ],
    [
      "gouttiere",
      0.0975
    ],
    [
      "grille",
      0.0975
    ],
    [
      "mystere",
      0.0975
    ]
  ],
  "coulisser": [
    [
      "couler",
      0.3325
    ],
    [
      "glisser",
      0.3325
    ],
    [
      "jouer",
      0.3325
    ]
  ],
  "rouer": [
    [
      "rompre",
      0.4
    ],
    [
      "disloquer",
      0.2
    ],
    [
      "enrouler",
      0.2
    ],
    [
      "ereinter",
      0.2
    ]
  ],
  "roue": [
    [
      "cercle",
      0.1425
    ],
    [
      "engrenage",
      0.1425
    ],
    [
      "moulinet",
      0.1425
    ],
    [
      "poulie",
      0.1425
    ],
    [
      "tour",
      0.1425
    ],
    [
      "volant",
      0.1425
    ]
  ],
  "consacre": [
    [
      "appliquer",
      0.13
    ],
    [
      "donner",
      0.0725
    ],
    [
      "employer",
      0.0725
    ],
    [
      "vouer",
      0.0575
    ],
    [
      "mettre",
      0.0425
    ],
    [
      "destiner",
      0.0425
    ],
    [
      "benir",
      0.0425
    ],
    [
      "attribuer",
      0.0425
    ],
    [
      "asseoir",
      0.0425
    ],
    [
      "sceller",
      0.0275
    ],
    [
      "sacrer",
      0.0275
    ],
    [
      "oindre",
      0.0275
    ],
    [
      "inaugurer",
      0.0275
    ],
    [
      "devouer",
      0.0275
    ],
    [
      "confirmer",
      0.0275
    ],
    [
      "baptiser",
      0.0275
    ],
    [
      "affermir",
      0.0275
    ],
    [
      "affecter",
      0.0275
    ],
    [
      "accorder",
      0.0275
    ],
    [
      "ratifier",
      0.0125
    ],
    [
      "sacrifier",
      0.0125
    ],
    [
      "sanctifier",
      0.0125
    ],
    [
      "sanctionner",
      0.0125
    ],
    [
      "ordonner",
      0.0125
    ],
    [
      "feter",
      0.0125
    ],
    [
      "enteriner",
      0.0125
    ],
    [
      "dedier",
      0.0125
    ],
    [
      "consumer",
      0.0125
    ],
    [
      "batir",
      0.0125
    ],
    [
      "utiliser",
      0.0125
    ]
  ],
  "consacrer": [
    [
      "appliquer",
      0.13
    ],
    [
      "donner",
      0.0725
    ],
    [
      "employer",
      0.0725
    ],
    [
      "vouer",
      0.0575
    ],
    [
      "mettre",
      0.0425
    ],
    [
      "destiner",
      0.0425
    ],
    [
      "benir",
      0.0425
    ],
    [
      "attribuer",
      0.0425
    ],
    [
      "asseoir",
      0.0425
    ],
    [
      "sceller",
      0.0275
    ],
    [
      "sacrer",
      0.0275
    ],
    [
      "oindre",
      0.0275
    ],
    [
      "inaugurer",
      0.0275
    ],
    [
      "devouer",
      0.0275
    ],
    [
      "confirmer",
      0.0275
    ],
    [
      "baptiser",
      0.0275
    ],
    [
      "affermir",
      0.0275
    ],
    [
      "affecter",
      0.0275
    ],
    [
      "accorder",
      0.0275
    ],
    [
      "ratifier",
      0.0125
    ],
    [
      "sacrifier",
      0.0125
    ],
    [
      "sanctifier",
      0.0125
    ],
    [
      "sanctionner",
      0.0125
    ],
    [
      "ordonner",
      0.0125
    ],
    [
      "feter",
      0.0125
    ],
    [
      "enteriner",
      0.0125
    ],
    [
      "dedier",
      0.0125
    ],
    [
      "consumer",
      0.0125
    ],
    [
      "batir",
      0.0125
    ],
    [
      "utiliser",
      0.0125
    ]
  ],
  "golfe": [
    [
      "baie",
      0.1925
    ],
    [
      "abri",
      0.1525
    ],
    [
      "anse",
      0.115
    ],
    [
      "havre",
      0.075
    ],
    [
      "port",
      0.075
    ],
    [
      "ria",
      0.0375
    ],
    [
      "retraite",
      0.0375
    ],
    [
      "fjord",
      0.0375
    ],
    [
      "estuaire",
      0.0375
    ],
    [
      "crique",
      0.0375
    ],
    [
      "conche",
      0.0375
    ],
    [
      "calanque",
      0.0375
    ],
    [
      "asile",
      0.0375
    ],
    [
      "aber",
      0.0375
    ],
    [
      "echancrure",
      0.0375
    ]
  ],
  "changeant": [
    [
      "versatile",
      0.09
    ],
    [
      "mobile",
      0.0875
    ],
    [
      "instable",
      0.0725
    ],
    [
      "capricieux",
      0.065
    ],
    [
      "ondoyant",
      0.06
    ],
    [
      "inconstant",
      0.045
    ],
    [
      "fantasque",
      0.04
    ],
    [
      "fugace",
      0.0325
    ],
    [
      "variable",
      0.0325
    ],
    [
      "divers",
      0.03
    ],
    [
      "inegal",
      0.03
    ],
    [
      "tordu",
      0.03
    ],
    [
      "volage",
      0.03
    ],
    [
      "flottant",
      0.025
    ],
    [
      "incertain",
      0.0225
    ],
    [
      "quinteux",
      0.0225
    ],
    [
      "bizarre",
      0.0175
    ],
    [
      "fragile",
      0.0175
    ],
    [
      "leger",
      0.0175
    ],
    [
      "mouvant",
      0.0175
    ],
    [
      "varie",
      0.015
    ],
    [
      "indecis",
      0.015
    ],
    [
      "fantaisiste",
      0.015
    ],
    [
      "ephemere",
      0.01
    ],
    [
      "vacillant",
      0.01
    ],
    [
      "lunatique",
      0.01
    ],
    [
      "inconsistant",
      0.01
    ],
    [
      "fuyant",
      0.01
    ],
    [
      "dissemblable",
      0.01
    ],
    [
      "chatoyant",
      0.01
    ],
    [
      "ambulant",
      0.01
    ],
    [
      "proteiforme",
      0.0075
    ],
    [
      "nomade",
      0.0025
    ],
    [
      "opportuniste",
      0.0025
    ],
    [
      "oscillant",
      0.0025
    ],
    [
      "papillonnant",
      0.0025
    ],
    [
      "sauteur",
      0.0025
    ],
    [
      "vague",
      0.0025
    ],
    [
      "variant",
      0.0025
    ],
    [
      "multiple",
      0.0025
    ],
    [
      "moire",
      0.0025
    ],
    [
      "miroitant",
      0.0025
    ],
    [
      "journalier",
      0.0025
    ],
    [
      "infidele",
      0.0025
    ],
    [
      "cameleon",
      0.0025
    ],
    [
      "arlequin",
      0.0025
    ],
    [
      "ambulatoire",
      0.0025
    ],
    [
      "alternant",
      0.0025
    ],
    [
      "elastique",
      0.0025
    ]
  ],
  "etang": [
    [
      "lac",
      0.2925
    ],
    [
      "mare",
      0.125
    ],
    [
      "reservoir",
      0.0825
    ],
    [
      "marais",
      0.0825
    ],
    [
      "lagon",
      0.0825
    ],
    [
      "bassin",
      0.0825
    ],
    [
      "chott",
      0.04
    ],
    [
      "lagune",
      0.04
    ],
    [
      "marecage",
      0.04
    ],
    [
      "retenue",
      0.04
    ]
  ],
  "footing": [
    [
      "jogging",
      0.5
    ],
    [
      "marche",
      0.5
    ]
  ],
  "corail": [
    [
      "corallin",
      0.25
    ],
    [
      "herpes",
      0.25
    ],
    [
      "puntarelle",
      0.25
    ],
    [
      "rouge",
      0.25
    ]
  ],
  "rigole": [
    [
      "canal",
      0.165
    ],
    [
      "fosse",
      0.165
    ],
    [
      "ruisseau",
      0.165
    ],
    [
      "caniveau",
      0.0825
    ],
    [
      "tranchee",
      0.0825
    ],
    [
      "saignee",
      0.04
    ],
    [
      "ruisson",
      0.04
    ],
    [
      "ruisselet",
      0.04
    ],
    [
      "goulotte",
      0.04
    ],
    [
      "fosse",
      0.04
    ],
    [
      "coupure",
      0.04
    ],
    [
      "cassis",
      0.04
    ],
    [
      "sillon",
      0.04
    ]
  ],
  "requin": [
    [
      "voleur",
      0.12
    ],
    [
      "bandit",
      0.09
    ],
    [
      "forban",
      0.09
    ],
    [
      "pirate",
      0.09
    ],
    [
      "rapace",
      0.09
    ],
    [
      "vautour",
      0.06
    ],
    [
      "corsaire",
      0.06
    ],
    [
      "brigand",
      0.06
    ],
    [
      "marteau",
      0.03
    ],
    [
      "margoulin",
      0.03
    ],
    [
      "maillet",
      0.03
    ],
    [
      "loup",
      0.03
    ],
    [
      "lamie",
      0.03
    ],
    [
      "griset",
      0.03
    ],
    [
      "gangster",
      0.03
    ],
    [
      "corbeau",
      0.03
    ],
    [
      "aiguillat",
      0.03
    ],
    [
      "squale",
      0.03
    ]
  ],
  "fremir": [
    [
      "frissonner",
      0.1925
    ],
    [
      "trembler",
      0.165
    ],
    [
      "vibrer",
      0.11
    ],
    [
      "tressaillir",
      0.0825
    ],
    [
      "tremuler",
      0.0825
    ],
    [
      "s'agiter",
      0.055
    ],
    [
      "palpiter",
      0.055
    ],
    [
      "murmurer",
      0.055
    ],
    [
      "bruire",
      0.055
    ],
    [
      "bouillir",
      0.0275
    ],
    [
      "chuchoter",
      0.0275
    ],
    [
      "grelotter",
      0.0275
    ],
    [
      "gronder",
      0.0275
    ],
    [
      "onduler",
      0.0275
    ]
  ],
  "clebs": [
    [
      "cabot",
      0.4
    ],
    [
      "cador",
      0.2
    ],
    [
      "chien",
      0.2
    ],
    [
      "clebard",
      0.2
    ]
  ],
  "aout": [
    [
      "auguste",
      0.5
    ],
    [
      "moisson",
      0.5
    ]
  ],
  "allumette": [
    [
      "brandon",
      0.5
    ],
    [
      "feu",
      0.25
    ],
    [
      "tison",
      0.25
    ]
  ],
  "vendredi": [],
  "cochonnet": [
    [
      "boule",
      0.2
    ],
    [
      "cochon",
      0.2
    ],
    [
      "goret",
      0.2
    ],
    [
      "porc",
      0.2
    ],
    [
      "porcelet",
      0.2
    ]
  ],
  "cauchemar": [
    [
      "spectre",
      0.165
    ],
    [
      "obsession",
      0.1325
    ],
    [
      "crainte",
      0.1
    ],
    [
      "hallucination",
      0.1
    ],
    [
      "peur",
      0.1
    ],
    [
      "tourment",
      0.065
    ],
    [
      "reve",
      0.065
    ],
    [
      "hantise",
      0.065
    ],
    [
      "delire",
      0.0325
    ],
    [
      "horreur",
      0.0325
    ],
    [
      "songe",
      0.0325
    ]
  ],
  "petale": [
    [
      "feuille",
      1.0
    ]
  ],
  "theme": [
    [
      "matiere",
      0.1625
    ],
    [
      "sujet",
      0.1225
    ],
    [
      "fable",
      0.08
    ],
    [
      "chapitre",
      0.06
    ],
    [
      "fond",
      0.06
    ],
    [
      "objet",
      0.06
    ],
    [
      "trame",
      0.04
    ],
    [
      "refrain",
      0.04
    ],
    [
      "propos",
      0.04
    ],
    [
      "motif",
      0.04
    ],
    [
      "leitmotiv",
      0.04
    ],
    [
      "intrigue",
      0.04
    ],
    [
      "idee",
      0.04
    ],
    [
      "thematique",
      0.0175
    ],
    [
      "terrain",
      0.0175
    ],
    [
      "radical",
      0.0175
    ],
    [
      "question",
      0.0175
    ],
    [
      "point",
      0.0175
    ],
    [
      "conception",
      0.0175
    ],
    [
      "air",
      0.0175
    ],
    [
      "traduction",
      0.0175
    ]
  ],
  "groupie": [
    [
      "fan",
      0.5
    ],
    [
      "fana",
      0.5
    ]
  ],
  "mare": [
    [
      "lac",
      0.2725
    ],
    [
      "etang",
      0.2725
    ],
    [
      "flache",
      0.09
    ],
    [
      "flaque",
      0.09
    ],
    [
      "lagon",
      0.09
    ],
    [
      "marais",
      0.09
    ]
  ],
  "mar": [],
  "7e": [],
  "2e": [],
  "58e": [],
  "anche": [
    [
      "cannelle",
      1.0
    ]
  ],
  "piccolo": [
    [
      "picrate",
      0.3325
    ],
    [
      "flute",
      0.165
    ],
    [
      "pichenet",
      0.165
    ],
    [
      "picton",
      0.165
    ],
    [
      "vin",
      0.165
    ]
  ],
  "avenue": [
    [
      "advenu",
      0.5
    ],
    [
      "ne",
      0.5
    ]
  ],
  "etourdir": [
    [
      "fatiguer",
      0.0775
    ],
    [
      "assommer",
      0.0675
    ],
    [
      "endormir",
      0.06
    ],
    [
      "ennuyer",
      0.06
    ],
    [
      "abasourdir",
      0.05
    ],
    [
      "etonner",
      0.0425
    ],
    [
      "assourdir",
      0.0425
    ],
    [
      "stupefier",
      0.0325
    ],
    [
      "souler",
      0.0325
    ],
    [
      "griser",
      0.0325
    ],
    [
      "diminuer",
      0.0325
    ],
    [
      "abrutir",
      0.0325
    ],
    [
      "raser",
      0.025
    ],
    [
      "enivrer",
      0.025
    ],
    [
      "engourdir",
      0.025
    ],
    [
      "bassiner",
      0.025
    ],
    [
      "assoupir",
      0.025
    ],
    [
      "etouffer",
      0.015
    ],
    [
      "ebranler",
      0.015
    ],
    [
      "tanner",
      0.015
    ],
    [
      "soulager",
      0.015
    ],
    [
      "saisir",
      0.015
    ],
    [
      "hebeter",
      0.015
    ],
    [
      "chavirer",
      0.015
    ],
    [
      "bercer",
      0.015
    ],
    [
      "taper",
      0.0075
    ],
    [
      "sonner",
      0.0075
    ],
    [
      "incommoder",
      0.0075
    ],
    [
      "enteter",
      0.0075
    ],
    [
      "distraire",
      0.0075
    ],
    [
      "eblouir",
      0.0075
    ]
  ],
  "etourdi": [
    [
      "ecervele",
      0.095
    ],
    [
      "irreflechi",
      0.09
    ],
    [
      "leger",
      0.0675
    ],
    [
      "evapore",
      0.0675
    ],
    [
      "imprudent",
      0.05
    ],
    [
      "inattentif",
      0.045
    ],
    [
      "imprevoyant",
      0.035
    ],
    [
      "fou",
      0.03
    ],
    [
      "inconsequent",
      0.03
    ],
    [
      "malavise",
      0.03
    ],
    [
      "temeraire",
      0.0275
    ],
    [
      "surpris",
      0.0275
    ],
    [
      "sot",
      0.0275
    ],
    [
      "insouciant",
      0.0275
    ],
    [
      "inconsidere",
      0.0225
    ],
    [
      "negligent",
      0.0225
    ],
    [
      "stupefait",
      0.0225
    ],
    [
      "farfelu",
      0.0175
    ],
    [
      "distrait",
      0.0175
    ],
    [
      "etourneau",
      0.0125
    ],
    [
      "sidere",
      0.0125
    ],
    [
      "hurluberlu",
      0.0125
    ],
    [
      "frivole",
      0.0125
    ],
    [
      "fatigue",
      0.0125
    ],
    [
      "deconcerte",
      0.0125
    ],
    [
      "consterne",
      0.0125
    ],
    [
      "bete",
      0.0125
    ],
    [
      "abruti",
      0.0125
    ],
    [
      "ebahi",
      0.0075
    ],
    [
      "maladroit",
      0.0075
    ],
    [
      "interloque",
      0.0075
    ],
    [
      "inapplique",
      0.0075
    ],
    [
      "braque",
      0.0075
    ],
    [
      "absent",
      0.0075
    ],
    [
      "evaltonne",
      0.0025
    ],
    [
      "soul",
      0.0025
    ],
    [
      "sonne",
      0.0025
    ],
    [
      "reveur",
      0.0025
    ],
    [
      "linotte",
      0.0025
    ],
    [
      "incommode",
      0.0025
    ],
    [
      "hanneton",
      0.0025
    ],
    [
      "engourdi",
      0.0025
    ],
    [
      "brouillon",
      0.0025
    ],
    [
      "atterre",
      0.0025
    ],
    [
      "evente",
      0.0025
    ]
  ],
  "orchestrer": [
    [
      "ordonner",
      0.155
    ],
    [
      "organiser",
      0.155
    ],
    [
      "planifier",
      0.075
    ],
    [
      "instrumenter",
      0.075
    ],
    [
      "harmoniser",
      0.075
    ],
    [
      "divulguer",
      0.075
    ],
    [
      "clamer",
      0.075
    ],
    [
      "arranger",
      0.075
    ],
    [
      "amplifier",
      0.075
    ],
    [
      "repandre",
      0.075
    ]
  ],
  "orchestre": [
    [
      "harmonie",
      0.12
    ],
    [
      "musique",
      0.12
    ],
    [
      "fanfare",
      0.1
    ],
    [
      "ensemble",
      0.08
    ],
    [
      "formation",
      0.06
    ],
    [
      "groupe",
      0.06
    ],
    [
      "quintette",
      0.04
    ],
    [
      "quatuor",
      0.04
    ],
    [
      "orpheon",
      0.04
    ],
    [
      "concert",
      0.04
    ],
    [
      "clique",
      0.04
    ],
    [
      "choeur",
      0.04
    ],
    [
      "sextuor",
      0.02
    ],
    [
      "septuor",
      0.02
    ],
    [
      "parterre",
      0.02
    ],
    [
      "parquet",
      0.02
    ],
    [
      "octuor",
      0.02
    ],
    [
      "nouba",
      0.02
    ],
    [
      "melodie",
      0.02
    ],
    [
      "lyre",
      0.02
    ],
    [
      "trio",
      0.02
    ]
  ],
  "furie": [
    [
      "megere",
      0.0975
    ],
    [
      "fureur",
      0.0825
    ],
    [
      "frenesie",
      0.075
    ],
    [
      "virago",
      0.075
    ],
    [
      "harengere",
      0.0675
    ],
    [
      "emportement",
      0.0675
    ],
    [
      "ardeur",
      0.0525
    ],
    [
      "grenadier",
      0.045
    ],
    [
      "passion",
      0.045
    ],
    [
      "violence",
      0.0375
    ],
    [
      "rage",
      0.0375
    ],
    [
      "impetuosite",
      0.03
    ],
    [
      "colere",
      0.0225
    ],
    [
      "harpie",
      0.0225
    ],
    [
      "vehemence",
      0.015
    ],
    [
      "pouffiasse",
      0.015
    ],
    [
      "manie",
      0.015
    ],
    [
      "demon",
      0.015
    ],
    [
      "dragon",
      0.015
    ],
    [
      "diable",
      0.015
    ],
    [
      "courage",
      0.015
    ],
    [
      "acharnement",
      0.015
    ],
    [
      "junon",
      0.005
    ],
    [
      "maritorne",
      0.005
    ],
    [
      "menade",
      0.005
    ],
    [
      "poissarde",
      0.005
    ],
    [
      "rombiere",
      0.005
    ],
    [
      "toquade",
      0.005
    ],
    [
      "grognasse",
      0.005
    ],
    [
      "gorgone",
      0.005
    ],
    [
      "gendarme",
      0.005
    ],
    [
      "furia",
      0.005
    ],
    [
      "fougue",
      0.005
    ],
    [
      "courroux",
      0.005
    ],
    [
      "bacchante",
      0.005
    ],
    [
      "tricoteuse",
      0.005
    ]
  ],
  "transi": [
    [
      "gele",
      0.0925
    ],
    [
      "fige",
      0.0625
    ],
    [
      "frissonnant",
      0.0625
    ],
    [
      "epouvante",
      0.045
    ],
    [
      "tremblant",
      0.045
    ],
    [
      "terrifie",
      0.045
    ],
    [
      "paralyse",
      0.045
    ],
    [
      "langoureux",
      0.045
    ],
    [
      "glace",
      0.045
    ],
    [
      "froid",
      0.045
    ],
    [
      "mourant",
      0.03
    ],
    [
      "mort",
      0.03
    ],
    [
      "languissant",
      0.03
    ],
    [
      "languide",
      0.03
    ],
    [
      "inquiet",
      0.03
    ],
    [
      "hallucine",
      0.03
    ],
    [
      "engourdi",
      0.03
    ],
    [
      "effraye",
      0.03
    ],
    [
      "amoureux",
      0.03
    ],
    [
      "alangui",
      0.03
    ],
    [
      "stupefie",
      0.015
    ],
    [
      "sentimental",
      0.015
    ],
    [
      "saisi",
      0.015
    ],
    [
      "rive",
      0.015
    ],
    [
      "petrifie",
      0.015
    ],
    [
      "penetre",
      0.015
    ],
    [
      "morfondu",
      0.015
    ],
    [
      "grelottant",
      0.015
    ],
    [
      "timide",
      0.015
    ]
  ],
  "transir": [
    [
      "petrifier",
      0.165
    ],
    [
      "paralyser",
      0.125
    ],
    [
      "glacer",
      0.0825
    ],
    [
      "stupefier",
      0.0825
    ],
    [
      "etonner",
      0.04
    ],
    [
      "epouvanter",
      0.04
    ],
    [
      "transpercer",
      0.04
    ],
    [
      "saisir",
      0.04
    ],
    [
      "penetrer",
      0.04
    ],
    [
      "meduser",
      0.04
    ],
    [
      "figer",
      0.04
    ],
    [
      "engourdir",
      0.04
    ],
    [
      "clouer",
      0.04
    ],
    [
      "ebahir",
      0.02
    ],
    [
      "traverser",
      0.02
    ],
    [
      "terrifier",
      0.02
    ],
    [
      "river",
      0.02
    ],
    [
      "morfondre",
      0.02
    ],
    [
      "geler",
      0.02
    ],
    [
      "effrayer",
      0.02
    ],
    [
      "etrangler",
      0.02
    ]
  ],
  "renvoyer": [
    [
      "chasser",
      0.0725
    ],
    [
      "congedier",
      0.07
    ],
    [
      "remercier",
      0.0525
    ],
    [
      "vider",
      0.045
    ],
    [
      "repousser",
      0.035
    ],
    [
      "rejeter",
      0.0325
    ],
    [
      "eloigner",
      0.03
    ],
    [
      "balancer",
      0.0275
    ],
    [
      "remettre",
      0.025
    ],
    [
      "ecarter",
      0.025
    ],
    [
      "licencier",
      0.0225
    ],
    [
      "exclure",
      0.0225
    ],
    [
      "balayer",
      0.02
    ],
    [
      "revoquer",
      0.02
    ],
    [
      "destituer",
      0.0175
    ],
    [
      "debarquer",
      0.0175
    ],
    [
      "limoger",
      0.0175
    ],
    [
      "refuser",
      0.0175
    ],
    [
      "econduire",
      0.0175
    ],
    [
      "retarder",
      0.015
    ],
    [
      "reculer",
      0.015
    ],
    [
      "ajourner",
      0.015
    ],
    [
      "differer",
      0.015
    ],
    [
      "expulser",
      0.015
    ],
    [
      "virer",
      0.015
    ],
    [
      "envoyer",
      0.01
    ],
    [
      "transporter",
      0.0075
    ],
    [
      "temporiser",
      0.0075
    ],
    [
      "reverberer",
      0.0075
    ],
    [
      "repercuter",
      0.0075
    ],
    [
      "reporter",
      0.0075
    ],
    [
      "proroger",
      0.0075
    ],
    [
      "liquider",
      0.0075
    ],
    [
      "demettre",
      0.0075
    ],
    [
      "oter",
      0.005
    ],
    [
      "suspendre",
      0.005
    ],
    [
      "surseoir",
      0.005
    ],
    [
      "repeter",
      0.005
    ],
    [
      "retourner",
      0.005
    ],
    [
      "pousser",
      0.005
    ],
    [
      "lourder",
      0.005
    ],
    [
      "degommer",
      0.005
    ],
    [
      "casser",
      0.005
    ],
    [
      "transmettre",
      0.005
    ],
    [
      "rendre",
      0.005
    ],
    [
      "expedier",
      0.005
    ],
    [
      "emballer",
      0.005
    ],
    [
      "degoter",
      0.005
    ],
    [
      "debouter",
      0.005
    ],
    [
      "reproduire",
      0.0025
    ],
    [
      "refleter",
      0.0025
    ],
    [
      "exiler",
      0.0025
    ],
    [
      "decliner",
      0.0025
    ],
    [
      "decharger",
      0.0025
    ],
    [
      "atermoyer",
      0.0025
    ],
    [
      "annuler",
      0.0025
    ],
    [
      "relancer",
      0.0
    ],
    [
      "larguer",
      0.0
    ],
    [
      "retentir",
      0.0
    ],
    [
      "reexpedier",
      0.0
    ],
    [
      "reflechir",
      0.0
    ],
    [
      "repudier",
      0.0
    ],
    [
      "resonner",
      0.0
    ],
    [
      "saquer",
      0.0
    ],
    [
      "tarder",
      0.0
    ],
    [
      "disgracier",
      0.0
    ],
    [
      "debaucher",
      0.0
    ],
    [
      "debucher",
      0.0
    ],
    [
      "demobiliser",
      0.0
    ],
    [
      "excommunier",
      0.0
    ],
    [
      "bourlinguer",
      0.0
    ]
  ],
  "pause": [
    [
      "arret",
      0.09
    ],
    [
      "repos",
      0.09
    ],
    [
      "interruption",
      0.08
    ],
    [
      "repit",
      0.07
    ],
    [
      "treve",
      0.05
    ],
    [
      "suspension",
      0.05
    ],
    [
      "intervalle",
      0.05
    ],
    [
      "detente",
      0.05
    ],
    [
      "cessation",
      0.04
    ],
    [
      "halte",
      0.04
    ],
    [
      "relache",
      0.04
    ],
    [
      "remission",
      0.03
    ],
    [
      "recreation",
      0.03
    ],
    [
      "entracte",
      0.03
    ],
    [
      "delassement",
      0.03
    ],
    [
      "battement",
      0.03
    ],
    [
      "station",
      0.02
    ],
    [
      "stagnation",
      0.02
    ],
    [
      "silence",
      0.0075
    ],
    [
      "relaxation",
      0.0075
    ],
    [
      "pietinement",
      0.0075
    ],
    [
      "loisir",
      0.0075
    ],
    [
      "interclasse",
      0.0075
    ],
    [
      "cesure",
      0.0075
    ],
    [
      "attente",
      0.0075
    ],
    [
      "abattement",
      0.0075
    ],
    [
      "sejour",
      0.0075
    ]
  ],
  "eclipser": [
    [
      "cacher",
      0.1125
    ],
    [
      "obscurcir",
      0.1125
    ],
    [
      "voiler",
      0.095
    ],
    [
      "effacer",
      0.075
    ],
    [
      "triompher",
      0.055
    ],
    [
      "surpasser",
      0.055
    ],
    [
      "offusquer",
      0.055
    ],
    [
      "couvrir",
      0.055
    ],
    [
      "ecraser",
      0.0375
    ],
    [
      "vaincre",
      0.0375
    ],
    [
      "ternir",
      0.0375
    ],
    [
      "supplanter",
      0.0375
    ],
    [
      "occulter",
      0.0375
    ],
    [
      "masquer",
      0.0375
    ],
    [
      "intercepter",
      0.0375
    ],
    [
      "detroner",
      0.0375
    ],
    [
      "l'emporter",
      0.0175
    ],
    [
      "palir",
      0.0175
    ],
    [
      "surclasser",
      0.0175
    ]
  ],
  "eclipse": [
    [
      "chute",
      0.0775
    ],
    [
      "disparition",
      0.0775
    ],
    [
      "obscurcissement",
      0.0775
    ],
    [
      "echec",
      0.0525
    ],
    [
      "occultation",
      0.0525
    ],
    [
      "fiasco",
      0.0525
    ],
    [
      "faillite",
      0.0525
    ],
    [
      "effacement",
      0.0525
    ],
    [
      "defaut",
      0.0525
    ],
    [
      "decadence",
      0.0525
    ],
    [
      "absence",
      0.0525
    ],
    [
      "manque",
      0.025
    ],
    [
      "obnubilation",
      0.025
    ],
    [
      "obscuration",
      0.025
    ],
    [
      "ratage",
      0.025
    ],
    [
      "sommeil",
      0.025
    ],
    [
      "interposition",
      0.025
    ],
    [
      "immersion",
      0.025
    ],
    [
      "defaveur",
      0.025
    ],
    [
      "defaite",
      0.025
    ],
    [
      "defaillance",
      0.025
    ],
    [
      "decheance",
      0.025
    ],
    [
      "affaissement",
      0.025
    ],
    [
      "eloignement",
      0.025
    ]
  ],
  "confortable": [
    [
      "agreable",
      0.1625
    ],
    [
      "doux",
      0.1275
    ],
    [
      "aimable",
      0.0975
    ],
    [
      "vivable",
      0.0625
    ],
    [
      "moelleux",
      0.0625
    ],
    [
      "grand",
      0.0625
    ],
    [
      "coquet",
      0.0625
    ],
    [
      "commode",
      0.0625
    ],
    [
      "large",
      0.03
    ],
    [
      "honorable",
      0.03
    ],
    [
      "honnete",
      0.03
    ],
    [
      "douillet",
      0.03
    ],
    [
      "considerable",
      0.03
    ],
    [
      "confortabilite",
      0.03
    ],
    [
      "confort",
      0.03
    ],
    [
      "bourgeois",
      0.03
    ],
    [
      "luxueux",
      0.03
    ]
  ],
  "batifoler": [
    [
      "folatrer",
      0.2
    ],
    [
      "s'amuser",
      0.17
    ],
    [
      "s'ebattre",
      0.085
    ],
    [
      "papillonner",
      0.055
    ],
    [
      "marivauder",
      0.055
    ],
    [
      "jouer",
      0.055
    ],
    [
      "flaner",
      0.055
    ],
    [
      "baguenauder",
      0.055
    ],
    [
      "plaisanter",
      0.0275
    ],
    [
      "peloter",
      0.0275
    ],
    [
      "lutiner",
      0.0275
    ],
    [
      "gambader",
      0.0275
    ],
    [
      "folichonner",
      0.0275
    ],
    [
      "flirter",
      0.0275
    ],
    [
      "cabrioler",
      0.0275
    ],
    [
      "roucouler",
      0.0275
    ]
  ],
  "rossignol": [
    [
      "clef",
      0.1175
    ],
    [
      "roustissure",
      0.0575
    ],
    [
      "pouillot",
      0.0575
    ],
    [
      "pince",
      0.0575
    ],
    [
      "pigeonneau",
      0.0575
    ],
    [
      "philomele",
      0.0575
    ],
    [
      "passe",
      0.0575
    ],
    [
      "occasion",
      0.0575
    ],
    [
      "nanard",
      0.0575
    ],
    [
      "marchandise",
      0.0575
    ],
    [
      "invendable",
      0.0575
    ],
    [
      "crochet",
      0.0575
    ],
    [
      "salete",
      0.0575
    ]
  ],
  "deserteur": [
    [
      "transfuge",
      0.25
    ],
    [
      "lache",
      0.165
    ],
    [
      "renegat",
      0.165
    ],
    [
      "traitre",
      0.165
    ],
    [
      "apostat",
      0.0825
    ],
    [
      "fuyard",
      0.0825
    ],
    [
      "insoumis",
      0.0825
    ]
  ],
  "militaire": [
    [
      "soldat",
      0.2
    ],
    [
      "guerrier",
      0.1325
    ],
    [
      "strategique",
      0.065
    ],
    [
      "soldatesque",
      0.065
    ],
    [
      "polemologique",
      0.065
    ],
    [
      "martial",
      0.065
    ],
    [
      "engage",
      0.065
    ],
    [
      "boucher",
      0.065
    ],
    [
      "belliqueux",
      0.065
    ],
    [
      "baderne",
      0.065
    ],
    [
      "tactique",
      0.065
    ]
  ],
  "mercredi": [
    [
      "merde",
      1.0
    ]
  ],
  "deserter": [
    [
      "abandonner",
      0.225
    ],
    [
      "delaisser",
      0.135
    ],
    [
      "quitter",
      0.135
    ],
    [
      "s'eloigner",
      0.135
    ],
    [
      "renier",
      0.09
    ],
    [
      "negliger",
      0.09
    ],
    [
      "oublier",
      0.045
    ],
    [
      "partir",
      0.045
    ],
    [
      "s'enfuir",
      0.045
    ],
    [
      "trahir",
      0.045
    ]
  ],
  "gendarme": [
    [
      "agent",
      0.0825
    ],
    [
      "cavalier",
      0.0825
    ],
    [
      "policier",
      0.0825
    ],
    [
      "guignol",
      0.04
    ],
    [
      "harengere",
      0.04
    ],
    [
      "megere",
      0.04
    ],
    [
      "pandore",
      0.04
    ],
    [
      "grenadier",
      0.04
    ],
    [
      "gardien",
      0.04
    ],
    [
      "furie",
      0.04
    ],
    [
      "cogne",
      0.04
    ],
    [
      "chardonneret",
      0.04
    ],
    [
      "carabinier",
      0.04
    ],
    [
      "brigadier",
      0.04
    ],
    [
      "bleu",
      0.04
    ],
    [
      "argoulet",
      0.04
    ],
    [
      "virago",
      0.04
    ]
  ],
  "dock": [
    [
      "depot",
      0.1525
    ],
    [
      "magasin",
      0.1525
    ],
    [
      "port",
      0.1525
    ],
    [
      "quai",
      0.1525
    ],
    [
      "bassin",
      0.075
    ],
    [
      "entrepot",
      0.075
    ],
    [
      "forme",
      0.075
    ],
    [
      "radoub",
      0.075
    ],
    [
      "silo",
      0.075
    ]
  ],
  "alourdir": [
    [
      "charger",
      0.13
    ],
    [
      "aggraver",
      0.0775
    ],
    [
      "grossir",
      0.0775
    ],
    [
      "appesantir",
      0.065
    ],
    [
      "augmenter",
      0.065
    ],
    [
      "grever",
      0.065
    ],
    [
      "peser",
      0.065
    ],
    [
      "surcharger",
      0.0525
    ],
    [
      "accabler",
      0.0525
    ],
    [
      "enrichir",
      0.0375
    ],
    [
      "garnir",
      0.0375
    ],
    [
      "renforcer",
      0.0375
    ],
    [
      "epaissir",
      0.025
    ],
    [
      "frapper",
      0.025
    ],
    [
      "engraisser",
      0.025
    ],
    [
      "engourdir",
      0.025
    ],
    [
      "encombrer",
      0.025
    ],
    [
      "congestionner",
      0.0125
    ],
    [
      "embarrasser",
      0.0125
    ],
    [
      "endormir",
      0.0125
    ],
    [
      "lester",
      0.0125
    ],
    [
      "opprimer",
      0.0125
    ],
    [
      "presser",
      0.0125
    ]
  ],
  "vagabonder": [
    [
      "errer",
      0.1825
    ],
    [
      "flaner",
      0.1375
    ],
    [
      "roder",
      0.1375
    ],
    [
      "trainer",
      0.09
    ],
    [
      "vaguer",
      0.06
    ],
    [
      "vadrouiller",
      0.06
    ],
    [
      "marcher",
      0.06
    ],
    [
      "deambuler",
      0.045
    ],
    [
      "trainasser",
      0.045
    ],
    [
      "divaguer",
      0.03
    ],
    [
      "musarder",
      0.015
    ],
    [
      "polissonner",
      0.015
    ],
    [
      "s'ebattre",
      0.015
    ],
    [
      "voyager",
      0.015
    ]
  ],
  "debarbouiller": [
    [
      "nettoyer",
      0.2725
    ],
    [
      "decrasser",
      0.18
    ],
    [
      "frotter",
      0.18
    ],
    [
      "debourber",
      0.09
    ],
    [
      "laver",
      0.09
    ],
    [
      "polir",
      0.09
    ],
    [
      "recurer",
      0.09
    ]
  ],
  "notion": [
    [
      "idee",
      0.1575
    ],
    [
      "connaissance",
      0.14
    ],
    [
      "sentiment",
      0.0875
    ],
    [
      "pensee",
      0.07
    ],
    [
      "conscience",
      0.07
    ],
    [
      "conception",
      0.07
    ],
    [
      "teinture",
      0.0525
    ],
    [
      "element",
      0.0325
    ],
    [
      "sens",
      0.0325
    ],
    [
      "principe",
      0.0325
    ],
    [
      "intuition",
      0.0325
    ],
    [
      "impression",
      0.0325
    ],
    [
      "imagination",
      0.0325
    ],
    [
      "concept",
      0.0325
    ],
    [
      "clarte",
      0.0325
    ],
    [
      "abstraction",
      0.015
    ],
    [
      "apercu",
      0.015
    ],
    [
      "competence",
      0.015
    ],
    [
      "vernis",
      0.015
    ]
  ],
  "deposer": [
    [
      "abandonner",
      0.065
    ],
    [
      "quitter",
      0.0475
    ],
    [
      "revoquer",
      0.04
    ],
    [
      "renoncer",
      0.04
    ],
    [
      "remettre",
      0.04
    ],
    [
      "laisser",
      0.04
    ],
    [
      "detroner",
      0.04
    ],
    [
      "destituer",
      0.04
    ],
    [
      "oter",
      0.03
    ],
    [
      "supprimer",
      0.03
    ],
    [
      "poser",
      0.03
    ],
    [
      "mettre",
      0.03
    ],
    [
      "demissionner",
      0.03
    ],
    [
      "demettre",
      0.03
    ],
    [
      "donner",
      0.03
    ],
    [
      "casser",
      0.03
    ],
    [
      "temoigner",
      0.0225
    ],
    [
      "interdire",
      0.0225
    ],
    [
      "enlever",
      0.0225
    ],
    [
      "declarer",
      0.0225
    ],
    [
      "abdiquer",
      0.0225
    ],
    [
      "verser",
      0.015
    ],
    [
      "signaler",
      0.015
    ],
    [
      "resigner",
      0.015
    ],
    [
      "reposer",
      0.015
    ],
    [
      "produire",
      0.015
    ],
    [
      "limoger",
      0.015
    ],
    [
      "consigner",
      0.015
    ],
    [
      "confier",
      0.015
    ],
    [
      "chasser",
      0.015
    ],
    [
      "arreter",
      0.015
    ],
    [
      "placer",
      0.0075
    ],
    [
      "perdre",
      0.0075
    ],
    [
      "formuler",
      0.0075
    ],
    [
      "entreposer",
      0.0075
    ],
    [
      "emmagasiner",
      0.0075
    ],
    [
      "decharger",
      0.0075
    ],
    [
      "descendre",
      0.0075
    ],
    [
      "attester",
      0.0075
    ],
    [
      "presenter",
      0.0075
    ]
  ],
  "depose": [
    [
      "abandonner",
      0.065
    ],
    [
      "quitter",
      0.0475
    ],
    [
      "revoquer",
      0.04
    ],
    [
      "renoncer",
      0.04
    ],
    [
      "remettre",
      0.04
    ],
    [
      "laisser",
      0.04
    ],
    [
      "detroner",
      0.04
    ],
    [
      "destituer",
      0.04
    ],
    [
      "oter",
      0.03
    ],
    [
      "supprimer",
      0.03
    ],
    [
      "poser",
      0.03
    ],
    [
      "mettre",
      0.03
    ],
    [
      "demissionner",
      0.03
    ],
    [
      "demettre",
      0.03
    ],
    [
      "donner",
      0.03
    ],
    [
      "casser",
      0.03
    ],
    [
      "temoigner",
      0.0225
    ],
    [
      "interdire",
      0.0225
    ],
    [
      "enlever",
      0.0225
    ],
    [
      "declarer",
      0.0225
    ],
    [
      "abdiquer",
      0.0225
    ],
    [
      "verser",
      0.015
    ],
    [
      "signaler",
      0.015
    ],
    [
      "resigner",
      0.015
    ],
    [
      "reposer",
      0.015
    ],
    [
      "produire",
      0.015
    ],
    [
      "limoger",
      0.015
    ],
    [
      "consigner",
      0.015
    ],
    [
      "confier",
      0.015
    ],
    [
      "chasser",
      0.015
    ],
    [
      "arreter",
      0.015
    ],
    [
      "placer",
      0.0075
    ],
    [
      "perdre",
      0.0075
    ],
    [
      "formuler",
      0.0075
    ],
    [
      "entreposer",
      0.0075
    ],
    [
      "emmagasiner",
      0.0075
    ],
    [
      "decharger",
      0.0075
    ],
    [
      "descendre",
      0.0075
    ],
    [
      "attester",
      0.0075
    ],
    [
      "presenter",
      0.0075
    ]
  ],
  "greve": [
    [
      "charger",
      0.2025
    ],
    [
      "accabler",
      0.135
    ],
    [
      "alourdir",
      0.1125
    ],
    [
      "surcharger",
      0.09
    ],
    [
      "ecraser",
      0.0675
    ],
    [
      "peser",
      0.0675
    ],
    [
      "imposer",
      0.0675
    ],
    [
      "frapper",
      0.0675
    ],
    [
      "affliger",
      0.045
    ],
    [
      "aggraver",
      0.045
    ],
    [
      "pressurer",
      0.045
    ],
    [
      "affecter",
      0.0225
    ],
    [
      "oppresser",
      0.0225
    ]
  ],
  "grever": [
    [
      "charger",
      0.2025
    ],
    [
      "accabler",
      0.135
    ],
    [
      "alourdir",
      0.1125
    ],
    [
      "surcharger",
      0.09
    ],
    [
      "ecraser",
      0.0675
    ],
    [
      "peser",
      0.0675
    ],
    [
      "imposer",
      0.0675
    ],
    [
      "frapper",
      0.0675
    ],
    [
      "affliger",
      0.045
    ],
    [
      "aggraver",
      0.045
    ],
    [
      "pressurer",
      0.045
    ],
    [
      "affecter",
      0.0225
    ],
    [
      "oppresser",
      0.0225
    ]
  ],
  "rafiot": [
    [
      "baille",
      0.2
    ],
    [
      "barque",
      0.2
    ],
    [
      "bateau",
      0.2
    ],
    [
      "embarcation",
      0.2
    ]
  ],
  "craquant": [
    [
      "croquant",
      0.5
    ],
    [
      "dur",
      0.5
    ]
  ],
  "coque": [
    [
      "coquille",
      0.1425
    ],
    [
      "bouffette",
      0.095
    ],
    [
      "carcasse",
      0.095
    ],
    [
      "ruban",
      0.095
    ],
    [
      "solitude",
      0.0475
    ],
    [
      "rigadeau",
      0.0475
    ],
    [
      "oeuf",
      0.0475
    ],
    [
      "noeud",
      0.0475
    ],
    [
      "habitacle",
      0.0475
    ],
    [
      "coquillage",
      0.0475
    ],
    [
      "coiffure",
      0.0475
    ],
    [
      "chassis",
      0.0475
    ],
    [
      "cardiides",
      0.0475
    ],
    [
      "caisse",
      0.0475
    ],
    [
      "brou",
      0.0475
    ],
    [
      "ecaille",
      0.0475
    ]
  ],
  "soute": [
    [
      "abri",
      0.3325
    ],
    [
      "cale",
      0.3325
    ],
    [
      "magasin",
      0.3325
    ]
  ],
  "alanguir": [
    [
      "affaiblir",
      0.19
    ],
    [
      "amollir",
      0.1425
    ],
    [
      "enerver",
      0.095
    ],
    [
      "emasculer",
      0.095
    ],
    [
      "fatiguer",
      0.095
    ],
    [
      "effeminer",
      0.095
    ],
    [
      "diminuer",
      0.095
    ],
    [
      "abattre",
      0.045
    ],
    [
      "assoupir",
      0.045
    ],
    [
      "detendre",
      0.045
    ],
    [
      "ramollir",
      0.045
    ]
  ],
  "alangui": [
    [
      "langoureux",
      0.2
    ],
    [
      "languide",
      0.165
    ],
    [
      "languissant",
      0.1325
    ],
    [
      "nonchalant",
      0.1
    ],
    [
      "transi",
      0.065
    ],
    [
      "tendre",
      0.065
    ],
    [
      "indolent",
      0.065
    ],
    [
      "amoureux",
      0.065
    ],
    [
      "effemine",
      0.0325
    ],
    [
      "lent",
      0.0325
    ],
    [
      "mourant",
      0.0325
    ],
    [
      "torpide",
      0.0325
    ]
  ],
  "tresser": [
    [
      "manigancer",
      0.0975
    ],
    [
      "ourdir",
      0.0975
    ],
    [
      "tisser",
      0.0975
    ],
    [
      "tramer",
      0.0975
    ],
    [
      "machiner",
      0.0825
    ],
    [
      "combiner",
      0.07
    ],
    [
      "preparer",
      0.04
    ],
    [
      "nouer",
      0.04
    ],
    [
      "conspirer",
      0.04
    ],
    [
      "comploter",
      0.04
    ],
    [
      "tortiller",
      0.0275
    ],
    [
      "tordre",
      0.0275
    ],
    [
      "monter",
      0.0275
    ],
    [
      "entrelacer",
      0.0275
    ],
    [
      "entortiller",
      0.0275
    ],
    [
      "assembler",
      0.0275
    ],
    [
      "arranger",
      0.0275
    ],
    [
      "amenager",
      0.0125
    ],
    [
      "brasser",
      0.0125
    ],
    [
      "cordonner",
      0.0125
    ],
    [
      "intriguer",
      0.0125
    ],
    [
      "natter",
      0.0125
    ],
    [
      "torsader",
      0.0125
    ]
  ],
  "chantant": [
    [
      "harmonieux",
      0.3325
    ],
    [
      "musical",
      0.3325
    ],
    [
      "melodieux",
      0.3325
    ]
  ],
  "pantomime": [
    [
      "mime",
      0.165
    ],
    [
      "acteur",
      0.11
    ],
    [
      "comedie",
      0.11
    ],
    [
      "geste",
      0.11
    ],
    [
      "saltation",
      0.055
    ],
    [
      "orchestique",
      0.055
    ],
    [
      "mimodrame",
      0.055
    ],
    [
      "mimique",
      0.055
    ],
    [
      "lazzi",
      0.055
    ],
    [
      "histrion",
      0.055
    ],
    [
      "gesticulation",
      0.055
    ],
    [
      "cirque",
      0.055
    ],
    [
      "sketch",
      0.055
    ]
  ],
  "mollet": [
    [
      "douillet",
      0.25
    ],
    [
      "doux",
      0.25
    ],
    [
      "moelleux",
      0.25
    ],
    [
      "mou",
      0.25
    ]
  ],
  "plexiglas": [
    [
      "altuglas",
      1.0
    ]
  ],
  "technicien": [
    [
      "specialiste",
      0.2
    ],
    [
      "technique",
      0.2
    ],
    [
      "professionnel",
      0.1325
    ],
    [
      "technocrate",
      0.1325
    ],
    [
      "executant",
      0.065
    ],
    [
      "ingenieur",
      0.065
    ],
    [
      "technologique",
      0.065
    ],
    [
      "virtuose",
      0.065
    ]
  ],
  "venitien": [],
  "trancher": [
    [
      "decider",
      0.125
    ],
    [
      "couper",
      0.09
    ],
    [
      "arreter",
      0.0475
    ],
    [
      "regler",
      0.0475
    ],
    [
      "resoudre",
      0.0425
    ],
    [
      "juger",
      0.035
    ],
    [
      "statuer",
      0.03
    ],
    [
      "determiner",
      0.0275
    ],
    [
      "prononcer",
      0.0225
    ],
    [
      "jurer",
      0.0225
    ],
    [
      "hacher",
      0.0225
    ],
    [
      "finir",
      0.0225
    ],
    [
      "fendre",
      0.0225
    ],
    [
      "conclure",
      0.0225
    ],
    [
      "ordonner",
      0.0175
    ],
    [
      "diviser",
      0.0175
    ],
    [
      "dire",
      0.0175
    ],
    [
      "briser",
      0.0175
    ],
    [
      "rompre",
      0.015
    ],
    [
      "interrompre",
      0.015
    ],
    [
      "fixer",
      0.015
    ],
    [
      "abattre",
      0.015
    ],
    [
      "vider",
      0.01
    ],
    [
      "terminer",
      0.01
    ],
    [
      "tailler",
      0.01
    ],
    [
      "sectionner",
      0.01
    ],
    [
      "faucher",
      0.01
    ],
    [
      "decreter",
      0.01
    ],
    [
      "decouper",
      0.01
    ],
    [
      "convenir",
      0.01
    ],
    [
      "contraster",
      0.01
    ],
    [
      "choisir",
      0.01
    ],
    [
      "separer",
      0.0075
    ],
    [
      "s'opposer",
      0.0075
    ],
    [
      "ressortir",
      0.0075
    ],
    [
      "detonner",
      0.0075
    ],
    [
      "disposer",
      0.0075
    ],
    [
      "selectionner",
      0.0025
    ],
    [
      "solutionner",
      0.0025
    ],
    [
      "resequer",
      0.0025
    ],
    [
      "hurler",
      0.0025
    ],
    [
      "deliberer",
      0.0025
    ],
    [
      "definir",
      0.0025
    ],
    [
      "decapiter",
      0.0025
    ],
    [
      "cisailler",
      0.0025
    ],
    [
      "arbitrer",
      0.0025
    ],
    [
      "amenuiser",
      0.0025
    ],
    [
      "abreger",
      0.0025
    ],
    [
      "tronconner",
      0.0025
    ]
  ],
  "tranche": [
    [
      "morceau",
      0.1425
    ],
    [
      "partie",
      0.1125
    ],
    [
      "portion",
      0.08
    ],
    [
      "bout",
      0.0475
    ],
    [
      "division",
      0.0475
    ],
    [
      "ramification",
      0.0475
    ],
    [
      "ration",
      0.0475
    ],
    [
      "rondelle",
      0.0475
    ],
    [
      "tartine",
      0.03
    ],
    [
      "part",
      0.03
    ],
    [
      "cote",
      0.03
    ],
    [
      "leche",
      0.015
    ],
    [
      "quartier",
      0.015
    ],
    [
      "rond",
      0.015
    ],
    [
      "rouelle",
      0.015
    ],
    [
      "sandwich",
      0.015
    ],
    [
      "serie",
      0.015
    ],
    [
      "taillon",
      0.015
    ],
    [
      "tende",
      0.015
    ],
    [
      "toast",
      0.015
    ],
    [
      "lame",
      0.015
    ],
    [
      "houe",
      0.015
    ],
    [
      "ados",
      0.015
    ],
    [
      "binette",
      0.015
    ],
    [
      "biscotte",
      0.015
    ],
    [
      "bord",
      0.015
    ],
    [
      "chant",
      0.015
    ],
    [
      "coupe",
      0.015
    ],
    [
      "cote",
      0.015
    ],
    [
      "darne",
      0.015
    ],
    [
      "gouttiere",
      0.015
    ],
    [
      "troncon",
      0.015
    ]
  ],
  "pervenche": [
    [
      "azure",
      0.3325
    ],
    [
      "bleu",
      0.3325
    ],
    [
      "contractuel",
      0.3325
    ]
  ],
  "mousseline": [
    [
      "gaze",
      0.3325
    ],
    [
      "tarlatane",
      0.3325
    ]
  ],
  "meninge": [],
  "environ": [
    [
      "approximativement",
      0.2075
    ],
    [
      "bien",
      0.0675
    ],
    [
      "quelque",
      0.0675
    ],
    [
      "sur",
      0.0325
    ],
    [
      "vers",
      0.0325
    ],
    [
      "sensiblement",
      0.0325
    ],
    [
      "presque",
      0.0325
    ],
    [
      "entour",
      0.0325
    ],
    [
      "cote",
      0.0325
    ],
    [
      "banlieue",
      0.0325
    ],
    [
      "approchant",
      0.0325
    ],
    [
      "abord",
      0.0325
    ]
  ],
  "deloyal": [
    [
      "infidele",
      0.11
    ],
    [
      "fourbe",
      0.0775
    ],
    [
      "perfide",
      0.0775
    ],
    [
      "traitre",
      0.0775
    ],
    [
      "trompeur",
      0.065
    ],
    [
      "hypocrite",
      0.065
    ],
    [
      "faux",
      0.065
    ],
    [
      "felon",
      0.055
    ],
    [
      "malhonnete",
      0.0425
    ],
    [
      "renegat",
      0.0425
    ],
    [
      "tartufe",
      0.0425
    ],
    [
      "sournois",
      0.0325
    ],
    [
      "judas",
      0.0325
    ],
    [
      "injuste",
      0.0325
    ],
    [
      "incorrect",
      0.02
    ],
    [
      "indelicat",
      0.02
    ],
    [
      "partial",
      0.02
    ],
    [
      "scelerat",
      0.02
    ],
    [
      "oblique",
      0.01
    ],
    [
      "lache",
      0.01
    ],
    [
      "chicaneur",
      0.01
    ],
    [
      "captieux",
      0.01
    ],
    [
      "apostat",
      0.01
    ],
    [
      "parjure",
      0.01
    ]
  ],
  "chauffage": [
    [
      "chaufferette",
      0.2025
    ],
    [
      "bouillotte",
      0.08
    ],
    [
      "fourneau",
      0.08
    ],
    [
      "moine",
      0.08
    ],
    [
      "rechaud",
      0.08
    ],
    [
      "couvet",
      0.0375
    ],
    [
      "distillation",
      0.0375
    ],
    [
      "poele",
      0.0375
    ],
    [
      "radiateur",
      0.0375
    ],
    [
      "climatisation",
      0.0375
    ],
    [
      "cheminee",
      0.0375
    ],
    [
      "chauffe",
      0.0375
    ],
    [
      "calorifere",
      0.0375
    ],
    [
      "brasero",
      0.0375
    ],
    [
      "bassinoire",
      0.0375
    ],
    [
      "thermosiphon",
      0.0375
    ]
  ],
  "central": [
    [
      "capital",
      0.2
    ],
    [
      "essentiel",
      0.2
    ],
    [
      "fondamental",
      0.2
    ],
    [
      "interieur",
      0.2
    ],
    [
      "principal",
      0.2
    ]
  ],
  "dense": [
    [
      "epais",
      0.1275
    ],
    [
      "touffu",
      0.1025
    ],
    [
      "fort",
      0.08
    ],
    [
      "serre",
      0.07
    ],
    [
      "lourd",
      0.0625
    ],
    [
      "court",
      0.055
    ],
    [
      "abondant",
      0.055
    ],
    [
      "concis",
      0.0375
    ],
    [
      "plein",
      0.0375
    ],
    [
      "ramasse",
      0.03
    ],
    [
      "tasse",
      0.03
    ],
    [
      "succinct",
      0.0225
    ],
    [
      "profond",
      0.0225
    ],
    [
      "pesant",
      0.0225
    ],
    [
      "dru",
      0.0225
    ],
    [
      "compact",
      0.0225
    ],
    [
      "solide",
      0.015
    ],
    [
      "nourri",
      0.015
    ],
    [
      "nombreux",
      0.015
    ],
    [
      "luxuriant",
      0.015
    ],
    [
      "intense",
      0.015
    ],
    [
      "impenetrable",
      0.015
    ],
    [
      "fourni",
      0.015
    ],
    [
      "condense",
      0.015
    ],
    [
      "populeux",
      0.0075
    ],
    [
      "pondereux",
      0.0075
    ],
    [
      "pile",
      0.0075
    ],
    [
      "lapidaire",
      0.0075
    ],
    [
      "feuillu",
      0.0075
    ],
    [
      "sobre",
      0.0075
    ]
  ],
  "facade": [
    [
      "apparence",
      0.15
    ],
    [
      "exterieur",
      0.1
    ],
    [
      "face",
      0.09
    ],
    [
      "dehors",
      0.07
    ],
    [
      "vernis",
      0.06
    ],
    [
      "figure",
      0.05
    ],
    [
      "surface",
      0.04
    ],
    [
      "mine",
      0.04
    ],
    [
      "masque",
      0.04
    ],
    [
      "front",
      0.04
    ],
    [
      "endroit",
      0.04
    ],
    [
      "devant",
      0.04
    ],
    [
      "air",
      0.03
    ],
    [
      "superficie",
      0.02
    ],
    [
      "semblant",
      0.02
    ],
    [
      "revetement",
      0.02
    ],
    [
      "devanture",
      0.02
    ],
    [
      "peristyle",
      0.01
    ],
    [
      "paravent",
      0.01
    ],
    [
      "mur",
      0.01
    ],
    [
      "montre",
      0.01
    ],
    [
      "fronton",
      0.01
    ],
    [
      "frontispice",
      0.01
    ],
    [
      "entree",
      0.01
    ],
    [
      "cote",
      0.01
    ],
    [
      "badigeon",
      0.01
    ],
    [
      "avant",
      0.01
    ],
    [
      "ecorce",
      0.01
    ]
  ],
  "palissade": [
    [
      "barriere",
      0.1425
    ],
    [
      "cloture",
      0.1425
    ],
    [
      "enceinte",
      0.1425
    ],
    [
      "fermeture",
      0.095
    ],
    [
      "palis",
      0.095
    ],
    [
      "separation",
      0.095
    ],
    [
      "lice",
      0.0475
    ],
    [
      "fraise",
      0.0475
    ],
    [
      "espalier",
      0.0475
    ],
    [
      "charmille",
      0.0475
    ],
    [
      "banquette",
      0.0475
    ],
    [
      "palanque",
      0.0475
    ]
  ],
  "gaine": [
    [
      "enveloppe",
      0.09
    ],
    [
      "fourreau",
      0.09
    ],
    [
      "gainage",
      0.045
    ],
    [
      "housse",
      0.045
    ],
    [
      "nevrileme",
      0.045
    ],
    [
      "piedestal",
      0.045
    ],
    [
      "protection",
      0.045
    ],
    [
      "sellette",
      0.045
    ],
    [
      "socle",
      0.045
    ],
    [
      "fers",
      0.045
    ],
    [
      "custode",
      0.045
    ],
    [
      "corset",
      0.045
    ],
    [
      "collier",
      0.045
    ],
    [
      "coffre",
      0.045
    ],
    [
      "chaine",
      0.045
    ],
    [
      "ceinture",
      0.045
    ],
    [
      "carcan",
      0.045
    ],
    [
      "caisse",
      0.045
    ],
    [
      "aponevrose",
      0.045
    ],
    [
      "etui",
      0.045
    ]
  ],
  "reveillon": [
    [
      "repas",
      0.4
    ],
    [
      "fete",
      0.2
    ],
    [
      "medianoche",
      0.2
    ],
    [
      "souper",
      0.2
    ]
  ],
  "scout": [
    [
      "louveteau",
      0.5
    ]
  ],
  "fascinant": [
    [
      "captivant",
      0.09
    ],
    [
      "seduisant",
      0.0825
    ],
    [
      "attirant",
      0.0775
    ],
    [
      "attrayant",
      0.0775
    ],
    [
      "enchanteur",
      0.07
    ],
    [
      "charmant",
      0.065
    ],
    [
      "envoutant",
      0.0525
    ],
    [
      "ravissant",
      0.04
    ],
    [
      "magique",
      0.04
    ],
    [
      "ensorcelant",
      0.04
    ],
    [
      "attachant",
      0.04
    ],
    [
      "agreable",
      0.035
    ],
    [
      "fascinateur",
      0.035
    ],
    [
      "prenant",
      0.03
    ],
    [
      "seducteur",
      0.0225
    ],
    [
      "interessant",
      0.0225
    ],
    [
      "delicieux",
      0.0225
    ],
    [
      "attractif",
      0.0225
    ],
    [
      "enjoleur",
      0.0175
    ],
    [
      "troublant",
      0.01
    ],
    [
      "prestigieux",
      0.01
    ],
    [
      "passionnant",
      0.01
    ],
    [
      "magnetique",
      0.01
    ],
    [
      "aimable",
      0.01
    ],
    [
      "charismatique",
      0.005
    ],
    [
      "magnetisant",
      0.005
    ],
    [
      "mysterieux",
      0.005
    ],
    [
      "palpitant",
      0.005
    ],
    [
      "subjuguant",
      0.005
    ],
    [
      "sublime",
      0.005
    ],
    [
      "eblouissant",
      0.005
    ]
  ],
  "toreador": [],
  "capitaine": [
    [
      "chef",
      0.2175
    ],
    [
      "capiston",
      0.13
    ],
    [
      "commandant",
      0.085
    ],
    [
      "pilote",
      0.085
    ],
    [
      "pitaine",
      0.0425
    ],
    [
      "piston",
      0.0425
    ],
    [
      "patron",
      0.0425
    ],
    [
      "navigateur",
      0.0425
    ],
    [
      "nautonier",
      0.0425
    ],
    [
      "louvetier",
      0.0425
    ],
    [
      "gouverneur",
      0.0425
    ],
    [
      "condottiere",
      0.0425
    ],
    [
      "cinquantenier",
      0.0425
    ],
    [
      "capitan",
      0.0425
    ],
    [
      "skipper",
      0.0425
    ]
  ],
  "polo": [
    [
      "coiffure",
      0.5
    ],
    [
      "toque",
      0.5
    ]
  ],
  "villa": [
    [
      "pavillon",
      0.28
    ],
    [
      "habitation",
      0.12
    ],
    [
      "maison",
      0.12
    ],
    [
      "bungalow",
      0.08
    ],
    [
      "chalet",
      0.08
    ],
    [
      "chartreuse",
      0.08
    ],
    [
      "folie",
      0.04
    ],
    [
      "cottage",
      0.04
    ],
    [
      "cassine",
      0.04
    ],
    [
      "camp",
      0.04
    ],
    [
      "cabanon",
      0.04
    ],
    [
      "vigne",
      0.04
    ]
  ],
  "lady": [],
  "andalou": [
    [
      "genet",
      1.0
    ]
  ],
  "tondre": [
    [
      "depouiller",
      0.1525
    ],
    [
      "peler",
      0.13
    ],
    [
      "couper",
      0.1075
    ],
    [
      "voler",
      0.1075
    ],
    [
      "oter",
      0.065
    ],
    [
      "egorger",
      0.0425
    ],
    [
      "raser",
      0.0425
    ],
    [
      "gratter",
      0.0425
    ],
    [
      "faucher",
      0.0425
    ],
    [
      "deposseder",
      0.0425
    ],
    [
      "demunir",
      0.0425
    ],
    [
      "ecorcer",
      0.02
    ],
    [
      "ebarber",
      0.02
    ],
    [
      "tailler",
      0.02
    ],
    [
      "raper",
      0.02
    ],
    [
      "flamber",
      0.02
    ],
    [
      "brouter",
      0.02
    ],
    [
      "bretauder",
      0.02
    ],
    [
      "eplucher",
      0.02
    ]
  ],
  "pelouse": [
    [
      "herbe",
      0.25
    ],
    [
      "gazon",
      0.125
    ],
    [
      "parterre",
      0.125
    ],
    [
      "prairie",
      0.125
    ],
    [
      "turf",
      0.125
    ]
  ],
  "veston": [
    [
      "blazer",
      0.5
    ],
    [
      "veste",
      0.5
    ]
  ],
  "ponton": [
    [
      "chaland",
      0.3325
    ],
    [
      "chameau",
      0.3325
    ],
    [
      "embarcadere",
      0.3325
    ]
  ],
  "saisonnier": [
    [
      "temporaire",
      0.5
    ],
    [
      "etesien",
      0.5
    ]
  ],
  "delicat": [
    [
      "fin",
      0.0425
    ],
    [
      "gracieux",
      0.0375
    ],
    [
      "beau",
      0.035
    ],
    [
      "leger",
      0.0325
    ],
    [
      "bon",
      0.0325
    ],
    [
      "agreable",
      0.03
    ],
    [
      "distingue",
      0.03
    ],
    [
      "poli",
      0.025
    ],
    [
      "doux",
      0.025
    ],
    [
      "difficile",
      0.0225
    ],
    [
      "faible",
      0.02
    ],
    [
      "elegant",
      0.02
    ],
    [
      "exquis",
      0.02
    ],
    [
      "galant",
      0.02
    ],
    [
      "aimable",
      0.0175
    ],
    [
      "raffine",
      0.0175
    ],
    [
      "honnete",
      0.0175
    ],
    [
      "fragile",
      0.0175
    ],
    [
      "grele",
      0.015
    ],
    [
      "mince",
      0.015
    ],
    [
      "tendre",
      0.015
    ],
    [
      "affable",
      0.0125
    ],
    [
      "gentil",
      0.0125
    ],
    [
      "precieux",
      0.0125
    ],
    [
      "menu",
      0.0125
    ],
    [
      "courtois",
      0.0125
    ],
    [
      "habile",
      0.01
    ],
    [
      "subtil",
      0.01
    ],
    [
      "tenu",
      0.01
    ],
    [
      "pur",
      0.01
    ],
    [
      "petit",
      0.01
    ],
    [
      "delie",
      0.01
    ],
    [
      "svelte",
      0.0075
    ],
    [
      "soigne",
      0.0075
    ],
    [
      "sensible",
      0.0075
    ],
    [
      "scabreux",
      0.0075
    ],
    [
      "maigre",
      0.0075
    ],
    [
      "joli",
      0.0075
    ],
    [
      "frele",
      0.0075
    ],
    [
      "fluet",
      0.0075
    ],
    [
      "chetif",
      0.0075
    ],
    [
      "adroit",
      0.0075
    ],
    [
      "epineux",
      0.0075
    ],
    [
      "travaille",
      0.0075
    ],
    [
      "prevenant",
      0.0075
    ],
    [
      "recherche",
      0.005
    ],
    [
      "pointilleux",
      0.005
    ],
    [
      "douillet",
      0.005
    ],
    [
      "consciencieux",
      0.005
    ],
    [
      "aerien",
      0.005
    ],
    [
      "amene",
      0.005
    ],
    [
      "ethere",
      0.0025
    ],
    [
      "suave",
      0.0025
    ],
    [
      "sourcilleux",
      0.0025
    ],
    [
      "reserve",
      0.0025
    ],
    [
      "risque",
      0.0025
    ],
    [
      "retenu",
      0.0025
    ],
    [
      "malingre",
      0.0025
    ],
    [
      "dur",
      0.0025
    ],
    [
      "difficultueux",
      0.0025
    ],
    [
      "dangereux",
      0.0025
    ],
    [
      "complique",
      0.0025
    ],
    [
      "mievre",
      0.0025
    ],
    [
      "pudique",
      0.0025
    ],
    [
      "perilleux",
      0.0025
    ],
    [
      "scrupuleux",
      0.0025
    ],
    [
      "spirituel",
      0.0025
    ],
    [
      "succulent",
      0.0025
    ],
    [
      "susceptible",
      0.0025
    ],
    [
      "malaise",
      0.0025
    ],
    [
      "harmonieux",
      0.0025
    ],
    [
      "embarrassant",
      0.0025
    ],
    [
      "bienseant",
      0.0025
    ],
    [
      "cale",
      0.0025
    ],
    [
      "chatouilleux",
      0.0025
    ],
    [
      "discret",
      0.0025
    ],
    [
      "debile",
      0.0025
    ],
    [
      "delicieux",
      0.0025
    ],
    [
      "effemine",
      0.0025
    ],
    [
      "leche",
      0.0
    ],
    [
      "mignon",
      0.0
    ],
    [
      "obligeant",
      0.0
    ],
    [
      "ombrageux",
      0.0
    ],
    [
      "probe",
      0.0
    ],
    [
      "penetrant",
      0.0
    ],
    [
      "savoureux",
      0.0
    ],
    [
      "sybarite",
      0.0
    ],
    [
      "vaporeux",
      0.0
    ],
    [
      "humain",
      0.0
    ],
    [
      "fignole",
      0.0
    ],
    [
      "exigeant",
      0.0
    ],
    [
      "anemie",
      0.0
    ],
    [
      "arachneen",
      0.0
    ],
    [
      "ardu",
      0.0
    ],
    [
      "attentif",
      0.0
    ],
    [
      "brulant",
      0.0
    ],
    [
      "cassant",
      0.0
    ],
    [
      "complexe",
      0.0
    ],
    [
      "critique",
      0.0
    ],
    [
      "delectable",
      0.0
    ],
    [
      "inconfortable",
      0.0
    ],
    [
      "maladif",
      0.0
    ],
    [
      "precaire",
      0.0
    ],
    [
      "select",
      0.0
    ],
    [
      "tachant",
      0.0
    ],
    [
      "friand",
      0.0
    ],
    [
      "faiblard",
      0.0
    ],
    [
      "detourne",
      0.0
    ],
    [
      "degoute",
      0.0
    ],
    [
      "crucial",
      0.0
    ],
    [
      "blase",
      0.0
    ],
    [
      "evolue",
      0.0
    ]
  ],
  "transat": [],
  "jus": [
    [
      "brouet",
      0.125
    ],
    [
      "cafe",
      0.125
    ],
    [
      "concentre",
      0.125
    ],
    [
      "discours",
      0.125
    ],
    [
      "laius",
      0.125
    ],
    [
      "sirop",
      0.125
    ],
    [
      "suc",
      0.125
    ],
    [
      "topo",
      0.125
    ]
  ],
  "abricot": [
    [
      "abricotine",
      0.3325
    ],
    [
      "alberge",
      0.3325
    ],
    [
      "orange",
      0.3325
    ]
  ],
  "vista": [],
  "compagnon": [
    [
      "camarade",
      0.1175
    ],
    [
      "acolyte",
      0.0775
    ],
    [
      "associe",
      0.0675
    ],
    [
      "compere",
      0.0675
    ],
    [
      "partenaire",
      0.0675
    ],
    [
      "confrere",
      0.0575
    ],
    [
      "copain",
      0.0575
    ],
    [
      "ami",
      0.0475
    ],
    [
      "collegue",
      0.0375
    ],
    [
      "complice",
      0.0275
    ],
    [
      "egal",
      0.0275
    ],
    [
      "zig",
      0.0175
    ],
    [
      "pote",
      0.0175
    ],
    [
      "gaillard",
      0.0175
    ],
    [
      "frere",
      0.0175
    ],
    [
      "familier",
      0.0175
    ],
    [
      "condisciple",
      0.0175
    ],
    [
      "drille",
      0.0075
    ],
    [
      "labadens",
      0.0075
    ],
    [
      "manoeuvre",
      0.0075
    ],
    [
      "poteau",
      0.0075
    ],
    [
      "societaire",
      0.0075
    ],
    [
      "travailleur",
      0.0075
    ],
    [
      "zigoto",
      0.0075
    ],
    [
      "concubin",
      0.0075
    ],
    [
      "concitoyen",
      0.0075
    ],
    [
      "compagnie",
      0.0075
    ],
    [
      "commensal",
      0.0075
    ],
    [
      "colon",
      0.0075
    ],
    [
      "camaro",
      0.0075
    ],
    [
      "artisan",
      0.0075
    ],
    [
      "alloue",
      0.0075
    ],
    [
      "epoux",
      0.0075
    ]
  ],
  "louer": [
    [
      "exalter",
      0.105
    ],
    [
      "glorifier",
      0.1
    ],
    [
      "vanter",
      0.0875
    ],
    [
      "celebrer",
      0.0675
    ],
    [
      "encenser",
      0.0625
    ],
    [
      "proner",
      0.05
    ],
    [
      "louanger",
      0.0375
    ],
    [
      "elever",
      0.0375
    ],
    [
      "complimenter",
      0.03
    ],
    [
      "flatter",
      0.03
    ],
    [
      "publier",
      0.025
    ],
    [
      "magnifier",
      0.025
    ],
    [
      "approuver",
      0.025
    ],
    [
      "admirer",
      0.0175
    ],
    [
      "chanter",
      0.0175
    ],
    [
      "precher",
      0.0175
    ],
    [
      "rehausser",
      0.0125
    ],
    [
      "preconiser",
      0.0125
    ],
    [
      "feliciter",
      0.0125
    ],
    [
      "flagorner",
      0.0125
    ],
    [
      "entonner",
      0.0125
    ],
    [
      "diviniser",
      0.0125
    ],
    [
      "benir",
      0.0125
    ],
    [
      "affermer",
      0.0125
    ],
    [
      "freter",
      0.005
    ],
    [
      "noliser",
      0.005
    ],
    [
      "recommander",
      0.005
    ],
    [
      "relever",
      0.005
    ],
    [
      "remercier",
      0.005
    ],
    [
      "retenir",
      0.005
    ],
    [
      "reserver",
      0.005
    ],
    [
      "enguirlander",
      0.005
    ],
    [
      "deifier",
      0.005
    ],
    [
      "affreter",
      0.005
    ],
    [
      "amodier",
      0.005
    ],
    [
      "apotheoser",
      0.005
    ],
    [
      "arrenter",
      0.005
    ],
    [
      "arreter",
      0.005
    ],
    [
      "blasonner",
      0.005
    ],
    [
      "canoniser",
      0.005
    ],
    [
      "caresser",
      0.005
    ]
  ],
  "declare": [
    [
      "reveler",
      0.0975
    ],
    [
      "dire",
      0.0925
    ],
    [
      "signaler",
      0.075
    ],
    [
      "montrer",
      0.055
    ],
    [
      "indiquer",
      0.055
    ],
    [
      "annoncer",
      0.0425
    ],
    [
      "signifier",
      0.04
    ],
    [
      "temoigner",
      0.0375
    ],
    [
      "exprimer",
      0.035
    ],
    [
      "affirmer",
      0.035
    ],
    [
      "exposer",
      0.035
    ],
    [
      "manifester",
      0.0325
    ],
    [
      "decouvrir",
      0.03
    ],
    [
      "afficher",
      0.0275
    ],
    [
      "publier",
      0.025
    ],
    [
      "assurer",
      0.0175
    ],
    [
      "enoncer",
      0.0175
    ],
    [
      "proclamer",
      0.015
    ],
    [
      "expliquer",
      0.015
    ],
    [
      "communiquer",
      0.015
    ],
    [
      "apprendre",
      0.0125
    ],
    [
      "certifier",
      0.0125
    ],
    [
      "repondre",
      0.01
    ],
    [
      "prononcer",
      0.01
    ],
    [
      "denoncer",
      0.01
    ],
    [
      "attester",
      0.0075
    ],
    [
      "confesser",
      0.0075
    ],
    [
      "porter",
      0.0075
    ],
    [
      "promettre",
      0.0075
    ],
    [
      "reconnaitre",
      0.0075
    ],
    [
      "jurer",
      0.0075
    ],
    [
      "informer",
      0.0075
    ],
    [
      "devoiler",
      0.0075
    ],
    [
      "avouer",
      0.0075
    ],
    [
      "notifier",
      0.005
    ],
    [
      "nommer",
      0.005
    ],
    [
      "confier",
      0.005
    ],
    [
      "convenir",
      0.0025
    ],
    [
      "deposer",
      0.0025
    ],
    [
      "enumerer",
      0.0025
    ],
    [
      "stipuler",
      0.0025
    ],
    [
      "s'engager",
      0.0025
    ],
    [
      "protester",
      0.0025
    ],
    [
      "proferer",
      0.0025
    ],
    [
      "professer",
      0.0025
    ],
    [
      "pretendre",
      0.0
    ],
    [
      "s'expliquer",
      0.0
    ]
  ],
  "declarer": [
    [
      "reveler",
      0.0975
    ],
    [
      "dire",
      0.0925
    ],
    [
      "signaler",
      0.075
    ],
    [
      "montrer",
      0.055
    ],
    [
      "indiquer",
      0.055
    ],
    [
      "annoncer",
      0.0425
    ],
    [
      "signifier",
      0.04
    ],
    [
      "temoigner",
      0.0375
    ],
    [
      "exprimer",
      0.035
    ],
    [
      "affirmer",
      0.035
    ],
    [
      "exposer",
      0.035
    ],
    [
      "manifester",
      0.0325
    ],
    [
      "decouvrir",
      0.03
    ],
    [
      "afficher",
      0.0275
    ],
    [
      "publier",
      0.025
    ],
    [
      "assurer",
      0.0175
    ],
    [
      "enoncer",
      0.0175
    ],
    [
      "proclamer",
      0.015
    ],
    [
      "expliquer",
      0.015
    ],
    [
      "communiquer",
      0.015
    ],
    [
      "apprendre",
      0.0125
    ],
    [
      "certifier",
      0.0125
    ],
    [
      "repondre",
      0.01
    ],
    [
      "prononcer",
      0.01
    ],
    [
      "denoncer",
      0.01
    ],
    [
      "attester",
      0.0075
    ],
    [
      "confesser",
      0.0075
    ],
    [
      "porter",
      0.0075
    ],
    [
      "promettre",
      0.0075
    ],
    [
      "reconnaitre",
      0.0075
    ],
    [
      "jurer",
      0.0075
    ],
    [
      "informer",
      0.0075
    ],
    [
      "devoiler",
      0.0075
    ],
    [
      "avouer",
      0.0075
    ],
    [
      "notifier",
      0.005
    ],
    [
      "nommer",
      0.005
    ],
    [
      "confier",
      0.005
    ],
    [
      "convenir",
      0.0025
    ],
    [
      "deposer",
      0.0025
    ],
    [
      "enumerer",
      0.0025
    ],
    [
      "stipuler",
      0.0025
    ],
    [
      "s'engager",
      0.0025
    ],
    [
      "protester",
      0.0025
    ],
    [
      "proferer",
      0.0025
    ],
    [
      "professer",
      0.0025
    ],
    [
      "pretendre",
      0.0
    ],
    [
      "s'expliquer",
      0.0
    ]
  ],
  "ape": [],
  "deal": [],
  "kid": [],
  "exorciser": [
    [
      "conjurer",
      0.4
    ],
    [
      "adjurer",
      0.2
    ],
    [
      "chasser",
      0.2
    ],
    [
      "purifier",
      0.2
    ]
  ],
  "intense": [
    [
      "grand",
      0.1175
    ],
    [
      "fort",
      0.1075
    ],
    [
      "excessif",
      0.0825
    ],
    [
      "violent",
      0.0825
    ],
    [
      "terrible",
      0.075
    ],
    [
      "gros",
      0.065
    ],
    [
      "profond",
      0.0575
    ],
    [
      "extreme",
      0.04
    ],
    [
      "vif",
      0.04
    ],
    [
      "puissant",
      0.0325
    ],
    [
      "insupportable",
      0.025
    ],
    [
      "haut",
      0.025
    ],
    [
      "frenetique",
      0.025
    ],
    [
      "forcene",
      0.025
    ],
    [
      "extraordinaire",
      0.025
    ],
    [
      "severe",
      0.015
    ],
    [
      "solide",
      0.015
    ],
    [
      "infernal",
      0.015
    ],
    [
      "glacial",
      0.015
    ],
    [
      "dense",
      0.015
    ],
    [
      "insondable",
      0.0075
    ],
    [
      "immodere",
      0.0075
    ],
    [
      "fievreux",
      0.0075
    ],
    [
      "fervent",
      0.0075
    ],
    [
      "cru",
      0.0075
    ],
    [
      "complet",
      0.0075
    ],
    [
      "carabine",
      0.0075
    ],
    [
      "acere",
      0.0075
    ],
    [
      "vehement",
      0.0075
    ]
  ],
  "familier": [
    [
      "facile",
      0.05
    ],
    [
      "simple",
      0.05
    ],
    [
      "habitue",
      0.045
    ],
    [
      "libre",
      0.045
    ],
    [
      "spontane",
      0.0375
    ],
    [
      "ordinaire",
      0.0375
    ],
    [
      "franc",
      0.0375
    ],
    [
      "coutumier",
      0.0375
    ],
    [
      "assimile",
      0.0375
    ],
    [
      "aise",
      0.0375
    ],
    [
      "usite",
      0.03
    ],
    [
      "intime",
      0.03
    ],
    [
      "habituel",
      0.03
    ],
    [
      "dresse",
      0.03
    ],
    [
      "courant",
      0.03
    ],
    [
      "accoutume",
      0.03
    ],
    [
      "traitable",
      0.02
    ],
    [
      "rompu",
      0.02
    ],
    [
      "domestique",
      0.02
    ],
    [
      "commun",
      0.02
    ],
    [
      "apprivoise",
      0.02
    ],
    [
      "ami",
      0.02
    ],
    [
      "usuel",
      0.0125
    ],
    [
      "sociable",
      0.0125
    ],
    [
      "familiarise",
      0.0125
    ],
    [
      "desinvolte",
      0.0125
    ],
    [
      "cordial",
      0.0125
    ],
    [
      "compagnon",
      0.0125
    ],
    [
      "bonhomme",
      0.0125
    ],
    [
      "amical",
      0.0125
    ],
    [
      "acclimate",
      0.0125
    ],
    [
      "accessible",
      0.0125
    ],
    [
      "lie",
      0.005
    ],
    [
      "maitre",
      0.005
    ],
    [
      "rassurant",
      0.005
    ],
    [
      "specialiste",
      0.005
    ],
    [
      "liant",
      0.005
    ],
    [
      "gentil",
      0.005
    ],
    [
      "familial",
      0.005
    ],
    [
      "experimente",
      0.005
    ],
    [
      "deboutonne",
      0.005
    ],
    [
      "domesticable",
      0.005
    ],
    [
      "connu",
      0.005
    ],
    [
      "commensal",
      0.005
    ],
    [
      "cavalier",
      0.005
    ],
    [
      "etroit",
      0.005
    ]
  ],
  "blouser": [
    [
      "tromper",
      0.23
    ],
    [
      "abuser",
      0.1525
    ],
    [
      "berner",
      0.1525
    ],
    [
      "gonfler",
      0.1525
    ],
    [
      "bouffer",
      0.075
    ],
    [
      "empaumer",
      0.075
    ],
    [
      "escroquer",
      0.075
    ],
    [
      "seduire",
      0.075
    ]
  ],
  "blouse": [
    [
      "corsage",
      0.1375
    ],
    [
      "surtout",
      0.1375
    ],
    [
      "souquenille",
      0.1025
    ],
    [
      "casaque",
      0.0675
    ],
    [
      "camisole",
      0.0675
    ],
    [
      "tablier",
      0.0325
    ],
    [
      "sarrau",
      0.0325
    ],
    [
      "rouliere",
      0.0325
    ],
    [
      "mariniere",
      0.0325
    ],
    [
      "chemisier",
      0.0325
    ],
    [
      "chemisette",
      0.0325
    ],
    [
      "caraco",
      0.0325
    ],
    [
      "bourgeron",
      0.0325
    ],
    [
      "bliaud",
      0.0325
    ],
    [
      "blaude",
      0.0325
    ],
    [
      "biaude",
      0.0325
    ],
    [
      "vareuse",
      0.0325
    ]
  ],
  "insouciance": [
    [
      "negligence",
      0.155
    ],
    [
      "inattention",
      0.095
    ],
    [
      "legerete",
      0.095
    ],
    [
      "nonchalance",
      0.0825
    ],
    [
      "irreflexion",
      0.0575
    ],
    [
      "etourderie",
      0.0575
    ],
    [
      "indifference",
      0.0475
    ],
    [
      "imprevoyance",
      0.0475
    ],
    [
      "abandon",
      0.035
    ],
    [
      "indolence",
      0.035
    ],
    [
      "philosophie",
      0.0225
    ],
    [
      "incurie",
      0.0225
    ],
    [
      "inapplication",
      0.0225
    ],
    [
      "detachement",
      0.0225
    ],
    [
      "desinteret",
      0.0225
    ],
    [
      "desaffection",
      0.0225
    ],
    [
      "optimisme",
      0.01
    ],
    [
      "incuriosite",
      0.01
    ],
    [
      "inconscience",
      0.01
    ],
    [
      "futilite",
      0.01
    ],
    [
      "frivolite",
      0.01
    ]
  ],
  "flirt": [
    [
      "amour",
      0.1225
    ],
    [
      "amourette",
      0.0975
    ],
    [
      "bagatelle",
      0.065
    ],
    [
      "caprice",
      0.055
    ],
    [
      "galanterie",
      0.04
    ],
    [
      "fantaisie",
      0.04
    ],
    [
      "bluette",
      0.04
    ],
    [
      "badinage",
      0.04
    ],
    [
      "amoureux",
      0.04
    ],
    [
      "passade",
      0.0325
    ],
    [
      "intrigue",
      0.0325
    ],
    [
      "cheri",
      0.0325
    ],
    [
      "beguin",
      0.0325
    ],
    [
      "ami",
      0.0325
    ],
    [
      "amant",
      0.0325
    ],
    [
      "toquade",
      0.0225
    ],
    [
      "bricole",
      0.0225
    ],
    [
      "batifolage",
      0.0225
    ],
    [
      "babiole",
      0.0225
    ],
    [
      "relation",
      0.015
    ],
    [
      "pelotage",
      0.015
    ],
    [
      "idylle",
      0.015
    ],
    [
      "coquet",
      0.015
    ],
    [
      "beau",
      0.015
    ],
    [
      "passionnette",
      0.0075
    ],
    [
      "flirteur",
      0.0075
    ],
    [
      "flirtation",
      0.0075
    ],
    [
      "flirtage",
      0.0075
    ],
    [
      "copain",
      0.0075
    ],
    [
      "amante",
      0.0075
    ],
    [
      "soupirant",
      0.0075
    ]
  ],
  "caliner": [
    [
      "cajoler",
      0.165
    ],
    [
      "mignoter",
      0.165
    ],
    [
      "caresser",
      0.11
    ],
    [
      "choyer",
      0.11
    ],
    [
      "dorloter",
      0.0825
    ],
    [
      "soigner",
      0.055
    ],
    [
      "pouponner",
      0.055
    ],
    [
      "flatter",
      0.055
    ],
    [
      "couver",
      0.055
    ],
    [
      "chouchouter",
      0.055
    ],
    [
      "aduler",
      0.055
    ],
    [
      "paresser",
      0.0275
    ]
  ],
  "emigre": [
    [
      "changer",
      0.2
    ],
    [
      "quitter",
      0.2
    ],
    [
      "s'expatrier",
      0.2
    ],
    [
      "partir",
      0.1
    ],
    [
      "s'exiler",
      0.1
    ],
    [
      "transmigrer",
      0.1
    ]
  ],
  "emigrer": [
    [
      "changer",
      0.2
    ],
    [
      "quitter",
      0.2
    ],
    [
      "s'expatrier",
      0.2
    ],
    [
      "partir",
      0.1
    ],
    [
      "s'exiler",
      0.1
    ],
    [
      "transmigrer",
      0.1
    ]
  ],
  "gre": [
    [
      "volonte",
      0.125
    ],
    [
      "fantaisie",
      0.1
    ],
    [
      "gout",
      0.1
    ],
    [
      "caprice",
      0.075
    ],
    [
      "humeur",
      0.075
    ],
    [
      "idee",
      0.075
    ],
    [
      "opinion",
      0.075
    ],
    [
      "sens",
      0.075
    ],
    [
      "sentiment",
      0.0475
    ],
    [
      "plaisir",
      0.0475
    ],
    [
      "guise",
      0.0475
    ],
    [
      "convenance",
      0.0225
    ],
    [
      "dessein",
      0.0225
    ],
    [
      "exigence",
      0.0225
    ],
    [
      "gratitude",
      0.0225
    ],
    [
      "reconnaissance",
      0.0225
    ],
    [
      "toquade",
      0.0225
    ]
  ],
  "revanche": [
    [
      "vengeance",
      0.205
    ],
    [
      "represailles",
      0.18
    ],
    [
      "compensation",
      0.1025
    ],
    [
      "reparation",
      0.05
    ],
    [
      "ressentiment",
      0.05
    ],
    [
      "punition",
      0.05
    ],
    [
      "dedommagement",
      0.05
    ],
    [
      "vendetta",
      0.025
    ],
    [
      "triomphe",
      0.025
    ],
    [
      "talion",
      0.025
    ],
    [
      "retorsion",
      0.025
    ],
    [
      "riposte",
      0.025
    ],
    [
      "retour",
      0.025
    ],
    [
      "nemesis",
      0.025
    ],
    [
      "manche",
      0.025
    ],
    [
      "contrepartie",
      0.025
    ],
    [
      "consolation",
      0.025
    ],
    [
      "chatiment",
      0.025
    ],
    [
      "vindicte",
      0.025
    ]
  ],
  "distinguo": [
    [
      "argutie",
      0.3325
    ],
    [
      "distinction",
      0.3325
    ],
    [
      "subtilite",
      0.3325
    ]
  ],
  "fraternite": [
    [
      "union",
      0.1575
    ],
    [
      "accord",
      0.1375
    ],
    [
      "harmonie",
      0.1075
    ],
    [
      "amitie",
      0.0775
    ],
    [
      "entente",
      0.0775
    ],
    [
      "camaraderie",
      0.0375
    ],
    [
      "unite",
      0.0375
    ],
    [
      "solidarite",
      0.0275
    ],
    [
      "ensemble",
      0.0275
    ],
    [
      "concert",
      0.0275
    ],
    [
      "charite",
      0.0275
    ],
    [
      "unisson",
      0.0175
    ],
    [
      "sympathie",
      0.0175
    ],
    [
      "intelligence",
      0.0175
    ],
    [
      "conformite",
      0.0175
    ],
    [
      "compagnonnage",
      0.0175
    ],
    [
      "communion",
      0.0175
    ],
    [
      "amour",
      0.0175
    ],
    [
      "parente",
      0.0075
    ],
    [
      "paix",
      0.0075
    ],
    [
      "lien",
      0.0075
    ],
    [
      "generosite",
      0.0075
    ],
    [
      "confraternite",
      0.0075
    ],
    [
      "confiance",
      0.0075
    ],
    [
      "concorde",
      0.0075
    ],
    [
      "sodalite",
      0.0075
    ]
  ],
  "hotelier": [
    [
      "hote",
      0.3325
    ],
    [
      "aubergiste",
      0.11
    ],
    [
      "hebergeur",
      0.11
    ],
    [
      "logeur",
      0.11
    ],
    [
      "motelier",
      0.11
    ],
    [
      "restaurateur",
      0.11
    ],
    [
      "taulier",
      0.11
    ]
  ],
  "arrivant": [
    [
      "parvenir",
      0.06
    ],
    [
      "tomber",
      0.0525
    ],
    [
      "venir",
      0.0525
    ],
    [
      "atteindre",
      0.0475
    ],
    [
      "surgir",
      0.045
    ],
    [
      "survenir",
      0.045
    ],
    [
      "aller",
      0.04
    ],
    [
      "gagner",
      0.0325
    ],
    [
      "aborder",
      0.03
    ],
    [
      "aboutir",
      0.03
    ],
    [
      "accoster",
      0.03
    ],
    [
      "toucher",
      0.03
    ],
    [
      "reussir",
      0.025
    ],
    [
      "percer",
      0.025
    ],
    [
      "advenir",
      0.02
    ],
    [
      "apparaitre",
      0.02
    ],
    [
      "monter",
      0.02
    ],
    [
      "s'elever",
      0.0175
    ],
    [
      "approcher",
      0.0175
    ],
    [
      "acceder",
      0.0175
    ],
    [
      "entrer",
      0.0125
    ],
    [
      "emerger",
      0.01
    ],
    [
      "s'approcher",
      0.01
    ],
    [
      "s'accomplir",
      0.01
    ],
    [
      "pointer",
      0.01
    ],
    [
      "joindre",
      0.01
    ],
    [
      "affluer",
      0.01
    ],
    [
      "echoir",
      0.005
    ],
    [
      "suivre",
      0.005
    ],
    [
      "finir",
      0.005
    ],
    [
      "accourir",
      0.005
    ],
    [
      "surprendre",
      0.0025
    ],
    [
      "sonner",
      0.0025
    ],
    [
      "s'ensuivre",
      0.0025
    ],
    [
      "s'abouler",
      0.0025
    ],
    [
      "preceder",
      0.0025
    ],
    [
      "debarquer",
      0.0025
    ],
    [
      "devancer",
      0.0025
    ],
    [
      "atterrir",
      0.0025
    ],
    [
      "amerrir",
      0.0025
    ],
    [
      "abattre",
      0.0025
    ]
  ],
  "cageot": [
    [
      "caisse",
      0.23
    ],
    [
      "billot",
      0.1525
    ],
    [
      "emballage",
      0.1525
    ],
    [
      "bourriche",
      0.075
    ],
    [
      "cagette",
      0.075
    ],
    [
      "caissette",
      0.075
    ],
    [
      "clayette",
      0.075
    ],
    [
      "contenant",
      0.075
    ]
  ],
  "tapee": [
    [
      "battre",
      0.145
    ],
    [
      "frapper",
      0.1175
    ],
    [
      "cogner",
      0.105
    ],
    [
      "tambouriner",
      0.065
    ],
    [
      "heurter",
      0.0525
    ],
    [
      "rosser",
      0.025
    ],
    [
      "marteler",
      0.025
    ],
    [
      "fesser",
      0.025
    ],
    [
      "claquer",
      0.025
    ],
    [
      "boxer",
      0.025
    ],
    [
      "meurtrir",
      0.0125
    ],
    [
      "medire",
      0.0125
    ],
    [
      "puer",
      0.0125
    ],
    [
      "quemander",
      0.0125
    ],
    [
      "rencontrer",
      0.0125
    ],
    [
      "sentir",
      0.0125
    ],
    [
      "souffleter",
      0.0125
    ],
    [
      "talocher",
      0.0125
    ],
    [
      "tapoter",
      0.0125
    ],
    [
      "toper",
      0.0125
    ],
    [
      "ecrire",
      0.0125
    ],
    [
      "griser",
      0.0125
    ],
    [
      "gifler",
      0.0125
    ],
    [
      "botter",
      0.0125
    ],
    [
      "bottiner",
      0.0125
    ],
    [
      "boucher",
      0.0125
    ],
    [
      "brutaliser",
      0.0125
    ],
    [
      "calotter",
      0.0125
    ],
    [
      "choquer",
      0.0125
    ],
    [
      "consommer",
      0.0125
    ],
    [
      "critiquer",
      0.0125
    ],
    [
      "dactylographier",
      0.0125
    ],
    [
      "emprunter",
      0.0125
    ],
    [
      "enivrer",
      0.0125
    ],
    [
      "entamer",
      0.0125
    ],
    [
      "friser",
      0.0125
    ],
    [
      "etourdir",
      0.0125
    ]
  ],
  "marteau": [
    [
      "maillet",
      0.165
    ],
    [
      "mail",
      0.125
    ],
    [
      "masse",
      0.0825
    ],
    [
      "martel",
      0.04
    ],
    [
      "massette",
      0.04
    ],
    [
      "perforateur",
      0.04
    ],
    [
      "picot",
      0.04
    ],
    [
      "requin",
      0.04
    ],
    [
      "timbre",
      0.04
    ],
    [
      "mailloche",
      0.04
    ],
    [
      "heurtoir",
      0.04
    ],
    [
      "fou",
      0.04
    ],
    [
      "broyeur",
      0.04
    ],
    [
      "batte",
      0.04
    ],
    [
      "battant",
      0.04
    ],
    [
      "aplatissoir",
      0.04
    ],
    [
      "aliene",
      0.04
    ],
    [
      "toque",
      0.04
    ]
  ],
  "piqueur": [
    [
      "chasseur",
      0.3325
    ],
    [
      "piqueux",
      0.3325
    ],
    [
      "voleur",
      0.3325
    ]
  ],
  "amusant": [
    [
      "comique",
      0.105
    ],
    [
      "drole",
      0.1025
    ],
    [
      "plaisant",
      0.085
    ],
    [
      "risible",
      0.065
    ],
    [
      "tordant",
      0.06
    ],
    [
      "cocasse",
      0.04
    ],
    [
      "gai",
      0.0325
    ],
    [
      "marrant",
      0.0275
    ],
    [
      "rigolo",
      0.0275
    ],
    [
      "agreable",
      0.02
    ],
    [
      "desopilant",
      0.02
    ],
    [
      "ridicule",
      0.02
    ],
    [
      "spirituel",
      0.0175
    ],
    [
      "original",
      0.0175
    ],
    [
      "bizarre",
      0.0175
    ],
    [
      "bidonnant",
      0.015
    ],
    [
      "bon",
      0.015
    ],
    [
      "charmant",
      0.015
    ],
    [
      "drolatique",
      0.015
    ],
    [
      "truculent",
      0.015
    ],
    [
      "rejouissant",
      0.0125
    ],
    [
      "roulant",
      0.0125
    ],
    [
      "joli",
      0.0125
    ],
    [
      "divertissant",
      0.0125
    ],
    [
      "curieux",
      0.0125
    ],
    [
      "recreatif",
      0.01
    ],
    [
      "piquant",
      0.01
    ],
    [
      "hilarant",
      0.01
    ],
    [
      "folatre",
      0.01
    ],
    [
      "burlesque",
      0.01
    ],
    [
      "bouffon",
      0.01
    ],
    [
      "badin",
      0.01
    ],
    [
      "joyeux",
      0.0075
    ],
    [
      "impayable",
      0.0075
    ],
    [
      "crevant",
      0.0075
    ],
    [
      "aimable",
      0.0075
    ],
    [
      "egayant",
      0.005
    ],
    [
      "riant",
      0.005
    ],
    [
      "gondolant",
      0.005
    ],
    [
      "folichon",
      0.005
    ],
    [
      "farce",
      0.005
    ],
    [
      "distrayant",
      0.005
    ],
    [
      "humoristique",
      0.0
    ],
    [
      "hurlant",
      0.0
    ],
    [
      "pilant",
      0.0
    ],
    [
      "pissant",
      0.0
    ],
    [
      "poilant",
      0.0
    ],
    [
      "rigolard",
      0.0
    ],
    [
      "rigolboche",
      0.0
    ],
    [
      "humoriste",
      0.0
    ],
    [
      "fendant",
      0.0
    ],
    [
      "delassant",
      0.0
    ],
    [
      "cornecul",
      0.0
    ],
    [
      "clownesque",
      0.0
    ],
    [
      "boyautant",
      0.0
    ],
    [
      "attrayant",
      0.0
    ],
    [
      "transpoil",
      0.0
    ]
  ],
  "democratique": [
    [
      "populaire",
      0.375
    ],
    [
      "democrate",
      0.25
    ],
    [
      "commun",
      0.125
    ],
    [
      "plebeien",
      0.125
    ],
    [
      "egalitaire",
      0.125
    ]
  ],
  "meeting": [
    [
      "rassemblement",
      0.285
    ],
    [
      "reunion",
      0.285
    ],
    [
      "assemblee",
      0.1425
    ],
    [
      "manifestation",
      0.1425
    ],
    [
      "metingue",
      0.1425
    ]
  ],
  "trappeur": [
    [
      "chasseur",
      0.5
    ],
    [
      "piegeur",
      0.5
    ]
  ],
  "conjurer": [
    [
      "detourner",
      0.11
    ],
    [
      "eviter",
      0.0725
    ],
    [
      "eloigner",
      0.0725
    ],
    [
      "prevenir",
      0.0725
    ],
    [
      "exorciser",
      0.0725
    ],
    [
      "chasser",
      0.0725
    ],
    [
      "adjurer",
      0.0725
    ],
    [
      "supplier",
      0.035
    ],
    [
      "prier",
      0.035
    ],
    [
      "parer",
      0.035
    ],
    [
      "ourdir",
      0.035
    ],
    [
      "implorer",
      0.035
    ],
    [
      "empecher",
      0.035
    ],
    [
      "decider",
      0.035
    ],
    [
      "demander",
      0.035
    ],
    [
      "conspirer",
      0.035
    ],
    [
      "comploter",
      0.035
    ],
    [
      "charmer",
      0.035
    ],
    [
      "tramer",
      0.035
    ]
  ],
  "rageur": [
    [
      "colereux",
      0.285
    ],
    [
      "colere",
      0.1425
    ],
    [
      "emporte",
      0.1425
    ],
    [
      "irascible",
      0.1425
    ],
    [
      "fulminant",
      0.095
    ],
    [
      "irritable",
      0.095
    ],
    [
      "hargneux",
      0.0475
    ],
    [
      "orageux",
      0.0475
    ]
  ],
  "autobus": [
    [
      "autocar",
      0.285
    ],
    [
      "car",
      0.285
    ],
    [
      "automobile",
      0.1425
    ],
    [
      "bus",
      0.1425
    ],
    [
      "patache",
      0.1425
    ]
  ],
  "indemne": [
    [
      "intact",
      0.22
    ],
    [
      "sauf",
      0.22
    ],
    [
      "entier",
      0.11
    ],
    [
      "exempt",
      0.11
    ],
    [
      "rescape",
      0.11
    ],
    [
      "survivant",
      0.11
    ]
  ],
  "evidemment": [
    [
      "assurement",
      0.1675
    ],
    [
      "certainement",
      0.145
    ],
    [
      "surement",
      0.07
    ],
    [
      "immanquablement",
      0.06
    ],
    [
      "naturellement",
      0.0475
    ],
    [
      "indubitablement",
      0.035
    ],
    [
      "visiblement",
      0.0225
    ],
    [
      "manifestement",
      0.0225
    ],
    [
      "infailliblement",
      0.0225
    ],
    [
      "incontestablement",
      0.0225
    ],
    [
      "forcement",
      0.0225
    ],
    [
      "certes",
      0.0225
    ],
    [
      "patemment",
      0.01
    ],
    [
      "oui",
      0.01
    ],
    [
      "franchement",
      0.01
    ],
    [
      "effectivement",
      0.01
    ]
  ],
  "raclette": [
    [
      "curette",
      0.3325
    ],
    [
      "racle",
      0.3325
    ]
  ],
  "intolerant": [
    [
      "sectaire",
      0.1775
    ],
    [
      "intransigeant",
      0.095
    ],
    [
      "exclusif",
      0.0525
    ],
    [
      "fanatique",
      0.0525
    ],
    [
      "rigide",
      0.0525
    ],
    [
      "severe",
      0.0525
    ],
    [
      "etroit",
      0.0525
    ],
    [
      "violent",
      0.04
    ],
    [
      "intraitable",
      0.04
    ],
    [
      "furieux",
      0.04
    ],
    [
      "farouche",
      0.04
    ],
    [
      "cruel",
      0.04
    ],
    [
      "incomprehensif",
      0.025
    ],
    [
      "frenetique",
      0.025
    ],
    [
      "enrage",
      0.025
    ],
    [
      "chauvin",
      0.025
    ],
    [
      "systematique",
      0.0125
    ],
    [
      "rigoriste",
      0.0125
    ],
    [
      "persecuteur",
      0.0125
    ],
    [
      "partial",
      0.0125
    ],
    [
      "irreductible",
      0.0125
    ],
    [
      "exalte",
      0.0125
    ],
    [
      "borne",
      0.0125
    ],
    [
      "autoritaire",
      0.0125
    ],
    [
      "antiliberal",
      0.0125
    ],
    [
      "ultra",
      0.0125
    ]
  ],
  "lactose": [],
  "chienlit": [
    [
      "carnaval",
      0.2
    ],
    [
      "deguisement",
      0.2
    ],
    [
      "desordre",
      0.2
    ],
    [
      "mascarade",
      0.2
    ],
    [
      "pagaille",
      0.2
    ]
  ],
  "mardi": [],
  "hosto": [
    [
      "hopital",
      1.0
    ]
  ],
  "accoucher": [
    [
      "enfanter",
      0.1275
    ],
    [
      "faire",
      0.1275
    ],
    [
      "produire",
      0.1275
    ],
    [
      "creer",
      0.105
    ],
    [
      "procreer",
      0.0625
    ],
    [
      "ecrire",
      0.0625
    ],
    [
      "engendrer",
      0.0425
    ],
    [
      "composer",
      0.0425
    ],
    [
      "realiser",
      0.02
    ],
    [
      "publier",
      0.02
    ],
    [
      "pondre",
      0.02
    ],
    [
      "peindre",
      0.02
    ],
    [
      "parler",
      0.02
    ],
    [
      "delivrer",
      0.02
    ],
    [
      "avouer",
      0.02
    ]
  ],
  "elastique": [
    [
      "mou",
      0.1325
    ],
    [
      "relache",
      0.115
    ],
    [
      "souple",
      0.115
    ],
    [
      "facile",
      0.075
    ],
    [
      "large",
      0.075
    ],
    [
      "lache",
      0.0575
    ],
    [
      "malleable",
      0.0575
    ],
    [
      "moelleux",
      0.0375
    ],
    [
      "mobile",
      0.0375
    ],
    [
      "indulgent",
      0.0375
    ],
    [
      "commode",
      0.0375
    ],
    [
      "agile",
      0.0375
    ],
    [
      "variable",
      0.0175
    ],
    [
      "liberal",
      0.0175
    ],
    [
      "flexible",
      0.0175
    ],
    [
      "extensible",
      0.0175
    ],
    [
      "douillet",
      0.0175
    ],
    [
      "compressible",
      0.0175
    ],
    [
      "changeant",
      0.0175
    ],
    [
      "caoutchouc",
      0.0175
    ],
    [
      "etirable",
      0.0175
    ]
  ],
  "amphore": [
    [
      "jarre",
      0.5
    ],
    [
      "oenophore",
      0.5
    ]
  ],
  "crique": [
    [
      "anse",
      0.285
    ],
    [
      "accul",
      0.1425
    ],
    [
      "anfractuosite",
      0.1425
    ],
    [
      "baie",
      0.1425
    ],
    [
      "calanque",
      0.1425
    ],
    [
      "golfe",
      0.1425
    ]
  ],
  "murene": [],
  "balneaire": [
    [
      "estival",
      0.5
    ]
  ],
  "crin": [
    [
      "bourrage",
      0.165
    ],
    [
      "criniere",
      0.165
    ],
    [
      "crinoline",
      0.165
    ],
    [
      "fanon",
      0.165
    ],
    [
      "poil",
      0.165
    ],
    [
      "etamine",
      0.165
    ]
  ],
  "geyser": [
    [
      "jet",
      0.4275
    ],
    [
      "gerbe",
      0.1425
    ],
    [
      "giclee",
      0.1425
    ],
    [
      "jaillissement",
      0.1425
    ],
    [
      "source",
      0.1425
    ]
  ],
  "cranien": [],
  "accaparer": [
    [
      "prendre",
      0.1325
    ],
    [
      "s'approprier",
      0.1
    ],
    [
      "s'emparer",
      0.1
    ],
    [
      "enlever",
      0.0825
    ],
    [
      "accumuler",
      0.0825
    ],
    [
      "absorber",
      0.0825
    ],
    [
      "occuper",
      0.065
    ],
    [
      "monopoliser",
      0.0475
    ],
    [
      "tenir",
      0.0325
    ],
    [
      "speculer",
      0.0325
    ],
    [
      "rafler",
      0.0325
    ],
    [
      "envahir",
      0.0325
    ],
    [
      "confisquer",
      0.0325
    ],
    [
      "affamer",
      0.0325
    ],
    [
      "agioter",
      0.015
    ],
    [
      "amasser",
      0.015
    ],
    [
      "capter",
      0.015
    ],
    [
      "posseder",
      0.015
    ],
    [
      "preoccuper",
      0.015
    ],
    [
      "truster",
      0.015
    ]
  ],
  "cirque": [
    [
      "comedie",
      0.1
    ],
    [
      "spectacle",
      0.1
    ],
    [
      "arene",
      0.075
    ],
    [
      "carriere",
      0.075
    ],
    [
      "seance",
      0.05
    ],
    [
      "stade",
      0.05
    ],
    [
      "scene",
      0.05
    ],
    [
      "lice",
      0.05
    ],
    [
      "enceinte",
      0.05
    ],
    [
      "amphitheatre",
      0.05
    ],
    [
      "tauromachie",
      0.0225
    ],
    [
      "representation",
      0.0225
    ],
    [
      "piste",
      0.0225
    ],
    [
      "pantomime",
      0.0225
    ],
    [
      "naumachie",
      0.0225
    ],
    [
      "hippodrome",
      0.0225
    ],
    [
      "grimace",
      0.0225
    ],
    [
      "entonnoir",
      0.0225
    ],
    [
      "colisee",
      0.0225
    ],
    [
      "cinema",
      0.0225
    ],
    [
      "chapiteau",
      0.0225
    ],
    [
      "chahut",
      0.0225
    ],
    [
      "cercle",
      0.0225
    ],
    [
      "voltige",
      0.0225
    ]
  ],
  "loulou": [
    [
      "loubard",
      0.3325
    ],
    [
      "louloute",
      0.3325
    ]
  ],
  "aqueduc": [
    [
      "canal",
      0.3625
    ],
    [
      "banquette",
      0.09
    ],
    [
      "cavite",
      0.09
    ],
    [
      "conduit",
      0.09
    ],
    [
      "conduite",
      0.09
    ],
    [
      "cunette",
      0.09
    ],
    [
      "dalot",
      0.09
    ],
    [
      "pont",
      0.09
    ]
  ],
  "colline": [
    [
      "hauteur",
      0.1575
    ],
    [
      "elevation",
      0.13
    ],
    [
      "eminence",
      0.13
    ],
    [
      "monticule",
      0.105
    ],
    [
      "butte",
      0.0775
    ],
    [
      "coteau",
      0.0775
    ],
    [
      "montagne",
      0.05
    ],
    [
      "mont",
      0.05
    ],
    [
      "cote",
      0.05
    ],
    [
      "haut",
      0.025
    ],
    [
      "mamelon",
      0.025
    ],
    [
      "penchant",
      0.025
    ],
    [
      "relief",
      0.025
    ],
    [
      "roche",
      0.025
    ],
    [
      "tertre",
      0.025
    ]
  ],
  "embrumer": [
    [
      "obscurcir",
      0.285
    ],
    [
      "assombrir",
      0.1425
    ],
    [
      "attrister",
      0.1425
    ],
    [
      "embrunir",
      0.1425
    ],
    [
      "embuer",
      0.1425
    ],
    [
      "troubler",
      0.1425
    ]
  ],
  "brouillard": [
    [
      "brume",
      0.1475
    ],
    [
      "bruine",
      0.0975
    ],
    [
      "brouillasse",
      0.065
    ],
    [
      "pluie",
      0.065
    ],
    [
      "vapeur",
      0.0475
    ],
    [
      "obscurite",
      0.0475
    ],
    [
      "nuage",
      0.0475
    ],
    [
      "frimas",
      0.0475
    ],
    [
      "brumaille",
      0.0475
    ],
    [
      "temps",
      0.0325
    ],
    [
      "ombre",
      0.0325
    ],
    [
      "nebulosite",
      0.0325
    ],
    [
      "humidite",
      0.0325
    ],
    [
      "crachin",
      0.0325
    ],
    [
      "smog",
      0.015
    ],
    [
      "precipitations",
      0.015
    ],
    [
      "nielle",
      0.015
    ],
    [
      "memorial",
      0.015
    ],
    [
      "livre",
      0.015
    ],
    [
      "hydrometeore",
      0.015
    ],
    [
      "embrun",
      0.015
    ],
    [
      "buee",
      0.015
    ],
    [
      "buvard",
      0.015
    ],
    [
      "brumasse",
      0.015
    ],
    [
      "brouillon",
      0.015
    ],
    [
      "tenebres",
      0.015
    ]
  ],
  "roulant": [
    [
      "amusant",
      0.1375
    ],
    [
      "comique",
      0.1375
    ],
    [
      "risible",
      0.1375
    ],
    [
      "tordant",
      0.1375
    ],
    [
      "marrant",
      0.0825
    ],
    [
      "rigolo",
      0.055
    ],
    [
      "desopilant",
      0.055
    ],
    [
      "crevant",
      0.055
    ],
    [
      "bidonnant",
      0.055
    ],
    [
      "ambulant",
      0.0275
    ],
    [
      "convoyeur",
      0.0275
    ],
    [
      "gondolant",
      0.0275
    ],
    [
      "mouvant",
      0.0275
    ],
    [
      "transporteur",
      0.0275
    ]
  ],
  "off": [],
  "back": [],
  "about": [
    [
      "assemblage",
      0.1675
    ],
    [
      "emboitement",
      0.1675
    ],
    [
      "mortaise",
      0.0825
    ],
    [
      "enture",
      0.0825
    ],
    [
      "embrevement",
      0.0825
    ],
    [
      "embreuvement",
      0.0825
    ],
    [
      "emboiture",
      0.0825
    ],
    [
      "ajoutage",
      0.0825
    ],
    [
      "adjonction",
      0.0825
    ],
    [
      "tenon",
      0.0825
    ]
  ],
  "single": [
    [
      "individuel",
      0.5
    ],
    [
      "simple",
      0.5
    ]
  ],
  "catch": [
    [
      "lutte",
      0.3325
    ],
    [
      "pancrace",
      0.3325
    ],
    [
      "pugilat",
      0.3325
    ]
  ],
  "serve": [
    [
      "esclave",
      0.125
    ],
    [
      "ilote",
      0.125
    ],
    [
      "obsequieux",
      0.125
    ],
    [
      "paysan",
      0.125
    ],
    [
      "plat",
      0.125
    ],
    [
      "rampant",
      0.125
    ],
    [
      "roturier",
      0.125
    ],
    [
      "servile",
      0.125
    ]
  ],
  "detonateur": [
    [
      "amorce",
      0.4
    ],
    [
      "etoupille",
      0.2
    ]
  ],
  "excitant": [
    [
      "seduisant",
      0.07
    ],
    [
      "affriolant",
      0.0625
    ],
    [
      "aguichant",
      0.0425
    ],
    [
      "passionnant",
      0.0425
    ],
    [
      "stimulant",
      0.0425
    ],
    [
      "troublant",
      0.0425
    ],
    [
      "enivrant",
      0.0375
    ],
    [
      "agreable",
      0.0375
    ],
    [
      "agacant",
      0.03
    ],
    [
      "capiteux",
      0.03
    ],
    [
      "engageant",
      0.03
    ],
    [
      "provocant",
      0.03
    ],
    [
      "plaisant",
      0.025
    ],
    [
      "piquant",
      0.025
    ],
    [
      "irritant",
      0.025
    ],
    [
      "exaltant",
      0.025
    ],
    [
      "allechant",
      0.0175
    ],
    [
      "vivifiant",
      0.0175
    ],
    [
      "erotique",
      0.0175
    ],
    [
      "reconfortant",
      0.01
    ],
    [
      "sensationnel",
      0.01
    ],
    [
      "voluptueux",
      0.01
    ],
    [
      "echauffant",
      0.01
    ],
    [
      "electrisant",
      0.01
    ],
    [
      "emoustillant",
      0.01
    ],
    [
      "emouvant",
      0.01
    ],
    [
      "provocateur",
      0.01
    ],
    [
      "grisant",
      0.01
    ],
    [
      "affolant",
      0.01
    ],
    [
      "affriandant",
      0.01
    ],
    [
      "aiguillon",
      0.01
    ],
    [
      "attrayant",
      0.01
    ],
    [
      "bandant",
      0.01
    ],
    [
      "encourageant",
      0.01
    ],
    [
      "galvanisant",
      0.01
    ],
    [
      "pressant",
      0.005
    ],
    [
      "reconstituant",
      0.005
    ],
    [
      "remontant",
      0.005
    ],
    [
      "stimulus",
      0.005
    ],
    [
      "surexcitant",
      0.005
    ],
    [
      "tentant",
      0.005
    ],
    [
      "tonique",
      0.005
    ],
    [
      "touchant",
      0.005
    ],
    [
      "palpitant",
      0.005
    ],
    [
      "fortifiant",
      0.005
    ],
    [
      "excitatif",
      0.005
    ],
    [
      "alliciant",
      0.005
    ],
    [
      "aphrodisiaque",
      0.005
    ],
    [
      "baisant",
      0.005
    ],
    [
      "chatouilleux",
      0.005
    ],
    [
      "dopage",
      0.005
    ],
    [
      "dopant",
      0.005
    ],
    [
      "entrainant",
      0.005
    ],
    [
      "euphorisant",
      0.005
    ],
    [
      "eperon",
      0.005
    ]
  ],
  "electron": [
    [
      "lepton",
      0.5
    ],
    [
      "negaton",
      0.5
    ]
  ],
  "bombarde": [
    [
      "biniou",
      0.15
    ],
    [
      "cabrette",
      0.15
    ],
    [
      "cornemuse",
      0.15
    ],
    [
      "canon",
      0.12
    ],
    [
      "mortier",
      0.06
    ],
    [
      "musette",
      0.03
    ],
    [
      "pibrock",
      0.03
    ],
    [
      "pierrier",
      0.03
    ],
    [
      "guimbarde",
      0.03
    ],
    [
      "chevrie",
      0.03
    ],
    [
      "chabrette",
      0.03
    ],
    [
      "bombe",
      0.03
    ],
    [
      "bagpipe",
      0.03
    ],
    [
      "aspic",
      0.03
    ],
    [
      "veuglaire",
      0.03
    ]
  ],
  "proton": [
    [
      "nucleon",
      1.0
    ]
  ],
  "charge": [
    [
      "accabler",
      0.0375
    ],
    [
      "alourdir",
      0.0375
    ],
    [
      "exagerer",
      0.0325
    ],
    [
      "grever",
      0.0325
    ],
    [
      "surcharger",
      0.0325
    ],
    [
      "grossir",
      0.0275
    ],
    [
      "rencherir",
      0.025
    ],
    [
      "mettre",
      0.025
    ],
    [
      "imposer",
      0.025
    ],
    [
      "attaquer",
      0.025
    ],
    [
      "prendre",
      0.0225
    ],
    [
      "porter",
      0.0225
    ],
    [
      "imputer",
      0.0225
    ],
    [
      "faire",
      0.0225
    ],
    [
      "augmenter",
      0.0225
    ],
    [
      "remplir",
      0.0175
    ],
    [
      "peser",
      0.0175
    ],
    [
      "outrer",
      0.0175
    ],
    [
      "frapper",
      0.0175
    ],
    [
      "forcer",
      0.0175
    ],
    [
      "couvrir",
      0.0175
    ],
    [
      "combler",
      0.0175
    ],
    [
      "aggraver",
      0.0175
    ],
    [
      "accuser",
      0.0175
    ],
    [
      "ecraser",
      0.0125
    ],
    [
      "pourvoir",
      0.0125
    ],
    [
      "poser",
      0.0125
    ],
    [
      "garnir",
      0.0125
    ],
    [
      "disposer",
      0.0125
    ],
    [
      "condamner",
      0.0125
    ],
    [
      "bourrer",
      0.0125
    ],
    [
      "amplifier",
      0.0125
    ],
    [
      "placer",
      0.01
    ],
    [
      "incriminer",
      0.01
    ],
    [
      "fondre",
      0.01
    ],
    [
      "foncer",
      0.01
    ],
    [
      "emplir",
      0.01
    ],
    [
      "embarquer",
      0.01
    ],
    [
      "commettre",
      0.01
    ],
    [
      "caricaturer",
      0.01
    ],
    [
      "calomnier",
      0.01
    ],
    [
      "preposer",
      0.005
    ],
    [
      "recouvrir",
      0.005
    ],
    [
      "s'elancer",
      0.005
    ],
    [
      "surfaire",
      0.005
    ],
    [
      "taxer",
      0.005
    ],
    [
      "truffer",
      0.005
    ],
    [
      "oppresser",
      0.005
    ],
    [
      "noircir",
      0.005
    ],
    [
      "munir",
      0.005
    ],
    [
      "affreter",
      0.005
    ],
    [
      "dramatiser",
      0.005
    ],
    [
      "empiler",
      0.005
    ],
    [
      "employer",
      0.005
    ],
    [
      "encombrer",
      0.005
    ],
    [
      "imiter",
      0.005
    ],
    [
      "lester",
      0.005
    ],
    [
      "inculper",
      0.0025
    ],
    [
      "oberer",
      0.0025
    ],
    [
      "parodier",
      0.0025
    ],
    [
      "pimenter",
      0.0025
    ],
    [
      "tarabiscoter",
      0.0025
    ],
    [
      "fuser",
      0.0025
    ],
    [
      "freter",
      0.0025
    ],
    [
      "fouler",
      0.0025
    ],
    [
      "encherir",
      0.0025
    ],
    [
      "enchainer",
      0.0025
    ],
    [
      "deleguer",
      0.0025
    ],
    [
      "chamarrer",
      0.0025
    ],
    [
      "arrimer",
      0.0025
    ]
  ],
  "charger": [
    [
      "accabler",
      0.0375
    ],
    [
      "alourdir",
      0.0375
    ],
    [
      "exagerer",
      0.0325
    ],
    [
      "grever",
      0.0325
    ],
    [
      "surcharger",
      0.0325
    ],
    [
      "grossir",
      0.0275
    ],
    [
      "rencherir",
      0.025
    ],
    [
      "mettre",
      0.025
    ],
    [
      "imposer",
      0.025
    ],
    [
      "attaquer",
      0.025
    ],
    [
      "prendre",
      0.0225
    ],
    [
      "porter",
      0.0225
    ],
    [
      "imputer",
      0.0225
    ],
    [
      "faire",
      0.0225
    ],
    [
      "augmenter",
      0.0225
    ],
    [
      "remplir",
      0.0175
    ],
    [
      "peser",
      0.0175
    ],
    [
      "outrer",
      0.0175
    ],
    [
      "frapper",
      0.0175
    ],
    [
      "forcer",
      0.0175
    ],
    [
      "couvrir",
      0.0175
    ],
    [
      "combler",
      0.0175
    ],
    [
      "aggraver",
      0.0175
    ],
    [
      "accuser",
      0.0175
    ],
    [
      "ecraser",
      0.0125
    ],
    [
      "pourvoir",
      0.0125
    ],
    [
      "poser",
      0.0125
    ],
    [
      "garnir",
      0.0125
    ],
    [
      "disposer",
      0.0125
    ],
    [
      "condamner",
      0.0125
    ],
    [
      "bourrer",
      0.0125
    ],
    [
      "amplifier",
      0.0125
    ],
    [
      "placer",
      0.01
    ],
    [
      "incriminer",
      0.01
    ],
    [
      "fondre",
      0.01
    ],
    [
      "foncer",
      0.01
    ],
    [
      "emplir",
      0.01
    ],
    [
      "embarquer",
      0.01
    ],
    [
      "commettre",
      0.01
    ],
    [
      "caricaturer",
      0.01
    ],
    [
      "calomnier",
      0.01
    ],
    [
      "preposer",
      0.005
    ],
    [
      "recouvrir",
      0.005
    ],
    [
      "s'elancer",
      0.005
    ],
    [
      "surfaire",
      0.005
    ],
    [
      "taxer",
      0.005
    ],
    [
      "truffer",
      0.005
    ],
    [
      "oppresser",
      0.005
    ],
    [
      "noircir",
      0.005
    ],
    [
      "munir",
      0.005
    ],
    [
      "affreter",
      0.005
    ],
    [
      "dramatiser",
      0.005
    ],
    [
      "empiler",
      0.005
    ],
    [
      "employer",
      0.005
    ],
    [
      "encombrer",
      0.005
    ],
    [
      "imiter",
      0.005
    ],
    [
      "lester",
      0.005
    ],
    [
      "inculper",
      0.0025
    ],
    [
      "oberer",
      0.0025
    ],
    [
      "parodier",
      0.0025
    ],
    [
      "pimenter",
      0.0025
    ],
    [
      "tarabiscoter",
      0.0025
    ],
    [
      "fuser",
      0.0025
    ],
    [
      "freter",
      0.0025
    ],
    [
      "fouler",
      0.0025
    ],
    [
      "encherir",
      0.0025
    ],
    [
      "enchainer",
      0.0025
    ],
    [
      "deleguer",
      0.0025
    ],
    [
      "chamarrer",
      0.0025
    ],
    [
      "arrimer",
      0.0025
    ]
  ],
  "electricite": [
    [
      "courant",
      0.2
    ],
    [
      "lumiere",
      0.2
    ],
    [
      "tension",
      0.2
    ],
    [
      "electrologie",
      0.2
    ],
    [
      "energie",
      0.2
    ]
  ],
  "accelerateur": [
    [
      "acceleration",
      0.25
    ],
    [
      "carburateur",
      0.25
    ],
    [
      "catalyseur",
      0.25
    ],
    [
      "champignon",
      0.25
    ]
  ],
  "particule": [
    [
      "grain",
      0.15
    ],
    [
      "affixe",
      0.1
    ],
    [
      "atome",
      0.1
    ],
    [
      "corpuscule",
      0.1
    ],
    [
      "morceau",
      0.1
    ],
    [
      "poussiere",
      0.1
    ],
    [
      "suffixe",
      0.05
    ],
    [
      "prefixe",
      0.05
    ],
    [
      "poudre",
      0.05
    ],
    [
      "partie",
      0.05
    ],
    [
      "mot",
      0.05
    ],
    [
      "molecule",
      0.05
    ],
    [
      "terme",
      0.05
    ]
  ],
  "adolescent": [
    [
      "jeune",
      0.11
    ],
    [
      "ephebe",
      0.0875
    ],
    [
      "galant",
      0.065
    ],
    [
      "teenager",
      0.0425
    ],
    [
      "novice",
      0.0425
    ],
    [
      "mineur",
      0.0425
    ],
    [
      "minet",
      0.0425
    ],
    [
      "juvenile",
      0.0425
    ],
    [
      "jouvenceau",
      0.0425
    ],
    [
      "godelureau",
      0.0425
    ],
    [
      "damoiseau",
      0.0425
    ],
    [
      "bejaune",
      0.0425
    ],
    [
      "pubere",
      0.02
    ],
    [
      "nubile",
      0.02
    ],
    [
      "bachelier",
      0.02
    ],
    [
      "adonis",
      0.02
    ],
    [
      "ado",
      0.02
    ],
    [
      "puceau",
      0.02
    ]
  ],
  "demunir": [
    [
      "depouiller",
      0.275
    ],
    [
      "oter",
      0.0775
    ],
    [
      "enlever",
      0.065
    ],
    [
      "ecorcher",
      0.065
    ],
    [
      "deshabiller",
      0.05
    ],
    [
      "voler",
      0.0375
    ],
    [
      "spolier",
      0.0375
    ],
    [
      "peler",
      0.0375
    ],
    [
      "denuder",
      0.0375
    ],
    [
      "defaire",
      0.0375
    ],
    [
      "tondre",
      0.025
    ],
    [
      "sevrer",
      0.025
    ],
    [
      "priver",
      0.025
    ],
    [
      "frustrer",
      0.025
    ],
    [
      "depiauter",
      0.025
    ],
    [
      "degarnir",
      0.025
    ],
    [
      "degager",
      0.025
    ],
    [
      "arracher",
      0.025
    ],
    [
      "dessaisir",
      0.0125
    ],
    [
      "denantir",
      0.0125
    ],
    [
      "depecer",
      0.0125
    ],
    [
      "depourvoir",
      0.0125
    ],
    [
      "devetir",
      0.0125
    ]
  ],
  "demuni": [
    [
      "depourvu",
      0.14
    ],
    [
      "denue",
      0.115
    ],
    [
      "pauvre",
      0.115
    ],
    [
      "vide",
      0.115
    ],
    [
      "nu",
      0.0925
    ],
    [
      "depouille",
      0.07
    ],
    [
      "prive",
      0.045
    ],
    [
      "necessiteux",
      0.045
    ],
    [
      "fauche",
      0.045
    ],
    [
      "desargente",
      0.045
    ],
    [
      "besogneux",
      0.0225
    ],
    [
      "destitue",
      0.0225
    ],
    [
      "defavorise",
      0.0225
    ],
    [
      "insolvable",
      0.0225
    ],
    [
      "leger",
      0.0225
    ],
    [
      "pele",
      0.0225
    ]
  ],
  "abime": [
    [
      "gouffre",
      0.1325
    ],
    [
      "cavite",
      0.0925
    ],
    [
      "precipice",
      0.065
    ],
    [
      "separation",
      0.0525
    ],
    [
      "profondeur",
      0.0525
    ],
    [
      "fosse",
      0.0525
    ],
    [
      "creux",
      0.0525
    ],
    [
      "abysse",
      0.04
    ],
    [
      "aven",
      0.04
    ],
    [
      "fosse",
      0.04
    ],
    [
      "ruine",
      0.025
    ],
    [
      "perte",
      0.025
    ],
    [
      "intervalle",
      0.025
    ],
    [
      "distance",
      0.025
    ],
    [
      "difference",
      0.025
    ],
    [
      "divorce",
      0.0125
    ],
    [
      "enfer",
      0.0125
    ],
    [
      "igue",
      0.0125
    ],
    [
      "immensite",
      0.0125
    ],
    [
      "incomprehension",
      0.0125
    ],
    [
      "neant",
      0.0125
    ],
    [
      "ocean",
      0.0125
    ],
    [
      "division",
      0.0125
    ],
    [
      "danger",
      0.0125
    ],
    [
      "comble",
      0.0125
    ],
    [
      "cloup",
      0.0125
    ],
    [
      "chaos",
      0.0125
    ],
    [
      "catastrophe",
      0.0125
    ],
    [
      "catacombe",
      0.0125
    ],
    [
      "barriere",
      0.0125
    ],
    [
      "barathre",
      0.0125
    ],
    [
      "puits",
      0.0125
    ]
  ],
  "frenesie": [
    [
      "fureur",
      0.08
    ],
    [
      "ardeur",
      0.0675
    ],
    [
      "bouillonnement",
      0.0675
    ],
    [
      "exaltation",
      0.0675
    ],
    [
      "passion",
      0.0675
    ],
    [
      "delire",
      0.0475
    ],
    [
      "emportement",
      0.045
    ],
    [
      "chaleur",
      0.035
    ],
    [
      "fievre",
      0.0325
    ],
    [
      "agitation",
      0.0275
    ],
    [
      "impetuosite",
      0.0275
    ],
    [
      "rage",
      0.0275
    ],
    [
      "violence",
      0.0275
    ],
    [
      "excitation",
      0.0275
    ],
    [
      "folie",
      0.025
    ],
    [
      "fougue",
      0.0225
    ],
    [
      "vehemence",
      0.0175
    ],
    [
      "manie",
      0.0175
    ],
    [
      "furie",
      0.0175
    ],
    [
      "flamme",
      0.0175
    ],
    [
      "dechainement",
      0.0175
    ],
    [
      "enthousiasme",
      0.015
    ],
    [
      "fanatisme",
      0.015
    ],
    [
      "effervescence",
      0.0125
    ],
    [
      "egarement",
      0.0075
    ],
    [
      "tempete",
      0.0075
    ],
    [
      "ouragan",
      0.0075
    ],
    [
      "acharnement",
      0.0075
    ],
    [
      "alienation",
      0.0075
    ],
    [
      "surexcitation",
      0.0075
    ],
    [
      "toquade",
      0.0075
    ],
    [
      "turbulence",
      0.005
    ],
    [
      "travers",
      0.005
    ],
    [
      "tic",
      0.005
    ],
    [
      "aprete",
      0.0025
    ],
    [
      "transe",
      0.0025
    ],
    [
      "petulance",
      0.0025
    ],
    [
      "precipitation",
      0.0025
    ],
    [
      "orage",
      0.0025
    ],
    [
      "ivresse",
      0.0025
    ],
    [
      "incendie",
      0.0025
    ],
    [
      "ferocite",
      0.0025
    ],
    [
      "debordement",
      0.0025
    ],
    [
      "divagation",
      0.0025
    ],
    [
      "boulimie",
      0.0025
    ],
    [
      "appetit",
      0.0025
    ],
    [
      "hysterie",
      0.0
    ],
    [
      "hallucination",
      0.0
    ],
    [
      "febrilite",
      0.0
    ],
    [
      "fringale",
      0.0
    ],
    [
      "paroxysme",
      0.0
    ]
  ],
  "imposture": [
    [
      "mensonge",
      0.165
    ],
    [
      "tromperie",
      0.1275
    ],
    [
      "mystification",
      0.11
    ],
    [
      "simulation",
      0.055
    ],
    [
      "illusion",
      0.055
    ],
    [
      "fourberie",
      0.055
    ],
    [
      "faux",
      0.055
    ],
    [
      "bateau",
      0.055
    ],
    [
      "piperie",
      0.035
    ],
    [
      "leurre",
      0.035
    ],
    [
      "faussete",
      0.035
    ],
    [
      "farce",
      0.035
    ],
    [
      "hypocrisie",
      0.0175
    ],
    [
      "foutaise",
      0.0175
    ],
    [
      "copie",
      0.0175
    ],
    [
      "contreverite",
      0.0175
    ],
    [
      "charlatanisme",
      0.0175
    ],
    [
      "canular",
      0.0175
    ],
    [
      "calomnie",
      0.0175
    ],
    [
      "blague",
      0.0175
    ],
    [
      "plagiat",
      0.0175
    ]
  ],
  "mentalite": [
    [
      "caractere",
      0.25
    ],
    [
      "esprit",
      0.165
    ],
    [
      "moeurs",
      0.165
    ],
    [
      "moral",
      0.0825
    ],
    [
      "moralite",
      0.0825
    ],
    [
      "pensee",
      0.0825
    ]
  ],
  "tocard": [
    [
      "tarte",
      0.3325
    ],
    [
      "outsider",
      0.165
    ],
    [
      "ringard",
      0.165
    ],
    [
      "tartignolle",
      0.165
    ],
    [
      "vilain",
      0.165
    ]
  ],
  "fevrier": [],
  "matraqueur": [],
  "assermente": [
    [
      "constitutionnel",
      1.0
    ]
  ],
  "assermenter": [],
  "besogne": [
    [
      "travail",
      0.2425
    ],
    [
      "tache",
      0.135
    ],
    [
      "occupation",
      0.1075
    ],
    [
      "affaire",
      0.0675
    ],
    [
      "labeur",
      0.0525
    ],
    [
      "mission",
      0.0525
    ],
    [
      "oeuvre",
      0.0525
    ],
    [
      "ouvrage",
      0.0525
    ],
    [
      "boulot",
      0.04
    ],
    [
      "activite",
      0.04
    ],
    [
      "job",
      0.025
    ],
    [
      "production",
      0.025
    ],
    [
      "soin",
      0.0125
    ],
    [
      "operation",
      0.0125
    ],
    [
      "office",
      0.0125
    ],
    [
      "necessaire",
      0.0125
    ],
    [
      "corvee",
      0.0125
    ],
    [
      "business",
      0.0125
    ],
    [
      "turbin",
      0.0125
    ]
  ],
  "besogner": [
    [
      "travailler",
      0.4
    ],
    [
      "peiner",
      0.2
    ],
    [
      "fonctionner",
      0.1
    ],
    [
      "occuper",
      0.1
    ],
    [
      "piocher",
      0.1
    ],
    [
      "trimer",
      0.1
    ]
  ],
  "impunement": [],
  "executer": [
    [
      "faire",
      0.11
    ],
    [
      "tuer",
      0.065
    ],
    [
      "accomplir",
      0.055
    ],
    [
      "pratiquer",
      0.045
    ],
    [
      "realiser",
      0.045
    ],
    [
      "tenir",
      0.045
    ],
    [
      "abattre",
      0.035
    ],
    [
      "achever",
      0.0325
    ],
    [
      "couper",
      0.025
    ],
    [
      "terminer",
      0.0225
    ],
    [
      "supprimer",
      0.0225
    ],
    [
      "saisir",
      0.0225
    ],
    [
      "remplir",
      0.0225
    ],
    [
      "proceder",
      0.0225
    ],
    [
      "operer",
      0.0225
    ],
    [
      "observer",
      0.0225
    ],
    [
      "jouer",
      0.0225
    ],
    [
      "effectuer",
      0.0225
    ],
    [
      "decapiter",
      0.0225
    ],
    [
      "descendre",
      0.0175
    ],
    [
      "ereinter",
      0.0125
    ],
    [
      "satisfaire",
      0.0125
    ],
    [
      "s'acquitter",
      0.0125
    ],
    [
      "interpreter",
      0.0125
    ],
    [
      "guillotiner",
      0.0125
    ],
    [
      "fabriquer",
      0.0125
    ],
    [
      "exercer",
      0.0125
    ],
    [
      "demolir",
      0.0125
    ],
    [
      "agir",
      0.0125
    ],
    [
      "travailler",
      0.0075
    ],
    [
      "supplicier",
      0.0075
    ],
    [
      "parfaire",
      0.0075
    ],
    [
      "parachever",
      0.0075
    ],
    [
      "obeir",
      0.0075
    ],
    [
      "expedier",
      0.0075
    ],
    [
      "commettre",
      0.0075
    ],
    [
      "obtemperer",
      0.0025
    ],
    [
      "pendre",
      0.0025
    ],
    [
      "electrocuter",
      0.0025
    ],
    [
      "lapider",
      0.0025
    ],
    [
      "garrotter",
      0.0025
    ],
    [
      "assassiner",
      0.0025
    ],
    [
      "chanter",
      0.0025
    ],
    [
      "condamner",
      0.0025
    ],
    [
      "confectionner",
      0.0025
    ],
    [
      "esquinter",
      0.0025
    ],
    [
      "exproprier",
      0.0025
    ],
    [
      "fusiller",
      0.0025
    ],
    [
      "eliminer",
      0.0025
    ]
  ],
  "mars": [],
  "basque": [
    [
      "euscarien",
      0.25
    ],
    [
      "pan",
      0.25
    ],
    [
      "queue",
      0.25
    ]
  ],
  "revolter": [
    [
      "indigner",
      0.1725
    ],
    [
      "facher",
      0.13
    ],
    [
      "revulser",
      0.13
    ],
    [
      "ecoeurer",
      0.085
    ],
    [
      "scandaliser",
      0.085
    ],
    [
      "degouter",
      0.085
    ],
    [
      "choquer",
      0.085
    ],
    [
      "cabrer",
      0.085
    ],
    [
      "agiter",
      0.0425
    ],
    [
      "outrer",
      0.0425
    ],
    [
      "soulever",
      0.0425
    ]
  ],
  "immonde": [
    [
      "ignoble",
      0.1075
    ],
    [
      "infame",
      0.0925
    ],
    [
      "abject",
      0.09
    ],
    [
      "sordide",
      0.09
    ],
    [
      "repugnant",
      0.0825
    ],
    [
      "degoutant",
      0.0725
    ],
    [
      "sale",
      0.0625
    ],
    [
      "infect",
      0.05
    ],
    [
      "honteux",
      0.0425
    ],
    [
      "vil",
      0.035
    ],
    [
      "impur",
      0.03
    ],
    [
      "malpropre",
      0.025
    ],
    [
      "ordurier",
      0.0225
    ],
    [
      "nauseabond",
      0.0225
    ],
    [
      "ignominieux",
      0.0225
    ],
    [
      "obscene",
      0.02
    ],
    [
      "avilissant",
      0.015
    ],
    [
      "innommable",
      0.015
    ],
    [
      "fetide",
      0.0125
    ],
    [
      "odieux",
      0.0125
    ],
    [
      "puant",
      0.0125
    ],
    [
      "meprisable",
      0.01
    ],
    [
      "degradant",
      0.005
    ],
    [
      "turpide",
      0.005
    ],
    [
      "inhumain",
      0.0025
    ],
    [
      "lache",
      0.0025
    ],
    [
      "nauseeux",
      0.0025
    ],
    [
      "repulsif",
      0.0025
    ]
  ],
  "guillotine": [
    [
      "bascule",
      0.1
    ],
    [
      "veuve",
      0.1
    ],
    [
      "massicot",
      0.1
    ],
    [
      "lunette",
      0.1
    ],
    [
      "faucheuse",
      0.1
    ],
    [
      "bequillarde",
      0.1
    ],
    [
      "becane",
      0.1
    ],
    [
      "echafaud",
      0.1
    ]
  ],
  "guillotiner": [
    [
      "decapiter",
      0.25
    ],
    [
      "couper",
      0.165
    ],
    [
      "executer",
      0.1225
    ],
    [
      "tuer",
      0.1225
    ],
    [
      "decoller",
      0.0825
    ],
    [
      "faucher",
      0.0825
    ],
    [
      "raccourcir",
      0.04
    ],
    [
      "supplicier",
      0.04
    ]
  ],
  "hexagone": [],
  "seizieme": [],
  "allant": [
    [
      "vivacite",
      0.145
    ],
    [
      "entrain",
      0.1025
    ],
    [
      "ardeur",
      0.0875
    ],
    [
      "vie",
      0.0725
    ],
    [
      "activite",
      0.0575
    ],
    [
      "vif",
      0.0575
    ],
    [
      "vitalite",
      0.0425
    ],
    [
      "mordant",
      0.0425
    ],
    [
      "allegre",
      0.0425
    ],
    [
      "actif",
      0.0425
    ],
    [
      "fougue",
      0.0275
    ],
    [
      "dynamisme",
      0.0275
    ],
    [
      "brio",
      0.0275
    ],
    [
      "allegresse",
      0.0275
    ],
    [
      "alacrite",
      0.0275
    ],
    [
      "montant",
      0.0125
    ],
    [
      "leste",
      0.0125
    ],
    [
      "juvenilite",
      0.0125
    ],
    [
      "initiative",
      0.0125
    ],
    [
      "ingambe",
      0.0125
    ],
    [
      "fraicheur",
      0.0125
    ],
    [
      "dynamique",
      0.0125
    ],
    [
      "alerte",
      0.0125
    ],
    [
      "agissant",
      0.0125
    ],
    [
      "vigoureux",
      0.0125
    ]
  ],
  "commemorer": [
    [
      "celebrer",
      0.25
    ],
    [
      "feter",
      0.25
    ],
    [
      "rappeler",
      0.25
    ],
    [
      "retracer",
      0.25
    ]
  ],
  "debarquement": [
    [
      "abordage",
      0.2
    ],
    [
      "descente",
      0.2
    ],
    [
      "debardage",
      0.2
    ],
    [
      "dechargement",
      0.2
    ],
    [
      "incursion",
      0.2
    ]
  ],
  "ricain": [
    [
      "amerloc",
      0.5
    ],
    [
      "americain",
      0.5
    ]
  ],
  "portugais": [
    [
      "iberique",
      0.5
    ],
    [
      "lusitanien",
      0.5
    ]
  ],
  "elimine": [
    [
      "exclure",
      0.0825
    ],
    [
      "supprimer",
      0.0825
    ],
    [
      "repousser",
      0.06
    ],
    [
      "ecarter",
      0.055
    ],
    [
      "chasser",
      0.0525
    ],
    [
      "retrancher",
      0.0475
    ],
    [
      "rejeter",
      0.035
    ],
    [
      "detruire",
      0.035
    ],
    [
      "bannir",
      0.035
    ],
    [
      "enlever",
      0.03
    ],
    [
      "retirer",
      0.03
    ],
    [
      "eloigner",
      0.03
    ],
    [
      "evincer",
      0.025
    ],
    [
      "refuser",
      0.025
    ],
    [
      "expulser",
      0.025
    ],
    [
      "dissiper",
      0.025
    ],
    [
      "proscrire",
      0.02
    ],
    [
      "rayer",
      0.02
    ],
    [
      "blackbouler",
      0.015
    ],
    [
      "epurer",
      0.0125
    ],
    [
      "tirer",
      0.0125
    ],
    [
      "sortir",
      0.0125
    ],
    [
      "refouler",
      0.0125
    ],
    [
      "excepter",
      0.0125
    ],
    [
      "effacer",
      0.0125
    ],
    [
      "battre",
      0.0125
    ],
    [
      "abattre",
      0.0125
    ],
    [
      "evacuer",
      0.0075
    ],
    [
      "recaler",
      0.0075
    ],
    [
      "ostraciser",
      0.0075
    ],
    [
      "coller",
      0.0075
    ],
    [
      "bousculer",
      0.0075
    ],
    [
      "ajourner",
      0.0075
    ],
    [
      "tamiser",
      0.0025
    ],
    [
      "omettre",
      0.0025
    ],
    [
      "neantiser",
      0.0025
    ],
    [
      "forclore",
      0.0025
    ],
    [
      "filtrer",
      0.0025
    ],
    [
      "executer",
      0.0025
    ],
    [
      "abstraire",
      0.0025
    ],
    [
      "eradiquer",
      0.0025
    ]
  ],
  "exploitation": [
    [
      "entreprise",
      0.06
    ],
    [
      "ferme",
      0.06
    ],
    [
      "industrie",
      0.06
    ],
    [
      "propriete",
      0.06
    ],
    [
      "usine",
      0.06
    ],
    [
      "etablissement",
      0.06
    ],
    [
      "vol",
      0.04
    ],
    [
      "terre",
      0.04
    ],
    [
      "manufacture",
      0.04
    ],
    [
      "fonds",
      0.04
    ],
    [
      "fermage",
      0.04
    ],
    [
      "fabrique",
      0.04
    ],
    [
      "domaine",
      0.04
    ],
    [
      "metayage",
      0.02
    ],
    [
      "plantation",
      0.02
    ],
    [
      "pressoir",
      0.02
    ],
    [
      "production",
      0.02
    ],
    [
      "profit",
      0.02
    ],
    [
      "ranch",
      0.02
    ],
    [
      "management",
      0.02
    ],
    [
      "exaction",
      0.02
    ],
    [
      "escroquerie",
      0.02
    ],
    [
      "culture",
      0.02
    ],
    [
      "concession",
      0.02
    ],
    [
      "commerce",
      0.02
    ],
    [
      "carotte",
      0.02
    ],
    [
      "utilisation",
      0.02
    ]
  ],
  "abreuver": [
    [
      "inonder",
      0.1125
    ],
    [
      "combler",
      0.0975
    ],
    [
      "remplir",
      0.08
    ],
    [
      "accabler",
      0.065
    ],
    [
      "couvrir",
      0.065
    ],
    [
      "impregner",
      0.065
    ],
    [
      "submerger",
      0.0475
    ],
    [
      "penetrer",
      0.0475
    ],
    [
      "mouiller",
      0.0475
    ],
    [
      "imbiber",
      0.0475
    ],
    [
      "gorger",
      0.0475
    ],
    [
      "bourrer",
      0.0475
    ],
    [
      "arroser",
      0.0475
    ],
    [
      "humecter",
      0.0325
    ],
    [
      "saturer",
      0.0325
    ],
    [
      "entourer",
      0.015
    ],
    [
      "desalterer",
      0.015
    ],
    [
      "boire",
      0.015
    ],
    [
      "apprendre",
      0.015
    ],
    [
      "agonir",
      0.015
    ]
  ],
  "artifice": [
    [
      "ruse",
      0.1375
    ],
    [
      "truc",
      0.1175
    ],
    [
      "astuce",
      0.115
    ],
    [
      "tromperie",
      0.0325
    ],
    [
      "habilete",
      0.0325
    ],
    [
      "rouerie",
      0.0325
    ],
    [
      "finesse",
      0.0225
    ],
    [
      "feinte",
      0.02
    ],
    [
      "sournoiserie",
      0.0175
    ],
    [
      "simulation",
      0.0175
    ],
    [
      "moyen",
      0.0175
    ],
    [
      "art",
      0.015
    ],
    [
      "piege",
      0.015
    ],
    [
      "stratageme",
      0.015
    ],
    [
      "matoiserie",
      0.015
    ],
    [
      "manege",
      0.015
    ],
    [
      "fourberie",
      0.015
    ],
    [
      "finasserie",
      0.015
    ],
    [
      "detour",
      0.015
    ],
    [
      "adresse",
      0.0125
    ],
    [
      "intrigue",
      0.0125
    ],
    [
      "subtilite",
      0.0125
    ],
    [
      "subterfuge",
      0.01
    ],
    [
      "machination",
      0.01
    ],
    [
      "invention",
      0.01
    ],
    [
      "combinaison",
      0.01
    ],
    [
      "tour",
      0.0075
    ],
    [
      "manoeuvre",
      0.0075
    ],
    [
      "machiavelisme",
      0.0075
    ],
    [
      "leurre",
      0.0075
    ],
    [
      "ficelle",
      0.0075
    ],
    [
      "singerie",
      0.0075
    ],
    [
      "roublardise",
      0.0075
    ],
    [
      "mensonge",
      0.0075
    ],
    [
      "fard",
      0.0075
    ],
    [
      "carotte",
      0.0075
    ],
    [
      "trame",
      0.005
    ],
    [
      "procede",
      0.005
    ],
    [
      "politique",
      0.005
    ],
    [
      "perfidie",
      0.005
    ],
    [
      "maquignonnage",
      0.005
    ],
    [
      "maniere",
      0.005
    ],
    [
      "industrie",
      0.005
    ],
    [
      "embuche",
      0.005
    ],
    [
      "diplomatie",
      0.005
    ],
    [
      "argutie",
      0.005
    ],
    [
      "malice",
      0.0025
    ],
    [
      "meandre",
      0.0025
    ],
    [
      "retour",
      0.0025
    ],
    [
      "technique",
      0.0025
    ],
    [
      "echappatoire",
      0.0025
    ],
    [
      "machine",
      0.0025
    ],
    [
      "ingeniosite",
      0.0025
    ],
    [
      "fraude",
      0.0025
    ],
    [
      "biais",
      0.0025
    ],
    [
      "cautele",
      0.0025
    ],
    [
      "chafouinerie",
      0.0025
    ],
    [
      "deguisement",
      0.0025
    ],
    [
      "rubrique",
      0.0
    ],
    [
      "rets",
      0.0
    ],
    [
      "pipeau",
      0.0
    ],
    [
      "ornement",
      0.0
    ],
    [
      "fantasmagorie",
      0.0
    ],
    [
      "entortillage",
      0.0
    ],
    [
      "chicane",
      0.0
    ],
    [
      "echafaudage",
      0.0
    ]
  ],
  "pion": [
    [
      "surveillant",
      0.4
    ],
    [
      "maitre",
      0.2
    ],
    [
      "meson",
      0.2
    ]
  ],
  "conge": [
    [
      "permission",
      0.105
    ],
    [
      "repos",
      0.105
    ],
    [
      "vacances",
      0.105
    ],
    [
      "autorisation",
      0.0775
    ],
    [
      "loisir",
      0.0525
    ],
    [
      "inactivite",
      0.0525
    ],
    [
      "inaction",
      0.0525
    ],
    [
      "exeat",
      0.0525
    ],
    [
      "campos",
      0.0525
    ],
    [
      "renvoi",
      0.025
    ],
    [
      "preavis",
      0.025
    ],
    [
      "passavant",
      0.025
    ],
    [
      "licenciement",
      0.025
    ],
    [
      "congediement",
      0.025
    ],
    [
      "cavet",
      0.025
    ],
    [
      "approbation",
      0.025
    ],
    [
      "treve",
      0.025
    ]
  ],
  "polluer": [
    [
      "souiller",
      0.1825
    ],
    [
      "gater",
      0.1425
    ],
    [
      "corrompre",
      0.1225
    ],
    [
      "infecter",
      0.08
    ],
    [
      "vicier",
      0.08
    ],
    [
      "salir",
      0.06
    ],
    [
      "empester",
      0.06
    ],
    [
      "contaminer",
      0.06
    ],
    [
      "profaner",
      0.04
    ],
    [
      "tacher",
      0.04
    ],
    [
      "tarer",
      0.04
    ],
    [
      "violer",
      0.04
    ],
    [
      "denaturer",
      0.02
    ],
    [
      "infester",
      0.02
    ]
  ],
  "presence": [
    [
      "assiduite",
      0.1
    ],
    [
      "regularite",
      0.1
    ],
    [
      "omnipresence",
      0.1
    ],
    [
      "fraicheur",
      0.1
    ],
    [
      "existence",
      0.1
    ],
    [
      "essence",
      0.1
    ],
    [
      "compagnie",
      0.1
    ],
    [
      "classe",
      0.1
    ],
    [
      "assistance",
      0.1
    ],
    [
      "vue",
      0.1
    ]
  ],
  "paysage": [
    [
      "vue",
      0.1525
    ],
    [
      "peinture",
      0.1325
    ],
    [
      "site",
      0.0925
    ],
    [
      "tableau",
      0.075
    ],
    [
      "panorama",
      0.055
    ],
    [
      "figure",
      0.055
    ],
    [
      "scene",
      0.0375
    ],
    [
      "perspective",
      0.0375
    ],
    [
      "marine",
      0.0375
    ],
    [
      "horizon",
      0.0375
    ],
    [
      "dessin",
      0.0375
    ],
    [
      "bergerie",
      0.0375
    ],
    [
      "situation",
      0.0175
    ],
    [
      "decor",
      0.0175
    ],
    [
      "carte",
      0.0175
    ],
    [
      "campagne",
      0.0175
    ],
    [
      "bucolique",
      0.0175
    ],
    [
      "verdure",
      0.0175
    ]
  ],
  "septembre": [],
  "ambassadeur": [
    [
      "representant",
      0.1525
    ],
    [
      "envoye",
      0.14
    ],
    [
      "negociateur",
      0.14
    ],
    [
      "diplomate",
      0.0625
    ],
    [
      "legat",
      0.0625
    ],
    [
      "emissaire",
      0.05
    ],
    [
      "intermediaire",
      0.05
    ],
    [
      "plenipotentiaire",
      0.0375
    ],
    [
      "messager",
      0.0375
    ],
    [
      "depute",
      0.0375
    ],
    [
      "agent",
      0.0375
    ],
    [
      "ministre",
      0.025
    ],
    [
      "nonce",
      0.025
    ],
    [
      "attache",
      0.0125
    ],
    [
      "excellence",
      0.0125
    ]
  ],
  "fascisme": [
    [
      "dictature",
      0.3325
    ],
    [
      "totalitarisme",
      0.3325
    ],
    [
      "tyrannie",
      0.3325
    ]
  ],
  "gangrene": [
    [
      "corrompre",
      0.1925
    ],
    [
      "gater",
      0.1925
    ],
    [
      "infecter",
      0.08
    ],
    [
      "pourrir",
      0.08
    ],
    [
      "pervertir",
      0.0675
    ],
    [
      "vicier",
      0.0675
    ],
    [
      "denaturer",
      0.055
    ],
    [
      "empoisonner",
      0.04
    ],
    [
      "empester",
      0.04
    ],
    [
      "depraver",
      0.04
    ],
    [
      "avarier",
      0.025
    ],
    [
      "carier",
      0.025
    ],
    [
      "frelater",
      0.025
    ],
    [
      "souiller",
      0.025
    ],
    [
      "mortifier",
      0.0125
    ],
    [
      "ronger",
      0.0125
    ]
  ],
  "gangrener": [
    [
      "corrompre",
      0.1925
    ],
    [
      "gater",
      0.1925
    ],
    [
      "infecter",
      0.08
    ],
    [
      "pourrir",
      0.08
    ],
    [
      "pervertir",
      0.0675
    ],
    [
      "vicier",
      0.0675
    ],
    [
      "denaturer",
      0.055
    ],
    [
      "empoisonner",
      0.04
    ],
    [
      "empester",
      0.04
    ],
    [
      "depraver",
      0.04
    ],
    [
      "avarier",
      0.025
    ],
    [
      "carier",
      0.025
    ],
    [
      "frelater",
      0.025
    ],
    [
      "souiller",
      0.025
    ],
    [
      "mortifier",
      0.0125
    ],
    [
      "ronger",
      0.0125
    ]
  ],
  "sinecure": [
    [
      "emploi",
      0.25
    ],
    [
      "fromage",
      0.25
    ],
    [
      "charge",
      0.125
    ],
    [
      "filon",
      0.125
    ],
    [
      "fonction",
      0.125
    ]
  ],
  "raisin": [
    [
      "cepage",
      0.25
    ],
    [
      "grappe",
      0.25
    ],
    [
      "vendange",
      0.25
    ],
    [
      "vigne",
      0.25
    ]
  ],
  "fermenter": [
    [
      "bouillir",
      0.19
    ],
    [
      "s'echauffer",
      0.1425
    ],
    [
      "bouillonner",
      0.095
    ],
    [
      "gonfler",
      0.095
    ],
    [
      "travailler",
      0.095
    ],
    [
      "s'exalter",
      0.0475
    ],
    [
      "s'agiter",
      0.0475
    ],
    [
      "mijoter",
      0.0475
    ],
    [
      "lever",
      0.0475
    ],
    [
      "germer",
      0.0475
    ],
    [
      "chauffer",
      0.0475
    ],
    [
      "bourdonner",
      0.0475
    ]
  ],
  "pinard": [
    [
      "picrate",
      0.4
    ],
    [
      "piqueton",
      0.2
    ],
    [
      "vin",
      0.2
    ]
  ],
  "tierce": [
    [
      "P.M.U.",
      0.25
    ],
    [
      "triade",
      0.25
    ],
    [
      "trio",
      0.25
    ],
    [
      "triumvirat",
      0.25
    ]
  ],
  "opium": [
    [
      "drogue",
      0.5
    ],
    [
      "laudanum",
      0.5
    ]
  ],
  "accoutumance": [
    [
      "habitude",
      0.165
    ],
    [
      "acclimatement",
      0.07
    ],
    [
      "adaptation",
      0.07
    ],
    [
      "usage",
      0.07
    ],
    [
      "routine",
      0.045
    ],
    [
      "immunite",
      0.045
    ],
    [
      "endurcissement",
      0.045
    ],
    [
      "acclimatation",
      0.045
    ],
    [
      "manie",
      0.0225
    ],
    [
      "mithridatisation",
      0.0225
    ],
    [
      "pharmacodependance",
      0.0225
    ],
    [
      "pli",
      0.0225
    ],
    [
      "tolerance",
      0.0225
    ],
    [
      "toxicomanie",
      0.0225
    ],
    [
      "transition",
      0.0225
    ],
    [
      "us",
      0.0225
    ],
    [
      "insensibilite",
      0.0225
    ],
    [
      "insensibilisation",
      0.0225
    ],
    [
      "accommodation",
      0.0225
    ],
    [
      "addiction",
      0.0225
    ],
    [
      "aguerrissement",
      0.0225
    ],
    [
      "apprivoisement",
      0.0225
    ],
    [
      "coutume",
      0.0225
    ],
    [
      "dependance",
      0.0225
    ],
    [
      "habituation",
      0.0225
    ],
    [
      "immunisation",
      0.0225
    ],
    [
      "vaccination",
      0.0225
    ]
  ],
  "decembre": [],
  "apotheose": [
    [
      "gloire",
      0.1325
    ],
    [
      "apogee",
      0.105
    ],
    [
      "triomphe",
      0.105
    ],
    [
      "comble",
      0.0775
    ],
    [
      "glorification",
      0.0775
    ],
    [
      "eloge",
      0.05
    ],
    [
      "summum",
      0.05
    ],
    [
      "honneur",
      0.05
    ],
    [
      "exaltation",
      0.05
    ],
    [
      "divinisation",
      0.05
    ],
    [
      "sommet",
      0.025
    ],
    [
      "immortalite",
      0.025
    ],
    [
      "faite",
      0.025
    ],
    [
      "deification",
      0.025
    ],
    [
      "consecration",
      0.025
    ],
    [
      "clou",
      0.025
    ],
    [
      "bouquet",
      0.025
    ],
    [
      "achevement",
      0.025
    ],
    [
      "terminaison",
      0.025
    ]
  ],
  "morose": [
    [
      "maussade",
      0.1075
    ],
    [
      "chagrin",
      0.08
    ],
    [
      "triste",
      0.08
    ],
    [
      "renfrogne",
      0.0725
    ],
    [
      "sombre",
      0.0725
    ],
    [
      "morne",
      0.0675
    ],
    [
      "melancolique",
      0.0675
    ],
    [
      "bilieux",
      0.06
    ],
    [
      "hargneux",
      0.0525
    ],
    [
      "acariatre",
      0.04
    ],
    [
      "atrabilaire",
      0.04
    ],
    [
      "bougon",
      0.025
    ],
    [
      "grincheux",
      0.025
    ],
    [
      "terne",
      0.02
    ],
    [
      "taciturne",
      0.02
    ],
    [
      "rechigne",
      0.02
    ],
    [
      "grognon",
      0.02
    ],
    [
      "bourru",
      0.02
    ],
    [
      "amer",
      0.02
    ],
    [
      "hypocondriaque",
      0.0125
    ],
    [
      "boudeur",
      0.0125
    ],
    [
      "abattu",
      0.0125
    ],
    [
      "aneanti",
      0.005
    ],
    [
      "gris",
      0.005
    ],
    [
      "grisatre",
      0.005
    ],
    [
      "nostalgique",
      0.005
    ],
    [
      "sepulcral",
      0.005
    ]
  ],
  "dinde": [
    [
      "becasse",
      0.5
    ],
    [
      "becassine",
      0.25
    ],
    [
      "bete",
      0.25
    ]
  ],
  "bandant": [
    [
      "entourer",
      0.0925
    ],
    [
      "envelopper",
      0.0925
    ],
    [
      "fermer",
      0.0925
    ],
    [
      "raidir",
      0.0925
    ],
    [
      "serrer",
      0.0925
    ],
    [
      "tendre",
      0.0925
    ],
    [
      "tirer",
      0.0625
    ],
    [
      "contracter",
      0.0625
    ],
    [
      "attacher",
      0.0625
    ],
    [
      "concentrer",
      0.03
    ],
    [
      "couvrir",
      0.03
    ],
    [
      "obturer",
      0.03
    ],
    [
      "panser",
      0.03
    ],
    [
      "roidir",
      0.03
    ],
    [
      "soigner",
      0.03
    ],
    [
      "triquer",
      0.03
    ]
  ],
  "pretendant": [
    [
      "postulant",
      0.19
    ],
    [
      "amant",
      0.095
    ],
    [
      "amoureux",
      0.095
    ],
    [
      "soupirant",
      0.0475
    ],
    [
      "solliciteur",
      0.0475
    ],
    [
      "pretendu",
      0.0475
    ],
    [
      "promis",
      0.0475
    ],
    [
      "poursuivant",
      0.0475
    ],
    [
      "impetrant",
      0.0475
    ],
    [
      "futur",
      0.0475
    ],
    [
      "fiance",
      0.0475
    ],
    [
      "courtisan",
      0.0475
    ],
    [
      "candidat",
      0.0475
    ],
    [
      "aspirant",
      0.0475
    ],
    [
      "amateur",
      0.0475
    ],
    [
      "epouseur",
      0.0475
    ]
  ],
  "taillader": [
    [
      "couper",
      0.2025
    ],
    [
      "blesser",
      0.095
    ],
    [
      "balafrer",
      0.075
    ],
    [
      "entailler",
      0.075
    ],
    [
      "tailler",
      0.0625
    ],
    [
      "dechirer",
      0.0625
    ],
    [
      "dechiqueter",
      0.0625
    ],
    [
      "labourer",
      0.0525
    ],
    [
      "echarper",
      0.0525
    ],
    [
      "lacerer",
      0.03
    ],
    [
      "hacher",
      0.03
    ],
    [
      "entamer",
      0.03
    ],
    [
      "sabrer",
      0.02
    ],
    [
      "inciser",
      0.02
    ],
    [
      "charcuter",
      0.02
    ],
    [
      "chapeler",
      0.02
    ],
    [
      "censurer",
      0.02
    ],
    [
      "buriner",
      0.01
    ],
    [
      "cisailler",
      0.01
    ],
    [
      "raviner",
      0.01
    ],
    [
      "rogner",
      0.01
    ]
  ],
  "ronron": [
    [
      "bourdonnement",
      0.2
    ],
    [
      "bruit",
      0.2
    ],
    [
      "grondement",
      0.2
    ],
    [
      "ronflement",
      0.15
    ],
    [
      "grognement",
      0.05
    ],
    [
      "mugissement",
      0.05
    ],
    [
      "ronronnement",
      0.05
    ],
    [
      "routine",
      0.05
    ],
    [
      "rumeur",
      0.05
    ]
  ],
  "conditionner": [
    [
      "commander",
      0.125
    ],
    [
      "dicter",
      0.125
    ],
    [
      "distribuer",
      0.125
    ],
    [
      "determiner",
      0.125
    ],
    [
      "emballer",
      0.125
    ],
    [
      "influencer",
      0.125
    ],
    [
      "traiter",
      0.125
    ]
  ],
  "conditionne": [
    [
      "commander",
      0.125
    ],
    [
      "dicter",
      0.125
    ],
    [
      "distribuer",
      0.125
    ],
    [
      "determiner",
      0.125
    ],
    [
      "emballer",
      0.125
    ],
    [
      "influencer",
      0.125
    ],
    [
      "traiter",
      0.125
    ]
  ],
  "gay": [
    [
      "gai",
      0.3325
    ],
    [
      "homosexuel",
      0.3325
    ],
    [
      "lesbien",
      0.3325
    ]
  ],
  "club": [
    [
      "association",
      0.155
    ],
    [
      "cabaret",
      0.115
    ],
    [
      "cercle",
      0.115
    ],
    [
      "groupe",
      0.115
    ],
    [
      "societe",
      0.075
    ],
    [
      "groupement",
      0.0375
    ],
    [
      "patronage",
      0.0375
    ],
    [
      "salon",
      0.0375
    ],
    [
      "spoon",
      0.0375
    ],
    [
      "discotheque",
      0.0375
    ],
    [
      "cenacle",
      0.0375
    ],
    [
      "canne",
      0.0375
    ],
    [
      "bar",
      0.0375
    ],
    [
      "amicale",
      0.0375
    ],
    [
      "ecole",
      0.0375
    ]
  ],
  "fuseau": [
    [
      "broche",
      0.1425
    ],
    [
      "fusee",
      0.1425
    ],
    [
      "heure",
      0.1425
    ],
    [
      "pantalon",
      0.1425
    ],
    [
      "rochet",
      0.1425
    ],
    [
      "roulet",
      0.1425
    ],
    [
      "trochoide",
      0.1425
    ]
  ],
  "matelot": [
    [
      "marin",
      0.3175
    ],
    [
      "navigateur",
      0.18
    ],
    [
      "gabier",
      0.09
    ],
    [
      "mathurin",
      0.09
    ],
    [
      "mousse",
      0.09
    ],
    [
      "moussaillon",
      0.045
    ],
    [
      "mataf",
      0.045
    ],
    [
      "marsouin",
      0.045
    ],
    [
      "nautonier",
      0.045
    ]
  ],
  "tangue": [
    [
      "osciller",
      0.165
    ],
    [
      "balancer",
      0.1175
    ],
    [
      "vaciller",
      0.095
    ],
    [
      "branler",
      0.0825
    ],
    [
      "remuer",
      0.07
    ],
    [
      "brimbaler",
      0.0575
    ],
    [
      "tituber",
      0.0575
    ],
    [
      "chanceler",
      0.0475
    ],
    [
      "ballotter",
      0.0475
    ],
    [
      "baller",
      0.035
    ],
    [
      "bringuebaler",
      0.035
    ],
    [
      "dodeliner",
      0.035
    ],
    [
      "danser",
      0.0225
    ],
    [
      "cahoter",
      0.0225
    ],
    [
      "bourlinguer",
      0.01
    ],
    [
      "chavirer",
      0.01
    ],
    [
      "houler",
      0.01
    ],
    [
      "zigzaguer",
      0.01
    ]
  ],
  "tanguer": [
    [
      "osciller",
      0.165
    ],
    [
      "balancer",
      0.1175
    ],
    [
      "vaciller",
      0.095
    ],
    [
      "branler",
      0.0825
    ],
    [
      "remuer",
      0.07
    ],
    [
      "brimbaler",
      0.0575
    ],
    [
      "tituber",
      0.0575
    ],
    [
      "chanceler",
      0.0475
    ],
    [
      "ballotter",
      0.0475
    ],
    [
      "baller",
      0.035
    ],
    [
      "bringuebaler",
      0.035
    ],
    [
      "dodeliner",
      0.035
    ],
    [
      "danser",
      0.0225
    ],
    [
      "cahoter",
      0.0225
    ],
    [
      "bourlinguer",
      0.01
    ],
    [
      "chavirer",
      0.01
    ],
    [
      "houler",
      0.01
    ],
    [
      "zigzaguer",
      0.01
    ]
  ],
  "extra": [
    [
      "beau",
      0.1325
    ],
    [
      "superieur",
      0.1325
    ],
    [
      "bon",
      0.0875
    ],
    [
      "extraordinaire",
      0.0875
    ],
    [
      "genial",
      0.0875
    ],
    [
      "etonnant",
      0.0875
    ],
    [
      "merveilleux",
      0.065
    ],
    [
      "excellent",
      0.065
    ],
    [
      "fameux",
      0.0425
    ],
    [
      "tres",
      0.02
    ],
    [
      "supplement",
      0.02
    ],
    [
      "superfin",
      0.02
    ],
    [
      "serviteur",
      0.02
    ],
    [
      "fin",
      0.02
    ],
    [
      "depense",
      0.02
    ],
    [
      "benevole",
      0.02
    ]
  ],
  "archet": [
    [
      "arceau",
      0.3325
    ],
    [
      "arcon",
      0.3325
    ],
    [
      "cerceau",
      0.3325
    ]
  ],
  "touffe": [
    [
      "houppe",
      0.16
    ],
    [
      "bouquet",
      0.1025
    ],
    [
      "aigrette",
      0.0725
    ],
    [
      "plumet",
      0.0575
    ],
    [
      "toupet",
      0.0425
    ],
    [
      "panache",
      0.0425
    ],
    [
      "flamme",
      0.0425
    ],
    [
      "buisson",
      0.0425
    ],
    [
      "bois",
      0.0425
    ],
    [
      "meche",
      0.0275
    ],
    [
      "breuil",
      0.0275
    ],
    [
      "botte",
      0.0275
    ],
    [
      "bosquet",
      0.0275
    ],
    [
      "plume",
      0.0125
    ],
    [
      "pompon",
      0.0125
    ],
    [
      "taroupe",
      0.0125
    ],
    [
      "tas",
      0.0125
    ],
    [
      "toupillon",
      0.0125
    ],
    [
      "troche",
      0.0125
    ],
    [
      "trochet",
      0.0125
    ],
    [
      "trochee",
      0.0125
    ],
    [
      "pinceau",
      0.0125
    ],
    [
      "huppe",
      0.0125
    ],
    [
      "broussaille",
      0.0125
    ],
    [
      "chatte",
      0.0125
    ],
    [
      "chignon",
      0.0125
    ],
    [
      "criniere",
      0.0125
    ],
    [
      "crepe",
      0.0125
    ],
    [
      "crete",
      0.0125
    ],
    [
      "fanon",
      0.0125
    ],
    [
      "flocon",
      0.0125
    ],
    [
      "epi",
      0.0125
    ]
  ],
  "jesus": [
    [
      "charcuterie",
      1.0
    ]
  ],
  "ruisseler": [
    [
      "couler",
      0.175
    ],
    [
      "degouliner",
      0.125
    ],
    [
      "suinter",
      0.1
    ],
    [
      "transpirer",
      0.1
    ],
    [
      "emaner",
      0.1
    ],
    [
      "decouler",
      0.075
    ],
    [
      "degoutter",
      0.05
    ],
    [
      "rayonner",
      0.05
    ],
    [
      "suer",
      0.05
    ],
    [
      "resplendir",
      0.025
    ],
    [
      "s'exhaler",
      0.025
    ]
  ],
  "nageur": [
    [
      "baigneur",
      0.5
    ],
    [
      "rameur",
      0.5
    ]
  ],
  "ampli": [
    [
      "amplificateur",
      1.0
    ]
  ],
  "parfaitement": [
    [
      "bien",
      0.085
    ],
    [
      "absolument",
      0.0775
    ],
    [
      "extremement",
      0.0775
    ],
    [
      "superieurement",
      0.0775
    ],
    [
      "excellemment",
      0.06
    ],
    [
      "totalement",
      0.05
    ],
    [
      "tres",
      0.05
    ],
    [
      "merveilleusement",
      0.04
    ],
    [
      "completement",
      0.04
    ],
    [
      "admirablement",
      0.0325
    ],
    [
      "divinement",
      0.0325
    ],
    [
      "entierement",
      0.0325
    ],
    [
      "supremement",
      0.0325
    ],
    [
      "souverainement",
      0.025
    ],
    [
      "royalement",
      0.025
    ],
    [
      "extraordinairement",
      0.025
    ],
    [
      "exactement",
      0.025
    ],
    [
      "certainement",
      0.025
    ],
    [
      "terriblement",
      0.015
    ],
    [
      "strictement",
      0.015
    ],
    [
      "splendidement",
      0.015
    ],
    [
      "pleinement",
      0.015
    ],
    [
      "oui",
      0.015
    ],
    [
      "exceptionnellement",
      0.0075
    ],
    [
      "idealement",
      0.0075
    ],
    [
      "impeccablement",
      0.0075
    ],
    [
      "incontestablement",
      0.0075
    ],
    [
      "integralement",
      0.0075
    ],
    [
      "eperdument",
      0.0075
    ]
  ],
  "artificiel": [
    [
      "factice",
      0.19
    ],
    [
      "faux",
      0.11
    ],
    [
      "affecte",
      0.08
    ],
    [
      "conventionnel",
      0.0475
    ],
    [
      "emprunte",
      0.0475
    ],
    [
      "etudie",
      0.0475
    ],
    [
      "feint",
      0.04
    ],
    [
      "fabrique",
      0.04
    ],
    [
      "d'emprunt",
      0.04
    ],
    [
      "force",
      0.0275
    ],
    [
      "postiche",
      0.0275
    ],
    [
      "precieux",
      0.0275
    ],
    [
      "prefabrique",
      0.0275
    ],
    [
      "stereotype",
      0.02
    ],
    [
      "platre",
      0.02
    ],
    [
      "contraint",
      0.02
    ],
    [
      "arrange",
      0.02
    ],
    [
      "subjectif",
      0.0075
    ],
    [
      "specieux",
      0.0075
    ],
    [
      "reproduit",
      0.0075
    ],
    [
      "poseur",
      0.0075
    ],
    [
      "livresque",
      0.0075
    ],
    [
      "litteraire",
      0.0075
    ],
    [
      "imite",
      0.0075
    ],
    [
      "fetiche",
      0.0075
    ],
    [
      "frelate",
      0.0075
    ],
    [
      "emphatique",
      0.0075
    ],
    [
      "convenu",
      0.0075
    ],
    [
      "arbitraire",
      0.0075
    ],
    [
      "affete",
      0.0075
    ],
    [
      "synthetique",
      0.0075
    ]
  ],
  "virtuel": [
    [
      "possible",
      0.3325
    ],
    [
      "latent",
      0.165
    ],
    [
      "potentiel",
      0.165
    ],
    [
      "realisable",
      0.165
    ],
    [
      "theorique",
      0.165
    ]
  ],
  "deesse": [
    [
      "divinite",
      0.1175
    ],
    [
      "grace",
      0.1175
    ],
    [
      "reine",
      0.0575
    ],
    [
      "paredre",
      0.0575
    ],
    [
      "ondine",
      0.0575
    ],
    [
      "nymphe",
      0.0575
    ],
    [
      "naiade",
      0.0575
    ],
    [
      "muse",
      0.0575
    ],
    [
      "heros",
      0.0575
    ],
    [
      "fee",
      0.0575
    ],
    [
      "demone",
      0.0575
    ],
    [
      "deite",
      0.0575
    ],
    [
      "beaute",
      0.0575
    ],
    [
      "apsara",
      0.0575
    ],
    [
      "walkyrie",
      0.0575
    ]
  ],
  "telecharger": [],
  "durant": [
    [
      "pendant",
      0.22
    ],
    [
      "pour",
      0.22
    ],
    [
      "par",
      0.11
    ]
  ],
  "embleme": [
    [
      "symbole",
      0.165
    ],
    [
      "signe",
      0.1075
    ],
    [
      "ecusson",
      0.0525
    ],
    [
      "marque",
      0.0525
    ],
    [
      "figure",
      0.0525
    ],
    [
      "blason",
      0.0525
    ],
    [
      "armoiries",
      0.0525
    ],
    [
      "allegorie",
      0.0525
    ],
    [
      "representation",
      0.035
    ],
    [
      "insigne",
      0.035
    ],
    [
      "drapeau",
      0.035
    ],
    [
      "banniere",
      0.035
    ],
    [
      "attribut",
      0.035
    ],
    [
      "aigle",
      0.035
    ],
    [
      "ecu",
      0.0175
    ],
    [
      "totem",
      0.0175
    ],
    [
      "personnification",
      0.0175
    ],
    [
      "image",
      0.0175
    ],
    [
      "hieroglyphe",
      0.0175
    ],
    [
      "devise",
      0.0175
    ],
    [
      "couronne",
      0.0175
    ],
    [
      "cocarde",
      0.0175
    ],
    [
      "armes",
      0.0175
    ],
    [
      "etendard",
      0.0175
    ]
  ],
  "totem": [
    [
      "amulette",
      0.125
    ],
    [
      "fetiche",
      0.125
    ],
    [
      "talisman",
      0.125
    ],
    [
      "signe",
      0.0625
    ],
    [
      "representation",
      0.0625
    ],
    [
      "representant",
      0.0625
    ],
    [
      "protecteur",
      0.0625
    ],
    [
      "mascotte",
      0.0625
    ],
    [
      "figure",
      0.0625
    ],
    [
      "embleme",
      0.0625
    ],
    [
      "ancetre",
      0.0625
    ],
    [
      "symbole",
      0.0625
    ]
  ],
  "lei": [],
  "primer": [
    [
      "l'emporter",
      0.15
    ],
    [
      "triompher",
      0.15
    ],
    [
      "dominer",
      0.12
    ],
    [
      "surpasser",
      0.12
    ],
    [
      "prevaloir",
      0.09
    ],
    [
      "surmonter",
      0.06
    ],
    [
      "predominer",
      0.06
    ],
    [
      "gagner",
      0.06
    ],
    [
      "distancer",
      0.06
    ],
    [
      "devancer",
      0.06
    ],
    [
      "recompenser",
      0.03
    ],
    [
      "regner",
      0.03
    ]
  ],
  "fa": [],
  "peso": [],
  "via": [
    [
      "par",
      1.0
    ]
  ],
  "oblique": [
    [
      "detourne",
      0.1375
    ],
    [
      "louche",
      0.09
    ],
    [
      "tortueux",
      0.09
    ],
    [
      "gauche",
      0.045
    ],
    [
      "indirect",
      0.045
    ],
    [
      "onduleux",
      0.045
    ],
    [
      "torve",
      0.045
    ],
    [
      "transversal",
      0.045
    ],
    [
      "deloyal",
      0.045
    ],
    [
      "biais",
      0.045
    ],
    [
      "ambigu",
      0.045
    ],
    [
      "zigzagant",
      0.045
    ]
  ],
  "obliquer": [
    [
      "tourner",
      0.2675
    ],
    [
      "devier",
      0.115
    ],
    [
      "virer",
      0.075
    ],
    [
      "rabattre",
      0.075
    ],
    [
      "incliner",
      0.075
    ],
    [
      "detourner",
      0.075
    ],
    [
      "aller",
      0.075
    ],
    [
      "biaiser",
      0.0375
    ],
    [
      "braquer",
      0.0375
    ],
    [
      "pencher",
      0.0375
    ],
    [
      "pivoter",
      0.0375
    ]
  ],
  "lubrique": [
    [
      "lascif",
      0.165
    ],
    [
      "impudique",
      0.1325
    ],
    [
      "sensuel",
      0.115
    ],
    [
      "libidineux",
      0.09
    ],
    [
      "luxurieux",
      0.0825
    ],
    [
      "obscene",
      0.0725
    ],
    [
      "salace",
      0.0575
    ],
    [
      "erotique",
      0.0575
    ],
    [
      "vicieux",
      0.0475
    ],
    [
      "impur",
      0.04
    ],
    [
      "licencieux",
      0.04
    ],
    [
      "charnel",
      0.0325
    ],
    [
      "paillard",
      0.015
    ],
    [
      "voluptueux",
      0.015
    ],
    [
      "bestial",
      0.0075
    ],
    [
      "concupiscent",
      0.0075
    ],
    [
      "graveleux",
      0.0075
    ]
  ],
  "revers": [
    [
      "tribulation",
      0.095
    ],
    [
      "malheur",
      0.085
    ],
    [
      "accident",
      0.0625
    ],
    [
      "insucces",
      0.0525
    ],
    [
      "echec",
      0.0525
    ],
    [
      "epreuve",
      0.0425
    ],
    [
      "defaite",
      0.0425
    ],
    [
      "deception",
      0.0425
    ],
    [
      "catastrophe",
      0.0425
    ],
    [
      "vicissitude",
      0.03
    ],
    [
      "malchance",
      0.03
    ],
    [
      "infortune",
      0.03
    ],
    [
      "debacle",
      0.03
    ],
    [
      "deboire",
      0.03
    ],
    [
      "traverse",
      0.02
    ],
    [
      "retroussis",
      0.02
    ],
    [
      "pile",
      0.02
    ],
    [
      "envers",
      0.02
    ],
    [
      "disgrace",
      0.02
    ],
    [
      "aventure",
      0.02
    ],
    [
      "orage",
      0.01
    ],
    [
      "parement",
      0.01
    ],
    [
      "rabat",
      0.01
    ],
    [
      "rebord",
      0.01
    ],
    [
      "rebras",
      0.01
    ],
    [
      "repli",
      0.01
    ],
    [
      "retour",
      0.01
    ],
    [
      "fiasco",
      0.01
    ],
    [
      "desillusion",
      0.01
    ],
    [
      "deroute",
      0.01
    ],
    [
      "doublure",
      0.01
    ],
    [
      "dos",
      0.01
    ],
    [
      "derriere",
      0.01
    ],
    [
      "choc",
      0.01
    ],
    [
      "avortement",
      0.01
    ],
    [
      "verso",
      0.01
    ]
  ],
  "nec": [],
  "ultra": [
    [
      "fanatique",
      0.2125
    ],
    [
      "royaliste",
      0.1425
    ],
    [
      "partisan",
      0.07
    ],
    [
      "maximaliste",
      0.07
    ],
    [
      "legitimiste",
      0.07
    ],
    [
      "jacobin",
      0.07
    ],
    [
      "intolerant",
      0.07
    ],
    [
      "extremiste",
      0.07
    ]
  ],
  "majeste": [
    [
      "grandeur",
      0.11
    ],
    [
      "eclat",
      0.11
    ],
    [
      "pompe",
      0.0925
    ],
    [
      "splendeur",
      0.0725
    ],
    [
      "gloire",
      0.0725
    ],
    [
      "beaute",
      0.0725
    ],
    [
      "gravite",
      0.055
    ],
    [
      "magnificence",
      0.055
    ],
    [
      "somptuosite",
      0.055
    ],
    [
      "solennite",
      0.035
    ],
    [
      "richesse",
      0.035
    ],
    [
      "prince",
      0.035
    ],
    [
      "noblesse",
      0.035
    ],
    [
      "souverainete",
      0.0175
    ],
    [
      "sire",
      0.0175
    ],
    [
      "roi",
      0.0175
    ],
    [
      "prestige",
      0.0175
    ],
    [
      "excellence",
      0.0175
    ],
    [
      "empereur",
      0.0175
    ],
    [
      "dignite",
      0.0175
    ],
    [
      "superbe",
      0.0175
    ]
  ],
  "ouvrager": [
    [
      "faconner",
      0.3325
    ],
    [
      "fabriquer",
      0.165
    ],
    [
      "orner",
      0.165
    ],
    [
      "ouvrer",
      0.165
    ],
    [
      "travailler",
      0.165
    ]
  ],
  "ouvrage": [
    [
      "fortification",
      0.075
    ],
    [
      "travail",
      0.075
    ],
    [
      "oeuvre",
      0.065
    ],
    [
      "forteresse",
      0.0575
    ],
    [
      "bastion",
      0.0425
    ],
    [
      "ecrit",
      0.0375
    ],
    [
      "production",
      0.0375
    ],
    [
      "citadelle",
      0.0375
    ],
    [
      "besogne",
      0.0275
    ],
    [
      "livre",
      0.0275
    ],
    [
      "piece",
      0.0275
    ],
    [
      "recueil",
      0.0275
    ],
    [
      "tache",
      0.02
    ],
    [
      "facon",
      0.02
    ],
    [
      "entreprise",
      0.02
    ],
    [
      "labeur",
      0.0125
    ],
    [
      "manuel",
      0.0125
    ],
    [
      "monument",
      0.0125
    ],
    [
      "opuscule",
      0.0125
    ],
    [
      "poeme",
      0.0125
    ],
    [
      "rempart",
      0.0125
    ],
    [
      "traite",
      0.0125
    ],
    [
      "edifice",
      0.0125
    ],
    [
      "etude",
      0.0125
    ],
    [
      "krak",
      0.0125
    ],
    [
      "fortin",
      0.0125
    ],
    [
      "fort",
      0.0125
    ],
    [
      "archives",
      0.0125
    ],
    [
      "bloc",
      0.0125
    ],
    [
      "blockhaus",
      0.0125
    ],
    [
      "casemate",
      0.0125
    ],
    [
      "composition",
      0.0125
    ],
    [
      "construction",
      0.0125
    ],
    [
      "creation",
      0.0125
    ],
    [
      "defense",
      0.0125
    ],
    [
      "essai",
      0.0125
    ],
    [
      "realisation",
      0.005
    ],
    [
      "redoute",
      0.005
    ],
    [
      "publication",
      0.005
    ],
    [
      "produit",
      0.005
    ],
    [
      "opus",
      0.005
    ],
    [
      "occupation",
      0.005
    ],
    [
      "facture",
      0.005
    ],
    [
      "dehors",
      0.005
    ],
    [
      "boulot",
      0.005
    ],
    [
      "bastille",
      0.005
    ],
    [
      "volume",
      0.005
    ]
  ],
  "obsession": [
    [
      "spectre",
      0.125
    ],
    [
      "hantise",
      0.1025
    ],
    [
      "manie",
      0.1025
    ],
    [
      "tourment",
      0.0575
    ],
    [
      "souci",
      0.0575
    ],
    [
      "crainte",
      0.0575
    ],
    [
      "cauchemar",
      0.045
    ],
    [
      "vision",
      0.0325
    ],
    [
      "psychose",
      0.0325
    ],
    [
      "marotte",
      0.0325
    ],
    [
      "inquietude",
      0.0325
    ],
    [
      "idee",
      0.0325
    ],
    [
      "hallucination",
      0.0325
    ],
    [
      "toquade",
      0.0225
    ],
    [
      "preoccupation",
      0.0225
    ],
    [
      "monomanie",
      0.0225
    ],
    [
      "maladie",
      0.0225
    ],
    [
      "tentation",
      0.01
    ],
    [
      "scrupule",
      0.01
    ],
    [
      "phobie",
      0.01
    ],
    [
      "envahissement",
      0.01
    ],
    [
      "complexe",
      0.01
    ],
    [
      "cassement",
      0.01
    ],
    [
      "assujettissement",
      0.01
    ],
    [
      "virus",
      0.01
    ]
  ],
  "enteter": [
    [
      "enivrer",
      0.285
    ],
    [
      "fasciner",
      0.1425
    ],
    [
      "infatuer",
      0.1425
    ],
    [
      "souler",
      0.1425
    ],
    [
      "etourdir",
      0.1425
    ]
  ],
  "esthete": [
    [
      "artiste",
      0.25
    ],
    [
      "dandy",
      0.25
    ],
    [
      "dilettante",
      0.25
    ],
    [
      "libertin",
      0.25
    ]
  ],
  "prose": [
    [
      "hymne",
      0.285
    ],
    [
      "cantique",
      0.1425
    ],
    [
      "derriere",
      0.1425
    ],
    [
      "fesse",
      0.1425
    ],
    [
      "litterature",
      0.1425
    ],
    [
      "sequence",
      0.1425
    ]
  ],
  "pretexter": [
    [
      "alleguer",
      0.2125
    ],
    [
      "invoquer",
      0.105
    ],
    [
      "opposer",
      0.105
    ],
    [
      "objecter",
      0.07
    ],
    [
      "feindre",
      0.07
    ],
    [
      "exciper",
      0.07
    ],
    [
      "avancer",
      0.07
    ],
    [
      "arguer",
      0.07
    ],
    [
      "s'autoriser",
      0.035
    ],
    [
      "simuler",
      0.035
    ],
    [
      "supposer",
      0.035
    ]
  ],
  "pretexte": [
    [
      "cause",
      0.09
    ],
    [
      "raison",
      0.075
    ],
    [
      "motif",
      0.0625
    ],
    [
      "occasion",
      0.0625
    ],
    [
      "echappatoire",
      0.05
    ],
    [
      "sujet",
      0.05
    ],
    [
      "excuse",
      0.05
    ],
    [
      "apparence",
      0.05
    ],
    [
      "semblant",
      0.0375
    ],
    [
      "moyen",
      0.0375
    ],
    [
      "manteau",
      0.0375
    ],
    [
      "couvert",
      0.0375
    ],
    [
      "voile",
      0.025
    ],
    [
      "subterfuge",
      0.025
    ],
    [
      "ombre",
      0.025
    ],
    [
      "matiere",
      0.025
    ],
    [
      "lieu",
      0.025
    ],
    [
      "germe",
      0.025
    ],
    [
      "couverture",
      0.025
    ],
    [
      "couleur",
      0.025
    ],
    [
      "refuite",
      0.01
    ],
    [
      "paravent",
      0.01
    ],
    [
      "mot",
      0.01
    ],
    [
      "defaite",
      0.01
    ],
    [
      "brandon",
      0.01
    ],
    [
      "argument",
      0.01
    ],
    [
      "allegation",
      0.01
    ],
    [
      "supposition",
      0.01
    ]
  ],
  "toquer": [
    [
      "frapper",
      0.5
    ],
    [
      "heurter",
      0.5
    ]
  ],
  "toque": [
    [
      "frapper",
      0.5
    ],
    [
      "heurter",
      0.5
    ]
  ],
  "radeau": [
    [
      "bib",
      0.25
    ],
    [
      "brele",
      0.25
    ],
    [
      "rade",
      0.25
    ],
    [
      "ras",
      0.25
    ]
  ],
  "naviguer": [
    [
      "marcher",
      0.09
    ],
    [
      "rouler",
      0.09
    ],
    [
      "circuler",
      0.0675
    ],
    [
      "voler",
      0.0675
    ],
    [
      "evoluer",
      0.045
    ],
    [
      "voyager",
      0.045
    ],
    [
      "voguer",
      0.045
    ],
    [
      "sillonner",
      0.045
    ],
    [
      "manoeuvrer",
      0.045
    ],
    [
      "flotter",
      0.045
    ],
    [
      "filer",
      0.045
    ],
    [
      "diriger",
      0.045
    ],
    [
      "cingler",
      0.045
    ],
    [
      "bourlinguer",
      0.045
    ],
    [
      "surfer",
      0.0225
    ],
    [
      "piloter",
      0.0225
    ],
    [
      "nager",
      0.0225
    ],
    [
      "fendre",
      0.0225
    ],
    [
      "croiser",
      0.0225
    ],
    [
      "caboter",
      0.0225
    ],
    [
      "tenir",
      0.0225
    ]
  ],
  "canard": [
    [
      "bobard",
      0.1175
    ],
    [
      "nouvelle",
      0.0925
    ],
    [
      "bruit",
      0.07
    ],
    [
      "nyroque",
      0.0225
    ],
    [
      "mulard",
      0.0225
    ],
    [
      "morillon",
      0.0225
    ],
    [
      "milouin",
      0.0225
    ],
    [
      "malard",
      0.0225
    ],
    [
      "macreuse",
      0.0225
    ],
    [
      "palmipede",
      0.0225
    ],
    [
      "pilet",
      0.0225
    ],
    [
      "petrin",
      0.0225
    ],
    [
      "rumeur",
      0.0225
    ],
    [
      "sarcelle",
      0.0225
    ],
    [
      "souchet",
      0.0225
    ],
    [
      "sucre",
      0.0225
    ],
    [
      "tadorne",
      0.0225
    ],
    [
      "journal",
      0.0225
    ],
    [
      "harle",
      0.0225
    ],
    [
      "anas",
      0.0225
    ],
    [
      "barbarie",
      0.0225
    ],
    [
      "cacophonie",
      0.0225
    ],
    [
      "canardeau",
      0.0225
    ],
    [
      "cane",
      0.0225
    ],
    [
      "caneton",
      0.0225
    ],
    [
      "canular",
      0.0225
    ],
    [
      "conte",
      0.0225
    ],
    [
      "couac",
      0.0225
    ],
    [
      "eider",
      0.0225
    ],
    [
      "feuille",
      0.0225
    ],
    [
      "gibier",
      0.0225
    ],
    [
      "halbran",
      0.0225
    ],
    [
      "tuyau",
      0.0225
    ]
  ],
  "litterature": [
    [
      "savoir",
      0.1525
    ],
    [
      "theatre",
      0.075
    ],
    [
      "roman",
      0.075
    ],
    [
      "prose",
      0.075
    ],
    [
      "poesie",
      0.075
    ],
    [
      "philologie",
      0.075
    ],
    [
      "linguistique",
      0.075
    ],
    [
      "lettres",
      0.075
    ],
    [
      "lettre",
      0.075
    ],
    [
      "edition",
      0.075
    ]
  ],
  "jeteur": [],
  "franco": [
    [
      "franchement",
      0.2
    ],
    [
      "gracieusement",
      0.2
    ],
    [
      "gratis",
      0.2
    ],
    [
      "gratuitement",
      0.2
    ]
  ],
  "litanie": [
    [
      "chapelet",
      0.165
    ],
    [
      "priere",
      0.165
    ],
    [
      "ribambelle",
      0.165
    ],
    [
      "chant",
      0.0825
    ],
    [
      "denombrement",
      0.0825
    ],
    [
      "invocation",
      0.0825
    ],
    [
      "kyrielle",
      0.0825
    ],
    [
      "revue",
      0.0825
    ],
    [
      "theorie",
      0.0825
    ]
  ],
  "semaphore": [
    [
      "phare",
      0.2
    ],
    [
      "signal",
      0.2
    ],
    [
      "signalement",
      0.2
    ],
    [
      "signalisation",
      0.2
    ],
    [
      "telegraphe",
      0.2
    ]
  ],
  "croquant": [
    [
      "dur",
      0.2
    ],
    [
      "craquant",
      0.1
    ],
    [
      "croustillant",
      0.1
    ],
    [
      "homme",
      0.1
    ],
    [
      "miserable",
      0.1
    ],
    [
      "paysan",
      0.1
    ],
    [
      "pedzouille",
      0.1
    ],
    [
      "rustre",
      0.1
    ],
    [
      "type",
      0.1
    ]
  ],
  "intentionne": [],
  "croc": [
    [
      "crochet",
      0.1775
    ],
    [
      "dent",
      0.1175
    ],
    [
      "grappin",
      0.1175
    ],
    [
      "harpon",
      0.1175
    ],
    [
      "patte",
      0.0575
    ],
    [
      "gaffe",
      0.0575
    ],
    [
      "fourche",
      0.0575
    ],
    [
      "crampon",
      0.0575
    ],
    [
      "corbeau",
      0.0575
    ],
    [
      "chicot",
      0.0575
    ],
    [
      "canine",
      0.0575
    ],
    [
      "perche",
      0.0575
    ]
  ],
  "huche": [
    [
      "coffre",
      0.25
    ],
    [
      "maie",
      0.25
    ],
    [
      "bahut",
      0.125
    ],
    [
      "farinier",
      0.125
    ],
    [
      "fariniere",
      0.125
    ],
    [
      "petrin",
      0.125
    ]
  ],
  "boycotter": [
    [
      "rejeter",
      0.25
    ],
    [
      "interdire",
      0.125
    ],
    [
      "refouler",
      0.125
    ],
    [
      "refuser",
      0.125
    ]
  ],
  "jackpot": [],
  "reussite": [
    [
      "succes",
      0.18
    ],
    [
      "bonheur",
      0.09
    ],
    [
      "chance",
      0.09
    ],
    [
      "prosperite",
      0.09
    ],
    [
      "victoire",
      0.09
    ],
    [
      "triomphe",
      0.045
    ],
    [
      "resultat",
      0.045
    ],
    [
      "realisation",
      0.045
    ],
    [
      "patience",
      0.045
    ],
    [
      "gain",
      0.045
    ],
    [
      "fortune",
      0.045
    ],
    [
      "demarrage",
      0.045
    ],
    [
      "veine",
      0.045
    ]
  ],
  "adrenaline": [],
  "gamme": [
    [
      "registre",
      0.2
    ],
    [
      "echelle",
      0.2
    ],
    [
      "eventail",
      0.2
    ],
    [
      "clavier",
      0.1
    ],
    [
      "palette",
      0.1
    ],
    [
      "panoplie",
      0.1
    ],
    [
      "suite",
      0.1
    ]
  ],
  "qualite": [
    [
      "pouvoir",
      0.045
    ],
    [
      "classe",
      0.04
    ],
    [
      "valeur",
      0.0375
    ],
    [
      "capacite",
      0.0325
    ],
    [
      "caractere",
      0.0325
    ],
    [
      "nature",
      0.0325
    ],
    [
      "etat",
      0.0325
    ],
    [
      "vertu",
      0.03
    ],
    [
      "merite",
      0.03
    ],
    [
      "disposition",
      0.025
    ],
    [
      "faculte",
      0.025
    ],
    [
      "grandeur",
      0.025
    ],
    [
      "titre",
      0.025
    ],
    [
      "rang",
      0.0225
    ],
    [
      "don",
      0.0225
    ],
    [
      "bonte",
      0.0225
    ],
    [
      "attribut",
      0.0225
    ],
    [
      "propriete",
      0.02
    ],
    [
      "sorte",
      0.02
    ],
    [
      "talent",
      0.02
    ],
    [
      "puissance",
      0.015
    ],
    [
      "modalite",
      0.015
    ],
    [
      "espece",
      0.015
    ],
    [
      "condition",
      0.015
    ],
    [
      "categorie",
      0.015
    ],
    [
      "avantage",
      0.015
    ],
    [
      "art",
      0.015
    ],
    [
      "superiorite",
      0.0125
    ],
    [
      "propre",
      0.0125
    ],
    [
      "particularite",
      0.0125
    ],
    [
      "ordre",
      0.0125
    ],
    [
      "fonction",
      0.0125
    ],
    [
      "excellence",
      0.0125
    ],
    [
      "caracteristique",
      0.0125
    ],
    [
      "aptitude",
      0.0125
    ],
    [
      "trempe",
      0.01
    ],
    [
      "qualification",
      0.01
    ],
    [
      "profession",
      0.01
    ],
    [
      "partie",
      0.01
    ],
    [
      "honnetete",
      0.01
    ],
    [
      "droit",
      0.01
    ],
    [
      "competence",
      0.01
    ],
    [
      "calibre",
      0.01
    ],
    [
      "agrement",
      0.01
    ],
    [
      "acabit",
      0.01
    ],
    [
      "specialite",
      0.005
    ],
    [
      "perfection",
      0.005
    ],
    [
      "nom",
      0.005
    ],
    [
      "niveau",
      0.005
    ],
    [
      "marque",
      0.005
    ],
    [
      "apanage",
      0.005
    ],
    [
      "noblesse",
      0.0025
    ],
    [
      "modification",
      0.0025
    ],
    [
      "mode",
      0.0025
    ],
    [
      "finesse",
      0.0025
    ],
    [
      "essence",
      0.0025
    ],
    [
      "choix",
      0.0025
    ],
    [
      "bourre",
      0.0025
    ],
    [
      "aloi",
      0.0025
    ],
    [
      "qualificatif",
      0.0025
    ]
  ],
  "delocaliser": [],
  "metalliser": [
    [
      "galvaniser",
      0.375
    ],
    [
      "argenter",
      0.125
    ],
    [
      "chromer",
      0.125
    ],
    [
      "cuivrer",
      0.125
    ],
    [
      "nickeler",
      0.125
    ],
    [
      "etamer",
      0.125
    ]
  ],
  "canaliser": [
    [
      "conduire",
      0.1475
    ],
    [
      "diriger",
      0.1475
    ],
    [
      "concentrer",
      0.11
    ],
    [
      "rassembler",
      0.11
    ],
    [
      "reunir",
      0.11
    ],
    [
      "orienter",
      0.0725
    ],
    [
      "capter",
      0.0725
    ],
    [
      "acheminer",
      0.035
    ],
    [
      "aiguiller",
      0.035
    ],
    [
      "centraliser",
      0.035
    ],
    [
      "distribuer",
      0.035
    ],
    [
      "grouper",
      0.035
    ],
    [
      "navigabiliser",
      0.035
    ]
  ],
  "reprocher": [
    [
      "blamer",
      0.1275
    ],
    [
      "critiquer",
      0.115
    ],
    [
      "condamner",
      0.1
    ],
    [
      "reprimander",
      0.1
    ],
    [
      "tancer",
      0.1
    ],
    [
      "censurer",
      0.0575
    ],
    [
      "accuser",
      0.0575
    ],
    [
      "desapprouver",
      0.0425
    ],
    [
      "incriminer",
      0.0425
    ],
    [
      "reprouver",
      0.0425
    ],
    [
      "remontrer",
      0.0275
    ],
    [
      "imputer",
      0.0275
    ],
    [
      "taxer",
      0.0125
    ],
    [
      "stigmatiser",
      0.0125
    ],
    [
      "recuser",
      0.0125
    ],
    [
      "representer",
      0.0125
    ],
    [
      "reprendre",
      0.0125
    ],
    [
      "improuver",
      0.0125
    ],
    [
      "gemir",
      0.0125
    ],
    [
      "desavouer",
      0.0125
    ]
  ],
  "reproche": [
    [
      "semonce",
      0.125
    ],
    [
      "reprimande",
      0.0975
    ],
    [
      "blame",
      0.08
    ],
    [
      "remontrance",
      0.07
    ],
    [
      "requisitoire",
      0.0575
    ],
    [
      "admonestation",
      0.0525
    ],
    [
      "observation",
      0.04
    ],
    [
      "objurgation",
      0.04
    ],
    [
      "critique",
      0.04
    ],
    [
      "reprobation",
      0.035
    ],
    [
      "attrapade",
      0.025
    ],
    [
      "avertissement",
      0.025
    ],
    [
      "mercuriale",
      0.025
    ],
    [
      "savon",
      0.02
    ],
    [
      "representation",
      0.02
    ],
    [
      "remarque",
      0.02
    ],
    [
      "engueulade",
      0.02
    ],
    [
      "censure",
      0.02
    ],
    [
      "accusation",
      0.02
    ],
    [
      "desapprobation",
      0.0175
    ],
    [
      "sortie",
      0.0175
    ],
    [
      "sermon",
      0.0125
    ],
    [
      "plainte",
      0.0125
    ],
    [
      "gronderie",
      0.0125
    ],
    [
      "grief",
      0.0125
    ],
    [
      "recrimination",
      0.0075
    ],
    [
      "objection",
      0.0075
    ],
    [
      "lessivage",
      0.0075
    ],
    [
      "danse",
      0.0075
    ],
    [
      "foudre",
      0.0025
    ],
    [
      "imputation",
      0.0025
    ],
    [
      "prone",
      0.0025
    ],
    [
      "remords",
      0.0025
    ]
  ],
  "moraliser": [
    [
      "sermonner",
      0.265
    ],
    [
      "catechiser",
      0.1325
    ],
    [
      "precher",
      0.1325
    ],
    [
      "reprimander",
      0.1325
    ],
    [
      "tancer",
      0.1325
    ],
    [
      "admonester",
      0.065
    ],
    [
      "corriger",
      0.065
    ],
    [
      "proner",
      0.065
    ]
  ],
  "gazoline": [],
  "communaute": [
    [
      "association",
      0.09
    ],
    [
      "accord",
      0.08
    ],
    [
      "societe",
      0.0725
    ],
    [
      "groupe",
      0.0475
    ],
    [
      "harmonie",
      0.0475
    ],
    [
      "reunion",
      0.0475
    ],
    [
      "similitude",
      0.0475
    ],
    [
      "unite",
      0.04
    ],
    [
      "congregation",
      0.04
    ],
    [
      "conformite",
      0.04
    ],
    [
      "compagnie",
      0.04
    ],
    [
      "affinite",
      0.03
    ],
    [
      "corps",
      0.03
    ],
    [
      "ressemblance",
      0.03
    ],
    [
      "ordre",
      0.0225
    ],
    [
      "nation",
      0.0225
    ],
    [
      "identite",
      0.0225
    ],
    [
      "confrerie",
      0.0225
    ],
    [
      "etat",
      0.015
    ],
    [
      "seminaire",
      0.015
    ],
    [
      "parite",
      0.015
    ],
    [
      "couvent",
      0.015
    ],
    [
      "corporation",
      0.015
    ],
    [
      "communion",
      0.015
    ],
    [
      "collectivite",
      0.015
    ],
    [
      "analogie",
      0.015
    ],
    [
      "pool",
      0.0075
    ],
    [
      "phalanstere",
      0.0075
    ],
    [
      "patrie",
      0.0075
    ],
    [
      "monastere",
      0.0075
    ],
    [
      "indivision",
      0.0075
    ],
    [
      "colonie",
      0.0075
    ],
    [
      "cloitre",
      0.0075
    ],
    [
      "unanimite",
      0.0075
    ]
  ],
  "monopoliser": [
    [
      "accaparer",
      0.1875
    ],
    [
      "s'approprier",
      0.1875
    ],
    [
      "accumuler",
      0.125
    ],
    [
      "s'emparer",
      0.125
    ],
    [
      "s'arroger",
      0.06
    ],
    [
      "s'adjuger",
      0.06
    ],
    [
      "nationaliser",
      0.06
    ],
    [
      "monopoler",
      0.06
    ],
    [
      "affamer",
      0.06
    ],
    [
      "truster",
      0.06
    ]
  ],
  "rancard": [
    [
      "rambour",
      0.285
    ],
    [
      "rambot",
      0.1425
    ],
    [
      "rancart",
      0.1425
    ],
    [
      "renseignement",
      0.1425
    ]
  ],
  "ideologie": [
    [
      "doctrine",
      0.2
    ],
    [
      "pensee",
      0.2
    ],
    [
      "systeme",
      0.2
    ],
    [
      "reve",
      0.1325
    ],
    [
      "dogme",
      0.065
    ],
    [
      "opinion",
      0.065
    ],
    [
      "philosophie",
      0.065
    ],
    [
      "utopie",
      0.065
    ]
  ],
  "recale": [
    [
      "coller",
      0.3325
    ],
    [
      "refuser",
      0.165
    ],
    [
      "eliminer",
      0.165
    ],
    [
      "ajourner",
      0.0825
    ],
    [
      "blackbouler",
      0.0825
    ],
    [
      "retaper",
      0.0825
    ],
    [
      "retoquer",
      0.0825
    ]
  ],
  "recaler": [
    [
      "coller",
      0.3325
    ],
    [
      "refuser",
      0.165
    ],
    [
      "eliminer",
      0.165
    ],
    [
      "ajourner",
      0.0825
    ],
    [
      "blackbouler",
      0.0825
    ],
    [
      "retaper",
      0.0825
    ],
    [
      "retoquer",
      0.0825
    ]
  ],
  "exclu": [
    [
      "exclusivement",
      0.2
    ],
    [
      "expulse",
      0.2
    ],
    [
      "forclos",
      0.2
    ],
    [
      "paria",
      0.2
    ],
    [
      "renvoye",
      0.2
    ]
  ],
  "exclure": [
    [
      "ecarter",
      0.0875
    ],
    [
      "chasser",
      0.075
    ],
    [
      "eliminer",
      0.075
    ],
    [
      "bannir",
      0.0675
    ],
    [
      "supprimer",
      0.055
    ],
    [
      "repousser",
      0.055
    ],
    [
      "renvoyer",
      0.0475
    ],
    [
      "rejeter",
      0.0425
    ],
    [
      "oter",
      0.0425
    ],
    [
      "eloigner",
      0.04
    ],
    [
      "proscrire",
      0.035
    ],
    [
      "expulser",
      0.0325
    ],
    [
      "retrancher",
      0.0325
    ],
    [
      "interdire",
      0.0275
    ],
    [
      "exiler",
      0.02
    ],
    [
      "rayer",
      0.02
    ],
    [
      "refuser",
      0.02
    ],
    [
      "evincer",
      0.015
    ],
    [
      "vider",
      0.015
    ],
    [
      "refouler",
      0.015
    ],
    [
      "excommunier",
      0.015
    ],
    [
      "excepter",
      0.015
    ],
    [
      "empecher",
      0.015
    ],
    [
      "econduire",
      0.01
    ],
    [
      "epurer",
      0.0075
    ],
    [
      "s'opposer",
      0.0075
    ],
    [
      "radier",
      0.0075
    ],
    [
      "prohiber",
      0.0075
    ],
    [
      "limoger",
      0.0075
    ],
    [
      "isoler",
      0.0075
    ],
    [
      "desocialiser",
      0.0025
    ],
    [
      "forclore",
      0.0025
    ]
  ],
  "grossir": [
    [
      "augmenter",
      0.1325
    ],
    [
      "amplifier",
      0.0725
    ],
    [
      "exagerer",
      0.0625
    ],
    [
      "enfler",
      0.0575
    ],
    [
      "gonfler",
      0.0425
    ],
    [
      "rencherir",
      0.04
    ],
    [
      "croitre",
      0.04
    ],
    [
      "agrandir",
      0.0375
    ],
    [
      "accroitre",
      0.0325
    ],
    [
      "grandir",
      0.03
    ],
    [
      "hausser",
      0.0225
    ],
    [
      "forcer",
      0.02
    ],
    [
      "engraisser",
      0.0175
    ],
    [
      "aggraver",
      0.015
    ],
    [
      "developper",
      0.015
    ],
    [
      "majorer",
      0.015
    ],
    [
      "etendre",
      0.0125
    ],
    [
      "surfaire",
      0.0125
    ],
    [
      "s'alourdir",
      0.0125
    ],
    [
      "s'accroitre",
      0.0125
    ],
    [
      "renforcer",
      0.0125
    ],
    [
      "multiplier",
      0.0125
    ],
    [
      "forcir",
      0.0125
    ],
    [
      "charger",
      0.0125
    ],
    [
      "ajouter",
      0.0125
    ],
    [
      "s'elargir",
      0.0125
    ],
    [
      "outrer",
      0.0125
    ],
    [
      "alourdir",
      0.01
    ],
    [
      "elargir",
      0.01
    ],
    [
      "epaissir",
      0.0075
    ],
    [
      "s'etendre",
      0.0075
    ],
    [
      "monter",
      0.0075
    ],
    [
      "enrichir",
      0.0075
    ],
    [
      "dramatiser",
      0.0075
    ],
    [
      "profiter",
      0.005
    ],
    [
      "s'arrondir",
      0.005
    ],
    [
      "s'enrichir",
      0.005
    ],
    [
      "s'engraisser",
      0.005
    ],
    [
      "s'empater",
      0.005
    ],
    [
      "s'amplifier",
      0.005
    ],
    [
      "fructifier",
      0.005
    ],
    [
      "arrondir",
      0.005
    ],
    [
      "s'intensifier",
      0.0025
    ],
    [
      "s'enfler",
      0.0025
    ],
    [
      "nourrir",
      0.0025
    ],
    [
      "enforcir",
      0.0025
    ],
    [
      "dilater",
      0.0025
    ],
    [
      "broder",
      0.0025
    ],
    [
      "bouffir",
      0.0025
    ],
    [
      "s'etoffer",
      0.0
    ],
    [
      "s'epaissir",
      0.0
    ],
    [
      "s'ajouter",
      0.0
    ],
    [
      "bedonner",
      0.0
    ],
    [
      "souffler",
      0.0
    ]
  ],
  "inventaire": [
    [
      "catalogue",
      0.1125
    ],
    [
      "denombrement",
      0.1125
    ],
    [
      "liste",
      0.1125
    ],
    [
      "revue",
      0.1125
    ],
    [
      "etat",
      0.095
    ],
    [
      "tableau",
      0.08
    ],
    [
      "repertoire",
      0.08
    ],
    [
      "enumeration",
      0.0625
    ],
    [
      "recensement",
      0.0475
    ],
    [
      "releve",
      0.03
    ],
    [
      "bilan",
      0.03
    ],
    [
      "arsenal",
      0.015
    ],
    [
      "enregistrement",
      0.015
    ],
    [
      "nomenclature",
      0.015
    ],
    [
      "pesee",
      0.015
    ],
    [
      "recapitulation",
      0.015
    ],
    [
      "table",
      0.015
    ],
    [
      "evaluation",
      0.015
    ]
  ],
  "plombe": [
    [
      "cacheter",
      0.1
    ],
    [
      "syphiliser",
      0.1
    ],
    [
      "sceller",
      0.1
    ],
    [
      "presser",
      0.1
    ],
    [
      "pourrir",
      0.1
    ],
    [
      "poivrer",
      0.1
    ],
    [
      "obturer",
      0.1
    ],
    [
      "lester",
      0.1
    ],
    [
      "ferrer",
      0.1
    ],
    [
      "veroler",
      0.1
    ]
  ],
  "nombre": [
    [
      "quantite",
      0.0875
    ],
    [
      "total",
      0.0875
    ],
    [
      "rythme",
      0.0575
    ],
    [
      "rang",
      0.0575
    ],
    [
      "masse",
      0.0575
    ],
    [
      "harmonie",
      0.0575
    ],
    [
      "foule",
      0.0575
    ],
    [
      "chiffre",
      0.0575
    ],
    [
      "cadence",
      0.0575
    ],
    [
      "unite",
      0.0275
    ],
    [
      "symbole",
      0.0275
    ],
    [
      "quorum",
      0.0275
    ],
    [
      "quantieme",
      0.0275
    ],
    [
      "peuple",
      0.0275
    ],
    [
      "numero",
      0.0275
    ],
    [
      "multitude",
      0.0275
    ],
    [
      "liste",
      0.0275
    ],
    [
      "frequence",
      0.0275
    ],
    [
      "effectif",
      0.0275
    ],
    [
      "compte",
      0.0275
    ],
    [
      "collection",
      0.0275
    ],
    [
      "beaucoup",
      0.0275
    ],
    [
      "vers",
      0.0275
    ]
  ],
  "retomber": [
    [
      "revenir",
      0.1525
    ],
    [
      "tomber",
      0.115
    ],
    [
      "recidiver",
      0.075
    ],
    [
      "retourner",
      0.075
    ],
    [
      "peser",
      0.075
    ],
    [
      "pendiller",
      0.075
    ],
    [
      "incomber",
      0.075
    ],
    [
      "ricocher",
      0.0375
    ],
    [
      "rejaillir",
      0.0375
    ],
    [
      "redonner",
      0.0375
    ],
    [
      "redescendre",
      0.0375
    ],
    [
      "recommencer",
      0.0375
    ],
    [
      "rechuter",
      0.0375
    ],
    [
      "pendre",
      0.0375
    ],
    [
      "trainer",
      0.0375
    ]
  ],
  "retombe": [
    [
      "revenir",
      0.1525
    ],
    [
      "tomber",
      0.115
    ],
    [
      "recidiver",
      0.075
    ],
    [
      "retourner",
      0.075
    ],
    [
      "peser",
      0.075
    ],
    [
      "pendiller",
      0.075
    ],
    [
      "incomber",
      0.075
    ],
    [
      "ricocher",
      0.0375
    ],
    [
      "rejaillir",
      0.0375
    ],
    [
      "redonner",
      0.0375
    ],
    [
      "redescendre",
      0.0375
    ],
    [
      "recommencer",
      0.0375
    ],
    [
      "rechuter",
      0.0375
    ],
    [
      "pendre",
      0.0375
    ],
    [
      "trainer",
      0.0375
    ]
  ],
  "obstinement": [
    [
      "opiniatrement",
      0.3325
    ],
    [
      "assidument",
      0.165
    ],
    [
      "aveuglement",
      0.165
    ],
    [
      "mordicus",
      0.165
    ],
    [
      "resolument",
      0.165
    ]
  ],
  "depart": [
    [
      "origine",
      0.0825
    ],
    [
      "commencement",
      0.07
    ],
    [
      "debut",
      0.07
    ],
    [
      "separation",
      0.07
    ],
    [
      "eloignement",
      0.055
    ],
    [
      "seuil",
      0.055
    ],
    [
      "difference",
      0.04
    ],
    [
      "principe",
      0.04
    ],
    [
      "evacuation",
      0.0275
    ],
    [
      "germe",
      0.0275
    ],
    [
      "demarrage",
      0.0275
    ],
    [
      "distinction",
      0.0275
    ],
    [
      "absence",
      0.0275
    ],
    [
      "exode",
      0.0125
    ],
    [
      "expedition",
      0.0125
    ],
    [
      "lancement",
      0.0125
    ],
    [
      "licenciement",
      0.0125
    ],
    [
      "limogeage",
      0.0125
    ],
    [
      "marge",
      0.0125
    ],
    [
      "naissance",
      0.0125
    ],
    [
      "partance",
      0.0125
    ],
    [
      "point",
      0.0125
    ],
    [
      "sortie",
      0.0125
    ],
    [
      "tri",
      0.0125
    ],
    [
      "triage",
      0.0125
    ],
    [
      "vidage",
      0.0125
    ],
    [
      "exil",
      0.0125
    ],
    [
      "envol",
      0.0125
    ],
    [
      "amont",
      0.0125
    ],
    [
      "amorce",
      0.0125
    ],
    [
      "appareillage",
      0.0125
    ],
    [
      "bourgeonnement",
      0.0125
    ],
    [
      "cause",
      0.0125
    ],
    [
      "congediement",
      0.0125
    ],
    [
      "discrimination",
      0.0125
    ],
    [
      "disparition",
      0.0125
    ],
    [
      "decollage",
      0.0125
    ],
    [
      "demission",
      0.0125
    ],
    [
      "embarquement",
      0.0125
    ],
    [
      "envoi",
      0.0125
    ],
    [
      "allumage",
      0.0125
    ]
  ],
  "distiller": [
    [
      "secreter",
      0.125
    ],
    [
      "raffiner",
      0.0825
    ],
    [
      "suinter",
      0.0825
    ],
    [
      "epancher",
      0.0825
    ],
    [
      "epurer",
      0.0825
    ],
    [
      "reduire",
      0.04
    ],
    [
      "repandre",
      0.04
    ],
    [
      "spiritualiser",
      0.04
    ],
    [
      "sublimer",
      0.04
    ],
    [
      "suppurer",
      0.04
    ],
    [
      "rectifier",
      0.04
    ],
    [
      "quintessencier",
      0.04
    ],
    [
      "extraire",
      0.04
    ],
    [
      "exsuder",
      0.04
    ],
    [
      "degoutter",
      0.04
    ],
    [
      "condenser",
      0.04
    ],
    [
      "cohober",
      0.04
    ],
    [
      "vaporiser",
      0.04
    ]
  ],
  "etonne": [
    [
      "stupefier",
      0.075
    ],
    [
      "abasourdir",
      0.065
    ],
    [
      "ebahir",
      0.0625
    ],
    [
      "ahurir",
      0.055
    ],
    [
      "confondre",
      0.055
    ],
    [
      "siderer",
      0.05
    ],
    [
      "deconcerter",
      0.05
    ],
    [
      "surprendre",
      0.045
    ],
    [
      "interloquer",
      0.035
    ],
    [
      "meduser",
      0.035
    ],
    [
      "petrifier",
      0.035
    ],
    [
      "troubler",
      0.03
    ],
    [
      "renverser",
      0.03
    ],
    [
      "interdire",
      0.03
    ],
    [
      "epater",
      0.025
    ],
    [
      "frapper",
      0.0225
    ],
    [
      "saisir",
      0.0225
    ],
    [
      "eblouir",
      0.02
    ],
    [
      "foudroyer",
      0.02
    ],
    [
      "estomaquer",
      0.02
    ],
    [
      "derouter",
      0.015
    ],
    [
      "etourdir",
      0.015
    ],
    [
      "epoustoufler",
      0.0125
    ],
    [
      "impressionner",
      0.0125
    ],
    [
      "effarer",
      0.0125
    ],
    [
      "bouleverser",
      0.0125
    ],
    [
      "assommer",
      0.01
    ],
    [
      "decontenancer",
      0.01
    ],
    [
      "suffoquer",
      0.01
    ],
    [
      "ecraser",
      0.01
    ],
    [
      "ebouriffer",
      0.005
    ],
    [
      "eberluer",
      0.005
    ],
    [
      "transir",
      0.005
    ],
    [
      "terroriser",
      0.005
    ],
    [
      "desorienter",
      0.005
    ],
    [
      "ebaubir",
      0.0025
    ],
    [
      "stupefaire",
      0.0025
    ],
    [
      "scier",
      0.0025
    ],
    [
      "heurter",
      0.0025
    ],
    [
      "esbroufer",
      0.0025
    ],
    [
      "depasser",
      0.0025
    ],
    [
      "assourdir",
      0.0025
    ],
    [
      "emerveiller",
      0.0025
    ]
  ],
  "mirador": [
    [
      "balcon",
      0.3325
    ],
    [
      "belvedere",
      0.3325
    ],
    [
      "observatoire",
      0.3325
    ]
  ],
  "policier": [
    [
      "agent",
      0.205
    ],
    [
      "espion",
      0.095
    ],
    [
      "limier",
      0.0625
    ],
    [
      "cogne",
      0.0475
    ],
    [
      "flic",
      0.0475
    ],
    [
      "gardien",
      0.0475
    ],
    [
      "poulet",
      0.0475
    ],
    [
      "inspecteur",
      0.03
    ],
    [
      "gendarme",
      0.03
    ],
    [
      "chien",
      0.03
    ],
    [
      "bourre",
      0.03
    ],
    [
      "argousin",
      0.03
    ],
    [
      "hirondelle",
      0.0125
    ],
    [
      "indicateur",
      0.0125
    ],
    [
      "perdreau",
      0.0125
    ],
    [
      "policeman",
      0.0125
    ],
    [
      "politique",
      0.0125
    ],
    [
      "poulaga",
      0.0125
    ],
    [
      "roussin",
      0.0125
    ],
    [
      "sbire",
      0.0125
    ],
    [
      "detective",
      0.0125
    ],
    [
      "C.R.S.",
      0.0125
    ],
    [
      "arguo",
      0.0125
    ],
    [
      "argus",
      0.0125
    ],
    [
      "barbouze",
      0.0125
    ],
    [
      "bourgeois",
      0.0125
    ],
    [
      "bourrique",
      0.0125
    ],
    [
      "commissaire",
      0.0125
    ],
    [
      "vache",
      0.0125
    ]
  ],
  "entrant": [
    [
      "penetrer",
      0.1
    ],
    [
      "s'engager",
      0.045
    ],
    [
      "s'introduire",
      0.045
    ],
    [
      "s'insinuer",
      0.04
    ],
    [
      "s'engouffrer",
      0.04
    ],
    [
      "s'enfoncer",
      0.04
    ],
    [
      "prendre",
      0.04
    ],
    [
      "monter",
      0.04
    ],
    [
      "rentrer",
      0.035
    ],
    [
      "passer",
      0.035
    ],
    [
      "embrasser",
      0.035
    ],
    [
      "tenir",
      0.0225
    ],
    [
      "introduire",
      0.0225
    ],
    [
      "enfoncer",
      0.0225
    ],
    [
      "arriver",
      0.0225
    ],
    [
      "aller",
      0.0225
    ],
    [
      "adherer",
      0.0225
    ],
    [
      "venir",
      0.015
    ],
    [
      "parvenir",
      0.015
    ],
    [
      "integrer",
      0.015
    ],
    [
      "forcer",
      0.015
    ],
    [
      "envahir",
      0.015
    ],
    [
      "comprendre",
      0.015
    ],
    [
      "acceder",
      0.015
    ],
    [
      "s'installer",
      0.01
    ],
    [
      "planter",
      0.01
    ],
    [
      "percuter",
      0.01
    ],
    [
      "participer",
      0.01
    ],
    [
      "inserer",
      0.01
    ],
    [
      "enfiler",
      0.01
    ],
    [
      "aborder",
      0.01
    ],
    [
      "s'ingerer",
      0.0025
    ],
    [
      "s'inscrire",
      0.0025
    ],
    [
      "epouser",
      0.0025
    ],
    [
      "s'incruster",
      0.0025
    ],
    [
      "s'incorporer",
      0.0025
    ],
    [
      "s'enfiler",
      0.0025
    ],
    [
      "s'affilier",
      0.0025
    ],
    [
      "ficher",
      0.0025
    ],
    [
      "considerer",
      0.0025
    ],
    [
      "accoster",
      0.0025
    ]
  ],
  "taille": [
    [
      "dimension",
      0.12
    ],
    [
      "grandeur",
      0.0825
    ],
    [
      "stature",
      0.07
    ],
    [
      "gabarit",
      0.0575
    ],
    [
      "elagage",
      0.035
    ],
    [
      "port",
      0.035
    ],
    [
      "mesure",
      0.035
    ],
    [
      "tournure",
      0.0225
    ],
    [
      "taxe",
      0.0225
    ],
    [
      "retranchement",
      0.0225
    ],
    [
      "prestance",
      0.0225
    ],
    [
      "mine",
      0.0225
    ],
    [
      "hauteur",
      0.0225
    ],
    [
      "grosseur",
      0.0225
    ],
    [
      "format",
      0.0225
    ],
    [
      "envergure",
      0.0225
    ],
    [
      "carrure",
      0.0225
    ],
    [
      "calibre",
      0.0225
    ],
    [
      "tenette",
      0.01
    ],
    [
      "taillis",
      0.01
    ],
    [
      "taillage",
      0.01
    ],
    [
      "rognage",
      0.01
    ],
    [
      "ravalement",
      0.01
    ],
    [
      "tonte",
      0.01
    ],
    [
      "torse",
      0.01
    ],
    [
      "tranchant",
      0.01
    ],
    [
      "echelle",
      0.01
    ],
    [
      "emondage",
      0.01
    ],
    [
      "emondement",
      0.01
    ],
    [
      "etetage",
      0.01
    ],
    [
      "proportions",
      0.01
    ],
    [
      "pointure",
      0.01
    ],
    [
      "cambrure",
      0.01
    ],
    [
      "ceinture",
      0.01
    ],
    [
      "charpente",
      0.01
    ],
    [
      "coupe",
      0.01
    ],
    [
      "croissance",
      0.01
    ],
    [
      "galerie",
      0.01
    ],
    [
      "gravure",
      0.01
    ],
    [
      "importance",
      0.01
    ],
    [
      "impot",
      0.01
    ],
    [
      "longueur",
      0.01
    ],
    [
      "pincement",
      0.01
    ],
    [
      "appareil",
      0.01
    ]
  ],
  "twister": [
    [
      "danser",
      1.0
    ]
  ],
  "fluo": [],
  "confluer": [
    [
      "affluer",
      0.1575
    ],
    [
      "converger",
      0.1575
    ],
    [
      "s'unir",
      0.05
    ],
    [
      "rejoindre",
      0.05
    ],
    [
      "couler",
      0.05
    ],
    [
      "tendre",
      0.05
    ]
  ],
  "confluent": [
    [
      "croisement",
      0.18
    ],
    [
      "jonction",
      0.18
    ],
    [
      "affluent",
      0.09
    ],
    [
      "bec",
      0.09
    ],
    [
      "carrefour",
      0.09
    ],
    [
      "concourant",
      0.09
    ],
    [
      "convergent",
      0.09
    ],
    [
      "croisee",
      0.09
    ],
    [
      "rencontre",
      0.09
    ]
  ],
  "transport": [
    [
      "exaltation",
      0.1025
    ],
    [
      "enthousiasme",
      0.065
    ],
    [
      "ardeur",
      0.0575
    ],
    [
      "passion",
      0.0525
    ],
    [
      "excitation",
      0.03
    ],
    [
      "chaleur",
      0.03
    ],
    [
      "agitation",
      0.0275
    ],
    [
      "delire",
      0.025
    ],
    [
      "fureur",
      0.025
    ],
    [
      "ivresse",
      0.025
    ],
    [
      "elan",
      0.0225
    ],
    [
      "mouvement",
      0.0225
    ],
    [
      "emportement",
      0.0225
    ],
    [
      "fievre",
      0.02
    ],
    [
      "emotion",
      0.02
    ],
    [
      "emballement",
      0.0175
    ],
    [
      "flamme",
      0.0175
    ],
    [
      "fougue",
      0.0175
    ],
    [
      "impetuosite",
      0.0175
    ],
    [
      "ravissement",
      0.015
    ],
    [
      "commerce",
      0.015
    ],
    [
      "circulation",
      0.0125
    ],
    [
      "communication",
      0.0125
    ],
    [
      "transe",
      0.0125
    ],
    [
      "voyage",
      0.01
    ],
    [
      "passage",
      0.01
    ],
    [
      "joie",
      0.01
    ],
    [
      "extase",
      0.01
    ],
    [
      "transmission",
      0.0075
    ],
    [
      "trafic",
      0.0075
    ],
    [
      "surexcitation",
      0.0075
    ],
    [
      "soulevement",
      0.0075
    ],
    [
      "rage",
      0.0075
    ],
    [
      "exultation",
      0.0075
    ],
    [
      "expedition",
      0.0075
    ],
    [
      "allegresse",
      0.0075
    ],
    [
      "vertige",
      0.005
    ],
    [
      "transfert",
      0.005
    ],
    [
      "train",
      0.005
    ],
    [
      "port",
      0.005
    ],
    [
      "exportation",
      0.005
    ],
    [
      "expansion",
      0.005
    ],
    [
      "enivrement",
      0.005
    ],
    [
      "effusion",
      0.005
    ],
    [
      "dechainement",
      0.005
    ],
    [
      "crise",
      0.005
    ],
    [
      "transit",
      0.0025
    ],
    [
      "translation",
      0.0025
    ],
    [
      "visite",
      0.0025
    ],
    [
      "echange",
      0.0025
    ],
    [
      "manifestation",
      0.0025
    ],
    [
      "demonstration",
      0.0025
    ],
    [
      "descente",
      0.0025
    ],
    [
      "charroi",
      0.0025
    ],
    [
      "alacrite",
      0.0025
    ],
    [
      "admiration",
      0.0025
    ],
    [
      "manutention",
      0.0
    ],
    [
      "logistique",
      0.0
    ],
    [
      "locomotion",
      0.0
    ],
    [
      "importation",
      0.0
    ],
    [
      "messagerie",
      0.0
    ],
    [
      "portage",
      0.0
    ],
    [
      "poste",
      0.0
    ],
    [
      "route",
      0.0
    ],
    [
      "traite",
      0.0
    ],
    [
      "transbordement",
      0.0
    ],
    [
      "transferement",
      0.0
    ],
    [
      "factage",
      0.0
    ],
    [
      "demenagement",
      0.0
    ],
    [
      "acheminement",
      0.0
    ],
    [
      "air",
      0.0
    ],
    [
      "attendrissement",
      0.0
    ],
    [
      "aviation",
      0.0
    ],
    [
      "avion",
      0.0
    ],
    [
      "bateau",
      0.0
    ],
    [
      "bouillon",
      0.0
    ],
    [
      "camionnage",
      0.0
    ],
    [
      "cession",
      0.0
    ],
    [
      "charriage",
      0.0
    ],
    [
      "delegation",
      0.0
    ],
    [
      "voiture",
      0.0
    ]
  ],
  "deriver": [
    [
      "proceder",
      0.0875
    ],
    [
      "venir",
      0.0875
    ],
    [
      "emaner",
      0.065
    ],
    [
      "tirer",
      0.065
    ],
    [
      "incliner",
      0.065
    ],
    [
      "devier",
      0.065
    ],
    [
      "decouler",
      0.065
    ],
    [
      "aller",
      0.065
    ],
    [
      "tourner",
      0.0425
    ],
    [
      "provenir",
      0.0425
    ],
    [
      "orienter",
      0.0425
    ],
    [
      "inflechir",
      0.0425
    ],
    [
      "detourner",
      0.0425
    ],
    [
      "attirer",
      0.0425
    ],
    [
      "deriveter",
      0.02
    ],
    [
      "deplacer",
      0.02
    ],
    [
      "defaire",
      0.02
    ],
    [
      "drosser",
      0.02
    ]
  ],
  "blaguer": [
    [
      "plaisanter",
      0.1725
    ],
    [
      "railler",
      0.085
    ],
    [
      "rire",
      0.07
    ],
    [
      "taquiner",
      0.0575
    ],
    [
      "mentir",
      0.0425
    ],
    [
      "jouer",
      0.0425
    ],
    [
      "galejer",
      0.0425
    ],
    [
      "chiner",
      0.0425
    ],
    [
      "charrier",
      0.0425
    ],
    [
      "badiner",
      0.0425
    ],
    [
      "romancer",
      0.0275
    ],
    [
      "rigoler",
      0.0275
    ],
    [
      "habler",
      0.0275
    ],
    [
      "exagerer",
      0.0275
    ],
    [
      "chahuter",
      0.0275
    ],
    [
      "brocarder",
      0.0275
    ],
    [
      "ironiser",
      0.0125
    ],
    [
      "converser",
      0.0125
    ],
    [
      "causer",
      0.0125
    ],
    [
      "bavarder",
      0.0125
    ],
    [
      "asticoter",
      0.0125
    ]
  ],
  "blague": [
    [
      "plaisanterie",
      0.09
    ],
    [
      "farce",
      0.07
    ],
    [
      "mensonge",
      0.06
    ],
    [
      "betise",
      0.0575
    ],
    [
      "canular",
      0.04
    ],
    [
      "facetie",
      0.04
    ],
    [
      "bateau",
      0.035
    ],
    [
      "attrape",
      0.035
    ],
    [
      "boniment",
      0.0325
    ],
    [
      "bourde",
      0.0325
    ],
    [
      "conte",
      0.0325
    ],
    [
      "mystification",
      0.0325
    ],
    [
      "hablerie",
      0.0275
    ],
    [
      "galejade",
      0.0225
    ],
    [
      "histoire",
      0.02
    ],
    [
      "rodomontade",
      0.02
    ],
    [
      "sornette",
      0.02
    ],
    [
      "sottise",
      0.015
    ],
    [
      "propos",
      0.015
    ],
    [
      "craque",
      0.015
    ],
    [
      "bevue",
      0.015
    ],
    [
      "tour",
      0.01
    ],
    [
      "maladresse",
      0.01
    ],
    [
      "impair",
      0.01
    ],
    [
      "gaffe",
      0.01
    ],
    [
      "fumisterie",
      0.01
    ],
    [
      "faute",
      0.01
    ],
    [
      "fable",
      0.01
    ],
    [
      "bouffonnerie",
      0.01
    ],
    [
      "bobard",
      0.01
    ],
    [
      "bluff",
      0.01
    ],
    [
      "balourdise",
      0.01
    ],
    [
      "gausse",
      0.0075
    ],
    [
      "malice",
      0.0075
    ],
    [
      "niche",
      0.0075
    ],
    [
      "rigolade",
      0.0075
    ],
    [
      "vanne",
      0.0075
    ],
    [
      "frime",
      0.0075
    ],
    [
      "exageration",
      0.0075
    ],
    [
      "erreur",
      0.0075
    ],
    [
      "charge",
      0.0075
    ],
    [
      "boulette",
      0.0075
    ],
    [
      "badinage",
      0.0075
    ],
    [
      "astuce",
      0.0075
    ],
    [
      "poche",
      0.0025
    ],
    [
      "imposture",
      0.0025
    ],
    [
      "gag",
      0.0025
    ],
    [
      "faconde",
      0.0025
    ],
    [
      "drolerie",
      0.0025
    ]
  ],
  "douze": [],
  "sordide": [
    [
      "degoutant",
      0.0925
    ],
    [
      "repugnant",
      0.0925
    ],
    [
      "ignoble",
      0.0825
    ],
    [
      "malpropre",
      0.07
    ],
    [
      "immonde",
      0.0625
    ],
    [
      "abject",
      0.0625
    ],
    [
      "infame",
      0.06
    ],
    [
      "infect",
      0.0475
    ],
    [
      "sale",
      0.0425
    ],
    [
      "nauseabond",
      0.0375
    ],
    [
      "bas",
      0.0375
    ],
    [
      "obscene",
      0.035
    ],
    [
      "grossier",
      0.0325
    ],
    [
      "impur",
      0.025
    ],
    [
      "vil",
      0.0225
    ],
    [
      "ordurier",
      0.0225
    ],
    [
      "innommable",
      0.015
    ],
    [
      "fetide",
      0.0125
    ],
    [
      "inconvenant",
      0.0125
    ],
    [
      "puant",
      0.01
    ],
    [
      "indecent",
      0.01
    ],
    [
      "immoral",
      0.01
    ],
    [
      "cochon",
      0.01
    ],
    [
      "ignominieux",
      0.0075
    ],
    [
      "ecoeurant",
      0.0075
    ],
    [
      "malhonnete",
      0.005
    ],
    [
      "pouilleux",
      0.0025
    ],
    [
      "nauseeux",
      0.0025
    ],
    [
      "mesquin",
      0.0025
    ],
    [
      "joli",
      0.0025
    ],
    [
      "hideux",
      0.0025
    ],
    [
      "crasseux",
      0.0025
    ],
    [
      "chiche",
      0.0025
    ],
    [
      "avare",
      0.0025
    ],
    [
      "misereux",
      0.0
    ],
    [
      "macule",
      0.0
    ],
    [
      "guenilleux",
      0.0
    ],
    [
      "glauque",
      0.0
    ],
    [
      "galeux",
      0.0
    ],
    [
      "crapuleux",
      0.0
    ],
    [
      "turpide",
      0.0
    ]
  ],
  "brusquement": [
    [
      "soudainement",
      0.1
    ],
    [
      "subito",
      0.08
    ],
    [
      "subitement",
      0.08
    ],
    [
      "brutalement",
      0.08
    ],
    [
      "abruptement",
      0.06
    ],
    [
      "inopinement",
      0.06
    ],
    [
      "vite",
      0.04
    ],
    [
      "soudain",
      0.04
    ],
    [
      "precipitamment",
      0.04
    ],
    [
      "nerveusement",
      0.0175
    ],
    [
      "net",
      0.0175
    ],
    [
      "sechement",
      0.0175
    ]
  ],
  "rattraper": [
    [
      "retrouver",
      0.145
    ],
    [
      "recouvrer",
      0.0875
    ],
    [
      "reprendre",
      0.0875
    ],
    [
      "recuperer",
      0.0875
    ],
    [
      "reparer",
      0.0875
    ],
    [
      "rejoindre",
      0.0575
    ],
    [
      "regagner",
      0.0575
    ],
    [
      "ressaisir",
      0.0275
    ],
    [
      "replatrer",
      0.0275
    ],
    [
      "repincer",
      0.0275
    ],
    [
      "relever",
      0.0275
    ],
    [
      "ravoir",
      0.0275
    ],
    [
      "ratteindre",
      0.0275
    ],
    [
      "racheter",
      0.0275
    ],
    [
      "poursuivre",
      0.0275
    ],
    [
      "depister",
      0.0275
    ],
    [
      "compenser",
      0.0275
    ],
    [
      "attraper",
      0.0275
    ],
    [
      "atteindre",
      0.0275
    ],
    [
      "reduire",
      0.0275
    ]
  ],
  "pointille": [
    [
      "piqueter",
      0.165
    ],
    [
      "marquer",
      0.1225
    ],
    [
      "piquer",
      0.1225
    ],
    [
      "tracer",
      0.0825
    ],
    [
      "tacheter",
      0.0825
    ],
    [
      "pointer",
      0.0825
    ],
    [
      "ergoter",
      0.0825
    ],
    [
      "chicaner",
      0.0825
    ],
    [
      "contester",
      0.04
    ],
    [
      "poindre",
      0.04
    ],
    [
      "ponctuer",
      0.04
    ],
    [
      "vetiller",
      0.04
    ]
  ],
  "pointiller": [
    [
      "piqueter",
      0.165
    ],
    [
      "marquer",
      0.1225
    ],
    [
      "piquer",
      0.1225
    ],
    [
      "tracer",
      0.0825
    ],
    [
      "tacheter",
      0.0825
    ],
    [
      "pointer",
      0.0825
    ],
    [
      "ergoter",
      0.0825
    ],
    [
      "chicaner",
      0.0825
    ],
    [
      "contester",
      0.04
    ],
    [
      "poindre",
      0.04
    ],
    [
      "ponctuer",
      0.04
    ],
    [
      "vetiller",
      0.04
    ]
  ],
  "nier": [
    [
      "contester",
      0.1225
    ],
    [
      "contredire",
      0.08
    ],
    [
      "desavouer",
      0.08
    ],
    [
      "refuser",
      0.08
    ],
    [
      "refuter",
      0.08
    ],
    [
      "denier",
      0.06
    ],
    [
      "dementir",
      0.06
    ],
    [
      "discuter",
      0.06
    ],
    [
      "rejeter",
      0.04
    ],
    [
      "disputer",
      0.04
    ],
    [
      "critiquer",
      0.04
    ],
    [
      "disconvenir",
      0.0175
    ],
    [
      "demonter",
      0.0175
    ],
    [
      "renier",
      0.0175
    ]
  ],
  "depraver": [
    [
      "corrompre",
      0.145
    ],
    [
      "degrader",
      0.125
    ],
    [
      "gater",
      0.0925
    ],
    [
      "pervertir",
      0.0775
    ],
    [
      "alterer",
      0.065
    ],
    [
      "avilir",
      0.0575
    ],
    [
      "denaturer",
      0.0525
    ],
    [
      "frelater",
      0.0375
    ],
    [
      "fausser",
      0.0325
    ],
    [
      "fletrir",
      0.0325
    ],
    [
      "vicier",
      0.0325
    ],
    [
      "prostituer",
      0.025
    ],
    [
      "perdre",
      0.025
    ],
    [
      "deformer",
      0.025
    ],
    [
      "abaisser",
      0.025
    ],
    [
      "devoyer",
      0.0175
    ],
    [
      "gangrener",
      0.0175
    ],
    [
      "pourrir",
      0.0175
    ],
    [
      "profaner",
      0.0125
    ],
    [
      "deteriorer",
      0.0125
    ],
    [
      "debaucher",
      0.0125
    ],
    [
      "abatardir",
      0.0125
    ],
    [
      "acheter",
      0.005
    ],
    [
      "deregler",
      0.005
    ],
    [
      "ravaler",
      0.005
    ]
  ],
  "deprave": [
    [
      "corrompre",
      0.145
    ],
    [
      "degrader",
      0.125
    ],
    [
      "gater",
      0.0925
    ],
    [
      "pervertir",
      0.0775
    ],
    [
      "alterer",
      0.065
    ],
    [
      "avilir",
      0.0575
    ],
    [
      "denaturer",
      0.0525
    ],
    [
      "frelater",
      0.0375
    ],
    [
      "fausser",
      0.0325
    ],
    [
      "fletrir",
      0.0325
    ],
    [
      "vicier",
      0.0325
    ],
    [
      "prostituer",
      0.025
    ],
    [
      "perdre",
      0.025
    ],
    [
      "deformer",
      0.025
    ],
    [
      "abaisser",
      0.025
    ],
    [
      "devoyer",
      0.0175
    ],
    [
      "gangrener",
      0.0175
    ],
    [
      "pourrir",
      0.0175
    ],
    [
      "profaner",
      0.0125
    ],
    [
      "deteriorer",
      0.0125
    ],
    [
      "debaucher",
      0.0125
    ],
    [
      "abatardir",
      0.0125
    ],
    [
      "acheter",
      0.005
    ],
    [
      "deregler",
      0.005
    ],
    [
      "ravaler",
      0.005
    ]
  ],
  "ricaner": [
    [
      "ricasser",
      0.5
    ],
    [
      "rire",
      0.5
    ]
  ],
  "mysterieux": [
    [
      "impenetrable",
      0.0925
    ],
    [
      "obscur",
      0.0925
    ],
    [
      "secret",
      0.08
    ],
    [
      "tenebreux",
      0.0725
    ],
    [
      "enigmatique",
      0.065
    ],
    [
      "sibyllin",
      0.065
    ],
    [
      "nebuleux",
      0.045
    ],
    [
      "cache",
      0.04
    ],
    [
      "insaisissable",
      0.0375
    ],
    [
      "incomprehensible",
      0.03
    ],
    [
      "esoterique",
      0.0275
    ],
    [
      "inintelligible",
      0.0275
    ],
    [
      "difficile",
      0.0275
    ],
    [
      "hermetique",
      0.0225
    ],
    [
      "inexplicable",
      0.0225
    ],
    [
      "inconnu",
      0.015
    ],
    [
      "indechiffrable",
      0.015
    ],
    [
      "voile",
      0.015
    ],
    [
      "etrange",
      0.0125
    ],
    [
      "sourd",
      0.0125
    ],
    [
      "occulte",
      0.0125
    ],
    [
      "cabalistique",
      0.0125
    ],
    [
      "equivoque",
      0.0075
    ],
    [
      "opaque",
      0.0075
    ],
    [
      "louche",
      0.0075
    ],
    [
      "invisible",
      0.0075
    ],
    [
      "indefinissable",
      0.0075
    ],
    [
      "subtil",
      0.005
    ],
    [
      "profond",
      0.005
    ],
    [
      "problematique",
      0.005
    ],
    [
      "magique",
      0.005
    ],
    [
      "inextricable",
      0.005
    ],
    [
      "indiscernable",
      0.005
    ],
    [
      "inconnaissable",
      0.005
    ],
    [
      "renferme",
      0.0025
    ],
    [
      "irreel",
      0.0025
    ],
    [
      "inexplique",
      0.0025
    ],
    [
      "glissant",
      0.0025
    ],
    [
      "fascinant",
      0.0025
    ],
    [
      "different",
      0.0025
    ],
    [
      "cachottier",
      0.0025
    ],
    [
      "augural",
      0.0025
    ],
    [
      "anonyme",
      0.0025
    ],
    [
      "romantique",
      0.0025
    ]
  ],
  "epreuve": [
    [
      "malheur",
      0.08
    ],
    [
      "affliction",
      0.0725
    ],
    [
      "tribulation",
      0.05
    ],
    [
      "douleur",
      0.045
    ],
    [
      "peine",
      0.04
    ],
    [
      "calamite",
      0.035
    ],
    [
      "mal",
      0.03
    ],
    [
      "tristesse",
      0.0275
    ],
    [
      "souffrance",
      0.0275
    ],
    [
      "ennui",
      0.0275
    ],
    [
      "deuil",
      0.0275
    ],
    [
      "rencontre",
      0.0225
    ],
    [
      "traverse",
      0.0225
    ],
    [
      "evenement",
      0.0175
    ],
    [
      "revers",
      0.0175
    ],
    [
      "experience",
      0.0175
    ],
    [
      "examen",
      0.0175
    ],
    [
      "essai",
      0.0175
    ],
    [
      "catastrophe",
      0.0175
    ],
    [
      "attaque",
      0.0175
    ],
    [
      "test",
      0.0125
    ],
    [
      "match",
      0.0125
    ],
    [
      "deboire",
      0.0125
    ],
    [
      "coup",
      0.0125
    ],
    [
      "competition",
      0.0125
    ],
    [
      "aventure",
      0.0125
    ],
    [
      "danger",
      0.0075
    ],
    [
      "devoir",
      0.0075
    ],
    [
      "heurt",
      0.0075
    ],
    [
      "interrogation",
      0.0075
    ],
    [
      "maladie",
      0.0075
    ],
    [
      "misere",
      0.0075
    ],
    [
      "peril",
      0.0075
    ],
    [
      "verification",
      0.0075
    ],
    [
      "croix",
      0.0075
    ],
    [
      "criterium",
      0.0075
    ],
    [
      "adversite",
      0.0075
    ],
    [
      "apprentissage",
      0.0075
    ],
    [
      "atteinte",
      0.0075
    ],
    [
      "brimade",
      0.0075
    ],
    [
      "calvaire",
      0.0075
    ],
    [
      "cliche",
      0.0075
    ],
    [
      "composition",
      0.0075
    ],
    [
      "copie",
      0.0075
    ],
    [
      "fatigue",
      0.0025
    ],
    [
      "initiation",
      0.0025
    ],
    [
      "morasse",
      0.0025
    ],
    [
      "negatif",
      0.0025
    ],
    [
      "persecution",
      0.0025
    ],
    [
      "photographie",
      0.0025
    ],
    [
      "phototype",
      0.0025
    ],
    [
      "placard",
      0.0025
    ],
    [
      "question",
      0.0025
    ],
    [
      "experimentation",
      0.0025
    ],
    [
      "exemplaire",
      0.0025
    ],
    [
      "assaut",
      0.0025
    ],
    [
      "audition",
      0.0025
    ],
    [
      "berne",
      0.0025
    ],
    [
      "bizutage",
      0.0025
    ],
    [
      "boulet",
      0.0025
    ],
    [
      "caillou",
      0.0025
    ],
    [
      "canular",
      0.0025
    ],
    [
      "challenge",
      0.0025
    ],
    [
      "critere",
      0.0025
    ],
    [
      "dechirement",
      0.0025
    ],
    [
      "eventualite",
      0.0025
    ]
  ],
  "dispute": [
    [
      "querelle",
      0.0975
    ],
    [
      "discussion",
      0.075
    ],
    [
      "desaccord",
      0.055
    ],
    [
      "contestation",
      0.0475
    ],
    [
      "conflit",
      0.0375
    ],
    [
      "altercation",
      0.0325
    ],
    [
      "chicane",
      0.0325
    ],
    [
      "discorde",
      0.0275
    ],
    [
      "differend",
      0.025
    ],
    [
      "combat",
      0.025
    ],
    [
      "bataille",
      0.025
    ],
    [
      "guerre",
      0.0225
    ],
    [
      "dissension",
      0.02
    ],
    [
      "bisbille",
      0.0175
    ],
    [
      "mesintelligence",
      0.0175
    ],
    [
      "scene",
      0.0175
    ],
    [
      "opposition",
      0.0175
    ],
    [
      "lutte",
      0.0175
    ],
    [
      "debat",
      0.0175
    ],
    [
      "brouille",
      0.0175
    ],
    [
      "bagarre",
      0.0175
    ],
    [
      "affaire",
      0.0125
    ],
    [
      "heurt",
      0.0125
    ],
    [
      "mesentente",
      0.0125
    ],
    [
      "rixe",
      0.0125
    ],
    [
      "grabuge",
      0.0125
    ],
    [
      "demele",
      0.0125
    ],
    [
      "difficulte",
      0.0125
    ],
    [
      "bouderie",
      0.0125
    ],
    [
      "accrochage",
      0.0125
    ],
    [
      "escarmouche",
      0.01
    ],
    [
      "tension",
      0.01
    ],
    [
      "litige",
      0.0075
    ],
    [
      "duel",
      0.0075
    ],
    [
      "discord",
      0.0075
    ],
    [
      "contradiction",
      0.0075
    ],
    [
      "trouble",
      0.005
    ],
    [
      "rupture",
      0.005
    ],
    [
      "malentendu",
      0.005
    ],
    [
      "division",
      0.005
    ],
    [
      "controverse",
      0.005
    ],
    [
      "brouillerie",
      0.005
    ],
    [
      "algarade",
      0.005
    ],
    [
      "chamaillerie",
      0.005
    ],
    [
      "noise",
      0.005
    ],
    [
      "seance",
      0.005
    ],
    [
      "tiraillement",
      0.0025
    ],
    [
      "proces",
      0.0025
    ],
    [
      "polemique",
      0.0025
    ],
    [
      "incident",
      0.0025
    ],
    [
      "engueulade",
      0.0025
    ],
    [
      "serenade",
      0.0025
    ],
    [
      "sortie",
      0.0025
    ],
    [
      "joute",
      0.0025
    ],
    [
      "explication",
      0.0025
    ],
    [
      "clash",
      0.0025
    ],
    [
      "charivari",
      0.0025
    ],
    [
      "chamaille",
      0.0025
    ],
    [
      "barouf",
      0.0025
    ],
    [
      "prise",
      0.0
    ],
    [
      "logomachie",
      0.0
    ],
    [
      "ivraie",
      0.0
    ],
    [
      "inimitie",
      0.0
    ],
    [
      "facherie",
      0.0
    ],
    [
      "empoignade",
      0.0
    ],
    [
      "disputation",
      0.0
    ],
    [
      "contention",
      0.0
    ],
    [
      "chamaillis",
      0.0
    ],
    [
      "castille",
      0.0
    ],
    [
      "bouffage",
      0.0
    ],
    [
      "verbiage",
      0.0
    ]
  ],
  "disputer": [
    [
      "discuter",
      0.0975
    ],
    [
      "batailler",
      0.07
    ],
    [
      "chicaner",
      0.0525
    ],
    [
      "lutter",
      0.0525
    ],
    [
      "sermonner",
      0.0425
    ],
    [
      "reprimander",
      0.0425
    ],
    [
      "ferrailler",
      0.0425
    ],
    [
      "contester",
      0.0425
    ],
    [
      "tancer",
      0.035
    ],
    [
      "quereller",
      0.035
    ],
    [
      "gronder",
      0.035
    ],
    [
      "ergoter",
      0.035
    ],
    [
      "attraper",
      0.035
    ],
    [
      "admonester",
      0.035
    ],
    [
      "raisonner",
      0.025
    ],
    [
      "jouter",
      0.025
    ],
    [
      "gourmander",
      0.025
    ],
    [
      "soutenir",
      0.015
    ],
    [
      "rivaliser",
      0.015
    ],
    [
      "nier",
      0.015
    ],
    [
      "morigener",
      0.015
    ],
    [
      "escrimer",
      0.015
    ],
    [
      "engueuler",
      0.015
    ],
    [
      "discourir",
      0.015
    ],
    [
      "controverser",
      0.015
    ],
    [
      "philosopher",
      0.0075
    ],
    [
      "enguirlander",
      0.0075
    ],
    [
      "defendre",
      0.0075
    ],
    [
      "debattre",
      0.0075
    ],
    [
      "disputailler",
      0.0075
    ],
    [
      "disconvenir",
      0.0075
    ],
    [
      "chapitrer",
      0.0075
    ],
    [
      "briguer",
      0.0075
    ],
    [
      "egaler",
      0.0075
    ]
  ],
  "liaison": [
    [
      "rapport",
      0.0825
    ],
    [
      "relation",
      0.0625
    ],
    [
      "union",
      0.055
    ],
    [
      "attachement",
      0.04
    ],
    [
      "connexion",
      0.0375
    ],
    [
      "lien",
      0.0325
    ],
    [
      "enchainement",
      0.03
    ],
    [
      "chaine",
      0.03
    ],
    [
      "amour",
      0.03
    ],
    [
      "alliance",
      0.0275
    ],
    [
      "association",
      0.0275
    ],
    [
      "frequentation",
      0.0275
    ],
    [
      "intimite",
      0.0275
    ],
    [
      "attache",
      0.025
    ],
    [
      "commerce",
      0.025
    ],
    [
      "suite",
      0.02
    ],
    [
      "correspondance",
      0.02
    ],
    [
      "amitie",
      0.02
    ],
    [
      "accointance",
      0.0175
    ],
    [
      "adherence",
      0.0175
    ],
    [
      "affinite",
      0.0175
    ],
    [
      "coherence",
      0.0175
    ],
    [
      "dependance",
      0.015
    ],
    [
      "contact",
      0.015
    ],
    [
      "trame",
      0.01
    ],
    [
      "reunion",
      0.01
    ],
    [
      "intrigue",
      0.01
    ],
    [
      "correlation",
      0.01
    ],
    [
      "cohesion",
      0.01
    ],
    [
      "assemblage",
      0.01
    ],
    [
      "passion",
      0.0075
    ],
    [
      "jonction",
      0.0075
    ],
    [
      "galanterie",
      0.0075
    ],
    [
      "fil",
      0.0075
    ],
    [
      "contiguite",
      0.0075
    ],
    [
      "connexite",
      0.0075
    ],
    [
      "concubinage",
      0.0075
    ],
    [
      "texture",
      0.005
    ],
    [
      "passade",
      0.005
    ],
    [
      "ligne",
      0.005
    ],
    [
      "filiation",
      0.005
    ],
    [
      "engagement",
      0.005
    ],
    [
      "convenance",
      0.005
    ],
    [
      "connaissance",
      0.005
    ],
    [
      "communication",
      0.005
    ],
    [
      "accouplement",
      0.005
    ],
    [
      "agencement",
      0.005
    ],
    [
      "amante",
      0.005
    ],
    [
      "aventure",
      0.005
    ],
    [
      "camaraderie",
      0.005
    ],
    [
      "sauce",
      0.0025
    ],
    [
      "recoupement",
      0.0025
    ],
    [
      "mortier",
      0.0025
    ],
    [
      "maitresse",
      0.0025
    ],
    [
      "interface",
      0.0025
    ],
    [
      "coule",
      0.0025
    ],
    [
      "continuite",
      0.0025
    ],
    [
      "bretelle",
      0.0025
    ],
    [
      "acoquinement",
      0.0025
    ],
    [
      "transition",
      0.0025
    ]
  ],
  "leser": [
    [
      "blesser",
      0.145
    ],
    [
      "nuire",
      0.145
    ],
    [
      "attaquer",
      0.0875
    ],
    [
      "atteindre",
      0.0875
    ],
    [
      "toucher",
      0.0875
    ],
    [
      "frustrer",
      0.0575
    ],
    [
      "endommager",
      0.0575
    ],
    [
      "desavantager",
      0.0575
    ],
    [
      "defavoriser",
      0.0575
    ],
    [
      "desservir",
      0.0275
    ],
    [
      "deposseder",
      0.0275
    ],
    [
      "interesser",
      0.0275
    ],
    [
      "mutiler",
      0.0275
    ],
    [
      "perdre",
      0.0275
    ]
  ],
  "lesion": [
    [
      "blessure",
      0.11
    ],
    [
      "brulure",
      0.11
    ],
    [
      "ulceration",
      0.0725
    ],
    [
      "trouble",
      0.0725
    ],
    [
      "tort",
      0.0725
    ],
    [
      "gangrene",
      0.0725
    ],
    [
      "chancre",
      0.0725
    ],
    [
      "plaie",
      0.035
    ],
    [
      "perturbation",
      0.035
    ],
    [
      "necrose",
      0.035
    ],
    [
      "inflammation",
      0.035
    ],
    [
      "desordre",
      0.035
    ],
    [
      "degenerescence",
      0.035
    ],
    [
      "dommage",
      0.035
    ],
    [
      "contusion",
      0.035
    ],
    [
      "affection",
      0.035
    ],
    [
      "accident",
      0.035
    ],
    [
      "prejudice",
      0.035
    ]
  ],
  "crainte": [
    [
      "redouter",
      0.24
    ],
    [
      "apprehender",
      0.1025
    ],
    [
      "pressentir",
      0.1025
    ],
    [
      "attendre",
      0.0675
    ],
    [
      "s'effrayer",
      0.0325
    ],
    [
      "trembler",
      0.0325
    ],
    [
      "s'attendre",
      0.0325
    ],
    [
      "s'alarmer",
      0.0325
    ],
    [
      "reverer",
      0.0325
    ],
    [
      "regretter",
      0.0325
    ],
    [
      "plaindre",
      0.0325
    ],
    [
      "menager",
      0.0325
    ],
    [
      "honorer",
      0.0325
    ]
  ],
  "evacuer": [
    [
      "sortir",
      0.1225
    ],
    [
      "expulser",
      0.08
    ],
    [
      "vider",
      0.08
    ],
    [
      "abandonner",
      0.0675
    ],
    [
      "debarrasser",
      0.0525
    ],
    [
      "liberer",
      0.0525
    ],
    [
      "rejeter",
      0.0525
    ],
    [
      "quitter",
      0.04
    ],
    [
      "faire",
      0.04
    ],
    [
      "degorger",
      0.04
    ],
    [
      "eliminer",
      0.025
    ],
    [
      "vomir",
      0.025
    ],
    [
      "uriner",
      0.025
    ],
    [
      "s'ecouler",
      0.025
    ],
    [
      "deverser",
      0.025
    ],
    [
      "degager",
      0.025
    ],
    [
      "defequer",
      0.025
    ],
    [
      "chier",
      0.025
    ],
    [
      "pisser",
      0.0125
    ],
    [
      "liquider",
      0.0125
    ],
    [
      "excreter",
      0.0125
    ],
    [
      "desemplir",
      0.0125
    ],
    [
      "cracher",
      0.0125
    ],
    [
      "bouser",
      0.0125
    ],
    [
      "vidanger",
      0.0125
    ]
  ],
  "entrevoir": [
    [
      "apercevoir",
      0.12
    ],
    [
      "deviner",
      0.12
    ],
    [
      "pressentir",
      0.1
    ],
    [
      "voir",
      0.1
    ],
    [
      "decouvrir",
      0.08
    ],
    [
      "percevoir",
      0.08
    ],
    [
      "prevoir",
      0.08
    ],
    [
      "discerner",
      0.06
    ],
    [
      "comprendre",
      0.06
    ],
    [
      "connaitre",
      0.04
    ],
    [
      "subodorer",
      0.04
    ],
    [
      "distinguer",
      0.02
    ],
    [
      "entrapercevoir",
      0.02
    ],
    [
      "esperer",
      0.02
    ],
    [
      "presager",
      0.02
    ],
    [
      "soupconner",
      0.02
    ]
  ],
  "attenuer": [
    [
      "diminuer",
      0.1175
    ],
    [
      "adoucir",
      0.11
    ],
    [
      "temperer",
      0.085
    ],
    [
      "affaiblir",
      0.0725
    ],
    [
      "moderer",
      0.0575
    ],
    [
      "reduire",
      0.05
    ],
    [
      "calmer",
      0.04
    ],
    [
      "eteindre",
      0.0325
    ],
    [
      "amortir",
      0.0325
    ],
    [
      "apaiser",
      0.0275
    ],
    [
      "estomper",
      0.025
    ],
    [
      "affadir",
      0.02
    ],
    [
      "emousser",
      0.0175
    ],
    [
      "edulcorer",
      0.0175
    ],
    [
      "soulager",
      0.0175
    ],
    [
      "amoindrir",
      0.0175
    ],
    [
      "abaisser",
      0.0175
    ],
    [
      "alleger",
      0.0125
    ],
    [
      "etouffer",
      0.01
    ],
    [
      "voiler",
      0.01
    ],
    [
      "relacher",
      0.01
    ],
    [
      "rabattre",
      0.01
    ],
    [
      "pallier",
      0.01
    ],
    [
      "mitiger",
      0.01
    ],
    [
      "fondre",
      0.01
    ],
    [
      "assoupir",
      0.01
    ],
    [
      "baisser",
      0.01
    ],
    [
      "consoler",
      0.01
    ],
    [
      "corriger",
      0.01
    ],
    [
      "dissimuler",
      0.01
    ],
    [
      "user",
      0.005
    ],
    [
      "pulveriser",
      0.005
    ],
    [
      "nuancer",
      0.005
    ],
    [
      "lenifier",
      0.005
    ],
    [
      "bercer",
      0.005
    ],
    [
      "assouplir",
      0.005
    ],
    [
      "amenuiser",
      0.005
    ],
    [
      "alterer",
      0.005
    ],
    [
      "piler",
      0.0025
    ],
    [
      "frelater",
      0.0025
    ],
    [
      "extenuer",
      0.0025
    ],
    [
      "effiler",
      0.0025
    ],
    [
      "broyer",
      0.0025
    ],
    [
      "assourdir",
      0.0025
    ],
    [
      "assagir",
      0.0025
    ],
    [
      "ralentir",
      0.0025
    ]
  ],
  "commentaire": [
    [
      "explication",
      0.1
    ],
    [
      "note",
      0.1
    ],
    [
      "exegese",
      0.0675
    ],
    [
      "remarque",
      0.05
    ],
    [
      "propos",
      0.05
    ],
    [
      "glose",
      0.05
    ],
    [
      "critique",
      0.05
    ],
    [
      "bavardage",
      0.05
    ],
    [
      "annotation",
      0.05
    ],
    [
      "souvenir",
      0.0325
    ],
    [
      "potin",
      0.0325
    ],
    [
      "paraphrase",
      0.0325
    ],
    [
      "observation",
      0.0325
    ],
    [
      "memoire",
      0.0325
    ],
    [
      "medisance",
      0.0325
    ],
    [
      "interpretation",
      0.0325
    ],
    [
      "histoire",
      0.0325
    ],
    [
      "commerage",
      0.0325
    ],
    [
      "cancan",
      0.0325
    ],
    [
      "scolie",
      0.015
    ],
    [
      "racontar",
      0.015
    ],
    [
      "annales",
      0.015
    ],
    [
      "anagogie",
      0.015
    ],
    [
      "eclaircissement",
      0.015
    ]
  ],
  "challenge": [
    [
      "competition",
      0.25
    ],
    [
      "defi",
      0.25
    ],
    [
      "match",
      0.25
    ],
    [
      "epreuve",
      0.25
    ]
  ],
  "crabe": [
    [
      "cancer",
      1.0
    ]
  ],
  "aisselle": [
    [
      "gousset",
      0.3325
    ]
  ],
  "dab": [
    [
      "pere",
      0.4
    ],
    [
      "daron",
      0.2
    ],
    [
      "pater",
      0.2
    ],
    [
      "vieux",
      0.2
    ]
  ],
  "clap": [
    [
      "claquette",
      1.0
    ]
  ],
  "colis": [
    [
      "bagage",
      0.165
    ],
    [
      "ballot",
      0.165
    ],
    [
      "balle",
      0.1
    ],
    [
      "barda",
      0.1
    ],
    [
      "paquet",
      0.1
    ],
    [
      "fardeau",
      0.065
    ],
    [
      "envoi",
      0.065
    ],
    [
      "caisse",
      0.065
    ],
    [
      "charge",
      0.0325
    ],
    [
      "empaquetage",
      0.0325
    ],
    [
      "expedition",
      0.0325
    ],
    [
      "malle",
      0.0325
    ],
    [
      "sac",
      0.0325
    ]
  ],
  "mandarine": [
    [
      "agrume",
      0.3325
    ],
    [
      "orange",
      0.3325
    ],
    [
      "sein",
      0.3325
    ]
  ],
  "tropical": [
    [
      "accablant",
      0.2
    ],
    [
      "chaud",
      0.2
    ],
    [
      "creole",
      0.2
    ],
    [
      "intertropical",
      0.2
    ],
    [
      "torride",
      0.2
    ]
  ],
  "accident": [
    [
      "evenement",
      0.0825
    ],
    [
      "tribulation",
      0.0525
    ],
    [
      "incident",
      0.05
    ],
    [
      "malheur",
      0.05
    ],
    [
      "mesaventure",
      0.0425
    ],
    [
      "ennui",
      0.0375
    ],
    [
      "aventure",
      0.03
    ],
    [
      "circonstance",
      0.03
    ],
    [
      "hasard",
      0.0275
    ],
    [
      "fait",
      0.0275
    ],
    [
      "affaire",
      0.0275
    ],
    [
      "anicroche",
      0.025
    ],
    [
      "cas",
      0.025
    ],
    [
      "malchance",
      0.025
    ],
    [
      "choc",
      0.02
    ],
    [
      "pepin",
      0.02
    ],
    [
      "episode",
      0.0175
    ],
    [
      "vicissitude",
      0.0175
    ],
    [
      "tuile",
      0.0175
    ],
    [
      "revers",
      0.0175
    ],
    [
      "complication",
      0.0175
    ],
    [
      "catastrophe",
      0.0175
    ],
    [
      "adversite",
      0.015
    ],
    [
      "avatar",
      0.015
    ],
    [
      "contretemps",
      0.015
    ],
    [
      "peripetie",
      0.0125
    ],
    [
      "occasion",
      0.0125
    ],
    [
      "effet",
      0.0125
    ],
    [
      "calamite",
      0.0125
    ],
    [
      "accrochage",
      0.0125
    ],
    [
      "accroc",
      0.0125
    ],
    [
      "alea",
      0.0075
    ],
    [
      "coup",
      0.0075
    ],
    [
      "plissement",
      0.005
    ],
    [
      "relief",
      0.005
    ],
    [
      "repli",
      0.005
    ],
    [
      "resultat",
      0.005
    ],
    [
      "mouvement",
      0.005
    ],
    [
      "inegalite",
      0.005
    ],
    [
      "incidence",
      0.005
    ],
    [
      "chute",
      0.005
    ],
    [
      "chagrin",
      0.005
    ],
    [
      "cataclysme",
      0.005
    ],
    [
      "montagne",
      0.0025
    ],
    [
      "malencontre",
      0.0025
    ],
    [
      "lesion",
      0.0025
    ],
    [
      "mechef",
      0.0025
    ],
    [
      "panne",
      0.0025
    ],
    [
      "phenomene",
      0.0025
    ],
    [
      "pli",
      0.0025
    ],
    [
      "tonneau",
      0.0025
    ],
    [
      "tragedie",
      0.0025
    ],
    [
      "irregularite",
      0.0025
    ],
    [
      "explosion",
      0.0025
    ],
    [
      "embardee",
      0.0025
    ],
    [
      "artefact",
      0.0025
    ],
    [
      "asperite",
      0.0025
    ],
    [
      "attribut",
      0.0025
    ],
    [
      "buche",
      0.0025
    ],
    [
      "capotage",
      0.0025
    ],
    [
      "collision",
      0.0025
    ],
    [
      "consequence",
      0.0025
    ],
    [
      "drame",
      0.0025
    ],
    [
      "denivellation",
      0.0025
    ],
    [
      "derapage",
      0.0025
    ]
  ],
  "tiroir": [
    [
      "casier",
      0.4
    ],
    [
      "boite",
      0.2
    ],
    [
      "compartiment",
      0.2
    ],
    [
      "recouvrement",
      0.2
    ]
  ],
  "planisphere": [
    [
      "carte",
      0.375
    ],
    [
      "georama",
      0.125
    ],
    [
      "mappemonde",
      0.125
    ],
    [
      "mercator",
      0.125
    ],
    [
      "projection",
      0.125
    ]
  ],
  "biguine": [],
  "grenadine": [
    [
      "fricandeau",
      1.0
    ]
  ],
  "grenadin": [
    [
      "fricandeau",
      1.0
    ]
  ],
  "immensite": [
    [
      "grandeur",
      0.19
    ],
    [
      "profondeur",
      0.115
    ],
    [
      "etendue",
      0.115
    ],
    [
      "quantite",
      0.075
    ],
    [
      "infinite",
      0.075
    ],
    [
      "infini",
      0.075
    ],
    [
      "espace",
      0.075
    ],
    [
      "vastitude",
      0.0375
    ],
    [
      "puissance",
      0.0375
    ],
    [
      "multitude",
      0.0375
    ],
    [
      "amplitude",
      0.0375
    ],
    [
      "ampleur",
      0.0375
    ],
    [
      "abime",
      0.0375
    ],
    [
      "enormite",
      0.0375
    ]
  ],
  "infiniment": [
    [
      "beaucoup",
      0.1625
    ],
    [
      "extremement",
      0.1625
    ],
    [
      "tres",
      0.13
    ],
    [
      "excessivement",
      0.08
    ],
    [
      "extraordinairement",
      0.0475
    ],
    [
      "genereusement",
      0.0475
    ],
    [
      "vivement",
      0.0475
    ],
    [
      "profondement",
      0.0325
    ],
    [
      "immensement",
      0.0325
    ],
    [
      "grandement",
      0.0325
    ],
    [
      "furieusement",
      0.0325
    ],
    [
      "diablement",
      0.0325
    ],
    [
      "trop",
      0.015
    ],
    [
      "toujours",
      0.015
    ],
    [
      "supremement",
      0.015
    ],
    [
      "puissamment",
      0.015
    ],
    [
      "nettement",
      0.015
    ],
    [
      "joliment",
      0.015
    ],
    [
      "incomparablement",
      0.015
    ],
    [
      "colossalement",
      0.015
    ]
  ],
  "cocagne": [
    [
      "abondance",
      0.2
    ],
    [
      "eldorado",
      0.2
    ],
    [
      "fete",
      0.2
    ],
    [
      "paradis",
      0.2
    ],
    [
      "rejouissance",
      0.2
    ]
  ],
  "bonsoir": [
    [
      "adieu",
      0.285
    ],
    [
      "salut",
      0.285
    ],
    [
      "bonjour",
      0.1425
    ]
  ],
  "canal": [
    [
      "conduit",
      0.065
    ],
    [
      "chenal",
      0.0425
    ],
    [
      "passage",
      0.035
    ],
    [
      "voie",
      0.035
    ],
    [
      "rigole",
      0.0275
    ],
    [
      "gorge",
      0.0275
    ],
    [
      "detroit",
      0.0275
    ],
    [
      "defile",
      0.0275
    ],
    [
      "conduite",
      0.0275
    ],
    [
      "cavite",
      0.0275
    ],
    [
      "aqueduc",
      0.0275
    ],
    [
      "agent",
      0.0275
    ],
    [
      "tuyau",
      0.02
    ],
    [
      "tube",
      0.02
    ],
    [
      "tranchee",
      0.02
    ],
    [
      "sillon",
      0.02
    ],
    [
      "rainure",
      0.02
    ],
    [
      "passe",
      0.02
    ],
    [
      "fosse",
      0.02
    ],
    [
      "dalle",
      0.02
    ],
    [
      "bras",
      0.02
    ],
    [
      "grau",
      0.0125
    ],
    [
      "intermediaire",
      0.0125
    ],
    [
      "moyen",
      0.0125
    ],
    [
      "pipeline",
      0.0125
    ],
    [
      "emissaire",
      0.0125
    ],
    [
      "gouttiere",
      0.0125
    ],
    [
      "dalot",
      0.0125
    ],
    [
      "coupure",
      0.0125
    ],
    [
      "couloir",
      0.0125
    ],
    [
      "cheneau",
      0.0125
    ],
    [
      "cannelure",
      0.0125
    ],
    [
      "caniveau",
      0.0125
    ],
    [
      "bassin",
      0.0125
    ],
    [
      "oleoduc",
      0.005
    ],
    [
      "noulet",
      0.005
    ],
    [
      "noue",
      0.005
    ],
    [
      "lit",
      0.005
    ],
    [
      "riviere",
      0.005
    ],
    [
      "robine",
      0.005
    ],
    [
      "roubine",
      0.005
    ],
    [
      "saignee",
      0.005
    ],
    [
      "sas",
      0.005
    ],
    [
      "source",
      0.005
    ],
    [
      "seguia",
      0.005
    ],
    [
      "uretere",
      0.005
    ],
    [
      "egout",
      0.005
    ],
    [
      "infundibulum",
      0.005
    ],
    [
      "goulot",
      0.005
    ],
    [
      "adducteur",
      0.005
    ],
    [
      "arrugie",
      0.005
    ],
    [
      "buse",
      0.005
    ],
    [
      "circuit",
      0.005
    ],
    [
      "coursier",
      0.005
    ],
    [
      "cunette",
      0.005
    ],
    [
      "drain",
      0.005
    ],
    [
      "derivation",
      0.005
    ],
    [
      "embouquement",
      0.005
    ],
    [
      "entremise",
      0.005
    ],
    [
      "filiere",
      0.005
    ],
    [
      "gargouille",
      0.005
    ],
    [
      "glyphe",
      0.005
    ],
    [
      "goulette",
      0.005
    ],
    [
      "etier",
      0.005
    ]
  ],
  "ecarteler": [
    [
      "disloquer",
      0.165
    ],
    [
      "demembrer",
      0.165
    ],
    [
      "tirailler",
      0.165
    ],
    [
      "dechirer",
      0.0825
    ],
    [
      "demancher",
      0.0825
    ],
    [
      "fissurer",
      0.0825
    ],
    [
      "partager",
      0.0825
    ],
    [
      "tendre",
      0.0825
    ],
    [
      "tirer",
      0.0825
    ]
  ],
  "novembre": [],
  "gue": [
    [
      "passage",
      1.0
    ]
  ],
  "mie": [
    [
      "pas",
      0.285
    ],
    [
      "amie",
      0.1425
    ],
    [
      "biquette",
      0.1425
    ],
    [
      "miette",
      0.1425
    ],
    [
      "ne",
      0.1425
    ],
    [
      "rien",
      0.1425
    ]
  ],
  "chamailler": [
    [
      "chicaner",
      0.5
    ],
    [
      "quereller",
      0.5
    ]
  ],
  "chamaille": [
    [
      "bisbille",
      0.2
    ],
    [
      "discussion",
      0.2
    ],
    [
      "dispute",
      0.2
    ],
    [
      "grabuge",
      0.2
    ],
    [
      "bruit",
      0.1
    ],
    [
      "chamaillerie",
      0.1
    ]
  ],
  "suer": [
    [
      "peiner",
      0.085
    ],
    [
      "suinter",
      0.085
    ],
    [
      "transpirer",
      0.085
    ],
    [
      "s'echiner",
      0.0725
    ],
    [
      "s'epuiser",
      0.0475
    ],
    [
      "travailler",
      0.035
    ],
    [
      "fatiguer",
      0.035
    ],
    [
      "exhaler",
      0.035
    ],
    [
      "couler",
      0.035
    ],
    [
      "trimer",
      0.0225
    ],
    [
      "s'ereinter",
      0.0225
    ],
    [
      "ruisseler",
      0.0225
    ],
    [
      "degoutter",
      0.0225
    ],
    [
      "degouliner",
      0.0225
    ],
    [
      "ahaner",
      0.0225
    ],
    [
      "sentir",
      0.01
    ],
    [
      "s'extenuer",
      0.01
    ],
    [
      "s'esquinter",
      0.01
    ],
    [
      "ressuer",
      0.01
    ],
    [
      "respirer",
      0.01
    ],
    [
      "payer",
      0.01
    ],
    [
      "moitir",
      0.01
    ],
    [
      "exsuder",
      0.01
    ],
    [
      "exploiter",
      0.01
    ]
  ],
  "giboulee": [
    [
      "volee",
      0.2125
    ],
    [
      "coup",
      0.1425
    ],
    [
      "orage",
      0.1425
    ],
    [
      "pluie",
      0.1425
    ],
    [
      "averse",
      0.07
    ],
    [
      "degelee",
      0.07
    ],
    [
      "grain",
      0.07
    ],
    [
      "ondee",
      0.07
    ],
    [
      "torgnole",
      0.07
    ]
  ],
  "frimas": [
    [
      "brouillard",
      0.125
    ],
    [
      "froid",
      0.125
    ],
    [
      "gelee",
      0.125
    ],
    [
      "bruine",
      0.0825
    ],
    [
      "froidure",
      0.0825
    ],
    [
      "gresil",
      0.04
    ],
    [
      "hiver",
      0.04
    ],
    [
      "rigueur",
      0.04
    ],
    [
      "givre",
      0.04
    ],
    [
      "embrun",
      0.04
    ],
    [
      "crachin",
      0.04
    ],
    [
      "canitie",
      0.04
    ],
    [
      "brume",
      0.04
    ],
    [
      "brouillasse",
      0.04
    ],
    [
      "verglas",
      0.04
    ]
  ],
  "raviver": [
    [
      "ranimer",
      0.215
    ],
    [
      "reveiller",
      0.135
    ],
    [
      "revivifier",
      0.1125
    ],
    [
      "reconforter",
      0.055
    ],
    [
      "revigorer",
      0.055
    ],
    [
      "retremper",
      0.055
    ],
    [
      "exalter",
      0.055
    ],
    [
      "rechauffer",
      0.045
    ],
    [
      "remonter",
      0.0325
    ],
    [
      "ravigoter",
      0.0325
    ],
    [
      "rajeunir",
      0.0325
    ],
    [
      "rafraichir",
      0.0325
    ],
    [
      "exciter",
      0.0325
    ],
    [
      "aviver",
      0.02
    ],
    [
      "ragaillardir",
      0.02
    ],
    [
      "renouveler",
      0.02
    ],
    [
      "degourdir",
      0.01
    ],
    [
      "rallumer",
      0.01
    ],
    [
      "reactiver",
      0.01
    ]
  ],
  "cerfeuil": [],
  "rapporter": [
    [
      "montrer",
      0.0675
    ],
    [
      "reveler",
      0.0575
    ],
    [
      "donner",
      0.0525
    ],
    [
      "dire",
      0.05
    ],
    [
      "porter",
      0.0375
    ],
    [
      "exposer",
      0.0325
    ],
    [
      "produire",
      0.0325
    ],
    [
      "signaler",
      0.03
    ],
    [
      "remettre",
      0.03
    ],
    [
      "raconter",
      0.03
    ],
    [
      "denoncer",
      0.03
    ],
    [
      "rendre",
      0.025
    ],
    [
      "ramener",
      0.02
    ],
    [
      "temoigner",
      0.0175
    ],
    [
      "retracer",
      0.0175
    ],
    [
      "representer",
      0.0125
    ],
    [
      "reporter",
      0.0125
    ],
    [
      "mentionner",
      0.0125
    ],
    [
      "joindre",
      0.0125
    ],
    [
      "gagner",
      0.0125
    ],
    [
      "citer",
      0.0125
    ],
    [
      "attribuer",
      0.0125
    ],
    [
      "apporter",
      0.0125
    ],
    [
      "ajouter",
      0.0125
    ],
    [
      "relater",
      0.01
    ],
    [
      "remporter",
      0.01
    ],
    [
      "repasser",
      0.01
    ],
    [
      "repeter",
      0.01
    ],
    [
      "informer",
      0.01
    ],
    [
      "imputer",
      0.01
    ],
    [
      "fructifier",
      0.01
    ],
    [
      "devoiler",
      0.01
    ],
    [
      "consigner",
      0.01
    ],
    [
      "annuler",
      0.01
    ],
    [
      "alleguer",
      0.01
    ],
    [
      "preter",
      0.005
    ],
    [
      "rapprocher",
      0.005
    ],
    [
      "redire",
      0.005
    ],
    [
      "rejeter",
      0.005
    ],
    [
      "remmener",
      0.005
    ],
    [
      "revoquer",
      0.005
    ],
    [
      "valoir",
      0.005
    ],
    [
      "profiter",
      0.005
    ],
    [
      "obtenir",
      0.005
    ],
    [
      "moucharder",
      0.005
    ],
    [
      "abolir",
      0.005
    ],
    [
      "acquerir",
      0.005
    ],
    [
      "cafarder",
      0.005
    ],
    [
      "concentrer",
      0.005
    ],
    [
      "diriger",
      0.005
    ],
    [
      "enseigner",
      0.005
    ],
    [
      "invalider",
      0.005
    ],
    [
      "noter",
      0.0025
    ],
    [
      "payer",
      0.0025
    ],
    [
      "proportionner",
      0.0025
    ],
    [
      "raccrocher",
      0.0025
    ],
    [
      "rattacher",
      0.0025
    ],
    [
      "recolter",
      0.0025
    ],
    [
      "referer",
      0.0025
    ],
    [
      "narrer",
      0.0025
    ],
    [
      "importer",
      0.0025
    ],
    [
      "contremander",
      0.0025
    ],
    [
      "conter",
      0.0025
    ],
    [
      "conquerir",
      0.0025
    ],
    [
      "completer",
      0.0025
    ],
    [
      "colporter",
      0.0025
    ],
    [
      "cafeter",
      0.0025
    ],
    [
      "abouter",
      0.0025
    ],
    [
      "resilier",
      0.0025
    ]
  ],
  "dompte": [
    [
      "maitriser",
      0.1225
    ],
    [
      "dominer",
      0.0825
    ],
    [
      "soumettre",
      0.0775
    ],
    [
      "assujettir",
      0.0675
    ],
    [
      "mater",
      0.0675
    ],
    [
      "asservir",
      0.0525
    ],
    [
      "reduire",
      0.0525
    ],
    [
      "vaincre",
      0.04
    ],
    [
      "triompher",
      0.035
    ],
    [
      "forcer",
      0.035
    ],
    [
      "enchainer",
      0.035
    ],
    [
      "regner",
      0.03
    ],
    [
      "captiver",
      0.02
    ],
    [
      "dresser",
      0.02
    ],
    [
      "museler",
      0.02
    ],
    [
      "surmonter",
      0.02
    ],
    [
      "subjuguer",
      0.0175
    ],
    [
      "discipliner",
      0.0175
    ],
    [
      "controler",
      0.0175
    ],
    [
      "commander",
      0.0175
    ],
    [
      "briser",
      0.0125
    ],
    [
      "domestiquer",
      0.0125
    ],
    [
      "terrasser",
      0.0125
    ],
    [
      "regler",
      0.0075
    ],
    [
      "rompre",
      0.0075
    ],
    [
      "plier",
      0.0075
    ],
    [
      "juguler",
      0.0075
    ],
    [
      "courber",
      0.0075
    ],
    [
      "contenir",
      0.0075
    ],
    [
      "apprivoiser",
      0.0075
    ],
    [
      "abattre",
      0.0075
    ],
    [
      "calmer",
      0.0025
    ],
    [
      "corriger",
      0.0025
    ],
    [
      "s'assujettir",
      0.0025
    ]
  ],
  "dompter": [
    [
      "maitriser",
      0.1225
    ],
    [
      "dominer",
      0.0825
    ],
    [
      "soumettre",
      0.0775
    ],
    [
      "assujettir",
      0.0675
    ],
    [
      "mater",
      0.0675
    ],
    [
      "asservir",
      0.0525
    ],
    [
      "reduire",
      0.0525
    ],
    [
      "vaincre",
      0.04
    ],
    [
      "triompher",
      0.035
    ],
    [
      "forcer",
      0.035
    ],
    [
      "enchainer",
      0.035
    ],
    [
      "regner",
      0.03
    ],
    [
      "captiver",
      0.02
    ],
    [
      "dresser",
      0.02
    ],
    [
      "museler",
      0.02
    ],
    [
      "surmonter",
      0.02
    ],
    [
      "subjuguer",
      0.0175
    ],
    [
      "discipliner",
      0.0175
    ],
    [
      "controler",
      0.0175
    ],
    [
      "commander",
      0.0175
    ],
    [
      "briser",
      0.0125
    ],
    [
      "domestiquer",
      0.0125
    ],
    [
      "terrasser",
      0.0125
    ],
    [
      "regler",
      0.0075
    ],
    [
      "rompre",
      0.0075
    ],
    [
      "plier",
      0.0075
    ],
    [
      "juguler",
      0.0075
    ],
    [
      "courber",
      0.0075
    ],
    [
      "contenir",
      0.0075
    ],
    [
      "apprivoiser",
      0.0075
    ],
    [
      "abattre",
      0.0075
    ],
    [
      "calmer",
      0.0025
    ],
    [
      "corriger",
      0.0025
    ],
    [
      "s'assujettir",
      0.0025
    ]
  ],
  "potager": [
    [
      "jardin",
      0.5
    ],
    [
      "plantation",
      0.5
    ]
  ],
  "buter": [
    [
      "achopper",
      0.085
    ],
    [
      "heurter",
      0.085
    ],
    [
      "chopper",
      0.0625
    ],
    [
      "rencontrer",
      0.0625
    ],
    [
      "tuer",
      0.0425
    ],
    [
      "trebucher",
      0.0425
    ],
    [
      "cogner",
      0.0425
    ],
    [
      "choquer",
      0.0425
    ],
    [
      "cabrer",
      0.0425
    ],
    [
      "broncher",
      0.0425
    ],
    [
      "appuyer",
      0.0425
    ],
    [
      "tituber",
      0.02
    ],
    [
      "zigouiller",
      0.02
    ],
    [
      "echouer",
      0.02
    ],
    [
      "epauler",
      0.02
    ],
    [
      "s'arreter",
      0.02
    ],
    [
      "acculer",
      0.02
    ],
    [
      "arreter",
      0.02
    ],
    [
      "braquer",
      0.02
    ],
    [
      "chanceler",
      0.02
    ],
    [
      "chausser",
      0.02
    ],
    [
      "dessouder",
      0.02
    ],
    [
      "flinguer",
      0.02
    ],
    [
      "s'appuyer",
      0.02
    ],
    [
      "etayer",
      0.02
    ]
  ],
  "bute": [
    [
      "achopper",
      0.085
    ],
    [
      "heurter",
      0.085
    ],
    [
      "chopper",
      0.0625
    ],
    [
      "rencontrer",
      0.0625
    ],
    [
      "tuer",
      0.0425
    ],
    [
      "trebucher",
      0.0425
    ],
    [
      "cogner",
      0.0425
    ],
    [
      "choquer",
      0.0425
    ],
    [
      "cabrer",
      0.0425
    ],
    [
      "broncher",
      0.0425
    ],
    [
      "appuyer",
      0.0425
    ],
    [
      "tituber",
      0.02
    ],
    [
      "zigouiller",
      0.02
    ],
    [
      "echouer",
      0.02
    ],
    [
      "epauler",
      0.02
    ],
    [
      "s'arreter",
      0.02
    ],
    [
      "acculer",
      0.02
    ],
    [
      "arreter",
      0.02
    ],
    [
      "braquer",
      0.02
    ],
    [
      "chanceler",
      0.02
    ],
    [
      "chausser",
      0.02
    ],
    [
      "dessouder",
      0.02
    ],
    [
      "flinguer",
      0.02
    ],
    [
      "s'appuyer",
      0.02
    ],
    [
      "etayer",
      0.02
    ]
  ],
  "comedie": [
    [
      "feinte",
      0.0925
    ],
    [
      "simulation",
      0.075
    ],
    [
      "hypocrisie",
      0.0675
    ],
    [
      "grimace",
      0.055
    ],
    [
      "singerie",
      0.055
    ],
    [
      "sournoiserie",
      0.0425
    ],
    [
      "momerie",
      0.04
    ],
    [
      "affectation",
      0.035
    ],
    [
      "tartuferie",
      0.035
    ],
    [
      "tromperie",
      0.0275
    ],
    [
      "mensonge",
      0.0225
    ],
    [
      "pantalonnade",
      0.0225
    ],
    [
      "saynete",
      0.0175
    ],
    [
      "histoire",
      0.0175
    ],
    [
      "farce",
      0.0175
    ],
    [
      "scene",
      0.015
    ],
    [
      "plaisanterie",
      0.015
    ],
    [
      "piece",
      0.015
    ],
    [
      "pitrerie",
      0.015
    ],
    [
      "facetie",
      0.015
    ],
    [
      "cirque",
      0.015
    ],
    [
      "bouffonnerie",
      0.015
    ],
    [
      "theatre",
      0.01
    ],
    [
      "spectacle",
      0.01
    ],
    [
      "simagrees",
      0.01
    ],
    [
      "simagree",
      0.01
    ],
    [
      "parade",
      0.01
    ],
    [
      "jeu",
      0.01
    ],
    [
      "frime",
      0.01
    ],
    [
      "deguisement",
      0.01
    ],
    [
      "dissimulation",
      0.01
    ],
    [
      "chanson",
      0.01
    ],
    [
      "cabotinage",
      0.01
    ],
    [
      "vaudeville",
      0.0075
    ],
    [
      "sketch",
      0.0075
    ],
    [
      "proverbe",
      0.0075
    ],
    [
      "poeme",
      0.0075
    ],
    [
      "pantomime",
      0.0075
    ],
    [
      "mascarade",
      0.0075
    ],
    [
      "manigance",
      0.0075
    ],
    [
      "invention",
      0.0075
    ],
    [
      "turlupinade",
      0.0025
    ],
    [
      "serenade",
      0.0025
    ],
    [
      "sotie",
      0.0025
    ],
    [
      "mimesis",
      0.0025
    ],
    [
      "dramatique",
      0.0025
    ],
    [
      "cinema",
      0.0025
    ],
    [
      "caprice",
      0.0025
    ],
    [
      "arlequinade",
      0.0025
    ],
    [
      "affaire",
      0.0025
    ],
    [
      "vie",
      0.0025
    ]
  ],
  "rajeunir": [
    [
      "ranimer",
      0.2075
    ],
    [
      "renover",
      0.165
    ],
    [
      "raviver",
      0.125
    ],
    [
      "renouveler",
      0.125
    ],
    [
      "rafraichir",
      0.0825
    ],
    [
      "moderniser",
      0.0825
    ],
    [
      "actualiser",
      0.04
    ],
    [
      "recrepir",
      0.04
    ],
    [
      "reverdir",
      0.04
    ],
    [
      "revigorer",
      0.04
    ],
    [
      "teindre",
      0.04
    ]
  ],
  "sobre": [
    [
      "simple",
      0.1
    ],
    [
      "modere",
      0.06
    ],
    [
      "severe",
      0.06
    ],
    [
      "reserve",
      0.05
    ],
    [
      "retenu",
      0.05
    ],
    [
      "depouille",
      0.05
    ],
    [
      "austere",
      0.05
    ],
    [
      "ascetique",
      0.05
    ],
    [
      "temperant",
      0.03
    ],
    [
      "sommaire",
      0.03
    ],
    [
      "nu",
      0.03
    ],
    [
      "mesure",
      0.03
    ],
    [
      "frugal",
      0.03
    ],
    [
      "discret",
      0.03
    ],
    [
      "court",
      0.03
    ],
    [
      "concis",
      0.03
    ],
    [
      "classique",
      0.03
    ],
    [
      "abstinent",
      0.03
    ],
    [
      "econome",
      0.02
    ],
    [
      "strict",
      0.02
    ],
    [
      "spartiate",
      0.02
    ],
    [
      "net",
      0.02
    ],
    [
      "modeste",
      0.02
    ],
    [
      "continent",
      0.02
    ],
    [
      "pondere",
      0.01
    ],
    [
      "ordinaire",
      0.01
    ],
    [
      "hygienique",
      0.01
    ],
    [
      "dietetique",
      0.01
    ],
    [
      "dense",
      0.01
    ],
    [
      "circonspect",
      0.01
    ],
    [
      "avare",
      0.01
    ],
    [
      "absteme",
      0.01
    ],
    [
      "elementaire",
      0.01
    ]
  ],
  "universite": [],
  "etudiant": [
    [
      "artiste",
      0.25
    ],
    [
      "estudiantin",
      0.25
    ],
    [
      "ecolier",
      0.25
    ],
    [
      "eleve",
      0.25
    ]
  ],
  "impatiemment": [
    [
      "anxieusement",
      0.2
    ],
    [
      "avidement",
      0.2
    ],
    [
      "colereusement",
      0.2
    ],
    [
      "fievreusement",
      0.2
    ],
    [
      "nerveusement",
      0.2
    ]
  ],
  "traduire": [
    [
      "exprimer",
      0.0775
    ],
    [
      "montrer",
      0.0775
    ],
    [
      "reveler",
      0.0775
    ],
    [
      "signifier",
      0.0675
    ],
    [
      "porter",
      0.055
    ],
    [
      "manifester",
      0.045
    ],
    [
      "interpreter",
      0.045
    ],
    [
      "expliquer",
      0.045
    ],
    [
      "citer",
      0.045
    ],
    [
      "revetir",
      0.0325
    ],
    [
      "rendre",
      0.0325
    ],
    [
      "peindre",
      0.0325
    ],
    [
      "designer",
      0.0325
    ],
    [
      "transcrire",
      0.02
    ],
    [
      "trahir",
      0.02
    ],
    [
      "refleter",
      0.02
    ],
    [
      "mettre",
      0.02
    ],
    [
      "mener",
      0.02
    ],
    [
      "dechiffrer",
      0.02
    ],
    [
      "comprendre",
      0.02
    ],
    [
      "assigner",
      0.02
    ],
    [
      "appeler",
      0.02
    ],
    [
      "transposer",
      0.01
    ],
    [
      "translater",
      0.01
    ],
    [
      "transcoder",
      0.01
    ],
    [
      "gloser",
      0.01
    ],
    [
      "figurer",
      0.01
    ],
    [
      "developper",
      0.01
    ],
    [
      "deferer",
      0.01
    ],
    [
      "deviner",
      0.01
    ],
    [
      "convoquer",
      0.01
    ],
    [
      "trainer",
      0.01
    ]
  ],
  "debouche": [
    [
      "sortir",
      0.12
    ],
    [
      "aboutir",
      0.0875
    ],
    [
      "degager",
      0.0875
    ],
    [
      "desobstruer",
      0.0875
    ],
    [
      "tomber",
      0.0875
    ],
    [
      "desopiler",
      0.0275
    ],
    [
      "detacher",
      0.0275
    ],
    [
      "mener",
      0.0275
    ],
    [
      "ouvrir",
      0.0275
    ],
    [
      "parvenir",
      0.0275
    ],
    [
      "s'emboucher",
      0.0275
    ],
    [
      "desengorger",
      0.0275
    ],
    [
      "decoiffer",
      0.0275
    ],
    [
      "decapsuler",
      0.0275
    ],
    [
      "debucher",
      0.0275
    ],
    [
      "debouquer",
      0.0275
    ],
    [
      "conduire",
      0.0275
    ],
    [
      "surgir",
      0.0275
    ]
  ],
  "deboucher": [
    [
      "sortir",
      0.12
    ],
    [
      "aboutir",
      0.0875
    ],
    [
      "degager",
      0.0875
    ],
    [
      "desobstruer",
      0.0875
    ],
    [
      "tomber",
      0.0875
    ],
    [
      "desopiler",
      0.0275
    ],
    [
      "detacher",
      0.0275
    ],
    [
      "mener",
      0.0275
    ],
    [
      "ouvrir",
      0.0275
    ],
    [
      "parvenir",
      0.0275
    ],
    [
      "s'emboucher",
      0.0275
    ],
    [
      "desengorger",
      0.0275
    ],
    [
      "decoiffer",
      0.0275
    ],
    [
      "decapsuler",
      0.0275
    ],
    [
      "debucher",
      0.0275
    ],
    [
      "debouquer",
      0.0275
    ],
    [
      "conduire",
      0.0275
    ],
    [
      "surgir",
      0.0275
    ]
  ],
  "incarcerer": [
    [
      "emprisonner",
      0.3325
    ],
    [
      "coffrer",
      0.2
    ],
    [
      "interner",
      0.1325
    ],
    [
      "arreter",
      0.065
    ],
    [
      "boucler",
      0.065
    ],
    [
      "detenir",
      0.065
    ],
    [
      "encelluler",
      0.065
    ],
    [
      "ecrouer",
      0.065
    ]
  ],
  "incarcere": [
    [
      "emprisonner",
      0.3325
    ],
    [
      "coffrer",
      0.2
    ],
    [
      "interner",
      0.1325
    ],
    [
      "arreter",
      0.065
    ],
    [
      "boucler",
      0.065
    ],
    [
      "detenir",
      0.065
    ],
    [
      "encelluler",
      0.065
    ],
    [
      "ecrouer",
      0.065
    ]
  ],
  "maths": [],
  "vaguement": [
    [
      "confusement",
      0.1425
    ],
    [
      "faiblement",
      0.1425
    ],
    [
      "peu",
      0.1425
    ],
    [
      "obscurement",
      0.07
    ],
    [
      "legerement",
      0.07
    ],
    [
      "indistinctement",
      0.07
    ],
    [
      "imprecisement",
      0.07
    ],
    [
      "imparfaitement",
      0.07
    ],
    [
      "evasivement",
      0.07
    ]
  ],
  "vocabulaire": [
    [
      "langue",
      0.1575
    ],
    [
      "terminologie",
      0.105
    ],
    [
      "nomenclature",
      0.105
    ],
    [
      "lexique",
      0.105
    ],
    [
      "langage",
      0.105
    ],
    [
      "jargon",
      0.105
    ],
    [
      "dictionnaire",
      0.105
    ],
    [
      "correction",
      0.05
    ],
    [
      "expression",
      0.05
    ],
    [
      "glossaire",
      0.05
    ],
    [
      "phraseologie",
      0.05
    ]
  ],
  "preface": [
    [
      "introduction",
      0.1225
    ],
    [
      "preambule",
      0.1225
    ],
    [
      "prologue",
      0.075
    ],
    [
      "preliminaires",
      0.075
    ],
    [
      "prelude",
      0.075
    ],
    [
      "notice",
      0.045
    ],
    [
      "commencement",
      0.045
    ],
    [
      "avis",
      0.045
    ],
    [
      "sommaire",
      0.03
    ],
    [
      "seuil",
      0.03
    ],
    [
      "prefiguration",
      0.03
    ],
    [
      "exorde",
      0.03
    ],
    [
      "avertissement",
      0.03
    ],
    [
      "argument",
      0.03
    ],
    [
      "proeme",
      0.0125
    ],
    [
      "prolegomenes",
      0.0125
    ],
    [
      "prodrome",
      0.0125
    ],
    [
      "priere",
      0.0125
    ],
    [
      "note",
      0.0125
    ],
    [
      "liminaire",
      0.0125
    ],
    [
      "frontispice",
      0.0125
    ],
    [
      "discours",
      0.0125
    ],
    [
      "presentation",
      0.0125
    ]
  ],
  "prefacer": [],
  "faignant": [],
  "corriger": [
    [
      "reformer",
      0.0525
    ],
    [
      "chatier",
      0.0425
    ],
    [
      "ameliorer",
      0.04
    ],
    [
      "reviser",
      0.04
    ],
    [
      "revoir",
      0.0375
    ],
    [
      "battre",
      0.0375
    ],
    [
      "redresser",
      0.03
    ],
    [
      "retoucher",
      0.0275
    ],
    [
      "reparer",
      0.0275
    ],
    [
      "amender",
      0.025
    ],
    [
      "remanier",
      0.0225
    ],
    [
      "punir",
      0.0225
    ],
    [
      "frapper",
      0.02
    ],
    [
      "modifier",
      0.02
    ],
    [
      "rectifier",
      0.02
    ],
    [
      "reprendre",
      0.02
    ],
    [
      "reprimander",
      0.02
    ],
    [
      "sermonner",
      0.02
    ],
    [
      "tancer",
      0.02
    ],
    [
      "relever",
      0.0175
    ],
    [
      "polir",
      0.0175
    ],
    [
      "adoucir",
      0.0175
    ],
    [
      "blamer",
      0.015
    ],
    [
      "changer",
      0.015
    ],
    [
      "regenerer",
      0.015
    ],
    [
      "retrancher",
      0.0125
    ],
    [
      "dresser",
      0.0125
    ],
    [
      "venger",
      0.01
    ],
    [
      "sevir",
      0.01
    ],
    [
      "suppleer",
      0.01
    ],
    [
      "morigener",
      0.01
    ],
    [
      "moderer",
      0.01
    ],
    [
      "compenser",
      0.01
    ],
    [
      "chapitrer",
      0.01
    ],
    [
      "admonester",
      0.01
    ],
    [
      "renouveler",
      0.0075
    ],
    [
      "rosser",
      0.0075
    ],
    [
      "souffleter",
      0.0075
    ],
    [
      "temperer",
      0.0075
    ],
    [
      "transformer",
      0.0075
    ],
    [
      "remedier",
      0.0075
    ],
    [
      "raboter",
      0.0075
    ],
    [
      "perfectionner",
      0.0075
    ],
    [
      "assouplir",
      0.0075
    ],
    [
      "attenuer",
      0.0075
    ],
    [
      "fesser",
      0.0075
    ],
    [
      "fustiger",
      0.0075
    ],
    [
      "guerir",
      0.0075
    ],
    [
      "pallier",
      0.0075
    ],
    [
      "equilibrer",
      0.0025
    ],
    [
      "refondre",
      0.0025
    ],
    [
      "fouetter",
      0.0025
    ],
    [
      "derouiller",
      0.0025
    ],
    [
      "degauchir",
      0.0025
    ],
    [
      "civiliser",
      0.0025
    ],
    [
      "blesser",
      0.0025
    ],
    [
      "ajouter",
      0.0025
    ],
    [
      "raturer",
      0.0
    ],
    [
      "ranger",
      0.0
    ],
    [
      "racheter",
      0.0
    ],
    [
      "policer",
      0.0
    ],
    [
      "reconsiderer",
      0.0
    ],
    [
      "sanctionner",
      0.0
    ],
    [
      "semoncer",
      0.0
    ],
    [
      "talocher",
      0.0
    ],
    [
      "tatouiller",
      0.0
    ],
    [
      "emender",
      0.0
    ],
    [
      "emonder",
      0.0
    ],
    [
      "nuancer",
      0.0
    ],
    [
      "neutraliser",
      0.0
    ],
    [
      "biffer",
      0.0
    ],
    [
      "bigorner",
      0.0
    ],
    [
      "brutaliser",
      0.0
    ],
    [
      "contrepeser",
      0.0
    ],
    [
      "dompter",
      0.0
    ],
    [
      "dulcifier",
      0.0
    ],
    [
      "expurger",
      0.0
    ],
    [
      "gourmander",
      0.0
    ],
    [
      "gratifier",
      0.0
    ],
    [
      "moraliser",
      0.0
    ],
    [
      "balancer",
      0.0
    ]
  ],
  "surdoue": [
    [
      "genie",
      0.5
    ],
    [
      "prodige",
      0.5
    ]
  ],
  "original": [
    [
      "bizarre",
      0.0925
    ],
    [
      "extraordinaire",
      0.07
    ],
    [
      "singulier",
      0.0575
    ],
    [
      "etonnant",
      0.0475
    ],
    [
      "truculent",
      0.0325
    ],
    [
      "curieux",
      0.03
    ],
    [
      "drole",
      0.0275
    ],
    [
      "rare",
      0.025
    ],
    [
      "etrange",
      0.025
    ],
    [
      "nouveau",
      0.0225
    ],
    [
      "special",
      0.0225
    ],
    [
      "particulier",
      0.0225
    ],
    [
      "insolite",
      0.0225
    ],
    [
      "fantasque",
      0.0225
    ],
    [
      "excentrique",
      0.0225
    ],
    [
      "extravagant",
      0.02
    ],
    [
      "inusite",
      0.02
    ],
    [
      "surprenant",
      0.02
    ],
    [
      "sensationnel",
      0.0175
    ],
    [
      "remarquable",
      0.015
    ],
    [
      "exceptionnel",
      0.015
    ],
    [
      "baroque",
      0.0125
    ],
    [
      "neuf",
      0.01
    ],
    [
      "caracteristique",
      0.01
    ],
    [
      "amusant",
      0.01
    ],
    [
      "inedit",
      0.01
    ],
    [
      "personnel",
      0.01
    ],
    [
      "pittoresque",
      0.01
    ],
    [
      "tordu",
      0.01
    ],
    [
      "unique",
      0.01
    ],
    [
      "typique",
      0.0075
    ],
    [
      "type",
      0.0075
    ],
    [
      "farfelu",
      0.0075
    ],
    [
      "deconcertant",
      0.0075
    ],
    [
      "capricieux",
      0.0075
    ],
    [
      "specifique",
      0.005
    ],
    [
      "plaisant",
      0.005
    ],
    [
      "phenomene",
      0.005
    ],
    [
      "originalite",
      0.005
    ],
    [
      "incomparable",
      0.005
    ],
    [
      "fantaisiste",
      0.005
    ],
    [
      "distinct",
      0.005
    ],
    [
      "texte",
      0.0025
    ],
    [
      "saugrenu",
      0.0025
    ],
    [
      "premier",
      0.0025
    ],
    [
      "piquant",
      0.0025
    ],
    [
      "maniaque",
      0.0025
    ],
    [
      "independant",
      0.0025
    ],
    [
      "inaccoutume",
      0.0025
    ],
    [
      "drolatique",
      0.0025
    ],
    [
      "distinctif",
      0.0025
    ],
    [
      "cocasse",
      0.0025
    ],
    [
      "braque",
      0.0025
    ],
    [
      "princeps",
      0.0025
    ],
    [
      "prototype",
      0.0025
    ],
    [
      "vierge",
      0.0025
    ],
    [
      "energumene",
      0.0025
    ],
    [
      "inexperimente",
      0.0025
    ],
    [
      "heureux",
      0.0025
    ],
    [
      "buissonnier",
      0.0025
    ],
    [
      "different",
      0.0025
    ],
    [
      "document",
      0.0025
    ],
    [
      "hardi",
      0.0025
    ],
    [
      "numero",
      0.0
    ],
    [
      "olibrius",
      0.0
    ],
    [
      "originaire",
      0.0
    ],
    [
      "originel",
      0.0
    ],
    [
      "paradoxal",
      0.0
    ],
    [
      "personnage",
      0.0
    ],
    [
      "primitif",
      0.0
    ],
    [
      "recent",
      0.0
    ],
    [
      "revolutionnaire",
      0.0
    ],
    [
      "virginal",
      0.0
    ],
    [
      "modele",
      0.0
    ],
    [
      "minute",
      0.0
    ],
    [
      "authentique",
      0.0
    ],
    [
      "boheme",
      0.0
    ],
    [
      "chinois",
      0.0
    ],
    [
      "exquis",
      0.0
    ],
    [
      "genial",
      0.0
    ],
    [
      "inimagine",
      0.0
    ],
    [
      "inimitable",
      0.0
    ],
    [
      "initial",
      0.0
    ],
    [
      "irreductible",
      0.0
    ],
    [
      "manuscrit",
      0.0
    ],
    [
      "archetype",
      0.0
    ]
  ],
  "vigile": [
    [
      "garde",
      0.165
    ],
    [
      "jeune",
      0.165
    ],
    [
      "matines",
      0.165
    ],
    [
      "veille",
      0.165
    ]
  ],
  "vigil": [],
  "brevet": [
    [
      "certificat",
      0.165
    ],
    [
      "diplome",
      0.165
    ],
    [
      "titre",
      0.165
    ],
    [
      "patente",
      0.125
    ],
    [
      "licence",
      0.0825
    ],
    [
      "examen",
      0.0825
    ],
    [
      "acte",
      0.04
    ],
    [
      "commission",
      0.04
    ],
    [
      "garantie",
      0.04
    ],
    [
      "parchemin",
      0.04
    ],
    [
      "talisman",
      0.04
    ]
  ],
  "fonctionnaire": [
    [
      "agent",
      0.25
    ],
    [
      "employe",
      0.25
    ],
    [
      "commis",
      0.165
    ],
    [
      "administrateur",
      0.0825
    ],
    [
      "bureaucrate",
      0.0825
    ],
    [
      "prepose",
      0.0825
    ]
  ],
  "controleur": [
    [
      "inspecteur",
      0.215
    ],
    [
      "critique",
      0.1425
    ],
    [
      "voltmetre",
      0.07
    ],
    [
      "visiteur",
      0.07
    ],
    [
      "surveillant",
      0.07
    ],
    [
      "observateur",
      0.07
    ],
    [
      "mouchard",
      0.07
    ],
    [
      "juge",
      0.07
    ],
    [
      "censeur",
      0.07
    ],
    [
      "aiguilleur",
      0.07
    ],
    [
      "verificateur",
      0.07
    ]
  ],
  "paie": [
    [
      "retribution",
      0.155
    ],
    [
      "traitement",
      0.155
    ],
    [
      "appointements",
      0.125
    ],
    [
      "remuneration",
      0.125
    ],
    [
      "solde",
      0.0925
    ],
    [
      "salaire",
      0.0925
    ],
    [
      "paye",
      0.0925
    ],
    [
      "gages",
      0.03
    ],
    [
      "gain",
      0.03
    ],
    [
      "mois",
      0.03
    ],
    [
      "paiement",
      0.03
    ],
    [
      "pret",
      0.03
    ]
  ],
  "redouble": [
    [
      "augmenter",
      0.25
    ],
    [
      "doubler",
      0.105
    ],
    [
      "multiplier",
      0.105
    ],
    [
      "recommencer",
      0.07
    ],
    [
      "monter",
      0.07
    ],
    [
      "grandir",
      0.07
    ],
    [
      "aggraver",
      0.07
    ],
    [
      "accroitre",
      0.07
    ],
    [
      "ajouter",
      0.035
    ],
    [
      "redonner",
      0.035
    ],
    [
      "renouveler",
      0.035
    ],
    [
      "reiterer",
      0.035
    ]
  ],
  "bulletin": [
    [
      "billet",
      0.11
    ],
    [
      "journal",
      0.0775
    ],
    [
      "avis",
      0.0625
    ],
    [
      "revue",
      0.0625
    ],
    [
      "etat",
      0.045
    ],
    [
      "papier",
      0.045
    ],
    [
      "certificat",
      0.045
    ],
    [
      "annonce",
      0.045
    ],
    [
      "recu",
      0.03
    ],
    [
      "magazine",
      0.03
    ],
    [
      "lettre",
      0.03
    ],
    [
      "information",
      0.03
    ],
    [
      "feuille",
      0.03
    ],
    [
      "communique",
      0.03
    ],
    [
      "annales",
      0.03
    ],
    [
      "missive",
      0.015
    ],
    [
      "ordre",
      0.015
    ],
    [
      "proclamation",
      0.015
    ],
    [
      "periodique",
      0.015
    ],
    [
      "rapport",
      0.015
    ],
    [
      "releve",
      0.015
    ],
    [
      "recepisse",
      0.015
    ],
    [
      "lien",
      0.015
    ],
    [
      "hebdomadaire",
      0.015
    ],
    [
      "fiche",
      0.015
    ],
    [
      "cote",
      0.015
    ],
    [
      "constatation",
      0.015
    ],
    [
      "chronique",
      0.015
    ],
    [
      "carnet",
      0.015
    ],
    [
      "bordereau",
      0.015
    ],
    [
      "attestation",
      0.015
    ],
    [
      "acte",
      0.015
    ],
    [
      "ticket",
      0.015
    ]
  ],
  "kir": [
    [
      "cassis",
      0.5
    ]
  ],
  "directif": [
    [
      "autocratique",
      0.3325
    ],
    [
      "autoritaire",
      0.3325
    ],
    [
      "directionnel",
      0.3325
    ]
  ],
  "directive": [
    [
      "autocratique",
      0.3325
    ],
    [
      "autoritaire",
      0.3325
    ],
    [
      "directionnel",
      0.3325
    ]
  ],
  "ministere": [
    [
      "charge",
      0.1425
    ],
    [
      "intervention",
      0.1425
    ],
    [
      "fonction",
      0.105
    ],
    [
      "portefeuille",
      0.105
    ],
    [
      "sacerdoce",
      0.07
    ],
    [
      "office",
      0.07
    ],
    [
      "gouvernement",
      0.035
    ],
    [
      "entremise",
      0.035
    ],
    [
      "emploi",
      0.035
    ],
    [
      "departement",
      0.035
    ],
    [
      "concours",
      0.035
    ],
    [
      "cabinet",
      0.035
    ],
    [
      "apostolat",
      0.035
    ],
    [
      "maroquin",
      0.035
    ]
  ],
  "reunion": [
    [
      "assemblage",
      0.095
    ],
    [
      "association",
      0.0575
    ],
    [
      "union",
      0.0525
    ],
    [
      "groupe",
      0.045
    ],
    [
      "societe",
      0.0275
    ],
    [
      "agglomeration",
      0.0275
    ],
    [
      "assemblee",
      0.0275
    ],
    [
      "rassemblement",
      0.025
    ],
    [
      "groupement",
      0.025
    ],
    [
      "amas",
      0.025
    ],
    [
      "jonction",
      0.0175
    ],
    [
      "colonie",
      0.015
    ],
    [
      "ensemble",
      0.015
    ],
    [
      "alliance",
      0.015
    ],
    [
      "bloc",
      0.015
    ],
    [
      "tas",
      0.015
    ],
    [
      "melange",
      0.0125
    ],
    [
      "conference",
      0.0125
    ],
    [
      "concentration",
      0.0125
    ],
    [
      "accumulation",
      0.0125
    ],
    [
      "combinaison",
      0.0125
    ],
    [
      "compagnie",
      0.0125
    ],
    [
      "masse",
      0.0125
    ],
    [
      "symposium",
      0.0125
    ],
    [
      "congres",
      0.01
    ],
    [
      "troupe",
      0.0075
    ],
    [
      "coterie",
      0.0075
    ],
    [
      "colloque",
      0.0075
    ],
    [
      "clan",
      0.0075
    ],
    [
      "seminaire",
      0.0075
    ],
    [
      "rapprochement",
      0.0075
    ],
    [
      "conjonction",
      0.0075
    ],
    [
      "communaute",
      0.0075
    ],
    [
      "coalition",
      0.0075
    ],
    [
      "cercle",
      0.0075
    ],
    [
      "agglomerat",
      0.0075
    ],
    [
      "accouplement",
      0.0075
    ],
    [
      "session",
      0.005
    ],
    [
      "rencontre",
      0.005
    ],
    [
      "faisceau",
      0.005
    ],
    [
      "conciliabule",
      0.005
    ],
    [
      "collection",
      0.005
    ],
    [
      "assistance",
      0.005
    ],
    [
      "amalgame",
      0.005
    ],
    [
      "accord",
      0.005
    ],
    [
      "mariage",
      0.005
    ],
    [
      "liaison",
      0.005
    ],
    [
      "joint",
      0.005
    ],
    [
      "fete",
      0.005
    ],
    [
      "federation",
      0.005
    ],
    [
      "fusion",
      0.005
    ],
    [
      "debat",
      0.005
    ],
    [
      "cenacle",
      0.005
    ],
    [
      "conseil",
      0.005
    ],
    [
      "bouquet",
      0.005
    ],
    [
      "adjonction",
      0.005
    ],
    [
      "incorporation",
      0.0025
    ],
    [
      "ramas",
      0.0025
    ],
    [
      "synthese",
      0.0025
    ],
    [
      "ecole",
      0.0025
    ],
    [
      "festival",
      0.0025
    ],
    [
      "emboitement",
      0.0025
    ],
    [
      "contact",
      0.0025
    ],
    [
      "consistoire",
      0.0025
    ],
    [
      "conjugaison",
      0.0025
    ],
    [
      "annexion",
      0.0025
    ],
    [
      "adherence",
      0.0025
    ],
    [
      "juxtaposition",
      0.0025
    ],
    [
      "festivite",
      0.0025
    ],
    [
      "entassement",
      0.0025
    ],
    [
      "congregation",
      0.0025
    ],
    [
      "manifestation",
      0.0025
    ],
    [
      "meeting",
      0.0025
    ],
    [
      "ramassage",
      0.0025
    ],
    [
      "ramassis",
      0.0025
    ],
    [
      "rattachement",
      0.0025
    ],
    [
      "seance",
      0.0025
    ],
    [
      "selection",
      0.0025
    ],
    [
      "confederation",
      0.0025
    ],
    [
      "confusion",
      0.0025
    ],
    [
      "agregation",
      0.0025
    ],
    [
      "ajustage",
      0.0025
    ],
    [
      "assise",
      0.0025
    ],
    [
      "auditoire",
      0.0025
    ],
    [
      "carrefour",
      0.0025
    ],
    [
      "clique",
      0.0025
    ],
    [
      "comite",
      0.0025
    ],
    [
      "commission",
      0.0025
    ],
    [
      "complot",
      0.0025
    ],
    [
      "concile",
      0.0025
    ],
    [
      "confrerie",
      0.0025
    ],
    [
      "reception",
      0.0
    ],
    [
      "regroupement",
      0.0
    ],
    [
      "raout",
      0.0
    ],
    [
      "quarteron",
      0.0
    ],
    [
      "sauterie",
      0.0
    ],
    [
      "soiree",
      0.0
    ],
    [
      "syndicat",
      0.0
    ],
    [
      "synode",
      0.0
    ],
    [
      "senat",
      0.0
    ],
    [
      "totalite",
      0.0
    ],
    [
      "zeugme",
      0.0
    ],
    [
      "provision",
      0.0
    ],
    [
      "montage",
      0.0
    ],
    [
      "hymen",
      0.0
    ],
    [
      "affluence",
      0.0
    ],
    [
      "areopage",
      0.0
    ],
    [
      "briefing",
      0.0
    ],
    [
      "centralisation",
      0.0
    ],
    [
      "chambree",
      0.0
    ],
    [
      "chapitre",
      0.0
    ],
    [
      "choix",
      0.0
    ],
    [
      "comice",
      0.0
    ],
    [
      "convergence",
      0.0
    ],
    [
      "couple",
      0.0
    ],
    [
      "entrevue",
      0.0
    ],
    [
      "gerbe",
      0.0
    ]
  ],
  "regulier": [
    [
      "exact",
      0.0775
    ],
    [
      "honnete",
      0.0725
    ],
    [
      "normal",
      0.0425
    ],
    [
      "constant",
      0.04
    ],
    [
      "fidele",
      0.04
    ],
    [
      "regle",
      0.035
    ],
    [
      "legal",
      0.025
    ],
    [
      "logique",
      0.025
    ],
    [
      "correct",
      0.025
    ],
    [
      "egal",
      0.02
    ],
    [
      "uniforme",
      0.02
    ],
    [
      "suivi",
      0.02
    ],
    [
      "solide",
      0.02
    ],
    [
      "proportionne",
      0.02
    ],
    [
      "net",
      0.02
    ],
    [
      "loyal",
      0.02
    ],
    [
      "convenable",
      0.02
    ],
    [
      "continu",
      0.02
    ],
    [
      "rythme",
      0.0175
    ],
    [
      "precis",
      0.0175
    ],
    [
      "ponctuel",
      0.0175
    ],
    [
      "ordonne",
      0.0175
    ],
    [
      "invariable",
      0.0175
    ],
    [
      "harmonieux",
      0.0175
    ],
    [
      "fixe",
      0.0175
    ],
    [
      "droit",
      0.0175
    ],
    [
      "canonique",
      0.0175
    ],
    [
      "valable",
      0.0125
    ],
    [
      "stable",
      0.0125
    ],
    [
      "reglementaire",
      0.0125
    ],
    [
      "periodique",
      0.0125
    ],
    [
      "mesure",
      0.0125
    ],
    [
      "licite",
      0.0125
    ],
    [
      "irreprochable",
      0.0125
    ],
    [
      "frequent",
      0.0125
    ],
    [
      "authentique",
      0.0125
    ],
    [
      "assidu",
      0.0125
    ],
    [
      "tranquille",
      0.0075
    ],
    [
      "successif",
      0.0075
    ],
    [
      "range",
      0.0075
    ],
    [
      "progressif",
      0.0075
    ],
    [
      "ordinaire",
      0.0075
    ],
    [
      "moral",
      0.0075
    ],
    [
      "homogene",
      0.0075
    ],
    [
      "tolere",
      0.0025
    ],
    [
      "symetrique",
      0.0025
    ],
    [
      "soutenu",
      0.0025
    ],
    [
      "reglo",
      0.0025
    ],
    [
      "permis",
      0.0025
    ],
    [
      "monotone",
      0.0025
    ],
    [
      "monastique",
      0.0025
    ],
    [
      "moine",
      0.0025
    ],
    [
      "homme",
      0.0025
    ],
    [
      "geometrique",
      0.0025
    ],
    [
      "cadence",
      0.0025
    ],
    [
      "valide",
      0.0025
    ]
  ],
  "planifier": [
    [
      "organiser",
      0.25
    ],
    [
      "etablir",
      0.0825
    ],
    [
      "prevoir",
      0.0825
    ],
    [
      "programmer",
      0.0825
    ],
    [
      "ordonner",
      0.0825
    ],
    [
      "diriger",
      0.0825
    ],
    [
      "calculer",
      0.0825
    ],
    [
      "administrer",
      0.0825
    ],
    [
      "ceduler",
      0.04
    ],
    [
      "orchestrer",
      0.04
    ],
    [
      "projeter",
      0.04
    ]
  ],
  "sanction": [
    [
      "condamnation",
      0.125
    ],
    [
      "censure",
      0.1
    ],
    [
      "punition",
      0.1
    ],
    [
      "blame",
      0.075
    ],
    [
      "peine",
      0.075
    ],
    [
      "ratification",
      0.075
    ],
    [
      "confirmation",
      0.05
    ],
    [
      "chatiment",
      0.05
    ],
    [
      "approbation",
      0.05
    ],
    [
      "suspension",
      0.0225
    ],
    [
      "repression",
      0.0225
    ],
    [
      "rancon",
      0.0225
    ],
    [
      "jugement",
      0.0225
    ],
    [
      "homologation",
      0.0225
    ],
    [
      "consecration",
      0.0225
    ],
    [
      "avertissement",
      0.0225
    ],
    [
      "apanage",
      0.0225
    ],
    [
      "amende",
      0.0225
    ],
    [
      "adoption",
      0.0225
    ],
    [
      "tribut",
      0.0225
    ]
  ],
  "encouragement": [
    [
      "aide",
      0.1125
    ],
    [
      "soutien",
      0.1125
    ],
    [
      "appui",
      0.085
    ],
    [
      "service",
      0.085
    ],
    [
      "eloge",
      0.055
    ],
    [
      "soulagement",
      0.055
    ],
    [
      "recompense",
      0.055
    ],
    [
      "applaudissement",
      0.055
    ],
    [
      "stimulant",
      0.0275
    ],
    [
      "reconfort",
      0.0275
    ],
    [
      "protection",
      0.0275
    ],
    [
      "prix",
      0.0275
    ],
    [
      "prime",
      0.0275
    ],
    [
      "louange",
      0.0275
    ],
    [
      "incitation",
      0.0275
    ],
    [
      "exhortation",
      0.0275
    ],
    [
      "excitation",
      0.0275
    ],
    [
      "compliment",
      0.0275
    ],
    [
      "approbation",
      0.0275
    ],
    [
      "aiguillon",
      0.0275
    ],
    [
      "subvention",
      0.0275
    ]
  ],
  "evaluation": [
    [
      "estimation",
      0.1825
    ],
    [
      "calcul",
      0.13
    ],
    [
      "appreciation",
      0.105
    ],
    [
      "mesure",
      0.0775
    ],
    [
      "revue",
      0.0525
    ],
    [
      "prix",
      0.0525
    ],
    [
      "examen",
      0.0525
    ],
    [
      "determination",
      0.0525
    ],
    [
      "recensement",
      0.025
    ],
    [
      "prisee",
      0.025
    ],
    [
      "majoration",
      0.025
    ],
    [
      "inventaire",
      0.025
    ],
    [
      "expertise",
      0.025
    ],
    [
      "denombrement",
      0.025
    ],
    [
      "diagnostic",
      0.025
    ],
    [
      "comparaison",
      0.025
    ],
    [
      "arbitrage",
      0.025
    ],
    [
      "approximation",
      0.025
    ],
    [
      "valeur",
      0.025
    ]
  ],
  "perturber": [
    [
      "troubler",
      0.1725
    ],
    [
      "bouleverser",
      0.1325
    ],
    [
      "deranger",
      0.12
    ],
    [
      "brouiller",
      0.0925
    ],
    [
      "remuer",
      0.065
    ],
    [
      "destabiliser",
      0.0525
    ],
    [
      "secouer",
      0.0375
    ],
    [
      "ebranler",
      0.0375
    ],
    [
      "tournebouler",
      0.025
    ],
    [
      "toucher",
      0.025
    ],
    [
      "detraquer",
      0.025
    ],
    [
      "desorganiser",
      0.025
    ],
    [
      "deregler",
      0.025
    ],
    [
      "chahuter",
      0.025
    ],
    [
      "agiter",
      0.025
    ],
    [
      "parasiter",
      0.0125
    ],
    [
      "mouvementer",
      0.0125
    ],
    [
      "interrompre",
      0.0125
    ],
    [
      "embrouiller",
      0.0125
    ],
    [
      "desequilibrer",
      0.0125
    ],
    [
      "traumatiser",
      0.0125
    ]
  ],
  "simplifier": [
    [
      "abreger",
      0.125
    ],
    [
      "axiomatiser",
      0.125
    ],
    [
      "decompliquer",
      0.125
    ],
    [
      "faciliter",
      0.125
    ],
    [
      "reduire",
      0.125
    ],
    [
      "schematiser",
      0.125
    ],
    [
      "styliser",
      0.125
    ],
    [
      "ecourter",
      0.125
    ]
  ],
  "propose": [
    [
      "presenter",
      0.1825
    ],
    [
      "offrir",
      0.1575
    ],
    [
      "avancer",
      0.13
    ],
    [
      "exposer",
      0.105
    ],
    [
      "soumettre",
      0.105
    ],
    [
      "enoncer",
      0.0525
    ],
    [
      "suggerer",
      0.0525
    ],
    [
      "agiter",
      0.025
    ],
    [
      "conseiller",
      0.025
    ],
    [
      "montrer",
      0.025
    ],
    [
      "promettre",
      0.025
    ],
    [
      "preter",
      0.025
    ]
  ],
  "surpayer": [],
  "rendement": [
    [
      "produit",
      0.17
    ],
    [
      "efficacite",
      0.1025
    ],
    [
      "gain",
      0.1025
    ],
    [
      "revenu",
      0.0675
    ],
    [
      "rapport",
      0.0675
    ],
    [
      "profit",
      0.0675
    ],
    [
      "productivite",
      0.0675
    ],
    [
      "benefice",
      0.0675
    ],
    [
      "recette",
      0.0325
    ],
    [
      "production",
      0.0325
    ],
    [
      "force",
      0.0325
    ],
    [
      "fertilite",
      0.0325
    ],
    [
      "efficience",
      0.0325
    ],
    [
      "effet",
      0.0325
    ],
    [
      "amortissement",
      0.0325
    ],
    [
      "recolte",
      0.0325
    ]
  ],
  "investissement": [
    [
      "financement",
      0.1525
    ],
    [
      "placement",
      0.1525
    ],
    [
      "siege",
      0.1525
    ],
    [
      "engagement",
      0.075
    ],
    [
      "encerclement",
      0.075
    ],
    [
      "blocus",
      0.075
    ],
    [
      "avance",
      0.075
    ],
    [
      "apport",
      0.075
    ],
    [
      "aide",
      0.075
    ]
  ],
  "arrangeant": [
    [
      "accommodant",
      0.18
    ],
    [
      "complaisant",
      0.18
    ],
    [
      "conciliant",
      0.18
    ],
    [
      "facile",
      0.18
    ],
    [
      "commode",
      0.09
    ],
    [
      "coulant",
      0.09
    ],
    [
      "traitable",
      0.09
    ]
  ],
  "songer": [
    [
      "penser",
      0.1775
    ],
    [
      "envisager",
      0.0875
    ],
    [
      "imaginer",
      0.0725
    ],
    [
      "projeter",
      0.0725
    ],
    [
      "evoquer",
      0.0575
    ],
    [
      "s'occuper",
      0.0575
    ],
    [
      "rever",
      0.0575
    ],
    [
      "reflechir",
      0.0275
    ],
    [
      "revivre",
      0.0275
    ],
    [
      "mediter",
      0.0275
    ],
    [
      "gamberger",
      0.0275
    ],
    [
      "considerer",
      0.0275
    ],
    [
      "compter",
      0.0275
    ],
    [
      "s'aviser",
      0.0125
    ],
    [
      "revasser",
      0.0125
    ],
    [
      "revoir",
      0.0125
    ],
    [
      "rappeler",
      0.0125
    ],
    [
      "veiller",
      0.0125
    ]
  ],
  "eveille": [
    [
      "exciter",
      0.2025
    ],
    [
      "soulever",
      0.07
    ],
    [
      "reveiller",
      0.0575
    ],
    [
      "stimuler",
      0.0575
    ],
    [
      "susciter",
      0.0575
    ],
    [
      "evoquer",
      0.0425
    ],
    [
      "tirer",
      0.0425
    ],
    [
      "provoquer",
      0.0425
    ],
    [
      "piquer",
      0.0425
    ],
    [
      "aviver",
      0.0425
    ],
    [
      "animer",
      0.0425
    ],
    [
      "aiguillonner",
      0.0425
    ],
    [
      "reveler",
      0.0275
    ],
    [
      "ouvrir",
      0.0275
    ],
    [
      "fouetter",
      0.0275
    ],
    [
      "fomenter",
      0.0275
    ],
    [
      "developper",
      0.0275
    ],
    [
      "attirer",
      0.0275
    ],
    [
      "alarmer",
      0.0125
    ],
    [
      "declencher",
      0.0125
    ],
    [
      "s'attirer",
      0.0125
    ]
  ],
  "avertir": [
    [
      "annoncer",
      0.1025
    ],
    [
      "informer",
      0.0975
    ],
    [
      "signaler",
      0.0875
    ],
    [
      "instruire",
      0.06
    ],
    [
      "apprendre",
      0.045
    ],
    [
      "prevenir",
      0.045
    ],
    [
      "dire",
      0.04
    ],
    [
      "aviser",
      0.04
    ],
    [
      "indiquer",
      0.035
    ],
    [
      "montrer",
      0.03
    ],
    [
      "alerter",
      0.025
    ],
    [
      "detromper",
      0.02
    ],
    [
      "crier",
      0.02
    ],
    [
      "sommer",
      0.015
    ],
    [
      "renseigner",
      0.015
    ],
    [
      "notifier",
      0.015
    ],
    [
      "denoncer",
      0.015
    ],
    [
      "conseiller",
      0.015
    ],
    [
      "representer",
      0.0075
    ],
    [
      "reprimander",
      0.0075
    ],
    [
      "sermonner",
      0.0075
    ],
    [
      "sonner",
      0.0075
    ],
    [
      "tancer",
      0.0075
    ],
    [
      "eclairer",
      0.0075
    ],
    [
      "recommander",
      0.0075
    ],
    [
      "presager",
      0.0075
    ],
    [
      "admonester",
      0.0075
    ],
    [
      "appeler",
      0.0075
    ],
    [
      "corner",
      0.0075
    ],
    [
      "menacer",
      0.0075
    ],
    [
      "premunir",
      0.0025
    ],
    [
      "klaxonner",
      0.0025
    ],
    [
      "insinuer",
      0.0025
    ],
    [
      "bousculer",
      0.0025
    ],
    [
      "sensibiliser",
      0.0025
    ]
  ],
  "averti": [
    [
      "habile",
      0.1225
    ],
    [
      "savant",
      0.105
    ],
    [
      "avise",
      0.09
    ],
    [
      "instruit",
      0.09
    ],
    [
      "eclaire",
      0.075
    ],
    [
      "experimente",
      0.075
    ],
    [
      "expert",
      0.075
    ],
    [
      "competent",
      0.045
    ],
    [
      "informe",
      0.045
    ],
    [
      "prudent",
      0.045
    ],
    [
      "sage",
      0.045
    ],
    [
      "prepare",
      0.03
    ],
    [
      "adulte",
      0.0125
    ],
    [
      "virtuose",
      0.0125
    ],
    [
      "fin",
      0.0125
    ],
    [
      "exerce",
      0.0125
    ],
    [
      "desabuse",
      0.0125
    ],
    [
      "dessale",
      0.0125
    ],
    [
      "emancipe",
      0.0125
    ]
  ],
  "degueulasse": [
    [
      "degoutant",
      0.13
    ],
    [
      "repugnant",
      0.13
    ],
    [
      "abject",
      0.1075
    ],
    [
      "infect",
      0.0825
    ],
    [
      "sale",
      0.07
    ],
    [
      "ignoble",
      0.07
    ],
    [
      "malpropre",
      0.0575
    ],
    [
      "nauseabond",
      0.0575
    ],
    [
      "horrible",
      0.045
    ],
    [
      "ecoeurant",
      0.035
    ],
    [
      "repoussant",
      0.035
    ],
    [
      "salope",
      0.0225
    ],
    [
      "salaud",
      0.0225
    ],
    [
      "revoltant",
      0.0225
    ],
    [
      "odieux",
      0.0225
    ],
    [
      "obscene",
      0.0225
    ],
    [
      "debectant",
      0.01
    ],
    [
      "moche",
      0.01
    ],
    [
      "pourri",
      0.01
    ]
  ],
  "degueulasser": [],
  "pretention": [
    [
      "orgueil",
      0.0925
    ],
    [
      "vanite",
      0.0875
    ],
    [
      "desir",
      0.0525
    ],
    [
      "presomption",
      0.0525
    ],
    [
      "superbe",
      0.0525
    ],
    [
      "suffisance",
      0.045
    ],
    [
      "fatuite",
      0.04
    ],
    [
      "infatuation",
      0.04
    ],
    [
      "soif",
      0.0325
    ],
    [
      "revendication",
      0.0325
    ],
    [
      "fierte",
      0.0325
    ],
    [
      "affectation",
      0.025
    ],
    [
      "demande",
      0.025
    ],
    [
      "exigence",
      0.025
    ],
    [
      "forfanterie",
      0.025
    ],
    [
      "outrecuidance",
      0.025
    ],
    [
      "sottise",
      0.02
    ],
    [
      "pose",
      0.02
    ],
    [
      "desiderata",
      0.02
    ],
    [
      "bouffissure",
      0.02
    ],
    [
      "arrogance",
      0.02
    ],
    [
      "ambition",
      0.02
    ],
    [
      "visee",
      0.0125
    ],
    [
      "vanterie",
      0.0125
    ],
    [
      "reclamation",
      0.0125
    ],
    [
      "neant",
      0.0125
    ],
    [
      "emphase",
      0.0125
    ],
    [
      "doleance",
      0.0125
    ],
    [
      "cranerie",
      0.0125
    ],
    [
      "requete",
      0.005
    ],
    [
      "immodestie",
      0.005
    ],
    [
      "gloriole",
      0.005
    ],
    [
      "esperance",
      0.005
    ],
    [
      "embarras",
      0.005
    ],
    [
      "dessein",
      0.005
    ],
    [
      "condition",
      0.005
    ],
    [
      "baudruche",
      0.005
    ],
    [
      "appret",
      0.005
    ],
    [
      "vantardise",
      0.005
    ]
  ],
  "reputation": [
    [
      "renommee",
      0.125
    ],
    [
      "gloire",
      0.1
    ],
    [
      "consideration",
      0.0875
    ],
    [
      "renom",
      0.075
    ],
    [
      "popularite",
      0.075
    ],
    [
      "celebrite",
      0.075
    ],
    [
      "credit",
      0.075
    ],
    [
      "estime",
      0.0625
    ],
    [
      "honneur",
      0.05
    ],
    [
      "prestige",
      0.05
    ],
    [
      "vogue",
      0.0375
    ],
    [
      "illustration",
      0.0375
    ],
    [
      "autorite",
      0.025
    ],
    [
      "lustre",
      0.025
    ],
    [
      "notoriete",
      0.025
    ],
    [
      "aloi",
      0.0125
    ],
    [
      "cote",
      0.0125
    ],
    [
      "memoire",
      0.0125
    ],
    [
      "nom",
      0.0125
    ],
    [
      "resonance",
      0.0125
    ]
  ],
  "coi": [
    [
      "silencieux",
      0.2
    ],
    [
      "tranquille",
      0.2
    ],
    [
      "abasourdi",
      0.1
    ],
    [
      "muet",
      0.1
    ],
    [
      "pantois",
      0.1
    ],
    [
      "quiet",
      0.1
    ],
    [
      "sidere",
      0.1
    ],
    [
      "stupefait",
      0.1
    ]
  ],
  "medire": [
    [
      "denigrer",
      0.135
    ],
    [
      "discrediter",
      0.0875
    ],
    [
      "calomnier",
      0.0675
    ],
    [
      "critiquer",
      0.055
    ],
    [
      "debiner",
      0.045
    ],
    [
      "diffamer",
      0.04
    ],
    [
      "jaser",
      0.04
    ],
    [
      "ereinter",
      0.035
    ],
    [
      "vilipender",
      0.035
    ],
    [
      "gloser",
      0.035
    ],
    [
      "clabauder",
      0.035
    ],
    [
      "becher",
      0.03
    ],
    [
      "baver",
      0.025
    ],
    [
      "deblaterer",
      0.025
    ],
    [
      "dechirer",
      0.025
    ],
    [
      "esquinter",
      0.02
    ],
    [
      "dauber",
      0.02
    ],
    [
      "cancaner",
      0.02
    ],
    [
      "attaquer",
      0.02
    ],
    [
      "abimer",
      0.02
    ],
    [
      "decrier",
      0.015
    ],
    [
      "commerer",
      0.015
    ],
    [
      "arranger",
      0.015
    ],
    [
      "nuire",
      0.01
    ],
    [
      "habiller",
      0.01
    ],
    [
      "fabriquer",
      0.01
    ],
    [
      "dire",
      0.01
    ],
    [
      "croasser",
      0.01
    ],
    [
      "coasser",
      0.01
    ],
    [
      "satiriser",
      0.0025
    ],
    [
      "repandre",
      0.0025
    ],
    [
      "ragoter",
      0.0025
    ],
    [
      "potiner",
      0.0025
    ],
    [
      "detracter",
      0.0025
    ],
    [
      "deshabiller",
      0.0025
    ],
    [
      "decauser",
      0.0025
    ],
    [
      "babiller",
      0.0025
    ],
    [
      "taper",
      0.0025
    ]
  ],
  "malchanceux": [
    [
      "malheureux",
      0.4275
    ],
    [
      "afflige",
      0.1425
    ],
    [
      "deveinard",
      0.1425
    ],
    [
      "guignard",
      0.1425
    ],
    [
      "malencontreux",
      0.1425
    ]
  ],
  "jatte": [
    [
      "bol",
      0.4425
    ],
    [
      "bolee",
      0.11
    ],
    [
      "coupe",
      0.11
    ],
    [
      "jattee",
      0.11
    ],
    [
      "recipient",
      0.11
    ],
    [
      "tasse",
      0.11
    ]
  ],
  "ver": [
    [
      "appat",
      0.165
    ],
    [
      "chenille",
      0.165
    ],
    [
      "esche",
      0.165
    ],
    [
      "larve",
      0.165
    ],
    [
      "stongle",
      0.165
    ],
    [
      "vermisseau",
      0.165
    ]
  ],
  "gente": [],
  "gent": [
    [
      "race",
      0.22
    ],
    [
      "beau",
      0.11
    ],
    [
      "classe",
      0.11
    ],
    [
      "espece",
      0.11
    ],
    [
      "famille",
      0.11
    ],
    [
      "gentil",
      0.11
    ],
    [
      "nation",
      0.11
    ],
    [
      "peuple",
      0.11
    ]
  ],
  "los": [
    [
      "louange",
      0.5
    ],
    [
      "eloge",
      0.5
    ]
  ],
  "caller": [],
  "patrouille": [
    [
      "armee",
      0.2
    ],
    [
      "detachement",
      0.2
    ],
    [
      "guet",
      0.2
    ],
    [
      "surveillance",
      0.2
    ],
    [
      "troupe",
      0.2
    ]
  ],
  "patrouiller": [
    [
      "patouiller",
      0.25
    ],
    [
      "manier",
      0.125
    ],
    [
      "parcourir",
      0.125
    ],
    [
      "patauger",
      0.125
    ],
    [
      "surveiller",
      0.125
    ],
    [
      "tripatouiller",
      0.125
    ],
    [
      "tripoter",
      0.125
    ]
  ],
  "acheminer": [
    [
      "conduire",
      0.1475
    ],
    [
      "expedier",
      0.1475
    ],
    [
      "transporter",
      0.1475
    ],
    [
      "envoyer",
      0.1
    ],
    [
      "diriger",
      0.1
    ],
    [
      "convoyer",
      0.1
    ],
    [
      "adresser",
      0.0475
    ],
    [
      "amener",
      0.0475
    ],
    [
      "canaliser",
      0.0475
    ]
  ],
  "pesamment": [
    [
      "lourdement",
      0.4
    ],
    [
      "gauchement",
      0.2
    ],
    [
      "maladroitement",
      0.2
    ],
    [
      "massivement",
      0.2
    ]
  ],
  "circuler": [
    [
      "courir",
      0.1475
    ],
    [
      "couler",
      0.11
    ],
    [
      "voyager",
      0.0725
    ],
    [
      "rouler",
      0.055
    ],
    [
      "passer",
      0.055
    ],
    [
      "partir",
      0.055
    ],
    [
      "naviguer",
      0.055
    ],
    [
      "sillonner",
      0.035
    ],
    [
      "degager",
      0.035
    ],
    [
      "affluer",
      0.0175
    ],
    [
      "decamper",
      0.0175
    ],
    [
      "s'agiter",
      0.0175
    ]
  ],
  "militairement": [
    [
      "rapidement",
      0.3325
    ],
    [
      "resolument",
      0.3325
    ]
  ],
  "inutilement": [
    [
      "vainement",
      0.3325
    ],
    [
      "sterilement",
      0.165
    ]
  ],
  "flaner": [
    [
      "trainer",
      0.155
    ],
    [
      "errer",
      0.085
    ],
    [
      "musarder",
      0.085
    ],
    [
      "roder",
      0.0625
    ],
    [
      "muser",
      0.0575
    ],
    [
      "vagabonder",
      0.05
    ],
    [
      "baguenauder",
      0.045
    ],
    [
      "marcher",
      0.04
    ],
    [
      "trainasser",
      0.0325
    ],
    [
      "s'amuser",
      0.0325
    ],
    [
      "lambiner",
      0.0225
    ],
    [
      "lanterner",
      0.0225
    ],
    [
      "vadrouiller",
      0.0225
    ],
    [
      "vaguer",
      0.015
    ],
    [
      "paresser",
      0.015
    ],
    [
      "faineanter",
      0.015
    ],
    [
      "deambuler",
      0.015
    ],
    [
      "badauder",
      0.015
    ],
    [
      "folatrer",
      0.01
    ],
    [
      "flanocher",
      0.01
    ],
    [
      "batifoler",
      0.01
    ],
    [
      "s'attarder",
      0.005
    ],
    [
      "flemmarder",
      0.005
    ],
    [
      "clampiner",
      0.005
    ],
    [
      "boulevarder",
      0.005
    ],
    [
      "balocher",
      0.005
    ],
    [
      "bader",
      0.005
    ],
    [
      "s'egarer",
      0.005
    ]
  ],
  "envouter": [
    [
      "seduire",
      0.16
    ],
    [
      "charmer",
      0.125
    ],
    [
      "ensorceler",
      0.105
    ],
    [
      "captiver",
      0.0875
    ],
    [
      "subjuguer",
      0.07
    ],
    [
      "tenter",
      0.0525
    ],
    [
      "fasciner",
      0.0525
    ],
    [
      "conquerir",
      0.0525
    ],
    [
      "troubler",
      0.035
    ],
    [
      "gagner",
      0.035
    ],
    [
      "enflammer",
      0.035
    ],
    [
      "enchanter",
      0.035
    ],
    [
      "assujettir",
      0.035
    ],
    [
      "affrioler",
      0.035
    ],
    [
      "dominer",
      0.0175
    ],
    [
      "fanatiser",
      0.0175
    ],
    [
      "hypnotiser",
      0.0175
    ],
    [
      "suggestionner",
      0.0175
    ]
  ],
  "envoutant": [
    [
      "seduire",
      0.16
    ],
    [
      "charmer",
      0.125
    ],
    [
      "ensorceler",
      0.105
    ],
    [
      "captiver",
      0.0875
    ],
    [
      "subjuguer",
      0.07
    ],
    [
      "tenter",
      0.0525
    ],
    [
      "fasciner",
      0.0525
    ],
    [
      "conquerir",
      0.0525
    ],
    [
      "troubler",
      0.035
    ],
    [
      "gagner",
      0.035
    ],
    [
      "enflammer",
      0.035
    ],
    [
      "enchanter",
      0.035
    ],
    [
      "assujettir",
      0.035
    ],
    [
      "affrioler",
      0.035
    ],
    [
      "dominer",
      0.0175
    ],
    [
      "fanatiser",
      0.0175
    ],
    [
      "hypnotiser",
      0.0175
    ],
    [
      "suggestionner",
      0.0175
    ]
  ],
  "serpenter": [
    [
      "onduler",
      0.1575
    ],
    [
      "s'infiltrer",
      0.105
    ],
    [
      "tourner",
      0.105
    ],
    [
      "tournoyer",
      0.105
    ],
    [
      "zigzaguer",
      0.105
    ],
    [
      "sinuer",
      0.05
    ],
    [
      "s'insinuer",
      0.05
    ],
    [
      "glisser",
      0.05
    ],
    [
      "virer",
      0.05
    ]
  ],
  "bazar": [
    [
      "desordre",
      0.0825
    ],
    [
      "affaire",
      0.0675
    ],
    [
      "bordel",
      0.0675
    ],
    [
      "bastringue",
      0.0625
    ],
    [
      "fourbi",
      0.0625
    ],
    [
      "attirail",
      0.055
    ],
    [
      "boutique",
      0.04
    ],
    [
      "vacarme",
      0.025
    ],
    [
      "tapage",
      0.025
    ],
    [
      "foutoir",
      0.025
    ],
    [
      "capharnaum",
      0.025
    ],
    [
      "boite",
      0.025
    ],
    [
      "bataclan",
      0.025
    ],
    [
      "barda",
      0.025
    ],
    [
      "magasin",
      0.02
    ],
    [
      "fourniment",
      0.02
    ],
    [
      "chantier",
      0.02
    ],
    [
      "bidule",
      0.02
    ],
    [
      "bagage",
      0.02
    ],
    [
      "souk",
      0.0125
    ],
    [
      "marche",
      0.0125
    ],
    [
      "machin",
      0.0125
    ],
    [
      "chaos",
      0.0125
    ],
    [
      "chahut",
      0.0125
    ],
    [
      "bruit",
      0.0125
    ],
    [
      "bahut",
      0.0125
    ],
    [
      "amas",
      0.0125
    ],
    [
      "merdier",
      0.005
    ],
    [
      "passage",
      0.005
    ],
    [
      "tas",
      0.005
    ],
    [
      "toutim",
      0.005
    ],
    [
      "vitrine",
      0.005
    ],
    [
      "lycee",
      0.005
    ],
    [
      "galerie",
      0.005
    ],
    [
      "chenil",
      0.005
    ],
    [
      "bouillabaisse",
      0.005
    ],
    [
      "binz",
      0.005
    ],
    [
      "bimbeloterie",
      0.005
    ],
    [
      "bibeloterie",
      0.005
    ],
    [
      "bataille",
      0.005
    ],
    [
      "ecole",
      0.005
    ]
  ],
  "jasmin": [],
  "senteur": [
    [
      "odeur",
      0.1525
    ],
    [
      "relent",
      0.1075
    ],
    [
      "exhalaison",
      0.09
    ],
    [
      "fumet",
      0.09
    ],
    [
      "emanation",
      0.075
    ],
    [
      "puanteur",
      0.075
    ],
    [
      "arome",
      0.075
    ],
    [
      "parfum",
      0.06
    ],
    [
      "effluve",
      0.045
    ],
    [
      "pestilence",
      0.03
    ],
    [
      "fetidite",
      0.03
    ],
    [
      "empyreume",
      0.03
    ],
    [
      "bouquet",
      0.015
    ],
    [
      "fragrance",
      0.015
    ],
    [
      "gout",
      0.015
    ],
    [
      "infection",
      0.015
    ],
    [
      "remugle",
      0.015
    ],
    [
      "trace",
      0.015
    ],
    [
      "vent",
      0.015
    ]
  ],
  "gourmand": [
    [
      "amoureux",
      0.08
    ],
    [
      "friand",
      0.08
    ],
    [
      "glouton",
      0.08
    ],
    [
      "passionne",
      0.0525
    ],
    [
      "gourmet",
      0.0525
    ],
    [
      "goulu",
      0.0525
    ],
    [
      "goinfre",
      0.0525
    ],
    [
      "amateur",
      0.0525
    ],
    [
      "avide",
      0.04
    ],
    [
      "fanatique",
      0.04
    ],
    [
      "gastronome",
      0.04
    ],
    [
      "vorace",
      0.025
    ],
    [
      "mordu",
      0.025
    ],
    [
      "bafreur",
      0.025
    ],
    [
      "ripailleur",
      0.0125
    ],
    [
      "piffre",
      0.0125
    ],
    [
      "lecheur",
      0.0125
    ],
    [
      "lucullus",
      0.0125
    ],
    [
      "intemperant",
      0.0125
    ],
    [
      "gueulard",
      0.0125
    ],
    [
      "gastronomique",
      0.0125
    ],
    [
      "gastrolatre",
      0.0125
    ],
    [
      "enrage",
      0.0125
    ],
    [
      "bequillard",
      0.0125
    ],
    [
      "briffaud",
      0.0125
    ],
    [
      "branche",
      0.0125
    ],
    [
      "agreable",
      0.0125
    ],
    [
      "sybarite",
      0.0125
    ]
  ],
  "marchander": [
    [
      "barguigner",
      0.0975
    ],
    [
      "chicaner",
      0.0975
    ],
    [
      "lesiner",
      0.0775
    ],
    [
      "plaindre",
      0.0775
    ],
    [
      "economiser",
      0.0775
    ],
    [
      "liarder",
      0.0575
    ],
    [
      "hesiter",
      0.0575
    ],
    [
      "discuter",
      0.0575
    ],
    [
      "chipoter",
      0.0575
    ],
    [
      "tergiverser",
      0.0375
    ],
    [
      "regretter",
      0.0375
    ],
    [
      "pleurer",
      0.0375
    ],
    [
      "menager",
      0.0375
    ],
    [
      "palabrer",
      0.0175
    ],
    [
      "mesurer",
      0.0175
    ],
    [
      "marchandailler",
      0.0175
    ],
    [
      "debattre",
      0.0175
    ],
    [
      "brocanter",
      0.0175
    ],
    [
      "bibeloter",
      0.0175
    ],
    [
      "acheter",
      0.0175
    ],
    [
      "tortiller",
      0.0175
    ]
  ],
  "chale": [
    [
      "fichu",
      0.3
    ],
    [
      "pointe",
      0.2
    ],
    [
      "carre",
      0.1
    ],
    [
      "cheret",
      0.1
    ],
    [
      "mouchoir",
      0.1
    ],
    [
      "sautoir",
      0.1
    ],
    [
      "echarpe",
      0.1
    ]
  ],
  "soie": [
    [
      "bombasin",
      0.04
    ],
    [
      "marceline",
      0.04
    ],
    [
      "organsin",
      0.04
    ],
    [
      "poil",
      0.04
    ],
    [
      "ponge",
      0.04
    ],
    [
      "pekin",
      0.04
    ],
    [
      "reps",
      0.04
    ],
    [
      "satin",
      0.04
    ],
    [
      "surah",
      0.04
    ],
    [
      "taffetas",
      0.04
    ],
    [
      "tussor",
      0.04
    ],
    [
      "levantine",
      0.04
    ],
    [
      "lampas",
      0.04
    ],
    [
      "brocart",
      0.04
    ],
    [
      "brosse",
      0.04
    ],
    [
      "cellulose",
      0.04
    ],
    [
      "cocon",
      0.04
    ],
    [
      "crepe",
      0.04
    ],
    [
      "faille",
      0.04
    ],
    [
      "fibre",
      0.04
    ],
    [
      "foulard",
      0.04
    ],
    [
      "grege",
      0.04
    ],
    [
      "verrofibre",
      0.04
    ]
  ],
  "dedale": [
    [
      "labyrinthe",
      0.1825
    ],
    [
      "enchevetrement",
      0.13
    ],
    [
      "confusion",
      0.105
    ],
    [
      "detour",
      0.105
    ],
    [
      "complication",
      0.0775
    ],
    [
      "embrouillamini",
      0.0775
    ],
    [
      "reseau",
      0.05
    ],
    [
      "repli",
      0.05
    ],
    [
      "meandre",
      0.05
    ],
    [
      "brouillamini",
      0.05
    ],
    [
      "catacombe",
      0.025
    ],
    [
      "lacis",
      0.025
    ],
    [
      "secret",
      0.025
    ],
    [
      "echeveau",
      0.025
    ]
  ],
  "conduit": [
    [
      "diriger",
      0.075
    ],
    [
      "mener",
      0.075
    ],
    [
      "entrainer",
      0.065
    ],
    [
      "pousser",
      0.065
    ],
    [
      "gouverner",
      0.0425
    ],
    [
      "guider",
      0.0375
    ],
    [
      "transporter",
      0.0325
    ],
    [
      "amener",
      0.025
    ],
    [
      "inspirer",
      0.0225
    ],
    [
      "determiner",
      0.0225
    ],
    [
      "commander",
      0.0225
    ],
    [
      "animer",
      0.02
    ],
    [
      "attirer",
      0.02
    ],
    [
      "exciter",
      0.02
    ],
    [
      "porter",
      0.02
    ],
    [
      "conseiller",
      0.0175
    ],
    [
      "soulever",
      0.0175
    ],
    [
      "elever",
      0.015
    ],
    [
      "agir",
      0.015
    ],
    [
      "accompagner",
      0.015
    ],
    [
      "jeter",
      0.0125
    ],
    [
      "mettre",
      0.0125
    ],
    [
      "regenter",
      0.0125
    ],
    [
      "regir",
      0.0125
    ],
    [
      "trainer",
      0.01
    ],
    [
      "piloter",
      0.01
    ],
    [
      "persuader",
      0.01
    ],
    [
      "manoeuvrer",
      0.01
    ],
    [
      "manier",
      0.01
    ],
    [
      "emmener",
      0.01
    ],
    [
      "conclure",
      0.01
    ],
    [
      "administrer",
      0.01
    ],
    [
      "regler",
      0.0075
    ],
    [
      "introduire",
      0.0075
    ],
    [
      "distribuer",
      0.0075
    ],
    [
      "chaperonner",
      0.0075
    ],
    [
      "canaliser",
      0.0075
    ],
    [
      "aller",
      0.0075
    ],
    [
      "eduquer",
      0.005
    ],
    [
      "presider",
      0.005
    ],
    [
      "promener",
      0.005
    ],
    [
      "orienter",
      0.005
    ],
    [
      "influencer",
      0.005
    ],
    [
      "induire",
      0.005
    ],
    [
      "gerer",
      0.005
    ],
    [
      "escorter",
      0.005
    ],
    [
      "acheminer",
      0.005
    ],
    [
      "aboutir",
      0.005
    ],
    [
      "raisonner",
      0.0025
    ],
    [
      "reconduire",
      0.0025
    ],
    [
      "reduire",
      0.0025
    ],
    [
      "surveiller",
      0.0025
    ],
    [
      "terminer",
      0.0025
    ],
    [
      "deduire",
      0.0025
    ],
    [
      "acculer",
      0.0025
    ],
    [
      "achever",
      0.0025
    ],
    [
      "capter",
      0.0025
    ],
    [
      "convaincre",
      0.0025
    ],
    [
      "convoyer",
      0.0025
    ],
    [
      "descendre",
      0.0025
    ],
    [
      "transmettre",
      0.0
    ],
    [
      "tailler",
      0.0
    ],
    [
      "raccompagner",
      0.0
    ],
    [
      "poursuivre",
      0.0
    ],
    [
      "manager",
      0.0
    ],
    [
      "initier",
      0.0
    ],
    [
      "deboucher",
      0.0
    ],
    [
      "drainer",
      0.0
    ],
    [
      "construire",
      0.0
    ],
    [
      "tyranniser",
      0.0
    ]
  ],
  "detenir": [
    [
      "tenir",
      0.155
    ],
    [
      "avoir",
      0.0875
    ],
    [
      "emprisonner",
      0.0875
    ],
    [
      "garder",
      0.0875
    ],
    [
      "renfermer",
      0.0875
    ],
    [
      "posseder",
      0.065
    ],
    [
      "sequestrer",
      0.0425
    ],
    [
      "retenir",
      0.0425
    ],
    [
      "rester",
      0.0425
    ],
    [
      "receler",
      0.0425
    ],
    [
      "occuper",
      0.0425
    ],
    [
      "interner",
      0.0425
    ],
    [
      "enfermer",
      0.0425
    ],
    [
      "disposer",
      0.0425
    ],
    [
      "conserver",
      0.0425
    ],
    [
      "incarcerer",
      0.02
    ]
  ],
  "progresser": [
    [
      "croitre",
      0.0975
    ],
    [
      "marcher",
      0.0975
    ],
    [
      "avancer",
      0.085
    ],
    [
      "aller",
      0.0725
    ],
    [
      "profiter",
      0.06
    ],
    [
      "s'etendre",
      0.06
    ],
    [
      "prosperer",
      0.0475
    ],
    [
      "gagner",
      0.035
    ],
    [
      "s'accroitre",
      0.035
    ],
    [
      "s'avancer",
      0.035
    ],
    [
      "evoluer",
      0.0225
    ],
    [
      "s'ameliorer",
      0.0225
    ],
    [
      "s'aggraver",
      0.0225
    ],
    [
      "monter",
      0.0225
    ],
    [
      "cingler",
      0.0225
    ],
    [
      "cheminer",
      0.0225
    ],
    [
      "proceder",
      0.01
    ],
    [
      "murir",
      0.01
    ],
    [
      "empirer",
      0.01
    ],
    [
      "developper",
      0.01
    ],
    [
      "commencer",
      0.01
    ],
    [
      "s'amender",
      0.01
    ]
  ],
  "dissimuler": [
    [
      "cacher",
      0.1275
    ],
    [
      "deguiser",
      0.09
    ],
    [
      "voiler",
      0.0675
    ],
    [
      "camoufler",
      0.06
    ],
    [
      "masquer",
      0.06
    ],
    [
      "couvrir",
      0.0475
    ],
    [
      "rentrer",
      0.035
    ],
    [
      "travestir",
      0.035
    ],
    [
      "etouffer",
      0.03
    ],
    [
      "refouler",
      0.03
    ],
    [
      "farder",
      0.03
    ],
    [
      "escamoter",
      0.03
    ],
    [
      "tromper",
      0.0225
    ],
    [
      "renfoncer",
      0.0225
    ],
    [
      "renfermer",
      0.0225
    ],
    [
      "envelopper",
      0.0225
    ],
    [
      "derober",
      0.0225
    ],
    [
      "taire",
      0.0175
    ],
    [
      "recouvrir",
      0.0175
    ],
    [
      "pallier",
      0.0175
    ],
    [
      "maquiller",
      0.0175
    ],
    [
      "celer",
      0.0175
    ],
    [
      "attenuer",
      0.0175
    ],
    [
      "tricher",
      0.01
    ],
    [
      "murer",
      0.01
    ],
    [
      "habiller",
      0.01
    ],
    [
      "feindre",
      0.01
    ],
    [
      "concentrer",
      0.01
    ],
    [
      "glisser",
      0.005
    ],
    [
      "frauder",
      0.005
    ],
    [
      "estomper",
      0.005
    ],
    [
      "enfouir",
      0.005
    ],
    [
      "abriter",
      0.005
    ],
    [
      "soustraire",
      0.005
    ]
  ],
  "guichet": [
    [
      "bureau",
      0.2675
    ],
    [
      "office",
      0.1325
    ],
    [
      "ouverture",
      0.1325
    ],
    [
      "station",
      0.065
    ],
    [
      "porte",
      0.065
    ],
    [
      "officine",
      0.065
    ],
    [
      "judas",
      0.065
    ],
    [
      "caisse",
      0.065
    ],
    [
      "cagibi",
      0.065
    ],
    [
      "succursale",
      0.065
    ]
  ],
  "contreplaque": [
    [
      "toc",
      1.0
    ]
  ],
  "agglomerer": [
    [
      "reunir",
      0.1675
    ],
    [
      "assembler",
      0.1375
    ],
    [
      "amasser",
      0.0825
    ],
    [
      "unir",
      0.0675
    ],
    [
      "rassembler",
      0.055
    ],
    [
      "entasser",
      0.055
    ],
    [
      "conglomerer",
      0.055
    ],
    [
      "agreger",
      0.055
    ],
    [
      "agglutiner",
      0.055
    ],
    [
      "melanger",
      0.04
    ],
    [
      "accumuler",
      0.04
    ],
    [
      "coller",
      0.0275
    ],
    [
      "masser",
      0.0275
    ],
    [
      "meler",
      0.0275
    ],
    [
      "entremeler",
      0.0125
    ],
    [
      "empiler",
      0.0125
    ],
    [
      "cristalliser",
      0.0125
    ],
    [
      "attrouper",
      0.0125
    ],
    [
      "amonceler",
      0.0125
    ]
  ],
  "agglomere": [
    [
      "reunir",
      0.1675
    ],
    [
      "assembler",
      0.1375
    ],
    [
      "amasser",
      0.0825
    ],
    [
      "unir",
      0.0675
    ],
    [
      "rassembler",
      0.055
    ],
    [
      "entasser",
      0.055
    ],
    [
      "conglomerer",
      0.055
    ],
    [
      "agreger",
      0.055
    ],
    [
      "agglutiner",
      0.055
    ],
    [
      "melanger",
      0.04
    ],
    [
      "accumuler",
      0.04
    ],
    [
      "coller",
      0.0275
    ],
    [
      "masser",
      0.0275
    ],
    [
      "meler",
      0.0275
    ],
    [
      "entremeler",
      0.0125
    ],
    [
      "empiler",
      0.0125
    ],
    [
      "cristalliser",
      0.0125
    ],
    [
      "attrouper",
      0.0125
    ],
    [
      "amonceler",
      0.0125
    ]
  ],
  "timbrer": [
    [
      "cacheter",
      0.285
    ],
    [
      "affranchir",
      0.1425
    ],
    [
      "estampiller",
      0.1425
    ],
    [
      "marquer",
      0.1425
    ],
    [
      "surmonter",
      0.1425
    ],
    [
      "tamponner",
      0.1425
    ]
  ],
  "timbre": [
    [
      "ton",
      0.1025
    ],
    [
      "sonnerie",
      0.0675
    ],
    [
      "son",
      0.0675
    ],
    [
      "griffe",
      0.0675
    ],
    [
      "cloche",
      0.0675
    ],
    [
      "cachet",
      0.0675
    ],
    [
      "bassin",
      0.0675
    ],
    [
      "voix",
      0.0325
    ],
    [
      "vignette",
      0.0325
    ],
    [
      "tampon",
      0.0325
    ],
    [
      "sonorite",
      0.0325
    ],
    [
      "sonnette",
      0.0325
    ],
    [
      "sceau",
      0.0325
    ],
    [
      "reservoir",
      0.0325
    ],
    [
      "marque",
      0.0325
    ],
    [
      "grelot",
      0.0325
    ],
    [
      "fontaine",
      0.0325
    ],
    [
      "clochette",
      0.0325
    ],
    [
      "bac",
      0.0325
    ],
    [
      "affranchissement",
      0.0325
    ],
    [
      "evier",
      0.0325
    ]
  ],
  "hygiaphone": [],
  "interphone": [
    [
      "parlophone",
      1.0
    ]
  ],
  "electrophone": [
    [
      "phono",
      0.125
    ],
    [
      "phonographe",
      0.125
    ],
    [
      "platine",
      0.125
    ]
  ],
  "megaphone": [],
  "aquarium": [
    [
      "reservoir",
      1.0
    ]
  ],
  "mouchoir": [
    [
      "fichu",
      0.25
    ],
    [
      "coiffure",
      0.165
    ],
    [
      "fanchon",
      0.165
    ],
    [
      "foulard",
      0.165
    ],
    [
      "pointe",
      0.165
    ],
    [
      "chale",
      0.0825
    ]
  ],
  "chevalier": [
    [
      "cavalier",
      0.1375
    ],
    [
      "page",
      0.09
    ],
    [
      "ecuyer",
      0.09
    ],
    [
      "paladin",
      0.045
    ],
    [
      "preux",
      0.045
    ],
    [
      "sigisbee",
      0.045
    ],
    [
      "suzerain",
      0.045
    ],
    [
      "tenant",
      0.045
    ],
    [
      "varlet",
      0.045
    ],
    [
      "noble",
      0.045
    ],
    [
      "gambette",
      0.045
    ],
    [
      "galant",
      0.045
    ],
    [
      "defenseur",
      0.045
    ],
    [
      "champion",
      0.045
    ],
    [
      "becasson",
      0.045
    ],
    [
      "bachelier",
      0.045
    ],
    [
      "aigrefin",
      0.045
    ],
    [
      "vassal",
      0.045
    ]
  ],
  "menacer": [
    [
      "attendre",
      0.07
    ],
    [
      "avertir",
      0.07
    ],
    [
      "braver",
      0.07
    ],
    [
      "defier",
      0.07
    ],
    [
      "presager",
      0.07
    ],
    [
      "tonner",
      0.07
    ],
    [
      "narguer",
      0.035
    ],
    [
      "provoquer",
      0.035
    ],
    [
      "risquer",
      0.035
    ],
    [
      "sommer",
      0.035
    ],
    [
      "intimider",
      0.035
    ],
    [
      "inquieter",
      0.035
    ],
    [
      "guetter",
      0.035
    ],
    [
      "gronder",
      0.035
    ],
    [
      "fulminer",
      0.035
    ],
    [
      "effrayer",
      0.035
    ],
    [
      "assombrir",
      0.035
    ]
  ],
  "menace": [
    [
      "avertissement",
      0.105
    ],
    [
      "defi",
      0.105
    ],
    [
      "bravade",
      0.07
    ],
    [
      "sommation",
      0.07
    ],
    [
      "ultimatum",
      0.07
    ],
    [
      "provocation",
      0.035
    ],
    [
      "presage",
      0.035
    ],
    [
      "peril",
      0.035
    ],
    [
      "risque",
      0.035
    ],
    [
      "rodomontade",
      0.035
    ],
    [
      "reprimande",
      0.035
    ],
    [
      "pression",
      0.035
    ],
    [
      "intimidation",
      0.035
    ],
    [
      "insulte",
      0.035
    ],
    [
      "grondement",
      0.035
    ],
    [
      "fulmination",
      0.035
    ],
    [
      "danger",
      0.035
    ],
    [
      "commination",
      0.035
    ],
    [
      "chantage",
      0.035
    ],
    [
      "spectre",
      0.035
    ]
  ],
  "cameleon": [
    [
      "girouette",
      0.285
    ],
    [
      "changeant",
      0.1425
    ],
    [
      "hypocrite",
      0.1425
    ],
    [
      "pantin",
      0.1425
    ],
    [
      "protee",
      0.1425
    ],
    [
      "tartufe",
      0.1425
    ]
  ],
  "rebondir": [
    [
      "bondir",
      0.1525
    ],
    [
      "recommencer",
      0.1525
    ],
    [
      "ricocher",
      0.1525
    ],
    [
      "resonner",
      0.075
    ],
    [
      "retentir",
      0.075
    ],
    [
      "reprendre",
      0.075
    ],
    [
      "repartir",
      0.075
    ],
    [
      "renaitre",
      0.075
    ],
    [
      "rejaillir",
      0.075
    ],
    [
      "sauter",
      0.075
    ]
  ],
  "desemparer": [
    [
      "disloquer",
      0.25
    ],
    [
      "deboussoler",
      0.125
    ],
    [
      "deconcerter",
      0.125
    ],
    [
      "demancher",
      0.125
    ],
    [
      "demanteler",
      0.125
    ],
    [
      "desaxer",
      0.125
    ],
    [
      "intimider",
      0.125
    ]
  ],
  "desempare": [
    [
      "disloquer",
      0.25
    ],
    [
      "deboussoler",
      0.125
    ],
    [
      "deconcerter",
      0.125
    ],
    [
      "demancher",
      0.125
    ],
    [
      "demanteler",
      0.125
    ],
    [
      "desaxer",
      0.125
    ],
    [
      "intimider",
      0.125
    ]
  ],
  "ecrase": [
    [
      "broyer",
      0.0625
    ],
    [
      "aneantir",
      0.05
    ],
    [
      "briser",
      0.05
    ],
    [
      "abattre",
      0.0425
    ],
    [
      "accabler",
      0.0425
    ],
    [
      "vaincre",
      0.035
    ],
    [
      "battre",
      0.035
    ],
    [
      "pulveriser",
      0.03
    ],
    [
      "detruire",
      0.0275
    ],
    [
      "aplatir",
      0.0275
    ],
    [
      "enfoncer",
      0.0275
    ],
    [
      "triompher",
      0.0225
    ],
    [
      "renverser",
      0.02
    ],
    [
      "triturer",
      0.02
    ],
    [
      "presser",
      0.0175
    ],
    [
      "casser",
      0.0175
    ],
    [
      "opprimer",
      0.015
    ],
    [
      "foudroyer",
      0.015
    ],
    [
      "fouler",
      0.0125
    ],
    [
      "froisser",
      0.0125
    ],
    [
      "etouffer",
      0.0125
    ],
    [
      "terrasser",
      0.0125
    ],
    [
      "piler",
      0.0125
    ],
    [
      "moudre",
      0.0125
    ],
    [
      "fatiguer",
      0.0125
    ],
    [
      "culbuter",
      0.0125
    ],
    [
      "tuer",
      0.01
    ],
    [
      "surpasser",
      0.01
    ],
    [
      "peser",
      0.01
    ],
    [
      "oppresser",
      0.01
    ],
    [
      "ecrabouiller",
      0.0075
    ],
    [
      "tomber",
      0.0075
    ],
    [
      "serrer",
      0.0075
    ],
    [
      "ruiner",
      0.0075
    ],
    [
      "rabaisser",
      0.0075
    ],
    [
      "humilier",
      0.0075
    ],
    [
      "enchainer",
      0.0075
    ],
    [
      "comprimer",
      0.0075
    ],
    [
      "abaisser",
      0.0075
    ],
    [
      "pressurer",
      0.005
    ],
    [
      "surclasser",
      0.005
    ],
    [
      "surmonter",
      0.005
    ],
    [
      "tasser",
      0.005
    ],
    [
      "meurtrir",
      0.005
    ],
    [
      "l'emporter",
      0.005
    ],
    [
      "dominer",
      0.005
    ],
    [
      "concasser",
      0.005
    ],
    [
      "charger",
      0.005
    ],
    [
      "bombarder",
      0.005
    ],
    [
      "blesser",
      0.005
    ],
    [
      "etonner",
      0.005
    ],
    [
      "epater",
      0.005
    ],
    [
      "tyranniser",
      0.005
    ],
    [
      "grever",
      0.005
    ],
    [
      "bigorner",
      0.005
    ],
    [
      "abrutir",
      0.005
    ],
    [
      "abasourdir",
      0.005
    ],
    [
      "eclipser",
      0.0025
    ],
    [
      "surmener",
      0.0025
    ],
    [
      "surcharger",
      0.0025
    ],
    [
      "rouler",
      0.0025
    ],
    [
      "petrir",
      0.0025
    ],
    [
      "pilonner",
      0.0025
    ],
    [
      "inonder",
      0.0025
    ],
    [
      "balayer",
      0.0025
    ],
    [
      "bousiller",
      0.0025
    ],
    [
      "consterner",
      0.0025
    ],
    [
      "deborder",
      0.0025
    ],
    [
      "gorger",
      0.0025
    ],
    [
      "egruger",
      0.0
    ],
    [
      "eclabousser",
      0.0
    ],
    [
      "ecacher",
      0.0
    ],
    [
      "rapetisser",
      0.0
    ],
    [
      "machurer",
      0.0
    ],
    [
      "macher",
      0.0
    ],
    [
      "mouliner",
      0.0
    ],
    [
      "laminer",
      0.0
    ],
    [
      "croquer",
      0.0
    ],
    [
      "compresser",
      0.0
    ],
    [
      "etriller",
      0.0
    ]
  ],
  "enchaine": [
    [
      "assujettir",
      0.1025
    ],
    [
      "attacher",
      0.0625
    ],
    [
      "lier",
      0.055
    ],
    [
      "soumettre",
      0.0525
    ],
    [
      "tenir",
      0.0475
    ],
    [
      "retenir",
      0.0425
    ],
    [
      "contenir",
      0.035
    ],
    [
      "museler",
      0.0325
    ],
    [
      "asservir",
      0.0325
    ],
    [
      "fixer",
      0.0275
    ],
    [
      "etouffer",
      0.0275
    ],
    [
      "dompter",
      0.025
    ],
    [
      "maitriser",
      0.0225
    ],
    [
      "dominer",
      0.0225
    ],
    [
      "contraindre",
      0.0225
    ],
    [
      "astreindre",
      0.0225
    ],
    [
      "captiver",
      0.0175
    ],
    [
      "opprimer",
      0.0175
    ],
    [
      "ecraser",
      0.015
    ],
    [
      "tyranniser",
      0.015
    ],
    [
      "subjuguer",
      0.015
    ],
    [
      "river",
      0.015
    ],
    [
      "garrotter",
      0.015
    ],
    [
      "courber",
      0.015
    ],
    [
      "unir",
      0.0125
    ],
    [
      "obliger",
      0.0125
    ],
    [
      "maintenir",
      0.0125
    ],
    [
      "ligoter",
      0.0125
    ],
    [
      "immobiliser",
      0.0125
    ],
    [
      "empecher",
      0.0125
    ],
    [
      "emprisonner",
      0.0125
    ],
    [
      "baillonner",
      0.0125
    ],
    [
      "atteler",
      0.0125
    ],
    [
      "reunir",
      0.0075
    ],
    [
      "plier",
      0.0075
    ],
    [
      "joindre",
      0.0075
    ],
    [
      "associer",
      0.0075
    ],
    [
      "amarrer",
      0.0075
    ],
    [
      "vassaliser",
      0.005
    ],
    [
      "relier",
      0.005
    ],
    [
      "enlacer",
      0.005
    ],
    [
      "agencer",
      0.005
    ],
    [
      "marier",
      0.0025
    ],
    [
      "jointoyer",
      0.0025
    ],
    [
      "engrener",
      0.0025
    ],
    [
      "domestiquer",
      0.0025
    ],
    [
      "coordonner",
      0.0025
    ],
    [
      "charpenter",
      0.0025
    ],
    [
      "charger",
      0.0025
    ],
    [
      "allier",
      0.0025
    ],
    [
      "s'atteler",
      0.0025
    ]
  ],
  "elancer": [
    [
      "darder",
      0.5
    ],
    [
      "lancer",
      0.5
    ]
  ],
  "farandole": [
    [
      "danse",
      0.4275
    ],
    [
      "chaine",
      0.1425
    ],
    [
      "chevauchee",
      0.1425
    ],
    [
      "ronde",
      0.1425
    ],
    [
      "sarabande",
      0.1425
    ]
  ],
  "souder": [
    [
      "assembler",
      0.1525
    ],
    [
      "joindre",
      0.1525
    ],
    [
      "reunir",
      0.1525
    ],
    [
      "unir",
      0.1525
    ],
    [
      "conglomerer",
      0.075
    ],
    [
      "conglutiner",
      0.075
    ],
    [
      "raccorder",
      0.0375
    ],
    [
      "fusionner",
      0.0375
    ],
    [
      "braser",
      0.0375
    ],
    [
      "accoler",
      0.0375
    ],
    [
      "solidariser",
      0.0375
    ]
  ],
  "soude": [
    [
      "assembler",
      0.1525
    ],
    [
      "joindre",
      0.1525
    ],
    [
      "reunir",
      0.1525
    ],
    [
      "unir",
      0.1525
    ],
    [
      "conglomerer",
      0.075
    ],
    [
      "conglutiner",
      0.075
    ],
    [
      "raccorder",
      0.0375
    ],
    [
      "fusionner",
      0.0375
    ],
    [
      "braser",
      0.0375
    ],
    [
      "accoler",
      0.0375
    ],
    [
      "solidariser",
      0.0375
    ]
  ],
  "enlacer": [
    [
      "enserrer",
      0.1325
    ],
    [
      "entourer",
      0.1175
    ],
    [
      "serrer",
      0.1175
    ],
    [
      "ceindre",
      0.0725
    ],
    [
      "embrasser",
      0.0725
    ],
    [
      "encercler",
      0.0725
    ],
    [
      "etreindre",
      0.0725
    ],
    [
      "attacher",
      0.0575
    ],
    [
      "ceinturer",
      0.0575
    ],
    [
      "ligoter",
      0.0425
    ],
    [
      "accoler",
      0.0275
    ],
    [
      "enchainer",
      0.0275
    ],
    [
      "entrelacer",
      0.0275
    ],
    [
      "lier",
      0.0275
    ],
    [
      "caresser",
      0.0125
    ],
    [
      "croiser",
      0.0125
    ],
    [
      "entrecroiser",
      0.0125
    ],
    [
      "museler",
      0.0125
    ]
  ],
  "eclabousser": [
    [
      "salir",
      0.1175
    ],
    [
      "souiller",
      0.1175
    ],
    [
      "tacher",
      0.1175
    ],
    [
      "rejaillir",
      0.0575
    ],
    [
      "mouiller",
      0.0575
    ],
    [
      "moucheter",
      0.0575
    ],
    [
      "impressionner",
      0.0575
    ],
    [
      "gicler",
      0.0575
    ],
    [
      "enfoncer",
      0.0575
    ],
    [
      "couvrir",
      0.0575
    ],
    [
      "briller",
      0.0575
    ],
    [
      "asperger",
      0.0575
    ],
    [
      "arroser",
      0.0575
    ],
    [
      "ecraser",
      0.0575
    ]
  ],
  "rejaillir": [
    [
      "gicler",
      0.23
    ],
    [
      "jaillir",
      0.1525
    ],
    [
      "ricocher",
      0.1525
    ],
    [
      "couler",
      0.075
    ],
    [
      "fuser",
      0.075
    ],
    [
      "rebondir",
      0.075
    ],
    [
      "retomber",
      0.075
    ],
    [
      "eclabousser",
      0.075
    ]
  ],
  "trainee": [
    [
      "flaner",
      0.08
    ],
    [
      "durer",
      0.04
    ],
    [
      "rester",
      0.0375
    ],
    [
      "errer",
      0.035
    ],
    [
      "musarder",
      0.035
    ],
    [
      "demeurer",
      0.0325
    ],
    [
      "subsister",
      0.03
    ],
    [
      "trainasser",
      0.03
    ],
    [
      "lambiner",
      0.025
    ],
    [
      "entrainer",
      0.025
    ],
    [
      "continuer",
      0.025
    ],
    [
      "lanterner",
      0.0225
    ],
    [
      "muser",
      0.0225
    ],
    [
      "s'eterniser",
      0.0225
    ],
    [
      "mener",
      0.02
    ],
    [
      "roder",
      0.02
    ],
    [
      "tenir",
      0.02
    ],
    [
      "transporter",
      0.02
    ],
    [
      "vagabonder",
      0.0175
    ],
    [
      "s'attarder",
      0.0175
    ],
    [
      "baguenauder",
      0.0125
    ],
    [
      "conduire",
      0.0125
    ],
    [
      "tarder",
      0.01
    ],
    [
      "s'amuser",
      0.01
    ],
    [
      "retarder",
      0.01
    ],
    [
      "marcher",
      0.01
    ],
    [
      "emporter",
      0.01
    ],
    [
      "attirer",
      0.01
    ],
    [
      "amener",
      0.01
    ],
    [
      "vadrouiller",
      0.0075
    ],
    [
      "tirer",
      0.0075
    ],
    [
      "survivre",
      0.0075
    ],
    [
      "s'etendre",
      0.0075
    ],
    [
      "promener",
      0.0075
    ],
    [
      "perseverer",
      0.0075
    ],
    [
      "emmener",
      0.0075
    ],
    [
      "charrier",
      0.0075
    ],
    [
      "badauder",
      0.0075
    ],
    [
      "temporiser",
      0.005
    ],
    [
      "tomber",
      0.005
    ],
    [
      "touer",
      0.005
    ],
    [
      "vaguer",
      0.005
    ],
    [
      "resister",
      0.005
    ],
    [
      "pendiller",
      0.005
    ],
    [
      "differer",
      0.005
    ],
    [
      "faineanter",
      0.005
    ],
    [
      "flanocher",
      0.005
    ],
    [
      "galvauder",
      0.005
    ],
    [
      "moisir",
      0.005
    ],
    [
      "paresser",
      0.005
    ],
    [
      "s'enliser",
      0.0025
    ],
    [
      "s'egarer",
      0.0025
    ],
    [
      "traduire",
      0.0025
    ],
    [
      "trainailler",
      0.0025
    ],
    [
      "trimballer",
      0.0025
    ],
    [
      "troler",
      0.0025
    ],
    [
      "vivre",
      0.0025
    ],
    [
      "zoner",
      0.0025
    ],
    [
      "rodailler",
      0.0025
    ],
    [
      "retomber",
      0.0025
    ],
    [
      "remorquer",
      0.0025
    ],
    [
      "bader",
      0.0025
    ],
    [
      "balayer",
      0.0025
    ],
    [
      "balocher",
      0.0025
    ],
    [
      "clampiner",
      0.0025
    ],
    [
      "dormir",
      0.0025
    ],
    [
      "folatrer",
      0.0025
    ],
    [
      "languir",
      0.0025
    ],
    [
      "occasionner",
      0.0025
    ],
    [
      "atteler",
      0.0025
    ]
  ],
  "emporte": [
    [
      "enlever",
      0.0925
    ],
    [
      "prendre",
      0.09
    ],
    [
      "entrainer",
      0.08
    ],
    [
      "conquerir",
      0.0475
    ],
    [
      "gagner",
      0.045
    ],
    [
      "forcer",
      0.04
    ],
    [
      "obtenir",
      0.03
    ],
    [
      "transporter",
      0.03
    ],
    [
      "voler",
      0.025
    ],
    [
      "pousser",
      0.025
    ],
    [
      "arracher",
      0.025
    ],
    [
      "aneantir",
      0.025
    ],
    [
      "attirer",
      0.02
    ],
    [
      "ravir",
      0.02
    ],
    [
      "rouler",
      0.0175
    ],
    [
      "s'emparer",
      0.0175
    ],
    [
      "supprimer",
      0.0175
    ],
    [
      "trainer",
      0.0175
    ],
    [
      "vaincre",
      0.0175
    ],
    [
      "rompre",
      0.0175
    ],
    [
      "remporter",
      0.0175
    ],
    [
      "ratiboiser",
      0.0175
    ],
    [
      "porter",
      0.0175
    ],
    [
      "emmener",
      0.0175
    ],
    [
      "embarquer",
      0.0175
    ],
    [
      "detruire",
      0.0175
    ],
    [
      "charrier",
      0.0175
    ],
    [
      "triompher",
      0.0125
    ],
    [
      "soustraire",
      0.0125
    ],
    [
      "rafler",
      0.0125
    ],
    [
      "couper",
      0.0125
    ],
    [
      "balayer",
      0.0125
    ],
    [
      "acquerir",
      0.0125
    ],
    [
      "tuer",
      0.0075
    ],
    [
      "ratisser",
      0.0075
    ],
    [
      "piller",
      0.0075
    ],
    [
      "impliquer",
      0.0075
    ],
    [
      "enflammer",
      0.0075
    ],
    [
      "devaster",
      0.0075
    ],
    [
      "submerger",
      0.0025
    ],
    [
      "renfermer",
      0.0025
    ],
    [
      "rallier",
      0.0025
    ],
    [
      "exterminer",
      0.0025
    ],
    [
      "devancer",
      0.0025
    ],
    [
      "comporter",
      0.0025
    ],
    [
      "bercer",
      0.0025
    ],
    [
      "eparpiller",
      0.0025
    ]
  ],
  "crisper": [
    [
      "agacer",
      0.115
    ],
    [
      "exasperer",
      0.115
    ],
    [
      "irriter",
      0.115
    ],
    [
      "turlupiner",
      0.115
    ],
    [
      "enerver",
      0.075
    ],
    [
      "horripiler",
      0.075
    ],
    [
      "convulser",
      0.075
    ],
    [
      "contracter",
      0.075
    ],
    [
      "herisser",
      0.0375
    ],
    [
      "impatienter",
      0.0375
    ],
    [
      "resserrer",
      0.0375
    ],
    [
      "rider",
      0.0375
    ],
    [
      "serrer",
      0.0375
    ]
  ],
  "rengaine": [
    [
      "refrain",
      0.17
    ],
    [
      "antienne",
      0.105
    ],
    [
      "chanson",
      0.105
    ],
    [
      "ritournelle",
      0.105
    ],
    [
      "repetition",
      0.085
    ],
    [
      "scie",
      0.0625
    ],
    [
      "romance",
      0.0625
    ],
    [
      "chant",
      0.0625
    ],
    [
      "rabachage",
      0.04
    ],
    [
      "redite",
      0.02
    ],
    [
      "leitmotiv",
      0.02
    ],
    [
      "guitare",
      0.02
    ],
    [
      "dada",
      0.02
    ],
    [
      "couplet",
      0.02
    ],
    [
      "bergerade",
      0.02
    ],
    [
      "banalite",
      0.02
    ],
    [
      "aria",
      0.02
    ],
    [
      "tube",
      0.02
    ]
  ],
  "lamenter": [],
  "alarme": [
    [
      "inquietude",
      0.095
    ],
    [
      "frayeur",
      0.0625
    ],
    [
      "crainte",
      0.0575
    ],
    [
      "epouvante",
      0.0575
    ],
    [
      "angoisse",
      0.0475
    ],
    [
      "effroi",
      0.0475
    ],
    [
      "peur",
      0.0475
    ],
    [
      "transe",
      0.0475
    ],
    [
      "alerte",
      0.045
    ],
    [
      "affres",
      0.035
    ],
    [
      "frousse",
      0.035
    ],
    [
      "emotion",
      0.035
    ],
    [
      "affolement",
      0.0275
    ],
    [
      "emoi",
      0.0275
    ],
    [
      "anxiete",
      0.0225
    ],
    [
      "tourment",
      0.0225
    ],
    [
      "terreur",
      0.0175
    ],
    [
      "avertissement",
      0.0175
    ],
    [
      "souci",
      0.0125
    ],
    [
      "signal",
      0.0125
    ],
    [
      "danger",
      0.0125
    ],
    [
      "apprehension",
      0.0125
    ],
    [
      "appel",
      0.0125
    ],
    [
      "tracas",
      0.0075
    ],
    [
      "panique",
      0.0075
    ],
    [
      "crise",
      0.0075
    ],
    [
      "cri",
      0.0075
    ],
    [
      "S.O.S.",
      0.0025
    ],
    [
      "sirene",
      0.0025
    ],
    [
      "tocsin",
      0.0025
    ],
    [
      "eveil",
      0.0025
    ]
  ],
  "alarmer": [
    [
      "affoler",
      0.1225
    ],
    [
      "inquieter",
      0.1225
    ],
    [
      "agiter",
      0.1
    ],
    [
      "effrayer",
      0.09
    ],
    [
      "epouvanter",
      0.0775
    ],
    [
      "troubler",
      0.065
    ],
    [
      "terroriser",
      0.055
    ],
    [
      "angoisser",
      0.045
    ],
    [
      "effaroucher",
      0.045
    ],
    [
      "tourmenter",
      0.0325
    ],
    [
      "terrifier",
      0.0325
    ],
    [
      "effarer",
      0.0325
    ],
    [
      "emouvoir",
      0.02
    ],
    [
      "tracasser",
      0.02
    ],
    [
      "remuer",
      0.02
    ],
    [
      "preoccuper",
      0.02
    ],
    [
      "alerter",
      0.01
    ],
    [
      "offenser",
      0.01
    ],
    [
      "paniquer",
      0.01
    ],
    [
      "eveiller",
      0.01
    ]
  ],
  "pudeur": [
    [
      "retenue",
      0.1075
    ],
    [
      "reserve",
      0.1075
    ],
    [
      "decence",
      0.08
    ],
    [
      "honnetete",
      0.06
    ],
    [
      "vertu",
      0.06
    ],
    [
      "honte",
      0.0525
    ],
    [
      "tenue",
      0.0525
    ],
    [
      "chastete",
      0.04
    ],
    [
      "respect",
      0.0325
    ],
    [
      "purete",
      0.0325
    ],
    [
      "honneur",
      0.0325
    ],
    [
      "bienseance",
      0.025
    ],
    [
      "continence",
      0.025
    ],
    [
      "discretion",
      0.025
    ],
    [
      "delicatesse",
      0.025
    ],
    [
      "modestie",
      0.025
    ],
    [
      "tact",
      0.0175
    ],
    [
      "sagesse",
      0.0175
    ],
    [
      "pudicite",
      0.0175
    ],
    [
      "timidite",
      0.0125
    ],
    [
      "scrupule",
      0.0125
    ],
    [
      "reverence",
      0.0125
    ],
    [
      "pruderie",
      0.0125
    ],
    [
      "litote",
      0.0125
    ],
    [
      "gene",
      0.0125
    ],
    [
      "embarras",
      0.0125
    ],
    [
      "contrainte",
      0.0125
    ],
    [
      "pudibonderie",
      0.005
    ],
    [
      "euphemisme",
      0.005
    ],
    [
      "confusion",
      0.005
    ],
    [
      "attenuation",
      0.005
    ],
    [
      "vergogne",
      0.005
    ]
  ],
  "bondir": [
    [
      "sauter",
      0.1275
    ],
    [
      "s'elancer",
      0.1125
    ],
    [
      "fuser",
      0.08
    ],
    [
      "s'elever",
      0.08
    ],
    [
      "courir",
      0.0625
    ],
    [
      "voler",
      0.0475
    ],
    [
      "partir",
      0.0475
    ],
    [
      "jaillir",
      0.0475
    ],
    [
      "foncer",
      0.0475
    ],
    [
      "retentir",
      0.03
    ],
    [
      "rebondir",
      0.03
    ],
    [
      "gambader",
      0.03
    ],
    [
      "tressaillir",
      0.015
    ],
    [
      "sursauter",
      0.015
    ],
    [
      "sortir",
      0.015
    ],
    [
      "resonner",
      0.015
    ],
    [
      "ricocher",
      0.015
    ],
    [
      "galoper",
      0.015
    ],
    [
      "cascader",
      0.015
    ],
    [
      "cahoter",
      0.015
    ],
    [
      "cabrioler",
      0.015
    ],
    [
      "voltiger",
      0.015
    ]
  ],
  "attendrir": [
    [
      "adoucir",
      0.1725
    ],
    [
      "toucher",
      0.135
    ],
    [
      "emouvoir",
      0.075
    ],
    [
      "flechir",
      0.075
    ],
    [
      "apitoyer",
      0.075
    ],
    [
      "amollir",
      0.075
    ],
    [
      "affaiblir",
      0.0575
    ],
    [
      "amadouer",
      0.0575
    ],
    [
      "remuer",
      0.0375
    ],
    [
      "humaniser",
      0.0375
    ],
    [
      "bouleverser",
      0.0375
    ],
    [
      "apaiser",
      0.0375
    ],
    [
      "amortir",
      0.0375
    ],
    [
      "fondre",
      0.0175
    ],
    [
      "interesser",
      0.0175
    ],
    [
      "ramollir",
      0.0175
    ],
    [
      "troubler",
      0.0175
    ]
  ],
  "beant": [
    [
      "large",
      0.25
    ],
    [
      "ouvert",
      0.25
    ],
    [
      "affame",
      0.125
    ],
    [
      "avide",
      0.125
    ],
    [
      "baillant",
      0.125
    ],
    [
      "grand",
      0.125
    ]
  ],
  "tendrement": [
    [
      "amoureusement",
      0.285
    ],
    [
      "cherement",
      0.285
    ],
    [
      "affectueusement",
      0.1425
    ],
    [
      "calinement",
      0.1425
    ],
    [
      "pieusement",
      0.1425
    ]
  ],
  "naivement": [
    [
      "bonnement",
      0.2325
    ],
    [
      "betement",
      0.1525
    ],
    [
      "innocemment",
      0.1525
    ],
    [
      "bravement",
      0.075
    ],
    [
      "candidement",
      0.075
    ],
    [
      "grossierement",
      0.075
    ],
    [
      "ingenument",
      0.075
    ],
    [
      "jobardement",
      0.075
    ]
  ],
  "engagement": [
    [
      "convention",
      0.0475
    ],
    [
      "obligation",
      0.0475
    ],
    [
      "accord",
      0.0425
    ],
    [
      "choc",
      0.0425
    ],
    [
      "combat",
      0.0425
    ],
    [
      "contrat",
      0.0425
    ],
    [
      "promesse",
      0.0425
    ],
    [
      "echauffouree",
      0.0425
    ],
    [
      "affaire",
      0.035
    ],
    [
      "accrochage",
      0.035
    ],
    [
      "alliance",
      0.03
    ],
    [
      "bataille",
      0.03
    ],
    [
      "caution",
      0.03
    ],
    [
      "garantie",
      0.03
    ],
    [
      "traite",
      0.0225
    ],
    [
      "situation",
      0.0225
    ],
    [
      "serment",
      0.0225
    ],
    [
      "rencontre",
      0.0225
    ],
    [
      "escarmouche",
      0.0175
    ],
    [
      "chaine",
      0.0175
    ],
    [
      "assurance",
      0.0175
    ],
    [
      "assaut",
      0.0175
    ],
    [
      "action",
      0.0175
    ],
    [
      "souscription",
      0.01
    ],
    [
      "signature",
      0.01
    ],
    [
      "position",
      0.01
    ],
    [
      "parole",
      0.01
    ],
    [
      "occupation",
      0.01
    ],
    [
      "mariage",
      0.01
    ],
    [
      "liaison",
      0.01
    ],
    [
      "foi",
      0.01
    ],
    [
      "embauchage",
      0.01
    ],
    [
      "depot",
      0.01
    ],
    [
      "dette",
      0.01
    ],
    [
      "coup",
      0.01
    ],
    [
      "collision",
      0.01
    ],
    [
      "participation",
      0.005
    ],
    [
      "protocole",
      0.005
    ],
    [
      "reconnaissance",
      0.005
    ],
    [
      "recrutement",
      0.005
    ],
    [
      "relation",
      0.005
    ],
    [
      "stipulation",
      0.005
    ],
    [
      "voeu",
      0.005
    ],
    [
      "orientation",
      0.005
    ],
    [
      "investissement",
      0.005
    ],
    [
      "hypotheque",
      0.005
    ],
    [
      "enrolement",
      0.005
    ],
    [
      "embauche",
      0.005
    ],
    [
      "domesticite",
      0.005
    ],
    [
      "baroud",
      0.005
    ],
    [
      "bapteme",
      0.005
    ],
    [
      "bail",
      0.005
    ],
    [
      "volontariat",
      0.005
    ]
  ],
  "malandrin": [
    [
      "brigand",
      0.1325
    ],
    [
      "bandit",
      0.115
    ],
    [
      "truand",
      0.115
    ],
    [
      "voleur",
      0.1
    ],
    [
      "vaurien",
      0.0825
    ],
    [
      "vagabond",
      0.05
    ],
    [
      "scelerat",
      0.05
    ],
    [
      "routier",
      0.05
    ],
    [
      "malfaiteur",
      0.05
    ],
    [
      "rodeur",
      0.0325
    ],
    [
      "pillard",
      0.0325
    ],
    [
      "forban",
      0.0325
    ],
    [
      "canaille",
      0.0325
    ],
    [
      "aigrefin",
      0.015
    ],
    [
      "chauffeur",
      0.015
    ],
    [
      "detrousseur",
      0.015
    ],
    [
      "gueux",
      0.015
    ],
    [
      "meurtrier",
      0.015
    ],
    [
      "pendard",
      0.015
    ],
    [
      "terreur",
      0.015
    ]
  ],
  "convaincre": [
    [
      "persuader",
      0.1825
    ],
    [
      "entrainer",
      0.09
    ],
    [
      "gagner",
      0.09
    ],
    [
      "amener",
      0.0725
    ],
    [
      "seduire",
      0.0725
    ],
    [
      "vaincre",
      0.0525
    ],
    [
      "captiver",
      0.0525
    ],
    [
      "prouver",
      0.035
    ],
    [
      "expliquer",
      0.035
    ],
    [
      "enfoncer",
      0.035
    ],
    [
      "demontrer",
      0.035
    ],
    [
      "conduire",
      0.035
    ],
    [
      "accabler",
      0.035
    ],
    [
      "precher",
      0.0175
    ],
    [
      "decider",
      0.0175
    ],
    [
      "convertir",
      0.0175
    ],
    [
      "confondre",
      0.0175
    ],
    [
      "assurer",
      0.0175
    ],
    [
      "toucher",
      0.0175
    ]
  ],
  "cependant": [
    [
      "neanmoins",
      0.235
    ],
    [
      "mais",
      0.0775
    ],
    [
      "toutefois",
      0.0775
    ],
    [
      "toujours",
      0.05
    ],
    [
      "pourtant",
      0.05
    ],
    [
      "nonobstant",
      0.05
    ],
    [
      "encore",
      0.05
    ],
    [
      "pendant",
      0.025
    ],
    [
      "seulement",
      0.025
    ],
    [
      "malgre",
      0.025
    ],
    [
      "alors",
      0.025
    ]
  ],
  "caressant": [
    [
      "doux",
      0.17
    ],
    [
      "amoureux",
      0.1025
    ],
    [
      "tendre",
      0.1025
    ],
    [
      "flatteur",
      0.0675
    ],
    [
      "enjoleur",
      0.0675
    ],
    [
      "calin",
      0.0675
    ],
    [
      "cajoleur",
      0.0675
    ],
    [
      "aimable",
      0.0675
    ],
    [
      "suave",
      0.0325
    ],
    [
      "expansif",
      0.0325
    ],
    [
      "demonstratif",
      0.0325
    ],
    [
      "caresseur",
      0.0325
    ],
    [
      "attentionne",
      0.0325
    ],
    [
      "aimant",
      0.0325
    ],
    [
      "affectueux",
      0.0325
    ],
    [
      "voluptueux",
      0.0325
    ]
  ],
  "fremissant": [
    [
      "frissonner",
      0.1925
    ],
    [
      "trembler",
      0.165
    ],
    [
      "vibrer",
      0.11
    ],
    [
      "tressaillir",
      0.0825
    ],
    [
      "tremuler",
      0.0825
    ],
    [
      "s'agiter",
      0.055
    ],
    [
      "palpiter",
      0.055
    ],
    [
      "murmurer",
      0.055
    ],
    [
      "bruire",
      0.055
    ],
    [
      "bouillir",
      0.0275
    ],
    [
      "chuchoter",
      0.0275
    ],
    [
      "grelotter",
      0.0275
    ],
    [
      "gronder",
      0.0275
    ],
    [
      "onduler",
      0.0275
    ]
  ],
  "berce": [
    [
      "consoler",
      0.0825
    ],
    [
      "tromper",
      0.0825
    ],
    [
      "endormir",
      0.0725
    ],
    [
      "apaiser",
      0.0625
    ],
    [
      "leurrer",
      0.0525
    ],
    [
      "calmer",
      0.0525
    ],
    [
      "amuser",
      0.0525
    ],
    [
      "adoucir",
      0.0525
    ],
    [
      "enjoler",
      0.04
    ],
    [
      "flatter",
      0.04
    ],
    [
      "soulager",
      0.03
    ],
    [
      "remuer",
      0.03
    ],
    [
      "charmer",
      0.03
    ],
    [
      "berner",
      0.03
    ],
    [
      "balancer",
      0.03
    ],
    [
      "assoupir",
      0.03
    ],
    [
      "abuser",
      0.03
    ],
    [
      "etourdir",
      0.02
    ],
    [
      "onduler",
      0.02
    ],
    [
      "mystifier",
      0.02
    ],
    [
      "caresser",
      0.02
    ],
    [
      "attenuer",
      0.02
    ],
    [
      "agiter",
      0.01
    ],
    [
      "dodeliner",
      0.01
    ],
    [
      "emporter",
      0.01
    ],
    [
      "illusionner",
      0.01
    ],
    [
      "ondoyer",
      0.01
    ],
    [
      "partager",
      0.01
    ],
    [
      "rythmer",
      0.01
    ]
  ],
  "console": [
    [
      "saillie",
      0.1825
    ],
    [
      "terminal",
      0.09
    ],
    [
      "table",
      0.09
    ],
    [
      "pupitre",
      0.09
    ],
    [
      "gousset",
      0.09
    ],
    [
      "encorbellement",
      0.09
    ],
    [
      "corbeau",
      0.09
    ],
    [
      "balcon",
      0.09
    ],
    [
      "teletype",
      0.09
    ]
  ],
  "verdoyant": [
    [
      "herbeux",
      0.5
    ],
    [
      "vert",
      0.5
    ]
  ],
  "bourgade": [
    [
      "bourg",
      0.23
    ],
    [
      "agglomeration",
      0.1525
    ],
    [
      "commune",
      0.1525
    ],
    [
      "localite",
      0.1525
    ],
    [
      "village",
      0.1525
    ],
    [
      "hameau",
      0.075
    ],
    [
      "pays",
      0.075
    ]
  ],
  "chatoyant": [
    [
      "brillant",
      0.175
    ],
    [
      "changeant",
      0.075
    ],
    [
      "luisant",
      0.075
    ],
    [
      "miroitant",
      0.075
    ],
    [
      "etincelant",
      0.075
    ],
    [
      "varie",
      0.0475
    ],
    [
      "papillotant",
      0.0475
    ],
    [
      "ondoyant",
      0.0475
    ],
    [
      "moire",
      0.0475
    ],
    [
      "mobile",
      0.0475
    ],
    [
      "lustre",
      0.0475
    ],
    [
      "image",
      0.0475
    ],
    [
      "colore",
      0.0475
    ],
    [
      "diapre",
      0.0225
    ],
    [
      "lumineux",
      0.0225
    ],
    [
      "petillant",
      0.0225
    ],
    [
      "riche",
      0.0225
    ],
    [
      "seduisant",
      0.0225
    ]
  ],
  "gnole": [
    [
      "alcool",
      0.25
    ]
  ],
  "rastaquouere": [
    [
      "intrigant",
      0.3325
    ],
    [
      "maraud",
      0.3325
    ],
    [
      "etranger",
      0.3325
    ]
  ],
  "quequette": [
    [
      "queue",
      0.5
    ],
    [
      "verge",
      0.5
    ]
  ],
  "tabou": [
    [
      "intangible",
      0.1425
    ],
    [
      "intouchable",
      0.1425
    ],
    [
      "sacre",
      0.1425
    ],
    [
      "nefas",
      0.07
    ],
    [
      "interdit",
      0.07
    ],
    [
      "interdiction",
      0.07
    ],
    [
      "fetiche",
      0.07
    ],
    [
      "brulant",
      0.07
    ],
    [
      "prohibe",
      0.07
    ]
  ],
  "retrograde": [
    [
      "arriere",
      0.1725
    ],
    [
      "perime",
      0.13
    ],
    [
      "reactionnaire",
      0.13
    ],
    [
      "retardataire",
      0.085
    ],
    [
      "suranne",
      0.085
    ],
    [
      "rococo",
      0.0425
    ],
    [
      "retarde",
      0.0425
    ],
    [
      "obscurantiste",
      0.0425
    ],
    [
      "immobiliste",
      0.0425
    ],
    [
      "fossilise",
      0.0425
    ],
    [
      "fossile",
      0.0425
    ],
    [
      "dextrogyre",
      0.0425
    ],
    [
      "conservateur",
      0.0425
    ],
    [
      "recurrent",
      0.0425
    ]
  ],
  "retrograder": [
    [
      "refluer",
      0.25
    ],
    [
      "reculer",
      0.15
    ],
    [
      "baisser",
      0.1
    ],
    [
      "regresser",
      0.1
    ],
    [
      "rompre",
      0.05
    ],
    [
      "revenir",
      0.05
    ],
    [
      "remonter",
      0.05
    ],
    [
      "dechoir",
      0.05
    ],
    [
      "descendre",
      0.05
    ],
    [
      "tomber",
      0.05
    ]
  ],
  "croisade": [
    [
      "campagne",
      0.3325
    ],
    [
      "expedition",
      0.165
    ],
    [
      "operation",
      0.165
    ],
    [
      "guerre",
      0.0825
    ],
    [
      "offensive",
      0.0825
    ],
    [
      "propagande",
      0.0825
    ]
  ],
  "date": [
    [
      "temps",
      0.2075
    ],
    [
      "epoque",
      0.125
    ],
    [
      "an",
      0.0825
    ],
    [
      "delai",
      0.0825
    ],
    [
      "jour",
      0.0825
    ],
    [
      "periode",
      0.0825
    ],
    [
      "echeance",
      0.04
    ],
    [
      "terme",
      0.04
    ],
    [
      "rubrique",
      0.04
    ],
    [
      "quantieme",
      0.04
    ],
    [
      "moment",
      0.04
    ],
    [
      "millesime",
      0.04
    ],
    [
      "annee",
      0.04
    ],
    [
      "evenement",
      0.04
    ]
  ],
  "dater": [
    [
      "commencer",
      0.1425
    ],
    [
      "compter",
      0.1425
    ],
    [
      "marquer",
      0.1425
    ],
    [
      "provenir",
      0.1425
    ],
    [
      "remonter",
      0.1425
    ],
    [
      "venir",
      0.1425
    ],
    [
      "vieillir",
      0.1425
    ]
  ],
  "capoter": [
    [
      "chavirer",
      0.25
    ],
    [
      "culbuter",
      0.25
    ],
    [
      "basculer",
      0.125
    ]
  ],
  "capote": [
    [
      "caban",
      0.22
    ],
    [
      "manteau",
      0.22
    ],
    [
      "capot",
      0.11
    ],
    [
      "capuchon",
      0.11
    ],
    [
      "condom",
      0.11
    ],
    [
      "couverture",
      0.11
    ],
    [
      "preservatif",
      0.11
    ]
  ],
  "plate": [
    [
      "terne",
      0.075
    ],
    [
      "insignifiant",
      0.0575
    ],
    [
      "insipide",
      0.0575
    ],
    [
      "fade",
      0.045
    ],
    [
      "mediocre",
      0.045
    ],
    [
      "banal",
      0.0425
    ],
    [
      "bas",
      0.035
    ],
    [
      "morne",
      0.035
    ],
    [
      "falot",
      0.0325
    ],
    [
      "quelconque",
      0.0275
    ],
    [
      "commun",
      0.025
    ],
    [
      "rampant",
      0.025
    ],
    [
      "servile",
      0.025
    ],
    [
      "humble",
      0.02
    ],
    [
      "inconsistant",
      0.02
    ],
    [
      "prosaique",
      0.02
    ],
    [
      "pale",
      0.02
    ],
    [
      "vil",
      0.02
    ],
    [
      "vide",
      0.0175
    ],
    [
      "monotone",
      0.0175
    ],
    [
      "mesquin",
      0.0175
    ],
    [
      "mince",
      0.0125
    ],
    [
      "pauvre",
      0.0125
    ],
    [
      "uni",
      0.0125
    ],
    [
      "egal",
      0.0125
    ],
    [
      "uniforme",
      0.01
    ],
    [
      "nul",
      0.01
    ],
    [
      "mets",
      0.01
    ],
    [
      "douceatre",
      0.01
    ],
    [
      "assiette",
      0.01
    ],
    [
      "aplati",
      0.01
    ],
    [
      "plan",
      0.005
    ],
    [
      "prosterne",
      0.005
    ],
    [
      "sot",
      0.005
    ],
    [
      "souple",
      0.005
    ],
    [
      "vaisselle",
      0.005
    ],
    [
      "ecrase",
      0.005
    ],
    [
      "piece",
      0.005
    ],
    [
      "obsequieux",
      0.005
    ],
    [
      "camus",
      0.005
    ],
    [
      "decolore",
      0.005
    ],
    [
      "fadasse",
      0.005
    ],
    [
      "froid",
      0.005
    ],
    [
      "morceau",
      0.005
    ],
    [
      "mort",
      0.005
    ],
    [
      "legumier",
      0.0025
    ],
    [
      "melliflu",
      0.0025
    ],
    [
      "plain",
      0.0025
    ],
    [
      "plateau",
      0.0025
    ],
    [
      "platee",
      0.0025
    ],
    [
      "ras",
      0.0025
    ],
    [
      "ravier",
      0.0025
    ],
    [
      "repas",
      0.0025
    ],
    [
      "serf",
      0.0025
    ],
    [
      "service",
      0.0025
    ],
    [
      "specialite",
      0.0025
    ],
    [
      "stupide",
      0.0025
    ],
    [
      "lisse",
      0.0025
    ],
    [
      "incolore",
      0.0025
    ],
    [
      "gris",
      0.0025
    ],
    [
      "abject",
      0.0025
    ],
    [
      "bassin",
      0.0025
    ],
    [
      "batterie",
      0.0025
    ],
    [
      "boniment",
      0.0025
    ],
    [
      "camard",
      0.0025
    ],
    [
      "compotier",
      0.0025
    ],
    [
      "contenant",
      0.0025
    ],
    [
      "degonfle",
      0.0025
    ],
    [
      "facile",
      0.0025
    ],
    [
      "fat",
      0.0025
    ],
    [
      "faience",
      0.0025
    ],
    [
      "flatterie",
      0.0025
    ],
    [
      "ecache",
      0.0025
    ]
  ],
  "petiller": [
    [
      "briller",
      0.1125
    ],
    [
      "fulgurer",
      0.1125
    ],
    [
      "resplendir",
      0.1125
    ],
    [
      "eclater",
      0.1125
    ],
    [
      "flamboyer",
      0.085
    ],
    [
      "etinceler",
      0.085
    ],
    [
      "scintiller",
      0.055
    ],
    [
      "rayonner",
      0.055
    ],
    [
      "peter",
      0.055
    ],
    [
      "crepiter",
      0.055
    ],
    [
      "craquer",
      0.055
    ],
    [
      "chatoyer",
      0.0275
    ],
    [
      "decrepiter",
      0.0275
    ],
    [
      "jaillir",
      0.0275
    ]
  ],
  "catheter": [
    [
      "sonde",
      0.5
    ],
    [
      "bougie",
      0.25
    ],
    [
      "canule",
      0.25
    ]
  ],
  "fretiller": [
    [
      "gigoter",
      0.1875
    ],
    [
      "remuer",
      0.1875
    ],
    [
      "gambiller",
      0.125
    ],
    [
      "s'agiter",
      0.125
    ],
    [
      "agiter",
      0.0625
    ],
    [
      "demanger",
      0.0625
    ],
    [
      "s'ebrouer",
      0.0625
    ],
    [
      "trepider",
      0.0625
    ]
  ],
  "please": [],
  "froideur": [
    [
      "flegme",
      0.105
    ],
    [
      "indifference",
      0.105
    ],
    [
      "calme",
      0.0825
    ],
    [
      "froid",
      0.0825
    ],
    [
      "impassibilite",
      0.0825
    ],
    [
      "insensibilite",
      0.0825
    ],
    [
      "durete",
      0.05
    ],
    [
      "frigidite",
      0.04
    ],
    [
      "secheresse",
      0.04
    ],
    [
      "severite",
      0.03
    ],
    [
      "tiedeur",
      0.02
    ],
    [
      "placidite",
      0.02
    ],
    [
      "detachement",
      0.02
    ],
    [
      "austerite",
      0.02
    ],
    [
      "aridite",
      0.02
    ],
    [
      "inaffection",
      0.01
    ],
    [
      "malaise",
      0.01
    ],
    [
      "morgue",
      0.01
    ],
    [
      "mecontentement",
      0.01
    ],
    [
      "mesintelligence",
      0.01
    ],
    [
      "retenue",
      0.01
    ],
    [
      "reserve",
      0.01
    ],
    [
      "impuissance",
      0.01
    ],
    [
      "impiete",
      0.01
    ],
    [
      "imperturbabilite",
      0.01
    ],
    [
      "gene",
      0.01
    ],
    [
      "facherie",
      0.01
    ],
    [
      "froidure",
      0.01
    ],
    [
      "fraicheur",
      0.01
    ],
    [
      "fadeur",
      0.01
    ],
    [
      "distance",
      0.01
    ],
    [
      "antipathie",
      0.01
    ]
  ],
  "pizza": [],
  "appareil": [
    [
      "apparat",
      0.045
    ],
    [
      "machine",
      0.045
    ],
    [
      "assemblage",
      0.0375
    ],
    [
      "engin",
      0.0375
    ],
    [
      "pompe",
      0.03
    ],
    [
      "outil",
      0.03
    ],
    [
      "mecanique",
      0.03
    ],
    [
      "decor",
      0.03
    ],
    [
      "disposition",
      0.03
    ],
    [
      "ceremonie",
      0.03
    ],
    [
      "collection",
      0.03
    ],
    [
      "equipage",
      0.0225
    ],
    [
      "eclat",
      0.0225
    ],
    [
      "instrument",
      0.0225
    ],
    [
      "dispositif",
      0.0225
    ],
    [
      "cadre",
      0.0225
    ],
    [
      "attirail",
      0.0225
    ],
    [
      "accompagnement",
      0.0225
    ],
    [
      "tralala",
      0.0125
    ],
    [
      "suite",
      0.0125
    ],
    [
      "solennite",
      0.0125
    ],
    [
      "preparatifs",
      0.0125
    ],
    [
      "moteur",
      0.0125
    ],
    [
      "grandeur",
      0.0125
    ],
    [
      "faste",
      0.0125
    ],
    [
      "ensemble",
      0.0125
    ],
    [
      "cortege",
      0.0125
    ],
    [
      "apparence",
      0.0125
    ],
    [
      "appareillage",
      0.0125
    ],
    [
      "poste",
      0.005
    ],
    [
      "metier",
      0.005
    ],
    [
      "montage",
      0.005
    ],
    [
      "monobloc",
      0.005
    ],
    [
      "magnificence",
      0.005
    ],
    [
      "legislation",
      0.005
    ],
    [
      "gadget",
      0.005
    ],
    [
      "projecteur",
      0.005
    ],
    [
      "prothese",
      0.005
    ],
    [
      "ustensile",
      0.005
    ],
    [
      "televiseur",
      0.005
    ],
    [
      "telephone",
      0.005
    ],
    [
      "taille",
      0.005
    ],
    [
      "systeme",
      0.005
    ],
    [
      "sonotone",
      0.005
    ],
    [
      "robot",
      0.005
    ],
    [
      "radio",
      0.005
    ],
    [
      "flipper",
      0.005
    ],
    [
      "exterieur",
      0.005
    ],
    [
      "agres",
      0.005
    ],
    [
      "appret",
      0.005
    ],
    [
      "apprets",
      0.005
    ],
    [
      "arsenal",
      0.005
    ],
    [
      "audiophone",
      0.005
    ],
    [
      "avion",
      0.005
    ],
    [
      "bandage",
      0.005
    ],
    [
      "bidule",
      0.005
    ],
    [
      "billard",
      0.005
    ],
    [
      "box",
      0.005
    ],
    [
      "bruleur",
      0.005
    ],
    [
      "camera",
      0.005
    ],
    [
      "combine",
      0.005
    ],
    [
      "costume",
      0.005
    ],
    [
      "ceremonial",
      0.005
    ],
    [
      "detective",
      0.005
    ],
    [
      "escorte",
      0.005
    ],
    [
      "activateur",
      0.005
    ]
  ],
  "surfeur": [
    [
      "surfiste",
      1.0
    ]
  ],
  "surgele": [
    [
      "congeler",
      1.0
    ]
  ],
  "surgeler": [
    [
      "congeler",
      1.0
    ]
  ],
  "attribue": [
    [
      "donner",
      0.135
    ],
    [
      "accorder",
      0.0775
    ],
    [
      "affecter",
      0.0425
    ],
    [
      "distribuer",
      0.0425
    ],
    [
      "octroyer",
      0.0425
    ],
    [
      "repartir",
      0.0375
    ],
    [
      "decerner",
      0.0375
    ],
    [
      "allouer",
      0.0375
    ],
    [
      "appliquer",
      0.0325
    ],
    [
      "assigner",
      0.0325
    ],
    [
      "attacher",
      0.0325
    ],
    [
      "preter",
      0.0275
    ],
    [
      "gratifier",
      0.0275
    ],
    [
      "adjuger",
      0.0275
    ],
    [
      "conceder",
      0.0225
    ],
    [
      "conferer",
      0.0225
    ],
    [
      "imputer",
      0.0225
    ],
    [
      "rapporter",
      0.0175
    ],
    [
      "partager",
      0.0175
    ],
    [
      "mettre",
      0.0175
    ],
    [
      "impartir",
      0.0175
    ],
    [
      "reconnaitre",
      0.0125
    ],
    [
      "rattacher",
      0.0125
    ],
    [
      "joindre",
      0.0125
    ],
    [
      "destiner",
      0.0125
    ],
    [
      "consacrer",
      0.0125
    ],
    [
      "classer",
      0.0125
    ],
    [
      "adjoindre",
      0.0125
    ],
    [
      "rejeter",
      0.0075
    ],
    [
      "lotir",
      0.0075
    ],
    [
      "doter",
      0.0075
    ],
    [
      "allotir",
      0.0075
    ],
    [
      "reserver",
      0.0025
    ],
    [
      "referer",
      0.0025
    ],
    [
      "reporter",
      0.0025
    ],
    [
      "honorer",
      0.0025
    ],
    [
      "departir",
      0.0025
    ],
    [
      "deferer",
      0.0025
    ],
    [
      "crediter",
      0.0025
    ],
    [
      "authentifier",
      0.0025
    ],
    [
      "approprier",
      0.0025
    ],
    [
      "annexer",
      0.0025
    ],
    [
      "supposer",
      0.0025
    ]
  ],
  "attribuer": [
    [
      "donner",
      0.135
    ],
    [
      "accorder",
      0.0775
    ],
    [
      "affecter",
      0.0425
    ],
    [
      "distribuer",
      0.0425
    ],
    [
      "octroyer",
      0.0425
    ],
    [
      "repartir",
      0.0375
    ],
    [
      "decerner",
      0.0375
    ],
    [
      "allouer",
      0.0375
    ],
    [
      "appliquer",
      0.0325
    ],
    [
      "assigner",
      0.0325
    ],
    [
      "attacher",
      0.0325
    ],
    [
      "preter",
      0.0275
    ],
    [
      "gratifier",
      0.0275
    ],
    [
      "adjuger",
      0.0275
    ],
    [
      "conceder",
      0.0225
    ],
    [
      "conferer",
      0.0225
    ],
    [
      "imputer",
      0.0225
    ],
    [
      "rapporter",
      0.0175
    ],
    [
      "partager",
      0.0175
    ],
    [
      "mettre",
      0.0175
    ],
    [
      "impartir",
      0.0175
    ],
    [
      "reconnaitre",
      0.0125
    ],
    [
      "rattacher",
      0.0125
    ],
    [
      "joindre",
      0.0125
    ],
    [
      "destiner",
      0.0125
    ],
    [
      "consacrer",
      0.0125
    ],
    [
      "classer",
      0.0125
    ],
    [
      "adjoindre",
      0.0125
    ],
    [
      "rejeter",
      0.0075
    ],
    [
      "lotir",
      0.0075
    ],
    [
      "doter",
      0.0075
    ],
    [
      "allotir",
      0.0075
    ],
    [
      "reserver",
      0.0025
    ],
    [
      "referer",
      0.0025
    ],
    [
      "reporter",
      0.0025
    ],
    [
      "honorer",
      0.0025
    ],
    [
      "departir",
      0.0025
    ],
    [
      "deferer",
      0.0025
    ],
    [
      "crediter",
      0.0025
    ],
    [
      "authentifier",
      0.0025
    ],
    [
      "approprier",
      0.0025
    ],
    [
      "annexer",
      0.0025
    ],
    [
      "supposer",
      0.0025
    ]
  ],
  "muter": [
    [
      "deplacer",
      0.4
    ],
    [
      "affecter",
      0.2
    ],
    [
      "changer",
      0.2
    ],
    [
      "verser",
      0.2
    ]
  ],
  "avalant": [
    [
      "absorber",
      0.105
    ],
    [
      "manger",
      0.0975
    ],
    [
      "ingurgiter",
      0.065
    ],
    [
      "boire",
      0.0475
    ],
    [
      "devorer",
      0.0475
    ],
    [
      "prendre",
      0.0475
    ],
    [
      "supporter",
      0.0325
    ],
    [
      "souffrir",
      0.0325
    ],
    [
      "recevoir",
      0.0325
    ],
    [
      "engloutir",
      0.0325
    ],
    [
      "bouffer",
      0.0325
    ],
    [
      "sauter",
      0.0225
    ],
    [
      "retenir",
      0.0225
    ],
    [
      "escamoter",
      0.0225
    ],
    [
      "bafrer",
      0.0225
    ],
    [
      "aspirer",
      0.0225
    ],
    [
      "apprendre",
      0.0225
    ],
    [
      "accepter",
      0.0225
    ],
    [
      "tolerer",
      0.015
    ],
    [
      "rentrer",
      0.015
    ],
    [
      "inhaler",
      0.015
    ],
    [
      "ingerer",
      0.015
    ],
    [
      "humer",
      0.015
    ],
    [
      "gober",
      0.015
    ],
    [
      "entonner",
      0.015
    ],
    [
      "engouffrer",
      0.015
    ],
    [
      "endurer",
      0.015
    ],
    [
      "encaisser",
      0.015
    ],
    [
      "deglutir",
      0.015
    ],
    [
      "digerer",
      0.015
    ],
    [
      "croire",
      0.015
    ],
    [
      "s'enfiler",
      0.0075
    ],
    [
      "resorber",
      0.0075
    ],
    [
      "inspirer",
      0.0075
    ],
    [
      "friper",
      0.0075
    ],
    [
      "descendre",
      0.0075
    ],
    [
      "boulotter",
      0.0075
    ],
    [
      "tortiller",
      0.0075
    ]
  ],
  "western": [
    [
      "film",
      1.0
    ]
  ],
  "japonais": [
    [
      "nippon",
      1.0
    ]
  ],
  "combattant": [
    [
      "adversaire",
      0.1325
    ],
    [
      "soldat",
      0.1325
    ],
    [
      "concurrent",
      0.105
    ],
    [
      "champion",
      0.0775
    ],
    [
      "rival",
      0.05
    ],
    [
      "militant",
      0.05
    ],
    [
      "guerrier",
      0.05
    ],
    [
      "defenseur",
      0.05
    ],
    [
      "competiteur",
      0.05
    ],
    [
      "apotre",
      0.05
    ],
    [
      "antagoniste",
      0.05
    ],
    [
      "poilu",
      0.025
    ],
    [
      "homme",
      0.025
    ],
    [
      "guerillero",
      0.025
    ],
    [
      "challenger",
      0.025
    ],
    [
      "belligerant",
      0.025
    ],
    [
      "batailleur",
      0.025
    ],
    [
      "proselyte",
      0.025
    ]
  ],
  "perte": [
    [
      "ruine",
      0.075
    ],
    [
      "degradation",
      0.0575
    ],
    [
      "chute",
      0.0425
    ],
    [
      "disparition",
      0.0425
    ],
    [
      "decadence",
      0.0375
    ],
    [
      "mort",
      0.03
    ],
    [
      "degenerescence",
      0.03
    ],
    [
      "tort",
      0.0225
    ],
    [
      "ravage",
      0.0225
    ],
    [
      "fuite",
      0.0225
    ],
    [
      "deperissement",
      0.0225
    ],
    [
      "deperdition",
      0.0225
    ],
    [
      "degat",
      0.0225
    ],
    [
      "defaite",
      0.0225
    ],
    [
      "decheance",
      0.0225
    ],
    [
      "dommage",
      0.0225
    ],
    [
      "aneantissement",
      0.0225
    ],
    [
      "alteration",
      0.0225
    ],
    [
      "eloignement",
      0.0175
    ],
    [
      "tribulation",
      0.0175
    ],
    [
      "separation",
      0.0175
    ],
    [
      "naufrage",
      0.0175
    ],
    [
      "malheur",
      0.0175
    ],
    [
      "mal",
      0.0175
    ],
    [
      "insucces",
      0.0175
    ],
    [
      "appauvrissement",
      0.0175
    ],
    [
      "evanouissement",
      0.01
    ],
    [
      "vide",
      0.01
    ],
    [
      "sinistre",
      0.01
    ],
    [
      "privation",
      0.01
    ],
    [
      "gachage",
      0.01
    ],
    [
      "gaspillage",
      0.01
    ],
    [
      "dechet",
      0.01
    ],
    [
      "breche",
      0.01
    ],
    [
      "amaigrissement",
      0.01
    ],
    [
      "alienation",
      0.01
    ],
    [
      "abime",
      0.01
    ],
    [
      "lessive",
      0.005
    ],
    [
      "lessivage",
      0.005
    ],
    [
      "hemorragie",
      0.005
    ],
    [
      "frottee",
      0.005
    ],
    [
      "leucorrhee",
      0.005
    ],
    [
      "mutilation",
      0.005
    ],
    [
      "perdition",
      0.005
    ],
    [
      "prejudice",
      0.005
    ],
    [
      "raclee",
      0.005
    ],
    [
      "extinction",
      0.005
    ],
    [
      "deficit",
      0.005
    ],
    [
      "deces",
      0.005
    ],
    [
      "amission",
      0.005
    ],
    [
      "avortement",
      0.005
    ],
    [
      "baisse",
      0.005
    ],
    [
      "bousillage",
      0.005
    ],
    [
      "casse",
      0.005
    ],
    [
      "coulage",
      0.005
    ],
    [
      "culotte",
      0.005
    ],
    [
      "damnation",
      0.005
    ],
    [
      "deuil",
      0.005
    ],
    [
      "discredit",
      0.005
    ],
    [
      "egarement",
      0.005
    ]
  ],
  "debacle": [
    [
      "ruine",
      0.1125
    ],
    [
      "chute",
      0.075
    ],
    [
      "deconfiture",
      0.075
    ],
    [
      "faillite",
      0.065
    ],
    [
      "deroute",
      0.0575
    ],
    [
      "ecroulement",
      0.0575
    ],
    [
      "krach",
      0.05
    ],
    [
      "effondrement",
      0.05
    ],
    [
      "defaite",
      0.05
    ],
    [
      "culbute",
      0.0275
    ],
    [
      "echec",
      0.0275
    ],
    [
      "revers",
      0.02
    ],
    [
      "naufrage",
      0.02
    ],
    [
      "desastre",
      0.02
    ],
    [
      "debandade",
      0.02
    ],
    [
      "dissolution",
      0.02
    ],
    [
      "confusion",
      0.02
    ],
    [
      "banqueroute",
      0.02
    ],
    [
      "renversement",
      0.0125
    ],
    [
      "fuite",
      0.0125
    ],
    [
      "deliquescence",
      0.0125
    ],
    [
      "dissociation",
      0.0125
    ],
    [
      "chaos",
      0.0125
    ],
    [
      "catastrophe",
      0.0125
    ],
    [
      "fin",
      0.005
    ],
    [
      "derangement",
      0.005
    ],
    [
      "demolition",
      0.005
    ],
    [
      "degat",
      0.005
    ],
    [
      "degel",
      0.005
    ],
    [
      "debine",
      0.005
    ],
    [
      "diarrhee",
      0.005
    ],
    [
      "crise",
      0.005
    ],
    [
      "colique",
      0.005
    ],
    [
      "bouscueil",
      0.005
    ],
    [
      "retraite",
      0.005
    ]
  ],
  "deroute": [
    [
      "debacle",
      0.1375
    ],
    [
      "debandade",
      0.1025
    ],
    [
      "confusion",
      0.0675
    ],
    [
      "defaite",
      0.0675
    ],
    [
      "desordre",
      0.0675
    ],
    [
      "fuite",
      0.0675
    ],
    [
      "ruine",
      0.05
    ],
    [
      "deconfiture",
      0.05
    ],
    [
      "ecroulement",
      0.0325
    ],
    [
      "panique",
      0.0325
    ],
    [
      "faillite",
      0.0325
    ],
    [
      "desarroi",
      0.0325
    ],
    [
      "derangement",
      0.0325
    ],
    [
      "dissolution",
      0.0325
    ],
    [
      "naufrage",
      0.015
    ],
    [
      "desastre",
      0.015
    ],
    [
      "defection",
      0.015
    ],
    [
      "dispersion",
      0.015
    ],
    [
      "bataille",
      0.015
    ],
    [
      "banqueroute",
      0.015
    ],
    [
      "revers",
      0.015
    ]
  ],
  "derouter": [
    [
      "deconcerter",
      0.1275
    ],
    [
      "desorienter",
      0.085
    ],
    [
      "confondre",
      0.0775
    ],
    [
      "troubler",
      0.0625
    ],
    [
      "egarer",
      0.0625
    ],
    [
      "decontenancer",
      0.0575
    ],
    [
      "demonter",
      0.05
    ],
    [
      "embarrasser",
      0.05
    ],
    [
      "interloquer",
      0.05
    ],
    [
      "etonner",
      0.035
    ],
    [
      "devoyer",
      0.035
    ],
    [
      "detourner",
      0.035
    ],
    [
      "desarconner",
      0.035
    ],
    [
      "ahurir",
      0.035
    ],
    [
      "depister",
      0.0275
    ],
    [
      "perdre",
      0.0275
    ],
    [
      "fourvoyer",
      0.02
    ],
    [
      "surprendre",
      0.02
    ],
    [
      "ecarter",
      0.02
    ],
    [
      "empecher",
      0.0125
    ],
    [
      "devier",
      0.0125
    ],
    [
      "demater",
      0.005
    ],
    [
      "depayser",
      0.005
    ],
    [
      "inquieter",
      0.005
    ],
    [
      "semer",
      0.005
    ],
    [
      "eloigner",
      0.005
    ]
  ],
  "fuyant": [
    [
      "s'enfuir",
      0.13
    ],
    [
      "partir",
      0.075
    ],
    [
      "disparaitre",
      0.055
    ],
    [
      "filer",
      0.0425
    ],
    [
      "s'echapper",
      0.04
    ],
    [
      "s'eclipser",
      0.0375
    ],
    [
      "s'evader",
      0.0325
    ],
    [
      "deguerpir",
      0.03
    ],
    [
      "echapper",
      0.025
    ],
    [
      "s'envoler",
      0.02
    ],
    [
      "couler",
      0.02
    ],
    [
      "courir",
      0.02
    ],
    [
      "decamper",
      0.02
    ],
    [
      "quitter",
      0.0175
    ],
    [
      "s'ecouler",
      0.015
    ],
    [
      "s'esquiver",
      0.015
    ],
    [
      "passer",
      0.015
    ],
    [
      "abandonner",
      0.01
    ],
    [
      "detaler",
      0.01
    ],
    [
      "eviter",
      0.01
    ],
    [
      "s'evanouir",
      0.0075
    ],
    [
      "s'eloigner",
      0.0075
    ],
    [
      "ceder",
      0.0075
    ],
    [
      "perdre",
      0.0075
    ],
    [
      "reculer",
      0.0075
    ],
    [
      "eluder",
      0.0075
    ],
    [
      "s'enfoncer",
      0.005
    ],
    [
      "deloger",
      0.005
    ],
    [
      "voler",
      0.0025
    ],
    [
      "suinter",
      0.0025
    ],
    [
      "s'exiler",
      0.0025
    ],
    [
      "esquiver",
      0.0025
    ],
    [
      "cavaler",
      0.0025
    ],
    [
      "sourdre",
      0.0025
    ],
    [
      "filtrer",
      0.0025
    ],
    [
      "caleter",
      0.0025
    ],
    [
      "refuir",
      0.0
    ],
    [
      "s'affaisser",
      0.0
    ],
    [
      "s'esbigner",
      0.0
    ],
    [
      "s'escamper",
      0.0
    ],
    [
      "pisser",
      0.0
    ],
    [
      "bannir",
      0.0
    ],
    [
      "defiler",
      0.0
    ],
    [
      "effrayer",
      0.0
    ],
    [
      "hair",
      0.0
    ]
  ],
  "pacte": [
    [
      "traite",
      0.2425
    ],
    [
      "convention",
      0.2075
    ],
    [
      "accord",
      0.1725
    ],
    [
      "entente",
      0.0675
    ],
    [
      "contrat",
      0.0675
    ],
    [
      "alliance",
      0.0675
    ],
    [
      "covenant",
      0.0325
    ],
    [
      "marche",
      0.0325
    ],
    [
      "paix",
      0.0325
    ],
    [
      "resolution",
      0.0325
    ],
    [
      "stipulation",
      0.0325
    ]
  ],
  "armistice": [
    [
      "treve",
      0.265
    ],
    [
      "arret",
      0.1575
    ],
    [
      "abandon",
      0.105
    ],
    [
      "cessation",
      0.105
    ],
    [
      "paix",
      0.05
    ],
    [
      "interruption",
      0.05
    ],
    [
      "capitulation",
      0.05
    ],
    [
      "amelioration",
      0.05
    ]
  ],
  "square": [
    [
      "place",
      0.4275
    ],
    [
      "carre",
      0.1425
    ],
    [
      "jardin",
      0.1425
    ],
    [
      "quinconce",
      0.1425
    ]
  ],
  "mairie": [
    [
      "municipalite",
      0.2
    ]
  ],
  "subtil": [
    [
      "fin",
      0.1025
    ],
    [
      "habile",
      0.0675
    ],
    [
      "intelligent",
      0.0525
    ],
    [
      "penetrant",
      0.0475
    ],
    [
      "delicat",
      0.0425
    ],
    [
      "adroit",
      0.0375
    ],
    [
      "ruse",
      0.0325
    ],
    [
      "perspicace",
      0.0325
    ],
    [
      "malin",
      0.0325
    ],
    [
      "leger",
      0.0325
    ],
    [
      "delie",
      0.0325
    ],
    [
      "astucieux",
      0.0325
    ],
    [
      "ingenieux",
      0.0225
    ],
    [
      "percant",
      0.0225
    ],
    [
      "raffine",
      0.0225
    ],
    [
      "sagace",
      0.0175
    ],
    [
      "imperceptible",
      0.0175
    ],
    [
      "fute",
      0.0175
    ],
    [
      "aigu",
      0.0175
    ],
    [
      "tortueux",
      0.0125
    ],
    [
      "souple",
      0.0125
    ],
    [
      "lucide",
      0.0125
    ],
    [
      "insaisissable",
      0.0125
    ],
    [
      "diplomate",
      0.0125
    ],
    [
      "difficile",
      0.0125
    ],
    [
      "complique",
      0.0125
    ],
    [
      "aerien",
      0.0125
    ],
    [
      "quintessencie",
      0.0075
    ],
    [
      "petit",
      0.0075
    ],
    [
      "mysterieux",
      0.0075
    ],
    [
      "inventif",
      0.0075
    ],
    [
      "impenetrable",
      0.0075
    ],
    [
      "imponderable",
      0.0075
    ],
    [
      "fertile",
      0.0075
    ],
    [
      "exquis",
      0.0075
    ],
    [
      "clairvoyant",
      0.0075
    ],
    [
      "alambique",
      0.0075
    ],
    [
      "agreable",
      0.0075
    ],
    [
      "renard",
      0.0025
    ],
    [
      "sophistique",
      0.0025
    ],
    [
      "timide",
      0.0025
    ],
    [
      "tenu",
      0.0025
    ],
    [
      "psychologue",
      0.0025
    ],
    [
      "menu",
      0.0025
    ],
    [
      "intrigant",
      0.0025
    ],
    [
      "espiegle",
      0.0025
    ],
    [
      "byzantin",
      0.0025
    ],
    [
      "aiguise",
      0.0025
    ],
    [
      "abstrait",
      0.0025
    ],
    [
      "ethere",
      0.0025
    ]
  ],
  "protocole": [
    [
      "convention",
      0.14
    ],
    [
      "regle",
      0.0775
    ],
    [
      "etiquette",
      0.0775
    ],
    [
      "convenance",
      0.0625
    ],
    [
      "traite",
      0.0625
    ],
    [
      "statut",
      0.05
    ],
    [
      "reglement",
      0.05
    ],
    [
      "decorum",
      0.05
    ],
    [
      "ceremonie",
      0.05
    ],
    [
      "ceremonial",
      0.05
    ],
    [
      "accord",
      0.05
    ],
    [
      "rite",
      0.0375
    ],
    [
      "acte",
      0.025
    ],
    [
      "concordat",
      0.025
    ],
    [
      "place",
      0.01
    ],
    [
      "preseance",
      0.01
    ],
    [
      "rituel",
      0.01
    ],
    [
      "regles",
      0.01
    ],
    [
      "ordonnance",
      0.01
    ],
    [
      "norme",
      0.01
    ],
    [
      "formulaire",
      0.01
    ],
    [
      "formes",
      0.01
    ],
    [
      "engagement",
      0.01
    ],
    [
      "bienseance",
      0.01
    ],
    [
      "alliance",
      0.01
    ],
    [
      "ajustement",
      0.01
    ],
    [
      "resolution",
      0.01
    ]
  ],
  "chretien": [
    [
      "catholique",
      0.2
    ],
    [
      "fidele",
      0.2
    ],
    [
      "baptise",
      0.1
    ],
    [
      "copte",
      0.1
    ],
    [
      "orthodoxe",
      0.1
    ],
    [
      "ouaille",
      0.1
    ],
    [
      "protestant",
      0.1
    ],
    [
      "evangelique",
      0.1
    ]
  ],
  "paien": [
    [
      "incroyant",
      0.17
    ],
    [
      "impie",
      0.1425
    ],
    [
      "infidele",
      0.1125
    ],
    [
      "irreligieux",
      0.085
    ],
    [
      "mecreant",
      0.085
    ],
    [
      "incredule",
      0.055
    ],
    [
      "heretique",
      0.055
    ],
    [
      "gentil",
      0.055
    ],
    [
      "athee",
      0.055
    ],
    [
      "agnostique",
      0.0275
    ],
    [
      "ethnique",
      0.0275
    ],
    [
      "idolatre",
      0.0275
    ],
    [
      "profane",
      0.0275
    ],
    [
      "renegat",
      0.0275
    ]
  ],
  "preste": [
    [
      "agile",
      0.165
    ],
    [
      "vif",
      0.15
    ],
    [
      "prompt",
      0.135
    ],
    [
      "alerte",
      0.075
    ],
    [
      "leste",
      0.075
    ],
    [
      "rapide",
      0.075
    ],
    [
      "vite",
      0.045
    ],
    [
      "habile",
      0.045
    ],
    [
      "dispos",
      0.045
    ],
    [
      "allegre",
      0.0275
    ],
    [
      "diligent",
      0.0275
    ],
    [
      "expeditif",
      0.0275
    ],
    [
      "eveille",
      0.0275
    ],
    [
      "adroit",
      0.0125
    ],
    [
      "aise",
      0.0125
    ],
    [
      "leger",
      0.0125
    ],
    [
      "veloce",
      0.0125
    ]
  ],
  "svelte": [
    [
      "mince",
      0.135
    ],
    [
      "grele",
      0.1075
    ],
    [
      "fin",
      0.085
    ],
    [
      "leger",
      0.085
    ],
    [
      "fusele",
      0.0725
    ],
    [
      "delie",
      0.055
    ],
    [
      "tenu",
      0.05
    ],
    [
      "menu",
      0.045
    ],
    [
      "delicat",
      0.0375
    ],
    [
      "elance",
      0.0375
    ],
    [
      "maigre",
      0.0325
    ],
    [
      "fluet",
      0.0275
    ],
    [
      "filiforme",
      0.0275
    ],
    [
      "effile",
      0.0275
    ],
    [
      "fragile",
      0.0225
    ],
    [
      "gracile",
      0.0225
    ],
    [
      "etroit",
      0.015
    ],
    [
      "elegant",
      0.015
    ],
    [
      "souple",
      0.015
    ],
    [
      "petit",
      0.015
    ],
    [
      "aile",
      0.01
    ],
    [
      "allonge",
      0.01
    ],
    [
      "aerien",
      0.01
    ],
    [
      "degage",
      0.01
    ]
  ],
  "gracieux": [
    [
      "aimable",
      0.09
    ],
    [
      "agreable",
      0.085
    ],
    [
      "charmant",
      0.06
    ],
    [
      "beau",
      0.05
    ],
    [
      "delicat",
      0.045
    ],
    [
      "doux",
      0.04
    ],
    [
      "gentil",
      0.04
    ],
    [
      "joli",
      0.035
    ],
    [
      "affable",
      0.035
    ],
    [
      "amene",
      0.03
    ],
    [
      "bon",
      0.03
    ],
    [
      "engageant",
      0.025
    ],
    [
      "galant",
      0.025
    ],
    [
      "poli",
      0.025
    ],
    [
      "sympathique",
      0.0225
    ],
    [
      "courtois",
      0.0175
    ],
    [
      "distingue",
      0.0175
    ],
    [
      "elegant",
      0.0175
    ],
    [
      "bienveillant",
      0.0175
    ],
    [
      "exquis",
      0.0175
    ],
    [
      "plaisant",
      0.0175
    ],
    [
      "avenant",
      0.015
    ],
    [
      "accueillant",
      0.015
    ],
    [
      "civil",
      0.0125
    ],
    [
      "adorable",
      0.01
    ],
    [
      "honnete",
      0.01
    ],
    [
      "sociable",
      0.01
    ],
    [
      "seduisant",
      0.01
    ],
    [
      "cordial",
      0.01
    ],
    [
      "coquet",
      0.01
    ],
    [
      "attrayant",
      0.0075
    ],
    [
      "tendre",
      0.0075
    ],
    [
      "empresse",
      0.0075
    ],
    [
      "favorable",
      0.0075
    ],
    [
      "leger",
      0.0075
    ],
    [
      "ravissant",
      0.0075
    ],
    [
      "suave",
      0.0075
    ],
    [
      "ouvert",
      0.005
    ],
    [
      "mignon",
      0.005
    ],
    [
      "attirant",
      0.005
    ],
    [
      "facile",
      0.0025
    ],
    [
      "harmonieux",
      0.0025
    ],
    [
      "pimpant",
      0.0025
    ],
    [
      "riant",
      0.0025
    ],
    [
      "raffine",
      0.0025
    ],
    [
      "moelleux",
      0.0025
    ],
    [
      "chaleureux",
      0.0025
    ],
    [
      "benevole",
      0.0025
    ],
    [
      "accort",
      0.0025
    ],
    [
      "gratuit",
      0.0
    ],
    [
      "gracioso",
      0.0
    ],
    [
      "gracile",
      0.0
    ],
    [
      "girond",
      0.0
    ],
    [
      "calin",
      0.0
    ],
    [
      "charmeur",
      0.0
    ],
    [
      "bienfaisant",
      0.0
    ],
    [
      "agile",
      0.0
    ],
    [
      "souriant",
      0.0
    ]
  ],
  "fluet": [
    [
      "grele",
      0.125
    ],
    [
      "maigre",
      0.105
    ],
    [
      "mince",
      0.095
    ],
    [
      "delicat",
      0.0725
    ],
    [
      "faible",
      0.0625
    ],
    [
      "menu",
      0.0625
    ],
    [
      "tenu",
      0.0525
    ],
    [
      "svelte",
      0.0525
    ],
    [
      "leger",
      0.0525
    ],
    [
      "frele",
      0.0525
    ],
    [
      "fragile",
      0.0525
    ],
    [
      "chetif",
      0.03
    ],
    [
      "gringalet",
      0.03
    ],
    [
      "maigrichon",
      0.03
    ],
    [
      "maigriot",
      0.02
    ],
    [
      "maigrelet",
      0.02
    ],
    [
      "gracile",
      0.02
    ],
    [
      "fusele",
      0.02
    ],
    [
      "anemie",
      0.01
    ],
    [
      "malingre",
      0.01
    ],
    [
      "squelettique",
      0.01
    ]
  ],
  "effleurer": [
    [
      "caresser",
      0.13
    ],
    [
      "froler",
      0.105
    ],
    [
      "toucher",
      0.095
    ],
    [
      "aborder",
      0.0575
    ],
    [
      "traiter",
      0.045
    ],
    [
      "egratigner",
      0.045
    ],
    [
      "evoquer",
      0.045
    ],
    [
      "raser",
      0.035
    ],
    [
      "friser",
      0.035
    ],
    [
      "examiner",
      0.035
    ],
    [
      "entamer",
      0.035
    ],
    [
      "serrer",
      0.0225
    ],
    [
      "peloter",
      0.0225
    ],
    [
      "glisser",
      0.0225
    ],
    [
      "frotter",
      0.0225
    ],
    [
      "chatouiller",
      0.0225
    ],
    [
      "approcher",
      0.0225
    ],
    [
      "ecrouter",
      0.01
    ],
    [
      "ecorcher",
      0.01
    ],
    [
      "survoler",
      0.01
    ],
    [
      "suggerer",
      0.01
    ],
    [
      "lecher",
      0.01
    ],
    [
      "baiser",
      0.01
    ],
    [
      "attoucher",
      0.01
    ],
    [
      "affleurer",
      0.01
    ],
    [
      "erafler",
      0.01
    ]
  ],
  "desesperant": [
    [
      "accablant",
      0.1675
    ],
    [
      "decourageant",
      0.1675
    ],
    [
      "facheux",
      0.1225
    ],
    [
      "navrant",
      0.0825
    ],
    [
      "desolant",
      0.0825
    ],
    [
      "demoralisant",
      0.0825
    ],
    [
      "attristant",
      0.0825
    ],
    [
      "debilitant",
      0.04
    ],
    [
      "imbattable",
      0.04
    ],
    [
      "morne",
      0.04
    ],
    [
      "regrettable",
      0.04
    ],
    [
      "ecoeurant",
      0.04
    ]
  ],
  "songe": [
    [
      "chimere",
      0.215
    ],
    [
      "illusion",
      0.1425
    ],
    [
      "reve",
      0.1175
    ],
    [
      "imagination",
      0.095
    ],
    [
      "fiction",
      0.07
    ],
    [
      "utopie",
      0.045
    ],
    [
      "mirage",
      0.045
    ],
    [
      "fantome",
      0.045
    ],
    [
      "billevesee",
      0.045
    ],
    [
      "cauchemar",
      0.0225
    ],
    [
      "erreur",
      0.0225
    ],
    [
      "fantasme",
      0.0225
    ],
    [
      "impossibilite",
      0.0225
    ],
    [
      "invention",
      0.0225
    ],
    [
      "irrealite",
      0.0225
    ],
    [
      "songerie",
      0.0225
    ]
  ],
  "absenter": [],
  "venant": [
    [
      "chasser",
      0.3325
    ],
    [
      "giboyer",
      0.3325
    ],
    [
      "mortifier",
      0.3325
    ]
  ],
  "tournoyer": [
    [
      "tourner",
      0.185
    ],
    [
      "tournailler",
      0.105
    ],
    [
      "virer",
      0.0775
    ],
    [
      "virevolter",
      0.0775
    ],
    [
      "voleter",
      0.05
    ],
    [
      "tourniquer",
      0.05
    ],
    [
      "tourbillonner",
      0.05
    ],
    [
      "serpenter",
      0.05
    ],
    [
      "roder",
      0.05
    ],
    [
      "pivoter",
      0.05
    ],
    [
      "errer",
      0.05
    ],
    [
      "toupiner",
      0.025
    ],
    [
      "toupiller",
      0.025
    ],
    [
      "pirouetter",
      0.025
    ],
    [
      "onduler",
      0.025
    ],
    [
      "biaiser",
      0.025
    ],
    [
      "voler",
      0.025
    ]
  ],
  "bruissement": [
    [
      "murmure",
      0.1425
    ],
    [
      "bruit",
      0.1275
    ],
    [
      "frisson",
      0.0775
    ],
    [
      "fremissement",
      0.0625
    ],
    [
      "gazouillement",
      0.05
    ],
    [
      "friselis",
      0.05
    ],
    [
      "chuchotement",
      0.05
    ],
    [
      "bourdonnement",
      0.05
    ],
    [
      "gemissement",
      0.0375
    ],
    [
      "froissement",
      0.0375
    ],
    [
      "chuchotis",
      0.0375
    ],
    [
      "grincement",
      0.025
    ],
    [
      "gazouillis",
      0.025
    ],
    [
      "cri",
      0.025
    ],
    [
      "chuintement",
      0.025
    ],
    [
      "battement",
      0.025
    ],
    [
      "fredon",
      0.0125
    ],
    [
      "fredonnement",
      0.0125
    ],
    [
      "gresillement",
      0.0125
    ],
    [
      "sifflement",
      0.0125
    ]
  ],
  "faiseur": [
    [
      "intrigant",
      0.1125
    ],
    [
      "constructeur",
      0.0725
    ],
    [
      "escroc",
      0.0725
    ],
    [
      "fabricant",
      0.0725
    ],
    [
      "fanfaron",
      0.0725
    ],
    [
      "fripon",
      0.035
    ],
    [
      "hableur",
      0.035
    ],
    [
      "ouvrier",
      0.035
    ],
    [
      "snob",
      0.035
    ],
    [
      "tailleur",
      0.035
    ],
    [
      "forgeur",
      0.035
    ],
    [
      "faisan",
      0.035
    ],
    [
      "fabricateur",
      0.035
    ],
    [
      "diseur",
      0.035
    ],
    [
      "becheur",
      0.035
    ],
    [
      "batisseur",
      0.035
    ],
    [
      "aventurier",
      0.035
    ],
    [
      "arriviste",
      0.035
    ],
    [
      "amateur",
      0.035
    ],
    [
      "vantard",
      0.035
    ]
  ],
  "vol": [
    [
      "escroquerie",
      0.095
    ],
    [
      "agression",
      0.0525
    ],
    [
      "filouterie",
      0.0525
    ],
    [
      "pillage",
      0.0425
    ],
    [
      "rapine",
      0.035
    ],
    [
      "malversation",
      0.035
    ],
    [
      "friponnerie",
      0.035
    ],
    [
      "exaction",
      0.035
    ],
    [
      "maraude",
      0.025
    ],
    [
      "maraudage",
      0.025
    ],
    [
      "larcin",
      0.025
    ],
    [
      "envol",
      0.025
    ],
    [
      "carotte",
      0.025
    ],
    [
      "brigandage",
      0.025
    ],
    [
      "volee",
      0.015
    ],
    [
      "volerie",
      0.015
    ],
    [
      "tripotage",
      0.015
    ],
    [
      "resquille",
      0.015
    ],
    [
      "malhonnetete",
      0.015
    ],
    [
      "indelicatesse",
      0.015
    ],
    [
      "grivelerie",
      0.015
    ],
    [
      "exploitation",
      0.015
    ],
    [
      "essaim",
      0.015
    ],
    [
      "enlevement",
      0.015
    ],
    [
      "detournement",
      0.015
    ],
    [
      "abus",
      0.015
    ],
    [
      "filoutage",
      0.0075
    ],
    [
      "essor",
      0.0075
    ],
    [
      "escamotage",
      0.0075
    ],
    [
      "envolee",
      0.0075
    ],
    [
      "fuite",
      0.0075
    ],
    [
      "levitation",
      0.0075
    ],
    [
      "mainmise",
      0.0075
    ],
    [
      "marauderie",
      0.0075
    ],
    [
      "nuee",
      0.0075
    ],
    [
      "soustraction",
      0.0075
    ],
    [
      "entolage",
      0.0075
    ],
    [
      "effraction",
      0.0075
    ],
    [
      "decollage",
      0.0075
    ],
    [
      "appropriation",
      0.0075
    ],
    [
      "arnaque",
      0.0075
    ],
    [
      "attaque",
      0.0075
    ],
    [
      "butin",
      0.0075
    ],
    [
      "cambriolage",
      0.0075
    ],
    [
      "carambouillage",
      0.0075
    ],
    [
      "carambouille",
      0.0075
    ],
    [
      "casse",
      0.0075
    ],
    [
      "chantage",
      0.0075
    ],
    [
      "chapardage",
      0.0075
    ],
    [
      "contrefacon",
      0.0075
    ],
    [
      "crime",
      0.0075
    ],
    [
      "agglomeration",
      0.0075
    ]
  ],
  "regagner": [
    [
      "retrouver",
      0.1575
    ],
    [
      "revenir",
      0.13
    ],
    [
      "rentrer",
      0.105
    ],
    [
      "reprendre",
      0.105
    ],
    [
      "recuperer",
      0.0775
    ],
    [
      "retourner",
      0.0775
    ],
    [
      "rejoindre",
      0.0775
    ],
    [
      "rallier",
      0.0525
    ],
    [
      "rattraper",
      0.0525
    ],
    [
      "reconquerir",
      0.0525
    ],
    [
      "recouvrer",
      0.0525
    ],
    [
      "reintegrer",
      0.025
    ]
  ],
  "poinconneur": [],
  "croisiere": [
    [
      "circuit",
      0.25
    ],
    [
      "tour",
      0.25
    ],
    [
      "voyage",
      0.25
    ],
    [
      "promenade",
      0.125
    ],
    [
      "periple",
      0.125
    ]
  ],
  "extrait": [
    [
      "enlever",
      0.1275
    ],
    [
      "oter",
      0.0825
    ],
    [
      "arracher",
      0.0725
    ],
    [
      "separer",
      0.0725
    ],
    [
      "tirer",
      0.0725
    ],
    [
      "degager",
      0.0625
    ],
    [
      "detacher",
      0.0625
    ],
    [
      "retirer",
      0.0625
    ],
    [
      "extirper",
      0.045
    ],
    [
      "prendre",
      0.035
    ],
    [
      "sortir",
      0.035
    ],
    [
      "relever",
      0.0275
    ],
    [
      "sucer",
      0.0175
    ],
    [
      "recueillir",
      0.0175
    ],
    [
      "prelever",
      0.0175
    ],
    [
      "isoler",
      0.0175
    ],
    [
      "extorquer",
      0.0175
    ],
    [
      "exprimer",
      0.0175
    ],
    [
      "deraciner",
      0.0175
    ],
    [
      "debarrasser",
      0.0175
    ],
    [
      "distraire",
      0.0175
    ],
    [
      "analyser",
      0.0175
    ],
    [
      "resumer",
      0.0075
    ],
    [
      "recopier",
      0.0075
    ],
    [
      "presser",
      0.0075
    ],
    [
      "distiller",
      0.0075
    ],
    [
      "compiler",
      0.0075
    ],
    [
      "enucleer",
      0.0075
    ]
  ],
  "extraire": [
    [
      "enlever",
      0.1275
    ],
    [
      "oter",
      0.0825
    ],
    [
      "arracher",
      0.0725
    ],
    [
      "separer",
      0.0725
    ],
    [
      "tirer",
      0.0725
    ],
    [
      "degager",
      0.0625
    ],
    [
      "detacher",
      0.0625
    ],
    [
      "retirer",
      0.0625
    ],
    [
      "extirper",
      0.045
    ],
    [
      "prendre",
      0.035
    ],
    [
      "sortir",
      0.035
    ],
    [
      "relever",
      0.0275
    ],
    [
      "sucer",
      0.0175
    ],
    [
      "recueillir",
      0.0175
    ],
    [
      "prelever",
      0.0175
    ],
    [
      "isoler",
      0.0175
    ],
    [
      "extorquer",
      0.0175
    ],
    [
      "exprimer",
      0.0175
    ],
    [
      "deraciner",
      0.0175
    ],
    [
      "debarrasser",
      0.0175
    ],
    [
      "distraire",
      0.0175
    ],
    [
      "analyser",
      0.0175
    ],
    [
      "resumer",
      0.0075
    ],
    [
      "recopier",
      0.0075
    ],
    [
      "presser",
      0.0075
    ],
    [
      "distiller",
      0.0075
    ],
    [
      "compiler",
      0.0075
    ],
    [
      "enucleer",
      0.0075
    ]
  ],
  "zouave": [
    [
      "clown",
      0.18
    ],
    [
      "pierrot",
      0.18
    ],
    [
      "soldat",
      0.18
    ],
    [
      "chacal",
      0.09
    ],
    [
      "fantassin",
      0.09
    ],
    [
      "homme",
      0.09
    ],
    [
      "numero",
      0.09
    ],
    [
      "pitre",
      0.09
    ]
  ],
  "jusque": [
    [
      "meme",
      0.3325
    ],
    [
      "pour",
      0.3325
    ]
  ],
  "faience": [
    [
      "carreau",
      0.11
    ],
    [
      "ceramique",
      0.11
    ],
    [
      "pot",
      0.11
    ],
    [
      "zellige",
      0.11
    ],
    [
      "plat",
      0.055
    ],
    [
      "pichet",
      0.055
    ],
    [
      "majolique",
      0.055
    ],
    [
      "faiencerie",
      0.055
    ],
    [
      "carrelage",
      0.055
    ],
    [
      "cailloutage",
      0.055
    ],
    [
      "bol",
      0.055
    ],
    [
      "azulejo",
      0.055
    ],
    [
      "assiette",
      0.055
    ],
    [
      "poterie",
      0.055
    ]
  ],
  "correspondance": [
    [
      "rapport",
      0.11
    ],
    [
      "accord",
      0.07
    ],
    [
      "harmonie",
      0.05
    ],
    [
      "relation",
      0.05
    ],
    [
      "liaison",
      0.045
    ],
    [
      "correlation",
      0.045
    ],
    [
      "concordance",
      0.045
    ],
    [
      "affinite",
      0.0375
    ],
    [
      "convenance",
      0.03
    ],
    [
      "similitude",
      0.03
    ],
    [
      "union",
      0.03
    ],
    [
      "ressemblance",
      0.025
    ],
    [
      "conformite",
      0.025
    ],
    [
      "analogie",
      0.025
    ],
    [
      "proportion",
      0.0175
    ],
    [
      "lettre",
      0.0175
    ],
    [
      "depeche",
      0.0175
    ],
    [
      "communion",
      0.0175
    ],
    [
      "communication",
      0.0175
    ],
    [
      "chronique",
      0.0175
    ],
    [
      "synchronisme",
      0.0125
    ],
    [
      "symetrie",
      0.0125
    ],
    [
      "message",
      0.0125
    ],
    [
      "intimite",
      0.0125
    ],
    [
      "frequentation",
      0.0125
    ],
    [
      "dependance",
      0.0125
    ],
    [
      "coincidence",
      0.0125
    ],
    [
      "courrier",
      0.0125
    ],
    [
      "connexite",
      0.0125
    ],
    [
      "concomitance",
      0.0125
    ],
    [
      "commerce",
      0.0125
    ],
    [
      "relais",
      0.005
    ],
    [
      "reportage",
      0.005
    ],
    [
      "rubrique",
      0.005
    ],
    [
      "reciprocite",
      0.005
    ],
    [
      "simultaneite",
      0.005
    ],
    [
      "valise",
      0.005
    ],
    [
      "epitre",
      0.005
    ],
    [
      "lettres",
      0.005
    ],
    [
      "intelligence",
      0.005
    ],
    [
      "fonction",
      0.005
    ],
    [
      "diagramme",
      0.005
    ],
    [
      "courbe",
      0.005
    ],
    [
      "changement",
      0.005
    ],
    [
      "billet",
      0.005
    ],
    [
      "application",
      0.005
    ],
    [
      "accordance",
      0.005
    ],
    [
      "equilibre",
      0.005
    ]
  ],
  "derailler": [
    [
      "divaguer",
      0.21
    ],
    [
      "deraisonner",
      0.1575
    ],
    [
      "delirer",
      0.105
    ],
    [
      "radoter",
      0.105
    ],
    [
      "foirer",
      0.05
    ],
    [
      "devier",
      0.05
    ],
    [
      "deraper",
      0.05
    ],
    [
      "demenager",
      0.05
    ],
    [
      "debloquer",
      0.05
    ],
    [
      "s'egarer",
      0.05
    ]
  ],
  "cloaque": [
    [
      "sentine",
      0.2325
    ],
    [
      "boue",
      0.1
    ],
    [
      "marais",
      0.1
    ],
    [
      "marecage",
      0.065
    ],
    [
      "margouillis",
      0.065
    ],
    [
      "bourbier",
      0.065
    ],
    [
      "abjection",
      0.065
    ],
    [
      "charnier",
      0.0325
    ],
    [
      "decharge",
      0.0325
    ],
    [
      "gachis",
      0.0325
    ],
    [
      "voirie",
      0.0325
    ],
    [
      "egout",
      0.0325
    ]
  ],
  "vestiaire": [],
  "dinguer": [
    [
      "valdinguer",
      0.4
    ],
    [
      "degringoler",
      0.2
    ],
    [
      "tomber",
      0.2
    ],
    [
      "valser",
      0.2
    ]
  ],
  "argument": [
    [
      "demonstration",
      0.1225
    ],
    [
      "raison",
      0.0975
    ],
    [
      "preuve",
      0.0725
    ],
    [
      "raisonnement",
      0.0725
    ],
    [
      "temoignage",
      0.0475
    ],
    [
      "sommaire",
      0.0475
    ],
    [
      "preface",
      0.0475
    ],
    [
      "justification",
      0.0475
    ],
    [
      "indice",
      0.0475
    ],
    [
      "exposition",
      0.0475
    ],
    [
      "dialectique",
      0.0475
    ],
    [
      "argumentation",
      0.0475
    ],
    [
      "resume",
      0.0225
    ],
    [
      "rhetorique",
      0.0225
    ],
    [
      "pretexte",
      0.0225
    ],
    [
      "prologue",
      0.0225
    ],
    [
      "parade",
      0.0225
    ],
    [
      "expose",
      0.0225
    ],
    [
      "arme",
      0.0225
    ],
    [
      "abrege",
      0.0225
    ],
    [
      "traite",
      0.0225
    ]
  ],
  "improviser": [
    [
      "bombarder",
      0.25
    ],
    [
      "imaginer",
      0.25
    ],
    [
      "inventer",
      0.25
    ],
    [
      "preluder",
      0.25
    ]
  ],
  "improvise": [
    [
      "bombarder",
      0.25
    ],
    [
      "imaginer",
      0.25
    ],
    [
      "inventer",
      0.25
    ],
    [
      "preluder",
      0.25
    ]
  ],
  "superbe": [
    [
      "orgueilleux",
      0.075
    ],
    [
      "vaniteux",
      0.05
    ],
    [
      "orgueil",
      0.0475
    ],
    [
      "fat",
      0.0425
    ],
    [
      "suffisant",
      0.0425
    ],
    [
      "fier",
      0.04
    ],
    [
      "important",
      0.035
    ],
    [
      "beau",
      0.0325
    ],
    [
      "pretentieux",
      0.0325
    ],
    [
      "outrecuidance",
      0.025
    ],
    [
      "outrecuidant",
      0.0225
    ],
    [
      "arrogant",
      0.0225
    ],
    [
      "arrogance",
      0.0225
    ],
    [
      "fierte",
      0.02
    ],
    [
      "suffisance",
      0.02
    ],
    [
      "magnifique",
      0.02
    ],
    [
      "vanite",
      0.02
    ],
    [
      "imposant",
      0.0175
    ],
    [
      "haut",
      0.015
    ],
    [
      "superieur",
      0.015
    ],
    [
      "pretention",
      0.0125
    ],
    [
      "morgue",
      0.0125
    ],
    [
      "hauteur",
      0.0125
    ],
    [
      "avantageux",
      0.0125
    ],
    [
      "glorieux",
      0.0125
    ],
    [
      "hautain",
      0.0125
    ],
    [
      "majestueux",
      0.0125
    ],
    [
      "presomptueux",
      0.0125
    ],
    [
      "presomption",
      0.01
    ],
    [
      "infatue",
      0.01
    ],
    [
      "grandiose",
      0.01
    ],
    [
      "craneur",
      0.01
    ],
    [
      "splendide",
      0.0075
    ],
    [
      "poseur",
      0.0075
    ],
    [
      "infatuation",
      0.0075
    ],
    [
      "fatuite",
      0.0075
    ],
    [
      "brillant",
      0.0075
    ],
    [
      "architectural",
      0.0075
    ],
    [
      "vain",
      0.005
    ],
    [
      "sublime",
      0.005
    ],
    [
      "somptueux",
      0.005
    ],
    [
      "faraud",
      0.005
    ],
    [
      "dedain",
      0.005
    ],
    [
      "dedaigneux",
      0.005
    ],
    [
      "admirable",
      0.005
    ],
    [
      "etonnant",
      0.005
    ],
    [
      "superiorite",
      0.005
    ],
    [
      "rencheri",
      0.005
    ],
    [
      "ostentation",
      0.005
    ],
    [
      "merveilleux",
      0.005
    ],
    [
      "insolence",
      0.005
    ],
    [
      "importance",
      0.005
    ],
    [
      "sourcilleux",
      0.0025
    ],
    [
      "riche",
      0.0025
    ],
    [
      "radieux",
      0.0025
    ],
    [
      "puant",
      0.0025
    ],
    [
      "plastronneur",
      0.0025
    ],
    [
      "jactance",
      0.0025
    ],
    [
      "gloriole",
      0.0025
    ],
    [
      "content",
      0.0025
    ],
    [
      "altier",
      0.0025
    ],
    [
      "paon",
      0.0
    ],
    [
      "paradisiaque",
      0.0
    ],
    [
      "pose",
      0.0
    ],
    [
      "ravissant",
      0.0
    ],
    [
      "sensationnel",
      0.0
    ],
    [
      "mepris",
      0.0
    ],
    [
      "megalomanie",
      0.0
    ],
    [
      "majeste",
      0.0
    ],
    [
      "imperieux",
      0.0
    ],
    [
      "gobeur",
      0.0
    ],
    [
      "flambard",
      0.0
    ],
    [
      "flambant",
      0.0
    ],
    [
      "fertile",
      0.0
    ],
    [
      "estime",
      0.0
    ],
    [
      "supercoquentieux",
      0.0
    ]
  ],
  "insoler": [],
  "certitude": [
    [
      "conviction",
      0.1225
    ],
    [
      "foi",
      0.105
    ],
    [
      "assurance",
      0.0875
    ],
    [
      "croyance",
      0.0875
    ],
    [
      "verite",
      0.07
    ],
    [
      "fermete",
      0.07
    ],
    [
      "esperance",
      0.0525
    ],
    [
      "nettete",
      0.0525
    ],
    [
      "evidence",
      0.0525
    ],
    [
      "surete",
      0.035
    ],
    [
      "persuasion",
      0.035
    ],
    [
      "clarte",
      0.035
    ],
    [
      "autorite",
      0.035
    ],
    [
      "realite",
      0.0175
    ],
    [
      "opinion",
      0.0175
    ],
    [
      "infaillibilite",
      0.0175
    ],
    [
      "espoir",
      0.0175
    ],
    [
      "dogme",
      0.0175
    ],
    [
      "connaissance",
      0.0175
    ],
    [
      "confirmation",
      0.0175
    ],
    [
      "stabilite",
      0.0175
    ]
  ],
  "candeur": [
    [
      "naivete",
      0.1625
    ],
    [
      "simplicite",
      0.145
    ],
    [
      "ingenuite",
      0.125
    ],
    [
      "innocence",
      0.1075
    ],
    [
      "purete",
      0.09
    ],
    [
      "bonte",
      0.0525
    ],
    [
      "credulite",
      0.0525
    ],
    [
      "sincerite",
      0.035
    ],
    [
      "grace",
      0.035
    ],
    [
      "fraicheur",
      0.035
    ],
    [
      "blancheur",
      0.0175
    ],
    [
      "bonhomie",
      0.0175
    ],
    [
      "franchise",
      0.0175
    ],
    [
      "ignorance",
      0.0175
    ],
    [
      "niais",
      0.0175
    ],
    [
      "niaiserie",
      0.0175
    ],
    [
      "simplesse",
      0.0175
    ],
    [
      "virginite",
      0.0175
    ]
  ],
  "veterinaire": [
    [
      "zootherapeutique",
      1.0
    ]
  ],
  "compote": [
    [
      "marmelade",
      0.4275
    ],
    [
      "bouillie",
      0.1425
    ],
    [
      "confiture",
      0.1425
    ],
    [
      "hachis",
      0.1425
    ],
    [
      "ragout",
      0.1425
    ]
  ],
  "penche": [
    [
      "incliner",
      0.1775
    ],
    [
      "flechir",
      0.1125
    ],
    [
      "baisser",
      0.08
    ],
    [
      "descendre",
      0.065
    ],
    [
      "s'incliner",
      0.0475
    ],
    [
      "courber",
      0.0475
    ],
    [
      "coucher",
      0.0475
    ],
    [
      "toucher",
      0.0325
    ],
    [
      "preferer",
      0.0325
    ],
    [
      "porter",
      0.0325
    ],
    [
      "glisser",
      0.0325
    ],
    [
      "decliner",
      0.0325
    ],
    [
      "chanceler",
      0.0325
    ],
    [
      "abaisser",
      0.0325
    ],
    [
      "tendre",
      0.015
    ],
    [
      "renverser",
      0.015
    ],
    [
      "opter",
      0.015
    ],
    [
      "obliquer",
      0.015
    ],
    [
      "inflechir",
      0.015
    ],
    [
      "deverser",
      0.015
    ]
  ],
  "pencher": [
    [
      "incliner",
      0.1775
    ],
    [
      "flechir",
      0.1125
    ],
    [
      "baisser",
      0.08
    ],
    [
      "descendre",
      0.065
    ],
    [
      "s'incliner",
      0.0475
    ],
    [
      "courber",
      0.0475
    ],
    [
      "coucher",
      0.0475
    ],
    [
      "toucher",
      0.0325
    ],
    [
      "preferer",
      0.0325
    ],
    [
      "porter",
      0.0325
    ],
    [
      "glisser",
      0.0325
    ],
    [
      "decliner",
      0.0325
    ],
    [
      "chanceler",
      0.0325
    ],
    [
      "abaisser",
      0.0325
    ],
    [
      "tendre",
      0.015
    ],
    [
      "renverser",
      0.015
    ],
    [
      "opter",
      0.015
    ],
    [
      "obliquer",
      0.015
    ],
    [
      "inflechir",
      0.015
    ],
    [
      "deverser",
      0.015
    ]
  ],
  "observer": [
    [
      "examiner",
      0.0675
    ],
    [
      "voir",
      0.0625
    ],
    [
      "regarder",
      0.0575
    ],
    [
      "tenir",
      0.0575
    ],
    [
      "suivre",
      0.0375
    ],
    [
      "etudier",
      0.0325
    ],
    [
      "remarquer",
      0.0325
    ],
    [
      "considerer",
      0.0275
    ],
    [
      "obeir",
      0.0275
    ],
    [
      "respecter",
      0.0275
    ],
    [
      "surveiller",
      0.0275
    ],
    [
      "satisfaire",
      0.0225
    ],
    [
      "pratiquer",
      0.0225
    ],
    [
      "faire",
      0.0225
    ],
    [
      "devisager",
      0.0225
    ],
    [
      "constater",
      0.0225
    ],
    [
      "scruter",
      0.0175
    ],
    [
      "marquer",
      0.0175
    ],
    [
      "fixer",
      0.0175
    ],
    [
      "decouvrir",
      0.0175
    ],
    [
      "contempler",
      0.0175
    ],
    [
      "accomplir",
      0.0175
    ],
    [
      "epier",
      0.0125
    ],
    [
      "signaler",
      0.0125
    ],
    [
      "reflechir",
      0.0125
    ],
    [
      "relever",
      0.0125
    ],
    [
      "noter",
      0.0125
    ],
    [
      "garder",
      0.0125
    ],
    [
      "executer",
      0.0125
    ],
    [
      "experimenter",
      0.0125
    ],
    [
      "dire",
      0.0125
    ],
    [
      "toiser",
      0.0075
    ],
    [
      "rendre",
      0.0075
    ],
    [
      "remplir",
      0.0075
    ],
    [
      "guetter",
      0.0075
    ],
    [
      "espionner",
      0.0075
    ],
    [
      "bigler",
      0.0075
    ],
    [
      "apercevoir",
      0.0075
    ],
    [
      "speculer",
      0.0025
    ],
    [
      "s'enquerir",
      0.0025
    ],
    [
      "s'aviser",
      0.0025
    ],
    [
      "s'acquitter",
      0.0025
    ],
    [
      "reluquer",
      0.0025
    ],
    [
      "flairer",
      0.0025
    ],
    [
      "explorer",
      0.0025
    ]
  ],
  "gazouiller": [
    [
      "chanter",
      0.1575
    ],
    [
      "jaser",
      0.1575
    ],
    [
      "murmurer",
      0.1575
    ],
    [
      "babiller",
      0.105
    ],
    [
      "sentir",
      0.05
    ],
    [
      "pepier",
      0.05
    ],
    [
      "puer",
      0.05
    ],
    [
      "piailler",
      0.05
    ],
    [
      "gringotter",
      0.05
    ],
    [
      "chuchoter",
      0.05
    ],
    [
      "bruire",
      0.05
    ],
    [
      "susurrer",
      0.05
    ]
  ],
  "traversant": [
    [
      "penetrer",
      0.1
    ],
    [
      "passer",
      0.09
    ],
    [
      "percer",
      0.075
    ],
    [
      "couler",
      0.0625
    ],
    [
      "fendre",
      0.05
    ],
    [
      "courir",
      0.05
    ],
    [
      "couper",
      0.05
    ],
    [
      "transpercer",
      0.0375
    ],
    [
      "parcourir",
      0.0375
    ],
    [
      "empecher",
      0.0375
    ],
    [
      "dechirer",
      0.0375
    ],
    [
      "barrer",
      0.0375
    ],
    [
      "baigner",
      0.0375
    ],
    [
      "aller",
      0.0375
    ],
    [
      "trouer",
      0.025
    ],
    [
      "sillonner",
      0.025
    ],
    [
      "franchir",
      0.025
    ],
    [
      "filtrer",
      0.025
    ],
    [
      "contrarier",
      0.025
    ],
    [
      "transir",
      0.01
    ],
    [
      "perforer",
      0.01
    ],
    [
      "interrompre",
      0.01
    ],
    [
      "infiltrer",
      0.01
    ],
    [
      "gener",
      0.01
    ],
    [
      "croiser",
      0.01
    ],
    [
      "arroser",
      0.01
    ],
    [
      "vivre",
      0.01
    ]
  ],
  "foulard": [
    [
      "fichu",
      0.18
    ],
    [
      "coiffure",
      0.135
    ],
    [
      "echarpe",
      0.135
    ],
    [
      "pointe",
      0.09
    ],
    [
      "mouchoir",
      0.09
    ],
    [
      "madras",
      0.09
    ],
    [
      "carre",
      0.09
    ],
    [
      "soie",
      0.045
    ]
  ],
  "milord": [
    [
      "nabab",
      0.5
    ],
    [
      "riche",
      0.5
    ]
  ],
  "tin": [
    [
      "billot",
      0.3325
    ],
    [
      "bequille",
      0.3325
    ],
    [
      "chantier",
      0.3325
    ]
  ],
  "santiag": [
    [
      "botte",
      1.0
    ]
  ],
  "deserte": [
    [
      "abandonner",
      0.225
    ],
    [
      "delaisser",
      0.135
    ],
    [
      "quitter",
      0.135
    ],
    [
      "s'eloigner",
      0.135
    ],
    [
      "renier",
      0.09
    ],
    [
      "negliger",
      0.09
    ],
    [
      "oublier",
      0.045
    ],
    [
      "partir",
      0.045
    ],
    [
      "s'enfuir",
      0.045
    ],
    [
      "trahir",
      0.045
    ]
  ],
  "crasse": [
    [
      "salete",
      0.1075
    ],
    [
      "mechancete",
      0.0975
    ],
    [
      "vacherie",
      0.075
    ],
    [
      "saloperie",
      0.065
    ],
    [
      "vilenie",
      0.0525
    ],
    [
      "rosserie",
      0.0525
    ],
    [
      "entourloupette",
      0.0525
    ],
    [
      "malproprete",
      0.0425
    ],
    [
      "ordure",
      0.0325
    ],
    [
      "noirceur",
      0.0325
    ],
    [
      "misere",
      0.0325
    ],
    [
      "cochonnerie",
      0.0325
    ],
    [
      "bassesse",
      0.0325
    ],
    [
      "abjection",
      0.0325
    ],
    [
      "tache",
      0.02
    ],
    [
      "perfidie",
      0.02
    ],
    [
      "indelicatesse",
      0.02
    ],
    [
      "crotte",
      0.02
    ],
    [
      "ecume",
      0.01
    ],
    [
      "tour",
      0.01
    ],
    [
      "souillure",
      0.01
    ],
    [
      "patine",
      0.01
    ],
    [
      "nul",
      0.01
    ],
    [
      "mouise",
      0.01
    ],
    [
      "lourd",
      0.01
    ],
    [
      "inexcusable",
      0.01
    ],
    [
      "ignorance",
      0.01
    ],
    [
      "grossier",
      0.01
    ],
    [
      "bruine",
      0.01
    ],
    [
      "brouillasse",
      0.01
    ],
    [
      "avarice",
      0.01
    ],
    [
      "epais",
      0.01
    ]
  ],
  "prudent": [
    [
      "sage",
      0.14
    ],
    [
      "circonspect",
      0.0975
    ],
    [
      "serieux",
      0.0575
    ],
    [
      "reserve",
      0.0575
    ],
    [
      "reflechi",
      0.0575
    ],
    [
      "avise",
      0.0575
    ],
    [
      "habile",
      0.04
    ],
    [
      "pose",
      0.04
    ],
    [
      "retenu",
      0.0325
    ],
    [
      "grave",
      0.0325
    ],
    [
      "calme",
      0.0325
    ],
    [
      "bon",
      0.0325
    ],
    [
      "timore",
      0.0225
    ],
    [
      "precautionneux",
      0.0225
    ],
    [
      "mesure",
      0.0225
    ],
    [
      "averti",
      0.0225
    ],
    [
      "vigilant",
      0.015
    ],
    [
      "raisonnable",
      0.015
    ],
    [
      "prevoyant",
      0.015
    ],
    [
      "politique",
      0.015
    ],
    [
      "nestor",
      0.015
    ],
    [
      "mefiant",
      0.015
    ],
    [
      "frileux",
      0.015
    ],
    [
      "experimente",
      0.015
    ],
    [
      "attentif",
      0.015
    ],
    [
      "pusillanime",
      0.005
    ],
    [
      "precautionne",
      0.005
    ],
    [
      "prud'homme",
      0.005
    ],
    [
      "peinard",
      0.005
    ],
    [
      "neutre",
      0.005
    ],
    [
      "inconsistant",
      0.005
    ],
    [
      "entendu",
      0.005
    ],
    [
      "defiant",
      0.005
    ],
    [
      "discret",
      0.005
    ],
    [
      "vertueux",
      0.005
    ]
  ],
  "depourvoir": [
    [
      "depouiller",
      0.4
    ],
    [
      "destituer",
      0.2
    ],
    [
      "degarnir",
      0.2
    ],
    [
      "demunir",
      0.2
    ]
  ],
  "depourvu": [
    [
      "depouiller",
      0.4
    ],
    [
      "destituer",
      0.2
    ],
    [
      "degarnir",
      0.2
    ],
    [
      "demunir",
      0.2
    ]
  ],
  "vomi": [
    [
      "vomissement",
      0.5
    ],
    [
      "vomissure",
      0.5
    ]
  ],
  "plaisance": [
    [
      "amusement",
      0.2
    ],
    [
      "divertissement",
      0.2
    ],
    [
      "plaisir",
      0.2
    ],
    [
      "agrement",
      0.1
    ],
    [
      "loisir",
      0.1
    ],
    [
      "luxe",
      0.1
    ],
    [
      "yachting",
      0.1
    ]
  ],
  "jetee": [
    [
      "lancer",
      0.07
    ],
    [
      "pousser",
      0.045
    ],
    [
      "repandre",
      0.04
    ],
    [
      "abandonner",
      0.035
    ],
    [
      "flanquer",
      0.035
    ],
    [
      "rejeter",
      0.0325
    ],
    [
      "balancer",
      0.0325
    ],
    [
      "mettre",
      0.0275
    ],
    [
      "lacher",
      0.0225
    ],
    [
      "ficher",
      0.0225
    ],
    [
      "envoyer",
      0.0225
    ],
    [
      "entrainer",
      0.0225
    ],
    [
      "conduire",
      0.0225
    ],
    [
      "emettre",
      0.02
    ],
    [
      "elever",
      0.02
    ],
    [
      "semer",
      0.02
    ],
    [
      "repousser",
      0.02
    ],
    [
      "dresser",
      0.02
    ],
    [
      "adresser",
      0.02
    ],
    [
      "eparpiller",
      0.015
    ],
    [
      "ejecter",
      0.015
    ],
    [
      "repartir",
      0.015
    ],
    [
      "projeter",
      0.015
    ],
    [
      "poser",
      0.015
    ],
    [
      "larguer",
      0.015
    ],
    [
      "foutre",
      0.015
    ],
    [
      "distribuer",
      0.015
    ],
    [
      "riposter",
      0.01
    ],
    [
      "verser",
      0.01
    ],
    [
      "epandre",
      0.01
    ],
    [
      "precipiter",
      0.01
    ],
    [
      "provoquer",
      0.01
    ],
    [
      "prodiguer",
      0.01
    ],
    [
      "plonger",
      0.01
    ],
    [
      "engager",
      0.01
    ],
    [
      "detruire",
      0.01
    ],
    [
      "bombarder",
      0.01
    ],
    [
      "bazarder",
      0.01
    ],
    [
      "glisser",
      0.0075
    ],
    [
      "liquider",
      0.0075
    ],
    [
      "proferer",
      0.0075
    ],
    [
      "releguer",
      0.0075
    ],
    [
      "eriger",
      0.0075
    ],
    [
      "deverser",
      0.0075
    ],
    [
      "disperser",
      0.0075
    ],
    [
      "catapulter",
      0.0075
    ],
    [
      "communiquer",
      0.0075
    ],
    [
      "construire",
      0.0075
    ],
    [
      "darder",
      0.0075
    ],
    [
      "descendre",
      0.0075
    ],
    [
      "edifier",
      0.0025
    ],
    [
      "retorquer",
      0.0025
    ],
    [
      "parsemer",
      0.0025
    ],
    [
      "insuffler",
      0.0025
    ],
    [
      "insinuer",
      0.0025
    ],
    [
      "imprimer",
      0.0025
    ],
    [
      "drosser",
      0.0025
    ],
    [
      "dispenser",
      0.0025
    ],
    [
      "causer",
      0.0025
    ],
    [
      "balanstiquer",
      0.0025
    ],
    [
      "ejaculer",
      0.0025
    ]
  ],
  "delaver": [
    [
      "affadir",
      0.1675
    ],
    [
      "mouiller",
      0.1675
    ],
    [
      "tremper",
      0.11
    ],
    [
      "laver",
      0.11
    ],
    [
      "imbiber",
      0.11
    ],
    [
      "detremper",
      0.11
    ],
    [
      "degraisser",
      0.0525
    ],
    [
      "humecter",
      0.0525
    ],
    [
      "ternir",
      0.0525
    ],
    [
      "eclaircir",
      0.0525
    ]
  ],
  "delave": [
    [
      "affadir",
      0.1675
    ],
    [
      "mouiller",
      0.1675
    ],
    [
      "tremper",
      0.11
    ],
    [
      "laver",
      0.11
    ],
    [
      "imbiber",
      0.11
    ],
    [
      "detremper",
      0.11
    ],
    [
      "degraisser",
      0.0525
    ],
    [
      "humecter",
      0.0525
    ],
    [
      "ternir",
      0.0525
    ],
    [
      "eclaircir",
      0.0525
    ]
  ],
  "bitte": [
    [
      "bollard",
      0.3325
    ],
    [
      "bite",
      0.165
    ],
    [
      "bitton",
      0.165
    ],
    [
      "borne",
      0.165
    ],
    [
      "canon",
      0.165
    ]
  ],
  "amarrage": [
    [
      "attache",
      0.24
    ],
    [
      "corde",
      0.1375
    ],
    [
      "cable",
      0.1375
    ],
    [
      "lien",
      0.1025
    ],
    [
      "chaine",
      0.0675
    ],
    [
      "fil",
      0.0675
    ],
    [
      "liure",
      0.0325
    ],
    [
      "jarretiere",
      0.0325
    ],
    [
      "cheville",
      0.0325
    ],
    [
      "bridure",
      0.0325
    ],
    [
      "arrimage",
      0.0325
    ],
    [
      "amarre",
      0.0325
    ],
    [
      "raban",
      0.0325
    ]
  ],
  "etape": [
    [
      "stade",
      0.075
    ],
    [
      "halte",
      0.06
    ],
    [
      "palier",
      0.06
    ],
    [
      "phase",
      0.06
    ],
    [
      "periode",
      0.06
    ],
    [
      "trajet",
      0.0425
    ],
    [
      "temps",
      0.0425
    ],
    [
      "relais",
      0.0425
    ],
    [
      "poste",
      0.0425
    ],
    [
      "parcours",
      0.0425
    ],
    [
      "hotel",
      0.0425
    ],
    [
      "chemin",
      0.0425
    ],
    [
      "echelon",
      0.03
    ],
    [
      "repos",
      0.03
    ],
    [
      "gite",
      0.03
    ],
    [
      "degre",
      0.03
    ],
    [
      "auberge",
      0.03
    ],
    [
      "arret",
      0.03
    ],
    [
      "trotte",
      0.0125
    ],
    [
      "traite",
      0.0125
    ],
    [
      "siecle",
      0.0125
    ],
    [
      "route",
      0.0125
    ],
    [
      "pas",
      0.0125
    ],
    [
      "morceau",
      0.0125
    ],
    [
      "lieu",
      0.0125
    ],
    [
      "journee",
      0.0125
    ],
    [
      "gradation",
      0.0125
    ],
    [
      "escale",
      0.0125
    ],
    [
      "entrepot",
      0.0125
    ],
    [
      "couchee",
      0.0125
    ],
    [
      "epoque",
      0.0125
    ]
  ],
  "grappe": [
    [
      "groupe",
      0.2325
    ],
    [
      "amas",
      0.1525
    ],
    [
      "faisceau",
      0.1525
    ],
    [
      "amoncellement",
      0.075
    ],
    [
      "chapelet",
      0.075
    ],
    [
      "essaim",
      0.075
    ],
    [
      "pampre",
      0.075
    ],
    [
      "paquet",
      0.075
    ],
    [
      "raisin",
      0.075
    ]
  ],
  "boxon": [
    [
      "bordel",
      0.3325
    ],
    [
      "bobinard",
      0.11
    ],
    [
      "bocard",
      0.11
    ],
    [
      "bouge",
      0.11
    ]
  ],
  "fameux": [
    [
      "beau",
      0.07
    ],
    [
      "grand",
      0.0625
    ],
    [
      "remarquable",
      0.0625
    ],
    [
      "illustre",
      0.0575
    ],
    [
      "eminent",
      0.0475
    ],
    [
      "superieur",
      0.045
    ],
    [
      "celebre",
      0.045
    ],
    [
      "bon",
      0.04
    ],
    [
      "distingue",
      0.0375
    ],
    [
      "repute",
      0.0325
    ],
    [
      "parfait",
      0.0325
    ],
    [
      "extraordinaire",
      0.0325
    ],
    [
      "excellent",
      0.03
    ],
    [
      "glorieux",
      0.03
    ],
    [
      "exquis",
      0.025
    ],
    [
      "marquant",
      0.025
    ],
    [
      "memorable",
      0.025
    ],
    [
      "sacre",
      0.02
    ],
    [
      "retentissant",
      0.02
    ],
    [
      "brillant",
      0.02
    ],
    [
      "fieffe",
      0.015
    ],
    [
      "emerite",
      0.01
    ],
    [
      "insigne",
      0.01
    ],
    [
      "inoubliable",
      0.01
    ],
    [
      "formidable",
      0.01
    ],
    [
      "delicieux",
      0.01
    ],
    [
      "epatant",
      0.0075
    ],
    [
      "succulent",
      0.0075
    ],
    [
      "renomme",
      0.0075
    ],
    [
      "legendaire",
      0.0075
    ],
    [
      "fier",
      0.0075
    ],
    [
      "connu",
      0.0075
    ],
    [
      "agreable",
      0.0075
    ],
    [
      "acheve",
      0.0075
    ],
    [
      "transcendant",
      0.005
    ],
    [
      "proverbial",
      0.005
    ],
    [
      "historique",
      0.005
    ],
    [
      "furieux",
      0.005
    ],
    [
      "franc",
      0.005
    ],
    [
      "fichu",
      0.005
    ],
    [
      "extra",
      0.005
    ],
    [
      "delectable",
      0.005
    ],
    [
      "consomme",
      0.005
    ],
    [
      "savoureux",
      0.0025
    ],
    [
      "satane",
      0.0025
    ],
    [
      "reluisant",
      0.0025
    ],
    [
      "foutu",
      0.0025
    ],
    [
      "chenu",
      0.0025
    ],
    [
      "sinistre",
      0.0025
    ]
  ],
  "bitume": [
    [
      "asphalte",
      0.1675
    ],
    [
      "macadam",
      0.1675
    ],
    [
      "trottoir",
      0.11
    ],
    [
      "revetement",
      0.11
    ],
    [
      "pave",
      0.11
    ],
    [
      "goudron",
      0.11
    ],
    [
      "coaltar",
      0.055
    ],
    [
      "malthe",
      0.055
    ],
    [
      "naphte",
      0.055
    ],
    [
      "elaterite",
      0.055
    ]
  ],
  "rafraichir": [
    [
      "ranimer",
      0.09
    ],
    [
      "reconforter",
      0.09
    ],
    [
      "reparer",
      0.09
    ],
    [
      "restaurer",
      0.0725
    ],
    [
      "retaper",
      0.0725
    ],
    [
      "revivifier",
      0.055
    ],
    [
      "raviver",
      0.055
    ],
    [
      "couper",
      0.055
    ],
    [
      "tailler",
      0.035
    ],
    [
      "renover",
      0.035
    ],
    [
      "refaire",
      0.035
    ],
    [
      "ravigoter",
      0.035
    ],
    [
      "rajeunir",
      0.035
    ],
    [
      "reveiller",
      0.0175
    ],
    [
      "refrigerer",
      0.0175
    ],
    [
      "rogner",
      0.0175
    ],
    [
      "repeindre",
      0.0175
    ],
    [
      "refroidir",
      0.0175
    ],
    [
      "ravaler",
      0.0175
    ],
    [
      "ragaillardir",
      0.0175
    ],
    [
      "radouber",
      0.0175
    ],
    [
      "desalterer",
      0.0175
    ],
    [
      "temperer",
      0.0175
    ]
  ],
  "habite": [
    [
      "loger",
      0.0975
    ],
    [
      "demeurer",
      0.09
    ],
    [
      "resider",
      0.08
    ],
    [
      "sejourner",
      0.06
    ],
    [
      "vivre",
      0.0425
    ],
    [
      "s'etablir",
      0.0425
    ],
    [
      "hanter",
      0.0425
    ],
    [
      "giter",
      0.0425
    ],
    [
      "nicher",
      0.035
    ],
    [
      "s'installer",
      0.035
    ],
    [
      "travailler",
      0.025
    ],
    [
      "rester",
      0.025
    ],
    [
      "obseder",
      0.025
    ],
    [
      "exister",
      0.025
    ],
    [
      "camper",
      0.025
    ],
    [
      "poursuivre",
      0.0175
    ],
    [
      "posseder",
      0.0175
    ],
    [
      "occuper",
      0.0175
    ],
    [
      "frequenter",
      0.0175
    ],
    [
      "crecher",
      0.0175
    ],
    [
      "sieger",
      0.0075
    ],
    [
      "regner",
      0.0075
    ],
    [
      "preoccuper",
      0.0075
    ],
    [
      "percher",
      0.0075
    ],
    [
      "harceler",
      0.0075
    ],
    [
      "coucher",
      0.0075
    ],
    [
      "cabaner",
      0.0075
    ],
    [
      "animer",
      0.0075
    ]
  ],
  "jadis": [
    [
      "autrefois",
      0.265
    ],
    [
      "anciennement",
      0.2
    ],
    [
      "auparavant",
      0.1325
    ],
    [
      "avant",
      0.065
    ],
    [
      "longtemps",
      0.065
    ],
    [
      "naguere",
      0.065
    ],
    [
      "temps",
      0.065
    ]
  ],
  "tarder": [
    [
      "lanterner",
      0.12
    ],
    [
      "trainer",
      0.12
    ],
    [
      "differer",
      0.09
    ],
    [
      "lambiner",
      0.09
    ],
    [
      "reculer",
      0.09
    ],
    [
      "retarder",
      0.09
    ],
    [
      "s'attarder",
      0.09
    ],
    [
      "remettre",
      0.06
    ],
    [
      "demeurer",
      0.06
    ],
    [
      "atermoyer",
      0.06
    ],
    [
      "renvoyer",
      0.03
    ],
    [
      "sejourner",
      0.03
    ],
    [
      "trainasser",
      0.03
    ]
  ],
  "joujoux": [
    [
      "jouet",
      0.4
    ],
    [
      "babiole",
      0.2
    ],
    [
      "biquet",
      0.2
    ],
    [
      "pantin",
      0.2
    ]
  ],
  "dodo": [
    [
      "dronte",
      0.25
    ],
    [
      "lit",
      0.25
    ],
    [
      "sieste",
      0.25
    ],
    [
      "sommeil",
      0.25
    ]
  ],
  "hotte": [
    [
      "panier",
      0.2
    ],
    [
      "bagnole",
      0.0975
    ],
    [
      "benne",
      0.0975
    ],
    [
      "bouille",
      0.0975
    ],
    [
      "caque",
      0.0975
    ],
    [
      "cuveau",
      0.0975
    ],
    [
      "sac",
      0.0975
    ],
    [
      "vendangeoir",
      0.0975
    ],
    [
      "vendangerot",
      0.0975
    ]
  ],
  "distribution": [
    [
      "ordre",
      0.1225
    ],
    [
      "disposition",
      0.08
    ],
    [
      "repartition",
      0.08
    ],
    [
      "classement",
      0.07
    ],
    [
      "arrangement",
      0.04
    ],
    [
      "division",
      0.04
    ],
    [
      "ordonnance",
      0.04
    ],
    [
      "rang",
      0.03
    ],
    [
      "partage",
      0.03
    ],
    [
      "hierarchie",
      0.03
    ],
    [
      "don",
      0.03
    ],
    [
      "agencement",
      0.03
    ],
    [
      "volee",
      0.02
    ],
    [
      "succession",
      0.02
    ],
    [
      "remise",
      0.02
    ],
    [
      "rangement",
      0.02
    ],
    [
      "dispersion",
      0.02
    ],
    [
      "diffusion",
      0.02
    ],
    [
      "correction",
      0.02
    ],
    [
      "alienation",
      0.02
    ],
    [
      "amenagement",
      0.02
    ],
    [
      "attribution",
      0.02
    ],
    [
      "classification",
      0.02
    ],
    [
      "collation",
      0.02
    ],
    [
      "torgnole",
      0.01
    ],
    [
      "raclee",
      0.01
    ],
    [
      "liberalite",
      0.01
    ],
    [
      "largesse",
      0.01
    ],
    [
      "donne",
      0.01
    ],
    [
      "dispense",
      0.01
    ],
    [
      "dispensation",
      0.01
    ],
    [
      "dilapidation",
      0.01
    ],
    [
      "coup",
      0.01
    ],
    [
      "bienfaisance",
      0.01
    ],
    [
      "affiche",
      0.01
    ],
    [
      "economie",
      0.01
    ]
  ],
  "barracuda": [
    [
      "becune",
      1.0
    ]
  ],
  "melodie": [
    [
      "chant",
      0.2225
    ],
    [
      "chanson",
      0.1
    ],
    [
      "poeme",
      0.08
    ],
    [
      "air",
      0.06
    ],
    [
      "harmonie",
      0.06
    ],
    [
      "melopee",
      0.04
    ],
    [
      "musique",
      0.04
    ],
    [
      "complainte",
      0.04
    ],
    [
      "cantilene",
      0.04
    ],
    [
      "romance",
      0.0175
    ],
    [
      "prosodie",
      0.0175
    ],
    [
      "piece",
      0.0175
    ],
    [
      "orchestre",
      0.0175
    ],
    [
      "ligne",
      0.0175
    ],
    [
      "lied",
      0.0175
    ],
    [
      "incantation",
      0.0175
    ],
    [
      "cavatine",
      0.0175
    ],
    [
      "cantate",
      0.0175
    ],
    [
      "cantabile",
      0.0175
    ],
    [
      "cadence",
      0.0175
    ],
    [
      "barcarolle",
      0.0175
    ],
    [
      "ariette",
      0.0175
    ],
    [
      "aria",
      0.0175
    ],
    [
      "accent",
      0.0175
    ],
    [
      "recitatif",
      0.0175
    ]
  ],
  "phare": [
    [
      "feu",
      0.24
    ],
    [
      "lumiere",
      0.16
    ],
    [
      "fanal",
      0.0775
    ],
    [
      "flambeau",
      0.0775
    ],
    [
      "gloire",
      0.0775
    ],
    [
      "lanterne",
      0.0775
    ],
    [
      "semaphore",
      0.0375
    ],
    [
      "projecteur",
      0.0375
    ],
    [
      "illustration",
      0.0375
    ],
    [
      "fleuron",
      0.0375
    ],
    [
      "code",
      0.0375
    ],
    [
      "balise",
      0.0375
    ],
    [
      "visionnaire",
      0.0375
    ]
  ],
  "naufrager": [],
  "croitre": [
    [
      "augmenter",
      0.125
    ],
    [
      "grossir",
      0.1075
    ],
    [
      "grandir",
      0.0825
    ],
    [
      "s'etendre",
      0.0575
    ],
    [
      "s'accroitre",
      0.0475
    ],
    [
      "progresser",
      0.0375
    ],
    [
      "profiter",
      0.0375
    ],
    [
      "pousser",
      0.0325
    ],
    [
      "prosperer",
      0.0325
    ],
    [
      "fructifier",
      0.0275
    ],
    [
      "s'elargir",
      0.0275
    ],
    [
      "developper",
      0.0225
    ],
    [
      "gagner",
      0.0225
    ],
    [
      "multiplier",
      0.0175
    ],
    [
      "monter",
      0.0175
    ],
    [
      "accroitre",
      0.0175
    ],
    [
      "s'amplifier",
      0.0125
    ],
    [
      "s'agrandir",
      0.0125
    ],
    [
      "pulluler",
      0.0125
    ],
    [
      "naitre",
      0.0125
    ],
    [
      "gonfler",
      0.0125
    ],
    [
      "fleurir",
      0.0125
    ],
    [
      "enfler",
      0.0125
    ],
    [
      "venir",
      0.0075
    ],
    [
      "s'elever",
      0.0075
    ],
    [
      "s'intensifier",
      0.0075
    ],
    [
      "s'exciter",
      0.0075
    ],
    [
      "allonger",
      0.0075
    ],
    [
      "s'arrondir",
      0.0025
    ],
    [
      "s'enfler",
      0.0025
    ],
    [
      "vegeter",
      0.0025
    ]
  ],
  "crue": [
    [
      "penser",
      0.115
    ],
    [
      "imaginer",
      0.0725
    ],
    [
      "compter",
      0.0525
    ],
    [
      "estimer",
      0.0525
    ],
    [
      "presumer",
      0.0475
    ],
    [
      "considerer",
      0.0475
    ],
    [
      "juger",
      0.04
    ],
    [
      "supposer",
      0.04
    ],
    [
      "s'attendre",
      0.0325
    ],
    [
      "esperer",
      0.025
    ],
    [
      "accepter",
      0.025
    ],
    [
      "admettre",
      0.02
    ],
    [
      "reputer",
      0.02
    ],
    [
      "soupconner",
      0.02
    ],
    [
      "trouver",
      0.02
    ],
    [
      "ecouter",
      0.0125
    ],
    [
      "s'imaginer",
      0.0125
    ],
    [
      "reconnaitre",
      0.0125
    ],
    [
      "avaler",
      0.0125
    ],
    [
      "attendre",
      0.0125
    ],
    [
      "apprecier",
      0.0125
    ],
    [
      "prejuger",
      0.005
    ],
    [
      "sembler",
      0.005
    ],
    [
      "tromper",
      0.005
    ],
    [
      "marcher",
      0.005
    ],
    [
      "jurer",
      0.005
    ],
    [
      "abuser",
      0.005
    ],
    [
      "adherer",
      0.005
    ],
    [
      "cuider",
      0.005
    ],
    [
      "donner",
      0.005
    ],
    [
      "faillir",
      0.005
    ],
    [
      "gober",
      0.005
    ]
  ],
  "vins": [
    [
      "provenir",
      0.055
    ],
    [
      "sortir",
      0.055
    ],
    [
      "arriver",
      0.0525
    ],
    [
      "decouler",
      0.04
    ],
    [
      "proceder",
      0.04
    ],
    [
      "tomber",
      0.04
    ],
    [
      "naitre",
      0.035
    ],
    [
      "surgir",
      0.0325
    ],
    [
      "suivre",
      0.0325
    ],
    [
      "resulter",
      0.0275
    ],
    [
      "apparaitre",
      0.025
    ],
    [
      "avancer",
      0.025
    ],
    [
      "marcher",
      0.025
    ],
    [
      "emaner",
      0.02
    ],
    [
      "passer",
      0.02
    ],
    [
      "partir",
      0.02
    ],
    [
      "descendre",
      0.02
    ],
    [
      "approcher",
      0.02
    ],
    [
      "survenir",
      0.0175
    ],
    [
      "pousser",
      0.0175
    ],
    [
      "aborder",
      0.0175
    ],
    [
      "reussir",
      0.0125
    ],
    [
      "parvenir",
      0.0125
    ],
    [
      "deriver",
      0.0125
    ],
    [
      "tenir",
      0.01
    ],
    [
      "s'avancer",
      0.01
    ],
    [
      "s'approcher",
      0.01
    ],
    [
      "s'amener",
      0.01
    ],
    [
      "s'abouler",
      0.01
    ],
    [
      "remonter",
      0.01
    ],
    [
      "pointer",
      0.01
    ],
    [
      "entrer",
      0.01
    ],
    [
      "dependre",
      0.01
    ],
    [
      "s'offrir",
      0.005
    ],
    [
      "rappliquer",
      0.005
    ],
    [
      "radiner",
      0.005
    ],
    [
      "grandir",
      0.005
    ],
    [
      "debarquer",
      0.005
    ],
    [
      "croitre",
      0.005
    ],
    [
      "aboutir",
      0.005
    ],
    [
      "succeder",
      0.0025
    ],
    [
      "echoir",
      0.0025
    ],
    [
      "s'aviser",
      0.0025
    ],
    [
      "intervenir",
      0.0025
    ],
    [
      "dater",
      0.0025
    ]
  ],
  "arrete": [
    [
      "retenir",
      0.0525
    ],
    [
      "fixer",
      0.0425
    ],
    [
      "endiguer",
      0.0325
    ],
    [
      "bloquer",
      0.03
    ],
    [
      "etouffer",
      0.0275
    ],
    [
      "attacher",
      0.0275
    ],
    [
      "freiner",
      0.025
    ],
    [
      "prendre",
      0.025
    ],
    [
      "immobiliser",
      0.025
    ],
    [
      "couper",
      0.025
    ],
    [
      "contenir",
      0.0225
    ],
    [
      "interrompre",
      0.0225
    ],
    [
      "enrayer",
      0.02
    ],
    [
      "paralyser",
      0.02
    ],
    [
      "tenir",
      0.0175
    ],
    [
      "moderer",
      0.0175
    ],
    [
      "empecher",
      0.015
    ],
    [
      "finir",
      0.015
    ],
    [
      "stopper",
      0.015
    ],
    [
      "suspendre",
      0.015
    ],
    [
      "trancher",
      0.0125
    ],
    [
      "terminer",
      0.0125
    ],
    [
      "saisir",
      0.0125
    ],
    [
      "barrer",
      0.0125
    ],
    [
      "supprimer",
      0.0125
    ],
    [
      "reprimer",
      0.0125
    ],
    [
      "regler",
      0.0125
    ],
    [
      "maintenir",
      0.0125
    ],
    [
      "fermer",
      0.0125
    ],
    [
      "decider",
      0.0125
    ],
    [
      "accrocher",
      0.01
    ],
    [
      "arrimer",
      0.01
    ],
    [
      "assujettir",
      0.01
    ],
    [
      "briser",
      0.01
    ],
    [
      "rompre",
      0.0075
    ],
    [
      "refrener",
      0.0075
    ],
    [
      "conclure",
      0.0075
    ],
    [
      "calmer",
      0.0075
    ],
    [
      "assurer",
      0.0075
    ],
    [
      "temperer",
      0.0075
    ],
    [
      "ralentir",
      0.0075
    ],
    [
      "juguler",
      0.0075
    ],
    [
      "entraver",
      0.0075
    ],
    [
      "borner",
      0.0075
    ],
    [
      "traiter",
      0.005
    ],
    [
      "resoudre",
      0.005
    ],
    [
      "limiter",
      0.005
    ],
    [
      "cesser",
      0.005
    ],
    [
      "captiver",
      0.005
    ],
    [
      "s'emparer",
      0.005
    ],
    [
      "emprisonner",
      0.005
    ],
    [
      "determiner",
      0.005
    ],
    [
      "dissoudre",
      0.005
    ],
    [
      "clore",
      0.005
    ],
    [
      "caler",
      0.005
    ],
    [
      "statuer",
      0.0025
    ],
    [
      "soumettre",
      0.0025
    ],
    [
      "s'arreter",
      0.0025
    ],
    [
      "piquer",
      0.0025
    ],
    [
      "intercepter",
      0.0025
    ],
    [
      "engager",
      0.0025
    ],
    [
      "circonscrire",
      0.0025
    ],
    [
      "capturer",
      0.0025
    ],
    [
      "ramasser",
      0.0025
    ],
    [
      "retarder",
      0.0025
    ],
    [
      "reserver",
      0.0025
    ],
    [
      "s'assurer",
      0.0025
    ],
    [
      "mater",
      0.0025
    ],
    [
      "geler",
      0.0025
    ],
    [
      "attirer",
      0.0025
    ],
    [
      "barricader",
      0.0025
    ],
    [
      "consolider",
      0.0025
    ],
    [
      "decourager",
      0.0025
    ],
    [
      "emballer",
      0.0025
    ],
    [
      "empoigner",
      0.0
    ],
    [
      "mouiller",
      0.0
    ],
    [
      "prescrire",
      0.0
    ],
    [
      "quitter",
      0.0
    ],
    [
      "vouloir",
      0.0
    ],
    [
      "ecluser",
      0.0
    ],
    [
      "etablir",
      0.0
    ],
    [
      "etancher",
      0.0
    ],
    [
      "embarrasser",
      0.0
    ],
    [
      "embarquer",
      0.0
    ],
    [
      "aborder",
      0.0
    ],
    [
      "ancrer",
      0.0
    ],
    [
      "cacher",
      0.0
    ],
    [
      "cloturer",
      0.0
    ],
    [
      "coffrer",
      0.0
    ],
    [
      "convenir",
      0.0
    ],
    [
      "cueillir",
      0.0
    ],
    [
      "deposer",
      0.0
    ],
    [
      "poisser",
      0.0
    ],
    [
      "prononcer",
      0.0
    ],
    [
      "rebuter",
      0.0
    ],
    [
      "souhaiter",
      0.0
    ],
    [
      "tarir",
      0.0
    ],
    [
      "temporiser",
      0.0
    ],
    [
      "louer",
      0.0
    ],
    [
      "incarcerer",
      0.0
    ],
    [
      "accoster",
      0.0
    ],
    [
      "achopper",
      0.0
    ],
    [
      "ankyloser",
      0.0
    ],
    [
      "apprehender",
      0.0
    ],
    [
      "assoupir",
      0.0
    ],
    [
      "buter",
      0.0
    ],
    [
      "debrancher",
      0.0
    ],
    [
      "torpiller",
      0.0
    ]
  ],
  "cadran": [
    [
      "gnomon",
      0.25
    ],
    [
      "horloge",
      0.25
    ],
    [
      "manometre",
      0.25
    ],
    [
      "solarium",
      0.25
    ]
  ],
  "balbutiement": [
    [
      "begaiement",
      0.135
    ],
    [
      "bredouillement",
      0.1075
    ],
    [
      "commencement",
      0.1075
    ],
    [
      "debut",
      0.1075
    ],
    [
      "bafouillage",
      0.08
    ],
    [
      "seuil",
      0.0525
    ],
    [
      "bredouillage",
      0.0525
    ],
    [
      "berceau",
      0.0525
    ],
    [
      "anonnement",
      0.025
    ],
    [
      "tatonnement",
      0.025
    ],
    [
      "prononciation",
      0.025
    ],
    [
      "murmure",
      0.025
    ],
    [
      "enfance",
      0.025
    ],
    [
      "bredouillis",
      0.025
    ],
    [
      "baragouin",
      0.025
    ],
    [
      "babil",
      0.025
    ],
    [
      "aurore",
      0.025
    ],
    [
      "aube",
      0.025
    ],
    [
      "elements",
      0.025
    ]
  ],
  "desormais": [
    [
      "dorenavant",
      0.165
    ],
    [
      "maintenant",
      0.165
    ]
  ],
  "concerner": [
    [
      "interesser",
      0.12
    ],
    [
      "regarder",
      0.12
    ],
    [
      "toucher",
      0.1
    ],
    [
      "s'adresser",
      0.08
    ],
    [
      "viser",
      0.04
    ],
    [
      "s'appliquer",
      0.04
    ],
    [
      "appartenir",
      0.04
    ],
    [
      "ressortir",
      0.0175
    ],
    [
      "impliquer",
      0.0175
    ],
    [
      "dependre",
      0.0175
    ],
    [
      "aller",
      0.0175
    ]
  ],
  "quinquet": [
    [
      "lumignon",
      0.285
    ],
    [
      "fumignon",
      0.1425
    ],
    [
      "godet",
      0.1425
    ],
    [
      "lampe",
      0.1425
    ],
    [
      "oeil",
      0.1425
    ],
    [
      "veilleuse",
      0.1425
    ]
  ],
  "taverne": [
    [
      "cabaret",
      0.275
    ],
    [
      "cafe",
      0.15
    ],
    [
      "restaurant",
      0.125
    ],
    [
      "beuglant",
      0.0725
    ],
    [
      "gargote",
      0.0725
    ],
    [
      "buvette",
      0.0475
    ],
    [
      "brasserie",
      0.0475
    ],
    [
      "bousin",
      0.0475
    ],
    [
      "bar",
      0.0475
    ],
    [
      "auberge",
      0.0475
    ],
    [
      "guinguette",
      0.0475
    ]
  ],
  "deconvenue": [
    [
      "deception",
      0.225
    ],
    [
      "deboire",
      0.1275
    ],
    [
      "desappointement",
      0.1275
    ],
    [
      "desillusion",
      0.095
    ],
    [
      "echec",
      0.095
    ],
    [
      "mesaventure",
      0.0625
    ],
    [
      "malheur",
      0.0625
    ],
    [
      "douche",
      0.03
    ],
    [
      "depit",
      0.03
    ],
    [
      "desenchantement",
      0.03
    ],
    [
      "humiliation",
      0.03
    ],
    [
      "insucces",
      0.03
    ],
    [
      "mecompte",
      0.03
    ]
  ],
  "brisee": [
    [
      "detruire",
      0.0725
    ],
    [
      "aneantir",
      0.0575
    ],
    [
      "abattre",
      0.055
    ],
    [
      "casser",
      0.045
    ],
    [
      "ecraser",
      0.0425
    ],
    [
      "rompre",
      0.04
    ],
    [
      "broyer",
      0.04
    ],
    [
      "fatiguer",
      0.04
    ],
    [
      "demolir",
      0.035
    ],
    [
      "epuiser",
      0.0275
    ],
    [
      "ruiner",
      0.0275
    ],
    [
      "ereinter",
      0.025
    ],
    [
      "accabler",
      0.02
    ],
    [
      "pulveriser",
      0.02
    ],
    [
      "affaiblir",
      0.0175
    ],
    [
      "battre",
      0.0175
    ],
    [
      "supprimer",
      0.0175
    ],
    [
      "extenuer",
      0.015
    ],
    [
      "esquinter",
      0.015
    ],
    [
      "couper",
      0.015
    ],
    [
      "degrader",
      0.015
    ],
    [
      "arreter",
      0.0125
    ],
    [
      "enfoncer",
      0.01
    ],
    [
      "dechirer",
      0.01
    ],
    [
      "etouffer",
      0.01
    ],
    [
      "triturer",
      0.01
    ],
    [
      "renverser",
      0.01
    ],
    [
      "forcer",
      0.01
    ],
    [
      "deteriorer",
      0.01
    ],
    [
      "deprimer",
      0.01
    ],
    [
      "demanteler",
      0.01
    ],
    [
      "decourager",
      0.01
    ],
    [
      "dissoudre",
      0.0075
    ],
    [
      "trancher",
      0.0075
    ],
    [
      "reduire",
      0.0075
    ],
    [
      "foudroyer",
      0.0075
    ],
    [
      "aplatir",
      0.0075
    ],
    [
      "annihiler",
      0.0075
    ],
    [
      "surmener",
      0.005
    ],
    [
      "moudre",
      0.005
    ],
    [
      "harasser",
      0.005
    ],
    [
      "hacher",
      0.005
    ],
    [
      "fracasser",
      0.005
    ],
    [
      "endommager",
      0.005
    ],
    [
      "demantibuler",
      0.005
    ],
    [
      "defoncer",
      0.005
    ],
    [
      "disloquer",
      0.005
    ],
    [
      "bouleverser",
      0.005
    ],
    [
      "bigorner",
      0.005
    ],
    [
      "lasser",
      0.0025
    ],
    [
      "interrompre",
      0.0025
    ],
    [
      "infirmer",
      0.0025
    ],
    [
      "fendre",
      0.0025
    ],
    [
      "dompter",
      0.0025
    ],
    [
      "concasser",
      0.0025
    ],
    [
      "affliger",
      0.0025
    ],
    [
      "emouvoir",
      0.0025
    ],
    [
      "ebrecher",
      0.0025
    ],
    [
      "torpiller",
      0.0025
    ],
    [
      "mutiler",
      0.0025
    ],
    [
      "fracturer",
      0.0025
    ],
    [
      "effondrer",
      0.0025
    ],
    [
      "demoraliser",
      0.0025
    ],
    [
      "harceler",
      0.0
    ],
    [
      "enrayer",
      0.0
    ],
    [
      "enfreindre",
      0.0
    ],
    [
      "depasser",
      0.0
    ],
    [
      "demancher",
      0.0
    ],
    [
      "desceller",
      0.0
    ],
    [
      "comminuer",
      0.0
    ]
  ],
  "guitariste": [
    [
      "bassiste",
      1.0
    ]
  ],
  "voici": [
    [
      "ci",
      0.5
    ],
    [
      "voila",
      0.5
    ]
  ],
  "rade": [
    [
      "abri",
      0.25
    ],
    [
      "zinc",
      0.165
    ],
    [
      "baie",
      0.0825
    ],
    [
      "bassin",
      0.0825
    ],
    [
      "bistrot",
      0.0825
    ],
    [
      "comptoir",
      0.0825
    ],
    [
      "mouillage",
      0.0825
    ],
    [
      "port",
      0.0825
    ],
    [
      "radeau",
      0.0825
    ]
  ],
  "impotent": [
    [
      "infirme",
      0.145
    ],
    [
      "faible",
      0.1175
    ],
    [
      "invalide",
      0.0875
    ],
    [
      "paralyse",
      0.0875
    ],
    [
      "paralytique",
      0.0875
    ],
    [
      "perclus",
      0.0875
    ],
    [
      "podagre",
      0.0575
    ],
    [
      "inerte",
      0.0575
    ],
    [
      "impuissant",
      0.0575
    ],
    [
      "estropie",
      0.0575
    ],
    [
      "caduc",
      0.0575
    ],
    [
      "goutteux",
      0.0275
    ],
    [
      "senile",
      0.0275
    ],
    [
      "eclope",
      0.0275
    ]
  ],
  "ventripotent": [
    [
      "gros",
      0.2075
    ],
    [
      "obese",
      0.125
    ],
    [
      "rebondi",
      0.125
    ],
    [
      "replet",
      0.125
    ],
    [
      "pansu",
      0.0825
    ],
    [
      "ventru",
      0.0825
    ],
    [
      "gidouillard",
      0.04
    ],
    [
      "gidouillant",
      0.04
    ],
    [
      "dodu",
      0.04
    ],
    [
      "bouffi",
      0.04
    ],
    [
      "bedonnant",
      0.04
    ],
    [
      "rond",
      0.04
    ]
  ],
  "absurdite": [
    [
      "extravagance",
      0.1125
    ],
    [
      "folie",
      0.1125
    ],
    [
      "aberration",
      0.085
    ],
    [
      "betise",
      0.07
    ],
    [
      "insanite",
      0.055
    ],
    [
      "stupidite",
      0.04
    ],
    [
      "sottise",
      0.04
    ],
    [
      "inconsequence",
      0.04
    ],
    [
      "incoherence",
      0.04
    ],
    [
      "impertinence",
      0.04
    ],
    [
      "contresens",
      0.04
    ],
    [
      "ineptie",
      0.0275
    ],
    [
      "illogisme",
      0.0275
    ],
    [
      "deraison",
      0.0275
    ],
    [
      "contradiction",
      0.0275
    ],
    [
      "absurde",
      0.0275
    ],
    [
      "saugrenuite",
      0.0125
    ],
    [
      "niaiserie",
      0.0125
    ],
    [
      "moquerie",
      0.0125
    ],
    [
      "loufoquerie",
      0.0125
    ],
    [
      "irrationalite",
      0.0125
    ],
    [
      "incongruite",
      0.0125
    ],
    [
      "imagination",
      0.0125
    ],
    [
      "enormite",
      0.0125
    ]
  ],
  "notoire": [
    [
      "evident",
      0.155
    ],
    [
      "certain",
      0.1075
    ],
    [
      "manifeste",
      0.1
    ],
    [
      "officiel",
      0.07
    ],
    [
      "incontestable",
      0.06
    ],
    [
      "patent",
      0.0525
    ],
    [
      "avere",
      0.0525
    ],
    [
      "public",
      0.045
    ],
    [
      "authentique",
      0.0375
    ],
    [
      "eclatant",
      0.03
    ],
    [
      "ouvert",
      0.03
    ],
    [
      "flagrant",
      0.03
    ],
    [
      "connu",
      0.03
    ],
    [
      "clair",
      0.03
    ],
    [
      "celebre",
      0.0225
    ],
    [
      "indeniable",
      0.0225
    ],
    [
      "reconnu",
      0.0225
    ],
    [
      "significatif",
      0.015
    ],
    [
      "retentissant",
      0.015
    ],
    [
      "irrefragable",
      0.015
    ],
    [
      "illustre",
      0.015
    ],
    [
      "declare",
      0.015
    ],
    [
      "imposant",
      0.005
    ]
  ],
  "debutant": [
    [
      "novice",
      0.2575
    ],
    [
      "neophyte",
      0.11
    ],
    [
      "nouveau",
      0.11
    ],
    [
      "commencant",
      0.11
    ],
    [
      "bleu",
      0.11
    ],
    [
      "apprenti",
      0.11
    ],
    [
      "ecolier",
      0.0725
    ],
    [
      "bizut",
      0.035
    ],
    [
      "initial",
      0.035
    ],
    [
      "neuf",
      0.035
    ]
  ],
  "becoter": [
    [
      "baiser",
      0.3325
    ],
    [
      "embrasser",
      0.25
    ],
    [
      "baisoter",
      0.0825
    ],
    [
      "becquer",
      0.0825
    ],
    [
      "biser",
      0.0825
    ],
    [
      "caresser",
      0.0825
    ]
  ],
  "sympathique": [
    [
      "gracieux",
      0.1425
    ],
    [
      "agreable",
      0.105
    ],
    [
      "aimable",
      0.095
    ],
    [
      "engageant",
      0.065
    ],
    [
      "cordial",
      0.065
    ],
    [
      "charmant",
      0.065
    ],
    [
      "accueillant",
      0.065
    ],
    [
      "bienveillant",
      0.0475
    ],
    [
      "amical",
      0.0375
    ],
    [
      "amene",
      0.0375
    ],
    [
      "avenant",
      0.0375
    ],
    [
      "plaisant",
      0.0275
    ],
    [
      "gentil",
      0.0275
    ],
    [
      "exquis",
      0.0275
    ],
    [
      "chaleureux",
      0.0275
    ],
    [
      "attirant",
      0.0175
    ],
    [
      "convivial",
      0.0175
    ],
    [
      "favorable",
      0.0175
    ],
    [
      "parasympathique",
      0.0075
    ],
    [
      "orthosympathique",
      0.0075
    ],
    [
      "hospitalier",
      0.0075
    ],
    [
      "fraternel",
      0.0075
    ],
    [
      "sympa",
      0.0075
    ]
  ],
  "revetir": [
    [
      "couvrir",
      0.0625
    ],
    [
      "deguiser",
      0.0625
    ],
    [
      "habiller",
      0.0625
    ],
    [
      "orner",
      0.0525
    ],
    [
      "tapisser",
      0.0425
    ],
    [
      "recouvrir",
      0.0425
    ],
    [
      "parer",
      0.0425
    ],
    [
      "masquer",
      0.0425
    ],
    [
      "envelopper",
      0.0425
    ],
    [
      "farder",
      0.035
    ],
    [
      "vetir",
      0.025
    ],
    [
      "traduire",
      0.025
    ],
    [
      "semer",
      0.025
    ],
    [
      "passer",
      0.025
    ],
    [
      "mettre",
      0.025
    ],
    [
      "garnir",
      0.025
    ],
    [
      "enduire",
      0.025
    ],
    [
      "decorer",
      0.025
    ],
    [
      "ajuster",
      0.025
    ],
    [
      "affecter",
      0.025
    ],
    [
      "travestir",
      0.0175
    ],
    [
      "refleter",
      0.0175
    ],
    [
      "pourvoir",
      0.0175
    ],
    [
      "porter",
      0.0175
    ],
    [
      "investir",
      0.0175
    ],
    [
      "endosser",
      0.0175
    ],
    [
      "colorer",
      0.0175
    ],
    [
      "rhabiller",
      0.0075
    ],
    [
      "rendre",
      0.0075
    ],
    [
      "paver",
      0.0075
    ],
    [
      "maconner",
      0.0075
    ],
    [
      "maquiller",
      0.0075
    ],
    [
      "incarner",
      0.0075
    ],
    [
      "gainer",
      0.0075
    ],
    [
      "enfiler",
      0.0075
    ],
    [
      "emprunter",
      0.0075
    ],
    [
      "ceindre",
      0.0075
    ],
    [
      "bitumer",
      0.0075
    ]
  ],
  "coudre": [
    [
      "coudrier",
      0.3325
    ],
    [
      "linger",
      0.3325
    ],
    [
      "noisetier",
      0.3325
    ]
  ],
  "malappris": [
    [
      "impoli",
      0.1875
    ],
    [
      "grossier",
      0.14
    ],
    [
      "incorrect",
      0.125
    ],
    [
      "inconvenant",
      0.0925
    ],
    [
      "pignouf",
      0.045
    ],
    [
      "mufle",
      0.045
    ],
    [
      "malotru",
      0.045
    ],
    [
      "irreverencieux",
      0.045
    ],
    [
      "discourtois",
      0.03
    ],
    [
      "effronte",
      0.03
    ],
    [
      "goujat",
      0.03
    ],
    [
      "impertinent",
      0.03
    ],
    [
      "malhonnete",
      0.03
    ],
    [
      "rustre",
      0.03
    ]
  ],
  "hardiment": [
    [
      "courageusement",
      0.17
    ],
    [
      "resolument",
      0.1425
    ],
    [
      "bravement",
      0.085
    ],
    [
      "gaillardement",
      0.085
    ],
    [
      "energiquement",
      0.055
    ],
    [
      "vaillamment",
      0.055
    ],
    [
      "intrepidement",
      0.055
    ],
    [
      "franchement",
      0.055
    ],
    [
      "cranement",
      0.055
    ],
    [
      "impudemment",
      0.0275
    ],
    [
      "hautement",
      0.0275
    ],
    [
      "effrontement",
      0.0275
    ],
    [
      "crument",
      0.0275
    ],
    [
      "carrement",
      0.0275
    ],
    [
      "audacieusement",
      0.0275
    ],
    [
      "vigoureusement",
      0.0275
    ]
  ],
  "venimeux": [
    [
      "mauvais",
      0.1825
    ],
    [
      "mechant",
      0.16
    ],
    [
      "fielleux",
      0.09
    ],
    [
      "malveillant",
      0.09
    ],
    [
      "perfide",
      0.0675
    ],
    [
      "virulent",
      0.0675
    ],
    [
      "malfaisant",
      0.0425
    ],
    [
      "haineux",
      0.0425
    ],
    [
      "envenime",
      0.0425
    ],
    [
      "empoisonne",
      0.0425
    ],
    [
      "corrosif",
      0.0425
    ],
    [
      "aigre",
      0.02
    ],
    [
      "calomnieux",
      0.02
    ],
    [
      "malintentionne",
      0.02
    ],
    [
      "medisant",
      0.02
    ],
    [
      "veneneux",
      0.02
    ]
  ],
  "emu": [
    [
      "bouleverser",
      0.0975
    ],
    [
      "troubler",
      0.0825
    ],
    [
      "toucher",
      0.0725
    ],
    [
      "ebranler",
      0.0625
    ],
    [
      "remuer",
      0.0625
    ],
    [
      "secouer",
      0.0525
    ],
    [
      "impressionner",
      0.05
    ],
    [
      "agiter",
      0.0425
    ],
    [
      "frapper",
      0.04
    ],
    [
      "saisir",
      0.035
    ],
    [
      "atteindre",
      0.03
    ],
    [
      "exciter",
      0.0275
    ],
    [
      "retourner",
      0.02
    ],
    [
      "piquer",
      0.02
    ],
    [
      "enflammer",
      0.0175
    ],
    [
      "revolutionner",
      0.015
    ],
    [
      "blesser",
      0.015
    ],
    [
      "affliger",
      0.015
    ],
    [
      "affecter",
      0.015
    ],
    [
      "affoler",
      0.0125
    ],
    [
      "empoigner",
      0.0125
    ],
    [
      "soulever",
      0.0125
    ],
    [
      "emotionner",
      0.01
    ],
    [
      "interesser",
      0.01
    ],
    [
      "inquieter",
      0.01
    ],
    [
      "attrister",
      0.01
    ],
    [
      "attendrir",
      0.01
    ],
    [
      "deranger",
      0.0075
    ],
    [
      "dechirer",
      0.0075
    ],
    [
      "chavirer",
      0.0075
    ],
    [
      "captiver",
      0.0075
    ],
    [
      "apitoyer",
      0.0075
    ],
    [
      "surexciter",
      0.005
    ],
    [
      "penetrer",
      0.005
    ],
    [
      "mouvoir",
      0.005
    ],
    [
      "intimider",
      0.005
    ],
    [
      "froisser",
      0.005
    ],
    [
      "flechir",
      0.005
    ],
    [
      "exalter",
      0.005
    ],
    [
      "chatouiller",
      0.005
    ],
    [
      "briser",
      0.005
    ],
    [
      "alarmer",
      0.005
    ],
    [
      "provoquer",
      0.0
    ],
    [
      "parler",
      0.0
    ],
    [
      "deregler",
      0.0
    ],
    [
      "consterner",
      0.0
    ],
    [
      "suffoquer",
      0.0
    ]
  ],
  "emouvoir": [
    [
      "bouleverser",
      0.0975
    ],
    [
      "troubler",
      0.0825
    ],
    [
      "toucher",
      0.0725
    ],
    [
      "ebranler",
      0.0625
    ],
    [
      "remuer",
      0.0625
    ],
    [
      "secouer",
      0.0525
    ],
    [
      "impressionner",
      0.05
    ],
    [
      "agiter",
      0.0425
    ],
    [
      "frapper",
      0.04
    ],
    [
      "saisir",
      0.035
    ],
    [
      "atteindre",
      0.03
    ],
    [
      "exciter",
      0.0275
    ],
    [
      "retourner",
      0.02
    ],
    [
      "piquer",
      0.02
    ],
    [
      "enflammer",
      0.0175
    ],
    [
      "revolutionner",
      0.015
    ],
    [
      "blesser",
      0.015
    ],
    [
      "affliger",
      0.015
    ],
    [
      "affecter",
      0.015
    ],
    [
      "affoler",
      0.0125
    ],
    [
      "empoigner",
      0.0125
    ],
    [
      "soulever",
      0.0125
    ],
    [
      "emotionner",
      0.01
    ],
    [
      "interesser",
      0.01
    ],
    [
      "inquieter",
      0.01
    ],
    [
      "attrister",
      0.01
    ],
    [
      "attendrir",
      0.01
    ],
    [
      "deranger",
      0.0075
    ],
    [
      "dechirer",
      0.0075
    ],
    [
      "chavirer",
      0.0075
    ],
    [
      "captiver",
      0.0075
    ],
    [
      "apitoyer",
      0.0075
    ],
    [
      "surexciter",
      0.005
    ],
    [
      "penetrer",
      0.005
    ],
    [
      "mouvoir",
      0.005
    ],
    [
      "intimider",
      0.005
    ],
    [
      "froisser",
      0.005
    ],
    [
      "flechir",
      0.005
    ],
    [
      "exalter",
      0.005
    ],
    [
      "chatouiller",
      0.005
    ],
    [
      "briser",
      0.005
    ],
    [
      "alarmer",
      0.005
    ],
    [
      "provoquer",
      0.0
    ],
    [
      "parler",
      0.0
    ],
    [
      "deregler",
      0.0
    ],
    [
      "consterner",
      0.0
    ],
    [
      "suffoquer",
      0.0
    ]
  ],
  "chas": [
    [
      "oeil",
      1.0
    ]
  ],
  "paillote": [
    [
      "cabane",
      0.3325
    ],
    [
      "case",
      0.3325
    ],
    [
      "hutte",
      0.3325
    ]
  ],
  "bigo": [],
  "glamour": [
    [
      "charme",
      0.5
    ],
    [
      "seduction",
      0.5
    ]
  ],
  "studio": [
    [
      "appartement",
      0.1675
    ],
    [
      "chambre",
      0.1675
    ],
    [
      "garconniere",
      0.11
    ],
    [
      "logement",
      0.11
    ],
    [
      "studette",
      0.055
    ],
    [
      "meuble",
      0.055
    ],
    [
      "cabinet",
      0.055
    ],
    [
      "bonbonniere",
      0.055
    ],
    [
      "atelier",
      0.055
    ],
    [
      "theatre",
      0.055
    ]
  ],
  "insolite": [
    [
      "bizarre",
      0.1175
    ],
    [
      "singulier",
      0.1025
    ],
    [
      "extraordinaire",
      0.0975
    ],
    [
      "inusite",
      0.0725
    ],
    [
      "etrange",
      0.0725
    ],
    [
      "original",
      0.0625
    ],
    [
      "etonnant",
      0.0575
    ],
    [
      "inhabituel",
      0.0475
    ],
    [
      "surprenant",
      0.0375
    ],
    [
      "anormal",
      0.0325
    ],
    [
      "sensationnel",
      0.0275
    ],
    [
      "rare",
      0.0275
    ],
    [
      "inaccoutume",
      0.0275
    ],
    [
      "extravagant",
      0.0275
    ],
    [
      "abracadabrant",
      0.0225
    ],
    [
      "curieux",
      0.0225
    ],
    [
      "nouveau",
      0.0225
    ],
    [
      "baroque",
      0.0175
    ],
    [
      "drole",
      0.0175
    ],
    [
      "irregulier",
      0.0125
    ],
    [
      "bizarroide",
      0.0075
    ],
    [
      "excentrique",
      0.0075
    ],
    [
      "saugrenu",
      0.0075
    ],
    [
      "buissonnier",
      0.0025
    ],
    [
      "deroutant",
      0.0025
    ],
    [
      "incoherent",
      0.0025
    ],
    [
      "pittoresque",
      0.0025
    ]
  ],
  "mecanique": [
    [
      "appareil",
      0.1475
    ],
    [
      "automatique",
      0.11
    ],
    [
      "machine",
      0.11
    ],
    [
      "machinal",
      0.0725
    ],
    [
      "involontaire",
      0.0725
    ],
    [
      "instinctif",
      0.0725
    ],
    [
      "physique",
      0.035
    ],
    [
      "outil",
      0.035
    ],
    [
      "metier",
      0.035
    ],
    [
      "moteur",
      0.035
    ],
    [
      "mathematique",
      0.035
    ],
    [
      "irreflechi",
      0.035
    ],
    [
      "industriel",
      0.035
    ],
    [
      "inconscient",
      0.035
    ],
    [
      "dispositif",
      0.035
    ],
    [
      "balistique",
      0.035
    ],
    [
      "reflexe",
      0.035
    ]
  ],
  "rythmique": [
    [
      "alternatif",
      0.1
    ],
    [
      "scansion",
      0.1
    ],
    [
      "rythme",
      0.1
    ],
    [
      "prosodie",
      0.1
    ],
    [
      "metrique",
      0.1
    ],
    [
      "mesure",
      0.1
    ],
    [
      "gymnique",
      0.1
    ],
    [
      "danse",
      0.1
    ],
    [
      "choregraphie",
      0.1
    ],
    [
      "versification",
      0.1
    ]
  ],
  "entretuer": [],
  "rajouter": [
    [
      "ajouter",
      0.23
    ],
    [
      "exagerer",
      0.1525
    ],
    [
      "remettre",
      0.1525
    ],
    [
      "rencherir",
      0.1525
    ],
    [
      "adjoindre",
      0.075
    ],
    [
      "completer",
      0.075
    ],
    [
      "encherir",
      0.075
    ],
    [
      "mettre",
      0.075
    ]
  ],
  "bouclier": [
    [
      "protection",
      0.1875
    ],
    [
      "cuirasse",
      0.0925
    ],
    [
      "rempart",
      0.0925
    ],
    [
      "sauvegarde",
      0.0775
    ],
    [
      "defense",
      0.0625
    ],
    [
      "egide",
      0.045
    ],
    [
      "carapace",
      0.045
    ],
    [
      "armure",
      0.045
    ],
    [
      "abri",
      0.045
    ],
    [
      "rondelle",
      0.03
    ],
    [
      "blindage",
      0.03
    ],
    [
      "arme",
      0.03
    ],
    [
      "tortue",
      0.015
    ],
    [
      "targe",
      0.015
    ],
    [
      "rondache",
      0.015
    ],
    [
      "pelte",
      0.015
    ],
    [
      "pavois",
      0.015
    ],
    [
      "paravent",
      0.015
    ],
    [
      "palladium",
      0.015
    ],
    [
      "isolant",
      0.015
    ],
    [
      "broquel",
      0.015
    ],
    [
      "bastion",
      0.015
    ],
    [
      "appui",
      0.015
    ],
    [
      "ecu",
      0.015
    ]
  ],
  "enchantement": [
    [
      "charme",
      0.1375
    ],
    [
      "fascination",
      0.0875
    ],
    [
      "magie",
      0.0625
    ],
    [
      "ravissement",
      0.0625
    ],
    [
      "sorcellerie",
      0.05
    ],
    [
      "envoutement",
      0.05
    ],
    [
      "ensorcellement",
      0.05
    ],
    [
      "sortilege",
      0.035
    ],
    [
      "prestige",
      0.035
    ],
    [
      "joie",
      0.035
    ],
    [
      "ivresse",
      0.035
    ],
    [
      "delice",
      0.035
    ],
    [
      "bonheur",
      0.035
    ],
    [
      "emerveillement",
      0.025
    ],
    [
      "eblouissement",
      0.025
    ],
    [
      "malefice",
      0.025
    ],
    [
      "griserie",
      0.025
    ],
    [
      "enivrement",
      0.025
    ],
    [
      "attrait",
      0.025
    ],
    [
      "merveille",
      0.01
    ],
    [
      "incantation",
      0.01
    ],
    [
      "illusion",
      0.01
    ],
    [
      "hypnose",
      0.01
    ],
    [
      "fete",
      0.01
    ],
    [
      "felicite",
      0.01
    ],
    [
      "ferveur",
      0.01
    ],
    [
      "bercement",
      0.01
    ],
    [
      "sort",
      0.01
    ]
  ],
  "secondaire": [
    [
      "accessoire",
      0.2675
    ],
    [
      "mineur",
      0.165
    ],
    [
      "subsidiaire",
      0.065
    ],
    [
      "subalterne",
      0.065
    ],
    [
      "second",
      0.065
    ],
    [
      "marginal",
      0.065
    ],
    [
      "insignifiant",
      0.065
    ],
    [
      "adventice",
      0.065
    ],
    [
      "concomitant",
      0.0325
    ],
    [
      "incident",
      0.0325
    ],
    [
      "inferieur",
      0.0325
    ],
    [
      "negligeable",
      0.0325
    ],
    [
      "episodique",
      0.0325
    ]
  ],
  "auteur": [
    [
      "ecrivain",
      0.105
    ],
    [
      "createur",
      0.045
    ],
    [
      "promoteur",
      0.0375
    ],
    [
      "barbouilleur",
      0.0275
    ],
    [
      "pere",
      0.0225
    ],
    [
      "cause",
      0.0225
    ],
    [
      "ecrivailleur",
      0.0175
    ],
    [
      "premier",
      0.0175
    ],
    [
      "inventeur",
      0.0175
    ],
    [
      "historien",
      0.0175
    ],
    [
      "critique",
      0.0175
    ],
    [
      "chroniqueur",
      0.0175
    ],
    [
      "artisan",
      0.0175
    ],
    [
      "agent",
      0.0175
    ],
    [
      "plumitif",
      0.0125
    ],
    [
      "poete",
      0.0125
    ],
    [
      "principe",
      0.0125
    ],
    [
      "producteur",
      0.0125
    ],
    [
      "responsable",
      0.0125
    ],
    [
      "moraliste",
      0.0125
    ],
    [
      "initiateur",
      0.0125
    ],
    [
      "chansonnier",
      0.0125
    ],
    [
      "commentateur",
      0.0125
    ],
    [
      "fabricant",
      0.0125
    ],
    [
      "feuilletoniste",
      0.0125
    ],
    [
      "litterateur",
      0.0075
    ],
    [
      "memorialiste",
      0.0075
    ],
    [
      "ouvrier",
      0.0075
    ],
    [
      "pamphletaire",
      0.0075
    ],
    [
      "parodiste",
      0.0075
    ],
    [
      "parolier",
      0.0075
    ],
    [
      "pasticheur",
      0.0075
    ],
    [
      "romancier",
      0.0075
    ],
    [
      "redacteur",
      0.0075
    ],
    [
      "satiriste",
      0.0075
    ],
    [
      "ecrivassier",
      0.0075
    ],
    [
      "librettiste",
      0.0075
    ],
    [
      "instaurateur",
      0.0075
    ],
    [
      "ancetre",
      0.0075
    ],
    [
      "anecdotier",
      0.0075
    ],
    [
      "biographe",
      0.0075
    ],
    [
      "cacographe",
      0.0075
    ],
    [
      "compilateur",
      0.0075
    ],
    [
      "conteur",
      0.0075
    ],
    [
      "fabuliste",
      0.0075
    ],
    [
      "facteur",
      0.0075
    ],
    [
      "folliculaire",
      0.0075
    ],
    [
      "gendelettre",
      0.0075
    ],
    [
      "generateur",
      0.0075
    ],
    [
      "polygraphe",
      0.0025
    ],
    [
      "plume",
      0.0025
    ],
    [
      "paremiographe",
      0.0025
    ],
    [
      "operateur",
      0.0025
    ],
    [
      "negre",
      0.0025
    ],
    [
      "nouvelliste",
      0.0025
    ],
    [
      "mythographe",
      0.0025
    ],
    [
      "musicographe",
      0.0025
    ],
    [
      "polemiste",
      0.0025
    ],
    [
      "prosateur",
      0.0025
    ],
    [
      "prefacier",
      0.0025
    ],
    [
      "epistolier",
      0.0025
    ],
    [
      "ecrivant",
      0.0025
    ],
    [
      "echotier",
      0.0025
    ],
    [
      "vaudevilliste",
      0.0025
    ],
    [
      "sermonnaire",
      0.0025
    ],
    [
      "scenariste",
      0.0025
    ],
    [
      "rhetoriqueur",
      0.0025
    ],
    [
      "revuiste",
      0.0025
    ],
    [
      "publiciste",
      0.0025
    ],
    [
      "mimographe",
      0.0025
    ],
    [
      "logographe",
      0.0025
    ],
    [
      "libelliste",
      0.0025
    ],
    [
      "encyclopediste",
      0.0025
    ],
    [
      "dramaturge",
      0.0025
    ],
    [
      "diariste",
      0.0025
    ],
    [
      "coupable",
      0.0025
    ],
    [
      "compositeur",
      0.0025
    ],
    [
      "cerveau",
      0.0025
    ],
    [
      "aieul",
      0.0025
    ],
    [
      "fondateur",
      0.0025
    ],
    [
      "lexicographe",
      0.0025
    ],
    [
      "historiographe",
      0.0025
    ],
    [
      "hagiographe",
      0.0025
    ],
    [
      "grimaud",
      0.0025
    ],
    [
      "gribouilleur",
      0.0025
    ],
    [
      "glossateur",
      0.0025
    ],
    [
      "gazetier",
      0.0025
    ],
    [
      "autoresse",
      0.0025
    ]
  ],
  "acteur": [
    [
      "comedien",
      0.15
    ],
    [
      "cabotin",
      0.13
    ],
    [
      "artiste",
      0.075
    ],
    [
      "baladin",
      0.075
    ],
    [
      "bouffon",
      0.055
    ],
    [
      "histrion",
      0.055
    ],
    [
      "interprete",
      0.055
    ],
    [
      "vedette",
      0.0375
    ],
    [
      "pantomime",
      0.0375
    ],
    [
      "mime",
      0.0375
    ],
    [
      "chanteur",
      0.0375
    ],
    [
      "cabot",
      0.0375
    ],
    [
      "tragedien",
      0.0175
    ],
    [
      "theatreux",
      0.0175
    ],
    [
      "star",
      0.0175
    ],
    [
      "ringard",
      0.0175
    ],
    [
      "protagoniste",
      0.0175
    ],
    [
      "pensionnaire",
      0.0175
    ],
    [
      "figurant",
      0.0175
    ],
    [
      "ficelier",
      0.0175
    ],
    [
      "etoile",
      0.0175
    ]
  ],
  "anarchiste": [
    [
      "extremiste",
      0.22
    ],
    [
      "revolutionnaire",
      0.22
    ],
    [
      "anar",
      0.11
    ],
    [
      "anarchique",
      0.11
    ],
    [
      "anarchisant",
      0.11
    ],
    [
      "libertaire",
      0.11
    ],
    [
      "seditieux",
      0.11
    ]
  ],
  "boomerang": [],
  "efface": [
    [
      "supprimer",
      0.1075
    ],
    [
      "oter",
      0.0575
    ],
    [
      "biffer",
      0.0525
    ],
    [
      "detruire",
      0.0525
    ],
    [
      "barrer",
      0.045
    ],
    [
      "enlever",
      0.045
    ],
    [
      "radier",
      0.045
    ],
    [
      "rayer",
      0.04
    ],
    [
      "annuler",
      0.0275
    ],
    [
      "abolir",
      0.0225
    ],
    [
      "couper",
      0.0225
    ],
    [
      "obscurcir",
      0.0225
    ],
    [
      "eteindre",
      0.0225
    ],
    [
      "excuser",
      0.02
    ],
    [
      "affadir",
      0.015
    ],
    [
      "eclipser",
      0.015
    ],
    [
      "ternir",
      0.015
    ],
    [
      "laver",
      0.015
    ],
    [
      "estomper",
      0.015
    ],
    [
      "couvrir",
      0.015
    ],
    [
      "censurer",
      0.015
    ],
    [
      "caviarder",
      0.015
    ],
    [
      "eliminer",
      0.01
    ],
    [
      "sabrer",
      0.01
    ],
    [
      "raturer",
      0.01
    ],
    [
      "pardonner",
      0.01
    ],
    [
      "obliterer",
      0.01
    ],
    [
      "lever",
      0.01
    ],
    [
      "justifier",
      0.01
    ],
    [
      "gratter",
      0.01
    ],
    [
      "absoudre",
      0.01
    ],
    [
      "resilier",
      0.0075
    ],
    [
      "guerir",
      0.0075
    ],
    [
      "gommer",
      0.0075
    ],
    [
      "canceller",
      0.0075
    ],
    [
      "affaiblir",
      0.0075
    ],
    [
      "fondre",
      0.0025
    ],
    [
      "oublier",
      0.0025
    ],
    [
      "purger",
      0.0025
    ],
    [
      "racheter",
      0.0025
    ],
    [
      "reparer",
      0.0025
    ],
    [
      "surpasser",
      0.0025
    ],
    [
      "echopper",
      0.0025
    ],
    [
      "faner",
      0.0025
    ],
    [
      "escamoter",
      0.0025
    ],
    [
      "encaisser",
      0.0025
    ],
    [
      "detroner",
      0.0025
    ],
    [
      "demarquer",
      0.0025
    ],
    [
      "croiser",
      0.0025
    ],
    [
      "annihiler",
      0.0025
    ],
    [
      "abroger",
      0.0025
    ],
    [
      "eradiquer",
      0.0025
    ]
  ],
  "rejete": [
    [
      "repousser",
      0.1125
    ],
    [
      "chasser",
      0.08
    ],
    [
      "renvoyer",
      0.0625
    ],
    [
      "refuser",
      0.045
    ],
    [
      "exclure",
      0.0375
    ],
    [
      "ecarter",
      0.0375
    ],
    [
      "expulser",
      0.035
    ],
    [
      "eloigner",
      0.03
    ],
    [
      "bannir",
      0.0275
    ],
    [
      "jeter",
      0.0275
    ],
    [
      "lancer",
      0.0275
    ],
    [
      "pousser",
      0.0275
    ],
    [
      "vomir",
      0.0275
    ],
    [
      "eliminer",
      0.0275
    ],
    [
      "balancer",
      0.0225
    ],
    [
      "abandonner",
      0.02
    ],
    [
      "balayer",
      0.02
    ],
    [
      "proscrire",
      0.02
    ],
    [
      "refouler",
      0.02
    ],
    [
      "evacuer",
      0.0125
    ],
    [
      "ejecter",
      0.0125
    ],
    [
      "recuser",
      0.0125
    ],
    [
      "reculer",
      0.0125
    ],
    [
      "repudier",
      0.01
    ],
    [
      "rendre",
      0.01
    ],
    [
      "releguer",
      0.01
    ],
    [
      "maudire",
      0.01
    ],
    [
      "execrer",
      0.01
    ],
    [
      "excommunier",
      0.01
    ],
    [
      "decliner",
      0.01
    ],
    [
      "reporter",
      0.005
    ],
    [
      "rapporter",
      0.005
    ],
    [
      "nier",
      0.005
    ],
    [
      "infirmer",
      0.005
    ],
    [
      "degorger",
      0.005
    ],
    [
      "debouter",
      0.005
    ],
    [
      "condamner",
      0.005
    ],
    [
      "casser",
      0.005
    ],
    [
      "boycotter",
      0.005
    ],
    [
      "attribuer",
      0.005
    ],
    [
      "relancer",
      0.0025
    ],
    [
      "restituer",
      0.0025
    ],
    [
      "reprouver",
      0.0025
    ],
    [
      "s'affranchir",
      0.0025
    ],
    [
      "s'opposer",
      0.0025
    ],
    [
      "rebuter",
      0.0025
    ],
    [
      "rayer",
      0.0025
    ],
    [
      "prescrire",
      0.0025
    ],
    [
      "dedaigner",
      0.0025
    ],
    [
      "debecter",
      0.0025
    ],
    [
      "cracher",
      0.0025
    ],
    [
      "accuser",
      0.0025
    ],
    [
      "epurer",
      0.0025
    ]
  ],
  "bringue": [
    [
      "bombance",
      0.1125
    ],
    [
      "festin",
      0.1125
    ],
    [
      "bombe",
      0.1
    ],
    [
      "fete",
      0.1
    ],
    [
      "noce",
      0.08
    ],
    [
      "debauche",
      0.06
    ],
    [
      "bamboche",
      0.0525
    ],
    [
      "beuverie",
      0.045
    ],
    [
      "nouba",
      0.045
    ],
    [
      "ripaille",
      0.04
    ],
    [
      "banquet",
      0.0325
    ],
    [
      "foire",
      0.0325
    ],
    [
      "rejouissance",
      0.025
    ],
    [
      "agapes",
      0.025
    ],
    [
      "ribote",
      0.02
    ],
    [
      "bamboula",
      0.0125
    ],
    [
      "degagement",
      0.0125
    ],
    [
      "festivite",
      0.0125
    ],
    [
      "partie",
      0.0125
    ],
    [
      "hallebreda",
      0.005
    ],
    [
      "gueuleton",
      0.005
    ],
    [
      "goguette",
      0.005
    ],
    [
      "gigue",
      0.005
    ],
    [
      "fiesta",
      0.005
    ],
    [
      "brinde",
      0.005
    ],
    [
      "java",
      0.005
    ]
  ],
  "exsangue": [
    [
      "bleme",
      0.1175
    ],
    [
      "terreux",
      0.1175
    ],
    [
      "pale",
      0.1175
    ],
    [
      "plombe",
      0.1175
    ],
    [
      "livide",
      0.1175
    ],
    [
      "faible",
      0.1175
    ],
    [
      "anemique",
      0.0575
    ],
    [
      "blafard",
      0.0575
    ],
    [
      "cadaverique",
      0.0575
    ],
    [
      "cireux",
      0.0575
    ],
    [
      "have",
      0.0575
    ]
  ],
  "deglinguer": [
    [
      "detraquer",
      0.2175
    ],
    [
      "demolir",
      0.155
    ],
    [
      "disloquer",
      0.125
    ],
    [
      "deregler",
      0.06
    ],
    [
      "deranger",
      0.06
    ],
    [
      "demanteler",
      0.06
    ],
    [
      "demancher",
      0.06
    ],
    [
      "degrader",
      0.06
    ],
    [
      "abimer",
      0.06
    ],
    [
      "debringuer",
      0.03
    ],
    [
      "demantibuler",
      0.03
    ],
    [
      "desarticuler",
      0.03
    ],
    [
      "deteriorer",
      0.03
    ]
  ],
  "deglingue": [
    [
      "detraquer",
      0.2175
    ],
    [
      "demolir",
      0.155
    ],
    [
      "disloquer",
      0.125
    ],
    [
      "deregler",
      0.06
    ],
    [
      "deranger",
      0.06
    ],
    [
      "demanteler",
      0.06
    ],
    [
      "demancher",
      0.06
    ],
    [
      "degrader",
      0.06
    ],
    [
      "abimer",
      0.06
    ],
    [
      "debringuer",
      0.03
    ],
    [
      "demantibuler",
      0.03
    ],
    [
      "desarticuler",
      0.03
    ],
    [
      "deteriorer",
      0.03
    ]
  ],
  "cruaute": [
    [
      "durete",
      0.1125
    ],
    [
      "ferocite",
      0.1125
    ],
    [
      "inhumanite",
      0.0775
    ],
    [
      "brutalite",
      0.0675
    ],
    [
      "severite",
      0.06
    ],
    [
      "mechancete",
      0.05
    ],
    [
      "aprete",
      0.0425
    ],
    [
      "rudesse",
      0.0425
    ],
    [
      "rigueur",
      0.0425
    ],
    [
      "barbarie",
      0.0425
    ],
    [
      "sauvagerie",
      0.0325
    ],
    [
      "mal",
      0.025
    ],
    [
      "insensibilite",
      0.025
    ],
    [
      "horreur",
      0.025
    ],
    [
      "haine",
      0.025
    ],
    [
      "amertume",
      0.025
    ],
    [
      "sadisme",
      0.015
    ],
    [
      "inexorabilite",
      0.015
    ],
    [
      "indifference",
      0.015
    ],
    [
      "inclemence",
      0.015
    ],
    [
      "atrocite",
      0.015
    ],
    [
      "acharnement",
      0.015
    ],
    [
      "rosserie",
      0.0075
    ],
    [
      "rapacite",
      0.0075
    ],
    [
      "injustice",
      0.0075
    ],
    [
      "hostilite",
      0.0075
    ],
    [
      "exces",
      0.0075
    ],
    [
      "courage",
      0.0075
    ],
    [
      "cannibalisme",
      0.0075
    ],
    [
      "bestialite",
      0.0075
    ],
    [
      "tyrannie",
      0.0075
    ]
  ],
  "seducteur": [
    [
      "charmeur",
      0.135
    ],
    [
      "suborneur",
      0.105
    ],
    [
      "enchanteur",
      0.065
    ],
    [
      "enjoleur",
      0.065
    ],
    [
      "ensorceleur",
      0.065
    ],
    [
      "seduisant",
      0.065
    ],
    [
      "charmant",
      0.0475
    ],
    [
      "troublant",
      0.0375
    ],
    [
      "galant",
      0.0375
    ],
    [
      "fascinateur",
      0.0375
    ],
    [
      "fascinant",
      0.0375
    ],
    [
      "envouteur",
      0.0275
    ],
    [
      "tombeur",
      0.0175
    ],
    [
      "magicien",
      0.0175
    ],
    [
      "lovelace",
      0.0175
    ],
    [
      "envoutant",
      0.0175
    ],
    [
      "attrayant",
      0.0175
    ],
    [
      "larron",
      0.0075
    ],
    [
      "flatteur",
      0.0075
    ],
    [
      "engageant",
      0.0075
    ],
    [
      "embobelineur",
      0.0075
    ],
    [
      "corrupteur",
      0.0075
    ],
    [
      "casanova",
      0.0075
    ],
    [
      "baratineur",
      0.0075
    ],
    [
      "apprivoiseur",
      0.0075
    ]
  ],
  "cingle": [
    [
      "battre",
      0.12
    ],
    [
      "fouetter",
      0.0925
    ],
    [
      "marcher",
      0.065
    ],
    [
      "blesser",
      0.0525
    ],
    [
      "flageller",
      0.0525
    ],
    [
      "souffleter",
      0.0375
    ],
    [
      "moucher",
      0.0375
    ],
    [
      "fustiger",
      0.0375
    ],
    [
      "frapper",
      0.0375
    ],
    [
      "couper",
      0.0375
    ],
    [
      "attaquer",
      0.0375
    ],
    [
      "voguer",
      0.025
    ],
    [
      "vexer",
      0.025
    ],
    [
      "s'avancer",
      0.025
    ],
    [
      "progresser",
      0.025
    ],
    [
      "naviguer",
      0.025
    ],
    [
      "forger",
      0.025
    ],
    [
      "critiquer",
      0.025
    ],
    [
      "aller",
      0.025
    ],
    [
      "gifler",
      0.0125
    ],
    [
      "fouailler",
      0.0125
    ],
    [
      "exciter",
      0.0125
    ],
    [
      "cravacher",
      0.0125
    ],
    [
      "corroyer",
      0.0125
    ],
    [
      "attiser",
      0.0125
    ],
    [
      "sangler",
      0.0125
    ]
  ],
  "cingler": [
    [
      "battre",
      0.12
    ],
    [
      "fouetter",
      0.0925
    ],
    [
      "marcher",
      0.065
    ],
    [
      "blesser",
      0.0525
    ],
    [
      "flageller",
      0.0525
    ],
    [
      "souffleter",
      0.0375
    ],
    [
      "moucher",
      0.0375
    ],
    [
      "fustiger",
      0.0375
    ],
    [
      "frapper",
      0.0375
    ],
    [
      "couper",
      0.0375
    ],
    [
      "attaquer",
      0.0375
    ],
    [
      "voguer",
      0.025
    ],
    [
      "vexer",
      0.025
    ],
    [
      "s'avancer",
      0.025
    ],
    [
      "progresser",
      0.025
    ],
    [
      "naviguer",
      0.025
    ],
    [
      "forger",
      0.025
    ],
    [
      "critiquer",
      0.025
    ],
    [
      "aller",
      0.025
    ],
    [
      "gifler",
      0.0125
    ],
    [
      "fouailler",
      0.0125
    ],
    [
      "exciter",
      0.0125
    ],
    [
      "cravacher",
      0.0125
    ],
    [
      "corroyer",
      0.0125
    ],
    [
      "attiser",
      0.0125
    ],
    [
      "sangler",
      0.0125
    ]
  ],
  "endurer": [
    [
      "souffrir",
      0.155
    ],
    [
      "supporter",
      0.155
    ],
    [
      "subir",
      0.1375
    ],
    [
      "accepter",
      0.075
    ],
    [
      "tolerer",
      0.06
    ],
    [
      "eprouver",
      0.045
    ],
    [
      "boire",
      0.045
    ],
    [
      "ressentir",
      0.03
    ],
    [
      "essuyer",
      0.03
    ],
    [
      "deguster",
      0.03
    ],
    [
      "digerer",
      0.03
    ],
    [
      "connaitre",
      0.03
    ],
    [
      "avaler",
      0.03
    ],
    [
      "resister",
      0.0125
    ],
    [
      "patir",
      0.0125
    ],
    [
      "permettre",
      0.0125
    ],
    [
      "autoriser",
      0.0125
    ],
    [
      "admettre",
      0.0125
    ],
    [
      "soutenir",
      0.0125
    ]
  ],
  "cylindrer": [
    [
      "aleser",
      0.25
    ],
    [
      "calandrer",
      0.25
    ],
    [
      "lustrer",
      0.25
    ],
    [
      "tuyauter",
      0.25
    ]
  ],
  "cylindre": [
    [
      "baton",
      0.1025
    ],
    [
      "rouleau",
      0.1025
    ],
    [
      "bobine",
      0.0675
    ],
    [
      "coussinet",
      0.0325
    ],
    [
      "laminoir",
      0.0325
    ],
    [
      "manchon",
      0.0325
    ],
    [
      "mandrin",
      0.0325
    ],
    [
      "meule",
      0.0325
    ],
    [
      "rond",
      0.0325
    ],
    [
      "rondin",
      0.0325
    ],
    [
      "tambour",
      0.0325
    ],
    [
      "tige",
      0.0325
    ],
    [
      "compresseur",
      0.0325
    ],
    [
      "barillet",
      0.0325
    ],
    [
      "boudin",
      0.0325
    ],
    [
      "batonnet",
      0.0325
    ],
    [
      "calandre",
      0.0325
    ],
    [
      "canette",
      0.0325
    ],
    [
      "canon",
      0.0325
    ],
    [
      "cartouche",
      0.0325
    ],
    [
      "colonne",
      0.0325
    ],
    [
      "tube",
      0.0325
    ]
  ],
  "oblong": [
    [
      "allonge",
      0.3325
    ],
    [
      "long",
      0.3325
    ],
    [
      "ovale",
      0.3325
    ]
  ],
  "archipel": [
    [
      "agglomeration",
      0.5
    ],
    [
      "iles",
      0.5
    ]
  ],
  "perpetuel": [
    [
      "continu",
      0.075
    ],
    [
      "immuable",
      0.075
    ],
    [
      "suivi",
      0.075
    ],
    [
      "eternel",
      0.075
    ],
    [
      "constant",
      0.0675
    ],
    [
      "sempiternel",
      0.0575
    ],
    [
      "permanent",
      0.0575
    ],
    [
      "durable",
      0.0575
    ],
    [
      "incessant",
      0.05
    ],
    [
      "persistant",
      0.05
    ],
    [
      "inalterable",
      0.0425
    ],
    [
      "continuel",
      0.0325
    ],
    [
      "indelebile",
      0.025
    ],
    [
      "indestructible",
      0.025
    ],
    [
      "immortel",
      0.025
    ],
    [
      "frequent",
      0.025
    ],
    [
      "ininterrompu",
      0.015
    ],
    [
      "infini",
      0.015
    ],
    [
      "imperissable",
      0.015
    ],
    [
      "habituel",
      0.015
    ],
    [
      "assidu",
      0.015
    ],
    [
      "inapaisable",
      0.0075
    ],
    [
      "indissoluble",
      0.0075
    ],
    [
      "indefini",
      0.0075
    ],
    [
      "renouvele",
      0.0075
    ],
    [
      "reitere",
      0.0075
    ],
    [
      "repete",
      0.0075
    ]
  ],
  "sensuel": [
    [
      "lascif",
      0.1275
    ],
    [
      "impudique",
      0.075
    ],
    [
      "libidineux",
      0.065
    ],
    [
      "licencieux",
      0.065
    ],
    [
      "lubrique",
      0.065
    ],
    [
      "luxurieux",
      0.05
    ],
    [
      "obscene",
      0.05
    ],
    [
      "erotique",
      0.0475
    ],
    [
      "voluptueux",
      0.0475
    ],
    [
      "libertin",
      0.0375
    ],
    [
      "paillard",
      0.0375
    ],
    [
      "debauche",
      0.0325
    ],
    [
      "charnel",
      0.0275
    ],
    [
      "salace",
      0.0225
    ],
    [
      "polisson",
      0.0225
    ],
    [
      "orgiaque",
      0.0225
    ],
    [
      "galant",
      0.0225
    ],
    [
      "impur",
      0.0175
    ],
    [
      "sybarite",
      0.0175
    ],
    [
      "epicurien",
      0.0125
    ],
    [
      "indecent",
      0.0125
    ],
    [
      "amoureux",
      0.0125
    ],
    [
      "materiel",
      0.0075
    ],
    [
      "leger",
      0.0075
    ],
    [
      "leste",
      0.0075
    ],
    [
      "jouisseur",
      0.0075
    ],
    [
      "immodeste",
      0.0075
    ],
    [
      "grossier",
      0.0075
    ],
    [
      "animal",
      0.0075
    ],
    [
      "concupiscent",
      0.0025
    ],
    [
      "physique",
      0.0025
    ],
    [
      "sexy",
      0.0025
    ]
  ],
  "fusee": [
    [
      "s'elancer",
      0.155
    ],
    [
      "jaillir",
      0.0975
    ],
    [
      "sauter",
      0.0875
    ],
    [
      "partir",
      0.0575
    ],
    [
      "foncer",
      0.0575
    ],
    [
      "bondir",
      0.0475
    ],
    [
      "eclater",
      0.0375
    ],
    [
      "tomber",
      0.0375
    ],
    [
      "fondre",
      0.0275
    ],
    [
      "gicler",
      0.0275
    ],
    [
      "piquer",
      0.0275
    ],
    [
      "s'elever",
      0.0175
    ],
    [
      "s'echapper",
      0.0175
    ],
    [
      "debouler",
      0.0175
    ],
    [
      "charger",
      0.0075
    ],
    [
      "exploser",
      0.0075
    ],
    [
      "glisser",
      0.0075
    ],
    [
      "rejaillir",
      0.0075
    ],
    [
      "sourdre",
      0.0075
    ]
  ],
  "fuser": [
    [
      "s'elancer",
      0.155
    ],
    [
      "jaillir",
      0.0975
    ],
    [
      "sauter",
      0.0875
    ],
    [
      "partir",
      0.0575
    ],
    [
      "foncer",
      0.0575
    ],
    [
      "bondir",
      0.0475
    ],
    [
      "eclater",
      0.0375
    ],
    [
      "tomber",
      0.0375
    ],
    [
      "fondre",
      0.0275
    ],
    [
      "gicler",
      0.0275
    ],
    [
      "piquer",
      0.0275
    ],
    [
      "s'elever",
      0.0175
    ],
    [
      "s'echapper",
      0.0175
    ],
    [
      "debouler",
      0.0175
    ],
    [
      "charger",
      0.0075
    ],
    [
      "exploser",
      0.0075
    ],
    [
      "glisser",
      0.0075
    ],
    [
      "rejaillir",
      0.0075
    ],
    [
      "sourdre",
      0.0075
    ]
  ],
  "voltige": [
    [
      "acrobatie",
      0.25
    ],
    [
      "cabriole",
      0.25
    ],
    [
      "cirque",
      0.25
    ],
    [
      "saut",
      0.25
    ]
  ],
  "voltiger": [
    [
      "voler",
      0.19
    ],
    [
      "papillonner",
      0.1425
    ],
    [
      "voleter",
      0.0925
    ],
    [
      "s'envoler",
      0.0925
    ],
    [
      "ondoyer",
      0.0925
    ],
    [
      "flotter",
      0.0925
    ],
    [
      "courir",
      0.0925
    ],
    [
      "bondir",
      0.045
    ],
    [
      "changer",
      0.045
    ]
  ],
  "plusieurs": [
    [
      "beaucoup",
      0.215
    ],
    [
      "divers",
      0.1725
    ],
    [
      "certains",
      0.13
    ],
    [
      "d'aucuns",
      0.085
    ],
    [
      "quelques",
      0.085
    ],
    [
      "multiples",
      0.0425
    ],
    [
      "moult",
      0.0425
    ],
    [
      "maint",
      0.0425
    ],
    [
      "force",
      0.0425
    ],
    [
      "differents",
      0.0425
    ]
  ],
  "fougere": [],
  "fusion": [
    [
      "association",
      0.125
    ],
    [
      "union",
      0.125
    ],
    [
      "integration",
      0.0875
    ],
    [
      "reunion",
      0.07
    ],
    [
      "melange",
      0.07
    ],
    [
      "combinaison",
      0.07
    ],
    [
      "assemblage",
      0.07
    ],
    [
      "concentration",
      0.0525
    ],
    [
      "syncretisme",
      0.035
    ],
    [
      "groupement",
      0.035
    ],
    [
      "entente",
      0.035
    ],
    [
      "assimilation",
      0.035
    ],
    [
      "unification",
      0.015
    ],
    [
      "reduction",
      0.015
    ],
    [
      "liquefaction",
      0.015
    ],
    [
      "jonction",
      0.015
    ],
    [
      "gemination",
      0.015
    ],
    [
      "fusionnement",
      0.015
    ],
    [
      "fonte",
      0.015
    ],
    [
      "brassage",
      0.015
    ],
    [
      "absorption",
      0.015
    ],
    [
      "eclectisme",
      0.015
    ]
  ],
  "desire": [
    [
      "vouloir",
      0.1425
    ],
    [
      "souhaiter",
      0.125
    ],
    [
      "pretendre",
      0.0575
    ],
    [
      "viser",
      0.0575
    ],
    [
      "convoiter",
      0.0525
    ],
    [
      "rever",
      0.0475
    ],
    [
      "ambitionner",
      0.0425
    ],
    [
      "aspirer",
      0.0425
    ],
    [
      "demander",
      0.0425
    ],
    [
      "briguer",
      0.035
    ],
    [
      "rechercher",
      0.03
    ],
    [
      "revendiquer",
      0.025
    ],
    [
      "solliciter",
      0.025
    ],
    [
      "exiger",
      0.02
    ],
    [
      "lorgner",
      0.02
    ],
    [
      "soupirer",
      0.02
    ],
    [
      "tendre",
      0.02
    ],
    [
      "chercher",
      0.0175
    ],
    [
      "aimer",
      0.0125
    ],
    [
      "appeler",
      0.0125
    ],
    [
      "envier",
      0.0125
    ],
    [
      "guigner",
      0.0075
    ],
    [
      "esperer",
      0.0075
    ],
    [
      "attendre",
      0.0075
    ],
    [
      "appeter",
      0.0075
    ],
    [
      "interesser",
      0.0025
    ],
    [
      "incliner",
      0.0025
    ],
    [
      "griller",
      0.0025
    ],
    [
      "entendre",
      0.0025
    ]
  ],
  "alize": [
    [
      "vent",
      1.0
    ]
  ],
  "alentour": [
    [
      "autour",
      0.3325
    ]
  ],
  "envoute": [
    [
      "seduire",
      0.16
    ],
    [
      "charmer",
      0.125
    ],
    [
      "ensorceler",
      0.105
    ],
    [
      "captiver",
      0.0875
    ],
    [
      "subjuguer",
      0.07
    ],
    [
      "tenter",
      0.0525
    ],
    [
      "fasciner",
      0.0525
    ],
    [
      "conquerir",
      0.0525
    ],
    [
      "troubler",
      0.035
    ],
    [
      "gagner",
      0.035
    ],
    [
      "enflammer",
      0.035
    ],
    [
      "enchanter",
      0.035
    ],
    [
      "assujettir",
      0.035
    ],
    [
      "affrioler",
      0.035
    ],
    [
      "dominer",
      0.0175
    ],
    [
      "fanatiser",
      0.0175
    ],
    [
      "hypnotiser",
      0.0175
    ],
    [
      "suggestionner",
      0.0175
    ]
  ],
  "mentalement": [
    [
      "moralement",
      0.5
    ],
    [
      "psychiquement",
      0.25
    ],
    [
      "psychologiquement",
      0.25
    ]
  ],
  "fiancailles": [
    [
      "accordailles",
      0.5
    ]
  ],
  "preference": [
    [
      "gout",
      0.1175
    ],
    [
      "faible",
      0.0775
    ],
    [
      "faveur",
      0.0775
    ],
    [
      "predilection",
      0.0775
    ],
    [
      "inclination",
      0.0575
    ],
    [
      "faiblesse",
      0.0575
    ],
    [
      "choix",
      0.0575
    ],
    [
      "egards",
      0.0375
    ],
    [
      "privilege",
      0.0375
    ],
    [
      "passion",
      0.0375
    ],
    [
      "partialite",
      0.0375
    ],
    [
      "favoritisme",
      0.0375
    ],
    [
      "avantage",
      0.0375
    ],
    [
      "affection",
      0.0375
    ],
    [
      "prevenances",
      0.0175
    ],
    [
      "preemption",
      0.0175
    ],
    [
      "predominance",
      0.0175
    ],
    [
      "option",
      0.0175
    ],
    [
      "distinction",
      0.0175
    ],
    [
      "attirance",
      0.0175
    ],
    [
      "attention",
      0.0175
    ],
    [
      "acception",
      0.0175
    ],
    [
      "eclectisme",
      0.0175
    ]
  ],
  "defaillance": [
    [
      "faiblesse",
      0.1425
    ],
    [
      "manque",
      0.1425
    ],
    [
      "defaut",
      0.105
    ],
    [
      "evanouissement",
      0.07
    ],
    [
      "syncope",
      0.07
    ],
    [
      "malaise",
      0.07
    ],
    [
      "absence",
      0.07
    ],
    [
      "eclipse",
      0.035
    ],
    [
      "trou",
      0.035
    ],
    [
      "suppression",
      0.035
    ],
    [
      "pamoison",
      0.035
    ],
    [
      "manquement",
      0.035
    ],
    [
      "insuffisance",
      0.035
    ],
    [
      "deficience",
      0.035
    ],
    [
      "affaiblissement",
      0.035
    ],
    [
      "etourdissement",
      0.035
    ]
  ],
  "qu": [],
  "incertitude": [
    [
      "hesitation",
      0.05
    ],
    [
      "indecision",
      0.05
    ],
    [
      "tatonnement",
      0.05
    ],
    [
      "obscurite",
      0.045
    ],
    [
      "instabilite",
      0.045
    ],
    [
      "doute",
      0.045
    ],
    [
      "confusion",
      0.0375
    ],
    [
      "indetermination",
      0.0375
    ],
    [
      "fluctuation",
      0.0325
    ],
    [
      "oscillation",
      0.0325
    ],
    [
      "vacillation",
      0.0275
    ],
    [
      "perplexite",
      0.0275
    ],
    [
      "hasard",
      0.0275
    ],
    [
      "variabilite",
      0.0225
    ],
    [
      "souci",
      0.0225
    ],
    [
      "precarite",
      0.0225
    ],
    [
      "irresolution",
      0.0225
    ],
    [
      "inconstance",
      0.0225
    ],
    [
      "flottement",
      0.0225
    ],
    [
      "embarras",
      0.0225
    ],
    [
      "equivoque",
      0.015
    ],
    [
      "versatilite",
      0.015
    ],
    [
      "vacillement",
      0.015
    ],
    [
      "tourment",
      0.015
    ],
    [
      "scrupule",
      0.015
    ],
    [
      "inquietude",
      0.015
    ],
    [
      "fragilite",
      0.015
    ],
    [
      "changement",
      0.015
    ],
    [
      "chance",
      0.015
    ],
    [
      "ambiguite",
      0.015
    ],
    [
      "eventualite",
      0.01
    ],
    [
      "enigme",
      0.01
    ],
    [
      "vague",
      0.01
    ],
    [
      "mystere",
      0.01
    ],
    [
      "faiblesse",
      0.01
    ],
    [
      "embrouillement",
      0.01
    ],
    [
      "desarroi",
      0.01
    ],
    [
      "tergiversation",
      0.005
    ],
    [
      "scepticisme",
      0.005
    ],
    [
      "imprevisibilite",
      0.005
    ],
    [
      "imbroglio",
      0.005
    ],
    [
      "fortune",
      0.005
    ],
    [
      "crise",
      0.005
    ],
    [
      "contingence",
      0.005
    ],
    [
      "brume",
      0.005
    ],
    [
      "brumaille",
      0.005
    ],
    [
      "ballottement",
      0.005
    ],
    [
      "anxiete",
      0.005
    ],
    [
      "alea",
      0.005
    ],
    [
      "vulnerabilite",
      0.005
    ]
  ],
  "ballon": [
    [
      "aeronef",
      0.085
    ],
    [
      "boule",
      0.085
    ],
    [
      "dirigeable",
      0.085
    ],
    [
      "hauteur",
      0.0425
    ],
    [
      "mont",
      0.0425
    ],
    [
      "montgolfiere",
      0.0425
    ],
    [
      "prison",
      0.0425
    ],
    [
      "saucisse",
      0.0425
    ],
    [
      "sommet",
      0.0425
    ],
    [
      "sphere",
      0.0425
    ],
    [
      "derriere",
      0.0425
    ],
    [
      "cuir",
      0.0425
    ],
    [
      "bulle",
      0.0425
    ],
    [
      "baudruche",
      0.0425
    ],
    [
      "ballonnet",
      0.0425
    ],
    [
      "balle",
      0.0425
    ],
    [
      "aerostat",
      0.0425
    ],
    [
      "abdomen",
      0.0425
    ],
    [
      "zeppelin",
      0.0425
    ]
  ],
  "tournesol": [
    [
      "bleu",
      0.25
    ],
    [
      "colorant",
      0.25
    ],
    [
      "helianthe",
      0.25
    ],
    [
      "soleil",
      0.25
    ]
  ],
  "moulin": [
    [
      "blutoir",
      0.125
    ],
    [
      "bourrin",
      0.125
    ],
    [
      "campagne",
      0.125
    ],
    [
      "habitation",
      0.125
    ],
    [
      "meunerie",
      0.125
    ],
    [
      "minoterie",
      0.125
    ],
    [
      "moteur",
      0.125
    ],
    [
      "egrugeoir",
      0.125
    ]
  ],
  "echeveau": [
    [
      "labyrinthe",
      0.3
    ],
    [
      "embrouillamini",
      0.2
    ],
    [
      "dedale",
      0.1
    ],
    [
      "entrelacement",
      0.1
    ],
    [
      "imbroglio",
      0.1
    ],
    [
      "maquis",
      0.1
    ],
    [
      "echevette",
      0.1
    ]
  ],
  "laine": [
    [
      "bourrage",
      0.165
    ],
    [
      "lainage",
      0.165
    ],
    [
      "mohair",
      0.165
    ],
    [
      "poil",
      0.165
    ],
    [
      "toison",
      0.165
    ],
    [
      "tricot",
      0.165
    ]
  ],
  "rengainer": [
    [
      "engainer",
      0.3325
    ],
    [
      "renquiller",
      0.3325
    ],
    [
      "rentrer",
      0.3325
    ]
  ],
  "tourbillon": [
    [
      "tempete",
      0.0825
    ],
    [
      "ouragan",
      0.07
    ],
    [
      "typhon",
      0.0575
    ],
    [
      "tumulte",
      0.0575
    ],
    [
      "tornade",
      0.0575
    ],
    [
      "bourrasque",
      0.0575
    ],
    [
      "remous",
      0.045
    ],
    [
      "tourmente",
      0.045
    ],
    [
      "vertige",
      0.035
    ],
    [
      "turbulence",
      0.035
    ],
    [
      "trombe",
      0.035
    ],
    [
      "mouvement",
      0.035
    ],
    [
      "cyclone",
      0.035
    ],
    [
      "vent",
      0.0225
    ],
    [
      "tournoiement",
      0.0225
    ],
    [
      "tourbillonnement",
      0.0225
    ],
    [
      "rafale",
      0.0225
    ],
    [
      "petillement",
      0.01
    ],
    [
      "multitude",
      0.01
    ],
    [
      "maelstrom",
      0.01
    ],
    [
      "impetuosite",
      0.01
    ],
    [
      "hourvari",
      0.01
    ],
    [
      "enivrement",
      0.01
    ],
    [
      "cercle",
      0.01
    ],
    [
      "bousculade",
      0.01
    ],
    [
      "vortex",
      0.01
    ]
  ],
  "goeland": [],
  "source": [
    [
      "origine",
      0.165
    ],
    [
      "principe",
      0.11
    ],
    [
      "racine",
      0.0625
    ],
    [
      "fondement",
      0.0525
    ],
    [
      "germe",
      0.0525
    ],
    [
      "commencement",
      0.045
    ],
    [
      "mine",
      0.035
    ],
    [
      "ferment",
      0.035
    ],
    [
      "cause",
      0.035
    ],
    [
      "base",
      0.035
    ],
    [
      "mere",
      0.025
    ],
    [
      "point",
      0.025
    ],
    [
      "provenance",
      0.025
    ],
    [
      "seuil",
      0.025
    ],
    [
      "pepiniere",
      0.0175
    ],
    [
      "puits",
      0.0175
    ],
    [
      "endroit",
      0.0175
    ],
    [
      "centre",
      0.0175
    ],
    [
      "agent",
      0.0175
    ],
    [
      "tresor",
      0.0075
    ],
    [
      "texte",
      0.0075
    ],
    [
      "resurgence",
      0.0075
    ],
    [
      "naissance",
      0.0075
    ],
    [
      "idee",
      0.0075
    ],
    [
      "generateur",
      0.0075
    ],
    [
      "griffon",
      0.0075
    ],
    [
      "geyser",
      0.0075
    ],
    [
      "foyer",
      0.0075
    ],
    [
      "fontaine",
      0.0075
    ],
    [
      "filon",
      0.0075
    ],
    [
      "canal",
      0.0075
    ],
    [
      "amont",
      0.0075
    ],
    [
      "etymologie",
      0.0075
    ]
  ],
  "tambourin": [
    [
      "tambour",
      1.0
    ]
  ],
  "terrien": [
    [
      "agreste",
      0.25
    ],
    [
      "continental",
      0.25
    ],
    [
      "paysan",
      0.25
    ],
    [
      "terrestre",
      0.25
    ]
  ],
  "metamorphose": [
    [
      "changement",
      0.255
    ],
    [
      "transformation",
      0.185
    ],
    [
      "transmutation",
      0.0925
    ],
    [
      "modification",
      0.0675
    ],
    [
      "evolution",
      0.045
    ],
    [
      "mutation",
      0.045
    ],
    [
      "conversion",
      0.045
    ],
    [
      "avatar",
      0.045
    ],
    [
      "alteration",
      0.045
    ],
    [
      "incarnation",
      0.0225
    ],
    [
      "mue",
      0.0225
    ],
    [
      "novation",
      0.0225
    ],
    [
      "revirement",
      0.0225
    ],
    [
      "renovation",
      0.0225
    ],
    [
      "transfiguration",
      0.0225
    ],
    [
      "transmigration",
      0.0225
    ]
  ],
  "metamorphoser": [
    [
      "changer",
      0.2125
    ],
    [
      "transformer",
      0.2125
    ],
    [
      "renouveler",
      0.095
    ],
    [
      "transmuer",
      0.095
    ],
    [
      "convertir",
      0.07
    ],
    [
      "modifier",
      0.07
    ],
    [
      "tourner",
      0.0475
    ],
    [
      "alterer",
      0.0475
    ],
    [
      "faire",
      0.0225
    ],
    [
      "incarner",
      0.0225
    ],
    [
      "muer",
      0.0225
    ],
    [
      "revolutionner",
      0.0225
    ],
    [
      "transfigurer",
      0.0225
    ],
    [
      "travestir",
      0.0225
    ]
  ],
  "loto": [
    [
      "bingo",
      1.0
    ]
  ],
  "onde": [
    [
      "ondulation",
      0.18
    ],
    [
      "vague",
      0.1275
    ],
    [
      "flot",
      0.1025
    ],
    [
      "remous",
      0.075
    ],
    [
      "vibration",
      0.05
    ],
    [
      "orbe",
      0.05
    ],
    [
      "houle",
      0.05
    ],
    [
      "frisson",
      0.05
    ],
    [
      "flux",
      0.05
    ],
    [
      "sinuosite",
      0.025
    ],
    [
      "rond",
      0.025
    ],
    [
      "ride",
      0.025
    ],
    [
      "mer",
      0.025
    ],
    [
      "lame",
      0.025
    ],
    [
      "fluide",
      0.025
    ],
    [
      "flots",
      0.025
    ],
    [
      "eau",
      0.025
    ],
    [
      "cercle",
      0.025
    ],
    [
      "son",
      0.025
    ]
  ],
  "trepasser": [
    [
      "mourir",
      0.1525
    ],
    [
      "perir",
      0.1525
    ],
    [
      "expirer",
      0.115
    ],
    [
      "finir",
      0.115
    ],
    [
      "succomber",
      0.075
    ],
    [
      "s'eteindre",
      0.075
    ],
    [
      "deceder",
      0.075
    ],
    [
      "disparaitre",
      0.075
    ],
    [
      "defunter",
      0.0375
    ],
    [
      "passer",
      0.0375
    ]
  ],
  "pou": [
    [
      "anoploure",
      0.1
    ],
    [
      "toto",
      0.1
    ],
    [
      "tique",
      0.1
    ],
    [
      "psoque",
      0.1
    ],
    [
      "melophage",
      0.1
    ],
    [
      "morpion",
      0.1
    ],
    [
      "lecanie",
      0.1
    ],
    [
      "lente",
      0.1
    ],
    [
      "grenadier",
      0.1
    ],
    [
      "vermine",
      0.1
    ]
  ],
  "touffu": [
    [
      "epais",
      0.13
    ],
    [
      "dense",
      0.1
    ],
    [
      "abondant",
      0.06
    ],
    [
      "fort",
      0.0525
    ],
    [
      "serre",
      0.0525
    ],
    [
      "plein",
      0.045
    ],
    [
      "obscur",
      0.045
    ],
    [
      "nebuleux",
      0.045
    ],
    [
      "tenebreux",
      0.0375
    ],
    [
      "sibyllin",
      0.03
    ],
    [
      "massif",
      0.03
    ],
    [
      "luxuriant",
      0.03
    ],
    [
      "fourni",
      0.03
    ],
    [
      "compact",
      0.03
    ],
    [
      "charge",
      0.0225
    ],
    [
      "dru",
      0.0225
    ],
    [
      "feuillu",
      0.0225
    ],
    [
      "impenetrable",
      0.0225
    ],
    [
      "tasse",
      0.015
    ],
    [
      "presse",
      0.015
    ],
    [
      "indigeste",
      0.015
    ],
    [
      "foisonnant",
      0.015
    ],
    [
      "filandreux",
      0.015
    ],
    [
      "broussailleux",
      0.015
    ],
    [
      "inextricable",
      0.005
    ],
    [
      "hirsute",
      0.005
    ],
    [
      "fourre",
      0.005
    ],
    [
      "feuille",
      0.005
    ],
    [
      "exuberant",
      0.005
    ],
    [
      "encombre",
      0.005
    ],
    [
      "condense",
      0.005
    ],
    [
      "comprime",
      0.005
    ],
    [
      "complique",
      0.005
    ],
    [
      "buissonneux",
      0.005
    ],
    [
      "branchu",
      0.005
    ],
    [
      "boise",
      0.005
    ],
    [
      "pile",
      0.005
    ]
  ],
  "crepu": [
    [
      "frisant",
      0.5
    ],
    [
      "frise",
      0.5
    ]
  ],
  "denuder": [
    [
      "decouvrir",
      0.1275
    ],
    [
      "depouiller",
      0.1275
    ],
    [
      "deshabiller",
      0.1275
    ],
    [
      "demunir",
      0.095
    ],
    [
      "montrer",
      0.095
    ],
    [
      "reveler",
      0.095
    ],
    [
      "devetir",
      0.0625
    ],
    [
      "devoiler",
      0.0625
    ],
    [
      "degarnir",
      0.0625
    ],
    [
      "degager",
      0.0625
    ],
    [
      "afficher",
      0.03
    ],
    [
      "dechausser",
      0.03
    ]
  ],
  "denude": [
    [
      "decouvrir",
      0.1275
    ],
    [
      "depouiller",
      0.1275
    ],
    [
      "deshabiller",
      0.1275
    ],
    [
      "demunir",
      0.095
    ],
    [
      "montrer",
      0.095
    ],
    [
      "reveler",
      0.095
    ],
    [
      "devetir",
      0.0625
    ],
    [
      "devoiler",
      0.0625
    ],
    [
      "degarnir",
      0.0625
    ],
    [
      "degager",
      0.0625
    ],
    [
      "afficher",
      0.03
    ],
    [
      "dechausser",
      0.03
    ]
  ],
  "vacant": [
    [
      "vide",
      0.235
    ],
    [
      "inoccupe",
      0.175
    ],
    [
      "abandonne",
      0.1175
    ],
    [
      "inhabite",
      0.1175
    ],
    [
      "libre",
      0.1175
    ],
    [
      "disponible",
      0.0575
    ],
    [
      "jacent",
      0.0575
    ],
    [
      "solitaire",
      0.0575
    ],
    [
      "vague",
      0.0575
    ]
  ],
  "bedouin": [
    [
      "arabe",
      1.0
    ]
  ],
  "shampoing": [],
  "perruque": [
    [
      "chevelure",
      0.2725
    ],
    [
      "postiche",
      0.2725
    ],
    [
      "cheveux",
      0.09
    ],
    [
      "coiffure",
      0.09
    ],
    [
      "moumoute",
      0.09
    ],
    [
      "rechauffante",
      0.09
    ],
    [
      "tignasse",
      0.09
    ]
  ],
  "implant": [
    [
      "pellet",
      1.0
    ]
  ],
  "traitement": [
    [
      "retribution",
      0.1325
    ],
    [
      "salaire",
      0.1
    ],
    [
      "remuneration",
      0.075
    ],
    [
      "appointements",
      0.05
    ],
    [
      "paye",
      0.05
    ],
    [
      "therapeutique",
      0.05
    ],
    [
      "paiement",
      0.0425
    ],
    [
      "paie",
      0.03
    ],
    [
      "recompense",
      0.03
    ],
    [
      "solde",
      0.03
    ],
    [
      "emoluments",
      0.03
    ],
    [
      "honoraires",
      0.025
    ],
    [
      "gain",
      0.025
    ],
    [
      "soin",
      0.0175
    ],
    [
      "remede",
      0.0175
    ],
    [
      "medication",
      0.0175
    ],
    [
      "indemnite",
      0.0175
    ],
    [
      "cure",
      0.0175
    ],
    [
      "soins",
      0.0125
    ],
    [
      "regime",
      0.0125
    ],
    [
      "operation",
      0.0125
    ],
    [
      "mois",
      0.0125
    ],
    [
      "mensualite",
      0.0125
    ],
    [
      "intervention",
      0.0125
    ],
    [
      "hygiene",
      0.0125
    ],
    [
      "gages",
      0.0125
    ],
    [
      "commission",
      0.0125
    ],
    [
      "manipulation",
      0.005
    ],
    [
      "medecine",
      0.005
    ],
    [
      "procede",
      0.005
    ],
    [
      "profit",
      0.005
    ],
    [
      "pret",
      0.005
    ],
    [
      "semaine",
      0.005
    ],
    [
      "transformation",
      0.005
    ],
    [
      "journee",
      0.005
    ],
    [
      "jour",
      0.005
    ],
    [
      "dotation",
      0.005
    ],
    [
      "ceremonial",
      0.005
    ],
    [
      "conditionnement",
      0.005
    ],
    [
      "cachet",
      0.005
    ],
    [
      "accueil",
      0.005
    ],
    [
      "vacations",
      0.005
    ]
  ],
  "permanente": [
    [
      "constant",
      0.1425
    ],
    [
      "immuable",
      0.11
    ],
    [
      "persistant",
      0.09
    ],
    [
      "durable",
      0.08
    ],
    [
      "perpetuel",
      0.07
    ],
    [
      "fixe",
      0.06
    ],
    [
      "continu",
      0.06
    ],
    [
      "inalterable",
      0.05
    ],
    [
      "stable",
      0.05
    ],
    [
      "suivi",
      0.04
    ],
    [
      "eternel",
      0.04
    ],
    [
      "sempiternel",
      0.03
    ],
    [
      "chronique",
      0.03
    ],
    [
      "continuel",
      0.02
    ],
    [
      "incessant",
      0.02
    ],
    [
      "indelebile",
      0.02
    ],
    [
      "inebranlable",
      0.02
    ],
    [
      "remanent",
      0.01
    ],
    [
      "perseverant",
      0.01
    ],
    [
      "intangible",
      0.01
    ],
    [
      "endemique",
      0.01
    ],
    [
      "sedentaire",
      0.01
    ]
  ],
  "permanent": [
    [
      "constant",
      0.1425
    ],
    [
      "immuable",
      0.11
    ],
    [
      "persistant",
      0.09
    ],
    [
      "durable",
      0.08
    ],
    [
      "perpetuel",
      0.07
    ],
    [
      "fixe",
      0.06
    ],
    [
      "continu",
      0.06
    ],
    [
      "inalterable",
      0.05
    ],
    [
      "stable",
      0.05
    ],
    [
      "suivi",
      0.04
    ],
    [
      "eternel",
      0.04
    ],
    [
      "sempiternel",
      0.03
    ],
    [
      "chronique",
      0.03
    ],
    [
      "continuel",
      0.02
    ],
    [
      "incessant",
      0.02
    ],
    [
      "indelebile",
      0.02
    ],
    [
      "inebranlable",
      0.02
    ],
    [
      "remanent",
      0.01
    ],
    [
      "perseverant",
      0.01
    ],
    [
      "intangible",
      0.01
    ],
    [
      "endemique",
      0.01
    ],
    [
      "sedentaire",
      0.01
    ]
  ],
  "bresilien": [],
  "raser": [
    [
      "fatiguer",
      0.095
    ],
    [
      "ennuyer",
      0.09
    ],
    [
      "assommer",
      0.0725
    ],
    [
      "barber",
      0.0725
    ],
    [
      "empoisonner",
      0.0475
    ],
    [
      "tanner",
      0.04
    ],
    [
      "ruiner",
      0.04
    ],
    [
      "lasser",
      0.0275
    ],
    [
      "froler",
      0.0275
    ],
    [
      "enquiquiner",
      0.0275
    ],
    [
      "endormir",
      0.0275
    ],
    [
      "abattre",
      0.0275
    ],
    [
      "embeter",
      0.0225
    ],
    [
      "depouiller",
      0.0225
    ],
    [
      "bassiner",
      0.0225
    ],
    [
      "effleurer",
      0.0175
    ],
    [
      "plumer",
      0.0175
    ],
    [
      "serrer",
      0.0175
    ],
    [
      "etourdir",
      0.0175
    ],
    [
      "friser",
      0.01
    ],
    [
      "peler",
      0.01
    ],
    [
      "ratisser",
      0.01
    ],
    [
      "tondre",
      0.01
    ],
    [
      "egaliser",
      0.01
    ],
    [
      "devaster",
      0.01
    ],
    [
      "achever",
      0.01
    ],
    [
      "couper",
      0.01
    ],
    [
      "cotoyer",
      0.01
    ],
    [
      "demolir",
      0.01
    ],
    [
      "detruire",
      0.01
    ],
    [
      "tonsurer",
      0.005
    ],
    [
      "s'approcher",
      0.005
    ],
    [
      "ratiboiser",
      0.005
    ],
    [
      "longer",
      0.005
    ],
    [
      "demanteler",
      0.005
    ],
    [
      "cavaler",
      0.005
    ],
    [
      "caresser",
      0.005
    ],
    [
      "canuler",
      0.005
    ],
    [
      "barbifier",
      0.005
    ],
    [
      "araser",
      0.005
    ],
    [
      "epiler",
      0.005
    ]
  ],
  "echarper": [
    [
      "couper",
      0.13
    ],
    [
      "taillader",
      0.1075
    ],
    [
      "blesser",
      0.085
    ],
    [
      "dechiqueter",
      0.085
    ],
    [
      "tailler",
      0.085
    ],
    [
      "battre",
      0.065
    ],
    [
      "entailler",
      0.065
    ],
    [
      "vaincre",
      0.0425
    ],
    [
      "mutiler",
      0.0425
    ],
    [
      "massacrer",
      0.0425
    ],
    [
      "charcuter",
      0.0425
    ],
    [
      "balafrer",
      0.0425
    ],
    [
      "hacher",
      0.02
    ],
    [
      "lapider",
      0.02
    ],
    [
      "lyncher",
      0.02
    ],
    [
      "triompher",
      0.02
    ],
    [
      "echarpiller",
      0.02
    ]
  ],
  "echarpe": [
    [
      "fichu",
      0.165
    ],
    [
      "carre",
      0.1
    ],
    [
      "foulard",
      0.1
    ],
    [
      "pointe",
      0.065
    ],
    [
      "mantille",
      0.065
    ],
    [
      "bande",
      0.065
    ],
    [
      "ephod",
      0.0325
    ],
    [
      "voile",
      0.0325
    ],
    [
      "insigne",
      0.0325
    ],
    [
      "herpe",
      0.0325
    ],
    [
      "guimpe",
      0.0325
    ],
    [
      "chale",
      0.0325
    ],
    [
      "ceinture",
      0.0325
    ],
    [
      "boa",
      0.0325
    ],
    [
      "bandage",
      0.0325
    ],
    [
      "etole",
      0.0325
    ]
  ],
  "migraine": [
    [
      "cephalee",
      0.4
    ],
    [
      "hemicranie",
      0.2
    ],
    [
      "cephalalgie",
      0.1
    ],
    [
      "encephalalgie",
      0.1
    ],
    [
      "hemialgie",
      0.1
    ]
  ],
  "tibia": [],
  "attenter": [
    [
      "entreprendre",
      1.0
    ]
  ],
  "clamser": [
    [
      "mourir",
      0.3325
    ],
    [
      "crever",
      0.22
    ],
    [
      "succomber",
      0.22
    ],
    [
      "calancher",
      0.11
    ],
    [
      "claboter",
      0.11
    ]
  ],
  "pilote": [
    [
      "nautonier",
      0.2425
    ],
    [
      "conducteur",
      0.065
    ],
    [
      "directeur",
      0.065
    ],
    [
      "guide",
      0.065
    ],
    [
      "navigateur",
      0.065
    ],
    [
      "responsable",
      0.0425
    ],
    [
      "meneur",
      0.0425
    ],
    [
      "leader",
      0.0425
    ],
    [
      "capitaine",
      0.0425
    ],
    [
      "stratege",
      0.02
    ],
    [
      "nocher",
      0.02
    ],
    [
      "mentor",
      0.02
    ],
    [
      "locman",
      0.02
    ],
    [
      "lamaneur",
      0.02
    ],
    [
      "copilote",
      0.02
    ],
    [
      "commandant",
      0.02
    ],
    [
      "cicerone",
      0.02
    ],
    [
      "chauffeur",
      0.02
    ],
    [
      "batelier",
      0.02
    ],
    [
      "barreur",
      0.02
    ],
    [
      "aviateur",
      0.02
    ],
    [
      "timonier",
      0.02
    ]
  ],
  "piloter": [
    [
      "conduire",
      0.165
    ],
    [
      "diriger",
      0.165
    ],
    [
      "guider",
      0.1325
    ],
    [
      "gouverner",
      0.1
    ],
    [
      "manoeuvrer",
      0.1
    ],
    [
      "mener",
      0.1
    ],
    [
      "regenter",
      0.0325
    ],
    [
      "promener",
      0.0325
    ],
    [
      "orienter",
      0.0325
    ],
    [
      "naviguer",
      0.0325
    ],
    [
      "cornaquer",
      0.0325
    ],
    [
      "chaperonner",
      0.0325
    ],
    [
      "telecommander",
      0.0325
    ]
  ],
  "catcheur": [
    [
      "lutteur",
      0.5
    ],
    [
      "pugiliste",
      0.5
    ]
  ],
  "skieur": [],
  "alpin": [
    [
      "alpestre",
      0.5
    ],
    [
      "alpicole",
      0.5
    ]
  ],
  "dresseur": [
    [
      "dompteur",
      0.5
    ],
    [
      "saltimbanque",
      0.5
    ]
  ],
  "obstetricien": [
    [
      "accoucheur",
      1.0
    ]
  ],
  "junte": [
    [
      "assemblee",
      1.0
    ]
  ],
  "anecdote": [
    [
      "conte",
      0.1275
    ],
    [
      "bruit",
      0.11
    ],
    [
      "histoire",
      0.11
    ],
    [
      "fable",
      0.095
    ],
    [
      "potin",
      0.0775
    ],
    [
      "nouvelle",
      0.0775
    ],
    [
      "recit",
      0.0625
    ],
    [
      "bavardage",
      0.0475
    ],
    [
      "echo",
      0.0475
    ],
    [
      "narration",
      0.03
    ],
    [
      "medisance",
      0.03
    ],
    [
      "historiette",
      0.03
    ],
    [
      "feuilleton",
      0.03
    ],
    [
      "bagou",
      0.015
    ],
    [
      "fait",
      0.015
    ],
    [
      "intrigue",
      0.015
    ],
    [
      "particularite",
      0.015
    ]
  ],
  "chasseur": [
    [
      "coursier",
      0.07
    ],
    [
      "groom",
      0.07
    ],
    [
      "serviteur",
      0.07
    ],
    [
      "nemrod",
      0.035
    ],
    [
      "piqueur",
      0.035
    ],
    [
      "pisteur",
      0.035
    ],
    [
      "portier",
      0.035
    ],
    [
      "poursuiveur",
      0.035
    ],
    [
      "queteur",
      0.035
    ],
    [
      "rabatteur",
      0.035
    ],
    [
      "trappeur",
      0.035
    ],
    [
      "traqueur",
      0.035
    ],
    [
      "giboyeur",
      0.035
    ],
    [
      "garcon",
      0.035
    ],
    [
      "fauconnier",
      0.035
    ],
    [
      "boucanier",
      0.035
    ],
    [
      "boucher",
      0.035
    ],
    [
      "braconnier",
      0.035
    ],
    [
      "carabinier",
      0.035
    ],
    [
      "cavalier",
      0.035
    ],
    [
      "colleteur",
      0.035
    ],
    [
      "commissionnaire",
      0.035
    ],
    [
      "domestique",
      0.035
    ],
    [
      "veneur",
      0.035
    ]
  ],
  "repousse": [
    [
      "rejeter",
      0.085
    ],
    [
      "chasser",
      0.0725
    ],
    [
      "refuser",
      0.055
    ],
    [
      "renvoyer",
      0.05
    ],
    [
      "eloigner",
      0.045
    ],
    [
      "exclure",
      0.0375
    ],
    [
      "eliminer",
      0.0375
    ],
    [
      "ecarter",
      0.03
    ],
    [
      "pousser",
      0.0275
    ],
    [
      "remettre",
      0.025
    ],
    [
      "expulser",
      0.0225
    ],
    [
      "bannir",
      0.02
    ],
    [
      "reculer",
      0.02
    ],
    [
      "refouler",
      0.02
    ],
    [
      "s'opposer",
      0.0175
    ],
    [
      "abandonner",
      0.015
    ],
    [
      "evincer",
      0.015
    ],
    [
      "rembarrer",
      0.0125
    ],
    [
      "rebuter",
      0.0125
    ],
    [
      "jeter",
      0.0125
    ],
    [
      "balayer",
      0.0125
    ],
    [
      "ajourner",
      0.0125
    ],
    [
      "econduire",
      0.01
    ],
    [
      "repugner",
      0.01
    ],
    [
      "retarder",
      0.01
    ],
    [
      "reconduire",
      0.01
    ],
    [
      "rabrouer",
      0.01
    ],
    [
      "proscrire",
      0.01
    ],
    [
      "detruire",
      0.01
    ],
    [
      "differer",
      0.01
    ],
    [
      "proroger",
      0.0075
    ],
    [
      "revenir",
      0.0075
    ],
    [
      "recuser",
      0.0075
    ],
    [
      "refuter",
      0.0075
    ],
    [
      "repudier",
      0.0075
    ],
    [
      "temporiser",
      0.0075
    ],
    [
      "etendre",
      0.0075
    ],
    [
      "excommunier",
      0.0075
    ],
    [
      "bousculer",
      0.0075
    ],
    [
      "culbuter",
      0.0075
    ],
    [
      "dissiper",
      0.0075
    ],
    [
      "debouter",
      0.0075
    ],
    [
      "decliner",
      0.0075
    ],
    [
      "degouter",
      0.0075
    ],
    [
      "remplacer",
      0.0025
    ],
    [
      "reporter",
      0.0025
    ],
    [
      "riposter",
      0.0025
    ],
    [
      "resister",
      0.0025
    ],
    [
      "supplanter",
      0.0025
    ],
    [
      "suspendre",
      0.0025
    ],
    [
      "ejecter",
      0.0025
    ],
    [
      "rabattre",
      0.0025
    ],
    [
      "ostraciser",
      0.0025
    ],
    [
      "objecter",
      0.0025
    ],
    [
      "allonger",
      0.0025
    ],
    [
      "blackbouler",
      0.0025
    ],
    [
      "bouter",
      0.0025
    ],
    [
      "contrarier",
      0.0025
    ],
    [
      "dedaigner",
      0.0025
    ],
    [
      "deplaire",
      0.0025
    ],
    [
      "moucher",
      0.0025
    ],
    [
      "rechasser",
      0.0
    ],
    [
      "remiser",
      0.0
    ],
    [
      "remonter",
      0.0
    ],
    [
      "remoucher",
      0.0
    ],
    [
      "renaitre",
      0.0
    ],
    [
      "rencogner",
      0.0
    ],
    [
      "rebuffer",
      0.0
    ],
    [
      "mepriser",
      0.0
    ],
    [
      "execrer",
      0.0
    ],
    [
      "emballer",
      0.0
    ],
    [
      "bouler",
      0.0
    ],
    [
      "ecoeurer",
      0.0
    ]
  ],
  "helicoptere": [
    [
      "giravion",
      0.25
    ],
    [
      "alouette",
      0.125
    ],
    [
      "autogire",
      0.125
    ],
    [
      "banane",
      0.125
    ],
    [
      "girodyne",
      0.125
    ],
    [
      "helico",
      0.125
    ],
    [
      "heligrue",
      0.125
    ]
  ],
  "avalanche": [
    [
      "deluge",
      0.13
    ],
    [
      "flot",
      0.105
    ],
    [
      "multitude",
      0.105
    ],
    [
      "pluie",
      0.105
    ],
    [
      "quantite",
      0.0925
    ],
    [
      "affluence",
      0.0525
    ],
    [
      "cataracte",
      0.0525
    ],
    [
      "kyrielle",
      0.0375
    ],
    [
      "grele",
      0.0375
    ],
    [
      "debordement",
      0.0375
    ],
    [
      "chute",
      0.0375
    ],
    [
      "torrent",
      0.025
    ],
    [
      "nuee",
      0.025
    ],
    [
      "inondation",
      0.025
    ],
    [
      "cascade",
      0.025
    ],
    [
      "averse",
      0.025
    ],
    [
      "lavanche",
      0.0125
    ],
    [
      "orage",
      0.0125
    ],
    [
      "pelletee",
      0.0125
    ],
    [
      "potee",
      0.0125
    ],
    [
      "eboulement",
      0.0125
    ]
  ],
  "tong": [],
  "haltere": [],
  "bambou": [
    [
      "canne",
      1.0
    ]
  ],
  "parait": [
    [
      "orner",
      0.12
    ],
    [
      "embellir",
      0.0625
    ],
    [
      "attifer",
      0.0525
    ],
    [
      "habiller",
      0.0475
    ],
    [
      "imager",
      0.0475
    ],
    [
      "garnir",
      0.04
    ],
    [
      "arranger",
      0.035
    ],
    [
      "remedier",
      0.025
    ],
    [
      "enjoliver",
      0.025
    ],
    [
      "decorer",
      0.025
    ],
    [
      "ajuster",
      0.0225
    ],
    [
      "farder",
      0.0225
    ],
    [
      "revetir",
      0.0225
    ],
    [
      "eviter",
      0.0225
    ],
    [
      "prevenir",
      0.015
    ],
    [
      "preserver",
      0.015
    ],
    [
      "pourvoir",
      0.015
    ],
    [
      "entourer",
      0.015
    ],
    [
      "enrichir",
      0.015
    ],
    [
      "agrementer",
      0.015
    ],
    [
      "preparer",
      0.0125
    ],
    [
      "proteger",
      0.0125
    ],
    [
      "pomponner",
      0.0125
    ],
    [
      "pallier",
      0.0125
    ],
    [
      "obvier",
      0.0125
    ],
    [
      "detourner",
      0.0125
    ],
    [
      "colorer",
      0.0125
    ],
    [
      "accoutrer",
      0.0125
    ],
    [
      "historier",
      0.0075
    ],
    [
      "ornementer",
      0.0075
    ],
    [
      "renforcer",
      0.0075
    ],
    [
      "veiller",
      0.0075
    ],
    [
      "egayer",
      0.0075
    ],
    [
      "broder",
      0.0075
    ],
    [
      "bichonner",
      0.0075
    ],
    [
      "accommoder",
      0.0075
    ],
    [
      "adorner",
      0.0075
    ],
    [
      "appreter",
      0.0075
    ],
    [
      "aureoler",
      0.0075
    ],
    [
      "aviser",
      0.0075
    ],
    [
      "perfectionner",
      0.0025
    ],
    [
      "plumer",
      0.0025
    ],
    [
      "poupiner",
      0.0025
    ],
    [
      "retenir",
      0.0025
    ],
    [
      "teinter",
      0.0025
    ],
    [
      "vider",
      0.0025
    ],
    [
      "nimber",
      0.0025
    ],
    [
      "garantir",
      0.0025
    ],
    [
      "adoniser",
      0.0025
    ],
    [
      "afistoler",
      0.0025
    ],
    [
      "chamarrer",
      0.0025
    ],
    [
      "conjurer",
      0.0025
    ],
    [
      "doubler",
      0.0025
    ],
    [
      "empanacher",
      0.0025
    ],
    [
      "endimancher",
      0.0025
    ],
    [
      "esquiver",
      0.0025
    ],
    [
      "ferrer",
      0.0025
    ],
    [
      "fleurir",
      0.0025
    ],
    [
      "emailler",
      0.0025
    ]
  ],
  "appele": [
    [
      "provoquer",
      0.055
    ],
    [
      "entrainer",
      0.045
    ],
    [
      "pousser",
      0.04
    ],
    [
      "determiner",
      0.0375
    ],
    [
      "exciter",
      0.0375
    ],
    [
      "demander",
      0.0325
    ],
    [
      "attirer",
      0.03
    ],
    [
      "crier",
      0.03
    ],
    [
      "engager",
      0.03
    ],
    [
      "reclamer",
      0.0275
    ],
    [
      "inviter",
      0.0275
    ],
    [
      "amener",
      0.025
    ],
    [
      "citer",
      0.025
    ],
    [
      "soulever",
      0.025
    ],
    [
      "solliciter",
      0.0225
    ],
    [
      "inciter",
      0.0225
    ],
    [
      "designer",
      0.02
    ],
    [
      "nommer",
      0.02
    ],
    [
      "susciter",
      0.02
    ],
    [
      "requerir",
      0.0175
    ],
    [
      "prier",
      0.0175
    ],
    [
      "occasionner",
      0.0175
    ],
    [
      "convier",
      0.0175
    ],
    [
      "commander",
      0.015
    ],
    [
      "convoquer",
      0.015
    ],
    [
      "implorer",
      0.015
    ],
    [
      "necessiter",
      0.015
    ],
    [
      "evoquer",
      0.015
    ],
    [
      "souhaiter",
      0.01
    ],
    [
      "qualifier",
      0.01
    ],
    [
      "assigner",
      0.01
    ],
    [
      "supplier",
      0.0075
    ],
    [
      "motiver",
      0.0075
    ],
    [
      "mander",
      0.0075
    ],
    [
      "invoquer",
      0.0075
    ],
    [
      "interpeller",
      0.0075
    ],
    [
      "exiger",
      0.0075
    ],
    [
      "elire",
      0.005
    ],
    [
      "predestiner",
      0.005
    ],
    [
      "heler",
      0.005
    ],
    [
      "exhorter",
      0.005
    ],
    [
      "desirer",
      0.005
    ],
    [
      "choisir",
      0.005
    ],
    [
      "apporter",
      0.005
    ],
    [
      "hucher",
      0.0025
    ],
    [
      "mobiliser",
      0.0025
    ],
    [
      "predisposer",
      0.0025
    ],
    [
      "rappeler",
      0.0025
    ],
    [
      "signaler",
      0.0025
    ],
    [
      "traduire",
      0.0025
    ],
    [
      "traiter",
      0.0025
    ],
    [
      "gemir",
      0.0025
    ],
    [
      "denommer",
      0.0025
    ],
    [
      "adjurer",
      0.0025
    ],
    [
      "ameuter",
      0.0025
    ],
    [
      "aspirer",
      0.0025
    ],
    [
      "avertir",
      0.0025
    ],
    [
      "baptiser",
      0.0025
    ],
    [
      "destiner",
      0.0025
    ],
    [
      "protester",
      0.0
    ],
    [
      "preceder",
      0.0
    ],
    [
      "prenommer",
      0.0
    ],
    [
      "preter",
      0.0
    ],
    [
      "siffler",
      0.0
    ],
    [
      "sonner",
      0.0
    ],
    [
      "surnommer",
      0.0
    ],
    [
      "telephoner",
      0.0
    ],
    [
      "meriter",
      0.0
    ],
    [
      "apostropher",
      0.0
    ],
    [
      "beugler",
      0.0
    ],
    [
      "beler",
      0.0
    ],
    [
      "coopter",
      0.0
    ],
    [
      "defier",
      0.0
    ],
    [
      "fasciner",
      0.0
    ],
    [
      "houper",
      0.0
    ],
    [
      "incorporer",
      0.0
    ],
    [
      "intituler",
      0.0
    ],
    [
      "vouer",
      0.0
    ]
  ],
  "raisonner": [
    [
      "examiner",
      0.0975
    ],
    [
      "discuter",
      0.085
    ],
    [
      "mediter",
      0.0725
    ],
    [
      "penser",
      0.06
    ],
    [
      "philosopher",
      0.06
    ],
    [
      "reflechir",
      0.06
    ],
    [
      "etudier",
      0.06
    ],
    [
      "eplucher",
      0.035
    ],
    [
      "disputer",
      0.035
    ],
    [
      "analyser",
      0.035
    ],
    [
      "traiter",
      0.0225
    ],
    [
      "speculer",
      0.0225
    ],
    [
      "ratiociner",
      0.0225
    ],
    [
      "inferer",
      0.0225
    ],
    [
      "induire",
      0.0225
    ],
    [
      "ergoter",
      0.0225
    ],
    [
      "deduire",
      0.0225
    ],
    [
      "conduire",
      0.0225
    ],
    [
      "cogiter",
      0.0225
    ],
    [
      "argumenter",
      0.0225
    ],
    [
      "repliquer",
      0.01
    ],
    [
      "repondre",
      0.01
    ],
    [
      "sophistiquer",
      0.01
    ],
    [
      "palabrer",
      0.01
    ],
    [
      "juger",
      0.01
    ],
    [
      "decortiquer",
      0.01
    ],
    [
      "converser",
      0.01
    ],
    [
      "calculer",
      0.01
    ],
    [
      "admonester",
      0.01
    ],
    [
      "eprouver",
      0.01
    ]
  ],
  "cradoque": [
    [
      "cracra",
      1.0
    ]
  ],
  "loque": [
    [
      "guenille",
      0.1925
    ],
    [
      "chiffon",
      0.1525
    ],
    [
      "haillon",
      0.1525
    ],
    [
      "debris",
      0.075
    ],
    [
      "lambeau",
      0.075
    ],
    [
      "serpilliere",
      0.0375
    ],
    [
      "ruine",
      0.0375
    ],
    [
      "piece",
      0.0375
    ],
    [
      "penaillon",
      0.0375
    ],
    [
      "penaille",
      0.0375
    ],
    [
      "fragment",
      0.0375
    ],
    [
      "defroque",
      0.0375
    ],
    [
      "chiffe",
      0.0375
    ],
    [
      "epave",
      0.0375
    ]
  ],
  "flip": [
    [
      "deprime",
      1.0
    ]
  ],
  "degainer": [
    [
      "defourailler",
      0.25
    ],
    [
      "degager",
      0.25
    ],
    [
      "tirer",
      0.25
    ]
  ],
  "degaine": [
    [
      "allure",
      0.145
    ],
    [
      "air",
      0.105
    ],
    [
      "comportement",
      0.105
    ],
    [
      "genre",
      0.0925
    ],
    [
      "attitude",
      0.0775
    ],
    [
      "maintien",
      0.065
    ],
    [
      "demarche",
      0.065
    ],
    [
      "touche",
      0.0525
    ],
    [
      "type",
      0.0375
    ],
    [
      "port",
      0.0375
    ],
    [
      "facon",
      0.0375
    ],
    [
      "conduite",
      0.0375
    ],
    [
      "contenance",
      0.025
    ],
    [
      "gueule",
      0.025
    ],
    [
      "look",
      0.025
    ],
    [
      "convenance",
      0.0125
    ],
    [
      "demande",
      0.0125
    ],
    [
      "frime",
      0.0125
    ],
    [
      "silhouette",
      0.0125
    ]
  ],
  "henne": [],
  "percee": [
    [
      "transpercer",
      0.075
    ],
    [
      "penetrer",
      0.045
    ],
    [
      "paraitre",
      0.04
    ],
    [
      "poindre",
      0.0375
    ],
    [
      "reperer",
      0.0325
    ],
    [
      "decouvrir",
      0.0325
    ],
    [
      "ouvrir",
      0.0225
    ],
    [
      "saisir",
      0.0225
    ],
    [
      "surgir",
      0.0225
    ],
    [
      "piquer",
      0.0225
    ],
    [
      "dechirer",
      0.0225
    ],
    [
      "creuser",
      0.0175
    ],
    [
      "emerger",
      0.0175
    ],
    [
      "trouer",
      0.0175
    ],
    [
      "sortir",
      0.0175
    ],
    [
      "passer",
      0.0175
    ],
    [
      "naitre",
      0.0175
    ],
    [
      "transpirer",
      0.015
    ],
    [
      "sourdre",
      0.015
    ],
    [
      "pointer",
      0.015
    ],
    [
      "enfoncer",
      0.015
    ],
    [
      "crever",
      0.015
    ],
    [
      "arriver",
      0.015
    ],
    [
      "voir",
      0.0125
    ],
    [
      "traverser",
      0.0125
    ],
    [
      "reveler",
      0.0125
    ],
    [
      "marquer",
      0.0125
    ],
    [
      "eclore",
      0.01
    ],
    [
      "trouver",
      0.01
    ],
    [
      "forer",
      0.01
    ],
    [
      "entamer",
      0.01
    ],
    [
      "comprendre",
      0.01
    ],
    [
      "blesser",
      0.01
    ],
    [
      "atteindre",
      0.01
    ],
    [
      "sonder",
      0.0075
    ],
    [
      "s'elever",
      0.0075
    ],
    [
      "reussir",
      0.0075
    ],
    [
      "perforer",
      0.0075
    ],
    [
      "parvenir",
      0.0075
    ],
    [
      "fendre",
      0.0075
    ],
    [
      "deceler",
      0.0075
    ],
    [
      "tuer",
      0.005
    ],
    [
      "tarauder",
      0.005
    ],
    [
      "s'ouvrir",
      0.005
    ],
    [
      "rompre",
      0.005
    ],
    [
      "pressentir",
      0.005
    ],
    [
      "monter",
      0.005
    ],
    [
      "enfiler",
      0.005
    ],
    [
      "dechiffrer",
      0.005
    ],
    [
      "s'imposer",
      0.0025
    ],
    [
      "s'eventer",
      0.0025
    ],
    [
      "eventrer",
      0.0025
    ],
    [
      "prevoir",
      0.0025
    ],
    [
      "pratiquer",
      0.0025
    ],
    [
      "cribler",
      0.0025
    ],
    [
      "enfourcher",
      0.0025
    ],
    [
      "filtrer",
      0.0025
    ],
    [
      "frayer",
      0.0025
    ],
    [
      "lire",
      0.0025
    ],
    [
      "perler",
      0.0025
    ],
    [
      "poinconner",
      0.0025
    ],
    [
      "s'eveiller",
      0.0
    ],
    [
      "s'ebruiter",
      0.0
    ],
    [
      "s'ebaucher",
      0.0
    ],
    [
      "transparaitre",
      0.0
    ],
    [
      "tremper",
      0.0
    ],
    [
      "vriller",
      0.0
    ],
    [
      "ebraser",
      0.0
    ],
    [
      "etamper",
      0.0
    ],
    [
      "eventer",
      0.0
    ],
    [
      "s'infiltrer",
      0.0
    ],
    [
      "s'enfoncer",
      0.0
    ],
    [
      "aiguillonner",
      0.0
    ],
    [
      "aleser",
      0.0
    ],
    [
      "darder",
      0.0
    ],
    [
      "depister",
      0.0
    ],
    [
      "developper",
      0.0
    ],
    [
      "embrocher",
      0.0
    ],
    [
      "empaler",
      0.0
    ],
    [
      "encorner",
      0.0
    ],
    [
      "enferrer",
      0.0
    ],
    [
      "excaver",
      0.0
    ],
    [
      "fileter",
      0.0
    ],
    [
      "fusiller",
      0.0
    ],
    [
      "larder",
      0.0
    ],
    [
      "affleurer",
      0.0
    ]
  ],
  "paletot": [
    [
      "manteau",
      0.3325
    ],
    [
      "pardessus",
      0.3325
    ]
  ],
  "glande": [
    [
      "capsule",
      0.25
    ],
    [
      "mamelle",
      0.25
    ],
    [
      "sein",
      0.25
    ],
    [
      "tumeur",
      0.25
    ]
  ],
  "glander": [
    [
      "branler",
      0.3325
    ],
    [
      "glandouiller",
      0.3325
    ],
    [
      "musarder",
      0.3325
    ]
  ],
  "bourgeois": [
    [
      "commun",
      0.0675
    ],
    [
      "vulgaire",
      0.0675
    ],
    [
      "beotien",
      0.055
    ],
    [
      "trivial",
      0.055
    ],
    [
      "riche",
      0.04
    ],
    [
      "prosaique",
      0.04
    ],
    [
      "mediocre",
      0.04
    ],
    [
      "grossier",
      0.04
    ],
    [
      "etrique",
      0.0275
    ],
    [
      "epicier",
      0.0275
    ],
    [
      "profane",
      0.0275
    ],
    [
      "philistin",
      0.0275
    ],
    [
      "nanti",
      0.0275
    ],
    [
      "formaliste",
      0.0275
    ],
    [
      "patron",
      0.0125
    ],
    [
      "pantouflard",
      0.0125
    ],
    [
      "pante",
      0.0125
    ],
    [
      "moyen",
      0.0125
    ],
    [
      "moitie",
      0.0125
    ],
    [
      "policier",
      0.0125
    ],
    [
      "prevoyant",
      0.0125
    ],
    [
      "rentier",
      0.0125
    ],
    [
      "repu",
      0.0125
    ],
    [
      "roturier",
      0.0125
    ],
    [
      "singe",
      0.0125
    ],
    [
      "egoiste",
      0.0125
    ],
    [
      "elite",
      0.0125
    ],
    [
      "marchand",
      0.0125
    ],
    [
      "lourd",
      0.0125
    ],
    [
      "cadre",
      0.0125
    ],
    [
      "capitaliste",
      0.0125
    ],
    [
      "cave",
      0.0125
    ],
    [
      "citadin",
      0.0125
    ],
    [
      "civil",
      0.0125
    ],
    [
      "combourgeois",
      0.0125
    ],
    [
      "conformiste",
      0.0125
    ],
    [
      "confortable",
      0.0125
    ],
    [
      "conservateur",
      0.0125
    ],
    [
      "conventionnel",
      0.0125
    ],
    [
      "dirigeant",
      0.0125
    ],
    [
      "employeur",
      0.0125
    ],
    [
      "gouvernement",
      0.0125
    ],
    [
      "habitant",
      0.0125
    ],
    [
      "borne",
      0.0125
    ]
  ],
  "becheur": [
    [
      "orgueilleux",
      0.1075
    ],
    [
      "fier",
      0.09
    ],
    [
      "pretentieux",
      0.09
    ],
    [
      "suffisant",
      0.09
    ],
    [
      "vaniteux",
      0.09
    ],
    [
      "arrogant",
      0.0725
    ],
    [
      "craneur",
      0.0525
    ],
    [
      "hautain",
      0.0525
    ],
    [
      "snob",
      0.0525
    ],
    [
      "poseur",
      0.035
    ],
    [
      "important",
      0.035
    ],
    [
      "distant",
      0.035
    ],
    [
      "meprisant",
      0.0175
    ],
    [
      "medisant",
      0.0175
    ],
    [
      "jaloux",
      0.0175
    ],
    [
      "frimeur",
      0.0175
    ],
    [
      "faiseur",
      0.0175
    ],
    [
      "bucheur",
      0.0175
    ],
    [
      "bete",
      0.0175
    ],
    [
      "bosseur",
      0.0175
    ],
    [
      "aigri",
      0.0175
    ],
    [
      "peteux",
      0.0175
    ]
  ],
  "debarque": [
    [
      "renvoyer",
      0.13
    ],
    [
      "limoger",
      0.1175
    ],
    [
      "revoquer",
      0.09
    ],
    [
      "vider",
      0.09
    ],
    [
      "congedier",
      0.0775
    ],
    [
      "remercier",
      0.065
    ],
    [
      "destituer",
      0.065
    ],
    [
      "degommer",
      0.0525
    ],
    [
      "decharger",
      0.0375
    ],
    [
      "virer",
      0.025
    ],
    [
      "venir",
      0.025
    ],
    [
      "detroner",
      0.025
    ],
    [
      "deboulonner",
      0.025
    ],
    [
      "casser",
      0.025
    ],
    [
      "balancer",
      0.025
    ],
    [
      "saquer",
      0.0125
    ],
    [
      "liquider",
      0.0125
    ],
    [
      "deverser",
      0.0125
    ],
    [
      "demissionner",
      0.0125
    ],
    [
      "debarder",
      0.0125
    ],
    [
      "descendre",
      0.0125
    ],
    [
      "arriver",
      0.0125
    ],
    [
      "ecarter",
      0.0125
    ]
  ],
  "pouffiasse": [
    [
      "furie",
      0.165
    ],
    [
      "harengere",
      0.165
    ],
    [
      "megere",
      0.165
    ],
    [
      "virago",
      0.165
    ],
    [
      "grenadier",
      0.0825
    ],
    [
      "grognasse",
      0.0825
    ],
    [
      "prostituee",
      0.0825
    ],
    [
      "petasse",
      0.0825
    ]
  ],
  "culasse": [
    [
      "cul",
      1.0
    ]
  ],
  "nibard": [],
  "leopard": [
    [
      "fauve",
      0.5
    ],
    [
      "panthere",
      0.5
    ]
  ],
  "homologue": [
    [
      "confirmer",
      0.16
    ],
    [
      "ratifier",
      0.1275
    ],
    [
      "approuver",
      0.095
    ],
    [
      "autoriser",
      0.095
    ],
    [
      "enteriner",
      0.095
    ],
    [
      "valider",
      0.0625
    ],
    [
      "titulariser",
      0.0625
    ],
    [
      "sanctionner",
      0.0625
    ],
    [
      "enregistrer",
      0.0625
    ],
    [
      "accepter",
      0.03
    ],
    [
      "authentifier",
      0.03
    ],
    [
      "decider",
      0.03
    ],
    [
      "officialiser",
      0.03
    ],
    [
      "qualifier",
      0.03
    ]
  ],
  "homologuer": [
    [
      "confirmer",
      0.16
    ],
    [
      "ratifier",
      0.1275
    ],
    [
      "approuver",
      0.095
    ],
    [
      "autoriser",
      0.095
    ],
    [
      "enteriner",
      0.095
    ],
    [
      "valider",
      0.0625
    ],
    [
      "titulariser",
      0.0625
    ],
    [
      "sanctionner",
      0.0625
    ],
    [
      "enregistrer",
      0.0625
    ],
    [
      "accepter",
      0.03
    ],
    [
      "authentifier",
      0.03
    ],
    [
      "decider",
      0.03
    ],
    [
      "officialiser",
      0.03
    ],
    [
      "qualifier",
      0.03
    ]
  ],
  "skai": [
    [
      "similicuir",
      1.0
    ]
  ],
  "sacquer": [],
  "starlette": [],
  "blondasse": [
    [
      "blond",
      1.0
    ]
  ],
  "cognac": [
    [
      "brandy",
      0.3325
    ],
    [
      "fine",
      0.165
    ]
  ],
  "colback": [
    [
      "bonnet",
      1.0
    ]
  ],
  "gourer": [
    [
      "duper",
      0.5
    ],
    [
      "tromper",
      0.5
    ]
  ],
  "saloon": [
    [
      "bar",
      1.0
    ]
  ],
  "tilt": [],
  "comptoir": [
    [
      "bureau",
      0.09
    ],
    [
      "succursale",
      0.09
    ],
    [
      "etablissement",
      0.09
    ],
    [
      "zinc",
      0.06
    ],
    [
      "trust",
      0.06
    ],
    [
      "magasin",
      0.06
    ],
    [
      "depot",
      0.06
    ],
    [
      "cartel",
      0.06
    ],
    [
      "agence",
      0.06
    ],
    [
      "rade",
      0.03
    ],
    [
      "loge",
      0.03
    ],
    [
      "factorerie",
      0.03
    ],
    [
      "entente",
      0.03
    ],
    [
      "cooperative",
      0.03
    ],
    [
      "consortium",
      0.03
    ],
    [
      "colonie",
      0.03
    ],
    [
      "caisse",
      0.03
    ],
    [
      "cabaret",
      0.03
    ],
    [
      "bar",
      0.03
    ],
    [
      "banque",
      0.03
    ],
    [
      "table",
      0.03
    ]
  ],
  "intellectuel": [
    [
      "mental",
      0.1175
    ],
    [
      "psychique",
      0.1175
    ],
    [
      "spirituel",
      0.0575
    ],
    [
      "representatif",
      0.0575
    ],
    [
      "moral",
      0.0575
    ],
    [
      "mandarin",
      0.0575
    ],
    [
      "intello",
      0.0575
    ],
    [
      "intelligentsia",
      0.0575
    ],
    [
      "intellectif",
      0.0575
    ],
    [
      "ideologique",
      0.0575
    ],
    [
      "cerebral",
      0.0575
    ],
    [
      "conceptuel",
      0.0575
    ],
    [
      "clerc",
      0.0575
    ]
  ],
  "massacrer": [
    [
      "abimer",
      0.1125
    ],
    [
      "bousiller",
      0.0925
    ],
    [
      "tuer",
      0.0925
    ],
    [
      "detruire",
      0.0725
    ],
    [
      "gater",
      0.04
    ],
    [
      "gacher",
      0.04
    ],
    [
      "estropier",
      0.04
    ],
    [
      "esquinter",
      0.04
    ],
    [
      "demolir",
      0.04
    ],
    [
      "defigurer",
      0.04
    ],
    [
      "torcher",
      0.03
    ],
    [
      "saccager",
      0.03
    ],
    [
      "saboter",
      0.03
    ],
    [
      "deformer",
      0.03
    ],
    [
      "abattre",
      0.03
    ],
    [
      "echarper",
      0.02
    ],
    [
      "mutiler",
      0.02
    ],
    [
      "lapider",
      0.02
    ],
    [
      "immoler",
      0.02
    ],
    [
      "faucher",
      0.02
    ],
    [
      "exterminer",
      0.02
    ],
    [
      "decimer",
      0.02
    ],
    [
      "assassiner",
      0.02
    ],
    [
      "amocher",
      0.01
    ],
    [
      "bacler",
      0.01
    ],
    [
      "saloper",
      0.01
    ],
    [
      "tronquer",
      0.01
    ],
    [
      "egorger",
      0.01
    ]
  ],
  "sandwich": [
    [
      "repas",
      0.25
    ],
    [
      "tranche",
      0.25
    ]
  ],
  "baleze": [
    [
      "baraque",
      0.215
    ],
    [
      "fort",
      0.1725
    ],
    [
      "costaud",
      0.13
    ],
    [
      "hercule",
      0.085
    ],
    [
      "geant",
      0.085
    ],
    [
      "grand",
      0.085
    ]
  ],
  "vicelard": [
    [
      "malin",
      0.3325
    ],
    [
      "retors",
      0.3325
    ],
    [
      "vicieux",
      0.3325
    ]
  ],
  "exotique": [
    [
      "colonial",
      0.25
    ],
    [
      "depaysant",
      0.25
    ],
    [
      "etrange",
      0.25
    ],
    [
      "etranger",
      0.25
    ]
  ],
  "baie": [
    [
      "brun",
      1.0
    ]
  ],
  "semblable": [
    [
      "pareil",
      0.1025
    ],
    [
      "analogue",
      0.0925
    ],
    [
      "similaire",
      0.085
    ],
    [
      "identique",
      0.0725
    ],
    [
      "comparable",
      0.0675
    ],
    [
      "equivalent",
      0.045
    ],
    [
      "egal",
      0.045
    ],
    [
      "meme",
      0.04
    ],
    [
      "proche",
      0.0325
    ],
    [
      "voisin",
      0.0275
    ],
    [
      "approchant",
      0.0275
    ],
    [
      "assimile",
      0.0225
    ],
    [
      "conforme",
      0.0225
    ],
    [
      "frere",
      0.0225
    ],
    [
      "homologue",
      0.0225
    ],
    [
      "parent",
      0.0225
    ],
    [
      "prochain",
      0.0225
    ],
    [
      "tel",
      0.015
    ],
    [
      "parallele",
      0.015
    ],
    [
      "homogene",
      0.015
    ],
    [
      "contigu",
      0.015
    ],
    [
      "commun",
      0.015
    ],
    [
      "uniforme",
      0.01
    ],
    [
      "ressemblant",
      0.01
    ],
    [
      "pendant",
      0.01
    ],
    [
      "congenere",
      0.01
    ],
    [
      "adequat",
      0.01
    ],
    [
      "symetrique",
      0.005
    ],
    [
      "jumeau",
      0.005
    ],
    [
      "homme",
      0.005
    ],
    [
      "exact",
      0.005
    ],
    [
      "comme",
      0.005
    ],
    [
      "autrui",
      0.005
    ],
    [
      "assorti",
      0.005
    ],
    [
      "assimilable",
      0.005
    ],
    [
      "approximatif",
      0.005
    ],
    [
      "affin",
      0.005
    ]
  ],
  "etouffant": [
    [
      "accablant",
      0.1425
    ],
    [
      "suffocant",
      0.1425
    ],
    [
      "irrespirable",
      0.085
    ],
    [
      "lourd",
      0.085
    ],
    [
      "surchauffe",
      0.085
    ],
    [
      "torride",
      0.055
    ],
    [
      "pesant",
      0.055
    ],
    [
      "oppressant",
      0.055
    ],
    [
      "gros",
      0.055
    ],
    [
      "caniculaire",
      0.055
    ],
    [
      "asphyxiant",
      0.055
    ],
    [
      "fetide",
      0.0275
    ],
    [
      "grand",
      0.0275
    ],
    [
      "horrible",
      0.0275
    ],
    [
      "paralysant",
      0.0275
    ]
  ],
  "sien": [
    [
      "leur",
      1.0
    ]
  ],
  "societe": [
    [
      "association",
      0.1375
    ],
    [
      "groupe",
      0.0725
    ],
    [
      "reunion",
      0.0475
    ],
    [
      "bande",
      0.03
    ],
    [
      "assemblage",
      0.0275
    ],
    [
      "compagnie",
      0.025
    ],
    [
      "parti",
      0.025
    ],
    [
      "rassemblement",
      0.025
    ],
    [
      "troupe",
      0.0225
    ],
    [
      "peuple",
      0.0225
    ],
    [
      "clan",
      0.0225
    ],
    [
      "assemblee",
      0.02
    ],
    [
      "colonie",
      0.02
    ],
    [
      "communaute",
      0.02
    ],
    [
      "groupement",
      0.02
    ],
    [
      "trust",
      0.02
    ],
    [
      "organisation",
      0.0175
    ],
    [
      "monde",
      0.0175
    ],
    [
      "masse",
      0.015
    ],
    [
      "union",
      0.015
    ],
    [
      "coalition",
      0.0125
    ],
    [
      "famille",
      0.0125
    ],
    [
      "syndicat",
      0.0125
    ],
    [
      "tribu",
      0.01
    ],
    [
      "nation",
      0.01
    ],
    [
      "ligue",
      0.01
    ],
    [
      "entourage",
      0.01
    ],
    [
      "corps",
      0.01
    ],
    [
      "congregation",
      0.01
    ],
    [
      "cartel",
      0.01
    ],
    [
      "etablissement",
      0.0075
    ],
    [
      "pool",
      0.0075
    ],
    [
      "institut",
      0.0075
    ],
    [
      "federation",
      0.0075
    ],
    [
      "entreprise",
      0.0075
    ],
    [
      "corporation",
      0.0075
    ],
    [
      "consortium",
      0.0075
    ],
    [
      "classe",
      0.0075
    ],
    [
      "cercle",
      0.0075
    ],
    [
      "public",
      0.005
    ],
    [
      "milieu",
      0.005
    ],
    [
      "humanite",
      0.005
    ],
    [
      "confrerie",
      0.005
    ],
    [
      "collectivite",
      0.005
    ],
    [
      "affaire",
      0.005
    ],
    [
      "cooperation",
      0.0025
    ],
    [
      "culture",
      0.0025
    ],
    [
      "frequentation",
      0.0025
    ],
    [
      "holding",
      0.0025
    ],
    [
      "homme",
      0.0025
    ],
    [
      "etat",
      0.0025
    ],
    [
      "constitution",
      0.0025
    ],
    [
      "commerce",
      0.0025
    ],
    [
      "aristocratie",
      0.0025
    ],
    [
      "boite",
      0.0025
    ],
    [
      "caste",
      0.0025
    ],
    [
      "civilisation",
      0.0025
    ],
    [
      "club",
      0.0025
    ],
    [
      "gratin",
      0.0
    ],
    [
      "hanse",
      0.0
    ],
    [
      "mutualite",
      0.0
    ],
    [
      "omnium",
      0.0
    ],
    [
      "relations",
      0.0
    ],
    [
      "religion",
      0.0
    ],
    [
      "sociabilite",
      0.0
    ],
    [
      "gentry",
      0.0
    ],
    [
      "firme",
      0.0
    ],
    [
      "corner",
      0.0
    ],
    [
      "cooperative",
      0.0
    ],
    [
      "contrat",
      0.0
    ],
    [
      "commandite",
      0.0
    ],
    [
      "accompagnement",
      0.0
    ],
    [
      "academie",
      0.0
    ]
  ],
  "definitivement": [
    [
      "irrevocablement",
      0.1175
    ],
    [
      "irremediablement",
      0.0575
    ],
    [
      "invariablement",
      0.0575
    ],
    [
      "finalement",
      0.0575
    ],
    [
      "decidement",
      0.0575
    ]
  ],
  "policeman": [
    [
      "policier",
      1.0
    ]
  ],
  "banque": [
    [
      "commerce",
      0.2
    ],
    [
      "banquette",
      0.1
    ],
    [
      "change",
      0.1
    ],
    [
      "comptoir",
      0.1
    ],
    [
      "finance",
      0.1
    ],
    [
      "levee",
      0.1
    ]
  ],
  "mitraillette": [
    [
      "P.M.",
      0.1425
    ],
    [
      "fusil",
      0.1425
    ],
    [
      "libouret",
      0.1425
    ],
    [
      "ligne",
      0.1425
    ],
    [
      "mitrailleuse",
      0.1425
    ]
  ],
  "attaque": [
    [
      "atteinte",
      0.06
    ],
    [
      "action",
      0.0525
    ],
    [
      "coup",
      0.0525
    ],
    [
      "choc",
      0.0475
    ],
    [
      "accusation",
      0.035
    ],
    [
      "agression",
      0.03
    ],
    [
      "assaut",
      0.03
    ],
    [
      "trait",
      0.025
    ],
    [
      "lutte",
      0.025
    ],
    [
      "guerre",
      0.025
    ],
    [
      "charge",
      0.025
    ],
    [
      "affaire",
      0.02
    ],
    [
      "entreprise",
      0.02
    ],
    [
      "querelle",
      0.02
    ],
    [
      "epreuve",
      0.015
    ],
    [
      "rencontre",
      0.015
    ],
    [
      "poussee",
      0.015
    ],
    [
      "invasion",
      0.015
    ],
    [
      "insulte",
      0.015
    ],
    [
      "attentat",
      0.015
    ],
    [
      "outrage",
      0.0125
    ],
    [
      "offensive",
      0.0125
    ],
    [
      "maladie",
      0.0125
    ],
    [
      "injure",
      0.0125
    ],
    [
      "descente",
      0.0125
    ],
    [
      "calomnie",
      0.0125
    ],
    [
      "approche",
      0.0125
    ],
    [
      "appel",
      0.0125
    ],
    [
      "algarade",
      0.0125
    ],
    [
      "feu",
      0.0075
    ],
    [
      "imputation",
      0.0075
    ],
    [
      "incursion",
      0.0075
    ],
    [
      "insinuation",
      0.0075
    ],
    [
      "moquerie",
      0.0075
    ],
    [
      "provocation",
      0.0075
    ],
    [
      "raid",
      0.0075
    ],
    [
      "sollicitation",
      0.0075
    ],
    [
      "denigrement",
      0.0075
    ],
    [
      "debat",
      0.0075
    ],
    [
      "diffamation",
      0.0075
    ],
    [
      "acces",
      0.0075
    ],
    [
      "affront",
      0.0075
    ],
    [
      "affrontement",
      0.0075
    ],
    [
      "altercation",
      0.0075
    ],
    [
      "apoplexie",
      0.0075
    ],
    [
      "avance",
      0.0075
    ],
    [
      "conquete",
      0.0075
    ],
    [
      "crise",
      0.0075
    ],
    [
      "invite",
      0.0025
    ],
    [
      "initiative",
      0.0025
    ],
    [
      "incrimination",
      0.0025
    ],
    [
      "ictus",
      0.0025
    ],
    [
      "feinte",
      0.0025
    ],
    [
      "irruption",
      0.0025
    ],
    [
      "morsure",
      0.0025
    ],
    [
      "paralysie",
      0.0025
    ],
    [
      "ruade",
      0.0025
    ],
    [
      "ruee",
      0.0025
    ],
    [
      "reprobation",
      0.0025
    ],
    [
      "siege",
      0.0025
    ],
    [
      "sortie",
      0.0025
    ],
    [
      "estocade",
      0.0025
    ],
    [
      "debut",
      0.0025
    ],
    [
      "abordage",
      0.0025
    ],
    [
      "allonge",
      0.0025
    ],
    [
      "alteration",
      0.0025
    ],
    [
      "amorce",
      0.0025
    ],
    [
      "argumentation",
      0.0025
    ],
    [
      "blame",
      0.0025
    ],
    [
      "botte",
      0.0025
    ],
    [
      "braquage",
      0.0025
    ],
    [
      "commencement",
      0.0025
    ],
    [
      "condamnation",
      0.0025
    ],
    [
      "congestion",
      0.0025
    ],
    [
      "destruction",
      0.0025
    ],
    [
      "diatribe",
      0.0025
    ],
    [
      "vol",
      0.0025
    ]
  ],
  "pendule": [
    [
      "horloge",
      0.3575
    ],
    [
      "regulateur",
      0.07
    ],
    [
      "pendulette",
      0.07
    ],
    [
      "oscillation",
      0.07
    ],
    [
      "coucou",
      0.07
    ],
    [
      "comtoise",
      0.07
    ],
    [
      "cartel",
      0.07
    ],
    [
      "carillon",
      0.07
    ],
    [
      "balancier",
      0.07
    ]
  ],
  "pic": [
    [
      "sommet",
      0.22
    ],
    [
      "aiguille",
      0.11
    ],
    [
      "pointe",
      0.11
    ],
    [
      "piton",
      0.0725
    ],
    [
      "mont",
      0.0725
    ],
    [
      "dent",
      0.0725
    ],
    [
      "rivelaine",
      0.035
    ],
    [
      "pivert",
      0.035
    ],
    [
      "pioche",
      0.035
    ],
    [
      "picot",
      0.035
    ],
    [
      "hauteur",
      0.035
    ],
    [
      "damette",
      0.035
    ],
    [
      "cime",
      0.035
    ],
    [
      "becquebois",
      0.035
    ],
    [
      "eminence",
      0.035
    ]
  ],
  "ding": [],
  "dong": [],
  "bloom": [
    [
      "blooming",
      1.0
    ]
  ],
  "astre": [
    [
      "planete",
      0.115
    ],
    [
      "etoile",
      0.115
    ],
    [
      "asterisme",
      0.075
    ],
    [
      "meteore",
      0.075
    ],
    [
      "luminaire",
      0.0375
    ],
    [
      "nebuleuse",
      0.0375
    ],
    [
      "satellite",
      0.0375
    ],
    [
      "signe",
      0.0375
    ],
    [
      "soleil",
      0.0375
    ],
    [
      "star",
      0.0375
    ],
    [
      "globe",
      0.0375
    ],
    [
      "galaxie",
      0.0375
    ],
    [
      "destinee",
      0.0375
    ],
    [
      "destin",
      0.0375
    ],
    [
      "constellation",
      0.0375
    ],
    [
      "comete",
      0.0375
    ],
    [
      "asteroide",
      0.0375
    ],
    [
      "asterie",
      0.0375
    ],
    [
      "ascendant",
      0.0375
    ],
    [
      "vedette",
      0.0375
    ]
  ],
  "aboi": [
    [
      "aboiement",
      0.2
    ],
    [
      "cri",
      0.2
    ],
    [
      "glapissement",
      0.2
    ],
    [
      "hurlement",
      0.2
    ],
    [
      "jappement",
      0.2
    ]
  ],
  "vaisselle": [
    [
      "contenant",
      0.22
    ],
    [
      "plat",
      0.22
    ],
    [
      "assiette",
      0.11
    ],
    [
      "plonge",
      0.11
    ],
    [
      "porcelaine",
      0.11
    ],
    [
      "poterie",
      0.11
    ],
    [
      "vaisseau",
      0.11
    ]
  ],
  "cric": [
    [
      "alcool",
      0.165
    ],
    [
      "cabestan",
      0.165
    ],
    [
      "levier",
      0.165
    ],
    [
      "treuil",
      0.165
    ],
    [
      "verin",
      0.165
    ]
  ],
  "crac": [
    [
      "boum",
      0.5
    ],
    [
      "krak",
      0.5
    ]
  ],
  "flac": [
    [
      "floc",
      0.3325
    ],
    [
      "plouf",
      0.3325
    ]
  ],
  "fauteuil": [
    [
      "siege",
      0.4275
    ],
    [
      "bergere",
      0.1425
    ],
    [
      "canape",
      0.1425
    ],
    [
      "place",
      0.1425
    ],
    [
      "sofa",
      0.1425
    ]
  ],
  "para": [
    [
      "orner",
      0.12
    ],
    [
      "embellir",
      0.0625
    ],
    [
      "attifer",
      0.0525
    ],
    [
      "habiller",
      0.0475
    ],
    [
      "imager",
      0.0475
    ],
    [
      "garnir",
      0.04
    ],
    [
      "arranger",
      0.035
    ],
    [
      "remedier",
      0.025
    ],
    [
      "enjoliver",
      0.025
    ],
    [
      "decorer",
      0.025
    ],
    [
      "ajuster",
      0.0225
    ],
    [
      "farder",
      0.0225
    ],
    [
      "revetir",
      0.0225
    ],
    [
      "eviter",
      0.0225
    ],
    [
      "prevenir",
      0.015
    ],
    [
      "preserver",
      0.015
    ],
    [
      "pourvoir",
      0.015
    ],
    [
      "entourer",
      0.015
    ],
    [
      "enrichir",
      0.015
    ],
    [
      "agrementer",
      0.015
    ],
    [
      "preparer",
      0.0125
    ],
    [
      "proteger",
      0.0125
    ],
    [
      "pomponner",
      0.0125
    ],
    [
      "pallier",
      0.0125
    ],
    [
      "obvier",
      0.0125
    ],
    [
      "detourner",
      0.0125
    ],
    [
      "colorer",
      0.0125
    ],
    [
      "accoutrer",
      0.0125
    ],
    [
      "historier",
      0.0075
    ],
    [
      "ornementer",
      0.0075
    ],
    [
      "renforcer",
      0.0075
    ],
    [
      "veiller",
      0.0075
    ],
    [
      "egayer",
      0.0075
    ],
    [
      "broder",
      0.0075
    ],
    [
      "bichonner",
      0.0075
    ],
    [
      "accommoder",
      0.0075
    ],
    [
      "adorner",
      0.0075
    ],
    [
      "appreter",
      0.0075
    ],
    [
      "aureoler",
      0.0075
    ],
    [
      "aviser",
      0.0075
    ],
    [
      "perfectionner",
      0.0025
    ],
    [
      "plumer",
      0.0025
    ],
    [
      "poupiner",
      0.0025
    ],
    [
      "retenir",
      0.0025
    ],
    [
      "teinter",
      0.0025
    ],
    [
      "vider",
      0.0025
    ],
    [
      "nimber",
      0.0025
    ],
    [
      "garantir",
      0.0025
    ],
    [
      "adoniser",
      0.0025
    ],
    [
      "afistoler",
      0.0025
    ],
    [
      "chamarrer",
      0.0025
    ],
    [
      "conjurer",
      0.0025
    ],
    [
      "doubler",
      0.0025
    ],
    [
      "empanacher",
      0.0025
    ],
    [
      "endimancher",
      0.0025
    ],
    [
      "esquiver",
      0.0025
    ],
    [
      "ferrer",
      0.0025
    ],
    [
      "fleurir",
      0.0025
    ],
    [
      "emailler",
      0.0025
    ]
  ],
  "madre": [
    [
      "malin",
      0.1075
    ],
    [
      "roublard",
      0.1075
    ],
    [
      "ruse",
      0.1075
    ],
    [
      "fute",
      0.09
    ],
    [
      "roue",
      0.09
    ],
    [
      "retors",
      0.06
    ],
    [
      "matois",
      0.06
    ],
    [
      "habile",
      0.045
    ],
    [
      "tortueux",
      0.045
    ],
    [
      "veine",
      0.03
    ],
    [
      "tache",
      0.03
    ],
    [
      "narquois",
      0.03
    ],
    [
      "marquete",
      0.03
    ],
    [
      "finaud",
      0.03
    ],
    [
      "ficelle",
      0.03
    ],
    [
      "combinard",
      0.03
    ],
    [
      "debrouillard",
      0.015
    ],
    [
      "normand",
      0.015
    ],
    [
      "tachete",
      0.015
    ],
    [
      "veineux",
      0.015
    ]
  ],
  "ave": [
    [
      "priere",
      1.0
    ]
  ],
  "inconsolable": [
    [
      "triste",
      0.4
    ],
    [
      "chagrin",
      0.2
    ],
    [
      "desespere",
      0.2
    ],
    [
      "eplore",
      0.2
    ]
  ],
  "indulgence": [
    [
      "bonte",
      0.1725
    ],
    [
      "bienveillance",
      0.095
    ],
    [
      "douceur",
      0.075
    ],
    [
      "grace",
      0.0625
    ],
    [
      "mansuetude",
      0.055
    ],
    [
      "facilite",
      0.0475
    ],
    [
      "humanite",
      0.0475
    ],
    [
      "complaisance",
      0.04
    ],
    [
      "charite",
      0.04
    ],
    [
      "clemence",
      0.0325
    ],
    [
      "pitie",
      0.0325
    ],
    [
      "gentillesse",
      0.025
    ],
    [
      "generosite",
      0.025
    ],
    [
      "misericorde",
      0.025
    ],
    [
      "tolerance",
      0.025
    ],
    [
      "mollesse",
      0.02
    ],
    [
      "comprehension",
      0.02
    ],
    [
      "patience",
      0.0125
    ],
    [
      "pardon",
      0.0125
    ],
    [
      "longanimite",
      0.0125
    ],
    [
      "gaterie",
      0.0125
    ],
    [
      "faveur",
      0.0125
    ],
    [
      "faiblesse",
      0.0125
    ],
    [
      "benignite",
      0.0125
    ],
    [
      "bonhomie",
      0.0125
    ],
    [
      "excuse",
      0.005
    ],
    [
      "exemption",
      0.005
    ],
    [
      "largeur",
      0.005
    ],
    [
      "magnanimite",
      0.005
    ],
    [
      "remission",
      0.005
    ]
  ],
  "lait": [
    [
      "boisson",
      1.0
    ]
  ],
  "isolement": [
    [
      "solitude",
      0.1725
    ],
    [
      "separation",
      0.0975
    ],
    [
      "abandon",
      0.0725
    ],
    [
      "reclusion",
      0.0725
    ],
    [
      "retranchement",
      0.0475
    ],
    [
      "internement",
      0.0475
    ],
    [
      "exil",
      0.0475
    ],
    [
      "delaissement",
      0.0475
    ],
    [
      "cloitre",
      0.0475
    ],
    [
      "claustration",
      0.0475
    ],
    [
      "sequestration",
      0.0225
    ],
    [
      "separatisme",
      0.0225
    ],
    [
      "quarantaine",
      0.0225
    ],
    [
      "isolationnisme",
      0.0225
    ],
    [
      "isolation",
      0.0225
    ],
    [
      "exclusion",
      0.0225
    ],
    [
      "esseulement",
      0.0225
    ],
    [
      "dereliction",
      0.0225
    ],
    [
      "autarcie",
      0.0225
    ],
    [
      "abandonnement",
      0.0225
    ],
    [
      "eloignement",
      0.0225
    ]
  ],
  "ohe": [
    [
      "oh",
      1.0
    ]
  ],
  "revolver": [
    [
      "pistolet",
      0.3125
    ],
    [
      "browning",
      0.125
    ],
    [
      "feu",
      0.125
    ],
    [
      "petard",
      0.125
    ],
    [
      "calibre",
      0.0625
    ],
    [
      "rif",
      0.0625
    ],
    [
      "rigolo",
      0.0625
    ],
    [
      "soufflant",
      0.0625
    ]
  ],
  "formica": [],
  "cine": [
    [
      "cinoche",
      0.3325
    ],
    [
      "cinema",
      0.3325
    ],
    [
      "kino",
      0.3325
    ]
  ],
  "machinal": [
    [
      "automatique",
      0.1575
    ],
    [
      "instinctif",
      0.1575
    ],
    [
      "involontaire",
      0.1575
    ],
    [
      "mecanique",
      0.105
    ],
    [
      "irreflechi",
      0.105
    ],
    [
      "inconscient",
      0.105
    ],
    [
      "brut",
      0.0525
    ],
    [
      "habituel",
      0.0525
    ],
    [
      "reflexe",
      0.0525
    ],
    [
      "spontane",
      0.0525
    ]
  ],
  "perdreau": [
    [
      "perdrix",
      0.3325
    ],
    [
      "policier",
      0.3325
    ],
    [
      "poulet",
      0.3325
    ]
  ],
  "tomme": [],
  "chevre": [
    [
      "cabri",
      0.1375
    ],
    [
      "bique",
      0.09
    ],
    [
      "biquet",
      0.09
    ],
    [
      "chevrette",
      0.09
    ],
    [
      "chevreau",
      0.045
    ],
    [
      "chevrillon",
      0.045
    ],
    [
      "derrick",
      0.045
    ],
    [
      "grue",
      0.045
    ],
    [
      "menon",
      0.045
    ],
    [
      "chevalet",
      0.045
    ],
    [
      "caprin",
      0.045
    ],
    [
      "cabre",
      0.045
    ],
    [
      "bouquetin",
      0.045
    ],
    [
      "bouc",
      0.045
    ],
    [
      "biquette",
      0.045
    ],
    [
      "bigue",
      0.045
    ],
    [
      "treuil",
      0.045
    ]
  ],
  "murette": [
    [
      "mur",
      0.3325
    ],
    [
      "muretin",
      0.3325
    ],
    [
      "parapet",
      0.3325
    ]
  ],
  "vigne": [
    [
      "clos",
      0.1675
    ],
    [
      "vignoble",
      0.1675
    ],
    [
      "treille",
      0.0825
    ],
    [
      "terre",
      0.0825
    ],
    [
      "raisin",
      0.0825
    ],
    [
      "plantation",
      0.0825
    ],
    [
      "pampre",
      0.0825
    ],
    [
      "lambrusque",
      0.0825
    ],
    [
      "cepage",
      0.0825
    ],
    [
      "villa",
      0.0825
    ]
  ],
  "horrible": [
    [
      "affreux",
      0.095
    ],
    [
      "repugnant",
      0.0525
    ],
    [
      "ignoble",
      0.05
    ],
    [
      "repoussant",
      0.05
    ],
    [
      "epouvantable",
      0.045
    ],
    [
      "odieux",
      0.045
    ],
    [
      "mauvais",
      0.045
    ],
    [
      "atroce",
      0.045
    ],
    [
      "abominable",
      0.04
    ],
    [
      "monstrueux",
      0.04
    ],
    [
      "degoutant",
      0.0375
    ],
    [
      "terrible",
      0.0375
    ],
    [
      "abject",
      0.0375
    ],
    [
      "laid",
      0.035
    ],
    [
      "hideux",
      0.0325
    ],
    [
      "infect",
      0.03
    ],
    [
      "effrayant",
      0.025
    ],
    [
      "execrable",
      0.0225
    ],
    [
      "effroyable",
      0.0175
    ],
    [
      "detestable",
      0.0175
    ],
    [
      "infame",
      0.015
    ],
    [
      "insupportable",
      0.015
    ],
    [
      "cruel",
      0.01
    ],
    [
      "nauseabond",
      0.0075
    ],
    [
      "extraordinaire",
      0.0075
    ],
    [
      "excessif",
      0.0075
    ],
    [
      "deplorable",
      0.0075
    ],
    [
      "degueulasse",
      0.0075
    ],
    [
      "feroce",
      0.0075
    ],
    [
      "miserable",
      0.0075
    ],
    [
      "terrifiant",
      0.0075
    ],
    [
      "vilain",
      0.0075
    ],
    [
      "sinistre",
      0.005
    ],
    [
      "revoltant",
      0.005
    ],
    [
      "moche",
      0.005
    ],
    [
      "intolerable",
      0.005
    ],
    [
      "nefaste",
      0.0025
    ],
    [
      "lamentable",
      0.0025
    ],
    [
      "inqualifiable",
      0.0025
    ],
    [
      "horrifiant",
      0.0025
    ],
    [
      "extreme",
      0.0025
    ],
    [
      "ahurissant",
      0.0
    ],
    [
      "assourdissant",
      0.0
    ],
    [
      "difforme",
      0.0
    ],
    [
      "satane",
      0.0
    ],
    [
      "etouffant",
      0.0
    ]
  ],
  "piquette": [
    [
      "marquer",
      0.135
    ],
    [
      "piquer",
      0.135
    ],
    [
      "tacheter",
      0.115
    ],
    [
      "pointiller",
      0.075
    ],
    [
      "tracer",
      0.075
    ],
    [
      "ponctuer",
      0.0575
    ],
    [
      "jalonner",
      0.0575
    ],
    [
      "baliser",
      0.0575
    ],
    [
      "reperer",
      0.0375
    ],
    [
      "picoter",
      0.0375
    ],
    [
      "parsemer",
      0.0375
    ],
    [
      "moucheter",
      0.0375
    ],
    [
      "ailler",
      0.0175
    ],
    [
      "aligner",
      0.0175
    ],
    [
      "borner",
      0.0175
    ],
    [
      "consteller",
      0.0175
    ],
    [
      "cribler",
      0.0175
    ],
    [
      "picter",
      0.0175
    ],
    [
      "pictonner",
      0.0175
    ]
  ],
  "centenaire": [
    [
      "vieux",
      0.3325
    ],
    [
      "antique",
      0.11
    ],
    [
      "aieul",
      0.11
    ],
    [
      "centennal",
      0.11
    ],
    [
      "seculaire",
      0.11
    ],
    [
      "vieillard",
      0.11
    ],
    [
      "veteran",
      0.11
    ]
  ],
  "centenaires": [
    [
      "vieux",
      0.3325
    ],
    [
      "antique",
      0.11
    ],
    [
      "aieul",
      0.11
    ],
    [
      "centennal",
      0.11
    ],
    [
      "seculaire",
      0.11
    ],
    [
      "vieillard",
      0.11
    ],
    [
      "veteran",
      0.11
    ]
  ],
  "hormone": [],
  "essentiel": [
    [
      "principal",
      0.0925
    ],
    [
      "primordial",
      0.0875
    ],
    [
      "fondamental",
      0.0675
    ],
    [
      "important",
      0.0675
    ],
    [
      "premier",
      0.055
    ],
    [
      "naturel",
      0.05
    ],
    [
      "capital",
      0.0425
    ],
    [
      "vital",
      0.0425
    ],
    [
      "necessaire",
      0.0375
    ],
    [
      "profond",
      0.0375
    ],
    [
      "majeur",
      0.03
    ],
    [
      "grand",
      0.03
    ],
    [
      "indispensable",
      0.025
    ],
    [
      "vrai",
      0.025
    ],
    [
      "substance",
      0.0175
    ],
    [
      "gros",
      0.0175
    ],
    [
      "fond",
      0.0175
    ],
    [
      "foncier",
      0.0175
    ],
    [
      "coeur",
      0.0175
    ],
    [
      "eminent",
      0.0125
    ],
    [
      "elementaire",
      0.0125
    ],
    [
      "primitif",
      0.0125
    ],
    [
      "point",
      0.0125
    ],
    [
      "maitre",
      0.0125
    ],
    [
      "intime",
      0.0125
    ],
    [
      "constitutif",
      0.0125
    ],
    [
      "caracteristique",
      0.0125
    ],
    [
      "absolu",
      0.0125
    ],
    [
      "noyau",
      0.005
    ],
    [
      "obligatoire",
      0.005
    ],
    [
      "rudiments",
      0.005
    ],
    [
      "revelateur",
      0.005
    ],
    [
      "spontane",
      0.005
    ],
    [
      "typique",
      0.005
    ],
    [
      "intrinseque",
      0.005
    ],
    [
      "inherent",
      0.005
    ],
    [
      "fait",
      0.005
    ],
    [
      "essence",
      0.005
    ],
    [
      "crucial",
      0.005
    ],
    [
      "central",
      0.005
    ],
    [
      "cardinal",
      0.005
    ],
    [
      "amande",
      0.005
    ],
    [
      "veritable",
      0.005
    ]
  ],
  "naufrage": [
    [
      "debacle",
      0.15
    ],
    [
      "perte",
      0.15
    ],
    [
      "ruine",
      0.15
    ],
    [
      "deconfiture",
      0.1
    ],
    [
      "ecroulement",
      0.1
    ],
    [
      "submersion",
      0.0475
    ],
    [
      "sinistre",
      0.0475
    ],
    [
      "perdition",
      0.0475
    ],
    [
      "effondrement",
      0.0475
    ],
    [
      "deroute",
      0.0475
    ],
    [
      "echec",
      0.0475
    ]
  ],
  "indiscrete": [
    [
      "importun",
      0.125
    ],
    [
      "fureteur",
      0.07
    ],
    [
      "raseur",
      0.07
    ],
    [
      "facheux",
      0.0425
    ],
    [
      "malavise",
      0.035
    ],
    [
      "impudent",
      0.035
    ],
    [
      "impertinent",
      0.035
    ],
    [
      "intrus",
      0.025
    ],
    [
      "inquisiteur",
      0.025
    ],
    [
      "inconvenant",
      0.025
    ],
    [
      "geneur",
      0.025
    ],
    [
      "genant",
      0.025
    ],
    [
      "deplace",
      0.025
    ],
    [
      "curieux",
      0.025
    ],
    [
      "bavard",
      0.025
    ],
    [
      "audacieux",
      0.025
    ],
    [
      "intempestif",
      0.0175
    ],
    [
      "imprudent",
      0.0175
    ],
    [
      "fouineur",
      0.0175
    ],
    [
      "envahissant",
      0.0175
    ],
    [
      "encombrant",
      0.0175
    ],
    [
      "bruyant",
      0.0175
    ],
    [
      "inquisitif",
      0.0075
    ],
    [
      "inquisitorial",
      0.0075
    ],
    [
      "inelegant",
      0.0075
    ],
    [
      "obsedant",
      0.0075
    ],
    [
      "tapageur",
      0.0075
    ],
    [
      "voyeur",
      0.0075
    ],
    [
      "inconsidere",
      0.0075
    ],
    [
      "immodere",
      0.0075
    ],
    [
      "cancanier",
      0.0075
    ],
    [
      "collant",
      0.0075
    ],
    [
      "commere",
      0.0075
    ],
    [
      "enquiquineur",
      0.0075
    ],
    [
      "espion",
      0.0075
    ],
    [
      "fouinard",
      0.0075
    ],
    [
      "hardi",
      0.0075
    ],
    [
      "ecouteur",
      0.0075
    ]
  ],
  "indiscret": [
    [
      "importun",
      0.125
    ],
    [
      "fureteur",
      0.07
    ],
    [
      "raseur",
      0.07
    ],
    [
      "facheux",
      0.0425
    ],
    [
      "malavise",
      0.035
    ],
    [
      "impudent",
      0.035
    ],
    [
      "impertinent",
      0.035
    ],
    [
      "intrus",
      0.025
    ],
    [
      "inquisiteur",
      0.025
    ],
    [
      "inconvenant",
      0.025
    ],
    [
      "geneur",
      0.025
    ],
    [
      "genant",
      0.025
    ],
    [
      "deplace",
      0.025
    ],
    [
      "curieux",
      0.025
    ],
    [
      "bavard",
      0.025
    ],
    [
      "audacieux",
      0.025
    ],
    [
      "intempestif",
      0.0175
    ],
    [
      "imprudent",
      0.0175
    ],
    [
      "fouineur",
      0.0175
    ],
    [
      "envahissant",
      0.0175
    ],
    [
      "encombrant",
      0.0175
    ],
    [
      "bruyant",
      0.0175
    ],
    [
      "inquisitif",
      0.0075
    ],
    [
      "inquisitorial",
      0.0075
    ],
    [
      "inelegant",
      0.0075
    ],
    [
      "obsedant",
      0.0075
    ],
    [
      "tapageur",
      0.0075
    ],
    [
      "voyeur",
      0.0075
    ],
    [
      "inconsidere",
      0.0075
    ],
    [
      "immodere",
      0.0075
    ],
    [
      "cancanier",
      0.0075
    ],
    [
      "collant",
      0.0075
    ],
    [
      "commere",
      0.0075
    ],
    [
      "enquiquineur",
      0.0075
    ],
    [
      "espion",
      0.0075
    ],
    [
      "fouinard",
      0.0075
    ],
    [
      "hardi",
      0.0075
    ],
    [
      "ecouteur",
      0.0075
    ]
  ],
  "haleine": [
    [
      "emanation",
      0.2
    ],
    [
      "souffle",
      0.1425
    ],
    [
      "exhalaison",
      0.1125
    ],
    [
      "vent",
      0.1125
    ],
    [
      "respiration",
      0.055
    ],
    [
      "odeur",
      0.055
    ],
    [
      "fumee",
      0.055
    ],
    [
      "fumet",
      0.055
    ],
    [
      "effluve",
      0.055
    ],
    [
      "anhelation",
      0.0275
    ],
    [
      "bouffee",
      0.0275
    ],
    [
      "brise",
      0.0275
    ],
    [
      "expiration",
      0.0275
    ],
    [
      "parfum",
      0.0275
    ]
  ],
  "paresser": [
    [
      "flaner",
      0.215
    ],
    [
      "faineanter",
      0.1425
    ],
    [
      "trainer",
      0.1425
    ],
    [
      "lezarder",
      0.07
    ],
    [
      "louper",
      0.07
    ],
    [
      "flemmarder",
      0.07
    ],
    [
      "caliner",
      0.07
    ],
    [
      "cagnarder",
      0.07
    ],
    [
      "trainasser",
      0.07
    ]
  ],
  "paresse": [
    [
      "indolence",
      0.145
    ],
    [
      "apathie",
      0.09
    ],
    [
      "torpeur",
      0.09
    ],
    [
      "mollesse",
      0.075
    ],
    [
      "nonchalance",
      0.0675
    ],
    [
      "engourdissement",
      0.055
    ],
    [
      "inaction",
      0.0475
    ],
    [
      "langueur",
      0.0475
    ],
    [
      "lenteur",
      0.04
    ],
    [
      "inertie",
      0.0325
    ],
    [
      "faineantise",
      0.0325
    ],
    [
      "assoupissement",
      0.0325
    ],
    [
      "alanguissement",
      0.0325
    ],
    [
      "atonie",
      0.0275
    ],
    [
      "flemme",
      0.02
    ],
    [
      "veulerie",
      0.0125
    ],
    [
      "oisivete",
      0.0125
    ],
    [
      "negligence",
      0.0125
    ],
    [
      "nonchaloir",
      0.0125
    ],
    [
      "lachete",
      0.0125
    ],
    [
      "cagnardise",
      0.0125
    ],
    [
      "peche",
      0.005
    ],
    [
      "neantise",
      0.005
    ],
    [
      "lourdeur",
      0.005
    ],
    [
      "lambinage",
      0.005
    ],
    [
      "inapplication",
      0.005
    ],
    [
      "flemmardise",
      0.005
    ],
    [
      "facilite",
      0.005
    ],
    [
      "desoeuvrement",
      0.005
    ],
    [
      "cosse",
      0.005
    ],
    [
      "rame",
      0.005
    ]
  ],
  "essai": [
    [
      "etude",
      0.0775
    ],
    [
      "esquisse",
      0.0625
    ],
    [
      "examen",
      0.05
    ],
    [
      "experience",
      0.05
    ],
    [
      "ebauche",
      0.05
    ],
    [
      "epreuve",
      0.05
    ],
    [
      "verification",
      0.0375
    ],
    [
      "traite",
      0.0375
    ],
    [
      "test",
      0.0375
    ],
    [
      "tentative",
      0.0375
    ],
    [
      "idee",
      0.0375
    ],
    [
      "experimentation",
      0.0375
    ],
    [
      "commencement",
      0.0375
    ],
    [
      "ouvrage",
      0.025
    ],
    [
      "memoire",
      0.025
    ],
    [
      "entreprise",
      0.025
    ],
    [
      "debut",
      0.025
    ],
    [
      "dissertation",
      0.025
    ],
    [
      "apprentissage",
      0.025
    ],
    [
      "apercu",
      0.025
    ],
    [
      "analyse",
      0.025
    ],
    [
      "melange",
      0.01
    ],
    [
      "pas",
      0.01
    ],
    [
      "preliminaire",
      0.01
    ],
    [
      "souvenir",
      0.01
    ],
    [
      "essayage",
      0.01
    ],
    [
      "effort",
      0.01
    ],
    [
      "degustation",
      0.01
    ],
    [
      "canevas",
      0.01
    ],
    [
      "but",
      0.01
    ],
    [
      "audition",
      0.01
    ],
    [
      "article",
      0.01
    ],
    [
      "tatonnement",
      0.01
    ]
  ],
  "fox": [],
  "menthe": [
    [
      "tisane",
      1.0
    ]
  ],
  "spot": [
    [
      "flash",
      0.5
    ],
    [
      "projecteur",
      0.5
    ]
  ],
  "meprise": [
    [
      "erreur",
      0.165
    ],
    [
      "bevue",
      0.11
    ],
    [
      "betise",
      0.0825
    ],
    [
      "faute",
      0.0825
    ],
    [
      "quiproquo",
      0.0825
    ],
    [
      "malentendu",
      0.055
    ],
    [
      "inattention",
      0.055
    ],
    [
      "inadvertance",
      0.055
    ],
    [
      "imprudence",
      0.055
    ],
    [
      "gaffe",
      0.055
    ],
    [
      "confusion",
      0.055
    ],
    [
      "aberration",
      0.055
    ],
    [
      "bourde",
      0.0275
    ],
    [
      "fourvoiement",
      0.0275
    ],
    [
      "equivoque",
      0.0275
    ]
  ],
  "proie": [
    [
      "jouet",
      0.2
    ],
    [
      "butin",
      0.1
    ],
    [
      "capture",
      0.1
    ],
    [
      "depouille",
      0.1
    ],
    [
      "esclave",
      0.1
    ],
    [
      "gibier",
      0.1
    ],
    [
      "prise",
      0.1
    ],
    [
      "pature",
      0.1
    ],
    [
      "victime",
      0.1
    ]
  ],
  "agressivite": [
    [
      "aigreur",
      0.1325
    ],
    [
      "violence",
      0.1325
    ],
    [
      "mechancete",
      0.065
    ],
    [
      "malveillance",
      0.065
    ],
    [
      "inimitie",
      0.065
    ],
    [
      "hargne",
      0.065
    ],
    [
      "colere",
      0.065
    ],
    [
      "amertume",
      0.065
    ],
    [
      "agression",
      0.065
    ],
    [
      "provocation",
      0.0325
    ],
    [
      "hostilite",
      0.0325
    ],
    [
      "combativite",
      0.0325
    ],
    [
      "brutalite",
      0.0325
    ],
    [
      "ardeur",
      0.0325
    ],
    [
      "antagonisme",
      0.0325
    ],
    [
      "acerbite",
      0.0325
    ],
    [
      "pugnacite",
      0.0325
    ]
  ],
  "canton": [
    [
      "region",
      0.18
    ],
    [
      "lieu",
      0.135
    ],
    [
      "pays",
      0.135
    ],
    [
      "zone",
      0.135
    ],
    [
      "circonscription",
      0.09
    ],
    [
      "coin",
      0.09
    ],
    [
      "division",
      0.09
    ],
    [
      "territoire",
      0.09
    ],
    [
      "site",
      0.0425
    ]
  ],
  "impudeur": [
    [
      "impudence",
      0.2
    ],
    [
      "impudicite",
      0.2
    ],
    [
      "indecence",
      0.2
    ],
    [
      "aplomb",
      0.065
    ],
    [
      "culot",
      0.065
    ],
    [
      "cynisme",
      0.065
    ],
    [
      "immodestie",
      0.065
    ],
    [
      "malhonnetete",
      0.065
    ],
    [
      "toupet",
      0.065
    ]
  ],
  "rigoureusement": [
    [
      "exactement",
      0.175
    ],
    [
      "strictement",
      0.085
    ],
    [
      "scrupuleusement",
      0.085
    ],
    [
      "precisement",
      0.085
    ],
    [
      "formellement",
      0.085
    ],
    [
      "absolument",
      0.085
    ],
    [
      "aprement",
      0.0425
    ],
    [
      "totalement",
      0.0425
    ],
    [
      "severement",
      0.0425
    ],
    [
      "rationnellement",
      0.0425
    ],
    [
      "minutieusement",
      0.0425
    ],
    [
      "mathematiquement",
      0.0425
    ],
    [
      "logiquement",
      0.0425
    ],
    [
      "durement",
      0.0425
    ],
    [
      "etroitement",
      0.0425
    ]
  ],
  "supposer": [
    [
      "imaginer",
      0.0975
    ],
    [
      "penser",
      0.0975
    ],
    [
      "croire",
      0.075
    ],
    [
      "conjecturer",
      0.06
    ],
    [
      "presumer",
      0.06
    ],
    [
      "prendre",
      0.0475
    ],
    [
      "soupconner",
      0.0475
    ],
    [
      "inventer",
      0.0375
    ],
    [
      "donner",
      0.0375
    ],
    [
      "compter",
      0.0375
    ],
    [
      "chercher",
      0.0375
    ],
    [
      "admettre",
      0.0375
    ],
    [
      "reveler",
      0.0225
    ],
    [
      "requerir",
      0.0225
    ],
    [
      "presupposer",
      0.0225
    ],
    [
      "marquer",
      0.0225
    ],
    [
      "indiquer",
      0.0225
    ],
    [
      "feindre",
      0.0225
    ],
    [
      "exiger",
      0.0225
    ],
    [
      "concevoir",
      0.0225
    ],
    [
      "reclamer",
      0.01
    ],
    [
      "preter",
      0.01
    ],
    [
      "pretexter",
      0.01
    ],
    [
      "poser",
      0.01
    ],
    [
      "impliquer",
      0.01
    ],
    [
      "denoter",
      0.01
    ],
    [
      "augurer",
      0.01
    ],
    [
      "attribuer",
      0.01
    ],
    [
      "substituer",
      0.01
    ]
  ],
  "sortant": [
    [
      "gagnant",
      1.0
    ]
  ],
  "pucelage": [
    [
      "hymen",
      0.5
    ],
    [
      "virginite",
      0.5
    ]
  ],
  "eperdu": [
    [
      "fou",
      0.1225
    ],
    [
      "frenetique",
      0.095
    ],
    [
      "passionne",
      0.095
    ],
    [
      "emu",
      0.055
    ],
    [
      "violent",
      0.055
    ],
    [
      "trouble",
      0.055
    ],
    [
      "exalte",
      0.055
    ],
    [
      "enrage",
      0.055
    ],
    [
      "affole",
      0.055
    ],
    [
      "bouleverse",
      0.045
    ],
    [
      "furieux",
      0.045
    ],
    [
      "ardent",
      0.0375
    ],
    [
      "ivre",
      0.0275
    ],
    [
      "extreme",
      0.0275
    ],
    [
      "agite",
      0.0175
    ],
    [
      "endiable",
      0.0175
    ],
    [
      "transporte",
      0.0175
    ],
    [
      "vif",
      0.0175
    ],
    [
      "egare",
      0.0175
    ],
    [
      "ebranle",
      0.0075
    ],
    [
      "vehement",
      0.0075
    ],
    [
      "retourne",
      0.0075
    ],
    [
      "desespere",
      0.0075
    ],
    [
      "dechirant",
      0.0075
    ],
    [
      "epeure",
      0.0075
    ]
  ],
  "eperdre": [],
  "assommant": [
    [
      "ennuyeux",
      0.1925
    ],
    [
      "fatigant",
      0.095
    ],
    [
      "embetant",
      0.0825
    ],
    [
      "barbant",
      0.065
    ],
    [
      "rasant",
      0.065
    ],
    [
      "raseur",
      0.0525
    ],
    [
      "somnifere",
      0.0475
    ],
    [
      "importun",
      0.04
    ],
    [
      "empoisonnant",
      0.035
    ],
    [
      "endormant",
      0.035
    ],
    [
      "fastidieux",
      0.035
    ],
    [
      "lassant",
      0.035
    ],
    [
      "tuant",
      0.0275
    ],
    [
      "sempiternel",
      0.0225
    ],
    [
      "enquiquinant",
      0.0225
    ],
    [
      "emmerdant",
      0.0175
    ],
    [
      "mortel",
      0.0175
    ],
    [
      "mourant",
      0.0175
    ],
    [
      "etourdissant",
      0.01
    ],
    [
      "chiant",
      0.005
    ],
    [
      "canulant",
      0.005
    ],
    [
      "barbifiant",
      0.005
    ],
    [
      "assourdissant",
      0.005
    ],
    [
      "assassinant",
      0.005
    ],
    [
      "accablant",
      0.005
    ],
    [
      "narcotique",
      0.005
    ]
  ],
  "guenon": [
    [
      "laideron",
      0.25
    ],
    [
      "singe",
      0.25
    ],
    [
      "guenuche",
      0.125
    ],
    [
      "macaque",
      0.125
    ],
    [
      "mochete",
      0.125
    ],
    [
      "singesse",
      0.125
    ]
  ],
  "engeance": [
    [
      "graine",
      0.3325
    ],
    [
      "race",
      0.3325
    ]
  ],
  "naguere": [
    [
      "anciennement",
      0.125
    ],
    [
      "auparavant",
      0.125
    ],
    [
      "autrefois",
      0.125
    ],
    [
      "avant",
      0.125
    ],
    [
      "jadis",
      0.125
    ],
    [
      "recemment",
      0.125
    ]
  ],
  "guere": [
    [
      "peu",
      0.31
    ],
    [
      "rarement",
      0.075
    ],
    [
      "ne",
      0.075
    ],
    [
      "mediocrement",
      0.075
    ],
    [
      "moyennement",
      0.075
    ]
  ],
  "luron": [
    [
      "gaillard",
      0.1875
    ],
    [
      "gai",
      0.115
    ],
    [
      "drille",
      0.0675
    ],
    [
      "loustic",
      0.0675
    ],
    [
      "egrillard",
      0.045
    ],
    [
      "type",
      0.045
    ],
    [
      "lascar",
      0.045
    ],
    [
      "homme",
      0.045
    ],
    [
      "espiegle",
      0.045
    ],
    [
      "comique",
      0.045
    ],
    [
      "bouffon",
      0.045
    ],
    [
      "matin",
      0.0225
    ],
    [
      "grivois",
      0.0225
    ],
    [
      "flambard",
      0.0225
    ],
    [
      "bougre",
      0.0225
    ],
    [
      "zigoto",
      0.0225
    ]
  ],
  "etreinte": [
    [
      "serrer",
      0.125
    ],
    [
      "embrasser",
      0.1
    ],
    [
      "entourer",
      0.0875
    ],
    [
      "prendre",
      0.0875
    ],
    [
      "enserrer",
      0.075
    ],
    [
      "presser",
      0.06
    ],
    [
      "enlacer",
      0.06
    ],
    [
      "ceinturer",
      0.06
    ],
    [
      "oppresser",
      0.05
    ],
    [
      "saisir",
      0.035
    ],
    [
      "retenir",
      0.035
    ],
    [
      "encercler",
      0.035
    ],
    [
      "accabler",
      0.025
    ],
    [
      "caresser",
      0.025
    ],
    [
      "tenir",
      0.025
    ],
    [
      "etouffer",
      0.025
    ],
    [
      "poindre",
      0.01
    ],
    [
      "empoigner",
      0.01
    ],
    [
      "dechirer",
      0.01
    ],
    [
      "cerner",
      0.01
    ],
    [
      "accoler",
      0.01
    ],
    [
      "tenailler",
      0.01
    ]
  ],
  "precipiter": [
    [
      "accelerer",
      0.1025
    ],
    [
      "brusquer",
      0.0925
    ],
    [
      "hater",
      0.075
    ],
    [
      "presser",
      0.075
    ],
    [
      "activer",
      0.065
    ],
    [
      "pousser",
      0.065
    ],
    [
      "renverser",
      0.045
    ],
    [
      "forcer",
      0.045
    ],
    [
      "expedier",
      0.045
    ],
    [
      "avancer",
      0.045
    ],
    [
      "abattre",
      0.045
    ],
    [
      "depecher",
      0.0375
    ],
    [
      "ruiner",
      0.0275
    ],
    [
      "jeter",
      0.0275
    ],
    [
      "envoyer",
      0.0275
    ],
    [
      "enfoncer",
      0.0275
    ],
    [
      "aneantir",
      0.0175
    ],
    [
      "bousculer",
      0.0175
    ],
    [
      "plonger",
      0.0175
    ],
    [
      "trousser",
      0.0175
    ],
    [
      "rabattre",
      0.0075
    ],
    [
      "bacler",
      0.0075
    ],
    [
      "anticiper",
      0.0075
    ],
    [
      "talonner",
      0.0075
    ]
  ],
  "atteinte": [
    [
      "toucher",
      0.1075
    ],
    [
      "frapper",
      0.04
    ],
    [
      "attaquer",
      0.0375
    ],
    [
      "saisir",
      0.0375
    ],
    [
      "arriver",
      0.035
    ],
    [
      "gagner",
      0.035
    ],
    [
      "emouvoir",
      0.0325
    ],
    [
      "ebranler",
      0.0275
    ],
    [
      "prendre",
      0.0275
    ],
    [
      "bouleverser",
      0.0275
    ],
    [
      "blesser",
      0.0275
    ],
    [
      "attraper",
      0.0275
    ],
    [
      "heurter",
      0.025
    ],
    [
      "parvenir",
      0.025
    ],
    [
      "troubler",
      0.025
    ],
    [
      "joindre",
      0.0225
    ],
    [
      "piquer",
      0.0225
    ],
    [
      "penetrer",
      0.02
    ],
    [
      "alterer",
      0.02
    ],
    [
      "affecter",
      0.02
    ],
    [
      "aller",
      0.0175
    ],
    [
      "monter",
      0.0175
    ],
    [
      "rejoindre",
      0.015
    ],
    [
      "rencontrer",
      0.015
    ],
    [
      "trouver",
      0.0125
    ],
    [
      "percer",
      0.0125
    ],
    [
      "detruire",
      0.0125
    ],
    [
      "accoster",
      0.0125
    ],
    [
      "aborder",
      0.0125
    ],
    [
      "abattre",
      0.0125
    ],
    [
      "s'elever",
      0.01
    ],
    [
      "retrouver",
      0.01
    ],
    [
      "remuer",
      0.01
    ],
    [
      "porter",
      0.01
    ],
    [
      "offenser",
      0.01
    ],
    [
      "choquer",
      0.01
    ],
    [
      "acceder",
      0.01
    ],
    [
      "aboutir",
      0.01
    ],
    [
      "affaiblir",
      0.0075
    ],
    [
      "leser",
      0.0075
    ],
    [
      "realiser",
      0.0075
    ],
    [
      "endommager",
      0.005
    ],
    [
      "contacter",
      0.005
    ],
    [
      "compromettre",
      0.005
    ],
    [
      "affliger",
      0.005
    ],
    [
      "accomplir",
      0.005
    ],
    [
      "egaler",
      0.0025
    ],
    [
      "rattraper",
      0.0025
    ],
    [
      "gravir",
      0.0025
    ],
    [
      "decrocher",
      0.0025
    ],
    [
      "chercher",
      0.0025
    ],
    [
      "aveindre",
      0.0025
    ],
    [
      "apparaitre",
      0.0025
    ],
    [
      "agresser",
      0.0025
    ],
    [
      "agiter",
      0.0025
    ]
  ],
  "rut": [
    [
      "accouplement",
      0.5
    ],
    [
      "chaleur",
      0.5
    ]
  ],
  "decrepit": [
    [
      "vieux",
      0.1925
    ],
    [
      "caduc",
      0.1525
    ],
    [
      "use",
      0.1525
    ],
    [
      "vetuste",
      0.115
    ],
    [
      "senile",
      0.075
    ],
    [
      "age",
      0.075
    ],
    [
      "ruine",
      0.0375
    ],
    [
      "lepreux",
      0.0375
    ],
    [
      "deliquescent",
      0.0375
    ],
    [
      "croulant",
      0.0375
    ],
    [
      "casse",
      0.0375
    ],
    [
      "usage",
      0.0375
    ]
  ],
  "derober": [
    [
      "voler",
      0.1475
    ],
    [
      "prendre",
      0.0825
    ],
    [
      "attraper",
      0.0475
    ],
    [
      "chiper",
      0.045
    ],
    [
      "piquer",
      0.045
    ],
    [
      "soustraire",
      0.0425
    ],
    [
      "enlever",
      0.0425
    ],
    [
      "s'approprier",
      0.0325
    ],
    [
      "faucher",
      0.03
    ],
    [
      "piller",
      0.0275
    ],
    [
      "choper",
      0.025
    ],
    [
      "ravir",
      0.025
    ],
    [
      "subtiliser",
      0.0225
    ],
    [
      "detourner",
      0.02
    ],
    [
      "escamoter",
      0.0175
    ],
    [
      "extorquer",
      0.0175
    ],
    [
      "plagier",
      0.0175
    ],
    [
      "s'emparer",
      0.0175
    ],
    [
      "souffler",
      0.0175
    ],
    [
      "escroquer",
      0.015
    ],
    [
      "cacher",
      0.015
    ],
    [
      "barboter",
      0.0125
    ],
    [
      "faire",
      0.0125
    ],
    [
      "marauder",
      0.0075
    ],
    [
      "kidnapper",
      0.0075
    ],
    [
      "imiter",
      0.0075
    ],
    [
      "emprunter",
      0.0075
    ],
    [
      "depouiller",
      0.0075
    ],
    [
      "dissimuler",
      0.0075
    ],
    [
      "copier",
      0.0075
    ],
    [
      "oter",
      0.0075
    ],
    [
      "etouffer",
      0.0075
    ],
    [
      "retirer",
      0.0075
    ],
    [
      "refaire",
      0.0075
    ],
    [
      "rafler",
      0.0075
    ],
    [
      "picorer",
      0.0075
    ],
    [
      "empecher",
      0.0075
    ],
    [
      "cueillir",
      0.0075
    ],
    [
      "chauffer",
      0.0075
    ],
    [
      "chaparder",
      0.0075
    ],
    [
      "carotter",
      0.0075
    ],
    [
      "usurper",
      0.0025
    ],
    [
      "surprendre",
      0.0025
    ],
    [
      "masquer",
      0.0025
    ],
    [
      "distraire",
      0.0025
    ],
    [
      "camoufler",
      0.0025
    ],
    [
      "butiner",
      0.0025
    ],
    [
      "rifler",
      0.0
    ],
    [
      "piper",
      0.0
    ],
    [
      "murer",
      0.0
    ],
    [
      "gripper",
      0.0
    ],
    [
      "friponner",
      0.0
    ],
    [
      "agripper",
      0.0
    ],
    [
      "voiler",
      0.0
    ]
  ],
  "quadrumane": [
    [
      "singe",
      1.0
    ]
  ],
  "dandinement": [
    [
      "balancement",
      0.4
    ],
    [
      "dodelinement",
      0.2
    ],
    [
      "dehanchement",
      0.2
    ],
    [
      "oscillation",
      0.2
    ]
  ],
  "magistrat": [
    [
      "chef",
      0.1125
    ],
    [
      "juge",
      0.1125
    ],
    [
      "echevin",
      0.055
    ],
    [
      "edile",
      0.055
    ],
    [
      "maire",
      0.035
    ],
    [
      "gouverneur",
      0.035
    ],
    [
      "consul",
      0.035
    ],
    [
      "censeur",
      0.035
    ],
    [
      "capitoul",
      0.035
    ],
    [
      "proconsul",
      0.0175
    ],
    [
      "procurateur",
      0.0175
    ],
    [
      "procureur",
      0.0175
    ],
    [
      "president",
      0.0175
    ],
    [
      "prevot",
      0.0175
    ],
    [
      "questeur",
      0.0175
    ],
    [
      "quindecemvir",
      0.0175
    ],
    [
      "robin",
      0.0175
    ],
    [
      "substitut",
      0.0175
    ],
    [
      "suffete",
      0.0175
    ],
    [
      "tribun",
      0.0175
    ],
    [
      "triumvir",
      0.0175
    ],
    [
      "podestat",
      0.0175
    ],
    [
      "maieur",
      0.0175
    ],
    [
      "alcade",
      0.0175
    ],
    [
      "alderman",
      0.0175
    ],
    [
      "archonte",
      0.0175
    ],
    [
      "avocat",
      0.0175
    ],
    [
      "avoyer",
      0.0175
    ],
    [
      "bourgmestre",
      0.0175
    ],
    [
      "corregidor",
      0.0175
    ],
    [
      "inquisiteur",
      0.0175
    ],
    [
      "jurat",
      0.0175
    ],
    [
      "lieutenant",
      0.0175
    ],
    [
      "viguier",
      0.0175
    ]
  ],
  "extraordinaire": [
    [
      "etonnant",
      0.075
    ],
    [
      "sensationnel",
      0.05
    ],
    [
      "fantastique",
      0.0475
    ],
    [
      "prodigieux",
      0.035
    ],
    [
      "formidable",
      0.0325
    ],
    [
      "surprenant",
      0.0325
    ],
    [
      "inoui",
      0.03
    ],
    [
      "incroyable",
      0.03
    ],
    [
      "fabuleux",
      0.03
    ],
    [
      "bizarre",
      0.0275
    ],
    [
      "enorme",
      0.0225
    ],
    [
      "grand",
      0.02
    ],
    [
      "singulier",
      0.02
    ],
    [
      "invraisemblable",
      0.0175
    ],
    [
      "etrange",
      0.0175
    ],
    [
      "remarquable",
      0.015
    ],
    [
      "original",
      0.015
    ],
    [
      "merveilleux",
      0.015
    ],
    [
      "extravagant",
      0.015
    ],
    [
      "exceptionnel",
      0.015
    ],
    [
      "stupefiant",
      0.0125
    ],
    [
      "excessif",
      0.0125
    ],
    [
      "superieur",
      0.0125
    ],
    [
      "monstrueux",
      0.01
    ],
    [
      "terrible",
      0.01
    ],
    [
      "rocambolesque",
      0.01
    ],
    [
      "rare",
      0.01
    ],
    [
      "phenomenal",
      0.01
    ],
    [
      "admirable",
      0.0075
    ],
    [
      "gigantesque",
      0.0075
    ],
    [
      "epatant",
      0.0075
    ],
    [
      "unique",
      0.0075
    ],
    [
      "parfait",
      0.0075
    ],
    [
      "insolite",
      0.0075
    ],
    [
      "gros",
      0.0075
    ],
    [
      "fou",
      0.0075
    ],
    [
      "abracadabrant",
      0.0075
    ],
    [
      "inconcevable",
      0.0075
    ],
    [
      "inusite",
      0.005
    ],
    [
      "impressionnant",
      0.005
    ],
    [
      "fantasmagorique",
      0.005
    ],
    [
      "curieux",
      0.005
    ],
    [
      "colossal",
      0.005
    ],
    [
      "anormal",
      0.005
    ],
    [
      "eminent",
      0.005
    ],
    [
      "notable",
      0.005
    ],
    [
      "inimaginable",
      0.005
    ],
    [
      "immense",
      0.005
    ],
    [
      "renversant",
      0.005
    ],
    [
      "incomparable",
      0.005
    ],
    [
      "faramineux",
      0.005
    ],
    [
      "extreme",
      0.005
    ],
    [
      "demesure",
      0.005
    ],
    [
      "considerable",
      0.005
    ],
    [
      "fort",
      0.005
    ],
    [
      "epoustouflant",
      0.005
    ],
    [
      "inhabituel",
      0.0025
    ],
    [
      "genial",
      0.0025
    ],
    [
      "fameux",
      0.0025
    ],
    [
      "drole",
      0.0025
    ],
    [
      "distingue",
      0.0025
    ],
    [
      "ahurissant",
      0.0025
    ],
    [
      "sublime",
      0.0025
    ],
    [
      "paradoxal",
      0.0025
    ],
    [
      "effrayant",
      0.0025
    ],
    [
      "truculent",
      0.0025
    ],
    [
      "transcendant",
      0.0025
    ],
    [
      "supreme",
      0.0025
    ],
    [
      "special",
      0.0025
    ],
    [
      "signale",
      0.0025
    ],
    [
      "prestigieux",
      0.0025
    ],
    [
      "particulier",
      0.0025
    ],
    [
      "furieux",
      0.0025
    ],
    [
      "epouvantable",
      0.0025
    ],
    [
      "incalculable",
      0.0025
    ],
    [
      "exquis",
      0.0025
    ],
    [
      "etourdissant",
      0.0
    ],
    [
      "emerite",
      0.0
    ],
    [
      "ebouriffant",
      0.0
    ],
    [
      "saisissant",
      0.0
    ],
    [
      "nouveau",
      0.0
    ],
    [
      "mirobolant",
      0.0
    ],
    [
      "magique",
      0.0
    ],
    [
      "irregulier",
      0.0
    ],
    [
      "horrible",
      0.0
    ],
    [
      "fantasque",
      0.0
    ],
    [
      "exorbitant",
      0.0
    ],
    [
      "excentrique",
      0.0
    ],
    [
      "brillant",
      0.0
    ],
    [
      "miraculeux",
      0.0
    ],
    [
      "mirifique",
      0.0
    ],
    [
      "retentissant",
      0.0
    ],
    [
      "spectaculaire",
      0.0
    ],
    [
      "surnaturel",
      0.0
    ],
    [
      "magnifique",
      0.0
    ],
    [
      "inexprimable",
      0.0
    ],
    [
      "affreux",
      0.0
    ],
    [
      "boeuf",
      0.0
    ],
    [
      "extra",
      0.0
    ],
    [
      "imprevu",
      0.0
    ],
    [
      "ineffable",
      0.0
    ],
    [
      "insolent",
      0.0
    ],
    [
      "intense",
      0.0
    ],
    [
      "pittoresque",
      0.0
    ],
    [
      "romanesque",
      0.0
    ],
    [
      "siderant",
      0.0
    ],
    [
      "thaumaturgique",
      0.0
    ],
    [
      "epique",
      0.0
    ],
    [
      "inexplicable",
      0.0
    ],
    [
      "inespere",
      0.0
    ],
    [
      "indescriptible",
      0.0
    ],
    [
      "accidentel",
      0.0
    ],
    [
      "d'exception",
      0.0
    ],
    [
      "funambulesque",
      0.0
    ],
    [
      "feerique",
      0.0
    ],
    [
      "grotesque",
      0.0
    ],
    [
      "hallucinant",
      0.0
    ],
    [
      "inappreciable",
      0.0
    ],
    [
      "surabondant",
      0.0
    ],
    [
      "supplementaire",
      0.0
    ],
    [
      "superlatif",
      0.0
    ],
    [
      "pyramidal",
      0.0
    ],
    [
      "indicible",
      0.0
    ],
    [
      "esbroufant",
      0.0
    ],
    [
      "anomal",
      0.0
    ]
  ],
  "inespere": [
    [
      "imprevu",
      0.2275
    ],
    [
      "inattendu",
      0.17
    ],
    [
      "surprenant",
      0.1125
    ],
    [
      "inopine",
      0.085
    ],
    [
      "insoupconne",
      0.055
    ],
    [
      "inoui",
      0.055
    ],
    [
      "imprevisible",
      0.055
    ],
    [
      "fortuit",
      0.055
    ],
    [
      "extraordinaire",
      0.055
    ],
    [
      "deroutant",
      0.055
    ],
    [
      "incroyable",
      0.0275
    ],
    [
      "subit",
      0.0275
    ]
  ],
  "impassible": [
    [
      "imperturbable",
      0.1075
    ],
    [
      "insensible",
      0.0975
    ],
    [
      "froid",
      0.06
    ],
    [
      "ferme",
      0.05
    ],
    [
      "indifferent",
      0.05
    ],
    [
      "stoique",
      0.05
    ],
    [
      "dur",
      0.045
    ],
    [
      "flegmatique",
      0.045
    ],
    [
      "calme",
      0.04
    ],
    [
      "inflexible",
      0.035
    ],
    [
      "inebranlable",
      0.035
    ],
    [
      "glacial",
      0.03
    ],
    [
      "immobile",
      0.03
    ],
    [
      "implacable",
      0.03
    ],
    [
      "tranquille",
      0.03
    ],
    [
      "placide",
      0.025
    ],
    [
      "philosophe",
      0.02
    ],
    [
      "patient",
      0.02
    ],
    [
      "glace",
      0.02
    ],
    [
      "impavide",
      0.015
    ],
    [
      "impenetrable",
      0.015
    ],
    [
      "resigne",
      0.015
    ],
    [
      "marmoreen",
      0.0075
    ],
    [
      "intrepide",
      0.0075
    ],
    [
      "impartial",
      0.0075
    ],
    [
      "immuable",
      0.0075
    ],
    [
      "fige",
      0.0075
    ],
    [
      "decontracte",
      0.0075
    ],
    [
      "apathique",
      0.0075
    ],
    [
      "ferme",
      0.0025
    ],
    [
      "juste",
      0.0025
    ],
    [
      "relax",
      0.0025
    ],
    [
      "equitable",
      0.0025
    ]
  ],
  "alternative": [
    [
      "alterne",
      0.1425
    ],
    [
      "sinusoidal",
      0.07
    ],
    [
      "recursif",
      0.07
    ],
    [
      "recurrent",
      0.07
    ],
    [
      "rythmique",
      0.07
    ],
    [
      "periodique",
      0.07
    ],
    [
      "oscillant",
      0.07
    ],
    [
      "ondulatoire",
      0.07
    ],
    [
      "discontinu",
      0.07
    ],
    [
      "cadence",
      0.07
    ],
    [
      "binaire",
      0.07
    ],
    [
      "balance",
      0.07
    ],
    [
      "successif",
      0.07
    ]
  ],
  "alternatif": [
    [
      "alterne",
      0.1425
    ],
    [
      "sinusoidal",
      0.07
    ],
    [
      "recursif",
      0.07
    ],
    [
      "recurrent",
      0.07
    ],
    [
      "rythmique",
      0.07
    ],
    [
      "periodique",
      0.07
    ],
    [
      "oscillant",
      0.07
    ],
    [
      "ondulatoire",
      0.07
    ],
    [
      "discontinu",
      0.07
    ],
    [
      "cadence",
      0.07
    ],
    [
      "binaire",
      0.07
    ],
    [
      "balance",
      0.07
    ],
    [
      "successif",
      0.07
    ]
  ],
  "convaincu": [
    [
      "persuader",
      0.1825
    ],
    [
      "entrainer",
      0.09
    ],
    [
      "gagner",
      0.09
    ],
    [
      "amener",
      0.0725
    ],
    [
      "seduire",
      0.0725
    ],
    [
      "vaincre",
      0.0525
    ],
    [
      "captiver",
      0.0525
    ],
    [
      "prouver",
      0.035
    ],
    [
      "expliquer",
      0.035
    ],
    [
      "enfoncer",
      0.035
    ],
    [
      "demontrer",
      0.035
    ],
    [
      "conduire",
      0.035
    ],
    [
      "accabler",
      0.035
    ],
    [
      "precher",
      0.0175
    ],
    [
      "decider",
      0.0175
    ],
    [
      "convertir",
      0.0175
    ],
    [
      "confondre",
      0.0175
    ],
    [
      "assurer",
      0.0175
    ],
    [
      "toucher",
      0.0175
    ]
  ],
  "maquis": [
    [
      "broussaille",
      0.105
    ],
    [
      "buisson",
      0.105
    ],
    [
      "garrigue",
      0.105
    ],
    [
      "labyrinthe",
      0.105
    ],
    [
      "taillis",
      0.0525
    ],
    [
      "resistance",
      0.0525
    ],
    [
      "rebellion",
      0.0525
    ],
    [
      "organisation",
      0.0525
    ],
    [
      "lande",
      0.0525
    ],
    [
      "lacis",
      0.0525
    ],
    [
      "jachere",
      0.0525
    ],
    [
      "insurrection",
      0.0525
    ],
    [
      "friche",
      0.0525
    ],
    [
      "echeveau",
      0.0525
    ]
  ],
  "delectable": [
    [
      "bon",
      0.15
    ],
    [
      "savoureux",
      0.12
    ],
    [
      "succulent",
      0.12
    ],
    [
      "agreable",
      0.09
    ],
    [
      "delicieux",
      0.09
    ],
    [
      "exquis",
      0.09
    ],
    [
      "fameux",
      0.06
    ],
    [
      "delicat",
      0.06
    ],
    [
      "doux",
      0.0275
    ],
    [
      "friand",
      0.0275
    ],
    [
      "ineffable",
      0.0275
    ],
    [
      "mangeable",
      0.0275
    ],
    [
      "paradisiaque",
      0.0275
    ],
    [
      "suave",
      0.0275
    ],
    [
      "superieur",
      0.0275
    ]
  ],
  "regrettable": [
    [
      "facheux",
      0.1875
    ],
    [
      "deplorable",
      0.1075
    ],
    [
      "malheureux",
      0.1075
    ],
    [
      "desagreable",
      0.08
    ],
    [
      "triste",
      0.0525
    ],
    [
      "miserable",
      0.0525
    ],
    [
      "malencontreux",
      0.0525
    ],
    [
      "funeste",
      0.0525
    ],
    [
      "detestable",
      0.0525
    ],
    [
      "dommage",
      0.0525
    ],
    [
      "bete",
      0.0525
    ],
    [
      "desesperant",
      0.025
    ],
    [
      "pitoyable",
      0.025
    ],
    [
      "saumatre",
      0.025
    ]
  ],
  "balayeur": [
    [
      "boueur",
      0.3325
    ],
    [
      "boueux",
      0.3325
    ],
    [
      "eboueur",
      0.3325
    ]
  ],
  "balai": [
    [
      "brosse",
      0.12
    ],
    [
      "plumeau",
      0.12
    ],
    [
      "houssoir",
      0.08
    ],
    [
      "plumard",
      0.04
    ],
    [
      "queue",
      0.04
    ],
    [
      "ramon",
      0.04
    ],
    [
      "vadrouille",
      0.04
    ],
    [
      "ecoupe",
      0.04
    ],
    [
      "ecouvillon",
      0.04
    ],
    [
      "plumail",
      0.04
    ],
    [
      "pige",
      0.04
    ],
    [
      "goupillon",
      0.04
    ],
    [
      "goret",
      0.04
    ],
    [
      "frotteur",
      0.04
    ],
    [
      "fauber",
      0.04
    ],
    [
      "balayette",
      0.04
    ],
    [
      "aspirateur",
      0.04
    ],
    [
      "epoussette",
      0.04
    ]
  ],
  "balais": [
    [
      "brosse",
      0.12
    ],
    [
      "plumeau",
      0.12
    ],
    [
      "houssoir",
      0.08
    ],
    [
      "plumard",
      0.04
    ],
    [
      "queue",
      0.04
    ],
    [
      "ramon",
      0.04
    ],
    [
      "vadrouille",
      0.04
    ],
    [
      "ecoupe",
      0.04
    ],
    [
      "ecouvillon",
      0.04
    ],
    [
      "plumail",
      0.04
    ],
    [
      "pige",
      0.04
    ],
    [
      "goupillon",
      0.04
    ],
    [
      "goret",
      0.04
    ],
    [
      "frotteur",
      0.04
    ],
    [
      "fauber",
      0.04
    ],
    [
      "balayette",
      0.04
    ],
    [
      "aspirateur",
      0.04
    ],
    [
      "epoussette",
      0.04
    ]
  ],
  "traversin": [
    [
      "oreiller",
      0.3325
    ],
    [
      "chevet",
      0.165
    ],
    [
      "coussin",
      0.165
    ],
    [
      "fleau",
      0.165
    ],
    [
      "polochon",
      0.165
    ]
  ],
  "boulevard": [
    [
      "voie",
      0.12
    ],
    [
      "allee",
      0.09
    ],
    [
      "rue",
      0.06
    ],
    [
      "rempart",
      0.06
    ],
    [
      "protection",
      0.06
    ],
    [
      "promenade",
      0.06
    ],
    [
      "defense",
      0.06
    ],
    [
      "cours",
      0.06
    ],
    [
      "chemin",
      0.06
    ],
    [
      "bastion",
      0.06
    ],
    [
      "avenue",
      0.06
    ],
    [
      "sauvegarde",
      0.03
    ],
    [
      "rocade",
      0.03
    ],
    [
      "mail",
      0.03
    ],
    [
      "levee",
      0.03
    ],
    [
      "fortification",
      0.03
    ],
    [
      "courtine",
      0.03
    ],
    [
      "comique",
      0.03
    ],
    [
      "theatre",
      0.03
    ]
  ],
  "carcasse": [
    [
      "cadre",
      0.08
    ],
    [
      "canevas",
      0.08
    ],
    [
      "charpente",
      0.08
    ],
    [
      "ossature",
      0.08
    ],
    [
      "squelette",
      0.08
    ],
    [
      "plan",
      0.065
    ],
    [
      "corps",
      0.0525
    ],
    [
      "schema",
      0.0375
    ],
    [
      "esquisse",
      0.0375
    ],
    [
      "bati",
      0.0375
    ],
    [
      "armature",
      0.0375
    ],
    [
      "ebauche",
      0.025
    ],
    [
      "projet",
      0.025
    ],
    [
      "os",
      0.025
    ],
    [
      "coque",
      0.025
    ],
    [
      "chassis",
      0.025
    ],
    [
      "caisse",
      0.025
    ],
    [
      "topo",
      0.0125
    ],
    [
      "temperament",
      0.0125
    ],
    [
      "peau",
      0.0125
    ],
    [
      "organisme",
      0.0125
    ],
    [
      "nature",
      0.0125
    ],
    [
      "moule",
      0.0125
    ],
    [
      "maigre",
      0.0125
    ],
    [
      "defroque",
      0.0125
    ],
    [
      "debris",
      0.0125
    ],
    [
      "coquatre",
      0.0125
    ],
    [
      "assemblage",
      0.0125
    ],
    [
      "trame",
      0.0125
    ]
  ],
  "ranimer": [
    [
      "exciter",
      0.0775
    ],
    [
      "revivifier",
      0.0725
    ],
    [
      "reveiller",
      0.0725
    ],
    [
      "exalter",
      0.07
    ],
    [
      "stimuler",
      0.055
    ],
    [
      "reconforter",
      0.0475
    ],
    [
      "revigorer",
      0.045
    ],
    [
      "raviver",
      0.0375
    ],
    [
      "remonter",
      0.0375
    ],
    [
      "vivifier",
      0.035
    ],
    [
      "attiser",
      0.0325
    ],
    [
      "retremper",
      0.03
    ],
    [
      "enflammer",
      0.0275
    ],
    [
      "aviver",
      0.0225
    ],
    [
      "relever",
      0.0225
    ],
    [
      "soutenir",
      0.0225
    ],
    [
      "rechauffer",
      0.0225
    ],
    [
      "ressusciter",
      0.0225
    ],
    [
      "animer",
      0.0225
    ],
    [
      "augmenter",
      0.02
    ],
    [
      "ravigoter",
      0.02
    ],
    [
      "encourager",
      0.015
    ],
    [
      "aiguillonner",
      0.0125
    ],
    [
      "renouveler",
      0.0125
    ],
    [
      "rehausser",
      0.01
    ],
    [
      "retablir",
      0.01
    ],
    [
      "rajeunir",
      0.01
    ],
    [
      "rafraichir",
      0.01
    ],
    [
      "aiguiser",
      0.0075
    ],
    [
      "galvaniser",
      0.0075
    ],
    [
      "ragaillardir",
      0.0075
    ],
    [
      "renover",
      0.005
    ],
    [
      "regenerer",
      0.005
    ],
    [
      "retaper",
      0.005
    ],
    [
      "rallumer",
      0.005
    ],
    [
      "raffermir",
      0.005
    ],
    [
      "degeler",
      0.0025
    ],
    [
      "degourdir",
      0.0025
    ],
    [
      "reactiver",
      0.0025
    ],
    [
      "eperonner",
      0.0025
    ],
    [
      "gratter",
      0.0
    ]
  ],
  "banlieusard": [
    [
      "habitant",
      0.5
    ],
    [
      "suburbain",
      0.5
    ]
  ],
  "lard": [
    [
      "panne",
      0.25
    ],
    [
      "graisse",
      0.1675
    ],
    [
      "aubier",
      0.0825
    ],
    [
      "bacon",
      0.0825
    ],
    [
      "charcuterie",
      0.0825
    ],
    [
      "couenne",
      0.0825
    ],
    [
      "crepine",
      0.0825
    ],
    [
      "gras",
      0.0825
    ],
    [
      "lardon",
      0.0825
    ]
  ],
  "brimer": [
    [
      "tourmenter",
      0.1625
    ],
    [
      "molester",
      0.1275
    ],
    [
      "vexer",
      0.0625
    ],
    [
      "tarabuster",
      0.0625
    ],
    [
      "taquiner",
      0.0625
    ],
    [
      "maltraiter",
      0.0625
    ],
    [
      "chahuter",
      0.0625
    ],
    [
      "berner",
      0.0625
    ],
    [
      "railler",
      0.03
    ],
    [
      "priver",
      0.03
    ],
    [
      "persecuter",
      0.03
    ],
    [
      "mortifier",
      0.03
    ],
    [
      "flouer",
      0.03
    ],
    [
      "defavoriser",
      0.03
    ],
    [
      "chicaner",
      0.03
    ],
    [
      "bizuter",
      0.03
    ],
    [
      "rudoyer",
      0.03
    ]
  ],
  "scenario": [
    [
      "synopsis",
      0.2
    ],
    [
      "intrigue",
      0.15
    ],
    [
      "trame",
      0.15
    ],
    [
      "resume",
      0.0975
    ],
    [
      "plan",
      0.0975
    ],
    [
      "canevas",
      0.0975
    ],
    [
      "action",
      0.0475
    ],
    [
      "fable",
      0.0475
    ],
    [
      "script",
      0.0475
    ],
    [
      "texte",
      0.0475
    ]
  ],
  "schizophrene": [
    [
      "aliene",
      0.285
    ],
    [
      "fou",
      0.285
    ],
    [
      "psychose",
      0.1425
    ],
    [
      "schizo",
      0.1425
    ],
    [
      "toque",
      0.1425
    ]
  ],
  "tromperie": [
    [
      "fourberie",
      0.0575
    ],
    [
      "mensonge",
      0.055
    ],
    [
      "simulation",
      0.05
    ],
    [
      "artifice",
      0.045
    ],
    [
      "mystification",
      0.04
    ],
    [
      "ruse",
      0.04
    ],
    [
      "truc",
      0.04
    ],
    [
      "feinte",
      0.0375
    ],
    [
      "duperie",
      0.0375
    ],
    [
      "hypocrisie",
      0.035
    ],
    [
      "sournoiserie",
      0.035
    ],
    [
      "leurre",
      0.0325
    ],
    [
      "fraude",
      0.0275
    ],
    [
      "illusion",
      0.025
    ],
    [
      "carotte",
      0.02
    ],
    [
      "invention",
      0.02
    ],
    [
      "piperie",
      0.02
    ],
    [
      "perfidie",
      0.02
    ],
    [
      "astuce",
      0.02
    ],
    [
      "attrape",
      0.0175
    ],
    [
      "bateau",
      0.0175
    ],
    [
      "comedie",
      0.0175
    ],
    [
      "farce",
      0.0175
    ],
    [
      "faussete",
      0.0175
    ],
    [
      "imposture",
      0.0175
    ],
    [
      "tartuferie",
      0.0175
    ],
    [
      "trahison",
      0.01
    ],
    [
      "bluff",
      0.01
    ],
    [
      "momerie",
      0.01
    ],
    [
      "truquage",
      0.01
    ],
    [
      "traitrise",
      0.005
    ],
    [
      "supercherie",
      0.005
    ],
    [
      "singerie",
      0.005
    ],
    [
      "facetie",
      0.005
    ],
    [
      "escroquerie",
      0.005
    ],
    [
      "semblant",
      0.0025
    ],
    [
      "mirage",
      0.0025
    ],
    [
      "matoiserie",
      0.0025
    ],
    [
      "maquignonnage",
      0.0025
    ],
    [
      "infidelite",
      0.0025
    ],
    [
      "hablerie",
      0.0025
    ],
    [
      "gabegie",
      0.0025
    ],
    [
      "fumisterie",
      0.0025
    ],
    [
      "fable",
      0.0025
    ],
    [
      "chantage",
      0.0025
    ],
    [
      "amusement",
      0.0025
    ],
    [
      "dol",
      0.0
    ],
    [
      "falsification",
      0.0
    ],
    [
      "finasserie",
      0.0
    ],
    [
      "flatterie",
      0.0
    ],
    [
      "fourbe",
      0.0
    ],
    [
      "chique",
      0.0
    ],
    [
      "carottage",
      0.0
    ],
    [
      "bobard",
      0.0
    ],
    [
      "baraterie",
      0.0
    ],
    [
      "alteration",
      0.0
    ],
    [
      "adultere",
      0.0
    ],
    [
      "tricherie",
      0.0
    ]
  ],
  "obseder": [
    [
      "tourmenter",
      0.11
    ],
    [
      "harceler",
      0.1025
    ],
    [
      "poursuivre",
      0.1025
    ],
    [
      "hanter",
      0.0675
    ],
    [
      "travailler",
      0.0625
    ],
    [
      "importuner",
      0.0575
    ],
    [
      "tracasser",
      0.0575
    ],
    [
      "assieger",
      0.04
    ],
    [
      "lanciner",
      0.0325
    ],
    [
      "fatiguer",
      0.0325
    ],
    [
      "ennuyer",
      0.0325
    ],
    [
      "agacer",
      0.0275
    ],
    [
      "preoccuper",
      0.0275
    ],
    [
      "tarabuster",
      0.0275
    ],
    [
      "turlupiner",
      0.0275
    ],
    [
      "assaillir",
      0.0225
    ],
    [
      "tenailler",
      0.015
    ],
    [
      "presser",
      0.015
    ],
    [
      "habiter",
      0.015
    ],
    [
      "devorer",
      0.015
    ],
    [
      "torturer",
      0.01
    ],
    [
      "enerver",
      0.01
    ],
    [
      "epuiser",
      0.01
    ],
    [
      "tyranniser",
      0.005
    ],
    [
      "submerger",
      0.005
    ],
    [
      "relancer",
      0.005
    ],
    [
      "posseder",
      0.005
    ],
    [
      "obnubiler",
      0.005
    ],
    [
      "hypnotiser",
      0.005
    ],
    [
      "cramponner",
      0.005
    ],
    [
      "cerner",
      0.005
    ],
    [
      "bombarder",
      0.005
    ]
  ],
  "proverbe": [
    [
      "aphorisme",
      0.1275
    ],
    [
      "sentence",
      0.1275
    ],
    [
      "apophtegme",
      0.095
    ],
    [
      "dicton",
      0.095
    ],
    [
      "maxime",
      0.095
    ],
    [
      "pensee",
      0.095
    ],
    [
      "saynete",
      0.0625
    ],
    [
      "comedie",
      0.0625
    ],
    [
      "adage",
      0.0625
    ],
    [
      "axiome",
      0.03
    ],
    [
      "formule",
      0.03
    ],
    [
      "parole",
      0.03
    ],
    [
      "piece",
      0.03
    ],
    [
      "scene",
      0.03
    ]
  ],
  "dialogue": [
    [
      "conversation",
      0.185
    ],
    [
      "entretien",
      0.1425
    ],
    [
      "conference",
      0.1025
    ],
    [
      "colloque",
      0.06
    ],
    [
      "conciliabule",
      0.06
    ],
    [
      "echange",
      0.04
    ],
    [
      "poeme",
      0.04
    ],
    [
      "discussion",
      0.04
    ],
    [
      "discours",
      0.04
    ],
    [
      "causerie",
      0.04
    ],
    [
      "stichomythie",
      0.0175
    ],
    [
      "interview",
      0.0175
    ],
    [
      "interlocution",
      0.0175
    ],
    [
      "interactivite",
      0.0175
    ],
    [
      "entrevue",
      0.0175
    ],
    [
      "debat",
      0.0175
    ],
    [
      "dialogisme",
      0.0175
    ],
    [
      "dialectique",
      0.0175
    ],
    [
      "tenson",
      0.0175
    ]
  ],
  "enliser": [
    [
      "embourber",
      0.25
    ],
    [
      "enfoncer",
      0.25
    ],
    [
      "ensabler",
      0.25
    ],
    [
      "envaser",
      0.25
    ]
  ],
  "inlassablement": [
    [
      "infatigablement",
      1.0
    ]
  ],
  "derive": [
    [
      "derivation",
      0.5
    ],
    [
      "deviation",
      0.5
    ]
  ],
  "nourri": [
    [
      "plein",
      0.25
    ],
    [
      "abondant",
      0.1875
    ],
    [
      "riche",
      0.1875
    ],
    [
      "dense",
      0.125
    ],
    [
      "gros",
      0.0625
    ],
    [
      "serre",
      0.0625
    ],
    [
      "substantiel",
      0.0625
    ],
    [
      "etoffe",
      0.0625
    ]
  ],
  "obscurite": [
    [
      "incertitude",
      0.1025
    ],
    [
      "ombre",
      0.0875
    ],
    [
      "brume",
      0.05
    ],
    [
      "confusion",
      0.05
    ],
    [
      "tenebres",
      0.05
    ],
    [
      "equivoque",
      0.05
    ],
    [
      "obscurcissement",
      0.0375
    ],
    [
      "mystere",
      0.0375
    ],
    [
      "doute",
      0.0375
    ],
    [
      "brouillard",
      0.0375
    ],
    [
      "esoterisme",
      0.025
    ],
    [
      "sombreur",
      0.025
    ],
    [
      "petitesse",
      0.025
    ],
    [
      "opacite",
      0.025
    ],
    [
      "nebulosite",
      0.025
    ],
    [
      "noirceur",
      0.025
    ],
    [
      "indetermination",
      0.025
    ],
    [
      "humilite",
      0.025
    ],
    [
      "brumaille",
      0.025
    ],
    [
      "bassesse",
      0.025
    ],
    [
      "ambiguite",
      0.025
    ],
    [
      "incomprehensibilite",
      0.0125
    ],
    [
      "mediocrite",
      0.0125
    ],
    [
      "nuage",
      0.0125
    ],
    [
      "nuit",
      0.0125
    ],
    [
      "precarite",
      0.0125
    ],
    [
      "incognito",
      0.0125
    ],
    [
      "impenetrabilite",
      0.0125
    ],
    [
      "hermetisme",
      0.0125
    ],
    [
      "difficulte",
      0.0125
    ],
    [
      "aveuglement",
      0.0125
    ],
    [
      "anonymat",
      0.0125
    ],
    [
      "amphibologie",
      0.0125
    ],
    [
      "sombre",
      0.0125
    ]
  ],
  "evangile": [
    [
      "Bible",
      1.0
    ]
  ],
  "herisse": [
    [
      "irriter",
      0.1325
    ],
    [
      "turlupiner",
      0.1325
    ],
    [
      "agacer",
      0.1
    ],
    [
      "surcharger",
      0.065
    ],
    [
      "horripiler",
      0.065
    ],
    [
      "farcir",
      0.065
    ],
    [
      "exceder",
      0.065
    ],
    [
      "exasperer",
      0.065
    ],
    [
      "parsemer",
      0.0325
    ],
    [
      "larder",
      0.0325
    ],
    [
      "indisposer",
      0.0325
    ],
    [
      "herissonner",
      0.0325
    ],
    [
      "entourer",
      0.0325
    ],
    [
      "embarrasser",
      0.0325
    ],
    [
      "crisper",
      0.0325
    ],
    [
      "armer",
      0.0325
    ],
    [
      "truffer",
      0.0325
    ]
  ],
  "herisser": [
    [
      "irriter",
      0.1325
    ],
    [
      "turlupiner",
      0.1325
    ],
    [
      "agacer",
      0.1
    ],
    [
      "surcharger",
      0.065
    ],
    [
      "horripiler",
      0.065
    ],
    [
      "farcir",
      0.065
    ],
    [
      "exceder",
      0.065
    ],
    [
      "exasperer",
      0.065
    ],
    [
      "parsemer",
      0.0325
    ],
    [
      "larder",
      0.0325
    ],
    [
      "indisposer",
      0.0325
    ],
    [
      "herissonner",
      0.0325
    ],
    [
      "entourer",
      0.0325
    ],
    [
      "embarrasser",
      0.0325
    ],
    [
      "crisper",
      0.0325
    ],
    [
      "armer",
      0.0325
    ],
    [
      "truffer",
      0.0325
    ]
  ],
  "barbele": [
    [
      "abri",
      0.165
    ],
    [
      "cloture",
      0.165
    ],
    [
      "piquant",
      0.165
    ],
    [
      "pointe",
      0.165
    ],
    [
      "ronce",
      0.165
    ]
  ],
  "somnifere": [
    [
      "ennuyeux",
      0.1625
    ],
    [
      "narcotique",
      0.095
    ],
    [
      "assommant",
      0.075
    ],
    [
      "endormant",
      0.0675
    ],
    [
      "soporifique",
      0.0475
    ],
    [
      "fatigant",
      0.0475
    ],
    [
      "fastidieux",
      0.0475
    ],
    [
      "embetant",
      0.0475
    ],
    [
      "hypnotique",
      0.0375
    ],
    [
      "rasoir",
      0.0275
    ],
    [
      "rasant",
      0.0275
    ],
    [
      "penible",
      0.0275
    ],
    [
      "mortel",
      0.0275
    ],
    [
      "calmant",
      0.0275
    ],
    [
      "soporeux",
      0.0175
    ],
    [
      "soporatif",
      0.0175
    ],
    [
      "insupportable",
      0.0175
    ],
    [
      "empoisonnant",
      0.0175
    ],
    [
      "assoupissant",
      0.0175
    ],
    [
      "soporifere",
      0.0075
    ],
    [
      "rebutant",
      0.0075
    ],
    [
      "hypnogene",
      0.0075
    ],
    [
      "ennuyant",
      0.0075
    ],
    [
      "emmerdant",
      0.0075
    ],
    [
      "dormitif",
      0.0075
    ],
    [
      "barbiturique",
      0.0075
    ],
    [
      "anesthesique",
      0.0075
    ],
    [
      "suant",
      0.0075
    ]
  ],
  "rancoeur": [
    [
      "aigreur",
      0.2
    ],
    [
      "ressentiment",
      0.2
    ],
    [
      "depit",
      0.1325
    ],
    [
      "haine",
      0.1325
    ],
    [
      "rancune",
      0.1325
    ],
    [
      "amertume",
      0.065
    ],
    [
      "dent",
      0.065
    ],
    [
      "desillusion",
      0.065
    ]
  ],
  "bidonville": [
    [
      "agglomeration",
      0.285
    ],
    [
      "camp",
      0.1425
    ],
    [
      "campement",
      0.1425
    ],
    [
      "favela",
      0.1425
    ],
    [
      "taudis",
      0.1425
    ],
    [
      "zone",
      0.1425
    ]
  ],
  "cre": [
    [
      "crenom",
      0.5
    ],
    [
      "sacre",
      0.5
    ]
  ],
  "phoque": [
    [
      "cystiphore",
      0.125
    ],
    [
      "moine",
      0.125
    ],
    [
      "otarie",
      0.125
    ],
    [
      "pinnipede",
      0.125
    ]
  ],
  "accroire": [],
  "bambin": [
    [
      "gamin",
      0.22
    ],
    [
      "enfant",
      0.165
    ],
    [
      "bebe",
      0.11
    ],
    [
      "gosse",
      0.11
    ],
    [
      "marmot",
      0.11
    ],
    [
      "petiot",
      0.11
    ],
    [
      "petit",
      0.11
    ],
    [
      "cherubin",
      0.055
    ]
  ],
  "promeneur": [
    [
      "flaneur",
      0.23
    ],
    [
      "excursionniste",
      0.1525
    ],
    [
      "marcheur",
      0.1525
    ],
    [
      "badaud",
      0.075
    ],
    [
      "baladeur",
      0.075
    ],
    [
      "passant",
      0.075
    ],
    [
      "rodeur",
      0.075
    ],
    [
      "visiteur",
      0.075
    ],
    [
      "voyageur",
      0.075
    ]
  ],
  "rayonner": [
    [
      "briller",
      0.1275
    ],
    [
      "flamboyer",
      0.115
    ],
    [
      "resplendir",
      0.1025
    ],
    [
      "luire",
      0.0875
    ],
    [
      "etinceler",
      0.0775
    ],
    [
      "reluire",
      0.0625
    ],
    [
      "eclater",
      0.05
    ],
    [
      "fulgurer",
      0.05
    ],
    [
      "irradier",
      0.0375
    ],
    [
      "rutiler",
      0.025
    ],
    [
      "ruisseler",
      0.025
    ],
    [
      "petiller",
      0.025
    ],
    [
      "s'etoiler",
      0.01
    ],
    [
      "s'etendre",
      0.01
    ],
    [
      "s'eclairer",
      0.01
    ],
    [
      "radier",
      0.01
    ],
    [
      "miroiter",
      0.01
    ],
    [
      "marquer",
      0.01
    ],
    [
      "flamber",
      0.01
    ],
    [
      "emaner",
      0.01
    ]
  ],
  "rayonnant": [
    [
      "radieux",
      0.235
    ],
    [
      "brillant",
      0.1175
    ],
    [
      "eclatant",
      0.1175
    ],
    [
      "triomphant",
      0.0575
    ],
    [
      "ravi",
      0.0575
    ],
    [
      "lumineux",
      0.0575
    ],
    [
      "heureux",
      0.0575
    ],
    [
      "epanoui",
      0.0275
    ],
    [
      "ruisselant",
      0.0275
    ],
    [
      "rayonne",
      0.0275
    ],
    [
      "radie",
      0.0275
    ],
    [
      "radiant",
      0.0275
    ],
    [
      "petillant",
      0.0275
    ],
    [
      "nitescent",
      0.0275
    ],
    [
      "irradiant",
      0.0275
    ],
    [
      "glorieux",
      0.0275
    ],
    [
      "etincelant",
      0.0275
    ]
  ],
  "infirmier": [
    [
      "ambulancier",
      0.3325
    ],
    [
      "brancardier",
      0.3325
    ]
  ],
  "agenouiller": [
    [
      "opprimer",
      1.0
    ]
  ],
  "volage": [
    [
      "changeant",
      0.1175
    ],
    [
      "instable",
      0.1175
    ],
    [
      "fragile",
      0.105
    ],
    [
      "inconstant",
      0.105
    ],
    [
      "leger",
      0.0875
    ],
    [
      "mobile",
      0.0875
    ],
    [
      "fugace",
      0.0725
    ],
    [
      "versatile",
      0.0575
    ],
    [
      "precaire",
      0.0425
    ],
    [
      "capricieux",
      0.0425
    ],
    [
      "faible",
      0.0275
    ],
    [
      "ondoyant",
      0.0275
    ],
    [
      "ephemere",
      0.0275
    ],
    [
      "coureur",
      0.0125
    ],
    [
      "fantasque",
      0.0125
    ],
    [
      "frivole",
      0.0125
    ],
    [
      "infidele",
      0.0125
    ]
  ],
  "convoler": [
    [
      "epouser",
      0.25
    ]
  ],
  "eperdument": [
    [
      "passionnement",
      0.25
    ],
    [
      "follement",
      0.165
    ],
    [
      "furieusement",
      0.165
    ],
    [
      "completement",
      0.0825
    ],
    [
      "entierement",
      0.0825
    ],
    [
      "frenetiquement",
      0.0825
    ],
    [
      "parfaitement",
      0.0825
    ]
  ],
  "flute": [
    [
      "pipeau",
      0.095
    ],
    [
      "baguette",
      0.0625
    ],
    [
      "chalumeau",
      0.0625
    ],
    [
      "fluteau",
      0.0625
    ],
    [
      "pain",
      0.03
    ],
    [
      "piccolo",
      0.03
    ],
    [
      "piffero",
      0.03
    ],
    [
      "poesie",
      0.03
    ],
    [
      "quille",
      0.03
    ],
    [
      "syrinx",
      0.03
    ],
    [
      "traversiere",
      0.03
    ],
    [
      "verre",
      0.03
    ],
    [
      "octavin",
      0.03
    ],
    [
      "ocarina",
      0.03
    ],
    [
      "mirliton",
      0.03
    ],
    [
      "allemande",
      0.03
    ],
    [
      "crotte",
      0.03
    ],
    [
      "diaule",
      0.03
    ],
    [
      "fifre",
      0.03
    ],
    [
      "flageolet",
      0.03
    ],
    [
      "flutiste",
      0.03
    ],
    [
      "galoubet",
      0.03
    ],
    [
      "jambe",
      0.03
    ],
    [
      "larigot",
      0.03
    ],
    [
      "zut",
      0.03
    ]
  ],
  "azimut": [
    [
      "direction",
      1.0
    ]
  ],
  "purement": [
    [
      "bien",
      0.1175
    ],
    [
      "candidement",
      0.1175
    ],
    [
      "seulement",
      0.1175
    ],
    [
      "simplement",
      0.1175
    ],
    [
      "uniquement",
      0.1175
    ],
    [
      "innocemment",
      0.0575
    ],
    [
      "ingenument",
      0.0575
    ],
    [
      "honnetement",
      0.0575
    ],
    [
      "exclusivement",
      0.0575
    ],
    [
      "correctement",
      0.0575
    ],
    [
      "chastement",
      0.0575
    ],
    [
      "noblement",
      0.0575
    ]
  ],
  "psychosomatique": [
    [
      "nerveux",
      0.3325
    ],
    [
      "psychogene",
      0.3325
    ],
    [
      "somatopsychique",
      0.3325
    ]
  ],
  "intemperie": [
    [
      "orage",
      0.2
    ],
    [
      "temps",
      0.1325
    ],
    [
      "tempete",
      0.1325
    ],
    [
      "vent",
      0.1325
    ],
    [
      "pluie",
      0.065
    ],
    [
      "meteore",
      0.065
    ],
    [
      "froid",
      0.065
    ],
    [
      "dereglement",
      0.065
    ],
    [
      "rigueur",
      0.065
    ]
  ],
  "exciter": [
    [
      "enflammer",
      0.0625
    ],
    [
      "exalter",
      0.0475
    ],
    [
      "attiser",
      0.0475
    ],
    [
      "pousser",
      0.045
    ],
    [
      "provoquer",
      0.035
    ],
    [
      "animer",
      0.0325
    ],
    [
      "soulever",
      0.03
    ],
    [
      "stimuler",
      0.025
    ],
    [
      "entrainer",
      0.025
    ],
    [
      "aiguillonner",
      0.0225
    ],
    [
      "ranimer",
      0.0225
    ],
    [
      "inciter",
      0.0175
    ],
    [
      "irriter",
      0.015
    ],
    [
      "transporter",
      0.015
    ],
    [
      "aviver",
      0.015
    ],
    [
      "enthousiasmer",
      0.0125
    ],
    [
      "allumer",
      0.0125
    ],
    [
      "augmenter",
      0.0125
    ],
    [
      "encourager",
      0.0125
    ],
    [
      "attirer",
      0.0125
    ],
    [
      "engager",
      0.0125
    ],
    [
      "surexciter",
      0.01
    ],
    [
      "susciter",
      0.01
    ],
    [
      "porter",
      0.01
    ],
    [
      "inviter",
      0.01
    ],
    [
      "determiner",
      0.01
    ],
    [
      "dechainer",
      0.01
    ],
    [
      "piquer",
      0.01
    ],
    [
      "reveiller",
      0.01
    ],
    [
      "agacer",
      0.0075
    ],
    [
      "exasperer",
      0.0075
    ],
    [
      "appeler",
      0.0075
    ],
    [
      "eveiller",
      0.0075
    ],
    [
      "presser",
      0.0075
    ],
    [
      "galvaniser",
      0.0075
    ],
    [
      "enfievrer",
      0.0075
    ],
    [
      "aiguiser",
      0.0075
    ],
    [
      "agiter",
      0.0075
    ],
    [
      "eperonner",
      0.005
    ],
    [
      "vivifier",
      0.005
    ],
    [
      "turlupiner",
      0.005
    ],
    [
      "occasionner",
      0.005
    ],
    [
      "fouetter",
      0.005
    ],
    [
      "charmer",
      0.005
    ],
    [
      "accroitre",
      0.005
    ],
    [
      "emouvoir",
      0.005
    ],
    [
      "electriser",
      0.005
    ],
    [
      "exacerber",
      0.005
    ],
    [
      "exhorter",
      0.005
    ],
    [
      "ravir",
      0.005
    ],
    [
      "revivifier",
      0.005
    ],
    [
      "solliciter",
      0.005
    ],
    [
      "echauffer",
      0.005
    ],
    [
      "soutenir",
      0.005
    ],
    [
      "relever",
      0.005
    ],
    [
      "embraser",
      0.005
    ],
    [
      "conduire",
      0.005
    ],
    [
      "tourmenter",
      0.0025
    ],
    [
      "reconforter",
      0.0025
    ],
    [
      "fomenter",
      0.0025
    ],
    [
      "enlever",
      0.0025
    ],
    [
      "enivrer",
      0.0025
    ],
    [
      "harceler",
      0.0025
    ],
    [
      "mouvoir",
      0.0025
    ],
    [
      "passionner",
      0.0025
    ],
    [
      "persuader",
      0.0025
    ],
    [
      "remuer",
      0.0025
    ],
    [
      "souffler",
      0.0025
    ],
    [
      "tenter",
      0.0025
    ],
    [
      "travailler",
      0.0025
    ],
    [
      "troubler",
      0.0025
    ],
    [
      "ebranler",
      0.0025
    ],
    [
      "envenimer",
      0.0025
    ],
    [
      "emballer",
      0.0025
    ],
    [
      "developper",
      0.0025
    ],
    [
      "activer",
      0.0025
    ],
    [
      "aggraver",
      0.0025
    ],
    [
      "aigrir",
      0.0025
    ],
    [
      "bousculer",
      0.0025
    ],
    [
      "bruler",
      0.0025
    ],
    [
      "captiver",
      0.0025
    ],
    [
      "causer",
      0.0025
    ],
    [
      "chatouiller",
      0.0025
    ],
    [
      "chauffer",
      0.0025
    ],
    [
      "declencher",
      0.0025
    ],
    [
      "enerver",
      0.0025
    ],
    [
      "emoustiller",
      0.0025
    ],
    [
      "monter",
      0.0025
    ],
    [
      "aguicher",
      0.0025
    ],
    [
      "taquiner",
      0.0
    ],
    [
      "retremper",
      0.0
    ],
    [
      "plaire",
      0.0
    ],
    [
      "nourrir",
      0.0
    ],
    [
      "griser",
      0.0
    ],
    [
      "dresser",
      0.0
    ],
    [
      "asticoter",
      0.0
    ],
    [
      "armer",
      0.0
    ],
    [
      "raviver",
      0.0
    ],
    [
      "flatter",
      0.0
    ],
    [
      "donner",
      0.0
    ],
    [
      "caresser",
      0.0
    ],
    [
      "ameuter",
      0.0
    ],
    [
      "actionner",
      0.0
    ],
    [
      "survolter",
      0.0
    ],
    [
      "opposer",
      0.0
    ],
    [
      "engendrer",
      0.0
    ],
    [
      "convier",
      0.0
    ],
    [
      "assaillir",
      0.0
    ],
    [
      "obliger",
      0.0
    ],
    [
      "insuffler",
      0.0
    ],
    [
      "instiguer",
      0.0
    ],
    [
      "fanatiser",
      0.0
    ],
    [
      "enfieller",
      0.0
    ],
    [
      "doper",
      0.0
    ],
    [
      "cingler",
      0.0
    ],
    [
      "braquer",
      0.0
    ],
    [
      "acharner",
      0.0
    ],
    [
      "epoinconner",
      0.0
    ]
  ],
  "fantaisie": [
    [
      "caprice",
      0.135
    ],
    [
      "humeur",
      0.0725
    ],
    [
      "toquade",
      0.0675
    ],
    [
      "folie",
      0.035
    ],
    [
      "volonte",
      0.0325
    ],
    [
      "imagination",
      0.0325
    ],
    [
      "bizarrerie",
      0.0325
    ],
    [
      "amour",
      0.0325
    ],
    [
      "desir",
      0.0225
    ],
    [
      "extravagance",
      0.0225
    ],
    [
      "passade",
      0.02
    ],
    [
      "idee",
      0.02
    ],
    [
      "flirt",
      0.02
    ],
    [
      "chimere",
      0.02
    ],
    [
      "bagatelle",
      0.02
    ],
    [
      "amourette",
      0.02
    ],
    [
      "manie",
      0.015
    ],
    [
      "lubie",
      0.015
    ],
    [
      "gre",
      0.015
    ],
    [
      "futilite",
      0.015
    ],
    [
      "frivolite",
      0.015
    ],
    [
      "bricole",
      0.015
    ],
    [
      "babiole",
      0.015
    ],
    [
      "originalite",
      0.01
    ],
    [
      "mode",
      0.01
    ],
    [
      "invention",
      0.01
    ],
    [
      "imaginaire",
      0.01
    ],
    [
      "esprit",
      0.01
    ],
    [
      "envie",
      0.01
    ],
    [
      "boutade",
      0.01
    ],
    [
      "bibelot",
      0.01
    ],
    [
      "amusette",
      0.01
    ],
    [
      "soif",
      0.0075
    ],
    [
      "plaisir",
      0.0075
    ],
    [
      "irregularite",
      0.0075
    ],
    [
      "guise",
      0.0075
    ],
    [
      "foucade",
      0.0075
    ],
    [
      "excentricite",
      0.0075
    ],
    [
      "betise",
      0.0075
    ],
    [
      "beguin",
      0.0075
    ],
    [
      "breloque",
      0.0075
    ],
    [
      "bluette",
      0.0075
    ],
    [
      "billevesee",
      0.0075
    ],
    [
      "indiscipline",
      0.0025
    ],
    [
      "ornement",
      0.0025
    ],
    [
      "passionnette",
      0.0025
    ],
    [
      "pittoresque",
      0.0025
    ],
    [
      "quinte",
      0.0025
    ],
    [
      "spectacle",
      0.0025
    ],
    [
      "tic",
      0.0025
    ],
    [
      "travers",
      0.0025
    ],
    [
      "inconsequence",
      0.0025
    ],
    [
      "imprevu",
      0.0025
    ],
    [
      "bobard",
      0.0025
    ],
    [
      "chimerique",
      0.0025
    ],
    [
      "exotisme",
      0.0025
    ],
    [
      "fable",
      0.0025
    ],
    [
      "fantaisiste",
      0.0025
    ],
    [
      "humour",
      0.0025
    ],
    [
      "illusion",
      0.0025
    ],
    [
      "imitation",
      0.0025
    ],
    [
      "vertigo",
      0.0025
    ]
  ],
  "adoucir": [
    [
      "attenuer",
      0.0725
    ],
    [
      "diminuer",
      0.07
    ],
    [
      "calmer",
      0.065
    ],
    [
      "apaiser",
      0.0625
    ],
    [
      "temperer",
      0.0475
    ],
    [
      "affaiblir",
      0.045
    ],
    [
      "moderer",
      0.0275
    ],
    [
      "amortir",
      0.0225
    ],
    [
      "consoler",
      0.0225
    ],
    [
      "flechir",
      0.0225
    ],
    [
      "eteindre",
      0.02
    ],
    [
      "emousser",
      0.02
    ],
    [
      "soulager",
      0.02
    ],
    [
      "endormir",
      0.02
    ],
    [
      "attendrir",
      0.02
    ],
    [
      "edulcorer",
      0.0175
    ],
    [
      "corriger",
      0.015
    ],
    [
      "estomper",
      0.015
    ],
    [
      "reduire",
      0.015
    ],
    [
      "toucher",
      0.0125
    ],
    [
      "apprivoiser",
      0.0125
    ],
    [
      "affadir",
      0.0125
    ],
    [
      "polir",
      0.01
    ],
    [
      "lenifier",
      0.01
    ],
    [
      "guerir",
      0.01
    ],
    [
      "civiliser",
      0.01
    ],
    [
      "bercer",
      0.01
    ],
    [
      "assouplir",
      0.01
    ],
    [
      "assoupir",
      0.01
    ],
    [
      "amadouer",
      0.01
    ],
    [
      "humaniser",
      0.0075
    ],
    [
      "amollir",
      0.0075
    ],
    [
      "abaisser",
      0.0075
    ],
    [
      "tranquilliser",
      0.005
    ],
    [
      "relacher",
      0.005
    ],
    [
      "rasserener",
      0.005
    ],
    [
      "mitiger",
      0.005
    ],
    [
      "fondre",
      0.005
    ],
    [
      "desarmer",
      0.005
    ],
    [
      "dulcifier",
      0.005
    ],
    [
      "baisser",
      0.005
    ],
    [
      "attiedir",
      0.005
    ],
    [
      "ameliorer",
      0.005
    ],
    [
      "alleger",
      0.005
    ],
    [
      "traiter",
      0.0025
    ],
    [
      "tamiser",
      0.0025
    ],
    [
      "radoucir",
      0.0025
    ],
    [
      "policer",
      0.0025
    ],
    [
      "cicatriser",
      0.0025
    ],
    [
      "chatier",
      0.0025
    ],
    [
      "charmer",
      0.0025
    ],
    [
      "amenuiser",
      0.0025
    ],
    [
      "emmieller",
      0.0
    ],
    [
      "filtrer",
      0.0
    ],
    [
      "pacifier",
      0.0
    ],
    [
      "panser",
      0.0
    ],
    [
      "purifier",
      0.0
    ],
    [
      "deraidir",
      0.0
    ],
    [
      "defacher",
      0.0
    ],
    [
      "diluer",
      0.0
    ],
    [
      "concilier",
      0.0
    ],
    [
      "climatiser",
      0.0
    ],
    [
      "arrondir",
      0.0
    ],
    [
      "apporter",
      0.0
    ],
    [
      "anesthesier",
      0.0
    ],
    [
      "sucrer",
      0.0
    ]
  ],
  "gosier": [
    [
      "gorge",
      0.135
    ],
    [
      "bouche",
      0.08
    ],
    [
      "dalle",
      0.08
    ],
    [
      "kiki",
      0.055
    ],
    [
      "goulot",
      0.055
    ],
    [
      "gavion",
      0.055
    ],
    [
      "larynx",
      0.025
    ],
    [
      "luette",
      0.025
    ],
    [
      "oesophage",
      0.025
    ],
    [
      "pave",
      0.025
    ],
    [
      "pharynx",
      0.025
    ],
    [
      "quiqui",
      0.025
    ],
    [
      "sifflet",
      0.025
    ],
    [
      "tuyau",
      0.025
    ],
    [
      "lampas",
      0.025
    ],
    [
      "gueule",
      0.025
    ],
    [
      "gaviot",
      0.025
    ],
    [
      "amygdale",
      0.025
    ],
    [
      "avaloir",
      0.025
    ],
    [
      "corridor",
      0.025
    ],
    [
      "descente",
      0.025
    ],
    [
      "entonnoir",
      0.025
    ],
    [
      "estomac",
      0.025
    ],
    [
      "fusil",
      0.025
    ],
    [
      "gargamelle",
      0.025
    ],
    [
      "voix",
      0.025
    ]
  ],
  "tourbillonner": [
    [
      "tournoyer",
      0.3325
    ],
    [
      "tourner",
      0.165
    ],
    [
      "virer",
      0.165
    ],
    [
      "virevolter",
      0.165
    ],
    [
      "voleter",
      0.165
    ]
  ],
  "satisfaction": [
    [
      "joie",
      0.13
    ],
    [
      "contentement",
      0.0975
    ],
    [
      "bonheur",
      0.085
    ],
    [
      "plaisir",
      0.085
    ],
    [
      "felicite",
      0.065
    ],
    [
      "euphorie",
      0.0425
    ],
    [
      "jouissance",
      0.0325
    ],
    [
      "gaiete",
      0.0325
    ],
    [
      "sensualite",
      0.02
    ],
    [
      "satiete",
      0.02
    ],
    [
      "reparation",
      0.02
    ],
    [
      "plenitude",
      0.02
    ],
    [
      "fierte",
      0.02
    ],
    [
      "douceur",
      0.02
    ],
    [
      "consolation",
      0.02
    ],
    [
      "compensation",
      0.02
    ],
    [
      "assouvissement",
      0.02
    ],
    [
      "allegresse",
      0.02
    ],
    [
      "suffisance",
      0.01
    ],
    [
      "rayonnement",
      0.01
    ],
    [
      "raison",
      0.01
    ],
    [
      "penitence",
      0.01
    ],
    [
      "complaisance",
      0.01
    ],
    [
      "beatitude",
      0.01
    ],
    [
      "bien",
      0.01
    ],
    [
      "applaudissement",
      0.01
    ],
    [
      "aise",
      0.01
    ],
    [
      "triomphe",
      0.01
    ]
  ],
  "sobriquet": [
    [
      "surnom",
      0.5
    ],
    [
      "heteronyme",
      0.25
    ],
    [
      "nom",
      0.25
    ]
  ],
  "lippu": [],
  "charnu": [
    [
      "rebondi",
      0.1375
    ],
    [
      "gras",
      0.125
    ],
    [
      "replet",
      0.125
    ],
    [
      "dodu",
      0.0625
    ],
    [
      "gros",
      0.0625
    ],
    [
      "potele",
      0.0625
    ],
    [
      "rondelet",
      0.05
    ],
    [
      "rond",
      0.05
    ],
    [
      "plein",
      0.05
    ],
    [
      "abondant",
      0.0375
    ],
    [
      "poupard",
      0.0375
    ],
    [
      "epais",
      0.0225
    ],
    [
      "rondouillard",
      0.0225
    ],
    [
      "plantureux",
      0.0225
    ],
    [
      "grassouillet",
      0.0225
    ],
    [
      "tubereux",
      0.01
    ],
    [
      "rondouillet",
      0.01
    ],
    [
      "pulpeux",
      0.01
    ],
    [
      "fessu",
      0.01
    ],
    [
      "corpulent",
      0.01
    ],
    [
      "charneux",
      0.01
    ],
    [
      "viande",
      0.01
    ]
  ],
  "renouveler": [
    [
      "changer",
      0.1175
    ],
    [
      "transformer",
      0.11
    ],
    [
      "ranimer",
      0.0575
    ],
    [
      "refaire",
      0.0575
    ],
    [
      "modifier",
      0.05
    ],
    [
      "reformer",
      0.04
    ],
    [
      "revolutionner",
      0.0325
    ],
    [
      "metamorphoser",
      0.0325
    ],
    [
      "retablir",
      0.0225
    ],
    [
      "repeter",
      0.0225
    ],
    [
      "renover",
      0.0225
    ],
    [
      "regenerer",
      0.0225
    ],
    [
      "ressusciter",
      0.0225
    ],
    [
      "rajeunir",
      0.0225
    ],
    [
      "corriger",
      0.0225
    ],
    [
      "bouleverser",
      0.0225
    ],
    [
      "transposer",
      0.015
    ],
    [
      "transmuer",
      0.015
    ],
    [
      "reveiller",
      0.015
    ],
    [
      "reiterer",
      0.015
    ],
    [
      "reproduire",
      0.015
    ],
    [
      "refondre",
      0.015
    ],
    [
      "rectifier",
      0.015
    ],
    [
      "recommencer",
      0.015
    ],
    [
      "raviver",
      0.015
    ],
    [
      "convertir",
      0.015
    ],
    [
      "redoubler",
      0.0075
    ],
    [
      "remanier",
      0.0075
    ],
    [
      "remplacer",
      0.0075
    ],
    [
      "renouer",
      0.0075
    ],
    [
      "rhabiller",
      0.0075
    ],
    [
      "toucher",
      0.0075
    ],
    [
      "recrepir",
      0.0075
    ],
    [
      "reconduire",
      0.0075
    ],
    [
      "proroger",
      0.0075
    ],
    [
      "nover",
      0.0075
    ],
    [
      "muer",
      0.0075
    ],
    [
      "innover",
      0.0075
    ],
    [
      "chambouler",
      0.0075
    ],
    [
      "chambarder",
      0.0075
    ],
    [
      "transfigurer",
      0.0075
    ]
  ],
  "abonnement": [
    [
      "forfait",
      0.5
    ],
    [
      "souscription",
      0.5
    ]
  ],
  "berlue": [
    [
      "couverture",
      0.3325
    ],
    [
      "hallucination",
      0.3325
    ],
    [
      "eblouissement",
      0.3325
    ]
  ],
  "sauterelle": [
    [
      "criquet",
      0.2
    ],
    [
      "locuste",
      0.2
    ],
    [
      "regle",
      0.2
    ],
    [
      "sauteriau",
      0.2
    ]
  ],
  "concession": [
    [
      "abandon",
      0.1075
    ],
    [
      "don",
      0.1075
    ],
    [
      "transaction",
      0.07
    ],
    [
      "renoncement",
      0.07
    ],
    [
      "privilege",
      0.07
    ],
    [
      "compromis",
      0.07
    ],
    [
      "attribution",
      0.07
    ],
    [
      "permission",
      0.035
    ],
    [
      "octroi",
      0.035
    ],
    [
      "facilite",
      0.035
    ],
    [
      "exploitation",
      0.035
    ],
    [
      "desistement",
      0.035
    ],
    [
      "contrat",
      0.035
    ],
    [
      "composition",
      0.035
    ],
    [
      "charte",
      0.035
    ],
    [
      "cession",
      0.035
    ],
    [
      "autorisation",
      0.035
    ],
    [
      "aire",
      0.035
    ],
    [
      "tombe",
      0.035
    ]
  ],
  "perfecto": [],
  "information": [
    [
      "avis",
      0.1025
    ],
    [
      "note",
      0.09
    ],
    [
      "renseignement",
      0.09
    ],
    [
      "annonce",
      0.065
    ],
    [
      "indication",
      0.065
    ],
    [
      "nouvelle",
      0.05
    ],
    [
      "recherche",
      0.0375
    ],
    [
      "instruction",
      0.0375
    ],
    [
      "examen",
      0.0375
    ],
    [
      "enquete",
      0.0375
    ],
    [
      "tuyau",
      0.025
    ],
    [
      "precision",
      0.025
    ],
    [
      "message",
      0.025
    ],
    [
      "lumiere",
      0.025
    ],
    [
      "journal",
      0.025
    ],
    [
      "declaration",
      0.025
    ],
    [
      "communique",
      0.025
    ],
    [
      "bulletin",
      0.025
    ],
    [
      "avertissement",
      0.025
    ],
    [
      "edification",
      0.0125
    ],
    [
      "scoop",
      0.0125
    ],
    [
      "question",
      0.0125
    ],
    [
      "media",
      0.0125
    ],
    [
      "investigation",
      0.0125
    ],
    [
      "interrogation",
      0.0125
    ],
    [
      "flash",
      0.0125
    ],
    [
      "donnee",
      0.0125
    ],
    [
      "code",
      0.0125
    ],
    [
      "etude",
      0.0125
    ]
  ],
  "kiwi": [],
  "serin": [
    [
      "beta",
      0.165
    ],
    [
      "bete",
      0.165
    ],
    [
      "canari",
      0.165
    ],
    [
      "niais",
      0.165
    ],
    [
      "nigaud",
      0.165
    ],
    [
      "sot",
      0.165
    ]
  ],
  "remercier": [
    [
      "renvoyer",
      0.1975
    ],
    [
      "congedier",
      0.1825
    ],
    [
      "chasser",
      0.07
    ],
    [
      "vider",
      0.055
    ],
    [
      "balayer",
      0.0475
    ],
    [
      "limoger",
      0.035
    ],
    [
      "licencier",
      0.035
    ],
    [
      "debarquer",
      0.035
    ],
    [
      "balancer",
      0.035
    ],
    [
      "ecarter",
      0.0275
    ],
    [
      "econduire",
      0.0275
    ],
    [
      "eloigner",
      0.0275
    ],
    [
      "liquider",
      0.02
    ],
    [
      "destituer",
      0.02
    ],
    [
      "benir",
      0.0125
    ],
    [
      "refuser",
      0.0125
    ],
    [
      "revoquer",
      0.0125
    ],
    [
      "gratifier",
      0.005
    ],
    [
      "louer",
      0.005
    ],
    [
      "saquer",
      0.005
    ],
    [
      "expedier",
      0.005
    ],
    [
      "emballer",
      0.005
    ],
    [
      "dedommager",
      0.005
    ],
    [
      "decliner",
      0.005
    ],
    [
      "debaucher",
      0.005
    ]
  ],
  "documentation": [
    [
      "descriptif",
      0.3325
    ],
    [
      "notice",
      0.3325
    ]
  ],
  "avancee": [
    [
      "marcher",
      0.065
    ],
    [
      "donner",
      0.0525
    ],
    [
      "aller",
      0.0375
    ],
    [
      "pousser",
      0.0325
    ],
    [
      "progresser",
      0.03
    ],
    [
      "venir",
      0.025
    ],
    [
      "presenter",
      0.025
    ],
    [
      "offrir",
      0.025
    ],
    [
      "tendre",
      0.0225
    ],
    [
      "s'avancer",
      0.0225
    ],
    [
      "gagner",
      0.0225
    ],
    [
      "depasser",
      0.0225
    ],
    [
      "alleguer",
      0.0225
    ],
    [
      "affirmer",
      0.0225
    ],
    [
      "reussir",
      0.0175
    ],
    [
      "precipiter",
      0.0175
    ],
    [
      "proposer",
      0.0175
    ],
    [
      "poser",
      0.0175
    ],
    [
      "brusquer",
      0.0175
    ],
    [
      "enoncer",
      0.015
    ],
    [
      "emettre",
      0.015
    ],
    [
      "soumettre",
      0.015
    ],
    [
      "pretendre",
      0.015
    ],
    [
      "profiter",
      0.015
    ],
    [
      "grandir",
      0.015
    ],
    [
      "deborder",
      0.015
    ],
    [
      "accelerer",
      0.015
    ],
    [
      "prosperer",
      0.01
    ],
    [
      "preter",
      0.01
    ],
    [
      "ressortir",
      0.01
    ],
    [
      "saillir",
      0.01
    ],
    [
      "soutenir",
      0.01
    ],
    [
      "ecrire",
      0.01
    ],
    [
      "payer",
      0.01
    ],
    [
      "hater",
      0.01
    ],
    [
      "forcer",
      0.01
    ],
    [
      "accorder",
      0.01
    ],
    [
      "aligner",
      0.01
    ],
    [
      "allonger",
      0.01
    ],
    [
      "anticiper",
      0.01
    ],
    [
      "approcher",
      0.01
    ],
    [
      "devancer",
      0.01
    ],
    [
      "empieter",
      0.01
    ],
    [
      "s'acheminer",
      0.005
    ],
    [
      "rapprocher",
      0.005
    ],
    [
      "pretexter",
      0.005
    ],
    [
      "proceder",
      0.005
    ],
    [
      "mordre",
      0.005
    ],
    [
      "degager",
      0.005
    ],
    [
      "cheminer",
      0.005
    ],
    [
      "arguer",
      0.005
    ],
    [
      "activer",
      0.005
    ],
    [
      "glisser",
      0.0025
    ],
    [
      "hasarder",
      0.0025
    ],
    [
      "opposer",
      0.0025
    ],
    [
      "s'ebranler",
      0.0025
    ],
    [
      "surplomber",
      0.0025
    ],
    [
      "fonctionner",
      0.0025
    ],
    [
      "escompter",
      0.0025
    ],
    [
      "decaler",
      0.0025
    ],
    [
      "citer",
      0.0025
    ],
    [
      "ameliorer",
      0.0025
    ],
    [
      "allouer",
      0.0025
    ],
    [
      "agiter",
      0.0025
    ],
    [
      "vieillir",
      0.0025
    ]
  ],
  "garconne": [
    [
      "fille",
      1.0
    ]
  ],
  "delicieux": [
    [
      "charmant",
      0.11
    ],
    [
      "beau",
      0.0875
    ],
    [
      "exquis",
      0.0825
    ],
    [
      "agreable",
      0.07
    ],
    [
      "bon",
      0.06
    ],
    [
      "joli",
      0.06
    ],
    [
      "ravissant",
      0.055
    ],
    [
      "merveilleux",
      0.05
    ],
    [
      "enchanteur",
      0.0425
    ],
    [
      "aimable",
      0.0375
    ],
    [
      "attrayant",
      0.0325
    ],
    [
      "adorable",
      0.0275
    ],
    [
      "doux",
      0.0275
    ],
    [
      "succulent",
      0.02
    ],
    [
      "fascinant",
      0.02
    ],
    [
      "fameux",
      0.02
    ],
    [
      "attirant",
      0.02
    ],
    [
      "savoureux",
      0.015
    ],
    [
      "excellent",
      0.015
    ],
    [
      "enivrant",
      0.015
    ],
    [
      "delicat",
      0.015
    ],
    [
      "delectable",
      0.015
    ],
    [
      "captivant",
      0.015
    ],
    [
      "attachant",
      0.01
    ],
    [
      "divin",
      0.01
    ],
    [
      "grisant",
      0.01
    ],
    [
      "suave",
      0.01
    ],
    [
      "friand",
      0.005
    ],
    [
      "prenant",
      0.005
    ]
  ],
  "condition": [
    [
      "etat",
      0.11
    ],
    [
      "situation",
      0.075
    ],
    [
      "position",
      0.06
    ],
    [
      "disposition",
      0.055
    ],
    [
      "convention",
      0.0475
    ],
    [
      "rang",
      0.0475
    ],
    [
      "modalite",
      0.04
    ],
    [
      "qualite",
      0.0325
    ],
    [
      "circonstance",
      0.0325
    ],
    [
      "cause",
      0.025
    ],
    [
      "clause",
      0.025
    ],
    [
      "conjoncture",
      0.025
    ],
    [
      "element",
      0.02
    ],
    [
      "stipulation",
      0.02
    ],
    [
      "statut",
      0.02
    ],
    [
      "sorte",
      0.02
    ],
    [
      "sort",
      0.02
    ],
    [
      "place",
      0.02
    ],
    [
      "forme",
      0.02
    ],
    [
      "destin",
      0.02
    ],
    [
      "classe",
      0.02
    ],
    [
      "evenement",
      0.0125
    ],
    [
      "traite",
      0.0125
    ],
    [
      "supposition",
      0.0125
    ],
    [
      "nature",
      0.0125
    ],
    [
      "metier",
      0.0125
    ],
    [
      "milieu",
      0.0125
    ],
    [
      "espece",
      0.0125
    ],
    [
      "donnee",
      0.0125
    ],
    [
      "posture",
      0.005
    ],
    [
      "prix",
      0.005
    ],
    [
      "prealable",
      0.005
    ],
    [
      "predisposition",
      0.005
    ],
    [
      "prerequis",
      0.005
    ],
    [
      "pretention",
      0.005
    ],
    [
      "tarif",
      0.005
    ],
    [
      "niveau",
      0.005
    ],
    [
      "hypothese",
      0.005
    ],
    [
      "fondement",
      0.005
    ],
    [
      "extraction",
      0.005
    ],
    [
      "exigence",
      0.005
    ],
    [
      "destinee",
      0.005
    ],
    [
      "conditionnement",
      0.005
    ],
    [
      "chose",
      0.005
    ],
    [
      "base",
      0.005
    ],
    [
      "auspice",
      0.005
    ],
    [
      "etre",
      0.005
    ]
  ],
  "errance": [
    [
      "course",
      0.0975
    ],
    [
      "promenade",
      0.0975
    ],
    [
      "tour",
      0.0975
    ],
    [
      "voyage",
      0.0975
    ],
    [
      "randonnee",
      0.0625
    ],
    [
      "peregrination",
      0.0625
    ],
    [
      "erreur",
      0.0625
    ],
    [
      "errements",
      0.0625
    ],
    [
      "deplacement",
      0.0625
    ],
    [
      "vagabondage",
      0.03
    ],
    [
      "reverie",
      0.03
    ],
    [
      "nomadisme",
      0.03
    ],
    [
      "instabilite",
      0.03
    ],
    [
      "hesitation",
      0.03
    ],
    [
      "flanerie",
      0.03
    ],
    [
      "aventure",
      0.03
    ],
    [
      "ambulation",
      0.03
    ],
    [
      "egarement",
      0.03
    ]
  ],
  "revue": [
    [
      "corriger",
      0.1175
    ],
    [
      "reviser",
      0.11
    ],
    [
      "retoucher",
      0.075
    ],
    [
      "repasser",
      0.0575
    ],
    [
      "chatier",
      0.05
    ],
    [
      "verifier",
      0.04
    ],
    [
      "reprendre",
      0.04
    ],
    [
      "ameliorer",
      0.0325
    ],
    [
      "rectifier",
      0.0325
    ],
    [
      "repeter",
      0.025
    ],
    [
      "reformer",
      0.025
    ],
    [
      "revivre",
      0.025
    ],
    [
      "repenser",
      0.025
    ],
    [
      "remanier",
      0.025
    ],
    [
      "polir",
      0.025
    ],
    [
      "parfaire",
      0.025
    ],
    [
      "voir",
      0.015
    ],
    [
      "recoler",
      0.015
    ],
    [
      "revisiter",
      0.015
    ],
    [
      "raboter",
      0.015
    ],
    [
      "examiner",
      0.015
    ],
    [
      "retrouver",
      0.0075
    ],
    [
      "reconsiderer",
      0.0075
    ],
    [
      "ravauder",
      0.0075
    ],
    [
      "rapiecer",
      0.0075
    ],
    [
      "rapetasser",
      0.0075
    ],
    [
      "raccommoder",
      0.0075
    ],
    [
      "limer",
      0.0075
    ],
    [
      "fatiguer",
      0.0075
    ],
    [
      "songer",
      0.0075
    ]
  ],
  "longer": [
    [
      "border",
      0.165
    ],
    [
      "cotoyer",
      0.165
    ],
    [
      "encadrer",
      0.11
    ],
    [
      "elonger",
      0.055
    ],
    [
      "suivre",
      0.055
    ],
    [
      "s'etendre",
      0.055
    ],
    [
      "raser",
      0.055
    ],
    [
      "ranger",
      0.055
    ],
    [
      "prolonger",
      0.055
    ],
    [
      "cerner",
      0.055
    ]
  ],
  "longe": [
    [
      "attache",
      0.2725
    ],
    [
      "corde",
      0.18
    ],
    [
      "laniere",
      0.18
    ],
    [
      "trait",
      0.18
    ],
    [
      "bride",
      0.09
    ],
    [
      "courroie",
      0.09
    ]
  ],
  "duvet": [
    [
      "bourre",
      0.1825
    ],
    [
      "poil",
      0.1825
    ],
    [
      "barbe",
      0.09
    ],
    [
      "bourrage",
      0.09
    ],
    [
      "coton",
      0.09
    ],
    [
      "couette",
      0.09
    ],
    [
      "plume",
      0.09
    ],
    [
      "edredon",
      0.09
    ]
  ],
  "greler": [
    [
      "gresiller",
      1.0
    ]
  ],
  "grele": [
    [
      "mince",
      0.12
    ],
    [
      "svelte",
      0.08
    ],
    [
      "menu",
      0.0625
    ],
    [
      "leger",
      0.06
    ],
    [
      "tenu",
      0.055
    ],
    [
      "delicat",
      0.05
    ],
    [
      "fluet",
      0.05
    ],
    [
      "delie",
      0.045
    ],
    [
      "fin",
      0.045
    ],
    [
      "maigre",
      0.0425
    ],
    [
      "fusele",
      0.0375
    ],
    [
      "faible",
      0.0275
    ],
    [
      "fragile",
      0.0275
    ],
    [
      "gracile",
      0.025
    ],
    [
      "elance",
      0.025
    ],
    [
      "frele",
      0.02
    ],
    [
      "petit",
      0.02
    ],
    [
      "kyrielle",
      0.015
    ],
    [
      "effile",
      0.015
    ],
    [
      "cascade",
      0.015
    ],
    [
      "avalanche",
      0.0125
    ],
    [
      "filiforme",
      0.0125
    ],
    [
      "pluie",
      0.0125
    ],
    [
      "quantite",
      0.0125
    ],
    [
      "gringalet",
      0.0075
    ],
    [
      "flot",
      0.0075
    ],
    [
      "deluge",
      0.0075
    ],
    [
      "bordee",
      0.0075
    ],
    [
      "averse",
      0.0075
    ],
    [
      "squelettique",
      0.0025
    ],
    [
      "maigriot",
      0.0025
    ],
    [
      "long",
      0.0025
    ],
    [
      "grelon",
      0.0025
    ],
    [
      "gresil",
      0.0025
    ],
    [
      "grain",
      0.0025
    ],
    [
      "degringolade",
      0.0025
    ],
    [
      "chapelet",
      0.0025
    ],
    [
      "abattee",
      0.0025
    ],
    [
      "volee",
      0.0025
    ]
  ],
  "frele": [
    [
      "fragile",
      0.1175
    ],
    [
      "delicat",
      0.08
    ],
    [
      "faible",
      0.08
    ],
    [
      "precaire",
      0.0575
    ],
    [
      "mince",
      0.0575
    ],
    [
      "menu",
      0.0575
    ],
    [
      "leger",
      0.0575
    ],
    [
      "grele",
      0.0575
    ],
    [
      "fluet",
      0.0575
    ],
    [
      "tenu",
      0.045
    ],
    [
      "malingre",
      0.035
    ],
    [
      "labile",
      0.035
    ],
    [
      "chetif",
      0.035
    ],
    [
      "ephemere",
      0.0225
    ],
    [
      "perissable",
      0.0225
    ],
    [
      "passager",
      0.0225
    ],
    [
      "gracile",
      0.0225
    ],
    [
      "fin",
      0.0225
    ],
    [
      "debile",
      0.0225
    ],
    [
      "anemie",
      0.0225
    ],
    [
      "faiblard",
      0.01
    ],
    [
      "fugitif",
      0.01
    ],
    [
      "maigrelet",
      0.01
    ],
    [
      "maigrichon",
      0.01
    ]
  ],
  "vallon": [
    [
      "ravin",
      0.25
    ],
    [
      "repli",
      0.25
    ],
    [
      "val",
      0.25
    ],
    [
      "vallee",
      0.25
    ]
  ],
  "genet": [
    [
      "cytise",
      0.5
    ],
    [
      "sarothamne",
      0.5
    ]
  ],
  "bruyere": [
    [
      "brande",
      0.5
    ],
    [
      "lande",
      0.5
    ]
  ],
  "transparence": [
    [
      "limpidite",
      0.25
    ],
    [
      "clarte",
      0.1875
    ],
    [
      "cristal",
      0.125
    ],
    [
      "verre",
      0.125
    ],
    [
      "delicatesse",
      0.06
    ],
    [
      "intelligibilite",
      0.06
    ],
    [
      "liquidite",
      0.06
    ],
    [
      "nettete",
      0.06
    ],
    [
      "translucidite",
      0.06
    ]
  ],
  "prestige": [
    [
      "charme",
      0.0725
    ],
    [
      "influence",
      0.0725
    ],
    [
      "ascendant",
      0.0625
    ],
    [
      "fascination",
      0.0625
    ],
    [
      "gloire",
      0.05
    ],
    [
      "seduction",
      0.05
    ],
    [
      "eclat",
      0.05
    ],
    [
      "reputation",
      0.04
    ],
    [
      "lustre",
      0.04
    ],
    [
      "credit",
      0.04
    ],
    [
      "autorite",
      0.04
    ],
    [
      "splendeur",
      0.03
    ],
    [
      "pouvoir",
      0.03
    ],
    [
      "magie",
      0.03
    ],
    [
      "enchantement",
      0.03
    ],
    [
      "renom",
      0.02
    ],
    [
      "rayonnement",
      0.02
    ],
    [
      "poids",
      0.02
    ],
    [
      "panache",
      0.02
    ],
    [
      "importance",
      0.02
    ],
    [
      "envoutement",
      0.02
    ],
    [
      "empire",
      0.02
    ],
    [
      "attrait",
      0.02
    ],
    [
      "allure",
      0.02
    ],
    [
      "regne",
      0.01
    ],
    [
      "relief",
      0.01
    ],
    [
      "prodige",
      0.01
    ],
    [
      "prestance",
      0.01
    ],
    [
      "majeste",
      0.01
    ],
    [
      "illusion",
      0.01
    ],
    [
      "distinction",
      0.01
    ],
    [
      "aureole",
      0.01
    ],
    [
      "sorcellerie",
      0.01
    ]
  ],
  "tonnant": [
    [
      "tonitruant",
      0.2725
    ],
    [
      "retentissant",
      0.18
    ],
    [
      "sonore",
      0.18
    ],
    [
      "assourdissant",
      0.09
    ],
    [
      "claironnant",
      0.09
    ],
    [
      "grondeur",
      0.09
    ],
    [
      "eclatant",
      0.09
    ]
  ],
  "fusiller": [
    [
      "tuer",
      0.22
    ],
    [
      "bousiller",
      0.11
    ],
    [
      "detruire",
      0.11
    ],
    [
      "abimer",
      0.0725
    ],
    [
      "harceler",
      0.035
    ],
    [
      "mitrailler",
      0.035
    ],
    [
      "percer",
      0.035
    ],
    [
      "poivrer",
      0.035
    ],
    [
      "foudroyer",
      0.035
    ],
    [
      "flinguer",
      0.035
    ],
    [
      "executer",
      0.035
    ],
    [
      "deteriorer",
      0.035
    ],
    [
      "depouiller",
      0.035
    ],
    [
      "depenser",
      0.035
    ],
    [
      "canarder",
      0.035
    ],
    [
      "railler",
      0.035
    ]
  ],
  "palette": [
    [
      "aube",
      0.1
    ],
    [
      "pale",
      0.1
    ],
    [
      "levee",
      0.1
    ],
    [
      "jantille",
      0.1
    ],
    [
      "gamme",
      0.1
    ],
    [
      "cuiller",
      0.1
    ],
    [
      "couchoir",
      0.1
    ],
    [
      "battoir",
      0.1
    ],
    [
      "batte",
      0.1
    ],
    [
      "paleron",
      0.1
    ]
  ],
  "multiplier": [
    [
      "augmenter",
      0.19
    ],
    [
      "grossir",
      0.08
    ],
    [
      "accroitre",
      0.0575
    ],
    [
      "amplifier",
      0.0575
    ],
    [
      "doubler",
      0.04
    ],
    [
      "croitre",
      0.04
    ],
    [
      "agrandir",
      0.04
    ],
    [
      "hausser",
      0.0275
    ],
    [
      "propager",
      0.0275
    ],
    [
      "redoubler",
      0.0275
    ],
    [
      "etendre",
      0.0175
    ],
    [
      "reproduire",
      0.0175
    ],
    [
      "pulluler",
      0.0175
    ],
    [
      "proliferer",
      0.0175
    ],
    [
      "majorer",
      0.0175
    ],
    [
      "intensifier",
      0.0175
    ],
    [
      "foisonner",
      0.0175
    ],
    [
      "exagerer",
      0.0175
    ],
    [
      "centupler",
      0.0175
    ],
    [
      "s'amplifier",
      0.0075
    ],
    [
      "s'etendre",
      0.0075
    ],
    [
      "semer",
      0.0075
    ],
    [
      "septupler",
      0.0075
    ],
    [
      "sextupler",
      0.0075
    ],
    [
      "repeter",
      0.0075
    ],
    [
      "quintupler",
      0.0075
    ],
    [
      "quadrupler",
      0.0075
    ],
    [
      "peupler",
      0.0075
    ],
    [
      "octupler",
      0.0075
    ],
    [
      "nonupler",
      0.0075
    ],
    [
      "entasser",
      0.0075
    ],
    [
      "decupler",
      0.0075
    ],
    [
      "cuber",
      0.0075
    ],
    [
      "tripler",
      0.0075
    ]
  ],
  "commune": [
    [
      "vulgaire",
      0.09
    ],
    [
      "ordinaire",
      0.0675
    ],
    [
      "trivial",
      0.06
    ],
    [
      "banal",
      0.055
    ],
    [
      "courant",
      0.045
    ],
    [
      "bas",
      0.04
    ],
    [
      "mediocre",
      0.03
    ],
    [
      "peuple",
      0.0275
    ],
    [
      "prosaique",
      0.025
    ],
    [
      "populaire",
      0.025
    ],
    [
      "general",
      0.025
    ],
    [
      "grossier",
      0.0225
    ],
    [
      "plat",
      0.0225
    ],
    [
      "public",
      0.0225
    ],
    [
      "quelconque",
      0.0225
    ],
    [
      "populacier",
      0.0175
    ],
    [
      "habituel",
      0.0175
    ],
    [
      "foule",
      0.0175
    ],
    [
      "vil",
      0.015
    ],
    [
      "moyen",
      0.015
    ],
    [
      "masse",
      0.015
    ],
    [
      "connu",
      0.015
    ],
    [
      "bourgeois",
      0.015
    ],
    [
      "canaille",
      0.0125
    ],
    [
      "collectif",
      0.0125
    ],
    [
      "populace",
      0.0125
    ],
    [
      "repandu",
      0.0075
    ],
    [
      "semblable",
      0.0075
    ],
    [
      "usite",
      0.0075
    ],
    [
      "usuel",
      0.0075
    ],
    [
      "roturier",
      0.0075
    ],
    [
      "rebattu",
      0.0075
    ],
    [
      "poissard",
      0.0075
    ],
    [
      "gros",
      0.0075
    ],
    [
      "familier",
      0.0075
    ],
    [
      "contigu",
      0.0075
    ],
    [
      "mitoyen",
      0.005
    ],
    [
      "pauvre",
      0.005
    ],
    [
      "unanime",
      0.005
    ],
    [
      "universel",
      0.005
    ],
    [
      "identique",
      0.005
    ],
    [
      "frequent",
      0.005
    ],
    [
      "ensemble",
      0.005
    ],
    [
      "comparable",
      0.005
    ],
    [
      "analogique",
      0.005
    ],
    [
      "abondant",
      0.005
    ],
    [
      "prolo",
      0.0025
    ],
    [
      "popu",
      0.0025
    ],
    [
      "partage",
      0.0025
    ],
    [
      "naturel",
      0.0025
    ],
    [
      "meme",
      0.0025
    ],
    [
      "roture",
      0.0025
    ],
    [
      "services",
      0.0025
    ],
    [
      "simultane",
      0.0025
    ],
    [
      "standard",
      0.0025
    ],
    [
      "use",
      0.0025
    ],
    [
      "utilitaire",
      0.0025
    ],
    [
      "monde",
      0.0025
    ],
    [
      "materiel",
      0.0025
    ],
    [
      "marchand",
      0.0025
    ],
    [
      "accoutume",
      0.0025
    ],
    [
      "aile",
      0.0025
    ],
    [
      "appellatif",
      0.0025
    ],
    [
      "communal",
      0.0025
    ],
    [
      "d'ensemble",
      0.0025
    ],
    [
      "debarras",
      0.0025
    ],
    [
      "democratique",
      0.0025
    ],
    [
      "generalite",
      0.0025
    ],
    [
      "generique",
      0.0025
    ],
    [
      "indivis",
      0.0025
    ],
    [
      "inferieur",
      0.0025
    ],
    [
      "inelegant",
      0.0025
    ],
    [
      "epicier",
      0.0025
    ]
  ],
  "travailleur": [
    [
      "laborieux",
      0.085
    ],
    [
      "applique",
      0.07
    ],
    [
      "manoeuvre",
      0.07
    ],
    [
      "zele",
      0.07
    ],
    [
      "vaillant",
      0.055
    ],
    [
      "ouvrier",
      0.055
    ],
    [
      "diligent",
      0.055
    ],
    [
      "actif",
      0.055
    ],
    [
      "bucheur",
      0.0425
    ],
    [
      "studieux",
      0.0275
    ],
    [
      "salarie",
      0.0275
    ],
    [
      "manouvrier",
      0.0275
    ],
    [
      "journalier",
      0.0275
    ],
    [
      "courageux",
      0.0275
    ],
    [
      "acharne",
      0.0275
    ],
    [
      "piocheur",
      0.0125
    ],
    [
      "prolo",
      0.0125
    ],
    [
      "proletaire",
      0.0125
    ],
    [
      "specialiste",
      0.0125
    ],
    [
      "trimardeur",
      0.0125
    ],
    [
      "trimeur",
      0.0125
    ],
    [
      "menestrel",
      0.0125
    ],
    [
      "mercenaire",
      0.0125
    ],
    [
      "employe",
      0.0125
    ],
    [
      "consciencieux",
      0.0125
    ],
    [
      "compagnon",
      0.0125
    ],
    [
      "chambrelan",
      0.0125
    ],
    [
      "bras",
      0.0125
    ],
    [
      "bosseur",
      0.0125
    ],
    [
      "assidu",
      0.0125
    ],
    [
      "tacheron",
      0.0125
    ]
  ],
  "obstiner": [],
  "obstine": [
    [
      "opiniatre",
      0.17
    ],
    [
      "tenace",
      0.1125
    ],
    [
      "tetu",
      0.1125
    ],
    [
      "perseverant",
      0.1025
    ],
    [
      "ferme",
      0.0775
    ],
    [
      "constant",
      0.0675
    ],
    [
      "entete",
      0.055
    ],
    [
      "acharne",
      0.045
    ],
    [
      "volontaire",
      0.045
    ],
    [
      "persistant",
      0.0325
    ],
    [
      "patient",
      0.0325
    ],
    [
      "intraitable",
      0.0325
    ],
    [
      "assidu",
      0.02
    ],
    [
      "coriace",
      0.02
    ],
    [
      "resolu",
      0.02
    ],
    [
      "bute",
      0.01
    ],
    [
      "entier",
      0.01
    ]
  ],
  "affiche": [
    [
      "annonce",
      0.19
    ],
    [
      "ecriteau",
      0.1025
    ],
    [
      "prospectus",
      0.0825
    ],
    [
      "avis",
      0.0625
    ],
    [
      "proclamation",
      0.0625
    ],
    [
      "programme",
      0.0625
    ],
    [
      "tract",
      0.04
    ],
    [
      "reclame",
      0.04
    ],
    [
      "placard",
      0.04
    ],
    [
      "pancarte",
      0.04
    ],
    [
      "manifestation",
      0.04
    ],
    [
      "publicite",
      0.02
    ],
    [
      "poster",
      0.02
    ],
    [
      "panneau",
      0.02
    ],
    [
      "ostentation",
      0.02
    ],
    [
      "inscription",
      0.02
    ],
    [
      "enseigne",
      0.02
    ],
    [
      "demonstration",
      0.02
    ],
    [
      "distribution",
      0.02
    ],
    [
      "affichette",
      0.02
    ],
    [
      "affectation",
      0.02
    ],
    [
      "ecrit",
      0.02
    ]
  ],
  "soixante": [],
  "faveur": [
    [
      "grace",
      0.0875
    ],
    [
      "bienfait",
      0.07
    ],
    [
      "avantage",
      0.0475
    ],
    [
      "don",
      0.0475
    ],
    [
      "bien",
      0.04
    ],
    [
      "service",
      0.04
    ],
    [
      "complaisance",
      0.035
    ],
    [
      "aide",
      0.035
    ],
    [
      "bienveillance",
      0.0275
    ],
    [
      "bonte",
      0.0275
    ],
    [
      "benediction",
      0.0275
    ],
    [
      "privilege",
      0.0225
    ],
    [
      "liberalite",
      0.0225
    ],
    [
      "honneur",
      0.0225
    ],
    [
      "consideration",
      0.0225
    ],
    [
      "benefice",
      0.0225
    ],
    [
      "amitie",
      0.0225
    ],
    [
      "protection",
      0.02
    ],
    [
      "estime",
      0.02
    ],
    [
      "cadeau",
      0.02
    ],
    [
      "egards",
      0.015
    ],
    [
      "preference",
      0.015
    ],
    [
      "popularite",
      0.015
    ],
    [
      "plaisir",
      0.015
    ],
    [
      "gratification",
      0.015
    ],
    [
      "gracieusete",
      0.015
    ],
    [
      "celebrite",
      0.015
    ],
    [
      "credit",
      0.015
    ],
    [
      "bonheur",
      0.015
    ],
    [
      "prerogative",
      0.01
    ],
    [
      "distinction",
      0.01
    ],
    [
      "aumone",
      0.01
    ],
    [
      "vogue",
      0.0075
    ],
    [
      "sympathie",
      0.0075
    ],
    [
      "recompense",
      0.0075
    ],
    [
      "recommandation",
      0.0075
    ],
    [
      "predilection",
      0.0075
    ],
    [
      "piston",
      0.0075
    ],
    [
      "indulgence",
      0.0075
    ],
    [
      "caresse",
      0.0075
    ],
    [
      "appui",
      0.0075
    ],
    [
      "repechage",
      0.0025
    ],
    [
      "profit",
      0.0025
    ],
    [
      "oreille",
      0.0025
    ],
    [
      "ferveur",
      0.0025
    ],
    [
      "favoritisme",
      0.0025
    ],
    [
      "dispense",
      0.0025
    ],
    [
      "chance",
      0.0025
    ],
    [
      "ruban",
      0.0025
    ]
  ],
  "bienfaisant": [
    [
      "bon",
      0.2725
    ],
    [
      "favorable",
      0.1175
    ],
    [
      "tutelaire",
      0.0575
    ],
    [
      "salutaire",
      0.0575
    ],
    [
      "charitable",
      0.0575
    ],
    [
      "benefique",
      0.0575
    ],
    [
      "bienfaiteur",
      0.0575
    ],
    [
      "avantageux",
      0.0575
    ],
    [
      "serviable",
      0.0375
    ],
    [
      "propice",
      0.0375
    ],
    [
      "profitable",
      0.0375
    ],
    [
      "philanthrope",
      0.0375
    ],
    [
      "efficace",
      0.0175
    ],
    [
      "gracieux",
      0.0175
    ],
    [
      "genereux",
      0.0175
    ],
    [
      "humain",
      0.0175
    ],
    [
      "philanthropique",
      0.0175
    ]
  ],
  "pansement": [
    [
      "bandage",
      0.1425
    ],
    [
      "charpie",
      0.1425
    ],
    [
      "compresse",
      0.1425
    ],
    [
      "gaze",
      0.1425
    ],
    [
      "pansage",
      0.1425
    ],
    [
      "poupee",
      0.1425
    ],
    [
      "remede",
      0.1425
    ]
  ],
  "gueri": [
    [
      "remis",
      0.3325
    ],
    [
      "retabli",
      0.3325
    ]
  ],
  "kaki": [
    [
      "jaune",
      0.3875
    ],
    [
      "brun",
      0.075
    ],
    [
      "chamois",
      0.075
    ],
    [
      "fauve",
      0.075
    ],
    [
      "flavescent",
      0.075
    ],
    [
      "grege",
      0.075
    ],
    [
      "marron",
      0.075
    ],
    [
      "ocre",
      0.075
    ],
    [
      "saure",
      0.075
    ]
  ],
  "generique": [
    [
      "commun",
      0.3325
    ],
    [
      "general",
      0.3325
    ],
    [
      "indicatif",
      0.3325
    ]
  ],
  "curry": [],
  "framboise": [],
  "collection": [
    [
      "assemblage",
      0.07
    ],
    [
      "amas",
      0.0625
    ],
    [
      "recueil",
      0.055
    ],
    [
      "quantite",
      0.0425
    ],
    [
      "attirail",
      0.035
    ],
    [
      "reunion",
      0.035
    ],
    [
      "tas",
      0.035
    ],
    [
      "groupe",
      0.0275
    ],
    [
      "ensemble",
      0.0275
    ],
    [
      "arsenal",
      0.0275
    ],
    [
      "appareil",
      0.0275
    ],
    [
      "selection",
      0.02
    ],
    [
      "ribambelle",
      0.02
    ],
    [
      "ramas",
      0.02
    ],
    [
      "foule",
      0.02
    ],
    [
      "choix",
      0.02
    ],
    [
      "assortiment",
      0.02
    ],
    [
      "anthologie",
      0.02
    ],
    [
      "serie",
      0.0125
    ],
    [
      "suite",
      0.0125
    ],
    [
      "rhapsodie",
      0.0125
    ],
    [
      "ramassis",
      0.0125
    ],
    [
      "publication",
      0.0125
    ],
    [
      "pinacotheque",
      0.0125
    ],
    [
      "melanges",
      0.0125
    ],
    [
      "musee",
      0.0125
    ],
    [
      "compilation",
      0.0125
    ],
    [
      "cabinet",
      0.0125
    ],
    [
      "bibliotheque",
      0.0125
    ],
    [
      "accumulation",
      0.0125
    ],
    [
      "nombre",
      0.005
    ],
    [
      "menagerie",
      0.005
    ],
    [
      "mediatheque",
      0.005
    ],
    [
      "medaillier",
      0.005
    ],
    [
      "ludotheque",
      0.005
    ],
    [
      "joujoutheque",
      0.005
    ],
    [
      "philatelie",
      0.005
    ],
    [
      "pus",
      0.005
    ],
    [
      "rituel",
      0.005
    ],
    [
      "tirage",
      0.005
    ],
    [
      "variete",
      0.005
    ],
    [
      "vitrine",
      0.005
    ],
    [
      "echantillonnage",
      0.005
    ],
    [
      "edition",
      0.005
    ],
    [
      "iconographie",
      0.005
    ],
    [
      "herbier",
      0.005
    ],
    [
      "genie",
      0.005
    ],
    [
      "ana",
      0.005
    ],
    [
      "bibelotage",
      0.005
    ],
    [
      "cargaison",
      0.005
    ],
    [
      "catalogue",
      0.005
    ],
    [
      "cinematheque",
      0.005
    ],
    [
      "code",
      0.005
    ],
    [
      "coquillier",
      0.005
    ],
    [
      "corps",
      0.005
    ],
    [
      "discotheque",
      0.005
    ],
    [
      "esprit",
      0.005
    ],
    [
      "famille",
      0.005
    ],
    [
      "galerie",
      0.005
    ],
    [
      "album",
      0.005
    ]
  ],
  "inserer": [
    [
      "introduire",
      0.14
    ],
    [
      "intercaler",
      0.0975
    ],
    [
      "enchasser",
      0.0525
    ],
    [
      "incorporer",
      0.0525
    ],
    [
      "joindre",
      0.0525
    ],
    [
      "sertir",
      0.0525
    ],
    [
      "inclure",
      0.0425
    ],
    [
      "mettre",
      0.03
    ],
    [
      "greffer",
      0.03
    ],
    [
      "glisser",
      0.03
    ],
    [
      "encastrer",
      0.03
    ],
    [
      "ajouter",
      0.03
    ],
    [
      "truffer",
      0.02
    ],
    [
      "integrer",
      0.02
    ],
    [
      "interposer",
      0.02
    ],
    [
      "interpoler",
      0.02
    ],
    [
      "imbriquer",
      0.02
    ],
    [
      "entrer",
      0.02
    ],
    [
      "entrelarder",
      0.02
    ],
    [
      "enclaver",
      0.02
    ],
    [
      "encarter",
      0.02
    ],
    [
      "emplir",
      0.02
    ],
    [
      "emboiter",
      0.02
    ],
    [
      "interfolier",
      0.0075
    ],
    [
      "incruster",
      0.0075
    ],
    [
      "implanter",
      0.0075
    ],
    [
      "immatriculer",
      0.0075
    ],
    [
      "fourrer",
      0.0075
    ],
    [
      "entremeler",
      0.0075
    ],
    [
      "enter",
      0.0075
    ],
    [
      "enchatonner",
      0.0075
    ],
    [
      "encadrer",
      0.0075
    ],
    [
      "remplir",
      0.0075
    ]
  ],
  "fonce": [
    [
      "courir",
      0.0875
    ],
    [
      "fondre",
      0.0725
    ],
    [
      "s'elancer",
      0.0675
    ],
    [
      "attaquer",
      0.0525
    ],
    [
      "piquer",
      0.0425
    ],
    [
      "fuser",
      0.0425
    ],
    [
      "sauter",
      0.035
    ],
    [
      "voler",
      0.035
    ],
    [
      "bondir",
      0.02
    ],
    [
      "charger",
      0.02
    ],
    [
      "filer",
      0.02
    ],
    [
      "obscurcir",
      0.0125
    ],
    [
      "enfoncer",
      0.0125
    ],
    [
      "brunir",
      0.0125
    ],
    [
      "galoper",
      0.005
    ],
    [
      "gazer",
      0.005
    ],
    [
      "ombrer",
      0.005
    ],
    [
      "payer",
      0.005
    ],
    [
      "poursuivre",
      0.005
    ],
    [
      "s'obscurcir",
      0.005
    ],
    [
      "financer",
      0.005
    ],
    [
      "enjabler",
      0.005
    ],
    [
      "creuser",
      0.005
    ],
    [
      "casquer",
      0.005
    ],
    [
      "bomber",
      0.005
    ],
    [
      "batailler",
      0.005
    ],
    [
      "barouder",
      0.005
    ],
    [
      "assombrir",
      0.005
    ],
    [
      "sprinter",
      0.005
    ]
  ],
  "juif": [
    [
      "israelite",
      0.3325
    ],
    [
      "hebraique",
      0.165
    ],
    [
      "hebreu",
      0.165
    ],
    [
      "judaique",
      0.165
    ],
    [
      "judeen",
      0.165
    ]
  ],
  "caillasse": [
    [
      "pierraille",
      0.22
    ],
    [
      "pierre",
      0.22
    ],
    [
      "caillou",
      0.11
    ],
    [
      "deblai",
      0.11
    ],
    [
      "decharge",
      0.11
    ],
    [
      "rocaille",
      0.11
    ],
    [
      "roche",
      0.11
    ]
  ],
  "peniche": [
    [
      "bateau",
      0.25
    ],
    [
      "chaloupe",
      0.125
    ],
    [
      "chaussure",
      0.125
    ],
    [
      "soulier",
      0.125
    ],
    [
      "molusson",
      0.0625
    ],
    [
      "godillot",
      0.0625
    ],
    [
      "embarcation",
      0.0625
    ],
    [
      "chaland",
      0.0625
    ],
    [
      "barge",
      0.0625
    ],
    [
      "pompe",
      0.0625
    ]
  ],
  "union": [
    [
      "accord",
      0.07
    ],
    [
      "reunion",
      0.0675
    ],
    [
      "association",
      0.0575
    ],
    [
      "alliance",
      0.05
    ],
    [
      "assemblage",
      0.05
    ],
    [
      "harmonie",
      0.0425
    ],
    [
      "entente",
      0.0425
    ],
    [
      "liaison",
      0.0325
    ],
    [
      "fraternite",
      0.03
    ],
    [
      "rapport",
      0.0275
    ],
    [
      "coalition",
      0.025
    ],
    [
      "combinaison",
      0.0225
    ],
    [
      "accouplement",
      0.02
    ],
    [
      "amitie",
      0.02
    ],
    [
      "groupement",
      0.02
    ],
    [
      "jonction",
      0.0175
    ],
    [
      "ligue",
      0.015
    ],
    [
      "conjonction",
      0.015
    ],
    [
      "societe",
      0.0125
    ],
    [
      "rapprochement",
      0.0125
    ],
    [
      "melange",
      0.0125
    ],
    [
      "federation",
      0.0125
    ],
    [
      "fusion",
      0.0125
    ],
    [
      "ensemble",
      0.0125
    ],
    [
      "unite",
      0.0075
    ],
    [
      "relation",
      0.0075
    ],
    [
      "intelligence",
      0.0075
    ],
    [
      "correspondance",
      0.0075
    ],
    [
      "concert",
      0.0075
    ],
    [
      "coherence",
      0.0075
    ],
    [
      "bloc",
      0.0075
    ],
    [
      "attachement",
      0.0075
    ],
    [
      "adherence",
      0.0075
    ],
    [
      "sympathie",
      0.005
    ],
    [
      "mariage",
      0.005
    ],
    [
      "lien",
      0.005
    ],
    [
      "connexion",
      0.005
    ],
    [
      "conjugaison",
      0.005
    ],
    [
      "confederation",
      0.005
    ],
    [
      "conformite",
      0.005
    ],
    [
      "communion",
      0.005
    ],
    [
      "chaine",
      0.005
    ],
    [
      "etreinte",
      0.005
    ],
    [
      "parti",
      0.005
    ],
    [
      "paix",
      0.005
    ],
    [
      "integration",
      0.005
    ],
    [
      "intimite",
      0.005
    ],
    [
      "concorde",
      0.005
    ],
    [
      "collusion",
      0.005
    ],
    [
      "amalgame",
      0.005
    ],
    [
      "affection",
      0.005
    ],
    [
      "abouchement",
      0.005
    ],
    [
      "fusionnement",
      0.0025
    ],
    [
      "joint",
      0.0025
    ],
    [
      "rassemblement",
      0.0025
    ],
    [
      "traite",
      0.0025
    ],
    [
      "unisson",
      0.0025
    ],
    [
      "front",
      0.0025
    ],
    [
      "emboitement",
      0.0025
    ],
    [
      "coit",
      0.0025
    ],
    [
      "complicite",
      0.0025
    ],
    [
      "colonie",
      0.0025
    ],
    [
      "camaraderie",
      0.0025
    ],
    [
      "branchement",
      0.0025
    ],
    [
      "symbiose",
      0.0
    ],
    [
      "symphonie",
      0.0
    ],
    [
      "syncretisme",
      0.0
    ],
    [
      "syndicat",
      0.0
    ],
    [
      "trait",
      0.0
    ],
    [
      "tranquillite",
      0.0
    ],
    [
      "hymen",
      0.0
    ],
    [
      "embrassement",
      0.0
    ],
    [
      "copulation",
      0.0
    ],
    [
      "convention",
      0.0
    ],
    [
      "contexture",
      0.0
    ],
    [
      "consommation",
      0.0
    ],
    [
      "concubinage",
      0.0
    ],
    [
      "zeugme",
      0.0
    ]
  ],
  "capable": [
    [
      "habile",
      0.165
    ],
    [
      "bon",
      0.065
    ],
    [
      "fort",
      0.06
    ],
    [
      "propre",
      0.06
    ],
    [
      "competent",
      0.055
    ],
    [
      "adroit",
      0.055
    ],
    [
      "apte",
      0.0475
    ],
    [
      "expert",
      0.0475
    ],
    [
      "susceptible",
      0.0425
    ],
    [
      "qualifie",
      0.0375
    ],
    [
      "experimente",
      0.0375
    ],
    [
      "intelligent",
      0.0325
    ],
    [
      "efficace",
      0.0275
    ],
    [
      "exerce",
      0.0275
    ],
    [
      "verse",
      0.0275
    ],
    [
      "ingenieux",
      0.02
    ],
    [
      "savant",
      0.02
    ],
    [
      "valable",
      0.02
    ],
    [
      "malin",
      0.015
    ],
    [
      "entendu",
      0.015
    ],
    [
      "doue",
      0.015
    ],
    [
      "taille",
      0.01
    ],
    [
      "talentueux",
      0.0025
    ],
    [
      "puissant",
      0.0025
    ],
    [
      "irresistible",
      0.0025
    ],
    [
      "industrieux",
      0.0025
    ],
    [
      "idoine",
      0.0025
    ],
    [
      "habilite",
      0.0025
    ],
    [
      "efficient",
      0.0025
    ],
    [
      "degourdi",
      0.0025
    ]
  ],
  "insaisissable": [
    [
      "impenetrable",
      0.125
    ],
    [
      "secret",
      0.1025
    ],
    [
      "mysterieux",
      0.085
    ],
    [
      "fuyant",
      0.0475
    ],
    [
      "enigmatique",
      0.0375
    ],
    [
      "obscur",
      0.0375
    ],
    [
      "invisible",
      0.0375
    ],
    [
      "inaccessible",
      0.0375
    ],
    [
      "imperceptible",
      0.03
    ],
    [
      "tenebreux",
      0.03
    ],
    [
      "subtil",
      0.0225
    ],
    [
      "sourd",
      0.0225
    ],
    [
      "sibyllin",
      0.0225
    ],
    [
      "introuvable",
      0.0225
    ],
    [
      "insondable",
      0.0225
    ],
    [
      "inintelligible",
      0.0225
    ],
    [
      "inexplicable",
      0.0225
    ],
    [
      "indefinissable",
      0.0225
    ],
    [
      "indiscernable",
      0.0225
    ],
    [
      "evanescent",
      0.015
    ],
    [
      "renferme",
      0.015
    ],
    [
      "opaque",
      0.015
    ],
    [
      "nebuleux",
      0.015
    ],
    [
      "insensible",
      0.015
    ],
    [
      "impalpable",
      0.015
    ],
    [
      "glissant",
      0.015
    ],
    [
      "fugitif",
      0.015
    ],
    [
      "fugace",
      0.015
    ],
    [
      "aerien",
      0.015
    ],
    [
      "vain",
      0.0075
    ],
    [
      "inscrutable",
      0.0075
    ],
    [
      "indecelable",
      0.0075
    ],
    [
      "imprenable",
      0.0075
    ],
    [
      "fluide",
      0.0075
    ],
    [
      "evanouissant",
      0.0075
    ]
  ],
  "ensevelir": [
    [
      "engloutir",
      0.18
    ],
    [
      "enterrer",
      0.12
    ],
    [
      "submerger",
      0.09
    ],
    [
      "plonger",
      0.09
    ],
    [
      "noyer",
      0.09
    ],
    [
      "enfouir",
      0.09
    ],
    [
      "cacher",
      0.09
    ],
    [
      "abimer",
      0.06
    ],
    [
      "detruire",
      0.06
    ],
    [
      "recouvrir",
      0.06
    ],
    [
      "inhumer",
      0.03
    ],
    [
      "tapisser",
      0.03
    ]
  ],
  "inoui": [
    [
      "extraordinaire",
      0.115
    ],
    [
      "etonnant",
      0.085
    ],
    [
      "fantastique",
      0.0825
    ],
    [
      "incroyable",
      0.0625
    ],
    [
      "sensationnel",
      0.0525
    ],
    [
      "invraisemblable",
      0.0425
    ],
    [
      "prodigieux",
      0.0425
    ],
    [
      "formidable",
      0.0375
    ],
    [
      "stupefiant",
      0.0375
    ],
    [
      "fabuleux",
      0.035
    ],
    [
      "phenomenal",
      0.035
    ],
    [
      "surprenant",
      0.03
    ],
    [
      "inimaginable",
      0.025
    ],
    [
      "inconcevable",
      0.025
    ],
    [
      "enorme",
      0.02
    ],
    [
      "faramineux",
      0.015
    ],
    [
      "rocambolesque",
      0.015
    ],
    [
      "extravagant",
      0.015
    ],
    [
      "etrange",
      0.015
    ],
    [
      "effarant",
      0.0125
    ],
    [
      "renversant",
      0.0125
    ],
    [
      "admirable",
      0.01
    ],
    [
      "merveilleux",
      0.0075
    ],
    [
      "epoustouflant",
      0.0075
    ],
    [
      "unique",
      0.005
    ],
    [
      "terrible",
      0.005
    ],
    [
      "paradoxal",
      0.005
    ],
    [
      "nouveau",
      0.005
    ],
    [
      "curieux",
      0.005
    ],
    [
      "ebouriffant",
      0.005
    ],
    [
      "inusite",
      0.005
    ],
    [
      "insoupconne",
      0.005
    ],
    [
      "ineffable",
      0.005
    ],
    [
      "fort",
      0.005
    ],
    [
      "boeuf",
      0.005
    ],
    [
      "suffocant",
      0.0025
    ],
    [
      "sublime",
      0.0025
    ],
    [
      "inedit",
      0.0025
    ],
    [
      "inexprimable",
      0.0025
    ],
    [
      "incomparable",
      0.0025
    ],
    [
      "neuf",
      0.0025
    ],
    [
      "monumental",
      0.0025
    ],
    [
      "monstre",
      0.0025
    ],
    [
      "mirobolant",
      0.0025
    ],
    [
      "inegalable",
      0.0025
    ],
    [
      "insolent",
      0.0025
    ],
    [
      "inespere",
      0.0025
    ],
    [
      "effrayant",
      0.0025
    ],
    [
      "incalculable",
      0.0025
    ],
    [
      "inconnu",
      0.0025
    ],
    [
      "indescriptible",
      0.0025
    ],
    [
      "indicible",
      0.0025
    ],
    [
      "extreme",
      0.0
    ],
    [
      "impossible",
      0.0
    ],
    [
      "inentendu",
      0.0
    ],
    [
      "lunaire",
      0.0
    ]
  ],
  "tricheur": [
    [
      "trompeur",
      0.135
    ],
    [
      "truqueur",
      0.135
    ],
    [
      "voleur",
      0.135
    ],
    [
      "fraudeur",
      0.09
    ],
    [
      "fripon",
      0.09
    ],
    [
      "pipeur",
      0.09
    ],
    [
      "maquilleur",
      0.045
    ],
    [
      "maquignon",
      0.045
    ],
    [
      "malhonnete",
      0.045
    ],
    [
      "filou",
      0.045
    ],
    [
      "dupeur",
      0.045
    ],
    [
      "biseauteur",
      0.045
    ]
  ],
  "megot": [
    [
      "clope",
      0.5
    ]
  ],
  "gramme": [
    [
      "goutte",
      0.285
    ],
    [
      "peu",
      0.285
    ],
    [
      "liard",
      0.1425
    ],
    [
      "miette",
      0.1425
    ],
    [
      "poids",
      0.1425
    ]
  ],
  "renferme": [
    [
      "enfermer",
      0.155
    ],
    [
      "contenir",
      0.0725
    ],
    [
      "emprisonner",
      0.0725
    ],
    [
      "entourer",
      0.055
    ],
    [
      "enserrer",
      0.0325
    ],
    [
      "sequestrer",
      0.0275
    ],
    [
      "tenir",
      0.025
    ],
    [
      "serrer",
      0.025
    ],
    [
      "murer",
      0.025
    ],
    [
      "boucler",
      0.025
    ],
    [
      "refouler",
      0.02
    ],
    [
      "limiter",
      0.02
    ],
    [
      "cloitrer",
      0.02
    ],
    [
      "claquemurer",
      0.02
    ],
    [
      "cacher",
      0.02
    ],
    [
      "borner",
      0.02
    ],
    [
      "enclore",
      0.015
    ],
    [
      "embrasser",
      0.015
    ],
    [
      "detenir",
      0.015
    ],
    [
      "dissimuler",
      0.015
    ],
    [
      "comprendre",
      0.015
    ],
    [
      "comporter",
      0.015
    ],
    [
      "circonscrire",
      0.015
    ],
    [
      "renfoncer",
      0.0125
    ],
    [
      "receler",
      0.0125
    ],
    [
      "parquer",
      0.0125
    ],
    [
      "interner",
      0.0125
    ],
    [
      "encercler",
      0.0125
    ],
    [
      "concentrer",
      0.0125
    ],
    [
      "ceindre",
      0.0125
    ],
    [
      "reduire",
      0.0075
    ],
    [
      "restreindre",
      0.0075
    ],
    [
      "posseder",
      0.0075
    ],
    [
      "inclure",
      0.0075
    ],
    [
      "impliquer",
      0.0075
    ],
    [
      "emmurer",
      0.0075
    ],
    [
      "consigner",
      0.0075
    ],
    [
      "coffrer",
      0.0075
    ],
    [
      "claustrer",
      0.0075
    ],
    [
      "localiser",
      0.0025
    ],
    [
      "ravaler",
      0.0025
    ],
    [
      "reclure",
      0.0025
    ],
    [
      "reprimer",
      0.0025
    ],
    [
      "verrouiller",
      0.0025
    ],
    [
      "encoffrer",
      0.0025
    ],
    [
      "emporter",
      0.0025
    ],
    [
      "emballer",
      0.0025
    ],
    [
      "devorer",
      0.0025
    ],
    [
      "confiner",
      0.0025
    ],
    [
      "chambrer",
      0.0025
    ],
    [
      "camoufler",
      0.0025
    ],
    [
      "calfeutrer",
      0.0025
    ]
  ],
  "renfermer": [
    [
      "enfermer",
      0.155
    ],
    [
      "contenir",
      0.0725
    ],
    [
      "emprisonner",
      0.0725
    ],
    [
      "entourer",
      0.055
    ],
    [
      "enserrer",
      0.0325
    ],
    [
      "sequestrer",
      0.0275
    ],
    [
      "tenir",
      0.025
    ],
    [
      "serrer",
      0.025
    ],
    [
      "murer",
      0.025
    ],
    [
      "boucler",
      0.025
    ],
    [
      "refouler",
      0.02
    ],
    [
      "limiter",
      0.02
    ],
    [
      "cloitrer",
      0.02
    ],
    [
      "claquemurer",
      0.02
    ],
    [
      "cacher",
      0.02
    ],
    [
      "borner",
      0.02
    ],
    [
      "enclore",
      0.015
    ],
    [
      "embrasser",
      0.015
    ],
    [
      "detenir",
      0.015
    ],
    [
      "dissimuler",
      0.015
    ],
    [
      "comprendre",
      0.015
    ],
    [
      "comporter",
      0.015
    ],
    [
      "circonscrire",
      0.015
    ],
    [
      "renfoncer",
      0.0125
    ],
    [
      "receler",
      0.0125
    ],
    [
      "parquer",
      0.0125
    ],
    [
      "interner",
      0.0125
    ],
    [
      "encercler",
      0.0125
    ],
    [
      "concentrer",
      0.0125
    ],
    [
      "ceindre",
      0.0125
    ],
    [
      "reduire",
      0.0075
    ],
    [
      "restreindre",
      0.0075
    ],
    [
      "posseder",
      0.0075
    ],
    [
      "inclure",
      0.0075
    ],
    [
      "impliquer",
      0.0075
    ],
    [
      "emmurer",
      0.0075
    ],
    [
      "consigner",
      0.0075
    ],
    [
      "coffrer",
      0.0075
    ],
    [
      "claustrer",
      0.0075
    ],
    [
      "localiser",
      0.0025
    ],
    [
      "ravaler",
      0.0025
    ],
    [
      "reclure",
      0.0025
    ],
    [
      "reprimer",
      0.0025
    ],
    [
      "verrouiller",
      0.0025
    ],
    [
      "encoffrer",
      0.0025
    ],
    [
      "emporter",
      0.0025
    ],
    [
      "emballer",
      0.0025
    ],
    [
      "devorer",
      0.0025
    ],
    [
      "confiner",
      0.0025
    ],
    [
      "chambrer",
      0.0025
    ],
    [
      "camoufler",
      0.0025
    ],
    [
      "calfeutrer",
      0.0025
    ]
  ],
  "saluer": [
    [
      "accueillir",
      0.09
    ],
    [
      "s'incliner",
      0.09
    ],
    [
      "reverer",
      0.09
    ],
    [
      "respecter",
      0.09
    ],
    [
      "honorer",
      0.09
    ],
    [
      "applaudir",
      0.09
    ],
    [
      "visiter",
      0.09
    ]
  ],
  "malfrat": [
    [
      "malfaiteur",
      0.5
    ],
    [
      "truand",
      0.5
    ]
  ],
  "negre": [
    [
      "allonyme",
      0.1
    ],
    [
      "melanoderme",
      0.1
    ],
    [
      "moricaud",
      0.1
    ],
    [
      "marron",
      0.1
    ],
    [
      "manoeuvre",
      0.1
    ],
    [
      "bamboula",
      0.1
    ],
    [
      "auteur",
      0.1
    ],
    [
      "associe",
      0.1
    ],
    [
      "sciene",
      0.1
    ]
  ],
  "event": [
    [
      "conduit",
      0.25
    ],
    [
      "fissure",
      0.25
    ],
    [
      "narine",
      0.25
    ],
    [
      "ouverture",
      0.25
    ]
  ],
  "hymen": [
    [
      "mariage",
      0.3
    ],
    [
      "amour",
      0.1
    ],
    [
      "hymenee",
      0.1
    ],
    [
      "noce",
      0.1
    ],
    [
      "pucelage",
      0.1
    ],
    [
      "reunion",
      0.1
    ],
    [
      "union",
      0.1
    ],
    [
      "virginite",
      0.1
    ]
  ],
  "taquiner": [
    [
      "asticoter",
      0.0975
    ],
    [
      "tourmenter",
      0.0975
    ],
    [
      "agacer",
      0.085
    ],
    [
      "plaisanter",
      0.07
    ],
    [
      "turlupiner",
      0.055
    ],
    [
      "piquer",
      0.055
    ],
    [
      "exciter",
      0.055
    ],
    [
      "blaguer",
      0.055
    ],
    [
      "chahuter",
      0.04
    ],
    [
      "chatouiller",
      0.04
    ],
    [
      "chiffonner",
      0.04
    ],
    [
      "s'amuser",
      0.0275
    ],
    [
      "lutiner",
      0.0275
    ],
    [
      "jouer",
      0.0275
    ],
    [
      "harceler",
      0.0275
    ],
    [
      "brimer",
      0.0275
    ],
    [
      "badiner",
      0.0275
    ],
    [
      "mecaniser",
      0.0125
    ],
    [
      "lanciner",
      0.0125
    ],
    [
      "inquieter",
      0.0125
    ],
    [
      "enrager",
      0.0125
    ],
    [
      "chipoter",
      0.0125
    ],
    [
      "chiner",
      0.0125
    ],
    [
      "charrier",
      0.0125
    ],
    [
      "picoter",
      0.0125
    ]
  ],
  "demenageur": [
    [
      "porteur",
      1.0
    ]
  ],
  "menage": [
    [
      "foyer",
      0.125
    ],
    [
      "maison",
      0.125
    ],
    [
      "economie",
      0.125
    ],
    [
      "famille",
      0.0825
    ],
    [
      "gouvernement",
      0.0825
    ],
    [
      "mobilier",
      0.04
    ],
    [
      "politique",
      0.04
    ],
    [
      "popote",
      0.04
    ],
    [
      "proprete",
      0.04
    ],
    [
      "mariage",
      0.04
    ],
    [
      "maisonnee",
      0.04
    ],
    [
      "feu",
      0.04
    ],
    [
      "domestique",
      0.04
    ],
    [
      "couple",
      0.04
    ],
    [
      "administration",
      0.04
    ],
    [
      "epargne",
      0.04
    ]
  ],
  "pepiniere": [
    [
      "arboriculture",
      0.1325
    ],
    [
      "source",
      0.1325
    ],
    [
      "seminaire",
      0.1325
    ],
    [
      "sylviculture",
      0.065
    ],
    [
      "origine",
      0.065
    ],
    [
      "mine",
      0.065
    ],
    [
      "jauge",
      0.065
    ],
    [
      "jardin",
      0.065
    ],
    [
      "horticulture",
      0.065
    ],
    [
      "couvent",
      0.065
    ],
    [
      "boisement",
      0.065
    ],
    [
      "ecole",
      0.065
    ]
  ],
  "bibi": [
    [
      "bugne",
      0.165
    ],
    [
      "chapeau",
      0.165
    ],
    [
      "coiffure",
      0.165
    ],
    [
      "galurin",
      0.165
    ],
    [
      "moi",
      0.165
    ],
    [
      "mezigue",
      0.165
    ]
  ],
  "enquete": [
    [
      "recherche",
      0.2325
    ],
    [
      "examen",
      0.165
    ],
    [
      "information",
      0.1
    ],
    [
      "investigation",
      0.1
    ],
    [
      "etude",
      0.065
    ],
    [
      "questionnaire",
      0.065
    ],
    [
      "observation",
      0.065
    ],
    [
      "consultation",
      0.065
    ],
    [
      "instruction",
      0.0325
    ],
    [
      "perquisition",
      0.0325
    ],
    [
      "quete",
      0.0325
    ],
    [
      "sondage",
      0.0325
    ]
  ],
  "vroum": [],
  "keuf": [],
  "ventriloque": [],
  "lascar": [
    [
      "gaillard",
      0.24
    ],
    [
      "loustic",
      0.1375
    ],
    [
      "drole",
      0.1025
    ],
    [
      "type",
      0.1025
    ],
    [
      "numero",
      0.0675
    ],
    [
      "luron",
      0.0675
    ],
    [
      "homme",
      0.0675
    ],
    [
      "briscard",
      0.0675
    ],
    [
      "bougre",
      0.0675
    ],
    [
      "phenomene",
      0.0675
    ]
  ],
  "braise": [
    [
      "brandon",
      0.1425
    ],
    [
      "feu",
      0.1425
    ],
    [
      "tison",
      0.1425
    ],
    [
      "etincelle",
      0.1425
    ],
    [
      "flamme",
      0.07
    ],
    [
      "charbon",
      0.07
    ],
    [
      "braisette",
      0.07
    ],
    [
      "bois",
      0.07
    ],
    [
      "argent",
      0.07
    ],
    [
      "picaillon",
      0.07
    ]
  ],
  "braiser": [
    [
      "cuire",
      0.5
    ],
    [
      "chauffer",
      0.25
    ],
    [
      "fricasser",
      0.25
    ]
  ],
  "decompresser": [
    [
      "dilater",
      0.11
    ],
    [
      "decomprimer",
      0.11
    ],
    [
      "detendre",
      0.11
    ]
  ],
  "business": [
    [
      "affaire",
      0.2725
    ],
    [
      "occupation",
      0.18
    ],
    [
      "affaires",
      0.09
    ],
    [
      "besogne",
      0.09
    ],
    [
      "bisness",
      0.09
    ],
    [
      "negoce",
      0.09
    ],
    [
      "travail",
      0.09
    ],
    [
      "truc",
      0.09
    ]
  ],
  "remede": [
    [
      "medicament",
      0.0525
    ],
    [
      "topique",
      0.03
    ],
    [
      "therapeutique",
      0.03
    ],
    [
      "sinapisme",
      0.03
    ],
    [
      "onguent",
      0.03
    ],
    [
      "moyen",
      0.03
    ],
    [
      "emplatre",
      0.03
    ],
    [
      "drogue",
      0.03
    ],
    [
      "cataplasme",
      0.03
    ],
    [
      "traitement",
      0.0225
    ],
    [
      "tisane",
      0.0225
    ],
    [
      "ressource",
      0.0225
    ],
    [
      "palliatif",
      0.0225
    ],
    [
      "medication",
      0.0225
    ],
    [
      "lavage",
      0.0225
    ],
    [
      "baume",
      0.0225
    ],
    [
      "antidote",
      0.0225
    ],
    [
      "recours",
      0.0125
    ],
    [
      "regime",
      0.0125
    ],
    [
      "solution",
      0.0125
    ],
    [
      "soulagement",
      0.0125
    ],
    [
      "specifique",
      0.0125
    ],
    [
      "purge",
      0.0125
    ],
    [
      "purgation",
      0.0125
    ],
    [
      "potion",
      0.0125
    ],
    [
      "compresse",
      0.0125
    ],
    [
      "injection",
      0.0125
    ],
    [
      "medecine",
      0.0125
    ],
    [
      "panacee",
      0.0125
    ],
    [
      "perfusion",
      0.0125
    ],
    [
      "refuge",
      0.005
    ],
    [
      "preservatif",
      0.005
    ],
    [
      "preparation",
      0.005
    ],
    [
      "preparatif",
      0.005
    ],
    [
      "ponction",
      0.005
    ],
    [
      "pommade",
      0.005
    ],
    [
      "placebo",
      0.005
    ],
    [
      "piqure",
      0.005
    ],
    [
      "pansement",
      0.005
    ],
    [
      "orvietan",
      0.005
    ],
    [
      "relaxation",
      0.005
    ],
    [
      "revulsif",
      0.005
    ],
    [
      "reeducation",
      0.005
    ],
    [
      "epitheme",
      0.005
    ],
    [
      "emulsion",
      0.005
    ],
    [
      "electuaire",
      0.005
    ],
    [
      "vesicatoire",
      0.005
    ],
    [
      "transfusion",
      0.005
    ],
    [
      "theriaque",
      0.005
    ],
    [
      "serum",
      0.005
    ],
    [
      "suralimentation",
      0.005
    ],
    [
      "specialite",
      0.005
    ],
    [
      "saignee",
      0.005
    ],
    [
      "mithridate",
      0.005
    ],
    [
      "massage",
      0.005
    ],
    [
      "douche",
      0.005
    ],
    [
      "diete",
      0.005
    ],
    [
      "cure",
      0.005
    ],
    [
      "contrepoison",
      0.005
    ],
    [
      "confection",
      0.005
    ],
    [
      "charme",
      0.005
    ],
    [
      "cautere",
      0.005
    ],
    [
      "calmant",
      0.005
    ],
    [
      "bouillon",
      0.005
    ],
    [
      "bain",
      0.005
    ],
    [
      "enveloppement",
      0.005
    ],
    [
      "expedient",
      0.005
    ],
    [
      "lavement",
      0.005
    ],
    [
      "insufflation",
      0.005
    ],
    [
      "instillation",
      0.005
    ],
    [
      "inhalation",
      0.005
    ],
    [
      "infusion",
      0.005
    ],
    [
      "implantation",
      0.005
    ],
    [
      "grog",
      0.005
    ],
    [
      "gargarisme",
      0.005
    ],
    [
      "fumigation",
      0.005
    ],
    [
      "friction",
      0.005
    ],
    [
      "acupuncture",
      0.005
    ]
  ],
  "reparer": [
    [
      "restaurer",
      0.09
    ],
    [
      "retaper",
      0.0525
    ],
    [
      "corriger",
      0.0475
    ],
    [
      "raccommoder",
      0.04
    ],
    [
      "refaire",
      0.04
    ],
    [
      "retablir",
      0.035
    ],
    [
      "remonter",
      0.035
    ],
    [
      "arranger",
      0.03
    ],
    [
      "racheter",
      0.03
    ],
    [
      "reconforter",
      0.025
    ],
    [
      "relever",
      0.025
    ],
    [
      "compenser",
      0.025
    ],
    [
      "rafistoler",
      0.02
    ],
    [
      "rafraichir",
      0.02
    ],
    [
      "reprendre",
      0.02
    ],
    [
      "revigorer",
      0.015
    ],
    [
      "repriser",
      0.015
    ],
    [
      "remanier",
      0.015
    ],
    [
      "redresser",
      0.015
    ],
    [
      "ameliorer",
      0.015
    ],
    [
      "suppleer",
      0.0125
    ],
    [
      "soutenir",
      0.0125
    ],
    [
      "reviser",
      0.0125
    ],
    [
      "renover",
      0.0125
    ],
    [
      "regenerer",
      0.0125
    ],
    [
      "rhabiller",
      0.0125
    ],
    [
      "ravauder",
      0.0125
    ],
    [
      "rattraper",
      0.0125
    ],
    [
      "rapiecer",
      0.0125
    ],
    [
      "rapetasser",
      0.0125
    ],
    [
      "payer",
      0.0125
    ],
    [
      "couvrir",
      0.0125
    ],
    [
      "remedier",
      0.0075
    ],
    [
      "replatrer",
      0.0075
    ],
    [
      "venger",
      0.0075
    ],
    [
      "reconstituer",
      0.0075
    ],
    [
      "radouber",
      0.0075
    ],
    [
      "colmater",
      0.0075
    ],
    [
      "dedommager",
      0.0075
    ],
    [
      "expier",
      0.0075
    ],
    [
      "indemniser",
      0.0075
    ],
    [
      "rabibocher",
      0.0075
    ],
    [
      "recarreler",
      0.0025
    ],
    [
      "recoudre",
      0.0025
    ],
    [
      "recrepir",
      0.0025
    ],
    [
      "remodeler",
      0.0025
    ],
    [
      "rempailler",
      0.0025
    ],
    [
      "rempieter",
      0.0025
    ],
    [
      "rentoiler",
      0.0025
    ],
    [
      "ressemeler",
      0.0025
    ],
    [
      "refectionner",
      0.0025
    ],
    [
      "rarranger",
      0.0025
    ],
    [
      "rajuster",
      0.0025
    ],
    [
      "adouber",
      0.0025
    ],
    [
      "bricoler",
      0.0025
    ],
    [
      "consolider",
      0.0025
    ],
    [
      "depanner",
      0.0025
    ],
    [
      "effacer",
      0.0025
    ],
    [
      "maconner",
      0.0025
    ],
    [
      "moderniser",
      0.0025
    ],
    [
      "obturer",
      0.0025
    ],
    [
      "rabobiner",
      0.0025
    ],
    [
      "raccoutrer",
      0.0025
    ],
    [
      "ragreer",
      0.0025
    ],
    [
      "stopper",
      0.0025
    ]
  ],
  "encombrer": [
    [
      "obstruer",
      0.14
    ],
    [
      "embouteiller",
      0.12
    ],
    [
      "embarrasser",
      0.08
    ],
    [
      "surcharger",
      0.0575
    ],
    [
      "remplir",
      0.0575
    ],
    [
      "paralyser",
      0.0575
    ],
    [
      "engorger",
      0.0575
    ],
    [
      "truffer",
      0.04
    ],
    [
      "gener",
      0.04
    ],
    [
      "farcir",
      0.04
    ],
    [
      "emplir",
      0.04
    ],
    [
      "congestionner",
      0.04
    ],
    [
      "charger",
      0.04
    ],
    [
      "boucher",
      0.04
    ],
    [
      "bloquer",
      0.04
    ],
    [
      "alourdir",
      0.04
    ],
    [
      "embroussailler",
      0.0175
    ],
    [
      "empater",
      0.0175
    ],
    [
      "inonder",
      0.0175
    ]
  ],
  "encombre": [
    [
      "embarras",
      0.3325
    ],
    [
      "obstacle",
      0.3325
    ],
    [
      "traverse",
      0.3325
    ]
  ],
  "iris": [],
  "absinthe": [
    [
      "armoise",
      1.0
    ]
  ],
  "volute": [
    [
      "courbe",
      0.4275
    ],
    [
      "arabesque",
      0.1425
    ],
    [
      "enroulement",
      0.1425
    ],
    [
      "helice",
      0.1425
    ],
    [
      "serpentin",
      0.1425
    ]
  ],
  "menthol": [],
  "zip": [],
  "evertuer": [],
  "enceinte": [
    [
      "entourer",
      0.1875
    ],
    [
      "enclore",
      0.17
    ],
    [
      "ceindre",
      0.1125
    ],
    [
      "clore",
      0.1125
    ],
    [
      "enfermer",
      0.075
    ],
    [
      "fermer",
      0.055
    ],
    [
      "encercler",
      0.055
    ],
    [
      "cercler",
      0.055
    ],
    [
      "ceinturer",
      0.0375
    ],
    [
      "cloturer",
      0.0375
    ],
    [
      "enserrer",
      0.0375
    ],
    [
      "enceinter",
      0.0175
    ],
    [
      "environner",
      0.0175
    ],
    [
      "fortifier",
      0.0175
    ]
  ],
  "sono": [],
  "lancant": [
    [
      "jeter",
      0.065
    ],
    [
      "pousser",
      0.065
    ],
    [
      "envoyer",
      0.0375
    ],
    [
      "ficher",
      0.0375
    ],
    [
      "porter",
      0.0375
    ],
    [
      "produire",
      0.0375
    ],
    [
      "tirer",
      0.0325
    ],
    [
      "lacher",
      0.0325
    ],
    [
      "balancer",
      0.03
    ],
    [
      "rejeter",
      0.03
    ],
    [
      "sortir",
      0.03
    ],
    [
      "emettre",
      0.03
    ],
    [
      "dire",
      0.025
    ],
    [
      "flanquer",
      0.025
    ],
    [
      "vomir",
      0.0225
    ],
    [
      "chasser",
      0.0225
    ],
    [
      "allonger",
      0.0225
    ],
    [
      "appliquer",
      0.0175
    ],
    [
      "creer",
      0.0175
    ],
    [
      "introduire",
      0.0175
    ],
    [
      "repandre",
      0.0175
    ],
    [
      "servir",
      0.015
    ],
    [
      "publier",
      0.015
    ],
    [
      "promouvoir",
      0.015
    ],
    [
      "projeter",
      0.015
    ],
    [
      "ouvrir",
      0.015
    ],
    [
      "foutre",
      0.015
    ],
    [
      "commencer",
      0.015
    ],
    [
      "ejecter",
      0.01
    ],
    [
      "remuer",
      0.01
    ],
    [
      "partir",
      0.01
    ],
    [
      "larguer",
      0.01
    ],
    [
      "detacher",
      0.01
    ],
    [
      "declencher",
      0.01
    ],
    [
      "catapulter",
      0.01
    ],
    [
      "branler",
      0.01
    ],
    [
      "bombarder",
      0.01
    ],
    [
      "parrainer",
      0.005
    ],
    [
      "patronner",
      0.005
    ],
    [
      "tendre",
      0.005
    ],
    [
      "eructer",
      0.005
    ],
    [
      "exhaler",
      0.005
    ],
    [
      "degorger",
      0.005
    ],
    [
      "aider",
      0.005
    ],
    [
      "assener",
      0.005
    ],
    [
      "coller",
      0.005
    ],
    [
      "darder",
      0.005
    ],
    [
      "desserrer",
      0.005
    ],
    [
      "editer",
      0.0025
    ],
    [
      "secouer",
      0.0025
    ],
    [
      "interjecter",
      0.0025
    ],
    [
      "innover",
      0.0025
    ],
    [
      "fulminer",
      0.0025
    ],
    [
      "fonder",
      0.0025
    ],
    [
      "entreprendre",
      0.0025
    ],
    [
      "decoupler",
      0.0025
    ],
    [
      "decocher",
      0.0025
    ],
    [
      "elancer",
      0.0025
    ]
  ],
  "esquinter": [
    [
      "abimer",
      0.115
    ],
    [
      "demolir",
      0.1075
    ],
    [
      "ereinter",
      0.0925
    ],
    [
      "deteriorer",
      0.0525
    ],
    [
      "briser",
      0.0475
    ],
    [
      "ruiner",
      0.0425
    ],
    [
      "endommager",
      0.0375
    ],
    [
      "epuiser",
      0.0375
    ],
    [
      "bousiller",
      0.035
    ],
    [
      "degrader",
      0.025
    ],
    [
      "dechirer",
      0.025
    ],
    [
      "critiquer",
      0.025
    ],
    [
      "accidenter",
      0.02
    ],
    [
      "demanteler",
      0.02
    ],
    [
      "extenuer",
      0.02
    ],
    [
      "fatiguer",
      0.02
    ],
    [
      "medire",
      0.0175
    ],
    [
      "massacrer",
      0.0175
    ],
    [
      "maltraiter",
      0.0175
    ],
    [
      "delabrer",
      0.0175
    ],
    [
      "amocher",
      0.0175
    ],
    [
      "etriller",
      0.0125
    ],
    [
      "saccager",
      0.0125
    ],
    [
      "harasser",
      0.0125
    ],
    [
      "detraquer",
      0.0125
    ],
    [
      "bigorner",
      0.0125
    ],
    [
      "surmener",
      0.0075
    ],
    [
      "mordre",
      0.0075
    ],
    [
      "exceder",
      0.0075
    ],
    [
      "denigrer",
      0.0075
    ],
    [
      "debiner",
      0.0075
    ],
    [
      "crosser",
      0.0075
    ],
    [
      "crever",
      0.0075
    ],
    [
      "claquer",
      0.0075
    ],
    [
      "manquer",
      0.0025
    ],
    [
      "malmener",
      0.0025
    ],
    [
      "executer",
      0.0025
    ],
    [
      "estropier",
      0.0025
    ],
    [
      "deblaterer",
      0.0025
    ],
    [
      "dauber",
      0.0025
    ],
    [
      "retamer",
      0.0025
    ]
  ],
  "ereinter": [
    [
      "fatiguer",
      0.0725
    ],
    [
      "epuiser",
      0.0725
    ],
    [
      "esquinter",
      0.0575
    ],
    [
      "extenuer",
      0.0525
    ],
    [
      "briser",
      0.05
    ],
    [
      "battre",
      0.0475
    ],
    [
      "aneantir",
      0.04
    ],
    [
      "demolir",
      0.04
    ],
    [
      "harasser",
      0.035
    ],
    [
      "dechirer",
      0.03
    ],
    [
      "maltraiter",
      0.0275
    ],
    [
      "claquer",
      0.0275
    ],
    [
      "abimer",
      0.0275
    ],
    [
      "vanner",
      0.0225
    ],
    [
      "etriller",
      0.0225
    ],
    [
      "tuer",
      0.02
    ],
    [
      "exceder",
      0.02
    ],
    [
      "critiquer",
      0.02
    ],
    [
      "casser",
      0.02
    ],
    [
      "crever",
      0.0175
    ],
    [
      "medire",
      0.0175
    ],
    [
      "rompre",
      0.0175
    ],
    [
      "blesser",
      0.015
    ],
    [
      "vider",
      0.015
    ],
    [
      "denigrer",
      0.0125
    ],
    [
      "debiner",
      0.01
    ],
    [
      "rosser",
      0.01
    ],
    [
      "surmener",
      0.01
    ],
    [
      "echiner",
      0.01
    ],
    [
      "rudoyer",
      0.0075
    ],
    [
      "pomper",
      0.0075
    ],
    [
      "mordre",
      0.0075
    ],
    [
      "malmener",
      0.0075
    ],
    [
      "executer",
      0.0075
    ],
    [
      "crosser",
      0.0075
    ],
    [
      "calomnier",
      0.0075
    ],
    [
      "affaiblir",
      0.0075
    ],
    [
      "accabler",
      0.0075
    ],
    [
      "egorger",
      0.005
    ],
    [
      "matraquer",
      0.005
    ],
    [
      "lasser",
      0.005
    ],
    [
      "descendre",
      0.005
    ],
    [
      "dauber",
      0.005
    ],
    [
      "aplatir",
      0.0
    ],
    [
      "diffamer",
      0.0
    ],
    [
      "deblaterer",
      0.0
    ],
    [
      "rouer",
      0.0
    ]
  ],
  "absurde": [
    [
      "insense",
      0.1075
    ],
    [
      "deraisonnable",
      0.08
    ],
    [
      "sot",
      0.0775
    ],
    [
      "fou",
      0.06
    ],
    [
      "stupide",
      0.06
    ],
    [
      "aberrant",
      0.045
    ],
    [
      "saugrenu",
      0.0425
    ],
    [
      "bete",
      0.04
    ],
    [
      "extravagant",
      0.04
    ],
    [
      "idiot",
      0.0325
    ],
    [
      "irrationnel",
      0.0325
    ],
    [
      "ridicule",
      0.0225
    ],
    [
      "inepte",
      0.0225
    ],
    [
      "incoherent",
      0.0225
    ],
    [
      "illogique",
      0.0225
    ],
    [
      "faux",
      0.0175
    ],
    [
      "impossible",
      0.0175
    ],
    [
      "inconsequent",
      0.0175
    ],
    [
      "loufoque",
      0.015
    ],
    [
      "mauvais",
      0.015
    ],
    [
      "vain",
      0.01
    ],
    [
      "niais",
      0.01
    ],
    [
      "incroyable",
      0.01
    ],
    [
      "dement",
      0.01
    ],
    [
      "biscornu",
      0.01
    ],
    [
      "monstrueux",
      0.0075
    ],
    [
      "insane",
      0.0075
    ],
    [
      "incongru",
      0.0075
    ],
    [
      "inadmissible",
      0.0075
    ],
    [
      "cretin",
      0.0075
    ],
    [
      "ballot",
      0.0075
    ],
    [
      "paradoxal",
      0.005
    ],
    [
      "lunaire",
      0.005
    ],
    [
      "inutile",
      0.005
    ],
    [
      "informe",
      0.005
    ],
    [
      "imaginaire",
      0.005
    ],
    [
      "dingue",
      0.005
    ],
    [
      "contradictoire",
      0.005
    ],
    [
      "balourd",
      0.005
    ],
    [
      "absurdite",
      0.005
    ],
    [
      "irreflechi",
      0.0
    ],
    [
      "illogisme",
      0.0
    ],
    [
      "gratuit",
      0.0
    ],
    [
      "dingo",
      0.0
    ],
    [
      "comique",
      0.0
    ],
    [
      "apagogie",
      0.0
    ]
  ],
  "resorber": [
    [
      "absorber",
      0.4
    ],
    [
      "assimiler",
      0.2
    ],
    [
      "avaler",
      0.2
    ],
    [
      "resoudre",
      0.2
    ]
  ],
  "coma": [
    [
      "assoupissement",
      0.1875
    ],
    [
      "abattement",
      0.125
    ],
    [
      "depression",
      0.125
    ],
    [
      "lethargie",
      0.125
    ],
    [
      "narcose",
      0.125
    ],
    [
      "sopor",
      0.06
    ],
    [
      "sommeil",
      0.06
    ],
    [
      "insensibilite",
      0.06
    ],
    [
      "evanouissement",
      0.06
    ]
  ],
  "absorber": [
    [
      "prendre",
      0.0675
    ],
    [
      "avaler",
      0.0575
    ],
    [
      "boire",
      0.05
    ],
    [
      "manger",
      0.05
    ],
    [
      "devorer",
      0.035
    ],
    [
      "detruire",
      0.035
    ],
    [
      "aneantir",
      0.03
    ],
    [
      "user",
      0.0275
    ],
    [
      "retenir",
      0.0275
    ],
    [
      "pomper",
      0.0275
    ],
    [
      "ingurgiter",
      0.0275
    ],
    [
      "engloutir",
      0.0275
    ],
    [
      "consumer",
      0.0275
    ],
    [
      "attacher",
      0.0275
    ],
    [
      "aspirer",
      0.0275
    ],
    [
      "apprendre",
      0.0275
    ],
    [
      "accaparer",
      0.0225
    ],
    [
      "assimiler",
      0.0225
    ],
    [
      "s'abreuver",
      0.0225
    ],
    [
      "epuiser",
      0.0225
    ],
    [
      "sucer",
      0.0175
    ],
    [
      "humer",
      0.0175
    ],
    [
      "consommer",
      0.0175
    ],
    [
      "tenir",
      0.0125
    ],
    [
      "s'impregner",
      0.0125
    ],
    [
      "penetrer",
      0.0125
    ],
    [
      "occuper",
      0.0125
    ],
    [
      "liquider",
      0.0125
    ],
    [
      "envahir",
      0.0125
    ],
    [
      "engouffrer",
      0.0125
    ],
    [
      "digerer",
      0.0125
    ],
    [
      "captiver",
      0.0125
    ],
    [
      "attirer",
      0.0125
    ],
    [
      "respirer",
      0.0075
    ],
    [
      "resorber",
      0.0075
    ],
    [
      "s'imbiber",
      0.0075
    ],
    [
      "supprimer",
      0.0075
    ],
    [
      "preoccuper",
      0.0075
    ],
    [
      "posseder",
      0.0075
    ],
    [
      "inhaler",
      0.0075
    ],
    [
      "ingerer",
      0.0075
    ],
    [
      "dissoudre",
      0.0075
    ],
    [
      "confisquer",
      0.0075
    ],
    [
      "nettoyer",
      0.0025
    ],
    [
      "integrer",
      0.0025
    ],
    [
      "deglutir",
      0.0025
    ],
    [
      "annexer",
      0.0025
    ],
    [
      "eponger",
      0.0025
    ]
  ],
  "obscur": [
    [
      "tenebreux",
      0.1
    ],
    [
      "nebuleux",
      0.0875
    ],
    [
      "sibyllin",
      0.075
    ],
    [
      "impenetrable",
      0.0425
    ],
    [
      "confus",
      0.03
    ],
    [
      "mysterieux",
      0.0275
    ],
    [
      "enigmatique",
      0.025
    ],
    [
      "secret",
      0.025
    ],
    [
      "vague",
      0.0225
    ],
    [
      "sombre",
      0.0225
    ],
    [
      "difficile",
      0.02
    ],
    [
      "inintelligible",
      0.02
    ],
    [
      "cache",
      0.0175
    ],
    [
      "incomprehensible",
      0.0175
    ],
    [
      "embrouille",
      0.0175
    ],
    [
      "incertain",
      0.015
    ],
    [
      "brumeux",
      0.015
    ],
    [
      "hermetique",
      0.015
    ],
    [
      "abscons",
      0.0125
    ],
    [
      "trouble",
      0.0125
    ],
    [
      "esoterique",
      0.0125
    ],
    [
      "equivoque",
      0.0125
    ],
    [
      "embarrasse",
      0.0125
    ],
    [
      "douteux",
      0.0125
    ],
    [
      "inconnu",
      0.01
    ],
    [
      "fumeux",
      0.01
    ],
    [
      "flou",
      0.01
    ],
    [
      "complique",
      0.01
    ],
    [
      "ambigu",
      0.01
    ],
    [
      "filandreux",
      0.0075
    ],
    [
      "opaque",
      0.0075
    ],
    [
      "profond",
      0.0075
    ],
    [
      "voile",
      0.0075
    ],
    [
      "indechiffrable",
      0.0075
    ],
    [
      "amphigourique",
      0.0075
    ],
    [
      "abstrus",
      0.0075
    ],
    [
      "timide",
      0.005
    ],
    [
      "occulte",
      0.005
    ],
    [
      "inextricable",
      0.005
    ],
    [
      "entortille",
      0.005
    ],
    [
      "cabalistique",
      0.005
    ],
    [
      "inexplicable",
      0.005
    ],
    [
      "terne",
      0.005
    ],
    [
      "touffu",
      0.005
    ],
    [
      "nuageux",
      0.005
    ],
    [
      "louche",
      0.005
    ],
    [
      "insondable",
      0.005
    ],
    [
      "insaisissable",
      0.005
    ],
    [
      "enchevetre",
      0.005
    ],
    [
      "emberlificote",
      0.005
    ],
    [
      "efface",
      0.005
    ],
    [
      "complexe",
      0.005
    ],
    [
      "epais",
      0.0025
    ],
    [
      "triste",
      0.0025
    ],
    [
      "terni",
      0.0025
    ],
    [
      "souterrain",
      0.0025
    ],
    [
      "ignore",
      0.0025
    ],
    [
      "fuligineux",
      0.0025
    ],
    [
      "assombri",
      0.0025
    ],
    [
      "abstrait",
      0.0025
    ],
    [
      "vaporeux",
      0.0025
    ],
    [
      "sepulcral",
      0.0025
    ],
    [
      "oublie",
      0.0025
    ],
    [
      "occulte",
      0.0025
    ],
    [
      "illisible",
      0.0025
    ],
    [
      "humble",
      0.0025
    ],
    [
      "embroussaille",
      0.0025
    ],
    [
      "couvert",
      0.0025
    ],
    [
      "charge",
      0.0025
    ],
    [
      "latent",
      0.0
    ],
    [
      "indistinct",
      0.0
    ],
    [
      "fonce",
      0.0
    ],
    [
      "enveloppe",
      0.0
    ],
    [
      "entenebre",
      0.0
    ],
    [
      "embrume",
      0.0
    ],
    [
      "clandestin",
      0.0
    ],
    [
      "amphibologique",
      0.0
    ],
    [
      "meconnu",
      0.0
    ],
    [
      "neutre",
      0.0
    ],
    [
      "nocturne",
      0.0
    ],
    [
      "obscurci",
      0.0
    ],
    [
      "ombreux",
      0.0
    ],
    [
      "petit",
      0.0
    ],
    [
      "primitif",
      0.0
    ],
    [
      "subalterne",
      0.0
    ],
    [
      "mesquin",
      0.0
    ],
    [
      "irraisonne",
      0.0
    ],
    [
      "ineclaire",
      0.0
    ],
    [
      "apocalyptique",
      0.0
    ],
    [
      "aveugle",
      0.0
    ],
    [
      "crepusculaire",
      0.0
    ],
    [
      "diffus",
      0.0
    ],
    [
      "furtif",
      0.0
    ],
    [
      "inavoue",
      0.0
    ],
    [
      "innomme",
      0.0
    ],
    [
      "vaseux",
      0.0
    ]
  ],
  "pupille": [
    [
      "enfant",
      0.165
    ],
    [
      "oeil",
      0.165
    ],
    [
      "orphelin",
      0.165
    ],
    [
      "pensionnaire",
      0.165
    ],
    [
      "prunelle",
      0.165
    ]
  ],
  "salace": [
    [
      "lascif",
      0.1225
    ],
    [
      "lubrique",
      0.1225
    ],
    [
      "impudique",
      0.105
    ],
    [
      "obscene",
      0.105
    ],
    [
      "sensuel",
      0.0875
    ],
    [
      "licencieux",
      0.0875
    ],
    [
      "luxurieux",
      0.07
    ],
    [
      "libidineux",
      0.05
    ],
    [
      "egrillard",
      0.0325
    ],
    [
      "vicieux",
      0.0325
    ],
    [
      "paillard",
      0.0325
    ],
    [
      "grivois",
      0.0325
    ],
    [
      "graveleux",
      0.0325
    ],
    [
      "amoureux",
      0.0325
    ],
    [
      "ardent",
      0.015
    ],
    [
      "sale",
      0.015
    ]
  ],
  "lavasse": [
    [
      "cafe",
      0.25
    ],
    [
      "lavure",
      0.25
    ],
    [
      "pluie",
      0.25
    ],
    [
      "potage",
      0.25
    ]
  ],
  "exhaler": [
    [
      "emettre",
      0.095
    ],
    [
      "degager",
      0.0775
    ],
    [
      "sentir",
      0.0775
    ],
    [
      "exprimer",
      0.0575
    ],
    [
      "manifester",
      0.0575
    ],
    [
      "repandre",
      0.0575
    ],
    [
      "reveler",
      0.0575
    ],
    [
      "suinter",
      0.0375
    ],
    [
      "respirer",
      0.0375
    ],
    [
      "produire",
      0.0375
    ],
    [
      "montrer",
      0.0375
    ],
    [
      "parfumer",
      0.0275
    ],
    [
      "pousser",
      0.0275
    ],
    [
      "puer",
      0.0275
    ],
    [
      "suer",
      0.0275
    ],
    [
      "epancher",
      0.0175
    ],
    [
      "rendre",
      0.0175
    ],
    [
      "proferer",
      0.0175
    ],
    [
      "odorer",
      0.0175
    ],
    [
      "lancer",
      0.0175
    ],
    [
      "fleurer",
      0.0175
    ],
    [
      "embaumer",
      0.0175
    ],
    [
      "transpirer",
      0.0075
    ],
    [
      "souffler",
      0.0075
    ],
    [
      "s'epancher",
      0.0075
    ],
    [
      "exterioriser",
      0.0075
    ],
    [
      "expirer",
      0.0075
    ],
    [
      "empuantir",
      0.0075
    ],
    [
      "empester",
      0.0075
    ],
    [
      "deverser",
      0.0075
    ],
    [
      "degoutter",
      0.0075
    ],
    [
      "evaporer",
      0.0075
    ]
  ],
  "cerebral": [
    [
      "mental",
      0.3325
    ],
    [
      "psychique",
      0.3325
    ],
    [
      "intellectuel",
      0.165
    ],
    [
      "psychologique",
      0.165
    ]
  ],
  "coca": [
    [
      "cocaine",
      0.5
    ]
  ],
  "corolle": [
    [
      "perianthe",
      1.0
    ]
  ],
  "calice": [
    [
      "affliction",
      0.1325
    ],
    [
      "croix",
      0.1325
    ],
    [
      "mal",
      0.1325
    ],
    [
      "perianthe",
      0.065
    ],
    [
      "hanap",
      0.065
    ],
    [
      "fiel",
      0.065
    ],
    [
      "enveloppe",
      0.065
    ],
    [
      "coupe",
      0.065
    ],
    [
      "calvaire",
      0.065
    ],
    [
      "calicule",
      0.065
    ],
    [
      "acetabule",
      0.065
    ],
    [
      "urceole",
      0.065
    ]
  ],
  "teinte": [
    [
      "colorer",
      0.1925
    ],
    [
      "orner",
      0.0825
    ],
    [
      "peindre",
      0.0825
    ],
    [
      "rehausser",
      0.055
    ],
    [
      "peinturlurer",
      0.055
    ],
    [
      "farder",
      0.055
    ],
    [
      "embellir",
      0.055
    ],
    [
      "barbouiller",
      0.055
    ],
    [
      "renover",
      0.0275
    ],
    [
      "rocouer",
      0.0275
    ],
    [
      "relever",
      0.0275
    ],
    [
      "rajeunir",
      0.0275
    ],
    [
      "raciner",
      0.0275
    ],
    [
      "noircir",
      0.0275
    ],
    [
      "impregner",
      0.0275
    ],
    [
      "garancer",
      0.0275
    ],
    [
      "colorier",
      0.0275
    ],
    [
      "cocheniller",
      0.0275
    ],
    [
      "bresiller",
      0.0275
    ],
    [
      "barioler",
      0.0275
    ],
    [
      "safraner",
      0.0275
    ]
  ],
  "febrile": [
    [
      "bouillonnant",
      0.125
    ],
    [
      "ardent",
      0.1125
    ],
    [
      "frenetique",
      0.1025
    ],
    [
      "fougueux",
      0.0775
    ],
    [
      "passionne",
      0.0775
    ],
    [
      "fievreux",
      0.055
    ],
    [
      "chaud",
      0.045
    ],
    [
      "nerveux",
      0.045
    ],
    [
      "vif",
      0.045
    ],
    [
      "vehement",
      0.0325
    ],
    [
      "impatient",
      0.0325
    ],
    [
      "excite",
      0.0325
    ],
    [
      "exalte",
      0.0325
    ],
    [
      "enflamme",
      0.0325
    ],
    [
      "bouillant",
      0.0225
    ],
    [
      "endiable",
      0.0225
    ],
    [
      "enfievre",
      0.0225
    ],
    [
      "violent",
      0.0225
    ],
    [
      "enerve",
      0.0225
    ],
    [
      "surchauffe",
      0.01
    ],
    [
      "echevele",
      0.01
    ]
  ],
  "narcisse": [
    [
      "coquelourde",
      0.25
    ],
    [
      "coucou",
      0.25
    ],
    [
      "jeannette",
      0.25
    ],
    [
      "jonquille",
      0.25
    ]
  ],
  "pubis": [],
  "enfoncer": [
    [
      "vaincre",
      0.0475
    ],
    [
      "ecraser",
      0.0475
    ],
    [
      "culbuter",
      0.04
    ],
    [
      "abattre",
      0.0375
    ],
    [
      "battre",
      0.03
    ],
    [
      "detruire",
      0.03
    ],
    [
      "triompher",
      0.03
    ],
    [
      "passer",
      0.025
    ],
    [
      "introduire",
      0.025
    ],
    [
      "briser",
      0.025
    ],
    [
      "surpasser",
      0.02
    ],
    [
      "renverser",
      0.02
    ],
    [
      "penetrer",
      0.02
    ],
    [
      "pousser",
      0.02
    ],
    [
      "percer",
      0.02
    ],
    [
      "ouvrir",
      0.02
    ],
    [
      "surclasser",
      0.0175
    ],
    [
      "rompre",
      0.0175
    ],
    [
      "plonger",
      0.0175
    ],
    [
      "forcer",
      0.0175
    ],
    [
      "defaire",
      0.0175
    ],
    [
      "accabler",
      0.0175
    ],
    [
      "transpercer",
      0.015
    ],
    [
      "piquer",
      0.015
    ],
    [
      "ficher",
      0.015
    ],
    [
      "entamer",
      0.015
    ],
    [
      "engloutir",
      0.015
    ],
    [
      "devancer",
      0.015
    ],
    [
      "bourrer",
      0.015
    ],
    [
      "surmonter",
      0.0125
    ],
    [
      "mettre",
      0.0125
    ],
    [
      "fourrer",
      0.0125
    ],
    [
      "entrer",
      0.0125
    ],
    [
      "engager",
      0.0125
    ],
    [
      "defoncer",
      0.0125
    ],
    [
      "creuser",
      0.0125
    ],
    [
      "pulveriser",
      0.0075
    ],
    [
      "precipiter",
      0.0075
    ],
    [
      "planter",
      0.0075
    ],
    [
      "piler",
      0.0075
    ],
    [
      "embourber",
      0.0075
    ],
    [
      "crever",
      0.0075
    ],
    [
      "couler",
      0.0075
    ],
    [
      "foncer",
      0.005
    ],
    [
      "immerger",
      0.005
    ],
    [
      "loger",
      0.005
    ],
    [
      "percuter",
      0.005
    ],
    [
      "rosser",
      0.005
    ],
    [
      "submerger",
      0.005
    ],
    [
      "expliquer",
      0.005
    ],
    [
      "enterrer",
      0.005
    ],
    [
      "emboutir",
      0.005
    ],
    [
      "apprendre",
      0.005
    ],
    [
      "arrimer",
      0.005
    ],
    [
      "caler",
      0.005
    ],
    [
      "convaincre",
      0.005
    ],
    [
      "distancer",
      0.005
    ],
    [
      "deprimer",
      0.005
    ],
    [
      "replonger",
      0.0025
    ],
    [
      "renfoncer",
      0.0025
    ],
    [
      "pitonner",
      0.0025
    ],
    [
      "griller",
      0.0025
    ],
    [
      "envaser",
      0.0025
    ],
    [
      "enliser",
      0.0025
    ],
    [
      "empetrer",
      0.0025
    ],
    [
      "duper",
      0.0025
    ],
    [
      "cheviller",
      0.0025
    ],
    [
      "brocher",
      0.0025
    ],
    [
      "affaisser",
      0.0025
    ],
    [
      "eclabousser",
      0.0025
    ]
  ],
  "malice": [
    [
      "plaisanterie",
      0.1
    ],
    [
      "rosserie",
      0.0875
    ],
    [
      "mechancete",
      0.0775
    ],
    [
      "taquinerie",
      0.0775
    ],
    [
      "tour",
      0.065
    ],
    [
      "facetie",
      0.055
    ],
    [
      "espieglerie",
      0.055
    ],
    [
      "farce",
      0.0425
    ],
    [
      "ruse",
      0.0325
    ],
    [
      "rouerie",
      0.0325
    ],
    [
      "finesse",
      0.0325
    ],
    [
      "astuce",
      0.0325
    ],
    [
      "vacherie",
      0.02
    ],
    [
      "truc",
      0.02
    ],
    [
      "raillerie",
      0.02
    ],
    [
      "niche",
      0.02
    ],
    [
      "mistoufle",
      0.02
    ],
    [
      "malignite",
      0.02
    ],
    [
      "ironie",
      0.02
    ],
    [
      "esprit",
      0.02
    ],
    [
      "blague",
      0.02
    ],
    [
      "artifice",
      0.02
    ],
    [
      "perversite",
      0.01
    ],
    [
      "misere",
      0.01
    ],
    [
      "finauderie",
      0.01
    ],
    [
      "ficelle",
      0.01
    ],
    [
      "diablerie",
      0.01
    ],
    [
      "attrape",
      0.01
    ],
    [
      "saloperie",
      0.01
    ]
  ],
  "self": [
    [
      "personnalite",
      0.4
    ],
    [
      "moi",
      0.2
    ],
    [
      "restaurant",
      0.2
    ],
    [
      "soi",
      0.2
    ]
  ],
  "control": [],
  "orifice": [
    [
      "ouverture",
      0.375
    ],
    [
      "bouche",
      0.125
    ],
    [
      "entree",
      0.125
    ],
    [
      "gueulard",
      0.0625
    ],
    [
      "lumiere",
      0.0625
    ],
    [
      "meat",
      0.0625
    ],
    [
      "pore",
      0.0625
    ],
    [
      "trou",
      0.0625
    ],
    [
      "evasure",
      0.0625
    ]
  ],
  "kermesse": [
    [
      "fete",
      0.3325
    ],
    [
      "festivite",
      0.11
    ],
    [
      "foire",
      0.11
    ],
    [
      "frairie",
      0.11
    ],
    [
      "rejouissance",
      0.0725
    ],
    [
      "festival",
      0.0725
    ],
    [
      "amusement",
      0.0725
    ],
    [
      "braderie",
      0.035
    ],
    [
      "ducasse",
      0.035
    ],
    [
      "vogue",
      0.035
    ]
  ],
  "neon": [],
  "decadence": [
    [
      "declin",
      0.095
    ],
    [
      "decheance",
      0.0925
    ],
    [
      "degradation",
      0.085
    ],
    [
      "abaissement",
      0.0725
    ],
    [
      "chute",
      0.065
    ],
    [
      "ruine",
      0.065
    ],
    [
      "degenerescence",
      0.0625
    ],
    [
      "affaiblissement",
      0.045
    ],
    [
      "deliquescence",
      0.0325
    ],
    [
      "diminution",
      0.0225
    ],
    [
      "perte",
      0.02
    ],
    [
      "effondrement",
      0.02
    ],
    [
      "deterioration",
      0.02
    ],
    [
      "decrepitude",
      0.02
    ],
    [
      "corruption",
      0.02
    ],
    [
      "avilissement",
      0.015
    ],
    [
      "destruction",
      0.015
    ],
    [
      "deperissement",
      0.015
    ],
    [
      "fin",
      0.015
    ],
    [
      "senescence",
      0.015
    ],
    [
      "ecroulement",
      0.0125
    ],
    [
      "decomposition",
      0.0125
    ],
    [
      "agonie",
      0.0125
    ],
    [
      "affaissement",
      0.0125
    ],
    [
      "abatardissement",
      0.0125
    ],
    [
      "crepuscule",
      0.01
    ],
    [
      "descente",
      0.01
    ],
    [
      "vieillesse",
      0.01
    ],
    [
      "etiolement",
      0.005
    ],
    [
      "eclipse",
      0.005
    ],
    [
      "regression",
      0.005
    ],
    [
      "renversement",
      0.005
    ],
    [
      "rapetissement",
      0.005
    ],
    [
      "degringolade",
      0.005
    ],
    [
      "couchant",
      0.005
    ],
    [
      "catabolisme",
      0.0025
    ],
    [
      "disgrace",
      0.0025
    ],
    [
      "decours",
      0.0025
    ],
    [
      "pente",
      0.0025
    ],
    [
      "relachement",
      0.0025
    ],
    [
      "epave",
      0.0025
    ]
  ],
  "duel": [
    [
      "combat",
      0.225
    ],
    [
      "lutte",
      0.145
    ],
    [
      "bataille",
      0.1125
    ],
    [
      "dispute",
      0.095
    ],
    [
      "joute",
      0.0625
    ],
    [
      "rivalite",
      0.0475
    ],
    [
      "opposition",
      0.0475
    ],
    [
      "competition",
      0.0475
    ],
    [
      "affrontement",
      0.0475
    ],
    [
      "affaire",
      0.03
    ],
    [
      "escarmouche",
      0.03
    ],
    [
      "rencontre",
      0.03
    ],
    [
      "antagonisme",
      0.015
    ],
    [
      "escrime",
      0.015
    ],
    [
      "ordalie",
      0.015
    ],
    [
      "reparation",
      0.015
    ]
  ],
  "nevrose": [
    [
      "derangement",
      0.1425
    ],
    [
      "desequilibre",
      0.1425
    ],
    [
      "trouble",
      0.1425
    ],
    [
      "nevropathie",
      0.07
    ],
    [
      "nervosite",
      0.07
    ],
    [
      "nervosisme",
      0.07
    ],
    [
      "folie",
      0.07
    ],
    [
      "extase",
      0.07
    ],
    [
      "dereglement",
      0.07
    ],
    [
      "alienation",
      0.07
    ],
    [
      "nevrosisme",
      0.07
    ]
  ],
  "abattre": [
    [
      "aneantir",
      0.0675
    ],
    [
      "detruire",
      0.0625
    ],
    [
      "briser",
      0.0425
    ],
    [
      "renverser",
      0.0425
    ],
    [
      "accabler",
      0.04
    ],
    [
      "tuer",
      0.035
    ],
    [
      "fatiguer",
      0.0325
    ],
    [
      "ruiner",
      0.03
    ],
    [
      "ecraser",
      0.0275
    ],
    [
      "epuiser",
      0.0275
    ],
    [
      "affaiblir",
      0.02
    ],
    [
      "demolir",
      0.02
    ],
    [
      "diminuer",
      0.02
    ],
    [
      "terrasser",
      0.0175
    ],
    [
      "vaincre",
      0.0175
    ],
    [
      "culbuter",
      0.015
    ],
    [
      "deprimer",
      0.015
    ],
    [
      "foudroyer",
      0.015
    ],
    [
      "enfoncer",
      0.0125
    ],
    [
      "couper",
      0.0125
    ],
    [
      "supprimer",
      0.0125
    ],
    [
      "assommer",
      0.01
    ],
    [
      "decourager",
      0.01
    ],
    [
      "defaire",
      0.01
    ],
    [
      "saper",
      0.01
    ],
    [
      "abaisser",
      0.0075
    ],
    [
      "confondre",
      0.0075
    ],
    [
      "consumer",
      0.0075
    ],
    [
      "desesperer",
      0.0075
    ],
    [
      "executer",
      0.0075
    ],
    [
      "etendre",
      0.0075
    ],
    [
      "rabattre",
      0.0075
    ],
    [
      "miner",
      0.0075
    ],
    [
      "demanteler",
      0.0075
    ],
    [
      "atterrer",
      0.0075
    ],
    [
      "vider",
      0.005
    ],
    [
      "triompher",
      0.005
    ],
    [
      "reduire",
      0.005
    ],
    [
      "rabaisser",
      0.005
    ],
    [
      "faucher",
      0.005
    ],
    [
      "consterner",
      0.005
    ],
    [
      "bouleverser",
      0.005
    ],
    [
      "aplatir",
      0.005
    ],
    [
      "lasser",
      0.005
    ],
    [
      "precipiter",
      0.005
    ],
    [
      "raser",
      0.005
    ],
    [
      "tirer",
      0.005
    ],
    [
      "ebranler",
      0.005
    ],
    [
      "broyer",
      0.005
    ],
    [
      "atteindre",
      0.005
    ],
    [
      "assassiner",
      0.005
    ],
    [
      "annihiler",
      0.005
    ],
    [
      "affliger",
      0.005
    ],
    [
      "achever",
      0.005
    ],
    [
      "frapper",
      0.0025
    ],
    [
      "liquider",
      0.0025
    ],
    [
      "trancher",
      0.0025
    ],
    [
      "egorger",
      0.0025
    ],
    [
      "fletrir",
      0.0025
    ],
    [
      "desoler",
      0.0025
    ],
    [
      "baisser",
      0.0025
    ],
    [
      "coucher",
      0.0025
    ],
    [
      "decapiter",
      0.0025
    ],
    [
      "demonter",
      0.0025
    ],
    [
      "demoraliser",
      0.0025
    ],
    [
      "eliminer",
      0.0025
    ],
    [
      "ecoeurer",
      0.0025
    ],
    [
      "saigner",
      0.0025
    ],
    [
      "massacrer",
      0.0025
    ],
    [
      "detacher",
      0.0025
    ],
    [
      "deraciner",
      0.0025
    ],
    [
      "descendre",
      0.0025
    ],
    [
      "catastropher",
      0.0025
    ],
    [
      "affaisser",
      0.0025
    ],
    [
      "etaler",
      0.0
    ],
    [
      "servir",
      0.0
    ],
    [
      "mater",
      0.0
    ],
    [
      "deshonorer",
      0.0
    ],
    [
      "dompter",
      0.0
    ],
    [
      "crouler",
      0.0
    ],
    [
      "apaiser",
      0.0
    ],
    [
      "deroder",
      0.0
    ],
    [
      "montrer",
      0.0
    ],
    [
      "scier",
      0.0
    ],
    [
      "supplicier",
      0.0
    ],
    [
      "deconstruire",
      0.0
    ],
    [
      "disqualifier",
      0.0
    ],
    [
      "contrarier",
      0.0
    ],
    [
      "calamiter",
      0.0
    ],
    [
      "arriver",
      0.0
    ],
    [
      "alanguir",
      0.0
    ],
    [
      "emousser",
      0.0
    ]
  ],
  "abattu": [
    [
      "aneantir",
      0.0675
    ],
    [
      "detruire",
      0.0625
    ],
    [
      "briser",
      0.0425
    ],
    [
      "renverser",
      0.0425
    ],
    [
      "accabler",
      0.04
    ],
    [
      "tuer",
      0.035
    ],
    [
      "fatiguer",
      0.0325
    ],
    [
      "ruiner",
      0.03
    ],
    [
      "ecraser",
      0.0275
    ],
    [
      "epuiser",
      0.0275
    ],
    [
      "affaiblir",
      0.02
    ],
    [
      "demolir",
      0.02
    ],
    [
      "diminuer",
      0.02
    ],
    [
      "terrasser",
      0.0175
    ],
    [
      "vaincre",
      0.0175
    ],
    [
      "culbuter",
      0.015
    ],
    [
      "deprimer",
      0.015
    ],
    [
      "foudroyer",
      0.015
    ],
    [
      "enfoncer",
      0.0125
    ],
    [
      "couper",
      0.0125
    ],
    [
      "supprimer",
      0.0125
    ],
    [
      "assommer",
      0.01
    ],
    [
      "decourager",
      0.01
    ],
    [
      "defaire",
      0.01
    ],
    [
      "saper",
      0.01
    ],
    [
      "abaisser",
      0.0075
    ],
    [
      "confondre",
      0.0075
    ],
    [
      "consumer",
      0.0075
    ],
    [
      "desesperer",
      0.0075
    ],
    [
      "executer",
      0.0075
    ],
    [
      "etendre",
      0.0075
    ],
    [
      "rabattre",
      0.0075
    ],
    [
      "miner",
      0.0075
    ],
    [
      "demanteler",
      0.0075
    ],
    [
      "atterrer",
      0.0075
    ],
    [
      "vider",
      0.005
    ],
    [
      "triompher",
      0.005
    ],
    [
      "reduire",
      0.005
    ],
    [
      "rabaisser",
      0.005
    ],
    [
      "faucher",
      0.005
    ],
    [
      "consterner",
      0.005
    ],
    [
      "bouleverser",
      0.005
    ],
    [
      "aplatir",
      0.005
    ],
    [
      "lasser",
      0.005
    ],
    [
      "precipiter",
      0.005
    ],
    [
      "raser",
      0.005
    ],
    [
      "tirer",
      0.005
    ],
    [
      "ebranler",
      0.005
    ],
    [
      "broyer",
      0.005
    ],
    [
      "atteindre",
      0.005
    ],
    [
      "assassiner",
      0.005
    ],
    [
      "annihiler",
      0.005
    ],
    [
      "affliger",
      0.005
    ],
    [
      "achever",
      0.005
    ],
    [
      "frapper",
      0.0025
    ],
    [
      "liquider",
      0.0025
    ],
    [
      "trancher",
      0.0025
    ],
    [
      "egorger",
      0.0025
    ],
    [
      "fletrir",
      0.0025
    ],
    [
      "desoler",
      0.0025
    ],
    [
      "baisser",
      0.0025
    ],
    [
      "coucher",
      0.0025
    ],
    [
      "decapiter",
      0.0025
    ],
    [
      "demonter",
      0.0025
    ],
    [
      "demoraliser",
      0.0025
    ],
    [
      "eliminer",
      0.0025
    ],
    [
      "ecoeurer",
      0.0025
    ],
    [
      "saigner",
      0.0025
    ],
    [
      "massacrer",
      0.0025
    ],
    [
      "detacher",
      0.0025
    ],
    [
      "deraciner",
      0.0025
    ],
    [
      "descendre",
      0.0025
    ],
    [
      "catastropher",
      0.0025
    ],
    [
      "affaisser",
      0.0025
    ],
    [
      "etaler",
      0.0
    ],
    [
      "servir",
      0.0
    ],
    [
      "mater",
      0.0
    ],
    [
      "deshonorer",
      0.0
    ],
    [
      "dompter",
      0.0
    ],
    [
      "crouler",
      0.0
    ],
    [
      "apaiser",
      0.0
    ],
    [
      "deroder",
      0.0
    ],
    [
      "montrer",
      0.0
    ],
    [
      "scier",
      0.0
    ],
    [
      "supplicier",
      0.0
    ],
    [
      "deconstruire",
      0.0
    ],
    [
      "disqualifier",
      0.0
    ],
    [
      "contrarier",
      0.0
    ],
    [
      "calamiter",
      0.0
    ],
    [
      "arriver",
      0.0
    ],
    [
      "alanguir",
      0.0
    ],
    [
      "emousser",
      0.0
    ]
  ],
  "courbatu": [
    [
      "fatigue",
      0.1525
    ],
    [
      "recru",
      0.1525
    ],
    [
      "rendu",
      0.1525
    ],
    [
      "rompu",
      0.1525
    ],
    [
      "ankylose",
      0.075
    ],
    [
      "courbature",
      0.075
    ],
    [
      "harasse",
      0.075
    ],
    [
      "moulu",
      0.075
    ],
    [
      "ereinte",
      0.075
    ]
  ],
  "mandoline": [
    [
      "guitare",
      0.5
    ],
    [
      "banjo",
      0.25
    ],
    [
      "luth",
      0.25
    ]
  ],
  "dehancher": [],
  "jalousie": [
    [
      "rivalite",
      0.1425
    ],
    [
      "envie",
      0.095
    ],
    [
      "haine",
      0.095
    ],
    [
      "mechancete",
      0.095
    ],
    [
      "volet",
      0.0475
    ],
    [
      "treillis",
      0.0475
    ],
    [
      "store",
      0.0475
    ],
    [
      "rosserie",
      0.0475
    ],
    [
      "persienne",
      0.0475
    ],
    [
      "ombrage",
      0.0475
    ],
    [
      "moucharabieh",
      0.0475
    ],
    [
      "depit",
      0.0475
    ],
    [
      "doute",
      0.0475
    ],
    [
      "dent",
      0.0475
    ],
    [
      "contrevent",
      0.0475
    ],
    [
      "emulation",
      0.0475
    ]
  ],
  "blottir": [
    [
      "s'accroupir",
      0.06
    ],
    [
      "s'enfouir",
      0.03
    ]
  ],
  "blotti": [
    [
      "ramasse",
      0.5
    ],
    [
      "tapi",
      0.5
    ]
  ],
  "palpiter": [
    [
      "trembler",
      0.25
    ],
    [
      "vibrer",
      0.1
    ],
    [
      "vaciller",
      0.1
    ],
    [
      "osciller",
      0.1
    ],
    [
      "fremir",
      0.1
    ],
    [
      "battre",
      0.1
    ],
    [
      "panteler",
      0.0475
    ],
    [
      "scintiller",
      0.0475
    ],
    [
      "tressaillir",
      0.0475
    ],
    [
      "tremuler",
      0.0475
    ]
  ],
  "codicille": [
    [
      "avenant",
      0.5
    ],
    [
      "complement",
      0.5
    ]
  ],
  "tabellion": [
    [
      "notaire",
      0.165
    ],
    [
      "scribe",
      0.165
    ],
    [
      "secretaire",
      0.165
    ],
    [
      "clerc",
      0.0825
    ],
    [
      "greffier",
      0.0825
    ],
    [
      "plumitif",
      0.0825
    ],
    [
      "scribouillard",
      0.0825
    ]
  ],
  "ecriture": [
    [
      "style",
      0.1325
    ],
    [
      "ton",
      0.1075
    ],
    [
      "plume",
      0.0525
    ],
    [
      "patte",
      0.0525
    ],
    [
      "main",
      0.0525
    ],
    [
      "griffe",
      0.0525
    ],
    [
      "graphisme",
      0.0525
    ],
    [
      "graphie",
      0.0525
    ],
    [
      "genre",
      0.0525
    ],
    [
      "griffonnage",
      0.025
    ],
    [
      "maniere",
      0.025
    ],
    [
      "notation",
      0.025
    ],
    [
      "orthographe",
      0.025
    ],
    [
      "phraseologie",
      0.025
    ],
    [
      "prophetie",
      0.025
    ],
    [
      "gribouillis",
      0.025
    ],
    [
      "gribouillage",
      0.025
    ],
    [
      "graphique",
      0.025
    ],
    [
      "encodage",
      0.025
    ],
    [
      "compte",
      0.025
    ],
    [
      "calligraphie",
      0.025
    ],
    [
      "article",
      0.025
    ],
    [
      "alphabet",
      0.025
    ],
    [
      "redaction",
      0.025
    ]
  ],
  "rupture": [
    [
      "tension",
      0.0775
    ],
    [
      "mesintelligence",
      0.0725
    ],
    [
      "desaccord",
      0.0675
    ],
    [
      "discorde",
      0.055
    ],
    [
      "division",
      0.045
    ],
    [
      "desunion",
      0.04
    ],
    [
      "brouille",
      0.035
    ],
    [
      "separation",
      0.0275
    ],
    [
      "mesentente",
      0.0275
    ],
    [
      "dechirement",
      0.0275
    ],
    [
      "divergence",
      0.0275
    ],
    [
      "dispute",
      0.0225
    ],
    [
      "dissension",
      0.0225
    ],
    [
      "zizanie",
      0.0175
    ],
    [
      "divorce",
      0.0175
    ],
    [
      "dissolution",
      0.0175
    ],
    [
      "destruction",
      0.0175
    ],
    [
      "cessation",
      0.0175
    ],
    [
      "cassure",
      0.0175
    ],
    [
      "annulation",
      0.0175
    ],
    [
      "abandon",
      0.0175
    ],
    [
      "suspension",
      0.0125
    ],
    [
      "orage",
      0.0125
    ],
    [
      "fracture",
      0.0125
    ],
    [
      "fraction",
      0.0125
    ],
    [
      "desagregation",
      0.0125
    ],
    [
      "dissonance",
      0.0125
    ],
    [
      "dissidence",
      0.0125
    ],
    [
      "dissentiment",
      0.0125
    ],
    [
      "brouillerie",
      0.0125
    ],
    [
      "brisement",
      0.0125
    ],
    [
      "froid",
      0.0075
    ],
    [
      "nuage",
      0.0075
    ],
    [
      "revocation",
      0.0075
    ],
    [
      "ecart",
      0.0075
    ],
    [
      "explosion",
      0.0075
    ],
    [
      "dechirure",
      0.0075
    ],
    [
      "decalage",
      0.0075
    ],
    [
      "brisure",
      0.0075
    ],
    [
      "bris",
      0.0075
    ],
    [
      "arret",
      0.0075
    ],
    [
      "abrogation",
      0.0075
    ],
    [
      "interruption",
      0.0025
    ],
    [
      "largage",
      0.0025
    ],
    [
      "lachage",
      0.0025
    ],
    [
      "percee",
      0.0025
    ],
    [
      "rompement",
      0.0025
    ],
    [
      "resiliation",
      0.0025
    ],
    [
      "section",
      0.0025
    ],
    [
      "infraction",
      0.0025
    ],
    [
      "deterioration",
      0.0025
    ],
    [
      "denonciation",
      0.0025
    ],
    [
      "crise",
      0.0025
    ],
    [
      "craqure",
      0.0025
    ],
    [
      "clash",
      0.0025
    ],
    [
      "cassage",
      0.0025
    ],
    [
      "arrachement",
      0.0025
    ],
    [
      "antagonisme",
      0.0025
    ],
    [
      "eclatement",
      0.0025
    ]
  ],
  "titi": [
    [
      "gaillard",
      0.3325
    ],
    [
      "gamin",
      0.3325
    ],
    [
      "gavroche",
      0.3325
    ]
  ],
  "grisette": [
    [
      "courtisane",
      0.11
    ],
    [
      "godinette",
      0.11
    ],
    [
      "gris",
      0.11
    ],
    [
      "lisette",
      0.11
    ],
    [
      "lorette",
      0.11
    ],
    [
      "manola",
      0.11
    ],
    [
      "midinette",
      0.11
    ]
  ],
  "natal": [
    [
      "originel",
      1.0
    ]
  ],
  "sleeping": [],
  "caveau": [
    [
      "cabaret",
      0.0875
    ],
    [
      "cave",
      0.0875
    ],
    [
      "cavite",
      0.0875
    ],
    [
      "hypogee",
      0.0875
    ],
    [
      "renfoncement",
      0.0875
    ],
    [
      "tombe",
      0.0875
    ],
    [
      "tombeau",
      0.0875
    ],
    [
      "sepulture",
      0.0575
    ],
    [
      "souterrain",
      0.0575
    ],
    [
      "crypte",
      0.0575
    ],
    [
      "columbarium",
      0.0275
    ],
    [
      "enfer",
      0.0275
    ],
    [
      "mausolee",
      0.0275
    ],
    [
      "niche",
      0.0275
    ],
    [
      "sepulcre",
      0.0275
    ]
  ],
  "moelleux": [
    [
      "doux",
      0.2
    ],
    [
      "mou",
      0.0825
    ],
    [
      "veloute",
      0.065
    ],
    [
      "tendre",
      0.065
    ],
    [
      "suave",
      0.065
    ],
    [
      "douillet",
      0.065
    ],
    [
      "agreable",
      0.0475
    ],
    [
      "onctueux",
      0.0475
    ],
    [
      "elastique",
      0.0325
    ],
    [
      "souple",
      0.0325
    ],
    [
      "gracieux",
      0.0325
    ],
    [
      "douceur",
      0.0325
    ],
    [
      "confortable",
      0.0325
    ],
    [
      "savoureux",
      0.015
    ],
    [
      "rembourre",
      0.015
    ],
    [
      "medullaire",
      0.015
    ],
    [
      "mollet",
      0.015
    ],
    [
      "mollesse",
      0.015
    ],
    [
      "liquoreux",
      0.015
    ],
    [
      "gras",
      0.015
    ],
    [
      "frais",
      0.015
    ],
    [
      "fondant",
      0.015
    ],
    [
      "duveteux",
      0.015
    ],
    [
      "soyeux",
      0.015
    ]
  ],
  "niche": [
    [
      "abri",
      0.115
    ],
    [
      "enfoncement",
      0.0725
    ],
    [
      "cavite",
      0.0575
    ],
    [
      "loge",
      0.0575
    ],
    [
      "nid",
      0.0575
    ],
    [
      "renfoncement",
      0.0575
    ],
    [
      "plaisanterie",
      0.0425
    ],
    [
      "facetie",
      0.0425
    ],
    [
      "alcove",
      0.0425
    ],
    [
      "trou",
      0.0275
    ],
    [
      "tour",
      0.0275
    ],
    [
      "toit",
      0.0275
    ],
    [
      "reduit",
      0.0275
    ],
    [
      "malice",
      0.0275
    ],
    [
      "logement",
      0.0275
    ],
    [
      "foyer",
      0.0275
    ],
    [
      "farce",
      0.0275
    ],
    [
      "cage",
      0.0275
    ],
    [
      "blague",
      0.0275
    ],
    [
      "attrape",
      0.0275
    ],
    [
      "gite",
      0.0125
    ],
    [
      "espieglerie",
      0.0125
    ],
    [
      "enfeu",
      0.0125
    ],
    [
      "creux",
      0.0125
    ],
    [
      "caveau",
      0.0125
    ],
    [
      "caponniere",
      0.0125
    ],
    [
      "canular",
      0.0125
    ],
    [
      "biotope",
      0.0125
    ],
    [
      "home",
      0.0125
    ]
  ],
  "nicher": [
    [
      "habiter",
      0.16
    ],
    [
      "loger",
      0.16
    ],
    [
      "resider",
      0.08
    ],
    [
      "placer",
      0.08
    ],
    [
      "percher",
      0.08
    ],
    [
      "demeurer",
      0.08
    ],
    [
      "situer",
      0.0375
    ],
    [
      "s'installer",
      0.0375
    ],
    [
      "s'abriter",
      0.0375
    ],
    [
      "nidifier",
      0.0375
    ],
    [
      "hanter",
      0.0375
    ],
    [
      "giter",
      0.0375
    ],
    [
      "caser",
      0.0375
    ],
    [
      "sejourner",
      0.0375
    ]
  ],
  "corniche": [
    [
      "cote",
      0.1425
    ],
    [
      "saillie",
      0.07
    ],
    [
      "poutre",
      0.07
    ],
    [
      "mouchette",
      0.07
    ],
    [
      "larmier",
      0.07
    ],
    [
      "escarpement",
      0.07
    ],
    [
      "couronnement",
      0.07
    ],
    [
      "cordon",
      0.07
    ],
    [
      "chapiteau",
      0.07
    ],
    [
      "bord",
      0.07
    ],
    [
      "boisage",
      0.07
    ],
    [
      "astragale",
      0.07
    ],
    [
      "soffite",
      0.07
    ]
  ],
  "pastis": [
    [
      "desordre",
      0.165
    ],
    [
      "melange",
      0.11
    ],
    [
      "gachis",
      0.11
    ],
    [
      "confusion",
      0.11
    ],
    [
      "chaos",
      0.11
    ],
    [
      "bouillabaisse",
      0.11
    ],
    [
      "agitation",
      0.055
    ],
    [
      "anis",
      0.055
    ],
    [
      "imbroglio",
      0.055
    ],
    [
      "misere",
      0.055
    ],
    [
      "pernod",
      0.055
    ]
  ],
  "bonbonne": [
    [
      "bouteille",
      0.3325
    ],
    [
      "abdomen",
      0.11
    ],
    [
      "bombe",
      0.11
    ],
    [
      "fiasque",
      0.11
    ],
    [
      "jaquelin",
      0.11
    ],
    [
      "tourie",
      0.11
    ]
  ],
  "quinze": [],
  "revolu": [
    [
      "passe",
      0.1475
    ],
    [
      "accompli",
      0.11
    ],
    [
      "vieux",
      0.11
    ],
    [
      "termine",
      0.0725
    ],
    [
      "perime",
      0.0725
    ],
    [
      "ancien",
      0.0725
    ],
    [
      "acheve",
      0.0725
    ],
    [
      "echu",
      0.035
    ],
    [
      "sonne",
      0.035
    ],
    [
      "fini",
      0.035
    ],
    [
      "expire",
      0.035
    ],
    [
      "deroule",
      0.035
    ],
    [
      "depasse",
      0.035
    ],
    [
      "defunt",
      0.035
    ],
    [
      "complet",
      0.035
    ],
    [
      "ecoule",
      0.035
    ]
  ],
  "prime": [
    [
      "gratification",
      0.14
    ],
    [
      "commission",
      0.1275
    ],
    [
      "guelte",
      0.075
    ],
    [
      "pourboire",
      0.075
    ],
    [
      "remuneration",
      0.075
    ],
    [
      "gain",
      0.0625
    ],
    [
      "recompense",
      0.0625
    ],
    [
      "salaire",
      0.0625
    ],
    [
      "ristourne",
      0.05
    ],
    [
      "remise",
      0.05
    ],
    [
      "courtage",
      0.05
    ],
    [
      "boni",
      0.025
    ],
    [
      "escompte",
      0.025
    ],
    [
      "premier",
      0.0125
    ],
    [
      "messe",
      0.0125
    ],
    [
      "gracieusete",
      0.0125
    ],
    [
      "encouragement",
      0.0125
    ],
    [
      "ducroire",
      0.0125
    ],
    [
      "cotisation",
      0.0125
    ],
    [
      "bonus",
      0.0125
    ],
    [
      "pret",
      0.0125
    ]
  ],
  "amourette": [
    [
      "amour",
      0.165
    ],
    [
      "flirt",
      0.14
    ],
    [
      "caprice",
      0.105
    ],
    [
      "bagatelle",
      0.07
    ],
    [
      "toquade",
      0.0575
    ],
    [
      "fantaisie",
      0.0575
    ],
    [
      "beguin",
      0.0575
    ],
    [
      "passade",
      0.045
    ],
    [
      "intrigue",
      0.035
    ],
    [
      "bluette",
      0.035
    ],
    [
      "badinage",
      0.035
    ],
    [
      "aventure",
      0.035
    ],
    [
      "idylle",
      0.0225
    ],
    [
      "bricole",
      0.0225
    ],
    [
      "batifolage",
      0.0225
    ],
    [
      "babiole",
      0.0225
    ],
    [
      "brize",
      0.01
    ],
    [
      "conquete",
      0.01
    ],
    [
      "frequentation",
      0.01
    ],
    [
      "passionnette",
      0.01
    ],
    [
      "pepin",
      0.01
    ]
  ],
  "rencherir": [
    [
      "exagerer",
      0.1425
    ],
    [
      "grossir",
      0.1
    ],
    [
      "augmenter",
      0.0925
    ],
    [
      "amplifier",
      0.0625
    ],
    [
      "surfaire",
      0.05
    ],
    [
      "enfler",
      0.045
    ],
    [
      "hausser",
      0.045
    ],
    [
      "forcer",
      0.04
    ],
    [
      "grandir",
      0.035
    ],
    [
      "charger",
      0.03
    ],
    [
      "encherir",
      0.03
    ],
    [
      "outrer",
      0.03
    ],
    [
      "monter",
      0.0275
    ],
    [
      "ajouter",
      0.0225
    ],
    [
      "majorer",
      0.0225
    ],
    [
      "relever",
      0.0175
    ],
    [
      "rehausser",
      0.0175
    ],
    [
      "pousser",
      0.0175
    ],
    [
      "bluffer",
      0.0125
    ],
    [
      "dramatiser",
      0.0125
    ],
    [
      "habler",
      0.0125
    ],
    [
      "revaloriser",
      0.0125
    ],
    [
      "surencherir",
      0.0075
    ],
    [
      "rajouter",
      0.0075
    ],
    [
      "galejer",
      0.0075
    ],
    [
      "depasser",
      0.0075
    ],
    [
      "broder",
      0.0075
    ],
    [
      "relancer",
      0.0025
    ],
    [
      "remonter",
      0.0025
    ],
    [
      "renvier",
      0.0025
    ]
  ],
  "autochtone": [
    [
      "indigene",
      0.23
    ],
    [
      "aborigene",
      0.1525
    ],
    [
      "natif",
      0.1525
    ],
    [
      "naturel",
      0.1525
    ],
    [
      "habitant",
      0.075
    ],
    [
      "local",
      0.075
    ],
    [
      "originaire",
      0.075
    ],
    [
      "ressortissant",
      0.075
    ]
  ],
  "baigneur": [
    [
      "vacancier",
      0.165
    ],
    [
      "poupee",
      0.0825
    ],
    [
      "poupon",
      0.0825
    ],
    [
      "poupard",
      0.0825
    ],
    [
      "nageur",
      0.0825
    ],
    [
      "curiste",
      0.0825
    ],
    [
      "bebe",
      0.0825
    ],
    [
      "buveur",
      0.0825
    ],
    [
      "baignade",
      0.0825
    ],
    [
      "aoutien",
      0.0825
    ],
    [
      "touriste",
      0.0825
    ]
  ],
  "paravent": [
    [
      "abri",
      0.1875
    ],
    [
      "protection",
      0.1875
    ],
    [
      "couverture",
      0.125
    ],
    [
      "ecran",
      0.125
    ],
    [
      "bouclier",
      0.06
    ],
    [
      "facade",
      0.06
    ],
    [
      "pretexte",
      0.06
    ]
  ],
  "lopin": [
    [
      "champ",
      0.25
    ],
    [
      "morceau",
      0.25
    ],
    [
      "parcelle",
      0.25
    ],
    [
      "portion",
      0.25
    ]
  ],
  "pin": [
    [
      "abietacee",
      0.5
    ],
    [
      "pinasse",
      0.5
    ]
  ],
  "parasol": [
    [
      "abri",
      0.22
    ],
    [
      "ombrelle",
      0.22
    ],
    [
      "parapluie",
      0.22
    ]
  ],
  "premunir": [
    [
      "proteger",
      0.1875
    ],
    [
      "garantir",
      0.125
    ],
    [
      "immuniser",
      0.125
    ],
    [
      "preserver",
      0.125
    ],
    [
      "vacciner",
      0.125
    ],
    [
      "garder",
      0.0625
    ],
    [
      "avertir",
      0.0625
    ],
    [
      "armer",
      0.0625
    ],
    [
      "accoutumer",
      0.0625
    ],
    [
      "munir",
      0.0625
    ]
  ],
  "insolation": [
    [
      "brulure",
      0.3325
    ],
    [
      "chaleur",
      0.3325
    ]
  ],
  "affectueux": [
    [
      "amoureux",
      0.145
    ],
    [
      "tendre",
      0.145
    ],
    [
      "sensible",
      0.0825
    ],
    [
      "sentimental",
      0.0825
    ],
    [
      "amical",
      0.0625
    ],
    [
      "bon",
      0.0625
    ],
    [
      "cordial",
      0.0625
    ],
    [
      "gentil",
      0.04
    ],
    [
      "fraternel",
      0.04
    ],
    [
      "doux",
      0.04
    ],
    [
      "calin",
      0.04
    ],
    [
      "aimant",
      0.04
    ],
    [
      "affectif",
      0.02
    ],
    [
      "affectionne",
      0.02
    ],
    [
      "ami",
      0.02
    ],
    [
      "amiteux",
      0.02
    ],
    [
      "attentif",
      0.02
    ],
    [
      "caressant",
      0.02
    ],
    [
      "chaleureux",
      0.02
    ]
  ],
  "reverence": [
    [
      "respect",
      0.17
    ],
    [
      "honneur",
      0.0825
    ],
    [
      "veneration",
      0.0825
    ],
    [
      "consideration",
      0.07
    ],
    [
      "estime",
      0.07
    ],
    [
      "salut",
      0.07
    ],
    [
      "hommage",
      0.055
    ],
    [
      "culte",
      0.04
    ],
    [
      "inclination",
      0.04
    ],
    [
      "egard",
      0.0275
    ],
    [
      "pudeur",
      0.0275
    ],
    [
      "prosternation",
      0.0275
    ],
    [
      "piete",
      0.0275
    ],
    [
      "deference",
      0.0275
    ],
    [
      "courbette",
      0.0275
    ],
    [
      "affection",
      0.0275
    ],
    [
      "reserve",
      0.0125
    ],
    [
      "retenue",
      0.0125
    ],
    [
      "prosternement",
      0.0125
    ],
    [
      "plongeon",
      0.0125
    ],
    [
      "crainte",
      0.0125
    ],
    [
      "courtoisie",
      0.0125
    ],
    [
      "salamalec",
      0.0125
    ]
  ],
  "tantot": [
    [
      "bientot",
      0.165
    ],
    [
      "heure",
      0.165
    ],
    [
      "parfois",
      0.165
    ],
    [
      "presque",
      0.165
    ],
    [
      "successivement",
      0.165
    ]
  ],
  "fandango": [],
  "tarentelle": [
    [
      "danse",
      1.0
    ]
  ],
  "prenant": [
    [
      "captivant",
      0.1275
    ],
    [
      "passionnant",
      0.1
    ],
    [
      "attachant",
      0.07
    ],
    [
      "fascinant",
      0.07
    ],
    [
      "emouvant",
      0.055
    ],
    [
      "seduisant",
      0.055
    ],
    [
      "interessant",
      0.055
    ],
    [
      "attirant",
      0.055
    ],
    [
      "poignant",
      0.0425
    ],
    [
      "palpitant",
      0.0425
    ],
    [
      "dramatique",
      0.0425
    ],
    [
      "charmant",
      0.0425
    ],
    [
      "attrayant",
      0.0425
    ],
    [
      "absorbant",
      0.0425
    ],
    [
      "empoignant",
      0.0275
    ],
    [
      "charmeur",
      0.0275
    ],
    [
      "attractif",
      0.0275
    ],
    [
      "delicieux",
      0.0125
    ],
    [
      "exigeant",
      0.0125
    ],
    [
      "occupant",
      0.0125
    ],
    [
      "pathetique",
      0.0125
    ]
  ],
  "butter": [
    [
      "rechausser",
      1.0
    ]
  ],
  "butte": [
    [
      "hauteur",
      0.195
    ],
    [
      "monticule",
      0.15
    ],
    [
      "eminence",
      0.13
    ],
    [
      "elevation",
      0.085
    ],
    [
      "colline",
      0.065
    ],
    [
      "tertre",
      0.0425
    ],
    [
      "taupiniere",
      0.0425
    ],
    [
      "motte",
      0.0425
    ],
    [
      "mamelon",
      0.0425
    ],
    [
      "dune",
      0.0425
    ],
    [
      "bosse",
      0.02
    ],
    [
      "but",
      0.02
    ],
    [
      "coteau",
      0.02
    ],
    [
      "erg",
      0.02
    ],
    [
      "mont",
      0.02
    ],
    [
      "talus",
      0.02
    ],
    [
      "taupinee",
      0.02
    ]
  ],
  "ondine": [
    [
      "deesse",
      0.5
    ],
    [
      "genie",
      0.5
    ]
  ],
  "posthume": [
    [
      "posterieur",
      0.5
    ]
  ],
  "pharaon": [
    [
      "roi",
      1.0
    ]
  ],
  "gesir": [
    [
      "resider",
      0.4
    ],
    [
      "consister",
      0.2
    ],
    [
      "sieger",
      0.2
    ]
  ],
  "gisant": [
    [
      "immobile",
      0.5
    ],
    [
      "etendu",
      0.5
    ]
  ],
  "consequence": [
    [
      "effet",
      0.17
    ],
    [
      "suite",
      0.12
    ],
    [
      "resultat",
      0.1
    ],
    [
      "fruit",
      0.06
    ],
    [
      "repercussion",
      0.05
    ],
    [
      "ricochet",
      0.0375
    ],
    [
      "dependance",
      0.0375
    ],
    [
      "contrecoup",
      0.0375
    ],
    [
      "conclusion",
      0.03
    ],
    [
      "produit",
      0.03
    ],
    [
      "prolongement",
      0.03
    ],
    [
      "rapport",
      0.03
    ],
    [
      "retentissement",
      0.03
    ],
    [
      "portee",
      0.0175
    ],
    [
      "enchainement",
      0.0175
    ],
    [
      "deduction",
      0.0175
    ],
    [
      "corollaire",
      0.0175
    ],
    [
      "sequelle",
      0.0075
    ],
    [
      "reaction",
      0.0075
    ],
    [
      "rejaillissement",
      0.0075
    ],
    [
      "rancon",
      0.0075
    ],
    [
      "lendemain",
      0.0075
    ],
    [
      "importance",
      0.0075
    ],
    [
      "impact",
      0.0075
    ],
    [
      "fonction",
      0.0075
    ],
    [
      "fils",
      0.0075
    ],
    [
      "fille",
      0.0075
    ],
    [
      "consequent",
      0.0075
    ],
    [
      "bilan",
      0.0075
    ],
    [
      "accompagnement",
      0.0075
    ],
    [
      "accident",
      0.0075
    ],
    [
      "serieux",
      0.0075
    ]
  ],
  "estivant": [
    [
      "vacancier",
      0.5
    ],
    [
      "aoutien",
      0.165
    ],
    [
      "villegiateur",
      0.165
    ],
    [
      "visiteur",
      0.165
    ]
  ],
  "pedalo": [],
  "radiateur": [
    [
      "chauffage",
      1.0
    ]
  ],
  "light": [],
  "mobile": [
    [
      "instable",
      0.11
    ],
    [
      "changeant",
      0.09
    ],
    [
      "mouvant",
      0.045
    ],
    [
      "flottant",
      0.0425
    ],
    [
      "inconstant",
      0.0375
    ],
    [
      "ondoyant",
      0.0375
    ],
    [
      "variable",
      0.035
    ],
    [
      "versatile",
      0.035
    ],
    [
      "fugace",
      0.025
    ],
    [
      "capricieux",
      0.0225
    ],
    [
      "fugitif",
      0.0225
    ],
    [
      "motif",
      0.0225
    ],
    [
      "vif",
      0.0225
    ],
    [
      "volage",
      0.0225
    ],
    [
      "remuant",
      0.0175
    ],
    [
      "fragile",
      0.0175
    ],
    [
      "errant",
      0.0175
    ],
    [
      "cause",
      0.0175
    ],
    [
      "ambulant",
      0.0175
    ],
    [
      "leger",
      0.015
    ],
    [
      "fuyant",
      0.015
    ],
    [
      "fringant",
      0.015
    ],
    [
      "anime",
      0.015
    ],
    [
      "vacillant",
      0.01
    ],
    [
      "turbulent",
      0.01
    ],
    [
      "tordu",
      0.01
    ],
    [
      "raison",
      0.01
    ],
    [
      "papillotant",
      0.01
    ],
    [
      "nomade",
      0.01
    ],
    [
      "moteur",
      0.01
    ],
    [
      "fluctuant",
      0.01
    ],
    [
      "fantasque",
      0.01
    ],
    [
      "agile",
      0.01
    ],
    [
      "elastique",
      0.005
    ],
    [
      "voyageur",
      0.005
    ],
    [
      "proteiforme",
      0.005
    ],
    [
      "portatif",
      0.005
    ],
    [
      "portable",
      0.005
    ],
    [
      "irresolu",
      0.005
    ],
    [
      "chatoyant",
      0.005
    ],
    [
      "ardent",
      0.005
    ],
    [
      "alterable",
      0.005
    ],
    [
      "fondement",
      0.0025
    ],
    [
      "influencable",
      0.0025
    ],
    [
      "intention",
      0.0025
    ],
    [
      "itinerant",
      0.0025
    ],
    [
      "moblot",
      0.0025
    ],
    [
      "motivation",
      0.0025
    ],
    [
      "ressort",
      0.0025
    ],
    [
      "telephone",
      0.0025
    ],
    [
      "expressif",
      0.0025
    ],
    [
      "explication",
      0.0025
    ],
    [
      "aigu",
      0.0025
    ],
    [
      "ambition",
      0.0025
    ],
    [
      "ambulatoire",
      0.0025
    ],
    [
      "amovible",
      0.0025
    ],
    [
      "astatique",
      0.0025
    ],
    [
      "bizarre",
      0.0025
    ],
    [
      "considerant",
      0.0025
    ],
    [
      "dissemblable",
      0.0025
    ],
    [
      "volant",
      0.0025
    ]
  ],
  "academie": [
    [
      "institut",
      0.1275
    ],
    [
      "ecole",
      0.1275
    ],
    [
      "nu",
      0.095
    ],
    [
      "lycee",
      0.0625
    ],
    [
      "cours",
      0.0625
    ],
    [
      "conservatoire",
      0.0625
    ],
    [
      "college",
      0.0625
    ],
    [
      "societe",
      0.03
    ],
    [
      "rectorat",
      0.03
    ],
    [
      "peinture",
      0.03
    ],
    [
      "modele",
      0.03
    ],
    [
      "gymnase",
      0.03
    ],
    [
      "faculte",
      0.03
    ],
    [
      "assemblee",
      0.03
    ],
    [
      "anatomie",
      0.03
    ],
    [
      "Institut",
      0.03
    ],
    [
      "universite",
      0.03
    ]
  ],
  "assaillir": [
    [
      "assieger",
      0.115
    ],
    [
      "attaquer",
      0.1025
    ],
    [
      "presser",
      0.1025
    ],
    [
      "harceler",
      0.09
    ],
    [
      "poursuivre",
      0.065
    ],
    [
      "tourmenter",
      0.065
    ],
    [
      "obseder",
      0.05
    ],
    [
      "bombarder",
      0.05
    ],
    [
      "solliciter",
      0.025
    ],
    [
      "ronger",
      0.025
    ],
    [
      "importuner",
      0.025
    ],
    [
      "hanter",
      0.025
    ],
    [
      "exciter",
      0.025
    ],
    [
      "battre",
      0.025
    ],
    [
      "accabler",
      0.025
    ],
    [
      "sauter",
      0.0125
    ],
    [
      "piller",
      0.0125
    ],
    [
      "fondre",
      0.0125
    ],
    [
      "environner",
      0.0125
    ],
    [
      "combattre",
      0.0125
    ],
    [
      "agresser",
      0.0125
    ]
  ],
  "desillusion": [
    [
      "deception",
      0.2775
    ],
    [
      "deboire",
      0.165
    ],
    [
      "deconvenue",
      0.165
    ],
    [
      "desappointement",
      0.11
    ],
    [
      "decompte",
      0.055
    ],
    [
      "desenchantement",
      0.055
    ],
    [
      "mecompte",
      0.055
    ],
    [
      "rancoeur",
      0.055
    ],
    [
      "revers",
      0.055
    ]
  ],
  "dring": [
    [
      "drelin",
      1.0
    ]
  ],
  "formulaire": [
    [
      "codex",
      0.3325
    ],
    [
      "catalogue",
      0.165
    ],
    [
      "formule",
      0.165
    ],
    [
      "protocole",
      0.165
    ],
    [
      "questionnaire",
      0.165
    ]
  ],
  "asthmatique": [
    [
      "essouffle",
      0.5
    ],
    [
      "poussif",
      0.5
    ]
  ],
  "civil": [
    [
      "poli",
      0.1175
    ],
    [
      "aimable",
      0.1075
    ],
    [
      "gracieux",
      0.0875
    ],
    [
      "serviable",
      0.0775
    ],
    [
      "affable",
      0.0675
    ],
    [
      "gentil",
      0.0675
    ],
    [
      "beau",
      0.0575
    ],
    [
      "empresse",
      0.0475
    ],
    [
      "galant",
      0.0475
    ],
    [
      "honnete",
      0.0475
    ],
    [
      "complaisant",
      0.0375
    ],
    [
      "courtois",
      0.0375
    ],
    [
      "bienseant",
      0.0275
    ],
    [
      "correct",
      0.0175
    ],
    [
      "sociable",
      0.0175
    ],
    [
      "traitable",
      0.0175
    ],
    [
      "politique",
      0.0075
    ],
    [
      "laique",
      0.0075
    ],
    [
      "laic",
      0.0075
    ],
    [
      "intestin",
      0.0075
    ],
    [
      "convenable",
      0.0075
    ],
    [
      "civique",
      0.0075
    ],
    [
      "bourgeois",
      0.0075
    ],
    [
      "pekin",
      0.0075
    ]
  ],
  "raz": [
    [
      "barre",
      1.0
    ]
  ],
  "scooter": [
    [
      "vespa",
      1.0
    ]
  ],
  "denoncer": [
    [
      "reveler",
      0.115
    ],
    [
      "signaler",
      0.0825
    ],
    [
      "indiquer",
      0.08
    ],
    [
      "montrer",
      0.0575
    ],
    [
      "trahir",
      0.055
    ],
    [
      "donner",
      0.045
    ],
    [
      "annoncer",
      0.04
    ],
    [
      "devoiler",
      0.03
    ],
    [
      "manifester",
      0.0275
    ],
    [
      "rapporter",
      0.0275
    ],
    [
      "signifier",
      0.0225
    ],
    [
      "livrer",
      0.0225
    ],
    [
      "declarer",
      0.0225
    ],
    [
      "decouvrir",
      0.015
    ],
    [
      "denoter",
      0.015
    ],
    [
      "marquer",
      0.015
    ],
    [
      "rompre",
      0.0125
    ],
    [
      "publier",
      0.0125
    ],
    [
      "nommer",
      0.0125
    ],
    [
      "accuser",
      0.0125
    ],
    [
      "notifier",
      0.01
    ],
    [
      "designer",
      0.01
    ],
    [
      "deceler",
      0.01
    ],
    [
      "cafarder",
      0.01
    ],
    [
      "avertir",
      0.01
    ],
    [
      "annuler",
      0.01
    ],
    [
      "s'allonger",
      0.005
    ],
    [
      "renoncer",
      0.005
    ],
    [
      "proclamer",
      0.005
    ],
    [
      "moucharder",
      0.005
    ],
    [
      "invalider",
      0.005
    ],
    [
      "inculper",
      0.005
    ],
    [
      "deferer",
      0.005
    ],
    [
      "casser",
      0.005
    ],
    [
      "bruler",
      0.005
    ],
    [
      "griller",
      0.0025
    ],
    [
      "s'affaler",
      0.0025
    ],
    [
      "sentir",
      0.0025
    ],
    [
      "fourguer",
      0.0025
    ],
    [
      "capouner",
      0.0025
    ],
    [
      "caponner",
      0.0025
    ],
    [
      "cafeter",
      0.0025
    ],
    [
      "balanstiquer",
      0.0025
    ],
    [
      "balancer",
      0.0025
    ],
    [
      "vendre",
      0.0025
    ]
  ],
  "amputation": [
    [
      "ablation",
      0.2075
    ],
    [
      "excision",
      0.125
    ],
    [
      "suppression",
      0.1025
    ],
    [
      "diminution",
      0.0825
    ],
    [
      "mutilation",
      0.0625
    ],
    [
      "retranchement",
      0.0625
    ],
    [
      "sectionnement",
      0.04
    ],
    [
      "resection",
      0.04
    ],
    [
      "retrait",
      0.04
    ],
    [
      "autotomie",
      0.04
    ],
    [
      "allegement",
      0.04
    ],
    [
      "abscission",
      0.02
    ],
    [
      "amenuisement",
      0.02
    ],
    [
      "appauvrissement",
      0.02
    ],
    [
      "censure",
      0.02
    ],
    [
      "operation",
      0.02
    ],
    [
      "rescision",
      0.02
    ]
  ],
  "karaoke": [],
  "goulag": [
    [
      "camp",
      1.0
    ]
  ],
  "cellule": [
    [
      "cachot",
      0.1275
    ],
    [
      "prison",
      0.0675
    ],
    [
      "compartiment",
      0.055
    ],
    [
      "division",
      0.055
    ],
    [
      "groupe",
      0.055
    ],
    [
      "loge",
      0.045
    ],
    [
      "case",
      0.045
    ],
    [
      "box",
      0.045
    ],
    [
      "cabanon",
      0.0325
    ],
    [
      "chambre",
      0.0325
    ],
    [
      "oubliette",
      0.0325
    ],
    [
      "taule",
      0.0325
    ],
    [
      "section",
      0.0225
    ],
    [
      "reduit",
      0.0225
    ],
    [
      "chambrette",
      0.0225
    ],
    [
      "bloc",
      0.0225
    ],
    [
      "alveole",
      0.0225
    ],
    [
      "neurone",
      0.01
    ],
    [
      "noyau",
      0.01
    ],
    [
      "osteocyte",
      0.01
    ],
    [
      "posemetre",
      0.01
    ],
    [
      "tissu",
      0.01
    ],
    [
      "tole",
      0.01
    ],
    [
      "violon",
      0.01
    ],
    [
      "mitard",
      0.01
    ],
    [
      "globule",
      0.01
    ],
    [
      "cabanette",
      0.01
    ],
    [
      "carre",
      0.01
    ],
    [
      "casemate",
      0.01
    ],
    [
      "clan",
      0.01
    ],
    [
      "fuselage",
      0.01
    ],
    [
      "geole",
      0.01
    ],
    [
      "element",
      0.01
    ]
  ],
  "parloir": [],
  "jamaicain": [],
  "italien": [
    [
      "ausonien",
      0.25
    ],
    [
      "italique",
      0.25
    ],
    [
      "rital",
      0.25
    ],
    [
      "transalpin",
      0.25
    ]
  ],
  "synthetique": [
    [
      "artificiel",
      0.25
    ],
    [
      "empirique",
      0.25
    ],
    [
      "polyamide",
      0.25
    ],
    [
      "polyester",
      0.25
    ]
  ],
  "concertiste": [
    [
      "musicien",
      0.5
    ],
    [
      "virtuose",
      0.5
    ]
  ],
  "toxico": [],
  "parpaing": [
    [
      "agglomere",
      0.18
    ],
    [
      "moellon",
      0.18
    ],
    [
      "roche",
      0.18
    ],
    [
      "bloc",
      0.09
    ],
    [
      "brique",
      0.09
    ],
    [
      "hourdis",
      0.09
    ],
    [
      "parpaigne",
      0.09
    ],
    [
      "pierre",
      0.09
    ]
  ],
  "betement": [
    [
      "innocemment",
      0.12
    ],
    [
      "sottement",
      0.12
    ],
    [
      "stupidement",
      0.08
    ],
    [
      "niaisement",
      0.08
    ],
    [
      "naivement",
      0.08
    ],
    [
      "imbecilement",
      0.08
    ],
    [
      "bonnement",
      0.08
    ],
    [
      "ridiculement",
      0.04
    ],
    [
      "pretentieusement",
      0.04
    ],
    [
      "maladroitement",
      0.04
    ],
    [
      "lourdement",
      0.04
    ],
    [
      "inintelligemment",
      0.04
    ],
    [
      "idiotement",
      0.04
    ],
    [
      "gauchement",
      0.04
    ],
    [
      "simplement",
      0.04
    ]
  ],
  "gold": [],
  "manioc": [
    [
      "tapioca",
      1.0
    ]
  ],
  "abat": [
    [
      "abattement",
      0.5
    ],
    [
      "pluie",
      0.5
    ]
  ],
  "fourmilier": [
    [
      "tamandua",
      1.0
    ]
  ],
  "sejour": [
    [
      "passage",
      0.125
    ],
    [
      "stage",
      0.0825
    ],
    [
      "residence",
      0.0825
    ],
    [
      "maison",
      0.0825
    ],
    [
      "lieu",
      0.0825
    ],
    [
      "domicile",
      0.0825
    ],
    [
      "arret",
      0.0825
    ],
    [
      "villegiature",
      0.04
    ],
    [
      "pause",
      0.04
    ],
    [
      "logement",
      0.04
    ],
    [
      "living",
      0.04
    ],
    [
      "habitation",
      0.04
    ],
    [
      "endroit",
      0.04
    ],
    [
      "demeure",
      0.04
    ],
    [
      "voyage",
      0.04
    ]
  ],
  "associe": [
    [
      "reunir",
      0.14
    ],
    [
      "unir",
      0.11
    ],
    [
      "joindre",
      0.0775
    ],
    [
      "assembler",
      0.0725
    ],
    [
      "combiner",
      0.06
    ],
    [
      "allier",
      0.0525
    ],
    [
      "lier",
      0.0425
    ],
    [
      "fusionner",
      0.03
    ],
    [
      "melanger",
      0.025
    ],
    [
      "rassembler",
      0.02
    ],
    [
      "rapprocher",
      0.02
    ],
    [
      "incorporer",
      0.02
    ],
    [
      "attacher",
      0.02
    ],
    [
      "adjoindre",
      0.02
    ],
    [
      "accorder",
      0.02
    ],
    [
      "federer",
      0.0175
    ],
    [
      "relier",
      0.015
    ],
    [
      "marier",
      0.015
    ],
    [
      "grouper",
      0.015
    ],
    [
      "amalgamer",
      0.015
    ],
    [
      "agencer",
      0.015
    ],
    [
      "adapter",
      0.015
    ],
    [
      "meler",
      0.0125
    ],
    [
      "juxtaposer",
      0.0125
    ],
    [
      "agreger",
      0.0125
    ],
    [
      "affilier",
      0.01
    ],
    [
      "coaliser",
      0.01
    ],
    [
      "integrer",
      0.01
    ],
    [
      "assortir",
      0.0075
    ],
    [
      "enchainer",
      0.0075
    ],
    [
      "liguer",
      0.0075
    ],
    [
      "s'adjoindre",
      0.005
    ],
    [
      "concentrer",
      0.005
    ],
    [
      "composer",
      0.005
    ],
    [
      "syndiquer",
      0.0025
    ],
    [
      "suspendre",
      0.0025
    ],
    [
      "solidariser",
      0.0025
    ],
    [
      "s'unir",
      0.0025
    ],
    [
      "s'attacher",
      0.0025
    ],
    [
      "partager",
      0.0025
    ],
    [
      "interesser",
      0.0025
    ],
    [
      "initier",
      0.0025
    ],
    [
      "enroler",
      0.0025
    ],
    [
      "embrancher",
      0.0025
    ],
    [
      "confederer",
      0.0025
    ],
    [
      "confondre",
      0.0025
    ],
    [
      "evoquer",
      0.0025
    ]
  ],
  "excellent": [
    [
      "beau",
      0.17
    ],
    [
      "parfait",
      0.105
    ],
    [
      "bon",
      0.1
    ],
    [
      "fameux",
      0.0575
    ],
    [
      "superieur",
      0.0575
    ],
    [
      "remarquable",
      0.0525
    ],
    [
      "exquis",
      0.045
    ],
    [
      "incomparable",
      0.04
    ],
    [
      "merveilleux",
      0.0275
    ],
    [
      "fin",
      0.0275
    ],
    [
      "accompli",
      0.0225
    ],
    [
      "acheve",
      0.0225
    ],
    [
      "admirable",
      0.0225
    ],
    [
      "grand",
      0.0225
    ],
    [
      "epatant",
      0.015
    ],
    [
      "succulent",
      0.015
    ],
    [
      "magistral",
      0.015
    ],
    [
      "extra",
      0.015
    ],
    [
      "delicieux",
      0.015
    ],
    [
      "consomme",
      0.015
    ],
    [
      "unique",
      0.01
    ],
    [
      "singulier",
      0.01
    ],
    [
      "brave",
      0.01
    ],
    [
      "bien",
      0.01
    ],
    [
      "precellent",
      0.005
    ],
    [
      "propice",
      0.005
    ],
    [
      "meilleur",
      0.005
    ],
    [
      "impeccable",
      0.005
    ],
    [
      "fort",
      0.005
    ],
    [
      "excellentissime",
      0.005
    ],
    [
      "devoue",
      0.005
    ],
    [
      "cher",
      0.005
    ],
    [
      "chenu",
      0.005
    ]
  ],
  "accablant": [
    [
      "penible",
      0.09
    ],
    [
      "ennuyeux",
      0.0825
    ],
    [
      "fatigant",
      0.055
    ],
    [
      "importun",
      0.0475
    ],
    [
      "lourd",
      0.0475
    ],
    [
      "pesant",
      0.0475
    ],
    [
      "etouffant",
      0.0325
    ],
    [
      "epuisant",
      0.0325
    ],
    [
      "ecrasant",
      0.0325
    ],
    [
      "tuant",
      0.0325
    ],
    [
      "triste",
      0.0325
    ],
    [
      "intolerable",
      0.0325
    ],
    [
      "insupportable",
      0.0325
    ],
    [
      "affligeant",
      0.0275
    ],
    [
      "desesperant",
      0.0275
    ],
    [
      "oppressant",
      0.0275
    ],
    [
      "suffocant",
      0.02
    ],
    [
      "rude",
      0.02
    ],
    [
      "irrespirable",
      0.02
    ],
    [
      "incommode",
      0.02
    ],
    [
      "facheux",
      0.02
    ],
    [
      "attristant",
      0.02
    ],
    [
      "alourdissant",
      0.02
    ],
    [
      "terrassant",
      0.0125
    ],
    [
      "surchauffe",
      0.0125
    ],
    [
      "morne",
      0.0125
    ],
    [
      "decourageant",
      0.0125
    ],
    [
      "fatidique",
      0.005
    ],
    [
      "impitoyable",
      0.005
    ],
    [
      "inexorable",
      0.005
    ],
    [
      "irrefutable",
      0.005
    ],
    [
      "onereux",
      0.005
    ],
    [
      "orageux",
      0.005
    ],
    [
      "surcharge",
      0.005
    ],
    [
      "torpide",
      0.005
    ],
    [
      "exhaustif",
      0.005
    ],
    [
      "desarmant",
      0.005
    ],
    [
      "accusateur",
      0.005
    ],
    [
      "aggravant",
      0.005
    ],
    [
      "assommant",
      0.005
    ],
    [
      "atroce",
      0.005
    ],
    [
      "atterrant",
      0.005
    ],
    [
      "brisant",
      0.005
    ],
    [
      "brulant",
      0.005
    ],
    [
      "deroutant",
      0.005
    ],
    [
      "tropical",
      0.005
    ]
  ],
  "hurlant": [
    [
      "criard",
      0.25
    ],
    [
      "gueulard",
      0.25
    ],
    [
      "amusant",
      0.125
    ],
    [
      "criant",
      0.125
    ],
    [
      "hurleur",
      0.125
    ],
    [
      "tonitruant",
      0.125
    ]
  ],
  "rallier": [
    [
      "rassembler",
      0.09
    ],
    [
      "reunir",
      0.09
    ],
    [
      "gagner",
      0.075
    ],
    [
      "joindre",
      0.075
    ],
    [
      "rejoindre",
      0.075
    ],
    [
      "toucher",
      0.045
    ],
    [
      "revenir",
      0.045
    ],
    [
      "rentrer",
      0.045
    ],
    [
      "regrouper",
      0.045
    ],
    [
      "ramasser",
      0.045
    ],
    [
      "concentrer",
      0.045
    ],
    [
      "assembler",
      0.045
    ],
    [
      "retrouver",
      0.03
    ],
    [
      "regagner",
      0.03
    ],
    [
      "conquerir",
      0.03
    ],
    [
      "aborder",
      0.03
    ],
    [
      "retourner",
      0.0125
    ],
    [
      "reformer",
      0.0125
    ],
    [
      "passer",
      0.0125
    ],
    [
      "liguer",
      0.0125
    ],
    [
      "emporter",
      0.0125
    ],
    [
      "convertir",
      0.0125
    ],
    [
      "accoster",
      0.0125
    ]
  ],
  "reserve": [
    [
      "retenue",
      0.125
    ],
    [
      "decence",
      0.0525
    ],
    [
      "circonspection",
      0.045
    ],
    [
      "pudeur",
      0.0425
    ],
    [
      "tenue",
      0.035
    ],
    [
      "discretion",
      0.035
    ],
    [
      "delicatesse",
      0.0225
    ],
    [
      "mesure",
      0.0225
    ],
    [
      "provision",
      0.0225
    ],
    [
      "sagesse",
      0.0225
    ],
    [
      "prudence",
      0.02
    ],
    [
      "honnetete",
      0.02
    ],
    [
      "bienseance",
      0.02
    ],
    [
      "honte",
      0.0175
    ],
    [
      "moderation",
      0.0175
    ],
    [
      "precaution",
      0.0175
    ],
    [
      "tact",
      0.0175
    ],
    [
      "economie",
      0.015
    ],
    [
      "menagement",
      0.015
    ],
    [
      "vertu",
      0.0125
    ],
    [
      "sobriete",
      0.0125
    ],
    [
      "respect",
      0.0125
    ],
    [
      "politesse",
      0.0125
    ],
    [
      "modestie",
      0.0125
    ],
    [
      "magasin",
      0.0125
    ],
    [
      "soin",
      0.01
    ],
    [
      "gravite",
      0.01
    ],
    [
      "depot",
      0.01
    ],
    [
      "convenance",
      0.01
    ],
    [
      "epargne",
      0.0075
    ],
    [
      "timidite",
      0.0075
    ],
    [
      "temperance",
      0.0075
    ],
    [
      "reticence",
      0.0075
    ],
    [
      "restriction",
      0.0075
    ],
    [
      "humilite",
      0.0075
    ],
    [
      "dignite",
      0.0075
    ],
    [
      "componction",
      0.0075
    ],
    [
      "chastete",
      0.0075
    ],
    [
      "calme",
      0.0075
    ],
    [
      "approvisionnement",
      0.0075
    ],
    [
      "secret",
      0.005
    ],
    [
      "silo",
      0.005
    ],
    [
      "stock",
      0.005
    ],
    [
      "tresor",
      0.005
    ],
    [
      "reservoir",
      0.005
    ],
    [
      "resserre",
      0.005
    ],
    [
      "puissance",
      0.005
    ],
    [
      "pudicite",
      0.005
    ],
    [
      "pruderie",
      0.005
    ],
    [
      "flegme",
      0.005
    ],
    [
      "amas",
      0.005
    ],
    [
      "ressource",
      0.0025
    ],
    [
      "ravitaillement",
      0.0025
    ],
    [
      "pudibonderie",
      0.0025
    ],
    [
      "potentiel",
      0.0025
    ],
    [
      "parc",
      0.0025
    ],
    [
      "reverence",
      0.0025
    ],
    [
      "sanctuaire",
      0.0025
    ],
    [
      "succession",
      0.0025
    ],
    [
      "territoire",
      0.0025
    ],
    [
      "viatique",
      0.0025
    ],
    [
      "victuailles",
      0.0025
    ],
    [
      "vivres",
      0.0025
    ],
    [
      "volant",
      0.0025
    ],
    [
      "etablissement",
      0.0025
    ],
    [
      "maitrise",
      0.0025
    ],
    [
      "matelas",
      0.0025
    ],
    [
      "manutention",
      0.0025
    ],
    [
      "avance",
      0.0025
    ],
    [
      "boutique",
      0.0025
    ],
    [
      "cargaison",
      0.0025
    ],
    [
      "cassette",
      0.0025
    ],
    [
      "congruite",
      0.0025
    ],
    [
      "correction",
      0.0025
    ],
    [
      "disponibilite",
      0.0025
    ],
    [
      "defiance",
      0.0025
    ],
    [
      "depense",
      0.0025
    ],
    [
      "entrepot",
      0.0025
    ],
    [
      "exception",
      0.0025
    ],
    [
      "fierte",
      0.0025
    ],
    [
      "fourniture",
      0.0025
    ],
    [
      "froideur",
      0.0025
    ],
    [
      "accumulation",
      0.0025
    ]
  ],
  "toutefois": [
    [
      "cependant",
      0.2725
    ],
    [
      "neanmoins",
      0.18
    ],
    [
      "pourtant",
      0.18
    ],
    [
      "mais",
      0.09
    ],
    [
      "nonobstant",
      0.09
    ],
    [
      "seulement",
      0.09
    ]
  ],
  "desolant": [
    [
      "affligeant",
      0.1175
    ],
    [
      "penible",
      0.1175
    ],
    [
      "triste",
      0.0975
    ],
    [
      "navrant",
      0.0925
    ],
    [
      "ennuyeux",
      0.0725
    ],
    [
      "attristant",
      0.0525
    ],
    [
      "tendu",
      0.045
    ],
    [
      "lamentable",
      0.045
    ],
    [
      "facheux",
      0.045
    ],
    [
      "douloureux",
      0.0375
    ],
    [
      "deplorable",
      0.0375
    ],
    [
      "piteux",
      0.0375
    ],
    [
      "embetant",
      0.0325
    ],
    [
      "funeste",
      0.025
    ],
    [
      "empoisonnant",
      0.0175
    ],
    [
      "fatigant",
      0.0175
    ],
    [
      "importun",
      0.0175
    ],
    [
      "insupportable",
      0.0125
    ],
    [
      "desesperant",
      0.0125
    ],
    [
      "consternant",
      0.0125
    ],
    [
      "amer",
      0.005
    ],
    [
      "calamiteux",
      0.005
    ],
    [
      "chagrinant",
      0.005
    ],
    [
      "contrariant",
      0.005
    ]
  ],
  "rendant": [
    [
      "donner",
      0.0725
    ],
    [
      "exprimer",
      0.0725
    ],
    [
      "faire",
      0.0725
    ],
    [
      "produire",
      0.0625
    ],
    [
      "remettre",
      0.05
    ],
    [
      "porter",
      0.045
    ],
    [
      "restituer",
      0.0375
    ],
    [
      "rapporter",
      0.0375
    ],
    [
      "reproduire",
      0.0325
    ],
    [
      "representer",
      0.0275
    ],
    [
      "signifier",
      0.02
    ],
    [
      "repeter",
      0.02
    ],
    [
      "refaire",
      0.02
    ],
    [
      "redonner",
      0.02
    ],
    [
      "prononcer",
      0.02
    ],
    [
      "marquer",
      0.02
    ],
    [
      "livrer",
      0.02
    ],
    [
      "enoncer",
      0.015
    ],
    [
      "emettre",
      0.015
    ],
    [
      "traduire",
      0.015
    ],
    [
      "retroceder",
      0.015
    ],
    [
      "renvoyer",
      0.015
    ],
    [
      "rejeter",
      0.015
    ],
    [
      "obtenir",
      0.015
    ],
    [
      "fructifier",
      0.015
    ],
    [
      "fournir",
      0.015
    ],
    [
      "attraper",
      0.015
    ],
    [
      "rembourser",
      0.01
    ],
    [
      "retourner",
      0.01
    ],
    [
      "tenir",
      0.01
    ],
    [
      "travailler",
      0.01
    ],
    [
      "vomir",
      0.01
    ],
    [
      "ramener",
      0.01
    ],
    [
      "poser",
      0.01
    ],
    [
      "payer",
      0.01
    ],
    [
      "observer",
      0.01
    ],
    [
      "lacher",
      0.01
    ],
    [
      "formuler",
      0.01
    ],
    [
      "exhaler",
      0.01
    ],
    [
      "repondre",
      0.0025
    ],
    [
      "repercuter",
      0.0025
    ],
    [
      "revetir",
      0.0025
    ],
    [
      "degueuler",
      0.0025
    ],
    [
      "devenir",
      0.0025
    ],
    [
      "compenser",
      0.0025
    ],
    [
      "reverberer",
      0.0025
    ]
  ],
  "constater": [
    [
      "voir",
      0.095
    ],
    [
      "apercevoir",
      0.065
    ],
    [
      "reconnaitre",
      0.065
    ],
    [
      "remarquer",
      0.065
    ],
    [
      "decouvrir",
      0.0575
    ],
    [
      "eprouver",
      0.0475
    ],
    [
      "verifier",
      0.0475
    ],
    [
      "observer",
      0.0475
    ],
    [
      "connaitre",
      0.0475
    ],
    [
      "apparaitre",
      0.0375
    ],
    [
      "experimenter",
      0.0375
    ],
    [
      "noter",
      0.0375
    ],
    [
      "s'apercevoir",
      0.0375
    ],
    [
      "sentir",
      0.0375
    ],
    [
      "relever",
      0.0275
    ],
    [
      "prouver",
      0.0275
    ],
    [
      "enregistrer",
      0.0275
    ],
    [
      "authentifier",
      0.0175
    ],
    [
      "avouer",
      0.0175
    ],
    [
      "certifier",
      0.0175
    ],
    [
      "controler",
      0.0175
    ],
    [
      "etablir",
      0.0175
    ],
    [
      "demontrer",
      0.0075
    ],
    [
      "convenir",
      0.0075
    ],
    [
      "consigner",
      0.0075
    ],
    [
      "apparoir",
      0.0075
    ],
    [
      "admirer",
      0.0075
    ],
    [
      "s'assurer",
      0.0075
    ]
  ],
  "fausser": [
    [
      "alterer",
      0.13
    ],
    [
      "deformer",
      0.0875
    ],
    [
      "denaturer",
      0.0875
    ],
    [
      "frelater",
      0.07
    ],
    [
      "deguiser",
      0.0475
    ],
    [
      "corrompre",
      0.0425
    ],
    [
      "degrader",
      0.035
    ],
    [
      "maquiller",
      0.035
    ],
    [
      "gater",
      0.03
    ],
    [
      "defigurer",
      0.03
    ],
    [
      "falsifier",
      0.025
    ],
    [
      "travestir",
      0.025
    ],
    [
      "tordre",
      0.02
    ],
    [
      "pervertir",
      0.02
    ],
    [
      "deteriorer",
      0.02
    ],
    [
      "depraver",
      0.02
    ],
    [
      "changer",
      0.02
    ],
    [
      "truquer",
      0.0175
    ],
    [
      "gauchir",
      0.0175
    ],
    [
      "forcer",
      0.0175
    ],
    [
      "farder",
      0.0175
    ],
    [
      "detraquer",
      0.0175
    ],
    [
      "courber",
      0.0125
    ],
    [
      "manquer",
      0.0125
    ],
    [
      "violer",
      0.0125
    ],
    [
      "transformer",
      0.0075
    ],
    [
      "trahir",
      0.0075
    ],
    [
      "perdre",
      0.0075
    ],
    [
      "fouler",
      0.0075
    ],
    [
      "disloquer",
      0.0075
    ],
    [
      "bosseler",
      0.0075
    ],
    [
      "adulterer",
      0.0075
    ],
    [
      "tourmenter",
      0.0025
    ],
    [
      "plier",
      0.0025
    ],
    [
      "enfreindre",
      0.0025
    ],
    [
      "demancher",
      0.0025
    ],
    [
      "dejeter",
      0.0025
    ],
    [
      "calomnier",
      0.0025
    ],
    [
      "bossuer",
      0.0025
    ],
    [
      "tronquer",
      0.0025
    ]
  ],
  "supplanter": [
    [
      "detroner",
      0.1825
    ],
    [
      "remplacer",
      0.135
    ],
    [
      "evincer",
      0.135
    ],
    [
      "repousser",
      0.09
    ],
    [
      "triompher",
      0.09
    ],
    [
      "eclipser",
      0.09
    ],
    [
      "prevaloir",
      0.045
    ],
    [
      "deposseder",
      0.045
    ],
    [
      "degoter",
      0.045
    ],
    [
      "succeder",
      0.045
    ]
  ],
  "longevite": [
    [
      "durabilite",
      0.2
    ],
    [
      "duree",
      0.2
    ],
    [
      "macrobie",
      0.2
    ],
    [
      "vie",
      0.2
    ],
    [
      "vieillesse",
      0.2
    ]
  ],
  "conclure": [
    [
      "regler",
      0.1075
    ],
    [
      "terminer",
      0.0925
    ],
    [
      "traiter",
      0.0675
    ],
    [
      "arreter",
      0.06
    ],
    [
      "finir",
      0.06
    ],
    [
      "convenir",
      0.045
    ],
    [
      "trancher",
      0.045
    ],
    [
      "resoudre",
      0.0375
    ],
    [
      "decider",
      0.0375
    ],
    [
      "conduire",
      0.0375
    ],
    [
      "achever",
      0.0375
    ],
    [
      "deduire",
      0.03
    ],
    [
      "arranger",
      0.02
    ],
    [
      "inferer",
      0.02
    ],
    [
      "parachever",
      0.0125
    ],
    [
      "s'entendre",
      0.0125
    ],
    [
      "tirer",
      0.0125
    ],
    [
      "mener",
      0.0125
    ],
    [
      "juger",
      0.0125
    ],
    [
      "clore",
      0.0125
    ],
    [
      "couronner",
      0.0125
    ],
    [
      "denouer",
      0.0125
    ],
    [
      "fixer",
      0.0125
    ],
    [
      "induire",
      0.0125
    ],
    [
      "signer",
      0.005
    ],
    [
      "s'accorder",
      0.005
    ],
    [
      "passer",
      0.005
    ],
    [
      "opiner",
      0.005
    ],
    [
      "demontrer",
      0.005
    ],
    [
      "contracter",
      0.005
    ],
    [
      "completer",
      0.005
    ],
    [
      "argumenter",
      0.005
    ],
    [
      "arguer",
      0.005
    ]
  ],
  "aparte": [
    [
      "conversation",
      0.4
    ],
    [
      "entretien",
      0.2
    ],
    [
      "monologue",
      0.2
    ],
    [
      "soliloque",
      0.2
    ]
  ],
  "mouron": [
    [
      "bile",
      1.0
    ]
  ],
  "sequelle": [
    [
      "suite",
      0.23
    ],
    [
      "reliquat",
      0.1525
    ],
    [
      "ribambelle",
      0.075
    ],
    [
      "restant",
      0.075
    ],
    [
      "partisan",
      0.075
    ],
    [
      "kyrielle",
      0.075
    ],
    [
      "consequence",
      0.075
    ],
    [
      "chapelet",
      0.075
    ],
    [
      "cascade",
      0.075
    ],
    [
      "serie",
      0.075
    ]
  ],
  "novice": [
    [
      "inexperimente",
      0.1325
    ],
    [
      "apprenti",
      0.085
    ],
    [
      "debutant",
      0.085
    ],
    [
      "bleu",
      0.06
    ],
    [
      "jeune",
      0.06
    ],
    [
      "nouveau",
      0.06
    ],
    [
      "ignorant",
      0.0475
    ],
    [
      "profane",
      0.035
    ],
    [
      "neophyte",
      0.035
    ],
    [
      "inhabile",
      0.035
    ],
    [
      "commencant",
      0.035
    ],
    [
      "bejaune",
      0.035
    ],
    [
      "ecolier",
      0.0225
    ],
    [
      "neuf",
      0.0225
    ],
    [
      "malhabile",
      0.0225
    ],
    [
      "inexpert",
      0.0225
    ],
    [
      "candide",
      0.0225
    ],
    [
      "cadet",
      0.0225
    ],
    [
      "adolescent",
      0.0225
    ],
    [
      "religieux",
      0.01
    ],
    [
      "religieuse",
      0.01
    ],
    [
      "nonne",
      0.01
    ],
    [
      "marin",
      0.01
    ],
    [
      "maladroit",
      0.01
    ],
    [
      "conscrit",
      0.01
    ],
    [
      "bleusaille",
      0.01
    ],
    [
      "bizut",
      0.01
    ],
    [
      "soeur",
      0.01
    ]
  ],
  "lesquelles": [
    [
      "dont",
      0.3325
    ],
    [
      "qui",
      0.3325
    ],
    [
      "quoi",
      0.3325
    ]
  ],
  "ressemblant": [
    [
      "analogue",
      0.1425
    ],
    [
      "comparable",
      0.1425
    ],
    [
      "semblable",
      0.1425
    ],
    [
      "similaire",
      0.1425
    ],
    [
      "vivant",
      0.07
    ],
    [
      "parlant",
      0.07
    ],
    [
      "pareil",
      0.07
    ],
    [
      "identique",
      0.07
    ],
    [
      "approchant",
      0.07
    ],
    [
      "voisin",
      0.07
    ]
  ],
  "hesitant": [
    [
      "incertain",
      0.1575
    ],
    [
      "indecis",
      0.1225
    ],
    [
      "flottant",
      0.06
    ],
    [
      "indetermine",
      0.06
    ],
    [
      "irresolu",
      0.06
    ],
    [
      "timide",
      0.0525
    ],
    [
      "vague",
      0.0525
    ],
    [
      "embarrasse",
      0.0425
    ],
    [
      "vacillant",
      0.0325
    ],
    [
      "perplexe",
      0.0325
    ],
    [
      "chancelant",
      0.0325
    ],
    [
      "confus",
      0.025
    ],
    [
      "fluctuant",
      0.025
    ],
    [
      "titubant",
      0.015
    ],
    [
      "suspendu",
      0.015
    ],
    [
      "oscillant",
      0.015
    ],
    [
      "flou",
      0.015
    ],
    [
      "craintif",
      0.015
    ],
    [
      "balance",
      0.015
    ],
    [
      "trebuchant",
      0.0075
    ],
    [
      "tergiversant",
      0.0075
    ],
    [
      "scrupuleux",
      0.0075
    ],
    [
      "reticent",
      0.0075
    ],
    [
      "precaire",
      0.0075
    ],
    [
      "imprecis",
      0.0075
    ],
    [
      "frileux",
      0.0075
    ],
    [
      "empeche",
      0.0075
    ],
    [
      "desoriente",
      0.0075
    ],
    [
      "dubitatif",
      0.0075
    ],
    [
      "douteux",
      0.0075
    ],
    [
      "ballotte",
      0.0075
    ],
    [
      "velleitaire",
      0.0075
    ]
  ],
  "hecatombe": [
    [
      "carnage",
      0.2125
    ],
    [
      "massacre",
      0.2125
    ],
    [
      "tuerie",
      0.2125
    ],
    [
      "immolation",
      0.1425
    ],
    [
      "boucherie",
      0.07
    ],
    [
      "extermination",
      0.07
    ],
    [
      "sacrifice",
      0.07
    ]
  ],
  "calendes": [
    [
      "dette",
      1.0
    ]
  ],
  "boutefeux": [
    [
      "belliciste",
      0.09
    ],
    [
      "querelleur",
      0.09
    ],
    [
      "provocateur",
      0.09
    ],
    [
      "guerrier",
      0.09
    ],
    [
      "fanatique",
      0.09
    ],
    [
      "extremiste",
      0.09
    ],
    [
      "excitateur",
      0.09
    ],
    [
      "contestataire",
      0.09
    ],
    [
      "brulot",
      0.09
    ],
    [
      "bruleur",
      0.09
    ],
    [
      "terroriste",
      0.09
    ]
  ],
  "morbleu": [
    [
      "corbleu",
      0.5
    ],
    [
      "palsambleu",
      0.25
    ],
    [
      "palsangue",
      0.25
    ]
  ],
  "vigilant": [
    [
      "attentif",
      0.2
    ],
    [
      "assidu",
      0.1
    ],
    [
      "circonspect",
      0.1
    ],
    [
      "prudent",
      0.1
    ],
    [
      "zele",
      0.1
    ],
    [
      "reflechi",
      0.0475
    ],
    [
      "expert",
      0.0475
    ],
    [
      "devoue",
      0.0475
    ],
    [
      "applique",
      0.0475
    ],
    [
      "alerte",
      0.0475
    ],
    [
      "scrupuleux",
      0.0475
    ]
  ],
  "macabre": [
    [
      "funebre",
      0.25
    ],
    [
      "lugubre",
      0.25
    ],
    [
      "sinistre",
      0.25
    ],
    [
      "sepulcral",
      0.25
    ]
  ],
  "echafaud": [
    [
      "estrade",
      0.2725
    ],
    [
      "plancher",
      0.18
    ],
    [
      "gibet",
      0.09
    ],
    [
      "guillotine",
      0.09
    ],
    [
      "tribune",
      0.09
    ],
    [
      "echafaudage",
      0.09
    ]
  ],
  "duper": [
    [
      "tromper",
      0.175
    ],
    [
      "berner",
      0.1175
    ],
    [
      "abuser",
      0.08
    ],
    [
      "rouler",
      0.065
    ],
    [
      "leurrer",
      0.06
    ],
    [
      "mystifier",
      0.055
    ],
    [
      "attraper",
      0.0425
    ],
    [
      "refaire",
      0.0425
    ],
    [
      "flouer",
      0.0275
    ],
    [
      "enjoler",
      0.0275
    ],
    [
      "avoir",
      0.0275
    ],
    [
      "amuser",
      0.0225
    ],
    [
      "escroquer",
      0.02
    ],
    [
      "jouer",
      0.02
    ],
    [
      "pigeonner",
      0.02
    ],
    [
      "embabouiner",
      0.015
    ],
    [
      "embobiner",
      0.015
    ],
    [
      "empaumer",
      0.015
    ],
    [
      "faire",
      0.01
    ],
    [
      "empiler",
      0.01
    ],
    [
      "capter",
      0.01
    ],
    [
      "surprendre",
      0.0075
    ],
    [
      "gruger",
      0.0075
    ],
    [
      "enquinauder",
      0.0075
    ],
    [
      "decevoir",
      0.0075
    ],
    [
      "carotter",
      0.0075
    ],
    [
      "jobarder",
      0.0025
    ],
    [
      "gourer",
      0.0025
    ],
    [
      "estamper",
      0.0025
    ],
    [
      "entoler",
      0.0025
    ],
    [
      "engeigner",
      0.0025
    ],
    [
      "enfoncer",
      0.0025
    ],
    [
      "dindonner",
      0.0025
    ],
    [
      "couillonner",
      0.0025
    ],
    [
      "renarder",
      0.0025
    ]
  ],
  "dupe": [
    [
      "gogo",
      0.22
    ],
    [
      "naif",
      0.22
    ],
    [
      "credule",
      0.11
    ],
    [
      "pigeon",
      0.11
    ],
    [
      "poire",
      0.11
    ]
  ],
  "eclore": [
    [
      "naitre",
      0.13
    ],
    [
      "poindre",
      0.11
    ],
    [
      "surgir",
      0.11
    ],
    [
      "paraitre",
      0.0925
    ],
    [
      "percer",
      0.0925
    ],
    [
      "sortir",
      0.0725
    ],
    [
      "s'ouvrir",
      0.055
    ],
    [
      "commencer",
      0.055
    ],
    [
      "apparaitre",
      0.055
    ],
    [
      "ouvrir",
      0.035
    ],
    [
      "s'epanouir",
      0.035
    ],
    [
      "sourdre",
      0.035
    ],
    [
      "fleurir",
      0.0175
    ],
    [
      "germer",
      0.0175
    ],
    [
      "s'eveiller",
      0.0175
    ]
  ],
  "muer": [
    [
      "changer",
      0.165
    ],
    [
      "metamorphoser",
      0.165
    ],
    [
      "renouveler",
      0.165
    ],
    [
      "transformer",
      0.165
    ],
    [
      "transmuer",
      0.165
    ]
  ],
  "mue": [
    [
      "remuer",
      0.1175
    ],
    [
      "agiter",
      0.085
    ],
    [
      "exciter",
      0.075
    ],
    [
      "pousser",
      0.075
    ],
    [
      "animer",
      0.065
    ],
    [
      "manier",
      0.0425
    ],
    [
      "fonctionner",
      0.0425
    ],
    [
      "balancer",
      0.0425
    ],
    [
      "agir",
      0.0425
    ],
    [
      "actionner",
      0.0325
    ],
    [
      "branler",
      0.0325
    ],
    [
      "inciter",
      0.0325
    ],
    [
      "ebranler",
      0.0325
    ],
    [
      "emouvoir",
      0.02
    ],
    [
      "secouer",
      0.02
    ],
    [
      "manoeuvrer",
      0.02
    ],
    [
      "deplacer",
      0.02
    ],
    [
      "bouger",
      0.02
    ],
    [
      "propulser",
      0.01
    ],
    [
      "porter",
      0.01
    ],
    [
      "dependre",
      0.01
    ],
    [
      "declencher",
      0.01
    ],
    [
      "dodeliner",
      0.01
    ],
    [
      "brandiller",
      0.01
    ],
    [
      "tortiller",
      0.01
    ]
  ],
  "ailier": [
    [
      "exterieur",
      0.5
    ]
  ],
  "soigneur": [
    [
      "kinesitherapeute",
      0.5
    ],
    [
      "masseur",
      0.5
    ]
  ],
  "poteau": [
    [
      "jambe",
      0.125
    ],
    [
      "pilier",
      0.125
    ],
    [
      "poutre",
      0.06
    ],
    [
      "pote",
      0.06
    ],
    [
      "pilori",
      0.06
    ],
    [
      "pieu",
      0.06
    ],
    [
      "copain",
      0.06
    ],
    [
      "compagnon",
      0.06
    ],
    [
      "colonne",
      0.06
    ],
    [
      "camarade",
      0.06
    ],
    [
      "but",
      0.06
    ],
    [
      "balise",
      0.06
    ],
    [
      "ami",
      0.06
    ],
    [
      "pylone",
      0.06
    ]
  ],
  "execution": [
    [
      "realisation",
      0.14
    ],
    [
      "accomplissement",
      0.0775
    ],
    [
      "action",
      0.0625
    ],
    [
      "operation",
      0.0625
    ],
    [
      "elaboration",
      0.0625
    ],
    [
      "travail",
      0.05
    ],
    [
      "pratique",
      0.05
    ],
    [
      "fabrication",
      0.05
    ],
    [
      "acte",
      0.0375
    ],
    [
      "application",
      0.0375
    ],
    [
      "composition",
      0.0375
    ],
    [
      "expedition",
      0.0375
    ],
    [
      "facon",
      0.0375
    ],
    [
      "facture",
      0.025
    ],
    [
      "effet",
      0.025
    ],
    [
      "construction",
      0.025
    ],
    [
      "confection",
      0.025
    ],
    [
      "achevement",
      0.025
    ],
    [
      "supplice",
      0.0125
    ],
    [
      "redaction",
      0.0125
    ],
    [
      "mort",
      0.0125
    ],
    [
      "liquidation",
      0.0125
    ],
    [
      "interpretation",
      0.0125
    ],
    [
      "homicide",
      0.0125
    ],
    [
      "expropriation",
      0.0125
    ],
    [
      "conduite",
      0.0125
    ],
    [
      "torture",
      0.0125
    ]
  ],
  "echauffer": [
    [
      "enflammer",
      0.155
    ],
    [
      "exciter",
      0.1425
    ],
    [
      "exalter",
      0.1125
    ],
    [
      "enfievrer",
      0.085
    ],
    [
      "enthousiasmer",
      0.07
    ],
    [
      "embraser",
      0.055
    ],
    [
      "transporter",
      0.055
    ],
    [
      "electriser",
      0.055
    ],
    [
      "galvaniser",
      0.0425
    ],
    [
      "animer",
      0.0425
    ],
    [
      "agiter",
      0.0425
    ],
    [
      "chauffer",
      0.0275
    ],
    [
      "agacer",
      0.0125
    ],
    [
      "aiguillonner",
      0.0125
    ],
    [
      "incendier",
      0.0125
    ],
    [
      "rechauffer",
      0.0125
    ],
    [
      "survolter",
      0.0125
    ],
    [
      "turlupiner",
      0.0125
    ],
    [
      "enerver",
      0.0125
    ]
  ],
  "hydrater": [
    [
      "humecter",
      0.3325
    ],
    [
      "imbiber",
      0.3325
    ],
    [
      "rehydrater",
      0.3325
    ]
  ],
  "ram": [],
  "bassiste": [
    [
      "contrebassiste",
      0.5
    ],
    [
      "guitariste",
      0.5
    ]
  ],
  "rasta": [
    [
      "intrigant",
      0.5
    ],
    [
      "etranger",
      0.5
    ]
  ],
  "barbarie": [
    [
      "brutalite",
      0.1425
    ],
    [
      "cruaute",
      0.1175
    ],
    [
      "ferocite",
      0.095
    ],
    [
      "inhumanite",
      0.095
    ],
    [
      "grossierete",
      0.07
    ],
    [
      "sauvagerie",
      0.07
    ],
    [
      "tyrannie",
      0.0475
    ],
    [
      "rudesse",
      0.0475
    ],
    [
      "bestialite",
      0.0475
    ],
    [
      "vandalisme",
      0.0225
    ],
    [
      "tenebres",
      0.0225
    ],
    [
      "sadisme",
      0.0225
    ],
    [
      "rusticite",
      0.0225
    ],
    [
      "primitivisme",
      0.0225
    ],
    [
      "incorrection",
      0.0225
    ],
    [
      "inconvenance",
      0.0225
    ],
    [
      "ignorance",
      0.0225
    ],
    [
      "canard",
      0.0225
    ],
    [
      "atrocite",
      0.0225
    ]
  ],
  "euh": [],
  "spectateur": [
    [
      "temoin",
      0.1675
    ],
    [
      "galerie",
      0.1225
    ],
    [
      "public",
      0.1225
    ],
    [
      "regardant",
      0.0825
    ],
    [
      "curieux",
      0.0825
    ],
    [
      "auditoire",
      0.0825
    ],
    [
      "auditeur",
      0.0825
    ],
    [
      "assistant",
      0.04
    ],
    [
      "observateur",
      0.04
    ],
    [
      "parterre",
      0.04
    ],
    [
      "telespectateur",
      0.04
    ],
    [
      "visiteur",
      0.04
    ],
    [
      "voyeur",
      0.04
    ]
  ],
  "allemand": [
    [
      "fridolin",
      0.1525
    ],
    [
      "frise",
      0.1525
    ],
    [
      "germanique",
      0.1525
    ],
    [
      "teuton",
      0.075
    ],
    [
      "prussco",
      0.075
    ],
    [
      "germain",
      0.075
    ],
    [
      "fritz",
      0.075
    ],
    [
      "chleuh",
      0.075
    ],
    [
      "boche",
      0.075
    ],
    [
      "tudesque",
      0.075
    ]
  ],
  "choree": [],
  "activite": [
    [
      "vivacite",
      0.075
    ],
    [
      "ardeur",
      0.07
    ],
    [
      "travail",
      0.06
    ],
    [
      "vie",
      0.06
    ],
    [
      "mouvement",
      0.05
    ],
    [
      "vitalite",
      0.0375
    ],
    [
      "animation",
      0.0325
    ],
    [
      "action",
      0.0325
    ],
    [
      "bouillonnement",
      0.0275
    ],
    [
      "dynamisme",
      0.0275
    ],
    [
      "energie",
      0.0225
    ],
    [
      "zele",
      0.0225
    ],
    [
      "vigueur",
      0.0225
    ],
    [
      "promptitude",
      0.0225
    ],
    [
      "occupation",
      0.0225
    ],
    [
      "fonctionnement",
      0.0225
    ],
    [
      "entrain",
      0.0225
    ],
    [
      "vitesse",
      0.0175
    ],
    [
      "celerite",
      0.0175
    ],
    [
      "allant",
      0.0175
    ],
    [
      "agitation",
      0.0175
    ],
    [
      "usage",
      0.0125
    ],
    [
      "hate",
      0.0125
    ],
    [
      "fonction",
      0.0125
    ],
    [
      "exercice",
      0.0125
    ],
    [
      "besogne",
      0.0125
    ],
    [
      "affaire",
      0.0125
    ],
    [
      "turbulence",
      0.0075
    ],
    [
      "ressort",
      0.0075
    ],
    [
      "rapidite",
      0.0075
    ],
    [
      "marche",
      0.0075
    ],
    [
      "labeur",
      0.0075
    ],
    [
      "intensite",
      0.0075
    ],
    [
      "effort",
      0.0075
    ],
    [
      "efficacite",
      0.0075
    ],
    [
      "diligence",
      0.0075
    ],
    [
      "allegresse",
      0.0075
    ],
    [
      "affairement",
      0.0075
    ],
    [
      "industrie",
      0.0025
    ],
    [
      "juvenilite",
      0.0025
    ],
    [
      "production",
      0.0025
    ],
    [
      "prosperite",
      0.0025
    ],
    [
      "radioactivite",
      0.0025
    ],
    [
      "faculte",
      0.0025
    ],
    [
      "expedition",
      0.0025
    ],
    [
      "essor",
      0.0025
    ],
    [
      "circulation",
      0.0025
    ],
    [
      "bras",
      0.0025
    ],
    [
      "boum",
      0.0025
    ],
    [
      "ballet",
      0.0025
    ],
    [
      "affaires",
      0.0025
    ],
    [
      "seve",
      0.0025
    ]
  ],
  "attraction": [
    [
      "attirance",
      0.12
    ],
    [
      "attrait",
      0.12
    ],
    [
      "affinite",
      0.09
    ],
    [
      "seduction",
      0.09
    ],
    [
      "sympathie",
      0.06
    ],
    [
      "fascination",
      0.06
    ],
    [
      "aimant",
      0.06
    ],
    [
      "spectacle",
      0.03
    ],
    [
      "pesanteur",
      0.03
    ],
    [
      "influence",
      0.03
    ],
    [
      "gravite",
      0.03
    ],
    [
      "gravitation",
      0.03
    ],
    [
      "feerie",
      0.03
    ],
    [
      "foire",
      0.03
    ],
    [
      "entrainement",
      0.03
    ],
    [
      "divertissement",
      0.03
    ],
    [
      "clou",
      0.03
    ],
    [
      "association",
      0.03
    ],
    [
      "allechement",
      0.03
    ],
    [
      "tendance",
      0.03
    ]
  ],
  "russe": [
    [
      "sovietique",
      1.0
    ]
  ],
  "democratie": [
    [
      "gouvernement",
      0.4
    ],
    [
      "politique",
      0.2
    ],
    [
      "republique",
      0.2
    ]
  ],
  "conjoncture": [
    [
      "circonstance",
      0.2
    ],
    [
      "situation",
      0.1075
    ],
    [
      "cas",
      0.09
    ],
    [
      "rencontre",
      0.0725
    ],
    [
      "occasion",
      0.0725
    ],
    [
      "condition",
      0.0725
    ],
    [
      "etat",
      0.0525
    ],
    [
      "temps",
      0.035
    ],
    [
      "occurrence",
      0.035
    ],
    [
      "moment",
      0.035
    ],
    [
      "hasard",
      0.035
    ],
    [
      "auspice",
      0.035
    ],
    [
      "affaire",
      0.035
    ],
    [
      "concours",
      0.0175
    ],
    [
      "donnee",
      0.0175
    ],
    [
      "passage",
      0.0175
    ],
    [
      "evenements",
      0.0175
    ]
  ],
  "actuel": [
    [
      "present",
      0.165
    ],
    [
      "tangible",
      0.11
    ],
    [
      "reel",
      0.11
    ],
    [
      "nouveau",
      0.11
    ],
    [
      "moderne",
      0.11
    ],
    [
      "existant",
      0.11
    ],
    [
      "brulant",
      0.055
    ],
    [
      "contemporain",
      0.055
    ],
    [
      "courant",
      0.055
    ],
    [
      "effectif",
      0.055
    ],
    [
      "frais",
      0.055
    ]
  ],
  "recycler": [
    [
      "recuperer",
      0.5
    ],
    [
      "reutiliser",
      0.5
    ]
  ],
  "genocide": [
    [
      "destruction",
      0.285
    ],
    [
      "assassin",
      0.1425
    ],
    [
      "ethnocide",
      0.1425
    ],
    [
      "massacre",
      0.1425
    ],
    [
      "pogrom",
      0.1425
    ],
    [
      "suppression",
      0.1425
    ]
  ],
  "impot": [
    [
      "taxe",
      0.1825
    ],
    [
      "contribution",
      0.09
    ],
    [
      "imposition",
      0.09
    ],
    [
      "charge",
      0.0525
    ],
    [
      "prestation",
      0.0525
    ],
    [
      "redevance",
      0.0375
    ],
    [
      "quota",
      0.0375
    ],
    [
      "prelevement",
      0.0375
    ],
    [
      "finance",
      0.0375
    ],
    [
      "apport",
      0.0375
    ],
    [
      "fiscalite",
      0.025
    ],
    [
      "fisc",
      0.025
    ],
    [
      "dime",
      0.025
    ],
    [
      "droit",
      0.025
    ],
    [
      "cote",
      0.025
    ],
    [
      "cens",
      0.025
    ],
    [
      "taxation",
      0.0125
    ],
    [
      "taille",
      0.0125
    ],
    [
      "surtaxe",
      0.0125
    ],
    [
      "subvention",
      0.0125
    ],
    [
      "subside",
      0.0125
    ],
    [
      "patente",
      0.0125
    ],
    [
      "maltote",
      0.0125
    ],
    [
      "levee",
      0.0125
    ],
    [
      "gabelle",
      0.0125
    ],
    [
      "corvee",
      0.0125
    ],
    [
      "tribut",
      0.0125
    ]
  ],
  "attrape": [
    [
      "farce",
      0.12
    ],
    [
      "blague",
      0.1075
    ],
    [
      "plaisanterie",
      0.1075
    ],
    [
      "mystification",
      0.095
    ],
    [
      "tromperie",
      0.0825
    ],
    [
      "canular",
      0.06
    ],
    [
      "facetie",
      0.06
    ],
    [
      "leurre",
      0.0475
    ],
    [
      "tour",
      0.035
    ],
    [
      "fumisterie",
      0.035
    ],
    [
      "bateau",
      0.035
    ],
    [
      "piege",
      0.0225
    ],
    [
      "niche",
      0.0225
    ],
    [
      "feinte",
      0.0225
    ],
    [
      "betise",
      0.0225
    ],
    [
      "bourde",
      0.0225
    ],
    [
      "colle",
      0.01
    ],
    [
      "malice",
      0.01
    ]
  ],
  "marmotter": [
    [
      "murmurer",
      0.17
    ],
    [
      "marmonner",
      0.1425
    ],
    [
      "ronchonner",
      0.1125
    ],
    [
      "bredouiller",
      0.085
    ],
    [
      "protester",
      0.055
    ],
    [
      "grommeler",
      0.055
    ],
    [
      "grogner",
      0.055
    ],
    [
      "bougonner",
      0.055
    ],
    [
      "balbutier",
      0.055
    ],
    [
      "baragouiner",
      0.0275
    ],
    [
      "barboter",
      0.0275
    ],
    [
      "chuchoter",
      0.0275
    ],
    [
      "maronner",
      0.0275
    ],
    [
      "macher",
      0.0275
    ],
    [
      "machonner",
      0.0275
    ],
    [
      "susurrer",
      0.0275
    ]
  ],
  "marmotte": [
    [
      "fanchon",
      0.3325
    ],
    [
      "boite",
      0.165
    ],
    [
      "coiffure",
      0.165
    ],
    [
      "fichu",
      0.165
    ],
    [
      "malle",
      0.165
    ]
  ],
  "kangourou": [
    [
      "wallaby",
      1.0
    ]
  ],
  "aquatique": [
    [
      "amphibie",
      0.25
    ],
    [
      "aquatile",
      0.25
    ],
    [
      "aquicole",
      0.25
    ],
    [
      "marecageux",
      0.25
    ]
  ],
  "romarin": [
    [
      "ledon",
      1.0
    ]
  ],
  "prefet": [
    [
      "igame",
      0.25
    ],
    [
      "maitre",
      0.25
    ],
    [
      "surveillant",
      0.25
    ]
  ],
  "consanguin": [
    [
      "parent",
      0.4
    ],
    [
      "agnat",
      0.2
    ],
    [
      "endogamique",
      0.2
    ],
    [
      "germain",
      0.2
    ]
  ],
  "selection": [
    [
      "choix",
      0.28
    ],
    [
      "elite",
      0.085
    ],
    [
      "collection",
      0.065
    ],
    [
      "gratin",
      0.065
    ],
    [
      "reunion",
      0.0425
    ],
    [
      "recueil",
      0.0425
    ],
    [
      "anthologie",
      0.0425
    ],
    [
      "tri",
      0.02
    ],
    [
      "triage",
      0.02
    ],
    [
      "eclectisme",
      0.02
    ],
    [
      "election",
      0.02
    ],
    [
      "elimination",
      0.02
    ],
    [
      "florilege",
      0.02
    ],
    [
      "finalite",
      0.02
    ],
    [
      "digest",
      0.02
    ],
    [
      "creme",
      0.02
    ],
    [
      "criterium",
      0.02
    ],
    [
      "assortiment",
      0.02
    ],
    [
      "aristocratie",
      0.02
    ],
    [
      "accouplement",
      0.02
    ],
    [
      "eventail",
      0.02
    ]
  ],
  "selecter": [],
  "ameliorer": [
    [
      "corriger",
      0.0725
    ],
    [
      "amender",
      0.0525
    ],
    [
      "perfectionner",
      0.0425
    ],
    [
      "reformer",
      0.0325
    ],
    [
      "parfaire",
      0.0325
    ],
    [
      "faconner",
      0.0325
    ],
    [
      "enrichir",
      0.0325
    ],
    [
      "chatier",
      0.0325
    ],
    [
      "cultiver",
      0.0275
    ],
    [
      "fertiliser",
      0.0275
    ],
    [
      "travailler",
      0.0225
    ],
    [
      "transformer",
      0.0225
    ],
    [
      "reviser",
      0.0225
    ],
    [
      "fignoler",
      0.0225
    ],
    [
      "developper",
      0.0225
    ],
    [
      "completer",
      0.0225
    ],
    [
      "augmenter",
      0.0225
    ],
    [
      "arranger",
      0.0225
    ],
    [
      "ajouter",
      0.0225
    ],
    [
      "reparer",
      0.0175
    ],
    [
      "revoir",
      0.0175
    ],
    [
      "retoucher",
      0.0175
    ],
    [
      "embellir",
      0.0175
    ],
    [
      "restaurer",
      0.0125
    ],
    [
      "modifier",
      0.0125
    ],
    [
      "fortifier",
      0.0125
    ],
    [
      "finir",
      0.0125
    ],
    [
      "engraisser",
      0.0125
    ],
    [
      "changer",
      0.0125
    ],
    [
      "bonifier",
      0.0125
    ],
    [
      "adoucir",
      0.0125
    ],
    [
      "marner",
      0.0075
    ],
    [
      "optimiser",
      0.0075
    ],
    [
      "planter",
      0.0075
    ],
    [
      "regenerer",
      0.0075
    ],
    [
      "renover",
      0.0075
    ],
    [
      "retablir",
      0.0075
    ],
    [
      "lecher",
      0.0075
    ],
    [
      "guerir",
      0.0075
    ],
    [
      "achever",
      0.0075
    ],
    [
      "ameublir",
      0.0075
    ],
    [
      "civiliser",
      0.0075
    ],
    [
      "decorer",
      0.0075
    ],
    [
      "ensemencer",
      0.0075
    ],
    [
      "exalter",
      0.0075
    ],
    [
      "normaliser",
      0.0025
    ],
    [
      "platrer",
      0.0025
    ],
    [
      "promouvoir",
      0.0025
    ],
    [
      "rabonnir",
      0.0025
    ],
    [
      "ravaler",
      0.0025
    ],
    [
      "retravailler",
      0.0025
    ],
    [
      "reconcilier",
      0.0025
    ],
    [
      "terreauter",
      0.0025
    ],
    [
      "abonnir",
      0.0025
    ],
    [
      "affermir",
      0.0025
    ],
    [
      "alleger",
      0.0025
    ],
    [
      "avancer",
      0.0025
    ],
    [
      "chauler",
      0.0025
    ],
    [
      "detendre",
      0.0025
    ],
    [
      "encherir",
      0.0025
    ],
    [
      "fumer",
      0.0025
    ],
    [
      "epurer",
      0.0025
    ]
  ],
  "placette": [
    [
      "place",
      1.0
    ]
  ],
  "buvette": [
    [
      "cabaret",
      0.225
    ],
    [
      "cafe",
      0.2075
    ],
    [
      "bistrot",
      0.08
    ],
    [
      "buffet",
      0.08
    ],
    [
      "bar",
      0.0625
    ],
    [
      "restaurant",
      0.0625
    ],
    [
      "estaminet",
      0.0475
    ],
    [
      "troquet",
      0.0475
    ],
    [
      "taverne",
      0.03
    ],
    [
      "caboulot",
      0.03
    ],
    [
      "bouchon",
      0.03
    ],
    [
      "beuverie",
      0.015
    ],
    [
      "cafeteria",
      0.015
    ],
    [
      "cantine",
      0.015
    ],
    [
      "debit",
      0.015
    ],
    [
      "mastroquet",
      0.015
    ]
  ],
  "alcoolique": [
    [
      "biberon",
      0.2225
    ],
    [
      "ivrogne",
      0.2225
    ],
    [
      "soiffard",
      0.055
    ],
    [
      "poivrot",
      0.055
    ],
    [
      "dipsomaniaque",
      0.055
    ],
    [
      "dipsomane",
      0.055
    ],
    [
      "buveur",
      0.055
    ],
    [
      "alcoole",
      0.055
    ],
    [
      "alcoolo",
      0.055
    ],
    [
      "alcoolise",
      0.055
    ],
    [
      "ethylique",
      0.055
    ]
  ],
  "trinquette": [],
  "tolerance": [
    [
      "bonte",
      0.1275
    ],
    [
      "indulgence",
      0.1275
    ],
    [
      "bienveillance",
      0.095
    ],
    [
      "permission",
      0.0625
    ],
    [
      "mansuetude",
      0.0625
    ],
    [
      "douceur",
      0.0625
    ],
    [
      "respect",
      0.03
    ],
    [
      "patience",
      0.03
    ],
    [
      "licence",
      0.03
    ],
    [
      "liberalisme",
      0.03
    ],
    [
      "facilite",
      0.03
    ],
    [
      "comprehension",
      0.03
    ],
    [
      "benignite",
      0.03
    ],
    [
      "acquiescement",
      0.03
    ],
    [
      "accoutumance",
      0.03
    ],
    [
      "tolerantisme",
      0.03
    ]
  ],
  "recracher": [
    [
      "cracher",
      1.0
    ]
  ],
  "olive": [
    [
      "vert",
      1.0
    ]
  ],
  "chevreau": [
    [
      "biquet",
      0.2
    ],
    [
      "cabri",
      0.2
    ],
    [
      "bicot",
      0.1
    ],
    [
      "broutart",
      0.1
    ],
    [
      "chevrotin",
      0.1
    ],
    [
      "chevre",
      0.1
    ],
    [
      "peau",
      0.1
    ]
  ],
  "laurier": [
    [
      "oleandre",
      0.5
    ],
    [
      "sassafras",
      0.5
    ]
  ],
  "thym": [
    [
      "farigoule",
      0.5
    ],
    [
      "serpolet",
      0.5
    ]
  ],
  "serpolet": [
    [
      "farigoule",
      0.5
    ],
    [
      "pouliot",
      0.25
    ],
    [
      "thym",
      0.25
    ]
  ],
  "hameau": [
    [
      "village",
      0.23
    ],
    [
      "agglomeration",
      0.1525
    ],
    [
      "bourg",
      0.1525
    ],
    [
      "bourgade",
      0.075
    ],
    [
      "localite",
      0.075
    ],
    [
      "menil",
      0.075
    ],
    [
      "paroisse",
      0.075
    ],
    [
      "ecart",
      0.075
    ]
  ],
  "captif": [
    [
      "prisonnier",
      0.1225
    ],
    [
      "interne",
      0.0975
    ],
    [
      "detenu",
      0.0725
    ],
    [
      "emprisonne",
      0.0725
    ],
    [
      "enferme",
      0.0725
    ],
    [
      "soumis",
      0.0475
    ],
    [
      "reclus",
      0.0475
    ],
    [
      "esclave",
      0.0475
    ],
    [
      "attache",
      0.0475
    ],
    [
      "asservi",
      0.0475
    ],
    [
      "transporte",
      0.0225
    ],
    [
      "sequestre",
      0.0225
    ],
    [
      "seduit",
      0.0225
    ],
    [
      "relegue",
      0.0225
    ],
    [
      "otage",
      0.0225
    ],
    [
      "occupe",
      0.0225
    ],
    [
      "incarcere",
      0.0225
    ],
    [
      "gene",
      0.0225
    ],
    [
      "forcat",
      0.0225
    ],
    [
      "enchaine",
      0.0225
    ],
    [
      "contraint",
      0.0225
    ],
    [
      "cadenasse",
      0.0225
    ],
    [
      "ecroue",
      0.0225
    ]
  ],
  "jouvenceau": [
    [
      "adolescent",
      0.165
    ],
    [
      "garcon",
      0.165
    ],
    [
      "jeune",
      0.165
    ],
    [
      "ephebe",
      0.165
    ]
  ],
  "voguer": [
    [
      "cingler",
      0.22
    ],
    [
      "nager",
      0.22
    ],
    [
      "naviguer",
      0.22
    ],
    [
      "flotter",
      0.11
    ],
    [
      "ramer",
      0.11
    ]
  ],
  "trousseau": [
    [
      "affaires",
      0.1425
    ],
    [
      "effets",
      0.1425
    ],
    [
      "vetements",
      0.1425
    ],
    [
      "toilette",
      0.07
    ],
    [
      "necessaire",
      0.07
    ],
    [
      "linge",
      0.07
    ],
    [
      "layette",
      0.07
    ],
    [
      "habits",
      0.07
    ],
    [
      "effet",
      0.07
    ],
    [
      "dot",
      0.07
    ],
    [
      "trousse",
      0.07
    ]
  ],
  "rive": [
    [
      "bord",
      0.2
    ],
    [
      "rivage",
      0.2
    ],
    [
      "berge",
      0.1
    ],
    [
      "cote",
      0.1
    ],
    [
      "greve",
      0.1
    ],
    [
      "littoral",
      0.1
    ],
    [
      "quai",
      0.1
    ],
    [
      "voute",
      0.1
    ]
  ],
  "esseuler": [
    [
      "isoler",
      1.0
    ]
  ],
  "esseule": [
    [
      "isoler",
      1.0
    ]
  ],
  "ruisselet": [
    [
      "rigole",
      0.3325
    ],
    [
      "rivelet",
      0.3325
    ],
    [
      "ru",
      0.3325
    ]
  ],
  "droitier": [],
  "comite": [
    [
      "commission",
      0.2
    ],
    [
      "groupe",
      0.1325
    ],
    [
      "reunion",
      0.1325
    ],
    [
      "tribunal",
      0.1325
    ],
    [
      "siege",
      0.065
    ],
    [
      "compagnie",
      0.065
    ],
    [
      "circonscription",
      0.065
    ],
    [
      "bureau",
      0.065
    ],
    [
      "association",
      0.065
    ],
    [
      "soviet",
      0.065
    ]
  ],
  "burger": [],
  "viande": [
    [
      "carnage",
      0.1325
    ],
    [
      "chair",
      0.1325
    ],
    [
      "salaison",
      0.065
    ],
    [
      "pemmican",
      0.065
    ],
    [
      "nourriture",
      0.065
    ],
    [
      "gibier",
      0.065
    ],
    [
      "charcuterie",
      0.065
    ],
    [
      "carne",
      0.065
    ],
    [
      "boucan",
      0.065
    ],
    [
      "bidoche",
      0.065
    ],
    [
      "barbaque",
      0.065
    ],
    [
      "singe",
      0.065
    ]
  ],
  "approuver": [
    [
      "accepter",
      0.095
    ],
    [
      "consentir",
      0.0725
    ],
    [
      "acquiescer",
      0.06
    ],
    [
      "admettre",
      0.0525
    ],
    [
      "ratifier",
      0.045
    ],
    [
      "autoriser",
      0.04
    ],
    [
      "complimenter",
      0.0325
    ],
    [
      "vanter",
      0.025
    ],
    [
      "permettre",
      0.025
    ],
    [
      "louer",
      0.025
    ],
    [
      "feliciter",
      0.025
    ],
    [
      "enteriner",
      0.025
    ],
    [
      "applaudir",
      0.025
    ],
    [
      "adopter",
      0.025
    ],
    [
      "souscrire",
      0.0175
    ],
    [
      "homologuer",
      0.0175
    ],
    [
      "confirmer",
      0.0175
    ],
    [
      "agreer",
      0.0175
    ],
    [
      "adherer",
      0.0175
    ],
    [
      "tolerer",
      0.0125
    ],
    [
      "sanctionner",
      0.0125
    ],
    [
      "louanger",
      0.0125
    ],
    [
      "gouter",
      0.0125
    ],
    [
      "glorifier",
      0.0125
    ],
    [
      "encourager",
      0.0125
    ],
    [
      "ceder",
      0.0125
    ],
    [
      "comprendre",
      0.0125
    ],
    [
      "avouer",
      0.0125
    ],
    [
      "apprecier",
      0.0125
    ],
    [
      "opiner",
      0.005
    ],
    [
      "signer",
      0.005
    ],
    [
      "encherir",
      0.005
    ],
    [
      "congratuler",
      0.005
    ],
    [
      "cautionner",
      0.005
    ],
    [
      "bonneter",
      0.005
    ],
    [
      "allouer",
      0.005
    ],
    [
      "acceder",
      0.005
    ],
    [
      "acclamer",
      0.005
    ]
  ],
  "approuve": [
    [
      "accepter",
      0.095
    ],
    [
      "consentir",
      0.0725
    ],
    [
      "acquiescer",
      0.06
    ],
    [
      "admettre",
      0.0525
    ],
    [
      "ratifier",
      0.045
    ],
    [
      "autoriser",
      0.04
    ],
    [
      "complimenter",
      0.0325
    ],
    [
      "vanter",
      0.025
    ],
    [
      "permettre",
      0.025
    ],
    [
      "louer",
      0.025
    ],
    [
      "feliciter",
      0.025
    ],
    [
      "enteriner",
      0.025
    ],
    [
      "applaudir",
      0.025
    ],
    [
      "adopter",
      0.025
    ],
    [
      "souscrire",
      0.0175
    ],
    [
      "homologuer",
      0.0175
    ],
    [
      "confirmer",
      0.0175
    ],
    [
      "agreer",
      0.0175
    ],
    [
      "adherer",
      0.0175
    ],
    [
      "tolerer",
      0.0125
    ],
    [
      "sanctionner",
      0.0125
    ],
    [
      "louanger",
      0.0125
    ],
    [
      "gouter",
      0.0125
    ],
    [
      "glorifier",
      0.0125
    ],
    [
      "encourager",
      0.0125
    ],
    [
      "ceder",
      0.0125
    ],
    [
      "comprendre",
      0.0125
    ],
    [
      "avouer",
      0.0125
    ],
    [
      "apprecier",
      0.0125
    ],
    [
      "opiner",
      0.005
    ],
    [
      "signer",
      0.005
    ],
    [
      "encherir",
      0.005
    ],
    [
      "congratuler",
      0.005
    ],
    [
      "cautionner",
      0.005
    ],
    [
      "bonneter",
      0.005
    ],
    [
      "allouer",
      0.005
    ],
    [
      "acceder",
      0.005
    ],
    [
      "acclamer",
      0.005
    ]
  ],
  "silicose": [
    [
      "pneumoconiose",
      1.0
    ]
  ],
  "desherber": [
    [
      "debroussailler",
      0.25
    ],
    [
      "degager",
      0.25
    ],
    [
      "sarcler",
      0.25
    ],
    [
      "eclaircir",
      0.25
    ]
  ],
  "contrebande": [
    [
      "fraude",
      0.5
    ],
    [
      "interlope",
      0.5
    ]
  ],
  "corruption": [
    [
      "degradation",
      0.105
    ],
    [
      "depravation",
      0.075
    ],
    [
      "vice",
      0.0575
    ],
    [
      "pourriture",
      0.0525
    ],
    [
      "turpitude",
      0.0475
    ],
    [
      "alteration",
      0.0475
    ],
    [
      "avilissement",
      0.04
    ],
    [
      "debauche",
      0.04
    ],
    [
      "decheance",
      0.04
    ],
    [
      "putrefaction",
      0.035
    ],
    [
      "decomposition",
      0.035
    ],
    [
      "impurete",
      0.03
    ],
    [
      "perversion",
      0.03
    ],
    [
      "decadence",
      0.025
    ],
    [
      "stupre",
      0.025
    ],
    [
      "infection",
      0.02
    ],
    [
      "deliquescence",
      0.02
    ],
    [
      "destruction",
      0.02
    ],
    [
      "souillure",
      0.0175
    ],
    [
      "pollution",
      0.0175
    ],
    [
      "immoralite",
      0.0175
    ],
    [
      "bassesse",
      0.0175
    ],
    [
      "tare",
      0.0125
    ],
    [
      "pourrissement",
      0.0125
    ],
    [
      "dereglement",
      0.0125
    ],
    [
      "dissolution",
      0.0125
    ],
    [
      "boue",
      0.0125
    ],
    [
      "viciation",
      0.0075
    ],
    [
      "prostitution",
      0.0075
    ],
    [
      "gangrene",
      0.0075
    ],
    [
      "empoisonnement",
      0.0075
    ],
    [
      "achat",
      0.0075
    ],
    [
      "abatardissement",
      0.0075
    ],
    [
      "subornation",
      0.0025
    ],
    [
      "pestilence",
      0.0025
    ],
    [
      "perversite",
      0.0025
    ],
    [
      "malversation",
      0.0025
    ],
    [
      "falsification",
      0.0025
    ],
    [
      "demoralisation",
      0.0025
    ],
    [
      "deformation",
      0.0025
    ],
    [
      "adulteration",
      0.0025
    ],
    [
      "venalite",
      0.0025
    ]
  ],
  "discernement": [
    [
      "intelligence",
      0.12
    ],
    [
      "jugement",
      0.0925
    ],
    [
      "esprit",
      0.08
    ],
    [
      "raison",
      0.0675
    ],
    [
      "sens",
      0.0675
    ],
    [
      "connaissance",
      0.0525
    ],
    [
      "perspicacite",
      0.0525
    ],
    [
      "sagesse",
      0.04
    ],
    [
      "sagacite",
      0.04
    ],
    [
      "faculte",
      0.04
    ],
    [
      "clairvoyance",
      0.04
    ],
    [
      "reflexion",
      0.025
    ],
    [
      "prudence",
      0.025
    ],
    [
      "perception",
      0.025
    ],
    [
      "circonspection",
      0.025
    ],
    [
      "astuce",
      0.025
    ],
    [
      "vision",
      0.0125
    ],
    [
      "jugeote",
      0.0125
    ],
    [
      "identification",
      0.0125
    ],
    [
      "flair",
      0.0125
    ],
    [
      "escient",
      0.0125
    ],
    [
      "decouverte",
      0.0125
    ],
    [
      "distinction",
      0.0125
    ],
    [
      "discrimination",
      0.0125
    ],
    [
      "appreciation",
      0.0125
    ]
  ],
  "refuser": [
    [
      "repousser",
      0.13
    ],
    [
      "rejeter",
      0.08
    ],
    [
      "renvoyer",
      0.06
    ],
    [
      "eloigner",
      0.06
    ],
    [
      "s'opposer",
      0.0475
    ],
    [
      "eliminer",
      0.035
    ],
    [
      "ecarter",
      0.035
    ],
    [
      "resister",
      0.035
    ],
    [
      "coller",
      0.03
    ],
    [
      "exclure",
      0.03
    ],
    [
      "recuser",
      0.0225
    ],
    [
      "nier",
      0.0225
    ],
    [
      "decliner",
      0.0225
    ],
    [
      "contester",
      0.0225
    ],
    [
      "econduire",
      0.0175
    ],
    [
      "repugner",
      0.0175
    ],
    [
      "debouter",
      0.0175
    ],
    [
      "ajourner",
      0.0175
    ],
    [
      "evincer",
      0.01
    ],
    [
      "etendre",
      0.01
    ],
    [
      "repudier",
      0.01
    ],
    [
      "remercier",
      0.01
    ],
    [
      "recaler",
      0.01
    ],
    [
      "rebuter",
      0.01
    ],
    [
      "envoyer",
      0.01
    ],
    [
      "desobeir",
      0.01
    ],
    [
      "blackbouler",
      0.01
    ],
    [
      "regimber",
      0.005
    ],
    [
      "retourner",
      0.005
    ],
    [
      "s'excuser",
      0.005
    ],
    [
      "envier",
      0.005
    ],
    [
      "denier",
      0.005
    ],
    [
      "defendre",
      0.005
    ],
    [
      "dedaigner",
      0.005
    ],
    [
      "consigner",
      0.005
    ],
    [
      "boycotter",
      0.005
    ],
    [
      "bouder",
      0.005
    ],
    [
      "transgresser",
      0.005
    ]
  ],
  "priorite": [
    [
      "avantage",
      0.1525
    ],
    [
      "primaute",
      0.1525
    ],
    [
      "privilege",
      0.1525
    ],
    [
      "prevalence",
      0.075
    ],
    [
      "preseance",
      0.075
    ],
    [
      "preemption",
      0.075
    ],
    [
      "precellence",
      0.075
    ],
    [
      "primeur",
      0.075
    ],
    [
      "anteriorite",
      0.075
    ]
  ],
  "systematiquement": [
    [
      "logiquement",
      0.2
    ],
    [
      "methodiquement",
      0.2
    ],
    [
      "automatiquement",
      0.0975
    ],
    [
      "consciencieusement",
      0.0975
    ],
    [
      "dogmatiquement",
      0.0975
    ],
    [
      "rationnellement",
      0.0975
    ],
    [
      "regulierement",
      0.0975
    ]
  ],
  "rang": [
    [
      "classe",
      0.07
    ],
    [
      "position",
      0.055
    ],
    [
      "etat",
      0.055
    ],
    [
      "degre",
      0.05
    ],
    [
      "situation",
      0.05
    ],
    [
      "qualite",
      0.0425
    ],
    [
      "ordre",
      0.0425
    ],
    [
      "condition",
      0.0425
    ],
    [
      "fonction",
      0.0375
    ],
    [
      "titre",
      0.03
    ],
    [
      "place",
      0.03
    ],
    [
      "niveau",
      0.03
    ],
    [
      "grade",
      0.03
    ],
    [
      "categorie",
      0.03
    ],
    [
      "sorte",
      0.025
    ],
    [
      "serie",
      0.025
    ],
    [
      "volee",
      0.025
    ],
    [
      "numero",
      0.0175
    ],
    [
      "qualification",
      0.0175
    ],
    [
      "echelon",
      0.0175
    ],
    [
      "etage",
      0.0175
    ],
    [
      "milieu",
      0.0175
    ],
    [
      "liste",
      0.0175
    ],
    [
      "lieu",
      0.0175
    ],
    [
      "file",
      0.0175
    ],
    [
      "distribution",
      0.0175
    ],
    [
      "dignite",
      0.0175
    ],
    [
      "tour",
      0.0125
    ],
    [
      "rangee",
      0.0125
    ],
    [
      "nombre",
      0.0125
    ],
    [
      "ligne",
      0.0125
    ],
    [
      "classement",
      0.0125
    ],
    [
      "statut",
      0.005
    ],
    [
      "repartition",
      0.005
    ],
    [
      "queue",
      0.005
    ],
    [
      "hierarchie",
      0.005
    ],
    [
      "haie",
      0.005
    ],
    [
      "cordon",
      0.005
    ],
    [
      "collier",
      0.005
    ],
    [
      "caste",
      0.005
    ],
    [
      "assise",
      0.005
    ],
    [
      "etre",
      0.005
    ]
  ],
  "dentier": [
    [
      "denture",
      0.4
    ],
    [
      "dent",
      0.2
    ],
    [
      "prothese",
      0.2
    ],
    [
      "ratelier",
      0.2
    ]
  ],
  "socialisme": [
    [
      "collectivisme",
      0.16
    ],
    [
      "communisme",
      0.16
    ],
    [
      "dirigisme",
      0.0775
    ],
    [
      "etatisme",
      0.0775
    ],
    [
      "travaillisme",
      0.0375
    ],
    [
      "trotskisme",
      0.0375
    ],
    [
      "egalitarisme",
      0.0375
    ],
    [
      "progressisme",
      0.0375
    ],
    [
      "mutualisme",
      0.0375
    ],
    [
      "marxisme",
      0.0375
    ],
    [
      "maoisme",
      0.0375
    ],
    [
      "fourierisme",
      0.0375
    ],
    [
      "cooperatisme",
      0.0375
    ],
    [
      "bolchevisme",
      0.0375
    ],
    [
      "etatisation",
      0.0375
    ]
  ],
  "lavande": [
    [
      "aromate",
      1.0
    ]
  ],
  "verbe": [
    [
      "Dieu",
      1.0
    ]
  ],
  "ronronner": [
    [
      "bourdonner",
      0.5
    ],
    [
      "rabacher",
      0.25
    ],
    [
      "ronfler",
      0.25
    ]
  ],
  "muscat": [],
  "habille": [
    [
      "fringuer",
      0.0925
    ],
    [
      "accoutrer",
      0.08
    ],
    [
      "deguiser",
      0.07
    ],
    [
      "parer",
      0.0575
    ],
    [
      "vetir",
      0.0475
    ],
    [
      "arranger",
      0.0475
    ],
    [
      "affubler",
      0.0425
    ],
    [
      "attifer",
      0.0425
    ],
    [
      "ajuster",
      0.0375
    ],
    [
      "revetir",
      0.0375
    ],
    [
      "orner",
      0.03
    ],
    [
      "embellir",
      0.03
    ],
    [
      "couvrir",
      0.03
    ],
    [
      "envelopper",
      0.025
    ],
    [
      "fagoter",
      0.02
    ],
    [
      "ficeler",
      0.02
    ],
    [
      "masquer",
      0.02
    ],
    [
      "travestir",
      0.02
    ],
    [
      "harnacher",
      0.015
    ],
    [
      "entourer",
      0.015
    ],
    [
      "endimancher",
      0.015
    ],
    [
      "decorer",
      0.015
    ],
    [
      "draper",
      0.015
    ],
    [
      "costumer",
      0.015
    ],
    [
      "ridiculiser",
      0.01
    ],
    [
      "recouvrir",
      0.01
    ],
    [
      "medire",
      0.01
    ],
    [
      "dissimuler",
      0.01
    ],
    [
      "convenir",
      0.01
    ],
    [
      "camoufler",
      0.01
    ],
    [
      "aller",
      0.01
    ],
    [
      "tendre",
      0.005
    ],
    [
      "seoir",
      0.005
    ],
    [
      "nipper",
      0.005
    ],
    [
      "enrichir",
      0.005
    ],
    [
      "enharnacher",
      0.005
    ],
    [
      "culotter",
      0.005
    ],
    [
      "calomnier",
      0.005
    ],
    [
      "avantager",
      0.005
    ],
    [
      "equiper",
      0.005
    ]
  ],
  "severe": [
    [
      "dur",
      0.125
    ],
    [
      "rude",
      0.0675
    ],
    [
      "rigide",
      0.055
    ],
    [
      "austere",
      0.0525
    ],
    [
      "rigoureux",
      0.0425
    ],
    [
      "cruel",
      0.0375
    ],
    [
      "sec",
      0.0325
    ],
    [
      "implacable",
      0.0275
    ],
    [
      "apre",
      0.0275
    ],
    [
      "raide",
      0.025
    ],
    [
      "mauvais",
      0.025
    ],
    [
      "inflexible",
      0.025
    ],
    [
      "strict",
      0.02
    ],
    [
      "grave",
      0.0175
    ],
    [
      "intransigeant",
      0.0175
    ],
    [
      "ascetique",
      0.015
    ],
    [
      "terrible",
      0.0125
    ],
    [
      "insensible",
      0.0125
    ],
    [
      "difficile",
      0.0125
    ],
    [
      "etroit",
      0.0125
    ],
    [
      "triste",
      0.0125
    ],
    [
      "simple",
      0.0125
    ],
    [
      "impitoyable",
      0.0125
    ],
    [
      "froid",
      0.0125
    ],
    [
      "brutal",
      0.0125
    ],
    [
      "bourru",
      0.0125
    ],
    [
      "tranchant",
      0.01
    ],
    [
      "serieux",
      0.01
    ],
    [
      "sobre",
      0.01
    ],
    [
      "rigoriste",
      0.01
    ],
    [
      "cassant",
      0.01
    ],
    [
      "autoritaire",
      0.01
    ],
    [
      "aigre",
      0.01
    ],
    [
      "range",
      0.0075
    ],
    [
      "sectaire",
      0.0075
    ],
    [
      "stoique",
      0.0075
    ],
    [
      "puritain",
      0.005
    ],
    [
      "intolerant",
      0.005
    ],
    [
      "ferme",
      0.005
    ],
    [
      "amer",
      0.005
    ],
    [
      "spartiate",
      0.0025
    ],
    [
      "regle",
      0.0025
    ],
    [
      "rebarbatif",
      0.0025
    ],
    [
      "profond",
      0.0025
    ],
    [
      "inexorable",
      0.0025
    ],
    [
      "gros",
      0.0025
    ],
    [
      "exigeant",
      0.0025
    ],
    [
      "exact",
      0.0025
    ],
    [
      "draconien",
      0.0025
    ],
    [
      "serre",
      0.0025
    ],
    [
      "sinistre",
      0.0025
    ],
    [
      "soigneux",
      0.0025
    ],
    [
      "sourcilleux",
      0.0025
    ],
    [
      "vache",
      0.0025
    ],
    [
      "sage",
      0.0025
    ],
    [
      "monacal",
      0.0025
    ],
    [
      "aride",
      0.0025
    ],
    [
      "cinglant",
      0.0025
    ],
    [
      "classique",
      0.0025
    ],
    [
      "depouille",
      0.0025
    ],
    [
      "intense",
      0.0025
    ],
    [
      "sale",
      0.0
    ],
    [
      "rosse",
      0.0
    ],
    [
      "punisseur",
      0.0
    ],
    [
      "inclement",
      0.0
    ],
    [
      "fruste",
      0.0
    ],
    [
      "fronce",
      0.0
    ],
    [
      "exemplaire",
      0.0
    ],
    [
      "drastique",
      0.0
    ],
    [
      "chaud",
      0.0
    ],
    [
      "eprouvant",
      0.0
    ]
  ],
  "ritournelle": [
    [
      "refrain",
      0.23
    ],
    [
      "rengaine",
      0.19
    ],
    [
      "antienne",
      0.115
    ],
    [
      "repetition",
      0.115
    ],
    [
      "scie",
      0.075
    ],
    [
      "chanson",
      0.075
    ],
    [
      "chant",
      0.0375
    ],
    [
      "couplet",
      0.0375
    ],
    [
      "disque",
      0.0375
    ],
    [
      "leitmotiv",
      0.0375
    ],
    [
      "rabachage",
      0.0375
    ]
  ],
  "cormoran": [],
  "palme": [
    [
      "branche",
      0.25
    ],
    [
      "couronne",
      0.25
    ],
    [
      "decoration",
      0.25
    ],
    [
      "palmette",
      0.25
    ]
  ],
  "perdant": [
    [
      "battu",
      0.165
    ],
    [
      "jusant",
      0.165
    ],
    [
      "loser",
      0.165
    ],
    [
      "maree",
      0.165
    ],
    [
      "reflux",
      0.165
    ],
    [
      "vaincu",
      0.165
    ]
  ],
  "u": [],
  "autorise": [
    [
      "permettre",
      0.14
    ],
    [
      "tolerer",
      0.1025
    ],
    [
      "admettre",
      0.095
    ],
    [
      "accepter",
      0.0575
    ],
    [
      "confirmer",
      0.05
    ],
    [
      "consentir",
      0.0425
    ],
    [
      "approuver",
      0.0425
    ],
    [
      "acquiescer",
      0.035
    ],
    [
      "supporter",
      0.0275
    ],
    [
      "souffrir",
      0.0275
    ],
    [
      "justifier",
      0.0275
    ],
    [
      "accorder",
      0.0275
    ],
    [
      "appuyer",
      0.02
    ],
    [
      "homologuer",
      0.02
    ],
    [
      "passer",
      0.02
    ],
    [
      "habiliter",
      0.0125
    ],
    [
      "laisser",
      0.0125
    ],
    [
      "legitimer",
      0.0125
    ],
    [
      "qualifier",
      0.0125
    ],
    [
      "ratifier",
      0.0125
    ],
    [
      "fortifier",
      0.0125
    ],
    [
      "exempter",
      0.0125
    ],
    [
      "agreer",
      0.0125
    ],
    [
      "comporter",
      0.0125
    ],
    [
      "conceder",
      0.0125
    ],
    [
      "daigner",
      0.0125
    ],
    [
      "dispenser",
      0.0125
    ],
    [
      "encourager",
      0.0125
    ],
    [
      "accrediter",
      0.005
    ],
    [
      "endurer",
      0.005
    ],
    [
      "renforcer",
      0.005
    ]
  ],
  "autoriser": [
    [
      "permettre",
      0.14
    ],
    [
      "tolerer",
      0.1025
    ],
    [
      "admettre",
      0.095
    ],
    [
      "accepter",
      0.0575
    ],
    [
      "confirmer",
      0.05
    ],
    [
      "consentir",
      0.0425
    ],
    [
      "approuver",
      0.0425
    ],
    [
      "acquiescer",
      0.035
    ],
    [
      "supporter",
      0.0275
    ],
    [
      "souffrir",
      0.0275
    ],
    [
      "justifier",
      0.0275
    ],
    [
      "accorder",
      0.0275
    ],
    [
      "appuyer",
      0.02
    ],
    [
      "homologuer",
      0.02
    ],
    [
      "passer",
      0.02
    ],
    [
      "habiliter",
      0.0125
    ],
    [
      "laisser",
      0.0125
    ],
    [
      "legitimer",
      0.0125
    ],
    [
      "qualifier",
      0.0125
    ],
    [
      "ratifier",
      0.0125
    ],
    [
      "fortifier",
      0.0125
    ],
    [
      "exempter",
      0.0125
    ],
    [
      "agreer",
      0.0125
    ],
    [
      "comporter",
      0.0125
    ],
    [
      "conceder",
      0.0125
    ],
    [
      "daigner",
      0.0125
    ],
    [
      "dispenser",
      0.0125
    ],
    [
      "encourager",
      0.0125
    ],
    [
      "accrediter",
      0.005
    ],
    [
      "endurer",
      0.005
    ],
    [
      "renforcer",
      0.005
    ]
  ],
  "helice": [
    [
      "courbe",
      0.3325
    ],
    [
      "spirale",
      0.3325
    ],
    [
      "torsade",
      0.165
    ],
    [
      "volute",
      0.165
    ]
  ],
  "precoce": [
    [
      "hatif",
      0.3325
    ],
    [
      "anticipe",
      0.165
    ],
    [
      "avance",
      0.165
    ],
    [
      "primeur",
      0.165
    ],
    [
      "premature",
      0.165
    ]
  ],
  "morsure": [
    [
      "blessure",
      0.3625
    ],
    [
      "attaque",
      0.09
    ],
    [
      "bourrade",
      0.09
    ],
    [
      "brulure",
      0.09
    ],
    [
      "dechirure",
      0.09
    ],
    [
      "meurtrissure",
      0.09
    ],
    [
      "piqure",
      0.09
    ],
    [
      "plaie",
      0.09
    ]
  ],
  "parjure": [
    [
      "adultere",
      0.18
    ],
    [
      "infidele",
      0.18
    ],
    [
      "blasphemateur",
      0.09
    ],
    [
      "deloyal",
      0.09
    ],
    [
      "infidelite",
      0.09
    ],
    [
      "renegat",
      0.09
    ],
    [
      "trahison",
      0.09
    ],
    [
      "traitre",
      0.09
    ]
  ],
  "parjurer": [],
  "carcan": [
    [
      "chaine",
      0.115
    ],
    [
      "joug",
      0.09
    ],
    [
      "servitude",
      0.09
    ],
    [
      "assujettissement",
      0.0675
    ],
    [
      "sujetion",
      0.045
    ],
    [
      "rosse",
      0.045
    ],
    [
      "haridelle",
      0.045
    ],
    [
      "esclavage",
      0.045
    ],
    [
      "contrainte",
      0.045
    ],
    [
      "collier",
      0.045
    ],
    [
      "cheval",
      0.045
    ],
    [
      "asservissement",
      0.045
    ],
    [
      "tribart",
      0.0225
    ],
    [
      "pilori",
      0.0225
    ],
    [
      "maigre",
      0.0225
    ],
    [
      "lien",
      0.0225
    ],
    [
      "griffe",
      0.0225
    ],
    [
      "gaine",
      0.0225
    ],
    [
      "exposition",
      0.0225
    ],
    [
      "carogne",
      0.0225
    ],
    [
      "cangue",
      0.0225
    ],
    [
      "canasson",
      0.0225
    ],
    [
      "cadre",
      0.0225
    ],
    [
      "tyrannie",
      0.0225
    ]
  ],
  "partenaire": [
    [
      "associe",
      0.1325
    ],
    [
      "acolyte",
      0.1
    ],
    [
      "aide",
      0.0875
    ],
    [
      "complice",
      0.0875
    ],
    [
      "compere",
      0.0775
    ],
    [
      "compagnon",
      0.0775
    ],
    [
      "adjoint",
      0.065
    ],
    [
      "allie",
      0.065
    ],
    [
      "camarade",
      0.055
    ],
    [
      "copain",
      0.0425
    ],
    [
      "ami",
      0.0325
    ],
    [
      "collegue",
      0.02
    ],
    [
      "second",
      0.02
    ],
    [
      "affide",
      0.01
    ],
    [
      "cavalier",
      0.01
    ],
    [
      "correspondant",
      0.01
    ],
    [
      "coequipier",
      0.01
    ],
    [
      "danseur",
      0.01
    ],
    [
      "danseuse",
      0.01
    ]
  ],
  "sacrilege": [
    [
      "impie",
      0.105
    ],
    [
      "impiete",
      0.105
    ],
    [
      "outrage",
      0.105
    ],
    [
      "profanation",
      0.105
    ],
    [
      "peche",
      0.07
    ],
    [
      "profanateur",
      0.07
    ],
    [
      "blasphemateur",
      0.07
    ],
    [
      "blaspheme",
      0.07
    ],
    [
      "attentat",
      0.07
    ],
    [
      "attentatoire",
      0.035
    ],
    [
      "blasphematoire",
      0.035
    ],
    [
      "crime",
      0.035
    ],
    [
      "heresie",
      0.035
    ],
    [
      "heretique",
      0.035
    ],
    [
      "violation",
      0.035
    ]
  ],
  "parchemin": [
    [
      "diplome",
      0.22
    ],
    [
      "brevet",
      0.11
    ],
    [
      "palimpseste",
      0.11
    ],
    [
      "peau",
      0.11
    ],
    [
      "titre",
      0.11
    ],
    [
      "velin",
      0.11
    ],
    [
      "ecrit",
      0.11
    ]
  ],
  "vielle": [
    [
      "cordeliere",
      1.0
    ]
  ],
  "lechefrite": [
    [
      "casserole",
      0.4
    ],
    [
      "broche",
      0.2
    ],
    [
      "casse",
      0.2
    ]
  ],
  "attrait": [
    [
      "charme",
      0.09
    ],
    [
      "seduction",
      0.0825
    ],
    [
      "desir",
      0.0725
    ],
    [
      "fascination",
      0.065
    ],
    [
      "gout",
      0.0475
    ],
    [
      "attirance",
      0.0475
    ],
    [
      "soif",
      0.04
    ],
    [
      "penchant",
      0.0325
    ],
    [
      "inclination",
      0.0325
    ],
    [
      "attraction",
      0.0325
    ],
    [
      "appat",
      0.0325
    ],
    [
      "appel",
      0.0325
    ],
    [
      "allechement",
      0.0325
    ],
    [
      "tentation",
      0.0225
    ],
    [
      "sympathie",
      0.0225
    ],
    [
      "appetit",
      0.0225
    ],
    [
      "appetence",
      0.0225
    ],
    [
      "appas",
      0.0225
    ],
    [
      "prestige",
      0.015
    ],
    [
      "grace",
      0.015
    ],
    [
      "ensorcellement",
      0.015
    ],
    [
      "enchantement",
      0.015
    ],
    [
      "concupiscence",
      0.015
    ],
    [
      "blandice",
      0.015
    ],
    [
      "beaute",
      0.015
    ],
    [
      "agrement",
      0.015
    ],
    [
      "affinite",
      0.015
    ],
    [
      "mirage",
      0.0075
    ],
    [
      "invite",
      0.0075
    ],
    [
      "invitation",
      0.0075
    ],
    [
      "entrainement",
      0.0075
    ],
    [
      "direction",
      0.0075
    ],
    [
      "chien",
      0.0075
    ],
    [
      "attractivite",
      0.0075
    ],
    [
      "amorce",
      0.0075
    ],
    [
      "aimant",
      0.0075
    ],
    [
      "ragout",
      0.0075
    ]
  ],
  "devoiler": [
    [
      "reveler",
      0.18
    ],
    [
      "montrer",
      0.13
    ],
    [
      "decouvrir",
      0.08
    ],
    [
      "indiquer",
      0.08
    ],
    [
      "trahir",
      0.06
    ],
    [
      "denoncer",
      0.045
    ],
    [
      "signaler",
      0.04
    ],
    [
      "dire",
      0.0275
    ],
    [
      "demontrer",
      0.0225
    ],
    [
      "demasquer",
      0.0225
    ],
    [
      "declarer",
      0.0225
    ],
    [
      "afficher",
      0.02
    ],
    [
      "expliquer",
      0.02
    ],
    [
      "livrer",
      0.02
    ],
    [
      "prouver",
      0.02
    ],
    [
      "etaler",
      0.0125
    ],
    [
      "rapporter",
      0.0125
    ],
    [
      "peindre",
      0.0125
    ],
    [
      "deceler",
      0.0125
    ],
    [
      "divulguer",
      0.0125
    ],
    [
      "deviner",
      0.0125
    ],
    [
      "proclamer",
      0.0075
    ],
    [
      "denuder",
      0.0075
    ],
    [
      "dechirer",
      0.0075
    ],
    [
      "dessiner",
      0.0075
    ],
    [
      "arracher",
      0.0075
    ],
    [
      "devetir",
      0.0025
    ],
    [
      "predire",
      0.0025
    ]
  ],
  "devoilant": [
    [
      "reveler",
      0.18
    ],
    [
      "montrer",
      0.13
    ],
    [
      "decouvrir",
      0.08
    ],
    [
      "indiquer",
      0.08
    ],
    [
      "trahir",
      0.06
    ],
    [
      "denoncer",
      0.045
    ],
    [
      "signaler",
      0.04
    ],
    [
      "dire",
      0.0275
    ],
    [
      "demontrer",
      0.0225
    ],
    [
      "demasquer",
      0.0225
    ],
    [
      "declarer",
      0.0225
    ],
    [
      "afficher",
      0.02
    ],
    [
      "expliquer",
      0.02
    ],
    [
      "livrer",
      0.02
    ],
    [
      "prouver",
      0.02
    ],
    [
      "etaler",
      0.0125
    ],
    [
      "rapporter",
      0.0125
    ],
    [
      "peindre",
      0.0125
    ],
    [
      "deceler",
      0.0125
    ],
    [
      "divulguer",
      0.0125
    ],
    [
      "deviner",
      0.0125
    ],
    [
      "proclamer",
      0.0075
    ],
    [
      "denuder",
      0.0075
    ],
    [
      "dechirer",
      0.0075
    ],
    [
      "dessiner",
      0.0075
    ],
    [
      "arracher",
      0.0075
    ],
    [
      "devetir",
      0.0025
    ],
    [
      "predire",
      0.0025
    ]
  ],
  "palir": [
    [
      "passer",
      0.1575
    ],
    [
      "diminuer",
      0.0775
    ],
    [
      "s'eteindre",
      0.0775
    ],
    [
      "s'estomper",
      0.0525
    ],
    [
      "s'effacer",
      0.0525
    ],
    [
      "s'affaiblir",
      0.0525
    ],
    [
      "blanchir",
      0.0525
    ],
    [
      "s'attenuer",
      0.025
    ],
    [
      "jaunir",
      0.025
    ],
    [
      "fletrir",
      0.025
    ],
    [
      "blemir",
      0.025
    ],
    [
      "apalir",
      0.025
    ],
    [
      "affadir",
      0.025
    ],
    [
      "eclipser",
      0.025
    ]
  ],
  "feuillet": [
    [
      "feuille",
      0.3025
    ],
    [
      "cahier",
      0.0975
    ],
    [
      "estomac",
      0.0975
    ],
    [
      "folio",
      0.0975
    ],
    [
      "lame",
      0.0975
    ],
    [
      "page",
      0.0975
    ],
    [
      "planche",
      0.0975
    ],
    [
      "pli",
      0.0975
    ]
  ],
  "confiture": [
    [
      "compote",
      0.0825
    ],
    [
      "roquille",
      0.0825
    ],
    [
      "raisine",
      0.0825
    ],
    [
      "pate",
      0.0825
    ],
    [
      "prunelee",
      0.0825
    ],
    [
      "orangeat",
      0.0825
    ],
    [
      "marmelade",
      0.0825
    ],
    [
      "gelee",
      0.0825
    ],
    [
      "excrement",
      0.0825
    ],
    [
      "cotignac",
      0.0825
    ],
    [
      "conserve",
      0.0825
    ],
    [
      "sucrerie",
      0.0825
    ]
  ],
  "servant": [
    [
      "acolyte",
      0.165
    ],
    [
      "artilleur",
      0.165
    ],
    [
      "asservi",
      0.165
    ],
    [
      "pourvoyeur",
      0.165
    ],
    [
      "serveur",
      0.165
    ],
    [
      "tireur",
      0.165
    ]
  ],
  "dispenser": [
    [
      "liberer",
      0.0975
    ],
    [
      "exempter",
      0.0825
    ],
    [
      "distribuer",
      0.0675
    ],
    [
      "donner",
      0.0675
    ],
    [
      "decharger",
      0.0675
    ],
    [
      "degager",
      0.0675
    ],
    [
      "repartir",
      0.0675
    ],
    [
      "eviter",
      0.055
    ],
    [
      "repandre",
      0.055
    ],
    [
      "accorder",
      0.04
    ],
    [
      "partager",
      0.04
    ],
    [
      "tolerer",
      0.0275
    ],
    [
      "soustraire",
      0.0275
    ],
    [
      "permettre",
      0.0275
    ],
    [
      "exonerer",
      0.0275
    ],
    [
      "delivrer",
      0.0275
    ],
    [
      "autoriser",
      0.0275
    ],
    [
      "jeter",
      0.0125
    ],
    [
      "interdire",
      0.0125
    ],
    [
      "fournir",
      0.0125
    ],
    [
      "departir",
      0.0125
    ],
    [
      "degrever",
      0.0125
    ],
    [
      "diviser",
      0.0125
    ],
    [
      "epargner",
      0.0125
    ]
  ],
  "dispense": [
    [
      "exemption",
      0.1875
    ],
    [
      "autorisation",
      0.125
    ],
    [
      "franchise",
      0.125
    ],
    [
      "immunite",
      0.125
    ],
    [
      "liberte",
      0.125
    ],
    [
      "permission",
      0.125
    ],
    [
      "distribution",
      0.06
    ],
    [
      "exoneration",
      0.06
    ],
    [
      "faveur",
      0.06
    ]
  ],
  "guepe": [
    [
      "astate",
      0.25
    ],
    [
      "frelon",
      0.25
    ],
    [
      "mouche",
      0.25
    ],
    [
      "sphex",
      0.25
    ]
  ],
  "supermarche": [
    [
      "hypermarche",
      0.165
    ],
    [
      "magasin",
      0.165
    ],
    [
      "superette",
      0.165
    ],
    [
      "surface",
      0.165
    ]
  ],
  "hydrogene": [],
  "sulfure": [
    [
      "bisulfure",
      0.5
    ],
    [
      "millefiori",
      0.5
    ]
  ],
  "progres": [
    [
      "developpement",
      0.13
    ],
    [
      "progression",
      0.1125
    ],
    [
      "avancement",
      0.0575
    ],
    [
      "marche",
      0.0575
    ],
    [
      "augmentation",
      0.0525
    ],
    [
      "evolution",
      0.045
    ],
    [
      "propagation",
      0.035
    ],
    [
      "extension",
      0.035
    ],
    [
      "croissance",
      0.035
    ],
    [
      "cours",
      0.035
    ],
    [
      "amelioration",
      0.035
    ],
    [
      "accroissement",
      0.035
    ],
    [
      "mouvement",
      0.0275
    ],
    [
      "processus",
      0.0275
    ],
    [
      "transmission",
      0.0225
    ],
    [
      "montee",
      0.0225
    ],
    [
      "expansion",
      0.0225
    ],
    [
      "essor",
      0.0225
    ],
    [
      "civilisation",
      0.015
    ],
    [
      "aggravation",
      0.015
    ],
    [
      "recrudescence",
      0.01
    ],
    [
      "perfectionnement",
      0.01
    ],
    [
      "pas",
      0.01
    ],
    [
      "gain",
      0.01
    ],
    [
      "ascension",
      0.01
    ],
    [
      "amendement",
      0.01
    ],
    [
      "renaissance",
      0.005
    ],
    [
      "prosperite",
      0.005
    ],
    [
      "profit",
      0.005
    ],
    [
      "proces",
      0.005
    ],
    [
      "modernisme",
      0.005
    ],
    [
      "mieux",
      0.005
    ],
    [
      "maturation",
      0.005
    ],
    [
      "courant",
      0.005
    ],
    [
      "cheminement",
      0.005
    ],
    [
      "approfondissement",
      0.005
    ],
    [
      "adoucissement",
      0.005
    ],
    [
      "technique",
      0.005
    ]
  ],
  "ire": [
    [
      "colere",
      1.0
    ]
  ],
  "tome": [
    [
      "livre",
      0.3325
    ],
    [
      "recueil",
      0.3325
    ],
    [
      "volume",
      0.3325
    ]
  ],
  "decombre": [
    [
      "decombrement",
      0.5
    ],
    [
      "demolition",
      0.5
    ]
  ],
  "tequila": [],
  "fiesta": [
    [
      "bringue",
      0.25
    ],
    [
      "foire",
      0.25
    ],
    [
      "fete",
      0.25
    ],
    [
      "noce",
      0.25
    ]
  ],
  "peton": [
    [
      "pied",
      1.0
    ]
  ],
  "teton": [
    [
      "sein",
      0.5
    ],
    [
      "tetin",
      0.5
    ]
  ],
  "teter": [
    [
      "boire",
      0.25
    ],
    [
      "s'abreuver",
      0.25
    ],
    [
      "sucer",
      0.25
    ],
    [
      "pinter",
      0.125
    ],
    [
      "sucoter",
      0.125
    ]
  ],
  "intelligence": [
    [
      "esprit",
      0.0725
    ],
    [
      "entendement",
      0.055
    ],
    [
      "connaissance",
      0.0475
    ],
    [
      "raison",
      0.0375
    ],
    [
      "conception",
      0.0375
    ],
    [
      "adresse",
      0.0375
    ],
    [
      "habilete",
      0.035
    ],
    [
      "penetration",
      0.035
    ],
    [
      "pensee",
      0.0275
    ],
    [
      "sagacite",
      0.025
    ],
    [
      "jugement",
      0.025
    ],
    [
      "finesse",
      0.025
    ],
    [
      "comprehension",
      0.025
    ],
    [
      "astuce",
      0.0225
    ],
    [
      "discernement",
      0.0225
    ],
    [
      "genie",
      0.0225
    ],
    [
      "perspicacite",
      0.0225
    ],
    [
      "faculte",
      0.0175
    ],
    [
      "capacite",
      0.0175
    ],
    [
      "art",
      0.015
    ],
    [
      "don",
      0.015
    ],
    [
      "idee",
      0.015
    ],
    [
      "imagination",
      0.015
    ],
    [
      "lucidite",
      0.015
    ],
    [
      "subtilite",
      0.015
    ],
    [
      "entente",
      0.0125
    ],
    [
      "clairvoyance",
      0.0125
    ],
    [
      "accord",
      0.0125
    ],
    [
      "intellect",
      0.0125
    ],
    [
      "reflexion",
      0.0125
    ],
    [
      "savoir",
      0.0125
    ],
    [
      "tete",
      0.0125
    ],
    [
      "union",
      0.0125
    ],
    [
      "vivacite",
      0.0075
    ],
    [
      "profondeur",
      0.0075
    ],
    [
      "moyen",
      0.0075
    ],
    [
      "cerveau",
      0.0075
    ],
    [
      "acuite",
      0.0075
    ],
    [
      "rapport",
      0.005
    ],
    [
      "perception",
      0.005
    ],
    [
      "lumiere",
      0.005
    ],
    [
      "ingeniosite",
      0.005
    ],
    [
      "collusion",
      0.005
    ],
    [
      "accointance",
      0.005
    ],
    [
      "abstraction",
      0.005
    ],
    [
      "ame",
      0.0025
    ],
    [
      "virtuosite",
      0.0025
    ],
    [
      "meche",
      0.0025
    ],
    [
      "maitrise",
      0.0025
    ],
    [
      "intellection",
      0.0025
    ],
    [
      "industrie",
      0.0025
    ],
    [
      "fraternite",
      0.0025
    ],
    [
      "amitie",
      0.0025
    ],
    [
      "complicite",
      0.0025
    ],
    [
      "connivence",
      0.0025
    ],
    [
      "doigte",
      0.0025
    ],
    [
      "facilite",
      0.0025
    ],
    [
      "maestria",
      0.0
    ],
    [
      "crack",
      0.0
    ],
    [
      "correspondance",
      0.0
    ],
    [
      "concert",
      0.0
    ],
    [
      "comprenette",
      0.0
    ],
    [
      "coalition",
      0.0
    ],
    [
      "aigle",
      0.0
    ],
    [
      "accointage",
      0.0
    ]
  ],
  "plumard": [
    [
      "lit",
      0.2725
    ],
    [
      "pieu",
      0.18
    ],
    [
      "balai",
      0.09
    ],
    [
      "paddock",
      0.09
    ],
    [
      "plumail",
      0.09
    ],
    [
      "plume",
      0.09
    ],
    [
      "plumeau",
      0.09
    ],
    [
      "portefeuille",
      0.09
    ]
  ],
  "autoritaire": [
    [
      "absolu",
      0.0875
    ],
    [
      "imperieux",
      0.065
    ],
    [
      "dur",
      0.055
    ],
    [
      "ferme",
      0.055
    ],
    [
      "tranchant",
      0.05
    ],
    [
      "fort",
      0.0425
    ],
    [
      "categorique",
      0.0425
    ],
    [
      "sec",
      0.0375
    ],
    [
      "imperatif",
      0.0375
    ],
    [
      "dominateur",
      0.0375
    ],
    [
      "dictatorial",
      0.0375
    ],
    [
      "despotique",
      0.0375
    ],
    [
      "cassant",
      0.0375
    ],
    [
      "raide",
      0.0325
    ],
    [
      "severe",
      0.0325
    ],
    [
      "tyrannique",
      0.0325
    ],
    [
      "volontaire",
      0.02
    ],
    [
      "strict",
      0.02
    ],
    [
      "peremptoire",
      0.02
    ],
    [
      "intransigeant",
      0.02
    ],
    [
      "abrupt",
      0.02
    ],
    [
      "autocratique",
      0.015
    ],
    [
      "brusque",
      0.015
    ],
    [
      "energique",
      0.01
    ],
    [
      "irresistible",
      0.01
    ],
    [
      "despote",
      0.01
    ],
    [
      "totalitaire",
      0.005
    ],
    [
      "sectaire",
      0.005
    ],
    [
      "repressif",
      0.005
    ],
    [
      "pressant",
      0.005
    ],
    [
      "net",
      0.005
    ],
    [
      "muscle",
      0.005
    ],
    [
      "intolerant",
      0.005
    ],
    [
      "entier",
      0.005
    ],
    [
      "directif",
      0.005
    ],
    [
      "coupant",
      0.005
    ],
    [
      "commandant",
      0.005
    ],
    [
      "altier",
      0.005
    ],
    [
      "absolutisme",
      0.005
    ],
    [
      "tyran",
      0.005
    ]
  ],
  "hippopotame": [],
  "tripler": [
    [
      "augmenter",
      0.5
    ],
    [
      "multiplier",
      0.5
    ]
  ],
  "triple": [
    [
      "double",
      0.1425
    ],
    [
      "grand",
      0.1425
    ],
    [
      "multiple",
      0.1425
    ],
    [
      "parfait",
      0.1425
    ],
    [
      "renforce",
      0.1425
    ],
    [
      "triple",
      0.1425
    ],
    [
      "trois",
      0.1425
    ]
  ],
  "effroi": [
    [
      "frayeur",
      0.115
    ],
    [
      "peur",
      0.115
    ],
    [
      "epouvante",
      0.085
    ],
    [
      "alarme",
      0.0775
    ],
    [
      "inquietude",
      0.07
    ],
    [
      "terreur",
      0.0625
    ],
    [
      "frousse",
      0.0625
    ],
    [
      "crainte",
      0.0625
    ],
    [
      "angoisse",
      0.045
    ],
    [
      "affolement",
      0.0375
    ],
    [
      "transe",
      0.0375
    ],
    [
      "horreur",
      0.03
    ],
    [
      "affres",
      0.03
    ],
    [
      "apprehension",
      0.0225
    ],
    [
      "panique",
      0.0225
    ],
    [
      "trouble",
      0.015
    ],
    [
      "stupefaction",
      0.015
    ],
    [
      "phobie",
      0.015
    ],
    [
      "effarement",
      0.015
    ],
    [
      "anxiete",
      0.015
    ],
    [
      "horripilation",
      0.0075
    ],
    [
      "trouille",
      0.0075
    ]
  ],
  "enfler": [
    [
      "grossir",
      0.1475
    ],
    [
      "gonfler",
      0.1375
    ],
    [
      "augmenter",
      0.1075
    ],
    [
      "amplifier",
      0.07
    ],
    [
      "exagerer",
      0.06
    ],
    [
      "rencherir",
      0.0475
    ],
    [
      "grandir",
      0.0375
    ],
    [
      "hausser",
      0.0375
    ],
    [
      "surfaire",
      0.0325
    ],
    [
      "majorer",
      0.0275
    ],
    [
      "forcer",
      0.0275
    ],
    [
      "agrandir",
      0.0275
    ],
    [
      "ballonner",
      0.0175
    ],
    [
      "boursoufler",
      0.0175
    ],
    [
      "exalter",
      0.0175
    ],
    [
      "souffler",
      0.0175
    ],
    [
      "s'arrondir",
      0.0125
    ],
    [
      "distendre",
      0.0125
    ],
    [
      "dilater",
      0.0125
    ],
    [
      "croitre",
      0.0125
    ],
    [
      "bouffer",
      0.0125
    ],
    [
      "renforcer",
      0.0075
    ],
    [
      "renfler",
      0.0075
    ],
    [
      "outrer",
      0.0075
    ],
    [
      "bouffir",
      0.0075
    ],
    [
      "bomber",
      0.0075
    ],
    [
      "bedonner",
      0.0025
    ],
    [
      "nourrir",
      0.0025
    ],
    [
      "remplir",
      0.0025
    ],
    [
      "s'alourdir",
      0.0025
    ],
    [
      "s'elargir",
      0.0025
    ],
    [
      "tumefier",
      0.0025
    ]
  ],
  "enfle": [
    [
      "grossir",
      0.1475
    ],
    [
      "gonfler",
      0.1375
    ],
    [
      "augmenter",
      0.1075
    ],
    [
      "amplifier",
      0.07
    ],
    [
      "exagerer",
      0.06
    ],
    [
      "rencherir",
      0.0475
    ],
    [
      "grandir",
      0.0375
    ],
    [
      "hausser",
      0.0375
    ],
    [
      "surfaire",
      0.0325
    ],
    [
      "majorer",
      0.0275
    ],
    [
      "forcer",
      0.0275
    ],
    [
      "agrandir",
      0.0275
    ],
    [
      "ballonner",
      0.0175
    ],
    [
      "boursoufler",
      0.0175
    ],
    [
      "exalter",
      0.0175
    ],
    [
      "souffler",
      0.0175
    ],
    [
      "s'arrondir",
      0.0125
    ],
    [
      "distendre",
      0.0125
    ],
    [
      "dilater",
      0.0125
    ],
    [
      "croitre",
      0.0125
    ],
    [
      "bouffer",
      0.0125
    ],
    [
      "renforcer",
      0.0075
    ],
    [
      "renfler",
      0.0075
    ],
    [
      "outrer",
      0.0075
    ],
    [
      "bouffir",
      0.0075
    ],
    [
      "bomber",
      0.0075
    ],
    [
      "bedonner",
      0.0025
    ],
    [
      "nourrir",
      0.0025
    ],
    [
      "remplir",
      0.0025
    ],
    [
      "s'alourdir",
      0.0025
    ],
    [
      "s'elargir",
      0.0025
    ],
    [
      "tumefier",
      0.0025
    ]
  ],
  "pincette": [
    [
      "badine",
      0.165
    ],
    [
      "jambe",
      0.165
    ],
    [
      "pince",
      0.165
    ],
    [
      "pinceau",
      0.165
    ],
    [
      "tisonnier",
      0.165
    ]
  ],
  "virage": [
    [
      "tournant",
      0.175
    ],
    [
      "detour",
      0.13
    ],
    [
      "zigzag",
      0.085
    ],
    [
      "revirement",
      0.085
    ],
    [
      "lacet",
      0.085
    ],
    [
      "courbe",
      0.085
    ],
    [
      "contour",
      0.085
    ],
    [
      "changement",
      0.0425
    ],
    [
      "coude",
      0.0425
    ],
    [
      "courbure",
      0.0425
    ]
  ],
  "stage": [
    [
      "alumnat",
      0.11
    ],
    [
      "arret",
      0.11
    ],
    [
      "passage",
      0.11
    ],
    [
      "sejour",
      0.11
    ],
    [
      "seminaire",
      0.055
    ],
    [
      "station",
      0.055
    ],
    [
      "periode",
      0.055
    ],
    [
      "preparation",
      0.055
    ],
    [
      "noviciat",
      0.055
    ],
    [
      "moment",
      0.055
    ],
    [
      "juvenat",
      0.055
    ],
    [
      "formation",
      0.055
    ],
    [
      "apprentissage",
      0.055
    ]
  ],
  "rattrapage": [
    [
      "raccrochage",
      0.5
    ],
    [
      "rajustement",
      0.5
    ]
  ],
  "tournant": [
    [
      "detour",
      0.14
    ],
    [
      "coude",
      0.0825
    ],
    [
      "courbe",
      0.07
    ],
    [
      "meandre",
      0.07
    ],
    [
      "virage",
      0.055
    ],
    [
      "sinuosite",
      0.055
    ],
    [
      "lacet",
      0.055
    ],
    [
      "contour",
      0.055
    ],
    [
      "angle",
      0.055
    ],
    [
      "zigzag",
      0.04
    ],
    [
      "tour",
      0.0275
    ],
    [
      "rotatif",
      0.0275
    ],
    [
      "retour",
      0.0275
    ],
    [
      "courbure",
      0.0275
    ],
    [
      "coin",
      0.0275
    ],
    [
      "tortueux",
      0.0125
    ],
    [
      "sinueux",
      0.0125
    ],
    [
      "serpentin",
      0.0125
    ],
    [
      "saillie",
      0.0125
    ],
    [
      "rotatoire",
      0.0125
    ],
    [
      "pourtournant",
      0.0125
    ],
    [
      "pivotant",
      0.0125
    ],
    [
      "moyen",
      0.0125
    ],
    [
      "moment",
      0.0125
    ],
    [
      "giratoire",
      0.0125
    ],
    [
      "croisement",
      0.0125
    ],
    [
      "tourbillonnant",
      0.0125
    ]
  ],
  "conscient": [
    [
      "clair",
      0.22
    ],
    [
      "clairvoyant",
      0.11
    ],
    [
      "delibere",
      0.11
    ],
    [
      "intentionnel",
      0.11
    ],
    [
      "lucide",
      0.11
    ],
    [
      "perspicace",
      0.11
    ],
    [
      "reflechi",
      0.11
    ],
    [
      "evident",
      0.11
    ]
  ],
  "plupart": [
    [
      "generalite",
      1.0
    ]
  ],
  "agression": [
    [
      "attaque",
      0.1475
    ],
    [
      "vol",
      0.1275
    ],
    [
      "invasion",
      0.0625
    ],
    [
      "violence",
      0.0625
    ],
    [
      "provocation",
      0.0425
    ],
    [
      "intervention",
      0.0425
    ],
    [
      "envahissement",
      0.0425
    ],
    [
      "conquete",
      0.0425
    ],
    [
      "attentat",
      0.0425
    ],
    [
      "agressivite",
      0.0425
    ],
    [
      "action",
      0.0425
    ],
    [
      "stress",
      0.02
    ],
    [
      "sadisme",
      0.02
    ],
    [
      "pollution",
      0.02
    ],
    [
      "nuisance",
      0.02
    ],
    [
      "masochisme",
      0.02
    ],
    [
      "intrusion",
      0.02
    ],
    [
      "insulte",
      0.02
    ],
    [
      "effraction",
      0.02
    ],
    [
      "deferlement",
      0.02
    ],
    [
      "casse",
      0.02
    ],
    [
      "cambriolage",
      0.02
    ],
    [
      "viol",
      0.02
    ]
  ],
  "pleureur": [
    [
      "pleurard",
      0.215
    ],
    [
      "pleurnicheur",
      0.1425
    ],
    [
      "geignard",
      0.105
    ],
    [
      "larmoyant",
      0.105
    ],
    [
      "gemissant",
      0.07
    ],
    [
      "geignant",
      0.07
    ],
    [
      "chagrin",
      0.07
    ],
    [
      "braillard",
      0.035
    ],
    [
      "plaignard",
      0.035
    ],
    [
      "pleurant",
      0.035
    ],
    [
      "pleurnichant",
      0.035
    ],
    [
      "pleurnichard",
      0.035
    ],
    [
      "vagissant",
      0.035
    ]
  ],
  "longueur": [
    [
      "remplissage",
      0.13
    ],
    [
      "etendue",
      0.13
    ],
    [
      "paraphrase",
      0.085
    ],
    [
      "grandeur",
      0.085
    ],
    [
      "developpement",
      0.085
    ],
    [
      "delayage",
      0.085
    ],
    [
      "dimension",
      0.085
    ],
    [
      "superfluite",
      0.0425
    ],
    [
      "prolixite",
      0.0425
    ],
    [
      "profondeur",
      0.0425
    ],
    [
      "long",
      0.0425
    ],
    [
      "lenteur",
      0.0425
    ],
    [
      "duree",
      0.0425
    ],
    [
      "taille",
      0.0425
    ]
  ],
  "ego": [
    [
      "je",
      0.5
    ],
    [
      "moi",
      0.5
    ]
  ],
  "surclasser": [
    [
      "surpasser",
      0.1625
    ],
    [
      "devancer",
      0.0975
    ],
    [
      "enfoncer",
      0.0975
    ],
    [
      "triompher",
      0.0975
    ],
    [
      "battre",
      0.08
    ],
    [
      "vaincre",
      0.065
    ],
    [
      "ecraser",
      0.065
    ],
    [
      "surmonter",
      0.0475
    ],
    [
      "depasser",
      0.0475
    ],
    [
      "distancer",
      0.0475
    ],
    [
      "exceller",
      0.0325
    ],
    [
      "gagner",
      0.0325
    ],
    [
      "surevaluer",
      0.015
    ],
    [
      "surfaire",
      0.015
    ],
    [
      "surestimer",
      0.015
    ],
    [
      "surcoter",
      0.015
    ],
    [
      "piler",
      0.015
    ],
    [
      "eclipser",
      0.015
    ]
  ],
  "injuste": [
    [
      "mauvais",
      0.1
    ],
    [
      "partial",
      0.0575
    ],
    [
      "deraisonnable",
      0.0475
    ],
    [
      "faux",
      0.0475
    ],
    [
      "mechant",
      0.0475
    ],
    [
      "irregulier",
      0.0375
    ],
    [
      "indigne",
      0.0375
    ],
    [
      "illegitime",
      0.0375
    ],
    [
      "illegal",
      0.0375
    ],
    [
      "calomnieux",
      0.0375
    ],
    [
      "arbitraire",
      0.0375
    ],
    [
      "malhonnete",
      0.0275
    ],
    [
      "injustifie",
      0.0275
    ],
    [
      "injustifiable",
      0.0275
    ],
    [
      "inique",
      0.0275
    ],
    [
      "deloyal",
      0.0275
    ],
    [
      "abusif",
      0.0275
    ],
    [
      "tyrannique",
      0.0175
    ],
    [
      "scelerat",
      0.0175
    ],
    [
      "irrecevable",
      0.0175
    ],
    [
      "inequitable",
      0.0175
    ],
    [
      "inegal",
      0.0175
    ],
    [
      "immoral",
      0.0175
    ],
    [
      "anormal",
      0.0175
    ],
    [
      "leonin",
      0.0075
    ],
    [
      "malfaisant",
      0.0075
    ],
    [
      "odieux",
      0.0075
    ],
    [
      "oppresseur",
      0.0075
    ],
    [
      "usurpe",
      0.0075
    ],
    [
      "injurieux",
      0.0075
    ],
    [
      "indu",
      0.0075
    ],
    [
      "inadmissible",
      0.0075
    ],
    [
      "inacceptable",
      0.0075
    ],
    [
      "immerite",
      0.0075
    ],
    [
      "idiot",
      0.0075
    ],
    [
      "blamable",
      0.0075
    ],
    [
      "attentatoire",
      0.0075
    ],
    [
      "affligeant",
      0.0075
    ],
    [
      "zoile",
      0.0075
    ]
  ],
  "vise": [
    [
      "desirer",
      0.09
    ],
    [
      "regarder",
      0.0775
    ],
    [
      "ambitionner",
      0.055
    ],
    [
      "chercher",
      0.0475
    ],
    [
      "rechercher",
      0.0475
    ],
    [
      "vouloir",
      0.0475
    ],
    [
      "souhaiter",
      0.04
    ],
    [
      "lorgner",
      0.04
    ],
    [
      "briguer",
      0.035
    ],
    [
      "pretendre",
      0.035
    ],
    [
      "rever",
      0.035
    ],
    [
      "voir",
      0.0275
    ],
    [
      "tendre",
      0.0275
    ],
    [
      "poursuivre",
      0.0275
    ],
    [
      "examiner",
      0.0275
    ],
    [
      "convoiter",
      0.0275
    ],
    [
      "emarger",
      0.02
    ],
    [
      "toucher",
      0.02
    ],
    [
      "mater",
      0.02
    ],
    [
      "interesser",
      0.02
    ],
    [
      "zieuter",
      0.0125
    ],
    [
      "signer",
      0.0125
    ],
    [
      "s'efforcer",
      0.0125
    ],
    [
      "s'attacher",
      0.0125
    ],
    [
      "s'appliquer",
      0.0125
    ],
    [
      "guigner",
      0.0125
    ],
    [
      "concerner",
      0.0125
    ],
    [
      "debarrasser",
      0.005
    ],
    [
      "mirer",
      0.005
    ],
    [
      "pointer",
      0.005
    ],
    [
      "rechasser",
      0.005
    ],
    [
      "tacher",
      0.005
    ],
    [
      "coucher",
      0.005
    ],
    [
      "citer",
      0.005
    ],
    [
      "bornoyer",
      0.005
    ],
    [
      "aviser",
      0.005
    ],
    [
      "authentifier",
      0.005
    ],
    [
      "apostiller",
      0.005
    ],
    [
      "ajuster",
      0.005
    ],
    [
      "valider",
      0.005
    ]
  ],
  "loser": [
    [
      "perdant",
      0.5
    ],
    [
      "rate",
      0.5
    ]
  ],
  "vanne": [
    [
      "fermeture",
      0.135
    ],
    [
      "ecluse",
      0.135
    ],
    [
      "blague",
      0.09
    ],
    [
      "brocard",
      0.09
    ],
    [
      "betise",
      0.09
    ],
    [
      "plaisanterie",
      0.09
    ],
    [
      "sarcasme",
      0.045
    ],
    [
      "robinet",
      0.045
    ],
    [
      "deversoir",
      0.045
    ],
    [
      "cataracte",
      0.045
    ],
    [
      "bevue",
      0.045
    ],
    [
      "bonde",
      0.045
    ],
    [
      "barrage",
      0.045
    ],
    [
      "vent",
      0.045
    ]
  ],
  "vanner": [
    [
      "ereinter",
      0.1375
    ],
    [
      "epuiser",
      0.1225
    ],
    [
      "fatiguer",
      0.1075
    ],
    [
      "claquer",
      0.09
    ],
    [
      "harasser",
      0.09
    ],
    [
      "extenuer",
      0.075
    ],
    [
      "vider",
      0.075
    ],
    [
      "tuer",
      0.045
    ],
    [
      "nettoyer",
      0.045
    ],
    [
      "exceder",
      0.045
    ],
    [
      "crever",
      0.045
    ],
    [
      "battre",
      0.03
    ],
    [
      "pomper",
      0.03
    ],
    [
      "lasser",
      0.015
    ],
    [
      "recurer",
      0.015
    ],
    [
      "tamiser",
      0.015
    ]
  ],
  "sketch": [
    [
      "comedie",
      0.285
    ],
    [
      "gag",
      0.1425
    ],
    [
      "numero",
      0.1425
    ],
    [
      "pantomime",
      0.1425
    ],
    [
      "saynete",
      0.1425
    ],
    [
      "scene",
      0.1425
    ]
  ],
  "calvaire": [
    [
      "affliction",
      0.18
    ],
    [
      "croix",
      0.12
    ],
    [
      "peine",
      0.12
    ],
    [
      "supplice",
      0.12
    ],
    [
      "douleur",
      0.09
    ],
    [
      "epreuve",
      0.06
    ],
    [
      "torture",
      0.06
    ],
    [
      "martyre",
      0.06
    ],
    [
      "Golgotha",
      0.03
    ],
    [
      "calice",
      0.03
    ],
    [
      "gehenne",
      0.03
    ],
    [
      "mortification",
      0.03
    ]
  ],
  "temoin": [
    [
      "spectateur",
      0.0925
    ],
    [
      "temoignage",
      0.0925
    ],
    [
      "assistant",
      0.07
    ],
    [
      "marque",
      0.07
    ],
    [
      "signe",
      0.07
    ],
    [
      "stigmate",
      0.045
    ],
    [
      "preuve",
      0.045
    ],
    [
      "caution",
      0.045
    ],
    [
      "present",
      0.0225
    ],
    [
      "recors",
      0.0225
    ],
    [
      "regardant",
      0.0225
    ],
    [
      "ruine",
      0.0225
    ],
    [
      "second",
      0.0225
    ],
    [
      "souvenir",
      0.0225
    ],
    [
      "taquet",
      0.0225
    ],
    [
      "tiers",
      0.0225
    ],
    [
      "parrain",
      0.0225
    ],
    [
      "observateur",
      0.0225
    ],
    [
      "manifestation",
      0.0225
    ],
    [
      "archives",
      0.0225
    ],
    [
      "auditeur",
      0.0225
    ],
    [
      "baton",
      0.0225
    ],
    [
      "batonnet",
      0.0225
    ],
    [
      "deposant",
      0.0225
    ],
    [
      "galerie",
      0.0225
    ],
    [
      "garant",
      0.0225
    ],
    [
      "voyant",
      0.0225
    ]
  ],
  "branler": [
    [
      "osciller",
      0.1075
    ],
    [
      "remuer",
      0.1075
    ],
    [
      "balancer",
      0.095
    ],
    [
      "tanguer",
      0.095
    ],
    [
      "vaciller",
      0.08
    ],
    [
      "secouer",
      0.0525
    ],
    [
      "agiter",
      0.0525
    ],
    [
      "ficher",
      0.04
    ],
    [
      "lancer",
      0.04
    ],
    [
      "mouvoir",
      0.04
    ],
    [
      "tituber",
      0.04
    ],
    [
      "foutre",
      0.025
    ],
    [
      "chanceler",
      0.025
    ],
    [
      "s'ebranler",
      0.0125
    ],
    [
      "locher",
      0.0125
    ],
    [
      "hocher",
      0.0125
    ],
    [
      "glander",
      0.0125
    ],
    [
      "fabriquer",
      0.0125
    ],
    [
      "danser",
      0.0125
    ],
    [
      "branlocher",
      0.0125
    ],
    [
      "brandiller",
      0.0125
    ],
    [
      "bouger",
      0.0125
    ],
    [
      "boiter",
      0.0125
    ],
    [
      "ebranler",
      0.0125
    ]
  ],
  "depistage": [
    [
      "detection",
      0.3325
    ],
    [
      "recherche",
      0.3325
    ],
    [
      "reperage",
      0.3325
    ]
  ],
  "examen": [
    [
      "observation",
      0.06
    ],
    [
      "analyse",
      0.055
    ],
    [
      "etude",
      0.055
    ],
    [
      "inspection",
      0.0425
    ],
    [
      "recherche",
      0.0425
    ],
    [
      "verification",
      0.0425
    ],
    [
      "exploration",
      0.0375
    ],
    [
      "consultation",
      0.0325
    ],
    [
      "enquete",
      0.0275
    ],
    [
      "expertise",
      0.0275
    ],
    [
      "reconnaissance",
      0.0275
    ],
    [
      "visite",
      0.0275
    ],
    [
      "epreuve",
      0.02
    ],
    [
      "investigation",
      0.02
    ],
    [
      "experience",
      0.02
    ],
    [
      "essai",
      0.02
    ],
    [
      "discussion",
      0.02
    ],
    [
      "controle",
      0.02
    ],
    [
      "approfondissement",
      0.02
    ],
    [
      "question",
      0.015
    ],
    [
      "interrogation",
      0.015
    ],
    [
      "information",
      0.015
    ],
    [
      "deliberation",
      0.015
    ],
    [
      "critique",
      0.015
    ],
    [
      "composition",
      0.015
    ],
    [
      "appreciation",
      0.015
    ],
    [
      "evaluation",
      0.01
    ],
    [
      "test",
      0.01
    ],
    [
      "revue",
      0.01
    ],
    [
      "licence",
      0.01
    ],
    [
      "introspection",
      0.01
    ],
    [
      "depouillement",
      0.01
    ],
    [
      "debat",
      0.01
    ],
    [
      "arraisonnement",
      0.01
    ],
    [
      "brevet",
      0.01
    ],
    [
      "certificat",
      0.01
    ],
    [
      "conference",
      0.01
    ],
    [
      "constatation",
      0.01
    ],
    [
      "dissection",
      0.005
    ],
    [
      "doctorat",
      0.005
    ],
    [
      "estimation",
      0.005
    ],
    [
      "oral",
      0.005
    ],
    [
      "partiel",
      0.005
    ],
    [
      "pesee",
      0.005
    ],
    [
      "ronde",
      0.005
    ],
    [
      "visa",
      0.005
    ],
    [
      "vue",
      0.005
    ],
    [
      "ecrit",
      0.005
    ],
    [
      "diplome",
      0.005
    ],
    [
      "consideration",
      0.005
    ],
    [
      "audiometrie",
      0.005
    ],
    [
      "audition",
      0.005
    ],
    [
      "auscultation",
      0.005
    ],
    [
      "autopsie",
      0.005
    ],
    [
      "bac",
      0.005
    ],
    [
      "baccalaureat",
      0.005
    ],
    [
      "bachot",
      0.005
    ],
    [
      "censure",
      0.005
    ],
    [
      "collation",
      0.005
    ],
    [
      "concours",
      0.005
    ],
    [
      "epluchage",
      0.005
    ]
  ],
  "filtrer": [
    [
      "couler",
      0.095
    ],
    [
      "passer",
      0.095
    ],
    [
      "purifier",
      0.095
    ],
    [
      "tamiser",
      0.095
    ],
    [
      "transpirer",
      0.0625
    ],
    [
      "epurer",
      0.0625
    ],
    [
      "sourdre",
      0.045
    ],
    [
      "clarifier",
      0.045
    ],
    [
      "traverser",
      0.03
    ],
    [
      "penetrer",
      0.03
    ],
    [
      "percer",
      0.03
    ],
    [
      "glisser",
      0.03
    ],
    [
      "fuir",
      0.03
    ],
    [
      "degager",
      0.03
    ],
    [
      "debarrasser",
      0.03
    ],
    [
      "verifier",
      0.015
    ],
    [
      "voiler",
      0.015
    ],
    [
      "transsuder",
      0.015
    ],
    [
      "secreter",
      0.015
    ],
    [
      "nettoyer",
      0.015
    ],
    [
      "defequer",
      0.015
    ],
    [
      "adoucir",
      0.015
    ],
    [
      "eliminer",
      0.015
    ]
  ],
  "filtre": [
    [
      "adoucisseur",
      0.0525
    ],
    [
      "epurateur",
      0.0525
    ],
    [
      "ecran",
      0.0525
    ],
    [
      "purificateur",
      0.0525
    ],
    [
      "percolateur",
      0.0525
    ],
    [
      "passoire",
      0.0525
    ],
    [
      "papier",
      0.0525
    ],
    [
      "feutre",
      0.0525
    ],
    [
      "citerneau",
      0.0525
    ],
    [
      "chaussette",
      0.0525
    ],
    [
      "chausse",
      0.0525
    ],
    [
      "censure",
      0.0525
    ],
    [
      "cafe",
      0.0525
    ],
    [
      "cafetiere",
      0.0525
    ],
    [
      "buvard",
      0.0525
    ],
    [
      "bougie",
      0.0525
    ],
    [
      "blanchet",
      0.0525
    ],
    [
      "antiparasite",
      0.0525
    ],
    [
      "etamine",
      0.0525
    ]
  ],
  "metaphore": [
    [
      "image",
      0.1875
    ],
    [
      "symbole",
      0.1875
    ],
    [
      "comparaison",
      0.125
    ],
    [
      "expression",
      0.125
    ],
    [
      "figure",
      0.125
    ],
    [
      "allegorie",
      0.0625
    ],
    [
      "analogie",
      0.0625
    ],
    [
      "catachrese",
      0.0625
    ],
    [
      "trope",
      0.0625
    ]
  ],
  "chimie": [
    [
      "agrochimie",
      0.075
    ],
    [
      "zoochimie",
      0.075
    ],
    [
      "thermochimie",
      0.075
    ],
    [
      "stereochimie",
      0.075
    ],
    [
      "radiochimie",
      0.075
    ],
    [
      "photochimie",
      0.075
    ],
    [
      "pharmacie",
      0.075
    ],
    [
      "magnetochimie",
      0.075
    ],
    [
      "iatrochimie",
      0.075
    ],
    [
      "cristallochimie",
      0.075
    ],
    [
      "biochimie",
      0.075
    ],
    [
      "alchimie",
      0.075
    ],
    [
      "electrochimie",
      0.075
    ]
  ],
  "philo": [],
  "oppose": [
    [
      "alleguer",
      0.0625
    ],
    [
      "comparer",
      0.0625
    ],
    [
      "dresser",
      0.0625
    ],
    [
      "pretexter",
      0.0625
    ],
    [
      "repondre",
      0.0625
    ],
    [
      "mettre",
      0.04
    ],
    [
      "objecter",
      0.04
    ],
    [
      "refuter",
      0.04
    ],
    [
      "invoquer",
      0.04
    ],
    [
      "exciter",
      0.04
    ],
    [
      "dire",
      0.04
    ],
    [
      "contredire",
      0.04
    ],
    [
      "braquer",
      0.04
    ],
    [
      "balancer",
      0.04
    ],
    [
      "diviser",
      0.02
    ],
    [
      "desaccorder",
      0.02
    ],
    [
      "endiguer",
      0.02
    ],
    [
      "separer",
      0.02
    ],
    [
      "dissocier",
      0.02
    ],
    [
      "confronter",
      0.02
    ],
    [
      "avancer",
      0.02
    ],
    [
      "armer",
      0.02
    ],
    [
      "agir",
      0.02
    ],
    [
      "affronter",
      0.02
    ],
    [
      "adosser",
      0.02
    ],
    [
      "elever",
      0.02
    ]
  ],
  "matos": [],
  "sniffer": [
    [
      "priser",
      0.5
    ]
  ],
  "tri": [
    [
      "triage",
      0.285
    ],
    [
      "choix",
      0.1425
    ],
    [
      "depart",
      0.1425
    ],
    [
      "ferrade",
      0.1425
    ],
    [
      "hombre",
      0.1425
    ],
    [
      "selection",
      0.1425
    ]
  ],
  "version": [
    [
      "explication",
      0.11
    ],
    [
      "interpretation",
      0.11
    ],
    [
      "rapport",
      0.11
    ],
    [
      "relation",
      0.11
    ],
    [
      "recit",
      0.11
    ],
    [
      "traduction",
      0.055
    ],
    [
      "mouture",
      0.055
    ],
    [
      "lecon",
      0.055
    ],
    [
      "histoire",
      0.055
    ],
    [
      "declaration",
      0.055
    ],
    [
      "variante",
      0.055
    ]
  ],
  "attentat": [
    [
      "crime",
      0.1575
    ],
    [
      "attaque",
      0.105
    ],
    [
      "faute",
      0.105
    ],
    [
      "atteinte",
      0.0775
    ],
    [
      "outrage",
      0.0775
    ],
    [
      "peche",
      0.0775
    ],
    [
      "sacrilege",
      0.05
    ],
    [
      "offense",
      0.05
    ],
    [
      "delit",
      0.05
    ],
    [
      "agression",
      0.05
    ],
    [
      "assassinat",
      0.025
    ],
    [
      "complot",
      0.025
    ],
    [
      "entreprise",
      0.025
    ],
    [
      "forfait",
      0.025
    ],
    [
      "infraction",
      0.025
    ],
    [
      "violence",
      0.025
    ]
  ],
  "decomposer": [
    [
      "detruire",
      0.1
    ],
    [
      "alterer",
      0.0875
    ],
    [
      "analyser",
      0.0775
    ],
    [
      "desagreger",
      0.065
    ],
    [
      "corrompre",
      0.055
    ],
    [
      "separer",
      0.055
    ],
    [
      "gater",
      0.0425
    ],
    [
      "diviser",
      0.0425
    ],
    [
      "dissoudre",
      0.0425
    ],
    [
      "dissocier",
      0.0425
    ],
    [
      "pourrir",
      0.0325
    ],
    [
      "depecer",
      0.0325
    ],
    [
      "defigurer",
      0.0325
    ],
    [
      "defaire",
      0.0325
    ],
    [
      "dissequer",
      0.0325
    ],
    [
      "troubler",
      0.02
    ],
    [
      "resoudre",
      0.02
    ],
    [
      "frelater",
      0.02
    ],
    [
      "desorganiser",
      0.02
    ],
    [
      "desintegrer",
      0.02
    ],
    [
      "reduire",
      0.01
    ],
    [
      "putrefier",
      0.01
    ],
    [
      "mortifier",
      0.01
    ],
    [
      "faisander",
      0.01
    ],
    [
      "examiner",
      0.01
    ],
    [
      "desosser",
      0.01
    ],
    [
      "contrefaire",
      0.01
    ],
    [
      "anatomiser",
      0.01
    ],
    [
      "scinder",
      0.01
    ]
  ],
  "accent": [
    [
      "ton",
      0.155
    ],
    [
      "son",
      0.1325
    ],
    [
      "marque",
      0.065
    ],
    [
      "voix",
      0.0425
    ],
    [
      "tonalite",
      0.0425
    ],
    [
      "prononciation",
      0.0425
    ],
    [
      "parole",
      0.0425
    ],
    [
      "note",
      0.0425
    ],
    [
      "modulation",
      0.0425
    ],
    [
      "maniere",
      0.0425
    ],
    [
      "intonation",
      0.0425
    ],
    [
      "inflexion",
      0.0425
    ],
    [
      "accentuation",
      0.0425
    ],
    [
      "signe",
      0.02
    ],
    [
      "ponctuation",
      0.02
    ],
    [
      "parler",
      0.02
    ],
    [
      "melodie",
      0.02
    ],
    [
      "intensite",
      0.02
    ],
    [
      "empreinte",
      0.02
    ],
    [
      "emphase",
      0.02
    ],
    [
      "assent",
      0.02
    ],
    [
      "elocution",
      0.02
    ]
  ],
  "froment": [
    [
      "ble",
      0.5
    ],
    [
      "cereale",
      0.25
    ],
    [
      "epeautre",
      0.25
    ]
  ],
  "charrier": [
    [
      "entrainer",
      0.0775
    ],
    [
      "transporter",
      0.0775
    ],
    [
      "railler",
      0.0625
    ],
    [
      "rouler",
      0.0625
    ],
    [
      "emporter",
      0.05
    ],
    [
      "exagerer",
      0.05
    ],
    [
      "pousser",
      0.05
    ],
    [
      "trainer",
      0.0375
    ],
    [
      "plaisanter",
      0.0375
    ],
    [
      "blaguer",
      0.0375
    ],
    [
      "tromper",
      0.025
    ],
    [
      "porter",
      0.025
    ],
    [
      "mystifier",
      0.025
    ],
    [
      "mener",
      0.025
    ],
    [
      "chiner",
      0.025
    ],
    [
      "cherrer",
      0.025
    ],
    [
      "chariboter",
      0.025
    ],
    [
      "attiger",
      0.025
    ],
    [
      "abuser",
      0.025
    ],
    [
      "touer",
      0.0125
    ],
    [
      "taquiner",
      0.0125
    ],
    [
      "enlever",
      0.0125
    ],
    [
      "chasser",
      0.0125
    ],
    [
      "charroyer",
      0.0125
    ],
    [
      "chambrer",
      0.0125
    ],
    [
      "voiturer",
      0.0125
    ]
  ],
  "terroir": [
    [
      "pays",
      0.2125
    ],
    [
      "terre",
      0.2125
    ],
    [
      "region",
      0.1425
    ],
    [
      "sol",
      0.1425
    ],
    [
      "terrain",
      0.1425
    ],
    [
      "champ",
      0.07
    ],
    [
      "origine",
      0.07
    ]
  ],
  "compose": [
    [
      "construire",
      0.08
    ],
    [
      "faire",
      0.0775
    ],
    [
      "former",
      0.07
    ],
    [
      "arranger",
      0.0525
    ],
    [
      "creer",
      0.0425
    ],
    [
      "elaborer",
      0.0425
    ],
    [
      "organiser",
      0.04
    ],
    [
      "preparer",
      0.0375
    ],
    [
      "faconner",
      0.035
    ],
    [
      "produire",
      0.035
    ],
    [
      "combiner",
      0.0325
    ],
    [
      "constituer",
      0.025
    ],
    [
      "disposer",
      0.0225
    ],
    [
      "batir",
      0.02
    ],
    [
      "ecrire",
      0.02
    ],
    [
      "transiger",
      0.02
    ],
    [
      "imaginer",
      0.02
    ],
    [
      "inventer",
      0.0175
    ],
    [
      "assembler",
      0.015
    ],
    [
      "concevoir",
      0.015
    ],
    [
      "forger",
      0.015
    ],
    [
      "travailler",
      0.015
    ],
    [
      "edifier",
      0.015
    ],
    [
      "traiter",
      0.01
    ],
    [
      "harmoniser",
      0.01
    ],
    [
      "ajuster",
      0.01
    ],
    [
      "agencer",
      0.01
    ],
    [
      "appreter",
      0.0075
    ],
    [
      "donner",
      0.0075
    ],
    [
      "s'entendre",
      0.005
    ],
    [
      "s'accorder",
      0.005
    ],
    [
      "polir",
      0.005
    ],
    [
      "ordonner",
      0.005
    ],
    [
      "confectionner",
      0.005
    ],
    [
      "affecter",
      0.005
    ],
    [
      "pactiser",
      0.0025
    ],
    [
      "parlementer",
      0.0025
    ],
    [
      "romancer",
      0.0025
    ],
    [
      "s'accommoder",
      0.0025
    ],
    [
      "sculpter",
      0.0025
    ],
    [
      "elucubrer",
      0.0025
    ],
    [
      "etudier",
      0.0025
    ],
    [
      "negocier",
      0.0025
    ],
    [
      "imiter",
      0.0025
    ],
    [
      "emprunter",
      0.0025
    ],
    [
      "accoucher",
      0.0025
    ],
    [
      "associer",
      0.0025
    ],
    [
      "capituler",
      0.0025
    ],
    [
      "charpenter",
      0.0025
    ],
    [
      "ciseler",
      0.0025
    ],
    [
      "ceder",
      0.0025
    ],
    [
      "deguiser",
      0.0025
    ],
    [
      "rediger",
      0.0
    ],
    [
      "rimer",
      0.0
    ],
    [
      "pondre",
      0.0
    ],
    [
      "ordonnancer",
      0.0
    ],
    [
      "melanger",
      0.0
    ],
    [
      "imprimer",
      0.0
    ],
    [
      "faufiler",
      0.0
    ],
    [
      "faiblir",
      0.0
    ],
    [
      "conceder",
      0.0
    ],
    [
      "biaiser",
      0.0
    ],
    [
      "adopter",
      0.0
    ],
    [
      "tergiverser",
      0.0
    ]
  ],
  "orange": [
    [
      "bigarade",
      0.25
    ],
    [
      "clementine",
      0.25
    ],
    [
      "mandarine",
      0.25
    ],
    [
      "orange",
      0.25
    ]
  ],
  "grotesque": [
    [
      "ridicule",
      0.1325
    ],
    [
      "burlesque",
      0.12
    ],
    [
      "comique",
      0.1075
    ],
    [
      "bizarre",
      0.08
    ],
    [
      "bouffon",
      0.08
    ],
    [
      "funambulesque",
      0.0525
    ],
    [
      "extravagant",
      0.0525
    ],
    [
      "caricatural",
      0.0375
    ],
    [
      "cocasse",
      0.0375
    ],
    [
      "risible",
      0.0375
    ],
    [
      "incroyable",
      0.025
    ],
    [
      "extraordinaire",
      0.025
    ],
    [
      "clownesque",
      0.025
    ],
    [
      "aberrant",
      0.025
    ],
    [
      "turlupin",
      0.0125
    ],
    [
      "scurrile",
      0.0125
    ],
    [
      "falot",
      0.0125
    ],
    [
      "crevant",
      0.0125
    ],
    [
      "carnaval",
      0.0125
    ],
    [
      "bete",
      0.0125
    ],
    [
      "bouffonnerie",
      0.0125
    ],
    [
      "biscornu",
      0.0125
    ],
    [
      "ubuesque",
      0.0125
    ]
  ],
  "gothique": [
    [
      "arriere",
      0.1525
    ],
    [
      "barbare",
      0.1525
    ],
    [
      "suranne",
      0.1525
    ],
    [
      "vieux",
      0.1525
    ],
    [
      "ancien",
      0.075
    ],
    [
      "goth",
      0.075
    ],
    [
      "medieval",
      0.075
    ],
    [
      "ogival",
      0.075
    ],
    [
      "sauvage",
      0.075
    ]
  ],
  "criard": [
    [
      "aigre",
      0.095
    ],
    [
      "gueulard",
      0.07
    ],
    [
      "vif",
      0.07
    ],
    [
      "tapageur",
      0.0575
    ],
    [
      "violent",
      0.045
    ],
    [
      "dur",
      0.045
    ],
    [
      "aigu",
      0.045
    ],
    [
      "voyant",
      0.035
    ],
    [
      "percant",
      0.035
    ],
    [
      "grincant",
      0.035
    ],
    [
      "desagreable",
      0.035
    ],
    [
      "discordant",
      0.035
    ],
    [
      "braillard",
      0.035
    ],
    [
      "acariatre",
      0.035
    ],
    [
      "acre",
      0.0225
    ],
    [
      "strident",
      0.0225
    ],
    [
      "hurlant",
      0.0225
    ],
    [
      "criant",
      0.0225
    ],
    [
      "bruyant",
      0.0225
    ],
    [
      "brillant",
      0.0225
    ],
    [
      "rouspeteur",
      0.01
    ],
    [
      "retentissant",
      0.01
    ],
    [
      "querelleur",
      0.01
    ],
    [
      "pleurnicheur",
      0.01
    ],
    [
      "oppose",
      0.01
    ],
    [
      "glapissant",
      0.01
    ],
    [
      "dissonant",
      0.01
    ],
    [
      "cru",
      0.01
    ],
    [
      "crieur",
      0.01
    ],
    [
      "criailleur",
      0.01
    ],
    [
      "charivarique",
      0.01
    ],
    [
      "brailleur",
      0.01
    ],
    [
      "reche",
      0.01
    ]
  ],
  "souffrant": [
    [
      "malade",
      0.2575
    ],
    [
      "maladif",
      0.085
    ],
    [
      "souffreteux",
      0.085
    ],
    [
      "patraque",
      0.0625
    ],
    [
      "egrotant",
      0.0425
    ],
    [
      "pale",
      0.0425
    ],
    [
      "indispose",
      0.0425
    ],
    [
      "fatigue",
      0.0425
    ],
    [
      "dolent",
      0.0425
    ],
    [
      "palot",
      0.02
    ],
    [
      "perclus",
      0.02
    ],
    [
      "patient",
      0.02
    ],
    [
      "incommode",
      0.02
    ],
    [
      "fievreux",
      0.02
    ],
    [
      "deprime",
      0.02
    ],
    [
      "douloureux",
      0.02
    ],
    [
      "cacochyme",
      0.02
    ],
    [
      "atteint",
      0.02
    ],
    [
      "alite",
      0.02
    ],
    [
      "abattu",
      0.02
    ],
    [
      "patissant",
      0.02
    ]
  ],
  "mail": [
    [
      "maillet",
      0.25
    ],
    [
      "marteau",
      0.15
    ],
    [
      "mel",
      0.0475
    ],
    [
      "masse",
      0.0475
    ],
    [
      "maillotin",
      0.0475
    ],
    [
      "mailloche",
      0.0475
    ],
    [
      "hutinet",
      0.0475
    ],
    [
      "dreve",
      0.0475
    ],
    [
      "cours",
      0.0475
    ],
    [
      "boulevard",
      0.0475
    ],
    [
      "batte",
      0.0475
    ],
    [
      "allee",
      0.0475
    ],
    [
      "promenade",
      0.0475
    ]
  ],
  "rimmel": [],
  "endurance": [
    [
      "force",
      0.1375
    ],
    [
      "fermete",
      0.1025
    ],
    [
      "resistance",
      0.1025
    ],
    [
      "solidite",
      0.1025
    ],
    [
      "energie",
      0.1025
    ],
    [
      "ressort",
      0.0675
    ],
    [
      "perseverance",
      0.0675
    ],
    [
      "patience",
      0.0675
    ],
    [
      "endurcissement",
      0.0675
    ],
    [
      "habitude",
      0.0325
    ],
    [
      "resilience",
      0.0325
    ],
    [
      "souffrance",
      0.0325
    ],
    [
      "trempe",
      0.0325
    ],
    [
      "vitalite",
      0.0325
    ]
  ],
  "gymnastique": [
    [
      "entrainement",
      0.125
    ],
    [
      "exercice",
      0.125
    ],
    [
      "sport",
      0.0825
    ],
    [
      "gymnique",
      0.04
    ],
    [
      "mouvement",
      0.04
    ],
    [
      "orchestique",
      0.04
    ],
    [
      "palestrique",
      0.04
    ],
    [
      "spheristique",
      0.04
    ],
    [
      "travail",
      0.04
    ],
    [
      "delassement",
      0.04
    ],
    [
      "culturisme",
      0.04
    ],
    [
      "athletisme",
      0.04
    ],
    [
      "athletique",
      0.04
    ],
    [
      "assouplissement",
      0.04
    ],
    [
      "agres",
      0.04
    ],
    [
      "agonistique",
      0.04
    ],
    [
      "acrobatie",
      0.04
    ]
  ],
  "recreer": [
    [
      "refaire",
      0.5
    ],
    [
      "repenser",
      0.5
    ]
  ],
  "prolonge": [
    [
      "brague",
      0.3325
    ],
    [
      "brancard",
      0.3325
    ],
    [
      "cordage",
      0.3325
    ]
  ],
  "transversal": [
    [
      "detourne",
      0.1425
    ],
    [
      "flechi",
      0.1425
    ],
    [
      "latitudinal",
      0.1425
    ],
    [
      "oblique",
      0.1425
    ],
    [
      "penche",
      0.1425
    ],
    [
      "transverse",
      0.1425
    ]
  ],
  "trepas": [
    [
      "mort",
      0.285
    ],
    [
      "disparition",
      0.1425
    ],
    [
      "deces",
      0.1425
    ],
    [
      "fin",
      0.1425
    ],
    [
      "trepassement",
      0.1425
    ]
  ],
  "fanfaron": [
    [
      "hableur",
      0.1725
    ],
    [
      "bravache",
      0.105
    ],
    [
      "matamore",
      0.095
    ],
    [
      "menteur",
      0.0525
    ],
    [
      "vantard",
      0.0525
    ],
    [
      "vaniteux",
      0.0425
    ],
    [
      "rodomont",
      0.0425
    ],
    [
      "fat",
      0.025
    ],
    [
      "faraud",
      0.025
    ],
    [
      "craneur",
      0.025
    ],
    [
      "sot",
      0.015
    ],
    [
      "pourfendeur",
      0.015
    ],
    [
      "fendeur",
      0.015
    ],
    [
      "faiseur",
      0.015
    ],
    [
      "esbroufeur",
      0.015
    ],
    [
      "courageux",
      0.015
    ],
    [
      "capitan",
      0.015
    ],
    [
      "gascon",
      0.0075
    ],
    [
      "matador",
      0.0075
    ],
    [
      "machefer",
      0.0075
    ],
    [
      "olibrius",
      0.0075
    ],
    [
      "plastronneur",
      0.0075
    ],
    [
      "tartarin",
      0.0075
    ],
    [
      "trompeur",
      0.0075
    ],
    [
      "fracasse",
      0.0075
    ],
    [
      "flambard",
      0.0075
    ],
    [
      "bluffeur",
      0.0075
    ],
    [
      "brave",
      0.0075
    ],
    [
      "casseur",
      0.0075
    ],
    [
      "coq",
      0.0075
    ],
    [
      "craqueur",
      0.0075
    ],
    [
      "fanfaronnade",
      0.0075
    ],
    [
      "fendant",
      0.0075
    ],
    [
      "vanteur",
      0.0075
    ]
  ],
  "larron": [
    [
      "voleur",
      0.25
    ],
    [
      "filou",
      0.2
    ],
    [
      "escroc",
      0.1
    ],
    [
      "fripon",
      0.1
    ],
    [
      "malfaiteur",
      0.1
    ],
    [
      "scelerat",
      0.1
    ],
    [
      "plagiaire",
      0.05
    ],
    [
      "suborneur",
      0.05
    ],
    [
      "seducteur",
      0.05
    ]
  ],
  "impur": [
    [
      "obscene",
      0.0675
    ],
    [
      "bas",
      0.0625
    ],
    [
      "abject",
      0.055
    ],
    [
      "immoral",
      0.05
    ],
    [
      "sale",
      0.0475
    ],
    [
      "honteux",
      0.045
    ],
    [
      "infame",
      0.04
    ],
    [
      "sordide",
      0.0375
    ],
    [
      "malpropre",
      0.0375
    ],
    [
      "impudique",
      0.0325
    ],
    [
      "vil",
      0.0325
    ],
    [
      "immonde",
      0.03
    ],
    [
      "indecent",
      0.0275
    ],
    [
      "vicieux",
      0.0275
    ],
    [
      "mauvais",
      0.0225
    ],
    [
      "inconvenant",
      0.0225
    ],
    [
      "corrompu",
      0.02
    ],
    [
      "indigne",
      0.02
    ],
    [
      "infect",
      0.02
    ],
    [
      "lascif",
      0.02
    ],
    [
      "boueux",
      0.015
    ],
    [
      "lubrique",
      0.015
    ],
    [
      "trivial",
      0.0125
    ],
    [
      "sensuel",
      0.0125
    ],
    [
      "malhonnete",
      0.0125
    ],
    [
      "frelate",
      0.0125
    ],
    [
      "avilissant",
      0.0125
    ],
    [
      "malsain",
      0.01
    ],
    [
      "libidineux",
      0.01
    ],
    [
      "fangeux",
      0.01
    ],
    [
      "deshonnete",
      0.01
    ],
    [
      "deprave",
      0.01
    ],
    [
      "tare",
      0.005
    ],
    [
      "repoussant",
      0.005
    ],
    [
      "putride",
      0.005
    ],
    [
      "insalubre",
      0.005
    ],
    [
      "immodeste",
      0.005
    ],
    [
      "degradant",
      0.005
    ],
    [
      "avarie",
      0.005
    ],
    [
      "falsifie",
      0.0025
    ],
    [
      "heterogene",
      0.0025
    ],
    [
      "mele",
      0.0025
    ],
    [
      "pollue",
      0.0025
    ],
    [
      "pecheur",
      0.0025
    ],
    [
      "souille",
      0.0025
    ],
    [
      "empuanti",
      0.0025
    ],
    [
      "empeste",
      0.0025
    ],
    [
      "devoye",
      0.0025
    ],
    [
      "deshonore",
      0.0025
    ],
    [
      "contamine",
      0.0025
    ],
    [
      "charnel",
      0.0025
    ],
    [
      "bourbeux",
      0.0025
    ],
    [
      "altere",
      0.0025
    ],
    [
      "adultere",
      0.0025
    ],
    [
      "trouble",
      0.0025
    ]
  ],
  "frappant": [
    [
      "saisissant",
      0.1275
    ],
    [
      "notable",
      0.085
    ],
    [
      "remarquable",
      0.085
    ],
    [
      "saillant",
      0.085
    ],
    [
      "signale",
      0.085
    ],
    [
      "evident",
      0.085
    ],
    [
      "eclatant",
      0.0625
    ],
    [
      "impressionnant",
      0.0625
    ],
    [
      "troublant",
      0.04
    ],
    [
      "etonnant",
      0.04
    ],
    [
      "touchant",
      0.02
    ],
    [
      "sensationnel",
      0.02
    ],
    [
      "percutant",
      0.02
    ],
    [
      "marquant",
      0.02
    ],
    [
      "lumineux",
      0.02
    ],
    [
      "inoubliable",
      0.02
    ],
    [
      "indeniable",
      0.02
    ],
    [
      "indubitable",
      0.02
    ],
    [
      "hallucinant",
      0.02
    ],
    [
      "criant",
      0.02
    ],
    [
      "emouvant",
      0.02
    ]
  ],
  "notaire": [
    [
      "tabellion",
      0.3325
    ],
    [
      "adjudicateur",
      0.165
    ],
    [
      "sedentaire",
      0.165
    ]
  ],
  "auparavant": [
    [
      "avant",
      0.2575
    ],
    [
      "anciennement",
      0.085
    ],
    [
      "precedemment",
      0.055
    ],
    [
      "premierement",
      0.055
    ],
    [
      "jadis",
      0.055
    ],
    [
      "d'abord",
      0.055
    ],
    [
      "autrefois",
      0.055
    ],
    [
      "naguere",
      0.0275
    ],
    [
      "deja",
      0.0275
    ],
    [
      "devant",
      0.0275
    ],
    [
      "anterieurement",
      0.0275
    ],
    [
      "prealablement",
      0.0275
    ]
  ],
  "veuf": [
    [
      "seul",
      1.0
    ]
  ],
  "colonel": [
    [
      "chef",
      0.25
    ],
    [
      "mestre",
      0.25
    ],
    [
      "officier",
      0.25
    ]
  ],
  "new": [],
  "pliant": [
    [
      "maniable",
      0.155
    ],
    [
      "malleable",
      0.1325
    ],
    [
      "facile",
      0.11
    ],
    [
      "souple",
      0.11
    ],
    [
      "accommodant",
      0.0875
    ],
    [
      "mou",
      0.065
    ],
    [
      "flexible",
      0.065
    ],
    [
      "docile",
      0.065
    ],
    [
      "complaisant",
      0.0425
    ],
    [
      "faible",
      0.0425
    ],
    [
      "comique",
      0.02
    ],
    [
      "depliant",
      0.02
    ],
    [
      "obeissant",
      0.02
    ],
    [
      "pliable",
      0.02
    ],
    [
      "siege",
      0.02
    ]
  ],
  "instrument": [
    [
      "engin",
      0.125
    ],
    [
      "truc",
      0.095
    ],
    [
      "moyen",
      0.0775
    ],
    [
      "outil",
      0.0775
    ],
    [
      "ustensile",
      0.0625
    ],
    [
      "machine",
      0.0625
    ],
    [
      "machin",
      0.0625
    ],
    [
      "agent",
      0.0625
    ],
    [
      "appareil",
      0.0475
    ],
    [
      "bidule",
      0.0475
    ],
    [
      "organe",
      0.03
    ],
    [
      "executant",
      0.03
    ],
    [
      "accessoire",
      0.03
    ],
    [
      "voie",
      0.015
    ],
    [
      "titre",
      0.015
    ],
    [
      "ministre",
      0.015
    ],
    [
      "microinstrument",
      0.015
    ],
    [
      "materiel",
      0.015
    ],
    [
      "levier",
      0.015
    ],
    [
      "contrat",
      0.015
    ],
    [
      "clou",
      0.015
    ],
    [
      "chose",
      0.015
    ],
    [
      "bras",
      0.015
    ]
  ],
  "twist": [],
  "ruser": [
    [
      "biaiser",
      0.2
    ],
    [
      "finasser",
      0.2
    ],
    [
      "louvoyer",
      0.2
    ],
    [
      "manoeuvrer",
      0.2
    ],
    [
      "renarder",
      0.2
    ]
  ],
  "ruse": [
    [
      "biaiser",
      0.2
    ],
    [
      "finasser",
      0.2
    ],
    [
      "louvoyer",
      0.2
    ],
    [
      "manoeuvrer",
      0.2
    ],
    [
      "renarder",
      0.2
    ]
  ],
  "saloperie": [
    [
      "salete",
      0.235
    ],
    [
      "crasse",
      0.1275
    ],
    [
      "vacherie",
      0.085
    ],
    [
      "abjection",
      0.0625
    ],
    [
      "mechancete",
      0.0625
    ],
    [
      "vilenie",
      0.0625
    ],
    [
      "vaurien",
      0.04
    ],
    [
      "rosserie",
      0.04
    ],
    [
      "ordure",
      0.04
    ],
    [
      "malproprete",
      0.04
    ],
    [
      "infamie",
      0.04
    ],
    [
      "cochonnerie",
      0.04
    ],
    [
      "camelote",
      0.02
    ],
    [
      "fripouille",
      0.02
    ],
    [
      "infection",
      0.02
    ],
    [
      "malice",
      0.02
    ],
    [
      "poison",
      0.02
    ]
  ],
  "garant": [
    [
      "caution",
      0.155
    ],
    [
      "repondant",
      0.11
    ],
    [
      "garantie",
      0.0875
    ],
    [
      "sauvegarde",
      0.0875
    ],
    [
      "gage",
      0.0675
    ],
    [
      "otage",
      0.0675
    ],
    [
      "responsable",
      0.0425
    ],
    [
      "parrain",
      0.0425
    ],
    [
      "cordage",
      0.0425
    ],
    [
      "comptable",
      0.0425
    ],
    [
      "assurance",
      0.0425
    ],
    [
      "surete",
      0.02
    ],
    [
      "preservation",
      0.02
    ],
    [
      "pleige",
      0.02
    ],
    [
      "gardien",
      0.02
    ],
    [
      "endosseur",
      0.02
    ],
    [
      "correspondant",
      0.02
    ],
    [
      "bosse",
      0.02
    ],
    [
      "appui",
      0.02
    ],
    [
      "temoin",
      0.02
    ]
  ],
  "republique": [
    [
      "etat",
      0.3325
    ],
    [
      "gouvernement",
      0.22
    ],
    [
      "cite",
      0.11
    ],
    [
      "democratie",
      0.11
    ],
    [
      "nation",
      0.11
    ]
  ],
  "honnetement": [
    [
      "convenablement",
      0.1525
    ],
    [
      "correctement",
      0.13
    ],
    [
      "bien",
      0.11
    ],
    [
      "dignement",
      0.0875
    ],
    [
      "decemment",
      0.065
    ],
    [
      "moralement",
      0.065
    ],
    [
      "raisonnablement",
      0.065
    ],
    [
      "proprement",
      0.0425
    ],
    [
      "passablement",
      0.0425
    ],
    [
      "honorablement",
      0.0425
    ],
    [
      "valablement",
      0.02
    ],
    [
      "suffisamment",
      0.02
    ],
    [
      "purement",
      0.02
    ],
    [
      "poliment",
      0.02
    ],
    [
      "moyennement",
      0.02
    ],
    [
      "loyalement",
      0.02
    ],
    [
      "irreprochablement",
      0.02
    ],
    [
      "civilement",
      0.02
    ],
    [
      "vertueusement",
      0.02
    ]
  ],
  "choregraphie": [
    [
      "danse",
      0.4275
    ],
    [
      "ballet",
      0.1425
    ],
    [
      "orchestique",
      0.1425
    ],
    [
      "orchesographie",
      0.1425
    ],
    [
      "rythmique",
      0.1425
    ]
  ],
  "calibrer": [
    [
      "aleser",
      0.2
    ],
    [
      "classer",
      0.2
    ],
    [
      "mesurer",
      0.2
    ],
    [
      "proportionner",
      0.2
    ],
    [
      "trier",
      0.2
    ]
  ],
  "camping": [
    [
      "camp",
      0.2
    ],
    [
      "campement",
      0.2
    ],
    [
      "caravaning",
      0.2
    ],
    [
      "tourisme",
      0.2
    ]
  ],
  "ceremonie": [
    [
      "fete",
      0.055
    ],
    [
      "ceremonial",
      0.0425
    ],
    [
      "celebration",
      0.0375
    ],
    [
      "liturgie",
      0.0375
    ],
    [
      "solennite",
      0.0375
    ],
    [
      "politesse",
      0.03
    ],
    [
      "manieres",
      0.03
    ],
    [
      "facons",
      0.03
    ],
    [
      "convenance",
      0.03
    ],
    [
      "rite",
      0.0225
    ],
    [
      "protocole",
      0.0225
    ],
    [
      "messe",
      0.0225
    ],
    [
      "formalite",
      0.0225
    ],
    [
      "culte",
      0.0225
    ],
    [
      "cortege",
      0.0225
    ],
    [
      "complication",
      0.0225
    ],
    [
      "civilite",
      0.0225
    ],
    [
      "chichi",
      0.0225
    ],
    [
      "appareil",
      0.0225
    ],
    [
      "apparat",
      0.0225
    ],
    [
      "affectation",
      0.0225
    ],
    [
      "pompe",
      0.0175
    ],
    [
      "mariage",
      0.0175
    ],
    [
      "emphase",
      0.0175
    ],
    [
      "embarras",
      0.0175
    ],
    [
      "defile",
      0.0175
    ],
    [
      "compliment",
      0.0175
    ],
    [
      "tralala",
      0.01
    ],
    [
      "sacrement",
      0.01
    ],
    [
      "reception",
      0.01
    ],
    [
      "parade",
      0.01
    ],
    [
      "inauguration",
      0.01
    ],
    [
      "gala",
      0.01
    ],
    [
      "formes",
      0.01
    ],
    [
      "festivite",
      0.01
    ],
    [
      "decorum",
      0.01
    ],
    [
      "courtoisie",
      0.01
    ],
    [
      "code",
      0.01
    ],
    [
      "chinoiserie",
      0.01
    ],
    [
      "raout",
      0.005
    ],
    [
      "regles",
      0.005
    ],
    [
      "sacre",
      0.005
    ],
    [
      "service",
      0.005
    ],
    [
      "procession",
      0.005
    ],
    [
      "prestation",
      0.005
    ],
    [
      "office",
      0.005
    ],
    [
      "honneur",
      0.005
    ],
    [
      "grimace",
      0.005
    ],
    [
      "deference",
      0.005
    ],
    [
      "commemoration",
      0.005
    ],
    [
      "cavalcade",
      0.005
    ],
    [
      "anniversaire",
      0.005
    ],
    [
      "usages",
      0.005
    ]
  ],
  "froidure": [
    [
      "froid",
      0.3
    ],
    [
      "frimas",
      0.2
    ],
    [
      "engelure",
      0.1
    ],
    [
      "fraicheur",
      0.1
    ],
    [
      "froideur",
      0.1
    ],
    [
      "gelee",
      0.1
    ],
    [
      "hiver",
      0.1
    ]
  ],
  "tristement": [
    [
      "amerement",
      0.2
    ],
    [
      "cruellement",
      0.2
    ],
    [
      "lugubrement",
      0.2
    ],
    [
      "miserablement",
      0.2
    ],
    [
      "sombrement",
      0.2
    ]
  ],
  "troufion": [
    [
      "soldat",
      0.3
    ],
    [
      "troupier",
      0.2
    ],
    [
      "pioupiou",
      0.1
    ],
    [
      "tourlourou",
      0.1
    ],
    [
      "troubade",
      0.1
    ]
  ],
  "andouille": [
    [
      "sot",
      0.15
    ],
    [
      "ballot",
      0.12
    ],
    [
      "bete",
      0.12
    ],
    [
      "idiot",
      0.09
    ],
    [
      "imbecile",
      0.09
    ],
    [
      "niais",
      0.09
    ],
    [
      "saucisse",
      0.06
    ],
    [
      "charcuterie",
      0.06
    ],
    [
      "beta",
      0.06
    ],
    [
      "benet",
      0.03
    ],
    [
      "cretin",
      0.03
    ],
    [
      "maladroit",
      0.03
    ],
    [
      "paton",
      0.03
    ],
    [
      "saucisson",
      0.03
    ]
  ],
  "fripouille": [
    [
      "vaurien",
      0.14
    ],
    [
      "truand",
      0.09
    ],
    [
      "bandit",
      0.085
    ],
    [
      "voleur",
      0.065
    ],
    [
      "brigand",
      0.05
    ],
    [
      "coquin",
      0.05
    ],
    [
      "canaille",
      0.0425
    ],
    [
      "chenapan",
      0.0375
    ],
    [
      "gredin",
      0.035
    ],
    [
      "crapule",
      0.0325
    ],
    [
      "malfaiteur",
      0.03
    ],
    [
      "fripon",
      0.0275
    ],
    [
      "forban",
      0.02
    ],
    [
      "voyou",
      0.0175
    ],
    [
      "scelerat",
      0.0175
    ],
    [
      "escroc",
      0.0175
    ],
    [
      "filou",
      0.015
    ],
    [
      "maraud",
      0.015
    ],
    [
      "terreur",
      0.015
    ],
    [
      "garnement",
      0.0125
    ],
    [
      "vermine",
      0.01
    ],
    [
      "sacripant",
      0.01
    ],
    [
      "debauche",
      0.0075
    ],
    [
      "gangster",
      0.0075
    ],
    [
      "pirate",
      0.0075
    ],
    [
      "racaille",
      0.0075
    ],
    [
      "rosse",
      0.005
    ],
    [
      "rossard",
      0.005
    ],
    [
      "arsouille",
      0.005
    ],
    [
      "salaud",
      0.0025
    ],
    [
      "malhonnete",
      0.0025
    ],
    [
      "gouape",
      0.0025
    ],
    [
      "galopin",
      0.0025
    ],
    [
      "galapiat",
      0.0025
    ],
    [
      "faineant",
      0.0025
    ],
    [
      "devoye",
      0.0025
    ],
    [
      "drole",
      0.0025
    ],
    [
      "aventurier",
      0.0025
    ],
    [
      "ribaud",
      0.0
    ],
    [
      "saligaud",
      0.0
    ],
    [
      "saloperie",
      0.0
    ],
    [
      "poisse",
      0.0
    ],
    [
      "nervi",
      0.0
    ],
    [
      "maquereau",
      0.0
    ],
    [
      "gouspin",
      0.0
    ],
    [
      "fumier",
      0.0
    ],
    [
      "frappe",
      0.0
    ],
    [
      "vicieux",
      0.0
    ]
  ],
  "gouin": [],
  "gouine": [
    [
      "gougnotte",
      0.5
    ],
    [
      "gousse",
      0.5
    ]
  ],
  "chienner": [],
  "cretin": [
    [
      "idiot",
      0.16
    ],
    [
      "bete",
      0.1325
    ],
    [
      "sot",
      0.115
    ],
    [
      "imbecile",
      0.105
    ],
    [
      "stupide",
      0.105
    ],
    [
      "ballot",
      0.0525
    ],
    [
      "abruti",
      0.035
    ],
    [
      "ane",
      0.025
    ],
    [
      "inintelligent",
      0.025
    ],
    [
      "ignorant",
      0.025
    ],
    [
      "absurde",
      0.025
    ],
    [
      "simple",
      0.0175
    ],
    [
      "innocent",
      0.0175
    ],
    [
      "inepte",
      0.0175
    ],
    [
      "fou",
      0.0175
    ],
    [
      "debile",
      0.0175
    ],
    [
      "demeure",
      0.0175
    ],
    [
      "con",
      0.0175
    ],
    [
      "minus",
      0.0075
    ],
    [
      "enflure",
      0.0075
    ],
    [
      "cul",
      0.0075
    ],
    [
      "cancre",
      0.0075
    ],
    [
      "buse",
      0.0075
    ],
    [
      "andouille",
      0.0075
    ],
    [
      "rachitique",
      0.0075
    ]
  ],
  "alpe": [
    [
      "alpage",
      1.0
    ]
  ],
  "marsouin": [
    [
      "belouga",
      0.165
    ],
    [
      "marin",
      0.165
    ],
    [
      "matelot",
      0.165
    ],
    [
      "navigateur",
      0.165
    ],
    [
      "tente",
      0.165
    ]
  ],
  "suceur": [
    [
      "tentaculifere",
      1.0
    ]
  ],
  "zozo": [],
  "dejanter": [],
  "dejante": [],
  "fabrique": [
    [
      "atelier",
      0.09
    ],
    [
      "cabinet",
      0.09
    ],
    [
      "usine",
      0.09
    ],
    [
      "manufacture",
      0.06
    ],
    [
      "laboratoire",
      0.06
    ],
    [
      "facon",
      0.06
    ],
    [
      "fabrication",
      0.06
    ],
    [
      "exploitation",
      0.06
    ],
    [
      "construction",
      0.06
    ],
    [
      "conseil",
      0.06
    ],
    [
      "ressource",
      0.0275
    ],
    [
      "industrie",
      0.0275
    ],
    [
      "farine",
      0.0275
    ],
    [
      "facture",
      0.0275
    ],
    [
      "fabricien",
      0.0275
    ],
    [
      "conseiller",
      0.0275
    ],
    [
      "chantier",
      0.0275
    ],
    [
      "batiment",
      0.0275
    ],
    [
      "brandebourg",
      0.0275
    ],
    [
      "tresorier",
      0.0275
    ]
  ],
  "tantouze": [],
  "bique": [
    [
      "bourrique",
      0.1425
    ],
    [
      "cheval",
      0.1425
    ],
    [
      "chevre",
      0.1425
    ],
    [
      "rosse",
      0.1425
    ],
    [
      "megere",
      0.07
    ],
    [
      "mule",
      0.07
    ],
    [
      "caprin",
      0.07
    ],
    [
      "cabri",
      0.07
    ],
    [
      "cabrette",
      0.07
    ]
  ],
  "ramolli": [
    [
      "mou",
      0.155
    ],
    [
      "gateux",
      0.115
    ],
    [
      "senile",
      0.115
    ],
    [
      "imbecile",
      0.075
    ],
    [
      "flasque",
      0.075
    ],
    [
      "faible",
      0.075
    ],
    [
      "cotonneux",
      0.075
    ],
    [
      "stupide",
      0.0375
    ],
    [
      "somnolent",
      0.0375
    ],
    [
      "ramollo",
      0.0375
    ],
    [
      "gaga",
      0.0375
    ],
    [
      "deliquescent",
      0.0375
    ],
    [
      "bouilli",
      0.0375
    ],
    [
      "avachi",
      0.0375
    ],
    [
      "eteint",
      0.0375
    ]
  ],
  "ramollir": [
    [
      "amollir",
      0.3125
    ],
    [
      "effeminer",
      0.125
    ],
    [
      "mollir",
      0.06
    ],
    [
      "mollifier",
      0.06
    ],
    [
      "debiliter",
      0.06
    ],
    [
      "aveulir",
      0.06
    ],
    [
      "avachir",
      0.06
    ],
    [
      "attendrir",
      0.06
    ],
    [
      "alanguir",
      0.06
    ],
    [
      "abetir",
      0.06
    ],
    [
      "relacher",
      0.06
    ]
  ],
  "gland": [
    [
      "balane",
      0.3325
    ],
    [
      "faine",
      0.3325
    ],
    [
      "passement",
      0.3325
    ]
  ],
  "chaudement": [
    [
      "chaleureusement",
      0.3325
    ],
    [
      "passionnement",
      0.3325
    ],
    [
      "vivement",
      0.3325
    ]
  ],
  "velu": [
    [
      "poilu",
      0.2775
    ],
    [
      "duveteux",
      0.2225
    ],
    [
      "duvete",
      0.11
    ],
    [
      "pubescent",
      0.11
    ],
    [
      "veloute",
      0.11
    ],
    [
      "barbu",
      0.0525
    ],
    [
      "peluche",
      0.0525
    ],
    [
      "villeux",
      0.0525
    ]
  ],
  "morve": [
    [
      "humeur",
      0.25
    ],
    [
      "mucosite",
      0.25
    ],
    [
      "roupie",
      0.25
    ],
    [
      "goutte",
      0.125
    ],
    [
      "mouchure",
      0.125
    ]
  ],
  "verdatre": [
    [
      "livide",
      0.1425
    ],
    [
      "vert",
      0.1425
    ],
    [
      "terreux",
      0.095
    ],
    [
      "plombe",
      0.095
    ],
    [
      "pers",
      0.095
    ],
    [
      "olivatre",
      0.095
    ],
    [
      "glauque",
      0.095
    ],
    [
      "bleme",
      0.095
    ],
    [
      "blafard",
      0.095
    ],
    [
      "verdasse",
      0.045
    ]
  ],
  "rampant": [
    [
      "servile",
      0.19
    ],
    [
      "plat",
      0.165
    ],
    [
      "obsequieux",
      0.095
    ],
    [
      "vil",
      0.07
    ],
    [
      "souple",
      0.0475
    ],
    [
      "soumis",
      0.0475
    ],
    [
      "prosterne",
      0.0475
    ],
    [
      "fade",
      0.0475
    ],
    [
      "bas",
      0.0475
    ],
    [
      "banal",
      0.0475
    ],
    [
      "abject",
      0.0475
    ],
    [
      "flatteur",
      0.0225
    ],
    [
      "lache",
      0.0225
    ],
    [
      "ploye",
      0.0225
    ],
    [
      "reverencieux",
      0.0225
    ],
    [
      "serf",
      0.0225
    ],
    [
      "terne",
      0.0225
    ]
  ],
  "poisse": [
    [
      "misere",
      0.2
    ],
    [
      "deche",
      0.085
    ],
    [
      "puree",
      0.055
    ],
    [
      "maquereau",
      0.055
    ],
    [
      "malchance",
      0.055
    ],
    [
      "indigence",
      0.055
    ],
    [
      "gene",
      0.055
    ],
    [
      "detresse",
      0.055
    ],
    [
      "adversite",
      0.055
    ],
    [
      "vaurien",
      0.0275
    ],
    [
      "truand",
      0.0275
    ],
    [
      "poisson",
      0.0275
    ],
    [
      "mouise",
      0.0275
    ],
    [
      "guignon",
      0.0275
    ],
    [
      "guigne",
      0.0275
    ],
    [
      "fripouille",
      0.0275
    ],
    [
      "ennui",
      0.0275
    ],
    [
      "deveine",
      0.0275
    ],
    [
      "colle",
      0.0275
    ],
    [
      "viscosite",
      0.0275
    ]
  ],
  "anus": [
    [
      "cul",
      0.31
    ],
    [
      "derriere",
      0.1025
    ],
    [
      "bol",
      0.0675
    ],
    [
      "pot",
      0.0675
    ],
    [
      "troufignon",
      0.0675
    ],
    [
      "rondelle",
      0.0325
    ],
    [
      "rosette",
      0.0325
    ],
    [
      "oignon",
      0.0325
    ],
    [
      "oeil",
      0.0325
    ],
    [
      "fondement",
      0.0325
    ],
    [
      "fion",
      0.0325
    ],
    [
      "fignard",
      0.0325
    ],
    [
      "derche",
      0.0325
    ],
    [
      "troufignard",
      0.0325
    ]
  ],
  "boueux": [
    [
      "impur",
      0.12
    ],
    [
      "abject",
      0.095
    ],
    [
      "bourbeux",
      0.07
    ],
    [
      "fangeux",
      0.07
    ],
    [
      "infame",
      0.07
    ],
    [
      "vaseux",
      0.07
    ],
    [
      "trouble",
      0.0475
    ],
    [
      "sale",
      0.0475
    ],
    [
      "bas",
      0.0475
    ],
    [
      "vicieux",
      0.0225
    ],
    [
      "tourbeux",
      0.0225
    ],
    [
      "ordurier",
      0.0225
    ],
    [
      "merdeux",
      0.0225
    ],
    [
      "marecageux",
      0.0225
    ],
    [
      "malodorant",
      0.0225
    ],
    [
      "limoneux",
      0.0225
    ],
    [
      "gadouilleux",
      0.0225
    ],
    [
      "fagneux",
      0.0225
    ],
    [
      "crotteux",
      0.0225
    ],
    [
      "corrompu",
      0.0225
    ],
    [
      "boueur",
      0.0225
    ],
    [
      "boue",
      0.0225
    ],
    [
      "balayeur",
      0.0225
    ],
    [
      "eboueur",
      0.0225
    ]
  ],
  "luisant": [
    [
      "briller",
      0.125
    ],
    [
      "reluire",
      0.115
    ],
    [
      "resplendir",
      0.115
    ],
    [
      "flamboyer",
      0.1
    ],
    [
      "etinceler",
      0.1
    ],
    [
      "scintiller",
      0.085
    ],
    [
      "rayonner",
      0.0525
    ],
    [
      "miroiter",
      0.045
    ],
    [
      "chatoyer",
      0.03
    ],
    [
      "fulgurer",
      0.03
    ],
    [
      "rutiler",
      0.03
    ],
    [
      "eclater",
      0.0225
    ],
    [
      "papilloter",
      0.0225
    ],
    [
      "brasiller",
      0.015
    ],
    [
      "flamber",
      0.015
    ],
    [
      "poudroyer",
      0.015
    ],
    [
      "eblouir",
      0.0075
    ],
    [
      "vaciller",
      0.0075
    ],
    [
      "s'etoiler",
      0.0075
    ],
    [
      "reflechir",
      0.0075
    ],
    [
      "rire",
      0.0075
    ],
    [
      "apparaitre",
      0.0075
    ],
    [
      "eclairer",
      0.0075
    ]
  ],
  "gerber": [
    [
      "botteler",
      0.2
    ],
    [
      "degueuler",
      0.2
    ],
    [
      "engerber",
      0.2
    ],
    [
      "entasser",
      0.2
    ],
    [
      "vomir",
      0.2
    ]
  ],
  "gerbe": [
    [
      "faisceau",
      0.1925
    ],
    [
      "bouquet",
      0.16
    ],
    [
      "assemblage",
      0.095
    ],
    [
      "botte",
      0.095
    ],
    [
      "panache",
      0.0625
    ],
    [
      "jet",
      0.0625
    ],
    [
      "fusee",
      0.0625
    ],
    [
      "trousse",
      0.03
    ],
    [
      "troche",
      0.03
    ],
    [
      "reunion",
      0.03
    ],
    [
      "javelle",
      0.03
    ],
    [
      "girandole",
      0.03
    ],
    [
      "geyser",
      0.03
    ],
    [
      "colonne",
      0.03
    ],
    [
      "eclaboussure",
      0.03
    ]
  ],
  "moisissure": [
    [
      "champignon",
      0.2
    ],
    [
      "chancissure",
      0.2
    ],
    [
      "decomposition",
      0.2
    ],
    [
      "ferment",
      0.2
    ],
    [
      "pourriture",
      0.2
    ]
  ],
  "prout": [
    [
      "pet",
      1.0
    ]
  ],
  "excrement": [
    [
      "ordure",
      0.1
    ],
    [
      "merde",
      0.0725
    ],
    [
      "gadoue",
      0.06
    ],
    [
      "boue",
      0.0475
    ],
    [
      "fiente",
      0.0475
    ],
    [
      "residu",
      0.035
    ],
    [
      "crotte",
      0.035
    ],
    [
      "rebut",
      0.0225
    ],
    [
      "guano",
      0.0225
    ],
    [
      "fumier",
      0.0225
    ],
    [
      "dechet",
      0.0225
    ],
    [
      "chiure",
      0.0225
    ],
    [
      "bran",
      0.0225
    ],
    [
      "bouse",
      0.0225
    ],
    [
      "meconium",
      0.01
    ],
    [
      "mouscaille",
      0.01
    ],
    [
      "marchandise",
      0.01
    ],
    [
      "laissees",
      0.01
    ],
    [
      "immondice",
      0.01
    ],
    [
      "paquet",
      0.01
    ],
    [
      "pot",
      0.01
    ],
    [
      "poudrette",
      0.01
    ],
    [
      "purin",
      0.01
    ],
    [
      "peche",
      0.01
    ],
    [
      "recrement",
      0.01
    ],
    [
      "selle",
      0.01
    ],
    [
      "sentinelle",
      0.01
    ],
    [
      "etron",
      0.01
    ],
    [
      "bronze",
      0.01
    ],
    [
      "caca",
      0.01
    ],
    [
      "chiasse",
      0.01
    ],
    [
      "colombin",
      0.01
    ],
    [
      "colombine",
      0.01
    ],
    [
      "confiture",
      0.01
    ],
    [
      "coprophage",
      0.01
    ],
    [
      "crottin",
      0.01
    ],
    [
      "dejection",
      0.01
    ],
    [
      "egesta",
      0.01
    ],
    [
      "excretion",
      0.01
    ],
    [
      "foire",
      0.01
    ],
    [
      "fumee",
      0.01
    ],
    [
      "feces",
      0.01
    ],
    [
      "brenne",
      0.01
    ]
  ],
  "recouvert": [
    [
      "couvrir",
      0.1625
    ],
    [
      "tapisser",
      0.08
    ],
    [
      "envelopper",
      0.055
    ],
    [
      "masquer",
      0.055
    ],
    [
      "garnir",
      0.0475
    ],
    [
      "revetir",
      0.04
    ],
    [
      "s'etendre",
      0.03
    ],
    [
      "deguiser",
      0.03
    ],
    [
      "cacher",
      0.03
    ],
    [
      "submerger",
      0.0225
    ],
    [
      "parsemer",
      0.0225
    ],
    [
      "inonder",
      0.0225
    ],
    [
      "enduire",
      0.0225
    ],
    [
      "embrasser",
      0.0225
    ],
    [
      "dissimuler",
      0.0225
    ],
    [
      "camoufler",
      0.0225
    ],
    [
      "etoffer",
      0.015
    ],
    [
      "etendre",
      0.015
    ],
    [
      "poudrer",
      0.015
    ],
    [
      "joncher",
      0.015
    ],
    [
      "habiller",
      0.015
    ],
    [
      "ensevelir",
      0.015
    ],
    [
      "enrober",
      0.015
    ],
    [
      "coiffer",
      0.015
    ],
    [
      "charger",
      0.015
    ],
    [
      "barder",
      0.015
    ],
    [
      "appliquer",
      0.015
    ],
    [
      "s'appliquer",
      0.005
    ],
    [
      "superposer",
      0.005
    ],
    [
      "tenir",
      0.005
    ],
    [
      "terrer",
      0.005
    ],
    [
      "paver",
      0.005
    ],
    [
      "escamoter",
      0.005
    ],
    [
      "chevaucher",
      0.005
    ],
    [
      "capuchonner",
      0.005
    ],
    [
      "bacher",
      0.005
    ],
    [
      "badigeonner",
      0.005
    ],
    [
      "voiler",
      0.005
    ]
  ],
  "chevreuil": [
    [
      "cerf",
      0.285
    ],
    [
      "brocard",
      0.1425
    ],
    [
      "chevrette",
      0.1425
    ],
    [
      "chevrillard",
      0.1425
    ],
    [
      "chevrotin",
      0.1425
    ],
    [
      "gibier",
      0.1425
    ]
  ],
  "egout": [
    [
      "conduit",
      0.1575
    ],
    [
      "canalisation",
      0.105
    ],
    [
      "vidange",
      0.105
    ],
    [
      "ecoulement",
      0.105
    ],
    [
      "puisard",
      0.0525
    ],
    [
      "gouttiere",
      0.0525
    ],
    [
      "cloaque",
      0.0525
    ],
    [
      "cheneau",
      0.0525
    ],
    [
      "canal",
      0.0525
    ],
    [
      "bourbier",
      0.0525
    ],
    [
      "battellement",
      0.0525
    ],
    [
      "sentine",
      0.0525
    ]
  ],
  "clodo": [
    [
      "clochard",
      0.3325
    ],
    [
      "cloche",
      0.22
    ],
    [
      "vagabond",
      0.22
    ],
    [
      "clopinard",
      0.11
    ],
    [
      "gueux",
      0.11
    ]
  ],
  "croquette": [
    [
      "boulette",
      0.25
    ],
    [
      "chocolat",
      0.25
    ],
    [
      "cromesquis",
      0.25
    ],
    [
      "hachis",
      0.25
    ]
  ],
  "sodomite": [
    [
      "pederaste",
      1.0
    ]
  ],
  "fumier": [
    [
      "gadoue",
      0.16
    ],
    [
      "engrais",
      0.12
    ],
    [
      "salaud",
      0.12
    ],
    [
      "poudrette",
      0.08
    ],
    [
      "ordure",
      0.08
    ],
    [
      "excrement",
      0.08
    ],
    [
      "compost",
      0.08
    ],
    [
      "ruisseau",
      0.04
    ],
    [
      "fripouille",
      0.04
    ],
    [
      "fertilisation",
      0.04
    ],
    [
      "bete",
      0.04
    ],
    [
      "apport",
      0.04
    ],
    [
      "amendement",
      0.04
    ],
    [
      "terreau",
      0.04
    ]
  ],
  "colombin": [
    [
      "colombaire",
      0.25
    ],
    [
      "excrement",
      0.25
    ],
    [
      "fiente",
      0.25
    ]
  ],
  "puant": [
    [
      "nauseabond",
      0.12
    ],
    [
      "degoutant",
      0.1125
    ],
    [
      "repugnant",
      0.1025
    ],
    [
      "infect",
      0.0875
    ],
    [
      "fetide",
      0.0725
    ],
    [
      "abject",
      0.055
    ],
    [
      "ecoeurant",
      0.055
    ],
    [
      "ignoble",
      0.0475
    ],
    [
      "repoussant",
      0.04
    ],
    [
      "sordide",
      0.04
    ],
    [
      "immonde",
      0.03
    ],
    [
      "superbe",
      0.015
    ],
    [
      "poseur",
      0.015
    ],
    [
      "pestilentiel",
      0.015
    ],
    [
      "orgueilleux",
      0.015
    ],
    [
      "malodorant",
      0.015
    ],
    [
      "infame",
      0.015
    ],
    [
      "important",
      0.015
    ],
    [
      "honteux",
      0.015
    ],
    [
      "fat",
      0.015
    ],
    [
      "punais",
      0.0075
    ],
    [
      "pouacre",
      0.0075
    ],
    [
      "nidoreux",
      0.0075
    ],
    [
      "mephitique",
      0.0075
    ],
    [
      "infatue",
      0.0075
    ],
    [
      "impudent",
      0.0075
    ],
    [
      "empuanti",
      0.0075
    ],
    [
      "empeste",
      0.0075
    ],
    [
      "desagreable",
      0.0075
    ],
    [
      "snob",
      0.0075
    ]
  ],
  "sperme": [
    [
      "germe",
      0.3325
    ],
    [
      "semence",
      0.3325
    ]
  ],
  "fossiliser": [
    [
      "abetir",
      0.25
    ],
    [
      "momifier",
      0.25
    ],
    [
      "petrifier",
      0.25
    ]
  ],
  "bouse": [
    [
      "excrement",
      0.3325
    ],
    [
      "bousage",
      0.165
    ],
    [
      "bousin",
      0.165
    ],
    [
      "fiente",
      0.165
    ],
    [
      "merde",
      0.165
    ]
  ],
  "ananas": [],
  "chiure": [
    [
      "excrement",
      0.4
    ],
    [
      "caque",
      0.2
    ],
    [
      "chiasse",
      0.2
    ],
    [
      "ordure",
      0.2
    ]
  ],
  "pelure": [
    [
      "peau",
      0.285
    ],
    [
      "robe",
      0.285
    ],
    [
      "vetement",
      0.1425
    ],
    [
      "ecorce",
      0.1425
    ],
    [
      "epluchure",
      0.1425
    ]
  ],
  "croupissant": [
    [
      "moisir",
      0.1575
    ],
    [
      "pourrir",
      0.1575
    ],
    [
      "rester",
      0.1575
    ],
    [
      "stagner",
      0.1025
    ],
    [
      "sejourner",
      0.1025
    ],
    [
      "vivoter",
      0.1025
    ],
    [
      "vivre",
      0.1025
    ],
    [
      "s'encrouter",
      0.05
    ]
  ],
  "balbutiant": [
    [
      "bredouillant",
      0.5
    ],
    [
      "begayant",
      0.5
    ]
  ],
  "paroi": [
    [
      "cloison",
      0.215
    ],
    [
      "mur",
      0.215
    ],
    [
      "muraille",
      0.1425
    ],
    [
      "face",
      0.07
    ],
    [
      "falaise",
      0.07
    ],
    [
      "galandage",
      0.07
    ],
    [
      "galandis",
      0.07
    ],
    [
      "pan",
      0.07
    ],
    [
      "separation",
      0.07
    ]
  ],
  "sacrement": [
    [
      "bougrement",
      0.25
    ],
    [
      "bigrement",
      0.1875
    ],
    [
      "beaucoup",
      0.125
    ],
    [
      "diablement",
      0.125
    ],
    [
      "drolement",
      0.125
    ],
    [
      "vachement",
      0.125
    ],
    [
      "foutrement",
      0.0625
    ]
  ],
  "bacterie": [
    [
      "bacille",
      0.2
    ],
    [
      "germe",
      0.2
    ],
    [
      "microbe",
      0.2
    ],
    [
      "ferment",
      0.1
    ],
    [
      "protiste",
      0.1
    ],
    [
      "thallophyte",
      0.1
    ],
    [
      "virus",
      0.1
    ]
  ],
  "fiente": [
    [
      "excrement",
      0.3675
    ],
    [
      "bousard",
      0.09
    ],
    [
      "bouse",
      0.09
    ],
    [
      "caque",
      0.09
    ],
    [
      "colombin",
      0.09
    ],
    [
      "guano",
      0.09
    ],
    [
      "ordure",
      0.09
    ],
    [
      "epreinte",
      0.09
    ]
  ],
  "escargot": [
    [
      "cagouille",
      0.2
    ],
    [
      "colimacon",
      0.2
    ],
    [
      "helix",
      0.2
    ],
    [
      "limacon",
      0.2
    ],
    [
      "luma",
      0.2
    ]
  ],
  "pisseur": [
    [
      "rinceur",
      1.0
    ]
  ],
  "afghan": [],
  "cinquantaine": [],
  "naze": []
}